// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"5DEId":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
var _jsxRuntime = require("react/jsx-runtime");
var _client = require("react-dom/client");
var _reactRouterDom = require("react-router-dom");
var _react = require("react");
var _reactHelmetAsync = require("react-helmet-async");
var _reactQuery = require("@tanstack/react-query");
var _drei = require("@react-three/drei");
var _home = require("src/screens/Home/Home");
var _trainer = require("src/screens/Trainer/Trainer");
var _programGenerated = require("src/screens/Trainer/screens/ProgramGenerated/ProgramGenerated");
var _programCompleted = require("src/screens/Trainer/screens/ProgramCompleted/ProgramCompleted");
// Onboarding Trainer
var _onboardingTrainer = require("src/screens/OnboardingTrainer/OnboardingTrainer");
var _hero = require("src/screens/OnboardingTrainer/screens/Hero/Hero");
var _login = require("src/screens/OnboardingTrainer/screens/Login/Login");
var _signUp = require("src/screens/OnboardingTrainer/screens/SignUp/SignUp");
var _forgotPassword = require("src/screens/OnboardingTrainer/screens/ForgotPassword/ForgotPassword");
var _resetPassword = require("src/screens/OnboardingTrainer/screens/ResetPassword/ResetPassword");
var _authAction = require("src/screens/OnboardingTrainer/screens/AuthAction/AuthAction");
var _emailVerified = require("src/screens/OnboardingTrainer/screens/EmailVerified/EmailVerified");
var _verifyEmail = require("src/screens/OnboardingTrainer/screens/VerifyEmail/VerifyEmail");
var _dashboard = require("src/screens/OnboardingTrainer/screens/Dashboard/Dashboard");
var _overview = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/Overview/Overview");
var _clients = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/Clients/Clients");
var _clientOverview = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/ClientOverview");
var _overviewTab = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/OverviewTab");
var _clientNotesTab = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/ClientNotesTab");
var _programTab = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/ProgramTab");
var _workoutsTab = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/WorkoutsTab");
var _clientProfileTab = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/ClientProfileTab");
var _workoutDetails = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/WorkoutDetails/WorkoutDetails");
var _programs = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/Programs/Programs");
var _profile = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/Profile/Profile");
var _programGeneratorAI = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/ProgramGeneratorAI/ProgramGeneratorAI");
var _programGenerated1 = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/ProgramGenerated/ProgramGenerated");
var _dashboardMessagesLayout = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/DashboardMessagesLayout");
var _dashboardMessagesIndexRoute = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/DashboardMessagesIndexRoute");
var _dashboardChatDetails = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/DashboardChatDetails");
var _dashboardMediaLinksFilesScreen = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/DashboardMediaLinksFilesScreen");
var _checkinDetailsRoute = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/Checkins/CheckinDetailsRoute");
var _schedule = require("src/screens/OnboardingTrainer/screens/Schedule/Schedule");
var _subscription = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/Subscription");
var _about = require("src/screens/About/About");
var _notFound = require("src/screens/NotFound/NotFound");
var _serverError = require("src/screens/ServerError/ServerError");
var _unauthorized = require("src/screens/Unauthorized/Unauthorized");
var _loading = require("src/screens/Loading/Loading");
var _maintenance = require("src/screens/Maintenance/Maintenance");
var _comingSoon = require("src/screens/ComingSoon/ComingSoon");
var _comingSoonTsx = require("src/screens/AccountStatus/ComingSoon.tsx");
var _privacyPolicy = require("src/screens/PrivacyPolicy/PrivacyPolicy");
var _termsOfService = require("src/screens/TermsOfService/TermsOfService");
var _utilityLayoutTsx = require("src/layouts/UtilityLayout/UtilityLayout.tsx");
var _utilityLayoutTsxDefault = parcelHelpers.interopDefault(_utilityLayoutTsx);
var _scrollToTop = require("./utils/scrollToTop");
var _scrollToTopDefault = parcelHelpers.interopDefault(_scrollToTop);
var _appManagerTsx = require("src/components/AppManager/AppManager.tsx");
var _appManagerTsxDefault = parcelHelpers.interopDefault(_appManagerTsx);
var _guestRouteTsx = require("src/components/GuestRoute/GuestRoute.tsx");
var _queryClientTs = require("src/api/queryClient.ts");
var _apiConfigTs = require("src/config/api-config.ts");
var _iphoneGlb = require("src/assets/other/iphone.glb");
var _iphoneGlbDefault = parcelHelpers.interopDefault(_iphoneGlb);
const container = document.getElementById('app');
const root = (0, _client.createRoot)(container);
if (0, _apiConfigTs.IS_DEV) console.log('Dev Mode is on');
(0, _drei.useGLTF).preload((0, _iphoneGlbDefault.default));
const router = (0, _reactRouterDom.createBrowserRouter)((0, _reactRouterDom.createRoutesFromElements)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Route), {
    element: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scrollToTopDefault.default), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _utilityLayoutTsxDefault.default), {})
        ]
    }),
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "/",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _home.Home), {})
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Route), {
            path: "/trainer",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    index: true,
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trainer.Trainer), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "generated/:type",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programGenerated.ProgramGenerated), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "generated/:completeType/completed",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programCompleted.ProgramCompleted), {})
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Route), {
            path: "/onboarding-trainer",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardingTrainer.OnboardingTrainer), {}),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    index: true,
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hero.Hero), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Route), {
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _guestRouteTsx.GuestRoute), {}),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "login",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _login.Login), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "signup",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _signUp.SignUp), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "forgot-password",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _forgotPassword.ForgotPassword), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "auth-action",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _authAction.AuthAction), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "reset-password",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resetPassword.ResetPassword), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "signup/verify-email",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _verifyEmail.VerifyEmail), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "signup/email-verified",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emailVerified.EmailVerified), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Route), {
                    path: "dashboard",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboard.Dashboard), {}),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            index: true,
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overview.Overview), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "welcome",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.Welcome), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "clients",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clients.Clients), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Route), {
                            path: "clients/:uid",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientOverview.ClientOverview), {}),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    index: true,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                                        to: "overview",
                                        replace: true
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "overview",
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewTab.OverviewTab), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "overview/notes",
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientNotesTab.ClientNotesTab), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "program",
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programTab.ProgramTab), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "workouts",
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _workoutsTab.WorkoutsTab), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "client-profile",
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientProfileTab.ClientProfileTab), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "workouts/:workoutId",
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _workoutDetails.WorkoutDetails), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "programs",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programs.Programs), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Route), {
                            path: "messages",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardMessagesLayout.DashboardMessagesLayout), {}),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    index: true,
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardMessagesIndexRoute.DashboardMessagesIndexRoute), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: ":chatId",
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardChatDetails.DashboardChatDetails), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: ":chatId/media",
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardMediaLinksFilesScreen.DashboardMediaLinksFilesScreen), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                                    path: "checkin/:checkinId",
                                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkinDetailsRoute.CheckinDetailsRoute), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "profile",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profile.Profile), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "profile/schedule",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _schedule.Schedule), {
                                mode: "profile"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "program-generator/:by",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programGeneratorAI.ProgramGeneratorAI), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "program-generated",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programGenerated1.ProgramGenerated), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "program-generated/:programId",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programGenerated1.ProgramGenerated), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "program-generated/:programId/:workout",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programGenerated1.ProgramGenerated), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "subscription",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.SubscriptionPlans), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "subscription/plans",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.SubscriptionPlans), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "subscription/checkout",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.Checkout), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "subscription/privacy-policy",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.PrivacyPolicyScreen), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "subscription/terms-of-service",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.TermsOfServiceScreen), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "subscription/my-subscription",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.MySubscription), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "subscription/manage-payment-method",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.ManagePaymentMethod), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "subscription/billing-history",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.BillingHistory), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "subscription/cancel",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.CancelSubscription), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "subscription/reactivate",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.ReactivatePro), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "subscription/contact-support",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.ContactSupport), {})
                        })
                    ]
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Route), {
            path: "/dashboard",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboard.Dashboard), {}),
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    index: true,
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overview.Overview), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "welcome",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.Welcome), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "clients",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clients.Clients), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Route), {
                    path: "clients/:uid",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientOverview.ClientOverview), {}),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            index: true,
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
                                to: "overview",
                                replace: true
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "overview",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewTab.OverviewTab), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "overview/notes",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientNotesTab.ClientNotesTab), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "program",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programTab.ProgramTab), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "workouts",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _workoutsTab.WorkoutsTab), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "client-profile",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientProfileTab.ClientProfileTab), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "workouts/:workoutId",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _workoutDetails.WorkoutDetails), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "programs",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programs.Programs), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.Route), {
                    path: "messages",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardMessagesLayout.DashboardMessagesLayout), {}),
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            index: true,
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardMessagesIndexRoute.DashboardMessagesIndexRoute), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: ":chatId",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardChatDetails.DashboardChatDetails), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: ":chatId/media",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardMediaLinksFilesScreen.DashboardMediaLinksFilesScreen), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                            path: "checkin/:checkinId",
                            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkinDetailsRoute.CheckinDetailsRoute), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "profile",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profile.Profile), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "profile/schedule",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _schedule.Schedule), {
                        mode: "profile"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "program-generator/:by",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programGeneratorAI.ProgramGeneratorAI), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "program-generated",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programGenerated1.ProgramGenerated), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "program-generated/:programId",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programGenerated1.ProgramGenerated), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "program-generated/:programId/:workout",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programGenerated1.ProgramGenerated), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "subscription",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.SubscriptionPlans), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "subscription/plans",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.SubscriptionPlans), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "subscription/checkout",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.Checkout), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "subscription/privacy-policy",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.PrivacyPolicyScreen), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "subscription/terms-of-service",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.TermsOfServiceScreen), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "subscription/my-subscription",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.MySubscription), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "subscription/manage-payment-method",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.ManagePaymentMethod), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "subscription/billing-history",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.BillingHistory), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "subscription/cancel",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.CancelSubscription), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "subscription/reactivate",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.ReactivatePro), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
                    path: "subscription/contact-support",
                    element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscription.ContactSupport), {})
                })
            ]
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "about",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _about.About), {})
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "loading",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _loading.Loading), {})
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "error",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _serverError.ServerError), {})
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "unauthorized",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unauthorized.Unauthorized), {})
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "maintenance",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _maintenance.Maintenance), {})
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "coming-soon",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comingSoon.ComingSoon), {})
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "account-status",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _comingSoonTsx.AccountStatus), {})
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "privacy-policy",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _privacyPolicy.PrivacyPolicy), {})
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "legal/privacyPolicy",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _privacyPolicy.PrivacyPolicy), {})
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "terms-of-service",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _termsOfService.TermsOfService), {})
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Route), {
            path: "*",
            element: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notFound.NotFound), {})
        })
    ]
})), {
    basename: "/" ?? '',
    future: {
        v7_relativeSplatPath: true
    }
});
// Service worker & app deep-linking message listener
if (typeof window !== 'undefined') {
    if ('serviceWorker' in navigator) navigator.serviceWorker.addEventListener('message', (event)=>{
        if (event.data?.type === 'navigate' && event.data.url) router.navigate(event.data.url);
    });
    window.addEventListener('app:navigate', (event)=>{
        const customEvent = event;
        if (customEvent.detail) router.navigate(customEvent.detail);
    });
}
root.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.StrictMode), {
    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHelmetAsync.HelmetProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactQuery.QueryClientProvider), {
            client: (0, _queryClientTs.queryClient),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appManagerTsxDefault.default), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.RouterProvider), {
                    router: router
                })
            })
        })
    })
}));

},{"react/jsx-runtime":"gonF6","react-dom/client":"5eZdG","react-router-dom":[["createBrowserRouter","f3cgC"],["RouterProvider","f3cgC"],["createRoutesFromElements","9oT3O"],["Navigate","9oT3O"],["Route","9oT3O"]],"react":"bmhQu","react-helmet-async":"eyrQZ","@tanstack/react-query":"97Oud","@react-three/drei":"8AynF","src/screens/Home/Home":"joyv9","src/screens/Trainer/Trainer":"jBYZm","src/screens/Trainer/screens/ProgramGenerated/ProgramGenerated":"lgM1o","src/screens/Trainer/screens/ProgramCompleted/ProgramCompleted":"WtCGM","src/screens/OnboardingTrainer/OnboardingTrainer":"89OvN","src/screens/OnboardingTrainer/screens/Hero/Hero":"7kqRm","src/screens/OnboardingTrainer/screens/Login/Login":"4zTfT","src/screens/OnboardingTrainer/screens/SignUp/SignUp":"dozlf","src/screens/OnboardingTrainer/screens/ForgotPassword/ForgotPassword":"2Qt0q","src/screens/OnboardingTrainer/screens/ResetPassword/ResetPassword":"2xpwe","src/screens/OnboardingTrainer/screens/AuthAction/AuthAction":"gIa7W","src/screens/OnboardingTrainer/screens/EmailVerified/EmailVerified":"52uKi","src/screens/OnboardingTrainer/screens/VerifyEmail/VerifyEmail":"g1QQu","src/screens/OnboardingTrainer/screens/Dashboard/Dashboard":"kXA0H","src/screens/OnboardingTrainer/screens/Dashboard/screens/Overview/Overview":"fUXFQ","src/screens/OnboardingTrainer/screens/Dashboard/screens/Clients/Clients":"lhjye","src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/ClientOverview":"hZ3OV","src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/OverviewTab":"cW78d","src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/ClientNotesTab":"eP8Ed","src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/ProgramTab":"9USUx","src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/WorkoutsTab":"iMQYC","src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/ClientProfileTab":"jStZT","src/screens/OnboardingTrainer/screens/Dashboard/screens/WorkoutDetails/WorkoutDetails":"bt8O1","src/screens/OnboardingTrainer/screens/Dashboard/screens/Programs/Programs":"iu3BE","src/screens/OnboardingTrainer/screens/Dashboard/screens/Profile/Profile":"jvVL7","src/screens/OnboardingTrainer/screens/Dashboard/screens/ProgramGeneratorAI/ProgramGeneratorAI":"3tyy0","src/screens/OnboardingTrainer/screens/Dashboard/screens/ProgramGenerated/ProgramGenerated":"kiv6R","src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/DashboardMessagesLayout":"fGBV7","src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/DashboardMessagesIndexRoute":"6qzcC","src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/DashboardChatDetails":"i7zub","src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/DashboardMediaLinksFilesScreen":"enFFI","src/screens/OnboardingTrainer/screens/Dashboard/screens/Checkins/CheckinDetailsRoute":"fjpjR","src/screens/OnboardingTrainer/screens/Schedule/Schedule":"itZID","src/screens/OnboardingTrainer/screens/Dashboard/screens/Subscription":"jbt5N","src/screens/About/About":"784WL","src/screens/NotFound/NotFound":"5lRtz","src/screens/ServerError/ServerError":"71pYm","src/screens/Unauthorized/Unauthorized":"2BMbt","src/screens/Loading/Loading":"eZRIx","src/screens/Maintenance/Maintenance":"bvYRr","src/screens/ComingSoon/ComingSoon":"lhYyx","src/screens/AccountStatus/ComingSoon.tsx":"6wOPq","src/screens/PrivacyPolicy/PrivacyPolicy":"GoYTU","src/screens/TermsOfService/TermsOfService":"kQN6n","src/layouts/UtilityLayout/UtilityLayout.tsx":"5Jgx8","./utils/scrollToTop":"f08Ie","src/components/AppManager/AppManager.tsx":"6jk7r","src/components/GuestRoute/GuestRoute.tsx":"9gfHC","src/api/queryClient.ts":"406Ct","src/config/api-config.ts":"9oD3c","src/assets/other/iphone.glb":"3DBKq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gonF6":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("75e31b526e250c6f");

},{"75e31b526e250c6f":"euPNa"}],"euPNa":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.jsx = jsxProd;
exports.jsxs = jsxProd;

},{}],"5eZdG":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("9e932721f217f9f6");

},{"9e932721f217f9f6":"atjdB"}],"atjdB":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ "use strict";
var Scheduler = require("934b50a50c275743"), React = require("56d30b16d84cc622"), ReactDOM = require("d42dbe4aacaa6df4");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber) throw Error(formatProdErrorMessage(188));
}
function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate) throw Error(formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return assertIsMounted(parentA), fiber;
                if (parentB === b) return assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error(formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error(formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case REACT_FRAGMENT_TYPE:
            return "Fragment";
        case REACT_PROFILER_TYPE:
            return "Profiler";
        case REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case REACT_SUSPENSE_TYPE:
            return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case REACT_PORTAL_TYPE:
            return "Portal";
        case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var isArrayImpl = Array.isArray, ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, valueStack = [], index = -1;
function createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function pop(cursor) {
    0 > index || (cursor.current = valueStack[index], valueStack[index] = null, index--);
}
function push(cursor, value) {
    index++;
    valueStack[index] = cursor.current;
    cursor.current = value;
}
var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
function pushHostContainer(fiber, nextRootInstance) {
    push(rootInstanceStackCursor, nextRootInstance);
    push(contextFiberStackCursor, fiber);
    push(contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    pop(contextStackCursor);
    push(contextStackCursor, fiber);
}
function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
}
function pushHostContext(fiber) {
    null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
    var context = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && (push(contextFiberStackCursor, fiber), push(contextStackCursor, JSCompiler_inline_result));
}
function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
}
var prefix, suffix;
function describeBuiltInComponentFrame(name) {
    if (void 0 === prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        prefix = match && match[1] || "";
        suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + prefix + name + suffix;
}
var reentry = !1;
function describeNativeComponentFrame(fn, construct) {
    if (!fn || reentry) return "";
    reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return describeBuiltInComponentFrame(fiber.type);
        case 16:
            return describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
        case 19:
            return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var hasOwnProperty = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, getCurrentPriorityLevel = Scheduler.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, LowPriority = Scheduler.unstable_LowPriority, IdlePriority = Scheduler.unstable_IdlePriority, log$1 = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$1 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
    } catch (err) {}
}
var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log = Math.log, LN2 = Math.LN2;
function clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - (log(x) / LN2 | 0) | 0;
}
var nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304;
function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
}
function createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
}
function runWithPriority(priority, fn) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        return ReactDOMSharedInternals.p = priority, fn();
    } finally{
        ReactDOMSharedInternals.p = previousPriority;
    }
}
var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlersKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
}
function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[internalInstanceKey]) return parentNode;
                targetNode = getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error(formatProdErrorMessage(33));
}
function getResourcesFromRoot(root) {
    var resources = root[internalRootNodeResourcesKey];
    resources || (resources = root[internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = !0;
}
var allNativeEvents = new Set(), registrationNameDependencies = {};
function registerTwoPhaseEvent(registrationName, dependencies) {
    registerDirectEvent(registrationName, dependencies);
    registerDirectEvent(registrationName + "Capture", dependencies);
}
function registerDirectEvent(registrationName, dependencies) {
    registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)allNativeEvents.add(dependencies[registrationName]);
}
var VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty.call(validatedAttributeNameCache, attributeName)) return !0;
    if (hasOwnProperty.call(illegalAttributeNameCache, attributeName)) return !1;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return validatedAttributeNameCache[attributeName] = !0;
    illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function setValueForAttribute(node, name, value) {
    if (isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function track(node) {
    if (!node._valueTracker) {
        var valueField = isCheckable(node) ? "checked" : "value";
        node._valueTracker = trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + getToStringValue(value);
        } else element.value !== "" + getToStringValue(value) && (element.value = "" + getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? setDefaultValue(element, type, getToStringValue(value)) : null != defaultValue ? setDefaultValue(element, type, getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + getToStringValue(name) : element.removeAttribute("name");
}
function initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    track(element);
}
function setDefaultValue(node, type, value) {
    "number" === type && getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + getToStringValue(defaultValue) : "";
}
function initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error(formatProdErrorMessage(92));
            if (isArrayImpl(children)) {
                if (1 < children.length) throw Error(formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    track(element);
}
function setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error(formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function noop$1() {}
var currentReplayingEvent = null;
function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var restoreTarget = null, restoreQueue = null;
function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[internalPropsKey] || null;
                            if (!otherProps) throw Error(formatProdErrorMessage(90));
                            updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var isInsideEventHandler = !1;
function batchedUpdates$1(fn, a, b) {
    if (isInsideEventHandler) return fn(a, b);
    isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if (isInsideEventHandler = !1, null !== restoreTarget || null !== restoreQueue) {
            if (flushSyncWork$1(), restoreTarget && (a = restoreTarget, fn = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)restoreStateOfTarget(fn[a]);
        }
    }
}
function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error(formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = !1;
if (canUseDOM) try {
    var options = {};
    Object.defineProperty(options, "passive", {
        get: function() {
            passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", options, options);
    window.removeEventListener("test", options, options);
} catch (e) {
    passiveBrowserEventsSupported = !1;
}
var root = null, startText = null, fallbackText = null;
function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root ? root.value : root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function functionThatReturnsTrue() {
    return !0;
}
function functionThatReturnsFalse() {
    return !1;
}
function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
    }
    assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign({}, EventInterface, {
    view: 0,
    detail: 0
}), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
    }
}), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign({}, MouseEventInterface, {
    dataTransfer: 0
}), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign({}, UIEventInterface, {
    relatedTarget: 0
}), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign({}, EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign({}, EventInterface, {
    data: 0
}), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function getEventModifierState() {
    return modifierStateGetter;
}
var KeyboardEventInterface = assign({}, UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
}), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign({}, MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign({}, EventInterface, {
    newState: 0,
    oldState: 0
}), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [
    9,
    13,
    27,
    32
], canUseCompositionEvent = canUseDOM && "CompositionEvent" in window, documentMode = null;
canUseDOM && "documentMode" in document && (documentMode = document.documentMode);
var canUseTextInputEvent = canUseDOM && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = !1;
function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var isComposing = !1;
function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            hasSpaceKeypress = !0;
            return SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing) return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root = null, isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [
        target
    ] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var activeElement$1 = null, activeElementInst$1 = null;
function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
}
function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
}
function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var isInputEventSupported = !1;
if (canUseDOM) {
    var JSCompiler_inline_result$jscomp$286;
    if (canUseDOM) {
        var isSupported$jscomp$inline_427 = "oninput" in document;
        if (!isSupported$jscomp$inline_427) {
            var element$jscomp$inline_428 = document.createElement("div");
            element$jscomp$inline_428.setAttribute("oninput", "return;");
            isSupported$jscomp$inline_427 = "function" === typeof element$jscomp$inline_428.oninput;
        }
        JSCompiler_inline_result$jscomp$286 = isSupported$jscomp$inline_427;
    } else JSCompiler_inline_result$jscomp$286 = !1;
    isInputEventSupported = JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
}
function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(dispatchQueue, activeElementInst$1, nativeEvent, getEventTarget(nativeEvent));
        batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
}
function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
}
function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return getInstIfValueChanged(activeElementInst$1);
}
function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
}
function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return getInstIfValueChanged(targetInst);
}
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is;
function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function getNodeForCharacterOffset(root, offset) {
    var node = getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = getLeafNode(node);
    }
}
function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = getActiveElement(containerInfo.document);
    }
    return element;
}
function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var skipSelectionChangeEvent = canUseDOM && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = !1;
function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement(doc) || (doc = activeElement, "selectionStart" in doc && hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc) || (lastSelection = doc, doc = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = activeElement)));
}
function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
}, prefixedEventNames = {}, style = {};
canUseDOM && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
simpleEventPluginEvents.push("scrollEnd");
function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
function finishQueueingConcurrentUpdates() {
    for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var queue = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var update = concurrentQueues[i];
        concurrentQueues[i++] = null;
        var lane = concurrentQueues[i];
        concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function enqueueUpdate$1(fiber, queue, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    enqueueUpdate$1(fiber, queue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
}
function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount) throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var emptyContextObject = {};
function FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function createFiberImplClass(tag, pendingProps, key, mode) {
    return new FiberNode(tag, pendingProps, key, mode);
}
function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case REACT_ACTIVITY_TYPE:
            return type = createFiberImplClass(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case REACT_FRAGMENT_TYPE:
            return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case REACT_PROFILER_TYPE:
            return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
            return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
            return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === typeof type && null !== type) switch(type.$$typeof){
                case REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error(formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function createFiberFromFragment(elements, mode, lanes, key) {
    elements = createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function createFiberFromText(content, mode, lanes) {
    content = createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var CapturedStacks = new WeakMap();
function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: getStackByFiberInDevAndProd(source)
    };
}
var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
function pushTreeFork(workInProgress, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress;
    treeForkCount = totalChildren;
}
function pushTreeId(workInProgress, totalChildren, index) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length + workInProgress;
    } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
}
function pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
}
function popTreeContext(workInProgress) {
    for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
}
function restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextId = suspendedContext.id;
    treeContextOverflow = suspendedContext.overflow;
    treeContextProvider = workInProgress;
}
var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error(formatProdErrorMessage(519));
function throwOnHydrationMismatch(fiber) {
    var error = Error(formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
}
function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props;
    switch(type){
        case "dialog":
            listenToNonDelegatedEvent("cancel", instance);
            listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < mediaEventTypes.length; type++)listenToNonDelegatedEvent(mediaEventTypes[type], instance);
            break;
        case "source":
            listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            listenToNonDelegatedEvent("error", instance);
            listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            listenToNonDelegatedEvent("invalid", instance);
            initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = noop$1), instance = !0) : instance = !1;
    instance || throwOnHydrationMismatch(fiber, !0);
}
function popToNextHostParent(fiber) {
    for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            rootOrSingletonContext = !0;
            return;
        default:
            hydrationParentFiber = hydrationParentFiber.return;
    }
}
function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return !1;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error(formatProdErrorMessage(317));
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = !1;
}
function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, queuedErrors), hydrationErrors = null);
    return queuedErrors;
}
function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [
        error
    ] : hydrationErrors.push(error);
}
var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
function pushProvider(providerFiber, context, nextValue) {
    push(valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
}
function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error(formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error(formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function prepareToReadContext(workInProgress) {
    currentlyRenderingFiber$1 = workInProgress;
    lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber$1, context);
}
function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
}
function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === lastContextDependency) {
        if (null === consumer) throw Error(formatProdErrorMessage(308));
        lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
}
var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, scheduleCallback$2 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function createCache() {
    return {
        controller: new AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
        cache.controller.abort();
    });
}
var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
}
function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var prevOnStartTransitionFinish = ReactSharedInternals.S;
ReactSharedInternals.S = function(transition, returnValue) {
    globalMostRecentTransitionTime = now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
};
var resumedCache = createCursor(null);
function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
}
function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
}
function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), SuspenseActionException = Error(formatProdErrorMessage(542)), noopSuspenseyCommitThenable = {
    then: function() {}
};
function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop$1, noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
            else {
                thenableState = workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error(formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            suspendedThenable = thenable;
            throw SuspenseException;
    }
}
function resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw suspendedThenable = x, SuspenseException;
        throw x;
    }
}
var suspendedThenable = null;
function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
}
function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException) throw Error(formatProdErrorMessage(483));
}
var thenableState$1 = null, thenableIndexCounter$1 = 0;
function unwrapThenable(thenable) {
    var index = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    return trackUsedThenable(thenableState$1, thenable, index);
}
function coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error(formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
        current = createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case REACT_PORTAL_TYPE:
                    return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newChild = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if (isArrayImpl(newChild) || getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error(formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case REACT_LAZY_TYPE:
                    return newChild = resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if (getIteratorFn(newChild)) {
                key = getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
            throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === SuspenseException || x === SuspenseActionException) throw x;
            var fiber = createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), hasForceUpdate = !1;
function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = getRootForUpdatedFiber(fiber);
        markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
}
function entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root, lane);
    }
}
function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var didReadFromEntangledAsyncAction = !1;
function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = assign({}, newState, updateLane);
                            break a;
                        case 2:
                            hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error(formatProdErrorMessage(191, callback));
    callback.call(context);
}
function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
}
var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push(prevEntangledRenderLanesCursor, fiber);
    push(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
}
function reuseHiddenContextOnStack() {
    push(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
}
function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
}
var suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
function pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    push(suspenseStackCursor, suspenseStackCursor.current & 1);
    push(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
}
function pushDehydratedActivitySuspenseHandler(fiber) {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, fiber);
    null === shellBoundary && (shellBoundary = fiber);
}
function pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack(fiber);
}
function reuseSuspenseHandlerOnStack() {
    push(suspenseStackCursor, suspenseStackCursor.current);
    push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
}
function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
}
var suspenseStackCursor = createCursor(0);
function findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0;
function throwInvalidHookError() {
    throw Error(formatProdErrorMessage(321));
}
function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = !1;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(workInProgress, Component, props, secondArg));
    finishRenderingHooks(current);
    return nextRenderLanes;
}
function finishRenderingHooks(current) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = !1;
    thenableIndexCounter = 0;
    thenableState = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
    null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
}
function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
        thenableIndexCounter = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
        numberOfReRenders += 1;
        workInProgressHook = currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        ReactSharedInternals.H = HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
}
function bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function resetHooksOnUnwind(workInProgress) {
    if (didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        didScheduleRenderPhaseUpdate = !1;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = !1;
    thenableIndexCounter = localIdCounter = 0;
    thenableState = null;
}
function mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
}
function updateWorkInProgressHook() {
    if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === currentlyRenderingFiber.alternate) throw Error(formatProdErrorMessage(467));
            throw Error(formatProdErrorMessage(310));
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: currentHook.memoizedState,
            baseState: currentHook.baseState,
            baseQueue: currentHook.baseQueue,
            queue: currentHook.queue,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
}
function createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function useThenable(thenable) {
    var index = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    thenable = trackUsedThenable(thenableState, thenable, index);
    index = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null === index || null === index.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
}
function use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage(438, String(usable)));
}
function useMemoCache(size) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
}
function updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if ((renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs((currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0);
    hook = hook.queue;
    updateEffect(subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        pushSimpleEffect(9, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
}
function subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function forceStoreRerender(fiber) {
    var root = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && scheduleUpdateOnFiber(root, fiber, 2);
}
function mountStateImpl(initialState) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
}
function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        onActionError(actionQueue, node, error$66);
    }
}
function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return onActionError(actionQueue, node, error);
    }) : onActionSuccess(actionQueue, node, returnValue);
}
function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
}
function onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function actionStateReducer(oldState, newState) {
    return newState;
}
function mountActionState(action, initialStateProp) {
    if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = currentlyRenderingFiber;
                if (isHydrating) {
                    if (nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                            for(var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            nextHydratableInstance = getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(!1);
    inRootOrSingleton = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
}
function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = useThenable(currentStateHook);
    } catch (x) {
        if (x === SuspenseException) throw SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(9, {
        destroy: void 0
    }, actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function updateRef() {
    return updateWorkInProgressHook().memoizedState;
}
function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = mountWorkInProgressHook();
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function mountEffect(create, deps) {
    mountEffectImpl(8390656, 8, create, deps);
}
function updateEffect(create, deps) {
    updateEffectImpl(2048, 8, create, deps);
}
function useEffectEventImpl(payload) {
    currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function updateEvent(callback) {
    var ref = updateWorkInProgressHook().memoizedState;
    useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function updateInsertionEffect(create, deps) {
    return updateEffectImpl(4, 2, create, deps);
}
function updateLayoutEffect(create, deps) {
    return updateEffectImpl(4, 4, create, deps);
}
function imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
}
function mountDebugValue() {}
function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
    if (0 === (renderLanes & 42) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930)) return didReceiveUpdate = !0, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
            dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
        } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
    } catch (error) {
        dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, requestUpdateLane());
    } finally{
        ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
}
function noop() {}
function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(formFiber, queue, pendingState, sharedNotPendingObject, null === action ? noop : function() {
        requestFormReset$1(formFiber);
        return action(formData);
    });
}
function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: sharedNotPendingObject,
        baseState: sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function requestFormReset$1(formFiber) {
    var stateHook = ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, requestUpdateLane());
}
function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
}
function updateId() {
    return updateWorkInProgressHook().memoizedState;
}
function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
}
function refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = requestUpdateLane();
                fiber = createUpdate(lane);
                var root$69 = enqueueUpdate(provider, fiber, lane);
                null !== root$69 && (scheduleUpdateOnFiber(root$69, provider, lane), entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function dispatchReducerAction(fiber, queue, action) {
    var lane = requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
}
function dispatchSetState(fiber, queue, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action, lane);
}
function dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
    } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
}
function enqueueRenderPhaseUpdate(queue, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        markRootEntangled(root, lane);
    }
}
var ContextOnlyDispatcher = {
    readContext: readContext,
    use: use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
};
ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
var HooksDispatcherOnMount = {
    readContext: readContext,
    use: use,
    useCallback: function(callback, deps) {
        mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        mountEffectImpl(4194308, 4, imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = mountWorkInProgressHook();
        return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = mountStateImpl(!1);
        stateHook = startTransition.bind(null, currentlyRenderingFiber, stateHook.queue, !0, !1);
        mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
        if (isHydrating) {
            if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
            0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        pushSimpleEffect(9, {
            destroy: void 0
        }, updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
        if (isHydrating) {
            var JSCompiler_inline_result = treeContextOverflow;
            var idWithLeadingBit = treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: function() {
        return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, HooksDispatcherOnUpdate = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
        return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
};
HooksDispatcherOnUpdate.useEffectEvent = updateEvent;
var HooksDispatcherOnRerender = {
    readContext: readContext,
    use: use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
        return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = updateWorkInProgressHook();
        return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus: useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: useMemoCache,
    useCacheRefresh: updateRefresh
};
HooksDispatcherOnRerender.useEffectEvent = updateEvent;
function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(), update = createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = enqueueUpdate(inst, update, lane);
        null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
};
function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
}
function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function defaultOnUncaughtError(error) {
    reportGlobalError(error);
}
function defaultOnCaughtError(error) {
    console.error(error);
}
function defaultOnRecoverableError(error) {
    reportGlobalError(error);
}
function logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function createRootErrorUpdate(root, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        logUncaughtError(root, errorInfo);
    };
    return lane;
}
function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error(formatProdErrorMessage(435, sourceFiber.tag));
        }
        attachPingListener(root, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return !1;
    }
    if (isHydrating) return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root = Error(formatProdErrorMessage(422), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(root, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
        cause: value
    }), queueHydrationError(createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error(formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
        wrapperError
    ] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = !1;
function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress);
    nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && key && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack(workInProgress));
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && pushTransition(workInProgress, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress);
    null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function mountActivityChildren(workInProgress, nextProps) {
    nextProps = mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if (isHydrating) {
            if ("hidden" === nextProps.mode) return current = mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, bailoutOffscreenComponent(null, current);
            pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = nextHydratableInstance) ? (current = canHydrateHydrationBoundary(current, rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== treeContextProvider ? {
                    id: treeContextId,
                    overflow: treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : current = null;
            if (null === current) throw throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error(formatProdErrorMessage(558));
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || didSuspend) {
            nextProps = workInProgressRoot;
            if (null !== nextProps && (dehydrated = getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, enqueueConcurrentRenderForLane(current, dehydrated), scheduleUpdateOnFiber(nextProps, current, dehydrated), SelectiveHydrationException;
            renderDidSuspendDelayIfPossible();
            workInProgress = retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, nextHydratableInstance = getNextHydratable(dehydrated.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error(formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    finishRenderingHooks(current);
    Component = checkDidRenderIdHook();
    if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    isHydrating && Component && pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && (applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress, nextProps, context, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    resetHydrationState();
    workInProgress.flags |= 256;
    reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: getSuspendedCache()
    };
}
function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= workInProgressDeferredLane);
    return current;
}
function updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if (isHydrating) {
            showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
            (current = nextHydratableInstance) ? (current = canHydrateHydrationBoundary(current, rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== treeContextProvider ? {
                    id: treeContextId,
                    overflow: treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null)) : current = null;
            if (null === current) throw throwOnHydrationMismatch(workInProgress);
            isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(null, nextProps);
        pushPrimaryTreeSuspenseHandler(workInProgress);
        return mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = bailoutOffscreenComponent(null, nextProps));
        else if (pushPrimaryTreeSuspenseHandler(workInProgress), isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error(formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
            isSuspenseInstancePending(nextPrimaryChildren) || renderDidSuspendDelayIfPossible();
            workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, nextHydratableInstance = getNextHydratable(nextPrimaryChildren.nextSibling), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && restoreSuspendedTreeContext(workInProgress, current), workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current.child, nextProps);
    pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    push(suspenseStackCursor, suspenseContext);
    reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = isHydrating ? treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error(formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && checkIfContextChanged(current) ? !0 : !1;
}
function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
            resetHydrationState();
            break;
        case 27:
        case 5:
            pushHostContext(workInProgress);
            break;
        case 4:
            pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                pushPrimaryTreeSuspenseHandler(workInProgress);
                current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            push(suspenseStackCursor, suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) didReceiveUpdate = !0;
        else {
            if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else didReceiveUpdate = !1, isHydrating && 0 !== (workInProgress.flags & 1048576) && pushTreeId(workInProgress, treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) shouldConstruct(current) ? (props = resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = getComponentNameFromType(current) || current;
                    throw Error(formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = resolveClassComponentProps(props, workInProgress.pendingProps), updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error(formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                cloneUpdateQueue(current, workInProgress);
                processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                pushProvider(workInProgress, CacheContext, props);
                props !== prevState.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0);
                suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = createCapturedValueAtFiber(Error(formatProdErrorMessage(424)), workInProgress);
                        queueHydrationError($$typeof);
                        workInProgress = mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        nextHydratableInstance = getNextHydratable(current.firstChild);
                        hydrationParentFiber = workInProgress;
                        isHydrating = !0;
                        hydrationErrors = null;
                        rootOrSingletonContext = !0;
                        renderLanes = mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current).createElement(renderLanes), props[internalInstanceKey] = workInProgress, props[internalPropsKey] = current, setInitialProperties(props, renderLanes, current), markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return pushHostContext(workInProgress), null === current && isHydrating && (props = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, $$typeof = nextHydratableInstance, isSingletonScope(workInProgress.type) ? (previousHydratableOnEnteringScopedSingleton = $$typeof, nextHydratableInstance = getNextHydratable(props.firstChild)) : nextHydratableInstance = $$typeof), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && isHydrating) {
                if ($$typeof = props = nextHydratableInstance) props = canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, hydrationParentFiber = workInProgress, nextHydratableInstance = getNextHydratable(props.firstChild), rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || throwOnHydrationMismatch(workInProgress);
            }
            pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), HostTransitionContext._currentValue = $$typeof);
            markRef(current, workInProgress);
            reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && isHydrating) {
                if (current = renderLanes = nextHydratableInstance) renderLanes = canHydrateTextInstance(renderLanes, workInProgress.pendingProps, rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null, current = !0) : current = !1;
                current || throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, props, renderLanes) : reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, pushProvider(workInProgress, workInProgress.type, props.value), reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, prepareToReadContext(workInProgress), $$typeof = readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return prepareToReadContext(workInProgress), props = readContext(CacheContext), null === current ? ($$typeof = peekCacheFromPool(), null === $$typeof && ($$typeof = workInProgressRoot, prevState = createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), pushProvider(workInProgress, CacheContext, props)) : (props = prevState.cache, pushProvider(workInProgress, CacheContext, props), props !== $$typeof.cache && propagateContextChanges(workInProgress, [
                CacheContext
            ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
        if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
    }
}
function scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
}
function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return bubbleProperties(workInProgress), null;
        case 1:
            return bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            popProvider(CacheContext);
            popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) popHydrationState(workInProgress) ? markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, upgradeHydrationErrorsToRecoverable());
            bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? (markUpdate(workInProgress), null !== nextResource ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && markUpdate(workInProgress), bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            popHostContext(workInProgress);
            renderLanes = rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                current = contextStackCursor.current;
                popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, markUpdate(workInProgress));
            }
            bubbleProperties(workInProgress);
            return null;
        case 5:
            popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = contextStackCursor.current;
                if (popHydrationState(workInProgress)) prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = getOwnerDocumentFromRootContainer(rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[internalInstanceKey] = workInProgress;
                    nextResource[internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch(setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && markUpdate(workInProgress);
                }
            }
            bubbleProperties(workInProgress);
            preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                current = rootInstanceStackCursor.current;
                if (popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || throwOnHydrationMismatch(workInProgress, !0);
                } else current = getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error(formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error(formatProdErrorMessage(557));
                        current[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error(formatProdErrorMessage(558));
            }
            bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error(formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error(formatProdErrorMessage(317));
                        type[internalInstanceKey] = workInProgress;
                    } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    bubbleProperties(workInProgress);
                    type = !1;
                } else type = upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                    popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            bubbleProperties(workInProgress);
            return null;
        case 4:
            return popHostContainer(), null === current && listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
        case 10:
            return popProvider(workInProgress.type), bubbleProperties(workInProgress), null;
        case 19:
            pop(suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            push(suspenseStackCursor, suspenseStackCursor.current & 1 | 2);
                            isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && now() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                    } else 2 * now() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = now(), current.sibling = null, renderLanes = suspenseStackCursor.current, push(suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), isHydrating && pushTreeFork(workInProgress, newProps.treeForkCount), current;
            bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error(formatProdErrorMessage(156, workInProgress.tag));
}
function unwindWork(current, workInProgress) {
    popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return popProvider(CacheContext), popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return pop(suspenseStackCursor), null;
        case 4:
            return popHostContainer(), null;
        case 10:
            return popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return popSuspenseHandler(workInProgress), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return popProvider(CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function unwindInterruptedWork(current, interruptedWork) {
    popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            popProvider(CacheContext);
            popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            popHostContext(interruptedWork);
            break;
        case 4:
            popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
            break;
        case 13:
            popSuspenseHandler(interruptedWork);
            break;
        case 19:
            pop(suspenseStackCursor);
            break;
        case 10:
            popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            popSuspenseHandler(interruptedWork);
            popHiddenContext();
            null !== current && pop(resumedCache);
            break;
        case 24:
            popProvider(CacheContext);
    }
}
function commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            commitCallbacks(updateQueue, instance);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[internalPropsKey] = newProps;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = noop$1));
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        setInitialProperties(singleton, type, props);
        singleton[internalInstanceKey] = finishedWork;
        singleton[internalPropsKey] = props;
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null;
function commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    eventsEnabled = _enabled;
    root = getActiveElementDeep(root);
    if (hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    _enabled = !1;
    for(nextEffect = firstChild; null !== nextEffect;)if (firstChild = nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, nextEffect = root;
    else for(; null !== nextEffect;){
        firstChild = nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error(formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            nextEffect = root;
            break;
        }
        nextEffect = firstChild.return;
    }
}
function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && commitClassCallbacks(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    commitCallbacks(finishedRoot, current);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && commitHostMount(finishedWork);
            flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(null, finishedWork), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                prevProps = offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = flags;
                (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                offscreenSubtreeIsHidden = prevProps;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var hostParent = null, hostParentIsContainer = !1;
function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
            isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = !1);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            releaseSingletonInstance(deletedFiber.stateNode);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = null;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            if (null !== hostParent) {
                if (hostParentIsContainer) try {
                    (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = hostParent;
            prevHostParentIsContainer = hostParentIsContainer;
            hostParent = deletedFiber.stateNode.containerInfo;
            hostParentIsContainer = !0;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            hostParent = prevHostParent;
            hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            retryIfBlockedOn(finishedRoot);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        retryIfBlockedOn(finishedRoot);
    } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
            throw Error(formatProdErrorMessage(435, finishedWork.tag));
    }
}
function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if (isSingletonScope(parent.type)) {
                        hostParent = parent.stateNode;
                        hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    hostParent = parent.stateNode;
                    hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    hostParent = parent.stateNode.containerInfo;
                    hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage(160));
        commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var currentHoistableRoot = null;
function commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = currentHoistableRoot;
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        setInitialProperties(currentResource, flags, current);
                                        currentResource[internalInstanceKey] = finishedWork;
                                        markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error(formatProdErrorMessage(468, flags));
                                }
                                currentResource[internalInstanceKey] = finishedWork;
                                markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            null !== current && flags & 4 && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    setTextContent(hoistableRoot, "");
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && (needsFormReset = !0);
            break;
        case 6:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error(formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            tagCaches = null;
            hoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(root.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            currentHoistableRoot = hoistableRoot;
            commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo);
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            currentHoistableRoot = flags;
            break;
        case 12:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            break;
        case 31:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            recursivelyTraverseMutationEffects(root, finishedWork);
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? hideOrUnhideDehydratedBoundary(instance, !0) : hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            recursivelyTraverseMutationEffects(root, finishedWork);
            commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
    }
}
function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if (isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error(formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && (setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = getHostSibling(finishedWork);
                    insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error(formatProdErrorMessage(161));
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                safelyDetachRef(finishedWork, finishedWork.return);
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
}
function commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
}
function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var suspenseyCommitFlag = 8192;
function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(suspendedState, currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = currentHoistableRoot;
            currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, deletions, deletions.return);
                recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== nextEffect;){
        var fiber = nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
            cache = nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            detachFiberAfterEffects(cache);
            if (cache === fiber) {
                nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                nextEffect = sibling;
                break a;
            }
            nextEffect = returnFiber;
        }
    }
}
var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return readContext(CacheContext).controller.signal;
    }
}, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
function requestUpdateLane() {
    return 0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes ? workInProgressRootRenderLanes & -workInProgressRootRenderLanes : null !== ReactSharedInternals.T ? requestTransitionLane() : resolveUpdatePriority();
}
function requestDeferredLane() {
    if (0 === workInProgressDeferredLane) {
        if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
            var lane = nextTransitionDeferredLane;
            nextTransitionDeferredLane <<= 1;
            0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
            workInProgressDeferredLane = lane;
        } else workInProgressDeferredLane = 536870912;
    }
    lane = suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return workInProgressDeferredLane;
}
function scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    markRootUpdated$1(root, lane);
    if (0 === (executionContext & 2) || root !== workInProgressRoot) root === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
}
function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = workInProgressRootRecoverableErrors;
                            workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                prepareFreshStack(root$jscomp$0, 0);
                markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error(formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error(formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
                    markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                commitRootWhenReady(shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    ensureRootIsScheduled(root$jscomp$0);
}
function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: noop$1
        };
        accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now() : 0;
        timeoutOffset = waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset(commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function resetWorkInProgressStack() {
    if (null !== workInProgress) {
        if (0 === workInProgressSuspendedReason) var interruptedWork = workInProgress.return;
        else interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
        for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
    }
}
function prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    pendingEffectsLanes = 0;
    resetWorkInProgressStack();
    workInProgressRoot = root;
    workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = !1;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    workInProgressRootDidAttachPingListener = !1;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function handleThrow(root, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current)));
}
function shouldRemainOnPreviousScreen() {
    var handler = suspenseHandlerStackCursor.current;
    return null === handler ? !0 : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? !0 : !1 : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : !1;
}
function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
}
function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
}
function renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) workInProgressTransitions = null, prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = workInProgressRootExitStatus;
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch(workInProgressSuspendedReason){
                case 8:
                    resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = workInProgressSuspendedReason;
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
}
function workLoopSync() {
    for(; null !== workInProgress;)performUnitOfWork(workInProgress);
}
function renderRootConcurrent(root, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
            lanes = workInProgress;
            var thrownValue = workInProgressThrownValue;
            b: switch(workInProgressSuspendedReason){
                case 1:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if (isThenableResolved(thrownValue)) {
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root || (workInProgressSuspendedReason = 7);
                        ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch(workInProgress.tag){
                        case 26:
                            resource = workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = workInProgress;
                            if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                                workInProgressSuspendedReason = 0;
                                workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                }
                                break b;
                            }
                    }
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    resetWorkInProgressStack();
                    workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error(formatProdErrorMessage(462));
            }
        }
        workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        handleThrow(root, thrownValue$167);
    }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
}
function workLoopConcurrentByScheduler() {
    for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
}
function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, workInProgressRootRenderLanes);
            break;
        case 11:
            next = replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, workInProgressRootRenderLanes);
            break;
        case 5:
            resetHooksOnUnwind(next);
        default:
            unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
}
function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState$1 = null;
    thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
            workInProgressRootExitStatus = 1;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error;
        workInProgressRootExitStatus = 1;
        logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
        workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if (isHydrating || 1 === suspendedReason) root = !0;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
        else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root);
    } else completeUnitOfWork(unitOfWork);
}
function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = completeWork(completedWork.alternate, completedWork, entangledRenderLanes);
        if (null !== next) {
            workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            workInProgress = completedWork;
            return;
        }
        workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
}
function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            workInProgress = unitOfWork;
            return;
        }
        workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
}
function commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
        markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        pendingFinishedWork = finishedWork;
        pendingEffectsRoot = root;
        pendingEffectsLanes = lanes;
        pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        pendingPassiveTransitions = transitions;
        pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
            flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            transitions = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            spawnedLane = executionContext;
            executionContext |= 4;
            try {
                commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
            }
        }
        pendingEffectsStatus = 1;
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
    }
}
function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = selectionInformation, curFocusedElem = getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                _enabled = !!eventsEnabled;
                selectionInformation = eventsEnabled = null;
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        pendingEffectsStatus = 2;
    }
}
function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = ReactSharedInternals.T;
            ReactSharedInternals.T = null;
            var previousPriority = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = executionContext;
            executionContext |= 4;
            try {
                commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        pendingEffectsStatus = 3;
    }
}
function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
        pendingEffectsStatus = 0;
        requestPaint();
        var root = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
        lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
            injectedHook.onCommitFiberRoot(rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = ReactSharedInternals.T;
            remainingLanes = ReactDOMSharedInternals.p;
            ReactDOMSharedInternals.p = 2;
            ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
        ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root) : nestedUpdateCount = 0;
        flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
}
function flushPendingEffects() {
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects();
}
function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return !1;
    var root = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        ReactSharedInternals.T = null;
        renderPriority = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
        pendingEffectsStatus = 0;
        pendingFinishedWork = pendingEffectsRoot = null;
        pendingEffectsLanes = 0;
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        commitPassiveUnmountOnFiber(root$jscomp$0.current);
        commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        executionContext = prevExecutionContext;
        flushSyncWorkAcrossRoots_impl(0, !1);
        if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
            injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root, remainingLanes);
    }
}
function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
}
function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                error = createClassErrorUpdate(2);
                instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root);
}
function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
}
function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error(formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
}
function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
}
var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0;
function ensureRootIsScheduled(root) {
    root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
    mightHavePendingSyncWork = !0;
    didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateRootScheduleTask());
}
function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(root$170, root$170 === workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        isFlushingWork = !1;
    }
}
function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
}
function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
    for(var currentTime = now(), prev = null, root = firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus || flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
}
function scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && cancelCallback$1(pingedLanes);
        switch(lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = IdlePriority;
                break;
            default:
                suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if (flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root, now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function performSyncWorkOnRoot(root, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root, lanes, !0);
}
function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
        0 !== (executionContext & 6) ? scheduleCallback$3(ImmediatePriority, processRootScheduleInImmediateTask) : processRootScheduleInMicrotask();
    });
}
function requestTransitionLane() {
    if (0 === currentEventTransitionLane) {
        var actionScopeLane = currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
        currentEventTransitionLane = actionScopeLane;
    }
    return currentEventTransitionLane;
}
function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
}
function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = coerceFormActionProp((nativeEventTarget[internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== currentEventTransitionLane) {
                                var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var i$jscomp$inline_1577 = 0; i$jscomp$inline_1577 < simpleEventPluginEvents.length; i$jscomp$inline_1577++){
    var eventName$jscomp$inline_1578 = simpleEventPluginEvents[i$jscomp$inline_1577], domEventName$jscomp$inline_1579 = eventName$jscomp$inline_1578.toLowerCase(), capitalizedEvent$jscomp$inline_1580 = eventName$jscomp$inline_1578[0].toUpperCase() + eventName$jscomp$inline_1578.slice(1);
    registerSimpleEvent(domEventName$jscomp$inline_1579, "on" + capitalizedEvent$jscomp$inline_1580);
}
registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
registerSimpleEvent(ANIMATION_START, "onAnimationStart");
registerSimpleEvent("dblclick", "onDoubleClick");
registerSimpleEvent("focusin", "onFocus");
registerSimpleEvent("focusout", "onBlur");
registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
registerSimpleEvent(TRANSITION_START, "onTransitionStart");
registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes));
function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = !0;
        allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, !1, rootContainerElement), listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = !0, listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch(getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = SyntheticTouchEvent;
                        break;
                    case ANIMATION_END:
                    case ANIMATION_ITERATION:
                    case ANIMATION_START:
                        SyntheticEventCtor = SyntheticAnimationEvent;
                        break;
                    case TRANSITION_END:
                        SyntheticEventCtor = SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = getTargetInstForChangeEvent;
                else if (isTextInputElement(reactName)) {
                    if (isInputEventSupported) getTargetInstFunc = getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = getTargetInstForInputEventPolyfill;
                        var handleEventFunc = handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
                    break;
                case "focusout":
                    lastSelection = activeElementInst = activeElement = null;
                    break;
                case "mousedown":
                    mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    mouseDown = !1;
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if (skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if (canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root = nativeEventTarget, startText = "value" in root ? root.value : root.textContent, isComposing = !0)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag && setTextContent(domElement, "" + value);
            break;
        case "className":
            setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && setProp(domElement, tag, "name", props.name, props, null), setProp(domElement, tag, "formEncType", props.formEncType, props, null), setProp(domElement, tag, "formMethod", props.formMethod, props, null), setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : (setProp(domElement, tag, "encType", props.encType, props, null), setProp(domElement, tag, "method", props.method, props, null), setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
    }
}
function setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error(formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error(formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
    }
}
function setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error(formatProdErrorMessage(137, tag));
                    default:
                        setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? updateOptions(domElement, !!hasSrc, tag, !1) : null != props && updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            listenToNonDelegatedEvent("beforetoggle", domElement);
            listenToNonDelegatedEvent("toggle", domElement);
            listenToNonDelegatedEvent("cancel", domElement);
            listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            listenToNonDelegatedEvent("error", domElement);
            listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error(formatProdErrorMessage(137, tag));
                default:
                    setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error(formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? updateOptions(domElement, !!lastProps, tag, !0) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error(formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && setProp(domElement, tag, value, name, nextProps, type);
            }
            updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                    break;
                default:
                    setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error(formatProdErrorMessage(137, tag));
                    break;
                default:
                    setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if (isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var eventsEnabled = null, selectionInformation = null;
function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var currentPopstateTransitionEvent = null;
function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return !1;
        currentPopstateTransitionEvent = event;
        return !0;
    }
    currentPopstateTransitionEvent = null;
    return !1;
}
var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
} : scheduleTimeout;
function handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function isSingletonScope(type) {
    return "head" === type;
}
function clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    retryIfBlockedOn(hydrationInstance);
}
function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                clearContainerSparingly(node);
                detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var previousHydratableOnEnteringScopedSingleton = null;
function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function resolveSingletonInstance(type, props, rootContainerInstance) {
    props = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error(formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error(formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error(formatProdErrorMessage(454));
            return type;
        default:
            throw Error(formatProdErrorMessage(451));
    }
}
function releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    detachDeletedInstance(instance);
}
var preloadPropsMap = new Map(), preconnectsSet = new Set();
function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var previousDispatcher = ReactDOMSharedInternals.d;
ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
};
function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
}
var globalDocument = "undefined" === typeof document ? null : document;
function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
}
function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
}
function preload(href, as, options) {
    previousDispatcher.L(href, as, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = getStyleKey(href);
                break;
            case "script":
                key = getScriptKey(href);
        }
        preloadPropsMap.has(key) || (href = assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function preloadModule(href, options) {
    previousDispatcher.m(href, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = getScriptKey(href);
        }
        if (!preloadPropsMap.has(key) && (href = assign({
            rel: "modulepreload",
            href: href
        }, options), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector(getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function preinitStyle(href, precedence, options) {
    previousDispatcher.S(href, precedence, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
        var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector(getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                markNodeAsHoistable(link);
                setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function preinitScript(src, options) {
    previousDispatcher.X(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function preinitModuleScript(src, options) {
    previousDispatcher.M(src, options);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
        var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = getStyleKey(pendingProps.href);
                var styles$243 = getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector(getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, preloadPropsMap.set(type, pendingProps), styles$243 || preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error(formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error(formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error(formatProdErrorMessage(444, type));
    }
}
function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function stylesheetPropsFromRawProps(rawProps) {
    return assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector(getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, markNodeAsHoistable(instance$249), instance$249;
            instance = stylesheetPropsFromRawProps(props);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector(getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = preloadPropsMap.get(instance$249)) instance = assign({}, props), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error(formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var tagCaches = null;
function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
        var cache = new Map();
        var caches = tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = getStyleKey(props.href), instance = hoistableRoot.querySelector(getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = stylesheetPropsFromRawProps(props);
            (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var estimatedBytesWithinLimit = 0;
function waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 62500 * estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var precedencesByRoot = null;
function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
}
function insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
};
function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
}
function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = enqueueUpdate(rootFiber, container, lane);
    null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
}
function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
}
function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = requestUpdateLane();
        lane = getBumpedLaneForHydrationByLane(lane);
        var root = enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && scheduleUpdateOnFiber(root, fiber, lane);
        markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var _enabled = !0;
function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
        ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
}
function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                ensureRootIsScheduled(fiber);
                                0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = enqueueConcurrentRenderForLane(fiber, 2), null !== root && scheduleUpdateOnFiber(root, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = findInstanceBlockingEvent(nativeEvent);
                null === fiber && dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
}
var return_targetInst = null;
function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    return_targetInst = targetNode;
    return null;
}
function getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch(getCurrentPriorityLevel()){
                case ImmediatePriority:
                    return 2;
                case UserBlockingPriority:
                    return 8;
                case NormalPriority$1:
                case LowPriority:
                    return 32;
                case IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var hasScheduledReplayAttempt = !1, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = new Map(), queuedPointerCaptures = new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            queuedPointers.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(pointerId, accumulateOrCreateContinuousQueuedReplayableEvent(queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    runWithPriority(queuedTarget.priority, function() {
                        attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            currentReplayingEvent = null;
        } else return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function replayUnblockedEvents() {
    hasScheduledReplayAttempt = !1;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
}
function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = !0, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, replayUnblockedEvents)));
}
var lastScheduledReplayQueue = null;
function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler.unstable_scheduleCallback(Scheduler.unstable_NormalPriority, function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < queuedExplicitHydrationTargets.length && (i = queuedExplicitHydrationTargets[0], null === i.blockedOn);)attemptExplicitHydrationTarget(i), null === i.blockedOn && queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i);
        }
    }
}
function defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error(formatProdErrorMessage(409));
    var current = root.current, lane = requestUpdateLane();
    updateContainerImpl(current, lane, children, root, null, null);
};
ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        updateContainerImpl(root.current, 2, null, root, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
    }
};
function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i].priority; i++);
        queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && attemptExplicitHydrationTarget(target);
    }
};
var isomorphicReactPackageVersion$jscomp$inline_1840 = React.version;
if ("19.2.3" !== isomorphicReactPackageVersion$jscomp$inline_1840) throw Error(formatProdErrorMessage(527, isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.3"));
ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error(formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.3",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.2.3"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2348.isDisabled && hook$jscomp$inline_2348.supportsFiber) try {
        rendererID = hook$jscomp$inline_2348.inject(internals$jscomp$inline_2347), injectedHook = hook$jscomp$inline_2348;
    } catch (err) {}
}
exports.createRoot = function(container, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
    container[internalContainerInstanceKey] = options.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options);
};
exports.hydrateRoot = function(container, initialChildren, options) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, defaultOnDefaultTransitionIndicator);
    initialChildren.context = getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    markRootUpdated$1(initialChildren, options);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
};
exports.version = "19.2.3";

},{"934b50a50c275743":"awyfd","56d30b16d84cc622":"bmhQu","d42dbe4aacaa6df4":"82aNB"}],"awyfd":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1bf2b05c96b56e48");

},{"1bf2b05c96b56e48":"dYcnT"}],"dYcnT":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
exports.unstable_now = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var localPerformance = performance;
    exports.unstable_now = function() {
        return localPerformance.now();
    };
} else {
    var localDate = Date, initialTime = localDate.now();
    exports.unstable_now = function() {
        return localDate.now() - initialTime;
    };
}
var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, needsPaint = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function advanceTimers(currentTime) {
    for(var timer = peek(timerQueue); null !== timer;){
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek(timerQueue);
    }
}
function handleTimeout(currentTime) {
    isHostTimeoutScheduled = !1;
    advanceTimers(currentTime);
    if (!isHostCallbackScheduled) {
        if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = peek(timerQueue);
            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
function shouldYieldToHost() {
    return needsPaint ? !0 : exports.unstable_now() - startTime < frameInterval ? !1 : !0;
}
function performWorkUntilDeadline() {
    needsPaint = !1;
    if (isMessageLoopRunning) {
        var currentTime = exports.unstable_now();
        startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                isHostCallbackScheduled = !1;
                isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                isPerformingWork = !0;
                var previousPriorityLevel = currentPriorityLevel;
                try {
                    b: {
                        advanceTimers(currentTime);
                        for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                            var callback = currentTask.callback;
                            if ("function" === typeof callback) {
                                currentTask.callback = null;
                                currentPriorityLevel = currentTask.priorityLevel;
                                var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                currentTime = exports.unstable_now();
                                if ("function" === typeof continuationCallback) {
                                    currentTask.callback = continuationCallback;
                                    advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                currentTask === peek(taskQueue) && pop(taskQueue);
                                advanceTimers(currentTime);
                            } else pop(taskQueue);
                            currentTask = peek(taskQueue);
                        }
                        if (null !== currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = peek(timerQueue);
                            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
        }
    }
}
var schedulePerformWorkUntilDeadline;
if ("function" === typeof localSetImmediate) schedulePerformWorkUntilDeadline = function() {
    localSetImmediate(performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var channel = new MessageChannel(), port = channel.port2;
    channel.port1.onmessage = performWorkUntilDeadline;
    schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
    };
} else schedulePerformWorkUntilDeadline = function() {
    localSetTimeout(performWorkUntilDeadline, 0);
};
function requestHostTimeout(callback, ms) {
    taskTimeoutID = localSetTimeout(function() {
        callback(exports.unstable_now());
    }, ms);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(task) {
    task.callback = null;
};
exports.unstable_forceFrameRate = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return currentPriorityLevel;
};
exports.unstable_next = function(eventHandler) {
    switch(currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = currentPriorityLevel;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_requestPaint = function() {
    needsPaint = !0;
};
exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
    var currentTime = exports.unstable_now();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
exports.unstable_shouldYield = shouldYieldToHost;
exports.unstable_wrapCallback = function(callback) {
    var parentPriorityLevel = currentPriorityLevel;
    return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
};

},{}],"bmhQu":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("1803ac46c34b822c");

},{"1803ac46c34b822c":"ez6FA"}],"ez6FA":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, assign = Object.assign, emptyObject = {};
function Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
Component.prototype.isReactComponent = {};
Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function ComponentDummy() {}
ComponentDummy.prototype = Component.prototype;
function PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = emptyObject;
    this.updater = updater || ReactNoopUpdateQueue;
}
var pureComponentPrototype = PureComponent.prototype = new ComponentDummy();
pureComponentPrototype.constructor = PureComponent;
assign(pureComponentPrototype, Component.prototype);
pureComponentPrototype.isPureReactComponent = !0;
var isArrayImpl = Array.isArray;
function noop() {}
var ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, hasOwnProperty = Object.prototype.hasOwnProperty;
function ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function cloneAndReplaceKey(oldElement, newKey) {
    return ReactElement(oldElement.type, newKey, oldElement.props);
}
function isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
}
function escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var userProvidedKeyEscapeRegex = /\/+/g;
function getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? escape("" + element.key) : index.toString(36);
}
function resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then(noop, noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case REACT_ELEMENT_TYPE:
                case REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case REACT_LAZY_TYPE:
                    return invokeCallback = children._init, mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + getElementKey(children, 0) : nameSoFar, isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace(userProvidedKeyEscapeRegex, "$&/") + "/"), mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && (isValidElement(callback) && (callback = cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace(userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if (isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + getElementKey(nameSoFar, i), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + getElementKey(nameSoFar, i++), invokeCallback += mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return mapIntoArray(resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, Children = {
    map: mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
exports.Activity = REACT_ACTIVITY_TYPE;
exports.Children = Children;
exports.Component = Component;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.PureComponent = PureComponent;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = ReactSharedInternals;
exports.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(size) {
        return ReactSharedInternals.H.useMemoCache(size);
    }
};
exports.cache = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
exports.cacheSignal = function() {
    return null;
};
exports.cloneElement = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return ReactElement(element.type, key, props);
};
exports.createContext = function(defaultValue) {
    defaultValue = {
        $$typeof: REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
exports.createElement = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return ReactElement(type, key, props);
};
exports.createRef = function() {
    return {
        current: null
    };
};
exports.forwardRef = function(render) {
    return {
        $$typeof: REACT_FORWARD_REF_TYPE,
        render: render
    };
};
exports.isValidElement = isValidElement;
exports.lazy = function(ctor) {
    return {
        $$typeof: REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: lazyInitializer
    };
};
exports.memo = function(type, compare) {
    return {
        $$typeof: REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
exports.startTransition = function(scope) {
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then(noop, reportGlobalError);
    } catch (error) {
        reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
};
exports.unstable_useCacheRefresh = function() {
    return ReactSharedInternals.H.useCacheRefresh();
};
exports.use = function(usable) {
    return ReactSharedInternals.H.use(usable);
};
exports.useActionState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
exports.useCallback = function(callback, deps) {
    return ReactSharedInternals.H.useCallback(callback, deps);
};
exports.useContext = function(Context) {
    return ReactSharedInternals.H.useContext(Context);
};
exports.useDebugValue = function() {};
exports.useDeferredValue = function(value, initialValue) {
    return ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
exports.useEffect = function(create, deps) {
    return ReactSharedInternals.H.useEffect(create, deps);
};
exports.useEffectEvent = function(callback) {
    return ReactSharedInternals.H.useEffectEvent(callback);
};
exports.useId = function() {
    return ReactSharedInternals.H.useId();
};
exports.useImperativeHandle = function(ref, create, deps) {
    return ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
exports.useInsertionEffect = function(create, deps) {
    return ReactSharedInternals.H.useInsertionEffect(create, deps);
};
exports.useLayoutEffect = function(create, deps) {
    return ReactSharedInternals.H.useLayoutEffect(create, deps);
};
exports.useMemo = function(create, deps) {
    return ReactSharedInternals.H.useMemo(create, deps);
};
exports.useOptimistic = function(passthrough, reducer) {
    return ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
exports.useReducer = function(reducer, initialArg, init) {
    return ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
exports.useRef = function(initialValue) {
    return ReactSharedInternals.H.useRef(initialValue);
};
exports.useState = function(initialState) {
    return ReactSharedInternals.H.useState(initialState);
};
exports.useSyncExternalStore = function(subscribe, getSnapshot, getServerSnapshot) {
    return ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
exports.useTransition = function() {
    return ReactSharedInternals.H.useTransition();
};
exports.version = "19.2.3";

},{}],"82aNB":[function(require,module,exports,__globalThis) {
'use strict';
function checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
checkDCE();
module.exports = require("b657abac8afb5bb8");

},{"b657abac8afb5bb8":"5lC7J"}],"5lC7J":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("6a05e75e64e4f862");
function formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function noop() {}
var Internals = {
    d: {
        f: noop,
        r: function() {
            throw Error(formatProdErrorMessage(522));
        },
        D: noop,
        C: noop,
        L: noop,
        m: noop,
        X: noop,
        S: noop,
        M: noop
    },
    p: 0,
    findDOMNode: null
}, REACT_PORTAL_TYPE = Symbol.for("react.portal");
function createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
exports.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = Internals;
exports.createPortal = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error(formatProdErrorMessage(299));
    return createPortal$1(children, container, null, key);
};
exports.flushSync = function(fn) {
    var previousTransition = ReactSharedInternals.T, previousUpdatePriority = Internals.p;
    try {
        if (ReactSharedInternals.T = null, Internals.p = 2, fn) return fn();
    } finally{
        ReactSharedInternals.T = previousTransition, Internals.p = previousUpdatePriority, Internals.d.f();
    }
};
exports.preconnect = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, Internals.d.C(href, options));
};
exports.prefetchDNS = function(href) {
    "string" === typeof href && Internals.d.D(href);
};
exports.preinit = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
exports.preinitModule = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
                Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && Internals.d.M(href);
    }
};
exports.preload = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = getCrossOriginStringAs(as, options.crossOrigin);
        Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
exports.preloadModule = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = getCrossOriginStringAs(options.as, options.crossOrigin);
            Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else Internals.d.m(href);
    }
};
exports.requestFormReset = function(form) {
    Internals.d.r(form);
};
exports.unstable_batchedUpdates = function(fn, a) {
    return fn(a);
};
exports.useFormState = function(action, initialState, permalink) {
    return ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
exports.useFormStatus = function() {
    return ReactSharedInternals.H.useHostTransitionStatus();
};
exports.version = "19.2.3";

},{"6a05e75e64e4f862":"bmhQu"}],"f3cgC":[function(require,module,exports,__globalThis) {
/**
 * React Router DOM v6.30.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _reactRouter.AbortedDeferredError));
parcelHelpers.export(exports, "Await", ()=>(0, _reactRouter.Await));
parcelHelpers.export(exports, "MemoryRouter", ()=>(0, _reactRouter.MemoryRouter));
parcelHelpers.export(exports, "Navigate", ()=>(0, _reactRouter.Navigate));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _reactRouter.NavigationType));
parcelHelpers.export(exports, "Outlet", ()=>(0, _reactRouter.Outlet));
parcelHelpers.export(exports, "Route", ()=>(0, _reactRouter.Route));
parcelHelpers.export(exports, "Router", ()=>(0, _reactRouter.Router));
parcelHelpers.export(exports, "Routes", ()=>(0, _reactRouter.Routes));
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>(0, _reactRouter.UNSAFE_DataRouterContext));
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>(0, _reactRouter.UNSAFE_DataRouterStateContext));
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>(0, _reactRouter.UNSAFE_LocationContext));
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>(0, _reactRouter.UNSAFE_NavigationContext));
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>(0, _reactRouter.UNSAFE_RouteContext));
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>(0, _reactRouter.UNSAFE_useRouteId));
parcelHelpers.export(exports, "createMemoryRouter", ()=>(0, _reactRouter.createMemoryRouter));
parcelHelpers.export(exports, "createPath", ()=>(0, _reactRouter.createPath));
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>(0, _reactRouter.createRoutesFromChildren));
parcelHelpers.export(exports, "createRoutesFromElements", ()=>(0, _reactRouter.createRoutesFromElements));
parcelHelpers.export(exports, "defer", ()=>(0, _reactRouter.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _reactRouter.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _reactRouter.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _reactRouter.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _reactRouter.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _reactRouter.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _reactRouter.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _reactRouter.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _reactRouter.redirectDocument));
parcelHelpers.export(exports, "renderMatches", ()=>(0, _reactRouter.renderMatches));
parcelHelpers.export(exports, "replace", ()=>(0, _reactRouter.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _reactRouter.resolvePath));
parcelHelpers.export(exports, "useActionData", ()=>(0, _reactRouter.useActionData));
parcelHelpers.export(exports, "useAsyncError", ()=>(0, _reactRouter.useAsyncError));
parcelHelpers.export(exports, "useAsyncValue", ()=>(0, _reactRouter.useAsyncValue));
parcelHelpers.export(exports, "useBlocker", ()=>(0, _reactRouter.useBlocker));
parcelHelpers.export(exports, "useHref", ()=>(0, _reactRouter.useHref));
parcelHelpers.export(exports, "useInRouterContext", ()=>(0, _reactRouter.useInRouterContext));
parcelHelpers.export(exports, "useLoaderData", ()=>(0, _reactRouter.useLoaderData));
parcelHelpers.export(exports, "useLocation", ()=>(0, _reactRouter.useLocation));
parcelHelpers.export(exports, "useMatch", ()=>(0, _reactRouter.useMatch));
parcelHelpers.export(exports, "useMatches", ()=>(0, _reactRouter.useMatches));
parcelHelpers.export(exports, "useNavigate", ()=>(0, _reactRouter.useNavigate));
parcelHelpers.export(exports, "useNavigation", ()=>(0, _reactRouter.useNavigation));
parcelHelpers.export(exports, "useNavigationType", ()=>(0, _reactRouter.useNavigationType));
parcelHelpers.export(exports, "useOutlet", ()=>(0, _reactRouter.useOutlet));
parcelHelpers.export(exports, "useOutletContext", ()=>(0, _reactRouter.useOutletContext));
parcelHelpers.export(exports, "useParams", ()=>(0, _reactRouter.useParams));
parcelHelpers.export(exports, "useResolvedPath", ()=>(0, _reactRouter.useResolvedPath));
parcelHelpers.export(exports, "useRevalidator", ()=>(0, _reactRouter.useRevalidator));
parcelHelpers.export(exports, "useRouteError", ()=>(0, _reactRouter.useRouteError));
parcelHelpers.export(exports, "useRouteLoaderData", ()=>(0, _reactRouter.useRouteLoaderData));
parcelHelpers.export(exports, "useRoutes", ()=>(0, _reactRouter.useRoutes));
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>(0, _router.UNSAFE_ErrorResponseImpl));
//#endregion
parcelHelpers.export(exports, "BrowserRouter", ()=>BrowserRouter);
parcelHelpers.export(exports, "Form", ()=>Form);
parcelHelpers.export(exports, "HashRouter", ()=>HashRouter);
parcelHelpers.export(exports, "Link", ()=>Link);
parcelHelpers.export(exports, "NavLink", ()=>NavLink);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "ScrollRestoration", ()=>ScrollRestoration);
parcelHelpers.export(exports, "UNSAFE_FetchersContext", ()=>FetchersContext);
parcelHelpers.export(exports, "UNSAFE_ViewTransitionContext", ()=>ViewTransitionContext);
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", ()=>useScrollRestoration);
parcelHelpers.export(exports, "createBrowserRouter", ()=>createBrowserRouter);
parcelHelpers.export(exports, "createHashRouter", ()=>createHashRouter);
parcelHelpers.export(exports, "createSearchParams", ()=>createSearchParams);
parcelHelpers.export(exports, "unstable_HistoryRouter", ()=>HistoryRouter);
parcelHelpers.export(exports, "unstable_usePrompt", ()=>usePrompt);
parcelHelpers.export(exports, "useBeforeUnload", ()=>useBeforeUnload);
parcelHelpers.export(exports, "useFetcher", ()=>useFetcher);
parcelHelpers.export(exports, "useFetchers", ()=>useFetchers);
parcelHelpers.export(exports, "useFormAction", ()=>useFormAction);
parcelHelpers.export(exports, "useLinkClickHandler", ()=>useLinkClickHandler);
parcelHelpers.export(exports, "useSearchParams", ()=>useSearchParams);
parcelHelpers.export(exports, "useSubmit", ()=>useSubmit);
parcelHelpers.export(exports, "useViewTransitionState", ()=>useViewTransitionState);
var _react = require("react");
var _reactDom = require("react-dom");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const defaultMethod = "get";
const defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let _formDataSupportsSubmitter = null;
function isFormDataSubmitterSupported() {
    if (_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        _formDataSupportsSubmitter = false;
    } catch (e) {
        _formDataSupportsSubmitter = true;
    }
    return _formDataSupportsSubmitter;
}
const supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function getFormEncType(encType) {
    if (encType != null && !supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if (isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("enctype")) || defaultEncType;
        formData = new FormData(target);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = getFormEncType(target.getAttribute("formenctype")) || getFormEncType(form.getAttribute("enctype")) || defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!isFormDataSubmitterSupported()) {
            let { name, type, value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = defaultMethod;
        action = null;
        encType = defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData,
        body
    };
}
const _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], _excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.UNSAFE_ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const ViewTransitionContext = /*#__PURE__*/ _react.createContext({
    isTransitioning: false
});
const FetchersContext = /*#__PURE__*/ _react.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
const FLUSH_SYNC = "flushSync";
const flushSyncImpl = _reactDom[FLUSH_SYNC];
const USE_ID = "useId";
const useIdImpl = _react[USE_ID];
function startTransitionSafe(cb) {
    if (startTransitionImpl) startTransitionImpl(cb);
    else cb();
}
function flushSyncSafe(cb) {
    if (flushSyncImpl) flushSyncImpl(cb);
    else cb();
}
class Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let [pendingState, setPendingState] = _react.useState();
    let [vtContext, setVtContext] = _react.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = _react.useState();
    let [transition, setTransition] = _react.useState();
    let [interruption, setInterruption] = _react.useState();
    let fetcherData = _react.useRef(new Map());
    let { v7_startTransition } = future || {};
    let optInStartTransition = _react.useCallback((cb)=>{
        if (v7_startTransition) startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = _react.useCallback((newState, _ref2)=>{
        let { deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    _react.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    _react.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    _react.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    _react.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = _react.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterContext).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.UNSAFE_DataRouterStateContext).Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(FetchersContext.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ _react.createElement(ViewTransitionContext.Provider, {
        value: vtContext
    }, /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const MemoizedDataRoutes = /*#__PURE__*/ _react.memo(DataRoutes);
function DataRoutes(_ref3) {
    let { routes, future, state } = _ref3;
    return (0, _reactRouter.UNSAFE_useRoutesImpl)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref4) {
    let { basename, children, future, window: window1 } = _ref4;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref5) {
    let { basename, children, future, window: window1 } = _ref5;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref6) {
    let { basename, children, future, history } = _ref6;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>(0, _reactRouter.UNSAFE_logV6DeprecationWarnings)(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick, relative, reloadDocument, replace, state, target, to, preventScrollReset, viewTransition } = _ref7, rest = _objectWithoutPropertiesLoose(_ref7, _excluded);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if (isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, _reactRouter.useHref)(to, {
        relative
    });
    let internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative,
        viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive = false, className: classNameProp = "", end = false, style: styleProp, to, viewTransition, children } = _ref8, rest = _objectWithoutPropertiesLoose(_ref8, _excluded2);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    let location = (0, _reactRouter.useLocation)();
    let routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    let { navigator, basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useViewTransitionState(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, _router.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive,
        isPending,
        isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const Form = /*#__PURE__*/ _react.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey, navigate, reloadDocument, replace, state, method = defaultMethod, action, onSubmit, relative, preventScrollReset, viewTransition } = _ref9, props = _objectWithoutPropertiesLoose(_ref9, _excluded3);
    let submit = useSubmit();
    let formAction = useFormAction(action, {
        relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey,
            method: submitMethod,
            navigate,
            replace,
            state,
            relative,
            preventScrollReset,
            viewTransition
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref10) {
    let { getKey, storageKey } = _ref10;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
// Internal hooks
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    let { target, replace: replaceProp, state, preventScrollReset, relative, viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, _reactRouter.useNavigate)();
    let location = (0, _reactRouter.useLocation)();
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback((event)=>{
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative,
                viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    let defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    let hasSetSearchParamsRef = _react.useRef(false);
    let location = (0, _reactRouter.useLocation)();
    let searchParams = _react.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, _reactRouter.useNavigate)();
    let setSearchParams = _react.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let fetcherId = 0;
let getUniqueFetcherId = ()=>"__" + String(++fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    let { router } = useDataRouterContext(DataRouterHook.UseSubmit);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        validateClientSideSubmission();
        let { action, method, encType, formData, body } = getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData,
                body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData,
            body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher(_temp3) {
    var _route$matches;
    let { key } = _temp3 === void 0 ? {} : _temp3;
    let { router } = useDataRouterContext(DataRouterHook.UseFetcher);
    let state = useDataRouterState(DataRouterStateHook.UseFetcher);
    let fetcherData = _react.useContext(FetchersContext);
    let route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, _router.UNSAFE_invariant)(false);
    !route && (0, _router.UNSAFE_invariant)(false);
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = useIdImpl ? useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = _react.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey(getUniqueFetcherId());
    // Registration/cleanup
    _react.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = _react.useCallback((href, opts)=>{
        !routeId && (0, _router.UNSAFE_invariant)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = useSubmit();
    let submit = _react.useCallback((target, opts)=>{
        submitImpl(target, _extends({}, opts, {
            navigate: false,
            fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = _react.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
            return /*#__PURE__*/ _react.createElement(Form, _extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, _router.IDLE_FETCHER);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = _react.useMemo(()=>_extends({
            Form: FetcherForm,
            submit,
            load
        }, fetcher, {
            data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    let state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return _extends({}, fetcher, {
            key
        });
    });
}
const SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp4) {
    let { getKey, storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router } = useDataRouterContext(DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition, preventScrollReset } = useDataRouterState(DataRouterStateHook.UseScrollRestoration);
    let { basename } = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext));
    let location = (0, _reactRouter.useLocation)();
    let matches = (0, _reactRouter.useMatches)();
    let navigation = (0, _reactRouter.useNavigation)();
    // Trigger manual scroll restoration while we're active
    _react.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    usePageHide(_react.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey(_extends({}, location, {
                    pathname: (0, _router.stripBasename)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    let { capture } = options || {};
    _react.useEffect(()=>{
        let opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref12) {
    let { when, message } = _ref12;
    let blocker = (0, _reactRouter.useBlocker)(when);
    _react.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    _react.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function useViewTransitionState(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = _react.useContext(ViewTransitionContext);
    !(vtContext != null) && (0, _router.UNSAFE_invariant)(false);
    let { basename } = useDataRouterContext(DataRouterHook.useViewTransitionState);
    let path = (0, _reactRouter.useResolvedPath)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, _router.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, _router.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, _router.matchPath)(path.pathname, nextPath) != null || (0, _router.matchPath)(path.pathname, currentPath) != null;
}

},{"react":"bmhQu","react-dom":"82aNB","react-router":[["createPath","jit4b"],["createRoutesFromElements","9oT3O"],["Navigate","9oT3O"],["Outlet","9oT3O"],["Route","9oT3O"],["Router","9oT3O"],["UNSAFE_DataRouterContext","9oT3O"],["UNSAFE_DataRouterStateContext","9oT3O"],["UNSAFE_logV6DeprecationWarnings","9oT3O"],["UNSAFE_mapRouteProperties","9oT3O"],["UNSAFE_NavigationContext","9oT3O"],["UNSAFE_RouteContext","9oT3O"],["UNSAFE_useRouteId","9oT3O"],["UNSAFE_useRoutesImpl","9oT3O"],["useBlocker","9oT3O"],["useHref","9oT3O"],["useLocation","9oT3O"],["useMatches","9oT3O"],["useNavigate","9oT3O"],["useNavigation","9oT3O"],["useOutletContext","9oT3O"],["useParams","9oT3O"],["useResolvedPath","9oT3O"]],"@remix-run/router":"jit4b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jit4b":[function(require,module,exports,__globalThis) {
/**
 * @remix-run/router v1.23.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
//#endregion
parcelHelpers.export(exports, "AbortedDeferredError", ()=>AbortedDeferredError);
parcelHelpers.export(exports, "Action", ()=>Action);
parcelHelpers.export(exports, "IDLE_BLOCKER", ()=>IDLE_BLOCKER);
parcelHelpers.export(exports, "IDLE_FETCHER", ()=>IDLE_FETCHER);
parcelHelpers.export(exports, "IDLE_NAVIGATION", ()=>IDLE_NAVIGATION);
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", ()=>UNSAFE_DEFERRED_SYMBOL);
parcelHelpers.export(exports, "UNSAFE_DeferredData", ()=>DeferredData);
parcelHelpers.export(exports, "UNSAFE_ErrorResponseImpl", ()=>ErrorResponseImpl);
parcelHelpers.export(exports, "UNSAFE_convertRouteMatchToUiMatch", ()=>convertRouteMatchToUiMatch);
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", ()=>convertRoutesToDataRoutes);
parcelHelpers.export(exports, "UNSAFE_decodePath", ()=>decodePath);
parcelHelpers.export(exports, "UNSAFE_getResolveToMatches", ()=>getResolveToMatches);
parcelHelpers.export(exports, "UNSAFE_invariant", ()=>invariant);
parcelHelpers.export(exports, "UNSAFE_warning", ()=>warning);
parcelHelpers.export(exports, "createBrowserHistory", ()=>createBrowserHistory);
parcelHelpers.export(exports, "createHashHistory", ()=>createHashHistory);
parcelHelpers.export(exports, "createMemoryHistory", ()=>createMemoryHistory);
parcelHelpers.export(exports, "createPath", ()=>createPath);
parcelHelpers.export(exports, "createRouter", ()=>createRouter);
parcelHelpers.export(exports, "createStaticHandler", ()=>createStaticHandler);
parcelHelpers.export(exports, "data", ()=>data);
parcelHelpers.export(exports, "defer", ()=>defer);
parcelHelpers.export(exports, "generatePath", ()=>generatePath);
parcelHelpers.export(exports, "getStaticContextFromError", ()=>getStaticContextFromError);
parcelHelpers.export(exports, "getToPathname", ()=>getToPathname);
parcelHelpers.export(exports, "isDataWithResponseInit", ()=>isDataWithResponseInit);
parcelHelpers.export(exports, "isDeferredData", ()=>isDeferredData);
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>isRouteErrorResponse);
parcelHelpers.export(exports, "joinPaths", ()=>joinPaths);
parcelHelpers.export(exports, "json", ()=>json);
parcelHelpers.export(exports, "matchPath", ()=>matchPath);
parcelHelpers.export(exports, "matchRoutes", ()=>matchRoutes);
parcelHelpers.export(exports, "normalizePathname", ()=>normalizePathname);
parcelHelpers.export(exports, "parsePath", ()=>parsePath);
parcelHelpers.export(exports, "redirect", ()=>redirect);
parcelHelpers.export(exports, "redirectDocument", ()=>redirectDocument);
parcelHelpers.export(exports, "replace", ()=>replace);
parcelHelpers.export(exports, "resolvePath", ()=>resolvePath);
parcelHelpers.export(exports, "resolveTo", ()=>resolveTo);
parcelHelpers.export(exports, "stripBasename", ()=>stripBasename);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
const PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    let { initialEntries = [
        "/"
    ], initialIndex, v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = Action.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname, search, hash } = window1.location;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname = "/", search = "", hash = "" } = parsePath(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return createLocation("", {
            pathname,
            search,
            hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    let { pathname = "/", search = "", hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = Action.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        let location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : createPath(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
const immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            let indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    let pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = decodePath(pathname);
        matches = matchRouteBranch(branches[i], decoded, allowPartial);
    }
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    let { route, pathname, params } = match;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const paramRe = /^:[\w-]+$/;
const dynamicSegmentValue = 3;
const indexRouteValue = 2;
const emptySegmentValue = 1;
const staticSegmentValue = 10;
const splatPenalty = -2;
const isSplat = (s)=>s === "*";
function computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter((s)=>!isSplat(s)).reduce((score, segment)=>score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue), initialScore);
}
function compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            invariant(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName, isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        warning(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const isAbsoluteUrl = (url)=>ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search = "", hash = "" } = typeof to === "string" ? parsePath(to) : to;
    let pathname;
    if (toPathname) {
        if (isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = toPathname.replace(/\/\/+/g, "/");
                warning(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = resolvePathname(toPathname.substring(1), "/");
            else pathname = resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function getResolveToMatches(matches, v7_relativeSplatPath) {
    let pathMatches = getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = resolvePath(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ const joinPaths = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const normalizePathname = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const json = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
class DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class AbortedDeferredError extends Error {
}
class DeferredData {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new AbortedDeferredError("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const defer = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const redirectDocument = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const replace = (url, init)=>{
    let response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class ErrorResponseImpl {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const validMutationMethods = new Set(validMutationMethodsArr);
const validRequestMethodsArr = [
    "get",
    ...validMutationMethodsArr
];
const validRequestMethods = new Set(validRequestMethodsArr);
const redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = _extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches, route } = getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = Action.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location, delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, IDLE_BLOCKER);
                        updateState({
                            blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = _extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, IDLE_BLOCKER));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === Action.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers
        }), {
            viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = Action.Push;
        if (userReplace === true) historyAction = Action.Replace;
        else if (userReplace === false) ;
        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = Action.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation,
            nextLocation,
            historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, IDLE_BLOCKER);
                    updateState({
                        blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : matchRoutes(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches
            }, {
                flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            findNearestBoundary(matches).route.id,
            {
                type: ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if (isErrorResult(result) && isRouteErrorResponse(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited, matches: updatedMatches, loaderData, errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, _extends({
            matches: updatedMatches || matches
        }, getActionDataForCommit(pendingActionResult), {
            loaderData,
            errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = getSubmittingNavigation(location, submission);
        updateState({
            navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches, error, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: ResultType.error,
                            error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: ResultType.error,
            error: getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if (isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission,
                replace
            });
            return {
                shortCircuited: true
            };
        }
        if (isDeferredResult(result)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
            return {
                matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState(_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData
                } : {}), {
                    flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error, notFoundMatches, route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, _extends({
                matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = _extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return _extends({
            matches,
            loaderData,
            errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = matchRoutes(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync
            });
            return;
        }
        let { path, submission, error } = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync
            });
            return;
        }
        let match = getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getSubmittingFetcher(submission, existingFetcher), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if (isRedirectResult(actionResult) || isErrorResult(actionResult)) {
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            }
        } else {
            if (isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if (isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
        invariant(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults, fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset
        });
        redirect = findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData, errors } = processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            invariant(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches,
                loaderData,
                errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors,
                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if (isDeferredResult(result)) result = await resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if (isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if (isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission, fetcherSubmission, preventScrollReset, replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        invariant(location, "Expected a Location header on the redirect Response");
        location = normalizeRedirectLocation(location, new URL(request.url), basename);
        let redirectLocation = createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if (ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                stripBasename(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? Action.Replace : Action.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod, formAction, formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if (redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: _extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation,
                // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if (isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: ResultType.redirect,
                response: normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: ResultType.error,
                    error: getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults,
            fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || IDLE_FETCHER;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            invariant(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || IDLE_BLOCKER;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation, nextLocation, historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = getInternalRouterError(404, {
            pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches, route } = getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route,
            error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>convertRouteMatchToUiMatch(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = matchRoutes(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose,
        getBlocker,
        deleteBlocker,
        patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = defaultMapRouteProperties;
    // Config driven behavior flags
    let future = _extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext, skipLoaderErrorBubbling, dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD") {
            let error = getInternalRouterError(405, {
                method
            });
            let { matches: methodNotAllowedMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route } = getShortCircuitMatches(dataRoutes);
            return {
                basename,
                location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if (isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return _extends({
            location,
            basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId, requestContext, dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = createLocation("", createPath(url), null, "default");
        let matches = matchRoutes(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
            method
        });
        else if (!matches) throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : getTargetMatch(matches, location);
        if (routeId && !match) throw getInternalRouterError(403, {
            pathname: location.pathname,
            routeId
        });
        else if (!match) // This should never hit I don't think?
        throw getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if (isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if (isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return isResponse(result) ? result : _extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if (isDataStrategyResult(e) && isResponse(e.result)) {
                if (e.type === ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if (isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isDeferredResult(result)) {
            let error = getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: ResultType.error,
                error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if (isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if (isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return _extends({}, context, {
                statusCode: isRouteErrorResponse(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: _extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return _extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && isErrorResult(pendingActionResult[1]) ? getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return _extends({}, context, {
            matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await callDataStrategyImpl(dataStrategy || defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if (isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if (isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    let newContext = _extends({}, context, {
        statusCode: isRouteErrorResponse(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = resolveTo(to ? to : ".", getResolveToMatches(contextualMatches, v7_relativeSplatPath), stripBasename(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path,
            error: getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path,
                submission: {
                    formMethod,
                    formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path,
                    submission: {
                        formMethod,
                        formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    invariant(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod,
        formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData,
        json: undefined,
        text: undefined
    };
    if (isMutationMethod(submission.formMethod)) return {
        path,
        submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = parsePath(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = matchRoutes(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        invariant(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>isSameRoute(newRoute, existingRoute)));
    let newRoutes = convertRoutesToDataRoutes(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    invariant(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        warning(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function defaultDataStrategy(_ref4) {
    let { matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: ResultType.data,
                result: undefined
            });
        };
        return _extends({}, match, {
            shouldLoad,
            resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request,
        params: matches[0].params,
        fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw getInternalRouterError(405, {
                        method: request.method,
                        pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw getInternalRouterError(404, {
                pathname
            });
        } else result = await runHandler(handler);
        invariant(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result, type } = dataStrategyResult;
    if (isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: ResultType.error,
                error: e
            };
        }
        if (type === ResultType.error) return {
            type: ResultType.error,
            error: new ErrorResponseImpl(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: ResultType.data,
            data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === ResultType.error) {
        if (isDataWithResponseInit(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: ResultType.error,
                error: new ErrorResponseImpl(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: isRouteErrorResponse(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: ResultType.error,
            error: result,
            statusCode: isRouteErrorResponse(result) ? result.status : undefined
        };
    }
    if (isDeferredData(result)) {
        var _result$init5, _result$init6;
        return {
            type: ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if (isDataWithResponseInit(result)) {
        var _result$init7, _result$init8;
        return {
            type: ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function normalizeRedirectLocation(location, currentUrl, basename) {
    if (ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        let isSameBasename = stripBasename(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return url.pathname + url.search + url.hash;
    }
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL(stripHashFromPath(location)).toString();
    let init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        let { formMethod, formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if (isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData, errors } = processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key, match, controller } = rf;
        let result = fetcherResults[key];
        invariant(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if (isErrorResult(result)) {
            let boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = _extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp5) {
    let { pathname, routeId, method, type, message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new ErrorResponseImpl(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if (isRedirectResult(result)) return {
            key,
            result
        };
    }
}
function stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === ResultType.data || result.type === ResultType.error);
}
function isRedirectDataStrategyResultResult(result) {
    return isResponse(result.result) && redirectStatusCodes.has(result.result.status);
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDataWithResponseInit(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function isDeferredData(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
async function resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if (isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key, routeId, controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if (isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            invariant(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: ResultType.error,
            error: e
        };
    }
    return {
        type: ResultType.data,
        data: result.deferredData.data
    };
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function getTargetMatch(matches, location) {
    let search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function getSubmissionFromNavigation(navigation) {
    let { formMethod, formAction, formEncType, text, formData, json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json: undefined,
        text
    };
    else if (formData != null) return {
        formMethod,
        formAction,
        formEncType,
        formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod,
        formAction,
        formEncType,
        formData: undefined,
        json,
        text: undefined
    };
}
function getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data
        };
        return fetcher;
    }
}
function getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data
    };
    return fetcher;
}
function restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem(TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem(TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            warning(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"91HVb":[function(require,module,exports,__globalThis) {
exports.interopDefault = function(a) {
    return a && a.__esModule ? a : {
        default: a
    };
};
exports.defineInteropFlag = function(a) {
    Object.defineProperty(a, '__esModule', {
        value: true
    });
};
exports.exportAll = function(source, dest) {
    Object.keys(source).forEach(function(key) {
        if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) return;
        Object.defineProperty(dest, key, {
            enumerable: true,
            get: function() {
                return source[key];
            }
        });
    });
    return dest;
};
exports.export = function(dest, destName, get) {
    Object.defineProperty(dest, destName, {
        enumerable: true,
        get: get
    });
};

},{}],"9oT3O":[function(require,module,exports,__globalThis) {
/**
 * React Router v6.30.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", ()=>(0, _router.AbortedDeferredError));
parcelHelpers.export(exports, "NavigationType", ()=>(0, _router.Action));
parcelHelpers.export(exports, "createPath", ()=>(0, _router.createPath));
parcelHelpers.export(exports, "defer", ()=>(0, _router.defer));
parcelHelpers.export(exports, "generatePath", ()=>(0, _router.generatePath));
parcelHelpers.export(exports, "isRouteErrorResponse", ()=>(0, _router.isRouteErrorResponse));
parcelHelpers.export(exports, "json", ()=>(0, _router.json));
parcelHelpers.export(exports, "matchPath", ()=>(0, _router.matchPath));
parcelHelpers.export(exports, "matchRoutes", ()=>(0, _router.matchRoutes));
parcelHelpers.export(exports, "parsePath", ()=>(0, _router.parsePath));
parcelHelpers.export(exports, "redirect", ()=>(0, _router.redirect));
parcelHelpers.export(exports, "redirectDocument", ()=>(0, _router.redirectDocument));
parcelHelpers.export(exports, "replace", ()=>(0, _router.replace));
parcelHelpers.export(exports, "resolvePath", ()=>(0, _router.resolvePath));
parcelHelpers.export(exports, "Await", ()=>Await);
parcelHelpers.export(exports, "MemoryRouter", ()=>MemoryRouter);
parcelHelpers.export(exports, "Navigate", ()=>Navigate);
parcelHelpers.export(exports, "Outlet", ()=>Outlet);
parcelHelpers.export(exports, "Route", ()=>Route);
parcelHelpers.export(exports, "Router", ()=>Router);
parcelHelpers.export(exports, "RouterProvider", ()=>RouterProvider);
parcelHelpers.export(exports, "Routes", ()=>Routes);
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", ()=>DataRouterContext);
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", ()=>DataRouterStateContext);
parcelHelpers.export(exports, "UNSAFE_LocationContext", ()=>LocationContext);
parcelHelpers.export(exports, "UNSAFE_NavigationContext", ()=>NavigationContext);
parcelHelpers.export(exports, "UNSAFE_RouteContext", ()=>RouteContext);
parcelHelpers.export(exports, "UNSAFE_logV6DeprecationWarnings", ()=>logV6DeprecationWarnings);
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", ()=>mapRouteProperties);
parcelHelpers.export(exports, "UNSAFE_useRouteId", ()=>useRouteId);
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", ()=>useRoutesImpl);
parcelHelpers.export(exports, "createMemoryRouter", ()=>createMemoryRouter);
parcelHelpers.export(exports, "createRoutesFromChildren", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "createRoutesFromElements", ()=>createRoutesFromChildren);
parcelHelpers.export(exports, "renderMatches", ()=>renderMatches);
parcelHelpers.export(exports, "useActionData", ()=>useActionData);
parcelHelpers.export(exports, "useAsyncError", ()=>useAsyncError);
parcelHelpers.export(exports, "useAsyncValue", ()=>useAsyncValue);
parcelHelpers.export(exports, "useBlocker", ()=>useBlocker);
parcelHelpers.export(exports, "useHref", ()=>useHref);
parcelHelpers.export(exports, "useInRouterContext", ()=>useInRouterContext);
parcelHelpers.export(exports, "useLoaderData", ()=>useLoaderData);
parcelHelpers.export(exports, "useLocation", ()=>useLocation);
parcelHelpers.export(exports, "useMatch", ()=>useMatch);
parcelHelpers.export(exports, "useMatches", ()=>useMatches);
parcelHelpers.export(exports, "useNavigate", ()=>useNavigate);
parcelHelpers.export(exports, "useNavigation", ()=>useNavigation);
parcelHelpers.export(exports, "useNavigationType", ()=>useNavigationType);
parcelHelpers.export(exports, "useOutlet", ()=>useOutlet);
parcelHelpers.export(exports, "useOutletContext", ()=>useOutletContext);
parcelHelpers.export(exports, "useParams", ()=>useParams);
parcelHelpers.export(exports, "useResolvedPath", ()=>useResolvedPath);
parcelHelpers.export(exports, "useRevalidator", ()=>useRevalidator);
parcelHelpers.export(exports, "useRouteError", ()=>useRouteError);
parcelHelpers.export(exports, "useRouteLoaderData", ()=>useRouteLoaderData);
parcelHelpers.export(exports, "useRoutes", ()=>useRoutes);
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const DataRouterContext = /*#__PURE__*/ _react.createContext(null);
const DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
const AwaitContext = /*#__PURE__*/ _react.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const NavigationContext = /*#__PURE__*/ _react.createContext(null);
const LocationContext = /*#__PURE__*/ _react.createContext(null);
const RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function useHref(to, _temp) {
    let { relative } = _temp === void 0 ? {} : _temp;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { basename, navigator } = _react.useContext(NavigationContext);
    let { hash, pathname, search } = useResolvedPath(to, {
        relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { pathname } = useLocation();
    return _react.useMemo(()=>(0, _router.matchPath)(pattern, (0, _router.UNSAFE_decodePath)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    let isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function useNavigate() {
    let { isDataRoute } = _react.useContext(RouteContext);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let dataRouterContext = _react.useContext(DataRouterContext);
    let { basename, future, navigator } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function useOutlet(context) {
    let outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function useParams() {
    let { matches } = _react.useContext(RouteContext);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    let { relative } = _temp2 === void 0 ? {} : _temp2;
    let { future } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath));
    return _react.useMemo(()=>(0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState, future) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { navigator } = _react.useContext(NavigationContext);
    let { matches: parentMatches } = _react.useContext(RouteContext);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = useLocation();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = _renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    let error = useRouteError();
    let message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
class RenderErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function RenderedRoute(_ref) {
    let { routeContext, match, children } = _ref;
    let dataRouterContext = _react.useContext(DataRouterContext);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData, errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}(DataRouterHook || {});
var DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}(DataRouterStateHook || {});
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    let ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    let state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    let route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
}
// Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    let route = useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    let state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    let dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    let state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return _react.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    let { matches, loaderData } = useDataRouterState(DataRouterStateHook.UseMatches);
    return _react.useMemo(()=>matches.map((m)=>(0, _router.UNSAFE_convertRouteMatchToUiMatch)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    let state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    let state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    let state = useDataRouterState(DataRouterStateHook.UseActionData);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    let error = _react.useContext(RouteErrorContext);
    let state = useDataRouterState(DataRouterStateHook.UseRouteError);
    let routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function useAsyncValue() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function useAsyncError() {
    let value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
let blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    let { router, basename } = useDataRouterContext(DataRouterHook.UseBlocker);
    let state = useDataRouterState(DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = _react.useState("");
    let blockerFunction = _react.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation, nextLocation, historyAction } = arg;
        return shouldBlock({
            currentLocation: _extends({}, currentLocation, {
                pathname: (0, _router.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: _extends({}, nextLocation, {
                pathname: (0, _router.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    _react.useEffect(()=>{
        let key = String(++blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    _react.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, _router.IDLE_BLOCKER);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    let { router } = useDataRouterContext(DataRouterHook.UseNavigateStable);
    let id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    let activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const alreadyWarned$1 = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned$1[key]) alreadyWarned$1[key] = true;
}
const alreadyWarned = {};
function warnOnce(key, message) {}
const logDeprecation = (flag, msg, link)=>warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function logV6DeprecationWarnings(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const START_TRANSITION = "startTransition";
const startTransitionImpl = _react[START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    let { fallbackElement, router, future } = _ref;
    let [state, setStateImpl] = _react.useState(router.state);
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        if (v7_startTransition && startTransitionImpl) startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    _react.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    _react.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = _react.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = _react.useMemo(()=>({
            router,
            navigator,
            static: false,
            basename
        }), [
        router,
        navigator,
        basename
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    let { routes, future, state } = _ref2;
    return useRoutesImpl(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    let { basename, children, initialEntries, initialIndex, future } = _ref3;
    let historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = _react.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition } = future || {};
    let setState = _react.useCallback((newState)=>{
        v7_startTransition && startTransitionImpl ? startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    _react.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    _react.useEffect(()=>logV6DeprecationWarnings(future), [
        future
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function Navigate(_ref4) {
    let { to, replace, state, relative } = _ref4;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    let { future, static: isStatic } = _react.useContext(NavigationContext);
    let { matches } = _react.useContext(RouteContext);
    let { pathname: locationPathname } = useLocation();
    let navigate = useNavigate();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getResolveToMatches)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    _react.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function Router(_ref5) {
    let { basename: basenameProp = "/", children = null, location: locationProp, navigationType = (0, _router.Action).Pop, navigator, static: staticProp = false, future } = _ref5;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = _react.useMemo(()=>({
            basename,
            navigator,
            static: staticProp,
            future: _extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    let { pathname = "/", search = "", hash = "", state = null, key = "default" } = locationProp;
    let locationContext = _react.useMemo(()=>{
        let trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function Routes(_ref6) {
    let { children, location } = _ref6;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    let { children, errorElement, resolve } = _ref7;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}(AwaitRenderStatus || {});
const neverSettledPromise = new Promise(()=>{});
class AwaitErrorBoundary extends _react.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children, errorElement, resolve } = this.props;
        let promise = null;
        let status = AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? AwaitRenderStatus.error : "_data" in promise ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
        throw neverSettledPromise;
        if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function ResolveAwait(_ref8) {
    let { children } = _ref8;
    let data = useAsyncValue();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    _react.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ _react.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}

},{"react":"bmhQu","@remix-run/router":"jit4b","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eyrQZ":[function(require,module,exports,__globalThis) {
// src/index.tsx
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Helmet", ()=>Helmet);
parcelHelpers.export(exports, "HelmetData", ()=>HelmetData);
parcelHelpers.export(exports, "HelmetProvider", ()=>HelmetProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactFastCompare = require("react-fast-compare");
var _reactFastCompareDefault = parcelHelpers.interopDefault(_reactFastCompare);
var _invariant = require("invariant");
var _invariantDefault = parcelHelpers.interopDefault(_invariant);
var _shallowequal = require("shallowequal");
var _shallowequalDefault = parcelHelpers.interopDefault(_shallowequal);
// src/constants.ts
var TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})(TAG_NAMES || {});
var SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var VALID_TAG_NAMES = Object.values(TAG_NAMES);
var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var HTML_TAG_MAP = Object.entries(REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var getTitleFromPropsList = (propsList)=>{
    let innermostTitle = getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var getOnChangeClientState = (propsList)=>getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var reducePropsToState = (propsList)=>({
        baseTag: getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: getAnyTrueFromPropsList(propsList, HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if (checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = generateElementAttributesAsString(attributes);
    const flattenedTitle = flattenArray(title);
    return attributeString ? `<${type} ${HELMET_ATTRIBUTE}="true" ${attributeString}>${encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${HELMET_ATTRIBUTE}="true">${encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [HELMET_ATTRIBUTE]: true
    };
    const props = convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, _reactDefault.default).createElement("title" /* TITLE */ , props, title)
    ];
};
var generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, _reactDefault.default).createElement(type, mappedTag);
    });
var getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>convertElementAttributesToReactProps(tags),
                toString: ()=>generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>generateTagsAsReactComponent(type, tags),
                toString: ()=>generateTagsAsString(type, tags, encode)
            };
    }
};
var getPriorityMethods = ({ metaTags, linkTags, scriptTags, encode })=>{
    const meta = prioritizer(metaTags, SEO_PRIORITY_TAGS.meta);
    const link = prioritizer(linkTags, SEO_PRIORITY_TAGS.link);
    const script = prioritizer(scriptTags, SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var mapStateOnServer = (props)=>{
    const { baseTag, bodyAttributes, encode = true, htmlAttributes, noscriptTags, styleTags, title = "", titleAttributes, prioritizeSeoTags } = props;
    let { linkTags, metaTags, scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>[],
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods, linkTags, metaTags, scriptTags } = getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: getMethodsForTag("title" /* TITLE */ , {
            title,
            titleAttributes
        }, encode)
    };
};
var server_default = mapStateOnServer;
// src/HelmetData.ts
var instances = [];
var isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var HelmetData = class {
    instances = [];
    canUseDOM = isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? instances : this.instances).indexOf(instance);
                (this.canUseDOM ? instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
var major = parseInt((0, _reactDefault.default).version.split(".")[0], 10);
var isReact19 = major >= 19;
// src/Provider.tsx
var defaultValue = {};
var Context = (0, _reactDefault.default).createContext(defaultValue);
var HelmetProvider = class _HelmetProvider extends (0, _react.Component) {
    static canUseDOM = isDocument;
    helmetData;
    constructor(props){
        super(props);
        if (isReact19) this.helmetData = null;
        else this.helmetData = new HelmetData(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        if (isReact19) return /* @__PURE__ */ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, this.props.children);
        return /* @__PURE__ */ (0, _reactDefault.default).createElement(Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                const cssText = tag.cssText;
                newElement.appendChild(document.createTextNode(cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute(HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags,
        newTags
    };
};
var updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute(HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = flattenArray(title);
    updateAttributes("title" /* TITLE */ , attributes);
};
var commitTagChanges = (newState, cb)=>{
    const { baseTag, bodyAttributes, htmlAttributes, linkTags, metaTags, noscriptTags, onChangeClientState, scriptTags, styleTags, title, titleAttributes } = newState;
    updateAttributes("body" /* BODY */ , bodyAttributes);
    updateAttributes("html" /* HTML */ , htmlAttributes);
    updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: updateTags("base" /* BASE */ , baseTag),
        linkTags: updateTags("link" /* LINK */ , linkTags),
        metaTags: updateTags("meta" /* META */ , metaTags),
        noscriptTags: updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags, oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var _helmetCallback = null;
var handleStateChangeOnClient = (newState)=>{
    if (_helmetCallback) cancelAnimationFrame(_helmetCallback);
    if (newState.defer) _helmetCallback = requestAnimationFrame(()=>{
        commitTagChanges(newState, ()=>{
            _helmetCallback = null;
        });
    });
    else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};
var client_default = handleStateChangeOnClient;
// src/Dispatcher.tsx
var HelmetDispatcher = class extends (0, _react.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, _shallowequalDefault.default)(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances, setHelmet } = this.props.context;
        let serverState = null;
        const state = reducePropsToState(helmetInstances.get().map((instance)=>{
            const { context: _context, ...props } = instance.props;
            return props;
        }));
        if (HelmetProvider.canUseDOM) client_default(state);
        else if (server_default) serverState = server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
var react19Instances = [];
var toHtmlAttributes = (props)=>{
    const result = {};
    for (const key of Object.keys(props))result[HTML_TAG_MAP[key] || key] = props[key];
    return result;
};
var toReactProps = (attrs)=>{
    const result = {};
    for (const key of Object.keys(attrs)){
        const mapped = REACT_TAG_MAP[key];
        result[mapped || key] = attrs[key];
    }
    return result;
};
var applyAttributes = (tagName, attributes)=>{
    if (!isDocument) return;
    const el = document.getElementsByTagName(tagName)[0];
    if (!el) return;
    const managedAttr = "data-rh-managed";
    const prev = el.getAttribute(managedAttr);
    const prevKeys = prev ? prev.split(",") : [];
    const nextKeys = Object.keys(attributes);
    for (const key of prevKeys)if (!nextKeys.includes(key)) el.removeAttribute(key);
    for (const key of nextKeys){
        const value = attributes[key];
        if (value === void 0 || value === null || value === false) el.removeAttribute(key);
        else if (value === true) el.setAttribute(key, "");
        else el.setAttribute(key, String(value));
    }
    if (nextKeys.length > 0) el.setAttribute(managedAttr, nextKeys.join(","));
    else el.removeAttribute(managedAttr);
};
var syncAllAttributes = ()=>{
    const htmlAttrs = {};
    const bodyAttrs = {};
    for (const instance of react19Instances){
        const { htmlAttributes, bodyAttributes } = instance.props;
        if (htmlAttributes) Object.assign(htmlAttrs, toHtmlAttributes(htmlAttributes));
        if (bodyAttributes) Object.assign(bodyAttrs, toHtmlAttributes(bodyAttributes));
    }
    applyAttributes("html" /* HTML */ , htmlAttrs);
    applyAttributes("body" /* BODY */ , bodyAttrs);
};
var React19Dispatcher = class extends (0, _react.Component) {
    componentDidMount() {
        react19Instances.push(this);
        syncAllAttributes();
    }
    componentDidUpdate() {
        syncAllAttributes();
    }
    componentWillUnmount() {
        const index = react19Instances.indexOf(this);
        if (index !== -1) react19Instances.splice(index, 1);
        syncAllAttributes();
    }
    resolveTitle() {
        const { title, titleTemplate, defaultTitle } = this.props;
        if (title && titleTemplate) return titleTemplate.replace(/%s/g, ()=>Array.isArray(title) ? title.join("") : title);
        return title || defaultTitle || void 0;
    }
    renderTitle() {
        const title = this.resolveTitle();
        if (title === void 0) return null;
        const titleAttributes = this.props.titleAttributes || {};
        return (0, _reactDefault.default).createElement("title" /* TITLE */ , toReactProps(titleAttributes), title);
    }
    renderBase() {
        const { base } = this.props;
        if (!base) return null;
        return (0, _reactDefault.default).createElement("base" /* BASE */ , toReactProps(base));
    }
    renderMeta() {
        const { meta } = this.props;
        if (!meta || !Array.isArray(meta)) return null;
        return meta.map((attrs, i)=>(0, _reactDefault.default).createElement("meta" /* META */ , {
                key: i,
                ...toReactProps(attrs)
            }));
    }
    renderLink() {
        const { link } = this.props;
        if (!link || !Array.isArray(link)) return null;
        return link.map((attrs, i)=>(0, _reactDefault.default).createElement("link" /* LINK */ , {
                key: i,
                ...toReactProps(attrs)
            }));
    }
    renderScript() {
        const { script } = this.props;
        if (!script || !Array.isArray(script)) return null;
        return script.map((attrs, i)=>{
            const { innerHTML, ...rest } = attrs;
            const props = toReactProps(rest);
            if (innerHTML) props.dangerouslySetInnerHTML = {
                __html: innerHTML
            };
            return (0, _reactDefault.default).createElement("script" /* SCRIPT */ , {
                key: i,
                ...props
            });
        });
    }
    renderStyle() {
        const { style } = this.props;
        if (!style || !Array.isArray(style)) return null;
        return style.map((attrs, i)=>{
            const { cssText, ...rest } = attrs;
            const props = toReactProps(rest);
            if (cssText) props.dangerouslySetInnerHTML = {
                __html: cssText
            };
            return (0, _reactDefault.default).createElement("style" /* STYLE */ , {
                key: i,
                ...props
            });
        });
    }
    renderNoscript() {
        const { noscript } = this.props;
        if (!noscript || !Array.isArray(noscript)) return null;
        return noscript.map((attrs, i)=>{
            const { innerHTML, ...rest } = attrs;
            const props = toReactProps(rest);
            if (innerHTML) props.dangerouslySetInnerHTML = {
                __html: innerHTML
            };
            return (0, _reactDefault.default).createElement("noscript" /* NOSCRIPT */ , {
                key: i,
                ...props
            });
        });
    }
    render() {
        return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, this.renderTitle(), this.renderBase(), this.renderMeta(), this.renderLink(), this.renderScript(), this.renderStyle(), this.renderNoscript());
    }
};
// src/index.tsx
var Helmet = class extends (0, _react.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, _reactFastCompareDefault.default)(without(this.props, "helmetData"), without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, _invariantDefault.default)(VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, _invariantDefault.default)(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, _reactDefault.default).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof HelmetData)) {
            const data = helmetData;
            helmetData = new HelmetData(data.context, true);
            delete newProps.helmetData;
        }
        if (isReact19) return /* @__PURE__ */ (0, _reactDefault.default).createElement(React19Dispatcher, {
            ...newProps
        });
        return helmetData ? /* @__PURE__ */ (0, _reactDefault.default).createElement(HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, _reactDefault.default).createElement(Context.Consumer, null, (context)=>/* @__PURE__ */ (0, _reactDefault.default).createElement(HelmetDispatcher, {
                ...newProps,
                context
            }));
    }
};

},{"react":"bmhQu","react-fast-compare":"9TXZ1","invariant":"3cETI","shallowequal":"8MVyy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9TXZ1":[function(require,module,exports,__globalThis) {
/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */ var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;
// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js
function equal(a, b) {
    // START: fast-deep-equal es6/index.js 3.1.3
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        // START: Modifications:
        // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
        //    to co-exist with es5.
        // 2. Replace `for of` with es5 compliant iteration using `for`.
        //    Basically, take:
        //
        //    ```js
        //    for (i of a.entries())
        //      if (!b.has(i[0])) return false;
        //    ```
        //
        //    ... and convert to:
        //
        //    ```js
        //    it = a.entries();
        //    while (!(i = it.next()).done)
        //      if (!b.has(i.value[0])) return false;
        //    ```
        //
        //    **Note**: `i` access switches to `i.value`.
        var it;
        if (hasMap && a instanceof Map && b instanceof Map) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!equal(i.value[1], b.get(i.value[0]))) return false;
            return true;
        }
        if (hasSet && a instanceof Set && b instanceof Set) {
            if (a.size !== b.size) return false;
            it = a.entries();
            while(!(i = it.next()).done)if (!b.has(i.value[0])) return false;
            return true;
        }
        // END: Modifications
        if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (a[i] !== b[i]) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        // START: Modifications:
        // Apply guards for `Object.create(null)` handling. See:
        // - https://github.com/FormidableLabs/react-fast-compare/issues/64
        // - https://github.com/epoberezkin/fast-deep-equal/issues/49
        if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
        // END: Modifications
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        // END: fast-deep-equal
        // START: react-fast-compare
        // custom handling for DOM elements
        if (hasElementType && a instanceof Element) return false;
        // custom handling for React/Preact
        for(i = length; i-- !== 0;){
            if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) continue;
            // all other properties should be traversed as usual
            if (!equal(a[keys[i]], b[keys[i]])) return false;
        }
        // END: react-fast-compare
        // START: fast-deep-equal
        return true;
    }
    return a !== a && b !== b;
}
// end fast-deep-equal
module.exports = function isEqual(a, b) {
    try {
        return equal(a, b);
    } catch (error) {
        if ((error.message || '').match(/stack|recursion/i)) {
            // warn on circular references, don't crash
            // browsers give this different errors name and messages:
            // chrome/safari: "RangeError", "Maximum call stack size exceeded"
            // firefox: "InternalError", too much recursion"
            // edge: "Error", "Out of stack space"
            console.warn('react-fast-compare cannot handle circular refs');
            return false;
        }
        // some other error. we should definitely know about these
        throw error;
    }
};

},{}],"3cETI":[function(require,module,exports,__globalThis) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
module.exports = invariant;

},{}],"8MVyy":[function(require,module,exports,__globalThis) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

},{}],"97Oud":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClientContext", ()=>QueryClientContext);
parcelHelpers.export(exports, "QueryClientProvider", ()=>QueryClientProvider);
parcelHelpers.export(exports, "useQueryClient", ()=>useQueryClient);
// src/QueryClientProvider.tsx
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
var QueryClientContext = _react.createContext(void 0);
var useQueryClient = (queryClient)=>{
    const client = _react.useContext(QueryClientContext);
    if (queryClient) return queryClient;
    if (!client) throw new Error("No QueryClient set, use QueryClientProvider to set one");
    return client;
};
var QueryClientProvider = ({ client, children })=>{
    _react.useEffect(()=>{
        client.mount();
        return ()=>{
            client.unmount();
        };
    }, [
        client
    ]);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(QueryClientContext.Provider, {
        value: client,
        children
    });
};

},{"react":"bmhQu","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8AynF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Gltf", ()=>Gltf);
parcelHelpers.export(exports, "useGLTF", ()=>useGLTF);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _threeStdlib = require("three-stdlib");
var _fiber = require("@react-three/fiber");
var _cloneJs = require("./Clone.js");
let dracoLoader = null;
let decoderPath = 'https://www.gstatic.com/draco/versioned/decoders/1.5.5/';
function extensions(useDraco = true, useMeshopt = true, extendLoader) {
    return (loader)=>{
        if (extendLoader) extendLoader(loader);
        if (useDraco) {
            if (!dracoLoader) dracoLoader = new (0, _threeStdlib.DRACOLoader)();
            dracoLoader.setDecoderPath(typeof useDraco === 'string' ? useDraco : decoderPath);
            loader.setDRACOLoader(dracoLoader);
        }
        if (useMeshopt) loader.setMeshoptDecoder(typeof (0, _threeStdlib.MeshoptDecoder) === 'function' ? (0, _threeStdlib.MeshoptDecoder)() : (0, _threeStdlib.MeshoptDecoder));
    };
}
const useGLTF = (path, useDraco, useMeshopt, extendLoader)=>(0, _fiber.useLoader)((0, _threeStdlib.GLTFLoader), path, extensions(useDraco, useMeshopt, extendLoader));
useGLTF.preload = (path, useDraco, useMeshopt, extendLoader)=>(0, _fiber.useLoader).preload((0, _threeStdlib.GLTFLoader), path, extensions(useDraco, useMeshopt, extendLoader));
useGLTF.clear = (path)=>(0, _fiber.useLoader).clear((0, _threeStdlib.GLTFLoader), path);
useGLTF.setDecoderPath = (path)=>{
    decoderPath = path;
};
//
const Gltf = /* @__PURE__ */ _react.forwardRef(({ src, useDraco, useMeshOpt, extendLoader, ...props }, ref)=>{
    const { scene } = useGLTF(src, useDraco, useMeshOpt, extendLoader);
    return /*#__PURE__*/ _react.createElement((0, _cloneJs.Clone), (0, _extendsDefault.default)({
        ref: ref
    }, props, {
        object: scene
    }));
});

},{"@babel/runtime/helpers/esm/extends":"85Hd3","react":"bmhQu","three-stdlib":[["DRACOLoader","1zC0C"],["GLTFLoader","gflFk"],["MeshoptDecoder","liDWE"]],"@react-three/fiber":[["useLoader","4p4ya","G"]],"./Clone.js":"8xH4W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"85Hd3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_extends);
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1zC0C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DRACOLoader", ()=>DRACOLoader);
var _three = require("three");
const _taskCache = /* @__PURE__ */ new WeakMap();
class DRACOLoader extends (0, _three.Loader) {
    constructor(manager){
        super(manager);
        this.decoderPath = "";
        this.decoderConfig = {};
        this.decoderBinary = null;
        this.decoderPending = null;
        this.workerLimit = 4;
        this.workerPool = [];
        this.workerNextTaskID = 1;
        this.workerSourceURL = "";
        this.defaultAttributeIDs = {
            position: "POSITION",
            normal: "NORMAL",
            color: "COLOR",
            uv: "TEX_COORD"
        };
        this.defaultAttributeTypes = {
            position: "Float32Array",
            normal: "Float32Array",
            color: "Float32Array",
            uv: "Float32Array"
        };
    }
    setDecoderPath(path) {
        this.decoderPath = path;
        return this;
    }
    setDecoderConfig(config) {
        this.decoderConfig = config;
        return this;
    }
    setWorkerLimit(workerLimit) {
        this.workerLimit = workerLimit;
        return this;
    }
    load(url, onLoad, onProgress, onError) {
        const loader = new (0, _three.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, (buffer)=>{
            const taskConfig = {
                attributeIDs: this.defaultAttributeIDs,
                attributeTypes: this.defaultAttributeTypes,
                useUniqueIDs: false
            };
            this.decodeGeometry(buffer, taskConfig).then(onLoad).catch(onError);
        }, onProgress, onError);
    }
    /** @deprecated Kept for backward-compatibility with previous DRACOLoader versions. */ decodeDracoFile(buffer, callback, attributeIDs, attributeTypes) {
        const taskConfig = {
            attributeIDs: attributeIDs || this.defaultAttributeIDs,
            attributeTypes: attributeTypes || this.defaultAttributeTypes,
            useUniqueIDs: !!attributeIDs
        };
        this.decodeGeometry(buffer, taskConfig).then(callback);
    }
    decodeGeometry(buffer, taskConfig) {
        for(const attribute in taskConfig.attributeTypes){
            const type = taskConfig.attributeTypes[attribute];
            if (type.BYTES_PER_ELEMENT !== void 0) taskConfig.attributeTypes[attribute] = type.name;
        }
        const taskKey = JSON.stringify(taskConfig);
        if (_taskCache.has(buffer)) {
            const cachedTask = _taskCache.get(buffer);
            if (cachedTask.key === taskKey) return cachedTask.promise;
            else if (buffer.byteLength === 0) throw new Error("THREE.DRACOLoader: Unable to re-decode a buffer with different settings. Buffer has already been transferred.");
        }
        let worker;
        const taskID = this.workerNextTaskID++;
        const taskCost = buffer.byteLength;
        const geometryPending = this._getWorker(taskID, taskCost).then((_worker)=>{
            worker = _worker;
            return new Promise((resolve, reject)=>{
                worker._callbacks[taskID] = {
                    resolve,
                    reject
                };
                worker.postMessage({
                    type: "decode",
                    id: taskID,
                    taskConfig,
                    buffer
                }, [
                    buffer
                ]);
            });
        }).then((message)=>this._createGeometry(message.geometry));
        geometryPending.catch(()=>true).then(()=>{
            if (worker && taskID) this._releaseTask(worker, taskID);
        });
        _taskCache.set(buffer, {
            key: taskKey,
            promise: geometryPending
        });
        return geometryPending;
    }
    _createGeometry(geometryData) {
        const geometry = new (0, _three.BufferGeometry)();
        if (geometryData.index) geometry.setIndex(new (0, _three.BufferAttribute)(geometryData.index.array, 1));
        for(let i = 0; i < geometryData.attributes.length; i++){
            const attribute = geometryData.attributes[i];
            const name = attribute.name;
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            geometry.setAttribute(name, new (0, _three.BufferAttribute)(array, itemSize));
        }
        return geometry;
    }
    _loadLibrary(url, responseType) {
        const loader = new (0, _three.FileLoader)(this.manager);
        loader.setPath(this.decoderPath);
        loader.setResponseType(responseType);
        loader.setWithCredentials(this.withCredentials);
        return new Promise((resolve, reject)=>{
            loader.load(url, resolve, void 0, reject);
        });
    }
    preload() {
        this._initDecoder();
        return this;
    }
    _initDecoder() {
        if (this.decoderPending) return this.decoderPending;
        const useJS = typeof WebAssembly !== "object" || this.decoderConfig.type === "js";
        const librariesPending = [];
        if (useJS) librariesPending.push(this._loadLibrary("draco_decoder.js", "text"));
        else {
            librariesPending.push(this._loadLibrary("draco_wasm_wrapper.js", "text"));
            librariesPending.push(this._loadLibrary("draco_decoder.wasm", "arraybuffer"));
        }
        this.decoderPending = Promise.all(librariesPending).then((libraries)=>{
            const jsContent = libraries[0];
            if (!useJS) this.decoderConfig.wasmBinary = libraries[1];
            const fn = DRACOWorker.toString();
            const body = [
                "/* draco decoder */",
                jsContent,
                "",
                "/* worker */",
                fn.substring(fn.indexOf("{") + 1, fn.lastIndexOf("}"))
            ].join("\n");
            this.workerSourceURL = URL.createObjectURL(new Blob([
                body
            ]));
        });
        return this.decoderPending;
    }
    _getWorker(taskID, taskCost) {
        return this._initDecoder().then(()=>{
            if (this.workerPool.length < this.workerLimit) {
                const worker2 = new Worker(this.workerSourceURL);
                worker2._callbacks = {};
                worker2._taskCosts = {};
                worker2._taskLoad = 0;
                worker2.postMessage({
                    type: "init",
                    decoderConfig: this.decoderConfig
                });
                worker2.onmessage = function(e) {
                    const message = e.data;
                    switch(message.type){
                        case "decode":
                            worker2._callbacks[message.id].resolve(message);
                            break;
                        case "error":
                            worker2._callbacks[message.id].reject(message);
                            break;
                        default:
                            console.error('THREE.DRACOLoader: Unexpected message, "' + message.type + '"');
                    }
                };
                this.workerPool.push(worker2);
            } else this.workerPool.sort(function(a, b) {
                return a._taskLoad > b._taskLoad ? -1 : 1;
            });
            const worker = this.workerPool[this.workerPool.length - 1];
            worker._taskCosts[taskID] = taskCost;
            worker._taskLoad += taskCost;
            return worker;
        });
    }
    _releaseTask(worker, taskID) {
        worker._taskLoad -= worker._taskCosts[taskID];
        delete worker._callbacks[taskID];
        delete worker._taskCosts[taskID];
    }
    debug() {
        console.log("Task load: ", this.workerPool.map((worker)=>worker._taskLoad));
    }
    dispose() {
        for(let i = 0; i < this.workerPool.length; ++i)this.workerPool[i].terminate();
        this.workerPool.length = 0;
        return this;
    }
}
function DRACOWorker() {
    let decoderConfig;
    let decoderPending;
    onmessage = function(e) {
        const message = e.data;
        switch(message.type){
            case "init":
                decoderConfig = message.decoderConfig;
                decoderPending = new Promise(function(resolve) {
                    decoderConfig.onModuleLoaded = function(draco) {
                        resolve({
                            draco
                        });
                    };
                    DracoDecoderModule(decoderConfig);
                });
                break;
            case "decode":
                const buffer = message.buffer;
                const taskConfig = message.taskConfig;
                decoderPending.then((module)=>{
                    const draco = module.draco;
                    const decoder = new draco.Decoder();
                    const decoderBuffer = new draco.DecoderBuffer();
                    decoderBuffer.Init(new Int8Array(buffer), buffer.byteLength);
                    try {
                        const geometry = decodeGeometry(draco, decoder, decoderBuffer, taskConfig);
                        const buffers = geometry.attributes.map((attr)=>attr.array.buffer);
                        if (geometry.index) buffers.push(geometry.index.array.buffer);
                        self.postMessage({
                            type: "decode",
                            id: message.id,
                            geometry
                        }, buffers);
                    } catch (error) {
                        console.error(error);
                        self.postMessage({
                            type: "error",
                            id: message.id,
                            error: error.message
                        });
                    } finally{
                        draco.destroy(decoderBuffer);
                        draco.destroy(decoder);
                    }
                });
                break;
        }
    };
    function decodeGeometry(draco, decoder, decoderBuffer, taskConfig) {
        const attributeIDs = taskConfig.attributeIDs;
        const attributeTypes = taskConfig.attributeTypes;
        let dracoGeometry;
        let decodingStatus;
        const geometryType = decoder.GetEncodedGeometryType(decoderBuffer);
        if (geometryType === draco.TRIANGULAR_MESH) {
            dracoGeometry = new draco.Mesh();
            decodingStatus = decoder.DecodeBufferToMesh(decoderBuffer, dracoGeometry);
        } else if (geometryType === draco.POINT_CLOUD) {
            dracoGeometry = new draco.PointCloud();
            decodingStatus = decoder.DecodeBufferToPointCloud(decoderBuffer, dracoGeometry);
        } else throw new Error("THREE.DRACOLoader: Unexpected geometry type.");
        if (!decodingStatus.ok() || dracoGeometry.ptr === 0) throw new Error("THREE.DRACOLoader: Decoding failed: " + decodingStatus.error_msg());
        const geometry = {
            index: null,
            attributes: []
        };
        for(const attributeName in attributeIDs){
            const attributeType = self[attributeTypes[attributeName]];
            let attribute;
            let attributeID;
            if (taskConfig.useUniqueIDs) {
                attributeID = attributeIDs[attributeName];
                attribute = decoder.GetAttributeByUniqueId(dracoGeometry, attributeID);
            } else {
                attributeID = decoder.GetAttributeId(dracoGeometry, draco[attributeIDs[attributeName]]);
                if (attributeID === -1) continue;
                attribute = decoder.GetAttribute(dracoGeometry, attributeID);
            }
            geometry.attributes.push(decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute));
        }
        if (geometryType === draco.TRIANGULAR_MESH) geometry.index = decodeIndex(draco, decoder, dracoGeometry);
        draco.destroy(dracoGeometry);
        return geometry;
    }
    function decodeIndex(draco, decoder, dracoGeometry) {
        const numFaces = dracoGeometry.num_faces();
        const numIndices = numFaces * 3;
        const byteLength = numIndices * 4;
        const ptr = draco._malloc(byteLength);
        decoder.GetTrianglesUInt32Array(dracoGeometry, byteLength, ptr);
        const index = new Uint32Array(draco.HEAPF32.buffer, ptr, numIndices).slice();
        draco._free(ptr);
        return {
            array: index,
            itemSize: 1
        };
    }
    function decodeAttribute(draco, decoder, dracoGeometry, attributeName, attributeType, attribute) {
        const numComponents = attribute.num_components();
        const numPoints = dracoGeometry.num_points();
        const numValues = numPoints * numComponents;
        const byteLength = numValues * attributeType.BYTES_PER_ELEMENT;
        const dataType = getDracoDataType(draco, attributeType);
        const ptr = draco._malloc(byteLength);
        decoder.GetAttributeDataArrayForAllPoints(dracoGeometry, attribute, dataType, byteLength, ptr);
        const array = new attributeType(draco.HEAPF32.buffer, ptr, numValues).slice();
        draco._free(ptr);
        return {
            name: attributeName,
            array,
            itemSize: numComponents
        };
    }
    function getDracoDataType(draco, attributeType) {
        switch(attributeType){
            case Float32Array:
                return draco.DT_FLOAT32;
            case Int8Array:
                return draco.DT_INT8;
            case Int16Array:
                return draco.DT_INT16;
            case Int32Array:
                return draco.DT_INT32;
            case Uint8Array:
                return draco.DT_UINT8;
            case Uint16Array:
                return draco.DT_UINT16;
            case Uint32Array:
                return draco.DT_UINT32;
        }
    }
}

},{"three":[["BufferAttribute","hZcQL"],["BufferGeometry","hZcQL"],["FileLoader","bihzc"],["Loader","bihzc"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hZcQL":[function(require,module,exports,__globalThis) {
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AdditiveAnimationBlendMode", ()=>(0, _threeCoreJs.AdditiveAnimationBlendMode));
parcelHelpers.export(exports, "AlwaysStencilFunc", ()=>(0, _threeCoreJs.AlwaysStencilFunc));
parcelHelpers.export(exports, "AmbientLight", ()=>(0, _threeCoreJs.AmbientLight));
parcelHelpers.export(exports, "AnimationAction", ()=>(0, _threeCoreJs.AnimationAction));
parcelHelpers.export(exports, "AnimationClip", ()=>(0, _threeCoreJs.AnimationClip));
parcelHelpers.export(exports, "AnimationLoader", ()=>(0, _threeCoreJs.AnimationLoader));
parcelHelpers.export(exports, "AnimationMixer", ()=>(0, _threeCoreJs.AnimationMixer));
parcelHelpers.export(exports, "AnimationObjectGroup", ()=>(0, _threeCoreJs.AnimationObjectGroup));
parcelHelpers.export(exports, "AnimationUtils", ()=>(0, _threeCoreJs.AnimationUtils));
parcelHelpers.export(exports, "ArcCurve", ()=>(0, _threeCoreJs.ArcCurve));
parcelHelpers.export(exports, "ArrowHelper", ()=>(0, _threeCoreJs.ArrowHelper));
parcelHelpers.export(exports, "AttachedBindMode", ()=>(0, _threeCoreJs.AttachedBindMode));
parcelHelpers.export(exports, "Audio", ()=>(0, _threeCoreJs.Audio));
parcelHelpers.export(exports, "AudioAnalyser", ()=>(0, _threeCoreJs.AudioAnalyser));
parcelHelpers.export(exports, "AudioContext", ()=>(0, _threeCoreJs.AudioContext));
parcelHelpers.export(exports, "AudioListener", ()=>(0, _threeCoreJs.AudioListener));
parcelHelpers.export(exports, "AudioLoader", ()=>(0, _threeCoreJs.AudioLoader));
parcelHelpers.export(exports, "AxesHelper", ()=>(0, _threeCoreJs.AxesHelper));
parcelHelpers.export(exports, "BasicDepthPacking", ()=>(0, _threeCoreJs.BasicDepthPacking));
parcelHelpers.export(exports, "BasicShadowMap", ()=>(0, _threeCoreJs.BasicShadowMap));
parcelHelpers.export(exports, "BatchedMesh", ()=>(0, _threeCoreJs.BatchedMesh));
parcelHelpers.export(exports, "Bone", ()=>(0, _threeCoreJs.Bone));
parcelHelpers.export(exports, "BooleanKeyframeTrack", ()=>(0, _threeCoreJs.BooleanKeyframeTrack));
parcelHelpers.export(exports, "Box2", ()=>(0, _threeCoreJs.Box2));
parcelHelpers.export(exports, "Box3", ()=>(0, _threeCoreJs.Box3));
parcelHelpers.export(exports, "Box3Helper", ()=>(0, _threeCoreJs.Box3Helper));
parcelHelpers.export(exports, "BoxHelper", ()=>(0, _threeCoreJs.BoxHelper));
parcelHelpers.export(exports, "BufferGeometryLoader", ()=>(0, _threeCoreJs.BufferGeometryLoader));
parcelHelpers.export(exports, "Cache", ()=>(0, _threeCoreJs.Cache));
parcelHelpers.export(exports, "Camera", ()=>(0, _threeCoreJs.Camera));
parcelHelpers.export(exports, "CameraHelper", ()=>(0, _threeCoreJs.CameraHelper));
parcelHelpers.export(exports, "CanvasTexture", ()=>(0, _threeCoreJs.CanvasTexture));
parcelHelpers.export(exports, "CapsuleGeometry", ()=>(0, _threeCoreJs.CapsuleGeometry));
parcelHelpers.export(exports, "CatmullRomCurve3", ()=>(0, _threeCoreJs.CatmullRomCurve3));
parcelHelpers.export(exports, "CircleGeometry", ()=>(0, _threeCoreJs.CircleGeometry));
parcelHelpers.export(exports, "Clock", ()=>(0, _threeCoreJs.Clock));
parcelHelpers.export(exports, "ColorKeyframeTrack", ()=>(0, _threeCoreJs.ColorKeyframeTrack));
parcelHelpers.export(exports, "CompressedArrayTexture", ()=>(0, _threeCoreJs.CompressedArrayTexture));
parcelHelpers.export(exports, "CompressedCubeTexture", ()=>(0, _threeCoreJs.CompressedCubeTexture));
parcelHelpers.export(exports, "CompressedTexture", ()=>(0, _threeCoreJs.CompressedTexture));
parcelHelpers.export(exports, "CompressedTextureLoader", ()=>(0, _threeCoreJs.CompressedTextureLoader));
parcelHelpers.export(exports, "ConeGeometry", ()=>(0, _threeCoreJs.ConeGeometry));
parcelHelpers.export(exports, "Controls", ()=>(0, _threeCoreJs.Controls));
parcelHelpers.export(exports, "CubeCamera", ()=>(0, _threeCoreJs.CubeCamera));
parcelHelpers.export(exports, "CubeTextureLoader", ()=>(0, _threeCoreJs.CubeTextureLoader));
parcelHelpers.export(exports, "CubicBezierCurve", ()=>(0, _threeCoreJs.CubicBezierCurve));
parcelHelpers.export(exports, "CubicBezierCurve3", ()=>(0, _threeCoreJs.CubicBezierCurve3));
parcelHelpers.export(exports, "CubicInterpolant", ()=>(0, _threeCoreJs.CubicInterpolant));
parcelHelpers.export(exports, "CullFaceFrontBack", ()=>(0, _threeCoreJs.CullFaceFrontBack));
parcelHelpers.export(exports, "Curve", ()=>(0, _threeCoreJs.Curve));
parcelHelpers.export(exports, "CurvePath", ()=>(0, _threeCoreJs.CurvePath));
parcelHelpers.export(exports, "CylinderGeometry", ()=>(0, _threeCoreJs.CylinderGeometry));
parcelHelpers.export(exports, "Cylindrical", ()=>(0, _threeCoreJs.Cylindrical));
parcelHelpers.export(exports, "DataTextureLoader", ()=>(0, _threeCoreJs.DataTextureLoader));
parcelHelpers.export(exports, "DataUtils", ()=>(0, _threeCoreJs.DataUtils));
parcelHelpers.export(exports, "DecrementStencilOp", ()=>(0, _threeCoreJs.DecrementStencilOp));
parcelHelpers.export(exports, "DecrementWrapStencilOp", ()=>(0, _threeCoreJs.DecrementWrapStencilOp));
parcelHelpers.export(exports, "DefaultLoadingManager", ()=>(0, _threeCoreJs.DefaultLoadingManager));
parcelHelpers.export(exports, "DetachedBindMode", ()=>(0, _threeCoreJs.DetachedBindMode));
parcelHelpers.export(exports, "DirectionalLight", ()=>(0, _threeCoreJs.DirectionalLight));
parcelHelpers.export(exports, "DirectionalLightHelper", ()=>(0, _threeCoreJs.DirectionalLightHelper));
parcelHelpers.export(exports, "DiscreteInterpolant", ()=>(0, _threeCoreJs.DiscreteInterpolant));
parcelHelpers.export(exports, "DodecahedronGeometry", ()=>(0, _threeCoreJs.DodecahedronGeometry));
parcelHelpers.export(exports, "DynamicCopyUsage", ()=>(0, _threeCoreJs.DynamicCopyUsage));
parcelHelpers.export(exports, "DynamicDrawUsage", ()=>(0, _threeCoreJs.DynamicDrawUsage));
parcelHelpers.export(exports, "DynamicReadUsage", ()=>(0, _threeCoreJs.DynamicReadUsage));
parcelHelpers.export(exports, "EdgesGeometry", ()=>(0, _threeCoreJs.EdgesGeometry));
parcelHelpers.export(exports, "EllipseCurve", ()=>(0, _threeCoreJs.EllipseCurve));
parcelHelpers.export(exports, "EqualStencilFunc", ()=>(0, _threeCoreJs.EqualStencilFunc));
parcelHelpers.export(exports, "ExtrudeGeometry", ()=>(0, _threeCoreJs.ExtrudeGeometry));
parcelHelpers.export(exports, "FileLoader", ()=>(0, _threeCoreJs.FileLoader));
parcelHelpers.export(exports, "Float16BufferAttribute", ()=>(0, _threeCoreJs.Float16BufferAttribute));
parcelHelpers.export(exports, "Fog", ()=>(0, _threeCoreJs.Fog));
parcelHelpers.export(exports, "FogExp2", ()=>(0, _threeCoreJs.FogExp2));
parcelHelpers.export(exports, "FramebufferTexture", ()=>(0, _threeCoreJs.FramebufferTexture));
parcelHelpers.export(exports, "FrustumArray", ()=>(0, _threeCoreJs.FrustumArray));
parcelHelpers.export(exports, "GLBufferAttribute", ()=>(0, _threeCoreJs.GLBufferAttribute));
parcelHelpers.export(exports, "GLSL1", ()=>(0, _threeCoreJs.GLSL1));
parcelHelpers.export(exports, "GreaterEqualStencilFunc", ()=>(0, _threeCoreJs.GreaterEqualStencilFunc));
parcelHelpers.export(exports, "GreaterStencilFunc", ()=>(0, _threeCoreJs.GreaterStencilFunc));
parcelHelpers.export(exports, "GridHelper", ()=>(0, _threeCoreJs.GridHelper));
parcelHelpers.export(exports, "Group", ()=>(0, _threeCoreJs.Group));
parcelHelpers.export(exports, "HemisphereLight", ()=>(0, _threeCoreJs.HemisphereLight));
parcelHelpers.export(exports, "HemisphereLightHelper", ()=>(0, _threeCoreJs.HemisphereLightHelper));
parcelHelpers.export(exports, "IcosahedronGeometry", ()=>(0, _threeCoreJs.IcosahedronGeometry));
parcelHelpers.export(exports, "ImageBitmapLoader", ()=>(0, _threeCoreJs.ImageBitmapLoader));
parcelHelpers.export(exports, "ImageLoader", ()=>(0, _threeCoreJs.ImageLoader));
parcelHelpers.export(exports, "ImageUtils", ()=>(0, _threeCoreJs.ImageUtils));
parcelHelpers.export(exports, "IncrementStencilOp", ()=>(0, _threeCoreJs.IncrementStencilOp));
parcelHelpers.export(exports, "IncrementWrapStencilOp", ()=>(0, _threeCoreJs.IncrementWrapStencilOp));
parcelHelpers.export(exports, "InstancedBufferAttribute", ()=>(0, _threeCoreJs.InstancedBufferAttribute));
parcelHelpers.export(exports, "InstancedBufferGeometry", ()=>(0, _threeCoreJs.InstancedBufferGeometry));
parcelHelpers.export(exports, "InstancedInterleavedBuffer", ()=>(0, _threeCoreJs.InstancedInterleavedBuffer));
parcelHelpers.export(exports, "InstancedMesh", ()=>(0, _threeCoreJs.InstancedMesh));
parcelHelpers.export(exports, "Int16BufferAttribute", ()=>(0, _threeCoreJs.Int16BufferAttribute));
parcelHelpers.export(exports, "Int32BufferAttribute", ()=>(0, _threeCoreJs.Int32BufferAttribute));
parcelHelpers.export(exports, "Int8BufferAttribute", ()=>(0, _threeCoreJs.Int8BufferAttribute));
parcelHelpers.export(exports, "InterleavedBuffer", ()=>(0, _threeCoreJs.InterleavedBuffer));
parcelHelpers.export(exports, "InterleavedBufferAttribute", ()=>(0, _threeCoreJs.InterleavedBufferAttribute));
parcelHelpers.export(exports, "Interpolant", ()=>(0, _threeCoreJs.Interpolant));
parcelHelpers.export(exports, "InterpolateDiscrete", ()=>(0, _threeCoreJs.InterpolateDiscrete));
parcelHelpers.export(exports, "InterpolateLinear", ()=>(0, _threeCoreJs.InterpolateLinear));
parcelHelpers.export(exports, "InterpolateSmooth", ()=>(0, _threeCoreJs.InterpolateSmooth));
parcelHelpers.export(exports, "InterpolationSamplingMode", ()=>(0, _threeCoreJs.InterpolationSamplingMode));
parcelHelpers.export(exports, "InterpolationSamplingType", ()=>(0, _threeCoreJs.InterpolationSamplingType));
parcelHelpers.export(exports, "InvertStencilOp", ()=>(0, _threeCoreJs.InvertStencilOp));
parcelHelpers.export(exports, "KeepStencilOp", ()=>(0, _threeCoreJs.KeepStencilOp));
parcelHelpers.export(exports, "KeyframeTrack", ()=>(0, _threeCoreJs.KeyframeTrack));
parcelHelpers.export(exports, "LOD", ()=>(0, _threeCoreJs.LOD));
parcelHelpers.export(exports, "LatheGeometry", ()=>(0, _threeCoreJs.LatheGeometry));
parcelHelpers.export(exports, "LessEqualStencilFunc", ()=>(0, _threeCoreJs.LessEqualStencilFunc));
parcelHelpers.export(exports, "LessStencilFunc", ()=>(0, _threeCoreJs.LessStencilFunc));
parcelHelpers.export(exports, "Light", ()=>(0, _threeCoreJs.Light));
parcelHelpers.export(exports, "LightProbe", ()=>(0, _threeCoreJs.LightProbe));
parcelHelpers.export(exports, "Line", ()=>(0, _threeCoreJs.Line));
parcelHelpers.export(exports, "Line3", ()=>(0, _threeCoreJs.Line3));
parcelHelpers.export(exports, "LineBasicMaterial", ()=>(0, _threeCoreJs.LineBasicMaterial));
parcelHelpers.export(exports, "LineCurve", ()=>(0, _threeCoreJs.LineCurve));
parcelHelpers.export(exports, "LineCurve3", ()=>(0, _threeCoreJs.LineCurve3));
parcelHelpers.export(exports, "LineDashedMaterial", ()=>(0, _threeCoreJs.LineDashedMaterial));
parcelHelpers.export(exports, "LineLoop", ()=>(0, _threeCoreJs.LineLoop));
parcelHelpers.export(exports, "LineSegments", ()=>(0, _threeCoreJs.LineSegments));
parcelHelpers.export(exports, "LinearInterpolant", ()=>(0, _threeCoreJs.LinearInterpolant));
parcelHelpers.export(exports, "LinearMipMapLinearFilter", ()=>(0, _threeCoreJs.LinearMipMapLinearFilter));
parcelHelpers.export(exports, "LinearMipMapNearestFilter", ()=>(0, _threeCoreJs.LinearMipMapNearestFilter));
parcelHelpers.export(exports, "Loader", ()=>(0, _threeCoreJs.Loader));
parcelHelpers.export(exports, "LoaderUtils", ()=>(0, _threeCoreJs.LoaderUtils));
parcelHelpers.export(exports, "LoadingManager", ()=>(0, _threeCoreJs.LoadingManager));
parcelHelpers.export(exports, "LoopOnce", ()=>(0, _threeCoreJs.LoopOnce));
parcelHelpers.export(exports, "LoopPingPong", ()=>(0, _threeCoreJs.LoopPingPong));
parcelHelpers.export(exports, "LoopRepeat", ()=>(0, _threeCoreJs.LoopRepeat));
parcelHelpers.export(exports, "MOUSE", ()=>(0, _threeCoreJs.MOUSE));
parcelHelpers.export(exports, "Material", ()=>(0, _threeCoreJs.Material));
parcelHelpers.export(exports, "MaterialLoader", ()=>(0, _threeCoreJs.MaterialLoader));
parcelHelpers.export(exports, "MathUtils", ()=>(0, _threeCoreJs.MathUtils));
parcelHelpers.export(exports, "Matrix2", ()=>(0, _threeCoreJs.Matrix2));
parcelHelpers.export(exports, "MeshLambertMaterial", ()=>(0, _threeCoreJs.MeshLambertMaterial));
parcelHelpers.export(exports, "MeshMatcapMaterial", ()=>(0, _threeCoreJs.MeshMatcapMaterial));
parcelHelpers.export(exports, "MeshNormalMaterial", ()=>(0, _threeCoreJs.MeshNormalMaterial));
parcelHelpers.export(exports, "MeshPhongMaterial", ()=>(0, _threeCoreJs.MeshPhongMaterial));
parcelHelpers.export(exports, "MeshPhysicalMaterial", ()=>(0, _threeCoreJs.MeshPhysicalMaterial));
parcelHelpers.export(exports, "MeshStandardMaterial", ()=>(0, _threeCoreJs.MeshStandardMaterial));
parcelHelpers.export(exports, "MeshToonMaterial", ()=>(0, _threeCoreJs.MeshToonMaterial));
parcelHelpers.export(exports, "NearestMipMapLinearFilter", ()=>(0, _threeCoreJs.NearestMipMapLinearFilter));
parcelHelpers.export(exports, "NearestMipMapNearestFilter", ()=>(0, _threeCoreJs.NearestMipMapNearestFilter));
parcelHelpers.export(exports, "NeverStencilFunc", ()=>(0, _threeCoreJs.NeverStencilFunc));
parcelHelpers.export(exports, "NoNormalPacking", ()=>(0, _threeCoreJs.NoNormalPacking));
parcelHelpers.export(exports, "NormalAnimationBlendMode", ()=>(0, _threeCoreJs.NormalAnimationBlendMode));
parcelHelpers.export(exports, "NormalGAPacking", ()=>(0, _threeCoreJs.NormalGAPacking));
parcelHelpers.export(exports, "NormalRGPacking", ()=>(0, _threeCoreJs.NormalRGPacking));
parcelHelpers.export(exports, "NotEqualStencilFunc", ()=>(0, _threeCoreJs.NotEqualStencilFunc));
parcelHelpers.export(exports, "NumberKeyframeTrack", ()=>(0, _threeCoreJs.NumberKeyframeTrack));
parcelHelpers.export(exports, "Object3D", ()=>(0, _threeCoreJs.Object3D));
parcelHelpers.export(exports, "ObjectLoader", ()=>(0, _threeCoreJs.ObjectLoader));
parcelHelpers.export(exports, "OctahedronGeometry", ()=>(0, _threeCoreJs.OctahedronGeometry));
parcelHelpers.export(exports, "Path", ()=>(0, _threeCoreJs.Path));
parcelHelpers.export(exports, "PlaneHelper", ()=>(0, _threeCoreJs.PlaneHelper));
parcelHelpers.export(exports, "PointLight", ()=>(0, _threeCoreJs.PointLight));
parcelHelpers.export(exports, "PointLightHelper", ()=>(0, _threeCoreJs.PointLightHelper));
parcelHelpers.export(exports, "Points", ()=>(0, _threeCoreJs.Points));
parcelHelpers.export(exports, "PointsMaterial", ()=>(0, _threeCoreJs.PointsMaterial));
parcelHelpers.export(exports, "PolarGridHelper", ()=>(0, _threeCoreJs.PolarGridHelper));
parcelHelpers.export(exports, "PolyhedronGeometry", ()=>(0, _threeCoreJs.PolyhedronGeometry));
parcelHelpers.export(exports, "PositionalAudio", ()=>(0, _threeCoreJs.PositionalAudio));
parcelHelpers.export(exports, "PropertyBinding", ()=>(0, _threeCoreJs.PropertyBinding));
parcelHelpers.export(exports, "PropertyMixer", ()=>(0, _threeCoreJs.PropertyMixer));
parcelHelpers.export(exports, "QuadraticBezierCurve", ()=>(0, _threeCoreJs.QuadraticBezierCurve));
parcelHelpers.export(exports, "QuadraticBezierCurve3", ()=>(0, _threeCoreJs.QuadraticBezierCurve3));
parcelHelpers.export(exports, "Quaternion", ()=>(0, _threeCoreJs.Quaternion));
parcelHelpers.export(exports, "QuaternionKeyframeTrack", ()=>(0, _threeCoreJs.QuaternionKeyframeTrack));
parcelHelpers.export(exports, "QuaternionLinearInterpolant", ()=>(0, _threeCoreJs.QuaternionLinearInterpolant));
parcelHelpers.export(exports, "RGBADepthPacking", ()=>(0, _threeCoreJs.RGBADepthPacking));
parcelHelpers.export(exports, "RGBDepthPacking", ()=>(0, _threeCoreJs.RGBDepthPacking));
parcelHelpers.export(exports, "RGBIntegerFormat", ()=>(0, _threeCoreJs.RGBIntegerFormat));
parcelHelpers.export(exports, "RGDepthPacking", ()=>(0, _threeCoreJs.RGDepthPacking));
parcelHelpers.export(exports, "Ray", ()=>(0, _threeCoreJs.Ray));
parcelHelpers.export(exports, "Raycaster", ()=>(0, _threeCoreJs.Raycaster));
parcelHelpers.export(exports, "RectAreaLight", ()=>(0, _threeCoreJs.RectAreaLight));
parcelHelpers.export(exports, "RenderTarget", ()=>(0, _threeCoreJs.RenderTarget));
parcelHelpers.export(exports, "RenderTarget3D", ()=>(0, _threeCoreJs.RenderTarget3D));
parcelHelpers.export(exports, "ReplaceStencilOp", ()=>(0, _threeCoreJs.ReplaceStencilOp));
parcelHelpers.export(exports, "RingGeometry", ()=>(0, _threeCoreJs.RingGeometry));
parcelHelpers.export(exports, "Scene", ()=>(0, _threeCoreJs.Scene));
parcelHelpers.export(exports, "ShadowMaterial", ()=>(0, _threeCoreJs.ShadowMaterial));
parcelHelpers.export(exports, "Shape", ()=>(0, _threeCoreJs.Shape));
parcelHelpers.export(exports, "ShapeGeometry", ()=>(0, _threeCoreJs.ShapeGeometry));
parcelHelpers.export(exports, "ShapePath", ()=>(0, _threeCoreJs.ShapePath));
parcelHelpers.export(exports, "ShapeUtils", ()=>(0, _threeCoreJs.ShapeUtils));
parcelHelpers.export(exports, "Skeleton", ()=>(0, _threeCoreJs.Skeleton));
parcelHelpers.export(exports, "SkeletonHelper", ()=>(0, _threeCoreJs.SkeletonHelper));
parcelHelpers.export(exports, "SkinnedMesh", ()=>(0, _threeCoreJs.SkinnedMesh));
parcelHelpers.export(exports, "Source", ()=>(0, _threeCoreJs.Source));
parcelHelpers.export(exports, "Sphere", ()=>(0, _threeCoreJs.Sphere));
parcelHelpers.export(exports, "SphereGeometry", ()=>(0, _threeCoreJs.SphereGeometry));
parcelHelpers.export(exports, "Spherical", ()=>(0, _threeCoreJs.Spherical));
parcelHelpers.export(exports, "SphericalHarmonics3", ()=>(0, _threeCoreJs.SphericalHarmonics3));
parcelHelpers.export(exports, "SplineCurve", ()=>(0, _threeCoreJs.SplineCurve));
parcelHelpers.export(exports, "SpotLight", ()=>(0, _threeCoreJs.SpotLight));
parcelHelpers.export(exports, "SpotLightHelper", ()=>(0, _threeCoreJs.SpotLightHelper));
parcelHelpers.export(exports, "Sprite", ()=>(0, _threeCoreJs.Sprite));
parcelHelpers.export(exports, "SpriteMaterial", ()=>(0, _threeCoreJs.SpriteMaterial));
parcelHelpers.export(exports, "StaticCopyUsage", ()=>(0, _threeCoreJs.StaticCopyUsage));
parcelHelpers.export(exports, "StaticDrawUsage", ()=>(0, _threeCoreJs.StaticDrawUsage));
parcelHelpers.export(exports, "StaticReadUsage", ()=>(0, _threeCoreJs.StaticReadUsage));
parcelHelpers.export(exports, "StereoCamera", ()=>(0, _threeCoreJs.StereoCamera));
parcelHelpers.export(exports, "StreamCopyUsage", ()=>(0, _threeCoreJs.StreamCopyUsage));
parcelHelpers.export(exports, "StreamDrawUsage", ()=>(0, _threeCoreJs.StreamDrawUsage));
parcelHelpers.export(exports, "StreamReadUsage", ()=>(0, _threeCoreJs.StreamReadUsage));
parcelHelpers.export(exports, "StringKeyframeTrack", ()=>(0, _threeCoreJs.StringKeyframeTrack));
parcelHelpers.export(exports, "TOUCH", ()=>(0, _threeCoreJs.TOUCH));
parcelHelpers.export(exports, "TetrahedronGeometry", ()=>(0, _threeCoreJs.TetrahedronGeometry));
parcelHelpers.export(exports, "TextureLoader", ()=>(0, _threeCoreJs.TextureLoader));
parcelHelpers.export(exports, "TextureUtils", ()=>(0, _threeCoreJs.TextureUtils));
parcelHelpers.export(exports, "Timer", ()=>(0, _threeCoreJs.Timer));
parcelHelpers.export(exports, "TimestampQuery", ()=>(0, _threeCoreJs.TimestampQuery));
parcelHelpers.export(exports, "TorusGeometry", ()=>(0, _threeCoreJs.TorusGeometry));
parcelHelpers.export(exports, "TorusKnotGeometry", ()=>(0, _threeCoreJs.TorusKnotGeometry));
parcelHelpers.export(exports, "Triangle", ()=>(0, _threeCoreJs.Triangle));
parcelHelpers.export(exports, "TriangleFanDrawMode", ()=>(0, _threeCoreJs.TriangleFanDrawMode));
parcelHelpers.export(exports, "TriangleStripDrawMode", ()=>(0, _threeCoreJs.TriangleStripDrawMode));
parcelHelpers.export(exports, "TrianglesDrawMode", ()=>(0, _threeCoreJs.TrianglesDrawMode));
parcelHelpers.export(exports, "TubeGeometry", ()=>(0, _threeCoreJs.TubeGeometry));
parcelHelpers.export(exports, "UVMapping", ()=>(0, _threeCoreJs.UVMapping));
parcelHelpers.export(exports, "Uint8BufferAttribute", ()=>(0, _threeCoreJs.Uint8BufferAttribute));
parcelHelpers.export(exports, "Uint8ClampedBufferAttribute", ()=>(0, _threeCoreJs.Uint8ClampedBufferAttribute));
parcelHelpers.export(exports, "Uniform", ()=>(0, _threeCoreJs.Uniform));
parcelHelpers.export(exports, "UniformsGroup", ()=>(0, _threeCoreJs.UniformsGroup));
parcelHelpers.export(exports, "VectorKeyframeTrack", ()=>(0, _threeCoreJs.VectorKeyframeTrack));
parcelHelpers.export(exports, "VideoFrameTexture", ()=>(0, _threeCoreJs.VideoFrameTexture));
parcelHelpers.export(exports, "VideoTexture", ()=>(0, _threeCoreJs.VideoTexture));
parcelHelpers.export(exports, "WebGL3DRenderTarget", ()=>(0, _threeCoreJs.WebGL3DRenderTarget));
parcelHelpers.export(exports, "WebGLArrayRenderTarget", ()=>(0, _threeCoreJs.WebGLArrayRenderTarget));
parcelHelpers.export(exports, "WebGPUCoordinateSystem", ()=>(0, _threeCoreJs.WebGPUCoordinateSystem));
parcelHelpers.export(exports, "WireframeGeometry", ()=>(0, _threeCoreJs.WireframeGeometry));
parcelHelpers.export(exports, "WrapAroundEnding", ()=>(0, _threeCoreJs.WrapAroundEnding));
parcelHelpers.export(exports, "ZeroCurvatureEnding", ()=>(0, _threeCoreJs.ZeroCurvatureEnding));
parcelHelpers.export(exports, "ZeroSlopeEnding", ()=>(0, _threeCoreJs.ZeroSlopeEnding));
parcelHelpers.export(exports, "ZeroStencilOp", ()=>(0, _threeCoreJs.ZeroStencilOp));
parcelHelpers.export(exports, "getConsoleFunction", ()=>(0, _threeCoreJs.getConsoleFunction));
parcelHelpers.export(exports, "setConsoleFunction", ()=>(0, _threeCoreJs.setConsoleFunction));
parcelHelpers.export(exports, "ACESFilmicToneMapping", ()=>(0, _threeCoreJs.ACESFilmicToneMapping));
parcelHelpers.export(exports, "AddEquation", ()=>(0, _threeCoreJs.AddEquation));
parcelHelpers.export(exports, "AddOperation", ()=>(0, _threeCoreJs.AddOperation));
parcelHelpers.export(exports, "AdditiveBlending", ()=>(0, _threeCoreJs.AdditiveBlending));
parcelHelpers.export(exports, "AgXToneMapping", ()=>(0, _threeCoreJs.AgXToneMapping));
parcelHelpers.export(exports, "AlphaFormat", ()=>(0, _threeCoreJs.AlphaFormat));
parcelHelpers.export(exports, "AlwaysCompare", ()=>(0, _threeCoreJs.AlwaysCompare));
parcelHelpers.export(exports, "AlwaysDepth", ()=>(0, _threeCoreJs.AlwaysDepth));
parcelHelpers.export(exports, "ArrayCamera", ()=>(0, _threeCoreJs.ArrayCamera));
parcelHelpers.export(exports, "BackSide", ()=>(0, _threeCoreJs.BackSide));
parcelHelpers.export(exports, "BoxGeometry", ()=>(0, _threeCoreJs.BoxGeometry));
parcelHelpers.export(exports, "BufferAttribute", ()=>(0, _threeCoreJs.BufferAttribute));
parcelHelpers.export(exports, "BufferGeometry", ()=>(0, _threeCoreJs.BufferGeometry));
parcelHelpers.export(exports, "ByteType", ()=>(0, _threeCoreJs.ByteType));
parcelHelpers.export(exports, "CineonToneMapping", ()=>(0, _threeCoreJs.CineonToneMapping));
parcelHelpers.export(exports, "ClampToEdgeWrapping", ()=>(0, _threeCoreJs.ClampToEdgeWrapping));
parcelHelpers.export(exports, "Color", ()=>(0, _threeCoreJs.Color));
parcelHelpers.export(exports, "ColorManagement", ()=>(0, _threeCoreJs.ColorManagement));
parcelHelpers.export(exports, "ConstantAlphaFactor", ()=>(0, _threeCoreJs.ConstantAlphaFactor));
parcelHelpers.export(exports, "ConstantColorFactor", ()=>(0, _threeCoreJs.ConstantColorFactor));
parcelHelpers.export(exports, "CubeDepthTexture", ()=>(0, _threeCoreJs.CubeDepthTexture));
parcelHelpers.export(exports, "CubeReflectionMapping", ()=>(0, _threeCoreJs.CubeReflectionMapping));
parcelHelpers.export(exports, "CubeRefractionMapping", ()=>(0, _threeCoreJs.CubeRefractionMapping));
parcelHelpers.export(exports, "CubeTexture", ()=>(0, _threeCoreJs.CubeTexture));
parcelHelpers.export(exports, "CubeUVReflectionMapping", ()=>(0, _threeCoreJs.CubeUVReflectionMapping));
parcelHelpers.export(exports, "CullFaceBack", ()=>(0, _threeCoreJs.CullFaceBack));
parcelHelpers.export(exports, "CullFaceFront", ()=>(0, _threeCoreJs.CullFaceFront));
parcelHelpers.export(exports, "CullFaceNone", ()=>(0, _threeCoreJs.CullFaceNone));
parcelHelpers.export(exports, "CustomBlending", ()=>(0, _threeCoreJs.CustomBlending));
parcelHelpers.export(exports, "CustomToneMapping", ()=>(0, _threeCoreJs.CustomToneMapping));
parcelHelpers.export(exports, "Data3DTexture", ()=>(0, _threeCoreJs.Data3DTexture));
parcelHelpers.export(exports, "DataArrayTexture", ()=>(0, _threeCoreJs.DataArrayTexture));
parcelHelpers.export(exports, "DataTexture", ()=>(0, _threeCoreJs.DataTexture));
parcelHelpers.export(exports, "DepthFormat", ()=>(0, _threeCoreJs.DepthFormat));
parcelHelpers.export(exports, "DepthStencilFormat", ()=>(0, _threeCoreJs.DepthStencilFormat));
parcelHelpers.export(exports, "DepthTexture", ()=>(0, _threeCoreJs.DepthTexture));
parcelHelpers.export(exports, "DoubleSide", ()=>(0, _threeCoreJs.DoubleSide));
parcelHelpers.export(exports, "DstAlphaFactor", ()=>(0, _threeCoreJs.DstAlphaFactor));
parcelHelpers.export(exports, "DstColorFactor", ()=>(0, _threeCoreJs.DstColorFactor));
parcelHelpers.export(exports, "EqualCompare", ()=>(0, _threeCoreJs.EqualCompare));
parcelHelpers.export(exports, "EqualDepth", ()=>(0, _threeCoreJs.EqualDepth));
parcelHelpers.export(exports, "EquirectangularReflectionMapping", ()=>(0, _threeCoreJs.EquirectangularReflectionMapping));
parcelHelpers.export(exports, "EquirectangularRefractionMapping", ()=>(0, _threeCoreJs.EquirectangularRefractionMapping));
parcelHelpers.export(exports, "Euler", ()=>(0, _threeCoreJs.Euler));
parcelHelpers.export(exports, "EventDispatcher", ()=>(0, _threeCoreJs.EventDispatcher));
parcelHelpers.export(exports, "ExternalTexture", ()=>(0, _threeCoreJs.ExternalTexture));
parcelHelpers.export(exports, "Float32BufferAttribute", ()=>(0, _threeCoreJs.Float32BufferAttribute));
parcelHelpers.export(exports, "FloatType", ()=>(0, _threeCoreJs.FloatType));
parcelHelpers.export(exports, "FrontSide", ()=>(0, _threeCoreJs.FrontSide));
parcelHelpers.export(exports, "Frustum", ()=>(0, _threeCoreJs.Frustum));
parcelHelpers.export(exports, "GLSL3", ()=>(0, _threeCoreJs.GLSL3));
parcelHelpers.export(exports, "GreaterCompare", ()=>(0, _threeCoreJs.GreaterCompare));
parcelHelpers.export(exports, "GreaterDepth", ()=>(0, _threeCoreJs.GreaterDepth));
parcelHelpers.export(exports, "GreaterEqualCompare", ()=>(0, _threeCoreJs.GreaterEqualCompare));
parcelHelpers.export(exports, "GreaterEqualDepth", ()=>(0, _threeCoreJs.GreaterEqualDepth));
parcelHelpers.export(exports, "HalfFloatType", ()=>(0, _threeCoreJs.HalfFloatType));
parcelHelpers.export(exports, "IntType", ()=>(0, _threeCoreJs.IntType));
parcelHelpers.export(exports, "Layers", ()=>(0, _threeCoreJs.Layers));
parcelHelpers.export(exports, "LessCompare", ()=>(0, _threeCoreJs.LessCompare));
parcelHelpers.export(exports, "LessDepth", ()=>(0, _threeCoreJs.LessDepth));
parcelHelpers.export(exports, "LessEqualCompare", ()=>(0, _threeCoreJs.LessEqualCompare));
parcelHelpers.export(exports, "LessEqualDepth", ()=>(0, _threeCoreJs.LessEqualDepth));
parcelHelpers.export(exports, "LinearFilter", ()=>(0, _threeCoreJs.LinearFilter));
parcelHelpers.export(exports, "LinearMipmapLinearFilter", ()=>(0, _threeCoreJs.LinearMipmapLinearFilter));
parcelHelpers.export(exports, "LinearMipmapNearestFilter", ()=>(0, _threeCoreJs.LinearMipmapNearestFilter));
parcelHelpers.export(exports, "LinearSRGBColorSpace", ()=>(0, _threeCoreJs.LinearSRGBColorSpace));
parcelHelpers.export(exports, "LinearToneMapping", ()=>(0, _threeCoreJs.LinearToneMapping));
parcelHelpers.export(exports, "LinearTransfer", ()=>(0, _threeCoreJs.LinearTransfer));
parcelHelpers.export(exports, "Matrix3", ()=>(0, _threeCoreJs.Matrix3));
parcelHelpers.export(exports, "Matrix4", ()=>(0, _threeCoreJs.Matrix4));
parcelHelpers.export(exports, "MaxEquation", ()=>(0, _threeCoreJs.MaxEquation));
parcelHelpers.export(exports, "Mesh", ()=>(0, _threeCoreJs.Mesh));
parcelHelpers.export(exports, "MeshBasicMaterial", ()=>(0, _threeCoreJs.MeshBasicMaterial));
parcelHelpers.export(exports, "MeshDepthMaterial", ()=>(0, _threeCoreJs.MeshDepthMaterial));
parcelHelpers.export(exports, "MeshDistanceMaterial", ()=>(0, _threeCoreJs.MeshDistanceMaterial));
parcelHelpers.export(exports, "MinEquation", ()=>(0, _threeCoreJs.MinEquation));
parcelHelpers.export(exports, "MirroredRepeatWrapping", ()=>(0, _threeCoreJs.MirroredRepeatWrapping));
parcelHelpers.export(exports, "MixOperation", ()=>(0, _threeCoreJs.MixOperation));
parcelHelpers.export(exports, "MultiplyBlending", ()=>(0, _threeCoreJs.MultiplyBlending));
parcelHelpers.export(exports, "MultiplyOperation", ()=>(0, _threeCoreJs.MultiplyOperation));
parcelHelpers.export(exports, "NearestFilter", ()=>(0, _threeCoreJs.NearestFilter));
parcelHelpers.export(exports, "NearestMipmapLinearFilter", ()=>(0, _threeCoreJs.NearestMipmapLinearFilter));
parcelHelpers.export(exports, "NearestMipmapNearestFilter", ()=>(0, _threeCoreJs.NearestMipmapNearestFilter));
parcelHelpers.export(exports, "NeutralToneMapping", ()=>(0, _threeCoreJs.NeutralToneMapping));
parcelHelpers.export(exports, "NeverCompare", ()=>(0, _threeCoreJs.NeverCompare));
parcelHelpers.export(exports, "NeverDepth", ()=>(0, _threeCoreJs.NeverDepth));
parcelHelpers.export(exports, "NoBlending", ()=>(0, _threeCoreJs.NoBlending));
parcelHelpers.export(exports, "NoColorSpace", ()=>(0, _threeCoreJs.NoColorSpace));
parcelHelpers.export(exports, "NoToneMapping", ()=>(0, _threeCoreJs.NoToneMapping));
parcelHelpers.export(exports, "NormalBlending", ()=>(0, _threeCoreJs.NormalBlending));
parcelHelpers.export(exports, "NotEqualCompare", ()=>(0, _threeCoreJs.NotEqualCompare));
parcelHelpers.export(exports, "NotEqualDepth", ()=>(0, _threeCoreJs.NotEqualDepth));
parcelHelpers.export(exports, "ObjectSpaceNormalMap", ()=>(0, _threeCoreJs.ObjectSpaceNormalMap));
parcelHelpers.export(exports, "OneFactor", ()=>(0, _threeCoreJs.OneFactor));
parcelHelpers.export(exports, "OneMinusConstantAlphaFactor", ()=>(0, _threeCoreJs.OneMinusConstantAlphaFactor));
parcelHelpers.export(exports, "OneMinusConstantColorFactor", ()=>(0, _threeCoreJs.OneMinusConstantColorFactor));
parcelHelpers.export(exports, "OneMinusDstAlphaFactor", ()=>(0, _threeCoreJs.OneMinusDstAlphaFactor));
parcelHelpers.export(exports, "OneMinusDstColorFactor", ()=>(0, _threeCoreJs.OneMinusDstColorFactor));
parcelHelpers.export(exports, "OneMinusSrcAlphaFactor", ()=>(0, _threeCoreJs.OneMinusSrcAlphaFactor));
parcelHelpers.export(exports, "OneMinusSrcColorFactor", ()=>(0, _threeCoreJs.OneMinusSrcColorFactor));
parcelHelpers.export(exports, "OrthographicCamera", ()=>(0, _threeCoreJs.OrthographicCamera));
parcelHelpers.export(exports, "PCFShadowMap", ()=>(0, _threeCoreJs.PCFShadowMap));
parcelHelpers.export(exports, "PCFSoftShadowMap", ()=>(0, _threeCoreJs.PCFSoftShadowMap));
parcelHelpers.export(exports, "PMREMGenerator", ()=>PMREMGenerator);
parcelHelpers.export(exports, "PerspectiveCamera", ()=>(0, _threeCoreJs.PerspectiveCamera));
parcelHelpers.export(exports, "Plane", ()=>(0, _threeCoreJs.Plane));
parcelHelpers.export(exports, "PlaneGeometry", ()=>(0, _threeCoreJs.PlaneGeometry));
parcelHelpers.export(exports, "R11_EAC_Format", ()=>(0, _threeCoreJs.R11_EAC_Format));
parcelHelpers.export(exports, "RED_GREEN_RGTC2_Format", ()=>(0, _threeCoreJs.RED_GREEN_RGTC2_Format));
parcelHelpers.export(exports, "RED_RGTC1_Format", ()=>(0, _threeCoreJs.RED_RGTC1_Format));
parcelHelpers.export(exports, "REVISION", ()=>(0, _threeCoreJs.REVISION));
parcelHelpers.export(exports, "RG11_EAC_Format", ()=>(0, _threeCoreJs.RG11_EAC_Format));
parcelHelpers.export(exports, "RGBAFormat", ()=>(0, _threeCoreJs.RGBAFormat));
parcelHelpers.export(exports, "RGBAIntegerFormat", ()=>(0, _threeCoreJs.RGBAIntegerFormat));
parcelHelpers.export(exports, "RGBA_ASTC_10x10_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_10x10_Format));
parcelHelpers.export(exports, "RGBA_ASTC_10x5_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_10x5_Format));
parcelHelpers.export(exports, "RGBA_ASTC_10x6_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_10x6_Format));
parcelHelpers.export(exports, "RGBA_ASTC_10x8_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_10x8_Format));
parcelHelpers.export(exports, "RGBA_ASTC_12x10_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_12x10_Format));
parcelHelpers.export(exports, "RGBA_ASTC_12x12_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_12x12_Format));
parcelHelpers.export(exports, "RGBA_ASTC_4x4_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_4x4_Format));
parcelHelpers.export(exports, "RGBA_ASTC_5x4_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_5x4_Format));
parcelHelpers.export(exports, "RGBA_ASTC_5x5_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_5x5_Format));
parcelHelpers.export(exports, "RGBA_ASTC_6x5_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_6x5_Format));
parcelHelpers.export(exports, "RGBA_ASTC_6x6_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_6x6_Format));
parcelHelpers.export(exports, "RGBA_ASTC_8x5_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_8x5_Format));
parcelHelpers.export(exports, "RGBA_ASTC_8x6_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_8x6_Format));
parcelHelpers.export(exports, "RGBA_ASTC_8x8_Format", ()=>(0, _threeCoreJs.RGBA_ASTC_8x8_Format));
parcelHelpers.export(exports, "RGBA_BPTC_Format", ()=>(0, _threeCoreJs.RGBA_BPTC_Format));
parcelHelpers.export(exports, "RGBA_ETC2_EAC_Format", ()=>(0, _threeCoreJs.RGBA_ETC2_EAC_Format));
parcelHelpers.export(exports, "RGBA_PVRTC_2BPPV1_Format", ()=>(0, _threeCoreJs.RGBA_PVRTC_2BPPV1_Format));
parcelHelpers.export(exports, "RGBA_PVRTC_4BPPV1_Format", ()=>(0, _threeCoreJs.RGBA_PVRTC_4BPPV1_Format));
parcelHelpers.export(exports, "RGBA_S3TC_DXT1_Format", ()=>(0, _threeCoreJs.RGBA_S3TC_DXT1_Format));
parcelHelpers.export(exports, "RGBA_S3TC_DXT3_Format", ()=>(0, _threeCoreJs.RGBA_S3TC_DXT3_Format));
parcelHelpers.export(exports, "RGBA_S3TC_DXT5_Format", ()=>(0, _threeCoreJs.RGBA_S3TC_DXT5_Format));
parcelHelpers.export(exports, "RGBFormat", ()=>(0, _threeCoreJs.RGBFormat));
parcelHelpers.export(exports, "RGB_BPTC_SIGNED_Format", ()=>(0, _threeCoreJs.RGB_BPTC_SIGNED_Format));
parcelHelpers.export(exports, "RGB_BPTC_UNSIGNED_Format", ()=>(0, _threeCoreJs.RGB_BPTC_UNSIGNED_Format));
parcelHelpers.export(exports, "RGB_ETC1_Format", ()=>(0, _threeCoreJs.RGB_ETC1_Format));
parcelHelpers.export(exports, "RGB_ETC2_Format", ()=>(0, _threeCoreJs.RGB_ETC2_Format));
parcelHelpers.export(exports, "RGB_PVRTC_2BPPV1_Format", ()=>(0, _threeCoreJs.RGB_PVRTC_2BPPV1_Format));
parcelHelpers.export(exports, "RGB_PVRTC_4BPPV1_Format", ()=>(0, _threeCoreJs.RGB_PVRTC_4BPPV1_Format));
parcelHelpers.export(exports, "RGB_S3TC_DXT1_Format", ()=>(0, _threeCoreJs.RGB_S3TC_DXT1_Format));
parcelHelpers.export(exports, "RGFormat", ()=>(0, _threeCoreJs.RGFormat));
parcelHelpers.export(exports, "RGIntegerFormat", ()=>(0, _threeCoreJs.RGIntegerFormat));
parcelHelpers.export(exports, "RawShaderMaterial", ()=>(0, _threeCoreJs.RawShaderMaterial));
parcelHelpers.export(exports, "RedFormat", ()=>(0, _threeCoreJs.RedFormat));
parcelHelpers.export(exports, "RedIntegerFormat", ()=>(0, _threeCoreJs.RedIntegerFormat));
parcelHelpers.export(exports, "ReinhardToneMapping", ()=>(0, _threeCoreJs.ReinhardToneMapping));
parcelHelpers.export(exports, "RepeatWrapping", ()=>(0, _threeCoreJs.RepeatWrapping));
parcelHelpers.export(exports, "ReverseSubtractEquation", ()=>(0, _threeCoreJs.ReverseSubtractEquation));
parcelHelpers.export(exports, "SIGNED_R11_EAC_Format", ()=>(0, _threeCoreJs.SIGNED_R11_EAC_Format));
parcelHelpers.export(exports, "SIGNED_RED_GREEN_RGTC2_Format", ()=>(0, _threeCoreJs.SIGNED_RED_GREEN_RGTC2_Format));
parcelHelpers.export(exports, "SIGNED_RED_RGTC1_Format", ()=>(0, _threeCoreJs.SIGNED_RED_RGTC1_Format));
parcelHelpers.export(exports, "SIGNED_RG11_EAC_Format", ()=>(0, _threeCoreJs.SIGNED_RG11_EAC_Format));
parcelHelpers.export(exports, "SRGBColorSpace", ()=>(0, _threeCoreJs.SRGBColorSpace));
parcelHelpers.export(exports, "SRGBTransfer", ()=>(0, _threeCoreJs.SRGBTransfer));
parcelHelpers.export(exports, "ShaderChunk", ()=>ShaderChunk);
parcelHelpers.export(exports, "ShaderLib", ()=>ShaderLib);
parcelHelpers.export(exports, "ShaderMaterial", ()=>(0, _threeCoreJs.ShaderMaterial));
parcelHelpers.export(exports, "ShortType", ()=>(0, _threeCoreJs.ShortType));
parcelHelpers.export(exports, "SrcAlphaFactor", ()=>(0, _threeCoreJs.SrcAlphaFactor));
parcelHelpers.export(exports, "SrcAlphaSaturateFactor", ()=>(0, _threeCoreJs.SrcAlphaSaturateFactor));
parcelHelpers.export(exports, "SrcColorFactor", ()=>(0, _threeCoreJs.SrcColorFactor));
parcelHelpers.export(exports, "SubtractEquation", ()=>(0, _threeCoreJs.SubtractEquation));
parcelHelpers.export(exports, "SubtractiveBlending", ()=>(0, _threeCoreJs.SubtractiveBlending));
parcelHelpers.export(exports, "TangentSpaceNormalMap", ()=>(0, _threeCoreJs.TangentSpaceNormalMap));
parcelHelpers.export(exports, "Texture", ()=>(0, _threeCoreJs.Texture));
parcelHelpers.export(exports, "Uint16BufferAttribute", ()=>(0, _threeCoreJs.Uint16BufferAttribute));
parcelHelpers.export(exports, "Uint32BufferAttribute", ()=>(0, _threeCoreJs.Uint32BufferAttribute));
parcelHelpers.export(exports, "UniformsLib", ()=>UniformsLib);
parcelHelpers.export(exports, "UniformsUtils", ()=>(0, _threeCoreJs.UniformsUtils));
parcelHelpers.export(exports, "UnsignedByteType", ()=>(0, _threeCoreJs.UnsignedByteType));
parcelHelpers.export(exports, "UnsignedInt101111Type", ()=>(0, _threeCoreJs.UnsignedInt101111Type));
parcelHelpers.export(exports, "UnsignedInt248Type", ()=>(0, _threeCoreJs.UnsignedInt248Type));
parcelHelpers.export(exports, "UnsignedInt5999Type", ()=>(0, _threeCoreJs.UnsignedInt5999Type));
parcelHelpers.export(exports, "UnsignedIntType", ()=>(0, _threeCoreJs.UnsignedIntType));
parcelHelpers.export(exports, "UnsignedShort4444Type", ()=>(0, _threeCoreJs.UnsignedShort4444Type));
parcelHelpers.export(exports, "UnsignedShort5551Type", ()=>(0, _threeCoreJs.UnsignedShort5551Type));
parcelHelpers.export(exports, "UnsignedShortType", ()=>(0, _threeCoreJs.UnsignedShortType));
parcelHelpers.export(exports, "VSMShadowMap", ()=>(0, _threeCoreJs.VSMShadowMap));
parcelHelpers.export(exports, "Vector2", ()=>(0, _threeCoreJs.Vector2));
parcelHelpers.export(exports, "Vector3", ()=>(0, _threeCoreJs.Vector3));
parcelHelpers.export(exports, "Vector4", ()=>(0, _threeCoreJs.Vector4));
parcelHelpers.export(exports, "WebGLCoordinateSystem", ()=>(0, _threeCoreJs.WebGLCoordinateSystem));
parcelHelpers.export(exports, "WebGLCubeRenderTarget", ()=>(0, _threeCoreJs.WebGLCubeRenderTarget));
parcelHelpers.export(exports, "WebGLRenderTarget", ()=>(0, _threeCoreJs.WebGLRenderTarget));
parcelHelpers.export(exports, "WebGLRenderer", ()=>WebGLRenderer);
parcelHelpers.export(exports, "WebGLUtils", ()=>WebGLUtils);
parcelHelpers.export(exports, "WebXRController", ()=>(0, _threeCoreJs.WebXRController));
parcelHelpers.export(exports, "ZeroFactor", ()=>(0, _threeCoreJs.ZeroFactor));
parcelHelpers.export(exports, "createCanvasElement", ()=>(0, _threeCoreJs.createCanvasElement));
parcelHelpers.export(exports, "error", ()=>(0, _threeCoreJs.error));
parcelHelpers.export(exports, "log", ()=>(0, _threeCoreJs.log));
parcelHelpers.export(exports, "warn", ()=>(0, _threeCoreJs.warn));
parcelHelpers.export(exports, "warnOnce", ()=>(0, _threeCoreJs.warnOnce));
var _threeCoreJs = require("./three.core.js");
function WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function WebGLAttributes(gl) {
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const size = array.byteLength;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type;
        if (array instanceof Float32Array) type = gl.FLOAT;
        else if (typeof Float16Array !== 'undefined' && array instanceof Float16Array) type = gl.HALF_FLOAT;
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) type = gl.HALF_FLOAT;
            else type = gl.UNSIGNED_SHORT;
        } else if (array instanceof Int16Array) type = gl.SHORT;
        else if (array instanceof Uint32Array) type = gl.UNSIGNED_INT;
        else if (array instanceof Int32Array) type = gl.INT;
        else if (array instanceof Int8Array) type = gl.BYTE;
        else if (array instanceof Uint8Array) type = gl.UNSIGNED_BYTE;
        else if (array instanceof Uint8ClampedArray) type = gl.UNSIGNED_BYTE;
        else throw new Error('THREE.WebGLAttributes: Unsupported buffer data format: ' + array);
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version,
            size: size
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRanges = attribute.updateRanges;
        gl.bindBuffer(bufferType, buffer);
        if (updateRanges.length === 0) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.bufferSubData`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousRange.start + previousRange.count + 1) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                gl.bufferSubData(bufferType, range.start * array.BYTES_PER_ELEMENT, array, range.start, range.count);
            }
            attribute.clearUpdateRanges();
        }
        attribute.onUploadCallback();
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            if (data.size !== attribute.array.byteLength) throw new Error('THREE.WebGLAttributes: The size of the buffer attribute\'s array buffer does not match the original size. Resizing buffer attributes is not supported.');
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
var alphahash_fragment = "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif";
var alphahash_pars_fragment = "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif";
var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif";
var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var alphatest_fragment = "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif";
var alphatest_pars_fragment = "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif";
var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif";
var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var batching_pars_vertex = "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif";
var batching_vertex = "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif";
var begin_vertex = "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif";
var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var bsdfs = "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated";
var iridescence_fragment = "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif";
var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif";
var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var color_fragment = "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif";
var color_pars_fragment = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif";
var color_pars_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var color_vertex = "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif";
var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated";
var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif";
var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var colorspace_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var colorspace_pars_fragment = "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}";
var envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n#endif";
var envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var fog_vertex = "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif";
var fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif";
var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}";
var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var lights_lambert_fragment = "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;";
var lights_lambert_pars_fragment = "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert";
var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif";
var envmap_physical_pars_fragment = "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, pow4( roughness ) ) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif";
var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var lights_toon_pars_fragment = "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon";
var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var lights_phong_pars_fragment = "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong";
var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.diffuseContribution = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nmaterial.metalness = metalnessFactor;\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor;\n\tmaterial.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = vec3( 0.04 );\n\tmaterial.specularColorBlended = mix( material.specularColor, diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.0001, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif";
var lights_physical_pars_fragment = "uniform sampler2D dfgLUT;\nstruct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tvec3 diffuseContribution;\n\tvec3 specularColor;\n\tvec3 specularColorBlended;\n\tfloat roughness;\n\tfloat metalness;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t\tvec3 iridescenceFresnelDielectric;\n\t\tvec3 iridescenceFresnelMetallic;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn v;\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColorBlended;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transpose( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat rInv = 1.0 / ( roughness + 0.1 );\n\tfloat a = -1.9362 + 1.0678 * roughness + 0.4573 * r2 - 0.8469 * rInv;\n\tfloat b = -0.6014 + 0.5538 * roughness - 0.4670 * r2 - 0.1255 * rInv;\n\tfloat DG = exp( a * dotNV + b );\n\treturn saturate( DG );\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 fab = texture2D( dfgLUT, vec2( roughness, dotNV ) ).rg;\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nvec3 BRDF_GGX_Multiscatter( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 singleScatter = BRDF_GGX( lightDir, viewDir, normal, material );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 dfgV = texture2D( dfgLUT, vec2( material.roughness, dotNV ) ).rg;\n\tvec2 dfgL = texture2D( dfgLUT, vec2( material.roughness, dotNL ) ).rg;\n\tvec3 FssEss_V = material.specularColorBlended * dfgV.x + material.specularF90 * dfgV.y;\n\tvec3 FssEss_L = material.specularColorBlended * dfgL.x + material.specularF90 * dfgL.y;\n\tfloat Ess_V = dfgV.x + dfgV.y;\n\tfloat Ess_L = dfgL.x + dfgL.y;\n\tfloat Ems_V = 1.0 - Ess_V;\n\tfloat Ems_L = 1.0 - Ess_L;\n\tvec3 Favg = material.specularColorBlended + ( 1.0 - material.specularColorBlended ) * 0.047619;\n\tvec3 Fms = FssEss_V * FssEss_L * Favg / ( 1.0 - Ems_V * Ems_L * Favg + EPSILON );\n\tfloat compensationFactor = Ems_V * Ems_L;\n\tvec3 multiScatter = Fms * compensationFactor;\n\treturn singleScatter + multiScatter;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColorBlended * t2.x + ( vec3( 1.0 ) - material.specularColorBlended ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseContribution * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n \n \t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n \n \t\tfloat sheenAlbedoV = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n \t\tfloat sheenAlbedoL = IBLSheenBRDF( geometryNormal, directLight.direction, material.sheenRoughness );\n \n \t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * max( sheenAlbedoV, sheenAlbedoL );\n \n \t\tirradiance *= sheenEnergyComp;\n \n \t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX_Multiscatter( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseContribution );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 diffuse = irradiance * BRDF_Lambert( material.diffuseContribution );\n\t#ifdef USE_SHEEN\n\t\tfloat sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n\t\tdiffuse *= sheenEnergyComp;\n\t#endif\n\treflectedLight.indirectDiffuse += diffuse;\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness ) * RECIPROCAL_PI;\n \t#endif\n\tvec3 singleScatteringDielectric = vec3( 0.0 );\n\tvec3 multiScatteringDielectric = vec3( 0.0 );\n\tvec3 singleScatteringMetallic = vec3( 0.0 );\n\tvec3 multiScatteringMetallic = vec3( 0.0 );\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnelDielectric, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.iridescence, material.iridescenceFresnelMetallic, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScatteringDielectric, multiScatteringDielectric );\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.diffuseColor, material.specularF90, material.roughness, singleScatteringMetallic, multiScatteringMetallic );\n\t#endif\n\tvec3 singleScattering = mix( singleScatteringDielectric, singleScatteringMetallic, material.metalness );\n\tvec3 multiScattering = mix( multiScatteringDielectric, multiScatteringMetallic, material.metalness );\n\tvec3 totalScatteringDielectric = singleScatteringDielectric + multiScatteringDielectric;\n\tvec3 diffuse = material.diffuseContribution * ( 1.0 - totalScatteringDielectric );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tvec3 indirectSpecular = radiance * singleScattering;\n\tindirectSpecular += multiScattering * cosineWeightedIrradiance;\n\tvec3 indirectDiffuse = diffuse * cosineWeightedIrradiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenAlbedo = IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t\tfloat sheenEnergyComp = 1.0 - max3( material.sheenColor ) * sheenAlbedo;\n\t\tindirectSpecular *= sheenEnergyComp;\n\t\tindirectDiffuse *= sheenEnergyComp;\n\t#endif\n\treflectedLight.indirectSpecular += indirectSpecular;\n\treflectedLight.indirectDiffuse += indirectDiffuse;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var lights_fragment_begin = "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnelDielectric = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceFresnelMetallic = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.diffuseColor );\n\t\tmaterial.iridescenceFresnel = mix( material.iridescenceFresnelDielectric, material.iridescenceFresnelMetallic, material.metalness );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS ) && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif";
var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif";
var logdepthbuf_fragment = "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var logdepthbuf_pars_fragment = "#if defined( USE_LOGARITHMIC_DEPTH_BUFFER )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var logdepthbuf_pars_vertex = "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var logdepthbuf_vertex = "#ifdef USE_LOGARITHMIC_DEPTH_BUFFER\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif";
var map_fragment = "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif";
var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var map_particle_pars_fragment = "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var morphinstance_vertex = "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif";
var morphcolor_vertex = "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif";
var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif";
var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif";
var normal_fragment_begin = "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;";
var normal_fragment_maps = "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif";
var normal_pars_fragment = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var normal_pars_vertex = "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif";
var normal_vertex = "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif";
var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif";
var clearcoat_normal_fragment_begin = "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif";
var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif";
var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif";
var iridescence_pars_fragment = "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif";
var opaque_fragment = "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );";
var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}";
var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var shadowmap_pars_fragment = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform sampler2DShadow directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\t#else\n\t\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform sampler2DShadow spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\t#else\n\t\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tuniform samplerCubeShadow pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\t#elif defined( SHADOWMAP_TYPE_BASIC )\n\t\t\tuniform samplerCube pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\t#endif\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\tfloat interleavedGradientNoise( vec2 position ) {\n\t\t\treturn fract( 52.9829189 * fract( dot( position, vec2( 0.06711056, 0.00583715 ) ) ) );\n\t\t}\n\t\tvec2 vogelDiskSample( int sampleIndex, int samplesCount, float phi ) {\n\t\t\tconst float goldenAngle = 2.399963229728653;\n\t\t\tfloat r = sqrt( ( float( sampleIndex ) + 0.5 ) / float( samplesCount ) );\n\t\t\tfloat theta = float( sampleIndex ) * goldenAngle + phi;\n\t\t\treturn vec2( cos( theta ), sin( theta ) ) * r;\n\t\t}\n\t#endif\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\tfloat getShadow( sampler2DShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\tshadowCoord.z += shadowBias;\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\t\tfloat radius = shadowRadius * texelSize.x;\n\t\t\t\tfloat phi = interleavedGradientNoise( gl_FragCoord.xy ) * 6.28318530718;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 0, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 1, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 2, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 3, 5, phi ) * radius, shadowCoord.z ) ) +\n\t\t\t\t\ttexture( shadowMap, vec3( shadowCoord.xy + vogelDiskSample( 4, 5, phi ) * radius, shadowCoord.z ) )\n\t\t\t\t) * 0.2;\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\tshadowCoord.z += shadowBias;\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tvec2 distribution = texture2D( shadowMap, shadowCoord.xy ).rg;\n\t\t\t\tfloat mean = distribution.x;\n\t\t\t\tfloat variance = distribution.y * distribution.y;\n\t\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\t\tfloat hard_shadow = step( mean, shadowCoord.z );\n\t\t\t\t#else\n\t\t\t\t\tfloat hard_shadow = step( shadowCoord.z, mean );\n\t\t\t\t#endif\n\t\t\t\tif ( hard_shadow == 1.0 ) {\n\t\t\t\t\tshadow = 1.0;\n\t\t\t\t} else {\n\t\t\t\t\tvariance = max( variance, 0.0000001 );\n\t\t\t\t\tfloat d = shadowCoord.z - mean;\n\t\t\t\t\tfloat p_max = variance / ( variance + d * d );\n\t\t\t\t\tp_max = clamp( ( p_max - 0.3 ) / 0.65, 0.0, 1.0 );\n\t\t\t\t\tshadow = max( hard_shadow, p_max );\n\t\t\t\t}\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#else\n\t\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\t\tfloat shadow = 1.0;\n\t\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\t\tshadowCoord.z += shadowBias;\n\t\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\t\tif ( frustumTest ) {\n\t\t\t\tfloat depth = texture2D( shadowMap, shadowCoord.xy ).r;\n\t\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\t\tshadow = step( depth, shadowCoord.z );\n\t\t\t\t#else\n\t\t\t\t\tshadow = step( shadowCoord.z, depth );\n\t\t\t\t#endif\n\t\t\t}\n\t\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t\t}\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#if defined( SHADOWMAP_TYPE_PCF )\n\tfloat getPointShadow( samplerCubeShadow shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tvec3 absVec = abs( lightToPosition );\n\t\tfloat viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n\t\tif ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\tdp += shadowBias;\n\t\t\tfloat texelSize = shadowRadius / shadowMapSize.x;\n\t\t\tvec3 absDir = abs( bd3D );\n\t\t\tvec3 tangent = absDir.x > absDir.z ? vec3( 0.0, 1.0, 0.0 ) : vec3( 1.0, 0.0, 0.0 );\n\t\t\ttangent = normalize( cross( bd3D, tangent ) );\n\t\t\tvec3 bitangent = cross( bd3D, tangent );\n\t\t\tfloat phi = interleavedGradientNoise( gl_FragCoord.xy ) * 6.28318530718;\n\t\t\tshadow = (\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 0, 5, phi ).x + bitangent * vogelDiskSample( 0, 5, phi ).y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 1, 5, phi ).x + bitangent * vogelDiskSample( 1, 5, phi ).y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 2, 5, phi ).x + bitangent * vogelDiskSample( 2, 5, phi ).y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 3, 5, phi ).x + bitangent * vogelDiskSample( 3, 5, phi ).y ) * texelSize, dp ) ) +\n\t\t\t\ttexture( shadowMap, vec4( bd3D + ( tangent * vogelDiskSample( 4, 5, phi ).x + bitangent * vogelDiskSample( 4, 5, phi ).y ) * texelSize, dp ) )\n\t\t\t) * 0.2;\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\t#elif defined( SHADOWMAP_TYPE_BASIC )\n\tfloat getPointShadow( samplerCube shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\tvec3 absVec = abs( lightToPosition );\n\t\tfloat viewSpaceZ = max( max( absVec.x, absVec.y ), absVec.z );\n\t\tif ( viewSpaceZ - shadowCameraFar <= 0.0 && viewSpaceZ - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( shadowCameraFar * ( viewSpaceZ - shadowCameraNear ) ) / ( viewSpaceZ * ( shadowCameraFar - shadowCameraNear ) );\n\t\t\tdp += shadowBias;\n\t\t\tfloat depth = textureCube( shadowMap, bd3D ).r;\n\t\t\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\t\t\tshadow = step( depth, dp );\n\t\t\t#else\n\t\t\t\tshadow = step( dp, depth );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\t#endif\n\t#endif\n#endif";
var shadowmap_pars_vertex = "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var shadowmap_vertex = "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif";
var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0 && ( defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_BASIC ) )\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif";
var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var transmission_fragment = "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseContribution, material.specularColorBlended, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif";
var transmission_pars_fragment = "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif";
var uv_pars_fragment = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var uv_pars_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif";
var uv_vertex = "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif";
var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
const vertex$h = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
const fragment$h = "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const vertex$g = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const fragment$g = "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const vertex$f = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
const fragment$f = "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const vertex$e = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
const fragment$e = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\t#ifdef USE_REVERSED_DEPTH_BUFFER\n\t\tfloat fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];\n\t#else\n\t\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;\n\t#endif\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}";
const vertex$d = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
const fragment$d = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = vec4( dist, 0.0, 0.0, 1.0 );\n}";
const vertex$c = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
const fragment$c = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}";
const vertex$b = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const fragment$b = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const vertex$a = "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
const fragment$a = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const vertex$9 = "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const fragment$9 = "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const vertex$8 = "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
const fragment$8 = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const vertex$7 = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
const fragment$7 = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( normalize( normal ) * 0.5 + 0.5, diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}";
const vertex$6 = "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const fragment$6 = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const vertex$5 = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}";
const fragment$5 = "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n \n\t\toutgoingLight = outgoingLight + sheenSpecularDirect + sheenSpecularIndirect;\n \n \t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const vertex$4 = "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const fragment$4 = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
const vertex$3 = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
const fragment$3 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
const vertex$2 = "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
const fragment$2 = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const vertex$1 = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const fragment$1 = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}";
const ShaderChunk = {
    alphahash_fragment: alphahash_fragment,
    alphahash_pars_fragment: alphahash_pars_fragment,
    alphamap_fragment: alphamap_fragment,
    alphamap_pars_fragment: alphamap_pars_fragment,
    alphatest_fragment: alphatest_fragment,
    alphatest_pars_fragment: alphatest_pars_fragment,
    aomap_fragment: aomap_fragment,
    aomap_pars_fragment: aomap_pars_fragment,
    batching_pars_vertex: batching_pars_vertex,
    batching_vertex: batching_vertex,
    begin_vertex: begin_vertex,
    beginnormal_vertex: beginnormal_vertex,
    bsdfs: bsdfs,
    iridescence_fragment: iridescence_fragment,
    bumpmap_pars_fragment: bumpmap_pars_fragment,
    clipping_planes_fragment: clipping_planes_fragment,
    clipping_planes_pars_fragment: clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: clipping_planes_pars_vertex,
    clipping_planes_vertex: clipping_planes_vertex,
    color_fragment: color_fragment,
    color_pars_fragment: color_pars_fragment,
    color_pars_vertex: color_pars_vertex,
    color_vertex: color_vertex,
    common: common,
    cube_uv_reflection_fragment: cube_uv_reflection_fragment,
    defaultnormal_vertex: defaultnormal_vertex,
    displacementmap_pars_vertex: displacementmap_pars_vertex,
    displacementmap_vertex: displacementmap_vertex,
    emissivemap_fragment: emissivemap_fragment,
    emissivemap_pars_fragment: emissivemap_pars_fragment,
    colorspace_fragment: colorspace_fragment,
    colorspace_pars_fragment: colorspace_pars_fragment,
    envmap_fragment: envmap_fragment,
    envmap_common_pars_fragment: envmap_common_pars_fragment,
    envmap_pars_fragment: envmap_pars_fragment,
    envmap_pars_vertex: envmap_pars_vertex,
    envmap_physical_pars_fragment: envmap_physical_pars_fragment,
    envmap_vertex: envmap_vertex,
    fog_vertex: fog_vertex,
    fog_pars_vertex: fog_pars_vertex,
    fog_fragment: fog_fragment,
    fog_pars_fragment: fog_pars_fragment,
    gradientmap_pars_fragment: gradientmap_pars_fragment,
    lightmap_pars_fragment: lightmap_pars_fragment,
    lights_lambert_fragment: lights_lambert_fragment,
    lights_lambert_pars_fragment: lights_lambert_pars_fragment,
    lights_pars_begin: lights_pars_begin,
    lights_toon_fragment: lights_toon_fragment,
    lights_toon_pars_fragment: lights_toon_pars_fragment,
    lights_phong_fragment: lights_phong_fragment,
    lights_phong_pars_fragment: lights_phong_pars_fragment,
    lights_physical_fragment: lights_physical_fragment,
    lights_physical_pars_fragment: lights_physical_pars_fragment,
    lights_fragment_begin: lights_fragment_begin,
    lights_fragment_maps: lights_fragment_maps,
    lights_fragment_end: lights_fragment_end,
    logdepthbuf_fragment: logdepthbuf_fragment,
    logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
    logdepthbuf_vertex: logdepthbuf_vertex,
    map_fragment: map_fragment,
    map_pars_fragment: map_pars_fragment,
    map_particle_fragment: map_particle_fragment,
    map_particle_pars_fragment: map_particle_pars_fragment,
    metalnessmap_fragment: metalnessmap_fragment,
    metalnessmap_pars_fragment: metalnessmap_pars_fragment,
    morphinstance_vertex: morphinstance_vertex,
    morphcolor_vertex: morphcolor_vertex,
    morphnormal_vertex: morphnormal_vertex,
    morphtarget_pars_vertex: morphtarget_pars_vertex,
    morphtarget_vertex: morphtarget_vertex,
    normal_fragment_begin: normal_fragment_begin,
    normal_fragment_maps: normal_fragment_maps,
    normal_pars_fragment: normal_pars_fragment,
    normal_pars_vertex: normal_pars_vertex,
    normal_vertex: normal_vertex,
    normalmap_pars_fragment: normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: clearcoat_pars_fragment,
    iridescence_pars_fragment: iridescence_pars_fragment,
    opaque_fragment: opaque_fragment,
    packing: packing,
    premultiplied_alpha_fragment: premultiplied_alpha_fragment,
    project_vertex: project_vertex,
    dithering_fragment: dithering_fragment,
    dithering_pars_fragment: dithering_pars_fragment,
    roughnessmap_fragment: roughnessmap_fragment,
    roughnessmap_pars_fragment: roughnessmap_pars_fragment,
    shadowmap_pars_fragment: shadowmap_pars_fragment,
    shadowmap_pars_vertex: shadowmap_pars_vertex,
    shadowmap_vertex: shadowmap_vertex,
    shadowmask_pars_fragment: shadowmask_pars_fragment,
    skinbase_vertex: skinbase_vertex,
    skinning_pars_vertex: skinning_pars_vertex,
    skinning_vertex: skinning_vertex,
    skinnormal_vertex: skinnormal_vertex,
    specularmap_fragment: specularmap_fragment,
    specularmap_pars_fragment: specularmap_pars_fragment,
    tonemapping_fragment: tonemapping_fragment,
    tonemapping_pars_fragment: tonemapping_pars_fragment,
    transmission_fragment: transmission_fragment,
    transmission_pars_fragment: transmission_pars_fragment,
    uv_pars_fragment: uv_pars_fragment,
    uv_pars_vertex: uv_pars_vertex,
    uv_vertex: uv_vertex,
    worldpos_vertex: worldpos_vertex,
    background_vert: vertex$h,
    background_frag: fragment$h,
    backgroundCube_vert: vertex$g,
    backgroundCube_frag: fragment$g,
    cube_vert: vertex$f,
    cube_frag: fragment$f,
    depth_vert: vertex$e,
    depth_frag: fragment$e,
    distance_vert: vertex$d,
    distance_frag: fragment$d,
    equirect_vert: vertex$c,
    equirect_frag: fragment$c,
    linedashed_vert: vertex$b,
    linedashed_frag: fragment$b,
    meshbasic_vert: vertex$a,
    meshbasic_frag: fragment$a,
    meshlambert_vert: vertex$9,
    meshlambert_frag: fragment$9,
    meshmatcap_vert: vertex$8,
    meshmatcap_frag: fragment$8,
    meshnormal_vert: vertex$7,
    meshnormal_frag: fragment$7,
    meshphong_vert: vertex$6,
    meshphong_frag: fragment$6,
    meshphysical_vert: vertex$5,
    meshphysical_frag: fragment$5,
    meshtoon_vert: vertex$4,
    meshtoon_frag: fragment$4,
    points_vert: vertex$3,
    points_frag: fragment$3,
    shadow_vert: vertex$2,
    shadow_frag: fragment$2,
    sprite_vert: vertex$1,
    sprite_frag: fragment$1
};
// Uniforms library for shared webgl shaders
const UniformsLib = {
    common: {
        diffuse: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        },
        alphaTest: {
            value: 0
        }
    },
    specularmap: {
        specularMap: {
            value: null
        },
        specularMapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        envMapRotation: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        ior: {
            value: 1.5
        },
        refractionRatio: {
            value: 0.98
        },
        dfgLUT: {
            value: null
        } // DFG LUT for physically-based rendering
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        },
        aoMapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        },
        lightMapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpMapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalMapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        },
        normalScale: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Vector2)(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementMapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        },
        emissiveMapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        },
        metalnessMapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        },
        roughnessMapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotLightMap: {
            value: []
        },
        spotShadowMap: {
            value: []
        },
        spotLightMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowIntensity: 1,
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        },
        alphaTest: {
            value: 0
        },
        uvTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        }
    },
    sprite: {
        diffuse: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(0xffffff)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Vector2)(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        mapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        },
        alphaMap: {
            value: null
        },
        alphaMapTransform: {
            value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
        },
        alphaTest: {
            value: 0
        }
    }
};
const ShaderLib = {
    basic: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.common,
            UniformsLib.specularmap,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.fog
        ]),
        vertexShader: ShaderChunk.meshbasic_vert,
        fragmentShader: ShaderChunk.meshbasic_frag
    },
    lambert: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.common,
            UniformsLib.specularmap,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(0x000000)
                }
            }
        ]),
        vertexShader: ShaderChunk.meshlambert_vert,
        fragmentShader: ShaderChunk.meshlambert_frag
    },
    phong: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.common,
            UniformsLib.specularmap,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(0x000000)
                },
                specular: {
                    value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: ShaderChunk.meshphong_vert,
        fragmentShader: ShaderChunk.meshphong_frag
    },
    standard: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.common,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.roughnessmap,
            UniformsLib.metalnessmap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                }
            }
        ]),
        vertexShader: ShaderChunk.meshphysical_vert,
        fragmentShader: ShaderChunk.meshphysical_frag
    },
    toon: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.common,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.gradientmap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                emissive: {
                    value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(0x000000)
                }
            }
        ]),
        vertexShader: ShaderChunk.meshtoon_vert,
        fragmentShader: ShaderChunk.meshtoon_frag
    },
    matcap: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.common,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: ShaderChunk.meshmatcap_vert,
        fragmentShader: ShaderChunk.meshmatcap_frag
    },
    points: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.points,
            UniformsLib.fog
        ]),
        vertexShader: ShaderChunk.points_vert,
        fragmentShader: ShaderChunk.points_frag
    },
    dashed: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.common,
            UniformsLib.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: ShaderChunk.linedashed_vert,
        fragmentShader: ShaderChunk.linedashed_frag
    },
    depth: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.common,
            UniformsLib.displacementmap
        ]),
        vertexShader: ShaderChunk.depth_vert,
        fragmentShader: ShaderChunk.depth_frag
    },
    normal: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.common,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: ShaderChunk.meshnormal_vert,
        fragmentShader: ShaderChunk.meshnormal_frag
    },
    sprite: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.sprite,
            UniformsLib.fog
        ]),
        vertexShader: ShaderChunk.sprite_vert,
        fragmentShader: ShaderChunk.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            },
            t2D: {
                value: null
            },
            backgroundIntensity: {
                value: 1
            }
        },
        vertexShader: ShaderChunk.background_vert,
        fragmentShader: ShaderChunk.background_frag
    },
    backgroundCube: {
        uniforms: {
            envMap: {
                value: null
            },
            flipEnvMap: {
                value: -1
            },
            backgroundBlurriness: {
                value: 0
            },
            backgroundIntensity: {
                value: 1
            },
            backgroundRotation: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            }
        },
        vertexShader: ShaderChunk.backgroundCube_vert,
        fragmentShader: ShaderChunk.backgroundCube_frag
    },
    cube: {
        uniforms: {
            tCube: {
                value: null
            },
            tFlip: {
                value: -1
            },
            opacity: {
                value: 1.0
            }
        },
        vertexShader: ShaderChunk.cube_vert,
        fragmentShader: ShaderChunk.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: ShaderChunk.equirect_vert,
        fragmentShader: ShaderChunk.equirect_frag
    },
    distance: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.common,
            UniformsLib.displacementmap,
            {
                referencePosition: {
                    value: /*@__PURE__*/ new (0, _threeCoreJs.Vector3)()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: ShaderChunk.distance_vert,
        fragmentShader: ShaderChunk.distance_frag
    },
    shadow: {
        uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
            UniformsLib.lights,
            UniformsLib.fog,
            {
                color: {
                    value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: ShaderChunk.shadow_vert,
        fragmentShader: ShaderChunk.shadow_frag
    }
};
ShaderLib.physical = {
    uniforms: /*@__PURE__*/ (0, _threeCoreJs.mergeUniforms)([
        ShaderLib.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatMapTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            },
            clearcoatNormalMap: {
                value: null
            },
            clearcoatNormalMapTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            },
            clearcoatNormalScale: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Vector2)(1, 1)
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            },
            dispersion: {
                value: 0
            },
            iridescence: {
                value: 0
            },
            iridescenceMap: {
                value: null
            },
            iridescenceMapTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            },
            iridescenceIOR: {
                value: 1.3
            },
            iridescenceThicknessMinimum: {
                value: 100
            },
            iridescenceThicknessMaximum: {
                value: 400
            },
            iridescenceThicknessMap: {
                value: null
            },
            iridescenceThicknessMapTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            },
            sheen: {
                value: 0
            },
            sheenColor: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(0x000000)
            },
            sheenColorMap: {
                value: null
            },
            sheenColorMapTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            },
            sheenRoughness: {
                value: 1
            },
            sheenRoughnessMap: {
                value: null
            },
            sheenRoughnessMapTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            },
            transmissionMapTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            },
            transmissionSamplerSize: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Vector2)()
            },
            transmissionSamplerMap: {
                value: null
            },
            thickness: {
                value: 0
            },
            thicknessMap: {
                value: null
            },
            thicknessMapTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            },
            attenuationDistance: {
                value: 0
            },
            attenuationColor: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(0x000000)
            },
            specularColor: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Color)(1, 1, 1)
            },
            specularColorMap: {
                value: null
            },
            specularColorMapTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            },
            specularIntensity: {
                value: 1
            },
            specularIntensityMap: {
                value: null
            },
            specularIntensityMapTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            },
            anisotropyVector: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Vector2)()
            },
            anisotropyMap: {
                value: null
            },
            anisotropyMapTransform: {
                value: /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)()
            }
        }
    ]),
    vertexShader: ShaderChunk.meshphysical_vert,
    fragmentShader: ShaderChunk.meshphysical_frag
};
const _rgb = {
    r: 0,
    b: 0,
    g: 0
};
const _e1$1 = /*@__PURE__*/ new (0, _threeCoreJs.Euler)();
const _m1$1 = /*@__PURE__*/ new (0, _threeCoreJs.Matrix4)();
function WebGLBackground(renderer, cubemaps, cubeuvmaps, state, objects, alpha, premultipliedAlpha) {
    const clearColor = new (0, _threeCoreJs.Color)(0x000000);
    let clearAlpha = alpha === true ? 0 : 1;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function getBackground(scene) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) {
            const usePMREM = scene.backgroundBlurriness > 0; // use PMREM if the user wants to blur the background
            background = (usePMREM ? cubeuvmaps : cubemaps).get(background);
        }
        return background;
    }
    function render(scene) {
        let forceClear = false;
        const background = getBackground(scene);
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        const environmentBlendMode = renderer.xr.getEnvironmentBlendMode();
        if (environmentBlendMode === 'additive') state.buffers.color.setClear(0, 0, 0, 1, premultipliedAlpha);
        else if (environmentBlendMode === 'alpha-blend') state.buffers.color.setClear(0, 0, 0, 0, premultipliedAlpha);
        if (renderer.autoClear || forceClear) {
            // buffers might not be writable which is required to ensure a correct clear
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        }
    }
    function addToRenderList(renderList, scene) {
        const background = getBackground(scene);
        if (background && (background.isCubeTexture || background.mapping === (0, _threeCoreJs.CubeUVReflectionMapping))) {
            if (boxMesh === undefined) {
                boxMesh = new (0, _threeCoreJs.Mesh)(new (0, _threeCoreJs.BoxGeometry)(1, 1, 1), new (0, _threeCoreJs.ShaderMaterial)({
                    name: 'BackgroundCubeMaterial',
                    uniforms: (0, _threeCoreJs.cloneUniforms)(ShaderLib.backgroundCube.uniforms),
                    vertexShader: ShaderLib.backgroundCube.vertexShader,
                    fragmentShader: ShaderLib.backgroundCube.fragmentShader,
                    side: (0, _threeCoreJs.BackSide),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // add "envMap" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            _e1$1.copy(scene.backgroundRotation);
            // accommodate left-handed frame
            _e1$1.x *= -1;
            _e1$1.y *= -1;
            _e1$1.z *= -1;
            if (background.isCubeTexture && background.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                _e1$1.y *= -1;
                _e1$1.z *= -1;
            }
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background.isRenderTargetTexture === false ? -1 : 1;
            boxMesh.material.uniforms.backgroundBlurriness.value = scene.backgroundBlurriness;
            boxMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            boxMesh.material.uniforms.backgroundRotation.value.setFromMatrix4(_m1$1.makeRotationFromEuler(_e1$1));
            boxMesh.material.toneMapped = (0, _threeCoreJs.ColorManagement).getTransfer(background.colorSpace) !== (0, _threeCoreJs.SRGBTransfer);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            boxMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new (0, _threeCoreJs.Mesh)(new (0, _threeCoreJs.PlaneGeometry)(2, 2), new (0, _threeCoreJs.ShaderMaterial)({
                    name: 'BackgroundMaterial',
                    uniforms: (0, _threeCoreJs.cloneUniforms)(ShaderLib.background.uniforms),
                    vertexShader: ShaderLib.background.vertexShader,
                    fragmentShader: ShaderLib.background.fragmentShader,
                    side: (0, _threeCoreJs.FrontSide),
                    depthTest: false,
                    depthWrite: false,
                    fog: false,
                    allowOverride: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // add "map" material property so the renderer can evaluate it like for built-in materials
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            planeMesh.material.uniforms.backgroundIntensity.value = scene.backgroundIntensity;
            planeMesh.material.toneMapped = (0, _threeCoreJs.ColorManagement).getTransfer(background.colorSpace) !== (0, _threeCoreJs.SRGBTransfer);
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            planeMesh.layers.enableAll();
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        color.getRGB(_rgb, (0, _threeCoreJs.getUnlitUniformColorSpace)(renderer));
        state.buffers.color.setClear(_rgb.r, _rgb.g, _rgb.b, alpha, premultipliedAlpha);
    }
    function dispose() {
        if (boxMesh !== undefined) {
            boxMesh.geometry.dispose();
            boxMesh.material.dispose();
            boxMesh = undefined;
        }
        if (planeMesh !== undefined) {
            planeMesh.geometry.dispose();
            planeMesh.material.dispose();
            planeMesh = undefined;
        }
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render,
        addToRenderList: addToRenderList,
        dispose: dispose
    };
}
function WebGLBindingStates(gl, attributes) {
    const maxVertexAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    let forceUpdate = false;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        const state = getBindingState(geometry, program, material);
        if (currentState !== state) {
            currentState = state;
            bindVertexArrayObject(currentState.object);
        }
        updateBuffers = needsUpdate(object, geometry, program, index);
        if (updateBuffers) saveCache(object, geometry, program, index);
        if (index !== null) attributes.update(index, gl.ELEMENT_ARRAY_BUFFER);
        if (updateBuffers || forceUpdate) {
            forceUpdate = false;
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        return gl.createVertexArray();
    }
    function bindVertexArrayObject(vao) {
        return gl.bindVertexArray(vao);
    }
    function deleteVertexArrayObject(vao) {
        return gl.deleteVertexArray(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(object, geometry, program, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                const cachedAttribute = cachedAttributes[name];
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (cachedAttribute === undefined) return true;
                if (cachedAttribute.attribute !== geometryAttribute) return true;
                if (geometryAttribute && cachedAttribute.data !== geometryAttribute.data) return true;
                attributesNum++;
            }
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(object, geometry, program, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        const programAttributes = program.getAttributes();
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let attribute = attributes[name];
                if (attribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) attribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) attribute = object.instanceColor;
                }
                const data = {};
                data.attribute = attribute;
                if (attribute && attribute.data) data.data = attribute.data;
                cache[name] = data;
                attributesNum++;
            }
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            gl.vertexAttribDivisor(attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset, integer) {
        if (integer === true) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute.location >= 0) {
                let geometryAttribute = geometryAttributes[name];
                if (geometryAttribute === undefined) {
                    if (name === 'instanceMatrix' && object.instanceMatrix) geometryAttribute = object.instanceMatrix;
                    if (name === 'instanceColor' && object.instanceColor) geometryAttribute = object.instanceColor;
                }
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    // check for integer attributes
                    const integer = type === gl.INT || type === gl.UNSIGNED_INT || geometryAttribute.gpuType === (0, _threeCoreJs.IntType);
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data.isInstancedInterleavedBuffer) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, data.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, stride * bytesPerElement, (offset + size / programAttribute.locationSize * i) * bytesPerElement, integer);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            for(let i = 0; i < programAttribute.locationSize; i++)enableAttributeAndDivisor(programAttribute.location + i, geometryAttribute.meshPerAttribute);
                            if (object.isInstancedMesh !== true && geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else for(let i = 0; i < programAttribute.locationSize; i++)enableAttribute(programAttribute.location + i);
                        gl.bindBuffer(gl.ARRAY_BUFFER, buffer);
                        for(let i = 0; i < programAttribute.locationSize; i++)vertexAttribPointer(programAttribute.location + i, size / programAttribute.locationSize, type, normalized, size * bytesPerElement, size / programAttribute.locationSize * i * bytesPerElement, integer);
                    }
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute.location, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute.location, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute.location, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute.location, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        forceUpdate = true;
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatibility
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function WebGLBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawArraysInstanced(mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawArraysWEBGL(mode, starts, 0, counts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i], counts[i], primcount[i]);
        else {
            extension.multiDrawArraysInstancedWEBGL(mode, starts, 0, counts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function WebGLCapabilities(gl, extensions, parameters, utils) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            const extension = extensions.get('EXT_texture_filter_anisotropic');
            maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        } else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function textureFormatReadable(textureFormat) {
        if (textureFormat !== (0, _threeCoreJs.RGBAFormat) && utils.convert(textureFormat) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_FORMAT)) return false;
        return true;
    }
    function textureTypeReadable(textureType) {
        const halfFloatSupportedByExt = textureType === (0, _threeCoreJs.HalfFloatType) && (extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float'));
        if (textureType !== (0, _threeCoreJs.UnsignedByteType) && utils.convert(textureType) !== gl.getParameter(gl.IMPLEMENTATION_COLOR_READ_TYPE) && // Edge and Chrome Mac < 52 (#9513)
        textureType !== (0, _threeCoreJs.FloatType) && !halfFloatSupportedByExt) return false;
        return true;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.HIGH_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.HIGH_FLOAT).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(gl.VERTEX_SHADER, gl.MEDIUM_FLOAT).precision > 0 && gl.getShaderPrecisionFormat(gl.FRAGMENT_SHADER, gl.MEDIUM_FLOAT).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        (0, _threeCoreJs.warn)('WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const reversedDepthBuffer = parameters.reversedDepthBuffer === true && extensions.has('EXT_clip_control');
    const maxTextures = gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS);
    const maxVertexTextures = gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
    const maxTextureSize = gl.getParameter(gl.MAX_TEXTURE_SIZE);
    const maxCubemapSize = gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE);
    const maxAttributes = gl.getParameter(gl.MAX_VERTEX_ATTRIBS);
    const maxVertexUniforms = gl.getParameter(gl.MAX_VERTEX_UNIFORM_VECTORS);
    const maxVaryings = gl.getParameter(gl.MAX_VARYING_VECTORS);
    const maxFragmentUniforms = gl.getParameter(gl.MAX_FRAGMENT_UNIFORM_VECTORS);
    const maxSamples = gl.getParameter(gl.MAX_SAMPLES);
    const samples = gl.getParameter(gl.SAMPLES);
    return {
        isWebGL2: true,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        textureFormatReadable: textureFormatReadable,
        textureTypeReadable: textureTypeReadable,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        reversedDepthBuffer: reversedDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        maxSamples: maxSamples,
        samples: samples
    };
}
function WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new (0, _threeCoreJs.Plane)(), viewNormalMatrix = new (0, _threeCoreJs.Matrix3)(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
    };
    this.setGlobalState = function(planes, camera) {
        globalState = projectPlanes(planes, camera, 0);
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === (0, _threeCoreJs.EquirectangularReflectionMapping)) texture.mapping = (0, _threeCoreJs.CubeReflectionMapping);
        else if (mapping === (0, _threeCoreJs.EquirectangularRefractionMapping)) texture.mapping = (0, _threeCoreJs.CubeRefractionMapping);
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === (0, _threeCoreJs.EquirectangularReflectionMapping) || mapping === (0, _threeCoreJs.EquirectangularRefractionMapping)) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const renderTarget = new (0, _threeCoreJs.WebGLCubeRenderTarget)(image.height);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const LOD_MIN = 4;
// The standard deviations (radians) associated with the extra mips.
// Used for scene blur in fromScene() method.
const EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
// Used for scene blur in fromScene() method.
const MAX_SAMPLES = 20;
// GGX VNDF importance sampling configuration
const GGX_SAMPLES = 256;
const _flatCamera = /*@__PURE__*/ new (0, _threeCoreJs.OrthographicCamera)();
const _clearColor = /*@__PURE__*/ new (0, _threeCoreJs.Color)();
let _oldTarget = null;
let _oldActiveCubeFace = 0;
let _oldActiveMipmapLevel = 0;
let _oldXrEnabled = false;
const _origin = /*@__PURE__*/ new (0, _threeCoreJs.Vector3)();
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 *
 * The prefiltering uses GGX VNDF (Visible Normal Distribution Function)
 * importance sampling based on "Sampling the GGX Distribution of Visible Normals"
 * (Heitz, 2018) to generate environment maps that accurately match the GGX BRDF
 * used in material rendering for physically-based image-based lighting.
 */ class PMREMGenerator {
    /**
	 * Constructs a new PMREM generator.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 */ constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._lodMax = 0;
        this._cubeSize = 0;
        this._sizeLods = [];
        this._sigmas = [];
        this._lodMeshes = [];
        this._backgroundBox = null;
        this._cubemapMaterial = null;
        this._equirectMaterial = null;
        this._blurMaterial = null;
        this._ggxMaterial = null;
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety.
	 *
	 * @param {Scene} scene - The scene to be captured.
	 * @param {number} [sigma=0] - The blur radius in radians.
	 * @param {number} [near=0.1] - The near plane distance.
	 * @param {number} [far=100] - The far plane distance.
	 * @param {Object} [options={}] - The configuration options.
	 * @param {number} [options.size=256] - The texture size of the PMREM.
	 * @param {Vector3} [options.position=origin] - The position of the internal cube camera that renders the scene.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100, options = {}) {
        const { size = 256, position = _origin } = options;
        _oldTarget = this._renderer.getRenderTarget();
        _oldActiveCubeFace = this._renderer.getActiveCubeFace();
        _oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        _oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        this._setSize(size);
        const cubeUVRenderTarget = this._allocateTargets();
        cubeUVRenderTarget.depthBuffer = true;
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * or HDR. The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} equirectangular - The equirectangular texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromEquirectangular(equirectangular, renderTarget = null) {
        return this._fromTexture(equirectangular, renderTarget);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * or HDR. The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 *
	 * @param {Texture} cubemap - The cubemap texture to be converted.
	 * @param {?WebGLRenderTarget} [renderTarget=null] - The render target to use.
	 * @return {WebGLRenderTarget} The resulting PMREM.
	 */ fromCubemap(cubemap, renderTarget = null) {
        return this._fromTexture(cubemap, renderTarget);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapMaterial === null) {
            this._cubemapMaterial = _getCubemapMaterial();
            this._compileMaterial(this._cubemapMaterial);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectMaterial === null) {
            this._equirectMaterial = _getEquirectMaterial();
            this._compileMaterial(this._equirectMaterial);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._dispose();
        if (this._cubemapMaterial !== null) this._cubemapMaterial.dispose();
        if (this._equirectMaterial !== null) this._equirectMaterial.dispose();
        if (this._backgroundBox !== null) {
            this._backgroundBox.geometry.dispose();
            this._backgroundBox.material.dispose();
        }
    }
    // private interface
    _setSize(cubeSize) {
        this._lodMax = Math.floor(Math.log2(cubeSize));
        this._cubeSize = Math.pow(2, this._lodMax);
    }
    _dispose() {
        if (this._blurMaterial !== null) this._blurMaterial.dispose();
        if (this._ggxMaterial !== null) this._ggxMaterial.dispose();
        if (this._pingPongRenderTarget !== null) this._pingPongRenderTarget.dispose();
        for(let i = 0; i < this._lodMeshes.length; i++)this._lodMeshes[i].geometry.dispose();
    }
    _cleanup(outputTarget) {
        this._renderer.setRenderTarget(_oldTarget, _oldActiveCubeFace, _oldActiveMipmapLevel);
        this._renderer.xr.enabled = _oldXrEnabled;
        outputTarget.scissorTest = false;
        _setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture, renderTarget) {
        if (texture.mapping === (0, _threeCoreJs.CubeReflectionMapping) || texture.mapping === (0, _threeCoreJs.CubeRefractionMapping)) this._setSize(texture.image.length === 0 ? 16 : texture.image[0].width || texture.image[0].image.width);
        else this._setSize(texture.image.width / 4);
        _oldTarget = this._renderer.getRenderTarget();
        _oldActiveCubeFace = this._renderer.getActiveCubeFace();
        _oldActiveMipmapLevel = this._renderer.getActiveMipmapLevel();
        _oldXrEnabled = this._renderer.xr.enabled;
        this._renderer.xr.enabled = false;
        const cubeUVRenderTarget = renderTarget || this._allocateTargets();
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets() {
        const width = 3 * Math.max(this._cubeSize, 112);
        const height = 4 * this._cubeSize;
        const params = {
            magFilter: (0, _threeCoreJs.LinearFilter),
            minFilter: (0, _threeCoreJs.LinearFilter),
            generateMipmaps: false,
            type: (0, _threeCoreJs.HalfFloatType),
            format: (0, _threeCoreJs.RGBAFormat),
            colorSpace: (0, _threeCoreJs.LinearSRGBColorSpace),
            depthBuffer: false
        };
        const cubeUVRenderTarget = _createRenderTarget(width, height, params);
        if (this._pingPongRenderTarget === null || this._pingPongRenderTarget.width !== width || this._pingPongRenderTarget.height !== height) {
            if (this._pingPongRenderTarget !== null) this._dispose();
            this._pingPongRenderTarget = _createRenderTarget(width, height, params);
            const { _lodMax } = this;
            ({ lodMeshes: this._lodMeshes, sizeLods: this._sizeLods, sigmas: this._sigmas } = _createPlanes(_lodMax));
            this._blurMaterial = _getBlurShader(_lodMax, width, height);
            this._ggxMaterial = _getGGXShader(_lodMax, width, height);
        }
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const mesh = new (0, _threeCoreJs.Mesh)(new (0, _threeCoreJs.BufferGeometry)(), material);
        this._renderer.compile(mesh, _flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget, position) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new (0, _threeCoreJs.PerspectiveCamera)(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor(_clearColor);
        renderer.toneMapping = (0, _threeCoreJs.NoToneMapping);
        renderer.autoClear = false;
        // https://github.com/mrdoob/three.js/issues/31413#issuecomment-3095966812
        const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        if (reversedDepthBuffer) {
            renderer.setRenderTarget(cubeUVRenderTarget);
            renderer.clearDepth();
            renderer.setRenderTarget(null);
        }
        if (this._backgroundBox === null) this._backgroundBox = new (0, _threeCoreJs.Mesh)(new (0, _threeCoreJs.BoxGeometry)(), new (0, _threeCoreJs.MeshBasicMaterial)({
            name: 'PMREM.Background',
            side: (0, _threeCoreJs.BackSide),
            depthWrite: false,
            depthTest: false
        }));
        const backgroundBox = this._backgroundBox;
        const backgroundMaterial = backgroundBox.material;
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background);
                scene.background = null;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy(_clearColor);
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col === 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x + forwardSign[i], position.y, position.z);
            } else if (col === 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y + forwardSign[i], position.z);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.position.set(position.x, position.y, position.z);
                cubeCamera.lookAt(position.x, position.y, position.z + forwardSign[i]);
            }
            const size = this._cubeSize;
            _setViewport(cubeUVRenderTarget, col * size, i > 2 ? size : 0, size, size);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        renderer.toneMapping = toneMapping;
        renderer.autoClear = originalAutoClear;
        scene.background = background;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        const isCubeTexture = texture.mapping === (0, _threeCoreJs.CubeReflectionMapping) || texture.mapping === (0, _threeCoreJs.CubeRefractionMapping);
        if (isCubeTexture) {
            if (this._cubemapMaterial === null) this._cubemapMaterial = _getCubemapMaterial();
            this._cubemapMaterial.uniforms.flipEnvMap.value = texture.isRenderTargetTexture === false ? -1 : 1;
        } else if (this._equirectMaterial === null) this._equirectMaterial = _getEquirectMaterial();
        const material = isCubeTexture ? this._cubemapMaterial : this._equirectMaterial;
        const mesh = this._lodMeshes[0];
        mesh.material = material;
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        const size = this._cubeSize;
        _setViewport(cubeUVRenderTarget, 0, 0, 3 * size, 2 * size);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, _flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        const n = this._lodMeshes.length;
        // Use GGX VNDF importance sampling
        for(let i = 1; i < n; i++)this._applyGGXFilter(cubeUVRenderTarget, i - 1, i);
        renderer.autoClear = autoClear;
    }
    /**
	 * Applies GGX VNDF importance sampling filter to generate a prefiltered environment map.
	 * Uses Monte Carlo integration with VNDF importance sampling to accurately represent the
	 * GGX BRDF for physically-based rendering. Reads from the previous LOD level and
	 * applies incremental roughness filtering to avoid over-blurring.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn - Source LOD level to read from
	 * @param {number} lodOut - Target LOD level to write to
	 */ _applyGGXFilter(cubeUVRenderTarget, lodIn, lodOut) {
        const renderer = this._renderer;
        const pingPongRenderTarget = this._pingPongRenderTarget;
        const ggxMaterial = this._ggxMaterial;
        const ggxMesh = this._lodMeshes[lodOut];
        ggxMesh.material = ggxMaterial;
        const ggxUniforms = ggxMaterial.uniforms;
        // Calculate incremental roughness between LOD levels
        const targetRoughness = lodOut / (this._lodMeshes.length - 1);
        const sourceRoughness = lodIn / (this._lodMeshes.length - 1);
        const incrementalRoughness = Math.sqrt(targetRoughness * targetRoughness - sourceRoughness * sourceRoughness);
        // Apply blur strength mapping for better quality across the roughness range
        const blurStrength = 0.0 + targetRoughness * 1.25;
        const adjustedRoughness = incrementalRoughness * blurStrength;
        // Calculate viewport position based on output LOD level
        const { _lodMax } = this;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - LOD_MIN ? lodOut - _lodMax + LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        // Read from previous LOD with incremental roughness
        ggxUniforms['envMap'].value = cubeUVRenderTarget.texture;
        ggxUniforms['roughness'].value = adjustedRoughness;
        ggxUniforms['mipInt'].value = _lodMax - lodIn; // Sample from input LOD
        _setViewport(pingPongRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(pingPongRenderTarget);
        renderer.render(ggxMesh, _flatCamera);
        // Copy from pingPong back to cubeUV (simple direct copy)
        ggxUniforms['envMap'].value = pingPongRenderTarget.texture;
        ggxUniforms['roughness'].value = 0.0; // Direct copy
        ggxUniforms['mipInt'].value = _lodMax - lodOut; // Read from the level we just wrote
        _setViewport(cubeUVRenderTarget, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(ggxMesh, _flatCamera);
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 *
	 * Used for initial scene blur in fromScene() method when sigma > 0.
	 *
	 * @private
	 * @param {WebGLRenderTarget} cubeUVRenderTarget
	 * @param {number} lodIn
	 * @param {number} lodOut
	 * @param {number} sigma
	 * @param {Vector3} [poleAxis]
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') (0, _threeCoreJs.error)('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = this._lodMeshes[lodOut];
        blurMesh.material = blurMaterial;
        const blurUniforms = blurMaterial.uniforms;
        const pixels = this._sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : MAX_SAMPLES;
        if (samples > MAX_SAMPLES) (0, _threeCoreJs.warn)(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i === 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        const { _lodMax } = this;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = _lodMax - lodIn;
        const outputSize = this._sizeLods[lodOut];
        const x = 3 * outputSize * (lodOut > _lodMax - LOD_MIN ? lodOut - _lodMax + LOD_MIN : 0);
        const y = 4 * (this._cubeSize - outputSize);
        _setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, _flatCamera);
    }
}
function _createPlanes(lodMax) {
    const sizeLods = [];
    const sigmas = [];
    const lodMeshes = [];
    let lod = lodMax;
    const totalLods = lodMax - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;
    for(let i = 0; i < totalLods; i++){
        const sizeLod = Math.pow(2, lod);
        sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > lodMax - LOD_MIN) sigma = EXTRA_LOD_SIGMA[i - lodMax + LOD_MIN - 1];
        else if (i === 0) sigma = 0;
        sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 2);
        const min = -texelSize;
        const max = 1 + texelSize;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new (0, _threeCoreJs.BufferGeometry)();
        planes.setAttribute('position', new (0, _threeCoreJs.BufferAttribute)(position, positionSize));
        planes.setAttribute('uv', new (0, _threeCoreJs.BufferAttribute)(uv, uvSize));
        planes.setAttribute('faceIndex', new (0, _threeCoreJs.BufferAttribute)(faceIndex, faceIndexSize));
        lodMeshes.push(new (0, _threeCoreJs.Mesh)(planes, null));
        if (lod > LOD_MIN) lod--;
    }
    return {
        lodMeshes,
        sizeLods,
        sigmas
    };
}
function _createRenderTarget(width, height, params) {
    const cubeUVRenderTarget = new (0, _threeCoreJs.WebGLRenderTarget)(width, height, params);
    cubeUVRenderTarget.texture.mapping = (0, _threeCoreJs.CubeUVReflectionMapping);
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function _setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function _getGGXShader(lodMax, width, height) {
    const shaderMaterial = new (0, _threeCoreJs.ShaderMaterial)({
        name: 'PMREMGGXConvolution',
        defines: {
            'GGX_SAMPLES': GGX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'roughness': {
                value: 0.0
            },
            'mipInt': {
                value: 0
            }
        },
        vertexShader: _getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision highp float;
			precision highp int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform float roughness;
			uniform float mipInt;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			#define PI 3.14159265359

			// Van der Corput radical inverse
			float radicalInverse_VdC(uint bits) {
				bits = (bits << 16u) | (bits >> 16u);
				bits = ((bits & 0x55555555u) << 1u) | ((bits & 0xAAAAAAAAu) >> 1u);
				bits = ((bits & 0x33333333u) << 2u) | ((bits & 0xCCCCCCCCu) >> 2u);
				bits = ((bits & 0x0F0F0F0Fu) << 4u) | ((bits & 0xF0F0F0F0u) >> 4u);
				bits = ((bits & 0x00FF00FFu) << 8u) | ((bits & 0xFF00FF00u) >> 8u);
				return float(bits) * 2.3283064365386963e-10; // / 0x100000000
			}

			// Hammersley sequence
			vec2 hammersley(uint i, uint N) {
				return vec2(float(i) / float(N), radicalInverse_VdC(i));
			}

			// GGX VNDF importance sampling (Eric Heitz 2018)
			// "Sampling the GGX Distribution of Visible Normals"
			// https://jcgt.org/published/0007/04/01/
			vec3 importanceSampleGGX_VNDF(vec2 Xi, vec3 V, float roughness) {
				float alpha = roughness * roughness;

				// Section 3.2: Transform view direction to hemisphere configuration
				vec3 Vh = normalize(vec3(alpha * V.x, alpha * V.y, V.z));

				// Section 4.1: Orthonormal basis
				float lensq = Vh.x * Vh.x + Vh.y * Vh.y;
				vec3 T1 = lensq > 0.0 ? vec3(-Vh.y, Vh.x, 0.0) / sqrt(lensq) : vec3(1.0, 0.0, 0.0);
				vec3 T2 = cross(Vh, T1);

				// Section 4.2: Parameterization of projected area
				float r = sqrt(Xi.x);
				float phi = 2.0 * PI * Xi.y;
				float t1 = r * cos(phi);
				float t2 = r * sin(phi);
				float s = 0.5 * (1.0 + Vh.z);
				t2 = (1.0 - s) * sqrt(1.0 - t1 * t1) + s * t2;

				// Section 4.3: Reprojection onto hemisphere
				vec3 Nh = t1 * T1 + t2 * T2 + sqrt(max(0.0, 1.0 - t1 * t1 - t2 * t2)) * Vh;

				// Section 3.4: Transform back to ellipsoid configuration
				return normalize(vec3(alpha * Nh.x, alpha * Nh.y, max(0.0, Nh.z)));
			}

			void main() {
				vec3 N = normalize(vOutputDirection);
				vec3 V = N; // Assume view direction equals normal for pre-filtering

				vec3 prefilteredColor = vec3(0.0);
				float totalWeight = 0.0;

				// For very low roughness, just sample the environment directly
				if (roughness < 0.001) {
					gl_FragColor = vec4(bilinearCubeUV(envMap, N, mipInt), 1.0);
					return;
				}

				// Tangent space basis for VNDF sampling
				vec3 up = abs(N.z) < 0.999 ? vec3(0.0, 0.0, 1.0) : vec3(1.0, 0.0, 0.0);
				vec3 tangent = normalize(cross(up, N));
				vec3 bitangent = cross(N, tangent);

				for(uint i = 0u; i < uint(GGX_SAMPLES); i++) {
					vec2 Xi = hammersley(i, uint(GGX_SAMPLES));

					// For PMREM, V = N, so in tangent space V is always (0, 0, 1)
					vec3 H_tangent = importanceSampleGGX_VNDF(Xi, vec3(0.0, 0.0, 1.0), roughness);

					// Transform H back to world space
					vec3 H = normalize(tangent * H_tangent.x + bitangent * H_tangent.y + N * H_tangent.z);
					vec3 L = normalize(2.0 * dot(V, H) * H - V);

					float NdotL = max(dot(N, L), 0.0);

					if(NdotL > 0.0) {
						// Sample environment at fixed mip level
						// VNDF importance sampling handles the distribution filtering
						vec3 sampleColor = bilinearCubeUV(envMap, L, mipInt);

						// Weight by NdotL for the split-sum approximation
						// VNDF PDF naturally accounts for the visible microfacet distribution
						prefilteredColor += sampleColor * NdotL;
						totalWeight += NdotL;
					}
				}

				if (totalWeight > 0.0) {
					prefilteredColor = prefilteredColor / totalWeight;
				}

				gl_FragColor = vec4(prefilteredColor, 1.0);
			}
		`,
        blending: (0, _threeCoreJs.NoBlending),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function _getBlurShader(lodMax, width, height) {
    const weights = new Float32Array(MAX_SAMPLES);
    const poleAxis = new (0, _threeCoreJs.Vector3)(0, 1, 0);
    const shaderMaterial = new (0, _threeCoreJs.ShaderMaterial)({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': MAX_SAMPLES,
            'CUBEUV_TEXEL_WIDTH': 1.0 / width,
            'CUBEUV_TEXEL_HEIGHT': 1.0 / height,
            'CUBEUV_MAX_MIP': `${lodMax}.0`
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            }
        },
        vertexShader: _getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

			}
		`,
        blending: (0, _threeCoreJs.NoBlending),
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function _getEquirectMaterial() {
    return new (0, _threeCoreJs.ShaderMaterial)({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            }
        },
        vertexShader: _getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;

			#include <common>

			void main() {

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				gl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );

			}
		`,
        blending: (0, _threeCoreJs.NoBlending),
        depthTest: false,
        depthWrite: false
    });
}
function _getCubemapMaterial() {
    return new (0, _threeCoreJs.ShaderMaterial)({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'flipEnvMap': {
                value: -1
            }
        },
        vertexShader: _getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			uniform float flipEnvMap;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			void main() {

				gl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );

			}
		`,
        blending: (0, _threeCoreJs.NoBlending),
        depthTest: false,
        depthWrite: false
    });
}
function _getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function WebGLCubeUVMaps(renderer) {
    let cubeUVmaps = new WeakMap();
    let pmremGenerator = null;
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            const isEquirectMap = mapping === (0, _threeCoreJs.EquirectangularReflectionMapping) || mapping === (0, _threeCoreJs.EquirectangularRefractionMapping);
            const isCubeMap = mapping === (0, _threeCoreJs.CubeReflectionMapping) || mapping === (0, _threeCoreJs.CubeRefractionMapping);
            // equirect/cube map to cubeUV conversion
            if (isEquirectMap || isCubeMap) {
                let renderTarget = cubeUVmaps.get(texture);
                const currentPMREMVersion = renderTarget !== undefined ? renderTarget.texture.pmremVersion : 0;
                if (texture.isRenderTargetTexture && texture.pmremVersion !== currentPMREMVersion) {
                    if (pmremGenerator === null) pmremGenerator = new PMREMGenerator(renderer);
                    renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture, renderTarget) : pmremGenerator.fromCubemap(texture, renderTarget);
                    renderTarget.texture.pmremVersion = texture.pmremVersion;
                    cubeUVmaps.set(texture, renderTarget);
                    return renderTarget.texture;
                } else {
                    if (renderTarget !== undefined) return renderTarget.texture;
                    else {
                        const image = texture.image;
                        if (isEquirectMap && image && image.height > 0 || isCubeMap && image && isCubeTextureComplete(image)) {
                            if (pmremGenerator === null) pmremGenerator = new PMREMGenerator(renderer);
                            renderTarget = isEquirectMap ? pmremGenerator.fromEquirectangular(texture) : pmremGenerator.fromCubemap(texture);
                            renderTarget.texture.pmremVersion = texture.pmremVersion;
                            cubeUVmaps.set(texture, renderTarget);
                            texture.addEventListener('dispose', onTextureDispose);
                            return renderTarget.texture;
                        } else // image not yet ready. try the conversion next frame
                        return null;
                    }
                }
            }
        }
        return texture;
    }
    function isCubeTextureComplete(image) {
        let count = 0;
        const length = 6;
        for(let i = 0; i < length; i++)if (image[i] !== undefined) count++;
        return count === length;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemapUV = cubeUVmaps.get(texture);
        if (cubemapUV !== undefined) {
            cubeUVmaps.delete(texture);
            cubemapUV.dispose();
        }
    }
    function dispose() {
        cubeUVmaps = new WeakMap();
        if (pmremGenerator !== null) {
            pmremGenerator.dispose();
            pmremGenerator = null;
        }
    }
    return {
        get: get,
        dispose: dispose
    };
}
function WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        const extension = gl.getExtension(name);
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function() {
            getExtension('EXT_color_buffer_float');
            getExtension('WEBGL_clip_cull_distance');
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
            getExtension('WEBGL_multisampled_render_to_texture');
            getExtension('WEBGL_render_shared_exponent');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) (0, _threeCoreJs.warnOnce)('WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], gl.ARRAY_BUFFER);
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else if (geometryPosition !== undefined) {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        } else return;
        const attribute = new ((0, _threeCoreJs.arrayNeedsUint32)(indices) ? (0, _threeCoreJs.Uint32BufferAttribute) : (0, _threeCoreJs.Uint16BufferAttribute))(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function WebGLIndexedBufferRenderer(gl, extensions, info) {
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        gl.drawElementsInstanced(mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    function renderMultiDraw(starts, counts, drawCount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        extension.multiDrawElementsWEBGL(mode, counts, 0, type, starts, 0, drawCount);
        let elementCount = 0;
        for(let i = 0; i < drawCount; i++)elementCount += counts[i];
        info.update(elementCount, mode, 1);
    }
    function renderMultiDrawInstances(starts, counts, drawCount, primcount) {
        if (drawCount === 0) return;
        const extension = extensions.get('WEBGL_multi_draw');
        if (extension === null) for(let i = 0; i < starts.length; i++)renderInstances(starts[i] / bytesPerElement, counts[i], primcount[i]);
        else {
            extension.multiDrawElementsInstancedWEBGL(mode, counts, 0, type, starts, 0, primcount, 0, drawCount);
            let elementCount = 0;
            for(let i = 0; i < drawCount; i++)elementCount += counts[i] * primcount[i];
            info.update(elementCount, mode, 1);
        }
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
    this.renderMultiDraw = renderMultiDraw;
    this.renderMultiDrawInstances = renderMultiDrawInstances;
}
function WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case gl.TRIANGLES:
                render.triangles += instanceCount * (count / 3);
                break;
            case gl.LINES:
                render.lines += instanceCount * (count / 2);
                break;
            case gl.LINE_STRIP:
                render.lines += instanceCount * (count - 1);
                break;
            case gl.LINE_LOOP:
                render.lines += instanceCount * count;
                break;
            case gl.POINTS:
                render.points += instanceCount * count;
                break;
            default:
                (0, _threeCoreJs.error)('WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function WebGLMorphtargets(gl, capabilities, textures) {
    const morphTextures = new WeakMap();
    const morph = new (0, _threeCoreJs.Vector4)();
    function update(object, geometry, program) {
        const objectInfluences = object.morphTargetInfluences;
        // the following encodes morph targets into an array of data textures. Each layer represents a single morph target.
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let entry = morphTextures.get(geometry);
        if (entry === undefined || entry.count !== morphTargetsCount) {
            if (entry !== undefined) entry.texture.dispose();
            const hasMorphPosition = geometry.morphAttributes.position !== undefined;
            const hasMorphNormals = geometry.morphAttributes.normal !== undefined;
            const hasMorphColors = geometry.morphAttributes.color !== undefined;
            const morphTargets = geometry.morphAttributes.position || [];
            const morphNormals = geometry.morphAttributes.normal || [];
            const morphColors = geometry.morphAttributes.color || [];
            let vertexDataCount = 0;
            if (hasMorphPosition === true) vertexDataCount = 1;
            if (hasMorphNormals === true) vertexDataCount = 2;
            if (hasMorphColors === true) vertexDataCount = 3;
            let width = geometry.attributes.position.count * vertexDataCount;
            let height = 1;
            if (width > capabilities.maxTextureSize) {
                height = Math.ceil(width / capabilities.maxTextureSize);
                width = capabilities.maxTextureSize;
            }
            const buffer = new Float32Array(width * height * 4 * morphTargetsCount);
            const texture = new (0, _threeCoreJs.DataArrayTexture)(buffer, width, height, morphTargetsCount);
            texture.type = (0, _threeCoreJs.FloatType);
            texture.needsUpdate = true;
            // fill buffer
            const vertexDataStride = vertexDataCount * 4;
            for(let i = 0; i < morphTargetsCount; i++){
                const morphTarget = morphTargets[i];
                const morphNormal = morphNormals[i];
                const morphColor = morphColors[i];
                const offset = width * height * 4 * i;
                for(let j = 0; j < morphTarget.count; j++){
                    const stride = j * vertexDataStride;
                    if (hasMorphPosition === true) {
                        morph.fromBufferAttribute(morphTarget, j);
                        buffer[offset + stride + 0] = morph.x;
                        buffer[offset + stride + 1] = morph.y;
                        buffer[offset + stride + 2] = morph.z;
                        buffer[offset + stride + 3] = 0;
                    }
                    if (hasMorphNormals === true) {
                        morph.fromBufferAttribute(morphNormal, j);
                        buffer[offset + stride + 4] = morph.x;
                        buffer[offset + stride + 5] = morph.y;
                        buffer[offset + stride + 6] = morph.z;
                        buffer[offset + stride + 7] = 0;
                    }
                    if (hasMorphColors === true) {
                        morph.fromBufferAttribute(morphColor, j);
                        buffer[offset + stride + 8] = morph.x;
                        buffer[offset + stride + 9] = morph.y;
                        buffer[offset + stride + 10] = morph.z;
                        buffer[offset + stride + 11] = morphColor.itemSize === 4 ? morph.w : 1;
                    }
                }
            }
            entry = {
                count: morphTargetsCount,
                texture: texture,
                size: new (0, _threeCoreJs.Vector2)(width, height)
            };
            morphTextures.set(geometry, entry);
            function disposeTexture() {
                texture.dispose();
                morphTextures.delete(geometry);
                geometry.removeEventListener('dispose', disposeTexture);
            }
            geometry.addEventListener('dispose', disposeTexture);
        }
        //
        if (object.isInstancedMesh === true && object.morphTexture !== null) program.getUniforms().setValue(gl, 'morphTexture', object.morphTexture, textures);
        else {
            let morphInfluencesSum = 0;
            for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
            const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
            program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
            program.getUniforms().setValue(gl, 'morphTargetInfluences', objectInfluences);
        }
        program.getUniforms().setValue(gl, 'morphTargetsTexture', entry.texture, textures);
        program.getUniforms().setValue(gl, 'morphTargetsTextureSize', entry.size);
    }
    return {
        update: update
    };
}
function WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            if (updateMap.get(object) !== frame) {
                attributes.update(object.instanceMatrix, gl.ARRAY_BUFFER);
                if (object.instanceColor !== null) attributes.update(object.instanceColor, gl.ARRAY_BUFFER);
                updateMap.set(object, frame);
            }
        }
        if (object.isSkinnedMesh) {
            const skeleton = object.skeleton;
            if (updateMap.get(skeleton) !== frame) {
                skeleton.update();
                updateMap.set(skeleton, frame);
            }
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
const toneMappingMap = {
    [(0, _threeCoreJs.LinearToneMapping)]: 'LINEAR_TONE_MAPPING',
    [(0, _threeCoreJs.ReinhardToneMapping)]: 'REINHARD_TONE_MAPPING',
    [(0, _threeCoreJs.CineonToneMapping)]: 'CINEON_TONE_MAPPING',
    [(0, _threeCoreJs.ACESFilmicToneMapping)]: 'ACES_FILMIC_TONE_MAPPING',
    [(0, _threeCoreJs.AgXToneMapping)]: 'AGX_TONE_MAPPING',
    [(0, _threeCoreJs.NeutralToneMapping)]: 'NEUTRAL_TONE_MAPPING',
    [(0, _threeCoreJs.CustomToneMapping)]: 'CUSTOM_TONE_MAPPING'
};
function WebGLOutput(type, width, height, depth, stencil) {
    // render targets for scene and post-processing
    const targetA = new (0, _threeCoreJs.WebGLRenderTarget)(width, height, {
        type: type,
        depthBuffer: depth,
        stencilBuffer: stencil
    });
    const targetB = new (0, _threeCoreJs.WebGLRenderTarget)(width, height, {
        type: (0, _threeCoreJs.HalfFloatType),
        depthBuffer: false,
        stencilBuffer: false
    });
    // create fullscreen triangle geometry
    const geometry = new (0, _threeCoreJs.BufferGeometry)();
    geometry.setAttribute('position', new (0, _threeCoreJs.Float32BufferAttribute)([
        -1,
        3,
        0,
        -1,
        -1,
        0,
        3,
        -1,
        0
    ], 3));
    geometry.setAttribute('uv', new (0, _threeCoreJs.Float32BufferAttribute)([
        0,
        2,
        0,
        0,
        2,
        0
    ], 2));
    // create output material with tone mapping support
    const material = new (0, _threeCoreJs.RawShaderMaterial)({
        uniforms: {
            tDiffuse: {
                value: null
            }
        },
        vertexShader: /* glsl */ `
			precision highp float;

			uniform mat4 modelViewMatrix;
			uniform mat4 projectionMatrix;

			attribute vec3 position;
			attribute vec2 uv;

			varying vec2 vUv;

			void main() {
				vUv = uv;
				gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );
			}`,
        fragmentShader: /* glsl */ `
			precision highp float;

			uniform sampler2D tDiffuse;

			varying vec2 vUv;

			#include <tonemapping_pars_fragment>
			#include <colorspace_pars_fragment>

			void main() {
				gl_FragColor = texture2D( tDiffuse, vUv );

				#ifdef LINEAR_TONE_MAPPING
					gl_FragColor.rgb = LinearToneMapping( gl_FragColor.rgb );
				#elif defined( REINHARD_TONE_MAPPING )
					gl_FragColor.rgb = ReinhardToneMapping( gl_FragColor.rgb );
				#elif defined( CINEON_TONE_MAPPING )
					gl_FragColor.rgb = CineonToneMapping( gl_FragColor.rgb );
				#elif defined( ACES_FILMIC_TONE_MAPPING )
					gl_FragColor.rgb = ACESFilmicToneMapping( gl_FragColor.rgb );
				#elif defined( AGX_TONE_MAPPING )
					gl_FragColor.rgb = AgXToneMapping( gl_FragColor.rgb );
				#elif defined( NEUTRAL_TONE_MAPPING )
					gl_FragColor.rgb = NeutralToneMapping( gl_FragColor.rgb );
				#elif defined( CUSTOM_TONE_MAPPING )
					gl_FragColor.rgb = CustomToneMapping( gl_FragColor.rgb );
				#endif

				#ifdef SRGB_TRANSFER
					gl_FragColor = sRGBTransferOETF( gl_FragColor );
				#endif
			}`,
        depthTest: false,
        depthWrite: false
    });
    const mesh = new (0, _threeCoreJs.Mesh)(geometry, material);
    const camera = new (0, _threeCoreJs.OrthographicCamera)(-1, 1, 1, -1, 0, 1);
    let _outputColorSpace = null;
    let _outputToneMapping = null;
    let _isCompositing = false;
    let _savedToneMapping;
    let _savedRenderTarget = null;
    let _effects = [];
    let _hasRenderPass = false;
    this.setSize = function(width, height) {
        targetA.setSize(width, height);
        targetB.setSize(width, height);
        for(let i = 0; i < _effects.length; i++){
            const effect = _effects[i];
            if (effect.setSize) effect.setSize(width, height);
        }
    };
    this.setEffects = function(effects) {
        _effects = effects;
        _hasRenderPass = _effects.length > 0 && _effects[0].isRenderPass === true;
        const width = targetA.width;
        const height = targetA.height;
        for(let i = 0; i < _effects.length; i++){
            const effect = _effects[i];
            if (effect.setSize) effect.setSize(width, height);
        }
    };
    this.begin = function(renderer, renderTarget) {
        // Don't begin during compositing phase (post-processing effects call render())
        if (_isCompositing) return false;
        if (renderer.toneMapping === (0, _threeCoreJs.NoToneMapping) && _effects.length === 0) return false;
        _savedRenderTarget = renderTarget;
        // resize internal buffers to match render target (e.g. XR resolution)
        if (renderTarget !== null) {
            const width = renderTarget.width;
            const height = renderTarget.height;
            if (targetA.width !== width || targetA.height !== height) this.setSize(width, height);
        }
        // if first effect is a RenderPass, it will set its own render target
        if (_hasRenderPass === false) renderer.setRenderTarget(targetA);
        // disable tone mapping during render - it will be applied in end()
        _savedToneMapping = renderer.toneMapping;
        renderer.toneMapping = (0, _threeCoreJs.NoToneMapping);
        return true;
    };
    this.hasRenderPass = function() {
        return _hasRenderPass;
    };
    this.end = function(renderer, deltaTime) {
        // restore tone mapping
        renderer.toneMapping = _savedToneMapping;
        _isCompositing = true;
        // run post-processing effects
        let readBuffer = targetA;
        let writeBuffer = targetB;
        for(let i = 0; i < _effects.length; i++){
            const effect = _effects[i];
            if (effect.enabled === false) continue;
            effect.render(renderer, writeBuffer, readBuffer, deltaTime);
            if (effect.needsSwap !== false) {
                const temp = readBuffer;
                readBuffer = writeBuffer;
                writeBuffer = temp;
            }
        }
        // update output material defines if settings changed
        if (_outputColorSpace !== renderer.outputColorSpace || _outputToneMapping !== renderer.toneMapping) {
            _outputColorSpace = renderer.outputColorSpace;
            _outputToneMapping = renderer.toneMapping;
            material.defines = {};
            if ((0, _threeCoreJs.ColorManagement).getTransfer(_outputColorSpace) === (0, _threeCoreJs.SRGBTransfer)) material.defines.SRGB_TRANSFER = '';
            const toneMapping = toneMappingMap[_outputToneMapping];
            if (toneMapping) material.defines[toneMapping] = '';
            material.needsUpdate = true;
        }
        // final output to canvas (or XR render target)
        material.uniforms.tDiffuse.value = readBuffer.texture;
        renderer.setRenderTarget(_savedRenderTarget);
        renderer.render(mesh, camera);
        _savedRenderTarget = null;
        _isCompositing = false;
    };
    this.isCompositing = function() {
        return _isCompositing;
    };
    this.dispose = function() {
        targetA.dispose();
        targetB.dispose();
        geometry.dispose();
        material.dispose();
    };
}
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const emptyTexture = /*@__PURE__*/ new (0, _threeCoreJs.Texture)();
const emptyShadowTexture = /*@__PURE__*/ new (0, _threeCoreJs.DepthTexture)(1, 1);
const emptyArrayTexture = /*@__PURE__*/ new (0, _threeCoreJs.DataArrayTexture)();
const empty3dTexture = /*@__PURE__*/ new (0, _threeCoreJs.Data3DTexture)();
const emptyCubeTexture = /*@__PURE__*/ new (0, _threeCoreJs.CubeTexture)();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const arrayCacheF32 = [];
const arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const mat4array = new Float32Array(16);
const mat3array = new Float32Array(9);
const mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function allocTexUnits(textures, n) {
    let r = arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        copyArray(cache, v);
    }
}
function setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        copyArray(cache, v);
    }
}
function setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        copyArray(cache, v);
    }
}
// Single matrix (from flat array or THREE.MatrixN)
function setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if (arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        copyArray(cache, v);
    } else {
        if (arraysEqual(cache, elements)) return;
        mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, mat2array);
        copyArray(cache, elements);
    }
}
function setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if (arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        copyArray(cache, v);
    } else {
        if (arraysEqual(cache, elements)) return;
        mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, mat3array);
        copyArray(cache, elements);
    }
}
function setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if (arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        copyArray(cache, v);
    } else {
        if (arraysEqual(cache, elements)) return;
        mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, mat4array);
        copyArray(cache, elements);
    }
}
// Single integer / boolean
function setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
// Single integer / boolean vector (from flat array or THREE.VectorN)
function setValueV2i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2i(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform2iv(this.addr, v);
        copyArray(cache, v);
    }
}
function setValueV3i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3i(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform3iv(this.addr, v);
        copyArray(cache, v);
    }
}
function setValueV4i(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4i(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform4iv(this.addr, v);
        copyArray(cache, v);
    }
}
// Single unsigned integer
function setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Single unsigned integer vector (from flat array or THREE.VectorN)
function setValueV2ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2ui(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform2uiv(this.addr, v);
        copyArray(cache, v);
    }
}
function setValueV3ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3ui(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform3uiv(this.addr, v);
        copyArray(cache, v);
    }
}
function setValueV4ui(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4ui(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform4uiv(this.addr, v);
        copyArray(cache, v);
    }
}
// Single texture (2D / Cube)
function setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) {
        emptyShadowTexture.compareFunction = textures.isReversedDepthBuffer() ? (0, _threeCoreJs.GreaterEqualCompare) : (0, _threeCoreJs.LessEqualCompare);
        emptyTexture2D = emptyShadowTexture;
    } else emptyTexture2D = emptyTexture;
    textures.setTexture2D(v || emptyTexture2D, unit);
}
function setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || empty3dTexture, unit);
}
function setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTextureCube(v || emptyCubeTexture, unit);
}
function setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || emptyArrayTexture, unit);
}
// Helper to pick the right setter for the singular case
function getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return setValueV1f; // FLOAT
        case 0x8b50:
            return setValueV2f; // _VEC2
        case 0x8b51:
            return setValueV3f; // _VEC3
        case 0x8b52:
            return setValueV4f; // _VEC4
        case 0x8b5a:
            return setValueM2; // _MAT2
        case 0x8b5b:
            return setValueM3; // _MAT3
        case 0x8b5c:
            return setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return setValueV4i; // _VEC4
        case 0x1405:
            return setValueV1ui; // UINT
        case 0x8dc6:
            return setValueV2ui; // _VEC2
        case 0x8dc7:
            return setValueV3ui; // _VEC3
        case 0x8dc8:
            return setValueV4ui; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return setValueT2DArray1;
    }
}
// Array of scalars
function setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Array of vectors (from flat array or array of THREE.VectorN)
function setValueV2fArray(gl, v) {
    const data = flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function setValueV3fArray(gl, v) {
    const data = flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function setValueV4fArray(gl, v) {
    const data = flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (from flat array or array of THREE.MatrixN)
function setValueM2Array(gl, v) {
    const data = flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function setValueM3Array(gl, v) {
    const data = flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function setValueM4Array(gl, v) {
    const data = flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of integer / boolean
function setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
// Array of integer / boolean vectors (from flat array)
function setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of unsigned integer
function setValueV1uiArray(gl, v) {
    gl.uniform1uiv(this.addr, v);
}
// Array of unsigned integer vectors (from flat array)
function setValueV2uiArray(gl, v) {
    gl.uniform2uiv(this.addr, v);
}
function setValueV3uiArray(gl, v) {
    gl.uniform3uiv(this.addr, v);
}
function setValueV4uiArray(gl, v) {
    gl.uniform4uiv(this.addr, v);
}
// Array of textures (2D / 3D / Cube / 2DArray)
function setValueT1Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = allocTexUnits(textures, n);
    if (!arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        copyArray(cache, units);
    }
    let emptyTexture2D;
    if (this.type === gl.SAMPLER_2D_SHADOW) emptyTexture2D = emptyShadowTexture;
    else emptyTexture2D = emptyTexture;
    for(let i = 0; i !== n; ++i)textures.setTexture2D(v[i] || emptyTexture2D, units[i]);
}
function setValueT3DArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = allocTexUnits(textures, n);
    if (!arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture3D(v[i] || empty3dTexture, units[i]);
}
function setValueT6Array(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = allocTexUnits(textures, n);
    if (!arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTextureCube(v[i] || emptyCubeTexture, units[i]);
}
function setValueT2DArrayArray(gl, v, textures) {
    const cache = this.cache;
    const n = v.length;
    const units = allocTexUnits(textures, n);
    if (!arraysEqual(cache, units)) {
        gl.uniform1iv(this.addr, units);
        copyArray(cache, units);
    }
    for(let i = 0; i !== n; ++i)textures.setTexture2DArray(v[i] || emptyArrayTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return setValueV1fArray; // FLOAT
        case 0x8b50:
            return setValueV2fArray; // _VEC2
        case 0x8b51:
            return setValueV3fArray; // _VEC3
        case 0x8b52:
            return setValueV4fArray; // _VEC4
        case 0x8b5a:
            return setValueM2Array; // _MAT2
        case 0x8b5b:
            return setValueM3Array; // _MAT3
        case 0x8b5c:
            return setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return setValueV4iArray; // _VEC4
        case 0x1405:
            return setValueV1uiArray; // UINT
        case 0x8dc6:
            return setValueV2uiArray; // _VEC2
        case 0x8dc7:
            return setValueV3uiArray; // _VEC3
        case 0x8dc8:
            return setValueV4uiArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return setValueT1Array;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return setValueT3DArray;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return setValueT6Array;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return setValueT2DArrayArray;
    }
}
// --- Uniform Classes ---
class SingleUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.setValue = getSingularSetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class PureArrayUniform {
    constructor(id, activeInfo, addr){
        this.id = id;
        this.addr = addr;
        this.cache = [];
        this.type = activeInfo.type;
        this.size = activeInfo.size;
        this.setValue = getPureArraySetter(activeInfo.type);
    // this.path = activeInfo.name; // DEBUG
    }
}
class StructuredUniform {
    constructor(id){
        this.id = id;
        this.seq = [];
        this.map = {};
    }
    setValue(gl, value, textures) {
        const seq = this.seq;
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            u.setValue(gl, value[u.id], textures);
        }
    }
}
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    RePathPart.lastIndex = 0;
    while(true){
        const match = RePathPart.exec(path), matchEnd = RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            addUniform(container, subscript === undefined ? new SingleUniform(id, activeInfo, addr) : new PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new StructuredUniform(id);
                addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
class WebGLUniforms {
    constructor(gl, program){
        this.seq = [];
        this.map = {};
        const n = gl.getProgramParameter(program, gl.ACTIVE_UNIFORMS);
        for(let i = 0; i < n; ++i){
            const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
            parseUniform(info, addr, this);
        }
        // Sort uniforms to prioritize shadow samplers first (for optimal texture unit allocation)
        const shadowSamplers = [];
        const otherUniforms = [];
        for (const u of this.seq)if (u.type === gl.SAMPLER_2D_SHADOW || u.type === gl.SAMPLER_CUBE_SHADOW || u.type === gl.SAMPLER_2D_ARRAY_SHADOW) shadowSamplers.push(u);
        else otherUniforms.push(u);
        if (shadowSamplers.length > 0) this.seq = shadowSamplers.concat(otherUniforms);
    }
    setValue(gl, name, value, textures) {
        const u = this.map[name];
        if (u !== undefined) u.setValue(gl, value, textures);
    }
    setOptional(gl, object, name) {
        const v = object[name];
        if (v !== undefined) this.setValue(gl, name, v);
    }
    static upload(gl, seq, values, textures) {
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i], v = values[u.id];
            if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
            u.setValue(gl, v.value, textures);
        }
    }
    static seqWithValue(seq, values) {
        const r = [];
        for(let i = 0, n = seq.length; i !== n; ++i){
            const u = seq[i];
            if (u.id in values) r.push(u);
        }
        return r;
    }
}
function WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
// From https://www.khronos.org/registry/webgl/extensions/KHR_parallel_shader_compile/
const COMPLETION_STATUS_KHR = 0x91B1;
let programIdCount = 0;
function handleSource(string, errorLine) {
    const lines = string.split('\n');
    const lines2 = [];
    const from = Math.max(errorLine - 6, 0);
    const to = Math.min(errorLine + 6, lines.length);
    for(let i = from; i < to; i++){
        const line = i + 1;
        lines2.push(`${line === errorLine ? '>' : ' '} ${line}: ${lines[i]}`);
    }
    return lines2.join('\n');
}
const _m0 = /*@__PURE__*/ new (0, _threeCoreJs.Matrix3)();
function getEncodingComponents(colorSpace) {
    (0, _threeCoreJs.ColorManagement)._getMatrix(_m0, (0, _threeCoreJs.ColorManagement).workingColorSpace, colorSpace);
    const encodingMatrix = `mat3( ${_m0.elements.map((v)=>v.toFixed(4))} )`;
    switch((0, _threeCoreJs.ColorManagement).getTransfer(colorSpace)){
        case 0, _threeCoreJs.LinearTransfer:
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
        case 0, _threeCoreJs.SRGBTransfer:
            return [
                encodingMatrix,
                'sRGBTransferOETF'
            ];
        default:
            (0, _threeCoreJs.warn)('WebGLProgram: Unsupported color space: ', colorSpace);
            return [
                encodingMatrix,
                'LinearTransferOETF'
            ];
    }
}
function getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, gl.COMPILE_STATUS);
    const shaderInfoLog = gl.getShaderInfoLog(shader) || '';
    const errors = shaderInfoLog.trim();
    if (status && errors === '') return '';
    const errorMatches = /ERROR: 0:(\d+)/.exec(errors);
    if (errorMatches) {
        // --enable-privileged-webgl-extension
        // log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
        const errorLine = parseInt(errorMatches[1]);
        return type.toUpperCase() + '\n\n' + errors + '\n\n' + handleSource(gl.getShaderSource(shader), errorLine);
    } else return errors;
}
function getTexelEncodingFunction(functionName, colorSpace) {
    const components = getEncodingComponents(colorSpace);
    return [
        `vec4 ${functionName}( vec4 value ) {`,
        `	return ${components[1]}( vec4( value.rgb * ${components[0]}, value.a ) );`,
        '}'
    ].join('\n');
}
const toneMappingFunctions = {
    [(0, _threeCoreJs.LinearToneMapping)]: 'Linear',
    [(0, _threeCoreJs.ReinhardToneMapping)]: 'Reinhard',
    [(0, _threeCoreJs.CineonToneMapping)]: 'Cineon',
    [(0, _threeCoreJs.ACESFilmicToneMapping)]: 'ACESFilmic',
    [(0, _threeCoreJs.AgXToneMapping)]: 'AgX',
    [(0, _threeCoreJs.NeutralToneMapping)]: 'Neutral',
    [(0, _threeCoreJs.CustomToneMapping)]: 'Custom'
};
function getToneMappingFunction(functionName, toneMapping) {
    const toneMappingName = toneMappingFunctions[toneMapping];
    if (toneMappingName === undefined) {
        (0, _threeCoreJs.warn)('WebGLProgram: Unsupported toneMapping:', toneMapping);
        return 'vec3 ' + functionName + '( vec3 color ) { return LinearToneMapping( color ); }';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
const _v0 = /*@__PURE__*/ new (0, _threeCoreJs.Vector3)();
function getLuminanceFunction() {
    (0, _threeCoreJs.ColorManagement).getLuminanceCoefficients(_v0);
    const r = _v0.x.toFixed(4);
    const g = _v0.y.toFixed(4);
    const b = _v0.z.toFixed(4);
    return [
        'float luminance( const in vec3 rgb ) {',
        `	const vec3 weights = vec3( ${r}, ${g}, ${b} );`,
        '	return dot( weights, rgb );',
        '}'
    ].join('\n');
}
function generateVertexExtensions(parameters) {
    const chunks = [
        parameters.extensionClipCullDistance ? '#extension GL_ANGLE_clip_cull_distance : require' : '',
        parameters.extensionMultiDraw ? '#extension GL_ANGLE_multi_draw : require' : ''
    ];
    return chunks.filter(filterEmptyLine).join('\n');
}
function generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, gl.ACTIVE_ATTRIBUTES);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        let locationSize = 1;
        if (info.type === gl.FLOAT_MAT2) locationSize = 2;
        if (info.type === gl.FLOAT_MAT3) locationSize = 3;
        if (info.type === gl.FLOAT_MAT4) locationSize = 4;
        // log( 'WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = {
            type: info.type,
            location: gl.getAttribLocation(program, name),
            locationSize: locationSize
        };
    }
    return attributes;
}
function filterEmptyLine(string) {
    return string !== '';
}
function replaceLightNums(string, parameters) {
    const numSpotLightCoords = parameters.numSpotLightShadows + parameters.numSpotLightMaps - parameters.numSpotLightShadowsWithMaps;
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, parameters.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, numSpotLightCoords).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, parameters.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function resolveIncludes(string) {
    return string.replace(includePattern, includeReplacer);
}
const shaderChunkMap = new Map();
function includeReplacer(match, include) {
    let string = ShaderChunk[include];
    if (string === undefined) {
        const newInclude = shaderChunkMap.get(include);
        if (newInclude !== undefined) {
            string = ShaderChunk[newInclude];
            (0, _threeCoreJs.warn)('WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', include, newInclude);
        } else throw new Error('Can not resolve #include <' + include + '>');
    }
    return resolveIncludes(string);
}
// Unroll Loops
const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function unrollLoops(string) {
    return string.replace(unrollLoopPattern, loopReplacer);
}
function loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function generatePrecision(parameters) {
    let precisionstring = `precision ${parameters.precision} float;
	precision ${parameters.precision} int;
	precision ${parameters.precision} sampler2D;
	precision ${parameters.precision} samplerCube;
	precision ${parameters.precision} sampler3D;
	precision ${parameters.precision} sampler2DArray;
	precision ${parameters.precision} sampler2DShadow;
	precision ${parameters.precision} samplerCubeShadow;
	precision ${parameters.precision} sampler2DArrayShadow;
	precision ${parameters.precision} isampler2D;
	precision ${parameters.precision} isampler3D;
	precision ${parameters.precision} isamplerCube;
	precision ${parameters.precision} isampler2DArray;
	precision ${parameters.precision} usampler2D;
	precision ${parameters.precision} usampler3D;
	precision ${parameters.precision} usamplerCube;
	precision ${parameters.precision} usampler2DArray;
	`;
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
const shadowMapTypeDefines = {
    [(0, _threeCoreJs.PCFShadowMap)]: 'SHADOWMAP_TYPE_PCF',
    [(0, _threeCoreJs.VSMShadowMap)]: 'SHADOWMAP_TYPE_VSM'
};
function generateShadowMapTypeDefine(parameters) {
    return shadowMapTypeDefines[parameters.shadowMapType] || 'SHADOWMAP_TYPE_BASIC';
}
const envMapTypeDefines = {
    [(0, _threeCoreJs.CubeReflectionMapping)]: 'ENVMAP_TYPE_CUBE',
    [(0, _threeCoreJs.CubeRefractionMapping)]: 'ENVMAP_TYPE_CUBE',
    [(0, _threeCoreJs.CubeUVReflectionMapping)]: 'ENVMAP_TYPE_CUBE_UV'
};
function generateEnvMapTypeDefine(parameters) {
    if (parameters.envMap === false) return 'ENVMAP_TYPE_CUBE';
    return envMapTypeDefines[parameters.envMapMode] || 'ENVMAP_TYPE_CUBE';
}
const envMapModeDefines = {
    [(0, _threeCoreJs.CubeRefractionMapping)]: 'ENVMAP_MODE_REFRACTION'
};
function generateEnvMapModeDefine(parameters) {
    if (parameters.envMap === false) return 'ENVMAP_MODE_REFLECTION';
    return envMapModeDefines[parameters.envMapMode] || 'ENVMAP_MODE_REFLECTION';
}
const envMapBlendingDefines = {
    [(0, _threeCoreJs.MultiplyOperation)]: 'ENVMAP_BLENDING_MULTIPLY',
    [(0, _threeCoreJs.MixOperation)]: 'ENVMAP_BLENDING_MIX',
    [(0, _threeCoreJs.AddOperation)]: 'ENVMAP_BLENDING_ADD'
};
function generateEnvMapBlendingDefine(parameters) {
    if (parameters.envMap === false) return 'ENVMAP_BLENDING_NONE';
    return envMapBlendingDefines[parameters.combine] || 'ENVMAP_BLENDING_NONE';
}
function generateCubeUVSize(parameters) {
    const imageHeight = parameters.envMapCubeUVHeight;
    if (imageHeight === null) return null;
    const maxMip = Math.log2(imageHeight) - 2;
    const texelHeight = 1.0 / imageHeight;
    const texelWidth = 1.0 / (3 * Math.max(Math.pow(2, maxMip), 112));
    return {
        texelWidth,
        texelHeight,
        maxMip
    };
}
function WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    // TODO Send this event to Three.js DevTools
    // log( 'WebGLProgram', cacheKey );
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = generateEnvMapBlendingDefine(parameters);
    const envMapCubeUVSize = generateCubeUVSize(parameters);
    const customVertexExtensions = generateVertexExtensions(parameters);
    const customDefines = generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter(filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines
        ].filter(filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.extensionClipCullDistance ? '#define USE_CLIP_DISTANCE' : '',
            parameters.batching ? '#define USE_BATCHING' : '',
            parameters.batchingColor ? '#define USE_BATCHING_COLOR' : '',
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.instancingMorph ? '#define USE_INSTANCING_MORPH' : '',
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.displacementMap ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            //
            parameters.mapUv ? '#define MAP_UV ' + parameters.mapUv : '',
            parameters.alphaMapUv ? '#define ALPHAMAP_UV ' + parameters.alphaMapUv : '',
            parameters.lightMapUv ? '#define LIGHTMAP_UV ' + parameters.lightMapUv : '',
            parameters.aoMapUv ? '#define AOMAP_UV ' + parameters.aoMapUv : '',
            parameters.emissiveMapUv ? '#define EMISSIVEMAP_UV ' + parameters.emissiveMapUv : '',
            parameters.bumpMapUv ? '#define BUMPMAP_UV ' + parameters.bumpMapUv : '',
            parameters.normalMapUv ? '#define NORMALMAP_UV ' + parameters.normalMapUv : '',
            parameters.displacementMapUv ? '#define DISPLACEMENTMAP_UV ' + parameters.displacementMapUv : '',
            parameters.metalnessMapUv ? '#define METALNESSMAP_UV ' + parameters.metalnessMapUv : '',
            parameters.roughnessMapUv ? '#define ROUGHNESSMAP_UV ' + parameters.roughnessMapUv : '',
            parameters.anisotropyMapUv ? '#define ANISOTROPYMAP_UV ' + parameters.anisotropyMapUv : '',
            parameters.clearcoatMapUv ? '#define CLEARCOATMAP_UV ' + parameters.clearcoatMapUv : '',
            parameters.clearcoatNormalMapUv ? '#define CLEARCOAT_NORMALMAP_UV ' + parameters.clearcoatNormalMapUv : '',
            parameters.clearcoatRoughnessMapUv ? '#define CLEARCOAT_ROUGHNESSMAP_UV ' + parameters.clearcoatRoughnessMapUv : '',
            parameters.iridescenceMapUv ? '#define IRIDESCENCEMAP_UV ' + parameters.iridescenceMapUv : '',
            parameters.iridescenceThicknessMapUv ? '#define IRIDESCENCE_THICKNESSMAP_UV ' + parameters.iridescenceThicknessMapUv : '',
            parameters.sheenColorMapUv ? '#define SHEEN_COLORMAP_UV ' + parameters.sheenColorMapUv : '',
            parameters.sheenRoughnessMapUv ? '#define SHEEN_ROUGHNESSMAP_UV ' + parameters.sheenRoughnessMapUv : '',
            parameters.specularMapUv ? '#define SPECULARMAP_UV ' + parameters.specularMapUv : '',
            parameters.specularColorMapUv ? '#define SPECULAR_COLORMAP_UV ' + parameters.specularColorMapUv : '',
            parameters.specularIntensityMapUv ? '#define SPECULAR_INTENSITYMAP_UV ' + parameters.specularIntensityMapUv : '',
            parameters.transmissionMapUv ? '#define TRANSMISSIONMAP_UV ' + parameters.transmissionMapUv : '',
            parameters.thicknessMapUv ? '#define THICKNESSMAP_UV ' + parameters.thicknessMapUv : '',
            //
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.morphColors ? '#define USE_MORPHCOLORS' : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_TEXTURE_STRIDE ' + parameters.morphTextureStride : '',
            parameters.morphTargetsCount > 0 ? '#define MORPHTARGETS_COUNT ' + parameters.morphTargetsCount : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGARITHMIC_DEPTH_BUFFER' : '',
            parameters.reversedDepthBuffer ? '#define USE_REVERSED_DEPTH_BUFFER' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            '#ifdef USE_INSTANCING_MORPH',
            '	uniform sampler2D morphTexture;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_UV1',
            '	attribute vec2 uv1;',
            '#endif',
            '#ifdef USE_UV2',
            '	attribute vec2 uv2;',
            '#endif',
            '#ifdef USE_UV3',
            '	attribute vec2 uv3;',
            '#endif',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#if defined( USE_COLOR_ALPHA )',
            '	attribute vec4 color;',
            '#elif defined( USE_COLOR )',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter(filterEmptyLine).join('\n');
        prefixFragment = [
            generatePrecision(parameters),
            '#define SHADER_TYPE ' + parameters.shaderType,
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.alphaToCoverage ? '#define ALPHA_TO_COVERAGE' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_WIDTH ' + envMapCubeUVSize.texelWidth : '',
            envMapCubeUVSize ? '#define CUBEUV_TEXEL_HEIGHT ' + envMapCubeUVSize.texelHeight : '',
            envMapCubeUVSize ? '#define CUBEUV_MAX_MIP ' + envMapCubeUVSize.maxMip + '.0' : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMapObjectSpace ? '#define USE_NORMALMAP_OBJECTSPACE' : '',
            parameters.normalMapTangentSpace ? '#define USE_NORMALMAP_TANGENTSPACE' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.anisotropy ? '#define USE_ANISOTROPY' : '',
            parameters.anisotropyMap ? '#define USE_ANISOTROPYMAP' : '',
            parameters.clearcoat ? '#define USE_CLEARCOAT' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.dispersion ? '#define USE_DISPERSION' : '',
            parameters.iridescence ? '#define USE_IRIDESCENCE' : '',
            parameters.iridescenceMap ? '#define USE_IRIDESCENCEMAP' : '',
            parameters.iridescenceThicknessMap ? '#define USE_IRIDESCENCE_THICKNESSMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.specularColorMap ? '#define USE_SPECULAR_COLORMAP' : '',
            parameters.specularIntensityMap ? '#define USE_SPECULAR_INTENSITYMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.alphaTest ? '#define USE_ALPHATEST' : '',
            parameters.alphaHash ? '#define USE_ALPHAHASH' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.sheenColorMap ? '#define USE_SHEEN_COLORMAP' : '',
            parameters.sheenRoughnessMap ? '#define USE_SHEEN_ROUGHNESSMAP' : '',
            parameters.transmission ? '#define USE_TRANSMISSION' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.thicknessMap ? '#define USE_THICKNESSMAP' : '',
            parameters.vertexTangents && parameters.flatShading === false ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor || parameters.batchingColor ? '#define USE_COLOR' : '',
            parameters.vertexAlphas ? '#define USE_COLOR_ALPHA' : '',
            parameters.vertexUv1s ? '#define USE_UV1' : '',
            parameters.vertexUv2s ? '#define USE_UV2' : '',
            parameters.vertexUv3s ? '#define USE_UV3' : '',
            parameters.pointsUvs ? '#define USE_POINTS_UV' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.numLightProbes > 0 ? '#define USE_LIGHT_PROBES' : '',
            parameters.decodeVideoTexture ? '#define DECODE_VIDEO_TEXTURE' : '',
            parameters.decodeVideoTextureEmissive ? '#define DECODE_VIDEO_TEXTURE_EMISSIVE' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGARITHMIC_DEPTH_BUFFER' : '',
            parameters.reversedDepthBuffer ? '#define USE_REVERSED_DEPTH_BUFFER' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== (0, _threeCoreJs.NoToneMapping) ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== (0, _threeCoreJs.NoToneMapping) ? ShaderChunk['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== (0, _threeCoreJs.NoToneMapping) ? getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            parameters.opaque ? '#define OPAQUE' : '',
            ShaderChunk['colorspace_pars_fragment'],
            getTexelEncodingFunction('linearToOutputTexel', parameters.outputColorSpace),
            getLuminanceFunction(),
            parameters.useDepthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter(filterEmptyLine).join('\n');
    }
    vertexShader = resolveIncludes(vertexShader);
    vertexShader = replaceLightNums(vertexShader, parameters);
    vertexShader = replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = resolveIncludes(fragmentShader);
    fragmentShader = replaceLightNums(fragmentShader, parameters);
    fragmentShader = replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = unrollLoops(vertexShader);
    fragmentShader = unrollLoops(fragmentShader);
    if (parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            customVertexExtensions,
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === (0, _threeCoreJs.GLSL3) ? '' : 'layout(location = 0) out highp vec4 pc_fragColor;',
            parameters.glslVersion === (0, _threeCoreJs.GLSL3) ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // log( '*VERTEX*', vertexGlsl );
    // log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = WebGLShader(gl, gl.VERTEX_SHADER, vertexGlsl);
    const glFragmentShader = WebGLShader(gl, gl.FRAGMENT_SHADER, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    function onFirstUse(self1) {
        // check for link errors
        if (renderer.debug.checkShaderErrors) {
            const programInfoLog = gl.getProgramInfoLog(program) || '';
            const vertexShaderInfoLog = gl.getShaderInfoLog(glVertexShader) || '';
            const fragmentShaderInfoLog = gl.getShaderInfoLog(glFragmentShader) || '';
            const programLog = programInfoLog.trim();
            const vertexLog = vertexShaderInfoLog.trim();
            const fragmentLog = fragmentShaderInfoLog.trim();
            let runnable = true;
            let haveDiagnostics = true;
            if (gl.getProgramParameter(program, gl.LINK_STATUS) === false) {
                runnable = false;
                if (typeof renderer.debug.onShaderError === 'function') renderer.debug.onShaderError(gl, program, glVertexShader, glFragmentShader);
                else {
                    // default error reporting
                    const vertexErrors = getShaderErrors(gl, glVertexShader, 'vertex');
                    const fragmentErrors = getShaderErrors(gl, glFragmentShader, 'fragment');
                    (0, _threeCoreJs.error)('THREE.WebGLProgram: Shader Error ' + gl.getError() + ' - ' + 'VALIDATE_STATUS ' + gl.getProgramParameter(program, gl.VALIDATE_STATUS) + '\n\n' + 'Material Name: ' + self1.name + '\n' + 'Material Type: ' + self1.type + '\n\n' + 'Program Info Log: ' + programLog + '\n' + vertexErrors + '\n' + fragmentErrors);
                }
            } else if (programLog !== '') (0, _threeCoreJs.warn)('WebGLProgram: Program Info Log:', programLog);
            else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
            if (haveDiagnostics) self1.diagnostics = {
                runnable: runnable,
                programLog: programLog,
                vertexShader: {
                    log: vertexLog,
                    prefix: prefixVertex
                },
                fragmentShader: {
                    log: fragmentLog,
                    prefix: prefixFragment
                }
            };
        }
        // Clean up
        // Crashes in iOS9 and iOS10. #18402
        // gl.detachShader( program, glVertexShader );
        // gl.detachShader( program, glFragmentShader );
        gl.deleteShader(glVertexShader);
        gl.deleteShader(glFragmentShader);
        cachedUniforms = new WebGLUniforms(gl, program);
        cachedAttributes = fetchAttributeLocations(gl, program);
    }
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) // Populates cachedUniforms and cachedAttributes
        onFirstUse(this);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) // Populates cachedAttributes and cachedUniforms
        onFirstUse(this);
        return cachedAttributes;
    };
    // indicate when the program is ready to be used. if the KHR_parallel_shader_compile extension isn't supported,
    // flag the program as ready immediately. It may cause a stall when it's first used.
    let programReady = parameters.rendererExtensionParallelShaderCompile === false;
    this.isReady = function() {
        if (programReady === false) programReady = gl.getProgramParameter(program, COMPLETION_STATUS_KHR);
        return programReady;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.type = parameters.shaderType;
    this.name = parameters.shaderName;
    this.id = programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
let _id = 0;
class WebGLShaderCache {
    constructor(){
        this.shaderCache = new Map();
        this.materialCache = new Map();
    }
    update(material) {
        const vertexShader = material.vertexShader;
        const fragmentShader = material.fragmentShader;
        const vertexShaderStage = this._getShaderStage(vertexShader);
        const fragmentShaderStage = this._getShaderStage(fragmentShader);
        const materialShaders = this._getShaderCacheForMaterial(material);
        if (materialShaders.has(vertexShaderStage) === false) {
            materialShaders.add(vertexShaderStage);
            vertexShaderStage.usedTimes++;
        }
        if (materialShaders.has(fragmentShaderStage) === false) {
            materialShaders.add(fragmentShaderStage);
            fragmentShaderStage.usedTimes++;
        }
        return this;
    }
    remove(material) {
        const materialShaders = this.materialCache.get(material);
        for (const shaderStage of materialShaders){
            shaderStage.usedTimes--;
            if (shaderStage.usedTimes === 0) this.shaderCache.delete(shaderStage.code);
        }
        this.materialCache.delete(material);
        return this;
    }
    getVertexShaderID(material) {
        return this._getShaderStage(material.vertexShader).id;
    }
    getFragmentShaderID(material) {
        return this._getShaderStage(material.fragmentShader).id;
    }
    dispose() {
        this.shaderCache.clear();
        this.materialCache.clear();
    }
    _getShaderCacheForMaterial(material) {
        const cache = this.materialCache;
        let set = cache.get(material);
        if (set === undefined) {
            set = new Set();
            cache.set(material, set);
        }
        return set;
    }
    _getShaderStage(code) {
        const cache = this.shaderCache;
        let stage = cache.get(code);
        if (stage === undefined) {
            stage = new WebGLShaderStage(code);
            cache.set(code, stage);
        }
        return stage;
    }
}
class WebGLShaderStage {
    constructor(code){
        this.id = _id++;
        this.code = code;
        this.usedTimes = 0;
    }
}
function WebGLPrograms(renderer, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping) {
    const _programLayers = new (0, _threeCoreJs.Layers)();
    const _customShaders = new WebGLShaderCache();
    const _activeChannels = new Set();
    const programs = [];
    const programsMap = new Map();
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distance',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    function getChannel(value) {
        _activeChannels.add(value);
        if (value === 0) return 'uv';
        return `uv${value}`;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const geometry = object.geometry;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
        const envMapCubeUVHeight = !!envMap && envMap.mapping === (0, _threeCoreJs.CubeUVReflectionMapping) ? envMap.image.height : null;
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) (0, _threeCoreJs.warn)('WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        //
        const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
        const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
        let morphTextureStride = 0;
        if (geometry.morphAttributes.position !== undefined) morphTextureStride = 1;
        if (geometry.morphAttributes.normal !== undefined) morphTextureStride = 2;
        if (geometry.morphAttributes.color !== undefined) morphTextureStride = 3;
        //
        let vertexShader, fragmentShader;
        let customVertexShaderID, customFragmentShaderID;
        if (shaderID) {
            const shader = ShaderLib[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
            _customShaders.update(material);
            customVertexShaderID = _customShaders.getVertexShaderID(material);
            customFragmentShaderID = _customShaders.getFragmentShaderID(material);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
        const IS_INSTANCEDMESH = object.isInstancedMesh === true;
        const IS_BATCHEDMESH = object.isBatchedMesh === true;
        const HAS_MAP = !!material.map;
        const HAS_MATCAP = !!material.matcap;
        const HAS_ENVMAP = !!envMap;
        const HAS_AOMAP = !!material.aoMap;
        const HAS_LIGHTMAP = !!material.lightMap;
        const HAS_BUMPMAP = !!material.bumpMap;
        const HAS_NORMALMAP = !!material.normalMap;
        const HAS_DISPLACEMENTMAP = !!material.displacementMap;
        const HAS_EMISSIVEMAP = !!material.emissiveMap;
        const HAS_METALNESSMAP = !!material.metalnessMap;
        const HAS_ROUGHNESSMAP = !!material.roughnessMap;
        const HAS_ANISOTROPY = material.anisotropy > 0;
        const HAS_CLEARCOAT = material.clearcoat > 0;
        const HAS_DISPERSION = material.dispersion > 0;
        const HAS_IRIDESCENCE = material.iridescence > 0;
        const HAS_SHEEN = material.sheen > 0;
        const HAS_TRANSMISSION = material.transmission > 0;
        const HAS_ANISOTROPYMAP = HAS_ANISOTROPY && !!material.anisotropyMap;
        const HAS_CLEARCOATMAP = HAS_CLEARCOAT && !!material.clearcoatMap;
        const HAS_CLEARCOAT_NORMALMAP = HAS_CLEARCOAT && !!material.clearcoatNormalMap;
        const HAS_CLEARCOAT_ROUGHNESSMAP = HAS_CLEARCOAT && !!material.clearcoatRoughnessMap;
        const HAS_IRIDESCENCEMAP = HAS_IRIDESCENCE && !!material.iridescenceMap;
        const HAS_IRIDESCENCE_THICKNESSMAP = HAS_IRIDESCENCE && !!material.iridescenceThicknessMap;
        const HAS_SHEEN_COLORMAP = HAS_SHEEN && !!material.sheenColorMap;
        const HAS_SHEEN_ROUGHNESSMAP = HAS_SHEEN && !!material.sheenRoughnessMap;
        const HAS_SPECULARMAP = !!material.specularMap;
        const HAS_SPECULAR_COLORMAP = !!material.specularColorMap;
        const HAS_SPECULAR_INTENSITYMAP = !!material.specularIntensityMap;
        const HAS_TRANSMISSIONMAP = HAS_TRANSMISSION && !!material.transmissionMap;
        const HAS_THICKNESSMAP = HAS_TRANSMISSION && !!material.thicknessMap;
        const HAS_GRADIENTMAP = !!material.gradientMap;
        const HAS_ALPHAMAP = !!material.alphaMap;
        const HAS_ALPHATEST = material.alphaTest > 0;
        const HAS_ALPHAHASH = !!material.alphaHash;
        const HAS_EXTENSIONS = !!material.extensions;
        let toneMapping = (0, _threeCoreJs.NoToneMapping);
        if (material.toneMapped) {
            if (currentRenderTarget === null || currentRenderTarget.isXRRenderTarget === true) toneMapping = renderer.toneMapping;
        }
        const parameters = {
            shaderID: shaderID,
            shaderType: material.type,
            shaderName: material.name,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            customVertexShaderID: customVertexShaderID,
            customFragmentShaderID: customFragmentShaderID,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            batching: IS_BATCHEDMESH,
            batchingColor: IS_BATCHEDMESH && object._colorsTexture !== null,
            instancing: IS_INSTANCEDMESH,
            instancingColor: IS_INSTANCEDMESH && object.instanceColor !== null,
            instancingMorph: IS_INSTANCEDMESH && object.morphTexture !== null,
            outputColorSpace: currentRenderTarget === null ? renderer.outputColorSpace : currentRenderTarget.isXRRenderTarget === true ? currentRenderTarget.texture.colorSpace : (0, _threeCoreJs.LinearSRGBColorSpace),
            alphaToCoverage: !!material.alphaToCoverage,
            map: HAS_MAP,
            matcap: HAS_MATCAP,
            envMap: HAS_ENVMAP,
            envMapMode: HAS_ENVMAP && envMap.mapping,
            envMapCubeUVHeight: envMapCubeUVHeight,
            aoMap: HAS_AOMAP,
            lightMap: HAS_LIGHTMAP,
            bumpMap: HAS_BUMPMAP,
            normalMap: HAS_NORMALMAP,
            displacementMap: HAS_DISPLACEMENTMAP,
            emissiveMap: HAS_EMISSIVEMAP,
            normalMapObjectSpace: HAS_NORMALMAP && material.normalMapType === (0, _threeCoreJs.ObjectSpaceNormalMap),
            normalMapTangentSpace: HAS_NORMALMAP && material.normalMapType === (0, _threeCoreJs.TangentSpaceNormalMap),
            metalnessMap: HAS_METALNESSMAP,
            roughnessMap: HAS_ROUGHNESSMAP,
            anisotropy: HAS_ANISOTROPY,
            anisotropyMap: HAS_ANISOTROPYMAP,
            clearcoat: HAS_CLEARCOAT,
            clearcoatMap: HAS_CLEARCOATMAP,
            clearcoatNormalMap: HAS_CLEARCOAT_NORMALMAP,
            clearcoatRoughnessMap: HAS_CLEARCOAT_ROUGHNESSMAP,
            dispersion: HAS_DISPERSION,
            iridescence: HAS_IRIDESCENCE,
            iridescenceMap: HAS_IRIDESCENCEMAP,
            iridescenceThicknessMap: HAS_IRIDESCENCE_THICKNESSMAP,
            sheen: HAS_SHEEN,
            sheenColorMap: HAS_SHEEN_COLORMAP,
            sheenRoughnessMap: HAS_SHEEN_ROUGHNESSMAP,
            specularMap: HAS_SPECULARMAP,
            specularColorMap: HAS_SPECULAR_COLORMAP,
            specularIntensityMap: HAS_SPECULAR_INTENSITYMAP,
            transmission: HAS_TRANSMISSION,
            transmissionMap: HAS_TRANSMISSIONMAP,
            thicknessMap: HAS_THICKNESSMAP,
            gradientMap: HAS_GRADIENTMAP,
            opaque: material.transparent === false && material.blending === (0, _threeCoreJs.NormalBlending) && material.alphaToCoverage === false,
            alphaMap: HAS_ALPHAMAP,
            alphaTest: HAS_ALPHATEST,
            alphaHash: HAS_ALPHAHASH,
            combine: material.combine,
            //
            mapUv: HAS_MAP && getChannel(material.map.channel),
            aoMapUv: HAS_AOMAP && getChannel(material.aoMap.channel),
            lightMapUv: HAS_LIGHTMAP && getChannel(material.lightMap.channel),
            bumpMapUv: HAS_BUMPMAP && getChannel(material.bumpMap.channel),
            normalMapUv: HAS_NORMALMAP && getChannel(material.normalMap.channel),
            displacementMapUv: HAS_DISPLACEMENTMAP && getChannel(material.displacementMap.channel),
            emissiveMapUv: HAS_EMISSIVEMAP && getChannel(material.emissiveMap.channel),
            metalnessMapUv: HAS_METALNESSMAP && getChannel(material.metalnessMap.channel),
            roughnessMapUv: HAS_ROUGHNESSMAP && getChannel(material.roughnessMap.channel),
            anisotropyMapUv: HAS_ANISOTROPYMAP && getChannel(material.anisotropyMap.channel),
            clearcoatMapUv: HAS_CLEARCOATMAP && getChannel(material.clearcoatMap.channel),
            clearcoatNormalMapUv: HAS_CLEARCOAT_NORMALMAP && getChannel(material.clearcoatNormalMap.channel),
            clearcoatRoughnessMapUv: HAS_CLEARCOAT_ROUGHNESSMAP && getChannel(material.clearcoatRoughnessMap.channel),
            iridescenceMapUv: HAS_IRIDESCENCEMAP && getChannel(material.iridescenceMap.channel),
            iridescenceThicknessMapUv: HAS_IRIDESCENCE_THICKNESSMAP && getChannel(material.iridescenceThicknessMap.channel),
            sheenColorMapUv: HAS_SHEEN_COLORMAP && getChannel(material.sheenColorMap.channel),
            sheenRoughnessMapUv: HAS_SHEEN_ROUGHNESSMAP && getChannel(material.sheenRoughnessMap.channel),
            specularMapUv: HAS_SPECULARMAP && getChannel(material.specularMap.channel),
            specularColorMapUv: HAS_SPECULAR_COLORMAP && getChannel(material.specularColorMap.channel),
            specularIntensityMapUv: HAS_SPECULAR_INTENSITYMAP && getChannel(material.specularIntensityMap.channel),
            transmissionMapUv: HAS_TRANSMISSIONMAP && getChannel(material.transmissionMap.channel),
            thicknessMapUv: HAS_THICKNESSMAP && getChannel(material.thicknessMap.channel),
            alphaMapUv: HAS_ALPHAMAP && getChannel(material.alphaMap.channel),
            //
            vertexTangents: !!geometry.attributes.tangent && (HAS_NORMALMAP || HAS_ANISOTROPY),
            vertexColors: material.vertexColors,
            vertexAlphas: material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4,
            pointsUvs: object.isPoints === true && !!geometry.attributes.uv && (HAS_MAP || HAS_ALPHAMAP),
            fog: !!fog,
            useFog: material.fog === true,
            fogExp2: !!fog && fog.isFogExp2,
            flatShading: material.flatShading === true && material.wireframe === false,
            sizeAttenuation: material.sizeAttenuation === true,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            reversedDepthBuffer: reversedDepthBuffer,
            skinning: object.isSkinnedMesh === true,
            morphTargets: geometry.morphAttributes.position !== undefined,
            morphNormals: geometry.morphAttributes.normal !== undefined,
            morphColors: geometry.morphAttributes.color !== undefined,
            morphTargetsCount: morphTargetsCount,
            morphTextureStride: morphTextureStride,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numSpotLightMaps: lights.spotLightMap.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numSpotLightShadowsWithMaps: lights.numSpotLightShadowsWithMaps,
            numLightProbes: lights.numLightProbes,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: toneMapping,
            decodeVideoTexture: HAS_MAP && material.map.isVideoTexture === true && (0, _threeCoreJs.ColorManagement).getTransfer(material.map.colorSpace) === (0, _threeCoreJs.SRGBTransfer),
            decodeVideoTextureEmissive: HAS_EMISSIVEMAP && material.emissiveMap.isVideoTexture === true && (0, _threeCoreJs.ColorManagement).getTransfer(material.emissiveMap.colorSpace) === (0, _threeCoreJs.SRGBTransfer),
            premultipliedAlpha: material.premultipliedAlpha,
            doubleSided: material.side === (0, _threeCoreJs.DoubleSide),
            flipSided: material.side === (0, _threeCoreJs.BackSide),
            useDepthPacking: material.depthPacking >= 0,
            depthPacking: material.depthPacking || 0,
            index0AttributeName: material.index0AttributeName,
            extensionClipCullDistance: HAS_EXTENSIONS && material.extensions.clipCullDistance === true && extensions.has('WEBGL_clip_cull_distance'),
            extensionMultiDraw: (HAS_EXTENSIONS && material.extensions.multiDraw === true || IS_BATCHEDMESH) && extensions.has('WEBGL_multi_draw'),
            rendererExtensionParallelShaderCompile: extensions.has('KHR_parallel_shader_compile'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        // the usage of getChannel() determines the active texture channels for this shader
        parameters.vertexUv1s = _activeChannels.has(1);
        parameters.vertexUv2s = _activeChannels.has(2);
        parameters.vertexUv3s = _activeChannels.has(3);
        _activeChannels.clear();
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.customVertexShaderID);
            array.push(parameters.customFragmentShaderID);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            getProgramCacheKeyParameters(array, parameters);
            getProgramCacheKeyBooleans(array, parameters);
            array.push(renderer.outputColorSpace);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getProgramCacheKeyParameters(array, parameters) {
        array.push(parameters.precision);
        array.push(parameters.outputColorSpace);
        array.push(parameters.envMapMode);
        array.push(parameters.envMapCubeUVHeight);
        array.push(parameters.mapUv);
        array.push(parameters.alphaMapUv);
        array.push(parameters.lightMapUv);
        array.push(parameters.aoMapUv);
        array.push(parameters.bumpMapUv);
        array.push(parameters.normalMapUv);
        array.push(parameters.displacementMapUv);
        array.push(parameters.emissiveMapUv);
        array.push(parameters.metalnessMapUv);
        array.push(parameters.roughnessMapUv);
        array.push(parameters.anisotropyMapUv);
        array.push(parameters.clearcoatMapUv);
        array.push(parameters.clearcoatNormalMapUv);
        array.push(parameters.clearcoatRoughnessMapUv);
        array.push(parameters.iridescenceMapUv);
        array.push(parameters.iridescenceThicknessMapUv);
        array.push(parameters.sheenColorMapUv);
        array.push(parameters.sheenRoughnessMapUv);
        array.push(parameters.specularMapUv);
        array.push(parameters.specularColorMapUv);
        array.push(parameters.specularIntensityMapUv);
        array.push(parameters.transmissionMapUv);
        array.push(parameters.thicknessMapUv);
        array.push(parameters.combine);
        array.push(parameters.fogExp2);
        array.push(parameters.sizeAttenuation);
        array.push(parameters.morphTargetsCount);
        array.push(parameters.morphAttributeCount);
        array.push(parameters.numDirLights);
        array.push(parameters.numPointLights);
        array.push(parameters.numSpotLights);
        array.push(parameters.numSpotLightMaps);
        array.push(parameters.numHemiLights);
        array.push(parameters.numRectAreaLights);
        array.push(parameters.numDirLightShadows);
        array.push(parameters.numPointLightShadows);
        array.push(parameters.numSpotLightShadows);
        array.push(parameters.numSpotLightShadowsWithMaps);
        array.push(parameters.numLightProbes);
        array.push(parameters.shadowMapType);
        array.push(parameters.toneMapping);
        array.push(parameters.numClippingPlanes);
        array.push(parameters.numClipIntersection);
        array.push(parameters.depthPacking);
    }
    function getProgramCacheKeyBooleans(array, parameters) {
        _programLayers.disableAll();
        if (parameters.instancing) _programLayers.enable(0);
        if (parameters.instancingColor) _programLayers.enable(1);
        if (parameters.instancingMorph) _programLayers.enable(2);
        if (parameters.matcap) _programLayers.enable(3);
        if (parameters.envMap) _programLayers.enable(4);
        if (parameters.normalMapObjectSpace) _programLayers.enable(5);
        if (parameters.normalMapTangentSpace) _programLayers.enable(6);
        if (parameters.clearcoat) _programLayers.enable(7);
        if (parameters.iridescence) _programLayers.enable(8);
        if (parameters.alphaTest) _programLayers.enable(9);
        if (parameters.vertexColors) _programLayers.enable(10);
        if (parameters.vertexAlphas) _programLayers.enable(11);
        if (parameters.vertexUv1s) _programLayers.enable(12);
        if (parameters.vertexUv2s) _programLayers.enable(13);
        if (parameters.vertexUv3s) _programLayers.enable(14);
        if (parameters.vertexTangents) _programLayers.enable(15);
        if (parameters.anisotropy) _programLayers.enable(16);
        if (parameters.alphaHash) _programLayers.enable(17);
        if (parameters.batching) _programLayers.enable(18);
        if (parameters.dispersion) _programLayers.enable(19);
        if (parameters.batchingColor) _programLayers.enable(20);
        if (parameters.gradientMap) _programLayers.enable(21);
        array.push(_programLayers.mask);
        _programLayers.disableAll();
        if (parameters.fog) _programLayers.enable(0);
        if (parameters.useFog) _programLayers.enable(1);
        if (parameters.flatShading) _programLayers.enable(2);
        if (parameters.logarithmicDepthBuffer) _programLayers.enable(3);
        if (parameters.reversedDepthBuffer) _programLayers.enable(4);
        if (parameters.skinning) _programLayers.enable(5);
        if (parameters.morphTargets) _programLayers.enable(6);
        if (parameters.morphNormals) _programLayers.enable(7);
        if (parameters.morphColors) _programLayers.enable(8);
        if (parameters.premultipliedAlpha) _programLayers.enable(9);
        if (parameters.shadowMapEnabled) _programLayers.enable(10);
        if (parameters.doubleSided) _programLayers.enable(11);
        if (parameters.flipSided) _programLayers.enable(12);
        if (parameters.useDepthPacking) _programLayers.enable(13);
        if (parameters.dithering) _programLayers.enable(14);
        if (parameters.transmission) _programLayers.enable(15);
        if (parameters.sheen) _programLayers.enable(16);
        if (parameters.opaque) _programLayers.enable(17);
        if (parameters.pointsUvs) _programLayers.enable(18);
        if (parameters.decodeVideoTexture) _programLayers.enable(19);
        if (parameters.decodeVideoTextureEmissive) _programLayers.enable(20);
        if (parameters.alphaToCoverage) _programLayers.enable(21);
        array.push(_programLayers.mask);
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = ShaderLib[shaderID];
            uniforms = (0, _threeCoreJs.UniformsUtils).clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program = programsMap.get(cacheKey);
        if (program !== undefined) ++program.usedTimes;
        else {
            program = new WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
            programsMap.set(cacheKey, program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Remove from map
            programsMap.delete(program.cacheKey);
            // Free WebGL resources
            program.destroy();
        }
    }
    function releaseShaderCache(material) {
        _customShaders.remove(material);
    }
    function dispose() {
        _customShaders.dispose();
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        releaseShaderCache: releaseShaderCache,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs,
        dispose: dispose
    };
}
function WebGLProperties() {
    let properties = new WeakMap();
    function has(object) {
        return properties.has(object);
    }
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        has: has,
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function WebGLRenderList() {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transmissive = [];
    const transparent = [];
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transmissive.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.push(renderItem);
        else if (material.transparent === true) transparent.push(renderItem);
        else opaque.push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        if (material.transmission > 0.0) transmissive.unshift(renderItem);
        else if (material.transparent === true) transparent.unshift(renderItem);
        else opaque.unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || painterSortStable);
        if (transmissive.length > 1) transmissive.sort(customTransparentSort || reversePainterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transmissive: transmissive,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function WebGLRenderLists() {
    let lists = new WeakMap();
    function get(scene, renderCallDepth) {
        const listArray = lists.get(scene);
        let list;
        if (listArray === undefined) {
            list = new WebGLRenderList();
            lists.set(scene, [
                list
            ]);
        } else if (renderCallDepth >= listArray.length) {
            list = new WebGLRenderList();
            listArray.push(list);
        } else list = listArray[renderCallDepth];
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new (0, _threeCoreJs.Vector3)(),
                        color: new (0, _threeCoreJs.Color)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new (0, _threeCoreJs.Vector3)(),
                        direction: new (0, _threeCoreJs.Vector3)(),
                        color: new (0, _threeCoreJs.Color)(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new (0, _threeCoreJs.Vector3)(),
                        color: new (0, _threeCoreJs.Color)(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new (0, _threeCoreJs.Vector3)(),
                        skyColor: new (0, _threeCoreJs.Color)(),
                        groundColor: new (0, _threeCoreJs.Color)()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new (0, _threeCoreJs.Color)(),
                        position: new (0, _threeCoreJs.Vector3)(),
                        halfWidth: new (0, _threeCoreJs.Vector3)(),
                        halfHeight: new (0, _threeCoreJs.Vector3)()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, _threeCoreJs.Vector2)()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, _threeCoreJs.Vector2)()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowIntensity: 1,
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new (0, _threeCoreJs.Vector2)(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let nextVersion = 0;
function shadowCastingAndTexturingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 2 : 0) - (lightA.castShadow ? 2 : 0) + (lightB.map ? 1 : 0) - (lightA.map ? 1 : 0);
}
function WebGLLights(extensions) {
    const cache = new UniformsCache();
    const shadowCache = ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1,
            numSpotMaps: -1,
            numLightProbes: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotLightMap: [],
        spotShadow: [],
        spotShadowMap: [],
        spotLightMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: [],
        numSpotLightShadowsWithMaps: 0,
        numLightProbes: 0
    };
    for(let i = 0; i < 9; i++)state.probe.push(new (0, _threeCoreJs.Vector3)());
    const vector3 = new (0, _threeCoreJs.Vector3)();
    const matrix4 = new (0, _threeCoreJs.Matrix4)();
    const matrix42 = new (0, _threeCoreJs.Matrix4)();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        let numSpotMaps = 0;
        let numSpotShadowsWithMaps = 0;
        let numLightProbes = 0;
        // ordering : [shadow casting + map texturing, map texturing, shadow casting, none ]
        lights.sort(shadowCastingAndTexturingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            let shadowMap = null;
            if (light.shadow && light.shadow.map) {
                if (light.shadow.map.texture.format === (0, _threeCoreJs.RGFormat)) // VSM uses color texture with blurred mean/std_dev
                shadowMap = light.shadow.map.texture;
                else // Other types use depth texture
                shadowMap = light.shadow.map.depthTexture || light.shadow.map.texture;
            }
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) {
                for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
                numLightProbes++;
            } else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                state.spot[spotLength] = uniforms;
                const shadow = light.shadow;
                if (light.map) {
                    state.spotLightMap[numSpotMaps] = light.map;
                    numSpotMaps++;
                    // make sure the lightMatrix is up to date
                    // TODO : do it if required only
                    shadow.updateMatrices(light);
                    if (light.castShadow) numSpotShadowsWithMaps++;
                }
                state.spotLightMatrix[spotLength] = shadow.matrix;
                if (light.castShadow) {
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    numSpotShadows++;
                }
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowIntensity = shadow.intensity;
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (extensions.has('OES_texture_float_linear') === true) {
                state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
                state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
            } else {
                state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
                state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows || hash.numSpotMaps !== numSpotMaps || hash.numLightProbes !== numLightProbes) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotLightMatrix.length = numSpotShadows + numSpotMaps - numSpotShadowsWithMaps;
            state.spotLightMap.length = numSpotMaps;
            state.numSpotLightShadowsWithMaps = numSpotShadowsWithMaps;
            state.numLightProbes = numLightProbes;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            hash.numSpotMaps = numSpotMaps;
            hash.numLightProbes = numLightProbes;
            state.version = nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function WebGLRenderState(extensions) {
    const lights = new WebGLLights(extensions);
    const lightsArray = [];
    const shadowsArray = [];
    function init(camera) {
        state.camera = camera;
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        camera: null,
        lights: lights,
        transmissionRenderTarget: {}
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function WebGLRenderStates(extensions) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        const renderStateArray = renderStates.get(scene);
        let renderState;
        if (renderStateArray === undefined) {
            renderState = new WebGLRenderState(extensions);
            renderStates.set(scene, [
                renderState
            ]);
        } else if (renderCallDepth >= renderStateArray.length) {
            renderState = new WebGLRenderState(extensions);
            renderStateArray.push(renderState);
        } else renderState = renderStateArray[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
const vertex = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
const fragment = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ).rg;\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ).r;\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( max( 0.0, squared_mean - mean * mean ) );\n\tgl_FragColor = vec4( mean, std_dev, 0.0, 1.0 );\n}";
const _cubeDirections = [
    /*@__PURE__*/ new (0, _threeCoreJs.Vector3)(1, 0, 0),
    /*@__PURE__*/ new (0, _threeCoreJs.Vector3)(-1, 0, 0),
    /*@__PURE__*/ new (0, _threeCoreJs.Vector3)(0, 1, 0),
    /*@__PURE__*/ new (0, _threeCoreJs.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, _threeCoreJs.Vector3)(0, 0, 1),
    /*@__PURE__*/ new (0, _threeCoreJs.Vector3)(0, 0, -1)
];
const _cubeUps = [
    /*@__PURE__*/ new (0, _threeCoreJs.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, _threeCoreJs.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, _threeCoreJs.Vector3)(0, 0, 1),
    /*@__PURE__*/ new (0, _threeCoreJs.Vector3)(0, 0, -1),
    /*@__PURE__*/ new (0, _threeCoreJs.Vector3)(0, -1, 0),
    /*@__PURE__*/ new (0, _threeCoreJs.Vector3)(0, -1, 0)
];
const _projScreenMatrix = /*@__PURE__*/ new (0, _threeCoreJs.Matrix4)();
const _lightPositionWorld = /*@__PURE__*/ new (0, _threeCoreJs.Vector3)();
const _lookTarget = /*@__PURE__*/ new (0, _threeCoreJs.Vector3)();
function WebGLShadowMap(renderer, objects, capabilities) {
    let _frustum = new (0, _threeCoreJs.Frustum)();
    const _shadowMapSize = new (0, _threeCoreJs.Vector2)(), _viewportSize = new (0, _threeCoreJs.Vector2)(), _viewport = new (0, _threeCoreJs.Vector4)(), _depthMaterial = new (0, _threeCoreJs.MeshDepthMaterial)(), _distanceMaterial = new (0, _threeCoreJs.MeshDistanceMaterial)(), _materialCache = {}, _maxTextureSize = capabilities.maxTextureSize;
    const shadowSide = {
        [(0, _threeCoreJs.FrontSide)]: (0, _threeCoreJs.BackSide),
        [(0, _threeCoreJs.BackSide)]: (0, _threeCoreJs.FrontSide),
        [(0, _threeCoreJs.DoubleSide)]: (0, _threeCoreJs.DoubleSide)
    };
    const shadowMaterialVertical = new (0, _threeCoreJs.ShaderMaterial)({
        defines: {
            VSM_SAMPLES: 8
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new (0, _threeCoreJs.Vector2)()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: vertex,
        fragmentShader: fragment
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new (0, _threeCoreJs.BufferGeometry)();
    fullScreenTri.setAttribute('position', new (0, _threeCoreJs.BufferAttribute)(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new (0, _threeCoreJs.Mesh)(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = (0, _threeCoreJs.PCFShadowMap);
    let _previousType = this.type;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        if (lights.type === (0, _threeCoreJs.PCFSoftShadowMap)) {
            (0, _threeCoreJs.warn)('WebGLShadowMap: PCFSoftShadowMap has been deprecated. Using PCFShadowMap instead.');
            lights.type = (0, _threeCoreJs.PCFShadowMap);
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const activeCubeFace = renderer.getActiveCubeFace();
        const activeMipmapLevel = renderer.getActiveMipmapLevel();
        const _state = renderer.state;
        // Set GL state for depth map.
        _state.setBlending((0, _threeCoreJs.NoBlending));
        if (_state.buffers.depth.getReversed() === true) _state.buffers.color.setClear(0, 0, 0, 0);
        else _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // check for shadow map type changes
        const typeChanged = _previousType !== this.type;
        // When shadow map type changes, materials need recompilation because sampler types change
        // (sampler2DShadow for PCF vs sampler2D for Basic)
        if (typeChanged) scene.traverse(function(object) {
            if (object.material) {
                if (Array.isArray(object.material)) object.material.forEach((mat)=>mat.needsUpdate = true);
                else object.material.needsUpdate = true;
            }
        });
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                (0, _threeCoreJs.warn)('WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > _maxTextureSize || _shadowMapSize.y > _maxTextureSize) {
                if (_shadowMapSize.x > _maxTextureSize) {
                    _viewportSize.x = Math.floor(_maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > _maxTextureSize) {
                    _viewportSize.y = Math.floor(_maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null || typeChanged === true) {
                if (shadow.map !== null) {
                    if (shadow.map.depthTexture !== null) {
                        shadow.map.depthTexture.dispose();
                        shadow.map.depthTexture = null;
                    }
                    shadow.map.dispose();
                }
                if (this.type === (0, _threeCoreJs.VSMShadowMap)) {
                    if (light.isPointLight) {
                        (0, _threeCoreJs.warn)('WebGLShadowMap: VSM shadow maps are not supported for PointLights. Use PCF or BasicShadowMap instead.');
                        continue;
                    }
                    shadow.map = new (0, _threeCoreJs.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y, {
                        format: (0, _threeCoreJs.RGFormat),
                        type: (0, _threeCoreJs.HalfFloatType),
                        minFilter: (0, _threeCoreJs.LinearFilter),
                        magFilter: (0, _threeCoreJs.LinearFilter),
                        generateMipmaps: false
                    });
                    shadow.map.texture.name = light.name + '.shadowMap';
                    // Native depth texture for VSM - depth is captured here, then blurred into the color texture
                    shadow.map.depthTexture = new (0, _threeCoreJs.DepthTexture)(_shadowMapSize.x, _shadowMapSize.y, (0, _threeCoreJs.FloatType));
                    shadow.map.depthTexture.name = light.name + '.shadowMapDepth';
                    shadow.map.depthTexture.format = (0, _threeCoreJs.DepthFormat);
                    shadow.map.depthTexture.compareFunction = null; // For regular sampling (not shadow comparison)
                    shadow.map.depthTexture.minFilter = (0, _threeCoreJs.NearestFilter);
                    shadow.map.depthTexture.magFilter = (0, _threeCoreJs.NearestFilter);
                } else {
                    if (light.isPointLight) {
                        shadow.map = new (0, _threeCoreJs.WebGLCubeRenderTarget)(_shadowMapSize.x);
                        shadow.map.depthTexture = new (0, _threeCoreJs.CubeDepthTexture)(_shadowMapSize.x, (0, _threeCoreJs.UnsignedIntType));
                    } else {
                        shadow.map = new (0, _threeCoreJs.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y);
                        shadow.map.depthTexture = new (0, _threeCoreJs.DepthTexture)(_shadowMapSize.x, _shadowMapSize.y, (0, _threeCoreJs.UnsignedIntType));
                    }
                    shadow.map.depthTexture.name = light.name + '.shadowMap';
                    shadow.map.depthTexture.format = (0, _threeCoreJs.DepthFormat);
                    const reversedDepthBuffer = renderer.state.buffers.depth.getReversed();
                    if (this.type === (0, _threeCoreJs.PCFShadowMap)) {
                        shadow.map.depthTexture.compareFunction = reversedDepthBuffer ? (0, _threeCoreJs.GreaterEqualCompare) : (0, _threeCoreJs.LessEqualCompare);
                        shadow.map.depthTexture.minFilter = (0, _threeCoreJs.LinearFilter);
                        shadow.map.depthTexture.magFilter = (0, _threeCoreJs.LinearFilter);
                    } else {
                        shadow.map.depthTexture.compareFunction = null;
                        shadow.map.depthTexture.minFilter = (0, _threeCoreJs.NearestFilter);
                        shadow.map.depthTexture.magFilter = (0, _threeCoreJs.NearestFilter);
                    }
                }
                shadow.camera.updateProjectionMatrix();
            }
            // For cube render targets (PointLights), render all 6 faces. Otherwise, render once.
            const faceCount = shadow.map.isWebGLCubeRenderTarget ? 6 : 1;
            for(let face = 0; face < faceCount; face++){
                // For cube render targets, render to each face separately
                if (shadow.map.isWebGLCubeRenderTarget) {
                    renderer.setRenderTarget(shadow.map, face);
                    renderer.clear();
                } else {
                    // For 2D render targets, use viewports
                    if (face === 0) {
                        renderer.setRenderTarget(shadow.map);
                        renderer.clear();
                    }
                    const viewport = shadow.getViewport(face);
                    _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                    _state.viewport(_viewport);
                }
                if (light.isPointLight) {
                    const camera = shadow.camera;
                    const shadowMatrix = shadow.matrix;
                    const far = light.distance || camera.far;
                    if (far !== camera.far) {
                        camera.far = far;
                        camera.updateProjectionMatrix();
                    }
                    _lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
                    camera.position.copy(_lightPositionWorld);
                    _lookTarget.copy(camera.position);
                    _lookTarget.add(_cubeDirections[face]);
                    camera.up.copy(_cubeUps[face]);
                    camera.lookAt(_lookTarget);
                    camera.updateMatrixWorld();
                    shadowMatrix.makeTranslation(-_lightPositionWorld.x, -_lightPositionWorld.y, -_lightPositionWorld.z);
                    _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
                    shadow._frustum.setFromProjectionMatrix(_projScreenMatrix, camera.coordinateSystem, camera.reversedDepth);
                } else shadow.updateMatrices(light);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (shadow.isPointLightShadow !== true && this.type === (0, _threeCoreJs.VSMShadowMap)) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        _previousType = this.type;
        scope.needsUpdate = false;
        renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = objects.update(fullScreenMesh);
        if (shadowMaterialVertical.defines.VSM_SAMPLES !== shadow.blurSamples) {
            shadowMaterialVertical.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialHorizontal.defines.VSM_SAMPLES = shadow.blurSamples;
            shadowMaterialVertical.needsUpdate = true;
            shadowMaterialHorizontal.needsUpdate = true;
        }
        if (shadow.mapPass === null) shadow.mapPass = new (0, _threeCoreJs.WebGLRenderTarget)(_shadowMapSize.x, _shadowMapSize.y, {
            format: (0, _threeCoreJs.RGFormat),
            type: (0, _threeCoreJs.HalfFloatType)
        });
        // vertical pass - read from native depth texture
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.depthTexture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.mapPass);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        renderer.setRenderTarget(shadow.map);
        renderer.clear();
        renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterial(object, material, light, type) {
        let result = null;
        const customMaterial = light.isPointLight === true ? object.customDistanceMaterial : object.customDepthMaterial;
        if (customMaterial !== undefined) result = customMaterial;
        else {
            result = light.isPointLight === true ? _distanceMaterial : _depthMaterial;
            if (renderer.localClippingEnabled && material.clipShadows === true && Array.isArray(material.clippingPlanes) && material.clippingPlanes.length !== 0 || material.displacementMap && material.displacementScale !== 0 || material.alphaMap && material.alphaTest > 0 || material.map && material.alphaTest > 0 || material.alphaToCoverage === true) {
                // in this case we need a unique material instance reflecting the
                // appropriate state
                const keyA = result.uuid, keyB = material.uuid;
                let materialsForVariant = _materialCache[keyA];
                if (materialsForVariant === undefined) {
                    materialsForVariant = {};
                    _materialCache[keyA] = materialsForVariant;
                }
                let cachedMaterial = materialsForVariant[keyB];
                if (cachedMaterial === undefined) {
                    cachedMaterial = result.clone();
                    materialsForVariant[keyB] = cachedMaterial;
                    material.addEventListener('dispose', onMaterialDispose);
                }
                result = cachedMaterial;
            }
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === (0, _threeCoreJs.VSMShadowMap)) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.alphaMap = material.alphaMap;
        result.alphaTest = material.alphaToCoverage === true ? 0.5 : material.alphaTest; // approximate alphaToCoverage by using a fixed alphaTest value
        result.map = material.map;
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.displacementMap = material.displacementMap;
        result.displacementScale = material.displacementScale;
        result.displacementBias = material.displacementBias;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            const materialProperties = renderer.properties.get(result);
            materialProperties.light = light;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === (0, _threeCoreJs.VSMShadowMap)) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, groupMaterial, light, type);
                            object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                            renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                            object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, material, light, type);
                    object.onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                    renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                    object.onAfterShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        // make sure to remove the unique distance/depth materials used for shadow map rendering
        for(const id in _materialCache){
            const cache = _materialCache[id];
            const uuid = event.target.uuid;
            if (uuid in cache) {
                const shadowMaterial = cache[uuid];
                shadowMaterial.dispose();
                delete cache[uuid];
            }
        }
    }
}
const reversedFuncs = {
    [(0, _threeCoreJs.NeverDepth)]: (0, _threeCoreJs.AlwaysDepth),
    [(0, _threeCoreJs.LessDepth)]: (0, _threeCoreJs.GreaterDepth),
    [(0, _threeCoreJs.EqualDepth)]: (0, _threeCoreJs.NotEqualDepth),
    [(0, _threeCoreJs.LessEqualDepth)]: (0, _threeCoreJs.GreaterEqualDepth),
    [(0, _threeCoreJs.AlwaysDepth)]: (0, _threeCoreJs.NeverDepth),
    [(0, _threeCoreJs.GreaterDepth)]: (0, _threeCoreJs.LessDepth),
    [(0, _threeCoreJs.NotEqualDepth)]: (0, _threeCoreJs.EqualDepth),
    [(0, _threeCoreJs.GreaterEqualDepth)]: (0, _threeCoreJs.LessEqualDepth)
};
function WebGLState(gl, extensions) {
    function ColorBuffer() {
        let locked = false;
        const color = new (0, _threeCoreJs.Vector4)();
        let currentColorMask = null;
        const currentColorClear = new (0, _threeCoreJs.Vector4)(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentReversed = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setReversed: function(reversed) {
                if (currentReversed !== reversed) {
                    const ext = extensions.get('EXT_clip_control');
                    if (reversed) ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.ZERO_TO_ONE_EXT);
                    else ext.clipControlEXT(ext.LOWER_LEFT_EXT, ext.NEGATIVE_ONE_TO_ONE_EXT);
                    currentReversed = reversed;
                    const oldDepth = currentDepthClear;
                    currentDepthClear = null;
                    this.setClear(oldDepth);
                }
            },
            getReversed: function() {
                return currentReversed;
            },
            setTest: function(depthTest) {
                if (depthTest) enable(gl.DEPTH_TEST);
                else disable(gl.DEPTH_TEST);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentReversed) depthFunc = reversedFuncs[depthFunc];
                if (currentDepthFunc !== depthFunc) {
                    switch(depthFunc){
                        case 0, _threeCoreJs.NeverDepth:
                            gl.depthFunc(gl.NEVER);
                            break;
                        case 0, _threeCoreJs.AlwaysDepth:
                            gl.depthFunc(gl.ALWAYS);
                            break;
                        case 0, _threeCoreJs.LessDepth:
                            gl.depthFunc(gl.LESS);
                            break;
                        case 0, _threeCoreJs.LessEqualDepth:
                            gl.depthFunc(gl.LEQUAL);
                            break;
                        case 0, _threeCoreJs.EqualDepth:
                            gl.depthFunc(gl.EQUAL);
                            break;
                        case 0, _threeCoreJs.GreaterEqualDepth:
                            gl.depthFunc(gl.GEQUAL);
                            break;
                        case 0, _threeCoreJs.GreaterDepth:
                            gl.depthFunc(gl.GREATER);
                            break;
                        case 0, _threeCoreJs.NotEqualDepth:
                            gl.depthFunc(gl.NOTEQUAL);
                            break;
                        default:
                            gl.depthFunc(gl.LEQUAL);
                    }
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    if (currentReversed) depth = 1 - depth;
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
                currentReversed = false;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(gl.STENCIL_TEST);
                    else disable(gl.STENCIL_TEST);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    const uboBindings = new WeakMap();
    const uboProgramMap = new WeakMap();
    let enabledCapabilities = {};
    let currentBoundFramebuffers = {};
    let currentDrawbuffers = new WeakMap();
    let defaultDrawbuffers = [];
    let currentProgram = null;
    let currentBlendingEnabled = false;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentBlendColor = new (0, _threeCoreJs.Color)(0, 0, 0);
    let currentBlendAlpha = 0;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(gl.VERSION);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const scissorParam = gl.getParameter(gl.SCISSOR_BOX);
    const viewportParam = gl.getParameter(gl.VIEWPORT);
    const currentScissor = new (0, _threeCoreJs.Vector4)().fromArray(scissorParam);
    const currentViewport = new (0, _threeCoreJs.Vector4)().fromArray(viewportParam);
    function createTexture(type, target, count, dimensions) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(type, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        for(let i = 0; i < count; i++)if (type === gl.TEXTURE_3D || type === gl.TEXTURE_2D_ARRAY) gl.texImage3D(target, 0, gl.RGBA, 1, 1, dimensions, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        else gl.texImage2D(target + i, 0, gl.RGBA, 1, 1, 0, gl.RGBA, gl.UNSIGNED_BYTE, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[gl.TEXTURE_2D] = createTexture(gl.TEXTURE_2D, gl.TEXTURE_2D, 1);
    emptyTextures[gl.TEXTURE_CUBE_MAP] = createTexture(gl.TEXTURE_CUBE_MAP, gl.TEXTURE_CUBE_MAP_POSITIVE_X, 6);
    emptyTextures[gl.TEXTURE_2D_ARRAY] = createTexture(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_2D_ARRAY, 1, 1);
    emptyTextures[gl.TEXTURE_3D] = createTexture(gl.TEXTURE_3D, gl.TEXTURE_3D, 1, 1);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(gl.DEPTH_TEST);
    depthBuffer.setFunc((0, _threeCoreJs.LessEqualDepth));
    setFlipSided(false);
    setCullFace((0, _threeCoreJs.CullFaceBack));
    enable(gl.CULL_FACE);
    setBlending((0, _threeCoreJs.NoBlending));
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function bindFramebuffer(target, framebuffer) {
        if (currentBoundFramebuffers[target] !== framebuffer) {
            gl.bindFramebuffer(target, framebuffer);
            currentBoundFramebuffers[target] = framebuffer;
            // gl.DRAW_FRAMEBUFFER is equivalent to gl.FRAMEBUFFER
            if (target === gl.DRAW_FRAMEBUFFER) currentBoundFramebuffers[gl.FRAMEBUFFER] = framebuffer;
            if (target === gl.FRAMEBUFFER) currentBoundFramebuffers[gl.DRAW_FRAMEBUFFER] = framebuffer;
            return true;
        }
        return false;
    }
    function drawBuffers(renderTarget, framebuffer) {
        let drawBuffers = defaultDrawbuffers;
        let needsUpdate = false;
        if (renderTarget) {
            drawBuffers = currentDrawbuffers.get(framebuffer);
            if (drawBuffers === undefined) {
                drawBuffers = [];
                currentDrawbuffers.set(framebuffer, drawBuffers);
            }
            const textures = renderTarget.textures;
            if (drawBuffers.length !== textures.length || drawBuffers[0] !== gl.COLOR_ATTACHMENT0) {
                for(let i = 0, il = textures.length; i < il; i++)drawBuffers[i] = gl.COLOR_ATTACHMENT0 + i;
                drawBuffers.length = textures.length;
                needsUpdate = true;
            }
        } else if (drawBuffers[0] !== gl.BACK) {
            drawBuffers[0] = gl.BACK;
            needsUpdate = true;
        }
        if (needsUpdate) gl.drawBuffers(drawBuffers);
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [(0, _threeCoreJs.AddEquation)]: gl.FUNC_ADD,
        [(0, _threeCoreJs.SubtractEquation)]: gl.FUNC_SUBTRACT,
        [(0, _threeCoreJs.ReverseSubtractEquation)]: gl.FUNC_REVERSE_SUBTRACT
    };
    equationToGL[0, _threeCoreJs.MinEquation] = gl.MIN;
    equationToGL[0, _threeCoreJs.MaxEquation] = gl.MAX;
    const factorToGL = {
        [(0, _threeCoreJs.ZeroFactor)]: gl.ZERO,
        [(0, _threeCoreJs.OneFactor)]: gl.ONE,
        [(0, _threeCoreJs.SrcColorFactor)]: gl.SRC_COLOR,
        [(0, _threeCoreJs.SrcAlphaFactor)]: gl.SRC_ALPHA,
        [(0, _threeCoreJs.SrcAlphaSaturateFactor)]: gl.SRC_ALPHA_SATURATE,
        [(0, _threeCoreJs.DstColorFactor)]: gl.DST_COLOR,
        [(0, _threeCoreJs.DstAlphaFactor)]: gl.DST_ALPHA,
        [(0, _threeCoreJs.OneMinusSrcColorFactor)]: gl.ONE_MINUS_SRC_COLOR,
        [(0, _threeCoreJs.OneMinusSrcAlphaFactor)]: gl.ONE_MINUS_SRC_ALPHA,
        [(0, _threeCoreJs.OneMinusDstColorFactor)]: gl.ONE_MINUS_DST_COLOR,
        [(0, _threeCoreJs.OneMinusDstAlphaFactor)]: gl.ONE_MINUS_DST_ALPHA,
        [(0, _threeCoreJs.ConstantColorFactor)]: gl.CONSTANT_COLOR,
        [(0, _threeCoreJs.OneMinusConstantColorFactor)]: gl.ONE_MINUS_CONSTANT_COLOR,
        [(0, _threeCoreJs.ConstantAlphaFactor)]: gl.CONSTANT_ALPHA,
        [(0, _threeCoreJs.OneMinusConstantAlphaFactor)]: gl.ONE_MINUS_CONSTANT_ALPHA
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, blendColor, blendAlpha, premultipliedAlpha) {
        if (blending === (0, _threeCoreJs.NoBlending)) {
            if (currentBlendingEnabled === true) {
                disable(gl.BLEND);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (currentBlendingEnabled === false) {
            enable(gl.BLEND);
            currentBlendingEnabled = true;
        }
        if (blending !== (0, _threeCoreJs.CustomBlending)) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== (0, _threeCoreJs.AddEquation) || currentBlendEquationAlpha !== (0, _threeCoreJs.AddEquation)) {
                    gl.blendEquation(gl.FUNC_ADD);
                    currentBlendEquation = (0, _threeCoreJs.AddEquation);
                    currentBlendEquationAlpha = (0, _threeCoreJs.AddEquation);
                }
                if (premultipliedAlpha) switch(blending){
                    case 0, _threeCoreJs.NormalBlending:
                        gl.blendFuncSeparate(gl.ONE, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, _threeCoreJs.AdditiveBlending:
                        gl.blendFunc(gl.ONE, gl.ONE);
                        break;
                    case 0, _threeCoreJs.SubtractiveBlending:
                        gl.blendFuncSeparate(gl.ZERO, gl.ONE_MINUS_SRC_COLOR, gl.ZERO, gl.ONE);
                        break;
                    case 0, _threeCoreJs.MultiplyBlending:
                        gl.blendFuncSeparate(gl.DST_COLOR, gl.ONE_MINUS_SRC_ALPHA, gl.ZERO, gl.ONE);
                        break;
                    default:
                        (0, _threeCoreJs.error)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case 0, _threeCoreJs.NormalBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA, gl.ONE, gl.ONE_MINUS_SRC_ALPHA);
                        break;
                    case 0, _threeCoreJs.AdditiveBlending:
                        gl.blendFuncSeparate(gl.SRC_ALPHA, gl.ONE, gl.ONE, gl.ONE);
                        break;
                    case 0, _threeCoreJs.SubtractiveBlending:
                        (0, _threeCoreJs.error)('WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true');
                        break;
                    case 0, _threeCoreJs.MultiplyBlending:
                        (0, _threeCoreJs.error)('WebGLState: MultiplyBlending requires material.premultipliedAlpha = true');
                        break;
                    default:
                        (0, _threeCoreJs.error)('WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlendColor.set(0, 0, 0);
                currentBlendAlpha = 0;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        if (blendColor.equals(currentBlendColor) === false || blendAlpha !== currentBlendAlpha) {
            gl.blendColor(blendColor.r, blendColor.g, blendColor.b, blendAlpha);
            currentBlendColor.copy(blendColor);
            currentBlendAlpha = blendAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = false;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === (0, _threeCoreJs.DoubleSide) ? disable(gl.CULL_FACE) : enable(gl.CULL_FACE);
        let flipSided = material.side === (0, _threeCoreJs.BackSide);
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === (0, _threeCoreJs.NormalBlending) && material.transparent === false ? setBlending((0, _threeCoreJs.NoBlending)) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.blendColor, material.blendAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
        material.alphaToCoverage === true ? enable(gl.SAMPLE_ALPHA_TO_COVERAGE) : disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(gl.CW);
            else gl.frontFace(gl.CCW);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== (0, _threeCoreJs.CullFaceNone)) {
            enable(gl.CULL_FACE);
            if (cullFace !== currentCullFace) {
                if (cullFace === (0, _threeCoreJs.CullFaceBack)) gl.cullFace(gl.BACK);
                else if (cullFace === (0, _threeCoreJs.CullFaceFront)) gl.cullFace(gl.FRONT);
                else gl.cullFace(gl.FRONT_AND_BACK);
            }
        } else disable(gl.CULL_FACE);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(gl.POLYGON_OFFSET_FILL);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(gl.POLYGON_OFFSET_FILL);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(gl.SCISSOR_TEST);
        else disable(gl.SCISSOR_TEST);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = gl.TEXTURE0 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture, webglSlot) {
        if (webglSlot === undefined) {
            if (currentTextureSlot === null) webglSlot = gl.TEXTURE0 + maxTextures - 1;
            else webglSlot = currentTextureSlot;
        }
        let boundTexture = currentBoundTextures[webglSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[webglSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            if (currentTextureSlot !== webglSlot) {
                gl.activeTexture(webglSlot);
                currentTextureSlot = webglSlot;
            }
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D(...arguments);
        } catch (e) {
            (0, _threeCoreJs.error)('WebGLState:', e);
        }
    }
    function compressedTexImage3D() {
        try {
            gl.compressedTexImage3D(...arguments);
        } catch (e) {
            (0, _threeCoreJs.error)('WebGLState:', e);
        }
    }
    function texSubImage2D() {
        try {
            gl.texSubImage2D(...arguments);
        } catch (e) {
            (0, _threeCoreJs.error)('WebGLState:', e);
        }
    }
    function texSubImage3D() {
        try {
            gl.texSubImage3D(...arguments);
        } catch (e) {
            (0, _threeCoreJs.error)('WebGLState:', e);
        }
    }
    function compressedTexSubImage2D() {
        try {
            gl.compressedTexSubImage2D(...arguments);
        } catch (e) {
            (0, _threeCoreJs.error)('WebGLState:', e);
        }
    }
    function compressedTexSubImage3D() {
        try {
            gl.compressedTexSubImage3D(...arguments);
        } catch (e) {
            (0, _threeCoreJs.error)('WebGLState:', e);
        }
    }
    function texStorage2D() {
        try {
            gl.texStorage2D(...arguments);
        } catch (e) {
            (0, _threeCoreJs.error)('WebGLState:', e);
        }
    }
    function texStorage3D() {
        try {
            gl.texStorage3D(...arguments);
        } catch (e) {
            (0, _threeCoreJs.error)('WebGLState:', e);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D(...arguments);
        } catch (e) {
            (0, _threeCoreJs.error)('WebGLState:', e);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D(...arguments);
        } catch (e) {
            (0, _threeCoreJs.error)('WebGLState:', e);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    function updateUBOMapping(uniformsGroup, program) {
        let mapping = uboProgramMap.get(program);
        if (mapping === undefined) {
            mapping = new WeakMap();
            uboProgramMap.set(program, mapping);
        }
        let blockIndex = mapping.get(uniformsGroup);
        if (blockIndex === undefined) {
            blockIndex = gl.getUniformBlockIndex(program, uniformsGroup.name);
            mapping.set(uniformsGroup, blockIndex);
        }
    }
    function uniformBlockBinding(uniformsGroup, program) {
        const mapping = uboProgramMap.get(program);
        const blockIndex = mapping.get(uniformsGroup);
        if (uboBindings.get(program) !== blockIndex) {
            // bind shader specific block index to global block point
            gl.uniformBlockBinding(program, blockIndex, uniformsGroup.__bindingPointIndex);
            uboBindings.set(program, blockIndex);
        }
    }
    //
    function reset() {
        // reset state
        gl.disable(gl.BLEND);
        gl.disable(gl.CULL_FACE);
        gl.disable(gl.DEPTH_TEST);
        gl.disable(gl.POLYGON_OFFSET_FILL);
        gl.disable(gl.SCISSOR_TEST);
        gl.disable(gl.STENCIL_TEST);
        gl.disable(gl.SAMPLE_ALPHA_TO_COVERAGE);
        gl.blendEquation(gl.FUNC_ADD);
        gl.blendFunc(gl.ONE, gl.ZERO);
        gl.blendFuncSeparate(gl.ONE, gl.ZERO, gl.ONE, gl.ZERO);
        gl.blendColor(0, 0, 0, 0);
        gl.colorMask(true, true, true, true);
        gl.clearColor(0, 0, 0, 0);
        gl.depthMask(true);
        gl.depthFunc(gl.LESS);
        depthBuffer.setReversed(false);
        gl.clearDepth(1);
        gl.stencilMask(0xffffffff);
        gl.stencilFunc(gl.ALWAYS, 0, 0xffffffff);
        gl.stencilOp(gl.KEEP, gl.KEEP, gl.KEEP);
        gl.clearStencil(0);
        gl.cullFace(gl.BACK);
        gl.frontFace(gl.CCW);
        gl.polygonOffset(0, 0);
        gl.activeTexture(gl.TEXTURE0);
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.DRAW_FRAMEBUFFER, null);
        gl.bindFramebuffer(gl.READ_FRAMEBUFFER, null);
        gl.useProgram(null);
        gl.lineWidth(1);
        gl.scissor(0, 0, gl.canvas.width, gl.canvas.height);
        gl.viewport(0, 0, gl.canvas.width, gl.canvas.height);
        // reset internals
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentBoundFramebuffers = {};
        currentDrawbuffers = new WeakMap();
        defaultDrawbuffers = [];
        currentProgram = null;
        currentBlendingEnabled = false;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentBlendColor = new (0, _threeCoreJs.Color)(0, 0, 0);
        currentBlendAlpha = 0;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        currentScissor.set(0, 0, gl.canvas.width, gl.canvas.height);
        currentViewport.set(0, 0, gl.canvas.width, gl.canvas.height);
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        bindFramebuffer: bindFramebuffer,
        drawBuffers: drawBuffers,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        compressedTexImage3D: compressedTexImage3D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        updateUBOMapping: updateUBOMapping,
        uniformBlockBinding: uniformBlockBinding,
        texStorage2D: texStorage2D,
        texStorage3D: texStorage3D,
        texSubImage2D: texSubImage2D,
        texSubImage3D: texSubImage3D,
        compressedTexSubImage2D: compressedTexSubImage2D,
        compressedTexSubImage3D: compressedTexSubImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const multisampledRTTExt = extensions.has('WEBGL_multisampled_render_to_texture') ? extensions.get('WEBGL_multisampled_render_to_texture') : null;
    const supportsInvalidateFramebuffer = typeof navigator === 'undefined' ? false : /OculusBrowser/g.test(navigator.userAgent);
    const _imageDimensions = new (0, _threeCoreJs.Vector2)();
    const _videoTextures = new WeakMap();
    let _canvas;
    const _sources = new WeakMap(); // maps WebglTexture objects to instances of Source
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? new OffscreenCanvas(width, height) : (0, _threeCoreJs.createElementNS)('canvas');
    }
    function resizeImage(image, needsNewCanvas, maxSize) {
        let scale = 1;
        const dimensions = getDimensions(image);
        // handle case if texture exceeds max size
        if (dimensions.width > maxSize || dimensions.height > maxSize) scale = maxSize / Math.max(dimensions.width, dimensions.height);
        // only perform resize if necessary
        if (scale < 1) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap || typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
                const width = Math.floor(scale * dimensions.width);
                const height = Math.floor(scale * dimensions.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                (0, _threeCoreJs.warn)('WebGLRenderer: Texture has been resized from (' + dimensions.width + 'x' + dimensions.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) (0, _threeCoreJs.warn)('WebGLRenderer: Image in DataTexture is too big (' + dimensions.width + 'x' + dimensions.height + ').');
                return image;
            }
        }
        return image;
    }
    function textureNeedsGenerateMipmaps(texture) {
        return texture.generateMipmaps;
    }
    function generateMipmap(target) {
        _gl.generateMipmap(target);
    }
    function getTargetType(texture) {
        if (texture.isWebGLCubeRenderTarget) return _gl.TEXTURE_CUBE_MAP;
        if (texture.isWebGL3DRenderTarget) return _gl.TEXTURE_3D;
        if (texture.isWebGLArrayRenderTarget || texture.isCompressedArrayTexture) return _gl.TEXTURE_2D_ARRAY;
        return _gl.TEXTURE_2D;
    }
    function getInternalFormat(internalFormatName, glFormat, glType, colorSpace, forceLinearTransfer = false) {
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            (0, _threeCoreJs.warn)('WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === _gl.RED) {
            if (glType === _gl.FLOAT) internalFormat = _gl.R32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.R16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8;
        }
        if (glFormat === _gl.RED_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.R8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.R16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.R32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.R8I;
            if (glType === _gl.SHORT) internalFormat = _gl.R16I;
            if (glType === _gl.INT) internalFormat = _gl.R32I;
        }
        if (glFormat === _gl.RG) {
            if (glType === _gl.FLOAT) internalFormat = _gl.RG32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RG16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8;
        }
        if (glFormat === _gl.RG_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RG8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RG16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RG32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RG8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RG16I;
            if (glType === _gl.INT) internalFormat = _gl.RG32I;
        }
        if (glFormat === _gl.RGB_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGB8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGB16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGB32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGB8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGB16I;
            if (glType === _gl.INT) internalFormat = _gl.RGB32I;
        }
        if (glFormat === _gl.RGBA_INTEGER) {
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = _gl.RGBA8UI;
            if (glType === _gl.UNSIGNED_SHORT) internalFormat = _gl.RGBA16UI;
            if (glType === _gl.UNSIGNED_INT) internalFormat = _gl.RGBA32UI;
            if (glType === _gl.BYTE) internalFormat = _gl.RGBA8I;
            if (glType === _gl.SHORT) internalFormat = _gl.RGBA16I;
            if (glType === _gl.INT) internalFormat = _gl.RGBA32I;
        }
        if (glFormat === _gl.RGB) {
            if (glType === _gl.UNSIGNED_INT_5_9_9_9_REV) internalFormat = _gl.RGB9_E5;
            if (glType === _gl.UNSIGNED_INT_10F_11F_11F_REV) internalFormat = _gl.R11F_G11F_B10F;
        }
        if (glFormat === _gl.RGBA) {
            const transfer = forceLinearTransfer ? (0, _threeCoreJs.LinearTransfer) : (0, _threeCoreJs.ColorManagement).getTransfer(colorSpace);
            if (glType === _gl.FLOAT) internalFormat = _gl.RGBA32F;
            if (glType === _gl.HALF_FLOAT) internalFormat = _gl.RGBA16F;
            if (glType === _gl.UNSIGNED_BYTE) internalFormat = transfer === (0, _threeCoreJs.SRGBTransfer) ? _gl.SRGB8_ALPHA8 : _gl.RGBA8;
            if (glType === _gl.UNSIGNED_SHORT_4_4_4_4) internalFormat = _gl.RGBA4;
            if (glType === _gl.UNSIGNED_SHORT_5_5_5_1) internalFormat = _gl.RGB5_A1;
        }
        if (internalFormat === _gl.R16F || internalFormat === _gl.R32F || internalFormat === _gl.RG16F || internalFormat === _gl.RG32F || internalFormat === _gl.RGBA16F || internalFormat === _gl.RGBA32F) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    function getInternalDepthFormat(useStencil, depthType) {
        let glInternalFormat;
        if (useStencil) {
            if (depthType === null || depthType === (0, _threeCoreJs.UnsignedIntType) || depthType === (0, _threeCoreJs.UnsignedInt248Type)) glInternalFormat = _gl.DEPTH24_STENCIL8;
            else if (depthType === (0, _threeCoreJs.FloatType)) glInternalFormat = _gl.DEPTH32F_STENCIL8;
            else if (depthType === (0, _threeCoreJs.UnsignedShortType)) {
                glInternalFormat = _gl.DEPTH24_STENCIL8;
                (0, _threeCoreJs.warn)('DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.');
            }
        } else {
            if (depthType === null || depthType === (0, _threeCoreJs.UnsignedIntType) || depthType === (0, _threeCoreJs.UnsignedInt248Type)) glInternalFormat = _gl.DEPTH_COMPONENT24;
            else if (depthType === (0, _threeCoreJs.FloatType)) glInternalFormat = _gl.DEPTH_COMPONENT32F;
            else if (depthType === (0, _threeCoreJs.UnsignedShortType)) glInternalFormat = _gl.DEPTH_COMPONENT16;
        }
        return glInternalFormat;
    }
    function getMipLevels(texture, image) {
        if (textureNeedsGenerateMipmaps(texture) === true || texture.isFramebufferTexture && texture.minFilter !== (0, _threeCoreJs.NearestFilter) && texture.minFilter !== (0, _threeCoreJs.LinearFilter)) return Math.log2(Math.max(image.width, image.height)) + 1;
        else if (texture.mipmaps !== undefined && texture.mipmaps.length > 0) // user-defined mipmaps
        return texture.mipmaps.length;
        else if (texture.isCompressedTexture && Array.isArray(texture.image)) return image.mipmaps.length;
        else // texture without mipmaps (only base level)
        return 1;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        // check if it's necessary to remove the WebGLTexture object
        const source = texture.source;
        const webglTextures = _sources.get(source);
        if (webglTextures) {
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            webglTexture.usedTimes--;
            // the WebGLTexture object is not used anymore, remove it
            if (webglTexture.usedTimes === 0) deleteTexture(texture);
            // remove the weak map entry if no WebGLTexture uses the source anymore
            if (Object.keys(webglTextures).length === 0) _sources.delete(source);
        }
        properties.remove(texture);
    }
    function deleteTexture(texture) {
        const textureProperties = properties.get(texture);
        _gl.deleteTexture(textureProperties.__webglTexture);
        const source = texture.source;
        const webglTextures = _sources.get(source);
        delete webglTextures[textureProperties.__cacheKey];
        info.memory.textures--;
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        if (renderTarget.depthTexture) {
            renderTarget.depthTexture.dispose();
            properties.remove(renderTarget.depthTexture);
        }
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            if (Array.isArray(renderTargetProperties.__webglFramebuffer[i])) for(let level = 0; level < renderTargetProperties.__webglFramebuffer[i].length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i][level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            if (Array.isArray(renderTargetProperties.__webglFramebuffer)) for(let level = 0; level < renderTargetProperties.__webglFramebuffer.length; level++)_gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[level]);
            else _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) {
                for(let i = 0; i < renderTargetProperties.__webglColorRenderbuffer.length; i++)if (renderTargetProperties.__webglColorRenderbuffer[i]) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer[i]);
            }
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const attachmentProperties = properties.get(textures[i]);
            if (attachmentProperties.__webglTexture) {
                _gl.deleteTexture(attachmentProperties.__webglTexture);
                info.memory.textures--;
            }
            properties.remove(textures[i]);
        }
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= capabilities.maxTextures) (0, _threeCoreJs.warn)('WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + capabilities.maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    function getTextureCacheKey(texture) {
        const array = [];
        array.push(texture.wrapS);
        array.push(texture.wrapT);
        array.push(texture.wrapR || 0);
        array.push(texture.magFilter);
        array.push(texture.minFilter);
        array.push(texture.anisotropy);
        array.push(texture.internalFormat);
        array.push(texture.format);
        array.push(texture.type);
        array.push(texture.generateMipmaps);
        array.push(texture.premultiplyAlpha);
        array.push(texture.flipY);
        array.push(texture.unpackAlignment);
        array.push(texture.colorSpace);
        return array.join();
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.isRenderTargetTexture === false && texture.isExternalTexture !== true && texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === null) (0, _threeCoreJs.warn)('WebGLRenderer: Texture marked for update but no image data found.');
            else if (image.complete === false) (0, _threeCoreJs.warn)('WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        } else if (texture.isExternalTexture) textureProperties.__webglTexture = texture.sourceTexture ? texture.sourceTexture : null;
        state.bindTexture(_gl.TEXTURE_2D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        } else if (texture.isExternalTexture) textureProperties.__webglTexture = texture.sourceTexture ? texture.sourceTexture : null;
        state.bindTexture(_gl.TEXTURE_2D_ARRAY, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isRenderTargetTexture === false && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_3D, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isCubeDepthTexture !== true && texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
    }
    const wrappingToGL = {
        [(0, _threeCoreJs.RepeatWrapping)]: _gl.REPEAT,
        [(0, _threeCoreJs.ClampToEdgeWrapping)]: _gl.CLAMP_TO_EDGE,
        [(0, _threeCoreJs.MirroredRepeatWrapping)]: _gl.MIRRORED_REPEAT
    };
    const filterToGL = {
        [(0, _threeCoreJs.NearestFilter)]: _gl.NEAREST,
        [(0, _threeCoreJs.NearestMipmapNearestFilter)]: _gl.NEAREST_MIPMAP_NEAREST,
        [(0, _threeCoreJs.NearestMipmapLinearFilter)]: _gl.NEAREST_MIPMAP_LINEAR,
        [(0, _threeCoreJs.LinearFilter)]: _gl.LINEAR,
        [(0, _threeCoreJs.LinearMipmapNearestFilter)]: _gl.LINEAR_MIPMAP_NEAREST,
        [(0, _threeCoreJs.LinearMipmapLinearFilter)]: _gl.LINEAR_MIPMAP_LINEAR
    };
    const compareToGL = {
        [(0, _threeCoreJs.NeverCompare)]: _gl.NEVER,
        [(0, _threeCoreJs.AlwaysCompare)]: _gl.ALWAYS,
        [(0, _threeCoreJs.LessCompare)]: _gl.LESS,
        [(0, _threeCoreJs.LessEqualCompare)]: _gl.LEQUAL,
        [(0, _threeCoreJs.EqualCompare)]: _gl.EQUAL,
        [(0, _threeCoreJs.GreaterEqualCompare)]: _gl.GEQUAL,
        [(0, _threeCoreJs.GreaterCompare)]: _gl.GREATER,
        [(0, _threeCoreJs.NotEqualCompare)]: _gl.NOTEQUAL
    };
    function setTextureParameters(textureType, texture) {
        if (texture.type === (0, _threeCoreJs.FloatType) && extensions.has('OES_texture_float_linear') === false && (texture.magFilter === (0, _threeCoreJs.LinearFilter) || texture.magFilter === (0, _threeCoreJs.LinearMipmapNearestFilter) || texture.magFilter === (0, _threeCoreJs.NearestMipmapLinearFilter) || texture.magFilter === (0, _threeCoreJs.LinearMipmapLinearFilter) || texture.minFilter === (0, _threeCoreJs.LinearFilter) || texture.minFilter === (0, _threeCoreJs.LinearMipmapNearestFilter) || texture.minFilter === (0, _threeCoreJs.NearestMipmapLinearFilter) || texture.minFilter === (0, _threeCoreJs.LinearMipmapLinearFilter))) (0, _threeCoreJs.warn)('WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device.');
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_S, wrappingToGL[texture.wrapS]);
        _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_T, wrappingToGL[texture.wrapT]);
        if (textureType === _gl.TEXTURE_3D || textureType === _gl.TEXTURE_2D_ARRAY) _gl.texParameteri(textureType, _gl.TEXTURE_WRAP_R, wrappingToGL[texture.wrapR]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MAG_FILTER, filterToGL[texture.magFilter]);
        _gl.texParameteri(textureType, _gl.TEXTURE_MIN_FILTER, filterToGL[texture.minFilter]);
        if (texture.compareFunction) {
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_MODE, _gl.COMPARE_REF_TO_TEXTURE);
            _gl.texParameteri(textureType, _gl.TEXTURE_COMPARE_FUNC, compareToGL[texture.compareFunction]);
        }
        if (extensions.has('EXT_texture_filter_anisotropic') === true) {
            if (texture.magFilter === (0, _threeCoreJs.NearestFilter)) return;
            if (texture.minFilter !== (0, _threeCoreJs.NearestMipmapLinearFilter) && texture.minFilter !== (0, _threeCoreJs.LinearMipmapLinearFilter)) return;
            if (texture.type === (0, _threeCoreJs.FloatType) && extensions.has('OES_texture_float_linear') === false) return; // verify extension
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                const extension = extensions.get('EXT_texture_filter_anisotropic');
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        let forceUpload = false;
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
        }
        // create Source <-> WebGLTextures mapping if necessary
        const source = texture.source;
        let webglTextures = _sources.get(source);
        if (webglTextures === undefined) {
            webglTextures = {};
            _sources.set(source, webglTextures);
        }
        // check if there is already a WebGLTexture object for the given texture parameters
        const textureCacheKey = getTextureCacheKey(texture);
        if (textureCacheKey !== textureProperties.__cacheKey) {
            // if not, create a new instance of WebGLTexture
            if (webglTextures[textureCacheKey] === undefined) {
                // create new entry
                webglTextures[textureCacheKey] = {
                    texture: _gl.createTexture(),
                    usedTimes: 0
                };
                info.memory.textures++;
                // when a new instance of WebGLTexture was created, a texture upload is required
                // even if the image contents are identical
                forceUpload = true;
            }
            webglTextures[textureCacheKey].usedTimes++;
            // every time the texture cache key changes, it's necessary to check if an instance of
            // WebGLTexture can be deleted in order to avoid a memory leak.
            const webglTexture = webglTextures[textureProperties.__cacheKey];
            if (webglTexture !== undefined) {
                webglTextures[textureProperties.__cacheKey].usedTimes--;
                if (webglTexture.usedTimes === 0) deleteTexture(texture);
            }
            // store references to cache key and WebGLTexture object
            textureProperties.__cacheKey = textureCacheKey;
            textureProperties.__webglTexture = webglTextures[textureCacheKey].texture;
        }
        return forceUpload;
    }
    function getRow(index, rowLength, componentStride) {
        return Math.floor(Math.floor(index / componentStride) / rowLength);
    }
    function updateTexture(texture, image, glFormat, glType) {
        const componentStride = 4; // only RGBA supported
        const updateRanges = texture.updateRanges;
        if (updateRanges.length === 0) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, image.width, image.height, glFormat, glType, image.data);
        else {
            // Before applying update ranges, we merge any adjacent / overlapping
            // ranges to reduce load on `gl.texSubImage2D`. Empirically, this has led
            // to performance improvements for applications which make heavy use of
            // update ranges. Likely due to GPU command overhead.
            //
            // Note that to reduce garbage collection between frames, we merge the
            // update ranges in-place. This is safe because this method will clear the
            // update ranges once updated.
            updateRanges.sort((a, b)=>a.start - b.start);
            // To merge the update ranges in-place, we work from left to right in the
            // existing updateRanges array, merging ranges. This may result in a final
            // array which is smaller than the original. This index tracks the last
            // index representing a merged range, any data after this index can be
            // trimmed once the merge algorithm is completed.
            let mergeIndex = 0;
            for(let i = 1; i < updateRanges.length; i++){
                const previousRange = updateRanges[mergeIndex];
                const range = updateRanges[i];
                // Only merge if in the same row and overlapping/adjacent
                const previousEnd = previousRange.start + previousRange.count;
                const currentRow = getRow(range.start, image.width, componentStride);
                const previousRow = getRow(previousRange.start, image.width, componentStride);
                // We add one here to merge adjacent ranges. This is safe because ranges
                // operate over positive integers.
                if (range.start <= previousEnd + 1 && currentRow === previousRow && getRow(range.start + range.count - 1, image.width, componentStride) === currentRow // ensure range doesn't spill
                ) previousRange.count = Math.max(previousRange.count, range.start + range.count - previousRange.start);
                else {
                    ++mergeIndex;
                    updateRanges[mergeIndex] = range;
                }
            }
            // Trim the array to only contain the merged ranges.
            updateRanges.length = mergeIndex + 1;
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            for(let i = 0, l = updateRanges.length; i < l; i++){
                const range = updateRanges[i];
                const pixelStart = Math.floor(range.start / componentStride);
                const pixelCount = Math.ceil(range.count / componentStride);
                const x = pixelStart % image.width;
                const y = Math.floor(pixelStart / image.width);
                // Assumes update ranges refer to contiguous memory
                const width = pixelCount;
                const height = 1;
                _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, x);
                _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, y);
                state.texSubImage2D(_gl.TEXTURE_2D, 0, x, y, width, height, glFormat, glType, image.data);
            }
            texture.clearUpdateRanges();
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = _gl.TEXTURE_2D;
        if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textureType = _gl.TEXTURE_2D_ARRAY;
        if (texture.isData3DTexture) textureType = _gl.TEXTURE_3D;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(textureType, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, _threeCoreJs.ColorManagement).getPrimaries((0, _threeCoreJs.ColorManagement).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, _threeCoreJs.NoColorSpace) ? null : (0, _threeCoreJs.ColorManagement).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, _threeCoreJs.NoColorSpace) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            let image = resizeImage(texture.image, false, capabilities.maxTextureSize);
            image = verifyColorSpace(texture, image);
            const glFormat = utils.convert(texture.format, texture.colorSpace);
            const glType = utils.convert(texture.type);
            let glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, texture.isVideoTexture);
            setTextureParameters(textureType, texture);
            let mipmap;
            const mipmaps = texture.mipmaps;
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            const levels = getMipLevels(texture, image);
            if (texture.isDepthTexture) {
                glInternalFormat = getInternalDepthFormat(texture.format === (0, _threeCoreJs.DepthStencilFormat), texture.type);
                //
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, 1, glInternalFormat, image.width, image.height);
                    else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
                }
            } else if (texture.isDataTexture) {
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    if (dataReady) updateTexture(texture, image, glFormat, glType);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
            } else if (texture.isCompressedTexture) {
                if (texture.isCompressedArrayTexture) {
                    if (useTexStorage && allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height, image.depth);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, _threeCoreJs.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) {
                                        if (texture.layerUpdates.size > 0) {
                                            const layerByteLength = (0, _threeCoreJs.getByteLength)(mipmap.width, mipmap.height, texture.format, texture.type);
                                            for (const layerIndex of texture.layerUpdates){
                                                const layerData = mipmap.data.subarray(layerIndex * layerByteLength / mipmap.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / mipmap.data.BYTES_PER_ELEMENT);
                                                state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, layerIndex, mipmap.width, mipmap.height, 1, glFormat, layerData);
                                            }
                                            texture.clearLayerUpdates();
                                        } else state.compressedTexSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, mipmap.data);
                                    }
                                } else state.compressedTexImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, mipmap.data, 0, 0);
                            } else (0, _threeCoreJs.warn)('WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, i, 0, 0, 0, mipmap.width, mipmap.height, image.depth, glFormat, glType, mipmap.data);
                            } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, i, glInternalFormat, mipmap.width, mipmap.height, image.depth, 0, glFormat, glType, mipmap.data);
                        }
                    }
                } else {
                    if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, mipmaps[0].width, mipmaps[0].height);
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (texture.format !== (0, _threeCoreJs.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else (0, _threeCoreJs.warn)('WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else if (texture.isDataArrayTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_2D_ARRAY, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) {
                        if (texture.layerUpdates.size > 0) {
                            const layerByteLength = (0, _threeCoreJs.getByteLength)(image.width, image.height, texture.format, texture.type);
                            for (const layerIndex of texture.layerUpdates){
                                const layerData = image.data.subarray(layerIndex * layerByteLength / image.data.BYTES_PER_ELEMENT, (layerIndex + 1) * layerByteLength / image.data.BYTES_PER_ELEMENT);
                                state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, layerIndex, image.width, image.height, 1, glFormat, glType, layerData);
                            }
                            texture.clearLayerUpdates();
                        } else state.texSubImage3D(_gl.TEXTURE_2D_ARRAY, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                    }
                } else state.texImage3D(_gl.TEXTURE_2D_ARRAY, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isData3DTexture) {
                if (useTexStorage) {
                    if (allocateMemory) state.texStorage3D(_gl.TEXTURE_3D, levels, glInternalFormat, image.width, image.height, image.depth);
                    if (dataReady) state.texSubImage3D(_gl.TEXTURE_3D, 0, 0, 0, 0, image.width, image.height, image.depth, glFormat, glType, image.data);
                } else state.texImage3D(_gl.TEXTURE_3D, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            } else if (texture.isFramebufferTexture) {
                if (allocateMemory) {
                    if (useTexStorage) state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, image.width, image.height);
                    else {
                        let width = image.width, height = image.height;
                        for(let i = 0; i < levels; i++){
                            state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, width, height, 0, glFormat, glType, null);
                            width >>= 1;
                            height >>= 1;
                        }
                    }
                }
            } else {
                // regular Texture (image, video, canvas)
                // use manually created mipmaps if available
                // if there are no manual mipmaps
                // set 0 level mipmap and then use GL to generate other mipmap levels
                if (mipmaps.length > 0) {
                    if (useTexStorage && allocateMemory) {
                        const dimensions = getDimensions(mipmaps[0]);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    for(let i = 0, il = mipmaps.length; i < il; i++){
                        mipmap = mipmaps[i];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, i, 0, 0, glFormat, glType, mipmap);
                        } else state.texImage2D(_gl.TEXTURE_2D, i, glInternalFormat, glFormat, glType, mipmap);
                    }
                    texture.generateMipmaps = false;
                } else if (useTexStorage) {
                    if (allocateMemory) {
                        const dimensions = getDimensions(image);
                        state.texStorage2D(_gl.TEXTURE_2D, levels, glInternalFormat, dimensions.width, dimensions.height);
                    }
                    if (dataReady) state.texSubImage2D(_gl.TEXTURE_2D, 0, 0, 0, glFormat, glType, image);
                } else state.texImage2D(_gl.TEXTURE_2D, 0, glInternalFormat, glFormat, glType, image);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(textureType);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        const forceUpload = initTexture(textureProperties, texture);
        const source = texture.source;
        state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture, _gl.TEXTURE0 + slot);
        const sourceProperties = properties.get(source);
        if (source.version !== sourceProperties.__version || forceUpload === true) {
            state.activeTexture(_gl.TEXTURE0 + slot);
            const workingPrimaries = (0, _threeCoreJs.ColorManagement).getPrimaries((0, _threeCoreJs.ColorManagement).workingColorSpace);
            const texturePrimaries = texture.colorSpace === (0, _threeCoreJs.NoColorSpace) ? null : (0, _threeCoreJs.ColorManagement).getPrimaries(texture.colorSpace);
            const unpackConversion = texture.colorSpace === (0, _threeCoreJs.NoColorSpace) || workingPrimaries === texturePrimaries ? _gl.NONE : _gl.BROWSER_DEFAULT_WEBGL;
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, texture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, texture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, texture.unpackAlignment);
            _gl.pixelStorei(_gl.UNPACK_COLORSPACE_CONVERSION_WEBGL, unpackConversion);
            const isCompressed = texture.isCompressedTexture || texture.image[0].isCompressedTexture;
            const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
            const cubeImage = [];
            for(let i = 0; i < 6; i++){
                if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], true, capabilities.maxCubemapSize);
                else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
                cubeImage[i] = verifyColorSpace(texture, cubeImage[i]);
            }
            const image = cubeImage[0], glFormat = utils.convert(texture.format, texture.colorSpace), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
            const useTexStorage = texture.isVideoTexture !== true;
            const allocateMemory = sourceProperties.__version === undefined || forceUpload === true;
            const dataReady = source.dataReady;
            let levels = getMipLevels(texture, image);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            let mipmaps;
            if (isCompressed) {
                if (useTexStorage && allocateMemory) state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, image.width, image.height);
                for(let i = 0; i < 6; i++){
                    mipmaps = cubeImage[i].mipmaps;
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (texture.format !== (0, _threeCoreJs.RGBAFormat)) {
                            if (glFormat !== null) {
                                if (useTexStorage) {
                                    if (dataReady) state.compressedTexSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, mipmap.data);
                                } else state.compressedTexImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                            } else (0, _threeCoreJs.warn)('WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                        } else {
                            if (useTexStorage) {
                                if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, 0, 0, mipmap.width, mipmap.height, glFormat, glType, mipmap.data);
                            } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                        }
                    }
                }
            } else {
                mipmaps = texture.mipmaps;
                if (useTexStorage && allocateMemory) {
                    // TODO: Uniformly handle mipmap definitions
                    // Normal textures and compressed cube textures define base level + mips with their mipmap array
                    // Uncompressed cube textures use their mipmap array only for mips (no base level)
                    if (mipmaps.length > 0) levels++;
                    const dimensions = getDimensions(cubeImage[0]);
                    state.texStorage2D(_gl.TEXTURE_CUBE_MAP, levels, glInternalFormat, dimensions.width, dimensions.height);
                }
                for(let i = 0; i < 6; i++)if (isDataTexture) {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, cubeImage[i].width, cubeImage[i].height, glFormat, glType, cubeImage[i].data);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        const mipmapImage = mipmap.image[i].image;
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, mipmapImage.width, mipmapImage.height, glFormat, glType, mipmapImage.data);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                    }
                } else {
                    if (useTexStorage) {
                        if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, 0, 0, glFormat, glType, cubeImage[i]);
                    } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                    for(let j = 0; j < mipmaps.length; j++){
                        const mipmap = mipmaps[j];
                        if (useTexStorage) {
                            if (dataReady) state.texSubImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, 0, 0, glFormat, glType, mipmap.image[i]);
                        } else state.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                    }
                }
            }
            if (textureNeedsGenerateMipmaps(texture)) // We assume images for cube map have the same size.
            generateMipmap(_gl.TEXTURE_CUBE_MAP);
            sourceProperties.__version = source.version;
            if (texture.onUpdate) texture.onUpdate(texture);
        }
        textureProperties.__version = texture.version;
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, texture, attachment, textureTarget, level) {
        const glFormat = utils.convert(texture.format, texture.colorSpace);
        const glType = utils.convert(texture.type);
        const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        textureProperties.__renderTarget = renderTarget;
        if (!renderTargetProperties.__hasExternalTextures) {
            const width = Math.max(1, renderTarget.width >> level);
            const height = Math.max(1, renderTarget.height >> level);
            if (textureTarget === _gl.TEXTURE_3D || textureTarget === _gl.TEXTURE_2D_ARRAY) state.texImage3D(textureTarget, level, glInternalFormat, width, height, renderTarget.depth, 0, glFormat, glType, null);
            else state.texImage2D(textureTarget, level, glInternalFormat, width, height, 0, glFormat, glType, null);
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, 0, getRenderTargetSamples(renderTarget));
        else if (textureTarget === _gl.TEXTURE_2D || textureTarget >= _gl.TEXTURE_CUBE_MAP_POSITIVE_X && textureTarget <= _gl.TEXTURE_CUBE_MAP_NEGATIVE_Z) _gl.framebufferTexture2D(_gl.FRAMEBUFFER, attachment, textureTarget, textureProperties.__webglTexture, level);
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, useMultisample) {
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
        if (renderTarget.depthBuffer) {
            // retrieve the depth attachment types
            const depthTexture = renderTarget.depthTexture;
            const depthType = depthTexture && depthTexture.isDepthTexture ? depthTexture.type : null;
            const glInternalFormat = getInternalDepthFormat(renderTarget.stencilBuffer, depthType);
            const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
            // set up the attachment
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
            else if (useMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
            else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
        } else {
            const textures = renderTarget.textures;
            for(let i = 0; i < textures.length; i++){
                const texture = textures[i];
                const glFormat = utils.convert(texture.format, texture.colorSpace);
                const glType = utils.convert(texture.type);
                const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace);
                if (useMultisampledRTT(renderTarget)) multisampledRTTExt.renderbufferStorageMultisampleEXT(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
                else if (useMultisample) _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, getRenderTargetSamples(renderTarget), glInternalFormat, renderTarget.width, renderTarget.height);
                else _gl.renderbufferStorage(_gl.RENDERBUFFER, glInternalFormat, renderTarget.width, renderTarget.height);
            }
        }
        _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget, cubeFace) {
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        const textureProperties = properties.get(renderTarget.depthTexture);
        textureProperties.__renderTarget = renderTarget;
        // upload an empty depth texture with framebuffer size
        if (!textureProperties.__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        if (isCube) {
            // For cube depth textures, initialize and bind without uploading image data
            if (textureProperties.__webglInit === undefined) {
                textureProperties.__webglInit = true;
                renderTarget.depthTexture.addEventListener('dispose', onTextureDispose);
            }
            // Only create and allocate storage once
            if (textureProperties.__webglTexture === undefined) {
                textureProperties.__webglTexture = _gl.createTexture();
                state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
                setTextureParameters(_gl.TEXTURE_CUBE_MAP, renderTarget.depthTexture);
                // Allocate storage for all 6 faces with correct depth texture format
                const glFormat = utils.convert(renderTarget.depthTexture.format);
                const glType = utils.convert(renderTarget.depthTexture.type);
                // Use proper internal format for depth textures
                let glInternalFormat;
                if (renderTarget.depthTexture.format === (0, _threeCoreJs.DepthFormat)) glInternalFormat = _gl.DEPTH_COMPONENT24;
                else if (renderTarget.depthTexture.format === (0, _threeCoreJs.DepthStencilFormat)) glInternalFormat = _gl.DEPTH24_STENCIL8;
                for(let i = 0; i < 6; i++)_gl.texImage2D(_gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
            }
        } else setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = textureProperties.__webglTexture;
        const samples = getRenderTargetSamples(renderTarget);
        const glTextureType = isCube ? _gl.TEXTURE_CUBE_MAP_POSITIVE_X + cubeFace : _gl.TEXTURE_2D;
        const glAttachmentType = renderTarget.depthTexture.format === (0, _threeCoreJs.DepthStencilFormat) ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
        if (renderTarget.depthTexture.format === (0, _threeCoreJs.DepthFormat)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0);
        } else if (renderTarget.depthTexture.format === (0, _threeCoreJs.DepthStencilFormat)) {
            if (useMultisampledRTT(renderTarget)) multisampledRTTExt.framebufferTexture2DMultisampleEXT(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0, samples);
            else _gl.framebufferTexture2D(_gl.FRAMEBUFFER, glAttachmentType, glTextureType, webglDepthTexture, 0);
        } else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        // if the bound depth texture has changed
        if (renderTargetProperties.__boundDepthTexture !== renderTarget.depthTexture) {
            // fire the dispose event to get rid of stored state associated with the previously bound depth buffer
            const depthTexture = renderTarget.depthTexture;
            if (renderTargetProperties.__depthDisposeCallback) renderTargetProperties.__depthDisposeCallback();
            // set up dispose listeners to track when the currently attached buffer is implicitly unbound
            if (depthTexture) {
                const disposeEvent = ()=>{
                    delete renderTargetProperties.__boundDepthTexture;
                    delete renderTargetProperties.__depthDisposeCallback;
                    depthTexture.removeEventListener('dispose', disposeEvent);
                };
                depthTexture.addEventListener('dispose', disposeEvent);
                renderTargetProperties.__depthDisposeCallback = disposeEvent;
            }
            renderTargetProperties.__boundDepthTexture = depthTexture;
        }
        if (renderTarget.depthTexture && !renderTargetProperties.__autoAllocateDepthBuffer) {
            if (isCube) // For cube render targets with depth texture, setup each face
            for(let i = 0; i < 6; i++)setupDepthTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, i);
            else {
                const mipmaps = renderTarget.texture.mipmaps;
                if (mipmaps && mipmaps.length > 0) setupDepthTexture(renderTargetProperties.__webglFramebuffer[0], renderTarget, 0);
                else setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget, 0);
            }
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[i]);
                if (renderTargetProperties.__webglDepthbuffer[i] === undefined) {
                    renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
                } else {
                    // attach buffer if it's been created already
                    const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                    const renderbuffer = renderTargetProperties.__webglDepthbuffer[i];
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
                }
            }
        } else {
            const mipmaps = renderTarget.texture.mipmaps;
            if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
            else state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer === undefined) {
                renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
            } else {
                // attach buffer if it's been created already
                const glAttachmentType = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderbuffer = renderTargetProperties.__webglDepthbuffer;
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderbuffer);
                _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, glAttachmentType, _gl.RENDERBUFFER, renderbuffer);
            }
        }
        state.bindFramebuffer(_gl.FRAMEBUFFER, null);
    }
    // rebind framebuffer with external textures
    function rebindTextures(renderTarget, colorTexture, depthTexture) {
        const renderTargetProperties = properties.get(renderTarget);
        if (colorTexture !== undefined) setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, renderTarget.texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, 0);
        if (depthTexture !== undefined) setupDepthRenderbuffer(renderTarget);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const texture = renderTarget.texture;
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        const textures = renderTarget.textures;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultipleRenderTargets = textures.length > 1;
        if (!isMultipleRenderTargets) {
            if (textureProperties.__webglTexture === undefined) textureProperties.__webglTexture = _gl.createTexture();
            textureProperties.__version = texture.version;
            info.memory.textures++;
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer[i] = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[i][level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            if (texture.mipmaps && texture.mipmaps.length > 0) {
                renderTargetProperties.__webglFramebuffer = [];
                for(let level = 0; level < texture.mipmaps.length; level++)renderTargetProperties.__webglFramebuffer[level] = _gl.createFramebuffer();
            } else renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultipleRenderTargets) for(let i = 0, il = textures.length; i < il; i++){
                const attachmentProperties = properties.get(textures[i]);
                if (attachmentProperties.__webglTexture === undefined) {
                    attachmentProperties.__webglTexture = _gl.createTexture();
                    info.memory.textures++;
                }
            }
            if (renderTarget.samples > 0 && useMultisampledRTT(renderTarget) === false) {
                renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                renderTargetProperties.__webglColorRenderbuffer = [];
                state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    const texture = textures[i];
                    renderTargetProperties.__webglColorRenderbuffer[i] = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(_gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const glFormat = utils.convert(texture.format, texture.colorSpace);
                    const glType = utils.convert(texture.type);
                    const glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType, texture.colorSpace, renderTarget.isXRRenderTarget === true);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(_gl.RENDERBUFFER, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                }
                _gl.bindRenderbuffer(_gl.RENDERBUFFER, null);
                if (renderTarget.depthBuffer) {
                    renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                    setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                }
                state.bindFramebuffer(_gl.FRAMEBUFFER, null);
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(_gl.TEXTURE_CUBE_MAP, textureProperties.__webglTexture);
            setTextureParameters(_gl.TEXTURE_CUBE_MAP, texture);
            for(let i = 0; i < 6; i++){
                if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i][level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, level);
                else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, texture, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + i, 0);
            }
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(_gl.TEXTURE_CUBE_MAP);
            state.unbindTexture();
        } else if (isMultipleRenderTargets) {
            for(let i = 0, il = textures.length; i < il; i++){
                const attachment = textures[i];
                const attachmentProperties = properties.get(attachment);
                let glTextureType = _gl.TEXTURE_2D;
                if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
                state.bindTexture(glTextureType, attachmentProperties.__webglTexture);
                setTextureParameters(glTextureType, attachment);
                setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, attachment, _gl.COLOR_ATTACHMENT0 + i, glTextureType, 0);
                if (textureNeedsGenerateMipmaps(attachment)) generateMipmap(glTextureType);
            }
            state.unbindTexture();
        } else {
            let glTextureType = _gl.TEXTURE_2D;
            if (renderTarget.isWebGL3DRenderTarget || renderTarget.isWebGLArrayRenderTarget) glTextureType = renderTarget.isWebGL3DRenderTarget ? _gl.TEXTURE_3D : _gl.TEXTURE_2D_ARRAY;
            state.bindTexture(glTextureType, textureProperties.__webglTexture);
            setTextureParameters(glTextureType, texture);
            if (texture.mipmaps && texture.mipmaps.length > 0) for(let level = 0; level < texture.mipmaps.length; level++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[level], renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, level);
            else setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, texture, _gl.COLOR_ATTACHMENT0, glTextureType, 0);
            if (textureNeedsGenerateMipmaps(texture)) generateMipmap(glTextureType);
            state.unbindTexture();
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const textures = renderTarget.textures;
        for(let i = 0, il = textures.length; i < il; i++){
            const texture = textures[i];
            if (textureNeedsGenerateMipmaps(texture)) {
                const targetType = getTargetType(renderTarget);
                const webglTexture = properties.get(texture).__webglTexture;
                state.bindTexture(targetType, webglTexture);
                generateMipmap(targetType);
                state.unbindTexture();
            }
        }
    }
    const invalidationArrayRead = [];
    const invalidationArrayDraw = [];
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.samples > 0) {
            if (useMultisampledRTT(renderTarget) === false) {
                const textures = renderTarget.textures;
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = _gl.COLOR_BUFFER_BIT;
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                const renderTargetProperties = properties.get(renderTarget);
                const isMultipleRenderTargets = textures.length > 1;
                // If MRT we need to remove FBO attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, null);
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, null, 0);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                const mipmaps = renderTarget.texture.mipmaps;
                if (mipmaps && mipmaps.length > 0) state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer[0]);
                else state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < textures.length; i++){
                    if (renderTarget.resolveDepthBuffer) {
                        if (renderTarget.depthBuffer) mask |= _gl.DEPTH_BUFFER_BIT;
                        // resolving stencil is slow with a D3D backend. disable it for all transmission render targets (see #27799)
                        if (renderTarget.stencilBuffer && renderTarget.resolveStencilBuffer) mask |= _gl.STENCIL_BUFFER_BIT;
                    }
                    if (isMultipleRenderTargets) {
                        _gl.framebufferRenderbuffer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                        const webglTexture = properties.get(textures[i]).__webglTexture;
                        _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, webglTexture, 0);
                    }
                    _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, _gl.NEAREST);
                    if (supportsInvalidateFramebuffer === true) {
                        invalidationArrayRead.length = 0;
                        invalidationArrayDraw.length = 0;
                        invalidationArrayRead.push(_gl.COLOR_ATTACHMENT0 + i);
                        if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false) {
                            invalidationArrayRead.push(depthStyle);
                            invalidationArrayDraw.push(depthStyle);
                            _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, invalidationArrayDraw);
                        }
                        _gl.invalidateFramebuffer(_gl.READ_FRAMEBUFFER, invalidationArrayRead);
                    }
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
                // If MRT since pre-blit we removed the FBO we need to reconstruct the attachments
                if (isMultipleRenderTargets) for(let i = 0; i < textures.length; i++){
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.RENDERBUFFER, renderTargetProperties.__webglColorRenderbuffer[i]);
                    const webglTexture = properties.get(textures[i]).__webglTexture;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, _gl.TEXTURE_2D, webglTexture, 0);
                }
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, renderTargetProperties.__webglMultisampledFramebuffer);
            } else if (renderTarget.depthBuffer && renderTarget.resolveDepthBuffer === false && supportsInvalidateFramebuffer) {
                const depthStyle = renderTarget.stencilBuffer ? _gl.DEPTH_STENCIL_ATTACHMENT : _gl.DEPTH_ATTACHMENT;
                _gl.invalidateFramebuffer(_gl.DRAW_FRAMEBUFFER, [
                    depthStyle
                ]);
            }
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return Math.min(capabilities.maxSamples, renderTarget.samples);
    }
    function useMultisampledRTT(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        return renderTarget.samples > 0 && extensions.has('WEBGL_multisampled_render_to_texture') === true && renderTargetProperties.__useRenderToTexture !== false;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    function verifyColorSpace(texture, image) {
        const colorSpace = texture.colorSpace;
        const format = texture.format;
        const type = texture.type;
        if (texture.isCompressedTexture === true || texture.isVideoTexture === true) return image;
        if (colorSpace !== (0, _threeCoreJs.LinearSRGBColorSpace) && colorSpace !== (0, _threeCoreJs.NoColorSpace)) {
            // sRGB
            if ((0, _threeCoreJs.ColorManagement).getTransfer(colorSpace) === (0, _threeCoreJs.SRGBTransfer)) // in WebGL 2 uncompressed textures can only be sRGB encoded if they have the RGBA8 format
            {
                if (format !== (0, _threeCoreJs.RGBAFormat) || type !== (0, _threeCoreJs.UnsignedByteType)) (0, _threeCoreJs.warn)('WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.');
            } else (0, _threeCoreJs.error)('WebGLTextures: Unsupported texture color space:', colorSpace);
        }
        return image;
    }
    function getDimensions(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement) {
            // if intrinsic data are not available, fallback to width/height
            _imageDimensions.width = image.naturalWidth || image.width;
            _imageDimensions.height = image.naturalHeight || image.height;
        } else if (typeof VideoFrame !== 'undefined' && image instanceof VideoFrame) {
            _imageDimensions.width = image.displayWidth;
            _imageDimensions.height = image.displayHeight;
        } else {
            _imageDimensions.width = image.width;
            _imageDimensions.height = image.height;
        }
        return _imageDimensions;
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.rebindTextures = rebindTextures;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.setupDepthRenderbuffer = setupDepthRenderbuffer;
    this.setupFrameBufferTexture = setupFrameBufferTexture;
    this.useMultisampledRTT = useMultisampledRTT;
    this.isReversedDepthBuffer = function() {
        return state.buffers.depth.getReversed();
    };
}
function WebGLUtils(gl, extensions) {
    function convert(p, colorSpace = (0, _threeCoreJs.NoColorSpace)) {
        let extension;
        const transfer = (0, _threeCoreJs.ColorManagement).getTransfer(colorSpace);
        if (p === (0, _threeCoreJs.UnsignedByteType)) return gl.UNSIGNED_BYTE;
        if (p === (0, _threeCoreJs.UnsignedShort4444Type)) return gl.UNSIGNED_SHORT_4_4_4_4;
        if (p === (0, _threeCoreJs.UnsignedShort5551Type)) return gl.UNSIGNED_SHORT_5_5_5_1;
        if (p === (0, _threeCoreJs.UnsignedInt5999Type)) return gl.UNSIGNED_INT_5_9_9_9_REV;
        if (p === (0, _threeCoreJs.UnsignedInt101111Type)) return gl.UNSIGNED_INT_10F_11F_11F_REV;
        if (p === (0, _threeCoreJs.ByteType)) return gl.BYTE;
        if (p === (0, _threeCoreJs.ShortType)) return gl.SHORT;
        if (p === (0, _threeCoreJs.UnsignedShortType)) return gl.UNSIGNED_SHORT;
        if (p === (0, _threeCoreJs.IntType)) return gl.INT;
        if (p === (0, _threeCoreJs.UnsignedIntType)) return gl.UNSIGNED_INT;
        if (p === (0, _threeCoreJs.FloatType)) return gl.FLOAT;
        if (p === (0, _threeCoreJs.HalfFloatType)) return gl.HALF_FLOAT;
        if (p === (0, _threeCoreJs.AlphaFormat)) return gl.ALPHA;
        if (p === (0, _threeCoreJs.RGBFormat)) return gl.RGB;
        if (p === (0, _threeCoreJs.RGBAFormat)) return gl.RGBA;
        if (p === (0, _threeCoreJs.DepthFormat)) return gl.DEPTH_COMPONENT;
        if (p === (0, _threeCoreJs.DepthStencilFormat)) return gl.DEPTH_STENCIL;
        // WebGL2 formats.
        if (p === (0, _threeCoreJs.RedFormat)) return gl.RED;
        if (p === (0, _threeCoreJs.RedIntegerFormat)) return gl.RED_INTEGER;
        if (p === (0, _threeCoreJs.RGFormat)) return gl.RG;
        if (p === (0, _threeCoreJs.RGIntegerFormat)) return gl.RG_INTEGER;
        if (p === (0, _threeCoreJs.RGBAIntegerFormat)) return gl.RGBA_INTEGER;
        // S3TC
        if (p === (0, _threeCoreJs.RGB_S3TC_DXT1_Format) || p === (0, _threeCoreJs.RGBA_S3TC_DXT1_Format) || p === (0, _threeCoreJs.RGBA_S3TC_DXT3_Format) || p === (0, _threeCoreJs.RGBA_S3TC_DXT5_Format)) {
            if (transfer === (0, _threeCoreJs.SRGBTransfer)) {
                extension = extensions.get('WEBGL_compressed_texture_s3tc_srgb');
                if (extension !== null) {
                    if (p === (0, _threeCoreJs.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                    if (p === (0, _threeCoreJs.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                    if (p === (0, _threeCoreJs.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                    if (p === (0, _threeCoreJs.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                } else return null;
            } else {
                extension = extensions.get('WEBGL_compressed_texture_s3tc');
                if (extension !== null) {
                    if (p === (0, _threeCoreJs.RGB_S3TC_DXT1_Format)) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                    if (p === (0, _threeCoreJs.RGBA_S3TC_DXT1_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                    if (p === (0, _threeCoreJs.RGBA_S3TC_DXT3_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                    if (p === (0, _threeCoreJs.RGBA_S3TC_DXT5_Format)) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                } else return null;
            }
        }
        // PVRTC
        if (p === (0, _threeCoreJs.RGB_PVRTC_4BPPV1_Format) || p === (0, _threeCoreJs.RGB_PVRTC_2BPPV1_Format) || p === (0, _threeCoreJs.RGBA_PVRTC_4BPPV1_Format) || p === (0, _threeCoreJs.RGBA_PVRTC_2BPPV1_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === (0, _threeCoreJs.RGB_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === (0, _threeCoreJs.RGB_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === (0, _threeCoreJs.RGBA_PVRTC_4BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === (0, _threeCoreJs.RGBA_PVRTC_2BPPV1_Format)) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        // ETC
        if (p === (0, _threeCoreJs.RGB_ETC1_Format) || p === (0, _threeCoreJs.RGB_ETC2_Format) || p === (0, _threeCoreJs.RGBA_ETC2_EAC_Format) || p === (0, _threeCoreJs.R11_EAC_Format) || p === (0, _threeCoreJs.SIGNED_R11_EAC_Format) || p === (0, _threeCoreJs.RG11_EAC_Format) || p === (0, _threeCoreJs.SIGNED_RG11_EAC_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === (0, _threeCoreJs.RGB_ETC1_Format) || p === (0, _threeCoreJs.RGB_ETC2_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ETC2 : extension.COMPRESSED_RGB8_ETC2;
                if (p === (0, _threeCoreJs.RGBA_ETC2_EAC_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : extension.COMPRESSED_RGBA8_ETC2_EAC;
                if (p === (0, _threeCoreJs.R11_EAC_Format)) return extension.COMPRESSED_R11_EAC;
                if (p === (0, _threeCoreJs.SIGNED_R11_EAC_Format)) return extension.COMPRESSED_SIGNED_R11_EAC;
                if (p === (0, _threeCoreJs.RG11_EAC_Format)) return extension.COMPRESSED_RG11_EAC;
                if (p === (0, _threeCoreJs.SIGNED_RG11_EAC_Format)) return extension.COMPRESSED_SIGNED_RG11_EAC;
            } else return null;
        }
        // ASTC
        if (p === (0, _threeCoreJs.RGBA_ASTC_4x4_Format) || p === (0, _threeCoreJs.RGBA_ASTC_5x4_Format) || p === (0, _threeCoreJs.RGBA_ASTC_5x5_Format) || p === (0, _threeCoreJs.RGBA_ASTC_6x5_Format) || p === (0, _threeCoreJs.RGBA_ASTC_6x6_Format) || p === (0, _threeCoreJs.RGBA_ASTC_8x5_Format) || p === (0, _threeCoreJs.RGBA_ASTC_8x6_Format) || p === (0, _threeCoreJs.RGBA_ASTC_8x8_Format) || p === (0, _threeCoreJs.RGBA_ASTC_10x5_Format) || p === (0, _threeCoreJs.RGBA_ASTC_10x6_Format) || p === (0, _threeCoreJs.RGBA_ASTC_10x8_Format) || p === (0, _threeCoreJs.RGBA_ASTC_10x10_Format) || p === (0, _threeCoreJs.RGBA_ASTC_12x10_Format) || p === (0, _threeCoreJs.RGBA_ASTC_12x12_Format)) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) {
                if (p === (0, _threeCoreJs.RGBA_ASTC_4x4_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : extension.COMPRESSED_RGBA_ASTC_4x4_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_5x4_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : extension.COMPRESSED_RGBA_ASTC_5x4_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_5x5_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : extension.COMPRESSED_RGBA_ASTC_5x5_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_6x5_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : extension.COMPRESSED_RGBA_ASTC_6x5_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_6x6_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : extension.COMPRESSED_RGBA_ASTC_6x6_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_8x5_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : extension.COMPRESSED_RGBA_ASTC_8x5_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_8x6_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : extension.COMPRESSED_RGBA_ASTC_8x6_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_8x8_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : extension.COMPRESSED_RGBA_ASTC_8x8_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_10x5_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : extension.COMPRESSED_RGBA_ASTC_10x5_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_10x6_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : extension.COMPRESSED_RGBA_ASTC_10x6_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_10x8_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : extension.COMPRESSED_RGBA_ASTC_10x8_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_10x10_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : extension.COMPRESSED_RGBA_ASTC_10x10_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_12x10_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : extension.COMPRESSED_RGBA_ASTC_12x10_KHR;
                if (p === (0, _threeCoreJs.RGBA_ASTC_12x12_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : extension.COMPRESSED_RGBA_ASTC_12x12_KHR;
            } else return null;
        }
        // BPTC
        if (p === (0, _threeCoreJs.RGBA_BPTC_Format) || p === (0, _threeCoreJs.RGB_BPTC_SIGNED_Format) || p === (0, _threeCoreJs.RGB_BPTC_UNSIGNED_Format)) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) {
                if (p === (0, _threeCoreJs.RGBA_BPTC_Format)) return transfer === (0, _threeCoreJs.SRGBTransfer) ? extension.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : extension.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                if (p === (0, _threeCoreJs.RGB_BPTC_SIGNED_Format)) return extension.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                if (p === (0, _threeCoreJs.RGB_BPTC_UNSIGNED_Format)) return extension.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
            } else return null;
        }
        // RGTC
        if (p === (0, _threeCoreJs.RED_RGTC1_Format) || p === (0, _threeCoreJs.SIGNED_RED_RGTC1_Format) || p === (0, _threeCoreJs.RED_GREEN_RGTC2_Format) || p === (0, _threeCoreJs.SIGNED_RED_GREEN_RGTC2_Format)) {
            extension = extensions.get('EXT_texture_compression_rgtc');
            if (extension !== null) {
                if (p === (0, _threeCoreJs.RED_RGTC1_Format)) return extension.COMPRESSED_RED_RGTC1_EXT;
                if (p === (0, _threeCoreJs.SIGNED_RED_RGTC1_Format)) return extension.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                if (p === (0, _threeCoreJs.RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_RED_GREEN_RGTC2_EXT;
                if (p === (0, _threeCoreJs.SIGNED_RED_GREEN_RGTC2_Format)) return extension.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
            } else return null;
        }
        //
        if (p === (0, _threeCoreJs.UnsignedInt248Type)) return gl.UNSIGNED_INT_24_8;
        // if "p" can't be resolved, assume the user defines a WebGL constant as a string (fallback/workaround for packed RGB formats)
        return gl[p] !== undefined ? gl[p] : null;
    }
    return {
        convert: convert
    };
}
const _occlusion_vertex = `
void main() {

	gl_Position = vec4( position, 1.0 );

}`;
const _occlusion_fragment = `
uniform sampler2DArray depthColor;
uniform float depthWidth;
uniform float depthHeight;

void main() {

	vec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );

	if ( coord.x >= 1.0 ) {

		gl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;

	} else {

		gl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;

	}

}`;
/**
 * A XR module that manages the access to the Depth Sensing API.
 */ class WebXRDepthSensing {
    /**
	 * Constructs a new depth sensing module.
	 */ constructor(){
        /**
		 * An opaque texture representing the depth of the user's environment.
		 *
		 * @type {?ExternalTexture}
		 */ this.texture = null;
        /**
		 * A plane mesh for visualizing the depth texture.
		 *
		 * @type {?Mesh}
		 */ this.mesh = null;
        /**
		 * The depth near value.
		 *
		 * @type {number}
		 */ this.depthNear = 0;
        /**
		 * The depth near far.
		 *
		 * @type {number}
		 */ this.depthFar = 0;
    }
    /**
	 * Inits the depth sensing module
	 *
	 * @param {XRWebGLDepthInformation} depthData - The XR depth data.
	 * @param {XRRenderState} renderState - The XR render state.
	 */ init(depthData, renderState) {
        if (this.texture === null) {
            const texture = new (0, _threeCoreJs.ExternalTexture)(depthData.texture);
            if (depthData.depthNear !== renderState.depthNear || depthData.depthFar !== renderState.depthFar) {
                this.depthNear = depthData.depthNear;
                this.depthFar = depthData.depthFar;
            }
            this.texture = texture;
        }
    }
    /**
	 * Returns a plane mesh that visualizes the depth texture.
	 *
	 * @param {ArrayCamera} cameraXR - The XR camera.
	 * @return {?Mesh} The plane mesh.
	 */ getMesh(cameraXR) {
        if (this.texture !== null) {
            if (this.mesh === null) {
                const viewport = cameraXR.cameras[0].viewport;
                const material = new (0, _threeCoreJs.ShaderMaterial)({
                    vertexShader: _occlusion_vertex,
                    fragmentShader: _occlusion_fragment,
                    uniforms: {
                        depthColor: {
                            value: this.texture
                        },
                        depthWidth: {
                            value: viewport.z
                        },
                        depthHeight: {
                            value: viewport.w
                        }
                    }
                });
                this.mesh = new (0, _threeCoreJs.Mesh)(new (0, _threeCoreJs.PlaneGeometry)(20, 20), material);
            }
        }
        return this.mesh;
    }
    /**
	 * Resets the module
	 */ reset() {
        this.texture = null;
        this.mesh = null;
    }
    /**
	 * Returns a texture representing the depth of the user's environment.
	 *
	 * @return {?ExternalTexture} The depth texture.
	 */ getDepthTexture() {
        return this.texture;
    }
}
/**
 * This class represents an abstraction of the WebXR Device API and is
 * internally used by {@link WebGLRenderer}. `WebXRManager` also provides a public
 * interface that allows users to enable/disable XR and perform XR related
 * tasks like for instance retrieving controllers.
 *
 * @augments EventDispatcher
 * @hideconstructor
 */ class WebXRManager extends (0, _threeCoreJs.EventDispatcher) {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {WebGL2RenderingContext} gl - The rendering context.
	 */ constructor(renderer, gl){
        super();
        const scope = this;
        let session = null;
        let framebufferScaleFactor = 1.0;
        let referenceSpace = null;
        let referenceSpaceType = 'local-floor';
        // Set default foveation to maximum.
        let foveation = 1.0;
        let customReferenceSpace = null;
        let pose = null;
        let glBinding = null;
        let glProjLayer = null;
        let glBaseLayer = null;
        let xrFrame = null;
        const supportsGlBinding = typeof XRWebGLBinding !== 'undefined';
        const depthSensing = new WebXRDepthSensing();
        const cameraAccessTextures = {};
        const attributes = gl.getContextAttributes();
        let initialRenderTarget = null;
        let newRenderTarget = null;
        const controllers = [];
        const controllerInputSources = [];
        const currentSize = new (0, _threeCoreJs.Vector2)();
        let currentPixelRatio = null;
        //
        const cameraL = new (0, _threeCoreJs.PerspectiveCamera)();
        cameraL.viewport = new (0, _threeCoreJs.Vector4)();
        const cameraR = new (0, _threeCoreJs.PerspectiveCamera)();
        cameraR.viewport = new (0, _threeCoreJs.Vector4)();
        const cameras = [
            cameraL,
            cameraR
        ];
        const cameraXR = new (0, _threeCoreJs.ArrayCamera)();
        let _currentDepthNear = null;
        let _currentDepthFar = null;
        //
        /**
		 * Whether the manager's XR camera should be automatically updated or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.cameraAutoUpdate = true;
        /**
		 * This flag notifies the renderer to be ready for XR rendering. Set it to `true`
		 * if you are going to use XR in your app.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.enabled = false;
        /**
		 * Whether XR presentation is active or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPresenting = false;
        /**
		 * Returns a group representing the `target ray` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `target ray` space.
		 */ this.getController = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, _threeCoreJs.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getTargetRaySpace();
        };
        /**
		 * Returns a group representing the `grip` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * Note: If you want to show something in the user's hand AND offer a
		 * pointing ray at the same time, you'll want to attached the handheld object
		 * to the group returned by `getControllerGrip()` and the ray to the
		 * group returned by `getController()`. The idea is to have two
		 * different groups in two different coordinate spaces for the same WebXR
		 * controller.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `grip` space.
		 */ this.getControllerGrip = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, _threeCoreJs.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getGripSpace();
        };
        /**
		 * Returns a group representing the `hand` space of the XR controller.
		 * Use this space for visualizing 3D objects that support the user in pointing
		 * tasks like UI interaction.
		 *
		 * @param {number} index - The index of the controller.
		 * @return {Group} A group representing the `hand` space.
		 */ this.getHand = function(index) {
            let controller = controllers[index];
            if (controller === undefined) {
                controller = new (0, _threeCoreJs.WebXRController)();
                controllers[index] = controller;
            }
            return controller.getHandSpace();
        };
        //
        function onSessionEvent(event) {
            const controllerIndex = controllerInputSources.indexOf(event.inputSource);
            if (controllerIndex === -1) return;
            const controller = controllers[controllerIndex];
            if (controller !== undefined) {
                controller.update(event.inputSource, event.frame, customReferenceSpace || referenceSpace);
                controller.dispatchEvent({
                    type: event.type,
                    data: event.inputSource
                });
            }
        }
        function onSessionEnd() {
            session.removeEventListener('select', onSessionEvent);
            session.removeEventListener('selectstart', onSessionEvent);
            session.removeEventListener('selectend', onSessionEvent);
            session.removeEventListener('squeeze', onSessionEvent);
            session.removeEventListener('squeezestart', onSessionEvent);
            session.removeEventListener('squeezeend', onSessionEvent);
            session.removeEventListener('end', onSessionEnd);
            session.removeEventListener('inputsourceschange', onInputSourcesChange);
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                if (inputSource === null) continue;
                controllerInputSources[i] = null;
                controllers[i].disconnect(inputSource);
            }
            _currentDepthNear = null;
            _currentDepthFar = null;
            depthSensing.reset();
            for(const key in cameraAccessTextures)delete cameraAccessTextures[key];
            // restore framebuffer/rendering state
            renderer.setRenderTarget(initialRenderTarget);
            glBaseLayer = null;
            glProjLayer = null;
            glBinding = null;
            session = null;
            newRenderTarget = null;
            //
            animation.stop();
            scope.isPresenting = false;
            renderer.setPixelRatio(currentPixelRatio);
            renderer.setSize(currentSize.width, currentSize.height, false);
            scope.dispatchEvent({
                type: 'sessionend'
            });
        }
        /**
		 * Sets the framebuffer scale factor.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {number} value - The framebuffer scale factor.
		 */ this.setFramebufferScaleFactor = function(value) {
            framebufferScaleFactor = value;
            if (scope.isPresenting === true) (0, _threeCoreJs.warn)('WebXRManager: Cannot change framebuffer scale while presenting.');
        };
        /**
		 * Sets the reference space type. Can be used to configure a spatial relationship with the user's physical
		 * environment. Depending on how the user moves in 3D space, setting an appropriate reference space can
		 * improve tracking. Default is `local-floor`. Valid values can be found here
		 * https://developer.mozilla.org/en-US/docs/Web/API/XRReferenceSpace#reference_space_types.
		 *
		 * This method can not be used during a XR session.
		 *
		 * @param {string} value - The reference space type.
		 */ this.setReferenceSpaceType = function(value) {
            referenceSpaceType = value;
            if (scope.isPresenting === true) (0, _threeCoreJs.warn)('WebXRManager: Cannot change reference space type while presenting.');
        };
        /**
		 * Returns the XR reference space.
		 *
		 * @return {XRReferenceSpace} The XR reference space.
		 */ this.getReferenceSpace = function() {
            return customReferenceSpace || referenceSpace;
        };
        /**
		 * Sets a custom XR reference space.
		 *
		 * @param {XRReferenceSpace} space - The XR reference space.
		 */ this.setReferenceSpace = function(space) {
            customReferenceSpace = space;
        };
        /**
		 * Returns the current base layer.
		 *
		 * This is an `XRProjectionLayer` when the targeted XR device supports the
		 * WebXR Layers API, or an `XRWebGLLayer` otherwise.
		 *
		 * @return {?(XRWebGLLayer|XRProjectionLayer)} The XR base layer.
		 */ this.getBaseLayer = function() {
            return glProjLayer !== null ? glProjLayer : glBaseLayer;
        };
        /**
		 * Returns the current XR binding.
		 *
		 * Creates a new binding if needed and the browser is
		 * capable of doing so.
		 *
		 * @return {?XRWebGLBinding} The XR binding. Returns `null` if one cannot be created.
		 */ this.getBinding = function() {
            if (glBinding === null && supportsGlBinding) glBinding = new XRWebGLBinding(session, gl);
            return glBinding;
        };
        /**
		 * Returns the current XR frame.
		 *
		 * @return {?XRFrame} The XR frame. Returns `null` when used outside a XR session.
		 */ this.getFrame = function() {
            return xrFrame;
        };
        /**
		 * Returns the current XR session.
		 *
		 * @return {?XRSession} The XR session. Returns `null` when used outside a XR session.
		 */ this.getSession = function() {
            return session;
        };
        /**
		 * After a XR session has been requested usually with one of the `*Button` modules, it
		 * is injected into the renderer with this method. This method triggers the start of
		 * the actual XR rendering.
		 *
		 * @async
		 * @param {XRSession} value - The XR session to set.
		 * @return {Promise} A Promise that resolves when the session has been set.
		 */ this.setSession = async function(value) {
            session = value;
            if (session !== null) {
                initialRenderTarget = renderer.getRenderTarget();
                session.addEventListener('select', onSessionEvent);
                session.addEventListener('selectstart', onSessionEvent);
                session.addEventListener('selectend', onSessionEvent);
                session.addEventListener('squeeze', onSessionEvent);
                session.addEventListener('squeezestart', onSessionEvent);
                session.addEventListener('squeezeend', onSessionEvent);
                session.addEventListener('end', onSessionEnd);
                session.addEventListener('inputsourceschange', onInputSourcesChange);
                if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
                currentPixelRatio = renderer.getPixelRatio();
                renderer.getSize(currentSize);
                // Check that the browser implements the necessary APIs to use an
                // XRProjectionLayer rather than an XRWebGLLayer
                const supportsLayers = supportsGlBinding && 'createProjectionLayer' in XRWebGLBinding.prototype;
                if (!supportsLayers) {
                    const layerInit = {
                        antialias: attributes.antialias,
                        alpha: true,
                        depth: attributes.depth,
                        stencil: attributes.stencil,
                        framebufferScaleFactor: framebufferScaleFactor
                    };
                    glBaseLayer = new XRWebGLLayer(session, gl, layerInit);
                    session.updateRenderState({
                        baseLayer: glBaseLayer
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, false);
                    newRenderTarget = new (0, _threeCoreJs.WebGLRenderTarget)(glBaseLayer.framebufferWidth, glBaseLayer.framebufferHeight, {
                        format: (0, _threeCoreJs.RGBAFormat),
                        type: (0, _threeCoreJs.UnsignedByteType),
                        colorSpace: renderer.outputColorSpace,
                        stencilBuffer: attributes.stencil,
                        resolveDepthBuffer: glBaseLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glBaseLayer.ignoreDepthValues === false
                    });
                } else {
                    let depthFormat = null;
                    let depthType = null;
                    let glDepthFormat = null;
                    if (attributes.depth) {
                        glDepthFormat = attributes.stencil ? gl.DEPTH24_STENCIL8 : gl.DEPTH_COMPONENT24;
                        depthFormat = attributes.stencil ? (0, _threeCoreJs.DepthStencilFormat) : (0, _threeCoreJs.DepthFormat);
                        depthType = attributes.stencil ? (0, _threeCoreJs.UnsignedInt248Type) : (0, _threeCoreJs.UnsignedIntType);
                    }
                    const projectionlayerInit = {
                        colorFormat: gl.RGBA8,
                        depthFormat: glDepthFormat,
                        scaleFactor: framebufferScaleFactor
                    };
                    glBinding = this.getBinding();
                    glProjLayer = glBinding.createProjectionLayer(projectionlayerInit);
                    session.updateRenderState({
                        layers: [
                            glProjLayer
                        ]
                    });
                    renderer.setPixelRatio(1);
                    renderer.setSize(glProjLayer.textureWidth, glProjLayer.textureHeight, false);
                    newRenderTarget = new (0, _threeCoreJs.WebGLRenderTarget)(glProjLayer.textureWidth, glProjLayer.textureHeight, {
                        format: (0, _threeCoreJs.RGBAFormat),
                        type: (0, _threeCoreJs.UnsignedByteType),
                        depthTexture: new (0, _threeCoreJs.DepthTexture)(glProjLayer.textureWidth, glProjLayer.textureHeight, depthType, undefined, undefined, undefined, undefined, undefined, undefined, depthFormat),
                        stencilBuffer: attributes.stencil,
                        colorSpace: renderer.outputColorSpace,
                        samples: attributes.antialias ? 4 : 0,
                        resolveDepthBuffer: glProjLayer.ignoreDepthValues === false,
                        resolveStencilBuffer: glProjLayer.ignoreDepthValues === false
                    });
                }
                newRenderTarget.isXRRenderTarget = true; // TODO Remove this when possible, see #23278
                this.setFoveation(foveation);
                customReferenceSpace = null;
                referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
                animation.setContext(session);
                animation.start();
                scope.isPresenting = true;
                scope.dispatchEvent({
                    type: 'sessionstart'
                });
            }
        };
        /**
		 * Returns the environment blend mode from the current XR session.
		 *
		 * @return {'opaque'|'additive'|'alpha-blend'|undefined} The environment blend mode. Returns `undefined` when used outside of a XR session.
		 */ this.getEnvironmentBlendMode = function() {
            if (session !== null) return session.environmentBlendMode;
        };
        /**
		 * Returns the current depth texture computed via depth sensing.
		 *
		 * See {@link WebXRDepthSensing#getDepthTexture}.
		 *
		 * @return {?Texture} The depth texture.
		 */ this.getDepthTexture = function() {
            return depthSensing.getDepthTexture();
        };
        function onInputSourcesChange(event) {
            // Notify disconnected
            for(let i = 0; i < event.removed.length; i++){
                const inputSource = event.removed[i];
                const index = controllerInputSources.indexOf(inputSource);
                if (index >= 0) {
                    controllerInputSources[index] = null;
                    controllers[index].disconnect(inputSource);
                }
            }
            // Notify connected
            for(let i = 0; i < event.added.length; i++){
                const inputSource = event.added[i];
                let controllerIndex = controllerInputSources.indexOf(inputSource);
                if (controllerIndex === -1) {
                    // Assign input source a controller that currently has no input source
                    for(let i = 0; i < controllers.length; i++){
                        if (i >= controllerInputSources.length) {
                            controllerInputSources.push(inputSource);
                            controllerIndex = i;
                            break;
                        } else if (controllerInputSources[i] === null) {
                            controllerInputSources[i] = inputSource;
                            controllerIndex = i;
                            break;
                        }
                    }
                    // If all controllers do currently receive input we ignore new ones
                    if (controllerIndex === -1) break;
                }
                const controller = controllers[controllerIndex];
                if (controller) controller.connect(inputSource);
            }
        }
        //
        const cameraLPos = new (0, _threeCoreJs.Vector3)();
        const cameraRPos = new (0, _threeCoreJs.Vector3)();
        /**
		 * Assumes 2 cameras that are parallel and share an X-axis, and that
		 * the cameras' projection and world matrices have already been set.
		 * And that near and far planes are identical for both cameras.
		 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
		 *
		 * @param {ArrayCamera} camera - The camera to update.
		 * @param {PerspectiveCamera} cameraL - The left camera.
		 * @param {PerspectiveCamera} cameraR - The right camera.
		 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
            cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
            cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
            const ipd = cameraLPos.distanceTo(cameraRPos);
            const projL = cameraL.projectionMatrix.elements;
            const projR = cameraR.projectionMatrix.elements;
            // VR systems will have identical far and near planes, and
            // most likely identical top and bottom frustum extents.
            // Use the left camera for these values.
            const near = projL[14] / (projL[10] - 1);
            const far = projL[14] / (projL[10] + 1);
            const topFov = (projL[9] + 1) / projL[5];
            const bottomFov = (projL[9] - 1) / projL[5];
            const leftFov = (projL[8] - 1) / projL[0];
            const rightFov = (projR[8] + 1) / projR[0];
            const left = near * leftFov;
            const right = near * rightFov;
            // Calculate the new camera's position offset from the
            // left camera. xOffset should be roughly half `ipd`.
            const zOffset = ipd / (-leftFov + rightFov);
            const xOffset = zOffset * -leftFov;
            // TODO: Better way to apply this offset?
            cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
            camera.translateX(xOffset);
            camera.translateZ(zOffset);
            camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
            // Check if the projection uses an infinite far plane.
            if (projL[10] === -1) {
                // Use the projection matrix from the left eye.
                // The camera offset is sufficient to include the view volumes
                // of both eyes (assuming symmetric projections).
                camera.projectionMatrix.copy(cameraL.projectionMatrix);
                camera.projectionMatrixInverse.copy(cameraL.projectionMatrixInverse);
            } else {
                // Find the union of the frustum values of the cameras and scale
                // the values so that the near plane's position does not change in world space,
                // although must now be relative to the new union camera.
                const near2 = near + zOffset;
                const far2 = far + zOffset;
                const left2 = left - xOffset;
                const right2 = right + (ipd - xOffset);
                const top2 = topFov * far / far2 * near2;
                const bottom2 = bottomFov * far / far2 * near2;
                camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
                camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
            }
        }
        function updateCamera(camera, parent) {
            if (parent === null) camera.matrixWorld.copy(camera.matrix);
            else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
            camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        }
        /**
		 * Updates the state of the XR camera. Use this method on app level if you
		 * set `cameraAutoUpdate` to `false`. The method requires the non-XR
		 * camera of the scene as a parameter. The passed in camera's transformation
		 * is automatically adjusted to the position of the XR camera when calling
		 * this method.
		 *
		 * @param {Camera} camera - The camera.
		 */ this.updateCamera = function(camera) {
            if (session === null) return;
            let depthNear = camera.near;
            let depthFar = camera.far;
            if (depthSensing.texture !== null) {
                if (depthSensing.depthNear > 0) depthNear = depthSensing.depthNear;
                if (depthSensing.depthFar > 0) depthFar = depthSensing.depthFar;
            }
            cameraXR.near = cameraR.near = cameraL.near = depthNear;
            cameraXR.far = cameraR.far = cameraL.far = depthFar;
            if (_currentDepthNear !== cameraXR.near || _currentDepthFar !== cameraXR.far) {
                // Note that the new renderState won't apply until the next frame. See #18320
                session.updateRenderState({
                    depthNear: cameraXR.near,
                    depthFar: cameraXR.far
                });
                _currentDepthNear = cameraXR.near;
                _currentDepthFar = cameraXR.far;
            }
            // inherit camera layers and enable eye layers (1 = left, 2 = right)
            cameraXR.layers.mask = camera.layers.mask | 6;
            cameraL.layers.mask = cameraXR.layers.mask & 3;
            cameraR.layers.mask = cameraXR.layers.mask & 5;
            const parent = camera.parent;
            const cameras = cameraXR.cameras;
            updateCamera(cameraXR, parent);
            for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
            // update projection matrix for proper view frustum culling
            if (cameras.length === 2) setProjectionFromUnion(cameraXR, cameraL, cameraR);
            else // assume single camera setup (AR)
            cameraXR.projectionMatrix.copy(cameraL.projectionMatrix);
            // update user camera and its children
            updateUserCamera(camera, cameraXR, parent);
        };
        function updateUserCamera(camera, cameraXR, parent) {
            if (parent === null) camera.matrix.copy(cameraXR.matrixWorld);
            else {
                camera.matrix.copy(parent.matrixWorld);
                camera.matrix.invert();
                camera.matrix.multiply(cameraXR.matrixWorld);
            }
            camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
            camera.updateMatrixWorld(true);
            camera.projectionMatrix.copy(cameraXR.projectionMatrix);
            camera.projectionMatrixInverse.copy(cameraXR.projectionMatrixInverse);
            if (camera.isPerspectiveCamera) {
                camera.fov = (0, _threeCoreJs.RAD2DEG) * 2 * Math.atan(1 / camera.projectionMatrix.elements[5]);
                camera.zoom = 1;
            }
        }
        /**
		 * Returns an instance of {@link ArrayCamera} which represents the XR camera
		 * of the active XR session. For each view it holds a separate camera object.
		 *
		 * The camera's `fov` is currently not used and does not reflect the fov of
		 * the XR camera. If you need the fov on app level, you have to compute in
		 * manually from the XR camera's projection matrices.
		 *
		 * @return {ArrayCamera} The XR camera.
		 */ this.getCamera = function() {
            return cameraXR;
        };
        /**
		 * Returns the amount of foveation used by the XR compositor for the projection layer.
		 *
		 * @return {number|undefined} The amount of foveation.
		 */ this.getFoveation = function() {
            if (glProjLayer === null && glBaseLayer === null) return undefined;
            return foveation;
        };
        /**
		 * Sets the foveation value.
		 *
		 * @param {number} value - A number in the range `[0,1]` where `0` means no foveation (full resolution)
		 * and `1` means maximum foveation (the edges render at lower resolution).
		 */ this.setFoveation = function(value) {
            // 0 = no foveation = full resolution
            // 1 = maximum foveation = the edges render at lower resolution
            foveation = value;
            if (glProjLayer !== null) glProjLayer.fixedFoveation = value;
            if (glBaseLayer !== null && glBaseLayer.fixedFoveation !== undefined) glBaseLayer.fixedFoveation = value;
        };
        /**
		 * Returns `true` if depth sensing is supported.
		 *
		 * @return {boolean} Whether depth sensing is supported or not.
		 */ this.hasDepthSensing = function() {
            return depthSensing.texture !== null;
        };
        /**
		 * Returns the depth sensing mesh.
		 *
		 * See {@link WebXRDepthSensing#getMesh}.
		 *
		 * @return {Mesh} The depth sensing mesh.
		 */ this.getDepthSensingMesh = function() {
            return depthSensing.getMesh(cameraXR);
        };
        /**
		 * Retrieves an opaque texture from the view-aligned {@link XRCamera}.
		 * Only available during the current animation loop.
		 *
		 * @param {XRCamera} xrCamera - The camera to query.
		 * @return {?Texture} An opaque texture representing the current raw camera frame.
		 */ this.getCameraTexture = function(xrCamera) {
            return cameraAccessTextures[xrCamera];
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time, frame) {
            pose = frame.getViewerPose(customReferenceSpace || referenceSpace);
            xrFrame = frame;
            if (pose !== null) {
                const views = pose.views;
                if (glBaseLayer !== null) {
                    renderer.setRenderTargetFramebuffer(newRenderTarget, glBaseLayer.framebuffer);
                    renderer.setRenderTarget(newRenderTarget);
                }
                let cameraXRNeedsUpdate = false;
                // check if it's necessary to rebuild cameraXR's camera list
                if (views.length !== cameraXR.cameras.length) {
                    cameraXR.cameras.length = 0;
                    cameraXRNeedsUpdate = true;
                }
                for(let i = 0; i < views.length; i++){
                    const view = views[i];
                    let viewport = null;
                    if (glBaseLayer !== null) viewport = glBaseLayer.getViewport(view);
                    else {
                        const glSubImage = glBinding.getViewSubImage(glProjLayer, view);
                        viewport = glSubImage.viewport;
                        // For side-by-side projection, we only produce a single texture for both eyes.
                        if (i === 0) {
                            renderer.setRenderTargetTextures(newRenderTarget, glSubImage.colorTexture, glSubImage.depthStencilTexture);
                            renderer.setRenderTarget(newRenderTarget);
                        }
                    }
                    let camera = cameras[i];
                    if (camera === undefined) {
                        camera = new (0, _threeCoreJs.PerspectiveCamera)();
                        camera.layers.enable(i);
                        camera.viewport = new (0, _threeCoreJs.Vector4)();
                        cameras[i] = camera;
                    }
                    camera.matrix.fromArray(view.transform.matrix);
                    camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
                    camera.projectionMatrix.fromArray(view.projectionMatrix);
                    camera.projectionMatrixInverse.copy(camera.projectionMatrix).invert();
                    camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                    if (i === 0) {
                        cameraXR.matrix.copy(camera.matrix);
                        cameraXR.matrix.decompose(cameraXR.position, cameraXR.quaternion, cameraXR.scale);
                    }
                    if (cameraXRNeedsUpdate === true) cameraXR.cameras.push(camera);
                }
                //
                const enabledFeatures = session.enabledFeatures;
                const gpuDepthSensingEnabled = enabledFeatures && enabledFeatures.includes('depth-sensing') && session.depthUsage == 'gpu-optimized';
                if (gpuDepthSensingEnabled && supportsGlBinding) {
                    glBinding = scope.getBinding();
                    const depthData = glBinding.getDepthInformation(views[0]);
                    if (depthData && depthData.isValid && depthData.texture) depthSensing.init(depthData, session.renderState);
                }
                const cameraAccessEnabled = enabledFeatures && enabledFeatures.includes('camera-access');
                if (cameraAccessEnabled && supportsGlBinding) {
                    renderer.state.unbindTexture();
                    glBinding = scope.getBinding();
                    for(let i = 0; i < views.length; i++){
                        const camera = views[i].camera;
                        if (camera) {
                            let cameraTex = cameraAccessTextures[camera];
                            if (!cameraTex) {
                                cameraTex = new (0, _threeCoreJs.ExternalTexture)();
                                cameraAccessTextures[camera] = cameraTex;
                            }
                            const glTexture = glBinding.getCameraImage(camera);
                            cameraTex.sourceTexture = glTexture;
                        }
                    }
                }
            }
            //
            for(let i = 0; i < controllers.length; i++){
                const inputSource = controllerInputSources[i];
                const controller = controllers[i];
                if (inputSource !== null && controller !== undefined) controller.update(inputSource, frame, customReferenceSpace || referenceSpace);
            }
            if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
            if (frame.detectedPlanes) scope.dispatchEvent({
                type: 'planesdetected',
                data: frame
            });
            xrFrame = null;
        }
        const animation = new WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
        };
        this.dispose = function() {};
    }
}
const _e1 = /*@__PURE__*/ new (0, _threeCoreJs.Euler)();
const _m1 = /*@__PURE__*/ new (0, _threeCoreJs.Matrix4)();
function WebGLMaterials(renderer, properties) {
    function refreshTransformUniform(map, uniform) {
        if (map.matrixAutoUpdate === true) map.updateMatrix();
        uniform.value.copy(map.matrix);
    }
    function refreshFogUniforms(uniforms, fog) {
        fog.color.getRGB(uniforms.fogColor.value, (0, _threeCoreJs.getUnlitUniformColorSpace)(renderer));
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height, transmissionRenderTarget) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsStandard(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material, transmissionRenderTarget);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            refreshTransformUniform(material.bumpMap, uniforms.bumpMapTransform);
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === (0, _threeCoreJs.BackSide)) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            refreshTransformUniform(material.normalMap, uniforms.normalMapTransform);
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === (0, _threeCoreJs.BackSide)) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            refreshTransformUniform(material.displacementMap, uniforms.displacementMapTransform);
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        if (material.emissiveMap) {
            uniforms.emissiveMap.value = material.emissiveMap;
            refreshTransformUniform(material.emissiveMap, uniforms.emissiveMapTransform);
        }
        if (material.specularMap) {
            uniforms.specularMap.value = material.specularMap;
            refreshTransformUniform(material.specularMap, uniforms.specularMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
        const materialProperties = properties.get(material);
        const envMap = materialProperties.envMap;
        const envMapRotation = materialProperties.envMapRotation;
        if (envMap) {
            uniforms.envMap.value = envMap;
            _e1.copy(envMapRotation);
            // accommodate left-handed frame
            _e1.x *= -1;
            _e1.y *= -1;
            _e1.z *= -1;
            if (envMap.isCubeTexture && envMap.isRenderTargetTexture === false) {
                // environment maps which are not cube render targets or PMREMs follow a different convention
                _e1.y *= -1;
                _e1.z *= -1;
            }
            uniforms.envMapRotation.value.setFromMatrix4(_m1.makeRotationFromEuler(_e1));
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.ior.value = material.ior;
            uniforms.refractionRatio.value = material.refractionRatio;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
            refreshTransformUniform(material.lightMap, uniforms.lightMapTransform);
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
            refreshTransformUniform(material.aoMap, uniforms.aoMapTransform);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.uvTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) {
            uniforms.map.value = material.map;
            refreshTransformUniform(material.map, uniforms.mapTransform);
        }
        if (material.alphaMap) {
            uniforms.alphaMap.value = material.alphaMap;
            refreshTransformUniform(material.alphaMap, uniforms.alphaMapTransform);
        }
        if (material.alphaTest > 0) uniforms.alphaTest.value = material.alphaTest;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.metalness.value = material.metalness;
        if (material.metalnessMap) {
            uniforms.metalnessMap.value = material.metalnessMap;
            refreshTransformUniform(material.metalnessMap, uniforms.metalnessMapTransform);
        }
        uniforms.roughness.value = material.roughness;
        if (material.roughnessMap) {
            uniforms.roughnessMap.value = material.roughnessMap;
            refreshTransformUniform(material.roughnessMap, uniforms.roughnessMapTransform);
        }
        if (material.envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material, transmissionRenderTarget) {
        uniforms.ior.value = material.ior; // also part of uniforms common
        if (material.sheen > 0) {
            uniforms.sheenColor.value.copy(material.sheenColor).multiplyScalar(material.sheen);
            uniforms.sheenRoughness.value = material.sheenRoughness;
            if (material.sheenColorMap) {
                uniforms.sheenColorMap.value = material.sheenColorMap;
                refreshTransformUniform(material.sheenColorMap, uniforms.sheenColorMapTransform);
            }
            if (material.sheenRoughnessMap) {
                uniforms.sheenRoughnessMap.value = material.sheenRoughnessMap;
                refreshTransformUniform(material.sheenRoughnessMap, uniforms.sheenRoughnessMapTransform);
            }
        }
        if (material.clearcoat > 0) {
            uniforms.clearcoat.value = material.clearcoat;
            uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
            if (material.clearcoatMap) {
                uniforms.clearcoatMap.value = material.clearcoatMap;
                refreshTransformUniform(material.clearcoatMap, uniforms.clearcoatMapTransform);
            }
            if (material.clearcoatRoughnessMap) {
                uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
                refreshTransformUniform(material.clearcoatRoughnessMap, uniforms.clearcoatRoughnessMapTransform);
            }
            if (material.clearcoatNormalMap) {
                uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
                refreshTransformUniform(material.clearcoatNormalMap, uniforms.clearcoatNormalMapTransform);
                uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
                if (material.side === (0, _threeCoreJs.BackSide)) uniforms.clearcoatNormalScale.value.negate();
            }
        }
        if (material.dispersion > 0) uniforms.dispersion.value = material.dispersion;
        if (material.iridescence > 0) {
            uniforms.iridescence.value = material.iridescence;
            uniforms.iridescenceIOR.value = material.iridescenceIOR;
            uniforms.iridescenceThicknessMinimum.value = material.iridescenceThicknessRange[0];
            uniforms.iridescenceThicknessMaximum.value = material.iridescenceThicknessRange[1];
            if (material.iridescenceMap) {
                uniforms.iridescenceMap.value = material.iridescenceMap;
                refreshTransformUniform(material.iridescenceMap, uniforms.iridescenceMapTransform);
            }
            if (material.iridescenceThicknessMap) {
                uniforms.iridescenceThicknessMap.value = material.iridescenceThicknessMap;
                refreshTransformUniform(material.iridescenceThicknessMap, uniforms.iridescenceThicknessMapTransform);
            }
        }
        if (material.transmission > 0) {
            uniforms.transmission.value = material.transmission;
            uniforms.transmissionSamplerMap.value = transmissionRenderTarget.texture;
            uniforms.transmissionSamplerSize.value.set(transmissionRenderTarget.width, transmissionRenderTarget.height);
            if (material.transmissionMap) {
                uniforms.transmissionMap.value = material.transmissionMap;
                refreshTransformUniform(material.transmissionMap, uniforms.transmissionMapTransform);
            }
            uniforms.thickness.value = material.thickness;
            if (material.thicknessMap) {
                uniforms.thicknessMap.value = material.thicknessMap;
                refreshTransformUniform(material.thicknessMap, uniforms.thicknessMapTransform);
            }
            uniforms.attenuationDistance.value = material.attenuationDistance;
            uniforms.attenuationColor.value.copy(material.attenuationColor);
        }
        if (material.anisotropy > 0) {
            uniforms.anisotropyVector.value.set(material.anisotropy * Math.cos(material.anisotropyRotation), material.anisotropy * Math.sin(material.anisotropyRotation));
            if (material.anisotropyMap) {
                uniforms.anisotropyMap.value = material.anisotropyMap;
                refreshTransformUniform(material.anisotropyMap, uniforms.anisotropyMapTransform);
            }
        }
        uniforms.specularIntensity.value = material.specularIntensity;
        uniforms.specularColor.value.copy(material.specularColor);
        if (material.specularColorMap) {
            uniforms.specularColorMap.value = material.specularColorMap;
            refreshTransformUniform(material.specularColorMap, uniforms.specularColorMapTransform);
        }
        if (material.specularIntensityMap) {
            uniforms.specularIntensityMap.value = material.specularIntensityMap;
            refreshTransformUniform(material.specularIntensityMap, uniforms.specularIntensityMapTransform);
        }
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
    }
    function refreshUniformsDistance(uniforms, material) {
        const light = properties.get(material).light;
        uniforms.referencePosition.value.setFromMatrixPosition(light.matrixWorld);
        uniforms.nearDistance.value = light.shadow.camera.near;
        uniforms.farDistance.value = light.shadow.camera.far;
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function WebGLUniformsGroups(gl, info, capabilities, state) {
    let buffers = {};
    let updateList = {};
    let allocatedBindingPoints = [];
    const maxBindingPoints = gl.getParameter(gl.MAX_UNIFORM_BUFFER_BINDINGS); // binding points are global whereas block indices are per shader program
    function bind(uniformsGroup, program) {
        const webglProgram = program.program;
        state.uniformBlockBinding(uniformsGroup, webglProgram);
    }
    function update(uniformsGroup, program) {
        let buffer = buffers[uniformsGroup.id];
        if (buffer === undefined) {
            prepareUniformsGroup(uniformsGroup);
            buffer = createBuffer(uniformsGroup);
            buffers[uniformsGroup.id] = buffer;
            uniformsGroup.addEventListener('dispose', onUniformsGroupsDispose);
        }
        // ensure to update the binding points/block indices mapping for this program
        const webglProgram = program.program;
        state.updateUBOMapping(uniformsGroup, webglProgram);
        // update UBO once per frame
        const frame = info.render.frame;
        if (updateList[uniformsGroup.id] !== frame) {
            updateBufferData(uniformsGroup);
            updateList[uniformsGroup.id] = frame;
        }
    }
    function createBuffer(uniformsGroup) {
        // the setup of an UBO is independent of a particular shader program but global
        const bindingPointIndex = allocateBindingPointIndex();
        uniformsGroup.__bindingPointIndex = bindingPointIndex;
        const buffer = gl.createBuffer();
        const size = uniformsGroup.__size;
        const usage = uniformsGroup.usage;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        gl.bufferData(gl.UNIFORM_BUFFER, size, usage);
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
        gl.bindBufferBase(gl.UNIFORM_BUFFER, bindingPointIndex, buffer);
        return buffer;
    }
    function allocateBindingPointIndex() {
        for(let i = 0; i < maxBindingPoints; i++)if (allocatedBindingPoints.indexOf(i) === -1) {
            allocatedBindingPoints.push(i);
            return i;
        }
        (0, _threeCoreJs.error)('WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached.');
        return 0;
    }
    function updateBufferData(uniformsGroup) {
        const buffer = buffers[uniformsGroup.id];
        const uniforms = uniformsGroup.uniforms;
        const cache = uniformsGroup.__cache;
        gl.bindBuffer(gl.UNIFORM_BUFFER, buffer);
        for(let i = 0, il = uniforms.length; i < il; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                if (hasUniformChanged(uniform, i, j, cache) === true) {
                    const offset = uniform.__offset;
                    const values = Array.isArray(uniform.value) ? uniform.value : [
                        uniform.value
                    ];
                    let arrayOffset = 0;
                    for(let k = 0; k < values.length; k++){
                        const value = values[k];
                        const info = getUniformSize(value);
                        // TODO add integer and struct support
                        if (typeof value === 'number' || typeof value === 'boolean') {
                            uniform.__data[0] = value;
                            gl.bufferSubData(gl.UNIFORM_BUFFER, offset + arrayOffset, uniform.__data);
                        } else if (value.isMatrix3) {
                            // manually converting 3x3 to 3x4
                            uniform.__data[0] = value.elements[0];
                            uniform.__data[1] = value.elements[1];
                            uniform.__data[2] = value.elements[2];
                            uniform.__data[3] = 0;
                            uniform.__data[4] = value.elements[3];
                            uniform.__data[5] = value.elements[4];
                            uniform.__data[6] = value.elements[5];
                            uniform.__data[7] = 0;
                            uniform.__data[8] = value.elements[6];
                            uniform.__data[9] = value.elements[7];
                            uniform.__data[10] = value.elements[8];
                            uniform.__data[11] = 0;
                        } else {
                            value.toArray(uniform.__data, arrayOffset);
                            arrayOffset += info.storage / Float32Array.BYTES_PER_ELEMENT;
                        }
                    }
                    gl.bufferSubData(gl.UNIFORM_BUFFER, offset, uniform.__data);
                }
            }
        }
        gl.bindBuffer(gl.UNIFORM_BUFFER, null);
    }
    function hasUniformChanged(uniform, index, indexArray, cache) {
        const value = uniform.value;
        const indexString = index + '_' + indexArray;
        if (cache[indexString] === undefined) {
            // cache entry does not exist so far
            if (typeof value === 'number' || typeof value === 'boolean') cache[indexString] = value;
            else cache[indexString] = value.clone();
            return true;
        } else {
            const cachedObject = cache[indexString];
            // compare current value with cached entry
            if (typeof value === 'number' || typeof value === 'boolean') {
                if (cachedObject !== value) {
                    cache[indexString] = value;
                    return true;
                }
            } else if (cachedObject.equals(value) === false) {
                cachedObject.copy(value);
                return true;
            }
        }
        return false;
    }
    function prepareUniformsGroup(uniformsGroup) {
        // determine total buffer size according to the STD140 layout
        // Hint: STD140 is the only supported layout in WebGL 2
        const uniforms = uniformsGroup.uniforms;
        let offset = 0; // global buffer offset in bytes
        const chunkSize = 16; // size of a chunk in bytes
        for(let i = 0, l = uniforms.length; i < l; i++){
            const uniformArray = Array.isArray(uniforms[i]) ? uniforms[i] : [
                uniforms[i]
            ];
            for(let j = 0, jl = uniformArray.length; j < jl; j++){
                const uniform = uniformArray[j];
                const values = Array.isArray(uniform.value) ? uniform.value : [
                    uniform.value
                ];
                for(let k = 0, kl = values.length; k < kl; k++){
                    const value = values[k];
                    const info = getUniformSize(value);
                    const chunkOffset = offset % chunkSize; // offset in the current chunk
                    const chunkPadding = chunkOffset % info.boundary; // required padding to match boundary
                    const chunkStart = chunkOffset + chunkPadding; // the start position in the current chunk for the data
                    offset += chunkPadding;
                    // Check for chunk overflow
                    if (chunkStart !== 0 && chunkSize - chunkStart < info.storage) // Add padding and adjust offset
                    offset += chunkSize - chunkStart;
                    // the following two properties will be used for partial buffer updates
                    uniform.__data = new Float32Array(info.storage / Float32Array.BYTES_PER_ELEMENT);
                    uniform.__offset = offset;
                    // Update the global offset
                    offset += info.storage;
                }
            }
        }
        // ensure correct final padding
        const chunkOffset = offset % chunkSize;
        if (chunkOffset > 0) offset += chunkSize - chunkOffset;
        //
        uniformsGroup.__size = offset;
        uniformsGroup.__cache = {};
        return this;
    }
    function getUniformSize(value) {
        const info = {
            boundary: 0,
            storage: 0 // bytes
        };
        // determine sizes according to STD140
        if (typeof value === 'number' || typeof value === 'boolean') {
            // float/int/bool
            info.boundary = 4;
            info.storage = 4;
        } else if (value.isVector2) {
            // vec2
            info.boundary = 8;
            info.storage = 8;
        } else if (value.isVector3 || value.isColor) {
            // vec3
            info.boundary = 16;
            info.storage = 12; // evil: vec3 must start on a 16-byte boundary but it only consumes 12 bytes
        } else if (value.isVector4) {
            // vec4
            info.boundary = 16;
            info.storage = 16;
        } else if (value.isMatrix3) {
            // mat3 (in STD140 a 3x3 matrix is represented as 3x4)
            info.boundary = 48;
            info.storage = 48;
        } else if (value.isMatrix4) {
            // mat4
            info.boundary = 64;
            info.storage = 64;
        } else if (value.isTexture) (0, _threeCoreJs.warn)('WebGLRenderer: Texture samplers can not be part of an uniforms group.');
        else (0, _threeCoreJs.warn)('WebGLRenderer: Unsupported uniform value type.', value);
        return info;
    }
    function onUniformsGroupsDispose(event) {
        const uniformsGroup = event.target;
        uniformsGroup.removeEventListener('dispose', onUniformsGroupsDispose);
        const index = allocatedBindingPoints.indexOf(uniformsGroup.__bindingPointIndex);
        allocatedBindingPoints.splice(index, 1);
        gl.deleteBuffer(buffers[uniformsGroup.id]);
        delete buffers[uniformsGroup.id];
        delete updateList[uniformsGroup.id];
    }
    function dispose() {
        for(const id in buffers)gl.deleteBuffer(buffers[id]);
        allocatedBindingPoints = [];
        buffers = {};
        updateList = {};
    }
    return {
        bind: bind,
        update: update,
        dispose: dispose
    };
}
/**
 * Precomputed DFG LUT for Image-Based Lighting
 * Resolution: 16x16
 * Samples: 4096 per texel
 * Format: RG16F (2 half floats per texel: scale, bias)
 */ const DATA = new Uint16Array([
    0x30b5,
    0x3ad1,
    0x314c,
    0x3a4d,
    0x33d2,
    0x391c,
    0x35ef,
    0x3828,
    0x37f3,
    0x36a6,
    0x38d1,
    0x3539,
    0x3979,
    0x3410,
    0x39f8,
    0x3252,
    0x3a53,
    0x30f0,
    0x3a94,
    0x2fc9,
    0x3abf,
    0x2e35,
    0x3ada,
    0x2d05,
    0x3ae8,
    0x2c1f,
    0x3aed,
    0x2ae0,
    0x3aea,
    0x29d1,
    0x3ae1,
    0x28ff,
    0x3638,
    0x38e4,
    0x364a,
    0x38ce,
    0x3699,
    0x385e,
    0x374e,
    0x372c,
    0x3839,
    0x35a4,
    0x38dc,
    0x3462,
    0x396e,
    0x32c4,
    0x39de,
    0x3134,
    0x3a2b,
    0x3003,
    0x3a59,
    0x2e3a,
    0x3a6d,
    0x2ce1,
    0x3a6e,
    0x2bba,
    0x3a5f,
    0x2a33,
    0x3a49,
    0x290a,
    0x3a2d,
    0x2826,
    0x3a0a,
    0x26e8,
    0x3894,
    0x36d7,
    0x3897,
    0x36c9,
    0x38a3,
    0x3675,
    0x38bc,
    0x35ac,
    0x38ee,
    0x349c,
    0x393e,
    0x3332,
    0x3997,
    0x3186,
    0x39e2,
    0x3038,
    0x3a13,
    0x2e75,
    0x3a29,
    0x2cf5,
    0x3a2d,
    0x2bac,
    0x3a21,
    0x29ff,
    0x3a04,
    0x28bc,
    0x39dc,
    0x2790,
    0x39ad,
    0x261a,
    0x3978,
    0x24fa,
    0x39ac,
    0x34a8,
    0x39ac,
    0x34a3,
    0x39ae,
    0x3480,
    0x39ae,
    0x3423,
    0x39b1,
    0x330e,
    0x39c2,
    0x31a9,
    0x39e0,
    0x3063,
    0x39fc,
    0x2eb5,
    0x3a0c,
    0x2d1d,
    0x3a14,
    0x2bcf,
    0x3a07,
    0x29ff,
    0x39e9,
    0x28a3,
    0x39be,
    0x273c,
    0x3989,
    0x25b3,
    0x394a,
    0x2488,
    0x3907,
    0x2345,
    0x3a77,
    0x3223,
    0x3a76,
    0x321f,
    0x3a73,
    0x3204,
    0x3a6a,
    0x31b3,
    0x3a58,
    0x3114,
    0x3a45,
    0x303b,
    0x3a34,
    0x2eb6,
    0x3a26,
    0x2d31,
    0x3a1e,
    0x2bef,
    0x3a0b,
    0x2a0d,
    0x39ec,
    0x28a1,
    0x39c0,
    0x271b,
    0x3987,
    0x2580,
    0x3944,
    0x2449,
    0x38fa,
    0x22bd,
    0x38ac,
    0x2155,
    0x3b07,
    0x2fca,
    0x3b06,
    0x2fca,
    0x3b00,
    0x2fb8,
    0x3af4,
    0x2f7c,
    0x3adb,
    0x2eea,
    0x3ab4,
    0x2e00,
    0x3a85,
    0x2cec,
    0x3a5e,
    0x2bc5,
    0x3a36,
    0x2a00,
    0x3a0d,
    0x2899,
    0x39dc,
    0x2707,
    0x39a0,
    0x2562,
    0x395a,
    0x2424,
    0x390b,
    0x2268,
    0x38b7,
    0x20fd,
    0x385f,
    0x1fd1,
    0x3b69,
    0x2cb9,
    0x3b68,
    0x2cbb,
    0x3b62,
    0x2cbb,
    0x3b56,
    0x2cae,
    0x3b3b,
    0x2c78,
    0x3b0d,
    0x2c0a,
    0x3acf,
    0x2ae3,
    0x3a92,
    0x2998,
    0x3a54,
    0x2867,
    0x3a17,
    0x26d0,
    0x39d3,
    0x253c,
    0x3989,
    0x2402,
    0x3935,
    0x2226,
    0x38dc,
    0x20bd,
    0x387d,
    0x1f54,
    0x381d,
    0x1db3,
    0x3ba9,
    0x296b,
    0x3ba8,
    0x296f,
    0x3ba3,
    0x297b,
    0x3b98,
    0x2987,
    0x3b7f,
    0x2976,
    0x3b4e,
    0x2927,
    0x3b0e,
    0x2895,
    0x3ac2,
    0x27b7,
    0x3a73,
    0x263b,
    0x3a23,
    0x24e7,
    0x39d0,
    0x239b,
    0x3976,
    0x21d9,
    0x3917,
    0x207e,
    0x38b2,
    0x1ee7,
    0x384b,
    0x1d53,
    0x37c7,
    0x1c1e,
    0x3bd2,
    0x25cb,
    0x3bd1,
    0x25d3,
    0x3bcd,
    0x25f0,
    0x3bc2,
    0x261f,
    0x3bad,
    0x2645,
    0x3b7d,
    0x262d,
    0x3b3e,
    0x25c4,
    0x3aec,
    0x250f,
    0x3a93,
    0x243a,
    0x3a32,
    0x22ce,
    0x39d0,
    0x215b,
    0x3969,
    0x202a,
    0x38fe,
    0x1e6e,
    0x388f,
    0x1cf1,
    0x381f,
    0x1b9b,
    0x3762,
    0x19dd,
    0x3be9,
    0x21ab,
    0x3be9,
    0x21b7,
    0x3be5,
    0x21e5,
    0x3bdd,
    0x2241,
    0x3bc9,
    0x22a7,
    0x3ba0,
    0x22ec,
    0x3b62,
    0x22cd,
    0x3b0f,
    0x2247,
    0x3aae,
    0x2175,
    0x3a44,
    0x2088,
    0x39d4,
    0x1f49,
    0x3960,
    0x1dbe,
    0x38e9,
    0x1c77,
    0x3870,
    0x1ae8,
    0x37f1,
    0x1953,
    0x3708,
    0x181b,
    0x3bf6,
    0x1cea,
    0x3bf6,
    0x1cfb,
    0x3bf3,
    0x1d38,
    0x3bec,
    0x1dbd,
    0x3bda,
    0x1e7c,
    0x3bb7,
    0x1f25,
    0x3b7d,
    0x1f79,
    0x3b2c,
    0x1f4c,
    0x3ac6,
    0x1ea6,
    0x3a55,
    0x1dbb,
    0x39da,
    0x1cbd,
    0x395a,
    0x1b9d,
    0x38d8,
    0x1a00,
    0x3855,
    0x18ac,
    0x37ab,
    0x173c,
    0x36b7,
    0x1598,
    0x3bfc,
    0x1736,
    0x3bfc,
    0x1759,
    0x3bf9,
    0x17e7,
    0x3bf4,
    0x1896,
    0x3be4,
    0x1997,
    0x3bc6,
    0x1aa8,
    0x3b91,
    0x1b84,
    0x3b43,
    0x1bd2,
    0x3ade,
    0x1b8a,
    0x3a65,
    0x1acd,
    0x39e2,
    0x19d3,
    0x3957,
    0x18cd,
    0x38ca,
    0x17b3,
    0x383e,
    0x1613,
    0x376d,
    0x14bf,
    0x366f,
    0x135e,
    0x3bff,
    0x101b,
    0x3bff,
    0x1039,
    0x3bfc,
    0x10c8,
    0x3bf9,
    0x1226,
    0x3bea,
    0x1428,
    0x3bcf,
    0x1584,
    0x3b9f,
    0x16c5,
    0x3b54,
    0x179a,
    0x3af0,
    0x17ce,
    0x3a76,
    0x1771,
    0x39ea,
    0x16a4,
    0x3956,
    0x15a7,
    0x38bf,
    0x14a7,
    0x3829,
    0x1379,
    0x3735,
    0x11ea,
    0x362d,
    0x10a1,
    0x3c00,
    0x061b,
    0x3c00,
    0x066a,
    0x3bfe,
    0x081c,
    0x3bfa,
    0x0a4c,
    0x3bed,
    0x0d16,
    0x3bd5,
    0x0fb3,
    0x3ba9,
    0x114d,
    0x3b63,
    0x127c,
    0x3b01,
    0x132f,
    0x3a85,
    0x1344,
    0x39f4,
    0x12d2,
    0x3957,
    0x120d,
    0x38b5,
    0x1122,
    0x3817,
    0x103c,
    0x3703,
    0x0ed3,
    0x35f0,
    0x0d6d,
    0x3c00,
    0x007a,
    0x3c00,
    0x0089,
    0x3bfe,
    0x011d,
    0x3bfb,
    0x027c,
    0x3bf0,
    0x04fa,
    0x3bda,
    0x0881,
    0x3bb1,
    0x0acd,
    0x3b6f,
    0x0c97,
    0x3b10,
    0x0d7b,
    0x3a93,
    0x0df1,
    0x39fe,
    0x0def,
    0x3959,
    0x0d8a,
    0x38af,
    0x0ce9,
    0x3808,
    0x0c31,
    0x36d5,
    0x0af0,
    0x35b9,
    0x09a3,
    0x3c00,
    0x0000,
    0x3c00,
    0x0001,
    0x3bff,
    0x0015,
    0x3bfb,
    0x0059,
    0x3bf2,
    0x00fd,
    0x3bdd,
    0x01df,
    0x3bb7,
    0x031c,
    0x3b79,
    0x047c,
    0x3b1d,
    0x05d4,
    0x3aa0,
    0x06d5,
    0x3a08,
    0x075a,
    0x395d,
    0x075e,
    0x38aa,
    0x06f7,
    0x37f4,
    0x0648,
    0x36ac,
    0x0576,
    0x3586,
    0x049f
]);
let lut = null;
function getDFGLUT() {
    if (lut === null) {
        lut = new (0, _threeCoreJs.DataTexture)(DATA, 16, 16, (0, _threeCoreJs.RGFormat), (0, _threeCoreJs.HalfFloatType));
        lut.name = 'DFG_LUT';
        lut.minFilter = (0, _threeCoreJs.LinearFilter);
        lut.magFilter = (0, _threeCoreJs.LinearFilter);
        lut.wrapS = (0, _threeCoreJs.ClampToEdgeWrapping);
        lut.wrapT = (0, _threeCoreJs.ClampToEdgeWrapping);
        lut.generateMipmaps = false;
        lut.needsUpdate = true;
    }
    return lut;
}
/**
 * This renderer uses WebGL 2 to display scenes.
 *
 * WebGL 1 is not supported since `r163`.
 */ class WebGLRenderer {
    /**
	 * Constructs a new WebGL renderer.
	 *
	 * @param {WebGLRenderer~Options} [parameters] - The configuration parameter.
	 */ constructor(parameters = {}){
        const { canvas = (0, _threeCoreJs.createCanvasElement)(), context = null, depth = true, stencil = false, alpha = false, antialias = false, premultipliedAlpha = true, preserveDrawingBuffer = false, powerPreference = 'default', failIfMajorPerformanceCaveat = false, reversedDepthBuffer = false, outputBufferType = (0, _threeCoreJs.UnsignedByteType) } = parameters;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderer = true;
        let _alpha;
        if (context !== null) {
            if (typeof WebGLRenderingContext !== 'undefined' && context instanceof WebGLRenderingContext) throw new Error('THREE.WebGLRenderer: WebGL 1 is not supported since r163.');
            _alpha = context.getContextAttributes().alpha;
        } else _alpha = alpha;
        const _outputBufferType = outputBufferType;
        const INTEGER_FORMATS = new Set([
            (0, _threeCoreJs.RGBAIntegerFormat),
            (0, _threeCoreJs.RGIntegerFormat),
            (0, _threeCoreJs.RedIntegerFormat)
        ]);
        const UNSIGNED_TYPES = new Set([
            (0, _threeCoreJs.UnsignedByteType),
            (0, _threeCoreJs.UnsignedIntType),
            (0, _threeCoreJs.UnsignedShortType),
            (0, _threeCoreJs.UnsignedInt248Type),
            (0, _threeCoreJs.UnsignedShort4444Type),
            (0, _threeCoreJs.UnsignedShort5551Type)
        ]);
        const uintClearColor = new Uint32Array(4);
        const intClearColor = new Int32Array(4);
        let currentRenderList = null;
        let currentRenderState = null;
        // render() can be called from within a callback triggered by another render.
        // We track this so that the nested render call gets its list and state isolated from the parent render call.
        const renderListStack = [];
        const renderStateStack = [];
        // internal render target for non-UnsignedByteType color buffer
        let output = null;
        // public properties
        /**
		 * A canvas where the renderer draws its output.This is automatically created by the renderer
		 * in the constructor (if not provided already); you just need to add it to your page like so:
		 * ```js
		 * document.body.appendChild( renderer.domElement );
		 * ```
		 *
		 * @type {HTMLCanvasElement|OffscreenCanvas}
		 */ this.domElement = canvas;
        /**
		 * A object with debug configuration settings.
		 *
		 * - `checkShaderErrors`: If it is `true`, defines whether material shader programs are
		 * checked for errors during compilation and linkage process. It may be useful to disable
		 * this check in production for performance gain. It is strongly recommended to keep these
		 * checks enabled during development. If the shader does not compile and link - it will not
		 * work and associated material will not render.
		 * - `onShaderError(gl, program, glVertexShader,glFragmentShader)`: A callback function that
		 * can be used for custom error reporting. The callback receives the WebGL context, an instance
		 * of WebGLProgram as well two instances of WebGLShader representing the vertex and fragment shader.
		 * Assigning a custom function disables the default error reporting.
		 *
		 * @type {Object}
		 */ this.debug = {
            /**
			 * Enables error checking and reporting when shader programs are being compiled.
			 * @type {boolean}
			 */ checkShaderErrors: true,
            /**
			 * Callback for custom error reporting.
			 * @type {?Function}
			 */ onShaderError: null
        };
        // clearing
        /**
		 * Whether the renderer should automatically clear its output before rendering a frame or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClear = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the color buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearColor = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearDepth = true;
        /**
		 * If {@link WebGLRenderer#autoClear} set to `true`, whether the renderer should clear
		 * the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoClearStencil = true;
        // scene graph
        /**
		 * Whether the renderer should sort objects or not.
		 *
		 * Note: Sorting is used to attempt to properly render objects that have some
		 * degree of transparency. By definition, sorting objects may not work in all
		 * cases. Depending on the needs of application, it may be necessary to turn
		 * off sorting and use other methods to deal with transparency rendering e.g.
		 * manually determining each object's rendering order.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        // user-defined clipping
        /**
		 * User-defined clipping planes specified in world space. These planes apply globally.
		 * Points in space whose dot product with the plane is negative are cut away.
		 *
		 * @type {Array<Plane>}
		 */ this.clippingPlanes = [];
        /**
		 * Whether the renderer respects object-level clipping planes or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.localClippingEnabled = false;
        // tone mapping
        /**
		 * The tone mapping technique of the renderer.
		 *
		 * @type {(NoToneMapping|LinearToneMapping|ReinhardToneMapping|CineonToneMapping|ACESFilmicToneMapping|CustomToneMapping|AgXToneMapping|NeutralToneMapping)}
		 * @default NoToneMapping
		 */ this.toneMapping = (0, _threeCoreJs.NoToneMapping);
        /**
		 * Exposure level of tone mapping.
		 *
		 * @type {number}
		 * @default 1
		 */ this.toneMappingExposure = 1.0;
        // transmission
        /**
		 * The normalized resolution scale for the transmission render target, measured in percentage
		 * of viewport dimensions. Lowering this value can result in significant performance improvements
		 * when using {@link MeshPhysicalMaterial#transmission}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.transmissionResolutionScale = 1.0;
        // internal properties
        const _this = this;
        let _isContextLost = false;
        // internal state cache
        this._outputColorSpace = (0, _threeCoreJs.SRGBColorSpace);
        let _currentActiveCubeFace = 0;
        let _currentActiveMipmapLevel = 0;
        let _currentRenderTarget = null;
        let _currentMaterialId = -1;
        let _currentCamera = null;
        const _currentViewport = new (0, _threeCoreJs.Vector4)();
        const _currentScissor = new (0, _threeCoreJs.Vector4)();
        let _currentScissorTest = null;
        const _currentClearColor = new (0, _threeCoreJs.Color)(0x000000);
        let _currentClearAlpha = 0;
        //
        let _width = canvas.width;
        let _height = canvas.height;
        let _pixelRatio = 1;
        let _opaqueSort = null;
        let _transparentSort = null;
        const _viewport = new (0, _threeCoreJs.Vector4)(0, 0, _width, _height);
        const _scissor = new (0, _threeCoreJs.Vector4)(0, 0, _width, _height);
        let _scissorTest = false;
        // frustum
        const _frustum = new (0, _threeCoreJs.Frustum)();
        // clipping
        let _clippingEnabled = false;
        let _localClippingEnabled = false;
        // camera matrices cache
        const _projScreenMatrix = new (0, _threeCoreJs.Matrix4)();
        const _vector3 = new (0, _threeCoreJs.Vector3)();
        const _vector4 = new (0, _threeCoreJs.Vector4)();
        const _emptyScene = {
            background: null,
            fog: null,
            environment: null,
            overrideMaterial: null,
            isScene: true
        };
        let _renderBackground = false;
        function getTargetPixelRatio() {
            return _currentRenderTarget === null ? _pixelRatio : 1;
        }
        // initialize
        let _gl = context;
        function getContext(contextName, contextAttributes) {
            return canvas.getContext(contextName, contextAttributes);
        }
        try {
            const contextAttributes = {
                alpha: true,
                depth,
                stencil,
                antialias,
                premultipliedAlpha,
                preserveDrawingBuffer,
                powerPreference,
                failIfMajorPerformanceCaveat
            };
            // OffscreenCanvas does not have setAttribute, see #22811
            if ('setAttribute' in canvas) canvas.setAttribute('data-engine', `three.js r${(0, _threeCoreJs.REVISION)}`);
            // event listeners must be registered before WebGL context is created, see #12753
            canvas.addEventListener('webglcontextlost', onContextLost, false);
            canvas.addEventListener('webglcontextrestored', onContextRestore, false);
            canvas.addEventListener('webglcontextcreationerror', onContextCreationError, false);
            if (_gl === null) {
                const contextName = 'webgl2';
                _gl = getContext(contextName, contextAttributes);
                if (_gl === null) {
                    if (getContext(contextName)) throw new Error('Error creating WebGL context with your selected attributes.');
                    else throw new Error('Error creating WebGL context.');
                }
            }
        } catch (e) {
            (0, _threeCoreJs.error)('WebGLRenderer: ' + e.message);
            throw e;
        }
        let extensions, capabilities, state, info;
        let properties, textures, cubemaps, cubeuvmaps, attributes, geometries, objects;
        let programCache, materials, renderLists, renderStates, clipping, shadowMap;
        let background, morphtargets, bufferRenderer, indexedBufferRenderer;
        let utils, bindingStates, uniformsGroups;
        function initGLContext() {
            extensions = new WebGLExtensions(_gl);
            extensions.init();
            utils = new WebGLUtils(_gl, extensions);
            capabilities = new WebGLCapabilities(_gl, extensions, parameters, utils);
            state = new WebGLState(_gl, extensions);
            if (capabilities.reversedDepthBuffer && reversedDepthBuffer) state.buffers.depth.setReversed(true);
            info = new WebGLInfo(_gl);
            properties = new WebGLProperties();
            textures = new WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
            cubemaps = new WebGLCubeMaps(_this);
            cubeuvmaps = new WebGLCubeUVMaps(_this);
            attributes = new WebGLAttributes(_gl);
            bindingStates = new WebGLBindingStates(_gl, attributes);
            geometries = new WebGLGeometries(_gl, attributes, info, bindingStates);
            objects = new WebGLObjects(_gl, geometries, attributes, info);
            morphtargets = new WebGLMorphtargets(_gl, capabilities, textures);
            clipping = new WebGLClipping(properties);
            programCache = new WebGLPrograms(_this, cubemaps, cubeuvmaps, extensions, capabilities, bindingStates, clipping);
            materials = new WebGLMaterials(_this, properties);
            renderLists = new WebGLRenderLists();
            renderStates = new WebGLRenderStates(extensions);
            background = new WebGLBackground(_this, cubemaps, cubeuvmaps, state, objects, _alpha, premultipliedAlpha);
            shadowMap = new WebGLShadowMap(_this, objects, capabilities);
            uniformsGroups = new WebGLUniformsGroups(_gl, info, capabilities, state);
            bufferRenderer = new WebGLBufferRenderer(_gl, extensions, info);
            indexedBufferRenderer = new WebGLIndexedBufferRenderer(_gl, extensions, info);
            info.programs = programCache.programs;
            /**
			 * Holds details about the capabilities of the current rendering context.
			 *
			 * @name WebGLRenderer#capabilities
			 * @type {WebGLRenderer~Capabilities}
			 */ _this.capabilities = capabilities;
            /**
			 * Provides methods for retrieving and testing WebGL extensions.
			 *
			 * - `get(extensionName:string)`: Used to check whether a WebGL extension is supported
			 * and return the extension object if available.
			 * - `has(extensionName:string)`: returns `true` if the extension is supported.
			 *
			 * @name WebGLRenderer#extensions
			 * @type {Object}
			 */ _this.extensions = extensions;
            /**
			 * Used to track properties of other objects like native WebGL objects.
			 *
			 * @name WebGLRenderer#properties
			 * @type {Object}
			 */ _this.properties = properties;
            /**
			 * Manages the render lists of the renderer.
			 *
			 * @name WebGLRenderer#renderLists
			 * @type {Object}
			 */ _this.renderLists = renderLists;
            /**
			 * Interface for managing shadows.
			 *
			 * @name WebGLRenderer#shadowMap
			 * @type {WebGLRenderer~ShadowMap}
			 */ _this.shadowMap = shadowMap;
            /**
			 * Interface for managing the WebGL state.
			 *
			 * @name WebGLRenderer#state
			 * @type {Object}
			 */ _this.state = state;
            /**
			 * Holds a series of statistical information about the GPU memory
			 * and the rendering process. Useful for debugging and monitoring.
			 *
			 * By default these data are reset at each render call but when having
			 * multiple render passes per frame (e.g. when using post processing) it can
			 * be preferred to reset with a custom pattern. First, set `autoReset` to
			 * `false`.
			 * ```js
			 * renderer.info.autoReset = false;
			 * ```
			 * Call `reset()` whenever you have finished to render a single frame.
			 * ```js
			 * renderer.info.reset();
			 * ```
			 *
			 * @name WebGLRenderer#info
			 * @type {WebGLRenderer~Info}
			 */ _this.info = info;
        }
        initGLContext();
        // initialize internal render target for non-UnsignedByteType color buffer
        if (_outputBufferType !== (0, _threeCoreJs.UnsignedByteType)) output = new WebGLOutput(_outputBufferType, canvas.width, canvas.height, depth, stencil);
        // xr
        const xr = new WebXRManager(_this, _gl);
        /**
		 * A reference to the XR manager.
		 *
		 * @type {WebXRManager}
		 */ this.xr = xr;
        /**
		 * Returns the rendering context.
		 *
		 * @return {WebGL2RenderingContext} The rendering context.
		 */ this.getContext = function() {
            return _gl;
        };
        /**
		 * Returns the rendering context attributes.
		 *
		 * @return {WebGLContextAttributes} The rendering context attributes.
		 */ this.getContextAttributes = function() {
            return _gl.getContextAttributes();
        };
        /**
		 * Simulates a loss of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextLoss = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.loseContext();
        };
        /**
		 * Simulates a restore of the WebGL context. This requires support for the `WEBGL_lose_context` extension.
		 */ this.forceContextRestore = function() {
            const extension = extensions.get('WEBGL_lose_context');
            if (extension) extension.restoreContext();
        };
        /**
		 * Returns the pixel ratio.
		 *
		 * @return {number} The pixel ratio.
		 */ this.getPixelRatio = function() {
            return _pixelRatio;
        };
        /**
		 * Sets the given pixel ratio and resizes the canvas if necessary.
		 *
		 * @param {number} value - The pixel ratio.
		 */ this.setPixelRatio = function(value) {
            if (value === undefined) return;
            _pixelRatio = value;
            this.setSize(_width, _height, false);
        };
        /**
		 * Returns the renderer's size in logical pixels. This method does not honor the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The renderer's size in logical pixels.
		 */ this.getSize = function(target) {
            return target.set(_width, _height);
        };
        /**
		 * Resizes the output canvas to (width, height) with device pixel ratio taken
		 * into account, and also sets the viewport to fit that size, starting in (0,
		 * 0). Setting `updateStyle` to false prevents any style changes to the output canvas.
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {boolean} [updateStyle=true] - Whether to update the `style` attribute of the canvas or not.
		 */ this.setSize = function(width, height, updateStyle = true) {
            if (xr.isPresenting) {
                (0, _threeCoreJs.warn)('WebGLRenderer: Can\'t change size while VR device is presenting.');
                return;
            }
            _width = width;
            _height = height;
            canvas.width = Math.floor(width * _pixelRatio);
            canvas.height = Math.floor(height * _pixelRatio);
            if (updateStyle === true) {
                canvas.style.width = width + 'px';
                canvas.style.height = height + 'px';
            }
            if (output !== null) output.setSize(canvas.width, canvas.height);
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Returns the drawing buffer size in physical pixels. This method honors the pixel ratio.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The drawing buffer size.
		 */ this.getDrawingBufferSize = function(target) {
            return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
        };
        /**
		 * This method allows to define the drawing buffer size by specifying
		 * width, height and pixel ratio all at once. The size of the drawing
		 * buffer is computed with this formula:
		 * ```js
		 * size.x = width * pixelRatio;
		 * size.y = height * pixelRatio;
		 * ```
		 *
		 * @param {number} width - The width in logical pixels.
		 * @param {number} height - The height in logical pixels.
		 * @param {number} pixelRatio - The pixel ratio.
		 */ this.setDrawingBufferSize = function(width, height, pixelRatio) {
            _width = width;
            _height = height;
            _pixelRatio = pixelRatio;
            canvas.width = Math.floor(width * pixelRatio);
            canvas.height = Math.floor(height * pixelRatio);
            this.setViewport(0, 0, width, height);
        };
        /**
		 * Sets the post-processing effects to be applied after rendering.
		 *
		 * @param {Array} effects - An array of post-processing effects.
		 */ this.setEffects = function(effects) {
            if (_outputBufferType === (0, _threeCoreJs.UnsignedByteType)) {
                console.error('THREE.WebGLRenderer: setEffects() requires outputBufferType set to HalfFloatType or FloatType.');
                return;
            }
            if (effects) {
                for(let i = 0; i < effects.length; i++)if (effects[i].isOutputPass === true) {
                    console.warn('THREE.WebGLRenderer: OutputPass is not needed in setEffects(). Tone mapping and color space conversion are applied automatically.');
                    break;
                }
            }
            output.setEffects(effects || []);
        };
        /**
		 * Returns the current viewport definition.
		 *
		 * @param {Vector2} target - The method writes the result in this target object.
		 * @return {Vector2} The current viewport definition.
		 */ this.getCurrentViewport = function(target) {
            return target.copy(_currentViewport);
        };
        /**
		 * Returns the viewport definition.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The viewport definition.
		 */ this.getViewport = function(target) {
            return target.copy(_viewport);
        };
        /**
		 * Sets the viewport to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the viewport origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the viewport.
		 * @param {number} y - The vertical coordinate for the lower left corner of the viewport origin  in logical pixel unit.
		 * @param {number} width - The width of the viewport in logical pixel unit.
		 * @param {number} height - The height of the viewport in logical pixel unit.
		 */ this.setViewport = function(x, y, width, height) {
            if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
            else _viewport.set(x, y, width, height);
            state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns the scissor region.
		 *
		 * @param {Vector4} target - The method writes the result in this target object.
		 * @return {Vector4} The scissor region.
		 */ this.getScissor = function(target) {
            return target.copy(_scissor);
        };
        /**
		 * Sets the scissor region to render from `(x, y)` to `(x + width, y + height)`.
		 *
		 * @param {number | Vector4} x - The horizontal coordinate for the lower left corner of the scissor region origin in logical pixel unit.
		 * Or alternatively a four-component vector specifying all the parameters of the scissor region.
		 * @param {number} y - The vertical coordinate for the lower left corner of the scissor region origin  in logical pixel unit.
		 * @param {number} width - The width of the scissor region in logical pixel unit.
		 * @param {number} height - The height of the scissor region in logical pixel unit.
		 */ this.setScissor = function(x, y, width, height) {
            if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
            else _scissor.set(x, y, width, height);
            state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).round());
        };
        /**
		 * Returns `true` if the scissor test is enabled.
		 *
		 * @return {boolean} Whether the scissor test is enabled or not.
		 */ this.getScissorTest = function() {
            return _scissorTest;
        };
        /**
		 * Enable or disable the scissor test. When this is enabled, only the pixels
		 * within the defined scissor area will be affected by further renderer
		 * actions.
		 *
		 * @param {boolean} boolean - Whether the scissor test is enabled or not.
		 */ this.setScissorTest = function(boolean) {
            state.setScissorTest(_scissorTest = boolean);
        };
        /**
		 * Sets a custom opaque sort function for the render lists. Pass `null`
		 * to use the default `painterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setOpaqueSort = function(method) {
            _opaqueSort = method;
        };
        /**
		 * Sets a custom transparent sort function for the render lists. Pass `null`
		 * to use the default `reversePainterSortStable` function.
		 *
		 * @param {?Function} method - The opaque sort function.
		 */ this.setTransparentSort = function(method) {
            _transparentSort = method;
        };
        // Clearing
        /**
		 * Returns the clear color.
		 *
		 * @param {Color} target - The method writes the result in this target object.
		 * @return {Color} The clear color.
		 */ this.getClearColor = function(target) {
            return target.copy(background.getClearColor());
        };
        /**
		 * Sets the clear color and alpha.
		 *
		 * @param {Color} color - The clear color.
		 * @param {number} [alpha=1] - The clear alpha.
		 */ this.setClearColor = function() {
            background.setClearColor(...arguments);
        };
        /**
		 * Returns the clear alpha. Ranges within `[0,1]`.
		 *
		 * @return {number} The clear alpha.
		 */ this.getClearAlpha = function() {
            return background.getClearAlpha();
        };
        /**
		 * Sets the clear alpha.
		 *
		 * @param {number} alpha - The clear alpha.
		 */ this.setClearAlpha = function() {
            background.setClearAlpha(...arguments);
        };
        /**
		 * Tells the renderer to clear its color, depth or stencil drawing buffer(s).
		 * This method initializes the buffers to the current clear color values.
		 *
		 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
		 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
		 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
		 */ this.clear = function(color = true, depth = true, stencil = true) {
            let bits = 0;
            if (color) {
                // check if we're trying to clear an integer target
                let isIntegerFormat = false;
                if (_currentRenderTarget !== null) {
                    const targetFormat = _currentRenderTarget.texture.format;
                    isIntegerFormat = INTEGER_FORMATS.has(targetFormat);
                }
                // use the appropriate clear functions to clear the target if it's a signed
                // or unsigned integer target
                if (isIntegerFormat) {
                    const targetType = _currentRenderTarget.texture.type;
                    const isUnsignedType = UNSIGNED_TYPES.has(targetType);
                    const clearColor = background.getClearColor();
                    const a = background.getClearAlpha();
                    const r = clearColor.r;
                    const g = clearColor.g;
                    const b = clearColor.b;
                    if (isUnsignedType) {
                        uintClearColor[0] = r;
                        uintClearColor[1] = g;
                        uintClearColor[2] = b;
                        uintClearColor[3] = a;
                        _gl.clearBufferuiv(_gl.COLOR, 0, uintClearColor);
                    } else {
                        intClearColor[0] = r;
                        intClearColor[1] = g;
                        intClearColor[2] = b;
                        intClearColor[3] = a;
                        _gl.clearBufferiv(_gl.COLOR, 0, intClearColor);
                    }
                } else bits |= _gl.COLOR_BUFFER_BIT;
            }
            if (depth) bits |= _gl.DEPTH_BUFFER_BIT;
            if (stencil) {
                bits |= _gl.STENCIL_BUFFER_BIT;
                this.state.buffers.stencil.setMask(0xffffffff);
            }
            _gl.clear(bits);
        };
        /**
		 * Clears the color buffer. Equivalent to calling `renderer.clear( true, false, false )`.
		 */ this.clearColor = function() {
            this.clear(true, false, false);
        };
        /**
		 * Clears the depth buffer. Equivalent to calling `renderer.clear( false, true, false )`.
		 */ this.clearDepth = function() {
            this.clear(false, true, false);
        };
        /**
		 * Clears the stencil buffer. Equivalent to calling `renderer.clear( false, false, true )`.
		 */ this.clearStencil = function() {
            this.clear(false, false, true);
        };
        /**
		 * Frees the GPU-related resources allocated by this instance. Call this
		 * method whenever this instance is no longer used in your app.
		 */ this.dispose = function() {
            canvas.removeEventListener('webglcontextlost', onContextLost, false);
            canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
            canvas.removeEventListener('webglcontextcreationerror', onContextCreationError, false);
            background.dispose();
            renderLists.dispose();
            renderStates.dispose();
            properties.dispose();
            cubemaps.dispose();
            cubeuvmaps.dispose();
            objects.dispose();
            bindingStates.dispose();
            uniformsGroups.dispose();
            programCache.dispose();
            xr.dispose();
            xr.removeEventListener('sessionstart', onXRSessionStart);
            xr.removeEventListener('sessionend', onXRSessionEnd);
            animation.stop();
        };
        // Events
        function onContextLost(event) {
            event.preventDefault();
            (0, _threeCoreJs.log)('WebGLRenderer: Context Lost.');
            _isContextLost = true;
        }
        function onContextRestore() {
            (0, _threeCoreJs.log)('WebGLRenderer: Context Restored.');
            _isContextLost = false;
            const infoAutoReset = info.autoReset;
            const shadowMapEnabled = shadowMap.enabled;
            const shadowMapAutoUpdate = shadowMap.autoUpdate;
            const shadowMapNeedsUpdate = shadowMap.needsUpdate;
            const shadowMapType = shadowMap.type;
            initGLContext();
            info.autoReset = infoAutoReset;
            shadowMap.enabled = shadowMapEnabled;
            shadowMap.autoUpdate = shadowMapAutoUpdate;
            shadowMap.needsUpdate = shadowMapNeedsUpdate;
            shadowMap.type = shadowMapType;
        }
        function onContextCreationError(event) {
            (0, _threeCoreJs.error)('WebGLRenderer: A WebGL context could not be created. Reason: ', event.statusMessage);
        }
        function onMaterialDispose(event) {
            const material = event.target;
            material.removeEventListener('dispose', onMaterialDispose);
            deallocateMaterial(material);
        }
        // Buffer deallocation
        function deallocateMaterial(material) {
            releaseMaterialProgramReferences(material);
            properties.remove(material);
        }
        function releaseMaterialProgramReferences(material) {
            const programs = properties.get(material).programs;
            if (programs !== undefined) {
                programs.forEach(function(program) {
                    programCache.releaseProgram(program);
                });
                if (material.isShaderMaterial) programCache.releaseShaderCache(material);
            }
        }
        // Buffer rendering
        this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
            if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
            const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
            const program = setProgram(camera, scene, geometry, material, object);
            state.setMaterial(material, frontFaceCW);
            //
            let index = geometry.index;
            let rangeFactor = 1;
            if (material.wireframe === true) {
                index = geometries.getWireframeAttribute(geometry);
                if (index === undefined) return;
                rangeFactor = 2;
            }
            //
            const drawRange = geometry.drawRange;
            const position = geometry.attributes.position;
            let drawStart = drawRange.start * rangeFactor;
            let drawEnd = (drawRange.start + drawRange.count) * rangeFactor;
            if (group !== null) {
                drawStart = Math.max(drawStart, group.start * rangeFactor);
                drawEnd = Math.min(drawEnd, (group.start + group.count) * rangeFactor);
            }
            if (index !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, index.count);
            } else if (position !== undefined && position !== null) {
                drawStart = Math.max(drawStart, 0);
                drawEnd = Math.min(drawEnd, position.count);
            }
            const drawCount = drawEnd - drawStart;
            if (drawCount < 0 || drawCount === Infinity) return;
            //
            bindingStates.setup(object, material, program, geometry, index);
            let attribute;
            let renderer = bufferRenderer;
            if (index !== null) {
                attribute = attributes.get(index);
                renderer = indexedBufferRenderer;
                renderer.setIndex(attribute);
            }
            //
            if (object.isMesh) {
                if (material.wireframe === true) {
                    state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                    renderer.setMode(_gl.LINES);
                } else renderer.setMode(_gl.TRIANGLES);
            } else if (object.isLine) {
                let lineWidth = material.linewidth;
                if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
                state.setLineWidth(lineWidth * getTargetPixelRatio());
                if (object.isLineSegments) renderer.setMode(_gl.LINES);
                else if (object.isLineLoop) renderer.setMode(_gl.LINE_LOOP);
                else renderer.setMode(_gl.LINE_STRIP);
            } else if (object.isPoints) renderer.setMode(_gl.POINTS);
            else if (object.isSprite) renderer.setMode(_gl.TRIANGLES);
            if (object.isBatchedMesh) {
                if (object._multiDrawInstances !== null) {
                    // @deprecated, r174
                    (0, _threeCoreJs.warnOnce)('WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection.');
                    renderer.renderMultiDrawInstances(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount, object._multiDrawInstances);
                } else if (!extensions.get('WEBGL_multi_draw')) {
                    const starts = object._multiDrawStarts;
                    const counts = object._multiDrawCounts;
                    const drawCount = object._multiDrawCount;
                    const bytesPerElement = index ? attributes.get(index).bytesPerElement : 1;
                    const uniforms = properties.get(material).currentProgram.getUniforms();
                    for(let i = 0; i < drawCount; i++){
                        uniforms.setValue(_gl, '_gl_DrawID', i);
                        renderer.render(starts[i] / bytesPerElement, counts[i]);
                    }
                } else renderer.renderMultiDraw(object._multiDrawStarts, object._multiDrawCounts, object._multiDrawCount);
            } else if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
            else if (geometry.isInstancedBufferGeometry) {
                const maxInstanceCount = geometry._maxInstanceCount !== undefined ? geometry._maxInstanceCount : Infinity;
                const instanceCount = Math.min(geometry.instanceCount, maxInstanceCount);
                renderer.renderInstances(drawStart, drawCount, instanceCount);
            } else renderer.render(drawStart, drawCount);
        };
        // Compile
        function prepareMaterial(material, scene, object) {
            if (material.transparent === true && material.side === (0, _threeCoreJs.DoubleSide) && material.forceSinglePass === false) {
                material.side = (0, _threeCoreJs.BackSide);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, _threeCoreJs.FrontSide);
                material.needsUpdate = true;
                getProgram(material, scene, object);
                material.side = (0, _threeCoreJs.DoubleSide);
            } else getProgram(material, scene, object);
        }
        /**
		 * Compiles all materials in the scene with the camera. This is useful to precompile shaders
		 * before the first rendering. If you want to add a 3D object to an existing scene, use the third
		 * optional parameter for applying the target scene.
		 *
		 * Note that the (target) scene's lighting and environment must be configured before calling this method.
		 *
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Set<Material>} The precompiled materials.
		 */ this.compile = function(scene, camera, targetScene = null) {
            if (targetScene === null) targetScene = scene;
            currentRenderState = renderStates.get(targetScene);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            // gather lights from both the target scene and the new object that will be added to the scene.
            targetScene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            if (scene !== targetScene) scene.traverseVisible(function(object) {
                if (object.isLight && object.layers.test(camera.layers)) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                }
            });
            currentRenderState.setupLights();
            // Only initialize materials in the new scene, not the targetScene.
            const materials = new Set();
            scene.traverse(function(object) {
                if (!(object.isMesh || object.isPoints || object.isLine || object.isSprite)) return;
                const material = object.material;
                if (material) {
                    if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                        const material2 = material[i];
                        prepareMaterial(material2, targetScene, object);
                        materials.add(material2);
                    }
                    else {
                        prepareMaterial(material, targetScene, object);
                        materials.add(material);
                    }
                }
            });
            currentRenderState = renderStateStack.pop();
            return materials;
        };
        // compileAsync
        /**
		 * Asynchronous version of {@link WebGLRenderer#compile}.
		 *
		 * This method makes use of the `KHR_parallel_shader_compile` WebGL extension. Hence,
		 * it is recommended to use this version of `compile()` whenever possible.
		 *
		 * @async
		 * @param {Object3D} scene - The scene or another type of 3D object to precompile.
		 * @param {Camera} camera - The camera.
		 * @param {?Scene} [targetScene=null] - The target scene.
		 * @return {Promise} A Promise that resolves when the given scene can be rendered without unnecessary stalling due to shader compilation.
		 */ this.compileAsync = function(scene, camera, targetScene = null) {
            const materials = this.compile(scene, camera, targetScene);
            // Wait for all the materials in the new object to indicate that they're
            // ready to be used before resolving the promise.
            return new Promise((resolve)=>{
                function checkMaterialsReady() {
                    materials.forEach(function(material) {
                        const materialProperties = properties.get(material);
                        const program = materialProperties.currentProgram;
                        if (program.isReady()) // remove any programs that report they're ready to use from the list
                        materials.delete(material);
                    });
                    // once the list of compiling materials is empty, call the callback
                    if (materials.size === 0) {
                        resolve(scene);
                        return;
                    }
                    // if some materials are still not ready, wait a bit and check again
                    setTimeout(checkMaterialsReady, 10);
                }
                if (extensions.get('KHR_parallel_shader_compile') !== null) // If we can check the compilation status of the materials without
                // blocking then do so right away.
                checkMaterialsReady();
                else // Otherwise start by waiting a bit to give the materials we just
                // initialized a chance to finish.
                setTimeout(checkMaterialsReady, 10);
            });
        };
        // Animation Loop
        let onAnimationFrameCallback = null;
        function onAnimationFrame(time) {
            if (onAnimationFrameCallback) onAnimationFrameCallback(time);
        }
        function onXRSessionStart() {
            animation.stop();
        }
        function onXRSessionEnd() {
            animation.start();
        }
        const animation = new WebGLAnimation();
        animation.setAnimationLoop(onAnimationFrame);
        if (typeof self !== 'undefined') animation.setContext(self);
        /**
		 * Applications are advised to always define the animation loop
		 * with this method and not manually with `requestAnimationFrame()`
		 * for best compatibility.
		 *
		 * @param {?onAnimationCallback} callback - The application's animation loop.
		 */ this.setAnimationLoop = function(callback) {
            onAnimationFrameCallback = callback;
            xr.setAnimationLoop(callback);
            callback === null ? animation.stop() : animation.start();
        };
        xr.addEventListener('sessionstart', onXRSessionStart);
        xr.addEventListener('sessionend', onXRSessionEnd);
        // Rendering
        /**
		 * Renders the given scene (or other type of 3D object) using the given camera.
		 *
		 * The render is done to a previously specified render target set by calling {@link WebGLRenderer#setRenderTarget}
		 * or to the canvas as usual.
		 *
		 * By default render buffers are cleared before rendering but you can prevent
		 * this by setting the property `autoClear` to `false`. If you want to prevent
		 * only certain buffers being cleared you can `autoClearColor`, `autoClearDepth`
		 * or `autoClearStencil` to `false`. To force a clear, use {@link WebGLRenderer#clear}.
		 *
		 * @param {Object3D} scene - The scene to render.
		 * @param {Camera} camera - The camera.
		 */ this.render = function(scene, camera) {
            if (camera !== undefined && camera.isCamera !== true) {
                (0, _threeCoreJs.error)('WebGLRenderer.render: camera is not an instance of THREE.Camera.');
                return;
            }
            if (_isContextLost === true) return;
            // use internal render target for HalfFloatType color buffer (only when tone mapping is enabled)
            const isXRPresenting = xr.enabled === true && xr.isPresenting === true;
            const useOutput = output !== null && (_currentRenderTarget === null || isXRPresenting) && output.begin(_this, _currentRenderTarget);
            // update scene graph
            if (scene.matrixWorldAutoUpdate === true) scene.updateMatrixWorld();
            // update camera matrices and frustum
            if (camera.parent === null && camera.matrixWorldAutoUpdate === true) camera.updateMatrixWorld();
            if (xr.enabled === true && xr.isPresenting === true && (output === null || output.isCompositing() === false)) {
                if (xr.cameraAutoUpdate === true) xr.updateCamera(camera);
                camera = xr.getCamera(); // use XR camera for rendering
            }
            //
            if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, _currentRenderTarget);
            currentRenderState = renderStates.get(scene, renderStateStack.length);
            currentRenderState.init(camera);
            renderStateStack.push(currentRenderState);
            _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum.setFromProjectionMatrix(_projScreenMatrix, (0, _threeCoreJs.WebGLCoordinateSystem), camera.reversedDepth);
            _localClippingEnabled = this.localClippingEnabled;
            _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled);
            currentRenderList = renderLists.get(scene, renderListStack.length);
            currentRenderList.init();
            renderListStack.push(currentRenderList);
            if (xr.enabled === true && xr.isPresenting === true) {
                const depthSensingMesh = _this.xr.getDepthSensingMesh();
                if (depthSensingMesh !== null) projectObject(depthSensingMesh, camera, -Infinity, _this.sortObjects);
            }
            projectObject(scene, camera, 0, _this.sortObjects);
            currentRenderList.finish();
            if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
            _renderBackground = xr.enabled === false || xr.isPresenting === false || xr.hasDepthSensing() === false;
            if (_renderBackground) background.addToRenderList(currentRenderList, scene);
            //
            this.info.render.frame++;
            if (_clippingEnabled === true) clipping.beginShadows();
            const shadowsArray = currentRenderState.state.shadowsArray;
            shadowMap.render(shadowsArray, scene, camera);
            if (_clippingEnabled === true) clipping.endShadows();
            //
            if (this.info.autoReset === true) this.info.reset();
            // render scene (skip if first effect is a render pass - it will render the scene itself)
            const skipSceneRender = useOutput && output.hasRenderPass();
            if (skipSceneRender === false) {
                const opaqueObjects = currentRenderList.opaque;
                const transmissiveObjects = currentRenderList.transmissive;
                currentRenderState.setupLights();
                if (camera.isArrayCamera) {
                    const cameras = camera.cameras;
                    if (transmissiveObjects.length > 0) for(let i = 0, l = cameras.length; i < l; i++){
                        const camera2 = cameras[i];
                        renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera2);
                    }
                    if (_renderBackground) background.render(scene);
                    for(let i = 0, l = cameras.length; i < l; i++){
                        const camera2 = cameras[i];
                        renderScene(currentRenderList, scene, camera2, camera2.viewport);
                    }
                } else {
                    if (transmissiveObjects.length > 0) renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera);
                    if (_renderBackground) background.render(scene);
                    renderScene(currentRenderList, scene, camera);
                }
            }
            //
            if (_currentRenderTarget !== null && _currentActiveMipmapLevel === 0) {
                // resolve multisample renderbuffers to a single-sample texture if necessary
                textures.updateMultisampleRenderTarget(_currentRenderTarget);
                // Generate mipmap if we're using any kind of mipmap filtering
                textures.updateRenderTargetMipmap(_currentRenderTarget);
            }
            // copy from internal render target to canvas using fullscreen quad
            if (useOutput) output.end(_this);
            //
            if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
            // _gl.finish();
            bindingStates.resetDefaultState();
            _currentMaterialId = -1;
            _currentCamera = null;
            renderStateStack.pop();
            if (renderStateStack.length > 0) {
                currentRenderState = renderStateStack[renderStateStack.length - 1];
                if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, currentRenderState.state.camera);
            } else currentRenderState = null;
            renderListStack.pop();
            if (renderListStack.length > 0) currentRenderList = renderListStack[renderListStack.length - 1];
            else currentRenderList = null;
        };
        function projectObject(object, camera, groupOrder, sortObjects) {
            if (object.visible === false) return;
            const visible = object.layers.test(camera.layers);
            if (visible) {
                if (object.isGroup) groupOrder = object.renderOrder;
                else if (object.isLOD) {
                    if (object.autoUpdate === true) object.update(camera);
                } else if (object.isLight) {
                    currentRenderState.pushLight(object);
                    if (object.castShadow) currentRenderState.pushShadow(object);
                } else if (object.isSprite) {
                    if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                        if (sortObjects) _vector4.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                } else if (object.isMesh || object.isLine || object.isPoints) {
                    if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                        const geometry = objects.update(object);
                        const material = object.material;
                        if (sortObjects) {
                            if (object.boundingSphere !== undefined) {
                                if (object.boundingSphere === null) object.computeBoundingSphere();
                                _vector4.copy(object.boundingSphere.center);
                            } else {
                                if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
                                _vector4.copy(geometry.boundingSphere.center);
                            }
                            _vector4.applyMatrix4(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                        }
                        if (Array.isArray(material)) {
                            const groups = geometry.groups;
                            for(let i = 0, l = groups.length; i < l; i++){
                                const group = groups[i];
                                const groupMaterial = material[group.materialIndex];
                                if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector4.z, group);
                            }
                        } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector4.z, null);
                    }
                }
            }
            const children = object.children;
            for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
        }
        function renderScene(currentRenderList, scene, camera, viewport) {
            const { opaque: opaqueObjects, transmissive: transmissiveObjects, transparent: transparentObjects } = currentRenderList;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            if (viewport) state.viewport(_currentViewport.copy(viewport));
            if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
            if (transmissiveObjects.length > 0) renderObjects(transmissiveObjects, scene, camera);
            if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
            // Ensure depth buffer writing is enabled so it can be cleared on next render
            state.buffers.depth.setTest(true);
            state.buffers.depth.setMask(true);
            state.buffers.color.setMask(true);
            state.setPolygonOffset(false);
        }
        function renderTransmissionPass(opaqueObjects, transmissiveObjects, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            if (overrideMaterial !== null) return;
            if (currentRenderState.state.transmissionRenderTarget[camera.id] === undefined) {
                const hasHalfFloatSupport = extensions.has('EXT_color_buffer_half_float') || extensions.has('EXT_color_buffer_float');
                currentRenderState.state.transmissionRenderTarget[camera.id] = new (0, _threeCoreJs.WebGLRenderTarget)(1, 1, {
                    generateMipmaps: true,
                    type: hasHalfFloatSupport ? (0, _threeCoreJs.HalfFloatType) : (0, _threeCoreJs.UnsignedByteType),
                    minFilter: (0, _threeCoreJs.LinearMipmapLinearFilter),
                    samples: capabilities.samples,
                    stencilBuffer: stencil,
                    resolveDepthBuffer: false,
                    resolveStencilBuffer: false,
                    colorSpace: (0, _threeCoreJs.ColorManagement).workingColorSpace
                });
            // debug
            /*
				const geometry = new PlaneGeometry();
				const material = new MeshBasicMaterial( { map: _transmissionRenderTarget.texture } );

				const mesh = new Mesh( geometry, material );
				scene.add( mesh );
				*/ }
            const transmissionRenderTarget = currentRenderState.state.transmissionRenderTarget[camera.id];
            const activeViewport = camera.viewport || _currentViewport;
            transmissionRenderTarget.setSize(activeViewport.z * _this.transmissionResolutionScale, activeViewport.w * _this.transmissionResolutionScale);
            //
            const currentRenderTarget = _this.getRenderTarget();
            const currentActiveCubeFace = _this.getActiveCubeFace();
            const currentActiveMipmapLevel = _this.getActiveMipmapLevel();
            _this.setRenderTarget(transmissionRenderTarget);
            _this.getClearColor(_currentClearColor);
            _currentClearAlpha = _this.getClearAlpha();
            if (_currentClearAlpha < 1) _this.setClearColor(0xffffff, 0.5);
            _this.clear();
            if (_renderBackground) background.render(scene);
            // Turn off the features which can affect the frag color for opaque objects pass.
            // Otherwise they are applied twice in opaque objects pass and transmission objects pass.
            const currentToneMapping = _this.toneMapping;
            _this.toneMapping = (0, _threeCoreJs.NoToneMapping);
            // Remove viewport from camera to avoid nested render calls resetting viewport to it (e.g Reflector).
            // Transmission render pass requires viewport to match the transmissionRenderTarget.
            const currentCameraViewport = camera.viewport;
            if (camera.viewport !== undefined) camera.viewport = undefined;
            currentRenderState.setupLightsView(camera);
            if (_clippingEnabled === true) clipping.setGlobalState(_this.clippingPlanes, camera);
            renderObjects(opaqueObjects, scene, camera);
            textures.updateMultisampleRenderTarget(transmissionRenderTarget);
            textures.updateRenderTargetMipmap(transmissionRenderTarget);
            if (extensions.has('WEBGL_multisampled_render_to_texture') === false) {
                let renderTargetNeedsUpdate = false;
                for(let i = 0, l = transmissiveObjects.length; i < l; i++){
                    const renderItem = transmissiveObjects[i];
                    const { object, geometry, material, group } = renderItem;
                    if (material.side === (0, _threeCoreJs.DoubleSide) && object.layers.test(camera.layers)) {
                        const currentSide = material.side;
                        material.side = (0, _threeCoreJs.BackSide);
                        material.needsUpdate = true;
                        renderObject(object, scene, camera, geometry, material, group);
                        material.side = currentSide;
                        material.needsUpdate = true;
                        renderTargetNeedsUpdate = true;
                    }
                }
                if (renderTargetNeedsUpdate === true) {
                    textures.updateMultisampleRenderTarget(transmissionRenderTarget);
                    textures.updateRenderTargetMipmap(transmissionRenderTarget);
                }
            }
            _this.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
            _this.setClearColor(_currentClearColor, _currentClearAlpha);
            if (currentCameraViewport !== undefined) camera.viewport = currentCameraViewport;
            _this.toneMapping = currentToneMapping;
        }
        function renderObjects(renderList, scene, camera) {
            const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
            for(let i = 0, l = renderList.length; i < l; i++){
                const renderItem = renderList[i];
                const { object, geometry, group } = renderItem;
                let material = renderItem.material;
                if (material.allowOverride === true && overrideMaterial !== null) material = overrideMaterial;
                if (object.layers.test(camera.layers)) renderObject(object, scene, camera, geometry, material, group);
            }
        }
        function renderObject(object, scene, camera, geometry, material, group) {
            object.onBeforeRender(_this, scene, camera, geometry, material, group);
            object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
            object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
            material.onBeforeRender(_this, scene, camera, geometry, object, group);
            if (material.transparent === true && material.side === (0, _threeCoreJs.DoubleSide) && material.forceSinglePass === false) {
                material.side = (0, _threeCoreJs.BackSide);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, _threeCoreJs.FrontSide);
                material.needsUpdate = true;
                _this.renderBufferDirect(camera, scene, geometry, material, object, group);
                material.side = (0, _threeCoreJs.DoubleSide);
            } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
            object.onAfterRender(_this, scene, camera, geometry, material, group);
        }
        function getProgram(material, scene, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            const shadowsArray = currentRenderState.state.shadowsArray;
            const lightsStateVersion = lights.state.version;
            const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
            const programCacheKey = programCache.getProgramCacheKey(parameters);
            let programs = materialProperties.programs;
            // always update environment and fog - changing these trigger an getProgram call, but it's possible that the program doesn't change
            materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
            materialProperties.fog = scene.fog;
            materialProperties.envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || materialProperties.environment);
            materialProperties.envMapRotation = materialProperties.environment !== null && material.envMap === null ? scene.environmentRotation : material.envMapRotation;
            if (programs === undefined) {
                // new material
                material.addEventListener('dispose', onMaterialDispose);
                programs = new Map();
                materialProperties.programs = programs;
            }
            let program = programs.get(programCacheKey);
            if (program !== undefined) // early out if program and light state is identical
            {
                if (materialProperties.currentProgram === program && materialProperties.lightsStateVersion === lightsStateVersion) {
                    updateCommonMaterialProperties(material, parameters);
                    return program;
                }
            } else {
                parameters.uniforms = programCache.getUniforms(material);
                material.onBeforeCompile(parameters, _this);
                program = programCache.acquireProgram(parameters, programCacheKey);
                programs.set(programCacheKey, program);
                materialProperties.uniforms = parameters.uniforms;
            }
            const uniforms = materialProperties.uniforms;
            if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) uniforms.clippingPlanes = clipping.uniform;
            updateCommonMaterialProperties(material, parameters);
            // store the light setup it was created for
            materialProperties.needsLights = materialNeedsLights(material);
            materialProperties.lightsStateVersion = lightsStateVersion;
            if (materialProperties.needsLights) {
                // wire up the material to this renderer's lighting state
                uniforms.ambientLightColor.value = lights.state.ambient;
                uniforms.lightProbe.value = lights.state.probe;
                uniforms.directionalLights.value = lights.state.directional;
                uniforms.directionalLightShadows.value = lights.state.directionalShadow;
                uniforms.spotLights.value = lights.state.spot;
                uniforms.spotLightShadows.value = lights.state.spotShadow;
                uniforms.rectAreaLights.value = lights.state.rectArea;
                uniforms.ltc_1.value = lights.state.rectAreaLTC1;
                uniforms.ltc_2.value = lights.state.rectAreaLTC2;
                uniforms.pointLights.value = lights.state.point;
                uniforms.pointLightShadows.value = lights.state.pointShadow;
                uniforms.hemisphereLights.value = lights.state.hemi;
                uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
                uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
                uniforms.spotShadowMap.value = lights.state.spotShadowMap;
                uniforms.spotLightMatrix.value = lights.state.spotLightMatrix;
                uniforms.spotLightMap.value = lights.state.spotLightMap;
                uniforms.pointShadowMap.value = lights.state.pointShadowMap;
                uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
            // TODO (abelnation): add area lights shadow info to uniforms
            }
            materialProperties.currentProgram = program;
            materialProperties.uniformsList = null;
            return program;
        }
        function getUniformList(materialProperties) {
            if (materialProperties.uniformsList === null) {
                const progUniforms = materialProperties.currentProgram.getUniforms();
                materialProperties.uniformsList = WebGLUniforms.seqWithValue(progUniforms.seq, materialProperties.uniforms);
            }
            return materialProperties.uniformsList;
        }
        function updateCommonMaterialProperties(material, parameters) {
            const materialProperties = properties.get(material);
            materialProperties.outputColorSpace = parameters.outputColorSpace;
            materialProperties.batching = parameters.batching;
            materialProperties.batchingColor = parameters.batchingColor;
            materialProperties.instancing = parameters.instancing;
            materialProperties.instancingColor = parameters.instancingColor;
            materialProperties.instancingMorph = parameters.instancingMorph;
            materialProperties.skinning = parameters.skinning;
            materialProperties.morphTargets = parameters.morphTargets;
            materialProperties.morphNormals = parameters.morphNormals;
            materialProperties.morphColors = parameters.morphColors;
            materialProperties.morphTargetsCount = parameters.morphTargetsCount;
            materialProperties.numClippingPlanes = parameters.numClippingPlanes;
            materialProperties.numIntersection = parameters.numClipIntersection;
            materialProperties.vertexAlphas = parameters.vertexAlphas;
            materialProperties.vertexTangents = parameters.vertexTangents;
            materialProperties.toneMapping = parameters.toneMapping;
        }
        function setProgram(camera, scene, geometry, material, object) {
            if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
            textures.resetTextureUnits();
            const fog = scene.fog;
            const environment = material.isMeshStandardMaterial ? scene.environment : null;
            const colorSpace = _currentRenderTarget === null ? _this.outputColorSpace : _currentRenderTarget.isXRRenderTarget === true ? _currentRenderTarget.texture.colorSpace : (0, _threeCoreJs.LinearSRGBColorSpace);
            const envMap = (material.isMeshStandardMaterial ? cubeuvmaps : cubemaps).get(material.envMap || environment);
            const vertexAlphas = material.vertexColors === true && !!geometry.attributes.color && geometry.attributes.color.itemSize === 4;
            const vertexTangents = !!geometry.attributes.tangent && (!!material.normalMap || material.anisotropy > 0);
            const morphTargets = !!geometry.morphAttributes.position;
            const morphNormals = !!geometry.morphAttributes.normal;
            const morphColors = !!geometry.morphAttributes.color;
            let toneMapping = (0, _threeCoreJs.NoToneMapping);
            if (material.toneMapped) {
                if (_currentRenderTarget === null || _currentRenderTarget.isXRRenderTarget === true) toneMapping = _this.toneMapping;
            }
            const morphAttribute = geometry.morphAttributes.position || geometry.morphAttributes.normal || geometry.morphAttributes.color;
            const morphTargetsCount = morphAttribute !== undefined ? morphAttribute.length : 0;
            const materialProperties = properties.get(material);
            const lights = currentRenderState.state.lights;
            if (_clippingEnabled === true) {
                if (_localClippingEnabled === true || camera !== _currentCamera) {
                    const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                    // we might want to call this function with some ClippingGroup
                    // object instead of the material, once it becomes feasible
                    // (#8465, #8379)
                    clipping.setState(material, camera, useCache);
                }
            }
            //
            let needsProgramChange = false;
            if (material.version === materialProperties.__version) {
                if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) needsProgramChange = true;
                else if (materialProperties.outputColorSpace !== colorSpace) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batching === false) needsProgramChange = true;
                else if (!object.isBatchedMesh && materialProperties.batching === true) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === true && object.colorTexture === null) needsProgramChange = true;
                else if (object.isBatchedMesh && materialProperties.batchingColor === false && object.colorTexture !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancing === false) needsProgramChange = true;
                else if (!object.isInstancedMesh && materialProperties.instancing === true) needsProgramChange = true;
                else if (object.isSkinnedMesh && materialProperties.skinning === false) needsProgramChange = true;
                else if (!object.isSkinnedMesh && materialProperties.skinning === true) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === true && object.instanceColor === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingColor === false && object.instanceColor !== null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === true && object.morphTexture === null) needsProgramChange = true;
                else if (object.isInstancedMesh && materialProperties.instancingMorph === false && object.morphTexture !== null) needsProgramChange = true;
                else if (materialProperties.envMap !== envMap) needsProgramChange = true;
                else if (material.fog === true && materialProperties.fog !== fog) needsProgramChange = true;
                else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) needsProgramChange = true;
                else if (materialProperties.vertexAlphas !== vertexAlphas) needsProgramChange = true;
                else if (materialProperties.vertexTangents !== vertexTangents) needsProgramChange = true;
                else if (materialProperties.morphTargets !== morphTargets) needsProgramChange = true;
                else if (materialProperties.morphNormals !== morphNormals) needsProgramChange = true;
                else if (materialProperties.morphColors !== morphColors) needsProgramChange = true;
                else if (materialProperties.toneMapping !== toneMapping) needsProgramChange = true;
                else if (materialProperties.morphTargetsCount !== morphTargetsCount) needsProgramChange = true;
            } else {
                needsProgramChange = true;
                materialProperties.__version = material.version;
            }
            //
            let program = materialProperties.currentProgram;
            if (needsProgramChange === true) program = getProgram(material, scene, object);
            let refreshProgram = false;
            let refreshMaterial = false;
            let refreshLights = false;
            const p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
            if (state.useProgram(program.program)) {
                refreshProgram = true;
                refreshMaterial = true;
                refreshLights = true;
            }
            if (material.id !== _currentMaterialId) {
                _currentMaterialId = material.id;
                refreshMaterial = true;
            }
            if (refreshProgram || _currentCamera !== camera) {
                // common camera uniforms
                const reversedDepthBuffer = state.buffers.depth.getReversed();
                if (reversedDepthBuffer && camera.reversedDepth !== true) {
                    camera._reversedDepth = true;
                    camera.updateProjectionMatrix();
                }
                p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
                p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
                if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
                // consider moving isOrthographic to UniformLib and WebGLMaterials, see https://github.com/mrdoob/three.js/pull/26467#issuecomment-1645185067
                if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
                if (_currentCamera !== camera) {
                    _currentCamera = camera;
                    // lighting uniforms depend on the camera so enforce an update
                    // now, in case this material supports lights - or later, when
                    // the next material that does gets activated:
                    refreshMaterial = true; // set to true on material change
                    refreshLights = true; // remains set until update done
                }
            }
            // Pre-allocate texture units for shadow samplers before setting data textures
            if (materialProperties.needsLights) {
                // Set shadow map uniforms first to ensure they get the first texture units
                if (lights.state.directionalShadowMap.length > 0) p_uniforms.setValue(_gl, 'directionalShadowMap', lights.state.directionalShadowMap, textures);
                if (lights.state.spotShadowMap.length > 0) p_uniforms.setValue(_gl, 'spotShadowMap', lights.state.spotShadowMap, textures);
                if (lights.state.pointShadowMap.length > 0) p_uniforms.setValue(_gl, 'pointShadowMap', lights.state.pointShadowMap, textures);
            }
            // skinning and morph target uniforms must be set even if material didn't change
            // auto-setting of texture unit for bone and morph texture must go before other textures
            // otherwise textures used for skinning and morphing can take over texture units reserved for other material textures
            if (object.isSkinnedMesh) {
                p_uniforms.setOptional(_gl, object, 'bindMatrix');
                p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
                const skeleton = object.skeleton;
                if (skeleton) {
                    if (skeleton.boneTexture === null) skeleton.computeBoneTexture();
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                }
            }
            if (object.isBatchedMesh) {
                p_uniforms.setOptional(_gl, object, 'batchingTexture');
                p_uniforms.setValue(_gl, 'batchingTexture', object._matricesTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingIdTexture');
                p_uniforms.setValue(_gl, 'batchingIdTexture', object._indirectTexture, textures);
                p_uniforms.setOptional(_gl, object, 'batchingColorTexture');
                if (object._colorsTexture !== null) p_uniforms.setValue(_gl, 'batchingColorTexture', object._colorsTexture, textures);
            }
            const morphAttributes = geometry.morphAttributes;
            if (morphAttributes.position !== undefined || morphAttributes.normal !== undefined || morphAttributes.color !== undefined) morphtargets.update(object, geometry, program);
            if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
                materialProperties.receiveShadow = object.receiveShadow;
                p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
            }
            // https://github.com/mrdoob/three.js/pull/24467#issuecomment-1209031512
            if (material.isMeshGouraudMaterial && material.envMap !== null) {
                m_uniforms.envMap.value = envMap;
                m_uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap.isRenderTargetTexture === false ? -1 : 1;
            }
            if (material.isMeshStandardMaterial && material.envMap === null && scene.environment !== null) m_uniforms.envMapIntensity.value = scene.environmentIntensity;
            // Set DFG LUT for physically-based materials
            if (m_uniforms.dfgLUT !== undefined) m_uniforms.dfgLUT.value = getDFGLUT();
            if (refreshMaterial) {
                p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
                if (materialProperties.needsLights) // the current material requires lighting info
                // note: all lighting uniforms are always set correctly
                // they simply reference the renderer's state for their
                // values
                //
                // use the current material's .needsUpdate flags to set
                // the GL state when required
                markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
                // refresh uniforms common to several materials
                if (fog && material.fog === true) materials.refreshFogUniforms(m_uniforms, fog);
                materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height, currentRenderState.state.transmissionRenderTarget[camera.id]);
                WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
            }
            if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
                WebGLUniforms.upload(_gl, getUniformList(materialProperties), m_uniforms, textures);
                material.uniformsNeedUpdate = false;
            }
            if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
            // common matrices
            p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
            p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
            p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
            // UBOs
            if (material.isShaderMaterial || material.isRawShaderMaterial) {
                const groups = material.uniformsGroups;
                for(let i = 0, l = groups.length; i < l; i++){
                    const group = groups[i];
                    uniformsGroups.update(group, program);
                    uniformsGroups.bind(group, program);
                }
            }
            return program;
        }
        // If uniforms are marked as clean, they don't need to be loaded to the GPU.
        function markUniformsLightsNeedsUpdate(uniforms, value) {
            uniforms.ambientLightColor.needsUpdate = value;
            uniforms.lightProbe.needsUpdate = value;
            uniforms.directionalLights.needsUpdate = value;
            uniforms.directionalLightShadows.needsUpdate = value;
            uniforms.pointLights.needsUpdate = value;
            uniforms.pointLightShadows.needsUpdate = value;
            uniforms.spotLights.needsUpdate = value;
            uniforms.spotLightShadows.needsUpdate = value;
            uniforms.rectAreaLights.needsUpdate = value;
            uniforms.hemisphereLights.needsUpdate = value;
        }
        function materialNeedsLights(material) {
            return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
        }
        /**
		 * Returns the active cube face.
		 *
		 * @return {number} The active cube face.
		 */ this.getActiveCubeFace = function() {
            return _currentActiveCubeFace;
        };
        /**
		 * Returns the active mipmap level.
		 *
		 * @return {number} The active mipmap level.
		 */ this.getActiveMipmapLevel = function() {
            return _currentActiveMipmapLevel;
        };
        /**
		 * Returns the active render target.
		 *
		 * @return {?WebGLRenderTarget} The active render target. Returns `null` if no render target
		 * is currently set.
		 */ this.getRenderTarget = function() {
            return _currentRenderTarget;
        };
        this.setRenderTargetTextures = function(renderTarget, colorTexture, depthTexture) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__autoAllocateDepthBuffer = renderTarget.resolveDepthBuffer === false;
            if (renderTargetProperties.__autoAllocateDepthBuffer === false) // The multisample_render_to_texture extension doesn't work properly if there
            // are midframe flushes and an external depth buffer. Disable use of the extension.
            renderTargetProperties.__useRenderToTexture = false;
            properties.get(renderTarget.texture).__webglTexture = colorTexture;
            properties.get(renderTarget.depthTexture).__webglTexture = renderTargetProperties.__autoAllocateDepthBuffer ? undefined : depthTexture;
            renderTargetProperties.__hasExternalTextures = true;
        };
        this.setRenderTargetFramebuffer = function(renderTarget, defaultFramebuffer) {
            const renderTargetProperties = properties.get(renderTarget);
            renderTargetProperties.__webglFramebuffer = defaultFramebuffer;
            renderTargetProperties.__useDefaultFramebuffer = defaultFramebuffer === undefined;
        };
        const _scratchFrameBuffer = _gl.createFramebuffer();
        /**
		 * Sets the active rendertarget.
		 *
		 * @param {?WebGLRenderTarget} renderTarget - The render target to set. When `null` is given,
		 * the canvas is set as the active render target instead.
		 * @param {number} [activeCubeFace=0] - The active cube face when using a cube render target.
		 * Indicates the z layer to render in to when using 3D or array render targets.
		 * @param {number} [activeMipmapLevel=0] - The active mipmap level.
		 */ this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
            _currentRenderTarget = renderTarget;
            _currentActiveCubeFace = activeCubeFace;
            _currentActiveMipmapLevel = activeMipmapLevel;
            let framebuffer = null;
            let isCube = false;
            let isRenderTarget3D = false;
            if (renderTarget) {
                const renderTargetProperties = properties.get(renderTarget);
                if (renderTargetProperties.__useDefaultFramebuffer !== undefined) {
                    // Externally-managed framebuffer (e.g. XR)
                    // Bind to the stored framebuffer (may be null for default, or a WebGLFramebuffer)
                    state.bindFramebuffer(_gl.FRAMEBUFFER, renderTargetProperties.__webglFramebuffer);
                    _currentViewport.copy(renderTarget.viewport);
                    _currentScissor.copy(renderTarget.scissor);
                    _currentScissorTest = renderTarget.scissorTest;
                    state.viewport(_currentViewport);
                    state.scissor(_currentScissor);
                    state.setScissorTest(_currentScissorTest);
                    _currentMaterialId = -1;
                    return;
                } else if (renderTargetProperties.__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
                else if (renderTargetProperties.__hasExternalTextures) // Color and depth texture must be rebound in order for the swapchain to update.
                textures.rebindTextures(renderTarget, properties.get(renderTarget.texture).__webglTexture, properties.get(renderTarget.depthTexture).__webglTexture);
                else if (renderTarget.depthBuffer) {
                    // check if the depth texture is already bound to the frame buffer and that it's been initialized
                    const depthTexture = renderTarget.depthTexture;
                    if (renderTargetProperties.__boundDepthTexture !== depthTexture) {
                        // check if the depth texture is compatible
                        if (depthTexture !== null && properties.has(depthTexture) && (renderTarget.width !== depthTexture.image.width || renderTarget.height !== depthTexture.image.height)) throw new Error('WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.');
                        // Swap the depth buffer to the currently attached one
                        textures.setupDepthRenderbuffer(renderTarget);
                    }
                }
                const texture = renderTarget.texture;
                if (texture.isData3DTexture || texture.isDataArrayTexture || texture.isCompressedArrayTexture) isRenderTarget3D = true;
                const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
                if (renderTarget.isWebGLCubeRenderTarget) {
                    if (Array.isArray(__webglFramebuffer[activeCubeFace])) framebuffer = __webglFramebuffer[activeCubeFace][activeMipmapLevel];
                    else framebuffer = __webglFramebuffer[activeCubeFace];
                    isCube = true;
                } else if (renderTarget.samples > 0 && textures.useMultisampledRTT(renderTarget) === false) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
                else if (Array.isArray(__webglFramebuffer)) framebuffer = __webglFramebuffer[activeMipmapLevel];
                else framebuffer = __webglFramebuffer;
                _currentViewport.copy(renderTarget.viewport);
                _currentScissor.copy(renderTarget.scissor);
                _currentScissorTest = renderTarget.scissorTest;
            } else {
                _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
                _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
                _currentScissorTest = _scissorTest;
            }
            // Use a scratch frame buffer if rendering to a mip level to avoid depth buffers
            // being bound that are different sizes.
            if (activeMipmapLevel !== 0) framebuffer = _scratchFrameBuffer;
            const framebufferBound = state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
            if (framebufferBound) state.drawBuffers(renderTarget, framebuffer);
            state.viewport(_currentViewport);
            state.scissor(_currentScissor);
            state.setScissorTest(_currentScissorTest);
            if (isCube) {
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_CUBE_MAP_POSITIVE_X + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
            } else if (isRenderTarget3D) {
                const layer = activeCubeFace;
                for(let i = 0; i < renderTarget.textures.length; i++){
                    const textureProperties = properties.get(renderTarget.textures[i]);
                    _gl.framebufferTextureLayer(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0 + i, textureProperties.__webglTexture, activeMipmapLevel, layer);
                }
            } else if (renderTarget !== null && activeMipmapLevel !== 0) {
                // Only bind the frame buffer if we are using a scratch frame buffer to render to a mipmap.
                // If we rebind the texture when using a multi sample buffer then an error about inconsistent samples will be thrown.
                const textureProperties = properties.get(renderTarget.texture);
                _gl.framebufferTexture2D(_gl.FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, textureProperties.__webglTexture, activeMipmapLevel);
            }
            _currentMaterialId = -1; // reset current material to ensure correct uniform bindings
        };
        /**
		 * Reads the pixel data from the given render target into the given buffer.
		 *
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 */ this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
                (0, _threeCoreJs.error)('WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
                return;
            }
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                try {
                    const texture = renderTarget.textures[textureIndex];
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) {
                        (0, _threeCoreJs.error)('WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                        return;
                    }
                    if (!capabilities.textureTypeReadable(textureType)) {
                        (0, _threeCoreJs.error)('WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                        return;
                    }
                    // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                        // when using MRT, select the correct color buffer for the subsequent read command
                        if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                        _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                    }
                } finally{
                    // restore framebuffer of current render target if necessary
                    const framebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                }
            }
        };
        /**
		 * Asynchronous, non-blocking version of {@link WebGLRenderer#readRenderTargetPixels}.
		 *
		 * It is recommended to use this version of `readRenderTargetPixels()` whenever possible.
		 *
		 * @async
		 * @param {WebGLRenderTarget} renderTarget - The render target to read from.
		 * @param {number} x - The `x` coordinate of the copy region's origin.
		 * @param {number} y - The `y` coordinate of the copy region's origin.
		 * @param {number} width - The width of the copy region.
		 * @param {number} height - The height of the copy region.
		 * @param {TypedArray} buffer - The result buffer.
		 * @param {number} [activeCubeFaceIndex] - The active cube face index.
		 * @param {number} [textureIndex=0] - The texture index of an MRT render target.
		 * @return {Promise<TypedArray>} A Promise that resolves when the read has been finished. The resolve provides the read data as a typed array.
		 */ this.readRenderTargetPixelsAsync = async function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex, textureIndex = 0) {
            if (!(renderTarget && renderTarget.isWebGLRenderTarget)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            let framebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
            if (framebuffer) {
                // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) {
                    // set the active frame buffer to the one we want to read
                    state.bindFramebuffer(_gl.FRAMEBUFFER, framebuffer);
                    const texture = renderTarget.textures[textureIndex];
                    const textureFormat = texture.format;
                    const textureType = texture.type;
                    if (!capabilities.textureFormatReadable(textureFormat)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.');
                    if (!capabilities.textureTypeReadable(textureType)) throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.');
                    const glBuffer = _gl.createBuffer();
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.bufferData(_gl.PIXEL_PACK_BUFFER, buffer.byteLength, _gl.STREAM_READ);
                    // when using MRT, select the correct color buffer for the subsequent read command
                    if (renderTarget.textures.length > 1) _gl.readBuffer(_gl.COLOR_ATTACHMENT0 + textureIndex);
                    _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), 0);
                    // reset the frame buffer to the currently set buffer before waiting
                    const currFramebuffer = _currentRenderTarget !== null ? properties.get(_currentRenderTarget).__webglFramebuffer : null;
                    state.bindFramebuffer(_gl.FRAMEBUFFER, currFramebuffer);
                    // check if the commands have finished every 8 ms
                    const sync = _gl.fenceSync(_gl.SYNC_GPU_COMMANDS_COMPLETE, 0);
                    _gl.flush();
                    await (0, _threeCoreJs.probeAsync)(_gl, sync, 4);
                    // read the data and delete the buffer
                    _gl.bindBuffer(_gl.PIXEL_PACK_BUFFER, glBuffer);
                    _gl.getBufferSubData(_gl.PIXEL_PACK_BUFFER, 0, buffer);
                    _gl.deleteBuffer(glBuffer);
                    _gl.deleteSync(sync);
                    return buffer;
                } else throw new Error('THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.');
            }
        };
        /**
		 * Copies pixels from the current bound framebuffer into the given texture.
		 *
		 * @param {FramebufferTexture} texture - The texture.
		 * @param {?Vector2} [position=null] - The start position of the copy operation.
		 * @param {number} [level=0] - The mip level. The default represents the base mip.
		 */ this.copyFramebufferToTexture = function(texture, position = null, level = 0) {
            const levelScale = Math.pow(2, -level);
            const width = Math.floor(texture.image.width * levelScale);
            const height = Math.floor(texture.image.height * levelScale);
            const x = position !== null ? position.x : 0;
            const y = position !== null ? position.y : 0;
            textures.setTexture2D(texture, 0);
            _gl.copyTexSubImage2D(_gl.TEXTURE_2D, level, 0, 0, x, y, width, height);
            state.unbindTexture();
        };
        const _srcFramebuffer = _gl.createFramebuffer();
        const _dstFramebuffer = _gl.createFramebuffer();
        /**
		 * Copies data of the given source texture into a destination texture.
		 *
		 * When using render target textures as `srcTexture` and `dstTexture`, you must make sure both render targets are initialized
		 * {@link WebGLRenderer#initRenderTarget}.
		 *
		 * @param {Texture} srcTexture - The source texture.
		 * @param {Texture} dstTexture - The destination texture.
		 * @param {?(Box2|Box3)} [srcRegion=null] - A bounding box which describes the source region. Can be two or three-dimensional.
		 * @param {?(Vector2|Vector3)} [dstPosition=null] - A vector that represents the origin of the destination region. Can be two or three-dimensional.
		 * @param {number} [srcLevel=0] - The source mipmap level to copy.
		 * @param {?number} [dstLevel=null] - The destination mipmap level.
		 */ this.copyTextureToTexture = function(srcTexture, dstTexture, srcRegion = null, dstPosition = null, srcLevel = 0, dstLevel = null) {
            // support the previous signature with just a single dst mipmap level
            if (dstLevel === null) {
                if (srcLevel !== 0) {
                    // @deprecated, r171
                    (0, _threeCoreJs.warnOnce)('WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels.');
                    dstLevel = srcLevel;
                    srcLevel = 0;
                } else dstLevel = 0;
            }
            // gather the necessary dimensions to copy
            let width, height, depth, minX, minY, minZ;
            let dstX, dstY, dstZ;
            const image = srcTexture.isCompressedTexture ? srcTexture.mipmaps[dstLevel] : srcTexture.image;
            if (srcRegion !== null) {
                width = srcRegion.max.x - srcRegion.min.x;
                height = srcRegion.max.y - srcRegion.min.y;
                depth = srcRegion.isBox3 ? srcRegion.max.z - srcRegion.min.z : 1;
                minX = srcRegion.min.x;
                minY = srcRegion.min.y;
                minZ = srcRegion.isBox3 ? srcRegion.min.z : 0;
            } else {
                const levelScale = Math.pow(2, -srcLevel);
                width = Math.floor(image.width * levelScale);
                height = Math.floor(image.height * levelScale);
                if (srcTexture.isDataArrayTexture) depth = image.depth;
                else if (srcTexture.isData3DTexture) depth = Math.floor(image.depth * levelScale);
                else depth = 1;
                minX = 0;
                minY = 0;
                minZ = 0;
            }
            if (dstPosition !== null) {
                dstX = dstPosition.x;
                dstY = dstPosition.y;
                dstZ = dstPosition.z;
            } else {
                dstX = 0;
                dstY = 0;
                dstZ = 0;
            }
            // Set up the destination target
            const glFormat = utils.convert(dstTexture.format);
            const glType = utils.convert(dstTexture.type);
            let glTarget;
            if (dstTexture.isData3DTexture) {
                textures.setTexture3D(dstTexture, 0);
                glTarget = _gl.TEXTURE_3D;
            } else if (dstTexture.isDataArrayTexture || dstTexture.isCompressedArrayTexture) {
                textures.setTexture2DArray(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D_ARRAY;
            } else {
                textures.setTexture2D(dstTexture, 0);
                glTarget = _gl.TEXTURE_2D;
            }
            _gl.pixelStorei(_gl.UNPACK_FLIP_Y_WEBGL, dstTexture.flipY);
            _gl.pixelStorei(_gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, dstTexture.premultiplyAlpha);
            _gl.pixelStorei(_gl.UNPACK_ALIGNMENT, dstTexture.unpackAlignment);
            // used for copying data from cpu
            const currentUnpackRowLen = _gl.getParameter(_gl.UNPACK_ROW_LENGTH);
            const currentUnpackImageHeight = _gl.getParameter(_gl.UNPACK_IMAGE_HEIGHT);
            const currentUnpackSkipPixels = _gl.getParameter(_gl.UNPACK_SKIP_PIXELS);
            const currentUnpackSkipRows = _gl.getParameter(_gl.UNPACK_SKIP_ROWS);
            const currentUnpackSkipImages = _gl.getParameter(_gl.UNPACK_SKIP_IMAGES);
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, image.width);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, image.height);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, minX);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, minY);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, minZ);
            // set up the src texture
            const isSrc3D = srcTexture.isDataArrayTexture || srcTexture.isData3DTexture;
            const isDst3D = dstTexture.isDataArrayTexture || dstTexture.isData3DTexture;
            if (srcTexture.isDepthTexture) {
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                const srcRenderTargetProperties = properties.get(srcTextureProperties.__renderTarget);
                const dstRenderTargetProperties = properties.get(dstTextureProperties.__renderTarget);
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, srcRenderTargetProperties.__webglFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, dstRenderTargetProperties.__webglFramebuffer);
                for(let i = 0; i < depth; i++){
                    // if the source or destination are a 3d target then a layer needs to be bound
                    if (isSrc3D) {
                        _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(srcTexture).__webglTexture, srcLevel, minZ + i);
                        _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, properties.get(dstTexture).__webglTexture, dstLevel, dstZ + i);
                    }
                    _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.DEPTH_BUFFER_BIT, _gl.NEAREST);
                }
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (srcLevel !== 0 || srcTexture.isRenderTargetTexture || properties.has(srcTexture)) {
                // get the appropriate frame buffers
                const srcTextureProperties = properties.get(srcTexture);
                const dstTextureProperties = properties.get(dstTexture);
                // bind the frame buffer targets
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, _srcFramebuffer);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, _dstFramebuffer);
                for(let i = 0; i < depth; i++){
                    // assign the correct layers and mip maps to the frame buffers
                    if (isSrc3D) _gl.framebufferTextureLayer(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, srcTextureProperties.__webglTexture, srcLevel, minZ + i);
                    else _gl.framebufferTexture2D(_gl.READ_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, srcTextureProperties.__webglTexture, srcLevel);
                    if (isDst3D) _gl.framebufferTextureLayer(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, dstTextureProperties.__webglTexture, dstLevel, dstZ + i);
                    else _gl.framebufferTexture2D(_gl.DRAW_FRAMEBUFFER, _gl.COLOR_ATTACHMENT0, _gl.TEXTURE_2D, dstTextureProperties.__webglTexture, dstLevel);
                    // copy the data using the fastest function that can achieve the copy
                    if (srcLevel !== 0) _gl.blitFramebuffer(minX, minY, width, height, dstX, dstY, width, height, _gl.COLOR_BUFFER_BIT, _gl.NEAREST);
                    else if (isDst3D) _gl.copyTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ + i, minX, minY, width, height);
                    else _gl.copyTexSubImage2D(glTarget, dstLevel, dstX, dstY, minX, minY, width, height);
                }
                // unbind read, draw buffers
                state.bindFramebuffer(_gl.READ_FRAMEBUFFER, null);
                state.bindFramebuffer(_gl.DRAW_FRAMEBUFFER, null);
            } else if (isDst3D) {
                // copy data into the 3d texture
                if (srcTexture.isDataTexture || srcTexture.isData3DTexture) _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image.data);
                else if (dstTexture.isCompressedArrayTexture) _gl.compressedTexSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, image.data);
                else _gl.texSubImage3D(glTarget, dstLevel, dstX, dstY, dstZ, width, height, depth, glFormat, glType, image);
            } else {
                // copy data into the 2d texture
                if (srcTexture.isDataTexture) _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image.data);
                else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, image.width, image.height, glFormat, image.data);
                else _gl.texSubImage2D(_gl.TEXTURE_2D, dstLevel, dstX, dstY, width, height, glFormat, glType, image);
            }
            // reset values
            _gl.pixelStorei(_gl.UNPACK_ROW_LENGTH, currentUnpackRowLen);
            _gl.pixelStorei(_gl.UNPACK_IMAGE_HEIGHT, currentUnpackImageHeight);
            _gl.pixelStorei(_gl.UNPACK_SKIP_PIXELS, currentUnpackSkipPixels);
            _gl.pixelStorei(_gl.UNPACK_SKIP_ROWS, currentUnpackSkipRows);
            _gl.pixelStorei(_gl.UNPACK_SKIP_IMAGES, currentUnpackSkipImages);
            // Generate mipmaps only when copying level 0
            if (dstLevel === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(glTarget);
            state.unbindTexture();
        };
        /**
		 * Initializes the given WebGLRenderTarget memory. Useful for initializing a render target so data
		 * can be copied into it using {@link WebGLRenderer#copyTextureToTexture} before it has been
		 * rendered to.
		 *
		 * @param {WebGLRenderTarget} target - The render target.
		 */ this.initRenderTarget = function(target) {
            if (properties.get(target).__webglFramebuffer === undefined) textures.setupRenderTarget(target);
        };
        /**
		 * Initializes the given texture. Useful for preloading a texture rather than waiting until first
		 * render (which can cause noticeable lags due to decode and GPU upload overhead).
		 *
		 * @param {Texture} texture - The texture.
		 */ this.initTexture = function(texture) {
            if (texture.isCubeTexture) textures.setTextureCube(texture, 0);
            else if (texture.isData3DTexture) textures.setTexture3D(texture, 0);
            else if (texture.isDataArrayTexture || texture.isCompressedArrayTexture) textures.setTexture2DArray(texture, 0);
            else textures.setTexture2D(texture, 0);
            state.unbindTexture();
        };
        /**
		 * Can be used to reset the internal WebGL state. This method is mostly
		 * relevant for applications which share a single WebGL context across
		 * multiple WebGL libraries.
		 */ this.resetState = function() {
            _currentActiveCubeFace = 0;
            _currentActiveMipmapLevel = 0;
            _currentRenderTarget = null;
            state.reset();
            bindingStates.reset();
        };
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    /**
	 * Defines the coordinate system of the renderer.
	 *
	 * In `WebGLRenderer`, the value is always `WebGLCoordinateSystem`.
	 *
	 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
	 * @default WebGLCoordinateSystem
	 * @readonly
	 */ get coordinateSystem() {
        return 0, _threeCoreJs.WebGLCoordinateSystem;
    }
    /**
	 * Defines the output color space of the renderer.
	 *
	 * @type {SRGBColorSpace|LinearSRGBColorSpace}
	 * @default SRGBColorSpace
	 */ get outputColorSpace() {
        return this._outputColorSpace;
    }
    set outputColorSpace(colorSpace) {
        this._outputColorSpace = colorSpace;
        const gl = this.getContext();
        gl.drawingBufferColorSpace = (0, _threeCoreJs.ColorManagement)._getDrawingBufferColorSpace(colorSpace);
        gl.unpackColorSpace = (0, _threeCoreJs.ColorManagement)._getUnpackColorSpace();
    }
}

},{"./three.core.js":"bihzc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bihzc":[function(require,module,exports,__globalThis) {
/**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACESFilmicToneMapping", ()=>ACESFilmicToneMapping);
parcelHelpers.export(exports, "AddEquation", ()=>AddEquation);
parcelHelpers.export(exports, "AddOperation", ()=>AddOperation);
parcelHelpers.export(exports, "AdditiveAnimationBlendMode", ()=>AdditiveAnimationBlendMode);
parcelHelpers.export(exports, "AdditiveBlending", ()=>AdditiveBlending);
parcelHelpers.export(exports, "AgXToneMapping", ()=>AgXToneMapping);
parcelHelpers.export(exports, "AlphaFormat", ()=>AlphaFormat);
parcelHelpers.export(exports, "AlwaysCompare", ()=>AlwaysCompare);
parcelHelpers.export(exports, "AlwaysDepth", ()=>AlwaysDepth);
parcelHelpers.export(exports, "AlwaysStencilFunc", ()=>AlwaysStencilFunc);
parcelHelpers.export(exports, "AmbientLight", ()=>AmbientLight);
parcelHelpers.export(exports, "AnimationAction", ()=>AnimationAction);
parcelHelpers.export(exports, "AnimationClip", ()=>AnimationClip);
parcelHelpers.export(exports, "AnimationLoader", ()=>AnimationLoader);
parcelHelpers.export(exports, "AnimationMixer", ()=>AnimationMixer);
parcelHelpers.export(exports, "AnimationObjectGroup", ()=>AnimationObjectGroup);
parcelHelpers.export(exports, "AnimationUtils", ()=>AnimationUtils);
parcelHelpers.export(exports, "ArcCurve", ()=>ArcCurve);
parcelHelpers.export(exports, "ArrayCamera", ()=>ArrayCamera);
parcelHelpers.export(exports, "ArrowHelper", ()=>ArrowHelper);
parcelHelpers.export(exports, "AttachedBindMode", ()=>AttachedBindMode);
parcelHelpers.export(exports, "Audio", ()=>Audio);
parcelHelpers.export(exports, "AudioAnalyser", ()=>AudioAnalyser);
parcelHelpers.export(exports, "AudioContext", ()=>AudioContext);
parcelHelpers.export(exports, "AudioListener", ()=>AudioListener);
parcelHelpers.export(exports, "AudioLoader", ()=>AudioLoader);
parcelHelpers.export(exports, "AxesHelper", ()=>AxesHelper);
parcelHelpers.export(exports, "BackSide", ()=>BackSide);
parcelHelpers.export(exports, "BasicDepthPacking", ()=>BasicDepthPacking);
parcelHelpers.export(exports, "BasicShadowMap", ()=>BasicShadowMap);
parcelHelpers.export(exports, "BatchedMesh", ()=>BatchedMesh);
parcelHelpers.export(exports, "Bone", ()=>Bone);
parcelHelpers.export(exports, "BooleanKeyframeTrack", ()=>BooleanKeyframeTrack);
parcelHelpers.export(exports, "Box2", ()=>Box2);
parcelHelpers.export(exports, "Box3", ()=>Box3);
parcelHelpers.export(exports, "Box3Helper", ()=>Box3Helper);
parcelHelpers.export(exports, "BoxGeometry", ()=>BoxGeometry);
parcelHelpers.export(exports, "BoxHelper", ()=>BoxHelper);
parcelHelpers.export(exports, "BufferAttribute", ()=>BufferAttribute);
parcelHelpers.export(exports, "BufferGeometry", ()=>BufferGeometry);
parcelHelpers.export(exports, "BufferGeometryLoader", ()=>BufferGeometryLoader);
parcelHelpers.export(exports, "ByteType", ()=>ByteType);
parcelHelpers.export(exports, "Cache", ()=>Cache);
parcelHelpers.export(exports, "Camera", ()=>Camera);
parcelHelpers.export(exports, "CameraHelper", ()=>CameraHelper);
parcelHelpers.export(exports, "CanvasTexture", ()=>CanvasTexture);
parcelHelpers.export(exports, "CapsuleGeometry", ()=>CapsuleGeometry);
parcelHelpers.export(exports, "CatmullRomCurve3", ()=>CatmullRomCurve3);
parcelHelpers.export(exports, "CineonToneMapping", ()=>CineonToneMapping);
parcelHelpers.export(exports, "CircleGeometry", ()=>CircleGeometry);
parcelHelpers.export(exports, "ClampToEdgeWrapping", ()=>ClampToEdgeWrapping);
parcelHelpers.export(exports, "Clock", ()=>Clock);
parcelHelpers.export(exports, "Color", ()=>Color);
parcelHelpers.export(exports, "ColorKeyframeTrack", ()=>ColorKeyframeTrack);
parcelHelpers.export(exports, "ColorManagement", ()=>ColorManagement);
parcelHelpers.export(exports, "CompressedArrayTexture", ()=>CompressedArrayTexture);
parcelHelpers.export(exports, "CompressedCubeTexture", ()=>CompressedCubeTexture);
parcelHelpers.export(exports, "CompressedTexture", ()=>CompressedTexture);
parcelHelpers.export(exports, "CompressedTextureLoader", ()=>CompressedTextureLoader);
parcelHelpers.export(exports, "ConeGeometry", ()=>ConeGeometry);
parcelHelpers.export(exports, "ConstantAlphaFactor", ()=>ConstantAlphaFactor);
parcelHelpers.export(exports, "ConstantColorFactor", ()=>ConstantColorFactor);
parcelHelpers.export(exports, "Controls", ()=>Controls);
parcelHelpers.export(exports, "CubeCamera", ()=>CubeCamera);
parcelHelpers.export(exports, "CubeDepthTexture", ()=>CubeDepthTexture);
parcelHelpers.export(exports, "CubeReflectionMapping", ()=>CubeReflectionMapping);
parcelHelpers.export(exports, "CubeRefractionMapping", ()=>CubeRefractionMapping);
parcelHelpers.export(exports, "CubeTexture", ()=>CubeTexture);
parcelHelpers.export(exports, "CubeTextureLoader", ()=>CubeTextureLoader);
parcelHelpers.export(exports, "CubeUVReflectionMapping", ()=>CubeUVReflectionMapping);
parcelHelpers.export(exports, "CubicBezierCurve", ()=>CubicBezierCurve);
parcelHelpers.export(exports, "CubicBezierCurve3", ()=>CubicBezierCurve3);
parcelHelpers.export(exports, "CubicInterpolant", ()=>CubicInterpolant);
parcelHelpers.export(exports, "CullFaceBack", ()=>CullFaceBack);
parcelHelpers.export(exports, "CullFaceFront", ()=>CullFaceFront);
parcelHelpers.export(exports, "CullFaceFrontBack", ()=>CullFaceFrontBack);
parcelHelpers.export(exports, "CullFaceNone", ()=>CullFaceNone);
parcelHelpers.export(exports, "Curve", ()=>Curve);
parcelHelpers.export(exports, "CurvePath", ()=>CurvePath);
parcelHelpers.export(exports, "CustomBlending", ()=>CustomBlending);
parcelHelpers.export(exports, "CustomToneMapping", ()=>CustomToneMapping);
parcelHelpers.export(exports, "CylinderGeometry", ()=>CylinderGeometry);
parcelHelpers.export(exports, "Cylindrical", ()=>Cylindrical);
parcelHelpers.export(exports, "Data3DTexture", ()=>Data3DTexture);
parcelHelpers.export(exports, "DataArrayTexture", ()=>DataArrayTexture);
parcelHelpers.export(exports, "DataTexture", ()=>DataTexture);
parcelHelpers.export(exports, "DataTextureLoader", ()=>DataTextureLoader);
parcelHelpers.export(exports, "DataUtils", ()=>DataUtils);
parcelHelpers.export(exports, "DecrementStencilOp", ()=>DecrementStencilOp);
parcelHelpers.export(exports, "DecrementWrapStencilOp", ()=>DecrementWrapStencilOp);
parcelHelpers.export(exports, "DefaultLoadingManager", ()=>DefaultLoadingManager);
parcelHelpers.export(exports, "DepthFormat", ()=>DepthFormat);
parcelHelpers.export(exports, "DepthStencilFormat", ()=>DepthStencilFormat);
parcelHelpers.export(exports, "DepthTexture", ()=>DepthTexture);
parcelHelpers.export(exports, "DetachedBindMode", ()=>DetachedBindMode);
parcelHelpers.export(exports, "DirectionalLight", ()=>DirectionalLight);
parcelHelpers.export(exports, "DirectionalLightHelper", ()=>DirectionalLightHelper);
parcelHelpers.export(exports, "DiscreteInterpolant", ()=>DiscreteInterpolant);
parcelHelpers.export(exports, "DodecahedronGeometry", ()=>DodecahedronGeometry);
parcelHelpers.export(exports, "DoubleSide", ()=>DoubleSide);
parcelHelpers.export(exports, "DstAlphaFactor", ()=>DstAlphaFactor);
parcelHelpers.export(exports, "DstColorFactor", ()=>DstColorFactor);
parcelHelpers.export(exports, "DynamicCopyUsage", ()=>DynamicCopyUsage);
parcelHelpers.export(exports, "DynamicDrawUsage", ()=>DynamicDrawUsage);
parcelHelpers.export(exports, "DynamicReadUsage", ()=>DynamicReadUsage);
parcelHelpers.export(exports, "EdgesGeometry", ()=>EdgesGeometry);
parcelHelpers.export(exports, "EllipseCurve", ()=>EllipseCurve);
parcelHelpers.export(exports, "EqualCompare", ()=>EqualCompare);
parcelHelpers.export(exports, "EqualDepth", ()=>EqualDepth);
parcelHelpers.export(exports, "EqualStencilFunc", ()=>EqualStencilFunc);
parcelHelpers.export(exports, "EquirectangularReflectionMapping", ()=>EquirectangularReflectionMapping);
parcelHelpers.export(exports, "EquirectangularRefractionMapping", ()=>EquirectangularRefractionMapping);
parcelHelpers.export(exports, "Euler", ()=>Euler);
parcelHelpers.export(exports, "EventDispatcher", ()=>EventDispatcher);
parcelHelpers.export(exports, "ExternalTexture", ()=>ExternalTexture);
parcelHelpers.export(exports, "ExtrudeGeometry", ()=>ExtrudeGeometry);
parcelHelpers.export(exports, "FileLoader", ()=>FileLoader);
parcelHelpers.export(exports, "Float16BufferAttribute", ()=>Float16BufferAttribute);
parcelHelpers.export(exports, "Float32BufferAttribute", ()=>Float32BufferAttribute);
parcelHelpers.export(exports, "FloatType", ()=>FloatType);
parcelHelpers.export(exports, "Fog", ()=>Fog);
parcelHelpers.export(exports, "FogExp2", ()=>FogExp2);
parcelHelpers.export(exports, "FramebufferTexture", ()=>FramebufferTexture);
parcelHelpers.export(exports, "FrontSide", ()=>FrontSide);
parcelHelpers.export(exports, "Frustum", ()=>Frustum);
parcelHelpers.export(exports, "FrustumArray", ()=>FrustumArray);
parcelHelpers.export(exports, "GLBufferAttribute", ()=>GLBufferAttribute);
parcelHelpers.export(exports, "GLSL1", ()=>GLSL1);
parcelHelpers.export(exports, "GLSL3", ()=>GLSL3);
parcelHelpers.export(exports, "GreaterCompare", ()=>GreaterCompare);
parcelHelpers.export(exports, "GreaterDepth", ()=>GreaterDepth);
parcelHelpers.export(exports, "GreaterEqualCompare", ()=>GreaterEqualCompare);
parcelHelpers.export(exports, "GreaterEqualDepth", ()=>GreaterEqualDepth);
parcelHelpers.export(exports, "GreaterEqualStencilFunc", ()=>GreaterEqualStencilFunc);
parcelHelpers.export(exports, "GreaterStencilFunc", ()=>GreaterStencilFunc);
parcelHelpers.export(exports, "GridHelper", ()=>GridHelper);
parcelHelpers.export(exports, "Group", ()=>Group);
parcelHelpers.export(exports, "HalfFloatType", ()=>HalfFloatType);
parcelHelpers.export(exports, "HemisphereLight", ()=>HemisphereLight);
parcelHelpers.export(exports, "HemisphereLightHelper", ()=>HemisphereLightHelper);
parcelHelpers.export(exports, "IcosahedronGeometry", ()=>IcosahedronGeometry);
parcelHelpers.export(exports, "ImageBitmapLoader", ()=>ImageBitmapLoader);
parcelHelpers.export(exports, "ImageLoader", ()=>ImageLoader);
parcelHelpers.export(exports, "ImageUtils", ()=>ImageUtils);
parcelHelpers.export(exports, "IncrementStencilOp", ()=>IncrementStencilOp);
parcelHelpers.export(exports, "IncrementWrapStencilOp", ()=>IncrementWrapStencilOp);
parcelHelpers.export(exports, "InstancedBufferAttribute", ()=>InstancedBufferAttribute);
parcelHelpers.export(exports, "InstancedBufferGeometry", ()=>InstancedBufferGeometry);
parcelHelpers.export(exports, "InstancedInterleavedBuffer", ()=>InstancedInterleavedBuffer);
parcelHelpers.export(exports, "InstancedMesh", ()=>InstancedMesh);
parcelHelpers.export(exports, "Int16BufferAttribute", ()=>Int16BufferAttribute);
parcelHelpers.export(exports, "Int32BufferAttribute", ()=>Int32BufferAttribute);
parcelHelpers.export(exports, "Int8BufferAttribute", ()=>Int8BufferAttribute);
parcelHelpers.export(exports, "IntType", ()=>IntType);
parcelHelpers.export(exports, "InterleavedBuffer", ()=>InterleavedBuffer);
parcelHelpers.export(exports, "InterleavedBufferAttribute", ()=>InterleavedBufferAttribute);
parcelHelpers.export(exports, "Interpolant", ()=>Interpolant);
parcelHelpers.export(exports, "InterpolateDiscrete", ()=>InterpolateDiscrete);
parcelHelpers.export(exports, "InterpolateLinear", ()=>InterpolateLinear);
parcelHelpers.export(exports, "InterpolateSmooth", ()=>InterpolateSmooth);
parcelHelpers.export(exports, "InterpolationSamplingMode", ()=>InterpolationSamplingMode);
parcelHelpers.export(exports, "InterpolationSamplingType", ()=>InterpolationSamplingType);
parcelHelpers.export(exports, "InvertStencilOp", ()=>InvertStencilOp);
parcelHelpers.export(exports, "KeepStencilOp", ()=>KeepStencilOp);
parcelHelpers.export(exports, "KeyframeTrack", ()=>KeyframeTrack);
parcelHelpers.export(exports, "LOD", ()=>LOD);
parcelHelpers.export(exports, "LatheGeometry", ()=>LatheGeometry);
parcelHelpers.export(exports, "Layers", ()=>Layers);
parcelHelpers.export(exports, "LessCompare", ()=>LessCompare);
parcelHelpers.export(exports, "LessDepth", ()=>LessDepth);
parcelHelpers.export(exports, "LessEqualCompare", ()=>LessEqualCompare);
parcelHelpers.export(exports, "LessEqualDepth", ()=>LessEqualDepth);
parcelHelpers.export(exports, "LessEqualStencilFunc", ()=>LessEqualStencilFunc);
parcelHelpers.export(exports, "LessStencilFunc", ()=>LessStencilFunc);
parcelHelpers.export(exports, "Light", ()=>Light);
parcelHelpers.export(exports, "LightProbe", ()=>LightProbe);
parcelHelpers.export(exports, "Line", ()=>Line);
parcelHelpers.export(exports, "Line3", ()=>Line3);
parcelHelpers.export(exports, "LineBasicMaterial", ()=>LineBasicMaterial);
parcelHelpers.export(exports, "LineCurve", ()=>LineCurve);
parcelHelpers.export(exports, "LineCurve3", ()=>LineCurve3);
parcelHelpers.export(exports, "LineDashedMaterial", ()=>LineDashedMaterial);
parcelHelpers.export(exports, "LineLoop", ()=>LineLoop);
parcelHelpers.export(exports, "LineSegments", ()=>LineSegments);
parcelHelpers.export(exports, "LinearFilter", ()=>LinearFilter);
parcelHelpers.export(exports, "LinearInterpolant", ()=>LinearInterpolant);
parcelHelpers.export(exports, "LinearMipMapLinearFilter", ()=>LinearMipMapLinearFilter);
parcelHelpers.export(exports, "LinearMipMapNearestFilter", ()=>LinearMipMapNearestFilter);
parcelHelpers.export(exports, "LinearMipmapLinearFilter", ()=>LinearMipmapLinearFilter);
parcelHelpers.export(exports, "LinearMipmapNearestFilter", ()=>LinearMipmapNearestFilter);
parcelHelpers.export(exports, "LinearSRGBColorSpace", ()=>LinearSRGBColorSpace);
parcelHelpers.export(exports, "LinearToneMapping", ()=>LinearToneMapping);
parcelHelpers.export(exports, "LinearTransfer", ()=>LinearTransfer);
parcelHelpers.export(exports, "Loader", ()=>Loader);
parcelHelpers.export(exports, "LoaderUtils", ()=>LoaderUtils);
parcelHelpers.export(exports, "LoadingManager", ()=>LoadingManager);
parcelHelpers.export(exports, "LoopOnce", ()=>LoopOnce);
parcelHelpers.export(exports, "LoopPingPong", ()=>LoopPingPong);
parcelHelpers.export(exports, "LoopRepeat", ()=>LoopRepeat);
parcelHelpers.export(exports, "MOUSE", ()=>MOUSE);
parcelHelpers.export(exports, "Material", ()=>Material);
parcelHelpers.export(exports, "MaterialLoader", ()=>MaterialLoader);
parcelHelpers.export(exports, "MathUtils", ()=>MathUtils);
parcelHelpers.export(exports, "Matrix2", ()=>Matrix2);
parcelHelpers.export(exports, "Matrix3", ()=>Matrix3);
parcelHelpers.export(exports, "Matrix4", ()=>Matrix4);
parcelHelpers.export(exports, "MaxEquation", ()=>MaxEquation);
parcelHelpers.export(exports, "Mesh", ()=>Mesh);
parcelHelpers.export(exports, "MeshBasicMaterial", ()=>MeshBasicMaterial);
parcelHelpers.export(exports, "MeshDepthMaterial", ()=>MeshDepthMaterial);
parcelHelpers.export(exports, "MeshDistanceMaterial", ()=>MeshDistanceMaterial);
parcelHelpers.export(exports, "MeshLambertMaterial", ()=>MeshLambertMaterial);
parcelHelpers.export(exports, "MeshMatcapMaterial", ()=>MeshMatcapMaterial);
parcelHelpers.export(exports, "MeshNormalMaterial", ()=>MeshNormalMaterial);
parcelHelpers.export(exports, "MeshPhongMaterial", ()=>MeshPhongMaterial);
parcelHelpers.export(exports, "MeshPhysicalMaterial", ()=>MeshPhysicalMaterial);
parcelHelpers.export(exports, "MeshStandardMaterial", ()=>MeshStandardMaterial);
parcelHelpers.export(exports, "MeshToonMaterial", ()=>MeshToonMaterial);
parcelHelpers.export(exports, "MinEquation", ()=>MinEquation);
parcelHelpers.export(exports, "MirroredRepeatWrapping", ()=>MirroredRepeatWrapping);
parcelHelpers.export(exports, "MixOperation", ()=>MixOperation);
parcelHelpers.export(exports, "MultiplyBlending", ()=>MultiplyBlending);
parcelHelpers.export(exports, "MultiplyOperation", ()=>MultiplyOperation);
parcelHelpers.export(exports, "NearestFilter", ()=>NearestFilter);
parcelHelpers.export(exports, "NearestMipMapLinearFilter", ()=>NearestMipMapLinearFilter);
parcelHelpers.export(exports, "NearestMipMapNearestFilter", ()=>NearestMipMapNearestFilter);
parcelHelpers.export(exports, "NearestMipmapLinearFilter", ()=>NearestMipmapLinearFilter);
parcelHelpers.export(exports, "NearestMipmapNearestFilter", ()=>NearestMipmapNearestFilter);
parcelHelpers.export(exports, "NeutralToneMapping", ()=>NeutralToneMapping);
parcelHelpers.export(exports, "NeverCompare", ()=>NeverCompare);
parcelHelpers.export(exports, "NeverDepth", ()=>NeverDepth);
parcelHelpers.export(exports, "NeverStencilFunc", ()=>NeverStencilFunc);
parcelHelpers.export(exports, "NoBlending", ()=>NoBlending);
parcelHelpers.export(exports, "NoColorSpace", ()=>NoColorSpace);
parcelHelpers.export(exports, "NoNormalPacking", ()=>NoNormalPacking);
parcelHelpers.export(exports, "NoToneMapping", ()=>NoToneMapping);
parcelHelpers.export(exports, "NormalAnimationBlendMode", ()=>NormalAnimationBlendMode);
parcelHelpers.export(exports, "NormalBlending", ()=>NormalBlending);
parcelHelpers.export(exports, "NormalGAPacking", ()=>NormalGAPacking);
parcelHelpers.export(exports, "NormalRGPacking", ()=>NormalRGPacking);
parcelHelpers.export(exports, "NotEqualCompare", ()=>NotEqualCompare);
parcelHelpers.export(exports, "NotEqualDepth", ()=>NotEqualDepth);
parcelHelpers.export(exports, "NotEqualStencilFunc", ()=>NotEqualStencilFunc);
parcelHelpers.export(exports, "NumberKeyframeTrack", ()=>NumberKeyframeTrack);
parcelHelpers.export(exports, "Object3D", ()=>Object3D);
parcelHelpers.export(exports, "ObjectLoader", ()=>ObjectLoader);
parcelHelpers.export(exports, "ObjectSpaceNormalMap", ()=>ObjectSpaceNormalMap);
parcelHelpers.export(exports, "OctahedronGeometry", ()=>OctahedronGeometry);
parcelHelpers.export(exports, "OneFactor", ()=>OneFactor);
parcelHelpers.export(exports, "OneMinusConstantAlphaFactor", ()=>OneMinusConstantAlphaFactor);
parcelHelpers.export(exports, "OneMinusConstantColorFactor", ()=>OneMinusConstantColorFactor);
parcelHelpers.export(exports, "OneMinusDstAlphaFactor", ()=>OneMinusDstAlphaFactor);
parcelHelpers.export(exports, "OneMinusDstColorFactor", ()=>OneMinusDstColorFactor);
parcelHelpers.export(exports, "OneMinusSrcAlphaFactor", ()=>OneMinusSrcAlphaFactor);
parcelHelpers.export(exports, "OneMinusSrcColorFactor", ()=>OneMinusSrcColorFactor);
parcelHelpers.export(exports, "OrthographicCamera", ()=>OrthographicCamera);
parcelHelpers.export(exports, "PCFShadowMap", ()=>PCFShadowMap);
parcelHelpers.export(exports, "PCFSoftShadowMap", ()=>PCFSoftShadowMap);
parcelHelpers.export(exports, "Path", ()=>Path);
parcelHelpers.export(exports, "PerspectiveCamera", ()=>PerspectiveCamera);
parcelHelpers.export(exports, "Plane", ()=>Plane);
parcelHelpers.export(exports, "PlaneGeometry", ()=>PlaneGeometry);
parcelHelpers.export(exports, "PlaneHelper", ()=>PlaneHelper);
parcelHelpers.export(exports, "PointLight", ()=>PointLight);
parcelHelpers.export(exports, "PointLightHelper", ()=>PointLightHelper);
parcelHelpers.export(exports, "Points", ()=>Points);
parcelHelpers.export(exports, "PointsMaterial", ()=>PointsMaterial);
parcelHelpers.export(exports, "PolarGridHelper", ()=>PolarGridHelper);
parcelHelpers.export(exports, "PolyhedronGeometry", ()=>PolyhedronGeometry);
parcelHelpers.export(exports, "PositionalAudio", ()=>PositionalAudio);
parcelHelpers.export(exports, "PropertyBinding", ()=>PropertyBinding);
parcelHelpers.export(exports, "PropertyMixer", ()=>PropertyMixer);
parcelHelpers.export(exports, "QuadraticBezierCurve", ()=>QuadraticBezierCurve);
parcelHelpers.export(exports, "QuadraticBezierCurve3", ()=>QuadraticBezierCurve3);
parcelHelpers.export(exports, "Quaternion", ()=>Quaternion);
parcelHelpers.export(exports, "QuaternionKeyframeTrack", ()=>QuaternionKeyframeTrack);
parcelHelpers.export(exports, "QuaternionLinearInterpolant", ()=>QuaternionLinearInterpolant);
parcelHelpers.export(exports, "R11_EAC_Format", ()=>R11_EAC_Format);
parcelHelpers.export(exports, "RAD2DEG", ()=>RAD2DEG);
parcelHelpers.export(exports, "RED_GREEN_RGTC2_Format", ()=>RED_GREEN_RGTC2_Format);
parcelHelpers.export(exports, "RED_RGTC1_Format", ()=>RED_RGTC1_Format);
parcelHelpers.export(exports, "REVISION", ()=>REVISION);
parcelHelpers.export(exports, "RG11_EAC_Format", ()=>RG11_EAC_Format);
parcelHelpers.export(exports, "RGBADepthPacking", ()=>RGBADepthPacking);
parcelHelpers.export(exports, "RGBAFormat", ()=>RGBAFormat);
parcelHelpers.export(exports, "RGBAIntegerFormat", ()=>RGBAIntegerFormat);
parcelHelpers.export(exports, "RGBA_ASTC_10x10_Format", ()=>RGBA_ASTC_10x10_Format);
parcelHelpers.export(exports, "RGBA_ASTC_10x5_Format", ()=>RGBA_ASTC_10x5_Format);
parcelHelpers.export(exports, "RGBA_ASTC_10x6_Format", ()=>RGBA_ASTC_10x6_Format);
parcelHelpers.export(exports, "RGBA_ASTC_10x8_Format", ()=>RGBA_ASTC_10x8_Format);
parcelHelpers.export(exports, "RGBA_ASTC_12x10_Format", ()=>RGBA_ASTC_12x10_Format);
parcelHelpers.export(exports, "RGBA_ASTC_12x12_Format", ()=>RGBA_ASTC_12x12_Format);
parcelHelpers.export(exports, "RGBA_ASTC_4x4_Format", ()=>RGBA_ASTC_4x4_Format);
parcelHelpers.export(exports, "RGBA_ASTC_5x4_Format", ()=>RGBA_ASTC_5x4_Format);
parcelHelpers.export(exports, "RGBA_ASTC_5x5_Format", ()=>RGBA_ASTC_5x5_Format);
parcelHelpers.export(exports, "RGBA_ASTC_6x5_Format", ()=>RGBA_ASTC_6x5_Format);
parcelHelpers.export(exports, "RGBA_ASTC_6x6_Format", ()=>RGBA_ASTC_6x6_Format);
parcelHelpers.export(exports, "RGBA_ASTC_8x5_Format", ()=>RGBA_ASTC_8x5_Format);
parcelHelpers.export(exports, "RGBA_ASTC_8x6_Format", ()=>RGBA_ASTC_8x6_Format);
parcelHelpers.export(exports, "RGBA_ASTC_8x8_Format", ()=>RGBA_ASTC_8x8_Format);
parcelHelpers.export(exports, "RGBA_BPTC_Format", ()=>RGBA_BPTC_Format);
parcelHelpers.export(exports, "RGBA_ETC2_EAC_Format", ()=>RGBA_ETC2_EAC_Format);
parcelHelpers.export(exports, "RGBA_PVRTC_2BPPV1_Format", ()=>RGBA_PVRTC_2BPPV1_Format);
parcelHelpers.export(exports, "RGBA_PVRTC_4BPPV1_Format", ()=>RGBA_PVRTC_4BPPV1_Format);
parcelHelpers.export(exports, "RGBA_S3TC_DXT1_Format", ()=>RGBA_S3TC_DXT1_Format);
parcelHelpers.export(exports, "RGBA_S3TC_DXT3_Format", ()=>RGBA_S3TC_DXT3_Format);
parcelHelpers.export(exports, "RGBA_S3TC_DXT5_Format", ()=>RGBA_S3TC_DXT5_Format);
parcelHelpers.export(exports, "RGBDepthPacking", ()=>RGBDepthPacking);
parcelHelpers.export(exports, "RGBFormat", ()=>RGBFormat);
parcelHelpers.export(exports, "RGBIntegerFormat", ()=>RGBIntegerFormat);
parcelHelpers.export(exports, "RGB_BPTC_SIGNED_Format", ()=>RGB_BPTC_SIGNED_Format);
parcelHelpers.export(exports, "RGB_BPTC_UNSIGNED_Format", ()=>RGB_BPTC_UNSIGNED_Format);
parcelHelpers.export(exports, "RGB_ETC1_Format", ()=>RGB_ETC1_Format);
parcelHelpers.export(exports, "RGB_ETC2_Format", ()=>RGB_ETC2_Format);
parcelHelpers.export(exports, "RGB_PVRTC_2BPPV1_Format", ()=>RGB_PVRTC_2BPPV1_Format);
parcelHelpers.export(exports, "RGB_PVRTC_4BPPV1_Format", ()=>RGB_PVRTC_4BPPV1_Format);
parcelHelpers.export(exports, "RGB_S3TC_DXT1_Format", ()=>RGB_S3TC_DXT1_Format);
parcelHelpers.export(exports, "RGDepthPacking", ()=>RGDepthPacking);
parcelHelpers.export(exports, "RGFormat", ()=>RGFormat);
parcelHelpers.export(exports, "RGIntegerFormat", ()=>RGIntegerFormat);
parcelHelpers.export(exports, "RawShaderMaterial", ()=>RawShaderMaterial);
parcelHelpers.export(exports, "Ray", ()=>Ray);
parcelHelpers.export(exports, "Raycaster", ()=>Raycaster);
parcelHelpers.export(exports, "RectAreaLight", ()=>RectAreaLight);
parcelHelpers.export(exports, "RedFormat", ()=>RedFormat);
parcelHelpers.export(exports, "RedIntegerFormat", ()=>RedIntegerFormat);
parcelHelpers.export(exports, "ReinhardToneMapping", ()=>ReinhardToneMapping);
parcelHelpers.export(exports, "RenderTarget", ()=>RenderTarget);
parcelHelpers.export(exports, "RenderTarget3D", ()=>RenderTarget3D);
parcelHelpers.export(exports, "RepeatWrapping", ()=>RepeatWrapping);
parcelHelpers.export(exports, "ReplaceStencilOp", ()=>ReplaceStencilOp);
parcelHelpers.export(exports, "ReverseSubtractEquation", ()=>ReverseSubtractEquation);
parcelHelpers.export(exports, "RingGeometry", ()=>RingGeometry);
parcelHelpers.export(exports, "SIGNED_R11_EAC_Format", ()=>SIGNED_R11_EAC_Format);
parcelHelpers.export(exports, "SIGNED_RED_GREEN_RGTC2_Format", ()=>SIGNED_RED_GREEN_RGTC2_Format);
parcelHelpers.export(exports, "SIGNED_RED_RGTC1_Format", ()=>SIGNED_RED_RGTC1_Format);
parcelHelpers.export(exports, "SIGNED_RG11_EAC_Format", ()=>SIGNED_RG11_EAC_Format);
parcelHelpers.export(exports, "SRGBColorSpace", ()=>SRGBColorSpace);
parcelHelpers.export(exports, "SRGBTransfer", ()=>SRGBTransfer);
parcelHelpers.export(exports, "Scene", ()=>Scene);
parcelHelpers.export(exports, "ShaderMaterial", ()=>ShaderMaterial);
parcelHelpers.export(exports, "ShadowMaterial", ()=>ShadowMaterial);
parcelHelpers.export(exports, "Shape", ()=>Shape);
parcelHelpers.export(exports, "ShapeGeometry", ()=>ShapeGeometry);
parcelHelpers.export(exports, "ShapePath", ()=>ShapePath);
parcelHelpers.export(exports, "ShapeUtils", ()=>ShapeUtils);
parcelHelpers.export(exports, "ShortType", ()=>ShortType);
parcelHelpers.export(exports, "Skeleton", ()=>Skeleton);
parcelHelpers.export(exports, "SkeletonHelper", ()=>SkeletonHelper);
parcelHelpers.export(exports, "SkinnedMesh", ()=>SkinnedMesh);
parcelHelpers.export(exports, "Source", ()=>Source);
parcelHelpers.export(exports, "Sphere", ()=>Sphere);
parcelHelpers.export(exports, "SphereGeometry", ()=>SphereGeometry);
parcelHelpers.export(exports, "Spherical", ()=>Spherical);
parcelHelpers.export(exports, "SphericalHarmonics3", ()=>SphericalHarmonics3);
parcelHelpers.export(exports, "SplineCurve", ()=>SplineCurve);
parcelHelpers.export(exports, "SpotLight", ()=>SpotLight);
parcelHelpers.export(exports, "SpotLightHelper", ()=>SpotLightHelper);
parcelHelpers.export(exports, "Sprite", ()=>Sprite);
parcelHelpers.export(exports, "SpriteMaterial", ()=>SpriteMaterial);
parcelHelpers.export(exports, "SrcAlphaFactor", ()=>SrcAlphaFactor);
parcelHelpers.export(exports, "SrcAlphaSaturateFactor", ()=>SrcAlphaSaturateFactor);
parcelHelpers.export(exports, "SrcColorFactor", ()=>SrcColorFactor);
parcelHelpers.export(exports, "StaticCopyUsage", ()=>StaticCopyUsage);
parcelHelpers.export(exports, "StaticDrawUsage", ()=>StaticDrawUsage);
parcelHelpers.export(exports, "StaticReadUsage", ()=>StaticReadUsage);
parcelHelpers.export(exports, "StereoCamera", ()=>StereoCamera);
parcelHelpers.export(exports, "StreamCopyUsage", ()=>StreamCopyUsage);
parcelHelpers.export(exports, "StreamDrawUsage", ()=>StreamDrawUsage);
parcelHelpers.export(exports, "StreamReadUsage", ()=>StreamReadUsage);
parcelHelpers.export(exports, "StringKeyframeTrack", ()=>StringKeyframeTrack);
parcelHelpers.export(exports, "SubtractEquation", ()=>SubtractEquation);
parcelHelpers.export(exports, "SubtractiveBlending", ()=>SubtractiveBlending);
parcelHelpers.export(exports, "TOUCH", ()=>TOUCH);
parcelHelpers.export(exports, "TangentSpaceNormalMap", ()=>TangentSpaceNormalMap);
parcelHelpers.export(exports, "TetrahedronGeometry", ()=>TetrahedronGeometry);
parcelHelpers.export(exports, "Texture", ()=>Texture);
parcelHelpers.export(exports, "TextureLoader", ()=>TextureLoader);
parcelHelpers.export(exports, "TextureUtils", ()=>TextureUtils);
parcelHelpers.export(exports, "Timer", ()=>Timer);
parcelHelpers.export(exports, "TimestampQuery", ()=>TimestampQuery);
parcelHelpers.export(exports, "TorusGeometry", ()=>TorusGeometry);
parcelHelpers.export(exports, "TorusKnotGeometry", ()=>TorusKnotGeometry);
parcelHelpers.export(exports, "Triangle", ()=>Triangle);
parcelHelpers.export(exports, "TriangleFanDrawMode", ()=>TriangleFanDrawMode);
parcelHelpers.export(exports, "TriangleStripDrawMode", ()=>TriangleStripDrawMode);
parcelHelpers.export(exports, "TrianglesDrawMode", ()=>TrianglesDrawMode);
parcelHelpers.export(exports, "TubeGeometry", ()=>TubeGeometry);
parcelHelpers.export(exports, "UVMapping", ()=>UVMapping);
parcelHelpers.export(exports, "Uint16BufferAttribute", ()=>Uint16BufferAttribute);
parcelHelpers.export(exports, "Uint32BufferAttribute", ()=>Uint32BufferAttribute);
parcelHelpers.export(exports, "Uint8BufferAttribute", ()=>Uint8BufferAttribute);
parcelHelpers.export(exports, "Uint8ClampedBufferAttribute", ()=>Uint8ClampedBufferAttribute);
parcelHelpers.export(exports, "Uniform", ()=>Uniform);
parcelHelpers.export(exports, "UniformsGroup", ()=>UniformsGroup);
parcelHelpers.export(exports, "UniformsUtils", ()=>UniformsUtils);
parcelHelpers.export(exports, "UnsignedByteType", ()=>UnsignedByteType);
parcelHelpers.export(exports, "UnsignedInt101111Type", ()=>UnsignedInt101111Type);
parcelHelpers.export(exports, "UnsignedInt248Type", ()=>UnsignedInt248Type);
parcelHelpers.export(exports, "UnsignedInt5999Type", ()=>UnsignedInt5999Type);
parcelHelpers.export(exports, "UnsignedIntType", ()=>UnsignedIntType);
parcelHelpers.export(exports, "UnsignedShort4444Type", ()=>UnsignedShort4444Type);
parcelHelpers.export(exports, "UnsignedShort5551Type", ()=>UnsignedShort5551Type);
parcelHelpers.export(exports, "UnsignedShortType", ()=>UnsignedShortType);
parcelHelpers.export(exports, "VSMShadowMap", ()=>VSMShadowMap);
parcelHelpers.export(exports, "Vector2", ()=>Vector2);
parcelHelpers.export(exports, "Vector3", ()=>Vector3);
parcelHelpers.export(exports, "Vector4", ()=>Vector4);
parcelHelpers.export(exports, "VectorKeyframeTrack", ()=>VectorKeyframeTrack);
parcelHelpers.export(exports, "VideoFrameTexture", ()=>VideoFrameTexture);
parcelHelpers.export(exports, "VideoTexture", ()=>VideoTexture);
parcelHelpers.export(exports, "WebGL3DRenderTarget", ()=>WebGL3DRenderTarget);
parcelHelpers.export(exports, "WebGLArrayRenderTarget", ()=>WebGLArrayRenderTarget);
parcelHelpers.export(exports, "WebGLCoordinateSystem", ()=>WebGLCoordinateSystem);
parcelHelpers.export(exports, "WebGLCubeRenderTarget", ()=>WebGLCubeRenderTarget);
parcelHelpers.export(exports, "WebGLRenderTarget", ()=>WebGLRenderTarget);
parcelHelpers.export(exports, "WebGPUCoordinateSystem", ()=>WebGPUCoordinateSystem);
parcelHelpers.export(exports, "WebXRController", ()=>WebXRController);
parcelHelpers.export(exports, "WireframeGeometry", ()=>WireframeGeometry);
parcelHelpers.export(exports, "WrapAroundEnding", ()=>WrapAroundEnding);
parcelHelpers.export(exports, "ZeroCurvatureEnding", ()=>ZeroCurvatureEnding);
parcelHelpers.export(exports, "ZeroFactor", ()=>ZeroFactor);
parcelHelpers.export(exports, "ZeroSlopeEnding", ()=>ZeroSlopeEnding);
parcelHelpers.export(exports, "ZeroStencilOp", ()=>ZeroStencilOp);
parcelHelpers.export(exports, "arrayNeedsUint32", ()=>arrayNeedsUint32);
parcelHelpers.export(exports, "cloneUniforms", ()=>cloneUniforms);
parcelHelpers.export(exports, "createCanvasElement", ()=>createCanvasElement);
parcelHelpers.export(exports, "createElementNS", ()=>createElementNS);
parcelHelpers.export(exports, "error", ()=>error);
parcelHelpers.export(exports, "getByteLength", ()=>getByteLength);
parcelHelpers.export(exports, "getConsoleFunction", ()=>getConsoleFunction);
parcelHelpers.export(exports, "getUnlitUniformColorSpace", ()=>getUnlitUniformColorSpace);
parcelHelpers.export(exports, "isTypedArray", ()=>isTypedArray);
parcelHelpers.export(exports, "log", ()=>log);
parcelHelpers.export(exports, "mergeUniforms", ()=>mergeUniforms);
parcelHelpers.export(exports, "probeAsync", ()=>probeAsync);
parcelHelpers.export(exports, "setConsoleFunction", ()=>setConsoleFunction);
parcelHelpers.export(exports, "warn", ()=>warn);
parcelHelpers.export(exports, "warnOnce", ()=>warnOnce);
const REVISION = '182';
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsMouse}
 * @constant
 */ const MOUSE = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
/**
 * Represents touch interaction types in context of controls.
 *
 * @type {ConstantsTouch}
 * @constant
 */ const TOUCH = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
/**
 * Disables face culling.
 *
 * @type {number}
 * @constant
 */ const CullFaceNone = 0;
/**
 * Culls back faces.
 *
 * @type {number}
 * @constant
 */ const CullFaceBack = 1;
/**
 * Culls front faces.
 *
 * @type {number}
 * @constant
 */ const CullFaceFront = 2;
/**
 * Culls both front and back faces.
 *
 * @type {number}
 * @constant
 */ const CullFaceFrontBack = 3;
/**
 * Gives unfiltered shadow maps - fastest, but lowest quality.
 *
 * @type {number}
 * @constant
 */ const BasicShadowMap = 0;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm.
 *
 * @type {number}
 * @constant
 */ const PCFShadowMap = 1;
/**
 * Filters shadow maps using the Percentage-Closer Filtering (PCF) algorithm with
 * better soft shadows especially when using low-resolution shadow maps.
 *
 * @type {number}
 * @constant
 */ const PCFSoftShadowMap = 2;
/**
 * Filters shadow maps using the Variance Shadow Map (VSM) algorithm.
 * When using VSMShadowMap all shadow receivers will also cast shadows.
 *
 * @type {number}
 * @constant
 */ const VSMShadowMap = 3;
/**
 * Only front faces are rendered.
 *
 * @type {number}
 * @constant
 */ const FrontSide = 0;
/**
 * Only back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const BackSide = 1;
/**
 * Both front and back faces are rendered.
 *
 * @type {number}
 * @constant
 */ const DoubleSide = 2;
/**
 * No blending is performed which effectively disables
 * alpha transparency.
 *
 * @type {number}
 * @constant
 */ const NoBlending = 0;
/**
 * The default blending.
 *
 * @type {number}
 * @constant
 */ const NormalBlending = 1;
/**
 * Represents additive blending.
 *
 * @type {number}
 * @constant
 */ const AdditiveBlending = 2;
/**
 * Represents subtractive blending.
 *
 * @type {number}
 * @constant
 */ const SubtractiveBlending = 3;
/**
 * Represents multiply blending.
 *
 * @type {number}
 * @constant
 */ const MultiplyBlending = 4;
/**
 * Represents custom blending.
 *
 * @type {number}
 * @constant
 */ const CustomBlending = 5;
/**
 * A `source + destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const AddEquation = 100;
/**
 * A `source - destination` blending equation.
 *
 * @type {number}
 * @constant
 */ const SubtractEquation = 101;
/**
 * A `destination - source` blending equation.
 *
 * @type {number}
 * @constant
 */ const ReverseSubtractEquation = 102;
/**
 * A blend equation that uses the minimum of source and destination.
 *
 * @type {number}
 * @constant
 */ const MinEquation = 103;
/**
 * A blend equation that uses the maximum of source and destination.
 *
 * @type {number}
 * @constant
 */ const MaxEquation = 104;
/**
 * Multiplies all colors by `0`.
 *
 * @type {number}
 * @constant
 */ const ZeroFactor = 200;
/**
 * Multiplies all colors by `1`.
 *
 * @type {number}
 * @constant
 */ const OneFactor = 201;
/**
 * Multiplies all colors by the source colors.
 *
 * @type {number}
 * @constant
 */ const SrcColorFactor = 202;
/**
 * Multiplies all colors by `1` minus each source color.
 *
 * @type {number}
 * @constant
 */ const OneMinusSrcColorFactor = 203;
/**
 * Multiplies all colors by the source alpha value.
 *
 * @type {number}
 * @constant
 */ const SrcAlphaFactor = 204;
/**
 * Multiplies all colors by 1 minus the source alpha value.
 *
 * @type {number}
 * @constant
 */ const OneMinusSrcAlphaFactor = 205;
/**
 * Multiplies all colors by the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const DstAlphaFactor = 206;
/**
 * Multiplies all colors by `1` minus the destination alpha value.
 *
 * @type {number}
 * @constant
 */ const OneMinusDstAlphaFactor = 207;
/**
 * Multiplies all colors by the destination color.
 *
 * @type {number}
 * @constant
 */ const DstColorFactor = 208;
/**
 * Multiplies all colors by `1` minus each destination color.
 *
 * @type {number}
 * @constant
 */ const OneMinusDstColorFactor = 209;
/**
 * Multiplies the RGB colors by the smaller of either the source alpha
 * value or the value of `1` minus the destination alpha value. The alpha
 * value is multiplied by `1`.
 *
 * @type {number}
 * @constant
 */ const SrcAlphaSaturateFactor = 210;
/**
 * Multiplies all colors by a constant color.
 *
 * @type {number}
 * @constant
 */ const ConstantColorFactor = 211;
/**
 * Multiplies all colors by `1` minus a constant color.
 *
 * @type {number}
 * @constant
 */ const OneMinusConstantColorFactor = 212;
/**
 * Multiplies all colors by a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const ConstantAlphaFactor = 213;
/**
 * Multiplies all colors by 1 minus a constant alpha value.
 *
 * @type {number}
 * @constant
 */ const OneMinusConstantAlphaFactor = 214;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const NeverDepth = 0;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const AlwaysDepth = 1;
/**
 * Pass if the incoming value is less than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const LessDepth = 2;
/**
 * Pass if the incoming value is less than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const LessEqualDepth = 3;
/**
 * Pass if the incoming value equals the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const EqualDepth = 4;
/**
 * Pass if the incoming value is greater than or equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const GreaterEqualDepth = 5;
/**
 * Pass if the incoming value is greater than the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const GreaterDepth = 6;
/**
 * Pass if the incoming value is not equal to the depth buffer value.
 *
 * @type {number}
 * @constant
 */ const NotEqualDepth = 7;
/**
 * Multiplies the environment map color with the surface color.
 *
 * @type {number}
 * @constant
 */ const MultiplyOperation = 0;
/**
 * Uses reflectivity to blend between the two colors.
 *
 * @type {number}
 * @constant
 */ const MixOperation = 1;
/**
 * Adds the two colors.
 *
 * @type {number}
 * @constant
 */ const AddOperation = 2;
/**
 * No tone mapping is applied.
 *
 * @type {number}
 * @constant
 */ const NoToneMapping = 0;
/**
 * Linear tone mapping.
 *
 * @type {number}
 * @constant
 */ const LinearToneMapping = 1;
/**
 * Reinhard tone mapping.
 *
 * @type {number}
 * @constant
 */ const ReinhardToneMapping = 2;
/**
 * Cineon tone mapping.
 *
 * @type {number}
 * @constant
 */ const CineonToneMapping = 3;
/**
 * ACES Filmic tone mapping.
 *
 * @type {number}
 * @constant
 */ const ACESFilmicToneMapping = 4;
/**
 * Custom tone mapping.
 *
 * Expects a custom implementation by modifying shader code of the material's fragment shader.
 *
 * @type {number}
 * @constant
 */ const CustomToneMapping = 5;
/**
 * AgX tone mapping.
 *
 * @type {number}
 * @constant
 */ const AgXToneMapping = 6;
/**
 * Neutral tone mapping.
 *
 * Implementation based on the Khronos 3D Commerce Group standard tone mapping.
 *
 * @type {number}
 * @constant
 */ const NeutralToneMapping = 7;
/**
 * The skinned mesh shares the same world space as the skeleton.
 *
 * @type {string}
 * @constant
 */ const AttachedBindMode = 'attached';
/**
 * The skinned mesh does not share the same world space as the skeleton.
 * This is useful when a skeleton is shared across multiple skinned meshes.
 *
 * @type {string}
 * @constant
 */ const DetachedBindMode = 'detached';
/**
 * Maps textures using the geometry's UV coordinates.
 *
 * @type {number}
 * @constant
 */ const UVMapping = 300;
/**
 * Reflection mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const CubeReflectionMapping = 301;
/**
 * Refraction mapping for cube textures.
 *
 * @type {number}
 * @constant
 */ const CubeRefractionMapping = 302;
/**
 * Reflection mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const EquirectangularReflectionMapping = 303;
/**
 * Refraction mapping for equirectangular textures.
 *
 * @type {number}
 * @constant
 */ const EquirectangularRefractionMapping = 304;
/**
 * Reflection mapping for PMREM textures.
 *
 * @type {number}
 * @constant
 */ const CubeUVReflectionMapping = 306;
/**
 * The texture will simply repeat to infinity.
 *
 * @type {number}
 * @constant
 */ const RepeatWrapping = 1000;
/**
 * The last pixel of the texture stretches to the edge of the mesh.
 *
 * @type {number}
 * @constant
 */ const ClampToEdgeWrapping = 1001;
/**
 * The texture will repeats to infinity, mirroring on each repeat.
 *
 * @type {number}
 * @constant
 */ const MirroredRepeatWrapping = 1002;
/**
 * Returns the value of the texture element that is nearest (in Manhattan distance)
 * to the specified texture coordinates.
 *
 * @type {number}
 * @constant
 */ const NearestFilter = 1003;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured
 * and uses the `NearestFilter` criterion (the texel nearest to the center of the pixel)
 * to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const NearestMipmapNearestFilter = 1004;
const NearestMipMapNearestFilter = 1004; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and
 * uses the `NearestFilter` criterion to produce a texture value from each mipmap.
 * The final texture value is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const NearestMipmapLinearFilter = 1005;
const NearestMipMapLinearFilter = 1005; // legacy
/**
 * Returns the weighted average of the four texture elements that are closest to the specified
 * texture coordinates, and can include items wrapped or repeated from other parts of a texture,
 * depending on the values of `wrapS` and `wrapT`, and on the exact mapping.
 *
 * @type {number}
 * @constant
 */ const LinearFilter = 1006;
/**
 * Chooses the mipmap that most closely matches the size of the pixel being textured and uses
 * the `LinearFilter` criterion (a weighted average of the four texels that are closest to the
 * center of the pixel) to produce a texture value.
 *
 * @type {number}
 * @constant
 */ const LinearMipmapNearestFilter = 1007;
const LinearMipMapNearestFilter = 1007; // legacy
/**
 * Chooses the two mipmaps that most closely match the size of the pixel being textured and uses
 * the `LinearFilter` criterion to produce a texture value from each mipmap. The final texture value
 * is a weighted average of those two values.
 *
 * @type {number}
 * @constant
 */ const LinearMipmapLinearFilter = 1008;
const LinearMipMapLinearFilter = 1008; // legacy
/**
 * An unsigned byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const UnsignedByteType = 1009;
/**
 * A byte data type for textures.
 *
 * @type {number}
 * @constant
 */ const ByteType = 1010;
/**
 * A short data type for textures.
 *
 * @type {number}
 * @constant
 */ const ShortType = 1011;
/**
 * An unsigned short data type for textures.
 *
 * @type {number}
 * @constant
 */ const UnsignedShortType = 1012;
/**
 * An int data type for textures.
 *
 * @type {number}
 * @constant
 */ const IntType = 1013;
/**
 * An unsigned int data type for textures.
 *
 * @type {number}
 * @constant
 */ const UnsignedIntType = 1014;
/**
 * A float data type for textures.
 *
 * @type {number}
 * @constant
 */ const FloatType = 1015;
/**
 * A half float data type for textures.
 *
 * @type {number}
 * @constant
 */ const HalfFloatType = 1016;
/**
 * An unsigned short 4_4_4_4 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const UnsignedShort4444Type = 1017;
/**
 * An unsigned short 5_5_5_1 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const UnsignedShort5551Type = 1018;
/**
 * An unsigned int 24_8 data type for textures.
 *
 * @type {number}
 * @constant
 */ const UnsignedInt248Type = 1020;
/**
 * An unsigned int 5_9_9_9 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const UnsignedInt5999Type = 35902;
/**
 * An unsigned int 10_11_11 (packed) data type for textures.
 *
 * @type {number}
 * @constant
 */ const UnsignedInt101111Type = 35899;
/**
 * Discards the red, green and blue components and reads just the alpha component.
 *
 * @type {number}
 * @constant
 */ const AlphaFormat = 1021;
/**
 * Discards the alpha component and reads the red, green and blue component.
 *
 * @type {number}
 * @constant
 */ const RGBFormat = 1022;
/**
 * Reads the red, green, blue and alpha components.
 *
 * @type {number}
 * @constant
 */ const RGBAFormat = 1023;
/**
 * Reads each element as a single depth value, converts it to floating point, and clamps to the range `[0,1]`.
 *
 * @type {number}
 * @constant
 */ const DepthFormat = 1026;
/**
 * Reads each element is a pair of depth and stencil values. The depth component of the pair is interpreted as
 * in `DepthFormat`. The stencil component is interpreted based on the depth + stencil internal format.
 *
 * @type {number}
 * @constant
 */ const DepthStencilFormat = 1027;
/**
 * Discards the green, blue and alpha components and reads just the red component.
 *
 * @type {number}
 * @constant
 */ const RedFormat = 1028;
/**
 * Discards the green, blue and alpha components and reads just the red component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const RedIntegerFormat = 1029;
/**
 * Discards the alpha, and blue components and reads the red, and green components.
 *
 * @type {number}
 * @constant
 */ const RGFormat = 1030;
/**
 * Discards the alpha, and blue components and reads the red, and green components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const RGIntegerFormat = 1031;
/**
 * Discards the alpha component and reads the red, green and blue component. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const RGBIntegerFormat = 1032;
/**
 * Reads the red, green, blue and alpha components. The texels are read as integers instead of floating point.
 *
 * @type {number}
 * @constant
 */ const RGBAIntegerFormat = 1033;
/**
 * A DXT1-compressed image in an RGB image format.
 *
 * @type {number}
 * @constant
 */ const RGB_S3TC_DXT1_Format = 33776;
/**
 * A DXT1-compressed image in an RGB image format with a simple on/off alpha value.
 *
 * @type {number}
 * @constant
 */ const RGBA_S3TC_DXT1_Format = 33777;
/**
 * A DXT3-compressed image in an RGBA image format. Compared to a 32-bit RGBA texture, it offers 4:1 compression.
 *
 * @type {number}
 * @constant
 */ const RGBA_S3TC_DXT3_Format = 33778;
/**
 * A DXT5-compressed image in an RGBA image format. It also provides a 4:1 compression, but differs to the DXT3
 * compression in how the alpha compression is done.
 *
 * @type {number}
 * @constant
 */ const RGBA_S3TC_DXT5_Format = 33779;
/**
 * PVRTC RGB compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const RGB_PVRTC_4BPPV1_Format = 35840;
/**
 * PVRTC RGB compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const RGB_PVRTC_2BPPV1_Format = 35841;
/**
 * PVRTC RGBA compression in 4-bit mode. One block for each 4×4 pixels.
 *
 * @type {number}
 * @constant
 */ const RGBA_PVRTC_4BPPV1_Format = 35842;
/**
 * PVRTC RGBA compression in 2-bit mode. One block for each 8×4 pixels.
 *
 * @type {number}
 * @constant
 */ const RGBA_PVRTC_2BPPV1_Format = 35843;
/**
 * ETC1 RGB format.
 *
 * @type {number}
 * @constant
 */ const RGB_ETC1_Format = 36196;
/**
 * ETC2 RGB format.
 *
 * @type {number}
 * @constant
 */ const RGB_ETC2_Format = 37492;
/**
 * ETC2 RGBA format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ETC2_EAC_Format = 37496;
/**
 * EAC R11 UNORM format.
 *
 * @type {number}
 * @constant
 */ const R11_EAC_Format = 37488; // 0x9270
/**
 * EAC R11 SNORM format.
 *
 * @type {number}
 * @constant
 */ const SIGNED_R11_EAC_Format = 37489; // 0x9271
/**
 * EAC RG11 UNORM format.
 *
 * @type {number}
 * @constant
 */ const RG11_EAC_Format = 37490; // 0x9272
/**
 * EAC RG11 SNORM format.
 *
 * @type {number}
 * @constant
 */ const SIGNED_RG11_EAC_Format = 37491; // 0x9273
/**
 * ASTC RGBA 4x4 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_4x4_Format = 37808;
/**
 * ASTC RGBA 5x4 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_5x4_Format = 37809;
/**
 * ASTC RGBA 5x5 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_5x5_Format = 37810;
/**
 * ASTC RGBA 6x5 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_6x5_Format = 37811;
/**
 * ASTC RGBA 6x6 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_6x6_Format = 37812;
/**
 * ASTC RGBA 8x5 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_8x5_Format = 37813;
/**
 * ASTC RGBA 8x6 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_8x6_Format = 37814;
/**
 * ASTC RGBA 8x8 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_8x8_Format = 37815;
/**
 * ASTC RGBA 10x5 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_10x5_Format = 37816;
/**
 * ASTC RGBA 10x6 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_10x6_Format = 37817;
/**
 * ASTC RGBA 10x8 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_10x8_Format = 37818;
/**
 * ASTC RGBA 10x10 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_10x10_Format = 37819;
/**
 * ASTC RGBA 12x10 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_12x10_Format = 37820;
/**
 * ASTC RGBA 12x12 format.
 *
 * @type {number}
 * @constant
 */ const RGBA_ASTC_12x12_Format = 37821;
/**
 * BPTC RGBA format.
 *
 * @type {number}
 * @constant
 */ const RGBA_BPTC_Format = 36492;
/**
 * BPTC Signed RGB format.
 *
 * @type {number}
 * @constant
 */ const RGB_BPTC_SIGNED_Format = 36494;
/**
 * BPTC Unsigned RGB format.
 *
 * @type {number}
 * @constant
 */ const RGB_BPTC_UNSIGNED_Format = 36495;
/**
 * RGTC1 Red format.
 *
 * @type {number}
 * @constant
 */ const RED_RGTC1_Format = 36283;
/**
 * RGTC1 Signed Red format.
 *
 * @type {number}
 * @constant
 */ const SIGNED_RED_RGTC1_Format = 36284;
/**
 * RGTC2 Red Green format.
 *
 * @type {number}
 * @constant
 */ const RED_GREEN_RGTC2_Format = 36285;
/**
 * RGTC2 Signed Red Green format.
 *
 * @type {number}
 * @constant
 */ const SIGNED_RED_GREEN_RGTC2_Format = 36286;
/**
 * Animations are played once.
 *
 * @type {number}
 * @constant
 */ const LoopOnce = 2200;
/**
 * Animations are played with a chosen number of repetitions, each time jumping from
 * the end of the clip directly to its beginning.
 *
 * @type {number}
 * @constant
 */ const LoopRepeat = 2201;
/**
 * Animations are played with a chosen number of repetitions, alternately playing forward
 * and backward.
 *
 * @type {number}
 * @constant
 */ const LoopPingPong = 2202;
/**
 * Discrete interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const InterpolateDiscrete = 2300;
/**
 * Linear interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const InterpolateLinear = 2301;
/**
 * Smooth interpolation mode for keyframe tracks.
 *
 * @type {number}
 * @constant
 */ const InterpolateSmooth = 2302;
/**
 * Zero curvature ending for animations.
 *
 * @type {number}
 * @constant
 */ const ZeroCurvatureEnding = 2400;
/**
 * Zero slope ending for animations.
 *
 * @type {number}
 * @constant
 */ const ZeroSlopeEnding = 2401;
/**
 * Wrap around ending for animations.
 *
 * @type {number}
 * @constant
 */ const WrapAroundEnding = 2402;
/**
 * Default animation blend mode.
 *
 * @type {number}
 * @constant
 */ const NormalAnimationBlendMode = 2500;
/**
 * Additive animation blend mode. Can be used to layer motions on top of
 * each other to build complex performances from smaller re-usable assets.
 *
 * @type {number}
 * @constant
 */ const AdditiveAnimationBlendMode = 2501;
/**
 * For every three vertices draw a single triangle.
 *
 * @type {number}
 * @constant
 */ const TrianglesDrawMode = 0;
/**
 * For each vertex draw a triangle from the last three vertices.
 *
 * @type {number}
 * @constant
 */ const TriangleStripDrawMode = 1;
/**
 * For each vertex draw a triangle from the first vertex and the last two vertices.
 *
 * @type {number}
 * @constant
 */ const TriangleFanDrawMode = 2;
/**
 * The depth value is inverted (1.0 - z) for visualization purposes.
 *
 * @type {number}
 * @constant
 */ const BasicDepthPacking = 3200;
/**
 * The depth value is packed into 32 bit RGBA.
 *
 * @type {number}
 * @constant
 */ const RGBADepthPacking = 3201;
/**
 * The depth value is packed into 24 bit RGB.
 *
 * @type {number}
 * @constant
 */ const RGBDepthPacking = 3202;
/**
 * The depth value is packed into 16 bit RG.
 *
 * @type {number}
 * @constant
 */ const RGDepthPacking = 3203;
/**
 * Normal information is relative to the underlying surface.
 *
 * @type {number}
 * @constant
 */ const TangentSpaceNormalMap = 0;
/**
 * Normal information is relative to the object orientation.
 *
 * @type {number}
 * @constant
 */ const ObjectSpaceNormalMap = 1;
// Color space string identifiers, matching CSS Color Module Level 4 and WebGPU names where available.
/**
 * No color space.
 *
 * @type {string}
 * @constant
 */ const NoColorSpace = '';
/**
 * sRGB color space.
 *
 * @type {string}
 * @constant
 */ const SRGBColorSpace = 'srgb';
/**
 * sRGB-linear color space.
 *
 * @type {string}
 * @constant
 */ const LinearSRGBColorSpace = 'srgb-linear';
/**
 * Linear transfer function.
 *
 * @type {string}
 * @constant
 */ const LinearTransfer = 'linear';
/**
 * sRGB transfer function.
 *
 * @type {string}
 * @constant
 */ const SRGBTransfer = 'srgb';
/**
 * No normal map packing.
 *
 * @type {string}
 * @constant
 */ const NoNormalPacking = '';
/**
 * Normal RG packing.
 *
 * @type {string}
 * @constant
 */ const NormalRGPacking = 'rg';
/**
 * Normal GA packing.
 *
 * @type {string}
 * @constant
 */ const NormalGAPacking = 'ga';
/**
 * Sets the stencil buffer value to `0`.
 *
 * @type {number}
 * @constant
 */ const ZeroStencilOp = 0;
/**
 * Keeps the current value.
 *
 * @type {number}
 * @constant
 */ const KeepStencilOp = 7680;
/**
 * Sets the stencil buffer value to the specified reference value.
 *
 * @type {number}
 * @constant
 */ const ReplaceStencilOp = 7681;
/**
 * Increments the current stencil buffer value. Clamps to the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const IncrementStencilOp = 7682;
/**
 * Decrements the current stencil buffer value. Clamps to `0`.
 *
 * @type {number}
 * @constant
 */ const DecrementStencilOp = 7683;
/**
 * Increments the current stencil buffer value. Wraps stencil buffer value to zero when incrementing
 * the maximum representable unsigned value.
 *
 * @type {number}
 * @constant
 */ const IncrementWrapStencilOp = 34055;
/**
 * Decrements the current stencil buffer value. Wraps stencil buffer value to the maximum representable
 * unsigned value when decrementing a stencil buffer value of `0`.
 *
 * @type {number}
 * @constant
 */ const DecrementWrapStencilOp = 34056;
/**
 * Inverts the current stencil buffer value bitwise.
 *
 * @type {number}
 * @constant
 */ const InvertStencilOp = 5386;
/**
 * Will never return true.
 *
 * @type {number}
 * @constant
 */ const NeverStencilFunc = 512;
/**
 * Will return true if the stencil reference value is less than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const LessStencilFunc = 513;
/**
 * Will return true if the stencil reference value is equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const EqualStencilFunc = 514;
/**
 * Will return true if the stencil reference value is less than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const LessEqualStencilFunc = 515;
/**
 * Will return true if the stencil reference value is greater than the current stencil value.
 *
 * @type {number}
 * @constant
 */ const GreaterStencilFunc = 516;
/**
 * Will return true if the stencil reference value is not equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const NotEqualStencilFunc = 517;
/**
 * Will return true if the stencil reference value is greater than or equal to the current stencil value.
 *
 * @type {number}
 * @constant
 */ const GreaterEqualStencilFunc = 518;
/**
 * Will always return true.
 *
 * @type {number}
 * @constant
 */ const AlwaysStencilFunc = 519;
/**
 * Never pass.
 *
 * @type {number}
 * @constant
 */ const NeverCompare = 512;
/**
 * Pass if the incoming value is less than the texture value.
 *
 * @type {number}
 * @constant
 */ const LessCompare = 513;
/**
 * Pass if the incoming value equals the texture value.
 *
 * @type {number}
 * @constant
 */ const EqualCompare = 514;
/**
 * Pass if the incoming value is less than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const LessEqualCompare = 515;
/**
 * Pass if the incoming value is greater than the texture value.
 *
 * @type {number}
 * @constant
 */ const GreaterCompare = 516;
/**
 * Pass if the incoming value is not equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const NotEqualCompare = 517;
/**
 * Pass if the incoming value is greater than or equal to the texture value.
 *
 * @type {number}
 * @constant
 */ const GreaterEqualCompare = 518;
/**
 * Always pass.
 *
 * @type {number}
 * @constant
 */ const AlwaysCompare = 519;
/**
 * The contents are intended to be specified once by the application, and used many
 * times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const StaticDrawUsage = 35044;
/**
 * The contents are intended to be respecified repeatedly by the application, and
 * used many times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const DynamicDrawUsage = 35048;
/**
 * The contents are intended to be specified once by the application, and used at most
 * a few times as the source for drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const StreamDrawUsage = 35040;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const StaticReadUsage = 35045;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and queried
 * many times by the application.
 *
 * @type {number}
 * @constant
 */ const DynamicReadUsage = 35049;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and queried at most
 * a few times by the application
 *
 * @type {number}
 * @constant
 */ const StreamReadUsage = 35041;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used many times as
 * the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const StaticCopyUsage = 35046;
/**
 * The contents are intended to be respecified repeatedly by reading data from the 3D API, and used many times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const DynamicCopyUsage = 35050;
/**
 * The contents are intended to be specified once by reading data from the 3D API, and used at most a few times
 * as the source for WebGL drawing and image specification commands.
 *
 * @type {number}
 * @constant
 */ const StreamCopyUsage = 35042;
/**
 * GLSL 1 shader code.
 *
 * @type {string}
 * @constant
 */ const GLSL1 = '100';
/**
 * GLSL 3 shader code.
 *
 * @type {string}
 * @constant
 */ const GLSL3 = '300 es';
/**
 * WebGL coordinate system.
 *
 * @type {number}
 * @constant
 */ const WebGLCoordinateSystem = 2000;
/**
 * WebGPU coordinate system.
 *
 * @type {number}
 * @constant
 */ const WebGPUCoordinateSystem = 2001;
/**
 * Represents the different timestamp query types.
 *
 * @type {ConstantsTimestampQuery}
 * @constant
 */ const TimestampQuery = {
    COMPUTE: 'compute',
    RENDER: 'render'
};
/**
 * Represents mouse buttons and interaction types in context of controls.
 *
 * @type {ConstantsInterpolationSamplingType}
 * @constant
 */ const InterpolationSamplingType = {
    PERSPECTIVE: 'perspective',
    LINEAR: 'linear',
    FLAT: 'flat'
};
/**
 * Represents the different interpolation sampling modes.
 *
 * @type {ConstantsInterpolationSamplingMode}
 * @constant
 */ const InterpolationSamplingMode = {
    NORMAL: 'normal',
    CENTROID: 'centroid',
    SAMPLE: 'sample',
    FIRST: 'first',
    EITHER: 'either'
};
/**
 * This type represents mouse buttons and interaction types in context of controls.
 *
 * @typedef {Object} ConstantsMouse
 * @property {number} MIDDLE - The left mouse button.
 * @property {number} LEFT - The middle mouse button.
 * @property {number} RIGHT - The right mouse button.
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} DOLLY - A dolly interaction.
 * @property {number} PAN - A pan interaction.
 **/ /**
 * This type represents touch interaction types in context of controls.
 *
 * @typedef {Object} ConstantsTouch
 * @property {number} ROTATE - A rotate interaction.
 * @property {number} PAN - A pan interaction.
 * @property {number} DOLLY_PAN - The dolly-pan interaction.
 * @property {number} DOLLY_ROTATE - A dolly-rotate interaction.
 **/ /**
 * This type represents the different timestamp query types.
 *
 * @typedef {Object} ConstantsTimestampQuery
 * @property {string} COMPUTE - A `compute` timestamp query.
 * @property {string} RENDER - A `render` timestamp query.
 **/ /**
 * Represents the different interpolation sampling types.
 *
 * @typedef {Object} ConstantsInterpolationSamplingType
 * @property {string} PERSPECTIVE - Perspective-correct interpolation.
 * @property {string} LINEAR - Linear interpolation.
 * @property {string} FLAT - Flat interpolation.
 */ /**
 * Represents the different interpolation sampling modes.
 *
 * @typedef {Object} ConstantsInterpolationSamplingMode
 * @property {string} NORMAL - Normal sampling mode.
 * @property {string} CENTROID - Centroid sampling mode.
 * @property {string} SAMPLE - Sample-specific sampling mode.
 * @property {string} FIRST - Flat interpolation using the first vertex.
 * @property {string} EITHER - Flat interpolation using either vertex.
 */ function arrayNeedsUint32(array) {
    // assumes larger values usually on last
    for(let i = array.length - 1; i >= 0; --i){
        if (array[i] >= 65535) return true; // account for PRIMITIVE_RESTART_FIXED_INDEX, #24565
    }
    return false;
}
const TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    Uint8ClampedArray: Uint8ClampedArray,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function getTypedArray(type, buffer) {
    return new TYPED_ARRAYS[type](buffer);
}
/**
 * Returns `true` if the given object is a typed array.
 *
 * @param {any} array - The object to check.
 * @return {boolean} Whether the given object is a typed array.
 */ function isTypedArray(array) {
    return ArrayBuffer.isView(array) && !(array instanceof DataView);
}
function createElementNS(name) {
    return document.createElementNS('http://www.w3.org/1999/xhtml', name);
}
function createCanvasElement() {
    const canvas = createElementNS('canvas');
    canvas.style.display = 'block';
    return canvas;
}
const _cache = {};
let _setConsoleFunction = null;
function setConsoleFunction(fn) {
    _setConsoleFunction = fn;
}
function getConsoleFunction() {
    return _setConsoleFunction;
}
function log(...params) {
    const message = 'THREE.' + params.shift();
    if (_setConsoleFunction) _setConsoleFunction('log', message, ...params);
    else console.log(message, ...params);
}
function warn(...params) {
    const message = 'THREE.' + params.shift();
    if (_setConsoleFunction) _setConsoleFunction('warn', message, ...params);
    else console.warn(message, ...params);
}
function error(...params) {
    const message = 'THREE.' + params.shift();
    if (_setConsoleFunction) _setConsoleFunction('error', message, ...params);
    else console.error(message, ...params);
}
function warnOnce(...params) {
    const message = params.join(' ');
    if (message in _cache) return;
    _cache[message] = true;
    warn(...params);
}
function probeAsync(gl, sync, interval) {
    return new Promise(function(resolve, reject) {
        function probe() {
            switch(gl.clientWaitSync(sync, gl.SYNC_FLUSH_COMMANDS_BIT, 0)){
                case gl.WAIT_FAILED:
                    reject();
                    break;
                case gl.TIMEOUT_EXPIRED:
                    setTimeout(probe, interval);
                    break;
                default:
                    resolve();
            }
        }
        setTimeout(probe, interval);
    });
}
/**
 * This modules allows to dispatch event objects on custom JavaScript objects.
 *
 * Main repository: [eventdispatcher.js](https://github.com/mrdoob/eventdispatcher.js/)
 *
 * Code Example:
 * ```js
 * class Car extends EventDispatcher {
 * 	start() {
 *		this.dispatchEvent( { type: 'start', message: 'vroom vroom!' } );
 *	}
 *};
 *
 * // Using events with the custom object
 * const car = new Car();
 * car.addEventListener( 'start', function ( event ) {
 * 	alert( event.message );
 * } );
 *
 * car.start();
 * ```
 */ class EventDispatcher {
    /**
	 * Adds the given event listener to the given event type.
	 *
	 * @param {string} type - The type of event to listen to.
	 * @param {Function} listener - The function that gets called when the event is fired.
	 */ addEventListener(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    }
    /**
	 * Returns `true` if the given event listener has been added to the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to check.
	 * @return {boolean} Whether the given event listener has been added to the given event type.
	 */ hasEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return false;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    }
    /**
	 * Removes the given event listener from the given event type.
	 *
	 * @param {string} type - The type of event.
	 * @param {Function} listener - The listener to remove.
	 */ removeEventListener(type, listener) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    }
    /**
	 * Dispatches an event object.
	 *
	 * @param {Object} event - The event that gets fired.
	 */ dispatchEvent(event) {
        const listeners = this._listeners;
        if (listeners === undefined) return;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
            event.target = null;
        }
    }
}
const _lut = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
    '0a',
    '0b',
    '0c',
    '0d',
    '0e',
    '0f',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '19',
    '1a',
    '1b',
    '1c',
    '1d',
    '1e',
    '1f',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '2a',
    '2b',
    '2c',
    '2d',
    '2e',
    '2f',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '39',
    '3a',
    '3b',
    '3c',
    '3d',
    '3e',
    '3f',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '4a',
    '4b',
    '4c',
    '4d',
    '4e',
    '4f',
    '50',
    '51',
    '52',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '5a',
    '5b',
    '5c',
    '5d',
    '5e',
    '5f',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '66',
    '67',
    '68',
    '69',
    '6a',
    '6b',
    '6c',
    '6d',
    '6e',
    '6f',
    '70',
    '71',
    '72',
    '73',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '7a',
    '7b',
    '7c',
    '7d',
    '7e',
    '7f',
    '80',
    '81',
    '82',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '8a',
    '8b',
    '8c',
    '8d',
    '8e',
    '8f',
    '90',
    '91',
    '92',
    '93',
    '94',
    '95',
    '96',
    '97',
    '98',
    '99',
    '9a',
    '9b',
    '9c',
    '9d',
    '9e',
    '9f',
    'a0',
    'a1',
    'a2',
    'a3',
    'a4',
    'a5',
    'a6',
    'a7',
    'a8',
    'a9',
    'aa',
    'ab',
    'ac',
    'ad',
    'ae',
    'af',
    'b0',
    'b1',
    'b2',
    'b3',
    'b4',
    'b5',
    'b6',
    'b7',
    'b8',
    'b9',
    'ba',
    'bb',
    'bc',
    'bd',
    'be',
    'bf',
    'c0',
    'c1',
    'c2',
    'c3',
    'c4',
    'c5',
    'c6',
    'c7',
    'c8',
    'c9',
    'ca',
    'cb',
    'cc',
    'cd',
    'ce',
    'cf',
    'd0',
    'd1',
    'd2',
    'd3',
    'd4',
    'd5',
    'd6',
    'd7',
    'd8',
    'd9',
    'da',
    'db',
    'dc',
    'dd',
    'de',
    'df',
    'e0',
    'e1',
    'e2',
    'e3',
    'e4',
    'e5',
    'e6',
    'e7',
    'e8',
    'e9',
    'ea',
    'eb',
    'ec',
    'ed',
    'ee',
    'ef',
    'f0',
    'f1',
    'f2',
    'f3',
    'f4',
    'f5',
    'f6',
    'f7',
    'f8',
    'f9',
    'fa',
    'fb',
    'fc',
    'fd',
    'fe',
    'ff'
];
let _seed = 1234567;
const DEG2RAD = Math.PI / 180;
const RAD2DEG = 180 / Math.PI;
/**
 * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
 * (universally unique identifier).
 *
 * @return {string} The UUID.
 */ function generateUUID() {
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
    const d0 = Math.random() * 0xffffffff | 0;
    const d1 = Math.random() * 0xffffffff | 0;
    const d2 = Math.random() * 0xffffffff | 0;
    const d3 = Math.random() * 0xffffffff | 0;
    const uuid = _lut[d0 & 0xff] + _lut[d0 >> 8 & 0xff] + _lut[d0 >> 16 & 0xff] + _lut[d0 >> 24 & 0xff] + '-' + _lut[d1 & 0xff] + _lut[d1 >> 8 & 0xff] + '-' + _lut[d1 >> 16 & 0x0f | 0x40] + _lut[d1 >> 24 & 0xff] + '-' + _lut[d2 & 0x3f | 0x80] + _lut[d2 >> 8 & 0xff] + '-' + _lut[d2 >> 16 & 0xff] + _lut[d2 >> 24 & 0xff] + _lut[d3 & 0xff] + _lut[d3 >> 8 & 0xff] + _lut[d3 >> 16 & 0xff] + _lut[d3 >> 24 & 0xff];
    // .toLowerCase() here flattens concatenated strings to save heap memory space.
    return uuid.toLowerCase();
}
/**
 * Clamps the given value between min and max.
 *
 * @param {number} value - The value to clamp.
 * @param {number} min - The min value.
 * @param {number} max - The max value.
 * @return {number} The clamped value.
 */ function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * Computes the Euclidean modulo of the given parameters that
 * is `( ( n % m ) + m ) % m`.
 *
 * @param {number} n - The first parameter.
 * @param {number} m - The second parameter.
 * @return {number} The Euclidean modulo.
 */ function euclideanModulo(n, m) {
    // https://en.wikipedia.org/wiki/Modulo_operation
    return (n % m + m) % m;
}
/**
 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
 * for the given value.
 *
 * @param {number} x - The value to be mapped.
 * @param {number} a1 - Minimum value for range A.
 * @param {number} a2 - Maximum value for range A.
 * @param {number} b1 - Minimum value for range B.
 * @param {number} b2 - Maximum value for range B.
 * @return {number} The mapped value.
 */ function mapLinear(x, a1, a2, b1, b2) {
    return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
}
/**
 * Returns the percentage in the closed interval `[0, 1]` of the given value
 * between the start and end point.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} value - A value between start and end.
 * @return {number} The interpolation factor.
 */ function inverseLerp(x, y, value) {
    // https://www.gamedev.net/tutorials/programming/general-and-gameplay-programming/inverse-lerp-a-super-useful-yet-often-overlooked-function-r5230/
    if (x !== y) return (value - x) / (y - x);
    else return 0;
}
/**
 * Returns a value linearly interpolated from two known points based on the given interval -
 * `t = 0` will return `x` and `t = 1` will return `y`.
 *
 * @param {number} x - The start point
 * @param {number} y - The end point.
 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
 * @return {number} The interpolated value.
 */ function lerp(x, y, t) {
    return (1 - t) * x + t * y;
}
/**
 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
 * time to maintain frame rate independent movement. For details, see
 * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
 *
 * @param {number} x - The current point.
 * @param {number} y - The target point.
 * @param {number} lambda - A higher lambda value will make the movement more sudden,
 * and a lower value will make the movement more gradual.
 * @param {number} dt - Delta time in seconds.
 * @return {number} The interpolated value.
 */ function damp(x, y, lambda, dt) {
    return lerp(x, y, 1 - Math.exp(-lambda * dt));
}
/**
 * Returns a value that alternates between `0` and the given `length` parameter.
 *
 * @param {number} x - The value to pingpong.
 * @param {number} [length=1] - The positive value the function will pingpong to.
 * @return {number} The alternated value.
 */ function pingpong(x, length = 1) {
    // https://www.desmos.com/calculator/vcsjnyz7x4
    return length - Math.abs(euclideanModulo(x, length * 2) - length);
}
/**
 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
 * the `min` and `max`.
 *
 * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function smoothstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * (3 - 2 * x);
}
/**
 * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
 *
 * @param {number} x - The value to evaluate based on its position between min and max.
 * @param {number} min - The min value. Any x value below min will be `0`.
 * @param {number} max - The max value. Any x value above max will be `1`.
 * @return {number} The alternated value.
 */ function smootherstep(x, min, max) {
    if (x <= min) return 0;
    if (x >= max) return 1;
    x = (x - min) / (max - min);
    return x * x * x * (x * (x * 6 - 15) + 10);
}
/**
 * Returns a random integer from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random integer.
 */ function randInt(low, high) {
    return low + Math.floor(Math.random() * (high - low + 1));
}
/**
 * Returns a random float from `<low, high>` interval.
 *
 * @param {number} low - The lower value boundary.
 * @param {number} high - The upper value boundary
 * @return {number} A random float.
 */ function randFloat(low, high) {
    return low + Math.random() * (high - low);
}
/**
 * Returns a random integer from `<-range/2, range/2>` interval.
 *
 * @param {number} range - Defines the value range.
 * @return {number} A random float.
 */ function randFloatSpread(range) {
    return range * (0.5 - Math.random());
}
/**
 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
 *
 * @param {number} [s] - The integer seed.
 * @return {number} A random float.
 */ function seededRandom(s) {
    if (s !== undefined) _seed = s;
    // Mulberry32 generator
    let t = _seed += 0x6D2B79F5;
    t = Math.imul(t ^ t >>> 15, t | 1);
    t ^= t + Math.imul(t ^ t >>> 7, t | 61);
    return ((t ^ t >>> 14) >>> 0) / 4294967296;
}
/**
 * Converts degrees to radians.
 *
 * @param {number} degrees - A value in degrees.
 * @return {number} The converted value in radians.
 */ function degToRad(degrees) {
    return degrees * DEG2RAD;
}
/**
 * Converts radians to degrees.
 *
 * @param {number} radians - A value in radians.
 * @return {number} The converted value in degrees.
 */ function radToDeg(radians) {
    return radians * RAD2DEG;
}
/**
 * Returns `true` if the given number is a power of two.
 *
 * @param {number} value - The value to check.
 * @return {boolean} Whether the given number is a power of two or not.
 */ function isPowerOfTwo(value) {
    return (value & value - 1) === 0 && value !== 0;
}
/**
 * Returns the smallest power of two that is greater than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The smallest power of two that is greater than or equal to the given number.
 */ function ceilPowerOfTwo(value) {
    return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
}
/**
 * Returns the largest power of two that is less than or equal to the given number.
 *
 * @param {number} value - The value to find a POT for.
 * @return {number} The largest power of two that is less than or equal to the given number.
 */ function floorPowerOfTwo(value) {
    return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
}
/**
 * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
 * defined by the given angles and order.
 *
 * Rotations are applied to the axes in the order specified by order:
 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
 *
 * @param {Quaternion} q - The quaternion to set.
 * @param {number} a - The rotation applied to the first axis, in radians.
 * @param {number} b - The rotation applied to the second axis, in radians.
 * @param {number} c - The rotation applied to the third axis, in radians.
 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
 */ function setQuaternionFromProperEuler(q, a, b, c, order) {
    const cos = Math.cos;
    const sin = Math.sin;
    const c2 = cos(b / 2);
    const s2 = sin(b / 2);
    const c13 = cos((a + c) / 2);
    const s13 = sin((a + c) / 2);
    const c1_3 = cos((a - c) / 2);
    const s1_3 = sin((a - c) / 2);
    const c3_1 = cos((c - a) / 2);
    const s3_1 = sin((c - a) / 2);
    switch(order){
        case 'XYX':
            q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
            break;
        case 'YZY':
            q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
            break;
        case 'ZXZ':
            q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
            break;
        case 'XZX':
            q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
            break;
        case 'YXY':
            q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
            break;
        case 'ZYZ':
            q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
            break;
        default:
            warn('MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
    }
}
/**
 * Denormalizes the given value according to the given typed array.
 *
 * @param {number} value - The value to denormalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The denormalize (float) value in the range `[0,1]`.
 */ function denormalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return value / 4294967295.0;
        case Uint16Array:
            return value / 65535.0;
        case Uint8Array:
            return value / 255.0;
        case Int32Array:
            return Math.max(value / 2147483647.0, -1);
        case Int16Array:
            return Math.max(value / 32767.0, -1);
        case Int8Array:
            return Math.max(value / 127.0, -1);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * Normalizes the given value according to the given typed array.
 *
 * @param {number} value - The float value in the range `[0,1]` to normalize.
 * @param {TypedArray} array - The typed array that defines the data type of the value.
 * @return {number} The normalize value.
 */ function normalize(value, array) {
    switch(array.constructor){
        case Float32Array:
            return value;
        case Uint32Array:
            return Math.round(value * 4294967295.0);
        case Uint16Array:
            return Math.round(value * 65535.0);
        case Uint8Array:
            return Math.round(value * 255.0);
        case Int32Array:
            return Math.round(value * 2147483647.0);
        case Int16Array:
            return Math.round(value * 32767.0);
        case Int8Array:
            return Math.round(value * 127.0);
        default:
            throw new Error('Invalid component type.');
    }
}
/**
 * @class
 * @classdesc A collection of math utility functions.
 * @hideconstructor
 */ const MathUtils = {
    DEG2RAD: DEG2RAD,
    RAD2DEG: RAD2DEG,
    /**
	 * Generate a [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)
	 * (universally unique identifier).
	 *
	 * @static
	 * @method
	 * @return {string} The UUID.
	 */ generateUUID: generateUUID,
    /**
	 * Clamps the given value between min and max.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to clamp.
	 * @param {number} min - The min value.
	 * @param {number} max - The max value.
	 * @return {number} The clamped value.
	 */ clamp: clamp,
    /**
	 * Computes the Euclidean modulo of the given parameters that
	 * is `( ( n % m ) + m ) % m`.
	 *
	 * @static
	 * @method
	 * @param {number} n - The first parameter.
	 * @param {number} m - The second parameter.
	 * @return {number} The Euclidean modulo.
	 */ euclideanModulo: euclideanModulo,
    /**
	 * Performs a linear mapping from range `<a1, a2>` to range `<b1, b2>`
	 * for the given value.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to be mapped.
	 * @param {number} a1 - Minimum value for range A.
	 * @param {number} a2 - Maximum value for range A.
	 * @param {number} b1 - Minimum value for range B.
	 * @param {number} b2 - Maximum value for range B.
	 * @return {number} The mapped value.
	 */ mapLinear: mapLinear,
    /**
	 * Returns the percentage in the closed interval `[0, 1]` of the given value
	 * between the start and end point.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} value - A value between start and end.
	 * @return {number} The interpolation factor.
	 */ inverseLerp: inverseLerp,
    /**
	 * Returns a value linearly interpolated from two known points based on the given interval -
	 * `t = 0` will return `x` and `t = 1` will return `y`.
	 *
	 * @static
	 * @method
	 * @param {number} x - The start point
	 * @param {number} y - The end point.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {number} The interpolated value.
	 */ lerp: lerp,
    /**
	 * Smoothly interpolate a number from `x` to `y` in  a spring-like manner using a delta
	 * time to maintain frame rate independent movement. For details, see
	 * [Frame rate independent damping using lerp](http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/).
	 *
	 * @static
	 * @method
	 * @param {number} x - The current point.
	 * @param {number} y - The target point.
	 * @param {number} lambda - A higher lambda value will make the movement more sudden,
	 * and a lower value will make the movement more gradual.
	 * @param {number} dt - Delta time in seconds.
	 * @return {number} The interpolated value.
	 */ damp: damp,
    /**
	 * Returns a value that alternates between `0` and the given `length` parameter.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to pingpong.
	 * @param {number} [length=1] - The positive value the function will pingpong to.
	 * @return {number} The alternated value.
	 */ pingpong: pingpong,
    /**
	 * Returns a value in the range `[0,1]` that represents the percentage that `x` has
	 * moved between `min` and `max`, but smoothed or slowed down the closer `x` is to
	 * the `min` and `max`.
	 *
	 * See [Smoothstep](http://en.wikipedia.org/wiki/Smoothstep) for more details.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smoothstep: smoothstep,
    /**
	 * A [variation on smoothstep](https://en.wikipedia.org/wiki/Smoothstep#Variations)
	 * that has zero 1st and 2nd order derivatives at x=0 and x=1.
	 *
	 * @static
	 * @method
	 * @param {number} x - The value to evaluate based on its position between min and max.
	 * @param {number} min - The min value. Any x value below min will be `0`.
	 * @param {number} max - The max value. Any x value above max will be `1`.
	 * @return {number} The alternated value.
	 */ smootherstep: smootherstep,
    /**
	 * Returns a random integer from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random integer.
	 */ randInt: randInt,
    /**
	 * Returns a random float from `<low, high>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} low - The lower value boundary.
	 * @param {number} high - The upper value boundary
	 * @return {number} A random float.
	 */ randFloat: randFloat,
    /**
	 * Returns a random integer from `<-range/2, range/2>` interval.
	 *
	 * @static
	 * @method
	 * @param {number} range - Defines the value range.
	 * @return {number} A random float.
	 */ randFloatSpread: randFloatSpread,
    /**
	 * Returns a deterministic pseudo-random float in the interval `[0, 1]`.
	 *
	 * @static
	 * @method
	 * @param {number} [s] - The integer seed.
	 * @return {number} A random float.
	 */ seededRandom: seededRandom,
    /**
	 * Converts degrees to radians.
	 *
	 * @static
	 * @method
	 * @param {number} degrees - A value in degrees.
	 * @return {number} The converted value in radians.
	 */ degToRad: degToRad,
    /**
	 * Converts radians to degrees.
	 *
	 * @static
	 * @method
	 * @param {number} radians - A value in radians.
	 * @return {number} The converted value in degrees.
	 */ radToDeg: radToDeg,
    /**
	 * Returns `true` if the given number is a power of two.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to check.
	 * @return {boolean} Whether the given number is a power of two or not.
	 */ isPowerOfTwo: isPowerOfTwo,
    /**
	 * Returns the smallest power of two that is greater than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The smallest power of two that is greater than or equal to the given number.
	 */ ceilPowerOfTwo: ceilPowerOfTwo,
    /**
	 * Returns the largest power of two that is less than or equal to the given number.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to find a POT for.
	 * @return {number} The largest power of two that is less than or equal to the given number.
	 */ floorPowerOfTwo: floorPowerOfTwo,
    /**
	 * Sets the given quaternion from the [Intrinsic Proper Euler Angles](https://en.wikipedia.org/wiki/Euler_angles)
	 * defined by the given angles and order.
	 *
	 * Rotations are applied to the axes in the order specified by order:
	 * rotation by angle `a` is applied first, then by angle `b`, then by angle `c`.
	 *
	 * @static
	 * @method
	 * @param {Quaternion} q - The quaternion to set.
	 * @param {number} a - The rotation applied to the first axis, in radians.
	 * @param {number} b - The rotation applied to the second axis, in radians.
	 * @param {number} c - The rotation applied to the third axis, in radians.
	 * @param {('XYX'|'XZX'|'YXY'|'YZY'|'ZXZ'|'ZYZ')} order - A string specifying the axes order.
	 */ setQuaternionFromProperEuler: setQuaternionFromProperEuler,
    /**
	 * Normalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The float value in the range `[0,1]` to normalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The normalize value.
	 */ normalize: normalize,
    /**
	 * Denormalizes the given value according to the given typed array.
	 *
	 * @static
	 * @method
	 * @param {number} value - The value to denormalize.
	 * @param {TypedArray} array - The typed array that defines the data type of the value.
	 * @return {number} The denormalize (float) value in the range `[0,1]`.
	 */ denormalize: denormalize
};
/**
 * Class representing a 2D vector. A 2D vector is an ordered pair of numbers
 * (labeled x and y), which can be used to represent a number of things, such as:
 *
 * - A point in 2D space (i.e. a position on a plane).
 * - A direction and length across a plane. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0)` to `(x, y)`
 * and the direction is also measured from `(0, 0)` towards `(x, y)`.
 * - Any arbitrary ordered pair of numbers.
 *
 * There are other things a 2D vector can be used to represent, such as
 * momentum vectors, complex numbers and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector2( 0, 1 );
 *
 * //no arguments; will be initialised to (0, 0)
 * const b = new THREE.Vector2( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class Vector2 {
    /**
	 * Constructs a new 2D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 */ constructor(x = 0, y = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ Vector2.prototype.isVector2 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
    }
    /**
	 * Alias for {@link Vector2#x}.
	 *
	 * @type {number}
	 */ get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    /**
	 * Alias for {@link Vector2#y}.
	 *
	 * @type {number}
	 */ get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @return {Vector2} A reference to this vector.
	 */ set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector2} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @param {number} value - The value to set.
	 * @return {Vector2} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector2} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to copy.
	 * @return {Vector2} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to add.
	 * @return {Vector2} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector2} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector2} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector2} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector2} v - The vector to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector2} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector2} a - The first vector.
	 * @param {Vector2} b - The second vector.
	 * @return {Vector2} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector2} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector2} v - The vector to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector2} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Multiplies this vector (with an implicit 1 as the 3rd component) by
	 * the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {Vector2} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the given vector's x or y
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is less than the given vector's x or y
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector2} v - The vector.
	 * @return {Vector2} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    /**
	 * If this vector's x or y value is greater than the max vector's x or y
	 * value, it is replaced by the corresponding value.
	 * If this vector's x or y value is less than the min vector's x or y value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector2} min - The minimum x and y values.
	 * @param {Vector2} max - The maximum x and y values in the desired range.
	 * @return {Vector2} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = clamp(this.x, min.x, max.x);
        this.y = clamp(this.y, min.y, max.y);
        return this;
    }
    /**
	 * If this vector's x or y values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x or y values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = clamp(this.x, minVal, maxVal);
        this.y = clamp(this.y, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector2} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector2} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x and y = -y.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector2} v - The vector to compute the cross product with.
	 * @return {number} The result of the cross product.
	 */ cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0) to (x, y). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0) to (x, y).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Computes the angle in radians of this vector with respect to the positive x-axis.
	 *
	 * @return {number} The angle in radians.
	 */ angle() {
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector2} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos(clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector2} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector2} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector2} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector2} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector2} v1 - The first vector.
	 * @param {Vector2} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector2} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector2} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]` and y
	 * value to be `array[ offset + 1 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector2} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector2} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    /**
	 * Rotates this vector around the given center by the given angle.
	 *
	 * @param {Vector2} center - The point around which to rotate.
	 * @param {number} angle - The angle to rotate, in radians.
	 * @return {Vector2} A reference to this vector.
	 */ rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector2} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
    }
}
/**
 * Class for representing a Quaternion. Quaternions are used in three.js to represent rotations.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 *
 * Note that three.js expects Quaternions to be normalized.
 * ```js
 * const quaternion = new THREE.Quaternion();
 * quaternion.setFromAxisAngle( new THREE.Vector3( 0, 1, 0 ), Math.PI / 2 );
 *
 * const vector = new THREE.Vector3( 1, 0, 0 );
 * vector.applyQuaternion( quaternion );
 * ```
 */ class Quaternion {
    /**
	 * Constructs a new quaternion.
	 *
	 * @param {number} [x=0] - The x value of this quaternion.
	 * @param {number} [y=0] - The y value of this quaternion.
	 * @param {number} [z=0] - The z value of this quaternion.
	 * @param {number} [w=1] - The w value of this quaternion.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuaternion = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    /**
	 * Interpolates between two quaternions via SLERP. This implementation assumes the
	 * quaternion data are managed in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @param {number} t - The interpolation factor in the range `[0,1]`.
	 * @see {@link Quaternion#slerp}
	 */ static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        let x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (t <= 0) {
            dst[dstOffset + 0] = x0;
            dst[dstOffset + 1] = y0;
            dst[dstOffset + 2] = z0;
            dst[dstOffset + 3] = w0;
            return;
        }
        if (t >= 1) {
            dst[dstOffset + 0] = x1;
            dst[dstOffset + 1] = y1;
            dst[dstOffset + 2] = z1;
            dst[dstOffset + 3] = w1;
            return;
        }
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let dot = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1;
            if (dot < 0) {
                x1 = -x1;
                y1 = -y1;
                z1 = -z1;
                w1 = -w1;
                dot = -dot;
            }
            let s = 1 - t;
            if (dot < 0.9995) {
                // slerp
                const theta = Math.acos(dot);
                const sin = Math.sin(theta);
                s = Math.sin(s * theta) / sin;
                t = Math.sin(t * theta) / sin;
                x0 = x0 * s + x1 * t;
                y0 = y0 * s + y1 * t;
                z0 = z0 * s + z1 * t;
                w0 = w0 * s + w1 * t;
            } else {
                // for small angles, lerp then normalize
                x0 = x0 * s + x1 * t;
                y0 = y0 * s + y1 * t;
                z0 = z0 * s + z1 * t;
                w0 = w0 * s + w1 * t;
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    /**
	 * Multiplies two quaternions. This implementation assumes the quaternion data are managed
	 * in flat arrays.
	 *
	 * @param {Array<number>} dst - The destination array.
	 * @param {number} dstOffset - An offset into the destination array.
	 * @param {Array<number>} src0 - The source array of the first quaternion.
	 * @param {number} srcOffset0 - An offset into the first source array.
	 * @param {Array<number>} src1 -  The source array of the second quaternion.
	 * @param {number} srcOffset1 - An offset into the second source array.
	 * @return {Array<number>} The destination array.
	 * @see {@link Quaternion#multiplyQuaternions}.
	 */ static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    /**
	 * The x value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The y value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The z value of this quaternion.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * The w value of this quaternion.
	 *
	 * @type {number}
	 * @default 1
	 */ get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the quaternion components.
	 *
	 * @param {number} x - The x value of this quaternion.
	 * @param {number} y - The y value of this quaternion.
	 * @param {number} z - The z value of this quaternion.
	 * @param {number} w - The w value of this quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new quaternion with copied values from this instance.
	 *
	 * @return {Quaternion} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    /**
	 * Copies the values of the given quaternion to this instance.
	 *
	 * @param {Quaternion} quaternion - The quaternion to copy.
	 * @return {Quaternion} A reference to this quaternion.
	 */ copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the rotation specified by the given
	 * Euler angles.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromEuler(euler, update = true) {
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                warn('Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given axis and angle.
	 *
	 * @param {Vector3} axis - The normalized axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion from the given rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets this quaternion to the rotation required to rotate the direction vector
	 * `vFrom` to the direction vector `vTo`.
	 *
	 * @param {Vector3} vFrom - The first (normalized) direction vector.
	 * @param {Vector3} vTo - The second (normalized) direction vector.
	 * @return {Quaternion} A reference to this quaternion.
	 */ setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        let r = vFrom.dot(vTo) + 1;
        if (r < 1e-8) {
            // vFrom and vTo point in opposite directions
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    /**
	 * Returns the angle between this quaternion and the given one in radians.
	 *
	 * @param {Quaternion} q - The quaternion to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(q) {
        return 2 * Math.acos(Math.abs(clamp(this.dot(q), -1, 1)));
    }
    /**
	 * Rotates this quaternion by a given angular step to the given quaternion.
	 * The method ensures that the final quaternion will not overshoot `q`.
	 *
	 * @param {Quaternion} q - The target quaternion.
	 * @param {number} step - The angular step in radians.
	 * @return {Quaternion} A reference to this quaternion.
	 */ rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    /**
	 * Sets this quaternion to the identity quaternion; that is, to the
	 * quaternion that represents "no rotation".
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ identity() {
        return this.set(0, 0, 0, 1);
    }
    /**
	 * Inverts this quaternion via {@link Quaternion#conjugate}. The
	 * quaternion is assumed to have unit length.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ invert() {
        return this.conjugate();
    }
    /**
	 * Returns the rotational conjugate of this quaternion. The conjugate of a
	 * quaternion represents the same rotation in the opposite direction about
	 * the rotational axis.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Calculates the dot product of this quaternion and the given one.
	 *
	 * @param {Quaternion} v - The quaternion to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    /**
	 * Computes the squared Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector. This can be useful if you are comparing the
	 * lengths of two quaternions, as this is a slightly more efficient calculation than
	 * {@link Quaternion#length}.
	 *
	 * @return {number} The squared Euclidean length.
	 */ lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    /**
	 * Computes the Euclidean length (straight-line length) of this quaternion,
	 * considered as a 4 dimensional vector.
	 *
	 * @return {number} The Euclidean length.
	 */ length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    /**
	 * Normalizes this quaternion - that is, calculated the quaternion that performs
	 * the same rotation as this one, but has a length equal to `1`.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    /**
	 * Multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiply(q) {
        return this.multiplyQuaternions(this, q);
    }
    /**
	 * Pre-multiplies this quaternion by the given one.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    /**
	 * Multiplies the given quaternions and stores the result in this instance.
	 *
	 * @param {Quaternion} a - The first quaternion.
	 * @param {Quaternion} b - The second quaternion.
	 * @return {Quaternion} A reference to this quaternion.
	 */ multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between quaternions.
	 *
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerp(qb, t) {
        if (t <= 0) return this;
        if (t >= 1) return this.copy(qb); // copy calls _onChangeCallback()
        let x = qb._x, y = qb._y, z = qb._z, w = qb._w;
        let dot = this.dot(qb);
        if (dot < 0) {
            x = -x;
            y = -y;
            z = -z;
            w = -w;
            dot = -dot;
        }
        let s = 1 - t;
        if (dot < 0.9995) {
            // slerp
            const theta = Math.acos(dot);
            const sin = Math.sin(theta);
            s = Math.sin(s * theta) / sin;
            t = Math.sin(t * theta) / sin;
            this._x = this._x * s + x * t;
            this._y = this._y * s + y * t;
            this._z = this._z * s + z * t;
            this._w = this._w * s + w * t;
            this._onChangeCallback();
        } else {
            // for small angles, lerp then normalize
            this._x = this._x * s + x * t;
            this._y = this._y * s + y * t;
            this._z = this._z * s + z * t;
            this._w = this._w * s + w * t;
            this.normalize(); // normalize calls _onChangeCallback()
        }
        return this;
    }
    /**
	 * Performs a spherical linear interpolation between the given quaternions
	 * and stores the result in this quaternion.
	 *
	 * @param {Quaternion} qa - The source quaternion.
	 * @param {Quaternion} qb - The target quaternion.
	 * @param {number} t - The interpolation factor in the closed interval `[0, 1]`.
	 * @return {Quaternion} A reference to this quaternion.
	 */ slerpQuaternions(qa, qb, t) {
        return this.copy(qa).slerp(qb, t);
    }
    /**
	 * Sets this quaternion to a uniformly random, normalized quaternion.
	 *
	 * @return {Quaternion} A reference to this quaternion.
	 */ random() {
        // Ken Shoemake
        // Uniform random rotations
        // D. Kirk, editor, Graphics Gems III, pages 124-132. Academic Press, New York, 1992.
        const theta1 = 2 * Math.PI * Math.random();
        const theta2 = 2 * Math.PI * Math.random();
        const x0 = Math.random();
        const r1 = Math.sqrt(1 - x0);
        const r2 = Math.sqrt(x0);
        return this.set(r1 * Math.sin(theta1), r1 * Math.cos(theta1), r2 * Math.sin(theta2), r2 * Math.cos(theta2));
    }
    /**
	 * Returns `true` if this quaternion is equal with the given one.
	 *
	 * @param {Quaternion} quaternion - The quaternion to test for equality.
	 * @return {boolean} Whether this quaternion is equal with the given one.
	 */ equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    /**
	 * Sets this quaternion's components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the quaternion component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this quaternion to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the quaternion components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The quaternion components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    /**
	 * Sets the components of this quaternion from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding quaternion data.
	 * @param {number} index - The index into the attribute.
	 * @return {Quaternion} A reference to this quaternion.
	 */ fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        this._onChangeCallback();
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the
	 * numerical elements of this quaternion in an array of format `[x, y, z, w]`.
	 *
	 * @return {Array<number>} The serialized quaternion.
	 */ toJSON() {
        return this.toArray();
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._w;
    }
}
/**
 * Class representing a 3D vector. A 3D vector is an ordered triplet of numbers
 * (labeled x, y and z), which can be used to represent a number of things, such as:
 *
 * - A point in 3D space.
 * - A direction and length in 3D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0)` to `(x, y, z)`
 * and the direction is also measured from `(0, 0, 0)` towards `(x, y, z)`.
 * - Any arbitrary ordered triplet of numbers.
 *
 * There are other things a 3D vector can be used to represent, such as
 * momentum vectors and so on, however these are the most
 * common uses in three.js.
 *
 * Iterating through a vector instance will yield its components `(x, y, z)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector3( 0, 1, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0)
 * const b = new THREE.Vector3( );
 *
 * const d = a.distanceTo( b );
 * ```
 */ class Vector3 {
    /**
	 * Constructs a new 3D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 */ constructor(x = 0, y = 0, z = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ Vector3.prototype.isVector3 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @return {Vector3} A reference to this vector.
	 */ set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector3} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @param {number} value - The value to set.
	 * @return {Vector3} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y, `2` equals to z.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector3} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to copy.
	 * @return {Vector3} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to add.
	 * @return {Vector3} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector3} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector3} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector3} v - The vector to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector3} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    /**
	 * Multiplies the given vectors and stores the result in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    /**
	 * Applies the given Euler rotation to this vector.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Vector3} A reference to this vector.
	 */ applyEuler(euler) {
        return this.applyQuaternion(_quaternion$4.setFromEuler(euler));
    }
    /**
	 * Applies a rotation specified by an axis and an angle to this vector.
	 *
	 * @param {Vector3} axis - A normalized vector representing the rotation axis.
	 * @param {number} angle - The angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ applyAxisAngle(axis, angle) {
        return this.applyQuaternion(_quaternion$4.setFromAxisAngle(axis, angle));
    }
    /**
	 * Multiplies this vector with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    /**
	 * Multiplies this vector by the given normal matrix and normalizes
	 * the result.
	 *
	 * @param {Matrix3} m - The normal matrix.
	 * @return {Vector3} A reference to this vector.
	 */ applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    /**
	 * Multiplies this vector (with an implicit 1 in the 4th dimension) by m, and
	 * divides by perspective.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {Vector3} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    /**
	 * Applies the given Quaternion to this vector.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Vector3} A reference to this vector.
	 */ applyQuaternion(q) {
        // quaternion q is assumed to have unit length
        const vx = this.x, vy = this.y, vz = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // t = 2 * cross( q.xyz, v );
        const tx = 2 * (qy * vz - qz * vy);
        const ty = 2 * (qz * vx - qx * vz);
        const tz = 2 * (qx * vy - qy * vx);
        // v + q.w * t + cross( q.xyz, t );
        this.x = vx + qw * tx + qy * tz - qz * ty;
        this.y = vy + qw * ty + qz * tx - qx * tz;
        this.z = vz + qw * tz + qx * ty - qy * tx;
        return this;
    }
    /**
	 * Projects this vector from world space into the camera's normalized
	 * device coordinate (NDC) space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    /**
	 * Unprojects this vector from the camera's normalized device coordinate (NDC)
	 * space into world space.
	 *
	 * @param {Camera} camera - The camera.
	 * @return {Vector3} A reference to this vector.
	 */ unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    /**
	 * Transforms the direction of this vector by a matrix (the upper left 3 x 3
	 * subset of the given 4x4 matrix and then normalizes the result.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Vector3} A reference to this vector.
	 */ transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector3} v - The vector to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector3} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * If this vector's x, y or z value is greater than the given vector's x, y or z
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is less than the given vector's x, y or z
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector3} v - The vector.
	 * @return {Vector3} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    /**
	 * If this vector's x, y or z value is greater than the max vector's x, y or z
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y or z value is less than the min vector's x, y or z value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector3} min - The minimum x, y and z values.
	 * @param {Vector3} max - The maximum x, y and z values in the desired range.
	 * @return {Vector3} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = clamp(this.x, min.x, max.x);
        this.y = clamp(this.y, min.y, max.y);
        this.z = clamp(this.z, min.z, max.z);
        return this;
    }
    /**
	 * If this vector's x, y or z values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y or z values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = clamp(this.x, minVal, maxVal);
        this.y = clamp(this.y, minVal, maxVal);
        this.z = clamp(this.z, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector3} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector3} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y and z = -z.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0) to (x, y, z). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0) to (x, y, z).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector3} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector3} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector3} v1 - The first vector.
	 * @param {Vector3} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector3} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    /**
	 * Calculates the cross product of the given vector with this instance.
	 *
	 * @param {Vector3} v - The vector to compute the cross product with.
	 * @return {Vector3} The result of the cross product.
	 */ cross(v) {
        return this.crossVectors(this, v);
    }
    /**
	 * Calculates the cross product of the given vectors and stores the result
	 * in this instance.
	 *
	 * @param {Vector3} a - The first vector.
	 * @param {Vector3} b - The second vector.
	 * @return {Vector3} A reference to this vector.
	 */ crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    /**
	 * Projects this vector onto the given one.
	 *
	 * @param {Vector3} v - The vector to project to.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    /**
	 * Projects this vector onto a plane by subtracting this
	 * vector projected onto the plane's normal from this vector.
	 *
	 * @param {Vector3} planeNormal - The plane normal.
	 * @return {Vector3} A reference to this vector.
	 */ projectOnPlane(planeNormal) {
        _vector$c.copy(this).projectOnVector(planeNormal);
        return this.sub(_vector$c);
    }
    /**
	 * Reflects this vector off a plane orthogonal to the given normal vector.
	 *
	 * @param {Vector3} normal - The (normalized) normal vector.
	 * @return {Vector3} A reference to this vector.
	 */ reflect(normal) {
        return this.sub(_vector$c.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    /**
	 * Returns the angle between the given vector and this instance in radians.
	 *
	 * @param {Vector3} v - The vector to compute the angle with.
	 * @return {number} The angle in radians.
	 */ angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos(clamp(theta, -1, 1));
    }
    /**
	 * Computes the distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the distance to.
	 * @return {number} The distance.
	 */ distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    /**
	 * Computes the squared distance from the given vector to this instance.
	 * If you are just comparing the distance with another distance, you should compare
	 * the distance squared instead as it is slightly more efficient to calculate.
	 *
	 * @param {Vector3} v - The vector to compute the squared distance to.
	 * @return {number} The squared distance.
	 */ distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    /**
	 * Computes the Manhattan distance from the given vector to this instance.
	 *
	 * @param {Vector3} v - The vector to compute the Manhattan distance to.
	 * @return {number} The Manhattan distance.
	 */ manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {Spherical} s - The spherical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    /**
	 * Sets the vector components from the given spherical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The phi angle in radians.
	 * @param {number} theta - The theta angle in radians.
	 * @return {Vector3} A reference to this vector.
	 */ setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {Cylindrical} c - The cylindrical coordinates.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    /**
	 * Sets the vector components from the given cylindrical coordinates.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle in radians.
	 * @param {number} y - The y value.
	 * @return {Vector3} A reference to this vector.
	 */ setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    /**
	 * Sets the vector components to the scale elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    /**
	 * Sets the vector components from the specified matrix column.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @param {number} index - The column index.
	 * @return {Vector3} A reference to this vector.
	 */ setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    /**
	 * Sets the vector components from the given Euler angles.
	 *
	 * @param {Euler} e - The Euler angles to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromEuler(e) {
        this.x = e._x;
        this.y = e._y;
        this.z = e._z;
        return this;
    }
    /**
	 * Sets the vector components from the RGB components of the
	 * given color.
	 *
	 * @param {Color} c - The color to set.
	 * @return {Vector3} A reference to this vector.
	 */ setFromColor(c) {
        this.x = c.r;
        this.y = c.g;
        this.z = c.b;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector3} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`
	 * and z value to be `array[ offset + 2 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector3} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector3} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
    /**
	 * Sets this vector to a uniformly random point on a unit sphere.
	 *
	 * @return {Vector3} A reference to this vector.
	 */ randomDirection() {
        // https://mathworld.wolfram.com/SpherePointPicking.html
        const theta = Math.random() * Math.PI * 2;
        const u = Math.random() * 2 - 1;
        const c = Math.sqrt(1 - u * u);
        this.x = c * Math.cos(theta);
        this.y = u;
        this.z = c * Math.sin(theta);
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
    }
}
const _vector$c = /*@__PURE__*/ new Vector3();
const _quaternion$4 = /*@__PURE__*/ new Quaternion();
/**
 * Represents a 3x3 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix();
 * m.set( 11, 12, 13,
 *        21, 22, 23,
 *        31, 32, 33 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31,
 *                12, 22, 32,
 *                13, 23, 33 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class Matrix3 {
    /**
	 * Constructs a new 3x3 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 */ constructor(n11, n12, n13, n21, n22, n23, n31, n32, n33){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ Matrix3.prototype.isMatrix3 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n21, n22, n23, n31, n32, n33);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @return {Matrix3} A reference to this matrix.
	 */ set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    /**
	 * Sets this matrix to the 3x3 identity matrix.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix3} m - The matrix to copy.
	 * @return {Matrix3} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    /**
	 * Set this matrix to the upper 3x3 matrix of the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix to multiply with.
	 * @return {Matrix3} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 3x3 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix3} a - The first matrix.
	 * @param {Matrix3} b - The second matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix3} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    /**
	 * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix3} A reference to this matrix.
	 */ transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    /**
	 * Computes the normal matrix which is the inverse transpose of the upper
	 * left 3x3 portion of the given 4x4 matrix.
	 *
	 * @param {Matrix4} matrix4 - The 4x4 matrix.
	 * @return {Matrix3} A reference to this matrix.
	 */ getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).invert().transpose();
    }
    /**
	 * Transposes this matrix into the supplied array, and returns itself unchanged.
	 *
	 * @param {Array<number>} r - An array to store the transposed matrix elements.
	 * @return {Matrix3} A reference to this matrix.
	 */ transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    /**
	 * Sets the UV transform matrix from offset, repeat, rotation, and center.
	 *
	 * @param {number} tx - Offset x.
	 * @param {number} ty - Offset y.
	 * @param {number} sx - Repeat x.
	 * @param {number} sy - Repeat y.
	 * @param {number} rotation - Rotation, in radians. Positive values rotate counterclockwise.
	 * @param {number} cx - Center x of rotation.
	 * @param {number} cy - Center y of rotation
	 * @return {Matrix3} A reference to this matrix.
	 */ setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    /**
	 * Scales this matrix with the given scalar values.
	 *
	 * @param {number} sx - The amount to scale in the X axis.
	 * @param {number} sy - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ scale(sx, sy) {
        this.premultiply(_m3.makeScale(sx, sy));
        return this;
    }
    /**
	 * Rotates this matrix by the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ rotate(theta) {
        this.premultiply(_m3.makeRotation(-theta));
        return this;
    }
    /**
	 * Translates this matrix by the given scalar values.
	 *
	 * @param {number} tx - The amount to translate in the X axis.
	 * @param {number} ty - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ translate(tx, ty) {
        this.premultiply(_m3.makeTranslation(tx, ty));
        return this;
    }
    // for 2D Transforms
    /**
	 * Sets this matrix as a 2D translation transform.
	 *
	 * @param {number|Vector2} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeTranslation(x, y) {
        if (x.isVector2) this.set(1, 0, x.x, 0, 1, x.y, 0, 0, 1);
        else this.set(1, 0, x, 0, 1, y, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D rotational transformation.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeRotation(theta) {
        // counterclockwise
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        this.set(c, -s, 0, s, c, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a 2D scale transform.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @return {Matrix3} A reference to this matrix.
	 */ makeScale(x, y) {
        this.set(x, 0, 0, 0, y, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix3} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix3} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix3} A clone of this instance.
	 */ clone() {
        return new this.constructor().fromArray(this.elements);
    }
}
const _m3 = /*@__PURE__*/ new Matrix3();
const LINEAR_REC709_TO_XYZ = /*@__PURE__*/ new Matrix3().set(0.4123908, 0.3575843, 0.1804808, 0.2126390, 0.7151687, 0.0721923, 0.0193308, 0.1191948, 0.9505322);
const XYZ_TO_LINEAR_REC709 = /*@__PURE__*/ new Matrix3().set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, 0.0415551, 0.0556301, -0.203977, 1.0569715);
function createColorManagement() {
    const ColorManagement = {
        enabled: true,
        workingColorSpace: LinearSRGBColorSpace,
        /**
		 * Implementations of supported color spaces.
		 *
		 * Required:
		 *	- primaries: chromaticity coordinates [ rx ry gx gy bx by ]
		 *	- whitePoint: reference white [ x y ]
		 *	- transfer: transfer function (pre-defined)
		 *	- toXYZ: Matrix3 RGB to XYZ transform
		 *	- fromXYZ: Matrix3 XYZ to RGB transform
		 *	- luminanceCoefficients: RGB luminance coefficients
		 *
		 * Optional:
		 *  - outputColorSpaceConfig: { drawingBufferColorSpace: ColorSpace, toneMappingMode: 'extended' | 'standard' }
		 *  - workingColorSpaceConfig: { unpackColorSpace: ColorSpace }
		 *
		 * Reference:
		 * - https://www.russellcottrell.com/photo/matrixCalculator.htm
		 */ spaces: {},
        convert: function(color, sourceColorSpace, targetColorSpace) {
            if (this.enabled === false || sourceColorSpace === targetColorSpace || !sourceColorSpace || !targetColorSpace) return color;
            if (this.spaces[sourceColorSpace].transfer === SRGBTransfer) {
                color.r = SRGBToLinear(color.r);
                color.g = SRGBToLinear(color.g);
                color.b = SRGBToLinear(color.b);
            }
            if (this.spaces[sourceColorSpace].primaries !== this.spaces[targetColorSpace].primaries) {
                color.applyMatrix3(this.spaces[sourceColorSpace].toXYZ);
                color.applyMatrix3(this.spaces[targetColorSpace].fromXYZ);
            }
            if (this.spaces[targetColorSpace].transfer === SRGBTransfer) {
                color.r = LinearToSRGB(color.r);
                color.g = LinearToSRGB(color.g);
                color.b = LinearToSRGB(color.b);
            }
            return color;
        },
        workingToColorSpace: function(color, targetColorSpace) {
            return this.convert(color, this.workingColorSpace, targetColorSpace);
        },
        colorSpaceToWorking: function(color, sourceColorSpace) {
            return this.convert(color, sourceColorSpace, this.workingColorSpace);
        },
        getPrimaries: function(colorSpace) {
            return this.spaces[colorSpace].primaries;
        },
        getTransfer: function(colorSpace) {
            if (colorSpace === NoColorSpace) return LinearTransfer;
            return this.spaces[colorSpace].transfer;
        },
        getToneMappingMode: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.toneMappingMode || 'standard';
        },
        getLuminanceCoefficients: function(target, colorSpace = this.workingColorSpace) {
            return target.fromArray(this.spaces[colorSpace].luminanceCoefficients);
        },
        define: function(colorSpaces) {
            Object.assign(this.spaces, colorSpaces);
        },
        // Internal APIs
        _getMatrix: function(targetMatrix, sourceColorSpace, targetColorSpace) {
            return targetMatrix.copy(this.spaces[sourceColorSpace].toXYZ).multiply(this.spaces[targetColorSpace].fromXYZ);
        },
        _getDrawingBufferColorSpace: function(colorSpace) {
            return this.spaces[colorSpace].outputColorSpaceConfig.drawingBufferColorSpace;
        },
        _getUnpackColorSpace: function(colorSpace = this.workingColorSpace) {
            return this.spaces[colorSpace].workingColorSpaceConfig.unpackColorSpace;
        },
        // Deprecated
        fromWorkingColorSpace: function(color, targetColorSpace) {
            warnOnce('ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace().'); // @deprecated, r177
            return ColorManagement.workingToColorSpace(color, targetColorSpace);
        },
        toWorkingColorSpace: function(color, sourceColorSpace) {
            warnOnce('ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking().'); // @deprecated, r177
            return ColorManagement.colorSpaceToWorking(color, sourceColorSpace);
        }
    };
    /******************************************************************************
	 * sRGB definitions
	 */ const REC709_PRIMARIES = [
        0.640,
        0.330,
        0.300,
        0.600,
        0.150,
        0.060
    ];
    const REC709_LUMINANCE_COEFFICIENTS = [
        0.2126,
        0.7152,
        0.0722
    ];
    const D65 = [
        0.3127,
        0.3290
    ];
    ColorManagement.define({
        [LinearSRGBColorSpace]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: LinearTransfer,
            toXYZ: LINEAR_REC709_TO_XYZ,
            fromXYZ: XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            workingColorSpaceConfig: {
                unpackColorSpace: SRGBColorSpace
            },
            outputColorSpaceConfig: {
                drawingBufferColorSpace: SRGBColorSpace
            }
        },
        [SRGBColorSpace]: {
            primaries: REC709_PRIMARIES,
            whitePoint: D65,
            transfer: SRGBTransfer,
            toXYZ: LINEAR_REC709_TO_XYZ,
            fromXYZ: XYZ_TO_LINEAR_REC709,
            luminanceCoefficients: REC709_LUMINANCE_COEFFICIENTS,
            outputColorSpaceConfig: {
                drawingBufferColorSpace: SRGBColorSpace
            }
        }
    });
    return ColorManagement;
}
const ColorManagement = /*@__PURE__*/ createColorManagement();
function SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
let _canvas;
/**
 * A class containing utility functions for images.
 *
 * @hideconstructor
 */ class ImageUtils {
    /**
	 * Returns a data URI containing a representation of the given image.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement)} image - The image object.
	 * @param {string} [type='image/png'] - Indicates the image format.
	 * @return {string} The data URI.
	 */ static getDataURL(image, type = 'image/png') {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement === 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if (_canvas === undefined) _canvas = createElementNS('canvas');
            _canvas.width = image.width;
            _canvas.height = image.height;
            const context = _canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = _canvas;
        }
        return canvas.toDataURL(type);
    }
    /**
	 * Converts the given sRGB image data to linear color space.
	 *
	 * @param {(HTMLImageElement|HTMLCanvasElement|ImageBitmap|Object)} image - The image object.
	 * @return {HTMLCanvasElement|Object} The converted image.
	 */ static sRGBToLinear(image) {
        if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
            const canvas = createElementNS('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            const context = canvas.getContext('2d');
            context.drawImage(image, 0, 0, image.width, image.height);
            const imageData = context.getImageData(0, 0, image.width, image.height);
            const data = imageData.data;
            for(let i = 0; i < data.length; i++)data[i] = SRGBToLinear(data[i] / 255) * 255;
            context.putImageData(imageData, 0, 0);
            return canvas;
        } else if (image.data) {
            const data = image.data.slice(0);
            for(let i = 0; i < data.length; i++)if (data instanceof Uint8Array || data instanceof Uint8ClampedArray) data[i] = Math.floor(SRGBToLinear(data[i] / 255) * 255);
            else // assuming float
            data[i] = SRGBToLinear(data[i]);
            return {
                data: data,
                width: image.width,
                height: image.height
            };
        } else {
            warn('ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied.');
            return image;
        }
    }
}
let _sourceId = 0;
/**
 * Represents the data source of a texture.
 *
 * The main purpose of this class is to decouple the data definition from the texture
 * definition so the same data can be used with multiple texture instances.
 */ class Source {
    /**
	 * Constructs a new video texture.
	 *
	 * @param {any} [data=null] - The data definition of a texture.
	 */ constructor(data = null){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSource = true;
        /**
		 * The ID of the source.
		 *
		 * @name Source#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: _sourceId++
        });
        /**
		 * The UUID of the source.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = generateUUID();
        /**
		 * The data definition of a texture.
		 *
		 * @type {any}
		 */ this.data = data;
        /**
		 * This property is only relevant when {@link Source#needsUpdate} is set to `true` and
		 * provides more control on how texture data should be processed. When `dataReady` is set
		 * to `false`, the engine performs the memory allocation (if necessary) but does not transfer
		 * the data into the GPU memory.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.dataReady = true;
        /**
		 * This starts at `0` and counts how many times {@link Source#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
    }
    /**
	 * Returns the dimensions of the source into the given target vector.
	 *
	 * @param {(Vector2|Vector3)} target - The target object the result is written into.
	 * @return {(Vector2|Vector3)} The dimensions of the source.
	 */ getSize(target) {
        const data = this.data;
        if (typeof HTMLVideoElement !== 'undefined' && data instanceof HTMLVideoElement) target.set(data.videoWidth, data.videoHeight, 0);
        else if (typeof VideoFrame !== 'undefined' && data instanceof VideoFrame) target.set(data.displayHeight, data.displayWidth, 0);
        else if (data !== null) target.set(data.width, data.height, data.depth || 0);
        else target.set(0, 0, 0);
        return target;
    }
    /**
	 * When the property is set to `true`, the engine allocates the memory
	 * for the texture (if necessary) and triggers the actual texture upload
	 * to the GPU next time the source is used.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Serializes the source into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized source.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.images[this.uuid] !== undefined) return meta.images[this.uuid];
        const output = {
            uuid: this.uuid,
            url: ''
        };
        const data = this.data;
        if (data !== null) {
            let url;
            if (Array.isArray(data)) {
                // cube texture
                url = [];
                for(let i = 0, l = data.length; i < l; i++)if (data[i].isDataTexture) url.push(serializeImage(data[i].image));
                else url.push(serializeImage(data[i]));
            } else // texture
            url = serializeImage(data);
            output.url = url;
        }
        if (!isRootObject) meta.images[this.uuid] = output;
        return output;
    }
}
function serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return ImageUtils.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.from(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            warn('Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
let _textureId = 0;
const _tempVec3 = /*@__PURE__*/ new Vector3();
/**
 * Base class for all textures.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments EventDispatcher
 */ class Texture extends EventDispatcher {
    /**
	 * Constructs a new texture.
	 *
	 * @param {?Object} [image=Texture.DEFAULT_IMAGE] - The image holding the texture data.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(image = Texture.DEFAULT_IMAGE, mapping = Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = Texture.DEFAULT_ANISOTROPY, colorSpace = NoColorSpace){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isTexture = true;
        /**
		 * The ID of the texture.
		 *
		 * @name Texture#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: _textureId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The data definition of a texture. A reference to the data source can be
		 * shared across textures. This is often useful in context of spritesheets
		 * where multiple textures render the same data but with different texture
		 * transformations.
		 *
		 * @type {Source}
		 */ this.source = new Source(image);
        /**
		 * An array holding user-defined mipmaps.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = [];
        /**
		 * How the texture is applied to the object. The value `UVMapping`
		 * is the default, where texture or uv coordinates are used to apply the map.
		 *
		 * @type {(UVMapping|CubeReflectionMapping|CubeRefractionMapping|EquirectangularReflectionMapping|EquirectangularRefractionMapping|CubeUVReflectionMapping)}
		 * @default UVMapping
		*/ this.mapping = mapping;
        /**
		 * Lets you select the uv attribute to map the texture to. `0` for `uv`,
		 * `1` for `uv1`, `2` for `uv2` and `3` for `uv3`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.channel = 0;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *U* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapS = wrapS;
        /**
		 * This defines how the texture is wrapped horizontally and corresponds to
		 * *V* in UV mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapT = wrapT;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearFilter
		 */ this.magFilter = magFilter;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default LinearMipmapLinearFilter
		 */ this.minFilter = minFilter;
        /**
		 * The number of samples taken along the axis through the pixel that has the
		 * highest density of texels. By default, this value is `1`. A higher value
		 * gives a less blurry result than a basic mipmap, at the cost of more
		 * texture samples being used.
		 *
		 * @type {number}
		 * @default Texture.DEFAULT_ANISOTROPY
		 */ this.anisotropy = anisotropy;
        /**
		 * The format of the texture.
		 *
		 * @type {number}
		 * @default RGBAFormat
		 */ this.format = format;
        /**
		 * The default internal format is derived from {@link Texture#format} and {@link Texture#type} and
		 * defines how the texture data is going to be stored on the GPU.
		 *
		 * This property allows to overwrite the default format.
		 *
		 * @type {?string}
		 * @default null
		 */ this.internalFormat = null;
        /**
		 * The data type of the texture.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.type = type;
        /**
		 * How much a single repetition of the texture is offset from the beginning,
		 * in each direction U and V. Typical range is `0.0` to `1.0`.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.offset = new Vector2(0, 0);
        /**
		 * How many times the texture is repeated across the surface, in each
		 * direction U and V. If repeat is set greater than `1` in either direction,
		 * the corresponding wrap parameter should also be set to `RepeatWrapping`
		 * or `MirroredRepeatWrapping` to achieve the desired tiling effect.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.repeat = new Vector2(1, 1);
        /**
		 * The point around which rotation occurs. A value of `(0.5, 0.5)` corresponds
		 * to the center of the texture. Default is `(0, 0)`, the lower left.
		 *
		 * @type {Vector2}
		 * @default (0,0)
		 */ this.center = new Vector2(0, 0);
        /**
		 * How much the texture is rotated around the center point, in radians.
		 * Positive values are counter-clockwise.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Whether to update the texture's uv-transformation {@link Texture#matrix}
		 * from the properties {@link Texture#offset}, {@link Texture#repeat},
		 * {@link Texture#rotation}, and {@link Texture#center}.
		 *
		 * Set this to `false` if you are specifying the uv-transform matrix directly.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = true;
        /**
		 * The uv-transformation matrix of the texture.
		 *
		 * @type {Matrix3}
		 */ this.matrix = new Matrix3();
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Set this to `false` if you are creating mipmaps manually.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.generateMipmaps = true;
        /**
		 * If set to `true`, the alpha channel, if present, is multiplied into the
		 * color channels when the texture is uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure premultiply alpha on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultiplyAlpha = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Note that this property has no effect when using `ImageBitmap`. You need to
		 * configure the flip on bitmap creation instead.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.flipY = true;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 * The allowable values are `1` (byte-alignment), `2` (rows aligned to even-numbered bytes),
		 * `4` (word-alignment), and `8` (rows start on double-word boundaries).
		 *
		 * @type {number}
		 * @default 4
		 */ this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
        /**
		 * Textures containing color data should be annotated with `SRGBColorSpace` or `LinearSRGBColorSpace`.
		 *
		 * @type {string}
		 * @default NoColorSpace
		 */ this.colorSpace = colorSpace;
        /**
		 * An object that can be used to store custom data about the texture. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This can be used to only update a subregion or specific rows of the texture (for example, just the
		 * first 3 rows). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * This starts at `0` and counts how many times {@link Texture#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        /**
		 * A callback function, called when the texture is updated (e.g., when
		 * {@link Texture#needsUpdate} has been set to true and then the texture is used).
		 *
		 * @type {?Function}
		 * @default null
		 */ this.onUpdate = null;
        /**
		 * An optional back reference to the textures render target.
		 *
		 * @type {?(RenderTarget|WebGLRenderTarget)}
		 * @default null
		 */ this.renderTarget = null;
        /**
		 * Indicates whether a texture belongs to a render target or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isRenderTargetTexture = false;
        /**
		 * Indicates if a texture should be handled like a texture array.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isArrayTexture = image && image.depth && image.depth > 1 ? true : false;
        /**
		 * Indicates whether this texture should be processed by `PMREMGenerator` or not
		 * (only relevant for render target textures).
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.pmremVersion = 0;
    }
    /**
	 * The width of the texture in pixels.
	 */ get width() {
        return this.source.getSize(_tempVec3).x;
    }
    /**
	 * The height of the texture in pixels.
	 */ get height() {
        return this.source.getSize(_tempVec3).y;
    }
    /**
	 * The depth of the texture in pixels.
	 */ get depth() {
        return this.source.getSize(_tempVec3).z;
    }
    /**
	 * The image object holding the texture data.
	 *
	 * @type {?Object}
	 */ get image() {
        return this.source.data;
    }
    set image(value = null) {
        this.source.data = value;
    }
    /**
	 * Updates the texture transformation matrix from the from the properties {@link Texture#offset},
	 * {@link Texture#repeat}, {@link Texture#rotation}, and {@link Texture#center}.
	 */ updateMatrix() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    }
    /**
	 * Adds a range of data in the data texture to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start,
            count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Returns a new texture with copied values from this instance.
	 *
	 * @return {Texture} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given texture to this instance.
	 *
	 * @param {Texture} source - The texture to copy.
	 * @return {Texture} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.source = source.source;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.channel = source.channel;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.colorSpace = source.colorSpace;
        this.renderTarget = source.renderTarget;
        this.isRenderTargetTexture = source.isRenderTargetTexture;
        this.isArrayTexture = source.isArrayTexture;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        this.needsUpdate = true;
        return this;
    }
    /**
	 * Sets this texture's properties based on `values`.
	 * @param {Object} values - A container with texture parameters.
	 */ setValues(values) {
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                warn(`Texture.setValues(): parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                warn(`Texture.setValues(): property '${key}' does not exist.`);
                continue;
            }
            if (currentValue && newValue && currentValue.isVector2 && newValue.isVector2) currentValue.copy(newValue);
            else if (currentValue && newValue && currentValue.isVector3 && newValue.isVector3) currentValue.copy(newValue);
            else if (currentValue && newValue && currentValue.isMatrix3 && newValue.isMatrix3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the texture into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized texture.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.7,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            image: this.source.toJSON(meta).uuid,
            mapping: this.mapping,
            channel: this.channel,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            internalFormat: this.internalFormat,
            type: this.type,
            colorSpace: this.colorSpace,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            generateMipmaps: this.generateMipmaps,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (Object.keys(this.userData).length > 0) output.userData = this.userData;
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        /**
		 * Fires when the texture has been disposed of.
		 *
		 * @event Texture#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Transforms the given uv vector with the textures uv transformation matrix.
	 *
	 * @param {Vector2} uv - The uv vector.
	 * @return {Vector2} The transformed uv vector.
	 */ transformUv(uv) {
        if (this.mapping !== UVMapping) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case RepeatWrapping:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case ClampToEdgeWrapping:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case MirroredRepeatWrapping:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case RepeatWrapping:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case ClampToEdgeWrapping:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case MirroredRepeatWrapping:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
    /**
	 * Setting this property to `true` indicates the engine the texture
	 * must be updated in the next render. This triggers a texture upload
	 * to the GPU and ensures correct texture parameter configuration.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) {
            this.version++;
            this.source.needsUpdate = true;
        }
    }
    /**
	 * Setting this property to `true` indicates the engine the PMREM
	 * must be regenerated.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsPMREMUpdate(value) {
        if (value === true) this.pmremVersion++;
    }
}
/**
 * The default image for all textures.
 *
 * @static
 * @type {?Image}
 * @default null
 */ Texture.DEFAULT_IMAGE = null;
/**
 * The default mapping for all textures.
 *
 * @static
 * @type {number}
 * @default UVMapping
 */ Texture.DEFAULT_MAPPING = UVMapping;
/**
 * The default anisotropy value for all textures.
 *
 * @static
 * @type {number}
 * @default 1
 */ Texture.DEFAULT_ANISOTROPY = 1;
/**
 * Class representing a 4D vector. A 4D vector is an ordered quadruplet of numbers
 * (labeled x, y, z and w), which can be used to represent a number of things, such as:
 *
 * - A point in 4D space.
 * - A direction and length in 4D space. In three.js the length will
 * always be the Euclidean distance(straight-line distance) from `(0, 0, 0, 0)` to `(x, y, z, w)`
 * and the direction is also measured from `(0, 0, 0, 0)` towards `(x, y, z, w)`.
 * - Any arbitrary ordered quadruplet of numbers.
 *
 * There are other things a 4D vector can be used to represent, however these
 * are the most common uses in *three.js*.
 *
 * Iterating through a vector instance will yield its components `(x, y, z, w)` in
 * the corresponding order.
 * ```js
 * const a = new THREE.Vector4( 0, 1, 0, 0 );
 *
 * //no arguments; will be initialised to (0, 0, 0, 1)
 * const b = new THREE.Vector4( );
 *
 * const d = a.dot( b );
 * ```
 */ class Vector4 {
    /**
	 * Constructs a new 4D vector.
	 *
	 * @param {number} [x=0] - The x value of this vector.
	 * @param {number} [y=0] - The y value of this vector.
	 * @param {number} [z=0] - The z value of this vector.
	 * @param {number} [w=1] - The w value of this vector.
	 */ constructor(x = 0, y = 0, z = 0, w = 1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ Vector4.prototype.isVector4 = true;
        /**
		 * The x value of this vector.
		 *
		 * @type {number}
		 */ this.x = x;
        /**
		 * The y value of this vector.
		 *
		 * @type {number}
		 */ this.y = y;
        /**
		 * The z value of this vector.
		 *
		 * @type {number}
		 */ this.z = z;
        /**
		 * The w value of this vector.
		 *
		 * @type {number}
		 */ this.w = w;
    }
    /**
	 * Alias for {@link Vector4#z}.
	 *
	 * @type {number}
	 */ get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    /**
	 * Alias for {@link Vector4#w}.
	 *
	 * @type {number}
	 */ get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    /**
	 * Sets the vector components.
	 *
	 * @param {number} x - The value of the x component.
	 * @param {number} y - The value of the y component.
	 * @param {number} z - The value of the z component.
	 * @param {number} w - The value of the w component.
	 * @return {Vector4} A reference to this vector.
	 */ set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    /**
	 * Sets the vector components to the same value.
	 *
	 * @param {number} scalar - The value to set for all vector components.
	 * @return {Vector4} A reference to this vector.
	 */ setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    /**
	 * Sets the vector's x component to the given value
	 *
	 * @param {number} x - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setX(x) {
        this.x = x;
        return this;
    }
    /**
	 * Sets the vector's y component to the given value
	 *
	 * @param {number} y - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setY(y) {
        this.y = y;
        return this;
    }
    /**
	 * Sets the vector's z component to the given value
	 *
	 * @param {number} z - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setZ(z) {
        this.z = z;
        return this;
    }
    /**
	 * Sets the vector's w component to the given value
	 *
	 * @param {number} w - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setW(w) {
        this.w = w;
        return this;
    }
    /**
	 * Allows to set a vector component with an index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @param {number} value - The value to set.
	 * @return {Vector4} A reference to this vector.
	 */ setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    /**
	 * Returns the value of the vector component which matches the given index.
	 *
	 * @param {number} index - The component index. `0` equals to x, `1` equals to y,
	 * `2` equals to z, `3` equals to w.
	 * @return {number} A vector component value.
	 */ getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    /**
	 * Returns a new vector with copied values from this instance.
	 *
	 * @return {Vector4} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    /**
	 * Copies the values of the given vector to this instance.
	 *
	 * @param {Vector3|Vector4} v - The vector to copy.
	 * @return {Vector4} A reference to this vector.
	 */ copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    /**
	 * Adds the given vector to this instance.
	 *
	 * @param {Vector4} v - The vector to add.
	 * @return {Vector4} A reference to this vector.
	 */ add(v) {
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    /**
	 * Adds the given scalar value to all components of this instance.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Vector4} A reference to this vector.
	 */ addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    /**
	 * Adds the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    /**
	 * Adds the given vector scaled by the given factor to this instance.
	 *
	 * @param {Vector4} v - The vector.
	 * @param {number} s - The factor that scales `v`.
	 * @return {Vector4} A reference to this vector.
	 */ addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    /**
	 * Subtracts the given vector from this instance.
	 *
	 * @param {Vector4} v - The vector to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ sub(v) {
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    /**
	 * Subtracts the given scalar value from all components of this instance.
	 *
	 * @param {number} s - The scalar to subtract.
	 * @return {Vector4} A reference to this vector.
	 */ subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    /**
	 * Subtracts the given vectors and stores the result in this instance.
	 *
	 * @param {Vector4} a - The first vector.
	 * @param {Vector4} b - The second vector.
	 * @return {Vector4} A reference to this vector.
	 */ subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    /**
	 * Multiplies the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    /**
	 * Multiplies the given scalar value with all components of this instance.
	 *
	 * @param {number} scalar - The scalar to multiply.
	 * @return {Vector4} A reference to this vector.
	 */ multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    /**
	 * Multiplies this vector with the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    /**
	 * Divides this instance by the given vector.
	 *
	 * @param {Vector4} v - The vector to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        this.w /= v.w;
        return this;
    }
    /**
	 * Divides this vector by the given scalar.
	 *
	 * @param {number} scalar - The scalar to divide.
	 * @return {Vector4} A reference to this vector.
	 */ divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the quaternion's axis and w to the angle.
	 *
	 * @param {Quaternion} q - The Quaternion to set.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    /**
	 * Sets the x, y and z components of this
	 * vector to the axis of rotation and w to the angle.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper left 3x3 matrix is a pure rotation matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    /**
	 * Sets the vector components to the position elements of the
	 * given transformation matrix.
	 *
	 * @param {Matrix4} m - The 4x4 matrix.
	 * @return {Vector4} A reference to this vector.
	 */ setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        this.w = e[15];
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the given vector's x, y, z or w
	 * value, replace that value with the corresponding min value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is less than the given vector's x, y, z or w
	 * value, replace that value with the corresponding max value.
	 *
	 * @param {Vector4} v - The vector.
	 * @return {Vector4} A reference to this vector.
	 */ max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w value is greater than the max vector's x, y, z or w
	 * value, it is replaced by the corresponding value.
	 * If this vector's x, y, z or w value is less than the min vector's x, y, z or w value,
	 * it is replaced by the corresponding value.
	 *
	 * @param {Vector4} min - The minimum x, y and z values.
	 * @param {Vector4} max - The maximum x, y and z values in the desired range.
	 * @return {Vector4} A reference to this vector.
	 */ clamp(min, max) {
        // assumes min < max, componentwise
        this.x = clamp(this.x, min.x, max.x);
        this.y = clamp(this.y, min.y, max.y);
        this.z = clamp(this.z, min.z, max.z);
        this.w = clamp(this.w, min.w, max.w);
        return this;
    }
    /**
	 * If this vector's x, y, z or w values are greater than the max value, they are
	 * replaced by the max value.
	 * If this vector's x, y, z or w values are less than the min value, they are
	 * replaced by the min value.
	 *
	 * @param {number} minVal - The minimum value the components will be clamped to.
	 * @param {number} maxVal - The maximum value the components will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampScalar(minVal, maxVal) {
        this.x = clamp(this.x, minVal, maxVal);
        this.y = clamp(this.y, minVal, maxVal);
        this.z = clamp(this.z, minVal, maxVal);
        this.w = clamp(this.w, minVal, maxVal);
        return this;
    }
    /**
	 * If this vector's length is greater than the max value, it is replaced by
	 * the max value.
	 * If this vector's length is less than the min value, it is replaced by the
	 * min value.
	 *
	 * @param {number} min - The minimum value the vector length will be clamped to.
	 * @param {number} max - The maximum value the vector length will be clamped to.
	 * @return {Vector4} A reference to this vector.
	 */ clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(clamp(length, min, max));
    }
    /**
	 * The components of this vector are rounded down to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded up to the nearest integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded to the nearest integer value
	 *
	 * @return {Vector4} A reference to this vector.
	 */ round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    /**
	 * The components of this vector are rounded towards zero (up if negative,
	 * down if positive) to an integer value.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ roundToZero() {
        this.x = Math.trunc(this.x);
        this.y = Math.trunc(this.y);
        this.z = Math.trunc(this.z);
        this.w = Math.trunc(this.w);
        return this;
    }
    /**
	 * Inverts this vector - i.e. sets x = -x, y = -y, z = -z, w = -w.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    /**
	 * Calculates the dot product of the given vector with this instance.
	 *
	 * @param {Vector4} v - The vector to compute the dot product with.
	 * @return {number} The result of the dot product.
	 */ dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    /**
	 * Computes the square of the Euclidean length (straight-line length) from
	 * (0, 0, 0, 0) to (x, y, z, w). If you are comparing the lengths of vectors, you should
	 * compare the length squared instead as it is slightly more efficient to calculate.
	 *
	 * @return {number} The square length of this vector.
	 */ lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    /**
	 * Computes the  Euclidean length (straight-line length) from (0, 0, 0, 0) to (x, y, z, w).
	 *
	 * @return {number} The length of this vector.
	 */ length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    /**
	 * Computes the Manhattan length of this vector.
	 *
	 * @return {number} The length of this vector.
	 */ manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    /**
	 * Converts this vector to a unit vector - that is, sets it equal to a vector
	 * with the same direction as this one, but with a vector length of `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ normalize() {
        return this.divideScalar(this.length() || 1);
    }
    /**
	 * Sets this vector to a vector with the same direction as this one, but
	 * with the specified length.
	 *
	 * @param {number} length - The new length of this vector.
	 * @return {Vector4} A reference to this vector.
	 */ setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    /**
	 * Linearly interpolates between the given vector and this instance, where
	 * alpha is the percent distance along the line - alpha = 0 will be this
	 * vector, and alpha = 1 will be the given one.
	 *
	 * @param {Vector4} v - The vector to interpolate towards.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given vectors, where alpha is the percent
	 * distance along the line - alpha = 0 will be first vector, and alpha = 1 will
	 * be the second one. The result is stored in this instance.
	 *
	 * @param {Vector4} v1 - The first vector.
	 * @param {Vector4} v2 - The second vector.
	 * @param {number} alpha - The interpolation factor, typically in the closed interval `[0, 1]`.
	 * @return {Vector4} A reference to this vector.
	 */ lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    /**
	 * Returns `true` if this vector is equal with the given one.
	 *
	 * @param {Vector4} v - The vector to test for equality.
	 * @return {boolean} Whether this vector is equal with the given one.
	 */ equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    /**
	 * Sets this vector's x value to be `array[ offset ]`, y value to be `array[ offset + 1 ]`,
	 * z value to be `array[ offset + 2 ]`, w value to be `array[ offset + 3 ]`.
	 *
	 * @param {Array<number>} array - An array holding the vector component values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Vector4} A reference to this vector.
	 */ fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    /**
	 * Writes the components of this vector to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the vector components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The vector components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    /**
	 * Sets the components of this vector from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding vector data.
	 * @param {number} index - The index into the attribute.
	 * @return {Vector4} A reference to this vector.
	 */ fromBufferAttribute(attribute, index) {
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    /**
	 * Sets each component of this vector to a pseudo-random value between `0` and
	 * `1`, excluding `1`.
	 *
	 * @return {Vector4} A reference to this vector.
	 */ random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
    *[Symbol.iterator]() {
        yield this.x;
        yield this.y;
        yield this.z;
        yield this.w;
    }
}
/**
 * A render target is a buffer where the video card draws pixels for a scene
 * that is being rendered in the background. It is used in different effects,
 * such as applying postprocessing to a rendered image before displaying it
 * on the screen.
 *
 * @augments EventDispatcher
 */ class RenderTarget extends EventDispatcher {
    /**
	 * Render target options.
	 *
	 * @typedef {Object} RenderTarget~Options
	 * @property {boolean} [generateMipmaps=false] - Whether to generate mipmaps or not.
	 * @property {number} [magFilter=LinearFilter] - The mag filter.
	 * @property {number} [minFilter=LinearFilter] - The min filter.
	 * @property {number} [format=RGBAFormat] - The texture format.
	 * @property {number} [type=UnsignedByteType] - The texture type.
	 * @property {?string} [internalFormat=null] - The texture's internal format.
	 * @property {number} [wrapS=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [wrapT=ClampToEdgeWrapping] - The texture's uv wrapping mode.
	 * @property {number} [anisotropy=1] - The texture's anisotropy value.
	 * @property {string} [colorSpace=NoColorSpace] - The texture's color space.
	 * @property {boolean} [depthBuffer=true] - Whether to allocate a depth buffer or not.
	 * @property {boolean} [stencilBuffer=false] - Whether to allocate a stencil buffer or not.
	 * @property {boolean} [resolveDepthBuffer=true] - Whether to resolve the depth buffer or not.
	 * @property {boolean} [resolveStencilBuffer=true] - Whether  to resolve the stencil buffer or not.
	 * @property {?Texture} [depthTexture=null] - Reference to a depth texture.
	 * @property {number} [samples=0] - The MSAA samples count.
	 * @property {number} [count=1] - Defines the number of color attachments . Must be at least `1`.
	 * @property {number} [depth=1] - The texture depth.
	 * @property {boolean} [multiview=false] - Whether this target is used for multiview rendering.
	 */ /**
	 * Constructs a new render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super();
        options = Object.assign({
            generateMipmaps: false,
            internalFormat: null,
            minFilter: LinearFilter,
            depthBuffer: true,
            stencilBuffer: false,
            resolveDepthBuffer: true,
            resolveStencilBuffer: true,
            depthTexture: null,
            samples: 0,
            count: 1,
            depth: 1,
            multiview: false
        }, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget = true;
        /**
		 * The width of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.width = width;
        /**
		 * The height of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.height = height;
        /**
		 * The depth of the render target.
		 *
		 * @type {number}
		 * @default 1
		 */ this.depth = options.depth;
        /**
		 * A rectangular area inside the render target's viewport. Fragments that are
		 * outside the area will be discarded.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.scissor = new Vector4(0, 0, width, height);
        /**
		 * Indicates whether the scissor test should be enabled when rendering into
		 * this render target or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.scissorTest = false;
        /**
		 * A rectangular area representing the render target's viewport.
		 *
		 * @type {Vector4}
		 * @default (0,0,width,height)
		 */ this.viewport = new Vector4(0, 0, width, height);
        const image = {
            width: width,
            height: height,
            depth: options.depth
        };
        const texture = new Texture(image);
        /**
		 * An array of textures. Each color attachment is represented as a separate texture.
		 * Has at least a single entry for the default color attachment.
		 *
		 * @type {Array<Texture>}
		 */ this.textures = [];
        const count = options.count;
        for(let i = 0; i < count; i++){
            this.textures[i] = texture.clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
        }
        this._setTextureOptions(options);
        /**
		 * Whether to allocate a depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthBuffer = options.depthBuffer;
        /**
		 * Whether to allocate a stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilBuffer = options.stencilBuffer;
        /**
		 * Whether to resolve the depth buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveDepthBuffer = options.resolveDepthBuffer;
        /**
		 * Whether to resolve the stencil buffer or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.resolveStencilBuffer = options.resolveStencilBuffer;
        this._depthTexture = null;
        this.depthTexture = options.depthTexture;
        /**
		 * The number of MSAA samples.
		 *
		 * A value of `0` disables MSAA.
		 *
		 * @type {number}
		 * @default 0
		 */ this.samples = options.samples;
        /**
		 * Whether to this target is used in multiview rendering.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.multiview = options.multiview;
    }
    _setTextureOptions(options = {}) {
        const values = {
            minFilter: LinearFilter,
            generateMipmaps: false,
            flipY: false,
            internalFormat: null
        };
        if (options.mapping !== undefined) values.mapping = options.mapping;
        if (options.wrapS !== undefined) values.wrapS = options.wrapS;
        if (options.wrapT !== undefined) values.wrapT = options.wrapT;
        if (options.wrapR !== undefined) values.wrapR = options.wrapR;
        if (options.magFilter !== undefined) values.magFilter = options.magFilter;
        if (options.minFilter !== undefined) values.minFilter = options.minFilter;
        if (options.format !== undefined) values.format = options.format;
        if (options.type !== undefined) values.type = options.type;
        if (options.anisotropy !== undefined) values.anisotropy = options.anisotropy;
        if (options.colorSpace !== undefined) values.colorSpace = options.colorSpace;
        if (options.flipY !== undefined) values.flipY = options.flipY;
        if (options.generateMipmaps !== undefined) values.generateMipmaps = options.generateMipmaps;
        if (options.internalFormat !== undefined) values.internalFormat = options.internalFormat;
        for(let i = 0; i < this.textures.length; i++){
            const texture = this.textures[i];
            texture.setValues(values);
        }
    }
    /**
	 * The texture representing the default color attachment.
	 *
	 * @type {Texture}
	 */ get texture() {
        return this.textures[0];
    }
    set texture(value) {
        this.textures[0] = value;
    }
    set depthTexture(current) {
        if (this._depthTexture !== null) this._depthTexture.renderTarget = null;
        if (current !== null) current.renderTarget = this;
        this._depthTexture = current;
    }
    /**
	 * Instead of saving the depth in a renderbuffer, a texture
	 * can be used instead which is useful for further processing
	 * e.g. in context of post-processing.
	 *
	 * @type {?DepthTexture}
	 * @default null
	 */ get depthTexture() {
        return this._depthTexture;
    }
    /**
	 * Sets the size of this render target.
	 *
	 * @param {number} width - The width.
	 * @param {number} height - The height.
	 * @param {number} [depth=1] - The depth.
	 */ setSize(width, height, depth = 1) {
        if (this.width !== width || this.height !== height || this.depth !== depth) {
            this.width = width;
            this.height = height;
            this.depth = depth;
            for(let i = 0, il = this.textures.length; i < il; i++){
                this.textures[i].image.width = width;
                this.textures[i].image.height = height;
                this.textures[i].image.depth = depth;
                if (this.textures[i].isData3DTexture !== true) // TODO: Reconsider setting isArrayTexture flag here and in the ctor of Texture.
                // Maybe a method `isArrayTexture()` or just a getter could replace a flag since
                // both are evaluated on each call?
                this.textures[i].isArrayTexture = this.textures[i].image.depth > 1;
            }
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    /**
	 * Returns a new render target with copied values from this instance.
	 *
	 * @return {RenderTarget} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the settings of the given render target. This is a structural copy so
	 * no resources are shared between render targets after the copy. That includes
	 * all MRT textures and the depth texture.
	 *
	 * @param {RenderTarget} source - The render target to copy.
	 * @return {RenderTarget} A reference to this instance.
	 */ copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.depth = source.depth;
        this.scissor.copy(source.scissor);
        this.scissorTest = source.scissorTest;
        this.viewport.copy(source.viewport);
        this.textures.length = 0;
        for(let i = 0, il = source.textures.length; i < il; i++){
            this.textures[i] = source.textures[i].clone();
            this.textures[i].isRenderTargetTexture = true;
            this.textures[i].renderTarget = this;
            // ensure image object is not shared, see #20328
            const image = Object.assign({}, source.textures[i].image);
            this.textures[i].source = new Source(image);
        }
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.resolveDepthBuffer = source.resolveDepthBuffer;
        this.resolveStencilBuffer = source.resolveStencilBuffer;
        if (source.depthTexture !== null) this.depthTexture = source.depthTexture.clone();
        this.samples = source.samples;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires RenderTarget#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
/**
 * A render target used in context of {@link WebGLRenderer}.
 *
 * @augments RenderTarget
 */ class WebGLRenderTarget extends RenderTarget {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLRenderTarget = true;
    }
}
/**
 * Creates an array of textures directly from raw buffer data.
 *
 * @augments Texture
 */ class DataArrayTexture extends Texture {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataArrayTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data,
            width,
            height,
            depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = NearestFilter;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = NearestFilter;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = ClampToEdgeWrapping;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire data texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
/**
 * An array render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class WebGLArrayRenderTarget extends WebGLRenderTarget {
    /**
	 * Constructs a new array render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLArrayRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new DataArrayTexture(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Creates a three-dimensional texture from raw data, with parameters to
 * divide it into width, height, and depth.
 *
 * @augments Texture
 */ class Data3DTexture extends Texture {
    /**
	 * Constructs a new data array texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(data = null, width = 1, height = 1, depth = 1){
        // We're going to add .setXXX() methods for setting properties later.
        // Users can still set in Data3DTexture directly.
        //
        //	const texture = new THREE.Data3DTexture( data, width, height, depth );
        // 	texture.anisotropy = 16;
        //
        // See #14839
        super(null);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isData3DTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number,depth:number}}
		 */ this.image = {
            data,
            width,
            height,
            depth
        };
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = NearestFilter;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = NearestFilter;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = ClampToEdgeWrapping;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
/**
 * A 3D render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class WebGL3DRenderTarget extends WebGLRenderTarget {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGL3DRenderTarget = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new Data3DTexture(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents an axis-aligned bounding box (AABB) in 3D space.
 */ class Box3 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector3} [min=(Infinity,Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector3} [max=(-Infinity,-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new Vector3(Infinity, Infinity, Infinity), max = new Vector3(-Infinity, -Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox3 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector3}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector3} min - The lower boundary of the box.
	 * @param {Vector3} max - The upper boundary of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<number>} array - An array holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromArray(array) {
        this.makeEmpty();
        for(let i = 0, il = array.length; i < il; i += 3)this.expandByPoint(_vector$b.fromArray(array, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute holding 3D position data.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromBufferAttribute(attribute) {
        this.makeEmpty();
        for(let i = 0, il = attribute.count; i < il; i++)this.expandByPoint(_vector$b.fromBufferAttribute(attribute, i));
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector3>} points - An array holding 3D position data as instances of {@link Vector3}.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector3} center - The center of the box.
	 * @param {Vector3} size - The x, y and z dimensions of the box.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = _vector$b.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Computes the world-axis-aligned bounding box for the given 3D object
	 * (including its children), accounting for the object's, and children's,
	 * world transforms. The function may result in a larger box than strictly necessary.
	 *
	 * @param {Object3D} object - The 3D object to compute the bounding box for.
	 * @param {boolean} [precise=false] - If set to `true`, the method computes the smallest
	 * world-axis-aligned bounding box at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ setFromObject(object, precise = false) {
        this.makeEmpty();
        return this.expandByObject(object, precise);
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box3} box - The box to copy.
	 * @return {Box3} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 3D.
	 *
	 * @return {Box3} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector3} point - The point that should be included by the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions. The depth of this box will be
	 * expanded by the z component of the vector in both directions.
	 *
	 * @param {Vector3} vector - The vector that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Expands the boundaries of this box to include the given 3D object and
	 * its children, accounting for the object's, and children's, world
	 * transforms. The function may result in a larger box than strictly
	 * necessary (unless the precise parameter is set to true).
	 *
	 * @param {Object3D} object - The 3D object that should expand the bounding box.
	 * @param {boolean} precise - If set to `true`, the method expands the bounding box
	 * as little as necessary at the expense of more computation.
	 * @return {Box3} A reference to this bounding box.
	 */ expandByObject(object, precise = false) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            const positionAttribute = geometry.getAttribute('position');
            // precise AABB computation based on vertex data requires at least a position attribute.
            // instancing isn't supported so far and uses the normal (conservative) code path.
            if (precise === true && positionAttribute !== undefined && object.isInstancedMesh !== true) for(let i = 0, l = positionAttribute.count; i < l; i++){
                if (object.isMesh === true) object.getVertexPosition(i, _vector$b);
                else _vector$b.fromBufferAttribute(positionAttribute, i);
                _vector$b.applyMatrix4(object.matrixWorld);
                this.expandByPoint(_vector$b);
            }
            else {
                if (object.boundingBox !== undefined) {
                    // object-level bounding box
                    if (object.boundingBox === null) object.computeBoundingBox();
                    _box$4.copy(object.boundingBox);
                } else {
                    // geometry-level bounding box
                    if (geometry.boundingBox === null) geometry.computeBoundingBox();
                    _box$4.copy(geometry.boundingBox);
                }
                _box$4.applyMatrix4(object.matrixWorld);
                this.union(_box$4);
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i], precise);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y && point.z >= this.min.z && point.z <= this.max.z;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    /**
	 * Returns a point as a proportion of this box's width, height and depth.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A point as a proportion of this box's width, height and depth.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y && box.max.z >= this.min.z && box.min.z <= this.max.z;
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with this bounding box.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with this bounding box.
	 */ intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, _vector$b);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return _vector$b.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Returns `true` if the given plane intersects with this bounding box.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether the given plane intersects with this bounding box.
	 */ intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    /**
	 * Returns `true` if the given triangle intersects with this bounding box.
	 *
	 * @param {Triangle} triangle - The triangle to test.
	 * @return {boolean} Whether the given triangle intersects with this bounding box.
	 */ intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter(_center);
        _extents.subVectors(this.max, _center);
        // translate triangle to aabb origin
        _v0$2.subVectors(triangle.a, _center);
        _v1$7.subVectors(triangle.b, _center);
        _v2$4.subVectors(triangle.c, _center);
        // compute edge vectors for triangle
        _f0.subVectors(_v1$7, _v0$2);
        _f1.subVectors(_v2$4, _v1$7);
        _f2.subVectors(_v0$2, _v2$4);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -_f0.z,
            _f0.y,
            0,
            -_f1.z,
            _f1.y,
            0,
            -_f2.z,
            _f2.y,
            _f0.z,
            0,
            -_f0.x,
            _f1.z,
            0,
            -_f1.x,
            _f2.z,
            0,
            -_f2.x,
            -_f0.y,
            _f0.x,
            0,
            -_f1.y,
            _f1.x,
            0,
            -_f2.y,
            _f2.x,
            0
        ];
        if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        _triangleNormal.crossVectors(_f0, _f1);
        axes = [
            _triangleNormal.x,
            _triangleNormal.y,
            _triangleNormal.z
        ];
        return satForAxes(axes, _v0$2, _v1$7, _v2$4, _extents);
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector3} point - The point to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, _vector$b).distanceTo(point);
    }
    /**
	 * Returns a bounding sphere that encloses this bounding box.
	 *
	 * @param {Sphere} target - The target sphere that is used to store the method's result.
	 * @return {Sphere} The bounding sphere that encloses this bounding box.
	 */ getBoundingSphere(target) {
        if (this.isEmpty()) target.makeEmpty();
        else {
            this.getCenter(target.center);
            target.radius = this.getSize(_vector$b).length() * 0.5;
        }
        return target;
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box3} box - The bounding box to intersect with.
	 * @return {Box3} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box3} box - The bounding box that will be unioned with this instance.
	 * @return {Box3} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Transforms this bounding box by the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Box3} A reference to this bounding box.
	 */ applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        _points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints(_points);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 3D space.
	 *
	 * @param {Vector3} offset - The offset that should be used to translate the bounding box.
	 * @return {Box3} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box3} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
    /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ toJSON() {
        return {
            min: this.min.toArray(),
            max: this.max.toArray()
        };
    }
    /**
	 * Returns a serialized structure of the bounding box.
	 *
	 * @param {Object} json - The serialized json to set the box from.
	 * @return {Box3} A reference to this bounding box.
	 */ fromJSON(json) {
        this.min.fromArray(json.min);
        this.max.fromArray(json.max);
        return this;
    }
}
const _points = [
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3()
];
const _vector$b = /*@__PURE__*/ new Vector3();
const _box$4 = /*@__PURE__*/ new Box3();
// triangle centered vertices
const _v0$2 = /*@__PURE__*/ new Vector3();
const _v1$7 = /*@__PURE__*/ new Vector3();
const _v2$4 = /*@__PURE__*/ new Vector3();
// triangle edge vectors
const _f0 = /*@__PURE__*/ new Vector3();
const _f1 = /*@__PURE__*/ new Vector3();
const _f2 = /*@__PURE__*/ new Vector3();
const _center = /*@__PURE__*/ new Vector3();
const _extents = /*@__PURE__*/ new Vector3();
const _triangleNormal = /*@__PURE__*/ new Vector3();
const _testAxis = /*@__PURE__*/ new Vector3();
function satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        _testAxis.fromArray(axes, i);
        // project the aabb onto the separating axis
        const r = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z);
        // project all 3 vertices of the triangle onto the separating axis
        const p0 = v0.dot(_testAxis);
        const p1 = v1.dot(_testAxis);
        const p2 = v2.dot(_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is separating and we can exit
        return false;
    }
    return true;
}
const _box$3 = /*@__PURE__*/ new Box3();
const _v1$6 = /*@__PURE__*/ new Vector3();
const _v2$3 = /*@__PURE__*/ new Vector3();
/**
 * An analytical 3D sphere defined by a center and radius. This class is mainly
 * used as a Bounding Sphere for 3D objects.
 */ class Sphere {
    /**
	 * Constructs a new sphere.
	 *
	 * @param {Vector3} [center=(0,0,0)] - The center of the sphere
	 * @param {number} [radius=-1] - The radius of the sphere.
	 */ constructor(center = new Vector3(), radius = -1){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphere = true;
        /**
		 * The center of the sphere
		 *
		 * @type {Vector3}
		 */ this.center = center;
        /**
		 * The radius of the sphere.
		 *
		 * @type {number}
		 */ this.radius = radius;
    }
    /**
	 * Sets the sphere's components by copying the given values.
	 *
	 * @param {Vector3} center - The center.
	 * @param {number} radius - The radius.
	 * @return {Sphere} A reference to this sphere.
	 */ set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    /**
	 * Computes the minimum bounding sphere for list of points.
	 * If the optional center point is given, it is used as the sphere's
	 * center. Otherwise, the center of the axis-aligned bounding box
	 * encompassing the points is calculated.
	 *
	 * @param {Array<Vector3>} points - A list of points in 3D space.
	 * @param {Vector3} [optionalCenter] - The center of the sphere.
	 * @return {Sphere} A reference to this sphere.
	 */ setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else _box$3.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    /**
	 * Copies the values of the given sphere to this instance.
	 *
	 * @param {Sphere} sphere - The sphere to copy.
	 * @return {Sphere} A reference to this sphere.
	 */ copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    /**
	 * Returns `true` if the sphere is empty (the radius set to a negative number).
	 *
	 * Spheres with a radius of `0` contain only their center point and are not
	 * considered to be empty.
	 *
	 * @return {boolean} Whether this sphere is empty or not.
	 */ isEmpty() {
        return this.radius < 0;
    }
    /**
	 * Makes this sphere empty which means in encloses a zero space in 3D.
	 *
	 * @return {Sphere} A reference to this sphere.
	 */ makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    /**
	 * Returns `true` if this sphere contains the given point inclusive of
	 * the surface of the sphere.
	 *
	 * @param {Vector3} point - The point to check.
	 * @return {boolean} Whether this sphere contains the given point or not.
	 */ containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    /**
	 * Returns the closest distance from the boundary of the sphere to the
	 * given point. If the sphere contains the point, the distance will
	 * be negative.
	 *
	 * @param {Vector3} point - The point to compute the distance to.
	 * @return {number} The distance to the point.
	 */ distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    /**
	 * Returns `true` if this sphere intersects with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test.
	 * @return {boolean} Whether this sphere intersects with the given one or not.
	 */ intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    /**
	 * Returns `true` if this sphere intersects with the given box.
	 *
	 * @param {Box3} box - The box to test.
	 * @return {boolean} Whether this sphere intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    /**
	 * Returns `true` if this sphere intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to test.
	 * @return {boolean} Whether this sphere intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    /**
	 * Clamps a point within the sphere. If the point is outside the sphere, it
	 * will clamp it to the closest point on the edge of the sphere. Points
	 * already inside the sphere will not be affected.
	 *
	 * @param {Vector3} point - The plane to clamp.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The clamped point.
	 */ clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    /**
	 * Returns a bounding box that encloses this sphere.
	 *
	 * @param {Box3} target - The target box that is used to store the method's result.
	 * @return {Box3} The bounding box that encloses this sphere.
	 */ getBoundingBox(target) {
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    /**
	 * Transforms this sphere with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Sphere} A reference to this sphere.
	 */ applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    /**
	 * Translates the sphere's center by the given offset.
	 *
	 * @param {Vector3} offset - The offset.
	 * @return {Sphere} A reference to this sphere.
	 */ translate(offset) {
        this.center.add(offset);
        return this;
    }
    /**
	 * Expands the boundaries of this sphere to include the given point.
	 *
	 * @param {Vector3} point - The point to include.
	 * @return {Sphere} A reference to this sphere.
	 */ expandByPoint(point) {
        if (this.isEmpty()) {
            this.center.copy(point);
            this.radius = 0;
            return this;
        }
        _v1$6.subVectors(point, this.center);
        const lengthSq = _v1$6.lengthSq();
        if (lengthSq > this.radius * this.radius) {
            // calculate the minimal sphere
            const length = Math.sqrt(lengthSq);
            const delta = (length - this.radius) * 0.5;
            this.center.addScaledVector(_v1$6, delta / length);
            this.radius += delta;
        }
        return this;
    }
    /**
	 * Expands this sphere to enclose both the original sphere and the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to include.
	 * @return {Sphere} A reference to this sphere.
	 */ union(sphere) {
        if (sphere.isEmpty()) return this;
        if (this.isEmpty()) {
            this.copy(sphere);
            return this;
        }
        if (this.center.equals(sphere.center) === true) this.radius = Math.max(this.radius, sphere.radius);
        else {
            _v2$3.subVectors(sphere.center, this.center).setLength(sphere.radius);
            this.expandByPoint(_v1$6.copy(sphere.center).add(_v2$3));
            this.expandByPoint(_v1$6.copy(sphere.center).sub(_v2$3));
        }
        return this;
    }
    /**
	 * Returns `true` if this sphere is equal with the given one.
	 *
	 * @param {Sphere} sphere - The sphere to test for equality.
	 * @return {boolean} Whether this bounding sphere is equal with the given one.
	 */ equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
    /**
	 * Returns a new sphere with copied values from this instance.
	 *
	 * @return {Sphere} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @return {Object} Serialized structure with fields representing the object state.
	 */ toJSON() {
        return {
            radius: this.radius,
            center: this.center.toArray()
        };
    }
    /**
	 * Returns a serialized structure of the bounding sphere.
	 *
	 * @param {Object} json - The serialized json to set the sphere from.
	 * @return {Sphere} A reference to this bounding sphere.
	 */ fromJSON(json) {
        this.radius = json.radius;
        this.center.fromArray(json.center);
        return this;
    }
}
const _vector$a = /*@__PURE__*/ new Vector3();
const _segCenter = /*@__PURE__*/ new Vector3();
const _segDir = /*@__PURE__*/ new Vector3();
const _diff = /*@__PURE__*/ new Vector3();
const _edge1 = /*@__PURE__*/ new Vector3();
const _edge2 = /*@__PURE__*/ new Vector3();
const _normal$1 = /*@__PURE__*/ new Vector3();
/**
 * A ray that emits from an origin in a certain direction. The class is used by
 * {@link Raycaster} to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3D space the mouse is over)
 * amongst other things.
 */ class Ray {
    /**
	 * Constructs a new ray.
	 *
	 * @param {Vector3} [origin=(0,0,0)] - The origin of the ray.
	 * @param {Vector3} [direction=(0,0,-1)] - The (normalized) direction of the ray.
	 */ constructor(origin = new Vector3(), direction = new Vector3(0, 0, -1)){
        /**
		 * The origin of the ray.
		 *
		 * @type {Vector3}
		 */ this.origin = origin;
        /**
		 * The (normalized) direction of the ray.
		 *
		 * @type {Vector3}
		 */ this.direction = direction;
    }
    /**
	 * Sets the ray's components by copying the given values.
	 *
	 * @param {Vector3} origin - The origin.
	 * @param {Vector3} direction - The direction.
	 * @return {Ray} A reference to this ray.
	 */ set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    /**
	 * Copies the values of the given ray to this instance.
	 *
	 * @param {Ray} ray - The ray to copy.
	 * @return {Ray} A reference to this ray.
	 */ copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    /**
	 * Returns a vector that is located at a given distance along this ray.
	 *
	 * @param {number} t - The distance along the ray to retrieve a position for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} A position on the ray.
	 */ at(t, target) {
        return target.copy(this.origin).addScaledVector(this.direction, t);
    }
    /**
	 * Adjusts the direction of the ray to point at the given vector in world space.
	 *
	 * @param {Vector3} v - The target position.
	 * @return {Ray} A reference to this ray.
	 */ lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    /**
	 * Shift the origin of this ray along its direction by the given distance.
	 *
	 * @param {number} t - The distance along the ray to interpolate.
	 * @return {Ray} A reference to this ray.
	 */ recast(t) {
        this.origin.copy(this.at(t, _vector$a));
        return this;
    }
    /**
	 * Returns the point along this ray that is closest to the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to get the closet location on the ray for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on this ray.
	 */ closestPointToPoint(point, target) {
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.origin).addScaledVector(this.direction, directionDistance);
    }
    /**
	 * Returns the distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The distance.
	 */ distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    /**
	 * Returns the squared distance of the closest approach between this ray and the given point.
	 *
	 * @param {Vector3} point - A point in 3D space to compute the distance to.
	 * @return {number} The squared distance.
	 */ distanceSqToPoint(point) {
        const directionDistance = _vector$a.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        _vector$a.copy(this.origin).addScaledVector(this.direction, directionDistance);
        return _vector$a.distanceToSquared(point);
    }
    /**
	 * Returns the squared distance between this ray and the given line segment.
	 *
	 * @param {Vector3} v0 - The start point of the line segment.
	 * @param {Vector3} v1 - The end point of the line segment.
	 * @param {Vector3} [optionalPointOnRay] - When provided, it receives the point on this ray that is closest to the segment.
	 * @param {Vector3} [optionalPointOnSegment] - When provided, it receives the point on the line segment that is closest to this ray.
	 * @return {number} The squared distance.
	 */ distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        _segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        _segDir.copy(v1).sub(v0).normalize();
        _diff.copy(this.origin).sub(_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot(_segDir);
        const b0 = _diff.dot(this.direction);
        const b1 = -_diff.dot(_segDir);
        const c = _diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.origin).addScaledVector(this.direction, s0);
        if (optionalPointOnSegment) optionalPointOnSegment.copy(_segCenter).addScaledVector(_segDir, s1);
        return sqrDist;
    }
    /**
	 * Intersects this ray with the given sphere, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectSphere(sphere, target) {
        _vector$a.subVectors(sphere.center, this.origin);
        const tca = _vector$a.dot(this.direction);
        const d2 = _vector$a.dot(_vector$a) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if t1 is behind the ray - if so, return null
        if (t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given sphere.
	 *
	 * @param {Sphere} sphere - The sphere to intersect.
	 * @return {boolean} Whether this ray intersects with the given sphere or not.
	 */ intersectsSphere(sphere) {
        if (sphere.radius < 0) return false; // handle empty spheres, see #31187
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    /**
	 * Computes the distance from the ray's origin to the given plane. Returns `null` if the ray
	 * does not intersect with the plane.
	 *
	 * @param {Plane} plane - The plane to compute the distance to.
	 * @return {?number} Whether this ray intersects with the given sphere or not.
	 */ distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    /**
	 * Intersects this ray with the given plane, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given plane.
	 *
	 * @param {Plane} plane - The plane to intersect.
	 * @return {boolean} Whether this ray intersects with the given plane or not.
	 */ intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    /**
	 * Intersects this ray with the given bounding box, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        if (tymin > tmin || isNaN(tmin)) tmin = tymin;
        if (tymax < tmax || isNaN(tmax)) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    /**
	 * Returns `true` if this ray intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this ray intersects with the given box or not.
	 */ intersectsBox(box) {
        return this.intersectBox(box, _vector$a) !== null;
    }
    /**
	 * Intersects this ray with the given triangle, returning the intersection
	 * point or `null` if there is no intersection.
	 *
	 * @param {Vector3} a - The first vertex of the triangle.
	 * @param {Vector3} b - The second vertex of the triangle.
	 * @param {Vector3} c - The third vertex of the triangle.
	 * @param {boolean} backfaceCulling - Whether to use backface culling or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from https://github.com/pmjoniak/GeometricTools/blob/master/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        _edge1.subVectors(b, a);
        _edge2.subVectors(c, a);
        _normal$1.crossVectors(_edge1, _edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot(_normal$1);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        _diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot(_edge2.crossVectors(_diff, _edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot(_edge1.cross(_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * _diff.dot(_normal$1);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    /**
	 * Transforms this ray with the given 4x4 transformation matrix.
	 *
	 * @param {Matrix4} matrix4 - The transformation matrix.
	 * @return {Ray} A reference to this ray.
	 */ applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    /**
	 * Returns `true` if this ray is equal with the given one.
	 *
	 * @param {Ray} ray - The ray to test for equality.
	 * @return {boolean} Whether this ray is equal with the given one.
	 */ equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
    /**
	 * Returns a new ray with copied values from this instance.
	 *
	 * @return {Ray} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Represents a 4x4 matrix.
 *
 * The most common use of a 4x4 matrix in 3D computer graphics is as a transformation matrix.
 * For an introduction to transformation matrices as used in WebGL, check out [this tutorial](https://www.opengl-tutorial.org/beginners-tutorials/tutorial-3-matrices)
 *
 * This allows a 3D vector representing a point in 3D space to undergo
 * transformations such as translation, rotation, shear, scale, reflection,
 * orthogonal or perspective projection and so on, by being multiplied by the
 * matrix. This is known as `applying` the matrix to the vector.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix3#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix3#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix4();
 * m.set( 11, 12, 13, 14,
 *        21, 22, 23, 24,
 *        31, 32, 33, 34,
 *        41, 42, 43, 44 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21, 31, 41,
 *                12, 22, 32, 42,
 *                13, 23, 33, 43,
 *                14, 24, 34, 44 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class Matrix4 {
    /**
	 * Constructs a new 4x4 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 */ constructor(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ Matrix4.prototype.isMatrix4 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44);
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n13] - 1-3 matrix element.
	 * @param {number} [n14] - 1-4 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 * @param {number} [n23] - 2-3 matrix element.
	 * @param {number} [n24] - 2-4 matrix element.
	 * @param {number} [n31] - 3-1 matrix element.
	 * @param {number} [n32] - 3-2 matrix element.
	 * @param {number} [n33] - 3-3 matrix element.
	 * @param {number} [n34] - 3-4 matrix element.
	 * @param {number} [n41] - 4-1 matrix element.
	 * @param {number} [n42] - 4-2 matrix element.
	 * @param {number} [n43] - 4-3 matrix element.
	 * @param {number} [n44] - 4-4 matrix element.
	 * @return {Matrix4} A reference to this matrix.
	 */ set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    /**
	 * Sets this matrix to the 4x4 identity matrix.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Returns a matrix with copied values from this instance.
	 *
	 * @return {Matrix4} A clone of this instance.
	 */ clone() {
        return new Matrix4().fromArray(this.elements);
    }
    /**
	 * Copies the values of the given matrix to this instance.
	 *
	 * @param {Matrix4} m - The matrix to copy.
	 * @return {Matrix4} A reference to this matrix.
	 */ copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    /**
	 * Copies the translation component of the given matrix
	 * into this matrix's translation component.
	 *
	 * @param {Matrix4} m - The matrix to copy the translation component.
	 * @return {Matrix4} A reference to this matrix.
	 */ copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    /**
	 * Set the upper 3x3 elements of this matrix to the values of given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The 3x3 matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the basis of this matrix into the three axis vectors provided.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractBasis(xAxis, yAxis, zAxis) {
        if (this.determinant() === 0) {
            xAxis.set(1, 0, 0);
            yAxis.set(0, 1, 0);
            zAxis.set(0, 0, 1);
            return this;
        }
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    /**
	 * Sets the given basis vectors to this matrix.
	 *
	 * @param {Vector3} xAxis - The basis's x axis.
	 * @param {Vector3} yAxis - The basis's y axis.
	 * @param {Vector3} zAxis - The basis's z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Extracts the rotation component of the given matrix
	 * into this matrix's rotation component.
	 *
	 * Note: This method does not support reflection matrices.
	 *
	 * @param {Matrix4} m - The matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ extractRotation(m) {
        if (m.determinant() === 0) return this.identity();
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / _v1$5.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / _v1$5.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / _v1$5.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component (the upper left 3x3 matrix) of this matrix to
	 * the rotation specified by the given Euler angles. The rest of
	 * the matrix is set to the identity. Depending on the {@link Euler#order},
	 * there are six possible outcomes. See [this page](https://en.wikipedia.org/wiki/Euler_angles#Rotation_matrix)
	 * for a complete list.
	 *
	 * @param {Euler} euler - The Euler angles.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromEuler(euler) {
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Sets the rotation component of this matrix to the rotation specified by
	 * the given Quaternion as outlined [here](https://en.wikipedia.org/wiki/Rotation_matrix#Quaternion)
	 * The rest of the matrix is set to the identity.
	 *
	 * @param {Quaternion} q - The Quaternion.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationFromQuaternion(q) {
        return this.compose(_zero, q, _one);
    }
    /**
	 * Sets the rotation component of the transformation matrix, looking from `eye` towards
	 * `target`, and oriented by the up-direction.
	 *
	 * @param {Vector3} eye - The eye vector.
	 * @param {Vector3} target - The target vector.
	 * @param {Vector3} up - The up vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ lookAt(eye, target, up) {
        const te = this.elements;
        _z.subVectors(eye, target);
        if (_z.lengthSq() === 0) // eye and target are in the same position
        _z.z = 1;
        _z.normalize();
        _x.crossVectors(up, _z);
        if (_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) _z.x += 0.0001;
            else _z.z += 0.0001;
            _z.normalize();
            _x.crossVectors(up, _z);
        }
        _x.normalize();
        _y.crossVectors(_z, _x);
        te[0] = _x.x;
        te[4] = _y.x;
        te[8] = _z.x;
        te[1] = _x.y;
        te[5] = _y.y;
        te[9] = _z.y;
        te[2] = _x.z;
        te[6] = _y.z;
        te[10] = _z.z;
        return this;
    }
    /**
	 * Post-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    /**
	 * Pre-multiplies this matrix by the given 4x4 matrix.
	 *
	 * @param {Matrix4} m - The matrix to multiply with.
	 * @return {Matrix4} A reference to this matrix.
	 */ premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    /**
	 * Multiples the given 4x4 matrices and stores the result
	 * in this matrix.
	 *
	 * @param {Matrix4} a - The first matrix.
	 * @param {Matrix4} b - The second matrix.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    /**
	 * Multiplies every component of the matrix by the given scalar.
	 *
	 * @param {number} s - The scalar.
	 * @return {Matrix4} A reference to this matrix.
	 */ multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    /**
	 * Computes and returns the determinant of this matrix.
	 *
	 * Based on the method outlined [here](http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.html).
	 *
	 * @return {number} The determinant.
	 */ determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        const t11 = n23 * n34 - n24 * n33;
        const t12 = n22 * n34 - n24 * n32;
        const t13 = n22 * n33 - n23 * n32;
        const t21 = n21 * n34 - n24 * n31;
        const t22 = n21 * n33 - n23 * n31;
        const t23 = n21 * n32 - n22 * n31;
        return n11 * (n42 * t11 - n43 * t12 + n44 * t13) - n12 * (n41 * t11 - n43 * t21 + n44 * t22) + n13 * (n41 * t12 - n42 * t21 + n44 * t23) - n14 * (n41 * t13 - n42 * t22 + n43 * t23);
    }
    /**
	 * Transposes this matrix in place.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    /**
	 * Sets the position component for this matrix from the given vector,
	 * without affecting the rest of the matrix.
	 *
	 * @param {number|Vector3} x - The x component of the vector or alternatively the vector object.
	 * @param {number} y - The y component of the vector.
	 * @param {number} z - The z component of the vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    /**
	 * Inverts this matrix, using the [analytic method](https://en.wikipedia.org/wiki/Invertible_matrix#Analytic_solution).
	 * You can not invert with a determinant of zero. If you attempt this, the method produces
	 * a zero matrix instead.
	 *
	 * @return {Matrix4} A reference to this matrix.
	 */ invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    /**
	 * Multiplies the columns of this matrix by the given vector.
	 *
	 * @param {Vector3} v - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    /**
	 * Gets the maximum scale value of the three axes.
	 *
	 * @return {number} The maximum scale.
	 */ getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    /**
	 * Sets this matrix as a translation transform from the given vector.
	 *
	 * @param {number|Vector3} x - The amount to translate in the X axis or alternatively a translation vector.
	 * @param {number} y - The amount to translate in the Y axis.
	 * @param {number} z - The amount to translate in the z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeTranslation(x, y, z) {
        if (x.isVector3) this.set(1, 0, 0, x.x, 0, 1, 0, x.y, 0, 0, 1, x.z, 0, 0, 0, 1);
        else this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the X axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Y axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the Z axis by
	 * the given angle.
	 *
	 * @param {number} theta - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a rotational transformation around the given axis by
	 * the given angle.
	 *
	 * This is a somewhat controversial but mathematically sound alternative to
	 * rotating via Quaternions. See the discussion [here](https://www.gamedev.net/articles/programming/math-and-physics/do-we-really-need-quaternions-r1199).
	 *
	 * @param {Vector3} axis - The normalized rotation axis.
	 * @param {number} angle - The rotation in radians.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a scale transformation.
	 *
	 * @param {number} x - The amount to scale in the X axis.
	 * @param {number} y - The amount to scale in the Y axis.
	 * @param {number} z - The amount to scale in the Z axis.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix as a shear transformation.
	 *
	 * @param {number} xy - The amount to shear X by Y.
	 * @param {number} xz - The amount to shear X by Z.
	 * @param {number} yx - The amount to shear Y by X.
	 * @param {number} yz - The amount to shear Y by Z.
	 * @param {number} zx - The amount to shear Z by X.
	 * @param {number} zy - The amount to shear Z by Y.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeShear(xy, xz, yx, yz, zx, zy) {
        this.set(1, yx, zx, 0, xy, 1, zy, 0, xz, yz, 1, 0, 0, 0, 0, 1);
        return this;
    }
    /**
	 * Sets this matrix to the transformation composed of the given position,
	 * rotation (Quaternion) and scale.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    /**
	 * Decomposes this matrix into its position, rotation and scale components
	 * and provides the result in the given objects.
	 *
	 * Note: Not all matrices are decomposable in this way. For example, if an
	 * object has a non-uniformly scaled parent, then the object's world matrix
	 * may not be decomposable, and this method may not be appropriate.
	 *
	 * @param {Vector3} position - The position vector.
	 * @param {Quaternion} quaternion - The rotation as a Quaternion.
	 * @param {Vector3} scale - The scale vector.
	 * @return {Matrix4} A reference to this matrix.
	 */ decompose(position, quaternion, scale) {
        const te = this.elements;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        if (this.determinant() === 0) {
            scale.set(1, 1, 1);
            quaternion.identity();
            return this;
        }
        let sx = _v1$5.set(te[0], te[1], te[2]).length();
        const sy = _v1$5.set(te[4], te[5], te[6]).length();
        const sz = _v1$5.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        // scale the rotation part
        _m1$2.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        _m1$2.elements[0] *= invSX;
        _m1$2.elements[1] *= invSX;
        _m1$2.elements[2] *= invSX;
        _m1$2.elements[4] *= invSY;
        _m1$2.elements[5] *= invSY;
        _m1$2.elements[6] *= invSY;
        _m1$2.elements[8] *= invSZ;
        _m1$2.elements[9] *= invSZ;
        _m1$2.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix(_m1$2);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    /**
	 * Creates a perspective projection matrix. This is used internally by
	 * {@link PerspectiveCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Matrix4} A reference to this matrix.
	 */ makePerspective(left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem, reversedDepth = false) {
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        let c, d;
        if (reversedDepth) {
            c = near / (far - near);
            d = far * near / (far - near);
        } else {
            if (coordinateSystem === WebGLCoordinateSystem) {
                c = -(far + near) / (far - near);
                d = -2 * far * near / (far - near);
            } else if (coordinateSystem === WebGPUCoordinateSystem) {
                c = -far / (far - near);
                d = -far * near / (far - near);
            } else throw new Error('THREE.Matrix4.makePerspective(): Invalid coordinate system: ' + coordinateSystem);
        }
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    /**
	 * Creates a orthographic projection matrix. This is used internally by
	 * {@link OrthographicCamera#updateProjectionMatrix}.

	 * @param {number} left - Left boundary of the viewing frustum at the near plane.
	 * @param {number} right - Right boundary of the viewing frustum at the near plane.
	 * @param {number} top - Top boundary of the viewing frustum at the near plane.
	 * @param {number} bottom - Bottom boundary of the viewing frustum at the near plane.
	 * @param {number} near - The distance from the camera to the near plane.
	 * @param {number} far - The distance from the camera to the far plane.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} [coordinateSystem=WebGLCoordinateSystem] - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Matrix4} A reference to this matrix.
	 */ makeOrthographic(left, right, top, bottom, near, far, coordinateSystem = WebGLCoordinateSystem, reversedDepth = false) {
        const te = this.elements;
        const x = 2 / (right - left);
        const y = 2 / (top - bottom);
        const a = -(right + left) / (right - left);
        const b = -(top + bottom) / (top - bottom);
        let c, d;
        if (reversedDepth) {
            c = 1 / (far - near);
            d = far / (far - near);
        } else {
            if (coordinateSystem === WebGLCoordinateSystem) {
                c = -2 / (far - near);
                d = -(far + near) / (far - near);
            } else if (coordinateSystem === WebGPUCoordinateSystem) {
                c = -1 / (far - near);
                d = -near / (far - near);
            } else throw new Error('THREE.Matrix4.makeOrthographic(): Invalid coordinate system: ' + coordinateSystem);
        }
        te[0] = x;
        te[4] = 0;
        te[8] = 0;
        te[12] = a;
        te[1] = 0;
        te[5] = y;
        te[9] = 0;
        te[13] = b;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    /**
	 * Returns `true` if this matrix is equal with the given one.
	 *
	 * @param {Matrix4} matrix - The matrix to test for equality.
	 * @return {boolean} Whether this matrix is equal with the given one.
	 */ equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix4} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Writes the elements of this matrix to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The matrix elements in column-major order.
	 */ toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const _v1$5 = /*@__PURE__*/ new Vector3();
const _m1$2 = /*@__PURE__*/ new Matrix4();
const _zero = /*@__PURE__*/ new Vector3(0, 0, 0);
const _one = /*@__PURE__*/ new Vector3(1, 1, 1);
const _x = /*@__PURE__*/ new Vector3();
const _y = /*@__PURE__*/ new Vector3();
const _z = /*@__PURE__*/ new Vector3();
const _matrix$2 = /*@__PURE__*/ new Matrix4();
const _quaternion$3 = /*@__PURE__*/ new Quaternion();
/**
 * A class representing Euler angles.
 *
 * Euler angles describe a rotational transformation by rotating an object on
 * its various axes in specified amounts per axis, and a specified axis
 * order.
 *
 * Iterating through an instance will yield its components (x, y, z,
 * order) in the corresponding order.
 *
 * ```js
 * const a = new THREE.Euler( 0, 1, 1.57, 'XYZ' );
 * const b = new THREE.Vector3( 1, 0, 1 );
 * b.applyEuler(a);
 * ```
 */ class Euler {
    /**
	 * Constructs a new euler instance.
	 *
	 * @param {number} [x=0] - The angle of the x axis in radians.
	 * @param {number} [y=0] - The angle of the y axis in radians.
	 * @param {number} [z=0] - The angle of the z axis in radians.
	 * @param {string} [order=Euler.DEFAULT_ORDER] - A string representing the order that the rotations are applied.
	 */ constructor(x = 0, y = 0, z = 0, order = Euler.DEFAULT_ORDER){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEuler = true;
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    /**
	 * The angle of the x axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the y axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    /**
	 * The angle of the z axis in radians.
	 *
	 * @type {number}
	 * @default 0
	 */ get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    /**
	 * A string representing the order that the rotations are applied.
	 *
	 * @type {string}
	 * @default 'XYZ'
	 */ get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    /**
	 * Sets the Euler components.
	 *
	 * @param {number} x - The angle of the x axis in radians.
	 * @param {number} y - The angle of the y axis in radians.
	 * @param {number} z - The angle of the z axis in radians.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ set(x, y, z, order = this._order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Returns a new Euler instance with copied values from this instance.
	 *
	 * @return {Euler} A clone of this instance.
	 */ clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    /**
	 * Copies the values of the given Euler instance to this instance.
	 *
	 * @param {Euler} euler - The Euler instance to copy.
	 * @return {Euler} A reference to this Euler instance.
	 */ copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a pure rotation matrix.
	 *
	 * @param {Matrix4} m - A 4x4 matrix of which the upper 3x3 of matrix is a pure rotation matrix (i.e. unscaled).
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromRotationMatrix(m, order = this._order, update = true) {
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        switch(order){
            case 'XYZ':
                this._y = Math.asin(clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin(clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin(clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                warn('Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update === true) this._onChangeCallback();
        return this;
    }
    /**
	 * Sets the angles of this Euler instance from a normalized quaternion.
	 *
	 * @param {Quaternion} q - A normalized Quaternion.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @param {boolean} [update=true] - Whether the internal `onChange` callback should be executed or not.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromQuaternion(q, order, update) {
        _matrix$2.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix(_matrix$2, order, update);
    }
    /**
	 * Sets the angles of this Euler instance from the given vector.
	 *
	 * @param {Vector3} v - The vector.
	 * @param {string} [order] - A string representing the order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ setFromVector3(v, order = this._order) {
        return this.set(v.x, v.y, v.z, order);
    }
    /**
	 * Resets the euler angle with a new order by creating a quaternion from this
	 * euler angle and then setting this euler angle with the quaternion and the
	 * new order.
	 *
	 * Warning: This discards revolution information.
	 *
	 * @param {string} [newOrder] - A string representing the new order that the rotations are applied.
	 * @return {Euler} A reference to this Euler instance.
	 */ reorder(newOrder) {
        _quaternion$3.setFromEuler(this);
        return this.setFromQuaternion(_quaternion$3, newOrder);
    }
    /**
	 * Returns `true` if this Euler instance is equal with the given one.
	 *
	 * @param {Euler} euler - The Euler instance to test for equality.
	 * @return {boolean} Whether this Euler instance is equal with the given one.
	 */ equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    /**
	 * Sets this Euler instance's components to values from the given array. The first three
	 * entries of the array are assign to the x,y and z components. An optional fourth entry
	 * defines the Euler order.
	 *
	 * @param {Array<number,number,number,?string>} array - An array holding the Euler component values.
	 * @return {Euler} A reference to this Euler instance.
	 */ fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    /**
	 * Writes the components of this Euler instance to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number,number,number,string>} [array=[]] - The target array holding the Euler components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number,number,number,string>} The Euler components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
    *[Symbol.iterator]() {
        yield this._x;
        yield this._y;
        yield this._z;
        yield this._order;
    }
}
/**
 * The default Euler angle order.
 *
 * @static
 * @type {string}
 * @default 'XYZ'
 */ Euler.DEFAULT_ORDER = 'XYZ';
/**
 * A layers object assigns an 3D object to 1 or more of 32
 * layers numbered `0` to `31` - internally the layers are stored as a
 * bit mask], and by default all 3D objects are a member of layer `0`.
 *
 * This can be used to control visibility - an object must share a layer with
 * a camera to be visible when that camera's view is
 * rendered.
 *
 * All classes that inherit from {@link Object3D} have an `layers` property which
 * is an instance of this class.
 */ class Layers {
    /**
	 * Constructs a new layers instance, with membership
	 * initially set to layer `0`.
	 */ constructor(){
        /**
		 * A bit mask storing which of the 32 layers this layers object is currently
		 * a member of.
		 *
		 * @type {number}
		 */ this.mask = 1;
    }
    /**
	 * Sets membership to the given layer, and remove membership all other layers.
	 *
	 * @param {number} layer - The layer to set.
	 */ set(layer) {
        this.mask = (1 << layer | 0) >>> 0;
    }
    /**
	 * Adds membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ enable(layer) {
        this.mask |= 1 << layer | 0;
    }
    /**
	 * Adds membership to all layers.
	 */ enableAll() {
        this.mask = -1;
    }
    /**
	 * Toggles the membership of the given layer.
	 *
	 * @param {number} layer - The layer to toggle.
	 */ toggle(layer) {
        this.mask ^= 1 << layer | 0;
    }
    /**
	 * Removes membership of the given layer.
	 *
	 * @param {number} layer - The layer to enable.
	 */ disable(layer) {
        this.mask &= ~(1 << layer | 0);
    }
    /**
	 * Removes the membership from all layers.
	 */ disableAll() {
        this.mask = 0;
    }
    /**
	 * Returns `true` if this and the given layers object have at least one
	 * layer in common.
	 *
	 * @param {Layers} layers - The layers to test.
	 * @return {boolean } Whether this and the given layers object have at least one layer in common or not.
	 */ test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
    /**
	 * Returns `true` if the given layer is enabled.
	 *
	 * @param {number} layer - The layer to test.
	 * @return {boolean } Whether the given layer is enabled or not.
	 */ isEnabled(layer) {
        return (this.mask & (1 << layer | 0)) !== 0;
    }
}
let _object3DId = 0;
const _v1$4 = /*@__PURE__*/ new Vector3();
const _q1 = /*@__PURE__*/ new Quaternion();
const _m1$1 = /*@__PURE__*/ new Matrix4();
const _target = /*@__PURE__*/ new Vector3();
const _position$3 = /*@__PURE__*/ new Vector3();
const _scale$2 = /*@__PURE__*/ new Vector3();
const _quaternion$2 = /*@__PURE__*/ new Quaternion();
const _xAxis = /*@__PURE__*/ new Vector3(1, 0, 0);
const _yAxis = /*@__PURE__*/ new Vector3(0, 1, 0);
const _zAxis = /*@__PURE__*/ new Vector3(0, 0, 1);
/**
 * Fires when the object has been added to its parent object.
 *
 * @event Object3D#added
 * @type {Object}
 */ const _addedEvent = {
    type: 'added'
};
/**
 * Fires when the object has been removed from its parent object.
 *
 * @event Object3D#removed
 * @type {Object}
 */ const _removedEvent = {
    type: 'removed'
};
/**
 * Fires when a new child object has been added.
 *
 * @event Object3D#childadded
 * @type {Object}
 */ const _childaddedEvent = {
    type: 'childadded',
    child: null
};
/**
 * Fires when a child object has been removed.
 *
 * @event Object3D#childremoved
 * @type {Object}
 */ const _childremovedEvent = {
    type: 'childremoved',
    child: null
};
/**
 * This is the base class for most objects in three.js and provides a set of
 * properties and methods for manipulating objects in 3D space.
 *
 * @augments EventDispatcher
 */ class Object3D extends EventDispatcher {
    /**
	 * Constructs a new 3D object.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isObject3D = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name Object3D#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: _object3DId++
        });
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = generateUUID();
        /**
		 * The name of the 3D object.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Object3D';
        /**
		 * A reference to the parent object.
		 *
		 * @type {?Object3D}
		 * @default null
		 */ this.parent = null;
        /**
		 * An array holding the child 3D objects of this instance.
		 *
		 * @type {Array<Object3D>}
		 */ this.children = [];
        /**
		 * Defines the `up` direction of the 3D object which influences
		 * the orientation via methods like {@link Object3D#lookAt}.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_UP`.
		 *
		 * @type {Vector3}
		 */ this.up = Object3D.DEFAULT_UP.clone();
        const position = new Vector3();
        const rotation = new Euler();
        const quaternion = new Quaternion();
        const scale = new Vector3(1, 1, 1);
        function onRotationChange() {
            quaternion.setFromEuler(rotation, false);
        }
        function onQuaternionChange() {
            rotation.setFromQuaternion(quaternion, undefined, false);
        }
        rotation._onChange(onRotationChange);
        quaternion._onChange(onQuaternionChange);
        Object.defineProperties(this, {
            /**
			 * Represents the object's local position.
			 *
			 * @name Object3D#position
			 * @type {Vector3}
			 * @default (0,0,0)
			 */ position: {
                configurable: true,
                enumerable: true,
                value: position
            },
            /**
			 * Represents the object's local rotation as Euler angles, in radians.
			 *
			 * @name Object3D#rotation
			 * @type {Euler}
			 * @default (0,0,0)
			 */ rotation: {
                configurable: true,
                enumerable: true,
                value: rotation
            },
            /**
			 * Represents the object's local rotation as Quaternions.
			 *
			 * @name Object3D#quaternion
			 * @type {Quaternion}
			 */ quaternion: {
                configurable: true,
                enumerable: true,
                value: quaternion
            },
            /**
			 * Represents the object's local scale.
			 *
			 * @name Object3D#scale
			 * @type {Vector3}
			 * @default (1,1,1)
			 */ scale: {
                configurable: true,
                enumerable: true,
                value: scale
            },
            /**
			 * Represents the object's model-view matrix.
			 *
			 * @name Object3D#modelViewMatrix
			 * @type {Matrix4}
			 */ modelViewMatrix: {
                value: new Matrix4()
            },
            /**
			 * Represents the object's normal matrix.
			 *
			 * @name Object3D#normalMatrix
			 * @type {Matrix3}
			 */ normalMatrix: {
                value: new Matrix3()
            }
        });
        /**
		 * Represents the object's transformation matrix in local space.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new Matrix4();
        /**
		 * Represents the object's transformation matrix in world space.
		 * If the 3D object has no parent, then it's identical to the local transformation matrix
		 *
		 * @type {Matrix4}
		 */ this.matrixWorld = new Matrix4();
        /**
		 * When set to `true`, the engine automatically computes the local matrix from position,
		 * rotation and scale every frame.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE;
        /**
		 * When set to `true`, the engine automatically computes the world matrix from the current local
		 * matrix and the object's transformation hierarchy.
		 *
		 * The default values for all 3D objects is defined by `Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE; // checked by the renderer
        /**
		 * When set to `true`, it calculates the world matrix in that frame and resets this property
		 * to `false`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.matrixWorldNeedsUpdate = false;
        /**
		 * The layer membership of the 3D object. The 3D object is only visible if it has
		 * at least one layer in common with the camera in use. This property can also be
		 * used to filter out unwanted objects in ray-intersection tests when using {@link Raycaster}.
		 *
		 * @type {Layers}
		 */ this.layers = new Layers();
        /**
		 * When set to `true`, the 3D object gets rendered.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * When set to `true`, the 3D object gets rendered into shadow maps.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.castShadow = false;
        /**
		 * When set to `true`, the 3D object is affected by shadows in the scene.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.receiveShadow = false;
        /**
		 * When set to `true`, the 3D object is honored by view frustum culling.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.frustumCulled = true;
        /**
		 * This value allows the default rendering order of scene graph objects to be
		 * overridden although opaque and transparent objects remain sorted independently.
		 * When this property is set for an instance of {@link Group},all descendants
		 * objects will be sorted and rendered together. Sorting is from lowest to highest
		 * render order.
		 *
		 * @type {number}
		 * @default 0
		 */ this.renderOrder = 0;
        /**
		 * An array holding the animation clips of the 3D object.
		 *
		 * @type {Array<AnimationClip>}
		 */ this.animations = [];
        /**
		 * Custom depth material to be used when rendering to the depth map. Can only be used
		 * in context of meshes. When shadow-casting with a {@link DirectionalLight} or {@link SpotLight},
		 * if you are modifying vertex positions in the vertex shader you must specify a custom depth
		 * material for proper shadows.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDepthMaterial = undefined;
        /**
		 * Same as {@link Object3D#customDepthMaterial}, but used with {@link PointLight}.
		 *
		 * Only relevant in context of {@link WebGLRenderer}.
		 *
		 * @type {(Material|undefined)}
		 * @default undefined
		 */ this.customDistanceMaterial = undefined;
        /**
		 * An object that can be used to store custom data about the 3D object. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
    /**
	 * A callback that is executed immediately before a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeShadow() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered to a shadow map.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {Camera} shadowCamera - The shadow camera.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} depthMaterial - The depth material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterShadow() {}
    /**
	 * A callback that is executed immediately before a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * A callback that is executed immediately after a 3D object is rendered.
	 *
	 * @param {Renderer|WebGLRenderer} renderer - The renderer.
	 * @param {Object3D} object - The 3D object.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Material} material - The 3D object's material.
	 * @param {Object} group - The geometry group data.
	 */ onAfterRender() {}
    /**
	 * Applies the given transformation matrix to the object and updates the object's position,
	 * rotation and scale.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 */ applyMatrix4(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    }
    /**
	 * Applies a rotation represented by given the quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The quaternion.
	 * @return {Object3D} A reference to this instance.
	 */ applyQuaternion(q) {
        this.quaternion.premultiply(q);
        return this;
    }
    /**
	 * Sets the given rotation represented as an axis/angle couple to the 3D object.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 */ setRotationFromAxisAngle(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    }
    /**
	 * Sets the given rotation represented as Euler angles to the 3D object.
	 *
	 * @param {Euler} euler - The Euler angles.
	 */ setRotationFromEuler(euler) {
        this.quaternion.setFromEuler(euler, true);
    }
    /**
	 * Sets the given rotation represented as rotation matrix to the 3D object.
	 *
	 * @param {Matrix4} m - Although a 4x4 matrix is expected, the upper 3x3 portion must be
	 * a pure rotation matrix (i.e, unscaled).
	 */ setRotationFromMatrix(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    }
    /**
	 * Sets the given rotation represented as a Quaternion to the 3D object.
	 *
	 * @param {Quaternion} q - The Quaternion
	 */ setRotationFromQuaternion(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    }
    /**
	 * Rotates the 3D object along an axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnAxis(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        _q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply(_q1);
        return this;
    }
    /**
	 * Rotates the 3D object along an axis in world space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateOnWorldAxis(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        _q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply(_q1);
        return this;
    }
    /**
	 * Rotates the 3D object around its X axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateX(angle) {
        return this.rotateOnAxis(_xAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Y axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateY(angle) {
        return this.rotateOnAxis(_yAxis, angle);
    }
    /**
	 * Rotates the 3D object around its Z axis in local space.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {Object3D} A reference to this instance.
	 */ rotateZ(angle) {
        return this.rotateOnAxis(_zAxis, angle);
    }
    /**
	 * Translate the 3D object by a distance along the given axis in local space.
	 *
	 * @param {Vector3} axis - The (normalized) axis vector.
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateOnAxis(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        _v1$4.copy(axis).applyQuaternion(this.quaternion);
        this.position.add(_v1$4.multiplyScalar(distance));
        return this;
    }
    /**
	 * Translate the 3D object by a distance along its X-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateX(distance) {
        return this.translateOnAxis(_xAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Y-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateY(distance) {
        return this.translateOnAxis(_yAxis, distance);
    }
    /**
	 * Translate the 3D object by a distance along its Z-axis in local space.
	 *
	 * @param {number} distance - The distance in world units.
	 * @return {Object3D} A reference to this instance.
	 */ translateZ(distance) {
        return this.translateOnAxis(_zAxis, distance);
    }
    /**
	 * Converts the given vector from this 3D object's local space to world space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ localToWorld(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(this.matrixWorld);
    }
    /**
	 * Converts the given vector from this 3D object's word space to local space.
	 *
	 * @param {Vector3} vector - The vector to convert.
	 * @return {Vector3} The converted vector.
	 */ worldToLocal(vector) {
        this.updateWorldMatrix(true, false);
        return vector.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
    }
    /**
	 * Rotates the object to face a point in world space.
	 *
	 * This method does not support objects having non-uniformly-scaled parent(s).
	 *
	 * @param {number|Vector3} x - The x coordinate in world space. Alternatively, a vector representing a position in world space
	 * @param {number} [y] - The y coordinate in world space.
	 * @param {number} [z] - The z coordinate in world space.
	 */ lookAt(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) _target.copy(x);
        else _target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        _position$3.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) _m1$1.lookAt(_position$3, _target, this.up);
        else _m1$1.lookAt(_target, _position$3, this.up);
        this.quaternion.setFromRotationMatrix(_m1$1);
        if (parent) {
            _m1$1.extractRotation(parent.matrixWorld);
            _q1.setFromRotationMatrix(_m1$1);
            this.quaternion.premultiply(_q1.invert());
        }
    }
    /**
	 * Adds the given 3D object as a child to this 3D object. An arbitrary number of
	 * objects may be added. Any current parent on an object passed in here will be
	 * removed, since an object can have at most one parent.
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to add.
	 * @return {Object3D} A reference to this instance.
	 */ add(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            error('Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            object.removeFromParent();
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent(_addedEvent);
            _childaddedEvent.child = object;
            this.dispatchEvent(_childaddedEvent);
            _childaddedEvent.child = null;
        } else error('Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    }
    /**
	 * Removes the given 3D object as child from this 3D object.
	 * An arbitrary number of objects may be removed.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @param {Object3D} object - The 3D object to remove.
	 * @return {Object3D} A reference to this instance.
	 */ remove(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent(_removedEvent);
            _childremovedEvent.child = object;
            this.dispatchEvent(_childremovedEvent);
            _childremovedEvent.child = null;
        }
        return this;
    }
    /**
	 * Removes this 3D object from its current parent.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ removeFromParent() {
        const parent = this.parent;
        if (parent !== null) parent.remove(this);
        return this;
    }
    /**
	 * Removes all child objects.
	 *
	 * @fires Object3D#removed
	 * @fires Object3D#childremoved
	 * @return {Object3D} A reference to this instance.
	 */ clear() {
        return this.remove(...this.children);
    }
    /**
	 * Adds the given 3D object as a child of this 3D object, while maintaining the object's world
	 * transform. This method does not support scene graphs having non-uniformly-scaled nodes(s).
	 *
	 * @fires Object3D#added
	 * @fires Object3D#childadded
	 * @param {Object3D} object - The 3D object to attach.
	 * @return {Object3D} A reference to this instance.
	 */ attach(object) {
        // adds object as a child of this, while maintaining the object's world transform
        // Note: This method does not support scene graphs having non-uniformly-scaled nodes(s)
        this.updateWorldMatrix(true, false);
        _m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            _m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4(_m1$1);
        object.removeFromParent();
        object.parent = this;
        this.children.push(object);
        object.updateWorldMatrix(false, true);
        object.dispatchEvent(_addedEvent);
        _childaddedEvent.child = object;
        this.dispatchEvent(_childaddedEvent);
        _childaddedEvent.child = null;
        return this;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching ID.
	 *
	 * @param {number} id - The id.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectById(id) {
        return this.getObjectByProperty('id', id);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching name.
	 *
	 * @param {string} name - The name.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByName(name) {
        return this.getObjectByProperty('name', name);
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns the first with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @return {Object3D|undefined} The found 3D object. Returns `undefined` if no 3D object has been found.
	 */ getObjectByProperty(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    }
    /**
	 * Searches through the 3D object and its children, starting with the 3D object
	 * itself, and returns all 3D objects with a matching property value.
	 *
	 * @param {string} name - The name of the property.
	 * @param {any} value - The value.
	 * @param {Array<Object3D>} result - The method stores the result in this array.
	 * @return {Array<Object3D>} The found 3D objects.
	 */ getObjectsByProperty(name, value, result = []) {
        if (this[name] === value) result.push(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].getObjectsByProperty(name, value, result);
        return result;
    }
    /**
	 * Returns a vector representing the position of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's position in world space.
	 */ getWorldPosition(target) {
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    }
    /**
	 * Returns a Quaternion representing the position of the 3D object in world space.
	 *
	 * @param {Quaternion} target - The target Quaternion the result is stored to.
	 * @return {Quaternion} The 3D object's rotation in world space.
	 */ getWorldQuaternion(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose(_position$3, target, _scale$2);
        return target;
    }
    /**
	 * Returns a vector representing the scale of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's scale in world space.
	 */ getWorldScale(target) {
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose(_position$3, _quaternion$2, target);
        return target;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    }
    /**
	 * Abstract method to get intersections between a casted ray and this
	 * 3D object. Renderable 3D objects such as {@link Mesh}, {@link Line} or {@link Points}
	 * implement this method in order to use raycasting.
	 *
	 * @abstract
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - An array holding the result of the method.
	 */ raycast() {}
    /**
	 * Executes the callback on this 3D object and all descendants.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverse(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for visible 3D objects.
	 * Descendants of invisible 3D objects are not traversed.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseVisible(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    }
    /**
	 * Like {@link Object3D#traverse}, but the callback will only be executed for all ancestors.
	 *
	 * Note: Modifying the scene graph inside the callback is discouraged.
	 *
	 * @param {Function} callback - A callback function that allows to process the current 3D object.
	 */ traverseAncestors(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    }
    /**
	 * Updates the transformation matrix in local space by computing it from the current
	 * position, rotation and scale values.
	 */ updateMatrix() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    }
    /**
	 * Updates the transformation matrix in world space of this 3D objects and its descendants.
	 *
	 * To ensure correct results, this method also recomputes the 3D object's transformation matrix in
	 * local space. The computation of the local and world matrix can be controlled with the
	 * {@link Object3D#matrixAutoUpdate} and {@link Object3D#matrixWorldAutoUpdate} flags which are both
	 * `true` by default.  Set these flags to `false` if you need more control over the update matrix process.
	 *
	 * @param {boolean} [force=false] - When set to `true`, a recomputation of world matrices is forced even
	 * when {@link Object3D#matrixWorldAutoUpdate} is set to `false`.
	 */ updateMatrixWorld(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.matrixWorldAutoUpdate === true) {
                if (this.parent === null) this.matrixWorld.copy(this.matrix);
                else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            }
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // make sure descendants are updated if required
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++){
            const child = children[i];
            child.updateMatrixWorld(force);
        }
    }
    /**
	 * An alternative version of {@link Object3D#updateMatrixWorld} with more control over the
	 * update of ancestor and descendant nodes.
	 *
	 * @param {boolean} [updateParents=false] Whether ancestor nodes should be updated or not.
	 * @param {boolean} [updateChildren=false] Whether descendant nodes should be updated or not.
	 */ updateWorldMatrix(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldAutoUpdate === true) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        }
        // make sure descendants are updated
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++){
                const child = children[i];
                child.updateWorldMatrix(false, true);
            }
        }
    }
    /**
	 * Serializes the 3D object into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized 3D object.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {},
                nodes: {}
            };
            output.metadata = {
                version: 4.7,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (Object.keys(this.userData).length > 0) object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        object.up = this.up.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
            if (this.instanceColor !== null) object.instanceColor = this.instanceColor.toJSON();
        }
        if (this.isBatchedMesh) {
            object.type = 'BatchedMesh';
            object.perObjectFrustumCulled = this.perObjectFrustumCulled;
            object.sortObjects = this.sortObjects;
            object.drawRanges = this._drawRanges;
            object.reservedRanges = this._reservedRanges;
            object.geometryInfo = this._geometryInfo.map((info)=>({
                    ...info,
                    boundingBox: info.boundingBox ? info.boundingBox.toJSON() : undefined,
                    boundingSphere: info.boundingSphere ? info.boundingSphere.toJSON() : undefined
                }));
            object.instanceInfo = this._instanceInfo.map((info)=>({
                    ...info
                }));
            object.availableInstanceIds = this._availableInstanceIds.slice();
            object.availableGeometryIds = this._availableGeometryIds.slice();
            object.nextIndexStart = this._nextIndexStart;
            object.nextVertexStart = this._nextVertexStart;
            object.geometryCount = this._geometryCount;
            object.maxInstanceCount = this._maxInstanceCount;
            object.maxVertexCount = this._maxVertexCount;
            object.maxIndexCount = this._maxIndexCount;
            object.geometryInitialized = this._geometryInitialized;
            object.matricesTexture = this._matricesTexture.toJSON(meta);
            object.indirectTexture = this._indirectTexture.toJSON(meta);
            if (this._colorsTexture !== null) object.colorsTexture = this._colorsTexture.toJSON(meta);
            if (this.boundingSphere !== null) object.boundingSphere = this.boundingSphere.toJSON();
            if (this.boundingBox !== null) object.boundingBox = this.boundingBox.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isScene) {
            if (this.background) {
                if (this.background.isColor) object.background = this.background.toJSON();
                else if (this.background.isTexture) object.background = this.background.toJSON(meta).uuid;
            }
            if (this.environment && this.environment.isTexture && this.environment.isRenderTargetTexture !== true) object.environment = this.environment.toJSON(meta).uuid;
        } else if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            const nodes = extractFromCache(meta.nodes);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
            if (nodes.length > 0) output.nodes = nodes;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    }
    /**
	 * Returns a new 3D object with copied values from this instance.
	 *
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are also cloned.
	 * @return {Object3D} A clone of this instance.
	 */ clone(recursive) {
        return new this.constructor().copy(this, recursive);
    }
    /**
	 * Copies the values of the given 3D object to this instance.
	 *
	 * @param {Object3D} source - The 3D object to copy.
	 * @param {boolean} [recursive=true] - When set to `true`, descendants of the 3D object are cloned.
	 * @return {Object3D} A reference to this instance.
	 */ copy(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldAutoUpdate = source.matrixWorldAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.animations = source.animations.slice();
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
}
/**
 * The default up direction for objects, also used as the default
 * position for {@link DirectionalLight} and {@link HemisphereLight}.
 *
 * @static
 * @type {Vector3}
 * @default (0,1,0)
 */ Object3D.DEFAULT_UP = /*@__PURE__*/ new Vector3(0, 1, 0);
/**
 * The default setting for {@link Object3D#matrixAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ Object3D.DEFAULT_MATRIX_AUTO_UPDATE = true;
/**
 * The default setting for {@link Object3D#matrixWorldAutoUpdate} for
 * newly created 3D objects.
 *
 * @static
 * @type {boolean}
 * @default true
 */ Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = true;
const _v0$1 = /*@__PURE__*/ new Vector3();
const _v1$3 = /*@__PURE__*/ new Vector3();
const _v2$2 = /*@__PURE__*/ new Vector3();
const _v3$2 = /*@__PURE__*/ new Vector3();
const _vab = /*@__PURE__*/ new Vector3();
const _vac = /*@__PURE__*/ new Vector3();
const _vbc = /*@__PURE__*/ new Vector3();
const _vap = /*@__PURE__*/ new Vector3();
const _vbp = /*@__PURE__*/ new Vector3();
const _vcp = /*@__PURE__*/ new Vector3();
const _v40 = /*@__PURE__*/ new Vector4();
const _v41 = /*@__PURE__*/ new Vector4();
const _v42 = /*@__PURE__*/ new Vector4();
/**
 * A geometric triangle as defined by three vectors representing its three corners.
 */ class Triangle {
    /**
	 * Constructs a new triangle.
	 *
	 * @param {Vector3} [a=(0,0,0)] - The first corner of the triangle.
	 * @param {Vector3} [b=(0,0,0)] - The second corner of the triangle.
	 * @param {Vector3} [c=(0,0,0)] - The third corner of the triangle.
	 */ constructor(a = new Vector3(), b = new Vector3(), c = new Vector3()){
        /**
		 * The first corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.a = a;
        /**
		 * The second corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.b = b;
        /**
		 * The third corner of the triangle.
		 *
		 * @type {Vector3}
		 */ this.c = c;
    }
    /**
	 * Computes the normal vector of a triangle.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ static getNormal(a, b, c, target) {
        target.subVectors(c, b);
        _v0$1.subVectors(a, b);
        target.cross(_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ static getBarycoord(point, a, b, c, target) {
        // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
        _v0$1.subVectors(c, a);
        _v1$3.subVectors(b, a);
        _v2$2.subVectors(point, a);
        const dot00 = _v0$1.dot(_v0$1);
        const dot01 = _v0$1.dot(_v1$3);
        const dot02 = _v0$1.dot(_v2$2);
        const dot11 = _v1$3.dot(_v1$3);
        const dot12 = _v1$3.dot(_v2$2);
        const denom = dot00 * dot11 - dot01 * dot01;
        // collinear or singular triangle
        if (denom === 0) {
            target.set(0, 0, 0);
            return null;
        }
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ static containsPoint(point, a, b, c) {
        // if the triangle is degenerate then we can't contain a point
        if (this.getBarycoord(point, a, b, c, _v3$2) === null) return false;
        return _v3$2.x >= 0 && _v3$2.y >= 0 && _v3$2.x + _v3$2.y <= 1;
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} p1 - The first corner of the triangle.
	 * @param {Vector3} p2 - The second corner of the triangle.
	 * @param {Vector3} p3 - The third corner of the triangle.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ static getInterpolation(point, p1, p2, p3, v1, v2, v3, target) {
        if (this.getBarycoord(point, p1, p2, p3, _v3$2) === null) {
            target.x = 0;
            target.y = 0;
            if ('z' in target) target.z = 0;
            if ('w' in target) target.w = 0;
            return null;
        }
        target.setScalar(0);
        target.addScaledVector(v1, _v3$2.x);
        target.addScaledVector(v2, _v3$2.y);
        target.addScaledVector(v3, _v3$2.z);
        return target;
    }
    /**
	 * Computes the value barycentrically interpolated for the given attribute and indices.
	 *
	 * @param {BufferAttribute} attr - The attribute to interpolate.
	 * @param {number} i1 - Index of first vertex.
	 * @param {number} i2 - Index of second vertex.
	 * @param {number} i3 - Index of third vertex.
	 * @param {Vector3} barycoord - The barycoordinate value to use to interpolate.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The interpolated attribute value.
	 */ static getInterpolatedAttribute(attr, i1, i2, i3, barycoord, target) {
        _v40.setScalar(0);
        _v41.setScalar(0);
        _v42.setScalar(0);
        _v40.fromBufferAttribute(attr, i1);
        _v41.fromBufferAttribute(attr, i2);
        _v42.fromBufferAttribute(attr, i3);
        target.setScalar(0);
        target.addScaledVector(_v40, barycoord.x);
        target.addScaledVector(_v41, barycoord.y);
        target.addScaledVector(_v42, barycoord.z);
        return target;
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ static isFrontFacing(a, b, c, direction) {
        _v0$1.subVectors(c, b);
        _v1$3.subVectors(a, b);
        // strictly front facing
        return _v0$1.cross(_v1$3).dot(direction) < 0 ? true : false;
    }
    /**
	 * Sets the triangle's vertices by copying the given values.
	 *
	 * @param {Vector3} a - The first corner of the triangle.
	 * @param {Vector3} b - The second corner of the triangle.
	 * @param {Vector3} c - The third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given array values.
	 *
	 * @param {Array<Vector3>} points - An array with 3D points.
	 * @param {number} i0 - The array index representing the first corner of the triangle.
	 * @param {number} i1 - The array index representing the second corner of the triangle.
	 * @param {number} i2 - The array index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    /**
	 * Sets the triangle's vertices by copying the given attribute values.
	 *
	 * @param {BufferAttribute} attribute - A buffer attribute with 3D points data.
	 * @param {number} i0 - The attribute index representing the first corner of the triangle.
	 * @param {number} i1 - The attribute index representing the second corner of the triangle.
	 * @param {number} i2 - The attribute index representing the third corner of the triangle.
	 * @return {Triangle} A reference to this triangle.
	 */ setFromAttributeAndIndices(attribute, i0, i1, i2) {
        this.a.fromBufferAttribute(attribute, i0);
        this.b.fromBufferAttribute(attribute, i1);
        this.c.fromBufferAttribute(attribute, i2);
        return this;
    }
    /**
	 * Returns a new triangle with copied values from this instance.
	 *
	 * @return {Triangle} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given triangle to this instance.
	 *
	 * @param {Triangle} triangle - The triangle to copy.
	 * @return {Triangle} A reference to this triangle.
	 */ copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    /**
	 * Computes the area of the triangle.
	 *
	 * @return {number} The triangle's area.
	 */ getArea() {
        _v0$1.subVectors(this.c, this.b);
        _v1$3.subVectors(this.a, this.b);
        return _v0$1.cross(_v1$3).length() * 0.5;
    }
    /**
	 * Computes the midpoint of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's midpoint.
	 */ getMidpoint(target) {
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    /**
	 * Computes the normal of the triangle.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The triangle's normal.
	 */ getNormal(target) {
        return Triangle.getNormal(this.a, this.b, this.c, target);
    }
    /**
	 * Computes a plane the triangle lies within.
	 *
	 * @param {Plane} target - The target vector that is used to store the method's result.
	 * @return {Plane} The plane the triangle lies within.
	 */ getPlane(target) {
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    /**
	 * Computes a barycentric coordinates from the given vector.
	 * Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - A point in 3D space.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The barycentric coordinates for the given point
	 */ getBarycoord(point, target) {
        return Triangle.getBarycoord(point, this.a, this.b, this.c, target);
    }
    /**
	 * Computes the value barycentrically interpolated for the given point on the
	 * triangle. Returns `null` if the triangle is degenerate.
	 *
	 * @param {Vector3} point - Position of interpolated point.
	 * @param {Vector3} v1 - Value to interpolate of first vertex.
	 * @param {Vector3} v2 - Value to interpolate of second vertex.
	 * @param {Vector3} v3 - Value to interpolate of third vertex.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The interpolated value.
	 */ getInterpolation(point, v1, v2, v3, target) {
        return Triangle.getInterpolation(point, this.a, this.b, this.c, v1, v2, v3, target);
    }
    /**
	 * Returns `true` if the given point, when projected onto the plane of the
	 * triangle, lies within the triangle.
	 *
	 * @param {Vector3} point - The point in 3D space to test.
	 * @return {boolean} Whether the given point, when projected onto the plane of the
	 * triangle, lies within the triangle or not.
	 */ containsPoint(point) {
        return Triangle.containsPoint(point, this.a, this.b, this.c);
    }
    /**
	 * Returns `true` if the triangle is oriented towards the given direction.
	 *
	 * @param {Vector3} direction - The (normalized) direction vector.
	 * @return {boolean} Whether the triangle is oriented towards the given direction or not.
	 */ isFrontFacing(direction) {
        return Triangle.isFrontFacing(this.a, this.b, this.c, direction);
    }
    /**
	 * Returns `true` if this triangle intersects with the given box.
	 *
	 * @param {Box3} box - The box to intersect.
	 * @return {boolean} Whether this triangle intersects with the given box or not.
	 */ intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    /**
	 * Returns the closest point on the triangle to the given point.
	 *
	 * @param {Vector3} p - The point to compute the closest point for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the triangle.
	 */ closestPointToPoint(p, target) {
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        _vab.subVectors(b, a);
        _vac.subVectors(c, a);
        _vap.subVectors(p, a);
        const d1 = _vab.dot(_vap);
        const d2 = _vac.dot(_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        _vbp.subVectors(p, b);
        const d3 = _vab.dot(_vbp);
        const d4 = _vac.dot(_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector(_vab, v);
        }
        _vcp.subVectors(p, c);
        const d5 = _vab.dot(_vcp);
        const d6 = _vac.dot(_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector(_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            _vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector(_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector(_vab, v).addScaledVector(_vac, w);
    }
    /**
	 * Returns `true` if this triangle is equal with the given one.
	 *
	 * @param {Triangle} triangle - The triangle to test for equality.
	 * @return {boolean} Whether this triangle is equal with the given one.
	 */ equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const _colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const _hslA = {
    h: 0,
    s: 0,
    l: 0
};
const _hslB = {
    h: 0,
    s: 0,
    l: 0
};
function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
/**
 * A Color instance is represented by RGB components in the linear <i>working
 * color space</i>, which defaults to `LinearSRGBColorSpace`. Inputs
 * conventionally using `SRGBColorSpace` (such as hexadecimals and CSS
 * strings) are converted to the working color space automatically.
 *
 * ```js
 * // converted automatically from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setHex( 0x112233 );
 * ```
 * Source color spaces may be specified explicitly, to ensure correct conversions.
 * ```js
 * // assumed already LinearSRGBColorSpace; no conversion
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5 );
 *
 * // converted explicitly from SRGBColorSpace to LinearSRGBColorSpace
 * const color = new THREE.Color().setRGB( 0.5, 0.5, 0.5, SRGBColorSpace );
 * ```
 * If THREE.ColorManagement is disabled, no conversions occur. For details,
 * see <i>Color management</i>. Iterating through a Color instance will yield
 * its components (r, g, b) in the corresponding order. A Color can be initialised
 * in any of the following ways:
 * ```js
 * //empty constructor - will default white
 * const color1 = new THREE.Color();
 *
 * //Hexadecimal color (recommended)
 * const color2 = new THREE.Color( 0xff0000 );
 *
 * //RGB string
 * const color3 = new THREE.Color("rgb(255, 0, 0)");
 * const color4 = new THREE.Color("rgb(100%, 0%, 0%)");
 *
 * //X11 color name - all 140 color names are supported.
 * //Note the lack of CamelCase in the name
 * const color5 = new THREE.Color( 'skyblue' );
 * //HSL string
 * const color6 = new THREE.Color("hsl(0, 100%, 50%)");
 *
 * //Separate RGB values between 0 and 1
 * const color7 = new THREE.Color( 1, 0, 0 );
 * ```
 */ class Color {
    /**
	 * Constructs a new color.
	 *
	 * Note that standard method of specifying color in three.js is with a hexadecimal triplet,
	 * and that method is used throughout the rest of the documentation.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 */ constructor(r, g, b){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isColor = true;
        /**
		 * The red component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.r = 1;
        /**
		 * The green component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.g = 1;
        /**
		 * The blue component.
		 *
		 * @type {number}
		 * @default 1
		 */ this.b = 1;
        return this.set(r, g, b);
    }
    /**
	 * Sets the colors's components from the given values.
	 *
	 * @param {(number|string|Color)} [r] - The red component of the color. If `g` and `b` are
	 * not provided, it can be hexadecimal triplet, a CSS-style string or another `Color` instance.
	 * @param {number} [g] - The green component.
	 * @param {number} [b] - The blue component.
	 * @return {Color} A reference to this color.
	 */ set(r, g, b) {
        if (g === undefined && b === undefined) {
            // r is THREE.Color, hex or string
            const value = r;
            if (value && value.isColor) this.copy(value);
            else if (typeof value === 'number') this.setHex(value);
            else if (typeof value === 'string') this.setStyle(value);
        } else this.setRGB(r, g, b);
        return this;
    }
    /**
	 * Sets the colors's components to the given scalar value.
	 *
	 * @param {number} scalar - The scalar value.
	 * @return {Color} A reference to this color.
	 */ setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    /**
	 * Sets this color from a hexadecimal value.
	 *
	 * @param {number} hex - The hexadecimal value.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHex(hex, colorSpace = SRGBColorSpace) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        ColorManagement.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} r - Red channel value between `0.0` and `1.0`.
	 * @param {number} g - Green channel value between `0.0` and `1.0`.
	 * @param {number} b - Blue channel value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setRGB(r, g, b, colorSpace = ColorManagement.workingColorSpace) {
        this.r = r;
        this.g = g;
        this.b = b;
        ColorManagement.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from RGB values.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setHSL(h, s, l, colorSpace = ColorManagement.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        h = euclideanModulo(h, 1);
        s = clamp(s, 0, 1);
        l = clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = hue2rgb(q, p, h + 1 / 3);
            this.g = hue2rgb(q, p, h);
            this.b = hue2rgb(q, p, h - 1 / 3);
        }
        ColorManagement.colorSpaceToWorking(this, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a CSS-style string. For example, `rgb(250, 0,0)`,
	 * `rgb(100%, 0%, 0%)`, `hsl(0, 100%, 50%)`, `#ff0000`, `#f00`, or `red` ( or
	 * any [X11 color name](https://en.wikipedia.org/wiki/X11_color_names#Color_name_chart) -
	 * all 140 color names are supported).
	 *
	 * @param {string} style - Color as a CSS-style string.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setStyle(style, colorSpace = SRGBColorSpace) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) warn('Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^(\w+)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(255, parseInt(color[1], 10)) / 255, Math.min(255, parseInt(color[2], 10)) / 255, Math.min(255, parseInt(color[3], 10)) / 255, colorSpace);
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        handleAlpha(color[4]);
                        return this.setRGB(Math.min(100, parseInt(color[1], 10)) / 100, Math.min(100, parseInt(color[2], 10)) / 100, Math.min(100, parseInt(color[3], 10)) / 100, colorSpace);
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        handleAlpha(color[4]);
                        return this.setHSL(parseFloat(color[1]) / 360, parseFloat(color[2]) / 100, parseFloat(color[3]) / 100, colorSpace);
                    }
                    break;
                default:
                    warn('Color: Unknown color model ' + style);
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) // #ff0
            return this.setRGB(parseInt(hex.charAt(0), 16) / 15, parseInt(hex.charAt(1), 16) / 15, parseInt(hex.charAt(2), 16) / 15, colorSpace);
            else if (size === 6) // #ff0000
            return this.setHex(parseInt(hex, 16), colorSpace);
            else warn('Color: Invalid hex color ' + style);
        } else if (style && style.length > 0) return this.setColorName(style, colorSpace);
        return this;
    }
    /**
	 * Sets this color from a color name. Faster than {@link Color#setStyle} if
	 * you don't need the other CSS-style formats.
	 *
	 * For convenience, the list of names is exposed in `Color.NAMES` as a hash.
	 * ```js
	 * Color.NAMES.aliceblue // returns 0xF0F8FF
	 * ```
	 *
	 * @param {string} style - The color name.
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {Color} A reference to this color.
	 */ setColorName(style, colorSpace = SRGBColorSpace) {
        // color keywords
        const hex = _colorKeywords[style.toLowerCase()];
        if (hex !== undefined) // red
        this.setHex(hex, colorSpace);
        else // unknown color
        warn('Color: Unknown color ' + style);
        return this;
    }
    /**
	 * Returns a new color with copied values from this instance.
	 *
	 * @return {Color} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    /**
	 * Copies the values of the given color to this instance.
	 *
	 * @param {Color} color - The color to copy.
	 * @return {Color} A reference to this color.
	 */ copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copySRGBToLinear(color) {
        this.r = SRGBToLinear(color.r);
        this.g = SRGBToLinear(color.g);
        this.b = SRGBToLinear(color.b);
        return this;
    }
    /**
	 * Copies the given color into this color, and then converts this color from
	 * `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @param {Color} color - The color to copy/convert.
	 * @return {Color} A reference to this color.
	 */ copyLinearToSRGB(color) {
        this.r = LinearToSRGB(color.r);
        this.g = LinearToSRGB(color.g);
        this.b = LinearToSRGB(color.b);
        return this;
    }
    /**
	 * Converts this color from `SRGBColorSpace` to `LinearSRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    /**
	 * Converts this color from `LinearSRGBColorSpace` to `SRGBColorSpace`.
	 *
	 * @return {Color} A reference to this color.
	 */ convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    /**
	 * Returns the hexadecimal value of this color.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {number} The hexadecimal value.
	 */ getHex(colorSpace = SRGBColorSpace) {
        ColorManagement.workingToColorSpace(_color.copy(this), colorSpace);
        return Math.round(clamp(_color.r * 255, 0, 255)) * 65536 + Math.round(clamp(_color.g * 255, 0, 255)) * 256 + Math.round(clamp(_color.b * 255, 0, 255));
    }
    /**
	 * Returns the hexadecimal value of this color as a string (for example, 'FFFFFF').
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The hexadecimal value as a string.
	 */ getHexString(colorSpace = SRGBColorSpace) {
        return ('000000' + this.getHex(colorSpace).toString(16)).slice(-6);
    }
    /**
	 * Converts the colors RGB values into the HSL format and stores them into the
	 * given target object.
	 *
	 * @param {{h:number,s:number,l:number}} target - The target object that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {{h:number,s:number,l:number}} The HSL representation of this color.
	 */ getHSL(target, colorSpace = ColorManagement.workingColorSpace) {
        // h,s,l ranges are in 0.0 - 1.0
        ColorManagement.workingToColorSpace(_color.copy(this), colorSpace);
        const r = _color.r, g = _color.g, b = _color.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    /**
	 * Returns the RGB values of this color and stores them into the given target object.
	 *
	 * @param {Color} target - The target color that is used to store the method's result.
	 * @param {string} [colorSpace=ColorManagement.workingColorSpace] - The color space.
	 * @return {Color} The RGB representation of this color.
	 */ getRGB(target, colorSpace = ColorManagement.workingColorSpace) {
        ColorManagement.workingToColorSpace(_color.copy(this), colorSpace);
        target.r = _color.r;
        target.g = _color.g;
        target.b = _color.b;
        return target;
    }
    /**
	 * Returns the value of this color as a CSS style string. Example: `rgb(255,0,0)`.
	 *
	 * @param {string} [colorSpace=SRGBColorSpace] - The color space.
	 * @return {string} The CSS representation of this color.
	 */ getStyle(colorSpace = SRGBColorSpace) {
        ColorManagement.workingToColorSpace(_color.copy(this), colorSpace);
        const r = _color.r, g = _color.g, b = _color.b;
        if (colorSpace !== SRGBColorSpace) // Requires CSS Color Module Level 4 (https://www.w3.org/TR/css-color-4/).
        return `color(${colorSpace} ${r.toFixed(3)} ${g.toFixed(3)} ${b.toFixed(3)})`;
        return `rgb(${Math.round(r * 255)},${Math.round(g * 255)},${Math.round(b * 255)})`;
    }
    /**
	 * Adds the given HSL values to this color's values.
	 * Internally, this converts the color's RGB values to HSL, adds HSL
	 * and then converts the color back to RGB.
	 *
	 * @param {number} h - Hue value between `0.0` and `1.0`.
	 * @param {number} s - Saturation value between `0.0` and `1.0`.
	 * @param {number} l - Lightness value between `0.0` and `1.0`.
	 * @return {Color} A reference to this color.
	 */ offsetHSL(h, s, l) {
        this.getHSL(_hslA);
        return this.setHSL(_hslA.h + h, _hslA.s + s, _hslA.l + l);
    }
    /**
	 * Adds the RGB values of the given color to the RGB values of this color.
	 *
	 * @param {Color} color - The color to add.
	 * @return {Color} A reference to this color.
	 */ add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    /**
	 * Adds the RGB values of the given colors and stores the result in this instance.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @return {Color} A reference to this color.
	 */ addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    /**
	 * Adds the given scalar value to the RGB values of this color.
	 *
	 * @param {number} s - The scalar to add.
	 * @return {Color} A reference to this color.
	 */ addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    /**
	 * Subtracts the RGB values of the given color from the RGB values of this color.
	 *
	 * @param {Color} color - The color to subtract.
	 * @return {Color} A reference to this color.
	 */ sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    /**
	 * Multiplies the RGB values of the given color with the RGB values of this color.
	 *
	 * @param {Color} color - The color to multiply.
	 * @return {Color} A reference to this color.
	 */ multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    /**
	 * Multiplies the given scalar value with the RGB values of this color.
	 *
	 * @param {number} s - The scalar to multiply.
	 * @return {Color} A reference to this color.
	 */ multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    /**
	 * Linearly interpolates this color's RGB values toward the RGB values of the
	 * given color. The alpha argument can be thought of as the ratio between
	 * the two colors, where `0.0` is this color and `1.0` is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates between the given colors and stores the result in this instance.
	 * The alpha argument can be thought of as the ratio between the two colors, where `0.0`
	 * is the first and `1.0` is the second color.
	 *
	 * @param {Color} color1 - The first color.
	 * @param {Color} color2 - The second color.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    /**
	 * Linearly interpolates this color's HSL values toward the HSL values of the
	 * given color. It differs from {@link Color#lerp} by not interpolating straight
	 * from one color to the other, but instead going through all the hues in between
	 * those two colors. The alpha argument can be thought of as the ratio between
	 * the two colors, where 0.0 is this color and 1.0 is the first argument.
	 *
	 * @param {Color} color - The color to converge on.
	 * @param {number} alpha - The interpolation factor in the closed interval `[0,1]`.
	 * @return {Color} A reference to this color.
	 */ lerpHSL(color, alpha) {
        this.getHSL(_hslA);
        color.getHSL(_hslB);
        const h = lerp(_hslA.h, _hslB.h, alpha);
        const s = lerp(_hslA.s, _hslB.s, alpha);
        const l = lerp(_hslA.l, _hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    /**
	 * Sets the color's RGB components from the given 3D vector.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Color} A reference to this color.
	 */ setFromVector3(v) {
        this.r = v.x;
        this.g = v.y;
        this.b = v.z;
        return this;
    }
    /**
	 * Transforms this color with the given 3x3 matrix.
	 *
	 * @param {Matrix3} m - The matrix.
	 * @return {Color} A reference to this color.
	 */ applyMatrix3(m) {
        const r = this.r, g = this.g, b = this.b;
        const e = m.elements;
        this.r = e[0] * r + e[3] * g + e[6] * b;
        this.g = e[1] * r + e[4] * g + e[7] * b;
        this.b = e[2] * r + e[5] * g + e[8] * b;
        return this;
    }
    /**
	 * Returns `true` if this color is equal with the given one.
	 *
	 * @param {Color} c - The color to test for equality.
	 * @return {boolean} Whether this bounding color is equal with the given one.
	 */ equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    /**
	 * Sets this color's RGB components from the given array.
	 *
	 * @param {Array<number>} array - An array holding the RGB values.
	 * @param {number} [offset=0] - The offset into the array.
	 * @return {Color} A reference to this color.
	 */ fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    /**
	 * Writes the RGB components of this color to the given array. If no array is provided,
	 * the method returns a new instance.
	 *
	 * @param {Array<number>} [array=[]] - The target array holding the color components.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Array<number>} The color components.
	 */ toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    /**
	 * Sets the components of this color from the given buffer attribute.
	 *
	 * @param {BufferAttribute} attribute - The buffer attribute holding color data.
	 * @param {number} index - The index into the attribute.
	 * @return {Color} A reference to this color.
	 */ fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        return this;
    }
    /**
	 * This methods defines the serialization result of this class. Returns the color
	 * as a hexadecimal value.
	 *
	 * @return {number} The hexadecimal value.
	 */ toJSON() {
        return this.getHex();
    }
    *[Symbol.iterator]() {
        yield this.r;
        yield this.g;
        yield this.b;
    }
}
const _color = /*@__PURE__*/ new Color();
/**
 * A dictionary with X11 color names.
 *
 * Note that multiple words such as Dark Orange become the string 'darkorange'.
 *
 * @static
 * @type {Object}
 */ Color.NAMES = _colorKeywords;
let _materialId = 0;
/**
 * Abstract base class for materials.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * @abstract
 * @augments EventDispatcher
 */ class Material extends EventDispatcher {
    /**
	 * Constructs a new material.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMaterial = true;
        /**
		 * The ID of the material.
		 *
		 * @name Material#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: _materialId++
        });
        /**
		 * The UUID of the material.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = generateUUID();
        /**
		 * The name of the material.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Material';
        /**
		 * Defines the blending type of the material.
		 *
		 * It must be set to `CustomBlending` if custom blending properties like
		 * {@link Material#blendSrc}, {@link Material#blendDst} or {@link Material#blendEquation}
		 * should have any effect.
		 *
		 * @type {(NoBlending|NormalBlending|AdditiveBlending|SubtractiveBlending|MultiplyBlending|CustomBlending)}
		 * @default NormalBlending
		 */ this.blending = NormalBlending;
        /**
		 * Defines which side of faces will be rendered - front, back or both.
		 *
		 * @type {(FrontSide|BackSide|DoubleSide)}
		 * @default FrontSide
		 */ this.side = FrontSide;
        /**
		 * If set to `true`, vertex colors should be used.
		 *
		 * The engine supports RGB and RGBA vertex colors depending on whether a three (RGB) or
		 * four (RGBA) component color buffer attribute is used.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.vertexColors = false;
        /**
		 * Defines how transparent the material is.
		 * A value of `0.0` indicates fully transparent, `1.0` is fully opaque.
		 *
		 * If the {@link Material#transparent} is not set to `true`,
		 * the material will remain fully opaque and this value will only affect its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.opacity = 1;
        /**
		 * Defines whether this material is transparent. This has an effect on
		 * rendering as transparent objects need special treatment and are rendered
		 * after non-transparent objects.
		 *
		 * When set to true, the extent to which the material is transparent is
		 * controlled by {@link Material#opacity}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.transparent = false;
        /**
		 * Enables alpha hashed transparency, an alternative to {@link Material#transparent} or
		 * {@link Material#alphaTest}. The material will not be rendered if opacity is lower than
		 * a random threshold. Randomization introduces some grain or noise, but approximates alpha
		 * blending without the associated problems of sorting. Using TAA can reduce the resulting noise.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaHash = false;
        /**
		 * Defines the blending source factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default SrcAlphaFactor
		 */ this.blendSrc = SrcAlphaFactor;
        /**
		 * Defines the blending destination factor.
		 *
		 * @type {(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default OneMinusSrcAlphaFactor
		 */ this.blendDst = OneMinusSrcAlphaFactor;
        /**
		 * Defines the blending equation.
		 *
		 * @type {(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default AddEquation
		 */ this.blendEquation = AddEquation;
        /**
		 * Defines the blending source alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendSrcAlpha = null;
        /**
		 * Defines the blending destination alpha factor.
		 *
		 * @type {?(ZeroFactor|OneFactor|SrcColorFactor|OneMinusSrcColorFactor|SrcAlphaFactor|OneMinusSrcAlphaFactor|DstAlphaFactor|OneMinusDstAlphaFactor|DstColorFactor|OneMinusDstColorFactor|SrcAlphaSaturateFactor|ConstantColorFactor|OneMinusConstantColorFactor|ConstantAlphaFactor|OneMinusConstantAlphaFactor)}
		 * @default null
		 */ this.blendDstAlpha = null;
        /**
		 * Defines the blending equation of the alpha channel.
		 *
		 * @type {?(AddEquation|SubtractEquation|ReverseSubtractEquation|MinEquation|MaxEquation)}
		 * @default null
		 */ this.blendEquationAlpha = null;
        /**
		 * Represents the RGB values of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantColor` or `OneMinusConstantColor`.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.blendColor = new Color(0, 0, 0);
        /**
		 * Represents the alpha value of the constant blend color.
		 *
		 * This property has only an effect when using custom blending with `ConstantAlpha` or `OneMinusConstantAlpha`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.blendAlpha = 0;
        /**
		 * Defines the depth function.
		 *
		 * @type {(NeverDepth|AlwaysDepth|LessDepth|LessEqualDepth|EqualDepth|GreaterEqualDepth|GreaterDepth|NotEqualDepth)}
		 * @default LessEqualDepth
		 */ this.depthFunc = LessEqualDepth;
        /**
		 * Whether to have depth test enabled when rendering this material.
		 * When the depth test is disabled, the depth write will also be implicitly disabled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthTest = true;
        /**
		 * Whether rendering this material has any effect on the depth buffer.
		 *
		 * When drawing 2D overlays it can be useful to disable the depth writing in
		 * order to layer several things together without creating z-index artifacts.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.depthWrite = true;
        /**
		 * The bit mask to use when writing to the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilWriteMask = 0xff;
        /**
		 * The stencil comparison function to use.
		 *
		 * @type {NeverStencilFunc|LessStencilFunc|EqualStencilFunc|LessEqualStencilFunc|GreaterStencilFunc|NotEqualStencilFunc|GreaterEqualStencilFunc|AlwaysStencilFunc}
		 * @default AlwaysStencilFunc
		 */ this.stencilFunc = AlwaysStencilFunc;
        /**
		 * The value to use when performing stencil comparisons or stencil operations.
		 *
		 * @type {number}
		 * @default 0
		 */ this.stencilRef = 0;
        /**
		 * The bit mask to use when comparing against the stencil buffer.
		 *
		 * @type {number}
		 * @default 0xff
		 */ this.stencilFuncMask = 0xff;
        /**
		 * Which stencil operation to perform when the comparison function returns `false`.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilFail = KeepStencilOp;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` but the depth test fails.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZFail = KeepStencilOp;
        /**
		 * Which stencil operation to perform when the comparison function returns
		 * `true` and the depth test passes.
		 *
		 * @type {ZeroStencilOp|KeepStencilOp|ReplaceStencilOp|IncrementStencilOp|DecrementStencilOp|IncrementWrapStencilOp|DecrementWrapStencilOp|InvertStencilOp}
		 * @default KeepStencilOp
		 */ this.stencilZPass = KeepStencilOp;
        /**
		 * Whether stencil operations are performed against the stencil buffer. In
		 * order to perform writes or comparisons against the stencil buffer this
		 * value must be `true`.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.stencilWrite = false;
        /**
		 * User-defined clipping planes specified as THREE.Plane objects in world
		 * space. These planes apply to the objects this material is attached to.
		 * Points in space whose signed distance to the plane is negative are clipped
		 * (not rendered). This requires {@link WebGLRenderer#localClippingEnabled} to
		 * be `true`.
		 *
		 * @type {?Array<Plane>}
		 * @default null
		 */ this.clippingPlanes = null;
        /**
		 * Changes the behavior of clipping planes so that only their intersection is
		 * clipped, rather than their union.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipIntersection = false;
        /**
		 * Defines whether to clip shadows according to the clipping planes specified
		 * on this material.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipShadows = false;
        /**
		 * Defines which side of faces cast shadows. If `null`, the side casting shadows
		 * is determined as follows:
		 *
		 * - When {@link Material#side} is set to `FrontSide`, the back side cast shadows.
		 * - When {@link Material#side} is set to `BackSide`, the front side cast shadows.
		 * - When {@link Material#side} is set to `DoubleSide`, both sides cast shadows.
		 *
		 * @type {?(FrontSide|BackSide|DoubleSide)}
		 * @default null
		 */ this.shadowSide = null;
        /**
		 * Whether to render the material's color.
		 *
		 * This can be used in conjunction with {@link Object3D#renderOder} to create invisible
		 * objects that occlude other objects.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.colorWrite = true;
        /**
		 * Override the renderer's default precision for this material.
		 *
		 * @type {?('highp'|'mediump'|'lowp')}
		 * @default null
		 */ this.precision = null;
        /**
		 * Whether to use polygon offset or not. When enabled, each fragment's depth value will
		 * be offset after it is interpolated from the depth values of the appropriate vertices.
		 * The offset is added before the depth test is performed and before the value is written
		 * into the depth buffer.
		 *
		 * Can be useful for rendering hidden-line images, for applying decals to surfaces, and for
		 * rendering solids with highlighted edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.polygonOffset = false;
        /**
		 * Specifies a scale factor that is used to create a variable depth offset for each polygon.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetFactor = 0;
        /**
		 * Is multiplied by an implementation-specific value to create a constant depth offset.
		 *
		 * @type {number}
		 * @default 0
		 */ this.polygonOffsetUnits = 0;
        /**
		 * Whether to apply dithering to the color to remove the appearance of banding.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.dithering = false;
        /**
		 * Whether alpha to coverage should be enabled or not. Can only be used with MSAA-enabled contexts
		 * (meaning when the renderer was created with *antialias* parameter set to `true`). Enabling this
		 * will smooth aliasing on clip plane edges and alphaTest-clipped edges.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.alphaToCoverage = false;
        /**
		 * Whether to premultiply the alpha (transparency) value.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.premultipliedAlpha = false;
        /**
		 * Whether double-sided, transparent objects should be rendered with a single pass or not.
		 *
		 * The engine renders double-sided, transparent objects with two draw calls (back faces first,
		 * then front faces) to mitigate transparency artifacts. There are scenarios however where this
		 * approach produces no quality gains but still doubles draw calls e.g. when rendering flat
		 * vegetation like grass sprites. In these cases, set the `forceSinglePass` flag to `true` to
		 * disable the two pass rendering to avoid performance issues.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.forceSinglePass = false;
        /**
		 * Whether it's possible to override the material with {@link Scene#overrideMaterial} or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.allowOverride = true;
        /**
		 * Defines whether 3D objects using this material are visible.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.visible = true;
        /**
		 * Defines whether this material is tone mapped according to the renderer's tone mapping setting.
		 *
		 * It is ignored when rendering to a render target or using post processing or when using
		 * `WebGPURenderer`. In all these cases, all materials are honored by tone mapping.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.toneMapped = true;
        /**
		 * An object that can be used to store custom data about the Material. It
		 * should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        /**
		 * This starts at `0` and counts how many times {@link Material#needsUpdate} is set to `true`.
		 *
		 * @type {number}
		 * @readonly
		 * @default 0
		 */ this.version = 0;
        this._alphaTest = 0;
    }
    /**
	 * Sets the alpha value to be used when running an alpha test. The material
	 * will not be rendered if the opacity is lower than this value.
	 *
	 * @type {number}
	 * @readonly
	 * @default 0
	 */ get alphaTest() {
        return this._alphaTest;
    }
    set alphaTest(value) {
        if (this._alphaTest > 0 !== value > 0) this.version++;
        this._alphaTest = value;
    }
    /**
	 * An optional callback that is executed immediately before the material is used to render a 3D object.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Scene} scene - The scene.
	 * @param {Camera} camera - The camera that is used to render the scene.
	 * @param {BufferGeometry} geometry - The 3D object's geometry.
	 * @param {Object3D} object - The 3D object.
	 * @param {Object} group - The geometry group data.
	 */ onBeforeRender() {}
    /**
	 * An optional callback that is executed immediately before the shader
	 * program is compiled. This function is called with the shader source code
	 * as a parameter. Useful for the modification of built-in materials.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}. The
	 * recommended approach when customizing materials is to use `WebGPURenderer` with the new
	 * Node Material system and [TSL](https://github.com/mrdoob/three.js/wiki/Three.js-Shading-Language).
	 *
	 * @param {{vertexShader:string,fragmentShader:string,uniforms:Object}} shaderobject - The object holds the uniforms and the vertex and fragment shader source.
	 * @param {WebGLRenderer} renderer - A reference to the renderer.
	 */ onBeforeCompile() {}
    /**
	 * In case {@link Material#onBeforeCompile} is used, this callback can be used to identify
	 * values of settings used in `onBeforeCompile()`, so three.js can reuse a cached
	 * shader or recompile the shader for this material as needed.
	 *
	 * This method can only be used when rendering with {@link WebGLRenderer}.
	 *
	 * @return {string} The custom program cache key.
	 */ customProgramCacheKey() {
        return this.onBeforeCompile.toString();
    }
    /**
	 * This method can be used to set default values from parameter objects.
	 * It is a generic implementation so it can be used with different types
	 * of materials.
	 *
	 * @param {Object} [values] - The material values to set.
	 */ setValues(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                warn(`Material: parameter '${key}' has value of undefined.`);
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                warn(`Material: '${key}' is not a property of THREE.${this.type}.`);
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    }
    /**
	 * Serializes the material into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized material.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (isRootObject) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.7,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen !== undefined) data.sheen = this.sheen;
        if (this.sheenColor && this.sheenColor.isColor) data.sheenColor = this.sheenColor.getHex();
        if (this.sheenRoughness !== undefined) data.sheenRoughness = this.sheenRoughness;
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity !== undefined && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.specularIntensity !== undefined) data.specularIntensity = this.specularIntensity;
        if (this.specularColor && this.specularColor.isColor) data.specularColor = this.specularColor.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.sheenColorMap && this.sheenColorMap.isTexture) data.sheenColorMap = this.sheenColorMap.toJSON(meta).uuid;
        if (this.sheenRoughnessMap && this.sheenRoughnessMap.isTexture) data.sheenRoughnessMap = this.sheenRoughnessMap.toJSON(meta).uuid;
        if (this.dispersion !== undefined) data.dispersion = this.dispersion;
        if (this.iridescence !== undefined) data.iridescence = this.iridescence;
        if (this.iridescenceIOR !== undefined) data.iridescenceIOR = this.iridescenceIOR;
        if (this.iridescenceThicknessRange !== undefined) data.iridescenceThicknessRange = this.iridescenceThicknessRange;
        if (this.iridescenceMap && this.iridescenceMap.isTexture) data.iridescenceMap = this.iridescenceMap.toJSON(meta).uuid;
        if (this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture) data.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(meta).uuid;
        if (this.anisotropy !== undefined) data.anisotropy = this.anisotropy;
        if (this.anisotropyRotation !== undefined) data.anisotropyRotation = this.anisotropyRotation;
        if (this.anisotropyMap && this.anisotropyMap.isTexture) data.anisotropyMap = this.anisotropyMap.toJSON(meta).uuid;
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) {
            data.lightMap = this.lightMap.toJSON(meta).uuid;
            data.lightMapIntensity = this.lightMapIntensity;
        }
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.specularIntensityMap && this.specularIntensityMap.isTexture) data.specularIntensityMap = this.specularIntensityMap.toJSON(meta).uuid;
        if (this.specularColorMap && this.specularColorMap.isTexture) data.specularColorMap = this.specularColorMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            if (this.combine !== undefined) data.combine = this.combine;
        }
        if (this.envMapRotation !== undefined) data.envMapRotation = this.envMapRotation.toArray();
        if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        if (this.reflectivity !== undefined) data.reflectivity = this.reflectivity;
        if (this.refractionRatio !== undefined) data.refractionRatio = this.refractionRatio;
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.transmission !== undefined) data.transmission = this.transmission;
        if (this.transmissionMap && this.transmissionMap.isTexture) data.transmissionMap = this.transmissionMap.toJSON(meta).uuid;
        if (this.thickness !== undefined) data.thickness = this.thickness;
        if (this.thicknessMap && this.thicknessMap.isTexture) data.thicknessMap = this.thicknessMap.toJSON(meta).uuid;
        if (this.attenuationDistance !== undefined && this.attenuationDistance !== Infinity) data.attenuationDistance = this.attenuationDistance;
        if (this.attenuationColor !== undefined) data.attenuationColor = this.attenuationColor.getHex();
        if (this.size !== undefined) data.size = this.size;
        if (this.shadowSide !== null) data.shadowSide = this.shadowSide;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== NormalBlending) data.blending = this.blending;
        if (this.side !== FrontSide) data.side = this.side;
        if (this.vertexColors === true) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = true;
        if (this.blendSrc !== SrcAlphaFactor) data.blendSrc = this.blendSrc;
        if (this.blendDst !== OneMinusSrcAlphaFactor) data.blendDst = this.blendDst;
        if (this.blendEquation !== AddEquation) data.blendEquation = this.blendEquation;
        if (this.blendSrcAlpha !== null) data.blendSrcAlpha = this.blendSrcAlpha;
        if (this.blendDstAlpha !== null) data.blendDstAlpha = this.blendDstAlpha;
        if (this.blendEquationAlpha !== null) data.blendEquationAlpha = this.blendEquationAlpha;
        if (this.blendColor && this.blendColor.isColor) data.blendColor = this.blendColor.getHex();
        if (this.blendAlpha !== 0) data.blendAlpha = this.blendAlpha;
        if (this.depthFunc !== LessEqualDepth) data.depthFunc = this.depthFunc;
        if (this.depthTest === false) data.depthTest = this.depthTest;
        if (this.depthWrite === false) data.depthWrite = this.depthWrite;
        if (this.colorWrite === false) data.colorWrite = this.colorWrite;
        if (this.stencilWriteMask !== 0xff) data.stencilWriteMask = this.stencilWriteMask;
        if (this.stencilFunc !== AlwaysStencilFunc) data.stencilFunc = this.stencilFunc;
        if (this.stencilRef !== 0) data.stencilRef = this.stencilRef;
        if (this.stencilFuncMask !== 0xff) data.stencilFuncMask = this.stencilFuncMask;
        if (this.stencilFail !== KeepStencilOp) data.stencilFail = this.stencilFail;
        if (this.stencilZFail !== KeepStencilOp) data.stencilZFail = this.stencilZFail;
        if (this.stencilZPass !== KeepStencilOp) data.stencilZPass = this.stencilZPass;
        if (this.stencilWrite === true) data.stencilWrite = this.stencilWrite;
        // rotation (SpriteMaterial)
        if (this.rotation !== undefined && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth !== undefined && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.alphaHash === true) data.alphaHash = true;
        if (this.alphaToCoverage === true) data.alphaToCoverage = true;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = true;
        if (this.forceSinglePass === true) data.forceSinglePass = true;
        if (this.allowOverride === false) data.allowOverride = false;
        if (this.wireframe === true) data.wireframe = true;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.flatShading === true) data.flatShading = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (this.fog === false) data.fog = false;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRootObject) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    }
    /**
	 * Returns a new material with copied values from this instance.
	 *
	 * @return {Material} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given material to this instance.
	 *
	 * @param {Material} source - The material to copy.
	 * @return {Material} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.blending = source.blending;
        this.side = source.side;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.blendColor.copy(source.blendColor);
        this.blendAlpha = source.blendAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.alphaHash = source.alphaHash;
        this.alphaToCoverage = source.alphaToCoverage;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.forceSinglePass = source.forceSinglePass;
        this.allowOverride = source.allowOverride;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Material#dispose
	 */ dispose() {
        /**
		 * Fires when the material has been disposed of.
		 *
		 * @event Material#dispose
		 * @type {Object}
		 */ this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Setting this property to `true` indicates the engine the material
	 * needs to be recompiled.
	 *
	 * @type {boolean}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
}
/**
 * A material for drawing geometries in a simple shaded (flat or wireframe) way.
 *
 * This material is not affected by lights.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshBasicMaterial
 */ class MeshBasicMaterial extends Material {
    /**
	 * Constructs a new mesh basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshBasicMaterial = true;
        this.type = 'MeshBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new Color(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new Euler();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = MultiplyOperation;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
// Fast Half Float Conversions, http://www.fox-toolkit.org/ftp/fasthalffloatconversion.pdf
const _tables = /*@__PURE__*/ _generateTables();
function _generateTables() {
    // float32 to float16 helpers
    const buffer = new ArrayBuffer(4);
    const floatView = new Float32Array(buffer);
    const uint32View = new Uint32Array(buffer);
    const baseTable = new Uint32Array(512);
    const shiftTable = new Uint32Array(512);
    for(let i = 0; i < 256; ++i){
        const e = i - 127;
        // very small number (0, -0)
        if (e < -27) {
            baseTable[i] = 0x0000;
            baseTable[i | 0x100] = 0x8000;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // small number (denorm)
        } else if (e < -14) {
            baseTable[i] = 0x0400 >> -e - 14;
            baseTable[i | 0x100] = 0x0400 >> -e - 14 | 0x8000;
            shiftTable[i] = -e - 1;
            shiftTable[i | 0x100] = -e - 1;
        // normal number
        } else if (e <= 15) {
            baseTable[i] = e + 15 << 10;
            baseTable[i | 0x100] = e + 15 << 10 | 0x8000;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        // large number (Infinity, -Infinity)
        } else if (e < 128) {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 24;
            shiftTable[i | 0x100] = 24;
        // stay (NaN, Infinity, -Infinity)
        } else {
            baseTable[i] = 0x7c00;
            baseTable[i | 0x100] = 0xfc00;
            shiftTable[i] = 13;
            shiftTable[i | 0x100] = 13;
        }
    }
    // float16 to float32 helpers
    const mantissaTable = new Uint32Array(2048);
    const exponentTable = new Uint32Array(64);
    const offsetTable = new Uint32Array(64);
    for(let i = 1; i < 1024; ++i){
        let m = i << 13; // zero pad mantissa bits
        let e = 0; // zero exponent
        // normalized
        while((m & 0x00800000) === 0){
            m <<= 1;
            e -= 0x00800000; // decrement exponent
        }
        m &= -8388609; // clear leading 1 bit
        e += 0x38800000; // adjust bias
        mantissaTable[i] = m | e;
    }
    for(let i = 1024; i < 2048; ++i)mantissaTable[i] = 0x38000000 + (i - 1024 << 13);
    for(let i = 1; i < 31; ++i)exponentTable[i] = i << 23;
    exponentTable[31] = 0x47800000;
    exponentTable[32] = 0x80000000;
    for(let i = 33; i < 63; ++i)exponentTable[i] = 0x80000000 + (i - 32 << 23);
    exponentTable[63] = 0xc7800000;
    for(let i = 1; i < 64; ++i)if (i !== 32) offsetTable[i] = 1024;
    return {
        floatView: floatView,
        uint32View: uint32View,
        baseTable: baseTable,
        shiftTable: shiftTable,
        mantissaTable: mantissaTable,
        exponentTable: exponentTable,
        offsetTable: offsetTable
    };
}
/**
 * Returns a half precision floating point value (FP16) from the given single
 * precision floating point value (FP32).
 *
 * @param {number} val - A single precision floating point value.
 * @return {number} The FP16 value.
 */ function toHalfFloat(val) {
    if (Math.abs(val) > 65504) warn('DataUtils.toHalfFloat(): Value out of range.');
    val = clamp(val, -65504, 65504);
    _tables.floatView[0] = val;
    const f = _tables.uint32View[0];
    const e = f >> 23 & 0x1ff;
    return _tables.baseTable[e] + ((f & 0x007fffff) >> _tables.shiftTable[e]);
}
/**
 * Returns a single precision floating point value (FP32) from the given half
 * precision floating point value (FP16).
 *
 * @param {number} val - A half precision floating point value.
 * @return {number} The FP32 value.
 */ function fromHalfFloat(val) {
    const m = val >> 10;
    _tables.uint32View[0] = _tables.mantissaTable[_tables.offsetTable[m] + (val & 0x3ff)] + _tables.exponentTable[m];
    return _tables.floatView[0];
}
/**
 * A class containing utility functions for data.
 *
 * @hideconstructor
 */ class DataUtils {
    /**
	 * Returns a half precision floating point value (FP16) from the given single
	 * precision floating point value (FP32).
	 *
	 * @param {number} val - A single precision floating point value.
	 * @return {number} The FP16 value.
	 */ static toHalfFloat(val) {
        return toHalfFloat(val);
    }
    /**
	 * Returns a single precision floating point value (FP32) from the given half
	 * precision floating point value (FP16).
	 *
	 * @param {number} val - A half precision floating point value.
	 * @return {number} The FP32 value.
	 */ static fromHalfFloat(val) {
        return fromHalfFloat(val);
    }
}
const _vector$9 = /*@__PURE__*/ new Vector3();
const _vector2$1 = /*@__PURE__*/ new Vector2();
let _id$2 = 0;
/**
 * This class stores data for an attribute (such as vertex positions, face
 * indices, normals, colors, UVs, and any custom attributes ) associated with
 * a geometry, which allows for more efficient passing of data to the GPU.
 *
 * When working with vector-like data, the `fromBufferAttribute( attribute, index )`
 * helper methods on vector and color class might be helpful. E.g. {@link Vector3#fromBufferAttribute}.
 */ class BufferAttribute {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized = false){
        if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferAttribute = true;
        /**
		 * The ID of the buffer attribute.
		 *
		 * @name BufferAttribute#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: _id$2++
        });
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The array holding the attribute data. It should have `itemSize * numVertices`
		 * elements, where `numVertices` is the number of vertices in the associated geometry.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of values of the array that should be associated with a particular vertex.
		 * For instance, if this attribute is storing a 3-component vector (such as a position,
		 * normal, or color), then the value should be `3`.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * Represents the number of items this buffer attribute stores. It is internally computed
		 * by dividing the `array` length by the `itemSize`.
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / itemSize : 0;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `array` is an instance of `UInt16Array`,
		 * and `normalized` is `true`, the values `0 - +65535` in the array data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = StaticDrawUsage;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * Configures the bound GPU type for use in shaders.
		 *
		 * Note: this only has an effect for integer arrays and is not configurable for float arrays.
		 * For lower precision float types, use `Float16BufferAttribute`.
		 *
		 * @type {(FloatType|IntType)}
		 * @default FloatType
		 */ this.gpuType = FloatType;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    /**
	 * A callback function that is executed after the renderer has transferred the attribute
	 * array data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this buffer attribute.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {BufferAttribute} A reference to this buffer attribute.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start,
            count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given buffer attribute to this instance.
	 *
	 * @param {BufferAttribute} source - The buffer attribute to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copy(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        this.gpuType = source.gpuType;
        return this;
    }
    /**
	 * Copies a vector from the given buffer attribute to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this buffer attribute.
	 * @param {BufferAttribute} attribute - The buffer attribute to copy from.
	 * @param {number} index2 - The source index into the given buffer attribute.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyAt(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    }
    /**
	 * Copies the given array data into this buffer attribute.
	 *
	 * @param {(TypedArray|Array)} array - The array to copy.
	 * @return {BufferAttribute} A reference to this instance.
	 */ copyArray(array) {
        this.array.set(array);
        return this;
    }
    /**
	 * Applies the given 3x3 matrix to the given attribute. Works with
	 * item size `2` and `3`.
	 *
	 * @param {Matrix3} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix3(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            _vector2$1.fromBufferAttribute(this, i);
            _vector2$1.applyMatrix3(m);
            this.setXY(i, _vector2$1.x, _vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            _vector$9.fromBufferAttribute(this, i);
            _vector$9.applyMatrix3(m);
            this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.count; i < l; i++){
            _vector$9.fromBufferAttribute(this, i);
            _vector$9.applyMatrix4(m);
            this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            _vector$9.fromBufferAttribute(this, i);
            _vector$9.applyNormalMatrix(m);
            this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {BufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            _vector$9.fromBufferAttribute(this, i);
            _vector$9.transformDirection(m);
            this.setXYZ(i, _vector$9.x, _vector$9.y, _vector$9.z);
        }
        return this;
    }
    /**
	 * Sets the given array data in the buffer attribute.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this buffer attribute's array.
	 * @return {BufferAttribute} A reference to this instance.
	 */ set(value, offset = 0) {
        // Matching BufferAttribute constructor, do not normalize the array.
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.itemSize + component];
        if (this.normalized) value = denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = normalize(value, this.array);
        this.array[index * this.itemSize + component] = value;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.array[index * this.itemSize];
        if (this.normalized) x = denormalize(x, this.array);
        return x;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = normalize(x, this.array);
        this.array[index * this.itemSize] = x;
        return this;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.array[index * this.itemSize + 1];
        if (this.normalized) y = denormalize(y, this.array);
        return y;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = normalize(y, this.array);
        this.array[index * this.itemSize + 1] = y;
        return this;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.array[index * this.itemSize + 2];
        if (this.normalized) z = denormalize(z, this.array);
        return z;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = normalize(z, this.array);
        this.array[index * this.itemSize + 2] = z;
        return this;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.array[index * this.itemSize + 3];
        if (this.normalized) w = denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = normalize(w, this.array);
        this.array[index * this.itemSize + 3] = w;
        return this;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = normalize(x, this.array);
            y = normalize(y, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = normalize(x, this.array);
            y = normalize(y, this.array);
            z = normalize(z, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = normalize(x, this.array);
            y = normalize(y, this.array);
            z = normalize(z, this.array);
            w = normalize(w, this.array);
        }
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the attribute array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when attribute data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {BufferAttribute} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * @return {BufferAttribute} A clone of this instance.
	 */ clone() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON() {
        const data = {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.from(this.array),
            normalized: this.normalized
        };
        if (this.name !== '') data.name = this.name;
        if (this.usage !== StaticDrawUsage) data.usage = this.usage;
        return data;
    }
}
/**
 * Convenient class that can be used when creating a `Int8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class Int8BufferAttribute extends BufferAttribute {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class Uint8BufferAttribute extends BufferAttribute {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt8Clamped` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class Uint8ClampedBufferAttribute extends BufferAttribute {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint8ClampedArray)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint8ClampedArray(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class Int16BufferAttribute extends BufferAttribute {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt16` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class Uint16BufferAttribute extends BufferAttribute {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Int32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class Int32BufferAttribute extends BufferAttribute {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Int32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Int32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `UInt32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class Uint32BufferAttribute extends BufferAttribute {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint32Array(array), itemSize, normalized);
    }
}
/**
 * Convenient class that can be used when creating a `Float16` buffer attribute with
 * a plain `Array` instance.
 *
 * This class automatically converts to and from FP16 via `Uint16Array` since `Float16Array`
 * browser support is still problematic.
 *
 * @augments BufferAttribute
 */ class Float16BufferAttribute extends BufferAttribute {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Uint16Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Uint16Array(array), itemSize, normalized);
        this.isFloat16BufferAttribute = true;
    }
    getX(index) {
        let x = fromHalfFloat(this.array[index * this.itemSize]);
        if (this.normalized) x = denormalize(x, this.array);
        return x;
    }
    setX(index, x) {
        if (this.normalized) x = normalize(x, this.array);
        this.array[index * this.itemSize] = toHalfFloat(x);
        return this;
    }
    getY(index) {
        let y = fromHalfFloat(this.array[index * this.itemSize + 1]);
        if (this.normalized) y = denormalize(y, this.array);
        return y;
    }
    setY(index, y) {
        if (this.normalized) y = normalize(y, this.array);
        this.array[index * this.itemSize + 1] = toHalfFloat(y);
        return this;
    }
    getZ(index) {
        let z = fromHalfFloat(this.array[index * this.itemSize + 2]);
        if (this.normalized) z = denormalize(z, this.array);
        return z;
    }
    setZ(index, z) {
        if (this.normalized) z = normalize(z, this.array);
        this.array[index * this.itemSize + 2] = toHalfFloat(z);
        return this;
    }
    getW(index) {
        let w = fromHalfFloat(this.array[index * this.itemSize + 3]);
        if (this.normalized) w = denormalize(w, this.array);
        return w;
    }
    setW(index, w) {
        if (this.normalized) w = normalize(w, this.array);
        this.array[index * this.itemSize + 3] = toHalfFloat(w);
        return this;
    }
    setXY(index, x, y) {
        index *= this.itemSize;
        if (this.normalized) {
            x = normalize(x, this.array);
            y = normalize(y, this.array);
        }
        this.array[index + 0] = toHalfFloat(x);
        this.array[index + 1] = toHalfFloat(y);
        return this;
    }
    setXYZ(index, x, y, z) {
        index *= this.itemSize;
        if (this.normalized) {
            x = normalize(x, this.array);
            y = normalize(y, this.array);
            z = normalize(z, this.array);
        }
        this.array[index + 0] = toHalfFloat(x);
        this.array[index + 1] = toHalfFloat(y);
        this.array[index + 2] = toHalfFloat(z);
        return this;
    }
    setXYZW(index, x, y, z, w) {
        index *= this.itemSize;
        if (this.normalized) {
            x = normalize(x, this.array);
            y = normalize(y, this.array);
            z = normalize(z, this.array);
            w = normalize(w, this.array);
        }
        this.array[index + 0] = toHalfFloat(x);
        this.array[index + 1] = toHalfFloat(y);
        this.array[index + 2] = toHalfFloat(z);
        this.array[index + 3] = toHalfFloat(w);
        return this;
    }
}
/**
 * Convenient class that can be used when creating a `Float32` buffer attribute with
 * a plain `Array` instance.
 *
 * @augments BufferAttribute
 */ class Float32BufferAttribute extends BufferAttribute {
    /**
	 * Constructs a new buffer attribute.
	 *
	 * @param {(Array<number>|Float32Array)} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(array, itemSize, normalized){
        super(new Float32Array(array), itemSize, normalized);
    }
}
let _id$1 = 0;
const _m1 = /*@__PURE__*/ new Matrix4();
const _obj = /*@__PURE__*/ new Object3D();
const _offset = /*@__PURE__*/ new Vector3();
const _box$2 = /*@__PURE__*/ new Box3();
const _boxMorphTargets = /*@__PURE__*/ new Box3();
const _vector$8 = /*@__PURE__*/ new Vector3();
/**
 * A representation of mesh, line, or point geometry. Includes vertex
 * positions, face indices, normals, colors, UVs, and custom attributes
 * within buffers, reducing the cost of passing all this data to the GPU.
 *
 * ```js
 * const geometry = new THREE.BufferGeometry();
 * // create a simple square shape. We duplicate the top left and bottom right
 * // vertices because each vertex needs to appear once per triangle.
 * const vertices = new Float32Array( [
 * 	-1.0, -1.0,  1.0, // v0
 * 	 1.0, -1.0,  1.0, // v1
 * 	 1.0,  1.0,  1.0, // v2
 *
 * 	 1.0,  1.0,  1.0, // v3
 * 	-1.0,  1.0,  1.0, // v4
 * 	-1.0, -1.0,  1.0  // v5
 * ] );
 * // itemSize = 3 because there are 3 values (components) per vertex
 * geometry.setAttribute( 'position', new THREE.BufferAttribute( vertices, 3 ) );
 * const material = new THREE.MeshBasicMaterial( { color: 0xff0000 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * ```
 *
 * @augments EventDispatcher
 */ class BufferGeometry extends EventDispatcher {
    /**
	 * Constructs a new geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBufferGeometry = true;
        /**
		 * The ID of the geometry.
		 *
		 * @name BufferGeometry#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: _id$1++
        });
        /**
		 * The UUID of the geometry.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = generateUUID();
        /**
		 * The name of the geometry.
		 *
		 * @type {string}
		 */ this.name = '';
        this.type = 'BufferGeometry';
        /**
		 * Allows for vertices to be re-used across multiple triangles; this is
		 * called using "indexed triangles". Each triangle is associated with the
		 * indices of three vertices. This attribute therefore stores the index of
		 * each vertex for each triangular face. If this attribute is not set, the
		 * renderer assumes that each three contiguous positions represent a single triangle.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.index = null;
        /**
		 * A (storage) buffer attribute which was generated with a compute shader and
		 * now defines indirect draw calls.
		 *
		 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
		 *
		 * @type {?BufferAttribute}
		 * @default null
		 */ this.indirect = null;
        /**
		 * The offset, in bytes, into the indirect drawing buffer where the value data begins. If an array is provided, multiple indirect draw calls will be made for each offset.
		 *
		 * Can only be used with {@link WebGPURenderer} and a WebGPU backend.
		 *
		 * @type {number|Array<number>}
		 * @default 0
		 */ this.indirectOffset = 0;
        /**
		 * This dictionary has as id the name of the attribute to be set and as value
		 * the buffer attribute to set it to. Rather than accessing this property directly,
		 * use `setAttribute()` and `getAttribute()` to access attributes of this geometry.
		 *
		 * @type {Object<string,(BufferAttribute|InterleavedBufferAttribute)>}
		 */ this.attributes = {};
        /**
		 * This dictionary holds the morph targets of the geometry.
		 *
		 * Note: Once the geometry has been rendered, the morph attribute data cannot
		 * be changed. You will have to call `dispose()`, and create a new geometry instance.
		 *
		 * @type {Object}
		 */ this.morphAttributes = {};
        /**
		 * Used to control the morph target behavior; when set to `true`, the morph
		 * target data is treated as relative offsets, rather than as absolute
		 * positions/normals.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.morphTargetsRelative = false;
        /**
		 * Split the geometry into groups, each of which will be rendered in a
		 * separate draw call. This allows an array of materials to be used with the geometry.
		 *
		 * Use `addGroup()` and `clearGroups()` to edit groups, rather than modifying this array directly.
		 *
		 * Every vertex and index must belong to exactly one group — groups must not share vertices or
		 * indices, and must not leave vertices or indices unused.
		 *
		 * @type {Array<Object>}
		 */ this.groups = [];
        /**
		 * Bounding box for the geometry which can be calculated with `computeBoundingBox()`.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * Bounding sphere for the geometry which can be calculated with `computeBoundingSphere()`.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Determines the part of the geometry to render. This should not be set directly,
		 * instead use `setDrawRange()`.
		 *
		 * @type {{start:number,count:number}}
		 */ this.drawRange = {
            start: 0,
            count: Infinity
        };
        /**
		 * An object that can be used to store custom data about the geometry.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
    }
    /**
	 * Returns the index of this geometry.
	 *
	 * @return {?BufferAttribute} The index. Returns `null` if no index is defined.
	 */ getIndex() {
        return this.index;
    }
    /**
	 * Sets the given index to this geometry.
	 *
	 * @param {Array<number>|BufferAttribute} index - The index to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndex(index) {
        if (Array.isArray(index)) this.index = new (arrayNeedsUint32(index) ? Uint32BufferAttribute : Uint16BufferAttribute)(index, 1);
        else this.index = index;
        return this;
    }
    /**
	 * Sets the given indirect attribute to this geometry.
	 *
	 * @param {BufferAttribute} indirect - The attribute holding indirect draw calls.
	 * @param {number|Array<number>} [indirectOffset=0] - The offset, in bytes, into the indirect drawing buffer where the value data begins. If an array is provided, multiple indirect draw calls will be made for each offset.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setIndirect(indirect, indirectOffset = 0) {
        this.indirect = indirect;
        this.indirectOffset = indirectOffset;
        return this;
    }
    /**
	 * Returns the indirect attribute of this geometry.
	 *
	 * @return {?BufferAttribute} The indirect attribute. Returns `null` if no indirect attribute is defined.
	 */ getIndirect() {
        return this.indirect;
    }
    /**
	 * Returns the buffer attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {BufferAttribute|InterleavedBufferAttribute|undefined} The buffer attribute.
	 * Returns `undefined` if not attribute has been found.
	 */ getAttribute(name) {
        return this.attributes[name];
    }
    /**
	 * Sets the given attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @param {BufferAttribute|InterleavedBufferAttribute} attribute - The attribute to set.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setAttribute(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    }
    /**
	 * Deletes the attribute for the given name.
	 *
	 * @param {string} name - The attribute name to delete.
	 * @return {BufferGeometry} A reference to this instance.
	 */ deleteAttribute(name) {
        delete this.attributes[name];
        return this;
    }
    /**
	 * Returns `true` if this geometry has an attribute for the given name.
	 *
	 * @param {string} name - The attribute name.
	 * @return {boolean} Whether this geometry has an attribute for the given name or not.
	 */ hasAttribute(name) {
        return this.attributes[name] !== undefined;
    }
    /**
	 * Adds a group to this geometry.
	 *
	 * @param {number} start - The first element in this draw call. That is the first
	 * vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - Specifies how many vertices (or indices) are part of this group.
	 * @param {number} [materialIndex=0] - The material array index to use.
	 */ addGroup(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    }
    /**
	 * Clears all groups.
	 */ clearGroups() {
        this.groups = [];
    }
    /**
	 * Sets the draw range for this geometry.
	 *
	 * @param {number} start - The first vertex for non-indexed geometry, otherwise the first triangle index.
	 * @param {number} count - For non-indexed BufferGeometry, `count` is the number of vertices to render.
	 * For indexed BufferGeometry, `count` is the number of indices to render.
	 */ setDrawRange(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    }
    /**
	 * Applies the given 4x4 transformation matrix to the geometry.
	 *
	 * @param {Matrix4} matrix - The matrix to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyMatrix4(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new Matrix3().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    }
    /**
	 * Applies the rotation represented by the Quaternion to the geometry.
	 *
	 * @param {Quaternion} q - The Quaternion to apply.
	 * @return {BufferGeometry} A reference to this instance.
	 */ applyQuaternion(q) {
        _m1.makeRotationFromQuaternion(q);
        this.applyMatrix4(_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the X axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateX(angle) {
        // rotate geometry around world x-axis
        _m1.makeRotationX(angle);
        this.applyMatrix4(_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Y axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateY(angle) {
        // rotate geometry around world y-axis
        _m1.makeRotationY(angle);
        this.applyMatrix4(_m1);
        return this;
    }
    /**
	 * Rotates the geometry about the Z axis. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#rotation} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} angle - The angle in radians.
	 * @return {BufferGeometry} A reference to this instance.
	 */ rotateZ(angle) {
        // rotate geometry around world z-axis
        _m1.makeRotationZ(angle);
        this.applyMatrix4(_m1);
        return this;
    }
    /**
	 * Translates the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#position} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x offset.
	 * @param {number} y - The y offset.
	 * @param {number} z - The z offset.
	 * @return {BufferGeometry} A reference to this instance.
	 */ translate(x, y, z) {
        // translate geometry
        _m1.makeTranslation(x, y, z);
        this.applyMatrix4(_m1);
        return this;
    }
    /**
	 * Scales the geometry. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#scale} for typical
	 * real-time mesh rotation.
	 *
	 * @param {number} x - The x scale.
	 * @param {number} y - The y scale.
	 * @param {number} z - The z scale.
	 * @return {BufferGeometry} A reference to this instance.
	 */ scale(x, y, z) {
        // scale geometry
        _m1.makeScale(x, y, z);
        this.applyMatrix4(_m1);
        return this;
    }
    /**
	 * Rotates the geometry to face a point in 3D space. This is typically done as a one time
	 * operation, and not during a loop. Use {@link Object3D#lookAt} for typical
	 * real-time mesh rotation.
	 *
	 * @param {Vector3} vector - The target point.
	 * @return {BufferGeometry} A reference to this instance.
	 */ lookAt(vector) {
        _obj.lookAt(vector);
        _obj.updateMatrix();
        this.applyMatrix4(_obj.matrix);
        return this;
    }
    /**
	 * Center the geometry based on its bounding box.
	 *
	 * @return {BufferGeometry} A reference to this instance.
	 */ center() {
        this.computeBoundingBox();
        this.boundingBox.getCenter(_offset).negate();
        this.translate(_offset.x, _offset.y, _offset.z);
        return this;
    }
    /**
	 * Defines a geometry by creating a `position` attribute based on the given array of points. The array
	 * can hold 2D or 3D vectors. When using two-dimensional data, the `z` coordinate for all vertices is
	 * set to `0`.
	 *
	 * If the method is used with an existing `position` attribute, the vertex data are overwritten with the
	 * data from the array. The length of the array must match the vertex count.
	 *
	 * @param {Array<Vector2>|Array<Vector3>} points - The points.
	 * @return {BufferGeometry} A reference to this instance.
	 */ setFromPoints(points) {
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute === undefined) {
            const position = [];
            for(let i = 0, l = points.length; i < l; i++){
                const point = points[i];
                position.push(point.x, point.y, point.z || 0);
            }
            this.setAttribute('position', new Float32BufferAttribute(position, 3));
        } else {
            const l = Math.min(points.length, positionAttribute.count); // make sure data do not exceed buffer size
            for(let i = 0; i < l; i++){
                const point = points[i];
                positionAttribute.setXYZ(i, point.x, point.y, point.z || 0);
            }
            if (points.length > positionAttribute.count) warn('BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry.');
            positionAttribute.needsUpdate = true;
        }
        return this;
    }
    /**
	 * Computes the bounding box of the geometry, and updates the `boundingBox` member.
	 * The bounding box is not computed by the engine; it must be computed by your app.
	 * You may need to recompute the bounding box if the geometry vertices are modified.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new Box3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            error('BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.', this);
            this.boundingBox.set(new Vector3(-Infinity, -Infinity, -Infinity), new Vector3(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                _box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    _vector$8.addVectors(this.boundingBox.min, _box$2.min);
                    this.boundingBox.expandByPoint(_vector$8);
                    _vector$8.addVectors(this.boundingBox.max, _box$2.max);
                    this.boundingBox.expandByPoint(_vector$8);
                } else {
                    this.boundingBox.expandByPoint(_box$2.min);
                    this.boundingBox.expandByPoint(_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) error('BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    }
    /**
	 * Computes the bounding sphere of the geometry, and updates the `boundingSphere` member.
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if the geometry vertices are modified.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new Sphere();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            error('BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.', this);
            this.boundingSphere.set(new Vector3(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            _box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                _boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    _vector$8.addVectors(_box$2.min, _boxMorphTargets.min);
                    _box$2.expandByPoint(_vector$8);
                    _vector$8.addVectors(_box$2.max, _boxMorphTargets.max);
                    _box$2.expandByPoint(_vector$8);
                } else {
                    _box$2.expandByPoint(_boxMorphTargets.min);
                    _box$2.expandByPoint(_boxMorphTargets.max);
                }
            }
            _box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                _vector$8.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    _vector$8.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        _offset.fromBufferAttribute(position, j);
                        _vector$8.add(_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$8));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) error('BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    }
    /**
	 * Calculates and adds a tangent attribute to this geometry.
	 *
	 * The computation is only supported for indexed geometries and if position, normal, and uv attributes
	 * are defined. When using a tangent space normal map, prefer the MikkTSpace algorithm provided by
	 * {@link BufferGeometryUtils#computeMikkTSpaceTangents} instead.
	 */ computeTangents() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            error('BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const positionAttribute = attributes.position;
        const normalAttribute = attributes.normal;
        const uvAttribute = attributes.uv;
        if (this.hasAttribute('tangent') === false) this.setAttribute('tangent', new BufferAttribute(new Float32Array(4 * positionAttribute.count), 4));
        const tangentAttribute = this.getAttribute('tangent');
        const tan1 = [], tan2 = [];
        for(let i = 0; i < positionAttribute.count; i++){
            tan1[i] = new Vector3();
            tan2[i] = new Vector3();
        }
        const vA = new Vector3(), vB = new Vector3(), vC = new Vector3(), uvA = new Vector2(), uvB = new Vector2(), uvC = new Vector2(), sdir = new Vector3(), tdir = new Vector3();
        function handleTriangle(a, b, c) {
            vA.fromBufferAttribute(positionAttribute, a);
            vB.fromBufferAttribute(positionAttribute, b);
            vC.fromBufferAttribute(positionAttribute, c);
            uvA.fromBufferAttribute(uvAttribute, a);
            uvB.fromBufferAttribute(uvAttribute, b);
            uvC.fromBufferAttribute(uvAttribute, c);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: index.count
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(index.getX(j + 0), index.getX(j + 1), index.getX(j + 2));
        }
        const tmp = new Vector3(), tmp2 = new Vector3();
        const n = new Vector3(), n2 = new Vector3();
        function handleVertex(v) {
            n.fromBufferAttribute(normalAttribute, v);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangentAttribute.setXYZW(v, tmp.x, tmp.y, tmp.z, w);
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(index.getX(j + 0));
                handleVertex(index.getX(j + 1));
                handleVertex(index.getX(j + 2));
            }
        }
    }
    /**
	 * Computes vertex normals for the given vertex data. For indexed geometries, the method sets
	 * each vertex normal to be the average of the face normals of the faces that share that vertex.
	 * For non-indexed geometries, vertices are not shared, and the method sets each vertex normal
	 * to be the same as the face normal.
	 */ computeVertexNormals() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new BufferAttribute(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
            const nA = new Vector3(), nB = new Vector3(), nC = new Vector3();
            const cb = new Vector3(), ab = new Vector3();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    }
    /**
	 * Ensures every normal vector in a geometry will have a magnitude of `1`. This will
	 * correct lighting on the geometry surfaces.
	 */ normalizeNormals() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            _vector$8.fromBufferAttribute(normals, i);
            _vector$8.normalize();
            normals.setXYZ(i, _vector$8.x, _vector$8.y, _vector$8.z);
        }
    }
    /**
	 * Return a new non-index version of this indexed geometry. If the geometry
	 * is already non-indexed, the method is a NOOP.
	 *
	 * @return {BufferGeometry} The non-indexed version of this indexed geometry.
	 */ toNonIndexed() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                if (attribute.isInterleavedBufferAttribute) index = indices[i] * attribute.data.stride + attribute.offset;
                else index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new BufferAttribute(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            warn('BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new BufferGeometry();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    }
    /**
	 * Serializes the geometry into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized geometry.
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        // for simplicity the code assumes attributes are not shared across geometries, see #15811
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            data.data.attributes[key] = attribute.toJSON(data.data);
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                array.push(attribute.toJSON(data.data));
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = boundingSphere.toJSON();
        return data;
    }
    /**
	 * Returns a new geometry with copied values from this instance.
	 *
	 * @return {BufferGeometry} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given geometry to this instance.
	 *
	 * @param {BufferGeometry} source - The geometry to copy.
	 * @return {BufferGeometry} A reference to this instance.
	 */ copy(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone());
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires BufferGeometry#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
const _inverseMatrix$3 = /*@__PURE__*/ new Matrix4();
const _ray$3 = /*@__PURE__*/ new Ray();
const _sphere$6 = /*@__PURE__*/ new Sphere();
const _sphereHitAt = /*@__PURE__*/ new Vector3();
const _vA$1 = /*@__PURE__*/ new Vector3();
const _vB$1 = /*@__PURE__*/ new Vector3();
const _vC$1 = /*@__PURE__*/ new Vector3();
const _tempA = /*@__PURE__*/ new Vector3();
const _morphA = /*@__PURE__*/ new Vector3();
const _intersectionPoint = /*@__PURE__*/ new Vector3();
const _intersectionPointWorld = /*@__PURE__*/ new Vector3();
/**
 * Class representing triangular polygon mesh based objects.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments Object3D
 */ class Mesh extends Object3D {
    /**
	 * Constructs a new mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry = new BufferGeometry(), material = new MeshBasicMaterial()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMesh = true;
        this.type = 'Mesh';
        /**
		 * The mesh geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The mesh material.
		 *
		 * @type {Material|Array<Material>}
		 * @default MeshBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<string,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        /**
		 * The number of instances of this mesh.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.count = 1;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Sets the values of {@link Mesh#morphTargetDictionary} and {@link Mesh#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
    /**
	 * Returns the local-space position of the vertex at the given index, taking into
	 * account the current animation state of both morph targets and skinning.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * @return {Vector3} The vertex position in local space.
	 */ getVertexPosition(index, target) {
        const geometry = this.geometry;
        const position = geometry.attributes.position;
        const morphPosition = geometry.morphAttributes.position;
        const morphTargetsRelative = geometry.morphTargetsRelative;
        target.fromBufferAttribute(position, index);
        const morphInfluences = this.morphTargetInfluences;
        if (morphPosition && morphInfluences) {
            _morphA.set(0, 0, 0);
            for(let i = 0, il = morphPosition.length; i < il; i++){
                const influence = morphInfluences[i];
                const morphAttribute = morphPosition[i];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morphAttribute, index);
                if (morphTargetsRelative) _morphA.addScaledVector(_tempA, influence);
                else _morphA.addScaledVector(_tempA.sub(target), influence);
            }
            target.add(_morphA);
        }
        return target;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere$6.copy(geometry.boundingSphere);
        _sphere$6.applyMatrix4(matrixWorld);
        // check distance from ray origin to bounding sphere
        _ray$3.copy(raycaster.ray).recast(raycaster.near);
        if (_sphere$6.containsPoint(_ray$3.origin) === false) {
            if (_ray$3.intersectSphere(_sphere$6, _sphereHitAt) === null) return;
            if (_ray$3.origin.distanceToSquared(_sphereHitAt) > (raycaster.far - raycaster.near) ** 2) return;
        }
        // convert ray to local space of mesh
        _inverseMatrix$3.copy(matrixWorld).invert();
        _ray$3.copy(raycaster.ray).applyMatrix4(_inverseMatrix$3);
        // test with bounding box in local space
        if (geometry.boundingBox !== null) {
            if (_ray$3.intersectsBox(geometry.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, _ray$3);
    }
    _computeIntersections(raycaster, intersects, rayLocalSpace) {
        let intersection;
        const geometry = this.geometry;
        const material = this.material;
        const index = geometry.index;
        const position = geometry.attributes.position;
        const uv = geometry.attributes.uv;
        const uv1 = geometry.attributes.uv1;
        const normal = geometry.attributes.normal;
        const groups = geometry.groups;
        const drawRange = geometry.drawRange;
        if (index !== null) {
            // indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(index.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = index.getX(j);
                    const b = index.getX(j + 1);
                    const c = index.getX(j + 2);
                    intersection = checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(index.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = index.getX(i);
                    const b = index.getX(i + 1);
                    const c = index.getX(i + 2);
                    intersection = checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        } else if (position !== undefined) {
            // non-indexed buffer geometry
            if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                const group = groups[i];
                const groupMaterial = material[group.materialIndex];
                const start = Math.max(group.start, drawRange.start);
                const end = Math.min(position.count, Math.min(group.start + group.count, drawRange.start + drawRange.count));
                for(let j = start, jl = end; j < jl; j += 3){
                    const a = j;
                    const b = j + 1;
                    const c = j + 2;
                    intersection = checkGeometryIntersection(this, groupMaterial, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                        intersection.face.materialIndex = group.materialIndex;
                        intersects.push(intersection);
                    }
                }
            }
            else {
                const start = Math.max(0, drawRange.start);
                const end = Math.min(position.count, drawRange.start + drawRange.count);
                for(let i = start, il = end; i < il; i += 3){
                    const a = i;
                    const b = i + 1;
                    const c = i + 2;
                    intersection = checkGeometryIntersection(this, material, raycaster, rayLocalSpace, uv, uv1, normal, a, b, c);
                    if (intersection) {
                        intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                        intersects.push(intersection);
                    }
                }
            }
        }
    }
}
function checkIntersection$1(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === BackSide) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side === FrontSide, point);
    if (intersect === null) return null;
    _intersectionPointWorld.copy(point);
    _intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo(_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: _intersectionPointWorld.clone(),
        object: object
    };
}
function checkGeometryIntersection(object, material, raycaster, ray, uv, uv1, normal, a, b, c) {
    object.getVertexPosition(a, _vA$1);
    object.getVertexPosition(b, _vB$1);
    object.getVertexPosition(c, _vC$1);
    const intersection = checkIntersection$1(object, material, raycaster, ray, _vA$1, _vB$1, _vC$1, _intersectionPoint);
    if (intersection) {
        const barycoord = new Vector3();
        Triangle.getBarycoord(_intersectionPoint, _vA$1, _vB$1, _vC$1, barycoord);
        if (uv) intersection.uv = Triangle.getInterpolatedAttribute(uv, a, b, c, barycoord, new Vector2());
        if (uv1) intersection.uv1 = Triangle.getInterpolatedAttribute(uv1, a, b, c, barycoord, new Vector2());
        if (normal) {
            intersection.normal = Triangle.getInterpolatedAttribute(normal, a, b, c, barycoord, new Vector3());
            if (intersection.normal.dot(ray.direction) > 0) intersection.normal.multiplyScalar(-1);
        }
        const face = {
            a: a,
            b: b,
            c: c,
            normal: new Vector3(),
            materialIndex: 0
        };
        Triangle.getNormal(_vA$1, _vB$1, _vC$1, face.normal);
        intersection.face = face;
        intersection.barycoord = barycoord;
    }
    return intersection;
}
/**
 * A geometry class for a rectangular cuboid with a given width, height, and depth.
 * On creation, the cuboid is centred on the origin, with each edge parallel to one
 * of the axes.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry( 1, 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const cube = new THREE.Mesh( geometry, material );
 * scene.add( cube );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#BoxGeometry
 */ class BoxGeometry extends BufferGeometry {
    /**
	 * Constructs a new box geometry.
	 *
	 * @param {number} [width=1] - The width. That is, the length of the edges parallel to the X axis.
	 * @param {number} [height=1] - The height. That is, the length of the edges parallel to the Y axis.
	 * @param {number} [depth=1] - The depth. That is, the length of the edges parallel to the Z axis.
	 * @param {number} [widthSegments=1] - Number of segmented rectangular faces along the width of the sides.
	 * @param {number} [heightSegments=1] - Number of segmented rectangular faces along the height of the sides.
	 * @param {number} [depthSegments=1] - Number of segmented rectangular faces along the depth of the sides.
	 */ constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new Vector3();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {BoxGeometry} A new instance.
	 */ static fromJSON(data) {
        return new BoxGeometry(data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
    }
}
/**
 * Provides utility functions for managing uniforms.
 *
 * @module UniformsUtils
 */ /**
 * Clones the given uniform definitions by performing a deep-copy. That means
 * if the value of a uniform refers to an object like a Vector3 or Texture,
 * the cloned uniform will refer to a new object reference.
 *
 * @param {Object} src - An object representing uniform definitions.
 * @return {Object} The cloned uniforms.
 */ function cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture || property.isQuaternion)) {
                if (property.isRenderTargetTexture) {
                    warn('UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms().');
                    dst[u][p] = null;
                } else dst[u][p] = property.clone();
            } else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
/**
 * Merges the given uniform definitions into a single object. Since the
 * method internally uses cloneUniforms(), it performs a deep-copy when
 * producing the merged uniform definitions.
 *
 * @param {Array} uniforms - An array of objects containing uniform definitions.
 * @return {Object} The merged uniforms.
 */ function mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
function cloneUniformsGroups(src) {
    const dst = [];
    for(let u = 0; u < src.length; u++)dst.push(src[u].clone());
    return dst;
}
function getUnlitUniformColorSpace(renderer) {
    const currentRenderTarget = renderer.getRenderTarget();
    if (currentRenderTarget === null) // https://github.com/mrdoob/three.js/pull/23937#issuecomment-1111067398
    return renderer.outputColorSpace;
    // https://github.com/mrdoob/three.js/issues/27868
    if (currentRenderTarget.isXRRenderTarget === true) return currentRenderTarget.texture.colorSpace;
    return ColorManagement.workingColorSpace;
}
// Legacy
const UniformsUtils = {
    clone: cloneUniforms,
    merge: mergeUniforms
};
var default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * A material rendered with custom shaders. A shader is a small program written in GLSL.
 * that runs on the GPU. You may want to use a custom shader if you need to implement an
 * effect not included with any of the built-in materials.
 *
 * There are the following notes to bear in mind when using a `ShaderMaterial`:
 *
 * - `ShaderMaterial` can only be used with {@link WebGLRenderer}.
 * - Built in attributes and uniforms are passed to the shaders along with your code. If
 * you don't want that, use {@link RawShaderMaterial} instead.
 * - You can use the directive `#pragma unroll_loop_start` and `#pragma unroll_loop_end`
 * in order to unroll a `for` loop in GLSL by the shader preprocessor. The directive has
 * to be placed right above the loop. The loop formatting has to correspond to a defined standard.
 *   - The loop has to be [normalized](https://en.wikipedia.org/wiki/Normalized_loop).
 *   - The loop variable has to be *i*.
 *   - The value `UNROLLED_LOOP_INDEX` will be replaced with the explicitly
 * value of *i* for the given iteration and can be used in preprocessor
 * statements.
 *
 * ```js
 * const material = new THREE.ShaderMaterial( {
 * 	uniforms: {
 * 		time: { value: 1.0 },
 * 		resolution: { value: new THREE.Vector2() }
 * 	},
 * 	vertexShader: document.getElementById( 'vertexShader' ).textContent,
 * 	fragmentShader: document.getElementById( 'fragmentShader' ).textContent
 * } );
 * ```
 *
 * @augments Material
 */ class ShaderMaterial extends Material {
    /**
	 * Constructs a new shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShaderMaterial = true;
        this.type = 'ShaderMaterial';
        /**
		 * Defines custom constants using `#define` directives within the GLSL code
		 * for both the vertex shader and the fragment shader; each key/value pair
		 * yields another directive.
		 * ```js
		 * defines: {
		 * 	FOO: 15,
		 * 	BAR: true
		 * }
		 * ```
		 * Yields the lines:
		 * ```
		 * #define FOO 15
		 * #define BAR true
		 * ```
		 *
		 * @type {Object}
		 */ this.defines = {};
        /**
		 * An object of the form:
		 * ```js
		 * {
		 * 	"uniform1": { value: 1.0 },
		 * 	"uniform2": { value: 2 }
		 * }
		 * ```
		 * specifying the uniforms to be passed to the shader code; keys are uniform
		 * names, values are definitions of the form
		 * ```
		 * {
		 * 	value: 1.0
		 * }
		 * ```
		 * where `value` is the value of the uniform. Names must match the name of
		 * the uniform, as defined in the GLSL code. Note that uniforms are refreshed
		 * on every frame, so updating the value of the uniform will immediately
		 * update the value available to the GLSL code.
		 *
		 * @type {Object}
		 */ this.uniforms = {};
        /**
		 * An array holding uniforms groups for configuring UBOs.
		 *
		 * @type {Array<UniformsGroup>}
		 */ this.uniformsGroups = [];
        /**
		 * Vertex shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.vertexShader = default_vertex;
        /**
		 * Fragment shader GLSL code. This is the actual code for the shader.
		 *
		 * @type {string}
		 */ this.fragmentShader = default_fragment;
        /**
		 * Controls line thickness or lines.
		 *
		 * WebGL and WebGPU ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines whether the material color is affected by global fog settings; `true`
		 * to pass fog uniforms to the shader.
		 *
		 * Setting this property to `true` requires the definition of fog uniforms. It is
		 * recommended to use `UniformsUtils.merge()` to combine the custom shader uniforms
		 * with predefined fog uniforms.
		 *
		 * ```js
		 * const material = new ShaderMaterial( {
		 *     uniforms: UniformsUtils.merge( [ UniformsLib[ 'fog' ], shaderUniforms ] );
		 *     vertexShader: vertexShader,
		 *     fragmentShader: fragmentShader,
		 *     fog: true
		 * } );
		 * ```
		 *
		 * @type {boolean}
		 * @default false
		 */ this.fog = false;
        /**
		 * Defines whether this material uses lighting; `true` to pass uniform data
		 * related to lighting to this shader.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.lights = false;
        /**
		 * Defines whether this material supports clipping; `true` to let the renderer
		 * pass the clippingPlanes uniform.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clipping = false;
        /**
		 * Overwritten and set to `true` by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.forceSinglePass = true;
        /**
		 * This object allows to enable certain WebGL 2 extensions.
		 *
		 * - clipCullDistance: set to `true` to use vertex shader clipping
		 * - multiDraw: set to `true` to use vertex shader multi_draw / enable gl_DrawID
		 *
		 * @type {{clipCullDistance:false,multiDraw:false}}
		 */ this.extensions = {
            clipCullDistance: false,
            multiDraw: false // set to use vertex shader multi_draw / enable gl_DrawID
        };
        /**
		 * When the rendered geometry doesn't include these attributes but the
		 * material does, these default values will be passed to the shaders. This
		 * avoids errors when buffer data is missing.
		 *
		 * - color: [ 1, 1, 1 ]
		 * - uv: [ 0, 0 ]
		 * - uv1: [ 0, 0 ]
		 *
		 * @type {Object}
		 */ this.defaultAttributeValues = {
            'color': [
                1,
                1,
                1
            ],
            'uv': [
                0,
                0
            ],
            'uv1': [
                0,
                0
            ]
        };
        /**
		 * If set, this calls [gl.bindAttribLocation](https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/bindAttribLocation)
		 * to bind a generic vertex index to an attribute variable.
		 *
		 * @type {string|undefined}
		 * @default undefined
		 */ this.index0AttributeName = undefined;
        /**
		 * Can be used to force a uniform update while changing uniforms in
		 * {@link Object3D#onBeforeRender}.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.uniformsNeedUpdate = false;
        /**
		 * Defines the GLSL version of custom shader code.
		 *
		 * @type {?(GLSL1|GLSL3)}
		 * @default null
		 */ this.glslVersion = null;
        if (parameters !== undefined) this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.fragmentShader = source.fragmentShader;
        this.vertexShader = source.vertexShader;
        this.uniforms = cloneUniforms(source.uniforms);
        this.uniformsGroups = cloneUniformsGroups(source.uniformsGroups);
        this.defines = Object.assign({}, source.defines);
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.fog = source.fog;
        this.lights = source.lights;
        this.clipping = source.clipping;
        this.extensions = Object.assign({}, source.extensions);
        this.glslVersion = source.glslVersion;
        this.defaultAttributeValues = Object.assign({}, source.defaultAttributeValues);
        this.index0AttributeName = source.index0AttributeName;
        this.uniformsNeedUpdate = source.uniformsNeedUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.glslVersion = this.glslVersion;
        data.uniforms = {};
        for(const name in this.uniforms){
            const uniform = this.uniforms[name];
            const value = uniform.value;
            if (value && value.isTexture) data.uniforms[name] = {
                type: 't',
                value: value.toJSON(meta).uuid
            };
            else if (value && value.isColor) data.uniforms[name] = {
                type: 'c',
                value: value.getHex()
            };
            else if (value && value.isVector2) data.uniforms[name] = {
                type: 'v2',
                value: value.toArray()
            };
            else if (value && value.isVector3) data.uniforms[name] = {
                type: 'v3',
                value: value.toArray()
            };
            else if (value && value.isVector4) data.uniforms[name] = {
                type: 'v4',
                value: value.toArray()
            };
            else if (value && value.isMatrix3) data.uniforms[name] = {
                type: 'm3',
                value: value.toArray()
            };
            else if (value && value.isMatrix4) data.uniforms[name] = {
                type: 'm4',
                value: value.toArray()
            };
            else data.uniforms[name] = {
                value: value
            };
        }
        if (Object.keys(this.defines).length > 0) data.defines = this.defines;
        data.vertexShader = this.vertexShader;
        data.fragmentShader = this.fragmentShader;
        data.lights = this.lights;
        data.clipping = this.clipping;
        const extensions = {};
        for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
        if (Object.keys(extensions).length > 0) data.extensions = extensions;
        return data;
    }
}
/**
 * Abstract base class for cameras. This class should always be inherited
 * when you build a new camera.
 *
 * @abstract
 * @augments Object3D
 */ class Camera extends Object3D {
    /**
	 * Constructs a new camera.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCamera = true;
        this.type = 'Camera';
        /**
		 * The inverse of the camera's world matrix.
		 *
		 * @type {Matrix4}
		 */ this.matrixWorldInverse = new Matrix4();
        /**
		 * The camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrix = new Matrix4();
        /**
		 * The inverse of the camera's projection matrix.
		 *
		 * @type {Matrix4}
		 */ this.projectionMatrixInverse = new Matrix4();
        /**
		 * The coordinate system in which the camera is used.
		 *
		 * @type {(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 */ this.coordinateSystem = WebGLCoordinateSystem;
        this._reversedDepth = false;
    }
    /**
	 * The flag that indicates whether the camera uses a reversed depth buffer.
	 *
	 * @type {boolean}
	 * @default false
	 */ get reversedDepth() {
        return this._reversedDepth;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        this.coordinateSystem = source.coordinateSystem;
        return this;
    }
    /**
	 * Returns a vector representing the ("look") direction of the 3D object in world space.
	 *
	 * This method is overwritten since cameras have a different forward vector compared to other
	 * 3D objects. A camera looks down its local, negative z-axis by default.
	 *
	 * @param {Vector3} target - The target vector the result is stored to.
	 * @return {Vector3} The 3D object's direction in world space.
	 */ getWorldDirection(target) {
        return super.getWorldDirection(target).negate();
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    updateWorldMatrix(updateParents, updateChildren) {
        super.updateWorldMatrix(updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    }
    clone() {
        return new this.constructor().copy(this);
    }
}
const _v3$1 = /*@__PURE__*/ new Vector3();
const _minTarget = /*@__PURE__*/ new Vector2();
const _maxTarget = /*@__PURE__*/ new Vector2();
/**
 * Camera that uses [perspective projection](https://en.wikipedia.org/wiki/Perspective_(graphical)).
 *
 * This projection mode is designed to mimic the way the human eye sees. It
 * is the most common projection mode used for rendering a 3D scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 45, width / height, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class PerspectiveCamera extends Camera {
    /**
	 * Constructs a new perspective camera.
	 *
	 * @param {number} [fov=50] - The vertical field of view.
	 * @param {number} [aspect=1] - The aspect ratio.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(fov = 50, aspect = 1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPerspectiveCamera = true;
        this.type = 'PerspectiveCamera';
        /**
		 * The vertical field of view, from bottom to top of view,
		 * in degrees.
		 *
		 * @type {number}
		 * @default 50
		 */ this.fov = fov;
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link PerspectiveCamera#far}.
		 *
		 * Note that, unlike for the {@link OrthographicCamera}, `0` is <em>not</em> a
		 * valid value for a perspective camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link PerspectiveCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        /**
		 * Object distance used for stereoscopy and depth-of-field effects. This
		 * parameter does not influence the projection matrix unless a
		 * {@link StereoCamera} is being used.
		 *
		 * @type {number}
		 * @default 10
		 */ this.focus = 10;
        /**
		 * The aspect ratio, usually the canvas width / canvas height.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = aspect;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * Film size used for the larger axis. Default is `35` (millimeters). This
		 * parameter does not influence the projection matrix unless {@link PerspectiveCamera#filmOffset}
		 * is set to a nonzero value.
		 *
		 * @type {number}
		 * @default 35
		 */ this.filmGauge = 35;
        /**
		 * Horizontal off-center offset in the same unit as {@link PerspectiveCamera#filmGauge}.
		 *
		 * @type {number}
		 * @default 0
		 */ this.filmOffset = 0;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    }
    /**
	 * Sets the FOV by focal length in respect to the current {@link PerspectiveCamera#filmGauge}.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * @param {number} focalLength - Values for focal length and film gauge must have the same unit.
	 */ setFocalLength(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    }
    /**
	 * Returns the focal length from the current {@link PerspectiveCamera#fov} and
	 * {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The computed focal length.
	 */ getFocalLength() {
        const vExtentSlope = Math.tan(DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    }
    /**
	 * Returns the current vertical field of view angle in degrees considering {@link PerspectiveCamera#zoom}.
	 *
	 * @return {number} The effective FOV.
	 */ getEffectiveFOV() {
        return RAD2DEG * 2 * Math.atan(Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom);
    }
    /**
	 * Returns the width of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmWidth() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    }
    /**
	 * Returns the height of the image on the film. If {@link PerspectiveCamera#aspect} is greater than or
	 * equal to one (landscape format), the result equals {@link PerspectiveCamera#filmGauge}.
	 *
	 * @return {number} The film width.
	 */ getFilmHeight() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    }
    /**
	 * Computes the 2D bounds of the camera's viewable rectangle at a given distance along the viewing direction.
	 * Sets `minTarget` and `maxTarget` to the coordinates of the lower-left and upper-right corners of the view rectangle.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} minTarget - The lower-left corner of the view rectangle is written into this vector.
	 * @param {Vector2} maxTarget - The upper-right corner of the view rectangle is written into this vector.
	 */ getViewBounds(distance, minTarget, maxTarget) {
        _v3$1.set(-1, -1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        minTarget.set(_v3$1.x, _v3$1.y).multiplyScalar(-distance / _v3$1.z);
        _v3$1.set(1, 1, 0.5).applyMatrix4(this.projectionMatrixInverse);
        maxTarget.set(_v3$1.x, _v3$1.y).multiplyScalar(-distance / _v3$1.z);
    }
    /**
	 * Computes the width and height of the camera's viewable rectangle at a given distance along the viewing direction.
	 *
	 * @param {number} distance - The viewing distance.
	 * @param {Vector2} target - The target vector that is used to store result where x is width and y is height.
	 * @returns {Vector2} The view size.
	 */ getViewSize(distance, target) {
        this.getViewBounds(distance, _minTarget, _maxTarget);
        return target.subVectors(_maxTarget, _minTarget);
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *```
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *```
	 * then for each monitor you would call it like this:
	 *```js
	 * const w = 1920;
	 * const h = 1080;
	 * const fullWidth = w * 3;
	 * const fullHeight = h * 2;
	 *
	 * // --A--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 * // --B--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 * // --C--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 * // --D--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 * // --E--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 * // --F--
	 * camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 * ```
	 *
	 * Note there is no reason monitors have to be the same size or in a grid.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const near = this.near;
        let top = near * Math.tan(DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far, this.coordinateSystem, this.reversedDepth);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
}
const fov = -90; // negative fov is not an error
const aspect = 1;
/**
 * A special type of camera that is positioned in 3D space to render its surroundings into a
 * cube render target. The render target can then be used as an environment map for rendering
 * realtime reflections in your scene.
 *
 * ```js
 * // Create cube render target
 * const cubeRenderTarget = new THREE.WebGLCubeRenderTarget( 256, { generateMipmaps: true, minFilter: THREE.LinearMipmapLinearFilter } );
 *
 * // Create cube camera
 * const cubeCamera = new THREE.CubeCamera( 1, 100000, cubeRenderTarget );
 * scene.add( cubeCamera );
 *
 * // Create car
 * const chromeMaterial = new THREE.MeshLambertMaterial( { color: 0xffffff, envMap: cubeRenderTarget.texture } );
 * const car = new THREE.Mesh( carGeometry, chromeMaterial );
 * scene.add( car );
 *
 * // Update the render target cube
 * car.visible = false;
 * cubeCamera.position.copy( car.position );
 * cubeCamera.update( renderer, scene );
 *
 * // Render the scene
 * car.visible = true;
 * renderer.render( scene, camera );
 * ```
 *
 * @augments Object3D
 */ class CubeCamera extends Object3D {
    /**
	 * Constructs a new cube camera.
	 *
	 * @param {number} near - The camera's near plane.
	 * @param {number} far - The camera's far plane.
	 * @param {WebGLCubeRenderTarget} renderTarget - The cube render target.
	 */ constructor(near, far, renderTarget){
        super();
        this.type = 'CubeCamera';
        /**
		 * A reference to the cube render target.
		 *
		 * @type {WebGLCubeRenderTarget}
		 */ this.renderTarget = renderTarget;
        /**
		 * The current active coordinate system.
		 *
		 * @type {?(WebGLCoordinateSystem|WebGPUCoordinateSystem)}
		 * @default null
		 */ this.coordinateSystem = null;
        /**
		 * The current active mipmap level
		 *
		 * @type {number}
		 * @default 0
		 */ this.activeMipmapLevel = 0;
        const cameraPX = new PerspectiveCamera(fov, aspect, near, far);
        cameraPX.layers = this.layers;
        this.add(cameraPX);
        const cameraNX = new PerspectiveCamera(fov, aspect, near, far);
        cameraNX.layers = this.layers;
        this.add(cameraNX);
        const cameraPY = new PerspectiveCamera(fov, aspect, near, far);
        cameraPY.layers = this.layers;
        this.add(cameraPY);
        const cameraNY = new PerspectiveCamera(fov, aspect, near, far);
        cameraNY.layers = this.layers;
        this.add(cameraNY);
        const cameraPZ = new PerspectiveCamera(fov, aspect, near, far);
        cameraPZ.layers = this.layers;
        this.add(cameraPZ);
        const cameraNZ = new PerspectiveCamera(fov, aspect, near, far);
        cameraNZ.layers = this.layers;
        this.add(cameraNZ);
    }
    /**
	 * Must be called when the coordinate system of the cube camera is changed.
	 */ updateCoordinateSystem() {
        const coordinateSystem = this.coordinateSystem;
        const cameras = this.children.concat();
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = cameras;
        for (const camera of cameras)this.remove(camera);
        if (coordinateSystem === WebGLCoordinateSystem) {
            cameraPX.up.set(0, 1, 0);
            cameraPX.lookAt(1, 0, 0);
            cameraNX.up.set(0, 1, 0);
            cameraNX.lookAt(-1, 0, 0);
            cameraPY.up.set(0, 0, -1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, 1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, 1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, 1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else if (coordinateSystem === WebGPUCoordinateSystem) {
            cameraPX.up.set(0, -1, 0);
            cameraPX.lookAt(-1, 0, 0);
            cameraNX.up.set(0, -1, 0);
            cameraNX.lookAt(1, 0, 0);
            cameraPY.up.set(0, 0, 1);
            cameraPY.lookAt(0, 1, 0);
            cameraNY.up.set(0, 0, -1);
            cameraNY.lookAt(0, -1, 0);
            cameraPZ.up.set(0, -1, 0);
            cameraPZ.lookAt(0, 0, 1);
            cameraNZ.up.set(0, -1, 0);
            cameraNZ.lookAt(0, 0, -1);
        } else throw new Error('THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: ' + coordinateSystem);
        for (const camera of cameras){
            this.add(camera);
            camera.updateMatrixWorld();
        }
    }
    /**
	 * Calling this method will render the given scene with the given renderer
	 * into the cube render target of the camera.
	 *
	 * @param {(Renderer|WebGLRenderer)} renderer - The renderer.
	 * @param {Scene} scene - The scene to render.
	 */ update(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const { renderTarget, activeMipmapLevel } = this;
        if (this.coordinateSystem !== renderer.coordinateSystem) {
            this.coordinateSystem = renderer.coordinateSystem;
            this.updateCoordinateSystem();
        }
        const [cameraPX, cameraNX, cameraPY, cameraNY, cameraPZ, cameraNZ] = this.children;
        const currentRenderTarget = renderer.getRenderTarget();
        const currentActiveCubeFace = renderer.getActiveCubeFace();
        const currentActiveMipmapLevel = renderer.getActiveMipmapLevel();
        const currentXrEnabled = renderer.xr.enabled;
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0, activeMipmapLevel);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1, activeMipmapLevel);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2, activeMipmapLevel);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3, activeMipmapLevel);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4, activeMipmapLevel);
        renderer.render(scene, cameraPZ);
        // mipmaps are generated during the last call of render()
        // at this point, all sides of the cube render target are defined
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5, activeMipmapLevel);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget, currentActiveCubeFace, currentActiveMipmapLevel);
        renderer.xr.enabled = currentXrEnabled;
        renderTarget.texture.needsPMREMUpdate = true;
    }
}
/**
 * Creates a cube texture made up of six images.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader();
 * loader.setPath( 'textures/cube/pisa/' );
 *
 * const textureCube = loader.load( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xffffff, envMap: textureCube } );
 * ```
 *
 * @augments Texture
 */ class CubeTexture extends Texture {
    /**
	 * Constructs a new cube texture.
	 *
	 * @param {Array<Image>} [images=[]] - An array holding a image for each side of a cube.
	 * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space value.
	 */ constructor(images = [], mapping = CubeReflectionMapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace){
        super(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
    }
    /**
	 * Alias for {@link CubeTexture#image}.
	 *
	 * @type {Array<Image>}
	 */ get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
/**
 * A cube render target used in context of {@link WebGLRenderer}.
 *
 * @augments WebGLRenderTarget
 */ class WebGLCubeRenderTarget extends WebGLRenderTarget {
    /**
	 * Constructs a new cube render target.
	 *
	 * @param {number} [size=1] - The size of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(size = 1, options = {}){
        super(size, size, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isWebGLCubeRenderTarget = true;
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {DataArrayTexture}
		 */ this.texture = new CubeTexture(images);
        this._setTextureOptions(options);
        // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
        // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
        // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
        // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
        // and the flag isRenderTargetTexture controls this conversion. The flip is not required when using WebGLCubeRenderTarget.texture
        // as a cube texture (this is detected when isRenderTargetTexture is set to true for cube textures).
        this.texture.isRenderTargetTexture = true;
    }
    /**
	 * Converts the given equirectangular texture to a cube map.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {Texture} texture - The equirectangular texture.
	 * @return {WebGLCubeRenderTarget} A reference to this cube render target.
	 */ fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.colorSpace = texture.colorSpace;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new BoxGeometry(5, 5, 5);
        const material = new ShaderMaterial({
            name: 'CubemapFromEquirect',
            uniforms: cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: BackSide,
            blending: NoBlending
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new Mesh(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === LinearMipmapLinearFilter) texture.minFilter = LinearFilter;
        const camera = new CubeCamera(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    /**
	 * Clears this cube render target.
	 *
	 * @param {WebGLRenderer} renderer - The renderer.
	 * @param {boolean} [color=true] - Whether the color buffer should be cleared or not.
	 * @param {boolean} [depth=true] - Whether the depth buffer should be cleared or not.
	 * @param {boolean} [stencil=true] - Whether the stencil buffer should be cleared or not.
	 */ clear(renderer, color = true, depth = true, stencil = true) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
/**
 * This is almost identical to an {@link Object3D}. Its purpose is to
 * make working with groups of objects syntactically clearer.
 *
 * ```js
 * // Create a group and add the two cubes.
 * // These cubes can now be rotated / scaled etc as a group.
 * const group = new THREE.Group();
 *
 * group.add( meshA );
 * group.add( meshB );
 *
 * scene.add( group );
 * ```
 *
 * @augments Object3D
 */ class Group extends Object3D {
    constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGroup = true;
        this.type = 'Group';
    }
}
const _moveEvent = {
    type: 'move'
};
/**
 * Class for representing a XR controller with its
 * different coordinate systems.
 *
 * @private
 */ class WebXRController {
    /**
	 * Constructs a new XR controller.
	 */ constructor(){
        /**
		 * A group representing the target ray space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._targetRay = null;
        /**
		 * A group representing the grip space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._grip = null;
        /**
		 * A group representing the hand space
		 * of the XR controller.
		 *
		 * @private
		 * @type {?Group}
		 * @default null
		 */ this._hand = null;
    }
    /**
	 * Returns a group representing the hand space of the XR controller.
	 *
	 * @return {Group} A group representing the hand space of the XR controller.
	 */ getHandSpace() {
        if (this._hand === null) {
            this._hand = new Group();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    }
    /**
	 * Returns a group representing the target ray space of the XR controller.
	 *
	 * @return {Group} A group representing the target ray space of the XR controller.
	 */ getTargetRaySpace() {
        if (this._targetRay === null) {
            this._targetRay = new Group();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
            this._targetRay.hasLinearVelocity = false;
            this._targetRay.linearVelocity = new Vector3();
            this._targetRay.hasAngularVelocity = false;
            this._targetRay.angularVelocity = new Vector3();
        }
        return this._targetRay;
    }
    /**
	 * Returns a group representing the grip space of the XR controller.
	 *
	 * @return {Group} A group representing the grip space of the XR controller.
	 */ getGripSpace() {
        if (this._grip === null) {
            this._grip = new Group();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
            this._grip.hasLinearVelocity = false;
            this._grip.linearVelocity = new Vector3();
            this._grip.hasAngularVelocity = false;
            this._grip.angularVelocity = new Vector3();
        }
        return this._grip;
    }
    /**
	 * Dispatches the given event to the groups representing
	 * the different coordinate spaces of the XR controller.
	 *
	 * @param {Object} event - The event to dispatch.
	 * @return {WebXRController} A reference to this instance.
	 */ dispatchEvent(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    }
    /**
	 * Connects the controller with the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ connect(inputSource) {
        if (inputSource && inputSource.hand) {
            const hand = this._hand;
            if (hand) for (const inputjoint of inputSource.hand.values())// Initialize hand with joints when connected
            this._getHandJoint(hand, inputjoint);
        }
        this.dispatchEvent({
            type: 'connected',
            data: inputSource
        });
        return this;
    }
    /**
	 * Disconnects the controller from the given XR input source.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @return {WebXRController} A reference to this instance.
	 */ disconnect(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    }
    /**
	 * Updates the controller with the given input source, XR frame and reference space.
	 * This updates the transformations of the groups that represent the different
	 * coordinate systems of the controller.
	 *
	 * @param {XRInputSource} inputSource - The input source.
	 * @param {XRFrame} frame - The XR frame.
	 * @param {XRReferenceSpace} referenceSpace - The reference space.
	 * @return {WebXRController} A reference to this instance.
	 */ update(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    // The transform of this joint will be updated with the joint pose on each frame
                    const joint = this._getHandJoint(hand, inputjoint);
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.matrixWorldNeedsUpdate = true;
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else if (grip !== null && inputSource.gripSpace) {
                gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                if (gripPose !== null) {
                    grip.matrix.fromArray(gripPose.transform.matrix);
                    grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    grip.matrixWorldNeedsUpdate = true;
                    if (gripPose.linearVelocity) {
                        grip.hasLinearVelocity = true;
                        grip.linearVelocity.copy(gripPose.linearVelocity);
                    } else grip.hasLinearVelocity = false;
                    if (gripPose.angularVelocity) {
                        grip.hasAngularVelocity = true;
                        grip.angularVelocity.copy(gripPose.angularVelocity);
                    } else grip.hasAngularVelocity = false;
                }
            }
            if (targetRay !== null) {
                inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                // Some runtimes (namely Vive Cosmos with Vive OpenXR Runtime) have only grip space and ray space is equal to it
                if (inputPose === null && gripPose !== null) inputPose = gripPose;
                if (inputPose !== null) {
                    targetRay.matrix.fromArray(inputPose.transform.matrix);
                    targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    targetRay.matrixWorldNeedsUpdate = true;
                    if (inputPose.linearVelocity) {
                        targetRay.hasLinearVelocity = true;
                        targetRay.linearVelocity.copy(inputPose.linearVelocity);
                    } else targetRay.hasLinearVelocity = false;
                    if (inputPose.angularVelocity) {
                        targetRay.hasAngularVelocity = true;
                        targetRay.angularVelocity.copy(inputPose.angularVelocity);
                    } else targetRay.hasAngularVelocity = false;
                    this.dispatchEvent(_moveEvent);
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
    /**
	 * Returns a group representing the hand joint for the given input joint.
	 *
	 * @private
	 * @param {Group} hand - The group representing the hand space.
	 * @param {XRJointSpace} inputjoint - The hand joint data.
	 * @return {Group} A group representing the hand joint for the given input joint.
	 */ _getHandJoint(hand, inputjoint) {
        if (hand.joints[inputjoint.jointName] === undefined) {
            const joint = new Group();
            joint.matrixAutoUpdate = false;
            joint.visible = false;
            hand.joints[inputjoint.jointName] = joint;
            hand.add(joint);
        }
        return hand.joints[inputjoint.jointName];
    }
}
/**
 * This class can be used to define an exponential squared fog,
 * which gives a clear view near the camera and a faster than exponentially
 * densening fog farther from the camera.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.FogExp2( 0xcccccc, 0.002 );
 * ```
 */ class FogExp2 {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [density=0.00025] - Defines how fast the fog will grow dense.
	 */ constructor(color, density = 0.00025){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFogExp2 = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new Color(color);
        /**
		 *  Defines how fast the fog will grow dense.
		 *
		 * @type {number}
		 * @default 0.00025
		 */ this.density = density;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {FogExp2} A clone of this instance.
	 */ clone() {
        return new FogExp2(this.color, this.density);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'FogExp2',
            name: this.name,
            color: this.color.getHex(),
            density: this.density
        };
    }
}
/**
 * This class can be used to define a linear fog that grows linearly denser
 * with the distance.
 *
 * ```js
 * const scene = new THREE.Scene();
 * scene.fog = new THREE.Fog( 0xcccccc, 10, 15 );
 * ```
 */ class Fog {
    /**
	 * Constructs a new fog.
	 *
	 * @param {number|Color} color - The fog's color.
	 * @param {number} [near=1] - The minimum distance to start applying fog.
	 * @param {number} [far=1000] - The maximum distance at which fog stops being calculated and applied.
	 */ constructor(color, near = 1, far = 1000){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFog = true;
        /**
		 * The name of the fog.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The fog's color.
		 *
		 * @type {Color}
		 */ this.color = new Color(color);
        /**
		 * The minimum distance to start applying fog. Objects that are less than
		 * `near` units from the active camera won't be affected by fog.
		 *
		 * @type {number}
		 * @default 1
		 */ this.near = near;
        /**
		 * The maximum distance at which fog stops being calculated and applied.
		 * Objects that are more than `far` units away from the active camera won't
		 * be affected by fog.
		 *
		 * @type {number}
		 * @default 1000
		 */ this.far = far;
    }
    /**
	 * Returns a new fog with copied values from this instance.
	 *
	 * @return {Fog} A clone of this instance.
	 */ clone() {
        return new Fog(this.color, this.near, this.far);
    }
    /**
	 * Serializes the fog into JSON.
	 *
	 * @param {?(Object|string)} meta - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized fog
	 */ toJSON() {
        return {
            type: 'Fog',
            name: this.name,
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
/**
 * Scenes allow you to set up what is to be rendered and where by three.js.
 * This is where you place 3D objects like meshes, lines or lights.
 *
 * @augments Object3D
 */ class Scene extends Object3D {
    /**
	 * Constructs a new scene.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isScene = true;
        this.type = 'Scene';
        /**
		 * Defines the background of the scene. Valid inputs are:
		 *
		 * - A color for defining a uniform colored background.
		 * - A texture for defining a (flat) textured background.
		 * - Cube textures or equirectangular textures for defining a skybox.
		 *
		 * @type {?(Color|Texture)}
		 * @default null
		 */ this.background = null;
        /**
		 * Sets the environment map for all physical materials in the scene. However,
		 * it's not possible to overwrite an existing texture assigned to the `envMap`
		 * material property.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.environment = null;
        /**
		 * A fog instance defining the type of fog that affects everything
		 * rendered in the scene.
		 *
		 * @type {?(Fog|FogExp2)}
		 * @default null
		 */ this.fog = null;
        /**
		 * Sets the blurriness of the background. Only influences environment maps
		 * assigned to {@link Scene#background}. Valid input is a float between `0`
		 * and `1`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.backgroundBlurriness = 0;
        /**
		 * Attenuates the color of the background. Only applies to background textures.
		 *
		 * @type {number}
		 * @default 1
		 */ this.backgroundIntensity = 1;
        /**
		 * The rotation of the background in radians. Only influences environment maps
		 * assigned to {@link Scene#background}.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.backgroundRotation = new Euler();
        /**
		 * Attenuates the color of the environment. Only influences environment maps
		 * assigned to {@link Scene#environment}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.environmentIntensity = 1;
        /**
		 * The rotation of the environment map in radians. Only influences physical materials
		 * in the scene when {@link Scene#environment} is used.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.environmentRotation = new Euler();
        /**
		 * Forces everything in the scene to be rendered with the defined material. It is possible
		 * to exclude materials from override by setting {@link Material#allowOverride} to `false`.
		 *
		 * @type {?Material}
		 * @default null
		 */ this.overrideMaterial = null;
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        }));
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        this.backgroundBlurriness = source.backgroundBlurriness;
        this.backgroundIntensity = source.backgroundIntensity;
        this.backgroundRotation.copy(source.backgroundRotation);
        this.environmentIntensity = source.environmentIntensity;
        this.environmentRotation.copy(source.environmentRotation);
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        if (this.backgroundBlurriness > 0) data.object.backgroundBlurriness = this.backgroundBlurriness;
        if (this.backgroundIntensity !== 1) data.object.backgroundIntensity = this.backgroundIntensity;
        data.object.backgroundRotation = this.backgroundRotation.toArray();
        if (this.environmentIntensity !== 1) data.object.environmentIntensity = this.environmentIntensity;
        data.object.environmentRotation = this.environmentRotation.toArray();
        return data;
    }
}
/**
 * "Interleaved" means that multiple attributes, possibly of different types,
 * (e.g., position, normal, uv, color) are packed into a single array buffer.
 *
 * An introduction into interleaved arrays can be found here: [Interleaved array basics](https://blog.tojicode.com/2011/05/interleaved-array-basics.html)
 */ class InterleavedBuffer {
    /**
	 * Constructs a new interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 */ constructor(array, stride){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBuffer = true;
        /**
		 * A typed array with a shared buffer storing attribute data.
		 *
		 * @type {TypedArray}
		 */ this.array = array;
        /**
		 * The number of typed-array elements per vertex.
		 *
		 * @type {number}
		 */ this.stride = stride;
        /**
		 * The total number of elements in the array
		 *
		 * @type {number}
		 * @readonly
		 */ this.count = array !== undefined ? array.length / stride : 0;
        /**
		 * Defines the intended usage pattern of the data store for optimization purposes.
		 *
		 * Note: After the initial use of a buffer, its usage cannot be changed. Instead,
		 * instantiate a new one and set the desired usage before the next render.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = StaticDrawUsage;
        /**
		 * This can be used to only update some components of stored vectors (for example, just the
		 * component related to color). Use the `addUpdateRange()` function to add ranges to this array.
		 *
		 * @type {Array<Object>}
		 */ this.updateRanges = [];
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
        /**
		 * The UUID of the interleaved buffer.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = generateUUID();
    }
    /**
	 * A callback function that is executed after the renderer has transferred the attribute array
	 * data to the GPU.
	 */ onUploadCallback() {}
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the usage of this interleaved buffer.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {InterleavedBuffer} A reference to this interleaved buffer.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Adds a range of data in the data array to be updated on the GPU.
	 *
	 * @param {number} start - Position at which to start update.
	 * @param {number} count - The number of components to update.
	 */ addUpdateRange(start, count) {
        this.updateRanges.push({
            start,
            count
        });
    }
    /**
	 * Clears the update ranges.
	 */ clearUpdateRanges() {
        this.updateRanges.length = 0;
    }
    /**
	 * Copies the values of the given interleaved buffer to this instance.
	 *
	 * @param {InterleavedBuffer} source - The interleaved buffer to copy.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copy(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    }
    /**
	 * Copies a vector from the given interleaved buffer to this one. The start
	 * and destination position in the attribute buffers are represented by the
	 * given indices.
	 *
	 * @param {number} index1 - The destination index into this interleaved buffer.
	 * @param {InterleavedBuffer} interleavedBuffer - The interleaved buffer to copy from.
	 * @param {number} index2 - The source index into the given interleaved buffer.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ copyAt(index1, interleavedBuffer, index2) {
        index1 *= this.stride;
        index2 *= interleavedBuffer.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = interleavedBuffer.array[index2 + i];
        return this;
    }
    /**
	 * Sets the given array data in the interleaved buffer.
	 *
	 * @param {(TypedArray|Array)} value - The array data to set.
	 * @param {number} [offset=0] - The offset in this interleaved buffer's array.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ set(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    }
    /**
	 * Returns a new interleaved buffer with copied values from this instance.
	 *
	 * @param {Object} [data] - An object with shared array buffers that allows to retain shared structures.
	 * @return {InterleavedBuffer} A clone of this instance.
	 */ clone(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new this.constructor(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    }
    /**
	 * Sets the given callback function that is executed after the Renderer has transferred
	 * the array data to the GPU. Can be used to perform clean-up operations after
	 * the upload when data are not needed anymore on the CPU side.
	 *
	 * @param {Function} callback - The `onUpload()` callback.
	 * @return {InterleavedBuffer} A reference to this instance.
	 */ onUpload(callback) {
        this.onUploadCallback = callback;
        return this;
    }
    /**
	 * Serializes the interleaved buffer into JSON.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized interleaved buffer.
	 */ toJSON(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.from(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
}
const _vector$7 = /*@__PURE__*/ new Vector3();
/**
 * An alternative version of a buffer attribute with interleaved data. Interleaved
 * attributes share a common interleaved data storage ({@link InterleavedBuffer}) and refer with
 * different offsets into the buffer.
 */ class InterleavedBufferAttribute {
    /**
	 * Constructs a new interleaved buffer attribute.
	 *
	 * @param {InterleavedBuffer} interleavedBuffer - The buffer holding the interleaved data.
	 * @param {number} itemSize - The item size.
	 * @param {number} offset - The attribute offset into the buffer.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(interleavedBuffer, itemSize, offset, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInterleavedBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer holding the interleaved data.
		 *
		 * @type {InterleavedBuffer}
		 */ this.data = interleavedBuffer;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The attribute offset into the buffer.
		 *
		 * @type {number}
		 */ this.offset = offset;
        /**
		 * Whether the data are normalized or not, see {@link BufferAttribute#normalized}
		 *
		 * @type {InterleavedBuffer}
		 */ this.normalized = normalized;
    }
    /**
	 * The item count of this buffer attribute.
	 *
	 * @type {number}
	 * @readonly
	 */ get count() {
        return this.data.count;
    }
    /**
	 * The array holding the interleaved buffer attribute data.
	 *
	 * @type {TypedArray}
	 */ get array() {
        return this.data.array;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        this.data.needsUpdate = value;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyMatrix4(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            _vector$7.fromBufferAttribute(this, i);
            _vector$7.applyMatrix4(m);
            this.setXYZ(i, _vector$7.x, _vector$7.y, _vector$7.z);
        }
        return this;
    }
    /**
	 * Applies the given 3x3 normal matrix to the given attribute. Only works with
	 * item size `3`.
	 *
	 * @param {Matrix3} m - The normal matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ applyNormalMatrix(m) {
        for(let i = 0, l = this.count; i < l; i++){
            _vector$7.fromBufferAttribute(this, i);
            _vector$7.applyNormalMatrix(m);
            this.setXYZ(i, _vector$7.x, _vector$7.y, _vector$7.z);
        }
        return this;
    }
    /**
	 * Applies the given 4x4 matrix to the given attribute. Only works with
	 * item size `3` and with direction vectors.
	 *
	 * @param {Matrix4} m - The matrix to apply.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ transformDirection(m) {
        for(let i = 0, l = this.count; i < l; i++){
            _vector$7.fromBufferAttribute(this, i);
            _vector$7.transformDirection(m);
            this.setXYZ(i, _vector$7.x, _vector$7.y, _vector$7.z);
        }
        return this;
    }
    /**
	 * Returns the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @return {number} The returned value.
	 */ getComponent(index, component) {
        let value = this.array[index * this.data.stride + this.offset + component];
        if (this.normalized) value = denormalize(value, this.array);
        return value;
    }
    /**
	 * Sets the given value to the given component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} component - The component index.
	 * @param {number} value - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setComponent(index, component, value) {
        if (this.normalized) value = normalize(value, this.array);
        this.data.array[index * this.data.stride + this.offset + component] = value;
        return this;
    }
    /**
	 * Sets the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setX(index, x) {
        if (this.normalized) x = normalize(x, this.array);
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    }
    /**
	 * Sets the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} y - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setY(index, y) {
        if (this.normalized) y = normalize(y, this.array);
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    }
    /**
	 * Sets the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} z - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setZ(index, z) {
        if (this.normalized) z = normalize(z, this.array);
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    }
    /**
	 * Sets the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} w - The value to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setW(index, w) {
        if (this.normalized) w = normalize(w, this.array);
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    }
    /**
	 * Returns the x component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The x component.
	 */ getX(index) {
        let x = this.data.array[index * this.data.stride + this.offset];
        if (this.normalized) x = denormalize(x, this.array);
        return x;
    }
    /**
	 * Returns the y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The y component.
	 */ getY(index) {
        let y = this.data.array[index * this.data.stride + this.offset + 1];
        if (this.normalized) y = denormalize(y, this.array);
        return y;
    }
    /**
	 * Returns the z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The z component.
	 */ getZ(index) {
        let z = this.data.array[index * this.data.stride + this.offset + 2];
        if (this.normalized) z = denormalize(z, this.array);
        return z;
    }
    /**
	 * Returns the w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @return {number} The w component.
	 */ getW(index) {
        let w = this.data.array[index * this.data.stride + this.offset + 3];
        if (this.normalized) w = denormalize(w, this.array);
        return w;
    }
    /**
	 * Sets the x and y component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXY(index, x, y) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = normalize(x, this.array);
            y = normalize(y, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    }
    /**
	 * Sets the x, y and z component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZ(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = normalize(x, this.array);
            y = normalize(y, this.array);
            z = normalize(z, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    }
    /**
	 * Sets the x, y, z and w component of the vector at the given index.
	 *
	 * @param {number} index - The index into the buffer attribute.
	 * @param {number} x - The value for the x component to set.
	 * @param {number} y - The value for the y component to set.
	 * @param {number} z - The value for the z component to set.
	 * @param {number} w - The value for the w component to set.
	 * @return {InterleavedBufferAttribute} A reference to this instance.
	 */ setXYZW(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        if (this.normalized) {
            x = normalize(x, this.array);
            y = normalize(y, this.array);
            z = normalize(z, this.array);
            w = normalize(w, this.array);
        }
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    }
    /**
	 * Returns a new buffer attribute with copied values from this instance.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An object with interleaved buffers that allows to retain the interleaved property.
	 * @return {BufferAttribute|InterleavedBufferAttribute} A clone of this instance.
	 */ clone(data) {
        if (data === undefined) {
            log('InterleavedBufferAttribute.clone(): Cloning an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new BufferAttribute(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    }
    /**
	 * Serializes the buffer attribute into JSON.
	 *
	 * If no parameter is provided, cloning an interleaved buffer attribute will de-interleave buffer data.
	 *
	 * @param {Object} [data] - An optional value holding meta information about the serialization.
	 * @return {Object} A JSON object representing the serialized buffer attribute.
	 */ toJSON(data) {
        if (data === undefined) {
            log('InterleavedBufferAttribute.toJSON(): Serializing an interleaved buffer attribute will de-interleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // de-interleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interleaved attribute
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
}
/**
 * A material for rendering instances of {@link Sprite}.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'textures/sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map, color: 0xffffff } );
 *
 * const sprite = new THREE.Sprite( material );
 * sprite.scale.set(200, 200, 1)
 * scene.add( sprite );
 * ```
 *
 * @augments Material
 */ class SpriteMaterial extends Material {
    /**
	 * Constructs a new sprite material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpriteMaterial = true;
        this.type = 'SpriteMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new Color(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The rotation of the sprite in radians.
		 *
		 * @type {number}
		 * @default 0
		 */ this.rotation = 0;
        /**
		 * Specifies whether size of the sprite is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Overwritten since sprite materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.rotation = source.rotation;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
let _geometry;
const _intersectPoint = /*@__PURE__*/ new Vector3();
const _worldScale = /*@__PURE__*/ new Vector3();
const _mvPosition = /*@__PURE__*/ new Vector3();
const _alignedPosition = /*@__PURE__*/ new Vector2();
const _rotatedPosition = /*@__PURE__*/ new Vector2();
const _viewWorldMatrix = /*@__PURE__*/ new Matrix4();
const _vA = /*@__PURE__*/ new Vector3();
const _vB = /*@__PURE__*/ new Vector3();
const _vC = /*@__PURE__*/ new Vector3();
const _uvA = /*@__PURE__*/ new Vector2();
const _uvB = /*@__PURE__*/ new Vector2();
const _uvC = /*@__PURE__*/ new Vector2();
/**
 * A sprite is a plane that always faces towards the camera, generally with a
 * partially transparent texture applied.
 *
 * Sprites do not cast shadows, setting {@link Object3D#castShadow} to `true` will
 * have no effect.
 *
 * ```js
 * const map = new THREE.TextureLoader().load( 'sprite.png' );
 * const material = new THREE.SpriteMaterial( { map: map } );
 *
 * const sprite = new THREE.Sprite( material );
 * scene.add( sprite );
 * ```
 *
 * @augments Object3D
 */ class Sprite extends Object3D {
    /**
	 * Constructs a new sprite.
	 *
	 * @param {(SpriteMaterial|SpriteNodeMaterial)} [material] - The sprite material.
	 */ constructor(material = new SpriteMaterial()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSprite = true;
        this.type = 'Sprite';
        if (_geometry === undefined) {
            _geometry = new BufferGeometry();
            const float32Array = new Float32Array([
                -0.5,
                -0.5,
                0,
                0,
                0,
                0.5,
                -0.5,
                0,
                1,
                0,
                0.5,
                0.5,
                0,
                1,
                1,
                -0.5,
                0.5,
                0,
                0,
                1
            ]);
            const interleavedBuffer = new InterleavedBuffer(float32Array, 5);
            _geometry.setIndex([
                0,
                1,
                2,
                0,
                2,
                3
            ]);
            _geometry.setAttribute('position', new InterleavedBufferAttribute(interleavedBuffer, 3, 0, false));
            _geometry.setAttribute('uv', new InterleavedBufferAttribute(interleavedBuffer, 2, 3, false));
        }
        /**
		 * The sprite geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = _geometry;
        /**
		 * The sprite material.
		 *
		 * @type {(SpriteMaterial|SpriteNodeMaterial)}
		 */ this.material = material;
        /**
		 * The sprite's anchor point, and the point around which the sprite rotates.
		 * A value of `(0.5, 0.5)` corresponds to the midpoint of the sprite. A value
		 * of `(0, 0)` corresponds to the lower left corner of the sprite.
		 *
		 * @type {Vector2}
		 * @default (0.5,0.5)
		 */ this.center = new Vector2(0.5, 0.5);
        /**
		 * The number of instances of this sprite.
		 * Can only be used with {@link WebGPURenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.count = 1;
    }
    /**
	 * Computes intersection points between a casted ray and this sprite.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        if (raycaster.camera === null) error('Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        _worldScale.setFromMatrixScale(this.matrixWorld);
        _viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        _mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) _worldScale.multiplyScalar(-_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        transformVertex(_vA.set(-0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
        transformVertex(_vB.set(0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
        transformVertex(_vC.set(0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
        _uvA.set(0, 0);
        _uvB.set(1, 0);
        _uvC.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle(_vA, _vB, _vC, false, _intersectPoint);
        if (intersect === null) {
            // check second triangle
            transformVertex(_vB.set(-0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
            _uvB.set(0, 1);
            intersect = raycaster.ray.intersectTriangle(_vA, _vC, _vB, false, _intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo(_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: _intersectPoint.clone(),
            uv: Triangle.getInterpolation(_intersectPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2()),
            face: null,
            object: this
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
}
function transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    _alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        _rotatedPosition.x = cos * _alignedPosition.x - sin * _alignedPosition.y;
        _rotatedPosition.y = sin * _alignedPosition.x + cos * _alignedPosition.y;
    } else _rotatedPosition.copy(_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += _rotatedPosition.x;
    vertexPosition.y += _rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4(_viewWorldMatrix);
}
const _v1$2 = /*@__PURE__*/ new Vector3();
const _v2$1 = /*@__PURE__*/ new Vector3();
/**
 * A component for providing a basic Level of Detail (LOD) mechanism.
 *
 * Every LOD level is associated with an object, and rendering can be switched
 * between them at the distances specified. Typically you would create, say,
 * three meshes, one for far away (low detail), one for mid range (medium
 * detail) and one for close up (high detail).
 *
 * ```js
 * const lod = new THREE.LOD();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 *
 * //Create spheres with 3 levels of detail and create new LOD levels for them
 * for( let i = 0; i < 3; i++ ) {
 *
 * 	const geometry = new THREE.IcosahedronGeometry( 10, 3 - i );
 * 	const mesh = new THREE.Mesh( geometry, material );
 * 	lod.addLevel( mesh, i * 75 );
 *
 * }
 *
 * scene.add( lod );
 * ```
 *
 * @augments Object3D
 */ class LOD extends Object3D {
    /**
	 * Constructs a new LOD.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLOD = true;
        /**
		 * The current LOD index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._currentLevel = 0;
        this.type = 'LOD';
        Object.defineProperties(this, {
            /**
			 * This array holds the LOD levels.
			 *
			 * @name LOD#levels
			 * @type {Array<{object:Object3D,distance:number,hysteresis:number}>}
			 */ levels: {
                enumerable: true,
                value: []
            }
        });
        /**
		 * Whether the LOD object is updated automatically by the renderer per frame
		 * or not. If set to `false`, you have to call {@link LOD#update} in the
		 * render loop by yourself.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
    }
    copy(source) {
        super.copy(source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance, level.hysteresis);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    }
    /**
	 * Adds a mesh that will display at a certain distance and greater. Typically
	 * the further away the distance, the lower the detail on the mesh.
	 *
	 * @param {Object3D} object - The 3D object to display at this level.
	 * @param {number} [distance=0] - The distance at which to display this level of detail.
	 * @param {number} [hysteresis=0] - Threshold used to avoid flickering at LOD boundaries, as a fraction of distance.
	 * @return {LOD} A reference to this instance.
	 */ addLevel(object, distance = 0, hysteresis = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            hysteresis: hysteresis,
            object: object
        });
        this.add(object);
        return this;
    }
    /**
	 * Removes an existing level, based on the distance from the camera.
	 * Returns `true` when the level has been removed. Otherwise `false`.
	 *
	 * @param {number} distance - Distance of the level to remove.
	 * @return {boolean} Whether the level has been removed or not.
	 */ removeLevel(distance) {
        const levels = this.levels;
        for(let i = 0; i < levels.length; i++)if (levels[i].distance === distance) {
            const removedElements = levels.splice(i, 1);
            this.remove(removedElements[0].object);
            return true;
        }
        return false;
    }
    /**
	 * Returns the currently active LOD level index.
	 *
	 * @return {number} The current active LOD level index.
	 */ getCurrentLevel() {
        return this._currentLevel;
    }
    /**
	 * Returns a reference to the first 3D object that is greater than
	 * the given distance.
	 *
	 * @param {number} distance - The LOD distance.
	 * @return {?Object3D} The found 3D object. `null` if no 3D object has been found.
	 */ getObjectForDistance(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance < levelDistance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    }
    /**
	 * Computes intersection points between a casted ray and this LOD.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            _v1$2.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo(_v1$2);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    }
    /**
	 * Updates the LOD by computing which LOD level should be visible according
	 * to the current distance of the given camera.
	 *
	 * @param {Camera} camera - The camera the scene is rendered with.
	 */ update(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            _v1$2.setFromMatrixPosition(camera.matrixWorld);
            _v2$1.setFromMatrixPosition(this.matrixWorld);
            const distance = _v1$2.distanceTo(_v2$1) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                let levelDistance = levels[i].distance;
                if (levels[i].object.visible) levelDistance -= levelDistance * levels[i].hysteresis;
                if (distance >= levelDistance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance,
                hysteresis: level.hysteresis
            });
        }
        return data;
    }
}
const _basePosition = /*@__PURE__*/ new Vector3();
const _skinIndex = /*@__PURE__*/ new Vector4();
const _skinWeight = /*@__PURE__*/ new Vector4();
const _vector3 = /*@__PURE__*/ new Vector3();
const _matrix4 = /*@__PURE__*/ new Matrix4();
const _vertex = /*@__PURE__*/ new Vector3();
const _sphere$5 = /*@__PURE__*/ new Sphere();
const _inverseMatrix$2 = /*@__PURE__*/ new Matrix4();
const _ray$2 = /*@__PURE__*/ new Ray();
/**
 * A mesh that has a {@link Skeleton} that can then be used to animate the
 * vertices of the geometry with skinning/skeleton animation.
 *
 * Next to a valid skeleton, the skinned mesh requires skin indices and weights
 * as buffer attributes in its geometry. These attribute define which bones affect a single
 * vertex to a certain extend.
 *
 * Typically skinned meshes are not created manually but loaders like {@link GLTFLoader}
 * or {@link FBXLoader } import respective models.
 *
 * @augments Mesh
 * @demo scenes/bones-browser.html
 */ class SkinnedMesh extends Mesh {
    /**
	 * Constructs a new skinned mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkinnedMesh = true;
        this.type = 'SkinnedMesh';
        /**
		 * `AttachedBindMode` means the skinned mesh shares the same world space as the skeleton.
		 * This is not true when using `DetachedBindMode` which is useful when sharing a skeleton
		 * across multiple skinned meshes.
		 *
		 * @type {(AttachedBindMode|DetachedBindMode)}
		 * @default AttachedBindMode
		 */ this.bindMode = AttachedBindMode;
        /**
		 * The base matrix that is used for the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrix = new Matrix4();
        /**
		 * The base matrix that is used for resetting the bound bone transforms.
		 *
		 * @type {Matrix4}
		 */ this.bindMatrixInverse = new Matrix4();
        /**
		 * The bounding box of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the skinned mesh. Can be computed via {@link SkinnedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
    }
    /**
	 * Computes the bounding box of the skinned mesh, and updates {@link SkinnedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * If the skinned mesh is animated, the bounding box should be recomputed per frame in order to reflect
	 * the current animation state.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        if (this.boundingBox === null) this.boundingBox = new Box3();
        this.boundingBox.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, _vertex);
            this.boundingBox.expandByPoint(_vertex);
        }
    }
    /**
	 * Computes the bounding sphere of the skinned mesh, and updates {@link SkinnedMesh#boundingSphere}.
	 * The bounding sphere is automatically computed by the engine once when it is needed, e.g., for ray casting
	 * and view frustum culling. If the skinned mesh is animated, the bounding sphere should be recomputed
	 * per frame in order to reflect the current animation state.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        if (this.boundingSphere === null) this.boundingSphere = new Sphere();
        this.boundingSphere.makeEmpty();
        const positionAttribute = geometry.getAttribute('position');
        for(let i = 0; i < positionAttribute.count; i++){
            this.getVertexPosition(i, _vertex);
            this.boundingSphere.expandByPoint(_vertex);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    raycast(raycaster, intersects) {
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // test with bounding sphere in world space
        if (this.boundingSphere === null) this.computeBoundingSphere();
        _sphere$5.copy(this.boundingSphere);
        _sphere$5.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere(_sphere$5) === false) return;
        // convert ray to local space of skinned mesh
        _inverseMatrix$2.copy(matrixWorld).invert();
        _ray$2.copy(raycaster.ray).applyMatrix4(_inverseMatrix$2);
        // test with bounding box in local space
        if (this.boundingBox !== null) {
            if (_ray$2.intersectsBox(this.boundingBox) === false) return;
        }
        // test for intersections with geometry
        this._computeIntersections(raycaster, intersects, _ray$2);
    }
    getVertexPosition(index, target) {
        super.getVertexPosition(index, target);
        this.applyBoneTransform(index, target);
        return target;
    }
    /**
	 * Binds the given skeleton to the skinned mesh.
	 *
	 * @param {Skeleton} skeleton - The skeleton to bind.
	 * @param {Matrix4} [bindMatrix] - The bind matrix. If no bind matrix is provided,
	 * the skinned mesh's world matrix will be used instead.
	 */ bind(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    }
    /**
	 * This method sets the skinned mesh in the rest pose).
	 */ pose() {
        this.skeleton.pose();
    }
    /**
	 * Normalizes the skin weights which are defined as a buffer attribute
	 * in the skinned mesh's geometry.
	 */ normalizeSkinWeights() {
        const vector = new Vector4();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.fromBufferAttribute(skinWeight, i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.bindMode === AttachedBindMode) this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === DetachedBindMode) this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else warn('SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    }
    /**
	 * Applies the bone transform associated with the given index to the given
	 * vertex position. Returns the updated vector.
	 *
	 * @param {number} index - The vertex index.
	 * @param {Vector3} target - The target object that is used to store the method's result.
	 * the skinned mesh's world matrix will be used instead.
	 * @return {Vector3} The updated vertex position.
	 */ applyBoneTransform(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        _skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        _skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        _basePosition.copy(target).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = _skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = _skinIndex.getComponent(i);
                _matrix4.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector(_vector3.copy(_basePosition).applyMatrix4(_matrix4), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
}
/**
 * A bone which is part of a {@link Skeleton}. The skeleton in turn is used by
 * the {@link SkinnedMesh}.
 *
 * ```js
 * const root = new THREE.Bone();
 * const child = new THREE.Bone();
 *
 * root.add( child );
 * child.position.y = 5;
 * ```
 *
 * @augments Object3D
 */ class Bone extends Object3D {
    /**
	 * Constructs a new bone.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBone = true;
        this.type = 'Bone';
    }
}
/**
 * Creates a texture directly from raw buffer data.
 *
 * The interpretation of the data depends on type and format: If the type is
 * `UnsignedByteType`, a `Uint8Array` will be useful for addressing the
 * texel data. If the format is `RGBAFormat`, data needs four values for
 * one texel; Red, Green, Blue and Alpha (typically the opacity).
 *
 * @augments Texture
 */ class DataTexture extends Texture {
    /**
	 * Constructs a new data texture.
	 *
	 * @param {?TypedArray} [data=null] - The buffer data.
	 * @param {number} [width=1] - The width of the texture.
	 * @param {number} [height=1] - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=NearestFilter] - The mag filter value.
	 * @param {number} [minFilter=NearestFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(data = null, width = 1, height = 1, format, type, mapping, wrapS, wrapT, magFilter = NearestFilter, minFilter = NearestFilter, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDataTexture = true;
        /**
		 * The image definition of a data texture.
		 *
		 * @type {{data:TypedArray,width:number,height:number}}
		 */ this.image = {
            data: data,
            width: width,
            height: height
        };
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Specifies the alignment requirements for the start of each pixel row in memory.
		 *
		 * Overwritten and set to `1` by default.
		 *
		 * @type {boolean}
		 * @default 1
		 */ this.unpackAlignment = 1;
    }
}
const _offsetMatrix = /*@__PURE__*/ new Matrix4();
const _identityMatrix = /*@__PURE__*/ new Matrix4();
/**
 * Class for representing the armatures in `three.js`. The skeleton
 * is defined by a hierarchy of bones.
 *
 * ```js
 * const bones = [];
 *
 * const shoulder = new THREE.Bone();
 * const elbow = new THREE.Bone();
 * const hand = new THREE.Bone();
 *
 * shoulder.add( elbow );
 * elbow.add( hand );
 *
 * bones.push( shoulder , elbow, hand);
 *
 * shoulder.position.y = -5;
 * elbow.position.y = 0;
 * hand.position.y = 5;
 *
 * const armSkeleton = new THREE.Skeleton( bones );
 * ```
 */ class Skeleton {
    /**
	 * Constructs a new skeleton.
	 *
	 * @param {Array<Bone>} [bones] - An array of bones.
	 * @param {Array<Matrix4>} [boneInverses] - An array of bone inverse matrices.
	 * If not provided, these matrices will be computed automatically via {@link Skeleton#calculateInverses}.
	 */ constructor(bones = [], boneInverses = []){
        this.uuid = generateUUID();
        /**
		 * An array of bones defining the skeleton.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones.slice(0);
        /**
		 * An array of bone inverse matrices.
		 *
		 * @type {Array<Matrix4>}
		 */ this.boneInverses = boneInverses;
        /**
		 * An array buffer holding the bone data.
		 * Input data for {@link Skeleton#boneTexture}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.boneMatrices = null;
        /**
		 * An array buffer holding the bone data of the previous frame.
		 * Required for computing velocity. Maintained in {@link SkinningNode}.
		 *
		 * @type {?Float32Array}
		 * @default null
		 */ this.previousBoneMatrices = null;
        /**
		 * A texture holding the bone data for use
		 * in the vertex shader.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.boneTexture = null;
        this.init();
    }
    /**
	 * Initializes the skeleton. This method gets automatically called by the constructor
	 * but depending on how the skeleton is created it might be necessary to call this method
	 * manually.
	 */ init() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            warn('Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new Matrix4());
        }
    }
    /**
	 * Computes the bone inverse matrices. This method resets {@link Skeleton#boneInverses}
	 * and fills it with new matrices.
	 */ calculateInverses() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new Matrix4();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ pose() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    }
    /**
	 * Resets the skeleton to the base pose.
	 */ update() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : _identityMatrix;
            _offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            _offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    }
    /**
	 * Returns a new skeleton with copied values from this instance.
	 *
	 * @return {Skeleton} A clone of this instance.
	 */ clone() {
        return new Skeleton(this.bones, this.boneInverses);
    }
    /**
	 * Computes a data texture for passing bone data to the vertex shader.
	 *
	 * @return {Skeleton} A reference of this instance.
	 */ computeBoneTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
        let size = Math.sqrt(this.bones.length * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        boneMatrices.set(this.boneMatrices); // copy current values
        const boneTexture = new DataTexture(boneMatrices, size, size, RGBAFormat, FloatType);
        boneTexture.needsUpdate = true;
        this.boneMatrices = boneMatrices;
        this.boneTexture = boneTexture;
        return this;
    }
    /**
	 * Searches through the skeleton's bone array and returns the first with a
	 * matching name.
	 *
	 * @param {string} name - The name of the bone.
	 * @return {Bone|undefined} The found bone. `undefined` if no bone has been found.
	 */ getBoneByName(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    }
    /**
	 * Setups the skeleton by the given JSON and bones.
	 *
	 * @param {Object} json - The skeleton as serialized JSON.
	 * @param {Object<string, Bone>} bones - An array of bones.
	 * @return {Skeleton} A reference of this instance.
	 */ fromJSON(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                warn('Skeleton: No bone found with UUID:', uuid);
                bone = new Bone();
            }
            this.bones.push(bone);
            this.boneInverses.push(new Matrix4().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    }
    /**
	 * Serializes the skeleton into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized skeleton.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
}
/**
 * An instanced version of a buffer attribute.
 *
 * @augments BufferAttribute
 */ class InstancedBufferAttribute extends BufferAttribute {
    /**
	 * Constructs a new instanced buffer attribute.
	 *
	 * @param {TypedArray} array - The array holding the attribute data.
	 * @param {number} itemSize - The item size.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 * @param {number} [meshPerAttribute=1] - How often a value of this buffer attribute should be repeated.
	 */ constructor(array, itemSize, normalized, meshPerAttribute = 1){
        super(array, itemSize, normalized);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferAttribute = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated. A
		 * value of one means that each value of the instanced attribute is used for
		 * a single instance. A value of two means that each value is used for two
		 * consecutive instances (and so on).
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
}
const _instanceLocalMatrix = /*@__PURE__*/ new Matrix4();
const _instanceWorldMatrix = /*@__PURE__*/ new Matrix4();
const _instanceIntersects = [];
const _box3 = /*@__PURE__*/ new Box3();
const _identity = /*@__PURE__*/ new Matrix4();
const _mesh$1 = /*@__PURE__*/ new Mesh();
const _sphere$4 = /*@__PURE__*/ new Sphere();
/**
 * A special version of a mesh with instanced rendering support. Use
 * this class if you have to render a large number of objects with the same
 * geometry and material(s) but with different world transformations. The usage
 * of 'InstancedMesh' will help you to reduce the number of draw calls and thus
 * improve the overall rendering performance in your application.
 *
 * @augments Mesh
 */ class InstancedMesh extends Mesh {
    /**
	 * Constructs a new instanced mesh.
	 *
	 * @param {BufferGeometry} [geometry] - The mesh geometry.
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 * @param {number} count - The number of instances.
	 */ constructor(geometry, material, count){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedMesh = true;
        /**
		 * Represents the local transformation of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMatrixAt}.
		 *
		 * @type {InstancedBufferAttribute}
		 */ this.instanceMatrix = new InstancedBufferAttribute(new Float32Array(count * 16), 16);
        /**
		 * Represents the color of all instances. You have to set its
		 * {@link BufferAttribute#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setColorAt}.
		 *
		 * @type {?InstancedBufferAttribute}
		 * @default null
		 */ this.instanceColor = null;
        /**
		 * Represents the morph target weights of all instances. You have to set its
		 * {@link Texture#needsUpdate} flag to true if you modify instanced data
		 * via {@link InstancedMesh#setMorphAt}.
		 *
		 * @type {?DataTexture}
		 * @default null
		 */ this.morphTexture = null;
        /**
		 * The number of instances.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * The bounding box of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the instanced mesh. Can be computed via {@link InstancedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        for(let i = 0; i < count; i++)this.setMatrixAt(i, _identity);
    }
    /**
	 * Computes the bounding box of the instanced mesh, and updates {@link InstancedMesh#boundingBox}.
	 * The bounding box is not automatically computed by the engine; this method must be called by your app.
	 * You may need to recompute the bounding box if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingBox() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingBox === null) this.boundingBox = new Box3();
        if (geometry.boundingBox === null) geometry.computeBoundingBox();
        this.boundingBox.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, _instanceLocalMatrix);
            _box3.copy(geometry.boundingBox).applyMatrix4(_instanceLocalMatrix);
            this.boundingBox.union(_box3);
        }
    }
    /**
	 * Computes the bounding sphere of the instanced mesh, and updates {@link InstancedMesh#boundingSphere}
	 * The engine automatically computes the bounding sphere when it is needed, e.g., for ray casting or view frustum culling.
	 * You may need to recompute the bounding sphere if an instance is transformed via {@link InstancedMesh#setMatrixAt}.
	 */ computeBoundingSphere() {
        const geometry = this.geometry;
        const count = this.count;
        if (this.boundingSphere === null) this.boundingSphere = new Sphere();
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        this.boundingSphere.makeEmpty();
        for(let i = 0; i < count; i++){
            this.getMatrixAt(i, _instanceLocalMatrix);
            _sphere$4.copy(geometry.boundingSphere).applyMatrix4(_instanceLocalMatrix);
            this.boundingSphere.union(_sphere$4);
        }
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.morphTexture !== null) this.morphTexture = source.morphTexture.clone();
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        if (source.boundingBox !== null) this.boundingBox = source.boundingBox.clone();
        if (source.boundingSphere !== null) this.boundingSphere = source.boundingSphere.clone();
        return this;
    }
    /**
	 * Gets the color of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The target object that is used to store the method's result.
	 */ getColorAt(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Gets the local transformation matrix of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 */ getMatrixAt(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Gets the morph target weights of the defined instance.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object - The target object that is used to store the method's result.
	 */ getMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const array = this.morphTexture.source.data.data;
        const len = objectInfluences.length + 1; // All influences + the baseInfluenceSum
        const dataIndex = index * len + 1; // Skip the baseInfluenceSum at the beginning
        for(let i = 0; i < objectInfluences.length; i++)objectInfluences[i] = array[dataIndex + i];
    }
    raycast(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        _mesh$1.geometry = this.geometry;
        _mesh$1.material = this.material;
        if (_mesh$1.material === undefined) return;
        // test with bounding sphere first
        if (this.boundingSphere === null) this.computeBoundingSphere();
        _sphere$4.copy(this.boundingSphere);
        _sphere$4.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere(_sphere$4) === false) return;
        // now test each instance
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, _instanceLocalMatrix);
            _instanceWorldMatrix.multiplyMatrices(matrixWorld, _instanceLocalMatrix);
            // the mesh represents this single instance
            _mesh$1.matrixWorld = _instanceWorldMatrix;
            _mesh$1.raycast(raycaster, _instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = _instanceIntersects.length; i < l; i++){
                const intersect = _instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            _instanceIntersects.length = 0;
        }
    }
    /**
	 * Sets the given color to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceColor} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Color} color - The instance color.
	 */ setColorAt(index, color) {
        if (this.instanceColor === null) this.instanceColor = new InstancedBufferAttribute(new Float32Array(this.instanceMatrix.count * 3).fill(1), 3);
        color.toArray(this.instanceColor.array, index * 3);
    }
    /**
	 * Sets the given local transformation matrix to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#instanceMatrix} to `true` after updating all the colors.
	 *
	 * @param {number} index - The instance index.
	 * @param {Matrix4} matrix - The local transformation.
	 */ setMatrixAt(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    }
    /**
	 * Sets the morph target weights to the defined instance. Make sure you set the `needsUpdate` flag of
	 * {@link InstancedMesh#morphTexture} to `true` after updating all the influences.
	 *
	 * @param {number} index - The instance index.
	 * @param {Mesh} object -  A mesh which `morphTargetInfluences` property containing the morph target weights
	 * of a single instance.
	 */ setMorphAt(index, object) {
        const objectInfluences = object.morphTargetInfluences;
        const len = objectInfluences.length + 1; // morphBaseInfluence + all influences
        if (this.morphTexture === null) this.morphTexture = new DataTexture(new Float32Array(len * this.count), len, this.count, RedFormat, FloatType);
        const array = this.morphTexture.source.data.data;
        let morphInfluencesSum = 0;
        for(let i = 0; i < objectInfluences.length; i++)morphInfluencesSum += objectInfluences[i];
        const morphBaseInfluence = this.geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        const dataIndex = len * index;
        array[dataIndex] = morphBaseInfluence;
        array.set(objectInfluences, dataIndex + 1);
    }
    updateMorphTargets() {}
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
        if (this.morphTexture !== null) {
            this.morphTexture.dispose();
            this.morphTexture = null;
        }
    }
}
const _vector1 = /*@__PURE__*/ new Vector3();
const _vector2 = /*@__PURE__*/ new Vector3();
const _normalMatrix = /*@__PURE__*/ new Matrix3();
/**
 * A two dimensional surface that extends infinitely in 3D space, represented
 * in [Hessian normal form](http://mathworld.wolfram.com/HessianNormalForm.html)
 * by a unit length normal vector and a constant.
 */ class Plane {
    /**
	 * Constructs a new plane.
	 *
	 * @param {Vector3} [normal=(1,0,0)] - A unit length vector defining the normal of the plane.
	 * @param {number} [constant=0] - The signed distance from the origin to the plane.
	 */ constructor(normal = new Vector3(1, 0, 0), constant = 0){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPlane = true;
        /**
		 * A unit length vector defining the normal of the plane.
		 *
		 * @type {Vector3}
		 */ this.normal = normal;
        /**
		 * The signed distance from the origin to the plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.constant = constant;
    }
    /**
	 * Sets the plane components by copying the given values.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {number} constant - The constant.
	 * @return {Plane} A reference to this plane.
	 */ set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    /**
	 * Sets the plane components by defining `x`, `y`, `z` as the
	 * plane normal and `w` as the constant.
	 *
	 * @param {number} x - The value for the normal's x component.
	 * @param {number} y - The value for the normal's y component.
	 * @param {number} z - The value for the normal's z component.
	 * @param {number} w - The constant value.
	 * @return {Plane} A reference to this plane.
	 */ setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    /**
	 * Sets the plane from the given normal and coplanar point (that is a point
	 * that lies onto the plane).
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Vector3} point - A coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    /**
	 * Sets the plane from three coplanar points. The winding order is
	 * assumed to be counter-clockwise, and determines the direction of
	 * the plane normal.
	 *
	 * @param {Vector3} a - The first coplanar point.
	 * @param {Vector3} b - The second coplanar point.
	 * @param {Vector3} c - The third coplanar point.
	 * @return {Plane} A reference to this plane.
	 */ setFromCoplanarPoints(a, b, c) {
        const normal = _vector1.subVectors(c, b).cross(_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    /**
	 * Copies the values of the given plane to this instance.
	 *
	 * @param {Plane} plane - The plane to copy.
	 * @return {Plane} A reference to this plane.
	 */ copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    /**
	 * Normalizes the plane normal and adjusts the constant accordingly.
	 *
	 * @return {Plane} A reference to this plane.
	 */ normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    /**
	 * Negates both the plane normal and the constant.
	 *
	 * @return {Plane} A reference to this plane.
	 */ negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    /**
	 * Returns the signed distance from the given point to this plane.
	 *
	 * @param {Vector3} point - The point to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    /**
	 * Returns the signed distance from the given sphere to this plane.
	 *
	 * @param {Sphere} sphere - The sphere to compute the distance for.
	 * @return {number} The signed distance.
	 */ distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    /**
	 * Projects a the given point onto the plane.
	 *
	 * @param {Vector3} point - The point to project.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The projected point on the plane.
	 */ projectPoint(point, target) {
        return target.copy(point).addScaledVector(this.normal, -this.distanceToPoint(point));
    }
    /**
	 * Returns the intersection point of the passed line and the plane. Returns
	 * `null` if the line does not intersect. Returns the line's starting point if
	 * the line is coplanar with the plane.
	 *
	 * @param {Line3} line - The line to compute the intersection for.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {?Vector3} The intersection point.
	 */ intersectLine(line, target) {
        const direction = line.delta(_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return null;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return null;
        return target.copy(line.start).addScaledVector(direction, t);
    }
    /**
	 * Returns `true` if the given line segment intersects with (passes through) the plane.
	 *
	 * @param {Line3} line - The line to test.
	 * @return {boolean} Whether the given line segment intersects with the plane or not.
	 */ intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    /**
	 * Returns `true` if the given bounding box intersects with the plane.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with the plane or not.
	 */ intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    /**
	 * Returns `true` if the given bounding sphere intersects with the plane.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the given bounding sphere intersects with the plane or not.
	 */ intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    /**
	 * Returns a coplanar vector to the plane, by calculating the
	 * projection of the normal at the origin onto the plane.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The coplanar point.
	 */ coplanarPoint(target) {
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    /**
	 * Apply a 4x4 matrix to the plane. The matrix must be an affine, homogeneous transform.
	 *
	 * The optional normal matrix can be pre-computed like so:
	 * ```js
	 * const optionalNormalMatrix = new THREE.Matrix3().getNormalMatrix( matrix );
	 * ```
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @param {Matrix4} [optionalNormalMatrix] - A pre-computed normal matrix.
	 * @return {Plane} A reference to this plane.
	 */ applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint(_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    /**
	 * Translates the plane by the distance defined by the given offset vector.
	 * Note that this only affects the plane constant and will not affect the normal vector.
	 *
	 * @param {Vector3} offset - The offset vector.
	 * @return {Plane} A reference to this plane.
	 */ translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    /**
	 * Returns `true` if this plane is equal with the given one.
	 *
	 * @param {Plane} plane - The plane to test for equality.
	 * @return {boolean} Whether this plane is equal with the given one.
	 */ equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
    /**
	 * Returns a new plane with copied values from this instance.
	 *
	 * @return {Plane} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const _sphere$3 = /*@__PURE__*/ new Sphere();
const _defaultSpriteCenter = /*@__PURE__*/ new Vector2(0.5, 0.5);
const _vector$6 = /*@__PURE__*/ new Vector3();
/**
 * Frustums are used to determine what is inside the camera's field of view.
 * They help speed up the rendering process - objects which lie outside a camera's
 * frustum can safely be excluded from rendering.
 *
 * This class is mainly intended for use internally by a renderer.
 */ class Frustum {
    /**
	 * Constructs a new frustum.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 */ constructor(p0 = new Plane(), p1 = new Plane(), p2 = new Plane(), p3 = new Plane(), p4 = new Plane(), p5 = new Plane()){
        /**
		 * This array holds the planes that enclose the frustum.
		 *
		 * @type {Array<Plane>}
		 */ this.planes = [
            p0,
            p1,
            p2,
            p3,
            p4,
            p5
        ];
    }
    /**
	 * Sets the frustum planes by copying the given planes.
	 *
	 * @param {Plane} [p0] - The first plane that encloses the frustum.
	 * @param {Plane} [p1] - The second plane that encloses the frustum.
	 * @param {Plane} [p2] - The third plane that encloses the frustum.
	 * @param {Plane} [p3] - The fourth plane that encloses the frustum.
	 * @param {Plane} [p4] - The fifth plane that encloses the frustum.
	 * @param {Plane} [p5] - The sixth plane that encloses the frustum.
	 * @return {Frustum} A reference to this frustum.
	 */ set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    /**
	 * Copies the values of the given frustum to this instance.
	 *
	 * @param {Frustum} frustum - The frustum to copy.
	 * @return {Frustum} A reference to this frustum.
	 */ copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    /**
	 * Sets the frustum planes from the given projection matrix.
	 *
	 * @param {Matrix4} m - The projection matrix.
	 * @param {(WebGLCoordinateSystem|WebGPUCoordinateSystem)} coordinateSystem - The coordinate system.
	 * @param {boolean} [reversedDepth=false] - Whether to use a reversed depth.
	 * @return {Frustum} A reference to this frustum.
	 */ setFromProjectionMatrix(m, coordinateSystem = WebGLCoordinateSystem, reversedDepth = false) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        if (reversedDepth) {
            planes[4].setComponents(me2, me6, me10, me14).normalize(); // far
            planes[5].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize(); // near
        } else {
            planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize(); // far
            if (coordinateSystem === WebGLCoordinateSystem) planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize(); // near
            else if (coordinateSystem === WebGPUCoordinateSystem) planes[5].setComponents(me2, me6, me10, me14).normalize(); // near
            else throw new Error('THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: ' + coordinateSystem);
        }
        return this;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting this frustum.
	 *
	 * Note that the 3D object must have a geometry so that the bounding sphere can be calculated.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @return {boolean} Whether the 3D object's bounding sphere is intersecting this frustum or not.
	 */ intersectsObject(object) {
        if (object.boundingSphere !== undefined) {
            if (object.boundingSphere === null) object.computeBoundingSphere();
            _sphere$3.copy(object.boundingSphere).applyMatrix4(object.matrixWorld);
        } else {
            const geometry = object.geometry;
            if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
            _sphere$3.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        }
        return this.intersectsSphere(_sphere$3);
    }
    /**
	 * Returns `true` if the given sprite is intersecting this frustum.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @return {boolean} Whether the sprite is intersecting this frustum or not.
	 */ intersectsSprite(sprite) {
        _sphere$3.center.set(0, 0, 0);
        const offset = _defaultSpriteCenter.distanceTo(sprite.center);
        _sphere$3.radius = 0.7071067811865476 + offset;
        _sphere$3.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere(_sphere$3);
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting this frustum.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @return {boolean} Whether the bounding sphere is intersecting this frustum or not.
	 */ intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given bounding box is intersecting this frustum.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box is intersecting this frustum or not.
	 */ intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            _vector$6.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            _vector$6.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            _vector$6.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint(_vector$6) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns `true` if the given point lies within the frustum.
	 *
	 * @param {Vector3} point - The point to test.
	 * @return {boolean} Whether the point lies within this frustum or not.
	 */ containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
    /**
	 * Returns a new frustum with copied values from this instance.
	 *
	 * @return {Frustum} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const _projScreenMatrix$1 = /*@__PURE__*/ new Matrix4();
const _frustum$1 = /*@__PURE__*/ new Frustum();
/**
 * FrustumArray is used to determine if an object is visible in at least one camera
 * from an array of cameras. This is particularly useful for multi-view renderers.
*/ class FrustumArray {
    /**
	 * Constructs a new frustum array.
	 *
	 */ constructor(){
        /**
		 * The coordinate system to use.
		 *
		 * @type {WebGLCoordinateSystem|WebGPUCoordinateSystem}
		 * @default WebGLCoordinateSystem
		 */ this.coordinateSystem = WebGLCoordinateSystem;
    }
    /**
	 * Returns `true` if the 3D object's bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Object3D} object - The 3D object to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the 3D object is visible in any camera.
	 */ intersectsObject(object, cameraArray) {
        if (!cameraArray.isArrayCamera || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            _projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum$1.setFromProjectionMatrix(_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if (_frustum$1.intersectsObject(object)) return true; // Object is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given sprite is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sprite} sprite - The sprite to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sprite is visible in any camera.
	 */ intersectsSprite(sprite, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            _projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum$1.setFromProjectionMatrix(_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if (_frustum$1.intersectsSprite(sprite)) return true; // Sprite is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given bounding sphere is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Sphere} sphere - The bounding sphere to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the sphere is visible in any camera.
	 */ intersectsSphere(sphere, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            _projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum$1.setFromProjectionMatrix(_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if (_frustum$1.intersectsSphere(sphere)) return true; // Sphere is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given bounding box is intersecting any frustum
	 * from the camera array.
	 *
	 * @param {Box3} box - The bounding box to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the box is visible in any camera.
	 */ intersectsBox(box, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            _projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum$1.setFromProjectionMatrix(_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if (_frustum$1.intersectsBox(box)) return true; // Box is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns `true` if the given point lies within any frustum
	 * from the camera array.
	 *
	 * @param {Vector3} point - The point to test.
	 * @param {Object} cameraArray - An object with a cameras property containing an array of cameras.
	 * @return {boolean} Whether the point is visible in any camera.
	 */ containsPoint(point, cameraArray) {
        if (!cameraArray || !cameraArray.cameras || cameraArray.cameras.length === 0) return false;
        for(let i = 0; i < cameraArray.cameras.length; i++){
            const camera = cameraArray.cameras[i];
            _projScreenMatrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
            _frustum$1.setFromProjectionMatrix(_projScreenMatrix$1, camera.coordinateSystem, camera.reversedDepth);
            if (_frustum$1.containsPoint(point)) return true; // Point is visible in at least one camera
        }
        return false; // Not visible in any camera
    }
    /**
	 * Returns a new frustum array with copied values from this instance.
	 *
	 * @return {FrustumArray} A clone of this instance.
	 */ clone() {
        return new FrustumArray();
    }
}
function ascIdSort(a, b) {
    return a - b;
}
function sortOpaque(a, b) {
    return a.z - b.z;
}
function sortTransparent(a, b) {
    return b.z - a.z;
}
class MultiDrawRenderList {
    constructor(){
        this.index = 0;
        this.pool = [];
        this.list = [];
    }
    push(start, count, z, index) {
        const pool = this.pool;
        const list = this.list;
        if (this.index >= pool.length) pool.push({
            start: -1,
            count: -1,
            z: -1,
            index: -1
        });
        const item = pool[this.index];
        list.push(item);
        this.index++;
        item.start = start;
        item.count = count;
        item.z = z;
        item.index = index;
    }
    reset() {
        this.list.length = 0;
        this.index = 0;
    }
}
const _matrix$1 = /*@__PURE__*/ new Matrix4();
const _whiteColor = /*@__PURE__*/ new Color(1, 1, 1);
const _frustum = /*@__PURE__*/ new Frustum();
const _frustumArray = /*@__PURE__*/ new FrustumArray();
const _box$1 = /*@__PURE__*/ new Box3();
const _sphere$2 = /*@__PURE__*/ new Sphere();
const _vector$5 = /*@__PURE__*/ new Vector3();
const _forward$1 = /*@__PURE__*/ new Vector3();
const _temp = /*@__PURE__*/ new Vector3();
const _renderList = /*@__PURE__*/ new MultiDrawRenderList();
const _mesh = /*@__PURE__*/ new Mesh();
const _batchIntersects = [];
// copies data from attribute "src" into "target" starting at "targetOffset"
function copyAttributeData(src, target, targetOffset = 0) {
    const itemSize = target.itemSize;
    if (src.isInterleavedBufferAttribute || src.array.constructor !== target.array.constructor) {
        // use the component getters and setters if the array data cannot
        // be copied directly
        const vertexCount = src.count;
        for(let i = 0; i < vertexCount; i++)for(let c = 0; c < itemSize; c++)target.setComponent(i + targetOffset, c, src.getComponent(i, c));
    } else // faster copy approach using typed array set function
    target.array.set(src.array, targetOffset * itemSize);
    target.needsUpdate = true;
}
// safely copies array contents to a potentially smaller array
function copyArrayContents(src, target) {
    if (src.constructor !== target.constructor) {
        // if arrays are of a different type (eg due to index size increasing) then data must be per-element copied
        const len = Math.min(src.length, target.length);
        for(let i = 0; i < len; i++)target[i] = src[i];
    } else {
        // if the arrays use the same data layout we can use a fast block copy
        const len = Math.min(src.length, target.length);
        target.set(new src.constructor(src.buffer, 0, len));
    }
}
/**
 * A special version of a mesh with multi draw batch rendering support. Use
 * this class if you have to render a large number of objects with the same
 * material but with different geometries or world transformations. The usage of
 * `BatchedMesh` will help you to reduce the number of draw calls and thus improve the overall
 * rendering performance in your application.
 *
 * ```js
 * const box = new THREE.BoxGeometry( 1, 1, 1 );
 * const sphere = new THREE.SphereGeometry( 1, 12, 12 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 *
 * // initialize and add geometries into the batched mesh
 * const batchedMesh = new BatchedMesh( 10, 5000, 10000, material );
 * const boxGeometryId = batchedMesh.addGeometry( box );
 * const sphereGeometryId = batchedMesh.addGeometry( sphere );
 *
 * // create instances of those geometries
 * const boxInstancedId1 = batchedMesh.addInstance( boxGeometryId );
 * const boxInstancedId2 = batchedMesh.addInstance( boxGeometryId );
 *
 * const sphereInstancedId1 = batchedMesh.addInstance( sphereGeometryId );
 * const sphereInstancedId2 = batchedMesh.addInstance( sphereGeometryId );
 *
 * // position the geometries
 * batchedMesh.setMatrixAt( boxInstancedId1, boxMatrix1 );
 * batchedMesh.setMatrixAt( boxInstancedId2, boxMatrix2 );
 *
 * batchedMesh.setMatrixAt( sphereInstancedId1, sphereMatrix1 );
 * batchedMesh.setMatrixAt( sphereInstancedId2, sphereMatrix2 );
 *
 * scene.add( batchedMesh );
 * ```
 *
 * @augments Mesh
 */ class BatchedMesh extends Mesh {
    /**
	 * Constructs a new batched mesh.
	 *
	 * @param {number} maxInstanceCount - The maximum number of individual instances planned to be added and rendered.
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries.
	 * @param {number} [maxIndexCount=maxVertexCount*2] - The maximum number of indices to be used by all unique geometries
	 * @param {Material|Array<Material>} [material] - The mesh material.
	 */ constructor(maxInstanceCount, maxVertexCount, maxIndexCount = maxVertexCount * 2, material){
        super(new BufferGeometry(), material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBatchedMesh = true;
        /**
		 * When set ot `true`, the individual objects of a batch are frustum culled.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.perObjectFrustumCulled = true;
        /**
		 * When set to `true`, the individual objects of a batch are sorted to improve overdraw-related artifacts.
		 * If the material is marked as "transparent" objects are rendered back to front and if not then they are
		 * rendered front to back.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sortObjects = true;
        /**
		 * The bounding box of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingBox}.
		 *
		 * @type {?Box3}
		 * @default null
		 */ this.boundingBox = null;
        /**
		 * The bounding sphere of the batched mesh. Can be computed via {@link BatchedMesh#computeBoundingSphere}.
		 *
		 * @type {?Sphere}
		 * @default null
		 */ this.boundingSphere = null;
        /**
		 * Takes a sort a function that is run before render. The function takes a list of instances to
		 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered
		 * sort with.
		 *
		 * @type {?Function}
		 * @default null
		 */ this.customSort = null;
        // stores visible, active, and geometry id per instance and reserved buffer ranges for geometries
        this._instanceInfo = [];
        this._geometryInfo = [];
        // instance, geometry ids that have been set as inactive, and are available to be overwritten
        this._availableInstanceIds = [];
        this._availableGeometryIds = [];
        // used to track where the next point is that geometry should be inserted
        this._nextIndexStart = 0;
        this._nextVertexStart = 0;
        this._geometryCount = 0;
        // flags
        this._visibilityChanged = true;
        this._geometryInitialized = false;
        // cached user options
        this._maxInstanceCount = maxInstanceCount;
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        // buffers for multi draw
        this._multiDrawCounts = new Int32Array(maxInstanceCount);
        this._multiDrawStarts = new Int32Array(maxInstanceCount);
        this._multiDrawCount = 0;
        this._multiDrawInstances = null;
        // Local matrix per geometry by using data texture
        this._matricesTexture = null;
        this._indirectTexture = null;
        this._colorsTexture = null;
        this._initMatricesTexture();
        this._initIndirectTexture();
    }
    /**
	 * The maximum number of individual instances that can be stored in the batch.
	 *
	 * @type {number}
	 * @readonly
	 */ get maxInstanceCount() {
        return this._maxInstanceCount;
    }
    /**
	 * The instance count.
	 *
	 * @type {number}
	 * @readonly
	 */ get instanceCount() {
        return this._instanceInfo.length - this._availableInstanceIds.length;
    }
    /**
	 * The number of unused vertices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedVertexCount() {
        return this._maxVertexCount - this._nextVertexStart;
    }
    /**
	 * The number of unused indices.
	 *
	 * @type {number}
	 * @readonly
	 */ get unusedIndexCount() {
        return this._maxIndexCount - this._nextIndexStart;
    }
    _initMatricesTexture() {
        // layout (1 matrix = 4 pixels)
        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
        //  with  8x8  pixel texture max   16 matrices * 4 pixels =  (8 * 8)
        //       16x16 pixel texture max   64 matrices * 4 pixels = (16 * 16)
        //       32x32 pixel texture max  256 matrices * 4 pixels = (32 * 32)
        //       64x64 pixel texture max 1024 matrices * 4 pixels = (64 * 64)
        let size = Math.sqrt(this._maxInstanceCount * 4); // 4 pixels needed for 1 matrix
        size = Math.ceil(size / 4) * 4;
        size = Math.max(size, 4);
        const matricesArray = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
        const matricesTexture = new DataTexture(matricesArray, size, size, RGBAFormat, FloatType);
        this._matricesTexture = matricesTexture;
    }
    _initIndirectTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        const indirectArray = new Uint32Array(size * size);
        const indirectTexture = new DataTexture(indirectArray, size, size, RedIntegerFormat, UnsignedIntType);
        this._indirectTexture = indirectTexture;
    }
    _initColorsTexture() {
        let size = Math.sqrt(this._maxInstanceCount);
        size = Math.ceil(size);
        // 4 floats per RGBA pixel initialized to white
        const colorsArray = new Float32Array(size * size * 4).fill(1);
        const colorsTexture = new DataTexture(colorsArray, size, size, RGBAFormat, FloatType);
        colorsTexture.colorSpace = ColorManagement.workingColorSpace;
        this._colorsTexture = colorsTexture;
    }
    _initializeGeometry(reference) {
        const geometry = this.geometry;
        const maxVertexCount = this._maxVertexCount;
        const maxIndexCount = this._maxIndexCount;
        if (this._geometryInitialized === false) {
            for(const attributeName in reference.attributes){
                const srcAttribute = reference.getAttribute(attributeName);
                const { array, itemSize, normalized } = srcAttribute;
                const dstArray = new array.constructor(maxVertexCount * itemSize);
                const dstAttribute = new BufferAttribute(dstArray, itemSize, normalized);
                geometry.setAttribute(attributeName, dstAttribute);
            }
            if (reference.getIndex() !== null) {
                // Reserve last u16 index for primitive restart.
                const indexArray = maxVertexCount > 65535 ? new Uint32Array(maxIndexCount) : new Uint16Array(maxIndexCount);
                geometry.setIndex(new BufferAttribute(indexArray, 1));
            }
            this._geometryInitialized = true;
        }
    }
    // Make sure the geometry is compatible with the existing combined geometry attributes
    _validateGeometry(geometry) {
        // check to ensure the geometries are using consistent attributes and indices
        const batchGeometry = this.geometry;
        if (Boolean(geometry.getIndex()) !== Boolean(batchGeometry.getIndex())) throw new Error('THREE.BatchedMesh: All geometries must consistently have "index".');
        for(const attributeName in batchGeometry.attributes){
            if (!geometry.hasAttribute(attributeName)) throw new Error(`THREE.BatchedMesh: Added geometry missing "${attributeName}". All geometries must have consistent attributes.`);
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            if (srcAttribute.itemSize !== dstAttribute.itemSize || srcAttribute.normalized !== dstAttribute.normalized) throw new Error('THREE.BatchedMesh: All attributes must have a consistent itemSize and normalized value.');
        }
    }
    /**
	 * Validates the instance defined by the given ID.
	 *
	 * @param {number} instanceId - The instance to validate.
	 */ validateInstanceId(instanceId) {
        const instanceInfo = this._instanceInfo;
        if (instanceId < 0 || instanceId >= instanceInfo.length || instanceInfo[instanceId].active === false) throw new Error(`THREE.BatchedMesh: Invalid instanceId ${instanceId}. Instance is either out of range or has been deleted.`);
    }
    /**
	 * Validates the geometry defined by the given ID.
	 *
	 * @param {number} geometryId - The geometry to validate.
	 */ validateGeometryId(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId < 0 || geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) throw new Error(`THREE.BatchedMesh: Invalid geometryId ${geometryId}. Geometry is either out of range or has been deleted.`);
    }
    /**
	 * Takes a sort a function that is run before render. The function takes a list of instances to
	 * sort and a camera. The objects in the list include a "z" field to perform a depth-ordered sort with.
	 *
	 * @param {Function} func - The custom sort function.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setCustomSort(func) {
        this.customSort = func;
        return this;
    }
    /**
	 * Computes the bounding box, updating {@link BatchedMesh#boundingBox}.
	 * Bounding boxes aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingBox() {
        if (this.boundingBox === null) this.boundingBox = new Box3();
        const boundingBox = this.boundingBox;
        const instanceInfo = this._instanceInfo;
        boundingBox.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, _matrix$1);
            this.getBoundingBoxAt(geometryId, _box$1).applyMatrix4(_matrix$1);
            boundingBox.union(_box$1);
        }
    }
    /**
	 * Computes the bounding sphere, updating {@link BatchedMesh#boundingSphere}.
	 * Bounding spheres aren't computed by default. They need to be explicitly computed,
	 * otherwise they are `null`.
	 */ computeBoundingSphere() {
        if (this.boundingSphere === null) this.boundingSphere = new Sphere();
        const boundingSphere = this.boundingSphere;
        const instanceInfo = this._instanceInfo;
        boundingSphere.makeEmpty();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (instanceInfo[i].active === false) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            this.getMatrixAt(i, _matrix$1);
            this.getBoundingSphereAt(geometryId, _sphere$2).applyMatrix4(_matrix$1);
            boundingSphere.union(_sphere$2);
        }
    }
    /**
	 * Adds a new instance to the batch using the geometry of the given ID and returns
	 * a new id referring to the new instance to be used by other functions.
	 *
	 * @param {number} geometryId - The ID of a previously added geometry via {@link BatchedMesh#addGeometry}.
	 * @return {number} The instance ID.
	 */ addInstance(geometryId) {
        const atCapacity = this._instanceInfo.length >= this.maxInstanceCount;
        // ensure we're not over geometry
        if (atCapacity && this._availableInstanceIds.length === 0) throw new Error('THREE.BatchedMesh: Maximum item count reached.');
        const instanceInfo = {
            visible: true,
            active: true,
            geometryIndex: geometryId
        };
        let drawId = null;
        // Prioritize using previously freed instance ids
        if (this._availableInstanceIds.length > 0) {
            this._availableInstanceIds.sort(ascIdSort);
            drawId = this._availableInstanceIds.shift();
            this._instanceInfo[drawId] = instanceInfo;
        } else {
            drawId = this._instanceInfo.length;
            this._instanceInfo.push(instanceInfo);
        }
        const matricesTexture = this._matricesTexture;
        _matrix$1.identity().toArray(matricesTexture.image.data, drawId * 16);
        matricesTexture.needsUpdate = true;
        const colorsTexture = this._colorsTexture;
        if (colorsTexture) {
            _whiteColor.toArray(colorsTexture.image.data, drawId * 4);
            colorsTexture.needsUpdate = true;
        }
        this._visibilityChanged = true;
        return drawId;
    }
    /**
	 * Adds the given geometry to the batch and returns the associated
	 * geometry id referring to it to be used in other functions.
	 *
	 * @param {BufferGeometry} geometry - The geometry to add.
	 * @param {number} [reservedVertexCount=-1] - Optional parameter specifying the amount of
	 * vertex buffer space to reserve for the added geometry. This is necessary if it is planned
	 * to set a new geometry at this index at a later time that is larger than the original geometry.
	 * Defaults to the length of the given geometry vertex buffer.
	 * @param {number} [reservedIndexCount=-1] - Optional parameter specifying the amount of index
	 * buffer space to reserve for the added geometry. This is necessary if it is planned to set a
	 * new geometry at this index at a later time that is larger than the original geometry. Defaults to
	 * the length of the given geometry index buffer.
	 * @return {number} The geometry ID.
	 */ addGeometry(geometry, reservedVertexCount = -1, reservedIndexCount = -1) {
        this._initializeGeometry(geometry);
        this._validateGeometry(geometry);
        const geometryInfo = {
            // geometry information
            vertexStart: -1,
            vertexCount: -1,
            reservedVertexCount: -1,
            indexStart: -1,
            indexCount: -1,
            reservedIndexCount: -1,
            // draw range information
            start: -1,
            count: -1,
            // state
            boundingBox: null,
            boundingSphere: null,
            active: true
        };
        const geometryInfoList = this._geometryInfo;
        geometryInfo.vertexStart = this._nextVertexStart;
        geometryInfo.reservedVertexCount = reservedVertexCount === -1 ? geometry.getAttribute('position').count : reservedVertexCount;
        const index = geometry.getIndex();
        const hasIndex = index !== null;
        if (hasIndex) {
            geometryInfo.indexStart = this._nextIndexStart;
            geometryInfo.reservedIndexCount = reservedIndexCount === -1 ? index.count : reservedIndexCount;
        }
        if (geometryInfo.indexStart !== -1 && geometryInfo.indexStart + geometryInfo.reservedIndexCount > this._maxIndexCount || geometryInfo.vertexStart + geometryInfo.reservedVertexCount > this._maxVertexCount) throw new Error('THREE.BatchedMesh: Reserved space request exceeds the maximum buffer size.');
        // update id
        let geometryId;
        if (this._availableGeometryIds.length > 0) {
            this._availableGeometryIds.sort(ascIdSort);
            geometryId = this._availableGeometryIds.shift();
            geometryInfoList[geometryId] = geometryInfo;
        } else {
            geometryId = this._geometryCount;
            this._geometryCount++;
            geometryInfoList.push(geometryInfo);
        }
        // update the geometry
        this.setGeometryAt(geometryId, geometry);
        // increment the next geometry position
        this._nextIndexStart = geometryInfo.indexStart + geometryInfo.reservedIndexCount;
        this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        return geometryId;
    }
    /**
	 * Replaces the geometry at the given ID with the provided geometry. Throws an error if there
	 * is not enough space reserved for geometry. Calling this will change all instances that are
	 * rendering that geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry that should be replaced with the given geometry.
	 * @param {BufferGeometry} geometry - The new geometry.
	 * @return {number} The geometry ID.
	 */ setGeometryAt(geometryId, geometry) {
        if (geometryId >= this._geometryCount) throw new Error('THREE.BatchedMesh: Maximum geometry count reached.');
        this._validateGeometry(geometry);
        const batchGeometry = this.geometry;
        const hasIndex = batchGeometry.getIndex() !== null;
        const dstIndex = batchGeometry.getIndex();
        const srcIndex = geometry.getIndex();
        const geometryInfo = this._geometryInfo[geometryId];
        if (hasIndex && srcIndex.count > geometryInfo.reservedIndexCount || geometry.attributes.position.count > geometryInfo.reservedVertexCount) throw new Error('THREE.BatchedMesh: Reserved space not large enough for provided geometry.');
        // copy geometry buffer data over
        const vertexStart = geometryInfo.vertexStart;
        const reservedVertexCount = geometryInfo.reservedVertexCount;
        geometryInfo.vertexCount = geometry.getAttribute('position').count;
        for(const attributeName in batchGeometry.attributes){
            // copy attribute data
            const srcAttribute = geometry.getAttribute(attributeName);
            const dstAttribute = batchGeometry.getAttribute(attributeName);
            copyAttributeData(srcAttribute, dstAttribute, vertexStart);
            // fill the rest in with zeroes
            const itemSize = srcAttribute.itemSize;
            for(let i = srcAttribute.count, l = reservedVertexCount; i < l; i++){
                const index = vertexStart + i;
                for(let c = 0; c < itemSize; c++)dstAttribute.setComponent(index, c, 0);
            }
            dstAttribute.needsUpdate = true;
            dstAttribute.addUpdateRange(vertexStart * itemSize, reservedVertexCount * itemSize);
        }
        // copy index
        if (hasIndex) {
            const indexStart = geometryInfo.indexStart;
            const reservedIndexCount = geometryInfo.reservedIndexCount;
            geometryInfo.indexCount = geometry.getIndex().count;
            // copy index data over
            for(let i = 0; i < srcIndex.count; i++)dstIndex.setX(indexStart + i, vertexStart + srcIndex.getX(i));
            // fill the rest in with zeroes
            for(let i = srcIndex.count, l = reservedIndexCount; i < l; i++)dstIndex.setX(indexStart + i, vertexStart);
            dstIndex.needsUpdate = true;
            dstIndex.addUpdateRange(indexStart, geometryInfo.reservedIndexCount);
        }
        // update the draw range
        geometryInfo.start = hasIndex ? geometryInfo.indexStart : geometryInfo.vertexStart;
        geometryInfo.count = hasIndex ? geometryInfo.indexCount : geometryInfo.vertexCount;
        // store the bounding boxes
        geometryInfo.boundingBox = null;
        if (geometry.boundingBox !== null) geometryInfo.boundingBox = geometry.boundingBox.clone();
        geometryInfo.boundingSphere = null;
        if (geometry.boundingSphere !== null) geometryInfo.boundingSphere = geometry.boundingSphere.clone();
        this._visibilityChanged = true;
        return geometryId;
    }
    /**
	 * Deletes the geometry defined by the given ID from this batch. Any instances referencing
	 * this geometry will also be removed as a side effect.
	 *
	 * @param {number} geometryId - The ID of the geometry to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteGeometry(geometryId) {
        const geometryInfoList = this._geometryInfo;
        if (geometryId >= geometryInfoList.length || geometryInfoList[geometryId].active === false) return this;
        // delete any instances associated with this geometry
        const instanceInfo = this._instanceInfo;
        for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].active && instanceInfo[i].geometryIndex === geometryId) this.deleteInstance(i);
        geometryInfoList[geometryId].active = false;
        this._availableGeometryIds.push(geometryId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Deletes an existing instance from the batch using the given ID.
	 *
	 * @param {number} instanceId - The ID of the instance to remove from the batch.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ deleteInstance(instanceId) {
        this.validateInstanceId(instanceId);
        this._instanceInfo[instanceId].active = false;
        this._availableInstanceIds.push(instanceId);
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Repacks the sub geometries in BatchedMesh to remove any unused space remaining from
	 * previously deleted geometry, freeing up space to add new geometry.
	 *
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ optimize() {
        // track the next indices to copy data to
        let nextVertexStart = 0;
        let nextIndexStart = 0;
        // Iterate over all geometry ranges in order sorted from earliest in the geometry buffer to latest
        // in the geometry buffer. Because draw range objects can be reused there is no guarantee of their order.
        const geometryInfoList = this._geometryInfo;
        const indices = geometryInfoList.map((e, i)=>i).sort((a, b)=>{
            return geometryInfoList[a].vertexStart - geometryInfoList[b].vertexStart;
        });
        const geometry = this.geometry;
        for(let i = 0, l = geometryInfoList.length; i < l; i++){
            // if a geometry range is inactive then don't copy anything
            const index = indices[i];
            const geometryInfo = geometryInfoList[index];
            if (geometryInfo.active === false) continue;
            // if a geometry contains an index buffer then shift it, as well
            if (geometry.index !== null) {
                if (geometryInfo.indexStart !== nextIndexStart) {
                    const { indexStart, vertexStart, reservedIndexCount } = geometryInfo;
                    const index = geometry.index;
                    const array = index.array;
                    // shift the index pointers based on how the vertex data will shift
                    // adjusting the index must happen first so the original vertex start value is available
                    const elementDelta = nextVertexStart - vertexStart;
                    for(let j = indexStart; j < indexStart + reservedIndexCount; j++)array[j] = array[j] + elementDelta;
                    index.array.copyWithin(nextIndexStart, indexStart, indexStart + reservedIndexCount);
                    index.addUpdateRange(nextIndexStart, reservedIndexCount);
                    index.needsUpdate = true;
                    geometryInfo.indexStart = nextIndexStart;
                }
                nextIndexStart += geometryInfo.reservedIndexCount;
            }
            // if a geometry needs to be moved then copy attribute data to overwrite unused space
            if (geometryInfo.vertexStart !== nextVertexStart) {
                const { vertexStart, reservedVertexCount } = geometryInfo;
                const attributes = geometry.attributes;
                for(const key in attributes){
                    const attribute = attributes[key];
                    const { array, itemSize } = attribute;
                    array.copyWithin(nextVertexStart * itemSize, vertexStart * itemSize, (vertexStart + reservedVertexCount) * itemSize);
                    attribute.addUpdateRange(nextVertexStart * itemSize, reservedVertexCount * itemSize);
                    attribute.needsUpdate = true;
                }
                geometryInfo.vertexStart = nextVertexStart;
            }
            nextVertexStart += geometryInfo.reservedVertexCount;
            geometryInfo.start = geometry.index ? geometryInfo.indexStart : geometryInfo.vertexStart;
            // step the next geometry points to the shifted position
            this._nextIndexStart = geometry.index ? geometryInfo.indexStart + geometryInfo.reservedIndexCount : 0;
            this._nextVertexStart = geometryInfo.vertexStart + geometryInfo.reservedVertexCount;
        }
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Returns the bounding box for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding box for.
	 * @param {Box3} target - The target object that is used to store the method's result.
	 * @return {?Box3} The geometry's bounding box. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingBoxAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding box
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingBox === null) {
            const box = new Box3();
            const index = geometry.index;
            const position = geometry.attributes.position;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                box.expandByPoint(_vector$5.fromBufferAttribute(position, iv));
            }
            geometryInfo.boundingBox = box;
        }
        target.copy(geometryInfo.boundingBox);
        return target;
    }
    /**
	 * Returns the bounding sphere for the given geometry.
	 *
	 * @param {number} geometryId - The ID of the geometry to return the bounding sphere for.
	 * @param {Sphere} target - The target object that is used to store the method's result.
	 * @return {?Sphere} The geometry's bounding sphere. Returns `null` if no geometry has been found for the given ID.
	 */ getBoundingSphereAt(geometryId, target) {
        if (geometryId >= this._geometryCount) return null;
        // compute bounding sphere
        const geometry = this.geometry;
        const geometryInfo = this._geometryInfo[geometryId];
        if (geometryInfo.boundingSphere === null) {
            const sphere = new Sphere();
            this.getBoundingBoxAt(geometryId, _box$1);
            _box$1.getCenter(sphere.center);
            const index = geometry.index;
            const position = geometry.attributes.position;
            let maxRadiusSq = 0;
            for(let i = geometryInfo.start, l = geometryInfo.start + geometryInfo.count; i < l; i++){
                let iv = i;
                if (index) iv = index.getX(iv);
                _vector$5.fromBufferAttribute(position, iv);
                maxRadiusSq = Math.max(maxRadiusSq, sphere.center.distanceToSquared(_vector$5));
            }
            sphere.radius = Math.sqrt(maxRadiusSq);
            geometryInfo.boundingSphere = sphere;
        }
        target.copy(geometryInfo.boundingSphere);
        return target;
    }
    /**
	 * Sets the given local transformation matrix to the defined instance.
	 * Negatively scaled matrices are not supported.
	 *
	 * @param {number} instanceId - The ID of an instance to set the matrix of.
	 * @param {Matrix4} matrix - A 4x4 matrix representing the local transformation of a single instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        const matricesTexture = this._matricesTexture;
        const matricesArray = this._matricesTexture.image.data;
        matrix.toArray(matricesArray, instanceId * 16);
        matricesTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the local transformation matrix of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the matrix of.
	 * @param {Matrix4} matrix - The target object that is used to store the method's result.
	 * @return {Matrix4} The instance's local transformation matrix.
	 */ getMatrixAt(instanceId, matrix) {
        this.validateInstanceId(instanceId);
        return matrix.fromArray(this._matricesTexture.image.data, instanceId * 16);
    }
    /**
	 * Sets the given color to the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to set the color of.
	 * @param {Color} color - The color to set the instance to.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        if (this._colorsTexture === null) this._initColorsTexture();
        color.toArray(this._colorsTexture.image.data, instanceId * 4);
        this._colorsTexture.needsUpdate = true;
        return this;
    }
    /**
	 * Returns the color of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the color of.
	 * @param {Color} color - The target object that is used to store the method's result.
	 * @return {Color} The instance's color.
	 */ getColorAt(instanceId, color) {
        this.validateInstanceId(instanceId);
        return color.fromArray(this._colorsTexture.image.data, instanceId * 4);
    }
    /**
	 * Sets the visibility of the instance.
	 *
	 * @param {number} instanceId - The id of the instance to set the visibility of.
	 * @param {boolean} visible - Whether the instance is visible or not.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setVisibleAt(instanceId, visible) {
        this.validateInstanceId(instanceId);
        if (this._instanceInfo[instanceId].visible === visible) return this;
        this._instanceInfo[instanceId].visible = visible;
        this._visibilityChanged = true;
        return this;
    }
    /**
	 * Returns the visibility state of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the visibility state of.
	 * @return {boolean} Whether the instance is visible or not.
	 */ getVisibleAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].visible;
    }
    /**
	 * Sets the geometry ID of the instance at the given index.
	 *
	 * @param {number} instanceId - The ID of the instance to set the geometry ID of.
	 * @param {number} geometryId - The geometry ID to be use by the instance.
	 * @return {BatchedMesh} A reference to this batched mesh.
	 */ setGeometryIdAt(instanceId, geometryId) {
        this.validateInstanceId(instanceId);
        this.validateGeometryId(geometryId);
        this._instanceInfo[instanceId].geometryIndex = geometryId;
        return this;
    }
    /**
	 * Returns the geometry ID of the defined instance.
	 *
	 * @param {number} instanceId - The ID of an instance to get the geometry ID of.
	 * @return {number} The instance's geometry ID.
	 */ getGeometryIdAt(instanceId) {
        this.validateInstanceId(instanceId);
        return this._instanceInfo[instanceId].geometryIndex;
    }
    /**
	 * Get the range representing the subset of triangles related to the attached geometry,
	 * indicating the starting offset and count, or `null` if invalid.
	 *
	 * @param {number} geometryId - The id of the geometry to get the range of.
	 * @param {Object} [target] - The target object that is used to store the method's result.
	 * @return {{
	 * 	vertexStart:number,vertexCount:number,reservedVertexCount:number,
	 * 	indexStart:number,indexCount:number,reservedIndexCount:number,
	 * 	start:number,count:number
	 * }} The result object with range data.
	 */ getGeometryRangeAt(geometryId, target = {}) {
        this.validateGeometryId(geometryId);
        const geometryInfo = this._geometryInfo[geometryId];
        target.vertexStart = geometryInfo.vertexStart;
        target.vertexCount = geometryInfo.vertexCount;
        target.reservedVertexCount = geometryInfo.reservedVertexCount;
        target.indexStart = geometryInfo.indexStart;
        target.indexCount = geometryInfo.indexCount;
        target.reservedIndexCount = geometryInfo.reservedIndexCount;
        target.start = geometryInfo.start;
        target.count = geometryInfo.count;
        return target;
    }
    /**
	 * Resizes the necessary buffers to support the provided number of instances.
	 * If the provided arguments shrink the number of instances but there are not enough
	 * unused Ids at the end of the list then an error is thrown.
	 *
	 * @param {number} maxInstanceCount - The max number of individual instances that can be added and rendered by the batch.
	*/ setInstanceCount(maxInstanceCount) {
        // shrink the available instances as much as possible
        const availableInstanceIds = this._availableInstanceIds;
        const instanceInfo = this._instanceInfo;
        availableInstanceIds.sort(ascIdSort);
        while(availableInstanceIds[availableInstanceIds.length - 1] === instanceInfo.length - 1){
            instanceInfo.pop();
            availableInstanceIds.pop();
        }
        // throw an error if it can't be shrunk to the desired size
        if (maxInstanceCount < instanceInfo.length) throw new Error(`BatchedMesh: Instance ids outside the range ${maxInstanceCount} are being used. Cannot shrink instance count.`);
        // copy the multi draw counts
        const multiDrawCounts = new Int32Array(maxInstanceCount);
        const multiDrawStarts = new Int32Array(maxInstanceCount);
        copyArrayContents(this._multiDrawCounts, multiDrawCounts);
        copyArrayContents(this._multiDrawStarts, multiDrawStarts);
        this._multiDrawCounts = multiDrawCounts;
        this._multiDrawStarts = multiDrawStarts;
        this._maxInstanceCount = maxInstanceCount;
        // update texture data for instance sampling
        const indirectTexture = this._indirectTexture;
        const matricesTexture = this._matricesTexture;
        const colorsTexture = this._colorsTexture;
        indirectTexture.dispose();
        this._initIndirectTexture();
        copyArrayContents(indirectTexture.image.data, this._indirectTexture.image.data);
        matricesTexture.dispose();
        this._initMatricesTexture();
        copyArrayContents(matricesTexture.image.data, this._matricesTexture.image.data);
        if (colorsTexture) {
            colorsTexture.dispose();
            this._initColorsTexture();
            copyArrayContents(colorsTexture.image.data, this._colorsTexture.image.data);
        }
    }
    /**
	 * Resizes the available space in the batch's vertex and index buffer attributes to the provided sizes.
	 * If the provided arguments shrink the geometry buffers but there is not enough unused space at the
	 * end of the geometry attributes then an error is thrown.
	 *
	 * @param {number} maxVertexCount - The maximum number of vertices to be used by all unique geometries to resize to.
	 * @param {number} maxIndexCount - The maximum number of indices to be used by all unique geometries to resize to.
	*/ setGeometrySize(maxVertexCount, maxIndexCount) {
        // Check if we can shrink to the requested vertex attribute size
        const validRanges = [
            ...this._geometryInfo
        ].filter((info)=>info.active);
        const requiredVertexLength = Math.max(...validRanges.map((range)=>range.vertexStart + range.reservedVertexCount));
        if (requiredVertexLength > maxVertexCount) throw new Error(`BatchedMesh: Geometry vertex values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        // Check if we can shrink to the requested index attribute size
        if (this.geometry.index) {
            const requiredIndexLength = Math.max(...validRanges.map((range)=>range.indexStart + range.reservedIndexCount));
            if (requiredIndexLength > maxIndexCount) throw new Error(`BatchedMesh: Geometry index values are being used outside the range ${maxIndexCount}. Cannot shrink further.`);
        }
        //
        // dispose of the previous geometry
        const oldGeometry = this.geometry;
        oldGeometry.dispose();
        // recreate the geometry needed based on the previous variant
        this._maxVertexCount = maxVertexCount;
        this._maxIndexCount = maxIndexCount;
        if (this._geometryInitialized) {
            this._geometryInitialized = false;
            this.geometry = new BufferGeometry();
            this._initializeGeometry(oldGeometry);
        }
        // copy data from the previous geometry
        const geometry = this.geometry;
        if (oldGeometry.index) copyArrayContents(oldGeometry.index.array, geometry.index.array);
        for(const key in oldGeometry.attributes)copyArrayContents(oldGeometry.attributes[key].array, geometry.attributes[key].array);
    }
    raycast(raycaster, intersects) {
        const instanceInfo = this._instanceInfo;
        const geometryInfoList = this._geometryInfo;
        const matrixWorld = this.matrixWorld;
        const batchGeometry = this.geometry;
        // iterate over each geometry
        _mesh.material = this.material;
        _mesh.geometry.index = batchGeometry.index;
        _mesh.geometry.attributes = batchGeometry.attributes;
        if (_mesh.geometry.boundingBox === null) _mesh.geometry.boundingBox = new Box3();
        if (_mesh.geometry.boundingSphere === null) _mesh.geometry.boundingSphere = new Sphere();
        for(let i = 0, l = instanceInfo.length; i < l; i++){
            if (!instanceInfo[i].visible || !instanceInfo[i].active) continue;
            const geometryId = instanceInfo[i].geometryIndex;
            const geometryInfo = geometryInfoList[geometryId];
            _mesh.geometry.setDrawRange(geometryInfo.start, geometryInfo.count);
            // get the intersects
            this.getMatrixAt(i, _mesh.matrixWorld).premultiply(matrixWorld);
            this.getBoundingBoxAt(geometryId, _mesh.geometry.boundingBox);
            this.getBoundingSphereAt(geometryId, _mesh.geometry.boundingSphere);
            _mesh.raycast(raycaster, _batchIntersects);
            // add batch id to the intersects
            for(let j = 0, l = _batchIntersects.length; j < l; j++){
                const intersect = _batchIntersects[j];
                intersect.object = this;
                intersect.batchId = i;
                intersects.push(intersect);
            }
            _batchIntersects.length = 0;
        }
        _mesh.material = null;
        _mesh.geometry.index = null;
        _mesh.geometry.attributes = {};
        _mesh.geometry.setDrawRange(0, Infinity);
    }
    copy(source) {
        super.copy(source);
        this.geometry = source.geometry.clone();
        this.perObjectFrustumCulled = source.perObjectFrustumCulled;
        this.sortObjects = source.sortObjects;
        this.boundingBox = source.boundingBox !== null ? source.boundingBox.clone() : null;
        this.boundingSphere = source.boundingSphere !== null ? source.boundingSphere.clone() : null;
        this._geometryInfo = source._geometryInfo.map((info)=>({
                ...info,
                boundingBox: info.boundingBox !== null ? info.boundingBox.clone() : null,
                boundingSphere: info.boundingSphere !== null ? info.boundingSphere.clone() : null
            }));
        this._instanceInfo = source._instanceInfo.map((info)=>({
                ...info
            }));
        this._availableInstanceIds = source._availableInstanceIds.slice();
        this._availableGeometryIds = source._availableGeometryIds.slice();
        this._nextIndexStart = source._nextIndexStart;
        this._nextVertexStart = source._nextVertexStart;
        this._geometryCount = source._geometryCount;
        this._maxInstanceCount = source._maxInstanceCount;
        this._maxVertexCount = source._maxVertexCount;
        this._maxIndexCount = source._maxIndexCount;
        this._geometryInitialized = source._geometryInitialized;
        this._multiDrawCounts = source._multiDrawCounts.slice();
        this._multiDrawStarts = source._multiDrawStarts.slice();
        this._indirectTexture = source._indirectTexture.clone();
        this._indirectTexture.image.data = this._indirectTexture.image.data.slice();
        this._matricesTexture = source._matricesTexture.clone();
        this._matricesTexture.image.data = this._matricesTexture.image.data.slice();
        if (this._colorsTexture !== null) {
            this._colorsTexture = source._colorsTexture.clone();
            this._colorsTexture.image.data = this._colorsTexture.image.data.slice();
        }
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        // Assuming the geometry is not shared with other meshes
        this.geometry.dispose();
        this._matricesTexture.dispose();
        this._matricesTexture = null;
        this._indirectTexture.dispose();
        this._indirectTexture = null;
        if (this._colorsTexture !== null) {
            this._colorsTexture.dispose();
            this._colorsTexture = null;
        }
    }
    onBeforeRender(renderer, scene, camera, geometry, material /*, _group*/ ) {
        // if visibility has not changed and frustum culling and object sorting is not required
        // then skip iterating over all items
        if (!this._visibilityChanged && !this.perObjectFrustumCulled && !this.sortObjects) return;
        // the indexed version of the multi draw function requires specifying the start
        // offset in bytes.
        const index = geometry.getIndex();
        const bytesPerElement = index === null ? 1 : index.array.BYTES_PER_ELEMENT;
        const instanceInfo = this._instanceInfo;
        const multiDrawStarts = this._multiDrawStarts;
        const multiDrawCounts = this._multiDrawCounts;
        const geometryInfoList = this._geometryInfo;
        const perObjectFrustumCulled = this.perObjectFrustumCulled;
        const indirectTexture = this._indirectTexture;
        const indirectArray = indirectTexture.image.data;
        const frustum = camera.isArrayCamera ? _frustumArray : _frustum;
        // prepare the frustum in the local frame
        if (perObjectFrustumCulled && !camera.isArrayCamera) {
            _matrix$1.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse).multiply(this.matrixWorld);
            _frustum.setFromProjectionMatrix(_matrix$1, camera.coordinateSystem, camera.reversedDepth);
        }
        let multiDrawCount = 0;
        if (this.sortObjects) {
            // get the camera position in the local frame
            _matrix$1.copy(this.matrixWorld).invert();
            _vector$5.setFromMatrixPosition(camera.matrixWorld).applyMatrix4(_matrix$1);
            _forward$1.set(0, 0, -1).transformDirection(camera.matrixWorld).transformDirection(_matrix$1);
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // get the bounds in world space
                this.getMatrixAt(i, _matrix$1);
                this.getBoundingSphereAt(geometryId, _sphere$2).applyMatrix4(_matrix$1);
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) culled = !frustum.intersectsSphere(_sphere$2, camera);
                if (!culled) {
                    // get the distance from camera used for sorting
                    const geometryInfo = geometryInfoList[geometryId];
                    const z = _temp.subVectors(_sphere$2.center, _vector$5).dot(_forward$1);
                    _renderList.push(geometryInfo.start, geometryInfo.count, z, i);
                }
            }
            // Sort the draw ranges and prep for rendering
            const list = _renderList.list;
            const customSort = this.customSort;
            if (customSort === null) list.sort(material.transparent ? sortTransparent : sortOpaque);
            else customSort.call(this, list, camera);
            for(let i = 0, l = list.length; i < l; i++){
                const item = list[i];
                multiDrawStarts[multiDrawCount] = item.start * bytesPerElement;
                multiDrawCounts[multiDrawCount] = item.count;
                indirectArray[multiDrawCount] = item.index;
                multiDrawCount++;
            }
            _renderList.reset();
        } else {
            for(let i = 0, l = instanceInfo.length; i < l; i++)if (instanceInfo[i].visible && instanceInfo[i].active) {
                const geometryId = instanceInfo[i].geometryIndex;
                // determine whether the batched geometry is within the frustum
                let culled = false;
                if (perObjectFrustumCulled) {
                    // get the bounds in world space
                    this.getMatrixAt(i, _matrix$1);
                    this.getBoundingSphereAt(geometryId, _sphere$2).applyMatrix4(_matrix$1);
                    culled = !frustum.intersectsSphere(_sphere$2, camera);
                }
                if (!culled) {
                    const geometryInfo = geometryInfoList[geometryId];
                    multiDrawStarts[multiDrawCount] = geometryInfo.start * bytesPerElement;
                    multiDrawCounts[multiDrawCount] = geometryInfo.count;
                    indirectArray[multiDrawCount] = i;
                    multiDrawCount++;
                }
            }
        }
        indirectTexture.needsUpdate = true;
        this._multiDrawCount = multiDrawCount;
        this._visibilityChanged = false;
    }
    onBeforeShadow(renderer, object, camera, shadowCamera, geometry, depthMaterial /* , group */ ) {
        this.onBeforeRender(renderer, null, shadowCamera, geometry, depthMaterial);
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 * ```
 *
 * @augments Material
 */ class LineBasicMaterial extends Material {
    /**
	 * Constructs a new line basic material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineBasicMaterial = true;
        this.type = 'LineBasicMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new Color(0xffffff);
        /**
		 * Sets the color of the lines using data from a texture. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Controls line thickness or lines.
		 *
		 * Can only be used with {@link SVGRenderer}. WebGL and WebGPU
		 * ignore this setting and always render line primitives with a
		 * width of one pixel.
		 *
		 * @type {number}
		 * @default 1
		 */ this.linewidth = 1;
        /**
		 * Defines appearance of line ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('butt'|'round'|'square')}
		 * @default 'round'
		 */ this.linecap = 'round';
        /**
		 * Defines appearance of line joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.linejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.linewidth = source.linewidth;
        this.linecap = source.linecap;
        this.linejoin = source.linejoin;
        this.fog = source.fog;
        return this;
    }
}
const _vStart = /*@__PURE__*/ new Vector3();
const _vEnd = /*@__PURE__*/ new Vector3();
const _inverseMatrix$1 = /*@__PURE__*/ new Matrix4();
const _ray$1 = /*@__PURE__*/ new Ray();
const _sphere$1 = /*@__PURE__*/ new Sphere();
const _intersectPointOnRay = /*@__PURE__*/ new Vector3();
const _intersectPointOnSegment = /*@__PURE__*/ new Vector3();
/**
 * A continuous line. The line are rendered by connecting consecutive
 * vertices with straight lines.
 *
 * ```js
 * const material = new THREE.LineBasicMaterial( { color: 0x0000ff } );
 *
 * const points = [];
 * points.push( new THREE.Vector3( - 10, 0, 0 ) );
 * points.push( new THREE.Vector3( 0, 10, 0 ) );
 * points.push( new THREE.Vector3( 10, 0, 0 ) );
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments Object3D
 */ class Line extends Object3D {
    /**
	 * Constructs a new line.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry = new BufferGeometry(), material = new LineBasicMaterial()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLine = true;
        this.type = 'Line';
        /**
		 * The line geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default LineBasicMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<string,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes an array of distance values which are necessary for rendering dashed lines.
	 * For each vertex in the geometry, the method calculates the cumulative length from the
	 * current point to the very beginning of the line.
	 *
	 * @return {Line} A reference to this line.
	 */ computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [
                0
            ];
            for(let i = 1, l = positionAttribute.count; i < l; i++){
                _vStart.fromBufferAttribute(positionAttribute, i - 1);
                _vEnd.fromBufferAttribute(positionAttribute, i);
                lineDistances[i] = lineDistances[i - 1];
                lineDistances[i] += _vStart.distanceTo(_vEnd);
            }
            geometry.setAttribute('lineDistance', new Float32BufferAttribute(lineDistances, 1));
        } else warn('Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this line.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere$1.copy(geometry.boundingSphere);
        _sphere$1.applyMatrix4(matrixWorld);
        _sphere$1.radius += threshold;
        if (raycaster.ray.intersectsSphere(_sphere$1) === false) return;
        //
        _inverseMatrix$1.copy(matrixWorld).invert();
        _ray$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const step = this.isLineSegments ? 2 : 1;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const a = index.getX(i);
                const b = index.getX(i + 1);
                const intersect = checkIntersection(this, raycaster, _ray$1, localThresholdSq, a, b, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const a = index.getX(end - 1);
                const b = index.getX(start);
                const intersect = checkIntersection(this, raycaster, _ray$1, localThresholdSq, a, b, end - 1);
                if (intersect) intersects.push(intersect);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end - 1; i < l; i += step){
                const intersect = checkIntersection(this, raycaster, _ray$1, localThresholdSq, i, i + 1, i);
                if (intersect) intersects.push(intersect);
            }
            if (this.isLineLoop) {
                const intersect = checkIntersection(this, raycaster, _ray$1, localThresholdSq, end - 1, start, end - 1);
                if (intersect) intersects.push(intersect);
            }
        }
    }
    /**
	 * Sets the values of {@link Line#morphTargetDictionary} and {@link Line#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function checkIntersection(object, raycaster, ray, thresholdSq, a, b, i) {
    const positionAttribute = object.geometry.attributes.position;
    _vStart.fromBufferAttribute(positionAttribute, a);
    _vEnd.fromBufferAttribute(positionAttribute, b);
    const distSq = ray.distanceSqToSegment(_vStart, _vEnd, _intersectPointOnRay, _intersectPointOnSegment);
    if (distSq > thresholdSq) return;
    _intersectPointOnRay.applyMatrix4(object.matrixWorld); // Move back to world space for distance calculation
    const distance = raycaster.ray.origin.distanceTo(_intersectPointOnRay);
    if (distance < raycaster.near || distance > raycaster.far) return;
    return {
        distance: distance,
        // What do we want? intersection point on the ray or on the segment??
        // point: raycaster.ray.at( distance ),
        point: _intersectPointOnSegment.clone().applyMatrix4(object.matrixWorld),
        index: i,
        face: null,
        faceIndex: null,
        barycoord: null,
        object: object
    };
}
const _start = /*@__PURE__*/ new Vector3();
const _end = /*@__PURE__*/ new Vector3();
/**
 * A series of lines drawn between pairs of vertices.
 *
 * @augments Line
 */ class LineSegments extends Line {
    /**
	 * Constructs a new line segments.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineSegments = true;
        this.type = 'LineSegments';
    }
    computeLineDistances() {
        const geometry = this.geometry;
        // we assume non-indexed geometry
        if (geometry.index === null) {
            const positionAttribute = geometry.attributes.position;
            const lineDistances = [];
            for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                _start.fromBufferAttribute(positionAttribute, i);
                _end.fromBufferAttribute(positionAttribute, i + 1);
                lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                lineDistances[i + 1] = lineDistances[i] + _start.distanceTo(_end);
            }
            geometry.setAttribute('lineDistance', new Float32BufferAttribute(lineDistances, 1));
        } else warn('LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        return this;
    }
}
/**
 * A continuous line. This is nearly the same as {@link Line} the only difference
 * is that the last vertex is connected with the first vertex in order to close
 * the line to form a loop.
 *
 * @augments Line
 */ class LineLoop extends Line {
    /**
	 * Constructs a new line loop.
	 *
	 * @param {BufferGeometry} [geometry] - The line geometry.
	 * @param {Material|Array<Material>} [material] - The line material.
	 */ constructor(geometry, material){
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineLoop = true;
        this.type = 'LineLoop';
    }
}
/**
 * A material for rendering point primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const vertices = [];
 *
 * for ( let i = 0; i < 10000; i ++ ) {
 * 	const x = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const y = THREE.MathUtils.randFloatSpread( 2000 );
 * 	const z = THREE.MathUtils.randFloatSpread( 2000 );
 *
 * 	vertices.push( x, y, z );
 * }
 *
 * const geometry = new THREE.BufferGeometry();
 * geometry.setAttribute( 'position', new THREE.Float32BufferAttribute( vertices, 3 ) );
 * const material = new THREE.PointsMaterial( { color: 0x888888 } );
 * const points = new THREE.Points( geometry, material );
 * scene.add( points );
 * ```
 *
 * @augments Material
 */ class PointsMaterial extends Material {
    /**
	 * Constructs a new points material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointsMaterial = true;
        this.type = 'PointsMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new Color(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Defines the size of the points in pixels.
		 *
		 * Might be capped if the value exceeds hardware dependent parameters like [gl.ALIASED_POINT_SIZE_RANGE](https://developer.mozilla.org/en-US/docs/Web/API/WebGLRenderingContext/getParamete).
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = 1;
        /**
		 * Specifies whether size of individual points is attenuated by the camera depth (perspective camera only).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.sizeAttenuation = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.size = source.size;
        this.sizeAttenuation = source.sizeAttenuation;
        this.fog = source.fog;
        return this;
    }
}
const _inverseMatrix = /*@__PURE__*/ new Matrix4();
const _ray = /*@__PURE__*/ new Ray();
const _sphere = /*@__PURE__*/ new Sphere();
const _position$2 = /*@__PURE__*/ new Vector3();
/**
 * A class for displaying points or point clouds.
 *
 * @augments Object3D
 */ class Points extends Object3D {
    /**
	 * Constructs a new point cloud.
	 *
	 * @param {BufferGeometry} [geometry] - The points geometry.
	 * @param {Material|Array<Material>} [material] - The points material.
	 */ constructor(geometry = new BufferGeometry(), material = new PointsMaterial()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPoints = true;
        this.type = 'Points';
        /**
		 * The points geometry.
		 *
		 * @type {BufferGeometry}
		 */ this.geometry = geometry;
        /**
		 * The line material.
		 *
		 * @type {Material|Array<Material>}
		 * @default PointsMaterial
		 */ this.material = material;
        /**
		 * A dictionary representing the morph targets in the geometry. The key is the
		 * morph targets name, the value its attribute index. This member is `undefined`
		 * by default and only set when morph targets are detected in the geometry.
		 *
		 * @type {Object<string,number>|undefined}
		 * @default undefined
		 */ this.morphTargetDictionary = undefined;
        /**
		 * An array of weights typically in the range `[0,1]` that specify how much of the morph
		 * is applied. This member is `undefined` by default and only set when morph targets are
		 * detected in the geometry.
		 *
		 * @type {Array<number>|undefined}
		 * @default undefined
		 */ this.morphTargetInfluences = undefined;
        this.updateMorphTargets();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.material = Array.isArray(source.material) ? source.material.slice() : source.material;
        this.geometry = source.geometry;
        return this;
    }
    /**
	 * Computes intersection points between a casted ray and this point cloud.
	 *
	 * @param {Raycaster} raycaster - The raycaster.
	 * @param {Array<Object>} intersects - The target array that holds the intersection points.
	 */ raycast(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        const drawRange = geometry.drawRange;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere.copy(geometry.boundingSphere);
        _sphere.applyMatrix4(matrixWorld);
        _sphere.radius += threshold;
        if (raycaster.ray.intersectsSphere(_sphere) === false) return;
        //
        _inverseMatrix.copy(matrixWorld).invert();
        _ray.copy(raycaster.ray).applyMatrix4(_inverseMatrix);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const index = geometry.index;
        const attributes = geometry.attributes;
        const positionAttribute = attributes.position;
        if (index !== null) {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(index.count, drawRange.start + drawRange.count);
            for(let i = start, il = end; i < il; i++){
                const a = index.getX(i);
                _position$2.fromBufferAttribute(positionAttribute, a);
                testPoint(_position$2, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else {
            const start = Math.max(0, drawRange.start);
            const end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(let i = start, l = end; i < l; i++){
                _position$2.fromBufferAttribute(positionAttribute, i);
                testPoint(_position$2, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        }
    }
    /**
	 * Sets the values of {@link Points#morphTargetDictionary} and {@link Points#morphTargetInfluences}
	 * to make sure existing morph targets can influence this 3D object.
	 */ updateMorphTargets() {
        const geometry = this.geometry;
        const morphAttributes = geometry.morphAttributes;
        const keys = Object.keys(morphAttributes);
        if (keys.length > 0) {
            const morphAttribute = morphAttributes[keys[0]];
            if (morphAttribute !== undefined) {
                this.morphTargetInfluences = [];
                this.morphTargetDictionary = {};
                for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                    const name = morphAttribute[m].name || String(m);
                    this.morphTargetInfluences.push(0);
                    this.morphTargetDictionary[name] = m;
                }
            }
        }
    }
}
function testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = _ray.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new Vector3();
        _ray.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            faceIndex: null,
            barycoord: null,
            object: object
        });
    }
}
/**
 * A texture for use with a video.
 *
 * ```js
 * // assuming you have created a HTML video element with id="video"
 * const video = document.getElementById( 'video' );
 * const texture = new THREE.VideoTexture( video );
 * ```
 *
 * Note: When using video textures with {@link WebGPURenderer}, {@link Texture#colorSpace} must be
 * set to THREE.SRGBColorSpace.
 *
 * Note: After the initial use of a texture, its dimensions, format, and type
 * cannot be changed. Instead, call {@link Texture#dispose} on the texture and instantiate a new one.
 *
 * @augments Texture
 */ class VideoTexture extends Texture {
    /**
	 * Constructs a new video texture.
	 *
	 * @param {HTMLVideoElement} video - The video element to use as a data source for the texture.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(video, mapping, wrapS, wrapT, magFilter = LinearFilter, minFilter = LinearFilter, format, type, anisotropy){
        super(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoTexture = true;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * The video frame request callback identifier, which is a positive integer.
		 *
		 * Value of 0 represents no scheduled rVFC.
		 *
		 * @private
		 * @type {number}
		 */ this._requestVideoFrameCallbackId = 0;
        const scope = this;
        function updateVideo() {
            scope.needsUpdate = true;
            scope._requestVideoFrameCallbackId = video.requestVideoFrameCallback(updateVideo);
        }
        if ('requestVideoFrameCallback' in video) this._requestVideoFrameCallbackId = video.requestVideoFrameCallback(updateVideo);
    }
    clone() {
        return new this.constructor(this.image).copy(this);
    }
    /**
	 * This method is called automatically by the renderer and sets {@link Texture#needsUpdate}
	 * to `true` every time a new frame is available.
	 *
	 * Only relevant if `requestVideoFrameCallback` is not supported in the browser.
	 */ update() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
    dispose() {
        if (this._requestVideoFrameCallbackId !== 0) {
            this.source.data.cancelVideoFrameCallback(this._requestVideoFrameCallbackId);
            this._requestVideoFrameCallbackId = 0;
        }
        super.dispose();
    }
}
/**
 * This class can be used as an alternative way to define video data. Instead of using
 * an instance of `HTMLVideoElement` like with `VideoTexture`, `VideoFrameTexture` expects each frame is
 * defined manually via {@link VideoFrameTexture#setFrame}. A typical use case for this module is when
 * video frames are decoded with the WebCodecs API.
 *
 * ```js
 * const texture = new THREE.VideoFrameTexture();
 * texture.setFrame( frame );
 * ```
 *
 * @augments VideoTexture
 */ class VideoFrameTexture extends VideoTexture {
    /**
	 * Constructs a new video frame texture.
	 *
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super({}, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isVideoFrameTexture = true;
    }
    /**
	 * This method overwritten with an empty implementation since
	 * this type of texture is updated via `setFrame()`.
	 */ update() {}
    clone() {
        return new this.constructor().copy(this); // restoring Texture.clone()
    }
    /**
	 * Sets the current frame of the video. This will automatically update the texture
	 * so the data can be used for rendering.
	 *
	 * @param {VideoFrame} frame - The video frame.
	 */ setFrame(frame) {
        this.image = frame;
        this.needsUpdate = true;
    }
}
/**
 * This class can only be used in combination with `copyFramebufferToTexture()` methods
 * of renderers. It extracts the contents of the current bound framebuffer and provides it
 * as a texture for further usage.
 *
 * ```js
 * const pixelRatio = window.devicePixelRatio;
 * const textureSize = 128 * pixelRatio;
 *
 * const frameTexture = new FramebufferTexture( textureSize, textureSize );
 *
 * // calculate start position for copying part of the frame data
 * const vector = new Vector2();
 * vector.x = ( window.innerWidth * pixelRatio / 2 ) - ( textureSize / 2 );
 * vector.y = ( window.innerHeight * pixelRatio / 2 ) - ( textureSize / 2 );
 *
 * renderer.render( scene, camera );
 *
 * // copy part of the rendered frame into the framebuffer texture
 * renderer.copyFramebufferToTexture( frameTexture, vector );
 * ```
 *
 * @augments Texture
 */ class FramebufferTexture extends Texture {
    /**
	 * Constructs a new framebuffer texture.
	 *
	 * @param {number} [width] - The width of the texture.
	 * @param {number} [height] - The height of the texture.
	 */ constructor(width, height){
        super({
            width,
            height
        });
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isFramebufferTexture = true;
        /**
		 * How the texture is sampled when a texel covers more than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.magFilter = NearestFilter;
        /**
		 * How the texture is sampled when a texel covers less than one pixel.
		 *
		 * Overwritten and set to `NearestFilter` by default to disable filtering.
		 *
		 * @type {(NearestFilter|NearestMipmapNearestFilter|NearestMipmapLinearFilter|LinearFilter|LinearMipmapNearestFilter|LinearMipmapLinearFilter)}
		 * @default NearestFilter
		 */ this.minFilter = NearestFilter;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        this.needsUpdate = true;
    }
}
/**
 * Creates a texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments Texture
 */ class CompressedTexture extends Texture {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {string} [colorSpace=NoColorSpace] - The color space.
	 */ constructor(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, colorSpace){
        super(null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, colorSpace);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @type {{width:number,height:number}}
		 */ this.image = {
            width: width,
            height: height
        };
        /**
		 * This array holds for all mipmaps (including the bases mip) the data and dimensions.
		 *
		 * @type {Array<Object>}
		 */ this.mipmaps = mipmaps;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default since it is not possible to
		 * flip compressed textures.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default since it is not
		 * possible to generate mipmaps for compressed data. Mipmaps
		 * must be embedded in the compressed texture file.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.generateMipmaps = false;
    }
}
/**
 * Creates a texture 2D array based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class CompressedArrayTexture extends CompressedTexture {
    /**
	 * Constructs a new compressed array texture.
	 *
	 * @param {Array<Object>} mipmaps - This array holds for all mipmaps (including the bases mip)
	 * the data and dimensions.
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} depth - The depth of the texture.
	 * @param {number} [format=RGBAFormat] - The min filter value.
	 * @param {number} [type=UnsignedByteType] - The min filter value.
	 */ constructor(mipmaps, width, height, depth, format, type){
        super(mipmaps, width, height, format, type);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedArrayTexture = true;
        /**
		 * The image property of a compressed texture just defines its dimensions.
		 *
		 * @name CompressedArrayTexture#image
		 * @type {{width:number,height:number,depth:number}}
		 */ this.image.depth = depth;
        /**
		 * This defines how the texture is wrapped in the depth and corresponds to
		 * *W* in UVW mapping.
		 *
		 * @type {(RepeatWrapping|ClampToEdgeWrapping|MirroredRepeatWrapping)}
		 * @default ClampToEdgeWrapping
		 */ this.wrapR = ClampToEdgeWrapping;
        /**
		 * A set of all layers which need to be updated in the texture.
		 *
		 * @type {Set<number>}
		 */ this.layerUpdates = new Set();
    }
    /**
	 * Describes that a specific layer of the texture needs to be updated.
	 * Normally when {@link Texture#needsUpdate} is set to `true`, the
	 * entire compressed texture array is sent to the GPU. Marking specific
	 * layers will only transmit subsets of all mipmaps associated with a
	 * specific depth in the array which is often much more performant.
	 *
	 * @param {number} layerIndex - The layer index that should be updated.
	 */ addLayerUpdate(layerIndex) {
        this.layerUpdates.add(layerIndex);
    }
    /**
	 * Resets the layer updates registry.
	 */ clearLayerUpdates() {
        this.layerUpdates.clear();
    }
}
/**
 * Creates a cube texture based on data in compressed form.
 *
 * These texture are usually loaded with {@link CompressedTextureLoader}.
 *
 * @augments CompressedTexture
 */ class CompressedCubeTexture extends CompressedTexture {
    /**
	 * Constructs a new compressed texture.
	 *
	 * @param {Array<CompressedTexture>} images - An array of compressed textures.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 */ constructor(images, format, type){
        super(undefined, images[0].width, images[0].height, format, type, CubeReflectionMapping);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCompressedCubeTexture = true;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
        this.image = images;
    }
}
/**
 * Creates a texture from a canvas element.
 *
 * This is almost the same as the base texture class, except that it sets {@link Texture#needsUpdate}
 * to `true` immediately since a canvas can directly be used for rendering.
 *
 * @augments Texture
 */ class CanvasTexture extends Texture {
    /**
	 * Constructs a new texture.
	 *
	 * @param {HTMLCanvasElement} [canvas] - The HTML canvas element.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearMipmapLinearFilter] - The min filter value.
	 * @param {number} [format=RGBAFormat] - The texture format.
	 * @param {number} [type=UnsignedByteType] - The texture type.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 */ constructor(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy){
        super(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCanvasTexture = true;
        this.needsUpdate = true;
    }
}
/**
 * This class can be used to automatically save the depth information of a
 * rendering into a texture.
 *
 * @augments Texture
 */ class DepthTexture extends Texture {
    /**
	 * Constructs a new depth texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} [type=UnsignedIntType] - The texture type.
	 * @param {number} [mapping=Texture.DEFAULT_MAPPING] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=LinearFilter] - The mag filter value.
	 * @param {number} [minFilter=LinearFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {number} [format=DepthFormat] - The texture format.
	 * @param {number} [depth=1] - The depth of the texture.
	 */ constructor(width, height, type = UnsignedIntType, mapping, wrapS, wrapT, magFilter = NearestFilter, minFilter = NearestFilter, anisotropy, format = DepthFormat, depth = 1){
        if (format !== DepthFormat && format !== DepthStencilFormat) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
        const image = {
            width: width,
            height: height,
            depth: depth
        };
        super(image, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDepthTexture = true;
        /**
		 * If set to `true`, the texture is flipped along the vertical axis when
		 * uploaded to the GPU.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flipY = false;
        /**
		 * Whether to generate mipmaps (if possible) for a texture.
		 *
		 * Overwritten and set to `false` by default.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.generateMipmaps = false;
        /**
		 * Code corresponding to the depth compare function.
		 *
		 * @type {?(NeverCompare|LessCompare|EqualCompare|LessEqualCompare|GreaterCompare|NotEqualCompare|GreaterEqualCompare|AlwaysCompare)}
		 * @default null
		 */ this.compareFunction = null;
    }
    copy(source) {
        super.copy(source);
        this.source = new Source(Object.assign({}, source.image)); // see #30540
        this.compareFunction = source.compareFunction;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.compareFunction !== null) data.compareFunction = this.compareFunction;
        return data;
    }
}
/**
 * This class can be used to automatically save the depth information of a
 * cube rendering into a cube texture with depth format. Used for PointLight shadows.
 *
 * @augments DepthTexture
 */ class CubeDepthTexture extends DepthTexture {
    /**
	 * Constructs a new cube depth texture.
	 *
	 * @param {number} size - The size (width and height) of each cube face.
	 * @param {number} [type=UnsignedIntType] - The texture type.
	 * @param {number} [mapping=CubeReflectionMapping] - The texture mapping.
	 * @param {number} [wrapS=ClampToEdgeWrapping] - The wrapS value.
	 * @param {number} [wrapT=ClampToEdgeWrapping] - The wrapT value.
	 * @param {number} [magFilter=NearestFilter] - The mag filter value.
	 * @param {number} [minFilter=NearestFilter] - The min filter value.
	 * @param {number} [anisotropy=Texture.DEFAULT_ANISOTROPY] - The anisotropy value.
	 * @param {number} [format=DepthFormat] - The texture format.
	 */ constructor(size, type = UnsignedIntType, mapping = CubeReflectionMapping, wrapS, wrapT, magFilter = NearestFilter, minFilter = NearestFilter, anisotropy, format = DepthFormat){
        // Create 6 identical image descriptors for the cube faces
        const image = {
            width: size,
            height: size,
            depth: 1
        };
        const images = [
            image,
            image,
            image,
            image,
            image,
            image
        ];
        // Call DepthTexture constructor with width, height
        super(size, size, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format);
        // Replace the single image with the array of 6 images
        this.image = images;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeDepthTexture = true;
        /**
		 * Set to true for cube texture handling in WebGLTextures.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubeTexture = true;
    }
    /**
	 * Alias for {@link CubeDepthTexture#image}.
	 *
	 * @type {Array<Image>}
	 */ get images() {
        return this.image;
    }
    set images(value) {
        this.image = value;
    }
}
/**
 * Represents a texture created externally with the same renderer context.
 *
 * This may be a texture from a protected media stream, device camera feed,
 * or other data feeds like a depth sensor.
 *
 * Note that this class is only supported in {@link WebGLRenderer}, and in
 * the {@link WebGPURenderer} WebGPU backend.
 *
 * @augments Texture
 */ class ExternalTexture extends Texture {
    /**
	 * Creates a new raw texture.
	 *
	 * @param {?(WebGLTexture|GPUTexture)} [sourceTexture=null] - The external texture.
	 */ constructor(sourceTexture = null){
        super();
        /**
		 * The external source texture.
		 *
		 * @type {?(WebGLTexture|GPUTexture)}
		 * @default null
		 */ this.sourceTexture = sourceTexture;
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isExternalTexture = true;
    }
    copy(source) {
        super.copy(source);
        this.sourceTexture = source.sourceTexture;
        return this;
    }
}
/**
 * A geometry class for representing a capsule.
 *
 * ```js
 * const geometry = new THREE.CapsuleGeometry( 1, 1, 4, 8, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const capsule = new THREE.Mesh( geometry, material );
 * scene.add( capsule );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CapsuleGeometry
 */ class CapsuleGeometry extends BufferGeometry {
    /**
	 * Constructs a new capsule geometry.
	 *
	 * @param {number} [radius=1] - Radius of the capsule.
	 * @param {number} [height=1] - Height of the middle section.
	 * @param {number} [capSegments=4] - Number of curve segments used to build each cap.
	 * @param {number} [radialSegments=8] - Number of segmented faces around the circumference of the capsule. Must be an integer >= 3.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the middle section. Must be an integer >= 1.
	 */ constructor(radius = 1, height = 1, capSegments = 4, radialSegments = 8, heightSegments = 1){
        super();
        this.type = 'CapsuleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            capSegments: capSegments,
            radialSegments: radialSegments,
            heightSegments: heightSegments
        };
        height = Math.max(0, height);
        capSegments = Math.max(1, Math.floor(capSegments));
        radialSegments = Math.max(3, Math.floor(radialSegments));
        heightSegments = Math.max(1, Math.floor(heightSegments));
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const halfHeight = height / 2;
        const capArcLength = Math.PI / 2 * radius;
        const cylinderPartLength = height;
        const totalArcLength = 2 * capArcLength + cylinderPartLength;
        const numVerticalSegments = capSegments * 2 + heightSegments;
        const verticesPerRow = radialSegments + 1;
        const normal = new Vector3();
        const vertex = new Vector3();
        // generate vertices, normals, and uvs
        for(let iy = 0; iy <= numVerticalSegments; iy++){
            let currentArcLength = 0;
            let profileY = 0;
            let profileRadius = 0;
            let normalYComponent = 0;
            if (iy <= capSegments) {
                // bottom cap
                const segmentProgress = iy / capSegments;
                const angle = segmentProgress * Math.PI / 2;
                profileY = -halfHeight - radius * Math.cos(angle);
                profileRadius = radius * Math.sin(angle);
                normalYComponent = -radius * Math.cos(angle);
                currentArcLength = segmentProgress * capArcLength;
            } else if (iy <= capSegments + heightSegments) {
                // middle section
                const segmentProgress = (iy - capSegments) / heightSegments;
                profileY = -halfHeight + segmentProgress * height;
                profileRadius = radius;
                normalYComponent = 0;
                currentArcLength = capArcLength + segmentProgress * cylinderPartLength;
            } else {
                // top cap
                const segmentProgress = (iy - capSegments - heightSegments) / capSegments;
                const angle = segmentProgress * Math.PI / 2;
                profileY = halfHeight + radius * Math.sin(angle);
                profileRadius = radius * Math.cos(angle);
                normalYComponent = radius * Math.sin(angle);
                currentArcLength = capArcLength + cylinderPartLength + segmentProgress * capArcLength;
            }
            const v = Math.max(0, Math.min(1, currentArcLength / totalArcLength));
            // special case for the poles
            let uOffset = 0;
            if (iy === 0) uOffset = 0.5 / radialSegments;
            else if (iy === numVerticalSegments) uOffset = -0.5 / radialSegments;
            for(let ix = 0; ix <= radialSegments; ix++){
                const u = ix / radialSegments;
                const theta = u * Math.PI * 2;
                const sinTheta = Math.sin(theta);
                const cosTheta = Math.cos(theta);
                // vertex
                vertex.x = -profileRadius * cosTheta;
                vertex.y = profileY;
                vertex.z = profileRadius * sinTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.set(-profileRadius * cosTheta, normalYComponent, profileRadius * sinTheta);
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, v);
            }
            if (iy > 0) {
                const prevIndexRow = (iy - 1) * verticesPerRow;
                for(let ix = 0; ix < radialSegments; ix++){
                    const i1 = prevIndexRow + ix;
                    const i2 = prevIndexRow + ix + 1;
                    const i3 = iy * verticesPerRow + ix;
                    const i4 = iy * verticesPerRow + ix + 1;
                    indices.push(i1, i2, i3);
                    indices.push(i2, i4, i3);
                }
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CapsuleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new CapsuleGeometry(data.radius, data.height, data.capSegments, data.radialSegments, data.heightSegments);
    }
}
/**
 * A simple shape of Euclidean geometry. It is constructed from a
 * number of triangular segments that are oriented around a central point and
 * extend as far out as a given radius. It is built counter-clockwise from a
 * start angle and a given central angle. It can also be used to create
 * regular polygons, where the number of segments determines the number of
 * sides.
 *
 * ```js
 * const geometry = new THREE.CircleGeometry( 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const circle = new THREE.Mesh( geometry, material );
 * scene.add( circle )
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CircleGeometry
 */ class CircleGeometry extends BufferGeometry {
    /**
	 * Constructs a new circle geometry.
	 *
	 * @param {number} [radius=1] - Radius of the circle.
	 * @param {number} [segments=32] - Number of segments (triangles), minimum = `3`.
	 * @param {number} [thetaStart=0] - Start angle for first segment in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta,
	 * of the circular sector in radians. The default value results in a complete circle.
	 */ constructor(radius = 1, segments = 32, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new Vector3();
        const uv = new Vector2();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CircleGeometry} A new instance.
	 */ static fromJSON(data) {
        return new CircleGeometry(data.radius, data.segments, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cylinder.
 *
 * ```js
 * const geometry = new THREE.CylinderGeometry( 5, 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cylinder = new THREE.Mesh( geometry, material );
 * scene.add( cylinder );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#CylinderGeometry
 */ class CylinderGeometry extends BufferGeometry {
    /**
	 * Constructs a new cylinder geometry.
	 *
	 * @param {number} [radiusTop=1] - Radius of the cylinder at the top.
	 * @param {number} [radiusBottom=1] - Radius of the cylinder at the bottom.
	 * @param {number} [height=1] - Height of the cylinder.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cylinder.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cylinder.
	 * @param {boolean} [openEnded=false] - Whether the base of the cylinder is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cylinder.
	 */ constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        function generateTorso() {
            const normal = new Vector3();
            const vertex = new Vector3();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                if (radiusTop > 0 || y !== 0) {
                    indices.push(a, b, d);
                    groupCount += 3;
                }
                if (radiusBottom > 0 || y !== heightSegments - 1) {
                    indices.push(b, c, d);
                    groupCount += 3;
                }
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new Vector2();
            const vertex = new Vector3();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {CylinderGeometry} A new instance.
	 */ static fromJSON(data) {
        return new CylinderGeometry(data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing a cone.
 *
 * ```js
 * const geometry = new THREE.ConeGeometry( 5, 20, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const cone = new THREE.Mesh(geometry, material );
 * scene.add( cone );
 * ```
 *
 * @augments CylinderGeometry
 * @demo scenes/geometry-browser.html#ConeGeometry
 */ class ConeGeometry extends CylinderGeometry {
    /**
	 * Constructs a new cone geometry.
	 *
	 * @param {number} [radius=1] - Radius of the cone base.
	 * @param {number} [height=1] - Height of the cone.
	 * @param {number} [radialSegments=32] - Number of segmented faces around the circumference of the cone.
	 * @param {number} [heightSegments=1] - Number of rows of faces along the height of the cone.
	 * @param {boolean} [openEnded=false] - Whether the base of the cone is open or capped.
	 * @param {number} [thetaStart=0] - Start angle for first segment, in radians.
	 * @param {number} [thetaLength=Math.PI*2] - The central angle, often called theta, of the circular sector, in radians.
	 * The default value results in a complete cone.
	 */ constructor(radius = 1, height = 1, radialSegments = 32, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {ConeGeometry} A new instance.
	 */ static fromJSON(data) {
        return new ConeGeometry(data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
    }
}
/**
 * A polyhedron is a solid in three dimensions with flat faces. This class
 * will take an array of vertices, project them onto a sphere, and then
 * divide them up to the desired level of detail.
 *
 * @augments BufferGeometry
 */ class PolyhedronGeometry extends BufferGeometry {
    /**
	 * Constructs a new polyhedron geometry.
	 *
	 * @param {Array<number>} [vertices] - A flat array of vertices describing the base shape.
	 * @param {Array<number>} [indices] - A flat array of indices describing the base shape.
	 * @param {number} [radius=1] - The radius of the shape.
	 * @param {number} [detail=0] - How many levels to subdivide the geometry. The more detail, the smoother the shape.
	 */ constructor(vertices = [], indices = [], radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new Float32BufferAttribute(vertexBuffer, 3));
        this.setAttribute('normal', new Float32BufferAttribute(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new Vector3();
            const b = new Vector3();
            const c = new Vector3();
            // iterate over all faces and apply a subdivision with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new Vector3();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new Vector3();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new Vector3();
            const b = new Vector3();
            const c = new Vector3();
            const centroid = new Vector3();
            const uvA = new Vector2();
            const uvB = new Vector2();
            const uvC = new Vector2();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PolyhedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new PolyhedronGeometry(data.vertices, data.indices, data.radius, data.detail);
    }
}
/**
 * A geometry class for representing a dodecahedron.
 *
 * ```js
 * const geometry = new THREE.DodecahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const dodecahedron = new THREE.Mesh( geometry, material );
 * scene.add( dodecahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#DodecahedronGeometry
 */ class DodecahedronGeometry extends PolyhedronGeometry {
    /**
	 * Constructs a new dodecahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the dodecahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a dodecahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {DodecahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new DodecahedronGeometry(data.radius, data.detail);
    }
}
const _v0 = /*@__PURE__*/ new Vector3();
const _v1$1 = /*@__PURE__*/ new Vector3();
const _normal = /*@__PURE__*/ new Vector3();
const _triangle = /*@__PURE__*/ new Triangle();
/**
 * Can be used as a helper object to view the edges of a geometry.
 *
 * ```js
 * const geometry = new THREE.BoxGeometry();
 * const edges = new THREE.EdgesGeometry( geometry );
 * const line = new THREE.LineSegments( edges );
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class EdgesGeometry extends BufferGeometry {
    /**
	 * Constructs a new edges geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 * @param {number} [thresholdAngle=1] - An edge is only rendered if the angle (in degrees)
	 * between the face normals of the adjoining faces exceeds this value.
	 */ constructor(geometry = null, thresholdAngle = 1){
        super();
        this.type = 'EdgesGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry,
            thresholdAngle: thresholdAngle
        };
        if (geometry !== null) {
            const precisionPoints = 4;
            const precision = Math.pow(10, precisionPoints);
            const thresholdDot = Math.cos(DEG2RAD * thresholdAngle);
            const indexAttr = geometry.getIndex();
            const positionAttr = geometry.getAttribute('position');
            const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
            const indexArr = [
                0,
                0,
                0
            ];
            const vertKeys = [
                'a',
                'b',
                'c'
            ];
            const hashes = new Array(3);
            const edgeData = {};
            const vertices = [];
            for(let i = 0; i < indexCount; i += 3){
                if (indexAttr) {
                    indexArr[0] = indexAttr.getX(i);
                    indexArr[1] = indexAttr.getX(i + 1);
                    indexArr[2] = indexAttr.getX(i + 2);
                } else {
                    indexArr[0] = i;
                    indexArr[1] = i + 1;
                    indexArr[2] = i + 2;
                }
                const { a, b, c } = _triangle;
                a.fromBufferAttribute(positionAttr, indexArr[0]);
                b.fromBufferAttribute(positionAttr, indexArr[1]);
                c.fromBufferAttribute(positionAttr, indexArr[2]);
                _triangle.getNormal(_normal);
                // create hashes for the edge from the vertices
                hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
                hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
                hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
                // skip degenerate triangles
                if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
                // iterate over every edge
                for(let j = 0; j < 3; j++){
                    // get the first and next vertex making up the edge
                    const jNext = (j + 1) % 3;
                    const vecHash0 = hashes[j];
                    const vecHash1 = hashes[jNext];
                    const v0 = _triangle[vertKeys[j]];
                    const v1 = _triangle[vertKeys[jNext]];
                    const hash = `${vecHash0}_${vecHash1}`;
                    const reverseHash = `${vecHash1}_${vecHash0}`;
                    if (reverseHash in edgeData && edgeData[reverseHash]) {
                        // if we found a sibling edge add it into the vertex array if
                        // it meets the angle threshold and delete the edge from the map.
                        if (_normal.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                            vertices.push(v0.x, v0.y, v0.z);
                            vertices.push(v1.x, v1.y, v1.z);
                        }
                        edgeData[reverseHash] = null;
                    } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                    edgeData[hash] = {
                        index0: indexArr[j],
                        index1: indexArr[jNext],
                        normal: _normal.clone()
                    };
                }
            }
            // iterate over all remaining, unmatched edges and add them to the vertex array
            for(const key in edgeData)if (edgeData[key]) {
                const { index0, index1 } = edgeData[key];
                _v0.fromBufferAttribute(positionAttr, index0);
                _v1$1.fromBufferAttribute(positionAttr, index1);
                vertices.push(_v0.x, _v0.y, _v0.z);
                vertices.push(_v1$1.x, _v1$1.y, _v1$1.z);
            }
            this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
/**
 * An abstract base class for creating an analytic curve object that contains methods
 * for interpolation.
 *
 * @abstract
 */ class Curve {
    /**
	 * Constructs a new curve.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'Curve';
        /**
		 * This value determines the amount of divisions when calculating the
		 * cumulative segment lengths of a curve via {@link Curve#getLengths}. To ensure
		 * precision when using methods like {@link Curve#getSpacedPoints}, it is
		 * recommended to increase the value of this property if the curve is very large.
		 *
		 * @type {number}
		 * @default 200
		 */ this.arcLengthDivisions = 200;
        /**
		 * Must be set to `true` if the curve parameters have changed.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        /**
		 * An internal cache that holds precomputed curve length values.
		 *
		 * @private
		 * @type {?Array<number>}
		 * @default null
		 */ this.cacheArcLengths = null;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor.
	 *
	 * @abstract
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint() {
        warn('Curve: .getPoint() not implemented.');
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definition)
	 * for the given interpolation factor. Unlike {@link Curve#getPoint}, this method honors the length
	 * of the curve which equidistant samples.
	 *
	 * @param {number} u - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPointAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    }
    /**
	 * This method samples the curve via {@link Curve#getPoint} and returns an array of points representing
	 * the curve shape.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    }
    // Get sequence of points using getPointAt( u )
    /**
	 * This method samples the curve via {@link Curve#getPointAt} and returns an array of points representing
	 * the curve shape. Unlike {@link Curve#getPoints}, this method returns equi-spaced points across the entire
	 * curve.
	 *
	 * @param {number} [divisions=5] - The number of divisions.
	 * @return {Array<(Vector2|Vector3)>} An array holding the sampled curve values. The number of points is `divisions + 1`.
	 */ getSpacedPoints(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    }
    /**
	 * Returns the total arc length of the curve.
	 *
	 * @return {number} The length of the curve.
	 */ getLength() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    }
    /**
	 * Returns an array of cumulative segment lengths of the curve.
	 *
	 * @param {number} [divisions=this.arcLengthDivisions] - The number of divisions.
	 * @return {Array<number>} An array holding the cumulative segment lengths.
	 */ getLengths(divisions = this.arcLengthDivisions) {
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    }
    /**
	 * Update the cumulative segment distance cache. The method must be called
	 * every time curve parameters are changed. If an updated curve is part of a
	 * composed curve like {@link CurvePath}, this method must be called on the
	 * composed curve, too.
	 */ updateArcLengths() {
        this.needsUpdate = true;
        this.getLengths();
    }
    /**
	 * Given an interpolation factor in the range `[0,1]`, this method returns an updated
	 * interpolation factor in the same range that can be ued to sample equidistant points
	 * from a curve.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {?number} distance - An optional distance on the curve.
	 * @return {number} The updated interpolation factor.
	 */ getUtoTmapping(u, distance = null) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    }
    /**
	 * Returns a unit vector tangent for the given interpolation factor.
	 * If the derived curve does not implement its tangent derivation,
	 * two points a small delta apart will be used to find its gradient
	 * which seems to give a reasonable approximation.
	 *
	 * @param {number} t - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 */ getTangent(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new Vector2() : new Vector3());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    }
    /**
	 * Same as {@link Curve#getTangent} but with equidistant samples.
	 *
	 * @param {number} u - The interpolation factor.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {(Vector2|Vector3)} The tangent vector.
	 * @see {@link Curve#getPointAt}
	 */ getTangentAt(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    }
    /**
	 * Generates the Frenet Frames. Requires a curve definition in 3D space. Used
	 * in geometries like {@link TubeGeometry} or {@link ExtrudeGeometry}.
	 *
	 * @param {number} segments - The number of segments.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @return {{tangents: Array<Vector3>, normals: Array<Vector3>, binormals: Array<Vector3>}} The Frenet Frames.
	 */ computeFrenetFrames(segments, closed = false) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new Vector3();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new Vector3();
        const mat = new Matrix4();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new Vector3());
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new Vector3();
        binormals[0] = new Vector3();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos(clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos(clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    }
    /**
	 * Returns a new curve with copied values from this instance.
	 *
	 * @return {Curve} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given curve to this instance.
	 *
	 * @param {Curve} source - The curve to copy.
	 * @return {Curve} A reference to this curve.
	 */ copy(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    }
    /**
	 * Serializes the curve into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized curve.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const data = {
            metadata: {
                version: 4.7,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    }
    /**
	 * Deserializes the curve from the given JSON.
	 *
	 * @param {Object} json - The JSON holding the serialized curve.
	 * @return {Curve} A reference to this curve.
	 */ fromJSON(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
}
/**
 * A curve representing an ellipse.
 *
 * ```js
 * const curve = new THREE.EllipseCurve(
 * 	0, 0,
 * 	10, 10,
 * 	0, 2 * Math.PI,
 * 	false,
 * 	0
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const ellipse = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class EllipseCurve extends Curve {
    /**
	 * Constructs a new ellipse curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 */ constructor(aX = 0, aY = 0, xRadius = 1, yRadius = 1, aStartAngle = 0, aEndAngle = Math.PI * 2, aClockwise = false, aRotation = 0){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isEllipseCurve = true;
        this.type = 'EllipseCurve';
        /**
		 * The X center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aX = aX;
        /**
		 * The Y center of the ellipse.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aY = aY;
        /**
		 * The radius of the ellipse in the x direction.
		 * Setting the this value equal to the {@link EllipseCurve#yRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.xRadius = xRadius;
        /**
		 * The radius of the ellipse in the y direction.
		 * Setting the this value equal to the {@link EllipseCurve#xRadius} will result in a circle.
		 *
		 * @type {number}
		 * @default 1
		 */ this.yRadius = yRadius;
        /**
		 * The start angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aStartAngle = aStartAngle;
        /**
		 * The end angle of the curve in radians starting from the positive X axis.
		 *
		 * @type {number}
		 * @default Math.PI*2
		 */ this.aEndAngle = aEndAngle;
        /**
		 * Whether the ellipse is drawn clockwise or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.aClockwise = aClockwise;
        /**
		 * The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.aRotation = aRotation;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new Vector2()) {
        const point = optionalTarget;
        const twoPi = Math.PI * 2;
        let deltaAngle = this.aEndAngle - this.aStartAngle;
        const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
        // ensures that deltaAngle is 0 .. 2 PI
        while(deltaAngle < 0)deltaAngle += twoPi;
        while(deltaAngle > twoPi)deltaAngle -= twoPi;
        if (deltaAngle < Number.EPSILON) {
            if (samePoints) deltaAngle = 0;
            else deltaAngle = twoPi;
        }
        if (this.aClockwise === true && !samePoints) {
            if (deltaAngle === twoPi) deltaAngle = -twoPi;
            else deltaAngle = deltaAngle - twoPi;
        }
        const angle = this.aStartAngle + t * deltaAngle;
        let x = this.aX + this.xRadius * Math.cos(angle);
        let y = this.aY + this.yRadius * Math.sin(angle);
        if (this.aRotation !== 0) {
            const cos = Math.cos(this.aRotation);
            const sin = Math.sin(this.aRotation);
            const tx = x - this.aX;
            const ty = y - this.aY;
            // Rotate the point about the center of the ellipse.
            x = tx * cos - ty * sin + this.aX;
            y = tx * sin + ty * cos + this.aY;
        }
        return point.set(x, y);
    }
    copy(source) {
        super.copy(source);
        this.aX = source.aX;
        this.aY = source.aY;
        this.xRadius = source.xRadius;
        this.yRadius = source.yRadius;
        this.aStartAngle = source.aStartAngle;
        this.aEndAngle = source.aEndAngle;
        this.aClockwise = source.aClockwise;
        this.aRotation = source.aRotation;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.aX = this.aX;
        data.aY = this.aY;
        data.xRadius = this.xRadius;
        data.yRadius = this.yRadius;
        data.aStartAngle = this.aStartAngle;
        data.aEndAngle = this.aEndAngle;
        data.aClockwise = this.aClockwise;
        data.aRotation = this.aRotation;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.aX = json.aX;
        this.aY = json.aY;
        this.xRadius = json.xRadius;
        this.yRadius = json.yRadius;
        this.aStartAngle = json.aStartAngle;
        this.aEndAngle = json.aEndAngle;
        this.aClockwise = json.aClockwise;
        this.aRotation = json.aRotation;
        return this;
    }
}
/**
 * A curve representing an arc.
 *
 * @augments EllipseCurve
 */ class ArcCurve extends EllipseCurve {
    /**
	 * Constructs a new arc curve.
	 *
	 * @param {number} [aX=0] - The X center of the ellipse.
	 * @param {number} [aY=0] - The Y center of the ellipse.
	 * @param {number} [aRadius=1] - The radius of the ellipse in the x direction.
	 * @param {number} [aStartAngle=0] - The start angle of the curve in radians starting from the positive X axis.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle of the curve in radians starting from the positive X axis.
	 * @param {boolean} [aClockwise=false] - Whether the ellipse is drawn clockwise or not.
	 */ constructor(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise){
        super(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArcCurve = true;
        this.type = 'ArcCurve';
    }
}
function CubicPoly() {
    /**
	 * Centripetal CatmullRom Curve - which is useful for avoiding
	* cusps and self-intersections in non-uniform catmull rom curves.
	* http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
	*
	* curve.type accepts centripetal(default), chordal and catmullrom
	* curve.tension is used for catmullrom which defaults to 0.5
	*/ /*
	Based on an optimized c++ solution in
	- http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
	- http://ideone.com/NoEbVM

	This CubicPoly class could be used for reusing some variables and calculations,
	but for three.js curve use, it could be possible inlined and flatten into a single function call
	which can be placed in CurveUtils.
	*/ let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const tmp = /*@__PURE__*/ new Vector3();
const px = /*@__PURE__*/ new CubicPoly();
const py = /*@__PURE__*/ new CubicPoly();
const pz = /*@__PURE__*/ new CubicPoly();
/**
 * A curve representing a Catmull-Rom spline.
 *
 * ```js
 * //Create a closed wavey loop
 * const curve = new THREE.CatmullRomCurve3( [
 * 	new THREE.Vector3( -10, 0, 10 ),
 * 	new THREE.Vector3( -5, 5, 5 ),
 * 	new THREE.Vector3( 0, 0, 0 ),
 * 	new THREE.Vector3( 5, -5, 5 ),
 * 	new THREE.Vector3( 10, 0, 10 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class CatmullRomCurve3 extends Curve {
    /**
	 * Constructs a new Catmull-Rom curve.
	 *
	 * @param {Array<Vector3>} [points] - An array of 3D points defining the curve.
	 * @param {boolean} [closed=false] - Whether the curve is closed or not.
	 * @param {('centripetal'|'chordal'|'catmullrom')} [curveType='centripetal'] - The curve type.
	 * @param {number} [tension=0.5] - Tension of the curve.
	 */ constructor(points = [], closed = false, curveType = 'centripetal', tension = 0.5){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCatmullRomCurve3 = true;
        this.type = 'CatmullRomCurve3';
        /**
		 * An array of 3D points defining the curve.
		 *
		 * @type {Array<Vector3>}
		 */ this.points = points;
        /**
		 * Whether the curve is closed or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.closed = closed;
        /**
		 * The curve type.
		 *
		 * @type {('centripetal'|'chordal'|'catmullrom')}
		 * @default 'centripetal'
		 */ this.curveType = curveType;
        /**
		 * Tension of the curve.
		 *
		 * @type {number}
		 * @default 0.5
		 */ this.tension = tension;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new Vector3()) {
        const point = optionalTarget;
        const points = this.points;
        const l = points.length;
        const p = (l - (this.closed ? 0 : 1)) * t;
        let intPoint = Math.floor(p);
        let weight = p - intPoint;
        if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
        else if (weight === 0 && intPoint === l - 1) {
            intPoint = l - 2;
            weight = 1;
        }
        let p0, p3; // 4 points (p1 & p2 defined below)
        if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
        else {
            // extrapolate first point
            tmp.subVectors(points[0], points[1]).add(points[0]);
            p0 = tmp;
        }
        const p1 = points[intPoint % l];
        const p2 = points[(intPoint + 1) % l];
        if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
        else {
            // extrapolate last point
            tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
            p3 = tmp;
        }
        if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
            // init Centripetal / Chordal Catmull-Rom
            const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
            let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
            let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
            let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
            // safety check for repeated points
            if (dt1 < 1e-4) dt1 = 1.0;
            if (dt0 < 1e-4) dt0 = dt1;
            if (dt2 < 1e-4) dt2 = dt1;
            px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
            py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
            pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
        } else if (this.curveType === 'catmullrom') {
            px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
            py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
            pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
        }
        point.set(px.calc(weight), py.calc(weight), pz.calc(weight));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        this.closed = source.closed;
        this.curveType = source.curveType;
        this.tension = source.tension;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        data.closed = this.closed;
        data.curveType = this.curveType;
        data.tension = this.tension;
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new Vector3().fromArray(point));
        }
        this.closed = json.closed;
        this.curveType = json.curveType;
        this.tension = json.tension;
        return this;
    }
}
/**
 * Interpolations contains spline and Bézier functions internally used by concrete curve classes.
 *
 * Bezier Curves formulas obtained from: https://en.wikipedia.org/wiki/B%C3%A9zier_curve
 *
 * @module Interpolations
 */ /**
 * Computes a point on a Catmull-Rom spline.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Catmull-Rom spline.
 */ function CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function QuadraticBezierP2(t, p) {
    return t * t * p;
}
/**
 * Computes a point on a Quadratic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @return {number} The calculated point on a Quadratic Bezier curve.
 */ function QuadraticBezier(t, p0, p1, p2) {
    return QuadraticBezierP0(t, p0) + QuadraticBezierP1(t, p1) + QuadraticBezierP2(t, p2);
}
//
function CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function CubicBezierP3(t, p) {
    return t * t * t * p;
}
/**
 * Computes a point on a Cubic Bezier curve.
 *
 * @param {number} t - The interpolation factor.
 * @param {number} p0 - The first control point.
 * @param {number} p1 - The second control point.
 * @param {number} p2 - The third control point.
 * @param {number} p3 - The fourth control point.
 * @return {number} The calculated point on a Cubic Bezier curve.
 */ function CubicBezier(t, p0, p1, p2, p3) {
    return CubicBezierP0(t, p0) + CubicBezierP1(t, p1) + CubicBezierP2(t, p2) + CubicBezierP3(t, p3);
}
/**
 * A curve representing a 2D Cubic Bezier curve.
 *
 * ```js
 * const curve = new THREE.CubicBezierCurve(
 * 	new THREE.Vector2( - 0, 0 ),
 * 	new THREE.Vector2( - 5, 15 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class CubicBezierCurve extends Curve {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The first control point.
	 * @param {Vector2} [v2] - The second control point.
	 * @param {Vector2} [v3] - The end point.
	 */ constructor(v0 = new Vector2(), v1 = new Vector2(), v2 = new Vector2(), v3 = new Vector2()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve = true;
        this.type = 'CubicBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new Vector2()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set(CubicBezier(t, v0.x, v1.x, v2.x, v3.x), CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 3D Cubic Bezier curve.
 *
 * @augments Curve
 */ class CubicBezierCurve3 extends Curve {
    /**
	 * Constructs a new Cubic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The first control point.
	 * @param {Vector3} [v2] - The second control point.
	 * @param {Vector3} [v3] - The end point.
	 */ constructor(v0 = new Vector3(), v1 = new Vector3(), v2 = new Vector3(), v3 = new Vector3()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isCubicBezierCurve3 = true;
        this.type = 'CubicBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The first control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The second control point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v3 = v3;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new Vector3()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
        point.set(CubicBezier(t, v0.x, v1.x, v2.x, v3.x), CubicBezier(t, v0.y, v1.y, v2.y, v3.y), CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        this.v3.copy(source.v3);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        data.v3 = this.v3.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        this.v3.fromArray(json.v3);
        return this;
    }
}
/**
 * A curve representing a 2D line segment.
 *
 * @augments Curve
 */ class LineCurve extends Curve {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector2} [v1] - The start point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v1 = new Vector2(), v2 = new Vector2()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve = true;
        this.type = 'LineCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the line.
	 */ getPoint(t, optionalTarget = new Vector2()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new Vector2()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D line segment.
 *
 * @augments Curve
 */ class LineCurve3 extends Curve {
    /**
	 * Constructs a new line curve.
	 *
	 * @param {Vector3} [v1] - The start point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v1 = new Vector3(), v2 = new Vector3()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineCurve3 = true;
        this.type = 'LineCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the line.
	 *
	 * @param {number} t - A interpolation factor representing a position on the line. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the line.
	 */ getPoint(t, optionalTarget = new Vector3()) {
        const point = optionalTarget;
        if (t === 1) point.copy(this.v2);
        else {
            point.copy(this.v2).sub(this.v1);
            point.multiplyScalar(t).add(this.v1);
        }
        return point;
    }
    // Line curve is linear, so we can overwrite default getPointAt
    getPointAt(u, optionalTarget) {
        return this.getPoint(u, optionalTarget);
    }
    getTangent(t, optionalTarget = new Vector3()) {
        return optionalTarget.subVectors(this.v2, this.v1).normalize();
    }
    getTangentAt(u, optionalTarget) {
        return this.getTangent(u, optionalTarget);
    }
    copy(source) {
        super.copy(source);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D Quadratic Bezier curve.
 *
 * ```js
 * const curve = new THREE.QuadraticBezierCurve(
 * 	new THREE.Vector2( - 10, 0 ),
 * 	new THREE.Vector2( 20, 15 ),
 * 	new THREE.Vector2( 10, 0 )
 * )
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const curveObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class QuadraticBezierCurve extends Curve {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector2} [v0] - The start point.
	 * @param {Vector2} [v1] - The control point.
	 * @param {Vector2} [v2] - The end point.
	 */ constructor(v0 = new Vector2(), v1 = new Vector2(), v2 = new Vector2()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve = true;
        this.type = 'QuadraticBezierCurve';
        /**
		 * The start point.
		 *
		 * @type {Vector2}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector2}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector2}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new Vector2()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set(QuadraticBezier(t, v0.x, v1.x, v2.x), QuadraticBezier(t, v0.y, v1.y, v2.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 3D Quadratic Bezier curve.
 *
 * @augments Curve
 */ class QuadraticBezierCurve3 extends Curve {
    /**
	 * Constructs a new Quadratic Bezier curve.
	 *
	 * @param {Vector3} [v0] - The start point.
	 * @param {Vector3} [v1] - The control point.
	 * @param {Vector3} [v2] - The end point.
	 */ constructor(v0 = new Vector3(), v1 = new Vector3(), v2 = new Vector3()){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isQuadraticBezierCurve3 = true;
        this.type = 'QuadraticBezierCurve3';
        /**
		 * The start point.
		 *
		 * @type {Vector3}
		 */ this.v0 = v0;
        /**
		 * The control point.
		 *
		 * @type {Vector3}
		 */ this.v1 = v1;
        /**
		 * The end point.
		 *
		 * @type {Vector3}
		 */ this.v2 = v2;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector3} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector3} The position on the curve.
	 */ getPoint(t, optionalTarget = new Vector3()) {
        const point = optionalTarget;
        const v0 = this.v0, v1 = this.v1, v2 = this.v2;
        point.set(QuadraticBezier(t, v0.x, v1.x, v2.x), QuadraticBezier(t, v0.y, v1.y, v2.y), QuadraticBezier(t, v0.z, v1.z, v2.z));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.v0.copy(source.v0);
        this.v1.copy(source.v1);
        this.v2.copy(source.v2);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.v0 = this.v0.toArray();
        data.v1 = this.v1.toArray();
        data.v2 = this.v2.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.v0.fromArray(json.v0);
        this.v1.fromArray(json.v1);
        this.v2.fromArray(json.v2);
        return this;
    }
}
/**
 * A curve representing a 2D spline curve.
 *
 * ```js
 * // Create a sine-like wave
 * const curve = new THREE.SplineCurve( [
 * 	new THREE.Vector2( -10, 0 ),
 * 	new THREE.Vector2( -5, 5 ),
 * 	new THREE.Vector2( 0, 0 ),
 * 	new THREE.Vector2( 5, -5 ),
 * 	new THREE.Vector2( 10, 0 )
 * ] );
 *
 * const points = curve.getPoints( 50 );
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 *
 * const material = new THREE.LineBasicMaterial( { color: 0xff0000 } );
 *
 * // Create the final object to add to the scene
 * const splineObject = new THREE.Line( geometry, material );
 * ```
 *
 * @augments Curve
 */ class SplineCurve extends Curve {
    /**
	 * Constructs a new 2D spline curve.
	 *
	 * @param {Array<Vector2>} [points] -  An array of 2D points defining the curve.
	 */ constructor(points = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSplineCurve = true;
        this.type = 'SplineCurve';
        /**
		 * An array of 2D points defining the curve.
		 *
		 * @type {Array<Vector2>}
		 */ this.points = points;
    }
    /**
	 * Returns a point on the curve.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {Vector2} [optionalTarget] - The optional target vector the result is written to.
	 * @return {Vector2} The position on the curve.
	 */ getPoint(t, optionalTarget = new Vector2()) {
        const point = optionalTarget;
        const points = this.points;
        const p = (points.length - 1) * t;
        const intPoint = Math.floor(p);
        const weight = p - intPoint;
        const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
        const p1 = points[intPoint];
        const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
        const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
        point.set(CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
        return point;
    }
    copy(source) {
        super.copy(source);
        this.points = [];
        for(let i = 0, l = source.points.length; i < l; i++){
            const point = source.points[i];
            this.points.push(point.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.points = [];
        for(let i = 0, l = this.points.length; i < l; i++){
            const point = this.points[i];
            data.points.push(point.toArray());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.points = [];
        for(let i = 0, l = json.points.length; i < l; i++){
            const point = json.points[i];
            this.points.push(new Vector2().fromArray(point));
        }
        return this;
    }
}
var Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: ArcCurve,
    CatmullRomCurve3: CatmullRomCurve3,
    CubicBezierCurve: CubicBezierCurve,
    CubicBezierCurve3: CubicBezierCurve3,
    EllipseCurve: EllipseCurve,
    LineCurve: LineCurve,
    LineCurve3: LineCurve3,
    QuadraticBezierCurve: QuadraticBezierCurve,
    QuadraticBezierCurve3: QuadraticBezierCurve3,
    SplineCurve: SplineCurve
});
/**
 * A base class extending {@link Curve}. `CurvePath` is simply an
 * array of connected curves, but retains the API of a curve.
 *
 * @augments Curve
 */ class CurvePath extends Curve {
    /**
	 * Constructs a new curve path.
	 */ constructor(){
        super();
        this.type = 'CurvePath';
        /**
		 * An array of curves defining the
		 * path.
		 *
		 * @type {Array<Curve>}
		 */ this.curves = [];
        /**
		 * Whether the path should automatically be closed
		 * by a line curve.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoClose = false;
    }
    /**
	 * Adds a curve to this curve path.
	 *
	 * @param {Curve} curve - The curve to add.
	 */ add(curve) {
        this.curves.push(curve);
    }
    /**
	 * Adds a line curve to close the path.
	 *
	 * @return {CurvePath} A reference to this curve path.
	 */ closePath() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) {
            const lineType = startPoint.isVector2 === true ? 'LineCurve' : 'LineCurve3';
            this.curves.push(new Curves[lineType](endPoint, startPoint));
        }
        return this;
    }
    /**
	 * This method returns a vector in 2D or 3D space (depending on the curve definitions)
	 * for the given interpolation factor.
	 *
	 * @param {number} t - A interpolation factor representing a position on the curve. Must be in the range `[0,1]`.
	 * @param {(Vector2|Vector3)} [optionalTarget] - The optional target vector the result is written to.
	 * @return {?(Vector2|Vector3)} The position on the curve. It can be a 2D or 3D vector depending on the curve definition.
	 */ getPoint(t, optionalTarget) {
        // To get accurate point with reference to
        // entire path distance at time t,
        // following has to be done:
        // 1. Length of each sub path have to be known
        // 2. Locate and identify type of curve
        // 3. Get t for the curve
        // 4. Return curve.getPointAt(t')
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u, optionalTarget);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    }
    getLength() {
        // We cannot use the default THREE.Curve getPoint() with getLength() because in
        // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
        // getPoint() depends on getLength
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    }
    updateArcLengths() {
        // cacheLengths must be recalculated.
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    }
    /**
	 * Returns list of cumulative curve lengths of the defined curves.
	 *
	 * @return {Array<number>} The curve lengths.
	 */ getCurveLengths() {
        // Compute lengths and cache them
        // We cannot overwrite getLengths() because UtoT mapping uses it.
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    }
    getSpacedPoints(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    }
    getPoints(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve.isEllipseCurve ? divisions * 2 : curve.isLineCurve || curve.isLineCurve3 ? 1 : curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    }
    copy(source) {
        super.copy(source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
}
/**
 * A 2D path representation. The class provides methods for creating paths
 * and contours of 2D shapes similar to the 2D Canvas API.
 *
 * ```js
 * const path = new THREE.Path();
 *
 * path.lineTo( 0, 0.8 );
 * path.quadraticCurveTo( 0, 1, 0.2, 1 );
 * path.lineTo( 1, 1 );
 *
 * const points = path.getPoints();
 *
 * const geometry = new THREE.BufferGeometry().setFromPoints( points );
 * const material = new THREE.LineBasicMaterial( { color: 0xffffff } );
 *
 * const line = new THREE.Line( geometry, material );
 * scene.add( line );
 * ```
 *
 * @augments CurvePath
 */ class Path extends CurvePath {
    /**
	 * Constructs a new path.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the path.
	 */ constructor(points){
        super();
        this.type = 'Path';
        /**
		 * The current offset of the path. Any new curve added will start here.
		 *
		 * @type {Vector2}
		 */ this.currentPoint = new Vector2();
        if (points) this.setFromPoints(points);
    }
    /**
	 * Creates a path from the given list of points. The points are added
	 * to the path as instances of {@link LineCurve}.
	 *
	 * @param {Array<Vector2>} points - An array of 2D points.
	 * @return {Path} A reference to this path.
	 */ setFromPoints(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    }
    /**
	 * Moves {@link Path#currentPoint} to the given point.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {Path} A reference to this path.
	 */ moveTo(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ lineTo(x, y) {
        const curve = new LineCurve(this.currentPoint.clone(), new Vector2(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        const curve = new QuadraticBezierCurve(this.currentPoint.clone(), new Vector2(aCPx, aCPy), new Vector2(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {Path} A reference to this path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new CubicBezierCurve(this.currentPoint.clone(), new Vector2(aCP1x, aCP1y), new Vector2(aCP2x, aCP2y), new Vector2(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {Path} A reference to this path.
	 */ splineThru(pts) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new SplineCurve(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    }
    /**
	 * Adds an arc as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc offsetted from the previous curve.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ arc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an absolutely positioned arc as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the arc.
	 * @param {number} [aY=0] - The y coordinate of the center of the arc.
	 * @param {number} [aRadius=1] - The radius of the arc.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the arc clockwise or not.
	 * @return {Path} A reference to this path.
	 */ absarc(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    }
    /**
	 * Adds an ellipse as an instance of {@link EllipseCurve} to the path, positioned relative
	 * to the current point
	 *
	 * @param {number} [aX=0] - The x coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [aY=0] - The y coordinate of the center of the ellipse offsetted from the previous curve.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ ellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    }
    /**
	 * Adds an absolutely positioned ellipse as an instance of {@link EllipseCurve} to the path.
	 *
	 * @param {number} [aX=0] - The x coordinate of the absolute center of the ellipse.
	 * @param {number} [aY=0] - The y coordinate of the absolute center of the ellipse.
	 * @param {number} [xRadius=1] - The radius of the ellipse in the x axis.
	 * @param {number} [yRadius=1] - The radius of the ellipse in the y axis.
	 * @param {number} [aStartAngle=0] - The start angle in radians.
	 * @param {number} [aEndAngle=Math.PI*2] - The end angle in radians.
	 * @param {boolean} [aClockwise=false] - Whether to sweep the ellipse clockwise or not.
	 * @param {number} [aRotation=0] - The rotation angle of the ellipse in radians, counterclockwise from the positive X axis.
	 * @return {Path} A reference to this path.
	 */ absellipse(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new EllipseCurve(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    }
    copy(source) {
        super.copy(source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.currentPoint = this.currentPoint.toArray();
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
}
/**
 * Defines an arbitrary 2d shape plane using paths with optional holes. It
 * can be used with {@link ExtrudeGeometry}, {@link ShapeGeometry}, to get
 * points, or to get triangulated faces.
 *
 * ```js
 * const heartShape = new THREE.Shape();
 *
 * heartShape.moveTo( 25, 25 );
 * heartShape.bezierCurveTo( 25, 25, 20, 0, 0, 0 );
 * heartShape.bezierCurveTo( - 30, 0, - 30, 35, - 30, 35 );
 * heartShape.bezierCurveTo( - 30, 55, - 10, 77, 25, 95 );
 * heartShape.bezierCurveTo( 60, 77, 80, 55, 80, 35 );
 * heartShape.bezierCurveTo( 80, 35, 80, 0, 50, 0 );
 * heartShape.bezierCurveTo( 35, 0, 25, 25, 25, 25 );
 *
 * const extrudeSettings = {
 * 	depth: 8,
 * 	bevelEnabled: true,
 * 	bevelSegments: 2,
 * 	steps: 2,
 * 	bevelSize: 1,
 * 	bevelThickness: 1
 * };
 *
 * const geometry = new THREE.ExtrudeGeometry( heartShape, extrudeSettings );
 * const mesh = new THREE.Mesh( geometry, new THREE.MeshBasicMaterial() );
 * ```
 *
 * @augments Path
 */ class Shape extends Path {
    /**
	 * Constructs a new shape.
	 *
	 * @param {Array<Vector2>} [points] - An array of 2D points defining the shape.
	 */ constructor(points){
        super(points);
        /**
		 * The UUID of the shape.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = generateUUID();
        this.type = 'Shape';
        /**
		 * Defines the holes in the shape. Hole definitions must use the
		 * opposite winding order (CW/CCW) than the outer shape.
		 *
		 * @type {Array<Path>}
		 * @readonly
		 */ this.holes = [];
    }
    /**
	 * Returns an array representing each contour of the holes
	 * as a list of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {Array<Array<Vector2>>} The holes as a series of 2D points.
	 */ getPointsHoles(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    }
    // get points of shape and holes (keypoints based on segments parameter)
    /**
	 * Returns an object that holds contour data for the shape and its holes as
	 * arrays of 2D points.
	 *
	 * @param {number} divisions - The fineness of the result.
	 * @return {{shape:Array<Vector2>,holes:Array<Array<Vector2>>}} An object with contour data.
	 */ extractPoints(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    }
    copy(source) {
        super.copy(source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    }
    fromJSON(json) {
        super.fromJSON(json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new Path().fromJSON(hole));
        }
        return this;
    }
}
/* eslint-disable */ // copy of mapbox/earcut version 3.0.2
// https://github.com/mapbox/earcut/tree/v3.0.2
function earcut(data, holeIndices, dim = 2) {
    const hasHoles = holeIndices && holeIndices.length;
    const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
    let outerNode = linkedList(data, 0, outerLen, dim, true);
    const triangles = [];
    if (!outerNode || outerNode.next === outerNode.prev) return triangles;
    let minX, minY, invSize;
    if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
    // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
    if (data.length > 80 * dim) {
        minX = data[0];
        minY = data[1];
        let maxX = minX;
        let maxY = minY;
        for(let i = dim; i < outerLen; i += dim){
            const x = data[i];
            const y = data[i + 1];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
        }
        // minX, minY and invSize are later used to transform coords into integers for z-order calculation
        invSize = Math.max(maxX - minX, maxY - minY);
        invSize = invSize !== 0 ? 32767 / invSize : 0;
    }
    earcutLinked(outerNode, triangles, dim, minX, minY, invSize, 0);
    return triangles;
}
// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {
    let last;
    if (clockwise === signedArea(data, start, end, dim) > 0) for(let i = start; i < end; i += dim)last = insertNode(i / dim | 0, data[i], data[i + 1], last);
    else for(let i = end - dim; i >= start; i -= dim)last = insertNode(i / dim | 0, data[i], data[i + 1], last);
    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
    let stop = ear;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        const prev = ear.prev;
        const next = ear.next;
        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            triangles.push(prev.i, ear.i, next.i); // cut off the triangle
            removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    let p = c.next;
    while(p !== a){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
    const ax = a.x, bx = b.x, cx = c.x, ay = a.y, by = b.y, cy = c.y;
    // triangle bbox
    const x0 = Math.min(ax, bx, cx), y0 = Math.min(ay, by, cy), x1 = Math.max(ax, bx, cx), y1 = Math.max(ay, by, cy);
    // z-order range for the current triangle bbox;
    const minZ = zOrder(x0, y0, minX, minY, invSize), maxZ = zOrder(x1, y1, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p.x >= x0 && p.x <= x1 && p.y >= y0 && p.y <= y1 && p !== a && p !== c && pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n.x >= x0 && n.x <= x1 && n.y >= y0 && n.y <= y1 && n !== a && n !== c && pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
            triangles.push(a.i, p.i, b.i);
            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = splitPolygon(a, b);
                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);
                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, invSize, 0);
                earcutLinked(c, triangles, dim, minX, minY, invSize, 0);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    for(let i = 0, len = holeIndices.length; i < len; i++){
        const start = holeIndices[i] * dim;
        const end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        const list = linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }
    queue.sort(compareXYSlope);
    // process holes from left to right
    for(let i = 0; i < queue.length; i++)outerNode = eliminateHole(queue[i], outerNode);
    return outerNode;
}
function compareXYSlope(a, b) {
    let result = a.x - b.x;
    // when the left-most point of 2 holes meet at a vertex, sort the holes counterclockwise so that when we find
    // the bridge to the outer shell is always the point that they meet at.
    if (result === 0) {
        result = a.y - b.y;
        if (result === 0) {
            const aSlope = (a.next.y - a.y) / (a.next.x - a.x);
            const bSlope = (b.next.y - b.y) / (b.next.x - b.x);
            result = aSlope - bSlope;
        }
    }
    return result;
}
// find a bridge between vertices that connects hole with an outer ring and link it
function eliminateHole(hole, outerNode) {
    const bridge = findHoleBridge(hole, outerNode);
    if (!bridge) return outerNode;
    const bridgeReverse = splitPolygon(bridge, hole);
    // filter collinear points around the cuts
    filterPoints(bridgeReverse, bridgeReverse.next);
    return filterPoints(bridge, bridge.next);
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity;
    let m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    // unless they intersect at a vertex, then choose the vertex
    if (equals(hole, p)) return p;
    do {
        if (equals(hole, p.next)) return p.next;
        else if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                m = p.x < p.next.x ? p : p.next;
                if (x === hx) return m; // hole touches outer segment; pick leftmost endpoint
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m;
    const mx = m.x;
    const my = m.y;
    let tanMin = Infinity;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            const tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === 0) p.z = zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    let numMerges;
    let inSize = 1;
    do {
        let p = list;
        let e;
        list = null;
        let tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            let q = p;
            let pSize = 0;
            for(let i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            let qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = (x - minX) * invSize | 0;
    y = (y - minY) * invSize | 0;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) >= (ax - px) * (cy - py) && (ax - px) * (by - py) >= (bx - px) * (ay - py) && (bx - px) * (cy - py) >= (cx - px) * (by - py);
}
// check if a point lies within a convex triangle but false if its equal to the first point of the triangle
function pointInTriangleExceptFirst(ax, ay, bx, by, cx, cy, px, py) {
    return !(ax === px && ay === py) && pointInTriangle(ax, ay, bx, by, cx, cy, px, py);
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // doesn't intersect other edges
    (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
    (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
    equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    const o1 = sign(area(p1, q1, p2));
    const o2 = sign(area(p1, q1, q2));
    const o3 = sign(area(p2, q2, p1));
    const o4 = sign(area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    let p = a;
    let inside = false;
    const px = (a.x + b.x) / 2;
    const py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    const a2 = createNode(a.i, a.x, a.y), b2 = createNode(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    const p = createNode(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function createNode(i, x, y) {
    return {
        i,
        x,
        y,
        prev: null,
        next: null,
        z: 0,
        prevZ: null,
        nextZ: null,
        steiner: false // indicates whether this is a steiner point
    };
}
function signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
/**
 * An implementation of the earcut polygon triangulation algorithm.
 * The code is a port of [mapbox/earcut](https://github.com/mapbox/earcut).
 *
 * @see https://github.com/mapbox/earcut
 */ class Earcut {
    /**
	 * Triangulates the given shape definition by returning an array of triangles.
	 *
	 * @param {Array<number>} data - An array with 2D points.
	 * @param {Array<number>} holeIndices - An array with indices defining holes.
	 * @param {number} [dim=2] - The number of coordinates per vertex in the input array.
	 * @return {Array<number>} An array representing the triangulated faces. Each face is defined by three consecutive numbers
	 * representing vertex indices.
	 */ static triangulate(data, holeIndices, dim = 2) {
        return earcut(data, holeIndices, dim);
    }
}
/**
 * A class containing utility functions for shapes.
 *
 * @hideconstructor
 */ class ShapeUtils {
    /**
	 * Calculate area of a ( 2D ) contour polygon.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points.
	 * @return {number} The area.
	 */ static area(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    }
    /**
	 * Returns `true` if the given contour uses a clockwise winding order.
	 *
	 * @param {Array<Vector2>} pts - An array of 2D points defining a polygon.
	 * @return {boolean} Whether the given contour uses a clockwise winding order or not.
	 */ static isClockWise(pts) {
        return ShapeUtils.area(pts) < 0;
    }
    /**
	 * Triangulates the given shape definition.
	 *
	 * @param {Array<Vector2>} contour - An array of 2D points defining the contour.
	 * @param {Array<Array<Vector2>>} holes - An array that holds arrays of 2D points defining the holes.
	 * @return {Array<Array<number>>} An array that holds for each face definition an array with three indices.
	 */ static triangulateShape(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        removeDupEndPts(contour);
        addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach(removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            addContour(vertices, holes[i]);
        }
        //
        const triangles = Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
}
function removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * ```js
 * const length = 12, width = 8;
 *
 * const shape = new THREE.Shape();
 * shape.moveTo( 0,0 );
 * shape.lineTo( 0, width );
 * shape.lineTo( length, width );
 * shape.lineTo( length, 0 );
 * shape.lineTo( 0, 0 );
 *
 * const geometry = new THREE.ExtrudeGeometry( shape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#ExtrudeGeometry
 */ class ExtrudeGeometry extends BufferGeometry {
    /**
	 * Constructs a new extrude geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {ExtrudeGeometry~Options} [options] - The extrude settings.
	 */ constructor(shapes = new Shape([
        new Vector2(0.5, 0.5),
        new Vector2(-0.5, 0.5),
        new Vector2(-0.5, -0.5),
        new Vector2(0.5, -0.5)
    ]), options = {}){
        super();
        this.type = 'ExtrudeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new Float32BufferAttribute(verticesArray, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            const depth = options.depth !== undefined ? options.depth : 1;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 0.2;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 0.1;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : WorldUVGenerator;
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                const isClosed = extrudePath.isCatmullRomCurve3 ? extrudePath.closed : false;
                splineTube = extrudePath.computeFrenetFrames(steps, isClosed);
                // log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new Vector3();
                normal = new Vector3();
                position2 = new Vector3();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !ShapeUtils.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if (ShapeUtils.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            /**Merges index-adjacent points that are within a threshold distance of each other. Array is modified in-place. Threshold distance is empirical, and scaled based on the magnitude of point coordinates.
			 * @param {Array<Vector2>} points
			*/ function mergeOverlappingPoints(points) {
                const THRESHOLD = 1e-10;
                const THRESHOLD_SQ = THRESHOLD * THRESHOLD;
                let prevPos = points[0];
                for(let i = 1; i <= points.length; i++){
                    const currentIndex = i % points.length;
                    const currentPos = points[currentIndex];
                    const dx = currentPos.x - prevPos.x;
                    const dy = currentPos.y - prevPos.y;
                    const distSq = dx * dx + dy * dy;
                    const scalingFactorSqrt = Math.max(Math.abs(currentPos.x), Math.abs(currentPos.y), Math.abs(prevPos.x), Math.abs(prevPos.y));
                    const thresholdSqScaled = THRESHOLD_SQ * scalingFactorSqrt * scalingFactorSqrt;
                    if (distSq <= thresholdSqScaled) {
                        points.splice(currentIndex, 1);
                        i--;
                        continue;
                    }
                    prevPos = currentPos;
                }
            }
            mergeOverlappingPoints(vertices);
            holes.forEach(mergeOverlappingPoints);
            const numHoles = holes.length;
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0; h < numHoles; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) error('ExtrudeGeometry: vec does not exist');
                return pt.clone().addScaledVector(vec, size);
            }
            const vlen = vertices.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new Vector2(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new Vector2(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = numHoles; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            let faces;
            if (bevelSegments === 0) faces = ShapeUtils.triangulateShape(contour, holes);
            else {
                const contractedContourVertices = [];
                const expandedHoleVertices = [];
                // Loop bevelSegments, 1 for the front, 1 for the back
                for(let b = 0; b < bevelSegments; b++){
                    //for ( b = bevelSegments; b > 0; b -- ) {
                    const t = b / bevelSegments;
                    const z = bevelThickness * Math.cos(t * Math.PI / 2);
                    const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                    // contract shape
                    for(let i = 0, il = contour.length; i < il; i++){
                        const vert = scalePt2(contour[i], contourMovements[i], bs);
                        v(vert.x, vert.y, -z);
                        if (t === 0) contractedContourVertices.push(vert);
                    }
                    // expand holes
                    for(let h = 0, hl = numHoles; h < hl; h++){
                        const ahole = holes[h];
                        oneHoleMovements = holesMovements[h];
                        const oneHoleVertices = [];
                        for(let i = 0, il = ahole.length; i < il; i++){
                            const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                            v(vert.x, vert.y, -z);
                            if (t === 0) oneHoleVertices.push(vert);
                        }
                        if (t === 0) expandedHoleVertices.push(oneHoleVertices);
                    }
                }
                faces = ShapeUtils.triangulateShape(contractedContourVertices, expandedHoleVertices);
            }
            const flen = faces.length;
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return toJSON$1(shapes, options, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ExtrudeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        const extrudePath = data.options.extrudePath;
        if (extrudePath !== undefined) data.options.extrudePath = new Curves[extrudePath.type]().fromJSON(extrudePath);
        return new ExtrudeGeometry(geometryShapes, data.options);
    }
}
const WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new Vector2(a_x, a_y),
            new Vector2(b_x, b_y),
            new Vector2(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < Math.abs(a_x - b_x)) return [
            new Vector2(a_x, 1 - a_z),
            new Vector2(b_x, 1 - b_z),
            new Vector2(c_x, 1 - c_z),
            new Vector2(d_x, 1 - d_z)
        ];
        else return [
            new Vector2(a_y, 1 - a_z),
            new Vector2(b_y, 1 - b_z),
            new Vector2(c_y, 1 - c_z),
            new Vector2(d_y, 1 - d_z)
        ];
    }
};
function toJSON$1(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    data.options = Object.assign({}, options);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
/**
 * A geometry class for representing an icosahedron.
 *
 * ```js
 * const geometry = new THREE.IcosahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const icosahedron = new THREE.Mesh( geometry, material );
 * scene.add( icosahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#IcosahedronGeometry
 */ class IcosahedronGeometry extends PolyhedronGeometry {
    /**
	 * Constructs a new icosahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the icosahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a icosahedron.
	 */ constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {IcosahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new IcosahedronGeometry(data.radius, data.detail);
    }
}
/**
 * Creates meshes with axial symmetry like vases. The lathe rotates around the Y axis.
 *
 * ```js
 * const points = [];
 * for ( let i = 0; i < 10; i ++ ) {
 * 	points.push( new THREE.Vector2( Math.sin( i * 0.2 ) * 10 + 5, ( i - 5 ) * 2 ) );
 * }
 * const geometry = new THREE.LatheGeometry( points );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const lathe = new THREE.Mesh( geometry, material );
 * scene.add( lathe );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#LatheGeometry
 */ class LatheGeometry extends BufferGeometry {
    /**
	 * Constructs a new lathe geometry.
	 *
	 * @param {Array<Vector2|Vector3>} [points] - An array of points in 2D space. The x-coordinate of each point
	 * must be greater than zero.
	 * @param {number} [segments=12] - The number of circumference segments to generate.
	 * @param {number} [phiStart=0] - The starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The radian (0 to 2PI) range of the lathed section 2PI is a
	 * closed lathe, less than 2PI is a portion.
	 */ constructor(points = [
        new Vector2(0, -0.5),
        new Vector2(0.5, 0),
        new Vector2(0, 0.5)
    ], segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        const initNormals = [];
        const normals = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new Vector3();
        const uv = new Vector2();
        const normal = new Vector3();
        const curNormal = new Vector3();
        const prevNormal = new Vector3();
        let dx = 0;
        let dy = 0;
        // pre-compute normals for initial "meridian"
        for(let j = 0; j <= points.length - 1; j++)switch(j){
            case 0:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                prevNormal.copy(normal);
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                break;
            case points.length - 1:
                initNormals.push(prevNormal.x, prevNormal.y, prevNormal.z);
                break;
            default:
                dx = points[j + 1].x - points[j].x;
                dy = points[j + 1].y - points[j].y;
                normal.x = dy * 1.0;
                normal.y = -dx;
                normal.z = dy * 0.0;
                curNormal.copy(normal);
                normal.x += prevNormal.x;
                normal.y += prevNormal.y;
                normal.z += prevNormal.z;
                normal.normalize();
                initNormals.push(normal.x, normal.y, normal.z);
                prevNormal.copy(curNormal);
        }
        // generate vertices, uvs and normals
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
                // normal
                const x = initNormals[3 * j + 0] * sin;
                const y = initNormals[3 * j + 1];
                const z = initNormals[3 * j + 0] * cos;
                normals.push(x, y, z);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(c, d, b);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {LatheGeometry} A new instance.
	 */ static fromJSON(data) {
        return new LatheGeometry(data.points, data.segments, data.phiStart, data.phiLength);
    }
}
/**
 * A geometry class for representing an octahedron.
 *
 * ```js
 * const geometry = new THREE.OctahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const octahedron = new THREE.Mesh( geometry, material );
 * scene.add( octahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#OctahedronGeometry
 */ class OctahedronGeometry extends PolyhedronGeometry {
    /**
	 * Constructs a new octahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the octahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a octahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {OctahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new OctahedronGeometry(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing a plane.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 1, 1 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const plane = new THREE.Mesh( geometry, material );
 * scene.add( plane );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#PlaneGeometry
 */ class PlaneGeometry extends BufferGeometry {
    /**
	 * Constructs a new plane geometry.
	 *
	 * @param {number} [width=1] - The width along the X axis.
	 * @param {number} [height=1] - The height along the Y axis
	 * @param {number} [widthSegments=1] - The number of segments along the X axis.
	 * @param {number} [heightSegments=1] - The number of segments along the Y axis.
	 */ constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {PlaneGeometry} A new instance.
	 */ static fromJSON(data) {
        return new PlaneGeometry(data.width, data.height, data.widthSegments, data.heightSegments);
    }
}
/**
 * A class for generating a two-dimensional ring geometry.
 *
 * ```js
 * const geometry = new THREE.RingGeometry( 1, 5, 32 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#RingGeometry
 */ class RingGeometry extends BufferGeometry {
    /**
	 * Constructs a new ring geometry.
	 *
	 * @param {number} [innerRadius=0.5] - The inner radius of the ring.
	 * @param {number} [outerRadius=1] - The outer radius of the ring.
	 * @param {number} [thetaSegments=32] - Number of segments. A higher number means the ring will be more round. Minimum is `3`.
	 * @param {number} [phiSegments=1] - Number of segments per ring segment. Minimum is `1`.
	 * @param {number} [thetaStart=0] - Starting angle in radians.
	 * @param {number} [thetaLength=Math.PI*2] - Central angle in radians.
	 */ constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 32, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new Vector3();
        const uv = new Vector2();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {RingGeometry} A new instance.
	 */ static fromJSON(data) {
        return new RingGeometry(data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
    }
}
/**
 * Creates an one-sided polygonal geometry from one or more path shapes.
 *
 * ```js
 * const arcShape = new THREE.Shape()
 *	.moveTo( 5, 1 )
 *	.absarc( 1, 1, 4, 0, Math.PI * 2, false );
 *
 * const geometry = new THREE.ShapeGeometry( arcShape );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00, side: THREE.DoubleSide } );
 * const mesh = new THREE.Mesh( geometry, material ) ;
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#ShapeGeometry
 */ class ShapeGeometry extends BufferGeometry {
    /**
	 * Constructs a new shape geometry.
	 *
	 * @param {Shape|Array<Shape>} [shapes] - A shape or an array of shapes.
	 * @param {number} [curveSegments=12] - Number of segments per shape.
	 */ constructor(shapes = new Shape([
        new Vector2(0, 0.5),
        new Vector2(-0.5, -0.5),
        new Vector2(0.5, -0.5)
    ]), curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if (ShapeUtils.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if (ShapeUtils.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = ShapeUtils.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // indices
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        const shapes = this.parameters.shapes;
        return toJSON(shapes, data);
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @param {Array<Shape>} shapes - An array of shapes.
	 * @return {ShapeGeometry} A new instance.
	 */ static fromJSON(data, shapes) {
        const geometryShapes = [];
        for(let j = 0, jl = data.shapes.length; j < jl; j++){
            const shape = shapes[data.shapes[j]];
            geometryShapes.push(shape);
        }
        return new ShapeGeometry(geometryShapes, data.curveSegments);
    }
}
function toJSON(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
/**
 * A class for generating a sphere geometry.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry( 15, 32, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const sphere = new THREE.Mesh( geometry, material );
 * scene.add( sphere );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#SphereGeometry
 */ class SphereGeometry extends BufferGeometry {
    /**
	 * Constructs a new sphere geometry.
	 *
	 * @param {number} [radius=1] - The sphere radius.
	 * @param {number} [widthSegments=32] - The number of horizontal segments. Minimum value is `3`.
	 * @param {number} [heightSegments=16] - The number of vertical segments. Minimum value is `2`.
	 * @param {number} [phiStart=0] - The horizontal starting angle in radians.
	 * @param {number} [phiLength=Math.PI*2] - The horizontal sweep angle size.
	 * @param {number} [thetaStart=0] - The vertical starting angle in radians.
	 * @param {number} [thetaLength=Math.PI] - The vertical sweep angle size.
	 */ constructor(radius = 1, widthSegments = 32, heightSegments = 16, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new Vector3();
        const normal = new Vector3();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy === 0 && thetaStart === 0) uOffset = 0.5 / widthSegments;
            else if (iy === heightSegments && thetaEnd === Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {SphereGeometry} A new instance.
	 */ static fromJSON(data) {
        return new SphereGeometry(data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
    }
}
/**
 * A geometry class for representing an tetrahedron.
 *
 * ```js
 * const geometry = new THREE.TetrahedronGeometry();
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const tetrahedron = new THREE.Mesh( geometry, material );
 * scene.add( tetrahedron );
 * ```
 *
 * @augments PolyhedronGeometry
 * @demo scenes/geometry-browser.html#TetrahedronGeometry
 */ class TetrahedronGeometry extends PolyhedronGeometry {
    /**
	 * Constructs a new tetrahedron geometry.
	 *
	 * @param {number} [radius=1] - Radius of the tetrahedron.
	 * @param {number} [detail=0] - Setting this to a value greater than `0` adds vertices making it no longer a tetrahedron.
	 */ constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            detail: detail
        };
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TetrahedronGeometry} A new instance.
	 */ static fromJSON(data) {
        return new TetrahedronGeometry(data.radius, data.detail);
    }
}
/**
 * A geometry class for representing an torus.
 *
 * ```js
 * const geometry = new THREE.TorusGeometry( 10, 3, 16, 100 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torus = new THREE.Mesh( geometry, material );
 * scene.add( torus );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TorusGeometry
 */ class TorusGeometry extends BufferGeometry {
    /**
	 * Constructs a new torus geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus, from the center of the torus to the center of the tube.
	 * @param {number} [tube=0.4] - Radius of the tube. Must be smaller than `radius`.
	 * @param {number} [radialSegments=12] - The number of radial segments.
	 * @param {number} [tubularSegments=48] - The number of tubular segments.
	 * @param {number} [arc=Math.PI*2] - Central angle in radians.
	 */ constructor(radius = 1, tube = 0.4, radialSegments = 12, tubularSegments = 48, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new Vector3();
        const vertex = new Vector3();
        const normal = new Vector3();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusGeometry} A new instance.
	 */ static fromJSON(data) {
        return new TorusGeometry(data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
    }
}
/**
 * Creates a torus knot, the particular shape of which is defined by a pair
 * of coprime integers, p and q. If p and q are not coprime, the result will
 * be a torus link.
 *
 * ```js
 * const geometry = new THREE.TorusKnotGeometry( 10, 3, 100, 16 );
 * const material = new THREE.MeshBasicMaterial( { color: 0xffff00 } );
 * const torusKnot = new THREE.Mesh( geometry, material );
 * scene.add( torusKnot );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TorusKnotGeometry
 */ class TorusKnotGeometry extends BufferGeometry {
    /**
	 * Constructs a new torus knot geometry.
	 *
	 * @param {number} [radius=1] - Radius of the torus knot.
	 * @param {number} [tube=0.4] - Radius of the tube.
	 * @param {number} [tubularSegments=64] - The number of tubular segments.
	 * @param {number} [radialSegments=8] - The number of radial segments.
	 * @param {number} [p=2] - This value determines, how many times the geometry winds around its axis of rotational symmetry.
	 * @param {number} [q=3] - This value determines, how many times the geometry winds around a circle in the interior of the torus.
	 */ constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new Vector3();
        const normal = new Vector3();
        const P1 = new Vector3();
        const P2 = new Vector3();
        const B = new Vector3();
        const T = new Vector3();
        const N = new Vector3();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segment
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectors, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TorusKnotGeometry} A new instance.
	 */ static fromJSON(data) {
        return new TorusKnotGeometry(data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
    }
}
/**
 * Creates a tube that extrudes along a 3D curve.
 *
 * ```js
 * class CustomSinCurve extends THREE.Curve {
 *
 * 	getPoint( t, optionalTarget = new THREE.Vector3() ) {
 *
 * 		const tx = t * 3 - 1.5;
 * 		const ty = Math.sin( 2 * Math.PI * t );
 * 		const tz = 0;
 *
 * 		return optionalTarget.set( tx, ty, tz );
 * 	}
 *
 * }
 *
 * const path = new CustomSinCurve( 10 );
 * const geometry = new THREE.TubeGeometry( path, 20, 2, 8, false );
 * const material = new THREE.MeshBasicMaterial( { color: 0x00ff00 } );
 * const mesh = new THREE.Mesh( geometry, material );
 * scene.add( mesh );
 * ```
 *
 * @augments BufferGeometry
 * @demo scenes/geometry-browser.html#TubeGeometry
 */ class TubeGeometry extends BufferGeometry {
    /**
	 * Constructs a new tube geometry.
	 *
	 * @param {Curve} [path=QuadraticBezierCurve3] - A 3D curve defining the path of the tube.
	 * @param {number} [tubularSegments=64] - The number of segments that make up the tube.
	 * @param {number} [radius=1] -The radius of the tube.
	 * @param {number} [radialSegments=8] - The number of segments that make up the cross-section.
	 * @param {boolean} [closed=false] - Whether the tube is closed or not.
	 */ constructor(path = new QuadraticBezierCurve3(new Vector3(-1, -1, 0), new Vector3(-1, 1, 0), new Vector3(1, 1, 0)), tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new Vector3();
        const normal = new Vector3();
        const uv = new Vector2();
        let P = new Vector3();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.path = this.parameters.path.toJSON();
        return data;
    }
    /**
	 * Factory method for creating an instance of this class from the given
	 * JSON object.
	 *
	 * @param {Object} data - A JSON object representing the serialized geometry.
	 * @return {TubeGeometry} A new instance.
	 */ static fromJSON(data) {
        // This only works for built-in curves (e.g. CatmullRomCurve3).
        // User defined curves or instances of CurvePath will not be deserialized.
        return new TubeGeometry(new Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
    }
}
/**
 * Can be used as a helper object to visualize a geometry as a wireframe.
 *
 * ```js
 * const geometry = new THREE.SphereGeometry();
 *
 * const wireframe = new THREE.WireframeGeometry( geometry );
 *
 * const line = new THREE.LineSegments( wireframe );
 * line.material.depthWrite = false;
 * line.material.opacity = 0.25;
 * line.material.transparent = true;
 *
 * scene.add( line );
 * ```
 *
 * Note: It is not yet possible to serialize/deserialize instances of this class.
 *
 * @augments BufferGeometry
 */ class WireframeGeometry extends BufferGeometry {
    /**
	 * Constructs a new wireframe geometry.
	 *
	 * @param {?BufferGeometry} [geometry=null] - The geometry.
	 */ constructor(geometry = null){
        super();
        this.type = 'WireframeGeometry';
        /**
		 * Holds the constructor parameters that have been
		 * used to generate the geometry. Any modification
		 * after instantiation does not change the geometry.
		 *
		 * @type {Object}
		 */ this.parameters = {
            geometry: geometry
        };
        if (geometry !== null) {
            // buffer
            const vertices = [];
            const edges = new Set();
            // helper variables
            const start = new Vector3();
            const end = new Vector3();
            if (geometry.index !== null) {
                // indexed BufferGeometry
                const position = geometry.attributes.position;
                const indices = geometry.index;
                let groups = geometry.groups;
                if (groups.length === 0) groups = [
                    {
                        start: 0,
                        count: indices.count,
                        materialIndex: 0
                    }
                ];
                // create a data structure that contains all edges without duplicates
                for(let o = 0, ol = groups.length; o < ol; ++o){
                    const group = groups[o];
                    const groupStart = group.start;
                    const groupCount = group.count;
                    for(let i = groupStart, l = groupStart + groupCount; i < l; i += 3)for(let j = 0; j < 3; j++){
                        const index1 = indices.getX(i + j);
                        const index2 = indices.getX(i + (j + 1) % 3);
                        start.fromBufferAttribute(position, index1);
                        end.fromBufferAttribute(position, index2);
                        if (isUniqueEdge(start, end, edges) === true) {
                            vertices.push(start.x, start.y, start.z);
                            vertices.push(end.x, end.y, end.z);
                        }
                    }
                }
            } else {
                // non-indexed BufferGeometry
                const position = geometry.attributes.position;
                for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                    // three edges per triangle, an edge is represented as (index1, index2)
                    // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                    const index1 = 3 * i + j;
                    const index2 = 3 * i + (j + 1) % 3;
                    start.fromBufferAttribute(position, index1);
                    end.fromBufferAttribute(position, index2);
                    if (isUniqueEdge(start, end, edges) === true) {
                        vertices.push(start.x, start.y, start.z);
                        vertices.push(end.x, end.y, end.z);
                    }
                }
            }
            // build geometry
            this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        }
    }
    copy(source) {
        super.copy(source);
        this.parameters = Object.assign({}, source.parameters);
        return this;
    }
}
function isUniqueEdge(start, end, edges) {
    const hash1 = `${start.x},${start.y},${start.z}-${end.x},${end.y},${end.z}`;
    const hash2 = `${end.x},${end.y},${end.z}-${start.x},${start.y},${start.z}`; // coincident edge
    if (edges.has(hash1) === true || edges.has(hash2) === true) return false;
    else {
        edges.add(hash1);
        edges.add(hash2);
        return true;
    }
}
var Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: BoxGeometry,
    CapsuleGeometry: CapsuleGeometry,
    CircleGeometry: CircleGeometry,
    ConeGeometry: ConeGeometry,
    CylinderGeometry: CylinderGeometry,
    DodecahedronGeometry: DodecahedronGeometry,
    EdgesGeometry: EdgesGeometry,
    ExtrudeGeometry: ExtrudeGeometry,
    IcosahedronGeometry: IcosahedronGeometry,
    LatheGeometry: LatheGeometry,
    OctahedronGeometry: OctahedronGeometry,
    PlaneGeometry: PlaneGeometry,
    PolyhedronGeometry: PolyhedronGeometry,
    RingGeometry: RingGeometry,
    ShapeGeometry: ShapeGeometry,
    SphereGeometry: SphereGeometry,
    TetrahedronGeometry: TetrahedronGeometry,
    TorusGeometry: TorusGeometry,
    TorusKnotGeometry: TorusKnotGeometry,
    TubeGeometry: TubeGeometry,
    WireframeGeometry: WireframeGeometry
});
/**
 * This material can receive shadows, but otherwise is completely transparent.
 *
 * ```js
 * const geometry = new THREE.PlaneGeometry( 2000, 2000 );
 * geometry.rotateX( - Math.PI / 2 );
 *
 * const material = new THREE.ShadowMaterial();
 * material.opacity = 0.2;
 *
 * const plane = new THREE.Mesh( geometry, material );
 * plane.position.y = -200;
 * plane.receiveShadow = true;
 * scene.add( plane );
 * ```
 *
 * @augments Material
 */ class ShadowMaterial extends Material {
    /**
	 * Constructs a new shadow material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isShadowMaterial = true;
        this.type = 'ShadowMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.color = new Color(0x000000);
        /**
		 * Overwritten since shadow materials are transparent
		 * by default.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.transparent = true;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.fog = source.fog;
        return this;
    }
}
/**
 * This class works just like {@link ShaderMaterial}, except that definitions
 * of built-in uniforms and attributes are not automatically prepended to the
 * GLSL shader code.
 *
 * `RawShaderMaterial` can only be used with {@link WebGLRenderer}.
 *
 * @augments ShaderMaterial
 */ class RawShaderMaterial extends ShaderMaterial {
    /**
	 * Constructs a new raw shader material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super(parameters);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRawShaderMaterial = true;
        this.type = 'RawShaderMaterial';
    }
}
/**
 * A standard physically based material, using Metallic-Roughness workflow.
 *
 * Physically based rendering (PBR) has recently become the standard in many
 * 3D applications, such as [Unity](https://blogs.unity3d.com/2014/10/29/physically-based-shading-in-unity-5-a-primer/),
 * [Unreal](https://docs.unrealengine.com/latest/INT/Engine/Rendering/Materials/PhysicallyBased/) and
 * [3D Studio Max](http://area.autodesk.com/blogs/the-3ds-max-blog/what039s-new-for-rendering-in-3ds-max-2017).
 *
 * This approach differs from older approaches in that instead of using
 * approximations for the way in which light interacts with a surface, a
 * physically correct model is used. The idea is that, instead of tweaking
 * materials to look good under specific lighting, a material can be created
 * that will react 'correctly' under all lighting scenarios.
 *
 * In practice this gives a more accurate and realistic looking result than
 * the {@link MeshLambertMaterial} or {@link MeshPhongMaterial}, at the cost of
 * being somewhat more computationally expensive. `MeshStandardMaterial` uses per-fragment
 * shading.
 *
 * Note that for best results you should always specify an environment map when using this material.
 *
 * For a non-technical introduction to the concept of PBR and how to set up a
 * PBR material, check out these articles by the people at [marmoset](https://www.marmoset.co):
 *
 * - [Basic Theory of Physically Based Rendering](https://www.marmoset.co/posts/basic-theory-of-physically-based-rendering/)
 * - [Physically Based Rendering and You Can Too](https://www.marmoset.co/posts/physically-based-rendering-and-you-can-too/)
 *
 * Technical details of the approach used in three.js (and most other PBR systems) can be found is this
 * [paper from Disney](https://media.disneyanimation.com/uploads/production/publication_asset/48/asset/s2012_pbs_disney_brdf_notes_v3.pdf)
 * (pdf), by Brent Burley.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshStandardMaterial
 */ class MeshStandardMaterial extends Material {
    /**
	 * Constructs a new mesh standard material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshStandardMaterial = true;
        this.type = 'MeshStandardMaterial';
        this.defines = {
            'STANDARD': ''
        };
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new Color(0xffffff); // diffuse
        /**
		 * How rough the material appears. `0.0` means a smooth mirror reflection, `1.0`
		 * means fully diffuse. If `roughnessMap` is also provided,
		 * both values are multiplied.
		 *
		 * @type {number}
		 * @default 1
		 */ this.roughness = 1.0;
        /**
		 * How much the material is like a metal. Non-metallic materials such as wood
		 * or stone use `0.0`, metallic use `1.0`, with nothing (usually) in between.
		 * A value between `0.0` and `1.0` could be used for a rusty metal look.
		 * If `metalnessMap` is also provided, both values are multiplied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.metalness = 0.0;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new Color(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = TangentSpaceNormalMap;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new Vector2(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The green channel of this texture is used to alter the roughness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.roughnessMap = null;
        /**
		 * The blue channel of this texture is used to alter the metalness of the
		 * material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.metalnessMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map. To ensure a physically correct rendering, environment maps
		 * are internally pre-processed with {@link PMREMGenerator}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new Euler();
        /**
		 * Scales the effect of the environment map by multiplying its color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.envMapIntensity = 1.0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': ''
        };
        this.color.copy(source.color);
        this.roughness = source.roughness;
        this.metalness = source.metalness;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.roughnessMap = source.roughnessMap;
        this.metalnessMap = source.metalnessMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.envMapIntensity = source.envMapIntensity;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * An extension of the {@link MeshStandardMaterial}, providing more advanced
 * physically-based rendering properties:
 *
 * - Anisotropy: Ability to represent the anisotropic property of materials
 * as observable with brushed metals.
 * - Clearcoat: Some materials — like car paints, carbon fiber, and wet surfaces — require
 * a clear, reflective layer on top of another layer that may be irregular or rough.
 * Clearcoat approximates this effect, without the need for a separate transparent surface.
 * - Iridescence: Allows to render the effect where hue varies  depending on the viewing
 * angle and illumination angle. This can be seen on soap bubbles, oil films, or on the
 * wings of many insects.
 * - Physically-based transparency: One limitation of {@link Material#opacity} is that highly
 * transparent materials are less reflective. Physically-based transmission provides a more
 * realistic option for thin, transparent surfaces like glass.
 * - Advanced reflectivity: More flexible reflectivity for non-metallic materials.
 * - Sheen: Can be used for representing cloth and fabric materials.
 *
 * As a result of these complex shading features, `MeshPhysicalMaterial` has a
 * higher performance cost, per pixel, than other three.js materials. Most
 * effects are disabled by default, and add cost as they are enabled. For
 * best results, always specify an environment map when using this material.
 *
 * @augments MeshStandardMaterial
 * @demo scenes/material-browser.html#MeshPhysicalMaterial
 */ class MeshPhysicalMaterial extends MeshStandardMaterial {
    /**
	 * Constructs a new mesh physical material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhysicalMaterial = true;
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.type = 'MeshPhysicalMaterial';
        /**
		 * The rotation of the anisotropy in tangent, bitangent space, measured in radians
		 * counter-clockwise from the tangent. When `anisotropyMap` is present, this
		 * property provides additional rotation to the vectors in the texture.
		 *
		 * @type {number}
		 * @default 1
		 */ this.anisotropyRotation = 0;
        /**
		 * Red and green channels represent the anisotropy direction in `[-1, 1]` tangent,
		 * bitangent space, to be rotated by `anisotropyRotation`. The blue channel
		 * contains strength as `[0, 1]` to be multiplied by `anisotropy`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.anisotropyMap = null;
        /**
		 * The red channel of this texture is multiplied against `clearcoat`,
		 * for per-pixel control over a coating's intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatMap = null;
        /**
		 * Roughness of the clear coat layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.clearcoatRoughness = 0.0;
        /**
		 * The green channel of this texture is multiplied against
		 * `clearcoatRoughness`, for per-pixel control over a coating's roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatRoughnessMap = null;
        /**
		 * How much `clearcoatNormalMap` affects the clear coat layer, from
		 * `(0,0)` to `(1,1)`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.clearcoatNormalScale = new Vector2(1, 1);
        /**
		 * Can be used to enable independent normals for the clear coat layer.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.clearcoatNormalMap = null;
        /**
		 * Index-of-refraction for non-metallic materials, from `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.5
		 */ this.ior = 1.5;
        /**
		 * Degree of reflectivity, from `0.0` to `1.0`. Default is `0.5`, which
		 * corresponds to an index-of-refraction of `1.5`.
		 *
		 * This models the reflectivity of non-metallic materials. It has no effect
		 * when `metalness` is `1.0`
		 *
		 * @name MeshPhysicalMaterial#reflectivity
		 * @type {number}
		 * @default 0.5
		 */ Object.defineProperty(this, 'reflectivity', {
            get: function() {
                return clamp(2.5 * (this.ior - 1) / (this.ior + 1), 0, 1);
            },
            set: function(reflectivity) {
                this.ior = (1 + 0.4 * reflectivity) / (1 - 0.4 * reflectivity);
            }
        });
        /**
		 * The red channel of this texture is multiplied against `iridescence`, for per-pixel
		 * control over iridescence.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceMap = null;
        /**
		 * Strength of the iridescence RGB color shift effect, represented by an index-of-refraction.
		 * Between `1.0` to `2.333`.
		 *
		 * @type {number}
		 * @default 1.3
		 */ this.iridescenceIOR = 1.3;
        /**
		 *Array of exactly 2 elements, specifying minimum and maximum thickness of the iridescence layer.
		 Thickness of iridescence layer has an equivalent effect of the one `thickness` has on `ior`.
		 *
		 * @type {Array<number,number>}
		 * @default [100,400]
		 */ this.iridescenceThicknessRange = [
            100,
            400
        ];
        /**
		 * A texture that defines the thickness of the iridescence layer, stored in the green channel.
		 * Minimum and maximum values of thickness are defined by `iridescenceThicknessRange` array:
		 * - `0.0` in the green channel will result in thickness equal to first element of the array.
		 * - `1.0` in the green channel will result in thickness equal to second element of the array.
		 * - Values in-between will linearly interpolate between the elements of the array.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.iridescenceThicknessMap = null;
        /**
		 * The sheen tint.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.sheenColor = new Color(0x000000);
        /**
		 * The RGB channels of this texture are multiplied against  `sheenColor`, for per-pixel control
		 * over sheen tint.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenColorMap = null;
        /**
		 * Roughness of the sheen layer, from `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.sheenRoughness = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `sheenRoughness`, for per-pixel control
		 * over sheen roughness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.sheenRoughnessMap = null;
        /**
		 * The red channel of this texture is multiplied against `transmission`, for per-pixel control over
		 * optical transparency.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.transmissionMap = null;
        /**
		 * The thickness of the volume beneath the surface. The value is given in the
		 * coordinate space of the mesh. If the value is `0` the material is
		 * thin-walled. Otherwise the material is a volume boundary.
		 *
		 * @type {number}
		 * @default 0
		 */ this.thickness = 0;
        /**
		 * A texture that defines the thickness, stored in the green channel. This will
		 * be multiplied by `thickness`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.thicknessMap = null;
        /**
		 * Density of the medium given as the average distance that light travels in
		 * the medium before interacting with a particle. The value is given in world
		 * space units, and must be greater than zero.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.attenuationDistance = Infinity;
        /**
		 * The color that white light turns into due to absorption when reaching the
		 * attenuation distance.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.attenuationColor = new Color(1, 1, 1);
        /**
		 * A float that scales the amount of specular reflection for non-metals only.
		 * When set to zero, the model is effectively Lambertian. From `0.0` to `1.0`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.specularIntensity = 1.0;
        /**
		 * The alpha channel of this texture is multiplied against `specularIntensity`,
		 * for per-pixel control over specular intensity.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularIntensityMap = null;
        /**
		 * Tints the specular reflection at normal incidence for non-metals only.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.specularColor = new Color(1, 1, 1);
        /**
		 * The RGB channels of this texture are multiplied against `specularColor`,
		 * for per-pixel control over specular color.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularColorMap = null;
        this._anisotropy = 0;
        this._clearcoat = 0;
        this._dispersion = 0;
        this._iridescence = 0;
        this._sheen = 0.0;
        this._transmission = 0;
        this.setValues(parameters);
    }
    /**
	 * The anisotropy strength, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get anisotropy() {
        return this._anisotropy;
    }
    set anisotropy(value) {
        if (this._anisotropy > 0 !== value > 0) this.version++;
        this._anisotropy = value;
    }
    /**
	 * Represents the intensity of the clear coat layer, from `0.0` to `1.0`. Use
	 * clear coat related properties to enable multilayer materials that have a
	 * thin translucent layer over the base layer.
	 *
	 * @type {number}
	 * @default 0
	 */ get clearcoat() {
        return this._clearcoat;
    }
    set clearcoat(value) {
        if (this._clearcoat > 0 !== value > 0) this.version++;
        this._clearcoat = value;
    }
    /**
	 * The intensity of the iridescence layer, simulating RGB color shift based on the angle between
	 * the surface and the viewer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get iridescence() {
        return this._iridescence;
    }
    set iridescence(value) {
        if (this._iridescence > 0 !== value > 0) this.version++;
        this._iridescence = value;
    }
    /**
	 * Defines the strength of the angular separation of colors (chromatic aberration) transmitting
	 * through a relatively clear volume. Any value zero or larger is valid, the typical range of
	 * realistic values is `[0, 1]`. This property can be only be used with transmissive objects.
	 *
	 * @type {number}
	 * @default 0
	 */ get dispersion() {
        return this._dispersion;
    }
    set dispersion(value) {
        if (this._dispersion > 0 !== value > 0) this.version++;
        this._dispersion = value;
    }
    /**
	 * The intensity of the sheen layer, from `0.0` to `1.0`.
	 *
	 * @type {number}
	 * @default 0
	 */ get sheen() {
        return this._sheen;
    }
    set sheen(value) {
        if (this._sheen > 0 !== value > 0) this.version++;
        this._sheen = value;
    }
    /**
	 * Degree of transmission (or optical transparency), from `0.0` to `1.0`.
	 *
	 * Thin, transparent or semitransparent, plastic or glass materials remain
	 * largely reflective even if they are fully transmissive. The transmission
	 * property can be used to model these materials.
	 *
	 * When transmission is non-zero, `opacity` should be  set to `1`.
	 *
	 * @type {number}
	 * @default 0
	 */ get transmission() {
        return this._transmission;
    }
    set transmission(value) {
        if (this._transmission > 0 !== value > 0) this.version++;
        this._transmission = value;
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'STANDARD': '',
            'PHYSICAL': ''
        };
        this.anisotropy = source.anisotropy;
        this.anisotropyRotation = source.anisotropyRotation;
        this.anisotropyMap = source.anisotropyMap;
        this.clearcoat = source.clearcoat;
        this.clearcoatMap = source.clearcoatMap;
        this.clearcoatRoughness = source.clearcoatRoughness;
        this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
        this.clearcoatNormalMap = source.clearcoatNormalMap;
        this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
        this.dispersion = source.dispersion;
        this.ior = source.ior;
        this.iridescence = source.iridescence;
        this.iridescenceMap = source.iridescenceMap;
        this.iridescenceIOR = source.iridescenceIOR;
        this.iridescenceThicknessRange = [
            ...source.iridescenceThicknessRange
        ];
        this.iridescenceThicknessMap = source.iridescenceThicknessMap;
        this.sheen = source.sheen;
        this.sheenColor.copy(source.sheenColor);
        this.sheenColorMap = source.sheenColorMap;
        this.sheenRoughness = source.sheenRoughness;
        this.sheenRoughnessMap = source.sheenRoughnessMap;
        this.transmission = source.transmission;
        this.transmissionMap = source.transmissionMap;
        this.thickness = source.thickness;
        this.thicknessMap = source.thicknessMap;
        this.attenuationDistance = source.attenuationDistance;
        this.attenuationColor.copy(source.attenuationColor);
        this.specularIntensity = source.specularIntensity;
        this.specularIntensityMap = source.specularIntensityMap;
        this.specularColor.copy(source.specularColor);
        this.specularColorMap = source.specularColorMap;
        return this;
    }
}
/**
 * A material for shiny surfaces with specular highlights.
 *
 * The material uses a non-physically based [Blinn-Phong](https://en.wikipedia.org/wiki/Blinn-Phong_shading_model)
 * model for calculating reflectance. Unlike the Lambertian model used in the
 * {@link MeshLambertMaterial} this can simulate shiny surfaces with specular
 * highlights (such as varnished wood). `MeshPhongMaterial` uses per-fragment shading.
 *
 * Performance will generally be greater when using this material over the
 * {@link MeshStandardMaterial} or {@link MeshPhysicalMaterial}, at the cost of
 * some graphical accuracy.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshPhongMaterial
 */ class MeshPhongMaterial extends Material {
    /**
	 * Constructs a new mesh phong material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshPhongMaterial = true;
        this.type = 'MeshPhongMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new Color(0xffffff); // diffuse
        /**
		 * Specular color of the material. The default color is set to `0x111111` (very dark grey)
		 *
		 * This defines how shiny the material is and the color of its shine.
		 *
		 * @type {Color}
		 */ this.specular = new Color(0x111111);
        /**
		 * How shiny the specular highlight is; a higher value gives a sharper highlight.
		 *
		 * @type {number}
		 * @default 30
		 */ this.shininess = 30;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new Color(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = TangentSpaceNormalMap;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new Vector2(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The specular map value affects both how much the specular surface
		 * highlight contributes and how much of the environment map affects the
		 * surface.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new Euler();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = MultiplyOperation;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.specular.copy(source.specular);
        this.shininess = source.shininess;
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material implementing toon shading.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshToonMaterial
 */ class MeshToonMaterial extends Material {
    /**
	 * Constructs a new mesh toon material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshToonMaterial = true;
        this.defines = {
            'TOON': ''
        };
        this.type = 'MeshToonMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new Color(0xffffff);
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * Gradient map for toon shading. It's required to set
		 * {@link Texture#minFilter} and {@link Texture#magFilter} to {@linkNearestFilter}
		 * when using this type of texture.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.gradientMap = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new Color(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = TangentSpaceNormalMap;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new Vector2(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.gradientMap = source.gradientMap;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material that maps the normal vectors to RGB colors.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshNormalMaterial
 */ class MeshNormalMaterial extends Material {
    /**
	 * Constructs a new mesh normal material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshNormalMaterial = true;
        this.type = 'MeshNormalMaterial';
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = TangentSpaceNormalMap;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new Vector2(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        return this;
    }
}
/**
 * A material for non-shiny surfaces, without specular highlights.
 *
 * The material uses a non-physically based [Lambertian](https://en.wikipedia.org/wiki/Lambertian_reflectance)
 * model for calculating reflectance. This can simulate some surfaces (such
 * as untreated wood or stone) well, but cannot simulate shiny surfaces with
 * specular highlights (such as varnished wood). `MeshLambertMaterial` uses per-fragment
 * shading.
 *
 * Due to the simplicity of the reflectance and illumination models,
 * performance will be greater when using this material over the
 * {@link MeshPhongMaterial}, {@link MeshStandardMaterial} or
 * {@link MeshPhysicalMaterial}, at the cost of some graphical accuracy.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshLambertMaterial
 */ class MeshLambertMaterial extends Material {
    /**
	 * Constructs a new mesh lambert material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshLambertMaterial = true;
        this.type = 'MeshLambertMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new Color(0xffffff); // diffuse
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The light map. Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.lightMap = null;
        /**
		 * Intensity of the baked light.
		 *
		 * @type {number}
		 * @default 1
		 */ this.lightMapIntensity = 1.0;
        /**
		 * The red channel of this texture is used as the ambient occlusion map.
		 * Requires a second set of UVs.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.aoMap = null;
        /**
		 * Intensity of the ambient occlusion effect. Range is `[0,1]`, where `0`
		 * disables ambient occlusion. Where intensity is `1` and the AO map's
		 * red channel is also `1`, ambient light is fully occluded on a surface.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aoMapIntensity = 1.0;
        /**
		 * Emissive (light) color of the material, essentially a solid color
		 * unaffected by other lighting.
		 *
		 * @type {Color}
		 * @default (0,0,0)
		 */ this.emissive = new Color(0x000000);
        /**
		 * Intensity of the emissive light. Modulates the emissive color.
		 *
		 * @type {number}
		 * @default 1
		 */ this.emissiveIntensity = 1.0;
        /**
		 * Set emissive (glow) map. The emissive map color is modulated by the
		 * emissive color and the emissive intensity. If you have an emissive map,
		 * be sure to set the emissive color to something other than black.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.emissiveMap = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = TangentSpaceNormalMap;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new Vector2(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Specular map used by the material.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.specularMap = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The environment map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.envMap = null;
        /**
		 * The rotation of the environment map in radians.
		 *
		 * @type {Euler}
		 * @default (0,0,0)
		 */ this.envMapRotation = new Euler();
        /**
		 * How to combine the result of the surface's color with the environment map, if any.
		 *
		 * When set to `MixOperation`, the {@link MeshBasicMaterial#reflectivity} is used to
		 * blend between the two colors.
		 *
		 * @type {(MultiplyOperation|MixOperation|AddOperation)}
		 * @default MultiplyOperation
		 */ this.combine = MultiplyOperation;
        /**
		 * How much the environment map affects the surface.
		 * The valid range is between `0` (no reflections) and `1` (full reflections).
		 *
		 * @type {number}
		 * @default 1
		 */ this.reflectivity = 1;
        /**
		 * The index of refraction (IOR) of air (approximately 1) divided by the
		 * index of refraction of the material. It is used with environment mapping
		 * modes {@link CubeRefractionMapping} and {@link EquirectangularRefractionMapping}.
		 * The refraction ratio should not exceed `1`.
		 *
		 * @type {number}
		 * @default 0.98
		 */ this.refractionRatio = 0.98;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Defines appearance of wireframe ends.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinecap = 'round';
        /**
		 * Defines appearance of wireframe joints.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {('round'|'bevel'|'miter')}
		 * @default 'round'
		 */ this.wireframeLinejoin = 'round';
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.color.copy(source.color);
        this.map = source.map;
        this.lightMap = source.lightMap;
        this.lightMapIntensity = source.lightMapIntensity;
        this.aoMap = source.aoMap;
        this.aoMapIntensity = source.aoMapIntensity;
        this.emissive.copy(source.emissive);
        this.emissiveMap = source.emissiveMap;
        this.emissiveIntensity = source.emissiveIntensity;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.specularMap = source.specularMap;
        this.alphaMap = source.alphaMap;
        this.envMap = source.envMap;
        this.envMapRotation.copy(source.envMapRotation);
        this.combine = source.combine;
        this.reflectivity = source.reflectivity;
        this.refractionRatio = source.refractionRatio;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.wireframeLinecap = source.wireframeLinecap;
        this.wireframeLinejoin = source.wireframeLinejoin;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material for drawing geometry by depth. Depth is based off of the camera
 * near and far plane. White is nearest, black is farthest.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshDepthMaterial
 */ class MeshDepthMaterial extends Material {
    /**
	 * Constructs a new mesh depth material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDepthMaterial = true;
        this.type = 'MeshDepthMaterial';
        /**
		 * Type for depth packing.
		 *
		 * @type {(BasicDepthPacking|RGBADepthPacking|RGBDepthPacking|RGDepthPacking)}
		 * @default BasicDepthPacking
		 */ this.depthPacking = BasicDepthPacking;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * WebGL and WebGPU ignore this property and always render
		 * 1 pixel wide lines.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.depthPacking = source.depthPacking;
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        return this;
    }
}
/**
 * A material used internally for implementing shadow mapping with
 * point lights.
 *
 * Can also be used to customize the shadow casting of an object by assigning
 * an instance of `MeshDistanceMaterial` to {@link Object3D#customDistanceMaterial}.
 * The following examples demonstrates this approach in order to ensure
 * transparent parts of objects do not cast shadows.
 *
 * @augments Material
 */ class MeshDistanceMaterial extends Material {
    /**
	 * Constructs a new mesh distance material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshDistanceMaterial = true;
        this.type = 'MeshDistanceMaterial';
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.map = source.map;
        this.alphaMap = source.alphaMap;
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        return this;
    }
}
/**
 * This material is defined by a MatCap (or Lit Sphere) texture, which encodes the
 * material color and shading.
 *
 * `MeshMatcapMaterial` does not respond to lights since the matcap image file encodes
 * baked lighting. It will cast a shadow onto an object that receives shadows
 * (and shadow clipping works), but it will not self-shadow or receive
 * shadows.
 *
 * @augments Material
 * @demo scenes/material-browser.html#MeshMatcapMaterial
 */ class MeshMatcapMaterial extends Material {
    /**
	 * Constructs a new mesh matcap material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isMeshMatcapMaterial = true;
        this.defines = {
            'MATCAP': ''
        };
        this.type = 'MeshMatcapMaterial';
        /**
		 * Color of the material.
		 *
		 * @type {Color}
		 * @default (1,1,1)
		 */ this.color = new Color(0xffffff); // diffuse
        /**
		 * The matcap map.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.matcap = null;
        /**
		 * The color map. May optionally include an alpha channel, typically combined
		 * with {@link Material#transparent} or {@link Material#alphaTest}. The texture map
		 * color is modulated by the diffuse `color`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * The texture to create a bump map. The black and white values map to the
		 * perceived depth in relation to the lights. Bump doesn't actually affect
		 * the geometry of the object, only the lighting. If a normal map is defined
		 * this will be ignored.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.bumpMap = null;
        /**
		 * How much the bump map affects the material. Typical range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.bumpScale = 1;
        /**
		 * The texture to create a normal map. The RGB values affect the surface
		 * normal for each pixel fragment and change the way the color is lit. Normal
		 * maps do not change the actual shape of the surface, only the lighting. In
		 * case the material has a normal map authored using the left handed
		 * convention, the `y` component of `normalScale` should be negated to compensate
		 * for the different handedness.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.normalMap = null;
        /**
		 * The type of normal map.
		 *
		 * @type {(TangentSpaceNormalMap|ObjectSpaceNormalMap)}
		 * @default TangentSpaceNormalMap
		 */ this.normalMapType = TangentSpaceNormalMap;
        /**
		 * How much the normal map affects the material. Typical value range is `[0,1]`.
		 *
		 * @type {Vector2}
		 * @default (1,1)
		 */ this.normalScale = new Vector2(1, 1);
        /**
		 * The displacement map affects the position of the mesh's vertices. Unlike
		 * other maps which only affect the light and shade of the material the
		 * displaced vertices can cast shadows, block other objects, and otherwise
		 * act as real geometry. The displacement texture is an image where the value
		 * of each pixel (white being the highest) is mapped against, and
		 * repositions, the vertices of the mesh.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.displacementMap = null;
        /**
		 * How much the displacement map affects the mesh (where black is no
		 * displacement, and white is maximum displacement). Without a displacement
		 * map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementScale = 1;
        /**
		 * The offset of the displacement map's values on the mesh's vertices.
		 * The bias is added to the scaled sample of the displacement map.
		 * Without a displacement map set, this value is not applied.
		 *
		 * @type {number}
		 * @default 0
		 */ this.displacementBias = 0;
        /**
		 * The alpha map is a grayscale texture that controls the opacity across the
		 * surface (black: fully transparent; white: fully opaque).
		 *
		 * Only the color of the texture is used, ignoring the alpha channel if one
		 * exists. For RGB and RGBA textures, the renderer will use the green channel
		 * when sampling this texture due to the extra bit of precision provided for
		 * green in DXT-compressed and uncompressed RGB 565 formats. Luminance-only and
		 * luminance/alpha textures will also still work as expected.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.alphaMap = null;
        /**
		 * Renders the geometry as a wireframe.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.wireframe = false;
        /**
		 * Controls the thickness of the wireframe.
		 *
		 * Can only be used with {@link SVGRenderer}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.wireframeLinewidth = 1;
        /**
		 * Whether the material is rendered with flat shading or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.flatShading = false;
        /**
		 * Whether the material is affected by fog or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.fog = true;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.defines = {
            'MATCAP': ''
        };
        this.color.copy(source.color);
        this.matcap = source.matcap;
        this.map = source.map;
        this.bumpMap = source.bumpMap;
        this.bumpScale = source.bumpScale;
        this.normalMap = source.normalMap;
        this.normalMapType = source.normalMapType;
        this.normalScale.copy(source.normalScale);
        this.displacementMap = source.displacementMap;
        this.displacementScale = source.displacementScale;
        this.displacementBias = source.displacementBias;
        this.alphaMap = source.alphaMap;
        this.wireframe = source.wireframe;
        this.wireframeLinewidth = source.wireframeLinewidth;
        this.flatShading = source.flatShading;
        this.fog = source.fog;
        return this;
    }
}
/**
 * A material for rendering line primitives.
 *
 * Materials define the appearance of renderable 3D objects.
 *
 * ```js
 * const material = new THREE.LineDashedMaterial( {
 * 	color: 0xffffff,
 * 	scale: 1,
 * 	dashSize: 3,
 * 	gapSize: 1,
 * } );
 * ```
 *
 * @augments LineBasicMaterial
 */ class LineDashedMaterial extends LineBasicMaterial {
    /**
	 * Constructs a new line dashed material.
	 *
	 * @param {Object} [parameters] - An object with one or more properties
	 * defining the material's appearance. Any property of the material
	 * (including any property from inherited materials) can be passed
	 * in here. Color values can be passed any type of value accepted
	 * by {@link Color#set}.
	 */ constructor(parameters){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLineDashedMaterial = true;
        this.type = 'LineDashedMaterial';
        /**
		 * The scale of the dashed part of a line.
		 *
		 * @type {number}
		 * @default 1
		 */ this.scale = 1;
        /**
		 * The size of the dash. This is both the gap with the stroke.
		 *
		 * @type {number}
		 * @default 3
		 */ this.dashSize = 3;
        /**
		 * The size of the gap.
		 *
		 * @type {number}
		 * @default 1
		 */ this.gapSize = 1;
        this.setValues(parameters);
    }
    copy(source) {
        super.copy(source);
        this.scale = source.scale;
        this.dashSize = source.dashSize;
        this.gapSize = source.gapSize;
        return this;
    }
}
/**
 * Converts an array to a specific type.
 *
 * @param {TypedArray|Array} array - The array to convert.
 * @param {TypedArray.constructor} type - The constructor of a typed array that defines the new type.
 * @return {TypedArray} The converted array.
 */ function convertArray(array, type) {
    if (!array || array.constructor === type) return array;
    if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
    return Array.prototype.slice.call(array); // create Array
}
/**
 * Returns an array by which times and values can be sorted.
 *
 * @param {Array<number>} times - The keyframe time values.
 * @return {Array<number>} The array.
 */ function getKeyframeOrder(times) {
    function compareTime(i, j) {
        return times[i] - times[j];
    }
    const n = times.length;
    const result = new Array(n);
    for(let i = 0; i !== n; ++i)result[i] = i;
    result.sort(compareTime);
    return result;
}
/**
 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
 *
 * @param {Array<number>} values - The values to sort.
 * @param {number} stride - The stride.
 * @param {Array<number>} order - The sort order.
 * @return {Array<number>} The sorted values.
 */ function sortedArray(values, stride, order) {
    const nValues = values.length;
    const result = new values.constructor(nValues);
    for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
        const srcOffset = order[i] * stride;
        for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
    }
    return result;
}
/**
 * Used for parsing AOS keyframe formats.
 *
 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
 * @param {Array<number>} times - This array will be filled with keyframe times by this function.
 * @param {Array<number>} values - This array will be filled with keyframe values by this function.
 * @param {string} valuePropertyName - The name of the property to use.
 */ function flattenJSON(jsonKeys, times, values, valuePropertyName) {
    let i = 1, key = jsonKeys[0];
    while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
    if (key === undefined) return; // no data
    let value = key[valuePropertyName];
    if (value === undefined) return; // no data
    if (Array.isArray(value)) do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(...value); // push all elements
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else if (value.toArray !== undefined) // ...assume THREE.Math-ish
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            value.toArray(values, values.length);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
    else // otherwise push as-is
    do {
        value = key[valuePropertyName];
        if (value !== undefined) {
            times.push(key.time);
            values.push(value);
        }
        key = jsonKeys[i++];
    }while (key !== undefined);
}
/**
 * Creates a new clip, containing only the segment of the original clip between the given frames.
 *
 * @param {AnimationClip} sourceClip - The values to sort.
 * @param {string} name - The name of the clip.
 * @param {number} startFrame - The start frame.
 * @param {number} endFrame - The end frame.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The new sub clip.
 */ function subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
    const clip = sourceClip.clone();
    clip.name = name;
    const tracks = [];
    for(let i = 0; i < clip.tracks.length; ++i){
        const track = clip.tracks[i];
        const valueSize = track.getValueSize();
        const times = [];
        const values = [];
        for(let j = 0; j < track.times.length; ++j){
            const frame = track.times[j] * fps;
            if (frame < startFrame || frame >= endFrame) continue;
            times.push(track.times[j]);
            for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
        }
        if (times.length === 0) continue;
        track.times = convertArray(times, track.times.constructor);
        track.values = convertArray(values, track.values.constructor);
        tracks.push(track);
    }
    clip.tracks = tracks;
    // find minimum .times value across all tracks in the trimmed clip
    let minStartTime = Infinity;
    for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
    // shift all tracks such that clip begins at t=0
    for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
    clip.resetDuration();
    return clip;
}
/**
 * Converts the keyframes of the given animation clip to an additive format.
 *
 * @param {AnimationClip} targetClip - The clip to make additive.
 * @param {number} [referenceFrame=0] - The reference frame.
 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
 * @param {number} [fps=30] - The FPS.
 * @return {AnimationClip} The updated clip which is now additive.
 */ function makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
    if (fps <= 0) fps = 30;
    const numTracks = referenceClip.tracks.length;
    const referenceTime = referenceFrame / fps;
    // Make each track's values relative to the values at the reference frame
    for(let i = 0; i < numTracks; ++i){
        const referenceTrack = referenceClip.tracks[i];
        const referenceTrackType = referenceTrack.ValueTypeName;
        // Skip this track if it's non-numeric
        if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
        // Find the track in the target clip whose name and type matches the reference track
        const targetTrack = targetClip.tracks.find(function(track) {
            return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
        });
        if (targetTrack === undefined) continue;
        let referenceOffset = 0;
        const referenceValueSize = referenceTrack.getValueSize();
        if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
        let targetOffset = 0;
        const targetValueSize = targetTrack.getValueSize();
        if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
        const lastIndex = referenceTrack.times.length - 1;
        let referenceValue;
        // Find the value to subtract out of the track
        if (referenceTime <= referenceTrack.times[0]) {
            // Reference frame is earlier than the first keyframe, so just use the first keyframe
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else if (referenceTime >= referenceTrack.times[lastIndex]) {
            // Reference frame is after the last keyframe, so just use the last keyframe
            const startIndex = lastIndex * referenceValueSize + referenceOffset;
            const endIndex = startIndex + referenceValueSize - referenceOffset;
            referenceValue = referenceTrack.values.slice(startIndex, endIndex);
        } else {
            // Interpolate to the reference value
            const interpolant = referenceTrack.createInterpolant();
            const startIndex = referenceOffset;
            const endIndex = referenceValueSize - referenceOffset;
            interpolant.evaluate(referenceTime);
            referenceValue = interpolant.resultBuffer.slice(startIndex, endIndex);
        }
        // Conjugate the quaternion
        if (referenceTrackType === 'quaternion') {
            const referenceQuat = new Quaternion().fromArray(referenceValue).normalize().conjugate();
            referenceQuat.toArray(referenceValue);
        }
        // Subtract the reference value from all of the track values
        const numTimes = targetTrack.times.length;
        for(let j = 0; j < numTimes; ++j){
            const valueStart = j * targetValueSize + targetOffset;
            if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
            Quaternion.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
            else {
                const valueEnd = targetValueSize - targetOffset * 2;
                // Subtract each value for all other numeric track types
                for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
            }
        }
    }
    targetClip.blendMode = AdditiveAnimationBlendMode;
    return targetClip;
}
/**
 * A class with various methods to assist with animations.
 *
 * @hideconstructor
 */ class AnimationUtils {
    /**
	 * Converts an array to a specific type
	 *
	 * @static
	 * @param {TypedArray|Array} array - The array to convert.
	 * @param {TypedArray.constructor} type - The constructor of a type array.
	 * @return {TypedArray} The converted array
	 */ static convertArray(array, type) {
        return convertArray(array, type);
    }
    /**
	 * Returns `true` if the given object is a typed array.
	 *
	 * @static
	 * @param {any} object - The object to check.
	 * @return {boolean} Whether the given object is a typed array.
	 */ static isTypedArray(object) {
        return isTypedArray(object);
    }
    /**
	 * Returns an array by which times and values can be sorted.
	 *
	 * @static
	 * @param {Array<number>} times - The keyframe time values.
	 * @return {Array<number>} The array.
	 */ static getKeyframeOrder(times) {
        return getKeyframeOrder(times);
    }
    /**
	 * Sorts the given array by the previously computed order via `getKeyframeOrder()`.
	 *
	 * @static
	 * @param {Array<number>} values - The values to sort.
	 * @param {number} stride - The stride.
	 * @param {Array<number>} order - The sort order.
	 * @return {Array<number>} The sorted values.
	 */ static sortedArray(values, stride, order) {
        return sortedArray(values, stride, order);
    }
    /**
	 * Used for parsing AOS keyframe formats.
	 *
	 * @static
	 * @param {Array<number>} jsonKeys - A list of JSON keyframes.
	 * @param {Array<number>} times - This array will be filled with keyframe times by this method.
	 * @param {Array<number>} values - This array will be filled with keyframe values by this method.
	 * @param {string} valuePropertyName - The name of the property to use.
	 */ static flattenJSON(jsonKeys, times, values, valuePropertyName) {
        flattenJSON(jsonKeys, times, values, valuePropertyName);
    }
    /**
	 * Creates a new clip, containing only the segment of the original clip between the given frames.
	 *
	 * @static
	 * @param {AnimationClip} sourceClip - The values to sort.
	 * @param {string} name - The name of the clip.
	 * @param {number} startFrame - The start frame.
	 * @param {number} endFrame - The end frame.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The new sub clip.
	 */ static subclip(sourceClip, name, startFrame, endFrame, fps = 30) {
        return subclip(sourceClip, name, startFrame, endFrame, fps);
    }
    /**
	 * Converts the keyframes of the given animation clip to an additive format.
	 *
	 * @static
	 * @param {AnimationClip} targetClip - The clip to make additive.
	 * @param {number} [referenceFrame=0] - The reference frame.
	 * @param {AnimationClip} [referenceClip=targetClip] - The reference clip.
	 * @param {number} [fps=30] - The FPS.
	 * @return {AnimationClip} The updated clip which is now additive.
	 */ static makeClipAdditive(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        return makeClipAdditive(targetClip, referenceFrame, referenceClip, fps);
    }
}
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References: {@link http://www.oodesign.com/template-method-pattern.html}
 *
 * @abstract
 */ class Interpolant {
    /**
	 * Constructs a new interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        /**
		 * The parameter positions.
		 *
		 * @type {TypedArray}
		 */ this.parameterPositions = parameterPositions;
        /**
		 * A cache index.
		 *
		 * @private
		 * @type {number}
		 * @default 0
		 */ this._cachedIndex = 0;
        /**
		 * The result buffer.
		 *
		 * @type {TypedArray}
		 */ this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
        /**
		 * The sample values.
		 *
		 * @type {TypedArray}
		 */ this.sampleValues = sampleValues;
        /**
		 * The value size.
		 *
		 * @type {TypedArray}
		 */ this.valueSize = sampleSize;
        /**
		 * The interpolation settings.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.settings = null;
        /**
		 * The default settings object.
		 *
		 * @type {Object}
		 */ this.DefaultSettings_ = {};
    }
    /**
	 * Evaluate the interpolant at position `t`.
	 *
	 * @param {number} t - The interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ evaluate(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.copySampleValue_(i1 - 1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.copySampleValue_(0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.copySampleValue_(0);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.copySampleValue_(i1 - 1);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    }
    /**
	 * Returns the interpolation settings.
	 *
	 * @return {Object} The interpolation settings.
	 */ getSettings_() {
        return this.settings || this.DefaultSettings_;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @param {number} index - An index into the sample value buffer.
	 * @return {TypedArray} The result buffer.
	 */ copySampleValue_(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    }
    /**
	 * Copies a sample value to the result buffer.
	 *
	 * @abstract
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 * @param {number} t1 - The next interpolation factor.
	 * @return {TypedArray} The result buffer.
	 */ interpolate_() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    }
    /**
	 * Optional method that is executed when the interval has changed.
	 *
	 * @param {number} i1 - An index into the sample value buffer.
	 * @param {number} t0 - The previous interpolation factor.
	 * @param {number} t - The current interpolation factor.
	 */ intervalChanged_() {
    // empty
    }
}
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 *
 * @augments Interpolant
 */ class CubicInterpolant extends Interpolant {
    /**
	 * Constructs a new cubic interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
        this._weightPrev = -0;
        this._offsetPrev = -0;
        this._weightNext = -0;
        this._offsetNext = -0;
        this.DefaultSettings_ = {
            endingStart: ZeroCurvatureEnding,
            endingEnd: ZeroCurvatureEnding
        };
    }
    intervalChanged_(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case ZeroSlopeEnding:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case WrapAroundEnding:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case ZeroSlopeEnding:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case WrapAroundEnding:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
}
/**
 * A basic linear interpolant.
 *
 * @augments Interpolant
 */ class LinearInterpolant extends Interpolant {
    /**
	 * Constructs a new linear interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
}
/**
 * Interpolant that evaluates to the sample value at the position preceding
 * the parameter.
 *
 * @augments Interpolant
 */ class DiscreteInterpolant extends Interpolant {
    /**
	 * Constructs a new discrete interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
}
/**
 * Represents s a timed sequence of keyframes, which are composed of lists of
 * times and related values, and which are used to animate a specific property
 * of an object.
 */ class KeyframeTrack {
    /**
	 * Constructs a new keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number|string|boolean>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
        if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
        /**
		 * The track's name can refer to morph targets or bones or
		 * possibly other values within an animated object. See {@link PropertyBinding#parseTrackName}
		 * for the forms of strings that can be parsed for property binding.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 * The keyframe times.
		 *
		 * @type {Float32Array}
		 */ this.times = convertArray(times, this.TimeBufferType);
        /**
		 * The keyframe values.
		 *
		 * @type {Float32Array}
		 */ this.values = convertArray(values, this.ValueBufferType);
        this.setInterpolation(interpolation || this.DefaultInterpolation);
    }
    /**
	 * Converts the keyframe track to JSON.
	 *
	 * @static
	 * @param {KeyframeTrack} track - The keyframe track to serialize.
	 * @return {Object} The serialized keyframe track as JSON.
	 */ static toJSON(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== this.toJSON) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': convertArray(track.times, Array),
                'values': convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
    /**
	 * Factory method for creating a new discrete interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {DiscreteInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodDiscrete(result) {
        return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new linear interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {LinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new LinearInterpolant(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Factory method for creating a new smooth interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {CubicInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodSmooth(result) {
        return new CubicInterpolant(this.times, this.values, this.getValueSize(), result);
    }
    /**
	 * Defines the interpolation factor method for this keyframe track.
	 *
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} interpolation - The interpolation type.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ setInterpolation(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case InterpolateDiscrete:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case InterpolateLinear:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case InterpolateSmooth:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            warn('KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    }
    /**
	 * Returns the current interpolation type.
	 *
	 * @return {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} The interpolation type.
	 */ getInterpolation() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return InterpolateDiscrete;
            case this.InterpolantFactoryMethodLinear:
                return InterpolateLinear;
            case this.InterpolantFactoryMethodSmooth:
                return InterpolateSmooth;
        }
    }
    /**
	 * Returns the value size.
	 *
	 * @return {number} The value size.
	 */ getValueSize() {
        return this.values.length / this.times.length;
    }
    /**
	 * Moves all keyframes either forward or backward in time.
	 *
	 * @param {number} timeOffset - The offset to move the time values.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ shift(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    }
    /**
	 * Scale all keyframe times by a factor (useful for frame - seconds conversions).
	 *
	 * @param {number} timeScale - The time scale.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ scale(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    }
    /**
	 * Removes keyframes before and after animation without changing any values within the defined time range.
	 *
	 * Note: The method does not shift around keys to the start of the track time, because for interpolated
	 * keys this will change their values
	 *
	 * @param {number} startTime - The start time.
	 * @param {number} endTime - The end time.
	 * @return {KeyframeTrack} A reference to this keyframe track.
	 */ trim(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = times.slice(from, to);
            this.values = this.values.slice(from * stride, to * stride);
        }
        return this;
    }
    /**
	 * Performs minimal validation on the keyframe track. Returns `true` if the values
	 * are valid.
	 *
	 * @return {boolean} Whether the keyframes are valid or not.
	 */ validate() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            error('KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            error('KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                error('KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                error('KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if (isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    error('KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    }
    /**
	 * Optimizes this keyframe track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ optimize() {
        // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = this.times.slice(), values = this.values.slice(), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === InterpolateSmooth, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = times.slice(0, writeIndex);
            this.values = values.slice(0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    }
    /**
	 * Returns a new keyframe track with copied values from this instance.
	 *
	 * @return {KeyframeTrack} A clone of this instance.
	 */ clone() {
        const times = this.times.slice();
        const values = this.values.slice();
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default ''
 */ KeyframeTrack.prototype.ValueTypeName = '';
/**
 * The time buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ KeyframeTrack.prototype.TimeBufferType = Float32Array;
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Float32Array.constructor
 */ KeyframeTrack.prototype.ValueBufferType = Float32Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateLinear
 */ KeyframeTrack.prototype.DefaultInterpolation = InterpolateLinear;
/**
 * A track for boolean keyframe values.
 *
 * @augments KeyframeTrack
 */ class BooleanKeyframeTrack extends KeyframeTrack {
    /**
	 * Constructs a new boolean keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<boolean>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'bool'
 */ BooleanKeyframeTrack.prototype.ValueTypeName = 'bool';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ BooleanKeyframeTrack.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ BooleanKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = undefined;
BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for color keyframe values.
 *
 * @augments KeyframeTrack
 */ class ColorKeyframeTrack extends KeyframeTrack {
    /**
	 * Constructs a new color keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'color'
 */ ColorKeyframeTrack.prototype.ValueTypeName = 'color';
/**
 * A track for numeric keyframe values.
 *
 * @augments KeyframeTrack
 */ class NumberKeyframeTrack extends KeyframeTrack {
    /**
	 * Constructs a new number keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'number'
 */ NumberKeyframeTrack.prototype.ValueTypeName = 'number';
/**
 * Spherical linear unit quaternion interpolant.
 *
 * @augments Interpolant
 */ class QuaternionLinearInterpolant extends Interpolant {
    /**
	 * Constructs a new SLERP interpolant.
	 *
	 * @param {TypedArray} parameterPositions - The parameter positions hold the interpolation factors.
	 * @param {TypedArray} sampleValues - The sample values.
	 * @param {number} sampleSize - The sample size
	 * @param {TypedArray} [resultBuffer] - The result buffer.
	 */ constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)Quaternion.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
}
/**
 * A track for Quaternion keyframe values.
 *
 * @augments KeyframeTrack
 */ class QuaternionKeyframeTrack extends KeyframeTrack {
    /**
	 * Constructs a new Quaternion keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
    /**
	 * Overwritten so the method returns Quaternion based interpolant.
	 *
	 * @static
	 * @param {TypedArray} [result] - The result buffer.
	 * @return {QuaternionLinearInterpolant} The new interpolant.
	 */ InterpolantFactoryMethodLinear(result) {
        return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), result);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'quaternion'
 */ QuaternionKeyframeTrack.prototype.ValueTypeName = 'quaternion';
// ValueBufferType is inherited
// DefaultInterpolation is inherited;
QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for string keyframe values.
 *
 * @augments KeyframeTrack
 */ class StringKeyframeTrack extends KeyframeTrack {
    /**
	 * Constructs a new string keyframe track.
	 *
	 * This keyframe track type has no `interpolation` parameter because the
	 * interpolation is always discrete.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<string>} values - A list of keyframe values.
	 */ constructor(name, times, values){
        super(name, times, values);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'string'
 */ StringKeyframeTrack.prototype.ValueTypeName = 'string';
/**
 * The value buffer type of this keyframe track.
 *
 * @type {TypedArray|Array}
 * @default Array.constructor
 */ StringKeyframeTrack.prototype.ValueBufferType = Array;
/**
 * The default interpolation type of this keyframe track.
 *
 * @type {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)}
 * @default InterpolateDiscrete
 */ StringKeyframeTrack.prototype.DefaultInterpolation = InterpolateDiscrete;
StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = undefined;
StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = undefined;
/**
 * A track for vector keyframe values.
 *
 * @augments KeyframeTrack
 */ class VectorKeyframeTrack extends KeyframeTrack {
    /**
	 * Constructs a new vector keyframe track.
	 *
	 * @param {string} name - The keyframe track's name.
	 * @param {Array<number>} times - A list of keyframe times.
	 * @param {Array<number>} values - A list of keyframe values.
	 * @param {(InterpolateLinear|InterpolateDiscrete|InterpolateSmooth)} [interpolation] - The interpolation type.
	 */ constructor(name, times, values, interpolation){
        super(name, times, values, interpolation);
    }
}
/**
 * The value type name.
 *
 * @type {string}
 * @default 'vector'
 */ VectorKeyframeTrack.prototype.ValueTypeName = 'vector';
/**
 * A reusable set of keyframe tracks which represent an animation.
 */ class AnimationClip {
    /**
	 * Constructs a new animation clip.
	 *
	 * Note: Instead of instantiating an AnimationClip directly with the constructor, you can
	 * use the static interface of this class for creating clips. In most cases though, animation clips
	 * will automatically be created by loaders when importing animated 3D assets.
	 *
	 * @param {string} [name=''] - The clip's name.
	 * @param {number} [duration=-1] - The clip's duration in seconds. If a negative value is passed,
	 * the duration will be calculated from the passed keyframes.
	 * @param {Array<KeyframeTrack>} tracks - An array of keyframe tracks.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode=NormalAnimationBlendMode] - Defines how the animation
	 * is blended/combined when two or more animations are simultaneously played.
	 */ constructor(name = '', duration = -1, tracks = [], blendMode = NormalAnimationBlendMode){
        /**
		 * The clip's name.
		 *
		 * @type {string}
		 */ this.name = name;
        /**
		 *  An array of keyframe tracks.
		 *
		 * @type {Array<KeyframeTrack>}
		 */ this.tracks = tracks;
        /**
		 * The clip's duration in seconds.
		 *
		 * @type {number}
		 */ this.duration = duration;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        /**
		 * The UUID of the animation clip.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = generateUUID();
        /**
		 * An object that can be used to store custom data about the animation clip.
		 * It should not hold references to functions as these will not be cloned.
		 *
		 * @type {Object}
		 */ this.userData = {};
        // this means it should figure out its duration by scanning the tracks
        if (this.duration < 0) this.resetDuration();
    }
    /**
	 * Factory method for creating an animation clip from the given JSON.
	 *
	 * @static
	 * @param {Object} json - The serialized animation clip.
	 * @return {AnimationClip} The new animation clip.
	 */ static parse(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push(parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new this(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        clip.userData = JSON.parse(json.userData || '{}');
        return clip;
    }
    /**
	 * Serializes the given animation clip into JSON.
	 *
	 * @static
	 * @param {AnimationClip} clip - The animation clip to serialize.
	 * @return {Object} The JSON object.
	 */ static toJSON(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode,
            'userData': JSON.stringify(clip.userData)
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push(KeyframeTrack.toJSON(clipTracks[i]));
        return json;
    }
    /**
	 * Returns a new animation clip from the passed morph targets array of a
	 * geometry, taking a name and the number of frames per second.
	 *
	 * Note: The fps parameter is required, but the animation speed can be
	 * overridden via {@link AnimationAction#setDuration}.
	 *
	 * @static
	 * @param {string} name - The name of the animation clip.
	 * @param {Array<Object>} morphTargetSequence - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {AnimationClip} The new animation clip.
	 */ static CreateFromMorphTargetSequence(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = getKeyframeOrder(times);
            times = sortedArray(times, 1, order);
            values = sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new NumberKeyframeTrack('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new this(name, -1, tracks);
    }
    /**
	 * Searches for an animation clip by name, taking as its first parameter
	 * either an array of clips, or a mesh or geometry that contains an
	 * array named "animations" property.
	 *
	 * @static
	 * @param {(Array<AnimationClip>|Object3D)} objectOrClipArray - The array or object to search through.
	 * @param {string} name - The name to search for.
	 * @return {?AnimationClip} The found animation clip. Returns `null` if no clip has been found.
	 */ static findByName(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    }
    /**
	 * Returns an array of new AnimationClips created from the morph target
	 * sequences of a geometry, trying to sort morph target names into
	 * animation-group-based patterns like "Walk_001, Walk_002, Run_001, Run_002...".
	 *
	 * See {@link MD2Loader#parse} as an example for how the method should be used.
	 *
	 * @static
	 * @param {Array<Object>} morphTargets - A sequence of morph targets.
	 * @param {number} fps - The Frames-Per-Second value.
	 * @param {boolean} noLoop - Whether the clip should be no loop or not.
	 * @return {Array<AnimationClip>} An array of new animation clips.
	 */ static CreateClipsFromMorphTargetSequences(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(this.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    }
    /**
	 * Parses the `animation.hierarchy` format and returns a new animation clip.
	 *
	 * @static
	 * @deprecated since r175.
	 * @param {Object} animation - A serialized animation clip as JSON.
	 * @param {Array<Bones>} bones - An array of bones.
	 * @return {?AnimationClip} The new animation clip.
	 */ static parseAnimation(animation, bones) {
        warn('AnimationClip: parseAnimation() is deprecated and will be removed with r185');
        if (!animation) {
            error('AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new NumberKeyframeTrack('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * fps;
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack(VectorKeyframeTrack, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack(QuaternionKeyframeTrack, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack(VectorKeyframeTrack, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new this(clipName, duration, tracks, blendMode);
        return clip;
    }
    /**
	 * Sets the duration of this clip to the duration of its longest keyframe track.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ resetDuration() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    }
    /**
	 * Trims all tracks to the clip's duration.
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ trim() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    }
    /**
	 * Performs minimal validation on each track in the clip. Returns `true` if all
	 * tracks are valid.
	 *
	 * @return {boolean} Whether the clip's keyframes are valid or not.
	 */ validate() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    }
    /**
	 * Optimizes each track by removing equivalent sequential keys (which are
	 * common in morph target sequences).
	 *
	 * @return {AnimationClip} A reference to this animation clip.
	 */ optimize() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    }
    /**
	 * Returns a new animation clip with copied values from this instance.
	 *
	 * @return {AnimationClip} A clone of this instance.
	 */ clone() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        const clip = new this.constructor(this.name, this.duration, tracks, this.blendMode);
        clip.userData = JSON.parse(JSON.stringify(this.userData));
        return clip;
    }
    /**
	 * Serializes this animation clip into JSON.
	 *
	 * @return {Object} The JSON object.
	 */ toJSON() {
        return this.constructor.toJSON(this);
    }
}
function getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return NumberKeyframeTrack;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return VectorKeyframeTrack;
        case 'color':
            return ColorKeyframeTrack;
        case 'quaternion':
            return QuaternionKeyframeTrack;
        case 'bool':
        case 'boolean':
            return BooleanKeyframeTrack;
        case 'string':
            return StringKeyframeTrack;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
/**
 * @class
 * @classdesc A simple caching system, used internally by {@link FileLoader}.
 * To enable caching across all loaders that use {@link FileLoader}, add `THREE.Cache.enabled = true.` once in your app.
 * @hideconstructor
 */ const Cache = {
    /**
	 * Whether caching is enabled or not.
	 *
	 * @static
	 * @type {boolean}
	 * @default false
	 */ enabled: false,
    /**
	 * A dictionary that holds cached files.
	 *
	 * @static
	 * @type {Object<string,Object>}
	 */ files: {},
    /**
	 * Adds a cache entry with a key to reference the file. If this key already
	 * holds a file, it is overwritten.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @param {Object} file -  The file to be cached.
	 */ add: function(key, file) {
        if (this.enabled === false) return;
        // log( 'Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    /**
	 * Gets the cached value for the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 * @return {Object|undefined} The cached file. If the key does not exist `undefined` is returned.
	 */ get: function(key) {
        if (this.enabled === false) return;
        // log( 'Cache', 'Checking key:', key );
        return this.files[key];
    },
    /**
	 * Removes the cached file associated with the given key.
	 *
	 * @static
	 * @param {string} key - The key to reference the cached file.
	 */ remove: function(key) {
        delete this.files[key];
    },
    /**
	 * Remove all values from the cache.
	 *
	 * @static
	 */ clear: function() {
        this.files = {};
    }
};
/**
 * Handles and keeps track of loaded and pending data. A default global
 * instance of this class is created and used by loaders if not supplied
 * manually.
 *
 * In general that should be sufficient, however there are times when it can
 * be useful to have separate loaders - for example if you want to show
 * separate loading bars for objects and textures.
 *
 * ```js
 * const manager = new THREE.LoadingManager();
 * manager.onLoad = () => console.log( 'Loading complete!' );
 *
 * const loader1 = new OBJLoader( manager );
 * const loader2 = new ColladaLoader( manager );
 * ```
 */ class LoadingManager {
    /**
	 * Constructs a new loading manager.
	 *
	 * @param {Function} [onLoad] - Executes when all items have been loaded.
	 * @param {Function} [onProgress] - Executes when single items have been loaded.
	 * @param {Function} [onError] - Executes when an error occurs.
	 */ constructor(onLoad, onProgress, onError){
        const scope = this;
        let isLoading = false;
        let itemsLoaded = 0;
        let itemsTotal = 0;
        let urlModifier = undefined;
        const handlers = [];
        // Refer to #5689 for the reason why we don't set .onStart
        // in the constructor
        /**
		 * Executes when an item starts loading.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onStart = undefined;
        /**
		 * Executes when all items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onLoad = onLoad;
        /**
		 * Executes when single items have been loaded.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onProgress = onProgress;
        /**
		 * Executes when an error occurs.
		 *
		 * @type {Function|undefined}
		 * @default undefined
		 */ this.onError = onError;
        /**
		 * Used for aborting ongoing requests in loaders using this manager.
		 *
		 * @private
		 * @type {AbortController | null}
		 */ this._abortController = null;
        /**
		 * This should be called by any loader using the manager when the loader
		 * starts loading an item.
		 *
		 * @param {string} url - The URL to load.
		 */ this.itemStart = function(url) {
            itemsTotal++;
            if (isLoading === false) {
                if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
            }
            isLoading = true;
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * ended loading an item.
		 *
		 * @param {string} url - The URL of the loaded item.
		 */ this.itemEnd = function(url) {
            itemsLoaded++;
            if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
            if (itemsLoaded === itemsTotal) {
                isLoading = false;
                if (scope.onLoad !== undefined) scope.onLoad();
            }
        };
        /**
		 * This should be called by any loader using the manager when the loader
		 * encounters an error when loading an item.
		 *
		 * @param {string} url - The URL of the item that produces an error.
		 */ this.itemError = function(url) {
            if (scope.onError !== undefined) scope.onError(url);
        };
        /**
		 * Given a URL, uses the URL modifier callback (if any) and returns a
		 * resolved URL. If no URL modifier is set, returns the original URL.
		 *
		 * @param {string} url - The URL to load.
		 * @return {string} The resolved URL.
		 */ this.resolveURL = function(url) {
            if (urlModifier) return urlModifier(url);
            return url;
        };
        /**
		 * If provided, the callback will be passed each resource URL before a
		 * request is sent. The callback may return the original URL, or a new URL to
		 * override loading behavior. This behavior can be used to load assets from
		 * .ZIP files, drag-and-drop APIs, and Data URIs.
		 *
		 * ```js
		 * const blobs = {'fish.gltf': blob1, 'diffuse.png': blob2, 'normal.png': blob3};
		 *
		 * const manager = new THREE.LoadingManager();
		 *
		 * // Initialize loading manager with URL callback.
		 * const objectURLs = [];
		 * manager.setURLModifier( ( url ) => {
		 *
		 * 	url = URL.createObjectURL( blobs[ url ] );
		 * 	objectURLs.push( url );
		 * 	return url;
		 *
		 * } );
		 *
		 * // Load as usual, then revoke the blob URLs.
		 * const loader = new GLTFLoader( manager );
		 * loader.load( 'fish.gltf', (gltf) => {
		 *
		 * 	scene.add( gltf.scene );
		 * 	objectURLs.forEach( ( url ) => URL.revokeObjectURL( url ) );
		 *
		 * } );
		 * ```
		 *
		 * @param {function(string):string} transform - URL modifier callback. Called with an URL and must return a resolved URL.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.setURLModifier = function(transform) {
            urlModifier = transform;
            return this;
        };
        /**
		 * Registers a loader with the given regular expression. Can be used to
		 * define what loader should be used in order to load specific files. A
		 * typical use case is to overwrite the default loader for textures.
		 *
		 * ```js
		 * // add handler for TGA textures
		 * manager.addHandler( /\.tga$/i, new TGALoader() );
		 * ```
		 *
		 * @param {string} regex - A regular expression.
		 * @param {Loader} loader - A loader that should handle matched cases.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.addHandler = function(regex, loader) {
            handlers.push(regex, loader);
            return this;
        };
        /**
		 * Removes the loader for the given regular expression.
		 *
		 * @param {string} regex - A regular expression.
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.removeHandler = function(regex) {
            const index = handlers.indexOf(regex);
            if (index !== -1) handlers.splice(index, 2);
            return this;
        };
        /**
		 * Can be used to retrieve the registered loader for the given file path.
		 *
		 * @param {string} file - The file path.
		 * @return {?Loader} The registered loader. Returns `null` if no loader was found.
		 */ this.getHandler = function(file) {
            for(let i = 0, l = handlers.length; i < l; i += 2){
                const regex = handlers[i];
                const loader = handlers[i + 1];
                if (regex.global) regex.lastIndex = 0; // see #17920
                if (regex.test(file)) return loader;
            }
            return null;
        };
        /**
		 * Can be used to abort ongoing loading requests in loaders using this manager.
		 * The abort only works if the loaders implement {@link Loader#abort} and `AbortSignal.any()`
		 * is supported in the browser.
		 *
		 * @return {LoadingManager} A reference to this loading manager.
		 */ this.abort = function() {
            this.abortController.abort();
            this._abortController = null;
            return this;
        };
    }
    // TODO: Revert this back to a single member variable once this issue has been fixed
    // https://github.com/cloudflare/workerd/issues/3657
    /**
	 * Used for aborting ongoing requests in loaders using this manager.
	 *
	 * @type {AbortController}
	 */ get abortController() {
        if (!this._abortController) this._abortController = new AbortController();
        return this._abortController;
    }
}
/**
 * The global default loading manager.
 *
 * @constant
 * @type {LoadingManager}
 */ const DefaultLoadingManager = /*@__PURE__*/ new LoadingManager();
/**
 * Abstract base class for loaders.
 *
 * @abstract
 */ class Loader {
    /**
	 * Constructs a new loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        /**
		 * The loading manager.
		 *
		 * @type {LoadingManager}
		 * @default DefaultLoadingManager
		 */ this.manager = manager !== undefined ? manager : DefaultLoadingManager;
        /**
		 * The crossOrigin string to implement CORS for loading the url from a
		 * different domain that allows CORS.
		 *
		 * @type {string}
		 * @default 'anonymous'
		 */ this.crossOrigin = 'anonymous';
        /**
		 * Whether the XMLHttpRequest uses credentials.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.withCredentials = false;
        /**
		 * The base path from which the asset will be loaded.
		 *
		 * @type {string}
		 */ this.path = '';
        /**
		 * The base path from which additional resources like textures will be loaded.
		 *
		 * @type {string}
		 */ this.resourcePath = '';
        /**
		 * The [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
		 * used in HTTP request.
		 *
		 * @type {Object<string, any>}
		 */ this.requestHeader = {};
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for loading assets from the backend.
	 *
	 * @abstract
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {Function} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 */ load() {}
    /**
	 * A async version of {@link Loader#load}.
	 *
	 * @param {string} url - The path/URL of the file to be loaded.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @return {Promise} A Promise that resolves when the asset has been loaded.
	 */ loadAsync(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    }
    /**
	 * This method needs to be implemented by all concrete loaders. It holds the
	 * logic for parsing the asset into three.js entities.
	 *
	 * @abstract
	 * @param {any} data - The data to parse.
	 */ parse() {}
    /**
	 * Sets the `crossOrigin` String to implement CORS for loading the URL
	 * from a different domain that allows CORS.
	 *
	 * @param {string} crossOrigin - The `crossOrigin` value.
	 * @return {Loader} A reference to this instance.
	 */ setCrossOrigin(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    }
    /**
	 * Whether the XMLHttpRequest uses credentials such as cookies, authorization
	 * headers or TLS client certificates, see [XMLHttpRequest.withCredentials](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/withCredentials).
	 *
	 * Note: This setting has no effect if you are loading files locally or from the same domain.
	 *
	 * @param {boolean} value - The `withCredentials` value.
	 * @return {Loader} A reference to this instance.
	 */ setWithCredentials(value) {
        this.withCredentials = value;
        return this;
    }
    /**
	 * Sets the base path for the asset.
	 *
	 * @param {string} path - The base path.
	 * @return {Loader} A reference to this instance.
	 */ setPath(path) {
        this.path = path;
        return this;
    }
    /**
	 * Sets the base path for dependent resources like textures.
	 *
	 * @param {string} resourcePath - The resource path.
	 * @return {Loader} A reference to this instance.
	 */ setResourcePath(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    }
    /**
	 * Sets the given request header.
	 *
	 * @param {Object} requestHeader - A [request header](https://developer.mozilla.org/en-US/docs/Glossary/Request_header)
	 * for configuring the HTTP request.
	 * @return {Loader} A reference to this instance.
	 */ setRequestHeader(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
    /**
	 * This method can be implemented in loaders for aborting ongoing requests.
	 *
	 * @abstract
	 * @return {Loader} A reference to this instance.
	 */ abort() {
        return this;
    }
}
/**
 * Callback for onProgress in loaders.
 *
 * @callback onProgressCallback
 * @param {ProgressEvent} event - An instance of `ProgressEvent` that represents the current loading status.
 */ /**
 * Callback for onError in loaders.
 *
 * @callback onErrorCallback
 * @param {Error} error - The error which occurred during the loading process.
 */ /**
 * The default material name that is used by loaders
 * when creating materials for loaded 3D objects.
 *
 * Note: Not all loaders might honor this setting.
 *
 * @static
 * @type {string}
 * @default '__DEFAULT'
 */ Loader.DEFAULT_MATERIAL_NAME = '__DEFAULT';
const loading = {};
class HttpError extends Error {
    constructor(message, response){
        super(message);
        this.response = response;
    }
}
/**
 * A low level class for loading resources with the Fetch API, used internally by
 * most loaders. It can also be used directly to load any file type that does
 * not have a loader.
 *
 * This loader supports caching. If you want to use it, add `THREE.Cache.enabled = true;`
 * once to your application.
 *
 * ```js
 * const loader = new THREE.FileLoader();
 * const data = await loader.loadAsync( 'example.txt' );
 * ```
 *
 * @augments Loader
 */ class FileLoader extends Loader {
    /**
	 * Constructs a new file loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * The expected mime type. Valid values can be found
		 * [here](hhttps://developer.mozilla.org/en-US/docs/Web/API/DOMParser/parseFromString#mimetype)
		 *
		 * @type {string}
		 */ this.mimeType = '';
        /**
		 * The expected response type.
		 *
		 * @type {('arraybuffer'|'blob'|'document'|'json'|'')}
		 * @default ''
		 */ this.responseType = '';
        /**
		 * Used for aborting requests.
		 *
		 * @private
		 * @type {AbortController}
		 */ this._abortController = new AbortController();
    }
    /**
	 * Starts loading from the given URL and pass the loaded response to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(any)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} [onProgress] - Executed while the loading is in progress.
	 * @param {onErrorCallback} [onError] - Executed when errors occur.
	 * @return {any|undefined} The cached resource if available.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const cached = Cache.get(`file:${url}`);
        if (cached !== undefined) {
            this.manager.itemStart(url);
            setTimeout(()=>{
                if (onLoad) onLoad(cached);
                this.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if (loading[url] !== undefined) {
            loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Initialise array for duplicate requests
        loading[url] = [];
        loading[url].push({
            onLoad: onLoad,
            onProgress: onProgress,
            onError: onError
        });
        // create request
        const req = new Request(url, {
            headers: new Headers(this.requestHeader),
            credentials: this.withCredentials ? 'include' : 'same-origin',
            signal: typeof AbortSignal.any === 'function' ? AbortSignal.any([
                this._abortController.signal,
                this.manager.abortController.signal
            ]) : this._abortController.signal
        });
        // record states ( avoid data race )
        const mimeType = this.mimeType;
        const responseType = this.responseType;
        // start the fetch
        fetch(req).then((response)=>{
            if (response.status === 200 || response.status === 0) {
                // Some browsers return HTTP Status 0 when using non-http protocol
                // e.g. 'file://' or 'data://'. Handle as success.
                if (response.status === 0) warn('FileLoader: HTTP Status 0 received.');
                // Workaround: Checking if response.body === undefined for Alipay browser #23548
                if (typeof ReadableStream === 'undefined' || response.body === undefined || response.body.getReader === undefined) return response;
                const callbacks = loading[url];
                const reader = response.body.getReader();
                // Nginx needs X-File-Size check
                // https://serverfault.com/questions/482875/why-does-nginx-remove-content-length-header-for-chunked-content
                const contentLength = response.headers.get('X-File-Size') || response.headers.get('Content-Length');
                const total = contentLength ? parseInt(contentLength) : 0;
                const lengthComputable = total !== 0;
                let loaded = 0;
                // periodically read data into the new stream tracking while download progress
                const stream = new ReadableStream({
                    start (controller) {
                        readData();
                        function readData() {
                            reader.read().then(({ done, value })=>{
                                if (done) controller.close();
                                else {
                                    loaded += value.byteLength;
                                    const event = new ProgressEvent('progress', {
                                        lengthComputable,
                                        loaded,
                                        total
                                    });
                                    for(let i = 0, il = callbacks.length; i < il; i++){
                                        const callback = callbacks[i];
                                        if (callback.onProgress) callback.onProgress(event);
                                    }
                                    controller.enqueue(value);
                                    readData();
                                }
                            }, (e)=>{
                                controller.error(e);
                            });
                        }
                    }
                });
                return new Response(stream);
            } else throw new HttpError(`fetch for "${response.url}" responded with ${response.status}: ${response.statusText}`, response);
        }).then((response)=>{
            switch(responseType){
                case 'arraybuffer':
                    return response.arrayBuffer();
                case 'blob':
                    return response.blob();
                case 'document':
                    return response.text().then((text)=>{
                        const parser = new DOMParser();
                        return parser.parseFromString(text, mimeType);
                    });
                case 'json':
                    return response.json();
                default:
                    if (mimeType === '') return response.text();
                    else {
                        // sniff encoding
                        const re = /charset="?([^;"\s]*)"?/i;
                        const exec = re.exec(mimeType);
                        const label = exec && exec[1] ? exec[1].toLowerCase() : undefined;
                        const decoder = new TextDecoder(label);
                        return response.arrayBuffer().then((ab)=>decoder.decode(ab));
                    }
            }
        }).then((data)=>{
            // Add to cache only on HTTP success, so that we do not cache
            // error response bodies as proper responses to requests.
            Cache.add(`file:${url}`, data);
            const callbacks = loading[url];
            delete loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(data);
            }
        }).catch((err)=>{
            // Abort errors and other errors are handled the same
            const callbacks = loading[url];
            if (callbacks === undefined) {
                // When onLoad was called and url was deleted in `loading`
                this.manager.itemError(url);
                throw err;
            }
            delete loading[url];
            for(let i = 0, il = callbacks.length; i < il; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(err);
            }
            this.manager.itemError(url);
        }).finally(()=>{
            this.manager.itemEnd(url);
        });
        this.manager.itemStart(url);
    }
    /**
	 * Sets the expected response type.
	 *
	 * @param {('arraybuffer'|'blob'|'document'|'json'|'')} value - The response type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setResponseType(value) {
        this.responseType = value;
        return this;
    }
    /**
	 * Sets the expected mime type of the loaded file.
	 *
	 * @param {string} value - The mime type.
	 * @return {FileLoader} A reference to this file loader.
	 */ setMimeType(value) {
        this.mimeType = value;
        return this;
    }
    /**
	 * Aborts ongoing fetch requests.
	 *
	 * @return {FileLoader} A reference to this instance.
	 */ abort() {
        this._abortController.abort();
        this._abortController = new AbortController();
        return this;
    }
}
/**
 * Class for loading animation clips in the JSON format. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.AnimationLoader();
 * const animations = await loader.loadAsync( 'animations/animation.js' );
 * ```
 *
 * @augments Loader
 */ class AnimationLoader extends Loader {
    /**
	 * Constructs a new animation loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded animations as an array
	 * holding instances of {@link AnimationClip} to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Array<AnimationClip>)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns an array of animation clips.
	 *
	 * @param {Object} json - The serialized animation clips.
	 * @return {Array<AnimationClip>} The parsed animation clips.
	 */ parse(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = AnimationClip.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
}
/**
 * Abstract base class for loading compressed texture formats S3TC, ASTC or ETC.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class CompressedTextureLoader extends Loader {
    /**
	 * Constructs a new compressed texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded compressed texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(CompressedTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CompressedTexture} The compressed texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new CompressedTexture();
        const loader = new FileLoader(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = LinearFilter;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = LinearFilter;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
const _loading = new WeakMap();
/**
 * A loader for loading images. The class loads images with the HTML `Image` API.
 *
 * ```js
 * const loader = new THREE.ImageLoader();
 * const image = await loader.loadAsync( 'image.png' );
 * ```
 * Please note that `ImageLoader` has dropped support for progress
 * events in `r84`. For an `ImageLoader` that supports progress events, see
 * [this thread](https://github.com/mrdoob/three.js/issues/10439#issuecomment-275785639).
 *
 * @augments Loader
 */ class ImageLoader extends Loader {
    /**
	 * Constructs a new image loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded image
	 * to the `onLoad()` callback. The method also returns a new `Image` object which can
	 * directly be used for texture creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Image)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Image} The image.
	 */ load(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = Cache.get(`image:${url}`);
        if (cached !== undefined) {
            if (cached.complete === true) {
                scope.manager.itemStart(url);
                setTimeout(function() {
                    if (onLoad) onLoad(cached);
                    scope.manager.itemEnd(url);
                }, 0);
            } else {
                let arr = _loading.get(cached);
                if (arr === undefined) {
                    arr = [];
                    _loading.set(cached, arr);
                }
                arr.push({
                    onLoad,
                    onError
                });
            }
            return cached;
        }
        const image = createElementNS('img');
        function onImageLoad() {
            removeEventListeners();
            if (onLoad) onLoad(this);
            //
            const callbacks = _loading.get(this) || [];
            for(let i = 0; i < callbacks.length; i++){
                const callback = callbacks[i];
                if (callback.onLoad) callback.onLoad(this);
            }
            _loading.delete(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            removeEventListeners();
            if (onError) onError(event);
            Cache.remove(`image:${url}`);
            //
            const callbacks = _loading.get(this) || [];
            for(let i = 0; i < callbacks.length; i++){
                const callback = callbacks[i];
                if (callback.onError) callback.onError(event);
            }
            _loading.delete(this);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        function removeEventListeners() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.slice(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        Cache.add(`image:${url}`, image);
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
}
/**
 * Class for loading cube textures. Images are internally loaded via {@link ImageLoader}.
 *
 * The loader returns an instance of {@link CubeTexture} and expects the cube map to
 * be defined as six separate images representing the sides of a cube. Other cube map definitions
 * like vertical and horizontal cross, column and row layouts are not supported.
 *
 * Note that, by convention, cube maps are specified in a coordinate system
 * in which positive-x is to the right when looking up the positive-z axis --
 * in other words, using a left-handed coordinate system. Since three.js uses
 * a right-handed coordinate system, environment maps used in three.js will
 * have pos-x and neg-x swapped.
 *
 * The loaded cube texture is in sRGB color space. Meaning {@link Texture#colorSpace}
 * is set to `SRGBColorSpace` by default.
 *
 * ```js
 * const loader = new THREE.CubeTextureLoader().setPath( 'textures/cubeMaps/' );
 * const cubeTexture = await loader.loadAsync( [
 * 	'px.png', 'nx.png', 'py.png', 'ny.png', 'pz.png', 'nz.png'
 * ] );
 * scene.background = cubeTexture;
 * ```
 *
 * @augments Loader
 */ class CubeTextureLoader extends Loader {
    /**
	 * Constructs a new cube texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the fully loaded cube texture
	 * to the `onLoad()` callback. The method also returns a new cube texture object which can
	 * directly be used for material creation. If you do it this way, the cube texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {Array<string>} urls - Array of 6 URLs to images, one for each side of the
	 * cube texture. The urls should be specified in the following order: pos-x,
	 * neg-x, pos-y, neg-y, pos-z, neg-z. An array of data URIs are allowed as well.
	 * @param {function(CubeTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {CubeTexture} The cube texture.
	 */ load(urls, onLoad, onProgress, onError) {
        const texture = new CubeTexture();
        texture.colorSpace = SRGBColorSpace;
        const loader = new ImageLoader(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
}
/**
 * Abstract base class for loading binary texture formats RGBE, EXR or TGA.
 * Textures are internally loaded via {@link FileLoader}.
 *
 * Derived classes have to implement the `parse()` method which holds the parsing
 * for the respective format.
 *
 * @abstract
 * @augments Loader
 */ class DataTextureLoader extends Loader {
    /**
	 * Constructs a new data texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded data texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(DataTexture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {DataTexture} The data texture.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new DataTexture();
        const loader = new FileLoader(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            let texData;
            try {
                texData = scope.parse(buffer);
            } catch (error) {
                if (onError !== undefined) onError(error);
                else {
                    error(error);
                    return;
                }
            }
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : ClampToEdgeWrapping;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : ClampToEdgeWrapping;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : LinearFilter;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : LinearFilter;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.colorSpace !== undefined) texture.colorSpace = texData.colorSpace;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = LinearMipmapLinearFilter; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = LinearFilter;
            if (texData.generateMipmaps !== undefined) texture.generateMipmaps = texData.generateMipmaps;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Class for loading textures. Images are internally
 * loaded via {@link ImageLoader}.
 *
 * ```js
 * const loader = new THREE.TextureLoader();
 * const texture = await loader.loadAsync( 'textures/land_ocean_ice_cloud_2048.jpg' );
 *
 * const material = new THREE.MeshBasicMaterial( { map:texture } );
 * ```
 * Please note that `TextureLoader` has dropped support for progress
 * events in `r84`. For a `TextureLoader` that supports progress events, see
 * [this thread](https://github.com/mrdoob/three.js/issues/10439#issuecomment-293260145).
 *
 * @augments Loader
 */ class TextureLoader extends Loader {
    /**
	 * Constructs a new texture loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the fully loaded texture
	 * to the `onLoad()` callback. The method also returns a new texture object which can
	 * directly be used for material creation. If you do it this way, the texture
	 * may pop up in your scene once the respective loading process is finished.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Texture)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {Texture} The texture.
	 */ load(url, onLoad, onProgress, onError) {
        const texture = new Texture();
        const loader = new ImageLoader(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
}
/**
 * Abstract base class for lights - all other light types inherit the
 * properties and methods described here.
 *
 * @abstract
 * @augments Object3D
 */ class Light extends Object3D {
    /**
	 * Constructs a new light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity = 1){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLight = true;
        this.type = 'Light';
        /**
		 * The light's color.
		 *
		 * @type {Color}
		 */ this.color = new Color(color);
        /**
		 * The light's intensity.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = intensity;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        return data;
    }
}
/**
 * A light source positioned directly above the scene, with color fading from
 * the sky color to the ground color.
 *
 * This light cannot be used to cast shadows.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class HemisphereLight extends Light {
    /**
	 * Constructs a new hemisphere light.
	 *
	 * @param {(number|Color|string)} [skyColor=0xffffff] - The light's sky color.
	 * @param {(number|Color|string)} [groundColor=0xffffff] - The light's ground color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(skyColor, groundColor, intensity){
        super(skyColor, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isHemisphereLight = true;
        this.type = 'HemisphereLight';
        this.position.copy(Object3D.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The light's ground color.
		 *
		 * @type {Color}
		 */ this.groundColor = new Color(groundColor);
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.groundColor.copy(source.groundColor);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.groundColor = this.groundColor.getHex();
        return data;
    }
}
const _projScreenMatrix = /*@__PURE__*/ new Matrix4();
const _lightPositionWorld = /*@__PURE__*/ new Vector3();
const _lookTarget = /*@__PURE__*/ new Vector3();
/**
 * Abstract base class for light shadow classes. These classes
 * represent the shadow configuration for different light types.
 *
 * @abstract
 */ class LightShadow {
    /**
	 * Constructs a new light shadow.
	 *
	 * @param {Camera} camera - The light's view of the world.
	 */ constructor(camera){
        /**
		 * The light's view of the world.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        /**
		 * The intensity of the shadow. The default is `1`.
		 * Valid values are in the range `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.intensity = 1;
        /**
		 * Shadow map bias, how much to add or subtract from the normalized depth
		 * when deciding whether a surface is in shadow.
		 *
		 * The default is `0`. Very tiny adjustments here (in the order of `0.0001`)
		 * may help reduce artifacts in shadows.
		 *
		 * @type {number}
		 * @default 0
		 */ this.bias = 0;
        /**
		 * Defines how much the position used to query the shadow map is offset along
		 * the object normal. The default is `0`. Increasing this value can be used to
		 * reduce shadow acne especially in large scenes where light shines onto
		 * geometry at a shallow angle. The cost is that shadows may appear distorted.
		 *
		 * @type {number}
		 * @default 0
		 */ this.normalBias = 0;
        /**
		 * Setting this to values greater than 1 will blur the edges of the shadow.
		 * High values will cause unwanted banding effects in the shadows - a greater
		 * map size will allow for a higher value to be used here before these effects
		 * become visible.
		 *
		 * The property has no effect when the shadow map type is `BasicShadowMap`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = 1;
        /**
		 * The amount of samples to use when blurring a VSM shadow map.
		 *
		 * @type {number}
		 * @default 8
		 */ this.blurSamples = 8;
        /**
		 * Defines the width and height of the shadow map. Higher values give better quality
		 * shadows at the cost of computation time. Values must be powers of two.
		 *
		 * @type {Vector2}
		 * @default (512,512)
		 */ this.mapSize = new Vector2(512, 512);
        /**
		 * The type of shadow texture. The default is `UnsignedByteType`.
		 *
		 * @type {number}
		 * @default UnsignedByteType
		 */ this.mapType = UnsignedByteType;
        /**
		 * The depth map generated using the internal camera; a location beyond a
		 * pixel's depth is in shadow. Computed internally during rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.map = null;
        /**
		 * The distribution map generated using the internal camera; an occlusion is
		 * calculated based on the distribution of depths. Computed internally during
		 * rendering.
		 *
		 * @type {?RenderTarget}
		 * @default null
		 */ this.mapPass = null;
        /**
		 * Model to shadow camera space, to compute location and depth in shadow map.
		 * This is computed internally during rendering.
		 *
		 * @type {Matrix4}
		 */ this.matrix = new Matrix4();
        /**
		 * Enables automatic updates of the light's shadow. If you do not require dynamic
		 * lighting / shadows, you may set this to `false`.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoUpdate = true;
        /**
		 * When set to `true`, shadow maps will be updated in the next `render` call.
		 * If you have set {@link LightShadow#autoUpdate} to `false`, you will need to
		 * set this property to `true` and then make a render call to update the light's shadow.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.needsUpdate = false;
        this._frustum = new Frustum();
        this._frameExtents = new Vector2(1, 1);
        this._viewportCount = 1;
        this._viewports = [
            new Vector4(0, 0, 1, 1)
        ];
    }
    /**
	 * Used internally by the renderer to get the number of viewports that need
	 * to be rendered for this shadow.
	 *
	 * @return {number} The viewport count.
	 */ getViewportCount() {
        return this._viewportCount;
    }
    /**
	 * Gets the shadow cameras frustum. Used internally by the renderer to cull objects.
	 *
	 * @return {Frustum} The shadow camera frustum.
	 */ getFrustum() {
        return this._frustum;
    }
    /**
	 * Update the matrices for the camera and shadow, used internally by the renderer.
	 *
	 * @param {Light} light - The light for which the shadow is being rendered.
	 */ updateMatrices(light) {
        const shadowCamera = this.camera;
        const shadowMatrix = this.matrix;
        _lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy(_lightPositionWorld);
        _lookTarget.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt(_lookTarget);
        shadowCamera.updateMatrixWorld();
        _projScreenMatrix.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix(_projScreenMatrix, shadowCamera.coordinateSystem, shadowCamera.reversedDepth);
        if (shadowCamera.reversedDepth) shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0);
        else shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply(_projScreenMatrix);
    }
    /**
	 * Returns a viewport definition for the given viewport index.
	 *
	 * @param {number} viewportIndex - The viewport index.
	 * @return {Vector4} The viewport.
	 */ getViewport(viewportIndex) {
        return this._viewports[viewportIndex];
    }
    /**
	 * Returns the frame extends.
	 *
	 * @return {Vector2} The frame extends.
	 */ getFrameExtents() {
        return this._frameExtents;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        if (this.map) this.map.dispose();
        if (this.mapPass) this.mapPass.dispose();
    }
    /**
	 * Copies the values of the given light shadow instance to this instance.
	 *
	 * @param {LightShadow} source - The light shadow to copy.
	 * @return {LightShadow} A reference to this light shadow instance.
	 */ copy(source) {
        this.camera = source.camera.clone();
        this.intensity = source.intensity;
        this.bias = source.bias;
        this.radius = source.radius;
        this.autoUpdate = source.autoUpdate;
        this.needsUpdate = source.needsUpdate;
        this.normalBias = source.normalBias;
        this.blurSamples = source.blurSamples;
        this.mapSize.copy(source.mapSize);
        return this;
    }
    /**
	 * Returns a new light shadow instance with copied values from this instance.
	 *
	 * @return {LightShadow} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Serializes the light shadow into JSON.
	 *
	 * @return {Object} A JSON object representing the serialized light shadow.
	 * @see {@link ObjectLoader#parse}
	 */ toJSON() {
        const object = {};
        if (this.intensity !== 1) object.intensity = this.intensity;
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class SpotLightShadow extends LightShadow {
    /**
	 * Constructs a new spot light shadow.
	 */ constructor(){
        super(new PerspectiveCamera(50, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLightShadow = true;
        /**
		 * Used to focus the shadow camera. The camera's field of view is set as a
		 * percentage of the spotlight's field-of-view. Range is `[0, 1]`.
		 *
		 * @type {number}
		 * @default 1
		 */ this.focus = 1;
        /**
		 * Texture aspect ratio.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
    }
    updateMatrices(light) {
        const camera = this.camera;
        const fov = RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height * this.aspect;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        super.updateMatrices(light);
    }
    copy(source) {
        super.copy(source);
        this.focus = source.focus;
        return this;
    }
}
/**
 * This light gets emitted from a single point in one direction, along a cone
 * that increases in size the further from the light it gets.
 *
 * This light can cast shadows - see the {@link SpotLightShadow} for details.
 *
 * ```js
 * // white spotlight shining from the side, modulated by a texture
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 100, 1000, 100 );
 * spotLight.map = new THREE.TextureLoader().load( url );
 *
 * spotLight.castShadow = true;
 * spotLight.shadow.mapSize.width = 1024;
 * spotLight.shadow.mapSize.height = 1024;
 * spotLight.shadow.camera.near = 500;
 * spotLight.shadow.camera.far = 4000;
 * spotLight.shadow.camera.fov = 30;s
 * ```
 *
 * @augments Light
 */ class SpotLight extends Light {
    /**
	 * Constructs a new spot light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [angle=Math.PI/3] - Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
	 * @param {number} [penumbra=0] - Percent of the spotlight cone that is attenuated due to penumbra. Value range is `[0,1]`.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, angle = Math.PI / 3, penumbra = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSpotLight = true;
        this.type = 'SpotLight';
        this.position.copy(Object3D.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The spot light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new Object3D();
        /**
		 * Maximum range of the light. `0` means no limit.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * Maximum angle of light dispersion from its direction whose upper bound is `Math.PI/2`.
		 *
		 * @type {number}
		 * @default Math.PI/3
		 */ this.angle = angle;
        /**
		 * Percent of the spotlight cone that is attenuated due to penumbra.
		 * Value range is `[0,1]`.
		 *
		 * @type {number}
		 * @default 0
		 */ this.penumbra = penumbra;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * A texture used to modulate the color of the light. The spot light
		 * color is mixed with the RGB value of this texture, with a ratio
		 * corresponding to its alpha value. The cookie-like masking effect is
		 * reproduced using pixel values (0, 0, 0, 1-cookie_value).
		 *
		 * *Warning*: This property is disabled if {@link Object3D#castShadow} is set to `false`.
		 *
		 * @type {?Texture}
		 * @default null
		 */ this.map = null;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {SpotLightShadow}
		 */ this.shadow = new SpotLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 *  Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // by convention for a spotlight, luminous power (lm) = π * luminous intensity (cd)
        return this.intensity * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / Math.PI;
    }
    dispose() {
        super.dispose();
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.map = source.map;
        this.shadow = source.shadow.clone();
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.distance = this.distance;
        data.object.angle = this.angle;
        data.object.decay = this.decay;
        data.object.penumbra = this.penumbra;
        data.object.target = this.target.uuid;
        if (this.map && this.map.isTexture) data.object.map = this.map.toJSON(meta).uuid;
        data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
/**
 * Represents the shadow configuration of point lights.
 *
 * @augments LightShadow
 */ class PointLightShadow extends LightShadow {
    /**
	 * Constructs a new point light shadow.
	 */ constructor(){
        super(new PerspectiveCamera(90, 1, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLightShadow = true;
    }
}
/**
 * A light that gets emitted from a single point in all directions. A common
 * use case for this is to replicate the light emitted from a bare
 * lightbulb.
 *
 * This light can cast shadows - see the {@link PointLightShadow} for details.
 *
 * ```js
 * const light = new THREE.PointLight( 0xff0000, 1, 100 );
 * light.position.set( 50, 50, 50 );
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class PointLight extends Light {
    /**
	 * Constructs a new point light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity measured in candela (cd).
	 * @param {number} [distance=0] - Maximum range of the light. `0` means no limit.
	 * @param {number} [decay=2] - The amount the light dims along the distance of the light.
	 */ constructor(color, intensity, distance = 0, decay = 2){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isPointLight = true;
        this.type = 'PointLight';
        /**
		 * When distance is zero, light will attenuate according to inverse-square
		 * law to infinite distance. When distance is non-zero, light will attenuate
		 * according to inverse-square law until near the distance cutoff, where it
		 * will then attenuate quickly and smoothly to 0. Inherently, cutoffs are not
		 * physically correct.
		 *
		 * @type {number}
		 * @default 0
		 */ this.distance = distance;
        /**
		 * The amount the light dims along the distance of the light. In context of
		 * physically-correct rendering the default value should not be changed.
		 *
		 * @type {number}
		 * @default 2
		 */ this.decay = decay;
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {PointLightShadow}
		 */ this.shadow = new PointLightShadow();
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in candela)
        // for an isotropic light source, luminous power (lm) = 4 π luminous intensity (cd)
        return this.intensity * 4 * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in candela) from the desired luminous power (in lumens)
        this.intensity = power / (4 * Math.PI);
    }
    dispose() {
        super.dispose();
        this.shadow.dispose();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.distance = this.distance;
        data.object.decay = this.decay;
        data.object.shadow = this.shadow.toJSON();
        return data;
    }
}
/**
 * Camera that uses [orthographic projection](https://en.wikipedia.org/wiki/Orthographic_projection).
 *
 * In this projection mode, an object's size in the rendered image stays
 * constant regardless of its distance from the camera. This can be useful
 * for rendering 2D scenes and UI elements, amongst other things.
 *
 * ```js
 * const camera = new THREE.OrthographicCamera( width / - 2, width / 2, height / 2, height / - 2, 1, 1000 );
 * scene.add( camera );
 * ```
 *
 * @augments Camera
 */ class OrthographicCamera extends Camera {
    /**
	 * Constructs a new orthographic camera.
	 *
	 * @param {number} [left=-1] - The left plane of the camera's frustum.
	 * @param {number} [right=1] - The right plane of the camera's frustum.
	 * @param {number} [top=1] - The top plane of the camera's frustum.
	 * @param {number} [bottom=-1] - The bottom plane of the camera's frustum.
	 * @param {number} [near=0.1] - The camera's near plane.
	 * @param {number} [far=2000] - The camera's far plane.
	 */ constructor(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isOrthographicCamera = true;
        this.type = 'OrthographicCamera';
        /**
		 * The zoom factor of the camera.
		 *
		 * @type {number}
		 * @default 1
		 */ this.zoom = 1;
        /**
		 * Represents the frustum window specification. This property should not be edited
		 * directly but via {@link PerspectiveCamera#setViewOffset} and {@link PerspectiveCamera#clearViewOffset}.
		 *
		 * @type {?Object}
		 * @default null
		 */ this.view = null;
        /**
		 * The left plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.left = left;
        /**
		 * The right plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.right = right;
        /**
		 * The top plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default 1
		 */ this.top = top;
        /**
		 * The bottom plane of the camera's frustum.
		 *
		 * @type {number}
		 * @default -1
		 */ this.bottom = bottom;
        /**
		 * The camera's near plane. The valid range is greater than `0`
		 * and less than the current value of {@link OrthographicCamera#far}.
		 *
		 * Note that, unlike for the {@link PerspectiveCamera}, `0` is a
		 * valid value for an orthographic camera's near plane.
		 *
		 * @type {number}
		 * @default 0.1
		 */ this.near = near;
        /**
		 * The camera's far plane. Must be greater than the
		 * current value of {@link OrthographicCamera#near}.
		 *
		 * @type {number}
		 * @default 2000
		 */ this.far = far;
        this.updateProjectionMatrix();
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    }
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * @param {number} fullWidth - The full width of multiview setup.
	 * @param {number} fullHeight - The full height of multiview setup.
	 * @param {number} x - The horizontal offset of the subcamera.
	 * @param {number} y - The vertical offset of the subcamera.
	 * @param {number} width - The width of subcamera.
	 * @param {number} height - The height of subcamera.
	 * @see {@link PerspectiveCamera#setViewOffset}
	 */ setViewOffset(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    }
    /**
	 * Removes the view offset from the projection matrix.
	 */ clearViewOffset() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    }
    /**
	 * Updates the camera's projection matrix. Must be called after any change of
	 * camera properties.
	 */ updateProjectionMatrix() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far, this.coordinateSystem, this.reversedDepth);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
}
/**
 * Represents the shadow configuration of directional lights.
 *
 * @augments LightShadow
 */ class DirectionalLightShadow extends LightShadow {
    /**
	 * Constructs a new directional light shadow.
	 */ constructor(){
        super(new OrthographicCamera(-5, 5, 5, -5, 0.5, 500));
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLightShadow = true;
    }
}
/**
 * A light that gets emitted in a specific direction. This light will behave
 * as though it is infinitely far away and the rays produced from it are all
 * parallel. The common use case for this is to simulate daylight; the sun is
 * far enough away that its position can be considered to be infinite, and
 * all light rays coming from it are parallel.
 *
 * A common point of confusion for directional lights is that setting the
 * rotation has no effect. This is because three.js's DirectionalLight is the
 * equivalent to what is often called a 'Target Direct Light' in other
 * applications.
 *
 * This means that its direction is calculated as pointing from the light's
 * {@link Object3D#position} to the {@link DirectionalLight#target} position
 * (as opposed to a 'Free Direct Light' that just has a rotation
 * component).
 *
 * This light can cast shadows - see the {@link DirectionalLightShadow} for details.
 *
 * ```js
 * // White directional light at half intensity shining from the top.
 * const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.5 );
 * scene.add( directionalLight );
 * ```
 *
 * @augments Light
 */ class DirectionalLight extends Light {
    /**
	 * Constructs a new directional light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isDirectionalLight = true;
        this.type = 'DirectionalLight';
        this.position.copy(Object3D.DEFAULT_UP);
        this.updateMatrix();
        /**
		 * The directional light points from its position to the
		 * target's position.
		 *
		 * For the target's position to be changed to anything other
		 * than the default, it must be added to the scene.
		 *
		 * It is also possible to set the target to be another 3D object
		 * in the scene. The light will now track the target object.
		 *
		 * @type {Object3D}
		 */ this.target = new Object3D();
        /**
		 * This property holds the light's shadow configuration.
		 *
		 * @type {DirectionalLightShadow}
		 */ this.shadow = new DirectionalLightShadow();
    }
    dispose() {
        super.dispose();
        this.shadow.dispose();
    }
    copy(source) {
        super.copy(source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.shadow = this.shadow.toJSON();
        data.object.target = this.target.uuid;
        return data;
    }
}
/**
 * This light globally illuminates all objects in the scene equally.
 *
 * It cannot be used to cast shadows as it does not have a direction.
 *
 * ```js
 * const light = new THREE.AmbientLight( 0x404040 ); // soft white light
 * scene.add( light );
 * ```
 *
 * @augments Light
 */ class AmbientLight extends Light {
    /**
	 * Constructs a new ambient light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(color, intensity){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAmbientLight = true;
        this.type = 'AmbientLight';
    }
}
/**
 * This class emits light uniformly across the face a rectangular plane.
 * This light type can be used to simulate light sources such as bright
 * windows or strip lighting.
 *
 * Important Notes:
 *
 * - There is no shadow support.
 * - Only PBR materials are supported.
 * - You have to include `RectAreaLightUniformsLib` (`WebGLRenderer`) or `RectAreaLightTexturesLib` (`WebGPURenderer`)
 * into your app and init the uniforms/textures.
 *
 * ```js
 * RectAreaLightUniformsLib.init(); // only relevant for WebGLRenderer
 * THREE.RectAreaLightNode.setLTC( RectAreaLightTexturesLib.init() ); //  only relevant for WebGPURenderer
 *
 * const intensity = 1; const width = 10; const height = 10;
 * const rectLight = new THREE.RectAreaLight( 0xffffff, intensity, width, height );
 * rectLight.position.set( 5, 5, 0 );
 * rectLight.lookAt( 0, 0, 0 );
 * scene.add( rectLight )
 * ```
 *
 * @augments Light
 */ class RectAreaLight extends Light {
    /**
	 * Constructs a new area light.
	 *
	 * @param {(number|Color|string)} [color=0xffffff] - The light's color.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 * @param {number} [width=10] - The width of the light.
	 * @param {number} [height=10] - The height of the light.
	 */ constructor(color, intensity, width = 10, height = 10){
        super(color, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRectAreaLight = true;
        this.type = 'RectAreaLight';
        /**
		 * The width of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.width = width;
        /**
		 * The height of the light.
		 *
		 * @type {number}
		 * @default 10
		 */ this.height = height;
    }
    /**
	 * The light's power. Power is the luminous power of the light measured in lumens (lm).
	 * Changing the power will also change the light's intensity.
	 *
	 * @type {number}
	 */ get power() {
        // compute the light's luminous power (in lumens) from its intensity (in nits)
        return this.intensity * this.width * this.height * Math.PI;
    }
    set power(power) {
        // set the light's intensity (in nits) from the desired luminous power (in lumens)
        this.intensity = power / (this.width * this.height * Math.PI);
    }
    copy(source) {
        super.copy(source);
        this.width = source.width;
        this.height = source.height;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
}
/**
 * Represents a third-order spherical harmonics (SH). Light probes use this class
 * to encode lighting information.
 *
 * - Primary reference: {@link https://graphics.stanford.edu/papers/envmap/envmap.pdf}
 * - Secondary reference: {@link https://www.ppsloan.org/publications/StupidSH36.pdf}
 */ class SphericalHarmonics3 {
    /**
	 * Constructs a new spherical harmonics.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSphericalHarmonics3 = true;
        /**
		 * An array holding the (9) SH coefficients.
		 *
		 * @type {Array<Vector3>}
		 */ this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new Vector3());
    }
    /**
	 * Sets the given SH coefficients to this instance by copying
	 * the values.
	 *
	 * @param {Array<Vector3>} coefficients - The SH coefficients.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    /**
	 * Sets all SH coefficients to `0`.
	 *
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    /**
	 * Returns the radiance in the direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The radiance.
	 */ getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    /**
	 * Returns the irradiance (radiance convolved with cosine lobe) in the
	 * direction of the given normal.
	 *
	 * @param {Vector3} normal - The normal vector (assumed to be unit length)
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The irradiance.
	 */ getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    /**
	 * Adds the given SH to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    /**
	 * A convenience method for performing {@link SphericalHarmonics3#add} and
	 * {@link SphericalHarmonics3#scale} at once.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to add.
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    /**
	 * Scales this SH by the given scale factor.
	 *
	 * @param {number} s - The scale factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    /**
	 * Linear interpolates between the given SH and this instance by the given
	 * alpha factor.
	 *
	 * @param {SphericalHarmonics3} sh - The SH to interpolate with.
	 * @param {number} alpha - The alpha factor.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    /**
	 * Returns `true` if this spherical harmonics is equal with the given one.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to test for equality.
	 * @return {boolean} Whether this spherical harmonics is equal with the given one.
	 */ equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    /**
	 * Copies the values of the given spherical harmonics to this instance.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics to copy.
	 * @return {SphericalHarmonics3} A reference to this spherical harmonics.
	 */ copy(sh) {
        return this.set(sh.coefficients);
    }
    /**
	 * Returns a new spherical harmonics with copied values from this instance.
	 *
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Sets the SH coefficients of this instance from the given array.
	 *
	 * @param {Array<number>} array - An array holding the SH coefficients.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {SphericalHarmonics3} A clone of this instance.
	 */ fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    /**
	 * Returns an array with the SH coefficients, or copies them into the provided
	 * array. The coefficients are represented as numbers.
	 *
	 * @param {Array<number>} [array=[]] - The target array.
	 * @param {number} [offset=0] - The array offset where to start copying.
	 * @return {Array<number>} An array with flat SH coefficients.
	 */ toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    /**
	 * Computes the SH basis for the given normal vector.
	 *
	 * @param {Vector3} normal - The normal.
	 * @param {Array<number>} shBasis - The target array holding the SH basis.
	 */ static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
/**
 * Light probes are an alternative way of adding light to a 3D scene. Unlike
 * classical light sources (e.g. directional, point or spot lights), light
 * probes do not emit light. Instead they store information about light
 * passing through 3D space. During rendering, the light that hits a 3D
 * object is approximated by using the data from the light probe.
 *
 * Light probes are usually created from (radiance) environment maps. The
 * class {@link LightProbeGenerator} can be used to create light probes from
 * cube textures or render targets. However, light estimation data could also
 * be provided in other forms e.g. by WebXR. This enables the rendering of
 * augmented reality content that reacts to real world lighting.
 *
 * The current probe implementation in three.js supports so-called diffuse
 * light probes. This type of light probe is functionally equivalent to an
 * irradiance environment map.
 *
 * @augments Light
 */ class LightProbe extends Light {
    /**
	 * Constructs a new light probe.
	 *
	 * @param {SphericalHarmonics3} sh - The spherical harmonics which represents encoded lighting information.
	 * @param {number} [intensity=1] - The light's strength/intensity.
	 */ constructor(sh = new SphericalHarmonics3(), intensity = 1){
        super(undefined, intensity);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isLightProbe = true;
        /**
		 * A light probe uses spherical harmonics to encode lighting information.
		 *
		 * @type {SphericalHarmonics3}
		 */ this.sh = sh;
    }
    copy(source) {
        super.copy(source);
        this.sh.copy(source.sh);
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
}
/**
 * Class for loading materials. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.MaterialLoader();
 * const material = await loader.loadAsync( 'material.json' );
 * ```
 * This loader does not support node materials. Use {@link NodeMaterialLoader} instead.
 *
 * @augments Loader
 */ class MaterialLoader extends Loader {
    /**
	 * Constructs a new material loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * A dictionary holding textures used by the material.
		 *
		 * @type {Object<string,Texture>}
		 */ this.textures = {};
    }
    /**
	 * Starts loading from the given URL and pass the loaded material to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Material)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a material.
	 *
	 * @param {Object} json - The serialized material.
	 * @return {Material} The parsed material.
	 */ parse(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) warn('MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = this.createMaterialFromType(json.type);
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = json.sheen;
        if (json.sheenColor !== undefined) material.sheenColor = new Color().setHex(json.sheenColor);
        if (json.sheenRoughness !== undefined) material.sheenRoughness = json.sheenRoughness;
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.specularIntensity !== undefined) material.specularIntensity = json.specularIntensity;
        if (json.specularColor !== undefined && material.specularColor !== undefined) material.specularColor.setHex(json.specularColor);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.dispersion !== undefined) material.dispersion = json.dispersion;
        if (json.iridescence !== undefined) material.iridescence = json.iridescence;
        if (json.iridescenceIOR !== undefined) material.iridescenceIOR = json.iridescenceIOR;
        if (json.iridescenceThicknessRange !== undefined) material.iridescenceThicknessRange = json.iridescenceThicknessRange;
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.thickness !== undefined) material.thickness = json.thickness;
        if (json.attenuationDistance !== undefined) material.attenuationDistance = json.attenuationDistance;
        if (json.attenuationColor !== undefined && material.attenuationColor !== undefined) material.attenuationColor.setHex(json.attenuationColor);
        if (json.anisotropy !== undefined) material.anisotropy = json.anisotropy;
        if (json.anisotropyRotation !== undefined) material.anisotropyRotation = json.anisotropyRotation;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.shadowSide !== undefined) material.shadowSide = json.shadowSide;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.alphaHash !== undefined) material.alphaHash = json.alphaHash;
        if (json.depthFunc !== undefined) material.depthFunc = json.depthFunc;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.blendSrc !== undefined) material.blendSrc = json.blendSrc;
        if (json.blendDst !== undefined) material.blendDst = json.blendDst;
        if (json.blendEquation !== undefined) material.blendEquation = json.blendEquation;
        if (json.blendSrcAlpha !== undefined) material.blendSrcAlpha = json.blendSrcAlpha;
        if (json.blendDstAlpha !== undefined) material.blendDstAlpha = json.blendDstAlpha;
        if (json.blendEquationAlpha !== undefined) material.blendEquationAlpha = json.blendEquationAlpha;
        if (json.blendColor !== undefined && material.blendColor !== undefined) material.blendColor.setHex(json.blendColor);
        if (json.blendAlpha !== undefined) material.blendAlpha = json.blendAlpha;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== undefined) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.alphaToCoverage !== undefined) material.alphaToCoverage = json.alphaToCoverage;
        if (json.premultipliedAlpha !== undefined) material.premultipliedAlpha = json.premultipliedAlpha;
        if (json.forceSinglePass !== undefined) material.forceSinglePass = json.forceSinglePass;
        if (json.allowOverride !== undefined) material.allowOverride = json.allowOverride;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new Color().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new Vector2().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new Vector3().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new Vector4().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new Matrix3().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new Matrix4().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.glslVersion !== undefined) material.glslVersion = json.glslVersion;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        if (json.lights !== undefined) material.lights = json.lights;
        if (json.clipping !== undefined) material.clipping = json.clipping;
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new Vector2().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.specularIntensityMap !== undefined) material.specularIntensityMap = getTexture(json.specularIntensityMap);
        if (json.specularColorMap !== undefined) material.specularColorMap = getTexture(json.specularColorMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapRotation !== undefined) material.envMapRotation.fromArray(json.envMapRotation);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new Vector2().fromArray(json.clearcoatNormalScale);
        if (json.iridescenceMap !== undefined) material.iridescenceMap = getTexture(json.iridescenceMap);
        if (json.iridescenceThicknessMap !== undefined) material.iridescenceThicknessMap = getTexture(json.iridescenceThicknessMap);
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        if (json.thicknessMap !== undefined) material.thicknessMap = getTexture(json.thicknessMap);
        if (json.anisotropyMap !== undefined) material.anisotropyMap = getTexture(json.anisotropyMap);
        if (json.sheenColorMap !== undefined) material.sheenColorMap = getTexture(json.sheenColorMap);
        if (json.sheenRoughnessMap !== undefined) material.sheenRoughnessMap = getTexture(json.sheenRoughnessMap);
        return material;
    }
    /**
	 * Textures are not embedded in the material JSON so they have
	 * to be injected before the loading process starts.
	 *
	 * @param {Object} value - A dictionary holding textures for material properties.
	 * @return {MaterialLoader} A reference to this material loader.
	 */ setTextures(value) {
        this.textures = value;
        return this;
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ createMaterialFromType(type) {
        return MaterialLoader.createMaterialFromType(type);
    }
    /**
	 * Creates a material for the given type.
	 *
	 * @static
	 * @param {string} type - The material type.
	 * @return {Material} The new material.
	 */ static createMaterialFromType(type) {
        const materialLib = {
            ShadowMaterial,
            SpriteMaterial,
            RawShaderMaterial,
            ShaderMaterial,
            PointsMaterial,
            MeshPhysicalMaterial,
            MeshStandardMaterial,
            MeshPhongMaterial,
            MeshToonMaterial,
            MeshNormalMaterial,
            MeshLambertMaterial,
            MeshDepthMaterial,
            MeshDistanceMaterial,
            MeshBasicMaterial,
            MeshMatcapMaterial,
            LineDashedMaterial,
            LineBasicMaterial,
            Material
        };
        return new materialLib[type]();
    }
}
/**
 * A class with loader utility functions.
 */ class LoaderUtils {
    /**
	 * Extracts the base URL from the given URL.
	 *
	 * @param {string} url -The URL to extract the base URL from.
	 * @return {string} The extracted base URL.
	 */ static extractUrlBase(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.slice(0, index + 1);
    }
    /**
	 * Resolves relative URLs against the given path. Absolute paths, data urls,
	 * and blob URLs will be returned as is. Invalid URLs will return an empty
	 * string.
	 *
	 * @param {string} url -The URL to resolve.
	 * @param {string} path - The base path for relative URLs to be resolved against.
	 * @return {string} The resolved URL.
	 */ static resolveURL(url, path) {
        // Invalid URL
        if (typeof url !== 'string' || url === '') return '';
        // Host Relative URL
        if (/^https?:\/\//i.test(path) && /^\//.test(url)) path = path.replace(/(^https?:\/\/[^\/]+).*/i, '$1');
        // Absolute URL http://,https://,//
        if (/^(https?:)?\/\//i.test(url)) return url;
        // Data URI
        if (/^data:.*,.*$/i.test(url)) return url;
        // Blob URL
        if (/^blob:.*$/i.test(url)) return url;
        // Relative URL
        return path + url;
    }
}
/**
 * An instanced version of a geometry.
 */ class InstancedBufferGeometry extends BufferGeometry {
    /**
	 * Constructs a new instanced buffer geometry.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedBufferGeometry = true;
        this.type = 'InstancedBufferGeometry';
        /**
		 * The instance count.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.instanceCount = Infinity;
    }
    copy(source) {
        super.copy(source);
        this.instanceCount = source.instanceCount;
        return this;
    }
    toJSON() {
        const data = super.toJSON();
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
}
/**
 * Class for loading geometries. The files are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.BufferGeometryLoader();
 * const geometry = await loader.loadAsync( 'models/json/pressure.json' );
 *
 * const material = new THREE.MeshBasicMaterial( { color: 0xF5F5F5 } );
 * const object = new THREE.Mesh( geometry, material );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class BufferGeometryLoader extends Loader {
    /**
	 * Constructs a new geometry loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded geometry to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(BufferGeometry)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
    /**
	 * Parses the given JSON object and returns a geometry.
	 *
	 * @param {Object} json - The serialized geometry.
	 * @return {BufferGeometry} The parsed geometry.
	 */ parse(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = getTypedArray(interleavedBuffer.type, buffer);
            const ib = new InterleavedBuffer(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new InstancedBufferGeometry() : new BufferGeometry();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = getTypedArray(index.type, index.array);
            geometry.setIndex(new BufferAttribute(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new InterleavedBufferAttribute(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? InstancedBufferAttribute : BufferAttribute;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            if (attribute.usage !== undefined) bufferAttribute.setUsage(attribute.usage);
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new InterleavedBufferAttribute(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new BufferAttribute(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) geometry.boundingSphere = new Sphere().fromJSON(boundingSphere);
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
}
/**
 * A loader for loading a JSON resource in the [JSON Object/Scene format](https://github.com/mrdoob/three.js/wiki/JSON-Object-Scene-format-4).
 * The files are internally loaded via {@link FileLoader}.
 *
 * ```js
 * const loader = new THREE.ObjectLoader();
 * const obj = await loader.loadAsync( 'models/json/example.json' );
 * scene.add( obj );
 *
 * // Alternatively, to parse a previously loaded JSON structure
 * const object = await loader.parseAsync( a_json_object );
 * scene.add( object );
 * ```
 *
 * @augments Loader
 */ class ObjectLoader extends Loader {
    /**
	 * Constructs a new object loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and pass the loaded 3D object to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(Object3D)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? LoaderUtils.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new FileLoader(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                error('ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                if (onError !== undefined) onError(new Error('THREE.ObjectLoader: Can\'t load ' + url));
                error('ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    /**
	 * Async version of {@link ObjectLoader#load}.
	 *
	 * @async
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @return {Promise<Object3D>} A Promise that resolves with the loaded 3D object.
	 */ async loadAsync(url, onProgress) {
        const scope = this;
        const path = this.path === '' ? LoaderUtils.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new FileLoader(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        const text = await loader.loadAsync(url, onProgress);
        const json = JSON.parse(text);
        const metadata = json.metadata;
        if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') throw new Error('THREE.ObjectLoader: Can\'t load ' + url);
        return await scope.parseAsync(json);
    }
    /**
	 * Parses the given JSON. This is used internally by {@link ObjectLoader#load}
	 * but can also be used directly to parse a previously loaded JSON structure.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @param {onLoad} onLoad - Executed when all resources (e.g. textures) have been fully loaded.
	 * @return {Object3D} The parsed 3D object.
	 */ parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid].data instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    /**
	 * Async version of {@link ObjectLoader#parse}.
	 *
	 * @param {Object} json - The serialized 3D object.
	 * @return {Promise<Object3D>} A Promise that resolves with the parsed 3D object.
	 */ async parseAsync(json) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = await this.parseImagesAsync(json.images);
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, textures, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        this.bindLightTargets(object);
        return object;
    }
    // internals
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new Shape().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new Skeleton().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        if (json !== undefined) {
            const bufferGeometryLoader = new BufferGeometryLoader();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    default:
                        if (data.type in Geometries) geometry = Geometries[data.type].fromJSON(data, shapes);
                        else warn(`ObjectLoader: Unsupported geometry type "${data.type}"`);
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new MaterialLoader();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                materials[data.uuid] = cache[data.uuid];
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = AnimationClip.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new LoadingManager(onLoad);
            loader = new ImageLoader(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new DataTexture(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new Source(imageArray);
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    images[image.uuid] = new Source(deserializedImage);
                }
            }
        }
        return images;
    }
    async parseImagesAsync(json) {
        const scope = this;
        const images = {};
        let loader;
        async function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return await loader.loadAsync(path);
            } else {
                if (image.data) return {
                    data: getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            loader = new ImageLoader(this.manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    const imageArray = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = await deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) imageArray.push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            imageArray.push(new DataTexture(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                    images[image.uuid] = new Source(imageArray);
                } else {
                    // load single image
                    const deserializedImage = await deserializeImage(image.url);
                    images[image.uuid] = new Source(deserializedImage);
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            warn('ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) warn('ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) warn('ObjectLoader: Undefined image', data.image);
            const source = images[data.image];
            const image = source.data;
            let texture;
            if (Array.isArray(image)) {
                texture = new CubeTexture();
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new DataTexture();
                else texture = new Texture();
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.source = source;
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, TEXTURE_MAPPING);
            if (data.channel !== undefined) texture.channel = data.channel;
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.internalFormat !== undefined) texture.internalFormat = data.internalFormat;
            if (data.type !== undefined) texture.type = data.type;
            if (data.colorSpace !== undefined) texture.colorSpace = data.colorSpace;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.generateMipmaps !== undefined) texture.generateMipmaps = data.generateMipmaps;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            if (data.compareFunction !== undefined) texture.compareFunction = data.compareFunction;
            if (data.userData !== undefined) texture.userData = data.userData;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, textures, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) warn('ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) warn('ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) warn('ObjectLoader: Undefined material', name);
            return materials[name];
        }
        function getTexture(uuid) {
            if (textures[uuid] === undefined) warn('ObjectLoader: Undefined texture', uuid);
            return textures[uuid];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new Scene();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new Color(data.background);
                    else object.background = getTexture(data.background);
                }
                if (data.environment !== undefined) object.environment = getTexture(data.environment);
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new Fog(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new FogExp2(data.fog.color, data.fog.density);
                    if (data.fog.name !== '') object.fog.name = data.fog.name;
                }
                if (data.backgroundBlurriness !== undefined) object.backgroundBlurriness = data.backgroundBlurriness;
                if (data.backgroundIntensity !== undefined) object.backgroundIntensity = data.backgroundIntensity;
                if (data.backgroundRotation !== undefined) object.backgroundRotation.fromArray(data.backgroundRotation);
                if (data.environmentIntensity !== undefined) object.environmentIntensity = data.environmentIntensity;
                if (data.environmentRotation !== undefined) object.environmentRotation.fromArray(data.environmentRotation);
                break;
            case 'PerspectiveCamera':
                object = new PerspectiveCamera(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new OrthographicCamera(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new AmbientLight(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new DirectionalLight(data.color, data.intensity);
                object.target = data.target || '';
                break;
            case 'PointLight':
                object = new PointLight(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new RectAreaLight(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new SpotLight(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                object.target = data.target || '';
                break;
            case 'HemisphereLight':
                object = new HemisphereLight(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                const sh = new SphericalHarmonics3().fromArray(data.sh);
                object = new LightProbe(sh, data.intensity);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new SkinnedMesh(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new Mesh(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                const instanceColor = data.instanceColor;
                object = new InstancedMesh(geometry, material, count);
                object.instanceMatrix = new InstancedBufferAttribute(new Float32Array(instanceMatrix.array), 16);
                if (instanceColor !== undefined) object.instanceColor = new InstancedBufferAttribute(new Float32Array(instanceColor.array), instanceColor.itemSize);
                break;
            case 'BatchedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new BatchedMesh(data.maxInstanceCount, data.maxVertexCount, data.maxIndexCount, material);
                object.geometry = geometry;
                object.perObjectFrustumCulled = data.perObjectFrustumCulled;
                object.sortObjects = data.sortObjects;
                object._drawRanges = data.drawRanges;
                object._reservedRanges = data.reservedRanges;
                object._geometryInfo = data.geometryInfo.map((info)=>{
                    let box = null;
                    let sphere = null;
                    if (info.boundingBox !== undefined) box = new Box3().fromJSON(info.boundingBox);
                    if (info.boundingSphere !== undefined) sphere = new Sphere().fromJSON(info.boundingSphere);
                    return {
                        ...info,
                        boundingBox: box,
                        boundingSphere: sphere
                    };
                });
                object._instanceInfo = data.instanceInfo;
                object._availableInstanceIds = data._availableInstanceIds;
                object._availableGeometryIds = data._availableGeometryIds;
                object._nextIndexStart = data.nextIndexStart;
                object._nextVertexStart = data.nextVertexStart;
                object._geometryCount = data.geometryCount;
                object._maxInstanceCount = data.maxInstanceCount;
                object._maxVertexCount = data.maxVertexCount;
                object._maxIndexCount = data.maxIndexCount;
                object._geometryInitialized = data.geometryInitialized;
                object._matricesTexture = getTexture(data.matricesTexture.uuid);
                object._indirectTexture = getTexture(data.indirectTexture.uuid);
                if (data.colorsTexture !== undefined) object._colorsTexture = getTexture(data.colorsTexture.uuid);
                if (data.boundingSphere !== undefined) object.boundingSphere = new Sphere().fromJSON(data.boundingSphere);
                if (data.boundingBox !== undefined) object.boundingBox = new Box3().fromJSON(data.boundingBox);
                break;
            case 'LOD':
                object = new LOD();
                break;
            case 'Line':
                object = new Line(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new LineLoop(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new LineSegments(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new Points(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new Sprite(getMaterial(data.material));
                break;
            case 'Group':
                object = new Group();
                break;
            case 'Bone':
                object = new Bone();
                break;
            default:
                object = new Object3D();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.up !== undefined) object.up.fromArray(data.up);
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.intensity !== undefined) object.shadow.intensity = data.shadow.intensity;
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, textures, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance, level.hysteresis);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) warn('ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    bindLightTargets(object) {
        object.traverse(function(child) {
            if (child.isDirectionalLight || child.isSpotLight) {
                const uuid = child.target;
                const target = object.getObjectByProperty('uuid', uuid);
                if (target !== undefined) child.target = target;
                else child.target = new Object3D();
            }
        });
    }
}
const TEXTURE_MAPPING = {
    UVMapping: UVMapping,
    CubeReflectionMapping: CubeReflectionMapping,
    CubeRefractionMapping: CubeRefractionMapping,
    EquirectangularReflectionMapping: EquirectangularReflectionMapping,
    EquirectangularRefractionMapping: EquirectangularRefractionMapping,
    CubeUVReflectionMapping: CubeUVReflectionMapping
};
const TEXTURE_WRAPPING = {
    RepeatWrapping: RepeatWrapping,
    ClampToEdgeWrapping: ClampToEdgeWrapping,
    MirroredRepeatWrapping: MirroredRepeatWrapping
};
const TEXTURE_FILTER = {
    NearestFilter: NearestFilter,
    NearestMipmapNearestFilter: NearestMipmapNearestFilter,
    NearestMipmapLinearFilter: NearestMipmapLinearFilter,
    LinearFilter: LinearFilter,
    LinearMipmapNearestFilter: LinearMipmapNearestFilter,
    LinearMipmapLinearFilter: LinearMipmapLinearFilter
};
const _errorMap = new WeakMap();
/**
 * A loader for loading images as an [ImageBitmap](https://developer.mozilla.org/en-US/docs/Web/API/ImageBitmap).
 * An `ImageBitmap` provides an asynchronous and resource efficient pathway to prepare
 * textures for rendering.
 *
 * Note that {@link Texture#flipY} and {@link Texture#premultiplyAlpha} are ignored with image bitmaps.
 * They needs these configuration on bitmap creation unlike regular images need them on uploading to GPU.
 *
 * You need to set the equivalent options via {@link ImageBitmapLoader#setOptions} instead.
 *
 * Also note that unlike {@link FileLoader}, this loader avoids multiple concurrent requests to the same URL only if `Cache` is enabled.
 *
 * ```js
 * const loader = new THREE.ImageBitmapLoader();
 * loader.setOptions( { imageOrientation: 'flipY' } ); // set options if needed
 * const imageBitmap = await loader.loadAsync( 'image.png' );
 *
 * const texture = new THREE.Texture( imageBitmap );
 * texture.needsUpdate = true;
 * ```
 *
 * @augments Loader
 */ class ImageBitmapLoader extends Loader {
    /**
	 * Constructs a new image bitmap loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isImageBitmapLoader = true;
        if (typeof createImageBitmap === 'undefined') warn('ImageBitmapLoader: createImageBitmap() not supported.');
        if (typeof fetch === 'undefined') warn('ImageBitmapLoader: fetch() not supported.');
        /**
		 * Represents the loader options.
		 *
		 * @type {Object}
		 * @default {premultiplyAlpha:'none'}
		 */ this.options = {
            premultiplyAlpha: 'none'
        };
        /**
		 * Used for aborting requests.
		 *
		 * @private
		 * @type {AbortController}
		 */ this._abortController = new AbortController();
    }
    /**
	 * Sets the given loader options. The structure of the object must match the `options` parameter of
	 * [createImageBitmap](https://developer.mozilla.org/en-US/docs/Web/API/Window/createImageBitmap).
	 *
	 * @param {Object} options - The loader options to set.
	 * @return {ImageBitmapLoader} A reference to this image bitmap loader.
	 */ setOptions(options) {
        this.options = options;
        return this;
    }
    /**
	 * Starts loading from the given URL and pass the loaded image bitmap to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(ImageBitmap)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Unsupported in this loader.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 * @return {ImageBitmap|undefined} The image bitmap.
	 */ load(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = Cache.get(`image-bitmap:${url}`);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            // If cached is a promise, wait for it to resolve
            if (cached.then) {
                cached.then((imageBitmap)=>{
                    // check if there is an error for the cached promise
                    if (_errorMap.has(cached) === true) {
                        if (onError) onError(_errorMap.get(cached));
                        scope.manager.itemError(url);
                        scope.manager.itemEnd(url);
                    } else {
                        if (onLoad) onLoad(imageBitmap);
                        scope.manager.itemEnd(url);
                        return imageBitmap;
                    }
                });
                return;
            }
            // If cached is not a promise (i.e., it's already an imageBitmap)
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetchOptions.headers = this.requestHeader;
        fetchOptions.signal = typeof AbortSignal.any === 'function' ? AbortSignal.any([
            this._abortController.signal,
            this.manager.abortController.signal
        ]) : this._abortController.signal;
        const promise = fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, Object.assign(scope.options, {
                colorSpaceConversion: 'none'
            }));
        }).then(function(imageBitmap) {
            Cache.add(`image-bitmap:${url}`, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
            return imageBitmap;
        }).catch(function(e) {
            if (onError) onError(e);
            _errorMap.set(promise, e);
            Cache.remove(`image-bitmap:${url}`);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        Cache.add(`image-bitmap:${url}`, promise);
        scope.manager.itemStart(url);
    }
    /**
	 * Aborts ongoing fetch requests.
	 *
	 * @return {ImageBitmapLoader} A reference to this instance.
	 */ abort() {
        this._abortController.abort();
        this._abortController = new AbortController();
        return this;
    }
}
let _context;
/**
 * Manages the global audio context in the engine.
 *
 * @hideconstructor
 */ class AudioContext {
    /**
	 * Returns the global native audio context.
	 *
	 * @return {AudioContext} The native audio context.
	 */ static getContext() {
        if (_context === undefined) _context = new (window.AudioContext || window.webkitAudioContext)();
        return _context;
    }
    /**
	 * Allows to set the global native audio context from outside.
	 *
	 * @param {AudioContext} value - The native context to set.
	 */ static setContext(value) {
        _context = value;
    }
}
/**
 * Class for loading audio buffers. Audios are internally
 * loaded via {@link FileLoader}.
 *
 * ```js
 * const audioListener = new THREE.AudioListener();
 * const ambientSound = new THREE.Audio( audioListener );
 *
 * const loader = new THREE.AudioLoader();
 * const audioBuffer = await loader.loadAsync( 'audio/ambient_ocean.ogg' );
 *
 * ambientSound.setBuffer( audioBuffer );
 * ambientSound.play();
 * ```
 *
 * @augments Loader
 */ class AudioLoader extends Loader {
    /**
	 * Constructs a new audio loader.
	 *
	 * @param {LoadingManager} [manager] - The loading manager.
	 */ constructor(manager){
        super(manager);
    }
    /**
	 * Starts loading from the given URL and passes the loaded audio buffer
	 * to the `onLoad()` callback.
	 *
	 * @param {string} url - The path/URL of the file to be loaded. This can also be a data URI.
	 * @param {function(AudioBuffer)} onLoad - Executed when the loading process has been finished.
	 * @param {onProgressCallback} onProgress - Executed while the loading is in progress.
	 * @param {onErrorCallback} onError - Executed when errors occur.
	 */ load(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = AudioContext.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                }).catch(handleError);
            } catch (e) {
                handleError(e);
            }
        }, onProgress, onError);
        function handleError(e) {
            if (onError) onError(e);
            else error(e);
            scope.manager.itemError(url);
        }
    }
}
const _eyeRight = /*@__PURE__*/ new Matrix4();
const _eyeLeft = /*@__PURE__*/ new Matrix4();
const _projectionMatrix = /*@__PURE__*/ new Matrix4();
/**
 * A special type of camera that uses two perspective cameras with
 * stereoscopic projection. Can be used for rendering stereo effects
 * like [3D Anaglyph](https://en.wikipedia.org/wiki/Anaglyph_3D) or
 * [Parallax Barrier](https://en.wikipedia.org/wiki/parallax_barrier).
 */ class StereoCamera {
    /**
	 * Constructs a new stereo camera.
	 */ constructor(){
        /**
		 * The type property is used for detecting the object type
		 * in context of serialization/deserialization.
		 *
		 * @type {string}
		 * @readonly
		 */ this.type = 'StereoCamera';
        /**
		 * The aspect.
		 *
		 * @type {number}
		 * @default 1
		 */ this.aspect = 1;
        /**
		 * The eye separation which represents the distance
		 * between the left and right camera.
		 *
		 * @type {number}
		 * @default 0.064
		 */ this.eyeSep = 0.064;
        /**
		 * The camera representing the left eye. This is added to layer `1` so objects to be
		 * rendered by the left camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraL = new PerspectiveCamera();
        this.cameraL.layers.enable(1);
        this.cameraL.matrixAutoUpdate = false;
        /**
		 * The camera representing the right eye. This is added to layer `2` so objects to be
		 * rendered by the right camera must also be added to this layer.
		 *
		 * @type {PerspectiveCamera}
		 */ this.cameraR = new PerspectiveCamera();
        this.cameraR.layers.enable(2);
        this.cameraR.matrixAutoUpdate = false;
        this._cache = {
            focus: null,
            fov: null,
            aspect: null,
            near: null,
            far: null,
            zoom: null,
            eyeSep: null
        };
    }
    /**
	 * Updates the stereo camera based on the given perspective camera.
	 *
	 * @param {PerspectiveCamera} camera - The perspective camera.
	 */ update(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            _projectionMatrix.copy(camera.projectionMatrix);
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan(DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            _eyeLeft.elements[12] = -eyeSepHalf;
            _eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            _projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            _projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy(_projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            _projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            _projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy(_projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply(_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply(_eyeRight);
    }
}
/**
 * This type of camera can be used in order to efficiently render a scene with a
 * predefined set of cameras. This is an important performance aspect for
 * rendering VR scenes.
 *
 * An instance of `ArrayCamera` always has an array of sub cameras. It's mandatory
 * to define for each sub camera the `viewport` property which determines the
 * part of the viewport that is rendered with this camera.
 *
 * @augments PerspectiveCamera
 */ class ArrayCamera extends PerspectiveCamera {
    /**
	 * Constructs a new array camera.
	 *
	 * @param {Array<PerspectiveCamera>} [array=[]] - An array of perspective sub cameras.
	 */ constructor(array = []){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isArrayCamera = true;
        /**
		 * Whether this camera is used with multiview rendering or not.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isMultiViewCamera = false;
        /**
		 * An array of perspective sub cameras.
		 *
		 * @type {Array<PerspectiveCamera>}
		 */ this.cameras = array;
    }
}
/**
 * Class for keeping track of time.
 */ class Clock {
    /**
	 * Constructs a new clock.
	 *
	 * @param {boolean} [autoStart=true] - Whether to automatically start the clock when
	 * `getDelta()` is called for the first time.
	 */ constructor(autoStart = true){
        /**
		 * If set to `true`, the clock starts automatically when `getDelta()` is called
		 * for the first time.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.autoStart = autoStart;
        /**
		 * Holds the time at which the clock's `start()` method was last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.startTime = 0;
        /**
		 * Holds the time at which the clock's `start()`, `getElapsedTime()` or
		 * `getDelta()` methods were last called.
		 *
		 * @type {number}
		 * @default 0
		 */ this.oldTime = 0;
        /**
		 * Keeps track of the total time that the clock has been running.
		 *
		 * @type {number}
		 * @default 0
		 */ this.elapsedTime = 0;
        /**
		 * Whether the clock is running or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.running = false;
    }
    /**
	 * Starts the clock. When `autoStart` is set to `true`, the method is automatically
	 * called by the class.
	 */ start() {
        this.startTime = performance.now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    /**
	 * Stops the clock.
	 */ stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time.
	 */ getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    /**
	 * Returns the delta time in seconds.
	 *
	 * @return {number} The delta time.
	 */ getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = performance.now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
const _position$1 = /*@__PURE__*/ new Vector3();
const _quaternion$1 = /*@__PURE__*/ new Quaternion();
const _scale$1 = /*@__PURE__*/ new Vector3();
const _forward = /*@__PURE__*/ new Vector3();
const _up = /*@__PURE__*/ new Vector3();
/**
 * The class represents a virtual listener of the all positional and non-positional audio effects
 * in the scene. A three.js application usually creates a single listener. It is a mandatory
 * constructor parameter for audios entities like {@link Audio} and {@link PositionalAudio}.
 *
 * In most cases, the listener object is a child of the camera. So the 3D transformation of the
 * camera represents the 3D transformation of the listener.
 *
 * @augments Object3D
 */ class AudioListener extends Object3D {
    /**
	 * Constructs a new audio listener.
	 */ constructor(){
        super();
        this.type = 'AudioListener';
        /**
		 * The native audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = AudioContext.getContext();
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        /**
		 * An optional filter.
		 *
		 * Defined via {@link AudioListener#setFilter}.
		 *
		 * @type {?AudioNode}
		 * @default null
		 * @readonly
		 */ this.filter = null;
        /**
		 * Time delta values required for `linearRampToValueAtTime()` usage.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.timeDelta = 0;
        // private
        this._clock = new Clock();
    }
    /**
	 * Returns the listener's input node.
	 *
	 * This method is used by other audio nodes to connect to this listener.
	 *
	 * @return {GainNode} The input node.
	 */ getInput() {
        return this.gain;
    }
    /**
	 * Removes the current filter from this listener.
	 *
	 * @return {AudioListener} A reference to this listener.
	 */ removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    /**
	 * Returns the current set filter.
	 *
	 * @return {?AudioNode} The filter.
	 */ getFilter() {
        return this.filter;
    }
    /**
	 * Sets the given filter to this listener.
	 *
	 * @param {AudioNode} value - The filter to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    /**
	 * Returns the applications master volume.
	 *
	 * @return {number} The master volume.
	 */ getMasterVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the applications master volume. This volume setting affects
	 * all audio nodes in the scene.
	 *
	 * @param {number} value - The master volume to set.
	 * @return {AudioListener} A reference to this listener.
	 */ setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose(_position$1, _quaternion$1, _scale$1);
        // the initial forward and up directions must be orthogonal
        _forward.set(0, 0, -1).applyQuaternion(_quaternion$1);
        _up.set(0, 1, 0).applyQuaternion(_quaternion$1);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime(_position$1.x, endTime);
            listener.positionY.linearRampToValueAtTime(_position$1.y, endTime);
            listener.positionZ.linearRampToValueAtTime(_position$1.z, endTime);
            listener.forwardX.linearRampToValueAtTime(_forward.x, endTime);
            listener.forwardY.linearRampToValueAtTime(_forward.y, endTime);
            listener.forwardZ.linearRampToValueAtTime(_forward.z, endTime);
            listener.upX.linearRampToValueAtTime(_up.x, endTime);
            listener.upY.linearRampToValueAtTime(_up.y, endTime);
            listener.upZ.linearRampToValueAtTime(_up.z, endTime);
        } else {
            listener.setPosition(_position$1.x, _position$1.y, _position$1.z);
            listener.setOrientation(_forward.x, _forward.y, _forward.z, _up.x, _up.y, _up.z);
        }
    }
}
/**
 * Represents a non-positional ( global ) audio object.
 *
 * This and related audio modules make use of the [Web Audio API](https://www.w3.org/TR/webaudio-1.1/).
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create a global audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop( true );
 * 	sound.setVolume( 0.5 );
 * 	sound.play();
 * });
 * ```
 *
 * @augments Object3D
 */ class Audio extends Object3D {
    /**
	 * Constructs a new audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super();
        this.type = 'Audio';
        /**
		 * The global audio listener.
		 *
		 * @type {AudioListener}
		 * @readonly
		 */ this.listener = listener;
        /**
		 * The audio context.
		 *
		 * @type {AudioContext}
		 * @readonly
		 */ this.context = listener.context;
        /**
		 * The gain node used for volume control.
		 *
		 * @type {GainNode}
		 * @readonly
		 */ this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        /**
		 * Whether to start playback automatically or not.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.autoplay = false;
        /**
		 * A reference to an audio buffer.
		 *
		 * Defined via {@link Audio#setBuffer}.
		 *
		 * @type {?AudioBuffer}
		 * @default null
		 * @readonly
		 */ this.buffer = null;
        /**
		 * Modify pitch, measured in cents. +/- 100 is a semitone.
		 * +/- 1200 is an octave.
		 *
		 * Defined via {@link Audio#setDetune}.
		 *
		 * @type {number}
		 * @default 0
		 * @readonly
		 */ this.detune = 0;
        /**
		 * Whether the audio should loop or not.
		 *
		 * Defined via {@link Audio#setLoop}.
		 *
		 * @type {boolean}
		 * @default false
		 * @readonly
		 */ this.loop = false;
        /**
		 * Defines where in the audio buffer the replay should
		 * start, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopStart = 0;
        /**
		 * Defines where in the audio buffer the replay should
		 * stop, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.loopEnd = 0;
        /**
		 * An offset to the time within the audio buffer the playback
		 * should begin, in seconds.
		 *
		 * @type {number}
		 * @default 0
		 */ this.offset = 0;
        /**
		 * Overrides the default duration of the audio.
		 *
		 * @type {undefined|number}
		 * @default undefined
		 */ this.duration = undefined;
        /**
		 * The playback speed.
		 *
		 * Defined via {@link Audio#setPlaybackRate}.
		 *
		 * @type {number}
		 * @readonly
		 * @default 1
		 */ this.playbackRate = 1;
        /**
		 * Indicates whether the audio is playing or not.
		 *
		 * This flag will be automatically set when using {@link Audio#play},
		 * {@link Audio#pause}, {@link Audio#stop}.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default false
		 */ this.isPlaying = false;
        /**
		 * Indicates whether the audio playback can be controlled
		 * with method like {@link Audio#play} or {@link Audio#pause}.
		 *
		 * This flag will be automatically set when audio sources are
		 * defined.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.hasPlaybackControl = true;
        /**
		 * Holds a reference to the current audio source.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {?AudioNode}
		 * @readonly
		 * @default null
		 */ this.source = null;
        /**
		 * Defines the source type.
		 *
		 * The property is automatically by one of the `set*()` methods.
		 *
		 * @type {('empty'|'audioNode'|'mediaNode'|'mediaStreamNode'|'buffer')}
		 * @readonly
		 * @default 'empty'
		 */ this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        /**
		 * Can be used to apply a variety of low-order filters to create
		 * more complex sound effects e.g. via `BiquadFilterNode`.
		 *
		 * The property is automatically set by {@link Audio#setFilters}.
		 *
		 * @type {Array<AudioNode>}
		 * @readonly
		 */ this.filters = [];
    }
    /**
	 * Returns the output audio node.
	 *
	 * @return {GainNode} The output node.
	 */ getOutput() {
        return this.gain;
    }
    /**
	 * Sets the given audio node as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `audioNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {AudioNode} audioNode - The audio node like an instance of `OscillatorNode`.
	 * @return {Audio} A reference to this instance.
	 */ setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    /**
	 * Sets the given media element as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {HTMLMediaElement} mediaElement - The media element.
	 * @return {Audio} A reference to this instance.
	 */ setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    /**
	 * Sets the given media stream as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `mediaStreamNode` and {@link Audio#hasPlaybackControl} to `false`.
	 *
	 * @param {MediaStream} mediaStream - The media stream.
	 * @return {Audio} A reference to this instance.
	 */ setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    /**
	 * Sets the given audio buffer as the source of this instance.
	 *
	 * {@link Audio#sourceType} is set to `buffer` and {@link Audio#hasPlaybackControl} to `true`.
	 *
	 * @param {AudioBuffer} audioBuffer - The audio buffer.
	 * @return {Audio} A reference to this instance.
	 */ setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    /**
	 * Starts the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should start playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ play(delay = 0) {
        if (this.isPlaying === true) {
            warn('Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            warn('Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    /**
	 * Pauses the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ pause() {
        if (this.hasPlaybackControl === false) {
            warn('Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    /**
	 * Stops the playback of the audio.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [delay=0] - The delay, in seconds, at which the audio should stop playing.
	 * @return {Audio|undefined} A reference to this instance.
	 */ stop(delay = 0) {
        if (this.hasPlaybackControl === false) {
            warn('Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        if (this.source !== null) {
            this.source.stop(this.context.currentTime + delay);
            this.source.onended = null;
        }
        this.isPlaying = false;
        return this;
    }
    /**
	 * Connects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio} A reference to this instance.
	 */ connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    /**
	 * Disconnects to the audio source. This is used internally on
	 * initialisation and when setting / removing filters.
	 *
	 * @return {Audio|undefined} A reference to this instance.
	 */ disconnect() {
        if (this._connected === false) return;
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    /**
	 * Returns the current set filters.
	 *
	 * @return {Array<AudioNode>} The list of filters.
	 */ getFilters() {
        return this.filters;
    }
    /**
	 * Sets an array of filters and connects them with the audio source.
	 *
	 * @param {Array<AudioNode>} [value] - A list of filters.
	 * @return {Audio} A reference to this instance.
	 */ setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    /**
	 * Defines the detuning of oscillation in cents.
	 *
	 * @param {number} value - The detuning of oscillation in cents.
	 * @return {Audio} A reference to this instance.
	 */ setDetune(value) {
        this.detune = value;
        if (this.isPlaying === true && this.source.detune !== undefined) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the detuning of oscillation in cents.
	 *
	 * @return {number} The detuning of oscillation in cents.
	 */ getDetune() {
        return this.detune;
    }
    /**
	 * Returns the first filter in the list of filters.
	 *
	 * @return {AudioNode|undefined} The first filter in the list of filters.
	 */ getFilter() {
        return this.getFilters()[0];
    }
    /**
	 * Applies a single filter node to the audio.
	 *
	 * @param {AudioNode} [filter] - The filter to set.
	 * @return {Audio} A reference to this instance.
	 */ setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    /**
	 * Sets the playback rate.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {number} [value] - The playback rate to set.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            warn('Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    /**
	 * Returns the current playback rate.

	 * @return {number} The playback rate.
	 */ getPlaybackRate() {
        return this.playbackRate;
    }
    /**
	 * Automatically called when playback finished.
	 */ onEnded() {
        this.isPlaying = false;
        this._progress = 0;
    }
    /**
	 * Returns the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @return {boolean} Whether the audio should loop or not.
	 */ getLoop() {
        if (this.hasPlaybackControl === false) {
            warn('Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    /**
	 * Sets the loop flag.
	 *
	 * Can only be used with compatible audio sources that allow playback control.
	 *
	 * @param {boolean} value - Whether the audio should loop or not.
	 * @return {Audio|undefined} A reference to this instance.
	 */ setLoop(value) {
        if (this.hasPlaybackControl === false) {
            warn('Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    /**
	 * Sets the loop start value which defines where in the audio buffer the replay should
	 * start, in seconds.
	 *
	 * @param {number} value - The loop start value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    /**
	 * Sets the loop end value which defines where in the audio buffer the replay should
	 * stop, in seconds.
	 *
	 * @param {number} value - The loop end value.
	 * @return {Audio} A reference to this instance.
	 */ setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    /**
	 * Returns the volume.
	 *
	 * @return {number} The volume.
	 */ getVolume() {
        return this.gain.gain.value;
    }
    /**
	 * Sets the volume.
	 *
	 * @param {number} value - The volume to set.
	 * @return {Audio} A reference to this instance.
	 */ setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.sourceType !== 'buffer') {
            warn('Audio: Audio source type cannot be copied.');
            return this;
        }
        this.autoplay = source.autoplay;
        this.buffer = source.buffer;
        this.detune = source.detune;
        this.loop = source.loop;
        this.loopStart = source.loopStart;
        this.loopEnd = source.loopEnd;
        this.offset = source.offset;
        this.duration = source.duration;
        this.playbackRate = source.playbackRate;
        this.hasPlaybackControl = source.hasPlaybackControl;
        this.sourceType = source.sourceType;
        this.filters = source.filters.slice();
        return this;
    }
    clone(recursive) {
        return new this.constructor(this.listener).copy(this, recursive);
    }
}
const _position = /*@__PURE__*/ new Vector3();
const _quaternion = /*@__PURE__*/ new Quaternion();
const _scale = /*@__PURE__*/ new Vector3();
const _orientation = /*@__PURE__*/ new Vector3();
/**
 * Represents a positional audio object.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create the PositionalAudio object (passing in the listener)
 * const sound = new THREE.PositionalAudio( listener );
 *
 * // load a sound and set it as the PositionalAudio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/song.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setRefDistance( 20 );
 * 	sound.play();
 * });
 *
 * // create an object for the sound to play from
 * const sphere = new THREE.SphereGeometry( 20, 32, 16 );
 * const material = new THREE.MeshPhongMaterial( { color: 0xff2200 } );
 * const mesh = new THREE.Mesh( sphere, material );
 * scene.add( mesh );
 *
 * // finally add the sound to the mesh
 * mesh.add( sound );
 *
 * @augments Audio
 */ class PositionalAudio extends Audio {
    /**
	 * Constructs a positional audio.
	 *
	 * @param {AudioListener} listener - The global audio listener.
	 */ constructor(listener){
        super(listener);
        /**
		 * The panner node represents the location, direction, and behavior of an audio
		 * source in 3D space.
		 *
		 * @type {PannerNode}
		 * @readonly
		 */ this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    connect() {
        super.connect();
        this.panner.connect(this.gain);
        return this;
    }
    disconnect() {
        super.disconnect();
        this.panner.disconnect(this.gain);
        return this;
    }
    getOutput() {
        return this.panner;
    }
    /**
	 * Returns the current reference distance.
	 *
	 * @return {number} The reference distance.
	 */ getRefDistance() {
        return this.panner.refDistance;
    }
    /**
	 * Defines the reference distance for reducing volume as the audio source moves
	 * further from the listener – i.e. the distance at which the volume reduction
	 * starts taking effect.
	 *
	 * @param {number} value - The reference distance to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    /**
	 * Returns the current rolloff factor.
	 *
	 * @return {number} The rolloff factor.
	 */ getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    /**
	 * Defines how quickly the volume is reduced as the source moves away from the listener.
	 *
	 * @param {number} value - The rolloff factor.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    /**
	 * Returns the current distance model.
	 *
	 * @return {('linear'|'inverse'|'exponential')} The distance model.
	 */ getDistanceModel() {
        return this.panner.distanceModel;
    }
    /**
	 * Defines which algorithm to use to reduce the volume of the audio source
	 * as it moves away from the listener.
	 *
	 * Read [the spec](https://www.w3.org/TR/webaudio-1.1/#enumdef-distancemodeltype)
	 * for more details.
	 *
	 * @param {('linear'|'inverse'|'exponential')} value - The distance model to set.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    /**
	 * Returns the current max distance.
	 *
	 * @return {number} The max distance.
	 */ getMaxDistance() {
        return this.panner.maxDistance;
    }
    /**
	 * Defines the maximum distance between the audio source and the listener,
	 * after which the volume is not reduced any further.
	 *
	 * This value is used only by the `linear` distance model.
	 *
	 * @param {number} value - The max distance.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    /**
	 * Sets the directional cone in which the audio can be listened.
	 *
	 * @param {number} coneInnerAngle - An angle, in degrees, of a cone inside of which there will be no volume reduction.
	 * @param {number} coneOuterAngle - An angle, in degrees, of a cone outside of which the volume will be reduced by a constant value, defined by the `coneOuterGain` parameter.
	 * @param {number} coneOuterGain - The amount of volume reduction outside the cone defined by the `coneOuterAngle`. When set to `0`, no sound can be heard.
	 * @return {PositionalAudio} A reference to this instance.
	 */ setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose(_position, _quaternion, _scale);
        _orientation.set(0, 0, 1).applyQuaternion(_quaternion);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime(_position.x, endTime);
            panner.positionY.linearRampToValueAtTime(_position.y, endTime);
            panner.positionZ.linearRampToValueAtTime(_position.z, endTime);
            panner.orientationX.linearRampToValueAtTime(_orientation.x, endTime);
            panner.orientationY.linearRampToValueAtTime(_orientation.y, endTime);
            panner.orientationZ.linearRampToValueAtTime(_orientation.z, endTime);
        } else {
            panner.setPosition(_position.x, _position.y, _position.z);
            panner.setOrientation(_orientation.x, _orientation.y, _orientation.z);
        }
    }
}
/**
 * This class can be used to analyse audio data.
 *
 * ```js
 * // create an AudioListener and add it to the camera
 * const listener = new THREE.AudioListener();
 * camera.add( listener );
 *
 * // create an Audio source
 * const sound = new THREE.Audio( listener );
 *
 * // load a sound and set it as the Audio object's buffer
 * const audioLoader = new THREE.AudioLoader();
 * audioLoader.load( 'sounds/ambient.ogg', function( buffer ) {
 * 	sound.setBuffer( buffer );
 * 	sound.setLoop(true);
 * 	sound.setVolume(0.5);
 * 	sound.play();
 * });
 *
 * // create an AudioAnalyser, passing in the sound and desired fftSize
 * const analyser = new THREE.AudioAnalyser( sound, 32 );
 *
 * // get the average frequency of the sound
 * const data = analyser.getAverageFrequency();
 * ```
 */ class AudioAnalyser {
    /**
	 * Constructs a new audio analyzer.
	 *
	 * @param {Audio} audio - The audio to analyze.
	 * @param {number} [fftSize=2048] - The window size in samples that is used when performing a Fast Fourier Transform (FFT) to get frequency domain data.
	 */ constructor(audio, fftSize = 2048){
        /**
		 * The global audio listener.
		 *
		 * @type {AnalyserNode}
		 */ this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        /**
		 * Holds the analyzed data.
		 *
		 * @type {Uint8Array}
		 */ this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    /**
	 * Returns an array with frequency data of the audio.
	 *
	 * Each item in the array represents the decibel value for a specific frequency.
	 * The frequencies are spread linearly from 0 to 1/2 of the sample rate.
	 * For example, for 48000 sample rate, the last item of the array will represent
	 * the decibel value for 24000 Hz.
	 *
	 * @return {Uint8Array} The frequency data.
	 */ getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    /**
	 * Returns the average of the frequencies returned by {@link AudioAnalyser#getFrequencyData}.
	 *
	 * @return {number} The average frequency.
	 */ getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
/**
 * Buffered scene graph property that allows weighted accumulation; used internally.
 */ class PropertyMixer {
    /**
	 * Constructs a new property mixer.
	 *
	 * @param {PropertyBinding} binding - The property binding.
	 * @param {string} typeName - The keyframe track type name.
	 * @param {number} valueSize - The keyframe track value size.
	 */ constructor(binding, typeName, valueSize){
        /**
		 * The property binding.
		 *
		 * @type {PropertyBinding}
		 */ this.binding = binding;
        /**
		 * The keyframe track value size.
		 *
		 * @type {number}
		 */ this.valueSize = valueSize;
        let mixFunction, mixFunctionAdditive, setIdentity;
        // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
        //
        // interpolators can use .buffer as their .result
        // the data then goes to 'incoming'
        //
        // 'accu0' and 'accu1' are used frame-interleaved for
        // the cumulative result and are compared to detect
        // changes
        //
        // 'orig' stores the original state of the property
        //
        // 'add' is used for additive cumulative results
        //
        // 'work' is optional and is only present for quaternion types. It is used
        // to store intermediate quaternion multiplication results
        switch(typeName){
            case 'quaternion':
                mixFunction = this._slerp;
                mixFunctionAdditive = this._slerpAdditive;
                setIdentity = this._setAdditiveIdentityQuaternion;
                this.buffer = new Float64Array(valueSize * 6);
                this._workIndex = 5;
                break;
            case 'string':
            case 'bool':
                mixFunction = this._select;
                // Use the regular mix function and for additive on these types,
                // additive is not relevant for non-numeric types
                mixFunctionAdditive = this._select;
                setIdentity = this._setAdditiveIdentityOther;
                this.buffer = new Array(valueSize * 5);
                break;
            default:
                mixFunction = this._lerp;
                mixFunctionAdditive = this._lerpAdditive;
                setIdentity = this._setAdditiveIdentityNumeric;
                this.buffer = new Float64Array(valueSize * 5);
        }
        this._mixBufferRegion = mixFunction;
        this._mixBufferRegionAdditive = mixFunctionAdditive;
        this._setIdentity = setIdentity;
        this._origIndex = 3;
        this._addIndex = 4;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeight = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.cumulativeWeightAdditive = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.useCount = 0;
        /**
		 * TODO
		 *
		 * @type {number}
		 * @default 0
		 */ this.referenceCount = 0;
    }
    /**
	 * Accumulates data in the `incoming` region into `accu<i>`.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 * @param {number} weight - The weight.
	 */ accumulate(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    }
    /**
	 * Accumulates data in the `incoming` region into `add`.
	 *
	 * @param {number} weight - The weight.
	 */ accumulateAdditive(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    }
    /**
	 * Applies the state of `accu<i>` to the binding when accus differ.
	 *
	 * @param {number} accuIndex - The accumulation index.
	 */ apply(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    }
    /**
	 * Remembers the state of the bound property and copy it to both accus.
	 */ saveOriginalState() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    }
    /**
	 * Applies the state previously taken via {@link PropertyMixer#saveOriginalState} to the binding.
	 */ restoreOriginalState() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    }
    // internals
    _setAdditiveIdentityNumeric() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    }
    _setAdditiveIdentityQuaternion() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    }
    _setAdditiveIdentityOther() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    }
    // mix functions
    _select(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    }
    _slerp(buffer, dstOffset, srcOffset, t) {
        Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    }
    _slerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        Quaternion.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    }
    _lerp(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    }
    _lerpAdditive(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
}
// Characters [].:/ are reserved for track binding syntax.
const _RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const _reservedRe = new RegExp('[' + _RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const _wordChar = '[^' + _RESERVED_CHARS_RE + ']';
const _wordCharOrDot = '[^' + _RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const _directoryRe = /*@__PURE__*/ /((?:WC+[\/:])*)/.source.replace('WC', _wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const _nodeRe = /*@__PURE__*/ /(WCOD+)?/.source.replace('WCOD', _wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const _objectRe = /*@__PURE__*/ /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', _wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const _propertyRe = /*@__PURE__*/ /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', _wordChar);
const _trackRe = new RegExp("^" + _directoryRe + _nodeRe + _objectRe + _propertyRe + '$');
const _supportedObjectNames = [
    'material',
    'materials',
    'bones',
    'map'
];
class Composite {
    constructor(targetGroup, path, optionalParsedPath){
        const parsedPath = optionalParsedPath || PropertyBinding.parseTrackName(path);
        this._targetGroup = targetGroup;
        this._bindings = targetGroup.subscribe_(path, parsedPath);
    }
    getValue(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    }
    setValue(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    }
    bind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    }
    unbind() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
}
// Note: This class uses a State pattern on a per-method basis:
// 'bind' sets 'this.getValue' / 'setValue' and shadows the
// prototype version of these methods with one that represents
// the bound state. When the property is not found, the methods
// become no-ops.
/**
 * This holds a reference to a real property in the scene graph; used internally.
 */ class PropertyBinding {
    /**
	 * Constructs a new property binding.
	 *
	 * @param {Object} rootNode - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 */ constructor(rootNode, path, parsedPath){
        /**
		 * The object path to the animated property.
		 *
		 * @type {string}
		 */ this.path = path;
        /**
		 * An object holding information about the path.
		 *
		 * @type {Object}
		 */ this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path);
        /**
		 * The object owns the animated property.
		 *
		 * @type {?Object}
		 */ this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName);
        /**
		 * The root node.
		 *
		 * @type {Object3D|Skeleton}
		 */ this.rootNode = rootNode;
        // initial state of these methods that calls 'bind'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
    /**
	 * Factory method for creating a property binding from the given parameters.
	 *
	 * @static
	 * @param {Object} root - The root node.
	 * @param {string} path - The path.
	 * @param {?Object} [parsedPath] - The parsed path.
	 * @return {PropertyBinding|Composite} The created property binding or composite.
	 */ static create(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new PropertyBinding(root, path, parsedPath);
        else return new PropertyBinding.Composite(root, path, parsedPath);
    }
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name - Node name to be sanitized.
	 * @return {string} The sanitized node name.
	 */ static sanitizeNodeName(name) {
        return name.replace(/\s/g, '_').replace(_reservedRe, '');
    }
    /**
	 * Parses the given track name (an object path to an animated property) and
	 * returns an object with information about the path. Matches strings in the following forms:
	 *
	 * - nodeName.property
	 * - nodeName.property[accessor]
	 * - nodeName.material.property[accessor]
	 * - uuid.property[accessor]
	 * - uuid.objectName[objectIndex].propertyName[propertyIndex]
	 * - parentName/nodeName.property
	 * - parentName/parentName/nodeName.property[index]
	 * - .bone[Armature.DEF_cog].position
	 * - scene:helium_balloon_model:helium_balloon_model.position
	 *
	 * @static
	 * @param {string} trackName - The track name to parse.
	 * @return {Object} The parsed track name as an object.
	 */ static parseTrackName(trackName) {
        const matches = _trackRe.exec(trackName);
        if (matches === null) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if (_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    }
    /**
	 * Searches for a node in the hierarchy of the given root object by the given
	 * node name.
	 *
	 * @static
	 * @param {Object} root - The root object.
	 * @param {string|number} nodeName - The name of the node.
	 * @return {?Object} The found node. Returns `null` if no object was found.
	 */ static findNode(root, nodeName) {
        if (nodeName === undefined || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
    // these are used to "bind" a nonexistent property
    _getValue_unavailable() {}
    _setValue_unavailable() {}
    // Getters
    _getValue_direct(buffer, offset) {
        buffer[offset] = this.targetObject[this.propertyName];
    }
    _getValue_array(buffer, offset) {
        const source = this.resolvedProperty;
        for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
    }
    _getValue_arrayElement(buffer, offset) {
        buffer[offset] = this.resolvedProperty[this.propertyIndex];
    }
    _getValue_toArray(buffer, offset) {
        this.resolvedProperty.toArray(buffer, offset);
    }
    // Direct
    _setValue_direct(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
    }
    _setValue_direct_setNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.targetObject[this.propertyName] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // EntireArray
    _setValue_array(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
    }
    _setValue_array_setNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.needsUpdate = true;
    }
    _setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
        const dest = this.resolvedProperty;
        for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // ArrayElement
    _setValue_arrayElement(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
    }
    _setValue_arrayElement_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.needsUpdate = true;
    }
    _setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty[this.propertyIndex] = buffer[offset];
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    // HasToFromArray
    _setValue_fromArray(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
    }
    _setValue_fromArray_setNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.needsUpdate = true;
    }
    _setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
        this.resolvedProperty.fromArray(buffer, offset);
        this.targetObject.matrixWorldNeedsUpdate = true;
    }
    _getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    }
    _setValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    }
    /**
	 * Creates a getter / setter pair for the property tracked by this binding.
	 */ bind() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName);
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            warn('PropertyBinding: No target node found for track: ' + this.path + '.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        error('PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        error('PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        error('PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                case 'map':
                    if ('map' in targetObject) {
                        targetObject = targetObject.map;
                        break;
                    }
                    if (!targetObject.material) {
                        error('PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.map) {
                        error('PropertyBinding: Can not bind to material.map as node.material does not have a map.', this);
                        return;
                    }
                    targetObject = targetObject.material.map;
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        error('PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    error('PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            error('PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.isMaterial === true) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.isObject3D === true) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    error('PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (!targetObject.geometry.morphAttributes) {
                    error('PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                    return;
                }
                if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    }
    /**
	 * Unbinds the property.
	 */ unbind() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
}
PropertyBinding.Composite = Composite;
PropertyBinding.prototype.BindingType = {
    Direct: 0,
    EntireArray: 1,
    ArrayElement: 2,
    HasFromToArray: 3
};
PropertyBinding.prototype.Versioning = {
    None: 0,
    NeedsUpdate: 1,
    MatrixWorldNeedsUpdate: 2
};
PropertyBinding.prototype.GetterByBindingType = [
    PropertyBinding.prototype._getValue_direct,
    PropertyBinding.prototype._getValue_array,
    PropertyBinding.prototype._getValue_arrayElement,
    PropertyBinding.prototype._getValue_toArray
];
PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [
    [
        // Direct
        PropertyBinding.prototype._setValue_direct,
        PropertyBinding.prototype._setValue_direct_setNeedsUpdate,
        PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate
    ],
    [
        // EntireArray
        PropertyBinding.prototype._setValue_array,
        PropertyBinding.prototype._setValue_array_setNeedsUpdate,
        PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate
    ],
    [
        // ArrayElement
        PropertyBinding.prototype._setValue_arrayElement,
        PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate,
        PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
    ],
    [
        // HasToFromArray
        PropertyBinding.prototype._setValue_fromArray,
        PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate,
        PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
    ]
];
/**
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 * - Add objects you would otherwise pass as 'root' to the
 * constructor or the .clipAction method of AnimationMixer.
 * - Instead pass this object as 'root'.
 * - You can also add and remove objects later when the mixer is running.
 *
 * Note:
 *
 * - Objects of this class appear as one object to the mixer,
 * so cache control of the individual objects must be done on the group.
 *
 * Limitation:
 *
 * - The animated properties must be compatible among the all objects in the group.
 * - A single property can either be controlled through a target group or directly, but not both.
 */ class AnimationObjectGroup {
    /**
	 * Constructs a new animation group.
	 *
	 * @param {...Object3D} arguments - An arbitrary number of 3D objects that share the same animation state.
	 */ constructor(){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isAnimationObjectGroup = true;
        /**
		 * The UUID of the 3D object.
		 *
		 * @type {string}
		 * @readonly
		 */ this.uuid = generateUUID();
        // cached objects followed by the active ones
        this._objects = Array.prototype.slice.call(arguments);
        this.nCachedObjects_ = 0; // threshold
        // note: read by PropertyBinding.Composite
        const indices = {};
        this._indicesByUUID = indices; // for bookkeeping
        for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
        this._paths = []; // inside: string
        this._parsedPaths = []; // inside: { we don't care, here }
        this._bindings = []; // inside: Array< PropertyBinding >
        this._bindingsIndicesByPath = {}; // inside: indices in these arrays
        const scope = this;
        this.stats = {
            objects: {
                get total () {
                    return scope._objects.length;
                },
                get inUse () {
                    return this.total - scope.nCachedObjects_;
                }
            },
            get bindingsPerObject () {
                return scope._bindings.length;
            }
        };
    }
    /**
	 * Adds an arbitrary number of objects to this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to add.
	 */ add() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new PropertyBinding(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new PropertyBinding(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) error("AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Removes an arbitrary number of objects to this animation group
	 *
	 * @param {...Object3D} arguments - The 3D objects to remove.
	 */ remove() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    /**
	 * Deallocates all memory resources for the passed 3D objects of this animation group.
	 *
	 * @param {...Object3D} arguments - The 3D objects to uncache.
	 */ uncache() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    }
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new PropertyBinding(object, path, parsedPath);
        }
        return bindingsForPath;
    }
    unsubscribe_(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
}
/**
 * An instance of `AnimationAction` schedules the playback of an animation which is
 * stored in {@link AnimationClip}.
 */ class AnimationAction {
    /**
	 * Constructs a new animation action.
	 *
	 * @param {AnimationMixer} mixer - The mixer that is controlled by this action.
	 * @param {AnimationClip} clip - The animation clip that holds the actual keyframes.
	 * @param {?Object3D} [localRoot=null] - The root object on which this action is performed.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 */ constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        /**
		 * Defines how the animation is blended/combined when two or more animations
		 * are simultaneously played.
		 *
		 * @type {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)}
		 */ this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: ZeroCurvatureEnding,
            endingEnd: ZeroCurvatureEnding
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        /**
		 * The loop mode, set via {@link AnimationAction#setLoop}.
		 *
		 * @type {(LoopRepeat|LoopOnce|LoopPingPong)}
		 * @default LoopRepeat
		 */ this.loop = LoopRepeat;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        /**
		 * The local time of this action (in seconds, starting with `0`).
		 *
		 * The value gets clamped or wrapped to `[0,clip.duration]` (according to the
		 * loop state).
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.time = 0;
        /**
		 * Scaling factor for the {@link AnimationAction#time}. A value of `0` causes the
		 * animation to pause. Negative values cause the animation to play backwards.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1;
        this._effectiveTimeScale = 1;
        /**
		 * The degree of influence of this action (in the interval `[0, 1]`). Values
		 * between `0` (no impact) and `1` (full impact) can be used to blend between
		 * several actions.
		 *
		 * @type {number}
		 * @default 1
		 */ this.weight = 1;
        this._effectiveWeight = 1;
        /**
		 * The number of repetitions of the performed clip over the course of this action.
		 * Can be set via {@link AnimationAction#setLoop}.
		 *
		 * Setting this number has no effect if {@link AnimationAction#loop} is set to
		 * `THREE:LoopOnce`.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.repetitions = Infinity;
        /**
		 * If set to `true`, the playback of the action is paused.
		 *
		 * @type {boolean}
		 * @default false
		 */ this.paused = false;
        /**
		 * If set to `false`, the action is disabled so it has no impact.
		 *
		 * When the action is re-enabled, the animation continues from its current
		 * time (setting `enabled` to `false` doesn't reset the action).
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * If set to true the animation will automatically be paused on its last frame.
		 *
		 * If set to false, {@link AnimationAction#enabled} will automatically be switched
		 * to `false` when the last loop of the action has finished, so that this action has
		 * no further impact.
		 *
		 * Note: This member has no impact if the action is interrupted (it
		 * has only an effect if its last loop has really finished).
		 *
		 * @type {boolean}
		 * @default false
		 */ this.clampWhenFinished = false;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtStart = true;
        /**
		 * Enables smooth interpolation without separate clips for start, loop and end.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.zeroSlopeAtEnd = true;
    }
    /**
	 * Starts the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ play() {
        this._mixer._activateAction(this);
        return this;
    }
    /**
	 * Stops the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    /**
	 * Resets the playback of the animation.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    /**
	 * Returns `true` if the animation is running.
	 *
	 * @return {boolean} Whether the animation is running or not.
	 */ isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    /**
	 * Returns `true` when {@link AnimationAction#play} has been called.
	 *
	 * @return {boolean} Whether the animation is scheduled or not.
	 */ isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    /**
	 * Defines the time when the animation should start.
	 *
	 * @param {number} time - The start time in seconds.
	 * @return {AnimationAction} A reference to this animation action.
	 */ startAt(time) {
        this._startTime = time;
        return this;
    }
    /**
	 * Configures the loop settings for this action.
	 *
	 * @param {(LoopRepeat|LoopOnce|LoopPingPong)} mode - The loop mode.
	 * @param {number} repetitions - The number of repetitions.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    /**
	 * Sets the effective weight of this action.
	 *
	 * An action has no effect and thus an effective weight of zero when the
	 * action is disabled.
	 *
	 * @param {number} weight - The weight to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    /**
	 * Returns the effective weight of this action.
	 *
	 * @return {number} The effective weight.
	 */ getEffectiveWeight() {
        return this._effectiveWeight;
    }
    /**
	 * Fades the animation in by increasing its weight gradually from `0` to `1`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    /**
	 * Fades the animation out by decreasing its weight gradually from `1` to `0`,
	 * within the passed time interval.
	 *
	 * @param {number} duration - The duration of the fade.
	 * @return {AnimationAction} A reference to this animation action.
	 */ fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    /**
	 * Causes this action to fade in and the given action to fade out,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeOutAction - The animation action to fade out.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeFrom(fadeOutAction, duration, warp = false) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp === true) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    /**
	 * Causes this action to fade out and the given action to fade in,
	 * within the passed time interval.
	 *
	 * @param {AnimationAction} fadeInAction - The animation action to fade in.
	 * @param {number} duration - The duration of the fade.
	 * @param {boolean} [warp=false] - Whether warping should be used or not.
	 * @return {AnimationAction} A reference to this animation action.
	 */ crossFadeTo(fadeInAction, duration, warp = false) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    /**
	 * Stops any fading which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    /**
	 * Sets the effective time scale of this action.
	 *
	 * An action has no effect and thus an effective time scale of zero when the
	 * action is paused.
	 *
	 * @param {number} timeScale - The time scale to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    /**
	 * Returns the effective time scale of this action.
	 *
	 * @return {number} The effective time scale.
	 */ getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    /**
	 * Sets the duration for a single loop of this action.
	 *
	 * @param {number} duration - The duration to set.
	 * @return {AnimationAction} A reference to this animation action.
	 */ setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    /**
	 * Synchronizes this action with the passed other action.
	 *
	 * @param {AnimationAction} action - The action to sync with.
	 * @return {AnimationAction} A reference to this animation action.
	 */ syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    /**
	 * Decelerates this animation's speed to `0` within the passed time interval.
	 *
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    /**
	 * Changes the playback speed, within the passed time interval, by modifying
	 * {@link AnimationAction#timeScale} gradually from `startTimeScale` to
	 * `endTimeScale`.
	 *
	 * @param {number} startTimeScale - The start time scale.
	 * @param {number} endTimeScale - The end time scale.
	 * @param {number} duration - The duration.
	 * @return {AnimationAction} A reference to this animation action.
	 */ warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    /**
	 * Stops any scheduled warping which is applied to this action.
	 *
	 * @return {AnimationAction} A reference to this animation action.
	 */ stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    /**
	 * Returns the animation mixer of this animation action.
	 *
	 * @return {AnimationMixer} The animation mixer.
	 */ getMixer() {
        return this._mixer;
    }
    /**
	 * Returns the animation clip of this animation action.
	 *
	 * @return {AnimationClip} The animation clip.
	 */ getClip() {
        return this._clip;
    }
    /**
	 * Returns the root object of this animation action.
	 *
	 * @return {Object3D} The root object.
	 */ getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) deltaTime = 0;
            else {
                this._startTime = null; // unschedule
                deltaTime = timeDirection * timeRunning;
            }
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case AdditiveAnimationBlendMode:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case NormalAnimationBlendMode:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === LoopPingPong;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === LoopOnce) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = ZeroSlopeEnding;
            settings.endingEnd = ZeroSlopeEnding;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;
            else settings.endingStart = WrapAroundEnding;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;
            else settings.endingEnd = WrapAroundEnding;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
const _controlInterpolantsResultBuffer = new Float32Array(1);
/**
 * `AnimationMixer` is a player for animations on a particular object in
 * the scene. When multiple objects in the scene are animated independently,
 * one `AnimationMixer` may be used for each object.
 */ class AnimationMixer extends EventDispatcher {
    /**
	 * Constructs a new animation mixer.
	 *
	 * @param {Object3D} root - The object whose animations shall be played by this mixer.
	 */ constructor(root){
        super();
        this._root = root;
        this._initMemoryManager();
        this._accuIndex = 0;
        /**
		 * The global mixer time (in seconds; starting with `0` on the mixer's creation).
		 *
		 * @type {number}
		 * @default 0
		 */ this.time = 0;
        /**
		 * A scaling factor for the global time.
		 *
		 * Note: Setting this member to `0` and later back to `1` is a
		 * possibility to pause/unpause all actions that are controlled by this
		 * mixer.
		 *
		 * @type {number}
		 * @default 1
		 */ this.timeScale = 1.0;
    }
    _bindAction(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) {
                ++binding.referenceCount;
                bindings[i] = binding;
            } else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new PropertyMixer(PropertyBinding.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    }
    _activateAction(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    }
    _deactivateAction(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    }
    // Memory manager
    _initMemoryManager() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    }
    // Memory management for AnimationAction objects
    _isActiveAction(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    }
    _addInactiveAction(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    }
    _removeInactiveAction(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    }
    _removeInactiveBindingsForAction(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    }
    _lendAction(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    }
    _takeBackAction(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    }
    // Memory management for PropertyMixer objects
    _addInactiveBinding(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    }
    _removeInactiveBinding(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    }
    _lendBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    }
    _takeBackBinding(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    }
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new LinearInterpolant(new Float32Array(2), new Float32Array(2), 1, _controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    }
    _takeBackControlInterpolant(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    }
    /**
	 * Returns an instance of {@link AnimationAction} for the passed clip.
	 *
	 * If an action fitting the clip and root parameters doesn't yet exist, it
	 * will be created by this method. Calling this method several times with the
	 * same clip and root parameters always returns the same action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @param {(NormalAnimationBlendMode|AdditiveAnimationBlendMode)} [blendMode] - The blend mode.
	 * @return {?AnimationAction} The animation action.
	 */ clipAction(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? AnimationClip.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = NormalAnimationBlendMode;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new AnimationAction(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    }
    /**
	 * Returns an existing animation action for the passed clip.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 * @return {?AnimationAction} The animation action. Returns `null` if no action was found.
	 */ existingAction(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? AnimationClip.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    }
    /**
	 * Deactivates all previously scheduled actions on this mixer.
	 *
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ stopAllAction() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    }
    /**
	 * Advances the global mixer time and updates the animation.
	 *
	 * This is usually done in the render loop by passing the delta
	 * time from {@link Clock} or {@link Timer}.
	 *
	 * @param {number} deltaTime - The delta time in seconds.
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ update(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    }
    /**
	 * Sets the global mixer to a specific time and updates the animation accordingly.
	 *
	 * This is useful when you need to jump to an exact time in an animation. The
	 * input parameter will be scaled by {@link AnimationMixer#timeScale}
	 *
	 * @param {number} time - The time to set in seconds.
	 * @return {AnimationMixer} A reference to this animation mixer.
	 */ setTime(time) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(time); // Update used to set exact time. Returns "this" AnimationMixer object.
    }
    /**
	 * Returns this mixer's root object.
	 *
	 * @return {Object3D} The mixer's root object.
	 */ getRoot() {
        return this._root;
    }
    /**
	 * Deallocates all memory resources for a clip. Before using this method make
	 * sure to call {@link AnimationAction#stop} for all related actions.
	 *
	 * @param {AnimationClip} clip - The clip to uncache.
	 */ uncacheClip(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    }
    /**
	 * Deallocates all memory resources for a root object. Before using this
	 * method make sure to call {@link AnimationAction#stop} for all related
	 * actions or alternatively {@link AnimationMixer#stopAllAction} when the
	 * mixer operates on a single root.
	 *
	 * @param {Object3D} root - The root object to uncache.
	 */ uncacheRoot(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    }
    /**
	 * Deallocates all memory resources for an action. The action is identified by the
	 * given clip and an optional root object. Before using this method make
	 * sure to call {@link AnimationAction#stop} to deactivate the action.
	 *
	 * @param {AnimationClip|string} clip - An animation clip or alternatively the name of the animation clip.
	 * @param {Object3D} [optionalRoot] - An alternative root object.
	 */ uncacheAction(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
}
/**
 * Represents a 3D render target.
 *
 * @augments RenderTarget
 */ class RenderTarget3D extends RenderTarget {
    /**
	 * Constructs a new 3D render target.
	 *
	 * @param {number} [width=1] - The width of the render target.
	 * @param {number} [height=1] - The height of the render target.
	 * @param {number} [depth=1] - The height of the render target.
	 * @param {RenderTarget~Options} [options] - The configuration object.
	 */ constructor(width = 1, height = 1, depth = 1, options = {}){
        super(width, height, options);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isRenderTarget3D = true;
        this.depth = depth;
        /**
		 * Overwritten with a different texture type.
		 *
		 * @type {Data3DTexture}
		 */ this.texture = new Data3DTexture(null, width, height, depth);
        this._setTextureOptions(options);
        this.texture.isRenderTargetTexture = true;
    }
}
/**
 * Represents a uniform which is a global shader variable. They are passed to shader programs.
 *
 * When declaring a uniform of a {@link ShaderMaterial}, it is declared by value or by object.
 * ```js
 * uniforms: {
 * 	time: { value: 1.0 },
 * 	resolution: new Uniform( new Vector2() )
 * };
 * ```
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 */ class Uniform {
    /**
	 * Constructs a new uniform.
	 *
	 * @param {any} value - The uniform value.
	 */ constructor(value){
        /**
		 * The uniform value.
		 *
		 * @type {any}
		 */ this.value = value;
    }
    /**
	 * Returns a new uniform with copied values from this instance.
	 * If the value has a `clone()` method, the value is cloned as well.
	 *
	 * @return {Uniform} A clone of this instance.
	 */ clone() {
        return new Uniform(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
let _id = 0;
/**
 * A class for managing multiple uniforms in a single group. The renderer will process
 * such a definition as a single UBO.
 *
 * Since this class can only be used in context of {@link ShaderMaterial}, it is only supported
 * in {@link WebGLRenderer}.
 *
 * @augments EventDispatcher
 */ class UniformsGroup extends EventDispatcher {
    /**
	 * Constructs a new uniforms group.
	 */ constructor(){
        super();
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isUniformsGroup = true;
        /**
		 * The ID of the 3D object.
		 *
		 * @name UniformsGroup#id
		 * @type {number}
		 * @readonly
		 */ Object.defineProperty(this, 'id', {
            value: _id++
        });
        /**
		 * The name of the uniforms group.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The buffer usage.
		 *
		 * @type {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)}
		 * @default StaticDrawUsage
		 */ this.usage = StaticDrawUsage;
        /**
		 * An array holding the uniforms.
		 *
		 * @type {Array<Uniform>}
		 */ this.uniforms = [];
    }
    /**
	 * Adds the given uniform to this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to add.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ add(uniform) {
        this.uniforms.push(uniform);
        return this;
    }
    /**
	 * Removes the given uniform from this uniforms group.
	 *
	 * @param {Uniform} uniform - The uniform to remove.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ remove(uniform) {
        const index = this.uniforms.indexOf(uniform);
        if (index !== -1) this.uniforms.splice(index, 1);
        return this;
    }
    /**
	 * Sets the name of this uniforms group.
	 *
	 * @param {string} name - The name to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setName(name) {
        this.name = name;
        return this;
    }
    /**
	 * Sets the usage of this uniforms group.
	 *
	 * @param {(StaticDrawUsage|DynamicDrawUsage|StreamDrawUsage|StaticReadUsage|DynamicReadUsage|StreamReadUsage|StaticCopyUsage|DynamicCopyUsage|StreamCopyUsage)} value - The usage to set.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ setUsage(value) {
        this.usage = value;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 *
	 * @fires Texture#dispose
	 */ dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
    /**
	 * Copies the values of the given uniforms group to this instance.
	 *
	 * @param {UniformsGroup} source - The uniforms group to copy.
	 * @return {UniformsGroup} A reference to this uniforms group.
	 */ copy(source) {
        this.name = source.name;
        this.usage = source.usage;
        const uniformsSource = source.uniforms;
        this.uniforms.length = 0;
        for(let i = 0, l = uniformsSource.length; i < l; i++){
            const uniforms = Array.isArray(uniformsSource[i]) ? uniformsSource[i] : [
                uniformsSource[i]
            ];
            for(let j = 0; j < uniforms.length; j++)this.uniforms.push(uniforms[j].clone());
        }
        return this;
    }
    /**
	 * Returns a new uniforms group with copied values from this instance.
	 *
	 * @return {UniformsGroup} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * An instanced version of an interleaved buffer.
 *
 * @augments InterleavedBuffer
 */ class InstancedInterleavedBuffer extends InterleavedBuffer {
    /**
	 * Constructs a new instanced interleaved buffer.
	 *
	 * @param {TypedArray} array - A typed array with a shared buffer storing attribute data.
	 * @param {number} stride - The number of typed-array elements per vertex.
	 * @param {number} [meshPerAttribute=1] - Defines how often a value of this interleaved buffer should be repeated.
	 */ constructor(array, stride, meshPerAttribute = 1){
        super(array, stride);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isInstancedInterleavedBuffer = true;
        /**
		 * Defines how often a value of this buffer attribute should be repeated,
		 * see {@link InstancedBufferAttribute#meshPerAttribute}.
		 *
		 * @type {number}
		 * @default 1
		 */ this.meshPerAttribute = meshPerAttribute;
    }
    copy(source) {
        super.copy(source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    }
    clone(data) {
        const ib = super.clone(data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    }
    toJSON(data) {
        const json = super.toJSON(data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
}
/**
 * An alternative version of a buffer attribute with more control over the VBO.
 *
 * The renderer does not construct a VBO for this kind of attribute. Instead, it uses
 * whatever VBO is passed in constructor and can later be altered via the `buffer` property.
 *
 * The most common use case for this class is when some kind of GPGPU calculation interferes
 * or even produces the VBOs in question.
 *
 * Notice that this class can only be used with {@link WebGLRenderer}.
 */ class GLBufferAttribute {
    /**
	 * Constructs a new GL buffer attribute.
	 *
	 * @param {WebGLBuffer} buffer - The native WebGL buffer.
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} itemSize - The item size.
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @param {number} count - The expected number of vertices in VBO.
	 * @param {boolean} [normalized=false] - Whether the data are normalized or not.
	 */ constructor(buffer, type, itemSize, elementSize, count, normalized = false){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isGLBufferAttribute = true;
        /**
		 * The name of the buffer attribute.
		 *
		 * @type {string}
		 */ this.name = '';
        /**
		 * The native WebGL buffer.
		 *
		 * @type {WebGLBuffer}
		 */ this.buffer = buffer;
        /**
		 * The native data type.
		 *
		 * @type {number}
		 */ this.type = type;
        /**
		 * The item size, see {@link BufferAttribute#itemSize}.
		 *
		 * @type {number}
		 */ this.itemSize = itemSize;
        /**
		 * The corresponding size (in bytes) for the given `type` parameter.
		 *
		 * @type {number}
		 */ this.elementSize = elementSize;
        /**
		 * The expected number of vertices in VBO.
		 *
		 * @type {number}
		 */ this.count = count;
        /**
		 * Applies to integer data only. Indicates how the underlying data in the buffer maps to
		 * the values in the GLSL code. For instance, if `buffer` contains data of `gl.UNSIGNED_SHORT`,
		 * and `normalized` is `true`, the values `0 - +65535` in the buffer data will be mapped to
		 * `0.0f - +1.0f` in the GLSL attribute. If `normalized` is `false`, the values will be converted
		 * to floats unmodified, i.e. `65535` becomes `65535.0f`.
		 *
		 * @type {boolean}
		 */ this.normalized = normalized;
        /**
		 * A version number, incremented every time the `needsUpdate` is set to `true`.
		 *
		 * @type {number}
		 */ this.version = 0;
    }
    /**
	 * Flag to indicate that this attribute has changed and should be re-sent to
	 * the GPU. Set this to `true` when you modify the value of the array.
	 *
	 * @type {number}
	 * @default false
	 * @param {boolean} value
	 */ set needsUpdate(value) {
        if (value === true) this.version++;
    }
    /**
	 * Sets the given native WebGL buffer.
	 *
	 * @param {WebGLBuffer} buffer - The buffer to set.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setBuffer(buffer) {
        this.buffer = buffer;
        return this;
    }
    /**
	 * Sets the given native data type and element size.
	 *
	 * @param {number} type - The native data type (e.g. `gl.FLOAT`).
	 * @param {number} elementSize - The corresponding size (in bytes) for the given `type` parameter.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setType(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    }
    /**
	 * Sets the item size.
	 *
	 * @param {number} itemSize - The item size.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setItemSize(itemSize) {
        this.itemSize = itemSize;
        return this;
    }
    /**
	 * Sets the count (the expected number of vertices in VBO).
	 *
	 * @param {number} count - The count.
	 * @return {BufferAttribute} A reference to this instance.
	 */ setCount(count) {
        this.count = count;
        return this;
    }
}
const _matrix = /*@__PURE__*/ new Matrix4();
/**
 * This class is designed to assist with raycasting. Raycasting is used for
 * mouse picking (working out what objects in the 3d space the mouse is over)
 * amongst other things.
 */ class Raycaster {
    /**
	 * Constructs a new raycaster.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 * @param {number} [near=0] - All results returned are further away than near. Near can't be negative.
	 * @param {number} [far=Infinity] - All results returned are closer than far. Far can't be lower than near.
	 */ constructor(origin, direction, near = 0, far = Infinity){
        /**
		 * The ray used for raycasting.
		 *
		 * @type {Ray}
		 */ this.ray = new Ray(origin, direction);
        /**
		 * All results returned are further away than near. Near can't be negative.
		 *
		 * @type {number}
		 * @default 0
		 */ this.near = near;
        /**
		 * All results returned are closer than far. Far can't be lower than near.
		 *
		 * @type {number}
		 * @default Infinity
		 */ this.far = far;
        /**
		 * The camera to use when raycasting against view-dependent objects such as
		 * billboarded objects like sprites. This field can be set manually or
		 * is set when calling `setFromCamera()`.
		 *
		 * @type {?Camera}
		 * @default null
		 */ this.camera = null;
        /**
		 * Allows to selectively ignore 3D objects when performing intersection tests.
		 * The following code example ensures that only 3D objects on layer `1` will be
		 * honored by raycaster.
		 * ```js
		 * raycaster.layers.set( 1 );
		 * object.layers.enable( 1 );
		 * ```
		 *
		 * @type {Layers}
		 */ this.layers = new Layers();
        /**
		 * A parameter object that configures the raycasting. It has the structure:
		 *
		 * ```
		 * {
		 * 	Mesh: {},
		 * 	Line: { threshold: 1 },
		 * 	LOD: {},
		 * 	Points: { threshold: 1 },
		 * 	Sprite: {}
		 * }
		 * ```
		 * Where `threshold` is the precision of the raycaster when intersecting objects, in world units.
		 *
		 * @type {Object}
		 */ this.params = {
            Mesh: {},
            Line: {
                threshold: 1
            },
            LOD: {},
            Points: {
                threshold: 1
            },
            Sprite: {}
        };
    }
    /**
	 * Updates the ray with a new origin and direction by copying the values from the arguments.
	 *
	 * @param {Vector3} origin - The origin vector where the ray casts from.
	 * @param {Vector3} direction - The (normalized) direction vector that gives direction to the ray.
	 */ set(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    }
    /**
	 * Uses the given coordinates and camera to compute a new origin and direction for the internal ray.
	 *
	 * @param {Vector2} coords - 2D coordinates of the mouse, in normalized device coordinates (NDC).
	 * X and Y components should be between `-1` and `1`.
	 * @param {Camera} camera - The camera from which the ray should originate.
	 */ setFromCamera(coords, camera) {
        if (camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else error('Raycaster: Unsupported camera type: ' + camera.type);
    }
    /**
	 * Uses the given WebXR controller to compute a new origin and direction for the internal ray.
	 *
	 * @param {WebXRController} controller - The controller to copy the position and direction from.
	 * @return {Raycaster} A reference to this raycaster.
	 */ setFromXRController(controller) {
        _matrix.identity().extractRotation(controller.matrixWorld);
        this.ray.origin.setFromMatrixPosition(controller.matrixWorld);
        this.ray.direction.set(0, 0, -1).applyMatrix4(_matrix);
        return this;
    }
    /**
	 * The intersection point of a raycaster intersection test.
	 * @typedef {Object} Raycaster~Intersection
	 * @property {number} distance - The distance from the ray's origin to the intersection point.
	 * @property {number} distanceToRay -  Some 3D objects e.g. {@link Points} provide the distance of the
	 * intersection to the nearest point on the ray. For other objects it will be `undefined`.
	 * @property {Vector3} point - The intersection point, in world coordinates.
	 * @property {Object} face - The face that has been intersected.
	 * @property {number} faceIndex - The face index.
	 * @property {Object3D} object - The 3D object that has been intersected.
	 * @property {Vector2} uv - U,V coordinates at point of intersection.
	 * @property {Vector2} uv1 - Second set of U,V coordinates at point of intersection.
	 * @property {Vector3} normal - Interpolated normal vector at point of intersection.
	 * @property {number} instanceId - The index number of the instance where the ray
	 * intersects the {@link InstancedMesh}.
	 */ /**
	 * Checks all intersection between the ray and the object with or without the
	 * descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * `Raycaster` delegates to the `raycast()` method of the passed 3D object, when
	 * evaluating whether the ray intersects the object or not. This allows meshes to respond
	 * differently to ray casting than lines or points.
	 *
	 * Note that for meshes, faces must be pointed towards the origin of the ray in order
	 * to be detected; intersections of the ray passing through the back of a face will not
	 * be detected. To raycast against both faces of an object, you'll want to set  {@link Material#side}
	 * to `THREE.DoubleSide`.
	 *
	 * @param {Object3D} object - The 3D object to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObject(object, recursive = true, intersects = []) {
        intersect(object, this, intersects, recursive);
        intersects.sort(ascSort);
        return intersects;
    }
    /**
	 * Checks all intersection between the ray and the objects with or without
	 * the descendants. Intersections are returned sorted by distance, closest first.
	 *
	 * @param {Array<Object3D>} objects - The 3D objects to check for intersection with the ray.
	 * @param {boolean} [recursive=true] - If set to `true`, it also checks all descendants.
	 * Otherwise it only checks intersection with the object.
	 * @param {Array<Raycaster~Intersection>} [intersects=[]] The target array that holds the result of the method.
	 * @return {Array<Raycaster~Intersection>} An array holding the intersection points.
	 */ intersectObjects(objects, recursive = true, intersects = []) {
        for(let i = 0, l = objects.length; i < l; i++)intersect(objects[i], this, intersects, recursive);
        intersects.sort(ascSort);
        return intersects;
    }
}
function ascSort(a, b) {
    return a.distance - b.distance;
}
function intersect(object, raycaster, intersects, recursive) {
    let propagate = true;
    if (object.layers.test(raycaster.layers)) {
        const result = object.raycast(raycaster, intersects);
        if (result === false) propagate = false;
    }
    if (propagate === true && recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)intersect(children[i], raycaster, intersects, true);
    }
}
/**
 * This class is an alternative to {@link Clock} with a different API design and behavior.
 * The goal is to avoid the conceptual flaws that became apparent in `Clock` over time.
 *
 * - `Timer` has an `update()` method that updates its internal state. That makes it possible to
 * call `getDelta()` and `getElapsed()` multiple times per simulation step without getting different values.
 * - The class can make use of the Page Visibility API to avoid large time delta values when the app
 * is inactive (e.g. tab switched or browser hidden).
 *
 * ```js
 * const timer = new Timer();
 * timer.connect( document ); // use Page Visibility API
 * ```
 */ class Timer {
    /**
	 * Constructs a new timer.
	 */ constructor(){
        this._previousTime = 0;
        this._currentTime = 0;
        this._startTime = performance.now();
        this._delta = 0;
        this._elapsed = 0;
        this._timescale = 1;
        this._document = null;
        this._pageVisibilityHandler = null;
    }
    /**
	 * Connect the timer to the given document.Calling this method is not mandatory to
	 * use the timer but enables the usage of the Page Visibility API to avoid large time
	 * delta values.
	 *
	 * @param {Document} document - The document.
	 */ connect(document1) {
        this._document = document1;
        // use Page Visibility API to avoid large time delta values
        if (document1.hidden !== undefined) {
            this._pageVisibilityHandler = handleVisibilityChange.bind(this);
            document1.addEventListener('visibilitychange', this._pageVisibilityHandler, false);
        }
    }
    /**
	 * Disconnects the timer from the DOM and also disables the usage of the Page Visibility API.
	 */ disconnect() {
        if (this._pageVisibilityHandler !== null) {
            this._document.removeEventListener('visibilitychange', this._pageVisibilityHandler);
            this._pageVisibilityHandler = null;
        }
        this._document = null;
    }
    /**
	 * Returns the time delta in seconds.
	 *
	 * @return {number} The time delta in second.
	 */ getDelta() {
        return this._delta / 1000;
    }
    /**
	 * Returns the elapsed time in seconds.
	 *
	 * @return {number} The elapsed time in second.
	 */ getElapsed() {
        return this._elapsed / 1000;
    }
    /**
	 * Returns the timescale.
	 *
	 * @return {number} The timescale.
	 */ getTimescale() {
        return this._timescale;
    }
    /**
	 * Sets the given timescale which scale the time delta computation
	 * in `update()`.
	 *
	 * @param {number} timescale - The timescale to set.
	 * @return {Timer} A reference to this timer.
	 */ setTimescale(timescale) {
        this._timescale = timescale;
        return this;
    }
    /**
	 * Resets the time computation for the current simulation step.
	 *
	 * @return {Timer} A reference to this timer.
	 */ reset() {
        this._currentTime = performance.now() - this._startTime;
        return this;
    }
    /**
	 * Can be used to free all internal resources. Usually called when
	 * the timer instance isn't required anymore.
	 */ dispose() {
        this.disconnect();
    }
    /**
	 * Updates the internal state of the timer. This method should be called
	 * once per simulation step and before you perform queries against the timer
	 * (e.g. via `getDelta()`).
	 *
	 * @param {number} timestamp - The current time in milliseconds. Can be obtained
	 * from the `requestAnimationFrame` callback argument. If not provided, the current
	 * time will be determined with `performance.now`.
	 * @return {Timer} A reference to this timer.
	 */ update(timestamp) {
        if (this._pageVisibilityHandler !== null && this._document.hidden === true) this._delta = 0;
        else {
            this._previousTime = this._currentTime;
            this._currentTime = (timestamp !== undefined ? timestamp : performance.now()) - this._startTime;
            this._delta = (this._currentTime - this._previousTime) * this._timescale;
            this._elapsed += this._delta; // _elapsed is the accumulation of all previous deltas
        }
        return this;
    }
}
function handleVisibilityChange() {
    if (this._document.hidden === false) this.reset();
}
/**
 * This class can be used to represent points in 3D space as
 * [Spherical coordinates](https://en.wikipedia.org/wiki/Spherical_coordinate_system).
 */ class Spherical {
    /**
	 * Constructs a new spherical.
	 *
	 * @param {number} [radius=1] - The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
	 * @param {number} [phi=0] - The polar angle in radians from the y (up) axis.
	 * @param {number} [theta=0] - The equator/azimuthal angle in radians around the y (up) axis.
	 */ constructor(radius = 1, phi = 0, theta = 0){
        /**
		 * The radius, or the Euclidean distance (straight-line distance) from the point to the origin.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * The polar angle in radians from the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.phi = phi;
        /**
		 * The equator/azimuthal angle in radians around the y (up) axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
    }
    /**
	 * Sets the spherical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} phi - The polar angle.
	 * @param {number} theta - The azimuthal angle.
	 * @return {Spherical} A reference to this spherical.
	 */ set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    /**
	 * Copies the values of the given spherical to this instance.
	 *
	 * @param {Spherical} other - The spherical to copy.
	 * @return {Spherical} A reference to this spherical.
	 */ copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    /**
	 * Restricts the polar angle [page:.phi phi] to be between `0.000001` and pi -
	 * `0.000001`.
	 *
	 * @return {Spherical} A reference to this spherical.
	 */ makeSafe() {
        const EPS = 0.000001;
        this.phi = clamp(this.phi, EPS, Math.PI - EPS);
        return this;
    }
    /**
	 * Sets the spherical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the spherical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The y value.
	 * @param {number} z - The z value.
	 * @return {Spherical} A reference to this spherical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos(clamp(y / this.radius, -1, 1));
        }
        return this;
    }
    /**
	 * Returns a new spherical with copied values from this instance.
	 *
	 * @return {Spherical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * This class can be used to represent points in 3D space as
 * [Cylindrical coordinates](https://en.wikipedia.org/wiki/Cylindrical_coordinate_system).
 */ class Cylindrical {
    /**
	 * Constructs a new cylindrical.
	 *
	 * @param {number} [radius=1] - The distance from the origin to a point in the x-z plane.
	 * @param {number} [theta=0] - A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
	 * @param {number} [y=0] - The height above the x-z plane.
	 */ constructor(radius = 1, theta = 0, y = 0){
        /**
		 * The distance from the origin to a point in the x-z plane.
		 *
		 * @type {number}
		 * @default 1
		 */ this.radius = radius;
        /**
		 * A counterclockwise angle in the x-z plane measured in radians from the positive z-axis.
		 *
		 * @type {number}
		 * @default 0
		 */ this.theta = theta;
        /**
		 * The height above the x-z plane.
		 *
		 * @type {number}
		 * @default 0
		 */ this.y = y;
    }
    /**
	 * Sets the cylindrical components by copying the given values.
	 *
	 * @param {number} radius - The radius.
	 * @param {number} theta - The theta angle.
	 * @param {number} y - The height value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    /**
	 * Copies the values of the given cylindrical to this instance.
	 *
	 * @param {Cylindrical} other - The cylindrical to copy.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    /**
	 * Sets the cylindrical components from the given vector which is assumed to hold
	 * Cartesian coordinates.
	 *
	 * @param {Vector3} v - The vector to set.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    /**
	 * Sets the cylindrical components from the given Cartesian coordinates.
	 *
	 * @param {number} x - The x value.
	 * @param {number} y - The x value.
	 * @param {number} z - The x value.
	 * @return {Cylindrical} A reference to this cylindrical.
	 */ setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
    /**
	 * Returns a new cylindrical with copied values from this instance.
	 *
	 * @return {Cylindrical} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
/**
 * Represents a 2x2 matrix.
 *
 * A Note on Row-Major and Column-Major Ordering:
 *
 * The constructor and {@link Matrix2#set} method take arguments in
 * [row-major](https://en.wikipedia.org/wiki/Row-_and_column-major_order#Column-major_order)
 * order, while internally they are stored in the {@link Matrix2#elements} array in column-major order.
 * This means that calling:
 * ```js
 * const m = new THREE.Matrix2();
 * m.set( 11, 12,
 *        21, 22 );
 * ```
 * will result in the elements array containing:
 * ```js
 * m.elements = [ 11, 21,
 *                12, 22 ];
 * ```
 * and internally all calculations are performed using column-major ordering.
 * However, as the actual ordering makes no difference mathematically and
 * most people are used to thinking about matrices in row-major order, the
 * three.js documentation shows matrices in row-major order. Just bear in
 * mind that if you are reading the source code, you'll have to take the
 * transpose of any matrices outlined here to make sense of the calculations.
 */ class Matrix2 {
    /**
	 * Constructs a new 2x2 matrix. The arguments are supposed to be
	 * in row-major order. If no arguments are provided, the constructor
	 * initializes the matrix as an identity matrix.
	 *
	 * @param {number} [n11] - 1-1 matrix element.
	 * @param {number} [n12] - 1-2 matrix element.
	 * @param {number} [n21] - 2-1 matrix element.
	 * @param {number} [n22] - 2-2 matrix element.
	 */ constructor(n11, n12, n21, n22){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ Matrix2.prototype.isMatrix2 = true;
        /**
		 * A column-major list of matrix values.
		 *
		 * @type {Array<number>}
		 */ this.elements = [
            1,
            0,
            0,
            1
        ];
        if (n11 !== undefined) this.set(n11, n12, n21, n22);
    }
    /**
	 * Sets this matrix to the 2x2 identity matrix.
	 *
	 * @return {Matrix2} A reference to this matrix.
	 */ identity() {
        this.set(1, 0, 0, 1);
        return this;
    }
    /**
	 * Sets the elements of the matrix from the given array.
	 *
	 * @param {Array<number>} array - The matrix elements in column-major order.
	 * @param {number} [offset=0] - Index of the first element in the array.
	 * @return {Matrix2} A reference to this matrix.
	 */ fromArray(array, offset = 0) {
        for(let i = 0; i < 4; i++)this.elements[i] = array[i + offset];
        return this;
    }
    /**
	 * Sets the elements of the matrix.The arguments are supposed to be
	 * in row-major order.
	 *
	 * @param {number} n11 - 1-1 matrix element.
	 * @param {number} n12 - 1-2 matrix element.
	 * @param {number} n21 - 2-1 matrix element.
	 * @param {number} n22 - 2-2 matrix element.
	 * @return {Matrix2} A reference to this matrix.
	 */ set(n11, n12, n21, n22) {
        const te = this.elements;
        te[0] = n11;
        te[2] = n12;
        te[1] = n21;
        te[3] = n22;
        return this;
    }
}
const _vector$4 = /*@__PURE__*/ new Vector2();
/**
 * Represents an axis-aligned bounding box (AABB) in 2D space.
 */ class Box2 {
    /**
	 * Constructs a new bounding box.
	 *
	 * @param {Vector2} [min=(Infinity,Infinity)] - A vector representing the lower boundary of the box.
	 * @param {Vector2} [max=(-Infinity,-Infinity)] - A vector representing the upper boundary of the box.
	 */ constructor(min = new Vector2(Infinity, Infinity), max = new Vector2(-Infinity, -Infinity)){
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isBox2 = true;
        /**
		 * The lower boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.min = min;
        /**
		 * The upper boundary of the box.
		 *
		 * @type {Vector2}
		 */ this.max = max;
    }
    /**
	 * Sets the lower and upper boundaries of this box.
	 * Please note that this method only copies the values from the given objects.
	 *
	 * @param {Vector2} min - The lower boundary of the box.
	 * @param {Vector2} max - The upper boundary of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    /**
	 * Sets the upper and lower bounds of this box so it encloses the position data
	 * in the given array.
	 *
	 * @param {Array<Vector2>} points - An array holding 2D position data as instances of {@link Vector2}.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    /**
	 * Centers this box on the given center vector and sets this box's width, height and
	 * depth to the given size values.
	 *
	 * @param {Vector2} center - The center of the box.
	 * @param {Vector2} size - The x and y dimensions of the box.
	 * @return {Box2} A reference to this bounding box.
	 */ setFromCenterAndSize(center, size) {
        const halfSize = _vector$4.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    /**
	 * Returns a new box with copied values from this instance.
	 *
	 * @return {Box2} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
    /**
	 * Copies the values of the given box to this instance.
	 *
	 * @param {Box2} box - The box to copy.
	 * @return {Box2} A reference to this bounding box.
	 */ copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    /**
	 * Makes this box empty which means in encloses a zero space in 2D.
	 *
	 * @return {Box2} A reference to this bounding box.
	 */ makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    /**
	 * Returns true if this box includes zero points within its bounds.
	 * Note that a box with equal lower and upper bounds still includes one
	 * point, the one both bounds share.
	 *
	 * @return {boolean} Whether this box is empty or not.
	 */ isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    /**
	 * Returns the center point of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The center point.
	 */ getCenter(target) {
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    /**
	 * Returns the dimensions of this box.
	 *
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The size.
	 */ getSize(target) {
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    /**
	 * Expands the boundaries of this box to include the given point.
	 *
	 * @param {Vector2} point - The point that should be included by the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    /**
	 * Expands this box equilaterally by the given vector. The width of this
	 * box will be expanded by the x component of the vector in both
	 * directions. The height of this box will be expanded by the y component of
	 * the vector in both directions.
	 *
	 * @param {Vector2} vector - The vector that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    /**
	 * Expands each dimension of the box by the given scalar. If negative, the
	 * dimensions of the box will be contracted.
	 *
	 * @param {number} scalar - The scalar value that should expand the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    /**
	 * Returns `true` if the given point lies within or on the boundaries of this box.
	 *
	 * @param {Vector2} point - The point to test.
	 * @return {boolean} Whether the bounding box contains the given point or not.
	 */ containsPoint(point) {
        return point.x >= this.min.x && point.x <= this.max.x && point.y >= this.min.y && point.y <= this.max.y;
    }
    /**
	 * Returns `true` if this bounding box includes the entirety of the given bounding box.
	 * If this box and the given one are identical, this function also returns `true`.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the bounding box contains the given bounding box or not.
	 */ containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    /**
	 * Returns a point as a proportion of this box's width and height.
	 *
	 * @param {Vector2} point - A point in 2D space.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} A point as a proportion of this box's width and height.
	 */ getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    /**
	 * Returns `true` if the given bounding box intersects with this bounding box.
	 *
	 * @param {Box2} box - The bounding box to test.
	 * @return {boolean} Whether the given bounding box intersects with this bounding box.
	 */ intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x >= this.min.x && box.min.x <= this.max.x && box.max.y >= this.min.y && box.min.y <= this.max.y;
    }
    /**
	 * Clamps the given point within the bounds of this box.
	 *
	 * @param {Vector2} point - The point to clamp.
	 * @param {Vector2} target - The target vector that is used to store the method's result.
	 * @return {Vector2} The clamped point.
	 */ clampPoint(point, target) {
        return target.copy(point).clamp(this.min, this.max);
    }
    /**
	 * Returns the euclidean distance from any edge of this box to the specified point. If
	 * the given point lies inside of this box, the distance will be `0`.
	 *
	 * @param {Vector2} point - The point to compute the distance to.
	 * @return {number} The euclidean distance.
	 */ distanceToPoint(point) {
        return this.clampPoint(point, _vector$4).distanceTo(point);
    }
    /**
	 * Computes the intersection of this bounding box and the given one, setting the upper
	 * bound of this box to the lesser of the two boxes' upper bounds and the
	 * lower bound of this box to the greater of the two boxes' lower bounds. If
	 * there's no overlap, makes this box empty.
	 *
	 * @param {Box2} box - The bounding box to intersect with.
	 * @return {Box2} A reference to this bounding box.
	 */ intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    /**
	 * Computes the union of this box and another and the given one, setting the upper
	 * bound of this box to the greater of the two boxes' upper bounds and the
	 * lower bound of this box to the lesser of the two boxes' lower bounds.
	 *
	 * @param {Box2} box - The bounding box that will be unioned with this instance.
	 * @return {Box2} A reference to this bounding box.
	 */ union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    /**
	 * Adds the given offset to both the upper and lower bounds of this bounding box,
	 * effectively moving it in 2D space.
	 *
	 * @param {Vector2} offset - The offset that should be used to translate the bounding box.
	 * @return {Box2} A reference to this bounding box.
	 */ translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    /**
	 * Returns `true` if this bounding box is equal with the given one.
	 *
	 * @param {Box2} box - The box to test for equality.
	 * @return {boolean} Whether this bounding box is equal with the given one.
	 */ equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const _startP = /*@__PURE__*/ new Vector3();
const _startEnd = /*@__PURE__*/ new Vector3();
const _d1 = /*@__PURE__*/ new Vector3();
const _d2 = /*@__PURE__*/ new Vector3();
const _r = /*@__PURE__*/ new Vector3();
const _c1 = /*@__PURE__*/ new Vector3();
const _c2 = /*@__PURE__*/ new Vector3();
/**
 * An analytical line segment in 3D space represented by a start and end point.
 */ class Line3 {
    /**
	 * Constructs a new line segment.
	 *
	 * @param {Vector3} [start=(0,0,0)] - Start of the line segment.
	 * @param {Vector3} [end=(0,0,0)] - End of the line segment.
	 */ constructor(start = new Vector3(), end = new Vector3()){
        /**
		 * Start of the line segment.
		 *
		 * @type {Vector3}
		 */ this.start = start;
        /**
		 * End of the line segment.
		 *
		 * @type {Vector3}
		 */ this.end = end;
    }
    /**
	 * Sets the start and end values by copying the given vectors.
	 *
	 * @param {Vector3} start - The start point.
	 * @param {Vector3} end - The end point.
	 * @return {Line3} A reference to this line segment.
	 */ set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    /**
	 * Copies the values of the given line segment to this instance.
	 *
	 * @param {Line3} line - The line segment to copy.
	 * @return {Line3} A reference to this line segment.
	 */ copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    /**
	 * Returns the center of the line segment.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The center point.
	 */ getCenter(target) {
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    /**
	 * Returns the delta vector of the line segment's start and end point.
	 *
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ delta(target) {
        return target.subVectors(this.end, this.start);
    }
    /**
	 * Returns the squared Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The squared Euclidean distance.
	 */ distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    /**
	 * Returns the Euclidean distance between the line' start and end point.
	 *
	 * @return {number} The Euclidean distance.
	 */ distance() {
        return this.start.distanceTo(this.end);
    }
    /**
	 * Returns a vector at a certain position along the line segment.
	 *
	 * @param {number} t - A value between `[0,1]` to represent a position along the line segment.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The delta vector.
	 */ at(t, target) {
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns a point parameter based on the closest point as projected on the line segment.
	 *
	 * @param {Vector3} point - The point for which to return a point parameter.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @return {number} The point parameter.
	 */ closestPointToPointParameter(point, clampToLine) {
        _startP.subVectors(point, this.start);
        _startEnd.subVectors(this.end, this.start);
        const startEnd2 = _startEnd.dot(_startEnd);
        const startEnd_startP = _startEnd.dot(_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = clamp(t, 0, 1);
        return t;
    }
    /**
	 * Returns the closest point on the line for a given point.
	 *
	 * @param {Vector3} point - The point to compute the closest point on the line for.
	 * @param {boolean} clampToLine - Whether to clamp the result to the range `[0,1]` or not.
	 * @param {Vector3} target - The target vector that is used to store the method's result.
	 * @return {Vector3} The closest point on the line.
	 */ closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    /**
	 * Returns the closest squared distance between this line segment and the given one.
	 *
	 * @param {Line3} line - The line segment to compute the closest squared distance to.
	 * @param {Vector3} [c1] - The closest point on this line segment.
	 * @param {Vector3} [c2] - The closest point on the given line segment.
	 * @return {number} The squared distance between this line segment and the given one.
	 */ distanceSqToLine3(line, c1 = _c1, c2 = _c2) {
        // from Real-Time Collision Detection by Christer Ericson, chapter 5.1.9
        // Computes closest points C1 and C2 of S1(s)=P1+s*(Q1-P1) and
        // S2(t)=P2+t*(Q2-P2), returning s and t. Function result is squared
        // distance between between S1(s) and S2(t)
        const EPSILON = 1e-8 * 1e-8; // must be squared since we compare squared length
        let s, t;
        const p1 = this.start;
        const p2 = line.start;
        const q1 = this.end;
        const q2 = line.end;
        _d1.subVectors(q1, p1); // Direction vector of segment S1
        _d2.subVectors(q2, p2); // Direction vector of segment S2
        _r.subVectors(p1, p2);
        const a = _d1.dot(_d1); // Squared length of segment S1, always nonnegative
        const e = _d2.dot(_d2); // Squared length of segment S2, always nonnegative
        const f = _d2.dot(_r);
        // Check if either or both segments degenerate into points
        if (a <= EPSILON && e <= EPSILON) {
            // Both segments degenerate into points
            c1.copy(p1);
            c2.copy(p2);
            c1.sub(c2);
            return c1.dot(c1);
        }
        if (a <= EPSILON) {
            // First segment degenerates into a point
            s = 0;
            t = f / e; // s = 0 => t = (b*s + f) / e = f / e
            t = clamp(t, 0, 1);
        } else {
            const c = _d1.dot(_r);
            if (e <= EPSILON) {
                // Second segment degenerates into a point
                t = 0;
                s = clamp(-c / a, 0, 1); // t = 0 => s = (b*t - c) / a = -c / a
            } else {
                // The general nondegenerate case starts here
                const b = _d1.dot(_d2);
                const denom = a * e - b * b; // Always nonnegative
                // If segments not parallel, compute closest point on L1 to L2 and
                // clamp to segment S1. Else pick arbitrary s (here 0)
                if (denom !== 0) s = clamp((b * f - c * e) / denom, 0, 1);
                else s = 0;
                // Compute point on L2 closest to S1(s) using
                // t = Dot((P1 + D1*s) - P2,D2) / Dot(D2,D2) = (b*s + f) / e
                t = (b * s + f) / e;
                // If t in [0,1] done. Else clamp t, recompute s for the new value
                // of t using s = Dot((P2 + D2*t) - P1,D1) / Dot(D1,D1)= (t*b - c) / a
                // and clamp s to [0, 1]
                if (t < 0) {
                    t = 0.;
                    s = clamp(-c / a, 0, 1);
                } else if (t > 1) {
                    t = 1;
                    s = clamp((b - c) / a, 0, 1);
                }
            }
        }
        c1.copy(p1).add(_d1.multiplyScalar(s));
        c2.copy(p2).add(_d2.multiplyScalar(t));
        c1.sub(c2);
        return c1.dot(c1);
    }
    /**
	 * Applies a 4x4 transformation matrix to this line segment.
	 *
	 * @param {Matrix4} matrix - The transformation matrix.
	 * @return {Line3} A reference to this line segment.
	 */ applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    /**
	 * Returns `true` if this line segment is equal with the given one.
	 *
	 * @param {Line3} line - The line segment to test for equality.
	 * @return {boolean} Whether this line segment is equal with the given one.
	 */ equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
    /**
	 * Returns a new line segment with copied values from this instance.
	 *
	 * @return {Line3} A clone of this instance.
	 */ clone() {
        return new this.constructor().copy(this);
    }
}
const _vector$3 = /*@__PURE__*/ new Vector3();
/**
 * This displays a cone shaped helper object for a {@link SpotLight}.
 *
 * ```js
 * const spotLight = new THREE.SpotLight( 0xffffff );
 * spotLight.position.set( 10, 10, 10 );
 * scene.add( spotLight );
 *
 * const spotLightHelper = new THREE.SpotLightHelper( spotLight );
 * scene.add( spotLightHelper );
 * ```
 *
 * @augments Object3D
 */ class SpotLightHelper extends Object3D {
    /**
	 * Constructs a new spot light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {SpotLight}
		 */ this.light = light;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'SpotLightHelper';
        const geometry = new BufferGeometry();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));
        const material = new LineBasicMaterial({
            fog: false,
            toneMapped: false
        });
        this.cone = new LineSegments(geometry, material);
        this.add(this.cone);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        // update the local matrix based on the parent and light target transforms
        if (this.parent) {
            this.parent.updateWorldMatrix(true);
            this.matrix.copy(this.parent.matrixWorld).invert().multiply(this.light.matrixWorld);
        } else this.matrix.copy(this.light.matrixWorld);
        this.matrixWorld.copy(this.light.matrixWorld);
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        _vector$3.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt(_vector$3);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const _vector$2 = /*@__PURE__*/ new Vector3();
const _boneMatrix = /*@__PURE__*/ new Matrix4();
const _matrixWorldInv = /*@__PURE__*/ new Matrix4();
/**
 * A helper object to assist with visualizing a {@link Skeleton}.
 *
 * ```js
 * const helper = new THREE.SkeletonHelper( skinnedMesh );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class SkeletonHelper extends LineSegments {
    /**
	 * Constructs a new skeleton helper.
	 *
	 * @param {Object3D} object -  Usually an instance of {@link SkinnedMesh}. However, any 3D object
	 * can be used if it represents a hierarchy of bones (see {@link Bone}).
	 */ constructor(object){
        const bones = getBoneList(object);
        const geometry = new BufferGeometry();
        const vertices = [];
        const colors = [];
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(0, 0, 0);
                colors.push(0, 0, 0);
            }
        }
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        const material = new LineBasicMaterial({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        /**
		 * This flag can be used for type testing.
		 *
		 * @type {boolean}
		 * @readonly
		 * @default true
		 */ this.isSkeletonHelper = true;
        this.type = 'SkeletonHelper';
        /**
		 * The object being visualized.
		 *
		 * @type {Object3D}
		 */ this.root = object;
        /**
		 * The list of bones that the helper visualizes.
		 *
		 * @type {Array<Bone>}
		 */ this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
        // colors
        const color1 = new Color(0x0000ff);
        const color2 = new Color(0x00ff00);
        this.setColors(color1, color2);
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        _matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.matrixWorld);
                _vector$2.setFromMatrixPosition(_boneMatrix);
                position.setXYZ(j, _vector$2.x, _vector$2.y, _vector$2.z);
                _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.parent.matrixWorld);
                _vector$2.setFromMatrixPosition(_boneMatrix);
                position.setXYZ(j + 1, _vector$2.x, _vector$2.y, _vector$2.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} color1 - The first line color for each bone.
	 * @param {Color} color2 - The second line color for each bone.
	 * @return {SkeletonHelper} A reference to this helper.
	 */ setColors(color1, color2) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        for(let i = 0; i < colorAttribute.count; i += 2){
            colorAttribute.setXYZ(i, color1.r, color1.g, color1.b);
            colorAttribute.setXYZ(i + 1, color2.r, color2.g, color2.b);
        }
        colorAttribute.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function getBoneList(object) {
    const boneList = [];
    if (object.isBone === true) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push(...getBoneList(object.children[i]));
    return boneList;
}
/**
 * This displays a helper object consisting of a spherical mesh for
 * visualizing an instance of {@link PointLight}.
 *
 * ```js
 * const pointLight = new THREE.PointLight( 0xff0000, 1, 100 );
 * pointLight.position.set( 10, 10, 10 );
 * scene.add( pointLight );
 *
 * const sphereSize = 1;
 * const pointLightHelper = new THREE.PointLightHelper( pointLight, sphereSize );
 * scene.add( pointLightHelper );
 * ```
 *
 * @augments Mesh
 */ class PointLightHelper extends Mesh {
    /**
	 * Constructs a new point light helper.
	 *
	 * @param {PointLight} light - The light to be visualized.
	 * @param {number} [sphereSize=1] - The size of the sphere helper.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, sphereSize, color){
        const geometry = new SphereGeometry(sphereSize, 4, 2);
        const material = new MeshBasicMaterial({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        /**
		 * The light being visualized.
		 *
		 * @type {PointLight}
		 */ this.light = light;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    /**
	 * Updates the helper to match the position of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const _vector$1 = /*@__PURE__*/ new Vector3();
const _color1 = /*@__PURE__*/ new Color();
const _color2 = /*@__PURE__*/ new Color();
/**
 * Creates a visual aid consisting of a spherical mesh for a
 * given {@link HemisphereLight}.
 *
 * ```js
 * const light = new THREE.HemisphereLight( 0xffffbb, 0x080820, 1 );
 * const helper = new THREE.HemisphereLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class HemisphereLightHelper extends Object3D {
    /**
	 * Constructs a new hemisphere light helper.
	 *
	 * @param {HemisphereLight} light - The light to be visualized.
	 * @param {number} [size=1] - The size of the mesh used to visualize the light.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {HemisphereLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'HemisphereLightHelper';
        const geometry = new OctahedronGeometry(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new MeshBasicMaterial({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new BufferAttribute(colors, 3));
        this.add(new Mesh(geometry, this.material));
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            _color1.copy(this.light.color);
            _color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? _color1 : _color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        this.light.updateWorldMatrix(true, false);
        mesh.lookAt(_vector$1.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
/**
 * The helper is an object to define grids. Grids are two-dimensional
 * arrays of lines.
 *
 * ```js
 * const size = 10;
 * const divisions = 10;
 *
 * const gridHelper = new THREE.GridHelper( size, divisions );
 * scene.add( gridHelper );
 * ```
 *
 * @augments LineSegments
 */ class GridHelper extends LineSegments {
    /**
	 * Constructs a new grid helper.
	 *
	 * @param {number} [size=10] - The size of the grid.
	 * @param {number} [divisions=10] - The number of divisions across the grid.
	 * @param {number|Color|string} [color1=0x444444] - The color of the center line.
	 * @param {number|Color|string} [color2=0x888888] - The color of the lines of the grid.
	 */ constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new Color(color1);
        color2 = new Color(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        const material = new LineBasicMaterial({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This helper is an object to define polar grids. Grids are
 * two-dimensional arrays of lines.
 *
 * ```js
 * const radius = 10;
 * const sectors = 16;
 * const rings = 8;
 * const divisions = 64;
 *
 * const helper = new THREE.PolarGridHelper( radius, sectors, rings, divisions );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class PolarGridHelper extends LineSegments {
    /**
	 * Constructs a new polar grid helper.
	 *
	 * @param {number} [radius=10] - The radius of the polar grid. This can be any positive number.
	 * @param {number} [sectors=16] - The number of sectors the grid will be divided into. This can be any positive integer.
	 * @param {number} [rings=16] - The number of rings. This can be any positive integer.
	 * @param {number} [divisions=64] - The number of line segments used for each circle. This can be any positive integer.
	 * @param {number|Color|string} [color1=0x444444] - The first color used for grid elements.
	 * @param {number|Color|string} [color2=0x888888] -  The second color used for grid elements.
	 */ constructor(radius = 10, sectors = 16, rings = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new Color(color1);
        color2 = new Color(color2);
        const vertices = [];
        const colors = [];
        // create the sectors
        if (sectors > 1) for(let i = 0; i < sectors; i++){
            const v = i / sectors * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the rings
        for(let i = 0; i < rings; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / rings * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        const material = new LineBasicMaterial({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
const _v1 = /*@__PURE__*/ new Vector3();
const _v2 = /*@__PURE__*/ new Vector3();
const _v3 = /*@__PURE__*/ new Vector3();
/**
 * Helper object to assist with visualizing a {@link DirectionalLight}'s
 * effect on the scene. This consists of plane and a line representing the
 * light's position and direction.
 *
 * ```js
 * const light = new THREE.DirectionalLight( 0xFFFFFF );
 * scene.add( light );
 *
 * const helper = new THREE.DirectionalLightHelper( light, 5 );
 * scene.add( helper );
 * ```
 *
 * @augments Object3D
 */ class DirectionalLightHelper extends Object3D {
    /**
	 * Constructs a new directional light helper.
	 *
	 * @param {DirectionalLight} light - The light to be visualized.
	 * @param {number} [size=1] - The dimensions of the plane.
	 * @param {number|Color|string} [color] - The helper's color. If not set, the helper will take
	 * the color of the light.
	 */ constructor(light, size, color){
        super();
        /**
		 * The light being visualized.
		 *
		 * @type {DirectionalLight}
		 */ this.light = light;
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * The color parameter passed in the constructor.
		 * If not set, the helper will take the color of the light.
		 *
		 * @type {number|Color|string}
		 */ this.color = color;
        this.type = 'DirectionalLightHelper';
        if (size === undefined) size = 1;
        let geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new LineBasicMaterial({
            fog: false,
            toneMapped: false
        });
        /**
		 * Contains the line showing the location of the directional light.
		 *
		 * @type {Line}
		 */ this.lightPlane = new Line(geometry, material);
        this.add(this.lightPlane);
        geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        /**
		 * Represents the target line of the directional light.
		 *
		 * @type {Line}
		 */ this.targetLine = new Line(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ update() {
        this.light.updateWorldMatrix(true, false);
        this.light.target.updateWorldMatrix(true, false);
        _v1.setFromMatrixPosition(this.light.matrixWorld);
        _v2.setFromMatrixPosition(this.light.target.matrixWorld);
        _v3.subVectors(_v2, _v1);
        this.lightPlane.lookAt(_v2);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt(_v2);
        this.targetLine.scale.z = _v3.length();
    }
}
const _vector = /*@__PURE__*/ new Vector3();
const _camera = /*@__PURE__*/ new Camera();
/**
 * This helps with visualizing what a camera contains in its frustum. It
 * visualizes the frustum of a camera using a line segments.
 *
 * Based on frustum visualization in [lightgl.js shadowmap example](https://github.com/evanw/lightgl.js/blob/master/tests/shadowmap.html).
 *
 * `CameraHelper` must be a child of the scene.
 *
 * ```js
 * const camera = new THREE.PerspectiveCamera( 75, window.innerWidth / window.innerHeight, 0.1, 1000 );
 * const helper = new THREE.CameraHelper( camera );
 * scene.add( helper );
 * ```
 *
 * @augments LineSegments
 */ class CameraHelper extends LineSegments {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Camera} camera - The camera to visualize.
	 */ constructor(camera){
        const geometry = new BufferGeometry();
        const material = new LineBasicMaterial({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // near
        addLine('n1', 'n2');
        addLine('n2', 'n4');
        addLine('n4', 'n3');
        addLine('n3', 'n1');
        // far
        addLine('f1', 'f2');
        addLine('f2', 'f4');
        addLine('f4', 'f3');
        addLine('f3', 'f1');
        // sides
        addLine('n1', 'f1');
        addLine('n2', 'f2');
        addLine('n3', 'f3');
        addLine('n4', 'f4');
        // cone
        addLine('p', 'n1');
        addLine('p', 'n2');
        addLine('p', 'n3');
        addLine('p', 'n4');
        // up
        addLine('u1', 'u2');
        addLine('u2', 'u3');
        addLine('u3', 'u1');
        // target
        addLine('c', 't');
        addLine('p', 'c');
        // cross
        addLine('cn1', 'cn2');
        addLine('cn3', 'cn4');
        addLine('cf1', 'cf2');
        addLine('cf3', 'cf4');
        function addLine(a, b) {
            addPoint(a);
            addPoint(b);
        }
        function addPoint(id) {
            vertices.push(0, 0, 0);
            colors.push(0, 0, 0);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        /**
		 * The camera being visualized.
		 *
		 * @type {Camera}
		 */ this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        /**
		 * This contains the points used to visualize the camera.
		 *
		 * @type {Object<string,Array<number>>}
		 */ this.pointMap = pointMap;
        this.update();
        // colors
        const colorFrustum = new Color(0xffaa00);
        const colorCone = new Color(0xff0000);
        const colorUp = new Color(0x00aaff);
        const colorTarget = new Color(0xffffff);
        const colorCross = new Color(0x333333);
        this.setColors(colorFrustum, colorCone, colorUp, colorTarget, colorCross);
    }
    /**
	 * Defines the colors of the helper.
	 *
	 * @param {Color} frustum - The frustum line color.
	 * @param {Color} cone - The cone line color.
	 * @param {Color} up - The up line color.
	 * @param {Color} target - The target line color.
	 * @param {Color} cross - The cross line color.
	 * @return {CameraHelper} A reference to this helper.
	 */ setColors(frustum, cone, up, target, cross) {
        const geometry = this.geometry;
        const colorAttribute = geometry.getAttribute('color');
        // near
        colorAttribute.setXYZ(0, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(1, frustum.r, frustum.g, frustum.b); // n1, n2
        colorAttribute.setXYZ(2, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(3, frustum.r, frustum.g, frustum.b); // n2, n4
        colorAttribute.setXYZ(4, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(5, frustum.r, frustum.g, frustum.b); // n4, n3
        colorAttribute.setXYZ(6, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(7, frustum.r, frustum.g, frustum.b); // n3, n1
        // far
        colorAttribute.setXYZ(8, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(9, frustum.r, frustum.g, frustum.b); // f1, f2
        colorAttribute.setXYZ(10, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(11, frustum.r, frustum.g, frustum.b); // f2, f4
        colorAttribute.setXYZ(12, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(13, frustum.r, frustum.g, frustum.b); // f4, f3
        colorAttribute.setXYZ(14, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(15, frustum.r, frustum.g, frustum.b); // f3, f1
        // sides
        colorAttribute.setXYZ(16, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(17, frustum.r, frustum.g, frustum.b); // n1, f1
        colorAttribute.setXYZ(18, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(19, frustum.r, frustum.g, frustum.b); // n2, f2
        colorAttribute.setXYZ(20, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(21, frustum.r, frustum.g, frustum.b); // n3, f3
        colorAttribute.setXYZ(22, frustum.r, frustum.g, frustum.b);
        colorAttribute.setXYZ(23, frustum.r, frustum.g, frustum.b); // n4, f4
        // cone
        colorAttribute.setXYZ(24, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(25, cone.r, cone.g, cone.b); // p, n1
        colorAttribute.setXYZ(26, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(27, cone.r, cone.g, cone.b); // p, n2
        colorAttribute.setXYZ(28, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(29, cone.r, cone.g, cone.b); // p, n3
        colorAttribute.setXYZ(30, cone.r, cone.g, cone.b);
        colorAttribute.setXYZ(31, cone.r, cone.g, cone.b); // p, n4
        // up
        colorAttribute.setXYZ(32, up.r, up.g, up.b);
        colorAttribute.setXYZ(33, up.r, up.g, up.b); // u1, u2
        colorAttribute.setXYZ(34, up.r, up.g, up.b);
        colorAttribute.setXYZ(35, up.r, up.g, up.b); // u2, u3
        colorAttribute.setXYZ(36, up.r, up.g, up.b);
        colorAttribute.setXYZ(37, up.r, up.g, up.b); // u3, u1
        // target
        colorAttribute.setXYZ(38, target.r, target.g, target.b);
        colorAttribute.setXYZ(39, target.r, target.g, target.b); // c, t
        colorAttribute.setXYZ(40, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(41, cross.r, cross.g, cross.b); // p, c
        // cross
        colorAttribute.setXYZ(42, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(43, cross.r, cross.g, cross.b); // cn1, cn2
        colorAttribute.setXYZ(44, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(45, cross.r, cross.g, cross.b); // cn3, cn4
        colorAttribute.setXYZ(46, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(47, cross.r, cross.g, cross.b); // cf1, cf2
        colorAttribute.setXYZ(48, cross.r, cross.g, cross.b);
        colorAttribute.setXYZ(49, cross.r, cross.g, cross.b); // cf3, cf4
        colorAttribute.needsUpdate = true;
        return this;
    }
    /**
	 * Updates the helper based on the projection matrix of the camera.
	 */ update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        let nearZ, farZ;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        _camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // Adjust z values based on coordinate system
        if (this.camera.reversedDepth === true) {
            nearZ = 1;
            farZ = 0;
        } else {
            if (this.camera.coordinateSystem === WebGLCoordinateSystem) {
                nearZ = -1;
                farZ = 1;
            } else if (this.camera.coordinateSystem === WebGPUCoordinateSystem) {
                nearZ = 0;
                farZ = 1;
            } else throw new Error('THREE.CameraHelper.update(): Invalid coordinate system: ' + this.camera.coordinateSystem);
        }
        // center / target
        setPoint('c', pointMap, geometry, _camera, 0, 0, nearZ);
        setPoint('t', pointMap, geometry, _camera, 0, 0, farZ);
        // near
        setPoint('n1', pointMap, geometry, _camera, -w, -h, nearZ);
        setPoint('n2', pointMap, geometry, _camera, w, -h, nearZ);
        setPoint('n3', pointMap, geometry, _camera, -w, h, nearZ);
        setPoint('n4', pointMap, geometry, _camera, w, h, nearZ);
        // far
        setPoint('f1', pointMap, geometry, _camera, -w, -h, farZ);
        setPoint('f2', pointMap, geometry, _camera, w, -h, farZ);
        setPoint('f3', pointMap, geometry, _camera, -w, h, farZ);
        setPoint('f4', pointMap, geometry, _camera, w, h, farZ);
        // up
        setPoint('u1', pointMap, geometry, _camera, w * 0.7, h * 1.1, nearZ);
        setPoint('u2', pointMap, geometry, _camera, -w * 0.7, h * 1.1, nearZ);
        setPoint('u3', pointMap, geometry, _camera, 0, h * 2, nearZ);
        // cross
        setPoint('cf1', pointMap, geometry, _camera, -w, 0, farZ);
        setPoint('cf2', pointMap, geometry, _camera, w, 0, farZ);
        setPoint('cf3', pointMap, geometry, _camera, 0, -h, farZ);
        setPoint('cf4', pointMap, geometry, _camera, 0, h, farZ);
        setPoint('cn1', pointMap, geometry, _camera, -w, 0, nearZ);
        setPoint('cn2', pointMap, geometry, _camera, w, 0, nearZ);
        setPoint('cn3', pointMap, geometry, _camera, 0, -h, nearZ);
        setPoint('cn4', pointMap, geometry, _camera, 0, h, nearZ);
        geometry.getAttribute('position').needsUpdate = true;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
function setPoint(point, pointMap, geometry, camera, x, y, z) {
    _vector.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], _vector.x, _vector.y, _vector.z);
    }
}
const _box = /*@__PURE__*/ new Box3();
/**
 * Helper object to graphically show the world-axis-aligned bounding box
 * around an object. The actual bounding box is handled with {@link Box3},
 * this is just a visual helper for debugging. It can be automatically
 * resized with {@link BoxHelper#update} when the object it's created from
 * is transformed. Note that the object must have a geometry for this to work,
 * so it won't work with sprites.
 *
 * ```js
 * const sphere = new THREE.SphereGeometry();
 * const object = new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( 0xff0000 ) );
 * const box = new THREE.BoxHelper( object, 0xffff00 );
 * scene.add( box );
 * ```
 *
 * @augments LineSegments
 */ class BoxHelper extends LineSegments {
    /**
	 * Constructs a new box helper.
	 *
	 * @param {Object3D} [object] - The 3D object to show the world-axis-aligned bounding box.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new BufferGeometry();
        geometry.setIndex(new BufferAttribute(indices, 1));
        geometry.setAttribute('position', new BufferAttribute(positions, 3));
        super(geometry, new LineBasicMaterial({
            color: color,
            toneMapped: false
        }));
        /**
		 * The 3D object being visualized.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    /**
	 * Updates the helper's geometry to match the dimensions of the object,
	 * including any children.
	 */ update() {
        if (this.object !== undefined) _box.setFromObject(this.object);
        if (_box.isEmpty()) return;
        const min = _box.min;
        const max = _box.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    /**
	 * Updates the wireframe box for the passed object.
	 *
	 * @param {Object3D} object - The 3D object to create the helper for.
	 * @return {BoxHelper} A reference to this instance.
	 */ setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        this.object = source.object;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Box3}.
 *
 * ```js
 * const box = new THREE.Box3();
 * box.setFromCenterAndSize( new THREE.Vector3( 1, 1, 1 ), new THREE.Vector3( 2, 1, 3 ) );
 *
 * const helper = new THREE.Box3Helper( box, 0xffff00 );
 * scene.add( helper )
 * ```
 *
 * @augments LineSegments
 */ class Box3Helper extends LineSegments {
    /**
	 * Constructs a new box3 helper.
	 *
	 * @param {Box3} box - The box to visualize.
	 * @param {number|Color|string} [color=0xffff00] - The box's color.
	 */ constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new BufferGeometry();
        geometry.setIndex(new BufferAttribute(indices, 1));
        geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));
        super(geometry, new LineBasicMaterial({
            color: color,
            toneMapped: false
        }));
        /**
		 * The box being visualized.
		 *
		 * @type {Box3}
		 */ this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * A helper object to visualize an instance of {@link Plane}.
 *
 * ```js
 * const plane = new THREE.Plane( new THREE.Vector3( 1, 1, 0.2 ), 3 );
 * const helper = new THREE.PlaneHelper( plane, 1, 0xffff00 );
 * scene.add( helper );
 * ```
 *
 * @augments Line
 */ class PlaneHelper extends Line {
    /**
	 * Constructs a new plane helper.
	 *
	 * @param {Plane} plane - The plane to be visualized.
	 * @param {number} [size=1] - The side length of plane helper.
	 * @param {number|Color|string} [hex=0xffff00] - The helper's color.
	 */ constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0,
            1,
            1,
            0
        ];
        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new LineBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        /**
		 * The plane being visualized.
		 *
		 * @type {Plane}
		 */ this.plane = plane;
        /**
		 * The side length of plane helper.
		 *
		 * @type {number}
		 * @default 1
		 */ this.size = size;
        const positions2 = [
            1,
            1,
            0,
            -1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            1,
            0,
            -1,
            -1,
            0,
            1,
            -1,
            0
        ];
        const geometry2 = new BufferGeometry();
        geometry2.setAttribute('position', new Float32BufferAttribute(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new Mesh(geometry2, new MeshBasicMaterial({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        this.position.set(0, 0, 0);
        this.scale.set(0.5 * this.size, 0.5 * this.size, 1);
        this.lookAt(this.plane.normal);
        this.translateZ(-this.plane.constant);
        super.updateMatrixWorld(force);
    }
    /**
	 * Updates the helper to match the position and direction of the
	 * light being visualized.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
}
const _axis = /*@__PURE__*/ new Vector3();
let _lineGeometry, _coneGeometry;
/**
 * An 3D arrow object for visualizing directions.
 *
 * ```js
 * const dir = new THREE.Vector3( 1, 2, 0 );
 *
 * //normalize the direction vector (convert to vector of length 1)
 * dir.normalize();
 *
 * const origin = new THREE.Vector3( 0, 0, 0 );
 * const length = 1;
 * const hex = 0xffff00;
 *
 * const arrowHelper = new THREE.ArrowHelper( dir, origin, length, hex );
 * scene.add( arrowHelper );
 * ```
 *
 * @augments Object3D
 */ class ArrowHelper extends Object3D {
    /**
	 * Constructs a new arrow helper.
	 *
	 * @param {Vector3} [dir=(0, 0, 1)] - The (normalized) direction vector.
	 * @param {Vector3} [origin=(0, 0, 0)] - Point at which the arrow starts.
	 * @param {number} [length=1] - Length of the arrow in world units.
	 * @param {(number|Color|string)} [color=0xffff00] - Color of the arrow.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ constructor(dir = new Vector3(0, 0, 1), origin = new Vector3(0, 0, 0), length = 1, color = 0xffff00, headLength = length * 0.2, headWidth = headLength * 0.2){
        super();
        this.type = 'ArrowHelper';
        if (_lineGeometry === undefined) {
            _lineGeometry = new BufferGeometry();
            _lineGeometry.setAttribute('position', new Float32BufferAttribute([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            _coneGeometry = new ConeGeometry(0.5, 1, 5, 1);
            _coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        /**
		 * The line part of the arrow helper.
		 *
		 * @type {Line}
		 */ this.line = new Line(_lineGeometry, new LineBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        /**
		 * The cone part of the arrow helper.
		 *
		 * @type {Mesh}
		 */ this.cone = new Mesh(_coneGeometry, new MeshBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    /**
	 * Sets the direction of the helper.
	 *
	 * @param {Vector3} dir - The normalized direction vector.
	 */ setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            _axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle(_axis, radians);
        }
    }
    /**
	 * Sets the length of the helper.
	 *
	 * @param {number} length - Length of the arrow in world units.
	 * @param {number} [headLength=length*0.2] - The length of the head of the arrow.
	 * @param {number} [headWidth=headLength*0.2] - The width of the head of the arrow.
	 */ setLength(length, headLength = length * 0.2, headWidth = headLength * 0.2) {
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    /**
	 * Sets the color of the helper.
	 *
	 * @param {number|Color|string} color - The color to set.
	 */ setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.line.geometry.dispose();
        this.line.material.dispose();
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
}
/**
 * An axis object to visualize the 3 axes in a simple way.
 * The X axis is red. The Y axis is green. The Z axis is blue.
 *
 * ```js
 * const axesHelper = new THREE.AxesHelper( 5 );
 * scene.add( axesHelper );
 * ```
 *
 * @augments LineSegments
 */ class AxesHelper extends LineSegments {
    /**
	 * Constructs a new axes helper.
	 *
	 * @param {number} [size=1] - Size of the lines representing the axes.
	 */ constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        const material = new LineBasicMaterial({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
    /**
	 * Defines the colors of the axes helper.
	 *
	 * @param {number|Color|string} xAxisColor - The color for the x axis.
	 * @param {number|Color|string} yAxisColor - The color for the y axis.
	 * @param {number|Color|string} zAxisColor - The color for the z axis.
	 * @return {AxesHelper} A reference to this axes helper.
	 */ setColors(xAxisColor, yAxisColor, zAxisColor) {
        const color = new Color();
        const array = this.geometry.attributes.color.array;
        color.set(xAxisColor);
        color.toArray(array, 0);
        color.toArray(array, 3);
        color.set(yAxisColor);
        color.toArray(array, 6);
        color.toArray(array, 9);
        color.set(zAxisColor);
        color.toArray(array, 12);
        color.toArray(array, 15);
        this.geometry.attributes.color.needsUpdate = true;
        return this;
    }
    /**
	 * Frees the GPU-related resources allocated by this instance. Call this
	 * method whenever this instance is no longer used in your app.
	 */ dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
}
/**
 * This class is used to convert a series of paths to an array of
 * shapes. It is specifically used in context of fonts and SVG.
 */ class ShapePath {
    /**
	 * Constructs a new shape path.
	 */ constructor(){
        this.type = 'ShapePath';
        /**
		 * The color of the shape.
		 *
		 * @type {Color}
		 */ this.color = new Color();
        /**
		 * The paths that have been generated for this shape.
		 *
		 * @type {Array<Path>}
		 * @default null
		 */ this.subPaths = [];
        /**
		 * The current path that is being generated.
		 *
		 * @type {?Path}
		 * @default null
		 */ this.currentPath = null;
    }
    /**
	 * Creates a new path and moves it current point to the given one.
	 *
	 * @param {number} x - The x coordinate.
	 * @param {number} y - The y coordinate.
	 * @return {ShapePath} A reference to this shape path.
	 */ moveTo(x, y) {
        this.currentPath = new Path();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link LineCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} x - The x coordinate of the end point.
	 * @param {number} y - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ lineTo(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    }
    /**
	 * Adds an instance of {@link QuadraticBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCPx - The x coordinate of the control point.
	 * @param {number} aCPy - The y coordinate of the control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ quadraticCurveTo(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link CubicBezierCurve} to the path by connecting
	 * the current point with the given one.
	 *
	 * @param {number} aCP1x - The x coordinate of the first control point.
	 * @param {number} aCP1y - The y coordinate of the first control point.
	 * @param {number} aCP2x - The x coordinate of the second control point.
	 * @param {number} aCP2y - The y coordinate of the second control point.
	 * @param {number} aX - The x coordinate of the end point.
	 * @param {number} aY - The y coordinate of the end point.
	 * @return {ShapePath} A reference to this shape path.
	 */ bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    }
    /**
	 * Adds an instance of {@link SplineCurve} to the path by connecting
	 * the current point with the given list of points.
	 *
	 * @param {Array<Vector2>} pts - An array of points in 2D space.
	 * @return {ShapePath} A reference to this shape path.
	 */ splineThru(pts) {
        this.currentPath.splineThru(pts);
        return this;
    }
    /**
	 * Converts the paths into an array of shapes.
	 *
	 * @param {boolean} isCCW - By default solid shapes are  defined clockwise (CW) and holes are defined counterclockwise (CCW).
	 * If this flag is set to `true`, then those are flipped.
	 * @return {Array<Shape>} An array of shapes.
	 */ toShapes(isCCW) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new Shape();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = ShapeUtils.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new Shape();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new Shape(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            let toChange = 0;
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange++;
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            if (toChange > 0 && ambiguous === false) newShapeHoles = betterShapeHoles;
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //log("shape", shapes);
        return shapes;
    }
}
/**
 * Abstract base class for controls.
 *
 * @abstract
 * @augments EventDispatcher
 */ class Controls extends EventDispatcher {
    /**
	 * Constructs a new controls instance.
	 *
	 * @param {Object3D} object - The object that is managed by the controls.
	 * @param {?HTMLElement} domElement - The HTML element used for event listeners.
	 */ constructor(object, domElement = null){
        super();
        /**
		 * The object that is managed by the controls.
		 *
		 * @type {Object3D}
		 */ this.object = object;
        /**
		 * The HTML element used for event listeners.
		 *
		 * @type {?HTMLElement}
		 * @default null
		 */ this.domElement = domElement;
        /**
		 * Whether the controls responds to user input or not.
		 *
		 * @type {boolean}
		 * @default true
		 */ this.enabled = true;
        /**
		 * The internal state of the controls.
		 *
		 * @type {number}
		 * @default -1
		 */ this.state = -1;
        /**
		 * This object defines the keyboard input of the controls.
		 *
		 * @type {Object}
		 */ this.keys = {};
        /**
		 * This object defines what type of actions are assigned to the available mouse buttons.
		 * It depends on the control implementation what kind of mouse buttons and actions are supported.
		 *
		 * @type {{LEFT: ?number, MIDDLE: ?number, RIGHT: ?number}}
		 */ this.mouseButtons = {
            LEFT: null,
            MIDDLE: null,
            RIGHT: null
        };
        /**
		 * This object defines what type of actions are assigned to what kind of touch interaction.
		 * It depends on the control implementation what kind of touch interaction and actions are supported.
		 *
		 * @type {{ONE: ?number, TWO: ?number}}
		 */ this.touches = {
            ONE: null,
            TWO: null
        };
    }
    /**
	 * Connects the controls to the DOM. This method has so called "side effects" since
	 * it adds the module's event listeners to the DOM.
	 *
	 * @param {HTMLElement} element - The DOM element to connect to.
	 */ connect(element) {
        if (element === undefined) {
            warn('Controls: connect() now requires an element.'); // @deprecated, the warning can be removed with r185
            return;
        }
        if (this.domElement !== null) this.disconnect();
        this.domElement = element;
    }
    /**
	 * Disconnects the controls from the DOM.
	 */ disconnect() {}
    /**
	 * Call this method if you no longer want use to the controls. It frees all internal
	 * resources and removes all event listeners.
	 */ dispose() {}
    /**
	 * Controls should implement this method if they have to update their internal state
	 * per simulation step.
	 *
	 * @param {number} [delta] - The time delta in seconds.
	 */ update() {}
}
/**
 * Scales the texture as large as possible within its surface without cropping
 * or stretching the texture. The method preserves the original aspect ratio of
 * the texture. Akin to CSS `object-fit: contain`
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function contain(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    } else {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    }
    return texture;
}
/**
 * Scales the texture to the smallest possible size to fill the surface, leaving
 * no empty space. The method preserves the original aspect ratio of the texture.
 * Akin to CSS `object-fit: cover`.
 *
 * @param {Texture} texture - The texture.
 * @param {number} aspect - The texture's aspect ratio.
 * @return {Texture} The updated texture.
 */ function cover(texture, aspect) {
    const imageAspect = texture.image && texture.image.width ? texture.image.width / texture.image.height : 1;
    if (imageAspect > aspect) {
        texture.repeat.x = aspect / imageAspect;
        texture.repeat.y = 1;
        texture.offset.x = (1 - texture.repeat.x) / 2;
        texture.offset.y = 0;
    } else {
        texture.repeat.x = 1;
        texture.repeat.y = imageAspect / aspect;
        texture.offset.x = 0;
        texture.offset.y = (1 - texture.repeat.y) / 2;
    }
    return texture;
}
/**
 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
 *
 * @param {Texture} texture - The texture.
 * @return {Texture} The updated texture.
 */ function fill(texture) {
    texture.repeat.x = 1;
    texture.repeat.y = 1;
    texture.offset.x = 0;
    texture.offset.y = 0;
    return texture;
}
/**
 * Determines how many bytes must be used to represent the texture.
 *
 * @param {number} width - The width of the texture.
 * @param {number} height - The height of the texture.
 * @param {number} format - The texture's format.
 * @param {number} type - The texture's type.
 * @return {number} The byte length.
 */ function getByteLength(width, height, format, type) {
    const typeByteLength = getTextureTypeByteLength(type);
    switch(format){
        // https://registry.khronos.org/OpenGL-Refpages/es3.0/html/glTexImage2D.xhtml
        case AlphaFormat:
            return width * height;
        case RedFormat:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case RedIntegerFormat:
            return width * height / typeByteLength.components * typeByteLength.byteLength;
        case RGFormat:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case RGIntegerFormat:
            return width * height * 2 / typeByteLength.components * typeByteLength.byteLength;
        case RGBFormat:
            return width * height * 3 / typeByteLength.components * typeByteLength.byteLength;
        case RGBAFormat:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        case RGBAIntegerFormat:
            return width * height * 4 / typeByteLength.components * typeByteLength.byteLength;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_s3tc_srgb/
        case RGB_S3TC_DXT1_Format:
        case RGBA_S3TC_DXT1_Format:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case RGBA_S3TC_DXT3_Format:
        case RGBA_S3TC_DXT5_Format:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_pvrtc/
        case RGB_PVRTC_2BPPV1_Format:
        case RGBA_PVRTC_2BPPV1_Format:
            return Math.max(width, 16) * Math.max(height, 8) / 4;
        case RGB_PVRTC_4BPPV1_Format:
        case RGBA_PVRTC_4BPPV1_Format:
            return Math.max(width, 8) * Math.max(height, 8) / 2;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_etc/
        case RGB_ETC1_Format:
        case RGB_ETC2_Format:
        case R11_EAC_Format:
        case SIGNED_R11_EAC_Format:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 8;
        case RGBA_ETC2_EAC_Format:
        case RG11_EAC_Format:
        case SIGNED_RG11_EAC_Format:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/WEBGL_compressed_texture_astc/
        case RGBA_ASTC_4x4_Format:
            return Math.floor((width + 3) / 4) * Math.floor((height + 3) / 4) * 16;
        case RGBA_ASTC_5x4_Format:
            return Math.floor((width + 4) / 5) * Math.floor((height + 3) / 4) * 16;
        case RGBA_ASTC_5x5_Format:
            return Math.floor((width + 4) / 5) * Math.floor((height + 4) / 5) * 16;
        case RGBA_ASTC_6x5_Format:
            return Math.floor((width + 5) / 6) * Math.floor((height + 4) / 5) * 16;
        case RGBA_ASTC_6x6_Format:
            return Math.floor((width + 5) / 6) * Math.floor((height + 5) / 6) * 16;
        case RGBA_ASTC_8x5_Format:
            return Math.floor((width + 7) / 8) * Math.floor((height + 4) / 5) * 16;
        case RGBA_ASTC_8x6_Format:
            return Math.floor((width + 7) / 8) * Math.floor((height + 5) / 6) * 16;
        case RGBA_ASTC_8x8_Format:
            return Math.floor((width + 7) / 8) * Math.floor((height + 7) / 8) * 16;
        case RGBA_ASTC_10x5_Format:
            return Math.floor((width + 9) / 10) * Math.floor((height + 4) / 5) * 16;
        case RGBA_ASTC_10x6_Format:
            return Math.floor((width + 9) / 10) * Math.floor((height + 5) / 6) * 16;
        case RGBA_ASTC_10x8_Format:
            return Math.floor((width + 9) / 10) * Math.floor((height + 7) / 8) * 16;
        case RGBA_ASTC_10x10_Format:
            return Math.floor((width + 9) / 10) * Math.floor((height + 9) / 10) * 16;
        case RGBA_ASTC_12x10_Format:
            return Math.floor((width + 11) / 12) * Math.floor((height + 9) / 10) * 16;
        case RGBA_ASTC_12x12_Format:
            return Math.floor((width + 11) / 12) * Math.floor((height + 11) / 12) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_bptc/
        case RGBA_BPTC_Format:
        case RGB_BPTC_SIGNED_Format:
        case RGB_BPTC_UNSIGNED_Format:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
        // https://registry.khronos.org/webgl/extensions/EXT_texture_compression_rgtc/
        case RED_RGTC1_Format:
        case SIGNED_RED_RGTC1_Format:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 8;
        case RED_GREEN_RGTC2_Format:
        case SIGNED_RED_GREEN_RGTC2_Format:
            return Math.ceil(width / 4) * Math.ceil(height / 4) * 16;
    }
    throw new Error(`Unable to determine texture byte length for ${format} format.`);
}
function getTextureTypeByteLength(type) {
    switch(type){
        case UnsignedByteType:
        case ByteType:
            return {
                byteLength: 1,
                components: 1
            };
        case UnsignedShortType:
        case ShortType:
        case HalfFloatType:
            return {
                byteLength: 2,
                components: 1
            };
        case UnsignedShort4444Type:
        case UnsignedShort5551Type:
            return {
                byteLength: 2,
                components: 4
            };
        case UnsignedIntType:
        case IntType:
        case FloatType:
            return {
                byteLength: 4,
                components: 1
            };
        case UnsignedInt5999Type:
        case UnsignedInt101111Type:
            return {
                byteLength: 4,
                components: 3
            };
    }
    throw new Error(`Unknown texture type ${type}.`);
}
/**
 * A class containing utility functions for textures.
 *
 * @hideconstructor
 */ class TextureUtils {
    /**
	 * Scales the texture as large as possible within its surface without cropping
	 * or stretching the texture. The method preserves the original aspect ratio of
	 * the texture. Akin to CSS `object-fit: contain`
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static contain(texture, aspect) {
        return contain(texture, aspect);
    }
    /**
	 * Scales the texture to the smallest possible size to fill the surface, leaving
	 * no empty space. The method preserves the original aspect ratio of the texture.
	 * Akin to CSS `object-fit: cover`.
	 *
	 * @param {Texture} texture - The texture.
	 * @param {number} aspect - The texture's aspect ratio.
	 * @return {Texture} The updated texture.
	 */ static cover(texture, aspect) {
        return cover(texture, aspect);
    }
    /**
	 * Configures the texture to the default transformation. Akin to CSS `object-fit: fill`.
	 *
	 * @param {Texture} texture - The texture.
	 * @return {Texture} The updated texture.
	 */ static fill(texture) {
        return fill(texture);
    }
    /**
	 * Determines how many bytes must be used to represent the texture.
	 *
	 * @param {number} width - The width of the texture.
	 * @param {number} height - The height of the texture.
	 * @param {number} format - The texture's format.
	 * @param {number} type - The texture's type.
	 * @return {number} The byte length.
	 */ static getByteLength(width, height, format, type) {
        return getByteLength(width, height, format, type);
    }
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: REVISION
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = REVISION;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gflFk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GLTFLoader", ()=>GLTFLoader);
var _three = require("three");
var _bufferGeometryUtilsJs = require("../utils/BufferGeometryUtils.js");
var _constantsJs = require("../_polyfill/constants.js");
var _loaderUtilsJs = require("../_polyfill/LoaderUtils.js");
const SRGBColorSpace = "srgb";
const LinearSRGBColorSpace = "srgb-linear";
const sRGBEncoding = 3001;
const LinearEncoding = 3e3;
class GLTFLoader extends (0, _three.Loader) {
    constructor(manager){
        super(manager);
        this.dracoLoader = null;
        this.ktx2Loader = null;
        this.meshoptDecoder = null;
        this.pluginCallbacks = [];
        this.register(function(parser) {
            return new GLTFMaterialsClearcoatExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFMaterialsDispersionExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFTextureBasisUExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFTextureWebPExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFTextureAVIFExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFMaterialsSheenExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFMaterialsTransmissionExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFMaterialsVolumeExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFMaterialsIorExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFMaterialsEmissiveStrengthExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFMaterialsSpecularExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFMaterialsIridescenceExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFMaterialsAnisotropyExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFMaterialsBumpExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFLightsExtension(parser);
        });
        this.register(function(parser) {
            return new GLTFMeshoptCompression(parser);
        });
        this.register(function(parser) {
            return new GLTFMeshGpuInstancing(parser);
        });
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        let resourcePath;
        if (this.resourcePath !== "") resourcePath = this.resourcePath;
        else if (this.path !== "") {
            const relativeUrl = (0, _three.LoaderUtils).extractUrlBase(url);
            resourcePath = (0, _three.LoaderUtils).resolveURL(relativeUrl, this.path);
        } else resourcePath = (0, _three.LoaderUtils).extractUrlBase(url);
        this.manager.itemStart(url);
        const _onError = function(e) {
            if (onError) onError(e);
            else console.error(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        };
        const loader = new (0, _three.FileLoader)(this.manager);
        loader.setPath(this.path);
        loader.setResponseType("arraybuffer");
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(data) {
            try {
                scope.parse(data, resourcePath, function(gltf) {
                    onLoad(gltf);
                    scope.manager.itemEnd(url);
                }, _onError);
            } catch (e) {
                _onError(e);
            }
        }, onProgress, _onError);
    }
    setDRACOLoader(dracoLoader) {
        this.dracoLoader = dracoLoader;
        return this;
    }
    setDDSLoader() {
        throw new Error('THREE.GLTFLoader: "MSFT_texture_dds" no longer supported. Please update to "KHR_texture_basisu".');
    }
    setKTX2Loader(ktx2Loader) {
        this.ktx2Loader = ktx2Loader;
        return this;
    }
    setMeshoptDecoder(meshoptDecoder) {
        this.meshoptDecoder = meshoptDecoder;
        return this;
    }
    register(callback) {
        if (this.pluginCallbacks.indexOf(callback) === -1) this.pluginCallbacks.push(callback);
        return this;
    }
    unregister(callback) {
        if (this.pluginCallbacks.indexOf(callback) !== -1) this.pluginCallbacks.splice(this.pluginCallbacks.indexOf(callback), 1);
        return this;
    }
    parse(data, path, onLoad, onError) {
        let json;
        const extensions = {};
        const plugins = {};
        if (typeof data === "string") json = JSON.parse(data);
        else if (data instanceof ArrayBuffer) {
            const magic = (0, _loaderUtilsJs.decodeText)(new Uint8Array(data.slice(0, 4)));
            if (magic === BINARY_EXTENSION_HEADER_MAGIC) {
                try {
                    extensions[EXTENSIONS.KHR_BINARY_GLTF] = new GLTFBinaryExtension(data);
                } catch (error) {
                    if (onError) onError(error);
                    return;
                }
                json = JSON.parse(extensions[EXTENSIONS.KHR_BINARY_GLTF].content);
            } else json = JSON.parse((0, _loaderUtilsJs.decodeText)(new Uint8Array(data)));
        } else json = data;
        if (json.asset === void 0 || json.asset.version[0] < 2) {
            if (onError) onError(new Error("THREE.GLTFLoader: Unsupported asset. glTF versions >=2.0 are supported."));
            return;
        }
        const parser = new GLTFParser(json, {
            path: path || this.resourcePath || "",
            crossOrigin: this.crossOrigin,
            requestHeader: this.requestHeader,
            manager: this.manager,
            ktx2Loader: this.ktx2Loader,
            meshoptDecoder: this.meshoptDecoder
        });
        parser.fileLoader.setRequestHeader(this.requestHeader);
        for(let i = 0; i < this.pluginCallbacks.length; i++){
            const plugin = this.pluginCallbacks[i](parser);
            if (!plugin.name) console.error("THREE.GLTFLoader: Invalid plugin found: missing name");
            plugins[plugin.name] = plugin;
            extensions[plugin.name] = true;
        }
        if (json.extensionsUsed) for(let i = 0; i < json.extensionsUsed.length; ++i){
            const extensionName = json.extensionsUsed[i];
            const extensionsRequired = json.extensionsRequired || [];
            switch(extensionName){
                case EXTENSIONS.KHR_MATERIALS_UNLIT:
                    extensions[extensionName] = new GLTFMaterialsUnlitExtension();
                    break;
                case EXTENSIONS.KHR_DRACO_MESH_COMPRESSION:
                    extensions[extensionName] = new GLTFDracoMeshCompressionExtension(json, this.dracoLoader);
                    break;
                case EXTENSIONS.KHR_TEXTURE_TRANSFORM:
                    extensions[extensionName] = new GLTFTextureTransformExtension();
                    break;
                case EXTENSIONS.KHR_MESH_QUANTIZATION:
                    extensions[extensionName] = new GLTFMeshQuantizationExtension();
                    break;
                default:
                    if (extensionsRequired.indexOf(extensionName) >= 0 && plugins[extensionName] === void 0) console.warn('THREE.GLTFLoader: Unknown extension "' + extensionName + '".');
            }
        }
        parser.setExtensions(extensions);
        parser.setPlugins(plugins);
        parser.parse(onLoad, onError);
    }
    parseAsync(data, path) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.parse(data, path, resolve, reject);
        });
    }
}
function GLTFRegistry() {
    let objects = {};
    return {
        get: function(key) {
            return objects[key];
        },
        add: function(key, object) {
            objects[key] = object;
        },
        remove: function(key) {
            delete objects[key];
        },
        removeAll: function() {
            objects = {};
        }
    };
}
const EXTENSIONS = {
    KHR_BINARY_GLTF: "KHR_binary_glTF",
    KHR_DRACO_MESH_COMPRESSION: "KHR_draco_mesh_compression",
    KHR_LIGHTS_PUNCTUAL: "KHR_lights_punctual",
    KHR_MATERIALS_CLEARCOAT: "KHR_materials_clearcoat",
    KHR_MATERIALS_DISPERSION: "KHR_materials_dispersion",
    KHR_MATERIALS_IOR: "KHR_materials_ior",
    KHR_MATERIALS_SHEEN: "KHR_materials_sheen",
    KHR_MATERIALS_SPECULAR: "KHR_materials_specular",
    KHR_MATERIALS_TRANSMISSION: "KHR_materials_transmission",
    KHR_MATERIALS_IRIDESCENCE: "KHR_materials_iridescence",
    KHR_MATERIALS_ANISOTROPY: "KHR_materials_anisotropy",
    KHR_MATERIALS_UNLIT: "KHR_materials_unlit",
    KHR_MATERIALS_VOLUME: "KHR_materials_volume",
    KHR_TEXTURE_BASISU: "KHR_texture_basisu",
    KHR_TEXTURE_TRANSFORM: "KHR_texture_transform",
    KHR_MESH_QUANTIZATION: "KHR_mesh_quantization",
    KHR_MATERIALS_EMISSIVE_STRENGTH: "KHR_materials_emissive_strength",
    EXT_MATERIALS_BUMP: "EXT_materials_bump",
    EXT_TEXTURE_WEBP: "EXT_texture_webp",
    EXT_TEXTURE_AVIF: "EXT_texture_avif",
    EXT_MESHOPT_COMPRESSION: "EXT_meshopt_compression",
    EXT_MESH_GPU_INSTANCING: "EXT_mesh_gpu_instancing"
};
class GLTFLightsExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.KHR_LIGHTS_PUNCTUAL;
        this.cache = {
            refs: {},
            uses: {}
        };
    }
    _markDefs() {
        const parser = this.parser;
        const nodeDefs = this.parser.json.nodes || [];
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.extensions && nodeDef.extensions[this.name] && nodeDef.extensions[this.name].light !== void 0) parser._addNodeRef(this.cache, nodeDef.extensions[this.name].light);
        }
    }
    _loadLight(lightIndex) {
        const parser = this.parser;
        const cacheKey = "light:" + lightIndex;
        let dependency = parser.cache.get(cacheKey);
        if (dependency) return dependency;
        const json = parser.json;
        const extensions = json.extensions && json.extensions[this.name] || {};
        const lightDefs = extensions.lights || [];
        const lightDef = lightDefs[lightIndex];
        let lightNode;
        const color = new (0, _three.Color)(16777215);
        if (lightDef.color !== void 0) color.setRGB(lightDef.color[0], lightDef.color[1], lightDef.color[2], LinearSRGBColorSpace);
        const range = lightDef.range !== void 0 ? lightDef.range : 0;
        switch(lightDef.type){
            case "directional":
                lightNode = new (0, _three.DirectionalLight)(color);
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            case "point":
                lightNode = new (0, _three.PointLight)(color);
                lightNode.distance = range;
                break;
            case "spot":
                lightNode = new (0, _three.SpotLight)(color);
                lightNode.distance = range;
                lightDef.spot = lightDef.spot || {};
                lightDef.spot.innerConeAngle = lightDef.spot.innerConeAngle !== void 0 ? lightDef.spot.innerConeAngle : 0;
                lightDef.spot.outerConeAngle = lightDef.spot.outerConeAngle !== void 0 ? lightDef.spot.outerConeAngle : Math.PI / 4;
                lightNode.angle = lightDef.spot.outerConeAngle;
                lightNode.penumbra = 1 - lightDef.spot.innerConeAngle / lightDef.spot.outerConeAngle;
                lightNode.target.position.set(0, 0, -1);
                lightNode.add(lightNode.target);
                break;
            default:
                throw new Error("THREE.GLTFLoader: Unexpected light type: " + lightDef.type);
        }
        lightNode.position.set(0, 0, 0);
        lightNode.decay = 2;
        assignExtrasToUserData(lightNode, lightDef);
        if (lightDef.intensity !== void 0) lightNode.intensity = lightDef.intensity;
        lightNode.name = parser.createUniqueName(lightDef.name || "light_" + lightIndex);
        dependency = Promise.resolve(lightNode);
        parser.cache.add(cacheKey, dependency);
        return dependency;
    }
    getDependency(type, index) {
        if (type !== "light") return;
        return this._loadLight(index);
    }
    createNodeAttachment(nodeIndex) {
        const self2 = this;
        const parser = this.parser;
        const json = parser.json;
        const nodeDef = json.nodes[nodeIndex];
        const lightDef = nodeDef.extensions && nodeDef.extensions[this.name] || {};
        const lightIndex = lightDef.light;
        if (lightIndex === void 0) return null;
        return this._loadLight(lightIndex).then(function(light) {
            return parser._getNodeRef(self2.cache, lightIndex, light);
        });
    }
}
class GLTFMaterialsUnlitExtension {
    constructor(){
        this.name = EXTENSIONS.KHR_MATERIALS_UNLIT;
    }
    getMaterialType() {
        return 0, _three.MeshBasicMaterial;
    }
    extendParams(materialParams, materialDef, parser) {
        const pending = [];
        materialParams.color = new (0, _three.Color)(1, 1, 1);
        materialParams.opacity = 1;
        const metallicRoughness = materialDef.pbrMetallicRoughness;
        if (metallicRoughness) {
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], LinearSRGBColorSpace);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== void 0) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, SRGBColorSpace));
        }
        return Promise.all(pending);
    }
}
class GLTFMaterialsEmissiveStrengthExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.KHR_MATERIALS_EMISSIVE_STRENGTH;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const emissiveStrength = materialDef.extensions[this.name].emissiveStrength;
        if (emissiveStrength !== void 0) materialParams.emissiveIntensity = emissiveStrength;
        return Promise.resolve();
    }
}
class GLTFMaterialsClearcoatExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.KHR_MATERIALS_CLEARCOAT;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, _three.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.clearcoatFactor !== void 0) materialParams.clearcoat = extension.clearcoatFactor;
        if (extension.clearcoatTexture !== void 0) pending.push(parser.assignTexture(materialParams, "clearcoatMap", extension.clearcoatTexture));
        if (extension.clearcoatRoughnessFactor !== void 0) materialParams.clearcoatRoughness = extension.clearcoatRoughnessFactor;
        if (extension.clearcoatRoughnessTexture !== void 0) pending.push(parser.assignTexture(materialParams, "clearcoatRoughnessMap", extension.clearcoatRoughnessTexture));
        if (extension.clearcoatNormalTexture !== void 0) {
            pending.push(parser.assignTexture(materialParams, "clearcoatNormalMap", extension.clearcoatNormalTexture));
            if (extension.clearcoatNormalTexture.scale !== void 0) {
                const scale = extension.clearcoatNormalTexture.scale;
                materialParams.clearcoatNormalScale = new (0, _three.Vector2)(scale, scale);
            }
        }
        return Promise.all(pending);
    }
}
class GLTFMaterialsDispersionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.KHR_MATERIALS_DISPERSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, _three.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.dispersion = extension.dispersion !== void 0 ? extension.dispersion : 0;
        return Promise.resolve();
    }
}
class GLTFMaterialsIridescenceExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.KHR_MATERIALS_IRIDESCENCE;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, _three.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.iridescenceFactor !== void 0) materialParams.iridescence = extension.iridescenceFactor;
        if (extension.iridescenceTexture !== void 0) pending.push(parser.assignTexture(materialParams, "iridescenceMap", extension.iridescenceTexture));
        if (extension.iridescenceIor !== void 0) materialParams.iridescenceIOR = extension.iridescenceIor;
        if (materialParams.iridescenceThicknessRange === void 0) materialParams.iridescenceThicknessRange = [
            100,
            400
        ];
        if (extension.iridescenceThicknessMinimum !== void 0) materialParams.iridescenceThicknessRange[0] = extension.iridescenceThicknessMinimum;
        if (extension.iridescenceThicknessMaximum !== void 0) materialParams.iridescenceThicknessRange[1] = extension.iridescenceThicknessMaximum;
        if (extension.iridescenceThicknessTexture !== void 0) pending.push(parser.assignTexture(materialParams, "iridescenceThicknessMap", extension.iridescenceThicknessTexture));
        return Promise.all(pending);
    }
}
class GLTFMaterialsSheenExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.KHR_MATERIALS_SHEEN;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, _three.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        materialParams.sheenColor = new (0, _three.Color)(0, 0, 0);
        materialParams.sheenRoughness = 0;
        materialParams.sheen = 1;
        const extension = materialDef.extensions[this.name];
        if (extension.sheenColorFactor !== void 0) {
            const colorFactor = extension.sheenColorFactor;
            materialParams.sheenColor.setRGB(colorFactor[0], colorFactor[1], colorFactor[2], LinearSRGBColorSpace);
        }
        if (extension.sheenRoughnessFactor !== void 0) materialParams.sheenRoughness = extension.sheenRoughnessFactor;
        if (extension.sheenColorTexture !== void 0) pending.push(parser.assignTexture(materialParams, "sheenColorMap", extension.sheenColorTexture, SRGBColorSpace));
        if (extension.sheenRoughnessTexture !== void 0) pending.push(parser.assignTexture(materialParams, "sheenRoughnessMap", extension.sheenRoughnessTexture));
        return Promise.all(pending);
    }
}
class GLTFMaterialsTransmissionExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.KHR_MATERIALS_TRANSMISSION;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, _three.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.transmissionFactor !== void 0) materialParams.transmission = extension.transmissionFactor;
        if (extension.transmissionTexture !== void 0) pending.push(parser.assignTexture(materialParams, "transmissionMap", extension.transmissionTexture));
        return Promise.all(pending);
    }
}
class GLTFMaterialsVolumeExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.KHR_MATERIALS_VOLUME;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, _three.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.thickness = extension.thicknessFactor !== void 0 ? extension.thicknessFactor : 0;
        if (extension.thicknessTexture !== void 0) pending.push(parser.assignTexture(materialParams, "thicknessMap", extension.thicknessTexture));
        materialParams.attenuationDistance = extension.attenuationDistance || Infinity;
        const colorArray = extension.attenuationColor || [
            1,
            1,
            1
        ];
        materialParams.attenuationColor = new (0, _three.Color)().setRGB(colorArray[0], colorArray[1], colorArray[2], LinearSRGBColorSpace);
        return Promise.all(pending);
    }
}
class GLTFMaterialsIorExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.KHR_MATERIALS_IOR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, _three.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const extension = materialDef.extensions[this.name];
        materialParams.ior = extension.ior !== void 0 ? extension.ior : 1.5;
        return Promise.resolve();
    }
}
class GLTFMaterialsSpecularExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.KHR_MATERIALS_SPECULAR;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, _three.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.specularIntensity = extension.specularFactor !== void 0 ? extension.specularFactor : 1;
        if (extension.specularTexture !== void 0) pending.push(parser.assignTexture(materialParams, "specularIntensityMap", extension.specularTexture));
        const colorArray = extension.specularColorFactor || [
            1,
            1,
            1
        ];
        materialParams.specularColor = new (0, _three.Color)().setRGB(colorArray[0], colorArray[1], colorArray[2], LinearSRGBColorSpace);
        if (extension.specularColorTexture !== void 0) pending.push(parser.assignTexture(materialParams, "specularColorMap", extension.specularColorTexture, SRGBColorSpace));
        return Promise.all(pending);
    }
}
class GLTFMaterialsBumpExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.EXT_MATERIALS_BUMP;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, _three.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        materialParams.bumpScale = extension.bumpFactor !== void 0 ? extension.bumpFactor : 1;
        if (extension.bumpTexture !== void 0) pending.push(parser.assignTexture(materialParams, "bumpMap", extension.bumpTexture));
        return Promise.all(pending);
    }
}
class GLTFMaterialsAnisotropyExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.KHR_MATERIALS_ANISOTROPY;
    }
    getMaterialType(materialIndex) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return null;
        return 0, _three.MeshPhysicalMaterial;
    }
    extendMaterialParams(materialIndex, materialParams) {
        const parser = this.parser;
        const materialDef = parser.json.materials[materialIndex];
        if (!materialDef.extensions || !materialDef.extensions[this.name]) return Promise.resolve();
        const pending = [];
        const extension = materialDef.extensions[this.name];
        if (extension.anisotropyStrength !== void 0) materialParams.anisotropy = extension.anisotropyStrength;
        if (extension.anisotropyRotation !== void 0) materialParams.anisotropyRotation = extension.anisotropyRotation;
        if (extension.anisotropyTexture !== void 0) pending.push(parser.assignTexture(materialParams, "anisotropyMap", extension.anisotropyTexture));
        return Promise.all(pending);
    }
}
class GLTFTextureBasisUExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.KHR_TEXTURE_BASISU;
    }
    loadTexture(textureIndex) {
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[this.name]) return null;
        const extension = textureDef.extensions[this.name];
        const loader = parser.options.ktx2Loader;
        if (!loader) {
            if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setKTX2Loader must be called before loading KTX2 textures");
            else return null;
        }
        return parser.loadTextureImage(textureIndex, extension.source, loader);
    }
}
class GLTFTextureWebPExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.EXT_TEXTURE_WEBP;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: WebP required by asset but unsupported.");
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            image.src = "data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
class GLTFTextureAVIFExtension {
    constructor(parser){
        this.parser = parser;
        this.name = EXTENSIONS.EXT_TEXTURE_AVIF;
        this.isSupported = null;
    }
    loadTexture(textureIndex) {
        const name = this.name;
        const parser = this.parser;
        const json = parser.json;
        const textureDef = json.textures[textureIndex];
        if (!textureDef.extensions || !textureDef.extensions[name]) return null;
        const extension = textureDef.extensions[name];
        const source = json.images[extension.source];
        let loader = parser.textureLoader;
        if (source.uri) {
            const handler = parser.options.manager.getHandler(source.uri);
            if (handler !== null) loader = handler;
        }
        return this.detectSupport().then(function(isSupported) {
            if (isSupported) return parser.loadTextureImage(textureIndex, extension.source, loader);
            if (json.extensionsRequired && json.extensionsRequired.indexOf(name) >= 0) throw new Error("THREE.GLTFLoader: AVIF required by asset but unsupported.");
            return parser.loadTexture(textureIndex);
        });
    }
    detectSupport() {
        if (!this.isSupported) this.isSupported = new Promise(function(resolve) {
            const image = new Image();
            image.src = "data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAABcAAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAEAAAABAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQAMAAAAABNjb2xybmNseAACAAIABoAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAAB9tZGF0EgAKCBgABogQEDQgMgkQAAAAB8dSLfI=";
            image.onload = image.onerror = function() {
                resolve(image.height === 1);
            };
        });
        return this.isSupported;
    }
}
class GLTFMeshoptCompression {
    constructor(parser){
        this.name = EXTENSIONS.EXT_MESHOPT_COMPRESSION;
        this.parser = parser;
    }
    loadBufferView(index) {
        const json = this.parser.json;
        const bufferView = json.bufferViews[index];
        if (bufferView.extensions && bufferView.extensions[this.name]) {
            const extensionDef = bufferView.extensions[this.name];
            const buffer = this.parser.getDependency("buffer", extensionDef.buffer);
            const decoder = this.parser.options.meshoptDecoder;
            if (!decoder || !decoder.supported) {
                if (json.extensionsRequired && json.extensionsRequired.indexOf(this.name) >= 0) throw new Error("THREE.GLTFLoader: setMeshoptDecoder must be called before loading compressed files");
                else return null;
            }
            return buffer.then(function(res) {
                const byteOffset = extensionDef.byteOffset || 0;
                const byteLength = extensionDef.byteLength || 0;
                const count = extensionDef.count;
                const stride = extensionDef.byteStride;
                const source = new Uint8Array(res, byteOffset, byteLength);
                if (decoder.decodeGltfBufferAsync) return decoder.decodeGltfBufferAsync(count, stride, source, extensionDef.mode, extensionDef.filter).then(function(res2) {
                    return res2.buffer;
                });
                else return decoder.ready.then(function() {
                    const result = new ArrayBuffer(count * stride);
                    decoder.decodeGltfBuffer(new Uint8Array(result), count, stride, source, extensionDef.mode, extensionDef.filter);
                    return result;
                });
            });
        } else return null;
    }
}
class GLTFMeshGpuInstancing {
    constructor(parser){
        this.name = EXTENSIONS.EXT_MESH_GPU_INSTANCING;
        this.parser = parser;
    }
    createNodeMesh(nodeIndex) {
        const json = this.parser.json;
        const nodeDef = json.nodes[nodeIndex];
        if (!nodeDef.extensions || !nodeDef.extensions[this.name] || nodeDef.mesh === void 0) return null;
        const meshDef = json.meshes[nodeDef.mesh];
        for (const primitive of meshDef.primitives){
            if (primitive.mode !== WEBGL_CONSTANTS.TRIANGLES && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_STRIP && primitive.mode !== WEBGL_CONSTANTS.TRIANGLE_FAN && primitive.mode !== void 0) return null;
        }
        const extensionDef = nodeDef.extensions[this.name];
        const attributesDef = extensionDef.attributes;
        const pending = [];
        const attributes = {};
        for(const key in attributesDef)pending.push(this.parser.getDependency("accessor", attributesDef[key]).then((accessor)=>{
            attributes[key] = accessor;
            return attributes[key];
        }));
        if (pending.length < 1) return null;
        pending.push(this.parser.createNodeMesh(nodeIndex));
        return Promise.all(pending).then((results)=>{
            const nodeObject = results.pop();
            const meshes = nodeObject.isGroup ? nodeObject.children : [
                nodeObject
            ];
            const count = results[0].count;
            const instancedMeshes = [];
            for (const mesh of meshes){
                const m = new (0, _three.Matrix4)();
                const p = new (0, _three.Vector3)();
                const q = new (0, _three.Quaternion)();
                const s = new (0, _three.Vector3)(1, 1, 1);
                const instancedMesh = new (0, _three.InstancedMesh)(mesh.geometry, mesh.material, count);
                for(let i = 0; i < count; i++){
                    if (attributes.TRANSLATION) p.fromBufferAttribute(attributes.TRANSLATION, i);
                    if (attributes.ROTATION) q.fromBufferAttribute(attributes.ROTATION, i);
                    if (attributes.SCALE) s.fromBufferAttribute(attributes.SCALE, i);
                    instancedMesh.setMatrixAt(i, m.compose(p, q, s));
                }
                for(const attributeName in attributes){
                    if (attributeName === "_COLOR_0") {
                        const attr = attributes[attributeName];
                        instancedMesh.instanceColor = new (0, _three.InstancedBufferAttribute)(attr.array, attr.itemSize, attr.normalized);
                    } else if (attributeName !== "TRANSLATION" && attributeName !== "ROTATION" && attributeName !== "SCALE") mesh.geometry.setAttribute(attributeName, attributes[attributeName]);
                }
                (0, _three.Object3D).prototype.copy.call(instancedMesh, mesh);
                this.parser.assignFinalMaterial(instancedMesh);
                instancedMeshes.push(instancedMesh);
            }
            if (nodeObject.isGroup) {
                nodeObject.clear();
                nodeObject.add(...instancedMeshes);
                return nodeObject;
            }
            return instancedMeshes[0];
        });
    }
}
const BINARY_EXTENSION_HEADER_MAGIC = "glTF";
const BINARY_EXTENSION_HEADER_LENGTH = 12;
const BINARY_EXTENSION_CHUNK_TYPES = {
    JSON: 1313821514,
    BIN: 5130562
};
class GLTFBinaryExtension {
    constructor(data){
        this.name = EXTENSIONS.KHR_BINARY_GLTF;
        this.content = null;
        this.body = null;
        const headerView = new DataView(data, 0, BINARY_EXTENSION_HEADER_LENGTH);
        this.header = {
            magic: (0, _loaderUtilsJs.decodeText)(new Uint8Array(data.slice(0, 4))),
            version: headerView.getUint32(4, true),
            length: headerView.getUint32(8, true)
        };
        if (this.header.magic !== BINARY_EXTENSION_HEADER_MAGIC) throw new Error("THREE.GLTFLoader: Unsupported glTF-Binary header.");
        else if (this.header.version < 2) throw new Error("THREE.GLTFLoader: Legacy binary file detected.");
        const chunkContentsLength = this.header.length - BINARY_EXTENSION_HEADER_LENGTH;
        const chunkView = new DataView(data, BINARY_EXTENSION_HEADER_LENGTH);
        let chunkIndex = 0;
        while(chunkIndex < chunkContentsLength){
            const chunkLength = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            const chunkType = chunkView.getUint32(chunkIndex, true);
            chunkIndex += 4;
            if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.JSON) {
                const contentArray = new Uint8Array(data, BINARY_EXTENSION_HEADER_LENGTH + chunkIndex, chunkLength);
                this.content = (0, _loaderUtilsJs.decodeText)(contentArray);
            } else if (chunkType === BINARY_EXTENSION_CHUNK_TYPES.BIN) {
                const byteOffset = BINARY_EXTENSION_HEADER_LENGTH + chunkIndex;
                this.body = data.slice(byteOffset, byteOffset + chunkLength);
            }
            chunkIndex += chunkLength;
        }
        if (this.content === null) throw new Error("THREE.GLTFLoader: JSON content not found.");
    }
}
class GLTFDracoMeshCompressionExtension {
    constructor(json, dracoLoader){
        if (!dracoLoader) throw new Error("THREE.GLTFLoader: No DRACOLoader instance provided.");
        this.name = EXTENSIONS.KHR_DRACO_MESH_COMPRESSION;
        this.json = json;
        this.dracoLoader = dracoLoader;
        this.dracoLoader.preload();
    }
    decodePrimitive(primitive, parser) {
        const json = this.json;
        const dracoLoader = this.dracoLoader;
        const bufferViewIndex = primitive.extensions[this.name].bufferView;
        const gltfAttributeMap = primitive.extensions[this.name].attributes;
        const threeAttributeMap = {};
        const attributeNormalizedMap = {};
        const attributeTypeMap = {};
        for(const attributeName in gltfAttributeMap){
            const threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            threeAttributeMap[threeAttributeName] = gltfAttributeMap[attributeName];
        }
        for(const attributeName in primitive.attributes){
            const threeAttributeName = ATTRIBUTES[attributeName] || attributeName.toLowerCase();
            if (gltfAttributeMap[attributeName] !== void 0) {
                const accessorDef = json.accessors[primitive.attributes[attributeName]];
                const componentType = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
                attributeTypeMap[threeAttributeName] = componentType.name;
                attributeNormalizedMap[threeAttributeName] = accessorDef.normalized === true;
            }
        }
        return parser.getDependency("bufferView", bufferViewIndex).then(function(bufferView) {
            return new Promise(function(resolve, reject) {
                dracoLoader.decodeDracoFile(bufferView, function(geometry) {
                    for(const attributeName in geometry.attributes){
                        const attribute = geometry.attributes[attributeName];
                        const normalized = attributeNormalizedMap[attributeName];
                        if (normalized !== void 0) attribute.normalized = normalized;
                    }
                    resolve(geometry);
                }, threeAttributeMap, attributeTypeMap, LinearSRGBColorSpace, reject);
            });
        });
    }
}
class GLTFTextureTransformExtension {
    constructor(){
        this.name = EXTENSIONS.KHR_TEXTURE_TRANSFORM;
    }
    extendTexture(texture, transform) {
        if ((transform.texCoord === void 0 || transform.texCoord === texture.channel) && transform.offset === void 0 && transform.rotation === void 0 && transform.scale === void 0) return texture;
        texture = texture.clone();
        if (transform.texCoord !== void 0) texture.channel = transform.texCoord;
        if (transform.offset !== void 0) texture.offset.fromArray(transform.offset);
        if (transform.rotation !== void 0) texture.rotation = transform.rotation;
        if (transform.scale !== void 0) texture.repeat.fromArray(transform.scale);
        texture.needsUpdate = true;
        return texture;
    }
}
class GLTFMeshQuantizationExtension {
    constructor(){
        this.name = EXTENSIONS.KHR_MESH_QUANTIZATION;
    }
}
class GLTFCubicSplineInterpolant extends (0, _three.Interpolant) {
    constructor(parameterPositions, sampleValues, sampleSize, resultBuffer){
        super(parameterPositions, sampleValues, sampleSize, resultBuffer);
    }
    copySampleValue_(index) {
        const result = this.resultBuffer, values = this.sampleValues, valueSize = this.valueSize, offset = index * valueSize * 3 + valueSize;
        for(let i = 0; i !== valueSize; i++)result[i] = values[offset + i];
        return result;
    }
    interpolate_(i1, t0, t, t1) {
        const result = this.resultBuffer;
        const values = this.sampleValues;
        const stride = this.valueSize;
        const stride2 = stride * 2;
        const stride3 = stride * 3;
        const td = t1 - t0;
        const p = (t - t0) / td;
        const pp = p * p;
        const ppp = pp * p;
        const offset1 = i1 * stride3;
        const offset0 = offset1 - stride3;
        const s2 = -2 * ppp + 3 * pp;
        const s3 = ppp - pp;
        const s0 = 1 - s2;
        const s1 = s3 - pp + p;
        for(let i = 0; i !== stride; i++){
            const p0 = values[offset0 + i + stride];
            const m0 = values[offset0 + i + stride2] * td;
            const p1 = values[offset1 + i + stride];
            const m1 = values[offset1 + i] * td;
            result[i] = s0 * p0 + s1 * m0 + s2 * p1 + s3 * m1;
        }
        return result;
    }
}
const _q = /* @__PURE__ */ new (0, _three.Quaternion)();
class GLTFCubicSplineQuaternionInterpolant extends GLTFCubicSplineInterpolant {
    interpolate_(i1, t0, t, t1) {
        const result = super.interpolate_(i1, t0, t, t1);
        _q.fromArray(result).normalize().toArray(result);
        return result;
    }
}
const WEBGL_CONSTANTS = {
    FLOAT: 5126,
    //FLOAT_MAT2: 35674,
    FLOAT_MAT3: 35675,
    FLOAT_MAT4: 35676,
    FLOAT_VEC2: 35664,
    FLOAT_VEC3: 35665,
    FLOAT_VEC4: 35666,
    LINEAR: 9729,
    REPEAT: 10497,
    SAMPLER_2D: 35678,
    POINTS: 0,
    LINES: 1,
    LINE_LOOP: 2,
    LINE_STRIP: 3,
    TRIANGLES: 4,
    TRIANGLE_STRIP: 5,
    TRIANGLE_FAN: 6,
    UNSIGNED_BYTE: 5121,
    UNSIGNED_SHORT: 5123
};
const WEBGL_COMPONENT_TYPES = {
    5120: Int8Array,
    5121: Uint8Array,
    5122: Int16Array,
    5123: Uint16Array,
    5125: Uint32Array,
    5126: Float32Array
};
const WEBGL_FILTERS = {
    9728: (0, _three.NearestFilter),
    9729: (0, _three.LinearFilter),
    9984: (0, _three.NearestMipmapNearestFilter),
    9985: (0, _three.LinearMipmapNearestFilter),
    9986: (0, _three.NearestMipmapLinearFilter),
    9987: (0, _three.LinearMipmapLinearFilter)
};
const WEBGL_WRAPPINGS = {
    33071: (0, _three.ClampToEdgeWrapping),
    33648: (0, _three.MirroredRepeatWrapping),
    10497: (0, _three.RepeatWrapping)
};
const WEBGL_TYPE_SIZES = {
    SCALAR: 1,
    VEC2: 2,
    VEC3: 3,
    VEC4: 4,
    MAT2: 4,
    MAT3: 9,
    MAT4: 16
};
const ATTRIBUTES = {
    POSITION: "position",
    NORMAL: "normal",
    TANGENT: "tangent",
    // uv => uv1, 4 uv channels
    // https://github.com/mrdoob/three.js/pull/25943
    // https://github.com/mrdoob/three.js/pull/25788
    ...(0, _constantsJs.version) >= 152 ? {
        TEXCOORD_0: "uv",
        TEXCOORD_1: "uv1",
        TEXCOORD_2: "uv2",
        TEXCOORD_3: "uv3"
    } : {
        TEXCOORD_0: "uv",
        TEXCOORD_1: "uv2"
    },
    COLOR_0: "color",
    WEIGHTS_0: "skinWeight",
    JOINTS_0: "skinIndex"
};
const PATH_PROPERTIES = {
    scale: "scale",
    translation: "position",
    rotation: "quaternion",
    weights: "morphTargetInfluences"
};
const INTERPOLATION = {
    CUBICSPLINE: void 0,
    // We use a custom interpolant (GLTFCubicSplineInterpolation) for CUBICSPLINE tracks. Each
    // keyframe track will be initialized with a default interpolation type, then modified.
    LINEAR: (0, _three.InterpolateLinear),
    STEP: (0, _three.InterpolateDiscrete)
};
const ALPHA_MODES = {
    OPAQUE: "OPAQUE",
    MASK: "MASK",
    BLEND: "BLEND"
};
function createDefaultMaterial(cache) {
    if (cache["DefaultMaterial"] === void 0) cache["DefaultMaterial"] = new (0, _three.MeshStandardMaterial)({
        color: 16777215,
        emissive: 0,
        metalness: 1,
        roughness: 1,
        transparent: false,
        depthTest: true,
        side: (0, _three.FrontSide)
    });
    return cache["DefaultMaterial"];
}
function addUnknownExtensionsToUserData(knownExtensions, object, objectDef) {
    for(const name in objectDef.extensions)if (knownExtensions[name] === void 0) {
        object.userData.gltfExtensions = object.userData.gltfExtensions || {};
        object.userData.gltfExtensions[name] = objectDef.extensions[name];
    }
}
function assignExtrasToUserData(object, gltfDef) {
    if (gltfDef.extras !== void 0) {
        if (typeof gltfDef.extras === "object") Object.assign(object.userData, gltfDef.extras);
        else console.warn("THREE.GLTFLoader: Ignoring primitive type .extras, " + gltfDef.extras);
    }
}
function addMorphTargets(geometry, targets, parser) {
    let hasMorphPosition = false;
    let hasMorphNormal = false;
    let hasMorphColor = false;
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (target.POSITION !== void 0) hasMorphPosition = true;
        if (target.NORMAL !== void 0) hasMorphNormal = true;
        if (target.COLOR_0 !== void 0) hasMorphColor = true;
        if (hasMorphPosition && hasMorphNormal && hasMorphColor) break;
    }
    if (!hasMorphPosition && !hasMorphNormal && !hasMorphColor) return Promise.resolve(geometry);
    const pendingPositionAccessors = [];
    const pendingNormalAccessors = [];
    const pendingColorAccessors = [];
    for(let i = 0, il = targets.length; i < il; i++){
        const target = targets[i];
        if (hasMorphPosition) {
            const pendingAccessor = target.POSITION !== void 0 ? parser.getDependency("accessor", target.POSITION) : geometry.attributes.position;
            pendingPositionAccessors.push(pendingAccessor);
        }
        if (hasMorphNormal) {
            const pendingAccessor = target.NORMAL !== void 0 ? parser.getDependency("accessor", target.NORMAL) : geometry.attributes.normal;
            pendingNormalAccessors.push(pendingAccessor);
        }
        if (hasMorphColor) {
            const pendingAccessor = target.COLOR_0 !== void 0 ? parser.getDependency("accessor", target.COLOR_0) : geometry.attributes.color;
            pendingColorAccessors.push(pendingAccessor);
        }
    }
    return Promise.all([
        Promise.all(pendingPositionAccessors),
        Promise.all(pendingNormalAccessors),
        Promise.all(pendingColorAccessors)
    ]).then(function(accessors) {
        const morphPositions = accessors[0];
        const morphNormals = accessors[1];
        const morphColors = accessors[2];
        if (hasMorphPosition) geometry.morphAttributes.position = morphPositions;
        if (hasMorphNormal) geometry.morphAttributes.normal = morphNormals;
        if (hasMorphColor) geometry.morphAttributes.color = morphColors;
        geometry.morphTargetsRelative = true;
        return geometry;
    });
}
function updateMorphTargets(mesh, meshDef) {
    mesh.updateMorphTargets();
    if (meshDef.weights !== void 0) for(let i = 0, il = meshDef.weights.length; i < il; i++)mesh.morphTargetInfluences[i] = meshDef.weights[i];
    if (meshDef.extras && Array.isArray(meshDef.extras.targetNames)) {
        const targetNames = meshDef.extras.targetNames;
        if (mesh.morphTargetInfluences.length === targetNames.length) {
            mesh.morphTargetDictionary = {};
            for(let i = 0, il = targetNames.length; i < il; i++)mesh.morphTargetDictionary[targetNames[i]] = i;
        } else console.warn("THREE.GLTFLoader: Invalid extras.targetNames length. Ignoring names.");
    }
}
function createPrimitiveKey(primitiveDef) {
    let geometryKey;
    const dracoExtension = primitiveDef.extensions && primitiveDef.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION];
    if (dracoExtension) geometryKey = "draco:" + dracoExtension.bufferView + ":" + dracoExtension.indices + ":" + createAttributesKey(dracoExtension.attributes);
    else geometryKey = primitiveDef.indices + ":" + createAttributesKey(primitiveDef.attributes) + ":" + primitiveDef.mode;
    if (primitiveDef.targets !== void 0) for(let i = 0, il = primitiveDef.targets.length; i < il; i++)geometryKey += ":" + createAttributesKey(primitiveDef.targets[i]);
    return geometryKey;
}
function createAttributesKey(attributes) {
    let attributesKey = "";
    const keys = Object.keys(attributes).sort();
    for(let i = 0, il = keys.length; i < il; i++)attributesKey += keys[i] + ":" + attributes[keys[i]] + ";";
    return attributesKey;
}
function getNormalizedComponentScale(constructor) {
    switch(constructor){
        case Int8Array:
            return 1 / 127;
        case Uint8Array:
            return 1 / 255;
        case Int16Array:
            return 1 / 32767;
        case Uint16Array:
            return 1 / 65535;
        default:
            throw new Error("THREE.GLTFLoader: Unsupported normalized accessor component type.");
    }
}
function getImageURIMimeType(uri) {
    if (uri.search(/\.jpe?g($|\?)/i) > 0 || uri.search(/^data\:image\/jpeg/) === 0) return "image/jpeg";
    if (uri.search(/\.webp($|\?)/i) > 0 || uri.search(/^data\:image\/webp/) === 0) return "image/webp";
    return "image/png";
}
const _identityMatrix = /* @__PURE__ */ new (0, _three.Matrix4)();
class GLTFParser {
    constructor(json = {}, options = {}){
        this.json = json;
        this.extensions = {};
        this.plugins = {};
        this.options = options;
        this.cache = new GLTFRegistry();
        this.associations = /* @__PURE__ */ new Map();
        this.primitiveCache = {};
        this.nodeCache = {};
        this.meshCache = {
            refs: {},
            uses: {}
        };
        this.cameraCache = {
            refs: {},
            uses: {}
        };
        this.lightCache = {
            refs: {},
            uses: {}
        };
        this.sourceCache = {};
        this.textureCache = {};
        this.nodeNamesUsed = {};
        let isSafari = false;
        let isFirefox = false;
        let firefoxVersion = -1;
        if (typeof navigator !== "undefined" && typeof navigator.userAgent !== "undefined") {
            isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) === true;
            isFirefox = navigator.userAgent.indexOf("Firefox") > -1;
            firefoxVersion = isFirefox ? navigator.userAgent.match(/Firefox\/([0-9]+)\./)[1] : -1;
        }
        if (typeof createImageBitmap === "undefined" || isSafari || isFirefox && firefoxVersion < 98) this.textureLoader = new (0, _three.TextureLoader)(this.options.manager);
        else this.textureLoader = new (0, _three.ImageBitmapLoader)(this.options.manager);
        this.textureLoader.setCrossOrigin(this.options.crossOrigin);
        this.textureLoader.setRequestHeader(this.options.requestHeader);
        this.fileLoader = new (0, _three.FileLoader)(this.options.manager);
        this.fileLoader.setResponseType("arraybuffer");
        if (this.options.crossOrigin === "use-credentials") this.fileLoader.setWithCredentials(true);
    }
    setExtensions(extensions) {
        this.extensions = extensions;
    }
    setPlugins(plugins) {
        this.plugins = plugins;
    }
    parse(onLoad, onError) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        this.cache.removeAll();
        this.nodeCache = {};
        this._invokeAll(function(ext) {
            return ext._markDefs && ext._markDefs();
        });
        Promise.all(this._invokeAll(function(ext) {
            return ext.beforeRoot && ext.beforeRoot();
        })).then(function() {
            return Promise.all([
                parser.getDependencies("scene"),
                parser.getDependencies("animation"),
                parser.getDependencies("camera")
            ]);
        }).then(function(dependencies) {
            const result = {
                scene: dependencies[0][json.scene || 0],
                scenes: dependencies[0],
                animations: dependencies[1],
                cameras: dependencies[2],
                asset: json.asset,
                parser,
                userData: {}
            };
            addUnknownExtensionsToUserData(extensions, result, json);
            assignExtrasToUserData(result, json);
            return Promise.all(parser._invokeAll(function(ext) {
                return ext.afterRoot && ext.afterRoot(result);
            })).then(function() {
                for (const scene of result.scenes)scene.updateMatrixWorld();
                onLoad(result);
            });
        }).catch(onError);
    }
    /**
   * Marks the special nodes/meshes in json for efficient parse.
   */ _markDefs() {
        const nodeDefs = this.json.nodes || [];
        const skinDefs = this.json.skins || [];
        const meshDefs = this.json.meshes || [];
        for(let skinIndex = 0, skinLength = skinDefs.length; skinIndex < skinLength; skinIndex++){
            const joints = skinDefs[skinIndex].joints;
            for(let i = 0, il = joints.length; i < il; i++)nodeDefs[joints[i]].isBone = true;
        }
        for(let nodeIndex = 0, nodeLength = nodeDefs.length; nodeIndex < nodeLength; nodeIndex++){
            const nodeDef = nodeDefs[nodeIndex];
            if (nodeDef.mesh !== void 0) {
                this._addNodeRef(this.meshCache, nodeDef.mesh);
                if (nodeDef.skin !== void 0) meshDefs[nodeDef.mesh].isSkinnedMesh = true;
            }
            if (nodeDef.camera !== void 0) this._addNodeRef(this.cameraCache, nodeDef.camera);
        }
    }
    /**
   * Counts references to shared node / Object3D resources. These resources
   * can be reused, or "instantiated", at multiple nodes in the scene
   * hierarchy. Mesh, Camera, and Light instances are instantiated and must
   * be marked. Non-scenegraph resources (like Materials, Geometries, and
   * Textures) can be reused directly and are not marked here.
   *
   * Example: CesiumMilkTruck sample model reuses "Wheel" meshes.
   */ _addNodeRef(cache, index) {
        if (index === void 0) return;
        if (cache.refs[index] === void 0) cache.refs[index] = cache.uses[index] = 0;
        cache.refs[index]++;
    }
    /** Returns a reference to a shared resource, cloning it if necessary. */ _getNodeRef(cache, index, object) {
        if (cache.refs[index] <= 1) return object;
        const ref = object.clone();
        const updateMappings = (original, clone)=>{
            const mappings = this.associations.get(original);
            if (mappings != null) this.associations.set(clone, mappings);
            for (const [i, child] of original.children.entries())updateMappings(child, clone.children[i]);
        };
        updateMappings(object, ref);
        ref.name += "_instance_" + cache.uses[index]++;
        return ref;
    }
    _invokeOne(func) {
        const extensions = Object.values(this.plugins);
        extensions.push(this);
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) return result;
        }
        return null;
    }
    _invokeAll(func) {
        const extensions = Object.values(this.plugins);
        extensions.unshift(this);
        const pending = [];
        for(let i = 0; i < extensions.length; i++){
            const result = func(extensions[i]);
            if (result) pending.push(result);
        }
        return pending;
    }
    /**
   * Requests the specified dependency asynchronously, with caching.
   * @param {string} type
   * @param {number} index
   * @return {Promise<Object3D|Material|THREE.Texture|AnimationClip|ArrayBuffer|Object>}
   */ getDependency(type, index) {
        const cacheKey = type + ":" + index;
        let dependency = this.cache.get(cacheKey);
        if (!dependency) {
            switch(type){
                case "scene":
                    dependency = this.loadScene(index);
                    break;
                case "node":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadNode && ext.loadNode(index);
                    });
                    break;
                case "mesh":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMesh && ext.loadMesh(index);
                    });
                    break;
                case "accessor":
                    dependency = this.loadAccessor(index);
                    break;
                case "bufferView":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadBufferView && ext.loadBufferView(index);
                    });
                    break;
                case "buffer":
                    dependency = this.loadBuffer(index);
                    break;
                case "material":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadMaterial && ext.loadMaterial(index);
                    });
                    break;
                case "texture":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadTexture && ext.loadTexture(index);
                    });
                    break;
                case "skin":
                    dependency = this.loadSkin(index);
                    break;
                case "animation":
                    dependency = this._invokeOne(function(ext) {
                        return ext.loadAnimation && ext.loadAnimation(index);
                    });
                    break;
                case "camera":
                    dependency = this.loadCamera(index);
                    break;
                default:
                    dependency = this._invokeOne(function(ext) {
                        return ext != this && ext.getDependency && ext.getDependency(type, index);
                    });
                    if (!dependency) throw new Error("Unknown type: " + type);
                    break;
            }
            this.cache.add(cacheKey, dependency);
        }
        return dependency;
    }
    /**
   * Requests all dependencies of the specified type asynchronously, with caching.
   * @param {string} type
   * @return {Promise<Array<Object>>}
   */ getDependencies(type) {
        let dependencies = this.cache.get(type);
        if (!dependencies) {
            const parser = this;
            const defs = this.json[type + (type === "mesh" ? "es" : "s")] || [];
            dependencies = Promise.all(defs.map(function(def, index) {
                return parser.getDependency(type, index);
            }));
            this.cache.add(type, dependencies);
        }
        return dependencies;
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferIndex
   * @return {Promise<ArrayBuffer>}
   */ loadBuffer(bufferIndex) {
        const bufferDef = this.json.buffers[bufferIndex];
        const loader = this.fileLoader;
        if (bufferDef.type && bufferDef.type !== "arraybuffer") throw new Error("THREE.GLTFLoader: " + bufferDef.type + " buffer type is not supported.");
        if (bufferDef.uri === void 0 && bufferIndex === 0) return Promise.resolve(this.extensions[EXTENSIONS.KHR_BINARY_GLTF].body);
        const options = this.options;
        return new Promise(function(resolve, reject) {
            loader.load((0, _three.LoaderUtils).resolveURL(bufferDef.uri, options.path), resolve, void 0, function() {
                reject(new Error('THREE.GLTFLoader: Failed to load buffer "' + bufferDef.uri + '".'));
            });
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#buffers-and-buffer-views
   * @param {number} bufferViewIndex
   * @return {Promise<ArrayBuffer>}
   */ loadBufferView(bufferViewIndex) {
        const bufferViewDef = this.json.bufferViews[bufferViewIndex];
        return this.getDependency("buffer", bufferViewDef.buffer).then(function(buffer) {
            const byteLength = bufferViewDef.byteLength || 0;
            const byteOffset = bufferViewDef.byteOffset || 0;
            return buffer.slice(byteOffset, byteOffset + byteLength);
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#accessors
   * @param {number} accessorIndex
   * @return {Promise<BufferAttribute|InterleavedBufferAttribute>}
   */ loadAccessor(accessorIndex) {
        const parser = this;
        const json = this.json;
        const accessorDef = this.json.accessors[accessorIndex];
        if (accessorDef.bufferView === void 0 && accessorDef.sparse === void 0) {
            const itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const normalized = accessorDef.normalized === true;
            const array = new TypedArray(accessorDef.count * itemSize);
            return Promise.resolve(new (0, _three.BufferAttribute)(array, itemSize, normalized));
        }
        const pendingBufferViews = [];
        if (accessorDef.bufferView !== void 0) pendingBufferViews.push(this.getDependency("bufferView", accessorDef.bufferView));
        else pendingBufferViews.push(null);
        if (accessorDef.sparse !== void 0) {
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.indices.bufferView));
            pendingBufferViews.push(this.getDependency("bufferView", accessorDef.sparse.values.bufferView));
        }
        return Promise.all(pendingBufferViews).then(function(bufferViews) {
            const bufferView = bufferViews[0];
            const itemSize = WEBGL_TYPE_SIZES[accessorDef.type];
            const TypedArray = WEBGL_COMPONENT_TYPES[accessorDef.componentType];
            const elementBytes = TypedArray.BYTES_PER_ELEMENT;
            const itemBytes = elementBytes * itemSize;
            const byteOffset = accessorDef.byteOffset || 0;
            const byteStride = accessorDef.bufferView !== void 0 ? json.bufferViews[accessorDef.bufferView].byteStride : void 0;
            const normalized = accessorDef.normalized === true;
            let array, bufferAttribute;
            if (byteStride && byteStride !== itemBytes) {
                const ibSlice = Math.floor(byteOffset / byteStride);
                const ibCacheKey = "InterleavedBuffer:" + accessorDef.bufferView + ":" + accessorDef.componentType + ":" + ibSlice + ":" + accessorDef.count;
                let ib = parser.cache.get(ibCacheKey);
                if (!ib) {
                    array = new TypedArray(bufferView, ibSlice * byteStride, accessorDef.count * byteStride / elementBytes);
                    ib = new (0, _three.InterleavedBuffer)(array, byteStride / elementBytes);
                    parser.cache.add(ibCacheKey, ib);
                }
                bufferAttribute = new (0, _three.InterleavedBufferAttribute)(ib, itemSize, byteOffset % byteStride / elementBytes, normalized);
            } else {
                if (bufferView === null) array = new TypedArray(accessorDef.count * itemSize);
                else array = new TypedArray(bufferView, byteOffset, accessorDef.count * itemSize);
                bufferAttribute = new (0, _three.BufferAttribute)(array, itemSize, normalized);
            }
            if (accessorDef.sparse !== void 0) {
                const itemSizeIndices = WEBGL_TYPE_SIZES.SCALAR;
                const TypedArrayIndices = WEBGL_COMPONENT_TYPES[accessorDef.sparse.indices.componentType];
                const byteOffsetIndices = accessorDef.sparse.indices.byteOffset || 0;
                const byteOffsetValues = accessorDef.sparse.values.byteOffset || 0;
                const sparseIndices = new TypedArrayIndices(bufferViews[1], byteOffsetIndices, accessorDef.sparse.count * itemSizeIndices);
                const sparseValues = new TypedArray(bufferViews[2], byteOffsetValues, accessorDef.sparse.count * itemSize);
                if (bufferView !== null) bufferAttribute = new (0, _three.BufferAttribute)(bufferAttribute.array.slice(), bufferAttribute.itemSize, bufferAttribute.normalized);
                for(let i = 0, il = sparseIndices.length; i < il; i++){
                    const index = sparseIndices[i];
                    bufferAttribute.setX(index, sparseValues[i * itemSize]);
                    if (itemSize >= 2) bufferAttribute.setY(index, sparseValues[i * itemSize + 1]);
                    if (itemSize >= 3) bufferAttribute.setZ(index, sparseValues[i * itemSize + 2]);
                    if (itemSize >= 4) bufferAttribute.setW(index, sparseValues[i * itemSize + 3]);
                    if (itemSize >= 5) throw new Error("THREE.GLTFLoader: Unsupported itemSize in sparse BufferAttribute.");
                }
            }
            return bufferAttribute;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#textures
   * @param {number} textureIndex
   * @return {Promise<THREE.Texture|null>}
   */ loadTexture(textureIndex) {
        const json = this.json;
        const options = this.options;
        const textureDef = json.textures[textureIndex];
        const sourceIndex = textureDef.source;
        const sourceDef = json.images[sourceIndex];
        let loader = this.textureLoader;
        if (sourceDef.uri) {
            const handler = options.manager.getHandler(sourceDef.uri);
            if (handler !== null) loader = handler;
        }
        return this.loadTextureImage(textureIndex, sourceIndex, loader);
    }
    loadTextureImage(textureIndex, sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const textureDef = json.textures[textureIndex];
        const sourceDef = json.images[sourceIndex];
        const cacheKey = (sourceDef.uri || sourceDef.bufferView) + ":" + textureDef.sampler;
        if (this.textureCache[cacheKey]) return this.textureCache[cacheKey];
        const promise = this.loadImageSource(sourceIndex, loader).then(function(texture) {
            texture.flipY = false;
            texture.name = textureDef.name || sourceDef.name || "";
            if (texture.name === "" && typeof sourceDef.uri === "string" && sourceDef.uri.startsWith("data:image/") === false) texture.name = sourceDef.uri;
            const samplers = json.samplers || {};
            const sampler = samplers[textureDef.sampler] || {};
            texture.magFilter = WEBGL_FILTERS[sampler.magFilter] || (0, _three.LinearFilter);
            texture.minFilter = WEBGL_FILTERS[sampler.minFilter] || (0, _three.LinearMipmapLinearFilter);
            texture.wrapS = WEBGL_WRAPPINGS[sampler.wrapS] || (0, _three.RepeatWrapping);
            texture.wrapT = WEBGL_WRAPPINGS[sampler.wrapT] || (0, _three.RepeatWrapping);
            parser.associations.set(texture, {
                textures: textureIndex
            });
            return texture;
        }).catch(function() {
            return null;
        });
        this.textureCache[cacheKey] = promise;
        return promise;
    }
    loadImageSource(sourceIndex, loader) {
        const parser = this;
        const json = this.json;
        const options = this.options;
        if (this.sourceCache[sourceIndex] !== void 0) return this.sourceCache[sourceIndex].then((texture)=>texture.clone());
        const sourceDef = json.images[sourceIndex];
        const URL = self.URL || self.webkitURL;
        let sourceURI = sourceDef.uri || "";
        let isObjectURL = false;
        if (sourceDef.bufferView !== void 0) sourceURI = parser.getDependency("bufferView", sourceDef.bufferView).then(function(bufferView) {
            isObjectURL = true;
            const blob = new Blob([
                bufferView
            ], {
                type: sourceDef.mimeType
            });
            sourceURI = URL.createObjectURL(blob);
            return sourceURI;
        });
        else if (sourceDef.uri === void 0) throw new Error("THREE.GLTFLoader: Image " + sourceIndex + " is missing URI and bufferView");
        const promise = Promise.resolve(sourceURI).then(function(sourceURI2) {
            return new Promise(function(resolve, reject) {
                let onLoad = resolve;
                if (loader.isImageBitmapLoader === true) onLoad = function(imageBitmap) {
                    const texture = new (0, _three.Texture)(imageBitmap);
                    texture.needsUpdate = true;
                    resolve(texture);
                };
                loader.load((0, _three.LoaderUtils).resolveURL(sourceURI2, options.path), onLoad, void 0, reject);
            });
        }).then(function(texture) {
            if (isObjectURL === true) URL.revokeObjectURL(sourceURI);
            assignExtrasToUserData(texture, sourceDef);
            texture.userData.mimeType = sourceDef.mimeType || getImageURIMimeType(sourceDef.uri);
            return texture;
        }).catch(function(error) {
            console.error("THREE.GLTFLoader: Couldn't load texture", sourceURI);
            throw error;
        });
        this.sourceCache[sourceIndex] = promise;
        return promise;
    }
    /**
   * Asynchronously assigns a texture to the given material parameters.
   * @param {Object} materialParams
   * @param {string} mapName
   * @param {Object} mapDef
   * @return {Promise<Texture>}
   */ assignTexture(materialParams, mapName, mapDef, colorSpace) {
        const parser = this;
        return this.getDependency("texture", mapDef.index).then(function(texture) {
            if (!texture) return null;
            if (mapDef.texCoord !== void 0 && mapDef.texCoord > 0) {
                texture = texture.clone();
                texture.channel = mapDef.texCoord;
            }
            if (parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM]) {
                const transform = mapDef.extensions !== void 0 ? mapDef.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM] : void 0;
                if (transform) {
                    const gltfReference = parser.associations.get(texture);
                    texture = parser.extensions[EXTENSIONS.KHR_TEXTURE_TRANSFORM].extendTexture(texture, transform);
                    parser.associations.set(texture, gltfReference);
                }
            }
            if (colorSpace !== void 0) {
                if (typeof colorSpace === "number") colorSpace = colorSpace === sRGBEncoding ? SRGBColorSpace : LinearSRGBColorSpace;
                if ("colorSpace" in texture) texture.colorSpace = colorSpace;
                else texture.encoding = colorSpace === SRGBColorSpace ? sRGBEncoding : LinearEncoding;
            }
            materialParams[mapName] = texture;
            return texture;
        });
    }
    /**
   * Assigns final material to a Mesh, Line, or Points instance. The instance
   * already has a material (generated from the glTF material options alone)
   * but reuse of the same glTF material may require multiple threejs materials
   * to accommodate different primitive types, defines, etc. New materials will
   * be created if necessary, and reused from a cache.
   * @param  {Object3D} mesh Mesh, Line, or Points instance.
   */ assignFinalMaterial(mesh) {
        const geometry = mesh.geometry;
        let material = mesh.material;
        const useDerivativeTangents = geometry.attributes.tangent === void 0;
        const useVertexColors = geometry.attributes.color !== void 0;
        const useFlatShading = geometry.attributes.normal === void 0;
        if (mesh.isPoints) {
            const cacheKey = "PointsMaterial:" + material.uuid;
            let pointsMaterial = this.cache.get(cacheKey);
            if (!pointsMaterial) {
                pointsMaterial = new (0, _three.PointsMaterial)();
                (0, _three.Material).prototype.copy.call(pointsMaterial, material);
                pointsMaterial.color.copy(material.color);
                pointsMaterial.map = material.map;
                pointsMaterial.sizeAttenuation = false;
                this.cache.add(cacheKey, pointsMaterial);
            }
            material = pointsMaterial;
        } else if (mesh.isLine) {
            const cacheKey = "LineBasicMaterial:" + material.uuid;
            let lineMaterial = this.cache.get(cacheKey);
            if (!lineMaterial) {
                lineMaterial = new (0, _three.LineBasicMaterial)();
                (0, _three.Material).prototype.copy.call(lineMaterial, material);
                lineMaterial.color.copy(material.color);
                lineMaterial.map = material.map;
                this.cache.add(cacheKey, lineMaterial);
            }
            material = lineMaterial;
        }
        if (useDerivativeTangents || useVertexColors || useFlatShading) {
            let cacheKey = "ClonedMaterial:" + material.uuid + ":";
            if (useDerivativeTangents) cacheKey += "derivative-tangents:";
            if (useVertexColors) cacheKey += "vertex-colors:";
            if (useFlatShading) cacheKey += "flat-shading:";
            let cachedMaterial = this.cache.get(cacheKey);
            if (!cachedMaterial) {
                cachedMaterial = material.clone();
                if (useVertexColors) cachedMaterial.vertexColors = true;
                if (useFlatShading) cachedMaterial.flatShading = true;
                if (useDerivativeTangents) {
                    if (cachedMaterial.normalScale) cachedMaterial.normalScale.y *= -1;
                    if (cachedMaterial.clearcoatNormalScale) cachedMaterial.clearcoatNormalScale.y *= -1;
                }
                this.cache.add(cacheKey, cachedMaterial);
                this.associations.set(cachedMaterial, this.associations.get(material));
            }
            material = cachedMaterial;
        }
        mesh.material = material;
    }
    getMaterialType() {
        return 0, _three.MeshStandardMaterial;
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#materials
   * @param {number} materialIndex
   * @return {Promise<Material>}
   */ loadMaterial(materialIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const materialDef = json.materials[materialIndex];
        let materialType;
        const materialParams = {};
        const materialExtensions = materialDef.extensions || {};
        const pending = [];
        if (materialExtensions[EXTENSIONS.KHR_MATERIALS_UNLIT]) {
            const kmuExtension = extensions[EXTENSIONS.KHR_MATERIALS_UNLIT];
            materialType = kmuExtension.getMaterialType();
            pending.push(kmuExtension.extendParams(materialParams, materialDef, parser));
        } else {
            const metallicRoughness = materialDef.pbrMetallicRoughness || {};
            materialParams.color = new (0, _three.Color)(1, 1, 1);
            materialParams.opacity = 1;
            if (Array.isArray(metallicRoughness.baseColorFactor)) {
                const array = metallicRoughness.baseColorFactor;
                materialParams.color.setRGB(array[0], array[1], array[2], LinearSRGBColorSpace);
                materialParams.opacity = array[3];
            }
            if (metallicRoughness.baseColorTexture !== void 0) pending.push(parser.assignTexture(materialParams, "map", metallicRoughness.baseColorTexture, SRGBColorSpace));
            materialParams.metalness = metallicRoughness.metallicFactor !== void 0 ? metallicRoughness.metallicFactor : 1;
            materialParams.roughness = metallicRoughness.roughnessFactor !== void 0 ? metallicRoughness.roughnessFactor : 1;
            if (metallicRoughness.metallicRoughnessTexture !== void 0) {
                pending.push(parser.assignTexture(materialParams, "metalnessMap", metallicRoughness.metallicRoughnessTexture));
                pending.push(parser.assignTexture(materialParams, "roughnessMap", metallicRoughness.metallicRoughnessTexture));
            }
            materialType = this._invokeOne(function(ext) {
                return ext.getMaterialType && ext.getMaterialType(materialIndex);
            });
            pending.push(Promise.all(this._invokeAll(function(ext) {
                return ext.extendMaterialParams && ext.extendMaterialParams(materialIndex, materialParams);
            })));
        }
        if (materialDef.doubleSided === true) materialParams.side = (0, _three.DoubleSide);
        const alphaMode = materialDef.alphaMode || ALPHA_MODES.OPAQUE;
        if (alphaMode === ALPHA_MODES.BLEND) {
            materialParams.transparent = true;
            materialParams.depthWrite = false;
        } else {
            materialParams.transparent = false;
            if (alphaMode === ALPHA_MODES.MASK) materialParams.alphaTest = materialDef.alphaCutoff !== void 0 ? materialDef.alphaCutoff : 0.5;
        }
        if (materialDef.normalTexture !== void 0 && materialType !== (0, _three.MeshBasicMaterial)) {
            pending.push(parser.assignTexture(materialParams, "normalMap", materialDef.normalTexture));
            materialParams.normalScale = new (0, _three.Vector2)(1, 1);
            if (materialDef.normalTexture.scale !== void 0) {
                const scale = materialDef.normalTexture.scale;
                materialParams.normalScale.set(scale, scale);
            }
        }
        if (materialDef.occlusionTexture !== void 0 && materialType !== (0, _three.MeshBasicMaterial)) {
            pending.push(parser.assignTexture(materialParams, "aoMap", materialDef.occlusionTexture));
            if (materialDef.occlusionTexture.strength !== void 0) materialParams.aoMapIntensity = materialDef.occlusionTexture.strength;
        }
        if (materialDef.emissiveFactor !== void 0 && materialType !== (0, _three.MeshBasicMaterial)) {
            const emissiveFactor = materialDef.emissiveFactor;
            materialParams.emissive = new (0, _three.Color)().setRGB(emissiveFactor[0], emissiveFactor[1], emissiveFactor[2], LinearSRGBColorSpace);
        }
        if (materialDef.emissiveTexture !== void 0 && materialType !== (0, _three.MeshBasicMaterial)) pending.push(parser.assignTexture(materialParams, "emissiveMap", materialDef.emissiveTexture, SRGBColorSpace));
        return Promise.all(pending).then(function() {
            const material = new materialType(materialParams);
            if (materialDef.name) material.name = materialDef.name;
            assignExtrasToUserData(material, materialDef);
            parser.associations.set(material, {
                materials: materialIndex
            });
            if (materialDef.extensions) addUnknownExtensionsToUserData(extensions, material, materialDef);
            return material;
        });
    }
    /** When Object3D instances are targeted by animation, they need unique names. */ createUniqueName(originalName) {
        const sanitizedName = (0, _three.PropertyBinding).sanitizeNodeName(originalName || "");
        if (sanitizedName in this.nodeNamesUsed) return sanitizedName + "_" + ++this.nodeNamesUsed[sanitizedName];
        else {
            this.nodeNamesUsed[sanitizedName] = 0;
            return sanitizedName;
        }
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#geometry
   *
   * Creates BufferGeometries from primitives.
   *
   * @param {Array<GLTF.Primitive>} primitives
   * @return {Promise<Array<BufferGeometry>>}
   */ loadGeometries(primitives) {
        const parser = this;
        const extensions = this.extensions;
        const cache = this.primitiveCache;
        function createDracoPrimitive(primitive) {
            return extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION].decodePrimitive(primitive, parser).then(function(geometry) {
                return addPrimitiveAttributes(geometry, primitive, parser);
            });
        }
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const primitive = primitives[i];
            const cacheKey = createPrimitiveKey(primitive);
            const cached = cache[cacheKey];
            if (cached) pending.push(cached.promise);
            else {
                let geometryPromise;
                if (primitive.extensions && primitive.extensions[EXTENSIONS.KHR_DRACO_MESH_COMPRESSION]) geometryPromise = createDracoPrimitive(primitive);
                else geometryPromise = addPrimitiveAttributes(new (0, _three.BufferGeometry)(), primitive, parser);
                cache[cacheKey] = {
                    primitive,
                    promise: geometryPromise
                };
                pending.push(geometryPromise);
            }
        }
        return Promise.all(pending);
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/blob/master/specification/2.0/README.md#meshes
   * @param {number} meshIndex
   * @return {Promise<Group|Mesh|SkinnedMesh>}
   */ loadMesh(meshIndex) {
        const parser = this;
        const json = this.json;
        const extensions = this.extensions;
        const meshDef = json.meshes[meshIndex];
        const primitives = meshDef.primitives;
        const pending = [];
        for(let i = 0, il = primitives.length; i < il; i++){
            const material = primitives[i].material === void 0 ? createDefaultMaterial(this.cache) : this.getDependency("material", primitives[i].material);
            pending.push(material);
        }
        pending.push(parser.loadGeometries(primitives));
        return Promise.all(pending).then(function(results) {
            const materials = results.slice(0, results.length - 1);
            const geometries = results[results.length - 1];
            const meshes = [];
            for(let i = 0, il = geometries.length; i < il; i++){
                const geometry = geometries[i];
                const primitive = primitives[i];
                let mesh;
                const material = materials[i];
                if (primitive.mode === WEBGL_CONSTANTS.TRIANGLES || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP || primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN || primitive.mode === void 0) {
                    mesh = meshDef.isSkinnedMesh === true ? new (0, _three.SkinnedMesh)(geometry, material) : new (0, _three.Mesh)(geometry, material);
                    if (mesh.isSkinnedMesh === true) mesh.normalizeSkinWeights();
                    if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_STRIP) mesh.geometry = (0, _bufferGeometryUtilsJs.toTrianglesDrawMode)(mesh.geometry, (0, _three.TriangleStripDrawMode));
                    else if (primitive.mode === WEBGL_CONSTANTS.TRIANGLE_FAN) mesh.geometry = (0, _bufferGeometryUtilsJs.toTrianglesDrawMode)(mesh.geometry, (0, _three.TriangleFanDrawMode));
                } else if (primitive.mode === WEBGL_CONSTANTS.LINES) mesh = new (0, _three.LineSegments)(geometry, material);
                else if (primitive.mode === WEBGL_CONSTANTS.LINE_STRIP) mesh = new (0, _three.Line)(geometry, material);
                else if (primitive.mode === WEBGL_CONSTANTS.LINE_LOOP) mesh = new (0, _three.LineLoop)(geometry, material);
                else if (primitive.mode === WEBGL_CONSTANTS.POINTS) mesh = new (0, _three.Points)(geometry, material);
                else throw new Error("THREE.GLTFLoader: Primitive mode unsupported: " + primitive.mode);
                if (Object.keys(mesh.geometry.morphAttributes).length > 0) updateMorphTargets(mesh, meshDef);
                mesh.name = parser.createUniqueName(meshDef.name || "mesh_" + meshIndex);
                assignExtrasToUserData(mesh, meshDef);
                if (primitive.extensions) addUnknownExtensionsToUserData(extensions, mesh, primitive);
                parser.assignFinalMaterial(mesh);
                meshes.push(mesh);
            }
            for(let i = 0, il = meshes.length; i < il; i++)parser.associations.set(meshes[i], {
                meshes: meshIndex,
                primitives: i
            });
            if (meshes.length === 1) {
                if (meshDef.extensions) addUnknownExtensionsToUserData(extensions, meshes[0], meshDef);
                return meshes[0];
            }
            const group = new (0, _three.Group)();
            if (meshDef.extensions) addUnknownExtensionsToUserData(extensions, group, meshDef);
            parser.associations.set(group, {
                meshes: meshIndex
            });
            for(let i = 0, il = meshes.length; i < il; i++)group.add(meshes[i]);
            return group;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#cameras
   * @param {number} cameraIndex
   * @return {Promise<THREE.Camera>}
   */ loadCamera(cameraIndex) {
        let camera;
        const cameraDef = this.json.cameras[cameraIndex];
        const params = cameraDef[cameraDef.type];
        if (!params) {
            console.warn("THREE.GLTFLoader: Missing camera parameters.");
            return;
        }
        if (cameraDef.type === "perspective") camera = new (0, _three.PerspectiveCamera)((0, _three.MathUtils).radToDeg(params.yfov), params.aspectRatio || 1, params.znear || 1, params.zfar || 2e6);
        else if (cameraDef.type === "orthographic") camera = new (0, _three.OrthographicCamera)(-params.xmag, params.xmag, params.ymag, -params.ymag, params.znear, params.zfar);
        if (cameraDef.name) camera.name = this.createUniqueName(cameraDef.name);
        assignExtrasToUserData(camera, cameraDef);
        return Promise.resolve(camera);
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#skins
   * @param {number} skinIndex
   * @return {Promise<Skeleton>}
   */ loadSkin(skinIndex) {
        const skinDef = this.json.skins[skinIndex];
        const pending = [];
        for(let i = 0, il = skinDef.joints.length; i < il; i++)pending.push(this._loadNodeShallow(skinDef.joints[i]));
        if (skinDef.inverseBindMatrices !== void 0) pending.push(this.getDependency("accessor", skinDef.inverseBindMatrices));
        else pending.push(null);
        return Promise.all(pending).then(function(results) {
            const inverseBindMatrices = results.pop();
            const jointNodes = results;
            const bones = [];
            const boneInverses = [];
            for(let i = 0, il = jointNodes.length; i < il; i++){
                const jointNode = jointNodes[i];
                if (jointNode) {
                    bones.push(jointNode);
                    const mat = new (0, _three.Matrix4)();
                    if (inverseBindMatrices !== null) mat.fromArray(inverseBindMatrices.array, i * 16);
                    boneInverses.push(mat);
                } else console.warn('THREE.GLTFLoader: Joint "%s" could not be found.', skinDef.joints[i]);
            }
            return new (0, _three.Skeleton)(bones, boneInverses);
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#animations
   * @param {number} animationIndex
   * @return {Promise<AnimationClip>}
   */ loadAnimation(animationIndex) {
        const json = this.json;
        const parser = this;
        const animationDef = json.animations[animationIndex];
        const animationName = animationDef.name ? animationDef.name : "animation_" + animationIndex;
        const pendingNodes = [];
        const pendingInputAccessors = [];
        const pendingOutputAccessors = [];
        const pendingSamplers = [];
        const pendingTargets = [];
        for(let i = 0, il = animationDef.channels.length; i < il; i++){
            const channel = animationDef.channels[i];
            const sampler = animationDef.samplers[channel.sampler];
            const target = channel.target;
            const name = target.node;
            const input = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.input] : sampler.input;
            const output = animationDef.parameters !== void 0 ? animationDef.parameters[sampler.output] : sampler.output;
            if (target.node === void 0) continue;
            pendingNodes.push(this.getDependency("node", name));
            pendingInputAccessors.push(this.getDependency("accessor", input));
            pendingOutputAccessors.push(this.getDependency("accessor", output));
            pendingSamplers.push(sampler);
            pendingTargets.push(target);
        }
        return Promise.all([
            Promise.all(pendingNodes),
            Promise.all(pendingInputAccessors),
            Promise.all(pendingOutputAccessors),
            Promise.all(pendingSamplers),
            Promise.all(pendingTargets)
        ]).then(function(dependencies) {
            const nodes = dependencies[0];
            const inputAccessors = dependencies[1];
            const outputAccessors = dependencies[2];
            const samplers = dependencies[3];
            const targets = dependencies[4];
            const tracks = [];
            for(let i = 0, il = nodes.length; i < il; i++){
                const node = nodes[i];
                const inputAccessor = inputAccessors[i];
                const outputAccessor = outputAccessors[i];
                const sampler = samplers[i];
                const target = targets[i];
                if (node === void 0) continue;
                if (node.updateMatrix) node.updateMatrix();
                const createdTracks = parser._createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target);
                if (createdTracks) for(let k = 0; k < createdTracks.length; k++)tracks.push(createdTracks[k]);
            }
            return new (0, _three.AnimationClip)(animationName, void 0, tracks);
        });
    }
    createNodeMesh(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        if (nodeDef.mesh === void 0) return null;
        return parser.getDependency("mesh", nodeDef.mesh).then(function(mesh) {
            const node = parser._getNodeRef(parser.meshCache, nodeDef.mesh, mesh);
            if (nodeDef.weights !== void 0) node.traverse(function(o) {
                if (!o.isMesh) return;
                for(let i = 0, il = nodeDef.weights.length; i < il; i++)o.morphTargetInfluences[i] = nodeDef.weights[i];
            });
            return node;
        });
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#nodes-and-hierarchy
   * @param {number} nodeIndex
   * @return {Promise<Object3D>}
   */ loadNode(nodeIndex) {
        const json = this.json;
        const parser = this;
        const nodeDef = json.nodes[nodeIndex];
        const nodePending = parser._loadNodeShallow(nodeIndex);
        const childPending = [];
        const childrenDef = nodeDef.children || [];
        for(let i = 0, il = childrenDef.length; i < il; i++)childPending.push(parser.getDependency("node", childrenDef[i]));
        const skeletonPending = nodeDef.skin === void 0 ? Promise.resolve(null) : parser.getDependency("skin", nodeDef.skin);
        return Promise.all([
            nodePending,
            Promise.all(childPending),
            skeletonPending
        ]).then(function(results) {
            const node = results[0];
            const children = results[1];
            const skeleton = results[2];
            if (skeleton !== null) node.traverse(function(mesh) {
                if (!mesh.isSkinnedMesh) return;
                mesh.bind(skeleton, _identityMatrix);
            });
            for(let i = 0, il = children.length; i < il; i++)node.add(children[i]);
            return node;
        });
    }
    // ._loadNodeShallow() parses a single node.
    // skin and child nodes are created and added in .loadNode() (no '_' prefix).
    _loadNodeShallow(nodeIndex) {
        const json = this.json;
        const extensions = this.extensions;
        const parser = this;
        if (this.nodeCache[nodeIndex] !== void 0) return this.nodeCache[nodeIndex];
        const nodeDef = json.nodes[nodeIndex];
        const nodeName = nodeDef.name ? parser.createUniqueName(nodeDef.name) : "";
        const pending = [];
        const meshPromise = parser._invokeOne(function(ext) {
            return ext.createNodeMesh && ext.createNodeMesh(nodeIndex);
        });
        if (meshPromise) pending.push(meshPromise);
        if (nodeDef.camera !== void 0) pending.push(parser.getDependency("camera", nodeDef.camera).then(function(camera) {
            return parser._getNodeRef(parser.cameraCache, nodeDef.camera, camera);
        }));
        parser._invokeAll(function(ext) {
            return ext.createNodeAttachment && ext.createNodeAttachment(nodeIndex);
        }).forEach(function(promise) {
            pending.push(promise);
        });
        this.nodeCache[nodeIndex] = Promise.all(pending).then(function(objects) {
            let node;
            if (nodeDef.isBone === true) node = new (0, _three.Bone)();
            else if (objects.length > 1) node = new (0, _three.Group)();
            else if (objects.length === 1) node = objects[0];
            else node = new (0, _three.Object3D)();
            if (node !== objects[0]) for(let i = 0, il = objects.length; i < il; i++)node.add(objects[i]);
            if (nodeDef.name) {
                node.userData.name = nodeDef.name;
                node.name = nodeName;
            }
            assignExtrasToUserData(node, nodeDef);
            if (nodeDef.extensions) addUnknownExtensionsToUserData(extensions, node, nodeDef);
            if (nodeDef.matrix !== void 0) {
                const matrix = new (0, _three.Matrix4)();
                matrix.fromArray(nodeDef.matrix);
                node.applyMatrix4(matrix);
            } else {
                if (nodeDef.translation !== void 0) node.position.fromArray(nodeDef.translation);
                if (nodeDef.rotation !== void 0) node.quaternion.fromArray(nodeDef.rotation);
                if (nodeDef.scale !== void 0) node.scale.fromArray(nodeDef.scale);
            }
            if (!parser.associations.has(node)) parser.associations.set(node, {});
            parser.associations.get(node).nodes = nodeIndex;
            return node;
        });
        return this.nodeCache[nodeIndex];
    }
    /**
   * Specification: https://github.com/KhronosGroup/glTF/tree/master/specification/2.0#scenes
   * @param {number} sceneIndex
   * @return {Promise<Group>}
   */ loadScene(sceneIndex) {
        const extensions = this.extensions;
        const sceneDef = this.json.scenes[sceneIndex];
        const parser = this;
        const scene = new (0, _three.Group)();
        if (sceneDef.name) scene.name = parser.createUniqueName(sceneDef.name);
        assignExtrasToUserData(scene, sceneDef);
        if (sceneDef.extensions) addUnknownExtensionsToUserData(extensions, scene, sceneDef);
        const nodeIds = sceneDef.nodes || [];
        const pending = [];
        for(let i = 0, il = nodeIds.length; i < il; i++)pending.push(parser.getDependency("node", nodeIds[i]));
        return Promise.all(pending).then(function(nodes) {
            for(let i = 0, il = nodes.length; i < il; i++)scene.add(nodes[i]);
            const reduceAssociations = (node)=>{
                const reducedAssociations = /* @__PURE__ */ new Map();
                for (const [key, value] of parser.associations)if (key instanceof (0, _three.Material) || key instanceof (0, _three.Texture)) reducedAssociations.set(key, value);
                node.traverse((node2)=>{
                    const mappings = parser.associations.get(node2);
                    if (mappings != null) reducedAssociations.set(node2, mappings);
                });
                return reducedAssociations;
            };
            parser.associations = reduceAssociations(scene);
            return scene;
        });
    }
    _createAnimationTracks(node, inputAccessor, outputAccessor, sampler, target) {
        const tracks = [];
        const targetName = node.name ? node.name : node.uuid;
        const targetNames = [];
        if (PATH_PROPERTIES[target.path] === PATH_PROPERTIES.weights) node.traverse(function(object) {
            if (object.morphTargetInfluences) targetNames.push(object.name ? object.name : object.uuid);
        });
        else targetNames.push(targetName);
        let TypedKeyframeTrack;
        switch(PATH_PROPERTIES[target.path]){
            case PATH_PROPERTIES.weights:
                TypedKeyframeTrack = (0, _three.NumberKeyframeTrack);
                break;
            case PATH_PROPERTIES.rotation:
                TypedKeyframeTrack = (0, _three.QuaternionKeyframeTrack);
                break;
            case PATH_PROPERTIES.position:
            case PATH_PROPERTIES.scale:
                TypedKeyframeTrack = (0, _three.VectorKeyframeTrack);
                break;
            default:
                switch(outputAccessor.itemSize){
                    case 1:
                        TypedKeyframeTrack = (0, _three.NumberKeyframeTrack);
                        break;
                    case 2:
                    case 3:
                    default:
                        TypedKeyframeTrack = (0, _three.VectorKeyframeTrack);
                        break;
                }
                break;
        }
        const interpolation = sampler.interpolation !== void 0 ? INTERPOLATION[sampler.interpolation] : (0, _three.InterpolateLinear);
        const outputArray = this._getArrayFromAccessor(outputAccessor);
        for(let j = 0, jl = targetNames.length; j < jl; j++){
            const track = new TypedKeyframeTrack(targetNames[j] + "." + PATH_PROPERTIES[target.path], inputAccessor.array, outputArray, interpolation);
            if (sampler.interpolation === "CUBICSPLINE") this._createCubicSplineTrackInterpolant(track);
            tracks.push(track);
        }
        return tracks;
    }
    _getArrayFromAccessor(accessor) {
        let outputArray = accessor.array;
        if (accessor.normalized) {
            const scale = getNormalizedComponentScale(outputArray.constructor);
            const scaled = new Float32Array(outputArray.length);
            for(let j = 0, jl = outputArray.length; j < jl; j++)scaled[j] = outputArray[j] * scale;
            outputArray = scaled;
        }
        return outputArray;
    }
    _createCubicSplineTrackInterpolant(track) {
        track.createInterpolant = function InterpolantFactoryMethodGLTFCubicSpline(result) {
            const interpolantType = this instanceof (0, _three.QuaternionKeyframeTrack) ? GLTFCubicSplineQuaternionInterpolant : GLTFCubicSplineInterpolant;
            return new interpolantType(this.times, this.values, this.getValueSize() / 3, result);
        };
        track.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline = true;
    }
}
function computeBounds(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const box = new (0, _three.Box3)();
    if (attributes.POSITION !== void 0) {
        const accessor = parser.json.accessors[attributes.POSITION];
        const min = accessor.min;
        const max = accessor.max;
        if (min !== void 0 && max !== void 0) {
            box.set(new (0, _three.Vector3)(min[0], min[1], min[2]), new (0, _three.Vector3)(max[0], max[1], max[2]));
            if (accessor.normalized) {
                const boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
                box.min.multiplyScalar(boxScale);
                box.max.multiplyScalar(boxScale);
            }
        } else {
            console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            return;
        }
    } else return;
    const targets = primitiveDef.targets;
    if (targets !== void 0) {
        const maxDisplacement = new (0, _three.Vector3)();
        const vector = new (0, _three.Vector3)();
        for(let i = 0, il = targets.length; i < il; i++){
            const target = targets[i];
            if (target.POSITION !== void 0) {
                const accessor = parser.json.accessors[target.POSITION];
                const min = accessor.min;
                const max = accessor.max;
                if (min !== void 0 && max !== void 0) {
                    vector.setX(Math.max(Math.abs(min[0]), Math.abs(max[0])));
                    vector.setY(Math.max(Math.abs(min[1]), Math.abs(max[1])));
                    vector.setZ(Math.max(Math.abs(min[2]), Math.abs(max[2])));
                    if (accessor.normalized) {
                        const boxScale = getNormalizedComponentScale(WEBGL_COMPONENT_TYPES[accessor.componentType]);
                        vector.multiplyScalar(boxScale);
                    }
                    maxDisplacement.max(vector);
                } else console.warn("THREE.GLTFLoader: Missing min/max properties for accessor POSITION.");
            }
        }
        box.expandByVector(maxDisplacement);
    }
    geometry.boundingBox = box;
    const sphere = new (0, _three.Sphere)();
    box.getCenter(sphere.center);
    sphere.radius = box.min.distanceTo(box.max) / 2;
    geometry.boundingSphere = sphere;
}
function addPrimitiveAttributes(geometry, primitiveDef, parser) {
    const attributes = primitiveDef.attributes;
    const pending = [];
    function assignAttributeAccessor(accessorIndex, attributeName) {
        return parser.getDependency("accessor", accessorIndex).then(function(accessor) {
            geometry.setAttribute(attributeName, accessor);
        });
    }
    for(const gltfAttributeName in attributes){
        const threeAttributeName = ATTRIBUTES[gltfAttributeName] || gltfAttributeName.toLowerCase();
        if (threeAttributeName in geometry.attributes) continue;
        pending.push(assignAttributeAccessor(attributes[gltfAttributeName], threeAttributeName));
    }
    if (primitiveDef.indices !== void 0 && !geometry.index) {
        const accessor = parser.getDependency("accessor", primitiveDef.indices).then(function(accessor2) {
            geometry.setIndex(accessor2);
        });
        pending.push(accessor);
    }
    assignExtrasToUserData(geometry, primitiveDef);
    computeBounds(geometry, primitiveDef, parser);
    return Promise.all(pending).then(function() {
        return primitiveDef.targets !== void 0 ? addMorphTargets(geometry, primitiveDef.targets, parser) : geometry;
    });
}

},{"three":[["AnimationClip","bihzc"],["Bone","bihzc"],["Box3","bihzc"],["DirectionalLight","bihzc"],["FileLoader","bihzc"],["Group","bihzc"],["ImageBitmapLoader","bihzc"],["InstancedBufferAttribute","bihzc"],["InstancedMesh","bihzc"],["InterleavedBuffer","bihzc"],["InterleavedBufferAttribute","bihzc"],["Interpolant","bihzc"],["InterpolateDiscrete","bihzc"],["InterpolateLinear","bihzc"],["Line","bihzc"],["LineBasicMaterial","bihzc"],["LineLoop","bihzc"],["LineSegments","bihzc"],["Loader","bihzc"],["LoaderUtils","bihzc"],["Material","bihzc"],["MathUtils","bihzc"],["MeshPhysicalMaterial","bihzc"],["MeshStandardMaterial","bihzc"],["NumberKeyframeTrack","bihzc"],["Object3D","bihzc"],["PointLight","bihzc"],["Points","bihzc"],["PointsMaterial","bihzc"],["PropertyBinding","bihzc"],["Quaternion","bihzc"],["QuaternionKeyframeTrack","bihzc"],["Skeleton","bihzc"],["SkinnedMesh","bihzc"],["Sphere","bihzc"],["SpotLight","bihzc"],["TextureLoader","bihzc"],["TriangleFanDrawMode","bihzc"],["TriangleStripDrawMode","bihzc"],["VectorKeyframeTrack","bihzc"],["BufferAttribute","hZcQL"],["BufferGeometry","hZcQL"],["ClampToEdgeWrapping","hZcQL"],["Color","hZcQL"],["DoubleSide","hZcQL"],["FrontSide","hZcQL"],["LinearFilter","hZcQL"],["LinearMipmapLinearFilter","hZcQL"],["LinearMipmapNearestFilter","hZcQL"],["Matrix4","hZcQL"],["Mesh","hZcQL"],["MeshBasicMaterial","hZcQL"],["MirroredRepeatWrapping","hZcQL"],["NearestFilter","hZcQL"],["NearestMipmapLinearFilter","hZcQL"],["NearestMipmapNearestFilter","hZcQL"],["OrthographicCamera","hZcQL"],["PerspectiveCamera","hZcQL"],["RepeatWrapping","hZcQL"],["Texture","hZcQL"],["Vector2","hZcQL"],["Vector3","hZcQL"]],"../utils/BufferGeometryUtils.js":"feuuj","../_polyfill/constants.js":"3ISzJ","../_polyfill/LoaderUtils.js":"ksNiW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"feuuj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "computeMorphedAttributes", ()=>computeMorphedAttributes);
parcelHelpers.export(exports, "estimateBytesUsed", ()=>estimateBytesUsed);
parcelHelpers.export(exports, "interleaveAttributes", ()=>interleaveAttributes);
parcelHelpers.export(exports, "mergeBufferAttributes", ()=>mergeBufferAttributes);
parcelHelpers.export(exports, "mergeBufferGeometries", ()=>mergeBufferGeometries);
parcelHelpers.export(exports, "mergeVertices", ()=>mergeVertices);
parcelHelpers.export(exports, "toCreasedNormals", ()=>toCreasedNormals);
parcelHelpers.export(exports, "toTrianglesDrawMode", ()=>toTrianglesDrawMode);
var _three = require("three");
var _helpersJs = require("../types/helpers.js");
const mergeBufferGeometries = (geometries, useGroups)=>{
    const isIndexed = geometries[0].index !== null;
    const attributesUsed = new Set(Object.keys(geometries[0].attributes));
    const morphAttributesUsed = new Set(Object.keys(geometries[0].morphAttributes));
    const attributes = {};
    const morphAttributes = {};
    const morphTargetsRelative = geometries[0].morphTargetsRelative;
    const mergedGeometry = new (0, _three.BufferGeometry)();
    let offset = 0;
    geometries.forEach((geom, i)=>{
        let attributesCount = 0;
        if (isIndexed !== (geom.index !== null)) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". All geometries must have compatible attributes; make sure index attribute exists among all geometries, or in none of them.");
            return null;
        }
        for(let name in geom.attributes){
            if (!attributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + '. All geometries must have compatible attributes; make sure "' + name + '" attribute exists among all geometries, or in none of them.');
                return null;
            }
            if (attributes[name] === void 0) attributes[name] = [];
            attributes[name].push(geom.attributes[name]);
            attributesCount++;
        }
        if (attributesCount !== attributesUsed.size) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". Make sure all geometries have the same number of attributes.");
            return null;
        }
        if (morphTargetsRelative !== geom.morphTargetsRelative) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". .morphTargetsRelative must be consistent throughout all geometries.");
            return null;
        }
        for(let name in geom.morphAttributes){
            if (!morphAttributesUsed.has(name)) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ".  .morphAttributes must be consistent throughout all geometries.");
                return null;
            }
            if (morphAttributes[name] === void 0) morphAttributes[name] = [];
            morphAttributes[name].push(geom.morphAttributes[name]);
        }
        mergedGeometry.userData.mergedUserData = mergedGeometry.userData.mergedUserData || [];
        mergedGeometry.userData.mergedUserData.push(geom.userData);
        if (useGroups) {
            let count;
            if (geom.index) count = geom.index.count;
            else if (geom.attributes.position !== void 0) count = geom.attributes.position.count;
            else {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed with geometry at index " + i + ". The geometry must have either an index or a position attribute");
                return null;
            }
            mergedGeometry.addGroup(offset, count, i);
            offset += count;
        }
    });
    if (isIndexed) {
        let indexOffset = 0;
        const mergedIndex = [];
        geometries.forEach((geom)=>{
            const index = geom.index;
            for(let j = 0; j < index.count; ++j)mergedIndex.push(index.getX(j) + indexOffset);
            indexOffset += geom.attributes.position.count;
        });
        mergedGeometry.setIndex(mergedIndex);
    }
    for(let name in attributes){
        const mergedAttribute = mergeBufferAttributes(attributes[name]);
        if (!mergedAttribute) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + name + " attribute.");
            return null;
        }
        mergedGeometry.setAttribute(name, mergedAttribute);
    }
    for(let name in morphAttributes){
        const numMorphTargets = morphAttributes[name][0].length;
        if (numMorphTargets === 0) break;
        mergedGeometry.morphAttributes = mergedGeometry.morphAttributes || {};
        mergedGeometry.morphAttributes[name] = [];
        for(let i = 0; i < numMorphTargets; ++i){
            const morphAttributesToMerge = [];
            for(let j = 0; j < morphAttributes[name].length; ++j)morphAttributesToMerge.push(morphAttributes[name][j][i]);
            const mergedMorphAttribute = mergeBufferAttributes(morphAttributesToMerge);
            if (!mergedMorphAttribute) {
                console.error("THREE.BufferGeometryUtils: .mergeBufferGeometries() failed while trying to merge the " + name + " morphAttribute.");
                return null;
            }
            mergedGeometry.morphAttributes[name].push(mergedMorphAttribute);
        }
    }
    return mergedGeometry;
};
const mergeBufferAttributes = (attributes)=>{
    let TypedArray = void 0;
    let itemSize = void 0;
    let normalized = void 0;
    let arrayLength = 0;
    attributes.forEach((attr)=>{
        if (TypedArray === void 0) TypedArray = attr.array.constructor;
        if (TypedArray !== attr.array.constructor) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.array must be of consistent array types across matching attributes.");
            return null;
        }
        if (itemSize === void 0) itemSize = attr.itemSize;
        if (itemSize !== attr.itemSize) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.itemSize must be consistent across matching attributes.");
            return null;
        }
        if (normalized === void 0) normalized = attr.normalized;
        if (normalized !== attr.normalized) {
            console.error("THREE.BufferGeometryUtils: .mergeBufferAttributes() failed. BufferAttribute.normalized must be consistent across matching attributes.");
            return null;
        }
        arrayLength += attr.array.length;
    });
    if (TypedArray && itemSize) {
        const array = new TypedArray(arrayLength);
        let offset = 0;
        attributes.forEach((attr)=>{
            array.set(attr.array, offset);
            offset += attr.array.length;
        });
        return new (0, _three.BufferAttribute)(array, itemSize, normalized);
    }
};
const interleaveAttributes = (attributes)=>{
    let TypedArray = void 0;
    let arrayLength = 0;
    let stride = 0;
    for(let i = 0, l = attributes.length; i < l; ++i){
        const attribute = attributes[i];
        if (TypedArray === void 0) TypedArray = attribute.array.constructor;
        if (TypedArray !== attribute.array.constructor) {
            console.error("AttributeBuffers of different types cannot be interleaved");
            return null;
        }
        arrayLength += attribute.array.length;
        stride += attribute.itemSize;
    }
    const interleavedBuffer = new (0, _three.InterleavedBuffer)(new TypedArray(arrayLength), stride);
    let offset = 0;
    const res = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    const setters = [
        "setX",
        "setY",
        "setZ",
        "setW"
    ];
    for(let j = 0, l = attributes.length; j < l; j++){
        const attribute = attributes[j];
        const itemSize = attribute.itemSize;
        const count = attribute.count;
        const iba = new (0, _three.InterleavedBufferAttribute)(interleavedBuffer, itemSize, offset, attribute.normalized);
        res.push(iba);
        offset += itemSize;
        for(let c = 0; c < count; c++)for(let k = 0; k < itemSize; k++){
            const set = (0, _helpersJs.getWithKey)(iba, setters[k]);
            const get = (0, _helpersJs.getWithKey)(attribute, getters[k]);
            set(c, get(c));
        }
    }
    return res;
};
function estimateBytesUsed(geometry) {
    let mem = 0;
    for(let name in geometry.attributes){
        const attr = geometry.getAttribute(name);
        mem += attr.count * attr.itemSize * attr.array.BYTES_PER_ELEMENT;
    }
    const indices = geometry.getIndex();
    mem += indices ? indices.count * indices.itemSize * indices.array.BYTES_PER_ELEMENT : 0;
    return mem;
}
function mergeVertices(geometry, tolerance = 1e-4) {
    tolerance = Math.max(tolerance, Number.EPSILON);
    const hashToIndex = {};
    const indices = geometry.getIndex();
    const positions = geometry.getAttribute("position");
    const vertexCount = indices ? indices.count : positions.count;
    let nextIndex = 0;
    const attributeNames = Object.keys(geometry.attributes);
    const attrArrays = {};
    const morphAttrsArrays = {};
    const newIndices = [];
    const getters = [
        "getX",
        "getY",
        "getZ",
        "getW"
    ];
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        attrArrays[name] = [];
        const morphAttr = geometry.morphAttributes[name];
        if (morphAttr) morphAttrsArrays[name] = new Array(morphAttr.length).fill(0).map(()=>[]);
    }
    const decimalShift = Math.log10(1 / tolerance);
    const shiftMultiplier = Math.pow(10, decimalShift);
    for(let i = 0; i < vertexCount; i++){
        const index = indices ? indices.getX(i) : i;
        let hash = "";
        for(let j = 0, l = attributeNames.length; j < l; j++){
            const name = attributeNames[j];
            const attribute = geometry.getAttribute(name);
            const itemSize = attribute.itemSize;
            for(let k = 0; k < itemSize; k++)hash += `${~~(attribute[getters[k]](index) * shiftMultiplier)},`;
        }
        if (hash in hashToIndex) newIndices.push(hashToIndex[hash]);
        else {
            for(let j = 0, l = attributeNames.length; j < l; j++){
                const name = attributeNames[j];
                const attribute = geometry.getAttribute(name);
                const morphAttr = geometry.morphAttributes[name];
                const itemSize = attribute.itemSize;
                const newarray = attrArrays[name];
                const newMorphArrays = morphAttrsArrays[name];
                for(let k = 0; k < itemSize; k++){
                    const getterFunc = getters[k];
                    newarray.push(attribute[getterFunc](index));
                    if (morphAttr) for(let m = 0, ml = morphAttr.length; m < ml; m++)newMorphArrays[m].push(morphAttr[m][getterFunc](index));
                }
            }
            hashToIndex[hash] = nextIndex;
            newIndices.push(nextIndex);
            nextIndex++;
        }
    }
    const result = geometry.clone();
    for(let i = 0, l = attributeNames.length; i < l; i++){
        const name = attributeNames[i];
        const oldAttribute = geometry.getAttribute(name);
        const buffer = new oldAttribute.array.constructor(attrArrays[name]);
        const attribute = new (0, _three.BufferAttribute)(buffer, oldAttribute.itemSize, oldAttribute.normalized);
        result.setAttribute(name, attribute);
        if (name in morphAttrsArrays) for(let j = 0; j < morphAttrsArrays[name].length; j++){
            const oldMorphAttribute = geometry.morphAttributes[name][j];
            const buffer2 = new oldMorphAttribute.array.constructor(morphAttrsArrays[name][j]);
            const morphAttribute = new (0, _three.BufferAttribute)(buffer2, oldMorphAttribute.itemSize, oldMorphAttribute.normalized);
            result.morphAttributes[name][j] = morphAttribute;
        }
    }
    result.setIndex(newIndices);
    return result;
}
function toTrianglesDrawMode(geometry, drawMode) {
    if (drawMode === (0, _three.TrianglesDrawMode)) {
        console.warn("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Geometry already defined as triangles.");
        return geometry;
    }
    if (drawMode === (0, _three.TriangleFanDrawMode) || drawMode === (0, _three.TriangleStripDrawMode)) {
        let index = geometry.getIndex();
        if (index === null) {
            const indices = [];
            const position = geometry.getAttribute("position");
            if (position !== void 0) {
                for(let i = 0; i < position.count; i++)indices.push(i);
                geometry.setIndex(indices);
                index = geometry.getIndex();
            } else {
                console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Undefined position attribute. Processing not possible.");
                return geometry;
            }
        }
        const numberOfTriangles = index.count - 2;
        const newIndices = [];
        if (index) {
            if (drawMode === (0, _three.TriangleFanDrawMode)) for(let i = 1; i <= numberOfTriangles; i++){
                newIndices.push(index.getX(0));
                newIndices.push(index.getX(i));
                newIndices.push(index.getX(i + 1));
            }
            else {
                for(let i = 0; i < numberOfTriangles; i++)if (i % 2 === 0) {
                    newIndices.push(index.getX(i));
                    newIndices.push(index.getX(i + 1));
                    newIndices.push(index.getX(i + 2));
                } else {
                    newIndices.push(index.getX(i + 2));
                    newIndices.push(index.getX(i + 1));
                    newIndices.push(index.getX(i));
                }
            }
        }
        if (newIndices.length / 3 !== numberOfTriangles) console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unable to generate correct amount of triangles.");
        const newGeometry = geometry.clone();
        newGeometry.setIndex(newIndices);
        newGeometry.clearGroups();
        return newGeometry;
    } else {
        console.error("THREE.BufferGeometryUtils.toTrianglesDrawMode(): Unknown draw mode:", drawMode);
        return geometry;
    }
}
function computeMorphedAttributes(object) {
    if (object.geometry.isBufferGeometry !== true) {
        console.error("THREE.BufferGeometryUtils: Geometry is not of type BufferGeometry.");
        return null;
    }
    const _vA = new (0, _three.Vector3)();
    const _vB = new (0, _three.Vector3)();
    const _vC = new (0, _three.Vector3)();
    const _tempA = new (0, _three.Vector3)();
    const _tempB = new (0, _three.Vector3)();
    const _tempC = new (0, _three.Vector3)();
    const _morphA = new (0, _three.Vector3)();
    const _morphB = new (0, _three.Vector3)();
    const _morphC = new (0, _three.Vector3)();
    function _calculateMorphedAttributeData(object2, material2, attribute, morphAttribute, morphTargetsRelative2, a2, b2, c2, modifiedAttributeArray) {
        _vA.fromBufferAttribute(attribute, a2);
        _vB.fromBufferAttribute(attribute, b2);
        _vC.fromBufferAttribute(attribute, c2);
        const morphInfluences = object2.morphTargetInfluences;
        if (// @ts-ignore
        material2.morphTargets && morphAttribute && morphInfluences) {
            _morphA.set(0, 0, 0);
            _morphB.set(0, 0, 0);
            _morphC.set(0, 0, 0);
            for(let i2 = 0, il2 = morphAttribute.length; i2 < il2; i2++){
                const influence = morphInfluences[i2];
                const morph = morphAttribute[i2];
                if (influence === 0) continue;
                _tempA.fromBufferAttribute(morph, a2);
                _tempB.fromBufferAttribute(morph, b2);
                _tempC.fromBufferAttribute(morph, c2);
                if (morphTargetsRelative2) {
                    _morphA.addScaledVector(_tempA, influence);
                    _morphB.addScaledVector(_tempB, influence);
                    _morphC.addScaledVector(_tempC, influence);
                } else {
                    _morphA.addScaledVector(_tempA.sub(_vA), influence);
                    _morphB.addScaledVector(_tempB.sub(_vB), influence);
                    _morphC.addScaledVector(_tempC.sub(_vC), influence);
                }
            }
            _vA.add(_morphA);
            _vB.add(_morphB);
            _vC.add(_morphC);
        }
        if (object2.isSkinnedMesh) {
            object2.boneTransform(a2, _vA);
            object2.boneTransform(b2, _vB);
            object2.boneTransform(c2, _vC);
        }
        modifiedAttributeArray[a2 * 3 + 0] = _vA.x;
        modifiedAttributeArray[a2 * 3 + 1] = _vA.y;
        modifiedAttributeArray[a2 * 3 + 2] = _vA.z;
        modifiedAttributeArray[b2 * 3 + 0] = _vB.x;
        modifiedAttributeArray[b2 * 3 + 1] = _vB.y;
        modifiedAttributeArray[b2 * 3 + 2] = _vB.z;
        modifiedAttributeArray[c2 * 3 + 0] = _vC.x;
        modifiedAttributeArray[c2 * 3 + 1] = _vC.y;
        modifiedAttributeArray[c2 * 3 + 2] = _vC.z;
    }
    const geometry = object.geometry;
    const material = object.material;
    let a, b, c;
    const index = geometry.index;
    const positionAttribute = geometry.attributes.position;
    const morphPosition = geometry.morphAttributes.position;
    const morphTargetsRelative = geometry.morphTargetsRelative;
    const normalAttribute = geometry.attributes.normal;
    const morphNormal = geometry.morphAttributes.position;
    const groups = geometry.groups;
    const drawRange = geometry.drawRange;
    let i, j, il, jl;
    let group, groupMaterial;
    let start, end;
    const modifiedPosition = new Float32Array(positionAttribute.count * positionAttribute.itemSize);
    const modifiedNormal = new Float32Array(normalAttribute.count * normalAttribute.itemSize);
    if (index !== null) {
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            groupMaterial = material[group.materialIndex];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = index.getX(j);
                b = index.getX(j + 1);
                c = index.getX(j + 2);
                _calculateMorphedAttributeData(object, groupMaterial, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, groupMaterial, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(index.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = index.getX(i);
                b = index.getX(i + 1);
                c = index.getX(i + 2);
                _calculateMorphedAttributeData(object, material, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, material, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    } else if (positionAttribute !== void 0) {
        if (Array.isArray(material)) for(i = 0, il = groups.length; i < il; i++){
            group = groups[i];
            groupMaterial = material[group.materialIndex];
            start = Math.max(group.start, drawRange.start);
            end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
            for(j = start, jl = end; j < jl; j += 3){
                a = j;
                b = j + 1;
                c = j + 2;
                _calculateMorphedAttributeData(object, groupMaterial, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, groupMaterial, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
        else {
            start = Math.max(0, drawRange.start);
            end = Math.min(positionAttribute.count, drawRange.start + drawRange.count);
            for(i = start, il = end; i < il; i += 3){
                a = i;
                b = i + 1;
                c = i + 2;
                _calculateMorphedAttributeData(object, material, positionAttribute, morphPosition, morphTargetsRelative, a, b, c, modifiedPosition);
                _calculateMorphedAttributeData(object, material, normalAttribute, morphNormal, morphTargetsRelative, a, b, c, modifiedNormal);
            }
        }
    }
    const morphedPositionAttribute = new (0, _three.Float32BufferAttribute)(modifiedPosition, 3);
    const morphedNormalAttribute = new (0, _three.Float32BufferAttribute)(modifiedNormal, 3);
    return {
        positionAttribute,
        normalAttribute,
        morphedPositionAttribute,
        morphedNormalAttribute
    };
}
function toCreasedNormals(geometry, creaseAngle = Math.PI / 3) {
    const creaseDot = Math.cos(creaseAngle);
    const hashMultiplier = (1 + 1e-10) * 100;
    const verts = [
        new (0, _three.Vector3)(),
        new (0, _three.Vector3)(),
        new (0, _three.Vector3)()
    ];
    const tempVec1 = new (0, _three.Vector3)();
    const tempVec2 = new (0, _three.Vector3)();
    const tempNorm = new (0, _three.Vector3)();
    const tempNorm2 = new (0, _three.Vector3)();
    function hashVertex(v) {
        const x = ~~(v.x * hashMultiplier);
        const y = ~~(v.y * hashMultiplier);
        const z = ~~(v.z * hashMultiplier);
        return `${x},${y},${z}`;
    }
    const resultGeometry = geometry.index ? geometry.toNonIndexed() : geometry;
    const posAttr = resultGeometry.attributes.position;
    const vertexMap = {};
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        const normal = new (0, _three.Vector3)().crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            if (!(hash in vertexMap)) vertexMap[hash] = [];
            vertexMap[hash].push(normal);
        }
    }
    const normalArray = new Float32Array(posAttr.count * 3);
    const normAttr = new (0, _three.BufferAttribute)(normalArray, 3, false);
    for(let i = 0, l = posAttr.count / 3; i < l; i++){
        const i3 = 3 * i;
        const a = verts[0].fromBufferAttribute(posAttr, i3 + 0);
        const b = verts[1].fromBufferAttribute(posAttr, i3 + 1);
        const c = verts[2].fromBufferAttribute(posAttr, i3 + 2);
        tempVec1.subVectors(c, b);
        tempVec2.subVectors(a, b);
        tempNorm.crossVectors(tempVec1, tempVec2).normalize();
        for(let n = 0; n < 3; n++){
            const vert = verts[n];
            const hash = hashVertex(vert);
            const otherNormals = vertexMap[hash];
            tempNorm2.set(0, 0, 0);
            for(let k = 0, lk = otherNormals.length; k < lk; k++){
                const otherNorm = otherNormals[k];
                if (tempNorm.dot(otherNorm) > creaseDot) tempNorm2.add(otherNorm);
            }
            tempNorm2.normalize();
            normAttr.setXYZ(i3 + n, tempNorm2.x, tempNorm2.y, tempNorm2.z);
        }
    }
    resultGeometry.setAttribute("normal", normAttr);
    return resultGeometry;
}

},{"three":[["BufferAttribute","hZcQL"],["BufferGeometry","hZcQL"],["Float32BufferAttribute","hZcQL"],["Vector3","hZcQL"],["InterleavedBuffer","bihzc"],["InterleavedBufferAttribute","bihzc"],["TriangleFanDrawMode","bihzc"],["TrianglesDrawMode","bihzc"],["TriangleStripDrawMode","bihzc"]],"../types/helpers.js":"lpUA8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lpUA8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getWithKey", ()=>getWithKey);
const getWithKey = (obj, key)=>obj[key];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ISzJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "version", ()=>version);
var _three = require("three");
const version = /* @__PURE__ */ (()=>parseInt((0, _three.REVISION).replace(/\D+/g, "")))();

},{"three":"hZcQL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ksNiW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "decodeText", ()=>decodeText);
function decodeText(array) {
    if (typeof TextDecoder !== "undefined") return new TextDecoder().decode(array);
    let s = "";
    for(let i = 0, il = array.length; i < il; i++)s += String.fromCharCode(array[i]);
    try {
        return decodeURIComponent(escape(s));
    } catch (e) {
        return s;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"liDWE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MeshoptDecoder", ()=>MeshoptDecoder);
let generated;
const MeshoptDecoder = ()=>{
    if (generated) return generated;
    const wasm_base = "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";
    const wasm_simd = "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";
    const detector = new Uint8Array([
        0,
        97,
        115,
        109,
        1,
        0,
        0,
        0,
        1,
        4,
        1,
        96,
        0,
        0,
        3,
        3,
        2,
        0,
        0,
        5,
        3,
        1,
        0,
        1,
        12,
        1,
        0,
        10,
        22,
        2,
        12,
        0,
        65,
        0,
        65,
        0,
        65,
        0,
        252,
        10,
        0,
        0,
        11,
        7,
        0,
        65,
        0,
        253,
        15,
        26,
        11
    ]);
    const wasmpack = new Uint8Array([
        32,
        0,
        65,
        253,
        3,
        1,
        2,
        34,
        4,
        106,
        6,
        5,
        11,
        8,
        7,
        20,
        13,
        33,
        12,
        16,
        128,
        9,
        116,
        64,
        19,
        113,
        127,
        15,
        10,
        21,
        22,
        14,
        255,
        66,
        24,
        54,
        136,
        107,
        18,
        23,
        192,
        26,
        114,
        118,
        132,
        17,
        77,
        101,
        130,
        144,
        27,
        87,
        131,
        44,
        45,
        74,
        156,
        154,
        70,
        167
    ]);
    if (typeof WebAssembly !== "object") return {
        supported: false
    };
    let wasm = wasm_base;
    if (WebAssembly.validate(detector)) wasm = wasm_simd;
    let instance;
    const promise = WebAssembly.instantiate(unpack(wasm), {}).then((result)=>{
        instance = result.instance;
        instance.exports.__wasm_call_ctors();
    });
    function unpack(data) {
        const result = new Uint8Array(data.length);
        for(let i = 0; i < data.length; ++i){
            const ch = data.charCodeAt(i);
            result[i] = ch > 96 ? ch - 71 : ch > 64 ? ch - 65 : ch > 47 ? ch + 4 : ch > 46 ? 63 : 62;
        }
        let write = 0;
        for(let i = 0; i < data.length; ++i)result[write++] = result[i] < 60 ? wasmpack[result[i]] : (result[i] - 60) * 64 + result[++i];
        return result.buffer.slice(0, write);
    }
    function decode(fun, target, count, size, source, filter) {
        const sbrk = instance.exports.sbrk;
        const count4 = count + 3 & -4;
        const tp = sbrk(count4 * size);
        const sp = sbrk(source.length);
        const heap = new Uint8Array(instance.exports.memory.buffer);
        heap.set(source, sp);
        const res = fun(tp, count, size, sp, source.length);
        if (res === 0 && filter) filter(tp, count4, size);
        target.set(heap.subarray(tp, tp + count * size));
        sbrk(tp - sbrk(0));
        if (res !== 0) throw new Error(`Malformed buffer data: ${res}`);
    }
    const filters = {
        // legacy index-based enums for glTF
        0: "",
        1: "meshopt_decodeFilterOct",
        2: "meshopt_decodeFilterQuat",
        3: "meshopt_decodeFilterExp",
        // string-based enums for glTF
        NONE: "",
        OCTAHEDRAL: "meshopt_decodeFilterOct",
        QUATERNION: "meshopt_decodeFilterQuat",
        EXPONENTIAL: "meshopt_decodeFilterExp"
    };
    const decoders = {
        // legacy index-based enums for glTF
        0: "meshopt_decodeVertexBuffer",
        1: "meshopt_decodeIndexBuffer",
        2: "meshopt_decodeIndexSequence",
        // string-based enums for glTF
        ATTRIBUTES: "meshopt_decodeVertexBuffer",
        TRIANGLES: "meshopt_decodeIndexBuffer",
        INDICES: "meshopt_decodeIndexSequence"
    };
    generated = {
        ready: promise,
        supported: true,
        decodeVertexBuffer (target, count, size, source, filter) {
            decode(instance.exports.meshopt_decodeVertexBuffer, target, count, size, source, instance.exports[filters[filter]]);
        },
        decodeIndexBuffer (target, count, size, source) {
            decode(instance.exports.meshopt_decodeIndexBuffer, target, count, size, source);
        },
        decodeIndexSequence (target, count, size, source) {
            decode(instance.exports.meshopt_decodeIndexSequence, target, count, size, source);
        },
        decodeGltfBuffer (target, count, size, source, mode, filter) {
            decode(instance.exports[decoders[mode]], target, count, size, source, instance.exports[filters[filter]]);
        }
    };
    return generated;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4p4ya":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "A", ()=>useStore);
parcelHelpers.export(exports, "B", ()=>Block);
parcelHelpers.export(exports, "C", ()=>useThree);
parcelHelpers.export(exports, "D", ()=>useFrame);
parcelHelpers.export(exports, "E", ()=>ErrorBoundary);
parcelHelpers.export(exports, "F", ()=>useGraph);
parcelHelpers.export(exports, "G", ()=>useLoader);
parcelHelpers.export(exports, "_", ()=>_roots);
parcelHelpers.export(exports, "a", ()=>useMutableCallback);
parcelHelpers.export(exports, "b", ()=>useIsomorphicLayoutEffect);
parcelHelpers.export(exports, "c", ()=>createRoot);
parcelHelpers.export(exports, "d", ()=>unmountComponentAtNode);
parcelHelpers.export(exports, "e", ()=>extend);
parcelHelpers.export(exports, "f", ()=>createPointerEvents);
parcelHelpers.export(exports, "g", ()=>createEvents);
parcelHelpers.export(exports, "h", ()=>flushGlobalEffects);
parcelHelpers.export(exports, "i", ()=>isRef);
parcelHelpers.export(exports, "j", ()=>addEffect);
parcelHelpers.export(exports, "k", ()=>addAfterEffect);
parcelHelpers.export(exports, "l", ()=>addTail);
parcelHelpers.export(exports, "m", ()=>invalidate);
parcelHelpers.export(exports, "n", ()=>advance);
parcelHelpers.export(exports, "o", ()=>createPortal);
parcelHelpers.export(exports, "p", ()=>flushSync);
parcelHelpers.export(exports, "q", ()=>context);
parcelHelpers.export(exports, "r", ()=>reconciler);
parcelHelpers.export(exports, "s", ()=>applyProps);
parcelHelpers.export(exports, "t", ()=>threeTypes);
parcelHelpers.export(exports, "u", ()=>useBridge);
parcelHelpers.export(exports, "v", ()=>getRootState);
parcelHelpers.export(exports, "w", ()=>dispose);
parcelHelpers.export(exports, "x", ()=>act);
parcelHelpers.export(exports, "y", ()=>buildGraph);
parcelHelpers.export(exports, "z", ()=>useInstanceHandle);
var _react = require("react");
var _constants = require("react-reconciler/constants");
var _three = require("three");
var _traditional = require("zustand/traditional");
var _suspendReact = require("suspend-react");
var _reactReconciler = require("react-reconciler");
var _reactReconcilerDefault = parcelHelpers.interopDefault(_reactReconciler);
var _scheduler = require("scheduler");
var _jsxRuntime = require("react/jsx-runtime");
var _itsFine = require("its-fine");
var threeTypes = /*#__PURE__*/ Object.freeze({
    __proto__: null
});
/**
 * Returns the instance's initial (outmost) root.
 */ function findInitialRoot(instance) {
    let root = instance.root;
    while(root.getState().previousRoot)root = root.getState().previousRoot;
    return root;
}
/**
 * Safely flush async effects when testing, simulating a legacy root.
 * @deprecated Import from React instead. import { act } from 'react'
 */ // Reference with computed key to break Webpack static analysis
// https://github.com/webpack/webpack/issues/14814
const act = _react["act"];
const isOrthographicCamera = (def)=>def && def.isOrthographicCamera;
const isRef = (obj)=>obj && obj.hasOwnProperty('current');
const isColorRepresentation = (value)=>value != null && (typeof value === 'string' || typeof value === 'number' || value.isColor);
/**
 * An SSR-friendly useLayoutEffect.
 *
 * React currently throws a warning when using useLayoutEffect on the server.
 * To get around it, we can conditionally useEffect on the server (no-op) and
 * useLayoutEffect elsewhere.
 *
 * @see https://github.com/facebook/react/issues/14927
 */ const useIsomorphicLayoutEffect = /* @__PURE__ */ ((_window$document, _window$navigator)=>typeof window !== 'undefined' && (((_window$document = window.document) == null ? void 0 : _window$document.createElement) || ((_window$navigator = window.navigator) == null ? void 0 : _window$navigator.product) === 'ReactNative'))() ? _react.useLayoutEffect : _react.useEffect;
function useMutableCallback(fn) {
    const ref = _react.useRef(fn);
    useIsomorphicLayoutEffect(()=>void (ref.current = fn), [
        fn
    ]);
    return ref;
}
/**
 * Bridges renderer Context and StrictMode from a primary renderer.
 */ function useBridge() {
    const fiber = (0, _itsFine.useFiber)();
    const ContextBridge = (0, _itsFine.useContextBridge)();
    return _react.useMemo(()=>({ children })=>{
            const strict = !!(0, _itsFine.traverseFiber)(fiber, true, (node)=>node.type === _react.StrictMode);
            const Root = strict ? _react.StrictMode : _react.Fragment;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Root, {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ContextBridge, {
                    children: children
                })
            });
        }, [
        fiber,
        ContextBridge
    ]);
}
function Block({ set }) {
    useIsomorphicLayoutEffect(()=>{
        set(new Promise(()=>null));
        return ()=>set(false);
    }, [
        set
    ]);
    return null;
}
// NOTE: static members get down-level transpiled to mutations which break tree-shaking
const ErrorBoundary = /* @__PURE__ */ ((_ErrorBoundary)=>(_ErrorBoundary = class ErrorBoundary extends _react.Component {
        constructor(...args){
            super(...args);
            this.state = {
                error: false
            };
        }
        componentDidCatch(err) {
            this.props.set(err);
        }
        render() {
            return this.state.error ? null : this.props.children;
        }
    }, _ErrorBoundary.getDerivedStateFromError = ()=>({
            error: true
        }), _ErrorBoundary))();
function calculateDpr(dpr) {
    var _window$devicePixelRa;
    // Err on the side of progress by assuming 2x dpr if we can't detect it
    // This will happen in workers where window is defined but dpr isn't.
    const target = typeof window !== 'undefined' ? (_window$devicePixelRa = window.devicePixelRatio) != null ? _window$devicePixelRa : 2 : 1;
    return Array.isArray(dpr) ? Math.min(Math.max(dpr[0], target), dpr[1]) : dpr;
}
/**
 * Returns instance root state
 */ function getRootState(obj) {
    var _r3f;
    return (_r3f = obj.__r3f) == null ? void 0 : _r3f.root.getState();
}
// A collection of compare functions
const is = {
    obj: (a)=>a === Object(a) && !is.arr(a) && typeof a !== 'function',
    fun: (a)=>typeof a === 'function',
    str: (a)=>typeof a === 'string',
    num: (a)=>typeof a === 'number',
    boo: (a)=>typeof a === 'boolean',
    und: (a)=>a === void 0,
    nul: (a)=>a === null,
    arr: (a)=>Array.isArray(a),
    equ (a, b, { arrays = 'shallow', objects = 'reference', strict = true } = {}) {
        // Wrong type or one of the two undefined, doesn't match
        if (typeof a !== typeof b || !!a !== !!b) return false;
        // Atomic, just compare a against b
        if (is.str(a) || is.num(a) || is.boo(a)) return a === b;
        const isObj = is.obj(a);
        if (isObj && objects === 'reference') return a === b;
        const isArr = is.arr(a);
        if (isArr && arrays === 'reference') return a === b;
        // Array or Object, shallow compare first to see if it's a match
        if ((isArr || isObj) && a === b) return true;
        // Last resort, go through keys
        let i;
        // Check if a has all the keys of b
        for(i in a)if (!(i in b)) return false;
        // Check if values between keys match
        if (isObj && arrays === 'shallow' && objects === 'shallow') {
            for(i in strict ? b : a)if (!is.equ(a[i], b[i], {
                strict,
                objects: 'reference'
            })) return false;
        } else {
            for(i in strict ? b : a)if (a[i] !== b[i]) return false;
        }
        // If i is undefined
        if (is.und(i)) {
            // If both arrays are empty we consider them equal
            if (isArr && a.length === 0 && b.length === 0) return true;
            // If both objects are empty we consider them equal
            if (isObj && Object.keys(a).length === 0 && Object.keys(b).length === 0) return true;
            // Otherwise match them by value
            if (a !== b) return false;
        }
        return true;
    }
};
// Collects nodes and materials from a THREE.Object3D
function buildGraph(object) {
    const data = {
        nodes: {},
        materials: {},
        meshes: {}
    };
    if (object) object.traverse((obj)=>{
        if (obj.name) data.nodes[obj.name] = obj;
        if (obj.material && !data.materials[obj.material.name]) data.materials[obj.material.name] = obj.material;
        if (obj.isMesh && !data.meshes[obj.name]) data.meshes[obj.name] = obj;
    });
    return data;
}
// Disposes an object and all its properties
function dispose(obj) {
    if (obj.type !== 'Scene') obj.dispose == null || obj.dispose();
    for(const p in obj){
        const prop = obj[p];
        if ((prop == null ? void 0 : prop.type) !== 'Scene') prop == null || prop.dispose == null || prop.dispose();
    }
}
const REACT_INTERNAL_PROPS = [
    'children',
    'key',
    'ref'
];
// Gets only instance props from reconciler fibers
function getInstanceProps(queue) {
    const props = {};
    for(const key in queue)if (!REACT_INTERNAL_PROPS.includes(key)) props[key] = queue[key];
    return props;
}
// Each object in the scene carries a small LocalState descriptor
function prepare(target, root, type, props) {
    const object = target;
    // Create instance descriptor
    let instance = object == null ? void 0 : object.__r3f;
    if (!instance) {
        instance = {
            root,
            type,
            parent: null,
            children: [],
            props: getInstanceProps(props),
            object,
            eventCount: 0,
            handlers: {},
            isHidden: false
        };
        if (object) object.__r3f = instance;
    }
    return instance;
}
function resolve(root, key) {
    if (!key.includes('-')) return {
        root,
        key,
        target: root[key]
    };
    // First try the entire key as a single property (e.g., 'foo-bar')
    if (key in root) return {
        root,
        key,
        target: root[key]
    };
    // Try piercing (e.g., 'material-color' -> material.color)
    let target = root;
    const parts = key.split('-');
    for (const part of parts){
        if (typeof target !== 'object' || target === null) {
            if (target !== undefined) {
                // Property exists but has unexpected shape
                const remaining = parts.slice(parts.indexOf(part)).join('-');
                return {
                    root: target,
                    key: remaining,
                    target: undefined
                };
            }
            // Property doesn't exist - fallback to original key
            return {
                root,
                key,
                target: undefined
            };
        }
        key = part;
        root = target;
        target = target[key];
    }
    return {
        root,
        key,
        target
    };
}
// Checks if a dash-cased string ends with an integer
const INDEX_REGEX = /-\d+$/;
function attach(parent, child) {
    if (is.str(child.props.attach)) {
        // If attaching into an array (foo-0), create one
        if (INDEX_REGEX.test(child.props.attach)) {
            const index = child.props.attach.replace(INDEX_REGEX, '');
            const { root, key } = resolve(parent.object, index);
            if (!Array.isArray(root[key])) root[key] = [];
        }
        const { root, key } = resolve(parent.object, child.props.attach);
        child.previousAttach = root[key];
        root[key] = child.object;
    } else if (is.fun(child.props.attach)) child.previousAttach = child.props.attach(parent.object, child.object);
}
function detach(parent, child) {
    if (is.str(child.props.attach)) {
        const { root, key } = resolve(parent.object, child.props.attach);
        const previous = child.previousAttach;
        // When the previous value was undefined, it means the value was never set to begin with
        if (previous === undefined) delete root[key];
        else root[key] = previous;
    } else child.previousAttach == null || child.previousAttach(parent.object, child.object);
    delete child.previousAttach;
}
const RESERVED_PROPS = [
    ...REACT_INTERNAL_PROPS,
    // Instance props
    'args',
    'dispose',
    'attach',
    'object',
    'onUpdate',
    // Behavior flags
    'dispose'
];
const MEMOIZED_PROTOTYPES = new Map();
function getMemoizedPrototype(root) {
    let ctor = MEMOIZED_PROTOTYPES.get(root.constructor);
    try {
        if (!ctor) {
            ctor = new root.constructor();
            MEMOIZED_PROTOTYPES.set(root.constructor, ctor);
        }
    } catch (e) {
    // ...
    }
    return ctor;
}
// This function prepares a set of changes to be applied to the instance
function diffProps(instance, newProps) {
    const changedProps = {};
    // Sort through props
    for(const prop in newProps){
        // Skip reserved keys
        if (RESERVED_PROPS.includes(prop)) continue;
        // Skip if props match
        if (is.equ(newProps[prop], instance.props[prop])) continue;
        // Props changed, add them
        changedProps[prop] = newProps[prop];
        // Reset pierced props
        for(const other in newProps)if (other.startsWith(`${prop}-`)) changedProps[other] = newProps[other];
    }
    // Reset removed props for HMR
    for(const prop in instance.props){
        if (RESERVED_PROPS.includes(prop) || newProps.hasOwnProperty(prop)) continue;
        const { root, key } = resolve(instance.object, prop);
        // https://github.com/mrdoob/three.js/issues/21209
        // HMR/fast-refresh relies on the ability to cancel out props, but threejs
        // has no means to do this. Hence we curate a small collection of value-classes
        // with their respective constructor/set arguments
        // For removed props, try to set default values, if possible
        if (root.constructor && root.constructor.length === 0) {
            // create a blank slate of the instance and copy the particular parameter.
            const ctor = getMemoizedPrototype(root);
            if (!is.und(ctor)) changedProps[key] = ctor[key];
        } else // instance does not have constructor, just set it to 0
        changedProps[key] = 0;
    }
    return changedProps;
}
// https://github.com/mrdoob/three.js/pull/27042
// https://github.com/mrdoob/three.js/pull/22748
const colorMaps = [
    'map',
    'emissiveMap',
    'sheenColorMap',
    'specularColorMap',
    'envMap'
];
const EVENT_REGEX = /^on(Pointer|Click|DoubleClick|ContextMenu|Wheel)/;
// This function applies a set of changes to the instance
function applyProps(object, props) {
    var _instance$object;
    const instance = object.__r3f;
    const rootState = instance && findInitialRoot(instance).getState();
    const prevHandlers = instance == null ? void 0 : instance.eventCount;
    for(const prop in props){
        let value = props[prop];
        // Don't mutate reserved keys
        if (RESERVED_PROPS.includes(prop)) continue;
        // Deal with pointer events, including removing them if undefined
        if (instance && EVENT_REGEX.test(prop)) {
            if (typeof value === 'function') instance.handlers[prop] = value;
            else delete instance.handlers[prop];
            instance.eventCount = Object.keys(instance.handlers).length;
            continue;
        }
        // Ignore setting undefined props
        // https://github.com/pmndrs/react-three-fiber/issues/274
        if (value === undefined) continue;
        let { root, key, target } = resolve(object, prop);
        // Throw an error if we attempted to set a pierced prop to a non-object
        if (target === undefined && (typeof root !== 'object' || root === null)) throw Error(`R3F: Cannot set "${prop}". Ensure it is an object before setting "${key}".`);
        // Layers must be written to the mask property
        if (target instanceof _three.Layers && value instanceof _three.Layers) target.mask = value.mask;
        else if (target instanceof _three.Color && isColorRepresentation(value)) target.set(value);
        else if (target !== null && typeof target === 'object' && typeof target.set === 'function' && typeof target.copy === 'function' && value != null && value.constructor && target.constructor === value.constructor) target.copy(value);
        else if (target !== null && typeof target === 'object' && typeof target.set === 'function' && Array.isArray(value)) {
            if (typeof target.fromArray === 'function') target.fromArray(value);
            else target.set(...value);
        } else if (target !== null && typeof target === 'object' && typeof target.set === 'function' && typeof value === 'number') {
            // Allow setting array scalars
            if (typeof target.setScalar === 'function') target.setScalar(value);
            else target.set(value);
        } else {
            var _root$key;
            root[key] = value;
            // Auto-convert sRGB texture parameters for built-in materials
            // https://github.com/pmndrs/react-three-fiber/issues/344
            // https://github.com/mrdoob/three.js/pull/25857
            if (rootState && !rootState.linear && colorMaps.includes(key) && (_root$key = root[key]) != null && _root$key.isTexture && // sRGB textures must be RGBA8 since r137 https://github.com/mrdoob/three.js/pull/23129
            root[key].format === _three.RGBAFormat && root[key].type === _three.UnsignedByteType) // NOTE: this cannot be set from the renderer (e.g. sRGB source textures rendered to P3)
            root[key].colorSpace = _three.SRGBColorSpace;
        }
    }
    // Register event handlers
    if (instance != null && instance.parent && rootState != null && rootState.internal && (_instance$object = instance.object) != null && _instance$object.isObject3D && prevHandlers !== instance.eventCount) {
        const object = instance.object;
        // Pre-emptively remove the instance from the interaction manager
        const index = rootState.internal.interaction.indexOf(object);
        if (index > -1) rootState.internal.interaction.splice(index, 1);
        // Add the instance to the interaction manager only when it has handlers
        if (instance.eventCount && object.raycast !== null) rootState.internal.interaction.push(object);
    }
    // Auto-attach geometries and materials
    if (instance && instance.props.attach === undefined) {
        if (instance.object.isBufferGeometry) instance.props.attach = 'geometry';
        else if (instance.object.isMaterial) instance.props.attach = 'material';
    }
    // Instance was updated, request a frame
    if (instance) invalidateInstance(instance);
    return object;
}
function invalidateInstance(instance) {
    var _instance$root;
    if (!instance.parent) return;
    instance.props.onUpdate == null || instance.props.onUpdate(instance.object);
    const state = (_instance$root = instance.root) == null ? void 0 : _instance$root.getState == null ? void 0 : _instance$root.getState();
    if (state && state.internal.frames === 0) state.invalidate();
}
function updateCamera(camera, size) {
    // Do not mess with the camera if it belongs to the user
    // https://github.com/pmndrs/react-three-fiber/issues/92
    if (camera.manual) return;
    if (isOrthographicCamera(camera)) {
        camera.left = size.width / -2;
        camera.right = size.width / 2;
        camera.top = size.height / 2;
        camera.bottom = size.height / -2;
    } else camera.aspect = size.width / size.height;
    camera.updateProjectionMatrix();
}
const isObject3D = (object)=>object == null ? void 0 : object.isObject3D;
function makeId(event) {
    return (event.eventObject || event.object).uuid + '/' + event.index + event.instanceId;
}
/**
 * Release pointer captures.
 * This is called by releasePointerCapture in the API, and when an object is removed.
 */ function releaseInternalPointerCapture(capturedMap, obj, captures, pointerId) {
    const captureData = captures.get(obj);
    if (captureData) {
        captures.delete(obj);
        // If this was the last capturing object for this pointer
        if (captures.size === 0) {
            capturedMap.delete(pointerId);
            captureData.target.releasePointerCapture(pointerId);
        }
    }
}
function removeInteractivity(store, object) {
    const { internal } = store.getState();
    // Removes every trace of an object from the data store
    internal.interaction = internal.interaction.filter((o)=>o !== object);
    internal.initialHits = internal.initialHits.filter((o)=>o !== object);
    internal.hovered.forEach((value, key)=>{
        if (value.eventObject === object || value.object === object) // Clear out intersects, they are outdated by now
        internal.hovered.delete(key);
    });
    internal.capturedMap.forEach((captures, pointerId)=>{
        releaseInternalPointerCapture(internal.capturedMap, object, captures, pointerId);
    });
}
function createEvents(store) {
    /** Calculates delta */ function calculateDistance(event) {
        const { internal } = store.getState();
        const dx = event.offsetX - internal.initialClick[0];
        const dy = event.offsetY - internal.initialClick[1];
        return Math.round(Math.sqrt(dx * dx + dy * dy));
    }
    /** Returns true if an instance has a valid pointer-event registered, this excludes scroll, clicks etc */ function filterPointerEvents(objects) {
        return objects.filter((obj)=>[
                'Move',
                'Over',
                'Enter',
                'Out',
                'Leave'
            ].some((name)=>{
                var _r3f;
                return (_r3f = obj.__r3f) == null ? void 0 : _r3f.handlers['onPointer' + name];
            }));
    }
    function intersect(event, filter) {
        const state = store.getState();
        const duplicates = new Set();
        const intersections = [];
        // Allow callers to eliminate event objects
        const eventsObjects = filter ? filter(state.internal.interaction) : state.internal.interaction;
        // Reset all raycaster cameras to undefined
        for(let i = 0; i < eventsObjects.length; i++){
            const state = getRootState(eventsObjects[i]);
            if (state) state.raycaster.camera = undefined;
        }
        if (!state.previousRoot) // Make sure root-level pointer and ray are set up
        state.events.compute == null || state.events.compute(event, state);
        function handleRaycast(obj) {
            const state = getRootState(obj);
            // Skip event handling when noEvents is set, or when the raycasters camera is null
            if (!state || !state.events.enabled || state.raycaster.camera === null) return [];
            // When the camera is undefined we have to call the event layers update function
            if (state.raycaster.camera === undefined) {
                var _state$previousRoot;
                state.events.compute == null || state.events.compute(event, state, (_state$previousRoot = state.previousRoot) == null ? void 0 : _state$previousRoot.getState());
                // If the camera is still undefined we have to skip this layer entirely
                if (state.raycaster.camera === undefined) state.raycaster.camera = null;
            }
            // Intersect object by object
            return state.raycaster.camera ? state.raycaster.intersectObject(obj, true) : [];
        }
        // Collect events
        let hits = eventsObjects// Intersect objects
        .flatMap(handleRaycast)// Sort by event priority and distance
        .sort((a, b)=>{
            const aState = getRootState(a.object);
            const bState = getRootState(b.object);
            if (!aState || !bState) return a.distance - b.distance;
            return bState.events.priority - aState.events.priority || a.distance - b.distance;
        })// Filter out duplicates
        .filter((item)=>{
            const id = makeId(item);
            if (duplicates.has(id)) return false;
            duplicates.add(id);
            return true;
        });
        // https://github.com/mrdoob/three.js/issues/16031
        // Allow custom userland intersect sort order, this likely only makes sense on the root filter
        if (state.events.filter) hits = state.events.filter(hits, state);
        // Bubble up the events, find the event source (eventObject)
        for (const hit of hits){
            let eventObject = hit.object;
            // Bubble event up
            while(eventObject){
                var _r3f2;
                if ((_r3f2 = eventObject.__r3f) != null && _r3f2.eventCount) intersections.push({
                    ...hit,
                    eventObject
                });
                eventObject = eventObject.parent;
            }
        }
        // If the interaction is captured, make all capturing targets part of the intersect.
        if ('pointerId' in event && state.internal.capturedMap.has(event.pointerId)) {
            for (let captureData of state.internal.capturedMap.get(event.pointerId).values())if (!duplicates.has(makeId(captureData.intersection))) intersections.push(captureData.intersection);
        }
        return intersections;
    }
    /**  Handles intersections by forwarding them to handlers */ function handleIntersects(intersections, event, delta, callback) {
        // If anything has been found, forward it to the event listeners
        if (intersections.length) {
            const localState = {
                stopped: false
            };
            for (const hit of intersections){
                let state = getRootState(hit.object);
                // If the object is not managed by R3F, it might be parented to an element which is.
                // Traverse upwards until we find a managed parent and use its state instead.
                if (!state) hit.object.traverseAncestors((obj)=>{
                    const parentState = getRootState(obj);
                    if (parentState) {
                        state = parentState;
                        return false;
                    }
                });
                if (state) {
                    const { raycaster, pointer, camera, internal } = state;
                    const unprojectedPoint = new _three.Vector3(pointer.x, pointer.y, 0).unproject(camera);
                    const hasPointerCapture = (id)=>{
                        var _internal$capturedMap, _internal$capturedMap2;
                        return (_internal$capturedMap = (_internal$capturedMap2 = internal.capturedMap.get(id)) == null ? void 0 : _internal$capturedMap2.has(hit.eventObject)) != null ? _internal$capturedMap : false;
                    };
                    const setPointerCapture = (id)=>{
                        const captureData = {
                            intersection: hit,
                            target: event.target
                        };
                        if (internal.capturedMap.has(id)) // if the pointerId was previously captured, we add the hit to the
                        // event capturedMap.
                        internal.capturedMap.get(id).set(hit.eventObject, captureData);
                        else // if the pointerId was not previously captured, we create a map
                        // containing the hitObject, and the hit. hitObject is used for
                        // faster access.
                        internal.capturedMap.set(id, new Map([
                            [
                                hit.eventObject,
                                captureData
                            ]
                        ]));
                        event.target.setPointerCapture(id);
                    };
                    const releasePointerCapture = (id)=>{
                        const captures = internal.capturedMap.get(id);
                        if (captures) releaseInternalPointerCapture(internal.capturedMap, hit.eventObject, captures, id);
                    };
                    // Add native event props
                    let extractEventProps = {};
                    // This iterates over the event's properties including the inherited ones. Native PointerEvents have most of their props as getters which are inherited, but polyfilled PointerEvents have them all as their own properties (i.e. not inherited). We can't use Object.keys() or Object.entries() as they only return "own" properties; nor Object.getPrototypeOf(event) as that *doesn't* return "own" properties, only inherited ones.
                    for(let prop in event){
                        let property = event[prop];
                        // Only copy over atomics, leave functions alone as these should be
                        // called as event.nativeEvent.fn()
                        if (typeof property !== 'function') extractEventProps[prop] = property;
                    }
                    let raycastEvent = {
                        ...hit,
                        ...extractEventProps,
                        pointer,
                        intersections,
                        stopped: localState.stopped,
                        delta,
                        unprojectedPoint,
                        ray: raycaster.ray,
                        camera: camera,
                        // Hijack stopPropagation, which just sets a flag
                        stopPropagation () {
                            // https://github.com/pmndrs/react-three-fiber/issues/596
                            // Events are not allowed to stop propagation if the pointer has been captured
                            const capturesForPointer = 'pointerId' in event && internal.capturedMap.get(event.pointerId);
                            // We only authorize stopPropagation...
                            if (// ...if this pointer hasn't been captured
                            !capturesForPointer || // ... or if the hit object is capturing the pointer
                            capturesForPointer.has(hit.eventObject)) {
                                raycastEvent.stopped = localState.stopped = true;
                                // Propagation is stopped, remove all other hover records
                                // An event handler is only allowed to flush other handlers if it is hovered itself
                                if (internal.hovered.size && Array.from(internal.hovered.values()).find((i)=>i.eventObject === hit.eventObject)) {
                                    // Objects cannot flush out higher up objects that have already caught the event
                                    const higher = intersections.slice(0, intersections.indexOf(hit));
                                    cancelPointer([
                                        ...higher,
                                        hit
                                    ]);
                                }
                            }
                        },
                        // there should be a distinction between target and currentTarget
                        target: {
                            hasPointerCapture,
                            setPointerCapture,
                            releasePointerCapture
                        },
                        currentTarget: {
                            hasPointerCapture,
                            setPointerCapture,
                            releasePointerCapture
                        },
                        nativeEvent: event
                    };
                    // Call subscribers
                    callback(raycastEvent);
                    // Event bubbling may be interrupted by stopPropagation
                    if (localState.stopped === true) break;
                }
            }
        }
        return intersections;
    }
    function cancelPointer(intersections) {
        const { internal } = store.getState();
        for (const hoveredObj of internal.hovered.values())// When no objects were hit or the the hovered object wasn't found underneath the cursor
        // we call onPointerOut and delete the object from the hovered-elements map
        if (!intersections.length || !intersections.find((hit)=>hit.object === hoveredObj.object && hit.index === hoveredObj.index && hit.instanceId === hoveredObj.instanceId)) {
            const eventObject = hoveredObj.eventObject;
            const instance = eventObject.__r3f;
            internal.hovered.delete(makeId(hoveredObj));
            if (instance != null && instance.eventCount) {
                const handlers = instance.handlers;
                // Clear out intersects, they are outdated by now
                const data = {
                    ...hoveredObj,
                    intersections
                };
                handlers.onPointerOut == null || handlers.onPointerOut(data);
                handlers.onPointerLeave == null || handlers.onPointerLeave(data);
            }
        }
    }
    function pointerMissed(event, objects) {
        for(let i = 0; i < objects.length; i++){
            const instance = objects[i].__r3f;
            instance == null || instance.handlers.onPointerMissed == null || instance.handlers.onPointerMissed(event);
        }
    }
    function handlePointer(name) {
        // Deal with cancelation
        switch(name){
            case 'onPointerLeave':
            case 'onPointerCancel':
                return ()=>cancelPointer([]);
            case 'onLostPointerCapture':
                return (event)=>{
                    const { internal } = store.getState();
                    if ('pointerId' in event && internal.capturedMap.has(event.pointerId)) // If the object event interface had onLostPointerCapture, we'd call it here on every
                    // object that's getting removed. We call it on the next frame because onLostPointerCapture
                    // fires before onPointerUp. Otherwise pointerUp would never be called if the event didn't
                    // happen in the object it originated from, leaving components in a in-between state.
                    requestAnimationFrame(()=>{
                        // Only release if pointer-up didn't do it already
                        if (internal.capturedMap.has(event.pointerId)) {
                            internal.capturedMap.delete(event.pointerId);
                            cancelPointer([]);
                        }
                    });
                };
        }
        // Any other pointer goes here ...
        return function handleEvent(event) {
            const { onPointerMissed, internal } = store.getState();
            // prepareRay(event)
            internal.lastEvent.current = event;
            // Get fresh intersects
            const isPointerMove = name === 'onPointerMove';
            const isClickEvent = name === 'onClick' || name === 'onContextMenu' || name === 'onDoubleClick';
            const filter = isPointerMove ? filterPointerEvents : undefined;
            const hits = intersect(event, filter);
            const delta = isClickEvent ? calculateDistance(event) : 0;
            // Save initial coordinates on pointer-down
            if (name === 'onPointerDown') {
                internal.initialClick = [
                    event.offsetX,
                    event.offsetY
                ];
                internal.initialHits = hits.map((hit)=>hit.eventObject);
            }
            // If a click yields no results, pass it back to the user as a miss
            // Missed events have to come first in order to establish user-land side-effect clean up
            if (isClickEvent && !hits.length) {
                if (delta <= 2) {
                    pointerMissed(event, internal.interaction);
                    if (onPointerMissed) onPointerMissed(event);
                }
            }
            // Take care of unhover
            if (isPointerMove) cancelPointer(hits);
            function onIntersect(data) {
                const eventObject = data.eventObject;
                const instance = eventObject.__r3f;
                // Check presence of handlers
                if (!(instance != null && instance.eventCount)) return;
                const handlers = instance.handlers;
                /*
        MAYBE TODO, DELETE IF NOT: 
          Check if the object is captured, captured events should not have intersects running in parallel
          But wouldn't it be better to just replace capturedMap with a single entry?
          Also, are we OK with straight up making picking up multiple objects impossible?
          
        const pointerId = (data as ThreeEvent<PointerEvent>).pointerId        
        if (pointerId !== undefined) {
          const capturedMeshSet = internal.capturedMap.get(pointerId)
          if (capturedMeshSet) {
            const captured = capturedMeshSet.get(eventObject)
            if (captured && captured.localState.stopped) return
          }
        }*/ if (isPointerMove) {
                    // Move event ...
                    if (handlers.onPointerOver || handlers.onPointerEnter || handlers.onPointerOut || handlers.onPointerLeave) {
                        // When enter or out is present take care of hover-state
                        const id = makeId(data);
                        const hoveredItem = internal.hovered.get(id);
                        if (!hoveredItem) {
                            // If the object wasn't previously hovered, book it and call its handler
                            internal.hovered.set(id, data);
                            handlers.onPointerOver == null || handlers.onPointerOver(data);
                            handlers.onPointerEnter == null || handlers.onPointerEnter(data);
                        } else if (hoveredItem.stopped) // If the object was previously hovered and stopped, we shouldn't allow other items to proceed
                        data.stopPropagation();
                    }
                    // Call mouse move
                    handlers.onPointerMove == null || handlers.onPointerMove(data);
                } else {
                    // All other events ...
                    const handler = handlers[name];
                    if (handler) // Forward all events back to their respective handlers with the exception of click events,
                    // which must use the initial target
                    {
                        if (!isClickEvent || internal.initialHits.includes(eventObject)) {
                            // Missed events have to come first
                            pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                            // Now call the handler
                            handler(data);
                        }
                    } else // Trigger onPointerMissed on all elements that have pointer over/out handlers, but not click and weren't hit
                    if (isClickEvent && internal.initialHits.includes(eventObject)) pointerMissed(event, internal.interaction.filter((object)=>!internal.initialHits.includes(object)));
                }
            }
            handleIntersects(hits, event, delta, onIntersect);
        };
    }
    return {
        handlePointer
    };
}
const isRenderer = (def)=>!!(def != null && def.render);
const context = /* @__PURE__ */ _react.createContext(null);
const createStore = (invalidate, advance)=>{
    const rootStore = (0, _traditional.createWithEqualityFn)((set, get)=>{
        const position = new _three.Vector3();
        const defaultTarget = new _three.Vector3();
        const tempTarget = new _three.Vector3();
        function getCurrentViewport(camera = get().camera, target = defaultTarget, size = get().size) {
            const { width, height, top, left } = size;
            const aspect = width / height;
            if (target.isVector3) tempTarget.copy(target);
            else tempTarget.set(...target);
            const distance = camera.getWorldPosition(position).distanceTo(tempTarget);
            if (isOrthographicCamera(camera)) return {
                width: width / camera.zoom,
                height: height / camera.zoom,
                top,
                left,
                factor: 1,
                distance,
                aspect
            };
            else {
                const fov = camera.fov * Math.PI / 180; // convert vertical fov to radians
                const h = 2 * Math.tan(fov / 2) * distance; // visible height
                const w = h * (width / height);
                return {
                    width: w,
                    height: h,
                    top,
                    left,
                    factor: width / w,
                    distance,
                    aspect
                };
            }
        }
        let performanceTimeout = undefined;
        const setPerformanceCurrent = (current)=>set((state)=>({
                    performance: {
                        ...state.performance,
                        current
                    }
                }));
        const pointer = new _three.Vector2();
        const rootState = {
            set,
            get,
            // Mock objects that have to be configured
            gl: null,
            camera: null,
            raycaster: null,
            events: {
                priority: 1,
                enabled: true,
                connected: false
            },
            scene: null,
            xr: null,
            invalidate: (frames = 1)=>invalidate(get(), frames),
            advance: (timestamp, runGlobalEffects)=>advance(timestamp, runGlobalEffects, get()),
            legacy: false,
            linear: false,
            flat: false,
            controls: null,
            clock: new _three.Clock(),
            pointer,
            mouse: pointer,
            frameloop: 'always',
            onPointerMissed: undefined,
            performance: {
                current: 1,
                min: 0.5,
                max: 1,
                debounce: 200,
                regress: ()=>{
                    const state = get();
                    // Clear timeout
                    if (performanceTimeout) clearTimeout(performanceTimeout);
                    // Set lower bound performance
                    if (state.performance.current !== state.performance.min) setPerformanceCurrent(state.performance.min);
                    // Go back to upper bound performance after a while unless something regresses meanwhile
                    performanceTimeout = setTimeout(()=>setPerformanceCurrent(get().performance.max), state.performance.debounce);
                }
            },
            size: {
                width: 0,
                height: 0,
                top: 0,
                left: 0
            },
            viewport: {
                initialDpr: 0,
                dpr: 0,
                width: 0,
                height: 0,
                top: 0,
                left: 0,
                aspect: 0,
                distance: 0,
                factor: 0,
                getCurrentViewport
            },
            setEvents: (events)=>set((state)=>({
                        ...state,
                        events: {
                            ...state.events,
                            ...events
                        }
                    })),
            setSize: (width, height, top = 0, left = 0)=>{
                const camera = get().camera;
                const size = {
                    width,
                    height,
                    top,
                    left
                };
                set((state)=>({
                        size,
                        viewport: {
                            ...state.viewport,
                            ...getCurrentViewport(camera, defaultTarget, size)
                        }
                    }));
            },
            setDpr: (dpr)=>set((state)=>{
                    const resolved = calculateDpr(dpr);
                    return {
                        viewport: {
                            ...state.viewport,
                            dpr: resolved,
                            initialDpr: state.viewport.initialDpr || resolved
                        }
                    };
                }),
            setFrameloop: (frameloop = 'always')=>{
                const clock = get().clock;
                // if frameloop === "never" clock.elapsedTime is updated using advance(timestamp)
                clock.stop();
                clock.elapsedTime = 0;
                if (frameloop !== 'never') {
                    clock.start();
                    clock.elapsedTime = 0;
                }
                set(()=>({
                        frameloop
                    }));
            },
            previousRoot: undefined,
            internal: {
                // Events
                interaction: [],
                hovered: new Map(),
                subscribers: [],
                initialClick: [
                    0,
                    0
                ],
                initialHits: [],
                capturedMap: new Map(),
                lastEvent: /*#__PURE__*/ _react.createRef(),
                // Updates
                active: false,
                frames: 0,
                priority: 0,
                subscribe: (ref, priority, store)=>{
                    const internal = get().internal;
                    // If this subscription was given a priority, it takes rendering into its own hands
                    // For that reason we switch off automatic rendering and increase the manual flag
                    // As long as this flag is positive there can be no internal rendering at all
                    // because there could be multiple render subscriptions
                    internal.priority = internal.priority + (priority > 0 ? 1 : 0);
                    internal.subscribers.push({
                        ref,
                        priority,
                        store
                    });
                    // Register subscriber and sort layers from lowest to highest, meaning,
                    // highest priority renders last (on top of the other frames)
                    internal.subscribers = internal.subscribers.sort((a, b)=>a.priority - b.priority);
                    return ()=>{
                        const internal = get().internal;
                        if (internal != null && internal.subscribers) {
                            // Decrease manual flag if this subscription had a priority
                            internal.priority = internal.priority - (priority > 0 ? 1 : 0);
                            // Remove subscriber from list
                            internal.subscribers = internal.subscribers.filter((s)=>s.ref !== ref);
                        }
                    };
                }
            }
        };
        return rootState;
    });
    const state = rootStore.getState();
    let oldSize = state.size;
    let oldDpr = state.viewport.dpr;
    let oldCamera = state.camera;
    rootStore.subscribe(()=>{
        const { camera, size, viewport, gl, set } = rootStore.getState();
        // Resize camera and renderer on changes to size and pixelratio
        if (size.width !== oldSize.width || size.height !== oldSize.height || viewport.dpr !== oldDpr) {
            oldSize = size;
            oldDpr = viewport.dpr;
            // Update camera & renderer
            updateCamera(camera, size);
            if (viewport.dpr > 0) gl.setPixelRatio(viewport.dpr);
            const updateStyle = typeof HTMLCanvasElement !== 'undefined' && gl.domElement instanceof HTMLCanvasElement;
            gl.setSize(size.width, size.height, updateStyle);
        }
        // Update viewport once the camera changes
        if (camera !== oldCamera) {
            oldCamera = camera;
            // Update viewport
            set((state)=>({
                    viewport: {
                        ...state.viewport,
                        ...state.viewport.getCurrentViewport(camera)
                    }
                }));
        }
    });
    // Invalidate on any change
    rootStore.subscribe((state)=>invalidate(state));
    // Return root state
    return rootStore;
};
/**
 * Exposes an object's {@link Instance}.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#useInstanceHandle
 *
 * **Note**: this is an escape hatch to react-internal fields. Expect this to change significantly between versions.
 */ function useInstanceHandle(ref) {
    const instance = _react.useRef(null);
    _react.useImperativeHandle(instance, ()=>ref.current.__r3f, [
        ref
    ]);
    return instance;
}
/**
 * Returns the R3F Canvas' Zustand store. Useful for [transient updates](https://github.com/pmndrs/zustand#transient-updates-for-often-occurring-state-changes).
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usestore
 */ function useStore() {
    const store = _react.useContext(context);
    if (!store) throw new Error('R3F: Hooks can only be used within the Canvas component!');
    return store;
}
/**
 * Accesses R3F's internal state, containing renderer, canvas, scene, etc.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usethree
 */ function useThree(selector = (state)=>state, equalityFn) {
    return useStore()(selector, equalityFn);
}
/**
 * Executes a callback before render in a shared frame loop.
 * Can order effects with render priority or manually render with a positive priority.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useframe
 */ function useFrame(callback, renderPriority = 0) {
    const store = useStore();
    const subscribe = store.getState().internal.subscribe;
    // Memoize ref
    const ref = useMutableCallback(callback);
    // Subscribe on mount, unsubscribe on unmount
    useIsomorphicLayoutEffect(()=>subscribe(ref, renderPriority, store), [
        renderPriority,
        subscribe,
        store
    ]);
    return null;
}
/**
 * Returns a node graph of an object with named nodes & materials.
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#usegraph
 */ function useGraph(object) {
    return _react.useMemo(()=>buildGraph(object), [
        object
    ]);
}
const memoizedLoaders = new WeakMap();
const isConstructor$1 = (value)=>{
    var _value$prototype;
    return typeof value === 'function' && (value == null ? void 0 : (_value$prototype = value.prototype) == null ? void 0 : _value$prototype.constructor) === value;
};
function loadingFn(extensions, onProgress) {
    return function(Proto, ...input) {
        let loader;
        // Construct and cache loader if constructor was passed
        if (isConstructor$1(Proto)) {
            loader = memoizedLoaders.get(Proto);
            if (!loader) {
                loader = new Proto();
                memoizedLoaders.set(Proto, loader);
            }
        } else loader = Proto;
        // Apply loader extensions
        if (extensions) extensions(loader);
        // Go through the urls and load them
        return Promise.all(input.map((input)=>new Promise((res, reject)=>loader.load(input, (data)=>{
                    if (isObject3D(data == null ? void 0 : data.scene)) Object.assign(data, buildGraph(data.scene));
                    res(data);
                }, onProgress, (error)=>reject(new Error(`Could not load ${input}: ${error == null ? void 0 : error.message}`))))));
    };
}
/**
 * Synchronously loads and caches assets with a three loader.
 *
 * Note: this hook's caller must be wrapped with `React.Suspense`
 * @see https://docs.pmnd.rs/react-three-fiber/api/hooks#useloader
 */ function useLoader(loader, input, extensions, onProgress) {
    // Use suspense to load async assets
    const keys = Array.isArray(input) ? input : [
        input
    ];
    const results = (0, _suspendReact.suspend)(loadingFn(extensions, onProgress), [
        loader,
        ...keys
    ], {
        equal: is.equ
    });
    // Return the object(s)
    return Array.isArray(input) ? results : results[0];
}
/**
 * Preloads an asset into cache as a side-effect.
 */ useLoader.preload = function(loader, input, extensions) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, _suspendReact.preload)(loadingFn(extensions), [
        loader,
        ...keys
    ]);
};
/**
 * Removes a loaded asset from cache.
 */ useLoader.clear = function(loader, input) {
    const keys = Array.isArray(input) ? input : [
        input
    ];
    return (0, _suspendReact.clear)([
        loader,
        ...keys
    ]);
};
var packageData = {
    name: "@react-three/fiber",
    version: "9.4.2",
    description: "A React renderer for Threejs",
    keywords: [
        "react",
        "renderer",
        "fiber",
        "three",
        "threejs"
    ],
    author: "Paul Henschel (https://github.com/drcmda)",
    license: "MIT",
    maintainers: [
        "Josh Ellis (https://github.com/joshuaellis)",
        "Cody Bennett (https://github.com/codyjasonbennett)",
        "Kris Baumgarter (https://github.com/krispya)"
    ],
    bugs: {
        url: "https://github.com/pmndrs/react-three-fiber/issues"
    },
    homepage: "https://github.com/pmndrs/react-three-fiber#readme",
    repository: {
        type: "git",
        url: "git+https://github.com/pmndrs/react-three-fiber.git"
    },
    collective: {
        type: "opencollective",
        url: "https://opencollective.com/react-three-fiber"
    },
    main: "dist/react-three-fiber.cjs.js",
    module: "dist/react-three-fiber.esm.js",
    types: "dist/react-three-fiber.cjs.d.ts",
    "react-native": "native/dist/react-three-fiber-native.cjs.js",
    sideEffects: false,
    preconstruct: {
        entrypoints: [
            "index.tsx",
            "native.tsx"
        ]
    },
    scripts: {
        prebuild: "cp ../../readme.md readme.md"
    },
    dependencies: {
        "@babel/runtime": "^7.17.8",
        "@types/react-reconciler": "^0.32.0",
        "@types/webxr": "*",
        "base64-js": "^1.5.1",
        buffer: "^6.0.3",
        "its-fine": "^2.0.0",
        "react-reconciler": "^0.31.0",
        "react-use-measure": "^2.1.7",
        scheduler: "^0.25.0",
        "suspend-react": "^0.1.3",
        "use-sync-external-store": "^1.4.0",
        zustand: "^5.0.3"
    },
    peerDependencies: {
        expo: ">=43.0",
        "expo-asset": ">=8.4",
        "expo-file-system": ">=11.0",
        "expo-gl": ">=11.0",
        react: "^19.0.0",
        "react-dom": "^19.0.0",
        "react-native": ">=0.78",
        three: ">=0.156"
    },
    peerDependenciesMeta: {
        "react-dom": {
            optional: true
        },
        "react-native": {
            optional: true
        },
        expo: {
            optional: true
        },
        "expo-asset": {
            optional: true
        },
        "expo-file-system": {
            optional: true
        },
        "expo-gl": {
            optional: true
        }
    }
};
function createReconciler(config) {
    const reconciler = (0, _reactReconcilerDefault.default)(config);
    // @ts-ignore DefinitelyTyped is not up to date
    reconciler.injectIntoDevTools();
    return reconciler;
}
const NoEventPriority = 0;
// TODO: handle constructor overloads
// https://github.com/pmndrs/react-three-fiber/pull/2931
// https://github.com/microsoft/TypeScript/issues/37079
const catalogue = {};
const PREFIX_REGEX = /^three(?=[A-Z])/;
const toPascalCase = (type)=>`${type[0].toUpperCase()}${type.slice(1)}`;
let i = 0;
const isConstructor = (object)=>typeof object === 'function';
function extend(objects) {
    if (isConstructor(objects)) {
        const Component = `${i++}`;
        catalogue[Component] = objects;
        return Component;
    } else Object.assign(catalogue, objects);
}
function validateInstance(type, props) {
    // Get target from catalogue
    const name = toPascalCase(type);
    const target = catalogue[name];
    // Validate element target
    if (type !== 'primitive' && !target) throw new Error(`R3F: ${name} is not part of the THREE namespace! Did you forget to extend? See: https://docs.pmnd.rs/react-three-fiber/api/objects#using-3rd-party-objects-declaratively`);
    // Validate primitives
    if (type === 'primitive' && !props.object) throw new Error(`R3F: Primitives without 'object' are invalid!`);
    // Throw if an object or literal was passed for args
    if (props.args !== undefined && !Array.isArray(props.args)) throw new Error('R3F: The args prop must be an array!');
}
function createInstance(type, props, root) {
    var _props$object;
    // Remove three* prefix from elements if native element not present
    type = toPascalCase(type) in catalogue ? type : type.replace(PREFIX_REGEX, '');
    validateInstance(type, props);
    // Regenerate the R3F instance for primitives to simulate a new object
    if (type === 'primitive' && (_props$object = props.object) != null && _props$object.__r3f) delete props.object.__r3f;
    return prepare(props.object, root, type, props);
}
function hideInstance(instance) {
    if (!instance.isHidden) {
        var _instance$parent;
        if (instance.props.attach && (_instance$parent = instance.parent) != null && _instance$parent.object) detach(instance.parent, instance);
        else if (isObject3D(instance.object)) instance.object.visible = false;
        instance.isHidden = true;
        invalidateInstance(instance);
    }
}
function unhideInstance(instance) {
    if (instance.isHidden) {
        var _instance$parent2;
        if (instance.props.attach && (_instance$parent2 = instance.parent) != null && _instance$parent2.object) attach(instance.parent, instance);
        else if (isObject3D(instance.object) && instance.props.visible !== false) instance.object.visible = true;
        instance.isHidden = false;
        invalidateInstance(instance);
    }
}
// https://github.com/facebook/react/issues/20271
// This will make sure events and attach are only handled once when trees are complete
function handleContainerEffects(parent, child, beforeChild) {
    // Bail if tree isn't mounted or parent is not a container.
    // This ensures that the tree is finalized and React won't discard results to Suspense
    const state = child.root.getState();
    if (!parent.parent && parent.object !== state.scene) return;
    // Create & link object on first run
    if (!child.object) {
        var _child$props$object, _child$props$args;
        // Get target from catalogue
        const target = catalogue[toPascalCase(child.type)];
        // Create object
        child.object = (_child$props$object = child.props.object) != null ? _child$props$object : new target(...(_child$props$args = child.props.args) != null ? _child$props$args : []);
        child.object.__r3f = child;
    }
    // Set initial props
    applyProps(child.object, child.props);
    // Append instance
    if (child.props.attach) attach(parent, child);
    else if (isObject3D(child.object) && isObject3D(parent.object)) {
        const childIndex = parent.object.children.indexOf(beforeChild == null ? void 0 : beforeChild.object);
        if (beforeChild && childIndex !== -1) {
            // If the child is already in the parent's children array, move it to the new position
            // Otherwise, just insert it at the target position
            const existingIndex = parent.object.children.indexOf(child.object);
            if (existingIndex !== -1) {
                parent.object.children.splice(existingIndex, 1);
                const adjustedIndex = existingIndex < childIndex ? childIndex - 1 : childIndex;
                parent.object.children.splice(adjustedIndex, 0, child.object);
            } else {
                child.object.parent = parent.object;
                parent.object.children.splice(childIndex, 0, child.object);
                child.object.dispatchEvent({
                    type: 'added'
                });
                parent.object.dispatchEvent({
                    type: 'childadded',
                    child: child.object
                });
            }
        } else parent.object.add(child.object);
    }
    // Link subtree
    for (const childInstance of child.children)handleContainerEffects(child, childInstance);
    // Tree was updated, request a frame
    invalidateInstance(child);
}
function appendChild(parent, child) {
    if (!child) return;
    // Link instances
    child.parent = parent;
    parent.children.push(child);
    // Attach tree once complete
    handleContainerEffects(parent, child);
}
function insertBefore(parent, child, beforeChild) {
    if (!child || !beforeChild) return;
    // Link instances
    child.parent = parent;
    const childIndex = parent.children.indexOf(beforeChild);
    if (childIndex !== -1) parent.children.splice(childIndex, 0, child);
    else parent.children.push(child);
    // Attach tree once complete
    handleContainerEffects(parent, child, beforeChild);
}
function disposeOnIdle(object) {
    if (typeof object.dispose === 'function') {
        const handleDispose = ()=>{
            try {
                object.dispose();
            } catch  {
            // no-op
            }
        };
        // In a testing environment, cleanup immediately
        if (typeof IS_REACT_ACT_ENVIRONMENT !== 'undefined') handleDispose();
        else (0, _scheduler.unstable_scheduleCallback)((0, _scheduler.unstable_IdlePriority), handleDispose);
    }
}
function removeChild(parent, child, dispose) {
    if (!child) return;
    // Unlink instances
    child.parent = null;
    const childIndex = parent.children.indexOf(child);
    if (childIndex !== -1) parent.children.splice(childIndex, 1);
    // Eagerly tear down tree
    if (child.props.attach) detach(parent, child);
    else if (isObject3D(child.object) && isObject3D(parent.object)) {
        parent.object.remove(child.object);
        removeInteractivity(findInitialRoot(child), child.object);
    }
    // Allow objects to bail out of unmount disposal with dispose={null}
    const shouldDispose = child.props.dispose !== null && dispose !== false;
    // Recursively remove instance children
    for(let i = child.children.length - 1; i >= 0; i--){
        const node = child.children[i];
        removeChild(child, node, shouldDispose);
    }
    child.children.length = 0;
    // Unlink instance object
    delete child.object.__r3f;
    // Dispose object whenever the reconciler feels like it.
    // Never dispose of primitives because their state may be kept outside of React!
    // In order for an object to be able to dispose it
    //   - has a dispose method
    //   - cannot be a <primitive object={...} />
    //   - cannot be a THREE.Scene, because three has broken its own API
    if (shouldDispose && child.type !== 'primitive' && child.object.type !== 'Scene') disposeOnIdle(child.object);
    // Tree was updated, request a frame for top-level instance
    if (dispose === undefined) invalidateInstance(child);
}
function setFiberRef(fiber, publicInstance) {
    for (const _fiber of [
        fiber,
        fiber.alternate
    ])if (_fiber !== null) {
        if (typeof _fiber.ref === 'function') {
            _fiber.refCleanup == null || _fiber.refCleanup();
            const cleanup = _fiber.ref(publicInstance);
            if (typeof cleanup === 'function') _fiber.refCleanup = cleanup;
        } else if (_fiber.ref) _fiber.ref.current = publicInstance;
    }
}
const reconstructed = [];
function swapInstances() {
    // Detach instance
    for (const [instance] of reconstructed){
        const parent = instance.parent;
        if (parent) {
            if (instance.props.attach) detach(parent, instance);
            else if (isObject3D(instance.object) && isObject3D(parent.object)) parent.object.remove(instance.object);
            for (const child of instance.children){
                if (child.props.attach) detach(instance, child);
                else if (isObject3D(child.object) && isObject3D(instance.object)) instance.object.remove(child.object);
            }
        }
        // If the old instance is hidden, we need to unhide it.
        // React assumes it can discard instances since they're pure for DOM.
        // This isn't true for us since our lifetimes are impure and longliving.
        // So, we manually check if an instance was hidden and unhide it.
        if (instance.isHidden) unhideInstance(instance);
        // Dispose of old object if able
        if (instance.object.__r3f) delete instance.object.__r3f;
        if (instance.type !== 'primitive') disposeOnIdle(instance.object);
    }
    // Update instance
    for (const [instance, props, fiber] of reconstructed){
        instance.props = props;
        const parent = instance.parent;
        if (parent) {
            var _instance$props$objec, _instance$props$args;
            // Get target from catalogue
            const target = catalogue[toPascalCase(instance.type)];
            // Create object
            instance.object = (_instance$props$objec = instance.props.object) != null ? _instance$props$objec : new target(...(_instance$props$args = instance.props.args) != null ? _instance$props$args : []);
            instance.object.__r3f = instance;
            setFiberRef(fiber, instance.object);
            // Set initial props
            applyProps(instance.object, instance.props);
            if (instance.props.attach) attach(parent, instance);
            else if (isObject3D(instance.object) && isObject3D(parent.object)) parent.object.add(instance.object);
            for (const child of instance.children){
                if (child.props.attach) attach(instance, child);
                else if (isObject3D(child.object) && isObject3D(instance.object)) instance.object.add(child.object);
            }
            // Tree was updated, request a frame
            invalidateInstance(instance);
        }
    }
    reconstructed.length = 0;
}
// Don't handle text instances, make it no-op
const handleTextInstance = ()=>{};
const NO_CONTEXT = {};
let currentUpdatePriority = NoEventPriority;
// https://github.com/facebook/react/blob/main/packages/react-reconciler/src/ReactFiberFlags.js
const NoFlags = 0;
const Update = 4;
const reconciler = /* @__PURE__ */ createReconciler({
    isPrimaryRenderer: false,
    warnsIfNotActing: false,
    supportsMutation: true,
    supportsPersistence: false,
    supportsHydration: false,
    createInstance,
    removeChild,
    appendChild,
    appendInitialChild: appendChild,
    insertBefore,
    appendChildToContainer (container, child) {
        const scene = container.getState().scene.__r3f;
        if (!child || !scene) return;
        appendChild(scene, child);
    },
    removeChildFromContainer (container, child) {
        const scene = container.getState().scene.__r3f;
        if (!child || !scene) return;
        removeChild(scene, child);
    },
    insertInContainerBefore (container, child, beforeChild) {
        const scene = container.getState().scene.__r3f;
        if (!child || !beforeChild || !scene) return;
        insertBefore(scene, child, beforeChild);
    },
    getRootHostContext: ()=>NO_CONTEXT,
    getChildHostContext: ()=>NO_CONTEXT,
    commitUpdate (instance, type, oldProps, newProps, fiber) {
        var _newProps$args, _oldProps$args, _newProps$args2;
        validateInstance(type, newProps);
        let reconstruct = false;
        // Reconstruct primitives if object prop changes
        if (instance.type === 'primitive' && oldProps.object !== newProps.object) reconstruct = true;
        else if (((_newProps$args = newProps.args) == null ? void 0 : _newProps$args.length) !== ((_oldProps$args = oldProps.args) == null ? void 0 : _oldProps$args.length)) reconstruct = true;
        else if ((_newProps$args2 = newProps.args) != null && _newProps$args2.some((value, index)=>{
            var _oldProps$args2;
            return value !== ((_oldProps$args2 = oldProps.args) == null ? void 0 : _oldProps$args2[index]);
        })) reconstruct = true;
        // Reconstruct when args or <primitive object={...} have changes
        if (reconstruct) reconstructed.push([
            instance,
            {
                ...newProps
            },
            fiber
        ]);
        else {
            // Create a diff-set, flag if there are any changes
            const changedProps = diffProps(instance, newProps);
            if (Object.keys(changedProps).length) {
                Object.assign(instance.props, changedProps);
                applyProps(instance.object, changedProps);
            }
        }
        // Flush reconstructed siblings when we hit the last updated child in a sequence
        const isTailSibling = fiber.sibling === null || (fiber.flags & Update) === NoFlags;
        if (isTailSibling) swapInstances();
    },
    finalizeInitialChildren: ()=>false,
    commitMount () {},
    getPublicInstance: (instance)=>instance == null ? void 0 : instance.object,
    prepareForCommit: ()=>null,
    preparePortalMount: (container)=>prepare(container.getState().scene, container, '', {}),
    resetAfterCommit: ()=>{},
    shouldSetTextContent: ()=>false,
    clearContainer: ()=>false,
    hideInstance,
    unhideInstance,
    createTextInstance: handleTextInstance,
    hideTextInstance: handleTextInstance,
    unhideTextInstance: handleTextInstance,
    scheduleTimeout: typeof setTimeout === 'function' ? setTimeout : undefined,
    cancelTimeout: typeof clearTimeout === 'function' ? clearTimeout : undefined,
    noTimeout: -1,
    getInstanceFromNode: ()=>null,
    beforeActiveInstanceBlur () {},
    afterActiveInstanceBlur () {},
    detachDeletedInstance () {},
    prepareScopeUpdate () {},
    getInstanceFromScope: ()=>null,
    shouldAttemptEagerTransition: ()=>false,
    trackSchedulerEvent: ()=>{},
    resolveEventType: ()=>null,
    resolveEventTimeStamp: ()=>-1.1,
    requestPostPaintCallback () {},
    maySuspendCommit: ()=>false,
    preloadInstance: ()=>true,
    // true indicates already loaded
    startSuspendingCommit () {},
    suspendInstance () {},
    waitForCommitToBeReady: ()=>null,
    NotPendingTransition: null,
    // The reconciler types use the internal ReactContext with all the hidden properties
    // so we have to cast from the public React.Context type
    HostTransitionContext: /* @__PURE__ */ _react.createContext(null),
    setCurrentUpdatePriority (newPriority) {
        currentUpdatePriority = newPriority;
    },
    getCurrentUpdatePriority () {
        return currentUpdatePriority;
    },
    resolveUpdatePriority () {
        var _window$event;
        if (currentUpdatePriority !== NoEventPriority) return currentUpdatePriority;
        switch(typeof window !== 'undefined' && ((_window$event = window.event) == null ? void 0 : _window$event.type)){
            case 'click':
            case 'contextmenu':
            case 'dblclick':
            case 'pointercancel':
            case 'pointerdown':
            case 'pointerup':
                return 0, _constants.DiscreteEventPriority;
            case 'pointermove':
            case 'pointerout':
            case 'pointerover':
            case 'pointerenter':
            case 'pointerleave':
            case 'wheel':
                return 0, _constants.ContinuousEventPriority;
            default:
                return 0, _constants.DefaultEventPriority;
        }
    },
    resetFormInstance () {},
    // @ts-ignore DefinitelyTyped is not up to date
    rendererPackageName: '@react-three/fiber',
    rendererVersion: packageData.version
});
const _roots = new Map();
const shallowLoose = {
    objects: 'shallow',
    strict: false
};
function computeInitialSize(canvas, size) {
    if (!size && typeof HTMLCanvasElement !== 'undefined' && canvas instanceof HTMLCanvasElement && canvas.parentElement) {
        const { width, height, top, left } = canvas.parentElement.getBoundingClientRect();
        return {
            width,
            height,
            top,
            left
        };
    } else if (!size && typeof OffscreenCanvas !== 'undefined' && canvas instanceof OffscreenCanvas) return {
        width: canvas.width,
        height: canvas.height,
        top: 0,
        left: 0
    };
    return {
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        ...size
    };
}
function createRoot(canvas) {
    // Check against mistaken use of createRoot
    const prevRoot = _roots.get(canvas);
    const prevFiber = prevRoot == null ? void 0 : prevRoot.fiber;
    const prevStore = prevRoot == null ? void 0 : prevRoot.store;
    if (prevRoot) console.warn('R3F.createRoot should only be called once!');
    // Report when an error was detected in a previous render
    // https://github.com/pmndrs/react-three-fiber/pull/2261
    const logRecoverableError = typeof reportError === 'function' ? // In modern browsers, reportError will dispatch an error event,
    // emulating an uncaught JavaScript error.
    reportError : // In older browsers and test environments, fallback to console.error.
    console.error;
    // Create store
    const store = prevStore || createStore(invalidate, advance);
    // Create renderer
    const fiber = prevFiber || reconciler.createContainer(store, // container
    (0, _constants.ConcurrentRoot), // tag
    null, // hydration callbacks
    false, // isStrictMode
    null, // concurrentUpdatesByDefaultOverride
    '', // identifierPrefix
    logRecoverableError, // onUncaughtError
    logRecoverableError, // onCaughtError
    logRecoverableError, // onRecoverableError
    null // transitionCallbacks
    );
    // Map it
    if (!prevRoot) _roots.set(canvas, {
        fiber,
        store
    });
    // Locals
    let onCreated;
    let lastCamera;
    let configured = false;
    let pending = null;
    return {
        async configure (props = {}) {
            let resolve;
            pending = new Promise((_resolve)=>resolve = _resolve);
            let { gl: glConfig, size: propsSize, scene: sceneOptions, events, onCreated: onCreatedCallback, shadows = false, linear = false, flat = false, legacy = false, orthographic = false, frameloop = 'always', dpr = [
                1,
                2
            ], performance, raycaster: raycastOptions, camera: cameraOptions, onPointerMissed } = props;
            let state = store.getState();
            // Set up renderer (one time only!)
            let gl = state.gl;
            if (!state.gl) {
                const defaultProps = {
                    canvas: canvas,
                    powerPreference: 'high-performance',
                    antialias: true,
                    alpha: true
                };
                const customRenderer = typeof glConfig === 'function' ? await glConfig(defaultProps) : glConfig;
                if (isRenderer(customRenderer)) gl = customRenderer;
                else gl = new _three.WebGLRenderer({
                    ...defaultProps,
                    ...glConfig
                });
                state.set({
                    gl
                });
            }
            // Set up raycaster (one time only!)
            let raycaster = state.raycaster;
            if (!raycaster) state.set({
                raycaster: raycaster = new _three.Raycaster()
            });
            // Set raycaster options
            const { params, ...options } = raycastOptions || {};
            if (!is.equ(options, raycaster, shallowLoose)) applyProps(raycaster, {
                ...options
            });
            if (!is.equ(params, raycaster.params, shallowLoose)) applyProps(raycaster, {
                params: {
                    ...raycaster.params,
                    ...params
                }
            });
            // Create default camera, don't overwrite any user-set state
            if (!state.camera || state.camera === lastCamera && !is.equ(lastCamera, cameraOptions, shallowLoose)) {
                lastCamera = cameraOptions;
                const isCamera = cameraOptions == null ? void 0 : cameraOptions.isCamera;
                const camera = isCamera ? cameraOptions : orthographic ? new _three.OrthographicCamera(0, 0, 0, 0, 0.1, 1000) : new _three.PerspectiveCamera(75, 0, 0.1, 1000);
                if (!isCamera) {
                    camera.position.z = 5;
                    if (cameraOptions) {
                        applyProps(camera, cameraOptions);
                        // Preserve user-defined frustum if possible
                        // https://github.com/pmndrs/react-three-fiber/issues/3160
                        if (!camera.manual) {
                            if ('aspect' in cameraOptions || 'left' in cameraOptions || 'right' in cameraOptions || 'bottom' in cameraOptions || 'top' in cameraOptions) {
                                camera.manual = true;
                                camera.updateProjectionMatrix();
                            }
                        }
                    }
                    // Always look at center by default
                    if (!state.camera && !(cameraOptions != null && cameraOptions.rotation)) camera.lookAt(0, 0, 0);
                }
                state.set({
                    camera
                });
                // Configure raycaster
                // https://github.com/pmndrs/react-xr/issues/300
                raycaster.camera = camera;
            }
            // Set up scene (one time only!)
            if (!state.scene) {
                let scene;
                if (sceneOptions != null && sceneOptions.isScene) {
                    scene = sceneOptions;
                    prepare(scene, store, '', {});
                } else {
                    scene = new _three.Scene();
                    prepare(scene, store, '', {});
                    if (sceneOptions) applyProps(scene, sceneOptions);
                }
                state.set({
                    scene
                });
            }
            // Store events internally
            if (events && !state.events.handlers) state.set({
                events: events(store)
            });
            // Check size, allow it to take on container bounds initially
            const size = computeInitialSize(canvas, propsSize);
            if (!is.equ(size, state.size, shallowLoose)) state.setSize(size.width, size.height, size.top, size.left);
            // Check pixelratio
            if (dpr && state.viewport.dpr !== calculateDpr(dpr)) state.setDpr(dpr);
            // Check frameloop
            if (state.frameloop !== frameloop) state.setFrameloop(frameloop);
            // Check pointer missed
            if (!state.onPointerMissed) state.set({
                onPointerMissed
            });
            // Check performance
            if (performance && !is.equ(performance, state.performance, shallowLoose)) state.set((state)=>({
                    performance: {
                        ...state.performance,
                        ...performance
                    }
                }));
            // Set up XR (one time only!)
            if (!state.xr) {
                var _gl$xr;
                // Handle frame behavior in WebXR
                const handleXRFrame = (timestamp, frame)=>{
                    const state = store.getState();
                    if (state.frameloop === 'never') return;
                    advance(timestamp, true, state, frame);
                };
                // Toggle render switching on session
                const handleSessionChange = ()=>{
                    const state = store.getState();
                    state.gl.xr.enabled = state.gl.xr.isPresenting;
                    state.gl.xr.setAnimationLoop(state.gl.xr.isPresenting ? handleXRFrame : null);
                    if (!state.gl.xr.isPresenting) invalidate(state);
                };
                // WebXR session manager
                const xr = {
                    connect () {
                        const gl = store.getState().gl;
                        gl.xr.addEventListener('sessionstart', handleSessionChange);
                        gl.xr.addEventListener('sessionend', handleSessionChange);
                    },
                    disconnect () {
                        const gl = store.getState().gl;
                        gl.xr.removeEventListener('sessionstart', handleSessionChange);
                        gl.xr.removeEventListener('sessionend', handleSessionChange);
                    }
                };
                // Subscribe to WebXR session events
                if (typeof ((_gl$xr = gl.xr) == null ? void 0 : _gl$xr.addEventListener) === 'function') xr.connect();
                state.set({
                    xr
                });
            }
            // Set shadowmap
            if (gl.shadowMap) {
                const oldEnabled = gl.shadowMap.enabled;
                const oldType = gl.shadowMap.type;
                gl.shadowMap.enabled = !!shadows;
                if (is.boo(shadows)) gl.shadowMap.type = _three.PCFSoftShadowMap;
                else if (is.str(shadows)) {
                    var _types$shadows;
                    const types = {
                        basic: _three.BasicShadowMap,
                        percentage: _three.PCFShadowMap,
                        soft: _three.PCFSoftShadowMap,
                        variance: _three.VSMShadowMap
                    };
                    gl.shadowMap.type = (_types$shadows = types[shadows]) != null ? _types$shadows : _three.PCFSoftShadowMap;
                } else if (is.obj(shadows)) Object.assign(gl.shadowMap, shadows);
                if (oldEnabled !== gl.shadowMap.enabled || oldType !== gl.shadowMap.type) gl.shadowMap.needsUpdate = true;
            }
            _three.ColorManagement.enabled = !legacy;
            // Set color space and tonemapping preferences
            if (!configured) {
                gl.outputColorSpace = linear ? _three.LinearSRGBColorSpace : _three.SRGBColorSpace;
                gl.toneMapping = flat ? _three.NoToneMapping : _three.ACESFilmicToneMapping;
            }
            // Update color management state
            if (state.legacy !== legacy) state.set(()=>({
                    legacy
                }));
            if (state.linear !== linear) state.set(()=>({
                    linear
                }));
            if (state.flat !== flat) state.set(()=>({
                    flat
                }));
            // Set gl props
            if (glConfig && !is.fun(glConfig) && !isRenderer(glConfig) && !is.equ(glConfig, gl, shallowLoose)) applyProps(gl, glConfig);
            // Set locals
            onCreated = onCreatedCallback;
            configured = true;
            resolve();
            return this;
        },
        render (children) {
            // The root has to be configured before it can be rendered
            if (!configured && !pending) this.configure();
            pending.then(()=>{
                reconciler.updateContainer(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Provider, {
                    store: store,
                    children: children,
                    onCreated: onCreated,
                    rootElement: canvas
                }), fiber, null, ()=>undefined);
            });
            return store;
        },
        unmount () {
            unmountComponentAtNode(canvas);
        }
    };
}
function Provider({ store, children, onCreated, rootElement }) {
    useIsomorphicLayoutEffect(()=>{
        const state = store.getState();
        // Flag the canvas active, rendering will now begin
        state.set((state)=>({
                internal: {
                    ...state.internal,
                    active: true
                }
            }));
        // Notify that init is completed, the scene graph exists, but nothing has yet rendered
        if (onCreated) onCreated(state);
        // Connect events to the targets parent, this is done to ensure events are registered on
        // a shared target, and not on the canvas itself
        if (!store.getState().events.connected) state.events.connect == null || state.events.connect(rootElement);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(context.Provider, {
        value: store,
        children: children
    });
}
function unmountComponentAtNode(canvas, callback) {
    const root = _roots.get(canvas);
    const fiber = root == null ? void 0 : root.fiber;
    if (fiber) {
        const state = root == null ? void 0 : root.store.getState();
        if (state) state.internal.active = false;
        reconciler.updateContainer(null, fiber, null, ()=>{
            if (state) setTimeout(()=>{
                try {
                    var _state$gl, _state$gl$renderLists, _state$gl2, _state$gl3;
                    state.events.disconnect == null || state.events.disconnect();
                    (_state$gl = state.gl) == null || (_state$gl$renderLists = _state$gl.renderLists) == null || _state$gl$renderLists.dispose == null || _state$gl$renderLists.dispose();
                    (_state$gl2 = state.gl) == null || _state$gl2.forceContextLoss == null || _state$gl2.forceContextLoss();
                    if ((_state$gl3 = state.gl) != null && _state$gl3.xr) state.xr.disconnect();
                    dispose(state.scene);
                    _roots.delete(canvas);
                    if (callback) callback(canvas);
                } catch (e) {
                /* ... */ }
            }, 500);
        });
    }
}
function createPortal(children, container, state) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Portal, {
        children: children,
        container: container,
        state: state
    });
}
function Portal({ state = {}, children, container }) {
    /** This has to be a component because it would not be able to call useThree/useStore otherwise since
   *  if this is our environment, then we are not in r3f's renderer but in react-dom, it would trigger
   *  the "R3F hooks can only be used within the Canvas component!" warning:
   *  <Canvas>
   *    {createPortal(...)} */ const { events, size, ...rest } = state;
    const previousRoot = useStore();
    const [raycaster] = _react.useState(()=>new _three.Raycaster());
    const [pointer] = _react.useState(()=>new _three.Vector2());
    const inject = useMutableCallback((rootState, injectState)=>{
        let viewport = undefined;
        if (injectState.camera && size) {
            const camera = injectState.camera;
            // Calculate the override viewport, if present
            viewport = rootState.viewport.getCurrentViewport(camera, new _three.Vector3(), size);
            // Update the portal camera, if it differs from the previous layer
            if (camera !== rootState.camera) updateCamera(camera, size);
        }
        return {
            // The intersect consists of the previous root state
            ...rootState,
            ...injectState,
            // Portals have their own scene, which forms the root, a raycaster and a pointer
            scene: container,
            raycaster,
            pointer,
            mouse: pointer,
            // Their previous root is the layer before it
            previousRoot,
            // Events, size and viewport can be overridden by the inject layer
            events: {
                ...rootState.events,
                ...injectState.events,
                ...events
            },
            size: {
                ...rootState.size,
                ...size
            },
            viewport: {
                ...rootState.viewport,
                ...viewport
            },
            // Layers are allowed to override events
            setEvents: (events)=>injectState.set((state)=>({
                        ...state,
                        events: {
                            ...state.events,
                            ...events
                        }
                    }))
        };
    });
    const usePortalStore = _react.useMemo(()=>{
        // Create a mirrored store, based on the previous root with a few overrides ...
        const store = (0, _traditional.createWithEqualityFn)((set, get)=>({
                ...rest,
                set,
                get
            }));
        // Subscribe to previous root-state and copy changes over to the mirrored portal-state
        const onMutate = (prev)=>store.setState((state)=>inject.current(prev, state));
        onMutate(previousRoot.getState());
        previousRoot.subscribe(onMutate);
        return store;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        previousRoot,
        container
    ]);
    return(/*#__PURE__*/ // @ts-ignore, reconciler types are not maintained
    (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: reconciler.createPortal(/*#__PURE__*/ (0, _jsxRuntime.jsx)(context.Provider, {
            value: usePortalStore,
            children: children
        }), usePortalStore, null)
    }));
}
/**
 * Force React to flush any updates inside the provided callback synchronously and immediately.
 * All the same caveats documented for react-dom's `flushSync` apply here (see https://react.dev/reference/react-dom/flushSync).
 * Nevertheless, sometimes one needs to render synchronously, for example to keep DOM and 3D changes in lock-step without
 * having to revert to a non-React solution. Note: this will only flush updates within the `Canvas` root.
 */ function flushSync(fn) {
    // @ts-ignore - reconciler types are not maintained
    return reconciler.flushSyncFromReconciler(fn);
}
function createSubs(callback, subs) {
    const sub = {
        callback
    };
    subs.add(sub);
    return ()=>void subs.delete(sub);
}
const globalEffects = new Set();
const globalAfterEffects = new Set();
const globalTailEffects = new Set();
/**
 * Adds a global render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addEffect
 */ const addEffect = (callback)=>createSubs(callback, globalEffects);
/**
 * Adds a global after-render callback which is called each frame.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addAfterEffect
 */ const addAfterEffect = (callback)=>createSubs(callback, globalAfterEffects);
/**
 * Adds a global callback which is called when rendering stops.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#addTail
 */ const addTail = (callback)=>createSubs(callback, globalTailEffects);
function run(effects, timestamp) {
    if (!effects.size) return;
    for (const { callback } of effects.values())callback(timestamp);
}
function flushGlobalEffects(type, timestamp) {
    switch(type){
        case 'before':
            return run(globalEffects, timestamp);
        case 'after':
            return run(globalAfterEffects, timestamp);
        case 'tail':
            return run(globalTailEffects, timestamp);
    }
}
let subscribers;
let subscription;
function update(timestamp, state, frame) {
    // Run local effects
    let delta = state.clock.getDelta();
    // In frameloop='never' mode, clock times are updated using the provided timestamp
    if (state.frameloop === 'never' && typeof timestamp === 'number') {
        delta = timestamp - state.clock.elapsedTime;
        state.clock.oldTime = state.clock.elapsedTime;
        state.clock.elapsedTime = timestamp;
    }
    // Call subscribers (useFrame)
    subscribers = state.internal.subscribers;
    for(let i = 0; i < subscribers.length; i++){
        subscription = subscribers[i];
        subscription.ref.current(subscription.store.getState(), delta, frame);
    }
    // Render content
    if (!state.internal.priority && state.gl.render) state.gl.render(state.scene, state.camera);
    // Decrease frame count
    state.internal.frames = Math.max(0, state.internal.frames - 1);
    return state.frameloop === 'always' ? 1 : state.internal.frames;
}
let running = false;
let useFrameInProgress = false;
let repeat;
let frame;
let state;
function loop(timestamp) {
    frame = requestAnimationFrame(loop);
    running = true;
    repeat = 0;
    // Run effects
    flushGlobalEffects('before', timestamp);
    // Render all roots
    useFrameInProgress = true;
    for (const root of _roots.values()){
        var _state$gl$xr;
        state = root.store.getState();
        // If the frameloop is invalidated, do not run another frame
        if (state.internal.active && (state.frameloop === 'always' || state.internal.frames > 0) && !((_state$gl$xr = state.gl.xr) != null && _state$gl$xr.isPresenting)) repeat += update(timestamp, state);
    }
    useFrameInProgress = false;
    // Run after-effects
    flushGlobalEffects('after', timestamp);
    // Stop the loop if nothing invalidates it
    if (repeat === 0) {
        // Tail call effects, they are called when rendering stops
        flushGlobalEffects('tail', timestamp);
        // Flag end of operation
        running = false;
        return cancelAnimationFrame(frame);
    }
}
/**
 * Invalidates the view, requesting a frame to be rendered. Will globally invalidate unless passed a root's state.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#invalidate
 */ function invalidate(state, frames = 1) {
    var _state$gl$xr2;
    if (!state) return _roots.forEach((root)=>invalidate(root.store.getState(), frames));
    if ((_state$gl$xr2 = state.gl.xr) != null && _state$gl$xr2.isPresenting || !state.internal.active || state.frameloop === 'never') return;
    if (frames > 1) // legacy support for people using frames parameters
    // Increase frames, do not go higher than 60
    state.internal.frames = Math.min(60, state.internal.frames + frames);
    else if (useFrameInProgress) //called from within a useFrame, it means the user wants an additional frame
    state.internal.frames = 2;
    else //the user need a new frame, no need to increment further than 1
    state.internal.frames = 1;
    // If the render-loop isn't active, start it
    if (!running) {
        running = true;
        requestAnimationFrame(loop);
    }
}
/**
 * Advances the frameloop and runs render effects, useful for when manually rendering via `frameloop="never"`.
 * @see https://docs.pmnd.rs/react-three-fiber/api/additional-exports#advance
 */ function advance(timestamp, runGlobalEffects = true, state, frame) {
    if (runGlobalEffects) flushGlobalEffects('before', timestamp);
    if (!state) for (const root of _roots.values())update(timestamp, root.store.getState());
    else update(timestamp, state, frame);
    if (runGlobalEffects) flushGlobalEffects('after', timestamp);
}
const DOM_EVENTS = {
    onClick: [
        'click',
        false
    ],
    onContextMenu: [
        'contextmenu',
        false
    ],
    onDoubleClick: [
        'dblclick',
        false
    ],
    onWheel: [
        'wheel',
        true
    ],
    onPointerDown: [
        'pointerdown',
        true
    ],
    onPointerUp: [
        'pointerup',
        true
    ],
    onPointerLeave: [
        'pointerleave',
        true
    ],
    onPointerMove: [
        'pointermove',
        true
    ],
    onPointerCancel: [
        'pointercancel',
        true
    ],
    onLostPointerCapture: [
        'lostpointercapture',
        true
    ]
};
/** Default R3F event manager for web */ function createPointerEvents(store) {
    const { handlePointer } = createEvents(store);
    return {
        priority: 1,
        enabled: true,
        compute (event, state, previous) {
            // https://github.com/pmndrs/react-three-fiber/pull/782
            // Events trigger outside of canvas when moved, use offsetX/Y by default and allow overrides
            state.pointer.set(event.offsetX / state.size.width * 2 - 1, -(event.offsetY / state.size.height) * 2 + 1);
            state.raycaster.setFromCamera(state.pointer, state.camera);
        },
        connected: undefined,
        handlers: Object.keys(DOM_EVENTS).reduce((acc, key)=>({
                ...acc,
                [key]: handlePointer(key)
            }), {}),
        update: ()=>{
            var _internal$lastEvent;
            const { events, internal } = store.getState();
            if ((_internal$lastEvent = internal.lastEvent) != null && _internal$lastEvent.current && events.handlers) events.handlers.onPointerMove(internal.lastEvent.current);
        },
        connect: (target)=>{
            const { set, events } = store.getState();
            events.disconnect == null || events.disconnect();
            set((state)=>({
                    events: {
                        ...state.events,
                        connected: target
                    }
                }));
            if (events.handlers) for(const name in events.handlers){
                const event = events.handlers[name];
                const [eventName, passive] = DOM_EVENTS[name];
                target.addEventListener(eventName, event, {
                    passive
                });
            }
        },
        disconnect: ()=>{
            const { set, events } = store.getState();
            if (events.connected) {
                if (events.handlers) for(const name in events.handlers){
                    const event = events.handlers[name];
                    const [eventName] = DOM_EVENTS[name];
                    events.connected.removeEventListener(eventName, event);
                }
                set((state)=>({
                        events: {
                            ...state.events,
                            connected: undefined
                        }
                    }));
            }
        }
    };
}

},{"react":"bmhQu","react-reconciler/constants":"dfuGR","three":"hZcQL","zustand/traditional":"196jd","suspend-react":"hMPkZ","react-reconciler":"92rXo","scheduler":"dHubo","react/jsx-runtime":"gonF6","its-fine":"3eSSa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dfuGR":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("90018208127929c3");

},{"90018208127929c3":"9P82P"}],"9P82P":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-reconciler-constants.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
exports.ConcurrentRoot = 1;
exports.ContinuousEventPriority = 8;
exports.DefaultEventPriority = 32;
exports.DiscreteEventPriority = 2;
exports.IdleEventPriority = 268435456;
exports.LegacyRoot = 0;
exports.NoEventPriority = 0;

},{}],"196jd":[function(require,module,exports,__globalThis) {
'use strict';
var React = require("55fe33b72be7f997");
var useSyncExternalStoreExports = require("bfacb3376c7259e5");
var vanilla = require("93e7584e5ac2a823");
const { useSyncExternalStoreWithSelector } = useSyncExternalStoreExports;
const identity = (arg)=>arg;
function useStoreWithEqualityFn(api, selector = identity, equalityFn) {
    const slice = useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getInitialState, selector, equalityFn);
    React.useDebugValue(slice);
    return slice;
}
const createWithEqualityFnImpl = (createState, defaultEqualityFn)=>{
    const api = vanilla.createStore(createState);
    const useBoundStoreWithEqualityFn = (selector, equalityFn = defaultEqualityFn)=>useStoreWithEqualityFn(api, selector, equalityFn);
    Object.assign(useBoundStoreWithEqualityFn, api);
    return useBoundStoreWithEqualityFn;
};
const createWithEqualityFn = (createState, defaultEqualityFn)=>createState ? createWithEqualityFnImpl(createState, defaultEqualityFn) : createWithEqualityFnImpl;
exports.createWithEqualityFn = createWithEqualityFn;
exports.useStoreWithEqualityFn = useStoreWithEqualityFn;

},{"55fe33b72be7f997":"bmhQu","bfacb3376c7259e5":"j1vWm","93e7584e5ac2a823":"bsCIB"}],"j1vWm":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("d1848724d1e53763");

},{"d1848724d1e53763":"8sq3O"}],"8sq3O":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("d57a74df6bca20fd"), shim = require("5be634d856d1f9fa");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = shim.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    useDebugValue(value);
    return value;
};

},{"d57a74df6bca20fd":"bmhQu","5be634d856d1f9fa":"6U7cH"}],"6U7cH":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("3e3e060a1c619377");

},{"3e3e060a1c619377":"adP2B"}],"adP2B":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("a18024ece7b3cd12");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useState = React.useState, useEffect = React.useEffect, useLayoutEffect = React.useLayoutEffect, useDebugValue = React.useDebugValue;
function useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    useEffect(function() {
        checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    useDebugValue(value);
    return value;
}
function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
exports.useSyncExternalStore = void 0 !== React.useSyncExternalStore ? React.useSyncExternalStore : shim;

},{"a18024ece7b3cd12":"bmhQu"}],"bsCIB":[function(require,module,exports,__globalThis) {
'use strict';
const createStoreImpl = (createState)=>{
    let state;
    const listeners = /* @__PURE__ */ new Set();
    const setState = (partial, replace)=>{
        const nextState = typeof partial === "function" ? partial(state) : partial;
        if (!Object.is(nextState, state)) {
            const previousState = state;
            state = (replace != null ? replace : typeof nextState !== "object" || nextState === null) ? nextState : Object.assign({}, state, nextState);
            listeners.forEach((listener)=>listener(state, previousState));
        }
    };
    const getState = ()=>state;
    const getInitialState = ()=>initialState;
    const subscribe = (listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    };
    const api = {
        setState,
        getState,
        getInitialState,
        subscribe
    };
    const initialState = state = createState(setState, getState, api);
    return api;
};
const createStore = (createState)=>createState ? createStoreImpl(createState) : createStoreImpl;
exports.createStore = createStore;

},{}],"hMPkZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clear", ()=>clear);
parcelHelpers.export(exports, "peek", ()=>peek);
parcelHelpers.export(exports, "preload", ()=>preload);
parcelHelpers.export(exports, "suspend", ()=>suspend);
const isPromise = (promise)=>typeof promise === 'object' && typeof promise.then === 'function';
const globalCache = [];
function shallowEqualArrays(arrA, arrB, equal = (a, b)=>a === b) {
    if (arrA === arrB) return true;
    if (!arrA || !arrB) return false;
    const len = arrA.length;
    if (arrB.length !== len) return false;
    for(let i = 0; i < len; i++)if (!equal(arrA[i], arrB[i])) return false;
    return true;
}
function query(fn, keys = null, preload = false, config = {}) {
    // If no keys were given, the function is the key
    if (keys === null) keys = [
        fn
    ];
    for (const entry of globalCache)// Find a match
    if (shallowEqualArrays(keys, entry.keys, entry.equal)) {
        // If we're pre-loading and the element is present, just return
        if (preload) return undefined; // If an error occurred, throw
        if (Object.prototype.hasOwnProperty.call(entry, 'error')) throw entry.error; // If a response was successful, return
        if (Object.prototype.hasOwnProperty.call(entry, 'response')) {
            if (config.lifespan && config.lifespan > 0) {
                if (entry.timeout) clearTimeout(entry.timeout);
                entry.timeout = setTimeout(entry.remove, config.lifespan);
            }
            return entry.response;
        } // If the promise is still unresolved, throw
        if (!preload) throw entry.promise;
    }
     // The request is new or has changed.
    const entry = {
        keys,
        equal: config.equal,
        remove: ()=>{
            const index = globalCache.indexOf(entry);
            if (index !== -1) globalCache.splice(index, 1);
        },
        promise: (isPromise(fn) ? fn : fn(...keys) // When it resolves, store its value
        ).then((response)=>{
            entry.response = response; // Remove the entry in time if a lifespan was given
            if (config.lifespan && config.lifespan > 0) entry.timeout = setTimeout(entry.remove, config.lifespan);
        }) // Store caught errors, they will be thrown in the render-phase to bubble into an error-bound
        .catch((error)=>entry.error = error)
    }; // Register the entry
    globalCache.push(entry); // And throw the promise, this yields control back to React
    if (!preload) throw entry.promise;
    return undefined;
}
const suspend = (fn, keys, config)=>query(fn, keys, false, config);
const preload = (fn, keys, config)=>void query(fn, keys, true, config);
const peek = (keys)=>{
    var _globalCache$find;
    return (_globalCache$find = globalCache.find((entry)=>shallowEqualArrays(keys, entry.keys, entry.equal))) == null ? void 0 : _globalCache$find.response;
};
const clear = (keys)=>{
    if (keys === undefined || keys.length === 0) globalCache.splice(0, globalCache.length);
    else {
        const entry = globalCache.find((entry)=>shallowEqualArrays(keys, entry.keys, entry.equal));
        if (entry) entry.remove();
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"92rXo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("463d2b6bf8f327f0");

},{"463d2b6bf8f327f0":"2bFlH"}],"2bFlH":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-reconciler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
module.exports = function($$$config) {
    function createFiber(tag, pendingProps, key, mode) {
        return new FiberNode(tag, pendingProps, key, mode);
    }
    function noop() {}
    function formatProdErrorMessage(code) {
        var url = "https://react.dev/errors/" + code;
        if (1 < arguments.length) {
            url += "?args[]=" + encodeURIComponent(arguments[1]);
            for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
        }
        return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
    }
    function getIteratorFn(maybeIterable) {
        if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
        maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
        return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function getComponentNameFromType(type) {
        if (null == type) return null;
        if ("function" === typeof type) return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
        if ("string" === typeof type) return type;
        switch(type){
            case REACT_FRAGMENT_TYPE:
                return "Fragment";
            case REACT_PORTAL_TYPE:
                return "Portal";
            case REACT_PROFILER_TYPE:
                return "Profiler";
            case REACT_STRICT_MODE_TYPE:
                return "StrictMode";
            case REACT_SUSPENSE_TYPE:
                return "Suspense";
            case REACT_SUSPENSE_LIST_TYPE:
                return "SuspenseList";
        }
        if ("object" === typeof type) switch(type.$$typeof){
            case REACT_CONTEXT_TYPE:
                return (type.displayName || "Context") + ".Provider";
            case REACT_CONSUMER_TYPE:
                return (type._context.displayName || "Context") + ".Consumer";
            case REACT_FORWARD_REF_TYPE:
                var innerType = type.render;
                type = type.displayName;
                type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
                return type;
            case REACT_MEMO_TYPE:
                return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
            case REACT_LAZY_TYPE:
                innerType = type._payload;
                type = type._init;
                try {
                    return getComponentNameFromType(type(innerType));
                } catch (x) {}
        }
        return null;
    }
    function describeBuiltInComponentFrame(name) {
        if (void 0 === prefix) try {
            throw Error();
        } catch (x) {
            var match = x.stack.trim().match(/\n( *(at )?)/);
            prefix = match && match[1] || "";
            suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
        return "\n" + prefix + name + suffix;
    }
    function describeNativeComponentFrame(fn, construct) {
        if (!fn || reentry) return "";
        reentry = !0;
        var previousPrepareStackTrace = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        try {
            var RunInRootFrame = {
                DetermineComponentFrameRoot: function() {
                    try {
                        if (construct) {
                            var Fake = function() {
                                throw Error();
                            };
                            Object.defineProperty(Fake.prototype, "props", {
                                set: function() {
                                    throw Error();
                                }
                            });
                            if ("object" === typeof Reflect && Reflect.construct) {
                                try {
                                    Reflect.construct(Fake, []);
                                } catch (x) {
                                    var control = x;
                                }
                                Reflect.construct(fn, [], Fake);
                            } else {
                                try {
                                    Fake.call();
                                } catch (x$0) {
                                    control = x$0;
                                }
                                fn.call(Fake.prototype);
                            }
                        } else {
                            try {
                                throw Error();
                            } catch (x$1) {
                                control = x$1;
                            }
                            (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                        }
                    } catch (sample) {
                        if (sample && control && "string" === typeof sample.stack) return [
                            sample.stack,
                            control.stack
                        ];
                    }
                    return [
                        null,
                        null
                    ];
                }
            };
            RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
            var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
            namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
                value: "DetermineComponentFrameRoot"
            });
            var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
            if (sampleStack && controlStack) {
                var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
                for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
                for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
                if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
                for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                    if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                        do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                            var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                            fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                            return frame;
                        }
                        while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                    }
                    break;
                }
            }
        } finally{
            reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
        }
        return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
    }
    function describeFiber(fiber) {
        switch(fiber.tag){
            case 26:
            case 27:
            case 5:
                return describeBuiltInComponentFrame(fiber.type);
            case 16:
                return describeBuiltInComponentFrame("Lazy");
            case 13:
                return describeBuiltInComponentFrame("Suspense");
            case 19:
                return describeBuiltInComponentFrame("SuspenseList");
            case 0:
            case 15:
                return fiber = describeNativeComponentFrame(fiber.type, !1), fiber;
            case 11:
                return fiber = describeNativeComponentFrame(fiber.type.render, !1), fiber;
            case 1:
                return fiber = describeNativeComponentFrame(fiber.type, !0), fiber;
            default:
                return "";
        }
    }
    function getStackByFiberInDevAndProd(workInProgress) {
        try {
            var info = "";
            do info += describeFiber(workInProgress), workInProgress = workInProgress.return;
            while (workInProgress);
            return info;
        } catch (x) {
            return "\nError generating stack: " + x.message + "\n" + x.stack;
        }
    }
    function getNearestMountedFiber(fiber) {
        var node = fiber, nearestMounted = fiber;
        if (fiber.alternate) for(; node.return;)node = node.return;
        else {
            fiber = node;
            do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
            while (fiber);
        }
        return 3 === node.tag ? nearestMounted : null;
    }
    function assertIsMounted(fiber) {
        if (getNearestMountedFiber(fiber) !== fiber) throw Error(formatProdErrorMessage(188));
    }
    function findCurrentFiberUsingSlowPath(fiber) {
        var alternate = fiber.alternate;
        if (!alternate) {
            alternate = getNearestMountedFiber(fiber);
            if (null === alternate) throw Error(formatProdErrorMessage(188));
            return alternate !== fiber ? null : fiber;
        }
        for(var a = fiber, b = alternate;;){
            var parentA = a.return;
            if (null === parentA) break;
            var parentB = parentA.alternate;
            if (null === parentB) {
                b = parentA.return;
                if (null !== b) {
                    a = b;
                    continue;
                }
                break;
            }
            if (parentA.child === parentB.child) {
                for(parentB = parentA.child; parentB;){
                    if (parentB === a) return assertIsMounted(parentA), fiber;
                    if (parentB === b) return assertIsMounted(parentA), alternate;
                    parentB = parentB.sibling;
                }
                throw Error(formatProdErrorMessage(188));
            }
            if (a.return !== b.return) a = parentA, b = parentB;
            else {
                for(var didFindChild = !1, child$2 = parentA.child; child$2;){
                    if (child$2 === a) {
                        didFindChild = !0;
                        a = parentA;
                        b = parentB;
                        break;
                    }
                    if (child$2 === b) {
                        didFindChild = !0;
                        b = parentA;
                        a = parentB;
                        break;
                    }
                    child$2 = child$2.sibling;
                }
                if (!didFindChild) {
                    for(child$2 = parentB.child; child$2;){
                        if (child$2 === a) {
                            didFindChild = !0;
                            a = parentB;
                            b = parentA;
                            break;
                        }
                        if (child$2 === b) {
                            didFindChild = !0;
                            b = parentB;
                            a = parentA;
                            break;
                        }
                        child$2 = child$2.sibling;
                    }
                    if (!didFindChild) throw Error(formatProdErrorMessage(189));
                }
            }
            if (a.alternate !== b) throw Error(formatProdErrorMessage(190));
        }
        if (3 !== a.tag) throw Error(formatProdErrorMessage(188));
        return a.stateNode.current === a ? fiber : alternate;
    }
    function findCurrentHostFiberImpl(node) {
        var tag = node.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
        for(node = node.child; null !== node;){
            tag = findCurrentHostFiberImpl(node);
            if (null !== tag) return tag;
            node = node.sibling;
        }
        return null;
    }
    function findCurrentHostFiberWithNoPortalsImpl(node) {
        var tag = node.tag;
        if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
        for(node = node.child; null !== node;){
            if (4 !== node.tag && (tag = findCurrentHostFiberWithNoPortalsImpl(node), null !== tag)) return tag;
            node = node.sibling;
        }
        return null;
    }
    function createCursor(defaultValue) {
        return {
            current: defaultValue
        };
    }
    function pop(cursor) {
        0 > index$jscomp$0 || (cursor.current = valueStack[index$jscomp$0], valueStack[index$jscomp$0] = null, index$jscomp$0--);
    }
    function push(cursor, value) {
        index$jscomp$0++;
        valueStack[index$jscomp$0] = cursor.current;
        cursor.current = value;
    }
    function clz32Fallback(x) {
        x >>>= 0;
        return 0 === x ? 32 : 31 - (log$1(x) / LN2 | 0) | 0;
    }
    function getHighestPriorityLanes(lanes) {
        var pendingSyncLanes = lanes & 42;
        if (0 !== pendingSyncLanes) return pendingSyncLanes;
        switch(lanes & -lanes){
            case 1:
                return 1;
            case 2:
                return 2;
            case 4:
                return 4;
            case 8:
                return 8;
            case 16:
                return 16;
            case 32:
                return 32;
            case 64:
                return 64;
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return lanes & 4194176;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return lanes & 62914560;
            case 67108864:
                return 67108864;
            case 134217728:
                return 134217728;
            case 268435456:
                return 268435456;
            case 536870912:
                return 536870912;
            case 1073741824:
                return 0;
            default:
                return lanes;
        }
    }
    function getNextLanes(root, wipLanes) {
        var pendingLanes = root.pendingLanes;
        if (0 === pendingLanes) return 0;
        var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, warmLanes = root.warmLanes;
        root = 0 !== root.finishedLanes;
        var nonIdlePendingLanes = pendingLanes & 134217727;
        0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : root || (warmLanes = nonIdlePendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = getHighestPriorityLanes(warmLanes))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : root || (warmLanes = pendingLanes & ~warmLanes, 0 !== warmLanes && (nextLanes = getHighestPriorityLanes(warmLanes))));
        return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, warmLanes = wipLanes & -wipLanes, suspendedLanes >= warmLanes || 32 === suspendedLanes && 0 !== (warmLanes & 4194176)) ? wipLanes : nextLanes;
    }
    function checkIfRootIsPrerendering(root, renderLanes) {
        return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
    }
    function computeExpirationTime(lane, currentTime) {
        switch(lane){
            case 1:
            case 2:
            case 4:
            case 8:
                return currentTime + 250;
            case 16:
            case 32:
            case 64:
            case 128:
            case 256:
            case 512:
            case 1024:
            case 2048:
            case 4096:
            case 8192:
            case 16384:
            case 32768:
            case 65536:
            case 131072:
            case 262144:
            case 524288:
            case 1048576:
            case 2097152:
                return currentTime + 5e3;
            case 4194304:
            case 8388608:
            case 16777216:
            case 33554432:
                return -1;
            case 67108864:
            case 134217728:
            case 268435456:
            case 536870912:
            case 1073741824:
                return -1;
            default:
                return -1;
        }
    }
    function claimNextTransitionLane() {
        var lane = nextTransitionLane;
        nextTransitionLane <<= 1;
        0 === (nextTransitionLane & 4194176) && (nextTransitionLane = 128);
        return lane;
    }
    function claimNextRetryLane() {
        var lane = nextRetryLane;
        nextRetryLane <<= 1;
        0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
        return lane;
    }
    function createLaneMap(initial) {
        for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
        return laneMap;
    }
    function markRootUpdated$1(root, updateLane) {
        root.pendingLanes |= updateLane;
        268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
    }
    function markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
        var previouslyPendingLanes = root.pendingLanes;
        root.pendingLanes = remainingLanes;
        root.suspendedLanes = 0;
        root.pingedLanes = 0;
        root.warmLanes = 0;
        root.expiredLanes &= remainingLanes;
        root.entangledLanes &= remainingLanes;
        root.errorRecoveryDisabledLanes &= remainingLanes;
        root.shellSuspendCounter = 0;
        var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
        for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
            var index$7 = 31 - clz32(remainingLanes), lane = 1 << index$7;
            entanglements[index$7] = 0;
            expirationTimes[index$7] = -1;
            var hiddenUpdatesForLane = hiddenUpdates[index$7];
            if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
                var update = hiddenUpdatesForLane[index$7];
                null !== update && (update.lane &= -536870913);
            }
            remainingLanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, 0);
        0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
    }
    function markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
        root.pendingLanes |= spawnedLane;
        root.suspendedLanes &= ~spawnedLane;
        var spawnedLaneIndex = 31 - clz32(spawnedLane);
        root.entangledLanes |= spawnedLane;
        root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 4194218;
    }
    function markRootEntangled(root, entangledLanes) {
        var rootEntangledLanes = root.entangledLanes |= entangledLanes;
        for(root = root.entanglements; rootEntangledLanes;){
            var index$8 = 31 - clz32(rootEntangledLanes), lane = 1 << index$8;
            lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
            rootEntangledLanes &= ~lane;
        }
    }
    function lanesToEventPriority(lanes) {
        lanes &= -lanes;
        return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
    }
    function onCommitRoot(root) {
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot) try {
            injectedHook.onCommitFiberRoot(rendererID, root, void 0, 128 === (root.current.flags & 128));
        } catch (err) {}
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
        "function" === typeof log && unstable_setDisableYieldValue(newIsStrictMode);
        if (injectedHook && "function" === typeof injectedHook.setStrictMode) try {
            injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {}
    }
    function is(x, y) {
        return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
    }
    function createCapturedValueAtFiber(value, source) {
        if ("object" === typeof value && null !== value) {
            var existing = CapturedStacks.get(value);
            if (void 0 !== existing) return existing;
            source = {
                value: value,
                source: source,
                stack: getStackByFiberInDevAndProd(source)
            };
            CapturedStacks.set(value, source);
            return source;
        }
        return {
            value: value,
            source: source,
            stack: getStackByFiberInDevAndProd(source)
        };
    }
    function pushTreeFork(workInProgress, totalChildren) {
        forkStack[forkStackIndex++] = treeForkCount;
        forkStack[forkStackIndex++] = treeForkProvider;
        treeForkProvider = workInProgress;
        treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress, totalChildren, index) {
        idStack[idStackIndex++] = treeContextId;
        idStack[idStackIndex++] = treeContextOverflow;
        idStack[idStackIndex++] = treeContextProvider;
        treeContextProvider = workInProgress;
        var baseIdWithLeadingBit = treeContextId;
        workInProgress = treeContextOverflow;
        var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
        baseIdWithLeadingBit &= ~(1 << baseLength);
        index += 1;
        var length = 32 - clz32(totalChildren) + baseLength;
        if (30 < length) {
            var numberOfOverflowBits = baseLength - baseLength % 5;
            length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
            baseIdWithLeadingBit >>= numberOfOverflowBits;
            baseLength -= numberOfOverflowBits;
            treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
            treeContextOverflow = length + workInProgress;
        } else treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress;
    }
    function pushMaterializedTreeId(workInProgress) {
        null !== workInProgress.return && (pushTreeFork(workInProgress, 1), pushTreeId(workInProgress, 1, 0));
    }
    function popTreeContext(workInProgress) {
        for(; workInProgress === treeForkProvider;)treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
        for(; workInProgress === treeContextProvider;)treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
    }
    function pushHostContainer(fiber, nextRootInstance) {
        push(rootInstanceStackCursor, nextRootInstance);
        push(contextFiberStackCursor, fiber);
        push(contextStackCursor, null);
        fiber = getRootHostContext(nextRootInstance);
        pop(contextStackCursor);
        push(contextStackCursor, fiber);
    }
    function popHostContainer() {
        pop(contextStackCursor);
        pop(contextFiberStackCursor);
        pop(rootInstanceStackCursor);
    }
    function pushHostContext(fiber) {
        null !== fiber.memoizedState && push(hostTransitionProviderCursor, fiber);
        var context = contextStackCursor.current, nextContext = getChildHostContext(context, fiber.type);
        context !== nextContext && (push(contextFiberStackCursor, fiber), push(contextStackCursor, nextContext));
    }
    function popHostContext(fiber) {
        contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
        hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), isPrimaryRenderer ? HostTransitionContext._currentValue = NotPendingTransition : HostTransitionContext._currentValue2 = NotPendingTransition);
    }
    function throwOnHydrationMismatch(fiber) {
        var error = Error(formatProdErrorMessage(418, ""));
        queueHydrationError(createCapturedValueAtFiber(error, fiber));
        throw HydrationMismatchException;
    }
    function prepareToHydrateHostInstance(fiber, hostContext) {
        if (!supportsHydration) throw Error(formatProdErrorMessage(175));
        hydrateInstance(fiber.stateNode, fiber.type, fiber.memoizedProps, hostContext, fiber) || throwOnHydrationMismatch(fiber);
    }
    function popToNextHostParent(fiber) {
        for(hydrationParentFiber = fiber.return; hydrationParentFiber;)switch(hydrationParentFiber.tag){
            case 3:
            case 27:
                rootOrSingletonContext = !0;
                return;
            case 5:
            case 13:
                rootOrSingletonContext = !1;
                return;
            default:
                hydrationParentFiber = hydrationParentFiber.return;
        }
    }
    function popHydrationState(fiber) {
        if (!supportsHydration || fiber !== hydrationParentFiber) return !1;
        if (!isHydrating) return popToNextHostParent(fiber), isHydrating = !0, !1;
        var shouldClear = !1;
        supportsSingletons ? 3 !== fiber.tag && 27 !== fiber.tag && (5 !== fiber.tag || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps)) && (shouldClear = !0) : 3 !== fiber.tag && (5 !== fiber.tag || shouldDeleteUnhydratedTailInstances(fiber.type) && !shouldSetTextContent(fiber.type, fiber.memoizedProps)) && (shouldClear = !0);
        shouldClear && nextHydratableInstance && throwOnHydrationMismatch(fiber);
        popToNextHostParent(fiber);
        if (13 === fiber.tag) {
            if (!supportsHydration) throw Error(formatProdErrorMessage(316));
            fiber = fiber.memoizedState;
            fiber = null !== fiber ? fiber.dehydrated : null;
            if (!fiber) throw Error(formatProdErrorMessage(317));
            nextHydratableInstance = getNextHydratableInstanceAfterSuspenseInstance(fiber);
        } else nextHydratableInstance = hydrationParentFiber ? getNextHydratableSibling(fiber.stateNode) : null;
        return !0;
    }
    function resetHydrationState() {
        supportsHydration && (nextHydratableInstance = hydrationParentFiber = null, isHydrating = !1);
    }
    function queueHydrationError(error) {
        null === hydrationErrors ? hydrationErrors = [
            error
        ] : hydrationErrors.push(error);
    }
    function finishQueueingConcurrentUpdates() {
        for(var endIndex = concurrentQueuesIndex, i = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i < endIndex;){
            var fiber = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var queue = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var update = concurrentQueues[i];
            concurrentQueues[i++] = null;
            var lane = concurrentQueues[i];
            concurrentQueues[i++] = null;
            if (null !== queue && null !== update) {
                var pending = queue.pending;
                null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
                queue.pending = update;
            }
            0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
        }
    }
    function enqueueUpdate$1(fiber, queue, update, lane) {
        concurrentQueues[concurrentQueuesIndex++] = fiber;
        concurrentQueues[concurrentQueuesIndex++] = queue;
        concurrentQueues[concurrentQueuesIndex++] = update;
        concurrentQueues[concurrentQueuesIndex++] = lane;
        concurrentlyUpdatedLanes |= lane;
        fiber.lanes |= lane;
        fiber = fiber.alternate;
        null !== fiber && (fiber.lanes |= lane);
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
        enqueueUpdate$1(fiber, queue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
        enqueueUpdate$1(fiber, null, null, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
        sourceFiber.lanes |= lane;
        var alternate = sourceFiber.alternate;
        null !== alternate && (alternate.lanes |= lane);
        for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
        isHidden && null !== update && 3 === sourceFiber.tag && (parent = sourceFiber.stateNode, isHidden = 31 - clz32(lane), parent = parent.hiddenUpdates, sourceFiber = parent[isHidden], null === sourceFiber ? parent[isHidden] = [
            update
        ] : sourceFiber.push(update), update.lane = lane | 536870912);
    }
    function getRootForUpdatedFiber(sourceFiber) {
        if (50 < nestedUpdateCount) throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage(185));
        for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
        return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
    }
    function ensureRootIsScheduled(root) {
        root !== lastScheduledRoot && null === root.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root : lastScheduledRoot = lastScheduledRoot.next = root);
        mightHavePendingSyncWork = !0;
        didScheduleMicrotask || (didScheduleMicrotask = !0, scheduleImmediateTask(processRootScheduleInMicrotask));
    }
    function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
        if (!isFlushingWork && mightHavePendingSyncWork) {
            isFlushingWork = !0;
            do {
                var didPerformSomeWork = !1;
                for(var root = firstScheduledRoot; null !== root;){
                    if (!onlyLegacy) {
                        if (0 !== syncTransitionLanes) {
                            var pendingLanes = root.pendingLanes;
                            if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                            else {
                                var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
                                JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                                JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                                JSCompiler_inline_result = JSCompiler_inline_result & 201326677 ? JSCompiler_inline_result & 201326677 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                            }
                            0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, performSyncWorkOnRoot(root, JSCompiler_inline_result));
                        } else JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(root, root === workInProgressRoot ? JSCompiler_inline_result : 0), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root, JSCompiler_inline_result) || (didPerformSomeWork = !0, performSyncWorkOnRoot(root, JSCompiler_inline_result));
                    }
                    root = root.next;
                }
            }while (didPerformSomeWork);
            isFlushingWork = !1;
        }
    }
    function processRootScheduleInMicrotask() {
        mightHavePendingSyncWork = didScheduleMicrotask = !1;
        var syncTransitionLanes = 0;
        0 !== currentEventTransitionLane && (shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane), currentEventTransitionLane = 0);
        for(var currentTime = now(), prev = null, root = firstScheduledRoot; null !== root;){
            var next = root.next, nextLanes = scheduleTaskForRootDuringMicrotask(root, currentTime);
            if (0 === nextLanes) root.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
            else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) mightHavePendingSyncWork = !0;
            root = next;
        }
        flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    }
    function scheduleTaskForRootDuringMicrotask(root, currentTime) {
        for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
            var index$5 = 31 - clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
            if (-1 === expirationTime) {
                if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = computeExpirationTime(lane, currentTime);
            } else expirationTime <= currentTime && (root.expiredLanes |= lane);
            lanes &= ~lane;
        }
        currentTime = workInProgressRoot;
        suspendedLanes = workInProgressRootRenderLanes;
        suspendedLanes = getNextLanes(root, root === currentTime ? suspendedLanes : 0);
        pingedLanes = root.callbackNode;
        if (0 === suspendedLanes || root === currentTime && 2 === workInProgressSuspendedReason || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
        if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root, suspendedLanes)) {
            currentTime = suspendedLanes & -suspendedLanes;
            if (currentTime === root.callbackPriority) return currentTime;
            null !== pingedLanes && cancelCallback$1(pingedLanes);
            switch(lanesToEventPriority(suspendedLanes)){
                case 2:
                case 8:
                    suspendedLanes = UserBlockingPriority;
                    break;
                case 32:
                    suspendedLanes = NormalPriority$1;
                    break;
                case 268435456:
                    suspendedLanes = IdlePriority;
                    break;
                default:
                    suspendedLanes = NormalPriority$1;
            }
            pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root);
            suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
            root.callbackPriority = currentTime;
            root.callbackNode = suspendedLanes;
            return currentTime;
        }
        null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
        root.callbackPriority = 2;
        root.callbackNode = null;
        return 2;
    }
    function performWorkOnRootViaSchedulerTask(root, didTimeout) {
        var originalCallbackNode = root.callbackNode;
        if (flushPassiveEffects() && root.callbackNode !== originalCallbackNode) return null;
        var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
        workInProgressRootRenderLanes$jscomp$0 = getNextLanes(root, root === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0);
        if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
        performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
        scheduleTaskForRootDuringMicrotask(root, now());
        return null != root.callbackNode && root.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root) : null;
    }
    function performSyncWorkOnRoot(root, lanes) {
        if (flushPassiveEffects()) return null;
        performWorkOnRoot(root, lanes, !0);
    }
    function scheduleImmediateTask(cb) {
        supportsMicrotasks ? scheduleMicrotask(function() {
            0 !== (executionContext & 6) ? scheduleCallback$3(ImmediatePriority, cb) : cb();
        }) : scheduleCallback$3(ImmediatePriority, cb);
    }
    function requestTransitionLane() {
        0 === currentEventTransitionLane && (currentEventTransitionLane = claimNextTransitionLane());
        return currentEventTransitionLane;
    }
    function entangleAsyncAction(transition, thenable) {
        if (null === currentEntangledListeners) {
            var entangledListeners = currentEntangledListeners = [];
            currentEntangledPendingCount = 0;
            currentEntangledLane = requestTransitionLane();
            currentEntangledActionThenable = {
                status: "pending",
                value: void 0,
                then: function(resolve) {
                    entangledListeners.push(resolve);
                }
            };
        }
        currentEntangledPendingCount++;
        thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
        return thenable;
    }
    function pingEngtangledActionScope() {
        if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
            null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
            var listeners = currentEntangledListeners;
            currentEntangledListeners = null;
            currentEntangledLane = 0;
            currentEntangledActionThenable = null;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
        }
    }
    function chainThenableValue(thenable, result) {
        var listeners = [], thenableWithOverride = {
            status: "pending",
            value: null,
            reason: null,
            then: function(resolve) {
                listeners.push(resolve);
            }
        };
        thenable.then(function() {
            thenableWithOverride.status = "fulfilled";
            thenableWithOverride.value = result;
            for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
        }, function(error) {
            thenableWithOverride.status = "rejected";
            thenableWithOverride.reason = error;
            for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
        });
        return thenableWithOverride;
    }
    function initializeUpdateQueue(fiber) {
        fiber.updateQueue = {
            baseState: fiber.memoizedState,
            firstBaseUpdate: null,
            lastBaseUpdate: null,
            shared: {
                pending: null,
                lanes: 0,
                hiddenCallbacks: null
            },
            callbacks: null
        };
    }
    function cloneUpdateQueue(current, workInProgress) {
        current = current.updateQueue;
        workInProgress.updateQueue === current && (workInProgress.updateQueue = {
            baseState: current.baseState,
            firstBaseUpdate: current.firstBaseUpdate,
            lastBaseUpdate: current.lastBaseUpdate,
            shared: current.shared,
            callbacks: null
        });
    }
    function createUpdate(lane) {
        return {
            lane: lane,
            tag: 0,
            payload: null,
            callback: null,
            next: null
        };
    }
    function enqueueUpdate(fiber, update, lane) {
        var updateQueue = fiber.updateQueue;
        if (null === updateQueue) return null;
        updateQueue = updateQueue.shared;
        if (0 !== (executionContext & 2)) {
            var pending = updateQueue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            updateQueue.pending = update;
            update = getRootForUpdatedFiber(fiber);
            markUpdateLaneFromFiberToRoot(fiber, null, lane);
            return update;
        }
        enqueueUpdate$1(fiber, updateQueue, update, lane);
        return getRootForUpdatedFiber(fiber);
    }
    function entangleTransitions(root, fiber, lane) {
        fiber = fiber.updateQueue;
        if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194176))) {
            var queueLanes = fiber.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            fiber.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function enqueueCapturedUpdate(workInProgress, capturedUpdate) {
        var queue = workInProgress.updateQueue, current = workInProgress.alternate;
        if (null !== current && (current = current.updateQueue, queue === current)) {
            var newFirst = null, newLast = null;
            queue = queue.firstBaseUpdate;
            if (null !== queue) {
                do {
                    var clone = {
                        lane: queue.lane,
                        tag: queue.tag,
                        payload: queue.payload,
                        callback: null,
                        next: null
                    };
                    null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                    queue = queue.next;
                }while (null !== queue);
                null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
            } else newFirst = newLast = capturedUpdate;
            queue = {
                baseState: current.baseState,
                firstBaseUpdate: newFirst,
                lastBaseUpdate: newLast,
                shared: current.shared,
                callbacks: current.callbacks
            };
            workInProgress.updateQueue = queue;
            return;
        }
        workInProgress = queue.lastBaseUpdate;
        null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
        queue.lastBaseUpdate = capturedUpdate;
    }
    function suspendIfUpdateReadFromEntangledAsyncAction() {
        if (didReadFromEntangledAsyncAction) {
            var entangledActionThenable = currentEntangledActionThenable;
            if (null !== entangledActionThenable) throw entangledActionThenable;
        }
    }
    function processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
        didReadFromEntangledAsyncAction = !1;
        var queue = workInProgress$jscomp$0.updateQueue;
        hasForceUpdate = !1;
        var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
        if (null !== pendingQueue) {
            queue.shared.pending = null;
            var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
            lastPendingUpdate.next = null;
            null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
            lastBaseUpdate = lastPendingUpdate;
            var current = workInProgress$jscomp$0.alternate;
            null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
        }
        if (null !== firstBaseUpdate) {
            var newState = queue.baseState;
            lastBaseUpdate = 0;
            current = firstPendingUpdate = lastPendingUpdate = null;
            pendingQueue = firstBaseUpdate;
            do {
                var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
                if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = !0);
                    null !== current && (current = current.next = {
                        lane: 0,
                        tag: pendingQueue.tag,
                        payload: pendingQueue.payload,
                        callback: null,
                        next: null
                    });
                    a: {
                        var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                        updateLane = props;
                        var instance = instance$jscomp$0;
                        switch(update.tag){
                            case 1:
                                workInProgress = update.payload;
                                if ("function" === typeof workInProgress) {
                                    newState = workInProgress.call(instance, newState, updateLane);
                                    break a;
                                }
                                newState = workInProgress;
                                break a;
                            case 3:
                                workInProgress.flags = workInProgress.flags & -65537 | 128;
                            case 0:
                                workInProgress = update.payload;
                                updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                                if (null === updateLane || void 0 === updateLane) break a;
                                newState = assign({}, newState, updateLane);
                                break a;
                            case 2:
                                hasForceUpdate = !0;
                        }
                    }
                    updateLane = pendingQueue.callback;
                    null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                        updateLane
                    ] : isHiddenUpdate.push(updateLane));
                } else isHiddenUpdate = {
                    lane: updateLane,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: pendingQueue.callback,
                    next: null
                }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
                pendingQueue = pendingQueue.next;
                if (null === pendingQueue) {
                    if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                    else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
                }
            }while (1);
            null === current && (lastPendingUpdate = newState);
            queue.baseState = lastPendingUpdate;
            queue.firstBaseUpdate = firstPendingUpdate;
            queue.lastBaseUpdate = current;
            null === firstBaseUpdate && (queue.shared.lanes = 0);
            workInProgressRootSkippedLanes |= lastBaseUpdate;
            workInProgress$jscomp$0.lanes = lastBaseUpdate;
            workInProgress$jscomp$0.memoizedState = newState;
        }
    }
    function callCallback(callback, context) {
        if ("function" !== typeof callback) throw Error(formatProdErrorMessage(191, callback));
        callback.call(context);
    }
    function commitCallbacks(updateQueue, context) {
        var callbacks = updateQueue.callbacks;
        if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)callCallback(callbacks[updateQueue], context);
    }
    function shallowEqual(objA, objB) {
        if (objectIs(objA, objB)) return !0;
        if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
        var keysA = Object.keys(objA), keysB = Object.keys(objB);
        if (keysA.length !== keysB.length) return !1;
        for(keysB = 0; keysB < keysA.length; keysB++){
            var currentKey = keysA[keysB];
            if (!hasOwnProperty.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey])) return !1;
        }
        return !0;
    }
    function isThenableResolved(thenable) {
        thenable = thenable.status;
        return "fulfilled" === thenable || "rejected" === thenable;
    }
    function noop$1() {}
    function trackUsedThenable(thenableState, thenable, index) {
        index = thenableState[index];
        void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then(noop$1, noop$1), thenable = index);
        switch(thenable.status){
            case "fulfilled":
                return thenable.value;
            case "rejected":
                thenableState = thenable.reason;
                if (thenableState === SuspenseException) throw Error(formatProdErrorMessage(483));
                throw thenableState;
            default:
                if ("string" === typeof thenable.status) thenable.then(noop$1, noop$1);
                else {
                    thenableState = workInProgressRoot;
                    if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error(formatProdErrorMessage(482));
                    thenableState = thenable;
                    thenableState.status = "pending";
                    thenableState.then(function(fulfilledValue) {
                        if ("pending" === thenable.status) {
                            var fulfilledThenable = thenable;
                            fulfilledThenable.status = "fulfilled";
                            fulfilledThenable.value = fulfilledValue;
                        }
                    }, function(error) {
                        if ("pending" === thenable.status) {
                            var rejectedThenable = thenable;
                            rejectedThenable.status = "rejected";
                            rejectedThenable.reason = error;
                        }
                    });
                }
                switch(thenable.status){
                    case "fulfilled":
                        return thenable.value;
                    case "rejected":
                        thenableState = thenable.reason;
                        if (thenableState === SuspenseException) throw Error(formatProdErrorMessage(483));
                        throw thenableState;
                }
                suspendedThenable = thenable;
                throw SuspenseException;
        }
    }
    function getSuspendedThenable() {
        if (null === suspendedThenable) throw Error(formatProdErrorMessage(459));
        var thenable = suspendedThenable;
        suspendedThenable = null;
        return thenable;
    }
    function unwrapThenable(thenable) {
        var index = thenableIndexCounter$1;
        thenableIndexCounter$1 += 1;
        null === thenableState$1 && (thenableState$1 = []);
        return trackUsedThenable(thenableState$1, thenable, index);
    }
    function coerceRef(workInProgress, element) {
        element = element.props.ref;
        workInProgress.ref = void 0 !== element ? element : null;
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
        if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE) throw Error(formatProdErrorMessage(525));
        returnFiber = Object.prototype.toString.call(newChild);
        throw Error(formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
    }
    function resolveLazy(lazyType) {
        var init = lazyType._init;
        return init(lazyType._payload);
    }
    function createChildReconciler(shouldTrackSideEffects) {
        function deleteChild(returnFiber, childToDelete) {
            if (shouldTrackSideEffects) {
                var deletions = returnFiber.deletions;
                null === deletions ? (returnFiber.deletions = [
                    childToDelete
                ], returnFiber.flags |= 16) : deletions.push(childToDelete);
            }
        }
        function deleteRemainingChildren(returnFiber, currentFirstChild) {
            if (!shouldTrackSideEffects) return null;
            for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return null;
        }
        function mapRemainingChildren(currentFirstChild) {
            for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
            return existingChildren;
        }
        function useFiber(fiber, pendingProps) {
            fiber = createWorkInProgress(fiber, pendingProps);
            fiber.index = 0;
            fiber.sibling = null;
            return fiber;
        }
        function placeChild(newFiber, lastPlacedIndex, newIndex) {
            newFiber.index = newIndex;
            if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
            newIndex = newFiber.alternate;
            if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 33554434, lastPlacedIndex) : newIndex;
            newFiber.flags |= 33554434;
            return lastPlacedIndex;
        }
        function placeSingleChild(newFiber) {
            shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 33554434);
            return newFiber;
        }
        function updateTextNode(returnFiber, current, textContent, lanes) {
            if (null === current || 6 !== current.tag) return current = createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
            current = useFiber(current, textContent);
            current.return = returnFiber;
            return current;
        }
        function updateElement(returnFiber, current, element, lanes) {
            var elementType = element.type;
            if (elementType === REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
            if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), coerceRef(current, element), current.return = returnFiber, current;
            current = createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
            coerceRef(current, element);
            current.return = returnFiber;
            return current;
        }
        function updatePortal(returnFiber, current, portal, lanes) {
            if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
            current = useFiber(current, portal.children || []);
            current.return = returnFiber;
            return current;
        }
        function updateFragment(returnFiber, current, fragment, lanes, key) {
            if (null === current || 7 !== current.tag) return current = createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
            current = useFiber(current, fragment);
            current.return = returnFiber;
            return current;
        }
        function createChild(returnFiber, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                    case REACT_PORTAL_TYPE:
                        return newChild = createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                    case REACT_LAZY_TYPE:
                        var init = newChild._init;
                        newChild = init(newChild._payload);
                        return createChild(returnFiber, newChild, lanes);
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return newChild = createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
                if ("function" === typeof newChild.then) return createChild(returnFiber, unwrapThenable(newChild), lanes);
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return createChild(returnFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            return null;
        }
        function updateSlot(returnFiber, oldFiber, newChild, lanes) {
            var key = null !== oldFiber ? oldFiber.key : null;
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                    case REACT_PORTAL_TYPE:
                        return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                    case REACT_LAZY_TYPE:
                        return key = newChild._init, newChild = key(newChild._payload), updateSlot(returnFiber, oldFiber, newChild, lanes);
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
                if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, unwrapThenable(newChild), lanes);
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            return null;
        }
        function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
            if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                    case REACT_PORTAL_TYPE:
                        return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                    case REACT_LAZY_TYPE:
                        var init = newChild._init;
                        newChild = init(newChild._payload);
                        return updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
                }
                if (isArrayImpl(newChild) || getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
                if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, unwrapThenable(newChild), lanes);
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            return null;
        }
        function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
            for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
            if (null == newChildren) throw Error(formatProdErrorMessage(151));
            for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
                oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
                var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
                if (null === newFiber) {
                    null === oldFiber && (oldFiber = nextOldFiber);
                    break;
                }
                shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
                currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
                null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
                previousNewFiber = newFiber;
                oldFiber = nextOldFiber;
            }
            if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
            if (null === oldFiber) {
                for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
                isHydrating && pushTreeFork(returnFiber, newIdx);
                return resultingFirstChild;
            }
            for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            shouldTrackSideEffects && oldFiber.forEach(function(child) {
                return deleteChild(returnFiber, child);
            });
            isHydrating && pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
            "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
            if ("object" === typeof newChild && null !== newChild) {
                switch(newChild.$$typeof){
                    case REACT_ELEMENT_TYPE:
                        a: {
                            for(var key = newChild.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === key) {
                                    key = newChild.type;
                                    if (key === REACT_FRAGMENT_TYPE) {
                                        if (7 === currentFirstChild.tag) {
                                            deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                            lanes = useFiber(currentFirstChild, newChild.props.children);
                                            lanes.return = returnFiber;
                                            returnFiber = lanes;
                                            break a;
                                        }
                                    } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props);
                                        coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                        }
                        return placeSingleChild(returnFiber);
                    case REACT_PORTAL_TYPE:
                        a: {
                            for(key = newChild.key; null !== currentFirstChild;){
                                if (currentFirstChild.key === key) {
                                    if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.children || []);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    } else {
                                        deleteRemainingChildren(returnFiber, currentFirstChild);
                                        break;
                                    }
                                } else deleteChild(returnFiber, currentFirstChild);
                                currentFirstChild = currentFirstChild.sibling;
                            }
                            lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
                            lanes.return = returnFiber;
                            returnFiber = lanes;
                        }
                        return placeSingleChild(returnFiber);
                    case REACT_LAZY_TYPE:
                        return key = newChild._init, newChild = key(newChild._payload), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
                }
                if (isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
                if (getIteratorFn(newChild)) {
                    key = getIteratorFn(newChild);
                    if ("function" !== typeof key) throw Error(formatProdErrorMessage(150));
                    newChild = key.call(newChild);
                    return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
                }
                if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, unwrapThenable(newChild), lanes);
                if (newChild.$$typeof === REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, readContextDuringReconciliation(returnFiber, newChild), lanes);
                throwOnInvalidObjectType(returnFiber, newChild);
            }
            return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
        }
        return function(returnFiber, currentFirstChild, newChild, lanes) {
            try {
                thenableIndexCounter$1 = 0;
                var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
                thenableState$1 = null;
                return firstChildFiber;
            } catch (x) {
                if (x === SuspenseException) throw x;
                var fiber = createFiber(29, x, null, returnFiber.mode);
                fiber.lanes = lanes;
                fiber.return = returnFiber;
                return fiber;
            } finally{}
        };
    }
    function pushHiddenContext(fiber, context) {
        fiber = entangledRenderLanes;
        push(prevEntangledRenderLanesCursor, fiber);
        push(currentTreeHiddenStackCursor, context);
        entangledRenderLanes = fiber | context.baseLanes;
    }
    function reuseHiddenContextOnStack() {
        push(prevEntangledRenderLanesCursor, entangledRenderLanes);
        push(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
    }
    function popHiddenContext() {
        entangledRenderLanes = prevEntangledRenderLanesCursor.current;
        pop(currentTreeHiddenStackCursor);
        pop(prevEntangledRenderLanesCursor);
    }
    function pushPrimaryTreeSuspenseHandler(handler) {
        var current = handler.alternate;
        push(suspenseStackCursor, suspenseStackCursor.current & 1);
        push(suspenseHandlerStackCursor, handler);
        null === shellBoundary && (null === current || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current.memoizedState && (shellBoundary = handler));
    }
    function pushOffscreenSuspenseHandler(fiber) {
        if (22 === fiber.tag) {
            if (push(suspenseStackCursor, suspenseStackCursor.current), push(suspenseHandlerStackCursor, fiber), null === shellBoundary) {
                var current = fiber.alternate;
                null !== current && null !== current.memoizedState && (shellBoundary = fiber);
            }
        } else reuseSuspenseHandlerOnStack(fiber);
    }
    function reuseSuspenseHandlerOnStack() {
        push(suspenseStackCursor, suspenseStackCursor.current);
        push(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
    }
    function popSuspenseHandler(fiber) {
        pop(suspenseHandlerStackCursor);
        shellBoundary === fiber && (shellBoundary = null);
        pop(suspenseStackCursor);
    }
    function findFirstSuspended(row) {
        for(var node = row; null !== node;){
            if (13 === node.tag) {
                var state = node.memoizedState;
                if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state))) return node;
            } else if (19 === node.tag && void 0 !== node.memoizedProps.revealOrder) {
                if (0 !== (node.flags & 128)) return node;
            } else if (null !== node.child) {
                node.child.return = node;
                node = node.child;
                continue;
            }
            if (node === row) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === row) return null;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
        return null;
    }
    function throwInvalidHookError() {
        throw Error(formatProdErrorMessage(321));
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
        if (null === prevDeps) return !1;
        for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!objectIs(nextDeps[i], prevDeps[i])) return !1;
        return !0;
    }
    function renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
        renderLanes = nextRenderLanes;
        currentlyRenderingFiber$1 = workInProgress;
        workInProgress.memoizedState = null;
        workInProgress.updateQueue = null;
        workInProgress.lanes = 0;
        ReactSharedInternals.H = null === current || null === current.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
        shouldDoubleInvokeUserFnsInHooksDEV = !1;
        nextRenderLanes = Component(props, secondArg);
        shouldDoubleInvokeUserFnsInHooksDEV = !1;
        didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(workInProgress, Component, props, secondArg));
        finishRenderingHooks(current);
        return nextRenderLanes;
    }
    function finishRenderingHooks(current) {
        ReactSharedInternals.H = ContextOnlyDispatcher;
        var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
        renderLanes = 0;
        workInProgressHook = currentHook = currentlyRenderingFiber$1 = null;
        didScheduleRenderPhaseUpdate = !1;
        thenableIndexCounter = 0;
        thenableState = null;
        if (didRenderTooFewHooks) throw Error(formatProdErrorMessage(300));
        null === current || didReceiveUpdate || (current = current.dependencies, null !== current && checkIfContextChanged(current) && (didReceiveUpdate = !0));
    }
    function renderWithHooksAgain(workInProgress, Component, props, secondArg) {
        currentlyRenderingFiber$1 = workInProgress;
        var numberOfReRenders = 0;
        do {
            didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
            thenableIndexCounter = 0;
            didScheduleRenderPhaseUpdateDuringThisPass = !1;
            if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage(301));
            numberOfReRenders += 1;
            workInProgressHook = currentHook = null;
            if (null != workInProgress.updateQueue) {
                var children = workInProgress.updateQueue;
                children.lastEffect = null;
                children.events = null;
                children.stores = null;
                null != children.memoCache && (children.memoCache.index = 0);
            }
            ReactSharedInternals.H = HooksDispatcherOnRerender;
            children = Component(props, secondArg);
        }while (didScheduleRenderPhaseUpdateDuringThisPass);
        return children;
    }
    function TransitionAwareHostComponent() {
        var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
        maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
        dispatcher = dispatcher.useState()[0];
        (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber$1.flags |= 1024);
        return maybeThenable;
    }
    function checkDidRenderIdHook() {
        var didRenderIdHook = 0 !== localIdCounter;
        localIdCounter = 0;
        return didRenderIdHook;
    }
    function bailoutHooks(current, workInProgress, lanes) {
        workInProgress.updateQueue = current.updateQueue;
        workInProgress.flags &= -2053;
        current.lanes &= ~lanes;
    }
    function resetHooksOnUnwind(workInProgress) {
        if (didScheduleRenderPhaseUpdate) {
            for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
                var queue = workInProgress.queue;
                null !== queue && (queue.pending = null);
                workInProgress = workInProgress.next;
            }
            didScheduleRenderPhaseUpdate = !1;
        }
        renderLanes = 0;
        workInProgressHook = currentHook = currentlyRenderingFiber$1 = null;
        didScheduleRenderPhaseUpdateDuringThisPass = !1;
        thenableIndexCounter = localIdCounter = 0;
        thenableState = null;
    }
    function mountWorkInProgressHook() {
        var hook = {
            memoizedState: null,
            baseState: null,
            baseQueue: null,
            queue: null,
            next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber$1.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
        return workInProgressHook;
    }
    function updateWorkInProgressHook() {
        if (null === currentHook) {
            var nextCurrentHook = currentlyRenderingFiber$1.alternate;
            nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
        } else nextCurrentHook = currentHook.next;
        var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber$1.memoizedState : workInProgressHook.next;
        if (null !== nextWorkInProgressHook) workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
        else {
            if (null === nextCurrentHook) {
                if (null === currentlyRenderingFiber$1.alternate) throw Error(formatProdErrorMessage(467));
                throw Error(formatProdErrorMessage(310));
            }
            currentHook = nextCurrentHook;
            nextCurrentHook = {
                memoizedState: currentHook.memoizedState,
                baseState: currentHook.baseState,
                baseQueue: currentHook.baseQueue,
                queue: currentHook.queue,
                next: null
            };
            null === workInProgressHook ? currentlyRenderingFiber$1.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
        }
        return workInProgressHook;
    }
    function useThenable(thenable) {
        var index = thenableIndexCounter;
        thenableIndexCounter += 1;
        null === thenableState && (thenableState = []);
        thenable = trackUsedThenable(thenableState, thenable, index);
        index = currentlyRenderingFiber$1;
        null === (null === workInProgressHook ? index.memoizedState : workInProgressHook.next) && (index = index.alternate, ReactSharedInternals.H = null === index || null === index.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
        return thenable;
    }
    function use(usable) {
        if (null !== usable && "object" === typeof usable) {
            if ("function" === typeof usable.then) return useThenable(usable);
            if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
        }
        throw Error(formatProdErrorMessage(438, String(usable)));
    }
    function useMemoCache(size) {
        var memoCache = null, updateQueue = currentlyRenderingFiber$1.updateQueue;
        null !== updateQueue && (memoCache = updateQueue.memoCache);
        if (null == memoCache) {
            var current = currentlyRenderingFiber$1.alternate;
            null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
                data: current.data.map(function(array) {
                    return array.slice();
                }),
                index: 0
            })));
        }
        null == memoCache && (memoCache = {
            data: [],
            index: 0
        });
        null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber$1.updateQueue = updateQueue);
        updateQueue.memoCache = memoCache;
        updateQueue = memoCache.data[memoCache.index];
        if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = REACT_MEMO_CACHE_SENTINEL;
        memoCache.index++;
        return updateQueue;
    }
    function basicStateReducer(state, action) {
        return "function" === typeof action ? action(state) : action;
    }
    function updateReducer(reducer) {
        var hook = updateWorkInProgressHook();
        return updateReducerImpl(hook, currentHook, reducer);
    }
    function updateReducerImpl(hook, current, reducer) {
        var queue = hook.queue;
        if (null === queue) throw Error(formatProdErrorMessage(311));
        queue.lastRenderedReducer = reducer;
        var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
        if (null !== pendingQueue) {
            if (null !== baseQueue) {
                var baseFirst = baseQueue.next;
                baseQueue.next = pendingQueue.next;
                pendingQueue.next = baseFirst;
            }
            current.baseQueue = baseQueue = pendingQueue;
            queue.pending = null;
        }
        pendingQueue = hook.baseState;
        if (null === baseQueue) hook.memoizedState = pendingQueue;
        else {
            current = baseQueue.next;
            var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$48 = !1;
            do {
                var updateLane = update.lane & -536870913;
                if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                    var revertLane = update.revertLane;
                    if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                        lane: 0,
                        revertLane: 0,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$48 = !0);
                    else if ((renderLanes & revertLane) === revertLane) {
                        update = update.next;
                        revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$48 = !0);
                        continue;
                    } else updateLane = {
                        lane: 0,
                        revertLane: update.revertLane,
                        action: update.action,
                        hasEagerState: update.hasEagerState,
                        eagerState: update.eagerState,
                        next: null
                    }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber$1.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
                    updateLane = update.action;
                    shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                    pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
                } else revertLane = {
                    lane: updateLane,
                    revertLane: update.revertLane,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber$1.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
                update = update.next;
            }while (null !== update && update !== current);
            null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
            if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = !0, didReadFromEntangledAsyncAction$48 && (reducer = currentEntangledActionThenable, null !== reducer))) throw reducer;
            hook.memoizedState = pendingQueue;
            hook.baseState = baseFirst;
            hook.baseQueue = newBaseQueueLast;
            queue.lastRenderedState = pendingQueue;
        }
        null === baseQueue && (queue.lanes = 0);
        return [
            hook.memoizedState,
            queue.dispatch
        ];
    }
    function rerenderReducer(reducer) {
        var hook = updateWorkInProgressHook(), queue = hook.queue;
        if (null === queue) throw Error(formatProdErrorMessage(311));
        queue.lastRenderedReducer = reducer;
        var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
        if (null !== lastRenderPhaseUpdate) {
            queue.pending = null;
            var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
            do newState = reducer(newState, update.action), update = update.next;
            while (update !== lastRenderPhaseUpdate);
            objectIs(newState, hook.memoizedState) || (didReceiveUpdate = !0);
            hook.memoizedState = newState;
            null === hook.baseQueue && (hook.baseState = newState);
            queue.lastRenderedState = newState;
        }
        return [
            newState,
            dispatch
        ];
    }
    function updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = currentlyRenderingFiber$1, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
        if (isHydrating$jscomp$0) {
            if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else getServerSnapshot = getSnapshot();
        var snapshotChanged = !objectIs((currentHook || hook).memoizedState, getServerSnapshot);
        snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = !0);
        hook = hook.queue;
        updateEffect(subscribeToStore.bind(null, fiber, hook, subscribe), [
            subscribe
        ]);
        if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
            fiber.flags |= 2048;
            pushEffect(9, updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), {
                destroy: void 0
            }, null);
            if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
            isHydrating$jscomp$0 || 0 !== (renderLanes & 60) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        return getServerSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
        fiber.flags |= 16384;
        fiber = {
            getSnapshot: getSnapshot,
            value: renderedSnapshot
        };
        getSnapshot = currentlyRenderingFiber$1.updateQueue;
        null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber$1.updateQueue = getSnapshot, getSnapshot.stores = [
            fiber
        ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
            fiber
        ] : renderedSnapshot.push(fiber));
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
        inst.value = nextSnapshot;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe) {
        return subscribe(function() {
            checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
        });
    }
    function checkIfSnapshotChanged(inst) {
        var latestGetSnapshot = inst.getSnapshot;
        inst = inst.value;
        try {
            var nextValue = latestGetSnapshot();
            return !objectIs(inst, nextValue);
        } catch (error) {
            return !0;
        }
    }
    function forceStoreRerender(fiber) {
        var root = enqueueConcurrentRenderForLane(fiber, 2);
        null !== root && scheduleUpdateOnFiber(root, fiber, 2);
    }
    function mountStateImpl(initialState) {
        var hook = mountWorkInProgressHook();
        if ("function" === typeof initialState) {
            var initialStateInitializer = initialState;
            initialState = initialStateInitializer();
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    initialStateInitializer();
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
        }
        hook.memoizedState = hook.baseState = initialState;
        hook.queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: basicStateReducer,
            lastRenderedState: initialState
        };
        return hook;
    }
    function updateOptimisticImpl(hook, current, passthrough, reducer) {
        hook.baseState = passthrough;
        return updateReducerImpl(hook, currentHook, "function" === typeof reducer ? reducer : basicStateReducer);
    }
    function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
        if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage(485));
        fiber = actionQueue.action;
        if (null !== fiber) {
            var actionNode = {
                payload: payload,
                action: fiber,
                next: null,
                isTransition: !0,
                status: "pending",
                value: null,
                reason: null,
                listeners: [],
                then: function(listener) {
                    actionNode.listeners.push(listener);
                }
            };
            null !== ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
            setState(actionNode);
            setPendingState = actionQueue.pending;
            null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
        }
    }
    function runActionStateAction(actionQueue, node) {
        var action = node.action, payload = node.payload, prevState = actionQueue.state;
        if (node.isTransition) {
            var prevTransition = ReactSharedInternals.T, currentTransition = {};
            ReactSharedInternals.T = currentTransition;
            try {
                var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
                null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
                handleActionReturnValue(actionQueue, node, returnValue);
            } catch (error) {
                onActionError(actionQueue, node, error);
            } finally{
                ReactSharedInternals.T = prevTransition;
            }
        } else try {
            prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
        } catch (error$52) {
            onActionError(actionQueue, node, error$52);
        }
    }
    function handleActionReturnValue(actionQueue, node, returnValue) {
        null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
            onActionSuccess(actionQueue, node, nextState);
        }, function(error) {
            return onActionError(actionQueue, node, error);
        }) : onActionSuccess(actionQueue, node, returnValue);
    }
    function onActionSuccess(actionQueue, actionNode, nextState) {
        actionNode.status = "fulfilled";
        actionNode.value = nextState;
        notifyActionListeners(actionNode);
        actionQueue.state = nextState;
        actionNode = actionQueue.pending;
        null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
    }
    function onActionError(actionQueue, actionNode, error) {
        var last = actionQueue.pending;
        actionQueue.pending = null;
        if (null !== last) {
            last = last.next;
            do actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
            while (actionNode !== last);
        }
        actionQueue.action = null;
    }
    function notifyActionListeners(actionNode) {
        actionNode = actionNode.listeners;
        for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
    }
    function actionStateReducer(oldState, newState) {
        return newState;
    }
    function mountActionState(action, initialStateProp) {
        if (isHydrating) {
            var ssrFormState = workInProgressRoot.formState;
            if (null !== ssrFormState) {
                a: {
                    var JSCompiler_inline_result = currentlyRenderingFiber$1;
                    if (isHydrating) {
                        if (nextHydratableInstance) {
                            var markerInstance = canHydrateFormStateMarker(nextHydratableInstance, rootOrSingletonContext);
                            if (markerInstance) {
                                nextHydratableInstance = getNextHydratableSibling(markerInstance);
                                JSCompiler_inline_result = isFormStateMarkerMatching(markerInstance);
                                break a;
                            }
                        }
                        throwOnHydrationMismatch(JSCompiler_inline_result);
                    }
                    JSCompiler_inline_result = !1;
                }
                JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
            }
        }
        ssrFormState = mountWorkInProgressHook();
        ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
        JSCompiler_inline_result = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: actionStateReducer,
            lastRenderedState: initialStateProp
        };
        ssrFormState.queue = JSCompiler_inline_result;
        ssrFormState = dispatchSetState.bind(null, currentlyRenderingFiber$1, JSCompiler_inline_result);
        JSCompiler_inline_result.dispatch = ssrFormState;
        JSCompiler_inline_result = mountStateImpl(!1);
        var setPendingState = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber$1, !1, JSCompiler_inline_result.queue);
        JSCompiler_inline_result = mountWorkInProgressHook();
        markerInstance = {
            state: initialStateProp,
            dispatch: null,
            action: action,
            pending: null
        };
        JSCompiler_inline_result.queue = markerInstance;
        ssrFormState = dispatchActionState.bind(null, currentlyRenderingFiber$1, markerInstance, setPendingState, ssrFormState);
        markerInstance.dispatch = ssrFormState;
        JSCompiler_inline_result.memoizedState = action;
        return [
            initialStateProp,
            ssrFormState,
            !1
        ];
    }
    function updateActionState(action) {
        var stateHook = updateWorkInProgressHook();
        return updateActionStateImpl(stateHook, currentHook, action);
    }
    function updateActionStateImpl(stateHook, currentStateHook, action) {
        currentStateHook = updateReducerImpl(stateHook, currentStateHook, actionStateReducer)[0];
        stateHook = updateReducer(basicStateReducer)[0];
        currentStateHook = "object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then ? useThenable(currentStateHook) : currentStateHook;
        var actionQueueHook = updateWorkInProgressHook(), actionQueue = actionQueueHook.queue, dispatch = actionQueue.dispatch;
        action !== actionQueueHook.memoizedState && (currentlyRenderingFiber$1.flags |= 2048, pushEffect(9, actionStateActionEffect.bind(null, actionQueue, action), {
            destroy: void 0
        }, null));
        return [
            currentStateHook,
            dispatch,
            stateHook
        ];
    }
    function actionStateActionEffect(actionQueue, action) {
        actionQueue.action = action;
    }
    function rerenderActionState(action) {
        var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
        if (null !== currentStateHook) return updateActionStateImpl(stateHook, currentStateHook, action);
        updateWorkInProgressHook();
        stateHook = stateHook.memoizedState;
        currentStateHook = updateWorkInProgressHook();
        var dispatch = currentStateHook.queue.dispatch;
        currentStateHook.memoizedState = action;
        return [
            stateHook,
            dispatch,
            !1
        ];
    }
    function pushEffect(tag, create, inst, deps) {
        tag = {
            tag: tag,
            create: create,
            inst: inst,
            deps: deps,
            next: null
        };
        create = currentlyRenderingFiber$1.updateQueue;
        null === create && (create = createFunctionComponentUpdateQueue(), currentlyRenderingFiber$1.updateQueue = create);
        inst = create.lastEffect;
        null === inst ? create.lastEffect = tag.next = tag : (deps = inst.next, inst.next = tag, tag.next = deps, create.lastEffect = tag);
        return tag;
    }
    function updateRef() {
        return updateWorkInProgressHook().memoizedState;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = mountWorkInProgressHook();
        currentlyRenderingFiber$1.flags |= fiberFlags;
        hook.memoizedState = pushEffect(1 | hookFlags, create, {
            destroy: void 0
        }, void 0 === deps ? null : deps);
    }
    function updateEffectImpl(fiberFlags, hookFlags, create, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var inst = hook.memoizedState.inst;
        null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushEffect(hookFlags, create, inst, deps) : (currentlyRenderingFiber$1.flags |= fiberFlags, hook.memoizedState = pushEffect(1 | hookFlags, create, inst, deps));
    }
    function mountEffect(create, deps) {
        mountEffectImpl(8390656, 8, create, deps);
    }
    function updateEffect(create, deps) {
        updateEffectImpl(2048, 8, create, deps);
    }
    function updateInsertionEffect(create, deps) {
        return updateEffectImpl(4, 2, create, deps);
    }
    function updateLayoutEffect(create, deps) {
        return updateEffectImpl(4, 4, create, deps);
    }
    function imperativeHandleEffect(create, ref) {
        if ("function" === typeof ref) {
            create = create();
            var refCleanup = ref(create);
            return function() {
                "function" === typeof refCleanup ? refCleanup() : ref(null);
            };
        }
        if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
            ref.current = null;
        };
    }
    function updateImperativeHandle(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create, ref), deps);
    }
    function mountDebugValue() {}
    function updateCallback(callback, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        hook.memoizedState = [
            callback,
            deps
        ];
        return callback;
    }
    function updateMemo(nextCreate, deps) {
        var hook = updateWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var prevState = hook.memoizedState;
        if (null !== deps && areHookInputsEqual(deps, prevState[1])) return prevState[0];
        prevState = nextCreate();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
            setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            prevState,
            deps
        ];
        return prevState;
    }
    function mountDeferredValueImpl(hook, value, initialValue) {
        if (void 0 === initialValue || 0 !== (renderLanes & 1073741824)) return hook.memoizedState = value;
        hook.memoizedState = initialValue;
        hook = requestDeferredLane();
        currentlyRenderingFiber$1.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return initialValue;
    }
    function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
        if (objectIs(value, prevValue)) return value;
        if (null !== currentTreeHiddenStackCursor.current) return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = !0), hook;
        if (0 === (renderLanes & 42)) return didReceiveUpdate = !0, hook.memoizedState = value;
        hook = requestDeferredLane();
        currentlyRenderingFiber$1.lanes |= hook;
        workInProgressRootSkippedLanes |= hook;
        return prevValue;
    }
    function startTransition(fiber, queue, pendingState, finishedState, callback) {
        var previousPriority = getCurrentUpdatePriority();
        setCurrentUpdatePriority(0 !== previousPriority && 8 > previousPriority ? previousPriority : 8);
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        ReactSharedInternals.T = currentTransition;
        dispatchOptimisticSetState(fiber, !1, queue, pendingState);
        try {
            var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
                var thenableForFinishedState = chainThenableValue(returnValue, finishedState);
                dispatchSetStateInternal(fiber, queue, thenableForFinishedState, requestUpdateLane(fiber));
            } else dispatchSetStateInternal(fiber, queue, finishedState, requestUpdateLane(fiber));
        } catch (error) {
            dispatchSetStateInternal(fiber, queue, {
                then: function() {},
                status: "rejected",
                reason: error
            }, requestUpdateLane());
        } finally{
            setCurrentUpdatePriority(previousPriority), ReactSharedInternals.T = prevTransition;
        }
    }
    function ensureFormComponentIsStateful(formFiber) {
        var existingStateHook = formFiber.memoizedState;
        if (null !== existingStateHook) return existingStateHook;
        existingStateHook = {
            memoizedState: NotPendingTransition,
            baseState: NotPendingTransition,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: NotPendingTransition
            },
            next: null
        };
        var initialResetState = {};
        existingStateHook.next = {
            memoizedState: initialResetState,
            baseState: initialResetState,
            baseQueue: null,
            queue: {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: basicStateReducer,
                lastRenderedState: initialResetState
            },
            next: null
        };
        formFiber.memoizedState = existingStateHook;
        formFiber = formFiber.alternate;
        null !== formFiber && (formFiber.memoizedState = existingStateHook);
        return existingStateHook;
    }
    function useHostTransitionStatus() {
        return readContext(HostTransitionContext);
    }
    function updateId() {
        return updateWorkInProgressHook().memoizedState;
    }
    function updateRefresh() {
        return updateWorkInProgressHook().memoizedState;
    }
    function refreshCache(fiber) {
        for(var provider = fiber.return; null !== provider;){
            switch(provider.tag){
                case 24:
                case 3:
                    var lane = requestUpdateLane();
                    fiber = createUpdate(lane);
                    var root = enqueueUpdate(provider, fiber, lane);
                    null !== root && (scheduleUpdateOnFiber(root, provider, lane), entangleTransitions(root, provider, lane));
                    provider = {
                        cache: createCache()
                    };
                    fiber.payload = provider;
                    return;
            }
            provider = provider.return;
        }
    }
    function dispatchReducerAction(fiber, queue, action) {
        var lane = requestUpdateLane();
        action = {
            lane: lane,
            revertLane: 0,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
    }
    function dispatchSetState(fiber, queue, action) {
        var lane = requestUpdateLane();
        dispatchSetStateInternal(fiber, queue, action, lane);
    }
    function dispatchSetStateInternal(fiber, queue, action, lane) {
        var update = {
            lane: lane,
            revertLane: 0,
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
        else {
            var alternate = fiber.alternate;
            if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
                var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
                update.hasEagerState = !0;
                update.eagerState = eagerState;
                if (objectIs(eagerState, currentState)) return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), !1;
            } catch (error) {} finally{}
            action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
            if (null !== action) return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), !0;
        }
        return !1;
    }
    function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
        action = {
            lane: 2,
            revertLane: requestTransitionLane(),
            action: action,
            hasEagerState: !1,
            eagerState: null,
            next: null
        };
        if (isRenderPhaseUpdate(fiber)) {
            if (throwIfDuringRender) throw Error(formatProdErrorMessage(479));
        } else throwIfDuringRender = enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
    }
    function isRenderPhaseUpdate(fiber) {
        var alternate = fiber.alternate;
        return fiber === currentlyRenderingFiber$1 || null !== alternate && alternate === currentlyRenderingFiber$1;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
        didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = !0;
        var pending = queue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        queue.pending = update;
    }
    function entangleTransitionUpdate(root, queue, lane) {
        if (0 !== (lane & 4194176)) {
            var queueLanes = queue.lanes;
            queueLanes &= root.pendingLanes;
            lane |= queueLanes;
            queue.lanes = lane;
            markRootEntangled(root, lane);
        }
    }
    function applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
        ctor = workInProgress.memoizedState;
        getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
        getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : assign({}, ctor, getDerivedStateFromProps);
        workInProgress.memoizedState = getDerivedStateFromProps;
        0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
    }
    function checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
        workInProgress = workInProgress.stateNode;
        return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : !0;
    }
    function callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
        workInProgress = instance.state;
        "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
        "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
        instance.state !== workInProgress && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
    }
    function resolveClassComponentProps(Component, baseProps) {
        var newProps = baseProps;
        if ("ref" in baseProps) {
            newProps = {};
            for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
        }
        if (Component = Component.defaultProps) {
            newProps === baseProps && (newProps = assign({}, newProps));
            for(var propName$54 in Component)void 0 === newProps[propName$54] && (newProps[propName$54] = Component[propName$54]);
        }
        return newProps;
    }
    function logUncaughtError(root, errorInfo) {
        try {
            var onUncaughtError = root.onUncaughtError;
            onUncaughtError(errorInfo.value, {
                componentStack: errorInfo.stack
            });
        } catch (e) {
            setTimeout(function() {
                throw e;
            });
        }
    }
    function logCaughtError(root, boundary, errorInfo) {
        try {
            var onCaughtError = root.onCaughtError;
            onCaughtError(errorInfo.value, {
                componentStack: errorInfo.stack,
                errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
            });
        } catch (e) {
            setTimeout(function() {
                throw e;
            });
        }
    }
    function createRootErrorUpdate(root, errorInfo, lane) {
        lane = createUpdate(lane);
        lane.tag = 3;
        lane.payload = {
            element: null
        };
        lane.callback = function() {
            logUncaughtError(root, errorInfo);
        };
        return lane;
    }
    function createClassErrorUpdate(lane) {
        lane = createUpdate(lane);
        lane.tag = 3;
        return lane;
    }
    function initializeClassErrorUpdate(update, root, fiber, errorInfo) {
        var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
        if ("function" === typeof getDerivedStateFromError) {
            var error = errorInfo.value;
            update.payload = function() {
                return getDerivedStateFromError(error);
            };
            update.callback = function() {
                logCaughtError(root, fiber, errorInfo);
            };
        }
        var inst = fiber.stateNode;
        null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
            logCaughtError(root, fiber, errorInfo);
            "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = new Set([
                this
            ]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
            var stack = errorInfo.stack;
            this.componentDidCatch(errorInfo.value, {
                componentStack: null !== stack ? stack : ""
            });
        });
    }
    function throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
        sourceFiber.flags |= 32768;
        if (null !== value && "object" === typeof value && "function" === typeof value.then) {
            returnFiber = sourceFiber.alternate;
            null !== returnFiber && propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
            sourceFiber = suspenseHandlerStackCursor.current;
            if (null !== sourceFiber) {
                switch(sourceFiber.tag){
                    case 13:
                        return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                            value
                        ]) : returnFiber.add(value), attachPingListener(root, value, rootRenderLanes)), !1;
                    case 22:
                        return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                            transitions: null,
                            markerInstances: null,
                            retryQueue: new Set([
                                value
                            ])
                        }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                            value
                        ]) : sourceFiber.add(value)), attachPingListener(root, value, rootRenderLanes)), !1;
                }
                throw Error(formatProdErrorMessage(435, sourceFiber.tag));
            }
            attachPingListener(root, value, rootRenderLanes);
            renderDidSuspendDelayIfPossible();
            return !1;
        }
        if (isHydrating) return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root = Error(formatProdErrorMessage(422), {
            cause: value
        }), queueHydrationError(createCapturedValueAtFiber(root, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage(423), {
            cause: value
        }), queueHydrationError(createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(root.stateNode, value, rootRenderLanes), enqueueCapturedUpdate(root, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), !1;
        var wrapperError = Error(formatProdErrorMessage(520), {
            cause: value
        });
        wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
        null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [
            wrapperError
        ] : workInProgressRootConcurrentErrors.push(wrapperError);
        4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
        if (null === returnFiber) return !0;
        value = createCapturedValueAtFiber(value, sourceFiber);
        sourceFiber = returnFiber;
        do {
            switch(sourceFiber.tag){
                case 3:
                    return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = createRootErrorUpdate(sourceFiber.stateNode, value, root), enqueueCapturedUpdate(sourceFiber, root), !1;
                case 1:
                    if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
            }
            sourceFiber = sourceFiber.return;
        }while (null !== sourceFiber);
        return !1;
    }
    function reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
        workInProgress.child = null === current ? mountChildFibers(workInProgress, null, nextChildren, renderLanes) : reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
    }
    function updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
        Component = Component.render;
        var ref = workInProgress.ref;
        if ("ref" in nextProps) {
            var propsWithoutRef = {};
            for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
        } else propsWithoutRef = nextProps;
        prepareToReadContext(workInProgress);
        nextProps = renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
        key = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && key && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null === current) {
            var type = Component.type;
            if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
            current = createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
            current.ref = workInProgress.ref;
            current.return = workInProgress;
            return workInProgress.child = current;
        }
        type = current.child;
        if (!checkScheduledUpdateOrContext(current, renderLanes)) {
            var prevProps = type.memoizedProps;
            Component = Component.compare;
            Component = null !== Component ? Component : shallowEqual;
            if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
        workInProgress.flags |= 1;
        current = createWorkInProgress(type, nextProps);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    function updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
        if (null !== current) {
            var prevProps = current.memoizedProps;
            if (shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
                if (didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && (didReceiveUpdate = !0);
                else return workInProgress.lanes = current.lanes, bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
            }
        }
        return updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
    }
    function updateOffscreenComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, nextChildren = nextProps.children, nextIsDetached = 0 !== (workInProgress.stateNode._pendingVisibility & 2), prevState = null !== current ? current.memoizedState : null;
        markRef(current, workInProgress);
        if ("hidden" === nextProps.mode || nextIsDetached) {
            if (0 !== (workInProgress.flags & 128)) {
                nextProps = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
                if (null !== current) {
                    nextChildren = workInProgress.child = current.child;
                    for(nextIsDetached = 0; null !== nextChildren;)nextIsDetached = nextIsDetached | nextChildren.lanes | nextChildren.childLanes, nextChildren = nextChildren.sibling;
                    workInProgress.childLanes = nextIsDetached & ~nextProps;
                } else workInProgress.childLanes = 0, workInProgress.child = null;
                return deferHiddenOffscreenComponent(current, workInProgress, nextProps, renderLanes);
            }
            if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, null !== current && pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? pushHiddenContext(workInProgress, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress);
            else return workInProgress.lanes = workInProgress.childLanes = 536870912, deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes);
        } else null !== prevState ? (pushTransition(workInProgress, prevState.cachePool), pushHiddenContext(workInProgress, prevState), reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && pushTransition(workInProgress, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack(workInProgress));
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes) {
        var JSCompiler_inline_result = peekCacheFromPool();
        JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
            parent: isPrimaryRenderer ? CacheContext._currentValue : CacheContext._currentValue2,
            pool: JSCompiler_inline_result
        };
        workInProgress.memoizedState = {
            baseLanes: nextBaseLanes,
            cachePool: JSCompiler_inline_result
        };
        null !== current && pushTransition(workInProgress, null);
        reuseHiddenContextOnStack();
        pushOffscreenSuspenseHandler(workInProgress);
        null !== current && propagateParentContextChanges(current, workInProgress, renderLanes, !0);
        return null;
    }
    function markRef(current, workInProgress) {
        var ref = workInProgress.ref;
        if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 2097664);
        else {
            if ("function" !== typeof ref && "object" !== typeof ref) throw Error(formatProdErrorMessage(284));
            if (null === current || current.ref !== ref) workInProgress.flags |= 2097664;
        }
    }
    function updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
        prepareToReadContext(workInProgress);
        Component = renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
        nextProps = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && nextProps && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, Component, renderLanes);
        return workInProgress.child;
    }
    function replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
        prepareToReadContext(workInProgress);
        workInProgress.updateQueue = null;
        nextProps = renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
        finishRenderingHooks(current);
        Component = checkDidRenderIdHook();
        if (null !== current && !didReceiveUpdate) return bailoutHooks(current, workInProgress, renderLanes), bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        isHydrating && Component && pushMaterializedTreeId(workInProgress);
        workInProgress.flags |= 1;
        reconcileChildren(current, workInProgress, nextProps, renderLanes);
        return workInProgress.child;
    }
    function updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
        prepareToReadContext(workInProgress);
        if (null === workInProgress.stateNode) {
            var context = emptyContextObject, contextType = Component.contextType;
            "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
            context = new Component(nextProps, context);
            workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
            context.updater = classComponentUpdater;
            workInProgress.stateNode = context;
            context._reactInternals = workInProgress;
            context = workInProgress.stateNode;
            context.props = nextProps;
            context.state = workInProgress.memoizedState;
            context.refs = {};
            initializeUpdateQueue(workInProgress);
            contextType = Component.contextType;
            context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
            context.state = workInProgress.memoizedState;
            contextType = Component.getDerivedStateFromProps;
            "function" === typeof contextType && (applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
            "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress, nextProps, context, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
            "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
            nextProps = !0;
        } else if (null === current) {
            context = workInProgress.stateNode;
            var unresolvedOldProps = workInProgress.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
            context.props = oldProps;
            var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
            contextType = emptyContextObject;
            "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
            var getDerivedStateFromProps = Component.getDerivedStateFromProps;
            contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
            unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
            contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
            hasForceUpdate = !1;
            var oldState = workInProgress.memoizedState;
            context.state = oldState;
            processUpdateQueue(workInProgress, nextProps, context, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            oldContext = workInProgress.memoizedState;
            unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
        } else {
            context = workInProgress.stateNode;
            cloneUpdateQueue(current, workInProgress);
            contextType = workInProgress.memoizedProps;
            contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
            context.props = contextType$jscomp$0;
            getDerivedStateFromProps = workInProgress.pendingProps;
            oldState = context.context;
            oldContext = Component.contextType;
            oldProps = emptyContextObject;
            "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
            unresolvedOldProps = Component.getDerivedStateFromProps;
            (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
            hasForceUpdate = !1;
            oldState = workInProgress.memoizedState;
            context.state = oldState;
            processUpdateQueue(workInProgress, nextProps, context, renderLanes);
            suspendIfUpdateReadFromEntangledAsyncAction();
            var newState = workInProgress.memoizedState;
            contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
        }
        context = nextProps;
        markRef(current, workInProgress);
        nextProps = 0 !== (workInProgress.flags & 128);
        context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = reconcileChildFibers(workInProgress, null, Component, renderLanes)) : reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        return current;
    }
    function mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
        resetHydrationState();
        workInProgress.flags |= 256;
        reconcileChildren(current, workInProgress, nextChildren, renderLanes);
        return workInProgress.child;
    }
    function mountSuspenseOffscreenState(renderLanes) {
        return {
            baseLanes: renderLanes,
            cachePool: getSuspendedCache()
        };
    }
    function getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
        current = null !== current ? current.childLanes & ~renderLanes : 0;
        primaryTreeDidDefer && (current |= workInProgressDeferredLane);
        return current;
    }
    function updateSuspenseComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
        (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== (suspenseStackCursor.current & 2));
        JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
        JSCompiler_temp = 0 !== (workInProgress.flags & 32);
        workInProgress.flags &= -33;
        if (null === current) {
            if (isHydrating) {
                showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress) : reuseSuspenseHandlerOnStack(workInProgress);
                if (isHydrating) {
                    var nextInstance = nextHydratableInstance, JSCompiler_temp$jscomp$0;
                    if (JSCompiler_temp$jscomp$0 = nextInstance) nextInstance = canHydrateSuspenseInstance(nextInstance, rootOrSingletonContext), null !== nextInstance ? (workInProgress.memoizedState = {
                        dehydrated: nextInstance,
                        treeContext: null !== treeContextProvider ? {
                            id: treeContextId,
                            overflow: treeContextOverflow
                        } : null,
                        retryLane: 536870912
                    }, JSCompiler_temp$jscomp$0 = createFiber(18, null, null, 0), JSCompiler_temp$jscomp$0.stateNode = nextInstance, JSCompiler_temp$jscomp$0.return = workInProgress, workInProgress.child = JSCompiler_temp$jscomp$0, hydrationParentFiber = workInProgress, nextHydratableInstance = null, JSCompiler_temp$jscomp$0 = !0) : JSCompiler_temp$jscomp$0 = !1;
                    JSCompiler_temp$jscomp$0 || throwOnHydrationMismatch(workInProgress);
                }
                nextInstance = workInProgress.memoizedState;
                if (null !== nextInstance && (nextInstance = nextInstance.dehydrated, null !== nextInstance)) return isSuspenseInstanceFallback(nextInstance) ? workInProgress.lanes = 16 : workInProgress.lanes = 536870912, null;
                popSuspenseHandler(workInProgress);
            }
            nextInstance = nextProps.children;
            nextProps = nextProps.fallback;
            if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextInstance = mountWorkInProgressOffscreenFiber({
                mode: "hidden",
                children: nextInstance
            }, showFallback), nextProps = createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextInstance.return = workInProgress, nextProps.return = workInProgress, nextInstance.sibling = nextProps, workInProgress.child = nextInstance, showFallback = workInProgress.child, showFallback.memoizedState = mountSuspenseOffscreenState(renderLanes), showFallback.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, nextProps;
            pushPrimaryTreeSuspenseHandler(workInProgress);
            return mountSuspensePrimaryChildren(workInProgress, nextInstance);
        }
        JSCompiler_temp$jscomp$0 = current.memoizedState;
        if (null !== JSCompiler_temp$jscomp$0 && (nextInstance = JSCompiler_temp$jscomp$0.dehydrated, null !== nextInstance)) {
            if (didSuspend) workInProgress.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : (reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, nextProps = mountWorkInProgressOffscreenFiber({
                mode: "visible",
                children: nextProps.children
            }, nextInstance), showFallback = createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2, nextProps.return = workInProgress, showFallback.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, workInProgress = showFallback);
            else if (pushPrimaryTreeSuspenseHandler(workInProgress), isSuspenseInstanceFallback(nextInstance)) JSCompiler_temp = getSuspenseInstanceFallbackErrorDetails(nextInstance).digest, nextProps = Error(formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = JSCompiler_temp, queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            }), workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (didReceiveUpdate || propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), didReceiveUpdate || JSCompiler_temp) {
                JSCompiler_temp = workInProgressRoot;
                if (null !== JSCompiler_temp) {
                    nextProps = renderLanes & -renderLanes;
                    if (0 !== (nextProps & 42)) nextProps = 1;
                    else switch(nextProps){
                        case 2:
                            nextProps = 1;
                            break;
                        case 8:
                            nextProps = 4;
                            break;
                        case 32:
                            nextProps = 16;
                            break;
                        case 128:
                        case 256:
                        case 512:
                        case 1024:
                        case 2048:
                        case 4096:
                        case 8192:
                        case 16384:
                        case 32768:
                        case 65536:
                        case 131072:
                        case 262144:
                        case 524288:
                        case 1048576:
                        case 2097152:
                        case 4194304:
                        case 8388608:
                        case 16777216:
                        case 33554432:
                            nextProps = 64;
                            break;
                        case 268435456:
                            nextProps = 134217728;
                            break;
                        default:
                            nextProps = 0;
                    }
                    nextProps = 0 !== (nextProps & (JSCompiler_temp.suspendedLanes | renderLanes)) ? 0 : nextProps;
                    if (0 !== nextProps && nextProps !== JSCompiler_temp$jscomp$0.retryLane) throw JSCompiler_temp$jscomp$0.retryLane = nextProps, enqueueConcurrentRenderForLane(current, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), SelectiveHydrationException;
                }
                isSuspenseInstancePending(nextInstance) || renderDidSuspendDelayIfPossible();
                workInProgress = retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
            } else isSuspenseInstancePending(nextInstance) ? (workInProgress.flags |= 128, workInProgress.child = current.child, workInProgress = retryDehydratedSuspenseBoundary.bind(null, current), registerSuspenseInstanceRetry(nextInstance, workInProgress), workInProgress = null) : (current = JSCompiler_temp$jscomp$0.treeContext, supportsHydration && (nextHydratableInstance = getFirstHydratableChildWithinSuspenseInstance(nextInstance), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !1, null !== current && (idStack[idStackIndex++] = treeContextId, idStack[idStackIndex++] = treeContextOverflow, idStack[idStackIndex++] = treeContextProvider, treeContextId = current.id, treeContextOverflow = current.overflow, treeContextProvider = workInProgress)), workInProgress = mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
            return workInProgress;
        }
        if (showFallback) return reuseSuspenseHandlerOnStack(workInProgress), showFallback = nextProps.fallback, nextInstance = workInProgress.mode, JSCompiler_temp$jscomp$0 = current.child, didSuspend = JSCompiler_temp$jscomp$0.sibling, nextProps = createWorkInProgress(JSCompiler_temp$jscomp$0, {
            mode: "hidden",
            children: nextProps.children
        }), nextProps.subtreeFlags = JSCompiler_temp$jscomp$0.subtreeFlags & 31457280, null !== didSuspend ? showFallback = createWorkInProgress(didSuspend, showFallback) : (showFallback = createFiberFromFragment(showFallback, nextInstance, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, nextProps = showFallback, showFallback = workInProgress.child, nextInstance = current.child.memoizedState, null === nextInstance ? nextInstance = mountSuspenseOffscreenState(renderLanes) : (JSCompiler_temp$jscomp$0 = nextInstance.cachePool, null !== JSCompiler_temp$jscomp$0 ? (didSuspend = isPrimaryRenderer ? CacheContext._currentValue : CacheContext._currentValue2, JSCompiler_temp$jscomp$0 = JSCompiler_temp$jscomp$0.parent !== didSuspend ? {
            parent: didSuspend,
            pool: didSuspend
        } : JSCompiler_temp$jscomp$0) : JSCompiler_temp$jscomp$0 = getSuspendedCache(), nextInstance = {
            baseLanes: nextInstance.baseLanes | renderLanes,
            cachePool: JSCompiler_temp$jscomp$0
        }), showFallback.memoizedState = nextInstance, showFallback.childLanes = getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = SUSPENDED_MARKER, nextProps;
        pushPrimaryTreeSuspenseHandler(workInProgress);
        renderLanes = current.child;
        current = renderLanes.sibling;
        renderLanes = createWorkInProgress(renderLanes, {
            mode: "visible",
            children: nextProps.children
        });
        renderLanes.return = workInProgress;
        renderLanes.sibling = null;
        null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
            current
        ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
        workInProgress.child = renderLanes;
        workInProgress.memoizedState = null;
        return renderLanes;
    }
    function mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
        primaryChildren = mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: primaryChildren
        }, workInProgress.mode);
        primaryChildren.return = workInProgress;
        return workInProgress.child = primaryChildren;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
        return createFiberFromOffscreen(offscreenProps, mode, 0, null);
    }
    function retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
        reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        current = mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
        current.flags |= 2;
        workInProgress.memoizedState = null;
        return current;
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
        fiber.lanes |= renderLanes;
        var alternate = fiber.alternate;
        null !== alternate && (alternate.lanes |= renderLanes);
        scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
    }
    function initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode) {
        var renderState = workInProgress.memoizedState;
        null === renderState ? workInProgress.memoizedState = {
            isBackwards: isBackwards,
            rendering: null,
            renderingStartTime: 0,
            last: lastContentRow,
            tail: tail,
            tailMode: tailMode
        } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode);
    }
    function updateSuspenseListComponent(current, workInProgress, renderLanes) {
        var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
        reconcileChildren(current, workInProgress, nextProps.children, renderLanes);
        nextProps = suspenseStackCursor.current;
        if (0 !== (nextProps & 2)) nextProps = nextProps & 1 | 2, workInProgress.flags |= 128;
        else {
            if (null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
                if (13 === current.tag) null !== current.memoizedState && scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
                else if (19 === current.tag) scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
                else if (null !== current.child) {
                    current.child.return = current;
                    current = current.child;
                    continue;
                }
                if (current === workInProgress) break a;
                for(; null === current.sibling;){
                    if (null === current.return || current.return === workInProgress) break a;
                    current = current.return;
                }
                current.sibling.return = current.return;
                current = current.sibling;
            }
            nextProps &= 1;
        }
        push(suspenseStackCursor, nextProps);
        switch(revealOrder){
            case "forwards":
                renderLanes = workInProgress.child;
                for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
                renderLanes = revealOrder;
                null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
                initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode);
                break;
            case "backwards":
                renderLanes = null;
                revealOrder = workInProgress.child;
                for(workInProgress.child = null; null !== revealOrder;){
                    current = revealOrder.alternate;
                    if (null !== current && null === findFirstSuspended(current)) {
                        workInProgress.child = revealOrder;
                        break;
                    }
                    current = revealOrder.sibling;
                    revealOrder.sibling = renderLanes;
                    renderLanes = revealOrder;
                    revealOrder = current;
                }
                initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode);
                break;
            case "together":
                initSuspenseListRenderState(workInProgress, !1, null, null, void 0);
                break;
            default:
                workInProgress.memoizedState = null;
        }
        return workInProgress.child;
    }
    function bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
        null !== current && (workInProgress.dependencies = current.dependencies);
        workInProgressRootSkippedLanes |= workInProgress.lanes;
        if (0 === (renderLanes & workInProgress.childLanes)) {
            if (null !== current) {
                if (propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
            } else return null;
        }
        if (null !== current && workInProgress.child !== current.child) throw Error(formatProdErrorMessage(153));
        if (null !== workInProgress.child) {
            current = workInProgress.child;
            renderLanes = createWorkInProgress(current, current.pendingProps);
            workInProgress.child = renderLanes;
            for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
            renderLanes.sibling = null;
        }
        return workInProgress.child;
    }
    function checkScheduledUpdateOrContext(current, renderLanes) {
        if (0 !== (current.lanes & renderLanes)) return !0;
        current = current.dependencies;
        return null !== current && checkIfContextChanged(current) ? !0 : !1;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
        switch(workInProgress.tag){
            case 3:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
                resetHydrationState();
                break;
            case 27:
            case 5:
                pushHostContext(workInProgress);
                break;
            case 4:
                pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                break;
            case 10:
                pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
                break;
            case 13:
                var state = workInProgress.memoizedState;
                if (null !== state) {
                    if (null !== state.dehydrated) return pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                    if (0 !== (renderLanes & workInProgress.child.childLanes)) return updateSuspenseComponent(current, workInProgress, renderLanes);
                    pushPrimaryTreeSuspenseHandler(workInProgress);
                    current = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                    return null !== current ? current.sibling : null;
                }
                pushPrimaryTreeSuspenseHandler(workInProgress);
                break;
            case 19:
                var didSuspendBefore = 0 !== (current.flags & 128);
                state = 0 !== (renderLanes & workInProgress.childLanes);
                state || (propagateParentContextChanges(current, workInProgress, renderLanes, !1), state = 0 !== (renderLanes & workInProgress.childLanes));
                if (didSuspendBefore) {
                    if (state) return updateSuspenseListComponent(current, workInProgress, renderLanes);
                    workInProgress.flags |= 128;
                }
                didSuspendBefore = workInProgress.memoizedState;
                null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
                push(suspenseStackCursor, suspenseStackCursor.current);
                if (state) break;
                else return null;
            case 22:
            case 23:
                return workInProgress.lanes = 0, updateOffscreenComponent(current, workInProgress, renderLanes);
            case 24:
                pushProvider(workInProgress, CacheContext, current.memoizedState.cache);
        }
        return bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    function beginWork(current, workInProgress, renderLanes) {
        if (null !== current) {
            if (current.memoizedProps !== workInProgress.pendingProps) didReceiveUpdate = !0;
            else {
                if (!checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return didReceiveUpdate = !1, attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
                didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
            }
        } else didReceiveUpdate = !1, isHydrating && 0 !== (workInProgress.flags & 1048576) && pushTreeId(workInProgress, treeForkCount, workInProgress.index);
        workInProgress.lanes = 0;
        switch(workInProgress.tag){
            case 16:
                a: {
                    current = workInProgress.pendingProps;
                    var lazyComponent = workInProgress.elementType, init = lazyComponent._init;
                    lazyComponent = init(lazyComponent._payload);
                    workInProgress.type = lazyComponent;
                    if ("function" === typeof lazyComponent) shouldConstruct(lazyComponent) ? (current = resolveClassComponentProps(lazyComponent, current), workInProgress.tag = 1, workInProgress = updateClassComponent(null, workInProgress, lazyComponent, current, renderLanes)) : (workInProgress.tag = 0, workInProgress = updateFunctionComponent(null, workInProgress, lazyComponent, current, renderLanes));
                    else {
                        if (void 0 !== lazyComponent && null !== lazyComponent) {
                            if (init = lazyComponent.$$typeof, init === REACT_FORWARD_REF_TYPE) {
                                workInProgress.tag = 11;
                                workInProgress = updateForwardRef(null, workInProgress, lazyComponent, current, renderLanes);
                                break a;
                            } else if (init === REACT_MEMO_TYPE) {
                                workInProgress.tag = 14;
                                workInProgress = updateMemoComponent(null, workInProgress, lazyComponent, current, renderLanes);
                                break a;
                            }
                        }
                        workInProgress = getComponentNameFromType(lazyComponent) || lazyComponent;
                        throw Error(formatProdErrorMessage(306, workInProgress, ""));
                    }
                }
                return workInProgress;
            case 0:
                return updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 1:
                return lazyComponent = workInProgress.type, init = resolveClassComponentProps(lazyComponent, workInProgress.pendingProps), updateClassComponent(current, workInProgress, lazyComponent, init, renderLanes);
            case 3:
                a: {
                    pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                    if (null === current) throw Error(formatProdErrorMessage(387));
                    var nextProps = workInProgress.pendingProps;
                    init = workInProgress.memoizedState;
                    lazyComponent = init.element;
                    cloneUpdateQueue(current, workInProgress);
                    processUpdateQueue(workInProgress, nextProps, null, renderLanes);
                    var nextState = workInProgress.memoizedState;
                    nextProps = nextState.cache;
                    pushProvider(workInProgress, CacheContext, nextProps);
                    nextProps !== init.cache && propagateContextChanges(workInProgress, [
                        CacheContext
                    ], renderLanes, !0);
                    suspendIfUpdateReadFromEntangledAsyncAction();
                    nextProps = nextState.element;
                    if (supportsHydration && init.isDehydrated) {
                        if (init = {
                            element: nextProps,
                            isDehydrated: !1,
                            cache: nextState.cache
                        }, workInProgress.updateQueue.baseState = init, workInProgress.memoizedState = init, workInProgress.flags & 256) {
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                            break a;
                        } else if (nextProps !== lazyComponent) {
                            lazyComponent = createCapturedValueAtFiber(Error(formatProdErrorMessage(424)), workInProgress);
                            queueHydrationError(lazyComponent);
                            workInProgress = mountHostRootWithoutHydrating(current, workInProgress, nextProps, renderLanes);
                            break a;
                        } else for(supportsHydration && (nextHydratableInstance = getFirstHydratableChildWithinContainer(workInProgress.stateNode.containerInfo), hydrationParentFiber = workInProgress, isHydrating = !0, hydrationErrors = null, rootOrSingletonContext = !0), renderLanes = mountChildFibers(workInProgress, null, nextProps, renderLanes), workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    } else {
                        resetHydrationState();
                        if (nextProps === lazyComponent) {
                            workInProgress = bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                            break a;
                        }
                        reconcileChildren(current, workInProgress, nextProps, renderLanes);
                    }
                    workInProgress = workInProgress.child;
                }
                return workInProgress;
            case 26:
                if (supportsResources) return markRef(current, workInProgress), null === current ? (renderLanes = getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : isHydrating || (workInProgress.stateNode = createHoistableInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
            case 27:
                if (supportsSingletons) return pushHostContext(workInProgress), null === current && supportsSingletons && isHydrating && (lazyComponent = workInProgress.stateNode = resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, rootInstanceStackCursor.current, contextStackCursor.current, !1), hydrationParentFiber = workInProgress, rootOrSingletonContext = !0, nextHydratableInstance = getFirstHydratableChild(lazyComponent)), lazyComponent = workInProgress.pendingProps.children, null !== current || isHydrating ? reconcileChildren(current, workInProgress, lazyComponent, renderLanes) : workInProgress.child = reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes), markRef(current, workInProgress), workInProgress.child;
            case 5:
                if (null === current && isHydrating) {
                    validateHydratableInstance(workInProgress.type, workInProgress.pendingProps, contextStackCursor.current);
                    if (init = lazyComponent = nextHydratableInstance) lazyComponent = canHydrateInstance(lazyComponent, workInProgress.type, workInProgress.pendingProps, rootOrSingletonContext), null !== lazyComponent ? (workInProgress.stateNode = lazyComponent, hydrationParentFiber = workInProgress, nextHydratableInstance = getFirstHydratableChild(lazyComponent), rootOrSingletonContext = !1, init = !0) : init = !1;
                    init || throwOnHydrationMismatch(workInProgress);
                }
                pushHostContext(workInProgress);
                init = workInProgress.type;
                nextProps = workInProgress.pendingProps;
                nextState = null !== current ? current.memoizedProps : null;
                lazyComponent = nextProps.children;
                shouldSetTextContent(init, nextProps) ? lazyComponent = null : null !== nextState && shouldSetTextContent(init, nextState) && (workInProgress.flags |= 32);
                null !== workInProgress.memoizedState && (init = renderWithHooks(current, workInProgress, TransitionAwareHostComponent, null, null, renderLanes), isPrimaryRenderer ? HostTransitionContext._currentValue = init : HostTransitionContext._currentValue2 = init);
                markRef(current, workInProgress);
                reconcileChildren(current, workInProgress, lazyComponent, renderLanes);
                return workInProgress.child;
            case 6:
                if (null === current && isHydrating) {
                    validateHydratableTextInstance(workInProgress.pendingProps, contextStackCursor.current);
                    if (current = renderLanes = nextHydratableInstance) renderLanes = canHydrateTextInstance(renderLanes, workInProgress.pendingProps, rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, hydrationParentFiber = workInProgress, nextHydratableInstance = null, current = !0) : current = !1;
                    current || throwOnHydrationMismatch(workInProgress);
                }
                return null;
            case 13:
                return updateSuspenseComponent(current, workInProgress, renderLanes);
            case 4:
                return pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), lazyComponent = workInProgress.pendingProps, null === current ? workInProgress.child = reconcileChildFibers(workInProgress, null, lazyComponent, renderLanes) : reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
            case 11:
                return updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 7:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
            case 8:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 12:
                return reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 10:
                return lazyComponent = workInProgress.pendingProps, pushProvider(workInProgress, workInProgress.type, lazyComponent.value), reconcileChildren(current, workInProgress, lazyComponent.children, renderLanes), workInProgress.child;
            case 9:
                return init = workInProgress.type._context, lazyComponent = workInProgress.pendingProps.children, prepareToReadContext(workInProgress), init = readContext(init), lazyComponent = lazyComponent(init), workInProgress.flags |= 1, reconcileChildren(current, workInProgress, lazyComponent, renderLanes), workInProgress.child;
            case 14:
                return updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 15:
                return updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
            case 19:
                return updateSuspenseListComponent(current, workInProgress, renderLanes);
            case 22:
                return updateOffscreenComponent(current, workInProgress, renderLanes);
            case 24:
                return prepareToReadContext(workInProgress), lazyComponent = readContext(CacheContext), null === current ? (init = peekCacheFromPool(), null === init && (init = workInProgressRoot, nextProps = createCache(), init.pooledCache = nextProps, nextProps.refCount++, null !== nextProps && (init.pooledCacheLanes |= renderLanes), init = nextProps), workInProgress.memoizedState = {
                    parent: lazyComponent,
                    cache: init
                }, initializeUpdateQueue(workInProgress), pushProvider(workInProgress, CacheContext, init)) : (0 !== (current.lanes & renderLanes) && (cloneUpdateQueue(current, workInProgress), processUpdateQueue(workInProgress, null, null, renderLanes), suspendIfUpdateReadFromEntangledAsyncAction()), init = current.memoizedState, nextProps = workInProgress.memoizedState, init.parent !== lazyComponent ? (init = {
                    parent: lazyComponent,
                    cache: lazyComponent
                }, workInProgress.memoizedState = init, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = init), pushProvider(workInProgress, CacheContext, lazyComponent)) : (lazyComponent = nextProps.cache, pushProvider(workInProgress, CacheContext, lazyComponent), lazyComponent !== init.cache && propagateContextChanges(workInProgress, [
                    CacheContext
                ], renderLanes, !0))), reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
            case 29:
                throw workInProgress.pendingProps;
        }
        throw Error(formatProdErrorMessage(156, workInProgress.tag));
    }
    function pushProvider(providerFiber, context, nextValue) {
        isPrimaryRenderer ? (push(valueCursor, context._currentValue), context._currentValue = nextValue) : (push(valueCursor, context._currentValue2), context._currentValue2 = nextValue);
    }
    function popProvider(context) {
        var currentValue = valueCursor.current;
        isPrimaryRenderer ? context._currentValue = currentValue : context._currentValue2 = currentValue;
        pop(valueCursor);
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
        for(; null !== parent;){
            var alternate = parent.alternate;
            (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
            if (parent === propagationRoot) break;
            parent = parent.return;
        }
    }
    function propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
        var fiber = workInProgress.child;
        null !== fiber && (fiber.return = workInProgress);
        for(; null !== fiber;){
            var list = fiber.dependencies;
            if (null !== list) {
                var nextFiber = fiber.child;
                list = list.firstContext;
                a: for(; null !== list;){
                    var dependency = list;
                    list = fiber;
                    for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                        list.lanes |= renderLanes;
                        dependency = list.alternate;
                        null !== dependency && (dependency.lanes |= renderLanes);
                        scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                        forcePropagateEntireTree || (nextFiber = null);
                        break a;
                    }
                    list = dependency.next;
                }
            } else if (18 === fiber.tag) {
                nextFiber = fiber.return;
                if (null === nextFiber) throw Error(formatProdErrorMessage(341));
                nextFiber.lanes |= renderLanes;
                list = nextFiber.alternate;
                null !== list && (list.lanes |= renderLanes);
                scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
                nextFiber = null;
            } else nextFiber = fiber.child;
            if (null !== nextFiber) nextFiber.return = fiber;
            else for(nextFiber = fiber; null !== nextFiber;){
                if (nextFiber === workInProgress) {
                    nextFiber = null;
                    break;
                }
                fiber = nextFiber.sibling;
                if (null !== fiber) {
                    fiber.return = nextFiber.return;
                    nextFiber = fiber;
                    break;
                }
                nextFiber = nextFiber.return;
            }
            fiber = nextFiber;
        }
    }
    function propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
        current = null;
        for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
            if (!isInsidePropagationBailout) {
                if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
                else if (0 !== (parent.flags & 262144)) break;
            }
            if (10 === parent.tag) {
                var currentParent = parent.alternate;
                if (null === currentParent) throw Error(formatProdErrorMessage(387));
                currentParent = currentParent.memoizedProps;
                if (null !== currentParent) {
                    var context = parent.type;
                    objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                        context
                    ]);
                }
            } else if (parent === hostTransitionProviderCursor.current) {
                currentParent = parent.alternate;
                if (null === currentParent) throw Error(formatProdErrorMessage(387));
                currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push(HostTransitionContext) : current = [
                    HostTransitionContext
                ]);
            }
            parent = parent.return;
        }
        null !== current && propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
        workInProgress.flags |= 262144;
    }
    function checkIfContextChanged(currentDependencies) {
        for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
            var context = currentDependencies.context;
            if (!objectIs(isPrimaryRenderer ? context._currentValue : context._currentValue2, currentDependencies.memoizedValue)) return !0;
            currentDependencies = currentDependencies.next;
        }
        return !1;
    }
    function prepareToReadContext(workInProgress) {
        currentlyRenderingFiber = workInProgress;
        lastContextDependency = null;
        workInProgress = workInProgress.dependencies;
        null !== workInProgress && (workInProgress.firstContext = null);
    }
    function readContext(context) {
        return readContextForConsumer(currentlyRenderingFiber, context);
    }
    function readContextDuringReconciliation(consumer, context) {
        null === currentlyRenderingFiber && prepareToReadContext(consumer);
        return readContextForConsumer(consumer, context);
    }
    function readContextForConsumer(consumer, context) {
        var value = isPrimaryRenderer ? context._currentValue : context._currentValue2;
        context = {
            context: context,
            memoizedValue: value,
            next: null
        };
        if (null === lastContextDependency) {
            if (null === consumer) throw Error(formatProdErrorMessage(308));
            lastContextDependency = context;
            consumer.dependencies = {
                lanes: 0,
                firstContext: context
            };
            consumer.flags |= 524288;
        } else lastContextDependency = lastContextDependency.next = context;
        return value;
    }
    function createCache() {
        return {
            controller: new AbortControllerLocal(),
            data: new Map(),
            refCount: 0
        };
    }
    function releaseCache(cache) {
        cache.refCount--;
        0 === cache.refCount && scheduleCallback$1(NormalPriority, function() {
            cache.controller.abort();
        });
    }
    function peekCacheFromPool() {
        var cacheResumedFromPreviousRender = resumedCache.current;
        return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
    }
    function pushTransition(offscreenWorkInProgress, prevCachePool) {
        null === prevCachePool ? push(resumedCache, resumedCache.current) : push(resumedCache, prevCachePool.pool);
    }
    function getSuspendedCache() {
        var cacheFromPool = peekCacheFromPool();
        return null === cacheFromPool ? null : {
            parent: isPrimaryRenderer ? CacheContext._currentValue : CacheContext._currentValue2,
            pool: cacheFromPool
        };
    }
    function markUpdate(workInProgress) {
        workInProgress.flags |= 4;
    }
    function doesRequireClone(current, completedWork) {
        if (null !== current && current.child === completedWork.child) return !1;
        if (0 !== (completedWork.flags & 16)) return !0;
        for(current = completedWork.child; null !== current;){
            if (0 !== (current.flags & 13878) || 0 !== (current.subtreeFlags & 13878)) return !0;
            current = current.sibling;
        }
        return !1;
    }
    function appendAllChildren(parent, workInProgress, needsVisibilityToggle, isHidden) {
        if (supportsMutation) for(needsVisibilityToggle = workInProgress.child; null !== needsVisibilityToggle;){
            if (5 === needsVisibilityToggle.tag || 6 === needsVisibilityToggle.tag) appendInitialChild(parent, needsVisibilityToggle.stateNode);
            else if (!(4 === needsVisibilityToggle.tag || supportsSingletons && 27 === needsVisibilityToggle.tag) && null !== needsVisibilityToggle.child) {
                needsVisibilityToggle.child.return = needsVisibilityToggle;
                needsVisibilityToggle = needsVisibilityToggle.child;
                continue;
            }
            if (needsVisibilityToggle === workInProgress) break;
            for(; null === needsVisibilityToggle.sibling;){
                if (null === needsVisibilityToggle.return || needsVisibilityToggle.return === workInProgress) return;
                needsVisibilityToggle = needsVisibilityToggle.return;
            }
            needsVisibilityToggle.sibling.return = needsVisibilityToggle.return;
            needsVisibilityToggle = needsVisibilityToggle.sibling;
        }
        else if (supportsPersistence) for(var node$91 = workInProgress.child; null !== node$91;){
            if (5 === node$91.tag) {
                var instance = node$91.stateNode;
                needsVisibilityToggle && isHidden && (instance = cloneHiddenInstance(instance, node$91.type, node$91.memoizedProps));
                appendInitialChild(parent, instance);
            } else if (6 === node$91.tag) instance = node$91.stateNode, needsVisibilityToggle && isHidden && (instance = cloneHiddenTextInstance(instance, node$91.memoizedProps)), appendInitialChild(parent, instance);
            else if (4 !== node$91.tag) {
                if (22 === node$91.tag && null !== node$91.memoizedState) instance = node$91.child, null !== instance && (instance.return = node$91), appendAllChildren(parent, node$91, !0, !0);
                else if (null !== node$91.child) {
                    node$91.child.return = node$91;
                    node$91 = node$91.child;
                    continue;
                }
            }
            if (node$91 === workInProgress) break;
            for(; null === node$91.sibling;){
                if (null === node$91.return || node$91.return === workInProgress) return;
                node$91 = node$91.return;
            }
            node$91.sibling.return = node$91.return;
            node$91 = node$91.sibling;
        }
    }
    function appendAllChildrenToContainer(containerChildSet, workInProgress, needsVisibilityToggle, isHidden) {
        if (supportsPersistence) for(var node = workInProgress.child; null !== node;){
            if (5 === node.tag) {
                var instance = node.stateNode;
                needsVisibilityToggle && isHidden && (instance = cloneHiddenInstance(instance, node.type, node.memoizedProps));
                appendChildToContainerChildSet(containerChildSet, instance);
            } else if (6 === node.tag) instance = node.stateNode, needsVisibilityToggle && isHidden && (instance = cloneHiddenTextInstance(instance, node.memoizedProps)), appendChildToContainerChildSet(containerChildSet, instance);
            else if (4 !== node.tag) {
                if (22 === node.tag && null !== node.memoizedState) instance = node.child, null !== instance && (instance.return = node), appendAllChildrenToContainer(containerChildSet, node, !(null !== node.memoizedProps && "manual" === node.memoizedProps.mode), !0);
                else if (null !== node.child) {
                    node.child.return = node;
                    node = node.child;
                    continue;
                }
            }
            if (node === workInProgress) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === workInProgress) return;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    function updateHostContainer(current, workInProgress) {
        if (supportsPersistence && doesRequireClone(current, workInProgress)) {
            current = workInProgress.stateNode;
            var container = current.containerInfo, newChildSet = createContainerChildSet();
            appendAllChildrenToContainer(newChildSet, workInProgress, !1, !1);
            current.pendingChildren = newChildSet;
            markUpdate(workInProgress);
            finalizeContainerChildren(container, newChildSet);
        }
    }
    function updateHostComponent(current, workInProgress, type, newProps) {
        if (supportsMutation) current.memoizedProps !== newProps && markUpdate(workInProgress);
        else if (supportsPersistence) {
            var currentInstance = current.stateNode, oldProps$94 = current.memoizedProps;
            if ((current = doesRequireClone(current, workInProgress)) || oldProps$94 !== newProps) {
                var currentHostContext = contextStackCursor.current;
                oldProps$94 = cloneInstance(currentInstance, type, oldProps$94, newProps, !current, null);
                oldProps$94 === currentInstance ? workInProgress.stateNode = currentInstance : (finalizeInitialChildren(oldProps$94, type, newProps, currentHostContext) && markUpdate(workInProgress), workInProgress.stateNode = oldProps$94, current ? appendAllChildren(oldProps$94, workInProgress, !1, !1) : markUpdate(workInProgress));
            } else workInProgress.stateNode = currentInstance;
        }
    }
    function preloadInstanceAndSuspendIfNeeded(workInProgress, type, props) {
        if (maySuspendCommit(type, props)) {
            if (workInProgress.flags |= 16777216, !preloadInstance(type, props)) {
                if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
                else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
            }
        } else workInProgress.flags &= -16777217;
    }
    function preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
        if (mayResourceSuspendCommit(resource)) {
            if (workInProgress.flags |= 16777216, !preloadResource(resource)) {
                if (shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
                else throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
            }
        } else workInProgress.flags &= -16777217;
    }
    function scheduleRetryEffect(workInProgress, retryQueue) {
        null !== retryQueue && (workInProgress.flags |= 4);
        workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
    }
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
        if (!isHydrating) switch(renderState.tailMode){
            case "hidden":
                hasRenderedATailFallback = renderState.tail;
                for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
                null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
                break;
            case "collapsed":
                lastTailNode = renderState.tail;
                for(var lastTailNode$96 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$96 = lastTailNode), lastTailNode = lastTailNode.sibling;
                null === lastTailNode$96 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$96.sibling = null;
        }
    }
    function bubbleProperties(completedWork) {
        var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
        if (didBailout) for(var child$97 = completedWork.child; null !== child$97;)newChildLanes |= child$97.lanes | child$97.childLanes, subtreeFlags |= child$97.subtreeFlags & 31457280, subtreeFlags |= child$97.flags & 31457280, child$97.return = completedWork, child$97 = child$97.sibling;
        else for(child$97 = completedWork.child; null !== child$97;)newChildLanes |= child$97.lanes | child$97.childLanes, subtreeFlags |= child$97.subtreeFlags, subtreeFlags |= child$97.flags, child$97.return = completedWork, child$97 = child$97.sibling;
        completedWork.subtreeFlags |= subtreeFlags;
        completedWork.childLanes = newChildLanes;
        return didBailout;
    }
    function completeWork(current, workInProgress, renderLanes) {
        var newProps = workInProgress.pendingProps;
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 16:
            case 15:
            case 0:
            case 11:
            case 7:
            case 8:
            case 12:
            case 9:
            case 14:
                return bubbleProperties(workInProgress), null;
            case 1:
                return bubbleProperties(workInProgress), null;
            case 3:
                renderLanes = workInProgress.stateNode;
                newProps = null;
                null !== current && (newProps = current.memoizedState.cache);
                workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
                popProvider(CacheContext);
                popHostContainer();
                renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
                if (null === current || null === current.child) popHydrationState(workInProgress) ? markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, null !== hydrationErrors && (queueRecoverableErrors(hydrationErrors), hydrationErrors = null));
                updateHostContainer(current, workInProgress);
                bubbleProperties(workInProgress);
                return null;
            case 26:
                if (supportsResources) {
                    renderLanes = workInProgress.type;
                    var nextResource = workInProgress.memoizedState;
                    null === current ? (markUpdate(workInProgress), null !== nextResource ? (bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, renderLanes, newProps))) : nextResource ? nextResource !== current.memoizedState ? (markUpdate(workInProgress), bubbleProperties(workInProgress), preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : (bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (supportsMutation ? current.memoizedProps !== newProps && markUpdate(workInProgress) : updateHostComponent(current, workInProgress, renderLanes, newProps), bubbleProperties(workInProgress), preloadInstanceAndSuspendIfNeeded(workInProgress, renderLanes, newProps));
                    return null;
                }
            case 27:
                if (supportsSingletons) {
                    popHostContext(workInProgress);
                    renderLanes = rootInstanceStackCursor.current;
                    nextResource = workInProgress.type;
                    if (null !== current && null != workInProgress.stateNode) supportsMutation ? current.memoizedProps !== newProps && markUpdate(workInProgress) : updateHostComponent(current, workInProgress, nextResource, newProps);
                    else {
                        if (!newProps) {
                            if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                            bubbleProperties(workInProgress);
                            return null;
                        }
                        current = contextStackCursor.current;
                        popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (current = resolveSingletonInstance(nextResource, newProps, renderLanes, current, !0), workInProgress.stateNode = current, markUpdate(workInProgress));
                    }
                    bubbleProperties(workInProgress);
                    return null;
                }
            case 5:
                popHostContext(workInProgress);
                renderLanes = workInProgress.type;
                if (null !== current && null != workInProgress.stateNode) updateHostComponent(current, workInProgress, renderLanes, newProps);
                else {
                    if (!newProps) {
                        if (null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                        bubbleProperties(workInProgress);
                        return null;
                    }
                    current = contextStackCursor.current;
                    popHydrationState(workInProgress) ? prepareToHydrateHostInstance(workInProgress, current) : (nextResource = createInstance(renderLanes, newProps, rootInstanceStackCursor.current, current, workInProgress), appendAllChildren(nextResource, workInProgress, !1, !1), workInProgress.stateNode = nextResource, finalizeInitialChildren(nextResource, renderLanes, newProps, current) && markUpdate(workInProgress));
                }
                bubbleProperties(workInProgress);
                preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, workInProgress.pendingProps);
                return null;
            case 6:
                if (current && null != workInProgress.stateNode) renderLanes = current.memoizedProps, supportsMutation ? renderLanes !== newProps && markUpdate(workInProgress) : supportsPersistence && (renderLanes !== newProps ? (workInProgress.stateNode = createTextInstance(newProps, rootInstanceStackCursor.current, contextStackCursor.current, workInProgress), markUpdate(workInProgress)) : workInProgress.stateNode = current.stateNode);
                else {
                    if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error(formatProdErrorMessage(166));
                    current = rootInstanceStackCursor.current;
                    renderLanes = contextStackCursor.current;
                    if (popHydrationState(workInProgress)) {
                        if (!supportsHydration) throw Error(formatProdErrorMessage(176));
                        current = workInProgress.stateNode;
                        renderLanes = workInProgress.memoizedProps;
                        newProps = null;
                        nextResource = hydrationParentFiber;
                        if (null !== nextResource) switch(nextResource.tag){
                            case 27:
                            case 5:
                                newProps = nextResource.memoizedProps;
                        }
                        hydrateTextInstance(current, renderLanes, workInProgress, newProps) || throwOnHydrationMismatch(workInProgress);
                    } else workInProgress.stateNode = createTextInstance(newProps, current, renderLanes, workInProgress);
                }
                bubbleProperties(workInProgress);
                return null;
            case 13:
                newProps = workInProgress.memoizedState;
                if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                    nextResource = popHydrationState(workInProgress);
                    if (null !== newProps && null !== newProps.dehydrated) {
                        if (null === current) {
                            if (!nextResource) throw Error(formatProdErrorMessage(318));
                            if (!supportsHydration) throw Error(formatProdErrorMessage(344));
                            nextResource = workInProgress.memoizedState;
                            nextResource = null !== nextResource ? nextResource.dehydrated : null;
                            if (!nextResource) throw Error(formatProdErrorMessage(317));
                            hydrateSuspenseInstance(nextResource, workInProgress);
                        } else resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                        bubbleProperties(workInProgress);
                        nextResource = !1;
                    } else null !== hydrationErrors && (queueRecoverableErrors(hydrationErrors), hydrationErrors = null), nextResource = !0;
                    if (!nextResource) {
                        if (workInProgress.flags & 256) return popSuspenseHandler(workInProgress), workInProgress;
                        popSuspenseHandler(workInProgress);
                        return null;
                    }
                }
                popSuspenseHandler(workInProgress);
                if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
                renderLanes = null !== newProps;
                current = null !== current && null !== current.memoizedState;
                if (renderLanes) {
                    newProps = workInProgress.child;
                    nextResource = null;
                    null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (nextResource = newProps.alternate.memoizedState.cachePool.pool);
                    var cache$110 = null;
                    null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (cache$110 = newProps.memoizedState.cachePool.pool);
                    cache$110 !== nextResource && (newProps.flags |= 2048);
                }
                renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
                scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
                bubbleProperties(workInProgress);
                return null;
            case 4:
                return popHostContainer(), updateHostContainer(current, workInProgress), null === current && preparePortalMount(workInProgress.stateNode.containerInfo), bubbleProperties(workInProgress), null;
            case 10:
                return popProvider(workInProgress.type), bubbleProperties(workInProgress), null;
            case 19:
                pop(suspenseStackCursor);
                nextResource = workInProgress.memoizedState;
                if (null === nextResource) return bubbleProperties(workInProgress), null;
                newProps = 0 !== (workInProgress.flags & 128);
                cache$110 = nextResource.rendering;
                if (null === cache$110) {
                    if (newProps) cutOffTailIfNeeded(nextResource, !1);
                    else {
                        if (0 !== workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                            cache$110 = findFirstSuspended(current);
                            if (null !== cache$110) {
                                workInProgress.flags |= 128;
                                cutOffTailIfNeeded(nextResource, !1);
                                current = cache$110.updateQueue;
                                workInProgress.updateQueue = current;
                                scheduleRetryEffect(workInProgress, current);
                                workInProgress.subtreeFlags = 0;
                                current = renderLanes;
                                for(renderLanes = workInProgress.child; null !== renderLanes;)resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                                push(suspenseStackCursor, suspenseStackCursor.current & 1 | 2);
                                return workInProgress.child;
                            }
                            current = current.sibling;
                        }
                        null !== nextResource.tail && now() > workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, newProps = !0, cutOffTailIfNeeded(nextResource, !1), workInProgress.lanes = 4194304);
                    }
                } else {
                    if (!newProps) {
                        if (current = findFirstSuspended(cache$110), null !== current) {
                            if (workInProgress.flags |= 128, newProps = !0, current = current.updateQueue, workInProgress.updateQueue = current, scheduleRetryEffect(workInProgress, current), cutOffTailIfNeeded(nextResource, !0), null === nextResource.tail && "hidden" === nextResource.tailMode && !cache$110.alternate && !isHydrating) return bubbleProperties(workInProgress), null;
                        } else 2 * now() - nextResource.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, newProps = !0, cutOffTailIfNeeded(nextResource, !1), workInProgress.lanes = 4194304);
                    }
                    nextResource.isBackwards ? (cache$110.sibling = workInProgress.child, workInProgress.child = cache$110) : (current = nextResource.last, null !== current ? current.sibling = cache$110 : workInProgress.child = cache$110, nextResource.last = cache$110);
                }
                if (null !== nextResource.tail) return workInProgress = nextResource.tail, nextResource.rendering = workInProgress, nextResource.tail = workInProgress.sibling, nextResource.renderingStartTime = now(), workInProgress.sibling = null, current = suspenseStackCursor.current, push(suspenseStackCursor, newProps ? current & 1 | 2 : current & 1), workInProgress;
                bubbleProperties(workInProgress);
                return null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && (bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && pop(resumedCache), null;
            case 24:
                return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress), null;
            case 25:
                return null;
        }
        throw Error(formatProdErrorMessage(156, workInProgress.tag));
    }
    function unwindWork(current, workInProgress) {
        popTreeContext(workInProgress);
        switch(workInProgress.tag){
            case 1:
                return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 3:
                return popProvider(CacheContext), popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 26:
            case 27:
            case 5:
                return popHostContext(workInProgress), null;
            case 13:
                popSuspenseHandler(workInProgress);
                current = workInProgress.memoizedState;
                if (null !== current && null !== current.dehydrated) {
                    if (null === workInProgress.alternate) throw Error(formatProdErrorMessage(340));
                    resetHydrationState();
                }
                current = workInProgress.flags;
                return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 19:
                return pop(suspenseStackCursor), null;
            case 4:
                return popHostContainer(), null;
            case 10:
                return popProvider(workInProgress.type), null;
            case 22:
            case 23:
                return popSuspenseHandler(workInProgress), popHiddenContext(), null !== current && pop(resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
            case 24:
                return popProvider(CacheContext), null;
            case 25:
                return null;
            default:
                return null;
        }
    }
    function unwindInterruptedWork(current, interruptedWork) {
        popTreeContext(interruptedWork);
        switch(interruptedWork.tag){
            case 3:
                popProvider(CacheContext);
                popHostContainer();
                break;
            case 26:
            case 27:
            case 5:
                popHostContext(interruptedWork);
                break;
            case 4:
                popHostContainer();
                break;
            case 13:
                popSuspenseHandler(interruptedWork);
                break;
            case 19:
                pop(suspenseStackCursor);
                break;
            case 10:
                popProvider(interruptedWork.type);
                break;
            case 22:
            case 23:
                popSuspenseHandler(interruptedWork);
                popHiddenContext();
                null !== current && pop(resumedCache);
                break;
            case 24:
                popProvider(CacheContext);
        }
    }
    function commitHookEffectListMount(flags, finishedWork) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags) {
                        lastEffect = void 0;
                        var create = updateQueue.create, inst = updateQueue.inst;
                        lastEffect = create();
                        inst.destroy = lastEffect;
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
        try {
            var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
            if (null !== lastEffect) {
                var firstEffect = lastEffect.next;
                updateQueue = firstEffect;
                do {
                    if ((updateQueue.tag & flags) === flags) {
                        var inst = updateQueue.inst, destroy = inst.destroy;
                        if (void 0 !== destroy) {
                            inst.destroy = void 0;
                            lastEffect = finishedWork;
                            var nearestMountedAncestor = nearestMountedAncestor$jscomp$0;
                            try {
                                destroy();
                            } catch (error) {
                                captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                            }
                        }
                    }
                    updateQueue = updateQueue.next;
                }while (updateQueue !== firstEffect);
            }
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitClassCallbacks(finishedWork) {
        var updateQueue = finishedWork.updateQueue;
        if (null !== updateQueue) {
            var instance = finishedWork.stateNode;
            try {
                commitCallbacks(updateQueue, instance);
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
        }
    }
    function safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
        instance.props = resolveClassComponentProps(current.type, current.memoizedProps);
        instance.state = current.memoizedState;
        try {
            instance.componentWillUnmount();
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyAttachRef(current, nearestMountedAncestor) {
        try {
            var ref = current.ref;
            if (null !== ref) {
                var instance = current.stateNode;
                switch(current.tag){
                    case 26:
                    case 27:
                    case 5:
                        var instanceToUse = getPublicInstance(instance);
                        break;
                    default:
                        instanceToUse = instance;
                }
                "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
            }
        } catch (error) {
            captureCommitPhaseError(current, nearestMountedAncestor, error);
        }
    }
    function safelyDetachRef(current, nearestMountedAncestor) {
        var ref = current.ref, refCleanup = current.refCleanup;
        if (null !== ref) {
            if ("function" === typeof refCleanup) try {
                refCleanup();
            } catch (error) {
                captureCommitPhaseError(current, nearestMountedAncestor, error);
            } finally{
                current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
            }
            else if ("function" === typeof ref) try {
                ref(null);
            } catch (error$126) {
                captureCommitPhaseError(current, nearestMountedAncestor, error$126);
            }
            else ref.current = null;
        }
    }
    function commitHostMount(finishedWork) {
        var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
        try {
            commitMount(instance, type, props, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitHostUpdate(finishedWork, newProps, oldProps) {
        try {
            commitUpdate(finishedWork.stateNode, finishedWork.type, oldProps, newProps, finishedWork);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function isHostParent(fiber) {
        return 5 === fiber.tag || 3 === fiber.tag || (supportsResources ? 26 === fiber.tag : !1) || (supportsSingletons ? 27 === fiber.tag : !1) || 4 === fiber.tag;
    }
    function getHostSibling(fiber) {
        a: for(;;){
            for(; null === fiber.sibling;){
                if (null === fiber.return || isHostParent(fiber.return)) return null;
                fiber = fiber.return;
            }
            fiber.sibling.return = fiber.return;
            for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && (supportsSingletons ? 27 !== fiber.tag : 1) && 18 !== fiber.tag;){
                if (fiber.flags & 2) continue a;
                if (null === fiber.child || 4 === fiber.tag) continue a;
                else fiber.child.return = fiber, fiber = fiber.child;
            }
            if (!(fiber.flags & 2)) return fiber.stateNode;
        }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) node = node.stateNode, before ? insertInContainerBefore(parent, node, before) : appendChildToContainer(parent, node);
        else if (!(4 === tag || supportsSingletons && 27 === tag) && (node = node.child, null !== node)) for(insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
    }
    function insertOrAppendPlacementNode(node, before, parent) {
        var tag = node.tag;
        if (5 === tag || 6 === tag) node = node.stateNode, before ? insertBefore(parent, node, before) : appendChild(parent, node);
        else if (!(4 === tag || supportsSingletons && 27 === tag) && (node = node.child, null !== node)) for(insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
    }
    function commitHostPortalContainerChildren(portal, finishedWork, pendingChildren) {
        portal = portal.containerInfo;
        try {
            replaceContainerChildren(portal, pendingChildren);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function commitBeforeMutationEffects(root, firstChild) {
        prepareForCommit(root.containerInfo);
        for(nextEffect = firstChild; null !== nextEffect;)if (root = nextEffect, firstChild = root.child, 0 !== (root.subtreeFlags & 1028) && null !== firstChild) firstChild.return = root, nextEffect = firstChild;
        else for(; null !== nextEffect;){
            root = nextEffect;
            var current = root.alternate;
            firstChild = root.flags;
            switch(root.tag){
                case 0:
                    break;
                case 11:
                case 15:
                    break;
                case 1:
                    if (0 !== (firstChild & 1024) && null !== current) {
                        firstChild = void 0;
                        var finishedWork = root, prevProps = current.memoizedProps;
                        current = current.memoizedState;
                        var instance = finishedWork.stateNode;
                        try {
                            var resolvedPrevProps = resolveClassComponentProps(finishedWork.type, prevProps, finishedWork.elementType === finishedWork.type);
                            firstChild = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                            instance.__reactInternalSnapshotBeforeUpdate = firstChild;
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                    break;
                case 3:
                    0 !== (firstChild & 1024) && supportsMutation && clearContainer(root.stateNode.containerInfo);
                    break;
                case 5:
                case 26:
                case 27:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    if (0 !== (firstChild & 1024)) throw Error(formatProdErrorMessage(163));
            }
            firstChild = root.sibling;
            if (null !== firstChild) {
                firstChild.return = root.return;
                nextEffect = firstChild;
                break;
            }
            nextEffect = root.return;
        }
        resolvedPrevProps = shouldFireAfterActiveInstanceBlur;
        shouldFireAfterActiveInstanceBlur = !1;
        return resolvedPrevProps;
    }
    function commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
        var flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitHookEffectListMount(5, finishedWork);
                break;
            case 1:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 4) {
                    if (finishedRoot = finishedWork.stateNode, null === current) try {
                        finishedRoot.componentDidMount();
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    else {
                        var prevProps = resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                        current = current.memoizedState;
                        try {
                            finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                        } catch (error$125) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error$125);
                        }
                    }
                }
                flags & 64 && commitClassCallbacks(finishedWork);
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 3:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
                    finishedRoot = null;
                    if (null !== finishedWork.child) switch(finishedWork.child.tag){
                        case 27:
                        case 5:
                            finishedRoot = getPublicInstance(finishedWork.child.stateNode);
                            break;
                        case 1:
                            finishedRoot = finishedWork.child.stateNode;
                    }
                    try {
                        commitCallbacks(flags, finishedRoot);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                break;
            case 26:
                if (supportsResources) {
                    recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                    break;
                }
            case 27:
            case 5:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                null === current && flags & 4 && commitHostMount(finishedWork);
                flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                break;
            case 13:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                prevProps = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
                if (!prevProps) {
                    current = null !== current && null !== current.memoizedState || offscreenSubtreeWasHidden;
                    var prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                    offscreenSubtreeIsHidden = prevProps;
                    (offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                    offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                    offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                }
                flags & 512 && ("manual" === finishedWork.memoizedProps.mode ? safelyAttachRef(finishedWork, finishedWork.return) : safelyDetachRef(finishedWork, finishedWork.return));
                break;
            default:
                recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        }
    }
    function detachFiberAfterEffects(fiber) {
        var alternate = fiber.alternate;
        null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
        fiber.child = null;
        fiber.deletions = null;
        fiber.sibling = null;
        5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
        fiber.stateNode = null;
        fiber.return = null;
        fiber.dependencies = null;
        fiber.memoizedProps = null;
        fiber.memoizedState = null;
        fiber.pendingProps = null;
        fiber.stateNode = null;
        fiber.updateQueue = null;
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
        for(parent = parent.child; null !== parent;)commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount) try {
            injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
        } catch (err) {}
        switch(deletedFiber.tag){
            case 26:
                if (supportsResources) {
                    offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    deletedFiber.memoizedState ? releaseResource(deletedFiber.memoizedState) : deletedFiber.stateNode && unmountHoistable(deletedFiber.stateNode);
                    break;
                }
            case 27:
                if (supportsSingletons) {
                    offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                    var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
                    hostParent = deletedFiber.stateNode;
                    recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                    releaseSingletonInstance(deletedFiber.stateNode);
                    hostParent = prevHostParent;
                    hostParentIsContainer = prevHostParentIsContainer;
                    break;
                }
            case 5:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
            case 6:
                if (supportsMutation) {
                    if (prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer, hostParent = null, recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber), hostParent = prevHostParent, hostParentIsContainer = prevHostParentIsContainer, null !== hostParent) {
                        if (hostParentIsContainer) try {
                            removeChildFromContainer(hostParent, deletedFiber.stateNode);
                        } catch (error) {
                            captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                        }
                        else try {
                            removeChild(hostParent, deletedFiber.stateNode);
                        } catch (error) {
                            captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                        }
                    }
                } else recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 18:
                supportsMutation && null !== hostParent && (hostParentIsContainer ? clearSuspenseBoundaryFromContainer(hostParent, deletedFiber.stateNode) : clearSuspenseBoundary(hostParent, deletedFiber.stateNode));
                break;
            case 4:
                supportsMutation ? (prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer, hostParent = deletedFiber.stateNode.containerInfo, hostParentIsContainer = !0, recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber), hostParent = prevHostParent, hostParentIsContainer = prevHostParentIsContainer) : (supportsPersistence && commitHostPortalContainerChildren(deletedFiber.stateNode, deletedFiber, createContainerChildSet()), recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber));
                break;
            case 0:
            case 11:
            case 14:
            case 15:
                offscreenSubtreeWasHidden || commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
                offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 1:
                offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 21:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                break;
            case 22:
                offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
                offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
                offscreenSubtreeWasHidden = prevHostParent;
                break;
            default:
                recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
        }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
        if (supportsHydration && null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
            commitHydratedSuspenseInstance(finishedRoot);
        } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function getRetryCache(finishedWork) {
        switch(finishedWork.tag){
            case 13:
            case 19:
                var retryCache = finishedWork.stateNode;
                null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
                return retryCache;
            case 22:
                return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
            default:
                throw Error(formatProdErrorMessage(435, finishedWork.tag));
        }
    }
    function attachSuspenseRetryListeners(finishedWork, wakeables) {
        var retryCache = getRetryCache(finishedWork);
        wakeables.forEach(function(wakeable) {
            var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
            retryCache.has(wakeable) || (retryCache.add(wakeable), wakeable.then(retry, retry));
        });
    }
    function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
        var deletions = parentFiber.deletions;
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber;
            if (supportsMutation) {
                var parent = returnFiber;
                a: for(; null !== parent;){
                    switch(parent.tag){
                        case 27:
                        case 5:
                            hostParent = parent.stateNode;
                            hostParentIsContainer = !1;
                            break a;
                        case 3:
                            hostParent = parent.stateNode.containerInfo;
                            hostParentIsContainer = !0;
                            break a;
                        case 4:
                            hostParent = parent.stateNode.containerInfo;
                            hostParentIsContainer = !0;
                            break a;
                    }
                    parent = parent.return;
                }
                if (null === hostParent) throw Error(formatProdErrorMessage(160));
                commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
                hostParent = null;
                hostParentIsContainer = !1;
            } else commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
            root = childToDelete.alternate;
            null !== root && (root.return = null);
            childToDelete.return = null;
        }
        if (parentFiber.subtreeFlags & 13878) for(parentFiber = parentFiber.child; null !== parentFiber;)commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
    }
    function commitMutationEffectsOnFiber(finishedWork, root) {
        var current = finishedWork.alternate, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
                break;
            case 1:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
                break;
            case 26:
                if (supportsResources) {
                    var hoistableRoot = currentHoistableRoot;
                    recursivelyTraverseMutationEffects(root, finishedWork);
                    commitReconciliationEffects(finishedWork);
                    flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                    flags & 4 && (flags = null !== current ? current.memoizedState : null, root = finishedWork.memoizedState, null === current ? null === root ? null === finishedWork.stateNode ? finishedWork.stateNode = hydrateHoistable(hoistableRoot, finishedWork.type, finishedWork.memoizedProps, finishedWork) : mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : finishedWork.stateNode = acquireResource(hoistableRoot, root, finishedWork.memoizedProps) : flags !== root ? (null === flags ? null !== current.stateNode && unmountHoistable(current.stateNode) : releaseResource(flags), null === root ? mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : acquireResource(hoistableRoot, root, finishedWork.memoizedProps)) : null === root && null !== finishedWork.stateNode && commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps));
                    break;
                }
            case 27:
                if (supportsSingletons && flags & 4 && null === finishedWork.alternate) {
                    hoistableRoot = finishedWork.stateNode;
                    var props = finishedWork.memoizedProps;
                    try {
                        clearSingleton(hoistableRoot), acquireSingletonInstance(finishedWork.type, props, hoistableRoot, finishedWork);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
            case 5:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                if (supportsMutation) {
                    if (finishedWork.flags & 32) {
                        root = finishedWork.stateNode;
                        try {
                            resetTextContent(root);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                    flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
                    flags & 1024 && (needsFormReset = !0);
                }
                break;
            case 6:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & 4 && supportsMutation) {
                    if (null === finishedWork.stateNode) throw Error(formatProdErrorMessage(162));
                    flags = finishedWork.memoizedProps;
                    current = null !== current ? current.memoizedProps : flags;
                    root = finishedWork.stateNode;
                    try {
                        commitTextUpdate(root, current, flags);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                }
                break;
            case 3:
                supportsResources ? (prepareToCommitHoistables(), hoistableRoot = currentHoistableRoot, currentHoistableRoot = getHoistableRoot(root.containerInfo), recursivelyTraverseMutationEffects(root, finishedWork), currentHoistableRoot = hoistableRoot) : recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                if (flags & 4) {
                    if (supportsMutation && supportsHydration && null !== current && current.memoizedState.isDehydrated) try {
                        commitHydratedContainer(root.containerInfo);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                    if (supportsPersistence) {
                        flags = root.containerInfo;
                        current = root.pendingChildren;
                        try {
                            replaceContainerChildren(flags, current);
                        } catch (error) {
                            captureCommitPhaseError(finishedWork, finishedWork.return, error);
                        }
                    }
                }
                needsFormReset && (needsFormReset = !1, recursivelyResetForms(finishedWork));
                break;
            case 4:
                supportsResources ? (current = currentHoistableRoot, currentHoistableRoot = getHoistableRoot(finishedWork.stateNode.containerInfo), recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork), currentHoistableRoot = current) : (recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork));
                flags & 4 && supportsPersistence && commitHostPortalContainerChildren(finishedWork.stateNode, finishedWork, finishedWork.stateNode.pendingChildren);
                break;
            case 12:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                break;
            case 13:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && (globalMostRecentFallbackTime = now());
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 22:
                flags & 512 && (offscreenSubtreeWasHidden || null === current || safelyDetachRef(current, current.return));
                hoistableRoot = null !== finishedWork.memoizedState;
                var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
                recursivelyTraverseMutationEffects(root, finishedWork);
                offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
                offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
                commitReconciliationEffects(finishedWork);
                root = finishedWork.stateNode;
                root._current = finishedWork;
                root._visibility &= -3;
                root._visibility |= root._pendingVisibility & 2;
                if (flags & 8192 && (root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (root = offscreenSubtreeIsHidden || offscreenSubtreeWasHidden, null === current || wasHidden || root || recursivelyTraverseDisappearLayoutEffects(finishedWork)), supportsMutation && (null === finishedWork.memoizedProps || "manual" !== finishedWork.memoizedProps.mode))) {
                    a: if (current = null, supportsMutation) for(root = finishedWork;;){
                        if (5 === root.tag || supportsResources && 26 === root.tag || supportsSingletons && 27 === root.tag) {
                            if (null === current) {
                                wasHidden = current = root;
                                try {
                                    props = wasHidden.stateNode, hoistableRoot ? hideInstance(props) : unhideInstance(wasHidden.stateNode, wasHidden.memoizedProps);
                                } catch (error) {
                                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
                                }
                            }
                        } else if (6 === root.tag) {
                            if (null === current) {
                                wasHidden = root;
                                try {
                                    var instance = wasHidden.stateNode;
                                    hoistableRoot ? hideTextInstance(instance) : unhideTextInstance(instance, wasHidden.memoizedProps);
                                } catch (error) {
                                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
                                }
                            }
                        } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                            root.child.return = root;
                            root = root.child;
                            continue;
                        }
                        if (root === finishedWork) break a;
                        for(; null === root.sibling;){
                            if (null === root.return || root.return === finishedWork) break a;
                            current === root && (current = null);
                            root = root.return;
                        }
                        current === root && (current = null);
                        root.sibling.return = root.return;
                        root = root.sibling;
                    }
                }
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current))));
                break;
            case 19:
                recursivelyTraverseMutationEffects(root, finishedWork);
                commitReconciliationEffects(finishedWork);
                flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
                break;
            case 21:
                break;
            default:
                recursivelyTraverseMutationEffects(root, finishedWork), commitReconciliationEffects(finishedWork);
        }
    }
    function commitReconciliationEffects(finishedWork) {
        var flags = finishedWork.flags;
        if (flags & 2) {
            try {
                if (supportsMutation && (!supportsSingletons || 27 !== finishedWork.tag)) {
                    a: {
                        for(var parent = finishedWork.return; null !== parent;){
                            if (isHostParent(parent)) {
                                var JSCompiler_inline_result = parent;
                                break a;
                            }
                            parent = parent.return;
                        }
                        throw Error(formatProdErrorMessage(160));
                    }
                    switch(JSCompiler_inline_result.tag){
                        case 27:
                            if (supportsSingletons) {
                                var parent$jscomp$0 = JSCompiler_inline_result.stateNode, before = getHostSibling(finishedWork);
                                insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0);
                                break;
                            }
                        case 5:
                            var parent$127 = JSCompiler_inline_result.stateNode;
                            JSCompiler_inline_result.flags & 32 && (resetTextContent(parent$127), JSCompiler_inline_result.flags &= -33);
                            var before$128 = getHostSibling(finishedWork);
                            insertOrAppendPlacementNode(finishedWork, before$128, parent$127);
                            break;
                        case 3:
                        case 4:
                            var parent$129 = JSCompiler_inline_result.stateNode.containerInfo, before$130 = getHostSibling(finishedWork);
                            insertOrAppendPlacementNodeIntoContainer(finishedWork, before$130, parent$129);
                            break;
                        default:
                            throw Error(formatProdErrorMessage(161));
                    }
                }
            } catch (error) {
                captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            finishedWork.flags &= -3;
        }
        flags & 4096 && (finishedWork.flags &= -4097);
    }
    function recursivelyResetForms(parentFiber) {
        if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var fiber = parentFiber;
            recursivelyResetForms(fiber);
            5 === fiber.tag && fiber.flags & 1024 && resetFormInstance(fiber.stateNode);
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseLayoutEffects(root, parentFiber) {
        if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
    }
    function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            var finishedWork = parentFiber;
            switch(finishedWork.tag){
                case 0:
                case 11:
                case 14:
                case 15:
                    commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                    recursivelyTraverseDisappearLayoutEffects(finishedWork);
                    break;
                case 1:
                    safelyDetachRef(finishedWork, finishedWork.return);
                    var instance = finishedWork.stateNode;
                    "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                    recursivelyTraverseDisappearLayoutEffects(finishedWork);
                    break;
                case 26:
                case 27:
                case 5:
                    safelyDetachRef(finishedWork, finishedWork.return);
                    recursivelyTraverseDisappearLayoutEffects(finishedWork);
                    break;
                case 22:
                    safelyDetachRef(finishedWork, finishedWork.return);
                    null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
                    break;
                default:
                    recursivelyTraverseDisappearLayoutEffects(finishedWork);
            }
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
        includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
            switch(finishedWork.tag){
                case 0:
                case 11:
                case 15:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    commitHookEffectListMount(4, finishedWork);
                    break;
                case 1:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    current = finishedWork;
                    finishedRoot = current.stateNode;
                    if ("function" === typeof finishedRoot.componentDidMount) try {
                        finishedRoot.componentDidMount();
                    } catch (error) {
                        captureCommitPhaseError(current, current.return, error);
                    }
                    current = finishedWork;
                    finishedRoot = current.updateQueue;
                    if (null !== finishedRoot) {
                        var instance = current.stateNode;
                        try {
                            var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                            if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)callCallback(hiddenCallbacks[finishedRoot], instance);
                        } catch (error) {
                            captureCommitPhaseError(current, current.return, error);
                        }
                    }
                    includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
                    safelyAttachRef(finishedWork, finishedWork.return);
                    break;
                case 26:
                case 27:
                case 5:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    includeWorkInProgressEffects && null === current && flags & 4 && commitHostMount(finishedWork);
                    safelyAttachRef(finishedWork, finishedWork.return);
                    break;
                case 12:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    break;
                case 13:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                    break;
                case 22:
                    null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                    safelyAttachRef(finishedWork, finishedWork.return);
                    break;
                default:
                    recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
            }
            parentFiber = parentFiber.sibling;
        }
    }
    function commitOffscreenPassiveMountEffects(current, finishedWork) {
        var previousCache = null;
        null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
        current = null;
        null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
        current !== previousCache && (null != current && current.refCount++, null != previousCache && releaseCache(previousCache));
    }
    function commitCachePassiveMountEffect(current, finishedWork) {
        current = null;
        null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
        finishedWork = finishedWork.memoizedState.cache;
        finishedWork !== current && (finishedWork.refCount++, null != current && releaseCache(current));
    }
    function recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
        if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
        var flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags & 2048 && commitHookEffectListMount(9, finishedWork);
                break;
            case 3:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
                break;
            case 12:
                if (flags & 2048) {
                    recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                    finishedRoot = finishedWork.stateNode;
                    try {
                        var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                        "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                    } catch (error) {
                        captureCommitPhaseError(finishedWork, finishedWork.return, error);
                    }
                } else recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                break;
            case 23:
                break;
            case 22:
                _finishedWork$memoize2 = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 4 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 4 ? recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 4, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256)));
                flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
        }
    }
    function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
        includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 10256);
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
            switch(finishedWork.tag){
                case 0:
                case 11:
                case 15:
                    recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                    commitHookEffectListMount(8, finishedWork);
                    break;
                case 23:
                    break;
                case 22:
                    var instance = finishedWork.stateNode;
                    null !== finishedWork.memoizedState ? instance._visibility & 4 ? recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 4, recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                    includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                    break;
                case 24:
                    recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                    includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                    break;
                default:
                    recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
            }
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
        if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
            var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
            switch(finishedWork.tag){
                case 22:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                    flags & 2048 && commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                    break;
                case 24:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                    flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                    break;
                default:
                    recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
            }
            parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyAccumulateSuspenseyCommit(parentFiber) {
        if (parentFiber.subtreeFlags & suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)accumulateSuspenseyCommitOnFiber(parentFiber), parentFiber = parentFiber.sibling;
    }
    function accumulateSuspenseyCommitOnFiber(fiber) {
        switch(fiber.tag){
            case 26:
                recursivelyAccumulateSuspenseyCommit(fiber);
                fiber.flags & suspenseyCommitFlag && (null !== fiber.memoizedState ? suspendResource(currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : suspendInstance(fiber.type, fiber.memoizedProps));
                break;
            case 5:
                recursivelyAccumulateSuspenseyCommit(fiber);
                fiber.flags & suspenseyCommitFlag && suspendInstance(fiber.type, fiber.memoizedProps);
                break;
            case 3:
            case 4:
                if (supportsResources) {
                    var previousHoistableRoot = currentHoistableRoot;
                    currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
                    recursivelyAccumulateSuspenseyCommit(fiber);
                    currentHoistableRoot = previousHoistableRoot;
                } else recursivelyAccumulateSuspenseyCommit(fiber);
                break;
            case 22:
                null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(fiber), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(fiber));
                break;
            default:
                recursivelyAccumulateSuspenseyCommit(fiber);
        }
    }
    function detachAlternateSiblings(parentFiber) {
        var previousFiber = parentFiber.alternate;
        if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
            previousFiber.child = null;
            do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
            while (null !== parentFiber);
        }
    }
    function recursivelyTraversePassiveUnmountEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i];
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
            }
            detachAlternateSiblings(parentFiber);
        }
        if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
                break;
            case 3:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                break;
            case 12:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState && instance._visibility & 4 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -5, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
                break;
            default:
                recursivelyTraversePassiveUnmountEffects(finishedWork);
        }
    }
    function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
        var deletions = parentFiber.deletions;
        if (0 !== (parentFiber.flags & 16)) {
            if (null !== deletions) for(var i = 0; i < deletions.length; i++){
                var childToDelete = deletions[i];
                nextEffect = childToDelete;
                commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
            }
            detachAlternateSiblings(parentFiber);
        }
        for(parentFiber = parentFiber.child; null !== parentFiber;){
            deletions = parentFiber;
            switch(deletions.tag){
                case 0:
                case 11:
                case 15:
                    commitHookEffectListUnmount(8, deletions, deletions.return);
                    recursivelyTraverseDisconnectPassiveEffects(deletions);
                    break;
                case 22:
                    i = deletions.stateNode;
                    i._visibility & 4 && (i._visibility &= -5, recursivelyTraverseDisconnectPassiveEffects(deletions));
                    break;
                default:
                    recursivelyTraverseDisconnectPassiveEffects(deletions);
            }
            parentFiber = parentFiber.sibling;
        }
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
        for(; null !== nextEffect;){
            var fiber = nextEffect;
            switch(fiber.tag){
                case 0:
                case 11:
                case 15:
                    commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                    break;
                case 23:
                case 22:
                    if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                        var cache = fiber.memoizedState.cachePool.pool;
                        null != cache && cache.refCount++;
                    }
                    break;
                case 24:
                    releaseCache(fiber.memoizedState.cache);
            }
            cache = fiber.child;
            if (null !== cache) cache.return = fiber, nextEffect = cache;
            else a: for(fiber = deletedSubtreeRoot; null !== nextEffect;){
                cache = nextEffect;
                var sibling = cache.sibling, returnFiber = cache.return;
                detachFiberAfterEffects(cache);
                if (cache === fiber) {
                    nextEffect = null;
                    break a;
                }
                if (null !== sibling) {
                    sibling.return = returnFiber;
                    nextEffect = sibling;
                    break a;
                }
                nextEffect = returnFiber;
            }
        }
    }
    function findFiberRootForHostRoot(hostRoot) {
        var maybeFiber = getInstanceFromNode(hostRoot);
        if (null != maybeFiber) {
            if ("string" !== typeof maybeFiber.memoizedProps["data-testname"]) throw Error(formatProdErrorMessage(364));
            return maybeFiber;
        }
        hostRoot = findFiberRoot(hostRoot);
        if (null === hostRoot) throw Error(formatProdErrorMessage(362));
        return hostRoot.stateNode.current;
    }
    function matchSelector(fiber$jscomp$0, selector) {
        var tag = fiber$jscomp$0.tag;
        switch(selector.$$typeof){
            case COMPONENT_TYPE:
                if (fiber$jscomp$0.type === selector.value) return !0;
                break;
            case HAS_PSEUDO_CLASS_TYPE:
                a: {
                    selector = selector.value;
                    fiber$jscomp$0 = [
                        fiber$jscomp$0,
                        0
                    ];
                    for(tag = 0; tag < fiber$jscomp$0.length;){
                        var fiber = fiber$jscomp$0[tag++], tag$jscomp$0 = fiber.tag, selectorIndex = fiber$jscomp$0[tag++], selector$jscomp$0 = selector[selectorIndex];
                        if (5 !== tag$jscomp$0 && 26 !== tag$jscomp$0 && 27 !== tag$jscomp$0 || !isHiddenSubtree(fiber)) {
                            for(; null != selector$jscomp$0 && matchSelector(fiber, selector$jscomp$0);)selectorIndex++, selector$jscomp$0 = selector[selectorIndex];
                            if (selectorIndex === selector.length) {
                                selector = !0;
                                break a;
                            } else for(fiber = fiber.child; null !== fiber;)fiber$jscomp$0.push(fiber, selectorIndex), fiber = fiber.sibling;
                        }
                    }
                    selector = !1;
                }
                return selector;
            case ROLE_TYPE:
                if ((5 === tag || 26 === tag || 27 === tag) && matchAccessibilityRole(fiber$jscomp$0.stateNode, selector.value)) return !0;
                break;
            case TEXT_TYPE:
                if (5 === tag || 6 === tag || 26 === tag || 27 === tag) {
                    if (fiber$jscomp$0 = getTextContent(fiber$jscomp$0), null !== fiber$jscomp$0 && 0 <= fiber$jscomp$0.indexOf(selector.value)) return !0;
                }
                break;
            case TEST_NAME_TYPE:
                if (5 === tag || 26 === tag || 27 === tag) {
                    if (fiber$jscomp$0 = fiber$jscomp$0.memoizedProps["data-testname"], "string" === typeof fiber$jscomp$0 && fiber$jscomp$0.toLowerCase() === selector.value.toLowerCase()) return !0;
                }
                break;
            default:
                throw Error(formatProdErrorMessage(365));
        }
        return !1;
    }
    function selectorToString(selector) {
        switch(selector.$$typeof){
            case COMPONENT_TYPE:
                return "<" + (getComponentNameFromType(selector.value) || "Unknown") + ">";
            case HAS_PSEUDO_CLASS_TYPE:
                return ":has(" + (selectorToString(selector) || "") + ")";
            case ROLE_TYPE:
                return '[role="' + selector.value + '"]';
            case TEXT_TYPE:
                return '"' + selector.value + '"';
            case TEST_NAME_TYPE:
                return '[data-testname="' + selector.value + '"]';
            default:
                throw Error(formatProdErrorMessage(365));
        }
    }
    function findPaths(root, selectors) {
        var matchingFibers = [];
        root = [
            root,
            0
        ];
        for(var index = 0; index < root.length;){
            var fiber = root[index++], tag = fiber.tag, selectorIndex = root[index++], selector = selectors[selectorIndex];
            if (5 !== tag && 26 !== tag && 27 !== tag || !isHiddenSubtree(fiber)) {
                for(; null != selector && matchSelector(fiber, selector);)selectorIndex++, selector = selectors[selectorIndex];
                if (selectorIndex === selectors.length) matchingFibers.push(fiber);
                else for(fiber = fiber.child; null !== fiber;)root.push(fiber, selectorIndex), fiber = fiber.sibling;
            }
        }
        return matchingFibers;
    }
    function findAllNodes(hostRoot, selectors) {
        if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
        hostRoot = findFiberRootForHostRoot(hostRoot);
        hostRoot = findPaths(hostRoot, selectors);
        selectors = [];
        hostRoot = Array.from(hostRoot);
        for(var index = 0; index < hostRoot.length;){
            var node = hostRoot[index++], tag = node.tag;
            if (5 === tag || 26 === tag || 27 === tag) isHiddenSubtree(node) || selectors.push(node.stateNode);
            else for(node = node.child; null !== node;)hostRoot.push(node), node = node.sibling;
        }
        return selectors;
    }
    function requestUpdateLane() {
        if (0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes) return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
        if (null !== ReactSharedInternals.T) {
            var actionScopeLane = currentEntangledLane;
            return 0 !== actionScopeLane ? actionScopeLane : requestTransitionLane();
        }
        return resolveUpdatePriority();
    }
    function requestDeferredLane() {
        0 === workInProgressDeferredLane && (workInProgressDeferredLane = 0 === (workInProgressRootRenderLanes & 536870912) || isHydrating ? claimNextTransitionLane() : 536870912);
        var suspenseHandler = suspenseHandlerStackCursor.current;
        null !== suspenseHandler && (suspenseHandler.flags |= 32);
        return workInProgressDeferredLane;
    }
    function scheduleUpdateOnFiber(root, fiber, lane) {
        if (root === workInProgressRoot && 2 === workInProgressSuspendedReason || null !== root.cancelPendingCommit) prepareFreshStack(root, 0), markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
        markRootUpdated$1(root, lane);
        if (0 === (executionContext & 2) || root !== workInProgressRoot) root === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(root, workInProgressRootRenderLanes, workInProgressDeferredLane, !1)), ensureRootIsScheduled(root);
    }
    function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
        var shouldTimeSlice = !forceSync && 0 === (lanes & 60) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
        do {
            if (0 === exitStatus) {
                workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, !1);
                break;
            } else if (6 === exitStatus) markRootSuspended(root$jscomp$0, lanes, 0, !workInProgressRootDidSkipSuspendedSiblings);
            else {
                forceSync = root$jscomp$0.current.alternate;
                if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
                    exitStatus = renderRootSync(root$jscomp$0, lanes, !1);
                    renderWasConcurrent = !1;
                    continue;
                }
                if (2 === exitStatus) {
                    renderWasConcurrent = lanes;
                    if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                    else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                    if (0 !== JSCompiler_inline_result) {
                        lanes = JSCompiler_inline_result;
                        a: {
                            var root = root$jscomp$0;
                            exitStatus = workInProgressRootConcurrentErrors;
                            var wasRootDehydrated = supportsHydration && root.current.memoizedState.isDehydrated;
                            wasRootDehydrated && (prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                            JSCompiler_inline_result = renderRootSync(root, JSCompiler_inline_result, !1);
                            if (2 !== JSCompiler_inline_result) {
                                if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                    root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                    workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                    exitStatus = 4;
                                    break a;
                                }
                                renderWasConcurrent = workInProgressRootRecoverableErrors;
                                workInProgressRootRecoverableErrors = exitStatus;
                                null !== renderWasConcurrent && queueRecoverableErrors(renderWasConcurrent);
                            }
                            exitStatus = JSCompiler_inline_result;
                        }
                        renderWasConcurrent = !1;
                        if (2 !== exitStatus) continue;
                    }
                }
                if (1 === exitStatus) {
                    prepareFreshStack(root$jscomp$0, 0);
                    markRootSuspended(root$jscomp$0, lanes, 0, !0);
                    break;
                }
                a: {
                    shouldTimeSlice = root$jscomp$0;
                    switch(exitStatus){
                        case 0:
                        case 1:
                            throw Error(formatProdErrorMessage(345));
                        case 4:
                            if ((lanes & 4194176) === lanes) {
                                markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                                break a;
                            }
                            break;
                        case 2:
                            workInProgressRootRecoverableErrors = null;
                            break;
                        case 3:
                        case 5:
                            break;
                        default:
                            throw Error(formatProdErrorMessage(329));
                    }
                    shouldTimeSlice.finishedWork = forceSync;
                    shouldTimeSlice.finishedLanes = lanes;
                    if ((lanes & 62914560) === lanes && (renderWasConcurrent = globalMostRecentFallbackTime + 300 - now(), 10 < renderWasConcurrent)) {
                        markRootSuspended(shouldTimeSlice, lanes, workInProgressDeferredLane, !workInProgressRootDidSkipSuspendedSiblings);
                        if (0 !== getNextLanes(shouldTimeSlice, 0)) break a;
                        shouldTimeSlice.timeoutHandle = scheduleTimeout(commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, 2, -0, 0), renderWasConcurrent);
                        break a;
                    }
                    commitRootWhenReady(shouldTimeSlice, forceSync, workInProgressRootRecoverableErrors, workInProgressTransitions, workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, workInProgressDeferredLane, workInProgressRootInterleavedUpdatedLanes, workInProgressSuspendedRetryLanes, workInProgressRootDidSkipSuspendedSiblings, 0, -0, 0);
                }
            }
            break;
        }while (1);
        ensureRootIsScheduled(root$jscomp$0);
    }
    function queueRecoverableErrors(errors) {
        null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = errors : workInProgressRootRecoverableErrors.push.apply(workInProgressRootRecoverableErrors, errors);
    }
    function commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        var subtreeFlags = finishedWork.subtreeFlags;
        if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
            if (startSuspendingCommit(), accumulateSuspenseyCommitOnFiber(finishedWork), finishedWork = waitForCommitToBeReady(), null !== finishedWork) {
                root.cancelPendingCommit = finishedWork(commitRoot.bind(null, root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, 1, completedRenderStartTime, completedRenderEndTime));
                markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
                return;
            }
        }
        commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
        for(var node = finishedWork;;){
            var tag = node.tag;
            if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
                var check = tag[i], getSnapshot = check.getSnapshot;
                check = check.value;
                try {
                    if (!objectIs(getSnapshot(), check)) return !1;
                } catch (error) {
                    return !1;
                }
            }
            tag = node.child;
            if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
            else {
                if (node === finishedWork) break;
                for(; null === node.sibling;){
                    if (null === node.return || node.return === finishedWork) return !0;
                    node = node.return;
                }
                node.sibling.return = node.return;
                node = node.sibling;
            }
        }
        return !0;
    }
    function markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
        suspendedLanes &= ~workInProgressRootPingedLanes;
        suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
        root.suspendedLanes |= suspendedLanes;
        root.pingedLanes &= ~suspendedLanes;
        didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
        didAttemptEntireTree = root.expirationTimes;
        for(var lanes = suspendedLanes; 0 < lanes;){
            var index$6 = 31 - clz32(lanes), lane = 1 << index$6;
            didAttemptEntireTree[index$6] = -1;
            lanes &= ~lane;
        }
        0 !== spawnedLane && markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
    }
    function flushSyncWork() {
        return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
    }
    function resetWorkInProgressStack() {
        if (null !== workInProgress) {
            if (0 === workInProgressSuspendedReason) var interruptedWork = workInProgress.return;
            else interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber = null, resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
            for(; null !== interruptedWork;)unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
            workInProgress = null;
        }
    }
    function prepareFreshStack(root, lanes) {
        root.finishedWork = null;
        root.finishedLanes = 0;
        var timeoutHandle = root.timeoutHandle;
        timeoutHandle !== noTimeout && (root.timeoutHandle = noTimeout, cancelTimeout(timeoutHandle));
        timeoutHandle = root.cancelPendingCommit;
        null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
        resetWorkInProgressStack();
        workInProgressRoot = root;
        workInProgress = timeoutHandle = createWorkInProgress(root.current, null);
        workInProgressRootRenderLanes = lanes;
        workInProgressSuspendedReason = 0;
        workInProgressThrownValue = null;
        workInProgressRootDidSkipSuspendedSiblings = !1;
        workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        workInProgressRootDidAttachPingListener = !1;
        workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
        workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
        workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
        0 !== (lanes & 8) && (lanes |= lanes & 32);
        var allEntangledLanes = root.entangledLanes;
        if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
            var index$4 = 31 - clz32(allEntangledLanes), lane = 1 << index$4;
            lanes |= root[index$4];
            allEntangledLanes &= ~lane;
        }
        entangledRenderLanes = lanes;
        finishQueueingConcurrentUpdates();
        return timeoutHandle;
    }
    function handleThrow(root, thrownValue) {
        currentlyRenderingFiber$1 = null;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        thrownValue === SuspenseException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
        workInProgressThrownValue = thrownValue;
        null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current)));
    }
    function shouldRemainOnPreviousScreen() {
        var handler = suspenseHandlerStackCursor.current;
        return null === handler ? !0 : (workInProgressRootRenderLanes & 4194176) === workInProgressRootRenderLanes ? null === shellBoundary ? !0 : !1 : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : !1;
    }
    function pushDispatcher() {
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = ContextOnlyDispatcher;
        return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
    }
    function pushAsyncDispatcher() {
        var prevAsyncDispatcher = ReactSharedInternals.A;
        ReactSharedInternals.A = DefaultAsyncDispatcher;
        return prevAsyncDispatcher;
    }
    function renderDidSuspendDelayIfPossible() {
        workInProgressRootExitStatus = 4;
        workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194176) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = !0);
        0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(workInProgressRoot, workInProgressRootRenderLanes, workInProgressDeferredLane, !1);
    }
    function renderRootSync(root, lanes, shouldYieldForPrerendering) {
        var prevExecutionContext = executionContext;
        executionContext |= 2;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        if (workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes) workInProgressTransitions = null, prepareFreshStack(root, lanes);
        lanes = !1;
        var exitStatus = workInProgressRootExitStatus;
        a: do try {
            if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
                var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
                switch(workInProgressSuspendedReason){
                    case 8:
                        resetWorkInProgressStack();
                        exitStatus = 6;
                        break a;
                    case 3:
                    case 2:
                    case 6:
                        null === suspenseHandlerStackCursor.current && (lanes = !0);
                        var reason = workInProgressSuspendedReason;
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                        if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                            exitStatus = 0;
                            break a;
                        }
                        break;
                    default:
                        reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                }
            }
            workLoopSync();
            exitStatus = workInProgressRootExitStatus;
            break;
        } catch (thrownValue$151) {
            handleThrow(root, thrownValue$151);
        }
        while (1);
        lanes && root.shellSuspendCounter++;
        lastContextDependency = currentlyRenderingFiber = null;
        executionContext = prevExecutionContext;
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
        return exitStatus;
    }
    function workLoopSync() {
        for(; null !== workInProgress;)performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root, lanes) {
        var prevExecutionContext = executionContext;
        executionContext |= 2;
        var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
        workInProgressRoot !== root || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root, lanes);
        a: do try {
            if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
                lanes = workInProgress;
                var thrownValue = workInProgressThrownValue;
                b: switch(workInProgressSuspendedReason){
                    case 1:
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                        break;
                    case 2:
                        if (isThenableResolved(thrownValue)) {
                            workInProgressSuspendedReason = 0;
                            workInProgressThrownValue = null;
                            replaySuspendedUnitOfWork(lanes);
                            break;
                        }
                        lanes = function() {
                            2 === workInProgressSuspendedReason && workInProgressRoot === root && (workInProgressSuspendedReason = 7);
                            ensureRootIsScheduled(root);
                        };
                        thrownValue.then(lanes, lanes);
                        break a;
                    case 3:
                        workInProgressSuspendedReason = 7;
                        break a;
                    case 4:
                        workInProgressSuspendedReason = 5;
                        break a;
                    case 7:
                        isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                        break;
                    case 5:
                        var resource = null;
                        switch(workInProgress.tag){
                            case 26:
                                resource = workInProgress.memoizedState;
                            case 5:
                            case 27:
                                var hostFiber = workInProgress, type = hostFiber.type, props = hostFiber.pendingProps;
                                if (resource ? preloadResource(resource) : preloadInstance(type, props)) {
                                    workInProgressSuspendedReason = 0;
                                    workInProgressThrownValue = null;
                                    var sibling = hostFiber.sibling;
                                    if (null !== sibling) workInProgress = sibling;
                                    else {
                                        var returnFiber = hostFiber.return;
                                        null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                                    }
                                    break b;
                                }
                        }
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                        break;
                    case 6:
                        workInProgressSuspendedReason = 0;
                        workInProgressThrownValue = null;
                        throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                        break;
                    case 8:
                        resetWorkInProgressStack();
                        workInProgressRootExitStatus = 6;
                        break a;
                    default:
                        throw Error(formatProdErrorMessage(462));
                }
            }
            workLoopConcurrent();
            break;
        } catch (thrownValue$153) {
            handleThrow(root, thrownValue$153);
        }
        while (1);
        lastContextDependency = currentlyRenderingFiber = null;
        ReactSharedInternals.H = prevDispatcher;
        ReactSharedInternals.A = prevAsyncDispatcher;
        executionContext = prevExecutionContext;
        if (null !== workInProgress) return 0;
        workInProgressRoot = null;
        workInProgressRootRenderLanes = 0;
        finishQueueingConcurrentUpdates();
        return workInProgressRootExitStatus;
    }
    function workLoopConcurrent() {
        for(; null !== workInProgress && !shouldYield();)performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
        var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
    }
    function replaySuspendedUnitOfWork(unitOfWork) {
        var next = unitOfWork;
        var current = next.alternate;
        switch(next.tag){
            case 15:
            case 0:
                next = replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, workInProgressRootRenderLanes);
                break;
            case 11:
                next = replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, workInProgressRootRenderLanes);
                break;
            case 5:
                resetHooksOnUnwind(next);
            default:
                unwindInterruptedWork(current, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current, next, entangledRenderLanes);
        }
        unitOfWork.memoizedProps = unitOfWork.pendingProps;
        null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
    }
    function throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
        lastContextDependency = currentlyRenderingFiber = null;
        resetHooksOnUnwind(unitOfWork);
        thenableState$1 = null;
        thenableIndexCounter$1 = 0;
        var returnFiber = unitOfWork.return;
        try {
            if (throwException(root, returnFiber, unitOfWork, thrownValue, workInProgressRootRenderLanes)) {
                workInProgressRootExitStatus = 1;
                logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
                workInProgress = null;
                return;
            }
        } catch (error) {
            if (null !== returnFiber) throw workInProgress = returnFiber, error;
            workInProgressRootExitStatus = 1;
            logUncaughtError(root, createCapturedValueAtFiber(thrownValue, root.current));
            workInProgress = null;
            return;
        }
        if (unitOfWork.flags & 32768) {
            if (isHydrating || 1 === suspendedReason) root = !0;
            else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912)) root = !1;
            else if (workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
            unwindUnitOfWork(unitOfWork, root);
        } else completeUnitOfWork(unitOfWork);
    }
    function completeUnitOfWork(unitOfWork) {
        var completedWork = unitOfWork;
        do {
            if (0 !== (completedWork.flags & 32768)) {
                unwindUnitOfWork(completedWork, workInProgressRootDidSkipSuspendedSiblings);
                return;
            }
            unitOfWork = completedWork.return;
            var next = completeWork(completedWork.alternate, completedWork, entangledRenderLanes);
            if (null !== next) {
                workInProgress = next;
                return;
            }
            completedWork = completedWork.sibling;
            if (null !== completedWork) {
                workInProgress = completedWork;
                return;
            }
            workInProgress = completedWork = unitOfWork;
        }while (null !== completedWork);
        0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
    }
    function unwindUnitOfWork(unitOfWork, skipSiblings) {
        do {
            var next = unwindWork(unitOfWork.alternate, unitOfWork);
            if (null !== next) {
                next.flags &= 32767;
                workInProgress = next;
                return;
            }
            next = unitOfWork.return;
            null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
            if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
                workInProgress = unitOfWork;
                return;
            }
            workInProgress = unitOfWork = next;
        }while (null !== unitOfWork);
        workInProgressRootExitStatus = 6;
        workInProgress = null;
    }
    function commitRoot(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
        var prevTransition = ReactSharedInternals.T, previousUpdateLanePriority = getCurrentUpdatePriority();
        try {
            setCurrentUpdatePriority(2), ReactSharedInternals.T = null, commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, previousUpdateLanePriority, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime);
        } finally{
            ReactSharedInternals.T = prevTransition, setCurrentUpdatePriority(previousUpdateLanePriority);
        }
    }
    function commitRootImpl(root, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, renderPriorityLevel, spawnedLane, updatedLanes, suspendedRetryLanes) {
        do flushPassiveEffects();
        while (null !== rootWithPendingPassiveEffects);
        if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(327));
        var finishedWork = root.finishedWork;
        didIncludeRenderPhaseUpdate = root.finishedLanes;
        if (null === finishedWork) return null;
        root.finishedWork = null;
        root.finishedLanes = 0;
        if (finishedWork === root.current) throw Error(formatProdErrorMessage(177));
        root.callbackNode = null;
        root.callbackPriority = 0;
        root.cancelPendingCommit = null;
        var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
        remainingLanes |= concurrentlyUpdatedLanes;
        markRootFinished(root, didIncludeRenderPhaseUpdate, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        0 === (finishedWork.subtreeFlags & 10256) && 0 === (finishedWork.flags & 10256) || rootDoesHavePassiveEffects || (rootDoesHavePassiveEffects = !0, pendingPassiveEffectsRemainingLanes = remainingLanes, pendingPassiveTransitions = transitions, scheduleCallback(NormalPriority$1, function() {
            flushPassiveEffects(!0);
            return null;
        }));
        transitions = 0 !== (finishedWork.flags & 15990);
        0 !== (finishedWork.subtreeFlags & 15990) || transitions ? (transitions = ReactSharedInternals.T, ReactSharedInternals.T = null, spawnedLane = getCurrentUpdatePriority(), setCurrentUpdatePriority(2), updatedLanes = executionContext, executionContext |= 4, commitBeforeMutationEffects(root, finishedWork), commitMutationEffectsOnFiber(finishedWork, root), resetAfterCommit(root.containerInfo), root.current = finishedWork, commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork), requestPaint(), executionContext = updatedLanes, setCurrentUpdatePriority(spawnedLane), ReactSharedInternals.T = transitions) : root.current = finishedWork;
        rootDoesHavePassiveEffects ? (rootDoesHavePassiveEffects = !1, rootWithPendingPassiveEffects = root, pendingPassiveEffectsLanes = didIncludeRenderPhaseUpdate) : releaseRootPooledCache(root, remainingLanes);
        remainingLanes = root.pendingLanes;
        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
        onCommitRoot(finishedWork.stateNode, renderPriorityLevel);
        ensureRootIsScheduled(root);
        if (null !== recoverableErrors) for(renderPriorityLevel = root.onRecoverableError, finishedWork = 0; finishedWork < recoverableErrors.length; finishedWork++)remainingLanes = recoverableErrors[finishedWork], renderPriorityLevel(remainingLanes.value, {
            componentStack: remainingLanes.stack
        });
        0 !== (pendingPassiveEffectsLanes & 3) && flushPassiveEffects();
        remainingLanes = root.pendingLanes;
        0 !== (didIncludeRenderPhaseUpdate & 4194218) && 0 !== (remainingLanes & 42) ? root === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root) : nestedUpdateCount = 0;
        flushSyncWorkAcrossRoots_impl(0, !1);
        return null;
    }
    function releaseRootPooledCache(root, remainingLanes) {
        0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, releaseCache(remainingLanes)));
    }
    function flushPassiveEffects() {
        if (null !== rootWithPendingPassiveEffects) {
            var root = rootWithPendingPassiveEffects, remainingLanes = pendingPassiveEffectsRemainingLanes;
            pendingPassiveEffectsRemainingLanes = 0;
            var renderPriority = lanesToEventPriority(pendingPassiveEffectsLanes), priority = 32 > renderPriority ? 32 : renderPriority;
            renderPriority = ReactSharedInternals.T;
            var previousPriority = getCurrentUpdatePriority();
            try {
                setCurrentUpdatePriority(priority);
                ReactSharedInternals.T = null;
                if (null === rootWithPendingPassiveEffects) var JSCompiler_inline_result = !1;
                else {
                    priority = pendingPassiveTransitions;
                    pendingPassiveTransitions = null;
                    var root$jscomp$0 = rootWithPendingPassiveEffects, lanes = pendingPassiveEffectsLanes;
                    rootWithPendingPassiveEffects = null;
                    pendingPassiveEffectsLanes = 0;
                    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage(331));
                    var prevExecutionContext = executionContext;
                    executionContext |= 4;
                    commitPassiveUnmountOnFiber(root$jscomp$0.current);
                    commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, priority);
                    executionContext = prevExecutionContext;
                    flushSyncWorkAcrossRoots_impl(0, !1);
                    if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot) try {
                        injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
                    } catch (err) {}
                    JSCompiler_inline_result = !0;
                }
                return JSCompiler_inline_result;
            } finally{
                setCurrentUpdatePriority(previousPriority), ReactSharedInternals.T = renderPriority, releaseRootPooledCache(root, remainingLanes);
            }
        }
        return !1;
    }
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
        sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
        sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
        rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
        null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
        if (3 === sourceFiber.tag) captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
        else for(; null !== nearestMountedAncestor;){
            if (3 === nearestMountedAncestor.tag) {
                captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
                break;
            } else if (1 === nearestMountedAncestor.tag) {
                var instance = nearestMountedAncestor.stateNode;
                if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
                    error = createClassErrorUpdate(2);
                    instance = enqueueUpdate(nearestMountedAncestor, error, 2);
                    null !== instance && (initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
                    break;
                }
            }
            nearestMountedAncestor = nearestMountedAncestor.return;
        }
    }
    function attachPingListener(root, wakeable, lanes) {
        var pingCache = root.pingCache;
        if (null === pingCache) {
            pingCache = root.pingCache = new PossiblyWeakMap();
            var threadIDs = new Set();
            pingCache.set(wakeable, threadIDs);
        } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
        threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
    }
    function pingSuspendedRoot(root, wakeable, pingedLanes) {
        var pingCache = root.pingCache;
        null !== pingCache && pingCache.delete(wakeable);
        root.pingedLanes |= root.suspendedLanes & pingedLanes;
        root.warmLanes &= ~pingedLanes;
        workInProgressRoot === root && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
        ensureRootIsScheduled(root);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
        0 === retryLane && (retryLane = claimNextRetryLane());
        boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
        null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
        var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
        null !== suspenseState && (retryLane = suspenseState.retryLane);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
        var retryLane = 0;
        switch(boundaryFiber.tag){
            case 13:
                var retryCache = boundaryFiber.stateNode;
                var suspenseState = boundaryFiber.memoizedState;
                null !== suspenseState && (retryLane = suspenseState.retryLane);
                break;
            case 19:
                retryCache = boundaryFiber.stateNode;
                break;
            case 22:
                retryCache = boundaryFiber.stateNode._retryCache;
                break;
            default:
                throw Error(formatProdErrorMessage(314));
        }
        null !== retryCache && retryCache.delete(wakeable);
        retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function scheduleCallback(priorityLevel, callback) {
        return scheduleCallback$3(priorityLevel, callback);
    }
    function FiberNode(tag, pendingProps, key, mode) {
        this.tag = tag;
        this.key = key;
        this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
        this.index = 0;
        this.refCleanup = this.ref = null;
        this.pendingProps = pendingProps;
        this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
        this.mode = mode;
        this.subtreeFlags = this.flags = 0;
        this.deletions = null;
        this.childLanes = this.lanes = 0;
        this.alternate = null;
    }
    function shouldConstruct(Component) {
        Component = Component.prototype;
        return !(!Component || !Component.isReactComponent);
    }
    function createWorkInProgress(current, pendingProps) {
        var workInProgress = current.alternate;
        null === workInProgress ? (workInProgress = createFiber(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
        workInProgress.flags = current.flags & 31457280;
        workInProgress.childLanes = current.childLanes;
        workInProgress.lanes = current.lanes;
        workInProgress.child = current.child;
        workInProgress.memoizedProps = current.memoizedProps;
        workInProgress.memoizedState = current.memoizedState;
        workInProgress.updateQueue = current.updateQueue;
        pendingProps = current.dependencies;
        workInProgress.dependencies = null === pendingProps ? null : {
            lanes: pendingProps.lanes,
            firstContext: pendingProps.firstContext
        };
        workInProgress.sibling = current.sibling;
        workInProgress.index = current.index;
        workInProgress.ref = current.ref;
        workInProgress.refCleanup = current.refCleanup;
        return workInProgress;
    }
    function resetWorkInProgress(workInProgress, renderLanes) {
        workInProgress.flags &= 31457282;
        var current = workInProgress.alternate;
        null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
            lanes: renderLanes.lanes,
            firstContext: renderLanes.firstContext
        });
        return workInProgress;
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
        var fiberTag = 0;
        owner = type;
        if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
        else if ("string" === typeof type) fiberTag = supportsResources && supportsSingletons ? isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : isHostSingletonType(type) ? 27 : 5 : supportsResources ? isHostHoistableType(type, pendingProps, contextStackCursor.current) ? 26 : 5 : supportsSingletons ? isHostSingletonType(type) ? 27 : 5 : 5;
        else a: switch(type){
            case REACT_FRAGMENT_TYPE:
                return createFiberFromFragment(pendingProps.children, mode, lanes, key);
            case REACT_STRICT_MODE_TYPE:
                fiberTag = 8;
                mode |= 24;
                break;
            case REACT_PROFILER_TYPE:
                return type = createFiber(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
            case REACT_SUSPENSE_TYPE:
                return type = createFiber(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
            case REACT_SUSPENSE_LIST_TYPE:
                return type = createFiber(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
            case REACT_OFFSCREEN_TYPE:
                return createFiberFromOffscreen(pendingProps, mode, lanes, key);
            default:
                if ("object" === typeof type && null !== type) switch(type.$$typeof){
                    case REACT_PROVIDER_TYPE:
                    case REACT_CONTEXT_TYPE:
                        fiberTag = 10;
                        break a;
                    case REACT_CONSUMER_TYPE:
                        fiberTag = 9;
                        break a;
                    case REACT_FORWARD_REF_TYPE:
                        fiberTag = 11;
                        break a;
                    case REACT_MEMO_TYPE:
                        fiberTag = 14;
                        break a;
                    case REACT_LAZY_TYPE:
                        fiberTag = 16;
                        owner = null;
                        break a;
                }
                fiberTag = 29;
                pendingProps = Error(formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
                owner = null;
        }
        key = createFiber(fiberTag, pendingProps, key, mode);
        key.elementType = type;
        key.type = owner;
        key.lanes = lanes;
        return key;
    }
    function createFiberFromFragment(elements, mode, lanes, key) {
        elements = createFiber(7, elements, key, mode);
        elements.lanes = lanes;
        return elements;
    }
    function createFiberFromOffscreen(pendingProps, mode, lanes, key) {
        pendingProps = createFiber(22, pendingProps, key, mode);
        pendingProps.elementType = REACT_OFFSCREEN_TYPE;
        pendingProps.lanes = lanes;
        var primaryChildInstance = {
            _visibility: 1,
            _pendingVisibility: 1,
            _pendingMarkers: null,
            _retryCache: null,
            _transitions: null,
            _current: null,
            detach: function() {
                var fiber = primaryChildInstance._current;
                if (null === fiber) throw Error(formatProdErrorMessage(456));
                if (0 === (primaryChildInstance._pendingVisibility & 2)) {
                    var root = enqueueConcurrentRenderForLane(fiber, 2);
                    null !== root && (primaryChildInstance._pendingVisibility |= 2, scheduleUpdateOnFiber(root, fiber, 2));
                }
            },
            attach: function() {
                var fiber = primaryChildInstance._current;
                if (null === fiber) throw Error(formatProdErrorMessage(456));
                if (0 !== (primaryChildInstance._pendingVisibility & 2)) {
                    var root = enqueueConcurrentRenderForLane(fiber, 2);
                    null !== root && (primaryChildInstance._pendingVisibility &= -3, scheduleUpdateOnFiber(root, fiber, 2));
                }
            }
        };
        pendingProps.stateNode = primaryChildInstance;
        return pendingProps;
    }
    function createFiberFromText(content, mode, lanes) {
        content = createFiber(6, content, null, mode);
        content.lanes = lanes;
        return content;
    }
    function createFiberFromPortal(portal, mode, lanes) {
        mode = createFiber(4, null !== portal.children ? portal.children : [], portal.key, mode);
        mode.lanes = lanes;
        mode.stateNode = {
            containerInfo: portal.containerInfo,
            pendingChildren: null,
            implementation: portal.implementation
        };
        return mode;
    }
    function FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState) {
        this.tag = 1;
        this.containerInfo = containerInfo;
        this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
        this.timeoutHandle = noTimeout;
        this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
        this.callbackPriority = 0;
        this.expirationTimes = createLaneMap(-1);
        this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.finishedLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
        this.entanglements = createLaneMap(0);
        this.hiddenUpdates = createLaneMap(null);
        this.identifierPrefix = identifierPrefix;
        this.onUncaughtError = onUncaughtError;
        this.onCaughtError = onCaughtError;
        this.onRecoverableError = onRecoverableError;
        this.pooledCache = null;
        this.pooledCacheLanes = 0;
        this.formState = formState;
        this.incompleteTransitions = new Map();
    }
    function createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
        containerInfo = new FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, formState);
        tag = 1;
        !0 === isStrictMode && (tag |= 24);
        isStrictMode = createFiber(3, null, null, tag);
        containerInfo.current = isStrictMode;
        isStrictMode.stateNode = containerInfo;
        tag = createCache();
        tag.refCount++;
        containerInfo.pooledCache = tag;
        tag.refCount++;
        isStrictMode.memoizedState = {
            element: initialChildren,
            isDehydrated: hydrate,
            cache: tag
        };
        initializeUpdateQueue(isStrictMode);
        return containerInfo;
    }
    function getContextForSubtree(parentComponent) {
        if (!parentComponent) return emptyContextObject;
        parentComponent = emptyContextObject;
        return parentComponent;
    }
    function findHostInstance(component) {
        var fiber = component._reactInternals;
        if (void 0 === fiber) {
            if ("function" === typeof component.render) throw Error(formatProdErrorMessage(188));
            component = Object.keys(component).join(",");
            throw Error(formatProdErrorMessage(268, component));
        }
        component = findCurrentFiberUsingSlowPath(fiber);
        component = null !== component ? findCurrentHostFiberImpl(component) : null;
        return null === component ? null : getPublicInstance(component.stateNode);
    }
    function updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
        parentComponent = getContextForSubtree(parentComponent);
        null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
        container = createUpdate(lane);
        container.payload = {
            element: element
        };
        callback = void 0 === callback ? null : callback;
        null !== callback && (container.callback = callback);
        element = enqueueUpdate(rootFiber, container, lane);
        null !== element && (scheduleUpdateOnFiber(element, rootFiber, lane), entangleTransitions(element, rootFiber, lane));
    }
    function markRetryLaneImpl(fiber, retryLane) {
        fiber = fiber.memoizedState;
        if (null !== fiber && null !== fiber.dehydrated) {
            var a = fiber.retryLane;
            fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
        }
    }
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
        markRetryLaneImpl(fiber, retryLane);
        (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
    }
    var exports = {};
    "use strict";
    var React = require("43c297beba254329"), Scheduler = require("8feb0ca1d3bca557"), assign = Object.assign, REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_PROVIDER_TYPE = Symbol.for("react.provider"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy");
    Symbol.for("react.scope");
    Symbol.for("react.debug_trace_mode");
    var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
    Symbol.for("react.legacy_hidden");
    Symbol.for("react.tracing_marker");
    var REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), MAYBE_ITERATOR_SYMBOL = Symbol.iterator, REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference"), ReactSharedInternals = React.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, prefix, suffix, reentry = !1, isArrayImpl = Array.isArray, rendererVersion = $$$config.rendererVersion, rendererPackageName = $$$config.rendererPackageName, extraDevToolsConfig = $$$config.extraDevToolsConfig, getPublicInstance = $$$config.getPublicInstance, getRootHostContext = $$$config.getRootHostContext, getChildHostContext = $$$config.getChildHostContext, prepareForCommit = $$$config.prepareForCommit, resetAfterCommit = $$$config.resetAfterCommit, createInstance = $$$config.createInstance, appendInitialChild = $$$config.appendInitialChild, finalizeInitialChildren = $$$config.finalizeInitialChildren, shouldSetTextContent = $$$config.shouldSetTextContent, createTextInstance = $$$config.createTextInstance, scheduleTimeout = $$$config.scheduleTimeout, cancelTimeout = $$$config.cancelTimeout, noTimeout = $$$config.noTimeout, isPrimaryRenderer = $$$config.isPrimaryRenderer;
    $$$config.warnsIfNotActing;
    var supportsMutation = $$$config.supportsMutation, supportsPersistence = $$$config.supportsPersistence, supportsHydration = $$$config.supportsHydration, getInstanceFromNode = $$$config.getInstanceFromNode;
    $$$config.beforeActiveInstanceBlur;
    $$$config.afterActiveInstanceBlur;
    var preparePortalMount = $$$config.preparePortalMount;
    $$$config.prepareScopeUpdate;
    $$$config.getInstanceFromScope;
    var setCurrentUpdatePriority = $$$config.setCurrentUpdatePriority, getCurrentUpdatePriority = $$$config.getCurrentUpdatePriority, resolveUpdatePriority = $$$config.resolveUpdatePriority;
    $$$config.resolveEventType;
    $$$config.resolveEventTimeStamp;
    var shouldAttemptEagerTransition = $$$config.shouldAttemptEagerTransition, detachDeletedInstance = $$$config.detachDeletedInstance;
    $$$config.requestPostPaintCallback;
    var maySuspendCommit = $$$config.maySuspendCommit, preloadInstance = $$$config.preloadInstance, startSuspendingCommit = $$$config.startSuspendingCommit, suspendInstance = $$$config.suspendInstance, waitForCommitToBeReady = $$$config.waitForCommitToBeReady, NotPendingTransition = $$$config.NotPendingTransition, HostTransitionContext = $$$config.HostTransitionContext, resetFormInstance = $$$config.resetFormInstance;
    $$$config.bindToConsole;
    var supportsMicrotasks = $$$config.supportsMicrotasks, scheduleMicrotask = $$$config.scheduleMicrotask, supportsTestSelectors = $$$config.supportsTestSelectors, findFiberRoot = $$$config.findFiberRoot, getBoundingRect = $$$config.getBoundingRect, getTextContent = $$$config.getTextContent, isHiddenSubtree = $$$config.isHiddenSubtree, matchAccessibilityRole = $$$config.matchAccessibilityRole, setFocusIfFocusable = $$$config.setFocusIfFocusable, setupIntersectionObserver = $$$config.setupIntersectionObserver, appendChild = $$$config.appendChild, appendChildToContainer = $$$config.appendChildToContainer, commitTextUpdate = $$$config.commitTextUpdate, commitMount = $$$config.commitMount, commitUpdate = $$$config.commitUpdate, insertBefore = $$$config.insertBefore, insertInContainerBefore = $$$config.insertInContainerBefore, removeChild = $$$config.removeChild, removeChildFromContainer = $$$config.removeChildFromContainer, resetTextContent = $$$config.resetTextContent, hideInstance = $$$config.hideInstance, hideTextInstance = $$$config.hideTextInstance, unhideInstance = $$$config.unhideInstance, unhideTextInstance = $$$config.unhideTextInstance, clearContainer = $$$config.clearContainer, cloneInstance = $$$config.cloneInstance, createContainerChildSet = $$$config.createContainerChildSet, appendChildToContainerChildSet = $$$config.appendChildToContainerChildSet, finalizeContainerChildren = $$$config.finalizeContainerChildren, replaceContainerChildren = $$$config.replaceContainerChildren, cloneHiddenInstance = $$$config.cloneHiddenInstance, cloneHiddenTextInstance = $$$config.cloneHiddenTextInstance, isSuspenseInstancePending = $$$config.isSuspenseInstancePending, isSuspenseInstanceFallback = $$$config.isSuspenseInstanceFallback, getSuspenseInstanceFallbackErrorDetails = $$$config.getSuspenseInstanceFallbackErrorDetails, registerSuspenseInstanceRetry = $$$config.registerSuspenseInstanceRetry, canHydrateFormStateMarker = $$$config.canHydrateFormStateMarker, isFormStateMarkerMatching = $$$config.isFormStateMarkerMatching, getNextHydratableSibling = $$$config.getNextHydratableSibling, getFirstHydratableChild = $$$config.getFirstHydratableChild, getFirstHydratableChildWithinContainer = $$$config.getFirstHydratableChildWithinContainer, getFirstHydratableChildWithinSuspenseInstance = $$$config.getFirstHydratableChildWithinSuspenseInstance, canHydrateInstance = $$$config.canHydrateInstance, canHydrateTextInstance = $$$config.canHydrateTextInstance, canHydrateSuspenseInstance = $$$config.canHydrateSuspenseInstance, hydrateInstance = $$$config.hydrateInstance, hydrateTextInstance = $$$config.hydrateTextInstance, hydrateSuspenseInstance = $$$config.hydrateSuspenseInstance, getNextHydratableInstanceAfterSuspenseInstance = $$$config.getNextHydratableInstanceAfterSuspenseInstance, commitHydratedContainer = $$$config.commitHydratedContainer, commitHydratedSuspenseInstance = $$$config.commitHydratedSuspenseInstance, clearSuspenseBoundary = $$$config.clearSuspenseBoundary, clearSuspenseBoundaryFromContainer = $$$config.clearSuspenseBoundaryFromContainer, shouldDeleteUnhydratedTailInstances = $$$config.shouldDeleteUnhydratedTailInstances;
    $$$config.diffHydratedPropsForDevWarnings;
    $$$config.diffHydratedTextForDevWarnings;
    $$$config.describeHydratableInstanceForDevWarnings;
    var validateHydratableInstance = $$$config.validateHydratableInstance, validateHydratableTextInstance = $$$config.validateHydratableTextInstance, supportsResources = $$$config.supportsResources, isHostHoistableType = $$$config.isHostHoistableType, getHoistableRoot = $$$config.getHoistableRoot, getResource = $$$config.getResource, acquireResource = $$$config.acquireResource, releaseResource = $$$config.releaseResource, hydrateHoistable = $$$config.hydrateHoistable, mountHoistable = $$$config.mountHoistable, unmountHoistable = $$$config.unmountHoistable, createHoistableInstance = $$$config.createHoistableInstance, prepareToCommitHoistables = $$$config.prepareToCommitHoistables, mayResourceSuspendCommit = $$$config.mayResourceSuspendCommit, preloadResource = $$$config.preloadResource, suspendResource = $$$config.suspendResource, supportsSingletons = $$$config.supportsSingletons, resolveSingletonInstance = $$$config.resolveSingletonInstance, clearSingleton = $$$config.clearSingleton, acquireSingletonInstance = $$$config.acquireSingletonInstance, releaseSingletonInstance = $$$config.releaseSingletonInstance, isHostSingletonType = $$$config.isHostSingletonType, valueStack = [], index$jscomp$0 = -1, emptyContextObject = {}, clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log$1 = Math.log, LN2 = Math.LN2, nextTransitionLane = 128, nextRetryLane = 4194304, scheduleCallback$3 = Scheduler.unstable_scheduleCallback, cancelCallback$1 = Scheduler.unstable_cancelCallback, shouldYield = Scheduler.unstable_shouldYield, requestPaint = Scheduler.unstable_requestPaint, now = Scheduler.unstable_now, ImmediatePriority = Scheduler.unstable_ImmediatePriority, UserBlockingPriority = Scheduler.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler.unstable_NormalPriority, IdlePriority = Scheduler.unstable_IdlePriority, log = Scheduler.log, unstable_setDisableYieldValue = Scheduler.unstable_setDisableYieldValue, rendererID = null, injectedHook = null, objectIs = "function" === typeof Object.is ? Object.is : is, CapturedStacks = new WeakMap(), forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "", contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null), hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = !1, hydrationErrors = null, rootOrSingletonContext = !1, HydrationMismatchException = Error(formatProdErrorMessage(519)), concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0, firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = !1, mightHavePendingSyncWork = !1, isFlushingWork = !1, currentEventTransitionLane = 0, currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null, hasForceUpdate = !1, didReadFromEntangledAsyncAction = !1, hasOwnProperty = Object.prototype.hasOwnProperty, SuspenseException = Error(formatProdErrorMessage(460)), SuspenseyCommitException = Error(formatProdErrorMessage(474)), noopSuspenseyCommitThenable = {
        then: function() {}
    }, suspendedThenable = null, thenableState$1 = null, thenableIndexCounter$1 = 0, reconcileChildFibers = createChildReconciler(!0), mountChildFibers = createChildReconciler(!1), currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null, suspenseStackCursor = createCursor(0), renderLanes = 0, currentlyRenderingFiber$1 = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = !1, didScheduleRenderPhaseUpdateDuringThisPass = !1, shouldDoubleInvokeUserFnsInHooksDEV = !1, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0;
    var createFunctionComponentUpdateQueue = function() {
        return {
            lastEffect: null,
            events: null,
            stores: null,
            memoCache: null
        };
    };
    var ContextOnlyDispatcher = {
        readContext: readContext,
        use: use,
        useCallback: throwInvalidHookError,
        useContext: throwInvalidHookError,
        useEffect: throwInvalidHookError,
        useImperativeHandle: throwInvalidHookError,
        useLayoutEffect: throwInvalidHookError,
        useInsertionEffect: throwInvalidHookError,
        useMemo: throwInvalidHookError,
        useReducer: throwInvalidHookError,
        useRef: throwInvalidHookError,
        useState: throwInvalidHookError,
        useDebugValue: throwInvalidHookError,
        useDeferredValue: throwInvalidHookError,
        useTransition: throwInvalidHookError,
        useSyncExternalStore: throwInvalidHookError,
        useId: throwInvalidHookError
    };
    ContextOnlyDispatcher.useCacheRefresh = throwInvalidHookError;
    ContextOnlyDispatcher.useMemoCache = throwInvalidHookError;
    ContextOnlyDispatcher.useHostTransitionStatus = throwInvalidHookError;
    ContextOnlyDispatcher.useFormState = throwInvalidHookError;
    ContextOnlyDispatcher.useActionState = throwInvalidHookError;
    ContextOnlyDispatcher.useOptimistic = throwInvalidHookError;
    var HooksDispatcherOnMount = {
        readContext: readContext,
        use: use,
        useCallback: function(callback, deps) {
            mountWorkInProgressHook().memoizedState = [
                callback,
                void 0 === deps ? null : deps
            ];
            return callback;
        },
        useContext: readContext,
        useEffect: mountEffect,
        useImperativeHandle: function(ref, create, deps) {
            deps = null !== deps && void 0 !== deps ? deps.concat([
                ref
            ]) : null;
            mountEffectImpl(4194308, 4, imperativeHandleEffect.bind(null, create, ref), deps);
        },
        useLayoutEffect: function(create, deps) {
            return mountEffectImpl(4194308, 4, create, deps);
        },
        useInsertionEffect: function(create, deps) {
            mountEffectImpl(4, 2, create, deps);
        },
        useMemo: function(nextCreate, deps) {
            var hook = mountWorkInProgressHook();
            deps = void 0 === deps ? null : deps;
            var nextValue = nextCreate();
            if (shouldDoubleInvokeUserFnsInHooksDEV) {
                setIsStrictModeForDevtools(!0);
                try {
                    nextCreate();
                } finally{
                    setIsStrictModeForDevtools(!1);
                }
            }
            hook.memoizedState = [
                nextValue,
                deps
            ];
            return nextValue;
        },
        useReducer: function(reducer, initialArg, init) {
            var hook = mountWorkInProgressHook();
            if (void 0 !== init) {
                var initialState = init(initialArg);
                if (shouldDoubleInvokeUserFnsInHooksDEV) {
                    setIsStrictModeForDevtools(!0);
                    try {
                        init(initialArg);
                    } finally{
                        setIsStrictModeForDevtools(!1);
                    }
                }
            } else initialState = initialArg;
            hook.memoizedState = hook.baseState = initialState;
            reducer = {
                pending: null,
                lanes: 0,
                dispatch: null,
                lastRenderedReducer: reducer,
                lastRenderedState: initialState
            };
            hook.queue = reducer;
            reducer = reducer.dispatch = dispatchReducerAction.bind(null, currentlyRenderingFiber$1, reducer);
            return [
                hook.memoizedState,
                reducer
            ];
        },
        useRef: function(initialValue) {
            var hook = mountWorkInProgressHook();
            initialValue = {
                current: initialValue
            };
            return hook.memoizedState = initialValue;
        },
        useState: function(initialState) {
            initialState = mountStateImpl(initialState);
            var queue = initialState.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber$1, queue);
            queue.dispatch = dispatch;
            return [
                initialState.memoizedState,
                dispatch
            ];
        },
        useDebugValue: mountDebugValue,
        useDeferredValue: function(value, initialValue) {
            var hook = mountWorkInProgressHook();
            return mountDeferredValueImpl(hook, value, initialValue);
        },
        useTransition: function() {
            var stateHook = mountStateImpl(!1);
            stateHook = startTransition.bind(null, currentlyRenderingFiber$1, stateHook.queue, !0, !1);
            mountWorkInProgressHook().memoizedState = stateHook;
            return [
                !1,
                stateHook
            ];
        },
        useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
            var fiber = currentlyRenderingFiber$1, hook = mountWorkInProgressHook();
            if (isHydrating) {
                if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage(407));
                getServerSnapshot = getServerSnapshot();
            } else {
                getServerSnapshot = getSnapshot();
                if (null === workInProgressRoot) throw Error(formatProdErrorMessage(349));
                0 !== (workInProgressRootRenderLanes & 60) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
            }
            hook.memoizedState = getServerSnapshot;
            var inst = {
                value: getServerSnapshot,
                getSnapshot: getSnapshot
            };
            hook.queue = inst;
            mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe), [
                subscribe
            ]);
            fiber.flags |= 2048;
            pushEffect(9, updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), {
                destroy: void 0
            }, null);
            return getServerSnapshot;
        },
        useId: function() {
            var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
            if (isHydrating) {
                var JSCompiler_inline_result = treeContextOverflow;
                var idWithLeadingBit = treeContextId;
                JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
                identifierPrefix = ":" + identifierPrefix + "R" + JSCompiler_inline_result;
                JSCompiler_inline_result = localIdCounter++;
                0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
                identifierPrefix += ":";
            } else JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = ":" + identifierPrefix + "r" + JSCompiler_inline_result.toString(32) + ":";
            return hook.memoizedState = identifierPrefix;
        },
        useCacheRefresh: function() {
            return mountWorkInProgressHook().memoizedState = refreshCache.bind(null, currentlyRenderingFiber$1);
        }
    };
    HooksDispatcherOnMount.useMemoCache = useMemoCache;
    HooksDispatcherOnMount.useHostTransitionStatus = useHostTransitionStatus;
    HooksDispatcherOnMount.useFormState = mountActionState;
    HooksDispatcherOnMount.useActionState = mountActionState;
    HooksDispatcherOnMount.useOptimistic = function(passthrough) {
        var hook = mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = dispatchOptimisticSetState.bind(null, currentlyRenderingFiber$1, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    };
    var HooksDispatcherOnUpdate = {
        readContext: readContext,
        use: use,
        useCallback: updateCallback,
        useContext: readContext,
        useEffect: updateEffect,
        useImperativeHandle: updateImperativeHandle,
        useInsertionEffect: updateInsertionEffect,
        useLayoutEffect: updateLayoutEffect,
        useMemo: updateMemo,
        useReducer: updateReducer,
        useRef: updateRef,
        useState: function() {
            return updateReducer(basicStateReducer);
        },
        useDebugValue: mountDebugValue,
        useDeferredValue: function(value, initialValue) {
            var hook = updateWorkInProgressHook();
            return updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
        },
        useTransition: function() {
            var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
            return [
                "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
                start
            ];
        },
        useSyncExternalStore: updateSyncExternalStore,
        useId: updateId
    };
    HooksDispatcherOnUpdate.useCacheRefresh = updateRefresh;
    HooksDispatcherOnUpdate.useMemoCache = useMemoCache;
    HooksDispatcherOnUpdate.useHostTransitionStatus = useHostTransitionStatus;
    HooksDispatcherOnUpdate.useFormState = updateActionState;
    HooksDispatcherOnUpdate.useActionState = updateActionState;
    HooksDispatcherOnUpdate.useOptimistic = function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    };
    var HooksDispatcherOnRerender = {
        readContext: readContext,
        use: use,
        useCallback: updateCallback,
        useContext: readContext,
        useEffect: updateEffect,
        useImperativeHandle: updateImperativeHandle,
        useInsertionEffect: updateInsertionEffect,
        useLayoutEffect: updateLayoutEffect,
        useMemo: updateMemo,
        useReducer: rerenderReducer,
        useRef: updateRef,
        useState: function() {
            return rerenderReducer(basicStateReducer);
        },
        useDebugValue: mountDebugValue,
        useDeferredValue: function(value, initialValue) {
            var hook = updateWorkInProgressHook();
            return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(hook, currentHook.memoizedState, value, initialValue);
        },
        useTransition: function() {
            var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
            return [
                "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
                start
            ];
        },
        useSyncExternalStore: updateSyncExternalStore,
        useId: updateId
    };
    HooksDispatcherOnRerender.useCacheRefresh = updateRefresh;
    HooksDispatcherOnRerender.useMemoCache = useMemoCache;
    HooksDispatcherOnRerender.useHostTransitionStatus = useHostTransitionStatus;
    HooksDispatcherOnRerender.useFormState = rerenderActionState;
    HooksDispatcherOnRerender.useActionState = rerenderActionState;
    HooksDispatcherOnRerender.useOptimistic = function(passthrough, reducer) {
        var hook = updateWorkInProgressHook();
        if (null !== currentHook) return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    };
    var classComponentUpdater = {
        isMounted: function(component) {
            return (component = component._reactInternals) ? getNearestMountedFiber(component) === component : !1;
        },
        enqueueSetState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(), update = createUpdate(lane);
            update.payload = payload;
            void 0 !== callback && null !== callback && (update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueReplaceState: function(inst, payload, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(), update = createUpdate(lane);
            update.tag = 1;
            update.payload = payload;
            void 0 !== callback && null !== callback && (update.callback = callback);
            payload = enqueueUpdate(inst, update, lane);
            null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
        },
        enqueueForceUpdate: function(inst, callback) {
            inst = inst._reactInternals;
            var lane = requestUpdateLane(), update = createUpdate(lane);
            update.tag = 2;
            void 0 !== callback && null !== callback && (update.callback = callback);
            callback = enqueueUpdate(inst, update, lane);
            null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
        }
    }, reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
        if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
            var event = new window.ErrorEvent("error", {
                bubbles: !0,
                cancelable: !0,
                message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
                error: error
            });
            if (!window.dispatchEvent(event)) return;
        }
        console.error(error);
    }, SelectiveHydrationException = Error(formatProdErrorMessage(461)), didReceiveUpdate = !1, SUSPENDED_MARKER = {
        dehydrated: null,
        treeContext: null,
        retryLane: 0
    }, valueCursor = createCursor(null), currentlyRenderingFiber = null, lastContextDependency = null, AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
        var listeners = [], signal = this.signal = {
            aborted: !1,
            addEventListener: function(type, listener) {
                listeners.push(listener);
            }
        };
        this.abort = function() {
            signal.aborted = !0;
            listeners.forEach(function(listener) {
                return listener();
            });
        };
    }, scheduleCallback$1 = Scheduler.unstable_scheduleCallback, NormalPriority = Scheduler.unstable_NormalPriority, CacheContext = {
        $$typeof: REACT_CONTEXT_TYPE,
        Consumer: null,
        Provider: null,
        _currentValue: null,
        _currentValue2: null,
        _threadCount: 0
    }, prevOnStartTransitionFinish = ReactSharedInternals.S;
    ReactSharedInternals.S = function(transition, returnValue) {
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
        null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
    };
    var resumedCache = createCursor(null), offscreenSubtreeIsHidden = !1, offscreenSubtreeWasHidden = !1, needsFormReset = !1, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null, shouldFireAfterActiveInstanceBlur = !1, hostParent = null, hostParentIsContainer = !1, currentHoistableRoot = null, suspenseyCommitFlag = 8192, DefaultAsyncDispatcher = {
        getCacheForType: function(resourceType) {
            var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
            void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
            return cacheForType;
        }
    }, COMPONENT_TYPE = 0, HAS_PSEUDO_CLASS_TYPE = 1, ROLE_TYPE = 2, TEST_NAME_TYPE = 3, TEXT_TYPE = 4;
    if ("function" === typeof Symbol && Symbol.for) {
        var symbolFor = Symbol.for;
        COMPONENT_TYPE = symbolFor("selector.component");
        HAS_PSEUDO_CLASS_TYPE = symbolFor("selector.has_pseudo_class");
        ROLE_TYPE = symbolFor("selector.role");
        TEST_NAME_TYPE = symbolFor("selector.test_id");
        TEXT_TYPE = symbolFor("selector.text");
    }
    var PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = !1, workInProgressRootIsPrerendering = !1, workInProgressRootDidAttachPingListener = !1, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = !1, globalMostRecentFallbackTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, rootDoesHavePassiveEffects = !1, rootWithPendingPassiveEffects = null, pendingPassiveEffectsLanes = 0, pendingPassiveEffectsRemainingLanes = 0, pendingPassiveTransitions = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
    exports.attemptContinuousHydration = function(fiber) {
        if (13 === fiber.tag) {
            var root = enqueueConcurrentRenderForLane(fiber, 67108864);
            null !== root && scheduleUpdateOnFiber(root, fiber, 67108864);
            markRetryLaneIfNotHydrated(fiber, 67108864);
        }
    };
    exports.attemptHydrationAtCurrentPriority = function(fiber) {
        if (13 === fiber.tag) {
            var lane = requestUpdateLane(), root = enqueueConcurrentRenderForLane(fiber, lane);
            null !== root && scheduleUpdateOnFiber(root, fiber, lane);
            markRetryLaneIfNotHydrated(fiber, lane);
        }
    };
    exports.attemptSynchronousHydration = function(fiber) {
        switch(fiber.tag){
            case 3:
                fiber = fiber.stateNode;
                if (fiber.current.memoizedState.isDehydrated) {
                    var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                    if (0 !== lanes) {
                        fiber.pendingLanes |= 2;
                        for(fiber.entangledLanes |= 2; lanes;){
                            var lane = 1 << 31 - clz32(lanes);
                            fiber.entanglements[1] |= lane;
                            lanes &= ~lane;
                        }
                        ensureRootIsScheduled(fiber);
                        0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0, !1));
                    }
                }
                break;
            case 13:
                lanes = enqueueConcurrentRenderForLane(fiber, 2), null !== lanes && scheduleUpdateOnFiber(lanes, fiber, 2), flushSyncWork(), markRetryLaneIfNotHydrated(fiber, 2);
        }
    };
    exports.batchedUpdates = function(fn, a) {
        return fn(a);
    };
    exports.createComponentSelector = function(component) {
        return {
            $$typeof: COMPONENT_TYPE,
            value: component
        };
    };
    exports.createContainer = function(containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks) {
        return createFiberRoot(containerInfo, tag, !1, null, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, null);
    };
    exports.createHasPseudoClassSelector = function(selectors) {
        return {
            $$typeof: HAS_PSEUDO_CLASS_TYPE,
            value: selectors
        };
    };
    exports.createHydrationContainer = function(initialChildren, callback, containerInfo, tag, hydrationCallbacks, isStrictMode, concurrentUpdatesByDefaultOverride, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState) {
        initialChildren = createFiberRoot(containerInfo, tag, !0, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, transitionCallbacks, formState);
        initialChildren.context = getContextForSubtree(null);
        containerInfo = initialChildren.current;
        tag = requestUpdateLane();
        hydrationCallbacks = createUpdate(tag);
        hydrationCallbacks.callback = void 0 !== callback && null !== callback ? callback : null;
        enqueueUpdate(containerInfo, hydrationCallbacks, tag);
        initialChildren.current.lanes = tag;
        markRootUpdated$1(initialChildren, tag);
        ensureRootIsScheduled(initialChildren);
        return initialChildren;
    };
    exports.createPortal = function(children, containerInfo, implementation) {
        var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
        return {
            $$typeof: REACT_PORTAL_TYPE,
            key: null == key ? null : "" + key,
            children: children,
            containerInfo: containerInfo,
            implementation: implementation
        };
    };
    exports.createRoleSelector = function(role) {
        return {
            $$typeof: ROLE_TYPE,
            value: role
        };
    };
    exports.createTestNameSelector = function(id) {
        return {
            $$typeof: TEST_NAME_TYPE,
            value: id
        };
    };
    exports.createTextSelector = function(text) {
        return {
            $$typeof: TEXT_TYPE,
            value: text
        };
    };
    exports.defaultOnCaughtError = function(error) {
        console.error(error);
    };
    exports.defaultOnRecoverableError = function(error) {
        reportGlobalError(error);
    };
    exports.defaultOnUncaughtError = function(error) {
        reportGlobalError(error);
    };
    exports.deferredUpdates = function(fn) {
        var prevTransition = ReactSharedInternals.T, previousPriority = getCurrentUpdatePriority();
        try {
            return setCurrentUpdatePriority(32), ReactSharedInternals.T = null, fn();
        } finally{
            setCurrentUpdatePriority(previousPriority), ReactSharedInternals.T = prevTransition;
        }
    };
    exports.discreteUpdates = function(fn, a, b, c, d) {
        var prevTransition = ReactSharedInternals.T, previousPriority = getCurrentUpdatePriority();
        try {
            return setCurrentUpdatePriority(2), ReactSharedInternals.T = null, fn(a, b, c, d);
        } finally{
            setCurrentUpdatePriority(previousPriority), ReactSharedInternals.T = prevTransition, 0 === executionContext && (workInProgressRootRenderTargetTime = now() + 500);
        }
    };
    exports.findAllNodes = findAllNodes;
    exports.findBoundingRects = function(hostRoot, selectors) {
        if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
        selectors = findAllNodes(hostRoot, selectors);
        hostRoot = [];
        for(var i = 0; i < selectors.length; i++)hostRoot.push(getBoundingRect(selectors[i]));
        for(selectors = hostRoot.length - 1; 0 < selectors; selectors--){
            i = hostRoot[selectors];
            for(var targetLeft = i.x, targetRight = targetLeft + i.width, targetTop = i.y, targetBottom = targetTop + i.height, j = selectors - 1; 0 <= j; j--)if (selectors !== j) {
                var otherRect = hostRoot[j], otherLeft = otherRect.x, otherRight = otherLeft + otherRect.width, otherTop = otherRect.y, otherBottom = otherTop + otherRect.height;
                if (targetLeft >= otherLeft && targetTop >= otherTop && targetRight <= otherRight && targetBottom <= otherBottom) {
                    hostRoot.splice(selectors, 1);
                    break;
                } else if (!(targetLeft !== otherLeft || i.width !== otherRect.width || otherBottom < targetTop || otherTop > targetBottom)) {
                    otherTop > targetTop && (otherRect.height += otherTop - targetTop, otherRect.y = targetTop);
                    otherBottom < targetBottom && (otherRect.height = targetBottom - otherTop);
                    hostRoot.splice(selectors, 1);
                    break;
                } else if (!(targetTop !== otherTop || i.height !== otherRect.height || otherRight < targetLeft || otherLeft > targetRight)) {
                    otherLeft > targetLeft && (otherRect.width += otherLeft - targetLeft, otherRect.x = targetLeft);
                    otherRight < targetRight && (otherRect.width = targetRight - otherLeft);
                    hostRoot.splice(selectors, 1);
                    break;
                }
            }
        }
        return hostRoot;
    };
    exports.findHostInstance = findHostInstance;
    exports.findHostInstanceWithNoPortals = function(fiber) {
        fiber = findCurrentFiberUsingSlowPath(fiber);
        fiber = null !== fiber ? findCurrentHostFiberWithNoPortalsImpl(fiber) : null;
        return null === fiber ? null : getPublicInstance(fiber.stateNode);
    };
    exports.findHostInstanceWithWarning = function(component) {
        return findHostInstance(component);
    };
    exports.flushPassiveEffects = flushPassiveEffects;
    exports.flushSyncFromReconciler = function(fn) {
        var prevExecutionContext = executionContext;
        executionContext |= 1;
        var prevTransition = ReactSharedInternals.T, previousPriority = getCurrentUpdatePriority();
        try {
            if (setCurrentUpdatePriority(2), ReactSharedInternals.T = null, fn) return fn();
        } finally{
            setCurrentUpdatePriority(previousPriority), ReactSharedInternals.T = prevTransition, executionContext = prevExecutionContext, 0 === (executionContext & 6) && flushSyncWorkAcrossRoots_impl(0, !1);
        }
    };
    exports.flushSyncWork = flushSyncWork;
    exports.focusWithin = function(hostRoot, selectors) {
        if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
        hostRoot = findFiberRootForHostRoot(hostRoot);
        selectors = findPaths(hostRoot, selectors);
        selectors = Array.from(selectors);
        for(hostRoot = 0; hostRoot < selectors.length;){
            var fiber = selectors[hostRoot++], tag = fiber.tag;
            if (!isHiddenSubtree(fiber)) {
                if ((5 === tag || 26 === tag || 27 === tag) && setFocusIfFocusable(fiber.stateNode)) return !0;
                for(fiber = fiber.child; null !== fiber;)selectors.push(fiber), fiber = fiber.sibling;
            }
        }
        return !1;
    };
    exports.getFindAllNodesFailureDescription = function(hostRoot, selectors) {
        if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
        var maxSelectorIndex = 0, matchedNames = [];
        hostRoot = [
            findFiberRootForHostRoot(hostRoot),
            0
        ];
        for(var index = 0; index < hostRoot.length;){
            var fiber = hostRoot[index++], tag = fiber.tag, selectorIndex = hostRoot[index++], selector = selectors[selectorIndex];
            if (5 !== tag && 26 !== tag && 27 !== tag || !isHiddenSubtree(fiber)) {
                if (matchSelector(fiber, selector) && (matchedNames.push(selectorToString(selector)), selectorIndex++, selectorIndex > maxSelectorIndex && (maxSelectorIndex = selectorIndex)), selectorIndex < selectors.length) for(fiber = fiber.child; null !== fiber;)hostRoot.push(fiber, selectorIndex), fiber = fiber.sibling;
            }
        }
        if (maxSelectorIndex < selectors.length) {
            for(hostRoot = []; maxSelectorIndex < selectors.length; maxSelectorIndex++)hostRoot.push(selectorToString(selectors[maxSelectorIndex]));
            return "findAllNodes was able to match part of the selector:\n  " + (matchedNames.join(" > ") + "\n\nNo matching component was found for:\n  ") + hostRoot.join(" > ");
        }
        return null;
    };
    exports.getPublicRootInstance = function(container) {
        container = container.current;
        if (!container.child) return null;
        switch(container.child.tag){
            case 27:
            case 5:
                return getPublicInstance(container.child.stateNode);
            default:
                return container.child.stateNode;
        }
    };
    exports.injectIntoDevTools = function() {
        var internals = {
            bundleType: 0,
            version: rendererVersion,
            rendererPackageName: rendererPackageName,
            currentDispatcherRef: ReactSharedInternals,
            findFiberByHostInstance: getInstanceFromNode,
            reconcilerVersion: "19.0.0"
        };
        null !== extraDevToolsConfig && (internals.rendererConfig = extraDevToolsConfig);
        if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) internals = !1;
        else {
            var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
            if (hook.isDisabled || !hook.supportsFiber) internals = !0;
            else {
                try {
                    rendererID = hook.inject(internals), injectedHook = hook;
                } catch (err) {}
                internals = hook.checkDCE ? !0 : !1;
            }
        }
        return internals;
    };
    exports.isAlreadyRendering = function() {
        return !1;
    };
    exports.observeVisibleRects = function(hostRoot, selectors, callback, options) {
        if (!supportsTestSelectors) throw Error(formatProdErrorMessage(363));
        hostRoot = findAllNodes(hostRoot, selectors);
        var disconnect = setupIntersectionObserver(hostRoot, callback, options).disconnect;
        return {
            disconnect: function() {
                disconnect();
            }
        };
    };
    exports.shouldError = function() {
        return null;
    };
    exports.shouldSuspend = function() {
        return !1;
    };
    exports.startHostTransition = function(formFiber, pendingState, action, formData) {
        if (5 !== formFiber.tag) throw Error(formatProdErrorMessage(476));
        var queue = ensureFormComponentIsStateful(formFiber).queue;
        startTransition(formFiber, queue, pendingState, NotPendingTransition, null === action ? noop : function() {
            var resetStateQueue = ensureFormComponentIsStateful(formFiber).next.queue;
            dispatchSetStateInternal(formFiber, resetStateQueue, {}, requestUpdateLane());
            return action(formData);
        });
    };
    exports.updateContainer = function(element, container, parentComponent, callback) {
        var current = container.current, lane = requestUpdateLane();
        updateContainerImpl(current, lane, element, container, parentComponent, callback);
        return lane;
    };
    exports.updateContainerSync = function(element, container, parentComponent, callback) {
        0 === container.tag && flushPassiveEffects();
        updateContainerImpl(container.current, 2, element, container, parentComponent, callback);
        return 2;
    };
    return exports;
};
module.exports.default = module.exports;
Object.defineProperty(module.exports, "__esModule", {
    value: !0
});

},{"43c297beba254329":"bmhQu","8feb0ca1d3bca557":"dHubo"}],"dHubo":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("c2333c22ee790411");

},{"c2333c22ee790411":"d4zlD"}],"d4zlD":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
function push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare(left, last)) rightIndex < length && 0 > compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
exports.unstable_now = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var localPerformance = performance;
    exports.unstable_now = function() {
        return localPerformance.now();
    };
} else {
    var localDate = Date, initialTime = localDate.now();
    exports.unstable_now = function() {
        return localDate.now() - initialTime;
    };
}
var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = !1, isHostCallbackScheduled = !1, isHostTimeoutScheduled = !1, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function advanceTimers(currentTime) {
    for(var timer = peek(timerQueue); null !== timer;){
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime) pop(timerQueue), timer.sortIndex = timer.expirationTime, push(taskQueue, timer);
        else break;
        timer = peek(timerQueue);
    }
}
function handleTimeout(currentTime) {
    isHostTimeoutScheduled = !1;
    advanceTimers(currentTime);
    if (!isHostCallbackScheduled) {
        if (null !== peek(taskQueue)) isHostCallbackScheduled = !0, requestHostCallback();
        else {
            var firstTimer = peek(timerQueue);
            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var isMessageLoopRunning = !1, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
function shouldYieldToHost() {
    return exports.unstable_now() - startTime < frameInterval ? !1 : !0;
}
function performWorkUntilDeadline() {
    if (isMessageLoopRunning) {
        var currentTime = exports.unstable_now();
        startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                isHostCallbackScheduled = !1;
                isHostTimeoutScheduled && (isHostTimeoutScheduled = !1, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
                isPerformingWork = !0;
                var previousPriorityLevel = currentPriorityLevel;
                try {
                    b: {
                        advanceTimers(currentTime);
                        for(currentTask = peek(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost());){
                            var callback = currentTask.callback;
                            if ("function" === typeof callback) {
                                currentTask.callback = null;
                                currentPriorityLevel = currentTask.priorityLevel;
                                var continuationCallback = callback(currentTask.expirationTime <= currentTime);
                                currentTime = exports.unstable_now();
                                if ("function" === typeof continuationCallback) {
                                    currentTask.callback = continuationCallback;
                                    advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                currentTask === peek(taskQueue) && pop(taskQueue);
                                advanceTimers(currentTime);
                            } else pop(taskQueue);
                            currentTask = peek(taskQueue);
                        }
                        if (null !== currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = peek(timerQueue);
                            null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = !1;
        }
    }
}
var schedulePerformWorkUntilDeadline;
if ("function" === typeof localSetImmediate) schedulePerformWorkUntilDeadline = function() {
    localSetImmediate(performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var channel = new MessageChannel(), port = channel.port2;
    channel.port1.onmessage = performWorkUntilDeadline;
    schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
    };
} else schedulePerformWorkUntilDeadline = function() {
    localSetTimeout(performWorkUntilDeadline, 0);
};
function requestHostCallback() {
    isMessageLoopRunning || (isMessageLoopRunning = !0, schedulePerformWorkUntilDeadline());
}
function requestHostTimeout(callback, ms) {
    taskTimeoutID = localSetTimeout(function() {
        callback(exports.unstable_now());
    }, ms);
}
exports.unstable_IdlePriority = 5;
exports.unstable_ImmediatePriority = 1;
exports.unstable_LowPriority = 4;
exports.unstable_NormalPriority = 3;
exports.unstable_Profiling = null;
exports.unstable_UserBlockingPriority = 2;
exports.unstable_cancelCallback = function(task) {
    task.callback = null;
};
exports.unstable_continueExecution = function() {
    isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, requestHostCallback());
};
exports.unstable_forceFrameRate = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
exports.unstable_getCurrentPriorityLevel = function() {
    return currentPriorityLevel;
};
exports.unstable_getFirstCallbackNode = function() {
    return peek(taskQueue);
};
exports.unstable_next = function(eventHandler) {
    switch(currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = currentPriorityLevel;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_pauseExecution = function() {};
exports.unstable_requestPaint = function() {};
exports.unstable_runWithPriority = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = currentPriorityLevel;
    currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        currentPriorityLevel = previousPriorityLevel;
    }
};
exports.unstable_scheduleCallback = function(priorityLevel, callback, options) {
    var currentTime = exports.unstable_now();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, push(timerQueue, priorityLevel), null === peek(taskQueue) && priorityLevel === peek(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = !0, requestHostTimeout(handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, push(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = !0, requestHostCallback()));
    return priorityLevel;
};
exports.unstable_shouldYield = shouldYieldToHost;
exports.unstable_wrapCallback = function(callback) {
    var parentPriorityLevel = currentPriorityLevel;
    return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            currentPriorityLevel = previousPriorityLevel;
        }
    };
};

},{}],"3eSSa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FiberProvider", ()=>m);
parcelHelpers.export(exports, "traverseFiber", ()=>i);
parcelHelpers.export(exports, "useContainer", ()=>w);
parcelHelpers.export(exports, "useContextBridge", ()=>x);
parcelHelpers.export(exports, "useContextMap", ()=>h);
parcelHelpers.export(exports, "useFiber", ()=>c);
parcelHelpers.export(exports, "useNearestChild", ()=>v);
parcelHelpers.export(exports, "useNearestParent", ()=>y);
var _react = require("react");
const f = /* @__PURE__ */ (()=>{
    var e, t;
    return typeof window != "undefined" && (((e = window.document) == null ? void 0 : e.createElement) || ((t = window.navigator) == null ? void 0 : t.product) === "ReactNative");
})() ? _react.useLayoutEffect : _react.useEffect;
function i(e, t, r) {
    if (!e) return;
    if (r(e) === !0) return e;
    let n = t ? e.return : e.child;
    for(; n;){
        const u = i(n, t, r);
        if (u) return u;
        n = t ? null : n.sibling;
    }
}
function l(e) {
    try {
        return Object.defineProperties(e, {
            _currentRenderer: {
                get () {
                    return null;
                },
                set () {}
            },
            _currentRenderer2: {
                get () {
                    return null;
                },
                set () {}
            }
        });
    } catch (t) {
        return e;
    }
}
const a = /* @__PURE__ */ l(/* @__PURE__ */ _react.createContext(null));
class m extends _react.Component {
    render() {
        return /* @__PURE__ */ _react.createElement(a.Provider, {
            value: this._reactInternals
        }, this.props.children);
    }
}
function c() {
    const e = _react.useContext(a);
    if (e === null) throw new Error("its-fine: useFiber must be called within a <FiberProvider />!");
    const t = _react.useId();
    return _react.useMemo(()=>{
        for (const n of [
            e,
            e == null ? void 0 : e.alternate
        ]){
            if (!n) continue;
            const u = i(n, !1, (d)=>{
                let s = d.memoizedState;
                for(; s;){
                    if (s.memoizedState === t) return !0;
                    s = s.next;
                }
            });
            if (u) return u;
        }
    }, [
        e,
        t
    ]);
}
function w() {
    const e = c(), t = _react.useMemo(()=>i(e, !0, (r)=>{
            var n;
            return ((n = r.stateNode) == null ? void 0 : n.containerInfo) != null;
        }), [
        e
    ]);
    return t == null ? void 0 : t.stateNode.containerInfo;
}
function v(e) {
    const t = c(), r = _react.useRef(void 0);
    return f(()=>{
        var n;
        r.current = (n = i(t, !1, (u)=>typeof u.type == "string" && (e === void 0 || u.type === e))) == null ? void 0 : n.stateNode;
    }, [
        t
    ]), r;
}
function y(e) {
    const t = c(), r = _react.useRef(void 0);
    return f(()=>{
        var n;
        r.current = (n = i(t, !0, (u)=>typeof u.type == "string" && (e === void 0 || u.type === e))) == null ? void 0 : n.stateNode;
    }, [
        t
    ]), r;
}
const p = Symbol.for("react.context"), b = (e)=>e !== null && typeof e == "object" && "$$typeof" in e && e.$$typeof === p;
function h() {
    const e = c(), [t] = _react.useState(()=>/* @__PURE__ */ new Map());
    t.clear();
    let r = e;
    for(; r;){
        const n = r.type;
        b(n) && n !== a && !t.has(n) && t.set(n, _react.use(l(n))), r = r.return;
    }
    return t;
}
function x() {
    const e = h();
    return _react.useMemo(()=>Array.from(e.keys()).reduce((t, r)=>(n)=>/* @__PURE__ */ _react.createElement(t, null, /* @__PURE__ */ _react.createElement(r.Provider, {
                    ...n,
                    value: e.get(r)
                })), (t)=>/* @__PURE__ */ _react.createElement(m, {
                ...t
            })), [
        e
    ]);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8xH4W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Clone", ()=>Clone);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _three = require("three");
var _react = require("react");
var _threeStdlib = require("three-stdlib");
function createSpread(child, { keys = [
    'near',
    'far',
    'color',
    'distance',
    'decay',
    'penumbra',
    'angle',
    'intensity',
    'skeleton',
    'visible',
    'castShadow',
    'receiveShadow',
    'morphTargetDictionary',
    'morphTargetInfluences',
    'name',
    'geometry',
    'material',
    'position',
    'rotation',
    'scale',
    'up',
    'userData',
    'bindMode',
    'bindMatrix',
    'bindMatrixInverse',
    'skeleton'
], deep, inject, castShadow, receiveShadow }) {
    let spread = {};
    for (const key of keys)spread[key] = child[key];
    if (deep) {
        if (spread.geometry && deep !== 'materialsOnly') spread.geometry = spread.geometry.clone();
        if (spread.material && deep !== 'geometriesOnly') spread.material = spread.material.clone();
    }
    if (inject) {
        if (typeof inject === 'function') spread = {
            ...spread,
            children: inject(child)
        };
        else if (/*#__PURE__*/ _react.isValidElement(inject)) spread = {
            ...spread,
            children: inject
        };
        else spread = {
            ...spread,
            ...inject
        };
    }
    if (child instanceof _three.Mesh) {
        if (castShadow) spread.castShadow = true;
        if (receiveShadow) spread.receiveShadow = true;
    }
    return spread;
}
const Clone = /* @__PURE__ */ _react.forwardRef(({ isChild = false, object, children, deep, castShadow, receiveShadow, inject, keys, ...props }, forwardRef)=>{
    const config = {
        keys,
        deep,
        inject,
        castShadow,
        receiveShadow
    };
    object = _react.useMemo(()=>{
        if (isChild === false && !Array.isArray(object)) {
            let isSkinned = false;
            object.traverse((object)=>{
                if (object.isSkinnedMesh) isSkinned = true;
            });
            if (isSkinned) return (0, _threeStdlib.SkeletonUtils).clone(object);
        }
        return object;
    }, [
        object,
        isChild
    ]);
    // Deal with arrayed clones
    if (Array.isArray(object)) return /*#__PURE__*/ _react.createElement("group", (0, _extendsDefault.default)({}, props, {
        ref: forwardRef
    }), object.map((o)=>/*#__PURE__*/ _react.createElement(Clone, (0, _extendsDefault.default)({
            key: o.uuid,
            object: o
        }, config))), children);
    // Singleton clones
    const { children: injectChildren, ...spread } = createSpread(object, config);
    const Element = object.type[0].toLowerCase() + object.type.slice(1);
    return /*#__PURE__*/ _react.createElement(Element, (0, _extendsDefault.default)({}, spread, props, {
        ref: forwardRef
    }), object.children.map((child)=>{
        if (child.type === 'Bone') return /*#__PURE__*/ _react.createElement("primitive", (0, _extendsDefault.default)({
            key: child.uuid,
            object: child
        }, config));
        return /*#__PURE__*/ _react.createElement(Clone, (0, _extendsDefault.default)({
            key: child.uuid,
            object: child
        }, config, {
            isChild: true
        }));
    }), children, injectChildren);
});

},{"@babel/runtime/helpers/esm/extends":"85Hd3","three":"hZcQL","react":"bmhQu","three-stdlib":"4Y00y","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Y00y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkeletonUtils", ()=>SkeletonUtils);
var _three = require("three");
function retarget(target, source, options = {}) {
    const pos = new (0, _three.Vector3)(), quat = new (0, _three.Quaternion)(), scale = new (0, _three.Vector3)(), bindBoneMatrix = new (0, _three.Matrix4)(), relativeMatrix = new (0, _three.Matrix4)(), globalMatrix = new (0, _three.Matrix4)();
    options.preserveMatrix = options.preserveMatrix !== void 0 ? options.preserveMatrix : true;
    options.preservePosition = options.preservePosition !== void 0 ? options.preservePosition : true;
    options.preserveHipPosition = options.preserveHipPosition !== void 0 ? options.preserveHipPosition : false;
    options.useTargetMatrix = options.useTargetMatrix !== void 0 ? options.useTargetMatrix : false;
    options.hip = options.hip !== void 0 ? options.hip : "hip";
    options.names = options.names || {};
    const sourceBones = source.isObject3D ? source.skeleton.bones : getBones(source), bones = target.isObject3D ? target.skeleton.bones : getBones(target);
    let bindBones, bone, name, boneTo, bonesPosition;
    if (target.isObject3D) target.skeleton.pose();
    else {
        options.useTargetMatrix = true;
        options.preserveMatrix = false;
    }
    if (options.preservePosition) {
        bonesPosition = [];
        for(let i = 0; i < bones.length; i++)bonesPosition.push(bones[i].position.clone());
    }
    if (options.preserveMatrix) {
        target.updateMatrixWorld();
        target.matrixWorld.identity();
        for(let i = 0; i < target.children.length; ++i)target.children[i].updateMatrixWorld(true);
    }
    if (options.offsets) {
        bindBones = [];
        for(let i = 0; i < bones.length; ++i){
            bone = bones[i];
            name = options.names[bone.name] || bone.name;
            if (options.offsets[name]) {
                bone.matrix.multiply(options.offsets[name]);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
                bone.updateMatrixWorld();
            }
            bindBones.push(bone.matrixWorld.clone());
        }
    }
    for(let i = 0; i < bones.length; ++i){
        bone = bones[i];
        name = options.names[bone.name] || bone.name;
        boneTo = getBoneByName(name, sourceBones);
        globalMatrix.copy(bone.matrixWorld);
        if (boneTo) {
            boneTo.updateMatrixWorld();
            if (options.useTargetMatrix) relativeMatrix.copy(boneTo.matrixWorld);
            else {
                relativeMatrix.copy(target.matrixWorld).invert();
                relativeMatrix.multiply(boneTo.matrixWorld);
            }
            scale.setFromMatrixScale(relativeMatrix);
            relativeMatrix.scale(scale.set(1 / scale.x, 1 / scale.y, 1 / scale.z));
            globalMatrix.makeRotationFromQuaternion(quat.setFromRotationMatrix(relativeMatrix));
            if (target.isObject3D) {
                const boneIndex = bones.indexOf(bone), wBindMatrix = bindBones ? bindBones[boneIndex] : bindBoneMatrix.copy(target.skeleton.boneInverses[boneIndex]).invert();
                globalMatrix.multiply(wBindMatrix);
            }
            globalMatrix.copyPosition(relativeMatrix);
        }
        if (bone.parent && bone.parent.isBone) {
            bone.matrix.copy(bone.parent.matrixWorld).invert();
            bone.matrix.multiply(globalMatrix);
        } else bone.matrix.copy(globalMatrix);
        if (options.preserveHipPosition && name === options.hip) bone.matrix.setPosition(pos.set(0, bone.position.y, 0));
        bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
        bone.updateMatrixWorld();
    }
    if (options.preservePosition) for(let i = 0; i < bones.length; ++i){
        bone = bones[i];
        name = options.names[bone.name] || bone.name;
        if (name !== options.hip) bone.position.copy(bonesPosition[i]);
    }
    if (options.preserveMatrix) target.updateMatrixWorld(true);
}
function retargetClip(target, source, clip, options = {}) {
    options.useFirstFramePosition = options.useFirstFramePosition !== void 0 ? options.useFirstFramePosition : false;
    options.fps = options.fps !== void 0 ? options.fps : 30;
    options.names = options.names || [];
    if (!source.isObject3D) source = getHelperFromSkeleton(source);
    const numFrames = Math.round(clip.duration * (options.fps / 1e3) * 1e3), delta = 1 / options.fps, convertedTracks = [], mixer = new (0, _three.AnimationMixer)(source), bones = getBones(target.skeleton), boneDatas = [];
    let positionOffset, bone, boneTo, boneData, name;
    mixer.clipAction(clip).play();
    mixer.update(0);
    source.updateMatrixWorld();
    for(let i = 0; i < numFrames; ++i){
        const time = i * delta;
        retarget(target, source, options);
        for(let j = 0; j < bones.length; ++j){
            name = options.names[bones[j].name] || bones[j].name;
            boneTo = getBoneByName(name, source.skeleton);
            if (boneTo) {
                bone = bones[j];
                boneData = boneDatas[j] = boneDatas[j] || {
                    bone
                };
                if (options.hip === name) {
                    if (!boneData.pos) boneData.pos = {
                        times: new Float32Array(numFrames),
                        values: new Float32Array(numFrames * 3)
                    };
                    if (options.useFirstFramePosition) {
                        if (i === 0) positionOffset = bone.position.clone();
                        bone.position.sub(positionOffset);
                    }
                    boneData.pos.times[i] = time;
                    bone.position.toArray(boneData.pos.values, i * 3);
                }
                if (!boneData.quat) boneData.quat = {
                    times: new Float32Array(numFrames),
                    values: new Float32Array(numFrames * 4)
                };
                boneData.quat.times[i] = time;
                bone.quaternion.toArray(boneData.quat.values, i * 4);
            }
        }
        mixer.update(delta);
        source.updateMatrixWorld();
    }
    for(let i = 0; i < boneDatas.length; ++i){
        boneData = boneDatas[i];
        if (boneData) {
            if (boneData.pos) convertedTracks.push(new (0, _three.VectorKeyframeTrack)(".bones[" + boneData.bone.name + "].position", boneData.pos.times, boneData.pos.values));
            convertedTracks.push(new (0, _three.QuaternionKeyframeTrack)(".bones[" + boneData.bone.name + "].quaternion", boneData.quat.times, boneData.quat.values));
        }
    }
    mixer.uncacheAction(clip);
    return new (0, _three.AnimationClip)(clip.name, -1, convertedTracks);
}
function clone(source) {
    const sourceLookup = /* @__PURE__ */ new Map();
    const cloneLookup = /* @__PURE__ */ new Map();
    const clone2 = source.clone();
    parallelTraverse(source, clone2, function(sourceNode, clonedNode) {
        sourceLookup.set(clonedNode, sourceNode);
        cloneLookup.set(sourceNode, clonedNode);
    });
    clone2.traverse(function(node) {
        if (!node.isSkinnedMesh) return;
        const clonedMesh = node;
        const sourceMesh = sourceLookup.get(node);
        const sourceBones = sourceMesh.skeleton.bones;
        clonedMesh.skeleton = sourceMesh.skeleton.clone();
        clonedMesh.bindMatrix.copy(sourceMesh.bindMatrix);
        clonedMesh.skeleton.bones = sourceBones.map(function(bone) {
            return cloneLookup.get(bone);
        });
        clonedMesh.bind(clonedMesh.skeleton, clonedMesh.bindMatrix);
    });
    return clone2;
}
function getBoneByName(name, skeleton) {
    for(let i = 0, bones = getBones(skeleton); i < bones.length; i++){
        if (name === bones[i].name) return bones[i];
    }
}
function getBones(skeleton) {
    return Array.isArray(skeleton) ? skeleton : skeleton.bones;
}
function getHelperFromSkeleton(skeleton) {
    const source = new (0, _three.SkeletonHelper)(skeleton.bones[0]);
    source.skeleton = skeleton;
    return source;
}
function parallelTraverse(a, b, callback) {
    callback(a, b);
    for(let i = 0; i < a.children.length; i++)parallelTraverse(a.children[i], b.children[i], callback);
}
const SkeletonUtils = {
    retarget,
    retargetClip,
    clone
};

},{"three":[["AnimationClip","bihzc"],["AnimationMixer","bihzc"],["Quaternion","bihzc"],["QuaternionKeyframeTrack","bihzc"],["SkeletonHelper","bihzc"],["VectorKeyframeTrack","bihzc"],["Matrix4","hZcQL"],["Vector3","hZcQL"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"joyv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Home", ()=>Home);
var _jsxRuntime = require("react/jsx-runtime");
var _indexCss = require("../../index.css");
var _react = require("react");
var _homeModuleCss = require("./Home.module.css");
//Assets
var _avatarRateStack1Webp = require("url:../../assets/images/avatar-rate-stack-1.webp");
var _avatarRateStack1WebpDefault = parcelHelpers.interopDefault(_avatarRateStack1Webp);
var _avatarRateStack2Webp = require("url:../../assets/images/avatar-rate-stack-2.webp");
var _avatarRateStack2WebpDefault = parcelHelpers.interopDefault(_avatarRateStack2Webp);
var _avatarRateStack3Webp = require("url:../../assets/images/avatar-rate-stack-3.webp");
var _avatarRateStack3WebpDefault = parcelHelpers.interopDefault(_avatarRateStack3Webp);
var _avatarRateStack4Webp = require("url:../../assets/images/avatar-rate-stack-4.webp");
var _avatarRateStack4WebpDefault = parcelHelpers.interopDefault(_avatarRateStack4Webp);
var _miniptIconWebp = require("url:../../assets/images/minipt-icon.webp");
var _miniptIconWebpDefault = parcelHelpers.interopDefault(_miniptIconWebp);
var _brandLlGoodWebp = require("url:../../assets/images/brand-ll-good.webp");
var _brandLlGoodWebpDefault = parcelHelpers.interopDefault(_brandLlGoodWebp);
var _brandCnetWebp = require("url:../../assets/images/brand-cnet.webp");
var _brandCnetWebpDefault = parcelHelpers.interopDefault(_brandCnetWebp);
var _brandForbesWebp = require("url:../../assets/images/brand-forbes.webp");
var _brandForbesWebpDefault = parcelHelpers.interopDefault(_brandForbesWebp);
var _brandMenHealthWebp = require("url:../../assets/images/brand-men-health.webp");
var _brandMenHealthWebpDefault = parcelHelpers.interopDefault(_brandMenHealthWebp);
var _brandHealthlineWebp = require("url:../../assets/images/brand-healthline.webp");
var _brandHealthlineWebpDefault = parcelHelpers.interopDefault(_brandHealthlineWebp);
var _brandOcbsWebp = require("url:../../assets/images/brand-ocbs.webp");
var _brandOcbsWebpDefault = parcelHelpers.interopDefault(_brandOcbsWebp);
var _brandTechradarWebp = require("url:../../assets/images/brand-techradar.webp");
var _brandTechradarWebpDefault = parcelHelpers.interopDefault(_brandTechradarWebp);
var _brandNewYorkPoWebp = require("url:../../assets/images/brand-new-york-po.webp");
var _brandNewYorkPoWebpDefault = parcelHelpers.interopDefault(_brandNewYorkPoWebp);
var _constantsTs = require("src/components/ModelWithVideo/Model3dWithVideo/constants.ts");
var _constantsTs1 = require("src/config/constants.ts");
var _teamMemberConfigTs = require("src/config/team-member.config.ts");
var _userTestimonialConfigTs = require("src/config/user-testimonial.config.ts");
var _blogPostConfigTs = require("src/config/blog-post.config.ts");
var _buttonTsx = require("src/components/Button/Button.tsx");
//Hooks
var _useMobilePhonePinTs = require("src/hooks/useMobilePhonePin.ts");
var _useTopBackgroundPinTs = require("src/hooks/useTopBackgroundPin.ts");
var _useTopBackgroundPinTsDefault = parcelHelpers.interopDefault(_useTopBackgroundPinTs);
var _canvasWrapperTsx = require("src/components/ModelWithVideo/Model3dWithVideo/CanvasWrapper.tsx");
var _useWindowDimensionsTs = require("src/hooks/useWindowDimensions.ts");
var _useWindowDimensionsTsDefault = parcelHelpers.interopDefault(_useWindowDimensionsTs);
var _uiStoreTs = require("src/store/uiStore.ts");
var _useAfterPageLoadTs = require("src/hooks/useAfterPageLoad.ts");
var _assets = require("src/assets");
var _preloadAssetsTs = require("src/utils/preloadAssets.ts");
var _appDownloadRedirectTs = require("src/utils/appDownloadRedirect.ts");
var _seo = require("src/components/SEO");
var _seoDefault = parcelHelpers.interopDefault(_seo);
//Components
const StackedImages = /*#__PURE__*/ (0, _react.lazy)(()=>require("82c9aa676bde72f2"));
const Model3dWithVideo = /*#__PURE__*/ (0, _react.lazy)(()=>require("6f25f7cabb7633e6"));
const StaticCenterLogos = /*#__PURE__*/ (0, _react.lazy)(()=>require("dee6a3e86774da5f"));
const FeatureCardsList = /*#__PURE__*/ (0, _react.lazy)(()=>require("697525379bad8fe2"));
const TeamMemberCard = /*#__PURE__*/ (0, _react.lazy)(()=>require("4cdc069311a0139b"));
const MotivationSection = /*#__PURE__*/ (0, _react.lazy)(()=>require("264e283121eb4b62"));
const UserTestimonials = /*#__PURE__*/ (0, _react.lazy)(()=>require("e1e32b03f7ae135d"));
const BlogSection = /*#__PURE__*/ (0, _react.lazy)(()=>require("706249876b830af4"));
const FeatureCardCarouselMobile = /*#__PURE__*/ (0, _react.lazy)(()=>require("f504a7d52a9cef0a"));
const FeatureCardCarousel = /*#__PURE__*/ (0, _react.lazy)(()=>require("1c59c9df2cc219db"));
function Home() {
    //Const
    const isMobileDevice = (0, _react.useMemo)(()=>/Android|iPhone|iPad|iPod/i.test(navigator.userAgent), []);
    const { width, height } = (0, _useWindowDimensionsTsDefault.default)();
    const isMobile = width <= 768;
    const showVideoPlayerVisible = (0, _uiStoreTs.uiStore)((s)=>s.showVideoPlayerVisible);
    //State
    const mobileStoryboardScrollProgress = (0, _react.useRef)(0);
    const [mobileFeatureScrollProgress, setMobileFeatureScrollProgress] = (0, _react.useState)(0);
    const [showSection, setShowSection] = (0, _react.useState)(false);
    //Derived
    const mobileHeight = (0, _react.useMemo)(()=>{
        const maxHeight = height - 140;
        return width >= height ? maxHeight : Math.min(maxHeight, width / (0, _constantsTs.MESH_ACCEPT_RATIO) * 0.8);
    }, [
        width,
        height
    ]);
    const modelScale = (0, _react.useMemo)(()=>mobileHeight * 6.8, [
        mobileHeight
    ]);
    //Load other section later
    (0, _useAfterPageLoadTs.useAfterDOMReady)(()=>{
        setShowSection(true);
        (0, _preloadAssetsTs.preloadAssets)((0, _assets.ALL_ASSETS));
    });
    const onFeatureProgress = (0, _react.useCallback)((progress)=>{
        setMobileFeatureScrollProgress(progress);
    }, []);
    const onStoryboardProgress = (0, _react.useCallback)((p)=>{
        mobileStoryboardScrollProgress.current = p;
    }, []);
    // Main feature 3d phone pin
    (0, _useMobilePhonePinTs.useMobilePhonePin)({
        triggerClass: `.${_homeModuleCss.phonePinWrapper}`,
        pinClass: `.${_homeModuleCss.cssMobileVideoContainer}`,
        scrollHeight: (0, _constantsTs1.MOBILE_SCROLL_HEIGHT),
        markers: false,
        onProgress: onStoryboardProgress
    });
    // Fade background behind 3d phone
    (0, _useTopBackgroundPinTsDefault.default)({
        topBgPinSelector: `.${_homeModuleCss.topBgPinWrapper}`,
        backgroundImageSelector: `.${_homeModuleCss.topBackgroundImageWrapper1}`,
        scrollHeight: (0, _constantsTs1.MOBILE_SCROLL_HEIGHT)
    });
    const onClickTeamMember = (0, _react.useCallback)((index)=>{
        const item = (0, _teamMemberConfigTs.TEAM_MEMBERS)[index];
        showVideoPlayerVisible(item.video);
    }, [
        showVideoPlayerVisible
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seoDefault.default), {
                title: "miniPT - Your Personal Training Companion",
                description: "Get expert fitness guidance, personalized workouts, and achieve your health goals with miniPT.",
                canonicalUrl: "/"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: _homeModuleCss.container,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: _homeModuleCss.topBgPinWrapper,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: _homeModuleCss.topBackgroundImageWrapper1
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: _homeModuleCss.topBackgroundImageWrapper,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: _homeModuleCss.reviewContainer,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(StackedImages, {
                                        className: _homeModuleCss.stackedImages,
                                        images: [
                                            (0, _avatarRateStack1WebpDefault.default),
                                            (0, _avatarRateStack2WebpDefault.default),
                                            (0, _avatarRateStack3WebpDefault.default),
                                            (0, _avatarRateStack4WebpDefault.default)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: _homeModuleCss.rating,
                                        children: 'Rated 4.8 from 200+ reviews'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: _homeModuleCss.title,
                                children: [
                                    'Transform your fitness journey\nwith  ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        src: (0, _miniptIconWebpDefault.default),
                                        className: _homeModuleCss.miniPt,
                                        alt: ""
                                    }),
                                    ' miniPT'
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: _homeModuleCss.description,
                                children: "Real-time motion tracking, personalized workouts, and expert\nfeedback \u2014 all in your pocket."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: _homeModuleCss.buttonsRow,
                        style: {
                            position: 'relative',
                            zIndex: 1
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                            onClick: (0, _appDownloadRedirectTs.handleAppDownloadRedirect),
                            variant: "primary",
                            children: 'Download the App Now'
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: _homeModuleCss.phonePinWrapper,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                height: mobileHeight
                            },
                            className: _homeModuleCss.cssMobileVideoContainer,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _canvasWrapperTsx.CanvasWrapper), {
                                canvasProps: {
                                    camera: {
                                        zoom: 1,
                                        position: [
                                            0,
                                            0,
                                            400
                                        ]
                                    },
                                    orthographic: true,
                                    resize: {
                                        scroll: false
                                    },
                                    dpr: isMobileDevice ? [
                                        1,
                                        1.25
                                    ] : [
                                        1,
                                        2
                                    ]
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                    fallback: null,
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Model3dWithVideo, {
                                        mobileProgress: mobileStoryboardScrollProgress,
                                        scale: modelScale,
                                        isMobile: isMobile
                                    })
                                })
                            })
                        })
                    }),
                    showSection && !(0, _constantsTs1.HIDE_SECTIONS).MEDIA_REPORTS && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(StaticCenterLogos, {
                            className: _homeModuleCss.staticCenterLogos,
                            images: [
                                (0, _brandLlGoodWebpDefault.default),
                                (0, _brandCnetWebpDefault.default),
                                (0, _brandForbesWebpDefault.default),
                                (0, _brandMenHealthWebpDefault.default),
                                (0, _brandHealthlineWebpDefault.default),
                                (0, _brandOcbsWebpDefault.default),
                                (0, _brandTechradarWebpDefault.default),
                                (0, _brandNewYorkPoWebpDefault.default)
                            ],
                            gap: 36,
                            size: 32
                        })
                    }),
                    showSection && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: _homeModuleCss.bestTimeHeadingText,
                                children: [
                                    "The best time ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                    " to start is",
                                    ' ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: _homeModuleCss.bestTimeHeadingHighlight,
                                        children: "now"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: _homeModuleCss.bestTimeSubHeadingText,
                                children: "With us, you\u2019ll stay on track and reach your goals."
                            })
                        ]
                    }),
                    showSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: _homeModuleCss.featureCardWrapper,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                            fallback: null,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FeatureCardsList, {
                                className: _homeModuleCss.featureCard
                            })
                        })
                    }),
                    showSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: _homeModuleCss.buttonsRowBottom,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                            onClick: (0, _appDownloadRedirectTs.handleAppDownloadRedirect),
                            variant: "primary",
                            children: 'Download the App Now'
                        })
                    }),
                    showSection && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: _homeModuleCss.whatsMakeUniqueText,
                        children: [
                            "What makes ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            " miniPT ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: _homeModuleCss.bestTimeHeadingHighlight,
                                children: "unique"
                            })
                        ]
                    }),
                    showSection && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Suspense), {
                        fallback: null,
                        children: [
                            !isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FeatureCardCarousel, {
                                mobileProgress: mobileFeatureScrollProgress,
                                onProgress: onFeatureProgress,
                                cssScaleFeature: (height - 250) / 879,
                                isMobile: isMobile
                            }),
                            isMobile && /*#__PURE__*/ (0, _jsxRuntime.jsx)(FeatureCardCarouselMobile, {
                                mobileProgress: mobileFeatureScrollProgress,
                                onProgress: onFeatureProgress,
                                cssScaleFeature: (height - 230) / 879,
                                isMobile: isMobile
                            })
                        ]
                    }),
                    showSection && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: _homeModuleCss.meetTeamWrapper,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: _homeModuleCss.mb60,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: _homeModuleCss.whatsMakeUniqueText,
                                        children: [
                                            "Meet the team ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            " behind",
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: _homeModuleCss.bestTimeHeadingHighlight,
                                                children: "miniPT"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: _homeModuleCss.teamMemberDescription,
                                        children: 'A group of passionate trainers, fitness experts, and tech innovators dedicated to making your workouts smarter, safer, and more effective.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: _homeModuleCss.teamMemberCardContainer,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                                    fallback: null,
                                    children: (0, _teamMemberConfigTs.TEAM_MEMBERS).map((member, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(TeamMemberCard, {
                                            index: index,
                                            className: _homeModuleCss.teamMemberCard,
                                            image: member.image,
                                            video: member.video,
                                            name: member.name,
                                            role: member.role,
                                            linkedinUrl: member.linkedinUrl,
                                            onClick: onClickTeamMember
                                        }, member.id))
                                })
                            })
                        ]
                    }),
                    showSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(MotivationSection, {
                            className: _homeModuleCss.motivationSection
                        })
                    }),
                    showSection && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(UserTestimonials, {
                            className: _homeModuleCss.userTestimonials,
                            title: "What our users say",
                            linkText: "From busy professionals to fitness beginners \u2014 discover how miniPT fits into every lifestyle.",
                            linkUrl: "#",
                            items: (0, _userTestimonialConfigTs.USER_TESTIMONIAL)
                        })
                    }),
                    showSection && !(0, _constantsTs1.HIDE_SECTIONS).BLOG && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                        fallback: null,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(BlogSection, {
                            className: _homeModuleCss.exploreBlog,
                            posts: (0, _blogPostConfigTs.BLOG_POSTS)
                        })
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","../../index.css":"fW8RG","react":"bmhQu","./Home.module.css":"hMdsK","url:../../assets/images/avatar-rate-stack-1.webp":"iagmh","url:../../assets/images/avatar-rate-stack-2.webp":"9hwaE","url:../../assets/images/avatar-rate-stack-3.webp":"gdTQh","url:../../assets/images/avatar-rate-stack-4.webp":"kD0WY","url:../../assets/images/minipt-icon.webp":"25Lce","url:../../assets/images/brand-ll-good.webp":"7mhlI","url:../../assets/images/brand-cnet.webp":"eli4I","url:../../assets/images/brand-forbes.webp":"8Kz2a","url:../../assets/images/brand-men-health.webp":"3pb5L","url:../../assets/images/brand-healthline.webp":"75wTh","url:../../assets/images/brand-ocbs.webp":"hnCC2","url:../../assets/images/brand-techradar.webp":"7E5OA","url:../../assets/images/brand-new-york-po.webp":"1JD8a","82c9aa676bde72f2":"h8nPt","6f25f7cabb7633e6":"aSmE1","dee6a3e86774da5f":"j9zdp","697525379bad8fe2":"2YORb","4cdc069311a0139b":"9uBHf","264e283121eb4b62":"gHdBx","e1e32b03f7ae135d":"3GNyi","706249876b830af4":"8Vebl","f504a7d52a9cef0a":"4CR5r","1c59c9df2cc219db":"bIbcQ","src/components/ModelWithVideo/Model3dWithVideo/constants.ts":"gNtJK","src/config/constants.ts":"uHGJK","src/config/team-member.config.ts":"9qh7Z","src/config/user-testimonial.config.ts":"5v9Dr","src/config/blog-post.config.ts":"hUzmH","src/components/Button/Button.tsx":"g0894","src/hooks/useMobilePhonePin.ts":"afPPd","src/hooks/useTopBackgroundPin.ts":"bhBQM","src/components/ModelWithVideo/Model3dWithVideo/CanvasWrapper.tsx":"iJUg0","src/hooks/useWindowDimensions.ts":"hENG8","src/store/uiStore.ts":"hxErL","src/hooks/useAfterPageLoad.ts":"5o3Y5","src/assets":"lm2uC","src/utils/preloadAssets.ts":"j8tJt","src/utils/appDownloadRedirect.ts":"1x7AV","src/components/SEO":"9lYJS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fW8RG":[function() {},{}],"hMdsK":[function(require,module,exports,__globalThis) {
var _indexCss = require("../../index.css");
module.exports["bestTimeHeadingHighlight"] = `_5_eMVq_bestTimeHeadingHighlight`;
module.exports["bestTimeHeadingText"] = `_5_eMVq_bestTimeHeadingText`;
module.exports["bestTimeSubHeadingText"] = `_5_eMVq_bestTimeSubHeadingText`;
module.exports["buttonsRow"] = `_5_eMVq_buttonsRow`;
module.exports["buttonsRowBottom"] = `_5_eMVq_buttonsRowBottom`;
module.exports["container"] = `_5_eMVq_container`;
module.exports["cssMobileVideoContainer"] = `_5_eMVq_cssMobileVideoContainer`;
module.exports["description"] = `_5_eMVq_description`;
module.exports["exploreBlog"] = `_5_eMVq_exploreBlog`;
module.exports["fadeOnScroll"] = `_5_eMVq_fadeOnScroll`;
module.exports["featureCard"] = `_5_eMVq_featureCard`;
module.exports["featureCardWrapper"] = `_5_eMVq_featureCardWrapper`;
module.exports["logoText"] = `_5_eMVq_logoText`;
module.exports["mainFooter"] = `_5_eMVq_mainFooter`;
module.exports["mb60"] = `_5_eMVq_mb60`;
module.exports["mcard"] = `_5_eMVq_mcard`;
module.exports["mcards"] = `_5_eMVq_mcards`;
module.exports["meetTeamWrapper"] = `_5_eMVq_meetTeamWrapper`;
module.exports["miniPt"] = `_5_eMVq_miniPt`;
module.exports["mobileMockup"] = `_5_eMVq_mobileMockup`;
module.exports["mobileVideoContainer"] = `_5_eMVq_mobileVideoContainer`;
module.exports["motivationSection"] = `_5_eMVq_motivationSection`;
module.exports["phonePinWrapper"] = `_5_eMVq_phonePinWrapper`;
module.exports["rating"] = `_5_eMVq_rating`;
module.exports["reviewContainer"] = `_5_eMVq_reviewContainer`;
module.exports["stackedImages"] = `_5_eMVq_stackedImages`;
module.exports["staticCenterLogos"] = `_5_eMVq_staticCenterLogos`;
module.exports["teamMemberCard"] = `_5_eMVq_teamMemberCard`;
module.exports["teamMemberCardContainer"] = `_5_eMVq_teamMemberCardContainer`;
module.exports["teamMemberDescription"] = `_5_eMVq_teamMemberDescription`;
module.exports["title"] = `_5_eMVq_title`;
module.exports["topBackgroundImageWrapper"] = `_5_eMVq_topBackgroundImageWrapper`;
module.exports["topBackgroundImageWrapper1"] = `_5_eMVq_topBackgroundImageWrapper1`;
module.exports["topBgPinWrapper"] = `_5_eMVq_topBgPinWrapper`;
module.exports["trackDescription"] = `_5_eMVq_trackDescription`;
module.exports["trackImage"] = `_5_eMVq_trackImage`;
module.exports["trackIndex"] = `_5_eMVq_trackIndex`;
module.exports["trackProgress"] = `_5_eMVq_trackProgress`;
module.exports["trackProgressCheckmarks"] = `_5_eMVq_trackProgressCheckmarks`;
module.exports["trackRightBlock"] = `_5_eMVq_trackRightBlock`;
module.exports["trackTitle"] = `_5_eMVq_trackTitle`;
module.exports["trackWrapper"] = `_5_eMVq_trackWrapper`;
module.exports["userTestimonials"] = `_5_eMVq_userTestimonials`;
module.exports["whatsMakeUniqueText"] = `_5_eMVq_whatsMakeUniqueText`;
for(let key in _indexCss)if (key in module.exports) module.exports[key] += ' ' + _indexCss[key];
else module.exports[key] = _indexCss[key];

},{"../../index.css":"fW8RG"}],"fW8RG":[function() {},{}],"iagmh":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4Y7Fv");

},{}],"9hwaE":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gFHtY");

},{}],"gdTQh":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9ei06");

},{}],"kD0WY":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("H0P2r");

},{}],"25Lce":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gfhgX");

},{}],"7mhlI":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("iSr8k");

},{}],"eli4I":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("b1vWu");

},{}],"8Kz2a":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3LHDD");

},{}],"3pb5L":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ifpTi");

},{}],"75wTh":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("bvfK2");

},{}],"hnCC2":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("iFGZE");

},{}],"7E5OA":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("eqFUY");

},{}],"1JD8a":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("aac5w");

},{}],"h8nPt":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("5d9a351aeda42458")(import.meta.resolve("3AW3Z")),
    import("kuEEe")
]).then(()=>module.bundle.root('fZQ3y'));

},{"5d9a351aeda42458":"deFMk"}],"deFMk":[function(require,module,exports,__globalThis) {
"use strict";
var cacheLoader = require("ae7c5e215a4907e2");
module.exports = cacheLoader(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

},{"ae7c5e215a4907e2":"hGvN3"}],"hGvN3":[function(require,module,exports,__globalThis) {
"use strict";
var cachedBundles = {};
var cachedPreloads = {};
var cachedPrefetches = {};
function getCache(type) {
    switch(type){
        case 'preload':
            return cachedPreloads;
        case 'prefetch':
            return cachedPrefetches;
        default:
            return cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

},{}],"aSmE1":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("hIJVv"),
    require("b262a9c20454f382")(import.meta.resolve("clSx7")),
    import("ksFgV")
]).then(()=>module.bundle.root('1YWUJ'));

},{"b262a9c20454f382":"deFMk"}],"j9zdp":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("6a6735b73ba6671a")(import.meta.resolve("4EdqM")),
    import("9LDJw")
]).then(()=>module.bundle.root('iPmSi'));

},{"6a6735b73ba6671a":"deFMk"}],"2YORb":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("94e929c7652ac596")(import.meta.resolve("bIKkE")),
    import("ksXf1")
]).then(()=>module.bundle.root('eoztS'));

},{"94e929c7652ac596":"deFMk"}],"9uBHf":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("28215ac119fde296")(import.meta.resolve("12TPX")),
    import("7kLQz")
]).then(()=>module.bundle.root('49TZ8'));

},{"28215ac119fde296":"deFMk"}],"gHdBx":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("b2241f391c68b778")(import.meta.resolve("gVtWq")),
    import("fkhcU")
]).then(()=>module.bundle.root('fhUQb'));

},{"b2241f391c68b778":"deFMk"}],"3GNyi":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("8248cd61eb278874")(import.meta.resolve("5v1Xt")),
    import("epbRr")
]).then(()=>module.bundle.root('2NiZk'));

},{"8248cd61eb278874":"deFMk"}],"8Vebl":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("7917d351d51e6779")(import.meta.resolve("3hqzg")),
    import("431tA")
]).then(()=>module.bundle.root('cQYA3'));

},{"7917d351d51e6779":"deFMk"}],"4CR5r":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    import("79zYt"),
    require("6017bf0058f38cea")(import.meta.resolve("k7vjD")),
    import("hIJVv"),
    import("29j97")
]).then(()=>module.bundle.root('e2Y2K'));

},{"6017bf0058f38cea":"deFMk"}],"bIbcQ":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("dc1b837b60d38328")(import.meta.resolve("eQ8Nc")),
    import("79zYt"),
    import("hIJVv"),
    import("7PDw0")
]).then(()=>module.bundle.root('kHnvt'));

},{"dc1b837b60d38328":"deFMk"}],"gNtJK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MESH_ACCEPT_RATIO", ()=>MESH_ACCEPT_RATIO);
parcelHelpers.export(exports, "HTML_CANVAS_HEIGHT", ()=>HTML_CANVAS_HEIGHT);
parcelHelpers.export(exports, "HTML_CANVAS_WIDTH", ()=>HTML_CANVAS_WIDTH);
const MESH_ACCEPT_RATIO = 66 / 142;
const HTML_CANVAS_HEIGHT = 952;
const HTML_CANVAS_WIDTH = HTML_CANVAS_HEIGHT * MESH_ACCEPT_RATIO;
exports.default = {
    MESH_ACCEPT_RATIO,
    HTML_CANVAS_HEIGHT,
    HTML_CANVAS_WIDTH
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"uHGJK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MOBILE_SCROLL_HEIGHT", ()=>MOBILE_SCROLL_HEIGHT);
parcelHelpers.export(exports, "SOCIAL_LINKS", ()=>SOCIAL_LINKS);
parcelHelpers.export(exports, "REQUIRE_ANALYTICS_CONSENT", ()=>REQUIRE_ANALYTICS_CONSENT);
parcelHelpers.export(exports, "HIDE_SECTIONS", ()=>HIDE_SECTIONS);
const MOBILE_SCROLL_HEIGHT = 16000;
const SOCIAL_LINKS = {
    instagram: 'https://www.instagram.com/miniptofficial',
    youtube: 'https://www.youtube.com/@miniPT.',
    twitter: 'https://twitter.com'
};
const REQUIRE_ANALYTICS_CONSENT = false;
const HIDE_SECTIONS = {
    BLOG: true,
    MEDIA_REPORTS: true
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9qh7Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TEAM_MEMBERS", ()=>TEAM_MEMBERS);
var _teamMember1Webp = require("url:../assets/images/team-member-1.webp");
var _teamMember1WebpDefault = parcelHelpers.interopDefault(_teamMember1Webp);
var _teamMember2Webp = require("url:../assets/images/team-member-2.webp");
var _teamMember2WebpDefault = parcelHelpers.interopDefault(_teamMember2Webp);
var _teamMember3Webp = require("url:../assets/images/team-member-3.webp");
var _teamMember3WebpDefault = parcelHelpers.interopDefault(_teamMember3Webp);
var _teamMember1Mp4 = require("url:../assets/videos/team-member-1.mp4");
var _teamMember1Mp4Default = parcelHelpers.interopDefault(_teamMember1Mp4);
var _teamMember2Mp4 = require("url:../assets/videos/team-member-2.mp4");
var _teamMember2Mp4Default = parcelHelpers.interopDefault(_teamMember2Mp4);
var _teamMember3Mp4 = require("url:../assets/videos/team-member-3.mp4");
var _teamMember3Mp4Default = parcelHelpers.interopDefault(_teamMember3Mp4);
const TEAM_MEMBERS = [
    {
        id: 0,
        image: (0, _teamMember1WebpDefault.default),
        video: (0, _teamMember1Mp4Default.default),
        name: 'Samuel Roberts',
        role: 'Founder and CEO',
        linkedinUrl: 'https://www.linkedin.com/in/samuel-roberts-311ab2153/'
    },
    {
        id: 1,
        image: (0, _teamMember2WebpDefault.default),
        video: (0, _teamMember2Mp4Default.default),
        name: 'Longbo Kong',
        role: 'Lead Engineer',
        linkedinUrl: 'https://www.linkedin.com/in/longbo-kong-533a446b'
    },
    {
        id: 2,
        image: (0, _teamMember3WebpDefault.default),
        video: (0, _teamMember3Mp4Default.default),
        name: 'Mike Saraswat',
        role: 'Senior Advisor',
        linkedinUrl: 'https://www.linkedin.com/in/mikesaraswat/'
    }
];

},{"url:../assets/images/team-member-1.webp":"hpuXZ","url:../assets/images/team-member-2.webp":"kRS6U","url:../assets/images/team-member-3.webp":"hJUMg","url:../assets/videos/team-member-1.mp4":"7Jwb5","url:../assets/videos/team-member-2.mp4":"esdD2","url:../assets/videos/team-member-3.mp4":"b3nQE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hpuXZ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("hgK1I");

},{}],"kRS6U":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("e2zno");

},{}],"hJUMg":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cEwHw");

},{}],"7Jwb5":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1ClHe");

},{}],"esdD2":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fJqP6");

},{}],"b3nQE":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dqHPf");

},{}],"5v9Dr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "USER_TESTIMONIAL", ()=>USER_TESTIMONIAL);
var _alisonBakerWebp = require("url:../assets/images/testimonials/alison-baker.webp");
var _alisonBakerWebpDefault = parcelHelpers.interopDefault(_alisonBakerWebp);
var _emmaReynoldsWebp = require("url:../assets/images/testimonials/emma-reynolds.webp");
var _emmaReynoldsWebpDefault = parcelHelpers.interopDefault(_emmaReynoldsWebp);
var _lucaMudrichWebp = require("url:../assets/images/testimonials/luca-mudrich.webp");
var _lucaMudrichWebpDefault = parcelHelpers.interopDefault(_lucaMudrichWebp);
var _sarahKellyWebp = require("url:../assets/images/testimonials/sarah-kelly.webp");
var _sarahKellyWebpDefault = parcelHelpers.interopDefault(_sarahKellyWebp);
const USER_TESTIMONIAL = [
    {
        id: 0,
        avatar: (0, _alisonBakerWebpDefault.default),
        name: 'Alison Baker',
        username: '@alison.baker',
        text: "I love how miniPT keeps me consistent. The real-time feedback feels like having a trainer with me \u2014 even when I\u2019m working out at home."
    },
    {
        id: 1,
        avatar: (0, _emmaReynoldsWebpDefault.default),
        name: 'Emma Reynolds',
        username: '@emmafitjourney',
        text: 'MiniPT helped me finally stay consistent with strength training. The clear cues and tracking keep me motivated every session.'
    },
    {
        id: 2,
        avatar: (0, _lucaMudrichWebpDefault.default),
        name: 'Luca Mudrich',
        username: '@lucamudrich',
        text: "I started using miniPT to rebuild my routine after an injury. The form corrections are super helpful \u2014 I feel safer and stronger every week."
    },
    {
        id: 3,
        avatar: (0, _sarahKellyWebpDefault.default),
        name: 'Sarah Kelly',
        username: '@sarahhkelly123',
        text: 'My goal was weight loss, and miniPT made the whole process feel manageable. Short, effective workouts + accountability = perfect combo.'
    }
];

},{"url:../assets/images/testimonials/alison-baker.webp":"8snhM","url:../assets/images/testimonials/emma-reynolds.webp":"8U5se","url:../assets/images/testimonials/luca-mudrich.webp":"4UL2i","url:../assets/images/testimonials/sarah-kelly.webp":"iRh6y","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8snhM":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("xlx85");

},{}],"8U5se":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("13DY9");

},{}],"4UL2i":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ivl9d");

},{}],"iRh6y":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("76rtM");

},{}],"hUzmH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BLOG_POSTS", ()=>BLOG_POSTS);
var _blogPoster1Webp = require("url:../assets/images/blog-poster-1.webp");
var _blogPoster1WebpDefault = parcelHelpers.interopDefault(_blogPoster1Webp);
var _blogPoster2Webp = require("url:../assets/images/blog-poster-2.webp");
var _blogPoster2WebpDefault = parcelHelpers.interopDefault(_blogPoster2Webp);
var _blogPoster3Webp = require("url:../assets/images/blog-poster-3.webp");
var _blogPoster3WebpDefault = parcelHelpers.interopDefault(_blogPoster3Webp);
const BLOG_POSTS = [
    {
        id: 0,
        image: (0, _blogPoster1WebpDefault.default),
        title: 'How AI is changing personal training forever',
        description: "Discover how AI-powered motion tracking and real-time feedback are transforming workouts \u2014 making personal training accessible to everyone, anywhere."
    },
    {
        id: 1,
        image: (0, _blogPoster2WebpDefault.default),
        title: "Why motivation isn\u2019t enough",
        description: 'Learn why willpower fades and how smart workout guidance keeps you on track, even when motivation dips.'
    },
    {
        id: 2,
        image: (0, _blogPoster3WebpDefault.default),
        title: 'How to prepare for your miniPT workout',
        description: "Learn the simple steps to get ready for your session \u2014 from setting up your space to warming up, so every workout is effective and safe."
    }
];

},{"url:../assets/images/blog-poster-1.webp":"2WP3I","url:../assets/images/blog-poster-2.webp":"d7m6f","url:../assets/images/blog-poster-3.webp":"d6K4k","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2WP3I":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("39E6S");

},{}],"d7m6f":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kgjHb");

},{}],"d6K4k":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gpvo1");

},{}],"g0894":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _buttonModuleCss = require("./Button.module.css");
const Button = /*#__PURE__*/ (0, _react.memo)(/*#__PURE__*/ (0, _react.forwardRef)(({ className, disabled, children, onClick, variant = 'primary', icon, iconWidth = 24, isLoading = false, svg, style, ...rest }, ref)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
        ref: ref,
        disabled: disabled,
        style: style,
        className: `${variant === 'primary' ? `${_buttonModuleCss.primary} primary-button` : variant === 'secondary' ? `${_buttonModuleCss.secondary} secondary-button` : variant === 'light' ? `${_buttonModuleCss.light} light-button` : variant === 'outline' ? `${_buttonModuleCss.outline} outline-button` : ''} ${className ?? ''}`,
        onClick: onClick,
        ...rest,
        children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            className: _buttonModuleCss.spinner
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: icon,
                    className: _buttonModuleCss.iconLeft,
                    style: {
                        width: iconWidth
                    },
                    alt: ""
                }),
                svg && svg,
                children
            ]
        })
    });
}));
Button.displayName = 'Button';

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./Button.module.css":"93Vtq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"93Vtq":[function(require,module,exports,__globalThis) {
module.exports["iconLeft"] = `-_VRTG_iconLeft`;
module.exports["light"] = `-_VRTG_light`;
module.exports["outline"] = `-_VRTG_outline`;
module.exports["primary"] = `-_VRTG_primary`;
module.exports["secondary"] = `-_VRTG_secondary`;
module.exports["spin"] = `-_VRTG_spin`;
module.exports["spin"];
module.exports["spinner"] = `-_VRTG_spinner`;

},{}],"afPPd":[function(require,module,exports,__globalThis) {
// src/hooks/useMobilePhonePin.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMobilePhonePin", ()=>useMobilePhonePin);
var _react = require("react");
var _gsapSetup = require("src/utils/gsapSetup");
var _gsapSetupDefault = parcelHelpers.interopDefault(_gsapSetup);
function useMobilePhonePin({ triggerClass, pinClass, scrollHeight, onProgress, markers = false }) {
    const rafScheduled = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        const ctx = (0, _gsapSetupDefault.default).context(()=>{
            (0, _gsapSetupDefault.default).to({}, {
                scrollTrigger: {
                    trigger: triggerClass,
                    start: 'center-=32 center',
                    end: `+=${scrollHeight - 700}`,
                    pin: pinClass,
                    scrub: 1,
                    markers,
                    invalidateOnRefresh: false,
                    onUpdate (self) {
                        if (rafScheduled.current) return;
                        rafScheduled.current = true;
                        requestAnimationFrame(()=>{
                            rafScheduled.current = false;
                            onProgress(self.progress);
                        });
                    }
                }
            });
        });
        return ()=>ctx.revert();
    }, [
        triggerClass,
        pinClass,
        scrollHeight,
        onProgress,
        markers
    ]);
}

},{"react":"bmhQu","src/utils/gsapSetup":"8koI4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8koI4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _gsap = require("gsap");
var _scrollTrigger = require("gsap/ScrollTrigger");
var _scrollSmoother = require("gsap/ScrollSmoother");
var _scrollToPlugin = require("gsap/ScrollToPlugin");
(0, _gsap.gsap).registerPlugin((0, _scrollTrigger.ScrollTrigger), (0, _scrollSmoother.ScrollSmoother), (0, _scrollToPlugin.ScrollToPlugin));
exports.default = (0, _gsap.gsap);

},{"gsap":"kKW9v","gsap/ScrollTrigger":"6usvx","gsap/ScrollSmoother":"4XNUc","gsap/ScrollToPlugin":"fqoay","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kKW9v":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gsap", ()=>gsapWithCSS);
parcelHelpers.export(exports, "default", ()=>gsapWithCSS);
parcelHelpers.export(exports, "CSSPlugin", ()=>(0, _csspluginJs.CSSPlugin));
parcelHelpers.export(exports, "TweenMax", ()=>TweenMaxWithCSS);
parcelHelpers.export(exports, "TweenLite", ()=>(0, _gsapCoreJs.TweenLite));
parcelHelpers.export(exports, "TimelineMax", ()=>(0, _gsapCoreJs.TimelineMax));
parcelHelpers.export(exports, "TimelineLite", ()=>(0, _gsapCoreJs.TimelineLite));
parcelHelpers.export(exports, "Power0", ()=>(0, _gsapCoreJs.Power0));
parcelHelpers.export(exports, "Power1", ()=>(0, _gsapCoreJs.Power1));
parcelHelpers.export(exports, "Power2", ()=>(0, _gsapCoreJs.Power2));
parcelHelpers.export(exports, "Power3", ()=>(0, _gsapCoreJs.Power3));
parcelHelpers.export(exports, "Power4", ()=>(0, _gsapCoreJs.Power4));
parcelHelpers.export(exports, "Linear", ()=>(0, _gsapCoreJs.Linear));
parcelHelpers.export(exports, "Quad", ()=>(0, _gsapCoreJs.Quad));
parcelHelpers.export(exports, "Cubic", ()=>(0, _gsapCoreJs.Cubic));
parcelHelpers.export(exports, "Quart", ()=>(0, _gsapCoreJs.Quart));
parcelHelpers.export(exports, "Quint", ()=>(0, _gsapCoreJs.Quint));
parcelHelpers.export(exports, "Strong", ()=>(0, _gsapCoreJs.Strong));
parcelHelpers.export(exports, "Elastic", ()=>(0, _gsapCoreJs.Elastic));
parcelHelpers.export(exports, "Back", ()=>(0, _gsapCoreJs.Back));
parcelHelpers.export(exports, "SteppedEase", ()=>(0, _gsapCoreJs.SteppedEase));
parcelHelpers.export(exports, "Bounce", ()=>(0, _gsapCoreJs.Bounce));
parcelHelpers.export(exports, "Sine", ()=>(0, _gsapCoreJs.Sine));
parcelHelpers.export(exports, "Expo", ()=>(0, _gsapCoreJs.Expo));
parcelHelpers.export(exports, "Circ", ()=>(0, _gsapCoreJs.Circ));
var _gsapCoreJs = require("./gsap-core.js");
var _csspluginJs = require("./CSSPlugin.js");
var gsapWithCSS = (0, _gsapCoreJs.gsap).registerPlugin((0, _csspluginJs.CSSPlugin)) || (0, _gsapCoreJs.gsap), // to protect from tree shaking
TweenMaxWithCSS = gsapWithCSS.core.Tween;

},{"./gsap-core.js":"5DEyn","./CSSPlugin.js":"6eg9y","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5DEyn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GSCache", ()=>GSCache);
parcelHelpers.export(exports, "Animation", ()=>Animation);
parcelHelpers.export(exports, "Timeline", ()=>Timeline);
parcelHelpers.export(exports, "Tween", ()=>Tween);
parcelHelpers.export(exports, "PropTween", ()=>PropTween);
parcelHelpers.export(exports, "gsap", ()=>gsap);
parcelHelpers.export(exports, "Power0", ()=>Power0);
parcelHelpers.export(exports, "Power1", ()=>Power1);
parcelHelpers.export(exports, "Power2", ()=>Power2);
parcelHelpers.export(exports, "Power3", ()=>Power3);
parcelHelpers.export(exports, "Power4", ()=>Power4);
parcelHelpers.export(exports, "Linear", ()=>Linear);
parcelHelpers.export(exports, "Quad", ()=>Quad);
parcelHelpers.export(exports, "Cubic", ()=>Cubic);
parcelHelpers.export(exports, "Quart", ()=>Quart);
parcelHelpers.export(exports, "Quint", ()=>Quint);
parcelHelpers.export(exports, "Strong", ()=>Strong);
parcelHelpers.export(exports, "Elastic", ()=>Elastic);
parcelHelpers.export(exports, "Back", ()=>Back);
parcelHelpers.export(exports, "SteppedEase", ()=>SteppedEase);
parcelHelpers.export(exports, "Bounce", ()=>Bounce);
parcelHelpers.export(exports, "Sine", ()=>Sine);
parcelHelpers.export(exports, "Expo", ()=>Expo);
parcelHelpers.export(exports, "Circ", ()=>Circ);
parcelHelpers.export(exports, "TweenMax", ()=>Tween) //export some internal methods/orojects for use in CSSPlugin so that we can externalize that file and allow custom builds that exclude it.
;
parcelHelpers.export(exports, "TweenLite", ()=>Tween);
parcelHelpers.export(exports, "TimelineMax", ()=>Timeline);
parcelHelpers.export(exports, "TimelineLite", ()=>Timeline);
parcelHelpers.export(exports, "default", ()=>gsap);
parcelHelpers.export(exports, "wrap", ()=>wrap);
parcelHelpers.export(exports, "wrapYoyo", ()=>wrapYoyo);
parcelHelpers.export(exports, "distribute", ()=>distribute);
parcelHelpers.export(exports, "random", ()=>random);
parcelHelpers.export(exports, "snap", ()=>snap);
parcelHelpers.export(exports, "normalize", ()=>normalize);
parcelHelpers.export(exports, "getUnit", ()=>getUnit);
parcelHelpers.export(exports, "clamp", ()=>clamp);
parcelHelpers.export(exports, "splitColor", ()=>splitColor);
parcelHelpers.export(exports, "toArray", ()=>toArray);
parcelHelpers.export(exports, "selector", ()=>selector);
parcelHelpers.export(exports, "mapRange", ()=>mapRange);
parcelHelpers.export(exports, "pipe", ()=>pipe);
parcelHelpers.export(exports, "unitize", ()=>unitize);
parcelHelpers.export(exports, "interpolate", ()=>interpolate);
parcelHelpers.export(exports, "shuffle", ()=>shuffle);
parcelHelpers.export(exports, "_getProperty", ()=>_getProperty);
parcelHelpers.export(exports, "_numExp", ()=>_numExp);
parcelHelpers.export(exports, "_numWithUnitExp", ()=>_numWithUnitExp);
parcelHelpers.export(exports, "_isString", ()=>_isString);
parcelHelpers.export(exports, "_isUndefined", ()=>_isUndefined);
parcelHelpers.export(exports, "_renderComplexString", ()=>_renderComplexString);
parcelHelpers.export(exports, "_relExp", ()=>_relExp);
parcelHelpers.export(exports, "_setDefaults", ()=>_setDefaults);
parcelHelpers.export(exports, "_removeLinkedListItem", ()=>_removeLinkedListItem);
parcelHelpers.export(exports, "_forEachName", ()=>_forEachName);
parcelHelpers.export(exports, "_sortPropTweensByPriority", ()=>_sortPropTweensByPriority);
parcelHelpers.export(exports, "_colorStringFilter", ()=>_colorStringFilter);
parcelHelpers.export(exports, "_replaceRandom", ()=>_replaceRandom);
parcelHelpers.export(exports, "_checkPlugin", ()=>_checkPlugin);
parcelHelpers.export(exports, "_plugins", ()=>_plugins);
parcelHelpers.export(exports, "_ticker", ()=>_ticker);
parcelHelpers.export(exports, "_config", ()=>_config);
parcelHelpers.export(exports, "_roundModifier", ()=>_roundModifier);
parcelHelpers.export(exports, "_round", ()=>_round);
parcelHelpers.export(exports, "_missingPlugin", ()=>_missingPlugin);
parcelHelpers.export(exports, "_getSetter", ()=>_getSetter);
parcelHelpers.export(exports, "_getCache", ()=>_getCache);
parcelHelpers.export(exports, "_colorExp", ()=>_colorExp);
parcelHelpers.export(exports, "_parseRelative", ()=>_parseRelative);
function _assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function _inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/*!
 * GSAP 3.14.2
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var _config = {
    autoSleep: 120,
    force3D: "auto",
    nullTargetWarn: 1,
    units: {
        lineHeight: ""
    }
}, _defaults = {
    duration: .5,
    overwrite: false,
    delay: 0
}, _suppressOverwrites, _reverting, _context, _bigNum = 1e8, _tinyNum = 1 / _bigNum, _2PI = Math.PI * 2, _HALF_PI = _2PI / 4, _gsID = 0, _sqrt = Math.sqrt, _cos = Math.cos, _sin = Math.sin, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isUndefined = function _isUndefined(value) {
    return typeof value === "undefined";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _isNotFalse = function _isNotFalse(value) {
    return value !== false;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _isFuncOrString = function _isFuncOrString(value) {
    return _isFunction(value) || _isString(value);
}, _isTypedArray = typeof ArrayBuffer === "function" && ArrayBuffer.isView || function() {}, // note: IE10 has ArrayBuffer, but NOT ArrayBuffer.isView().
_isArray = Array.isArray, _randomExp = /random\([^)]+\)/g, _commaDelimExp = /,\s*/g, _strictNumExp = /(?:-?\.?\d|\.)+/gi, //only numbers (including negatives and decimals) but NOT relative values.
_numExp = /[-+=.]*\d+[.e\-+]*\d*[e\-+]*\d*/g, //finds any numbers, including ones that start with += or -=, negative numbers, and ones in scientific notation like 1e-8.
_numWithUnitExp = /[-+=.]*\d+[.e-]*\d*[a-z%]*/g, _complexStringNumExp = /[-+=.]*\d+\.?\d*(?:e-|e\+)?\d*/gi, //duplicate so that while we're looping through matches from exec(), it doesn't contaminate the lastIndex of _numExp which we use to search for colors too.
_relExp = /[+-]=-?[.\d]+/, _delimitedValueExp = /[^,'"\[\]\s]+/gi, // previously /[#\-+.]*\b[a-z\d\-=+%.]+/gi but didn't catch special characters.
_unitExp = /^[+\-=e\s\d]*\d+[.\d]*([a-z]*|%)\s*$/i, _globalTimeline, _win, _coreInitted, _doc, _globals = {}, _installScope = {}, _coreReady, _install = function _install(scope) {
    return (_installScope = _merge(scope, _globals)) && gsap;
}, _missingPlugin = function _missingPlugin(property, value) {
    return console.warn("Invalid property", property, "set to", value, "Missing plugin? gsap.registerPlugin()");
}, _warn = function _warn(message, suppress) {
    return !suppress && console.warn(message);
}, _addGlobal = function _addGlobal(name, obj) {
    return name && (_globals[name] = obj) && _installScope && (_installScope[name] = obj) || _globals;
}, _emptyFunc = function _emptyFunc() {
    return 0;
}, _startAtRevertConfig = {
    suppressEvents: true,
    isStart: true,
    kill: false
}, _revertConfigNoKill = {
    suppressEvents: true,
    kill: false
}, _revertConfig = {
    suppressEvents: true
}, _reservedProps = {}, _lazyTweens = [], _lazyLookup = {}, _lastRenderedFrame, _plugins = {}, _effects = {}, _nextGCFrame = 30, _harnessPlugins = [], _callbackNames = "", _harness = function _harness(targets) {
    var target = targets[0], harnessPlugin, i;
    _isObject(target) || _isFunction(target) || (targets = [
        targets
    ]);
    if (!(harnessPlugin = (target._gsap || {}).harness)) {
        // find the first target with a harness. We assume targets passed into an animation will be of similar type, meaning the same kind of harness can be used for them all (performance optimization)
        i = _harnessPlugins.length;
        while(i-- && !_harnessPlugins[i].targetTest(target));
        harnessPlugin = _harnessPlugins[i];
    }
    i = targets.length;
    while(i--)targets[i] && (targets[i]._gsap || (targets[i]._gsap = new GSCache(targets[i], harnessPlugin))) || targets.splice(i, 1);
    return targets;
}, _getCache = function _getCache(target) {
    return target._gsap || _harness(toArray(target))[0]._gsap;
}, _getProperty = function _getProperty(target, property, v) {
    return (v = target[property]) && _isFunction(v) ? target[property]() : _isUndefined(v) && target.getAttribute && target.getAttribute(property) || v;
}, _forEachName = function _forEachName(names, func) {
    return (names = names.split(",")).forEach(func) || names;
}, //split a comma-delimited list of names into an array, then run a forEach() function and return the split array (this is just a way to consolidate/shorten some code).
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _roundPrecise = function _roundPrecise(value) {
    return Math.round(value * 10000000) / 10000000 || 0;
}, // increased precision mostly for timing values.
_parseRelative = function _parseRelative(start, value) {
    var operator = value.charAt(0), end = parseFloat(value.substr(2));
    start = parseFloat(start);
    return operator === "+" ? start + end : operator === "-" ? start - end : operator === "*" ? start * end : start / end;
}, _arrayContainsAny = function _arrayContainsAny(toSearch, toFind) {
    //searches one array to find matches for any of the items in the toFind array. As soon as one is found, it returns true. It does NOT return all the matches; it's simply a boolean search.
    var l = toFind.length, i = 0;
    for(; toSearch.indexOf(toFind[i]) < 0 && ++i < l;);
    return i < l;
}, _lazyRender = function _lazyRender() {
    var l = _lazyTweens.length, a = _lazyTweens.slice(0), i, tween;
    _lazyLookup = {};
    _lazyTweens.length = 0;
    for(i = 0; i < l; i++){
        tween = a[i];
        tween && tween._lazy && (tween.render(tween._lazy[0], tween._lazy[1], true)._lazy = 0);
    }
}, _isRevertWorthy = function _isRevertWorthy(animation) {
    return !!(animation._initted || animation._startAt || animation.add);
}, _lazySafeRender = function _lazySafeRender(animation, time, suppressEvents, force) {
    _lazyTweens.length && !_reverting && _lazyRender();
    animation.render(time, suppressEvents, force || !!(_reverting && time < 0 && _isRevertWorthy(animation)));
    _lazyTweens.length && !_reverting && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when someone calls seek() or time() or progress(), they expect an immediate render.
}, _numericIfPossible = function _numericIfPossible(value) {
    var n = parseFloat(value);
    return (n || n === 0) && (value + "").match(_delimitedValueExp).length < 2 ? n : _isString(value) ? value.trim() : value;
}, _passThrough = function _passThrough(p) {
    return p;
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _setKeyframeDefaults = function _setKeyframeDefaults(excludeDuration) {
    return function(obj, defaults) {
        for(var p in defaults)p in obj || p === "duration" && excludeDuration || p === "ease" || (obj[p] = defaults[p]);
    };
}, _merge = function _merge(base, toMerge) {
    for(var p in toMerge)base[p] = toMerge[p];
    return base;
}, _mergeDeep = function _mergeDeep(base, toMerge) {
    for(var p in toMerge)p !== "__proto__" && p !== "constructor" && p !== "prototype" && (base[p] = _isObject(toMerge[p]) ? _mergeDeep(base[p] || (base[p] = {}), toMerge[p]) : toMerge[p]);
    return base;
}, _copyExcluding = function _copyExcluding(obj, excluding) {
    var copy = {}, p;
    for(p in obj)p in excluding || (copy[p] = obj[p]);
    return copy;
}, _inheritDefaults = function _inheritDefaults(vars) {
    var parent = vars.parent || _globalTimeline, func = vars.keyframes ? _setKeyframeDefaults(_isArray(vars.keyframes)) : _setDefaults;
    if (_isNotFalse(vars.inherit)) while(parent){
        func(vars, parent.vars.defaults);
        parent = parent.parent || parent._dp;
    }
    return vars;
}, _arraysMatch = function _arraysMatch(a1, a2) {
    var i = a1.length, match = i === a2.length;
    while(match && i-- && a1[i] === a2[i]);
    return i < 0;
}, _addLinkedListItem = function _addLinkedListItem(parent, child, firstProp, lastProp, sortBy) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = parent[lastProp], t;
    if (sortBy) {
        t = child[sortBy];
        while(prev && prev[sortBy] > t)prev = prev._prev;
    }
    if (prev) {
        child._next = prev._next;
        prev._next = child;
    } else {
        child._next = parent[firstProp];
        parent[firstProp] = child;
    }
    if (child._next) child._next._prev = child;
    else parent[lastProp] = child;
    child._prev = prev;
    child.parent = child._dp = parent;
    return child;
}, _removeLinkedListItem = function _removeLinkedListItem(parent, child, firstProp, lastProp) {
    if (firstProp === void 0) firstProp = "_first";
    if (lastProp === void 0) lastProp = "_last";
    var prev = child._prev, next = child._next;
    if (prev) prev._next = next;
    else if (parent[firstProp] === child) parent[firstProp] = next;
    if (next) next._prev = prev;
    else if (parent[lastProp] === child) parent[lastProp] = prev;
    child._next = child._prev = child.parent = null; // don't delete the _dp just so we can revert if necessary. But parent should be null to indicate the item isn't in a linked list.
}, _removeFromParent = function _removeFromParent(child, onlyIfParentHasAutoRemove) {
    child.parent && (!onlyIfParentHasAutoRemove || child.parent.autoRemoveChildren) && child.parent.remove && child.parent.remove(child);
    child._act = 0;
}, _uncache = function _uncache(animation, child) {
    if (animation && (!child || child._end > animation._dur || child._start < 0)) {
        // performance optimization: if a child animation is passed in we should only uncache if that child EXTENDS the animation (its end time is beyond the end)
        var a = animation;
        while(a){
            a._dirty = 1;
            a = a.parent;
        }
    }
    return animation;
}, _recacheAncestors = function _recacheAncestors(animation) {
    var parent = animation.parent;
    while(parent && parent.parent){
        //sometimes we must force a re-sort of all children and update the duration/totalDuration of all ancestor timelines immediately in case, for example, in the middle of a render loop, one tween alters another tween's timeScale which shoves its startTime before 0, forcing the parent timeline to shift around and shiftChildren() which could affect that next tween's render (startTime). Doesn't matter for the root timeline though.
        parent._dirty = 1;
        parent.totalDuration();
        parent = parent.parent;
    }
    return animation;
}, _rewindStartAt = function _rewindStartAt(tween, totalTime, suppressEvents, force) {
    return tween._startAt && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween.vars.immediateRender && !tween.vars.autoRevert || tween._startAt.render(totalTime, true, force));
}, _hasNoPausedAncestors = function _hasNoPausedAncestors(animation) {
    return !animation || animation._ts && _hasNoPausedAncestors(animation.parent);
}, _elapsedCycleDuration = function _elapsedCycleDuration(animation) {
    return animation._repeat ? _animationCycle(animation._tTime, animation = animation.duration() + animation._rDelay) * animation : 0;
}, // feed in the totalTime and cycleDuration and it'll return the cycle (iteration minus 1) and if the playhead is exactly at the very END, it will NOT bump up to the next cycle.
_animationCycle = function _animationCycle(tTime, cycleDuration) {
    var whole = Math.floor(tTime = _roundPrecise(tTime / cycleDuration));
    return tTime && whole === tTime ? whole - 1 : whole;
}, _parentToChildTotalTime = function _parentToChildTotalTime(parentTime, child) {
    return (parentTime - child._start) * child._ts + (child._ts >= 0 ? 0 : child._dirty ? child.totalDuration() : child._tDur);
}, _setEnd = function _setEnd(animation) {
    return animation._end = _roundPrecise(animation._start + (animation._tDur / Math.abs(animation._ts || animation._rts || _tinyNum) || 0));
}, _alignPlayhead = function _alignPlayhead(animation, totalTime) {
    // adjusts the animation's _start and _end according to the provided totalTime (only if the parent's smoothChildTiming is true and the animation isn't paused). It doesn't do any rendering or forcing things back into parent timelines, etc. - that's what totalTime() is for.
    var parent = animation._dp;
    if (parent && parent.smoothChildTiming && animation._ts) {
        animation._start = _roundPrecise(parent._time - (animation._ts > 0 ? totalTime / animation._ts : ((animation._dirty ? animation.totalDuration() : animation._tDur) - totalTime) / -animation._ts));
        _setEnd(animation);
        parent._dirty || _uncache(parent, animation); //for performance improvement. If the parent's cache is already dirty, it already took care of marking the ancestors as dirty too, so skip the function call here.
    }
    return animation;
}, /*
_totalTimeToTime = (clampedTotalTime, duration, repeat, repeatDelay, yoyo) => {
	let cycleDuration = duration + repeatDelay,
		time = _round(clampedTotalTime % cycleDuration);
	if (time > duration) {
		time = duration;
	}
	return (yoyo && (~~(clampedTotalTime / cycleDuration) & 1)) ? duration - time : time;
},
*/ _postAddChecks = function _postAddChecks(timeline, child) {
    var t;
    if (child._time || !child._dur && child._initted || child._start < timeline._time && (child._dur || !child.add)) {
        // in case, for example, the _start is moved on a tween that has already rendered, or if it's being inserted into a timeline BEFORE where the playhead is currently. Imagine it's at its end state, then the startTime is moved WAY later (after the end of this timeline), it should render at its beginning. Special case: if it's a timeline (has .add() method) and no duration, we can skip rendering because the user may be populating it AFTER adding it to a parent timeline (unconventional, but possible, and we wouldn't want it to get removed if the parent's autoRemoveChildren is true).
        t = _parentToChildTotalTime(timeline.rawTime(), child);
        if (!child._dur || _clamp(0, child.totalDuration(), t) - child._tTime > _tinyNum) child.render(t, true);
    } //if the timeline has already ended but the inserted tween/timeline extends the duration, we should enable this timeline again so that it renders properly. We should also align the playhead with the parent timeline's when appropriate.
    if (_uncache(timeline, child)._dp && timeline._initted && timeline._time >= timeline._dur && timeline._ts) {
        //in case any of the ancestors had completed but should now be enabled...
        if (timeline._dur < timeline.duration()) {
            t = timeline;
            while(t._dp){
                t.rawTime() >= 0 && t.totalTime(t._tTime); //moves the timeline (shifts its startTime) if necessary, and also enables it. If it's currently zero, though, it may not be scheduled to render until later so there's no need to force it to align with the current playhead position. Only move to catch up with the playhead.
                t = t._dp;
            }
        }
        timeline._zTime = -_tinyNum; // helps ensure that the next render() will be forced (crossingStart = true in render()), even if the duration hasn't changed (we're adding a child which would need to get rendered). Definitely an edge case. Note: we MUST do this AFTER the loop above where the totalTime() might trigger a render() because this _addToTimeline() method gets called from the Animation constructor, BEFORE tweens even record their targets, etc. so we wouldn't want things to get triggered in the wrong order.
    }
}, _addToTimeline = function _addToTimeline(timeline, child, position, skipChecks) {
    child.parent && _removeFromParent(child);
    child._start = _roundPrecise((_isNumber(position) ? position : position || timeline !== _globalTimeline ? _parsePosition(timeline, position, child) : timeline._time) + child._delay);
    child._end = _roundPrecise(child._start + (child.totalDuration() / Math.abs(child.timeScale()) || 0));
    _addLinkedListItem(timeline, child, "_first", "_last", timeline._sort ? "_start" : 0);
    _isFromOrFromStart(child) || (timeline._recent = child);
    skipChecks || _postAddChecks(timeline, child);
    timeline._ts < 0 && _alignPlayhead(timeline, timeline._tTime); // if the timeline is reversed and the new child makes it longer, we may need to adjust the parent's _start (push it back)
    return timeline;
}, _scrollTrigger = function _scrollTrigger(animation, trigger) {
    return (_globals.ScrollTrigger || _missingPlugin("scrollTrigger", trigger)) && _globals.ScrollTrigger.create(trigger, animation);
}, _attemptInitTween = function _attemptInitTween(tween, time, force, suppressEvents, tTime) {
    _initTween(tween, time, tTime);
    if (!tween._initted) return 1;
    if (!force && tween._pt && !_reverting && (tween._dur && tween.vars.lazy !== false || !tween._dur && tween.vars.lazy) && _lastRenderedFrame !== _ticker.frame) {
        _lazyTweens.push(tween);
        tween._lazy = [
            tTime,
            suppressEvents
        ];
        return 1;
    }
}, _parentPlayheadIsBeforeStart = function _parentPlayheadIsBeforeStart(_ref) {
    var parent = _ref.parent;
    return parent && parent._ts && parent._initted && !parent._lock && (parent.rawTime() < 0 || _parentPlayheadIsBeforeStart(parent));
}, // check parent's _lock because when a timeline repeats/yoyos and does its artificial wrapping, we shouldn't force the ratio back to 0
_isFromOrFromStart = function _isFromOrFromStart(_ref2) {
    var data = _ref2.data;
    return data === "isFromStart" || data === "isStart";
}, _renderZeroDurationTween = function _renderZeroDurationTween(tween, totalTime, suppressEvents, force) {
    var prevRatio = tween.ratio, ratio = totalTime < 0 || !totalTime && (!tween._start && _parentPlayheadIsBeforeStart(tween) && !(!tween._initted && _isFromOrFromStart(tween)) || (tween._ts < 0 || tween._dp._ts < 0) && !_isFromOrFromStart(tween)) ? 0 : 1, // if the tween or its parent is reversed and the totalTime is 0, we should go to a ratio of 0. Edge case: if a from() or fromTo() stagger tween is placed later in a timeline, the "startAt" zero-duration tween could initially render at a time when the parent timeline's playhead is technically BEFORE where this tween is, so make sure that any "from" and "fromTo" startAt tweens are rendered the first time at a ratio of 1.
    repeatDelay = tween._rDelay, tTime = 0, pt, iteration, prevIteration;
    if (repeatDelay && tween._repeat) {
        // in case there's a zero-duration tween that has a repeat with a repeatDelay
        tTime = _clamp(0, tween._tDur, totalTime);
        iteration = _animationCycle(tTime, repeatDelay);
        tween._yoyo && iteration & 1 && (ratio = 1 - ratio);
        if (iteration !== _animationCycle(tween._tTime, repeatDelay)) {
            // if iteration changed
            prevRatio = 1 - ratio;
            tween.vars.repeatRefresh && tween._initted && tween.invalidate();
        }
    }
    if (ratio !== prevRatio || _reverting || force || tween._zTime === _tinyNum || !totalTime && tween._zTime) {
        if (!tween._initted && _attemptInitTween(tween, totalTime, force, suppressEvents, tTime)) // if we render the very beginning (time == 0) of a fromTo(), we must force the render (normal tweens wouldn't need to render at a time of 0 when the prevTime was also 0). This is also mandatory to make sure overwriting kicks in immediately.
        return;
        prevIteration = tween._zTime;
        tween._zTime = totalTime || (suppressEvents ? _tinyNum : 0); // when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration tween, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
        suppressEvents || (suppressEvents = totalTime && !prevIteration); // if it was rendered previously at exactly 0 (_zTime) and now the playhead is moving away, DON'T fire callbacks otherwise they'll seem like duplicates.
        tween.ratio = ratio;
        tween._from && (ratio = 1 - ratio);
        tween._time = 0;
        tween._tTime = tTime;
        pt = tween._pt;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        totalTime < 0 && _rewindStartAt(tween, totalTime, suppressEvents, true);
        tween._onUpdate && !suppressEvents && _callback(tween, "onUpdate");
        tTime && tween._repeat && !suppressEvents && tween.parent && _callback(tween, "onRepeat");
        if ((totalTime >= tween._tDur || totalTime < 0) && tween.ratio === ratio) {
            ratio && _removeFromParent(tween, 1);
            if (!suppressEvents && !_reverting) {
                _callback(tween, ratio ? "onComplete" : "onReverseComplete", true);
                tween._prom && tween._prom();
            }
        }
    } else if (!tween._zTime) tween._zTime = totalTime;
}, _findNextPauseTween = function _findNextPauseTween(animation, prevTime, time) {
    var child;
    if (time > prevTime) {
        child = animation._first;
        while(child && child._start <= time){
            if (child.data === "isPause" && child._start > prevTime) return child;
            child = child._next;
        }
    } else {
        child = animation._last;
        while(child && child._start >= time){
            if (child.data === "isPause" && child._start < prevTime) return child;
            child = child._prev;
        }
    }
}, _setDuration = function _setDuration(animation, duration, skipUncache, leavePlayhead) {
    var repeat = animation._repeat, dur = _roundPrecise(duration) || 0, totalProgress = animation._tTime / animation._tDur;
    totalProgress && !leavePlayhead && (animation._time *= dur / animation._dur);
    animation._dur = dur;
    animation._tDur = !repeat ? dur : repeat < 0 ? 1e10 : _roundPrecise(dur * (repeat + 1) + animation._rDelay * repeat);
    totalProgress > 0 && !leavePlayhead && _alignPlayhead(animation, animation._tTime = animation._tDur * totalProgress);
    animation.parent && _setEnd(animation);
    skipUncache || _uncache(animation.parent, animation);
    return animation;
}, _onUpdateTotalDuration = function _onUpdateTotalDuration(animation) {
    return animation instanceof Timeline ? _uncache(animation) : _setDuration(animation, animation._dur);
}, _zeroPosition = {
    _start: 0,
    endTime: _emptyFunc,
    totalDuration: _emptyFunc
}, _parsePosition = function _parsePosition(animation, position, percentAnimation) {
    var labels = animation.labels, recent = animation._recent || _zeroPosition, clippedDuration = animation.duration() >= _bigNum ? recent.endTime(false) : animation._dur, //in case there's a child that infinitely repeats, users almost never intend for the insertion point of a new child to be based on a SUPER long value like that so we clip it and assume the most recently-added child's endTime should be used instead.
    i, offset, isPercent;
    if (_isString(position) && (isNaN(position) || position in labels)) {
        //if the string is a number like "1", check to see if there's a label with that name, otherwise interpret it as a number (absolute value).
        offset = position.charAt(0);
        isPercent = position.substr(-1) === "%";
        i = position.indexOf("=");
        if (offset === "<" || offset === ">") {
            i >= 0 && (position = position.replace(/=/, ""));
            return (offset === "<" ? recent._start : recent.endTime(recent._repeat >= 0)) + (parseFloat(position.substr(1)) || 0) * (isPercent ? (i < 0 ? recent : percentAnimation).totalDuration() / 100 : 1);
        }
        if (i < 0) {
            position in labels || (labels[position] = clippedDuration);
            return labels[position];
        }
        offset = parseFloat(position.charAt(i - 1) + position.substr(i + 1));
        if (isPercent && percentAnimation) offset = offset / 100 * (_isArray(percentAnimation) ? percentAnimation[0] : percentAnimation).totalDuration();
        return i > 1 ? _parsePosition(animation, position.substr(0, i - 1), percentAnimation) + offset : clippedDuration + offset;
    }
    return position == null ? clippedDuration : +position;
}, _createTweenType = function _createTweenType(type, params, timeline) {
    var isLegacy = _isNumber(params[1]), varsIndex = (isLegacy ? 2 : 1) + (type < 2 ? 0 : 1), vars = params[varsIndex], irVars, parent;
    isLegacy && (vars.duration = params[1]);
    vars.parent = timeline;
    if (type) {
        irVars = vars;
        parent = timeline;
        while(parent && !("immediateRender" in irVars)){
            // inheritance hasn't happened yet, but someone may have set a default in an ancestor timeline. We could do vars.immediateRender = _isNotFalse(_inheritDefaults(vars).immediateRender) but that'd exact a slight performance penalty because _inheritDefaults() also runs in the Tween constructor. We're paying a small kb price here to gain speed.
            irVars = parent.vars.defaults || {};
            parent = _isNotFalse(parent.vars.inherit) && parent.parent;
        }
        vars.immediateRender = _isNotFalse(irVars.immediateRender);
        type < 2 ? vars.runBackwards = 1 : vars.startAt = params[varsIndex - 1]; // "from" vars
    }
    return new Tween(params[0], vars, params[varsIndex + 1]);
}, _conditionalReturn = function _conditionalReturn(value, func) {
    return value || value === 0 ? func(value) : func;
}, _clamp = function _clamp(min, max, value) {
    return value < min ? min : value > max ? max : value;
}, getUnit = function getUnit(value, v) {
    return !_isString(value) || !(v = _unitExp.exec(value)) ? "" : v[1];
}, // note: protect against padded numbers as strings, like "100.100". That shouldn't return "00" as the unit. If it's numeric, return no unit.
clamp = function clamp(min, max, value) {
    return _conditionalReturn(value, function(v) {
        return _clamp(min, max, v);
    });
}, _slice = [].slice, _isArrayLike = function _isArrayLike(value, nonEmpty) {
    return value && _isObject(value) && "length" in value && (!nonEmpty && !value.length || value.length - 1 in value && _isObject(value[0])) && !value.nodeType && value !== _win;
}, _flatten = function _flatten(ar, leaveStrings, accumulator) {
    if (accumulator === void 0) accumulator = [];
    return ar.forEach(function(value) {
        var _accumulator;
        return _isString(value) && !leaveStrings || _isArrayLike(value, 1) ? (_accumulator = accumulator).push.apply(_accumulator, toArray(value)) : accumulator.push(value);
    }) || accumulator;
}, // takes any value and returns an Array. If it's a string (and leaveStrings isn't true), it'll use document.querySelectorAll() and convert that to an array. It'll also accept iterables like jQuery objects.
toArray = function toArray(value, scope, leaveStrings) {
    return _context && !scope && _context.selector ? _context.selector(value) : _isString(value) && !leaveStrings && (_coreInitted || !_wake()) ? _slice.call((scope || _doc).querySelectorAll(value), 0) : _isArray(value) ? _flatten(value, leaveStrings) : _isArrayLike(value) ? _slice.call(value, 0) : value ? [
        value
    ] : [];
}, selector = function selector(value) {
    value = toArray(value)[0] || _warn("Invalid scope") || {};
    return function(v) {
        var el = value.current || value.nativeElement || value;
        return toArray(v, el.querySelectorAll ? el : el === value ? _warn("Invalid scope") || _doc.createElement("div") : value);
    };
}, shuffle = function shuffle(a) {
    return a.sort(function() {
        return .5 - Math.random();
    });
}, // alternative that's a bit faster and more reliably diverse but bigger:   for (let j, v, i = a.length; i; j = (Math.random() * i) | 0, v = a[--i], a[i] = a[j], a[j] = v); return a;
// for distributing values across an Array. Can accept a number, a function or (most commonly) an object which can contain the following properties: {base, amount, from, ease, grid, axis, length, each}. Returns a function that expects the following parameters: index, target, array.
distribute = function distribute(v) {
    if (_isFunction(v)) return v;
    var vars = _isObject(v) ? v : {
        each: v
    }, //n:1 is just to indicate v was a number; we leverage that later to set v according to the length we get. If a number is passed in, we treat it like the old stagger value where 0.1, for example, would mean that things would be distributed with 0.1 between each element in the array rather than a total "amount" that's chunked out among them all.
    ease = _parseEase(vars.ease), from = vars.from || 0, base = parseFloat(vars.base) || 0, cache = {}, isDecimal = from > 0 && from < 1, ratios = isNaN(from) || isDecimal, axis = vars.axis, ratioX = from, ratioY = from;
    if (_isString(from)) ratioX = ratioY = ({
        center: .5,
        edges: .5,
        end: 1
    })[from] || 0;
    else if (!isDecimal && ratios) {
        ratioX = from[0];
        ratioY = from[1];
    }
    return function(i, target, a) {
        var l = (a || vars).length, distances = cache[l], originX, originY, x, y, d, j, max, min, wrapAt;
        if (!distances) {
            wrapAt = vars.grid === "auto" ? 0 : (vars.grid || [
                1,
                _bigNum
            ])[1];
            if (!wrapAt) {
                max = -_bigNum;
                while(max < (max = a[wrapAt++].getBoundingClientRect().left) && wrapAt < l);
                wrapAt < l && wrapAt--;
            }
            distances = cache[l] = [];
            originX = ratios ? Math.min(wrapAt, l) * ratioX - .5 : from % wrapAt;
            originY = wrapAt === _bigNum ? 0 : ratios ? l * ratioY / wrapAt - .5 : from / wrapAt | 0;
            max = 0;
            min = _bigNum;
            for(j = 0; j < l; j++){
                x = j % wrapAt - originX;
                y = originY - (j / wrapAt | 0);
                distances[j] = d = !axis ? _sqrt(x * x + y * y) : Math.abs(axis === "y" ? y : x);
                d > max && (max = d);
                d < min && (min = d);
            }
            from === "random" && shuffle(distances);
            distances.max = max - min;
            distances.min = min;
            distances.v = l = (parseFloat(vars.amount) || parseFloat(vars.each) * (wrapAt > l ? l - 1 : !axis ? Math.max(wrapAt, l / wrapAt) : axis === "y" ? l / wrapAt : wrapAt) || 0) * (from === "edges" ? -1 : 1);
            distances.b = l < 0 ? base - l : base;
            distances.u = getUnit(vars.amount || vars.each) || 0; //unit
            ease = ease && l < 0 ? _invertEase(ease) : ease;
        }
        l = (distances[i] - distances.min) / distances.max || 0;
        return _roundPrecise(distances.b + (ease ? ease(l) : l) * distances.v) + distances.u; //round in order to work around floating point errors
    };
}, _roundModifier = function _roundModifier(v) {
    //pass in 0.1 get a function that'll round to the nearest tenth, or 5 to round to the closest 5, or 0.001 to the closest 1000th, etc.
    var p = Math.pow(10, ((v + "").split(".")[1] || "").length); //to avoid floating point math errors (like 24 * 0.1 == 2.4000000000000004), we chop off at a specific number of decimal places (much faster than toFixed())
    return function(raw) {
        var n = _roundPrecise(Math.round(parseFloat(raw) / v) * v * p);
        return (n - n % 1) / p + (_isNumber(raw) ? 0 : getUnit(raw)); // n - n % 1 replaces Math.floor() in order to handle negative values properly. For example, Math.floor(-150.00000000000003) is 151!
    };
}, snap = function snap(snapTo, value) {
    var isArray = _isArray(snapTo), radius, is2D;
    if (!isArray && _isObject(snapTo)) {
        radius = isArray = snapTo.radius || _bigNum;
        if (snapTo.values) {
            snapTo = toArray(snapTo.values);
            if (is2D = !_isNumber(snapTo[0])) radius *= radius; //performance optimization so we don't have to Math.sqrt() in the loop.
        } else snapTo = _roundModifier(snapTo.increment);
    }
    return _conditionalReturn(value, !isArray ? _roundModifier(snapTo) : _isFunction(snapTo) ? function(raw) {
        is2D = snapTo(raw);
        return Math.abs(is2D - raw) <= radius ? is2D : raw;
    } : function(raw) {
        var x = parseFloat(is2D ? raw.x : raw), y = parseFloat(is2D ? raw.y : 0), min = _bigNum, closest = 0, i = snapTo.length, dx, dy;
        while(i--){
            if (is2D) {
                dx = snapTo[i].x - x;
                dy = snapTo[i].y - y;
                dx = dx * dx + dy * dy;
            } else dx = Math.abs(snapTo[i] - x);
            if (dx < min) {
                min = dx;
                closest = i;
            }
        }
        closest = !radius || min <= radius ? snapTo[closest] : raw;
        return is2D || closest === raw || _isNumber(raw) ? closest : closest + getUnit(raw);
    });
}, random = function random(min, max, roundingIncrement, returnFunction) {
    return _conditionalReturn(_isArray(min) ? !max : roundingIncrement === true ? (roundingIncrement = 0, false) : !returnFunction, function() {
        return _isArray(min) ? min[~~(Math.random() * min.length)] : (roundingIncrement = roundingIncrement || 1e-5, returnFunction = roundingIncrement < 1 ? Math.pow(10, (roundingIncrement + "").length - 2) : 1) && Math.floor(Math.round((min - roundingIncrement / 2 + Math.random() * (max - min + roundingIncrement * .99)) / roundingIncrement) * roundingIncrement * returnFunction) / returnFunction;
    });
}, pipe = function pipe() {
    for(var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++)functions[_key] = arguments[_key];
    return function(value) {
        return functions.reduce(function(v, f) {
            return f(v);
        }, value);
    };
}, unitize = function unitize(func, unit) {
    return function(value) {
        return func(parseFloat(value)) + (unit || getUnit(value));
    };
}, normalize = function normalize(min, max, value) {
    return mapRange(min, max, 0, 1, value);
}, _wrapArray = function _wrapArray(a, wrapper, value) {
    return _conditionalReturn(value, function(index) {
        return a[~~wrapper(index)];
    });
}, wrap = function wrap(min, max, value) {
    // NOTE: wrap() CANNOT be an arrow function! A very odd compiling bug causes problems (unrelated to GSAP).
    var range = max - min;
    return _isArray(min) ? _wrapArray(min, wrap(0, min.length), max) : _conditionalReturn(value, function(value) {
        return (range + (value - min) % range) % range + min;
    });
}, wrapYoyo = function wrapYoyo(min, max, value) {
    var range = max - min, total = range * 2;
    return _isArray(min) ? _wrapArray(min, wrapYoyo(0, min.length - 1), max) : _conditionalReturn(value, function(value) {
        value = (total + (value - min) % total) % total || 0;
        return min + (value > range ? total - value : value);
    });
}, _replaceRandom = function _replaceRandom(s) {
    return s.replace(_randomExp, function(match) {
        //replaces all occurrences of random(...) in a string with the calculated random value. can be a range like random(-100, 100, 5) or an array like random([0, 100, 500])
        var arIndex = match.indexOf("[") + 1, values = match.substring(arIndex || 7, arIndex ? match.indexOf("]") : match.length - 1).split(_commaDelimExp);
        return random(arIndex ? values : +values[0], arIndex ? 0 : +values[1], +values[2] || 1e-5);
    });
}, mapRange = function mapRange(inMin, inMax, outMin, outMax, value) {
    var inRange = inMax - inMin, outRange = outMax - outMin;
    return _conditionalReturn(value, function(value) {
        return outMin + ((value - inMin) / inRange * outRange || 0);
    });
}, interpolate = function interpolate(start, end, progress, mutate) {
    var func = isNaN(start + end) ? 0 : function(p) {
        return (1 - p) * start + p * end;
    };
    if (!func) {
        var isString = _isString(start), master = {}, p, i, interpolators, l, il;
        progress === true && (mutate = 1) && (progress = null);
        if (isString) {
            start = {
                p: start
            };
            end = {
                p: end
            };
        } else if (_isArray(start) && !_isArray(end)) {
            interpolators = [];
            l = start.length;
            il = l - 2;
            for(i = 1; i < l; i++)interpolators.push(interpolate(start[i - 1], start[i])); //build the interpolators up front as a performance optimization so that when the function is called many times, it can just reuse them.
            l--;
            func = function func(p) {
                p *= l;
                var i = Math.min(il, ~~p);
                return interpolators[i](p - i);
            };
            progress = end;
        } else if (!mutate) start = _merge(_isArray(start) ? [] : {}, start);
        if (!interpolators) {
            for(p in end)_addPropTween.call(master, start, p, "get", end[p]);
            func = function func(p) {
                return _renderPropTweens(p, master) || (isString ? start.p : start);
            };
        }
    }
    return _conditionalReturn(progress, func);
}, _getLabelInDirection = function _getLabelInDirection(timeline, fromTime, backward) {
    //used for nextLabel() and previousLabel()
    var labels = timeline.labels, min = _bigNum, p, distance, label;
    for(p in labels){
        distance = labels[p] - fromTime;
        if (distance < 0 === !!backward && distance && min > (distance = Math.abs(distance))) {
            label = p;
            min = distance;
        }
    }
    return label;
}, _callback = function _callback(animation, type, executeLazyFirst) {
    var v = animation.vars, callback = v[type], prevContext = _context, context = animation._ctx, params, scope, result;
    if (!callback) return;
    params = v[type + "Params"];
    scope = v.callbackScope || animation;
    executeLazyFirst && _lazyTweens.length && _lazyRender(); //in case rendering caused any tweens to lazy-init, we should render them because typically when a timeline finishes, users expect things to have rendered fully. Imagine an onUpdate on a timeline that reports/checks tweened values.
    context && (_context = context);
    result = params ? callback.apply(scope, params) : callback.call(scope);
    _context = prevContext;
    return result;
}, _interrupt = function _interrupt(animation) {
    _removeFromParent(animation);
    animation.scrollTrigger && animation.scrollTrigger.kill(!!_reverting);
    animation.progress() < 1 && _callback(animation, "onInterrupt");
    return animation;
}, _quickTween, _registerPluginQueue = [], _createPlugin = function _createPlugin(config) {
    if (!config) return;
    config = !config.name && config["default"] || config; // UMD packaging wraps things oddly, so for example MotionPathHelper becomes {MotionPathHelper:MotionPathHelper, default:MotionPathHelper}.
    if (_windowExists() || config.headless) {
        // edge case: some build tools may pass in a null/undefined value
        var name = config.name, isFunc = _isFunction(config), Plugin = name && !isFunc && config.init ? function() {
            this._props = [];
        } : config, //in case someone passes in an object that's not a plugin, like CustomEase
        instanceDefaults = {
            init: _emptyFunc,
            render: _renderPropTweens,
            add: _addPropTween,
            kill: _killPropTweensOf,
            modifier: _addPluginModifier,
            rawVars: 0
        }, statics = {
            targetTest: 0,
            get: 0,
            getSetter: _getSetter,
            aliases: {},
            register: 0
        };
        _wake();
        if (config !== Plugin) {
            if (_plugins[name]) return;
            _setDefaults(Plugin, _setDefaults(_copyExcluding(config, instanceDefaults), statics)); //static methods
            _merge(Plugin.prototype, _merge(instanceDefaults, _copyExcluding(config, statics))); //instance methods
            _plugins[Plugin.prop = name] = Plugin;
            if (config.targetTest) {
                _harnessPlugins.push(Plugin);
                _reservedProps[name] = 1;
            }
            name = (name === "css" ? "CSS" : name.charAt(0).toUpperCase() + name.substr(1)) + "Plugin"; //for the global name. "motionPath" should become MotionPathPlugin
        }
        _addGlobal(name, Plugin);
        config.register && config.register(gsap, Plugin, PropTween);
    } else _registerPluginQueue.push(config);
}, /*
 * --------------------------------------------------------------------------------------
 * COLORS
 * --------------------------------------------------------------------------------------
 */ _255 = 255, _colorLookup = {
    aqua: [
        0,
        _255,
        _255
    ],
    lime: [
        0,
        _255,
        0
    ],
    silver: [
        192,
        192,
        192
    ],
    black: [
        0,
        0,
        0
    ],
    maroon: [
        128,
        0,
        0
    ],
    teal: [
        0,
        128,
        128
    ],
    blue: [
        0,
        0,
        _255
    ],
    navy: [
        0,
        0,
        128
    ],
    white: [
        _255,
        _255,
        _255
    ],
    olive: [
        128,
        128,
        0
    ],
    yellow: [
        _255,
        _255,
        0
    ],
    orange: [
        _255,
        165,
        0
    ],
    gray: [
        128,
        128,
        128
    ],
    purple: [
        128,
        0,
        128
    ],
    green: [
        0,
        128,
        0
    ],
    red: [
        _255,
        0,
        0
    ],
    pink: [
        _255,
        192,
        203
    ],
    cyan: [
        0,
        _255,
        _255
    ],
    transparent: [
        _255,
        _255,
        _255,
        0
    ]
}, // possible future idea to replace the hard-coded color name values - put this in the ticker.wake() where we set the _doc:
// let ctx = _doc.createElement("canvas").getContext("2d");
// _forEachName("aqua,lime,silver,black,maroon,teal,blue,navy,white,olive,yellow,orange,gray,purple,green,red,pink,cyan", color => {ctx.fillStyle = color; _colorLookup[color] = splitColor(ctx.fillStyle)});
_hue = function _hue(h, m1, m2) {
    h += h < 0 ? 1 : h > 1 ? -1 : 0;
    return (h * 6 < 1 ? m1 + (m2 - m1) * h * 6 : h < .5 ? m2 : h * 3 < 2 ? m1 + (m2 - m1) * (2 / 3 - h) * 6 : m1) * _255 + .5 | 0;
}, splitColor = function splitColor(v, toHSL, forceAlpha) {
    var a = !v ? _colorLookup.black : _isNumber(v) ? [
        v >> 16,
        v >> 8 & _255,
        v & _255
    ] : 0, r, g, b, h, s, l, max, min, d, wasHSL;
    if (!a) {
        if (v.substr(-1) === ",") //sometimes a trailing comma is included and we should chop it off (typically from a comma-delimited list of values like a textShadow:"2px 2px 2px blue, 5px 5px 5px rgb(255,0,0)" - in this example "blue," has a trailing comma. We could strip it out inside parseComplex() but we'd need to do it to the beginning and ending values plus it wouldn't provide protection from other potential scenarios like if the user passes in a similar value.
        v = v.substr(0, v.length - 1);
        if (_colorLookup[v]) a = _colorLookup[v];
        else if (v.charAt(0) === "#") {
            if (v.length < 6) {
                //for shorthand like #9F0 or #9F0F (could have alpha)
                r = v.charAt(1);
                g = v.charAt(2);
                b = v.charAt(3);
                v = "#" + r + r + g + g + b + b + (v.length === 5 ? v.charAt(4) + v.charAt(4) : "");
            }
            if (v.length === 9) {
                // hex with alpha, like #fd5e53ff
                a = parseInt(v.substr(1, 6), 16);
                return [
                    a >> 16,
                    a >> 8 & _255,
                    a & _255,
                    parseInt(v.substr(7), 16) / 255
                ];
            }
            v = parseInt(v.substr(1), 16);
            a = [
                v >> 16,
                v >> 8 & _255,
                v & _255
            ];
        } else if (v.substr(0, 3) === "hsl") {
            a = wasHSL = v.match(_strictNumExp);
            if (!toHSL) {
                h = +a[0] % 360 / 360;
                s = +a[1] / 100;
                l = +a[2] / 100;
                g = l <= .5 ? l * (s + 1) : l + s - l * s;
                r = l * 2 - g;
                a.length > 3 && (a[3] *= 1); //cast as number
                a[0] = _hue(h + 1 / 3, r, g);
                a[1] = _hue(h, r, g);
                a[2] = _hue(h - 1 / 3, r, g);
            } else if (~v.indexOf("=")) {
                //if relative values are found, just return the raw strings with the relative prefixes in place.
                a = v.match(_numExp);
                forceAlpha && a.length < 4 && (a[3] = 1);
                return a;
            }
        } else a = v.match(_strictNumExp) || _colorLookup.transparent;
        a = a.map(Number);
    }
    if (toHSL && !wasHSL) {
        r = a[0] / _255;
        g = a[1] / _255;
        b = a[2] / _255;
        max = Math.max(r, g, b);
        min = Math.min(r, g, b);
        l = (max + min) / 2;
        if (max === min) h = s = 0;
        else {
            d = max - min;
            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
            h = max === r ? (g - b) / d + (g < b ? 6 : 0) : max === g ? (b - r) / d + 2 : (r - g) / d + 4;
            h *= 60;
        }
        a[0] = ~~(h + .5);
        a[1] = ~~(s * 100 + .5);
        a[2] = ~~(l * 100 + .5);
    }
    forceAlpha && a.length < 4 && (a[3] = 1);
    return a;
}, _colorOrderData = function _colorOrderData(v) {
    // strips out the colors from the string, finds all the numeric slots (with units) and returns an array of those. The Array also has a "c" property which is an Array of the index values where the colors belong. This is to help work around issues where there's a mis-matched order of color/numeric data like drop-shadow(#f00 0px 1px 2px) and drop-shadow(0x 1px 2px #f00). This is basically a helper function used in _formatColors()
    var values = [], c = [], i = -1;
    v.split(_colorExp).forEach(function(v) {
        var a = v.match(_numWithUnitExp) || [];
        values.push.apply(values, a);
        c.push(i += a.length + 1);
    });
    values.c = c;
    return values;
}, _formatColors = function _formatColors(s, toHSL, orderMatchData) {
    var result = "", colors = (s + result).match(_colorExp), type = toHSL ? "hsla(" : "rgba(", i = 0, c, shell, d, l;
    if (!colors) return s;
    colors = colors.map(function(color) {
        return (color = splitColor(color, toHSL, 1)) && type + (toHSL ? color[0] + "," + color[1] + "%," + color[2] + "%," + color[3] : color.join(",")) + ")";
    });
    if (orderMatchData) {
        d = _colorOrderData(s);
        c = orderMatchData.c;
        if (c.join(result) !== d.c.join(result)) {
            shell = s.replace(_colorExp, "1").split(_numWithUnitExp);
            l = shell.length - 1;
            for(; i < l; i++)result += shell[i] + (~c.indexOf(i) ? colors.shift() || type + "0,0,0,0)" : (d.length ? d : colors.length ? colors : orderMatchData).shift());
        }
    }
    if (!shell) {
        shell = s.split(_colorExp);
        l = shell.length - 1;
        for(; i < l; i++)result += shell[i] + colors[i];
    }
    return result + shell[l];
}, _colorExp = function() {
    var s = "(?:\\b(?:(?:rgb|rgba|hsl|hsla)\\(.+?\\))|\\B#(?:[0-9a-f]{3,4}){1,2}\\b", //we'll dynamically build this Regular Expression to conserve file size. After building it, it will be able to find rgb(), rgba(), # (hexadecimal), and named color values like red, blue, purple, etc.,
    p;
    for(p in _colorLookup)s += "|" + p + "\\b";
    return new RegExp(s + ")", "gi");
}(), _hslExp = /hsl[a]?\(/, _colorStringFilter = function _colorStringFilter(a) {
    var combined = a.join(" "), toHSL;
    _colorExp.lastIndex = 0;
    if (_colorExp.test(combined)) {
        toHSL = _hslExp.test(combined);
        a[1] = _formatColors(a[1], toHSL);
        a[0] = _formatColors(a[0], toHSL, _colorOrderData(a[1])); // make sure the order of numbers/colors match with the END value.
        return true;
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TICKER
 * --------------------------------------------------------------------------------------
 */ _tickerActive, _ticker = function() {
    var _getTime = Date.now, _lagThreshold = 500, _adjustedLag = 33, _startTime = _getTime(), _lastUpdate = _startTime, _gap = 1000 / 240, _nextTime = _gap, _listeners = [], _id, _req, _raf, _self, _delta, _i, _tick = function _tick(v) {
        var elapsed = _getTime() - _lastUpdate, manual = v === true, overlap, dispatch, time, frame;
        (elapsed > _lagThreshold || elapsed < 0) && (_startTime += elapsed - _adjustedLag);
        _lastUpdate += elapsed;
        time = _lastUpdate - _startTime;
        overlap = time - _nextTime;
        if (overlap > 0 || manual) {
            frame = ++_self.frame;
            _delta = time - _self.time * 1000;
            _self.time = time = time / 1000;
            _nextTime += overlap + (overlap >= _gap ? 4 : _gap - overlap);
            dispatch = 1;
        }
        manual || (_id = _req(_tick)); //make sure the request is made before we dispatch the "tick" event so that timing is maintained. Otherwise, if processing the "tick" requires a bunch of time (like 15ms) and we're using a setTimeout() that's based on 16.7ms, it'd technically take 31.7ms between frames otherwise.
        if (dispatch) for(_i = 0; _i < _listeners.length; _i++)// use _i and check _listeners.length instead of a variable because a listener could get removed during the loop, and if that happens to an element less than the current index, it'd throw things off in the loop.
        _listeners[_i](time, _delta, frame, v);
    };
    _self = {
        time: 0,
        frame: 0,
        tick: function tick() {
            _tick(true);
        },
        deltaRatio: function deltaRatio(fps) {
            return _delta / (1000 / (fps || 60));
        },
        wake: function wake() {
            if (_coreReady) {
                if (!_coreInitted && _windowExists()) {
                    _win = _coreInitted = window;
                    _doc = _win.document || {};
                    _globals.gsap = gsap;
                    (_win.gsapVersions || (_win.gsapVersions = [])).push(gsap.version);
                    _install(_installScope || _win.GreenSockGlobals || !_win.gsap && _win || {});
                    _registerPluginQueue.forEach(_createPlugin);
                }
                _raf = typeof requestAnimationFrame !== "undefined" && requestAnimationFrame;
                _id && _self.sleep();
                _req = _raf || function(f) {
                    return setTimeout(f, _nextTime - _self.time * 1000 + 1 | 0);
                };
                _tickerActive = 1;
                _tick(2);
            }
        },
        sleep: function sleep() {
            (_raf ? cancelAnimationFrame : clearTimeout)(_id);
            _tickerActive = 0;
            _req = _emptyFunc;
        },
        lagSmoothing: function lagSmoothing(threshold, adjustedLag) {
            _lagThreshold = threshold || Infinity; // zero should be interpreted as basically unlimited
            _adjustedLag = Math.min(adjustedLag || 33, _lagThreshold);
        },
        fps: function fps(_fps) {
            _gap = 1000 / (_fps || 240);
            _nextTime = _self.time * 1000 + _gap;
        },
        add: function add(callback, once, prioritize) {
            var func = once ? function(t, d, f, v) {
                callback(t, d, f, v);
                _self.remove(func);
            } : callback;
            _self.remove(callback);
            _listeners[prioritize ? "unshift" : "push"](func);
            _wake();
            return func;
        },
        remove: function remove(callback, i) {
            ~(i = _listeners.indexOf(callback)) && _listeners.splice(i, 1) && _i >= i && _i--;
        },
        _listeners: _listeners
    };
    return _self;
}(), _wake = function _wake() {
    return !_tickerActive && _ticker.wake();
}, //also ensures the core classes are initialized.
/*
* -------------------------------------------------
* EASING
* -------------------------------------------------
*/ _easeMap = {}, _customEaseExp = /^[\d.\-M][\d.\-,\s]/, _quotesExp = /["']/g, _parseObjectInString = function _parseObjectInString(value) {
    //takes a string like "{wiggles:10, type:anticipate})" and turns it into a real object. Notice it ends in ")" and includes the {} wrappers. This is because we only use this function for parsing ease configs and prioritized optimization rather than reusability.
    var obj = {}, split = value.substr(1, value.length - 3).split(":"), key = split[0], i = 1, l = split.length, index, val, parsedVal;
    for(; i < l; i++){
        val = split[i];
        index = i !== l - 1 ? val.lastIndexOf(",") : val.length;
        parsedVal = val.substr(0, index);
        obj[key] = isNaN(parsedVal) ? parsedVal.replace(_quotesExp, "").trim() : +parsedVal;
        key = val.substr(index + 1).trim();
    }
    return obj;
}, _valueInParentheses = function _valueInParentheses(value) {
    var open = value.indexOf("(") + 1, close = value.indexOf(")"), nested = value.indexOf("(", open);
    return value.substring(open, ~nested && nested < close ? value.indexOf(")", close + 1) : close);
}, _configEaseFromString = function _configEaseFromString(name) {
    //name can be a string like "elastic.out(1,0.5)", and pass in _easeMap as obj and it'll parse it out and call the actual function like _easeMap.Elastic.easeOut.config(1,0.5). It will also parse custom ease strings as long as CustomEase is loaded and registered (internally as _easeMap._CE).
    var split = (name + "").split("("), ease = _easeMap[split[0]];
    return ease && split.length > 1 && ease.config ? ease.config.apply(null, ~name.indexOf("{") ? [
        _parseObjectInString(split[1])
    ] : _valueInParentheses(name).split(",").map(_numericIfPossible)) : _easeMap._CE && _customEaseExp.test(name) ? _easeMap._CE("", name) : ease;
}, _invertEase = function _invertEase(ease) {
    return function(p) {
        return 1 - ease(1 - p);
    };
}, // allow yoyoEase to be set in children and have those affected when the parent/ancestor timeline yoyos.
_propagateYoyoEase = function _propagateYoyoEase(timeline, isYoyo) {
    var child = timeline._first, ease;
    while(child){
        if (child instanceof Timeline) _propagateYoyoEase(child, isYoyo);
        else if (child.vars.yoyoEase && (!child._yoyo || !child._repeat) && child._yoyo !== isYoyo) {
            if (child.timeline) _propagateYoyoEase(child.timeline, isYoyo);
            else {
                ease = child._ease;
                child._ease = child._yEase;
                child._yEase = ease;
                child._yoyo = isYoyo;
            }
        }
        child = child._next;
    }
}, _parseEase = function _parseEase(ease, defaultEase) {
    return !ease ? defaultEase : (_isFunction(ease) ? ease : _easeMap[ease] || _configEaseFromString(ease)) || defaultEase;
}, _insertEase = function _insertEase(names, easeIn, easeOut, easeInOut) {
    if (easeOut === void 0) easeOut = function easeOut(p) {
        return 1 - easeIn(1 - p);
    };
    if (easeInOut === void 0) easeInOut = function easeInOut(p) {
        return p < .5 ? easeIn(p * 2) / 2 : 1 - easeIn((1 - p) * 2) / 2;
    };
    var ease = {
        easeIn: easeIn,
        easeOut: easeOut,
        easeInOut: easeInOut
    }, lowercaseName;
    _forEachName(names, function(name) {
        _easeMap[name] = _globals[name] = ease;
        _easeMap[lowercaseName = name.toLowerCase()] = easeOut;
        for(var p in ease)_easeMap[lowercaseName + (p === "easeIn" ? ".in" : p === "easeOut" ? ".out" : ".inOut")] = _easeMap[name + "." + p] = ease[p];
    });
    return ease;
}, _easeInOutFromOut = function _easeInOutFromOut(easeOut) {
    return function(p) {
        return p < .5 ? (1 - easeOut(1 - p * 2)) / 2 : .5 + easeOut((p - .5) * 2) / 2;
    };
}, _configElastic = function _configElastic(type, amplitude, period) {
    var p1 = amplitude >= 1 ? amplitude : 1, //note: if amplitude is < 1, we simply adjust the period for a more natural feel. Otherwise the math doesn't work right and the curve starts at 1.
    p2 = (period || (type ? .3 : .45)) / (amplitude < 1 ? amplitude : 1), p3 = p2 / _2PI * (Math.asin(1 / p1) || 0), easeOut = function easeOut(p) {
        return p === 1 ? 1 : p1 * Math.pow(2, -10 * p) * _sin((p - p3) * p2) + 1;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    p2 = _2PI / p2; //precalculate to optimize
    ease.config = function(amplitude, period) {
        return _configElastic(type, amplitude, period);
    };
    return ease;
}, _configBack = function _configBack(type, overshoot) {
    if (overshoot === void 0) overshoot = 1.70158;
    var easeOut = function easeOut(p) {
        return p ? --p * p * ((overshoot + 1) * p + overshoot) + 1 : 0;
    }, ease = type === "out" ? easeOut : type === "in" ? function(p) {
        return 1 - easeOut(1 - p);
    } : _easeInOutFromOut(easeOut);
    ease.config = function(overshoot) {
        return _configBack(type, overshoot);
    };
    return ease;
}; // a cheaper (kb and cpu) but more mild way to get a parameterized weighted ease by feeding in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEase = ratio => {
// 	let y = 0.5 + ratio / 2;
// 	return p => (2 * (1 - p) * p * y + p * p);
// },
// a stronger (but more expensive kb/cpu) parameterized weighted ease that lets you feed in a value between -1 (easeIn) and 1 (easeOut) where 0 is linear.
// _weightedEaseStrong = ratio => {
// 	ratio = .5 + ratio / 2;
// 	let o = 1 / 3 * (ratio < .5 ? ratio : 1 - ratio),
// 		b = ratio - o,
// 		c = ratio + o;
// 	return p => p === 1 ? p : 3 * b * (1 - p) * (1 - p) * p + 3 * c * (1 - p) * p * p + p * p * p;
// };
_forEachName("Linear,Quad,Cubic,Quart,Quint,Strong", function(name, i) {
    var power = i < 5 ? i + 1 : i;
    _insertEase(name + ",Power" + (power - 1), i ? function(p) {
        return Math.pow(p, power);
    } : function(p) {
        return p;
    }, function(p) {
        return 1 - Math.pow(1 - p, power);
    }, function(p) {
        return p < .5 ? Math.pow(p * 2, power) / 2 : 1 - Math.pow((1 - p) * 2, power) / 2;
    });
});
_easeMap.Linear.easeNone = _easeMap.none = _easeMap.Linear.easeIn;
_insertEase("Elastic", _configElastic("in"), _configElastic("out"), _configElastic());
(function(n, c) {
    var n1 = 1 / c, n2 = 2 * n1, n3 = 2.5 * n1, easeOut = function easeOut(p) {
        return p < n1 ? n * p * p : p < n2 ? n * Math.pow(p - 1.5 / c, 2) + .75 : p < n3 ? n * (p -= 2.25 / c) * p + .9375 : n * Math.pow(p - 2.625 / c, 2) + .984375;
    };
    _insertEase("Bounce", function(p) {
        return 1 - easeOut(1 - p);
    }, easeOut);
})(7.5625, 2.75);
_insertEase("Expo", function(p) {
    return Math.pow(2, 10 * (p - 1)) * p + p * p * p * p * p * p * (1 - p);
}); // previously 2 ** (10 * (p - 1)) but that doesn't end up with the value quite at the right spot so we do a blended ease to ensure it lands where it should perfectly.
_insertEase("Circ", function(p) {
    return -(_sqrt(1 - p * p) - 1);
});
_insertEase("Sine", function(p) {
    return p === 1 ? 1 : -_cos(p * _HALF_PI) + 1;
});
_insertEase("Back", _configBack("in"), _configBack("out"), _configBack());
_easeMap.SteppedEase = _easeMap.steps = _globals.SteppedEase = {
    config: function config(steps, immediateStart) {
        if (steps === void 0) steps = 1;
        var p1 = 1 / steps, p2 = steps + (immediateStart ? 0 : 1), p3 = immediateStart ? 1 : 0, max = 1 - _tinyNum;
        return function(p) {
            return ((p2 * _clamp(0, max, p) | 0) + p3) * p1;
        };
    }
};
_defaults.ease = _easeMap["quad.out"];
_forEachName("onComplete,onUpdate,onStart,onRepeat,onReverseComplete,onInterrupt", function(name) {
    return _callbackNames += name + "," + name + "Params,";
});
var GSCache = function GSCache(target, harness) {
    this.id = _gsID++;
    target._gsap = this;
    this.target = target;
    this.harness = harness;
    this.get = harness ? harness.get : _getProperty;
    this.set = harness ? harness.getSetter : _getSetter;
};
var Animation = /*#__PURE__*/ function() {
    function Animation(vars) {
        this.vars = vars;
        this._delay = +vars.delay || 0;
        if (this._repeat = vars.repeat === Infinity ? -2 : vars.repeat || 0) {
            // TODO: repeat: Infinity on a timeline's children must flag that timeline internally and affect its totalDuration, otherwise it'll stop in the negative direction when reaching the start.
            this._rDelay = vars.repeatDelay || 0;
            this._yoyo = !!vars.yoyo || !!vars.yoyoEase;
        }
        this._ts = 1;
        _setDuration(this, +vars.duration, 1, 1);
        this.data = vars.data;
        if (_context) {
            this._ctx = _context;
            _context.data.push(this);
        }
        _tickerActive || _ticker.wake();
    }
    var _proto = Animation.prototype;
    _proto.delay = function delay(value) {
        if (value || value === 0) {
            this.parent && this.parent.smoothChildTiming && this.startTime(this._start + value - this._delay);
            this._delay = value;
            return this;
        }
        return this._delay;
    };
    _proto.duration = function duration(value) {
        return arguments.length ? this.totalDuration(this._repeat > 0 ? value + (value + this._rDelay) * this._repeat : value) : this.totalDuration() && this._dur;
    };
    _proto.totalDuration = function totalDuration(value) {
        if (!arguments.length) return this._tDur;
        this._dirty = 0;
        return _setDuration(this, this._repeat < 0 ? value : (value - this._repeat * this._rDelay) / (this._repeat + 1));
    };
    _proto.totalTime = function totalTime(_totalTime, suppressEvents) {
        _wake();
        if (!arguments.length) return this._tTime;
        var parent = this._dp;
        if (parent && parent.smoothChildTiming && this._ts) {
            _alignPlayhead(this, _totalTime);
            !parent._dp || parent.parent || _postAddChecks(parent, this); // edge case: if this is a child of a timeline that already completed, for example, we must re-activate the parent.
            //in case any of the ancestor timelines had completed but should now be enabled, we should reset their totalTime() which will also ensure that they're lined up properly and enabled. Skip for animations that are on the root (wasteful). Example: a TimelineLite.exportRoot() is performed when there's a paused tween on the root, the export will not complete until that tween is unpaused, but imagine a child gets restarted later, after all [unpaused] tweens have completed. The start of that child would get pushed out, but one of the ancestors may have completed.
            while(parent && parent.parent){
                if (parent.parent._time !== parent._start + (parent._ts >= 0 ? parent._tTime / parent._ts : (parent.totalDuration() - parent._tTime) / -parent._ts)) parent.totalTime(parent._tTime, true);
                parent = parent.parent;
            }
            if (!this.parent && this._dp.autoRemoveChildren && (this._ts > 0 && _totalTime < this._tDur || this._ts < 0 && _totalTime > 0 || !this._tDur && !_totalTime)) //if the animation doesn't have a parent, put it back into its last parent (recorded as _dp for exactly cases like this). Limit to parents with autoRemoveChildren (like globalTimeline) so that if the user manually removes an animation from a timeline and then alters its playhead, it doesn't get added back in.
            _addToTimeline(this._dp, this, this._start - this._delay);
        }
        if (this._tTime !== _totalTime || !this._dur && !suppressEvents || this._initted && Math.abs(this._zTime) === _tinyNum || !this._initted && this._dur && _totalTime || !_totalTime && !this._initted && (this.add || this._ptLookup)) {
            // check for _ptLookup on a Tween instance to ensure it has actually finished being instantiated, otherwise if this.reverse() gets called in the Animation constructor, it could trigger a render() here even though the _targets weren't populated, thus when _init() is called there won't be any PropTweens (it'll act like the tween is non-functional)
            this._ts || (this._pTime = _totalTime); // otherwise, if an animation is paused, then the playhead is moved back to zero, then resumed, it'd revert back to the original time at the pause
            //if (!this._lock) { // avoid endless recursion (not sure we need this yet or if it's worth the performance hit)
            //   this._lock = 1;
            _lazySafeRender(this, _totalTime, suppressEvents); //   this._lock = 0;
        //}
        }
        return this;
    };
    _proto.time = function time(value, suppressEvents) {
        return arguments.length ? this.totalTime(Math.min(this.totalDuration(), value + _elapsedCycleDuration(this)) % (this._dur + this._rDelay) || (value ? this._dur : 0), suppressEvents) : this._time; // note: if the modulus results in 0, the playhead could be exactly at the end or the beginning, and we always defer to the END with a non-zero value, otherwise if you set the time() to the very end (duration()), it would render at the START!
    };
    _proto.totalProgress = function totalProgress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.totalDuration() * value, suppressEvents) : this.totalDuration() ? Math.min(1, this._tTime / this._tDur) : this.rawTime() >= 0 && this._initted ? 1 : 0;
    };
    _proto.progress = function progress(value, suppressEvents) {
        return arguments.length ? this.totalTime(this.duration() * (this._yoyo && !(this.iteration() & 1) ? 1 - value : value) + _elapsedCycleDuration(this), suppressEvents) : this.duration() ? Math.min(1, this._time / this._dur) : this.rawTime() > 0 ? 1 : 0;
    };
    _proto.iteration = function iteration(value, suppressEvents) {
        var cycleDuration = this.duration() + this._rDelay;
        return arguments.length ? this.totalTime(this._time + (value - 1) * cycleDuration, suppressEvents) : this._repeat ? _animationCycle(this._tTime, cycleDuration) + 1 : 1;
    } // potential future addition:
    ;
    _proto.timeScale = function timeScale(value, suppressEvents) {
        if (!arguments.length) return this._rts === -_tinyNum ? 0 : this._rts; // recorded timeScale. Special case: if someone calls reverse() on an animation with timeScale of 0, we assign it -_tinyNum to remember it's reversed.
        if (this._rts === value) return this;
        var tTime = this.parent && this._ts ? _parentToChildTotalTime(this.parent._time, this) : this._tTime; // make sure to do the parentToChildTotalTime() BEFORE setting the new _ts because the old one must be used in that calculation.
        // future addition? Up side: fast and minimal file size. Down side: only works on this animation; if a timeline is reversed, for example, its childrens' onReverse wouldn't get called.
        //(+value < 0 && this._rts >= 0) && _callback(this, "onReverse", true);
        // prioritize rendering where the parent's playhead lines up instead of this._tTime because there could be a tween that's animating another tween's timeScale in the same rendering loop (same parent), thus if the timeScale tween renders first, it would alter _start BEFORE _tTime was set on that tick (in the rendering loop), effectively freezing it until the timeScale tween finishes.
        this._rts = +value || 0;
        this._ts = this._ps || value === -_tinyNum ? 0 : this._rts; // _ts is the functional timeScale which would be 0 if the animation is paused.
        this.totalTime(_clamp(-Math.abs(this._delay), this.totalDuration(), tTime), suppressEvents !== false);
        _setEnd(this); // if parent.smoothChildTiming was false, the end time didn't get updated in the _alignPlayhead() method, so do it here.
        return _recacheAncestors(this);
    };
    _proto.paused = function paused(value) {
        if (!arguments.length) return this._ps;
         // possible future addition - if an animation is removed from its parent and then .restart() or .play() or .resume() is called, perhaps we should force it back into the globalTimeline but be careful because what if it's already at its end? We don't want it to just persist forever and not get released for GC.
        // !this.parent && !value && this._tTime < this._tDur && this !== _globalTimeline && _globalTimeline.add(this);
        if (this._ps !== value) {
            this._ps = value;
            if (value) {
                this._pTime = this._tTime || Math.max(-this._delay, this.rawTime()); // if the pause occurs during the delay phase, make sure that's factored in when resuming.
                this._ts = this._act = 0; // _ts is the functional timeScale, so a paused tween would effectively have a timeScale of 0. We record the "real" timeScale as _rts (recorded time scale)
            } else {
                _wake();
                this._ts = this._rts; //only defer to _pTime (pauseTime) if tTime is zero. Remember, someone could pause() an animation, then scrub the playhead and resume(). If the parent doesn't have smoothChildTiming, we render at the rawTime() because the startTime won't get updated.
                this.totalTime(this.parent && !this.parent.smoothChildTiming ? this.rawTime() : this._tTime || this._pTime, this.progress() === 1 && Math.abs(this._zTime) !== _tinyNum && (this._tTime -= _tinyNum)); // edge case: animation.progress(1).pause().play() wouldn't render again because the playhead is already at the end, but the call to totalTime() below will add it back to its parent...and not remove it again (since removing only happens upon rendering at a new time). Offsetting the _tTime slightly is done simply to cause the final render in totalTime() that'll pop it off its timeline (if autoRemoveChildren is true, of course). Check to make sure _zTime isn't -_tinyNum to avoid an edge case where the playhead is pushed to the end but INSIDE a tween/callback, the timeline itself is paused thus halting rendering and leaving a few unrendered. When resuming, it wouldn't render those otherwise.
            }
        }
        return this;
    };
    _proto.startTime = function startTime(value) {
        if (arguments.length) {
            this._start = _roundPrecise(value);
            var parent = this.parent || this._dp;
            parent && (parent._sort || !this.parent) && _addToTimeline(parent, this, this._start - this._delay);
            return this;
        }
        return this._start;
    };
    _proto.endTime = function endTime(includeRepeats) {
        return this._start + (_isNotFalse(includeRepeats) ? this.totalDuration() : this.duration()) / Math.abs(this._ts || 1);
    };
    _proto.rawTime = function rawTime(wrapRepeats) {
        var parent = this.parent || this._dp; // _dp = detached parent
        return !parent ? this._tTime : wrapRepeats && (!this._ts || this._repeat && this._time && this.totalProgress() < 1) ? this._tTime % (this._dur + this._rDelay) : !this._ts ? this._tTime : _parentToChildTotalTime(parent.rawTime(wrapRepeats), this);
    };
    _proto.revert = function revert(config) {
        if (config === void 0) config = _revertConfig;
        var prevIsReverting = _reverting;
        _reverting = config;
        if (_isRevertWorthy(this)) {
            this.timeline && this.timeline.revert(config);
            this.totalTime(-0.01, config.suppressEvents);
        }
        this.data !== "nested" && config.kill !== false && this.kill();
        _reverting = prevIsReverting;
        return this;
    };
    _proto.globalTime = function globalTime(rawTime) {
        var animation = this, time = arguments.length ? rawTime : animation.rawTime();
        while(animation){
            time = animation._start + time / (Math.abs(animation._ts) || 1);
            animation = animation._dp;
        }
        return !this.parent && this._sat ? this._sat.globalTime(rawTime) : time; // the _startAt tweens for .fromTo() and .from() that have immediateRender should always be FIRST in the timeline (important for context.revert()). "_sat" stands for _startAtTween, referring to the parent tween that created the _startAt. We must discern if that tween had immediateRender so that we can know whether or not to prioritize it in revert().
    };
    _proto.repeat = function repeat(value) {
        if (arguments.length) {
            this._repeat = value === Infinity ? -2 : value;
            return _onUpdateTotalDuration(this);
        }
        return this._repeat === -2 ? Infinity : this._repeat;
    };
    _proto.repeatDelay = function repeatDelay(value) {
        if (arguments.length) {
            var time = this._time;
            this._rDelay = value;
            _onUpdateTotalDuration(this);
            return time ? this.time(time) : this;
        }
        return this._rDelay;
    };
    _proto.yoyo = function yoyo(value) {
        if (arguments.length) {
            this._yoyo = value;
            return this;
        }
        return this._yoyo;
    };
    _proto.seek = function seek(position, suppressEvents) {
        return this.totalTime(_parsePosition(this, position), _isNotFalse(suppressEvents));
    };
    _proto.restart = function restart(includeDelay, suppressEvents) {
        this.play().totalTime(includeDelay ? -this._delay : 0, _isNotFalse(suppressEvents));
        this._dur || (this._zTime = -_tinyNum); // ensures onComplete fires on a zero-duration animation that gets restarted.
        return this;
    };
    _proto.play = function play(from, suppressEvents) {
        from != null && this.seek(from, suppressEvents);
        return this.reversed(false).paused(false);
    };
    _proto.reverse = function reverse(from, suppressEvents) {
        from != null && this.seek(from || this.totalDuration(), suppressEvents);
        return this.reversed(true).paused(false);
    };
    _proto.pause = function pause(atTime, suppressEvents) {
        atTime != null && this.seek(atTime, suppressEvents);
        return this.paused(true);
    };
    _proto.resume = function resume() {
        return this.paused(false);
    };
    _proto.reversed = function reversed(value) {
        if (arguments.length) {
            !!value !== this.reversed() && this.timeScale(-this._rts || (value ? -_tinyNum : 0)); // in case timeScale is zero, reversing would have no effect so we use _tinyNum.
            return this;
        }
        return this._rts < 0;
    };
    _proto.invalidate = function invalidate() {
        this._initted = this._act = 0;
        this._zTime = -_tinyNum;
        return this;
    };
    _proto.isActive = function isActive() {
        var parent = this.parent || this._dp, start = this._start, rawTime;
        return !!(!parent || this._ts && this._initted && parent.isActive() && (rawTime = parent.rawTime(true)) >= start && rawTime < this.endTime(true) - _tinyNum);
    };
    _proto.eventCallback = function eventCallback(type, callback, params) {
        var vars = this.vars;
        if (arguments.length > 1) {
            if (!callback) delete vars[type];
            else {
                vars[type] = callback;
                params && (vars[type + "Params"] = params);
                type === "onUpdate" && (this._onUpdate = callback);
            }
            return this;
        }
        return vars[type];
    };
    _proto.then = function then(onFulfilled) {
        var self = this, prevProm = self._prom;
        return new Promise(function(resolve) {
            var f = _isFunction(onFulfilled) ? onFulfilled : _passThrough, _resolve = function _resolve() {
                var _then = self.then;
                self.then = null; // temporarily null the then() method to avoid an infinite loop (see https://github.com/greensock/GSAP/issues/322)
                prevProm && prevProm();
                _isFunction(f) && (f = f(self)) && (f.then || f === self) && (self.then = _then);
                resolve(f);
                self.then = _then;
            };
            if (self._initted && self.totalProgress() === 1 && self._ts >= 0 || !self._tTime && self._ts < 0) _resolve();
            else self._prom = _resolve;
        });
    };
    _proto.kill = function kill() {
        _interrupt(this);
    };
    return Animation;
}();
_setDefaults(Animation.prototype, {
    _time: 0,
    _start: 0,
    _end: 0,
    _tTime: 0,
    _tDur: 0,
    _dirty: 0,
    _repeat: 0,
    _yoyo: false,
    parent: null,
    _initted: false,
    _rDelay: 0,
    _ts: 1,
    _dp: 0,
    ratio: 0,
    _zTime: -_tinyNum,
    _prom: 0,
    _ps: false,
    _rts: 1
});
var Timeline = /*#__PURE__*/ function(_Animation) {
    _inheritsLoose(Timeline, _Animation);
    function Timeline(vars, position) {
        var _this;
        if (vars === void 0) vars = {};
        _this = _Animation.call(this, vars) || this;
        _this.labels = {};
        _this.smoothChildTiming = !!vars.smoothChildTiming;
        _this.autoRemoveChildren = !!vars.autoRemoveChildren;
        _this._sort = _isNotFalse(vars.sortChildren);
        _globalTimeline && _addToTimeline(vars.parent || _globalTimeline, _assertThisInitialized(_this), position);
        vars.reversed && _this.reverse();
        vars.paused && _this.paused(true);
        vars.scrollTrigger && _scrollTrigger(_assertThisInitialized(_this), vars.scrollTrigger);
        return _this;
    }
    var _proto2 = Timeline.prototype;
    _proto2.to = function to(targets, vars, position) {
        _createTweenType(0, arguments, this);
        return this;
    };
    _proto2.from = function from(targets, vars, position) {
        _createTweenType(1, arguments, this);
        return this;
    };
    _proto2.fromTo = function fromTo(targets, fromVars, toVars, position) {
        _createTweenType(2, arguments, this);
        return this;
    };
    _proto2.set = function set(targets, vars, position) {
        vars.duration = 0;
        vars.parent = this;
        _inheritDefaults(vars).repeatDelay || (vars.repeat = 0);
        vars.immediateRender = !!vars.immediateRender;
        new Tween(targets, vars, _parsePosition(this, position), 1);
        return this;
    };
    _proto2.call = function call(callback, params, position) {
        return _addToTimeline(this, Tween.delayedCall(0, callback, params), position);
    } //ONLY for backward compatibility! Maybe delete?
    ;
    _proto2.staggerTo = function staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.duration = duration;
        vars.stagger = vars.stagger || stagger;
        vars.onComplete = onCompleteAll;
        vars.onCompleteParams = onCompleteAllParams;
        vars.parent = this;
        new Tween(targets, vars, _parsePosition(this, position));
        return this;
    };
    _proto2.staggerFrom = function staggerFrom(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams) {
        vars.runBackwards = 1;
        _inheritDefaults(vars).immediateRender = _isNotFalse(vars.immediateRender);
        return this.staggerTo(targets, duration, vars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.staggerFromTo = function staggerFromTo(targets, duration, fromVars, toVars, stagger, position, onCompleteAll, onCompleteAllParams) {
        toVars.startAt = fromVars;
        _inheritDefaults(toVars).immediateRender = _isNotFalse(toVars.immediateRender);
        return this.staggerTo(targets, duration, toVars, stagger, position, onCompleteAll, onCompleteAllParams);
    };
    _proto2.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._dirty ? this.totalDuration() : this._tDur, dur = this._dur, tTime = totalTime <= 0 ? 0 : _roundPrecise(totalTime), // if a paused timeline is resumed (or its _start is updated for another reason...which rounds it), that could result in the playhead shifting a **tiny** amount and a zero-duration child at that spot may get rendered at a different ratio, like its totalTime in render() may be 1e-17 instead of 0, for example.
        crossingStart = this._zTime < 0 !== totalTime < 0 && (this._initted || !dur), time, child, next, iteration, cycleDuration, prevPaused, pauseTween, timeScale, prevStart, prevIteration, yoyo, isYoyo;
        this !== _globalTimeline && tTime > tDur && totalTime >= 0 && (tTime = tDur);
        if (tTime !== this._tTime || force || crossingStart) {
            if (prevTime !== this._time && dur) {
                //if totalDuration() finds a child with a negative startTime and smoothChildTiming is true, things get shifted around internally so we need to adjust the time accordingly. For example, if a tween starts at -30 we must shift EVERYTHING forward 30 seconds and move this timeline's startTime backward by 30 seconds so that things align with the playhead (no jump).
                tTime += this._time - prevTime;
                totalTime += this._time - prevTime;
            }
            time = tTime;
            prevStart = this._start;
            timeScale = this._ts;
            prevPaused = !timeScale;
            if (crossingStart) {
                dur || (prevTime = this._zTime); //when the playhead arrives at EXACTLY time 0 (right on top) of a zero-duration timeline, we need to discern if events are suppressed so that when the playhead moves again (next time), it'll trigger the callback. If events are NOT suppressed, obviously the callback would be triggered in this render. Basically, the callback should fire either when the playhead ARRIVES or LEAVES this exact spot, not both. Imagine doing a timeline.seek(0) and there's a callback that sits at 0. Since events are suppressed on that seek() by default, nothing will fire, but when the playhead moves off of that position, the callback should fire. This behavior is what people intuitively expect.
                (totalTime || !suppressEvents) && (this._zTime = totalTime);
            }
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                yoyo = this._yoyo;
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && totalTime < 0) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    }
                    time > dur && (time = dur);
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                !prevTime && this._tTime && prevIteration !== iteration && this._tTime - prevIteration * cycleDuration - this._dur <= 0 && (prevIteration = iteration); // edge case - if someone does addPause() at the very beginning of a repeating timeline, that pause is technically at the same spot as the end which causes this._time to get set to 0 when the totalTime would normally place the playhead at the end. See https://gsap.com/forums/topic/23823-closing-nav-animation-not-working-on-ie-and-iphone-6-maybe-other-older-browser/?tab=comments#comment-113005 also, this._tTime - prevIteration * cycleDuration - this._dur <= 0 just checks to make sure it wasn't previously in the "repeatDelay" portion
                if (yoyo && iteration & 1) {
                    time = dur - time;
                    isYoyo = 1;
                }
                /*
        make sure children at the end/beginning of the timeline are rendered properly. If, for example,
        a 3-second long timeline rendered at 2.9 seconds previously, and now renders at 3.2 seconds (which
        would get translated to 2.8 seconds if the timeline yoyos or 0.2 seconds if it just repeats), there
        could be a callback or a short tween that's at 2.95 or 3 seconds in which wouldn't render. So
        we need to push the timeline to the end (and/or beginning depending on its yoyo value). Also we must
        ensure that zero-duration tweens at the very beginning or end of the Timeline work.
        */ if (iteration !== prevIteration && !this._lock) {
                    var rewinding = yoyo && prevIteration & 1, doesWrap = rewinding === (yoyo && iteration & 1);
                    iteration < prevIteration && (rewinding = !rewinding);
                    prevTime = rewinding ? 0 : tTime % dur ? dur : tTime; // if the playhead is landing exactly at the end of an iteration, use that totalTime rather than only the duration, otherwise it'll skip the 2nd render since it's effectively at the same time.
                    this._lock = 1;
                    this.render(prevTime || (isYoyo ? 0 : _roundPrecise(iteration * cycleDuration)), suppressEvents, !dur)._lock = 0;
                    this._tTime = tTime; // if a user gets the iteration() inside the onRepeat, for example, it should be accurate.
                    !suppressEvents && this.parent && _callback(this, "onRepeat");
                    if (this.vars.repeatRefresh && !isYoyo) {
                        this.invalidate()._lock = 1;
                        prevIteration = iteration; // otherwise, the onStart() may fire on the 2nd iteration.
                    }
                    if (prevTime && prevTime !== this._time || prevPaused !== !this._ts || this.vars.onRepeat && !this.parent && !this._act) // if prevTime is 0 and we render at the very end, _time will be the end, thus won't match. So in this edge case, prevTime won't match _time but that's okay. If it gets killed in the onRepeat, eject as well.
                    return this;
                    dur = this._dur; // in case the duration changed in the onRepeat
                    tDur = this._tDur;
                    if (doesWrap) {
                        this._lock = 2;
                        prevTime = rewinding ? dur : -0.0001;
                        this.render(prevTime, true);
                        this.vars.repeatRefresh && !isYoyo && this.invalidate();
                    }
                    this._lock = 0;
                    if (!this._ts && !prevPaused) return this;
                     //in order for yoyoEase to work properly when there's a stagger, we must swap out the ease in each sub-tween.
                    _propagateYoyoEase(this, isYoyo);
                }
            }
            if (this._hasPause && !this._forcing && this._lock < 2) {
                pauseTween = _findNextPauseTween(this, _roundPrecise(prevTime), _roundPrecise(time));
                if (pauseTween) tTime -= time - (time = pauseTween._start);
            }
            this._tTime = tTime;
            this._time = time;
            this._act = !timeScale; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
            if (!this._initted) {
                this._onUpdate = this.vars.onUpdate;
                this._initted = 1;
                this._zTime = totalTime;
                prevTime = 0; // upon init, the playhead should always go forward; someone could invalidate() a completed timeline and then if they restart(), that would make child tweens render in reverse order which could lock in the wrong starting values if they build on each other, like tl.to(obj, {x: 100}).to(obj, {x: 0}).
            }
            if (!prevTime && tTime && dur && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            if (time >= prevTime && totalTime >= 0) {
                child = this._first;
                while(child){
                    next = child._next;
                    if ((child._act || time >= child._start) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (time - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (time - child._start) * child._ts, suppressEvents, force);
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = -_tinyNum); // it didn't finish rendering, so flag zTime as negative so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            } else {
                child = this._last;
                var adjustedTime = totalTime < 0 ? totalTime : time; //when the playhead goes backward beyond the start of this timeline, we must pass that information down to the child animations so that zero-duration tweens know whether to render their starting or ending values.
                while(child){
                    next = child._prev;
                    if ((child._act || adjustedTime <= child._end) && child._ts && pauseTween !== child) {
                        if (child.parent !== this) // an extreme edge case - the child's render could do something like kill() the "next" one in the linked list, or reparent it. In that case we must re-initiate the whole render to be safe.
                        return this.render(totalTime, suppressEvents, force);
                        child.render(child._ts > 0 ? (adjustedTime - child._start) * child._ts : (child._dirty ? child.totalDuration() : child._tDur) + (adjustedTime - child._start) * child._ts, suppressEvents, force || _reverting && _isRevertWorthy(child)); // if reverting, we should always force renders of initted tweens (but remember that .fromTo() or .from() may have a _startAt but not _initted yet). If, for example, a .fromTo() tween with a stagger (which creates an internal timeline) gets reverted BEFORE some of its child tweens render for the first time, it may not properly trigger them to revert.
                        if (time !== this._time || !this._ts && !prevPaused) {
                            //in case a tween pauses or seeks the timeline when rendering, like inside of an onUpdate/onComplete
                            pauseTween = 0;
                            next && (tTime += this._zTime = adjustedTime ? -_tinyNum : _tinyNum); // it didn't finish rendering, so adjust zTime so that so that the next time render() is called it'll be forced (to render any remaining children)
                            break;
                        }
                    }
                    child = next;
                }
            }
            if (pauseTween && !suppressEvents) {
                this.pause();
                pauseTween.render(time >= prevTime ? 0 : -_tinyNum)._zTime = time >= prevTime ? 1 : -1;
                if (this._ts) {
                    //the callback resumed playback! So since we may have held back the playhead due to where the pause is positioned, go ahead and jump to where it's SUPPOSED to be (if no pause happened).
                    this._start = prevStart; //if the pause was at an earlier time and the user resumed in the callback, it could reposition the timeline (changing its startTime), throwing things off slightly, so we make sure the _start doesn't shift.
                    _setEnd(this);
                    return this.render(totalTime, suppressEvents, force);
                }
            }
            this._onUpdate && !suppressEvents && _callback(this, "onUpdate", true);
            if (tTime === tDur && this._tTime >= this.totalDuration() || !tTime && prevTime) {
                if (prevStart === this._start || Math.abs(timeScale) !== Math.abs(this._ts)) {
                    if (!this._lock) {
                        // remember, a child's callback may alter this timeline's playhead or timeScale which is why we need to add some of these checks.
                        (totalTime || !dur) && (tTime === tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                        if (!suppressEvents && !(totalTime < 0 && !prevTime) && (tTime || prevTime || !tDur)) {
                            _callback(this, tTime === tDur && totalTime >= 0 ? "onComplete" : "onReverseComplete", true);
                            this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                        }
                    }
                }
            }
        }
        return this;
    };
    _proto2.add = function add(child, position) {
        var _this2 = this;
        _isNumber(position) || (position = _parsePosition(this, position, child));
        if (!(child instanceof Animation)) {
            if (_isArray(child)) {
                child.forEach(function(obj) {
                    return _this2.add(obj, position);
                });
                return this;
            }
            if (_isString(child)) return this.addLabel(child, position);
            if (_isFunction(child)) child = Tween.delayedCall(0, child);
            else return this;
        }
        return this !== child ? _addToTimeline(this, child, position) : this; //don't allow a timeline to be added to itself as a child!
    };
    _proto2.getChildren = function getChildren(nested, tweens, timelines, ignoreBeforeTime) {
        if (nested === void 0) nested = true;
        if (tweens === void 0) tweens = true;
        if (timelines === void 0) timelines = true;
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = -_bigNum;
        var a = [], child = this._first;
        while(child){
            if (child._start >= ignoreBeforeTime) {
                if (child instanceof Tween) tweens && a.push(child);
                else {
                    timelines && a.push(child);
                    nested && a.push.apply(a, child.getChildren(true, tweens, timelines));
                }
            }
            child = child._next;
        }
        return a;
    };
    _proto2.getById = function getById(id) {
        var animations = this.getChildren(1, 1, 1), i = animations.length;
        while(i--){
            if (animations[i].vars.id === id) return animations[i];
        }
    };
    _proto2.remove = function remove(child) {
        if (_isString(child)) return this.removeLabel(child);
        if (_isFunction(child)) return this.killTweensOf(child);
        child.parent === this && _removeLinkedListItem(this, child);
        if (child === this._recent) this._recent = this._last;
        return _uncache(this);
    };
    _proto2.totalTime = function totalTime(_totalTime2, suppressEvents) {
        if (!arguments.length) return this._tTime;
        this._forcing = 1;
        if (!this._dp && this._ts) //special case for the global timeline (or any other that has no parent or detached parent).
        this._start = _roundPrecise(_ticker.time - (this._ts > 0 ? _totalTime2 / this._ts : (this.totalDuration() - _totalTime2) / -this._ts));
        _Animation.prototype.totalTime.call(this, _totalTime2, suppressEvents);
        this._forcing = 0;
        return this;
    };
    _proto2.addLabel = function addLabel(label, position) {
        this.labels[label] = _parsePosition(this, position);
        return this;
    };
    _proto2.removeLabel = function removeLabel(label) {
        delete this.labels[label];
        return this;
    };
    _proto2.addPause = function addPause(position, callback, params) {
        var t = Tween.delayedCall(0, callback || _emptyFunc, params);
        t.data = "isPause";
        this._hasPause = 1;
        return _addToTimeline(this, t, _parsePosition(this, position));
    };
    _proto2.removePause = function removePause(position) {
        var child = this._first;
        position = _parsePosition(this, position);
        while(child){
            if (child._start === position && child.data === "isPause") _removeFromParent(child);
            child = child._next;
        }
    };
    _proto2.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        var tweens = this.getTweensOf(targets, onlyActive), i = tweens.length;
        while(i--)_overwritingTween !== tweens[i] && tweens[i].kill(targets, props);
        return this;
    };
    _proto2.getTweensOf = function getTweensOf(targets, onlyActive) {
        var a = [], parsedTargets = toArray(targets), child = this._first, isGlobalTime = _isNumber(onlyActive), // a number is interpreted as a global time. If the animation spans
        children;
        while(child){
            if (child instanceof Tween) {
                if (_arrayContainsAny(child._targets, parsedTargets) && (isGlobalTime ? (!_overwritingTween || child._initted && child._ts) && child.globalTime(0) <= onlyActive && child.globalTime(child.totalDuration()) > onlyActive : !onlyActive || child.isActive())) // note: if this is for overwriting, it should only be for tweens that aren't paused and are initted.
                a.push(child);
            } else if ((children = child.getTweensOf(parsedTargets, onlyActive)).length) a.push.apply(a, children);
            child = child._next;
        }
        return a;
    } // potential future feature - targets() on timelines
    ;
    _proto2.tweenTo = function tweenTo(position, vars) {
        vars = vars || {};
        var tl = this, endTime = _parsePosition(tl, position), _vars = vars, startAt = _vars.startAt, _onStart = _vars.onStart, onStartParams = _vars.onStartParams, immediateRender = _vars.immediateRender, initted, tween = Tween.to(tl, _setDefaults({
            ease: vars.ease || "none",
            lazy: false,
            immediateRender: false,
            time: endTime,
            overwrite: "auto",
            duration: vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale()) || _tinyNum,
            onStart: function onStart() {
                tl.pause();
                if (!initted) {
                    var duration = vars.duration || Math.abs((endTime - (startAt && "time" in startAt ? startAt.time : tl._time)) / tl.timeScale());
                    tween._dur !== duration && _setDuration(tween, duration, 0, 1).render(tween._time, true, true);
                    initted = 1;
                }
                _onStart && _onStart.apply(tween, onStartParams || []); //in case the user had an onStart in the vars - we don't want to overwrite it.
            }
        }, vars));
        return immediateRender ? tween.render(0) : tween;
    };
    _proto2.tweenFromTo = function tweenFromTo(fromPosition, toPosition, vars) {
        return this.tweenTo(toPosition, _setDefaults({
            startAt: {
                time: _parsePosition(this, fromPosition)
            }
        }, vars));
    };
    _proto2.recent = function recent() {
        return this._recent;
    };
    _proto2.nextLabel = function nextLabel(afterTime) {
        if (afterTime === void 0) afterTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, afterTime));
    };
    _proto2.previousLabel = function previousLabel(beforeTime) {
        if (beforeTime === void 0) beforeTime = this._time;
        return _getLabelInDirection(this, _parsePosition(this, beforeTime), 1);
    };
    _proto2.currentLabel = function currentLabel(value) {
        return arguments.length ? this.seek(value, true) : this.previousLabel(this._time + _tinyNum);
    };
    _proto2.shiftChildren = function shiftChildren(amount, adjustLabels, ignoreBeforeTime) {
        if (ignoreBeforeTime === void 0) ignoreBeforeTime = 0;
        var child = this._first, labels = this.labels, p;
        amount = _roundPrecise(amount);
        while(child){
            if (child._start >= ignoreBeforeTime) {
                child._start += amount;
                child._end += amount;
            }
            child = child._next;
        }
        if (adjustLabels) {
            for(p in labels)if (labels[p] >= ignoreBeforeTime) labels[p] += amount;
        }
        return _uncache(this);
    };
    _proto2.invalidate = function invalidate(soft) {
        var child = this._first;
        this._lock = 0;
        while(child){
            child.invalidate(soft);
            child = child._next;
        }
        return _Animation.prototype.invalidate.call(this, soft);
    };
    _proto2.clear = function clear(includeLabels) {
        if (includeLabels === void 0) includeLabels = true;
        var child = this._first, next;
        while(child){
            next = child._next;
            this.remove(child);
            child = next;
        }
        this._dp && (this._time = this._tTime = this._pTime = 0);
        includeLabels && (this.labels = {});
        return _uncache(this);
    };
    _proto2.totalDuration = function totalDuration(value) {
        var max = 0, self = this, child = self._last, prevStart = _bigNum, prev, start, parent;
        if (arguments.length) return self.timeScale((self._repeat < 0 ? self.duration() : self.totalDuration()) / (self.reversed() ? -value : value));
        if (self._dirty) {
            parent = self.parent;
            while(child){
                prev = child._prev; //record it here in case the tween changes position in the sequence...
                child._dirty && child.totalDuration(); //could change the tween._startTime, so make sure the animation's cache is clean before analyzing it.
                start = child._start;
                if (start > prevStart && self._sort && child._ts && !self._lock) {
                    //in case one of the tweens shifted out of order, it needs to be re-inserted into the correct position in the sequence
                    self._lock = 1; //prevent endless recursive calls - there are methods that get triggered that check duration/totalDuration when we add().
                    _addToTimeline(self, child, start - child._delay, 1)._lock = 0;
                } else prevStart = start;
                if (start < 0 && child._ts) {
                    //children aren't allowed to have negative startTimes unless smoothChildTiming is true, so adjust here if one is found.
                    max -= start;
                    if (!parent && !self._dp || parent && parent.smoothChildTiming) {
                        self._start += _roundPrecise(start / self._ts);
                        self._time -= start;
                        self._tTime -= start;
                    }
                    self.shiftChildren(-start, false, -Infinity);
                    prevStart = 0;
                }
                child._end > max && child._ts && (max = child._end);
                child = prev;
            }
            _setDuration(self, self === _globalTimeline && self._time > max ? self._time : max, 1, 1);
            self._dirty = 0;
        }
        return self._tDur;
    };
    Timeline.updateRoot = function updateRoot(time) {
        if (_globalTimeline._ts) {
            _lazySafeRender(_globalTimeline, _parentToChildTotalTime(time, _globalTimeline));
            _lastRenderedFrame = _ticker.frame;
        }
        if (_ticker.frame >= _nextGCFrame) {
            _nextGCFrame += _config.autoSleep || 120;
            var child = _globalTimeline._first;
            if (!child || !child._ts) {
                if (_config.autoSleep && _ticker._listeners.length < 2) {
                    while(child && !child._ts)child = child._next;
                    child || _ticker.sleep();
                }
            }
        }
    };
    return Timeline;
}(Animation);
_setDefaults(Timeline.prototype, {
    _lock: 0,
    _hasPause: 0,
    _forcing: 0
});
var _addComplexStringPropTween = function _addComplexStringPropTween(target, prop, start, end, setter, stringFilter, funcParam) {
    //note: we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    var pt = new PropTween(this._pt, target, prop, 0, 1, _renderComplexString, null, setter), index = 0, matchIndex = 0, result, startNums, color, endNum, chunk, startNum, hasRandom, a;
    pt.b = start;
    pt.e = end;
    start += ""; //ensure values are strings
    end += "";
    if (hasRandom = ~end.indexOf("random(")) end = _replaceRandom(end);
    if (stringFilter) {
        a = [
            start,
            end
        ];
        stringFilter(a, target, prop); //pass an array with the starting and ending values and let the filter do whatever it needs to the values.
        start = a[0];
        end = a[1];
    }
    startNums = start.match(_complexStringNumExp) || [];
    while(result = _complexStringNumExp.exec(end)){
        endNum = result[0];
        chunk = end.substring(index, result.index);
        if (color) color = (color + 1) % 5;
        else if (chunk.substr(-5) === "rgba(") color = 1;
        if (endNum !== startNums[matchIndex++]) {
            startNum = parseFloat(startNums[matchIndex - 1]) || 0; //these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
            pt._pt = {
                _next: pt._pt,
                p: chunk || matchIndex === 1 ? chunk : ",",
                //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                s: startNum,
                c: endNum.charAt(1) === "=" ? _parseRelative(startNum, endNum) - startNum : parseFloat(endNum) - startNum,
                m: color && color < 4 ? Math.round : 0
            };
            index = _complexStringNumExp.lastIndex;
        }
    }
    pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    pt.fp = funcParam;
    if (_relExp.test(end) || hasRandom) pt.e = 0; //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _addComplexStringPropTween.call(tweenInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    return pt;
}, _addPropTween = function _addPropTween(target, prop, start, end, index, targets, modifier, stringFilter, funcParam, optional) {
    _isFunction(end) && (end = end(index || 0, target, targets));
    var currentValue = target[prop], parsedStart = start !== "get" ? start : !_isFunction(currentValue) ? currentValue : funcParam ? target[prop.indexOf("set") || !_isFunction(target["get" + prop.substr(3)]) ? prop : "get" + prop.substr(3)](funcParam) : target[prop](), setter = !_isFunction(currentValue) ? _setterPlain : funcParam ? _setterFuncWithParam : _setterFunc, pt;
    if (_isString(end)) {
        if (~end.indexOf("random(")) end = _replaceRandom(end);
        if (end.charAt(1) === "=") {
            pt = _parseRelative(parsedStart, end) + (getUnit(parsedStart) || 0);
            if (pt || pt === 0) // to avoid isNaN, like if someone passes in a value like "!= whatever"
            end = pt;
        }
    }
    if (!optional || parsedStart !== end || _forceAllPropTweens) {
        if (!isNaN(parsedStart * end) && end !== "") {
            // fun fact: any number multiplied by "" is evaluated as the number 0!
            pt = new PropTween(this._pt, target, prop, +parsedStart || 0, end - (parsedStart || 0), typeof currentValue === "boolean" ? _renderBoolean : _renderPlain, 0, setter);
            funcParam && (pt.fp = funcParam);
            modifier && pt.modifier(modifier, this, target);
            return this._pt = pt;
        }
        !currentValue && !(prop in target) && _missingPlugin(prop, end);
        return _addComplexStringPropTween.call(this, target, prop, parsedStart, end, setter, stringFilter || _config.stringFilter, funcParam);
    }
}, //creates a copy of the vars object and processes any function-based values (putting the resulting values directly into the copy) as well as strings with "random()" in them. It does NOT process relative values.
_processVars = function _processVars(vars, index, target, targets, tween) {
    _isFunction(vars) && (vars = _parseFuncOrString(vars, tween, index, target, targets));
    if (!_isObject(vars) || vars.style && vars.nodeType || _isArray(vars) || _isTypedArray(vars)) return _isString(vars) ? _parseFuncOrString(vars, tween, index, target, targets) : vars;
    var copy = {}, p;
    for(p in vars)copy[p] = _parseFuncOrString(vars[p], tween, index, target, targets);
    return copy;
}, _checkPlugin = function _checkPlugin(property, vars, tween, index, target, targets) {
    var plugin, pt, ptLookup, i;
    if (_plugins[property] && (plugin = new _plugins[property]()).init(target, plugin.rawVars ? vars[property] : _processVars(vars[property], index, target, targets, tween), tween, index, targets) !== false) {
        tween._pt = pt = new PropTween(tween._pt, target, property, 0, 1, plugin.render, plugin, 0, plugin.priority);
        if (tween !== _quickTween) {
            ptLookup = tween._ptLookup[tween._targets.indexOf(target)]; //note: we can't use tween._ptLookup[index] because for staggered tweens, the index from the fullTargets array won't match what it is in each individual tween that spawns from the stagger.
            i = plugin._props.length;
            while(i--)ptLookup[plugin._props[i]] = pt;
        }
    }
    return plugin;
}, _overwritingTween, //store a reference temporarily so we can avoid overwriting itself.
_forceAllPropTweens, _initTween = function _initTween(tween, time, tTime) {
    var vars = tween.vars, ease = vars.ease, startAt = vars.startAt, immediateRender = vars.immediateRender, lazy = vars.lazy, onUpdate = vars.onUpdate, runBackwards = vars.runBackwards, yoyoEase = vars.yoyoEase, keyframes = vars.keyframes, autoRevert = vars.autoRevert, dur = tween._dur, prevStartAt = tween._startAt, targets = tween._targets, parent = tween.parent, fullTargets = parent && parent.data === "nested" ? parent.vars.targets : targets, autoOverwrite = tween._overwrite === "auto" && !_suppressOverwrites, tl = tween.timeline, cleanVars, i, p, pt, target, hasPriority, gsData, harness, plugin, ptLookup, index, harnessVars, overwritten;
    tl && (!keyframes || !ease) && (ease = "none");
    tween._ease = _parseEase(ease, _defaults.ease);
    tween._yEase = yoyoEase ? _invertEase(_parseEase(yoyoEase === true ? ease : yoyoEase, _defaults.ease)) : 0;
    if (yoyoEase && tween._yoyo && !tween._repeat) {
        //there must have been a parent timeline with yoyo:true that is currently in its yoyo phase, so flip the eases.
        yoyoEase = tween._yEase;
        tween._yEase = tween._ease;
        tween._ease = yoyoEase;
    }
    tween._from = !tl && !!vars.runBackwards; //nested timelines should never run backwards - the backwards-ness is in the child tweens.
    if (!tl || keyframes && !vars.stagger) {
        //if there's an internal timeline, skip all the parsing because we passed that task down the chain.
        harness = targets[0] ? _getCache(targets[0]).harness : 0;
        harnessVars = harness && vars[harness.prop]; //someone may need to specify CSS-specific values AND non-CSS values, like if the element has an "x" property plus it's a standard DOM element. We allow people to distinguish by wrapping plugin-specific stuff in a css:{} object for example.
        cleanVars = _copyExcluding(vars, _reservedProps);
        if (prevStartAt) {
            prevStartAt._zTime < 0 && prevStartAt.progress(1); // in case it's a lazy startAt that hasn't rendered yet.
            time < 0 && runBackwards && immediateRender && !autoRevert ? prevStartAt.render(-1, true) : prevStartAt.revert(runBackwards && dur ? _revertConfigNoKill : _startAtRevertConfig); // if it's a "startAt" (not "from()" or runBackwards: true), we only need to do a shallow revert (keep transforms cached in CSSPlugin)
            // don't just _removeFromParent(prevStartAt.render(-1, true)) because that'll leave inline styles. We're creating a new _startAt for "startAt" tweens that re-capture things to ensure that if the pre-tween values changed since the tween was created, they're recorded.
            prevStartAt._lazy = 0;
        }
        if (startAt) {
            _removeFromParent(tween._startAt = Tween.set(targets, _setDefaults({
                data: "isStart",
                overwrite: false,
                parent: parent,
                immediateRender: true,
                lazy: !prevStartAt && _isNotFalse(lazy),
                startAt: null,
                delay: 0,
                onUpdate: onUpdate && function() {
                    return _callback(tween, "onUpdate");
                },
                stagger: 0
            }, startAt))); //copy the properties/values into a new object to avoid collisions, like var to = {x:0}, from = {x:500}; timeline.fromTo(e, from, to).fromTo(e, to, from);
            tween._startAt._dp = 0; // don't allow it to get put back into root timeline! Like when revert() is called and totalTime() gets set.
            tween._startAt._sat = tween; // used in globalTime(). _sat stands for _startAtTween
            time < 0 && (_reverting || !immediateRender && !autoRevert) && tween._startAt.revert(_revertConfigNoKill); // rare edge case, like if a render is forced in the negative direction of a non-initted tween.
            if (immediateRender) {
                if (dur && time <= 0 && tTime <= 0) {
                    // check tTime here because in the case of a yoyo tween whose playhead gets pushed to the end like tween.progress(1), we should allow it through so that the onComplete gets fired properly.
                    time && (tween._zTime = time);
                    return; //we skip initialization here so that overwriting doesn't occur until the tween actually begins. Otherwise, if you create several immediateRender:true tweens of the same target/properties to drop into a Timeline, the last one created would overwrite the first ones because they didn't get placed into the timeline yet before the first render occurs and kicks in overwriting.
                }
            }
        } else if (runBackwards && dur) //from() tweens must be handled uniquely: their beginning values must be rendered but we don't want overwriting to occur yet (when time is still 0). Wait until the tween actually begins before doing all the routines like overwriting. At that time, we should render at the END of the tween to ensure that things initialize correctly (remember, from() tweens go backwards)
        {
            if (!prevStartAt) {
                time && (immediateRender = false); //in rare cases (like if a from() tween runs and then is invalidate()-ed), immediateRender could be true but the initial forced-render gets skipped, so there's no need to force the render in this context when the _time is greater than 0
                p = _setDefaults({
                    overwrite: false,
                    data: "isFromStart",
                    //we tag the tween with as "isFromStart" so that if [inside a plugin] we need to only do something at the very END of a tween, we have a way of identifying this tween as merely the one that's setting the beginning values for a "from()" tween. For example, clearProps in CSSPlugin should only get applied at the very END of a tween and without this tag, from(...{height:100, clearProps:"height", delay:1}) would wipe the height at the beginning of the tween and after 1 second, it'd kick back in.
                    lazy: immediateRender && !prevStartAt && _isNotFalse(lazy),
                    immediateRender: immediateRender,
                    //zero-duration tweens render immediately by default, but if we're not specifically instructed to render this tween immediately, we should skip this and merely _init() to record the starting values (rendering them immediately would push them to completion which is wasteful in that case - we'd have to render(-1) immediately after)
                    stagger: 0,
                    parent: parent //ensures that nested tweens that had a stagger are handled properly, like gsap.from(".class", {y: gsap.utils.wrap([-100,100]), stagger: 0.5})
                }, cleanVars);
                harnessVars && (p[harness.prop] = harnessVars); // in case someone does something like .from(..., {css:{}})
                _removeFromParent(tween._startAt = Tween.set(targets, p));
                tween._startAt._dp = 0; // don't allow it to get put back into root timeline!
                tween._startAt._sat = tween; // used in globalTime()
                time < 0 && (_reverting ? tween._startAt.revert(_revertConfigNoKill) : tween._startAt.render(-1, true));
                tween._zTime = time;
                if (!immediateRender) _initTween(tween._startAt, _tinyNum, _tinyNum); //ensures that the initial values are recorded
                else if (!time) return;
            }
        }
        tween._pt = tween._ptCache = 0;
        lazy = dur && _isNotFalse(lazy) || lazy && !dur;
        for(i = 0; i < targets.length; i++){
            target = targets[i];
            gsData = target._gsap || _harness(targets)[i]._gsap;
            tween._ptLookup[i] = ptLookup = {};
            _lazyLookup[gsData.id] && _lazyTweens.length && _lazyRender(); //if other tweens of the same target have recently initted but haven't rendered yet, we've got to force the render so that the starting values are correct (imagine populating a timeline with a bunch of sequential tweens and then jumping to the end)
            index = fullTargets === targets ? i : fullTargets.indexOf(target);
            if (harness && (plugin = new harness()).init(target, harnessVars || cleanVars, tween, index, fullTargets) !== false) {
                tween._pt = pt = new PropTween(tween._pt, target, plugin.name, 0, 1, plugin.render, plugin, 0, plugin.priority);
                plugin._props.forEach(function(name) {
                    ptLookup[name] = pt;
                });
                plugin.priority && (hasPriority = 1);
            }
            if (!harness || harnessVars) {
                for(p in cleanVars)if (_plugins[p] && (plugin = _checkPlugin(p, cleanVars, tween, index, target, fullTargets))) plugin.priority && (hasPriority = 1);
                else ptLookup[p] = pt = _addPropTween.call(tween, target, p, "get", cleanVars[p], index, fullTargets, 0, vars.stringFilter);
            }
            tween._op && tween._op[i] && tween.kill(target, tween._op[i]);
            if (autoOverwrite && tween._pt) {
                _overwritingTween = tween;
                _globalTimeline.killTweensOf(target, ptLookup, tween.globalTime(time)); // make sure the overwriting doesn't overwrite THIS tween!!!
                overwritten = !tween.parent;
                _overwritingTween = 0;
            }
            tween._pt && lazy && (_lazyLookup[gsData.id] = 1);
        }
        hasPriority && _sortPropTweensByPriority(tween);
        tween._onInit && tween._onInit(tween); //plugins like RoundProps must wait until ALL of the PropTweens are instantiated. In the plugin's init() function, it sets the _onInit on the tween instance. May not be pretty/intuitive, but it's fast and keeps file size down.
    }
    tween._onUpdate = onUpdate;
    tween._initted = (!tween._op || tween._pt) && !overwritten; // if overwrittenProps resulted in the entire tween being killed, do NOT flag it as initted or else it may render for one tick.
    keyframes && time <= 0 && tl.render(_bigNum, true, true); // if there's a 0% keyframe, it'll render in the "before" state for any staggered/delayed animations thus when the following tween initializes, it'll use the "before" state instead of the "after" state as the initial values.
}, _updatePropTweens = function _updatePropTweens(tween, property, value, start, startIsRelative, ratio, time, skipRecursion) {
    var ptCache = (tween._pt && tween._ptCache || (tween._ptCache = {}))[property], pt, rootPT, lookup, i;
    if (!ptCache) {
        ptCache = tween._ptCache[property] = [];
        lookup = tween._ptLookup;
        i = tween._targets.length;
        while(i--){
            pt = lookup[i][property];
            if (pt && pt.d && pt.d._pt) {
                // it's a plugin, so find the nested PropTween
                pt = pt.d._pt;
                while(pt && pt.p !== property && pt.fp !== property)// "fp" is functionParam for things like setting CSS variables which require .setProperty("--var-name", value)
                pt = pt._next;
            }
            if (!pt) {
                // there is no PropTween associated with that property, so we must FORCE one to be created and ditch out of this
                // if the tween has other properties that already rendered at new positions, we'd normally have to rewind to put them back like tween.render(0, true) before forcing an _initTween(), but that can create another edge case like tweening a timeline's progress would trigger onUpdates to fire which could move other things around. It's better to just inform users that .resetTo() should ONLY be used for tweens that already have that property. For example, you can't gsap.to(...{ y: 0 }) and then tween.restTo("x", 200) for example.
                _forceAllPropTweens = 1; // otherwise, when we _addPropTween() and it finds no change between the start and end values, it skips creating a PropTween (for efficiency...why tween when there's no difference?) but in this case we NEED that PropTween created so we can edit it.
                tween.vars[property] = "+=0";
                _initTween(tween, time);
                _forceAllPropTweens = 0;
                return skipRecursion ? _warn(property + " not eligible for reset") : 1; // if someone tries to do a quickTo() on a special property like borderRadius which must get split into 4 different properties, that's not eligible for .resetTo().
            }
            ptCache.push(pt);
        }
    }
    i = ptCache.length;
    while(i--){
        rootPT = ptCache[i];
        pt = rootPT._pt || rootPT; // complex values may have nested PropTweens. We only accommodate the FIRST value.
        pt.s = (start || start === 0) && !startIsRelative ? start : pt.s + (start || 0) + ratio * pt.c;
        pt.c = value - pt.s;
        rootPT.e && (rootPT.e = _round(value) + getUnit(rootPT.e)); // mainly for CSSPlugin (end value)
        rootPT.b && (rootPT.b = pt.s + getUnit(rootPT.b)); // (beginning value)
    }
}, _addAliasesToVars = function _addAliasesToVars(targets, vars) {
    var harness = targets[0] ? _getCache(targets[0]).harness : 0, propertyAliases = harness && harness.aliases, copy, p, i, aliases;
    if (!propertyAliases) return vars;
    copy = _merge({}, vars);
    for(p in propertyAliases)if (p in copy) {
        aliases = propertyAliases[p].split(",");
        i = aliases.length;
        while(i--)copy[aliases[i]] = copy[p];
    }
    return copy;
}, // parses multiple formats, like {"0%": {x: 100}, {"50%": {x: -20}} and { x: {"0%": 100, "50%": -20} }, and an "ease" can be set on any object. We populate an "allProps" object with an Array for each property, like {x: [{}, {}], y:[{}, {}]} with data for each property tween. The objects have a "t" (time), "v", (value), and "e" (ease) property. This allows us to piece together a timeline later.
_parseKeyframe = function _parseKeyframe(prop, obj, allProps, easeEach) {
    var ease = obj.ease || easeEach || "power1.inOut", p, a;
    if (_isArray(obj)) {
        a = allProps[prop] || (allProps[prop] = []); // t = time (out of 100), v = value, e = ease
        obj.forEach(function(value, i) {
            return a.push({
                t: i / (obj.length - 1) * 100,
                v: value,
                e: ease
            });
        });
    } else for(p in obj){
        a = allProps[p] || (allProps[p] = []);
        p === "ease" || a.push({
            t: parseFloat(prop),
            v: obj[p],
            e: ease
        });
    }
}, _parseFuncOrString = function _parseFuncOrString(value, tween, i, target, targets) {
    return _isFunction(value) ? value.call(tween, i, target, targets) : _isString(value) && ~value.indexOf("random(") ? _replaceRandom(value) : value;
}, _staggerTweenProps = _callbackNames + "repeat,repeatDelay,yoyo,repeatRefresh,yoyoEase,autoRevert", _staggerPropsToSkip = {};
_forEachName(_staggerTweenProps + ",id,stagger,delay,duration,paused,scrollTrigger", function(name) {
    return _staggerPropsToSkip[name] = 1;
});
var Tween = /*#__PURE__*/ function(_Animation2) {
    _inheritsLoose(Tween, _Animation2);
    function Tween(targets, vars, position, skipInherit) {
        var _this3;
        if (typeof vars === "number") {
            position.duration = vars;
            vars = position;
            position = null;
        }
        _this3 = _Animation2.call(this, skipInherit ? vars : _inheritDefaults(vars)) || this;
        var _this3$vars = _this3.vars, duration = _this3$vars.duration, delay = _this3$vars.delay, immediateRender = _this3$vars.immediateRender, stagger = _this3$vars.stagger, overwrite = _this3$vars.overwrite, keyframes = _this3$vars.keyframes, defaults = _this3$vars.defaults, scrollTrigger = _this3$vars.scrollTrigger, yoyoEase = _this3$vars.yoyoEase, parent = vars.parent || _globalTimeline, parsedTargets = (_isArray(targets) || _isTypedArray(targets) ? _isNumber(targets[0]) : "length" in vars) ? [
            targets
        ] : toArray(targets), tl, i, copy, l, p, curTarget, staggerFunc, staggerVarsToMerge;
        _this3._targets = parsedTargets.length ? _harness(parsedTargets) : _warn("GSAP target " + targets + " not found. https://gsap.com", !_config.nullTargetWarn) || [];
        _this3._ptLookup = []; //PropTween lookup. An array containing an object for each target, having keys for each tweening property
        _this3._overwrite = overwrite;
        if (keyframes || stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
            vars = _this3.vars;
            tl = _this3.timeline = new Timeline({
                data: "nested",
                defaults: defaults || {},
                targets: parent && parent.data === "nested" ? parent.vars.targets : parsedTargets
            }); // we need to store the targets because for staggers and keyframes, we end up creating an individual tween for each but function-based values need to know the index and the whole Array of targets.
            tl.kill();
            tl.parent = tl._dp = _assertThisInitialized(_this3);
            tl._start = 0;
            if (stagger || _isFuncOrString(duration) || _isFuncOrString(delay)) {
                l = parsedTargets.length;
                staggerFunc = stagger && distribute(stagger);
                if (_isObject(stagger)) {
                    //users can pass in callbacks like onStart/onComplete in the stagger object. These should fire with each individual tween.
                    for(p in stagger)if (~_staggerTweenProps.indexOf(p)) {
                        staggerVarsToMerge || (staggerVarsToMerge = {});
                        staggerVarsToMerge[p] = stagger[p];
                    }
                }
                for(i = 0; i < l; i++){
                    copy = _copyExcluding(vars, _staggerPropsToSkip);
                    copy.stagger = 0;
                    yoyoEase && (copy.yoyoEase = yoyoEase);
                    staggerVarsToMerge && _merge(copy, staggerVarsToMerge);
                    curTarget = parsedTargets[i]; //don't just copy duration or delay because if they're a string or function, we'd end up in an infinite loop because _isFuncOrString() would evaluate as true in the child tweens, entering this loop, etc. So we parse the value straight from vars and default to 0.
                    copy.duration = +_parseFuncOrString(duration, _assertThisInitialized(_this3), i, curTarget, parsedTargets);
                    copy.delay = (+_parseFuncOrString(delay, _assertThisInitialized(_this3), i, curTarget, parsedTargets) || 0) - _this3._delay;
                    if (!stagger && l === 1 && copy.delay) {
                        // if someone does delay:"random(1, 5)", repeat:-1, for example, the delay shouldn't be inside the repeat.
                        _this3._delay = delay = copy.delay;
                        _this3._start += delay;
                        copy.delay = 0;
                    }
                    tl.to(curTarget, copy, staggerFunc ? staggerFunc(i, curTarget, parsedTargets) : 0);
                    tl._ease = _easeMap.none;
                }
                tl.duration() ? duration = delay = 0 : _this3.timeline = 0; // if the timeline's duration is 0, we don't need a timeline internally!
            } else if (keyframes) {
                _inheritDefaults(_setDefaults(tl.vars.defaults, {
                    ease: "none"
                }));
                tl._ease = _parseEase(keyframes.ease || vars.ease || "none");
                var time = 0, a, kf, v;
                if (_isArray(keyframes)) {
                    keyframes.forEach(function(frame) {
                        return tl.to(parsedTargets, frame, ">");
                    });
                    tl.duration(); // to ensure tl._dur is cached because we tap into it for performance purposes in the render() method.
                } else {
                    copy = {};
                    for(p in keyframes)p === "ease" || p === "easeEach" || _parseKeyframe(p, keyframes[p], copy, keyframes.easeEach);
                    for(p in copy){
                        a = copy[p].sort(function(a, b) {
                            return a.t - b.t;
                        });
                        time = 0;
                        for(i = 0; i < a.length; i++){
                            kf = a[i];
                            v = {
                                ease: kf.e,
                                duration: (kf.t - (i ? a[i - 1].t : 0)) / 100 * duration
                            };
                            v[p] = kf.v;
                            tl.to(parsedTargets, v, time);
                            time += v.duration;
                        }
                    }
                    tl.duration() < duration && tl.to({}, {
                        duration: duration - tl.duration()
                    }); // in case keyframes didn't go to 100%
                }
            }
            duration || _this3.duration(duration = tl.duration());
        } else _this3.timeline = 0; //speed optimization, faster lookups (no going up the prototype chain)
        if (overwrite === true && !_suppressOverwrites) {
            _overwritingTween = _assertThisInitialized(_this3);
            _globalTimeline.killTweensOf(parsedTargets);
            _overwritingTween = 0;
        }
        _addToTimeline(parent, _assertThisInitialized(_this3), position);
        vars.reversed && _this3.reverse();
        vars.paused && _this3.paused(true);
        if (immediateRender || !duration && !keyframes && _this3._start === _roundPrecise(parent._time) && _isNotFalse(immediateRender) && _hasNoPausedAncestors(_assertThisInitialized(_this3)) && parent.data !== "nested") {
            _this3._tTime = -_tinyNum; //forces a render without having to set the render() "force" parameter to true because we want to allow lazying by default (using the "force" parameter always forces an immediate full render)
            _this3.render(Math.max(0, -delay) || 0); //in case delay is negative
        }
        scrollTrigger && _scrollTrigger(_assertThisInitialized(_this3), scrollTrigger);
        return _this3;
    }
    var _proto3 = Tween.prototype;
    _proto3.render = function render(totalTime, suppressEvents, force) {
        var prevTime = this._time, tDur = this._tDur, dur = this._dur, isNegative = totalTime < 0, tTime = totalTime > tDur - _tinyNum && !isNegative ? tDur : totalTime < _tinyNum ? 0 : totalTime, time, pt, iteration, cycleDuration, prevIteration, isYoyo, ratio, timeline, yoyoEase;
        if (!dur) _renderZeroDurationTween(this, totalTime, suppressEvents, force);
        else if (tTime !== this._tTime || !totalTime || force || !this._initted && this._tTime || this._startAt && this._zTime < 0 !== isNegative || this._lazy) {
            // this senses if we're crossing over the start time, in which case we must record _zTime and force the render, but we do it in this lengthy conditional way for performance reasons (usually we can skip the calculations): this._initted && (this._zTime < 0) !== (totalTime < 0)
            time = tTime;
            timeline = this.timeline;
            if (this._repeat) {
                //adjust the time for repeats and yoyos
                cycleDuration = dur + this._rDelay;
                if (this._repeat < -1 && isNegative) return this.totalTime(cycleDuration * 100 + totalTime, suppressEvents, force);
                time = _roundPrecise(tTime % cycleDuration); //round to avoid floating point errors. (4 % 0.8 should be 0 but some browsers report it as 0.79999999!)
                if (tTime === tDur) {
                    // the tDur === tTime is for edge cases where there's a lengthy decimal on the duration and it may reach the very end but the time is rendered as not-quite-there (remember, tDur is rounded to 4 decimals whereas dur isn't)
                    iteration = this._repeat;
                    time = dur;
                } else {
                    prevIteration = _roundPrecise(tTime / cycleDuration); // full decimal version of iterations, not the previous iteration (we're reusing prevIteration variable for efficiency)
                    iteration = ~~prevIteration;
                    if (iteration && iteration === prevIteration) {
                        time = dur;
                        iteration--;
                    } else if (time > dur) time = dur;
                }
                isYoyo = this._yoyo && iteration & 1;
                if (isYoyo) {
                    yoyoEase = this._yEase;
                    time = dur - time;
                }
                prevIteration = _animationCycle(this._tTime, cycleDuration);
                if (time === prevTime && !force && this._initted && iteration === prevIteration) {
                    //could be during the repeatDelay part. No need to render and fire callbacks.
                    this._tTime = tTime;
                    return this;
                }
                if (iteration !== prevIteration) {
                    timeline && this._yEase && _propagateYoyoEase(timeline, isYoyo); //repeatRefresh functionality
                    if (this.vars.repeatRefresh && !isYoyo && !this._lock && time !== cycleDuration && this._initted) {
                        // this._time will === cycleDuration when we render at EXACTLY the end of an iteration. Without this condition, it'd often do the repeatRefresh render TWICE (again on the very next tick).
                        this._lock = force = 1; //force, otherwise if lazy is true, the _attemptInitTween() will return and we'll jump out and get caught bouncing on each tick.
                        this.render(_roundPrecise(cycleDuration * iteration), true).invalidate()._lock = 0;
                    }
                }
            }
            if (!this._initted) {
                if (_attemptInitTween(this, isNegative ? totalTime : time, force, suppressEvents, tTime)) {
                    this._tTime = 0; // in constructor if immediateRender is true, we set _tTime to -_tinyNum to have the playhead cross the starting point but we can't leave _tTime as a negative number.
                    return this;
                }
                if (prevTime !== this._time && !(force && this.vars.repeatRefresh && iteration !== prevIteration)) // rare edge case - during initialization, an onUpdate in the _startAt (.fromTo()) might force this tween to render at a different spot in which case we should ditch this render() call so that it doesn't revert the values. But we also don't want to dump if we're doing a repeatRefresh render!
                return this;
                if (dur !== this._dur) // while initting, a plugin like InertiaPlugin might alter the duration, so rerun from the start to ensure everything renders as it should.
                return this.render(totalTime, suppressEvents, force);
            }
            this._tTime = tTime;
            this._time = time;
            if (!this._act && this._ts) {
                this._act = 1; //as long as it's not paused, force it to be active so that if the user renders independent of the parent timeline, it'll be forced to re-render on the next tick.
                this._lazy = 0;
            }
            this.ratio = ratio = (yoyoEase || this._ease)(time / dur);
            if (this._from) this.ratio = ratio = 1 - ratio;
            if (!prevTime && tTime && !suppressEvents && !prevIteration) {
                _callback(this, "onStart");
                if (this._tTime !== tTime) // in case the onStart triggered a render at a different spot, eject. Like if someone did animation.pause(0.5) or something inside the onStart.
                return this;
            }
            pt = this._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
            timeline && timeline.render(totalTime < 0 ? totalTime : timeline._dur * timeline._ease(time / this._dur), suppressEvents, force) || this._startAt && (this._zTime = totalTime);
            if (this._onUpdate && !suppressEvents) {
                isNegative && _rewindStartAt(this, totalTime, suppressEvents, force); //note: for performance reasons, we tuck this conditional logic inside less traveled areas (most tweens don't have an onUpdate). We'd just have it at the end before the onComplete, but the values should be updated before any onUpdate is called, so we ALSO put it here and then if it's not called, we do so later near the onComplete.
                _callback(this, "onUpdate");
            }
            this._repeat && iteration !== prevIteration && this.vars.onRepeat && !suppressEvents && this.parent && _callback(this, "onRepeat");
            if ((tTime === this._tDur || !tTime) && this._tTime === tTime) {
                isNegative && !this._onUpdate && _rewindStartAt(this, totalTime, true, true);
                (totalTime || !dur) && (tTime === this._tDur && this._ts > 0 || !tTime && this._ts < 0) && _removeFromParent(this, 1); // don't remove if we're rendering at exactly a time of 0, as there could be autoRevert values that should get set on the next tick (if the playhead goes backward beyond the startTime, negative totalTime). Don't remove if the timeline is reversed and the playhead isn't at 0, otherwise tl.progress(1).reverse() won't work. Only remove if the playhead is at the end and timeScale is positive, or if the playhead is at 0 and the timeScale is negative.
                if (!suppressEvents && !(isNegative && !prevTime) && (tTime || prevTime || isYoyo)) {
                    // if prevTime and tTime are zero, we shouldn't fire the onReverseComplete. This could happen if you gsap.to(... {paused:true}).play();
                    _callback(this, tTime === tDur ? "onComplete" : "onReverseComplete", true);
                    this._prom && !(tTime < tDur && this.timeScale() > 0) && this._prom();
                }
            }
        }
        return this;
    };
    _proto3.targets = function targets() {
        return this._targets;
    };
    _proto3.invalidate = function invalidate(soft) {
        // "soft" gives us a way to clear out everything EXCEPT the recorded pre-"from" portion of from() tweens. Otherwise, for example, if you tween.progress(1).render(0, true true).invalidate(), the "from" values would persist and then on the next render, the from() tweens would initialize and the current value would match the "from" values, thus animate from the same value to the same value (no animation). We tap into this in ScrollTrigger's refresh() where we must push a tween to completion and then back again but honor its init state in case the tween is dependent on another tween further up on the page.
        (!soft || !this.vars.runBackwards) && (this._startAt = 0);
        this._pt = this._op = this._onUpdate = this._lazy = this.ratio = 0;
        this._ptLookup = [];
        this.timeline && this.timeline.invalidate(soft);
        return _Animation2.prototype.invalidate.call(this, soft);
    };
    _proto3.resetTo = function resetTo(property, value, start, startIsRelative, skipRecursion) {
        _tickerActive || _ticker.wake();
        this._ts || this.play();
        var time = Math.min(this._dur, (this._dp._time - this._start) * this._ts), ratio;
        this._initted || _initTween(this, time);
        ratio = this._ease(time / this._dur); // don't just get tween.ratio because it may not have rendered yet.
        // possible future addition to allow an object with multiple values to update, like tween.resetTo({x: 100, y: 200}); At this point, it doesn't seem worth the added kb given the fact that most users will likely opt for the convenient gsap.quickTo() way of interacting with this method.
        // if (_isObject(property)) { // performance optimization
        // 	for (p in property) {
        // 		if (_updatePropTweens(this, p, property[p], value ? value[p] : null, start, ratio, time)) {
        // 			return this.resetTo(property, value, start, startIsRelative); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
        // 		}
        // 	}
        // } else {
        if (_updatePropTweens(this, property, value, start, startIsRelative, ratio, time, skipRecursion)) return this.resetTo(property, value, start, startIsRelative, 1); // if a PropTween wasn't found for the property, it'll get forced with a re-initialization so we need to jump out and start over again.
         //}
        _alignPlayhead(this, 0);
        this.parent || _addLinkedListItem(this._dp, this, "_first", "_last", this._dp._sort ? "_start" : 0);
        return this.render(0);
    };
    _proto3.kill = function kill(targets, vars) {
        if (vars === void 0) vars = "all";
        if (!targets && (!vars || vars === "all")) {
            this._lazy = this._pt = 0;
            this.parent ? _interrupt(this) : this.scrollTrigger && this.scrollTrigger.kill(!!_reverting);
            return this;
        }
        if (this.timeline) {
            var tDur = this.timeline.totalDuration();
            this.timeline.killTweensOf(targets, vars, _overwritingTween && _overwritingTween.vars.overwrite !== true)._first || _interrupt(this); // if nothing is left tweening, interrupt.
            this.parent && tDur !== this.timeline.totalDuration() && _setDuration(this, this._dur * this.timeline._tDur / tDur, 0, 1); // if a nested tween is killed that changes the duration, it should affect this tween's duration. We must use the ratio, though, because sometimes the internal timeline is stretched like for keyframes where they don't all add up to whatever the parent tween's duration was set to.
            return this;
        }
        var parsedTargets = this._targets, killingTargets = targets ? toArray(targets) : parsedTargets, propTweenLookup = this._ptLookup, firstPT = this._pt, overwrittenProps, curLookup, curOverwriteProps, props, p, pt, i;
        if ((!vars || vars === "all") && _arraysMatch(parsedTargets, killingTargets)) {
            vars === "all" && (this._pt = 0);
            return _interrupt(this);
        }
        overwrittenProps = this._op = this._op || [];
        if (vars !== "all") {
            //so people can pass in a comma-delimited list of property names
            if (_isString(vars)) {
                p = {};
                _forEachName(vars, function(name) {
                    return p[name] = 1;
                });
                vars = p;
            }
            vars = _addAliasesToVars(parsedTargets, vars);
        }
        i = parsedTargets.length;
        while(i--)if (~killingTargets.indexOf(parsedTargets[i])) {
            curLookup = propTweenLookup[i];
            if (vars === "all") {
                overwrittenProps[i] = vars;
                props = curLookup;
                curOverwriteProps = {};
            } else {
                curOverwriteProps = overwrittenProps[i] = overwrittenProps[i] || {};
                props = vars;
            }
            for(p in props){
                pt = curLookup && curLookup[p];
                if (pt) {
                    if (!("kill" in pt.d) || pt.d.kill(p) === true) _removeLinkedListItem(this, pt, "_pt");
                    delete curLookup[p];
                }
                if (curOverwriteProps !== "all") curOverwriteProps[p] = 1;
            }
        }
        this._initted && !this._pt && firstPT && _interrupt(this); //if all tweening properties are killed, kill the tween. Without this line, if there's a tween with multiple targets and then you killTweensOf() each target individually, the tween would technically still remain active and fire its onComplete even though there aren't any more properties tweening.
        return this;
    };
    Tween.to = function to(targets, vars) {
        return new Tween(targets, vars, arguments[2]);
    };
    Tween.from = function from(targets, vars) {
        return _createTweenType(1, arguments);
    };
    Tween.delayedCall = function delayedCall(delay, callback, params, scope) {
        return new Tween(callback, 0, {
            immediateRender: false,
            lazy: false,
            overwrite: false,
            delay: delay,
            onComplete: callback,
            onReverseComplete: callback,
            onCompleteParams: params,
            onReverseCompleteParams: params,
            callbackScope: scope
        }); // we must use onReverseComplete too for things like timeline.add(() => {...}) which should be triggered in BOTH directions (forward and reverse)
    };
    Tween.fromTo = function fromTo(targets, fromVars, toVars) {
        return _createTweenType(2, arguments);
    };
    Tween.set = function set(targets, vars) {
        vars.duration = 0;
        vars.repeatDelay || (vars.repeat = 0);
        return new Tween(targets, vars);
    };
    Tween.killTweensOf = function killTweensOf(targets, props, onlyActive) {
        return _globalTimeline.killTweensOf(targets, props, onlyActive);
    };
    return Tween;
}(Animation);
_setDefaults(Tween.prototype, {
    _targets: [],
    _lazy: 0,
    _startAt: 0,
    _op: 0,
    _onInit: 0
}); //add the pertinent timeline methods to Tween instances so that users can chain conveniently and create a timeline automatically. (removed due to concerns that it'd ultimately add to more confusion especially for beginners)
// _forEachName("to,from,fromTo,set,call,add,addLabel,addPause", name => {
// 	Tween.prototype[name] = function() {
// 		let tl = new Timeline();
// 		return _addToTimeline(tl, this)[name].apply(tl, toArray(arguments));
// 	}
// });
//for backward compatibility. Leverage the timeline calls.
_forEachName("staggerTo,staggerFrom,staggerFromTo", function(name) {
    Tween[name] = function() {
        var tl = new Timeline(), params = _slice.call(arguments, 0);
        params.splice(name === "staggerFromTo" ? 5 : 4, 0, 0);
        return tl[name].apply(tl, params);
    };
});
/*
 * --------------------------------------------------------------------------------------
 * PROPTWEEN
 * --------------------------------------------------------------------------------------
 */ var _setterPlain = function _setterPlain(target, property, value) {
    return target[property] = value;
}, _setterFunc = function _setterFunc(target, property, value) {
    return target[property](value);
}, _setterFuncWithParam = function _setterFuncWithParam(target, property, value, data) {
    return target[property](data.fp, value);
}, _setterAttribute = function _setterAttribute(target, property, value) {
    return target.setAttribute(property, value);
}, _getSetter = function _getSetter(target, property) {
    return _isFunction(target[property]) ? _setterFunc : _isUndefined(target[property]) && target.setAttribute ? _setterAttribute : _setterPlain;
}, _renderPlain = function _renderPlain(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 1000000) / 1000000, data);
}, _renderBoolean = function _renderBoolean(ratio, data) {
    return data.set(data.t, data.p, !!(data.s + data.c * ratio), data);
}, _renderComplexString = function _renderComplexString(ratio, data) {
    var pt = data._pt, s = "";
    if (!ratio && data.b) //b = beginning string
    s = data.b;
    else if (ratio === 1 && data.e) //e = ending string
    s = data.e;
    else {
        while(pt){
            s = pt.p + (pt.m ? pt.m(pt.s + pt.c * ratio) : Math.round((pt.s + pt.c * ratio) * 10000) / 10000) + s; //we use the "p" property for the text inbetween (like a suffix). And in the context of a complex string, the modifier (m) is typically just Math.round(), like for RGB colors.
            pt = pt._next;
        }
        s += data.c; //we use the "c" of the PropTween to store the final chunk of non-numeric text.
    }
    data.set(data.t, data.p, s, data);
}, _renderPropTweens = function _renderPropTweens(ratio, data) {
    var pt = data._pt;
    while(pt){
        pt.r(ratio, pt.d);
        pt = pt._next;
    }
}, _addPluginModifier = function _addPluginModifier(modifier, tween, target, property) {
    var pt = this._pt, next;
    while(pt){
        next = pt._next;
        pt.p === property && pt.modifier(modifier, tween, target);
        pt = next;
    }
}, _killPropTweensOf = function _killPropTweensOf(property) {
    var pt = this._pt, hasNonDependentRemaining, next;
    while(pt){
        next = pt._next;
        if (pt.p === property && !pt.op || pt.op === property) _removeLinkedListItem(this, pt, "_pt");
        else if (!pt.dep) hasNonDependentRemaining = 1;
        pt = next;
    }
    return !hasNonDependentRemaining;
}, _setterWithModifier = function _setterWithModifier(target, property, value, data) {
    data.mSet(target, property, data.m.call(data.tween, value, data.mt), data);
}, _sortPropTweensByPriority = function _sortPropTweensByPriority(parent) {
    var pt = parent._pt, next, pt2, first, last; //sorts the PropTween linked list in order of priority because some plugins need to do their work after ALL of the PropTweens were created (like RoundPropsPlugin and ModifiersPlugin)
    while(pt){
        next = pt._next;
        pt2 = first;
        while(pt2 && pt2.pr > pt.pr)pt2 = pt2._next;
        if (pt._prev = pt2 ? pt2._prev : last) pt._prev._next = pt;
        else first = pt;
        if (pt._next = pt2) pt2._prev = pt;
        else last = pt;
        pt = next;
    }
    parent._pt = first;
}; //PropTween key: t = target, p = prop, r = renderer, d = data, s = start, c = change, op = overwriteProperty (ONLY populated when it's different than p), pr = priority, _next/_prev for the linked list siblings, set = setter, m = modifier, mSet = modifierSetter (the original setter, before a modifier was added)
var PropTween = /*#__PURE__*/ function() {
    function PropTween(next, target, prop, start, change, renderer, data, setter, priority) {
        this.t = target;
        this.s = start;
        this.c = change;
        this.p = prop;
        this.r = renderer || _renderPlain;
        this.d = data || this;
        this.set = setter || _setterPlain;
        this.pr = priority || 0;
        this._next = next;
        if (next) next._prev = this;
    }
    var _proto4 = PropTween.prototype;
    _proto4.modifier = function modifier(func, tween, target) {
        this.mSet = this.mSet || this.set; //in case it was already set (a PropTween can only have one modifier)
        this.set = _setterWithModifier;
        this.m = func;
        this.mt = target; //modifier target
        this.tween = tween;
    };
    return PropTween;
}(); //Initialization tasks
_forEachName(_callbackNames + "parent,duration,ease,delay,overwrite,runBackwards,startAt,yoyo,immediateRender,repeat,repeatDelay,data,paused,reversed,lazy,callbackScope,stringFilter,id,yoyoEase,stagger,inherit,repeatRefresh,keyframes,autoRevert,scrollTrigger", function(name) {
    return _reservedProps[name] = 1;
});
_globals.TweenMax = _globals.TweenLite = Tween;
_globals.TimelineLite = _globals.TimelineMax = Timeline;
_globalTimeline = new Timeline({
    sortChildren: false,
    defaults: _defaults,
    autoRemoveChildren: true,
    id: "root",
    smoothChildTiming: true
});
_config.stringFilter = _colorStringFilter;
var _media = [], _listeners = {}, _emptyArray = [], _lastMediaTime = 0, _contextID = 0, _dispatch = function _dispatch(type) {
    return (_listeners[type] || _emptyArray).map(function(f) {
        return f();
    });
}, _onMediaChange = function _onMediaChange() {
    var time = Date.now(), matches = [];
    if (time - _lastMediaTime > 2) {
        _dispatch("matchMediaInit");
        _media.forEach(function(c) {
            var queries = c.queries, conditions = c.conditions, match, p, anyMatch, toggled;
            for(p in queries){
                match = _win.matchMedia(queries[p]).matches; // Firefox doesn't update the "matches" property of the MediaQueryList object correctly - it only does so as it calls its change handler - so we must re-create a media query here to ensure it's accurate.
                match && (anyMatch = 1);
                if (match !== conditions[p]) {
                    conditions[p] = match;
                    toggled = 1;
                }
            }
            if (toggled) {
                c.revert();
                anyMatch && matches.push(c);
            }
        });
        _dispatch("matchMediaRevert");
        matches.forEach(function(c) {
            return c.onMatch(c, function(func) {
                return c.add(null, func);
            });
        });
        _lastMediaTime = time;
        _dispatch("matchMedia");
    }
};
var Context = /*#__PURE__*/ function() {
    function Context(func, scope) {
        this.selector = scope && selector(scope);
        this.data = [];
        this._r = []; // returned/cleanup functions
        this.isReverted = false;
        this.id = _contextID++; // to work around issues that frameworks like Vue cause by making things into Proxies which make it impossible to do something like _media.indexOf(this) because "this" would no longer refer to the Context instance itself - it'd refer to a Proxy! We needed a way to identify the context uniquely
        func && this.add(func);
    }
    var _proto5 = Context.prototype;
    _proto5.add = function add(name, func, scope) {
        // possible future addition if we need the ability to add() an animation to a context and for whatever reason cannot create that animation inside of a context.add(() => {...}) function.
        // if (name && _isFunction(name.revert)) {
        // 	this.data.push(name);
        // 	return (name._ctx = this);
        // }
        if (_isFunction(name)) {
            scope = func;
            func = name;
            name = _isFunction;
        }
        var self = this, f = function f() {
            var prev = _context, prevSelector = self.selector, result;
            prev && prev !== self && prev.data.push(self);
            scope && (self.selector = selector(scope));
            _context = self;
            result = func.apply(self, arguments);
            _isFunction(result) && self._r.push(result);
            _context = prev;
            self.selector = prevSelector;
            self.isReverted = false;
            return result;
        };
        self.last = f;
        return name === _isFunction ? f(self, function(func) {
            return self.add(null, func);
        }) : name ? self[name] = f : f;
    };
    _proto5.ignore = function ignore(func) {
        var prev = _context;
        _context = null;
        func(this);
        _context = prev;
    };
    _proto5.getTweens = function getTweens() {
        var a = [];
        this.data.forEach(function(e) {
            return e instanceof Context ? a.push.apply(a, e.getTweens()) : e instanceof Tween && !(e.parent && e.parent.data === "nested") && a.push(e);
        });
        return a;
    };
    _proto5.clear = function clear() {
        this._r.length = this.data.length = 0;
    };
    _proto5.kill = function kill(revert, matchMedia) {
        var _this4 = this;
        if (revert) (function() {
            var tweens = _this4.getTweens(), i = _this4.data.length, t;
            while(i--){
                // Flip plugin tweens are very different in that they should actually be pushed to their end. The plugin replaces the timeline's .revert() method to do exactly that. But we also need to remove any of those nested tweens inside the flip timeline so that they don't get individually reverted.
                t = _this4.data[i];
                if (t.data === "isFlip") {
                    t.revert();
                    t.getChildren(true, true, false).forEach(function(tween) {
                        return tweens.splice(tweens.indexOf(tween), 1);
                    });
                }
            } // save as an object so that we can cache the globalTime for each tween to optimize performance during the sort
            tweens.map(function(t) {
                return {
                    g: t._dur || t._delay || t._sat && !t._sat.vars.immediateRender ? t.globalTime(0) : -Infinity,
                    t: t
                };
            }).sort(function(a, b) {
                return b.g - a.g || -Infinity;
            }).forEach(function(o) {
                return o.t.revert(revert);
            }); // note: all of the _startAt tweens should be reverted in reverse order that they were created, and they'll all have the same globalTime (-1) so the " || -1" in the sort keeps the order properly.
            i = _this4.data.length;
            while(i--){
                // make sure we loop backwards so that, for example, SplitTexts that were created later on the same element get reverted first
                t = _this4.data[i];
                if (t instanceof Timeline) {
                    if (t.data !== "nested") {
                        t.scrollTrigger && t.scrollTrigger.revert();
                        t.kill(); // don't revert() the timeline because that's duplicating efforts since we already reverted all the tweens
                    }
                } else !(t instanceof Tween) && t.revert && t.revert(revert);
            }
            _this4._r.forEach(function(f) {
                return f(revert, _this4);
            });
            _this4.isReverted = true;
        })();
        else this.data.forEach(function(e) {
            return e.kill && e.kill();
        });
        this.clear();
        if (matchMedia) {
            var i = _media.length;
            while(i--)// previously, we checked _media.indexOf(this), but some frameworks like Vue enforce Proxy objects that make it impossible to get the proper result that way, so we must use a unique ID number instead.
            _media[i].id === this.id && _media.splice(i, 1);
        }
    } // killWithCleanup() {
    ;
    _proto5.revert = function revert(config) {
        this.kill(config || {});
    };
    return Context;
}();
var MatchMedia = /*#__PURE__*/ function() {
    function MatchMedia(scope) {
        this.contexts = [];
        this.scope = scope;
        _context && _context.data.push(this);
    }
    var _proto6 = MatchMedia.prototype;
    _proto6.add = function add(conditions, func, scope) {
        _isObject(conditions) || (conditions = {
            matches: conditions
        });
        var context = new Context(0, scope || this.scope), cond = context.conditions = {}, mq, p, active;
        _context && !context.selector && (context.selector = _context.selector); // in case a context is created inside a context. Like a gsap.matchMedia() that's inside a scoped gsap.context()
        this.contexts.push(context);
        func = context.add("onMatch", func);
        context.queries = conditions;
        for(p in conditions)if (p === "all") active = 1;
        else {
            mq = _win.matchMedia(conditions[p]);
            if (mq) {
                _media.indexOf(context) < 0 && _media.push(context);
                (cond[p] = mq.matches) && (active = 1);
                mq.addListener ? mq.addListener(_onMediaChange) : mq.addEventListener("change", _onMediaChange);
            }
        }
        active && func(context, function(f) {
            return context.add(null, f);
        });
        return this;
    } // refresh() {
    ;
    _proto6.revert = function revert(config) {
        this.kill(config || {});
    };
    _proto6.kill = function kill(revert) {
        this.contexts.forEach(function(c) {
            return c.kill(revert, true);
        });
    };
    return MatchMedia;
}();
/*
 * --------------------------------------------------------------------------------------
 * GSAP
 * --------------------------------------------------------------------------------------
 */ var _gsap = {
    registerPlugin: function registerPlugin() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        args.forEach(function(config) {
            return _createPlugin(config);
        });
    },
    timeline: function timeline(vars) {
        return new Timeline(vars);
    },
    getTweensOf: function getTweensOf(targets, onlyActive) {
        return _globalTimeline.getTweensOf(targets, onlyActive);
    },
    getProperty: function getProperty(target, property, unit, uncache) {
        _isString(target) && (target = toArray(target)[0]); //in case selector text or an array is passed in
        var getter = _getCache(target || {}).get, format = unit ? _passThrough : _numericIfPossible;
        unit === "native" && (unit = "");
        return !target ? target : !property ? function(property, unit, uncache) {
            return format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
        } : format((_plugins[property] && _plugins[property].get || getter)(target, property, unit, uncache));
    },
    quickSetter: function quickSetter(target, property, unit) {
        target = toArray(target);
        if (target.length > 1) {
            var setters = target.map(function(t) {
                return gsap.quickSetter(t, property, unit);
            }), l = setters.length;
            return function(value) {
                var i = l;
                while(i--)setters[i](value);
            };
        }
        target = target[0] || {};
        var Plugin = _plugins[property], cache = _getCache(target), p = cache.harness && (cache.harness.aliases || {})[property] || property, // in case it's an alias, like "rotate" for "rotation".
        setter = Plugin ? function(value) {
            var p = new Plugin();
            _quickTween._pt = 0;
            p.init(target, unit ? value + unit : value, _quickTween, 0, [
                target
            ]);
            p.render(1, p);
            _quickTween._pt && _renderPropTweens(1, _quickTween);
        } : cache.set(target, p);
        return Plugin ? setter : function(value) {
            return setter(target, p, unit ? value + unit : value, cache, 1);
        };
    },
    quickTo: function quickTo(target, property, vars) {
        var _setDefaults2;
        var tween = gsap.to(target, _setDefaults((_setDefaults2 = {}, _setDefaults2[property] = "+=0.1", _setDefaults2.paused = true, _setDefaults2.stagger = 0, _setDefaults2), vars || {})), func = function func(value, start, startIsRelative) {
            return tween.resetTo(property, value, start, startIsRelative);
        };
        func.tween = tween;
        return func;
    },
    isTweening: function isTweening(targets) {
        return _globalTimeline.getTweensOf(targets, true).length > 0;
    },
    defaults: function defaults(value) {
        value && value.ease && (value.ease = _parseEase(value.ease, _defaults.ease));
        return _mergeDeep(_defaults, value || {});
    },
    config: function config(value) {
        return _mergeDeep(_config, value || {});
    },
    registerEffect: function registerEffect(_ref3) {
        var name = _ref3.name, effect = _ref3.effect, plugins = _ref3.plugins, defaults = _ref3.defaults, extendTimeline = _ref3.extendTimeline;
        (plugins || "").split(",").forEach(function(pluginName) {
            return pluginName && !_plugins[pluginName] && !_globals[pluginName] && _warn(name + " effect requires " + pluginName + " plugin.");
        });
        _effects[name] = function(targets, vars, tl) {
            return effect(toArray(targets), _setDefaults(vars || {}, defaults), tl);
        };
        if (extendTimeline) Timeline.prototype[name] = function(targets, vars, position) {
            return this.add(_effects[name](targets, _isObject(vars) ? vars : (position = vars) && {}, this), position);
        };
    },
    registerEase: function registerEase(name, ease) {
        _easeMap[name] = _parseEase(ease);
    },
    parseEase: function parseEase(ease, defaultEase) {
        return arguments.length ? _parseEase(ease, defaultEase) : _easeMap;
    },
    getById: function getById(id) {
        return _globalTimeline.getById(id);
    },
    exportRoot: function exportRoot(vars, includeDelayedCalls) {
        if (vars === void 0) vars = {};
        var tl = new Timeline(vars), child, next;
        tl.smoothChildTiming = _isNotFalse(vars.smoothChildTiming);
        _globalTimeline.remove(tl);
        tl._dp = 0; //otherwise it'll get re-activated when adding children and be re-introduced into _globalTimeline's linked list (then added to itself).
        tl._time = tl._tTime = _globalTimeline._time;
        child = _globalTimeline._first;
        while(child){
            next = child._next;
            if (includeDelayedCalls || !(!child._dur && child instanceof Tween && child.vars.onComplete === child._targets[0])) _addToTimeline(tl, child, child._start - child._delay);
            child = next;
        }
        _addToTimeline(_globalTimeline, tl, 0);
        return tl;
    },
    context: function context(func, scope) {
        return func ? new Context(func, scope) : _context;
    },
    matchMedia: function matchMedia(scope) {
        return new MatchMedia(scope);
    },
    matchMediaRefresh: function matchMediaRefresh() {
        return _media.forEach(function(c) {
            var cond = c.conditions, found, p;
            for(p in cond)if (cond[p]) {
                cond[p] = false;
                found = 1;
            }
            found && c.revert();
        }) || _onMediaChange();
    },
    addEventListener: function addEventListener(type, callback) {
        var a = _listeners[type] || (_listeners[type] = []);
        ~a.indexOf(callback) || a.push(callback);
    },
    removeEventListener: function removeEventListener(type, callback) {
        var a = _listeners[type], i = a && a.indexOf(callback);
        i >= 0 && a.splice(i, 1);
    },
    utils: {
        wrap: wrap,
        wrapYoyo: wrapYoyo,
        distribute: distribute,
        random: random,
        snap: snap,
        normalize: normalize,
        getUnit: getUnit,
        clamp: clamp,
        splitColor: splitColor,
        toArray: toArray,
        selector: selector,
        mapRange: mapRange,
        pipe: pipe,
        unitize: unitize,
        interpolate: interpolate,
        shuffle: shuffle
    },
    install: _install,
    effects: _effects,
    ticker: _ticker,
    updateRoot: Timeline.updateRoot,
    plugins: _plugins,
    globalTimeline: _globalTimeline,
    core: {
        PropTween: PropTween,
        globals: _addGlobal,
        Tween: Tween,
        Timeline: Timeline,
        Animation: Animation,
        getCache: _getCache,
        _removeLinkedListItem: _removeLinkedListItem,
        reverting: function reverting() {
            return _reverting;
        },
        context: function context(toAdd) {
            if (toAdd && _context) {
                _context.data.push(toAdd);
                toAdd._ctx = _context;
            }
            return _context;
        },
        suppressOverwrites: function suppressOverwrites(value) {
            return _suppressOverwrites = value;
        }
    }
};
_forEachName("to,from,fromTo,delayedCall,set,killTweensOf", function(name) {
    return _gsap[name] = Tween[name];
});
_ticker.add(Timeline.updateRoot);
_quickTween = _gsap.to({}, {
    duration: 0
}); // ---- EXTRA PLUGINS --------------------------------------------------------
var _getPluginPropTween = function _getPluginPropTween(plugin, prop) {
    var pt = plugin._pt;
    while(pt && pt.p !== prop && pt.op !== prop && pt.fp !== prop)pt = pt._next;
    return pt;
}, _addModifiers = function _addModifiers(tween, modifiers) {
    var targets = tween._targets, p, i, pt;
    for(p in modifiers){
        i = targets.length;
        while(i--){
            pt = tween._ptLookup[i][p];
            if (pt && (pt = pt.d)) {
                if (pt._pt) // is a plugin
                pt = _getPluginPropTween(pt, p);
                pt && pt.modifier && pt.modifier(modifiers[p], tween, targets[i], p);
            }
        }
    }
}, _buildModifierPlugin = function _buildModifierPlugin(name, modifier) {
    return {
        name: name,
        headless: 1,
        rawVars: 1,
        //don't pre-process function-based values or "random()" strings.
        init: function init(target, vars, tween) {
            tween._onInit = function(tween) {
                var temp, p;
                if (_isString(vars)) {
                    temp = {};
                    _forEachName(vars, function(name) {
                        return temp[name] = 1;
                    }); //if the user passes in a comma-delimited list of property names to roundProps, like "x,y", we round to whole numbers.
                    vars = temp;
                }
                if (modifier) {
                    temp = {};
                    for(p in vars)temp[p] = modifier(vars[p]);
                    vars = temp;
                }
                _addModifiers(tween, vars);
            };
        }
    };
}; //register core plugins
var gsap = _gsap.registerPlugin({
    name: "attr",
    init: function init(target, vars, tween, index, targets) {
        var p, pt, v;
        this.tween = tween;
        for(p in vars){
            v = target.getAttribute(p) || "";
            pt = this.add(target, "setAttribute", (v || 0) + "", vars[p], index, targets, 0, 0, p);
            pt.op = p;
            pt.b = v; // record the beginning value so we can revert()
            this._props.push(p);
        }
    },
    render: function render(ratio, data) {
        var pt = data._pt;
        while(pt){
            _reverting ? pt.set(pt.t, pt.p, pt.b, pt) : pt.r(ratio, pt.d); // if reverting, go back to the original (pt.b)
            pt = pt._next;
        }
    }
}, {
    name: "endArray",
    headless: 1,
    init: function init(target, value) {
        var i = value.length;
        while(i--)this.add(target, i, target[i] || 0, value[i], 0, 0, 0, 0, 0, 1);
    }
}, _buildModifierPlugin("roundProps", _roundModifier), _buildModifierPlugin("modifiers"), _buildModifierPlugin("snap", snap)) || _gsap; //to prevent the core plugins from being dropped via aggressive tree shaking, we must include them in the variable declaration in this way.
Tween.version = Timeline.version = gsap.version = "3.14.2";
_coreReady = 1;
_windowExists() && _wake();
var Power0 = _easeMap.Power0, Power1 = _easeMap.Power1, Power2 = _easeMap.Power2, Power3 = _easeMap.Power3, Power4 = _easeMap.Power4, Linear = _easeMap.Linear, Quad = _easeMap.Quad, Cubic = _easeMap.Cubic, Quart = _easeMap.Quart, Quint = _easeMap.Quint, Strong = _easeMap.Strong, Elastic = _easeMap.Elastic, Back = _easeMap.Back, SteppedEase = _easeMap.SteppedEase, Bounce = _easeMap.Bounce, Sine = _easeMap.Sine, Expo = _easeMap.Expo, Circ = _easeMap.Circ;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6eg9y":[function(require,module,exports,__globalThis) {
/*!
 * CSSPlugin 3.14.2
 * https://gsap.com
 *
 * Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSSPlugin", ()=>CSSPlugin);
parcelHelpers.export(exports, "default", ()=>CSSPlugin);
parcelHelpers.export(exports, "_getBBox", ()=>_getBBox);
parcelHelpers.export(exports, "_createElement", ()=>_createElement);
parcelHelpers.export(exports, "checkPrefix", ()=>_checkPropPrefix);
var _gsapCoreJs = require("./gsap-core.js");
var _win, _doc, _docElement, _pluginInitted, _tempDiv, _tempDivStyler, _recentSetterPlugin, _reverting, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _transformProps = {}, _RAD2DEG = 180 / Math.PI, _DEG2RAD = Math.PI / 180, _atan2 = Math.atan2, _bigNum = 1e8, _capsExp = /([A-Z])/g, _horizontalExp = /(left|right|width|margin|padding|x)/i, _complexExp = /[\s,\(]\S/, _propertyAliases = {
    autoAlpha: "opacity,visibility",
    scale: "scaleX,scaleY",
    alpha: "opacity"
}, _renderCSSProp = function _renderCSSProp(ratio, data) {
    return data.set(data.t, data.p, Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, _renderPropWithEnd = function _renderPropWithEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u, data);
}, _renderCSSPropWithBeginning = function _renderCSSPropWithBeginning(ratio, data) {
    return data.set(data.t, data.p, ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
_renderCSSPropWithBeginningAndEnd = function _renderCSSPropWithBeginningAndEnd(ratio, data) {
    return data.set(data.t, data.p, ratio === 1 ? data.e : ratio ? Math.round((data.s + data.c * ratio) * 10000) / 10000 + data.u : data.b, data);
}, //if units change, we need a way to render the original unit/value when the tween goes all the way back to the beginning (ratio:0)
_renderRoundedCSSProp = function _renderRoundedCSSProp(ratio, data) {
    var value = data.s + data.c * ratio;
    data.set(data.t, data.p, ~~(value + (value < 0 ? -0.5 : .5)) + data.u, data);
}, _renderNonTweeningValue = function _renderNonTweeningValue(ratio, data) {
    return data.set(data.t, data.p, ratio ? data.e : data.b, data);
}, _renderNonTweeningValueOnlyAtEnd = function _renderNonTweeningValueOnlyAtEnd(ratio, data) {
    return data.set(data.t, data.p, ratio !== 1 ? data.b : data.e, data);
}, _setterCSSStyle = function _setterCSSStyle(target, property, value) {
    return target.style[property] = value;
}, _setterCSSProp = function _setterCSSProp(target, property, value) {
    return target.style.setProperty(property, value);
}, _setterTransform = function _setterTransform(target, property, value) {
    return target._gsap[property] = value;
}, _setterScale = function _setterScale(target, property, value) {
    return target._gsap.scaleX = target._gsap.scaleY = value;
}, _setterScaleWithRender = function _setterScaleWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache.scaleX = cache.scaleY = value;
    cache.renderTransform(ratio, cache);
}, _setterTransformWithRender = function _setterTransformWithRender(target, property, value, data, ratio) {
    var cache = target._gsap;
    cache[property] = value;
    cache.renderTransform(ratio, cache);
}, _transformProp = "transform", _transformOriginProp = _transformProp + "Origin", _saveStyle = function _saveStyle(property, isNotCSS) {
    var _this = this;
    var target = this.target, style = target.style, cache = target._gsap;
    if (property in _transformProps && style) {
        this.tfm = this.tfm || {};
        if (property !== "transform") {
            property = _propertyAliases[property] || property;
            ~property.indexOf(",") ? property.split(",").forEach(function(a) {
                return _this.tfm[a] = _get(target, a);
            }) : this.tfm[property] = cache.x ? cache[property] : _get(target, property); // note: scale would map to "scaleX,scaleY", thus we loop and apply them both.
            property === _transformOriginProp && (this.tfm.zOrigin = cache.zOrigin);
        } else return _propertyAliases.transform.split(",").forEach(function(p) {
            return _saveStyle.call(_this, p, isNotCSS);
        });
        if (this.props.indexOf(_transformProp) >= 0) return;
        if (cache.svg) {
            this.svgo = target.getAttribute("data-svg-origin");
            this.props.push(_transformOriginProp, isNotCSS, "");
        }
        property = _transformProp;
    }
    (style || isNotCSS) && this.props.push(property, isNotCSS, style[property]);
}, _removeIndependentTransforms = function _removeIndependentTransforms(style) {
    if (style.translate) {
        style.removeProperty("translate");
        style.removeProperty("scale");
        style.removeProperty("rotate");
    }
}, _revertStyle = function _revertStyle() {
    var props = this.props, target = this.target, style = target.style, cache = target._gsap, i, p;
    for(i = 0; i < props.length; i += 3){
        // stored like this: property, isNotCSS, value
        if (!props[i + 1]) props[i + 2] ? style[props[i]] = props[i + 2] : style.removeProperty(props[i].substr(0, 2) === "--" ? props[i] : props[i].replace(_capsExp, "-$1").toLowerCase());
        else if (props[i + 1] === 2) // non-CSS value (function-based)
        target[props[i]](props[i + 2]);
        else // non-CSS value (not function-based)
        target[props[i]] = props[i + 2];
    }
    if (this.tfm) {
        for(p in this.tfm)cache[p] = this.tfm[p];
        if (cache.svg) {
            cache.renderTransform();
            target.setAttribute("data-svg-origin", this.svgo || "");
        }
        i = _reverting();
        if ((!i || !i.isStart) && !style[_transformProp]) {
            _removeIndependentTransforms(style);
            if (cache.zOrigin && style[_transformOriginProp]) {
                style[_transformOriginProp] += " " + cache.zOrigin + "px"; // since we're uncaching, we must put the zOrigin back into the transformOrigin so that we can pull it out accurately when we parse again. Otherwise, we'd lose the z portion of the origin since we extract it to protect from Safari bugs.
                cache.zOrigin = 0;
                cache.renderTransform();
            }
            cache.uncache = 1; // if it's a startAt that's being reverted in the _initTween() of the core, we don't need to uncache transforms. This is purely a performance optimization.
        }
    }
}, _getStyleSaver = function _getStyleSaver(target, properties) {
    var saver = {
        target: target,
        props: [],
        revert: _revertStyle,
        save: _saveStyle
    };
    target._gsap || (0, _gsapCoreJs.gsap).core.getCache(target); // just make sure there's a _gsap cache defined because we read from it in _saveStyle() and it's more efficient to just check it here once.
    properties && target.style && target.nodeType && properties.split(",").forEach(function(p) {
        return saver.save(p);
    }); // make sure it's a DOM node too.
    return saver;
}, _supports3D, _createElement = function _createElement(type, ns) {
    var e = _doc.createElementNS ? _doc.createElementNS((ns || "http://www.w3.org/1999/xhtml").replace(/^https/, "http"), type) : _doc.createElement(type); //some servers swap in https for http in the namespace which can break things, making "style" inaccessible.
    return e && e.style ? e : _doc.createElement(type); //some environments won't allow access to the element's style when created with a namespace in which case we default to the standard createElement() to work around the issue. Also note that when GSAP is embedded directly inside an SVG file, createElement() won't allow access to the style object in Firefox (see https://gsap.com/forums/topic/20215-problem-using-tweenmax-in-standalone-self-containing-svg-file-err-cannot-set-property-csstext-of-undefined/).
}, _getComputedProperty = function _getComputedProperty(target, property, skipPrefixFallback) {
    var cs = getComputedStyle(target);
    return cs[property] || cs.getPropertyValue(property.replace(_capsExp, "-$1").toLowerCase()) || cs.getPropertyValue(property) || !skipPrefixFallback && _getComputedProperty(target, _checkPropPrefix(property) || property, 1) || ""; //css variables may not need caps swapped out for dashes and lowercase.
}, _prefixes = "O,Moz,ms,Ms,Webkit".split(","), _checkPropPrefix = function _checkPropPrefix(property, element, preferPrefix) {
    var e = element || _tempDiv, s = e.style, i = 5;
    if (property in s && !preferPrefix) return property;
    property = property.charAt(0).toUpperCase() + property.substr(1);
    while(i-- && !(_prefixes[i] + property in s));
    return i < 0 ? null : (i === 3 ? "ms" : i >= 0 ? _prefixes[i] : "") + property;
}, _initCore = function _initCore() {
    if (_windowExists() && window.document) {
        _win = window;
        _doc = _win.document;
        _docElement = _doc.documentElement;
        _tempDiv = _createElement("div") || {
            style: {}
        };
        _tempDivStyler = _createElement("div");
        _transformProp = _checkPropPrefix(_transformProp);
        _transformOriginProp = _transformProp + "Origin";
        _tempDiv.style.cssText = "border-width:0;line-height:0;position:absolute;padding:0"; //make sure to override certain properties that may contaminate measurements, in case the user has overreaching style sheets.
        _supports3D = !!_checkPropPrefix("perspective");
        _reverting = (0, _gsapCoreJs.gsap).core.reverting;
        _pluginInitted = 1;
    }
}, _getReparentedCloneBBox = function _getReparentedCloneBBox(target) {
    //works around issues in some browsers (like Firefox) that don't correctly report getBBox() on SVG elements inside a <defs> element and/or <mask>. We try creating an SVG, adding it to the documentElement and toss the element in there so that it's definitely part of the rendering tree, then grab the bbox and if it works, we actually swap out the original getBBox() method for our own that does these extra steps whenever getBBox is needed. This helps ensure that performance is optimal (only do all these extra steps when absolutely necessary...most elements don't need it).
    var owner = target.ownerSVGElement, svg = _createElement("svg", owner && owner.getAttribute("xmlns") || "http://www.w3.org/2000/svg"), clone = target.cloneNode(true), bbox;
    clone.style.display = "block";
    svg.appendChild(clone);
    _docElement.appendChild(svg);
    try {
        bbox = clone.getBBox();
    } catch (e) {}
    svg.removeChild(clone);
    _docElement.removeChild(svg);
    return bbox;
}, _getAttributeFallbacks = function _getAttributeFallbacks(target, attributesArray) {
    var i = attributesArray.length;
    while(i--){
        if (target.hasAttribute(attributesArray[i])) return target.getAttribute(attributesArray[i]);
    }
}, _getBBox = function _getBBox(target) {
    var bounds, cloned;
    try {
        bounds = target.getBBox(); //Firefox throws errors if you try calling getBBox() on an SVG element that's not rendered (like in a <symbol> or <defs>). https://bugzilla.mozilla.org/show_bug.cgi?id=612118
    } catch (error) {
        bounds = _getReparentedCloneBBox(target);
        cloned = 1;
    }
    bounds && (bounds.width || bounds.height) || cloned || (bounds = _getReparentedCloneBBox(target)); //some browsers (like Firefox) misreport the bounds if the element has zero width and height (it just assumes it's at x:0, y:0), thus we need to manually grab the position in that case.
    return bounds && !bounds.width && !bounds.x && !bounds.y ? {
        x: +_getAttributeFallbacks(target, [
            "x",
            "cx",
            "x1"
        ]) || 0,
        y: +_getAttributeFallbacks(target, [
            "y",
            "cy",
            "y1"
        ]) || 0,
        width: 0,
        height: 0
    } : bounds;
}, _isSVG = function _isSVG(e) {
    return !!(e.getCTM && (!e.parentNode || e.ownerSVGElement) && _getBBox(e));
}, //reports if the element is an SVG on which getBBox() actually works
_removeProperty = function _removeProperty(target, property) {
    if (property) {
        var style = target.style, first2Chars;
        if (property in _transformProps && property !== _transformOriginProp) property = _transformProp;
        if (style.removeProperty) {
            first2Chars = property.substr(0, 2);
            if (first2Chars === "ms" || property.substr(0, 6) === "webkit") //Microsoft and some Webkit browsers don't conform to the standard of capitalizing the first prefix character, so we adjust so that when we prefix the caps with a dash, it's correct (otherwise it'd be "ms-transform" instead of "-ms-transform" for IE9, for example)
            property = "-" + property;
            style.removeProperty(first2Chars === "--" ? property : property.replace(_capsExp, "-$1").toLowerCase());
        } else //note: old versions of IE use "removeAttribute()" instead of "removeProperty()"
        style.removeAttribute(property);
    }
}, _addNonTweeningPT = function _addNonTweeningPT(plugin, target, property, beginning, end, onlySetAtEnd) {
    var pt = new (0, _gsapCoreJs.PropTween)(plugin._pt, target, property, 0, 1, onlySetAtEnd ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue);
    plugin._pt = pt;
    pt.b = beginning;
    pt.e = end;
    plugin._props.push(property);
    return pt;
}, _nonConvertibleUnits = {
    deg: 1,
    rad: 1,
    turn: 1
}, _nonStandardLayouts = {
    grid: 1,
    flex: 1
}, //takes a single value like 20px and converts it to the unit specified, like "%", returning only the numeric amount.
_convertToUnit = function _convertToUnit(target, property, value, unit) {
    var curValue = parseFloat(value) || 0, curUnit = (value + "").trim().substr((curValue + "").length) || "px", // some browsers leave extra whitespace at the beginning of CSS variables, hence the need to trim()
    style = _tempDiv.style, horizontal = _horizontalExp.test(property), isRootSVG = target.tagName.toLowerCase() === "svg", measureProperty = (isRootSVG ? "client" : "offset") + (horizontal ? "Width" : "Height"), amount = 100, toPixels = unit === "px", toPercent = unit === "%", px, parent, cache, isSVG;
    if (unit === curUnit || !curValue || _nonConvertibleUnits[unit] || _nonConvertibleUnits[curUnit]) return curValue;
    curUnit !== "px" && !toPixels && (curValue = _convertToUnit(target, property, value, "px"));
    isSVG = target.getCTM && _isSVG(target);
    if ((toPercent || curUnit === "%") && (_transformProps[property] || ~property.indexOf("adius"))) {
        px = isSVG ? target.getBBox()[horizontal ? "width" : "height"] : target[measureProperty];
        return (0, _gsapCoreJs._round)(toPercent ? curValue / px * amount : curValue / 100 * px);
    }
    style[horizontal ? "width" : "height"] = amount + (toPixels ? curUnit : unit);
    parent = unit !== "rem" && ~property.indexOf("adius") || unit === "em" && target.appendChild && !isRootSVG ? target : target.parentNode;
    if (isSVG) parent = (target.ownerSVGElement || {}).parentNode;
    if (!parent || parent === _doc || !parent.appendChild) parent = _doc.body;
    cache = parent._gsap;
    if (cache && toPercent && cache.width && horizontal && cache.time === (0, _gsapCoreJs._ticker).time && !cache.uncache) return (0, _gsapCoreJs._round)(curValue / cache.width * amount);
    else {
        if (toPercent && (property === "height" || property === "width")) {
            // if we're dealing with width/height that's inside a container with padding and/or it's a flexbox/grid container, we must apply it to the target itself rather than the _tempDiv in order to ensure complete accuracy, factoring in the parent's padding.
            var v = target.style[property];
            target.style[property] = amount + unit;
            px = target[measureProperty];
            v ? target.style[property] = v : _removeProperty(target, property);
        } else {
            (toPercent || curUnit === "%") && !_nonStandardLayouts[_getComputedProperty(parent, "display")] && (style.position = _getComputedProperty(target, "position"));
            parent === target && (style.position = "static"); // like for borderRadius, if it's a % we must have it relative to the target itself but that may not have position: relative or position: absolute in which case it'd go up the chain until it finds its offsetParent (bad). position: static protects against that.
            parent.appendChild(_tempDiv);
            px = _tempDiv[measureProperty];
            parent.removeChild(_tempDiv);
            style.position = "absolute";
        }
        if (horizontal && toPercent) {
            cache = (0, _gsapCoreJs._getCache)(parent);
            cache.time = (0, _gsapCoreJs._ticker).time;
            cache.width = parent[measureProperty];
        }
    }
    return (0, _gsapCoreJs._round)(toPixels ? px * curValue / amount : px && curValue ? amount / px * curValue : 0);
}, _get = function _get(target, property, unit, uncache) {
    var value;
    _pluginInitted || _initCore();
    if (property in _propertyAliases && property !== "transform") {
        property = _propertyAliases[property];
        if (~property.indexOf(",")) property = property.split(",")[0];
    }
    if (_transformProps[property] && property !== "transform") {
        value = _parseTransform(target, uncache);
        value = property !== "transformOrigin" ? value[property] : value.svg ? value.origin : _firstTwoOnly(_getComputedProperty(target, _transformOriginProp)) + " " + value.zOrigin + "px";
    } else {
        value = target.style[property];
        if (!value || value === "auto" || uncache || ~(value + "").indexOf("calc(")) value = _specialProps[property] && _specialProps[property](target, property, unit) || _getComputedProperty(target, property) || (0, _gsapCoreJs._getProperty)(target, property) || (property === "opacity" ? 1 : 0); // note: some browsers, like Firefox, don't report borderRadius correctly! Instead, it only reports every corner like  borderTopLeftRadius
    }
    return unit && !~(value + "").trim().indexOf(" ") ? _convertToUnit(target, property, value, unit) + unit : value;
}, _tweenComplexCSSString = function _tweenComplexCSSString(target, prop, start, end) {
    // note: we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within a plugin too, thus "this" would refer to the plugin.
    if (!start || start === "none") {
        // some browsers like Safari actually PREFER the prefixed property and mis-report the unprefixed value like clipPath (BUG). In other words, even though clipPath exists in the style ("clipPath" in target.style) and it's set in the CSS properly (along with -webkit-clip-path), Safari reports clipPath as "none" whereas WebkitClipPath reports accurately like "ellipse(100% 0% at 50% 0%)", so in this case we must SWITCH to using the prefixed property instead. See https://gsap.com/forums/topic/18310-clippath-doesnt-work-on-ios/
        var p = _checkPropPrefix(prop, target, 1), s = p && _getComputedProperty(target, p, 1);
        if (s && s !== start) {
            prop = p;
            start = s;
        } else if (prop === "borderColor") start = _getComputedProperty(target, "borderTopColor"); // Firefox bug: always reports "borderColor" as "", so we must fall back to borderTopColor. See https://gsap.com/forums/topic/24583-how-to-return-colors-that-i-had-after-reverse/
    }
    var pt = new (0, _gsapCoreJs.PropTween)(this._pt, target.style, prop, 0, 1, (0, _gsapCoreJs._renderComplexString)), index = 0, matchIndex = 0, a, result, startValues, startNum, color, startValue, endValue, endNum, chunk, endUnit, startUnit, endValues;
    pt.b = start;
    pt.e = end;
    start += ""; // ensure values are strings
    end += "";
    if (end.substring(0, 6) === "var(--") end = _getComputedProperty(target, end.substring(4, end.indexOf(")")));
    if (end === "auto") {
        startValue = target.style[prop];
        target.style[prop] = end;
        end = _getComputedProperty(target, prop) || end;
        startValue ? target.style[prop] = startValue : _removeProperty(target, prop);
    }
    a = [
        start,
        end
    ];
    (0, _gsapCoreJs._colorStringFilter)(a); // pass an array with the starting and ending values and let the filter do whatever it needs to the values. If colors are found, it returns true and then we must match where the color shows up order-wise because for things like boxShadow, sometimes the browser provides the computed values with the color FIRST, but the user provides it with the color LAST, so flip them if necessary. Same for drop-shadow().
    start = a[0];
    end = a[1];
    startValues = start.match((0, _gsapCoreJs._numWithUnitExp)) || [];
    endValues = end.match((0, _gsapCoreJs._numWithUnitExp)) || [];
    if (endValues.length) {
        while(result = (0, _gsapCoreJs._numWithUnitExp).exec(end)){
            endValue = result[0];
            chunk = end.substring(index, result.index);
            if (color) color = (color + 1) % 5;
            else if (chunk.substr(-5) === "rgba(" || chunk.substr(-5) === "hsla(") color = 1;
            if (endValue !== (startValue = startValues[matchIndex++] || "")) {
                startNum = parseFloat(startValue) || 0;
                startUnit = startValue.substr((startNum + "").length);
                endValue.charAt(1) === "=" && (endValue = (0, _gsapCoreJs._parseRelative)(startNum, endValue) + startUnit);
                endNum = parseFloat(endValue);
                endUnit = endValue.substr((endNum + "").length);
                index = (0, _gsapCoreJs._numWithUnitExp).lastIndex - endUnit.length;
                if (!endUnit) {
                    //if something like "perspective:300" is passed in and we must add a unit to the end
                    endUnit = endUnit || (0, _gsapCoreJs._config).units[prop] || startUnit;
                    if (index === end.length) {
                        end += endUnit;
                        pt.e += endUnit;
                    }
                }
                if (startUnit !== endUnit) startNum = _convertToUnit(target, prop, startValue, endUnit) || 0;
                 // these nested PropTweens are handled in a special way - we'll never actually call a render or setter method on them. We'll just loop through them in the parent complex string PropTween's render method.
                pt._pt = {
                    _next: pt._pt,
                    p: chunk || matchIndex === 1 ? chunk : ",",
                    //note: SVG spec allows omission of comma/space when a negative sign is wedged between two numbers, like 2.5-5.3 instead of 2.5,-5.3 but when tweening, the negative value may switch to positive, so we insert the comma just in case.
                    s: startNum,
                    c: endNum - startNum,
                    m: color && color < 4 || prop === "zIndex" ? Math.round : 0
                };
            }
        }
        pt.c = index < end.length ? end.substring(index, end.length) : ""; //we use the "c" of the PropTween to store the final part of the string (after the last number)
    } else pt.r = prop === "display" && end === "none" ? _renderNonTweeningValueOnlyAtEnd : _renderNonTweeningValue;
    (0, _gsapCoreJs._relExp).test(end) && (pt.e = 0); //if the end string contains relative values or dynamic random(...) values, delete the end it so that on the final render we don't actually set it to the string with += or -= characters (forces it to use the calculated value).
    this._pt = pt; //start the linked list with this new PropTween. Remember, we call _tweenComplexCSSString.call(pluginInstance...) to ensure that it's scoped properly. We may call it from within another plugin too, thus "this" would refer to the plugin.
    return pt;
}, _keywordToPercent = {
    top: "0%",
    bottom: "100%",
    left: "0%",
    right: "100%",
    center: "50%"
}, _convertKeywordsToPercentages = function _convertKeywordsToPercentages(value) {
    var split = value.split(" "), x = split[0], y = split[1] || "50%";
    if (x === "top" || x === "bottom" || y === "left" || y === "right") {
        //the user provided them in the wrong order, so flip them
        value = x;
        x = y;
        y = value;
    }
    split[0] = _keywordToPercent[x] || x;
    split[1] = _keywordToPercent[y] || y;
    return split.join(" ");
}, _renderClearProps = function _renderClearProps(ratio, data) {
    if (data.tween && data.tween._time === data.tween._dur) {
        var target = data.t, style = target.style, props = data.u, cache = target._gsap, prop, clearTransforms, i;
        if (props === "all" || props === true) {
            style.cssText = "";
            clearTransforms = 1;
        } else {
            props = props.split(",");
            i = props.length;
            while(--i > -1){
                prop = props[i];
                if (_transformProps[prop]) {
                    clearTransforms = 1;
                    prop = prop === "transformOrigin" ? _transformOriginProp : _transformProp;
                }
                _removeProperty(target, prop);
            }
        }
        if (clearTransforms) {
            _removeProperty(target, _transformProp);
            if (cache) {
                cache.svg && target.removeAttribute("transform");
                style.scale = style.rotate = style.translate = "none";
                _parseTransform(target, 1); // force all the cached values back to "normal"/identity, otherwise if there's another tween that's already set to render transforms on this element, it could display the wrong values.
                cache.uncache = 1;
                _removeIndependentTransforms(style);
            }
        }
    }
}, // note: specialProps should return 1 if (and only if) they have a non-zero priority. It indicates we need to sort the linked list.
_specialProps = {
    clearProps: function clearProps(plugin, target, property, endValue, tween) {
        if (tween.data !== "isFromStart") {
            var pt = plugin._pt = new (0, _gsapCoreJs.PropTween)(plugin._pt, target, property, 0, 0, _renderClearProps);
            pt.u = endValue;
            pt.pr = -10;
            pt.tween = tween;
            plugin._props.push(property);
            return 1;
        }
    }
}, /*
 * --------------------------------------------------------------------------------------
 * TRANSFORMS
 * --------------------------------------------------------------------------------------
 */ _identity2DMatrix = [
    1,
    0,
    0,
    1,
    0,
    0
], _rotationalProperties = {}, _isNullTransform = function _isNullTransform(value) {
    return value === "matrix(1, 0, 0, 1, 0, 0)" || value === "none" || !value;
}, _getComputedTransformMatrixAsArray = function _getComputedTransformMatrixAsArray(target) {
    var matrixString = _getComputedProperty(target, _transformProp);
    return _isNullTransform(matrixString) ? _identity2DMatrix : matrixString.substr(7).match((0, _gsapCoreJs._numExp)).map((0, _gsapCoreJs._round));
}, _getMatrix = function _getMatrix(target, force2D) {
    var cache = target._gsap || (0, _gsapCoreJs._getCache)(target), style = target.style, matrix = _getComputedTransformMatrixAsArray(target), parent, nextSibling, temp, addedToDOM;
    if (cache.svg && target.getAttribute("transform")) {
        temp = target.transform.baseVal.consolidate().matrix; //ensures that even complex values like "translate(50,60) rotate(135,0,0)" are parsed because it mashes it into a matrix.
        matrix = [
            temp.a,
            temp.b,
            temp.c,
            temp.d,
            temp.e,
            temp.f
        ];
        return matrix.join(",") === "1,0,0,1,0,0" ? _identity2DMatrix : matrix;
    } else if (matrix === _identity2DMatrix && !target.offsetParent && target !== _docElement && !cache.svg) {
        //note: if offsetParent is null, that means the element isn't in the normal document flow, like if it has display:none or one of its ancestors has display:none). Firefox returns null for getComputedStyle() if the element is in an iframe that has display:none. https://bugzilla.mozilla.org/show_bug.cgi?id=548397
        //browsers don't report transforms accurately unless the element is in the DOM and has a display value that's not "none". Firefox and Microsoft browsers have a partial bug where they'll report transforms even if display:none BUT not any percentage-based values like translate(-50%, 8px) will be reported as if it's translate(0, 8px).
        temp = style.display;
        style.display = "block";
        parent = target.parentNode;
        if (!parent || !target.offsetParent && !target.getBoundingClientRect().width) {
            // note: in 3.3.0 we switched target.offsetParent to _doc.body.contains(target) to avoid [sometimes unnecessary] MutationObserver calls but that wasn't adequate because there are edge cases where nested position: fixed elements need to get reparented to accurately sense transforms. See https://github.com/greensock/GSAP/issues/388 and https://github.com/greensock/GSAP/issues/375. Note: position: fixed elements report a null offsetParent but they could also be invisible because they're in an ancestor with display: none, so we check getBoundingClientRect(). We only want to alter the DOM if we absolutely have to because it can cause iframe content to reload, like a Vimeo video.
            addedToDOM = 1; //flag
            nextSibling = target.nextElementSibling;
            _docElement.appendChild(target); //we must add it to the DOM in order to get values properly
        }
        matrix = _getComputedTransformMatrixAsArray(target);
        temp ? style.display = temp : _removeProperty(target, "display");
        if (addedToDOM) nextSibling ? parent.insertBefore(target, nextSibling) : parent ? parent.appendChild(target) : _docElement.removeChild(target);
    }
    return force2D && matrix.length > 6 ? [
        matrix[0],
        matrix[1],
        matrix[4],
        matrix[5],
        matrix[12],
        matrix[13]
    ] : matrix;
}, _applySVGOrigin = function _applySVGOrigin(target, origin, originIsAbsolute, smooth, matrixArray, pluginToAddPropTweensTo) {
    var cache = target._gsap, matrix = matrixArray || _getMatrix(target, true), xOriginOld = cache.xOrigin || 0, yOriginOld = cache.yOrigin || 0, xOffsetOld = cache.xOffset || 0, yOffsetOld = cache.yOffset || 0, a = matrix[0], b = matrix[1], c = matrix[2], d = matrix[3], tx = matrix[4], ty = matrix[5], originSplit = origin.split(" "), xOrigin = parseFloat(originSplit[0]) || 0, yOrigin = parseFloat(originSplit[1]) || 0, bounds, determinant, x, y;
    if (!originIsAbsolute) {
        bounds = _getBBox(target);
        xOrigin = bounds.x + (~originSplit[0].indexOf("%") ? xOrigin / 100 * bounds.width : xOrigin);
        yOrigin = bounds.y + (~(originSplit[1] || originSplit[0]).indexOf("%") ? yOrigin / 100 * bounds.height : yOrigin); // if (!("xOrigin" in cache) && (xOrigin || yOrigin)) { // added in 3.12.3, reverted in 3.12.4; requires more exploration
    // 	xOrigin -= bounds.x;
    // 	yOrigin -= bounds.y;
    // }
    } else if (matrix !== _identity2DMatrix && (determinant = a * d - b * c)) {
        //if it's zero (like if scaleX and scaleY are zero), skip it to avoid errors with dividing by zero.
        x = xOrigin * (d / determinant) + yOrigin * (-c / determinant) + (c * ty - d * tx) / determinant;
        y = xOrigin * (-b / determinant) + yOrigin * (a / determinant) - (a * ty - b * tx) / determinant;
        xOrigin = x;
        yOrigin = y; // theory: we only had to do this for smoothing and it assumes that the previous one was not originIsAbsolute.
    }
    if (smooth || smooth !== false && cache.smooth) {
        tx = xOrigin - xOriginOld;
        ty = yOrigin - yOriginOld;
        cache.xOffset = xOffsetOld + (tx * a + ty * c) - tx;
        cache.yOffset = yOffsetOld + (tx * b + ty * d) - ty;
    } else cache.xOffset = cache.yOffset = 0;
    cache.xOrigin = xOrigin;
    cache.yOrigin = yOrigin;
    cache.smooth = !!smooth;
    cache.origin = origin;
    cache.originIsAbsolute = !!originIsAbsolute;
    target.style[_transformOriginProp] = "0px 0px"; //otherwise, if someone sets  an origin via CSS, it will likely interfere with the SVG transform attribute ones (because remember, we're baking the origin into the matrix() value).
    if (pluginToAddPropTweensTo) {
        _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOrigin", xOriginOld, xOrigin);
        _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOrigin", yOriginOld, yOrigin);
        _addNonTweeningPT(pluginToAddPropTweensTo, cache, "xOffset", xOffsetOld, cache.xOffset);
        _addNonTweeningPT(pluginToAddPropTweensTo, cache, "yOffset", yOffsetOld, cache.yOffset);
    }
    target.setAttribute("data-svg-origin", xOrigin + " " + yOrigin);
}, _parseTransform = function _parseTransform(target, uncache) {
    var cache = target._gsap || new (0, _gsapCoreJs.GSCache)(target);
    if ("x" in cache && !uncache && !cache.uncache) return cache;
    var style = target.style, invertedScaleX = cache.scaleX < 0, px = "px", deg = "deg", cs = getComputedStyle(target), origin = _getComputedProperty(target, _transformOriginProp) || "0", x, y, z, scaleX, scaleY, rotation, rotationX, rotationY, skewX, skewY, perspective, xOrigin, yOrigin, matrix, angle, cos, sin, a, b, c, d, a12, a22, t1, t2, t3, a13, a23, a33, a42, a43, a32;
    x = y = z = rotation = rotationX = rotationY = skewX = skewY = perspective = 0;
    scaleX = scaleY = 1;
    cache.svg = !!(target.getCTM && _isSVG(target));
    if (cs.translate) {
        // accommodate independent transforms by combining them into normal ones.
        if (cs.translate !== "none" || cs.scale !== "none" || cs.rotate !== "none") style[_transformProp] = (cs.translate !== "none" ? "translate3d(" + (cs.translate + " 0 0").split(" ").slice(0, 3).join(", ") + ") " : "") + (cs.rotate !== "none" ? "rotate(" + cs.rotate + ") " : "") + (cs.scale !== "none" ? "scale(" + cs.scale.split(" ").join(",") + ") " : "") + (cs[_transformProp] !== "none" ? cs[_transformProp] : "");
        style.scale = style.rotate = style.translate = "none";
    }
    matrix = _getMatrix(target, cache.svg);
    if (cache.svg) {
        if (cache.uncache) {
            // if cache.uncache is true (and maybe if origin is 0,0), we need to set element.style.transformOrigin = (cache.xOrigin - bbox.x) + "px " + (cache.yOrigin - bbox.y) + "px". Previously we let the data-svg-origin stay instead, but when introducing revert(), it complicated things.
            t2 = target.getBBox();
            origin = cache.xOrigin - t2.x + "px " + (cache.yOrigin - t2.y) + "px";
            t1 = "";
        } else t1 = !uncache && target.getAttribute("data-svg-origin"); //  Remember, to work around browser inconsistencies we always force SVG elements' transformOrigin to 0,0 and offset the translation accordingly.
        _applySVGOrigin(target, t1 || origin, !!t1 || cache.originIsAbsolute, cache.smooth !== false, matrix);
    }
    xOrigin = cache.xOrigin || 0;
    yOrigin = cache.yOrigin || 0;
    if (matrix !== _identity2DMatrix) {
        a = matrix[0]; //a11
        b = matrix[1]; //a21
        c = matrix[2]; //a31
        d = matrix[3]; //a41
        x = a12 = matrix[4];
        y = a22 = matrix[5]; //2D matrix
        if (matrix.length === 6) {
            scaleX = Math.sqrt(a * a + b * b);
            scaleY = Math.sqrt(d * d + c * c);
            rotation = a || b ? _atan2(b, a) * _RAD2DEG : 0; //note: if scaleX is 0, we cannot accurately measure rotation. Same for skewX with a scaleY of 0. Therefore, we default to the previously recorded value (or zero if that doesn't exist).
            skewX = c || d ? _atan2(c, d) * _RAD2DEG + rotation : 0;
            skewX && (scaleY *= Math.abs(Math.cos(skewX * _DEG2RAD)));
            if (cache.svg) {
                x -= xOrigin - (xOrigin * a + yOrigin * c);
                y -= yOrigin - (xOrigin * b + yOrigin * d);
            } //3D matrix
        } else {
            a32 = matrix[6];
            a42 = matrix[7];
            a13 = matrix[8];
            a23 = matrix[9];
            a33 = matrix[10];
            a43 = matrix[11];
            x = matrix[12];
            y = matrix[13];
            z = matrix[14];
            angle = _atan2(a32, a33);
            rotationX = angle * _RAD2DEG; //rotationX
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a12 * cos + a13 * sin;
                t2 = a22 * cos + a23 * sin;
                t3 = a32 * cos + a33 * sin;
                a13 = a12 * -sin + a13 * cos;
                a23 = a22 * -sin + a23 * cos;
                a33 = a32 * -sin + a33 * cos;
                a43 = a42 * -sin + a43 * cos;
                a12 = t1;
                a22 = t2;
                a32 = t3;
            } //rotationY
            angle = _atan2(-c, a33);
            rotationY = angle * _RAD2DEG;
            if (angle) {
                cos = Math.cos(-angle);
                sin = Math.sin(-angle);
                t1 = a * cos - a13 * sin;
                t2 = b * cos - a23 * sin;
                t3 = c * cos - a33 * sin;
                a43 = d * sin + a43 * cos;
                a = t1;
                b = t2;
                c = t3;
            } //rotationZ
            angle = _atan2(b, a);
            rotation = angle * _RAD2DEG;
            if (angle) {
                cos = Math.cos(angle);
                sin = Math.sin(angle);
                t1 = a * cos + b * sin;
                t2 = a12 * cos + a22 * sin;
                b = b * cos - a * sin;
                a22 = a22 * cos - a12 * sin;
                a = t1;
                a12 = t2;
            }
            if (rotationX && Math.abs(rotationX) + Math.abs(rotation) > 359.9) {
                //when rotationY is set, it will often be parsed as 180 degrees different than it should be, and rotationX and rotation both being 180 (it looks the same), so we adjust for that here.
                rotationX = rotation = 0;
                rotationY = 180 - rotationY;
            }
            scaleX = (0, _gsapCoreJs._round)(Math.sqrt(a * a + b * b + c * c));
            scaleY = (0, _gsapCoreJs._round)(Math.sqrt(a22 * a22 + a32 * a32));
            angle = _atan2(a12, a22);
            skewX = Math.abs(angle) > 0.0002 ? angle * _RAD2DEG : 0;
            perspective = a43 ? 1 / (a43 < 0 ? -a43 : a43) : 0;
        }
        if (cache.svg) {
            //sense if there are CSS transforms applied on an SVG element in which case we must overwrite them when rendering. The transform attribute is more reliable cross-browser, but we can't just remove the CSS ones because they may be applied in a CSS rule somewhere (not just inline).
            t1 = target.getAttribute("transform");
            cache.forceCSS = target.setAttribute("transform", "") || !_isNullTransform(_getComputedProperty(target, _transformProp));
            t1 && target.setAttribute("transform", t1);
        }
    }
    if (Math.abs(skewX) > 90 && Math.abs(skewX) < 270) {
        if (invertedScaleX) {
            scaleX *= -1;
            skewX += rotation <= 0 ? 180 : -180;
            rotation += rotation <= 0 ? 180 : -180;
        } else {
            scaleY *= -1;
            skewX += skewX <= 0 ? 180 : -180;
        }
    }
    uncache = uncache || cache.uncache;
    cache.x = x - ((cache.xPercent = x && (!uncache && cache.xPercent || (Math.round(target.offsetWidth / 2) === Math.round(-x) ? -50 : 0))) ? target.offsetWidth * cache.xPercent / 100 : 0) + px;
    cache.y = y - ((cache.yPercent = y && (!uncache && cache.yPercent || (Math.round(target.offsetHeight / 2) === Math.round(-y) ? -50 : 0))) ? target.offsetHeight * cache.yPercent / 100 : 0) + px;
    cache.z = z + px;
    cache.scaleX = (0, _gsapCoreJs._round)(scaleX);
    cache.scaleY = (0, _gsapCoreJs._round)(scaleY);
    cache.rotation = (0, _gsapCoreJs._round)(rotation) + deg;
    cache.rotationX = (0, _gsapCoreJs._round)(rotationX) + deg;
    cache.rotationY = (0, _gsapCoreJs._round)(rotationY) + deg;
    cache.skewX = skewX + deg;
    cache.skewY = skewY + deg;
    cache.transformPerspective = perspective + px;
    if (cache.zOrigin = parseFloat(origin.split(" ")[2]) || !uncache && cache.zOrigin || 0) style[_transformOriginProp] = _firstTwoOnly(origin);
    cache.xOffset = cache.yOffset = 0;
    cache.force3D = (0, _gsapCoreJs._config).force3D;
    cache.renderTransform = cache.svg ? _renderSVGTransforms : _supports3D ? _renderCSSTransforms : _renderNon3DTransforms;
    cache.uncache = 0;
    return cache;
}, _firstTwoOnly = function _firstTwoOnly(value) {
    return (value = value.split(" "))[0] + " " + value[1];
}, //for handling transformOrigin values, stripping out the 3rd dimension
_addPxTranslate = function _addPxTranslate(target, start, value) {
    var unit = (0, _gsapCoreJs.getUnit)(start);
    return (0, _gsapCoreJs._round)(parseFloat(start) + parseFloat(_convertToUnit(target, "x", value + "px", unit))) + unit;
}, _renderNon3DTransforms = function _renderNon3DTransforms(ratio, cache) {
    cache.z = "0px";
    cache.rotationY = cache.rotationX = "0deg";
    cache.force3D = 0;
    _renderCSSTransforms(ratio, cache);
}, _zeroDeg = "0deg", _zeroPx = "0px", _endParenthesis = ") ", _renderCSSTransforms = function _renderCSSTransforms(ratio, cache) {
    var _ref = cache || this, xPercent = _ref.xPercent, yPercent = _ref.yPercent, x = _ref.x, y = _ref.y, z = _ref.z, rotation = _ref.rotation, rotationY = _ref.rotationY, rotationX = _ref.rotationX, skewX = _ref.skewX, skewY = _ref.skewY, scaleX = _ref.scaleX, scaleY = _ref.scaleY, transformPerspective = _ref.transformPerspective, force3D = _ref.force3D, target = _ref.target, zOrigin = _ref.zOrigin, transforms = "", use3D = force3D === "auto" && ratio && ratio !== 1 || force3D === true; // Safari has a bug that causes it not to render 3D transform-origin values properly, so we force the z origin to 0, record it in the cache, and then do the math here to offset the translate values accordingly (basically do the 3D transform-origin part manually)
    if (zOrigin && (rotationX !== _zeroDeg || rotationY !== _zeroDeg)) {
        var angle = parseFloat(rotationY) * _DEG2RAD, a13 = Math.sin(angle), a33 = Math.cos(angle), cos;
        angle = parseFloat(rotationX) * _DEG2RAD;
        cos = Math.cos(angle);
        x = _addPxTranslate(target, x, a13 * cos * -zOrigin);
        y = _addPxTranslate(target, y, -Math.sin(angle) * -zOrigin);
        z = _addPxTranslate(target, z, a33 * cos * -zOrigin + zOrigin);
    }
    if (transformPerspective !== _zeroPx) transforms += "perspective(" + transformPerspective + _endParenthesis;
    if (xPercent || yPercent) transforms += "translate(" + xPercent + "%, " + yPercent + "%) ";
    if (use3D || x !== _zeroPx || y !== _zeroPx || z !== _zeroPx) transforms += z !== _zeroPx || use3D ? "translate3d(" + x + ", " + y + ", " + z + ") " : "translate(" + x + ", " + y + _endParenthesis;
    if (rotation !== _zeroDeg) transforms += "rotate(" + rotation + _endParenthesis;
    if (rotationY !== _zeroDeg) transforms += "rotateY(" + rotationY + _endParenthesis;
    if (rotationX !== _zeroDeg) transforms += "rotateX(" + rotationX + _endParenthesis;
    if (skewX !== _zeroDeg || skewY !== _zeroDeg) transforms += "skew(" + skewX + ", " + skewY + _endParenthesis;
    if (scaleX !== 1 || scaleY !== 1) transforms += "scale(" + scaleX + ", " + scaleY + _endParenthesis;
    target.style[_transformProp] = transforms || "translate(0, 0)";
}, _renderSVGTransforms = function _renderSVGTransforms(ratio, cache) {
    var _ref2 = cache || this, xPercent = _ref2.xPercent, yPercent = _ref2.yPercent, x = _ref2.x, y = _ref2.y, rotation = _ref2.rotation, skewX = _ref2.skewX, skewY = _ref2.skewY, scaleX = _ref2.scaleX, scaleY = _ref2.scaleY, target = _ref2.target, xOrigin = _ref2.xOrigin, yOrigin = _ref2.yOrigin, xOffset = _ref2.xOffset, yOffset = _ref2.yOffset, forceCSS = _ref2.forceCSS, tx = parseFloat(x), ty = parseFloat(y), a11, a21, a12, a22, temp;
    rotation = parseFloat(rotation);
    skewX = parseFloat(skewX);
    skewY = parseFloat(skewY);
    if (skewY) {
        //for performance reasons, we combine all skewing into the skewX and rotation values. Remember, a skewY of 10 degrees looks the same as a rotation of 10 degrees plus a skewX of 10 degrees.
        skewY = parseFloat(skewY);
        skewX += skewY;
        rotation += skewY;
    }
    if (rotation || skewX) {
        rotation *= _DEG2RAD;
        skewX *= _DEG2RAD;
        a11 = Math.cos(rotation) * scaleX;
        a21 = Math.sin(rotation) * scaleX;
        a12 = Math.sin(rotation - skewX) * -scaleY;
        a22 = Math.cos(rotation - skewX) * scaleY;
        if (skewX) {
            skewY *= _DEG2RAD;
            temp = Math.tan(skewX - skewY);
            temp = Math.sqrt(1 + temp * temp);
            a12 *= temp;
            a22 *= temp;
            if (skewY) {
                temp = Math.tan(skewY);
                temp = Math.sqrt(1 + temp * temp);
                a11 *= temp;
                a21 *= temp;
            }
        }
        a11 = (0, _gsapCoreJs._round)(a11);
        a21 = (0, _gsapCoreJs._round)(a21);
        a12 = (0, _gsapCoreJs._round)(a12);
        a22 = (0, _gsapCoreJs._round)(a22);
    } else {
        a11 = scaleX;
        a22 = scaleY;
        a21 = a12 = 0;
    }
    if (tx && !~(x + "").indexOf("px") || ty && !~(y + "").indexOf("px")) {
        tx = _convertToUnit(target, "x", x, "px");
        ty = _convertToUnit(target, "y", y, "px");
    }
    if (xOrigin || yOrigin || xOffset || yOffset) {
        tx = (0, _gsapCoreJs._round)(tx + xOrigin - (xOrigin * a11 + yOrigin * a12) + xOffset);
        ty = (0, _gsapCoreJs._round)(ty + yOrigin - (xOrigin * a21 + yOrigin * a22) + yOffset);
    }
    if (xPercent || yPercent) {
        //The SVG spec doesn't support percentage-based translation in the "transform" attribute, so we merge it into the translation to simulate it.
        temp = target.getBBox();
        tx = (0, _gsapCoreJs._round)(tx + xPercent / 100 * temp.width);
        ty = (0, _gsapCoreJs._round)(ty + yPercent / 100 * temp.height);
    }
    temp = "matrix(" + a11 + "," + a21 + "," + a12 + "," + a22 + "," + tx + "," + ty + ")";
    target.setAttribute("transform", temp);
    forceCSS && (target.style[_transformProp] = temp); //some browsers prioritize CSS transforms over the transform attribute. When we sense that the user has CSS transforms applied, we must overwrite them this way (otherwise some browser simply won't render the transform attribute changes!)
}, _addRotationalPropTween = function _addRotationalPropTween(plugin, target, property, startNum, endValue) {
    var cap = 360, isString = (0, _gsapCoreJs._isString)(endValue), endNum = parseFloat(endValue) * (isString && ~endValue.indexOf("rad") ? _RAD2DEG : 1), change = endNum - startNum, finalValue = startNum + change + "deg", direction, pt;
    if (isString) {
        direction = endValue.split("_")[1];
        if (direction === "short") {
            change %= cap;
            if (change !== change % (cap / 2)) change += change < 0 ? cap : -cap;
        }
        if (direction === "cw" && change < 0) change = (change + cap * _bigNum) % cap - ~~(change / cap) * cap;
        else if (direction === "ccw" && change > 0) change = (change - cap * _bigNum) % cap - ~~(change / cap) * cap;
    }
    plugin._pt = pt = new (0, _gsapCoreJs.PropTween)(plugin._pt, target, property, startNum, change, _renderPropWithEnd);
    pt.e = finalValue;
    pt.u = "deg";
    plugin._props.push(property);
    return pt;
}, _assign = function _assign(target, source) {
    // Internet Explorer doesn't have Object.assign(), so we recreate it here.
    for(var p in source)target[p] = source[p];
    return target;
}, _addRawTransformPTs = function _addRawTransformPTs(plugin, transforms, target) {
    //for handling cases where someone passes in a whole transform string, like transform: "scale(2, 3) rotate(20deg) translateY(30em)"
    var startCache = _assign({}, target._gsap), exclude = "perspective,force3D,transformOrigin,svgOrigin", style = target.style, endCache, p, startValue, endValue, startNum, endNum, startUnit, endUnit;
    if (startCache.svg) {
        startValue = target.getAttribute("transform");
        target.setAttribute("transform", "");
        style[_transformProp] = transforms;
        endCache = _parseTransform(target, 1);
        _removeProperty(target, _transformProp);
        target.setAttribute("transform", startValue);
    } else {
        startValue = getComputedStyle(target)[_transformProp];
        style[_transformProp] = transforms;
        endCache = _parseTransform(target, 1);
        style[_transformProp] = startValue;
    }
    for(p in _transformProps){
        startValue = startCache[p];
        endValue = endCache[p];
        if (startValue !== endValue && exclude.indexOf(p) < 0) {
            //tweening to no perspective gives very unintuitive results - just keep the same perspective in that case.
            startUnit = (0, _gsapCoreJs.getUnit)(startValue);
            endUnit = (0, _gsapCoreJs.getUnit)(endValue);
            startNum = startUnit !== endUnit ? _convertToUnit(target, p, startValue, endUnit) : parseFloat(startValue);
            endNum = parseFloat(endValue);
            plugin._pt = new (0, _gsapCoreJs.PropTween)(plugin._pt, endCache, p, startNum, endNum - startNum, _renderCSSProp);
            plugin._pt.u = endUnit || 0;
            plugin._props.push(p);
        }
    }
    _assign(endCache, startCache);
}; // handle splitting apart padding, margin, borderWidth, and borderRadius into their 4 components. Firefox, for example, won't report borderRadius correctly - it will only do borderTopLeftRadius and the other corners. We also want to handle paddingTop, marginLeft, borderRightWidth, etc.
(0, _gsapCoreJs._forEachName)("padding,margin,Width,Radius", function(name, index) {
    var t = "Top", r = "Right", b = "Bottom", l = "Left", props = (index < 3 ? [
        t,
        r,
        b,
        l
    ] : [
        t + l,
        t + r,
        b + r,
        b + l
    ]).map(function(side) {
        return index < 2 ? name + side : "border" + side + name;
    });
    _specialProps[index > 1 ? "border" + name : name] = function(plugin, target, property, endValue, tween) {
        var a, vars;
        if (arguments.length < 4) {
            // getter, passed target, property, and unit (from _get())
            a = props.map(function(prop) {
                return _get(plugin, prop, property);
            });
            vars = a.join(" ");
            return vars.split(a[0]).length === 5 ? a[0] : vars;
        }
        a = (endValue + "").split(" ");
        vars = {};
        props.forEach(function(prop, i) {
            return vars[prop] = a[i] = a[i] || a[(i - 1) / 2 | 0];
        });
        plugin.init(target, vars, tween);
    };
});
var CSSPlugin = {
    name: "css",
    register: _initCore,
    targetTest: function targetTest(target) {
        return target.style && target.nodeType;
    },
    init: function init(target, vars, tween, index, targets) {
        var props = this._props, style = target.style, startAt = tween.vars.startAt, startValue, endValue, endNum, startNum, type, specialProp, p, startUnit, endUnit, relative, isTransformRelated, transformPropTween, cache, smooth, hasPriority, inlineProps, finalTransformValue;
        _pluginInitted || _initCore(); // we may call init() multiple times on the same plugin instance, like when adding special properties, so make sure we don't overwrite the revert data or inlineProps
        this.styles = this.styles || _getStyleSaver(target);
        inlineProps = this.styles.props;
        this.tween = tween;
        for(p in vars){
            if (p === "autoRound") continue;
            endValue = vars[p];
            if ((0, _gsapCoreJs._plugins)[p] && (0, _gsapCoreJs._checkPlugin)(p, vars, tween, index, target, targets)) continue;
            type = typeof endValue;
            specialProp = _specialProps[p];
            if (type === "function") {
                endValue = endValue.call(tween, index, target, targets);
                type = typeof endValue;
            }
            if (type === "string" && ~endValue.indexOf("random(")) endValue = (0, _gsapCoreJs._replaceRandom)(endValue);
            if (specialProp) specialProp(this, target, p, endValue, tween) && (hasPriority = 1);
            else if (p.substr(0, 2) === "--") {
                //CSS variable
                startValue = (getComputedStyle(target).getPropertyValue(p) + "").trim();
                endValue += "";
                (0, _gsapCoreJs._colorExp).lastIndex = 0;
                if (!(0, _gsapCoreJs._colorExp).test(startValue)) {
                    // colors don't have units
                    startUnit = (0, _gsapCoreJs.getUnit)(startValue);
                    endUnit = (0, _gsapCoreJs.getUnit)(endValue);
                    endUnit ? startUnit !== endUnit && (startValue = _convertToUnit(target, p, startValue, endUnit) + endUnit) : startUnit && (endValue += startUnit);
                }
                this.add(style, "setProperty", startValue, endValue, index, targets, 0, 0, p);
                props.push(p);
                inlineProps.push(p, 0, style[p]);
            } else if (type !== "undefined") {
                if (startAt && p in startAt) {
                    // in case someone hard-codes a complex value as the start, like top: "calc(2vh / 2)". Without this, it'd use the computed value (always in px)
                    startValue = typeof startAt[p] === "function" ? startAt[p].call(tween, index, target, targets) : startAt[p];
                    (0, _gsapCoreJs._isString)(startValue) && ~startValue.indexOf("random(") && (startValue = (0, _gsapCoreJs._replaceRandom)(startValue));
                    (0, _gsapCoreJs.getUnit)(startValue + "") || startValue === "auto" || (startValue += (0, _gsapCoreJs._config).units[p] || (0, _gsapCoreJs.getUnit)(_get(target, p)) || ""); // for cases when someone passes in a unitless value like {x: 100}; if we try setting translate(100, 0px) it won't work.
                    (startValue + "").charAt(1) === "=" && (startValue = _get(target, p)); // can't work with relative values
                } else startValue = _get(target, p);
                startNum = parseFloat(startValue);
                relative = type === "string" && endValue.charAt(1) === "=" && endValue.substr(0, 2);
                relative && (endValue = endValue.substr(2));
                endNum = parseFloat(endValue);
                if (p in _propertyAliases) {
                    if (p === "autoAlpha") {
                        //special case where we control the visibility along with opacity. We still allow the opacity value to pass through and get tweened.
                        if (startNum === 1 && _get(target, "visibility") === "hidden" && endNum) //if visibility is initially set to "hidden", we should interpret that as intent to make opacity 0 (a convenience)
                        startNum = 0;
                        inlineProps.push("visibility", 0, style.visibility);
                        _addNonTweeningPT(this, style, "visibility", startNum ? "inherit" : "hidden", endNum ? "inherit" : "hidden", !endNum);
                    }
                    if (p !== "scale" && p !== "transform") {
                        p = _propertyAliases[p];
                        ~p.indexOf(",") && (p = p.split(",")[0]);
                    }
                }
                isTransformRelated = p in _transformProps; //--- TRANSFORM-RELATED ---
                if (isTransformRelated) {
                    this.styles.save(p);
                    finalTransformValue = endValue; // this is always the same as endValue except when it's a var(--) value, in which case we need to calculate the end value.
                    if (type === "string" && endValue.substring(0, 6) === "var(--") {
                        endValue = _getComputedProperty(target, endValue.substring(4, endValue.indexOf(")")));
                        if (endValue.substring(0, 5) === "calc(") {
                            var origPerspective = target.style.perspective;
                            target.style.perspective = endValue;
                            endValue = _getComputedProperty(target, "perspective");
                            origPerspective ? target.style.perspective = origPerspective : _removeProperty(target, "perspective");
                        }
                        endNum = parseFloat(endValue);
                    }
                    if (!transformPropTween) {
                        cache = target._gsap;
                        cache.renderTransform && !vars.parseTransform || _parseTransform(target, vars.parseTransform); // if, for example, gsap.set(... {transform:"translateX(50vw)"}), the _get() call doesn't parse the transform, thus cache.renderTransform won't be set yet so force the parsing of the transform here.
                        smooth = vars.smoothOrigin !== false && cache.smooth;
                        transformPropTween = this._pt = new (0, _gsapCoreJs.PropTween)(this._pt, style, _transformProp, 0, 1, cache.renderTransform, cache, 0, -1); //the first time through, create the rendering PropTween so that it runs LAST (in the linked list, we keep adding to the beginning)
                        transformPropTween.dep = 1; //flag it as dependent so that if things get killed/overwritten and this is the only PropTween left, we can safely kill the whole tween.
                    }
                    if (p === "scale") {
                        this._pt = new (0, _gsapCoreJs.PropTween)(this._pt, cache, "scaleY", cache.scaleY, (relative ? (0, _gsapCoreJs._parseRelative)(cache.scaleY, relative + endNum) : endNum) - cache.scaleY || 0, _renderCSSProp);
                        this._pt.u = 0;
                        props.push("scaleY", p);
                        p += "X";
                    } else if (p === "transformOrigin") {
                        inlineProps.push(_transformOriginProp, 0, style[_transformOriginProp]);
                        endValue = _convertKeywordsToPercentages(endValue); //in case something like "left top" or "bottom right" is passed in. Convert to percentages.
                        if (cache.svg) _applySVGOrigin(target, endValue, 0, smooth, 0, this);
                        else {
                            endUnit = parseFloat(endValue.split(" ")[2]) || 0; //handle the zOrigin separately!
                            endUnit !== cache.zOrigin && _addNonTweeningPT(this, cache, "zOrigin", cache.zOrigin, endUnit);
                            _addNonTweeningPT(this, style, p, _firstTwoOnly(startValue), _firstTwoOnly(endValue));
                        }
                        continue;
                    } else if (p === "svgOrigin") {
                        _applySVGOrigin(target, endValue, 1, smooth, 0, this);
                        continue;
                    } else if (p in _rotationalProperties) {
                        _addRotationalPropTween(this, cache, p, startNum, relative ? (0, _gsapCoreJs._parseRelative)(startNum, relative + endValue) : endValue);
                        continue;
                    } else if (p === "smoothOrigin") {
                        _addNonTweeningPT(this, cache, "smooth", cache.smooth, endValue);
                        continue;
                    } else if (p === "force3D") {
                        cache[p] = endValue;
                        continue;
                    } else if (p === "transform") {
                        _addRawTransformPTs(this, endValue, target);
                        continue;
                    }
                } else if (!(p in style)) p = _checkPropPrefix(p) || p;
                if (isTransformRelated || (endNum || endNum === 0) && (startNum || startNum === 0) && !_complexExp.test(endValue) && p in style) {
                    startUnit = (startValue + "").substr((startNum + "").length);
                    endNum || (endNum = 0); // protect against NaN
                    endUnit = (0, _gsapCoreJs.getUnit)(endValue) || (p in (0, _gsapCoreJs._config).units ? (0, _gsapCoreJs._config).units[p] : startUnit);
                    startUnit !== endUnit && (startNum = _convertToUnit(target, p, startValue, endUnit));
                    this._pt = new (0, _gsapCoreJs.PropTween)(this._pt, isTransformRelated ? cache : style, p, startNum, (relative ? (0, _gsapCoreJs._parseRelative)(startNum, relative + endNum) : endNum) - startNum, !isTransformRelated && (endUnit === "px" || p === "zIndex") && vars.autoRound !== false ? _renderRoundedCSSProp : _renderCSSProp);
                    this._pt.u = endUnit || 0;
                    if (isTransformRelated && finalTransformValue !== endValue) {
                        this._pt.b = startValue;
                        this._pt.e = finalTransformValue;
                        this._pt.r = _renderCSSPropWithBeginningAndEnd;
                    } else if (startUnit !== endUnit && endUnit !== "%") {
                        //when the tween goes all the way back to the beginning, we need to revert it to the OLD/ORIGINAL value (with those units). We record that as a "b" (beginning) property and point to a render method that handles that. (performance optimization)
                        this._pt.b = startValue;
                        this._pt.r = _renderCSSPropWithBeginning;
                    }
                } else if (!(p in style)) {
                    if (p in target) //maybe it's not a style - it could be a property added directly to an element in which case we'll try to animate that.
                    this.add(target, p, startValue || target[p], relative ? relative + endValue : endValue, index, targets);
                    else if (p !== "parseTransform") {
                        (0, _gsapCoreJs._missingPlugin)(p, endValue);
                        continue;
                    }
                } else _tweenComplexCSSString.call(this, target, p, startValue, relative ? relative + endValue : endValue);
                isTransformRelated || (p in style ? inlineProps.push(p, 0, style[p]) : typeof target[p] === "function" ? inlineProps.push(p, 2, target[p]()) : inlineProps.push(p, 1, startValue || target[p]));
                props.push(p);
            }
        }
        hasPriority && (0, _gsapCoreJs._sortPropTweensByPriority)(this);
    },
    render: function render(ratio, data) {
        if (data.tween._time || !_reverting()) {
            var pt = data._pt;
            while(pt){
                pt.r(ratio, pt.d);
                pt = pt._next;
            }
        } else data.styles.revert();
    },
    get: _get,
    aliases: _propertyAliases,
    getSetter: function getSetter(target, property, plugin) {
        //returns a setter function that accepts target, property, value and applies it accordingly. Remember, properties like "x" aren't as simple as target.style.property = value because they've got to be applied to a proxy object and then merged into a transform string in a renderer.
        var p = _propertyAliases[property];
        p && p.indexOf(",") < 0 && (property = p);
        return property in _transformProps && property !== _transformOriginProp && (target._gsap.x || _get(target, "x")) ? plugin && _recentSetterPlugin === plugin ? property === "scale" ? _setterScale : _setterTransform : (_recentSetterPlugin = plugin || {}, property === "scale" ? _setterScaleWithRender : _setterTransformWithRender) : target.style && !(0, _gsapCoreJs._isUndefined)(target.style[property]) ? _setterCSSStyle : ~property.indexOf("-") ? _setterCSSProp : (0, _gsapCoreJs._getSetter)(target, property);
    },
    core: {
        _removeProperty: _removeProperty,
        _getMatrix: _getMatrix
    }
};
(0, _gsapCoreJs.gsap).utils.checkPrefix = _checkPropPrefix;
(0, _gsapCoreJs.gsap).core.getStyleSaver = _getStyleSaver;
(function(positionAndScale, rotation, others, aliases) {
    var all = (0, _gsapCoreJs._forEachName)(positionAndScale + "," + rotation + "," + others, function(name) {
        _transformProps[name] = 1;
    });
    (0, _gsapCoreJs._forEachName)(rotation, function(name) {
        (0, _gsapCoreJs._config).units[name] = "deg";
        _rotationalProperties[name] = 1;
    });
    _propertyAliases[all[13]] = positionAndScale + "," + rotation;
    (0, _gsapCoreJs._forEachName)(aliases, function(name) {
        var split = name.split(":");
        _propertyAliases[split[1]] = all[split[0]];
    });
})("x,y,z,scale,scaleX,scaleY,xPercent,yPercent", "rotation,rotationX,rotationY,skewX,skewY", "transform,transformOrigin,svgOrigin,force3D,smoothOrigin,transformPerspective", "0:translateX,1:translateY,2:translateZ,8:rotate,8:rotationZ,8:rotateZ,9:rotateX,10:rotateY");
(0, _gsapCoreJs._forEachName)("x,y,z,top,right,bottom,left,width,height,fontSize,padding,margin,perspective", function(name) {
    (0, _gsapCoreJs._config).units[name] = "px";
});
(0, _gsapCoreJs.gsap).registerPlugin(CSSPlugin);

},{"./gsap-core.js":"5DEyn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6usvx":[function(require,module,exports,__globalThis) {
/*!
 * ScrollTrigger 3.14.2
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollTrigger", ()=>ScrollTrigger);
parcelHelpers.export(exports, "default", ()=>ScrollTrigger);
var _observerJs = require("./Observer.js");
var gsap, _coreInitted, _win, _doc, _docEl, _body, _root, _resizeDelay, _toArray, _clamp, _time2, _syncInterval, _refreshing, _pointerIsDown, _transformProp, _i, _prevWidth, _prevHeight, _autoRefresh, _sort, _suppressOverwrites, _ignoreResize, _normalizer, _ignoreMobileResize, _baseScreenHeight, _baseScreenWidth, _fixIOSBug, _context, _scrollRestoration, _div100vh, _100vh, _isReverted, _clampingMax, _limitCallbacks, // if true, we'll only trigger callbacks if the active state toggles, so if you scroll immediately past both the start and end positions of a ScrollTrigger (thus inactive to inactive), neither its onEnter nor onLeave will be called. This is useful during startup.
_startup = 1, _getTime = Date.now, _time1 = _getTime(), _lastScrollTime = 0, _enabled = 0, _parseClamp = function _parseClamp(value, type, self) {
    var clamp = _isString(value) && (value.substr(0, 6) === "clamp(" || value.indexOf("max") > -1);
    self["_" + type + "Clamp"] = clamp;
    return clamp ? value.substr(6, value.length - 7) : value;
}, _keepClamp = function _keepClamp(value, clamp) {
    return clamp && (!_isString(value) || value.substr(0, 6) !== "clamp(") ? "clamp(" + value + ")" : value;
}, _rafBugFix = function _rafBugFix() {
    return _enabled && requestAnimationFrame(_rafBugFix);
}, // in some browsers (like Firefox), screen repaints weren't consistent unless we had SOMETHING queued up in requestAnimationFrame()! So this just creates a super simple loop to keep it alive and smooth out repaints.
_pointerDownHandler = function _pointerDownHandler() {
    return _pointerIsDown = 1;
}, _pointerUpHandler = function _pointerUpHandler() {
    return _pointerIsDown = 0;
}, _passThrough = function _passThrough(v) {
    return v;
}, _round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _getGSAP = function _getGSAP() {
    return gsap || _windowExists() && (gsap = window.gsap) && gsap.registerPlugin && gsap;
}, _isViewport = function _isViewport(e) {
    return !!~_root.indexOf(e);
}, _getViewportDimension = function _getViewportDimension(dimensionProperty) {
    return (dimensionProperty === "Height" ? _100vh : _win["inner" + dimensionProperty]) || _docEl["client" + dimensionProperty] || _body["client" + dimensionProperty];
}, _getBoundsFunc = function _getBoundsFunc(element) {
    return (0, _observerJs._getProxyProp)(element, "getBoundingClientRect") || (_isViewport(element) ? function() {
        _winOffsets.width = _win.innerWidth;
        _winOffsets.height = _100vh;
        return _winOffsets;
    } : function() {
        return _getBounds(element);
    });
}, _getSizeFunc = function _getSizeFunc(scroller, isViewport, _ref) {
    var d = _ref.d, d2 = _ref.d2, a = _ref.a;
    return (a = (0, _observerJs._getProxyProp)(scroller, "getBoundingClientRect")) ? function() {
        return a()[d];
    } : function() {
        return (isViewport ? _getViewportDimension(d2) : scroller["client" + d2]) || 0;
    };
}, _getOffsetsFunc = function _getOffsetsFunc(element, isViewport) {
    return !isViewport || ~(0, _observerJs._proxies).indexOf(element) ? _getBoundsFunc(element) : function() {
        return _winOffsets;
    };
}, _maxScroll = function _maxScroll(element, _ref2) {
    var s = _ref2.s, d2 = _ref2.d2, d = _ref2.d, a = _ref2.a;
    return Math.max(0, (s = "scroll" + d2, a = (0, _observerJs._getProxyProp)(element, s)) ? a() - _getBoundsFunc(element)()[d] : _isViewport(element) ? (_docEl[s] || _body[s]) - _getViewportDimension(d2) : element[s] - element["offset" + d2]);
}, _iterateAutoRefresh = function _iterateAutoRefresh(func, events) {
    for(var i = 0; i < _autoRefresh.length; i += 3)(!events || ~events.indexOf(_autoRefresh[i + 1])) && func(_autoRefresh[i], _autoRefresh[i + 1], _autoRefresh[i + 2]);
}, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _isNumber = function _isNumber(value) {
    return typeof value === "number";
}, _isObject = function _isObject(value) {
    return typeof value === "object";
}, _endAnimation = function _endAnimation(animation, reversed, pause) {
    return animation && animation.progress(reversed ? 0 : 1) && pause && animation.pause();
}, _callback = function _callback(self, func) {
    if (self.enabled) {
        var result = self._ctx ? self._ctx.add(function() {
            return func(self);
        }) : func(self);
        result && result.totalTime && (self.callbackAnimation = result);
    }
}, _abs = Math.abs, _left = "left", _top = "top", _right = "right", _bottom = "bottom", _width = "width", _height = "height", _Right = "Right", _Left = "Left", _Top = "Top", _Bottom = "Bottom", _padding = "padding", _margin = "margin", _Width = "Width", _Height = "Height", _px = "px", _getComputedStyle = function _getComputedStyle(element) {
    return _win.getComputedStyle(element);
}, _makePositionable = function _makePositionable(element) {
    // if the element already has position: absolute or fixed, leave that, otherwise make it position: relative
    var position = _getComputedStyle(element).position;
    element.style.position = position === "absolute" || position === "fixed" ? position : "relative";
}, _setDefaults = function _setDefaults(obj, defaults) {
    for(var p in defaults)p in obj || (obj[p] = defaults[p]);
    return obj;
}, _getBounds = function _getBounds(element, withoutTransforms) {
    var tween = withoutTransforms && _getComputedStyle(element)[_transformProp] !== "matrix(1, 0, 0, 1, 0, 0)" && gsap.to(element, {
        x: 0,
        y: 0,
        xPercent: 0,
        yPercent: 0,
        rotation: 0,
        rotationX: 0,
        rotationY: 0,
        scale: 1,
        skewX: 0,
        skewY: 0
    }).progress(1), bounds = element.getBoundingClientRect();
    tween && tween.progress(0).kill();
    return bounds;
}, _getSize = function _getSize(element, _ref3) {
    var d2 = _ref3.d2;
    return element["offset" + d2] || element["client" + d2] || 0;
}, _getLabelRatioArray = function _getLabelRatioArray(timeline) {
    var a = [], labels = timeline.labels, duration = timeline.duration(), p;
    for(p in labels)a.push(labels[p] / duration);
    return a;
}, _getClosestLabel = function _getClosestLabel(animation) {
    return function(value) {
        return gsap.utils.snap(_getLabelRatioArray(animation), value);
    };
}, _snapDirectional = function _snapDirectional(snapIncrementOrArray) {
    var snap = gsap.utils.snap(snapIncrementOrArray), a = Array.isArray(snapIncrementOrArray) && snapIncrementOrArray.slice(0).sort(function(a, b) {
        return a - b;
    });
    return a ? function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var i;
        if (!direction) return snap(value);
        if (direction > 0) {
            value -= threshold; // to avoid rounding errors. If we're too strict, it might snap forward, then immediately again, and again.
            for(i = 0; i < a.length; i++){
                if (a[i] >= value) return a[i];
            }
            return a[i - 1];
        } else {
            i = a.length;
            value += threshold;
            while(i--){
                if (a[i] <= value) return a[i];
            }
        }
        return a[0];
    } : function(value, direction, threshold) {
        if (threshold === void 0) threshold = 1e-3;
        var snapped = snap(value);
        return !direction || Math.abs(snapped - value) < threshold || snapped - value < 0 === direction < 0 ? snapped : snap(direction < 0 ? value - snapIncrementOrArray : value + snapIncrementOrArray);
    };
}, _getLabelAtDirection = function _getLabelAtDirection(timeline) {
    return function(value, st) {
        return _snapDirectional(_getLabelRatioArray(timeline))(value, st.direction);
    };
}, _multiListener = function _multiListener(func, element, types, callback) {
    return types.split(",").forEach(function(type) {
        return func(element, type, callback);
    });
}, _addListener = function _addListener(element, type, func, nonPassive, capture) {
    return element.addEventListener(type, func, {
        passive: !nonPassive,
        capture: !!capture
    });
}, _removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, _wheelListener = function _wheelListener(func, el, scrollFunc) {
    scrollFunc = scrollFunc && scrollFunc.wheelHandler;
    if (scrollFunc) {
        func(el, "wheel", scrollFunc);
        func(el, "touchmove", scrollFunc);
    }
}, _markerDefaults = {
    startColor: "green",
    endColor: "red",
    indent: 0,
    fontSize: "16px",
    fontWeight: "normal"
}, _defaults = {
    toggleActions: "play",
    anticipatePin: 0
}, _keywords = {
    top: 0,
    left: 0,
    center: 0.5,
    bottom: 1,
    right: 1
}, _offsetToPx = function _offsetToPx(value, size) {
    if (_isString(value)) {
        var eqIndex = value.indexOf("="), relative = ~eqIndex ? +(value.charAt(eqIndex - 1) + 1) * parseFloat(value.substr(eqIndex + 1)) : 0;
        if (~eqIndex) {
            value.indexOf("%") > eqIndex && (relative *= size / 100);
            value = value.substr(0, eqIndex - 1);
        }
        value = relative + (value in _keywords ? _keywords[value] * size : ~value.indexOf("%") ? parseFloat(value) * size / 100 : parseFloat(value) || 0);
    }
    return value;
}, _createMarker = function _createMarker(type, name, container, direction, _ref4, offset, matchWidthEl, containerAnimation) {
    var startColor = _ref4.startColor, endColor = _ref4.endColor, fontSize = _ref4.fontSize, indent = _ref4.indent, fontWeight = _ref4.fontWeight;
    var e = _doc.createElement("div"), useFixedPosition = _isViewport(container) || (0, _observerJs._getProxyProp)(container, "pinType") === "fixed", isScroller = type.indexOf("scroller") !== -1, parent = useFixedPosition ? _body : container, isStart = type.indexOf("start") !== -1, color = isStart ? startColor : endColor, css = "border-color:" + color + ";font-size:" + fontSize + ";color:" + color + ";font-weight:" + fontWeight + ";pointer-events:none;white-space:nowrap;font-family:sans-serif,Arial;z-index:1000;padding:4px 8px;border-width:0;border-style:solid;";
    css += "position:" + ((isScroller || containerAnimation) && useFixedPosition ? "fixed;" : "absolute;");
    (isScroller || containerAnimation || !useFixedPosition) && (css += (direction === (0, _observerJs._vertical) ? _right : _bottom) + ":" + (offset + parseFloat(indent)) + "px;");
    matchWidthEl && (css += "box-sizing:border-box;text-align:left;width:" + matchWidthEl.offsetWidth + "px;");
    e._isStart = isStart;
    e.setAttribute("class", "gsap-marker-" + type + (name ? " marker-" + name : ""));
    e.style.cssText = css;
    e.innerText = name || name === 0 ? type + "-" + name : type;
    parent.children[0] ? parent.insertBefore(e, parent.children[0]) : parent.appendChild(e);
    e._offset = e["offset" + direction.op.d2];
    _positionMarker(e, 0, direction, isStart);
    return e;
}, _positionMarker = function _positionMarker(marker, start, direction, flipped) {
    var vars = {
        display: "block"
    }, side = direction[flipped ? "os2" : "p2"], oppositeSide = direction[flipped ? "p2" : "os2"];
    marker._isFlipped = flipped;
    vars[direction.a + "Percent"] = flipped ? -100 : 0;
    vars[direction.a] = flipped ? "1px" : 0;
    vars["border" + side + _Width] = 1;
    vars["border" + oppositeSide + _Width] = 0;
    vars[direction.p] = start + "px";
    gsap.set(marker, vars);
}, _triggers = [], _ids = {}, _rafID, _sync = function _sync() {
    return _getTime() - _lastScrollTime > 34 && (_rafID || (_rafID = requestAnimationFrame(_updateAll)));
}, _onScroll = function _onScroll() {
    // previously, we tried to optimize performance by batching/deferring to the next requestAnimationFrame(), but discovered that Safari has a few bugs that make this unworkable (especially on iOS). See https://codepen.io/GreenSock/pen/16c435b12ef09c38125204818e7b45fc?editors=0010 and https://codepen.io/GreenSock/pen/JjOxYpQ/3dd65ccec5a60f1d862c355d84d14562?editors=0010 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503?editors=0010
    if (!_normalizer || !_normalizer.isPressed || _normalizer.startX > _body.clientWidth) {
        // if the user is dragging the scrollbar, allow it.
        (0, _observerJs._scrollers).cache++;
        if (_normalizer) _rafID || (_rafID = requestAnimationFrame(_updateAll));
        else _updateAll(); // Safari in particular (on desktop) NEEDS the immediate update rather than waiting for a requestAnimationFrame() whereas iOS seems to benefit from waiting for the requestAnimationFrame() tick, at least when normalizing. See https://codepen.io/GreenSock/pen/qBYozqO?editors=0110
        _lastScrollTime || _dispatch("scrollStart");
        _lastScrollTime = _getTime();
    }
}, _setBaseDimensions = function _setBaseDimensions() {
    _baseScreenWidth = _win.innerWidth;
    _baseScreenHeight = _win.innerHeight;
}, _onResize = function _onResize(force) {
    (0, _observerJs._scrollers).cache++;
    (force === true || !_refreshing && !_ignoreResize && !_doc.fullscreenElement && !_doc.webkitFullscreenElement && (!_ignoreMobileResize || _baseScreenWidth !== _win.innerWidth || Math.abs(_win.innerHeight - _baseScreenHeight) > _win.innerHeight * 0.25)) && _resizeDelay.restart(true);
}, // ignore resizes triggered by refresh()
_listeners = {}, _emptyArray = [], _softRefresh = function _softRefresh() {
    return _removeListener(ScrollTrigger, "scrollEnd", _softRefresh) || _refreshAll(true);
}, _dispatch = function _dispatch(type) {
    return _listeners[type] && _listeners[type].map(function(f) {
        return f();
    }) || _emptyArray;
}, _savedStyles = [], // when ScrollTrigger.saveStyles() is called, the inline styles are recorded in this Array in a sequential format like [element, cssText, gsCache, media]. This keeps it very memory-efficient and fast to iterate through.
_revertRecorded = function _revertRecorded(media) {
    for(var i = 0; i < _savedStyles.length; i += 5)if (!media || _savedStyles[i + 4] && _savedStyles[i + 4].query === media) {
        _savedStyles[i].style.cssText = _savedStyles[i + 1];
        _savedStyles[i].getBBox && _savedStyles[i].setAttribute("transform", _savedStyles[i + 2] || "");
        _savedStyles[i + 3].uncache = 1;
    }
}, _recordScrollPositions = function _recordScrollPositions() {
    return (0, _observerJs._scrollers).forEach(function(obj) {
        return _isFunction(obj) && ++obj.cacheID && (obj.rec = obj());
    });
}, // record the current scroll position. Also force the clearing of the cache because some browsers take a little while to dispatch the "scroll" event and the user may have changed the scroll position and then called ScrollTrigger.refresh() right away
_revertAll = function _revertAll(kill, media) {
    var trigger;
    for(_i = 0; _i < _triggers.length; _i++){
        trigger = _triggers[_i];
        if (trigger && (!media || trigger._ctx === media)) {
            if (kill) trigger.kill(1);
            else trigger.revert(true, true);
        }
    }
    _isReverted = true;
    media && _revertRecorded(media);
    media || _dispatch("revert");
}, _clearScrollMemory = function _clearScrollMemory(scrollRestoration, force) {
    // zero-out all the recorded scroll positions. Don't use _triggers because if, for example, .matchMedia() is used to create some ScrollTriggers and then the user resizes and it removes ALL ScrollTriggers, and then go back to a size where there are ScrollTriggers, it would have kept the position(s) saved from the initial state.
    (0, _observerJs._scrollers).cache++;
    (force || !_refreshingAll) && (0, _observerJs._scrollers).forEach(function(obj) {
        return _isFunction(obj) && obj.cacheID++ && (obj.rec = 0);
    });
    _isString(scrollRestoration) && (_win.history.scrollRestoration = _scrollRestoration = scrollRestoration);
}, _refreshingAll, _refreshID = 0, _queueRefreshID, _queueRefreshAll = function _queueRefreshAll() {
    // we don't want to call _refreshAll() every time we create a new ScrollTrigger (for performance reasons) - it's better to batch them. Some frameworks dynamically load content and we can't rely on the window's "load" or "DOMContentLoaded" events to trigger it.
    if (_queueRefreshID !== _refreshID) {
        var id = _queueRefreshID = _refreshID;
        requestAnimationFrame(function() {
            return id === _refreshID && _refreshAll(true);
        });
    }
}, _refresh100vh = function _refresh100vh() {
    _body.appendChild(_div100vh);
    _100vh = !_normalizer && _div100vh.offsetHeight || _win.innerHeight;
    _body.removeChild(_div100vh);
}, _hideAllMarkers = function _hideAllMarkers(hide) {
    return _toArray(".gsap-marker-start, .gsap-marker-end, .gsap-marker-scroller-start, .gsap-marker-scroller-end").forEach(function(el) {
        return el.style.display = hide ? "none" : "block";
    });
}, _refreshAll = function _refreshAll(force, skipRevert) {
    _docEl = _doc.documentElement; // some frameworks like Astro may cache the <body> and replace it during routing, so we'll just re-record the _docEl and _body for safety (otherwise, the markers may not get added properly).
    _body = _doc.body;
    _root = [
        _win,
        _doc,
        _docEl,
        _body
    ];
    if (_lastScrollTime && !force && !_isReverted) {
        _addListener(ScrollTrigger, "scrollEnd", _softRefresh);
        return;
    }
    _refresh100vh();
    _refreshingAll = ScrollTrigger.isRefreshing = true;
    _isReverted || _recordScrollPositions();
    var refreshInits = _dispatch("refreshInit");
    _sort && ScrollTrigger.sort();
    skipRevert || _revertAll();
    (0, _observerJs._scrollers).forEach(function(obj) {
        if (_isFunction(obj)) {
            obj.smooth && (obj.target.style.scrollBehavior = "auto"); // smooth scrolling interferes
            obj(0);
        }
    });
    _triggers.slice(0).forEach(function(t) {
        return t.refresh();
    }); // don't loop with _i because during a refresh() someone could call ScrollTrigger.update() which would iterate through _i resulting in a skip.
    _isReverted = false;
    _triggers.forEach(function(t) {
        // nested pins (pinnedContainer) with pinSpacing may expand the container, so we must accommodate that here.
        if (t._subPinOffset && t.pin) {
            var prop = t.vars.horizontal ? "offsetWidth" : "offsetHeight", original = t.pin[prop];
            t.revert(true, 1);
            t.adjustPinSpacing(t.pin[prop] - original);
            t.refresh();
        }
    });
    _clampingMax = 1; // pinSpacing might be propping a page open, thus when we .setPositions() to clamp a ScrollTrigger's end we should leave the pinSpacing alone. That's what this flag is for.
    _hideAllMarkers(true);
    _triggers.forEach(function(t) {
        // the scroller's max scroll position may change after all the ScrollTriggers refreshed (like pinning could push it down), so we need to loop back and correct any with end: "max". Same for anything with a clamped end
        var max = _maxScroll(t.scroller, t._dir), endClamp = t.vars.end === "max" || t._endClamp && t.end > max, startClamp = t._startClamp && t.start >= max;
        (endClamp || startClamp) && t.setPositions(startClamp ? max - 1 : t.start, endClamp ? Math.max(startClamp ? max : t.start + 1, max) : t.end, true);
    });
    _hideAllMarkers(false);
    _clampingMax = 0;
    refreshInits.forEach(function(result) {
        return result && result.render && result.render(-1);
    }); // if the onRefreshInit() returns an animation (typically a gsap.set()), revert it. This makes it easy to put things in a certain spot before refreshing for measurement purposes, and then put things back.
    (0, _observerJs._scrollers).forEach(function(obj) {
        if (_isFunction(obj)) {
            obj.smooth && requestAnimationFrame(function() {
                return obj.target.style.scrollBehavior = "smooth";
            });
            obj.rec && obj(obj.rec);
        }
    });
    _clearScrollMemory(_scrollRestoration, 1);
    _resizeDelay.pause();
    _refreshID++;
    _refreshingAll = 2;
    _updateAll(2);
    _triggers.forEach(function(t) {
        return _isFunction(t.vars.onRefresh) && t.vars.onRefresh(t);
    });
    _refreshingAll = ScrollTrigger.isRefreshing = false;
    _dispatch("refresh");
}, _lastScroll = 0, _direction = 1, _primary, _updateAll = function _updateAll(force) {
    if (force === 2 || !_refreshingAll && !_isReverted) {
        // _isReverted could be true if, for example, a matchMedia() is in the process of executing. We don't want to update during the time everything is reverted.
        ScrollTrigger.isUpdating = true;
        _primary && _primary.update(0); // ScrollSmoother uses refreshPriority -9999 to become the primary that gets updated before all others because it affects the scroll position.
        var l = _triggers.length, time = _getTime(), recordVelocity = time - _time1 >= 50, scroll = l && _triggers[0].scroll();
        _direction = _lastScroll > scroll ? -1 : 1;
        _refreshingAll || (_lastScroll = scroll);
        if (recordVelocity) {
            if (_lastScrollTime && !_pointerIsDown && time - _lastScrollTime > 200) {
                _lastScrollTime = 0;
                _dispatch("scrollEnd");
            }
            _time2 = _time1;
            _time1 = time;
        }
        if (_direction < 0) {
            _i = l;
            while(_i-- > 0)_triggers[_i] && _triggers[_i].update(0, recordVelocity);
            _direction = 1;
        } else for(_i = 0; _i < l; _i++)_triggers[_i] && _triggers[_i].update(0, recordVelocity);
        ScrollTrigger.isUpdating = false;
    }
    _rafID = 0;
}, _propNamesToCopy = [
    _left,
    _top,
    _bottom,
    _right,
    _margin + _Bottom,
    _margin + _Right,
    _margin + _Top,
    _margin + _Left,
    "display",
    "flexShrink",
    "float",
    "zIndex",
    "gridColumnStart",
    "gridColumnEnd",
    "gridRowStart",
    "gridRowEnd",
    "gridArea",
    "justifySelf",
    "alignSelf",
    "placeSelf",
    "order"
], _stateProps = _propNamesToCopy.concat([
    _width,
    _height,
    "boxSizing",
    "max" + _Width,
    "max" + _Height,
    "position",
    _margin,
    _padding,
    _padding + _Top,
    _padding + _Right,
    _padding + _Bottom,
    _padding + _Left
]), _swapPinOut = function _swapPinOut(pin, spacer, state) {
    _setState(state);
    var cache = pin._gsap;
    if (cache.spacerIsNative) _setState(cache.spacerState);
    else if (pin._gsap.swappedIn) {
        var parent = spacer.parentNode;
        if (parent) {
            parent.insertBefore(pin, spacer);
            parent.removeChild(spacer);
        }
    }
    pin._gsap.swappedIn = false;
}, _swapPinIn = function _swapPinIn(pin, spacer, cs, spacerState) {
    if (!pin._gsap.swappedIn) {
        var i = _propNamesToCopy.length, spacerStyle = spacer.style, pinStyle = pin.style, p;
        while(i--){
            p = _propNamesToCopy[i];
            spacerStyle[p] = cs[p];
        }
        spacerStyle.position = cs.position === "absolute" ? "absolute" : "relative";
        cs.display === "inline" && (spacerStyle.display = "inline-block");
        pinStyle[_bottom] = pinStyle[_right] = "auto";
        spacerStyle.flexBasis = cs.flexBasis || "auto";
        spacerStyle.overflow = "visible";
        spacerStyle.boxSizing = "border-box";
        spacerStyle[_width] = _getSize(pin, (0, _observerJs._horizontal)) + _px;
        spacerStyle[_height] = _getSize(pin, (0, _observerJs._vertical)) + _px;
        spacerStyle[_padding] = pinStyle[_margin] = pinStyle[_top] = pinStyle[_left] = "0";
        _setState(spacerState);
        pinStyle[_width] = pinStyle["max" + _Width] = cs[_width];
        pinStyle[_height] = pinStyle["max" + _Height] = cs[_height];
        pinStyle[_padding] = cs[_padding];
        if (pin.parentNode !== spacer) {
            pin.parentNode.insertBefore(spacer, pin);
            spacer.appendChild(pin);
        }
        pin._gsap.swappedIn = true;
    }
}, _capsExp = /([A-Z])/g, _setState = function _setState(state) {
    if (state) {
        var style = state.t.style, l = state.length, i = 0, p, value;
        (state.t._gsap || gsap.core.getCache(state.t)).uncache = 1; // otherwise transforms may be off
        for(; i < l; i += 2){
            value = state[i + 1];
            p = state[i];
            if (value) style[p] = value;
            else if (style[p]) style.removeProperty(p.replace(_capsExp, "-$1").toLowerCase());
        }
    }
}, _getState = function _getState(element) {
    // returns an Array with alternating values like [property, value, property, value] and a "t" property pointing to the target (element). Makes it fast and cheap.
    var l = _stateProps.length, style = element.style, state = [], i = 0;
    for(; i < l; i++)state.push(_stateProps[i], style[_stateProps[i]]);
    state.t = element;
    return state;
}, _copyState = function _copyState(state, override, omitOffsets) {
    var result = [], l = state.length, i = omitOffsets ? 8 : 0, // skip top, left, right, bottom if omitOffsets is true
    p;
    for(; i < l; i += 2){
        p = state[i];
        result.push(p, p in override ? override[p] : state[i + 1]);
    }
    result.t = state.t;
    return result;
}, _winOffsets = {
    left: 0,
    top: 0
}, // // potential future feature (?) Allow users to calculate where a trigger hits (scroll position) like getScrollPosition("#id", "top bottom")
// _getScrollPosition = (trigger, position, {scroller, containerAnimation, horizontal}) => {
// 	scroller = _getTarget(scroller || _win);
// 	let direction = horizontal ? _horizontal : _vertical,
// 		isViewport = _isViewport(scroller);
// 	_getSizeFunc(scroller, isViewport, direction);
// 	return _parsePosition(position, _getTarget(trigger), _getSizeFunc(scroller, isViewport, direction)(), direction, _getScrollFunc(scroller, direction)(), 0, 0, 0, _getOffsetsFunc(scroller, isViewport)(), isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, 0, containerAnimation ? containerAnimation.duration() : _maxScroll(scroller), containerAnimation);
// },
_parsePosition = function _parsePosition(value, trigger, scrollerSize, direction, scroll, marker, markerScroller, self, scrollerBounds, borderWidth, useFixedPosition, scrollerMax, containerAnimation, clampZeroProp) {
    _isFunction(value) && (value = value(self));
    if (_isString(value) && value.substr(0, 3) === "max") value = scrollerMax + (value.charAt(4) === "=" ? _offsetToPx("0" + value.substr(3), scrollerSize) : 0);
    var time = containerAnimation ? containerAnimation.time() : 0, p1, p2, element;
    containerAnimation && containerAnimation.seek(0);
    isNaN(value) || (value = +value); // convert a string number like "45" to an actual number
    if (!_isNumber(value)) {
        _isFunction(trigger) && (trigger = trigger(self));
        var offsets = (value || "0").split(" "), bounds, localOffset, globalOffset, display;
        element = (0, _observerJs._getTarget)(trigger, self) || _body;
        bounds = _getBounds(element) || {};
        if ((!bounds || !bounds.left && !bounds.top) && _getComputedStyle(element).display === "none") {
            // if display is "none", it won't report getBoundingClientRect() properly
            display = element.style.display;
            element.style.display = "block";
            bounds = _getBounds(element);
            display ? element.style.display = display : element.style.removeProperty("display");
        }
        localOffset = _offsetToPx(offsets[0], bounds[direction.d]);
        globalOffset = _offsetToPx(offsets[1] || "0", scrollerSize);
        value = bounds[direction.p] - scrollerBounds[direction.p] - borderWidth + localOffset + scroll - globalOffset;
        markerScroller && _positionMarker(markerScroller, globalOffset, direction, scrollerSize - globalOffset < 20 || markerScroller._isStart && globalOffset > 20);
        scrollerSize -= scrollerSize - globalOffset; // adjust for the marker
    } else {
        containerAnimation && (value = gsap.utils.mapRange(containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, 0, scrollerMax, value));
        markerScroller && _positionMarker(markerScroller, scrollerSize, direction, true);
    }
    if (clampZeroProp) {
        self[clampZeroProp] = value || -0.001;
        value < 0 && (value = 0);
    }
    if (marker) {
        var position = value + scrollerSize, isStart = marker._isStart;
        p1 = "scroll" + direction.d2;
        _positionMarker(marker, position, direction, isStart && position > 20 || !isStart && (useFixedPosition ? Math.max(_body[p1], _docEl[p1]) : marker.parentNode[p1]) <= position + 1);
        if (useFixedPosition) {
            scrollerBounds = _getBounds(markerScroller);
            useFixedPosition && (marker.style[direction.op.p] = scrollerBounds[direction.op.p] - direction.op.m - marker._offset + _px);
        }
    }
    if (containerAnimation && element) {
        p1 = _getBounds(element);
        containerAnimation.seek(scrollerMax);
        p2 = _getBounds(element);
        containerAnimation._caScrollDist = p1[direction.p] - p2[direction.p];
        value = value / containerAnimation._caScrollDist * scrollerMax;
    }
    containerAnimation && containerAnimation.seek(time);
    return containerAnimation ? value : Math.round(value);
}, _prefixExp = /(webkit|moz|length|cssText|inset)/i, _reparent = function _reparent(element, parent, top, left) {
    if (element.parentNode !== parent) {
        var style = element.style, p, cs;
        if (parent === _body) {
            element._stOrig = style.cssText; // record original inline styles so we can revert them later
            cs = _getComputedStyle(element);
            for(p in cs)// must copy all relevant styles to ensure that nothing changes visually when we reparent to the <body>. Skip the vendor prefixed ones.
            if (!+p && !_prefixExp.test(p) && cs[p] && typeof style[p] === "string" && p !== "0") style[p] = cs[p];
            style.top = top;
            style.left = left;
        } else style.cssText = element._stOrig;
        gsap.core.getCache(element).uncache = 1;
        parent.appendChild(element);
    }
}, _interruptionTracker = function _interruptionTracker(getValueFunc, initialValue, onInterrupt) {
    var last1 = initialValue, last2 = last1;
    return function(value) {
        var current = Math.round(getValueFunc()); // round because in some [very uncommon] Windows environments, scroll can get reported with decimals even though it was set without.
        if (current !== last1 && current !== last2 && Math.abs(current - last1) > 3 && Math.abs(current - last2) > 3) {
            // if the user scrolls, kill the tween. iOS Safari intermittently misreports the scroll position, it may be the most recently-set one or the one before that! When Safari is zoomed (CMD-+), it often misreports as 1 pixel off too! So if we set the scroll position to 125, for example, it'll actually report it as 124.
            value = current;
            onInterrupt && onInterrupt();
        }
        last2 = last1;
        last1 = Math.round(value);
        return last1;
    };
}, _shiftMarker = function _shiftMarker(marker, direction, value) {
    var vars = {};
    vars[direction.p] = "+=" + value;
    gsap.set(marker, vars);
}, // _mergeAnimations = animations => {
// 	let tl = gsap.timeline({smoothChildTiming: true}).startTime(Math.min(...animations.map(a => a.globalTime(0))));
// 	animations.forEach(a => {let time = a.totalTime(); tl.add(a); a.totalTime(time); });
// 	tl.smoothChildTiming = false;
// 	return tl;
// },
// returns a function that can be used to tween the scroll position in the direction provided, and when doing so it'll add a .tween property to the FUNCTION itself, and remove it when the tween completes or gets killed. This gives us a way to have multiple ScrollTriggers use a central function for any given scroller and see if there's a scroll tween running (which would affect if/how things get updated)
_getTweenCreator = function _getTweenCreator(scroller, direction) {
    var getScroll = (0, _observerJs._getScrollFunc)(scroller, direction), prop = "_scroll" + direction.p2, // add a tweenable property to the scroller that's a getter/setter function, like _scrollTop or _scrollLeft. This way, if someone does gsap.killTweensOf(scroller) it'll kill the scroll tween.
    getTween = function getTween(scrollTo, vars, initialValue, change1, change2) {
        var tween = getTween.tween, onComplete = vars.onComplete, modifiers = {};
        initialValue = initialValue || getScroll();
        var checkForInterruption = _interruptionTracker(getScroll, initialValue, function() {
            tween.kill();
            getTween.tween = 0;
        });
        change2 = change1 && change2 || 0; // if change1 is 0, we set that to the difference and ignore change2. Otherwise, there would be a compound effect.
        change1 = change1 || scrollTo - initialValue;
        tween && tween.kill();
        vars[prop] = scrollTo;
        vars.inherit = false;
        vars.modifiers = modifiers;
        modifiers[prop] = function() {
            return checkForInterruption(initialValue + change1 * tween.ratio + change2 * tween.ratio * tween.ratio);
        };
        vars.onUpdate = function() {
            (0, _observerJs._scrollers).cache++;
            getTween.tween && _updateAll(); // if it was interrupted/killed, like in a context.revert(), don't force an updateAll()
        };
        vars.onComplete = function() {
            getTween.tween = 0;
            onComplete && onComplete.call(tween);
        };
        tween = getTween.tween = gsap.to(scroller, vars);
        return tween;
    };
    scroller[prop] = getScroll;
    getScroll.wheelHandler = function() {
        return getTween.tween && getTween.tween.kill() && (getTween.tween = 0);
    };
    _addListener(scroller, "wheel", getScroll.wheelHandler); // Windows machines handle mousewheel scrolling in chunks (like "3 lines per scroll") meaning the typical strategy for cancelling the scroll isn't as sensitive. It's much more likely to match one of the previous 2 scroll event positions. So we kill any snapping as soon as there's a wheel event.
    ScrollTrigger.isTouch && _addListener(scroller, "touchmove", getScroll.wheelHandler);
    return getTween;
};
var ScrollTrigger = /*#__PURE__*/ function() {
    function ScrollTrigger(vars, animation) {
        _coreInitted || ScrollTrigger.register(gsap) || console.warn("Please gsap.registerPlugin(ScrollTrigger)");
        _context(this);
        this.init(vars, animation);
    }
    var _proto = ScrollTrigger.prototype;
    _proto.init = function init(vars, animation) {
        this.progress = this.start = 0;
        this.vars && this.kill(true, true); // in case it's being initted again
        if (!_enabled) {
            this.update = this.refresh = this.kill = _passThrough;
            return;
        }
        vars = _setDefaults(_isString(vars) || _isNumber(vars) || vars.nodeType ? {
            trigger: vars
        } : vars, _defaults);
        var _vars = vars, onUpdate = _vars.onUpdate, toggleClass = _vars.toggleClass, id = _vars.id, onToggle = _vars.onToggle, onRefresh = _vars.onRefresh, scrub = _vars.scrub, trigger = _vars.trigger, pin = _vars.pin, pinSpacing = _vars.pinSpacing, invalidateOnRefresh = _vars.invalidateOnRefresh, anticipatePin = _vars.anticipatePin, onScrubComplete = _vars.onScrubComplete, onSnapComplete = _vars.onSnapComplete, once = _vars.once, snap = _vars.snap, pinReparent = _vars.pinReparent, pinSpacer = _vars.pinSpacer, containerAnimation = _vars.containerAnimation, fastScrollEnd = _vars.fastScrollEnd, preventOverlaps = _vars.preventOverlaps, direction = vars.horizontal || vars.containerAnimation && vars.horizontal !== false ? (0, _observerJs._horizontal) : (0, _observerJs._vertical), isToggle = !scrub && scrub !== 0, scroller = (0, _observerJs._getTarget)(vars.scroller || _win), scrollerCache = gsap.core.getCache(scroller), isViewport = _isViewport(scroller), useFixedPosition = ("pinType" in vars ? vars.pinType : (0, _observerJs._getProxyProp)(scroller, "pinType") || isViewport && "fixed") === "fixed", callbacks = [
            vars.onEnter,
            vars.onLeave,
            vars.onEnterBack,
            vars.onLeaveBack
        ], toggleActions = isToggle && vars.toggleActions.split(" "), markers = "markers" in vars ? vars.markers : _defaults.markers, borderWidth = isViewport ? 0 : parseFloat(_getComputedStyle(scroller)["border" + direction.p2 + _Width]) || 0, self = this, onRefreshInit = vars.onRefreshInit && function() {
            return vars.onRefreshInit(self);
        }, getScrollerSize = _getSizeFunc(scroller, isViewport, direction), getScrollerOffsets = _getOffsetsFunc(scroller, isViewport), lastSnap = 0, lastRefresh = 0, prevProgress = 0, scrollFunc = (0, _observerJs._getScrollFunc)(scroller, direction), tweenTo, pinCache, snapFunc, scroll1, scroll2, start, end, markerStart, markerEnd, markerStartTrigger, markerEndTrigger, markerVars, executingOnRefresh, change, pinOriginalState, pinActiveState, pinState, spacer, offset, pinGetter, pinSetter, pinStart, pinChange, spacingStart, spacerState, markerStartSetter, pinMoves, markerEndSetter, cs, snap1, snap2, scrubTween, scrubSmooth, snapDurClamp, snapDelayedCall, prevScroll, prevAnimProgress, caMarkerSetter, customRevertReturn; // for the sake of efficiency, _startClamp/_endClamp serve like a truthy value indicating that clamping was enabled on the start/end, and ALSO store the actual pre-clamped numeric value. We tap into that in ScrollSmoother for speed effects. So for example, if start="clamp(top bottom)" results in a start of -100 naturally, it would get clamped to 0 but -100 would be stored in _startClamp.
        self._startClamp = self._endClamp = false;
        self._dir = direction;
        anticipatePin *= 45;
        self.scroller = scroller;
        self.scroll = containerAnimation ? containerAnimation.time.bind(containerAnimation) : scrollFunc;
        scroll1 = scrollFunc();
        self.vars = vars;
        animation = animation || vars.animation;
        if ("refreshPriority" in vars) {
            _sort = 1;
            vars.refreshPriority === -9999 && (_primary = self); // used by ScrollSmoother
        }
        scrollerCache.tweenScroll = scrollerCache.tweenScroll || {
            top: _getTweenCreator(scroller, (0, _observerJs._vertical)),
            left: _getTweenCreator(scroller, (0, _observerJs._horizontal))
        };
        self.tweenTo = tweenTo = scrollerCache.tweenScroll[direction.p];
        self.scrubDuration = function(value) {
            scrubSmooth = _isNumber(value) && value;
            if (!scrubSmooth) {
                scrubTween && scrubTween.progress(1).kill();
                scrubTween = 0;
            } else scrubTween ? scrubTween.duration(value) : scrubTween = gsap.to(animation, {
                ease: "expo",
                totalProgress: "+=0",
                inherit: false,
                duration: scrubSmooth,
                paused: true,
                onComplete: function onComplete() {
                    return onScrubComplete && onScrubComplete(self);
                }
            });
        };
        if (animation) {
            animation.vars.lazy = false;
            animation._initted && !self.isReverted || animation.vars.immediateRender !== false && vars.immediateRender !== false && animation.duration() && animation.render(0, true, true); // special case: if this ScrollTrigger gets re-initted, a from() tween with a stagger could get initted initially and then reverted on the re-init which means it'll need to get rendered again here to properly display things. Otherwise, See https://gsap.com/forums/topic/36777-scrollsmoother-splittext-nextjs/ and https://codepen.io/GreenSock/pen/eYPyPpd?editors=0010
            self.animation = animation.pause();
            animation.scrollTrigger = self;
            self.scrubDuration(scrub);
            snap1 = 0;
            id || (id = animation.vars.id);
        }
        if (snap) {
            // TODO: potential idea: use legitimate CSS scroll snapping by pushing invisible elements into the DOM that serve as snap positions, and toggle the document.scrollingElement.style.scrollSnapType onToggle. See https://codepen.io/GreenSock/pen/JjLrgWM for a quick proof of concept.
            if (!_isObject(snap) || snap.push) snap = {
                snapTo: snap
            };
            "scrollBehavior" in _body.style && gsap.set(isViewport ? [
                _body,
                _docEl
            ] : scroller, {
                scrollBehavior: "auto"
            }); // smooth scrolling doesn't work with snap.
            (0, _observerJs._scrollers).forEach(function(o) {
                return _isFunction(o) && o.target === (isViewport ? _doc.scrollingElement || _docEl : scroller) && (o.smooth = false);
            }); // note: set smooth to false on both the vertical and horizontal scroll getters/setters
            snapFunc = _isFunction(snap.snapTo) ? snap.snapTo : snap.snapTo === "labels" ? _getClosestLabel(animation) : snap.snapTo === "labelsDirectional" ? _getLabelAtDirection(animation) : snap.directional !== false ? function(value, st) {
                return _snapDirectional(snap.snapTo)(value, _getTime() - lastRefresh < 500 ? 0 : st.direction);
            } : gsap.utils.snap(snap.snapTo);
            snapDurClamp = snap.duration || {
                min: 0.1,
                max: 2
            };
            snapDurClamp = _isObject(snapDurClamp) ? _clamp(snapDurClamp.min, snapDurClamp.max) : _clamp(snapDurClamp, snapDurClamp);
            snapDelayedCall = gsap.delayedCall(snap.delay || scrubSmooth / 2 || 0.1, function() {
                var scroll = scrollFunc(), refreshedRecently = _getTime() - lastRefresh < 500, tween = tweenTo.tween;
                if ((refreshedRecently || Math.abs(self.getVelocity()) < 10) && !tween && !_pointerIsDown && lastSnap !== scroll) {
                    var progress = (scroll - start) / change, totalProgress = animation && !isToggle ? animation.totalProgress() : progress, velocity = refreshedRecently ? 0 : (totalProgress - snap2) / (_getTime() - _time2) * 1000 || 0, change1 = gsap.utils.clamp(-progress, 1 - progress, _abs(velocity / 2) * velocity / 0.185), naturalEnd = progress + (snap.inertia === false ? 0 : change1), endValue, endScroll, _snap = snap, onStart = _snap.onStart, _onInterrupt = _snap.onInterrupt, _onComplete = _snap.onComplete;
                    endValue = snapFunc(naturalEnd, self);
                    _isNumber(endValue) || (endValue = naturalEnd); // in case the function didn't return a number, fall back to using the naturalEnd
                    endScroll = Math.max(0, Math.round(start + endValue * change));
                    if (scroll <= end && scroll >= start && endScroll !== scroll) {
                        if (tween && !tween._initted && tween.data <= _abs(endScroll - scroll)) // there's an overlapping snap! So we must figure out which one is closer and let that tween live.
                        return;
                        if (snap.inertia === false) change1 = endValue - progress;
                        tweenTo(endScroll, {
                            duration: snapDurClamp(_abs(Math.max(_abs(naturalEnd - totalProgress), _abs(endValue - totalProgress)) * 0.185 / velocity / 0.05 || 0)),
                            ease: snap.ease || "power3",
                            data: _abs(endScroll - scroll),
                            // record the distance so that if another snap tween occurs (conflict) we can prioritize the closest snap.
                            onInterrupt: function onInterrupt() {
                                return snapDelayedCall.restart(true) && _onInterrupt && _onInterrupt(self);
                            },
                            onComplete: function onComplete() {
                                self.update();
                                lastSnap = scrollFunc();
                                if (animation && !isToggle) // the resolution of the scrollbar is limited, so we should correct the scrubbed animation's playhead at the end to match EXACTLY where it was supposed to snap
                                scrubTween ? scrubTween.resetTo("totalProgress", endValue, animation._tTime / animation._tDur) : animation.progress(endValue);
                                snap1 = snap2 = animation && !isToggle ? animation.totalProgress() : self.progress;
                                onSnapComplete && onSnapComplete(self);
                                _onComplete && _onComplete(self);
                            }
                        }, scroll, change1 * change, endScroll - scroll - change1 * change);
                        onStart && onStart(self, tweenTo.tween);
                    }
                } else if (self.isActive && lastSnap !== scroll) snapDelayedCall.restart(true);
            }).pause();
        }
        id && (_ids[id] = self);
        trigger = self.trigger = (0, _observerJs._getTarget)(trigger || pin !== true && pin); // if a trigger has some kind of scroll-related effect applied that could contaminate the "y" or "x" position (like a ScrollSmoother effect), we needed a way to temporarily revert it, so we use the stRevert property of the gsCache. It can return another function that we'll call at the end so it can return to its normal state.
        customRevertReturn = trigger && trigger._gsap && trigger._gsap.stRevert;
        customRevertReturn && (customRevertReturn = customRevertReturn(self));
        pin = pin === true ? trigger : (0, _observerJs._getTarget)(pin);
        _isString(toggleClass) && (toggleClass = {
            targets: trigger,
            className: toggleClass
        });
        if (pin) {
            pinSpacing === false || pinSpacing === _margin || (pinSpacing = !pinSpacing && pin.parentNode && pin.parentNode.style && _getComputedStyle(pin.parentNode).display === "flex" ? false : _padding); // if the parent is display: flex, don't apply pinSpacing by default. We should check that pin.parentNode is an element (not shadow dom window)
            self.pin = pin;
            pinCache = gsap.core.getCache(pin);
            if (!pinCache.spacer) {
                // record the spacer and pinOriginalState on the cache in case someone tries pinning the same element with MULTIPLE ScrollTriggers - we don't want to have multiple spacers or record the "original" pin state after it has already been affected by another ScrollTrigger.
                if (pinSpacer) {
                    pinSpacer = (0, _observerJs._getTarget)(pinSpacer);
                    pinSpacer && !pinSpacer.nodeType && (pinSpacer = pinSpacer.current || pinSpacer.nativeElement); // for React & Angular
                    pinCache.spacerIsNative = !!pinSpacer;
                    pinSpacer && (pinCache.spacerState = _getState(pinSpacer));
                }
                pinCache.spacer = spacer = pinSpacer || _doc.createElement("div");
                spacer.classList.add("pin-spacer");
                id && spacer.classList.add("pin-spacer-" + id);
                pinCache.pinState = pinOriginalState = _getState(pin);
            } else pinOriginalState = pinCache.pinState;
            vars.force3D !== false && gsap.set(pin, {
                force3D: true
            });
            self.spacer = spacer = pinCache.spacer;
            cs = _getComputedStyle(pin);
            spacingStart = cs[pinSpacing + direction.os2];
            pinGetter = gsap.getProperty(pin);
            pinSetter = gsap.quickSetter(pin, direction.a, _px); // pin.firstChild && !_maxScroll(pin, direction) && (pin.style.overflow = "hidden"); // protects from collapsing margins, but can have unintended consequences as demonstrated here: https://codepen.io/GreenSock/pen/1e42c7a73bfa409d2cf1e184e7a4248d so it was removed in favor of just telling people to set up their CSS to avoid the collapsing margins (overflow: hidden | auto is just one option. Another is border-top: 1px solid transparent).
            _swapPinIn(pin, spacer, cs);
            pinState = _getState(pin);
        }
        if (markers) {
            markerVars = _isObject(markers) ? _setDefaults(markers, _markerDefaults) : _markerDefaults;
            markerStartTrigger = _createMarker("scroller-start", id, scroller, direction, markerVars, 0);
            markerEndTrigger = _createMarker("scroller-end", id, scroller, direction, markerVars, 0, markerStartTrigger);
            offset = markerStartTrigger["offset" + direction.op.d2];
            var content = (0, _observerJs._getTarget)((0, _observerJs._getProxyProp)(scroller, "content") || scroller);
            markerStart = this.markerStart = _createMarker("start", id, content, direction, markerVars, offset, 0, containerAnimation);
            markerEnd = this.markerEnd = _createMarker("end", id, content, direction, markerVars, offset, 0, containerAnimation);
            containerAnimation && (caMarkerSetter = gsap.quickSetter([
                markerStart,
                markerEnd
            ], direction.a, _px));
            if (!useFixedPosition && !((0, _observerJs._proxies).length && (0, _observerJs._getProxyProp)(scroller, "fixedMarkers") === true)) {
                _makePositionable(isViewport ? _body : scroller);
                gsap.set([
                    markerStartTrigger,
                    markerEndTrigger
                ], {
                    force3D: true
                });
                markerStartSetter = gsap.quickSetter(markerStartTrigger, direction.a, _px);
                markerEndSetter = gsap.quickSetter(markerEndTrigger, direction.a, _px);
            }
        }
        if (containerAnimation) {
            var oldOnUpdate = containerAnimation.vars.onUpdate, oldParams = containerAnimation.vars.onUpdateParams;
            containerAnimation.eventCallback("onUpdate", function() {
                self.update(0, 0, 1);
                oldOnUpdate && oldOnUpdate.apply(containerAnimation, oldParams || []);
            });
        }
        self.previous = function() {
            return _triggers[_triggers.indexOf(self) - 1];
        };
        self.next = function() {
            return _triggers[_triggers.indexOf(self) + 1];
        };
        self.revert = function(revert, temp) {
            if (!temp) return self.kill(true);
             // for compatibility with gsap.context() and gsap.matchMedia() which call revert()
            var r = revert !== false || !self.enabled, prevRefreshing = _refreshing;
            if (r !== self.isReverted) {
                if (r) {
                    prevScroll = Math.max(scrollFunc(), self.scroll.rec || 0); // record the scroll so we can revert later (repositioning/pinning things can affect scroll position). In the static refresh() method, we first record all the scroll positions as a reference.
                    prevProgress = self.progress;
                    prevAnimProgress = animation && animation.progress();
                }
                markerStart && [
                    markerStart,
                    markerEnd,
                    markerStartTrigger,
                    markerEndTrigger
                ].forEach(function(m) {
                    return m.style.display = r ? "none" : "block";
                });
                if (r) {
                    _refreshing = self;
                    self.update(r); // make sure the pin is back in its original position so that all the measurements are correct. do this BEFORE swapping the pin out
                }
                if (pin && (!pinReparent || !self.isActive)) {
                    if (r) _swapPinOut(pin, spacer, pinOriginalState);
                    else _swapPinIn(pin, spacer, _getComputedStyle(pin), spacerState);
                }
                r || self.update(r); // when we're restoring, the update should run AFTER swapping the pin into its pin-spacer.
                _refreshing = prevRefreshing; // restore. We set it to true during the update() so that things fire properly in there.
                self.isReverted = r;
            }
        };
        self.refresh = function(soft, force, position, pinOffset) {
            // position is typically only defined if it's coming from setPositions() - it's a way to skip the normal parsing. pinOffset is also only from setPositions() and is mostly related to fancy stuff we need to do in ScrollSmoother with effects
            if ((_refreshing || !self.enabled) && !force) return;
            if (pin && soft && _lastScrollTime) {
                _addListener(ScrollTrigger, "scrollEnd", _softRefresh);
                return;
            }
            !_refreshingAll && onRefreshInit && onRefreshInit(self);
            _refreshing = self;
            if (tweenTo.tween && !position) {
                // we skip this if a position is passed in because typically that's from .setPositions() and it's best to allow in-progress snapping to continue.
                tweenTo.tween.kill();
                tweenTo.tween = 0;
            }
            scrubTween && scrubTween.pause();
            if (invalidateOnRefresh && animation) {
                animation.revert({
                    kill: false
                }).invalidate();
                animation.getChildren ? animation.getChildren(true, true, false).forEach(function(t) {
                    return t.vars.immediateRender && t.render(0, true, true);
                }) : animation.vars.immediateRender && animation.render(0, true, true); // any from() or fromTo() tweens should render immediately (well, unless they have immediateRender: false)
            }
            self.isReverted || self.revert(true, true);
            self._subPinOffset = false; // we'll set this to true in the sub-pins if we find any
            var size = getScrollerSize(), scrollerBounds = getScrollerOffsets(), max = containerAnimation ? containerAnimation.duration() : _maxScroll(scroller, direction), isFirstRefresh = change <= 0.01 || !change, offset = 0, otherPinOffset = pinOffset || 0, parsedEnd = _isObject(position) ? position.end : vars.end, parsedEndTrigger = vars.endTrigger || trigger, parsedStart = _isObject(position) ? position.start : vars.start || (vars.start === 0 || !trigger ? 0 : pin ? "0 0" : "0 100%"), pinnedContainer = self.pinnedContainer = vars.pinnedContainer && (0, _observerJs._getTarget)(vars.pinnedContainer, self), triggerIndex = trigger && Math.max(0, _triggers.indexOf(self)) || 0, i = triggerIndex, cs, bounds, scroll, isVertical, override, curTrigger, curPin, oppositeScroll, initted, revertedPins, forcedOverflow, markerStartOffset, markerEndOffset;
            if (markers && _isObject(position)) {
                // if we alter the start/end positions with .setPositions(), it generally feeds in absolute NUMBERS which don't convey information about where to line up the markers, so to keep it intuitive, we record how far the trigger positions shift after applying the new numbers and then offset by that much in the opposite direction. We do the same to the associated trigger markers too of course.
                markerStartOffset = gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset = gsap.getProperty(markerEndTrigger, direction.p);
            }
            while(i-- > 0){
                // user might try to pin the same element more than once, so we must find any prior triggers with the same pin, revert them, and determine how long they're pinning so that we can offset things appropriately. Make sure we revert from last to first so that things "rewind" properly.
                curTrigger = _triggers[i];
                curTrigger.end || curTrigger.refresh(0, 1) || (_refreshing = self); // if it's a timeline-based trigger that hasn't been fully initialized yet because it's waiting for 1 tick, just force the refresh() here, otherwise if it contains a pin that's supposed to affect other ScrollTriggers further down the page, they won't be adjusted properly.
                curPin = curTrigger.pin;
                if (curPin && (curPin === trigger || curPin === pin || curPin === pinnedContainer) && !curTrigger.isReverted) {
                    revertedPins || (revertedPins = []);
                    revertedPins.unshift(curTrigger); // we'll revert from first to last to make sure things reach their end state properly
                    curTrigger.revert(true, true);
                }
                if (curTrigger !== _triggers[i]) {
                    // in case it got removed.
                    triggerIndex--;
                    i--;
                }
            }
            _isFunction(parsedStart) && (parsedStart = parsedStart(self));
            parsedStart = _parseClamp(parsedStart, "start", self);
            start = _parsePosition(parsedStart, trigger, size, direction, scrollFunc(), markerStart, markerStartTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._startClamp && "_startClamp") || (pin ? -0.001 : 0);
            _isFunction(parsedEnd) && (parsedEnd = parsedEnd(self));
            if (_isString(parsedEnd) && !parsedEnd.indexOf("+=")) {
                if (~parsedEnd.indexOf(" ")) parsedEnd = (_isString(parsedStart) ? parsedStart.split(" ")[0] : "") + parsedEnd;
                else {
                    offset = _offsetToPx(parsedEnd.substr(2), size);
                    parsedEnd = _isString(parsedStart) ? parsedStart : (containerAnimation ? gsap.utils.mapRange(0, containerAnimation.duration(), containerAnimation.scrollTrigger.start, containerAnimation.scrollTrigger.end, start) : start) + offset; // _parsePosition won't factor in the offset if the start is a number, so do it here.
                    parsedEndTrigger = trigger;
                }
            }
            parsedEnd = _parseClamp(parsedEnd, "end", self);
            end = Math.max(start, _parsePosition(parsedEnd || (parsedEndTrigger ? "100% 0" : max), parsedEndTrigger, size, direction, scrollFunc() + offset, markerEnd, markerEndTrigger, self, scrollerBounds, borderWidth, useFixedPosition, max, containerAnimation, self._endClamp && "_endClamp")) || -0.001;
            offset = 0;
            i = triggerIndex;
            while(i--){
                curTrigger = _triggers[i] || {};
                curPin = curTrigger.pin;
                if (curPin && curTrigger.start - curTrigger._pinPush <= start && !containerAnimation && curTrigger.end > 0) {
                    cs = curTrigger.end - (self._startClamp ? Math.max(0, curTrigger.start) : curTrigger.start);
                    if ((curPin === trigger && curTrigger.start - curTrigger._pinPush < start || curPin === pinnedContainer) && isNaN(parsedStart)) // numeric start values shouldn't be offset at all - treat them as absolute
                    offset += cs * (1 - curTrigger.progress);
                    curPin === pin && (otherPinOffset += cs);
                }
            }
            start += offset;
            end += offset;
            self._startClamp && (self._startClamp += offset);
            if (self._endClamp && !_refreshingAll) {
                self._endClamp = end || -0.001;
                end = Math.min(end, _maxScroll(scroller, direction));
            }
            change = end - start || (start -= 0.01) && 0.001;
            if (isFirstRefresh) // on the very first refresh(), the prevProgress couldn't have been accurate yet because the start/end were never calculated, so we set it here. Before 3.11.5, it could lead to an inaccurate scroll position restoration with snapping.
            prevProgress = gsap.utils.clamp(0, 1, gsap.utils.normalize(start, end, prevScroll));
            self._pinPush = otherPinOffset;
            if (markerStart && offset) {
                // offset the markers if necessary
                cs = {};
                cs[direction.a] = "+=" + offset;
                pinnedContainer && (cs[direction.p] = "-=" + scrollFunc());
                gsap.set([
                    markerStart,
                    markerEnd
                ], cs);
            }
            if (pin && !(_clampingMax && self.end >= _maxScroll(scroller, direction))) {
                cs = _getComputedStyle(pin);
                isVertical = direction === (0, _observerJs._vertical);
                scroll = scrollFunc(); // recalculate because the triggers can affect the scroll
                pinStart = parseFloat(pinGetter(direction.a)) + otherPinOffset;
                if (!max && end > 1) {
                    // makes sure the scroller has a scrollbar, otherwise if something has width: 100%, for example, it would be too big (exclude the scrollbar). See https://gsap.com/forums/topic/25182-scrolltrigger-width-of-page-increase-where-markers-are-set-to-false/
                    forcedOverflow = (isViewport ? _doc.scrollingElement || _docEl : scroller).style;
                    forcedOverflow = {
                        style: forcedOverflow,
                        value: forcedOverflow["overflow" + direction.a.toUpperCase()]
                    };
                    if (isViewport && _getComputedStyle(_body)["overflow" + direction.a.toUpperCase()] !== "scroll") // avoid an extra scrollbar if BOTH <html> and <body> have overflow set to "scroll"
                    forcedOverflow.style["overflow" + direction.a.toUpperCase()] = "scroll";
                }
                _swapPinIn(pin, spacer, cs);
                pinState = _getState(pin); // transforms will interfere with the top/left/right/bottom placement, so remove them temporarily. getBoundingClientRect() factors in transforms.
                bounds = _getBounds(pin, true);
                oppositeScroll = useFixedPosition && (0, _observerJs._getScrollFunc)(scroller, isVertical ? (0, _observerJs._horizontal) : (0, _observerJs._vertical))();
                if (pinSpacing) {
                    spacerState = [
                        pinSpacing + direction.os2,
                        change + otherPinOffset + _px
                    ];
                    spacerState.t = spacer;
                    i = pinSpacing === _padding ? _getSize(pin, direction) + change + otherPinOffset : 0;
                    if (i) {
                        spacerState.push(direction.d, i + _px); // for box-sizing: border-box (must include padding).
                        spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + _px);
                    }
                    _setState(spacerState);
                    if (pinnedContainer) // in ScrollTrigger.refresh(), we need to re-evaluate the pinContainer's size because this pinSpacing may stretch it out, but we can't just add the exact distance because depending on layout, it may not push things down or it may only do so partially.
                    _triggers.forEach(function(t) {
                        if (t.pin === pinnedContainer && t.vars.pinSpacing !== false) t._subPinOffset = true;
                    });
                    useFixedPosition && scrollFunc(prevScroll);
                } else {
                    i = _getSize(pin, direction);
                    i && spacer.style.flexBasis !== "auto" && (spacer.style.flexBasis = i + _px);
                }
                if (useFixedPosition) {
                    override = {
                        top: bounds.top + (isVertical ? scroll - start : oppositeScroll) + _px,
                        left: bounds.left + (isVertical ? oppositeScroll : scroll - start) + _px,
                        boxSizing: "border-box",
                        position: "fixed"
                    };
                    override[_width] = override["max" + _Width] = Math.ceil(bounds.width) + _px;
                    override[_height] = override["max" + _Height] = Math.ceil(bounds.height) + _px;
                    override[_margin] = override[_margin + _Top] = override[_margin + _Right] = override[_margin + _Bottom] = override[_margin + _Left] = "0";
                    override[_padding] = cs[_padding];
                    override[_padding + _Top] = cs[_padding + _Top];
                    override[_padding + _Right] = cs[_padding + _Right];
                    override[_padding + _Bottom] = cs[_padding + _Bottom];
                    override[_padding + _Left] = cs[_padding + _Left];
                    pinActiveState = _copyState(pinOriginalState, override, pinReparent);
                    _refreshingAll && scrollFunc(0);
                }
                if (animation) {
                    // the animation might be affecting the transform, so we must jump to the end, check the value, and compensate accordingly. Otherwise, when it becomes unpinned, the pinSetter() will get set to a value that doesn't include whatever the animation did.
                    initted = animation._initted; // if not, we must invalidate() after this step, otherwise it could lock in starting values prematurely.
                    _suppressOverwrites(1);
                    animation.render(animation.duration(), true, true);
                    pinChange = pinGetter(direction.a) - pinStart + change + otherPinOffset;
                    pinMoves = Math.abs(change - pinChange) > 1;
                    useFixedPosition && pinMoves && pinActiveState.splice(pinActiveState.length - 2, 2); // transform is the last property/value set in the state Array. Since the animation is controlling that, we should omit it.
                    animation.render(0, true, true);
                    initted || animation.invalidate(true);
                    animation.parent || animation.totalTime(animation.totalTime()); // if, for example, a toggleAction called play() and then refresh() happens and when we render(1) above, it would cause the animation to complete and get removed from its parent, so this makes sure it gets put back in.
                    _suppressOverwrites(0);
                } else pinChange = change;
                forcedOverflow && (forcedOverflow.value ? forcedOverflow.style["overflow" + direction.a.toUpperCase()] = forcedOverflow.value : forcedOverflow.style.removeProperty("overflow-" + direction.a));
            } else if (trigger && scrollFunc() && !containerAnimation) {
                // it may be INSIDE a pinned element, so walk up the tree and look for any elements with _pinOffset to compensate because anything with pinSpacing that's already scrolled would throw off the measurements in getBoundingClientRect()
                bounds = trigger.parentNode;
                while(bounds && bounds !== _body){
                    if (bounds._pinOffset) {
                        start -= bounds._pinOffset;
                        end -= bounds._pinOffset;
                    }
                    bounds = bounds.parentNode;
                }
            }
            revertedPins && revertedPins.forEach(function(t) {
                return t.revert(false, true);
            });
            self.start = start;
            self.end = end;
            scroll1 = scroll2 = _refreshingAll ? prevScroll : scrollFunc(); // reset velocity
            if (!containerAnimation && !_refreshingAll) {
                scroll1 < prevScroll && scrollFunc(prevScroll);
                self.scroll.rec = 0;
            }
            self.revert(false, true);
            lastRefresh = _getTime();
            if (snapDelayedCall) {
                lastSnap = -1; // just so snapping gets re-enabled, clear out any recorded last value
                // self.isActive && scrollFunc(start + change * prevProgress); // previously this line was here to ensure that when snapping kicks in, it's from the previous progress but in some cases that's not desirable, like an all-page ScrollTrigger when new content gets added to the page, that'd totally change the progress.
                snapDelayedCall.restart(true);
            }
            _refreshing = 0;
            animation && isToggle && (animation._initted || prevAnimProgress) && animation.progress() !== prevAnimProgress && animation.progress(prevAnimProgress || 0, true).render(animation.time(), true, true); // must force a re-render because if saveStyles() was used on the target(s), the styles could have been wiped out during the refresh().
            if (isFirstRefresh || prevProgress !== self.progress || containerAnimation || invalidateOnRefresh || animation && !animation._initted) {
                // ensures that the direction is set properly (when refreshing, progress is set back to 0 initially, then back again to wherever it needs to be) and that callbacks are triggered.
                animation && !isToggle && (animation._initted || prevProgress || animation.vars.immediateRender !== false) && animation.totalProgress(containerAnimation && start < -0.001 && !prevProgress ? gsap.utils.normalize(start, end, 0) : prevProgress, true); // to avoid issues where animation callbacks like onStart aren't triggered.
                self.progress = isFirstRefresh || (scroll1 - start) / change === prevProgress ? 0 : prevProgress;
            }
            pin && pinSpacing && (spacer._pinOffset = Math.round(self.progress * pinChange));
            scrubTween && scrubTween.invalidate();
            if (!isNaN(markerStartOffset)) {
                // numbers were passed in for the position which are absolute, so instead of just putting the markers at the very bottom of the viewport, we figure out how far they shifted down (it's safe to assume they were originally positioned in closer relation to the trigger element with values like "top", "center", a percentage or whatever, so we offset that much in the opposite direction to basically revert them to the relative position thy were at previously.
                markerStartOffset -= gsap.getProperty(markerStartTrigger, direction.p);
                markerEndOffset -= gsap.getProperty(markerEndTrigger, direction.p);
                _shiftMarker(markerStartTrigger, direction, markerStartOffset);
                _shiftMarker(markerStart, direction, markerStartOffset - (pinOffset || 0));
                _shiftMarker(markerEndTrigger, direction, markerEndOffset);
                _shiftMarker(markerEnd, direction, markerEndOffset - (pinOffset || 0));
            }
            isFirstRefresh && !_refreshingAll && self.update(); // edge case - when you reload a page when it's already scrolled down, some browsers fire a "scroll" event before DOMContentLoaded, triggering an updateAll(). If we don't update the self.progress as part of refresh(), then when it happens next, it may record prevProgress as 0 when it really shouldn't, potentially causing a callback in an animation to fire again.
            if (onRefresh && !_refreshingAll && !executingOnRefresh) {
                // when refreshing all, we do extra work to correct pinnedContainer sizes and ensure things don't exceed the maxScroll, so we should do all the refreshes at the end after all that work so that the start/end values are corrected.
                executingOnRefresh = true;
                onRefresh(self);
                executingOnRefresh = false;
            }
        };
        self.getVelocity = function() {
            return (scrollFunc() - scroll2) / (_getTime() - _time2) * 1000 || 0;
        };
        self.endAnimation = function() {
            _endAnimation(self.callbackAnimation);
            if (animation) scrubTween ? scrubTween.progress(1) : !animation.paused() ? _endAnimation(animation, animation.reversed()) : isToggle || _endAnimation(animation, self.direction < 0, 1);
        };
        self.labelToScroll = function(label) {
            return animation && animation.labels && (start || self.refresh() || start) + animation.labels[label] / animation.duration() * change || 0;
        };
        self.getTrailing = function(name) {
            var i = _triggers.indexOf(self), a = self.direction > 0 ? _triggers.slice(0, i).reverse() : _triggers.slice(i + 1);
            return (_isString(name) ? a.filter(function(t) {
                return t.vars.preventOverlaps === name;
            }) : a).filter(function(t) {
                return self.direction > 0 ? t.end <= start : t.start >= end;
            });
        };
        self.update = function(reset, recordVelocity, forceFake) {
            if (containerAnimation && !forceFake && !reset) return;
            var scroll = _refreshingAll === true ? prevScroll : self.scroll(), p = reset ? 0 : (scroll - start) / change, clipped = p < 0 ? 0 : p > 1 ? 1 : p || 0, prevProgress = self.progress, isActive, wasActive, toggleState, action, stateChanged, toggled, isAtMax, isTakingAction;
            if (recordVelocity) {
                scroll2 = scroll1;
                scroll1 = containerAnimation ? scrollFunc() : scroll;
                if (snap) {
                    snap2 = snap1;
                    snap1 = animation && !isToggle ? animation.totalProgress() : clipped;
                }
            } // anticipate the pinning a few ticks ahead of time based on velocity to avoid a visual glitch due to the fact that most browsers do scrolling on a separate thread (not synced with requestAnimationFrame).
            if (anticipatePin && pin && !_refreshing && !_startup && _lastScrollTime) {
                if (!clipped && start < scroll + (scroll - scroll2) / (_getTime() - _time2) * anticipatePin) clipped = 0.0001;
                else if (clipped === 1 && end > scroll + (scroll - scroll2) / (_getTime() - _time2) * anticipatePin) clipped = 0.9999;
            }
            if (clipped !== prevProgress && self.enabled) {
                isActive = self.isActive = !!clipped && clipped < 1;
                wasActive = !!prevProgress && prevProgress < 1;
                toggled = isActive !== wasActive;
                stateChanged = toggled || !!clipped !== !!prevProgress; // could go from start all the way to end, thus it didn't toggle but it did change state in a sense (may need to fire a callback)
                self.direction = clipped > prevProgress ? 1 : -1;
                self.progress = clipped;
                if (stateChanged && !_refreshing) {
                    toggleState = clipped && !prevProgress ? 0 : clipped === 1 ? 1 : prevProgress === 1 ? 2 : 3; // 0 = enter, 1 = leave, 2 = enterBack, 3 = leaveBack (we prioritize the FIRST encounter, thus if you scroll really fast past the onEnter and onLeave in one tick, it'd prioritize onEnter.
                    if (isToggle) {
                        action = !toggled && toggleActions[toggleState + 1] !== "none" && toggleActions[toggleState + 1] || toggleActions[toggleState]; // if it didn't toggle, that means it shot right past and since we prioritize the "enter" action, we should switch to the "leave" in this case (but only if one is defined)
                        isTakingAction = animation && (action === "complete" || action === "reset" || action in animation);
                    }
                }
                preventOverlaps && (toggled || isTakingAction) && (isTakingAction || scrub || !animation) && (_isFunction(preventOverlaps) ? preventOverlaps(self) : self.getTrailing(preventOverlaps).forEach(function(t) {
                    return t.endAnimation();
                }));
                if (!isToggle) {
                    if (scrubTween && !_refreshing && !_startup) {
                        scrubTween._dp._time - scrubTween._start !== scrubTween._time && scrubTween.render(scrubTween._dp._time - scrubTween._start); // if there's a scrub on both the container animation and this one (or a ScrollSmoother), the update order would cause this one not to have rendered yet, so it wouldn't make any progress before we .restart() it heading toward the new progress so it'd appear stuck thus we force a render here.
                        if (scrubTween.resetTo) scrubTween.resetTo("totalProgress", clipped, animation._tTime / animation._tDur);
                        else {
                            // legacy support (courtesy), before 3.10.0
                            scrubTween.vars.totalProgress = clipped;
                            scrubTween.invalidate().restart();
                        }
                    } else if (animation) animation.totalProgress(clipped, !!(_refreshing && (lastRefresh || reset)));
                }
                if (pin) {
                    reset && pinSpacing && (spacer.style[pinSpacing + direction.os2] = spacingStart);
                    if (!useFixedPosition) pinSetter(_round(pinStart + pinChange * clipped));
                    else if (stateChanged) {
                        isAtMax = !reset && clipped > prevProgress && end + 1 > scroll && scroll + 1 >= _maxScroll(scroller, direction); // if it's at the VERY end of the page, don't switch away from position: fixed because it's pointless and it could cause a brief flash when the user scrolls back up (when it gets pinned again)
                        if (pinReparent) {
                            if (!reset && (isActive || isAtMax)) {
                                var bounds = _getBounds(pin, true), _offset = scroll - start;
                                _reparent(pin, _body, bounds.top + (direction === (0, _observerJs._vertical) ? _offset : 0) + _px, bounds.left + (direction === (0, _observerJs._vertical) ? 0 : _offset) + _px);
                            } else _reparent(pin, spacer);
                        }
                        _setState(isActive || isAtMax ? pinActiveState : pinState);
                        pinMoves && clipped < 1 && isActive || pinSetter(pinStart + (clipped === 1 && !isAtMax ? pinChange : 0));
                    }
                }
                snap && !tweenTo.tween && !_refreshing && !_startup && snapDelayedCall.restart(true);
                toggleClass && (toggled || once && clipped && (clipped < 1 || !_limitCallbacks)) && _toArray(toggleClass.targets).forEach(function(el) {
                    return el.classList[isActive || once ? "add" : "remove"](toggleClass.className);
                }); // classes could affect positioning, so do it even if reset or refreshing is true.
                onUpdate && !isToggle && !reset && onUpdate(self);
                if (stateChanged && !_refreshing) {
                    if (isToggle) {
                        if (isTakingAction) {
                            if (action === "complete") animation.pause().totalProgress(1);
                            else if (action === "reset") animation.restart(true).pause();
                            else if (action === "restart") animation.restart(true);
                            else animation[action]();
                        }
                        onUpdate && onUpdate(self);
                    }
                    if (toggled || !_limitCallbacks) {
                        // on startup, the page could be scrolled and we don't want to fire callbacks that didn't toggle. For example onEnter shouldn't fire if the ScrollTrigger isn't actually entered.
                        onToggle && toggled && _callback(self, onToggle);
                        callbacks[toggleState] && _callback(self, callbacks[toggleState]);
                        once && (clipped === 1 ? self.kill(false, 1) : callbacks[toggleState] = 0); // a callback shouldn't be called again if once is true.
                        if (!toggled) {
                            // it's possible to go completely past, like from before the start to after the end (or vice-versa) in which case BOTH callbacks should be fired in that order
                            toggleState = clipped === 1 ? 1 : 3;
                            callbacks[toggleState] && _callback(self, callbacks[toggleState]);
                        }
                    }
                    if (fastScrollEnd && !isActive && Math.abs(self.getVelocity()) > (_isNumber(fastScrollEnd) ? fastScrollEnd : 2500)) {
                        _endAnimation(self.callbackAnimation);
                        scrubTween ? scrubTween.progress(1) : _endAnimation(animation, action === "reverse" ? 1 : !clipped, 1);
                    }
                } else if (isToggle && onUpdate && !_refreshing) onUpdate(self);
            } // update absolutely-positioned markers (only if the scroller isn't the viewport)
            if (markerEndSetter) {
                var n = containerAnimation ? scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0) : scroll;
                markerStartSetter(n + (markerStartTrigger._isFlipped ? 1 : 0));
                markerEndSetter(n);
            }
            caMarkerSetter && caMarkerSetter(-scroll / containerAnimation.duration() * (containerAnimation._caScrollDist || 0));
        };
        self.enable = function(reset, refresh) {
            if (!self.enabled) {
                self.enabled = true;
                _addListener(scroller, "resize", _onResize);
                isViewport || _addListener(scroller, "scroll", _onScroll);
                onRefreshInit && _addListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (reset !== false) {
                    self.progress = prevProgress = 0;
                    scroll1 = scroll2 = lastSnap = scrollFunc();
                }
                refresh !== false && self.refresh();
            }
        };
        self.getTween = function(snap) {
            return snap && tweenTo ? tweenTo.tween : scrubTween;
        };
        self.setPositions = function(newStart, newEnd, keepClamp, pinOffset) {
            // doesn't persist after refresh()! Intended to be a way to override values that were set during refresh(), like you could set it in onRefresh()
            if (containerAnimation) {
                // convert ratios into scroll positions. Remember, start/end values on ScrollTriggers that have a containerAnimation refer to the time (in seconds), NOT scroll positions.
                var st = containerAnimation.scrollTrigger, duration = containerAnimation.duration(), _change = st.end - st.start;
                newStart = st.start + _change * newStart / duration;
                newEnd = st.start + _change * newEnd / duration;
            }
            self.refresh(false, false, {
                start: _keepClamp(newStart, keepClamp && !!self._startClamp),
                end: _keepClamp(newEnd, keepClamp && !!self._endClamp)
            }, pinOffset);
            self.update();
        };
        self.adjustPinSpacing = function(amount) {
            if (spacerState && amount) {
                var i = spacerState.indexOf(direction.d) + 1;
                spacerState[i] = parseFloat(spacerState[i]) + amount + _px;
                spacerState[1] = parseFloat(spacerState[1]) + amount + _px;
                _setState(spacerState);
            }
        };
        self.disable = function(reset, allowAnimation) {
            reset !== false && self.revert(true, true);
            if (self.enabled) {
                self.enabled = self.isActive = false;
                allowAnimation || scrubTween && scrubTween.pause();
                prevScroll = 0;
                pinCache && (pinCache.uncache = 1);
                onRefreshInit && _removeListener(ScrollTrigger, "refreshInit", onRefreshInit);
                if (snapDelayedCall) {
                    snapDelayedCall.pause();
                    tweenTo.tween && tweenTo.tween.kill() && (tweenTo.tween = 0);
                }
                if (!isViewport) {
                    var i = _triggers.length;
                    while(i--){
                        if (_triggers[i].scroller === scroller && _triggers[i] !== self) return; //don't remove the listeners if there are still other triggers referencing it.
                    }
                    _removeListener(scroller, "resize", _onResize);
                    isViewport || _removeListener(scroller, "scroll", _onScroll);
                }
            }
        };
        self.kill = function(revert, allowAnimation) {
            self.disable(revert, allowAnimation);
            scrubTween && !allowAnimation && scrubTween.kill();
            id && delete _ids[id];
            var i = _triggers.indexOf(self);
            i >= 0 && _triggers.splice(i, 1);
            i === _i && _direction > 0 && _i--; // if we're in the middle of a refresh() or update(), splicing would cause skips in the index, so adjust...
            // if no other ScrollTrigger instances of the same scroller are found, wipe out any recorded scroll position. Otherwise, in a single page application, for example, it could maintain scroll position when it really shouldn't.
            i = 0;
            _triggers.forEach(function(t) {
                return t.scroller === self.scroller && (i = 1);
            });
            i || _refreshingAll || (self.scroll.rec = 0);
            if (animation) {
                animation.scrollTrigger = null;
                revert && animation.revert({
                    kill: false
                });
                allowAnimation || animation.kill();
            }
            markerStart && [
                markerStart,
                markerEnd,
                markerStartTrigger,
                markerEndTrigger
            ].forEach(function(m) {
                return m.parentNode && m.parentNode.removeChild(m);
            });
            _primary === self && (_primary = 0);
            if (pin) {
                pinCache && (pinCache.uncache = 1);
                i = 0;
                _triggers.forEach(function(t) {
                    return t.pin === pin && i++;
                });
                i || (pinCache.spacer = 0); // if there aren't any more ScrollTriggers with the same pin, remove the spacer, otherwise it could be contaminated with old/stale values if the user re-creates a ScrollTrigger for the same element.
            }
            vars.onKill && vars.onKill(self);
        };
        _triggers.push(self);
        self.enable(false, false);
        customRevertReturn && customRevertReturn(self);
        if (animation && animation.add && !change) {
            // if the animation is a timeline, it may not have been populated yet, so it wouldn't render at the proper place on the first refresh(), thus we should schedule one for the next tick. If "change" is defined, we know it must be re-enabling, thus we can refresh() right away.
            var updateFunc = self.update; // some browsers may fire a scroll event BEFORE a tick elapses and/or the DOMContentLoaded fires. So there's a chance update() will be called BEFORE a refresh() has happened on a Timeline-attached ScrollTrigger which means the start/end won't be calculated yet. We don't want to add conditional logic inside the update() method (like check to see if end is defined and if not, force a refresh()) because that's a function that gets hit a LOT (performance). So we swap out the real update() method for this one that'll re-attach it the first time it gets called and of course forces a refresh().
            self.update = function() {
                self.update = updateFunc;
                (0, _observerJs._scrollers).cache++; // otherwise a cached scroll position may get used in the refresh() in a very rare scenario, like if ScrollTriggers are created inside a DOMContentLoaded event and the queued requestAnimationFrame() fires beforehand. See https://gsap.com/community/forums/topic/41267-scrolltrigger-breaks-on-refresh-when-using-domcontentloaded/
                start || end || self.refresh();
            };
            gsap.delayedCall(0.01, self.update);
            change = 0.01;
            start = end = 0;
        } else self.refresh();
        pin && _queueRefreshAll(); // pinning could affect the positions of other things, so make sure we queue a full refresh()
    };
    ScrollTrigger.register = function register(core) {
        if (!_coreInitted) {
            gsap = core || _getGSAP();
            _windowExists() && window.document && ScrollTrigger.enable();
            _coreInitted = _enabled;
        }
        return _coreInitted;
    };
    ScrollTrigger.defaults = function defaults(config) {
        if (config) for(var p in config)_defaults[p] = config[p];
        return _defaults;
    };
    ScrollTrigger.disable = function disable(reset, kill) {
        _enabled = 0;
        _triggers.forEach(function(trigger) {
            return trigger[kill ? "kill" : "disable"](reset);
        });
        _removeListener(_win, "wheel", _onScroll);
        _removeListener(_doc, "scroll", _onScroll);
        clearInterval(_syncInterval);
        _removeListener(_doc, "touchcancel", _passThrough);
        _removeListener(_body, "touchstart", _passThrough);
        _multiListener(_removeListener, _doc, "pointerdown,touchstart,mousedown", _pointerDownHandler);
        _multiListener(_removeListener, _doc, "pointerup,touchend,mouseup", _pointerUpHandler);
        _resizeDelay.kill();
        _iterateAutoRefresh(_removeListener);
        for(var i = 0; i < (0, _observerJs._scrollers).length; i += 3){
            _wheelListener(_removeListener, (0, _observerJs._scrollers)[i], (0, _observerJs._scrollers)[i + 1]);
            _wheelListener(_removeListener, (0, _observerJs._scrollers)[i], (0, _observerJs._scrollers)[i + 2]);
        }
    };
    ScrollTrigger.enable = function enable() {
        _win = window;
        _doc = document;
        _docEl = _doc.documentElement;
        _body = _doc.body;
        if (gsap) {
            _toArray = gsap.utils.toArray;
            _clamp = gsap.utils.clamp;
            _context = gsap.core.context || _passThrough;
            _suppressOverwrites = gsap.core.suppressOverwrites || _passThrough;
            _scrollRestoration = _win.history.scrollRestoration || "auto";
            _lastScroll = _win.pageYOffset || 0;
            gsap.core.globals("ScrollTrigger", ScrollTrigger); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
            if (_body) {
                _enabled = 1;
                _div100vh = document.createElement("div"); // to solve mobile browser address bar show/hide resizing, we shouldn't rely on window.innerHeight. Instead, use a <div> with its height set to 100vh and measure that since that's what the scrolling is based on anyway and it's not affected by address bar showing/hiding.
                _div100vh.style.height = "100vh";
                _div100vh.style.position = "absolute";
                _refresh100vh();
                _rafBugFix();
                (0, _observerJs.Observer).register(gsap); // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
                ScrollTrigger.isTouch = (0, _observerJs.Observer).isTouch;
                _fixIOSBug = (0, _observerJs.Observer).isTouch && /(iPad|iPhone|iPod|Mac)/g.test(navigator.userAgent); // since 2017, iOS has had a bug that causes event.clientX/Y to be inaccurate when a scroll occurs, thus we must alternate ignoring every other touchmove event to work around it. See https://bugs.webkit.org/show_bug.cgi?id=181954 and https://codepen.io/GreenSock/pen/ExbrPNa/087cef197dc35445a0951e8935c41503
                _ignoreMobileResize = (0, _observerJs.Observer).isTouch === 1;
                _addListener(_win, "wheel", _onScroll); // mostly for 3rd party smooth scrolling libraries.
                _root = [
                    _win,
                    _doc,
                    _docEl,
                    _body
                ];
                if (gsap.matchMedia) {
                    ScrollTrigger.matchMedia = function(vars) {
                        var mm = gsap.matchMedia(), p;
                        for(p in vars)mm.add(p, vars[p]);
                        return mm;
                    };
                    gsap.addEventListener("matchMediaInit", function() {
                        _recordScrollPositions();
                        _revertAll();
                    });
                    gsap.addEventListener("matchMediaRevert", function() {
                        return _revertRecorded();
                    });
                    gsap.addEventListener("matchMedia", function() {
                        _refreshAll(0, 1);
                        _dispatch("matchMedia");
                    });
                    gsap.matchMedia().add("(orientation: portrait)", function() {
                        // when orientation changes, we should take new base measurements for the ignoreMobileResize feature.
                        _setBaseDimensions();
                        return _setBaseDimensions;
                    });
                } else console.warn("Requires GSAP 3.11.0 or later");
                _setBaseDimensions();
                _addListener(_doc, "scroll", _onScroll); // some browsers (like Chrome), the window stops dispatching scroll events on the window if you scroll really fast, but it's consistent on the document!
                var bodyHasStyle = _body.hasAttribute("style"), bodyStyle = _body.style, border = bodyStyle.borderTopStyle, AnimationProto = gsap.core.Animation.prototype, bounds, i;
                AnimationProto.revert || Object.defineProperty(AnimationProto, "revert", {
                    value: function value() {
                        return this.time(-0.01, true);
                    }
                }); // only for backwards compatibility (Animation.revert() was added after 3.10.4)
                bodyStyle.borderTopStyle = "solid"; // works around an issue where a margin of a child element could throw off the bounds of the _body, making it seem like there's a margin when there actually isn't. The border ensures that the bounds are accurate.
                bounds = _getBounds(_body);
                (0, _observerJs._vertical).m = Math.round(bounds.top + (0, _observerJs._vertical).sc()) || 0; // accommodate the offset of the <body> caused by margins and/or padding
                (0, _observerJs._horizontal).m = Math.round(bounds.left + (0, _observerJs._horizontal).sc()) || 0;
                border ? bodyStyle.borderTopStyle = border : bodyStyle.removeProperty("border-top-style");
                if (!bodyHasStyle) {
                    // SSR frameworks like Next.js complain if this attribute gets added.
                    _body.setAttribute("style", ""); // it's not enough to just removeAttribute() - we must first set it to empty, otherwise Next.js complains.
                    _body.removeAttribute("style");
                } // TODO: (?) maybe move to leveraging the velocity mechanism in Observer and skip intervals.
                _syncInterval = setInterval(_sync, 250);
                gsap.delayedCall(0.5, function() {
                    return _startup = 0;
                });
                _addListener(_doc, "touchcancel", _passThrough); // some older Android devices intermittently stop dispatching "touchmove" events if we don't listen for "touchcancel" on the document.
                _addListener(_body, "touchstart", _passThrough); //works around Safari bug: https://gsap.com/forums/topic/21450-draggable-in-iframe-on-mobile-is-buggy/
                _multiListener(_addListener, _doc, "pointerdown,touchstart,mousedown", _pointerDownHandler);
                _multiListener(_addListener, _doc, "pointerup,touchend,mouseup", _pointerUpHandler);
                _transformProp = gsap.utils.checkPrefix("transform");
                _stateProps.push(_transformProp);
                _coreInitted = _getTime();
                _resizeDelay = gsap.delayedCall(0.2, _refreshAll).pause();
                _autoRefresh = [
                    _doc,
                    "visibilitychange",
                    function() {
                        var w = _win.innerWidth, h = _win.innerHeight;
                        if (_doc.hidden) {
                            _prevWidth = w;
                            _prevHeight = h;
                        } else if (_prevWidth !== w || _prevHeight !== h) _onResize();
                    },
                    _doc,
                    "DOMContentLoaded",
                    _refreshAll,
                    _win,
                    "load",
                    _refreshAll,
                    _win,
                    "resize",
                    _onResize
                ];
                _iterateAutoRefresh(_addListener);
                _triggers.forEach(function(trigger) {
                    return trigger.enable(0, 1);
                });
                for(i = 0; i < (0, _observerJs._scrollers).length; i += 3){
                    _wheelListener(_removeListener, (0, _observerJs._scrollers)[i], (0, _observerJs._scrollers)[i + 1]);
                    _wheelListener(_removeListener, (0, _observerJs._scrollers)[i], (0, _observerJs._scrollers)[i + 2]);
                }
            }
        }
    };
    ScrollTrigger.config = function config(vars) {
        "limitCallbacks" in vars && (_limitCallbacks = !!vars.limitCallbacks);
        var ms = vars.syncInterval;
        ms && clearInterval(_syncInterval) || (_syncInterval = ms) && setInterval(_sync, ms);
        "ignoreMobileResize" in vars && (_ignoreMobileResize = ScrollTrigger.isTouch === 1 && vars.ignoreMobileResize);
        if ("autoRefreshEvents" in vars) {
            _iterateAutoRefresh(_removeListener) || _iterateAutoRefresh(_addListener, vars.autoRefreshEvents || "none");
            _ignoreResize = (vars.autoRefreshEvents + "").indexOf("resize") === -1;
        }
    };
    ScrollTrigger.scrollerProxy = function scrollerProxy(target, vars) {
        var t = (0, _observerJs._getTarget)(target), i = (0, _observerJs._scrollers).indexOf(t), isViewport = _isViewport(t);
        if (~i) (0, _observerJs._scrollers).splice(i, isViewport ? 6 : 2);
        if (vars) isViewport ? (0, _observerJs._proxies).unshift(_win, vars, _body, vars, _docEl, vars) : (0, _observerJs._proxies).unshift(t, vars);
    };
    ScrollTrigger.clearMatchMedia = function clearMatchMedia(query) {
        _triggers.forEach(function(t) {
            return t._ctx && t._ctx.query === query && t._ctx.kill(true, true);
        });
    };
    ScrollTrigger.isInViewport = function isInViewport(element, ratio, horizontal) {
        var bounds = (_isString(element) ? (0, _observerJs._getTarget)(element) : element).getBoundingClientRect(), offset = bounds[horizontal ? _width : _height] * ratio || 0;
        return horizontal ? bounds.right - offset > 0 && bounds.left + offset < _win.innerWidth : bounds.bottom - offset > 0 && bounds.top + offset < _win.innerHeight;
    };
    ScrollTrigger.positionInViewport = function positionInViewport(element, referencePoint, horizontal) {
        _isString(element) && (element = (0, _observerJs._getTarget)(element));
        var bounds = element.getBoundingClientRect(), size = bounds[horizontal ? _width : _height], offset = referencePoint == null ? size / 2 : referencePoint in _keywords ? _keywords[referencePoint] * size : ~referencePoint.indexOf("%") ? parseFloat(referencePoint) * size / 100 : parseFloat(referencePoint) || 0;
        return horizontal ? (bounds.left + offset) / _win.innerWidth : (bounds.top + offset) / _win.innerHeight;
    };
    ScrollTrigger.killAll = function killAll(allowListeners) {
        _triggers.slice(0).forEach(function(t) {
            return t.vars.id !== "ScrollSmoother" && t.kill();
        });
        if (allowListeners !== true) {
            var listeners = _listeners.killAll || [];
            _listeners = {};
            listeners.forEach(function(f) {
                return f();
            });
        }
    };
    return ScrollTrigger;
}();
ScrollTrigger.version = "3.14.2";
ScrollTrigger.saveStyles = function(targets) {
    return targets ? _toArray(targets).forEach(function(target) {
        // saved styles are recorded in a consecutive alternating Array, like [element, cssText, transform attribute, cache, matchMedia, ...]
        if (target && target.style) {
            var i = _savedStyles.indexOf(target);
            i >= 0 && _savedStyles.splice(i, 5);
            _savedStyles.push(target, target.style.cssText, target.getBBox && target.getAttribute("transform"), gsap.core.getCache(target), _context());
        }
    }) : _savedStyles;
};
ScrollTrigger.revert = function(soft, media) {
    return _revertAll(!soft, media);
};
ScrollTrigger.create = function(vars, animation) {
    return new ScrollTrigger(vars, animation);
};
ScrollTrigger.refresh = function(safe) {
    return safe ? _onResize(true) : (_coreInitted || ScrollTrigger.register()) && _refreshAll(true);
};
ScrollTrigger.update = function(force) {
    return ++(0, _observerJs._scrollers).cache && _updateAll(force === true ? 2 : 0);
};
ScrollTrigger.clearScrollMemory = _clearScrollMemory;
ScrollTrigger.maxScroll = function(element, horizontal) {
    return _maxScroll(element, horizontal ? (0, _observerJs._horizontal) : (0, _observerJs._vertical));
};
ScrollTrigger.getScrollFunc = function(element, horizontal) {
    return (0, _observerJs._getScrollFunc)((0, _observerJs._getTarget)(element), horizontal ? (0, _observerJs._horizontal) : (0, _observerJs._vertical));
};
ScrollTrigger.getById = function(id) {
    return _ids[id];
};
ScrollTrigger.getAll = function() {
    return _triggers.filter(function(t) {
        return t.vars.id !== "ScrollSmoother";
    });
}; // it's common for people to ScrollTrigger.getAll(t => t.kill()) on page routes, for example, and we don't want it to ruin smooth scrolling by killing the main ScrollSmoother one.
ScrollTrigger.isScrolling = function() {
    return !!_lastScrollTime;
};
ScrollTrigger.snapDirectional = _snapDirectional;
ScrollTrigger.addEventListener = function(type, callback) {
    var a = _listeners[type] || (_listeners[type] = []);
    ~a.indexOf(callback) || a.push(callback);
};
ScrollTrigger.removeEventListener = function(type, callback) {
    var a = _listeners[type], i = a && a.indexOf(callback);
    i >= 0 && a.splice(i, 1);
};
ScrollTrigger.batch = function(targets, vars) {
    var result = [], varsCopy = {}, interval = vars.interval || 0.016, batchMax = vars.batchMax || 1e9, proxyCallback = function proxyCallback(type, callback) {
        var elements = [], triggers = [], delay = gsap.delayedCall(interval, function() {
            callback(elements, triggers);
            elements = [];
            triggers = [];
        }).pause();
        return function(self) {
            elements.length || delay.restart(true);
            elements.push(self.trigger);
            triggers.push(self);
            batchMax <= elements.length && delay.progress(1);
        };
    }, p;
    for(p in vars)varsCopy[p] = p.substr(0, 2) === "on" && _isFunction(vars[p]) && p !== "onRefreshInit" ? proxyCallback(p, vars[p]) : vars[p];
    if (_isFunction(batchMax)) {
        batchMax = batchMax();
        _addListener(ScrollTrigger, "refresh", function() {
            return batchMax = vars.batchMax();
        });
    }
    _toArray(targets).forEach(function(target) {
        var config = {};
        for(p in varsCopy)config[p] = varsCopy[p];
        config.trigger = target;
        result.push(ScrollTrigger.create(config));
    });
    return result;
}; // to reduce file size. clamps the scroll and also returns a duration multiplier so that if the scroll gets chopped shorter, the duration gets curtailed as well (otherwise if you're very close to the top of the page, for example, and swipe up really fast, it'll suddenly slow down and take a long time to reach the top).
var _clampScrollAndGetDurationMultiplier = function _clampScrollAndGetDurationMultiplier(scrollFunc, current, end, max) {
    current > max ? scrollFunc(max) : current < 0 && scrollFunc(0);
    return end > max ? (max - current) / (end - current) : end < 0 ? current / (current - end) : 1;
}, _allowNativePanning = function _allowNativePanning(target, direction) {
    if (direction === true) target.style.removeProperty("touch-action");
    else target.style.touchAction = direction === true ? "auto" : direction ? "pan-" + direction + ((0, _observerJs.Observer).isTouch ? " pinch-zoom" : "") : "none"; // note: Firefox doesn't support it pinch-zoom properly, at least in addition to a pan-x or pan-y.
    target === _docEl && _allowNativePanning(_body, direction);
}, _overflow = {
    auto: 1,
    scroll: 1
}, _nestedScroll = function _nestedScroll(_ref5) {
    var event = _ref5.event, target = _ref5.target, axis = _ref5.axis;
    var node = (event.changedTouches ? event.changedTouches[0] : event).target, cache = node._gsap || gsap.core.getCache(node), time = _getTime(), cs;
    if (!cache._isScrollT || time - cache._isScrollT > 2000) {
        // cache for 2 seconds to improve performance.
        while(node && node !== _body && (node.scrollHeight <= node.clientHeight && node.scrollWidth <= node.clientWidth || !(_overflow[(cs = _getComputedStyle(node)).overflowY] || _overflow[cs.overflowX])))node = node.parentNode;
        cache._isScroll = node && node !== target && !_isViewport(node) && (_overflow[(cs = _getComputedStyle(node)).overflowY] || _overflow[cs.overflowX]);
        cache._isScrollT = time;
    }
    if (cache._isScroll || axis === "x") {
        event.stopPropagation();
        event._gsapAllow = true;
    }
}, // capture events on scrollable elements INSIDE the <body> and allow those by calling stopPropagation() when we find a scrollable ancestor
_inputObserver = function _inputObserver(target, type, inputs, nested) {
    return (0, _observerJs.Observer).create({
        target: target,
        capture: true,
        debounce: false,
        lockAxis: true,
        type: type,
        onWheel: nested = nested && _nestedScroll,
        onPress: nested,
        onDrag: nested,
        onScroll: nested,
        onEnable: function onEnable() {
            return inputs && _addListener(_doc, (0, _observerJs.Observer).eventTypes[0], _captureInputs, false, true);
        },
        onDisable: function onDisable() {
            return _removeListener(_doc, (0, _observerJs.Observer).eventTypes[0], _captureInputs, true);
        }
    });
}, _inputExp = /(input|label|select|textarea)/i, _inputIsFocused, _captureInputs = function _captureInputs(e) {
    var isInput = _inputExp.test(e.target.tagName);
    if (isInput || _inputIsFocused) {
        e._gsapAllow = true;
        _inputIsFocused = isInput;
    }
}, _getScrollNormalizer = function _getScrollNormalizer(vars) {
    _isObject(vars) || (vars = {});
    vars.preventDefault = vars.isNormalizer = vars.allowClicks = true;
    vars.type || (vars.type = "wheel,touch");
    vars.debounce = !!vars.debounce;
    vars.id = vars.id || "normalizer";
    var _vars2 = vars, normalizeScrollX = _vars2.normalizeScrollX, momentum = _vars2.momentum, allowNestedScroll = _vars2.allowNestedScroll, onRelease = _vars2.onRelease, self, maxY, target = (0, _observerJs._getTarget)(vars.target) || _docEl, smoother = gsap.core.globals().ScrollSmoother, smootherInstance = smoother && smoother.get(), content = _fixIOSBug && (vars.content && (0, _observerJs._getTarget)(vars.content) || smootherInstance && vars.content !== false && !smootherInstance.smooth() && smootherInstance.content()), scrollFuncY = (0, _observerJs._getScrollFunc)(target, (0, _observerJs._vertical)), scrollFuncX = (0, _observerJs._getScrollFunc)(target, (0, _observerJs._horizontal)), scale = 1, initialScale = ((0, _observerJs.Observer).isTouch && _win.visualViewport ? _win.visualViewport.scale * _win.visualViewport.width : _win.outerWidth) / _win.innerWidth, wheelRefresh = 0, resolveMomentumDuration = _isFunction(momentum) ? function() {
        return momentum(self);
    } : function() {
        return momentum || 2.8;
    }, lastRefreshID, skipTouchMove, inputObserver = _inputObserver(target, vars.type, true, allowNestedScroll), resumeTouchMove = function resumeTouchMove() {
        return skipTouchMove = false;
    }, scrollClampX = _passThrough, scrollClampY = _passThrough, updateClamps = function updateClamps() {
        maxY = _maxScroll(target, (0, _observerJs._vertical));
        scrollClampY = _clamp(_fixIOSBug ? 1 : 0, maxY);
        normalizeScrollX && (scrollClampX = _clamp(0, _maxScroll(target, (0, _observerJs._horizontal))));
        lastRefreshID = _refreshID;
    }, removeContentOffset = function removeContentOffset() {
        content._gsap.y = _round(parseFloat(content._gsap.y) + scrollFuncY.offset) + "px";
        content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + parseFloat(content._gsap.y) + ", 0, 1)";
        scrollFuncY.offset = scrollFuncY.cacheID = 0;
    }, ignoreDrag = function ignoreDrag() {
        if (skipTouchMove) {
            requestAnimationFrame(resumeTouchMove);
            var offset = _round(self.deltaY / 2), scroll = scrollClampY(scrollFuncY.v - offset);
            if (content && scroll !== scrollFuncY.v + scrollFuncY.offset) {
                scrollFuncY.offset = scroll - scrollFuncY.v;
                var y = _round((parseFloat(content && content._gsap.y) || 0) - scrollFuncY.offset);
                content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)";
                content._gsap.y = y + "px";
                scrollFuncY.cacheID = (0, _observerJs._scrollers).cache;
                _updateAll();
            }
            return true;
        }
        scrollFuncY.offset && removeContentOffset();
        skipTouchMove = true;
    }, tween, startScrollX, startScrollY, onStopDelayedCall, onResize = function onResize() {
        // if the window resizes, like on an iPhone which Apple FORCES the address bar to show/hide even if we event.preventDefault(), it may be scrolling too far now that the address bar is showing, so we must dynamically adjust the momentum tween.
        updateClamps();
        if (tween.isActive() && tween.vars.scrollY > maxY) scrollFuncY() > maxY ? tween.progress(1) && scrollFuncY(maxY) : tween.resetTo("scrollY", maxY);
    };
    content && gsap.set(content, {
        y: "+=0"
    }); // to ensure there's a cache (element._gsap)
    vars.ignoreCheck = function(e) {
        return _fixIOSBug && e.type === "touchmove" && ignoreDrag(e) || scale > 1.05 && e.type !== "touchstart" || self.isGesturing || e.touches && e.touches.length > 1;
    };
    vars.onPress = function() {
        skipTouchMove = false;
        var prevScale = scale;
        scale = _round((_win.visualViewport && _win.visualViewport.scale || 1) / initialScale);
        tween.pause();
        prevScale !== scale && _allowNativePanning(target, scale > 1.01 ? true : normalizeScrollX ? false : "x");
        startScrollX = scrollFuncX();
        startScrollY = scrollFuncY();
        updateClamps();
        lastRefreshID = _refreshID;
    };
    vars.onRelease = vars.onGestureStart = function(self, wasDragging) {
        scrollFuncY.offset && removeContentOffset();
        if (!wasDragging) onStopDelayedCall.restart(true);
        else {
            (0, _observerJs._scrollers).cache++; // make sure we're pulling the non-cached value
            // alternate algorithm: durX = Math.min(6, Math.abs(self.velocityX / 800)),	dur = Math.max(durX, Math.min(6, Math.abs(self.velocityY / 800))); dur = dur * (0.4 + (1 - _power4In(dur / 6)) * 0.6)) * (momentumSpeed || 1)
            var dur = resolveMomentumDuration(), currentScroll, endScroll;
            if (normalizeScrollX) {
                currentScroll = scrollFuncX();
                endScroll = currentScroll + dur * 0.05 * -self.velocityX / 0.227; // the constant .227 is from power4(0.05). velocity is inverted because scrolling goes in the opposite direction.
                dur *= _clampScrollAndGetDurationMultiplier(scrollFuncX, currentScroll, endScroll, _maxScroll(target, (0, _observerJs._horizontal)));
                tween.vars.scrollX = scrollClampX(endScroll);
            }
            currentScroll = scrollFuncY();
            endScroll = currentScroll + dur * 0.05 * -self.velocityY / 0.227; // the constant .227 is from power4(0.05)
            dur *= _clampScrollAndGetDurationMultiplier(scrollFuncY, currentScroll, endScroll, _maxScroll(target, (0, _observerJs._vertical)));
            tween.vars.scrollY = scrollClampY(endScroll);
            tween.invalidate().duration(dur).play(0.01);
            if (_fixIOSBug && tween.vars.scrollY >= maxY || currentScroll >= maxY - 1) // iOS bug: it'll show the address bar but NOT fire the window "resize" event until the animation is done but we must protect against overshoot so we leverage an onUpdate to do so.
            gsap.to({}, {
                onUpdate: onResize,
                duration: dur
            });
        }
        onRelease && onRelease(self);
    };
    vars.onWheel = function() {
        tween._ts && tween.pause();
        if (_getTime() - wheelRefresh > 1000) {
            // after 1 second, refresh the clamps otherwise that'll only happen when ScrollTrigger.refresh() is called or for touch-scrolling.
            lastRefreshID = 0;
            wheelRefresh = _getTime();
        }
    };
    vars.onChange = function(self, dx, dy, xArray, yArray) {
        _refreshID !== lastRefreshID && updateClamps();
        dx && normalizeScrollX && scrollFuncX(scrollClampX(xArray[2] === dx ? startScrollX + (self.startX - self.x) : scrollFuncX() + dx - xArray[1])); // for more precision, we track pointer/touch movement from the start, otherwise it'll drift.
        if (dy) {
            scrollFuncY.offset && removeContentOffset();
            var isTouch = yArray[2] === dy, y = isTouch ? startScrollY + self.startY - self.y : scrollFuncY() + dy - yArray[1], yClamped = scrollClampY(y);
            isTouch && y !== yClamped && (startScrollY += yClamped - y);
            scrollFuncY(yClamped);
        }
        (dy || dx) && _updateAll();
    };
    vars.onEnable = function() {
        _allowNativePanning(target, normalizeScrollX ? false : "x");
        ScrollTrigger.addEventListener("refresh", onResize);
        _addListener(_win, "resize", onResize);
        if (scrollFuncY.smooth) {
            scrollFuncY.target.style.scrollBehavior = "auto";
            scrollFuncY.smooth = scrollFuncX.smooth = false;
        }
        inputObserver.enable();
    };
    vars.onDisable = function() {
        _allowNativePanning(target, true);
        _removeListener(_win, "resize", onResize);
        ScrollTrigger.removeEventListener("refresh", onResize);
        inputObserver.kill();
    };
    vars.lockAxis = vars.lockAxis !== false;
    self = new (0, _observerJs.Observer)(vars);
    self.iOS = _fixIOSBug; // used in the Observer getCachedScroll() function to work around an iOS bug that wreaks havoc with TouchEvent.clientY if we allow scroll to go all the way back to 0.
    _fixIOSBug && !scrollFuncY() && scrollFuncY(1); // iOS bug causes event.clientY values to freak out (wildly inaccurate) if the scroll position is exactly 0.
    _fixIOSBug && gsap.ticker.add(_passThrough); // prevent the ticker from sleeping
    onStopDelayedCall = self._dc;
    tween = gsap.to(self, {
        ease: "power4",
        paused: true,
        inherit: false,
        scrollX: normalizeScrollX ? "+=0.1" : "+=0",
        scrollY: "+=0.1",
        modifiers: {
            scrollY: _interruptionTracker(scrollFuncY, scrollFuncY(), function() {
                return tween.pause();
            })
        },
        onUpdate: _updateAll,
        onComplete: onStopDelayedCall.vars.onComplete
    }); // we need the modifier to sense if the scroll position is altered outside of the momentum tween (like with a scrollTo tween) so we can pause() it to prevent conflicts.
    return self;
};
ScrollTrigger.sort = function(func) {
    if (_isFunction(func)) return _triggers.sort(func);
    var scroll = _win.pageYOffset || 0;
    ScrollTrigger.getAll().forEach(function(t) {
        return t._sortY = t.trigger ? scroll + t.trigger.getBoundingClientRect().top : t.start + _win.innerHeight;
    });
    return _triggers.sort(func || function(a, b) {
        return (a.vars.refreshPriority || 0) * -1000000 + (a.vars.containerAnimation ? 1e6 : a._sortY) - ((b.vars.containerAnimation ? 1e6 : b._sortY) + (b.vars.refreshPriority || 0) * -1000000);
    }); // anything with a containerAnimation should refresh last.
};
ScrollTrigger.observe = function(vars) {
    return new (0, _observerJs.Observer)(vars);
};
ScrollTrigger.normalizeScroll = function(vars) {
    if (typeof vars === "undefined") return _normalizer;
    if (vars === true && _normalizer) return _normalizer.enable();
    if (vars === false) {
        _normalizer && _normalizer.kill();
        _normalizer = vars;
        return;
    }
    var normalizer = vars instanceof (0, _observerJs.Observer) ? vars : _getScrollNormalizer(vars);
    _normalizer && _normalizer.target === normalizer.target && _normalizer.kill();
    _isViewport(normalizer.target) && (_normalizer = normalizer);
    return normalizer;
};
ScrollTrigger.core = {
    // smaller file size way to leverage in ScrollSmoother and Observer
    _getVelocityProp: (0, _observerJs._getVelocityProp),
    _inputObserver: _inputObserver,
    _scrollers: (0, _observerJs._scrollers),
    _proxies: (0, _observerJs._proxies),
    bridge: {
        // when normalizeScroll sets the scroll position (ss = setScroll)
        ss: function ss() {
            _lastScrollTime || _dispatch("scrollStart");
            _lastScrollTime = _getTime();
        },
        // a way to get the _refreshing value in Observer
        ref: function ref() {
            return _refreshing;
        }
    }
};
_getGSAP() && gsap.registerPlugin(ScrollTrigger);

},{"./Observer.js":"hQBxY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hQBxY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Observer", ()=>Observer);
parcelHelpers.export(exports, "default", ()=>Observer);
parcelHelpers.export(exports, "_isViewport", ()=>_isViewport);
parcelHelpers.export(exports, "_scrollers", ()=>_scrollers);
parcelHelpers.export(exports, "_getScrollFunc", ()=>_getScrollFunc);
parcelHelpers.export(exports, "_getProxyProp", ()=>_getProxyProp);
parcelHelpers.export(exports, "_proxies", ()=>_proxies);
parcelHelpers.export(exports, "_getVelocityProp", ()=>_getVelocityProp);
parcelHelpers.export(exports, "_vertical", ()=>_vertical);
parcelHelpers.export(exports, "_horizontal", ()=>_horizontal);
parcelHelpers.export(exports, "_getTarget", ()=>_getTarget);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * Observer 3.14.2
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var gsap, _coreInitted, _clamp, _win, _doc, _docEl, _body, _isTouch, _pointerType, ScrollTrigger, _root, _normalizer, _eventTypes, _context, _getGSAP = function _getGSAP() {
    return gsap || typeof window !== "undefined" && (gsap = window.gsap) && gsap.registerPlugin && gsap;
}, _startup = 1, _observers = [], _scrollers = [], _proxies = [], _getTime = Date.now, _bridge = function _bridge(name, value) {
    return value;
}, _integrate = function _integrate() {
    var core = ScrollTrigger.core, data = core.bridge || {}, scrollers = core._scrollers, proxies = core._proxies;
    scrollers.push.apply(scrollers, _scrollers);
    proxies.push.apply(proxies, _proxies);
    _scrollers = scrollers;
    _proxies = proxies;
    _bridge = function _bridge(name, value) {
        return data[name](value);
    };
}, _getProxyProp = function _getProxyProp(element, property) {
    return ~_proxies.indexOf(element) && _proxies[_proxies.indexOf(element) + 1][property];
}, _isViewport = function _isViewport(el) {
    return !!~_root.indexOf(el);
}, _addListener = function _addListener(element, type, func, passive, capture) {
    return element.addEventListener(type, func, {
        passive: passive !== false,
        capture: !!capture
    });
}, _removeListener = function _removeListener(element, type, func, capture) {
    return element.removeEventListener(type, func, !!capture);
}, _scrollLeft = "scrollLeft", _scrollTop = "scrollTop", _onScroll = function _onScroll() {
    return _normalizer && _normalizer.isPressed || _scrollers.cache++;
}, _scrollCacheFunc = function _scrollCacheFunc(f, doNotCache) {
    var cachingFunc = function cachingFunc(value) {
        // since reading the scrollTop/scrollLeft/pageOffsetY/pageOffsetX can trigger a layout, this function allows us to cache the value so it only gets read fresh after a "scroll" event fires (or while we're refreshing because that can lengthen the page and alter the scroll position). when "soft" is true, that means don't actually set the scroll, but cache the new value instead (useful in ScrollSmoother)
        if (value || value === 0) {
            _startup && (_win.history.scrollRestoration = "manual"); // otherwise the new position will get overwritten by the browser onload.
            var isNormalizing = _normalizer && _normalizer.isPressed;
            value = cachingFunc.v = Math.round(value) || (_normalizer && _normalizer.iOS ? 1 : 0); //TODO: iOS Bug: if you allow it to go to 0, Safari can start to report super strange (wildly inaccurate) touch positions!
            f(value);
            cachingFunc.cacheID = _scrollers.cache;
            isNormalizing && _bridge("ss", value); // set scroll (notify ScrollTrigger so it can dispatch a "scrollStart" event if necessary
        } else if (doNotCache || _scrollers.cache !== cachingFunc.cacheID || _bridge("ref")) {
            cachingFunc.cacheID = _scrollers.cache;
            cachingFunc.v = f();
        }
        return cachingFunc.v + cachingFunc.offset;
    };
    cachingFunc.offset = 0;
    return f && cachingFunc;
}, _horizontal = {
    s: _scrollLeft,
    p: "left",
    p2: "Left",
    os: "right",
    os2: "Right",
    d: "width",
    d2: "Width",
    a: "x",
    sc: _scrollCacheFunc(function(value) {
        return arguments.length ? _win.scrollTo(value, _vertical.sc()) : _win.pageXOffset || _doc[_scrollLeft] || _docEl[_scrollLeft] || _body[_scrollLeft] || 0;
    })
}, _vertical = {
    s: _scrollTop,
    p: "top",
    p2: "Top",
    os: "bottom",
    os2: "Bottom",
    d: "height",
    d2: "Height",
    a: "y",
    op: _horizontal,
    sc: _scrollCacheFunc(function(value) {
        return arguments.length ? _win.scrollTo(_horizontal.sc(), value) : _win.pageYOffset || _doc[_scrollTop] || _docEl[_scrollTop] || _body[_scrollTop] || 0;
    })
}, _getTarget = function _getTarget(t, self) {
    return (self && self._ctx && self._ctx.selector || gsap.utils.toArray)(t)[0] || (typeof t === "string" && gsap.config().nullTargetWarn !== false ? console.warn("Element not found:", t) : null);
}, _isWithin = function _isWithin(element, list) {
    // check if the element is in the list or is a descendant of an element in the list.
    var i = list.length;
    while(i--){
        if (list[i] === element || list[i].contains(element)) return true;
    }
    return false;
}, _getScrollFunc = function _getScrollFunc(element, _ref) {
    var s = _ref.s, sc = _ref.sc;
    // we store the scroller functions in an alternating sequenced Array like [element, verticalScrollFunc, horizontalScrollFunc, ...] so that we can minimize memory, maximize performance, and we also record the last position as a ".rec" property in order to revert to that after refreshing to ensure things don't shift around.
    _isViewport(element) && (element = _doc.scrollingElement || _docEl);
    var i = _scrollers.indexOf(element), offset = sc === _vertical.sc ? 1 : 2;
    !~i && (i = _scrollers.push(element) - 1);
    _scrollers[i + offset] || _addListener(element, "scroll", _onScroll); // clear the cache when a scroll occurs
    var prev = _scrollers[i + offset], func = prev || (_scrollers[i + offset] = _scrollCacheFunc(_getProxyProp(element, s), true) || (_isViewport(element) ? sc : _scrollCacheFunc(function(value) {
        return arguments.length ? element[s] = value : element[s];
    })));
    func.target = element;
    prev || (func.smooth = gsap.getProperty(element, "scrollBehavior") === "smooth"); // only set it the first time (don't reset every time a scrollFunc is requested because perhaps it happens during a refresh() when it's disabled in ScrollTrigger.
    return func;
}, _getVelocityProp = function _getVelocityProp(value, minTimeRefresh, useDelta) {
    var v1 = value, v2 = value, t1 = _getTime(), t2 = t1, min = minTimeRefresh || 50, dropToZeroTime = Math.max(500, min * 3), update = function update(value, force) {
        var t = _getTime();
        if (force || t - t1 > min) {
            v2 = v1;
            v1 = value;
            t2 = t1;
            t1 = t;
        } else if (useDelta) v1 += value;
        else // not totally necessary, but makes it a bit more accurate by adjusting the v1 value according to the new slope. This way we're not just ignoring the incoming data. Removing for now because it doesn't seem to make much practical difference and it's probably not worth the kb.
        v1 = v2 + (value - v2) / (t - t2) * (t1 - t2);
    }, reset = function reset() {
        v2 = v1 = useDelta ? 0 : v1;
        t2 = t1 = 0;
    }, getVelocity = function getVelocity(latestValue) {
        var tOld = t2, vOld = v2, t = _getTime();
        (latestValue || latestValue === 0) && latestValue !== v1 && update(latestValue);
        return t1 === t2 || t - t2 > dropToZeroTime ? 0 : (v1 + (useDelta ? vOld : -vOld)) / ((useDelta ? t : t1) - tOld) * 1000;
    };
    return {
        update: update,
        reset: reset,
        getVelocity: getVelocity
    };
}, _getEvent = function _getEvent(e, preventDefault) {
    preventDefault && !e._gsapAllow && e.preventDefault();
    return e.changedTouches ? e.changedTouches[0] : e;
}, _getAbsoluteMax = function _getAbsoluteMax(a) {
    var max = Math.max.apply(Math, a), min = Math.min.apply(Math, a);
    return Math.abs(max) >= Math.abs(min) ? max : min;
}, _setScrollTrigger = function _setScrollTrigger() {
    ScrollTrigger = gsap.core.globals().ScrollTrigger;
    ScrollTrigger && ScrollTrigger.core && _integrate();
}, _initCore = function _initCore(core) {
    gsap = core || _getGSAP();
    if (!_coreInitted && gsap && typeof document !== "undefined" && document.body) {
        _win = window;
        _doc = document;
        _docEl = _doc.documentElement;
        _body = _doc.body;
        _root = [
            _win,
            _doc,
            _docEl,
            _body
        ];
        _clamp = gsap.utils.clamp;
        _context = gsap.core.context || function() {};
        _pointerType = "onpointerenter" in _body ? "pointer" : "mouse"; // isTouch is 0 if no touch, 1 if ONLY touch, and 2 if it can accommodate touch but also other types like mouse/pointer.
        _isTouch = Observer.isTouch = _win.matchMedia && _win.matchMedia("(hover: none), (pointer: coarse)").matches ? 1 : "ontouchstart" in _win || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0 ? 2 : 0;
        _eventTypes = Observer.eventTypes = ("ontouchstart" in _docEl ? "touchstart,touchmove,touchcancel,touchend" : !("onpointerdown" in _docEl) ? "mousedown,mousemove,mouseup,mouseup" : "pointerdown,pointermove,pointercancel,pointerup").split(",");
        setTimeout(function() {
            return _startup = 0;
        }, 500);
        _setScrollTrigger();
        _coreInitted = 1;
    }
    return _coreInitted;
};
_horizontal.op = _vertical;
_scrollers.cache = 0;
var Observer = /*#__PURE__*/ function() {
    function Observer(vars) {
        this.init(vars);
    }
    var _proto = Observer.prototype;
    _proto.init = function init(vars) {
        _coreInitted || _initCore(gsap) || console.warn("Please gsap.registerPlugin(Observer)");
        ScrollTrigger || _setScrollTrigger();
        var tolerance = vars.tolerance, dragMinimum = vars.dragMinimum, type = vars.type, target = vars.target, lineHeight = vars.lineHeight, debounce = vars.debounce, preventDefault = vars.preventDefault, onStop = vars.onStop, onStopDelay = vars.onStopDelay, ignore = vars.ignore, wheelSpeed = vars.wheelSpeed, event = vars.event, onDragStart = vars.onDragStart, onDragEnd = vars.onDragEnd, onDrag = vars.onDrag, onPress = vars.onPress, onRelease = vars.onRelease, onRight = vars.onRight, onLeft = vars.onLeft, onUp = vars.onUp, onDown = vars.onDown, onChangeX = vars.onChangeX, onChangeY = vars.onChangeY, onChange = vars.onChange, onToggleX = vars.onToggleX, onToggleY = vars.onToggleY, onHover = vars.onHover, onHoverEnd = vars.onHoverEnd, onMove = vars.onMove, ignoreCheck = vars.ignoreCheck, isNormalizer = vars.isNormalizer, onGestureStart = vars.onGestureStart, onGestureEnd = vars.onGestureEnd, onWheel = vars.onWheel, onEnable = vars.onEnable, onDisable = vars.onDisable, onClick = vars.onClick, scrollSpeed = vars.scrollSpeed, capture = vars.capture, allowClicks = vars.allowClicks, lockAxis = vars.lockAxis, onLockAxis = vars.onLockAxis;
        this.target = target = _getTarget(target) || _docEl;
        this.vars = vars;
        ignore && (ignore = gsap.utils.toArray(ignore));
        tolerance = tolerance || 1e-9;
        dragMinimum = dragMinimum || 0;
        wheelSpeed = wheelSpeed || 1;
        scrollSpeed = scrollSpeed || 1;
        type = type || "wheel,touch,pointer";
        debounce = debounce !== false;
        lineHeight || (lineHeight = parseFloat(_win.getComputedStyle(_body).lineHeight) || 22); // note: browser may report "normal", so default to 22.
        var id, onStopDelayedCall, dragged, moved, wheeled, locked, axis, self = this, prevDeltaX = 0, prevDeltaY = 0, passive = vars.passive || !preventDefault && vars.passive !== false, scrollFuncX = _getScrollFunc(target, _horizontal), scrollFuncY = _getScrollFunc(target, _vertical), scrollX = scrollFuncX(), scrollY = scrollFuncY(), limitToTouch = ~type.indexOf("touch") && !~type.indexOf("pointer") && _eventTypes[0] === "pointerdown", // for devices that accommodate mouse events and touch events, we need to distinguish.
        isViewport = _isViewport(target), ownerDoc = target.ownerDocument || _doc, deltaX = [
            0,
            0,
            0
        ], // wheel, scroll, pointer/touch
        deltaY = [
            0,
            0,
            0
        ], onClickTime = 0, clickCapture = function clickCapture() {
            return onClickTime = _getTime();
        }, _ignoreCheck = function _ignoreCheck(e, isPointerOrTouch) {
            return (self.event = e) && ignore && _isWithin(e.target, ignore) || isPointerOrTouch && limitToTouch && e.pointerType !== "touch" || ignoreCheck && ignoreCheck(e, isPointerOrTouch);
        }, onStopFunc = function onStopFunc() {
            self._vx.reset();
            self._vy.reset();
            onStopDelayedCall.pause();
            onStop && onStop(self);
        }, update = function update() {
            var dx = self.deltaX = _getAbsoluteMax(deltaX), dy = self.deltaY = _getAbsoluteMax(deltaY), changedX = Math.abs(dx) >= tolerance, changedY = Math.abs(dy) >= tolerance;
            onChange && (changedX || changedY) && onChange(self, dx, dy, deltaX, deltaY); // in ScrollTrigger.normalizeScroll(), we need to know if it was touch/pointer so we need access to the deltaX/deltaY Arrays before we clear them out.
            if (changedX) {
                onRight && self.deltaX > 0 && onRight(self);
                onLeft && self.deltaX < 0 && onLeft(self);
                onChangeX && onChangeX(self);
                onToggleX && self.deltaX < 0 !== prevDeltaX < 0 && onToggleX(self);
                prevDeltaX = self.deltaX;
                deltaX[0] = deltaX[1] = deltaX[2] = 0;
            }
            if (changedY) {
                onDown && self.deltaY > 0 && onDown(self);
                onUp && self.deltaY < 0 && onUp(self);
                onChangeY && onChangeY(self);
                onToggleY && self.deltaY < 0 !== prevDeltaY < 0 && onToggleY(self);
                prevDeltaY = self.deltaY;
                deltaY[0] = deltaY[1] = deltaY[2] = 0;
            }
            if (moved || dragged) {
                onMove && onMove(self);
                if (dragged) {
                    onDragStart && dragged === 1 && onDragStart(self);
                    onDrag && onDrag(self);
                    dragged = 0;
                }
                moved = false;
            }
            locked && (locked = false, true) && onLockAxis && onLockAxis(self);
            if (wheeled) {
                onWheel(self);
                wheeled = false;
            }
            id = 0;
        }, onDelta = function onDelta(x, y, index) {
            deltaX[index] += x;
            deltaY[index] += y;
            self._vx.update(x);
            self._vy.update(y);
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, onTouchOrPointerDelta = function onTouchOrPointerDelta(x, y) {
            if (lockAxis && !axis) {
                self.axis = axis = Math.abs(x) > Math.abs(y) ? "x" : "y";
                locked = true;
            }
            if (axis !== "y") {
                deltaX[2] += x;
                self._vx.update(x, true); // update the velocity as frequently as possible instead of in the debounced function so that very quick touch-scrolls (flicks) feel natural. If it's the mouse/touch/pointer, force it so that we get snappy/accurate momentum scroll.
            }
            if (axis !== "x") {
                deltaY[2] += y;
                self._vy.update(y, true);
            }
            debounce ? id || (id = requestAnimationFrame(update)) : update();
        }, _onDrag = function _onDrag(e) {
            if (_ignoreCheck(e, 1)) return;
            e = _getEvent(e, preventDefault);
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y, isDragging = self.isDragging;
            self.x = x;
            self.y = y;
            if (isDragging || (dx || dy) && (Math.abs(self.startX - x) >= dragMinimum || Math.abs(self.startY - y) >= dragMinimum)) {
                dragged || (dragged = isDragging ? 2 : 1); // dragged: 0 = not dragging, 1 = first drag, 2 = normal drag
                isDragging || (self.isDragging = true);
                onTouchOrPointerDelta(dx, dy);
            }
        }, _onPress = self.onPress = function(e) {
            if (_ignoreCheck(e, 1) || e && e.button) return;
            self.axis = axis = null;
            onStopDelayedCall.pause();
            self.isPressed = true;
            e = _getEvent(e); // note: may need to preventDefault(?) Won't side-scroll on iOS Safari if we do, though.
            prevDeltaX = prevDeltaY = 0;
            self.startX = self.x = e.clientX;
            self.startY = self.y = e.clientY;
            self._vx.reset(); // otherwise the t2 may be stale if the user touches and flicks super fast and releases in less than 2 requestAnimationFrame ticks, causing velocity to be 0.
            self._vy.reset();
            _addListener(isNormalizer ? target : ownerDoc, _eventTypes[1], _onDrag, passive, true);
            self.deltaX = self.deltaY = 0;
            onPress && onPress(self);
        }, _onRelease = self.onRelease = function(e) {
            if (_ignoreCheck(e, 1)) return;
            _removeListener(isNormalizer ? target : ownerDoc, _eventTypes[1], _onDrag, true);
            var isTrackingDrag = !isNaN(self.y - self.startY), wasDragging = self.isDragging, isDragNotClick = wasDragging && (Math.abs(self.x - self.startX) > 3 || Math.abs(self.y - self.startY) > 3), // some touch devices need some wiggle room in terms of sensing clicks - the finger may move a few pixels.
            eventData = _getEvent(e);
            if (!isDragNotClick && isTrackingDrag) {
                self._vx.reset();
                self._vy.reset(); //if (preventDefault && allowClicks && self.isPressed) { // check isPressed because in a rare edge case, the inputObserver in ScrollTrigger may stopPropagation() on the press/drag, so the onRelease may get fired without the onPress/onDrag ever getting called, thus it could trigger a click to occur on a link after scroll-dragging it.
                if (preventDefault && allowClicks) gsap.delayedCall(0.08, function() {
                    // some browsers (like Firefox) won't trust script-generated clicks, so if the user tries to click on a video to play it, for example, it simply won't work. Since a regular "click" event will most likely be generated anyway (one that has its isTrusted flag set to true), we must slightly delay our script-generated click so that the "real"/trusted one is prioritized. Remember, when there are duplicate events in quick succession, we suppress all but the first one. Some browsers don't even trigger the "real" one at all, so our synthetic one is a safety valve that ensures that no matter what, a click event does get dispatched.
                    if (_getTime() - onClickTime > 300 && !e.defaultPrevented) {
                        if (e.target.click) //some browsers (like mobile Safari) don't properly trigger the click event
                        e.target.click();
                        else if (ownerDoc.createEvent) {
                            var syntheticEvent = ownerDoc.createEvent("MouseEvents");
                            syntheticEvent.initMouseEvent("click", true, true, _win, 1, eventData.screenX, eventData.screenY, eventData.clientX, eventData.clientY, false, false, false, false, 0, null);
                            e.target.dispatchEvent(syntheticEvent);
                        }
                    }
                });
            }
            self.isDragging = self.isGesturing = self.isPressed = false;
            onStop && wasDragging && !isNormalizer && onStopDelayedCall.restart(true);
            dragged && update(); // in case debouncing, we don't want onDrag to fire AFTER onDragEnd().
            onDragEnd && wasDragging && onDragEnd(self);
            onRelease && onRelease(self, isDragNotClick);
        }, _onGestureStart = function _onGestureStart(e) {
            return e.touches && e.touches.length > 1 && (self.isGesturing = true) && onGestureStart(e, self.isDragging);
        }, _onGestureEnd = function _onGestureEnd() {
            return self.isGesturing = false, onGestureEnd(self);
        }, onScroll = function onScroll(e) {
            if (_ignoreCheck(e)) return;
            var x = scrollFuncX(), y = scrollFuncY();
            onDelta((x - scrollX) * scrollSpeed, (y - scrollY) * scrollSpeed, 1);
            scrollX = x;
            scrollY = y;
            onStop && onStopDelayedCall.restart(true);
        }, _onWheel = function _onWheel(e) {
            if (_ignoreCheck(e)) return;
            e = _getEvent(e, preventDefault);
            onWheel && (wheeled = true);
            var multiplier = (e.deltaMode === 1 ? lineHeight : e.deltaMode === 2 ? _win.innerHeight : 1) * wheelSpeed;
            onDelta(e.deltaX * multiplier, e.deltaY * multiplier, 0);
            onStop && !isNormalizer && onStopDelayedCall.restart(true);
        }, _onMove = function _onMove(e) {
            if (_ignoreCheck(e)) return;
            var x = e.clientX, y = e.clientY, dx = x - self.x, dy = y - self.y;
            self.x = x;
            self.y = y;
            moved = true;
            onStop && onStopDelayedCall.restart(true);
            (dx || dy) && onTouchOrPointerDelta(dx, dy);
        }, _onHover = function _onHover(e) {
            self.event = e;
            onHover(self);
        }, _onHoverEnd = function _onHoverEnd(e) {
            self.event = e;
            onHoverEnd(self);
        }, _onClick = function _onClick(e) {
            return _ignoreCheck(e) || _getEvent(e, preventDefault) && onClick(self);
        };
        onStopDelayedCall = self._dc = gsap.delayedCall(onStopDelay || 0.25, onStopFunc).pause();
        self.deltaX = self.deltaY = 0;
        self._vx = _getVelocityProp(0, 50, true);
        self._vy = _getVelocityProp(0, 50, true);
        self.scrollX = scrollFuncX;
        self.scrollY = scrollFuncY;
        self.isDragging = self.isGesturing = self.isPressed = false;
        _context(this);
        self.enable = function(e) {
            if (!self.isEnabled) {
                _addListener(isViewport ? ownerDoc : target, "scroll", _onScroll);
                type.indexOf("scroll") >= 0 && _addListener(isViewport ? ownerDoc : target, "scroll", onScroll, passive, capture);
                type.indexOf("wheel") >= 0 && _addListener(target, "wheel", _onWheel, passive, capture);
                if (type.indexOf("touch") >= 0 && _isTouch || type.indexOf("pointer") >= 0) {
                    _addListener(target, _eventTypes[0], _onPress, passive, capture);
                    _addListener(ownerDoc, _eventTypes[2], _onRelease);
                    _addListener(ownerDoc, _eventTypes[3], _onRelease);
                    allowClicks && _addListener(target, "click", clickCapture, true, true);
                    onClick && _addListener(target, "click", _onClick);
                    onGestureStart && _addListener(ownerDoc, "gesturestart", _onGestureStart);
                    onGestureEnd && _addListener(ownerDoc, "gestureend", _onGestureEnd);
                    onHover && _addListener(target, _pointerType + "enter", _onHover);
                    onHoverEnd && _addListener(target, _pointerType + "leave", _onHoverEnd);
                    onMove && _addListener(target, _pointerType + "move", _onMove);
                }
                self.isEnabled = true;
                self.isDragging = self.isGesturing = self.isPressed = moved = dragged = false;
                self._vx.reset();
                self._vy.reset();
                scrollX = scrollFuncX();
                scrollY = scrollFuncY();
                e && e.type && _onPress(e);
                onEnable && onEnable(self);
            }
            return self;
        };
        self.disable = function() {
            if (self.isEnabled) {
                // only remove the _onScroll listener if there aren't any others that rely on the functionality.
                _observers.filter(function(o) {
                    return o !== self && _isViewport(o.target);
                }).length || _removeListener(isViewport ? ownerDoc : target, "scroll", _onScroll);
                if (self.isPressed) {
                    self._vx.reset();
                    self._vy.reset();
                    _removeListener(isNormalizer ? target : ownerDoc, _eventTypes[1], _onDrag, true);
                }
                _removeListener(isViewport ? ownerDoc : target, "scroll", onScroll, capture);
                _removeListener(target, "wheel", _onWheel, capture);
                _removeListener(target, _eventTypes[0], _onPress, capture);
                _removeListener(ownerDoc, _eventTypes[2], _onRelease);
                _removeListener(ownerDoc, _eventTypes[3], _onRelease);
                _removeListener(target, "click", clickCapture, true);
                _removeListener(target, "click", _onClick);
                _removeListener(ownerDoc, "gesturestart", _onGestureStart);
                _removeListener(ownerDoc, "gestureend", _onGestureEnd);
                _removeListener(target, _pointerType + "enter", _onHover);
                _removeListener(target, _pointerType + "leave", _onHoverEnd);
                _removeListener(target, _pointerType + "move", _onMove);
                self.isEnabled = self.isPressed = self.isDragging = false;
                onDisable && onDisable(self);
            }
        };
        self.kill = self.revert = function() {
            self.disable();
            var i = _observers.indexOf(self);
            i >= 0 && _observers.splice(i, 1);
            _normalizer === self && (_normalizer = 0);
        };
        _observers.push(self);
        isNormalizer && _isViewport(target) && (_normalizer = self);
        self.enable(event);
    };
    _createClass(Observer, [
        {
            key: "velocityX",
            get: function get() {
                return this._vx.getVelocity();
            }
        },
        {
            key: "velocityY",
            get: function get() {
                return this._vy.getVelocity();
            }
        }
    ]);
    return Observer;
}();
Observer.version = "3.14.2";
Observer.create = function(vars) {
    return new Observer(vars);
};
Observer.register = _initCore;
Observer.getAll = function() {
    return _observers.slice();
};
Observer.getById = function(id) {
    return _observers.filter(function(o) {
        return o.vars.id === id;
    })[0];
};
_getGSAP() && gsap.registerPlugin(Observer);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4XNUc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollSmoother", ()=>ScrollSmoother);
parcelHelpers.export(exports, "default", ()=>ScrollSmoother);
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
/*!
 * ScrollSmoother 3.14.2
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var gsap, _coreInitted, _win, _doc, _docEl, _body, _root, _toArray, _clamp, ScrollTrigger, _mainInstance, _expo, _getVelocityProp, _inputObserver, _context, _onResizeDelayedCall, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _getGSAP = function _getGSAP() {
    return gsap || _windowExists() && (gsap = window.gsap) && gsap.registerPlugin && gsap;
}, _bonusValidated = 1, //<name>ScrollSmoother</name>
_round = function _round(value) {
    return Math.round(value * 100000) / 100000 || 0;
}, _maxScroll = function _maxScroll(scroller) {
    return ScrollTrigger.maxScroll(scroller || _win);
}, _autoDistance = function _autoDistance(el, progress) {
    // for calculating the distance (and offset) for elements with speed: "auto". Progress is for if it's "above the fold" (negative start position), so we can crop as little as possible.
    var parent = el.parentNode || _docEl, b1 = el.getBoundingClientRect(), b2 = parent.getBoundingClientRect(), gapTop = b2.top - b1.top, gapBottom = b2.bottom - b1.bottom, change = (Math.abs(gapTop) > Math.abs(gapBottom) ? gapTop : gapBottom) / (1 - progress), offset = -change * progress, ratio, extraChange;
    if (change > 0) {
        // if the image starts at the BOTTOM of the container, adjust things so that it shows as much of the image as possible while still covering.
        ratio = b2.height / (_win.innerHeight + b2.height);
        extraChange = ratio === 0.5 ? b2.height * 2 : Math.min(b2.height, Math.abs(-change * ratio / (2 * ratio - 1))) * 2 * (progress || 1);
        offset += progress ? -extraChange * progress : -extraChange / 2; // whatever the offset, we must double that in the opposite direction to compensate.
        change += extraChange;
    }
    return {
        change: change,
        offset: offset
    };
}, _wrap = function _wrap(el) {
    var wrapper = _doc.querySelector(".ScrollSmoother-wrapper"); // some frameworks load multiple times, so one already exists, just use that to avoid duplicates
    if (!wrapper) {
        wrapper = _doc.createElement("div");
        wrapper.classList.add("ScrollSmoother-wrapper");
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    }
    return wrapper;
};
var ScrollSmoother = /*#__PURE__*/ function() {
    function ScrollSmoother(vars) {
        var _this = this;
        _coreInitted || ScrollSmoother.register(gsap) || console.warn("Please gsap.registerPlugin(ScrollSmoother)");
        vars = this.vars = vars || {};
        _mainInstance && _mainInstance.kill();
        _mainInstance = this;
        _context(this);
        var _vars = vars, smoothTouch = _vars.smoothTouch, _onUpdate = _vars.onUpdate, onStop = _vars.onStop, smooth = _vars.smooth, onFocusIn = _vars.onFocusIn, normalizeScroll = _vars.normalizeScroll, wholePixels = _vars.wholePixels, content, wrapper, height, mainST, effects, sections, intervalID, wrapperCSS, contentCSS, paused, pausedNormalizer, recordedRefreshScroll, recordedRefreshScrub, allowUpdates, self = this, effectsPrefix = vars.effectsPrefix || "", scrollFunc = ScrollTrigger.getScrollFunc(_win), smoothDuration = ScrollTrigger.isTouch === 1 ? smoothTouch === true ? 0.8 : parseFloat(smoothTouch) || 0 : smooth === 0 || smooth === false ? 0 : parseFloat(smooth) || 0.8, speed = smoothDuration && +vars.speed || 1, currentY = 0, delta = 0, startupPhase = 1, tracker = _getVelocityProp(0), updateVelocity = function updateVelocity() {
            return tracker.update(-currentY);
        }, scroll = {
            y: 0
        }, removeScroll = function removeScroll() {
            return content.style.overflow = "visible";
        }, isProxyScrolling, killScrub = function killScrub(trigger) {
            trigger.update(); // it's possible that it hasn't been synchronized with the actual scroll position yet, like if it's later in the _triggers Array. If it was already updated, it'll skip the processing anyway.
            var scrub = trigger.getTween();
            if (scrub) {
                scrub.pause();
                scrub._time = scrub._dur; // force the playhead to completion without rendering just so that when it resumes, it doesn't jump back in the .resetTo().
                scrub._tTime = scrub._tDur;
            }
            isProxyScrolling = false;
            trigger.animation.progress(trigger.progress, true);
        }, render = function render(y, force) {
            if (y !== currentY && !paused || force) {
                wholePixels && (y = Math.round(y));
                if (smoothDuration) {
                    content.style.transform = "matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, " + y + ", 0, 1)"; //content.style.transform = "translateY(" + y + "px)"; // NOTE: when we used matrix3d() or set will-change: transform, it performed noticeably worse on iOS counter-intuitively!
                    content._gsap.y = y + "px";
                }
                delta = y - currentY;
                currentY = y;
                ScrollTrigger.isUpdating || ScrollSmoother.isRefreshing || ScrollTrigger.update(); // note: if we allowed an update() when in the middle of a refresh() it could render all the other ScrollTriggers and inside the update(), _refreshing would be true thus scrubs would jump instantly, but then on the very next update they'd continue from there. Basically this allowed update() to be called on OTHER ScrollTriggers during the refresh() of the mainST which could cause some complications. See https://gsap.com/forums/topic/35536-smoothscroller-ignoremobileresize-for-non-touch-devices
            }
        }, scrollTop = function scrollTop(value) {
            if (arguments.length) {
                value < 0 && (value = 0);
                scroll.y = -value; // don't use currentY because we must accurately track the delta variable (in render() method)
                isProxyScrolling = true; // otherwise, if snapping was applied (or anything that attempted to SET the scroll proxy's scroll position), we'd set the scroll here which would then (on the next tick) update the content tween/ScrollTrigger which would try to smoothly animate to that new value, thus the scrub tween would impede the progress. So we use this flag to respond accordingly in the ScrollTrigger's onUpdate and effectively force the scrub to its end immediately.
                paused ? currentY = -value : render(-value);
                ScrollTrigger.isRefreshing ? mainST.update() : scrollFunc(value / speed); // during a refresh, we revert all scrollers to 0 and then put them back. We shouldn't force the window to that value too during the refresh.
                return this;
            }
            return -currentY;
        }, resizeObserver = typeof ResizeObserver !== "undefined" && vars.autoResize !== false && new ResizeObserver(function() {
            if (!ScrollTrigger.isRefreshing) {
                var max = _maxScroll(wrapper) * speed;
                max < -currentY && scrollTop(max); // if the user scrolled down to the bottom, for example, and then the page resizes smaller, we should adjust things accordingly right away so that the scroll position isn't past the very end.
                _onResizeDelayedCall.restart(true);
            }
        }), lastFocusElement, _onFocusIn = function _onFocusIn(e) {
            // when the focus changes, make sure that element is on-screen
            wrapper.scrollTop = 0;
            if (e.target.contains && e.target.contains(wrapper) || onFocusIn && onFocusIn(_this, e) === false) return;
            ScrollTrigger.isInViewport(e.target) || e.target === lastFocusElement || _this.scrollTo(e.target, false, "center center");
            lastFocusElement = e.target;
        }, _transformPosition = function _transformPosition(position, st) {
            // feed in a position (start or end scroll value) and a ScrollTrigger that's associated with a parallax effect and it'll spit back the adjusted position based on the movement of the trigger. For example, if the trigger goes at a speed of 0.5 while in the viewport, we must push the start/end values of OTHER ScrollTriggers that use that same trigger further down to compensate.
            if (position < st.start) return position;
            var ratio = isNaN(st.ratio) ? 1 : st.ratio, change = st.end - st.start, distance = position - st.start, offset = st.offset || 0, pins = st.pins || [], pinOffset = pins.offset || 0, progressOffset = st._startClamp && st.start <= 0 || st.pins && st.pins.offset ? 0 : st._endClamp && st.end === _maxScroll() ? 1 : 0.5;
            pins.forEach(function(p) {
                // remove any pinning space/distance
                change -= p.distance;
                if (p.nativeStart <= position) distance -= p.distance;
            });
            if (pinOffset) // edge case when a clamped effect starts mid-pin; we've gotta compensate for the smaller change amount (the yOffset gets set to the st.pins.offset, so let's say it clamps such that the page starts with the element pinned 100px in, we have to set the yOffset to 100 but then subtract 100 from the change value to compensate, thus we must scale the positions accordingly based on the ratios. Like if it would normally have a change of 2000, and a pin would normally hit at 1000, but we're offsetting by 100, that means everything must scale now that we're only moving 1900px rather than 2000px.
            distance *= (change - pinOffset / ratio) / change;
            return position + (distance - offset * progressOffset) / ratio - distance;
        }, adjustEffectRelatedTriggers = function adjustEffectRelatedTriggers(st, triggers, partial) {
            // if we're using this method to do only a partial Array of triggers, we should NOT reset or rebuild the pin data. For example, we tap into this from the offset() method.
            partial || (st.pins.length = st.pins.offset = 0);
            var pins = st.pins, markers = st.markers, dif, isClamped, start, end, nativeStart, nativeEnd, i, trig;
            for(i = 0; i < triggers.length; i++){
                trig = triggers[i];
                if (st.trigger && trig.trigger && st !== trig && (trig.trigger === st.trigger || trig.pinnedContainer === st.trigger || st.trigger.contains(trig.trigger))) {
                    nativeStart = trig._startNative || trig._startClamp || trig.start;
                    nativeEnd = trig._endNative || trig._endClamp || trig.end;
                    start = _transformPosition(nativeStart, st); // note: _startClamp and _endClamp are populated with the unclamped values. For the sake of efficiency sake, we use the property both like a boolean to indicate that clamping is enabled AND the actual original unclamped value which we need in situations like if there's a data-speed="" on an element that has something like start="clamp(top bottom)". For in-viewport elements, it would clamp the values on the ScrollTrigger first, then feed it here and we'd adjust it on the clamped value which could throw things off - we need to apply the logic to the unclamped value and THEN re-apply clamping on the result.
                    end = trig.pin && nativeEnd > 0 ? start + (nativeEnd - nativeStart) : _transformPosition(nativeEnd, st);
                    trig.setPositions(start, end, true, (trig._startClamp ? Math.max(0, start) : start) - nativeStart); // the last value (pinOffset) is to adjust the pinStart y value inside ScrollTrigger to accommodate for the y offset that gets applied by the parallax effect.
                    trig.markerStart && markers.push(gsap.quickSetter([
                        trig.markerStart,
                        trig.markerEnd
                    ], "y", "px"));
                    if (trig.pin && trig.end > 0 && !partial) {
                        dif = trig.end - trig.start;
                        isClamped = st._startClamp && trig.start < 0;
                        if (isClamped) {
                            if (st.start > 0) {
                                // the trigger element on the effect must have been pinned BEFORE its starting position, so in this edge case we must adjust the start position to be 0 and end position to get pushed further by the amount of the overlap
                                st.setPositions(0, st.end + (st._startNative - st.start), true); // add the overlap amount
                                adjustEffectRelatedTriggers(st, triggers);
                                return; // start over for this trigger element!
                            }
                            dif += trig.start;
                            pins.offset = -trig.start; // edge case when a clamped effect starts mid-pin, we've gotta compensate in the onUpdate algorithm.
                        }
                        pins.push({
                            start: trig.start,
                            nativeStart: nativeStart,
                            end: trig.end,
                            distance: dif,
                            trig: trig
                        });
                        st.setPositions(st.start, st.end + (isClamped ? -trig.start : dif), true);
                    }
                }
            }
        }, adjustParallaxPosition = function adjustParallaxPosition(triggers, createdAfterEffectWasApplied) {
            effects.forEach(function(st) {
                return adjustEffectRelatedTriggers(st, triggers, createdAfterEffectWasApplied);
            });
        }, onRefresh = function onRefresh() {
            _docEl = _doc.documentElement; // some frameworks like Astro may cache the <body> and replace it during routing, so we'll just re-record the _docEl and _body for safety (otherwise, the markers may not get added properly).
            _body = _doc.body;
            removeScroll();
            requestAnimationFrame(removeScroll);
            if (effects) {
                // adjust all the effect start/end positions including any pins!
                ScrollTrigger.getAll().forEach(function(st) {
                    // record the native start/end positions because we'll be messing with them and need a way to have a "source of truth"
                    st._startNative = st.start;
                    st._endNative = st.end;
                });
                effects.forEach(function(st) {
                    var start = st._startClamp || st.start, // if it was already clamped, we should base things on the unclamped value and then do the clamping here.
                    end = st.autoSpeed ? Math.min(_maxScroll(), st.end) : start + Math.abs((st.end - start) / st.ratio), offset = end - st.end; // we split the difference so that it reaches its natural position in the MIDDLE of the viewport
                    start -= offset / 2;
                    end -= offset / 2;
                    if (start > end) {
                        var s = start;
                        start = end;
                        end = s;
                    }
                    if (st._startClamp && start < 0) {
                        end = st.ratio < 0 ? _maxScroll() : st.end / st.ratio;
                        offset = end - st.end;
                        start = 0;
                    } else if (st.ratio < 0 || st._endClamp && end >= _maxScroll()) {
                        end = _maxScroll();
                        start = st.ratio < 0 ? 0 : st.ratio > 1 ? 0 : end - (end - st.start) / st.ratio;
                        offset = (end - start) * st.ratio - (st.end - st.start);
                    }
                    st.offset = offset || 0.0001; // we assign at least a tiny value because we check in the onUpdate for .offset being set in order to apply values.
                    st.pins.length = st.pins.offset = 0;
                    st.setPositions(start, end, true); // note: another way of getting only the amount of offset traveled for a certain ratio is: distanceBetweenStartAndEnd * (1 / ratio - 1)
                });
                adjustParallaxPosition(ScrollTrigger.sort());
            }
            tracker.reset();
        }, addOnRefresh = function addOnRefresh() {
            return ScrollTrigger.addEventListener("refresh", onRefresh);
        }, restoreEffects = function restoreEffects() {
            return effects && effects.forEach(function(st) {
                return st.vars.onRefresh(st);
            });
        }, revertEffects = function revertEffects() {
            effects && effects.forEach(function(st) {
                return st.vars.onRefreshInit(st);
            });
            return restoreEffects;
        }, effectValueGetter = function effectValueGetter(name, value, index, el) {
            return function() {
                var v = typeof value === "function" ? value(index, el) : value;
                v || v === 0 || (v = el.getAttribute("data-" + effectsPrefix + name) || (name === "speed" ? 1 : 0));
                el.setAttribute("data-" + effectsPrefix + name, v);
                var clamp = (v + "").substr(0, 6) === "clamp(";
                return {
                    clamp: clamp,
                    value: clamp ? v.substr(6, v.length - 7) : v
                };
            };
        }, createEffect = function createEffect(el, speed, lag, index, effectsPadding) {
            effectsPadding = (typeof effectsPadding === "function" ? effectsPadding(index, el) : effectsPadding) || 0;
            var getSpeed = effectValueGetter("speed", speed, index, el), getLag = effectValueGetter("lag", lag, index, el), startY = gsap.getProperty(el, "y"), cache = el._gsap, ratio, st, autoSpeed, scrub, progressOffset, yOffset, pins = [], initDynamicValues = function initDynamicValues() {
                speed = getSpeed();
                lag = parseFloat(getLag().value);
                ratio = parseFloat(speed.value) || 1;
                autoSpeed = speed.value === "auto";
                progressOffset = autoSpeed || st && st._startClamp && st.start <= 0 || pins.offset ? 0 : st && st._endClamp && st.end === _maxScroll() ? 1 : 0.5;
                scrub && scrub.kill();
                scrub = lag && gsap.to(el, {
                    ease: _expo,
                    overwrite: false,
                    y: "+=0",
                    duration: lag
                });
                if (st) {
                    st.ratio = ratio;
                    st.autoSpeed = autoSpeed;
                }
            }, revert = function revert() {
                cache.y = startY + "px";
                cache.renderTransform(1);
                initDynamicValues();
            }, markers = [], change = 0, updateChange = function updateChange(self) {
                if (autoSpeed) {
                    revert();
                    var auto = _autoDistance(el, _clamp(0, 1, -self.start / (self.end - self.start)));
                    change = auto.change;
                    yOffset = auto.offset;
                } else {
                    yOffset = pins.offset || 0;
                    change = (self.end - self.start - yOffset) * (1 - ratio);
                }
                pins.forEach(function(p) {
                    return change -= p.distance * (1 - ratio);
                });
                self.offset = change || 0.001;
                self.vars.onUpdate(self);
                scrub && scrub.progress(1);
            };
            initDynamicValues();
            if (ratio !== 1 || autoSpeed || scrub) {
                st = ScrollTrigger.create({
                    trigger: autoSpeed ? el.parentNode : el,
                    start: function start() {
                        return speed.clamp ? "clamp(top bottom+=" + effectsPadding + ")" : "top bottom+=" + effectsPadding;
                    },
                    end: function end() {
                        return speed.value < 0 ? "max" : speed.clamp ? "clamp(bottom top-=" + effectsPadding + ")" : "bottom top-=" + effectsPadding;
                    },
                    scroller: wrapper,
                    scrub: true,
                    refreshPriority: -999,
                    // must update AFTER any other ScrollTrigger pins
                    onRefreshInit: revert,
                    onRefresh: updateChange,
                    onKill: function onKill(self) {
                        var i = effects.indexOf(self);
                        i >= 0 && effects.splice(i, 1);
                        revert();
                    },
                    onUpdate: function onUpdate(self) {
                        var y = startY + change * (self.progress - progressOffset), i = pins.length, extraY = 0, pin, scrollY, end;
                        if (self.offset) {
                            // wait until the effects are adjusted.
                            if (i) {
                                // pinning must be handled in a special way because when pinned, slope changes to 1.
                                scrollY = -currentY; // -scroll.y;
                                end = self.end;
                                while(i--){
                                    pin = pins[i];
                                    if (pin.trig.isActive || scrollY >= pin.start && scrollY <= pin.end) {
                                        // currently pinned so no need to set anything
                                        if (scrub) {
                                            pin.trig.progress += pin.trig.direction < 0 ? 0.001 : -0.001; // just to make absolutely sure that it renders (if the progress didn't change, it'll skip)
                                            pin.trig.update(0, 0, 1);
                                            scrub.resetTo("y", parseFloat(cache.y), -delta, true);
                                            startupPhase && scrub.progress(1);
                                        }
                                        return;
                                    }
                                    scrollY > pin.end && (extraY += pin.distance);
                                    end -= pin.distance;
                                }
                                y = startY + extraY + change * ((gsap.utils.clamp(self.start, self.end, scrollY) - self.start - extraY) / (end - self.start) - progressOffset);
                            }
                            markers.length && !autoSpeed && markers.forEach(function(setter) {
                                return setter(y - extraY);
                            });
                            y = _round(y + yOffset);
                            if (scrub) {
                                scrub.resetTo("y", y, -delta, true);
                                startupPhase && scrub.progress(1);
                            } else {
                                cache.y = y + "px";
                                cache.renderTransform(1);
                            }
                        }
                    }
                });
                updateChange(st);
                gsap.core.getCache(st.trigger).stRevert = revertEffects; // if user calls ScrollSmoother.create() with effects and THEN creates a ScrollTrigger on the same trigger element, the effect would throw off the start/end positions thus we needed a way to revert things when creating a new ScrollTrigger in that scenario, so we use this stRevert property of the GSCache inside ScrollTrigger.
                st.startY = startY;
                st.pins = pins;
                st.markers = markers;
                st.ratio = ratio;
                st.autoSpeed = autoSpeed;
                el.style.willChange = "transform";
            }
            return st;
        };
        addOnRefresh();
        ScrollTrigger.addEventListener("killAll", addOnRefresh);
        gsap.delayedCall(0.5, function() {
            return startupPhase = 0;
        });
        this.scrollTop = scrollTop;
        this.scrollTo = function(target, smooth, position) {
            var p = gsap.utils.clamp(0, _maxScroll(), isNaN(target) ? _this.offset(target, position, !!smooth && !paused) : +target);
            !smooth ? scrollTop(p) : paused ? gsap.to(_this, {
                duration: smoothDuration,
                scrollTop: p,
                overwrite: "auto",
                ease: _expo
            }) : scrollFunc(p);
        };
        this.offset = function(target, position, ignoreSpeed) {
            target = _toArray(target)[0];
            var cssText = target.style.cssText, // because if there's an effect applied, we revert(). We need to restore.
            st = ScrollTrigger.create({
                trigger: target,
                start: position || "top top"
            }), y;
            if (effects) startupPhase ? ScrollTrigger.refresh() : adjustParallaxPosition([
                st
            ], true); // all the effects need to go through the initial full refresh() so that all the pins and ratios and offsets are set up. That's why we do a full refresh() if it's during the startupPhase.
            y = st.start / (ignoreSpeed ? speed : 1);
            st.kill(false);
            target.style.cssText = cssText;
            gsap.core.getCache(target).uncache = 1;
            return y;
        };
        function refreshHeight() {
            height = content.clientHeight;
            content.style.overflow = "visible";
            _body.style.height = _win.innerHeight + (height - _win.innerHeight) / speed + "px";
            return height - _win.innerHeight;
        }
        this.content = function(element) {
            if (arguments.length) {
                var newContent = _toArray(element || "#smooth-content")[0] || console.warn("ScrollSmoother needs a valid content element.") || _body.children[0];
                if (newContent !== content) {
                    content = newContent;
                    contentCSS = content.getAttribute("style") || "";
                    resizeObserver && resizeObserver.observe(content);
                    gsap.set(content, {
                        overflow: "visible",
                        width: "100%",
                        boxSizing: "border-box",
                        y: "+=0"
                    });
                    smoothDuration || gsap.set(content, {
                        clearProps: "transform"
                    });
                }
                return this;
            }
            return content;
        };
        this.wrapper = function(element) {
            if (arguments.length) {
                wrapper = _toArray(element || "#smooth-wrapper")[0] || _wrap(content);
                wrapperCSS = wrapper.getAttribute("style") || "";
                refreshHeight();
                gsap.set(wrapper, smoothDuration ? {
                    overflow: "hidden",
                    position: "fixed",
                    height: "100%",
                    width: "100%",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0
                } : {
                    overflow: "visible",
                    position: "relative",
                    width: "100%",
                    height: "auto",
                    top: "auto",
                    bottom: "auto",
                    left: "auto",
                    right: "auto"
                });
                return this;
            }
            return wrapper;
        };
        this.effects = function(targets, config) {
            var _effects;
            effects || (effects = []);
            if (!targets) return effects.slice(0);
            targets = _toArray(targets);
            targets.forEach(function(target) {
                var i = effects.length;
                while(i--)effects[i].trigger === target && effects[i].kill(); // will automatically splice() it from the effects Array in the onKill
            });
            config = config || {};
            var _config = config, speed = _config.speed, lag = _config.lag, effectsPadding = _config.effectsPadding, effectsToAdd = [], i, st;
            for(i = 0; i < targets.length; i++){
                st = createEffect(targets[i], speed, lag, i, effectsPadding);
                st && effectsToAdd.push(st);
            }
            (_effects = effects).push.apply(_effects, effectsToAdd);
            config.refresh !== false && ScrollTrigger.refresh(); // certain effects require a refresh to work properly
            return effectsToAdd;
        };
        this.sections = function(targets, config) {
            var _sections;
            sections || (sections = []);
            if (!targets) return sections.slice(0);
            var newSections = _toArray(targets).map(function(el) {
                return ScrollTrigger.create({
                    trigger: el,
                    start: "top 120%",
                    end: "bottom -20%",
                    onToggle: function onToggle(self) {
                        el.style.opacity = self.isActive ? "1" : "0";
                        el.style.pointerEvents = self.isActive ? "all" : "none";
                    }
                });
            });
            config && config.add ? (_sections = sections).push.apply(_sections, newSections) : sections = newSections.slice(0);
            return newSections;
        };
        this.content(vars.content);
        this.wrapper(vars.wrapper);
        this.render = function(y) {
            return render(y || y === 0 ? y : currentY);
        };
        this.getVelocity = function() {
            return tracker.getVelocity(-currentY);
        };
        ScrollTrigger.scrollerProxy(wrapper, {
            scrollTop: scrollTop,
            scrollHeight: function scrollHeight() {
                return refreshHeight() && _body.scrollHeight;
            },
            fixedMarkers: vars.fixedMarkers !== false && !!smoothDuration,
            content: content,
            getBoundingClientRect: function getBoundingClientRect() {
                return {
                    top: 0,
                    left: 0,
                    width: _win.innerWidth,
                    height: _win.innerHeight
                };
            }
        });
        ScrollTrigger.defaults({
            scroller: wrapper
        });
        var existingScrollTriggers = ScrollTrigger.getAll().filter(function(st) {
            return st.scroller === _win || st.scroller === wrapper;
        });
        existingScrollTriggers.forEach(function(st) {
            return st.revert(true, true);
        }); // in case it's in an environment like React where child components that have ScrollTriggers instantiate BEFORE the parent that does ScrollSmoother.create(...);
        mainST = ScrollTrigger.create({
            animation: gsap.fromTo(scroll, {
                y: function y() {
                    allowUpdates = 0;
                    return 0;
                }
            }, {
                y: function y() {
                    allowUpdates = 1;
                    return -refreshHeight();
                },
                immediateRender: false,
                ease: "none",
                data: "ScrollSmoother",
                duration: 100,
                // for added precision
                onUpdate: function onUpdate() {
                    if (allowUpdates) {
                        // skip when it's the "from" part of the tween (setting the startAt)
                        var force = isProxyScrolling;
                        if (force) {
                            killScrub(mainST);
                            scroll.y = currentY;
                        }
                        render(scroll.y, force);
                        updateVelocity();
                        _onUpdate && !paused && _onUpdate(self);
                    }
                }
            }),
            onRefreshInit: function onRefreshInit(self) {
                if (ScrollSmoother.isRefreshing) // gets called on the onRefresh() when we do self.setPositions(...) in which case we should skip this
                return;
                ScrollSmoother.isRefreshing = true;
                if (effects) {
                    var _pins = ScrollTrigger.getAll().filter(function(st) {
                        return !!st.pin;
                    });
                    effects.forEach(function(st) {
                        if (!st.vars.pinnedContainer) _pins.forEach(function(pinST) {
                            if (pinST.pin.contains(st.trigger)) {
                                var v = st.vars;
                                v.pinnedContainer = pinST.pin;
                                st.vars = null; // otherwise, it'll self.kill(), triggering the onKill()
                                st.init(v, st.animation);
                            }
                        });
                    });
                }
                var scrub = self.getTween();
                recordedRefreshScrub = scrub && scrub._end > scrub._dp._time; // don't use scrub.progress() < 1 because we may have called killScrub() recently in which case it'll report progress() as 1 when we were actually in the middle of a scrub. That's why we tap into the _end instead.
                recordedRefreshScroll = currentY;
                scroll.y = 0;
                if (smoothDuration) {
                    ScrollTrigger.isTouch === 1 && (wrapper.style.position = "absolute"); // Safari 16 has a major bug - if you set wrapper.scrollTop to 0 (even if it's already 0), it blocks the whole page from scrolling page non-scrollable! See https://bugs.webkit.org/show_bug.cgi?id=245300 and https://codepen.io/GreenSock/pen/YzLZVOz. Originally we set pointer-events: none on the wrapper temporarily, and set it back to all after setting scrollTop to 0, but that could cause mouseenter/mouseleave/etc. events to fire too, so we opted to set the position to absolute and then back to fixed after setting scrollTop.
                    wrapper.scrollTop = 0; // set wrapper.scrollTop to 0 because in some very rare situations, the browser will auto-set that, like if there's a hash in the link or changing focus to an off-screen input
                    ScrollTrigger.isTouch === 1 && (wrapper.style.position = "fixed");
                }
            },
            onRefresh: function onRefresh(self) {
                self.animation.invalidate(); // because pinnedContainers may have been found in ScrollTrigger's _refreshAll() that extend the height. Without this, it may prevent the user from being able to scroll all the way down.
                scroll.y = 0; // since we invalidated the tween, we must reset scroll.y to 0, otherwise when the tween inits it'll record the current scroll.y as the pre-fromTo(), thus when ScrollTrigger calls revert(), it'll set it back to that old value! See https://gsap.com/community/forums/topic/45138-scrollsmoother-stops-and-scrolltrigger-misaligned-in-browser-dev-tools/
                self.setPositions(self.start, refreshHeight() / speed);
                recordedRefreshScrub || killScrub(self);
                scroll.y = -scrollFunc() * speed; // in 3.11.1, we shifted to forcing the scroll position to 0 during the entire refreshAll() in ScrollTrigger and then restored the scroll position AFTER everything had been updated, thus we should always make these adjustments AFTER a full refresh rather than putting it in the onRefresh() of the individual mainST ScrollTrigger which would fire before the scroll position was restored.
                render(scroll.y);
                if (!startupPhase) {
                    recordedRefreshScrub && (isProxyScrolling = false); // otherwise, we lose any in-progress scrub. When we set the progress(), it fires the onUpdate() which sets the scroll position immediately (jumps ahead if isProxyScrolling is true). See https://gsap.com/community/forums/topic/37515-dynamic-scrolltrigger-with-pin-inside-a-scrollsmoother/
                    self.animation.progress(gsap.utils.clamp(0, 1, recordedRefreshScroll / speed / -self.end));
                }
                if (recordedRefreshScrub) {
                    // we need to trigger the scrub to happen again
                    self.progress -= 0.001;
                    self.update();
                }
                ScrollSmoother.isRefreshing = false;
            },
            id: "ScrollSmoother",
            scroller: _win,
            invalidateOnRefresh: true,
            start: 0,
            refreshPriority: -9999,
            // because all other pins, etc. should be calculated first before this figures out the height of the body. BUT this should also update FIRST so that the scroll position on the proxy is up-to-date when all the ScrollTriggers calculate their progress! -9999 is a special number that ScrollTrigger looks for to handle in this way.
            end: function end() {
                return refreshHeight() / speed;
            },
            onScrubComplete: function onScrubComplete() {
                tracker.reset();
                onStop && onStop(_this);
            },
            scrub: smoothDuration || true
        });
        this.smooth = function(value) {
            if (arguments.length) {
                smoothDuration = value || 0;
                speed = smoothDuration && +vars.speed || 1;
                mainST.scrubDuration(value);
            }
            return mainST.getTween() ? mainST.getTween().duration() : 0;
        };
        mainST.getTween() && (mainST.getTween().vars.ease = vars.ease || _expo);
        this.scrollTrigger = mainST;
        vars.effects && this.effects(vars.effects === true ? "[data-" + effectsPrefix + "speed], [data-" + effectsPrefix + "lag]" : vars.effects, {
            effectsPadding: vars.effectsPadding,
            refresh: false
        });
        vars.sections && this.sections(vars.sections === true ? "[data-section]" : vars.sections);
        existingScrollTriggers.forEach(function(st) {
            st.vars.scroller = wrapper;
            st.revert(false, true);
            st.init(st.vars, st.animation);
        });
        this.paused = function(value, allowNestedScroll) {
            if (arguments.length) {
                if (!!paused !== value) {
                    if (value) {
                        // pause
                        mainST.getTween() && mainST.getTween().pause();
                        scrollFunc(-currentY / speed);
                        tracker.reset();
                        pausedNormalizer = ScrollTrigger.normalizeScroll();
                        pausedNormalizer && pausedNormalizer.disable(); // otherwise the normalizer would try to scroll the page on things like wheel events.
                        paused = ScrollTrigger.observe({
                            preventDefault: true,
                            type: "wheel,touch,scroll",
                            debounce: false,
                            allowClicks: true,
                            onChangeY: function onChangeY() {
                                return scrollTop(-currentY);
                            } // refuse to scroll
                        });
                        paused.nested = _inputObserver(_docEl, "wheel,touch,scroll", true, allowNestedScroll !== false); // allow nested scrolling, like modals
                    } else {
                        // resume
                        paused.nested.kill();
                        paused.kill();
                        paused = 0;
                        pausedNormalizer && pausedNormalizer.enable();
                        mainST.progress = (-currentY / speed - mainST.start) / (mainST.end - mainST.start);
                        killScrub(mainST);
                    }
                }
                return this;
            }
            return !!paused;
        };
        this.kill = this.revert = function() {
            _this.paused(false);
            killScrub(mainST);
            mainST.kill();
            var triggers = (effects || []).concat(sections || []), i = triggers.length;
            while(i--)// make sure we go backwards because the onKill() will effects.splice(index, 1) and we don't want to skip
            triggers[i].kill();
            ScrollTrigger.scrollerProxy(wrapper);
            ScrollTrigger.removeEventListener("killAll", addOnRefresh);
            ScrollTrigger.removeEventListener("refresh", onRefresh);
            wrapper.style.cssText = wrapperCSS;
            content.style.cssText = contentCSS;
            var defaults = ScrollTrigger.defaults({});
            defaults && defaults.scroller === wrapper && ScrollTrigger.defaults({
                scroller: _win
            });
            _this.normalizer && ScrollTrigger.normalizeScroll(false);
            clearInterval(intervalID);
            _mainInstance = null;
            resizeObserver && resizeObserver.disconnect();
            _body.style.removeProperty("height");
            _win.removeEventListener("focusin", _onFocusIn);
        };
        this.refresh = function(soft, force) {
            return mainST.refresh(soft, force);
        };
        if (normalizeScroll) this.normalizer = ScrollTrigger.normalizeScroll(normalizeScroll === true ? {
            debounce: true,
            content: !smoothDuration && content
        } : normalizeScroll);
        ScrollTrigger.config(vars); // in case user passes in ignoreMobileResize for example
        // ("overscrollBehavior" in _win.getComputedStyle(_body)) && gsap.set([_body, _docEl], {overscrollBehavior: "none"}); // this caused Safari 17+ not to scroll the entire page (bug in Safari), so let people set this in the CSS instead if they want.
        "scrollBehavior" in _win.getComputedStyle(_body) && gsap.set([
            _body,
            _docEl
        ], {
            scrollBehavior: "auto"
        }); // if the user hits the tab key (or whatever) to shift focus to an element that's off-screen, center that element.
        _win.addEventListener("focusin", _onFocusIn);
        intervalID = setInterval(updateVelocity, 250);
        _doc.readyState === "loading" || requestAnimationFrame(function() {
            return ScrollTrigger.refresh();
        });
    }
    ScrollSmoother.register = function register(core) {
        if (!_coreInitted) {
            gsap = core || _getGSAP();
            if (_windowExists() && window.document) {
                _win = window;
                _doc = document;
                _docEl = _doc.documentElement;
                _body = _doc.body;
            }
            if (gsap) {
                _toArray = gsap.utils.toArray;
                _clamp = gsap.utils.clamp;
                _expo = gsap.parseEase("expo");
                _context = gsap.core.context || function() {};
                ScrollTrigger = gsap.core.globals().ScrollTrigger;
                gsap.core.globals("ScrollSmoother", ScrollSmoother); // must register the global manually because in Internet Explorer, functions (classes) don't have a "name" property.
                if (_body && ScrollTrigger) {
                    _onResizeDelayedCall = gsap.delayedCall(0.2, function() {
                        return ScrollTrigger.isRefreshing || _mainInstance && _mainInstance.refresh();
                    }).pause();
                    _root = [
                        _win,
                        _doc,
                        _docEl,
                        _body
                    ];
                    _getVelocityProp = ScrollTrigger.core._getVelocityProp;
                    _inputObserver = ScrollTrigger.core._inputObserver;
                    ScrollSmoother.refresh = ScrollTrigger.refresh;
                    _coreInitted = 1;
                }
            }
        }
        return _coreInitted;
    };
    _createClass(ScrollSmoother, [
        {
            key: "progress",
            get: function get() {
                return this.scrollTrigger ? this.scrollTrigger.animation._time / 100 : 0;
            }
        }
    ]);
    return ScrollSmoother;
}();
ScrollSmoother.version = "3.14.2";
ScrollSmoother.create = function(vars) {
    return _mainInstance && vars && _mainInstance.content() === _toArray(vars.content)[0] ? _mainInstance : new ScrollSmoother(vars);
};
ScrollSmoother.get = function() {
    return _mainInstance;
};
_getGSAP() && gsap.registerPlugin(ScrollSmoother);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fqoay":[function(require,module,exports,__globalThis) {
/*!
 * ScrollToPlugin 3.14.2
 * https://gsap.com
 *
 * @license Copyright 2008-2025, GreenSock. All rights reserved.
 * Subject to the terms at https://gsap.com/standard-license
 * @author: Jack Doyle, jack@greensock.com
*/ /* eslint-disable */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScrollToPlugin", ()=>ScrollToPlugin);
parcelHelpers.export(exports, "default", ()=>ScrollToPlugin);
var gsap, _coreInitted, _window, _docEl, _body, _toArray, _config, ScrollTrigger, _windowExists = function _windowExists() {
    return typeof window !== "undefined";
}, _getGSAP = function _getGSAP() {
    return gsap || _windowExists() && (gsap = window.gsap) && gsap.registerPlugin && gsap;
}, _isString = function _isString(value) {
    return typeof value === "string";
}, _isFunction = function _isFunction(value) {
    return typeof value === "function";
}, _max = function _max(element, axis) {
    var dim = axis === "x" ? "Width" : "Height", scroll = "scroll" + dim, client = "client" + dim;
    return element === _window || element === _docEl || element === _body ? Math.max(_docEl[scroll], _body[scroll]) - (_window["inner" + dim] || _docEl[client] || _body[client]) : element[scroll] - element["offset" + dim];
}, _buildGetter = function _buildGetter(e, axis) {
    //pass in an element and an axis ("x" or "y") and it'll return a getter function for the scroll position of that element (like scrollTop or scrollLeft, although if the element is the window, it'll use the pageXOffset/pageYOffset or the documentElement's scrollTop/scrollLeft or document.body's. Basically this streamlines things and makes a very fast getter across browsers.
    var p = "scroll" + (axis === "x" ? "Left" : "Top");
    if (e === _window) {
        if (e.pageXOffset != null) p = "page" + axis.toUpperCase() + "Offset";
        else e = _docEl[p] != null ? _docEl : _body;
    }
    return function() {
        return e[p];
    };
}, _clean = function _clean(value, index, target, targets) {
    _isFunction(value) && (value = value(index, target, targets));
    if (typeof value !== "object") return _isString(value) && value !== "max" && value.charAt(1) !== "=" ? {
        x: value,
        y: value
    } : {
        y: value
    }; //if we don't receive an object as the parameter, assume the user intends "y".
    else if (value.nodeType) return {
        y: value,
        x: value
    };
    else {
        var result = {}, p;
        for(p in value)result[p] = p !== "onAutoKill" && _isFunction(value[p]) ? value[p](index, target, targets) : value[p];
        return result;
    }
}, _getOffset = function _getOffset(element, container) {
    element = _toArray(element)[0];
    if (!element || !element.getBoundingClientRect) return console.warn("scrollTo target doesn't exist. Using 0") || {
        x: 0,
        y: 0
    };
    var rect = element.getBoundingClientRect(), isRoot = !container || container === _window || container === _body, cRect = isRoot ? {
        top: _docEl.clientTop - (_window.pageYOffset || _docEl.scrollTop || _body.scrollTop || 0),
        left: _docEl.clientLeft - (_window.pageXOffset || _docEl.scrollLeft || _body.scrollLeft || 0)
    } : container.getBoundingClientRect(), offsets = {
        x: rect.left - cRect.left,
        y: rect.top - cRect.top
    };
    if (!isRoot && container) {
        //only add the current scroll position if it's not the window/body.
        offsets.x += _buildGetter(container, "x")();
        offsets.y += _buildGetter(container, "y")();
    }
    return offsets;
}, _parseVal = function _parseVal(value, target, axis, currentVal, offset) {
    return !isNaN(value) && typeof value !== "object" ? parseFloat(value) - offset : _isString(value) && value.charAt(1) === "=" ? parseFloat(value.substr(2)) * (value.charAt(0) === "-" ? -1 : 1) + currentVal - offset : value === "max" ? _max(target, axis) - offset : Math.min(_max(target, axis), _getOffset(value, target)[axis] - offset);
}, _initCore = function _initCore() {
    gsap = _getGSAP();
    if (_windowExists() && gsap && typeof document !== "undefined" && document.body) {
        _window = window;
        _body = document.body;
        _docEl = document.documentElement;
        _toArray = gsap.utils.toArray;
        gsap.config({
            autoKillThreshold: 7
        });
        _config = gsap.config();
        _coreInitted = 1;
    }
};
var ScrollToPlugin = {
    version: "3.14.2",
    name: "scrollTo",
    rawVars: 1,
    register: function register(core) {
        gsap = core;
        _initCore();
    },
    init: function init(target, value, tween, index, targets) {
        _coreInitted || _initCore();
        var data = this, snapType = gsap.getProperty(target, "scrollSnapType");
        data.isWin = target === _window;
        data.target = target;
        data.tween = tween;
        value = _clean(value, index, target, targets);
        data.vars = value;
        data.autoKill = !!("autoKill" in value ? value : _config).autoKill;
        data.getX = _buildGetter(target, "x");
        data.getY = _buildGetter(target, "y");
        data.x = data.xPrev = data.getX();
        data.y = data.yPrev = data.getY();
        ScrollTrigger || (ScrollTrigger = gsap.core.globals().ScrollTrigger);
        gsap.getProperty(target, "scrollBehavior") === "smooth" && gsap.set(target, {
            scrollBehavior: "auto"
        });
        if (snapType && snapType !== "none") {
            // disable scroll snapping to avoid strange behavior
            data.snap = 1;
            data.snapInline = target.style.scrollSnapType;
            target.style.scrollSnapType = "none";
        }
        if (value.x != null) {
            data.add(data, "x", data.x, _parseVal(value.x, target, "x", data.x, value.offsetX || 0), index, targets);
            data._props.push("scrollTo_x");
        } else data.skipX = 1;
        if (value.y != null) {
            data.add(data, "y", data.y, _parseVal(value.y, target, "y", data.y, value.offsetY || 0), index, targets);
            data._props.push("scrollTo_y");
        } else data.skipY = 1;
    },
    render: function render(ratio, data) {
        var pt = data._pt, target = data.target, tween = data.tween, autoKill = data.autoKill, xPrev = data.xPrev, yPrev = data.yPrev, isWin = data.isWin, snap = data.snap, snapInline = data.snapInline, x, y, yDif, xDif, threshold;
        while(pt){
            pt.r(ratio, pt.d);
            pt = pt._next;
        }
        x = isWin || !data.skipX ? data.getX() : xPrev;
        y = isWin || !data.skipY ? data.getY() : yPrev;
        yDif = y - yPrev;
        xDif = x - xPrev;
        threshold = _config.autoKillThreshold;
        if (data.x < 0) //can't scroll to a position less than 0! Might happen if someone uses a Back.easeOut or Elastic.easeOut when scrolling back to the top of the page (for example)
        data.x = 0;
        if (data.y < 0) data.y = 0;
        if (autoKill) {
            //note: iOS has a bug that throws off the scroll by several pixels, so we need to check if it's within 7 pixels of the previous one that we set instead of just looking for an exact match.
            if (!data.skipX && (xDif > threshold || xDif < -threshold) && x < _max(target, "x")) data.skipX = 1; //if the user scrolls separately, we should stop tweening!
            if (!data.skipY && (yDif > threshold || yDif < -threshold) && y < _max(target, "y")) data.skipY = 1; //if the user scrolls separately, we should stop tweening!
            if (data.skipX && data.skipY) {
                tween.kill();
                data.vars.onAutoKill && data.vars.onAutoKill.apply(tween, data.vars.onAutoKillParams || []);
            }
        }
        if (isWin) _window.scrollTo(!data.skipX ? data.x : x, !data.skipY ? data.y : y);
        else {
            data.skipY || (target.scrollTop = data.y);
            data.skipX || (target.scrollLeft = data.x);
        }
        if (snap && (ratio === 1 || ratio === 0)) {
            y = target.scrollTop;
            x = target.scrollLeft;
            snapInline ? target.style.scrollSnapType = snapInline : target.style.removeProperty("scroll-snap-type");
            target.scrollTop = y + 1; // bug in Safari causes the element to totally reset its scroll position when scroll-snap-type changes, so we need to set it to a slightly different value and then back again to work around this bug.
            target.scrollLeft = x + 1;
            target.scrollTop = y;
            target.scrollLeft = x;
        }
        data.xPrev = data.x;
        data.yPrev = data.y;
        ScrollTrigger && ScrollTrigger.update();
    },
    kill: function kill(property) {
        var both = property === "scrollTo", i = this._props.indexOf(property);
        if (both || property === "scrollTo_x") this.skipX = 1;
        if (both || property === "scrollTo_y") this.skipY = 1;
        i > -1 && this._props.splice(i, 1);
        return !this._props.length;
    }
};
ScrollToPlugin.max = _max;
ScrollToPlugin.getOffset = _getOffset;
ScrollToPlugin.buildGetter = _buildGetter;
ScrollToPlugin.config = function(vars) {
    _config || _initCore() || (_config = gsap.config()); // in case the window hasn't been defined yet.
    for(var p in vars)_config[p] = vars[p];
};
_getGSAP() && gsap.registerPlugin(ScrollToPlugin);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bhBQM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTopBackgroundPin);
var _react = require("react");
var _gsapSetupTs = require("src/utils/gsapSetup.ts");
var _gsapSetupTsDefault = parcelHelpers.interopDefault(_gsapSetupTs);
function useTopBackgroundPin({ topBgPinSelector, backgroundImageSelector, scrollHeight }) {
    (0, _react.useEffect)(()=>{
        const ctx = (0, _gsapSetupTsDefault.default).context(()=>{
            const tl = (0, _gsapSetupTsDefault.default).timeline({
                scrollTrigger: {
                    trigger: topBgPinSelector,
                    start: 'top top',
                    end: `+=${scrollHeight - 260}`,
                    scrub: true,
                    pin: true,
                    pinSpacing: false,
                    markers: false,
                    invalidateOnRefresh: true
                }
            });
            tl.fromTo(backgroundImageSelector, {
                opacity: 1
            }, {
                opacity: 0,
                ease: 'none'
            }, 0.9);
        });
        return ()=>ctx.revert();
    }, [
        topBgPinSelector,
        backgroundImageSelector,
        scrollHeight
    ]);
}

},{"react":"bmhQu","src/utils/gsapSetup.ts":"8koI4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iJUg0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CanvasWrapper", ()=>CanvasWrapper);
var _jsxRuntime = require("react/jsx-runtime");
var _fiber = require("@react-three/fiber");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const toEven = (v)=>v % 2 === 0 ? v : v - 1;
const getViewportSize = ()=>({
        width: toEven(Math.floor(window.innerWidth)),
        height: toEven(Math.floor(window.innerHeight))
    });
const RESIZE_DEBOUNCE_MS = 1000;
const CanvasWrapper = /*#__PURE__*/ (0, _react.memo)(({ children, canvasProps })=>{
    const [size, setSize] = (0, _react.useState)(getViewportSize);
    const resizeTimeout = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const onResize = ()=>{
            if (resizeTimeout.current != null) clearTimeout(resizeTimeout.current);
            resizeTimeout.current = window.setTimeout(()=>{
                const { width, height } = getViewportSize();
                setSize((prev)=>prev.width === width && prev.height === height ? prev : {
                        width,
                        height
                    });
            }, RESIZE_DEBOUNCE_MS);
        };
        window.addEventListener('resize', onResize);
        window.addEventListener('orientationchange', onResize);
        onResize();
        return ()=>{
            window.removeEventListener('resize', onResize);
            window.removeEventListener('orientationchange', onResize);
            if (resizeTimeout.current != null) clearTimeout(resizeTimeout.current);
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {},
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _fiber.Canvas), {
            style: {
                width: size.width,
                height: size.height
            },
            ...canvasProps,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)(InvalidateOnResize, {}),
                children
            ]
        })
    });
});
CanvasWrapper.displayName = 'CanvasWrapper';
const InvalidateOnResize = ()=>{
    const { invalidate } = (0, _fiber.useThree)();
    const timeout = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const handle = ()=>{
            if (timeout.current != null) clearTimeout(timeout.current);
            timeout.current = window.setTimeout(()=>{
                invalidate();
            }, RESIZE_DEBOUNCE_MS);
        };
        window.addEventListener('resize', handle);
        return ()=>{
            window.removeEventListener('resize', handle);
            if (timeout.current != null) clearTimeout(timeout.current);
        };
    }, [
        invalidate
    ]);
    return null;
};

},{"react/jsx-runtime":"gonF6","@react-three/fiber":[["Canvas","fhffm"],["useThree","4p4ya","C"]],"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fhffm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactThreeFiber", ()=>(0, _events1Eccaf1CEsmJs.t));
parcelHelpers.export(exports, "_roots", ()=>(0, _events1Eccaf1CEsmJs._));
parcelHelpers.export(exports, "act", ()=>(0, _events1Eccaf1CEsmJs.x));
parcelHelpers.export(exports, "addAfterEffect", ()=>(0, _events1Eccaf1CEsmJs.k));
parcelHelpers.export(exports, "addEffect", ()=>(0, _events1Eccaf1CEsmJs.j));
parcelHelpers.export(exports, "addTail", ()=>(0, _events1Eccaf1CEsmJs.l));
parcelHelpers.export(exports, "advance", ()=>(0, _events1Eccaf1CEsmJs.n));
parcelHelpers.export(exports, "applyProps", ()=>(0, _events1Eccaf1CEsmJs.s));
parcelHelpers.export(exports, "buildGraph", ()=>(0, _events1Eccaf1CEsmJs.y));
parcelHelpers.export(exports, "context", ()=>(0, _events1Eccaf1CEsmJs.q));
parcelHelpers.export(exports, "createEvents", ()=>(0, _events1Eccaf1CEsmJs.g));
parcelHelpers.export(exports, "createPortal", ()=>(0, _events1Eccaf1CEsmJs.o));
parcelHelpers.export(exports, "createRoot", ()=>(0, _events1Eccaf1CEsmJs.c));
parcelHelpers.export(exports, "dispose", ()=>(0, _events1Eccaf1CEsmJs.w));
parcelHelpers.export(exports, "events", ()=>(0, _events1Eccaf1CEsmJs.f));
parcelHelpers.export(exports, "extend", ()=>(0, _events1Eccaf1CEsmJs.e));
parcelHelpers.export(exports, "flushGlobalEffects", ()=>(0, _events1Eccaf1CEsmJs.h));
parcelHelpers.export(exports, "flushSync", ()=>(0, _events1Eccaf1CEsmJs.p));
parcelHelpers.export(exports, "getRootState", ()=>(0, _events1Eccaf1CEsmJs.v));
parcelHelpers.export(exports, "invalidate", ()=>(0, _events1Eccaf1CEsmJs.m));
parcelHelpers.export(exports, "reconciler", ()=>(0, _events1Eccaf1CEsmJs.r));
parcelHelpers.export(exports, "unmountComponentAtNode", ()=>(0, _events1Eccaf1CEsmJs.d));
parcelHelpers.export(exports, "useFrame", ()=>(0, _events1Eccaf1CEsmJs.D));
parcelHelpers.export(exports, "useGraph", ()=>(0, _events1Eccaf1CEsmJs.F));
parcelHelpers.export(exports, "useInstanceHandle", ()=>(0, _events1Eccaf1CEsmJs.z));
parcelHelpers.export(exports, "useLoader", ()=>(0, _events1Eccaf1CEsmJs.G));
parcelHelpers.export(exports, "useStore", ()=>(0, _events1Eccaf1CEsmJs.A));
parcelHelpers.export(exports, "useThree", ()=>(0, _events1Eccaf1CEsmJs.C));
parcelHelpers.export(exports, "Canvas", ()=>Canvas);
var _events1Eccaf1CEsmJs = require("./events-1eccaf1c.esm.js");
var _react = require("react");
var _three = require("three");
var _reactUseMeasure = require("react-use-measure");
var _reactUseMeasureDefault = parcelHelpers.interopDefault(_reactUseMeasure);
var _itsFine = require("its-fine");
var _jsxRuntime = require("react/jsx-runtime");
var _constants = require("react-reconciler/constants");
var _traditional = require("zustand/traditional");
var _suspendReact = require("suspend-react");
var _reactReconciler = require("react-reconciler");
var _scheduler = require("scheduler");
function CanvasImpl({ ref, children, fallback, resize, style, gl, events = (0, _events1Eccaf1CEsmJs.f), eventSource, eventPrefix, shadows, linear, flat, legacy, orthographic, frameloop, dpr, performance, raycaster, camera, scene, onPointerMissed, onCreated, ...props }) {
    // Create a known catalogue of Threejs-native elements
    // This will include the entire THREE namespace by default, users can extend
    // their own elements by using the createRoot API instead
    _react.useMemo(()=>(0, _events1Eccaf1CEsmJs.e)(_three), []);
    const Bridge = (0, _events1Eccaf1CEsmJs.u)();
    const [containerRef, containerRect] = (0, _reactUseMeasureDefault.default)({
        scroll: true,
        debounce: {
            scroll: 50,
            resize: 0
        },
        ...resize
    });
    const canvasRef = _react.useRef(null);
    const divRef = _react.useRef(null);
    _react.useImperativeHandle(ref, ()=>canvasRef.current);
    const handlePointerMissed = (0, _events1Eccaf1CEsmJs.a)(onPointerMissed);
    const [block, setBlock] = _react.useState(false);
    const [error, setError] = _react.useState(false);
    // Suspend this component if block is a promise (2nd run)
    if (block) throw block;
    // Throw exception outwards if anything within canvas throws
    if (error) throw error;
    const root = _react.useRef(null);
    (0, _events1Eccaf1CEsmJs.b)(()=>{
        const canvas = canvasRef.current;
        if (containerRect.width > 0 && containerRect.height > 0 && canvas) {
            if (!root.current) root.current = (0, _events1Eccaf1CEsmJs.c)(canvas);
            async function run() {
                await root.current.configure({
                    gl,
                    scene,
                    events,
                    shadows,
                    linear,
                    flat,
                    legacy,
                    orthographic,
                    frameloop,
                    dpr,
                    performance,
                    raycaster,
                    camera,
                    size: containerRect,
                    // Pass mutable reference to onPointerMissed so it's free to update
                    onPointerMissed: (...args)=>handlePointerMissed.current == null ? void 0 : handlePointerMissed.current(...args),
                    onCreated: (state)=>{
                        // Connect to event source
                        state.events.connect == null || state.events.connect(eventSource ? (0, _events1Eccaf1CEsmJs.i)(eventSource) ? eventSource.current : eventSource : divRef.current);
                        // Set up compute function
                        if (eventPrefix) state.setEvents({
                            compute: (event, state)=>{
                                const x = event[eventPrefix + 'X'];
                                const y = event[eventPrefix + 'Y'];
                                state.pointer.set(x / state.size.width * 2 - 1, -(y / state.size.height) * 2 + 1);
                                state.raycaster.setFromCamera(state.pointer, state.camera);
                            }
                        });
                        // Call onCreated callback
                        onCreated == null || onCreated(state);
                    }
                });
                root.current.render(/*#__PURE__*/ (0, _jsxRuntime.jsx)(Bridge, {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _events1Eccaf1CEsmJs.E), {
                        set: setError,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Suspense, {
                            fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _events1Eccaf1CEsmJs.B), {
                                set: setBlock
                            }),
                            children: children != null ? children : null
                        })
                    })
                }));
            }
            run();
        }
    });
    _react.useEffect(()=>{
        const canvas = canvasRef.current;
        if (canvas) return ()=>(0, _events1Eccaf1CEsmJs.d)(canvas);
    }, []);
    // When the event source is not this div, we need to set pointer-events to none
    // Or else the canvas will block events from reaching the event source
    const pointerEvents = eventSource ? 'none' : 'auto';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: divRef,
        style: {
            position: 'relative',
            width: '100%',
            height: '100%',
            overflow: 'hidden',
            pointerEvents,
            ...style
        },
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            ref: containerRef,
            style: {
                width: '100%',
                height: '100%'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("canvas", {
                ref: canvasRef,
                style: {
                    display: 'block'
                },
                children: fallback
            })
        })
    });
}
/**
 * A DOM canvas which accepts threejs elements as children.
 * @see https://docs.pmnd.rs/react-three-fiber/api/canvas
 */ function Canvas(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _itsFine.FiberProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CanvasImpl, {
            ...props
        })
    });
}

},{"./events-1eccaf1c.esm.js":"4p4ya","react":"bmhQu","three":"hZcQL","react-use-measure":"leTe7","its-fine":"3eSSa","react/jsx-runtime":"gonF6","react-reconciler/constants":"dfuGR","zustand/traditional":"196jd","suspend-react":"hMPkZ","react-reconciler":"92rXo","scheduler":"dHubo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"leTe7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>j);
var _react = require("react");
function g(n, t) {
    let o;
    return (...i)=>{
        window.clearTimeout(o), o = window.setTimeout(()=>n(...i), t);
    };
}
function j({ debounce: n, scroll: t, polyfill: o, offsetSize: i } = {
    debounce: 0,
    scroll: !1,
    offsetSize: !1
}) {
    const a = o || (typeof window == "undefined" ? class {
    } : window.ResizeObserver);
    if (!a) throw new Error("This browser does not support ResizeObserver out of the box. See: https://github.com/react-spring/react-use-measure/#resize-observer-polyfills");
    const [c, h] = (0, _react.useState)({
        left: 0,
        top: 0,
        width: 0,
        height: 0,
        bottom: 0,
        right: 0,
        x: 0,
        y: 0
    }), e = (0, _react.useRef)({
        element: null,
        scrollContainers: null,
        resizeObserver: null,
        lastBounds: c,
        orientationHandler: null
    }), d = n ? typeof n == "number" ? n : n.scroll : null, f = n ? typeof n == "number" ? n : n.resize : null, w = (0, _react.useRef)(!1);
    (0, _react.useEffect)(()=>(w.current = !0, ()=>void (w.current = !1)));
    const [z, m, s] = (0, _react.useMemo)(()=>{
        const r = ()=>{
            if (!e.current.element) return;
            const { left: y, top: C, width: H, height: O, bottom: S, right: x, x: B, y: R } = e.current.element.getBoundingClientRect(), l = {
                left: y,
                top: C,
                width: H,
                height: O,
                bottom: S,
                right: x,
                x: B,
                y: R
            };
            e.current.element instanceof HTMLElement && i && (l.height = e.current.element.offsetHeight, l.width = e.current.element.offsetWidth), Object.freeze(l), w.current && !D(e.current.lastBounds, l) && h(e.current.lastBounds = l);
        };
        return [
            r,
            f ? g(r, f) : r,
            d ? g(r, d) : r
        ];
    }, [
        h,
        i,
        d,
        f
    ]);
    function v() {
        e.current.scrollContainers && (e.current.scrollContainers.forEach((r)=>r.removeEventListener("scroll", s, !0)), e.current.scrollContainers = null), e.current.resizeObserver && (e.current.resizeObserver.disconnect(), e.current.resizeObserver = null), e.current.orientationHandler && ("orientation" in screen && "removeEventListener" in screen.orientation ? screen.orientation.removeEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.removeEventListener("orientationchange", e.current.orientationHandler));
    }
    function b() {
        e.current.element && (e.current.resizeObserver = new a(s), e.current.resizeObserver.observe(e.current.element), t && e.current.scrollContainers && e.current.scrollContainers.forEach((r)=>r.addEventListener("scroll", s, {
                capture: !0,
                passive: !0
            })), e.current.orientationHandler = ()=>{
            s();
        }, "orientation" in screen && "addEventListener" in screen.orientation ? screen.orientation.addEventListener("change", e.current.orientationHandler) : "onorientationchange" in window && window.addEventListener("orientationchange", e.current.orientationHandler));
    }
    const L = (r)=>{
        !r || r === e.current.element || (v(), e.current.element = r, e.current.scrollContainers = E(r), b());
    };
    return X(s, !!t), W(m), (0, _react.useEffect)(()=>{
        v(), b();
    }, [
        t,
        s,
        m
    ]), (0, _react.useEffect)(()=>v, []), [
        L,
        c,
        z
    ];
}
function W(n) {
    (0, _react.useEffect)(()=>{
        const t = n;
        return window.addEventListener("resize", t), ()=>void window.removeEventListener("resize", t);
    }, [
        n
    ]);
}
function X(n, t) {
    (0, _react.useEffect)(()=>{
        if (t) {
            const o = n;
            return window.addEventListener("scroll", o, {
                capture: !0,
                passive: !0
            }), ()=>void window.removeEventListener("scroll", o, !0);
        }
    }, [
        n,
        t
    ]);
}
function E(n) {
    const t = [];
    if (!n || n === document.body) return t;
    const { overflow: o, overflowX: i, overflowY: a } = window.getComputedStyle(n);
    return [
        o,
        i,
        a
    ].some((c)=>c === "auto" || c === "scroll") && t.push(n), [
        ...t,
        ...E(n.parentElement)
    ];
}
const k = [
    "x",
    "y",
    "top",
    "bottom",
    "left",
    "right",
    "width",
    "height"
], D = (n, t)=>k.every((o)=>n[o] === t[o]);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hENG8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWindowDimensions);
var _react = require("react");
function getStableHeight() {
    return Math.max(window.innerHeight, window.visualViewport?.height ?? 0);
}
function useWindowDimensions() {
    const lockedHeightRef = (0, _react.useRef)(null);
    const [size, setSize] = (0, _react.useState)(()=>({
            width: window.innerWidth,
            height: getStableHeight()
        }));
    (0, _react.useEffect)(()=>{
        const handleResize = ()=>{
            const width = window.innerWidth;
            if (width <= 768) {
                if (lockedHeightRef.current == null) lockedHeightRef.current = getStableHeight();
                setSize({
                    width,
                    height: lockedHeightRef.current
                });
            } else // desktop: real resize
            setSize({
                width,
                height: window.innerHeight
            });
        };
        window.addEventListener('resize', handleResize);
        window.visualViewport?.addEventListener('resize', handleResize);
        return ()=>{
            window.removeEventListener('resize', handleResize);
            window.visualViewport?.removeEventListener('resize', handleResize);
        };
    }, []);
    return size;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hxErL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "uiStore", ()=>uiStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
const uiStore = (0, _zustand.create)()((0, _middleware.persist)((set)=>({
        waitlistModalVisible: false,
        quizModalVisible: false,
        videoPlayerVisible: false,
        videoPlayerLink: null,
        setWaitlistModalVisible: (visible)=>set({
                waitlistModalVisible: visible
            }),
        setQuizModalVisible: (visible)=>set({
                quizModalVisible: visible
            }),
        waitlistEmail: null,
        setWaitlistEmail: (email)=>set({
                waitlistEmail: email
            }),
        hasSignedUp: false,
        setHasSignedUp: (val)=>set({
                hasSignedUp: val
            }),
        showVideoPlayerVisible: (link)=>set({
                videoPlayerLink: link,
                videoPlayerVisible: true
            }),
        hideVideoPlayerVisible: ()=>set({
                videoPlayerVisible: false,
                videoPlayerLink: null
            })
    }), {
    name: 'ui-storage'
}));

},{"zustand":"dodpK","zustand/middleware":"2zkjt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dodpK":[function(require,module,exports,__globalThis) {
'use strict';
var vanilla = require("a19f4edd89926025");
var react = require("a0cacd268d6bf882");
Object.keys(vanilla).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function() {
            return vanilla[k];
        }
    });
});
Object.keys(react).forEach(function(k) {
    if (k !== 'default' && !Object.prototype.hasOwnProperty.call(exports, k)) Object.defineProperty(exports, k, {
        enumerable: true,
        get: function() {
            return react[k];
        }
    });
});

},{"a19f4edd89926025":"bsCIB","a0cacd268d6bf882":"3viQv"}],"3viQv":[function(require,module,exports,__globalThis) {
'use strict';
var React = require("6a69048f974f8971");
var vanilla = require("985957b117977eb9");
const identity = (arg)=>arg;
function useStore(api, selector = identity) {
    const slice = React.useSyncExternalStore(api.subscribe, React.useCallback(()=>selector(api.getState()), [
        api,
        selector
    ]), React.useCallback(()=>selector(api.getInitialState()), [
        api,
        selector
    ]));
    React.useDebugValue(slice);
    return slice;
}
const createImpl = (createState)=>{
    const api = vanilla.createStore(createState);
    const useBoundStore = (selector)=>useStore(api, selector);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const create = (createState)=>createState ? createImpl(createState) : createImpl;
exports.create = create;
exports.useStore = useStore;

},{"6a69048f974f8971":"bmhQu","985957b117977eb9":"bsCIB"}],"2zkjt":[function(require,module,exports,__globalThis) {
'use strict';
const reduxImpl = (reducer, initial)=>(set, _get, api)=>{
        api.dispatch = (action)=>{
            set((state)=>reducer(state, action), false, action);
            return action;
        };
        api.dispatchFromDevtools = true;
        return {
            dispatch: (...args)=>api.dispatch(...args),
            ...initial
        };
    };
const redux = reduxImpl;
const trackedConnections = /* @__PURE__ */ new Map();
const getTrackedConnectionState = (name)=>{
    const api = trackedConnections.get(name);
    if (!api) return {};
    return Object.fromEntries(Object.entries(api.stores).map(([key, api2])=>[
            key,
            api2.getState()
        ]));
};
const extractConnectionInformation = (store, extensionConnector, options)=>{
    if (store === void 0) return {
        type: "untracked",
        connection: extensionConnector.connect(options)
    };
    const existingConnection = trackedConnections.get(options.name);
    if (existingConnection) return {
        type: "tracked",
        store,
        ...existingConnection
    };
    const newConnection = {
        connection: extensionConnector.connect(options),
        stores: {}
    };
    trackedConnections.set(options.name, newConnection);
    return {
        type: "tracked",
        store,
        ...newConnection
    };
};
const removeStoreFromTrackedConnections = (name, store)=>{
    if (store === void 0) return;
    const connectionInfo = trackedConnections.get(name);
    if (!connectionInfo) return;
    delete connectionInfo.stores[store];
    if (Object.keys(connectionInfo.stores).length === 0) trackedConnections.delete(name);
};
const findCallerName = (stack)=>{
    var _a, _b;
    if (!stack) return void 0;
    const traceLines = stack.split("\n");
    const apiSetStateLineIndex = traceLines.findIndex((traceLine)=>traceLine.includes("api.setState"));
    if (apiSetStateLineIndex < 0) return void 0;
    const callerLine = ((_a = traceLines[apiSetStateLineIndex + 1]) == null ? void 0 : _a.trim()) || "";
    return (_b = /.+ (.+) .+/.exec(callerLine)) == null ? void 0 : _b[1];
};
const devtoolsImpl = (fn, devtoolsOptions = {})=>(set, get, api)=>{
        const { enabled, anonymousActionType, store, ...options } = devtoolsOptions;
        let extensionConnector;
        try {
            extensionConnector = (enabled != null ? enabled : false) && window.__REDUX_DEVTOOLS_EXTENSION__;
        } catch (e) {}
        if (!extensionConnector) return fn(set, get, api);
        const { connection, ...connectionInformation } = extractConnectionInformation(store, extensionConnector, options);
        let isRecording = true;
        api.setState = (state, replace, nameOrAction)=>{
            const r = set(state, replace);
            if (!isRecording) return r;
            const action = nameOrAction === void 0 ? {
                type: anonymousActionType || findCallerName(new Error().stack) || "anonymous"
            } : typeof nameOrAction === "string" ? {
                type: nameOrAction
            } : nameOrAction;
            if (store === void 0) {
                connection == null || connection.send(action, get());
                return r;
            }
            connection == null || connection.send({
                ...action,
                type: `${store}/${action.type}`
            }, {
                ...getTrackedConnectionState(options.name),
                [store]: api.getState()
            });
            return r;
        };
        api.devtools = {
            cleanup: ()=>{
                if (connection && typeof connection.unsubscribe === "function") connection.unsubscribe();
                removeStoreFromTrackedConnections(options.name, store);
            }
        };
        const setStateFromDevtools = (...a)=>{
            const originalIsRecording = isRecording;
            isRecording = false;
            set(...a);
            isRecording = originalIsRecording;
        };
        const initialState = fn(api.setState, get, api);
        if (connectionInformation.type === "untracked") connection == null || connection.init(initialState);
        else {
            connectionInformation.stores[connectionInformation.store] = api;
            connection == null || connection.init(Object.fromEntries(Object.entries(connectionInformation.stores).map(([key, store2])=>[
                    key,
                    key === connectionInformation.store ? initialState : store2.getState()
                ])));
        }
        if (api.dispatchFromDevtools && typeof api.dispatch === "function") {
            let didWarnAboutReservedActionType = false;
            const originalDispatch = api.dispatch;
            api.dispatch = (...args)=>{
                originalDispatch(...args);
            };
        }
        connection.subscribe((message)=>{
            var _a;
            switch(message.type){
                case "ACTION":
                    if (typeof message.payload !== "string") {
                        console.error("[zustand devtools middleware] Unsupported action format");
                        return;
                    }
                    return parseJsonThen(message.payload, (action)=>{
                        if (action.type === "__setState") {
                            if (store === void 0) {
                                setStateFromDevtools(action.state);
                                return;
                            }
                            if (Object.keys(action.state).length !== 1) console.error(`
                    [zustand devtools middleware] Unsupported __setState action format.
                    When using 'store' option in devtools(), the 'state' should have only one key, which is a value of 'store' that was passed in devtools(),
                    and value of this only key should be a state object. Example: { "type": "__setState", "state": { "abc123Store": { "foo": "bar" } } }
                    `);
                            const stateFromDevtools = action.state[store];
                            if (stateFromDevtools === void 0 || stateFromDevtools === null) return;
                            if (JSON.stringify(api.getState()) !== JSON.stringify(stateFromDevtools)) setStateFromDevtools(stateFromDevtools);
                            return;
                        }
                        if (!api.dispatchFromDevtools) return;
                        if (typeof api.dispatch !== "function") return;
                        api.dispatch(action);
                    });
                case "DISPATCH":
                    switch(message.payload.type){
                        case "RESET":
                            setStateFromDevtools(initialState);
                            if (store === void 0) return connection == null ? void 0 : connection.init(api.getState());
                            return connection == null ? void 0 : connection.init(getTrackedConnectionState(options.name));
                        case "COMMIT":
                            if (store === void 0) {
                                connection == null || connection.init(api.getState());
                                return;
                            }
                            return connection == null ? void 0 : connection.init(getTrackedConnectionState(options.name));
                        case "ROLLBACK":
                            return parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    connection == null || connection.init(api.getState());
                                    return;
                                }
                                setStateFromDevtools(state[store]);
                                connection == null || connection.init(getTrackedConnectionState(options.name));
                            });
                        case "JUMP_TO_STATE":
                        case "JUMP_TO_ACTION":
                            return parseJsonThen(message.state, (state)=>{
                                if (store === void 0) {
                                    setStateFromDevtools(state);
                                    return;
                                }
                                if (JSON.stringify(api.getState()) !== JSON.stringify(state[store])) setStateFromDevtools(state[store]);
                            });
                        case "IMPORT_STATE":
                            {
                                const { nextLiftedState } = message.payload;
                                const lastComputedState = (_a = nextLiftedState.computedStates.slice(-1)[0]) == null ? void 0 : _a.state;
                                if (!lastComputedState) return;
                                if (store === void 0) setStateFromDevtools(lastComputedState);
                                else setStateFromDevtools(lastComputedState[store]);
                                connection == null || connection.send(null, // FIXME no-any
                                nextLiftedState);
                                return;
                            }
                        case "PAUSE_RECORDING":
                            return isRecording = !isRecording;
                    }
                    return;
            }
        });
        return initialState;
    };
const devtools = devtoolsImpl;
const parseJsonThen = (stringified, fn)=>{
    let parsed;
    try {
        parsed = JSON.parse(stringified);
    } catch (e) {
        console.error("[zustand devtools middleware] Could not parse the received json", e);
    }
    if (parsed !== void 0) fn(parsed);
};
const subscribeWithSelectorImpl = (fn)=>(set, get, api)=>{
        const origSubscribe = api.subscribe;
        api.subscribe = (selector, optListener, options)=>{
            let listener = selector;
            if (optListener) {
                const equalityFn = (options == null ? void 0 : options.equalityFn) || Object.is;
                let currentSlice = selector(api.getState());
                listener = (state)=>{
                    const nextSlice = selector(state);
                    if (!equalityFn(currentSlice, nextSlice)) {
                        const previousSlice = currentSlice;
                        optListener(currentSlice = nextSlice, previousSlice);
                    }
                };
                if (options == null ? void 0 : options.fireImmediately) optListener(currentSlice, currentSlice);
            }
            return origSubscribe(listener);
        };
        const initialState = fn(set, get, api);
        return initialState;
    };
const subscribeWithSelector = subscribeWithSelectorImpl;
function combine(initialState, create) {
    return (...args)=>Object.assign({}, initialState, create(...args));
}
function createJSONStorage(getStorage, options) {
    let storage;
    try {
        storage = getStorage();
    } catch (e) {
        return;
    }
    const persistStorage = {
        getItem: (name)=>{
            var _a;
            const parse = (str2)=>{
                if (str2 === null) return null;
                return JSON.parse(str2, options == null ? void 0 : options.reviver);
            };
            const str = (_a = storage.getItem(name)) != null ? _a : null;
            if (str instanceof Promise) return str.then(parse);
            return parse(str);
        },
        setItem: (name, newValue)=>storage.setItem(name, JSON.stringify(newValue, options == null ? void 0 : options.replacer)),
        removeItem: (name)=>storage.removeItem(name)
    };
    return persistStorage;
}
const toThenable = (fn)=>(input)=>{
        try {
            const result = fn(input);
            if (result instanceof Promise) return result;
            return {
                then (onFulfilled) {
                    return toThenable(onFulfilled)(result);
                },
                catch (_onRejected) {
                    return this;
                }
            };
        } catch (e) {
            return {
                then (_onFulfilled) {
                    return this;
                },
                catch (onRejected) {
                    return toThenable(onRejected)(e);
                }
            };
        }
    };
const persistImpl = (config, baseOptions)=>(set, get, api)=>{
        let options = {
            storage: createJSONStorage(()=>localStorage),
            partialize: (state)=>state,
            version: 0,
            merge: (persistedState, currentState)=>({
                    ...currentState,
                    ...persistedState
                }),
            ...baseOptions
        };
        let hasHydrated = false;
        const hydrationListeners = /* @__PURE__ */ new Set();
        const finishHydrationListeners = /* @__PURE__ */ new Set();
        let storage = options.storage;
        if (!storage) return config((...args)=>{
            console.warn(`[zustand persist middleware] Unable to update item '${options.name}', the given storage is currently unavailable.`);
            set(...args);
        }, get, api);
        const setItem = ()=>{
            const state = options.partialize({
                ...get()
            });
            return storage.setItem(options.name, {
                state,
                version: options.version
            });
        };
        const savedSetState = api.setState;
        api.setState = (state, replace)=>{
            savedSetState(state, replace);
            return setItem();
        };
        const configResult = config((...args)=>{
            set(...args);
            return setItem();
        }, get, api);
        api.getInitialState = ()=>configResult;
        let stateFromStorage;
        const hydrate = ()=>{
            var _a, _b;
            if (!storage) return;
            hasHydrated = false;
            hydrationListeners.forEach((cb)=>{
                var _a2;
                return cb((_a2 = get()) != null ? _a2 : configResult);
            });
            const postRehydrationCallback = ((_b = options.onRehydrateStorage) == null ? void 0 : _b.call(options, (_a = get()) != null ? _a : configResult)) || void 0;
            return toThenable(storage.getItem.bind(storage))(options.name).then((deserializedStorageValue)=>{
                if (deserializedStorageValue) {
                    if (typeof deserializedStorageValue.version === "number" && deserializedStorageValue.version !== options.version) {
                        if (options.migrate) {
                            const migration = options.migrate(deserializedStorageValue.state, deserializedStorageValue.version);
                            if (migration instanceof Promise) return migration.then((result)=>[
                                    true,
                                    result
                                ]);
                            return [
                                true,
                                migration
                            ];
                        }
                        console.error(`State loaded from storage couldn't be migrated since no migrate function was provided`);
                    } else return [
                        false,
                        deserializedStorageValue.state
                    ];
                }
                return [
                    false,
                    void 0
                ];
            }).then((migrationResult)=>{
                var _a2;
                const [migrated, migratedState] = migrationResult;
                stateFromStorage = options.merge(migratedState, (_a2 = get()) != null ? _a2 : configResult);
                set(stateFromStorage, true);
                if (migrated) return setItem();
            }).then(()=>{
                postRehydrationCallback == null || postRehydrationCallback(stateFromStorage, void 0);
                stateFromStorage = get();
                hasHydrated = true;
                finishHydrationListeners.forEach((cb)=>cb(stateFromStorage));
            }).catch((e)=>{
                postRehydrationCallback == null || postRehydrationCallback(void 0, e);
            });
        };
        api.persist = {
            setOptions: (newOptions)=>{
                options = {
                    ...options,
                    ...newOptions
                };
                if (newOptions.storage) storage = newOptions.storage;
            },
            clearStorage: ()=>{
                storage == null || storage.removeItem(options.name);
            },
            getOptions: ()=>options,
            rehydrate: ()=>hydrate(),
            hasHydrated: ()=>hasHydrated,
            onHydrate: (cb)=>{
                hydrationListeners.add(cb);
                return ()=>{
                    hydrationListeners.delete(cb);
                };
            },
            onFinishHydration: (cb)=>{
                finishHydrationListeners.add(cb);
                return ()=>{
                    finishHydrationListeners.delete(cb);
                };
            }
        };
        if (!options.skipHydration) hydrate();
        return stateFromStorage || configResult;
    };
const persist = persistImpl;
function ssrSafe(config, isSSR = typeof window === "undefined") {
    return (set, get, api)=>{
        if (!isSSR) return config(set, get, api);
        const ssrSet = ()=>{
            throw new Error("Cannot set state of Zustand store in SSR");
        };
        api.setState = ssrSet;
        return config(ssrSet, get, api);
    };
}
exports.combine = combine;
exports.createJSONStorage = createJSONStorage;
exports.devtools = devtools;
exports.persist = persist;
exports.redux = redux;
exports.subscribeWithSelector = subscribeWithSelector;
exports.unstable_ssrSafe = ssrSafe;

},{}],"5o3Y5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAfterPageLoad", ()=>useAfterPageLoad);
parcelHelpers.export(exports, "useAfterDOMReady", ()=>useAfterDOMReady);
var _react = require("react");
const useAfterPageLoad = (callback)=>{
    const calledRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        const safeCall = ()=>{
            if (calledRef.current) return;
            calledRef.current = true;
            callback();
        };
        const onLoad = ()=>{
            safeCall();
        };
        const timeoutId = setTimeout(()=>{
            safeCall();
        }, 5000);
        if (document.readyState === 'complete') safeCall();
        else window.addEventListener('load', onLoad);
        return ()=>{
            window.removeEventListener('load', onLoad);
            clearTimeout(timeoutId);
        };
    }, [
        callback
    ]);
};
const useAfterDOMReady = (callback)=>{
    const calledRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        const safeCall = ()=>{
            if (calledRef.current) return;
            calledRef.current = true;
            callback();
        };
        const timeoutId = setTimeout(()=>{
            safeCall();
        }, 5000);
        if (document.readyState !== 'loading') safeCall();
        else document.addEventListener('DOMContentLoaded', safeCall);
        return ()=>{
            document.removeEventListener('DOMContentLoaded', safeCall);
            clearTimeout(timeoutId);
        };
    }, [
        callback
    ]);
};

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lm2uC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ALL_ASSETS", ()=>ALL_ASSETS);
var _assetsTs = require("src/components/PhoneAnimations/GreatJobVideo/assets.ts");
var _assetsTs1 = require("src/components/PhoneAnimations/HomeWorkout/assets.ts");
var _assetsTs2 = require("src/components/PhoneAnimations/LateralRaise/assets.ts");
var _assetsTs3 = require("src/components/PhoneAnimations/LateralRaiseComplete/assets.ts");
var _assetsTs4 = require("src/components/PhoneAnimations/LateralRaiseDetails/assets.ts");
var _assetsTs5 = require("src/components/PhoneAnimations/LateralRaiseHexReveal/assets.ts");
var _assetsTs6 = require("src/components/PhoneAnimations/Lunges/assets.ts");
var _assetsTs7 = require("src/components/PhoneAnimations/LungesComplete/assets.ts");
var _assetsTs8 = require("src/components/PhoneAnimations/LungesDetails/assets.ts");
var _assetsTs9 = require("src/components/PhoneAnimations/LungesHexReveal/assets.ts");
var _assetsTs10 = require("src/components/PhoneAnimations/MyProgress/assets.ts");
var _assetsTs11 = require("src/components/PhoneAnimations/SideLunges/assets.ts");
var _assetsTs12 = require("src/components/PhoneAnimations/TrainerProfile/assets.ts");
var _assetsTs13 = require("src/components/PhoneAnimations/Trainers/assets.ts");
var _assetsTs14 = require("src/components/PhoneAnimations/TrainingProgramme/assets.ts");
var _assetsTs15 = require("src/components/PhoneAnimations/WorkoutResults/assets.ts");
const ALL_ASSETS = [
    ...(0, _assetsTs.greatJobVideoAssetList),
    ...(0, _assetsTs1.homeWorkoutImageList),
    ...(0, _assetsTs2.lateralRaiseAssetList),
    ...(0, _assetsTs3.lateralRaiseCompleteAssetList),
    ...(0, _assetsTs4.lateralRaiseDetailsAssetList),
    ...(0, _assetsTs5.lateralRaiseHexRevealAssetList),
    ...(0, _assetsTs6.lungesAssetList),
    ...(0, _assetsTs7.lungesCompleteAssetList),
    ...(0, _assetsTs8.lungesDetailsAssetList),
    ...(0, _assetsTs9.lungesHexRevealAssetList),
    ...(0, _assetsTs10.myProgressAssetList),
    ...(0, _assetsTs11.sideLungesAssetList),
    ...(0, _assetsTs12.trainerProfileAssetList),
    ...(0, _assetsTs13.trainersAssetList),
    ...(0, _assetsTs14.trainingProgrammeAssetList),
    ...(0, _assetsTs15.workoutResultsImageList)
];

},{"src/components/PhoneAnimations/GreatJobVideo/assets.ts":"gDhhV","src/components/PhoneAnimations/HomeWorkout/assets.ts":"hzxOq","src/components/PhoneAnimations/LateralRaise/assets.ts":"iDQQz","src/components/PhoneAnimations/LateralRaiseComplete/assets.ts":"183X7","src/components/PhoneAnimations/LateralRaiseDetails/assets.ts":"jl5Gk","src/components/PhoneAnimations/LateralRaiseHexReveal/assets.ts":"ivdqG","src/components/PhoneAnimations/Lunges/assets.ts":"ksIzr","src/components/PhoneAnimations/LungesComplete/assets.ts":"5DHSo","src/components/PhoneAnimations/LungesDetails/assets.ts":"4Is7x","src/components/PhoneAnimations/LungesHexReveal/assets.ts":"hfn5h","src/components/PhoneAnimations/MyProgress/assets.ts":"20fGv","src/components/PhoneAnimations/SideLunges/assets.ts":"2oXmy","src/components/PhoneAnimations/TrainerProfile/assets.ts":"hyz4d","src/components/PhoneAnimations/Trainers/assets.ts":"9ZVMB","src/components/PhoneAnimations/TrainingProgramme/assets.ts":"aPFOe","src/components/PhoneAnimations/WorkoutResults/assets.ts":"81PGR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gDhhV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "greatJobVideoAssets", ()=>greatJobVideoAssets);
parcelHelpers.export(exports, "greatJobVideoAssetList", ()=>greatJobVideoAssetList);
var _whiteStatusbarWebp = require("url:../../../assets/images/white-statusbar.webp");
var _whiteStatusbarWebpDefault = parcelHelpers.interopDefault(_whiteStatusbarWebp);
var _greatJobVideoMp4 = require("url:../../../assets/videos/great-job-video.mp4");
var _greatJobVideoMp4Default = parcelHelpers.interopDefault(_greatJobVideoMp4);
const greatJobVideoAssets = {
    whiteStatusbar: (0, _whiteStatusbarWebpDefault.default),
    greatJobVideo: (0, _greatJobVideoMp4Default.default)
};
const greatJobVideoAssetList = Object.values(greatJobVideoAssets);

},{"url:../../../assets/images/white-statusbar.webp":"5gtSW","url:../../../assets/videos/great-job-video.mp4":"f8Xro","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5gtSW":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dHor4");

},{}],"f8Xro":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("82MSx");

},{}],"hzxOq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "homeWorkoutImages", ()=>homeWorkoutImages);
parcelHelpers.export(exports, "homeWorkoutImageList", ()=>homeWorkoutImageList);
var _homeWorkoutNavbarWebp = require("url:../../../assets/images/home-workout-navbar.webp");
var _homeWorkoutNavbarWebpDefault = parcelHelpers.interopDefault(_homeWorkoutNavbarWebp);
var _homeProgress0Webp = require("url:../../../assets/images/home-progress-0.webp");
var _homeProgress0WebpDefault = parcelHelpers.interopDefault(_homeProgress0Webp);
var _homeProgress1Webp = require("url:../../../assets/images/home-progress-1.webp");
var _homeProgress1WebpDefault = parcelHelpers.interopDefault(_homeProgress1Webp);
var _homeProgress2Webp = require("url:../../../assets/images/home-progress-2.webp");
var _homeProgress2WebpDefault = parcelHelpers.interopDefault(_homeProgress2Webp);
var _homeProgress3Webp = require("url:../../../assets/images/home-progress-3.webp");
var _homeProgress3WebpDefault = parcelHelpers.interopDefault(_homeProgress3Webp);
var _homeProgress4Webp = require("url:../../../assets/images/home-progress-4.webp");
var _homeProgress4WebpDefault = parcelHelpers.interopDefault(_homeProgress4Webp);
var _homeProgress5Webp = require("url:../../../assets/images/home-progress-5.webp");
var _homeProgress5WebpDefault = parcelHelpers.interopDefault(_homeProgress5Webp);
var _homeProgress6Webp = require("url:../../../assets/images/home-progress-6.webp");
var _homeProgress6WebpDefault = parcelHelpers.interopDefault(_homeProgress6Webp);
var _homeProgress7Webp = require("url:../../../assets/images/home-progress-7.webp");
var _homeProgress7WebpDefault = parcelHelpers.interopDefault(_homeProgress7Webp);
var _homeProgress8Webp = require("url:../../../assets/images/home-progress-8.webp");
var _homeProgress8WebpDefault = parcelHelpers.interopDefault(_homeProgress8Webp);
var _homeProgress9Webp = require("url:../../../assets/images/home-progress-9.webp");
var _homeProgress9WebpDefault = parcelHelpers.interopDefault(_homeProgress9Webp);
var _homeProgress10Webp = require("url:../../../assets/images/home-progress-10.webp");
var _homeProgress10WebpDefault = parcelHelpers.interopDefault(_homeProgress10Webp);
var _homeProgress11Webp = require("url:../../../assets/images/home-progress-11.webp");
var _homeProgress11WebpDefault = parcelHelpers.interopDefault(_homeProgress11Webp);
const homeWorkoutImages = {
    homeProgressNavbar: (0, _homeWorkoutNavbarWebpDefault.default),
    homeProgress0: (0, _homeProgress0WebpDefault.default),
    homeProgress1: (0, _homeProgress1WebpDefault.default),
    homeProgress2: (0, _homeProgress2WebpDefault.default),
    homeProgress3: (0, _homeProgress3WebpDefault.default),
    homeProgress4: (0, _homeProgress4WebpDefault.default),
    homeProgress5: (0, _homeProgress5WebpDefault.default),
    homeProgress6: (0, _homeProgress6WebpDefault.default),
    homeProgress7: (0, _homeProgress7WebpDefault.default),
    homeProgress8: (0, _homeProgress8WebpDefault.default),
    homeProgress9: (0, _homeProgress9WebpDefault.default),
    homeProgress10: (0, _homeProgress10WebpDefault.default),
    homeProgress11: (0, _homeProgress11WebpDefault.default)
};
const homeWorkoutImageList = Object.values(homeWorkoutImages);

},{"url:../../../assets/images/home-workout-navbar.webp":"amrrA","url:../../../assets/images/home-progress-0.webp":"2T7E8","url:../../../assets/images/home-progress-1.webp":"byjzq","url:../../../assets/images/home-progress-2.webp":"02Rxx","url:../../../assets/images/home-progress-3.webp":"aEFvc","url:../../../assets/images/home-progress-4.webp":"46DWg","url:../../../assets/images/home-progress-5.webp":"futNW","url:../../../assets/images/home-progress-6.webp":"cuGMx","url:../../../assets/images/home-progress-7.webp":"4cCgF","url:../../../assets/images/home-progress-8.webp":"1PRrM","url:../../../assets/images/home-progress-9.webp":"bf0RF","url:../../../assets/images/home-progress-10.webp":"f6Cla","url:../../../assets/images/home-progress-11.webp":"c9eot","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"amrrA":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("86H0B");

},{}],"2T7E8":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9mVYJ");

},{}],"byjzq":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2cGmy");

},{}],"02Rxx":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1FtUB");

},{}],"aEFvc":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("a3q7m");

},{}],"46DWg":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2eg5a");

},{}],"futNW":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dsPOE");

},{}],"cuGMx":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4Wf2W");

},{}],"4cCgF":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5J1ks");

},{}],"1PRrM":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("f0hLA");

},{}],"bf0RF":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("63BtX");

},{}],"f6Cla":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3Dq6f");

},{}],"c9eot":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("iwg8k");

},{}],"iDQQz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lateralRaiseAssets", ()=>lateralRaiseAssets);
parcelHelpers.export(exports, "lateralRaiseAssetList", ()=>lateralRaiseAssetList);
var _homeProgress0Webp = require("url:../../../assets/images/home-progress-0.webp");
var _homeProgress0WebpDefault = parcelHelpers.interopDefault(_homeProgress0Webp);
var _lateralRaiseVideoMp4 = require("url:../../../assets/videos/lateral-raise-video.mp4");
var _lateralRaiseVideoMp4Default = parcelHelpers.interopDefault(_lateralRaiseVideoMp4);
var _lunges1Webp = require("url:../../../assets/images/lunges-1.webp");
var _lunges1WebpDefault = parcelHelpers.interopDefault(_lunges1Webp);
var _lateralRaise2Webp = require("url:../../../assets/images/lateral-raise-2.webp");
var _lateralRaise2WebpDefault = parcelHelpers.interopDefault(_lateralRaise2Webp);
const lateralRaiseAssets = {
    homeProgress0: (0, _homeProgress0WebpDefault.default),
    lateralRaiseVideo: (0, _lateralRaiseVideoMp4Default.default),
    lunges1: (0, _lunges1WebpDefault.default),
    lunges2: (0, _lateralRaise2WebpDefault.default)
};
const lateralRaiseAssetList = Object.values(lateralRaiseAssets);

},{"url:../../../assets/images/home-progress-0.webp":"2T7E8","url:../../../assets/videos/lateral-raise-video.mp4":"kPvC8","url:../../../assets/images/lunges-1.webp":"hofAL","url:../../../assets/images/lateral-raise-2.webp":"01asb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kPvC8":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3j5U7");

},{}],"hofAL":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("a0O22");

},{}],"01asb":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1UaXS");

},{}],"183X7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lateralRaiseCompleteAssets", ()=>lateralRaiseCompleteAssets);
parcelHelpers.export(exports, "lateralRaiseCompleteAssetList", ()=>lateralRaiseCompleteAssetList);
var _whiteStatusbarWebp = require("url:../../../assets/images/white-statusbar.webp");
var _whiteStatusbarWebpDefault = parcelHelpers.interopDefault(_whiteStatusbarWebp);
var _lungesDetails4Webp = require("url:../../../assets/images/lunges-details-4.webp");
var _lungesDetails4WebpDefault = parcelHelpers.interopDefault(_lungesDetails4Webp);
var _lungesComplete1Webp = require("url:../../../assets/images/lunges-complete-1.webp");
var _lungesComplete1WebpDefault = parcelHelpers.interopDefault(_lungesComplete1Webp);
const lateralRaiseCompleteAssets = {
    homeProgress0: (0, _whiteStatusbarWebpDefault.default),
    lungesComplete1: (0, _lungesComplete1WebpDefault.default),
    exercisesDetails4: (0, _lungesDetails4WebpDefault.default)
};
const lateralRaiseCompleteAssetList = Object.values(lateralRaiseCompleteAssets);

},{"url:../../../assets/images/white-statusbar.webp":"5gtSW","url:../../../assets/images/lunges-details-4.webp":"dosO8","url:../../../assets/images/lunges-complete-1.webp":"9J7VB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dosO8":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2gLvJ");

},{}],"9J7VB":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("e65qM");

},{}],"jl5Gk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lateralRaiseDetailsAssets", ()=>lateralRaiseDetailsAssets);
parcelHelpers.export(exports, "lateralRaiseDetailsAssetList", ()=>lateralRaiseDetailsAssetList);
var _whiteStatusbarWebp = require("url:../../../assets/images/white-statusbar.webp");
var _whiteStatusbarWebpDefault = parcelHelpers.interopDefault(_whiteStatusbarWebp);
var _lungesDetails1Webp = require("url:../../../assets/images/lunges-details-1.webp");
var _lungesDetails1WebpDefault = parcelHelpers.interopDefault(_lungesDetails1Webp);
var _lateralRaiseDetails2Webp = require("url:../../../assets/images/lateral-raise-details-2.webp");
var _lateralRaiseDetails2WebpDefault = parcelHelpers.interopDefault(_lateralRaiseDetails2Webp);
var _lateralRaiseDetails3Webp = require("url:../../../assets/images/lateral-raise-details-3.webp");
var _lateralRaiseDetails3WebpDefault = parcelHelpers.interopDefault(_lateralRaiseDetails3Webp);
var _lungesDetails4Webp = require("url:../../../assets/images/lunges-details-4.webp");
var _lungesDetails4WebpDefault = parcelHelpers.interopDefault(_lungesDetails4Webp);
var _lungesDetails5Webp = require("url:../../../assets/images/lunges-details-5.webp");
var _lungesDetails5WebpDefault = parcelHelpers.interopDefault(_lungesDetails5Webp);
var _lungesDetails6Webp = require("url:../../../assets/images/lunges-details-6.webp");
var _lungesDetails6WebpDefault = parcelHelpers.interopDefault(_lungesDetails6Webp);
const lateralRaiseDetailsAssets = {
    whiteStatusbar: (0, _whiteStatusbarWebpDefault.default),
    exercisesDetails1: (0, _lungesDetails1WebpDefault.default),
    exercisesDetails2: (0, _lateralRaiseDetails2WebpDefault.default),
    exercisesDetails3: (0, _lateralRaiseDetails3WebpDefault.default),
    exercisesDetails4: (0, _lungesDetails4WebpDefault.default),
    exercisesDetails5: (0, _lungesDetails5WebpDefault.default),
    exercisesDetails6: (0, _lungesDetails6WebpDefault.default)
};
const lateralRaiseDetailsAssetList = Object.values(lateralRaiseDetailsAssets);

},{"url:../../../assets/images/white-statusbar.webp":"5gtSW","url:../../../assets/images/lunges-details-1.webp":"bvnMF","url:../../../assets/images/lateral-raise-details-2.webp":"9aAmS","url:../../../assets/images/lateral-raise-details-3.webp":"exzUV","url:../../../assets/images/lunges-details-4.webp":"dosO8","url:../../../assets/images/lunges-details-5.webp":"36GIp","url:../../../assets/images/lunges-details-6.webp":"9aJdy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bvnMF":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2SEHw");

},{}],"9aAmS":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("i07Ph");

},{}],"exzUV":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("alVVA");

},{}],"36GIp":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kGqS2");

},{}],"9aJdy":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5KZsS");

},{}],"ivdqG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lateralRaiseHexRevealAssets", ()=>lateralRaiseHexRevealAssets);
parcelHelpers.export(exports, "lateralRaiseHexRevealAssetList", ()=>lateralRaiseHexRevealAssetList);
var _lateralRaiseEx1Webp = require("url:../../../assets/images/lateral-raise-ex-1.webp");
var _lateralRaiseEx1WebpDefault = parcelHelpers.interopDefault(_lateralRaiseEx1Webp);
var _lateralRaiseEx2Webp = require("url:../../../assets/images/lateral-raise-ex-2.webp");
var _lateralRaiseEx2WebpDefault = parcelHelpers.interopDefault(_lateralRaiseEx2Webp);
const lateralRaiseHexRevealAssets = {
    lateralRaise1: (0, _lateralRaiseEx1WebpDefault.default),
    lateralRaise2: (0, _lateralRaiseEx2WebpDefault.default)
};
const lateralRaiseHexRevealAssetList = Object.values(lateralRaiseHexRevealAssets);

},{"url:../../../assets/images/lateral-raise-ex-1.webp":"axHfy","url:../../../assets/images/lateral-raise-ex-2.webp":"IMilL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"axHfy":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4bbod");

},{}],"IMilL":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("29Nwg");

},{}],"ksIzr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lungesAssets", ()=>lungesAssets);
parcelHelpers.export(exports, "lungesAssetList", ()=>lungesAssetList);
var _homeProgress0Webp = require("url:../../../assets/images/home-progress-0.webp");
var _homeProgress0WebpDefault = parcelHelpers.interopDefault(_homeProgress0Webp);
var _lungesVideoMp4 = require("url:../../../assets/videos/lunges-video.mp4");
var _lungesVideoMp4Default = parcelHelpers.interopDefault(_lungesVideoMp4);
var _lunges1Webp = require("url:../../../assets/images/lunges-1.webp");
var _lunges1WebpDefault = parcelHelpers.interopDefault(_lunges1Webp);
var _lunges2Webp = require("url:../../../assets/images/lunges-2.webp");
var _lunges2WebpDefault = parcelHelpers.interopDefault(_lunges2Webp);
const lungesAssets = {
    homeProgress0: (0, _homeProgress0WebpDefault.default),
    lungesVideo: (0, _lungesVideoMp4Default.default),
    lunges1: (0, _lunges1WebpDefault.default),
    lunges2: (0, _lunges2WebpDefault.default)
};
const lungesAssetList = Object.values(lungesAssets);

},{"url:../../../assets/images/home-progress-0.webp":"2T7E8","url:../../../assets/videos/lunges-video.mp4":"lukG3","url:../../../assets/images/lunges-1.webp":"hofAL","url:../../../assets/images/lunges-2.webp":"dwzzj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lukG3":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("87QKL");

},{}],"dwzzj":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fh6cY");

},{}],"5DHSo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lungesCompleteAssets", ()=>lungesCompleteAssets);
parcelHelpers.export(exports, "lungesCompleteAssetList", ()=>lungesCompleteAssetList);
var _whiteStatusbarWebp = require("url:../../../assets/images/white-statusbar.webp");
var _whiteStatusbarWebpDefault = parcelHelpers.interopDefault(_whiteStatusbarWebp);
var _lungesDetails4Webp = require("url:../../../assets/images/lunges-details-4.webp");
var _lungesDetails4WebpDefault = parcelHelpers.interopDefault(_lungesDetails4Webp);
var _lungesComplete1Webp = require("url:../../../assets/images/lunges-complete-1.webp");
var _lungesComplete1WebpDefault = parcelHelpers.interopDefault(_lungesComplete1Webp);
const lungesCompleteAssets = {
    homeProgress0: (0, _whiteStatusbarWebpDefault.default),
    lungesComplete1: (0, _lungesComplete1WebpDefault.default),
    exercisesDetails4: (0, _lungesDetails4WebpDefault.default)
};
const lungesCompleteAssetList = Object.values(lungesCompleteAssets);

},{"url:../../../assets/images/white-statusbar.webp":"5gtSW","url:../../../assets/images/lunges-details-4.webp":"dosO8","url:../../../assets/images/lunges-complete-1.webp":"9J7VB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Is7x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lungesDetailsAssets", ()=>lungesDetailsAssets);
parcelHelpers.export(exports, "lungesDetailsAssetList", ()=>lungesDetailsAssetList);
var _whiteStatusbarWebp = require("url:../../../assets/images/white-statusbar.webp");
var _whiteStatusbarWebpDefault = parcelHelpers.interopDefault(_whiteStatusbarWebp);
var _lungesDetails1Webp = require("url:../../../assets/images/lunges-details-1.webp");
var _lungesDetails1WebpDefault = parcelHelpers.interopDefault(_lungesDetails1Webp);
var _lungesDetails2Webp = require("url:../../../assets/images/lunges-details-2.webp");
var _lungesDetails2WebpDefault = parcelHelpers.interopDefault(_lungesDetails2Webp);
var _lungesDetails3Webp = require("url:../../../assets/images/lunges-details-3.webp");
var _lungesDetails3WebpDefault = parcelHelpers.interopDefault(_lungesDetails3Webp);
var _lungesDetails4Webp = require("url:../../../assets/images/lunges-details-4.webp");
var _lungesDetails4WebpDefault = parcelHelpers.interopDefault(_lungesDetails4Webp);
var _lungesDetails5Webp = require("url:../../../assets/images/lunges-details-5.webp");
var _lungesDetails5WebpDefault = parcelHelpers.interopDefault(_lungesDetails5Webp);
var _lungesDetails6Webp = require("url:../../../assets/images/lunges-details-6.webp");
var _lungesDetails6WebpDefault = parcelHelpers.interopDefault(_lungesDetails6Webp);
const lungesDetailsAssets = {
    whiteStatusbar: (0, _whiteStatusbarWebpDefault.default),
    exercisesDetails1: (0, _lungesDetails1WebpDefault.default),
    exercisesDetails2: (0, _lungesDetails2WebpDefault.default),
    exercisesDetails3: (0, _lungesDetails3WebpDefault.default),
    exercisesDetails4: (0, _lungesDetails4WebpDefault.default),
    exercisesDetails5: (0, _lungesDetails5WebpDefault.default),
    exercisesDetails6: (0, _lungesDetails6WebpDefault.default)
};
const lungesDetailsAssetList = Object.values(lungesDetailsAssets);

},{"url:../../../assets/images/white-statusbar.webp":"5gtSW","url:../../../assets/images/lunges-details-1.webp":"bvnMF","url:../../../assets/images/lunges-details-2.webp":"5SbY2","url:../../../assets/images/lunges-details-3.webp":"ddCvS","url:../../../assets/images/lunges-details-4.webp":"dosO8","url:../../../assets/images/lunges-details-5.webp":"36GIp","url:../../../assets/images/lunges-details-6.webp":"9aJdy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5SbY2":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kFSEi");

},{}],"ddCvS":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("b4iUw");

},{}],"hfn5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lungesHexRevealAssets", ()=>lungesHexRevealAssets);
parcelHelpers.export(exports, "lungesHexRevealAssetList", ()=>lungesHexRevealAssetList);
var _lungsEx1Webp = require("url:../../../assets/images/lungs-ex-1.webp");
var _lungsEx1WebpDefault = parcelHelpers.interopDefault(_lungsEx1Webp);
var _lungsEx2Webp = require("url:../../../assets/images/lungs-ex-2.webp");
var _lungsEx2WebpDefault = parcelHelpers.interopDefault(_lungsEx2Webp);
const lungesHexRevealAssets = {
    lungs1: (0, _lungsEx1WebpDefault.default),
    lungs2: (0, _lungsEx2WebpDefault.default)
};
const lungesHexRevealAssetList = Object.values(lungesHexRevealAssets);

},{"url:../../../assets/images/lungs-ex-1.webp":"4H9e0","url:../../../assets/images/lungs-ex-2.webp":"figzK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4H9e0":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7vtTX");

},{}],"figzK":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("hkgS1");

},{}],"20fGv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "myProgressAssets", ()=>myProgressAssets);
parcelHelpers.export(exports, "myProgressAssetList", ()=>myProgressAssetList);
var _homeProgressNavbarWebp = require("url:../../../assets/images/home-progress-navbar.webp");
var _homeProgressNavbarWebpDefault = parcelHelpers.interopDefault(_homeProgressNavbarWebp);
var _homeProgress0Webp = require("url:../../../assets/images/home-progress-0.webp");
var _homeProgress0WebpDefault = parcelHelpers.interopDefault(_homeProgress0Webp);
var _myProgress1Webp = require("url:../../../assets/images/my-progress-1.webp");
var _myProgress1WebpDefault = parcelHelpers.interopDefault(_myProgress1Webp);
var _myProgress2Webp = require("url:../../../assets/images/my-progress-2.webp");
var _myProgress2WebpDefault = parcelHelpers.interopDefault(_myProgress2Webp);
var _myProgress3Webp = require("url:../../../assets/images/my-progress-3.webp");
var _myProgress3WebpDefault = parcelHelpers.interopDefault(_myProgress3Webp);
var _myProgress4Webp = require("url:../../../assets/images/my-progress-4.webp");
var _myProgress4WebpDefault = parcelHelpers.interopDefault(_myProgress4Webp);
var _myProgress5Webp = require("url:../../../assets/images/my-progress-5.webp");
var _myProgress5WebpDefault = parcelHelpers.interopDefault(_myProgress5Webp);
var _myProgress6Webp = require("url:../../../assets/images/my-progress-6.webp");
var _myProgress6WebpDefault = parcelHelpers.interopDefault(_myProgress6Webp);
var _myProgress7Webp = require("url:../../../assets/images/my-progress-7.webp");
var _myProgress7WebpDefault = parcelHelpers.interopDefault(_myProgress7Webp);
var _myProgress8Webp = require("url:../../../assets/images/my-progress-8.webp");
var _myProgress8WebpDefault = parcelHelpers.interopDefault(_myProgress8Webp);
var _myProgress9Webp = require("url:../../../assets/images/my-progress-9.webp");
var _myProgress9WebpDefault = parcelHelpers.interopDefault(_myProgress9Webp);
var _myProgress10Webp = require("url:../../../assets/images/my-progress-10.webp");
var _myProgress10WebpDefault = parcelHelpers.interopDefault(_myProgress10Webp);
const myProgressAssets = {
    homeProgressNavbar: (0, _homeProgressNavbarWebpDefault.default),
    statusbar: (0, _homeProgress0WebpDefault.default),
    homeProgress1: (0, _myProgress1WebpDefault.default),
    homeProgress2: (0, _myProgress2WebpDefault.default),
    homeProgress3: (0, _myProgress3WebpDefault.default),
    homeProgress4: (0, _myProgress4WebpDefault.default),
    homeProgress5: (0, _myProgress5WebpDefault.default),
    homeProgress6: (0, _myProgress6WebpDefault.default),
    homeProgress7: (0, _myProgress7WebpDefault.default),
    homeProgress8: (0, _myProgress8WebpDefault.default),
    homeProgress9: (0, _myProgress9WebpDefault.default),
    homeProgress10: (0, _myProgress10WebpDefault.default)
};
const myProgressAssetList = Object.values(myProgressAssets);

},{"url:../../../assets/images/home-progress-navbar.webp":"kxd5M","url:../../../assets/images/home-progress-0.webp":"2T7E8","url:../../../assets/images/my-progress-1.webp":"6IM9c","url:../../../assets/images/my-progress-2.webp":"dMbNN","url:../../../assets/images/my-progress-3.webp":"4m2jT","url:../../../assets/images/my-progress-4.webp":"e0AZa","url:../../../assets/images/my-progress-5.webp":"5MC3T","url:../../../assets/images/my-progress-6.webp":"buCZB","url:../../../assets/images/my-progress-7.webp":"94GJE","url:../../../assets/images/my-progress-8.webp":"91957","url:../../../assets/images/my-progress-9.webp":"jZfsk","url:../../../assets/images/my-progress-10.webp":"ag7lf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kxd5M":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("bhhcQ");

},{}],"6IM9c":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kBBAh");

},{}],"dMbNN":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lsrXm");

},{}],"4m2jT":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6fwdq");

},{}],"e0AZa":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gZfJP");

},{}],"5MC3T":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lOtmU");

},{}],"buCZB":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1OODC");

},{}],"94GJE":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2FbbZ");

},{}],"91957":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kGSuq");

},{}],"jZfsk":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("hC4Rn");

},{}],"ag7lf":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("iOJBD");

},{}],"2oXmy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sideLungesAssets", ()=>sideLungesAssets);
parcelHelpers.export(exports, "sideLungesAssetList", ()=>sideLungesAssetList);
var _homeProgress0Webp = require("url:../../../assets/images/home-progress-0.webp");
var _homeProgress0WebpDefault = parcelHelpers.interopDefault(_homeProgress0Webp);
var _sideLungesMp4 = require("url:../../../assets/videos/side-lunges.mp4");
var _sideLungesMp4Default = parcelHelpers.interopDefault(_sideLungesMp4);
var _lunges1Webp = require("url:../../../assets/images/lunges-1.webp");
var _lunges1WebpDefault = parcelHelpers.interopDefault(_lunges1Webp);
var _sideLunges2Webp = require("url:../../../assets/images/side-lunges-2.webp");
var _sideLunges2WebpDefault = parcelHelpers.interopDefault(_sideLunges2Webp);
const sideLungesAssets = {
    homeProgress0: (0, _homeProgress0WebpDefault.default),
    sideLungesVideo: (0, _sideLungesMp4Default.default),
    lunges1: (0, _lunges1WebpDefault.default),
    lunges2: (0, _sideLunges2WebpDefault.default)
};
const sideLungesAssetList = Object.values(sideLungesAssets);

},{"url:../../../assets/images/home-progress-0.webp":"2T7E8","url:../../../assets/videos/side-lunges.mp4":"j2r6T","url:../../../assets/images/lunges-1.webp":"hofAL","url:../../../assets/images/side-lunges-2.webp":"dC48G","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j2r6T":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5NzUF");

},{}],"dC48G":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cqG93");

},{}],"hyz4d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trainerProfileAssets", ()=>trainerProfileAssets);
parcelHelpers.export(exports, "trainerProfileAssetList", ()=>trainerProfileAssetList);
var _homeProgress0Webp = require("url:../../../assets/images/home-progress-0.webp");
var _homeProgress0WebpDefault = parcelHelpers.interopDefault(_homeProgress0Webp);
var _trainerProfile1Webp = require("url:../../../assets/images/trainer-profile-1.webp");
var _trainerProfile1WebpDefault = parcelHelpers.interopDefault(_trainerProfile1Webp);
var _trainerProfile2Webp = require("url:../../../assets/images/trainer-profile-2.webp");
var _trainerProfile2WebpDefault = parcelHelpers.interopDefault(_trainerProfile2Webp);
var _trainerProfile3Webp = require("url:../../../assets/images/trainer-profile-3.webp");
var _trainerProfile3WebpDefault = parcelHelpers.interopDefault(_trainerProfile3Webp);
var _trainerProfile4Webp = require("url:../../../assets/images/trainer-profile-4.webp");
var _trainerProfile4WebpDefault = parcelHelpers.interopDefault(_trainerProfile4Webp);
var _trainerProfile5Webp = require("url:../../../assets/images/trainer-profile-5.webp");
var _trainerProfile5WebpDefault = parcelHelpers.interopDefault(_trainerProfile5Webp);
var _trainerProfile6Webp = require("url:../../../assets/images/trainer-profile-6.webp");
var _trainerProfile6WebpDefault = parcelHelpers.interopDefault(_trainerProfile6Webp);
var _trainerProfile7Webp = require("url:../../../assets/images/trainer-profile-7.webp");
var _trainerProfile7WebpDefault = parcelHelpers.interopDefault(_trainerProfile7Webp);
var _trainerProfile8Webp = require("url:../../../assets/images/trainer-profile-8.webp");
var _trainerProfile8WebpDefault = parcelHelpers.interopDefault(_trainerProfile8Webp);
var _trainerProfile9Webp = require("url:../../../assets/images/trainer-profile-9.webp");
var _trainerProfile9WebpDefault = parcelHelpers.interopDefault(_trainerProfile9Webp);
const trainerProfileAssets = {
    statusbar: (0, _homeProgress0WebpDefault.default),
    trainerProfile1: (0, _trainerProfile1WebpDefault.default),
    trainerProfile2: (0, _trainerProfile2WebpDefault.default),
    trainerProfile3: (0, _trainerProfile3WebpDefault.default),
    trainerProfile4: (0, _trainerProfile4WebpDefault.default),
    trainerProfile5: (0, _trainerProfile5WebpDefault.default),
    trainerProfile6: (0, _trainerProfile6WebpDefault.default),
    trainerProfile7: (0, _trainerProfile7WebpDefault.default),
    trainerProfile8: (0, _trainerProfile8WebpDefault.default),
    trainerProfile9: (0, _trainerProfile9WebpDefault.default)
};
const trainerProfileAssetList = Object.values(trainerProfileAssets);

},{"url:../../../assets/images/home-progress-0.webp":"2T7E8","url:../../../assets/images/trainer-profile-1.webp":"2WrGM","url:../../../assets/images/trainer-profile-2.webp":"cRydg","url:../../../assets/images/trainer-profile-3.webp":"bVzHi","url:../../../assets/images/trainer-profile-4.webp":"auk4Y","url:../../../assets/images/trainer-profile-5.webp":"a0az7","url:../../../assets/images/trainer-profile-6.webp":"9leLF","url:../../../assets/images/trainer-profile-7.webp":"iy45F","url:../../../assets/images/trainer-profile-8.webp":"fcSmS","url:../../../assets/images/trainer-profile-9.webp":"9Wimg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2WrGM":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lxAV0");

},{}],"cRydg":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8z9tr");

},{}],"bVzHi":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("bixnA");

},{}],"auk4Y":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5AHRD");

},{}],"a0az7":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("aRL59");

},{}],"9leLF":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gjdwa");

},{}],"iy45F":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kgmdb");

},{}],"fcSmS":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lBInu");

},{}],"9Wimg":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gfGFE");

},{}],"9ZVMB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trainersAssets", ()=>trainersAssets);
parcelHelpers.export(exports, "trainersAssetList", ()=>trainersAssetList);
var _homeProgress0Webp = require("url:../../../assets/images/home-progress-0.webp");
var _homeProgress0WebpDefault = parcelHelpers.interopDefault(_homeProgress0Webp);
var _trainers1Webp = require("url:../../../assets/images/trainers-1.webp");
var _trainers1WebpDefault = parcelHelpers.interopDefault(_trainers1Webp);
var _trainers2Webp = require("url:../../../assets/images/trainers-2.webp");
var _trainers2WebpDefault = parcelHelpers.interopDefault(_trainers2Webp);
var _trainers3Webp = require("url:../../../assets/images/trainers-3.webp");
var _trainers3WebpDefault = parcelHelpers.interopDefault(_trainers3Webp);
var _trainers4Webp = require("url:../../../assets/images/trainers-4.webp");
var _trainers4WebpDefault = parcelHelpers.interopDefault(_trainers4Webp);
var _trainers5Webp = require("url:../../../assets/images/trainers-5.webp");
var _trainers5WebpDefault = parcelHelpers.interopDefault(_trainers5Webp);
var _trainers6Webp = require("url:../../../assets/images/trainers-6.webp");
var _trainers6WebpDefault = parcelHelpers.interopDefault(_trainers6Webp);
var _trainers7Webp = require("url:../../../assets/images/trainers-7.webp");
var _trainers7WebpDefault = parcelHelpers.interopDefault(_trainers7Webp);
var _trainers8Webp = require("url:../../../assets/images/trainers-8.webp");
var _trainers8WebpDefault = parcelHelpers.interopDefault(_trainers8Webp);
const trainersAssets = {
    statusbar: (0, _homeProgress0WebpDefault.default),
    trainers1: (0, _trainers1WebpDefault.default),
    trainers2: (0, _trainers2WebpDefault.default),
    trainers3: (0, _trainers3WebpDefault.default),
    trainers4: (0, _trainers4WebpDefault.default),
    trainers5: (0, _trainers5WebpDefault.default),
    trainers6: (0, _trainers6WebpDefault.default),
    trainers7: (0, _trainers7WebpDefault.default),
    tabBar: (0, _trainers8WebpDefault.default)
};
const trainersAssetList = Object.values(trainersAssets);

},{"url:../../../assets/images/home-progress-0.webp":"2T7E8","url:../../../assets/images/trainers-1.webp":"2e9pX","url:../../../assets/images/trainers-2.webp":"14GNr","url:../../../assets/images/trainers-3.webp":"lNcXl","url:../../../assets/images/trainers-4.webp":"iM8ef","url:../../../assets/images/trainers-5.webp":"lQhDD","url:../../../assets/images/trainers-6.webp":"5DbXW","url:../../../assets/images/trainers-7.webp":"1oR7C","url:../../../assets/images/trainers-8.webp":"4AL5F","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2e9pX":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("51mjZ");

},{}],"14GNr":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("eSQDF");

},{}],"lNcXl":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("62PzZ");

},{}],"iM8ef":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lqwAZ");

},{}],"lQhDD":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ePuwS");

},{}],"5DbXW":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2WUSI");

},{}],"1oR7C":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("jrfxp");

},{}],"4AL5F":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("hNr48");

},{}],"aPFOe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trainingProgrammeAssets", ()=>trainingProgrammeAssets);
parcelHelpers.export(exports, "trainingProgrammeAssetList", ()=>trainingProgrammeAssetList);
var _homeProgress0Webp = require("url:../../../assets/images/home-progress-0.webp");
var _homeProgress0WebpDefault = parcelHelpers.interopDefault(_homeProgress0Webp);
var _trainingProgramme1Webp = require("url:../../../assets/images/training-programme-1.webp");
var _trainingProgramme1WebpDefault = parcelHelpers.interopDefault(_trainingProgramme1Webp);
var _trainingProgramme3Webp = require("url:../../../assets/images/training-programme-3.webp");
var _trainingProgramme3WebpDefault = parcelHelpers.interopDefault(_trainingProgramme3Webp);
var _trainingProgramme4Webp = require("url:../../../assets/images/training-programme-4.webp");
var _trainingProgramme4WebpDefault = parcelHelpers.interopDefault(_trainingProgramme4Webp);
var _trainingProgramme5Webp = require("url:../../../assets/images/training-programme-5.webp");
var _trainingProgramme5WebpDefault = parcelHelpers.interopDefault(_trainingProgramme5Webp);
var _trainingProgramme6Webp = require("url:../../../assets/images/training-programme-6.webp");
var _trainingProgramme6WebpDefault = parcelHelpers.interopDefault(_trainingProgramme6Webp);
var _trainingProgramme7Webp = require("url:../../../assets/images/training-programme-7.webp");
var _trainingProgramme7WebpDefault = parcelHelpers.interopDefault(_trainingProgramme7Webp);
var _trainingProgramme8Webp = require("url:../../../assets/images/training-programme-8.webp");
var _trainingProgramme8WebpDefault = parcelHelpers.interopDefault(_trainingProgramme8Webp);
var _trainingWeeksCompletedWebp = require("url:../../../assets/images/training-weeks-completed.webp");
var _trainingWeeksCompletedWebpDefault = parcelHelpers.interopDefault(_trainingWeeksCompletedWebp);
const trainingProgrammeAssets = {
    statusbar: (0, _homeProgress0WebpDefault.default),
    trainerProgramme1: (0, _trainingProgramme1WebpDefault.default),
    trainerProgramme3: (0, _trainingProgramme3WebpDefault.default),
    trainerProgramme4: (0, _trainingProgramme4WebpDefault.default),
    trainerProgramme5: (0, _trainingProgramme5WebpDefault.default),
    trainerProgramme6: (0, _trainingProgramme6WebpDefault.default),
    trainerProgramme7: (0, _trainingProgramme7WebpDefault.default),
    trainerProgramme8: (0, _trainingProgramme8WebpDefault.default),
    trainingWeeksCompleted: (0, _trainingWeeksCompletedWebpDefault.default)
};
const trainingProgrammeAssetList = Object.values(trainingProgrammeAssets);

},{"url:../../../assets/images/home-progress-0.webp":"2T7E8","url:../../../assets/images/training-programme-1.webp":"63hTl","url:../../../assets/images/training-programme-3.webp":"4Mkwj","url:../../../assets/images/training-programme-4.webp":"6RWmg","url:../../../assets/images/training-programme-5.webp":"lWTQF","url:../../../assets/images/training-programme-6.webp":"dR6ea","url:../../../assets/images/training-programme-7.webp":"iDEec","url:../../../assets/images/training-programme-8.webp":"1KZjp","url:../../../assets/images/training-weeks-completed.webp":"alSEk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"63hTl":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ewzO1");

},{}],"4Mkwj":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("iQipy");

},{}],"6RWmg":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("h6geF");

},{}],"lWTQF":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cSxr3");

},{}],"dR6ea":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9sOHG");

},{}],"iDEec":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cq4kc");

},{}],"1KZjp":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3oz6C");

},{}],"alSEk":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9znmU");

},{}],"81PGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "workoutResultsImages", ()=>workoutResultsImages);
parcelHelpers.export(exports, "workoutResultsImageList", ()=>workoutResultsImageList);
var _homeProgress0Webp = require("url:../../../assets/images/home-progress-0.webp");
var _homeProgress0WebpDefault = parcelHelpers.interopDefault(_homeProgress0Webp);
var _workoutResults1Webp = require("url:../../../assets/images/workout-results-1.webp");
var _workoutResults1WebpDefault = parcelHelpers.interopDefault(_workoutResults1Webp);
var _workoutResults2Webp = require("url:../../../assets/images/workout-results-2.webp");
var _workoutResults2WebpDefault = parcelHelpers.interopDefault(_workoutResults2Webp);
var _workoutResults3Webp = require("url:../../../assets/images/workout-results-3.webp");
var _workoutResults3WebpDefault = parcelHelpers.interopDefault(_workoutResults3Webp);
var _workoutResults4Webp = require("url:../../../assets/images/workout-results-4.webp");
var _workoutResults4WebpDefault = parcelHelpers.interopDefault(_workoutResults4Webp);
var _workoutResults5Webp = require("url:../../../assets/images/workout-results-5.webp");
var _workoutResults5WebpDefault = parcelHelpers.interopDefault(_workoutResults5Webp);
var _workoutResults6Webp = require("url:../../../assets/images/workout-results-6.webp");
var _workoutResults6WebpDefault = parcelHelpers.interopDefault(_workoutResults6Webp);
var _workoutResults7Webp = require("url:../../../assets/images/workout-results-7.webp");
var _workoutResults7WebpDefault = parcelHelpers.interopDefault(_workoutResults7Webp);
var _workoutResults8Webp = require("url:../../../assets/images/workout-results-8.webp");
var _workoutResults8WebpDefault = parcelHelpers.interopDefault(_workoutResults8Webp);
var _workoutResults9Webp = require("url:../../../assets/images/workout-results-9.webp");
var _workoutResults9WebpDefault = parcelHelpers.interopDefault(_workoutResults9Webp);
var _workoutResults10Webp = require("url:../../../assets/images/workout-results-10.webp");
var _workoutResults10WebpDefault = parcelHelpers.interopDefault(_workoutResults10Webp);
var _workoutResults11Webp = require("url:../../../assets/images/workout-results-11.webp");
var _workoutResults11WebpDefault = parcelHelpers.interopDefault(_workoutResults11Webp);
var _workoutResults12Webp = require("url:../../../assets/images/workout-results-12.webp");
var _workoutResults12WebpDefault = parcelHelpers.interopDefault(_workoutResults12Webp);
var _workoutResults13Webp = require("url:../../../assets/images/workout-results-13.webp");
var _workoutResults13WebpDefault = parcelHelpers.interopDefault(_workoutResults13Webp);
var _workoutResults14Webp = require("url:../../../assets/images/workout-results-14.webp");
var _workoutResults14WebpDefault = parcelHelpers.interopDefault(_workoutResults14Webp);
var _workoutResults15Webp = require("url:../../../assets/images/workout-results-15.webp");
var _workoutResults15WebpDefault = parcelHelpers.interopDefault(_workoutResults15Webp);
var _workoutResults16Webp = require("url:../../../assets/images/workout-results-16.webp");
var _workoutResults16WebpDefault = parcelHelpers.interopDefault(_workoutResults16Webp);
var _workoutResults17Webp = require("url:../../../assets/images/workout-results-17.webp");
var _workoutResults17WebpDefault = parcelHelpers.interopDefault(_workoutResults17Webp);
var _workoutResults18Webp = require("url:../../../assets/images/workout-results-18.webp");
var _workoutResults18WebpDefault = parcelHelpers.interopDefault(_workoutResults18Webp);
var _workoutResults19Webp = require("url:../../../assets/images/workout-results-19.webp");
var _workoutResults19WebpDefault = parcelHelpers.interopDefault(_workoutResults19Webp);
var _workoutResults20Webp = require("url:../../../assets/images/workout-results-20.webp");
var _workoutResults20WebpDefault = parcelHelpers.interopDefault(_workoutResults20Webp);
var _workoutResults21Webp = require("url:../../../assets/images/workout-results-21.webp");
var _workoutResults21WebpDefault = parcelHelpers.interopDefault(_workoutResults21Webp);
var _workoutResults22Webp = require("url:../../../assets/images/workout-results-22.webp");
var _workoutResults22WebpDefault = parcelHelpers.interopDefault(_workoutResults22Webp);
const workoutResultsImages = {
    homeProgress0: (0, _homeProgress0WebpDefault.default),
    workoutResults1: (0, _workoutResults1WebpDefault.default),
    workoutResults2: (0, _workoutResults2WebpDefault.default),
    workoutResults3: (0, _workoutResults3WebpDefault.default),
    workoutResults4: (0, _workoutResults4WebpDefault.default),
    workoutResults5: (0, _workoutResults5WebpDefault.default),
    workoutResults6: (0, _workoutResults6WebpDefault.default),
    workoutResults7: (0, _workoutResults7WebpDefault.default),
    workoutResults8: (0, _workoutResults8WebpDefault.default),
    workoutResults9: (0, _workoutResults9WebpDefault.default),
    workoutResults10: (0, _workoutResults10WebpDefault.default),
    workoutResults11: (0, _workoutResults11WebpDefault.default),
    workoutResults12: (0, _workoutResults12WebpDefault.default),
    workoutResults13: (0, _workoutResults13WebpDefault.default),
    workoutResults14: (0, _workoutResults14WebpDefault.default),
    workoutResults15: (0, _workoutResults15WebpDefault.default),
    workoutResults16: (0, _workoutResults16WebpDefault.default),
    workoutResults17: (0, _workoutResults17WebpDefault.default),
    workoutResults18: (0, _workoutResults18WebpDefault.default),
    workoutResults19: (0, _workoutResults19WebpDefault.default),
    workoutResults20: (0, _workoutResults20WebpDefault.default),
    workoutResults21: (0, _workoutResults21WebpDefault.default),
    workoutResults22: (0, _workoutResults22WebpDefault.default)
};
const workoutResultsImageList = Object.values(workoutResultsImages);

},{"url:../../../assets/images/home-progress-0.webp":"2T7E8","url:../../../assets/images/workout-results-1.webp":"aZTOA","url:../../../assets/images/workout-results-2.webp":"jJs2S","url:../../../assets/images/workout-results-3.webp":"jwO5V","url:../../../assets/images/workout-results-4.webp":"9b1y6","url:../../../assets/images/workout-results-5.webp":"2cWdT","url:../../../assets/images/workout-results-6.webp":"adVIJ","url:../../../assets/images/workout-results-7.webp":"cwc3m","url:../../../assets/images/workout-results-8.webp":"4IVdj","url:../../../assets/images/workout-results-9.webp":"7fqvO","url:../../../assets/images/workout-results-10.webp":"cfQYJ","url:../../../assets/images/workout-results-11.webp":"kG48S","url:../../../assets/images/workout-results-12.webp":"1ruEj","url:../../../assets/images/workout-results-13.webp":"i1I3h","url:../../../assets/images/workout-results-14.webp":"humAx","url:../../../assets/images/workout-results-15.webp":"sl1NG","url:../../../assets/images/workout-results-16.webp":"g8wig","url:../../../assets/images/workout-results-17.webp":"lrDFV","url:../../../assets/images/workout-results-18.webp":"5AQvH","url:../../../assets/images/workout-results-19.webp":"azLmN","url:../../../assets/images/workout-results-20.webp":"b8P58","url:../../../assets/images/workout-results-21.webp":"52eVy","url:../../../assets/images/workout-results-22.webp":"hlaOh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aZTOA":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7QNcr");

},{}],"jJs2S":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6btHJ");

},{}],"jwO5V":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6Og3e");

},{}],"9b1y6":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kZkXx");

},{}],"2cWdT":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8DGbG");

},{}],"adVIJ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("jZeaH");

},{}],"cwc3m":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("blEbZ");

},{}],"4IVdj":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("umtax");

},{}],"7fqvO":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3TB5B");

},{}],"cfQYJ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7GObV");

},{}],"kG48S":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8Y6u0");

},{}],"1ruEj":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ky4Ue");

},{}],"i1I3h":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9ZcyM");

},{}],"humAx":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lBM4P");

},{}],"sl1NG":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ejPgD");

},{}],"g8wig":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dy7Sh");

},{}],"lrDFV":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9gDuW");

},{}],"5AQvH":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7Yjvz");

},{}],"azLmN":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5EXQW");

},{}],"b8P58":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("jA6s1");

},{}],"52eVy":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("Sqko4");

},{}],"hlaOh":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("84sd1");

},{}],"j8tJt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preloadAssets", ()=>preloadAssets);
function preloadAssets(urls) {
    urls.forEach((src)=>{
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = src;
        if (src.endsWith('.mp4')) {
            link.as = 'video';
            link.type = 'video/mp4';
        } else if (src.endsWith('.webm')) {
            link.as = 'video';
            link.type = 'video/webm';
        } else link.as = 'image';
        document.head.appendChild(link);
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1x7AV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOS", ()=>getOS);
parcelHelpers.export(exports, "handleAppDownloadRedirect", ()=>handleAppDownloadRedirect);
var _appLinksConfig = require("../config/app-links.config");
const getOS = ()=>{
    const userAgent = window.navigator.userAgent || window.navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) return 'Android';
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) return 'iOS';
    return 'unknown';
};
const handleAppDownloadRedirect = ()=>{
    const os = getOS();
    const iosLink = (0, _appLinksConfig.APP_LINKS).ios && (0, _appLinksConfig.APP_LINKS).ios !== '#' ? (0, _appLinksConfig.APP_LINKS).ios : 'https://apps.apple.com/';
    if (os === 'iOS') window.location.href = iosLink;
    else window.open(iosLink, '_blank');
};

},{"../config/app-links.config":"lGiup","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lGiup":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "APP_LINKS", ()=>APP_LINKS);
const APP_LINKS = {
    ios: 'https://apps.apple.com/us/app/minipt-al-open-access/id6758595495',
    android: '#'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9lYJS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _seoDefault.default));
var _seo = require("./SEO");
var _seoDefault = parcelHelpers.interopDefault(_seo);

},{"./SEO":"dZ71k","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dZ71k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHelmetAsync = require("react-helmet-async");
const DEFAULT_DOMAIN = 'https://www.minipt.co.uk';
const DEFAULT_OG_IMAGE = 'https://www.minipt.co.uk/og-image.jpg';
const SEO = ({ title, description, canonicalUrl, ogImage, ogType = 'website' })=>{
    const domain = "https://www.minipt.co.uk".replace(/\/$/, '');
    const fullCanonicalUrl = canonicalUrl ? `${domain}${canonicalUrl.startsWith('/') ? canonicalUrl : `/${canonicalUrl}`}` : domain;
    const ogImageUrl = ogImage ? ogImage.startsWith('http') ? ogImage : `${domain}${ogImage.startsWith('/') ? ogImage : `/${ogImage}`}` : DEFAULT_OG_IMAGE;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactHelmetAsync.Helmet), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("title", {
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "title",
                content: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "description",
                content: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("link", {
                rel: "canonical",
                href: fullCanonicalUrl
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:type",
                content: ogType
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:site_name",
                content: "miniPT"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:title",
                content: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:description",
                content: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:image",
                content: ogImageUrl
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:image:secure_url",
                content: ogImageUrl
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:image:type",
                content: "image/png"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:image:width",
                content: "1200"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:image:height",
                content: "630"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:image:alt",
                content: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:url",
                content: fullCanonicalUrl
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                property: "og:locale",
                content: "en_GB"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "twitter:card",
                content: "summary_large_image"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "twitter:site",
                content: "@miniPT"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "twitter:creator",
                content: "@miniPT"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "twitter:title",
                content: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "twitter:description",
                content: description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "twitter:image",
                content: ogImageUrl
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "twitter:image:alt",
                content: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("meta", {
                name: "twitter:url",
                content: fullCanonicalUrl
            })
        ]
    });
};
exports.default = SEO;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-helmet-async":"eyrQZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jBYZm":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Trainer", ()=>Trainer);
var _jsxRuntime = require("react/jsx-runtime");
var _indexCss = require("../../index.css");
var _routeCss = require("../../route.css");
var _resetCss = require("../../reset.css");
// 🔹 React & Hooks
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("motion/react");
// 🔹 Routing
var _reactRouterDom = require("react-router-dom");
// 🔹 UI
var _antd = require("antd");
// 🔹 Internal Components
var _buttonTsx = require("src/components/Button/Button.tsx");
var _programUserSelectComponent = require("src/components/ProgramUserSelect/ProgramUserSelect.component");
var _programUserSelectComponentDefault = parcelHelpers.interopDefault(_programUserSelectComponent);
var _trainingNavigationButtonComponent = require("src/components/TrainingNavigationButton/TrainingNavigationButton.component");
var _trainingNavigationButtonComponentDefault = parcelHelpers.interopDefault(_trainingNavigationButtonComponent);
var _animatedStep = require("src/components/Animation/AnimatedStep");
var _textAnimate = require("src/components/Animation/text-animate");
var _autoCloseTooltip = require("src/components/AutoCloseTooltip/AutoCloseTooltip");
var _autoCloseTooltipDefault = parcelHelpers.interopDefault(_autoCloseTooltip);
var _commandDialog = require("src/components/Modals/CommandDialog/CommandDialog");
var _commandDialogDefault = parcelHelpers.interopDefault(_commandDialog);
var _seo = require("src/components/SEO");
var _seoDefault = parcelHelpers.interopDefault(_seo);
// 🔹 GSAP
var _gsapSetup = require("../../utils/gsapSetup");
var _gsapSetupDefault = parcelHelpers.interopDefault(_gsapSetup);
// 🔹 Store
var _trainingStore = require("src/store/trainingStore");
// 🔹 API Hooks
var _useWorkoutProgram = require("src/api/mutations/useWorkoutProgram");
// 🔹 Config
var _traninerConfig = require("src/config/traniner.config");
// 🔹 Assets
// Using static folder path for reliable access
var _miniPtCareMp4 = require("url:../../assets/videos/mini-pt-care.mp4");
var _miniPtCareMp4Default = parcelHelpers.interopDefault(_miniPtCareMp4);
var _useSliderDotClick = require("src/components/useSliderDotClick/useSliderDotClick");
var _useScreenTime = require("src/hooks/useScreenTime");
var _screenTimeTracker = require("src/utils/screenTimeTracker");
var _useUserBehaviorTracker = require("src/api/mutations/useUserBehaviorTracker");
var _programStore = require("src/store/programStore");
var _muscleGroupImages = require("../OnboardingTrainer/screens/Dashboard/screens/ProgramGeneratorAI/assets/MuscleGroupImages");
// Strings
const titleText = "Hi! I\u2019m MiniPT Core and I\u2019ll take care of building your workout program for you.";
const introTime = 1500;
const introButton = 200;
const formatName = (name, isMobile)=>{
    if (!name) return '';
    if (!isMobile) return name;
    const parts = name.split(' ');
    if (parts.length < 2) return name;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            parts[0],
            " ",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
            parts.slice(1).join(' ')
        ]
    });
};
const renderFormattedText = (text)=>{
    if (!text) return null;
    const parts = text.split(/(\*\*.*?\*\*)/gs);
    return parts.map((part, index)=>{
        if (part.startsWith('**') && part.endsWith('**')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
            children: part.slice(2, -2)
        }, index);
        return part;
    });
};
const information = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
    className: "postion-relative-2",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M7.99967 14.6663C11.6816 14.6663 14.6663 11.6816 14.6663 7.99967C14.6663 4.31778 11.6816 1.33301 7.99967 1.33301C4.31778 1.33301 1.33301 4.31778 1.33301 7.99967C1.33301 11.6816 4.31778 14.6663 7.99967 14.6663Z",
            stroke: "white",
            strokeOpacity: "0.7",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        }),
        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M8 10.6663V7.99967M8 5.33301H8.00667",
            stroke: "white",
            strokeOpacity: "0.7",
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    ]
});
const LoadingDots = ()=>{
    const [index, setIndex] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        const interval = setInterval(()=>{
            setIndex((prev)=>(prev + 1) % 4); // --> 0 to 3 dots
        }, 1000);
        return ()=>clearInterval(interval);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
        children: [
            "Loading",
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                style: {
                    display: 'inline-block',
                    width: '24px',
                    textAlign: 'left'
                },
                children: '.'.repeat(index)
            })
        ]
    });
};
const Trainer = ()=>{
    // Use
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const containerRef = (0, _react.useRef)(null);
    const miniPTGifRef = (0, _react.useRef)(null);
    const miniPTGifTextRef = (0, _react.useRef)(null);
    const miniPTGifScreen = (0, _react.useRef)(null);
    const miniPTGifScreen2 = (0, _react.useRef)(null);
    const activityLikeRef = (0, _react.useRef)(null);
    const fitnessLevelRef = (0, _react.useRef)(null);
    const mobilityLevelRef = (0, _react.useRef)(null);
    const stabilityControlRef = (0, _react.useRef)(null);
    const balanceConsistencyRef = (0, _react.useRef)(null);
    const movementSymmetryRef = (0, _react.useRef)(null);
    const overallMovementQualityRef = (0, _react.useRef)(null);
    const programDurationRef = (0, _react.useRef)(null);
    // Store
    const assessment = (0, _trainingStore.trainingStore)((state)=>state.assessment || {});
    // Client Firstname
    const firstName = assessment?.selectedClient?.name?.split(' ')[0] || 'Client';
    // Global State
    const [step, setStep] = (0, _react.useState)(1);
    const [stepAnimation, setStepAnimation] = (0, _react.useState)({});
    // Mutations
    const { mutate: requestSummaryInstruction, data: summaryData, isPending: isSummarizing } = (0, _useWorkoutProgram.useSummarizeInstruction)();
    const { mutate: generateWorkout, isPending: isGenerating } = (0, _useWorkoutProgram.useGenerateWorkoutProgram)();
    // Who is this program for? (Step 3)
    const [selectedClient, setSelectedClient] = (0, _react.useState)([]);
    // Let’s build the base for Client Firstname’s workout plan. (Step 4)
    const clientIntroTitle = `Let\u{2019}s build the base for ${firstName}\u{2019}s workout plan.`;
    // What's Client Firstname's baseline energy level? (Step 5)
    const [selectedEnergyLevel, setSelectedEnergyLevel] = (0, _react.useState)();
    // What's Client Firstname's non-gym activity like? (Step 6)
    const [activityLike, setActivityLike] = (0, _react.useState)(0);
    const [selectedScheduleFlexibility, setSelectedScheduleFlexibility] = (0, _react.useState)();
    // What’s the intensity vibe for this program? (Step 7)
    const [selectedIntensityVibe, setSelectedIntensityVibe] = (0, _react.useState)();
    // What’s their fitness level? (Step 8)
    const [fitnessLevel, setFitnessLevel] = (0, _react.useState)(3);
    // What is the training goal? (Step 9)
    const [selectedGoal, setSelectedGoal] = (0, _react.useState)();
    const [selectedGoalStyle, setSelectedGoalStyle] = (0, _react.useState)();
    // Movement Insights (Step 10)
    const [mobilityLevel, setMobilityLevel] = (0, _react.useState)(3);
    const [stabilityControl, setStabilityControl] = (0, _react.useState)(2);
    const [balanceConsistency, setBalanceConsistency] = (0, _react.useState)(3);
    const [movementSymmetry, setMovementSymmetry] = (0, _react.useState)(1);
    const [overallMovementQuality, setOverallMovementQuality] = (0, _react.useState)(2);
    // Program Duration (Step 12)
    const [programDuration, setProgramDuration] = (0, _react.useState)(0);
    const [minute, setMinute] = (0, _react.useState)(null);
    // How often will they train? (Step 13)
    const [selectedTime, setSelectedTime] = (0, _react.useState)([]);
    // What should this program focus on? (Step 14)
    const [selectedFocusProgram, setSelectedFocusProgram] = (0, _react.useState)([]);
    //Any injuries or limitations to keep in mind? (Step 15)
    const [selectedInjuries, setSelectedInjuries] = (0, _react.useState)([]);
    const [requirement, setRequirement] = (0, _react.useState)('');
    const [selectedDays, setSelectedDaysLocal] = (0, _react.useState)([
        'Mon',
        'Wed',
        'Fri'
    ]);
    const [selectedSummaryPrompts, setSelectedSummaryPrompts] = (0, _react.useState)([]);
    const [generateErrorVisible, setGenerateErrorVisible] = (0, _react.useState)(false);
    // Device
    const [device, setDevice] = (0, _react.useState)('desktop');
    (0, _react.useEffect)(()=>{
        const updateDevice = ()=>{
            const width = window.innerWidth;
            if (width <= 575) setDevice('mobile');
            else if (width <= 991) setDevice('tablet');
            else setDevice('desktop');
        };
        updateDevice();
        window.addEventListener('resize', updateDevice);
        return ()=>window.removeEventListener('resize', updateDevice);
    }, []);
    const buildWorkoutProgramPayload = (0, _react.useCallback)((extraInfo)=>({
            user_id: 'user123',
            user_name: firstName,
            body_weight: '180',
            mobility_level: (0, _traninerConfig.trainingMovementGrade)?.[mobilityLevel - 1]?.name || 'Medium',
            stability_level: (0, _traninerConfig.trainingMovementGrade)?.[stabilityControl - 1]?.name || 'Medium',
            balance_consistency: (0, _traninerConfig.trainingMovementGrade)?.[balanceConsistency - 1]?.name || 'Medium',
            movement_symmetry: (0, _traninerConfig.trainingMovementGrade)?.[movementSymmetry - 1]?.name || 'Medium',
            overall_movement_quality: (0, _traninerConfig.trainingMovementGrade)?.[overallMovementQuality - 1]?.name || 'Medium',
            program_name: 'Generated Program',
            program_length: programDuration,
            workout_duration: `${minute} minutes`,
            fitness_level: (0, _traninerConfig.fitnessLevels)?.[fitnessLevel - 1]?.name || 'Intermediate',
            energy_level: (0, _traninerConfig.trainingEnergyLevel)?.find((e)=>e.value === selectedEnergyLevel)?.name || 'Medium',
            daily_physical_load: (0, _traninerConfig.trainingActivityLike)?.[activityLike - 1]?.name || 'Moderate',
            goals: (0, _traninerConfig.trainingGoal)?.find((g)=>g.value === selectedGoal)?.name || 'Build muscle',
            training_goal: selectedGoalStyle || 'Strength',
            training_style: selectedGoalStyle || 'Strength',
            focused_area: selectedFocusProgram.join(', '),
            muscles: selectedFocusProgram,
            selected_days: assessment.selectedDays || [],
            selected_time: selectedTime.join(', '),
            workout_intensity: (0, _traninerConfig.trainingIntensity)?.find((i)=>i.value === selectedIntensityVibe)?.name || 'Moderate',
            injured_body_parts: selectedInjuries.join(', '),
            equiptments: [
                'Dumbbell',
                'Bodyweight',
                'Weight Plates',
                'Benches',
                'Power Racks/Squat Racks',
                'Cable Machines/Functional Trainers',
                'Leg Press Machine',
                'Lat Pulldown/Seated Row Machine',
                'Leg Extension/Leg Curl Machine',
                'Smith Machine',
                'Pec Deck/Chest Fly Machine',
                'Treadmills',
                'Rowing Machines',
                'Exercise Bikes',
                'Stair Climber/Elliptical',
                'Resistance Bands',
                'Pull-up Bars',
                'Yoga/Gym Mats'
            ],
            activation_date: '2026-04-23',
            preferences: requirement.trim().length > 0 ? requirement.trim() : 'None',
            extra_info: extraInfo.trim().length > 0 ? extraInfo.trim() : 'None',
            model: 'gemini-2.5-flash'
        }), [
        activityLike,
        assessment.selectedDays,
        balanceConsistency,
        firstName,
        fitnessLevel,
        minute,
        mobilityLevel,
        movementSymmetry,
        overallMovementQuality,
        programDuration,
        requirement,
        selectedEnergyLevel,
        selectedFocusProgram,
        selectedGoal,
        selectedGoalStyle,
        selectedInjuries,
        selectedIntensityVibe,
        selectedTime,
        stabilityControl
    ]);
    const handleSummaryPrompt = (0, _react.useCallback)((prompt)=>{
        if (containerRef.current) (0, _gsapSetupDefault.default).to(window, {
            duration: 0.6,
            scrollTo: containerRef.current,
            ease: 'power2.inOut'
        });
        setSelectedSummaryPrompts((prev)=>{
            const nextPrompts = prompt ? prev.includes(prompt) ? prev.filter((item)=>item !== prompt) : [
                ...prev,
                prompt
            ] : [];
            const summaryInstruction = nextPrompts.length > 0 ? nextPrompts.join('. ') : '';
            requestSummaryInstruction(buildWorkoutProgramPayload(summaryInstruction));
            return nextPrompts;
        });
    }, [
        buildWorkoutProgramPayload,
        requestSummaryInstruction
    ]);
    // Stable fingerprint of every field that feeds into buildWorkoutProgramPayload.
    // Uses the same dependency list as buildWorkoutProgramPayload so any user change
    // that would alter the payload is automatically detected.
    const summaryPayloadFingerprint = (0, _react.useMemo)(()=>JSON.stringify({
            activityLike,
            balanceConsistency,
            firstName,
            fitnessLevel,
            minute,
            mobilityLevel,
            movementSymmetry,
            overallMovementQuality,
            programDuration,
            requirement,
            selectedEnergyLevel,
            selectedFocusProgram: [
                ...selectedFocusProgram
            ].sort(),
            selectedGoal,
            selectedGoalStyle,
            selectedInjuries: [
                ...selectedInjuries
            ].sort(),
            selectedIntensityVibe,
            selectedTime: [
                ...selectedTime
            ].sort(),
            stabilityControl,
            selectedDays: [
                ...assessment.selectedDays || []
            ].sort()
        }), [
        activityLike,
        assessment.selectedDays,
        balanceConsistency,
        firstName,
        fitnessLevel,
        minute,
        mobilityLevel,
        movementSymmetry,
        overallMovementQuality,
        programDuration,
        requirement,
        selectedEnergyLevel,
        selectedFocusProgram,
        selectedGoal,
        selectedGoalStyle,
        selectedInjuries,
        selectedIntensityVibe,
        selectedTime,
        stabilityControl
    ]);
    // Tracks the fingerprint that was used for the most recent summary API call.
    // Stored in a ref so changes to it never trigger a re-render.
    const lastSummaryFingerprintRef = (0, _react.useRef)(null);
    // Fetch summary when reaching step 16, and re-fetch whenever the payload
    // data has changed since the last call (user went back, edited, returned).
    (0, _react.useEffect)(()=>{
        if (step !== 16 || isSummarizing) return;
        const isFirstFetch = lastSummaryFingerprintRef.current === null;
        const dataChanged = lastSummaryFingerprintRef.current !== summaryPayloadFingerprint;
        if (isFirstFetch || dataChanged) {
            lastSummaryFingerprintRef.current = summaryPayloadFingerprint;
            // handleSummaryPrompt() with no argument resets selectedSummaryPrompts to []
            // and fires a fresh API call with the current payload.
            handleSummaryPrompt();
        }
    }, [
        handleSummaryPrompt,
        isSummarizing,
        step,
        summaryPayloadFingerprint
    ]);
    const hasSummaryResponse = Boolean(summaryData?.response);
    const canProceedFromSummary = hasSummaryResponse && !isSummarizing;
    // Init Screen
    (0, _react.useEffect)(()=>{
        // Initial GSAP setup for State 1 (Rising Sun)
        if (miniPTGifRef.current) {
            (0, _gsapSetupDefault.default).set(miniPTGifRef.current, {
                xPercent: -50,
                yPercent: -50,
                y: '70vh',
                scale: 4,
                opacity: 0.8
            });
            if (window.innerWidth < 576) (0, _gsapSetupDefault.default).set(miniPTGifRef.current, {
                width: 150,
                height: 150,
                top: `40%`
            });
        }
        if (miniPTGifTextRef.current) (0, _gsapSetupDefault.default).set(miniPTGifTextRef.current, {
            opacity: 0
        }); // hide the "MiniPT Core" text
        if (miniPTGifScreen2.current) (0, _gsapSetupDefault.default).set(miniPTGifScreen2.current, {
            opacity: 0,
            display: 'none'
        });
    }, []);
    // Handler
    // Init Screen Handler
    const handleCreateProgram = (0, _react.useCallback)((value)=>{
        // Prevent double execution
        if (step === 2) return;
        const tl = (0, _gsapSetupDefault.default).timeline({
            onComplete: ()=>{
                const nextStep = typeof value === 'number' && Number.isFinite(value) ? value : 2;
                // eslint-disable-next-line react-hooks/immutability
                resetStep(nextStep);
                setStep(nextStep);
                localStorage.removeItem('minipt-tour-done');
                if (nextStep === 2) {
                    (0, _trainingStore.setSelectedDays)(selectedDays);
                    setSelectedDaysLocal([]);
                    // Wipe any previously generated program so a fresh run starts clean.
                    (0, _programStore.clearGeneratedProgram)();
                }
            }
        });
        // 1. Fade out Screen 1 smoothly
        tl.to(miniPTGifScreen.current, {
            y: -30,
            opacity: 0,
            duration: 0.5,
            ease: 'power2.inOut',
            onComplete: ()=>{
                (0, _gsapSetupDefault.default).set(miniPTGifScreen.current, {
                    display: 'none'
                });
                const parent = miniPTGifScreen.current?.parentElement;
                parent?.classList.remove('flex-center-column');
                (0, _gsapSetupDefault.default).set(miniPTGifRef.current, {
                    top: 'calc(var(--padding-top) + 250px + 32px)'
                });
            }
        }, 0);
        // 2. Interpolate Circle scale, Y-axis Translation, and explicit dimensions simultaneously
        // Goal: "arrive at the top and hit its final size simultaneously"
        tl.to(miniPTGifRef.current, {
            yPercent: -100,
            y: 'calc(var(--padding-top) - 125px)',
            scale: 1,
            width: 250,
            height: 250,
            opacity: 1,
            duration: 1.5,
            ease: 'power3.inOut'
        }, 0.2); // Start slightly after screen 1 starts fading out
        // Fade in the text inside circle after the scale down
        tl.to(miniPTGifTextRef.current, {
            opacity: 1,
            duration: 0.5,
            ease: 'power2.out'
        }, 1.2);
        // 3. Fade in Screen 2
        tl.set(miniPTGifScreen2.current, {
            display: 'flex'
        }, 1.0); // Display slightly before fading to avoid flicker
        tl.fromTo(miniPTGifScreen2.current, {
            y: 30,
            opacity: 0
        }, {
            y: 0,
            opacity: 1,
            duration: 0.6,
            ease: 'power2.out'
        }, 1.1);
    }, [
        selectedDays,
        step
    ]);
    (0, _react.useEffect)(()=>{
        if (location.search) {
            const path = location.search.split('?')?.[1] || null;
            if (path) {
                const step = {
                    'program-let-start-intro': 2,
                    'program-for': 3,
                    'program-client-select-intro': 4,
                    'program-energy-level': 5,
                    'program-activity': 6,
                    'program-intensity': 7,
                    'program-level': 8,
                    'program-goal': 9,
                    'program-movement-insight': 10,
                    'program-movement-insight-intro': 11,
                    'program-run': 12,
                    'program-frequency': 13,
                    'program-focus': 14,
                    'program-injuries': 15,
                    'program-generate': 16
                }[path];
                if (step) handleCreateProgram(step);
            }
        }
    }, [
        handleCreateProgram,
        location.search
    ]);
    // Animation For Global
    const updateStepAnimation = (step, key, value = true)=>{
        setStepAnimation((prev)=>({
                ...prev,
                [step]: {
                    ...prev[step],
                    [key]: value
                }
            }));
    };
    // Reset Animation For Global
    const resetStep = (step)=>{
        setStepAnimation((prev)=>{
            const currentStep = prev[step];
            if (!currentStep) return prev; // 👈 prevent crash
            return {
                ...prev,
                [step]: Object.keys(currentStep).reduce((acc, key)=>{
                    acc[key] = false;
                    return acc;
                }, {})
            };
        });
    };
    (0, _react.useEffect)(()=>{
        if (step >= 3 && containerRef.current) (0, _gsapSetupDefault.default).to(window, {
            duration: 0.6,
            scrollTo: containerRef.current,
            ease: 'power2.inOut'
        });
    }, [
        step
    ]);
    // Who is this program for? (Step 3)
    const toggleClient = (0, _react.useCallback)((id)=>{
        setSelectedClient([
            id
        ]);
        const selectedUser = (0, _traninerConfig.trainerProgramUser).find((user)=>user._id === id);
        if (!selectedUser) return;
        (0, _trainingStore.setClient)({
            _id: selectedUser._id,
            name: selectedUser.name,
            avatar: selectedUser.avatar
        });
        setTimeout(()=>{
            setStep(4);
        }, introButton);
    }, []);
    // What's Client Firstname's non-gym activity like? (Step 6)
    const handleActivityLike = (val)=>{
        setActivityLike(val);
        updateStepAnimation(step, 'description');
    };
    // What’s their fitness level? (Step 8)
    const handleFitnessLevel = (val)=>{
        setFitnessLevel(val);
        updateStepAnimation(step, 'fit-level');
    };
    // What is the training goal? (Step 9)
    const goalHandler = (goal)=>{
        setSelectedGoal(goal);
        setSelectedGoalStyle(null);
        updateStepAnimation(step, 'goal');
    };
    const goalStyleHandler = (goal)=>{
        setSelectedGoalStyle(goal);
        if (goal) setTimeout(()=>{
            setStep(10);
        }, introButton);
    };
    // Movement Insights (Step 10)
    const handleMobilityLevelChange = (val)=>{
        setMobilityLevel(val);
    };
    const handleStabilityControlChange = (val)=>{
        setStabilityControl(val);
    };
    const handleBalanceConsistencyChange = (val)=>{
        setBalanceConsistency(val);
    };
    const handleMovementSymmetryChange = (val)=>{
        setMovementSymmetry(val);
    };
    const handleOverallMovementQualityChange = (val)=>{
        setOverallMovementQuality(val);
    };
    // Program Duration (Step 12)
    const handleProgramDuration = (val)=>{
        setProgramDuration(val);
        updateStepAnimation(step, 'duration');
    };
    // How often will they train? (Step 13)
    const handleToggleDay = (day)=>{
        (0, _trainingStore.toggleAssessmentDay)(day);
        if (day) updateStepAnimation(step, 'reminder');
    };
    const toggleTime = (time)=>{
        setSelectedTime((prev)=>prev.includes(time) ? prev.filter((d)=>d !== time) : [
                time
            ]);
        setTimeout(()=>{
            setStep(14);
        }, introButton);
    };
    // What should this program focus on? (Step 14)
    const toggleFocusProgram = (focusProgram)=>{
        setSelectedFocusProgram((prev)=>{
            // If user selects "Full Body", make it exclusive
            if (focusProgram === 'Full Body') return [
                'Full Body'
            ];
            // If selecting any other program
            // 1. remove "Full Body" if it's currently selected
            const withoutFullBody = prev.filter((p)=>p !== 'Full Body');
            // 2. toggle the selected program
            return withoutFullBody.includes(focusProgram) ? withoutFullBody.filter((p)=>p !== focusProgram) : [
                ...withoutFullBody,
                focusProgram
            ];
        });
    };
    //Any injuries or limitations to keep in mind? (Step 15)
    const injuriesHandler = (injuries)=>{
        setSelectedInjuries((prev)=>prev.includes(injuries) ? prev.filter((d)=>d !== injuries) : [
                ...prev,
                injuries
            ]);
    };
    const requirementHandler = (value)=>{
        setRequirement(value || '');
    };
    // Antd Generate Slide
    // What's Client Firstname's non-gym activity like? (Step 6)
    // 🔥 Generate marks with fitness levels from config
    const activityLikeNames = (0, _traninerConfig.trainingActivityLike)?.map((level)=>level.name);
    const activityLikeMarks = {};
    activityLikeNames.forEach((level, index)=>{
        const step = index + 1;
        activityLikeMarks[step] = {
            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `mark-label ${activityLike === step ? `active-mark` : ''}`,
                onClick: ()=>handleActivityLike(step),
                children: level
            })
        };
    });
    // 🔥 Generate marks with fitness levels from config
    const fitnessLevelNames = (0, _traninerConfig.fitnessLevels)?.map((level)=>level.name);
    const fitnessLevelMarks = {};
    fitnessLevelNames.forEach((level, index)=>{
        const step = index + 1;
        fitnessLevelMarks[step] = {
            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `mark-label ${fitnessLevel === step ? `active-mark` : ''}`,
                onClick: ()=>handleFitnessLevel(step),
                children: level
            })
        };
    });
    // 🔥 Generate marks with fitness levels from config
    const trainingMovementNames = (0, _traninerConfig.trainingMovementGrade)?.map((level)=>level.name);
    const mobilityLevelMarks = {};
    trainingMovementNames.forEach((level, index)=>{
        const step = index + 1;
        mobilityLevelMarks[step] = {
            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `mark-label ${mobilityLevel === step ? `active-mark` : ''}`,
                onClick: ()=>handleMobilityLevelChange(step),
                children: level
            })
        };
    });
    const stabilityControlMarks = {};
    trainingMovementNames.forEach((level, index)=>{
        const step = index + 1;
        stabilityControlMarks[step] = {
            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `mark-label ${stabilityControl === step ? `active-mark` : ''}`,
                onClick: ()=>handleStabilityControlChange(step),
                children: level
            })
        };
    });
    const balanceConsistencyMarks = {};
    trainingMovementNames.forEach((level, index)=>{
        const step = index + 1;
        balanceConsistencyMarks[step] = {
            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `mark-label ${balanceConsistency === step ? `active-mark` : ''}`,
                onClick: ()=>handleBalanceConsistencyChange(step),
                children: level
            })
        };
    });
    const movementSymmetryMarks = {};
    trainingMovementNames.forEach((level, index)=>{
        const step = index + 1;
        movementSymmetryMarks[step] = {
            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `mark-label ${movementSymmetry === step ? `active-mark` : ''}`,
                onClick: ()=>handleMovementSymmetryChange(step),
                children: level
            })
        };
    });
    const overallMovementQualityMarks = {};
    trainingMovementNames.forEach((level, index)=>{
        const step = index + 1;
        overallMovementQualityMarks[step] = {
            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `mark-label ${overallMovementQuality === step ? `active-mark` : ''}`,
                onClick: ()=>handleOverallMovementQualityChange(step),
                children: level
            })
        };
    });
    // 🔥 Generate marks (1 → 12)
    const programDurationMarks = Array.from({
        length: 12
    }).reduce((acc, _, i)=>{
        const step = i + 1;
        acc[step] = {
            label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: `mark-label ${programDuration === step ? `active-mark` : ''}`,
                onClick: ()=>handleProgramDuration(step),
                children: step
            })
        };
        return acc;
    }, {});
    const isSelected = (day)=>assessment.selectedDays?.includes(day) || false;
    const isSelectedTime = (time)=>selectedTime.includes(time);
    const isSelectedFocusProgram = (focusProgram)=>selectedFocusProgram.includes(focusProgram);
    const isSelectedInjuries = (injuries)=>selectedInjuries.includes(injuries);
    const getSelectedGoal = (0, _traninerConfig.trainingGoal)?.find((goal)=>goal.value === selectedGoal);
    const days = [
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
        'Sun'
    ];
    const times = [
        'Morning',
        'Lunch',
        'Evening '
    ];
    const focusProgram = [
        'Full Body',
        'Upper Body',
        'Lower Body',
        'Core',
        'Back',
        'Glutes'
    ];
    const prompts = [
        'Gradually raise workout intensity',
        'All weeks should have the same workout'
    ];
    const stepClass = {
        1: 'page-program-creator-demo',
        2: 'page-program-creator-demo-intro',
        3: 'page-program-for',
        5: 'page-program-energy-level',
        6: 'page-program-activity',
        7: 'page-program-intensity',
        8: 'page-program-level',
        9: 'page-program-goal',
        10: 'page-program-movement-insight',
        12: 'page-program-run',
        13: 'page-program-frequency',
        14: 'page-trainer-program-focus',
        15: `page-trainer-program-injuries`,
        16: 'page-trainer-program-generate'
    }[step] || '';
    const nextDisableStep = step ? ({
        5: !selectedEnergyLevel,
        6: !selectedScheduleFlexibility && activityLike >= 0,
        7: !selectedIntensityVibe,
        8: !(fitnessLevel > 0),
        9: !(selectedGoal && selectedGoalStyle),
        10: !(mobilityLevel > 0 && stabilityControl > 0 && balanceConsistency > 0 && movementSymmetry > 0 && overallMovementQuality > 0),
        12: !(programDuration && minute),
        13: !(assessment.selectedDays?.length && selectedTime?.length),
        14: !selectedFocusProgram?.length,
        16: true
    })[step] || false : true;
    (0, _useSliderDotClick.useSliderDotClick)({
        ref: activityLikeRef,
        step,
        targetStep: 6,
        onDotClick: ()=>handleActivityLike(1)
    });
    (0, _useSliderDotClick.useSliderDotClick)({
        ref: fitnessLevelRef,
        step,
        targetStep: 8,
        onDotClick: ()=>handleFitnessLevel(1)
    });
    (0, _useSliderDotClick.useSliderDotClick)({
        ref: mobilityLevelRef,
        step,
        targetStep: 10,
        onDotClick: ()=>handleMobilityLevelChange(1)
    });
    (0, _useSliderDotClick.useSliderDotClick)({
        ref: stabilityControlRef,
        step,
        targetStep: 10,
        onDotClick: ()=>handleStabilityControlChange(1)
    });
    (0, _useSliderDotClick.useSliderDotClick)({
        ref: balanceConsistencyRef,
        step,
        targetStep: 10,
        onDotClick: ()=>handleBalanceConsistencyChange(1)
    });
    (0, _useSliderDotClick.useSliderDotClick)({
        ref: movementSymmetryRef,
        step,
        targetStep: 10,
        onDotClick: ()=>handleMovementSymmetryChange(1)
    });
    (0, _useSliderDotClick.useSliderDotClick)({
        ref: overallMovementQualityRef,
        step,
        targetStep: 10,
        onDotClick: ()=>handleOverallMovementQualityChange(1)
    });
    (0, _useSliderDotClick.useSliderDotClick)({
        ref: programDurationRef,
        step,
        targetStep: 12,
        onDotClick: ()=>handleProgramDuration(1)
    });
    // ── Screen time tracking ──────────────────────────────────────────────────
    // Automatically tracks time per section; skips automated transitions (steps 2, 4, 11).
    // Pass active=false when the step has no mapping so an empty-string section
    // is never created in the tracker (guards against unknown step values).
    const _currentSection = (0, _screenTimeTracker.STEP_TO_SECTION)[step] ?? '';
    (0, _useScreenTime.useScreenTime)(_currentSection, Boolean(_currentSection));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seoDefault.default), {
                title: "miniPT for Trainers",
                description: "Manage your clients, create personalized programs, and grow your fitness business with miniPT.",
                canonicalUrl: "/trainer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `miniPT-container miniPT-training-container ${step > 2 && step <= 10 || step > 12 && step <= 16 ? `miniPT-animation` : ``} ${stepClass}`,
                ref: containerRef,
                "data-step": step,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commandDialogDefault.default), {
                        visible: generateErrorVisible,
                        onClose: ()=>setGenerateErrorVisible(false),
                        type: "error",
                        title: "We couldn\u2019t generate the program",
                        description: "Something went wrong while creating the workout program. Please try again later.",
                        confirmText: "Okay"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `flex-center-column miniPT-animation-container ${isGenerating || isSummarizing ? `ai-program-generating` : ``}`,
                        ref: miniPTGifRef,
                        style: {
                            position: 'fixed',
                            top: '50%',
                            left: '50%',
                            width: 300,
                            height: 300,
                            zIndex: 0,
                            pointerEvents: 'none',
                            mixBlendMode: 'lighten'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                                autoPlay: true,
                                muted: true,
                                loop: true,
                                playsInline: true,
                                preload: "auto",
                                style: {
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    zIndex: 0,
                                    mixBlendMode: 'lighten'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                                    src: (0, _miniPtCareMp4Default.default),
                                    type: "video/mp4"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                ref: miniPTGifTextRef,
                                className: "mini-pt-text",
                                children: "MiniPT Core"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `background-wrapper flex-center-column px-16`,
                        style: {
                            position: 'relative',
                            zIndex: 1,
                            width: '100%'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                ref: miniPTGifScreen,
                                className: "background-wrapper-content flex-center-column",
                                style: {
                                    marginTop: '-10vh'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: `creator-card`,
                                        style: {
                                            textTransform: 'uppercase'
                                        },
                                        children: "Program creator DEMO"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                                        className: `page-title`,
                                        style: {
                                            textAlign: 'center'
                                        },
                                        children: [
                                            "Build structured workout ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "programs ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `text-primary-light`,
                                                children: "10x faster"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        style: {
                                            textAlign: 'center'
                                        },
                                        className: "mt-0 text-light fs-16",
                                        children: "Define your structure once, then let AI generate a complete program instantly."
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        style: {
                                            textAlign: 'center'
                                        },
                                        className: "sound-great fs-16",
                                        children: "Sounds great! Let\u2019s start"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                        onClick: handleCreateProgram,
                                        variant: "primary",
                                        className: `bg-gradient-color relative-z-10`,
                                        children: "Create a Program"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                ref: miniPTGifScreen2,
                                className: "flex-center-column animation-margin-top",
                                children: [
                                    step === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "max-width-768",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAnimate.TextAnimate), {
                                            animation: "slideUp",
                                            by: "word",
                                            as: "h2",
                                            center: true,
                                            className: "page-intro-title mt-0",
                                            duration: 1,
                                            delay: 0.05,
                                            onComplete: ()=>{
                                                setTimeout(()=>{
                                                    setStep(3);
                                                }, introTime);
                                            },
                                            children: titleText
                                        })
                                    }),
                                    step === 3 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "max-width-768 route-fade-in",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                className: "page-sub-title text-center mt-0 page-sub-title-margin",
                                                children: "Who is this program for?"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-light text-center mt-0 page-secondary-margin fs-18",
                                                children: "Let\u2019s select a client from your list."
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programUserSelectComponentDefault.default), {
                                                users: (0, _traninerConfig.trainerProgramUser),
                                                selectedIds: selectedClient,
                                                toggleUser: toggleClient
                                            })
                                        ]
                                    }),
                                    step === 4 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "max-width-768",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAnimate.TextAnimate), {
                                            animation: "slideUp",
                                            by: "word",
                                            as: "h2",
                                            center: true,
                                            className: "page-intro-title mt-0",
                                            duration: 1,
                                            delay: 0.05,
                                            onComplete: ()=>{
                                                setTimeout(()=>{
                                                    setStep(5);
                                                }, introTime);
                                            },
                                            children: clientIntroTitle
                                        })
                                    }),
                                    step === 5 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "max-width-768 route-fade-in",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                    className: "page-sub-title text-center mt-0 mb-12",
                                                    children: `What's ${firstName}'s baseline energy level?`
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-light text-center mt-0 mb-32 fs-18",
                                                    children: "I\u2019ll use this to set the baseline for their recovery and intensity curves."
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex-button max-width-576",
                                                    children: (0, _traninerConfig.trainingEnergyLevel)?.map((energy)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                            onClick: ()=>{
                                                                setSelectedEnergyLevel(energy?.value);
                                                                setTimeout(()=>{
                                                                    setStep(6);
                                                                }, introButton);
                                                            },
                                                            variant: "primary",
                                                            className: `${selectedEnergyLevel && selectedEnergyLevel === energy?.value ? `active` : ``} button-svg flex-md-1`,
                                                            svg: energy?.icon,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "flex-1",
                                                                children: energy?.name
                                                            })
                                                        }, energy?.value))
                                                })
                                            ]
                                        })
                                    }),
                                    step === 6 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "max-width-768 route-fade-in",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                className: "page-sub-title text-center mt-0 mb-12",
                                                children: `What's ${firstName || ''}'s non-gym activity like?`
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "text-light text-center mt-0 mb-32 fs-18",
                                                children: `We account for their daily physical load to ensure the program isn't overreaching.`
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "max-width-768 gradient-wrapper",
                                                ref: activityLikeRef,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Slider), {
                                                        min: 1,
                                                        max: 3,
                                                        step: activityLike,
                                                        value: activityLike ?? undefined,
                                                        onChange: handleActivityLike,
                                                        marks: activityLikeMarks,
                                                        tooltip: {
                                                            open: false
                                                        },
                                                        className: `mobile-gradient-slider gradient-slider text-start-end ${activityLike ? `` : `not-select`}`
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _animatedStep.AnimatedStep), {
                                                        isVisible: activityLike > 0,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "gradient-description-container",
                                                            style: activityLike ? {
                                                                marginTop: 40
                                                            } : {},
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                                                className: "gradient-description-list",
                                                                children: (0, _traninerConfig.trainingActivityLike)[activityLike - 1]?.descriptions?.map((description, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.motion).li, {
                                                                        initial: {
                                                                            opacity: 0,
                                                                            clipPath: 'inset(0 100% 0 0)'
                                                                        },
                                                                        animate: {
                                                                            opacity: 0.7,
                                                                            clipPath: 'inset(0 0 0 0)'
                                                                        },
                                                                        transition: {
                                                                            delay: index * 0.1,
                                                                            duration: 0.8,
                                                                            ease: 'easeInOut'
                                                                        },
                                                                        className: "gradient-description-item text-light slide-up-item",
                                                                        children: description
                                                                    }, index))
                                                            }, activityLike)
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _animatedStep.AnimatedStep), {
                                                isVisible: activityLike > 0 && stepAnimation?.[step]?.description,
                                                className: "text-center",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        style: {
                                                            marginTop: 21,
                                                            marginBottom: 16
                                                        },
                                                        className: "fs-18 client-best-style",
                                                        children: [
                                                            "How flexible is ",
                                                            firstName,
                                                            "'s schedule?"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "flex-button",
                                                        children: (0, _traninerConfig.trainingScheduleFlexibility)?.map((schedule)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                                onClick: ()=>{
                                                                    setSelectedScheduleFlexibility(schedule?.value);
                                                                    if (schedule?.value) setTimeout(()=>{
                                                                        setStep(7);
                                                                    }, introButton);
                                                                },
                                                                variant: "primary",
                                                                className: `${selectedScheduleFlexibility && selectedScheduleFlexibility === schedule?.value ? `active` : ``} flex-md-120`,
                                                                children: schedule?.name
                                                            }, schedule?.value))
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    step === 7 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "max-width-768 route-fade-in",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                    className: "page-sub-title text-center mt-0 mb-12",
                                                    children: `What\u{2019}s the intensity vibe for this program?`
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-light text-center mt-0 mb-32",
                                                    children: `Pick the baseline stimulus you want Oliver to experience.`
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "flex-button",
                                                    children: (0, _traninerConfig.trainingIntensity)?.map((energy)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                            onClick: ()=>{
                                                                setSelectedIntensityVibe(energy?.value);
                                                                if (energy?.value) setTimeout(()=>{
                                                                    setStep(8);
                                                                }, introButton);
                                                            },
                                                            variant: "primary",
                                                            className: `${selectedIntensityVibe && selectedIntensityVibe === energy?.value ? `active` : ``} button-svg flex-md-160`,
                                                            svg: energy?.icon,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "flex-1",
                                                                children: formatName(energy?.name, device === 'mobile')
                                                            })
                                                        }, energy?.value))
                                                })
                                            ]
                                        })
                                    }),
                                    step === 8 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "max-width-768 route-fade-in",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                        className: "page-sub-title text-center mt-0 mb-12",
                                                        children: `What\u{2019}s their fitness level?`
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "text-light text-center mt-0 mb-32",
                                                        children: [
                                                            "Looks like your client is",
                                                            ' ',
                                                            fitnessLevel > 0 ? fitnessLevelNames[fitnessLevel - 1] : 'Intermediate',
                                                            " level. Do you want to make any changes?"
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "max-width-768 gradient-wrapper route-fade-in",
                                                ref: fitnessLevelRef,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Slider), {
                                                        min: 1,
                                                        max: 5,
                                                        step: fitnessLevel,
                                                        value: fitnessLevel,
                                                        onChange: handleFitnessLevel,
                                                        marks: fitnessLevelMarks,
                                                        tooltip: {
                                                            open: false
                                                        },
                                                        className: `mobile-gradient-slider gradient-slider text-start-end ${fitnessLevel ? `` : `not-select`}`
                                                    }),
                                                    fitnessLevel > 0 && (stepAnimation?.[step]?.['fit-level'] ?? fitnessLevel) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _animatedStep.AnimatedStep), {
                                                            isVisible: stepAnimation?.[step]?.['fit-level'] ?? fitnessLevel,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "gradient-description-container",
                                                                style: {
                                                                    marginTop: 40
                                                                },
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                                                    className: "gradient-description-list",
                                                                    children: (0, _traninerConfig.fitnessLevels)[fitnessLevel - 1]?.descriptions?.map((description, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.motion).li, {
                                                                            initial: {
                                                                                opacity: 0,
                                                                                clipPath: 'inset(0 100% 0 0)'
                                                                            },
                                                                            animate: {
                                                                                opacity: 0.7,
                                                                                clipPath: 'inset(0 0 0 0)'
                                                                            },
                                                                            transition: {
                                                                                delay: index * 0.1,
                                                                                duration: 0.8,
                                                                                ease: 'easeInOut'
                                                                            },
                                                                            className: "gradient-description-item text-light slide-up-item",
                                                                            children: description
                                                                        }, index))
                                                                }, fitnessLevel)
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    step === 9 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "max-width-768 route-fade-in",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                    className: "page-sub-title text-center mt-0 mb-12",
                                                    children: `What is the training goal?`
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-light text-center mt-0 mb-32",
                                                    children: "Looks like your client wants to build muscle. Do you want to make any changes?"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `max-width-576 grid-button`,
                                                    children: (0, _traninerConfig.trainingGoal).map((goal, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                            onClick: ()=>goalHandler(goal?.value),
                                                            variant: "primary",
                                                            className: `${selectedGoal === goal?.value ? `active` : ``}`,
                                                            svg: goal?.icon,
                                                            children: goal?.name
                                                        }, goal?.value + index))
                                                }),
                                                selectedGoal && getSelectedGoal && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _animatedStep.AnimatedStep), {
                                                        isVisible: stepAnimation?.[step]?.['goal'],
                                                        className: "text-center",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                style: {
                                                                    marginBottom: 16,
                                                                    marginTop: 32
                                                                },
                                                                className: "client-best-style",
                                                                children: `What training style suits your client best?`
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: `max-width-576 grid-button`,
                                                                children: getSelectedGoal && getSelectedGoal?.styles?.map((style, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                                        onClick: ()=>goalStyleHandler(style?.value),
                                                                        variant: "primary",
                                                                        className: `${selectedGoalStyle === style?.value ? `active` : ``} `,
                                                                        svg: style?.icon,
                                                                        children: style?.name
                                                                    }, style?.value + index))
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    step === 10 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "max-width-768 route-fade-in",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                        className: "page-sub-title text-center mt-0 mb-12",
                                                        children: `Movement Insights`
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "text-light text-center mb-32 mt-0",
                                                        children: "We\u2019ve analysed your client\u2019s movement patterns. You can adjust these if needed."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "max-width-768 gradient-wrapper route-fade-in",
                                                ref: mobilityLevelRef,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "text-start mt-0 information-primary-text",
                                                        children: [
                                                            "Mobility level",
                                                            ' ',
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autoCloseTooltipDefault.default), {
                                                                title: `I will use this to set the safe range of motion for your client\u{2019}s exercises.`,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "information",
                                                                    children: information
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: `text-light text-start mt-0 mb-2-5 information-text`,
                                                        children: `I will use this to set the safe range of motion for your client\u{2019}s exercises.`
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Slider), {
                                                        min: 1,
                                                        max: 3,
                                                        step: mobilityLevel,
                                                        value: mobilityLevel,
                                                        onChange: handleMobilityLevelChange,
                                                        marks: mobilityLevelMarks,
                                                        tooltip: {
                                                            open: false
                                                        },
                                                        className: `mobile-gradient-slider gradient-slider text-start-end ${mobilityLevel ? `` : `not-select`}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "max-width-768 gradient-wrapper route-fade-in",
                                                ref: stabilityControlRef,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "text-start mt-0 information-primary-text",
                                                        children: [
                                                            "Stability Control",
                                                            ' ',
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autoCloseTooltipDefault.default), {
                                                                title: `This helps me decide when to use supported machines versus free weights.`,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "information",
                                                                    children: information
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: `text-light text-start mt-0 mb-2-5 information-text`,
                                                        children: "This helps me decide when to use supported machines versus free weights."
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Slider), {
                                                        min: 1,
                                                        max: 3,
                                                        step: stabilityControl,
                                                        value: stabilityControl,
                                                        onChange: handleStabilityControlChange,
                                                        marks: stabilityControlMarks,
                                                        tooltip: {
                                                            open: false
                                                        },
                                                        className: `mobile-gradient-slider gradient-slider text-start-end ${stabilityControl ? `` : `not-select`}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "max-width-768 gradient-wrapper route-fade-in",
                                                ref: balanceConsistencyRef,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "text-start mt-0 information-primary-text",
                                                        children: [
                                                            "Balance Consistency",
                                                            ' ',
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autoCloseTooltipDefault.default), {
                                                                title: `This helps to balance the program between unilateral and bilateral movements.`,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "information",
                                                                    children: information
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: `text-light text-start mt-0 mb-2-5 information-text`,
                                                        children: "This helps to balance the program between unilateral and bilateral movements."
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Slider), {
                                                        min: 1,
                                                        max: 3,
                                                        step: balanceConsistency,
                                                        value: balanceConsistency,
                                                        onChange: handleBalanceConsistencyChange,
                                                        marks: balanceConsistencyMarks,
                                                        tooltip: {
                                                            open: false
                                                        },
                                                        className: `mobile-gradient-slider gradient-slider text-start-end ${balanceConsistency ? `` : `not-select`}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "max-width-768 gradient-wrapper route-fade-in",
                                                ref: movementSymmetryRef,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "text-start mt-0 information-primary-text",
                                                        children: [
                                                            "Movement Symmetry",
                                                            ' ',
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autoCloseTooltipDefault.default), {
                                                                title: `This flags where we might need extra corrective work to fix side-to-side
                  imbalances.`,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "information",
                                                                    children: information
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: `text-light text-start mt-0 mb-2-5 information-text`,
                                                        children: "This flags where we might need extra corrective work to fix side-to-side imbalances."
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Slider), {
                                                        min: 1,
                                                        max: 3,
                                                        step: movementSymmetry,
                                                        value: movementSymmetry,
                                                        onChange: handleMovementSymmetryChange,
                                                        marks: movementSymmetryMarks,
                                                        tooltip: {
                                                            open: false
                                                        },
                                                        className: `mobile-gradient-slider gradient-slider text-start-end ${movementSymmetry ? `` : `not-select`}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "max-width-768 gradient-wrapper route-fade-in",
                                                ref: overallMovementQualityRef,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "text-start mt-0 information-primary-text",
                                                        children: [
                                                            "Overall Movement Quality",
                                                            ' ',
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _autoCloseTooltipDefault.default), {
                                                                title: `This is my primary filter for determining the total technical complexity of the
                  plan.`,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "information",
                                                                    children: information
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: `text-light text-start mt-0 mb-2-5 information-text`,
                                                        children: "This is my primary filter for determining the total technical complexity of the plan."
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Slider), {
                                                        min: 1,
                                                        max: 3,
                                                        step: overallMovementQuality,
                                                        value: overallMovementQuality,
                                                        onChange: handleOverallMovementQualityChange,
                                                        marks: overallMovementQualityMarks,
                                                        tooltip: {
                                                            open: false
                                                        },
                                                        className: `mobile-gradient-slider gradient-slider text-start-end ${overallMovementQuality ? `` : `not-select`}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "max-width-next route-fade-in",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                    onClick: ()=>{
                                                        setTimeout(()=>{
                                                            setStep(11);
                                                        }, introButton);
                                                    },
                                                    variant: "primary",
                                                    className: `flex-next`,
                                                    disabled: !(mobilityLevel > 0 && stabilityControl > 0 && balanceConsistency > 0 && movementSymmetry > 0 && overallMovementQuality > 0),
                                                    children: "Next"
                                                })
                                            })
                                        ]
                                    }),
                                    step === 11 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "max-width-768 route-fade-in",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAnimate.TextAnimate), {
                                            animation: "slideUp",
                                            by: "word",
                                            as: "h2",
                                            center: true,
                                            className: "page-intro-title mt-0",
                                            duration: 1,
                                            delay: 0.05,
                                            onComplete: ()=>{
                                                setTimeout(()=>{
                                                    setStep(12);
                                                }, introTime);
                                            },
                                            children: `Great! Now let\u{2019}s talk about the program`
                                        })
                                    }),
                                    step === 12 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "max-width-768 route-fade-in",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                    className: "page-sub-title text-center mt-0 mb-12",
                                                    children: `Let\u{2019}s set the program duration.`
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "text-light text-center mt-0 mb-32",
                                                    children: `How many weeks are we planning for?`
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `max-width-768 gradient-wrapper`,
                                                    ref: programDurationRef,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Slider), {
                                                        min: 1,
                                                        max: 12,
                                                        step: programDuration,
                                                        value: programDuration,
                                                        onChange: handleProgramDuration,
                                                        marks: programDurationMarks,
                                                        tooltip: {
                                                            open: false
                                                        },
                                                        className: `gradient-slider ${programDuration ? `` : `not-select`}`
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "max-width-768 text-center",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _animatedStep.AnimatedStep), {
                                                        isVisible: stepAnimation?.[step]?.duration,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                style: {
                                                                    marginTop: 21,
                                                                    marginBottom: 16
                                                                },
                                                                className: "client-best-style",
                                                                children: "How long should be the workouts?"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: `flex-button`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                                        onClick: ()=>{
                                                                            setMinute(15);
                                                                            setTimeout(()=>{
                                                                                setStep(13);
                                                                            }, introButton);
                                                                        },
                                                                        variant: "primary",
                                                                        className: `${minute === 15 ? `active` : ``} flex-md-110`,
                                                                        children: "15 min"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                                        onClick: ()=>{
                                                                            setMinute(30);
                                                                            setTimeout(()=>{
                                                                                setStep(13);
                                                                            }, introButton);
                                                                        },
                                                                        variant: "primary",
                                                                        className: `${minute === 30 ? `active` : ``} flex-md-110`,
                                                                        children: "30 min"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                                        onClick: ()=>{
                                                                            setMinute(45);
                                                                            setTimeout(()=>{
                                                                                setStep(13);
                                                                            }, introButton);
                                                                        },
                                                                        variant: "primary",
                                                                        className: `${minute === 45 ? `active` : ``} flex-md-110`,
                                                                        children: "45 min"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    step === 13 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "max-width-768 route-fade-in",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                    className: "page-sub-title text-center mt-0 mb-12",
                                                    children: `How often will they train?`
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "max-width-576 ",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "text-light text-center mt-0 mb-32",
                                                        children: `Looks like your client set their preferred workout days. Do you want to make
                      any changes?`
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `flex-button flex-days`,
                                                    children: days.map((day)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                            onClick: ()=>handleToggleDay(day),
                                                            variant: "primary",
                                                            className: `${isSelected(day) ? `active` : ``} flex-md-80 justify-content-center`,
                                                            children: day
                                                        }, day))
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _animatedStep.AnimatedStep), {
                                                    isVisible: stepAnimation?.[step]?.reminder || assessment.selectedDays?.length > 0,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: `reminder-container`,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: `text-center client-best-style`,
                                                                style: {
                                                                    marginBottom: 16,
                                                                    marginTop: 31
                                                                },
                                                                children: `Let's set a reminder for them`
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: `flex-button`,
                                                                children: times.map((time)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                                        onClick: ()=>toggleTime(time),
                                                                        variant: "primary",
                                                                        className: `${isSelectedTime(time) ? `active` : ``} flex-md-120`,
                                                                        children: time
                                                                    }, time))
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "max-width-next route-fade-in",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                        onClick: ()=>{
                                                            setTimeout(()=>{
                                                                setStep(13);
                                                            }, introButton);
                                                        },
                                                        variant: "primary",
                                                        className: `flex-next`,
                                                        disabled: !selectedTime?.length,
                                                        children: "Next"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    step === 14 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "max-width-768 route-fade-in",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                        className: "page-sub-title text-center mt-0 mb-12",
                                                        children: `What should this program focus on?`
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "text-light text-center mt-0 mb-32",
                                                        children: [
                                                            ' ',
                                                            `Where are we prioritizing growth?`
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: `program-focus-container trainer-program-focus-wrapper max-width-576 route-fade-in`,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: `trainer-program-focus-button-wrapper`,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: `trainer-program-focus-flex-button`,
                                                            children: focusProgram.map((program)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                                    onClick: ()=>toggleFocusProgram(program),
                                                                    variant: "primary",
                                                                    className: `${isSelectedFocusProgram(program) ? `active` : ``} program-focus-program-button justify-content-center`,
                                                                    children: program
                                                                }, program))
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "trainer-program-focus-image-wrapper",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: (0, _muscleGroupImages.MuscleGroupImages)?.male?.base,
                                                                className: "muscle-group",
                                                                alt: 'muscleGroup'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: (0, _muscleGroupImages.MuscleGroupImages)?.male?.full_body,
                                                                className: `${isSelectedFocusProgram('Full Body') ? `active` : ``} muscle-group-item`,
                                                                alt: 'muscleGroupFullBody'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: (0, _muscleGroupImages.MuscleGroupImages)?.male?.upper_body,
                                                                className: `${isSelectedFocusProgram('Upper Body') ? `active` : ``} muscle-group-item`,
                                                                alt: 'muscleGroupUpperBody'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: (0, _muscleGroupImages.MuscleGroupImages)?.male?.lower_body,
                                                                className: `${isSelectedFocusProgram('Lower Body') ? `active` : ``} muscle-group-item`,
                                                                alt: 'muscleGroupLowerBody'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: (0, _muscleGroupImages.MuscleGroupImages)?.male?.core,
                                                                className: `${isSelectedFocusProgram('Core') ? `active` : ``} muscle-group-item`,
                                                                alt: 'muscleGroupCore'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: (0, _muscleGroupImages.MuscleGroupImages)?.male?.back,
                                                                className: `${isSelectedFocusProgram('Back') ? `active` : ``} muscle-group-item`,
                                                                alt: 'muscleGroupBack'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: (0, _muscleGroupImages.MuscleGroupImages)?.male?.glutes,
                                                                className: `${isSelectedFocusProgram('Glutes') ? `active` : ``} muscle-group-item`,
                                                                alt: 'muscleGroupGlutes'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "max-width-next route-fade-in",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                    onClick: ()=>{
                                                        setTimeout(()=>{
                                                            setStep(15);
                                                        }, introButton);
                                                    },
                                                    variant: "primary",
                                                    className: `flex-next`,
                                                    disabled: !selectedFocusProgram?.length,
                                                    children: "Next"
                                                })
                                            })
                                        ]
                                    }),
                                    step === 15 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "max-width-576 route-fade-in",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                        className: "page-sub-title text-center mt-0 mb-12",
                                                        children: `Any injuries or limitations to keep in mind?`
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "text-light text-center mt-0 mb-32",
                                                        children: [
                                                            ' ',
                                                            `Select an area to add more details.`
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "max-width-768 route-fade-in",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: " injurie-grid-container grid-lg-4 grid-md-3 grid-2 route-fade-in mb-32",
                                                        children: (0, _traninerConfig.traniningLimitation)?.map((injurie)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonTsx.Button), {
                                                                onClick: ()=>injuriesHandler(injurie?.value),
                                                                variant: "primary",
                                                                className: `${isSelectedInjuries(injurie?.value) ? `active` : ``}`,
                                                                children: [
                                                                    injurie?.image && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: injurie?.image,
                                                                        alt: injurie?.name
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                        className: "mt-0",
                                                                        children: injurie?.name
                                                                    })
                                                                ]
                                                            }, injurie?.value))
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "requirement-wrapper route-fade-in",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                                className: "fs-18",
                                                                children: "Requirements (optional)"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                                placeholder: "No jumping exercises,...",
                                                                rows: 4,
                                                                className: "fs-18",
                                                                value: requirement,
                                                                onChange: (e)=>requirementHandler(e.target.value)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "max-width-next route-fade-in",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                    onClick: ()=>{
                                                        setTimeout(()=>{
                                                            setStep(16);
                                                        }, introButton);
                                                    },
                                                    variant: "primary",
                                                    className: `flex-next`,
                                                    children: "Next"
                                                })
                                            })
                                        ]
                                    }),
                                    step === 16 && !isGenerating && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "max-width-576 mb-14",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                    className: "page-sub-title text-center mt-0",
                                                    children: `Let\u{2019}s create the program based on your responses`
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: `max-width-576 p-3 border-radius-16 center-text flex-center-column`,
                                                children: [
                                                    isSummarizing && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
                                                                children: `@keyframes gradientMove {
                          0% { background-position: 0% 50%; }
                          100% { background-position: -200% 50%; }
                        }`
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: `loading-title`,
                                                                style: {
                                                                    background: 'linear-gradient(90deg, #B68031, #FFFFFF, #B68031)',
                                                                    backgroundSize: '200% 100%',
                                                                    animation: 'gradientMove 3s linear infinite',
                                                                    WebkitBackgroundClip: 'text',
                                                                    WebkitTextFillColor: 'transparent',
                                                                    textAlign: 'center'
                                                                },
                                                                children: "Generating instructions..."
                                                            })
                                                        ]
                                                    }),
                                                    !isSummarizing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "text-start mt-8",
                                                        style: {
                                                            minHeight: '80px',
                                                            whiteSpace: 'pre-wrap'
                                                        },
                                                        children: renderFormattedText(summaryData?.response ? summaryData.response : `I will prepare a ${programDuration}-week program for ${firstName} at ${(0, _traninerConfig.fitnessLevels)?.[fitnessLevel - 1]?.name || 'intermediate'} level, focusing on ${selectedFocusProgram.join(', ')}, taking into account any limitations.`)
                                                    }),
                                                    !isSummarizing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        style: {
                                                            marginBottom: 8,
                                                            marginTop: 32
                                                        },
                                                        className: "text-start",
                                                        children: "Do you want to add anything?"
                                                    }),
                                                    !isSummarizing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "prompt-container",
                                                        children: prompts?.map((prompt, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: `prompt prompt-btn ${selectedSummaryPrompts.includes(prompt) ? 'active' : ''} ${isSummarizing ? 'disabled' : ''}`,
                                                                "aria-disabled": isSummarizing,
                                                                onClick: ()=>{
                                                                    if (!isSummarizing) handleSummaryPrompt(prompt);
                                                                },
                                                                children: prompt
                                                            }, index))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "max-width-576",
                                                style: {
                                                    marginTop: 24
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _buttonTsx.Button), {
                                                    onClick: ()=>{
                                                        if (containerRef.current) (0, _gsapSetupDefault.default).to(window, {
                                                            duration: 0.6,
                                                            scrollTo: containerRef.current,
                                                            ease: 'power2.inOut'
                                                        });
                                                        // Fire analytics snapshot – do not await, must not block the generate flow.
                                                        // No sessionId on this first call; the backend generates one and returns it.
                                                        // We persist the returned ID so the Get Early Access call can reuse it.
                                                        (0, _useUserBehaviorTracker.trackUserBehavior)({
                                                            email: '',
                                                            data: (0, _screenTimeTracker.screenTimeTracker).getReport()
                                                        }).then((res)=>{
                                                            (0, _screenTimeTracker.screenTimeTracker).setSessionId(res.sessionId);
                                                        }).catch(()=>{
                                                        // Silently ignore – analytics are non-critical
                                                        });
                                                        const payload = buildWorkoutProgramPayload(selectedSummaryPrompts.length > 0 ? selectedSummaryPrompts.join('. ') : '');
                                                        generateWorkout(payload, {
                                                            onSuccess: (data)=>{
                                                                if (!data?.program) {
                                                                    setGenerateErrorVisible(true);
                                                                    return;
                                                                }
                                                                navigate('/trainer/generated/ai', {
                                                                    state: {
                                                                        program: data?.program,
                                                                        payload
                                                                    }
                                                                });
                                                            },
                                                            onError: ()=>{
                                                                setGenerateErrorVisible(true);
                                                            }
                                                        });
                                                    },
                                                    variant: "primary",
                                                    disabled: isGenerating || !canProceedFromSummary,
                                                    className: `bg-gradient-color w-100 justify-content-center`,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            width: 16,
                                                            height: 16,
                                                            viewBox: "0 0 16 16",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M10.6861 8.78076L9.25273 11.0808C9.13051 11.2697 8.96118 11.3474 8.74473 11.3141C8.52829 11.2808 8.39207 11.153 8.33607 10.9308L7.8694 9.0641L3.3194 13.6141C3.19718 13.7363 3.04451 13.8003 2.8614 13.8061C2.67829 13.8119 2.51985 13.7479 2.38607 13.6141C2.26385 13.4919 2.20273 13.3363 2.20273 13.1474C2.20273 12.9585 2.26385 12.803 2.38607 12.6808L6.93607 8.1141L5.0694 7.64743C4.84718 7.59188 4.7194 7.45588 4.68607 7.23943C4.65273 7.02299 4.73051 6.85343 4.9194 6.73076L7.2194 5.3141L7.0194 2.59743C6.99718 2.37521 7.08607 2.2141 7.28607 2.1141C7.48607 2.0141 7.6694 2.03632 7.83607 2.18076L9.9194 3.93076L12.4361 2.9141C12.6472 2.82521 12.8305 2.85854 12.9861 3.0141C13.1416 3.16965 13.175 3.35299 13.0861 3.5641L12.0694 6.08076L13.8194 8.14743C13.9638 8.3141 13.9861 8.49743 13.8861 8.69743C13.7861 8.89743 13.625 8.98632 13.4027 8.9641L10.6861 8.78076ZM2.15273 4.3141C2.08607 4.24743 2.05273 4.16965 2.05273 4.08076C2.05273 3.99188 2.08607 3.9141 2.15273 3.84743L3.0194 2.98076C3.08607 2.9141 3.16385 2.88076 3.25273 2.88076C3.34162 2.88076 3.4194 2.9141 3.48607 2.98076L4.35273 3.84743C4.4194 3.9141 4.45273 3.99188 4.45273 4.08076C4.45273 4.16965 4.4194 4.24743 4.35273 4.3141L3.48607 5.18076C3.4194 5.24743 3.34162 5.28076 3.25273 5.28076C3.16385 5.28076 3.08607 5.24743 3.0194 5.18076L2.15273 4.3141ZM11.6861 13.8474L10.8194 12.9808C10.7527 12.9141 10.7194 12.8363 10.7194 12.7474C10.7194 12.6585 10.7527 12.5808 10.8194 12.5141L11.6861 11.6474C11.7527 11.5808 11.8305 11.5474 11.9194 11.5474C12.0083 11.5474 12.0861 11.5808 12.1527 11.6474L13.0194 12.5141C13.0861 12.5808 13.1194 12.6585 13.1194 12.7474C13.1194 12.8363 13.0861 12.9141 13.0194 12.9808L12.1527 13.8474C12.0861 13.9141 12.0083 13.9474 11.9194 13.9474C11.8305 13.9474 11.7527 13.9141 11.6861 13.8474Z",
                                                                fill: "var(--dark-blue-light)"
                                                            })
                                                        }),
                                                        isGenerating ? 'Generating...' : 'Generate with MiniPt AI'
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                                        ]
                                    }),
                                    step === 16 && isGenerating && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "max-width-768 route-fade-in flex-center-column",
                                        style: {
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("style", {
                                                children: `
                  @keyframes gradientMove {
                    0% { background-position: 0% 50%; }
                    100% { background-position: -200% 50%; }
                  }
                `
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                className: "page-sub-title text-center mb-32",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    style: {
                                                        background: 'linear-gradient(90deg, #B68031, #FFFFFF, #B68031)',
                                                        backgroundSize: '200% 100%',
                                                        animation: 'gradientMove 3s linear infinite',
                                                        WebkitBackgroundClip: 'text',
                                                        WebkitTextFillColor: 'transparent'
                                                    },
                                                    children: [
                                                        "Generating your",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                        "workout program"
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                                                variant: "primary",
                                                disabled: true,
                                                style: {
                                                    backgroundColor: '#FFA10012',
                                                    color: '#FFA100',
                                                    minWidth: '160px',
                                                    border: 'none',
                                                    opacity: 1,
                                                    borderRadius: '45px'
                                                },
                                                className: "justify-content-center",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(LoadingDots, {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            step >= 5 && step <= 10 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _animatedStep.AnimatedStep), {
                                isVisible: step >= 5 && step <= 10,
                                className: "trainer-card-footer extra",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trainingNavigationButtonComponentDefault.default), {
                                    currentStep: step - 5,
                                    prevStep: ()=>{
                                        setStep((prev)=>prev - 1);
                                    },
                                    nextStep: ()=>{
                                        setStep((prev)=>prev + 1);
                                    },
                                    nextDisable: nextDisableStep,
                                    prevDisable: false,
                                    totalSteps: 6
                                })
                            }),
                            step >= 12 && step <= 16 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _animatedStep.AnimatedStep), {
                                isVisible: step >= 12 && step <= 16,
                                className: "trainer-card-footer extra",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trainingNavigationButtonComponentDefault.default), {
                                    currentStep: step - 12,
                                    prevStep: ()=>{
                                        setStep((prev)=>prev - 1);
                                    },
                                    nextStep: ()=>{
                                        setStep((prev)=>prev + 1);
                                    },
                                    nextDisable: nextDisableStep,
                                    prevDisable: false,
                                    totalSteps: 4
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","../../index.css":"fW8RG","../../route.css":"h1KSg","../../reset.css":"3X473","react":"bmhQu","motion/react":"aBn1X","react-router-dom":"f3cgC","antd":[["Slider","iCqio","default"]],"src/components/Button/Button.tsx":"g0894","src/components/ProgramUserSelect/ProgramUserSelect.component":"e78Rn","src/components/TrainingNavigationButton/TrainingNavigationButton.component":"c4HL6","src/components/Animation/AnimatedStep":"duzKS","src/components/Animation/text-animate":"iQJIi","src/components/AutoCloseTooltip/AutoCloseTooltip":"gpxHy","src/components/Modals/CommandDialog/CommandDialog":"1t08c","src/components/SEO":"9lYJS","../../utils/gsapSetup":"8koI4","src/store/trainingStore":"eYkDC","src/api/mutations/useWorkoutProgram":"h8xaL","src/config/traniner.config":"krjj7","url:../../assets/videos/mini-pt-care.mp4":"5knEg","src/components/useSliderDotClick/useSliderDotClick":"5ZLH7","src/hooks/useScreenTime":"dhG6r","src/utils/screenTimeTracker":"dwAC9","src/api/mutations/useUserBehaviorTracker":"3nht4","src/store/programStore":"hM1mR","../OnboardingTrainer/screens/Dashboard/screens/ProgramGeneratorAI/assets/MuscleGroupImages":"9D5GI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fW8RG":[function() {},{}],"h1KSg":[function() {},{}],"3X473":[function() {},{}],"aBn1X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "m", ()=>(0, _framerMotion.m));
parcelHelpers.export(exports, "motion", ()=>(0, _framerMotion.motion));
var _framerMotion = require("framer-motion");
parcelHelpers.exportAll(_framerMotion, exports);

},{"framer-motion":"9sgBs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"QteOV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimatePresence", ()=>AnimatePresence);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _layoutGroupContextMjs = require("../../context/LayoutGroupContext.mjs");
var _useConstantMjs = require("../../utils/use-constant.mjs");
var _useIsomorphicEffectMjs = require("../../utils/use-isomorphic-effect.mjs");
var _presenceChildMjs = require("./PresenceChild.mjs");
var _usePresenceMjs = require("./use-presence.mjs");
var _utilsMjs = require("./utils.mjs");
"use client";
/**
 * `AnimatePresence` enables the animation of components that have been removed from the tree.
 *
 * When adding/removing more than a single child, every child **must** be given a unique `key` prop.
 *
 * Any `motion` components that have an `exit` property defined will animate out when removed from
 * the tree.
 *
 * ```jsx
 * import { motion, AnimatePresence } from 'framer-motion'
 *
 * export const Items = ({ items }) => (
 *   <AnimatePresence>
 *     {items.map(item => (
 *       <motion.div
 *         key={item.id}
 *         initial={{ opacity: 0 }}
 *         animate={{ opacity: 1 }}
 *         exit={{ opacity: 0 }}
 *       />
 *     ))}
 *   </AnimatePresence>
 * )
 * ```
 *
 * You can sequence exit animations throughout a tree using variants.
 *
 * If a child contains multiple `motion` components with `exit` props, it will only unmount the child
 * once all `motion` components have finished animating out. Likewise, any components using
 * `usePresence` all need to call `safeToRemove`.
 *
 * @public
 */ const AnimatePresence = ({ children, custom, initial = true, onExitComplete, presenceAffectsLayout = true, mode = "sync", propagate = false, anchorX = "left", anchorY = "top", root })=>{
    const [isParentPresent, safeToRemove] = (0, _usePresenceMjs.usePresence)(propagate);
    /**
     * Filter any children that aren't ReactElements. We can only track components
     * between renders with a props.key.
     */ const presentChildren = (0, _react.useMemo)(()=>(0, _utilsMjs.onlyElements)(children), [
        children
    ]);
    /**
     * Track the keys of the currently rendered children. This is used to
     * determine which children are exiting.
     */ const presentKeys = propagate && !isParentPresent ? [] : presentChildren.map((0, _utilsMjs.getChildKey));
    /**
     * If `initial={false}` we only want to pass this to components in the first render.
     */ const isInitialRender = (0, _react.useRef)(true);
    /**
     * A ref containing the currently present children. When all exit animations
     * are complete, we use this to re-render the component with the latest children
     * *committed* rather than the latest children *rendered*.
     */ const pendingPresentChildren = (0, _react.useRef)(presentChildren);
    /**
     * Track which exiting children have finished animating out.
     */ const exitComplete = (0, _useConstantMjs.useConstant)(()=>new Map());
    /**
     * Track which components are currently processing exit to prevent duplicate processing.
     */ const exitingComponents = (0, _react.useRef)(new Set());
    /**
     * Save children to render as React state. To ensure this component is concurrent-safe,
     * we check for exiting children via an effect.
     */ const [diffedChildren, setDiffedChildren] = (0, _react.useState)(presentChildren);
    const [renderedChildren, setRenderedChildren] = (0, _react.useState)(presentChildren);
    (0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect)(()=>{
        isInitialRender.current = false;
        pendingPresentChildren.current = presentChildren;
        /**
         * Update complete status of exiting children.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const key = (0, _utilsMjs.getChildKey)(renderedChildren[i]);
            if (!presentKeys.includes(key)) {
                if (exitComplete.get(key) !== true) exitComplete.set(key, false);
            } else {
                exitComplete.delete(key);
                exitingComponents.current.delete(key);
            }
        }
    }, [
        renderedChildren,
        presentKeys.length,
        presentKeys.join("-")
    ]);
    const exitingChildren = [];
    if (presentChildren !== diffedChildren) {
        let nextChildren = [
            ...presentChildren
        ];
        /**
         * Loop through all the currently rendered components and decide which
         * are exiting.
         */ for(let i = 0; i < renderedChildren.length; i++){
            const child = renderedChildren[i];
            const key = (0, _utilsMjs.getChildKey)(child);
            if (!presentKeys.includes(key)) {
                nextChildren.splice(i, 0, child);
                exitingChildren.push(child);
            }
        }
        /**
         * If we're in "wait" mode, and we have exiting children, we want to
         * only render these until they've all exited.
         */ if (mode === "wait" && exitingChildren.length) nextChildren = exitingChildren;
        setRenderedChildren((0, _utilsMjs.onlyElements)(nextChildren));
        setDiffedChildren(presentChildren);
        /**
         * Early return to ensure once we've set state with the latest diffed
         * children, we can immediately re-render.
         */ return null;
    }
    /**
     * If we've been provided a forceRender function by the LayoutGroupContext,
     * we can use it to force a re-render amongst all surrounding components once
     * all components have finished animating out.
     */ const { forceRender } = (0, _react.useContext)((0, _layoutGroupContextMjs.LayoutGroupContext));
    return (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
        children: renderedChildren.map((child)=>{
            const key = (0, _utilsMjs.getChildKey)(child);
            const isPresent = propagate && !isParentPresent ? false : presentChildren === renderedChildren || presentKeys.includes(key);
            const onExit = ()=>{
                if (exitingComponents.current.has(key)) return;
                if (exitComplete.has(key)) {
                    exitingComponents.current.add(key);
                    exitComplete.set(key, true);
                } else return;
                let isEveryExitComplete = true;
                exitComplete.forEach((isExitComplete)=>{
                    if (!isExitComplete) isEveryExitComplete = false;
                });
                if (isEveryExitComplete) {
                    forceRender?.();
                    setRenderedChildren(pendingPresentChildren.current);
                    propagate && safeToRemove?.();
                    onExitComplete && onExitComplete();
                }
            };
            return (0, _jsxRuntime.jsx)((0, _presenceChildMjs.PresenceChild), {
                isPresent: isPresent,
                initial: !isInitialRender.current || initial ? undefined : false,
                custom: custom,
                presenceAffectsLayout: presenceAffectsLayout,
                mode: mode,
                root: root,
                onExitComplete: isPresent ? undefined : onExit,
                anchorX: anchorX,
                anchorY: anchorY,
                children: child
            }, key);
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../context/LayoutGroupContext.mjs":"6GAWV","../../utils/use-constant.mjs":"2eji4","../../utils/use-isomorphic-effect.mjs":"3CLHh","./PresenceChild.mjs":"dISkx","./use-presence.mjs":"2qRef","./utils.mjs":"2btBZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6GAWV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutGroupContext", ()=>LayoutGroupContext);
var _react = require("react");
"use client";
const LayoutGroupContext = (0, _react.createContext)({});

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2eji4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useConstant", ()=>useConstant);
var _react = require("react");
"use client";
/**
 * Creates a constant value over the lifecycle of a component.
 *
 * Even if `useMemo` is provided an empty array as its final argument, it doesn't offer
 * a guarantee that it won't re-run for performance reasons later on. By using `useConstant`
 * you can ensure that initialisers don't execute twice or more.
 */ function useConstant(init) {
    const ref = (0, _react.useRef)(null);
    if (ref.current === null) ref.current = init();
    return ref.current;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3CLHh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
var _react = require("react");
var _isBrowserMjs = require("./is-browser.mjs");
"use client";
const useIsomorphicLayoutEffect = (0, _isBrowserMjs.isBrowser) ? (0, _react.useLayoutEffect) : (0, _react.useEffect);

},{"react":"bmhQu","./is-browser.mjs":"gkwN3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gkwN3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
const isBrowser = typeof window !== "undefined";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dISkx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PresenceChild", ()=>PresenceChild);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
var _useConstantMjs = require("../../utils/use-constant.mjs");
var _popChildMjs = require("./PopChild.mjs");
"use client";
const PresenceChild = ({ children, initial, isPresent, onExitComplete, custom, presenceAffectsLayout, mode, anchorX, anchorY, root })=>{
    const presenceChildren = (0, _useConstantMjs.useConstant)(newChildrenMap);
    const id = (0, _react.useId)();
    let isReusedContext = true;
    let context = (0, _react.useMemo)(()=>{
        isReusedContext = false;
        return {
            id,
            initial,
            isPresent,
            custom,
            onExitComplete: (childId)=>{
                presenceChildren.set(childId, true);
                for (const isComplete of presenceChildren.values()){
                    if (!isComplete) return; // can stop searching when any is incomplete
                }
                onExitComplete && onExitComplete();
            },
            register: (childId)=>{
                presenceChildren.set(childId, false);
                return ()=>presenceChildren.delete(childId);
            }
        };
    }, [
        isPresent,
        presenceChildren,
        onExitComplete
    ]);
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */ if (presenceAffectsLayout && isReusedContext) context = {
        ...context
    };
    (0, _react.useMemo)(()=>{
        presenceChildren.forEach((_, key)=>presenceChildren.set(key, false));
    }, [
        isPresent
    ]);
    /**
     * If there's no `motion` components to fire exit animations, we want to remove this
     * component immediately.
     */ _react.useEffect(()=>{
        !isPresent && !presenceChildren.size && onExitComplete && onExitComplete();
    }, [
        isPresent
    ]);
    children = (0, _jsxRuntime.jsx)((0, _popChildMjs.PopChild), {
        pop: mode === "popLayout",
        isPresent: isPresent,
        anchorX: anchorX,
        anchorY: anchorY,
        root: root,
        children: children
    });
    return (0, _jsxRuntime.jsx)((0, _presenceContextMjs.PresenceContext).Provider, {
        value: context,
        children: children
    });
};
function newChildrenMap() {
    return new Map();
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../context/PresenceContext.mjs":"ewqOU","../../utils/use-constant.mjs":"2eji4","./PopChild.mjs":"kARUR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ewqOU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PresenceContext", ()=>PresenceContext);
var _react = require("react");
"use client";
/**
 * @public
 */ const PresenceContext = /* @__PURE__ */ (0, _react.createContext)(null);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kARUR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PopChild", ()=>PopChild);
var _jsxRuntime = require("react/jsx-runtime");
var _motionDom = require("motion-dom");
var _react = require("react");
var _motionConfigContextMjs = require("../../context/MotionConfigContext.mjs");
var _useComposedRefMjs = require("../../utils/use-composed-ref.mjs");
"use client";
/**
 * Measurement functionality has to be within a separate component
 * to leverage snapshot lifecycle.
 */ class PopChildMeasure extends _react.Component {
    getSnapshotBeforeUpdate(prevProps) {
        const element = this.props.childRef.current;
        if ((0, _motionDom.isHTMLElement)(element) && prevProps.isPresent && !this.props.isPresent && this.props.pop !== false) {
            const parent = element.offsetParent;
            const parentWidth = (0, _motionDom.isHTMLElement)(parent) ? parent.offsetWidth || 0 : 0;
            const parentHeight = (0, _motionDom.isHTMLElement)(parent) ? parent.offsetHeight || 0 : 0;
            const computedStyle = getComputedStyle(element);
            const size = this.props.sizeRef.current;
            size.height = parseFloat(computedStyle.height);
            size.width = parseFloat(computedStyle.width);
            size.top = element.offsetTop;
            size.left = element.offsetLeft;
            size.right = parentWidth - size.width - size.left;
            size.bottom = parentHeight - size.height - size.top;
        }
        return null;
    }
    /**
     * Required with getSnapshotBeforeUpdate to stop React complaining.
     */ componentDidUpdate() {}
    render() {
        return this.props.children;
    }
}
function PopChild({ children, isPresent, anchorX, anchorY, root, pop }) {
    const id = (0, _react.useId)();
    const ref = (0, _react.useRef)(null);
    const size = (0, _react.useRef)({
        width: 0,
        height: 0,
        top: 0,
        left: 0,
        right: 0,
        bottom: 0
    });
    const { nonce } = (0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext));
    /**
     * In React 19, refs are passed via props.ref instead of element.ref.
     * We check props.ref first (React 19) and fall back to element.ref (React 18).
     */ const childRef = children.props?.ref ?? children?.ref;
    const composedRef = (0, _useComposedRefMjs.useComposedRefs)(ref, childRef);
    /**
     * We create and inject a style block so we can apply this explicit
     * sizing in a non-destructive manner by just deleting the style block.
     *
     * We can't apply size via render as the measurement happens
     * in getSnapshotBeforeUpdate (post-render), likewise if we apply the
     * styles directly on the DOM node, we might be overwriting
     * styles set via the style prop.
     */ (0, _react.useInsertionEffect)(()=>{
        const { width, height, top, left, right, bottom } = size.current;
        if (isPresent || pop === false || !ref.current || !width || !height) return;
        const x = anchorX === "left" ? `left: ${left}` : `right: ${right}`;
        const y = anchorY === "bottom" ? `bottom: ${bottom}` : `top: ${top}`;
        ref.current.dataset.motionPopId = id;
        const style = document.createElement("style");
        if (nonce) style.nonce = nonce;
        const parent = root ?? document.head;
        parent.appendChild(style);
        if (style.sheet) style.sheet.insertRule(`
          [data-motion-pop-id="${id}"] {
            position: absolute !important;
            width: ${width}px !important;
            height: ${height}px !important;
            ${x}px !important;
            ${y}px !important;
          }
        `);
        return ()=>{
            ref.current?.removeAttribute("data-motion-pop-id");
            if (parent.contains(style)) parent.removeChild(style);
        };
    }, [
        isPresent
    ]);
    return (0, _jsxRuntime.jsx)(PopChildMeasure, {
        isPresent: isPresent,
        childRef: ref,
        sizeRef: size,
        pop: pop,
        children: pop === false ? children : _react.cloneElement(children, {
            ref: composedRef
        })
    });
}

},{"react/jsx-runtime":"gonF6","motion-dom":"8vTac","react":"bmhQu","../../context/MotionConfigContext.mjs":"jiPm9","../../utils/use-composed-ref.mjs":"gLP16","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8vTac":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
var _motionUtils = require("motion-utils");
/**
 * Checks if an element is an HTML element in a way
 * that works across iframes
 */ function isHTMLElement(element) {
    return (0, _motionUtils.isObject)(element) && "offsetHeight" in element && !("ownerSVGElement" in element);
}

},{"motion-utils":"iBZNm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iBZNm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isObject", ()=>isObject);
function isObject(value) {
    return typeof value === "object" && value !== null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jiPm9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionConfigContext", ()=>MotionConfigContext);
var _react = require("react");
"use client";
/**
 * @public
 */ const MotionConfigContext = (0, _react.createContext)({
    transformPagePoint: (p)=>p,
    isStatic: false,
    reducedMotion: "never"
});

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gLP16":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useComposedRefs", ()=>useComposedRefs);
var _react = require("react");
/**
 * Taken from https://github.com/radix-ui/primitives/blob/main/packages/react/compose-refs/src/compose-refs.tsx
 */ /**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function setRef(ref, value) {
    if (typeof ref === "function") return ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function composeRefs(...refs) {
    return (node)=>{
        let hasCleanup = false;
        const cleanups = refs.map((ref)=>{
            const cleanup = setRef(ref, node);
            if (!hasCleanup && typeof cleanup === "function") hasCleanup = true;
            return cleanup;
        });
        // React <19 will log an error to the console if a callback ref returns a
        // value. We don't use ref cleanups internally so this will only happen if a
        // user's ref callback returns a value, which we only expect if they are
        // using the cleanup functionality added in React 19.
        if (hasCleanup) return ()=>{
            for(let i = 0; i < cleanups.length; i++){
                const cleanup = cleanups[i];
                if (typeof cleanup === "function") cleanup();
                else setRef(refs[i], null);
            }
        };
    };
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function useComposedRefs(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return _react.useCallback(composeRefs(...refs), refs);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2qRef":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPresent", ()=>isPresent);
parcelHelpers.export(exports, "useIsPresent", ()=>useIsPresent);
parcelHelpers.export(exports, "usePresence", ()=>usePresence);
var _react = require("react");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
"use client";
/**
 * When a component is the child of `AnimatePresence`, it can use `usePresence`
 * to access information about whether it's still present in the React tree.
 *
 * ```jsx
 * import { usePresence } from "framer-motion"
 *
 * export const Component = () => {
 *   const [isPresent, safeToRemove] = usePresence()
 *
 *   useEffect(() => {
 *     !isPresent && setTimeout(safeToRemove, 1000)
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * If `isPresent` is `false`, it means that a component has been removed from the tree,
 * but `AnimatePresence` won't really remove it until `safeToRemove` has been called.
 *
 * @public
 */ function usePresence(subscribe = true) {
    const context = (0, _react.useContext)((0, _presenceContextMjs.PresenceContext));
    if (context === null) return [
        true,
        null
    ];
    const { isPresent, onExitComplete, register } = context;
    // It's safe to call the following hooks conditionally (after an early return) because the context will always
    // either be null or non-null for the lifespan of the component.
    const id = (0, _react.useId)();
    (0, _react.useEffect)(()=>{
        if (subscribe) return register(id);
    }, [
        subscribe
    ]);
    const safeToRemove = (0, _react.useCallback)(()=>subscribe && onExitComplete && onExitComplete(id), [
        id,
        onExitComplete,
        subscribe
    ]);
    return !isPresent && onExitComplete ? [
        false,
        safeToRemove
    ] : [
        true
    ];
}
/**
 * Similar to `usePresence`, except `useIsPresent` simply returns whether or not the component is present.
 * There is no `safeToRemove` function.
 *
 * ```jsx
 * import { useIsPresent } from "framer-motion"
 *
 * export const Component = () => {
 *   const isPresent = useIsPresent()
 *
 *   useEffect(() => {
 *     !isPresent && console.log("I've been removed!")
 *   }, [isPresent])
 *
 *   return <div />
 * }
 * ```
 *
 * @public
 */ function useIsPresent() {
    return isPresent((0, _react.useContext)((0, _presenceContextMjs.PresenceContext)));
}
function isPresent(context) {
    return context === null ? true : context.isPresent;
}

},{"react":"bmhQu","../../context/PresenceContext.mjs":"ewqOU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2btBZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChildKey", ()=>getChildKey);
parcelHelpers.export(exports, "onlyElements", ()=>onlyElements);
var _react = require("react");
const getChildKey = (child)=>child.key || "";
function onlyElements(children) {
    const filtered = [];
    // We use forEach here instead of map as map mutates the component key by preprending `.$`
    (0, _react.Children).forEach(children, (child)=>{
        if ((0, _react.isValidElement)(child)) filtered.push(child);
    });
    return filtered;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9sgBs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "motion", ()=>motion);
var _createVisualElementMjs = require("../../dom/create-visual-element.mjs");
var _createProxyMjs = require("../create-proxy.mjs");
var _featureBundleMjs = require("./feature-bundle.mjs");
const motion = /*@__PURE__*/ (0, _createProxyMjs.createMotionProxy)((0, _featureBundleMjs.featureBundle), (0, _createVisualElementMjs.createDomVisualElement));

},{"../../dom/create-visual-element.mjs":"lTGz1","../create-proxy.mjs":"etSNQ","./feature-bundle.mjs":"7bvMJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lTGz1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDomVisualElement", ()=>createDomVisualElement);
var _motionDom = require("motion-dom");
var _react = require("react");
var _isSvgComponentMjs = require("./utils/is-svg-component.mjs");
const createDomVisualElement = (Component, options)=>{
    /**
     * Use explicit isSVG override if provided, otherwise auto-detect
     */ const isSVG = options.isSVG ?? (0, _isSvgComponentMjs.isSVGComponent)(Component);
    return isSVG ? new (0, _motionDom.SVGVisualElement)(options) : new (0, _motionDom.HTMLVisualElement)(options, {
        allowProjection: Component !== (0, _react.Fragment)
    });
};

},{"motion-dom":[["HTMLVisualElement","eQTgj"],["SVGVisualElement","id072"]],"react":"bmhQu","./utils/is-svg-component.mjs":"852Y7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eQTgj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLVisualElement", ()=>HTMLVisualElement);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
var _isCssVariableMjs = require("../../animation/utils/is-css-variable.mjs");
var _keysTransformMjs = require("../utils/keys-transform.mjs");
var _parseTransformMjs = require("../dom/parse-transform.mjs");
var _measureMjs = require("../../projection/utils/measure.mjs");
var _domvisualElementMjs = require("../dom/DOMVisualElement.mjs");
var _buildStylesMjs = require("./utils/build-styles.mjs");
var _renderMjs = require("./utils/render.mjs");
var _scrapeMotionValuesMjs = require("./utils/scrape-motion-values.mjs");
function getComputedStyle(element) {
    return window.getComputedStyle(element);
}
class HTMLVisualElement extends (0, _domvisualElementMjs.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "html";
        this.renderInstance = (0, _renderMjs.renderHTML);
    }
    readValueFromInstance(instance, key) {
        if ((0, _keysTransformMjs.transformProps).has(key)) return this.projection?.isProjecting ? (0, _parseTransformMjs.defaultTransformValue)(key) : (0, _parseTransformMjs.readTransformValue)(instance, key);
        else {
            const computedStyle = getComputedStyle(instance);
            const value = ((0, _isCssVariableMjs.isCSSVariableName)(key) ? computedStyle.getPropertyValue(key) : computedStyle[key]) || 0;
            return typeof value === "string" ? value.trim() : value;
        }
    }
    measureInstanceViewportBox(instance, { transformPagePoint }) {
        return (0, _measureMjs.measureViewportBox)(instance, transformPagePoint);
    }
    build(renderState, latestValues, props) {
        (0, _buildStylesMjs.buildHTMLStyles)(renderState, latestValues, props.transformTemplate);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
}

},{"../../animation/utils/is-css-variable.mjs":"jfZBC","../utils/keys-transform.mjs":"bJbLV","../dom/parse-transform.mjs":"lnnQE","../../projection/utils/measure.mjs":"jzMhe","../dom/DOMVisualElement.mjs":"cmuh9","./utils/build-styles.mjs":"e1GuX","./utils/render.mjs":"hUnZX","./utils/scrape-motion-values.mjs":"504Ps","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jfZBC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "containsCSSVariable", ()=>containsCSSVariable);
parcelHelpers.export(exports, "isCSSVariableName", ()=>isCSSVariableName);
parcelHelpers.export(exports, "isCSSVariableToken", ()=>isCSSVariableToken);
const checkStringStartsWith = (token)=>(key)=>typeof key === "string" && key.startsWith(token);
const isCSSVariableName = /*@__PURE__*/ checkStringStartsWith("--");
const startsAsVariableToken = /*@__PURE__*/ checkStringStartsWith("var(--");
const isCSSVariableToken = (value)=>{
    const startsWithToken = startsAsVariableToken(value);
    if (!startsWithToken) return false;
    // Ensure any comments are stripped from the value as this can harm performance of the regex.
    return singleCssVariableRegex.test(value.split("/*")[0].trim());
};
const singleCssVariableRegex = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu;
/**
 * Check if a value contains a CSS variable anywhere (e.g. inside calc()).
 * Unlike isCSSVariableToken which checks if the value IS a var() token,
 * this checks if the value CONTAINS var() somewhere in the string.
 */ function containsCSSVariable(value) {
    if (typeof value !== "string") return false;
    // Strip comments to avoid false positives
    return value.split("/*")[0].includes("var(--");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bJbLV":[function(require,module,exports,__globalThis) {
/**
 * Generate a list of every possible transform key.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformPropOrder", ()=>transformPropOrder);
parcelHelpers.export(exports, "transformProps", ()=>transformProps);
const transformPropOrder = [
    "transformPerspective",
    "x",
    "y",
    "z",
    "translateX",
    "translateY",
    "translateZ",
    "scale",
    "scaleX",
    "scaleY",
    "rotate",
    "rotateX",
    "rotateY",
    "rotateZ",
    "skew",
    "skewX",
    "skewY"
];
/**
 * A quick lookup for transform props.
 */ const transformProps = /*@__PURE__*/ (()=>new Set(transformPropOrder))();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lnnQE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTransformValue", ()=>defaultTransformValue);
parcelHelpers.export(exports, "parseValueFromTransform", ()=>parseValueFromTransform);
parcelHelpers.export(exports, "readTransformValue", ()=>readTransformValue);
const radToDeg = (rad)=>rad * 180 / Math.PI;
const rotate = (v)=>{
    const angle = radToDeg(Math.atan2(v[1], v[0]));
    return rebaseAngle(angle);
};
const matrix2dParsers = {
    x: 4,
    y: 5,
    translateX: 4,
    translateY: 5,
    scaleX: 0,
    scaleY: 3,
    scale: (v)=>(Math.abs(v[0]) + Math.abs(v[3])) / 2,
    rotate,
    rotateZ: rotate,
    skewX: (v)=>radToDeg(Math.atan(v[1])),
    skewY: (v)=>radToDeg(Math.atan(v[2])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[2])) / 2
};
const rebaseAngle = (angle)=>{
    angle = angle % 360;
    if (angle < 0) angle += 360;
    return angle;
};
const rotateZ = rotate;
const scaleX = (v)=>Math.sqrt(v[0] * v[0] + v[1] * v[1]);
const scaleY = (v)=>Math.sqrt(v[4] * v[4] + v[5] * v[5]);
const matrix3dParsers = {
    x: 12,
    y: 13,
    z: 14,
    translateX: 12,
    translateY: 13,
    translateZ: 14,
    scaleX,
    scaleY,
    scale: (v)=>(scaleX(v) + scaleY(v)) / 2,
    rotateX: (v)=>rebaseAngle(radToDeg(Math.atan2(v[6], v[5]))),
    rotateY: (v)=>rebaseAngle(radToDeg(Math.atan2(-v[2], v[0]))),
    rotateZ,
    rotate: rotateZ,
    skewX: (v)=>radToDeg(Math.atan(v[4])),
    skewY: (v)=>radToDeg(Math.atan(v[1])),
    skew: (v)=>(Math.abs(v[1]) + Math.abs(v[4])) / 2
};
function defaultTransformValue(name) {
    return name.includes("scale") ? 1 : 0;
}
function parseValueFromTransform(transform, name) {
    if (!transform || transform === "none") return defaultTransformValue(name);
    const matrix3dMatch = transform.match(/^matrix3d\(([-\d.e\s,]+)\)$/u);
    let parsers;
    let match;
    if (matrix3dMatch) {
        parsers = matrix3dParsers;
        match = matrix3dMatch;
    } else {
        const matrix2dMatch = transform.match(/^matrix\(([-\d.e\s,]+)\)$/u);
        parsers = matrix2dParsers;
        match = matrix2dMatch;
    }
    if (!match) return defaultTransformValue(name);
    const valueParser = parsers[name];
    const values = match[1].split(",").map(convertTransformToNumber);
    return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}
const readTransformValue = (instance, name)=>{
    const { transform = "none" } = getComputedStyle(instance);
    return parseValueFromTransform(transform, name);
};
function convertTransformToNumber(value) {
    return parseFloat(value.trim());
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jzMhe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "measurePageBox", ()=>measurePageBox);
parcelHelpers.export(exports, "measureViewportBox", ()=>measureViewportBox);
var _conversionMjs = require("../geometry/conversion.mjs");
var _deltaApplyMjs = require("../geometry/delta-apply.mjs");
function measureViewportBox(instance, transformPoint) {
    return (0, _conversionMjs.convertBoundingBoxToBox)((0, _conversionMjs.transformBoxPoints)(instance.getBoundingClientRect(), transformPoint));
}
function measurePageBox(element, rootProjectionNode, transformPagePoint) {
    const viewportBox = measureViewportBox(element, transformPagePoint);
    const { scroll } = rootProjectionNode;
    if (scroll) {
        (0, _deltaApplyMjs.translateAxis)(viewportBox.x, scroll.offset.x);
        (0, _deltaApplyMjs.translateAxis)(viewportBox.y, scroll.offset.y);
    }
    return viewportBox;
}

},{"../geometry/conversion.mjs":"iGSIB","../geometry/delta-apply.mjs":"iEf7c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iGSIB":[function(require,module,exports,__globalThis) {
/**
 * Bounding boxes tend to be defined as top, left, right, bottom. For various operations
 * it's easier to consider each axis individually. This function returns a bounding box
 * as a map of single-axis min/max values.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertBoundingBoxToBox", ()=>convertBoundingBoxToBox);
parcelHelpers.export(exports, "convertBoxToBoundingBox", ()=>convertBoxToBoundingBox);
parcelHelpers.export(exports, "transformBoxPoints", ()=>transformBoxPoints);
function convertBoundingBoxToBox({ top, left, right, bottom }) {
    return {
        x: {
            min: left,
            max: right
        },
        y: {
            min: top,
            max: bottom
        }
    };
}
function convertBoxToBoundingBox({ x, y }) {
    return {
        top: y.min,
        right: x.max,
        bottom: y.max,
        left: x.min
    };
}
/**
 * Applies a TransformPoint function to a bounding box. TransformPoint is usually a function
 * provided by Framer to allow measured points to be corrected for device scaling. This is used
 * when measuring DOM elements and DOM event points.
 */ function transformBoxPoints(point, transformPoint) {
    if (!transformPoint) return point;
    const topLeft = transformPoint({
        x: point.left,
        y: point.top
    });
    const bottomRight = transformPoint({
        x: point.right,
        y: point.bottom
    });
    return {
        top: topLeft.y,
        left: topLeft.x,
        bottom: bottomRight.y,
        right: bottomRight.x
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iEf7c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyAxisDelta", ()=>applyAxisDelta);
parcelHelpers.export(exports, "applyBoxDelta", ()=>applyBoxDelta);
parcelHelpers.export(exports, "applyPointDelta", ()=>applyPointDelta);
parcelHelpers.export(exports, "applyTreeDeltas", ()=>applyTreeDeltas);
parcelHelpers.export(exports, "scalePoint", ()=>scalePoint);
parcelHelpers.export(exports, "transformAxis", ()=>transformAxis);
parcelHelpers.export(exports, "transformBox", ()=>transformBox);
parcelHelpers.export(exports, "translateAxis", ()=>translateAxis);
var _numberMjs = require("../../utils/mix/number.mjs");
var _hasTransformMjs = require("../utils/has-transform.mjs");
/**
 * Scales a point based on a factor and an originPoint
 */ function scalePoint(point, scale, originPoint) {
    const distanceFromOrigin = point - originPoint;
    const scaled = scale * distanceFromOrigin;
    return originPoint + scaled;
}
/**
 * Applies a translate/scale delta to a point
 */ function applyPointDelta(point, translate, scale, originPoint, boxScale) {
    if (boxScale !== undefined) point = scalePoint(point, boxScale, originPoint);
    return scalePoint(point, scale, originPoint) + translate;
}
/**
 * Applies a translate/scale delta to an axis
 */ function applyAxisDelta(axis, translate = 0, scale = 1, originPoint, boxScale) {
    axis.min = applyPointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = applyPointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Applies a translate/scale delta to a box
 */ function applyBoxDelta(box, { x, y }) {
    applyAxisDelta(box.x, x.translate, x.scale, x.originPoint);
    applyAxisDelta(box.y, y.translate, y.scale, y.originPoint);
}
const TREE_SCALE_SNAP_MIN = 0.999999999999;
const TREE_SCALE_SNAP_MAX = 1.0000000000001;
/**
 * Apply a tree of deltas to a box. We do this to calculate the effect of all the transforms
 * in a tree upon our box before then calculating how to project it into our desired viewport-relative box
 *
 * This is the final nested loop within updateLayoutDelta for future refactoring
 */ function applyTreeDeltas(box, treeScale, treePath, isSharedTransition = false) {
    const treeLength = treePath.length;
    if (!treeLength) return;
    // Reset the treeScale
    treeScale.x = treeScale.y = 1;
    let node;
    let delta;
    for(let i = 0; i < treeLength; i++){
        node = treePath[i];
        delta = node.projectionDelta;
        /**
         * TODO: Prefer to remove this, but currently we have motion components with
         * display: contents in Framer.
         */ const { visualElement } = node.options;
        if (visualElement && visualElement.props.style && visualElement.props.style.display === "contents") continue;
        if (isSharedTransition && node.options.layoutScroll && node.scroll && node !== node.root) {
            translateAxis(box.x, -node.scroll.offset.x);
            translateAxis(box.y, -node.scroll.offset.y);
        }
        if (delta) {
            // Incoporate each ancestor's scale into a cumulative treeScale for this component
            treeScale.x *= delta.x.scale;
            treeScale.y *= delta.y.scale;
            // Apply each ancestor's calculated delta into this component's recorded layout box
            applyBoxDelta(box, delta);
        }
        if (isSharedTransition && (0, _hasTransformMjs.hasTransform)(node.latestValues)) transformBox(box, node.latestValues, node.layout?.layoutBox);
    }
    /**
     * Snap tree scale back to 1 if it's within a non-perceivable threshold.
     * This will help reduce useless scales getting rendered.
     */ if (treeScale.x < TREE_SCALE_SNAP_MAX && treeScale.x > TREE_SCALE_SNAP_MIN) treeScale.x = 1.0;
    if (treeScale.y < TREE_SCALE_SNAP_MAX && treeScale.y > TREE_SCALE_SNAP_MIN) treeScale.y = 1.0;
}
function translateAxis(axis, distance) {
    axis.min += distance;
    axis.max += distance;
}
/**
 * Apply a transform to an axis from the latest resolved motion values.
 * This function basically acts as a bridge between a flat motion value map
 * and applyAxisDelta
 */ function transformAxis(axis, axisTranslate, axisScale, boxScale, axisOrigin = 0.5) {
    const originPoint = (0, _numberMjs.mixNumber)(axis.min, axis.max, axisOrigin);
    // Apply the axis delta to the final axis
    applyAxisDelta(axis, axisTranslate, axisScale, originPoint, boxScale);
}
function resolveAxisTranslate(value, axis) {
    if (typeof value === "string") return parseFloat(value) / 100 * (axis.max - axis.min);
    return value;
}
/**
 * Apply a transform to a box from the latest resolved motion values.
 */ function transformBox(box, transform, sourceBox) {
    const resolveBox = sourceBox ?? box;
    transformAxis(box.x, resolveAxisTranslate(transform.x, resolveBox.x), transform.scaleX, transform.scale, transform.originX);
    transformAxis(box.y, resolveAxisTranslate(transform.y, resolveBox.y), transform.scaleY, transform.scale, transform.originY);
}

},{"../../utils/mix/number.mjs":"91GSx","../utils/has-transform.mjs":"6BpuE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"91GSx":[function(require,module,exports,__globalThis) {
/*
  Value in range from progress

  Given a lower limit and an upper limit, we return the value within
  that range as expressed by progress (usually a number from 0 to 1)

  So progress = 0.5 would change

  from -------- to

  to

  from ---- to

  E.g. from = 10, to = 20, progress = 0.5 => 15

  @param [number]: Lower limit of range
  @param [number]: Upper limit of range
  @param [number]: The progress between lower and upper limits expressed 0-1
  @return [number]: Value as calculated from progress within range (not limited within range)
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixNumber", ()=>mixNumber);
const mixNumber = (from, to, progress)=>{
    return from + (to - from) * progress;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6BpuE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "has2DTranslate", ()=>has2DTranslate);
parcelHelpers.export(exports, "hasScale", ()=>hasScale);
parcelHelpers.export(exports, "hasTransform", ()=>hasTransform);
function isIdentityScale(scale) {
    return scale === undefined || scale === 1;
}
function hasScale({ scale, scaleX, scaleY }) {
    return !isIdentityScale(scale) || !isIdentityScale(scaleX) || !isIdentityScale(scaleY);
}
function hasTransform(values) {
    return hasScale(values) || has2DTranslate(values) || values.z || values.rotate || values.rotateX || values.rotateY || values.skewX || values.skewY;
}
function has2DTranslate(values) {
    return is2DTranslate(values.x) || is2DTranslate(values.y);
}
function is2DTranslate(value) {
    return value && value !== "0%";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cmuh9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMVisualElement", ()=>DOMVisualElement);
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
var _domkeyframesResolverMjs = require("../../animation/keyframes/DOMKeyframesResolver.mjs");
var _visualElementMjs = require("../VisualElement.mjs");
class DOMVisualElement extends (0, _visualElementMjs.VisualElement) {
    constructor(){
        super(...arguments);
        this.KeyframeResolver = (0, _domkeyframesResolverMjs.DOMKeyframesResolver);
    }
    sortInstanceNodePosition(a, b) {
        /**
         * compareDocumentPosition returns a bitmask, by using the bitwise &
         * we're returning true if 2 in that bitmask is set to true. 2 is set
         * to true if b preceeds a.
         */ return a.compareDocumentPosition(b) & 2 ? 1 : -1;
    }
    getBaseTargetFromProps(props, key) {
        const style = props.style;
        return style ? style[key] : undefined;
    }
    removeValueFromRenderState(key, { vars, style }) {
        delete vars[key];
        delete style[key];
    }
    handleChildMotionValue() {
        if (this.childSubscription) {
            this.childSubscription();
            delete this.childSubscription;
        }
        const { children } = this.props;
        if ((0, _isMotionValueMjs.isMotionValue)(children)) this.childSubscription = children.on("change", (latest)=>{
            if (this.current) this.current.textContent = `${latest}`;
        });
    }
}

},{"../../value/utils/is-motion-value.mjs":"fKDJz","../../animation/keyframes/DOMKeyframesResolver.mjs":"8PqS6","../VisualElement.mjs":"lVIcw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fKDJz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isMotionValue", ()=>isMotionValue);
const isMotionValue = (value)=>Boolean(value && value.getVelocity);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8PqS6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DOMKeyframesResolver", ()=>DOMKeyframesResolver);
var _keysPositionMjs = require("../../render/utils/keys-position.mjs");
var _dimensionsMjs = require("../../value/types/dimensions.mjs");
var _cssVariablesConversionMjs = require("../utils/css-variables-conversion.mjs");
var _isCssVariableMjs = require("../utils/is-css-variable.mjs");
var _keyframesResolverMjs = require("./KeyframesResolver.mjs");
var _isNoneMjs = require("./utils/is-none.mjs");
var _makeNoneAnimatableMjs = require("./utils/make-none-animatable.mjs");
var _unitConversionMjs = require("./utils/unit-conversion.mjs");
class DOMKeyframesResolver extends (0, _keyframesResolverMjs.KeyframeResolver) {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element){
        super(unresolvedKeyframes, onComplete, name, motionValue, element, true);
    }
    readKeyframes() {
        const { unresolvedKeyframes, element, name } = this;
        if (!element || !element.current) return;
        super.readKeyframes();
        /**
         * If any keyframe is a CSS variable, we need to find its value by sampling the element
         */ for(let i = 0; i < unresolvedKeyframes.length; i++){
            let keyframe = unresolvedKeyframes[i];
            if (typeof keyframe === "string") {
                keyframe = keyframe.trim();
                if ((0, _isCssVariableMjs.isCSSVariableToken)(keyframe)) {
                    const resolved = (0, _cssVariablesConversionMjs.getVariableValue)(keyframe, element.current);
                    if (resolved !== undefined) unresolvedKeyframes[i] = resolved;
                    if (i === unresolvedKeyframes.length - 1) this.finalKeyframe = keyframe;
                }
            }
        }
        /**
         * Resolve "none" values. We do this potentially twice - once before and once after measuring keyframes.
         * This could be seen as inefficient but it's a trade-off to avoid measurements in more situations, which
         * have a far bigger performance impact.
         */ this.resolveNoneKeyframes();
        /**
         * Check to see if unit type has changed. If so schedule jobs that will
         * temporarily set styles to the destination keyframes.
         * Skip if we have more than two keyframes or this isn't a positional value.
         * TODO: We can throw if there are multiple keyframes and the value type changes.
         */ if (!(0, _keysPositionMjs.positionalKeys).has(name) || unresolvedKeyframes.length !== 2) return;
        const [origin, target] = unresolvedKeyframes;
        const originType = (0, _dimensionsMjs.findDimensionValueType)(origin);
        const targetType = (0, _dimensionsMjs.findDimensionValueType)(target);
        /**
         * If one keyframe contains embedded CSS variables (e.g. in calc()) and the other
         * doesn't, we need to measure to convert to pixels. This handles GitHub issue #3410.
         */ const originHasVar = (0, _isCssVariableMjs.containsCSSVariable)(origin);
        const targetHasVar = (0, _isCssVariableMjs.containsCSSVariable)(target);
        if (originHasVar !== targetHasVar && (0, _unitConversionMjs.positionalValues)[name]) {
            this.needsMeasurement = true;
            return;
        }
        /**
         * Either we don't recognise these value types or we can animate between them.
         */ if (originType === targetType) return;
        /**
         * If both values are numbers or pixels, we can animate between them by
         * converting them to numbers.
         */ if ((0, _unitConversionMjs.isNumOrPxType)(originType) && (0, _unitConversionMjs.isNumOrPxType)(targetType)) for(let i = 0; i < unresolvedKeyframes.length; i++){
            const value = unresolvedKeyframes[i];
            if (typeof value === "string") unresolvedKeyframes[i] = parseFloat(value);
        }
        else if ((0, _unitConversionMjs.positionalValues)[name]) /**
             * Else, the only way to resolve this is by measuring the element.
             */ this.needsMeasurement = true;
    }
    resolveNoneKeyframes() {
        const { unresolvedKeyframes, name } = this;
        const noneKeyframeIndexes = [];
        for(let i = 0; i < unresolvedKeyframes.length; i++)if (unresolvedKeyframes[i] === null || (0, _isNoneMjs.isNone)(unresolvedKeyframes[i])) noneKeyframeIndexes.push(i);
        if (noneKeyframeIndexes.length) (0, _makeNoneAnimatableMjs.makeNoneKeyframesAnimatable)(unresolvedKeyframes, noneKeyframeIndexes, name);
    }
    measureInitialState() {
        const { element, unresolvedKeyframes, name } = this;
        if (!element || !element.current) return;
        if (name === "height") this.suspendedScrollY = window.pageYOffset;
        this.measuredOrigin = (0, _unitConversionMjs.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        unresolvedKeyframes[0] = this.measuredOrigin;
        // Set final key frame to measure after next render
        const measureKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
        if (measureKeyframe !== undefined) element.getValue(name, measureKeyframe).jump(measureKeyframe, false);
    }
    measureEndState() {
        const { element, name, unresolvedKeyframes } = this;
        if (!element || !element.current) return;
        const value = element.getValue(name);
        value && value.jump(this.measuredOrigin, false);
        const finalKeyframeIndex = unresolvedKeyframes.length - 1;
        const finalKeyframe = unresolvedKeyframes[finalKeyframeIndex];
        unresolvedKeyframes[finalKeyframeIndex] = (0, _unitConversionMjs.positionalValues)[name](element.measureViewportBox(), window.getComputedStyle(element.current));
        if (finalKeyframe !== null && this.finalKeyframe === undefined) this.finalKeyframe = finalKeyframe;
        // If we removed transform values, reapply them before the next render
        if (this.removedTransforms?.length) this.removedTransforms.forEach(([unsetTransformName, unsetTransformValue])=>{
            element.getValue(unsetTransformName).set(unsetTransformValue);
        });
        this.resolveNoneKeyframes();
    }
}

},{"../../render/utils/keys-position.mjs":"5Qoar","../../value/types/dimensions.mjs":"hyZyT","../utils/css-variables-conversion.mjs":"j6uk3","../utils/is-css-variable.mjs":"jfZBC","./KeyframesResolver.mjs":"aNL0j","./utils/is-none.mjs":"ilKnG","./utils/make-none-animatable.mjs":"2z43A","./utils/unit-conversion.mjs":"dXS41","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5Qoar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "positionalKeys", ()=>positionalKeys);
var _keysTransformMjs = require("./keys-transform.mjs");
const positionalKeys = new Set([
    "width",
    "height",
    "top",
    "left",
    "right",
    "bottom",
    ...(0, _keysTransformMjs.transformPropOrder)
]);

},{"./keys-transform.mjs":"bJbLV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hyZyT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "dimensionValueTypes", ()=>dimensionValueTypes);
parcelHelpers.export(exports, "findDimensionValueType", ()=>findDimensionValueType);
var _autoMjs = require("./auto.mjs");
var _indexMjs = require("./numbers/index.mjs");
var _unitsMjs = require("./numbers/units.mjs");
var _testMjs = require("./test.mjs");
/**
 * A list of value types commonly used for dimensions
 */ const dimensionValueTypes = [
    (0, _indexMjs.number),
    (0, _unitsMjs.px),
    (0, _unitsMjs.percent),
    (0, _unitsMjs.degrees),
    (0, _unitsMjs.vw),
    (0, _unitsMjs.vh),
    (0, _autoMjs.auto)
];
/**
 * Tests a dimensional value against the list of dimension ValueTypes
 */ const findDimensionValueType = (v)=>dimensionValueTypes.find((0, _testMjs.testValueType)(v));

},{"./auto.mjs":"3NAB1","./numbers/index.mjs":"hGTrH","./numbers/units.mjs":"aXLZR","./test.mjs":"bY55t","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3NAB1":[function(require,module,exports,__globalThis) {
/**
 * ValueType for "auto"
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "auto", ()=>auto);
const auto = {
    test: (v)=>v === "auto",
    parse: (v)=>v
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hGTrH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alpha", ()=>alpha);
parcelHelpers.export(exports, "number", ()=>number);
parcelHelpers.export(exports, "scale", ()=>scale);
var _motionUtils = require("motion-utils");
const number = {
    test: (v)=>typeof v === "number",
    parse: parseFloat,
    transform: (v)=>v
};
const alpha = {
    ...number,
    transform: (v)=>(0, _motionUtils.clamp)(0, 1, v)
};
const scale = {
    ...number,
    default: 1
};

},{"motion-utils":"b78W4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b78W4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clamp", ()=>clamp);
const clamp = (min, max, v)=>{
    if (v > max) return max;
    if (v < min) return min;
    return v;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aXLZR":[function(require,module,exports,__globalThis) {
/*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "degrees", ()=>degrees);
parcelHelpers.export(exports, "percent", ()=>percent);
parcelHelpers.export(exports, "progressPercentage", ()=>progressPercentage);
parcelHelpers.export(exports, "px", ()=>px);
parcelHelpers.export(exports, "vh", ()=>vh);
parcelHelpers.export(exports, "vw", ()=>vw);
const createUnitType = (unit)=>({
        test: (v)=>typeof v === "string" && v.endsWith(unit) && v.split(" ").length === 1,
        parse: parseFloat,
        transform: (v)=>`${v}${unit}`
    });
const degrees = /*@__PURE__*/ createUnitType("deg");
const percent = /*@__PURE__*/ createUnitType("%");
const px = /*@__PURE__*/ createUnitType("px");
const vh = /*@__PURE__*/ createUnitType("vh");
const vw = /*@__PURE__*/ createUnitType("vw");
const progressPercentage = /*@__PURE__*/ (()=>({
        ...percent,
        parse: (v)=>percent.parse(v) / 100,
        transform: (v)=>percent.transform(v * 100)
    }))();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bY55t":[function(require,module,exports,__globalThis) {
/**
 * Tests a provided value against a ValueType
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "testValueType", ()=>testValueType);
const testValueType = (v)=>(type)=>type.test(v);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j6uk3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVariableValue", ()=>getVariableValue);
parcelHelpers.export(exports, "parseCSSVariable", ()=>parseCSSVariable);
var _motionUtils = require("motion-utils");
var _isCssVariableMjs = require("./is-css-variable.mjs");
/**
 * Parse Framer's special CSS variable format into a CSS token and a fallback.
 *
 * ```
 * `var(--foo, #fff)` => [`--foo`, '#fff']
 * ```
 *
 * @param current
 */ const splitCSSVariableRegex = // eslint-disable-next-line redos-detector/no-unsafe-regex -- false positive, as it can match a lot of words
/^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
function parseCSSVariable(current) {
    const match = splitCSSVariableRegex.exec(current);
    if (!match) return [
        , 
    ];
    const [, token1, token2, fallback] = match;
    return [
        `--${token1 ?? token2}`,
        fallback
    ];
}
const maxDepth = 4;
function getVariableValue(current, element, depth = 1) {
    (0, _motionUtils.invariant)(depth <= maxDepth, `Max CSS variable fallback depth detected in property "${current}". This may indicate a circular fallback dependency.`, "max-css-var-depth");
    const [token, fallback] = parseCSSVariable(current);
    // No CSS variable detected
    if (!token) return;
    // Attempt to read this CSS variable off the element
    const resolved = window.getComputedStyle(element).getPropertyValue(token);
    if (resolved) {
        const trimmed = resolved.trim();
        return (0, _motionUtils.isNumericalString)(trimmed) ? parseFloat(trimmed) : trimmed;
    }
    return (0, _isCssVariableMjs.isCSSVariableToken)(fallback) ? getVariableValue(fallback, element, depth + 1) : fallback;
}

},{"motion-utils":[["invariant","588wx"],["isNumericalString","jEMv3"]],"./is-css-variable.mjs":"jfZBC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"588wx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invariant", ()=>invariant);
parcelHelpers.export(exports, "warning", ()=>warning);
var _formatErrorMessageMjs = require("./format-error-message.mjs");
let warning = ()=>{};
let invariant = ()=>{};
var check, message, errorCode, check1, message1, errorCode1;

},{"./format-error-message.mjs":"f3Mzt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f3Mzt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatErrorMessage", ()=>formatErrorMessage);
function formatErrorMessage(message, errorCode) {
    return errorCode ? `${message}. For more information and steps for solving, visit https://motion.dev/troubleshooting/${errorCode}` : message;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jEMv3":[function(require,module,exports,__globalThis) {
/**
 * Check if value is a numerical string, ie a string that is purely a number eg "100" or "-100.1"
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumericalString", ()=>isNumericalString);
const isNumericalString = (v)=>/^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(v);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aNL0j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "KeyframeResolver", ()=>KeyframeResolver);
parcelHelpers.export(exports, "flushKeyframeResolvers", ()=>flushKeyframeResolvers);
var _fillWildcardsMjs = require("./utils/fill-wildcards.mjs");
var _unitConversionMjs = require("./utils/unit-conversion.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
const toResolve = new Set();
let isScheduled = false;
let anyNeedsMeasurement = false;
let isForced = false;
function measureAllKeyframes() {
    if (anyNeedsMeasurement) {
        const resolversToMeasure = Array.from(toResolve).filter((resolver)=>resolver.needsMeasurement);
        const elementsToMeasure = new Set(resolversToMeasure.map((resolver)=>resolver.element));
        const transformsToRestore = new Map();
        /**
         * Write pass
         * If we're measuring elements we want to remove bounding box-changing transforms.
         */ elementsToMeasure.forEach((element)=>{
            const removedTransforms = (0, _unitConversionMjs.removeNonTranslationalTransform)(element);
            if (!removedTransforms.length) return;
            transformsToRestore.set(element, removedTransforms);
            element.render();
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureInitialState());
        // Write
        elementsToMeasure.forEach((element)=>{
            element.render();
            const restore = transformsToRestore.get(element);
            if (restore) restore.forEach(([key, value])=>{
                element.getValue(key)?.set(value);
            });
        });
        // Read
        resolversToMeasure.forEach((resolver)=>resolver.measureEndState());
        // Write
        resolversToMeasure.forEach((resolver)=>{
            if (resolver.suspendedScrollY !== undefined) window.scrollTo(0, resolver.suspendedScrollY);
        });
    }
    anyNeedsMeasurement = false;
    isScheduled = false;
    toResolve.forEach((resolver)=>resolver.complete(isForced));
    toResolve.clear();
}
function readAllKeyframes() {
    toResolve.forEach((resolver)=>{
        resolver.readKeyframes();
        if (resolver.needsMeasurement) anyNeedsMeasurement = true;
    });
}
function flushKeyframeResolvers() {
    isForced = true;
    readAllKeyframes();
    measureAllKeyframes();
    isForced = false;
}
class KeyframeResolver {
    constructor(unresolvedKeyframes, onComplete, name, motionValue, element, isAsync = false){
        this.state = "pending";
        /**
         * Track whether this resolver is async. If it is, it'll be added to the
         * resolver queue and flushed in the next frame. Resolvers that aren't going
         * to trigger read/write thrashing don't need to be async.
         */ this.isAsync = false;
        /**
         * Track whether this resolver needs to perform a measurement
         * to resolve its keyframes.
         */ this.needsMeasurement = false;
        this.unresolvedKeyframes = [
            ...unresolvedKeyframes
        ];
        this.onComplete = onComplete;
        this.name = name;
        this.motionValue = motionValue;
        this.element = element;
        this.isAsync = isAsync;
    }
    scheduleResolve() {
        this.state = "scheduled";
        if (this.isAsync) {
            toResolve.add(this);
            if (!isScheduled) {
                isScheduled = true;
                (0, _frameMjs.frame).read(readAllKeyframes);
                (0, _frameMjs.frame).resolveKeyframes(measureAllKeyframes);
            }
        } else {
            this.readKeyframes();
            this.complete();
        }
    }
    readKeyframes() {
        const { unresolvedKeyframes, name, element, motionValue } = this;
        // If initial keyframe is null we need to read it from the DOM
        if (unresolvedKeyframes[0] === null) {
            const currentValue = motionValue?.get();
            // TODO: This doesn't work if the final keyframe is a wildcard
            const finalKeyframe = unresolvedKeyframes[unresolvedKeyframes.length - 1];
            if (currentValue !== undefined) unresolvedKeyframes[0] = currentValue;
            else if (element && name) {
                const valueAsRead = element.readValue(name, finalKeyframe);
                if (valueAsRead !== undefined && valueAsRead !== null) unresolvedKeyframes[0] = valueAsRead;
            }
            if (unresolvedKeyframes[0] === undefined) unresolvedKeyframes[0] = finalKeyframe;
            if (motionValue && currentValue === undefined) motionValue.set(unresolvedKeyframes[0]);
        }
        (0, _fillWildcardsMjs.fillWildcards)(unresolvedKeyframes);
    }
    setFinalKeyframe() {}
    measureInitialState() {}
    renderEndStyles() {}
    measureEndState() {}
    complete(isForcedComplete = false) {
        this.state = "complete";
        this.onComplete(this.unresolvedKeyframes, this.finalKeyframe, isForcedComplete);
        toResolve.delete(this);
    }
    cancel() {
        if (this.state === "scheduled") {
            toResolve.delete(this);
            this.state = "pending";
        }
    }
    resume() {
        if (this.state === "pending") this.scheduleResolve();
    }
}

},{"./utils/fill-wildcards.mjs":"ePdwO","./utils/unit-conversion.mjs":"dXS41","../../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ePdwO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillWildcards", ()=>fillWildcards);
function fillWildcards(keyframes) {
    for(let i = 1; i < keyframes.length; i++)keyframes[i] ?? (keyframes[i] = keyframes[i - 1]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dXS41":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNumOrPxType", ()=>isNumOrPxType);
parcelHelpers.export(exports, "positionalValues", ()=>positionalValues);
parcelHelpers.export(exports, "removeNonTranslationalTransform", ()=>removeNonTranslationalTransform);
var _parseTransformMjs = require("../../../render/dom/parse-transform.mjs");
var _keysTransformMjs = require("../../../render/utils/keys-transform.mjs");
var _indexMjs = require("../../../value/types/numbers/index.mjs");
var _unitsMjs = require("../../../value/types/numbers/units.mjs");
const isNumOrPxType = (v)=>v === (0, _indexMjs.number) || v === (0, _unitsMjs.px);
const transformKeys = new Set([
    "x",
    "y",
    "z"
]);
const nonTranslationalTransformKeys = (0, _keysTransformMjs.transformPropOrder).filter((key)=>!transformKeys.has(key));
function removeNonTranslationalTransform(visualElement) {
    const removedTransforms = [];
    nonTranslationalTransformKeys.forEach((key)=>{
        const value = visualElement.getValue(key);
        if (value !== undefined) {
            removedTransforms.push([
                key,
                value.get()
            ]);
            value.set(key.startsWith("scale") ? 1 : 0);
        }
    });
    return removedTransforms;
}
const positionalValues = {
    // Dimensions
    width: ({ x }, { paddingLeft = "0", paddingRight = "0", boxSizing })=>{
        const width = x.max - x.min;
        return boxSizing === "border-box" ? width : width - parseFloat(paddingLeft) - parseFloat(paddingRight);
    },
    height: ({ y }, { paddingTop = "0", paddingBottom = "0", boxSizing })=>{
        const height = y.max - y.min;
        return boxSizing === "border-box" ? height : height - parseFloat(paddingTop) - parseFloat(paddingBottom);
    },
    top: (_bbox, { top })=>parseFloat(top),
    left: (_bbox, { left })=>parseFloat(left),
    bottom: ({ y }, { top })=>parseFloat(top) + (y.max - y.min),
    right: ({ x }, { left })=>parseFloat(left) + (x.max - x.min),
    // Transform
    x: (_bbox, { transform })=>(0, _parseTransformMjs.parseValueFromTransform)(transform, "x"),
    y: (_bbox, { transform })=>(0, _parseTransformMjs.parseValueFromTransform)(transform, "y")
};
// Alias translate longform names
positionalValues.translateX = positionalValues.x;
positionalValues.translateY = positionalValues.y;

},{"../../../render/dom/parse-transform.mjs":"lnnQE","../../../render/utils/keys-transform.mjs":"bJbLV","../../../value/types/numbers/index.mjs":"hGTrH","../../../value/types/numbers/units.mjs":"aXLZR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4c192":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cancelFrame", ()=>cancelFrame);
parcelHelpers.export(exports, "frame", ()=>frame);
parcelHelpers.export(exports, "frameData", ()=>frameData);
parcelHelpers.export(exports, "frameSteps", ()=>frameSteps);
var _motionUtils = require("motion-utils");
var _batcherMjs = require("./batcher.mjs");
const { schedule: frame, cancel: cancelFrame, state: frameData, steps: frameSteps } = /* @__PURE__ */ (0, _batcherMjs.createRenderBatcher)(typeof requestAnimationFrame !== "undefined" ? requestAnimationFrame : (0, _motionUtils.noop), true);

},{"motion-utils":"1tDyg","./batcher.mjs":"kAUIQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1tDyg":[function(require,module,exports,__globalThis) {
/*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
const noop = (any)=>any;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kAUIQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRenderBatcher", ()=>createRenderBatcher);
var _motionUtils = require("motion-utils");
var _orderMjs = require("./order.mjs");
var _renderStepMjs = require("./render-step.mjs");
const maxElapsed = 40;
function createRenderBatcher(scheduleNextBatch, allowKeepAlive) {
    let runNextFrame = false;
    let useDefaultElapsed = true;
    const state = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    const flagRunNextFrame = ()=>runNextFrame = true;
    const steps = (0, _orderMjs.stepsOrder).reduce((acc, key)=>{
        acc[key] = (0, _renderStepMjs.createRenderStep)(flagRunNextFrame, allowKeepAlive ? key : undefined);
        return acc;
    }, {});
    const { setup, read, resolveKeyframes, preUpdate, update, preRender, render, postRender } = steps;
    const processBatch = ()=>{
        const useManualTiming = (0, _motionUtils.MotionGlobalConfig).useManualTiming;
        const timestamp = useManualTiming ? state.timestamp : performance.now();
        runNextFrame = false;
        if (!useManualTiming) state.delta = useDefaultElapsed ? 1000 / 60 : Math.max(Math.min(timestamp - state.timestamp, maxElapsed), 1);
        state.timestamp = timestamp;
        state.isProcessing = true;
        // Unrolled render loop for better per-frame performance
        setup.process(state);
        read.process(state);
        resolveKeyframes.process(state);
        preUpdate.process(state);
        update.process(state);
        preRender.process(state);
        render.process(state);
        postRender.process(state);
        state.isProcessing = false;
        if (runNextFrame && allowKeepAlive) {
            useDefaultElapsed = false;
            scheduleNextBatch(processBatch);
        }
    };
    const wake = ()=>{
        runNextFrame = true;
        useDefaultElapsed = true;
        if (!state.isProcessing) scheduleNextBatch(processBatch);
    };
    const schedule = (0, _orderMjs.stepsOrder).reduce((acc, key)=>{
        const step = steps[key];
        acc[key] = (process, keepAlive = false, immediate = false)=>{
            if (!runNextFrame) wake();
            return step.schedule(process, keepAlive, immediate);
        };
        return acc;
    }, {});
    const cancel = (process)=>{
        for(let i = 0; i < (0, _orderMjs.stepsOrder).length; i++)steps[(0, _orderMjs.stepsOrder)[i]].cancel(process);
    };
    return {
        schedule,
        cancel,
        state,
        steps
    };
}

},{"motion-utils":"jQhZ4","./order.mjs":"dqkMK","./render-step.mjs":"iSqBJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jQhZ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionGlobalConfig", ()=>MotionGlobalConfig);
const MotionGlobalConfig = {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dqkMK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stepsOrder", ()=>stepsOrder);
const stepsOrder = [
    "setup",
    "read",
    "resolveKeyframes",
    "preUpdate",
    "update",
    "preRender",
    "render",
    "postRender"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iSqBJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRenderStep", ()=>createRenderStep);
var _bufferMjs = require("../stats/buffer.mjs");
function createRenderStep(runNextFrame, stepName) {
    /**
     * We create and reuse two queues, one to queue jobs for the current frame
     * and one for the next. We reuse to avoid triggering GC after x frames.
     */ let thisFrame = new Set();
    let nextFrame = new Set();
    /**
     * Track whether we're currently processing jobs in this step. This way
     * we can decide whether to schedule new jobs for this frame or next.
     */ let isProcessing = false;
    let flushNextFrame = false;
    /**
     * A set of processes which were marked keepAlive when scheduled.
     */ const toKeepAlive = new WeakSet();
    let latestFrameData = {
        delta: 0.0,
        timestamp: 0.0,
        isProcessing: false
    };
    let numCalls = 0;
    function triggerCallback(callback) {
        if (toKeepAlive.has(callback)) {
            step.schedule(callback);
            runNextFrame();
        }
        numCalls++;
        callback(latestFrameData);
    }
    const step = {
        /**
         * Schedule a process to run on the next frame.
         */ schedule: (callback, keepAlive = false, immediate = false)=>{
            const addToCurrentFrame = immediate && isProcessing;
            const queue = addToCurrentFrame ? thisFrame : nextFrame;
            if (keepAlive) toKeepAlive.add(callback);
            queue.add(callback);
            return callback;
        },
        /**
         * Cancel the provided callback from running on the next frame.
         */ cancel: (callback)=>{
            nextFrame.delete(callback);
            toKeepAlive.delete(callback);
        },
        /**
         * Execute all schedule callbacks.
         */ process: (frameData)=>{
            latestFrameData = frameData;
            /**
             * If we're already processing we've probably been triggered by a flushSync
             * inside an existing process. Instead of executing, mark flushNextFrame
             * as true and ensure we flush the following frame at the end of this one.
             */ if (isProcessing) {
                flushNextFrame = true;
                return;
            }
            isProcessing = true;
            // Swap this frame and the next to avoid GC
            const prevFrame = thisFrame;
            thisFrame = nextFrame;
            nextFrame = prevFrame;
            // Execute this frame
            thisFrame.forEach(triggerCallback);
            /**
             * If we're recording stats then
             */ if (stepName && (0, _bufferMjs.statsBuffer).value) (0, _bufferMjs.statsBuffer).value.frameloop[stepName].push(numCalls);
            numCalls = 0;
            // Clear the frame so no callbacks remain. This is to avoid
            // memory leaks should this render step not run for a while.
            thisFrame.clear();
            isProcessing = false;
            if (flushNextFrame) {
                flushNextFrame = false;
                step.process(frameData);
            }
        }
    };
    return step;
}

},{"../stats/buffer.mjs":"94Uw8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"94Uw8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "statsBuffer", ()=>statsBuffer);
const statsBuffer = {
    value: null,
    addProjectionMetrics: null
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ilKnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNone", ()=>isNone);
var _motionUtils = require("motion-utils");
function isNone(value) {
    if (typeof value === "number") return value === 0;
    else if (value !== null) return value === "none" || value === "0" || (0, _motionUtils.isZeroValueString)(value);
    else return true;
}

},{"motion-utils":"d1J8f","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d1J8f":[function(require,module,exports,__globalThis) {
/**
 * Check if the value is a zero value string like "0px" or "0%"
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isZeroValueString", ()=>isZeroValueString);
const isZeroValueString = (v)=>/^0[^.\s]+$/u.test(v);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2z43A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeNoneKeyframesAnimatable", ()=>makeNoneKeyframesAnimatable);
var _indexMjs = require("../../../value/types/complex/index.mjs");
var _animatableNoneMjs = require("../../../value/types/utils/animatable-none.mjs");
/**
 * If we encounter keyframes like "none" or "0" and we also have keyframes like
 * "#fff" or "200px 200px" we want to find a keyframe to serve as a template for
 * the "none" keyframes. In this case "#fff" or "200px 200px" - then these get turned into
 * zero equivalents, i.e. "#fff0" or "0px 0px".
 */ const invalidTemplates = new Set([
    "auto",
    "none",
    "0"
]);
function makeNoneKeyframesAnimatable(unresolvedKeyframes, noneKeyframeIndexes, name) {
    let i = 0;
    let animatableTemplate = undefined;
    while(i < unresolvedKeyframes.length && !animatableTemplate){
        const keyframe = unresolvedKeyframes[i];
        if (typeof keyframe === "string" && !invalidTemplates.has(keyframe) && (0, _indexMjs.analyseComplexValue)(keyframe).values.length) animatableTemplate = unresolvedKeyframes[i];
        i++;
    }
    if (animatableTemplate && name) for (const noneIndex of noneKeyframeIndexes)unresolvedKeyframes[noneIndex] = (0, _animatableNoneMjs.getAnimatableNone)(name, animatableTemplate);
}

},{"../../../value/types/complex/index.mjs":"aBOw1","../../../value/types/utils/animatable-none.mjs":"1iM43","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aBOw1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "analyseComplexValue", ()=>analyseComplexValue);
parcelHelpers.export(exports, "complex", ()=>complex);
var _indexMjs = require("../color/index.mjs");
var _colorRegexMjs = require("../utils/color-regex.mjs");
var _floatRegexMjs = require("../utils/float-regex.mjs");
var _sanitizeMjs = require("../utils/sanitize.mjs");
function test(v) {
    return isNaN(v) && typeof v === "string" && (v.match((0, _floatRegexMjs.floatRegex))?.length || 0) + (v.match((0, _colorRegexMjs.colorRegex))?.length || 0) > 0;
}
const NUMBER_TOKEN = "number";
const COLOR_TOKEN = "color";
const VAR_TOKEN = "var";
const VAR_FUNCTION_TOKEN = "var(";
const SPLIT_TOKEN = "${}";
// this regex consists of the `singleCssVariableRegex|rgbHSLValueRegex|digitRegex`
const complexRegex = /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
function analyseComplexValue(value) {
    const originalValue = value.toString();
    const values = [];
    const indexes = {
        color: [],
        number: [],
        var: []
    };
    const types = [];
    let i = 0;
    const tokenised = originalValue.replace(complexRegex, (parsedValue)=>{
        if ((0, _indexMjs.color).test(parsedValue)) {
            indexes.color.push(i);
            types.push(COLOR_TOKEN);
            values.push((0, _indexMjs.color).parse(parsedValue));
        } else if (parsedValue.startsWith(VAR_FUNCTION_TOKEN)) {
            indexes.var.push(i);
            types.push(VAR_TOKEN);
            values.push(parsedValue);
        } else {
            indexes.number.push(i);
            types.push(NUMBER_TOKEN);
            values.push(parseFloat(parsedValue));
        }
        ++i;
        return SPLIT_TOKEN;
    });
    const split = tokenised.split(SPLIT_TOKEN);
    return {
        values,
        split,
        indexes,
        types
    };
}
function parseComplexValue(v) {
    return analyseComplexValue(v).values;
}
function buildTransformer({ split, types }) {
    const numSections = split.length;
    return (v)=>{
        let output = "";
        for(let i = 0; i < numSections; i++){
            output += split[i];
            if (v[i] !== undefined) {
                const type = types[i];
                if (type === NUMBER_TOKEN) output += (0, _sanitizeMjs.sanitize)(v[i]);
                else if (type === COLOR_TOKEN) output += (0, _indexMjs.color).transform(v[i]);
                else output += v[i];
            }
        }
        return output;
    };
}
function createTransformer(source) {
    return buildTransformer(analyseComplexValue(source));
}
const convertNumbersToZero = (v)=>typeof v === "number" ? 0 : (0, _indexMjs.color).test(v) ? (0, _indexMjs.color).getAnimatableNone(v) : v;
/**
 * Convert a parsed value to its zero equivalent, but preserve numbers
 * that act as divisors in CSS calc() expressions.
 *
 * analyseComplexValue extracts numbers from CSS strings and puts the
 * surrounding text into a `split` template array. For example:
 *   "calc(var(--gap) / 5)"  →  values: [var(--gap), 5]
 *                               split:  ["calc(", " / ", ")"]
 *
 * When building a zero-equivalent for animation, naively zeroing all
 * numbers turns the divisor into 0 → "calc(var(--gap) / 0)" → NaN.
 * We detect this by checking whether the text preceding a number
 * (split[i]) ends with "/" — the CSS calc division operator.
 */ const convertToZero = (value, splitBefore)=>{
    if (typeof value === "number") return splitBefore?.trim().endsWith("/") ? value : 0;
    return convertNumbersToZero(value);
};
function getAnimatableNone(v) {
    const info = analyseComplexValue(v);
    const transformer = buildTransformer(info);
    return transformer(info.values.map((value, i)=>convertToZero(value, info.split[i])));
}
const complex = {
    test,
    parse: parseComplexValue,
    createTransformer,
    getAnimatableNone
};

},{"../color/index.mjs":"5J712","../utils/color-regex.mjs":"5Y2fm","../utils/float-regex.mjs":"3aqYL","../utils/sanitize.mjs":"iukd0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5J712":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "color", ()=>color);
var _hexMjs = require("./hex.mjs");
var _hslaMjs = require("./hsla.mjs");
var _rgbaMjs = require("./rgba.mjs");
const color = {
    test: (v)=>(0, _rgbaMjs.rgba).test(v) || (0, _hexMjs.hex).test(v) || (0, _hslaMjs.hsla).test(v),
    parse: (v)=>{
        if ((0, _rgbaMjs.rgba).test(v)) return (0, _rgbaMjs.rgba).parse(v);
        else if ((0, _hslaMjs.hsla).test(v)) return (0, _hslaMjs.hsla).parse(v);
        else return (0, _hexMjs.hex).parse(v);
    },
    transform: (v)=>{
        return typeof v === "string" ? v : v.hasOwnProperty("red") ? (0, _rgbaMjs.rgba).transform(v) : (0, _hslaMjs.hsla).transform(v);
    },
    getAnimatableNone: (v)=>{
        const parsed = color.parse(v);
        parsed.alpha = 0;
        return color.transform(parsed);
    }
};

},{"./hex.mjs":"lzelM","./hsla.mjs":"7LnvJ","./rgba.mjs":"7hioC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lzelM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hex", ()=>hex);
var _rgbaMjs = require("./rgba.mjs");
var _utilsMjs = require("./utils.mjs");
function parseHex(v) {
    let r = "";
    let g = "";
    let b = "";
    let a = "";
    // If we have 6 characters, ie #FF0000
    if (v.length > 5) {
        r = v.substring(1, 3);
        g = v.substring(3, 5);
        b = v.substring(5, 7);
        a = v.substring(7, 9);
    // Or we have 3 characters, ie #F00
    } else {
        r = v.substring(1, 2);
        g = v.substring(2, 3);
        b = v.substring(3, 4);
        a = v.substring(4, 5);
        r += r;
        g += g;
        b += b;
        a += a;
    }
    return {
        red: parseInt(r, 16),
        green: parseInt(g, 16),
        blue: parseInt(b, 16),
        alpha: a ? parseInt(a, 16) / 255 : 1
    };
}
const hex = {
    test: /*@__PURE__*/ (0, _utilsMjs.isColorString)("#"),
    parse: parseHex,
    transform: (0, _rgbaMjs.rgba).transform
};

},{"./rgba.mjs":"7hioC","./utils.mjs":"b01X8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7hioC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rgbUnit", ()=>rgbUnit);
parcelHelpers.export(exports, "rgba", ()=>rgba);
var _motionUtils = require("motion-utils");
var _indexMjs = require("../numbers/index.mjs");
var _sanitizeMjs = require("../utils/sanitize.mjs");
var _utilsMjs = require("./utils.mjs");
const clampRgbUnit = (v)=>(0, _motionUtils.clamp)(0, 255, v);
const rgbUnit = {
    ...(0, _indexMjs.number),
    transform: (v)=>Math.round(clampRgbUnit(v))
};
const rgba = {
    test: /*@__PURE__*/ (0, _utilsMjs.isColorString)("rgb", "red"),
    parse: /*@__PURE__*/ (0, _utilsMjs.splitColor)("red", "green", "blue"),
    transform: ({ red, green, blue, alpha: alpha$1 = 1 })=>"rgba(" + rgbUnit.transform(red) + ", " + rgbUnit.transform(green) + ", " + rgbUnit.transform(blue) + ", " + (0, _sanitizeMjs.sanitize)((0, _indexMjs.alpha).transform(alpha$1)) + ")"
};

},{"motion-utils":"b78W4","../numbers/index.mjs":"hGTrH","../utils/sanitize.mjs":"iukd0","./utils.mjs":"b01X8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iukd0":[function(require,module,exports,__globalThis) {
// If this number is a decimal, make it just five decimal places
// to avoid exponents
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sanitize", ()=>sanitize);
const sanitize = (v)=>Math.round(v * 100000) / 100000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b01X8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isColorString", ()=>isColorString);
parcelHelpers.export(exports, "splitColor", ()=>splitColor);
var _floatRegexMjs = require("../utils/float-regex.mjs");
var _isNullishMjs = require("../utils/is-nullish.mjs");
var _singleColorRegexMjs = require("../utils/single-color-regex.mjs");
/**
 * Returns true if the provided string is a color, ie rgba(0,0,0,0) or #000,
 * but false if a number or multiple colors
 */ const isColorString = (type, testProp)=>(v)=>{
        return Boolean(typeof v === "string" && (0, _singleColorRegexMjs.singleColorRegex).test(v) && v.startsWith(type) || testProp && !(0, _isNullishMjs.isNullish)(v) && Object.prototype.hasOwnProperty.call(v, testProp));
    };
const splitColor = (aName, bName, cName)=>(v)=>{
        if (typeof v !== "string") return v;
        const [a, b, c, alpha] = v.match((0, _floatRegexMjs.floatRegex));
        return {
            [aName]: parseFloat(a),
            [bName]: parseFloat(b),
            [cName]: parseFloat(c),
            alpha: alpha !== undefined ? parseFloat(alpha) : 1
        };
    };

},{"../utils/float-regex.mjs":"3aqYL","../utils/is-nullish.mjs":"doH62","../utils/single-color-regex.mjs":"lhjd6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3aqYL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "floatRegex", ()=>floatRegex);
const floatRegex = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"doH62":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNullish", ()=>isNullish);
function isNullish(v) {
    return v == null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lhjd6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "singleColorRegex", ()=>singleColorRegex);
const singleColorRegex = /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7LnvJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hsla", ()=>hsla);
var _indexMjs = require("../numbers/index.mjs");
var _unitsMjs = require("../numbers/units.mjs");
var _sanitizeMjs = require("../utils/sanitize.mjs");
var _utilsMjs = require("./utils.mjs");
const hsla = {
    test: /*@__PURE__*/ (0, _utilsMjs.isColorString)("hsl", "hue"),
    parse: /*@__PURE__*/ (0, _utilsMjs.splitColor)("hue", "saturation", "lightness"),
    transform: ({ hue, saturation, lightness, alpha: alpha$1 = 1 })=>{
        return "hsla(" + Math.round(hue) + ", " + (0, _unitsMjs.percent).transform((0, _sanitizeMjs.sanitize)(saturation)) + ", " + (0, _unitsMjs.percent).transform((0, _sanitizeMjs.sanitize)(lightness)) + ", " + (0, _sanitizeMjs.sanitize)((0, _indexMjs.alpha).transform(alpha$1)) + ")";
    }
};

},{"../numbers/index.mjs":"hGTrH","../numbers/units.mjs":"aXLZR","../utils/sanitize.mjs":"iukd0","./utils.mjs":"b01X8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5Y2fm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "colorRegex", ()=>colorRegex);
const colorRegex = /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1iM43":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAnimatableNone", ()=>getAnimatableNone);
var _indexMjs = require("../complex/index.mjs");
var _filterMjs = require("../complex/filter.mjs");
var _maskMjs = require("../complex/mask.mjs");
var _defaultsMjs = require("../maps/defaults.mjs");
const customTypes = /*@__PURE__*/ new Set([
    (0, _filterMjs.filter),
    (0, _maskMjs.mask)
]);
function getAnimatableNone(key, value) {
    let defaultValueType = (0, _defaultsMjs.getDefaultValueType)(key);
    if (!customTypes.has(defaultValueType)) defaultValueType = (0, _indexMjs.complex);
    // If value is not recognised as animatable, ie "none", create an animatable version origin based on the target
    return defaultValueType.getAnimatableNone ? defaultValueType.getAnimatableNone(value) : undefined;
}

},{"../complex/index.mjs":"aBOw1","../complex/filter.mjs":"bBVR1","../complex/mask.mjs":"gKtNM","../maps/defaults.mjs":"gMxw9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bBVR1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filter", ()=>filter);
var _indexMjs = require("./index.mjs");
var _floatRegexMjs = require("../utils/float-regex.mjs");
/**
 * Properties that should default to 1 or 100%
 */ const maxDefaults = new Set([
    "brightness",
    "contrast",
    "saturate",
    "opacity"
]);
function applyDefaultFilter(v) {
    const [name, value] = v.slice(0, -1).split("(");
    if (name === "drop-shadow") return v;
    const [number] = value.match((0, _floatRegexMjs.floatRegex)) || [];
    if (!number) return v;
    const unit = value.replace(number, "");
    let defaultValue = maxDefaults.has(name) ? 1 : 0;
    if (number !== value) defaultValue *= 100;
    return name + "(" + defaultValue + unit + ")";
}
const functionRegex = /\b([a-z-]*)\(.*?\)/gu;
const filter = {
    ...(0, _indexMjs.complex),
    getAnimatableNone: (v)=>{
        const functions = v.match(functionRegex);
        return functions ? functions.map(applyDefaultFilter).join(" ") : v;
    }
};

},{"./index.mjs":"aBOw1","../utils/float-regex.mjs":"3aqYL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gKtNM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mask", ()=>mask);
var _indexMjs = require("./index.mjs");
const mask = {
    ...(0, _indexMjs.complex),
    getAnimatableNone: (v)=>{
        const parsed = (0, _indexMjs.complex).parse(v);
        const transformer = (0, _indexMjs.complex).createTransformer(v);
        return transformer(parsed.map((v)=>typeof v === "number" ? 0 : typeof v === "object" ? {
                ...v,
                alpha: 1
            } : v));
    }
};

},{"./index.mjs":"aBOw1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gMxw9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultValueTypes", ()=>defaultValueTypes);
parcelHelpers.export(exports, "getDefaultValueType", ()=>getDefaultValueType);
var _indexMjs = require("../color/index.mjs");
var _filterMjs = require("../complex/filter.mjs");
var _maskMjs = require("../complex/mask.mjs");
var _numberMjs = require("./number.mjs");
/**
 * A map of default value types for common values
 */ const defaultValueTypes = {
    ...(0, _numberMjs.numberValueTypes),
    color: // Color props
    (0, _indexMjs.color),
    backgroundColor: (0, _indexMjs.color),
    outlineColor: (0, _indexMjs.color),
    fill: (0, _indexMjs.color),
    stroke: (0, _indexMjs.color),
    // Border props
    borderColor: (0, _indexMjs.color),
    borderTopColor: (0, _indexMjs.color),
    borderRightColor: (0, _indexMjs.color),
    borderBottomColor: (0, _indexMjs.color),
    borderLeftColor: (0, _indexMjs.color),
    filter: (0, _filterMjs.filter),
    WebkitFilter: (0, _filterMjs.filter),
    mask: (0, _maskMjs.mask),
    WebkitMask: (0, _maskMjs.mask)
};
/**
 * Gets the default ValueType for the provided value key
 */ const getDefaultValueType = (key)=>defaultValueTypes[key];

},{"../color/index.mjs":"5J712","../complex/filter.mjs":"bBVR1","../complex/mask.mjs":"gKtNM","./number.mjs":"jehqS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jehqS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numberValueTypes", ()=>numberValueTypes);
var _intMjs = require("../int.mjs");
var _indexMjs = require("../numbers/index.mjs");
var _unitsMjs = require("../numbers/units.mjs");
var _transformMjs = require("./transform.mjs");
const numberValueTypes = {
    // Border props
    borderWidth: (0, _unitsMjs.px),
    borderTopWidth: (0, _unitsMjs.px),
    borderRightWidth: (0, _unitsMjs.px),
    borderBottomWidth: (0, _unitsMjs.px),
    borderLeftWidth: (0, _unitsMjs.px),
    borderRadius: (0, _unitsMjs.px),
    borderTopLeftRadius: (0, _unitsMjs.px),
    borderTopRightRadius: (0, _unitsMjs.px),
    borderBottomRightRadius: (0, _unitsMjs.px),
    borderBottomLeftRadius: (0, _unitsMjs.px),
    // Positioning props
    width: (0, _unitsMjs.px),
    maxWidth: (0, _unitsMjs.px),
    height: (0, _unitsMjs.px),
    maxHeight: (0, _unitsMjs.px),
    top: (0, _unitsMjs.px),
    right: (0, _unitsMjs.px),
    bottom: (0, _unitsMjs.px),
    left: (0, _unitsMjs.px),
    inset: (0, _unitsMjs.px),
    insetBlock: (0, _unitsMjs.px),
    insetBlockStart: (0, _unitsMjs.px),
    insetBlockEnd: (0, _unitsMjs.px),
    insetInline: (0, _unitsMjs.px),
    insetInlineStart: (0, _unitsMjs.px),
    insetInlineEnd: (0, _unitsMjs.px),
    // Spacing props
    padding: (0, _unitsMjs.px),
    paddingTop: (0, _unitsMjs.px),
    paddingRight: (0, _unitsMjs.px),
    paddingBottom: (0, _unitsMjs.px),
    paddingLeft: (0, _unitsMjs.px),
    paddingBlock: (0, _unitsMjs.px),
    paddingBlockStart: (0, _unitsMjs.px),
    paddingBlockEnd: (0, _unitsMjs.px),
    paddingInline: (0, _unitsMjs.px),
    paddingInlineStart: (0, _unitsMjs.px),
    paddingInlineEnd: (0, _unitsMjs.px),
    margin: (0, _unitsMjs.px),
    marginTop: (0, _unitsMjs.px),
    marginRight: (0, _unitsMjs.px),
    marginBottom: (0, _unitsMjs.px),
    marginLeft: (0, _unitsMjs.px),
    marginBlock: (0, _unitsMjs.px),
    marginBlockStart: (0, _unitsMjs.px),
    marginBlockEnd: (0, _unitsMjs.px),
    marginInline: (0, _unitsMjs.px),
    marginInlineStart: (0, _unitsMjs.px),
    marginInlineEnd: (0, _unitsMjs.px),
    // Typography
    fontSize: (0, _unitsMjs.px),
    // Misc
    backgroundPositionX: (0, _unitsMjs.px),
    backgroundPositionY: (0, _unitsMjs.px),
    ...(0, _transformMjs.transformValueTypes),
    zIndex: (0, _intMjs.int),
    // SVG
    fillOpacity: (0, _indexMjs.alpha),
    strokeOpacity: (0, _indexMjs.alpha),
    numOctaves: (0, _intMjs.int)
};

},{"../int.mjs":"k5Zvx","../numbers/index.mjs":"hGTrH","../numbers/units.mjs":"aXLZR","./transform.mjs":"bH0aJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k5Zvx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "int", ()=>int);
var _indexMjs = require("./numbers/index.mjs");
const int = {
    ...(0, _indexMjs.number),
    transform: Math.round
};

},{"./numbers/index.mjs":"hGTrH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bH0aJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformValueTypes", ()=>transformValueTypes);
var _indexMjs = require("../numbers/index.mjs");
var _unitsMjs = require("../numbers/units.mjs");
const transformValueTypes = {
    rotate: (0, _unitsMjs.degrees),
    rotateX: (0, _unitsMjs.degrees),
    rotateY: (0, _unitsMjs.degrees),
    rotateZ: (0, _unitsMjs.degrees),
    scale: (0, _indexMjs.scale),
    scaleX: (0, _indexMjs.scale),
    scaleY: (0, _indexMjs.scale),
    scaleZ: (0, _indexMjs.scale),
    skew: (0, _unitsMjs.degrees),
    skewX: (0, _unitsMjs.degrees),
    skewY: (0, _unitsMjs.degrees),
    distance: (0, _unitsMjs.px),
    translateX: (0, _unitsMjs.px),
    translateY: (0, _unitsMjs.px),
    translateZ: (0, _unitsMjs.px),
    x: (0, _unitsMjs.px),
    y: (0, _unitsMjs.px),
    z: (0, _unitsMjs.px),
    perspective: (0, _unitsMjs.px),
    transformPerspective: (0, _unitsMjs.px),
    opacity: (0, _indexMjs.alpha),
    originX: (0, _unitsMjs.progressPercentage),
    originY: (0, _unitsMjs.progressPercentage),
    originZ: (0, _unitsMjs.px)
};

},{"../numbers/index.mjs":"hGTrH","../numbers/units.mjs":"aXLZR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lVIcw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VisualElement", ()=>VisualElement);
parcelHelpers.export(exports, "getFeatureDefinitions", ()=>getFeatureDefinitions);
parcelHelpers.export(exports, "setFeatureDefinitions", ()=>setFeatureDefinitions);
var _motionUtils = require("motion-utils");
var _keyframesResolverMjs = require("../animation/keyframes/KeyframesResolver.mjs");
var _nativeAnimationMjs = require("../animation/NativeAnimation.mjs");
var _acceleratedValuesMjs = require("../animation/waapi/utils/accelerated-values.mjs");
var _microtaskMjs = require("../frameloop/microtask.mjs");
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
var _modelsMjs = require("../projection/geometry/models.mjs");
var _indexMjs = require("../value/index.mjs");
var _indexMjs1 = require("../value/types/complex/index.mjs");
var _animatableNoneMjs = require("../value/types/utils/animatable-none.mjs");
var _findMjs = require("../value/types/utils/find.mjs");
var _isMotionValueMjs = require("../value/utils/is-motion-value.mjs");
var _storeMjs = require("./store.mjs");
var _isControllingVariantsMjs = require("./utils/is-controlling-variants.mjs");
var _keysTransformMjs = require("./utils/keys-transform.mjs");
var _motionValuesMjs = require("./utils/motion-values.mjs");
var _indexMjs2 = require("./utils/reduced-motion/index.mjs");
var _resolveVariantsMjs = require("./utils/resolve-variants.mjs");
var _stateMjs = require("./utils/reduced-motion/state.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
const propEventHandlers = [
    "AnimationStart",
    "AnimationComplete",
    "Update",
    "BeforeLayoutMeasure",
    "LayoutMeasure",
    "LayoutAnimationStart",
    "LayoutAnimationComplete"
];
/**
 * Static feature definitions - can be injected by framework layer
 */ let featureDefinitions = {};
/**
 * Set feature definitions for all VisualElements.
 * This should be called by the framework layer (e.g., framer-motion) during initialization.
 */ function setFeatureDefinitions(definitions) {
    featureDefinitions = definitions;
}
/**
 * Get the current feature definitions
 */ function getFeatureDefinitions() {
    return featureDefinitions;
}
/**
 * A VisualElement is an imperative abstraction around UI elements such as
 * HTMLElement, SVGElement, Three.Object3D etc.
 */ class VisualElement {
    /**
     * This method takes React props and returns found MotionValues. For example, HTML
     * MotionValues will be found within the style prop, whereas for Three.js within attribute arrays.
     *
     * This isn't an abstract method as it needs calling in the constructor, but it is
     * intended to be one.
     */ scrapeMotionValuesFromProps(_props, _prevProps, _visualElement) {
        return {};
    }
    constructor({ parent, props, presenceContext, reducedMotionConfig, skipAnimations, blockInitialAnimation, visualState }, options = {}){
        /**
         * A reference to the current underlying Instance, e.g. a HTMLElement
         * or Three.Mesh etc.
         */ this.current = null;
        /**
         * A set containing references to this VisualElement's children.
         */ this.children = new Set();
        /**
         * Determine what role this visual element should take in the variant tree.
         */ this.isVariantNode = false;
        this.isControllingVariants = false;
        /**
         * Decides whether this VisualElement should animate in reduced motion
         * mode.
         *
         * TODO: This is currently set on every individual VisualElement but feels
         * like it could be set globally.
         */ this.shouldReduceMotion = null;
        /**
         * Decides whether animations should be skipped for this VisualElement.
         * Useful for E2E tests and visual regression testing.
         */ this.shouldSkipAnimations = false;
        /**
         * A map of all motion values attached to this visual element. Motion
         * values are source of truth for any given animated value. A motion
         * value might be provided externally by the component via props.
         */ this.values = new Map();
        this.KeyframeResolver = (0, _keyframesResolverMjs.KeyframeResolver);
        /**
         * Cleanup functions for active features (hover/tap/exit etc)
         */ this.features = {};
        /**
         * A map of every subscription that binds the provided or generated
         * motion values onChange listeners to this visual element.
         */ this.valueSubscriptions = new Map();
        /**
         * A reference to the previously-provided motion values as returned
         * from scrapeMotionValuesFromProps. We use the keys in here to determine
         * if any motion values need to be removed after props are updated.
         */ this.prevMotionValues = {};
        /**
         * Track whether this element has been mounted before, to detect
         * remounts after Suspense unmount/remount cycles.
         */ this.hasBeenMounted = false;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        /**
         * An object containing an unsubscribe function for each prop event subscription.
         * For example, every "Update" event can have multiple subscribers via
         * VisualElement.on(), but only one of those can be defined via the onUpdate prop.
         */ this.propEventSubscriptions = {};
        this.notifyUpdate = ()=>this.notify("Update", this.latestValues);
        this.render = ()=>{
            if (!this.current) return;
            this.triggerBuild();
            this.renderInstance(this.current, this.renderState, this.props.style, this.projection);
        };
        this.renderScheduledAt = 0.0;
        this.scheduleRender = ()=>{
            const now = (0, _syncTimeMjs.time).now();
            if (this.renderScheduledAt < now) {
                this.renderScheduledAt = now;
                (0, _frameMjs.frame).render(this.render, false, true);
            }
        };
        const { latestValues, renderState } = visualState;
        this.latestValues = latestValues;
        this.baseTarget = {
            ...latestValues
        };
        this.initialValues = props.initial ? {
            ...latestValues
        } : {};
        this.renderState = renderState;
        this.parent = parent;
        this.props = props;
        this.presenceContext = presenceContext;
        this.depth = parent ? parent.depth + 1 : 0;
        this.reducedMotionConfig = reducedMotionConfig;
        this.skipAnimationsConfig = skipAnimations;
        this.options = options;
        this.blockInitialAnimation = Boolean(blockInitialAnimation);
        this.isControllingVariants = (0, _isControllingVariantsMjs.isControllingVariants)(props);
        this.isVariantNode = (0, _isControllingVariantsMjs.isVariantNode)(props);
        if (this.isVariantNode) this.variantChildren = new Set();
        this.manuallyAnimateOnMount = Boolean(parent && parent.current);
        /**
         * Any motion values that are provided to the element when created
         * aren't yet bound to the element, as this would technically be impure.
         * However, we iterate through the motion values and set them to the
         * initial values for this component.
         *
         * TODO: This is impure and we should look at changing this to run on mount.
         * Doing so will break some tests but this isn't necessarily a breaking change,
         * more a reflection of the test.
         */ const { willChange, ...initialMotionValues } = this.scrapeMotionValuesFromProps(props, {}, this);
        for(const key in initialMotionValues){
            const value = initialMotionValues[key];
            if (latestValues[key] !== undefined && (0, _isMotionValueMjs.isMotionValue)(value)) value.set(latestValues[key]);
        }
    }
    mount(instance) {
        /**
         * If this element has been mounted before (e.g. after a Suspense
         * unmount/remount), reset motion values to their initial state
         * so animations replay correctly from initial → animate.
         */ if (this.hasBeenMounted) for(const key in this.initialValues){
            this.values.get(key)?.jump(this.initialValues[key]);
            this.latestValues[key] = this.initialValues[key];
        }
        this.current = instance;
        (0, _storeMjs.visualElementStore).set(instance, this);
        if (this.projection && !this.projection.instance) this.projection.mount(instance);
        if (this.parent && this.isVariantNode && !this.isControllingVariants) this.removeFromVariantTree = this.parent.addVariantChild(this);
        this.values.forEach((value, key)=>this.bindToMotionValue(key, value));
        /**
         * Determine reduced motion preference. Only initialize the matchMedia
         * listener if we actually need the dynamic value (i.e., when config
         * is neither "never" nor "always").
         */ if (this.reducedMotionConfig === "never") this.shouldReduceMotion = false;
        else if (this.reducedMotionConfig === "always") this.shouldReduceMotion = true;
        else {
            if (!(0, _stateMjs.hasReducedMotionListener).current) (0, _indexMjs2.initPrefersReducedMotion)();
            this.shouldReduceMotion = (0, _stateMjs.prefersReducedMotion).current;
        }
        /**
         * Set whether animations should be skipped based on the config.
         */ this.shouldSkipAnimations = this.skipAnimationsConfig ?? false;
        this.parent?.addChild(this);
        this.update(this.props, this.presenceContext);
        this.hasBeenMounted = true;
    }
    unmount() {
        this.projection && this.projection.unmount();
        (0, _frameMjs.cancelFrame)(this.notifyUpdate);
        (0, _frameMjs.cancelFrame)(this.render);
        this.valueSubscriptions.forEach((remove)=>remove());
        this.valueSubscriptions.clear();
        this.removeFromVariantTree && this.removeFromVariantTree();
        this.parent?.removeChild(this);
        for(const key in this.events)this.events[key].clear();
        for(const key in this.features){
            const feature = this.features[key];
            if (feature) {
                feature.unmount();
                feature.isMounted = false;
            }
        }
        this.current = null;
    }
    addChild(child) {
        this.children.add(child);
        this.enteringChildren ?? (this.enteringChildren = new Set());
        this.enteringChildren.add(child);
    }
    removeChild(child) {
        this.children.delete(child);
        this.enteringChildren && this.enteringChildren.delete(child);
    }
    bindToMotionValue(key, value) {
        if (this.valueSubscriptions.has(key)) this.valueSubscriptions.get(key)();
        if (value.accelerate && (0, _acceleratedValuesMjs.acceleratedValues).has(key) && this.current instanceof HTMLElement) {
            const { factory, keyframes, times, ease, duration } = value.accelerate;
            const animation = new (0, _nativeAnimationMjs.NativeAnimation)({
                element: this.current,
                name: key,
                keyframes,
                times,
                ease,
                duration: (0, _motionUtils.secondsToMilliseconds)(duration)
            });
            const cleanup = factory(animation);
            this.valueSubscriptions.set(key, ()=>{
                cleanup();
                animation.cancel();
            });
            return;
        }
        const valueIsTransform = (0, _keysTransformMjs.transformProps).has(key);
        if (valueIsTransform && this.onBindTransform) this.onBindTransform();
        const removeOnChange = value.on("change", (latestValue)=>{
            this.latestValues[key] = latestValue;
            this.props.onUpdate && (0, _frameMjs.frame).preRender(this.notifyUpdate);
            if (valueIsTransform && this.projection) this.projection.isTransformDirty = true;
            this.scheduleRender();
        });
        let removeSyncCheck;
        if (typeof window !== "undefined" && window.MotionCheckAppearSync) removeSyncCheck = window.MotionCheckAppearSync(this, key, value);
        this.valueSubscriptions.set(key, ()=>{
            removeOnChange();
            if (removeSyncCheck) removeSyncCheck();
            if (value.owner) value.stop();
        });
    }
    sortNodePosition(other) {
        /**
         * If these nodes aren't even of the same type we can't compare their depth.
         */ if (!this.current || !this.sortInstanceNodePosition || this.type !== other.type) return 0;
        return this.sortInstanceNodePosition(this.current, other.current);
    }
    updateFeatures() {
        let key = "animation";
        for(key in featureDefinitions){
            const featureDefinition = featureDefinitions[key];
            if (!featureDefinition) continue;
            const { isEnabled, Feature: FeatureConstructor } = featureDefinition;
            /**
             * If this feature is enabled but not active, make a new instance.
             */ if (!this.features[key] && FeatureConstructor && isEnabled(this.props)) this.features[key] = new FeatureConstructor(this);
            /**
             * If we have a feature, mount or update it.
             */ if (this.features[key]) {
                const feature = this.features[key];
                if (feature.isMounted) feature.update();
                else {
                    feature.mount();
                    feature.isMounted = true;
                }
            }
        }
    }
    triggerBuild() {
        this.build(this.renderState, this.latestValues, this.props);
    }
    /**
     * Measure the current viewport box with or without transforms.
     * Only measures axis-aligned boxes, rotate and skew must be manually
     * removed with a re-render to work.
     */ measureViewportBox() {
        return this.current ? this.measureInstanceViewportBox(this.current, this.props) : (0, _modelsMjs.createBox)();
    }
    getStaticValue(key) {
        return this.latestValues[key];
    }
    setStaticValue(key, value) {
        this.latestValues[key] = value;
    }
    /**
     * Update the provided props. Ensure any newly-added motion values are
     * added to our map, old ones removed, and listeners updated.
     */ update(props, presenceContext) {
        if (props.transformTemplate || this.props.transformTemplate) this.scheduleRender();
        this.prevProps = this.props;
        this.props = props;
        this.prevPresenceContext = this.presenceContext;
        this.presenceContext = presenceContext;
        /**
         * Update prop event handlers ie onAnimationStart, onAnimationComplete
         */ for(let i = 0; i < propEventHandlers.length; i++){
            const key = propEventHandlers[i];
            if (this.propEventSubscriptions[key]) {
                this.propEventSubscriptions[key]();
                delete this.propEventSubscriptions[key];
            }
            const listenerName = "on" + key;
            const listener = props[listenerName];
            if (listener) this.propEventSubscriptions[key] = this.on(key, listener);
        }
        this.prevMotionValues = (0, _motionValuesMjs.updateMotionValuesFromProps)(this, this.scrapeMotionValuesFromProps(props, this.prevProps || {}, this), this.prevMotionValues);
        if (this.handleChildMotionValue) this.handleChildMotionValue();
    }
    getProps() {
        return this.props;
    }
    /**
     * Returns the variant definition with a given name.
     */ getVariant(name) {
        return this.props.variants ? this.props.variants[name] : undefined;
    }
    /**
     * Returns the defined default transition on this component.
     */ getDefaultTransition() {
        return this.props.transition;
    }
    getTransformPagePoint() {
        return this.props.transformPagePoint;
    }
    getClosestVariantNode() {
        return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : undefined;
    }
    /**
     * Add a child visual element to our set of children.
     */ addVariantChild(child) {
        const closestVariantNode = this.getClosestVariantNode();
        if (closestVariantNode) {
            closestVariantNode.variantChildren && closestVariantNode.variantChildren.add(child);
            return ()=>closestVariantNode.variantChildren.delete(child);
        }
    }
    /**
     * Add a motion value and bind it to this visual element.
     */ addValue(key, value) {
        // Remove existing value if it exists
        const existingValue = this.values.get(key);
        if (value !== existingValue) {
            if (existingValue) this.removeValue(key);
            this.bindToMotionValue(key, value);
            this.values.set(key, value);
            this.latestValues[key] = value.get();
        }
    }
    /**
     * Remove a motion value and unbind any active subscriptions.
     */ removeValue(key) {
        this.values.delete(key);
        const unsubscribe = this.valueSubscriptions.get(key);
        if (unsubscribe) {
            unsubscribe();
            this.valueSubscriptions.delete(key);
        }
        delete this.latestValues[key];
        this.removeValueFromRenderState(key, this.renderState);
    }
    /**
     * Check whether we have a motion value for this key
     */ hasValue(key) {
        return this.values.has(key);
    }
    getValue(key, defaultValue) {
        if (this.props.values && this.props.values[key]) return this.props.values[key];
        let value = this.values.get(key);
        if (value === undefined && defaultValue !== undefined) {
            value = (0, _indexMjs.motionValue)(defaultValue === null ? undefined : defaultValue, {
                owner: this
            });
            this.addValue(key, value);
        }
        return value;
    }
    /**
     * If we're trying to animate to a previously unencountered value,
     * we need to check for it in our state and as a last resort read it
     * directly from the instance (which might have performance implications).
     */ readValue(key, target) {
        let value = this.latestValues[key] !== undefined || !this.current ? this.latestValues[key] : this.getBaseTargetFromProps(this.props, key) ?? this.readValueFromInstance(this.current, key, this.options);
        if (value !== undefined && value !== null) {
            if (typeof value === "string" && ((0, _motionUtils.isNumericalString)(value) || (0, _motionUtils.isZeroValueString)(value))) // If this is a number read as a string, ie "0" or "200", convert it to a number
            value = parseFloat(value);
            else if (!(0, _findMjs.findValueType)(value) && (0, _indexMjs1.complex).test(target)) value = (0, _animatableNoneMjs.getAnimatableNone)(key, target);
            this.setBaseTarget(key, (0, _isMotionValueMjs.isMotionValue)(value) ? value.get() : value);
        }
        return (0, _isMotionValueMjs.isMotionValue)(value) ? value.get() : value;
    }
    /**
     * Set the base target to later animate back to. This is currently
     * only hydrated on creation and when we first read a value.
     */ setBaseTarget(key, value) {
        this.baseTarget[key] = value;
    }
    /**
     * Find the base target for a value thats been removed from all animation
     * props.
     */ getBaseTarget(key) {
        const { initial } = this.props;
        let valueFromInitial;
        if (typeof initial === "string" || typeof initial === "object") {
            const variant = (0, _resolveVariantsMjs.resolveVariantFromProps)(this.props, initial, this.presenceContext?.custom);
            if (variant) valueFromInitial = variant[key];
        }
        /**
         * If this value still exists in the current initial variant, read that.
         */ if (initial && valueFromInitial !== undefined) return valueFromInitial;
        /**
         * Alternatively, if this VisualElement config has defined a getBaseTarget
         * so we can read the value from an alternative source, try that.
         */ const target = this.getBaseTargetFromProps(this.props, key);
        if (target !== undefined && !(0, _isMotionValueMjs.isMotionValue)(target)) return target;
        /**
         * If the value was initially defined on initial, but it doesn't any more,
         * return undefined. Otherwise return the value as initially read from the DOM.
         */ return this.initialValues[key] !== undefined && valueFromInitial === undefined ? undefined : this.baseTarget[key];
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, _motionUtils.SubscriptionManager)();
        return this.events[eventName].add(callback);
    }
    notify(eventName, ...args) {
        if (this.events[eventName]) this.events[eventName].notify(...args);
    }
    scheduleRenderMicrotask() {
        (0, _microtaskMjs.microtask).render(this.render);
    }
}

},{"motion-utils":[["isNumericalString","jEMv3"],["isZeroValueString","d1J8f"],["secondsToMilliseconds","dIdtR"],["SubscriptionManager","8tNj4"]],"../animation/keyframes/KeyframesResolver.mjs":"aNL0j","../animation/NativeAnimation.mjs":"bnVN0","../animation/waapi/utils/accelerated-values.mjs":"2tVvg","../frameloop/microtask.mjs":"7uR6H","../frameloop/sync-time.mjs":"74aV8","../projection/geometry/models.mjs":"5H0uu","../value/index.mjs":"hX31g","../value/types/complex/index.mjs":"aBOw1","../value/types/utils/animatable-none.mjs":"1iM43","../value/types/utils/find.mjs":"iv21g","../value/utils/is-motion-value.mjs":"fKDJz","./store.mjs":"4d03k","./utils/is-controlling-variants.mjs":"932u2","./utils/keys-transform.mjs":"bJbLV","./utils/motion-values.mjs":"dMLgg","./utils/reduced-motion/index.mjs":"jII2O","./utils/resolve-variants.mjs":"fFvtX","./utils/reduced-motion/state.mjs":"2VFG9","../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dIdtR":[function(require,module,exports,__globalThis) {
/**
 * Converts seconds to milliseconds
 *
 * @param seconds - Time in seconds.
 * @return milliseconds - Converted time in milliseconds.
 */ /*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "millisecondsToSeconds", ()=>millisecondsToSeconds);
parcelHelpers.export(exports, "secondsToMilliseconds", ()=>secondsToMilliseconds);
const secondsToMilliseconds = (seconds)=>seconds * 1000;
/*#__NO_SIDE_EFFECTS__*/ const millisecondsToSeconds = (milliseconds)=>milliseconds / 1000;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8tNj4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscriptionManager", ()=>SubscriptionManager);
var _arrayMjs = require("./array.mjs");
class SubscriptionManager {
    constructor(){
        this.subscriptions = [];
    }
    add(handler) {
        (0, _arrayMjs.addUniqueItem)(this.subscriptions, handler);
        return ()=>(0, _arrayMjs.removeItem)(this.subscriptions, handler);
    }
    notify(a, b, c) {
        const numSubscriptions = this.subscriptions.length;
        if (!numSubscriptions) return;
        if (numSubscriptions === 1) /**
             * If there's only a single handler we can just call it without invoking a loop.
             */ this.subscriptions[0](a, b, c);
        else for(let i = 0; i < numSubscriptions; i++){
            /**
                 * Check whether the handler exists before firing as it's possible
                 * the subscriptions were modified during this loop running.
                 */ const handler = this.subscriptions[i];
            handler && handler(a, b, c);
        }
    }
    getSize() {
        return this.subscriptions.length;
    }
    clear() {
        this.subscriptions.length = 0;
    }
}

},{"./array.mjs":"841vh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"841vh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addUniqueItem", ()=>addUniqueItem);
parcelHelpers.export(exports, "moveItem", ()=>moveItem);
parcelHelpers.export(exports, "removeItem", ()=>removeItem);
function addUniqueItem(arr, item) {
    if (arr.indexOf(item) === -1) arr.push(item);
}
function removeItem(arr, item) {
    const index = arr.indexOf(item);
    if (index > -1) arr.splice(index, 1);
}
// Adapted from array-move
function moveItem([...arr], fromIndex, toIndex) {
    const startIndex = fromIndex < 0 ? arr.length + fromIndex : fromIndex;
    if (startIndex >= 0 && startIndex < arr.length) {
        const endIndex = toIndex < 0 ? arr.length + toIndex : toIndex;
        const [item] = arr.splice(fromIndex, 1);
        arr.splice(endIndex, 0, item);
    }
    return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bnVN0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NativeAnimation", ()=>NativeAnimation);
var _motionUtils = require("motion-utils");
var _styleSetMjs = require("../render/dom/style-set.mjs");
var _scrollTimelineMjs = require("../utils/supports/scroll-timeline.mjs");
var _getFinalMjs = require("./keyframes/get-final.mjs");
var _withPromiseMjs = require("./utils/WithPromise.mjs");
var _startWaapiAnimationMjs = require("./waapi/start-waapi-animation.mjs");
var _applyGeneratorMjs = require("./waapi/utils/apply-generator.mjs");
/**
 * NativeAnimation implements AnimationPlaybackControls for the browser's Web Animations API.
 */ class NativeAnimation extends (0, _withPromiseMjs.WithPromise) {
    constructor(options){
        super();
        this.finishedTime = null;
        this.isStopped = false;
        /**
         * Tracks a manually-set start time that takes precedence over WAAPI's
         * dynamic startTime. This is cleared when play() or time setter is called,
         * allowing WAAPI to take over timing.
         */ this.manualStartTime = null;
        if (!options) return;
        const { element, name, keyframes, pseudoElement, allowFlatten = false, finalKeyframe, onComplete } = options;
        this.isPseudoElement = Boolean(pseudoElement);
        this.allowFlatten = allowFlatten;
        this.options = options;
        (0, _motionUtils.invariant)(typeof options.type !== "string", `Mini animate() doesn't support "type" as a string.`, "mini-spring");
        const transition = (0, _applyGeneratorMjs.applyGeneratorOptions)(options);
        this.animation = (0, _startWaapiAnimationMjs.startWaapiAnimation)(element, name, keyframes, transition, pseudoElement);
        if (transition.autoplay === false) this.animation.pause();
        this.animation.onfinish = ()=>{
            this.finishedTime = this.time;
            if (!pseudoElement) {
                const keyframe = (0, _getFinalMjs.getFinalKeyframe)(keyframes, this.options, finalKeyframe, this.speed);
                if (this.updateMotionValue) this.updateMotionValue(keyframe);
                /**
                 * If we can, we want to commit the final style as set by the user,
                 * rather than the computed keyframe value supplied by the animation.
                 * We always do this, even when a motion value is present, to prevent
                 * a visual flash in Firefox where the WAAPI animation's fill is removed
                 * during cancel() before the scheduled render can apply the correct value.
                 */ (0, _styleSetMjs.setStyle)(element, name, keyframe);
                this.animation.cancel();
            }
            onComplete?.();
            this.notifyFinished();
        };
    }
    play() {
        if (this.isStopped) return;
        this.manualStartTime = null;
        this.animation.play();
        if (this.state === "finished") this.updateFinished();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.finish?.();
    }
    cancel() {
        try {
            this.animation.cancel();
        } catch (e) {}
    }
    stop() {
        if (this.isStopped) return;
        this.isStopped = true;
        const { state } = this;
        if (state === "idle" || state === "finished") return;
        if (this.updateMotionValue) this.updateMotionValue();
        else this.commitStyles();
        if (!this.isPseudoElement) this.cancel();
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * In this method, we commit styles back to the DOM before cancelling
     * the animation.
     *
     * This is designed to be overridden by NativeAnimationExtended, which
     * will create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to also correctly calculate velocity for any subsequent animation
     * while deferring the commit until the next animation frame.
     */ commitStyles() {
        const element = this.options?.element;
        if (!this.isPseudoElement && element?.isConnected) this.animation.commitStyles?.();
    }
    get duration() {
        const duration = this.animation.effect?.getComputedTiming?.().duration || 0;
        return (0, _motionUtils.millisecondsToSeconds)(Number(duration));
    }
    get iterationDuration() {
        const { delay = 0 } = this.options || {};
        return this.duration + (0, _motionUtils.millisecondsToSeconds)(delay);
    }
    get time() {
        return (0, _motionUtils.millisecondsToSeconds)(Number(this.animation.currentTime) || 0);
    }
    set time(newTime) {
        const wasFinished = this.finishedTime !== null;
        this.manualStartTime = null;
        this.finishedTime = null;
        this.animation.currentTime = (0, _motionUtils.secondsToMilliseconds)(newTime);
        if (wasFinished) this.animation.pause();
    }
    /**
     * The playback speed of the animation.
     * 1 = normal speed, 2 = double speed, 0.5 = half speed.
     */ get speed() {
        return this.animation.playbackRate;
    }
    set speed(newSpeed) {
        // Allow backwards playback after finishing
        if (newSpeed < 0) this.finishedTime = null;
        this.animation.playbackRate = newSpeed;
    }
    get state() {
        return this.finishedTime !== null ? "finished" : this.animation.playState;
    }
    get startTime() {
        return this.manualStartTime ?? Number(this.animation.startTime);
    }
    set startTime(newStartTime) {
        this.manualStartTime = this.animation.startTime = newStartTime;
    }
    /**
     * Attaches a timeline to the animation, for instance the `ScrollTimeline`.
     */ attachTimeline({ timeline, rangeStart, rangeEnd, observe }) {
        if (this.allowFlatten) this.animation.effect?.updateTiming({
            easing: "linear"
        });
        this.animation.onfinish = null;
        if (timeline && (0, _scrollTimelineMjs.supportsScrollTimeline)()) {
            this.animation.timeline = timeline;
            if (rangeStart) this.animation.rangeStart = rangeStart;
            if (rangeEnd) this.animation.rangeEnd = rangeEnd;
            return 0, _motionUtils.noop;
        } else return observe(this);
    }
}

},{"motion-utils":[["invariant","588wx"],["millisecondsToSeconds","dIdtR"],["secondsToMilliseconds","dIdtR"],["noop","1tDyg"]],"../render/dom/style-set.mjs":"lzPnK","../utils/supports/scroll-timeline.mjs":"bbKge","./keyframes/get-final.mjs":"914tK","./utils/WithPromise.mjs":"iiiW5","./waapi/start-waapi-animation.mjs":"kcu7p","./waapi/utils/apply-generator.mjs":"96wQp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lzPnK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setStyle", ()=>setStyle);
var _isCssVarMjs = require("./is-css-var.mjs");
function setStyle(element, name, value) {
    (0, _isCssVarMjs.isCSSVar)(name) ? element.style.setProperty(name, value) : element.style[name] = value;
}

},{"./is-css-var.mjs":"3Amn8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Amn8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isCSSVar", ()=>isCSSVar);
const isCSSVar = (name)=>name.startsWith("--");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bbKge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsScrollTimeline", ()=>supportsScrollTimeline);
parcelHelpers.export(exports, "supportsViewTimeline", ()=>supportsViewTimeline);
var _memoMjs = require("./memo.mjs");
const supportsScrollTimeline = /* @__PURE__ */ (0, _memoMjs.memoSupports)(()=>window.ScrollTimeline !== undefined, "scrollTimeline");
const supportsViewTimeline = /* @__PURE__ */ (0, _memoMjs.memoSupports)(()=>window.ViewTimeline !== undefined, "viewTimeline");

},{"./memo.mjs":"5narn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5narn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoSupports", ()=>memoSupports);
var _motionUtils = require("motion-utils");
var _flagsMjs = require("./flags.mjs");
function memoSupports(callback, supportsFlag) {
    const memoized = (0, _motionUtils.memo)(callback);
    return ()=>(0, _flagsMjs.supportsFlags)[supportsFlag] ?? memoized();
}

},{"motion-utils":"240b7","./flags.mjs":"fqH7Q","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"240b7":[function(require,module,exports,__globalThis) {
/*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memo", ()=>memo);
function memo(callback) {
    let result;
    return ()=>{
        if (result === undefined) result = callback();
        return result;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fqH7Q":[function(require,module,exports,__globalThis) {
/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsFlags", ()=>supportsFlags);
const supportsFlags = {};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"914tK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFinalKeyframe", ()=>getFinalKeyframe);
const isNotNull = (value)=>value !== null;
function getFinalKeyframe(keyframes, { repeat, repeatType = "loop" }, finalKeyframe, speed = 1) {
    const resolvedKeyframes = keyframes.filter(isNotNull);
    const useFirstKeyframe = speed < 0 || repeat && repeatType !== "loop" && repeat % 2 === 1;
    const index = useFirstKeyframe ? 0 : resolvedKeyframes.length - 1;
    return !index || finalKeyframe === undefined ? resolvedKeyframes[index] : finalKeyframe;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iiiW5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WithPromise", ()=>WithPromise);
class WithPromise {
    constructor(){
        this.updateFinished();
    }
    get finished() {
        return this._finished;
    }
    updateFinished() {
        this._finished = new Promise((resolve)=>{
            this.resolve = resolve;
        });
    }
    notifyFinished() {
        this.resolve();
    }
    /**
     * Allows the animation to be awaited.
     *
     * @deprecated Use `finished` instead.
     */ then(onResolve, onReject) {
        return this.finished.then(onResolve, onReject);
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kcu7p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startWaapiAnimation", ()=>startWaapiAnimation);
var _animationCountMjs = require("../../stats/animation-count.mjs");
var _bufferMjs = require("../../stats/buffer.mjs");
var _mapEasingMjs = require("./easing/map-easing.mjs");
function startWaapiAnimation(element, valueName, keyframes, { delay = 0, duration = 300, repeat = 0, repeatType = "loop", ease = "easeOut", times } = {}, pseudoElement) {
    const keyframeOptions = {
        [valueName]: keyframes
    };
    if (times) keyframeOptions.offset = times;
    const easing = (0, _mapEasingMjs.mapEasingToNativeEasing)(ease, duration);
    /**
     * If this is an easing array, apply to keyframes, not animation as a whole
     */ if (Array.isArray(easing)) keyframeOptions.easing = easing;
    if ((0, _bufferMjs.statsBuffer).value) (0, _animationCountMjs.activeAnimations).waapi++;
    const options = {
        delay,
        duration,
        easing: !Array.isArray(easing) ? easing : "linear",
        fill: "both",
        iterations: repeat + 1,
        direction: repeatType === "reverse" ? "alternate" : "normal"
    };
    if (pseudoElement) options.pseudoElement = pseudoElement;
    const animation = element.animate(keyframeOptions, options);
    if ((0, _bufferMjs.statsBuffer).value) animation.finished.finally(()=>{
        (0, _animationCountMjs.activeAnimations).waapi--;
    });
    return animation;
}

},{"../../stats/animation-count.mjs":"lEkpG","../../stats/buffer.mjs":"94Uw8","./easing/map-easing.mjs":"4rOWo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lEkpG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "activeAnimations", ()=>activeAnimations);
const activeAnimations = {
    layout: 0,
    mainThread: 0,
    waapi: 0
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4rOWo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapEasingToNativeEasing", ()=>mapEasingToNativeEasing);
var _motionUtils = require("motion-utils");
var _linearEasingMjs = require("../../../utils/supports/linear-easing.mjs");
var _linearMjs = require("../utils/linear.mjs");
var _cubicBezierMjs = require("./cubic-bezier.mjs");
var _supportedMjs = require("./supported.mjs");
function mapEasingToNativeEasing(easing, duration) {
    if (!easing) return undefined;
    else if (typeof easing === "function") return (0, _linearEasingMjs.supportsLinearEasing)() ? (0, _linearMjs.generateLinearEasing)(easing, duration) : "ease-out";
    else if ((0, _motionUtils.isBezierDefinition)(easing)) return (0, _cubicBezierMjs.cubicBezierAsString)(easing);
    else if (Array.isArray(easing)) return easing.map((segmentEasing)=>mapEasingToNativeEasing(segmentEasing, duration) || (0, _supportedMjs.supportedWaapiEasing).easeOut);
    else return (0, _supportedMjs.supportedWaapiEasing)[easing];
}

},{"motion-utils":"8410g","../../../utils/supports/linear-easing.mjs":"2AnQL","../utils/linear.mjs":"7F3AT","./cubic-bezier.mjs":"TGF1g","./supported.mjs":"fof9P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8410g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBezierDefinition", ()=>isBezierDefinition);
const isBezierDefinition = (easing)=>Array.isArray(easing) && typeof easing[0] === "number";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2AnQL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsLinearEasing", ()=>supportsLinearEasing);
var _memoMjs = require("./memo.mjs");
const supportsLinearEasing = /*@__PURE__*/ (0, _memoMjs.memoSupports)(()=>{
    try {
        document.createElement("div").animate({
            opacity: 0
        }, {
            easing: "linear(0, 1)"
        });
    } catch (e) {
        return false;
    }
    return true;
}, "linearEasing");

},{"./memo.mjs":"5narn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7F3AT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateLinearEasing", ()=>generateLinearEasing);
const generateLinearEasing = (easing, duration, resolution = 10 // as milliseconds
)=>{
    let points = "";
    const numPoints = Math.max(Math.round(duration / resolution), 2);
    for(let i = 0; i < numPoints; i++)points += Math.round(easing(i / (numPoints - 1)) * 10000) / 10000 + ", ";
    return `linear(${points.substring(0, points.length - 2)})`;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"TGF1g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicBezierAsString", ()=>cubicBezierAsString);
const cubicBezierAsString = ([a, b, c, d])=>`cubic-bezier(${a}, ${b}, ${c}, ${d})`;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fof9P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportedWaapiEasing", ()=>supportedWaapiEasing);
var _cubicBezierMjs = require("./cubic-bezier.mjs");
const supportedWaapiEasing = {
    linear: "linear",
    ease: "ease",
    easeIn: "ease-in",
    easeOut: "ease-out",
    easeInOut: "ease-in-out",
    circIn: /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezierAsString)([
        0,
        0.65,
        0.55,
        1
    ]),
    circOut: /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezierAsString)([
        0.55,
        0,
        1,
        0.45
    ]),
    backIn: /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezierAsString)([
        0.31,
        0.01,
        0.66,
        -0.59
    ]),
    backOut: /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezierAsString)([
        0.33,
        1.53,
        0.69,
        0.99
    ])
};

},{"./cubic-bezier.mjs":"TGF1g","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"96wQp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyGeneratorOptions", ()=>applyGeneratorOptions);
var _linearEasingMjs = require("../../../utils/supports/linear-easing.mjs");
var _isGeneratorMjs = require("../../generators/utils/is-generator.mjs");
function applyGeneratorOptions({ type, ...options }) {
    if ((0, _isGeneratorMjs.isGenerator)(type) && (0, _linearEasingMjs.supportsLinearEasing)()) return type.applyToOptions(options);
    else {
        options.duration ?? (options.duration = 300);
        options.ease ?? (options.ease = "easeOut");
    }
    return options;
}

},{"../../../utils/supports/linear-easing.mjs":"2AnQL","../../generators/utils/is-generator.mjs":"fI1UZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fI1UZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isGenerator", ()=>isGenerator);
function isGenerator(type) {
    return typeof type === "function" && "applyToOptions" in type;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2tVvg":[function(require,module,exports,__globalThis) {
/**
 * A list of values that can be hardware-accelerated.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "acceleratedValues", ()=>acceleratedValues);
const acceleratedValues = new Set([
    "opacity",
    "clipPath",
    "filter",
    "transform"
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7uR6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cancelMicrotask", ()=>cancelMicrotask);
parcelHelpers.export(exports, "microtask", ()=>microtask);
var _batcherMjs = require("./batcher.mjs");
const { schedule: microtask, cancel: cancelMicrotask } = /* @__PURE__ */ (0, _batcherMjs.createRenderBatcher)(queueMicrotask, false);

},{"./batcher.mjs":"kAUIQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"74aV8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "time", ()=>time);
var _motionUtils = require("motion-utils");
var _frameMjs = require("./frame.mjs");
let now;
function clearTime() {
    now = undefined;
}
/**
 * An eventloop-synchronous alternative to performance.now().
 *
 * Ensures that time measurements remain consistent within a synchronous context.
 * Usually calling performance.now() twice within the same synchronous context
 * will return different values which isn't useful for animations when we're usually
 * trying to sync animations to the same frame.
 */ const time = {
    now: ()=>{
        if (now === undefined) time.set((0, _frameMjs.frameData).isProcessing || (0, _motionUtils.MotionGlobalConfig).useManualTiming ? (0, _frameMjs.frameData).timestamp : performance.now());
        return now;
    },
    set: (newTime)=>{
        now = newTime;
        queueMicrotask(clearTime);
    }
};

},{"motion-utils":"jQhZ4","./frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5H0uu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAxis", ()=>createAxis);
parcelHelpers.export(exports, "createAxisDelta", ()=>createAxisDelta);
parcelHelpers.export(exports, "createBox", ()=>createBox);
parcelHelpers.export(exports, "createDelta", ()=>createDelta);
const createAxisDelta = ()=>({
        translate: 0,
        scale: 1,
        origin: 0,
        originPoint: 0
    });
const createDelta = ()=>({
        x: createAxisDelta(),
        y: createAxisDelta()
    });
const createAxis = ()=>({
        min: 0,
        max: 0
    });
const createBox = ()=>({
        x: createAxis(),
        y: createAxis()
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hX31g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionValue", ()=>MotionValue);
parcelHelpers.export(exports, "collectMotionValues", ()=>collectMotionValues);
parcelHelpers.export(exports, "motionValue", ()=>motionValue);
var _motionUtils = require("motion-utils");
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
/**
 * Maximum time between the value of two frames, beyond which we
 * assume the velocity has since been 0.
 */ const MAX_VELOCITY_DELTA = 30;
const isFloat = (value)=>{
    return !isNaN(parseFloat(value));
};
const collectMotionValues = {
    current: undefined
};
/**
 * `MotionValue` is used to track the state and velocity of motion values.
 *
 * @public
 */ class MotionValue {
    /**
     * @param init - The initiating value
     * @param config - Optional configuration options
     *
     * -  `transformer`: A function to transform incoming values with.
     */ constructor(init, options = {}){
        /**
         * Tracks whether this value can output a velocity. Currently this is only true
         * if the value is numerical, but we might be able to widen the scope here and support
         * other value types.
         *
         * @internal
         */ this.canTrackVelocity = null;
        /**
         * An object containing a SubscriptionManager for each active event.
         */ this.events = {};
        this.updateAndNotify = (v)=>{
            const currentTime = (0, _syncTimeMjs.time).now();
            /**
             * If we're updating the value during another frame or eventloop
             * than the previous frame, then the we set the previous frame value
             * to current.
             */ if (this.updatedAt !== currentTime) this.setPrevFrameValue();
            this.prev = this.current;
            this.setCurrent(v);
            // Update update subscribers
            if (this.current !== this.prev) {
                this.events.change?.notify(this.current);
                if (this.dependents) for (const dependent of this.dependents)dependent.dirty();
            }
        };
        this.hasAnimated = false;
        this.setCurrent(init);
        this.owner = options.owner;
    }
    setCurrent(current) {
        this.current = current;
        this.updatedAt = (0, _syncTimeMjs.time).now();
        if (this.canTrackVelocity === null && current !== undefined) this.canTrackVelocity = isFloat(this.current);
    }
    setPrevFrameValue(prevFrameValue = this.current) {
        this.prevFrameValue = prevFrameValue;
        this.prevUpdatedAt = this.updatedAt;
    }
    /**
     * Adds a function that will be notified when the `MotionValue` is updated.
     *
     * It returns a function that, when called, will cancel the subscription.
     *
     * When calling `onChange` inside a React component, it should be wrapped with the
     * `useEffect` hook. As it returns an unsubscribe function, this should be returned
     * from the `useEffect` function to ensure you don't add duplicate subscribers..
     *
     * ```jsx
     * export const MyComponent = () => {
     *   const x = useMotionValue(0)
     *   const y = useMotionValue(0)
     *   const opacity = useMotionValue(1)
     *
     *   useEffect(() => {
     *     function updateOpacity() {
     *       const maxXY = Math.max(x.get(), y.get())
     *       const newOpacity = transform(maxXY, [0, 100], [1, 0])
     *       opacity.set(newOpacity)
     *     }
     *
     *     const unsubscribeX = x.on("change", updateOpacity)
     *     const unsubscribeY = y.on("change", updateOpacity)
     *
     *     return () => {
     *       unsubscribeX()
     *       unsubscribeY()
     *     }
     *   }, [])
     *
     *   return <motion.div style={{ x }} />
     * }
     * ```
     *
     * @param subscriber - A function that receives the latest value.
     * @returns A function that, when called, will cancel this subscription.
     *
     * @deprecated
     */ onChange(subscription) {
        return this.on("change", subscription);
    }
    on(eventName, callback) {
        if (!this.events[eventName]) this.events[eventName] = new (0, _motionUtils.SubscriptionManager)();
        const unsubscribe = this.events[eventName].add(callback);
        if (eventName === "change") return ()=>{
            unsubscribe();
            /**
                 * If we have no more change listeners by the start
                 * of the next frame, stop active animations.
                 */ (0, _frameMjs.frame).read(()=>{
                if (!this.events.change.getSize()) this.stop();
            });
        };
        return unsubscribe;
    }
    clearListeners() {
        for(const eventManagers in this.events)this.events[eventManagers].clear();
    }
    /**
     * Attaches a passive effect to the `MotionValue`.
     */ attach(passiveEffect, stopPassiveEffect) {
        this.passiveEffect = passiveEffect;
        this.stopPassiveEffect = stopPassiveEffect;
    }
    /**
     * Sets the state of the `MotionValue`.
     *
     * @remarks
     *
     * ```jsx
     * const x = useMotionValue(0)
     * x.set(10)
     * ```
     *
     * @param latest - Latest value to set.
     * @param render - Whether to notify render subscribers. Defaults to `true`
     *
     * @public
     */ set(v) {
        if (!this.passiveEffect) this.updateAndNotify(v);
        else this.passiveEffect(v, this.updateAndNotify);
    }
    setWithVelocity(prev, current, delta) {
        this.set(current);
        this.prev = undefined;
        this.prevFrameValue = prev;
        this.prevUpdatedAt = this.updatedAt - delta;
    }
    /**
     * Set the state of the `MotionValue`, stopping any active animations,
     * effects, and resets velocity to `0`.
     */ jump(v, endAnimation = true) {
        this.updateAndNotify(v);
        this.prev = v;
        this.prevUpdatedAt = this.prevFrameValue = undefined;
        endAnimation && this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
    dirty() {
        this.events.change?.notify(this.current);
    }
    addDependent(dependent) {
        if (!this.dependents) this.dependents = new Set();
        this.dependents.add(dependent);
    }
    removeDependent(dependent) {
        if (this.dependents) this.dependents.delete(dependent);
    }
    /**
     * Returns the latest state of `MotionValue`
     *
     * @returns - The latest state of `MotionValue`
     *
     * @public
     */ get() {
        if (collectMotionValues.current) collectMotionValues.current.push(this);
        return this.current;
    }
    /**
     * @public
     */ getPrevious() {
        return this.prev;
    }
    /**
     * Returns the latest velocity of `MotionValue`
     *
     * @returns - The latest velocity of `MotionValue`. Returns `0` if the state is non-numerical.
     *
     * @public
     */ getVelocity() {
        const currentTime = (0, _syncTimeMjs.time).now();
        if (!this.canTrackVelocity || this.prevFrameValue === undefined || currentTime - this.updatedAt > MAX_VELOCITY_DELTA) return 0;
        const delta = Math.min(this.updatedAt - this.prevUpdatedAt, MAX_VELOCITY_DELTA);
        // Casts because of parseFloat's poor typing
        return (0, _motionUtils.velocityPerSecond)(parseFloat(this.current) - parseFloat(this.prevFrameValue), delta);
    }
    /**
     * Registers a new animation to control this `MotionValue`. Only one
     * animation can drive a `MotionValue` at one time.
     *
     * ```jsx
     * value.start()
     * ```
     *
     * @param animation - A function that starts the provided animation
     */ start(startAnimation) {
        this.stop();
        return new Promise((resolve)=>{
            this.hasAnimated = true;
            this.animation = startAnimation(resolve);
            if (this.events.animationStart) this.events.animationStart.notify();
        }).then(()=>{
            if (this.events.animationComplete) this.events.animationComplete.notify();
            this.clearAnimation();
        });
    }
    /**
     * Stop the currently active animation.
     *
     * @public
     */ stop() {
        if (this.animation) {
            this.animation.stop();
            if (this.events.animationCancel) this.events.animationCancel.notify();
        }
        this.clearAnimation();
    }
    /**
     * Returns `true` if this value is currently animating.
     *
     * @public
     */ isAnimating() {
        return !!this.animation;
    }
    clearAnimation() {
        delete this.animation;
    }
    /**
     * Destroy and clean up subscribers to this `MotionValue`.
     *
     * The `MotionValue` hooks like `useMotionValue` and `useTransform` automatically
     * handle the lifecycle of the returned `MotionValue`, so this method is only necessary if you've manually
     * created a `MotionValue` via the `motionValue` function.
     *
     * @public
     */ destroy() {
        this.dependents?.clear();
        this.events.destroy?.notify();
        this.clearListeners();
        this.stop();
        if (this.stopPassiveEffect) this.stopPassiveEffect();
    }
}
function motionValue(init, options) {
    return new MotionValue(init, options);
}

},{"motion-utils":[["SubscriptionManager","8tNj4"],["velocityPerSecond","drsSU"]],"../frameloop/sync-time.mjs":"74aV8","../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"drsSU":[function(require,module,exports,__globalThis) {
/*
  Convert velocity into velocity per second

  @param [number]: Unit per frame
  @param [number]: Frame duration in ms
*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "velocityPerSecond", ()=>velocityPerSecond);
function velocityPerSecond(velocity, frameDuration) {
    return frameDuration ? velocity * (1000 / frameDuration) : 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iv21g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findValueType", ()=>findValueType);
var _indexMjs = require("../color/index.mjs");
var _indexMjs1 = require("../complex/index.mjs");
var _dimensionsMjs = require("../dimensions.mjs");
var _testMjs = require("../test.mjs");
/**
 * A list of all ValueTypes
 */ const valueTypes = [
    ...(0, _dimensionsMjs.dimensionValueTypes),
    (0, _indexMjs.color),
    (0, _indexMjs1.complex)
];
/**
 * Tests a value against the list of ValueTypes
 */ const findValueType = (v)=>valueTypes.find((0, _testMjs.testValueType)(v));

},{"../color/index.mjs":"5J712","../complex/index.mjs":"aBOw1","../dimensions.mjs":"hyZyT","../test.mjs":"bY55t","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4d03k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "visualElementStore", ()=>visualElementStore);
const visualElementStore = new WeakMap();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"932u2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isControllingVariants", ()=>isControllingVariants);
parcelHelpers.export(exports, "isVariantNode", ()=>isVariantNode);
var _isAnimationControlsMjs = require("./is-animation-controls.mjs");
var _isVariantLabelMjs = require("./is-variant-label.mjs");
var _variantPropsMjs = require("./variant-props.mjs");
function isControllingVariants(props) {
    return (0, _isAnimationControlsMjs.isAnimationControls)(props.animate) || (0, _variantPropsMjs.variantProps).some((name)=>(0, _isVariantLabelMjs.isVariantLabel)(props[name]));
}
function isVariantNode(props) {
    return Boolean(isControllingVariants(props) || props.variants);
}

},{"./is-animation-controls.mjs":"eZBfs","./is-variant-label.mjs":"9bqH5","./variant-props.mjs":"8WhrK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eZBfs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnimationControls", ()=>isAnimationControls);
function isAnimationControls(v) {
    return v !== null && typeof v === "object" && typeof v.start === "function";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9bqH5":[function(require,module,exports,__globalThis) {
/**
 * Decides if the supplied variable is variant label
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isVariantLabel", ()=>isVariantLabel);
function isVariantLabel(v) {
    return typeof v === "string" || Array.isArray(v);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8WhrK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "variantPriorityOrder", ()=>variantPriorityOrder);
parcelHelpers.export(exports, "variantProps", ()=>variantProps);
const variantPriorityOrder = [
    "animate",
    "whileInView",
    "whileFocus",
    "whileHover",
    "whileTap",
    "whileDrag",
    "exit"
];
const variantProps = [
    "initial",
    ...variantPriorityOrder
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dMLgg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateMotionValuesFromProps", ()=>updateMotionValuesFromProps);
var _indexMjs = require("../../value/index.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
/**
 * Updates motion values from props changes.
 * Uses `any` type for element to avoid circular dependencies with VisualElement.
 */ function updateMotionValuesFromProps(element, next, prev) {
    for(const key in next){
        const nextValue = next[key];
        const prevValue = prev[key];
        if ((0, _isMotionValueMjs.isMotionValue)(nextValue)) /**
             * If this is a motion value found in props or style, we want to add it
             * to our visual element's motion value map.
             */ element.addValue(key, nextValue);
        else if ((0, _isMotionValueMjs.isMotionValue)(prevValue)) /**
             * If we're swapping from a motion value to a static value,
             * create a new motion value from that
             */ element.addValue(key, (0, _indexMjs.motionValue)(nextValue, {
            owner: element
        }));
        else if (prevValue !== nextValue) {
            /**
             * If this is a flat value that has changed, update the motion value
             * or create one if it doesn't exist. We only want to do this if we're
             * not handling the value with our animation state.
             */ if (element.hasValue(key)) {
                const existingValue = element.getValue(key);
                if (existingValue.liveStyle === true) existingValue.jump(nextValue);
                else if (!existingValue.hasAnimated) existingValue.set(nextValue);
            } else {
                const latestValue = element.getStaticValue(key);
                element.addValue(key, (0, _indexMjs.motionValue)(latestValue !== undefined ? latestValue : nextValue, {
                    owner: element
                }));
            }
        }
    }
    // Handle removed values
    for(const key in prev)if (next[key] === undefined) element.removeValue(key);
    return next;
}

},{"../../value/index.mjs":"hX31g","../../value/utils/is-motion-value.mjs":"fKDJz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jII2O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasReducedMotionListener", ()=>(0, _stateMjs.hasReducedMotionListener));
parcelHelpers.export(exports, "initPrefersReducedMotion", ()=>initPrefersReducedMotion);
parcelHelpers.export(exports, "prefersReducedMotion", ()=>(0, _stateMjs.prefersReducedMotion));
var _stateMjs = require("./state.mjs");
const isBrowser = typeof window !== "undefined";
function initPrefersReducedMotion() {
    (0, _stateMjs.hasReducedMotionListener).current = true;
    if (!isBrowser) return;
    if (window.matchMedia) {
        const motionMediaQuery = window.matchMedia("(prefers-reduced-motion)");
        const setReducedMotionPreferences = ()=>(0, _stateMjs.prefersReducedMotion).current = motionMediaQuery.matches;
        motionMediaQuery.addEventListener("change", setReducedMotionPreferences);
        setReducedMotionPreferences();
    } else (0, _stateMjs.prefersReducedMotion).current = false;
}

},{"./state.mjs":"2VFG9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2VFG9":[function(require,module,exports,__globalThis) {
// Does this device prefer reduced motion? Returns `null` server-side.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasReducedMotionListener", ()=>hasReducedMotionListener);
parcelHelpers.export(exports, "prefersReducedMotion", ()=>prefersReducedMotion);
const prefersReducedMotion = {
    current: null
};
const hasReducedMotionListener = {
    current: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fFvtX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveVariantFromProps", ()=>resolveVariantFromProps);
function getValueState(visualElement) {
    const state = [
        {},
        {}
    ];
    visualElement?.values.forEach((value, key)=>{
        state[0][key] = value.get();
        state[1][key] = value.getVelocity();
    });
    return state;
}
function resolveVariantFromProps(props, definition, custom, visualElement) {
    /**
     * If the variant definition is a function, resolve.
     */ if (typeof definition === "function") {
        const [current, velocity] = getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    /**
     * If the variant definition is a variant label, or
     * the function returned a variant label, resolve.
     */ if (typeof definition === "string") definition = props.variants && props.variants[definition];
    /**
     * At this point we've resolved both functions and variant labels,
     * but the resolved variant label might itself have been a function.
     * If so, resolve. This can only have returned a valid target object.
     */ if (typeof definition === "function") {
        const [current, velocity] = getValueState(visualElement);
        definition = definition(custom !== undefined ? custom : props.custom, current, velocity);
    }
    return definition;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e1GuX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildHTMLStyles", ()=>buildHTMLStyles);
var _getAsTypeMjs = require("../../../value/types/utils/get-as-type.mjs");
var _numberMjs = require("../../../value/types/maps/number.mjs");
var _keysTransformMjs = require("../../utils/keys-transform.mjs");
var _isCssVariableMjs = require("../../../animation/utils/is-css-variable.mjs");
var _buildTransformMjs = require("./build-transform.mjs");
function buildHTMLStyles(state, latestValues, transformTemplate) {
    const { style, vars, transformOrigin } = state;
    // Track whether we encounter any transform or transformOrigin values.
    let hasTransform = false;
    let hasTransformOrigin = false;
    /**
     * Loop over all our latest animated values and decide whether to handle them
     * as a style or CSS variable.
     *
     * Transforms and transform origins are kept separately for further processing.
     */ for(const key in latestValues){
        const value = latestValues[key];
        if ((0, _keysTransformMjs.transformProps).has(key)) {
            // If this is a transform, flag to enable further transform processing
            hasTransform = true;
            continue;
        } else if ((0, _isCssVariableMjs.isCSSVariableName)(key)) {
            vars[key] = value;
            continue;
        } else {
            // Convert the value to its default value type, ie 0 -> "0px"
            const valueAsType = (0, _getAsTypeMjs.getValueAsType)(value, (0, _numberMjs.numberValueTypes)[key]);
            if (key.startsWith("origin")) {
                // If this is a transform origin, flag and enable further transform-origin processing
                hasTransformOrigin = true;
                transformOrigin[key] = valueAsType;
            } else style[key] = valueAsType;
        }
    }
    if (!latestValues.transform) {
        if (hasTransform || transformTemplate) style.transform = (0, _buildTransformMjs.buildTransform)(latestValues, state.transform, transformTemplate);
        else if (style.transform) /**
             * If we have previously created a transform but currently don't have any,
             * reset transform style to none.
             */ style.transform = "none";
    }
    /**
     * Build a transformOrigin style. Uses the same defaults as the browser for
     * undefined origins.
     */ if (hasTransformOrigin) {
        const { originX = "50%", originY = "50%", originZ = 0 } = transformOrigin;
        style.transformOrigin = `${originX} ${originY} ${originZ}`;
    }
}

},{"../../../value/types/utils/get-as-type.mjs":"5raY2","../../../value/types/maps/number.mjs":"jehqS","../../utils/keys-transform.mjs":"bJbLV","../../../animation/utils/is-css-variable.mjs":"jfZBC","./build-transform.mjs":"dq3X4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5raY2":[function(require,module,exports,__globalThis) {
/**
 * Provided a value and a ValueType, returns the value as that value type.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueAsType", ()=>getValueAsType);
const getValueAsType = (value, type)=>{
    return type && typeof value === "number" ? type.transform(value) : value;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dq3X4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildTransform", ()=>buildTransform);
var _getAsTypeMjs = require("../../../value/types/utils/get-as-type.mjs");
var _numberMjs = require("../../../value/types/maps/number.mjs");
var _keysTransformMjs = require("../../utils/keys-transform.mjs");
const translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
const numTransforms = (0, _keysTransformMjs.transformPropOrder).length;
/**
 * Build a CSS transform style from individual x/y/scale etc properties.
 *
 * This outputs with a default order of transforms/scales/rotations, this can be customised by
 * providing a transformTemplate function.
 */ function buildTransform(latestValues, transform, transformTemplate) {
    // The transform string we're going to build into.
    let transformString = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < numTransforms; i++){
        const key = (0, _keysTransformMjs.transformPropOrder)[i];
        const value = latestValues[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else {
            const parsed = parseFloat(value);
            valueIsDefault = key.startsWith("scale") ? parsed === 1 : parsed === 0;
        }
        if (!valueIsDefault || transformTemplate) {
            const valueAsType = (0, _getAsTypeMjs.getValueAsType)(value, (0, _numberMjs.numberValueTypes)[key]);
            if (!valueIsDefault) {
                transformIsDefault = false;
                const transformName = translateAlias[key] || key;
                transformString += `${transformName}(${valueAsType}) `;
            }
            if (transformTemplate) transform[key] = valueAsType;
        }
    }
    transformString = transformString.trim();
    // If we have a custom `transform` template, pass our transform values and
    // generated transformString to that before returning
    if (transformTemplate) transformString = transformTemplate(transform, transformIsDefault ? "" : transformString);
    else if (transformIsDefault) transformString = "none";
    return transformString;
}

},{"../../../value/types/utils/get-as-type.mjs":"5raY2","../../../value/types/maps/number.mjs":"jehqS","../../utils/keys-transform.mjs":"bJbLV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hUnZX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderHTML", ()=>renderHTML);
function renderHTML(element, { style, vars }, styleProp, projection) {
    const elementStyle = element.style;
    let key;
    for(key in style)// CSSStyleDeclaration has [index: number]: string; in the types, so we use that as key type.
    elementStyle[key] = style[key];
    // Write projection styles directly to element style
    projection?.applyProjectionStyles(elementStyle, styleProp);
    for(key in vars)// Loop over any CSS variables and assign those.
    // They can only be assigned using `setProperty`.
    elementStyle.setProperty(key, vars[key]);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"504Ps":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrapeMotionValuesFromProps", ()=>scrapeMotionValuesFromProps);
var _isMotionValueMjs = require("../../../value/utils/is-motion-value.mjs");
var _isForcedMotionValueMjs = require("../../utils/is-forced-motion-value.mjs");
function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    const style = props.style;
    const prevStyle = prevProps?.style;
    const newValues = {};
    if (!style) return newValues;
    for(const key in style)if ((0, _isMotionValueMjs.isMotionValue)(style[key]) || prevStyle && (0, _isMotionValueMjs.isMotionValue)(prevStyle[key]) || (0, _isForcedMotionValueMjs.isForcedMotionValue)(key, props) || visualElement?.getValue(key)?.liveStyle !== undefined) newValues[key] = style[key];
    return newValues;
}

},{"../../../value/utils/is-motion-value.mjs":"fKDJz","../../utils/is-forced-motion-value.mjs":"3YH1U","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3YH1U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addScaleCorrector", ()=>(0, _scaleCorrectionMjs.addScaleCorrector));
parcelHelpers.export(exports, "isForcedMotionValue", ()=>isForcedMotionValue);
parcelHelpers.export(exports, "scaleCorrectors", ()=>(0, _scaleCorrectionMjs.scaleCorrectors));
var _keysTransformMjs = require("./keys-transform.mjs");
var _scaleCorrectionMjs = require("../../projection/styles/scale-correction.mjs");
function isForcedMotionValue(key, { layout, layoutId }) {
    return (0, _keysTransformMjs.transformProps).has(key) || key.startsWith("origin") || (layout || layoutId !== undefined) && (!!(0, _scaleCorrectionMjs.scaleCorrectors)[key] || key === "opacity");
}

},{"./keys-transform.mjs":"bJbLV","../../projection/styles/scale-correction.mjs":"4154g","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4154g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addScaleCorrector", ()=>addScaleCorrector);
parcelHelpers.export(exports, "scaleCorrectors", ()=>scaleCorrectors);
var _isCssVariableMjs = require("../../animation/utils/is-css-variable.mjs");
var _scaleBorderRadiusMjs = require("./scale-border-radius.mjs");
var _scaleBoxShadowMjs = require("./scale-box-shadow.mjs");
const scaleCorrectors = {
    borderRadius: {
        ...(0, _scaleBorderRadiusMjs.correctBorderRadius),
        applyTo: [
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomLeftRadius",
            "borderBottomRightRadius"
        ]
    },
    borderTopLeftRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    borderTopRightRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    borderBottomLeftRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    borderBottomRightRadius: (0, _scaleBorderRadiusMjs.correctBorderRadius),
    boxShadow: (0, _scaleBoxShadowMjs.correctBoxShadow)
};
function addScaleCorrector(correctors) {
    for(const key in correctors){
        scaleCorrectors[key] = correctors[key];
        if ((0, _isCssVariableMjs.isCSSVariableName)(key)) scaleCorrectors[key].isCSSVariable = true;
    }
}

},{"../../animation/utils/is-css-variable.mjs":"jfZBC","./scale-border-radius.mjs":"4RSUY","./scale-box-shadow.mjs":"f97Mj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4RSUY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "correctBorderRadius", ()=>correctBorderRadius);
parcelHelpers.export(exports, "pixelsToPercent", ()=>pixelsToPercent);
var _unitsMjs = require("../../value/types/numbers/units.mjs");
function pixelsToPercent(pixels, axis) {
    if (axis.max === axis.min) return 0;
    return pixels / (axis.max - axis.min) * 100;
}
/**
 * We always correct borderRadius as a percentage rather than pixels to reduce paints.
 * For example, if you are projecting a box that is 100px wide with a 10px borderRadius
 * into a box that is 200px wide with a 20px borderRadius, that is actually a 10%
 * borderRadius in both states. If we animate between the two in pixels that will trigger
 * a paint each time. If we animate between the two in percentage we'll avoid a paint.
 */ const correctBorderRadius = {
    correct: (latest, node)=>{
        if (!node.target) return latest;
        /**
         * If latest is a string, if it's a percentage we can return immediately as it's
         * going to be stretched appropriately. Otherwise, if it's a pixel, convert it to a number.
         */ if (typeof latest === "string") {
            if ((0, _unitsMjs.px).test(latest)) latest = parseFloat(latest);
            else return latest;
        }
        /**
         * If latest is a number, it's a pixel value. We use the current viewportBox to calculate that
         * pixel value as a percentage of each axis
         */ const x = pixelsToPercent(latest, node.target.x);
        const y = pixelsToPercent(latest, node.target.y);
        return `${x}% ${y}%`;
    }
};

},{"../../value/types/numbers/units.mjs":"aXLZR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f97Mj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "correctBoxShadow", ()=>correctBoxShadow);
var _indexMjs = require("../../value/types/complex/index.mjs");
var _numberMjs = require("../../utils/mix/number.mjs");
const correctBoxShadow = {
    correct: (latest, { treeScale, projectionDelta })=>{
        const original = latest;
        const shadow = (0, _indexMjs.complex).parse(latest);
        // TODO: Doesn't support multiple shadows
        if (shadow.length > 5) return original;
        const template = (0, _indexMjs.complex).createTransformer(latest);
        const offset = typeof shadow[0] !== "number" ? 1 : 0;
        // Calculate the overall context scale
        const xScale = projectionDelta.x.scale * treeScale.x;
        const yScale = projectionDelta.y.scale * treeScale.y;
        shadow[0 + offset] /= xScale;
        shadow[1 + offset] /= yScale;
        /**
         * Ideally we'd correct x and y scales individually, but because blur and
         * spread apply to both we have to take a scale average and apply that instead.
         * We could potentially improve the outcome of this by incorporating the ratio between
         * the two scales.
         */ const averageScale = (0, _numberMjs.mixNumber)(xScale, yScale, 0.5);
        // Blur
        if (typeof shadow[2 + offset] === "number") shadow[2 + offset] /= averageScale;
        // Spread
        if (typeof shadow[3 + offset] === "number") shadow[3 + offset] /= averageScale;
        return template(shadow);
    }
};

},{"../../value/types/complex/index.mjs":"aBOw1","../../utils/mix/number.mjs":"91GSx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"id072":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SVGVisualElement", ()=>SVGVisualElement);
var _keysTransformMjs = require("../utils/keys-transform.mjs");
var _defaultsMjs = require("../../value/types/maps/defaults.mjs");
var _modelsMjs = require("../../projection/geometry/models.mjs");
var _domvisualElementMjs = require("../dom/DOMVisualElement.mjs");
var _camelToDashMjs = require("../dom/utils/camel-to-dash.mjs");
var _buildAttrsMjs = require("./utils/build-attrs.mjs");
var _camelCaseAttrsMjs = require("./utils/camel-case-attrs.mjs");
var _isSvgTagMjs = require("./utils/is-svg-tag.mjs");
var _renderMjs = require("./utils/render.mjs");
var _scrapeMotionValuesMjs = require("./utils/scrape-motion-values.mjs");
class SVGVisualElement extends (0, _domvisualElementMjs.DOMVisualElement) {
    constructor(){
        super(...arguments);
        this.type = "svg";
        this.isSVGTag = false;
        this.measureInstanceViewportBox = (0, _modelsMjs.createBox);
    }
    getBaseTargetFromProps(props, key) {
        return props[key];
    }
    readValueFromInstance(instance, key) {
        if ((0, _keysTransformMjs.transformProps).has(key)) {
            const defaultType = (0, _defaultsMjs.getDefaultValueType)(key);
            return defaultType ? defaultType.default || 0 : 0;
        }
        key = !(0, _camelCaseAttrsMjs.camelCaseAttributes).has(key) ? (0, _camelToDashMjs.camelToDash)(key) : key;
        return instance.getAttribute(key);
    }
    scrapeMotionValuesFromProps(props, prevProps, visualElement) {
        return (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    }
    build(renderState, latestValues, props) {
        (0, _buildAttrsMjs.buildSVGAttrs)(renderState, latestValues, this.isSVGTag, props.transformTemplate, props.style);
    }
    renderInstance(instance, renderState, styleProp, projection) {
        (0, _renderMjs.renderSVG)(instance, renderState, styleProp, projection);
    }
    mount(instance) {
        this.isSVGTag = (0, _isSvgTagMjs.isSVGTag)(instance.tagName);
        super.mount(instance);
    }
}

},{"../utils/keys-transform.mjs":"bJbLV","../../value/types/maps/defaults.mjs":"gMxw9","../../projection/geometry/models.mjs":"5H0uu","../dom/DOMVisualElement.mjs":"cmuh9","../dom/utils/camel-to-dash.mjs":"9nVP8","./utils/build-attrs.mjs":"8wKO9","./utils/camel-case-attrs.mjs":"kf3o7","./utils/is-svg-tag.mjs":"cROGR","./utils/render.mjs":"6C8Mu","./utils/scrape-motion-values.mjs":"iWJKc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9nVP8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "camelToDash", ()=>camelToDash);
function camelToDash(str) {
    return str.replace(/([A-Z])/g, (match)=>`-${match.toLowerCase()}`);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8wKO9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildSVGAttrs", ()=>buildSVGAttrs);
var _buildStylesMjs = require("../../html/utils/build-styles.mjs");
var _pathMjs = require("./path.mjs");
/**
 * CSS Motion Path properties that should remain as CSS styles on SVG elements.
 */ const cssMotionPathProperties = [
    "offsetDistance",
    "offsetPath",
    "offsetRotate",
    "offsetAnchor"
];
/**
 * Build SVG visual attributes, like cx and style.transform
 */ function buildSVGAttrs(state, { attrX, attrY, attrScale, pathLength, pathSpacing = 1, pathOffset = 0, // This is object creation, which we try to avoid per-frame.
...latest }, isSVGTag, transformTemplate, styleProp) {
    (0, _buildStylesMjs.buildHTMLStyles)(state, latest, transformTemplate);
    /**
     * For svg tags we just want to make sure viewBox is animatable and treat all the styles
     * as normal HTML tags.
     */ if (isSVGTag) {
        if (state.style.viewBox) state.attrs.viewBox = state.style.viewBox;
        return;
    }
    state.attrs = state.style;
    state.style = {};
    const { attrs, style } = state;
    /**
     * However, we apply transforms as CSS transforms.
     * So if we detect a transform, transformOrigin we take it from attrs and copy it into style.
     */ if (attrs.transform) {
        style.transform = attrs.transform;
        delete attrs.transform;
    }
    if (style.transform || attrs.transformOrigin) {
        style.transformOrigin = attrs.transformOrigin ?? "50% 50%";
        delete attrs.transformOrigin;
    }
    if (style.transform) {
        /**
         * SVG's element transform-origin uses its own median as a reference.
         * Therefore, transformBox becomes a fill-box
         */ style.transformBox = styleProp?.transformBox ?? "fill-box";
        delete attrs.transformBox;
    }
    for (const key of cssMotionPathProperties)if (attrs[key] !== undefined) {
        style[key] = attrs[key];
        delete attrs[key];
    }
    // Render attrX/attrY/attrScale as attributes
    if (attrX !== undefined) attrs.x = attrX;
    if (attrY !== undefined) attrs.y = attrY;
    if (attrScale !== undefined) attrs.scale = attrScale;
    // Build SVG path if one has been defined
    if (pathLength !== undefined) (0, _pathMjs.buildSVGPath)(attrs, pathLength, pathSpacing, pathOffset, false);
}

},{"../../html/utils/build-styles.mjs":"e1GuX","./path.mjs":"h0syE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h0syE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildSVGPath", ()=>buildSVGPath);
const dashKeys = {
    offset: "stroke-dashoffset",
    array: "stroke-dasharray"
};
const camelKeys = {
    offset: "strokeDashoffset",
    array: "strokeDasharray"
};
/**
 * Build SVG path properties. Uses the path's measured length to convert
 * our custom pathLength, pathSpacing and pathOffset into stroke-dashoffset
 * and stroke-dasharray attributes.
 *
 * This function is mutative to reduce per-frame GC.
 *
 * Note: We use unitless values for stroke-dasharray and stroke-dashoffset
 * because Safari incorrectly scales px values when the page is zoomed.
 */ function buildSVGPath(attrs, length, spacing = 1, offset = 0, useDashCase = true) {
    // Normalise path length by setting SVG attribute pathLength to 1
    attrs.pathLength = 1;
    // We use dash case when setting attributes directly to the DOM node and camel case
    // when defining props on a React component.
    const keys = useDashCase ? dashKeys : camelKeys;
    // Build the dash offset (unitless to avoid Safari zoom bug)
    attrs[keys.offset] = `${-offset}`;
    // Build the dash array (unitless to avoid Safari zoom bug)
    attrs[keys.array] = `${length} ${spacing}`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kf3o7":[function(require,module,exports,__globalThis) {
/**
 * A set of attribute names that are always read/written as camel case.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "camelCaseAttributes", ()=>camelCaseAttributes);
const camelCaseAttributes = new Set([
    "baseFrequency",
    "diffuseConstant",
    "kernelMatrix",
    "kernelUnitLength",
    "keySplines",
    "keyTimes",
    "limitingConeAngle",
    "markerHeight",
    "markerWidth",
    "numOctaves",
    "targetX",
    "targetY",
    "surfaceScale",
    "specularConstant",
    "specularExponent",
    "stdDeviation",
    "tableValues",
    "viewBox",
    "gradientTransform",
    "pathLength",
    "startOffset",
    "textLength",
    "lengthAdjust"
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cROGR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGTag", ()=>isSVGTag);
const isSVGTag = (tag)=>typeof tag === "string" && tag.toLowerCase() === "svg";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6C8Mu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderSVG", ()=>renderSVG);
var _camelToDashMjs = require("../../dom/utils/camel-to-dash.mjs");
var _renderMjs = require("../../html/utils/render.mjs");
var _camelCaseAttrsMjs = require("./camel-case-attrs.mjs");
function renderSVG(element, renderState, _styleProp, projection) {
    (0, _renderMjs.renderHTML)(element, renderState, undefined, projection);
    for(const key in renderState.attrs)element.setAttribute(!(0, _camelCaseAttrsMjs.camelCaseAttributes).has(key) ? (0, _camelToDashMjs.camelToDash)(key) : key, renderState.attrs[key]);
}

},{"../../dom/utils/camel-to-dash.mjs":"9nVP8","../../html/utils/render.mjs":"hUnZX","./camel-case-attrs.mjs":"kf3o7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iWJKc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "scrapeMotionValuesFromProps", ()=>scrapeMotionValuesFromProps);
var _isMotionValueMjs = require("../../../value/utils/is-motion-value.mjs");
var _keysTransformMjs = require("../../utils/keys-transform.mjs");
var _scrapeMotionValuesMjs = require("../../html/utils/scrape-motion-values.mjs");
function scrapeMotionValuesFromProps(props, prevProps, visualElement) {
    const newValues = (0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps)(props, prevProps, visualElement);
    for(const key in props)if ((0, _isMotionValueMjs.isMotionValue)(props[key]) || (0, _isMotionValueMjs.isMotionValue)(prevProps[key])) {
        const targetKey = (0, _keysTransformMjs.transformPropOrder).indexOf(key) !== -1 ? "attr" + key.charAt(0).toUpperCase() + key.substring(1) : key;
        newValues[targetKey] = props[key];
    }
    return newValues;
}

},{"../../../value/utils/is-motion-value.mjs":"fKDJz","../../utils/keys-transform.mjs":"bJbLV","../../html/utils/scrape-motion-values.mjs":"504Ps","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"852Y7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGComponent", ()=>isSVGComponent);
var _lowercaseElementsMjs = require("../../svg/lowercase-elements.mjs");
function isSVGComponent(Component) {
    if (/**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */ typeof Component !== "string" || /**
         * If it contains a dash, the element is a custom HTML webcomponent.
         */ Component.includes("-")) return false;
    else if (/**
     * If it's in our list of lowercase SVG tags, it's an SVG component
     */ (0, _lowercaseElementsMjs.lowercaseSVGElements).indexOf(Component) > -1 || /**
         * If it contains a capital letter, it's an SVG component
         */ /[A-Z]/u.test(Component)) return true;
    return false;
}

},{"../../svg/lowercase-elements.mjs":"kUGgZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kUGgZ":[function(require,module,exports,__globalThis) {
/**
 * We keep these listed separately as we use the lowercase tag names as part
 * of the runtime bundle to detect SVG components
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lowercaseSVGElements", ()=>lowercaseSVGElements);
const lowercaseSVGElements = [
    "animate",
    "circle",
    "defs",
    "desc",
    "ellipse",
    "g",
    "image",
    "line",
    "filter",
    "marker",
    "mask",
    "metadata",
    "path",
    "pattern",
    "polygon",
    "polyline",
    "rect",
    "stop",
    "switch",
    "symbol",
    "svg",
    "text",
    "tspan",
    "use",
    "view"
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"etSNQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMotionProxy", ()=>createMotionProxy);
var _motionUtils = require("motion-utils");
var _indexMjs = require("../../motion/index.mjs");
function createMotionProxy(preloadedFeatures, createVisualElement) {
    if (typeof Proxy === "undefined") return 0, _indexMjs.createMotionComponent;
    /**
     * A cache of generated `motion` components, e.g `motion.div`, `motion.input` etc.
     * Rather than generating them anew every render.
     */ const componentCache = new Map();
    const factory = (Component, options)=>{
        return (0, _indexMjs.createMotionComponent)(Component, options, preloadedFeatures, createVisualElement);
    };
    /**
     * Support for deprecated`motion(Component)` pattern
     */ const deprecatedFactoryFunction = (Component, options)=>{
        return factory(Component, options);
    };
    return new Proxy(deprecatedFactoryFunction, {
        /**
         * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
         * The prop name is passed through as `key` and we can use that to generate a `motion`
         * DOM component with that name.
         */ get: (_target, key)=>{
            if (key === "create") return factory;
            /**
             * If this element doesn't exist in the component cache, create it and cache.
             */ if (!componentCache.has(key)) componentCache.set(key, (0, _indexMjs.createMotionComponent)(key, undefined, preloadedFeatures, createVisualElement));
            return componentCache.get(key);
        }
    });
}

},{"motion-utils":"1UaYR","../../motion/index.mjs":"1OKFF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1UaYR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addUniqueItem", ()=>(0, _arrayMjs.addUniqueItem));
parcelHelpers.export(exports, "moveItem", ()=>(0, _arrayMjs.moveItem));
parcelHelpers.export(exports, "removeItem", ()=>(0, _arrayMjs.removeItem));
parcelHelpers.export(exports, "clamp", ()=>(0, _clampMjs.clamp));
parcelHelpers.export(exports, "invariant", ()=>(0, _errorsMjs.invariant));
parcelHelpers.export(exports, "warning", ()=>(0, _errorsMjs.warning));
parcelHelpers.export(exports, "MotionGlobalConfig", ()=>(0, _globalConfigMjs.MotionGlobalConfig));
parcelHelpers.export(exports, "isNumericalString", ()=>(0, _isNumericalStringMjs.isNumericalString));
parcelHelpers.export(exports, "isObject", ()=>(0, _isObjectMjs.isObject));
parcelHelpers.export(exports, "isZeroValueString", ()=>(0, _isZeroValueStringMjs.isZeroValueString));
parcelHelpers.export(exports, "memo", ()=>(0, _memoMjs.memo));
parcelHelpers.export(exports, "noop", ()=>(0, _noopMjs.noop));
parcelHelpers.export(exports, "pipe", ()=>(0, _pipeMjs.pipe));
parcelHelpers.export(exports, "progress", ()=>(0, _progressMjs.progress));
parcelHelpers.export(exports, "SubscriptionManager", ()=>(0, _subscriptionManagerMjs.SubscriptionManager));
parcelHelpers.export(exports, "millisecondsToSeconds", ()=>(0, _timeConversionMjs.millisecondsToSeconds));
parcelHelpers.export(exports, "secondsToMilliseconds", ()=>(0, _timeConversionMjs.secondsToMilliseconds));
parcelHelpers.export(exports, "velocityPerSecond", ()=>(0, _velocityPerSecondMjs.velocityPerSecond));
parcelHelpers.export(exports, "hasWarned", ()=>(0, _warnOnceMjs.hasWarned));
parcelHelpers.export(exports, "warnOnce", ()=>(0, _warnOnceMjs.warnOnce));
parcelHelpers.export(exports, "wrap", ()=>(0, _wrapMjs.wrap));
parcelHelpers.export(exports, "anticipate", ()=>(0, _anticipateMjs.anticipate));
parcelHelpers.export(exports, "backIn", ()=>(0, _backMjs.backIn));
parcelHelpers.export(exports, "backInOut", ()=>(0, _backMjs.backInOut));
parcelHelpers.export(exports, "backOut", ()=>(0, _backMjs.backOut));
parcelHelpers.export(exports, "circIn", ()=>(0, _circMjs.circIn));
parcelHelpers.export(exports, "circInOut", ()=>(0, _circMjs.circInOut));
parcelHelpers.export(exports, "circOut", ()=>(0, _circMjs.circOut));
parcelHelpers.export(exports, "cubicBezier", ()=>(0, _cubicBezierMjs.cubicBezier));
parcelHelpers.export(exports, "easeIn", ()=>(0, _easeMjs.easeIn));
parcelHelpers.export(exports, "easeInOut", ()=>(0, _easeMjs.easeInOut));
parcelHelpers.export(exports, "easeOut", ()=>(0, _easeMjs.easeOut));
parcelHelpers.export(exports, "mirrorEasing", ()=>(0, _mirrorMjs.mirrorEasing));
parcelHelpers.export(exports, "reverseEasing", ()=>(0, _reverseMjs.reverseEasing));
parcelHelpers.export(exports, "steps", ()=>(0, _stepsMjs.steps));
parcelHelpers.export(exports, "getEasingForSegment", ()=>(0, _getEasingForSegmentMjs.getEasingForSegment));
parcelHelpers.export(exports, "isBezierDefinition", ()=>(0, _isBezierDefinitionMjs.isBezierDefinition));
parcelHelpers.export(exports, "isEasingArray", ()=>(0, _isEasingArrayMjs.isEasingArray));
parcelHelpers.export(exports, "easingDefinitionToFunction", ()=>(0, _mapMjs.easingDefinitionToFunction));
var _arrayMjs = require("./array.mjs");
var _clampMjs = require("./clamp.mjs");
var _errorsMjs = require("./errors.mjs");
var _globalConfigMjs = require("./global-config.mjs");
var _isNumericalStringMjs = require("./is-numerical-string.mjs");
var _isObjectMjs = require("./is-object.mjs");
var _isZeroValueStringMjs = require("./is-zero-value-string.mjs");
var _memoMjs = require("./memo.mjs");
var _noopMjs = require("./noop.mjs");
var _pipeMjs = require("./pipe.mjs");
var _progressMjs = require("./progress.mjs");
var _subscriptionManagerMjs = require("./subscription-manager.mjs");
var _timeConversionMjs = require("./time-conversion.mjs");
var _velocityPerSecondMjs = require("./velocity-per-second.mjs");
var _warnOnceMjs = require("./warn-once.mjs");
var _wrapMjs = require("./wrap.mjs");
var _anticipateMjs = require("./easing/anticipate.mjs");
var _backMjs = require("./easing/back.mjs");
var _circMjs = require("./easing/circ.mjs");
var _cubicBezierMjs = require("./easing/cubic-bezier.mjs");
var _easeMjs = require("./easing/ease.mjs");
var _mirrorMjs = require("./easing/modifiers/mirror.mjs");
var _reverseMjs = require("./easing/modifiers/reverse.mjs");
var _stepsMjs = require("./easing/steps.mjs");
var _getEasingForSegmentMjs = require("./easing/utils/get-easing-for-segment.mjs");
var _isBezierDefinitionMjs = require("./easing/utils/is-bezier-definition.mjs");
var _isEasingArrayMjs = require("./easing/utils/is-easing-array.mjs");
var _mapMjs = require("./easing/utils/map.mjs");

},{"./array.mjs":"841vh","./clamp.mjs":"b78W4","./errors.mjs":"588wx","./global-config.mjs":"jQhZ4","./is-numerical-string.mjs":"jEMv3","./is-object.mjs":"iBZNm","./is-zero-value-string.mjs":"d1J8f","./memo.mjs":"240b7","./noop.mjs":"1tDyg","./pipe.mjs":"lPgnn","./progress.mjs":"6Q1yP","./subscription-manager.mjs":"8tNj4","./time-conversion.mjs":"dIdtR","./velocity-per-second.mjs":"drsSU","./warn-once.mjs":"jVwil","./wrap.mjs":"5A3ZA","./easing/anticipate.mjs":"4teBY","./easing/back.mjs":"hMfhC","./easing/circ.mjs":"gCpPR","./easing/cubic-bezier.mjs":"8siuB","./easing/ease.mjs":"i2AmW","./easing/modifiers/mirror.mjs":"4q4aF","./easing/modifiers/reverse.mjs":"ccnCS","./easing/steps.mjs":"iwMYF","./easing/utils/get-easing-for-segment.mjs":"jTpGH","./easing/utils/is-bezier-definition.mjs":"8410g","./easing/utils/is-easing-array.mjs":"39Hz1","./easing/utils/map.mjs":"9fF4f","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lPgnn":[function(require,module,exports,__globalThis) {
/**
 * Pipe
 * Compose other transformers to run linearily
 * pipe(min(20), max(40))
 * @param  {...functions} transformers
 * @return {function}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pipe", ()=>pipe);
const combineFunctions = (a, b)=>(v)=>b(a(v));
const pipe = (...transformers)=>transformers.reduce(combineFunctions);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Q1yP":[function(require,module,exports,__globalThis) {
/*
  Progress within given range

  Given a lower limit and an upper limit, we return the progress
  (expressed as a number 0-1) represented by the given value, and
  limit that progress to within 0-1.

  @param [number]: Lower limit
  @param [number]: Upper limit
  @param [number]: Value to find progress within given range
  @return [number]: Progress of value within range as expressed 0-1
*/ /*#__NO_SIDE_EFFECTS__*/ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progress", ()=>progress);
const progress = (from, to, value)=>{
    const toFromDifference = to - from;
    return toFromDifference === 0 ? 1 : (value - from) / toFromDifference;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jVwil":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasWarned", ()=>hasWarned);
parcelHelpers.export(exports, "warnOnce", ()=>warnOnce);
var _formatErrorMessageMjs = require("./format-error-message.mjs");
const warned = new Set();
function hasWarned(message) {
    return warned.has(message);
}
function warnOnce(condition, message, errorCode) {
    if (condition || warned.has(message)) return;
    console.warn((0, _formatErrorMessageMjs.formatErrorMessage)(message, errorCode));
    warned.add(message);
}

},{"./format-error-message.mjs":"f3Mzt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5A3ZA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "wrap", ()=>wrap);
const wrap = (min, max, v)=>{
    const rangeSize = max - min;
    return ((v - min) % rangeSize + rangeSize) % rangeSize + min;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4teBY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "anticipate", ()=>anticipate);
var _backMjs = require("./back.mjs");
const anticipate = (p)=>p >= 1 ? 1 : (p *= 2) < 1 ? 0.5 * (0, _backMjs.backIn)(p) : 0.5 * (2 - Math.pow(2, -10 * (p - 1)));

},{"./back.mjs":"hMfhC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hMfhC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "backIn", ()=>backIn);
parcelHelpers.export(exports, "backInOut", ()=>backInOut);
parcelHelpers.export(exports, "backOut", ()=>backOut);
var _cubicBezierMjs = require("./cubic-bezier.mjs");
var _mirrorMjs = require("./modifiers/mirror.mjs");
var _reverseMjs = require("./modifiers/reverse.mjs");
const backOut = /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezier)(0.33, 1.53, 0.69, 0.99);
const backIn = /*@__PURE__*/ (0, _reverseMjs.reverseEasing)(backOut);
const backInOut = /*@__PURE__*/ (0, _mirrorMjs.mirrorEasing)(backIn);

},{"./cubic-bezier.mjs":"8siuB","./modifiers/mirror.mjs":"4q4aF","./modifiers/reverse.mjs":"ccnCS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8siuB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cubicBezier", ()=>cubicBezier);
var _noopMjs = require("../noop.mjs");
/*
  Bezier function generator
  This has been modified from Gaëtan Renaudeau's BezierEasing
  https://github.com/gre/bezier-easing/blob/master/src/index.js
  https://github.com/gre/bezier-easing/blob/master/LICENSE
  
  I've removed the newtonRaphsonIterate algo because in benchmarking it
  wasn't noticeably faster than binarySubdivision, indeed removing it
  usually improved times, depending on the curve.
  I also removed the lookup table, as for the added bundle size and loop we're
  only cutting ~4 or so subdivision iterations. I bumped the max iterations up
  to 12 to compensate and this still tended to be faster for no perceivable
  loss in accuracy.
  Usage
    const easeOut = cubicBezier(.17,.67,.83,.67);
    const x = easeOut(0.5); // returns 0.627...
*/ // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
const calcBezier = (t, a1, a2)=>(((1.0 - 3.0 * a2 + 3.0 * a1) * t + (3.0 * a2 - 6.0 * a1)) * t + 3.0 * a1) * t;
const subdivisionPrecision = 0.0000001;
const subdivisionMaxIterations = 12;
function binarySubdivide(x, lowerBound, upperBound, mX1, mX2) {
    let currentX;
    let currentT;
    let i = 0;
    do {
        currentT = lowerBound + (upperBound - lowerBound) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - x;
        if (currentX > 0.0) upperBound = currentT;
        else lowerBound = currentT;
    }while (Math.abs(currentX) > subdivisionPrecision && ++i < subdivisionMaxIterations);
    return currentT;
}
function cubicBezier(mX1, mY1, mX2, mY2) {
    // If this is a linear gradient, return linear easing
    if (mX1 === mY1 && mX2 === mY2) return 0, _noopMjs.noop;
    const getTForX = (aX)=>binarySubdivide(aX, 0, 1, mX1, mX2);
    // If animation is at start/end, return t without easing
    return (t)=>t === 0 || t === 1 ? t : calcBezier(getTForX(t), mY1, mY2);
}

},{"../noop.mjs":"1tDyg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4q4aF":[function(require,module,exports,__globalThis) {
// Accepts an easing function and returns a new one that outputs mirrored values for
// the second half of the animation. Turns easeIn into easeInOut.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mirrorEasing", ()=>mirrorEasing);
const mirrorEasing = (easing)=>(p)=>p <= 0.5 ? easing(2 * p) / 2 : (2 - easing(2 * (1 - p))) / 2;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ccnCS":[function(require,module,exports,__globalThis) {
// Accepts an easing function and returns a new one that outputs reversed values.
// Turns easeIn into easeOut.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reverseEasing", ()=>reverseEasing);
const reverseEasing = (easing)=>(p)=>1 - easing(1 - p);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gCpPR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "circIn", ()=>circIn);
parcelHelpers.export(exports, "circInOut", ()=>circInOut);
parcelHelpers.export(exports, "circOut", ()=>circOut);
var _mirrorMjs = require("./modifiers/mirror.mjs");
var _reverseMjs = require("./modifiers/reverse.mjs");
const circIn = (p)=>1 - Math.sin(Math.acos(p));
const circOut = (0, _reverseMjs.reverseEasing)(circIn);
const circInOut = (0, _mirrorMjs.mirrorEasing)(circIn);

},{"./modifiers/mirror.mjs":"4q4aF","./modifiers/reverse.mjs":"ccnCS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i2AmW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easeIn", ()=>easeIn);
parcelHelpers.export(exports, "easeInOut", ()=>easeInOut);
parcelHelpers.export(exports, "easeOut", ()=>easeOut);
var _cubicBezierMjs = require("./cubic-bezier.mjs");
const easeIn = /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezier)(0.42, 0, 1, 1);
const easeOut = /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezier)(0, 0, 0.58, 1);
const easeInOut = /*@__PURE__*/ (0, _cubicBezierMjs.cubicBezier)(0.42, 0, 0.58, 1);

},{"./cubic-bezier.mjs":"8siuB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iwMYF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "steps", ()=>steps);
var _clampMjs = require("../clamp.mjs");
function steps(numSteps, direction = "end") {
    return (progress)=>{
        progress = direction === "end" ? Math.min(progress, 0.999) : Math.max(progress, 0.001);
        const expanded = progress * numSteps;
        const rounded = direction === "end" ? Math.floor(expanded) : Math.ceil(expanded);
        return (0, _clampMjs.clamp)(0, 1, rounded / numSteps);
    };
}

},{"../clamp.mjs":"b78W4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jTpGH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEasingForSegment", ()=>getEasingForSegment);
var _wrapMjs = require("../../wrap.mjs");
var _isEasingArrayMjs = require("./is-easing-array.mjs");
function getEasingForSegment(easing, i) {
    return (0, _isEasingArrayMjs.isEasingArray)(easing) ? easing[(0, _wrapMjs.wrap)(0, easing.length, i)] : easing;
}

},{"../../wrap.mjs":"5A3ZA","./is-easing-array.mjs":"39Hz1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"39Hz1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEasingArray", ()=>isEasingArray);
const isEasingArray = (ease)=>{
    return Array.isArray(ease) && typeof ease[0] !== "number";
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9fF4f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "easingDefinitionToFunction", ()=>easingDefinitionToFunction);
var _errorsMjs = require("../../errors.mjs");
var _noopMjs = require("../../noop.mjs");
var _anticipateMjs = require("../anticipate.mjs");
var _backMjs = require("../back.mjs");
var _circMjs = require("../circ.mjs");
var _cubicBezierMjs = require("../cubic-bezier.mjs");
var _easeMjs = require("../ease.mjs");
var _isBezierDefinitionMjs = require("./is-bezier-definition.mjs");
const easingLookup = {
    linear: (0, _noopMjs.noop),
    easeIn: (0, _easeMjs.easeIn),
    easeInOut: (0, _easeMjs.easeInOut),
    easeOut: (0, _easeMjs.easeOut),
    circIn: (0, _circMjs.circIn),
    circInOut: (0, _circMjs.circInOut),
    circOut: (0, _circMjs.circOut),
    backIn: (0, _backMjs.backIn),
    backInOut: (0, _backMjs.backInOut),
    backOut: (0, _backMjs.backOut),
    anticipate: (0, _anticipateMjs.anticipate)
};
const isValidEasing = (easing)=>{
    return typeof easing === "string";
};
const easingDefinitionToFunction = (definition)=>{
    if ((0, _isBezierDefinitionMjs.isBezierDefinition)(definition)) {
        // If cubic bezier definition, create bezier curve
        (0, _errorsMjs.invariant)(definition.length === 4, `Cubic bezier arrays must contain four numerical values.`, "cubic-bezier-length");
        const [x1, y1, x2, y2] = definition;
        return (0, _cubicBezierMjs.cubicBezier)(x1, y1, x2, y2);
    } else if (isValidEasing(definition)) {
        // Else lookup from table
        (0, _errorsMjs.invariant)(easingLookup[definition] !== undefined, `Invalid easing type '${definition}'`, "invalid-easing-type");
        return easingLookup[definition];
    }
    return definition;
};

},{"../../errors.mjs":"588wx","../../noop.mjs":"1tDyg","../anticipate.mjs":"4teBY","../back.mjs":"hMfhC","../circ.mjs":"gCpPR","../cubic-bezier.mjs":"8siuB","../ease.mjs":"i2AmW","./is-bezier-definition.mjs":"8410g","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1OKFF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createMotionComponent", ()=>createMotionComponent);
var _jsxRuntime = require("react/jsx-runtime");
var _motionUtils = require("motion-utils");
var _react = require("react");
var _layoutGroupContextMjs = require("../context/LayoutGroupContext.mjs");
var _lazyContextMjs = require("../context/LazyContext.mjs");
var _motionConfigContextMjs = require("../context/MotionConfigContext.mjs");
var _indexMjs = require("../context/MotionContext/index.mjs");
var _createMjs = require("../context/MotionContext/create.mjs");
var _useRenderMjs = require("../render/dom/use-render.mjs");
var _isSvgComponentMjs = require("../render/dom/utils/is-svg-component.mjs");
var _useHtmlVisualStateMjs = require("../render/html/use-html-visual-state.mjs");
var _useSvgVisualStateMjs = require("../render/svg/use-svg-visual-state.mjs");
var _definitionsMjs = require("./features/definitions.mjs");
var _loadFeaturesMjs = require("./features/load-features.mjs");
var _symbolMjs = require("./utils/symbol.mjs");
var _useMotionRefMjs = require("./utils/use-motion-ref.mjs");
var _useVisualElementMjs = require("./utils/use-visual-element.mjs");
"use client";
/**
 * Create a `motion` component.
 *
 * This function accepts a Component argument, which can be either a string (ie "div"
 * for `motion.div`), or an actual React component.
 *
 * Alongside this is a config option which provides a way of rendering the provided
 * component "offline", or outside the React render cycle.
 */ function createMotionComponent(Component, { forwardMotionProps = false, type } = {}, preloadedFeatures, createVisualElement) {
    preloadedFeatures && (0, _loadFeaturesMjs.loadFeatures)(preloadedFeatures);
    /**
     * Determine whether to use SVG or HTML rendering based on:
     * 1. Explicit `type` option (highest priority)
     * 2. Auto-detection via `isSVGComponent`
     */ const isSVG = type ? type === "svg" : (0, _isSvgComponentMjs.isSVGComponent)(Component);
    const useVisualState = isSVG ? (0, _useSvgVisualStateMjs.useSVGVisualState) : (0, _useHtmlVisualStateMjs.useHTMLVisualState);
    function MotionDOMComponent(props, externalRef) {
        /**
         * If we need to measure the element we load this functionality in a
         * separate class component in order to gain access to getSnapshotBeforeUpdate.
         */ let MeasureLayout;
        const configAndProps = {
            ...(0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext)),
            ...props,
            layoutId: useLayoutId(props)
        };
        const { isStatic } = configAndProps;
        const context = (0, _createMjs.useCreateMotionContext)(props);
        const visualState = useVisualState(props, isStatic);
        if (!isStatic && typeof window !== "undefined") {
            useStrictMode(configAndProps, preloadedFeatures);
            const layoutProjection = getProjectionFunctionality(configAndProps);
            MeasureLayout = layoutProjection.MeasureLayout;
            /**
             * Create a VisualElement for this component. A VisualElement provides a common
             * interface to renderer-specific APIs (ie DOM/Three.js etc) as well as
             * providing a way of rendering to these APIs outside of the React render loop
             * for more performant animations and interactions
             */ context.visualElement = (0, _useVisualElementMjs.useVisualElement)(Component, visualState, configAndProps, createVisualElement, layoutProjection.ProjectionNode, isSVG);
        }
        /**
         * The mount order and hierarchy is specific to ensure our element ref
         * is hydrated by the time features fire their effects.
         */ return (0, _jsxRuntime.jsxs)((0, _indexMjs.MotionContext).Provider, {
            value: context,
            children: [
                MeasureLayout && context.visualElement ? (0, _jsxRuntime.jsx)(MeasureLayout, {
                    visualElement: context.visualElement,
                    ...configAndProps
                }) : null,
                (0, _useRenderMjs.useRender)(Component, props, (0, _useMotionRefMjs.useMotionRef)(visualState, context.visualElement, externalRef), visualState, isStatic, forwardMotionProps, isSVG)
            ]
        });
    }
    MotionDOMComponent.displayName = `motion.${typeof Component === "string" ? Component : `create(${Component.displayName ?? Component.name ?? ""})`}`;
    const ForwardRefMotionComponent = (0, _react.forwardRef)(MotionDOMComponent);
    ForwardRefMotionComponent[0, _symbolMjs.motionComponentSymbol] = Component;
    return ForwardRefMotionComponent;
}
function useLayoutId({ layoutId }) {
    const layoutGroupId = (0, _react.useContext)((0, _layoutGroupContextMjs.LayoutGroupContext)).id;
    return layoutGroupId && layoutId !== undefined ? layoutGroupId + "-" + layoutId : layoutId;
}
function useStrictMode(configAndProps, preloadedFeatures) {
    const isStrict = (0, _react.useContext)((0, _lazyContextMjs.LazyContext)).strict;
}
function getProjectionFunctionality(props) {
    const featureDefinitions = (0, _definitionsMjs.getInitializedFeatureDefinitions)();
    const { drag, layout } = featureDefinitions;
    if (!drag && !layout) return {};
    const combined = {
        ...drag,
        ...layout
    };
    return {
        MeasureLayout: drag?.isEnabled(props) || layout?.isEnabled(props) ? combined.MeasureLayout : undefined,
        ProjectionNode: combined.ProjectionNode
    };
}

},{"react/jsx-runtime":"gonF6","motion-utils":"1UaYR","react":"bmhQu","../context/LayoutGroupContext.mjs":"6GAWV","../context/LazyContext.mjs":"fr7qV","../context/MotionConfigContext.mjs":"jiPm9","../context/MotionContext/index.mjs":"6fBuO","../context/MotionContext/create.mjs":"dTyh7","../render/dom/use-render.mjs":"2pqLf","../render/dom/utils/is-svg-component.mjs":"852Y7","../render/html/use-html-visual-state.mjs":"71Uqj","../render/svg/use-svg-visual-state.mjs":"2tae0","./features/definitions.mjs":"iaXo3","./features/load-features.mjs":"8z1j8","./utils/symbol.mjs":"1BT9R","./utils/use-motion-ref.mjs":"DjKGs","./utils/use-visual-element.mjs":"5g05W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fr7qV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LazyContext", ()=>LazyContext);
var _react = require("react");
"use client";
const LazyContext = (0, _react.createContext)({
    strict: false
});

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6fBuO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionContext", ()=>MotionContext);
var _react = require("react");
"use client";
const MotionContext = /* @__PURE__ */ (0, _react.createContext)({});

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dTyh7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCreateMotionContext", ()=>useCreateMotionContext);
var _react = require("react");
var _indexMjs = require("./index.mjs");
var _utilsMjs = require("./utils.mjs");
"use client";
function useCreateMotionContext(props) {
    const { initial, animate } = (0, _utilsMjs.getCurrentTreeVariants)(props, (0, _react.useContext)((0, _indexMjs.MotionContext)));
    return (0, _react.useMemo)(()=>({
            initial,
            animate
        }), [
        variantLabelsAsDependency(initial),
        variantLabelsAsDependency(animate)
    ]);
}
function variantLabelsAsDependency(prop) {
    return Array.isArray(prop) ? prop.join(" ") : prop;
}

},{"react":"bmhQu","./index.mjs":"6fBuO","./utils.mjs":"lXgv9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lXgv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCurrentTreeVariants", ()=>getCurrentTreeVariants);
var _motionDom = require("motion-dom");
function getCurrentTreeVariants(props, context) {
    if ((0, _motionDom.isControllingVariants)(props)) {
        const { initial, animate } = props;
        return {
            initial: initial === false || (0, _motionDom.isVariantLabel)(initial) ? initial : undefined,
            animate: (0, _motionDom.isVariantLabel)(animate) ? animate : undefined
        };
    }
    return props.inherit !== false ? context : {};
}

},{"motion-dom":[["isControllingVariants","932u2"],["isVariantLabel","9bqH5"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2pqLf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useRender", ()=>useRender);
var _motionDom = require("motion-dom");
var _react = require("react");
var _usePropsMjs = require("../html/use-props.mjs");
var _usePropsMjs1 = require("../svg/use-props.mjs");
var _filterPropsMjs = require("./utils/filter-props.mjs");
var _isSvgComponentMjs = require("./utils/is-svg-component.mjs");
"use client";
function useRender(Component, props, ref, { latestValues }, isStatic, forwardMotionProps = false, isSVG) {
    const useVisualProps = isSVG ?? (0, _isSvgComponentMjs.isSVGComponent)(Component) ? (0, _usePropsMjs1.useSVGProps) : (0, _usePropsMjs.useHTMLProps);
    const visualProps = useVisualProps(props, latestValues, isStatic, Component);
    const filteredProps = (0, _filterPropsMjs.filterProps)(props, typeof Component === "string", forwardMotionProps);
    const elementProps = Component !== (0, _react.Fragment) ? {
        ...filteredProps,
        ...visualProps,
        ref
    } : {};
    /**
     * If component has been handed a motion value as its child,
     * memoise its initial value and render that. Subsequent updates
     * will be handled by the onChange handler
     */ const { children } = props;
    const renderedChildren = (0, _react.useMemo)(()=>(0, _motionDom.isMotionValue)(children) ? children.get() : children, [
        children
    ]);
    return (0, _react.createElement)(Component, {
        ...elementProps,
        children: renderedChildren
    });
}

},{"motion-dom":"fKDJz","react":"bmhQu","../html/use-props.mjs":"1f2WZ","../svg/use-props.mjs":"bHCFQ","./utils/filter-props.mjs":"4zlyC","./utils/is-svg-component.mjs":"852Y7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1f2WZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copyRawValuesOnly", ()=>copyRawValuesOnly);
parcelHelpers.export(exports, "useHTMLProps", ()=>useHTMLProps);
var _motionDom = require("motion-dom");
var _react = require("react");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
"use client";
function copyRawValuesOnly(target, source, props) {
    for(const key in source)if (!(0, _motionDom.isMotionValue)(source[key]) && !(0, _motionDom.isForcedMotionValue)(key, props)) target[key] = source[key];
}
function useInitialMotionValues({ transformTemplate }, visualState) {
    return (0, _react.useMemo)(()=>{
        const state = (0, _createRenderStateMjs.createHtmlRenderState)();
        (0, _motionDom.buildHTMLStyles)(state, visualState, transformTemplate);
        return Object.assign({}, state.vars, state.style);
    }, [
        visualState
    ]);
}
function useStyle(props, visualState) {
    const styleProp = props.style || {};
    const style = {};
    /**
     * Copy non-Motion Values straight into style
     */ copyRawValuesOnly(style, styleProp, props);
    Object.assign(style, useInitialMotionValues(props, visualState));
    return style;
}
function useHTMLProps(props, visualState) {
    // The `any` isn't ideal but it is the type of createElement props argument
    const htmlProps = {};
    const style = useStyle(props, visualState);
    if (props.drag && props.dragListener !== false) {
        // Disable the ghost element when a user drags
        htmlProps.draggable = false;
        // Disable text selection
        style.userSelect = style.WebkitUserSelect = style.WebkitTouchCallout = "none";
        // Disable scrolling on the draggable direction
        style.touchAction = props.drag === true ? "none" : `pan-${props.drag === "x" ? "y" : "x"}`;
    }
    if (props.tabIndex === undefined && (props.onTap || props.onTapStart || props.whileTap)) htmlProps.tabIndex = 0;
    htmlProps.style = style;
    return htmlProps;
}

},{"motion-dom":[["buildHTMLStyles","e1GuX"],["isForcedMotionValue","3YH1U"],["isMotionValue","fKDJz"]],"react":"bmhQu","./utils/create-render-state.mjs":"dVHwA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dVHwA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createHtmlRenderState", ()=>createHtmlRenderState);
const createHtmlRenderState = ()=>({
        style: {},
        transform: {},
        transformOrigin: {},
        vars: {}
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bHCFQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSVGProps", ()=>useSVGProps);
var _motionDom = require("motion-dom");
var _react = require("react");
var _usePropsMjs = require("../html/use-props.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
"use client";
function useSVGProps(props, visualState, _isStatic, Component) {
    const visualProps = (0, _react.useMemo)(()=>{
        const state = (0, _createRenderStateMjs.createSvgRenderState)();
        (0, _motionDom.buildSVGAttrs)(state, visualState, (0, _motionDom.isSVGTag)(Component), props.transformTemplate, props.style);
        return {
            ...state.attrs,
            style: {
                ...state.style
            }
        };
    }, [
        visualState
    ]);
    if (props.style) {
        const rawStyles = {};
        (0, _usePropsMjs.copyRawValuesOnly)(rawStyles, props.style, props);
        visualProps.style = {
            ...rawStyles,
            ...visualProps.style
        };
    }
    return visualProps;
}

},{"motion-dom":[["buildSVGAttrs","8wKO9"],["isSVGTag","cROGR"]],"react":"bmhQu","../html/use-props.mjs":"1f2WZ","./utils/create-render-state.mjs":"02xGj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"02xGj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSvgRenderState", ()=>createSvgRenderState);
var _createRenderStateMjs = require("../../html/utils/create-render-state.mjs");
const createSvgRenderState = ()=>({
        ...(0, _createRenderStateMjs.createHtmlRenderState)(),
        attrs: {}
    });

},{"../../html/utils/create-render-state.mjs":"dVHwA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4zlyC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "filterProps", ()=>filterProps);
parcelHelpers.export(exports, "loadExternalIsValidProp", ()=>loadExternalIsValidProp);
var _motionDom = require("motion-dom");
var _validPropMjs = require("../../../motion/utils/valid-prop.mjs");
let shouldForward = (key)=>!(0, _validPropMjs.isValidMotionProp)(key);
function loadExternalIsValidProp(isValidProp) {
    if (typeof isValidProp !== "function") return;
    // Explicitly filter our events
    shouldForward = (key)=>key.startsWith("on") ? !(0, _validPropMjs.isValidMotionProp)(key) : isValidProp(key);
}
/**
 * Emotion and Styled Components both allow users to pass through arbitrary props to their components
 * to dynamically generate CSS. They both use the `@emotion/is-prop-valid` package to determine which
 * of these should be passed to the underlying DOM node.
 *
 * However, when styling a Motion component `styled(motion.div)`, both packages pass through *all* props
 * as it's seen as an arbitrary component rather than a DOM node. Motion only allows arbitrary props
 * passed through the `custom` prop so it doesn't *need* the payload or computational overhead of
 * `@emotion/is-prop-valid`, however to fix this problem we need to use it.
 *
 * By making it an optionalDependency we can offer this functionality only in the situations where it's
 * actually required.
 */ try {
    /**
     * We attempt to import this package but require won't be defined in esm environments, in that case
     * isPropValid will have to be provided via `MotionContext`. In a 6.0.0 this should probably be removed
     * in favour of explicit injection.
     *
     * String concatenation prevents bundlers like webpack (e.g. Storybook)
     * from statically resolving this optional dependency at build time.
     */ const emotionPkg = "@emotion/is-prop-valid";
    loadExternalIsValidProp(require(emotionPkg).default);
} catch  {
// We don't need to actually do anything here - the fallback is the existing `isPropValid`.
}
function filterProps(props, isDom, forwardMotionProps) {
    const filteredProps = {};
    for(const key in props){
        /**
         * values is considered a valid prop by Emotion, so if it's present
         * this will be rendered out to the DOM unless explicitly filtered.
         *
         * We check the type as it could be used with the `feColorMatrix`
         * element, which we support.
         */ if (key === "values" && typeof props.values === "object") continue;
        if ((0, _motionDom.isMotionValue)(props[key])) continue;
        if (shouldForward(key) || forwardMotionProps === true && (0, _validPropMjs.isValidMotionProp)(key) || !isDom && !(0, _validPropMjs.isValidMotionProp)(key) || // If trying to use native HTML drag events, forward drag listeners
        props["draggable"] && key.startsWith("onDrag")) filteredProps[key] = props[key];
    }
    return filteredProps;
}

},{"motion-dom":"fKDJz","../../../motion/utils/valid-prop.mjs":"iZjss","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iZjss":[function(require,module,exports,__globalThis) {
/**
 * A list of all valid MotionProps.
 *
 * @privateRemarks
 * This doesn't throw if a `MotionProp` name is missing - it should.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidMotionProp", ()=>isValidMotionProp);
const validMotionProps = new Set([
    "animate",
    "exit",
    "variants",
    "initial",
    "style",
    "values",
    "variants",
    "transition",
    "transformTemplate",
    "custom",
    "inherit",
    "onBeforeLayoutMeasure",
    "onAnimationStart",
    "onAnimationComplete",
    "onUpdate",
    "onDragStart",
    "onDrag",
    "onDragEnd",
    "onMeasureDragConstraints",
    "onDirectionLock",
    "onDragTransitionEnd",
    "_dragX",
    "_dragY",
    "onHoverStart",
    "onHoverEnd",
    "onViewportEnter",
    "onViewportLeave",
    "globalTapTarget",
    "propagate",
    "ignoreStrict",
    "viewport"
]);
/**
 * Check whether a prop name is a valid `MotionProp` key.
 *
 * @param key - Name of the property to check
 * @returns `true` is key is a valid `MotionProp`.
 *
 * @public
 */ function isValidMotionProp(key) {
    return key.startsWith("while") || key.startsWith("drag") && key !== "draggable" || key.startsWith("layout") || key.startsWith("onTap") || key.startsWith("onPan") || key.startsWith("onLayout") || validMotionProps.has(key);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"71Uqj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useHTMLVisualState", ()=>useHTMLVisualState);
var _motionDom = require("motion-dom");
var _useVisualStateMjs = require("../../motion/utils/use-visual-state.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
"use client";
const useHTMLVisualState = /*@__PURE__*/ (0, _useVisualStateMjs.makeUseVisualState)({
    scrapeMotionValuesFromProps: (0, _motionDom.scrapeHTMLMotionValuesFromProps),
    createRenderState: (0, _createRenderStateMjs.createHtmlRenderState)
});

},{"motion-dom":[["scrapeHTMLMotionValuesFromProps","504Ps","scrapeMotionValuesFromProps"]],"../../motion/utils/use-visual-state.mjs":"bjd2T","./utils/create-render-state.mjs":"dVHwA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bjd2T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeUseVisualState", ()=>makeUseVisualState);
var _motionDom = require("motion-dom");
var _react = require("react");
var _indexMjs = require("../../context/MotionContext/index.mjs");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
var _useConstantMjs = require("../../utils/use-constant.mjs");
"use client";
function makeState({ scrapeMotionValuesFromProps, createRenderState }, props, context, presenceContext) {
    const state = {
        latestValues: makeLatestValues(props, context, presenceContext, scrapeMotionValuesFromProps),
        renderState: createRenderState()
    };
    return state;
}
function makeLatestValues(props, context, presenceContext, scrapeMotionValues) {
    const values = {};
    const motionValues = scrapeMotionValues(props, {});
    for(const key in motionValues)values[key] = (0, _motionDom.resolveMotionValue)(motionValues[key]);
    let { initial, animate } = props;
    const isControllingVariants$1 = (0, _motionDom.isControllingVariants)(props);
    const isVariantNode$1 = (0, _motionDom.isVariantNode)(props);
    if (context && isVariantNode$1 && !isControllingVariants$1 && props.inherit !== false) {
        if (initial === undefined) initial = context.initial;
        if (animate === undefined) animate = context.animate;
    }
    let isInitialAnimationBlocked = presenceContext ? presenceContext.initial === false : false;
    isInitialAnimationBlocked = isInitialAnimationBlocked || initial === false;
    const variantToSet = isInitialAnimationBlocked ? animate : initial;
    if (variantToSet && typeof variantToSet !== "boolean" && !(0, _motionDom.isAnimationControls)(variantToSet)) {
        const list = Array.isArray(variantToSet) ? variantToSet : [
            variantToSet
        ];
        for(let i = 0; i < list.length; i++){
            const resolved = (0, _motionDom.resolveVariantFromProps)(props, list[i]);
            if (resolved) {
                const { transitionEnd, transition, ...target } = resolved;
                for(const key in target){
                    let valueTarget = target[key];
                    if (Array.isArray(valueTarget)) {
                        /**
                         * Take final keyframe if the initial animation is blocked because
                         * we want to initialise at the end of that blocked animation.
                         */ const index = isInitialAnimationBlocked ? valueTarget.length - 1 : 0;
                        valueTarget = valueTarget[index];
                    }
                    if (valueTarget !== null) values[key] = valueTarget;
                }
                for(const key in transitionEnd)values[key] = transitionEnd[key];
            }
        }
    }
    return values;
}
const makeUseVisualState = (config)=>(props, isStatic)=>{
        const context = (0, _react.useContext)((0, _indexMjs.MotionContext));
        const presenceContext = (0, _react.useContext)((0, _presenceContextMjs.PresenceContext));
        const make = ()=>makeState(config, props, context, presenceContext);
        return isStatic ? make() : (0, _useConstantMjs.useConstant)(make);
    };

},{"motion-dom":[["isAnimationControls","eZBfs"],["isControllingVariants","932u2"],["isVariantNode","932u2"],["resolveMotionValue","9TiOd"],["resolveVariantFromProps","fFvtX"]],"react":"bmhQu","../../context/MotionContext/index.mjs":"6fBuO","../../context/PresenceContext.mjs":"ewqOU","../../utils/use-constant.mjs":"2eji4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9TiOd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveMotionValue", ()=>resolveMotionValue);
var _isMotionValueMjs = require("./is-motion-value.mjs");
/**
 * If the provided value is a MotionValue, this returns the actual value, otherwise just the value itself
 */ function resolveMotionValue(value) {
    return (0, _isMotionValueMjs.isMotionValue)(value) ? value.get() : value;
}

},{"./is-motion-value.mjs":"fKDJz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2tae0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSVGVisualState", ()=>useSVGVisualState);
var _motionDom = require("motion-dom");
var _useVisualStateMjs = require("../../motion/utils/use-visual-state.mjs");
var _createRenderStateMjs = require("./utils/create-render-state.mjs");
"use client";
const useSVGVisualState = /*@__PURE__*/ (0, _useVisualStateMjs.makeUseVisualState)({
    scrapeMotionValuesFromProps: (0, _motionDom.scrapeSVGMotionValuesFromProps),
    createRenderState: (0, _createRenderStateMjs.createSvgRenderState)
});

},{"motion-dom":[["scrapeSVGMotionValuesFromProps","iWJKc","scrapeMotionValuesFromProps"]],"../../motion/utils/use-visual-state.mjs":"bjd2T","./utils/create-render-state.mjs":"02xGj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iaXo3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getInitializedFeatureDefinitions", ()=>getInitializedFeatureDefinitions);
parcelHelpers.export(exports, "initFeatureDefinitions", ()=>initFeatureDefinitions);
var _motionDom = require("motion-dom");
const featureProps = {
    animation: [
        "animate",
        "variants",
        "whileHover",
        "whileTap",
        "exit",
        "whileInView",
        "whileFocus",
        "whileDrag"
    ],
    exit: [
        "exit"
    ],
    drag: [
        "drag",
        "dragControls"
    ],
    focus: [
        "whileFocus"
    ],
    hover: [
        "whileHover",
        "onHoverStart",
        "onHoverEnd"
    ],
    tap: [
        "whileTap",
        "onTap",
        "onTapStart",
        "onTapCancel"
    ],
    pan: [
        "onPan",
        "onPanStart",
        "onPanSessionStart",
        "onPanEnd"
    ],
    inView: [
        "whileInView",
        "onViewportEnter",
        "onViewportLeave"
    ],
    layout: [
        "layout",
        "layoutId"
    ]
};
let isInitialized = false;
/**
 * Initialize feature definitions with isEnabled checks.
 * This must be called before any motion components are rendered.
 */ function initFeatureDefinitions() {
    if (isInitialized) return;
    const initialFeatureDefinitions = {};
    for(const key in featureProps)initialFeatureDefinitions[key] = {
        isEnabled: (props)=>featureProps[key].some((name)=>!!props[name])
    };
    (0, _motionDom.setFeatureDefinitions)(initialFeatureDefinitions);
    isInitialized = true;
}
/**
 * Get the current feature definitions, initializing if needed.
 */ function getInitializedFeatureDefinitions() {
    initFeatureDefinitions();
    return (0, _motionDom.getFeatureDefinitions)();
}

},{"motion-dom":"lVIcw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8z1j8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadFeatures", ()=>loadFeatures);
var _motionDom = require("motion-dom");
var _definitionsMjs = require("./definitions.mjs");
function loadFeatures(features) {
    const featureDefinitions = (0, _definitionsMjs.getInitializedFeatureDefinitions)();
    for(const key in features)featureDefinitions[key] = {
        ...featureDefinitions[key],
        ...features[key]
    };
    (0, _motionDom.setFeatureDefinitions)(featureDefinitions);
}

},{"motion-dom":"lVIcw","./definitions.mjs":"iaXo3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1BT9R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "motionComponentSymbol", ()=>motionComponentSymbol);
const motionComponentSymbol = Symbol.for("motionComponentSymbol");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"DjKGs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMotionRef", ()=>useMotionRef);
var _react = require("react");
"use client";
/**
 * Creates a ref function that, when called, hydrates the provided
 * external ref and VisualElement.
 */ function useMotionRef(visualState, visualElement, externalRef) {
    /**
     * Store externalRef in a ref to avoid including it in the useCallback
     * dependency array. Including externalRef in dependencies causes issues
     * with libraries like Radix UI that create new callback refs on each render
     * when using asChild - this would cause the callback to be recreated,
     * triggering element remounts and breaking AnimatePresence exit animations.
     */ const externalRefContainer = (0, _react.useRef)(externalRef);
    (0, _react.useInsertionEffect)(()=>{
        externalRefContainer.current = externalRef;
    });
    // Store cleanup function returned by callback refs (React 19 feature)
    const refCleanup = (0, _react.useRef)(null);
    return (0, _react.useCallback)((instance)=>{
        if (instance) visualState.onMount?.(instance);
        const ref = externalRefContainer.current;
        if (typeof ref === "function") {
            if (instance) {
                const cleanup = ref(instance);
                if (typeof cleanup === "function") refCleanup.current = cleanup;
            } else if (refCleanup.current) {
                refCleanup.current();
                refCleanup.current = null;
            } else ref(instance);
        } else if (ref) ref.current = instance;
        if (visualElement) instance ? visualElement.mount(instance) : visualElement.unmount();
    }, [
        visualElement
    ]);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5g05W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useVisualElement", ()=>useVisualElement);
var _motionDom = require("motion-dom");
var _react = require("react");
var _lazyContextMjs = require("../../context/LazyContext.mjs");
var _motionConfigContextMjs = require("../../context/MotionConfigContext.mjs");
var _indexMjs = require("../../context/MotionContext/index.mjs");
var _presenceContextMjs = require("../../context/PresenceContext.mjs");
var _switchLayoutGroupContextMjs = require("../../context/SwitchLayoutGroupContext.mjs");
var _isRefObjectMjs = require("../../utils/is-ref-object.mjs");
var _useIsomorphicEffectMjs = require("../../utils/use-isomorphic-effect.mjs");
"use client";
function useVisualElement(Component, visualState, props, createVisualElement, ProjectionNodeConstructor, isSVG) {
    const { visualElement: parent } = (0, _react.useContext)((0, _indexMjs.MotionContext));
    const lazyContext = (0, _react.useContext)((0, _lazyContextMjs.LazyContext));
    const presenceContext = (0, _react.useContext)((0, _presenceContextMjs.PresenceContext));
    const motionConfig = (0, _react.useContext)((0, _motionConfigContextMjs.MotionConfigContext));
    const reducedMotionConfig = motionConfig.reducedMotion;
    const skipAnimations = motionConfig.skipAnimations;
    const visualElementRef = (0, _react.useRef)(null);
    /**
     * Track whether the component has been through React's commit phase.
     * Used to detect when LazyMotion features load after the component has mounted.
     */ const hasMountedOnce = (0, _react.useRef)(false);
    /**
     * If we haven't preloaded a renderer, check to see if we have one lazy-loaded
     */ createVisualElement = createVisualElement || lazyContext.renderer;
    if (!visualElementRef.current && createVisualElement) {
        visualElementRef.current = createVisualElement(Component, {
            visualState,
            parent,
            props,
            presenceContext,
            blockInitialAnimation: presenceContext ? presenceContext.initial === false : false,
            reducedMotionConfig,
            skipAnimations,
            isSVG
        });
        /**
         * If the component has already mounted before features loaded (e.g. via
         * LazyMotion with async feature loading), we need to force the initial
         * animation to run. Otherwise state changes that occurred before features
         * loaded will be lost and the element will snap to its final state.
         */ if (hasMountedOnce.current && visualElementRef.current) visualElementRef.current.manuallyAnimateOnMount = true;
    }
    const visualElement = visualElementRef.current;
    /**
     * Load Motion gesture and animation features. These are rendered as renderless
     * components so each feature can optionally make use of React lifecycle methods.
     */ const initialLayoutGroupConfig = (0, _react.useContext)((0, _switchLayoutGroupContextMjs.SwitchLayoutGroupContext));
    if (visualElement && !visualElement.projection && ProjectionNodeConstructor && (visualElement.type === "html" || visualElement.type === "svg")) createProjectionNode(visualElementRef.current, props, ProjectionNodeConstructor, initialLayoutGroupConfig);
    const isMounted = (0, _react.useRef)(false);
    (0, _react.useInsertionEffect)(()=>{
        /**
         * Check the component has already mounted before calling
         * `update` unnecessarily. This ensures we skip the initial update.
         */ if (visualElement && isMounted.current) visualElement.update(props, presenceContext);
    });
    /**
     * Cache this value as we want to know whether HandoffAppearAnimations
     * was present on initial render - it will be deleted after this.
     */ const optimisedAppearId = props[0, _motionDom.optimizedAppearDataAttribute];
    const wantsHandoff = (0, _react.useRef)(Boolean(optimisedAppearId) && typeof window !== "undefined" && !window.MotionHandoffIsComplete?.(optimisedAppearId) && window.MotionHasOptimisedAnimation?.(optimisedAppearId));
    (0, _useIsomorphicEffectMjs.useIsomorphicLayoutEffect)(()=>{
        /**
         * Track that this component has mounted. This is used to detect when
         * LazyMotion features load after the component has already committed.
         */ hasMountedOnce.current = true;
        if (!visualElement) return;
        isMounted.current = true;
        window.MotionIsMounted = true;
        visualElement.updateFeatures();
        visualElement.scheduleRenderMicrotask();
        /**
         * Ideally this function would always run in a useEffect.
         *
         * However, if we have optimised appear animations to handoff from,
         * it needs to happen synchronously to ensure there's no flash of
         * incorrect styles in the event of a hydration error.
         *
         * So if we detect a situtation where optimised appear animations
         * are running, we use useLayoutEffect to trigger animations.
         */ if (wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
    });
    (0, _react.useEffect)(()=>{
        if (!visualElement) return;
        if (!wantsHandoff.current && visualElement.animationState) visualElement.animationState.animateChanges();
        if (wantsHandoff.current) {
            // This ensures all future calls to animateChanges() in this component will run in useEffect
            queueMicrotask(()=>{
                window.MotionHandoffMarkAsComplete?.(optimisedAppearId);
            });
            wantsHandoff.current = false;
        }
        /**
         * Now we've finished triggering animations for this element we
         * can wipe the enteringChildren set for the next render.
         */ visualElement.enteringChildren = undefined;
    });
    return visualElement;
}
function createProjectionNode(visualElement, props, ProjectionNodeConstructor, initialPromotionConfig) {
    const { layoutId, layout, drag, dragConstraints, layoutScroll, layoutRoot, layoutAnchor, layoutCrossfade } = props;
    visualElement.projection = new ProjectionNodeConstructor(visualElement.latestValues, props["data-framer-portal-id"] ? undefined : getClosestProjectingNode(visualElement.parent));
    visualElement.projection.setOptions({
        layoutId,
        layout,
        alwaysMeasureLayout: Boolean(drag) || dragConstraints && (0, _isRefObjectMjs.isRefObject)(dragConstraints),
        visualElement,
        /**
         * TODO: Update options in an effect. This could be tricky as it'll be too late
         * to update by the time layout animations run.
         * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
         * ensuring it gets called if there's no potential layout animations.
         *
         */ animationType: typeof layout === "string" ? layout : "both",
        initialPromotionConfig,
        crossfade: layoutCrossfade,
        layoutScroll,
        layoutRoot,
        layoutAnchor
    });
}
function getClosestProjectingNode(visualElement) {
    if (!visualElement) return undefined;
    return visualElement.options.allowProjection !== false ? visualElement.projection : getClosestProjectingNode(visualElement.parent);
}

},{"motion-dom":"anCPn","react":"bmhQu","../../context/LazyContext.mjs":"fr7qV","../../context/MotionConfigContext.mjs":"jiPm9","../../context/MotionContext/index.mjs":"6fBuO","../../context/PresenceContext.mjs":"ewqOU","../../context/SwitchLayoutGroupContext.mjs":"eSdvu","../../utils/is-ref-object.mjs":"7C36g","../../utils/use-isomorphic-effect.mjs":"3CLHh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"anCPn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncMotionValueAnimation", ()=>(0, _asyncMotionValueAnimationMjs.AsyncMotionValueAnimation));
parcelHelpers.export(exports, "GroupAnimation", ()=>(0, _groupAnimationMjs.GroupAnimation));
parcelHelpers.export(exports, "GroupAnimationWithThen", ()=>(0, _groupAnimationWithThenMjs.GroupAnimationWithThen));
parcelHelpers.export(exports, "JSAnimation", ()=>(0, _jsanimationMjs.JSAnimation));
parcelHelpers.export(exports, "animateValue", ()=>(0, _jsanimationMjs.animateValue));
parcelHelpers.export(exports, "NativeAnimation", ()=>(0, _nativeAnimationMjs.NativeAnimation));
parcelHelpers.export(exports, "NativeAnimationExtended", ()=>(0, _nativeAnimationExtendedMjs.NativeAnimationExtended));
parcelHelpers.export(exports, "NativeAnimationWrapper", ()=>(0, _nativeAnimationWrapperMjs.NativeAnimationWrapper));
parcelHelpers.export(exports, "animationMapKey", ()=>(0, _activeAnimationsMjs.animationMapKey));
parcelHelpers.export(exports, "getAnimationMap", ()=>(0, _activeAnimationsMjs.getAnimationMap));
parcelHelpers.export(exports, "calcChildStagger", ()=>(0, _calcChildStaggerMjs.calcChildStagger));
parcelHelpers.export(exports, "getVariableValue", ()=>(0, _cssVariablesConversionMjs.getVariableValue));
parcelHelpers.export(exports, "parseCSSVariable", ()=>(0, _cssVariablesConversionMjs.parseCSSVariable));
parcelHelpers.export(exports, "getDefaultTransition", ()=>(0, _defaultTransitionsMjs.getDefaultTransition));
parcelHelpers.export(exports, "getFinalKeyframe", ()=>(0, _getFinalMjs.getFinalKeyframe));
parcelHelpers.export(exports, "getValueTransition", ()=>(0, _getValueTransitionMjs.getValueTransition));
parcelHelpers.export(exports, "resolveTransition", ()=>(0, _resolveTransitionMjs.resolveTransition));
parcelHelpers.export(exports, "containsCSSVariable", ()=>(0, _isCssVariableMjs.containsCSSVariable));
parcelHelpers.export(exports, "isCSSVariableName", ()=>(0, _isCssVariableMjs.isCSSVariableName));
parcelHelpers.export(exports, "isCSSVariableToken", ()=>(0, _isCssVariableMjs.isCSSVariableToken));
parcelHelpers.export(exports, "isTransitionDefined", ()=>(0, _isTransitionDefinedMjs.isTransitionDefined));
parcelHelpers.export(exports, "makeAnimationInstant", ()=>(0, _makeAnimationInstantMjs.makeAnimationInstant));
parcelHelpers.export(exports, "animateMotionValue", ()=>(0, _motionValueMjs.animateMotionValue));
parcelHelpers.export(exports, "animateVisualElement", ()=>(0, _visualElementMjs.animateVisualElement));
parcelHelpers.export(exports, "animateTarget", ()=>(0, _visualElementTargetMjs.animateTarget));
parcelHelpers.export(exports, "animateVariant", ()=>(0, _visualElementVariantMjs.animateVariant));
parcelHelpers.export(exports, "optimizedAppearDataAttribute", ()=>(0, _dataIdMjs.optimizedAppearDataAttribute));
parcelHelpers.export(exports, "optimizedAppearDataId", ()=>(0, _dataIdMjs.optimizedAppearDataId));
parcelHelpers.export(exports, "getOptimisedAppearId", ()=>(0, _getAppearIdMjs.getOptimisedAppearId));
parcelHelpers.export(exports, "inertia", ()=>(0, _inertiaMjs.inertia));
parcelHelpers.export(exports, "defaultEasing", ()=>(0, _keyframesMjs.defaultEasing));
parcelHelpers.export(exports, "keyframes", ()=>(0, _keyframesMjs.keyframes));
parcelHelpers.export(exports, "spring", ()=>(0, _springMjs.spring));
parcelHelpers.export(exports, "calcGeneratorDuration", ()=>(0, _calcDurationMjs.calcGeneratorDuration));
parcelHelpers.export(exports, "maxGeneratorDuration", ()=>(0, _calcDurationMjs.maxGeneratorDuration));
parcelHelpers.export(exports, "createGeneratorEasing", ()=>(0, _createGeneratorEasingMjs.createGeneratorEasing));
parcelHelpers.export(exports, "isGenerator", ()=>(0, _isGeneratorMjs.isGenerator));
parcelHelpers.export(exports, "DOMKeyframesResolver", ()=>(0, _domkeyframesResolverMjs.DOMKeyframesResolver));
parcelHelpers.export(exports, "KeyframeResolver", ()=>(0, _keyframesResolverMjs.KeyframeResolver));
parcelHelpers.export(exports, "flushKeyframeResolvers", ()=>(0, _keyframesResolverMjs.flushKeyframeResolvers));
parcelHelpers.export(exports, "defaultOffset", ()=>(0, _defaultMjs.defaultOffset));
parcelHelpers.export(exports, "fillOffset", ()=>(0, _fillMjs.fillOffset));
parcelHelpers.export(exports, "convertOffsetToTimes", ()=>(0, _timeMjs.convertOffsetToTimes));
parcelHelpers.export(exports, "applyPxDefaults", ()=>(0, _applyPxDefaultsMjs.applyPxDefaults));
parcelHelpers.export(exports, "fillWildcards", ()=>(0, _fillWildcardsMjs.fillWildcards));
parcelHelpers.export(exports, "cubicBezierAsString", ()=>(0, _cubicBezierMjs.cubicBezierAsString));
parcelHelpers.export(exports, "isWaapiSupportedEasing", ()=>(0, _isSupportedMjs.isWaapiSupportedEasing));
parcelHelpers.export(exports, "mapEasingToNativeEasing", ()=>(0, _mapEasingMjs.mapEasingToNativeEasing));
parcelHelpers.export(exports, "supportedWaapiEasing", ()=>(0, _supportedMjs.supportedWaapiEasing));
parcelHelpers.export(exports, "startWaapiAnimation", ()=>(0, _startWaapiAnimationMjs.startWaapiAnimation));
parcelHelpers.export(exports, "supportsPartialKeyframes", ()=>(0, _partialKeyframesMjs.supportsPartialKeyframes));
parcelHelpers.export(exports, "supportsBrowserAnimation", ()=>(0, _waapiMjs.supportsBrowserAnimation));
parcelHelpers.export(exports, "acceleratedValues", ()=>(0, _acceleratedValuesMjs.acceleratedValues));
parcelHelpers.export(exports, "applyGeneratorOptions", ()=>(0, _applyGeneratorMjs.applyGeneratorOptions));
parcelHelpers.export(exports, "generateLinearEasing", ()=>(0, _linearMjs.generateLinearEasing));
parcelHelpers.export(exports, "addAttrValue", ()=>(0, _indexMjs.addAttrValue));
parcelHelpers.export(exports, "attrEffect", ()=>(0, _indexMjs.attrEffect));
parcelHelpers.export(exports, "propEffect", ()=>(0, _indexMjs1.propEffect));
parcelHelpers.export(exports, "addStyleValue", ()=>(0, _indexMjs2.addStyleValue));
parcelHelpers.export(exports, "styleEffect", ()=>(0, _indexMjs2.styleEffect));
parcelHelpers.export(exports, "svgEffect", ()=>(0, _indexMjs3.svgEffect));
parcelHelpers.export(exports, "createRenderBatcher", ()=>(0, _batcherMjs.createRenderBatcher));
parcelHelpers.export(exports, "cancelMicrotask", ()=>(0, _microtaskMjs.cancelMicrotask));
parcelHelpers.export(exports, "microtask", ()=>(0, _microtaskMjs.microtask));
parcelHelpers.export(exports, "time", ()=>(0, _syncTimeMjs.time));
parcelHelpers.export(exports, "isDragActive", ()=>(0, _isActiveMjs.isDragActive));
parcelHelpers.export(exports, "isDragging", ()=>(0, _isActiveMjs.isDragging));
parcelHelpers.export(exports, "setDragLock", ()=>(0, _setActiveMjs.setDragLock));
parcelHelpers.export(exports, "hover", ()=>(0, _hoverMjs.hover));
parcelHelpers.export(exports, "press", ()=>(0, _indexMjs4.press));
parcelHelpers.export(exports, "isElementKeyboardAccessible", ()=>(0, _isKeyboardAccessibleMjs.isElementKeyboardAccessible));
parcelHelpers.export(exports, "isElementTextInput", ()=>(0, _isKeyboardAccessibleMjs.isElementTextInput));
parcelHelpers.export(exports, "isNodeOrChild", ()=>(0, _isNodeOrChildMjs.isNodeOrChild));
parcelHelpers.export(exports, "isPrimaryPointer", ()=>(0, _isPrimaryPointerMjs.isPrimaryPointer));
parcelHelpers.export(exports, "defaultTransformValue", ()=>(0, _parseTransformMjs.defaultTransformValue));
parcelHelpers.export(exports, "parseValueFromTransform", ()=>(0, _parseTransformMjs.parseValueFromTransform));
parcelHelpers.export(exports, "readTransformValue", ()=>(0, _parseTransformMjs.readTransformValue));
parcelHelpers.export(exports, "getComputedStyle", ()=>(0, _styleComputedMjs.getComputedStyle));
parcelHelpers.export(exports, "setStyle", ()=>(0, _styleSetMjs.setStyle));
parcelHelpers.export(exports, "isKeyframesTarget", ()=>(0, _isKeyframesTargetMjs.isKeyframesTarget));
parcelHelpers.export(exports, "positionalKeys", ()=>(0, _keysPositionMjs.positionalKeys));
parcelHelpers.export(exports, "transformPropOrder", ()=>(0, _keysTransformMjs.transformPropOrder));
parcelHelpers.export(exports, "transformProps", ()=>(0, _keysTransformMjs.transformProps));
parcelHelpers.export(exports, "resize", ()=>(0, _indexMjs5.resize));
parcelHelpers.export(exports, "observeTimeline", ()=>(0, _observeMjs.observeTimeline));
parcelHelpers.export(exports, "recordStats", ()=>(0, _indexMjs6.recordStats));
parcelHelpers.export(exports, "activeAnimations", ()=>(0, _animationCountMjs.activeAnimations));
parcelHelpers.export(exports, "statsBuffer", ()=>(0, _bufferMjs.statsBuffer));
parcelHelpers.export(exports, "interpolate", ()=>(0, _interpolateMjs.interpolate));
parcelHelpers.export(exports, "isHTMLElement", ()=>(0, _isHtmlElementMjs.isHTMLElement));
parcelHelpers.export(exports, "isSVGElement", ()=>(0, _isSvgElementMjs.isSVGElement));
parcelHelpers.export(exports, "isSVGSVGElement", ()=>(0, _isSvgSvgElementMjs.isSVGSVGElement));
parcelHelpers.export(exports, "mix", ()=>(0, _indexMjs7.mix));
parcelHelpers.export(exports, "mixColor", ()=>(0, _colorMjs.mixColor));
parcelHelpers.export(exports, "mixLinearColor", ()=>(0, _colorMjs.mixLinearColor));
parcelHelpers.export(exports, "getMixer", ()=>(0, _complexMjs.getMixer));
parcelHelpers.export(exports, "mixArray", ()=>(0, _complexMjs.mixArray));
parcelHelpers.export(exports, "mixComplex", ()=>(0, _complexMjs.mixComplex));
parcelHelpers.export(exports, "mixObject", ()=>(0, _complexMjs.mixObject));
parcelHelpers.export(exports, "mixImmediate", ()=>(0, _immediateMjs.mixImmediate));
parcelHelpers.export(exports, "mixNumber", ()=>(0, _numberMjs.mixNumber));
parcelHelpers.export(exports, "invisibleValues", ()=>(0, _visibilityMjs.invisibleValues));
parcelHelpers.export(exports, "mixVisibility", ()=>(0, _visibilityMjs.mixVisibility));
parcelHelpers.export(exports, "resolveElements", ()=>(0, _resolveElementsMjs.resolveElements));
parcelHelpers.export(exports, "getOriginIndex", ()=>(0, _staggerMjs.getOriginIndex));
parcelHelpers.export(exports, "stagger", ()=>(0, _staggerMjs.stagger));
parcelHelpers.export(exports, "supportsFlags", ()=>(0, _flagsMjs.supportsFlags));
parcelHelpers.export(exports, "supportsLinearEasing", ()=>(0, _linearEasingMjs.supportsLinearEasing));
parcelHelpers.export(exports, "supportsScrollTimeline", ()=>(0, _scrollTimelineMjs.supportsScrollTimeline));
parcelHelpers.export(exports, "supportsViewTimeline", ()=>(0, _scrollTimelineMjs.supportsViewTimeline));
parcelHelpers.export(exports, "transform", ()=>(0, _transformMjs.transform));
parcelHelpers.export(exports, "MotionValue", ()=>(0, _indexMjs8.MotionValue));
parcelHelpers.export(exports, "collectMotionValues", ()=>(0, _indexMjs8.collectMotionValues));
parcelHelpers.export(exports, "motionValue", ()=>(0, _indexMjs8.motionValue));
parcelHelpers.export(exports, "attachFollow", ()=>(0, _followValueMjs.attachFollow));
parcelHelpers.export(exports, "followValue", ()=>(0, _followValueMjs.followValue));
parcelHelpers.export(exports, "mapValue", ()=>(0, _mapValueMjs.mapValue));
parcelHelpers.export(exports, "attachSpring", ()=>(0, _springValueMjs.attachSpring));
parcelHelpers.export(exports, "springValue", ()=>(0, _springValueMjs.springValue));
parcelHelpers.export(exports, "transformValue", ()=>(0, _transformValueMjs.transformValue));
parcelHelpers.export(exports, "color", ()=>(0, _indexMjs9.color));
parcelHelpers.export(exports, "hex", ()=>(0, _hexMjs.hex));
parcelHelpers.export(exports, "hsla", ()=>(0, _hslaMjs.hsla));
parcelHelpers.export(exports, "hslaToRgba", ()=>(0, _hslaToRgbaMjs.hslaToRgba));
parcelHelpers.export(exports, "rgbUnit", ()=>(0, _rgbaMjs.rgbUnit));
parcelHelpers.export(exports, "rgba", ()=>(0, _rgbaMjs.rgba));
parcelHelpers.export(exports, "analyseComplexValue", ()=>(0, _indexMjs10.analyseComplexValue));
parcelHelpers.export(exports, "complex", ()=>(0, _indexMjs10.complex));
parcelHelpers.export(exports, "dimensionValueTypes", ()=>(0, _dimensionsMjs.dimensionValueTypes));
parcelHelpers.export(exports, "findDimensionValueType", ()=>(0, _dimensionsMjs.findDimensionValueType));
parcelHelpers.export(exports, "defaultValueTypes", ()=>(0, _defaultsMjs.defaultValueTypes));
parcelHelpers.export(exports, "getDefaultValueType", ()=>(0, _defaultsMjs.getDefaultValueType));
parcelHelpers.export(exports, "numberValueTypes", ()=>(0, _numberMjs1.numberValueTypes));
parcelHelpers.export(exports, "transformValueTypes", ()=>(0, _transformMjs1.transformValueTypes));
parcelHelpers.export(exports, "alpha", ()=>(0, _indexMjs11.alpha));
parcelHelpers.export(exports, "number", ()=>(0, _indexMjs11.number));
parcelHelpers.export(exports, "scale", ()=>(0, _indexMjs11.scale));
parcelHelpers.export(exports, "degrees", ()=>(0, _unitsMjs.degrees));
parcelHelpers.export(exports, "percent", ()=>(0, _unitsMjs.percent));
parcelHelpers.export(exports, "progressPercentage", ()=>(0, _unitsMjs.progressPercentage));
parcelHelpers.export(exports, "px", ()=>(0, _unitsMjs.px));
parcelHelpers.export(exports, "vh", ()=>(0, _unitsMjs.vh));
parcelHelpers.export(exports, "vw", ()=>(0, _unitsMjs.vw));
parcelHelpers.export(exports, "testValueType", ()=>(0, _testMjs.testValueType));
parcelHelpers.export(exports, "getAnimatableNone", ()=>(0, _animatableNoneMjs.getAnimatableNone));
parcelHelpers.export(exports, "findValueType", ()=>(0, _findMjs.findValueType));
parcelHelpers.export(exports, "getValueAsType", ()=>(0, _getAsTypeMjs.getValueAsType));
parcelHelpers.export(exports, "isMotionValue", ()=>(0, _isMotionValueMjs.isMotionValue));
parcelHelpers.export(exports, "addValueToWillChange", ()=>(0, _addWillChangeMjs.addValueToWillChange));
parcelHelpers.export(exports, "isWillChangeMotionValue", ()=>(0, _isMjs.isWillChangeMotionValue));
parcelHelpers.export(exports, "ViewTransitionBuilder", ()=>(0, _indexMjs12.ViewTransitionBuilder));
parcelHelpers.export(exports, "animateView", ()=>(0, _indexMjs12.animateView));
parcelHelpers.export(exports, "getViewAnimationLayerInfo", ()=>(0, _getLayerInfoMjs.getViewAnimationLayerInfo));
parcelHelpers.export(exports, "getViewAnimations", ()=>(0, _getViewAnimationsMjs.getViewAnimations));
parcelHelpers.export(exports, "DOMVisualElement", ()=>(0, _domvisualElementMjs.DOMVisualElement));
parcelHelpers.export(exports, "Feature", ()=>(0, _featureMjs.Feature));
parcelHelpers.export(exports, "HTMLVisualElement", ()=>(0, _htmlvisualElementMjs.HTMLVisualElement));
parcelHelpers.export(exports, "ObjectVisualElement", ()=>(0, _objectVisualElementMjs.ObjectVisualElement));
parcelHelpers.export(exports, "visualElementStore", ()=>(0, _storeMjs.visualElementStore));
parcelHelpers.export(exports, "SVGVisualElement", ()=>(0, _svgvisualElementMjs.SVGVisualElement));
parcelHelpers.export(exports, "VisualElement", ()=>(0, _visualElementMjs1.VisualElement));
parcelHelpers.export(exports, "getFeatureDefinitions", ()=>(0, _visualElementMjs1.getFeatureDefinitions));
parcelHelpers.export(exports, "setFeatureDefinitions", ()=>(0, _visualElementMjs1.setFeatureDefinitions));
parcelHelpers.export(exports, "checkVariantsDidChange", ()=>(0, _animationStateMjs.checkVariantsDidChange));
parcelHelpers.export(exports, "createAnimationState", ()=>(0, _animationStateMjs.createAnimationState));
parcelHelpers.export(exports, "getVariantContext", ()=>(0, _getVariantContextMjs.getVariantContext));
parcelHelpers.export(exports, "isAnimationControls", ()=>(0, _isAnimationControlsMjs.isAnimationControls));
parcelHelpers.export(exports, "isControllingVariants", ()=>(0, _isControllingVariantsMjs.isControllingVariants));
parcelHelpers.export(exports, "isVariantNode", ()=>(0, _isControllingVariantsMjs.isVariantNode));
parcelHelpers.export(exports, "isForcedMotionValue", ()=>(0, _isForcedMotionValueMjs.isForcedMotionValue));
parcelHelpers.export(exports, "isVariantLabel", ()=>(0, _isVariantLabelMjs.isVariantLabel));
parcelHelpers.export(exports, "updateMotionValuesFromProps", ()=>(0, _motionValuesMjs.updateMotionValuesFromProps));
parcelHelpers.export(exports, "resolveVariant", ()=>(0, _resolveDynamicVariantsMjs.resolveVariant));
parcelHelpers.export(exports, "resolveVariantFromProps", ()=>(0, _resolveVariantsMjs.resolveVariantFromProps));
parcelHelpers.export(exports, "setTarget", ()=>(0, _settersMjs.setTarget));
parcelHelpers.export(exports, "variantPriorityOrder", ()=>(0, _variantPropsMjs.variantPriorityOrder));
parcelHelpers.export(exports, "variantProps", ()=>(0, _variantPropsMjs.variantProps));
parcelHelpers.export(exports, "initPrefersReducedMotion", ()=>(0, _indexMjs13.initPrefersReducedMotion));
parcelHelpers.export(exports, "convertBoundingBoxToBox", ()=>(0, _conversionMjs.convertBoundingBoxToBox));
parcelHelpers.export(exports, "convertBoxToBoundingBox", ()=>(0, _conversionMjs.convertBoxToBoundingBox));
parcelHelpers.export(exports, "transformBoxPoints", ()=>(0, _conversionMjs.transformBoxPoints));
parcelHelpers.export(exports, "copyAxisDeltaInto", ()=>(0, _copyMjs.copyAxisDeltaInto));
parcelHelpers.export(exports, "copyAxisInto", ()=>(0, _copyMjs.copyAxisInto));
parcelHelpers.export(exports, "copyBoxInto", ()=>(0, _copyMjs.copyBoxInto));
parcelHelpers.export(exports, "applyAxisDelta", ()=>(0, _deltaApplyMjs.applyAxisDelta));
parcelHelpers.export(exports, "applyBoxDelta", ()=>(0, _deltaApplyMjs.applyBoxDelta));
parcelHelpers.export(exports, "applyPointDelta", ()=>(0, _deltaApplyMjs.applyPointDelta));
parcelHelpers.export(exports, "applyTreeDeltas", ()=>(0, _deltaApplyMjs.applyTreeDeltas));
parcelHelpers.export(exports, "scalePoint", ()=>(0, _deltaApplyMjs.scalePoint));
parcelHelpers.export(exports, "transformAxis", ()=>(0, _deltaApplyMjs.transformAxis));
parcelHelpers.export(exports, "transformBox", ()=>(0, _deltaApplyMjs.transformBox));
parcelHelpers.export(exports, "translateAxis", ()=>(0, _deltaApplyMjs.translateAxis));
parcelHelpers.export(exports, "calcAxisDelta", ()=>(0, _deltaCalcMjs.calcAxisDelta));
parcelHelpers.export(exports, "calcBoxDelta", ()=>(0, _deltaCalcMjs.calcBoxDelta));
parcelHelpers.export(exports, "calcLength", ()=>(0, _deltaCalcMjs.calcLength));
parcelHelpers.export(exports, "calcRelativeAxis", ()=>(0, _deltaCalcMjs.calcRelativeAxis));
parcelHelpers.export(exports, "calcRelativeAxisPosition", ()=>(0, _deltaCalcMjs.calcRelativeAxisPosition));
parcelHelpers.export(exports, "calcRelativeBox", ()=>(0, _deltaCalcMjs.calcRelativeBox));
parcelHelpers.export(exports, "calcRelativePosition", ()=>(0, _deltaCalcMjs.calcRelativePosition));
parcelHelpers.export(exports, "isNear", ()=>(0, _deltaCalcMjs.isNear));
parcelHelpers.export(exports, "removeAxisDelta", ()=>(0, _deltaRemoveMjs.removeAxisDelta));
parcelHelpers.export(exports, "removeAxisTransforms", ()=>(0, _deltaRemoveMjs.removeAxisTransforms));
parcelHelpers.export(exports, "removeBoxTransforms", ()=>(0, _deltaRemoveMjs.removeBoxTransforms));
parcelHelpers.export(exports, "removePointDelta", ()=>(0, _deltaRemoveMjs.removePointDelta));
parcelHelpers.export(exports, "createAxis", ()=>(0, _modelsMjs.createAxis));
parcelHelpers.export(exports, "createAxisDelta", ()=>(0, _modelsMjs.createAxisDelta));
parcelHelpers.export(exports, "createBox", ()=>(0, _modelsMjs.createBox));
parcelHelpers.export(exports, "createDelta", ()=>(0, _modelsMjs.createDelta));
parcelHelpers.export(exports, "aspectRatio", ()=>(0, _utilsMjs.aspectRatio));
parcelHelpers.export(exports, "axisDeltaEquals", ()=>(0, _utilsMjs.axisDeltaEquals));
parcelHelpers.export(exports, "axisEquals", ()=>(0, _utilsMjs.axisEquals));
parcelHelpers.export(exports, "axisEqualsRounded", ()=>(0, _utilsMjs.axisEqualsRounded));
parcelHelpers.export(exports, "boxEquals", ()=>(0, _utilsMjs.boxEquals));
parcelHelpers.export(exports, "boxEqualsRounded", ()=>(0, _utilsMjs.boxEqualsRounded));
parcelHelpers.export(exports, "isDeltaZero", ()=>(0, _utilsMjs.isDeltaZero));
parcelHelpers.export(exports, "eachAxis", ()=>(0, _eachAxisMjs.eachAxis));
parcelHelpers.export(exports, "has2DTranslate", ()=>(0, _hasTransformMjs.has2DTranslate));
parcelHelpers.export(exports, "hasScale", ()=>(0, _hasTransformMjs.hasScale));
parcelHelpers.export(exports, "hasTransform", ()=>(0, _hasTransformMjs.hasTransform));
parcelHelpers.export(exports, "measurePageBox", ()=>(0, _measureMjs.measurePageBox));
parcelHelpers.export(exports, "measureViewportBox", ()=>(0, _measureMjs.measureViewportBox));
parcelHelpers.export(exports, "correctBorderRadius", ()=>(0, _scaleBorderRadiusMjs.correctBorderRadius));
parcelHelpers.export(exports, "pixelsToPercent", ()=>(0, _scaleBorderRadiusMjs.pixelsToPercent));
parcelHelpers.export(exports, "correctBoxShadow", ()=>(0, _scaleBoxShadowMjs.correctBoxShadow));
parcelHelpers.export(exports, "buildProjectionTransform", ()=>(0, _transformMjs2.buildProjectionTransform));
parcelHelpers.export(exports, "mixValues", ()=>(0, _mixValuesMjs.mixValues));
parcelHelpers.export(exports, "animateSingleValue", ()=>(0, _singleValueMjs.animateSingleValue));
parcelHelpers.export(exports, "addDomEvent", ()=>(0, _addDomEventMjs.addDomEvent));
parcelHelpers.export(exports, "compareByDepth", ()=>(0, _compareByDepthMjs.compareByDepth));
parcelHelpers.export(exports, "FlatTree", ()=>(0, _flatTreeMjs.FlatTree));
parcelHelpers.export(exports, "delay", ()=>(0, _delayMjs.delay));
parcelHelpers.export(exports, "delayInSeconds", ()=>(0, _delayMjs.delayInSeconds));
parcelHelpers.export(exports, "resolveMotionValue", ()=>(0, _resolveMotionValueMjs.resolveMotionValue));
parcelHelpers.export(exports, "cleanDirtyNodes", ()=>(0, _createProjectionNodeMjs.cleanDirtyNodes));
parcelHelpers.export(exports, "createProjectionNode", ()=>(0, _createProjectionNodeMjs.createProjectionNode));
parcelHelpers.export(exports, "propagateDirtyNodes", ()=>(0, _createProjectionNodeMjs.propagateDirtyNodes));
parcelHelpers.export(exports, "DocumentProjectionNode", ()=>(0, _documentProjectionNodeMjs.DocumentProjectionNode));
parcelHelpers.export(exports, "nodeGroup", ()=>(0, _groupMjs.nodeGroup));
parcelHelpers.export(exports, "HTMLProjectionNode", ()=>(0, _htmlprojectionNodeMjs.HTMLProjectionNode));
parcelHelpers.export(exports, "rootProjectionNode", ()=>(0, _htmlprojectionNodeMjs.rootProjectionNode));
parcelHelpers.export(exports, "globalProjectionState", ()=>(0, _stateMjs.globalProjectionState));
parcelHelpers.export(exports, "NodeStack", ()=>(0, _stackMjs.NodeStack));
parcelHelpers.export(exports, "camelToDash", ()=>(0, _camelToDashMjs.camelToDash));
parcelHelpers.export(exports, "buildHTMLStyles", ()=>(0, _buildStylesMjs.buildHTMLStyles));
parcelHelpers.export(exports, "buildTransform", ()=>(0, _buildTransformMjs.buildTransform));
parcelHelpers.export(exports, "renderHTML", ()=>(0, _renderMjs.renderHTML));
parcelHelpers.export(exports, "scrapeHTMLMotionValuesFromProps", ()=>(0, _scrapeMotionValuesMjs.scrapeMotionValuesFromProps));
parcelHelpers.export(exports, "buildSVGAttrs", ()=>(0, _buildAttrsMjs.buildSVGAttrs));
parcelHelpers.export(exports, "camelCaseAttributes", ()=>(0, _camelCaseAttrsMjs.camelCaseAttributes));
parcelHelpers.export(exports, "isSVGTag", ()=>(0, _isSvgTagMjs.isSVGTag));
parcelHelpers.export(exports, "buildSVGPath", ()=>(0, _pathMjs.buildSVGPath));
parcelHelpers.export(exports, "renderSVG", ()=>(0, _renderMjs1.renderSVG));
parcelHelpers.export(exports, "scrapeSVGMotionValuesFromProps", ()=>(0, _scrapeMotionValuesMjs1.scrapeMotionValuesFromProps));
parcelHelpers.export(exports, "LayoutAnimationBuilder", ()=>(0, _layoutAnimationBuilderMjs.LayoutAnimationBuilder));
parcelHelpers.export(exports, "parseAnimateLayoutArgs", ()=>(0, _layoutAnimationBuilderMjs.parseAnimateLayoutArgs));
parcelHelpers.export(exports, "cancelSync", ()=>(0, _indexLegacyMjs.cancelSync));
parcelHelpers.export(exports, "sync", ()=>(0, _indexLegacyMjs.sync));
parcelHelpers.export(exports, "addScaleCorrector", ()=>(0, _scaleCorrectionMjs.addScaleCorrector));
parcelHelpers.export(exports, "scaleCorrectors", ()=>(0, _scaleCorrectionMjs.scaleCorrectors));
parcelHelpers.export(exports, "cancelFrame", ()=>(0, _frameMjs.cancelFrame));
parcelHelpers.export(exports, "frame", ()=>(0, _frameMjs.frame));
parcelHelpers.export(exports, "frameData", ()=>(0, _frameMjs.frameData));
parcelHelpers.export(exports, "frameSteps", ()=>(0, _frameMjs.frameSteps));
parcelHelpers.export(exports, "hasReducedMotionListener", ()=>(0, _stateMjs1.hasReducedMotionListener));
parcelHelpers.export(exports, "prefersReducedMotion", ()=>(0, _stateMjs1.prefersReducedMotion));
var _asyncMotionValueAnimationMjs = require("./animation/AsyncMotionValueAnimation.mjs");
var _groupAnimationMjs = require("./animation/GroupAnimation.mjs");
var _groupAnimationWithThenMjs = require("./animation/GroupAnimationWithThen.mjs");
var _jsanimationMjs = require("./animation/JSAnimation.mjs");
var _nativeAnimationMjs = require("./animation/NativeAnimation.mjs");
var _nativeAnimationExtendedMjs = require("./animation/NativeAnimationExtended.mjs");
var _nativeAnimationWrapperMjs = require("./animation/NativeAnimationWrapper.mjs");
var _activeAnimationsMjs = require("./animation/utils/active-animations.mjs");
var _calcChildStaggerMjs = require("./animation/utils/calc-child-stagger.mjs");
var _cssVariablesConversionMjs = require("./animation/utils/css-variables-conversion.mjs");
var _defaultTransitionsMjs = require("./animation/utils/default-transitions.mjs");
var _getFinalMjs = require("./animation/keyframes/get-final.mjs");
var _getValueTransitionMjs = require("./animation/utils/get-value-transition.mjs");
var _resolveTransitionMjs = require("./animation/utils/resolve-transition.mjs");
var _isCssVariableMjs = require("./animation/utils/is-css-variable.mjs");
var _isTransitionDefinedMjs = require("./animation/utils/is-transition-defined.mjs");
var _makeAnimationInstantMjs = require("./animation/utils/make-animation-instant.mjs");
var _motionValueMjs = require("./animation/interfaces/motion-value.mjs");
var _visualElementMjs = require("./animation/interfaces/visual-element.mjs");
var _visualElementTargetMjs = require("./animation/interfaces/visual-element-target.mjs");
var _visualElementVariantMjs = require("./animation/interfaces/visual-element-variant.mjs");
var _dataIdMjs = require("./animation/optimized-appear/data-id.mjs");
var _getAppearIdMjs = require("./animation/optimized-appear/get-appear-id.mjs");
var _inertiaMjs = require("./animation/generators/inertia.mjs");
var _keyframesMjs = require("./animation/generators/keyframes.mjs");
var _springMjs = require("./animation/generators/spring.mjs");
var _calcDurationMjs = require("./animation/generators/utils/calc-duration.mjs");
var _createGeneratorEasingMjs = require("./animation/generators/utils/create-generator-easing.mjs");
var _isGeneratorMjs = require("./animation/generators/utils/is-generator.mjs");
var _domkeyframesResolverMjs = require("./animation/keyframes/DOMKeyframesResolver.mjs");
var _keyframesResolverMjs = require("./animation/keyframes/KeyframesResolver.mjs");
var _defaultMjs = require("./animation/keyframes/offsets/default.mjs");
var _fillMjs = require("./animation/keyframes/offsets/fill.mjs");
var _timeMjs = require("./animation/keyframes/offsets/time.mjs");
var _applyPxDefaultsMjs = require("./animation/keyframes/utils/apply-px-defaults.mjs");
var _fillWildcardsMjs = require("./animation/keyframes/utils/fill-wildcards.mjs");
var _cubicBezierMjs = require("./animation/waapi/easing/cubic-bezier.mjs");
var _isSupportedMjs = require("./animation/waapi/easing/is-supported.mjs");
var _mapEasingMjs = require("./animation/waapi/easing/map-easing.mjs");
var _supportedMjs = require("./animation/waapi/easing/supported.mjs");
var _startWaapiAnimationMjs = require("./animation/waapi/start-waapi-animation.mjs");
var _partialKeyframesMjs = require("./animation/waapi/supports/partial-keyframes.mjs");
var _waapiMjs = require("./animation/waapi/supports/waapi.mjs");
var _acceleratedValuesMjs = require("./animation/waapi/utils/accelerated-values.mjs");
var _applyGeneratorMjs = require("./animation/waapi/utils/apply-generator.mjs");
var _linearMjs = require("./animation/waapi/utils/linear.mjs");
var _indexMjs = require("./effects/attr/index.mjs");
var _indexMjs1 = require("./effects/prop/index.mjs");
var _indexMjs2 = require("./effects/style/index.mjs");
var _indexMjs3 = require("./effects/svg/index.mjs");
var _batcherMjs = require("./frameloop/batcher.mjs");
var _microtaskMjs = require("./frameloop/microtask.mjs");
var _syncTimeMjs = require("./frameloop/sync-time.mjs");
var _isActiveMjs = require("./gestures/drag/state/is-active.mjs");
var _setActiveMjs = require("./gestures/drag/state/set-active.mjs");
var _hoverMjs = require("./gestures/hover.mjs");
var _indexMjs4 = require("./gestures/press/index.mjs");
var _isKeyboardAccessibleMjs = require("./gestures/press/utils/is-keyboard-accessible.mjs");
var _isNodeOrChildMjs = require("./gestures/utils/is-node-or-child.mjs");
var _isPrimaryPointerMjs = require("./gestures/utils/is-primary-pointer.mjs");
var _parseTransformMjs = require("./render/dom/parse-transform.mjs");
var _styleComputedMjs = require("./render/dom/style-computed.mjs");
var _styleSetMjs = require("./render/dom/style-set.mjs");
var _isKeyframesTargetMjs = require("./render/utils/is-keyframes-target.mjs");
var _keysPositionMjs = require("./render/utils/keys-position.mjs");
var _keysTransformMjs = require("./render/utils/keys-transform.mjs");
var _indexMjs5 = require("./resize/index.mjs");
var _observeMjs = require("./scroll/observe.mjs");
var _indexMjs6 = require("./stats/index.mjs");
var _animationCountMjs = require("./stats/animation-count.mjs");
var _bufferMjs = require("./stats/buffer.mjs");
var _interpolateMjs = require("./utils/interpolate.mjs");
var _isHtmlElementMjs = require("./utils/is-html-element.mjs");
var _isSvgElementMjs = require("./utils/is-svg-element.mjs");
var _isSvgSvgElementMjs = require("./utils/is-svg-svg-element.mjs");
var _indexMjs7 = require("./utils/mix/index.mjs");
var _colorMjs = require("./utils/mix/color.mjs");
var _complexMjs = require("./utils/mix/complex.mjs");
var _immediateMjs = require("./utils/mix/immediate.mjs");
var _numberMjs = require("./utils/mix/number.mjs");
var _visibilityMjs = require("./utils/mix/visibility.mjs");
var _resolveElementsMjs = require("./utils/resolve-elements.mjs");
var _staggerMjs = require("./utils/stagger.mjs");
var _flagsMjs = require("./utils/supports/flags.mjs");
var _linearEasingMjs = require("./utils/supports/linear-easing.mjs");
var _scrollTimelineMjs = require("./utils/supports/scroll-timeline.mjs");
var _transformMjs = require("./utils/transform.mjs");
var _indexMjs8 = require("./value/index.mjs");
var _followValueMjs = require("./value/follow-value.mjs");
var _mapValueMjs = require("./value/map-value.mjs");
var _springValueMjs = require("./value/spring-value.mjs");
var _transformValueMjs = require("./value/transform-value.mjs");
var _indexMjs9 = require("./value/types/color/index.mjs");
var _hexMjs = require("./value/types/color/hex.mjs");
var _hslaMjs = require("./value/types/color/hsla.mjs");
var _hslaToRgbaMjs = require("./value/types/color/hsla-to-rgba.mjs");
var _rgbaMjs = require("./value/types/color/rgba.mjs");
var _indexMjs10 = require("./value/types/complex/index.mjs");
var _dimensionsMjs = require("./value/types/dimensions.mjs");
var _defaultsMjs = require("./value/types/maps/defaults.mjs");
var _numberMjs1 = require("./value/types/maps/number.mjs");
var _transformMjs1 = require("./value/types/maps/transform.mjs");
var _indexMjs11 = require("./value/types/numbers/index.mjs");
var _unitsMjs = require("./value/types/numbers/units.mjs");
var _testMjs = require("./value/types/test.mjs");
var _animatableNoneMjs = require("./value/types/utils/animatable-none.mjs");
var _findMjs = require("./value/types/utils/find.mjs");
var _getAsTypeMjs = require("./value/types/utils/get-as-type.mjs");
var _isMotionValueMjs = require("./value/utils/is-motion-value.mjs");
var _addWillChangeMjs = require("./value/will-change/add-will-change.mjs");
var _isMjs = require("./value/will-change/is.mjs");
var _indexMjs12 = require("./view/index.mjs");
var _getLayerInfoMjs = require("./view/utils/get-layer-info.mjs");
var _getViewAnimationsMjs = require("./view/utils/get-view-animations.mjs");
var _domvisualElementMjs = require("./render/dom/DOMVisualElement.mjs");
var _featureMjs = require("./render/Feature.mjs");
var _htmlvisualElementMjs = require("./render/html/HTMLVisualElement.mjs");
var _objectVisualElementMjs = require("./render/object/ObjectVisualElement.mjs");
var _storeMjs = require("./render/store.mjs");
var _svgvisualElementMjs = require("./render/svg/SVGVisualElement.mjs");
var _visualElementMjs1 = require("./render/VisualElement.mjs");
var _animationStateMjs = require("./render/utils/animation-state.mjs");
var _getVariantContextMjs = require("./render/utils/get-variant-context.mjs");
var _isAnimationControlsMjs = require("./render/utils/is-animation-controls.mjs");
var _isControllingVariantsMjs = require("./render/utils/is-controlling-variants.mjs");
var _isForcedMotionValueMjs = require("./render/utils/is-forced-motion-value.mjs");
var _isVariantLabelMjs = require("./render/utils/is-variant-label.mjs");
var _motionValuesMjs = require("./render/utils/motion-values.mjs");
var _resolveDynamicVariantsMjs = require("./render/utils/resolve-dynamic-variants.mjs");
var _resolveVariantsMjs = require("./render/utils/resolve-variants.mjs");
var _settersMjs = require("./render/utils/setters.mjs");
var _variantPropsMjs = require("./render/utils/variant-props.mjs");
var _indexMjs13 = require("./render/utils/reduced-motion/index.mjs");
var _conversionMjs = require("./projection/geometry/conversion.mjs");
var _copyMjs = require("./projection/geometry/copy.mjs");
var _deltaApplyMjs = require("./projection/geometry/delta-apply.mjs");
var _deltaCalcMjs = require("./projection/geometry/delta-calc.mjs");
var _deltaRemoveMjs = require("./projection/geometry/delta-remove.mjs");
var _modelsMjs = require("./projection/geometry/models.mjs");
var _utilsMjs = require("./projection/geometry/utils.mjs");
var _eachAxisMjs = require("./projection/utils/each-axis.mjs");
var _hasTransformMjs = require("./projection/utils/has-transform.mjs");
var _measureMjs = require("./projection/utils/measure.mjs");
var _scaleBorderRadiusMjs = require("./projection/styles/scale-border-radius.mjs");
var _scaleBoxShadowMjs = require("./projection/styles/scale-box-shadow.mjs");
var _transformMjs2 = require("./projection/styles/transform.mjs");
var _mixValuesMjs = require("./projection/animation/mix-values.mjs");
var _singleValueMjs = require("./animation/animate/single-value.mjs");
var _addDomEventMjs = require("./events/add-dom-event.mjs");
var _compareByDepthMjs = require("./projection/utils/compare-by-depth.mjs");
var _flatTreeMjs = require("./projection/utils/flat-tree.mjs");
var _delayMjs = require("./utils/delay.mjs");
var _resolveMotionValueMjs = require("./value/utils/resolve-motion-value.mjs");
var _createProjectionNodeMjs = require("./projection/node/create-projection-node.mjs");
var _documentProjectionNodeMjs = require("./projection/node/DocumentProjectionNode.mjs");
var _groupMjs = require("./projection/node/group.mjs");
var _htmlprojectionNodeMjs = require("./projection/node/HTMLProjectionNode.mjs");
var _stateMjs = require("./projection/node/state.mjs");
var _stackMjs = require("./projection/shared/stack.mjs");
var _camelToDashMjs = require("./render/dom/utils/camel-to-dash.mjs");
var _buildStylesMjs = require("./render/html/utils/build-styles.mjs");
var _buildTransformMjs = require("./render/html/utils/build-transform.mjs");
var _renderMjs = require("./render/html/utils/render.mjs");
var _scrapeMotionValuesMjs = require("./render/html/utils/scrape-motion-values.mjs");
var _buildAttrsMjs = require("./render/svg/utils/build-attrs.mjs");
var _camelCaseAttrsMjs = require("./render/svg/utils/camel-case-attrs.mjs");
var _isSvgTagMjs = require("./render/svg/utils/is-svg-tag.mjs");
var _pathMjs = require("./render/svg/utils/path.mjs");
var _renderMjs1 = require("./render/svg/utils/render.mjs");
var _scrapeMotionValuesMjs1 = require("./render/svg/utils/scrape-motion-values.mjs");
var _layoutAnimationBuilderMjs = require("./layout/LayoutAnimationBuilder.mjs");
var _indexLegacyMjs = require("./frameloop/index-legacy.mjs");
var _scaleCorrectionMjs = require("./projection/styles/scale-correction.mjs");
var _frameMjs = require("./frameloop/frame.mjs");
var _stateMjs1 = require("./render/utils/reduced-motion/state.mjs");

},{"./animation/AsyncMotionValueAnimation.mjs":"ln4oa","./animation/GroupAnimation.mjs":"7hkDg","./animation/GroupAnimationWithThen.mjs":"E935f","./animation/JSAnimation.mjs":"hmfBB","./animation/NativeAnimation.mjs":"bnVN0","./animation/NativeAnimationExtended.mjs":"9lnJz","./animation/NativeAnimationWrapper.mjs":"1IfeU","./animation/utils/active-animations.mjs":"3gCCL","./animation/utils/calc-child-stagger.mjs":"hitnd","./animation/utils/css-variables-conversion.mjs":"j6uk3","./animation/utils/default-transitions.mjs":"dqKNa","./animation/keyframes/get-final.mjs":"914tK","./animation/utils/get-value-transition.mjs":"6hcoP","./animation/utils/resolve-transition.mjs":"ctmfM","./animation/utils/is-css-variable.mjs":"jfZBC","./animation/utils/is-transition-defined.mjs":"i2hQb","./animation/utils/make-animation-instant.mjs":"13ipP","./animation/interfaces/motion-value.mjs":"5NoWL","./animation/interfaces/visual-element.mjs":"a7b44","./animation/interfaces/visual-element-target.mjs":"3tujD","./animation/interfaces/visual-element-variant.mjs":"25yLb","./animation/optimized-appear/data-id.mjs":"9fex9","./animation/optimized-appear/get-appear-id.mjs":"cbcxg","./animation/generators/inertia.mjs":"bAsqb","./animation/generators/keyframes.mjs":"kLVN8","./animation/generators/spring.mjs":"1DO7Q","./animation/generators/utils/calc-duration.mjs":"jC7RK","./animation/generators/utils/create-generator-easing.mjs":"5qGPZ","./animation/generators/utils/is-generator.mjs":"fI1UZ","./animation/keyframes/DOMKeyframesResolver.mjs":"8PqS6","./animation/keyframes/KeyframesResolver.mjs":"aNL0j","./animation/keyframes/offsets/default.mjs":"2O2lC","./animation/keyframes/offsets/fill.mjs":"j8mup","./animation/keyframes/offsets/time.mjs":"fVEUO","./animation/keyframes/utils/apply-px-defaults.mjs":"6jvhs","./animation/keyframes/utils/fill-wildcards.mjs":"ePdwO","./animation/waapi/easing/cubic-bezier.mjs":"TGF1g","./animation/waapi/easing/is-supported.mjs":"7m2oZ","./animation/waapi/easing/map-easing.mjs":"4rOWo","./animation/waapi/easing/supported.mjs":"fof9P","./animation/waapi/start-waapi-animation.mjs":"kcu7p","./animation/waapi/supports/partial-keyframes.mjs":"f4TM4","./animation/waapi/supports/waapi.mjs":"4pfl7","./animation/waapi/utils/accelerated-values.mjs":"2tVvg","./animation/waapi/utils/apply-generator.mjs":"96wQp","./animation/waapi/utils/linear.mjs":"7F3AT","./effects/attr/index.mjs":"kh80d","./effects/prop/index.mjs":"6mW8K","./effects/style/index.mjs":"8JxT5","./effects/svg/index.mjs":"1CasU","./frameloop/batcher.mjs":"kAUIQ","./frameloop/microtask.mjs":"7uR6H","./frameloop/sync-time.mjs":"74aV8","./gestures/drag/state/is-active.mjs":"9v2ac","./gestures/drag/state/set-active.mjs":"IpnbG","./gestures/hover.mjs":"4tYFv","./gestures/press/index.mjs":"8GlfC","./gestures/press/utils/is-keyboard-accessible.mjs":"kU60h","./gestures/utils/is-node-or-child.mjs":"4Udis","./gestures/utils/is-primary-pointer.mjs":"5ALZe","./render/dom/parse-transform.mjs":"lnnQE","./render/dom/style-computed.mjs":"e4krJ","./render/dom/style-set.mjs":"lzPnK","./render/utils/is-keyframes-target.mjs":"2DP7E","./render/utils/keys-position.mjs":"5Qoar","./render/utils/keys-transform.mjs":"bJbLV","./resize/index.mjs":"3FQRk","./scroll/observe.mjs":"eJu1Y","./stats/index.mjs":"yxTcM","./stats/animation-count.mjs":"lEkpG","./stats/buffer.mjs":"94Uw8","./utils/interpolate.mjs":"8F7BJ","./utils/is-html-element.mjs":"8vTac","./utils/is-svg-element.mjs":"jqrAv","./utils/is-svg-svg-element.mjs":"a7f17","./utils/mix/index.mjs":"a3j1F","./utils/mix/color.mjs":"2lfV0","./utils/mix/complex.mjs":"d0Pfl","./utils/mix/immediate.mjs":"efYr9","./utils/mix/number.mjs":"91GSx","./utils/mix/visibility.mjs":"97pbW","./utils/resolve-elements.mjs":"pZkYr","./utils/stagger.mjs":"6ujIK","./utils/supports/flags.mjs":"fqH7Q","./utils/supports/linear-easing.mjs":"2AnQL","./utils/supports/scroll-timeline.mjs":"bbKge","./utils/transform.mjs":"54ksz","./value/index.mjs":"hX31g","./value/follow-value.mjs":"lcLCq","./value/map-value.mjs":"exPo0","./value/spring-value.mjs":"6u4Nr","./value/transform-value.mjs":"iCJCp","./value/types/color/index.mjs":"5J712","./value/types/color/hex.mjs":"lzelM","./value/types/color/hsla.mjs":"7LnvJ","./value/types/color/hsla-to-rgba.mjs":"8RJGJ","./value/types/color/rgba.mjs":"7hioC","./value/types/complex/index.mjs":"aBOw1","./value/types/dimensions.mjs":"hyZyT","./value/types/maps/defaults.mjs":"gMxw9","./value/types/maps/number.mjs":"jehqS","./value/types/maps/transform.mjs":"bH0aJ","./value/types/numbers/index.mjs":"hGTrH","./value/types/numbers/units.mjs":"aXLZR","./value/types/test.mjs":"bY55t","./value/types/utils/animatable-none.mjs":"1iM43","./value/types/utils/find.mjs":"iv21g","./value/types/utils/get-as-type.mjs":"5raY2","./value/utils/is-motion-value.mjs":"fKDJz","./value/will-change/add-will-change.mjs":"fVkj9","./value/will-change/is.mjs":"2r2wf","./view/index.mjs":"bCLqF","./view/utils/get-layer-info.mjs":"21pKt","./view/utils/get-view-animations.mjs":"4QNDL","./render/dom/DOMVisualElement.mjs":"cmuh9","./render/Feature.mjs":"2NZnJ","./render/html/HTMLVisualElement.mjs":"eQTgj","./render/object/ObjectVisualElement.mjs":"8FXBn","./render/store.mjs":"4d03k","./render/svg/SVGVisualElement.mjs":"id072","./render/VisualElement.mjs":"lVIcw","./render/utils/animation-state.mjs":"kHpbR","./render/utils/get-variant-context.mjs":"7T65F","./render/utils/is-animation-controls.mjs":"eZBfs","./render/utils/is-controlling-variants.mjs":"932u2","./render/utils/is-forced-motion-value.mjs":"3YH1U","./render/utils/is-variant-label.mjs":"9bqH5","./render/utils/motion-values.mjs":"dMLgg","./render/utils/resolve-dynamic-variants.mjs":"7PfV6","./render/utils/resolve-variants.mjs":"fFvtX","./render/utils/setters.mjs":"i6e2d","./render/utils/variant-props.mjs":"8WhrK","./render/utils/reduced-motion/index.mjs":"jII2O","./projection/geometry/conversion.mjs":"iGSIB","./projection/geometry/copy.mjs":"fNsM5","./projection/geometry/delta-apply.mjs":"iEf7c","./projection/geometry/delta-calc.mjs":"fywoX","./projection/geometry/delta-remove.mjs":"bpDGg","./projection/geometry/models.mjs":"5H0uu","./projection/geometry/utils.mjs":"41DAH","./projection/utils/each-axis.mjs":"6q1eY","./projection/utils/has-transform.mjs":"6BpuE","./projection/utils/measure.mjs":"jzMhe","./projection/styles/scale-border-radius.mjs":"4RSUY","./projection/styles/scale-box-shadow.mjs":"f97Mj","./projection/styles/transform.mjs":"1vFgW","./projection/animation/mix-values.mjs":"fuYQ7","./animation/animate/single-value.mjs":"eUA8b","./events/add-dom-event.mjs":"e11Be","./projection/utils/compare-by-depth.mjs":"RKiwB","./projection/utils/flat-tree.mjs":"1xjHX","./utils/delay.mjs":"Ua5cg","./value/utils/resolve-motion-value.mjs":"9TiOd","./projection/node/create-projection-node.mjs":"khfgR","./projection/node/DocumentProjectionNode.mjs":"3mFFY","./projection/node/group.mjs":"8n0Vk","./projection/node/HTMLProjectionNode.mjs":"2kn0n","./projection/node/state.mjs":"iPZeA","./projection/shared/stack.mjs":"7JjwZ","./render/dom/utils/camel-to-dash.mjs":"9nVP8","./render/html/utils/build-styles.mjs":"e1GuX","./render/html/utils/build-transform.mjs":"dq3X4","./render/html/utils/render.mjs":"hUnZX","./render/html/utils/scrape-motion-values.mjs":"504Ps","./render/svg/utils/build-attrs.mjs":"8wKO9","./render/svg/utils/camel-case-attrs.mjs":"kf3o7","./render/svg/utils/is-svg-tag.mjs":"cROGR","./render/svg/utils/path.mjs":"h0syE","./render/svg/utils/render.mjs":"6C8Mu","./render/svg/utils/scrape-motion-values.mjs":"iWJKc","./layout/LayoutAnimationBuilder.mjs":"av52f","./frameloop/index-legacy.mjs":"86tnH","./projection/styles/scale-correction.mjs":"4154g","./frameloop/frame.mjs":"4c192","./render/utils/reduced-motion/state.mjs":"2VFG9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ln4oa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AsyncMotionValueAnimation", ()=>AsyncMotionValueAnimation);
var _motionUtils = require("motion-utils");
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
var _jsanimationMjs = require("./JSAnimation.mjs");
var _getFinalMjs = require("./keyframes/get-final.mjs");
var _keyframesResolverMjs = require("./keyframes/KeyframesResolver.mjs");
var _nativeAnimationExtendedMjs = require("./NativeAnimationExtended.mjs");
var _canAnimateMjs = require("./utils/can-animate.mjs");
var _makeAnimationInstantMjs = require("./utils/make-animation-instant.mjs");
var _withPromiseMjs = require("./utils/WithPromise.mjs");
var _waapiMjs = require("./waapi/supports/waapi.mjs");
/**
 * Maximum time allowed between an animation being created and it being
 * resolved for us to use the latter as the start time.
 *
 * This is to ensure that while we prefer to "start" an animation as soon
 * as it's triggered, we also want to avoid a visual jump if there's a big delay
 * between these two moments.
 */ const MAX_RESOLVE_DELAY = 40;
class AsyncMotionValueAnimation extends (0, _withPromiseMjs.WithPromise) {
    constructor({ autoplay = true, delay = 0, type = "keyframes", repeat = 0, repeatDelay = 0, repeatType = "loop", keyframes, name, motionValue, element, ...options }){
        super();
        /**
         * Bound to support return animation.stop pattern
         */ this.stop = ()=>{
            if (this._animation) {
                this._animation.stop();
                this.stopTimeline?.();
            }
            this.keyframeResolver?.cancel();
        };
        this.createdAt = (0, _syncTimeMjs.time).now();
        const optionsWithDefaults = {
            autoplay,
            delay,
            type,
            repeat,
            repeatDelay,
            repeatType,
            name,
            motionValue,
            element,
            ...options
        };
        const KeyframeResolver$1 = element?.KeyframeResolver || (0, _keyframesResolverMjs.KeyframeResolver);
        this.keyframeResolver = new KeyframeResolver$1(keyframes, (resolvedKeyframes, finalKeyframe, forced)=>this.onKeyframesResolved(resolvedKeyframes, finalKeyframe, optionsWithDefaults, !forced), name, motionValue, element);
        this.keyframeResolver?.scheduleResolve();
    }
    onKeyframesResolved(keyframes, finalKeyframe, options, sync) {
        this.keyframeResolver = undefined;
        const { name, type, velocity, delay, isHandoff, onUpdate } = options;
        this.resolvedAt = (0, _syncTimeMjs.time).now();
        /**
         * If we can't animate this value with the resolved keyframes
         * then we should complete it immediately.
         */ let canAnimateValue = true;
        if (!(0, _canAnimateMjs.canAnimate)(keyframes, name, type, velocity)) {
            canAnimateValue = false;
            if ((0, _motionUtils.MotionGlobalConfig).instantAnimations || !delay) onUpdate?.((0, _getFinalMjs.getFinalKeyframe)(keyframes, options, finalKeyframe));
            keyframes[0] = keyframes[keyframes.length - 1];
            (0, _makeAnimationInstantMjs.makeAnimationInstant)(options);
            options.repeat = 0;
        }
        /**
         * Resolve startTime for the animation.
         *
         * This method uses the createdAt and resolvedAt to calculate the
         * animation startTime. *Ideally*, we would use the createdAt time as t=0
         * as the following frame would then be the first frame of the animation in
         * progress, which would feel snappier.
         *
         * However, if there's a delay (main thread work) between the creation of
         * the animation and the first committed frame, we prefer to use resolvedAt
         * to avoid a sudden jump into the animation.
         */ const startTime = sync ? !this.resolvedAt ? this.createdAt : this.resolvedAt - this.createdAt > MAX_RESOLVE_DELAY ? this.resolvedAt : this.createdAt : undefined;
        const resolvedOptions = {
            startTime,
            finalKeyframe,
            ...options,
            keyframes
        };
        /**
         * Animate via WAAPI if possible. If this is a handoff animation, the optimised animation will be running via
         * WAAPI. Therefore, this animation must be JS to ensure it runs "under" the
         * optimised animation.
         *
         * Also skip WAAPI when keyframes aren't animatable, as the resolved
         * values may not be valid CSS and would trigger browser warnings.
         */ const useWaapi = canAnimateValue && !isHandoff && (0, _waapiMjs.supportsBrowserAnimation)(resolvedOptions);
        const element = resolvedOptions.motionValue?.owner?.current;
        let animation;
        if (useWaapi) try {
            animation = new (0, _nativeAnimationExtendedMjs.NativeAnimationExtended)({
                ...resolvedOptions,
                element
            });
        } catch  {
            animation = new (0, _jsanimationMjs.JSAnimation)(resolvedOptions);
        }
        else animation = new (0, _jsanimationMjs.JSAnimation)(resolvedOptions);
        animation.finished.then(()=>{
            this.notifyFinished();
        }).catch((0, _motionUtils.noop));
        if (this.pendingTimeline) {
            this.stopTimeline = animation.attachTimeline(this.pendingTimeline);
            this.pendingTimeline = undefined;
        }
        this._animation = animation;
    }
    get finished() {
        if (!this._animation) return this._finished;
        else return this.animation.finished;
    }
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
    get animation() {
        if (!this._animation) {
            this.keyframeResolver?.resume();
            (0, _keyframesResolverMjs.flushKeyframeResolvers)();
        }
        return this._animation;
    }
    get duration() {
        return this.animation.duration;
    }
    get iterationDuration() {
        return this.animation.iterationDuration;
    }
    get time() {
        return this.animation.time;
    }
    set time(newTime) {
        this.animation.time = newTime;
    }
    get speed() {
        return this.animation.speed;
    }
    get state() {
        return this.animation.state;
    }
    set speed(newSpeed) {
        this.animation.speed = newSpeed;
    }
    get startTime() {
        return this.animation.startTime;
    }
    attachTimeline(timeline) {
        if (this._animation) this.stopTimeline = this.animation.attachTimeline(timeline);
        else this.pendingTimeline = timeline;
        return ()=>this.stop();
    }
    play() {
        this.animation.play();
    }
    pause() {
        this.animation.pause();
    }
    complete() {
        this.animation.complete();
    }
    cancel() {
        if (this._animation) this.animation.cancel();
        this.keyframeResolver?.cancel();
    }
}

},{"motion-utils":[["MotionGlobalConfig","jQhZ4"],["noop","1tDyg"]],"../frameloop/sync-time.mjs":"74aV8","./JSAnimation.mjs":"hmfBB","./keyframes/get-final.mjs":"914tK","./keyframes/KeyframesResolver.mjs":"aNL0j","./NativeAnimationExtended.mjs":"9lnJz","./utils/can-animate.mjs":"gyV2F","./utils/make-animation-instant.mjs":"13ipP","./utils/WithPromise.mjs":"iiiW5","./waapi/supports/waapi.mjs":"4pfl7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hmfBB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JSAnimation", ()=>JSAnimation);
parcelHelpers.export(exports, "animateValue", ()=>animateValue);
var _motionUtils = require("motion-utils");
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
var _animationCountMjs = require("../stats/animation-count.mjs");
var _indexMjs = require("../utils/mix/index.mjs");
var _frameMjs = require("./drivers/frame.mjs");
var _inertiaMjs = require("./generators/inertia.mjs");
var _keyframesMjs = require("./generators/keyframes.mjs");
var _calcDurationMjs = require("./generators/utils/calc-duration.mjs");
var _velocityMjs = require("./generators/utils/velocity.mjs");
var _getFinalMjs = require("./keyframes/get-final.mjs");
var _replaceTransitionTypeMjs = require("./utils/replace-transition-type.mjs");
var _withPromiseMjs = require("./utils/WithPromise.mjs");
const percentToProgress = (percent)=>percent / 100;
class JSAnimation extends (0, _withPromiseMjs.WithPromise) {
    constructor(options){
        super();
        this.state = "idle";
        this.startTime = null;
        this.isStopped = false;
        /**
         * The current time of the animation.
         */ this.currentTime = 0;
        /**
         * The time at which the animation was paused.
         */ this.holdTime = null;
        /**
         * Playback speed as a factor. 0 would be stopped, -1 reverse and 2 double speed.
         */ this.playbackSpeed = 1;
        /**
         * Reusable state object for the delay phase to avoid
         * allocating a new object every frame.
         */ this.delayState = {
            done: false,
            value: undefined
        };
        /**
         * This method is bound to the instance to fix a pattern where
         * animation.stop is returned as a reference from a useEffect.
         */ this.stop = ()=>{
            const { motionValue } = this.options;
            if (motionValue && motionValue.updatedAt !== (0, _syncTimeMjs.time).now()) this.tick((0, _syncTimeMjs.time).now());
            this.isStopped = true;
            if (this.state === "idle") return;
            this.teardown();
            this.options.onStop?.();
        };
        (0, _animationCountMjs.activeAnimations).mainThread++;
        this.options = options;
        this.initAnimation();
        this.play();
        if (options.autoplay === false) this.pause();
    }
    initAnimation() {
        const { options } = this;
        (0, _replaceTransitionTypeMjs.replaceTransitionType)(options);
        const { type = (0, _keyframesMjs.keyframes), repeat = 0, repeatDelay = 0, repeatType, velocity = 0 } = options;
        let { keyframes: keyframes$1 } = options;
        const generatorFactory = type || (0, _keyframesMjs.keyframes);
        if (generatorFactory !== (0, _keyframesMjs.keyframes) && typeof keyframes$1[0] !== "number") {
            this.mixKeyframes = (0, _motionUtils.pipe)(percentToProgress, (0, _indexMjs.mix)(keyframes$1[0], keyframes$1[1]));
            keyframes$1 = [
                0,
                100
            ];
        }
        const generator = generatorFactory({
            ...options,
            keyframes: keyframes$1
        });
        /**
         * If we have a mirror repeat type we need to create a second generator that outputs the
         * mirrored (not reversed) animation and later ping pong between the two generators.
         */ if (repeatType === "mirror") this.mirroredGenerator = generatorFactory({
            ...options,
            keyframes: [
                ...keyframes$1
            ].reverse(),
            velocity: -velocity
        });
        /**
         * If duration is undefined and we have repeat options,
         * we need to calculate a duration from the generator.
         *
         * We set it to the generator itself to cache the duration.
         * Any timeline resolver will need to have already precalculated
         * the duration by this step.
         */ if (generator.calculatedDuration === null) generator.calculatedDuration = (0, _calcDurationMjs.calcGeneratorDuration)(generator);
        const { calculatedDuration } = generator;
        this.calculatedDuration = calculatedDuration;
        this.resolvedDuration = calculatedDuration + repeatDelay;
        this.totalDuration = this.resolvedDuration * (repeat + 1) - repeatDelay;
        this.generator = generator;
    }
    updateTime(timestamp) {
        const animationTime = Math.round(timestamp - this.startTime) * this.playbackSpeed;
        // Update currentTime
        if (this.holdTime !== null) this.currentTime = this.holdTime;
        else // Rounding the time because floating point arithmetic is not always accurate, e.g. 3000.367 - 1000.367 =
        // 2000.0000000000002. This is a problem when we are comparing the currentTime with the duration, for
        // example.
        this.currentTime = animationTime;
    }
    tick(timestamp, sample = false) {
        const { generator, totalDuration, mixKeyframes, mirroredGenerator, resolvedDuration, calculatedDuration } = this;
        if (this.startTime === null) return generator.next(0);
        const { delay = 0, keyframes, repeat, repeatType, repeatDelay, type, onUpdate, finalKeyframe } = this.options;
        /**
         * requestAnimationFrame timestamps can come through as lower than
         * the startTime as set by performance.now(). Here we prevent this,
         * though in the future it could be possible to make setting startTime
         * a pending operation that gets resolved here.
         */ if (this.speed > 0) this.startTime = Math.min(this.startTime, timestamp);
        else if (this.speed < 0) this.startTime = Math.min(timestamp - totalDuration / this.speed, this.startTime);
        if (sample) this.currentTime = timestamp;
        else this.updateTime(timestamp);
        // Rebase on delay
        const timeWithoutDelay = this.currentTime - delay * (this.playbackSpeed >= 0 ? 1 : -1);
        const isInDelayPhase = this.playbackSpeed >= 0 ? timeWithoutDelay < 0 : timeWithoutDelay > totalDuration;
        this.currentTime = Math.max(timeWithoutDelay, 0);
        // If this animation has finished, set the current time  to the total duration.
        if (this.state === "finished" && this.holdTime === null) this.currentTime = totalDuration;
        let elapsed = this.currentTime;
        let frameGenerator = generator;
        if (repeat) {
            /**
             * Get the current progress (0-1) of the animation. If t is >
             * than duration we'll get values like 2.5 (midway through the
             * third iteration)
             */ const progress = Math.min(this.currentTime, totalDuration) / resolvedDuration;
            /**
             * Get the current iteration (0 indexed). For instance the floor of
             * 2.5 is 2.
             */ let currentIteration = Math.floor(progress);
            /**
             * Get the current progress of the iteration by taking the remainder
             * so 2.5 is 0.5 through iteration 2
             */ let iterationProgress = progress % 1.0;
            /**
             * If iteration progress is 1 we count that as the end
             * of the previous iteration.
             */ if (!iterationProgress && progress >= 1) iterationProgress = 1;
            iterationProgress === 1 && currentIteration--;
            currentIteration = Math.min(currentIteration, repeat + 1);
            /**
             * Reverse progress if we're not running in "normal" direction
             */ const isOddIteration = Boolean(currentIteration % 2);
            if (isOddIteration) {
                if (repeatType === "reverse") {
                    iterationProgress = 1 - iterationProgress;
                    if (repeatDelay) iterationProgress -= repeatDelay / resolvedDuration;
                } else if (repeatType === "mirror") frameGenerator = mirroredGenerator;
            }
            elapsed = (0, _motionUtils.clamp)(0, 1, iterationProgress) * resolvedDuration;
        }
        /**
         * If we're in negative time, set state as the initial keyframe.
         * This prevents delay: x, duration: 0 animations from finishing
         * instantly.
         */ let state;
        if (isInDelayPhase) {
            this.delayState.value = keyframes[0];
            state = this.delayState;
        } else state = frameGenerator.next(elapsed);
        if (mixKeyframes && !isInDelayPhase) state.value = mixKeyframes(state.value);
        let { done } = state;
        if (!isInDelayPhase && calculatedDuration !== null) done = this.playbackSpeed >= 0 ? this.currentTime >= totalDuration : this.currentTime <= 0;
        const isAnimationFinished = this.holdTime === null && (this.state === "finished" || this.state === "running" && done);
        // TODO: The exception for inertia could be cleaner here
        if (isAnimationFinished && type !== (0, _inertiaMjs.inertia)) state.value = (0, _getFinalMjs.getFinalKeyframe)(keyframes, this.options, finalKeyframe, this.speed);
        if (onUpdate) onUpdate(state.value);
        if (isAnimationFinished) this.finish();
        return state;
    }
    /**
     * Allows the returned animation to be awaited or promise-chained. Currently
     * resolves when the animation finishes at all but in a future update could/should
     * reject if its cancels.
     */ then(resolve, reject) {
        return this.finished.then(resolve, reject);
    }
    get duration() {
        return (0, _motionUtils.millisecondsToSeconds)(this.calculatedDuration);
    }
    get iterationDuration() {
        const { delay = 0 } = this.options || {};
        return this.duration + (0, _motionUtils.millisecondsToSeconds)(delay);
    }
    get time() {
        return (0, _motionUtils.millisecondsToSeconds)(this.currentTime);
    }
    set time(newTime) {
        newTime = (0, _motionUtils.secondsToMilliseconds)(newTime);
        this.currentTime = newTime;
        if (this.startTime === null || this.holdTime !== null || this.playbackSpeed === 0) this.holdTime = newTime;
        else if (this.driver) this.startTime = this.driver.now() - newTime / this.playbackSpeed;
        if (this.driver) this.driver.start(false);
        else {
            this.startTime = 0;
            this.state = "paused";
            this.holdTime = newTime;
            this.tick(newTime);
        }
    }
    /**
     * Returns the generator's velocity at the current time in units/second.
     * Uses the analytical derivative when available (springs), avoiding
     * the MotionValue's frame-dependent velocity estimation.
     */ getGeneratorVelocity() {
        const t = this.currentTime;
        if (t <= 0) return this.options.velocity || 0;
        if (this.generator.velocity) return this.generator.velocity(t);
        // Fallback: finite difference
        const current = this.generator.next(t).value;
        return (0, _velocityMjs.getGeneratorVelocity)((s)=>this.generator.next(s).value, t, current);
    }
    get speed() {
        return this.playbackSpeed;
    }
    set speed(newSpeed) {
        const hasChanged = this.playbackSpeed !== newSpeed;
        if (hasChanged && this.driver) this.updateTime((0, _syncTimeMjs.time).now());
        this.playbackSpeed = newSpeed;
        if (hasChanged && this.driver) this.time = (0, _motionUtils.millisecondsToSeconds)(this.currentTime);
    }
    play() {
        if (this.isStopped) return;
        const { driver = (0, _frameMjs.frameloopDriver), startTime } = this.options;
        if (!this.driver) this.driver = driver((timestamp)=>this.tick(timestamp));
        this.options.onPlay?.();
        const now = this.driver.now();
        if (this.state === "finished") {
            this.updateFinished();
            this.startTime = now;
        } else if (this.holdTime !== null) this.startTime = now - this.holdTime;
        else if (!this.startTime) this.startTime = startTime ?? now;
        if (this.state === "finished" && this.speed < 0) this.startTime += this.calculatedDuration;
        this.holdTime = null;
        /**
         * Set playState to running only after we've used it in
         * the previous logic.
         */ this.state = "running";
        this.driver.start();
    }
    pause() {
        this.state = "paused";
        this.updateTime((0, _syncTimeMjs.time).now());
        this.holdTime = this.currentTime;
    }
    complete() {
        if (this.state !== "running") this.play();
        this.state = "finished";
        this.holdTime = null;
    }
    finish() {
        this.notifyFinished();
        this.teardown();
        this.state = "finished";
        this.options.onComplete?.();
    }
    cancel() {
        this.holdTime = null;
        this.startTime = 0;
        this.tick(0);
        this.teardown();
        this.options.onCancel?.();
    }
    teardown() {
        this.state = "idle";
        this.stopDriver();
        this.startTime = this.holdTime = null;
        (0, _animationCountMjs.activeAnimations).mainThread--;
    }
    stopDriver() {
        if (!this.driver) return;
        this.driver.stop();
        this.driver = undefined;
    }
    sample(sampleTime) {
        this.startTime = 0;
        return this.tick(sampleTime, true);
    }
    attachTimeline(timeline) {
        if (this.options.allowFlatten) {
            this.options.type = "keyframes";
            this.options.ease = "linear";
            this.initAnimation();
        }
        this.driver?.stop();
        return timeline.observe(this);
    }
}
// Legacy function support
function animateValue(options) {
    return new JSAnimation(options);
}

},{"motion-utils":[["clamp","b78W4"],["millisecondsToSeconds","dIdtR"],["secondsToMilliseconds","dIdtR"],["pipe","lPgnn"]],"../frameloop/sync-time.mjs":"74aV8","../stats/animation-count.mjs":"lEkpG","../utils/mix/index.mjs":"a3j1F","./drivers/frame.mjs":"l9Npg","./generators/inertia.mjs":"bAsqb","./generators/keyframes.mjs":"kLVN8","./generators/utils/calc-duration.mjs":"jC7RK","./generators/utils/velocity.mjs":"1kSKh","./keyframes/get-final.mjs":"914tK","./utils/replace-transition-type.mjs":"lfBD4","./utils/WithPromise.mjs":"iiiW5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a3j1F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mix", ()=>mix);
var _complexMjs = require("./complex.mjs");
var _numberMjs = require("./number.mjs");
function mix(from, to, p) {
    if (typeof from === "number" && typeof to === "number" && typeof p === "number") return (0, _numberMjs.mixNumber)(from, to, p);
    const mixer = (0, _complexMjs.getMixer)(from);
    return mixer(from, to);
}

},{"./complex.mjs":"d0Pfl","./number.mjs":"91GSx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d0Pfl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMixer", ()=>getMixer);
parcelHelpers.export(exports, "mixArray", ()=>mixArray);
parcelHelpers.export(exports, "mixComplex", ()=>mixComplex);
parcelHelpers.export(exports, "mixObject", ()=>mixObject);
var _motionUtils = require("motion-utils");
var _isCssVariableMjs = require("../../animation/utils/is-css-variable.mjs");
var _indexMjs = require("../../value/types/color/index.mjs");
var _indexMjs1 = require("../../value/types/complex/index.mjs");
var _colorMjs = require("./color.mjs");
var _immediateMjs = require("./immediate.mjs");
var _numberMjs = require("./number.mjs");
var _visibilityMjs = require("./visibility.mjs");
function mixNumber(a, b) {
    return (p)=>(0, _numberMjs.mixNumber)(a, b, p);
}
function getMixer(a) {
    if (typeof a === "number") return mixNumber;
    else if (typeof a === "string") return (0, _isCssVariableMjs.isCSSVariableToken)(a) ? (0, _immediateMjs.mixImmediate) : (0, _indexMjs.color).test(a) ? (0, _colorMjs.mixColor) : mixComplex;
    else if (Array.isArray(a)) return mixArray;
    else if (typeof a === "object") return (0, _indexMjs.color).test(a) ? (0, _colorMjs.mixColor) : mixObject;
    return 0, _immediateMjs.mixImmediate;
}
function mixArray(a, b) {
    const output = [
        ...a
    ];
    const numValues = output.length;
    const blendValue = a.map((v, i)=>getMixer(v)(v, b[i]));
    return (p)=>{
        for(let i = 0; i < numValues; i++)output[i] = blendValue[i](p);
        return output;
    };
}
function mixObject(a, b) {
    const output = {
        ...a,
        ...b
    };
    const blendValue = {};
    for(const key in output)if (a[key] !== undefined && b[key] !== undefined) blendValue[key] = getMixer(a[key])(a[key], b[key]);
    return (v)=>{
        for(const key in blendValue)output[key] = blendValue[key](v);
        return output;
    };
}
function matchOrder(origin, target) {
    const orderedOrigin = [];
    const pointers = {
        color: 0,
        var: 0,
        number: 0
    };
    for(let i = 0; i < target.values.length; i++){
        const type = target.types[i];
        const originIndex = origin.indexes[type][pointers[type]];
        const originValue = origin.values[originIndex] ?? 0;
        orderedOrigin[i] = originValue;
        pointers[type]++;
    }
    return orderedOrigin;
}
const mixComplex = (origin, target)=>{
    const template = (0, _indexMjs1.complex).createTransformer(target);
    const originStats = (0, _indexMjs1.analyseComplexValue)(origin);
    const targetStats = (0, _indexMjs1.analyseComplexValue)(target);
    const canInterpolate = originStats.indexes.var.length === targetStats.indexes.var.length && originStats.indexes.color.length === targetStats.indexes.color.length && originStats.indexes.number.length >= targetStats.indexes.number.length;
    if (canInterpolate) {
        if ((0, _visibilityMjs.invisibleValues).has(origin) && !targetStats.values.length || (0, _visibilityMjs.invisibleValues).has(target) && !originStats.values.length) return (0, _visibilityMjs.mixVisibility)(origin, target);
        return (0, _motionUtils.pipe)(mixArray(matchOrder(originStats, targetStats), targetStats.values), template);
    } else {
        (0, _motionUtils.warning)(true, `Complex values '${origin}' and '${target}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`, "complex-values-different");
        return (0, _immediateMjs.mixImmediate)(origin, target);
    }
};

},{"motion-utils":[["pipe","lPgnn"],["warning","588wx"]],"../../animation/utils/is-css-variable.mjs":"jfZBC","../../value/types/color/index.mjs":"5J712","../../value/types/complex/index.mjs":"aBOw1","./color.mjs":"2lfV0","./immediate.mjs":"efYr9","./number.mjs":"91GSx","./visibility.mjs":"97pbW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2lfV0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixColor", ()=>mixColor);
parcelHelpers.export(exports, "mixLinearColor", ()=>mixLinearColor);
var _motionUtils = require("motion-utils");
var _hexMjs = require("../../value/types/color/hex.mjs");
var _hslaMjs = require("../../value/types/color/hsla.mjs");
var _hslaToRgbaMjs = require("../../value/types/color/hsla-to-rgba.mjs");
var _rgbaMjs = require("../../value/types/color/rgba.mjs");
var _immediateMjs = require("./immediate.mjs");
var _numberMjs = require("./number.mjs");
// Linear color space blending
// Explained https://www.youtube.com/watch?v=LKnqECcg6Gw
// Demonstrated http://codepen.io/osublake/pen/xGVVaN
const mixLinearColor = (from, to, v)=>{
    const fromExpo = from * from;
    const expo = v * (to * to - fromExpo) + fromExpo;
    return expo < 0 ? 0 : Math.sqrt(expo);
};
const colorTypes = [
    (0, _hexMjs.hex),
    (0, _rgbaMjs.rgba),
    (0, _hslaMjs.hsla)
];
const getColorType = (v)=>colorTypes.find((type)=>type.test(v));
function asRGBA(color) {
    const type = getColorType(color);
    (0, _motionUtils.warning)(Boolean(type), `'${color}' is not an animatable color. Use the equivalent color code instead.`, "color-not-animatable");
    if (!Boolean(type)) return false;
    let model = type.parse(color);
    if (type === (0, _hslaMjs.hsla)) // TODO Remove this cast - needed since Motion's stricter typing
    model = (0, _hslaToRgbaMjs.hslaToRgba)(model);
    return model;
}
const mixColor = (from, to)=>{
    const fromRGBA = asRGBA(from);
    const toRGBA = asRGBA(to);
    if (!fromRGBA || !toRGBA) return (0, _immediateMjs.mixImmediate)(from, to);
    const blended = {
        ...fromRGBA
    };
    return (v)=>{
        blended.red = mixLinearColor(fromRGBA.red, toRGBA.red, v);
        blended.green = mixLinearColor(fromRGBA.green, toRGBA.green, v);
        blended.blue = mixLinearColor(fromRGBA.blue, toRGBA.blue, v);
        blended.alpha = (0, _numberMjs.mixNumber)(fromRGBA.alpha, toRGBA.alpha, v);
        return (0, _rgbaMjs.rgba).transform(blended);
    };
};

},{"motion-utils":"588wx","../../value/types/color/hex.mjs":"lzelM","../../value/types/color/hsla.mjs":"7LnvJ","../../value/types/color/hsla-to-rgba.mjs":"8RJGJ","../../value/types/color/rgba.mjs":"7hioC","./immediate.mjs":"efYr9","./number.mjs":"91GSx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8RJGJ":[function(require,module,exports,__globalThis) {
// Adapted from https://gist.github.com/mjackson/5311256
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hslaToRgba", ()=>hslaToRgba);
function hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
function hslaToRgba({ hue, saturation, lightness, alpha }) {
    hue /= 360;
    saturation /= 100;
    lightness /= 100;
    let red = 0;
    let green = 0;
    let blue = 0;
    if (!saturation) red = green = blue = lightness;
    else {
        const q = lightness < 0.5 ? lightness * (1 + saturation) : lightness + saturation - lightness * saturation;
        const p = 2 * lightness - q;
        red = hueToRgb(p, q, hue + 1 / 3);
        green = hueToRgb(p, q, hue);
        blue = hueToRgb(p, q, hue - 1 / 3);
    }
    return {
        red: Math.round(red * 255),
        green: Math.round(green * 255),
        blue: Math.round(blue * 255),
        alpha
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"efYr9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixImmediate", ()=>mixImmediate);
function mixImmediate(a, b) {
    return (p)=>p > 0 ? b : a;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"97pbW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "invisibleValues", ()=>invisibleValues);
parcelHelpers.export(exports, "mixVisibility", ()=>mixVisibility);
const invisibleValues = new Set([
    "none",
    "hidden"
]);
/**
 * Returns a function that, when provided a progress value between 0 and 1,
 * will return the "none" or "hidden" string only when the progress is that of
 * the origin or target.
 */ function mixVisibility(origin, target) {
    if (invisibleValues.has(origin)) return (p)=>p <= 0 ? origin : target;
    else return (p)=>p >= 1 ? target : origin;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l9Npg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "frameloopDriver", ()=>frameloopDriver);
var _syncTimeMjs = require("../../frameloop/sync-time.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
const frameloopDriver = (update)=>{
    const passTimestamp = ({ timestamp })=>update(timestamp);
    return {
        start: (keepAlive = true)=>(0, _frameMjs.frame).update(passTimestamp, keepAlive),
        stop: ()=>(0, _frameMjs.cancelFrame)(passTimestamp),
        /**
         * If we're processing this frame we can use the
         * framelocked timestamp to keep things in sync.
         */ now: ()=>(0, _frameMjs.frameData).isProcessing ? (0, _frameMjs.frameData).timestamp : (0, _syncTimeMjs.time).now()
    };
};

},{"../../frameloop/sync-time.mjs":"74aV8","../../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bAsqb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inertia", ()=>inertia);
var _springMjs = require("./spring.mjs");
var _velocityMjs = require("./utils/velocity.mjs");
function inertia({ keyframes, velocity = 0.0, power = 0.8, timeConstant = 325, bounceDamping = 10, bounceStiffness = 500, modifyTarget, min, max, restDelta = 0.5, restSpeed }) {
    const origin = keyframes[0];
    const state = {
        done: false,
        value: origin
    };
    const isOutOfBounds = (v)=>min !== undefined && v < min || max !== undefined && v > max;
    const nearestBoundary = (v)=>{
        if (min === undefined) return max;
        if (max === undefined) return min;
        return Math.abs(min - v) < Math.abs(max - v) ? min : max;
    };
    let amplitude = power * velocity;
    const ideal = origin + amplitude;
    const target = modifyTarget === undefined ? ideal : modifyTarget(ideal);
    /**
     * If the target has changed we need to re-calculate the amplitude, otherwise
     * the animation will start from the wrong position.
     */ if (target !== ideal) amplitude = target - origin;
    const calcDelta = (t)=>-amplitude * Math.exp(-t / timeConstant);
    const calcLatest = (t)=>target + calcDelta(t);
    const applyFriction = (t)=>{
        const delta = calcDelta(t);
        const latest = calcLatest(t);
        state.done = Math.abs(delta) <= restDelta;
        state.value = state.done ? target : latest;
    };
    /**
     * Ideally this would resolve for t in a stateless way, we could
     * do that by always precalculating the animation but as we know
     * this will be done anyway we can assume that spring will
     * be discovered during that.
     */ let timeReachedBoundary;
    let spring$1;
    const checkCatchBoundary = (t)=>{
        if (!isOutOfBounds(state.value)) return;
        timeReachedBoundary = t;
        spring$1 = (0, _springMjs.spring)({
            keyframes: [
                state.value,
                nearestBoundary(state.value)
            ],
            velocity: (0, _velocityMjs.getGeneratorVelocity)(calcLatest, t, state.value),
            damping: bounceDamping,
            stiffness: bounceStiffness,
            restDelta,
            restSpeed
        });
    };
    checkCatchBoundary(0);
    return {
        calculatedDuration: null,
        next: (t)=>{
            /**
             * We need to resolve the friction to figure out if we need a
             * spring but we don't want to do this twice per frame. So here
             * we flag if we updated for this frame and later if we did
             * we can skip doing it again.
             */ let hasUpdatedFrame = false;
            if (!spring$1 && timeReachedBoundary === undefined) {
                hasUpdatedFrame = true;
                applyFriction(t);
                checkCatchBoundary(t);
            }
            /**
             * If we have a spring and the provided t is beyond the moment the friction
             * animation crossed the min/max boundary, use the spring.
             */ if (timeReachedBoundary !== undefined && t >= timeReachedBoundary) return spring$1.next(t - timeReachedBoundary);
            else {
                !hasUpdatedFrame && applyFriction(t);
                return state;
            }
        }
    };
}

},{"./spring.mjs":"1DO7Q","./utils/velocity.mjs":"1kSKh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1DO7Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "spring", ()=>spring);
var _motionUtils = require("motion-utils");
var _linearMjs = require("../waapi/utils/linear.mjs");
var _calcDurationMjs = require("./utils/calc-duration.mjs");
var _createGeneratorEasingMjs = require("./utils/create-generator-easing.mjs");
const springDefaults = {
    // Default spring physics
    stiffness: 100,
    damping: 10,
    mass: 1.0,
    velocity: 0.0,
    // Default duration/bounce-based options
    duration: 800,
    bounce: 0.3,
    visualDuration: 0.3,
    // Rest thresholds
    restSpeed: {
        granular: 0.01,
        default: 2
    },
    restDelta: {
        granular: 0.005,
        default: 0.5
    },
    // Limits
    minDuration: 0.01,
    maxDuration: 10.0,
    minDamping: 0.05,
    maxDamping: 1
};
function calcAngularFreq(undampedFreq, dampingRatio) {
    return undampedFreq * Math.sqrt(1 - dampingRatio * dampingRatio);
}
const rootIterations = 12;
function approximateRoot(envelope, derivative, initialGuess) {
    let result = initialGuess;
    for(let i = 1; i < rootIterations; i++)result = result - envelope(result) / derivative(result);
    return result;
}
/**
 * This is ported from the Framer implementation of duration-based spring resolution.
 */ const safeMin = 0.001;
function findSpring({ duration = springDefaults.duration, bounce = springDefaults.bounce, velocity = springDefaults.velocity, mass = springDefaults.mass }) {
    let envelope;
    let derivative;
    (0, _motionUtils.warning)(duration <= (0, _motionUtils.secondsToMilliseconds)(springDefaults.maxDuration), "Spring duration must be 10 seconds or less", "spring-duration-limit");
    let dampingRatio = 1 - bounce;
    /**
     * Restrict dampingRatio and duration to within acceptable ranges.
     */ dampingRatio = (0, _motionUtils.clamp)(springDefaults.minDamping, springDefaults.maxDamping, dampingRatio);
    duration = (0, _motionUtils.clamp)(springDefaults.minDuration, springDefaults.maxDuration, (0, _motionUtils.millisecondsToSeconds)(duration));
    if (dampingRatio < 1) {
        /**
         * Underdamped spring
         */ envelope = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const a = exponentialDecay - velocity;
            const b = calcAngularFreq(undampedFreq, dampingRatio);
            const c = Math.exp(-delta);
            return safeMin - a / b * c;
        };
        derivative = (undampedFreq)=>{
            const exponentialDecay = undampedFreq * dampingRatio;
            const delta = exponentialDecay * duration;
            const d = delta * velocity + velocity;
            const e = Math.pow(dampingRatio, 2) * Math.pow(undampedFreq, 2) * duration;
            const f = Math.exp(-delta);
            const g = calcAngularFreq(Math.pow(undampedFreq, 2), dampingRatio);
            const factor = -envelope(undampedFreq) + safeMin > 0 ? -1 : 1;
            return factor * ((d - e) * f) / g;
        };
    } else {
        /**
         * Critically-damped spring
         */ envelope = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (undampedFreq - velocity) * duration + 1;
            return -safeMin + a * b;
        };
        derivative = (undampedFreq)=>{
            const a = Math.exp(-undampedFreq * duration);
            const b = (velocity - undampedFreq) * (duration * duration);
            return a * b;
        };
    }
    const initialGuess = 5 / duration;
    const undampedFreq = approximateRoot(envelope, derivative, initialGuess);
    duration = (0, _motionUtils.secondsToMilliseconds)(duration);
    if (isNaN(undampedFreq)) return {
        stiffness: springDefaults.stiffness,
        damping: springDefaults.damping,
        duration
    };
    else {
        const stiffness = Math.pow(undampedFreq, 2) * mass;
        return {
            stiffness,
            damping: dampingRatio * 2 * Math.sqrt(mass * stiffness),
            duration
        };
    }
}
const durationKeys = [
    "duration",
    "bounce"
];
const physicsKeys = [
    "stiffness",
    "damping",
    "mass"
];
function isSpringType(options, keys) {
    return keys.some((key)=>options[key] !== undefined);
}
function getSpringOptions(options) {
    let springOptions = {
        velocity: springDefaults.velocity,
        stiffness: springDefaults.stiffness,
        damping: springDefaults.damping,
        mass: springDefaults.mass,
        isResolvedFromDuration: false,
        ...options
    };
    // stiffness/damping/mass overrides duration/bounce
    if (!isSpringType(options, physicsKeys) && isSpringType(options, durationKeys)) {
        // Time-defined springs should ignore inherited velocity.
        // Velocity from interrupted animations can cause findSpring()
        // to compute wildly different spring parameters, leading to
        // massive oscillation on small-range animations.
        springOptions.velocity = 0;
        if (options.visualDuration) {
            const visualDuration = options.visualDuration;
            const root = 2 * Math.PI / (visualDuration * 1.2);
            const stiffness = root * root;
            const damping = 2 * (0, _motionUtils.clamp)(0.05, 1, 1 - (options.bounce || 0)) * Math.sqrt(stiffness);
            springOptions = {
                ...springOptions,
                mass: springDefaults.mass,
                stiffness,
                damping
            };
        } else {
            const derived = findSpring({
                ...options,
                velocity: 0
            });
            springOptions = {
                ...springOptions,
                ...derived,
                mass: springDefaults.mass
            };
            springOptions.isResolvedFromDuration = true;
        }
    }
    return springOptions;
}
function spring(optionsOrVisualDuration = springDefaults.visualDuration, bounce = springDefaults.bounce) {
    const options = typeof optionsOrVisualDuration !== "object" ? {
        visualDuration: optionsOrVisualDuration,
        keyframes: [
            0,
            1
        ],
        bounce
    } : optionsOrVisualDuration;
    let { restSpeed, restDelta } = options;
    const origin = options.keyframes[0];
    const target = options.keyframes[options.keyframes.length - 1];
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: origin
    };
    const { stiffness, damping, mass, duration, velocity, isResolvedFromDuration } = getSpringOptions({
        ...options,
        velocity: -(0, _motionUtils.millisecondsToSeconds)(options.velocity || 0)
    });
    const initialVelocity = velocity || 0.0;
    const dampingRatio = damping / (2 * Math.sqrt(stiffness * mass));
    const initialDelta = target - origin;
    const undampedAngularFreq = (0, _motionUtils.millisecondsToSeconds)(Math.sqrt(stiffness / mass));
    /**
     * If we're working on a granular scale, use smaller defaults for determining
     * when the spring is finished.
     *
     * These defaults have been selected emprically based on what strikes a good
     * ratio between feeling good and finishing as soon as changes are imperceptible.
     */ const isGranularScale = Math.abs(initialDelta) < 5;
    restSpeed || (restSpeed = isGranularScale ? springDefaults.restSpeed.granular : springDefaults.restSpeed.default);
    restDelta || (restDelta = isGranularScale ? springDefaults.restDelta.granular : springDefaults.restDelta.default);
    let resolveSpring;
    let resolveVelocity;
    // Underdamped coefficients, hoisted for use in the inlined next() hot path
    let angularFreq;
    let A;
    let sinCoeff;
    let cosCoeff;
    if (dampingRatio < 1) {
        angularFreq = calcAngularFreq(undampedAngularFreq, dampingRatio);
        A = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / angularFreq;
        // Underdamped spring
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return target - envelope * (A * Math.sin(angularFreq * t) + initialDelta * Math.cos(angularFreq * t));
        };
        // Analytical derivative of underdamped spring (px/ms)
        sinCoeff = dampingRatio * undampedAngularFreq * A + initialDelta * angularFreq;
        cosCoeff = dampingRatio * undampedAngularFreq * initialDelta - A * angularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            return envelope * (sinCoeff * Math.sin(angularFreq * t) + cosCoeff * Math.cos(angularFreq * t));
        };
    } else if (dampingRatio === 1) {
        // Critically damped spring
        resolveSpring = (t)=>target - Math.exp(-undampedAngularFreq * t) * (initialDelta + (initialVelocity + undampedAngularFreq * initialDelta) * t);
        // Analytical derivative of critically damped spring (px/ms)
        const C = initialVelocity + undampedAngularFreq * initialDelta;
        resolveVelocity = (t)=>Math.exp(-undampedAngularFreq * t) * (undampedAngularFreq * C * t - initialVelocity);
    } else {
        // Overdamped spring
        const dampedAngularFreq = undampedAngularFreq * Math.sqrt(dampingRatio * dampingRatio - 1);
        resolveSpring = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            // When performing sinh or cosh values can hit Infinity so we cap them here
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return target - envelope * ((initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) * Math.sinh(freqForT) + dampedAngularFreq * initialDelta * Math.cosh(freqForT)) / dampedAngularFreq;
        };
        // Analytical derivative of overdamped spring (px/ms)
        const P = (initialVelocity + dampingRatio * undampedAngularFreq * initialDelta) / dampedAngularFreq;
        const sinhCoeff = dampingRatio * undampedAngularFreq * P - initialDelta * dampedAngularFreq;
        const coshCoeff = dampingRatio * undampedAngularFreq * initialDelta - P * dampedAngularFreq;
        resolveVelocity = (t)=>{
            const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
            const freqForT = Math.min(dampedAngularFreq * t, 300);
            return envelope * (sinhCoeff * Math.sinh(freqForT) + coshCoeff * Math.cosh(freqForT));
        };
    }
    const generator = {
        calculatedDuration: isResolvedFromDuration ? duration || null : null,
        velocity: (t)=>(0, _motionUtils.secondsToMilliseconds)(resolveVelocity(t)),
        next: (t)=>{
            /**
             * For underdamped physics springs we need both position and
             * velocity each tick. Compute shared trig values once to avoid
             * duplicate Math.exp/sin/cos calls on the hot path.
             */ if (!isResolvedFromDuration && dampingRatio < 1) {
                const envelope = Math.exp(-dampingRatio * undampedAngularFreq * t);
                const sin = Math.sin(angularFreq * t);
                const cos = Math.cos(angularFreq * t);
                const current = target - envelope * (A * sin + initialDelta * cos);
                const currentVelocity = (0, _motionUtils.secondsToMilliseconds)(envelope * (sinCoeff * sin + cosCoeff * cos));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
                state.value = state.done ? target : current;
                return state;
            }
            const current = resolveSpring(t);
            if (!isResolvedFromDuration) {
                const currentVelocity = (0, _motionUtils.secondsToMilliseconds)(resolveVelocity(t));
                state.done = Math.abs(currentVelocity) <= restSpeed && Math.abs(target - current) <= restDelta;
            } else state.done = t >= duration;
            state.value = state.done ? target : current;
            return state;
        },
        toString: ()=>{
            const calculatedDuration = Math.min((0, _calcDurationMjs.calcGeneratorDuration)(generator), (0, _calcDurationMjs.maxGeneratorDuration));
            const easing = (0, _linearMjs.generateLinearEasing)((progress)=>generator.next(calculatedDuration * progress).value, calculatedDuration, 30);
            return calculatedDuration + "ms " + easing;
        },
        toTransition: ()=>{}
    };
    return generator;
}
spring.applyToOptions = (options)=>{
    const generatorOptions = (0, _createGeneratorEasingMjs.createGeneratorEasing)(options, 100, spring);
    options.ease = generatorOptions.ease;
    options.duration = (0, _motionUtils.secondsToMilliseconds)(generatorOptions.duration);
    options.type = "keyframes";
    return options;
};

},{"motion-utils":[["clamp","b78W4"],["millisecondsToSeconds","dIdtR"],["secondsToMilliseconds","dIdtR"],["warning","588wx"]],"../waapi/utils/linear.mjs":"7F3AT","./utils/calc-duration.mjs":"jC7RK","./utils/create-generator-easing.mjs":"5qGPZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jC7RK":[function(require,module,exports,__globalThis) {
/**
 * Implement a practical max duration for keyframe generation
 * to prevent infinite loops
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcGeneratorDuration", ()=>calcGeneratorDuration);
parcelHelpers.export(exports, "maxGeneratorDuration", ()=>maxGeneratorDuration);
const maxGeneratorDuration = 20000;
function calcGeneratorDuration(generator) {
    let duration = 0;
    const timeStep = 50;
    let state = generator.next(duration);
    while(!state.done && duration < maxGeneratorDuration){
        duration += timeStep;
        state = generator.next(duration);
    }
    return duration >= maxGeneratorDuration ? Infinity : duration;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5qGPZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createGeneratorEasing", ()=>createGeneratorEasing);
var _motionUtils = require("motion-utils");
var _calcDurationMjs = require("./calc-duration.mjs");
/**
 * Create a progress => progress easing function from a generator.
 */ function createGeneratorEasing(options, scale = 100, createGenerator) {
    const generator = createGenerator({
        ...options,
        keyframes: [
            0,
            scale
        ]
    });
    const duration = Math.min((0, _calcDurationMjs.calcGeneratorDuration)(generator), (0, _calcDurationMjs.maxGeneratorDuration));
    return {
        type: "keyframes",
        ease: (progress)=>{
            return generator.next(duration * progress).value / scale;
        },
        duration: (0, _motionUtils.millisecondsToSeconds)(duration)
    };
}

},{"motion-utils":"dIdtR","./calc-duration.mjs":"jC7RK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1kSKh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getGeneratorVelocity", ()=>getGeneratorVelocity);
var _motionUtils = require("motion-utils");
const velocitySampleDuration = 5; // ms
function getGeneratorVelocity(resolveValue, t, current) {
    const prevT = Math.max(t - velocitySampleDuration, 0);
    return (0, _motionUtils.velocityPerSecond)(current - resolveValue(prevT), t - prevT);
}

},{"motion-utils":"drsSU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kLVN8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultEasing", ()=>defaultEasing);
parcelHelpers.export(exports, "keyframes", ()=>keyframes);
var _motionUtils = require("motion-utils");
var _interpolateMjs = require("../../utils/interpolate.mjs");
var _defaultMjs = require("../keyframes/offsets/default.mjs");
var _timeMjs = require("../keyframes/offsets/time.mjs");
function defaultEasing(values, easing) {
    return values.map(()=>easing || (0, _motionUtils.easeInOut)).splice(0, values.length - 1);
}
function keyframes({ duration = 300, keyframes: keyframeValues, times, ease = "easeInOut" }) {
    /**
     * Easing functions can be externally defined as strings. Here we convert them
     * into actual functions.
     */ const easingFunctions = (0, _motionUtils.isEasingArray)(ease) ? ease.map((0, _motionUtils.easingDefinitionToFunction)) : (0, _motionUtils.easingDefinitionToFunction)(ease);
    /**
     * This is the Iterator-spec return value. We ensure it's mutable rather than using a generator
     * to reduce GC during animation.
     */ const state = {
        done: false,
        value: keyframeValues[0]
    };
    /**
     * Create a times array based on the provided 0-1 offsets
     */ const absoluteTimes = (0, _timeMjs.convertOffsetToTimes)(// Only use the provided offsets if they're the correct length
    // TODO Maybe we should warn here if there's a length mismatch
    times && times.length === keyframeValues.length ? times : (0, _defaultMjs.defaultOffset)(keyframeValues), duration);
    const mapTimeToKeyframe = (0, _interpolateMjs.interpolate)(absoluteTimes, keyframeValues, {
        ease: Array.isArray(easingFunctions) ? easingFunctions : defaultEasing(keyframeValues, easingFunctions)
    });
    return {
        calculatedDuration: duration,
        next: (t)=>{
            state.value = mapTimeToKeyframe(t);
            state.done = t >= duration;
            return state;
        }
    };
}

},{"motion-utils":[["easeInOut","i2AmW"],["easingDefinitionToFunction","9fF4f"],["isEasingArray","39Hz1"]],"../../utils/interpolate.mjs":"8F7BJ","../keyframes/offsets/default.mjs":"2O2lC","../keyframes/offsets/time.mjs":"fVEUO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8F7BJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "interpolate", ()=>interpolate);
var _motionUtils = require("motion-utils");
var _indexMjs = require("./mix/index.mjs");
function createMixers(output, ease, customMixer) {
    const mixers = [];
    const mixerFactory = customMixer || (0, _motionUtils.MotionGlobalConfig).mix || (0, _indexMjs.mix);
    const numMixers = output.length - 1;
    for(let i = 0; i < numMixers; i++){
        let mixer = mixerFactory(output[i], output[i + 1]);
        if (ease) {
            const easingFunction = Array.isArray(ease) ? ease[i] || (0, _motionUtils.noop) : ease;
            mixer = (0, _motionUtils.pipe)(easingFunction, mixer);
        }
        mixers.push(mixer);
    }
    return mixers;
}
/**
 * Create a function that maps from a numerical input array to a generic output array.
 *
 * Accepts:
 *   - Numbers
 *   - Colors (hex, hsl, hsla, rgb, rgba)
 *   - Complex (combinations of one or more numbers or strings)
 *
 * ```jsx
 * const mixColor = interpolate([0, 1], ['#fff', '#000'])
 *
 * mixColor(0.5) // 'rgba(128, 128, 128, 1)'
 * ```
 *
 * TODO Revisit this approach once we've moved to data models for values,
 * probably not needed to pregenerate mixer functions.
 *
 * @public
 */ function interpolate(input, output, { clamp: isClamp = true, ease, mixer } = {}) {
    const inputLength = input.length;
    (0, _motionUtils.invariant)(inputLength === output.length, "Both input and output ranges must be the same length", "range-length");
    /**
     * If we're only provided a single input, we can just make a function
     * that returns the output.
     */ if (inputLength === 1) return ()=>output[0];
    if (inputLength === 2 && output[0] === output[1]) return ()=>output[1];
    const isZeroDeltaRange = input[0] === input[1];
    // If input runs highest -> lowest, reverse both arrays
    if (input[0] > input[inputLength - 1]) {
        input = [
            ...input
        ].reverse();
        output = [
            ...output
        ].reverse();
    }
    const mixers = createMixers(output, ease, mixer);
    const numMixers = mixers.length;
    const interpolator = (v)=>{
        if (isZeroDeltaRange && v < input[0]) return output[0];
        let i = 0;
        if (numMixers > 1) for(; i < input.length - 2; i++){
            if (v < input[i + 1]) break;
        }
        const progressInRange = (0, _motionUtils.progress)(input[i], input[i + 1], v);
        return mixers[i](progressInRange);
    };
    return isClamp ? (v)=>interpolator((0, _motionUtils.clamp)(input[0], input[inputLength - 1], v)) : interpolator;
}

},{"motion-utils":[["clamp","b78W4"],["invariant","588wx"],["MotionGlobalConfig","jQhZ4"],["noop","1tDyg"],["pipe","lPgnn"],["progress","6Q1yP"]],"./mix/index.mjs":"a3j1F","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2O2lC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultOffset", ()=>defaultOffset);
var _fillMjs = require("./fill.mjs");
function defaultOffset(arr) {
    const offset = [
        0
    ];
    (0, _fillMjs.fillOffset)(offset, arr.length - 1);
    return offset;
}

},{"./fill.mjs":"j8mup","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j8mup":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillOffset", ()=>fillOffset);
var _motionUtils = require("motion-utils");
var _numberMjs = require("../../../utils/mix/number.mjs");
function fillOffset(offset, remaining) {
    const min = offset[offset.length - 1];
    for(let i = 1; i <= remaining; i++){
        const offsetProgress = (0, _motionUtils.progress)(0, remaining, i);
        offset.push((0, _numberMjs.mixNumber)(min, 1, offsetProgress));
    }
}

},{"motion-utils":"6Q1yP","../../../utils/mix/number.mjs":"91GSx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fVEUO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "convertOffsetToTimes", ()=>convertOffsetToTimes);
function convertOffsetToTimes(offset, duration) {
    return offset.map((o)=>o * duration);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lfBD4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceTransitionType", ()=>replaceTransitionType);
var _inertiaMjs = require("../generators/inertia.mjs");
var _keyframesMjs = require("../generators/keyframes.mjs");
var _springMjs = require("../generators/spring.mjs");
const transitionTypeMap = {
    decay: (0, _inertiaMjs.inertia),
    inertia: (0, _inertiaMjs.inertia),
    tween: (0, _keyframesMjs.keyframes),
    keyframes: (0, _keyframesMjs.keyframes),
    spring: (0, _springMjs.spring)
};
function replaceTransitionType(transition) {
    if (typeof transition.type === "string") transition.type = transitionTypeMap[transition.type];
}

},{"../generators/inertia.mjs":"bAsqb","../generators/keyframes.mjs":"kLVN8","../generators/spring.mjs":"1DO7Q","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9lnJz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NativeAnimationExtended", ()=>NativeAnimationExtended);
var _motionUtils = require("motion-utils");
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
var _styleSetMjs = require("../render/dom/style-set.mjs");
var _jsanimationMjs = require("./JSAnimation.mjs");
var _nativeAnimationMjs = require("./NativeAnimation.mjs");
var _replaceTransitionTypeMjs = require("./utils/replace-transition-type.mjs");
var _unsupportedEasingMjs = require("./waapi/utils/unsupported-easing.mjs");
/**
 * 10ms is chosen here as it strikes a balance between smooth
 * results (more than one keyframe per frame at 60fps) and
 * keyframe quantity.
 */ const sampleDelta = 10; //ms
class NativeAnimationExtended extends (0, _nativeAnimationMjs.NativeAnimation) {
    constructor(options){
        /**
         * The base NativeAnimation function only supports a subset
         * of Motion easings, and WAAPI also only supports some
         * easing functions via string/cubic-bezier definitions.
         *
         * This function replaces those unsupported easing functions
         * with a JS easing function. This will later get compiled
         * to a linear() easing function.
         */ (0, _unsupportedEasingMjs.replaceStringEasing)(options);
        /**
         * Ensure we replace the transition type with a generator function
         * before passing to WAAPI.
         *
         * TODO: Does this have a better home? It could be shared with
         * JSAnimation.
         */ (0, _replaceTransitionTypeMjs.replaceTransitionType)(options);
        super(options);
        /**
         * Only set startTime when the animation should autoplay.
         * Setting startTime on a paused WAAPI animation unpauses it
         * (per the WAAPI spec), which breaks autoplay: false.
         */ if (options.startTime !== undefined && options.autoplay !== false) this.startTime = options.startTime;
        this.options = options;
    }
    /**
     * WAAPI doesn't natively have any interruption capabilities.
     *
     * Rather than read committed styles back out of the DOM, we can
     * create a renderless JS animation and sample it twice to calculate
     * its current value, "previous" value, and therefore allow
     * Motion to calculate velocity for any subsequent animation.
     */ updateMotionValue(value) {
        const { motionValue, onUpdate, onComplete, element, ...options } = this.options;
        if (!motionValue) return;
        if (value !== undefined) {
            motionValue.set(value);
            return;
        }
        const sampleAnimation = new (0, _jsanimationMjs.JSAnimation)({
            ...options,
            autoplay: false
        });
        /**
         * Use wall-clock elapsed time for sampling.
         * Under CPU load, WAAPI's currentTime may not reflect actual
         * elapsed time, causing incorrect sampling and visual jumps.
         */ const sampleTime = Math.max(sampleDelta, (0, _syncTimeMjs.time).now() - this.startTime);
        const delta = (0, _motionUtils.clamp)(0, sampleDelta, sampleTime - sampleDelta);
        const current = sampleAnimation.sample(sampleTime).value;
        /**
         * Write the estimated value to inline style so it persists
         * after cancel(), covering the async gap before the next
         * animation starts.
         */ const { name } = this.options;
        if (element && name) (0, _styleSetMjs.setStyle)(element, name, current);
        motionValue.setWithVelocity(sampleAnimation.sample(Math.max(0, sampleTime - delta)).value, current, delta);
        sampleAnimation.stop();
    }
}

},{"motion-utils":"b78W4","../frameloop/sync-time.mjs":"74aV8","../render/dom/style-set.mjs":"lzPnK","./JSAnimation.mjs":"hmfBB","./NativeAnimation.mjs":"bnVN0","./utils/replace-transition-type.mjs":"lfBD4","./waapi/utils/unsupported-easing.mjs":"4ZtU2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4ZtU2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "replaceStringEasing", ()=>replaceStringEasing);
var _motionUtils = require("motion-utils");
const unsupportedEasingFunctions = {
    anticipate: (0, _motionUtils.anticipate),
    backInOut: (0, _motionUtils.backInOut),
    circInOut: (0, _motionUtils.circInOut)
};
function isUnsupportedEase(key) {
    return key in unsupportedEasingFunctions;
}
function replaceStringEasing(transition) {
    if (typeof transition.ease === "string" && isUnsupportedEase(transition.ease)) transition.ease = unsupportedEasingFunctions[transition.ease];
}

},{"motion-utils":[["anticipate","4teBY"],["backInOut","hMfhC"],["circInOut","gCpPR"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gyV2F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canAnimate", ()=>canAnimate);
var _motionUtils = require("motion-utils");
var _isGeneratorMjs = require("../generators/utils/is-generator.mjs");
var _isAnimatableMjs = require("./is-animatable.mjs");
function hasKeyframesChanged(keyframes) {
    const current = keyframes[0];
    if (keyframes.length === 1) return true;
    for(let i = 0; i < keyframes.length; i++){
        if (keyframes[i] !== current) return true;
    }
}
function canAnimate(keyframes, name, type, velocity) {
    /**
     * Check if we're able to animate between the start and end keyframes,
     * and throw a warning if we're attempting to animate between one that's
     * animatable and another that isn't.
     */ const originKeyframe = keyframes[0];
    if (originKeyframe === null) return false;
    /**
     * These aren't traditionally animatable but we do support them.
     * In future we could look into making this more generic or replacing
     * this function with mix() === mixImmediate
     */ if (name === "display" || name === "visibility") return true;
    const targetKeyframe = keyframes[keyframes.length - 1];
    const isOriginAnimatable = (0, _isAnimatableMjs.isAnimatable)(originKeyframe, name);
    const isTargetAnimatable = (0, _isAnimatableMjs.isAnimatable)(targetKeyframe, name);
    (0, _motionUtils.warning)(isOriginAnimatable === isTargetAnimatable, `You are trying to animate ${name} from "${originKeyframe}" to "${targetKeyframe}". "${isOriginAnimatable ? targetKeyframe : originKeyframe}" is not an animatable value.`, "value-not-animatable");
    // Always skip if any of these are true
    if (!isOriginAnimatable || !isTargetAnimatable) return false;
    return hasKeyframesChanged(keyframes) || (type === "spring" || (0, _isGeneratorMjs.isGenerator)(type)) && velocity;
}

},{"motion-utils":"588wx","../generators/utils/is-generator.mjs":"fI1UZ","./is-animatable.mjs":"9KmWL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9KmWL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isAnimatable", ()=>isAnimatable);
var _indexMjs = require("../../value/types/complex/index.mjs");
/**
 * Check if a value is animatable. Examples:
 *
 * ✅: 100, "100px", "#fff"
 * ❌: "block", "url(2.jpg)"
 * @param value
 *
 * @internal
 */ const isAnimatable = (value, name)=>{
    // If the list of keys that might be non-animatable grows, replace with Set
    if (name === "zIndex") return false;
    // If it's a number or a keyframes array, we can animate it. We might at some point
    // need to do a deep isAnimatable check of keyframes, or let Popmotion handle this,
    // but for now lets leave it like this for performance reasons
    if (typeof value === "number" || Array.isArray(value)) return true;
    if (typeof value === "string" && // It's animatable if we have a string
    ((0, _indexMjs.complex).test(value) || value === "0") && // And it contains numbers and/or colors
    !value.startsWith("url(") // Unless it starts with "url("
    ) return true;
    return false;
};

},{"../../value/types/complex/index.mjs":"aBOw1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"13ipP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "makeAnimationInstant", ()=>makeAnimationInstant);
function makeAnimationInstant(options) {
    options.duration = 0;
    options.type = "keyframes";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4pfl7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsBrowserAnimation", ()=>supportsBrowserAnimation);
var _motionUtils = require("motion-utils");
var _acceleratedValuesMjs = require("../utils/accelerated-values.mjs");
var _isBrowserColorMjs = require("../utils/is-browser-color.mjs");
const colorProperties = new Set([
    "color",
    "backgroundColor",
    "outlineColor",
    "fill",
    "stroke",
    "borderColor",
    "borderTopColor",
    "borderRightColor",
    "borderBottomColor",
    "borderLeftColor"
]);
const supportsWaapi = /*@__PURE__*/ (0, _motionUtils.memo)(()=>Object.hasOwnProperty.call(Element.prototype, "animate"));
function supportsBrowserAnimation(options) {
    const { motionValue, name, repeatDelay, repeatType, damping, type, keyframes } = options;
    const subject = motionValue?.owner?.current;
    /**
     * We use this check instead of isHTMLElement() because we explicitly
     * **don't** want elements in different timing contexts (i.e. popups)
     * to be accelerated, as it's not possible to sync these animations
     * properly with those driven from the main window frameloop.
     */ if (!(subject instanceof HTMLElement)) return false;
    const { onUpdate, transformTemplate } = motionValue.owner.getProps();
    return supportsWaapi() && name && /**
         * Force WAAPI for color properties with browser-only color formats
         * (oklch, oklab, lab, lch, etc.) that the JS animation path can't parse.
         */ ((0, _acceleratedValuesMjs.acceleratedValues).has(name) || colorProperties.has(name) && (0, _isBrowserColorMjs.hasBrowserOnlyColors)(keyframes)) && (name !== "transform" || !transformTemplate) && /**
         * If we're outputting values to onUpdate then we can't use WAAPI as there's
         * no way to read the value from WAAPI every frame.
         */ !onUpdate && !repeatDelay && repeatType !== "mirror" && damping !== 0 && type !== "inertia";
}

},{"motion-utils":"240b7","../utils/accelerated-values.mjs":"2tVvg","../utils/is-browser-color.mjs":"4W2eI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4W2eI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserOnlyColors", ()=>hasBrowserOnlyColors);
const browserColorFunctions = /^(?:oklch|oklab|lab|lch|color|color-mix|light-dark)\(/;
function hasBrowserOnlyColors(keyframes) {
    for(let i = 0; i < keyframes.length; i++){
        if (typeof keyframes[i] === "string" && browserColorFunctions.test(keyframes[i])) return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7hkDg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupAnimation", ()=>GroupAnimation);
class GroupAnimation {
    constructor(animations){
        // Bound to accomadate common `return animation.stop` pattern
        this.stop = ()=>this.runAll("stop");
        this.animations = animations.filter(Boolean);
    }
    get finished() {
        return Promise.all(this.animations.map((animation)=>animation.finished));
    }
    /**
     * TODO: Filter out cancelled or stopped animations before returning
     */ getAll(propName) {
        return this.animations[0][propName];
    }
    setAll(propName, newValue) {
        for(let i = 0; i < this.animations.length; i++)this.animations[i][propName] = newValue;
    }
    attachTimeline(timeline) {
        const subscriptions = this.animations.map((animation)=>animation.attachTimeline(timeline));
        return ()=>{
            subscriptions.forEach((cancel, i)=>{
                cancel && cancel();
                this.animations[i].stop();
            });
        };
    }
    get time() {
        return this.getAll("time");
    }
    set time(time) {
        this.setAll("time", time);
    }
    get speed() {
        return this.getAll("speed");
    }
    set speed(speed) {
        this.setAll("speed", speed);
    }
    get state() {
        return this.getAll("state");
    }
    get startTime() {
        return this.getAll("startTime");
    }
    get duration() {
        return getMax(this.animations, "duration");
    }
    get iterationDuration() {
        return getMax(this.animations, "iterationDuration");
    }
    runAll(methodName) {
        this.animations.forEach((controls)=>controls[methodName]());
    }
    play() {
        this.runAll("play");
    }
    pause() {
        this.runAll("pause");
    }
    cancel() {
        this.runAll("cancel");
    }
    complete() {
        this.runAll("complete");
    }
}
function getMax(animations, propName) {
    let max = 0;
    for(let i = 0; i < animations.length; i++){
        const value = animations[i][propName];
        if (value !== null && value > max) max = value;
    }
    return max;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"E935f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupAnimationWithThen", ()=>GroupAnimationWithThen);
var _groupAnimationMjs = require("./GroupAnimation.mjs");
class GroupAnimationWithThen extends (0, _groupAnimationMjs.GroupAnimation) {
    then(onResolve, _onReject) {
        return this.finished.finally(onResolve).then(()=>{});
    }
}

},{"./GroupAnimation.mjs":"7hkDg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1IfeU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NativeAnimationWrapper", ()=>NativeAnimationWrapper);
var _nativeAnimationMjs = require("./NativeAnimation.mjs");
class NativeAnimationWrapper extends (0, _nativeAnimationMjs.NativeAnimation) {
    constructor(animation){
        super();
        this.animation = animation;
        animation.onfinish = ()=>{
            this.finishedTime = this.time;
            this.notifyFinished();
        };
    }
}

},{"./NativeAnimation.mjs":"bnVN0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3gCCL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animationMapKey", ()=>animationMapKey);
parcelHelpers.export(exports, "getAnimationMap", ()=>getAnimationMap);
const animationMaps = new WeakMap();
const animationMapKey = (name, pseudoElement = "")=>`${name}:${pseudoElement}`;
function getAnimationMap(element) {
    let map = animationMaps.get(element);
    if (!map) {
        map = new Map();
        animationMaps.set(element, map);
    }
    return map;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hitnd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcChildStagger", ()=>calcChildStagger);
function calcChildStagger(children, child, delayChildren, staggerChildren = 0, staggerDirection = 1) {
    const index = Array.from(children).sort((a, b)=>a.sortNodePosition(b)).indexOf(child);
    const numChildren = children.size;
    const maxStaggerDuration = (numChildren - 1) * staggerChildren;
    const delayIsFunction = typeof delayChildren === "function";
    return delayIsFunction ? delayChildren(index, numChildren) : staggerDirection === 1 ? index * staggerChildren : maxStaggerDuration - index * staggerChildren;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dqKNa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultTransition", ()=>getDefaultTransition);
var _keysTransformMjs = require("../../render/utils/keys-transform.mjs");
const underDampedSpring = {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
};
const criticallyDampedSpring = (target)=>({
        type: "spring",
        stiffness: 550,
        damping: target === 0 ? 2 * Math.sqrt(550) : 30,
        restSpeed: 10
    });
const keyframesTransition = {
    type: "keyframes",
    duration: 0.8
};
/**
 * Default easing curve is a slightly shallower version of
 * the default browser easing curve.
 */ const ease = {
    type: "keyframes",
    ease: [
        0.25,
        0.1,
        0.35,
        1
    ],
    duration: 0.3
};
const getDefaultTransition = (valueKey, { keyframes })=>{
    if (keyframes.length > 2) return keyframesTransition;
    else if ((0, _keysTransformMjs.transformProps).has(valueKey)) return valueKey.startsWith("scale") ? criticallyDampedSpring(keyframes[1]) : underDampedSpring;
    return ease;
};

},{"../../render/utils/keys-transform.mjs":"bJbLV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6hcoP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueTransition", ()=>getValueTransition);
var _resolveTransitionMjs = require("./resolve-transition.mjs");
function getValueTransition(transition, key) {
    const valueTransition = transition?.[key] ?? transition?.["default"] ?? transition;
    if (valueTransition !== transition) return (0, _resolveTransitionMjs.resolveTransition)(valueTransition, transition);
    return valueTransition;
}

},{"./resolve-transition.mjs":"ctmfM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ctmfM":[function(require,module,exports,__globalThis) {
/**
 * If `transition` has `inherit: true`, shallow-merge it with
 * `parentTransition` (child keys win) and strip the `inherit` key.
 * Otherwise return `transition` unchanged.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveTransition", ()=>resolveTransition);
function resolveTransition(transition, parentTransition) {
    if (transition?.inherit && parentTransition) {
        const { inherit: _, ...rest } = transition;
        return {
            ...parentTransition,
            ...rest
        };
    }
    return transition;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i2hQb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTransitionDefined", ()=>isTransitionDefined);
const orchestrationKeys = new Set([
    "when",
    "delay",
    "delayChildren",
    "staggerChildren",
    "staggerDirection",
    "repeat",
    "repeatType",
    "repeatDelay",
    "from",
    "elapsed"
]);
/**
 * Decide whether a transition is defined on a given Transition.
 * This filters out orchestration options and returns true
 * if any options are left.
 */ function isTransitionDefined(transition) {
    for(const key in transition){
        if (!orchestrationKeys.has(key)) return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5NoWL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateMotionValue", ()=>animateMotionValue);
var _motionUtils = require("motion-utils");
var _asyncMotionValueAnimationMjs = require("../AsyncMotionValueAnimation.mjs");
var _jsanimationMjs = require("../JSAnimation.mjs");
var _getValueTransitionMjs = require("../utils/get-value-transition.mjs");
var _makeAnimationInstantMjs = require("../utils/make-animation-instant.mjs");
var _defaultTransitionsMjs = require("../utils/default-transitions.mjs");
var _getFinalMjs = require("../keyframes/get-final.mjs");
var _isTransitionDefinedMjs = require("../utils/is-transition-defined.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
const animateMotionValue = (name, value, target, transition = {}, element, isHandoff)=>(onComplete)=>{
        const valueTransition = (0, _getValueTransitionMjs.getValueTransition)(transition, name) || {};
        /**
     * Most transition values are currently completely overwritten by value-specific
     * transitions. In the future it'd be nicer to blend these transitions. But for now
     * delay actually does inherit from the root transition if not value-specific.
     */ const delay = valueTransition.delay || transition.delay || 0;
        /**
     * Elapsed isn't a public transition option but can be passed through from
     * optimized appear effects in milliseconds.
     */ let { elapsed = 0 } = transition;
        elapsed = elapsed - (0, _motionUtils.secondsToMilliseconds)(delay);
        const options = {
            keyframes: Array.isArray(target) ? target : [
                null,
                target
            ],
            ease: "easeOut",
            velocity: value.getVelocity(),
            ...valueTransition,
            delay: -elapsed,
            onUpdate: (v)=>{
                value.set(v);
                valueTransition.onUpdate && valueTransition.onUpdate(v);
            },
            onComplete: ()=>{
                onComplete();
                valueTransition.onComplete && valueTransition.onComplete();
            },
            name,
            motionValue: value,
            element: isHandoff ? undefined : element
        };
        /**
     * If there's no transition defined for this value, we can generate
     * unique transition settings for this value.
     */ if (!(0, _isTransitionDefinedMjs.isTransitionDefined)(valueTransition)) Object.assign(options, (0, _defaultTransitionsMjs.getDefaultTransition)(name, options));
        /**
     * Both WAAPI and our internal animation functions use durations
     * as defined by milliseconds, while our external API defines them
     * as seconds.
     */ options.duration && (options.duration = (0, _motionUtils.secondsToMilliseconds)(options.duration));
        options.repeatDelay && (options.repeatDelay = (0, _motionUtils.secondsToMilliseconds)(options.repeatDelay));
        /**
     * Support deprecated way to set initial value. Prefer keyframe syntax.
     */ if (options.from !== undefined) options.keyframes[0] = options.from;
        let shouldSkip = false;
        if (options.type === false || options.duration === 0 && !options.repeatDelay) {
            (0, _makeAnimationInstantMjs.makeAnimationInstant)(options);
            if (options.delay === 0) shouldSkip = true;
        }
        if ((0, _motionUtils.MotionGlobalConfig).instantAnimations || (0, _motionUtils.MotionGlobalConfig).skipAnimations || element?.shouldSkipAnimations) {
            shouldSkip = true;
            (0, _makeAnimationInstantMjs.makeAnimationInstant)(options);
            options.delay = 0;
        }
        /**
     * If the transition type or easing has been explicitly set by the user
     * then we don't want to allow flattening the animation.
     */ options.allowFlatten = !valueTransition.type && !valueTransition.ease;
        /**
     * If we can or must skip creating the animation, and apply only
     * the final keyframe, do so. We also check once keyframes are resolved but
     * this early check prevents the need to create an animation at all.
     */ if (shouldSkip && !isHandoff && value.get() !== undefined) {
            const finalKeyframe = (0, _getFinalMjs.getFinalKeyframe)(options.keyframes, valueTransition);
            if (finalKeyframe !== undefined) {
                (0, _frameMjs.frame).update(()=>{
                    options.onUpdate(finalKeyframe);
                    options.onComplete();
                });
                return;
            }
        }
        return valueTransition.isSync ? new (0, _jsanimationMjs.JSAnimation)(options) : new (0, _asyncMotionValueAnimationMjs.AsyncMotionValueAnimation)(options);
    };

},{"motion-utils":[["MotionGlobalConfig","jQhZ4"],["secondsToMilliseconds","dIdtR"]],"../AsyncMotionValueAnimation.mjs":"ln4oa","../JSAnimation.mjs":"hmfBB","../utils/get-value-transition.mjs":"6hcoP","../utils/make-animation-instant.mjs":"13ipP","../utils/default-transitions.mjs":"dqKNa","../keyframes/get-final.mjs":"914tK","../utils/is-transition-defined.mjs":"i2hQb","../../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a7b44":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateVisualElement", ()=>animateVisualElement);
var _resolveDynamicVariantsMjs = require("../../render/utils/resolve-dynamic-variants.mjs");
var _visualElementTargetMjs = require("./visual-element-target.mjs");
var _visualElementVariantMjs = require("./visual-element-variant.mjs");
function animateVisualElement(visualElement, definition, options = {}) {
    visualElement.notify("AnimationStart", definition);
    let animation;
    if (Array.isArray(definition)) {
        const animations = definition.map((variant)=>(0, _visualElementVariantMjs.animateVariant)(visualElement, variant, options));
        animation = Promise.all(animations);
    } else if (typeof definition === "string") animation = (0, _visualElementVariantMjs.animateVariant)(visualElement, definition, options);
    else {
        const resolvedDefinition = typeof definition === "function" ? (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, definition, options.custom) : definition;
        animation = Promise.all((0, _visualElementTargetMjs.animateTarget)(visualElement, resolvedDefinition, options));
    }
    return animation.then(()=>{
        visualElement.notify("AnimationComplete", definition);
    });
}

},{"../../render/utils/resolve-dynamic-variants.mjs":"7PfV6","./visual-element-target.mjs":"3tujD","./visual-element-variant.mjs":"25yLb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7PfV6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveVariant", ()=>resolveVariant);
var _resolveVariantsMjs = require("./resolve-variants.mjs");
function resolveVariant(visualElement, definition, custom) {
    const props = visualElement.getProps();
    return (0, _resolveVariantsMjs.resolveVariantFromProps)(props, definition, custom !== undefined ? custom : props.custom, visualElement);
}

},{"./resolve-variants.mjs":"fFvtX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3tujD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateTarget", ()=>animateTarget);
var _getValueTransitionMjs = require("../utils/get-value-transition.mjs");
var _resolveTransitionMjs = require("../utils/resolve-transition.mjs");
var _keysPositionMjs = require("../../render/utils/keys-position.mjs");
var _settersMjs = require("../../render/utils/setters.mjs");
var _addWillChangeMjs = require("../../value/will-change/add-will-change.mjs");
var _getAppearIdMjs = require("../optimized-appear/get-appear-id.mjs");
var _motionValueMjs = require("./motion-value.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
/**
 * Decide whether we should block this animation. Previously, we achieved this
 * just by checking whether the key was listed in protectedKeys, but this
 * posed problems if an animation was triggered by afterChildren and protectedKeys
 * had been set to true in the meantime.
 */ function shouldBlockAnimation({ protectedKeys, needsAnimating }, key) {
    const shouldBlock = protectedKeys.hasOwnProperty(key) && needsAnimating[key] !== true;
    needsAnimating[key] = false;
    return shouldBlock;
}
function animateTarget(visualElement, targetAndTransition, { delay = 0, transitionOverride, type } = {}) {
    let { transition, transitionEnd, ...target } = targetAndTransition;
    const defaultTransition = visualElement.getDefaultTransition();
    transition = transition ? (0, _resolveTransitionMjs.resolveTransition)(transition, defaultTransition) : defaultTransition;
    const reduceMotion = transition?.reduceMotion;
    if (transitionOverride) transition = transitionOverride;
    const animations = [];
    const animationTypeState = type && visualElement.animationState && visualElement.animationState.getState()[type];
    for(const key in target){
        const value = visualElement.getValue(key, visualElement.latestValues[key] ?? null);
        const valueTarget = target[key];
        if (valueTarget === undefined || animationTypeState && shouldBlockAnimation(animationTypeState, key)) continue;
        const valueTransition = {
            delay,
            ...(0, _getValueTransitionMjs.getValueTransition)(transition || {}, key)
        };
        /**
         * If the value is already at the defined target, skip the animation.
         * We still re-assert the value via frame.update to take precedence
         * over any stale transitionEnd callbacks from previous animations.
         */ const currentValue = value.get();
        if (currentValue !== undefined && !value.isAnimating() && !Array.isArray(valueTarget) && valueTarget === currentValue && !valueTransition.velocity) {
            (0, _frameMjs.frame).update(()=>value.set(valueTarget));
            continue;
        }
        /**
         * If this is the first time a value is being animated, check
         * to see if we're handling off from an existing animation.
         */ let isHandoff = false;
        if (window.MotionHandoffAnimation) {
            const appearId = (0, _getAppearIdMjs.getOptimisedAppearId)(visualElement);
            if (appearId) {
                const startTime = window.MotionHandoffAnimation(appearId, key, (0, _frameMjs.frame));
                if (startTime !== null) {
                    valueTransition.startTime = startTime;
                    isHandoff = true;
                }
            }
        }
        (0, _addWillChangeMjs.addValueToWillChange)(visualElement, key);
        const shouldReduceMotion = reduceMotion ?? visualElement.shouldReduceMotion;
        value.start((0, _motionValueMjs.animateMotionValue)(key, value, valueTarget, shouldReduceMotion && (0, _keysPositionMjs.positionalKeys).has(key) ? {
            type: false
        } : valueTransition, visualElement, isHandoff));
        const animation = value.animation;
        if (animation) animations.push(animation);
    }
    if (transitionEnd) {
        const applyTransitionEnd = ()=>(0, _frameMjs.frame).update(()=>{
                transitionEnd && (0, _settersMjs.setTarget)(visualElement, transitionEnd);
            });
        if (animations.length) Promise.all(animations).then(applyTransitionEnd);
        else applyTransitionEnd();
    }
    return animations;
}

},{"../utils/get-value-transition.mjs":"6hcoP","../utils/resolve-transition.mjs":"ctmfM","../../render/utils/keys-position.mjs":"5Qoar","../../render/utils/setters.mjs":"i6e2d","../../value/will-change/add-will-change.mjs":"fVkj9","../optimized-appear/get-appear-id.mjs":"cbcxg","./motion-value.mjs":"5NoWL","../../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i6e2d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setTarget", ()=>setTarget);
var _indexMjs = require("../../value/index.mjs");
var _resolveDynamicVariantsMjs = require("./resolve-dynamic-variants.mjs");
var _isKeyframesTargetMjs = require("./is-keyframes-target.mjs");
/**
 * Set VisualElement's MotionValue, creating a new MotionValue for it if
 * it doesn't exist.
 */ function setMotionValue(visualElement, key, value) {
    if (visualElement.hasValue(key)) visualElement.getValue(key).set(value);
    else visualElement.addValue(key, (0, _indexMjs.motionValue)(value));
}
function resolveFinalValueInKeyframes(v) {
    // TODO maybe throw if v.length - 1 is placeholder token?
    return (0, _isKeyframesTargetMjs.isKeyframesTarget)(v) ? v[v.length - 1] || 0 : v;
}
function setTarget(visualElement, definition) {
    const resolved = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, definition);
    let { transitionEnd = {}, transition = {}, ...target } = resolved || {};
    target = {
        ...target,
        ...transitionEnd
    };
    for(const key in target){
        const value = resolveFinalValueInKeyframes(target[key]);
        setMotionValue(visualElement, key, value);
    }
}

},{"../../value/index.mjs":"hX31g","./resolve-dynamic-variants.mjs":"7PfV6","./is-keyframes-target.mjs":"2DP7E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2DP7E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isKeyframesTarget", ()=>isKeyframesTarget);
const isKeyframesTarget = (v)=>{
    return Array.isArray(v);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fVkj9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addValueToWillChange", ()=>addValueToWillChange);
var _motionUtils = require("motion-utils");
var _isMjs = require("./is.mjs");
function addValueToWillChange(visualElement, key) {
    const willChange = visualElement.getValue("willChange");
    /**
     * It could be that a user has set willChange to a regular MotionValue,
     * in which case we can't add the value to it.
     */ if ((0, _isMjs.isWillChangeMotionValue)(willChange)) return willChange.add(key);
    else if (!willChange && (0, _motionUtils.MotionGlobalConfig).WillChange) {
        const newWillChange = new (0, _motionUtils.MotionGlobalConfig).WillChange("auto");
        visualElement.addValue("willChange", newWillChange);
        newWillChange.add(key);
    }
}

},{"motion-utils":"jQhZ4","./is.mjs":"2r2wf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2r2wf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWillChangeMotionValue", ()=>isWillChangeMotionValue);
var _isMotionValueMjs = require("../utils/is-motion-value.mjs");
function isWillChangeMotionValue(value) {
    return Boolean((0, _isMotionValueMjs.isMotionValue)(value) && value.add);
}

},{"../utils/is-motion-value.mjs":"fKDJz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cbcxg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOptimisedAppearId", ()=>getOptimisedAppearId);
var _dataIdMjs = require("./data-id.mjs");
function getOptimisedAppearId(visualElement) {
    return visualElement.props[0, _dataIdMjs.optimizedAppearDataAttribute];
}

},{"./data-id.mjs":"9fex9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9fex9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "optimizedAppearDataAttribute", ()=>optimizedAppearDataAttribute);
parcelHelpers.export(exports, "optimizedAppearDataId", ()=>optimizedAppearDataId);
var _camelToDashMjs = require("../../render/dom/utils/camel-to-dash.mjs");
const optimizedAppearDataId = "framerAppearId";
const optimizedAppearDataAttribute = "data-" + (0, _camelToDashMjs.camelToDash)(optimizedAppearDataId);

},{"../../render/dom/utils/camel-to-dash.mjs":"9nVP8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"25yLb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateVariant", ()=>animateVariant);
var _resolveDynamicVariantsMjs = require("../../render/utils/resolve-dynamic-variants.mjs");
var _calcChildStaggerMjs = require("../utils/calc-child-stagger.mjs");
var _visualElementTargetMjs = require("./visual-element-target.mjs");
function animateVariant(visualElement, variant, options = {}) {
    const resolved = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, variant, options.type === "exit" ? visualElement.presenceContext?.custom : undefined);
    let { transition = visualElement.getDefaultTransition() || {} } = resolved || {};
    if (options.transitionOverride) transition = options.transitionOverride;
    /**
     * If we have a variant, create a callback that runs it as an animation.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getAnimation = resolved ? ()=>Promise.all((0, _visualElementTargetMjs.animateTarget)(visualElement, resolved, options)) : ()=>Promise.resolve();
    /**
     * If we have children, create a callback that runs all their animations.
     * Otherwise, we resolve a Promise immediately for a composable no-op.
     */ const getChildAnimations = visualElement.variantChildren && visualElement.variantChildren.size ? (forwardDelay = 0)=>{
        const { delayChildren = 0, staggerChildren, staggerDirection } = transition;
        return animateChildren(visualElement, variant, forwardDelay, delayChildren, staggerChildren, staggerDirection, options);
    } : ()=>Promise.resolve();
    /**
     * If the transition explicitly defines a "when" option, we need to resolve either
     * this animation or all children animations before playing the other.
     */ const { when } = transition;
    if (when) {
        const [first, last] = when === "beforeChildren" ? [
            getAnimation,
            getChildAnimations
        ] : [
            getChildAnimations,
            getAnimation
        ];
        return first().then(()=>last());
    } else return Promise.all([
        getAnimation(),
        getChildAnimations(options.delay)
    ]);
}
function animateChildren(visualElement, variant, delay = 0, delayChildren = 0, staggerChildren = 0, staggerDirection = 1, options) {
    const animations = [];
    for (const child of visualElement.variantChildren){
        child.notify("AnimationStart", variant);
        animations.push(animateVariant(child, variant, {
            ...options,
            delay: delay + (typeof delayChildren === "function" ? 0 : delayChildren) + (0, _calcChildStaggerMjs.calcChildStagger)(visualElement.variantChildren, child, delayChildren, staggerChildren, staggerDirection)
        }).then(()=>child.notify("AnimationComplete", variant)));
    }
    return Promise.all(animations);
}

},{"../../render/utils/resolve-dynamic-variants.mjs":"7PfV6","../utils/calc-child-stagger.mjs":"hitnd","./visual-element-target.mjs":"3tujD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6jvhs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyPxDefaults", ()=>applyPxDefaults);
var _pxValuesMjs = require("../../waapi/utils/px-values.mjs");
function applyPxDefaults(keyframes, name) {
    for(let i = 0; i < keyframes.length; i++)if (typeof keyframes[i] === "number" && (0, _pxValuesMjs.pxValues).has(name)) keyframes[i] = keyframes[i] + "px";
}

},{"../../waapi/utils/px-values.mjs":"dtLZk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dtLZk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pxValues", ()=>pxValues);
const pxValues = new Set([
    // Border props
    "borderWidth",
    "borderTopWidth",
    "borderRightWidth",
    "borderBottomWidth",
    "borderLeftWidth",
    "borderRadius",
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomRightRadius",
    "borderBottomLeftRadius",
    // Positioning props
    "width",
    "maxWidth",
    "height",
    "maxHeight",
    "top",
    "right",
    "bottom",
    "left",
    "inset",
    "insetBlock",
    "insetBlockStart",
    "insetBlockEnd",
    "insetInline",
    "insetInlineStart",
    "insetInlineEnd",
    // Spacing props
    "padding",
    "paddingTop",
    "paddingRight",
    "paddingBottom",
    "paddingLeft",
    "paddingBlock",
    "paddingBlockStart",
    "paddingBlockEnd",
    "paddingInline",
    "paddingInlineStart",
    "paddingInlineEnd",
    "margin",
    "marginTop",
    "marginRight",
    "marginBottom",
    "marginLeft",
    "marginBlock",
    "marginBlockStart",
    "marginBlockEnd",
    "marginInline",
    "marginInlineStart",
    "marginInlineEnd",
    // Typography
    "fontSize",
    // Misc
    "backgroundPositionX",
    "backgroundPositionY"
]);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7m2oZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWaapiSupportedEasing", ()=>isWaapiSupportedEasing);
var _motionUtils = require("motion-utils");
var _linearEasingMjs = require("../../../utils/supports/linear-easing.mjs");
var _supportedMjs = require("./supported.mjs");
function isWaapiSupportedEasing(easing) {
    return Boolean(typeof easing === "function" && (0, _linearEasingMjs.supportsLinearEasing)() || !easing || typeof easing === "string" && (easing in (0, _supportedMjs.supportedWaapiEasing) || (0, _linearEasingMjs.supportsLinearEasing)()) || (0, _motionUtils.isBezierDefinition)(easing) || Array.isArray(easing) && easing.every(isWaapiSupportedEasing));
}

},{"motion-utils":"8410g","../../../utils/supports/linear-easing.mjs":"2AnQL","./supported.mjs":"fof9P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f4TM4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "supportsPartialKeyframes", ()=>supportsPartialKeyframes);
var _motionUtils = require("motion-utils");
const supportsPartialKeyframes = /*@__PURE__*/ (0, _motionUtils.memo)(()=>{
    try {
        document.createElement("div").animate({
            opacity: [
                1
            ]
        });
    } catch (e) {
        return false;
    }
    return true;
});

},{"motion-utils":"240b7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kh80d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addAttrValue", ()=>addAttrValue);
parcelHelpers.export(exports, "attrEffect", ()=>attrEffect);
var _camelToDashMjs = require("../../render/dom/utils/camel-to-dash.mjs");
var _createDomEffectMjs = require("../utils/create-dom-effect.mjs");
var _createEffectMjs = require("../utils/create-effect.mjs");
function canSetAsProperty(element, name) {
    if (!(name in element)) return false;
    const descriptor = Object.getOwnPropertyDescriptor(Object.getPrototypeOf(element), name) || Object.getOwnPropertyDescriptor(element, name);
    // Check if it has a setter
    return descriptor && typeof descriptor.set === "function";
}
const addAttrValue = (element, state, key, value)=>{
    const isProp = canSetAsProperty(element, key);
    const name = isProp ? key : key.startsWith("data") || key.startsWith("aria") ? (0, _camelToDashMjs.camelToDash)(key) : key;
    /**
     * Set attribute directly via property if available
     */ const render = isProp ? ()=>{
        element[name] = state.latest[key];
    } : ()=>{
        const v = state.latest[key];
        if (v === null || v === undefined) element.removeAttribute(name);
        else element.setAttribute(name, String(v));
    };
    return state.set(key, value, render);
};
const attrEffect = /*@__PURE__*/ (0, _createDomEffectMjs.createSelectorEffect)(/*@__PURE__*/ (0, _createEffectMjs.createEffect)(addAttrValue));

},{"../../render/dom/utils/camel-to-dash.mjs":"9nVP8","../utils/create-dom-effect.mjs":"9FwXM","../utils/create-effect.mjs":"7mLbf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9FwXM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSelectorEffect", ()=>createSelectorEffect);
var _resolveElementsMjs = require("../../utils/resolve-elements.mjs");
function createSelectorEffect(subjectEffect) {
    return (subject, values)=>{
        const elements = (0, _resolveElementsMjs.resolveElements)(subject);
        const subscriptions = [];
        for (const element of elements){
            const remove = subjectEffect(element, values);
            subscriptions.push(remove);
        }
        return ()=>{
            for (const remove of subscriptions)remove();
        };
    };
}

},{"../../utils/resolve-elements.mjs":"pZkYr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"pZkYr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveElements", ()=>resolveElements);
function resolveElements(elementOrSelector, scope, selectorCache) {
    if (elementOrSelector == null) return [];
    if (elementOrSelector instanceof EventTarget) return [
        elementOrSelector
    ];
    else if (typeof elementOrSelector === "string") {
        let root = document;
        if (scope) root = scope.current;
        const elements = selectorCache?.[elementOrSelector] ?? root.querySelectorAll(elementOrSelector);
        return elements ? Array.from(elements) : [];
    }
    return Array.from(elementOrSelector).filter((element)=>element != null);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7mLbf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createEffect", ()=>createEffect);
var _motionValueStateMjs = require("../MotionValueState.mjs");
function createEffect(addValue) {
    const stateCache = new WeakMap();
    return (subject, values)=>{
        const state = stateCache.get(subject) ?? new (0, _motionValueStateMjs.MotionValueState)();
        stateCache.set(subject, state);
        const subscriptions = [];
        for(const key in values){
            const value = values[key];
            const remove = addValue(subject, state, key, value);
            subscriptions.push(remove);
        }
        return ()=>{
            for (const cancel of subscriptions)cancel();
        };
    };
}

},{"../MotionValueState.mjs":"dJK3Q","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dJK3Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MotionValueState", ()=>MotionValueState);
var _frameMjs = require("../frameloop/frame.mjs");
var _numberMjs = require("../value/types/maps/number.mjs");
var _getAsTypeMjs = require("../value/types/utils/get-as-type.mjs");
class MotionValueState {
    constructor(){
        this.latest = {};
        this.values = new Map();
    }
    set(name, value, render, computed, useDefaultValueType = true) {
        const existingValue = this.values.get(name);
        if (existingValue) existingValue.onRemove();
        const onChange = ()=>{
            const v = value.get();
            if (useDefaultValueType) this.latest[name] = (0, _getAsTypeMjs.getValueAsType)(v, (0, _numberMjs.numberValueTypes)[name]);
            else this.latest[name] = v;
            render && (0, _frameMjs.frame).render(render);
        };
        onChange();
        const cancelOnChange = value.on("change", onChange);
        computed && value.addDependent(computed);
        const remove = ()=>{
            cancelOnChange();
            render && (0, _frameMjs.cancelFrame)(render);
            this.values.delete(name);
            computed && value.removeDependent(computed);
        };
        this.values.set(name, {
            value,
            onRemove: remove
        });
        return remove;
    }
    get(name) {
        return this.values.get(name)?.value;
    }
}

},{"../frameloop/frame.mjs":"4c192","../value/types/maps/number.mjs":"jehqS","../value/types/utils/get-as-type.mjs":"5raY2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6mW8K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "propEffect", ()=>propEffect);
var _createEffectMjs = require("../utils/create-effect.mjs");
const propEffect = /*@__PURE__*/ (0, _createEffectMjs.createEffect)((subject, state, key, value)=>{
    return state.set(key, value, ()=>{
        subject[key] = state.latest[key];
    }, undefined, false);
});

},{"../utils/create-effect.mjs":"7mLbf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8JxT5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addStyleValue", ()=>addStyleValue);
parcelHelpers.export(exports, "styleEffect", ()=>styleEffect);
var _isCssVarMjs = require("../../render/dom/is-css-var.mjs");
var _keysTransformMjs = require("../../render/utils/keys-transform.mjs");
var _isHtmlElementMjs = require("../../utils/is-html-element.mjs");
var _indexMjs = require("../../value/index.mjs");
var _createDomEffectMjs = require("../utils/create-dom-effect.mjs");
var _createEffectMjs = require("../utils/create-effect.mjs");
var _transformMjs = require("./transform.mjs");
const originProps = new Set([
    "originX",
    "originY",
    "originZ"
]);
const addStyleValue = (element, state, key, value)=>{
    let render = undefined;
    let computed = undefined;
    if ((0, _keysTransformMjs.transformProps).has(key)) {
        if (!state.get("transform")) {
            // If this is an HTML element, we need to set the transform-box to fill-box
            // to normalise the transform relative to the element's bounding box
            if (!(0, _isHtmlElementMjs.isHTMLElement)(element) && !state.get("transformBox")) addStyleValue(element, state, "transformBox", new (0, _indexMjs.MotionValue)("fill-box"));
            state.set("transform", new (0, _indexMjs.MotionValue)("none"), ()=>{
                element.style.transform = (0, _transformMjs.buildTransform)(state);
            });
        }
        computed = state.get("transform");
    } else if (originProps.has(key)) {
        if (!state.get("transformOrigin")) state.set("transformOrigin", new (0, _indexMjs.MotionValue)(""), ()=>{
            const originX = state.latest.originX ?? "50%";
            const originY = state.latest.originY ?? "50%";
            const originZ = state.latest.originZ ?? 0;
            element.style.transformOrigin = `${originX} ${originY} ${originZ}`;
        });
        computed = state.get("transformOrigin");
    } else if ((0, _isCssVarMjs.isCSSVar)(key)) render = ()=>{
        element.style.setProperty(key, state.latest[key]);
    };
    else render = ()=>{
        element.style[key] = state.latest[key];
    };
    return state.set(key, value, render, computed);
};
const styleEffect = /*@__PURE__*/ (0, _createDomEffectMjs.createSelectorEffect)(/*@__PURE__*/ (0, _createEffectMjs.createEffect)(addStyleValue));

},{"../../render/dom/is-css-var.mjs":"3Amn8","../../render/utils/keys-transform.mjs":"bJbLV","../../utils/is-html-element.mjs":"8vTac","../../value/index.mjs":"hX31g","../utils/create-dom-effect.mjs":"9FwXM","../utils/create-effect.mjs":"7mLbf","./transform.mjs":"hKVGH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hKVGH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildTransform", ()=>buildTransform);
var _keysTransformMjs = require("../../render/utils/keys-transform.mjs");
const translateAlias = {
    x: "translateX",
    y: "translateY",
    z: "translateZ",
    transformPerspective: "perspective"
};
function buildTransform(state) {
    let transform = "";
    let transformIsDefault = true;
    /**
     * Loop over all possible transforms in order, adding the ones that
     * are present to the transform string.
     */ for(let i = 0; i < (0, _keysTransformMjs.transformPropOrder).length; i++){
        const key = (0, _keysTransformMjs.transformPropOrder)[i];
        const value = state.latest[key];
        if (value === undefined) continue;
        let valueIsDefault = true;
        if (typeof value === "number") valueIsDefault = value === (key.startsWith("scale") ? 1 : 0);
        else {
            const parsed = parseFloat(value);
            valueIsDefault = key.startsWith("scale") ? parsed === 1 : parsed === 0;
        }
        if (!valueIsDefault) {
            transformIsDefault = false;
            const transformName = translateAlias[key] || key;
            transform += `${transformName}(${value}) `;
        }
    }
    return transformIsDefault ? "none" : transform.trim();
}

},{"../../render/utils/keys-transform.mjs":"bJbLV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1CasU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "svgEffect", ()=>svgEffect);
var _indexMjs = require("../../value/index.mjs");
var _indexMjs1 = require("../attr/index.mjs");
var _indexMjs2 = require("../style/index.mjs");
var _createDomEffectMjs = require("../utils/create-dom-effect.mjs");
var _createEffectMjs = require("../utils/create-effect.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
function addSVGPathValue(element, state, key, value) {
    (0, _frameMjs.frame).render(()=>element.setAttribute("pathLength", "1"));
    if (key === "pathOffset") return state.set(key, value, ()=>{
        // Use unitless value to avoid Safari zoom bug
        const offset = state.latest[key];
        element.setAttribute("stroke-dashoffset", `${-offset}`);
    });
    else {
        if (!state.get("stroke-dasharray")) state.set("stroke-dasharray", new (0, _indexMjs.MotionValue)("1 1"), ()=>{
            const { pathLength = 1, pathSpacing } = state.latest;
            // Use unitless values to avoid Safari zoom bug
            element.setAttribute("stroke-dasharray", `${pathLength} ${pathSpacing ?? 1 - Number(pathLength)}`);
        });
        return state.set(key, value, undefined, state.get("stroke-dasharray"));
    }
}
const addSVGValue = (element, state, key, value)=>{
    if (key.startsWith("path")) return addSVGPathValue(element, state, key, value);
    else if (key.startsWith("attr")) return (0, _indexMjs1.addAttrValue)(element, state, convertAttrKey(key), value);
    const handler = key in element.style ? (0, _indexMjs2.addStyleValue) : (0, _indexMjs1.addAttrValue);
    return handler(element, state, key, value);
};
const svgEffect = /*@__PURE__*/ (0, _createDomEffectMjs.createSelectorEffect)(/*@__PURE__*/ (0, _createEffectMjs.createEffect)(addSVGValue));
function convertAttrKey(key) {
    return key.replace(/^attr([A-Z])/, (_, firstChar)=>firstChar.toLowerCase());
}

},{"../../value/index.mjs":"hX31g","../attr/index.mjs":"kh80d","../style/index.mjs":"8JxT5","../utils/create-dom-effect.mjs":"9FwXM","../utils/create-effect.mjs":"7mLbf","../../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9v2ac":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDragActive", ()=>isDragActive);
parcelHelpers.export(exports, "isDragging", ()=>isDragging);
const isDragging = {
    x: false,
    y: false
};
function isDragActive() {
    return isDragging.x || isDragging.y;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"IpnbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setDragLock", ()=>setDragLock);
var _isActiveMjs = require("./is-active.mjs");
function setDragLock(axis) {
    if (axis === "x" || axis === "y") {
        if ((0, _isActiveMjs.isDragging)[axis]) return null;
        else {
            (0, _isActiveMjs.isDragging)[axis] = true;
            return ()=>{
                (0, _isActiveMjs.isDragging)[axis] = false;
            };
        }
    } else {
        if ((0, _isActiveMjs.isDragging).x || (0, _isActiveMjs.isDragging).y) return null;
        else {
            (0, _isActiveMjs.isDragging).x = (0, _isActiveMjs.isDragging).y = true;
            return ()=>{
                (0, _isActiveMjs.isDragging).x = (0, _isActiveMjs.isDragging).y = false;
            };
        }
    }
}

},{"./is-active.mjs":"9v2ac","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4tYFv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hover", ()=>hover);
var _isActiveMjs = require("./drag/state/is-active.mjs");
var _setupMjs = require("./utils/setup.mjs");
function isValidHover(event) {
    return !(event.pointerType === "touch" || (0, _isActiveMjs.isDragActive)());
}
/**
 * Create a hover gesture. hover() is different to .addEventListener("pointerenter")
 * in that it has an easier syntax, filters out polyfilled touch events, interoperates
 * with drag gestures, and automatically removes the "pointerennd" event listener when the hover ends.
 *
 * @public
 */ function hover(elementOrSelector, onHoverStart, options = {}) {
    const [elements, eventOptions, cancel] = (0, _setupMjs.setupGesture)(elementOrSelector, options);
    elements.forEach((element)=>{
        let isPressed = false;
        let deferredHoverEnd = false;
        let hoverEndCallback;
        const removePointerLeave = ()=>{
            element.removeEventListener("pointerleave", onPointerLeave);
        };
        const endHover = (event)=>{
            if (hoverEndCallback) {
                hoverEndCallback(event);
                hoverEndCallback = undefined;
            }
            removePointerLeave();
        };
        const onPointerUp = (event)=>{
            isPressed = false;
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerUp);
            if (deferredHoverEnd) {
                deferredHoverEnd = false;
                endHover(event);
            }
        };
        const onPointerDown = ()=>{
            isPressed = true;
            window.addEventListener("pointerup", onPointerUp, eventOptions);
            window.addEventListener("pointercancel", onPointerUp, eventOptions);
        };
        const onPointerLeave = (leaveEvent)=>{
            if (leaveEvent.pointerType === "touch") return;
            if (isPressed) {
                deferredHoverEnd = true;
                return;
            }
            endHover(leaveEvent);
        };
        const onPointerEnter = (enterEvent)=>{
            if (!isValidHover(enterEvent)) return;
            deferredHoverEnd = false;
            const onHoverEnd = onHoverStart(element, enterEvent);
            if (typeof onHoverEnd !== "function") return;
            hoverEndCallback = onHoverEnd;
            element.addEventListener("pointerleave", onPointerLeave, eventOptions);
        };
        element.addEventListener("pointerenter", onPointerEnter, eventOptions);
        element.addEventListener("pointerdown", onPointerDown, eventOptions);
    });
    return cancel;
}

},{"./drag/state/is-active.mjs":"9v2ac","./utils/setup.mjs":"euWf9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"euWf9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setupGesture", ()=>setupGesture);
var _resolveElementsMjs = require("../../utils/resolve-elements.mjs");
function setupGesture(elementOrSelector, options) {
    const elements = (0, _resolveElementsMjs.resolveElements)(elementOrSelector);
    const gestureAbortController = new AbortController();
    const eventOptions = {
        passive: true,
        ...options,
        signal: gestureAbortController.signal
    };
    const cancel = ()=>gestureAbortController.abort();
    return [
        elements,
        eventOptions,
        cancel
    ];
}

},{"../../utils/resolve-elements.mjs":"pZkYr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8GlfC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "press", ()=>press);
var _isHtmlElementMjs = require("../../utils/is-html-element.mjs");
var _isActiveMjs = require("../drag/state/is-active.mjs");
var _isNodeOrChildMjs = require("../utils/is-node-or-child.mjs");
var _isPrimaryPointerMjs = require("../utils/is-primary-pointer.mjs");
var _setupMjs = require("../utils/setup.mjs");
var _isKeyboardAccessibleMjs = require("./utils/is-keyboard-accessible.mjs");
var _keyboardMjs = require("./utils/keyboard.mjs");
var _stateMjs = require("./utils/state.mjs");
/**
 * Filter out events that are not primary pointer events, or are triggering
 * while a Motion gesture is active.
 */ function isValidPressEvent(event) {
    return (0, _isPrimaryPointerMjs.isPrimaryPointer)(event) && !(0, _isActiveMjs.isDragActive)();
}
const claimedPointerDownEvents = new WeakSet();
/**
 * Create a press gesture.
 *
 * Press is different to `"pointerdown"`, `"pointerup"` in that it
 * automatically filters out secondary pointer events like right
 * click and multitouch.
 *
 * It also adds accessibility support for keyboards, where
 * an element with a press gesture will receive focus and
 *  trigger on Enter `"keydown"` and `"keyup"` events.
 *
 * This is different to a browser's `"click"` event, which does
 * respond to keyboards but only for the `"click"` itself, rather
 * than the press start and end/cancel. The element also needs
 * to be focusable for this to work, whereas a press gesture will
 * make an element focusable by default.
 *
 * @public
 */ function press(targetOrSelector, onPressStart, options = {}) {
    const [targets, eventOptions, cancelEvents] = (0, _setupMjs.setupGesture)(targetOrSelector, options);
    const startPress = (startEvent)=>{
        const target = startEvent.currentTarget;
        if (!isValidPressEvent(startEvent)) return;
        if (claimedPointerDownEvents.has(startEvent)) return;
        (0, _stateMjs.isPressing).add(target);
        if (options.stopPropagation) claimedPointerDownEvents.add(startEvent);
        const onPressEnd = onPressStart(target, startEvent);
        const onPointerEnd = (endEvent, success)=>{
            window.removeEventListener("pointerup", onPointerUp);
            window.removeEventListener("pointercancel", onPointerCancel);
            if ((0, _stateMjs.isPressing).has(target)) (0, _stateMjs.isPressing).delete(target);
            if (!isValidPressEvent(endEvent)) return;
            if (typeof onPressEnd === "function") onPressEnd(endEvent, {
                success
            });
        };
        const onPointerUp = (upEvent)=>{
            onPointerEnd(upEvent, target === window || target === document || options.useGlobalTarget || (0, _isNodeOrChildMjs.isNodeOrChild)(target, upEvent.target));
        };
        const onPointerCancel = (cancelEvent)=>{
            onPointerEnd(cancelEvent, false);
        };
        window.addEventListener("pointerup", onPointerUp, eventOptions);
        window.addEventListener("pointercancel", onPointerCancel, eventOptions);
    };
    targets.forEach((target)=>{
        const pointerDownTarget = options.useGlobalTarget ? window : target;
        pointerDownTarget.addEventListener("pointerdown", startPress, eventOptions);
        if ((0, _isHtmlElementMjs.isHTMLElement)(target)) {
            target.addEventListener("focus", (event)=>(0, _keyboardMjs.enableKeyboardPress)(event, eventOptions));
            if (!(0, _isKeyboardAccessibleMjs.isElementKeyboardAccessible)(target) && !target.hasAttribute("tabindex")) target.tabIndex = 0;
        }
    });
    return cancelEvents;
}

},{"../../utils/is-html-element.mjs":"8vTac","../drag/state/is-active.mjs":"9v2ac","../utils/is-node-or-child.mjs":"4Udis","../utils/is-primary-pointer.mjs":"5ALZe","../utils/setup.mjs":"euWf9","./utils/is-keyboard-accessible.mjs":"kU60h","./utils/keyboard.mjs":"dE9sw","./utils/state.mjs":"fY6oy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Udis":[function(require,module,exports,__globalThis) {
/**
 * Recursively traverse up the tree to check whether the provided child node
 * is the parent or a descendant of it.
 *
 * @param parent - Element to find
 * @param child - Element to test against parent
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isNodeOrChild", ()=>isNodeOrChild);
const isNodeOrChild = (parent, child)=>{
    if (!child) return false;
    else if (parent === child) return true;
    else return isNodeOrChild(parent, child.parentElement);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5ALZe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPrimaryPointer", ()=>isPrimaryPointer);
const isPrimaryPointer = (event)=>{
    if (event.pointerType === "mouse") return typeof event.button !== "number" || event.button <= 0;
    else /**
         * isPrimary is true for all mice buttons, whereas every touch point
         * is regarded as its own input. So subsequent concurrent touch points
         * will be false.
         *
         * Specifically match against false here as incomplete versions of
         * PointerEvents in very old browser might have it set as undefined.
         */ return event.isPrimary !== false;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kU60h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isElementKeyboardAccessible", ()=>isElementKeyboardAccessible);
parcelHelpers.export(exports, "isElementTextInput", ()=>isElementTextInput);
const keyboardAccessibleElements = new Set([
    "BUTTON",
    "INPUT",
    "SELECT",
    "TEXTAREA",
    "A"
]);
/**
 * Checks if an element is natively keyboard accessible (focusable).
 * Used by the press gesture to determine if we need to add tabIndex.
 */ function isElementKeyboardAccessible(element) {
    return keyboardAccessibleElements.has(element.tagName) || element.isContentEditable === true;
}
const textInputElements = new Set([
    "INPUT",
    "SELECT",
    "TEXTAREA"
]);
/**
 * Checks if an element has text selection or direct interaction behavior
 * that should block drag gestures from starting.
 *
 * This specifically targets form controls where the user might want to select
 * text or interact with the control (e.g., sliders, dropdowns).
 *
 * Buttons and links are NOT included because they don't have click-and-move
 * actions of their own - they only respond to click events, so dragging
 * should still work when initiated from these elements.
 */ function isElementTextInput(element) {
    return textInputElements.has(element.tagName) || element.isContentEditable === true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dE9sw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enableKeyboardPress", ()=>enableKeyboardPress);
var _stateMjs = require("./state.mjs");
/**
 * Filter out events that are not "Enter" keys.
 */ function filterEvents(callback) {
    return (event)=>{
        if (event.key !== "Enter") return;
        callback(event);
    };
}
function firePointerEvent(target, type) {
    target.dispatchEvent(new PointerEvent("pointer" + type, {
        isPrimary: true,
        bubbles: true
    }));
}
const enableKeyboardPress = (focusEvent, eventOptions)=>{
    const element = focusEvent.currentTarget;
    if (!element) return;
    const handleKeydown = filterEvents(()=>{
        if ((0, _stateMjs.isPressing).has(element)) return;
        firePointerEvent(element, "down");
        const handleKeyup = filterEvents(()=>{
            firePointerEvent(element, "up");
        });
        const handleBlur = ()=>firePointerEvent(element, "cancel");
        element.addEventListener("keyup", handleKeyup, eventOptions);
        element.addEventListener("blur", handleBlur, eventOptions);
    });
    element.addEventListener("keydown", handleKeydown, eventOptions);
    /**
     * Add an event listener that fires on blur to remove the keydown events.
     */ element.addEventListener("blur", ()=>element.removeEventListener("keydown", handleKeydown), eventOptions);
};

},{"./state.mjs":"fY6oy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fY6oy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPressing", ()=>isPressing);
const isPressing = new WeakSet();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e4krJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedStyle", ()=>getComputedStyle);
var _isCssVarMjs = require("./is-css-var.mjs");
function getComputedStyle(element, name) {
    const computedStyle = window.getComputedStyle(element);
    return (0, _isCssVarMjs.isCSSVar)(name) ? computedStyle.getPropertyValue(name) : computedStyle[name];
}

},{"./is-css-var.mjs":"3Amn8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3FQRk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resize", ()=>resize);
var _handleElementMjs = require("./handle-element.mjs");
var _handleWindowMjs = require("./handle-window.mjs");
function resize(a, b) {
    return typeof a === "function" ? (0, _handleWindowMjs.resizeWindow)(a) : (0, _handleElementMjs.resizeElement)(a, b);
}

},{"./handle-element.mjs":"lvmH8","./handle-window.mjs":"26xIA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lvmH8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resizeElement", ()=>resizeElement);
var _isSvgElementMjs = require("../utils/is-svg-element.mjs");
var _resolveElementsMjs = require("../utils/resolve-elements.mjs");
const resizeHandlers = new WeakMap();
let observer;
const getSize = (borderBoxAxis, svgAxis, htmlAxis)=>(target, borderBoxSize)=>{
        if (borderBoxSize && borderBoxSize[0]) return borderBoxSize[0][borderBoxAxis + "Size"];
        else if ((0, _isSvgElementMjs.isSVGElement)(target) && "getBBox" in target) return target.getBBox()[svgAxis];
        else return target[htmlAxis];
    };
const getWidth = /*@__PURE__*/ getSize("inline", "width", "offsetWidth");
const getHeight = /*@__PURE__*/ getSize("block", "height", "offsetHeight");
function notifyTarget({ target, borderBoxSize }) {
    resizeHandlers.get(target)?.forEach((handler)=>{
        handler(target, {
            get width () {
                return getWidth(target, borderBoxSize);
            },
            get height () {
                return getHeight(target, borderBoxSize);
            }
        });
    });
}
function notifyAll(entries) {
    entries.forEach(notifyTarget);
}
function createResizeObserver() {
    if (typeof ResizeObserver === "undefined") return;
    observer = new ResizeObserver(notifyAll);
}
function resizeElement(target, handler) {
    if (!observer) createResizeObserver();
    const elements = (0, _resolveElementsMjs.resolveElements)(target);
    elements.forEach((element)=>{
        let elementHandlers = resizeHandlers.get(element);
        if (!elementHandlers) {
            elementHandlers = new Set();
            resizeHandlers.set(element, elementHandlers);
        }
        elementHandlers.add(handler);
        observer?.observe(element);
    });
    return ()=>{
        elements.forEach((element)=>{
            const elementHandlers = resizeHandlers.get(element);
            elementHandlers?.delete(handler);
            if (!elementHandlers?.size) observer?.unobserve(element);
        });
    };
}

},{"../utils/is-svg-element.mjs":"jqrAv","../utils/resolve-elements.mjs":"pZkYr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jqrAv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGElement", ()=>isSVGElement);
var _motionUtils = require("motion-utils");
/**
 * Checks if an element is an SVG element in a way
 * that works across iframes
 */ function isSVGElement(element) {
    return (0, _motionUtils.isObject)(element) && "ownerSVGElement" in element;
}

},{"motion-utils":"iBZNm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"26xIA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resizeWindow", ()=>resizeWindow);
const windowCallbacks = new Set();
let windowResizeHandler;
function createWindowResizeHandler() {
    windowResizeHandler = ()=>{
        const info = {
            get width () {
                return window.innerWidth;
            },
            get height () {
                return window.innerHeight;
            }
        };
        windowCallbacks.forEach((callback)=>callback(info));
    };
    window.addEventListener("resize", windowResizeHandler);
}
function resizeWindow(callback) {
    windowCallbacks.add(callback);
    if (!windowResizeHandler) createWindowResizeHandler();
    return ()=>{
        windowCallbacks.delete(callback);
        if (!windowCallbacks.size && typeof windowResizeHandler === "function") {
            window.removeEventListener("resize", windowResizeHandler);
            windowResizeHandler = undefined;
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eJu1Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeTimeline", ()=>observeTimeline);
var _frameMjs = require("../frameloop/frame.mjs");
function observeTimeline(update, timeline) {
    let prevProgress;
    const onFrame = ()=>{
        const { currentTime } = timeline;
        const percentage = currentTime === null ? 0 : currentTime.value;
        const progress = percentage / 100;
        if (prevProgress !== progress) update(progress);
        prevProgress = progress;
    };
    (0, _frameMjs.frame).preUpdate(onFrame, true);
    return ()=>(0, _frameMjs.cancelFrame)(onFrame);
}

},{"../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"yxTcM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "recordStats", ()=>recordStats);
var _animationCountMjs = require("./animation-count.mjs");
var _bufferMjs = require("./buffer.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
function record() {
    const { value } = (0, _bufferMjs.statsBuffer);
    if (value === null) {
        (0, _frameMjs.cancelFrame)(record);
        return;
    }
    value.frameloop.rate.push((0, _frameMjs.frameData).delta);
    value.animations.mainThread.push((0, _animationCountMjs.activeAnimations).mainThread);
    value.animations.waapi.push((0, _animationCountMjs.activeAnimations).waapi);
    value.animations.layout.push((0, _animationCountMjs.activeAnimations).layout);
}
function mean(values) {
    return values.reduce((acc, value)=>acc + value, 0) / values.length;
}
function summarise(values, calcAverage = mean) {
    if (values.length === 0) return {
        min: 0,
        max: 0,
        avg: 0
    };
    return {
        min: Math.min(...values),
        max: Math.max(...values),
        avg: calcAverage(values)
    };
}
const msToFps = (ms)=>Math.round(1000 / ms);
function clearStatsBuffer() {
    (0, _bufferMjs.statsBuffer).value = null;
    (0, _bufferMjs.statsBuffer).addProjectionMetrics = null;
}
function reportStats() {
    const { value } = (0, _bufferMjs.statsBuffer);
    if (!value) throw new Error("Stats are not being measured");
    clearStatsBuffer();
    (0, _frameMjs.cancelFrame)(record);
    const summary = {
        frameloop: {
            setup: summarise(value.frameloop.setup),
            rate: summarise(value.frameloop.rate),
            read: summarise(value.frameloop.read),
            resolveKeyframes: summarise(value.frameloop.resolveKeyframes),
            preUpdate: summarise(value.frameloop.preUpdate),
            update: summarise(value.frameloop.update),
            preRender: summarise(value.frameloop.preRender),
            render: summarise(value.frameloop.render),
            postRender: summarise(value.frameloop.postRender)
        },
        animations: {
            mainThread: summarise(value.animations.mainThread),
            waapi: summarise(value.animations.waapi),
            layout: summarise(value.animations.layout)
        },
        layoutProjection: {
            nodes: summarise(value.layoutProjection.nodes),
            calculatedTargetDeltas: summarise(value.layoutProjection.calculatedTargetDeltas),
            calculatedProjections: summarise(value.layoutProjection.calculatedProjections)
        }
    };
    /**
     * Convert the rate to FPS
     */ const { rate } = summary.frameloop;
    rate.min = msToFps(rate.min);
    rate.max = msToFps(rate.max);
    rate.avg = msToFps(rate.avg);
    [rate.min, rate.max] = [
        rate.max,
        rate.min
    ];
    return summary;
}
function recordStats() {
    if ((0, _bufferMjs.statsBuffer).value) {
        clearStatsBuffer();
        throw new Error("Stats are already being measured");
    }
    const newStatsBuffer = (0, _bufferMjs.statsBuffer);
    newStatsBuffer.value = {
        frameloop: {
            setup: [],
            rate: [],
            read: [],
            resolveKeyframes: [],
            preUpdate: [],
            update: [],
            preRender: [],
            render: [],
            postRender: []
        },
        animations: {
            mainThread: [],
            waapi: [],
            layout: []
        },
        layoutProjection: {
            nodes: [],
            calculatedTargetDeltas: [],
            calculatedProjections: []
        }
    };
    newStatsBuffer.addProjectionMetrics = (metrics)=>{
        const { layoutProjection } = newStatsBuffer.value;
        layoutProjection.nodes.push(metrics.nodes);
        layoutProjection.calculatedTargetDeltas.push(metrics.calculatedTargetDeltas);
        layoutProjection.calculatedProjections.push(metrics.calculatedProjections);
    };
    (0, _frameMjs.frame).postRender(record, true);
    return reportStats;
}

},{"./animation-count.mjs":"lEkpG","./buffer.mjs":"94Uw8","../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a7f17":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSVGSVGElement", ()=>isSVGSVGElement);
var _isSvgElementMjs = require("./is-svg-element.mjs");
/**
 * Checks if an element is specifically an SVGSVGElement (the root SVG element)
 * in a way that works across iframes
 */ function isSVGSVGElement(element) {
    return (0, _isSvgElementMjs.isSVGElement)(element) && element.tagName === "svg";
}

},{"./is-svg-element.mjs":"jqrAv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ujIK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOriginIndex", ()=>getOriginIndex);
parcelHelpers.export(exports, "stagger", ()=>stagger);
var _motionUtils = require("motion-utils");
function getOriginIndex(from, total) {
    if (from === "first") return 0;
    else {
        const lastIndex = total - 1;
        return from === "last" ? lastIndex : lastIndex / 2;
    }
}
function stagger(duration = 0.1, { startDelay = 0, from = 0, ease } = {}) {
    return (i, total)=>{
        const fromIndex = typeof from === "number" ? from : getOriginIndex(from, total);
        const distance = Math.abs(fromIndex - i);
        let delay = duration * distance;
        if (ease) {
            const maxDelay = total * duration;
            const easingFunction = (0, _motionUtils.easingDefinitionToFunction)(ease);
            delay = easingFunction(delay / maxDelay) * maxDelay;
        }
        return startDelay + delay;
    };
}

},{"motion-utils":"9fF4f","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"54ksz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transform", ()=>transform);
var _interpolateMjs = require("./interpolate.mjs");
function transform(...args) {
    const useImmediate = !Array.isArray(args[0]);
    const argOffset = useImmediate ? 0 : -1;
    const inputValue = args[0 + argOffset];
    const inputRange = args[1 + argOffset];
    const outputRange = args[2 + argOffset];
    const options = args[3 + argOffset];
    const interpolator = (0, _interpolateMjs.interpolate)(inputRange, outputRange, options);
    return useImmediate ? interpolator(inputValue) : interpolator;
}

},{"./interpolate.mjs":"8F7BJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcLCq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachFollow", ()=>attachFollow);
parcelHelpers.export(exports, "followValue", ()=>followValue);
var _indexMjs = require("./index.mjs");
var _jsanimationMjs = require("../animation/JSAnimation.mjs");
var _isMotionValueMjs = require("./utils/is-motion-value.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
/**
 * Create a `MotionValue` that animates to its latest value using any transition type.
 * Can either be a value or track another `MotionValue`.
 *
 * ```jsx
 * const x = motionValue(0)
 * const y = followValue(x, { type: "spring", stiffness: 300 })
 * // or with tween
 * const z = followValue(x, { type: "tween", duration: 0.5, ease: "easeOut" })
 * ```
 *
 * @param source - Initial value or MotionValue to track
 * @param options - Animation transition options
 * @returns `MotionValue`
 *
 * @public
 */ function followValue(source, options) {
    const initialValue = (0, _isMotionValueMjs.isMotionValue)(source) ? source.get() : source;
    const value = (0, _indexMjs.motionValue)(initialValue);
    attachFollow(value, source, options);
    return value;
}
/**
 * Attach an animation to a MotionValue that will animate whenever the value changes.
 * Similar to attachSpring but supports any transition type (spring, tween, inertia, etc.)
 *
 * @param value - The MotionValue to animate
 * @param source - Initial value or MotionValue to track
 * @param options - Animation transition options
 * @returns Cleanup function
 *
 * @public
 */ function attachFollow(value, source, options = {}) {
    const initialValue = value.get();
    let activeAnimation = null;
    let latestValue = initialValue;
    let latestSetter;
    const unit = typeof initialValue === "string" ? initialValue.replace(/[\d.-]/g, "") : undefined;
    const stopAnimation = ()=>{
        if (activeAnimation) {
            activeAnimation.stop();
            activeAnimation = null;
        }
        value.animation = undefined;
    };
    const startAnimation = ()=>{
        const currentValue = asNumber(value.get());
        const targetValue = asNumber(latestValue);
        // Don't animate if we're already at the target
        if (currentValue === targetValue) {
            stopAnimation();
            return;
        }
        // Use the running animation's analytical velocity for accuracy,
        // falling back to the MotionValue's velocity for the initial animation.
        // This prevents systematic velocity loss at high frame rates (240hz+).
        const velocity = activeAnimation ? activeAnimation.getGeneratorVelocity() : value.getVelocity();
        stopAnimation();
        activeAnimation = new (0, _jsanimationMjs.JSAnimation)({
            keyframes: [
                currentValue,
                targetValue
            ],
            velocity,
            // Default to spring if no type specified (matches useSpring behavior)
            type: "spring",
            restDelta: 0.001,
            restSpeed: 0.01,
            ...options,
            onUpdate: latestSetter
        });
    };
    // Use a stable function reference so the frame loop Set deduplicates
    // multiple calls within the same frame (e.g. rapid mouse events)
    const scheduleAnimation = ()=>{
        startAnimation();
        value.animation = activeAnimation ?? undefined;
        value["events"].animationStart?.notify();
        activeAnimation?.then(()=>{
            value.animation = undefined;
            value["events"].animationComplete?.notify();
        });
    };
    value.attach((v, set)=>{
        latestValue = v;
        latestSetter = (latest)=>set(parseValue(latest, unit));
        (0, _frameMjs.frame).postRender(scheduleAnimation);
    }, stopAnimation);
    if ((0, _isMotionValueMjs.isMotionValue)(source)) {
        let skipNextAnimation = options.skipInitialAnimation === true;
        const removeSourceOnChange = source.on("change", (v)=>{
            if (skipNextAnimation) {
                skipNextAnimation = false;
                value.jump(parseValue(v, unit), false);
            } else value.set(parseValue(v, unit));
        });
        const removeValueOnDestroy = value.on("destroy", removeSourceOnChange);
        return ()=>{
            removeSourceOnChange();
            removeValueOnDestroy();
        };
    }
    return stopAnimation;
}
function parseValue(v, unit) {
    return unit ? v + unit : v;
}
function asNumber(v) {
    return typeof v === "number" ? v : parseFloat(v);
}

},{"./index.mjs":"hX31g","../animation/JSAnimation.mjs":"hmfBB","./utils/is-motion-value.mjs":"fKDJz","../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"exPo0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", ()=>mapValue);
var _transformMjs = require("../utils/transform.mjs");
var _transformValueMjs = require("./transform-value.mjs");
/**
 * Create a `MotionValue` that maps the output of another `MotionValue` by
 * mapping it from one range of values into another.
 *
 * @remarks
 *
 * Given an input range of `[-200, -100, 100, 200]` and an output range of
 * `[0, 1, 1, 0]`, the returned `MotionValue` will:
 *
 * - When provided a value between `-200` and `-100`, will return a value between `0` and  `1`.
 * - When provided a value between `-100` and `100`, will return `1`.
 * - When provided a value between `100` and `200`, will return a value between `1` and  `0`
 *
 * The input range must be a linear series of numbers. The output range
 * can be any value type supported by Motion: numbers, colors, shadows, etc.
 *
 * Every value in the output range must be of the same type and in the same format.
 *
 * ```jsx
 * const x = motionValue(0)
 * const xRange = [-200, -100, 100, 200]
 * const opacityRange = [0, 1, 1, 0]
 * const opacity = mapValue(x, xRange, opacityRange)
 * ```
 *
 * @param inputValue - `MotionValue`
 * @param inputRange - A linear series of numbers (either all increasing or decreasing)
 * @param outputRange - A series of numbers, colors or strings. Must be the same length as `inputRange`.
 * @param options -
 *
 *  - clamp: boolean. Clamp values to within the given range. Defaults to `true`
 *  - ease: EasingFunction[]. Easing functions to use on the interpolations between each value in the input and output ranges. If provided as an array, the array must be one item shorter than the input and output ranges, as the easings apply to the transition between each.
 *
 * @returns `MotionValue`
 *
 * @public
 */ function mapValue(inputValue, inputRange, outputRange, options) {
    const map = (0, _transformMjs.transform)(inputRange, outputRange, options);
    return (0, _transformValueMjs.transformValue)(()=>map(inputValue.get()));
}

},{"../utils/transform.mjs":"54ksz","./transform-value.mjs":"iCJCp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iCJCp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformValue", ()=>transformValue);
var _indexMjs = require("./index.mjs");
var _subscribeValueMjs = require("./subscribe-value.mjs");
/**
 * Create a `MotionValue` that transforms the output of other `MotionValue`s by
 * passing their latest values through a transform function.
 *
 * Whenever a `MotionValue` referred to in the provided function is updated,
 * it will be re-evaluated.
 *
 * ```jsx
 * const x = motionValue(0)
 * const y = transformValue(() => x.get() * 2) // double x
 * ```
 *
 * @param transformer - A transform function. This function must be pure with no side-effects or conditional statements.
 * @returns `MotionValue`
 *
 * @public
 */ function transformValue(transform) {
    const collectedValues = [];
    /**
     * Open session of collectMotionValues. Any MotionValue that calls get()
     * inside transform will be saved into this array.
     */ (0, _indexMjs.collectMotionValues).current = collectedValues;
    const initialValue = transform();
    (0, _indexMjs.collectMotionValues).current = undefined;
    const value = (0, _indexMjs.motionValue)(initialValue);
    (0, _subscribeValueMjs.subscribeValue)(collectedValues, value, transform);
    return value;
}

},{"./index.mjs":"hX31g","./subscribe-value.mjs":"I4a10","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"I4a10":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscribeValue", ()=>subscribeValue);
var _frameMjs = require("../frameloop/frame.mjs");
function subscribeValue(inputValues, outputValue, getLatest) {
    const update = ()=>outputValue.set(getLatest());
    const scheduleUpdate = ()=>(0, _frameMjs.frame).preRender(update, false, true);
    const subscriptions = inputValues.map((v)=>v.on("change", scheduleUpdate));
    outputValue.on("destroy", ()=>{
        subscriptions.forEach((unsubscribe)=>unsubscribe());
        (0, _frameMjs.cancelFrame)(update);
    });
}

},{"../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6u4Nr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "attachSpring", ()=>attachSpring);
parcelHelpers.export(exports, "springValue", ()=>springValue);
var _followValueMjs = require("./follow-value.mjs");
/**
 * Create a `MotionValue` that animates to its latest value using a spring.
 * Can either be a value or track another `MotionValue`.
 *
 * ```jsx
 * const x = motionValue(0)
 * const y = springValue(x, { stiffness: 300 })
 * ```
 *
 * @param source - Initial value or MotionValue to track
 * @param options - Spring configuration options
 * @returns `MotionValue`
 *
 * @public
 */ function springValue(source, options) {
    return (0, _followValueMjs.followValue)(source, {
        type: "spring",
        ...options
    });
}
/**
 * Attach a spring animation to a MotionValue that will animate whenever the value changes.
 *
 * @param value - The MotionValue to animate
 * @param source - Initial value or MotionValue to track
 * @param options - Spring configuration options
 * @returns Cleanup function
 *
 * @public
 */ function attachSpring(value, source, options) {
    return (0, _followValueMjs.attachFollow)(value, source, {
        type: "spring",
        ...options
    });
}

},{"./follow-value.mjs":"lcLCq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bCLqF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ViewTransitionBuilder", ()=>ViewTransitionBuilder);
parcelHelpers.export(exports, "animateView", ()=>animateView);
var _motionUtils = require("motion-utils");
var _queueMjs = require("./queue.mjs");
class ViewTransitionBuilder {
    constructor(update, options = {}){
        this.currentSubject = "root";
        this.targets = new Map();
        this.notifyReady = (0, _motionUtils.noop);
        this.readyPromise = new Promise((resolve)=>{
            this.notifyReady = resolve;
        });
        this.update = update;
        this.options = {
            interrupt: "wait",
            ...options
        };
        (0, _queueMjs.addToQueue)(this);
    }
    get(subject) {
        this.currentSubject = subject;
        return this;
    }
    layout(keyframes, options) {
        this.updateTarget("layout", keyframes, options);
        return this;
    }
    new(keyframes, options) {
        this.updateTarget("new", keyframes, options);
        return this;
    }
    old(keyframes, options) {
        this.updateTarget("old", keyframes, options);
        return this;
    }
    enter(keyframes, options) {
        this.updateTarget("enter", keyframes, options);
        return this;
    }
    exit(keyframes, options) {
        this.updateTarget("exit", keyframes, options);
        return this;
    }
    crossfade(options) {
        this.updateTarget("enter", {
            opacity: 1
        }, options);
        this.updateTarget("exit", {
            opacity: 0
        }, options);
        return this;
    }
    updateTarget(target, keyframes, options = {}) {
        const { currentSubject, targets } = this;
        if (!targets.has(currentSubject)) targets.set(currentSubject, {});
        const targetData = targets.get(currentSubject);
        targetData[target] = {
            keyframes,
            options
        };
    }
    then(resolve, reject) {
        return this.readyPromise.then(resolve, reject);
    }
}
function animateView(update, defaultOptions = {}) {
    return new ViewTransitionBuilder(update, defaultOptions);
}

},{"motion-utils":"1tDyg","./queue.mjs":"dpBvE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dpBvE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addToQueue", ()=>addToQueue);
var _motionUtils = require("motion-utils");
var _microtaskMjs = require("../frameloop/microtask.mjs");
var _startMjs = require("./start.mjs");
let builders = [];
let current = null;
function next() {
    current = null;
    const [nextBuilder] = builders;
    if (nextBuilder) start(nextBuilder);
}
function start(builder) {
    (0, _motionUtils.removeItem)(builders, builder);
    current = builder;
    (0, _startMjs.startViewAnimation)(builder).then((animation)=>{
        builder.notifyReady(animation);
        animation.finished.finally(next);
    });
}
function processQueue() {
    /**
     * Iterate backwards over the builders array. We can ignore the
     * "wait" animations. If we have an interrupting animation in the
     * queue then we need to batch all preceeding animations into it.
     * Currently this only batches the update functions but will also
     * need to batch the targets.
     */ for(let i = builders.length - 1; i >= 0; i--){
        const builder = builders[i];
        const { interrupt } = builder.options;
        if (interrupt === "immediate") {
            const batchedUpdates = builders.slice(0, i + 1).map((b)=>b.update);
            const remaining = builders.slice(i + 1);
            builder.update = ()=>{
                batchedUpdates.forEach((update)=>update());
            };
            // Put the current builder at the front, followed by any "wait" builders
            builders = [
                builder,
                ...remaining
            ];
            break;
        }
    }
    if (!current || builders[0]?.options.interrupt === "immediate") next();
}
function addToQueue(builder) {
    builders.push(builder);
    (0, _microtaskMjs.microtask).render(processQueue);
}

},{"motion-utils":"841vh","../frameloop/microtask.mjs":"7uR6H","./start.mjs":"feT4i","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"feT4i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "startViewAnimation", ()=>startViewAnimation);
var _motionUtils = require("motion-utils");
var _groupAnimationMjs = require("../animation/GroupAnimation.mjs");
var _nativeAnimationMjs = require("../animation/NativeAnimation.mjs");
var _nativeAnimationWrapperMjs = require("../animation/NativeAnimationWrapper.mjs");
var _getValueTransitionMjs = require("../animation/utils/get-value-transition.mjs");
var _mapEasingMjs = require("../animation/waapi/easing/map-easing.mjs");
var _applyGeneratorMjs = require("../animation/waapi/utils/apply-generator.mjs");
var _chooseLayerTypeMjs = require("./utils/choose-layer-type.mjs");
var _cssMjs = require("./utils/css.mjs");
var _getLayerInfoMjs = require("./utils/get-layer-info.mjs");
var _getViewAnimationsMjs = require("./utils/get-view-animations.mjs");
var _hasTargetMjs = require("./utils/has-target.mjs");
const definitionNames = [
    "layout",
    "enter",
    "exit",
    "new",
    "old"
];
function startViewAnimation(builder) {
    const { update, targets, options: defaultOptions } = builder;
    if (!document.startViewTransition) return new Promise(async (resolve)=>{
        await update();
        resolve(new (0, _groupAnimationMjs.GroupAnimation)([]));
    });
    // TODO: Go over existing targets and ensure they all have ids
    /**
     * If we don't have any animations defined for the root target,
     * remove it from being captured.
     */ if (!(0, _hasTargetMjs.hasTarget)("root", targets)) (0, _cssMjs.css).set(":root", {
        "view-transition-name": "none"
    });
    /**
     * Set the timing curve to linear for all view transition layers.
     * This gets baked into the keyframes, which can't be changed
     * without breaking the generated animation.
     *
     * This allows us to set easing via updateTiming - which can be changed.
     */ (0, _cssMjs.css).set("::view-transition-group(*), ::view-transition-old(*), ::view-transition-new(*)", {
        "animation-timing-function": "linear !important"
    });
    (0, _cssMjs.css).commit(); // Write
    const transition = document.startViewTransition(async ()=>{
        await update();
    // TODO: Go over new targets and ensure they all have ids
    });
    transition.finished.finally(()=>{
        (0, _cssMjs.css).remove(); // Write
    });
    return new Promise((resolve)=>{
        transition.ready.then(()=>{
            const generatedViewAnimations = (0, _getViewAnimationsMjs.getViewAnimations)();
            const animations = [];
            /**
             * Create animations for each of our explicitly-defined subjects.
             */ targets.forEach((definition, target)=>{
                // TODO: If target is not "root", resolve elements
                // and iterate over each
                for (const key of definitionNames){
                    if (!definition[key]) continue;
                    const { keyframes, options } = definition[key];
                    for (let [valueName, valueKeyframes] of Object.entries(keyframes)){
                        if (!valueKeyframes) continue;
                        const valueOptions = {
                            ...(0, _getValueTransitionMjs.getValueTransition)(defaultOptions, valueName),
                            ...(0, _getValueTransitionMjs.getValueTransition)(options, valueName)
                        };
                        const type = (0, _chooseLayerTypeMjs.chooseLayerType)(key);
                        /**
                         * If this is an opacity animation, and keyframes are not an array,
                         * we need to convert them into an array and set an initial value.
                         */ if (valueName === "opacity" && !Array.isArray(valueKeyframes)) {
                            const initialValue = type === "new" ? 0 : 1;
                            valueKeyframes = [
                                initialValue,
                                valueKeyframes
                            ];
                        }
                        /**
                         * Resolve stagger function if provided.
                         */ if (typeof valueOptions.delay === "function") valueOptions.delay = valueOptions.delay(0, 1);
                        valueOptions.duration && (valueOptions.duration = (0, _motionUtils.secondsToMilliseconds)(valueOptions.duration));
                        valueOptions.delay && (valueOptions.delay = (0, _motionUtils.secondsToMilliseconds)(valueOptions.delay));
                        const animation = new (0, _nativeAnimationMjs.NativeAnimation)({
                            ...valueOptions,
                            element: document.documentElement,
                            name: valueName,
                            pseudoElement: `::view-transition-${type}(${target})`,
                            keyframes: valueKeyframes
                        });
                        animations.push(animation);
                    }
                }
            });
            /**
             * Handle browser generated animations
             */ for (const animation of generatedViewAnimations){
                if (animation.playState === "finished") continue;
                const { effect } = animation;
                if (!effect || !(effect instanceof KeyframeEffect)) continue;
                const { pseudoElement } = effect;
                if (!pseudoElement) continue;
                const name = (0, _getLayerInfoMjs.getViewAnimationLayerInfo)(pseudoElement);
                if (!name) continue;
                const targetDefinition = targets.get(name.layer);
                if (!targetDefinition) {
                    /**
                     * If transition name is group then update the timing of the animation
                     * whereas if it's old or new then we could possibly replace it using
                     * the above method.
                     */ const transitionName = name.type === "group" ? "layout" : "";
                    let animationTransition = {
                        ...(0, _getValueTransitionMjs.getValueTransition)(defaultOptions, transitionName)
                    };
                    animationTransition.duration && (animationTransition.duration = (0, _motionUtils.secondsToMilliseconds)(animationTransition.duration));
                    animationTransition = (0, _applyGeneratorMjs.applyGeneratorOptions)(animationTransition);
                    const easing = (0, _mapEasingMjs.mapEasingToNativeEasing)(animationTransition.ease, animationTransition.duration);
                    effect.updateTiming({
                        delay: (0, _motionUtils.secondsToMilliseconds)(animationTransition.delay ?? 0),
                        duration: animationTransition.duration,
                        easing
                    });
                    animations.push(new (0, _nativeAnimationWrapperMjs.NativeAnimationWrapper)(animation));
                } else if (hasOpacity(targetDefinition, "enter") && hasOpacity(targetDefinition, "exit") && effect.getKeyframes().some((keyframe)=>keyframe.mixBlendMode)) animations.push(new (0, _nativeAnimationWrapperMjs.NativeAnimationWrapper)(animation));
                else animation.cancel();
            }
            resolve(new (0, _groupAnimationMjs.GroupAnimation)(animations));
        });
    });
}
function hasOpacity(target, key) {
    return target?.[key]?.keyframes.opacity;
}

},{"motion-utils":"dIdtR","../animation/GroupAnimation.mjs":"7hkDg","../animation/NativeAnimation.mjs":"bnVN0","../animation/NativeAnimationWrapper.mjs":"1IfeU","../animation/utils/get-value-transition.mjs":"6hcoP","../animation/waapi/easing/map-easing.mjs":"4rOWo","../animation/waapi/utils/apply-generator.mjs":"96wQp","./utils/choose-layer-type.mjs":"1HjOH","./utils/css.mjs":"7WArr","./utils/get-layer-info.mjs":"21pKt","./utils/get-view-animations.mjs":"4QNDL","./utils/has-target.mjs":"dbY0W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1HjOH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "chooseLayerType", ()=>chooseLayerType);
function chooseLayerType(valueName) {
    if (valueName === "layout") return "group";
    if (valueName === "enter" || valueName === "new") return "new";
    if (valueName === "exit" || valueName === "old") return "old";
    return "group";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7WArr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "css", ()=>css);
let pendingRules = {};
let style = null;
const css = {
    set: (selector, values)=>{
        pendingRules[selector] = values;
    },
    commit: ()=>{
        if (!style) {
            style = document.createElement("style");
            style.id = "motion-view";
        }
        let cssText = "";
        for(const selector in pendingRules){
            const rule = pendingRules[selector];
            cssText += `${selector} {\n`;
            for (const [property, value] of Object.entries(rule))cssText += `  ${property}: ${value};\n`;
            cssText += "}\n";
        }
        style.textContent = cssText;
        document.head.appendChild(style);
        pendingRules = {};
    },
    remove: ()=>{
        if (style && style.parentElement) style.parentElement.removeChild(style);
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"21pKt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getViewAnimationLayerInfo", ()=>getViewAnimationLayerInfo);
function getViewAnimationLayerInfo(pseudoElement) {
    const match = pseudoElement.match(/::view-transition-(old|new|group|image-pair)\((.*?)\)/);
    if (!match) return null;
    return {
        layer: match[2],
        type: match[1]
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4QNDL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getViewAnimations", ()=>getViewAnimations);
function filterViewAnimations(animation) {
    const { effect } = animation;
    if (!effect) return false;
    return effect.target === document.documentElement && effect.pseudoElement?.startsWith("::view-transition");
}
function getViewAnimations() {
    return document.getAnimations().filter(filterViewAnimations);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dbY0W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasTarget", ()=>hasTarget);
function hasTarget(target, targets) {
    return targets.has(target) && Object.keys(targets.get(target)).length > 0;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2NZnJ":[function(require,module,exports,__globalThis) {
/**
 * Feature base class for extending VisualElement functionality.
 * Features are plugins that can be mounted/unmounted to add behavior
 * like gestures, animations, or layout tracking.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Feature", ()=>Feature);
class Feature {
    constructor(node){
        this.isMounted = false;
        this.node = node;
    }
    update() {}
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8FXBn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ObjectVisualElement", ()=>ObjectVisualElement);
var _modelsMjs = require("../../projection/geometry/models.mjs");
var _visualElementMjs = require("../VisualElement.mjs");
function isObjectKey(key, object) {
    return key in object;
}
class ObjectVisualElement extends (0, _visualElementMjs.VisualElement) {
    constructor(){
        super(...arguments);
        this.type = "object";
    }
    readValueFromInstance(instance, key) {
        if (isObjectKey(key, instance)) {
            const value = instance[key];
            if (typeof value === "string" || typeof value === "number") return value;
        }
        return undefined;
    }
    getBaseTargetFromProps() {
        return undefined;
    }
    removeValueFromRenderState(key, renderState) {
        delete renderState.output[key];
    }
    measureInstanceViewportBox() {
        return (0, _modelsMjs.createBox)();
    }
    build(renderState, latestValues) {
        Object.assign(renderState.output, latestValues);
    }
    renderInstance(instance, { output }) {
        Object.assign(instance, output);
    }
    sortInstanceNodePosition() {
        return 0;
    }
}

},{"../../projection/geometry/models.mjs":"5H0uu","../VisualElement.mjs":"lVIcw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kHpbR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "checkVariantsDidChange", ()=>checkVariantsDidChange);
parcelHelpers.export(exports, "createAnimationState", ()=>createAnimationState);
var _visualElementMjs = require("../../animation/interfaces/visual-element.mjs");
var _calcChildStaggerMjs = require("../../animation/utils/calc-child-stagger.mjs");
var _getVariantContextMjs = require("./get-variant-context.mjs");
var _isAnimationControlsMjs = require("./is-animation-controls.mjs");
var _isKeyframesTargetMjs = require("./is-keyframes-target.mjs");
var _isVariantLabelMjs = require("./is-variant-label.mjs");
var _resolveDynamicVariantsMjs = require("./resolve-dynamic-variants.mjs");
var _shallowCompareMjs = require("./shallow-compare.mjs");
var _variantPropsMjs = require("./variant-props.mjs");
const reversePriorityOrder = [
    ...(0, _variantPropsMjs.variantPriorityOrder)
].reverse();
const numAnimationTypes = (0, _variantPropsMjs.variantPriorityOrder).length;
function createAnimateFunction(visualElement) {
    return (animations)=>{
        return Promise.all(animations.map(({ animation, options })=>(0, _visualElementMjs.animateVisualElement)(visualElement, animation, options)));
    };
}
function createAnimationState(visualElement) {
    let animate = createAnimateFunction(visualElement);
    let state = createState();
    let isInitialRender = true;
    /**
     * Track whether the animation state has been reset (e.g. via StrictMode
     * double-invocation or Suspense unmount/remount). On the first
     * animateChanges() call after a reset we need to behave like the initial
     * render for variant-inheritance checks, even though isInitialRender is
     * already false.
     */ let wasReset = false;
    /**
     * This function will be used to reduce the animation definitions for
     * each active animation type into an object of resolved values for it.
     */ const buildResolvedTypeValues = (type)=>(acc, definition)=>{
            const resolved = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, definition, type === "exit" ? visualElement.presenceContext?.custom : undefined);
            if (resolved) {
                const { transition, transitionEnd, ...target } = resolved;
                acc = {
                    ...acc,
                    ...target,
                    ...transitionEnd
                };
            }
            return acc;
        };
    /**
     * This just allows us to inject mocked animation functions
     * @internal
     */ function setAnimateFunction(makeAnimator) {
        animate = makeAnimator(visualElement);
    }
    /**
     * When we receive new props, we need to:
     * 1. Create a list of protected keys for each type. This is a directory of
     *    value keys that are currently being "handled" by types of a higher priority
     *    so that whenever an animation is played of a given type, these values are
     *    protected from being animated.
     * 2. Determine if an animation type needs animating.
     * 3. Determine if any values have been removed from a type and figure out
     *    what to animate those to.
     */ function animateChanges(changedActiveType) {
        const { props } = visualElement;
        const context = (0, _getVariantContextMjs.getVariantContext)(visualElement.parent) || {};
        /**
         * A list of animations that we'll build into as we iterate through the animation
         * types. This will get executed at the end of the function.
         */ const animations = [];
        /**
         * Keep track of which values have been removed. Then, as we hit lower priority
         * animation types, we can check if they contain removed values and animate to that.
         */ const removedKeys = new Set();
        /**
         * A dictionary of all encountered keys. This is an object to let us build into and
         * copy it without iteration. Each time we hit an animation type we set its protected
         * keys - the keys its not allowed to animate - to the latest version of this object.
         */ let encounteredKeys = {};
        /**
         * If a variant has been removed at a given index, and this component is controlling
         * variant animations, we want to ensure lower-priority variants are forced to animate.
         */ let removedVariantIndex = Infinity;
        /**
         * Iterate through all animation types in reverse priority order. For each, we want to
         * detect which values it's handling and whether or not they've changed (and therefore
         * need to be animated). If any values have been removed, we want to detect those in
         * lower priority props and flag for animation.
         */ for(let i = 0; i < numAnimationTypes; i++){
            const type = reversePriorityOrder[i];
            const typeState = state[type];
            const prop = props[type] !== undefined ? props[type] : context[type];
            const propIsVariant = (0, _isVariantLabelMjs.isVariantLabel)(prop);
            /**
             * If this type has *just* changed isActive status, set activeDelta
             * to that status. Otherwise set to null.
             */ const activeDelta = type === changedActiveType ? typeState.isActive : null;
            if (activeDelta === false) removedVariantIndex = i;
            /**
             * If this prop is an inherited variant, rather than been set directly on the
             * component itself, we want to make sure we allow the parent to trigger animations.
             *
             * TODO: Can probably change this to a !isControllingVariants check
             */ let isInherited = prop === context[type] && prop !== props[type] && propIsVariant;
            if (isInherited && (isInitialRender || wasReset) && visualElement.manuallyAnimateOnMount) isInherited = false;
            /**
             * Set all encountered keys so far as the protected keys for this type. This will
             * be any key that has been animated or otherwise handled by active, higher-priortiy types.
             */ typeState.protectedKeys = {
                ...encounteredKeys
            };
            // Check if we can skip analysing this prop early
            if (// If it isn't active and hasn't *just* been set as inactive
            !typeState.isActive && activeDelta === null || // If we didn't and don't have any defined prop for this animation type
            !prop && !typeState.prevProp || // Or if the prop doesn't define an animation
            (0, _isAnimationControlsMjs.isAnimationControls)(prop) || typeof prop === "boolean") continue;
            /**
             * If exit is already active and wasn't just activated, skip
             * re-processing to prevent interrupting running exit animations.
             * Re-resolving exit with a changed custom value can start new
             * value animations that stop the originals, leaving the exit
             * animation promise unresolved and the component stuck in the DOM.
             */ if (type === "exit" && typeState.isActive && activeDelta !== true) {
                if (typeState.prevResolvedValues) encounteredKeys = {
                    ...encounteredKeys,
                    ...typeState.prevResolvedValues
                };
                continue;
            }
            /**
             * As we go look through the values defined on this type, if we detect
             * a changed value or a value that was removed in a higher priority, we set
             * this to true and add this prop to the animation list.
             */ const variantDidChange = checkVariantsDidChange(typeState.prevProp, prop);
            let shouldAnimateType = variantDidChange || // If we're making this variant active, we want to always make it active
            type === changedActiveType && typeState.isActive && !isInherited && propIsVariant || // If we removed a higher-priority variant (i is in reverse order)
            i > removedVariantIndex && propIsVariant;
            let handledRemovedValues = false;
            /**
             * As animations can be set as variant lists, variants or target objects, we
             * coerce everything to an array if it isn't one already
             */ const definitionList = Array.isArray(prop) ? prop : [
                prop
            ];
            /**
             * Build an object of all the resolved values. We'll use this in the subsequent
             * animateChanges calls to determine whether a value has changed.
             */ let resolvedValues = definitionList.reduce(buildResolvedTypeValues(type), {});
            if (activeDelta === false) resolvedValues = {};
            /**
             * Now we need to loop through all the keys in the prev prop and this prop,
             * and decide:
             * 1. If the value has changed, and needs animating
             * 2. If it has been removed, and needs adding to the removedKeys set
             * 3. If it has been removed in a higher priority type and needs animating
             * 4. If it hasn't been removed in a higher priority but hasn't changed, and
             *    needs adding to the type's protectedKeys list.
             */ const { prevResolvedValues = {} } = typeState;
            const allKeys = {
                ...prevResolvedValues,
                ...resolvedValues
            };
            const markToAnimate = (key)=>{
                shouldAnimateType = true;
                if (removedKeys.has(key)) {
                    handledRemovedValues = true;
                    removedKeys.delete(key);
                }
                typeState.needsAnimating[key] = true;
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = false;
            };
            for(const key in allKeys){
                const next = resolvedValues[key];
                const prev = prevResolvedValues[key];
                // If we've already handled this we can just skip ahead
                if (encounteredKeys.hasOwnProperty(key)) continue;
                /**
                 * If the value has changed, we probably want to animate it.
                 */ let valueHasChanged = false;
                if ((0, _isKeyframesTargetMjs.isKeyframesTarget)(next) && (0, _isKeyframesTargetMjs.isKeyframesTarget)(prev)) valueHasChanged = !(0, _shallowCompareMjs.shallowCompare)(next, prev);
                else valueHasChanged = next !== prev;
                if (valueHasChanged) {
                    if (next !== undefined && next !== null) // If next is defined and doesn't equal prev, it needs animating
                    markToAnimate(key);
                    else // If it's undefined, it's been removed.
                    removedKeys.add(key);
                } else if (next !== undefined && removedKeys.has(key)) /**
                     * If next hasn't changed and it isn't undefined, we want to check if it's
                     * been removed by a higher priority
                     */ markToAnimate(key);
                else /**
                     * If it hasn't changed, we add it to the list of protected values
                     * to ensure it doesn't get animated.
                     */ typeState.protectedKeys[key] = true;
            }
            /**
             * Update the typeState so next time animateChanges is called we can compare the
             * latest prop and resolvedValues to these.
             */ typeState.prevProp = prop;
            typeState.prevResolvedValues = resolvedValues;
            if (typeState.isActive) encounteredKeys = {
                ...encounteredKeys,
                ...resolvedValues
            };
            if ((isInitialRender || wasReset) && visualElement.blockInitialAnimation) shouldAnimateType = false;
            /**
             * If this is an inherited prop we want to skip this animation
             * unless the inherited variants haven't changed on this render.
             */ const willAnimateViaParent = isInherited && variantDidChange;
            const needsAnimating = !willAnimateViaParent || handledRemovedValues;
            if (shouldAnimateType && needsAnimating) animations.push(...definitionList.map((animation)=>{
                const options = {
                    type
                };
                /**
                     * If we're performing the initial animation, but we're not
                     * rendering at the same time as the variant-controlling parent,
                     * we want to use the parent's transition to calculate the stagger.
                     */ if (typeof animation === "string" && (isInitialRender || wasReset) && !willAnimateViaParent && visualElement.manuallyAnimateOnMount && visualElement.parent) {
                    const { parent } = visualElement;
                    const parentVariant = (0, _resolveDynamicVariantsMjs.resolveVariant)(parent, animation);
                    if (parent.enteringChildren && parentVariant) {
                        const { delayChildren } = parentVariant.transition || {};
                        options.delay = (0, _calcChildStaggerMjs.calcChildStagger)(parent.enteringChildren, visualElement, delayChildren);
                    }
                }
                return {
                    animation: animation,
                    options
                };
            }));
        }
        /**
         * If there are some removed value that haven't been dealt with,
         * we need to create a new animation that falls back either to the value
         * defined in the style prop, or the last read value.
         */ if (removedKeys.size) {
            const fallbackAnimation = {};
            /**
             * If the initial prop contains a transition we can use that, otherwise
             * allow the animation function to use the visual element's default.
             */ if (typeof props.initial !== "boolean") {
                const initialTransition = (0, _resolveDynamicVariantsMjs.resolveVariant)(visualElement, Array.isArray(props.initial) ? props.initial[0] : props.initial);
                if (initialTransition && initialTransition.transition) fallbackAnimation.transition = initialTransition.transition;
            }
            removedKeys.forEach((key)=>{
                const fallbackTarget = visualElement.getBaseTarget(key);
                const motionValue = visualElement.getValue(key);
                if (motionValue) motionValue.liveStyle = true;
                // @ts-expect-error - @mattgperry to figure if we should do something here
                fallbackAnimation[key] = fallbackTarget ?? null;
            });
            animations.push({
                animation: fallbackAnimation
            });
        }
        let shouldAnimate = Boolean(animations.length);
        if (isInitialRender && (props.initial === false || props.initial === props.animate) && !visualElement.manuallyAnimateOnMount) shouldAnimate = false;
        isInitialRender = false;
        wasReset = false;
        return shouldAnimate ? animate(animations) : Promise.resolve();
    }
    /**
     * Change whether a certain animation type is active.
     */ function setActive(type, isActive) {
        // If the active state hasn't changed, we can safely do nothing here
        if (state[type].isActive === isActive) return Promise.resolve();
        // Propagate active change to children
        visualElement.variantChildren?.forEach((child)=>child.animationState?.setActive(type, isActive));
        state[type].isActive = isActive;
        const animations = animateChanges(type);
        for(const key in state)state[key].protectedKeys = {};
        return animations;
    }
    return {
        animateChanges,
        setActive,
        setAnimateFunction,
        getState: ()=>state,
        reset: ()=>{
            state = createState();
            wasReset = true;
        }
    };
}
function checkVariantsDidChange(prev, next) {
    if (typeof next === "string") return next !== prev;
    else if (Array.isArray(next)) return !(0, _shallowCompareMjs.shallowCompare)(next, prev);
    return false;
}
function createTypeState(isActive = false) {
    return {
        isActive,
        protectedKeys: {},
        needsAnimating: {},
        prevResolvedValues: {}
    };
}
function createState() {
    return {
        animate: createTypeState(true),
        whileInView: createTypeState(),
        whileHover: createTypeState(),
        whileTap: createTypeState(),
        whileDrag: createTypeState(),
        whileFocus: createTypeState(),
        exit: createTypeState()
    };
}

},{"../../animation/interfaces/visual-element.mjs":"a7b44","../../animation/utils/calc-child-stagger.mjs":"hitnd","./get-variant-context.mjs":"7T65F","./is-animation-controls.mjs":"eZBfs","./is-keyframes-target.mjs":"2DP7E","./is-variant-label.mjs":"9bqH5","./resolve-dynamic-variants.mjs":"7PfV6","./shallow-compare.mjs":"ut6XR","./variant-props.mjs":"8WhrK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7T65F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVariantContext", ()=>getVariantContext);
var _isVariantLabelMjs = require("./is-variant-label.mjs");
var _variantPropsMjs = require("./variant-props.mjs");
const numVariantProps = (0, _variantPropsMjs.variantProps).length;
/**
 * Get variant context from a visual element's parent chain.
 * Uses `any` type for visualElement to avoid circular dependencies.
 */ function getVariantContext(visualElement) {
    if (!visualElement) return undefined;
    if (!visualElement.isControllingVariants) {
        const context = visualElement.parent ? getVariantContext(visualElement.parent) || {} : {};
        if (visualElement.props.initial !== undefined) context.initial = visualElement.props.initial;
        return context;
    }
    const context = {};
    for(let i = 0; i < numVariantProps; i++){
        const name = (0, _variantPropsMjs.variantProps)[i];
        const prop = visualElement.props[name];
        if ((0, _isVariantLabelMjs.isVariantLabel)(prop) || prop === false) context[name] = prop;
    }
    return context;
}

},{"./is-variant-label.mjs":"9bqH5","./variant-props.mjs":"8WhrK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ut6XR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "shallowCompare", ()=>shallowCompare);
function shallowCompare(next, prev) {
    if (!Array.isArray(prev)) return false;
    const prevLength = prev.length;
    if (prevLength !== next.length) return false;
    for(let i = 0; i < prevLength; i++){
        if (prev[i] !== next[i]) return false;
    }
    return true;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fNsM5":[function(require,module,exports,__globalThis) {
/**
 * Reset an axis to the provided origin box.
 *
 * This is a mutative operation.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "copyAxisDeltaInto", ()=>copyAxisDeltaInto);
parcelHelpers.export(exports, "copyAxisInto", ()=>copyAxisInto);
parcelHelpers.export(exports, "copyBoxInto", ()=>copyBoxInto);
function copyAxisInto(axis, originAxis) {
    axis.min = originAxis.min;
    axis.max = originAxis.max;
}
/**
 * Reset a box to the provided origin box.
 *
 * This is a mutative operation.
 */ function copyBoxInto(box, originBox) {
    copyAxisInto(box.x, originBox.x);
    copyAxisInto(box.y, originBox.y);
}
/**
 * Reset a delta to the provided origin box.
 *
 * This is a mutative operation.
 */ function copyAxisDeltaInto(delta, originDelta) {
    delta.translate = originDelta.translate;
    delta.scale = originDelta.scale;
    delta.originPoint = originDelta.originPoint;
    delta.origin = originDelta.origin;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fywoX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calcAxisDelta", ()=>calcAxisDelta);
parcelHelpers.export(exports, "calcBoxDelta", ()=>calcBoxDelta);
parcelHelpers.export(exports, "calcLength", ()=>calcLength);
parcelHelpers.export(exports, "calcRelativeAxis", ()=>calcRelativeAxis);
parcelHelpers.export(exports, "calcRelativeAxisPosition", ()=>calcRelativeAxisPosition);
parcelHelpers.export(exports, "calcRelativeBox", ()=>calcRelativeBox);
parcelHelpers.export(exports, "calcRelativePosition", ()=>calcRelativePosition);
parcelHelpers.export(exports, "isNear", ()=>isNear);
var _numberMjs = require("../../utils/mix/number.mjs");
const SCALE_PRECISION = 0.0001;
const SCALE_MIN = 1 - SCALE_PRECISION;
const SCALE_MAX = 1 + SCALE_PRECISION;
const TRANSLATE_PRECISION = 0.01;
const TRANSLATE_MIN = 0 - TRANSLATE_PRECISION;
const TRANSLATE_MAX = 0 + TRANSLATE_PRECISION;
function calcLength(axis) {
    return axis.max - axis.min;
}
function isNear(value, target, maxDistance) {
    return Math.abs(value - target) <= maxDistance;
}
function calcAxisDelta(delta, source, target, origin = 0.5) {
    delta.origin = origin;
    delta.originPoint = (0, _numberMjs.mixNumber)(source.min, source.max, delta.origin);
    delta.scale = calcLength(target) / calcLength(source);
    delta.translate = (0, _numberMjs.mixNumber)(target.min, target.max, delta.origin) - delta.originPoint;
    if (delta.scale >= SCALE_MIN && delta.scale <= SCALE_MAX || isNaN(delta.scale)) delta.scale = 1.0;
    if (delta.translate >= TRANSLATE_MIN && delta.translate <= TRANSLATE_MAX || isNaN(delta.translate)) delta.translate = 0.0;
}
function calcBoxDelta(delta, source, target, origin) {
    calcAxisDelta(delta.x, source.x, target.x, origin ? origin.originX : undefined);
    calcAxisDelta(delta.y, source.y, target.y, origin ? origin.originY : undefined);
}
function calcRelativeAxis(target, relative, parent, anchor = 0) {
    const anchorPoint = anchor ? (0, _numberMjs.mixNumber)(parent.min, parent.max, anchor) : parent.min;
    target.min = anchorPoint + relative.min;
    target.max = target.min + calcLength(relative);
}
function calcRelativeBox(target, relative, parent, anchor) {
    calcRelativeAxis(target.x, relative.x, parent.x, anchor?.x);
    calcRelativeAxis(target.y, relative.y, parent.y, anchor?.y);
}
function calcRelativeAxisPosition(target, layout, parent, anchor = 0) {
    const anchorPoint = anchor ? (0, _numberMjs.mixNumber)(parent.min, parent.max, anchor) : parent.min;
    target.min = layout.min - anchorPoint;
    target.max = target.min + calcLength(layout);
}
function calcRelativePosition(target, layout, parent, anchor) {
    calcRelativeAxisPosition(target.x, layout.x, parent.x, anchor?.x);
    calcRelativeAxisPosition(target.y, layout.y, parent.y, anchor?.y);
}

},{"../../utils/mix/number.mjs":"91GSx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bpDGg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "removeAxisDelta", ()=>removeAxisDelta);
parcelHelpers.export(exports, "removeAxisTransforms", ()=>removeAxisTransforms);
parcelHelpers.export(exports, "removeBoxTransforms", ()=>removeBoxTransforms);
parcelHelpers.export(exports, "removePointDelta", ()=>removePointDelta);
var _numberMjs = require("../../utils/mix/number.mjs");
var _unitsMjs = require("../../value/types/numbers/units.mjs");
var _deltaApplyMjs = require("./delta-apply.mjs");
/**
 * Remove a delta from a point. This is essentially the steps of applyPointDelta in reverse
 */ function removePointDelta(point, translate, scale, originPoint, boxScale) {
    point -= translate;
    point = (0, _deltaApplyMjs.scalePoint)(point, 1 / scale, originPoint);
    if (boxScale !== undefined) point = (0, _deltaApplyMjs.scalePoint)(point, 1 / boxScale, originPoint);
    return point;
}
/**
 * Remove a delta from an axis. This is essentially the steps of applyAxisDelta in reverse
 */ function removeAxisDelta(axis, translate = 0, scale = 1, origin = 0.5, boxScale, originAxis = axis, sourceAxis = axis) {
    if ((0, _unitsMjs.percent).test(translate)) {
        translate = parseFloat(translate);
        const relativeProgress = (0, _numberMjs.mixNumber)(sourceAxis.min, sourceAxis.max, translate / 100);
        translate = relativeProgress - sourceAxis.min;
    }
    if (typeof translate !== "number") return;
    let originPoint = (0, _numberMjs.mixNumber)(originAxis.min, originAxis.max, origin);
    if (axis === originAxis) originPoint -= translate;
    axis.min = removePointDelta(axis.min, translate, scale, originPoint, boxScale);
    axis.max = removePointDelta(axis.max, translate, scale, originPoint, boxScale);
}
/**
 * Remove a transforms from an axis. This is essentially the steps of applyAxisTransforms in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function removeAxisTransforms(axis, transforms, [key, scaleKey, originKey], origin, sourceAxis) {
    removeAxisDelta(axis, transforms[key], transforms[scaleKey], transforms[originKey], transforms.scale, origin, sourceAxis);
}
/**
 * The names of the motion values we want to apply as translation, scale and origin.
 */ const xKeys = [
    "x",
    "scaleX",
    "originX"
];
const yKeys = [
    "y",
    "scaleY",
    "originY"
];
/**
 * Remove a transforms from an box. This is essentially the steps of applyAxisBox in reverse
 * and acts as a bridge between motion values and removeAxisDelta
 */ function removeBoxTransforms(box, transforms, originBox, sourceBox) {
    removeAxisTransforms(box.x, transforms, xKeys, originBox ? originBox.x : undefined, sourceBox ? sourceBox.x : undefined);
    removeAxisTransforms(box.y, transforms, yKeys, originBox ? originBox.y : undefined, sourceBox ? sourceBox.y : undefined);
}

},{"../../utils/mix/number.mjs":"91GSx","../../value/types/numbers/units.mjs":"aXLZR","./delta-apply.mjs":"iEf7c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"41DAH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "aspectRatio", ()=>aspectRatio);
parcelHelpers.export(exports, "axisDeltaEquals", ()=>axisDeltaEquals);
parcelHelpers.export(exports, "axisEquals", ()=>axisEquals);
parcelHelpers.export(exports, "axisEqualsRounded", ()=>axisEqualsRounded);
parcelHelpers.export(exports, "boxEquals", ()=>boxEquals);
parcelHelpers.export(exports, "boxEqualsRounded", ()=>boxEqualsRounded);
parcelHelpers.export(exports, "isDeltaZero", ()=>isDeltaZero);
var _deltaCalcMjs = require("./delta-calc.mjs");
function isAxisDeltaZero(delta) {
    return delta.translate === 0 && delta.scale === 1;
}
function isDeltaZero(delta) {
    return isAxisDeltaZero(delta.x) && isAxisDeltaZero(delta.y);
}
function axisEquals(a, b) {
    return a.min === b.min && a.max === b.max;
}
function boxEquals(a, b) {
    return axisEquals(a.x, b.x) && axisEquals(a.y, b.y);
}
function axisEqualsRounded(a, b) {
    return Math.round(a.min) === Math.round(b.min) && Math.round(a.max) === Math.round(b.max);
}
function boxEqualsRounded(a, b) {
    return axisEqualsRounded(a.x, b.x) && axisEqualsRounded(a.y, b.y);
}
function aspectRatio(box) {
    return (0, _deltaCalcMjs.calcLength)(box.x) / (0, _deltaCalcMjs.calcLength)(box.y);
}
function axisDeltaEquals(a, b) {
    return a.translate === b.translate && a.scale === b.scale && a.originPoint === b.originPoint;
}

},{"./delta-calc.mjs":"fywoX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6q1eY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eachAxis", ()=>eachAxis);
function eachAxis(callback) {
    return [
        callback("x"),
        callback("y")
    ];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1vFgW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildProjectionTransform", ()=>buildProjectionTransform);
function buildProjectionTransform(delta, treeScale, latestTransform) {
    let transform = "";
    /**
     * The translations we use to calculate are always relative to the viewport coordinate space.
     * But when we apply scales, we also scale the coordinate space of an element and its children.
     * For instance if we have a treeScale (the culmination of all parent scales) of 0.5 and we need
     * to move an element 100 pixels, we actually need to move it 200 in within that scaled space.
     */ const xTranslate = delta.x.translate / treeScale.x;
    const yTranslate = delta.y.translate / treeScale.y;
    const zTranslate = latestTransform?.z || 0;
    if (xTranslate || yTranslate || zTranslate) transform = `translate3d(${xTranslate}px, ${yTranslate}px, ${zTranslate}px) `;
    /**
     * Apply scale correction for the tree transform.
     * This will apply scale to the screen-orientated axes.
     */ if (treeScale.x !== 1 || treeScale.y !== 1) transform += `scale(${1 / treeScale.x}, ${1 / treeScale.y}) `;
    if (latestTransform) {
        const { transformPerspective, rotate, rotateX, rotateY, skewX, skewY } = latestTransform;
        if (transformPerspective) transform = `perspective(${transformPerspective}px) ${transform}`;
        if (rotate) transform += `rotate(${rotate}deg) `;
        if (rotateX) transform += `rotateX(${rotateX}deg) `;
        if (rotateY) transform += `rotateY(${rotateY}deg) `;
        if (skewX) transform += `skewX(${skewX}deg) `;
        if (skewY) transform += `skewY(${skewY}deg) `;
    }
    /**
     * Apply scale to match the size of the element to the size we want it.
     * This will apply scale to the element-orientated axes.
     */ const elementScaleX = delta.x.scale * treeScale.x;
    const elementScaleY = delta.y.scale * treeScale.y;
    if (elementScaleX !== 1 || elementScaleY !== 1) transform += `scale(${elementScaleX}, ${elementScaleY})`;
    return transform || "none";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fuYQ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mixValues", ()=>mixValues);
var _numberMjs = require("../../utils/mix/number.mjs");
var _unitsMjs = require("../../value/types/numbers/units.mjs");
var _motionUtils = require("motion-utils");
const borderLabels = [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
];
const numBorders = borderLabels.length;
const asNumber = (value)=>typeof value === "string" ? parseFloat(value) : value;
const isPx = (value)=>typeof value === "number" || (0, _unitsMjs.px).test(value);
function mixValues(target, follow, lead, progress, shouldCrossfadeOpacity, isOnlyMember) {
    if (shouldCrossfadeOpacity) {
        target.opacity = (0, _numberMjs.mixNumber)(0, lead.opacity ?? 1, easeCrossfadeIn(progress));
        target.opacityExit = (0, _numberMjs.mixNumber)(follow.opacity ?? 1, 0, easeCrossfadeOut(progress));
    } else if (isOnlyMember) target.opacity = (0, _numberMjs.mixNumber)(follow.opacity ?? 1, lead.opacity ?? 1, progress);
    /**
     * Mix border radius
     */ for(let i = 0; i < numBorders; i++){
        const borderLabel = borderLabels[i];
        let followRadius = getRadius(follow, borderLabel);
        let leadRadius = getRadius(lead, borderLabel);
        if (followRadius === undefined && leadRadius === undefined) continue;
        followRadius || (followRadius = 0);
        leadRadius || (leadRadius = 0);
        const canMix = followRadius === 0 || leadRadius === 0 || isPx(followRadius) === isPx(leadRadius);
        if (canMix) {
            target[borderLabel] = Math.max((0, _numberMjs.mixNumber)(asNumber(followRadius), asNumber(leadRadius), progress), 0);
            if ((0, _unitsMjs.percent).test(leadRadius) || (0, _unitsMjs.percent).test(followRadius)) target[borderLabel] += "%";
        } else target[borderLabel] = leadRadius;
    }
    /**
     * Mix rotation
     */ if (follow.rotate || lead.rotate) target.rotate = (0, _numberMjs.mixNumber)(follow.rotate || 0, lead.rotate || 0, progress);
}
function getRadius(values, radiusName) {
    return values[radiusName] !== undefined ? values[radiusName] : values.borderRadius;
}
const easeCrossfadeIn = /*@__PURE__*/ compress(0, 0.5, (0, _motionUtils.circOut));
const easeCrossfadeOut = /*@__PURE__*/ compress(0.5, 0.95, (0, _motionUtils.noop));
function compress(min, max, easing) {
    return (p)=>{
        // Could replace ifs with clamp
        if (p < min) return 0;
        if (p > max) return 1;
        return easing((0, _motionUtils.progress)(min, max, p));
    };
}

},{"../../utils/mix/number.mjs":"91GSx","../../value/types/numbers/units.mjs":"aXLZR","motion-utils":[["circOut","gCpPR"],["noop","1tDyg"],["progress","6Q1yP"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eUA8b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animateSingleValue", ()=>animateSingleValue);
var _motionValueMjs = require("../interfaces/motion-value.mjs");
var _indexMjs = require("../../value/index.mjs");
var _isMotionValueMjs = require("../../value/utils/is-motion-value.mjs");
function animateSingleValue(value, keyframes, options) {
    const motionValue$1 = (0, _isMotionValueMjs.isMotionValue)(value) ? value : (0, _indexMjs.motionValue)(value);
    motionValue$1.start((0, _motionValueMjs.animateMotionValue)("", motionValue$1, keyframes, options));
    return motionValue$1.animation;
}

},{"../interfaces/motion-value.mjs":"5NoWL","../../value/index.mjs":"hX31g","../../value/utils/is-motion-value.mjs":"fKDJz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e11Be":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addDomEvent", ()=>addDomEvent);
function addDomEvent(target, eventName, handler, options = {
    passive: true
}) {
    target.addEventListener(eventName, handler, options);
    return ()=>target.removeEventListener(eventName, handler);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"RKiwB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compareByDepth", ()=>compareByDepth);
const compareByDepth = (a, b)=>a.depth - b.depth;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1xjHX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FlatTree", ()=>FlatTree);
var _motionUtils = require("motion-utils");
var _compareByDepthMjs = require("./compare-by-depth.mjs");
class FlatTree {
    constructor(){
        this.children = [];
        this.isDirty = false;
    }
    add(child) {
        (0, _motionUtils.addUniqueItem)(this.children, child);
        this.isDirty = true;
    }
    remove(child) {
        (0, _motionUtils.removeItem)(this.children, child);
        this.isDirty = true;
    }
    forEach(callback) {
        this.isDirty && this.children.sort((0, _compareByDepthMjs.compareByDepth));
        this.isDirty = false;
        this.children.forEach(callback);
    }
}

},{"motion-utils":"841vh","./compare-by-depth.mjs":"RKiwB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Ua5cg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "delay", ()=>delay);
parcelHelpers.export(exports, "delayInSeconds", ()=>delayInSeconds);
var _syncTimeMjs = require("../frameloop/sync-time.mjs");
var _motionUtils = require("motion-utils");
var _frameMjs = require("../frameloop/frame.mjs");
/**
 * Timeout defined in ms
 */ function delay(callback, timeout) {
    const start = (0, _syncTimeMjs.time).now();
    const checkElapsed = ({ timestamp })=>{
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            (0, _frameMjs.cancelFrame)(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    (0, _frameMjs.frame).setup(checkElapsed, true);
    return ()=>(0, _frameMjs.cancelFrame)(checkElapsed);
}
function delayInSeconds(callback, timeout) {
    return delay(callback, (0, _motionUtils.secondsToMilliseconds)(timeout));
}

},{"../frameloop/sync-time.mjs":"74aV8","motion-utils":"dIdtR","../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"khfgR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cleanDirtyNodes", ()=>cleanDirtyNodes);
parcelHelpers.export(exports, "createProjectionNode", ()=>createProjectionNode);
parcelHelpers.export(exports, "mixAxis", ()=>mixAxis);
parcelHelpers.export(exports, "mixAxisDelta", ()=>mixAxisDelta);
parcelHelpers.export(exports, "mixBox", ()=>mixBox);
parcelHelpers.export(exports, "propagateDirtyNodes", ()=>propagateDirtyNodes);
var _motionUtils = require("motion-utils");
var _singleValueMjs = require("../../animation/animate/single-value.mjs");
var _getAppearIdMjs = require("../../animation/optimized-appear/get-appear-id.mjs");
var _getValueTransitionMjs = require("../../animation/utils/get-value-transition.mjs");
var _microtaskMjs = require("../../frameloop/microtask.mjs");
var _syncTimeMjs = require("../../frameloop/sync-time.mjs");
var _scaleCorrectionMjs = require("../styles/scale-correction.mjs");
var _animationCountMjs = require("../../stats/animation-count.mjs");
var _bufferMjs = require("../../stats/buffer.mjs");
var _delayMjs = require("../../utils/delay.mjs");
var _isSvgElementMjs = require("../../utils/is-svg-element.mjs");
var _isSvgSvgElementMjs = require("../../utils/is-svg-svg-element.mjs");
var _numberMjs = require("../../utils/mix/number.mjs");
var _indexMjs = require("../../value/index.mjs");
var _resolveMotionValueMjs = require("../../value/utils/resolve-motion-value.mjs");
var _mixValuesMjs = require("../animation/mix-values.mjs");
var _copyMjs = require("../geometry/copy.mjs");
var _deltaApplyMjs = require("../geometry/delta-apply.mjs");
var _deltaCalcMjs = require("../geometry/delta-calc.mjs");
var _deltaRemoveMjs = require("../geometry/delta-remove.mjs");
var _modelsMjs = require("../geometry/models.mjs");
var _utilsMjs = require("../geometry/utils.mjs");
var _stackMjs = require("../shared/stack.mjs");
var _transformMjs = require("../styles/transform.mjs");
var _eachAxisMjs = require("../utils/each-axis.mjs");
var _flatTreeMjs = require("../utils/flat-tree.mjs");
var _hasTransformMjs = require("../utils/has-transform.mjs");
var _stateMjs = require("./state.mjs");
var _frameMjs = require("../../frameloop/frame.mjs");
const metrics = {
    nodes: 0,
    calculatedTargetDeltas: 0,
    calculatedProjections: 0
};
const transformAxes = [
    "",
    "X",
    "Y",
    "Z"
];
/**
 * We use 1000 as the animation target as 0-1000 maps better to pixels than 0-1
 * which has a noticeable difference in spring animations
 */ const animationTarget = 1000;
let id = 0;
function resetDistortingTransform(key, visualElement, values, sharedAnimationValues) {
    const { latestValues } = visualElement;
    // Record the distorting transform and then temporarily set it to 0
    if (latestValues[key]) {
        values[key] = latestValues[key];
        visualElement.setStaticValue(key, 0);
        if (sharedAnimationValues) sharedAnimationValues[key] = 0;
    }
}
function cancelTreeOptimisedTransformAnimations(projectionNode) {
    projectionNode.hasCheckedOptimisedAppear = true;
    if (projectionNode.root === projectionNode) return;
    const { visualElement } = projectionNode.options;
    if (!visualElement) return;
    const appearId = (0, _getAppearIdMjs.getOptimisedAppearId)(visualElement);
    if (window.MotionHasOptimisedAnimation(appearId, "transform")) {
        const { layout, layoutId } = projectionNode.options;
        window.MotionCancelOptimisedAnimation(appearId, "transform", (0, _frameMjs.frame), !(layout || layoutId));
    }
    const { parent } = projectionNode;
    if (parent && !parent.hasCheckedOptimisedAppear) cancelTreeOptimisedTransformAnimations(parent);
}
function createProjectionNode({ attachResizeListener, defaultParent, measureScroll, checkIsScrollRoot, resetTransform }) {
    return class ProjectionNode {
        constructor(latestValues = {}, parent = defaultParent?.()){
            /**
             * A unique ID generated for every projection node.
             */ this.id = id++;
            /**
             * An id that represents a unique session instigated by startUpdate.
             */ this.animationId = 0;
            this.animationCommitId = 0;
            /**
             * A Set containing all this component's children. This is used to iterate
             * through the children.
             *
             * TODO: This could be faster to iterate as a flat array stored on the root node.
             */ this.children = new Set();
            /**
             * Options for the node. We use this to configure what kind of layout animations
             * we should perform (if any).
             */ this.options = {};
            /**
             * We use this to detect when its safe to shut down part of a projection tree.
             * We have to keep projecting children for scale correction and relative projection
             * until all their parents stop performing layout animations.
             */ this.isTreeAnimating = false;
            this.isAnimationBlocked = false;
            /**
             * Flag to true if we think this layout has been changed. We can't always know this,
             * currently we set it to true every time a component renders, or if it has a layoutDependency
             * if that has changed between renders. Additionally, components can be grouped by LayoutGroup
             * and if one node is dirtied, they all are.
             */ this.isLayoutDirty = false;
            /**
             * Flag to true if we think the projection calculations for this node needs
             * recalculating as a result of an updated transform or layout animation.
             */ this.isProjectionDirty = false;
            /**
             * Flag to true if the layout *or* transform has changed. This then gets propagated
             * throughout the projection tree, forcing any element below to recalculate on the next frame.
             */ this.isSharedProjectionDirty = false;
            /**
             * Flag transform dirty. This gets propagated throughout the whole tree but is only
             * respected by shared nodes.
             */ this.isTransformDirty = false;
            /**
             * Block layout updates for instant layout transitions throughout the tree.
             */ this.updateManuallyBlocked = false;
            this.updateBlockedByResize = false;
            /**
             * Set to true between the start of the first `willUpdate` call and the end of the `didUpdate`
             * call.
             */ this.isUpdating = false;
            /**
             * If this is an SVG element we currently disable projection transforms
             */ this.isSVG = false;
            /**
             * Flag to true (during promotion) if a node doing an instant layout transition needs to reset
             * its projection styles.
             */ this.needsReset = false;
            /**
             * Flags whether this node should have its transform reset prior to measuring.
             */ this.shouldResetTransform = false;
            /**
             * Store whether this node has been checked for optimised appear animations. As
             * effects fire bottom-up, and we want to look up the tree for appear animations,
             * this makes sure we only check each path once, stopping at nodes that
             * have already been checked.
             */ this.hasCheckedOptimisedAppear = false;
            /**
             * An object representing the calculated contextual/accumulated/tree scale.
             * This will be used to scale calculcated projection transforms, as these are
             * calculated in screen-space but need to be scaled for elements to layoutly
             * make it to their calculated destinations.
             *
             * TODO: Lazy-init
             */ this.treeScale = {
                x: 1,
                y: 1
            };
            /**
             *
             */ this.eventHandlers = new Map();
            this.hasTreeAnimated = false;
            this.layoutVersion = 0;
            // Note: Currently only running on root node
            this.updateScheduled = false;
            this.scheduleUpdate = ()=>this.update();
            this.projectionUpdateScheduled = false;
            this.checkUpdateFailed = ()=>{
                if (this.isUpdating) {
                    this.isUpdating = false;
                    this.clearAllSnapshots();
                }
            };
            /**
             * This is a multi-step process as shared nodes might be of different depths. Nodes
             * are sorted by depth order, so we need to resolve the entire tree before moving to
             * the next step.
             */ this.updateProjection = ()=>{
                this.projectionUpdateScheduled = false;
                /**
                 * Reset debug counts. Manually resetting rather than creating a new
                 * object each frame.
                 */ if ((0, _bufferMjs.statsBuffer).value) metrics.nodes = metrics.calculatedTargetDeltas = metrics.calculatedProjections = 0;
                this.nodes.forEach(propagateDirtyNodes);
                this.nodes.forEach(resolveTargetDelta);
                this.nodes.forEach(calcProjection);
                this.nodes.forEach(cleanDirtyNodes);
                if ((0, _bufferMjs.statsBuffer).addProjectionMetrics) (0, _bufferMjs.statsBuffer).addProjectionMetrics(metrics);
            };
            /**
             * Frame calculations
             */ this.resolvedRelativeTargetAt = 0.0;
            this.linkedParentVersion = 0;
            this.hasProjected = false;
            this.isVisible = true;
            this.animationProgress = 0;
            /**
             * Shared layout
             */ // TODO Only running on root node
            this.sharedNodes = new Map();
            this.latestValues = latestValues;
            this.root = parent ? parent.root || parent : this;
            this.path = parent ? [
                ...parent.path,
                parent
            ] : [];
            this.parent = parent;
            this.depth = parent ? parent.depth + 1 : 0;
            for(let i = 0; i < this.path.length; i++)this.path[i].shouldResetTransform = true;
            if (this.root === this) this.nodes = new (0, _flatTreeMjs.FlatTree)();
        }
        addEventListener(name, handler) {
            if (!this.eventHandlers.has(name)) this.eventHandlers.set(name, new (0, _motionUtils.SubscriptionManager)());
            return this.eventHandlers.get(name).add(handler);
        }
        notifyListeners(name, ...args) {
            const subscriptionManager = this.eventHandlers.get(name);
            subscriptionManager && subscriptionManager.notify(...args);
        }
        hasListeners(name) {
            return this.eventHandlers.has(name);
        }
        /**
         * Lifecycles
         */ mount(instance) {
            if (this.instance) return;
            this.isSVG = (0, _isSvgElementMjs.isSVGElement)(instance) && !(0, _isSvgSvgElementMjs.isSVGSVGElement)(instance);
            this.instance = instance;
            const { layoutId, layout, visualElement } = this.options;
            if (visualElement && !visualElement.current) visualElement.mount(instance);
            this.root.nodes.add(this);
            this.parent && this.parent.children.add(this);
            if (this.root.hasTreeAnimated && (layout || layoutId)) this.isLayoutDirty = true;
            if (attachResizeListener) {
                let cancelDelay;
                let innerWidth = 0;
                const resizeUnblockUpdate = ()=>this.root.updateBlockedByResize = false;
                // Set initial innerWidth in a frame.read callback to batch the read
                (0, _frameMjs.frame).read(()=>{
                    innerWidth = window.innerWidth;
                });
                attachResizeListener(instance, ()=>{
                    const newInnerWidth = window.innerWidth;
                    if (newInnerWidth === innerWidth) return;
                    innerWidth = newInnerWidth;
                    this.root.updateBlockedByResize = true;
                    cancelDelay && cancelDelay();
                    cancelDelay = (0, _delayMjs.delay)(resizeUnblockUpdate, 250);
                    if ((0, _stateMjs.globalProjectionState).hasAnimatedSinceResize) {
                        (0, _stateMjs.globalProjectionState).hasAnimatedSinceResize = false;
                        this.nodes.forEach(finishAnimation);
                    }
                });
            }
            if (layoutId) this.root.registerSharedNode(layoutId, this);
            // Only register the handler if it requires layout animation
            if (this.options.animate !== false && visualElement && (layoutId || layout)) this.addEventListener("didUpdate", ({ delta, hasLayoutChanged, hasRelativeLayoutChanged, layout: newLayout })=>{
                if (this.isTreeAnimationBlocked()) {
                    this.target = undefined;
                    this.relativeTarget = undefined;
                    return;
                }
                // TODO: Check here if an animation exists
                const layoutTransition = this.options.transition || visualElement.getDefaultTransition() || defaultLayoutTransition;
                const { onLayoutAnimationStart, onLayoutAnimationComplete } = visualElement.getProps();
                /**
                     * The target layout of the element might stay the same,
                     * but its position relative to its parent has changed.
                     */ const hasTargetChanged = !this.targetLayout || !(0, _utilsMjs.boxEqualsRounded)(this.targetLayout, newLayout);
                /*
                     * Note: Disabled to fix relative animations always triggering new
                     * layout animations. If this causes further issues, we can try
                     * a different approach to detecting relative target changes.
                     */ // || hasRelativeLayoutChanged
                /**
                     * If the layout hasn't seemed to have changed, it might be that the
                     * element is visually in the same place in the document but its position
                     * relative to its parent has indeed changed. So here we check for that.
                     */ const hasOnlyRelativeTargetChanged = !hasLayoutChanged && hasRelativeLayoutChanged;
                if (this.options.layoutRoot || this.resumeFrom || hasOnlyRelativeTargetChanged || hasLayoutChanged && (hasTargetChanged || !this.currentAnimation)) {
                    if (this.resumeFrom) {
                        this.resumingFrom = this.resumeFrom;
                        this.resumingFrom.resumingFrom = undefined;
                    }
                    const animationOptions = {
                        ...(0, _getValueTransitionMjs.getValueTransition)(layoutTransition, "layout"),
                        onPlay: onLayoutAnimationStart,
                        onComplete: onLayoutAnimationComplete
                    };
                    if (visualElement.shouldReduceMotion || this.options.layoutRoot) {
                        animationOptions.delay = 0;
                        animationOptions.type = false;
                    }
                    this.startAnimation(animationOptions);
                    /**
                         * Set animation origin after starting animation to avoid layout jump
                         * caused by stopping previous layout animation
                         */ this.setAnimationOrigin(delta, hasOnlyRelativeTargetChanged);
                } else {
                    /**
                         * If the layout hasn't changed and we have an animation that hasn't started yet,
                         * finish it immediately. Otherwise it will be animating from a location
                         * that was probably never committed to screen and look like a jumpy box.
                         */ if (!hasLayoutChanged) finishAnimation(this);
                    if (this.isLead() && this.options.onExitComplete) this.options.onExitComplete();
                }
                this.targetLayout = newLayout;
            });
        }
        unmount() {
            this.options.layoutId && this.willUpdate();
            this.root.nodes.remove(this);
            const stack = this.getStack();
            stack && stack.remove(this);
            this.parent && this.parent.children.delete(this);
            this.instance = undefined;
            this.eventHandlers.clear();
            (0, _frameMjs.cancelFrame)(this.updateProjection);
        }
        // only on the root
        blockUpdate() {
            this.updateManuallyBlocked = true;
        }
        unblockUpdate() {
            this.updateManuallyBlocked = false;
        }
        isUpdateBlocked() {
            return this.updateManuallyBlocked || this.updateBlockedByResize;
        }
        isTreeAnimationBlocked() {
            return this.isAnimationBlocked || this.parent && this.parent.isTreeAnimationBlocked() || false;
        }
        // Note: currently only running on root node
        startUpdate() {
            if (this.isUpdateBlocked()) return;
            this.isUpdating = true;
            this.nodes && this.nodes.forEach(resetSkewAndRotation);
            this.animationId++;
        }
        getTransformTemplate() {
            const { visualElement } = this.options;
            return visualElement && visualElement.getProps().transformTemplate;
        }
        willUpdate(shouldNotifyListeners = true) {
            this.root.hasTreeAnimated = true;
            if (this.root.isUpdateBlocked()) {
                this.options.onExitComplete && this.options.onExitComplete();
                return;
            }
            /**
             * If we're running optimised appear animations then these must be
             * cancelled before measuring the DOM. This is so we can measure
             * the true layout of the element rather than the WAAPI animation
             * which will be unaffected by the resetSkewAndRotate step.
             *
             * Note: This is a DOM write. Worst case scenario is this is sandwiched
             * between other snapshot reads which will cause unnecessary style recalculations.
             * This has to happen here though, as we don't yet know which nodes will need
             * snapshots in startUpdate(), but we only want to cancel optimised animations
             * if a layout animation measurement is actually going to be affected by them.
             */ if (window.MotionCancelOptimisedAnimation && !this.hasCheckedOptimisedAppear) cancelTreeOptimisedTransformAnimations(this);
            !this.root.isUpdating && this.root.startUpdate();
            if (this.isLayoutDirty) return;
            this.isLayoutDirty = true;
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.shouldResetTransform = true;
                /**
                 * Percentage translates resolve against layoutBox dimensions,
                 * so ancestors with them must be re-measured after transform reset.
                 */ if (typeof node.latestValues.x === "string" || typeof node.latestValues.y === "string") node.isLayoutDirty = true;
                node.updateScroll("snapshot");
                if (node.options.layoutRoot) node.willUpdate(false);
            }
            const { layoutId, layout } = this.options;
            if (layoutId === undefined && !layout) return;
            const transformTemplate = this.getTransformTemplate();
            this.prevTransformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            this.updateSnapshot();
            shouldNotifyListeners && this.notifyListeners("willUpdate");
        }
        update() {
            this.updateScheduled = false;
            const updateWasBlocked = this.isUpdateBlocked();
            // When doing an instant transition, we skip the layout update,
            // but should still clean up the measurements so that the next
            // snapshot could be taken correctly.
            if (updateWasBlocked) {
                const wasBlockedByResize = this.updateBlockedByResize;
                this.unblockUpdate();
                this.updateBlockedByResize = false;
                this.clearAllSnapshots();
                /**
                 * When blocked by resize, still measure layouts so
                 * callbacks like onLayoutMeasure fire (e.g. Reorder).
                 * Skip notifyLayoutUpdate to prevent animations.
                 */ if (wasBlockedByResize) this.nodes.forEach(forceLayoutMeasure);
                this.nodes.forEach(clearMeasurements);
                return;
            }
            /**
             * If this is a repeat of didUpdate then ignore the animation.
             */ if (this.animationId <= this.animationCommitId) {
                this.nodes.forEach(clearIsLayoutDirty);
                return;
            }
            this.animationCommitId = this.animationId;
            if (!this.isUpdating) this.nodes.forEach(clearIsLayoutDirty);
            else {
                this.isUpdating = false;
                /**
                 * Ensure animation-blocked nodes (e.g. during drag)
                 * get measured even when memoized (willUpdate skipped).
                 */ this.nodes.forEach(ensureDraggedNodesSnapshotted);
                /**
                 * Write
                 */ this.nodes.forEach(resetTransformStyle);
                /**
                 * Read ==================
                 */ // Update layout measurements of updated children
                this.nodes.forEach(updateLayout);
                /**
                 * Write
                 */ // Notify listeners that the layout is updated
                this.nodes.forEach(notifyLayoutUpdate);
            }
            this.clearAllSnapshots();
            /**
             * Manually flush any pending updates. Ideally
             * we could leave this to the following requestAnimationFrame but this seems
             * to leave a flash of incorrectly styled content.
             */ const now = (0, _syncTimeMjs.time).now();
            (0, _frameMjs.frameData).delta = (0, _motionUtils.clamp)(0, 1000 / 60, now - (0, _frameMjs.frameData).timestamp);
            (0, _frameMjs.frameData).timestamp = now;
            (0, _frameMjs.frameData).isProcessing = true;
            (0, _frameMjs.frameSteps).update.process((0, _frameMjs.frameData));
            (0, _frameMjs.frameSteps).preRender.process((0, _frameMjs.frameData));
            (0, _frameMjs.frameSteps).render.process((0, _frameMjs.frameData));
            (0, _frameMjs.frameData).isProcessing = false;
        }
        didUpdate() {
            if (!this.updateScheduled) {
                this.updateScheduled = true;
                (0, _microtaskMjs.microtask).read(this.scheduleUpdate);
            }
        }
        clearAllSnapshots() {
            this.nodes.forEach(clearSnapshot);
            this.sharedNodes.forEach(removeLeadSnapshots);
        }
        scheduleUpdateProjection() {
            if (!this.projectionUpdateScheduled) {
                this.projectionUpdateScheduled = true;
                (0, _frameMjs.frame).preRender(this.updateProjection, false, true);
            }
        }
        scheduleCheckAfterUnmount() {
            /**
             * If the unmounting node is in a layoutGroup and did trigger a willUpdate,
             * we manually call didUpdate to give a chance to the siblings to animate.
             * Otherwise, cleanup all snapshots to prevents future nodes from reusing them.
             */ (0, _frameMjs.frame).postRender(()=>{
                if (this.isLayoutDirty) this.root.didUpdate();
                else this.root.checkUpdateFailed();
            });
        }
        /**
         * Update measurements
         */ updateSnapshot() {
            if (this.snapshot || !this.instance) return;
            this.snapshot = this.measure();
            if (this.snapshot && !(0, _deltaCalcMjs.calcLength)(this.snapshot.measuredBox.x) && !(0, _deltaCalcMjs.calcLength)(this.snapshot.measuredBox.y)) this.snapshot = undefined;
        }
        updateLayout() {
            if (!this.instance) return;
            this.updateScroll();
            if (!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty) return;
            /**
             * When a node is mounted, it simply resumes from the prevLead's
             * snapshot instead of taking a new one, but the ancestors scroll
             * might have updated while the prevLead is unmounted. We need to
             * update the scroll again to make sure the layout we measure is
             * up to date.
             */ if (this.resumeFrom && !this.resumeFrom.instance) for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                node.updateScroll();
            }
            const prevLayout = this.layout;
            this.layout = this.measure(false);
            this.layoutVersion++;
            if (!this.layoutCorrected) this.layoutCorrected = (0, _modelsMjs.createBox)();
            this.isLayoutDirty = false;
            this.projectionDelta = undefined;
            this.notifyListeners("measure", this.layout.layoutBox);
            const { visualElement } = this.options;
            visualElement && visualElement.notify("LayoutMeasure", this.layout.layoutBox, prevLayout ? prevLayout.layoutBox : undefined);
        }
        updateScroll(phase = "measure") {
            let needsMeasurement = Boolean(this.options.layoutScroll && this.instance);
            if (this.scroll && this.scroll.animationId === this.root.animationId && this.scroll.phase === phase) needsMeasurement = false;
            if (needsMeasurement && this.instance) {
                const isRoot = checkIsScrollRoot(this.instance);
                this.scroll = {
                    animationId: this.root.animationId,
                    phase,
                    isRoot,
                    offset: measureScroll(this.instance),
                    wasRoot: this.scroll ? this.scroll.isRoot : isRoot
                };
            }
        }
        resetTransform() {
            if (!resetTransform) return;
            const isResetRequested = this.isLayoutDirty || this.shouldResetTransform || this.options.alwaysMeasureLayout;
            const hasProjection = this.projectionDelta && !(0, _utilsMjs.isDeltaZero)(this.projectionDelta);
            const transformTemplate = this.getTransformTemplate();
            const transformTemplateValue = transformTemplate ? transformTemplate(this.latestValues, "") : undefined;
            const transformTemplateHasChanged = transformTemplateValue !== this.prevTransformTemplateValue;
            if (isResetRequested && this.instance && (hasProjection || (0, _hasTransformMjs.hasTransform)(this.latestValues) || transformTemplateHasChanged)) {
                resetTransform(this.instance, transformTemplateValue);
                this.shouldResetTransform = false;
                this.scheduleRender();
            }
        }
        measure(removeTransform = true) {
            const pageBox = this.measurePageBox();
            let layoutBox = this.removeElementScroll(pageBox);
            /**
             * Measurements taken during the pre-render stage
             * still have transforms applied so we remove them
             * via calculation.
             */ if (removeTransform) layoutBox = this.removeTransform(layoutBox);
            roundBox(layoutBox);
            return {
                animationId: this.root.animationId,
                measuredBox: pageBox,
                layoutBox,
                latestValues: {},
                source: this.id
            };
        }
        measurePageBox() {
            const { visualElement } = this.options;
            if (!visualElement) return (0, _modelsMjs.createBox)();
            const box = visualElement.measureViewportBox();
            const wasInScrollRoot = this.scroll?.wasRoot || this.path.some(checkNodeWasScrollRoot);
            if (!wasInScrollRoot) {
                // Remove viewport scroll to give page-relative coordinates
                const { scroll } = this.root;
                if (scroll) {
                    (0, _deltaApplyMjs.translateAxis)(box.x, scroll.offset.x);
                    (0, _deltaApplyMjs.translateAxis)(box.y, scroll.offset.y);
                }
            }
            return box;
        }
        removeElementScroll(box) {
            const boxWithoutScroll = (0, _modelsMjs.createBox)();
            (0, _copyMjs.copyBoxInto)(boxWithoutScroll, box);
            if (this.scroll?.wasRoot) return boxWithoutScroll;
            /**
             * Performance TODO: Keep a cumulative scroll offset down the tree
             * rather than loop back up the path.
             */ for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                const { scroll, options } = node;
                if (node !== this.root && scroll && options.layoutScroll) {
                    /**
                     * If this is a new scroll root, we want to remove all previous scrolls
                     * from the viewport box.
                     */ if (scroll.wasRoot) (0, _copyMjs.copyBoxInto)(boxWithoutScroll, box);
                    (0, _deltaApplyMjs.translateAxis)(boxWithoutScroll.x, scroll.offset.x);
                    (0, _deltaApplyMjs.translateAxis)(boxWithoutScroll.y, scroll.offset.y);
                }
            }
            return boxWithoutScroll;
        }
        applyTransform(box, transformOnly = false, output) {
            const withTransforms = output || (0, _modelsMjs.createBox)();
            (0, _copyMjs.copyBoxInto)(withTransforms, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!transformOnly && node.options.layoutScroll && node.scroll && node !== node.root) {
                    (0, _deltaApplyMjs.translateAxis)(withTransforms.x, -node.scroll.offset.x);
                    (0, _deltaApplyMjs.translateAxis)(withTransforms.y, -node.scroll.offset.y);
                }
                if (!(0, _hasTransformMjs.hasTransform)(node.latestValues)) continue;
                (0, _deltaApplyMjs.transformBox)(withTransforms, node.latestValues, node.layout?.layoutBox);
            }
            if ((0, _hasTransformMjs.hasTransform)(this.latestValues)) (0, _deltaApplyMjs.transformBox)(withTransforms, this.latestValues, this.layout?.layoutBox);
            return withTransforms;
        }
        removeTransform(box) {
            const boxWithoutTransform = (0, _modelsMjs.createBox)();
            (0, _copyMjs.copyBoxInto)(boxWithoutTransform, box);
            for(let i = 0; i < this.path.length; i++){
                const node = this.path[i];
                if (!(0, _hasTransformMjs.hasTransform)(node.latestValues)) continue;
                let sourceBox;
                if (node.instance) {
                    (0, _hasTransformMjs.hasScale)(node.latestValues) && node.updateSnapshot();
                    sourceBox = (0, _modelsMjs.createBox)();
                    (0, _copyMjs.copyBoxInto)(sourceBox, node.measurePageBox());
                }
                (0, _deltaRemoveMjs.removeBoxTransforms)(boxWithoutTransform, node.latestValues, node.snapshot?.layoutBox, sourceBox);
            }
            if ((0, _hasTransformMjs.hasTransform)(this.latestValues)) (0, _deltaRemoveMjs.removeBoxTransforms)(boxWithoutTransform, this.latestValues);
            return boxWithoutTransform;
        }
        setTargetDelta(delta) {
            this.targetDelta = delta;
            this.root.scheduleUpdateProjection();
            this.isProjectionDirty = true;
        }
        setOptions(options) {
            this.options = {
                ...this.options,
                ...options,
                crossfade: options.crossfade !== undefined ? options.crossfade : true
            };
        }
        clearMeasurements() {
            this.scroll = undefined;
            this.layout = undefined;
            this.snapshot = undefined;
            this.prevTransformTemplateValue = undefined;
            this.targetDelta = undefined;
            this.target = undefined;
            this.isLayoutDirty = false;
        }
        forceRelativeParentToResolveTarget() {
            if (!this.relativeParent) return;
            /**
             * If the parent target isn't up-to-date, force it to update.
             * This is an unfortunate de-optimisation as it means any updating relative
             * projection will cause all the relative parents to recalculate back
             * up the tree.
             */ if (this.relativeParent.resolvedRelativeTargetAt !== (0, _frameMjs.frameData).timestamp) this.relativeParent.resolveTargetDelta(true);
        }
        resolveTargetDelta(forceRecalculation = false) {
            /**
             * Once the dirty status of nodes has been spread through the tree, we also
             * need to check if we have a shared node of a different depth that has itself
             * been dirtied.
             */ const lead = this.getLead();
            this.isProjectionDirty || (this.isProjectionDirty = lead.isProjectionDirty);
            this.isTransformDirty || (this.isTransformDirty = lead.isTransformDirty);
            this.isSharedProjectionDirty || (this.isSharedProjectionDirty = lead.isSharedProjectionDirty);
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            /**
             * We don't use transform for this step of processing so we don't
             * need to check whether any nodes have changed transform.
             */ const canSkip = !(forceRecalculation || isShared && this.isSharedProjectionDirty || this.isProjectionDirty || this.parent?.isProjectionDirty || this.attemptToResolveRelativeTarget || this.root.updateBlockedByResize);
            if (canSkip) return;
            const { layout, layoutId } = this.options;
            /**
             * If we have no layout, we can't perform projection, so early return
             */ if (!this.layout || !(layout || layoutId)) return;
            this.resolvedRelativeTargetAt = (0, _frameMjs.frameData).timestamp;
            const relativeParent = this.getClosestProjectingParent();
            if (relativeParent && this.linkedParentVersion !== relativeParent.layoutVersion && !relativeParent.options.layoutRoot) this.removeRelativeTarget();
            /**
             * If we don't have a targetDelta but do have a layout, we can attempt to resolve
             * a relativeParent. This will allow a component to perform scale correction
             * even if no animation has started.
             */ if (!this.targetDelta && !this.relativeTarget) {
                if (this.options.layoutAnchor !== false && relativeParent && relativeParent.layout) this.createRelativeTarget(relativeParent, this.layout.layoutBox, relativeParent.layout.layoutBox);
                else this.removeRelativeTarget();
            }
            /**
             * If we have no relative target or no target delta our target isn't valid
             * for this frame.
             */ if (!this.relativeTarget && !this.targetDelta) return;
            /**
             * Lazy-init target data structure
             */ if (!this.target) {
                this.target = (0, _modelsMjs.createBox)();
                this.targetWithTransforms = (0, _modelsMjs.createBox)();
            }
            /**
             * If we've got a relative box for this component, resolve it into a target relative to the parent.
             */ if (this.relativeTarget && this.relativeTargetOrigin && this.relativeParent && this.relativeParent.target) {
                this.forceRelativeParentToResolveTarget();
                (0, _deltaCalcMjs.calcRelativeBox)(this.target, this.relativeTarget, this.relativeParent.target, this.options.layoutAnchor || undefined);
            /**
                 * If we've only got a targetDelta, resolve it into a target
                 */ } else if (this.targetDelta) {
                if (Boolean(this.resumingFrom)) this.applyTransform(this.layout.layoutBox, false, this.target);
                else (0, _copyMjs.copyBoxInto)(this.target, this.layout.layoutBox);
                (0, _deltaApplyMjs.applyBoxDelta)(this.target, this.targetDelta);
            } else /**
                 * If no target, use own layout as target
                 */ (0, _copyMjs.copyBoxInto)(this.target, this.layout.layoutBox);
            /**
             * If we've been told to attempt to resolve a relative target, do so.
             */ if (this.attemptToResolveRelativeTarget) {
                this.attemptToResolveRelativeTarget = false;
                if (this.options.layoutAnchor !== false && relativeParent && Boolean(relativeParent.resumingFrom) === Boolean(this.resumingFrom) && !relativeParent.options.layoutScroll && relativeParent.target && this.animationProgress !== 1) this.createRelativeTarget(relativeParent, this.target, relativeParent.target);
                else this.relativeParent = this.relativeTarget = undefined;
            }
            /**
             * Increase debug counter for resolved target deltas
             */ if ((0, _bufferMjs.statsBuffer).value) metrics.calculatedTargetDeltas++;
        }
        getClosestProjectingParent() {
            if (!this.parent || (0, _hasTransformMjs.hasScale)(this.parent.latestValues) || (0, _hasTransformMjs.has2DTranslate)(this.parent.latestValues)) return undefined;
            if (this.parent.isProjecting()) return this.parent;
            else return this.parent.getClosestProjectingParent();
        }
        isProjecting() {
            return Boolean((this.relativeTarget || this.targetDelta || this.options.layoutRoot) && this.layout);
        }
        createRelativeTarget(relativeParent, layout, parentLayout) {
            this.relativeParent = relativeParent;
            this.linkedParentVersion = relativeParent.layoutVersion;
            this.forceRelativeParentToResolveTarget();
            this.relativeTarget = (0, _modelsMjs.createBox)();
            this.relativeTargetOrigin = (0, _modelsMjs.createBox)();
            (0, _deltaCalcMjs.calcRelativePosition)(this.relativeTargetOrigin, layout, parentLayout, this.options.layoutAnchor || undefined);
            (0, _copyMjs.copyBoxInto)(this.relativeTarget, this.relativeTargetOrigin);
        }
        removeRelativeTarget() {
            this.relativeParent = this.relativeTarget = undefined;
        }
        calcProjection() {
            const lead = this.getLead();
            const isShared = Boolean(this.resumingFrom) || this !== lead;
            let canSkip = true;
            /**
             * If this is a normal layout animation and neither this node nor its nearest projecting
             * is dirty then we can't skip.
             */ if (this.isProjectionDirty || this.parent?.isProjectionDirty) canSkip = false;
            /**
             * If this is a shared layout animation and this node's shared projection is dirty then
             * we can't skip.
             */ if (isShared && (this.isSharedProjectionDirty || this.isTransformDirty)) canSkip = false;
            /**
             * If we have resolved the target this frame we must recalculate the
             * projection to ensure it visually represents the internal calculations.
             */ if (this.resolvedRelativeTargetAt === (0, _frameMjs.frameData).timestamp) canSkip = false;
            if (canSkip) return;
            const { layout, layoutId } = this.options;
            /**
             * If this section of the tree isn't animating we can
             * delete our target sources for the following frame.
             */ this.isTreeAnimating = Boolean(this.parent && this.parent.isTreeAnimating || this.currentAnimation || this.pendingAnimation);
            if (!this.isTreeAnimating) this.targetDelta = this.relativeTarget = undefined;
            if (!this.layout || !(layout || layoutId)) return;
            /**
             * Reset the corrected box with the latest values from box, as we're then going
             * to perform mutative operations on it.
             */ (0, _copyMjs.copyBoxInto)(this.layoutCorrected, this.layout.layoutBox);
            /**
             * Record previous tree scales before updating.
             */ const prevTreeScaleX = this.treeScale.x;
            const prevTreeScaleY = this.treeScale.y;
            /**
             * Apply all the parent deltas to this box to produce the corrected box. This
             * is the layout box, as it will appear on screen as a result of the transforms of its parents.
             */ (0, _deltaApplyMjs.applyTreeDeltas)(this.layoutCorrected, this.treeScale, this.path, isShared);
            /**
             * If this layer needs to perform scale correction but doesn't have a target,
             * use the layout as the target.
             */ if (lead.layout && !lead.target && (this.treeScale.x !== 1 || this.treeScale.y !== 1)) {
                lead.target = lead.layout.layoutBox;
                lead.targetWithTransforms = (0, _modelsMjs.createBox)();
            }
            const { target } = lead;
            if (!target) {
                /**
                 * If we don't have a target to project into, but we were previously
                 * projecting, we want to remove the stored transform and schedule
                 * a render to ensure the elements reflect the removed transform.
                 */ if (this.prevProjectionDelta) {
                    this.createProjectionDeltas();
                    this.scheduleRender();
                }
                return;
            }
            if (!this.projectionDelta || !this.prevProjectionDelta) this.createProjectionDeltas();
            else {
                (0, _copyMjs.copyAxisDeltaInto)(this.prevProjectionDelta.x, this.projectionDelta.x);
                (0, _copyMjs.copyAxisDeltaInto)(this.prevProjectionDelta.y, this.projectionDelta.y);
            }
            /**
             * Update the delta between the corrected box and the target box before user-set transforms were applied.
             * This will allow us to calculate the corrected borderRadius and boxShadow to compensate
             * for our layout reprojection, but still allow them to be scaled correctly by the user.
             * It might be that to simplify this we may want to accept that user-set scale is also corrected
             * and we wouldn't have to keep and calc both deltas, OR we could support a user setting
             * to allow people to choose whether these styles are corrected based on just the
             * layout reprojection or the final bounding box.
             */ (0, _deltaCalcMjs.calcBoxDelta)(this.projectionDelta, this.layoutCorrected, target, this.latestValues);
            if (this.treeScale.x !== prevTreeScaleX || this.treeScale.y !== prevTreeScaleY || !(0, _utilsMjs.axisDeltaEquals)(this.projectionDelta.x, this.prevProjectionDelta.x) || !(0, _utilsMjs.axisDeltaEquals)(this.projectionDelta.y, this.prevProjectionDelta.y)) {
                this.hasProjected = true;
                this.scheduleRender();
                this.notifyListeners("projectionUpdate", target);
            }
            /**
             * Increase debug counter for recalculated projections
             */ if ((0, _bufferMjs.statsBuffer).value) metrics.calculatedProjections++;
        }
        hide() {
            this.isVisible = false;
        // TODO: Schedule render
        }
        show() {
            this.isVisible = true;
        // TODO: Schedule render
        }
        scheduleRender(notifyAll = true) {
            this.options.visualElement?.scheduleRender();
            if (notifyAll) {
                const stack = this.getStack();
                stack && stack.scheduleRender();
            }
            if (this.resumingFrom && !this.resumingFrom.instance) this.resumingFrom = undefined;
        }
        createProjectionDeltas() {
            this.prevProjectionDelta = (0, _modelsMjs.createDelta)();
            this.projectionDelta = (0, _modelsMjs.createDelta)();
            this.projectionDeltaWithTransform = (0, _modelsMjs.createDelta)();
        }
        setAnimationOrigin(delta, hasOnlyRelativeTargetChanged = false) {
            const snapshot = this.snapshot;
            const snapshotLatestValues = snapshot ? snapshot.latestValues : {};
            const mixedValues = {
                ...this.latestValues
            };
            const targetDelta = (0, _modelsMjs.createDelta)();
            if (!this.relativeParent || !this.relativeParent.options.layoutRoot) this.relativeTarget = this.relativeTargetOrigin = undefined;
            this.attemptToResolveRelativeTarget = !hasOnlyRelativeTargetChanged;
            const relativeLayout = (0, _modelsMjs.createBox)();
            const snapshotSource = snapshot ? snapshot.source : undefined;
            const layoutSource = this.layout ? this.layout.source : undefined;
            const isSharedLayoutAnimation = snapshotSource !== layoutSource;
            const stack = this.getStack();
            const isOnlyMember = !stack || stack.members.length <= 1;
            const shouldCrossfadeOpacity = Boolean(isSharedLayoutAnimation && !isOnlyMember && this.options.crossfade === true && !this.path.some(hasOpacityCrossfade));
            this.animationProgress = 0;
            let prevRelativeTarget;
            this.mixTargetDelta = (latest)=>{
                const progress = latest / 1000;
                mixAxisDelta(targetDelta.x, delta.x, progress);
                mixAxisDelta(targetDelta.y, delta.y, progress);
                this.setTargetDelta(targetDelta);
                if (this.relativeTarget && this.relativeTargetOrigin && this.layout && this.relativeParent && this.relativeParent.layout) {
                    (0, _deltaCalcMjs.calcRelativePosition)(relativeLayout, this.layout.layoutBox, this.relativeParent.layout.layoutBox, this.options.layoutAnchor || undefined);
                    mixBox(this.relativeTarget, this.relativeTargetOrigin, relativeLayout, progress);
                    /**
                     * If this is an unchanged relative target we can consider the
                     * projection not dirty.
                     */ if (prevRelativeTarget && (0, _utilsMjs.boxEquals)(this.relativeTarget, prevRelativeTarget)) this.isProjectionDirty = false;
                    if (!prevRelativeTarget) prevRelativeTarget = (0, _modelsMjs.createBox)();
                    (0, _copyMjs.copyBoxInto)(prevRelativeTarget, this.relativeTarget);
                }
                if (isSharedLayoutAnimation) {
                    this.animationValues = mixedValues;
                    (0, _mixValuesMjs.mixValues)(mixedValues, snapshotLatestValues, this.latestValues, progress, shouldCrossfadeOpacity, isOnlyMember);
                }
                this.root.scheduleUpdateProjection();
                this.scheduleRender();
                this.animationProgress = progress;
            };
            this.mixTargetDelta(this.options.layoutRoot ? 1000 : 0);
        }
        startAnimation(options) {
            this.notifyListeners("animationStart");
            this.currentAnimation?.stop();
            this.resumingFrom?.currentAnimation?.stop();
            if (this.pendingAnimation) {
                (0, _frameMjs.cancelFrame)(this.pendingAnimation);
                this.pendingAnimation = undefined;
            }
            /**
             * Start the animation in the next frame to have a frame with progress 0,
             * where the target is the same as when the animation started, so we can
             * calculate the relative positions correctly for instant transitions.
             */ this.pendingAnimation = (0, _frameMjs.frame).update(()=>{
                (0, _stateMjs.globalProjectionState).hasAnimatedSinceResize = true;
                (0, _animationCountMjs.activeAnimations).layout++;
                this.motionValue || (this.motionValue = (0, _indexMjs.motionValue)(0));
                this.motionValue.jump(0, false);
                this.currentAnimation = (0, _singleValueMjs.animateSingleValue)(this.motionValue, [
                    0,
                    1000
                ], {
                    ...options,
                    velocity: 0,
                    isSync: true,
                    onUpdate: (latest)=>{
                        this.mixTargetDelta(latest);
                        options.onUpdate && options.onUpdate(latest);
                    },
                    onStop: ()=>{
                        (0, _animationCountMjs.activeAnimations).layout--;
                    },
                    onComplete: ()=>{
                        (0, _animationCountMjs.activeAnimations).layout--;
                        options.onComplete && options.onComplete();
                        this.completeAnimation();
                    }
                });
                if (this.resumingFrom) this.resumingFrom.currentAnimation = this.currentAnimation;
                this.pendingAnimation = undefined;
            });
        }
        completeAnimation() {
            if (this.resumingFrom) {
                this.resumingFrom.currentAnimation = undefined;
                this.resumingFrom.preserveOpacity = undefined;
            }
            const stack = this.getStack();
            stack && stack.exitAnimationComplete();
            this.resumingFrom = this.currentAnimation = this.animationValues = undefined;
            this.notifyListeners("animationComplete");
        }
        finishAnimation() {
            if (this.currentAnimation) {
                this.mixTargetDelta && this.mixTargetDelta(animationTarget);
                this.currentAnimation.stop();
            }
            this.completeAnimation();
        }
        applyTransformsToTarget() {
            const lead = this.getLead();
            let { targetWithTransforms, target, layout, latestValues } = lead;
            if (!targetWithTransforms || !target || !layout) return;
            /**
             * If we're only animating position, and this element isn't the lead element,
             * then instead of projecting into the lead box we instead want to calculate
             * a new target that aligns the two boxes but maintains the layout shape.
             */ if (this !== lead && this.layout && layout && shouldAnimatePositionOnly(this.options.animationType, this.layout.layoutBox, layout.layoutBox)) {
                target = this.target || (0, _modelsMjs.createBox)();
                const xLength = (0, _deltaCalcMjs.calcLength)(this.layout.layoutBox.x);
                target.x.min = lead.target.x.min;
                target.x.max = target.x.min + xLength;
                const yLength = (0, _deltaCalcMjs.calcLength)(this.layout.layoutBox.y);
                target.y.min = lead.target.y.min;
                target.y.max = target.y.min + yLength;
            }
            (0, _copyMjs.copyBoxInto)(targetWithTransforms, target);
            /**
             * Apply the latest user-set transforms to the targetBox to produce the targetBoxFinal.
             * This is the final box that we will then project into by calculating a transform delta and
             * applying it to the corrected box.
             */ (0, _deltaApplyMjs.transformBox)(targetWithTransforms, latestValues);
            /**
             * Update the delta between the corrected box and the final target box, after
             * user-set transforms are applied to it. This will be used by the renderer to
             * create a transform style that will reproject the element from its layout layout
             * into the desired bounding box.
             */ (0, _deltaCalcMjs.calcBoxDelta)(this.projectionDeltaWithTransform, this.layoutCorrected, targetWithTransforms, latestValues);
        }
        registerSharedNode(layoutId, node) {
            if (!this.sharedNodes.has(layoutId)) this.sharedNodes.set(layoutId, new (0, _stackMjs.NodeStack)());
            const stack = this.sharedNodes.get(layoutId);
            stack.add(node);
            const config = node.options.initialPromotionConfig;
            node.promote({
                transition: config ? config.transition : undefined,
                preserveFollowOpacity: config && config.shouldPreserveFollowOpacity ? config.shouldPreserveFollowOpacity(node) : undefined
            });
        }
        isLead() {
            const stack = this.getStack();
            return stack ? stack.lead === this : true;
        }
        getLead() {
            const { layoutId } = this.options;
            return layoutId ? this.getStack()?.lead || this : this;
        }
        getPrevLead() {
            const { layoutId } = this.options;
            return layoutId ? this.getStack()?.prevLead : undefined;
        }
        getStack() {
            const { layoutId } = this.options;
            if (layoutId) return this.root.sharedNodes.get(layoutId);
        }
        promote({ needsReset, transition, preserveFollowOpacity } = {}) {
            const stack = this.getStack();
            if (stack) stack.promote(this, preserveFollowOpacity);
            if (needsReset) {
                this.projectionDelta = undefined;
                this.needsReset = true;
            }
            if (transition) this.setOptions({
                transition
            });
        }
        relegate() {
            const stack = this.getStack();
            if (stack) return stack.relegate(this);
            else return false;
        }
        resetSkewAndRotation() {
            const { visualElement } = this.options;
            if (!visualElement) return;
            // If there's no detected skew or rotation values, we can early return without a forced render.
            let hasDistortingTransform = false;
            /**
             * An unrolled check for rotation values. Most elements don't have any rotation and
             * skipping the nested loop and new object creation is 50% faster.
             */ const { latestValues } = visualElement;
            if (latestValues.z || latestValues.rotate || latestValues.rotateX || latestValues.rotateY || latestValues.rotateZ || latestValues.skewX || latestValues.skewY) hasDistortingTransform = true;
            // If there's no distorting values, we don't need to do any more.
            if (!hasDistortingTransform) return;
            const resetValues = {};
            if (latestValues.z) resetDistortingTransform("z", visualElement, resetValues, this.animationValues);
            // Check the skew and rotate value of all axes and reset to 0
            for(let i = 0; i < transformAxes.length; i++){
                resetDistortingTransform(`rotate${transformAxes[i]}`, visualElement, resetValues, this.animationValues);
                resetDistortingTransform(`skew${transformAxes[i]}`, visualElement, resetValues, this.animationValues);
            }
            // Force a render of this element to apply the transform with all skews and rotations
            // set to 0.
            visualElement.render();
            // Put back all the values we reset
            for(const key in resetValues){
                visualElement.setStaticValue(key, resetValues[key]);
                if (this.animationValues) this.animationValues[key] = resetValues[key];
            }
            // Schedule a render for the next frame. This ensures we won't visually
            // see the element with the reset rotate value applied.
            visualElement.scheduleRender();
        }
        applyProjectionStyles(targetStyle, styleProp) {
            if (!this.instance || this.isSVG) return;
            if (!this.isVisible) {
                targetStyle.visibility = "hidden";
                return;
            }
            const transformTemplate = this.getTransformTemplate();
            if (this.needsReset) {
                this.needsReset = false;
                targetStyle.visibility = "";
                targetStyle.opacity = "";
                targetStyle.pointerEvents = (0, _resolveMotionValueMjs.resolveMotionValue)(styleProp?.pointerEvents) || "";
                targetStyle.transform = transformTemplate ? transformTemplate(this.latestValues, "") : "none";
                return;
            }
            const lead = this.getLead();
            if (!this.projectionDelta || !this.layout || !lead.target) {
                if (this.options.layoutId) {
                    targetStyle.opacity = this.latestValues.opacity !== undefined ? this.latestValues.opacity : 1;
                    targetStyle.pointerEvents = (0, _resolveMotionValueMjs.resolveMotionValue)(styleProp?.pointerEvents) || "";
                }
                if (this.hasProjected && !(0, _hasTransformMjs.hasTransform)(this.latestValues)) {
                    targetStyle.transform = transformTemplate ? transformTemplate({}, "") : "none";
                    this.hasProjected = false;
                }
                return;
            }
            targetStyle.visibility = "";
            const valuesToRender = lead.animationValues || lead.latestValues;
            this.applyTransformsToTarget();
            let transform = (0, _transformMjs.buildProjectionTransform)(this.projectionDeltaWithTransform, this.treeScale, valuesToRender);
            if (transformTemplate) transform = transformTemplate(valuesToRender, transform);
            targetStyle.transform = transform;
            const { x, y } = this.projectionDelta;
            targetStyle.transformOrigin = `${x.origin * 100}% ${y.origin * 100}% 0`;
            if (lead.animationValues) /**
                 * If the lead component is animating, assign this either the entering/leaving
                 * opacity
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity ?? this.latestValues.opacity ?? 1 : this.preserveOpacity ? this.latestValues.opacity : valuesToRender.opacityExit;
            else /**
                 * Or we're not animating at all, set the lead component to its layout
                 * opacity and other components to hidden.
                 */ targetStyle.opacity = lead === this ? valuesToRender.opacity !== undefined ? valuesToRender.opacity : "" : valuesToRender.opacityExit !== undefined ? valuesToRender.opacityExit : 0;
            /**
             * Apply scale correction
             */ for(const key in 0, _scaleCorrectionMjs.scaleCorrectors){
                if (valuesToRender[key] === undefined) continue;
                const { correct, applyTo, isCSSVariable } = (0, _scaleCorrectionMjs.scaleCorrectors)[key];
                /**
                 * Only apply scale correction to the value if we have an
                 * active projection transform. Otherwise these values become
                 * vulnerable to distortion if the element changes size without
                 * a corresponding layout animation.
                 */ const corrected = transform === "none" ? valuesToRender[key] : correct(valuesToRender[key], lead);
                if (applyTo) {
                    const num = applyTo.length;
                    for(let i = 0; i < num; i++)targetStyle[applyTo[i]] = corrected;
                } else // If this is a CSS variable, set it directly on the instance.
                // Replacing this function from creating styles to setting them
                // would be a good place to remove per frame object creation
                if (isCSSVariable) this.options.visualElement.renderState.vars[key] = corrected;
                else targetStyle[key] = corrected;
            }
            /**
             * Disable pointer events on follow components. This is to ensure
             * that if a follow component covers a lead component it doesn't block
             * pointer events on the lead.
             */ if (this.options.layoutId) targetStyle.pointerEvents = lead === this ? (0, _resolveMotionValueMjs.resolveMotionValue)(styleProp?.pointerEvents) || "" : "none";
        }
        clearSnapshot() {
            this.resumeFrom = this.snapshot = undefined;
        }
        // Only run on root
        resetTree() {
            this.root.nodes.forEach((node)=>node.currentAnimation?.stop());
            this.root.nodes.forEach(clearMeasurements);
            this.root.sharedNodes.clear();
        }
    };
}
function updateLayout(node) {
    node.updateLayout();
}
function notifyLayoutUpdate(node) {
    const snapshot = node.resumeFrom?.snapshot || node.snapshot;
    if (node.isLead() && node.layout && snapshot && node.hasListeners("didUpdate")) {
        const { layoutBox: layout, measuredBox: measuredLayout } = node.layout;
        const { animationType } = node.options;
        const isShared = snapshot.source !== node.layout.source;
        // TODO Maybe we want to also resize the layout snapshot so we don't trigger
        // animations for instance if layout="size" and an element has only changed position
        if (animationType === "size") (0, _eachAxisMjs.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, _deltaCalcMjs.calcLength)(axisSnapshot);
            axisSnapshot.min = layout[axis].min;
            axisSnapshot.max = axisSnapshot.min + length;
        });
        else if (animationType === "x" || animationType === "y") {
            const snapAxis = animationType === "x" ? "y" : "x";
            (0, _copyMjs.copyAxisInto)(isShared ? snapshot.measuredBox[snapAxis] : snapshot.layoutBox[snapAxis], layout[snapAxis]);
        } else if (shouldAnimatePositionOnly(animationType, snapshot.layoutBox, layout)) (0, _eachAxisMjs.eachAxis)((axis)=>{
            const axisSnapshot = isShared ? snapshot.measuredBox[axis] : snapshot.layoutBox[axis];
            const length = (0, _deltaCalcMjs.calcLength)(layout[axis]);
            axisSnapshot.max = axisSnapshot.min + length;
            /**
                 * Ensure relative target gets resized and rerendererd
                 */ if (node.relativeTarget && !node.currentAnimation) {
                node.isProjectionDirty = true;
                node.relativeTarget[axis].max = node.relativeTarget[axis].min + length;
            }
        });
        const layoutDelta = (0, _modelsMjs.createDelta)();
        (0, _deltaCalcMjs.calcBoxDelta)(layoutDelta, layout, snapshot.layoutBox);
        const visualDelta = (0, _modelsMjs.createDelta)();
        if (isShared) (0, _deltaCalcMjs.calcBoxDelta)(visualDelta, node.applyTransform(measuredLayout, true), snapshot.measuredBox);
        else (0, _deltaCalcMjs.calcBoxDelta)(visualDelta, layout, snapshot.layoutBox);
        const hasLayoutChanged = !(0, _utilsMjs.isDeltaZero)(layoutDelta);
        let hasRelativeLayoutChanged = false;
        if (!node.resumeFrom) {
            const relativeParent = node.getClosestProjectingParent();
            /**
             * If the relativeParent is itself resuming from a different element then
             * the relative snapshot is not relavent
             */ if (relativeParent && !relativeParent.resumeFrom) {
                const { snapshot: parentSnapshot, layout: parentLayout } = relativeParent;
                if (parentSnapshot && parentLayout) {
                    const anchor = node.options.layoutAnchor || undefined;
                    const relativeSnapshot = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(relativeSnapshot, snapshot.layoutBox, parentSnapshot.layoutBox, anchor);
                    const relativeLayout = (0, _modelsMjs.createBox)();
                    (0, _deltaCalcMjs.calcRelativePosition)(relativeLayout, layout, parentLayout.layoutBox, anchor);
                    if (!(0, _utilsMjs.boxEqualsRounded)(relativeSnapshot, relativeLayout)) hasRelativeLayoutChanged = true;
                    if (relativeParent.options.layoutRoot) {
                        node.relativeTarget = relativeLayout;
                        node.relativeTargetOrigin = relativeSnapshot;
                        node.relativeParent = relativeParent;
                    }
                }
            }
        }
        node.notifyListeners("didUpdate", {
            layout,
            snapshot,
            delta: visualDelta,
            layoutDelta,
            hasLayoutChanged,
            hasRelativeLayoutChanged
        });
    } else if (node.isLead()) {
        const { onExitComplete } = node.options;
        onExitComplete && onExitComplete();
    }
    /**
     * Clearing transition
     * TODO: Investigate why this transition is being passed in as {type: false } from Framer
     * and why we need it at all
     */ node.options.transition = undefined;
}
function propagateDirtyNodes(node) {
    /**
     * Increase debug counter for nodes encountered this frame
     */ if ((0, _bufferMjs.statsBuffer).value) metrics.nodes++;
    if (!node.parent) return;
    /**
     * If this node isn't projecting, propagate isProjectionDirty. It will have
     * no performance impact but it will allow the next child that *is* projecting
     * but *isn't* dirty to just check its parent to see if *any* ancestor needs
     * correcting.
     */ if (!node.isProjecting()) node.isProjectionDirty = node.parent.isProjectionDirty;
    /**
     * Propagate isSharedProjectionDirty and isTransformDirty
     * throughout the whole tree. A future revision can take another look at
     * this but for safety we still recalcualte shared nodes.
     */ node.isSharedProjectionDirty || (node.isSharedProjectionDirty = Boolean(node.isProjectionDirty || node.parent.isProjectionDirty || node.parent.isSharedProjectionDirty));
    node.isTransformDirty || (node.isTransformDirty = node.parent.isTransformDirty);
}
function cleanDirtyNodes(node) {
    node.isProjectionDirty = node.isSharedProjectionDirty = node.isTransformDirty = false;
}
function clearSnapshot(node) {
    node.clearSnapshot();
}
function clearMeasurements(node) {
    node.clearMeasurements();
}
function forceLayoutMeasure(node) {
    node.isLayoutDirty = true;
    node.updateLayout();
}
function clearIsLayoutDirty(node) {
    node.isLayoutDirty = false;
}
/**
 * When a node is animation-blocked (e.g. during drag) and its component
 * didn't re-render (memoized), willUpdate() is never called so there's
 * no snapshot. Use the previous layout as a snapshot and mark dirty so
 * resetTransform/updateLayout/notifyLayoutUpdate process it normally.
 */ function ensureDraggedNodesSnapshotted(node) {
    if (node.isAnimationBlocked && node.layout && !node.isLayoutDirty) {
        node.snapshot = node.layout;
        node.isLayoutDirty = true;
    }
}
function resetTransformStyle(node) {
    const { visualElement } = node.options;
    if (visualElement && visualElement.getProps().onBeforeLayoutMeasure) visualElement.notify("BeforeLayoutMeasure");
    node.resetTransform();
}
function finishAnimation(node) {
    node.finishAnimation();
    node.targetDelta = node.relativeTarget = node.target = undefined;
    node.isProjectionDirty = true;
}
function resolveTargetDelta(node) {
    node.resolveTargetDelta();
}
function calcProjection(node) {
    node.calcProjection();
}
function resetSkewAndRotation(node) {
    node.resetSkewAndRotation();
}
function removeLeadSnapshots(stack) {
    stack.removeLeadSnapshot();
}
function mixAxisDelta(output, delta, p) {
    output.translate = (0, _numberMjs.mixNumber)(delta.translate, 0, p);
    output.scale = (0, _numberMjs.mixNumber)(delta.scale, 1, p);
    output.origin = delta.origin;
    output.originPoint = delta.originPoint;
}
function mixAxis(output, from, to, p) {
    output.min = (0, _numberMjs.mixNumber)(from.min, to.min, p);
    output.max = (0, _numberMjs.mixNumber)(from.max, to.max, p);
}
function mixBox(output, from, to, p) {
    mixAxis(output.x, from.x, to.x, p);
    mixAxis(output.y, from.y, to.y, p);
}
function hasOpacityCrossfade(node) {
    return node.animationValues && node.animationValues.opacityExit !== undefined;
}
const defaultLayoutTransition = {
    duration: 0.45,
    ease: [
        0.4,
        0,
        0.1,
        1
    ]
};
const userAgentContains = (string)=>typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().includes(string);
/**
 * Measured bounding boxes must be rounded in Safari and
 * left untouched in Chrome, otherwise non-integer layouts within scaled-up elements
 * can appear to jump.
 */ const roundPoint = userAgentContains("applewebkit/") && !userAgentContains("chrome/") ? Math.round : (0, _motionUtils.noop);
function roundAxis(axis) {
    // Round to the nearest .5 pixels to support subpixel layouts
    axis.min = roundPoint(axis.min);
    axis.max = roundPoint(axis.max);
}
function roundBox(box) {
    roundAxis(box.x);
    roundAxis(box.y);
}
function shouldAnimatePositionOnly(animationType, snapshot, layout) {
    return animationType === "position" || animationType === "preserve-aspect" && !(0, _deltaCalcMjs.isNear)((0, _utilsMjs.aspectRatio)(snapshot), (0, _utilsMjs.aspectRatio)(layout), 0.2);
}
function checkNodeWasScrollRoot(node) {
    return node !== node.root && node.scroll?.wasRoot;
}

},{"motion-utils":[["clamp","b78W4"],["noop","1tDyg"],["SubscriptionManager","8tNj4"]],"../../animation/animate/single-value.mjs":"eUA8b","../../animation/optimized-appear/get-appear-id.mjs":"cbcxg","../../animation/utils/get-value-transition.mjs":"6hcoP","../../frameloop/microtask.mjs":"7uR6H","../../frameloop/sync-time.mjs":"74aV8","../styles/scale-correction.mjs":"4154g","../../stats/animation-count.mjs":"lEkpG","../../stats/buffer.mjs":"94Uw8","../../utils/delay.mjs":"Ua5cg","../../utils/is-svg-element.mjs":"jqrAv","../../utils/is-svg-svg-element.mjs":"a7f17","../../utils/mix/number.mjs":"91GSx","../../value/index.mjs":"hX31g","../../value/utils/resolve-motion-value.mjs":"9TiOd","../animation/mix-values.mjs":"fuYQ7","../geometry/copy.mjs":"fNsM5","../geometry/delta-apply.mjs":"iEf7c","../geometry/delta-calc.mjs":"fywoX","../geometry/delta-remove.mjs":"bpDGg","../geometry/models.mjs":"5H0uu","../geometry/utils.mjs":"41DAH","../shared/stack.mjs":"7JjwZ","../styles/transform.mjs":"1vFgW","../utils/each-axis.mjs":"6q1eY","../utils/flat-tree.mjs":"1xjHX","../utils/has-transform.mjs":"6BpuE","./state.mjs":"iPZeA","../../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7JjwZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NodeStack", ()=>NodeStack);
var _motionUtils = require("motion-utils");
class NodeStack {
    constructor(){
        this.members = [];
    }
    add(node) {
        (0, _motionUtils.addUniqueItem)(this.members, node);
        for(let i = this.members.length - 1; i >= 0; i--){
            const member = this.members[i];
            if (member === node || member === this.lead || member === this.prevLead) continue;
            const inst = member.instance;
            if ((!inst || inst.isConnected === false) && !member.snapshot) {
                (0, _motionUtils.removeItem)(this.members, member);
                member.unmount();
            }
        }
        node.scheduleRender();
    }
    remove(node) {
        (0, _motionUtils.removeItem)(this.members, node);
        if (node === this.prevLead) this.prevLead = undefined;
        if (node === this.lead) {
            const prevLead = this.members[this.members.length - 1];
            if (prevLead) this.promote(prevLead);
        }
    }
    relegate(node) {
        for(let i = this.members.indexOf(node) - 1; i >= 0; i--){
            const member = this.members[i];
            if (member.isPresent !== false && member.instance?.isConnected !== false) {
                this.promote(member);
                return true;
            }
        }
        return false;
    }
    promote(node, preserveFollowOpacity) {
        const prevLead = this.lead;
        if (node === prevLead) return;
        this.prevLead = prevLead;
        this.lead = node;
        node.show();
        if (prevLead) {
            prevLead.updateSnapshot();
            node.scheduleRender();
            const { layoutDependency: prevDep } = prevLead.options;
            const { layoutDependency: nextDep } = node.options;
            if (prevDep === undefined || prevDep !== nextDep) {
                node.resumeFrom = prevLead;
                if (preserveFollowOpacity) prevLead.preserveOpacity = true;
                if (prevLead.snapshot) {
                    node.snapshot = prevLead.snapshot;
                    node.snapshot.latestValues = prevLead.animationValues || prevLead.latestValues;
                }
                if (node.root?.isUpdating) node.isLayoutDirty = true;
            }
            if (node.options.crossfade === false) prevLead.hide();
        }
    }
    exitAnimationComplete() {
        this.members.forEach((member)=>{
            member.options.onExitComplete?.();
            member.resumingFrom?.options.onExitComplete?.();
        });
    }
    scheduleRender() {
        this.members.forEach((member)=>member.instance && member.scheduleRender(false));
    }
    removeLeadSnapshot() {
        if (this.lead?.snapshot) this.lead.snapshot = undefined;
    }
}

},{"motion-utils":"841vh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iPZeA":[function(require,module,exports,__globalThis) {
/**
 * This should only ever be modified on the client otherwise it'll
 * persist through server requests. If we need instanced states we
 * could lazy-init via root.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "globalProjectionState", ()=>globalProjectionState);
const globalProjectionState = {
    /**
     * Global flag as to whether the tree has animated since the last time
     * we resized the window
     */ hasAnimatedSinceResize: true,
    /**
     * We set this to true once, on the first update. Any nodes added to the tree beyond that
     * update will be given a `data-projection-id` attribute.
     */ hasEverUpdated: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3mFFY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocumentProjectionNode", ()=>DocumentProjectionNode);
var _addDomEventMjs = require("../../events/add-dom-event.mjs");
var _createProjectionNodeMjs = require("./create-projection-node.mjs");
const DocumentProjectionNode = (0, _createProjectionNodeMjs.createProjectionNode)({
    attachResizeListener: (ref, notify)=>(0, _addDomEventMjs.addDomEvent)(ref, "resize", notify),
    measureScroll: ()=>({
            x: document.documentElement.scrollLeft || document.body?.scrollLeft || 0,
            y: document.documentElement.scrollTop || document.body?.scrollTop || 0
        }),
    checkIsScrollRoot: ()=>true
});

},{"../../events/add-dom-event.mjs":"e11Be","./create-projection-node.mjs":"khfgR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8n0Vk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nodeGroup", ()=>nodeGroup);
const notify = (node)=>!node.isLayoutDirty && node.willUpdate(false);
function nodeGroup() {
    const nodes = new Set();
    const subscriptions = new WeakMap();
    const dirtyAll = ()=>nodes.forEach(notify);
    return {
        add: (node)=>{
            nodes.add(node);
            subscriptions.set(node, node.addEventListener("willUpdate", dirtyAll));
        },
        remove: (node)=>{
            nodes.delete(node);
            const unsubscribe = subscriptions.get(node);
            if (unsubscribe) {
                unsubscribe();
                subscriptions.delete(node);
            }
            dirtyAll();
        },
        dirty: dirtyAll
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2kn0n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HTMLProjectionNode", ()=>HTMLProjectionNode);
parcelHelpers.export(exports, "rootProjectionNode", ()=>rootProjectionNode);
var _createProjectionNodeMjs = require("./create-projection-node.mjs");
var _documentProjectionNodeMjs = require("./DocumentProjectionNode.mjs");
const rootProjectionNode = {
    current: undefined
};
const HTMLProjectionNode = (0, _createProjectionNodeMjs.createProjectionNode)({
    measureScroll: (instance)=>({
            x: instance.scrollLeft,
            y: instance.scrollTop
        }),
    defaultParent: ()=>{
        if (!rootProjectionNode.current) {
            const documentNode = new (0, _documentProjectionNodeMjs.DocumentProjectionNode)({});
            documentNode.mount(window);
            documentNode.setOptions({
                layoutScroll: true
            });
            rootProjectionNode.current = documentNode;
        }
        return rootProjectionNode.current;
    },
    resetTransform: (instance, value)=>{
        instance.style.transform = value !== undefined ? value : "none";
    },
    checkIsScrollRoot: (instance)=>Boolean(window.getComputedStyle(instance).position === "fixed")
});

},{"./create-projection-node.mjs":"khfgR","./DocumentProjectionNode.mjs":"3mFFY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"av52f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutAnimationBuilder", ()=>LayoutAnimationBuilder);
parcelHelpers.export(exports, "parseAnimateLayoutArgs", ()=>parseAnimateLayoutArgs);
var _groupAnimationMjs = require("../animation/GroupAnimation.mjs");
var _copyMjs = require("../projection/geometry/copy.mjs");
var _modelsMjs = require("../projection/geometry/models.mjs");
var _htmlprojectionNodeMjs = require("../projection/node/HTMLProjectionNode.mjs");
var _htmlvisualElementMjs = require("../render/html/HTMLVisualElement.mjs");
var _storeMjs = require("../render/store.mjs");
var _resolveElementsMjs = require("../utils/resolve-elements.mjs");
var _frameMjs = require("../frameloop/frame.mjs");
const layoutSelector = "[data-layout], [data-layout-id]";
const noop = ()=>{};
function snapshotFromTarget(projection) {
    const target = projection.targetWithTransforms || projection.target;
    if (!target) return undefined;
    const measuredBox = (0, _modelsMjs.createBox)();
    const layoutBox = (0, _modelsMjs.createBox)();
    (0, _copyMjs.copyBoxInto)(measuredBox, target);
    (0, _copyMjs.copyBoxInto)(layoutBox, target);
    return {
        animationId: projection.root?.animationId ?? 0,
        measuredBox,
        layoutBox,
        latestValues: projection.animationValues || projection.latestValues || {},
        source: projection.id
    };
}
class LayoutAnimationBuilder {
    constructor(scope, updateDom, defaultOptions){
        this.sharedTransitions = new Map();
        this.notifyReady = noop;
        this.rejectReady = noop;
        this.scope = scope;
        this.updateDom = updateDom;
        this.defaultOptions = defaultOptions;
        this.readyPromise = new Promise((resolve, reject)=>{
            this.notifyReady = resolve;
            this.rejectReady = reject;
        });
        (0, _frameMjs.frame).postRender(()=>{
            this.start().then(this.notifyReady).catch(this.rejectReady);
        });
    }
    shared(id, transition) {
        this.sharedTransitions.set(id, transition);
        return this;
    }
    then(resolve, reject) {
        return this.readyPromise.then(resolve, reject);
    }
    async start() {
        const beforeElements = collectLayoutElements(this.scope);
        const beforeRecords = this.buildRecords(beforeElements);
        beforeRecords.forEach(({ projection })=>{
            const hasCurrentAnimation = Boolean(projection.currentAnimation);
            const isSharedLayout = Boolean(projection.options.layoutId);
            if (hasCurrentAnimation && isSharedLayout) {
                const snapshot = snapshotFromTarget(projection);
                if (snapshot) projection.snapshot = snapshot;
                else if (projection.snapshot) projection.snapshot = undefined;
            } else if (projection.snapshot && (projection.currentAnimation || projection.isProjecting())) projection.snapshot = undefined;
            projection.isPresent = true;
            projection.willUpdate();
        });
        await this.updateDom();
        const afterElements = collectLayoutElements(this.scope);
        const afterRecords = this.buildRecords(afterElements);
        this.handleExitingElements(beforeRecords, afterRecords);
        afterRecords.forEach(({ projection })=>{
            const instance = projection.instance;
            const resumeFromInstance = projection.resumeFrom?.instance;
            if (!instance || !resumeFromInstance) return;
            if (!("style" in instance)) return;
            const currentTransform = instance.style.transform;
            const resumeFromTransform = resumeFromInstance.style.transform;
            if (currentTransform && resumeFromTransform && currentTransform === resumeFromTransform) {
                instance.style.transform = "";
                instance.style.transformOrigin = "";
            }
        });
        afterRecords.forEach(({ projection })=>{
            projection.isPresent = true;
        });
        const root = getProjectionRoot(afterRecords, beforeRecords);
        root?.didUpdate();
        await new Promise((resolve)=>{
            (0, _frameMjs.frame).postRender(()=>resolve());
        });
        const animations = collectAnimations(afterRecords);
        const animation = new (0, _groupAnimationMjs.GroupAnimation)(animations);
        return animation;
    }
    buildRecords(elements) {
        const records = [];
        const recordMap = new Map();
        for (const element of elements){
            const parentRecord = findParentRecord(element, recordMap, this.scope);
            const { layout, layoutId } = readLayoutAttributes(element);
            const override = layoutId ? this.sharedTransitions.get(layoutId) : undefined;
            const transition = override || this.defaultOptions;
            const record = getOrCreateRecord(element, parentRecord?.projection, {
                layout,
                layoutId,
                animationType: typeof layout === "string" ? layout : "both",
                transition: transition
            });
            recordMap.set(element, record);
            records.push(record);
        }
        return records;
    }
    handleExitingElements(beforeRecords, afterRecords) {
        const afterElementsSet = new Set(afterRecords.map((record)=>record.element));
        beforeRecords.forEach((record)=>{
            if (afterElementsSet.has(record.element)) return;
            // For shared layout elements, relegate to set up resumeFrom
            // so the remaining element animates from this position
            if (record.projection.options.layoutId) {
                record.projection.isPresent = false;
                record.projection.relegate();
            }
            record.visualElement.unmount();
            (0, _storeMjs.visualElementStore).delete(record.element);
        });
        // Clear resumeFrom on EXISTING nodes that point to unmounted projections
        // This prevents crossfade animation when the source element was removed entirely
        // But preserve resumeFrom for NEW nodes so they can animate from the old position
        // Also preserve resumeFrom for lead nodes that were just promoted via relegate
        const beforeElementsSet = new Set(beforeRecords.map((record)=>record.element));
        afterRecords.forEach(({ element, projection })=>{
            if (beforeElementsSet.has(element) && projection.resumeFrom && !projection.resumeFrom.instance && !projection.isLead()) {
                projection.resumeFrom = undefined;
                projection.snapshot = undefined;
            }
        });
    }
}
function parseAnimateLayoutArgs(scopeOrUpdateDom, updateDomOrOptions, options) {
    // animateLayout(updateDom)
    if (typeof scopeOrUpdateDom === "function") return {
        scope: document,
        updateDom: scopeOrUpdateDom,
        defaultOptions: updateDomOrOptions
    };
    // animateLayout(scope, updateDom, options?)
    const elements = (0, _resolveElementsMjs.resolveElements)(scopeOrUpdateDom);
    const scope = elements[0] || document;
    return {
        scope,
        updateDom: updateDomOrOptions,
        defaultOptions: options
    };
}
function collectLayoutElements(scope) {
    const elements = Array.from(scope.querySelectorAll(layoutSelector));
    if (scope instanceof Element && scope.matches(layoutSelector)) {
        if (!elements.includes(scope)) elements.unshift(scope);
    }
    return elements;
}
function readLayoutAttributes(element) {
    const layoutId = element.getAttribute("data-layout-id") || undefined;
    const rawLayout = element.getAttribute("data-layout");
    let layout;
    if (rawLayout === "" || rawLayout === "true") layout = true;
    else if (rawLayout) layout = rawLayout;
    return {
        layout,
        layoutId
    };
}
function createVisualState() {
    return {
        latestValues: {},
        renderState: {
            transform: {},
            transformOrigin: {},
            style: {},
            vars: {}
        }
    };
}
function getOrCreateRecord(element, parentProjection, projectionOptions) {
    const existing = (0, _storeMjs.visualElementStore).get(element);
    const visualElement = existing ?? new (0, _htmlvisualElementMjs.HTMLVisualElement)({
        props: {},
        presenceContext: null,
        visualState: createVisualState()
    }, {
        allowProjection: true
    });
    if (!existing || !visualElement.projection) visualElement.projection = new (0, _htmlprojectionNodeMjs.HTMLProjectionNode)(visualElement.latestValues, parentProjection);
    visualElement.projection.setOptions({
        ...projectionOptions,
        visualElement
    });
    if (!visualElement.current) visualElement.mount(element);
    else if (!visualElement.projection.instance) // Mount projection if VisualElement is already mounted but projection isn't
    // This happens when animate() was called before animateLayout()
    visualElement.projection.mount(element);
    if (!existing) (0, _storeMjs.visualElementStore).set(element, visualElement);
    return {
        element,
        visualElement,
        projection: visualElement.projection
    };
}
function findParentRecord(element, recordMap, scope) {
    let parent = element.parentElement;
    while(parent){
        const record = recordMap.get(parent);
        if (record) return record;
        if (parent === scope) break;
        parent = parent.parentElement;
    }
    return undefined;
}
function getProjectionRoot(afterRecords, beforeRecords) {
    const record = afterRecords[0] || beforeRecords[0];
    return record?.projection.root;
}
function collectAnimations(afterRecords) {
    const animations = new Set();
    afterRecords.forEach((record)=>{
        const animation = record.projection.currentAnimation;
        if (animation) animations.add(animation);
    });
    return Array.from(animations);
}

},{"../animation/GroupAnimation.mjs":"7hkDg","../projection/geometry/copy.mjs":"fNsM5","../projection/geometry/models.mjs":"5H0uu","../projection/node/HTMLProjectionNode.mjs":"2kn0n","../render/html/HTMLVisualElement.mjs":"eQTgj","../render/store.mjs":"4d03k","../utils/resolve-elements.mjs":"pZkYr","../frameloop/frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"86tnH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cancelSync", ()=>cancelSync);
parcelHelpers.export(exports, "sync", ()=>sync);
var _orderMjs = require("./order.mjs");
var _frameMjs = require("./frame.mjs");
/**
 * @deprecated
 *
 * Import as `frame` instead.
 */ const sync = (0, _frameMjs.frame);
/**
 * @deprecated
 *
 * Use cancelFrame(callback) instead.
 */ const cancelSync = (0, _orderMjs.stepsOrder).reduce((acc, key)=>{
    acc[key] = (process)=>(0, _frameMjs.cancelFrame)(process);
    return acc;
}, {});

},{"./order.mjs":"dqkMK","./frame.mjs":"4c192","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eSdvu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SwitchLayoutGroupContext", ()=>SwitchLayoutGroupContext);
var _react = require("react");
"use client";
/**
 * Internal, exported only for usage in Framer
 */ const SwitchLayoutGroupContext = (0, _react.createContext)({});

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7C36g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isRefObject", ()=>isRefObject);
function isRefObject(ref) {
    return ref && typeof ref === "object" && Object.prototype.hasOwnProperty.call(ref, "current");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7bvMJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "featureBundle", ()=>featureBundle);
var _animationsMjs = require("../../../motion/features/animations.mjs");
var _dragMjs = require("../../../motion/features/drag.mjs");
var _gesturesMjs = require("../../../motion/features/gestures.mjs");
var _layoutMjs = require("../../../motion/features/layout.mjs");
const featureBundle = {
    ...(0, _animationsMjs.animations),
    ...(0, _gesturesMjs.gestureAnimations),
    ...(0, _dragMjs.drag),
    ...(0, _layoutMjs.layout)
};

},{"../../../motion/features/animations.mjs":"dj5wy","../../../motion/features/drag.mjs":"5hQnI","../../../motion/features/gestures.mjs":"GWBKF","../../../motion/features/layout.mjs":"bUUEG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dj5wy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "animations", ()=>animations);
var _indexMjs = require("./animation/index.mjs");
var _exitMjs = require("./animation/exit.mjs");
const animations = {
    animation: {
        Feature: (0, _indexMjs.AnimationFeature)
    },
    exit: {
        Feature: (0, _exitMjs.ExitAnimationFeature)
    }
};

},{"./animation/index.mjs":"5sJcb","./animation/exit.mjs":"4d69r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5sJcb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationFeature", ()=>AnimationFeature);
var _motionDom = require("motion-dom");
class AnimationFeature extends (0, _motionDom.Feature) {
    /**
     * We dynamically generate the AnimationState manager as it contains a reference
     * to the underlying animation library. We only want to load that if we load this,
     * so people can optionally code split it out using the `m` component.
     */ constructor(node){
        super(node);
        node.animationState || (node.animationState = (0, _motionDom.createAnimationState)(node));
    }
    updateAnimationControlsSubscription() {
        const { animate } = this.node.getProps();
        if ((0, _motionDom.isAnimationControls)(animate)) this.unmountControls = animate.subscribe(this.node);
    }
    /**
     * Subscribe any provided AnimationControls to the component's VisualElement
     */ mount() {
        this.updateAnimationControlsSubscription();
    }
    update() {
        const { animate } = this.node.getProps();
        const { animate: prevAnimate } = this.node.prevProps || {};
        if (animate !== prevAnimate) this.updateAnimationControlsSubscription();
    }
    unmount() {
        this.node.animationState.reset();
        this.unmountControls?.();
    }
}

},{"motion-dom":[["createAnimationState","kHpbR"],["Feature","2NZnJ"],["isAnimationControls","eZBfs"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4d69r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExitAnimationFeature", ()=>ExitAnimationFeature);
var _motionDom = require("motion-dom");
let id = 0;
class ExitAnimationFeature extends (0, _motionDom.Feature) {
    constructor(){
        super(...arguments);
        this.id = id++;
        this.isExitComplete = false;
    }
    update() {
        if (!this.node.presenceContext) return;
        const { isPresent, onExitComplete } = this.node.presenceContext;
        const { isPresent: prevIsPresent } = this.node.prevPresenceContext || {};
        if (!this.node.animationState || isPresent === prevIsPresent) return;
        if (isPresent && prevIsPresent === false) {
            /**
             * When re-entering, if the exit animation already completed
             * (element is at rest), reset to initial values so the enter
             * animation replays from the correct position.
             */ if (this.isExitComplete) {
                const { initial, custom } = this.node.getProps();
                if (typeof initial === "string") {
                    const resolved = (0, _motionDom.resolveVariant)(this.node, initial, custom);
                    if (resolved) {
                        const { transition, transitionEnd, ...target } = resolved;
                        for(const key in target)this.node.getValue(key)?.jump(target[key]);
                    }
                }
                this.node.animationState.reset();
                this.node.animationState.animateChanges();
            } else this.node.animationState.setActive("exit", false);
            this.isExitComplete = false;
            return;
        }
        const exitAnimation = this.node.animationState.setActive("exit", !isPresent);
        if (onExitComplete && !isPresent) exitAnimation.then(()=>{
            this.isExitComplete = true;
            onExitComplete(this.id);
        });
    }
    mount() {
        const { register, onExitComplete } = this.node.presenceContext || {};
        if (onExitComplete) onExitComplete(this.id);
        if (register) this.unmount = register(this.id);
    }
    unmount() {}
}

},{"motion-dom":[["Feature","2NZnJ"],["resolveVariant","7PfV6"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5hQnI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "drag", ()=>drag);
var _indexMjs = require("../../gestures/drag/index.mjs");
var _indexMjs1 = require("../../gestures/pan/index.mjs");
var _measureLayoutMjs = require("./layout/MeasureLayout.mjs");
var _motionDom = require("motion-dom");
const drag = {
    pan: {
        Feature: (0, _indexMjs1.PanGesture)
    },
    drag: {
        Feature: (0, _indexMjs.DragGesture),
        ProjectionNode: (0, _motionDom.HTMLProjectionNode),
        MeasureLayout: (0, _measureLayoutMjs.MeasureLayout)
    }
};

},{"../../gestures/drag/index.mjs":"2oO4A","../../gestures/pan/index.mjs":"htzn9","./layout/MeasureLayout.mjs":"47rO5","motion-dom":"2kn0n","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2oO4A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragGesture", ()=>DragGesture);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _visualElementDragControlsMjs = require("./VisualElementDragControls.mjs");
class DragGesture extends (0, _motionDom.Feature) {
    constructor(node){
        super(node);
        this.removeGroupControls = (0, _motionUtils.noop);
        this.removeListeners = (0, _motionUtils.noop);
        this.controls = new (0, _visualElementDragControlsMjs.VisualElementDragControls)(node);
    }
    mount() {
        // If we've been provided a DragControls for manual control over the drag gesture,
        // subscribe this component to it on mount.
        const { dragControls } = this.node.getProps();
        if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        this.removeListeners = this.controls.addListeners() || (0, _motionUtils.noop);
    }
    update() {
        const { dragControls } = this.node.getProps();
        const { dragControls: prevDragControls } = this.node.prevProps || {};
        if (dragControls !== prevDragControls) {
            this.removeGroupControls();
            if (dragControls) this.removeGroupControls = dragControls.subscribe(this.controls);
        }
    }
    unmount() {
        this.removeGroupControls();
        this.removeListeners();
        /**
         * In React 19, during list reorder reconciliation, components may
         * briefly unmount and remount while the drag is still active. If we're
         * actively dragging, we should NOT end the pan session - it will
         * continue tracking pointer events via its window-level listeners.
         *
         * The pan session will be properly cleaned up when:
         * 1. The drag ends naturally (pointerup/pointercancel)
         * 2. The component is truly removed from the DOM
         */ if (!this.controls.isDragging) this.controls.endPanSession();
    }
}

},{"motion-dom":"2NZnJ","motion-utils":"1tDyg","./VisualElementDragControls.mjs":"64Rnp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"64Rnp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VisualElementDragControls", ()=>VisualElementDragControls);
parcelHelpers.export(exports, "elementDragControls", ()=>elementDragControls);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _addPointerEventMjs = require("../../events/add-pointer-event.mjs");
var _eventInfoMjs = require("../../events/event-info.mjs");
var _getContextWindowMjs = require("../../utils/get-context-window.mjs");
var _isRefObjectMjs = require("../../utils/is-ref-object.mjs");
var _panSessionMjs = require("../pan/PanSession.mjs");
var _constraintsMjs = require("./utils/constraints.mjs");
const elementDragControls = new WeakMap();
class VisualElementDragControls {
    constructor(visualElement){
        this.openDragLock = null;
        this.isDragging = false;
        this.currentDirection = null;
        this.originPoint = {
            x: 0,
            y: 0
        };
        /**
         * The permitted boundaries of travel, in pixels.
         */ this.constraints = false;
        this.hasMutatedConstraints = false;
        /**
         * The per-axis resolved elastic values.
         */ this.elastic = (0, _motionDom.createBox)();
        /**
         * The latest pointer event. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPointerEvent = null;
        /**
         * The latest pan info. Used as fallback when the `cancel` and `stop` functions are called without arguments.
         */ this.latestPanInfo = null;
        this.visualElement = visualElement;
    }
    start(originEvent, { snapToCursor = false, distanceThreshold } = {}) {
        /**
         * Don't start dragging if this component is exiting
         */ const { presenceContext } = this.visualElement;
        if (presenceContext && presenceContext.isPresent === false) return;
        const onSessionStart = (event)=>{
            if (snapToCursor) this.snapToCursor((0, _eventInfoMjs.extractEventInfo)(event).point);
            this.stopAnimation();
        };
        const onStart = (event, info)=>{
            // Attempt to grab the global drag gesture lock - maybe make this part of PanSession
            const { drag, dragPropagation, onDragStart } = this.getProps();
            if (drag && !dragPropagation) {
                if (this.openDragLock) this.openDragLock();
                this.openDragLock = (0, _motionDom.setDragLock)(drag);
                // If we don 't have the lock, don't start dragging
                if (!this.openDragLock) return;
            }
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.isDragging = true;
            this.currentDirection = null;
            this.resolveConstraints();
            if (this.visualElement.projection) {
                this.visualElement.projection.isAnimationBlocked = true;
                this.visualElement.projection.target = undefined;
            }
            /**
             * Record gesture origin and pointer offset
             */ (0, _motionDom.eachAxis)((axis)=>{
                let current = this.getAxisMotionValue(axis).get() || 0;
                /**
                 * If the MotionValue is a percentage value convert to px
                 */ if ((0, _motionDom.percent).test(current)) {
                    const { projection } = this.visualElement;
                    if (projection && projection.layout) {
                        const measuredAxis = projection.layout.layoutBox[axis];
                        if (measuredAxis) {
                            const length = (0, _motionDom.calcLength)(measuredAxis);
                            current = length * (parseFloat(current) / 100);
                        }
                    }
                }
                this.originPoint[axis] = current;
            });
            // Fire onDragStart event
            if (onDragStart) (0, _motionDom.frame).update(()=>onDragStart(event, info), false, true);
            (0, _motionDom.addValueToWillChange)(this.visualElement, "transform");
            const { animationState } = this.visualElement;
            animationState && animationState.setActive("whileDrag", true);
        };
        const onMove = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            const { dragPropagation, dragDirectionLock, onDirectionLock, onDrag } = this.getProps();
            // If we didn't successfully receive the gesture lock, early return.
            if (!dragPropagation && !this.openDragLock) return;
            const { offset } = info;
            // Attempt to detect drag direction if directionLock is true
            if (dragDirectionLock && this.currentDirection === null) {
                this.currentDirection = getCurrentDirection(offset);
                // If we've successfully set a direction, notify listener
                if (this.currentDirection !== null) onDirectionLock && onDirectionLock(this.currentDirection);
                return;
            }
            // Update each point with the latest position
            this.updateAxis("x", info.point, offset);
            this.updateAxis("y", info.point, offset);
            /**
             * Ideally we would leave the renderer to fire naturally at the end of
             * this frame but if the element is about to change layout as the result
             * of a re-render we want to ensure the browser can read the latest
             * bounding box to ensure the pointer and element don't fall out of sync.
             */ this.visualElement.render();
            /**
             * This must fire after the render call as it might trigger a state
             * change which itself might trigger a layout update.
             */ if (onDrag) (0, _motionDom.frame).update(()=>onDrag(event, info), false, true);
        };
        const onSessionEnd = (event, info)=>{
            this.latestPointerEvent = event;
            this.latestPanInfo = info;
            this.stop(event, info);
            this.latestPointerEvent = null;
            this.latestPanInfo = null;
        };
        const resumeAnimation = ()=>{
            const { dragSnapToOrigin: snap } = this.getProps();
            if (snap || this.constraints) this.startAnimation({
                x: 0,
                y: 0
            });
        };
        const { dragSnapToOrigin } = this.getProps();
        this.panSession = new (0, _panSessionMjs.PanSession)(originEvent, {
            onSessionStart,
            onStart,
            onMove,
            onSessionEnd,
            resumeAnimation
        }, {
            transformPagePoint: this.visualElement.getTransformPagePoint(),
            dragSnapToOrigin,
            distanceThreshold,
            contextWindow: (0, _getContextWindowMjs.getContextWindow)(this.visualElement),
            element: this.visualElement.current
        });
    }
    /**
     * @internal
     */ stop(event, panInfo) {
        const finalEvent = event || this.latestPointerEvent;
        const finalPanInfo = panInfo || this.latestPanInfo;
        const isDragging = this.isDragging;
        this.cancel();
        if (!isDragging || !finalPanInfo || !finalEvent) return;
        const { velocity } = finalPanInfo;
        this.startAnimation(velocity);
        const { onDragEnd } = this.getProps();
        if (onDragEnd) (0, _motionDom.frame).postRender(()=>onDragEnd(finalEvent, finalPanInfo));
    }
    /**
     * @internal
     */ cancel() {
        this.isDragging = false;
        const { projection, animationState } = this.visualElement;
        if (projection) projection.isAnimationBlocked = false;
        this.endPanSession();
        const { dragPropagation } = this.getProps();
        if (!dragPropagation && this.openDragLock) {
            this.openDragLock();
            this.openDragLock = null;
        }
        animationState && animationState.setActive("whileDrag", false);
    }
    /**
     * Clean up the pan session without modifying other drag state.
     * This is used during unmount to ensure event listeners are removed
     * without affecting projection animations or drag locks.
     * @internal
     */ endPanSession() {
        this.panSession && this.panSession.end();
        this.panSession = undefined;
    }
    updateAxis(axis, _point, offset) {
        const { drag } = this.getProps();
        // If we're not dragging this axis, do an early return.
        if (!offset || !shouldDrag(axis, drag, this.currentDirection)) return;
        const axisValue = this.getAxisMotionValue(axis);
        let next = this.originPoint[axis] + offset[axis];
        // Apply constraints
        if (this.constraints && this.constraints[axis]) next = (0, _constraintsMjs.applyConstraints)(next, this.constraints[axis], this.elastic[axis]);
        axisValue.set(next);
    }
    resolveConstraints() {
        const { dragConstraints, dragElastic } = this.getProps();
        const layout = this.visualElement.projection && !this.visualElement.projection.layout ? this.visualElement.projection.measure(false) : this.visualElement.projection?.layout;
        const prevConstraints = this.constraints;
        if (dragConstraints && (0, _isRefObjectMjs.isRefObject)(dragConstraints)) {
            if (!this.constraints) this.constraints = this.resolveRefConstraints();
        } else if (dragConstraints && layout) this.constraints = (0, _constraintsMjs.calcRelativeConstraints)(layout.layoutBox, dragConstraints);
        else this.constraints = false;
        this.elastic = (0, _constraintsMjs.resolveDragElastic)(dragElastic);
        /**
         * If we're outputting to external MotionValues, we want to rebase the measured constraints
         * from viewport-relative to component-relative. This only applies to relative (non-ref)
         * constraints, as ref-based constraints from calcViewportConstraints are already in the
         * correct coordinate space for the motion value transform offset.
         */ if (prevConstraints !== this.constraints && !(0, _isRefObjectMjs.isRefObject)(dragConstraints) && layout && this.constraints && !this.hasMutatedConstraints) (0, _motionDom.eachAxis)((axis)=>{
            if (this.constraints !== false && this.getAxisMotionValue(axis)) this.constraints[axis] = (0, _constraintsMjs.rebaseAxisConstraints)(layout.layoutBox[axis], this.constraints[axis]);
        });
    }
    resolveRefConstraints() {
        const { dragConstraints: constraints, onMeasureDragConstraints } = this.getProps();
        if (!constraints || !(0, _isRefObjectMjs.isRefObject)(constraints)) return false;
        const constraintsElement = constraints.current;
        (0, _motionUtils.invariant)(constraintsElement !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.", "drag-constraints-ref");
        const { projection } = this.visualElement;
        // TODO
        if (!projection || !projection.layout) return false;
        const constraintsBox = (0, _motionDom.measurePageBox)(constraintsElement, projection.root, this.visualElement.getTransformPagePoint());
        let measuredConstraints = (0, _constraintsMjs.calcViewportConstraints)(projection.layout.layoutBox, constraintsBox);
        /**
         * If there's an onMeasureDragConstraints listener we call it and
         * if different constraints are returned, set constraints to that
         */ if (onMeasureDragConstraints) {
            const userConstraints = onMeasureDragConstraints((0, _motionDom.convertBoxToBoundingBox)(measuredConstraints));
            this.hasMutatedConstraints = !!userConstraints;
            if (userConstraints) measuredConstraints = (0, _motionDom.convertBoundingBoxToBox)(userConstraints);
        }
        return measuredConstraints;
    }
    startAnimation(velocity) {
        const { drag, dragMomentum, dragElastic, dragTransition, dragSnapToOrigin, onDragTransitionEnd } = this.getProps();
        const constraints = this.constraints || {};
        const momentumAnimations = (0, _motionDom.eachAxis)((axis)=>{
            if (!shouldDrag(axis, drag, this.currentDirection)) return;
            let transition = constraints && constraints[axis] || {};
            if (dragSnapToOrigin === true || dragSnapToOrigin === axis) transition = {
                min: 0,
                max: 0
            };
            /**
             * Overdamp the boundary spring if `dragElastic` is disabled. There's still a frame
             * of spring animations so we should look into adding a disable spring option to `inertia`.
             * We could do something here where we affect the `bounceStiffness` and `bounceDamping`
             * using the value of `dragElastic`.
             */ const bounceStiffness = dragElastic ? 200 : 1000000;
            const bounceDamping = dragElastic ? 40 : 10000000;
            const inertia = {
                type: "inertia",
                velocity: dragMomentum ? velocity[axis] : 0,
                bounceStiffness,
                bounceDamping,
                timeConstant: 750,
                restDelta: 1,
                restSpeed: 10,
                ...dragTransition,
                ...transition
            };
            // If we're not animating on an externally-provided `MotionValue` we can use the
            // component's animation controls which will handle interactions with whileHover (etc),
            // otherwise we just have to animate the `MotionValue` itself.
            return this.startAxisValueAnimation(axis, inertia);
        });
        // Run all animations and then resolve the new drag constraints.
        return Promise.all(momentumAnimations).then(onDragTransitionEnd);
    }
    startAxisValueAnimation(axis, transition) {
        const axisValue = this.getAxisMotionValue(axis);
        (0, _motionDom.addValueToWillChange)(this.visualElement, axis);
        return axisValue.start((0, _motionDom.animateMotionValue)(axis, axisValue, 0, transition, this.visualElement, false));
    }
    stopAnimation() {
        (0, _motionDom.eachAxis)((axis)=>this.getAxisMotionValue(axis).stop());
    }
    /**
     * Drag works differently depending on which props are provided.
     *
     * - If _dragX and _dragY are provided, we output the gesture delta directly to those motion values.
     * - Otherwise, we apply the delta to the x/y motion values.
     */ getAxisMotionValue(axis) {
        const dragKey = `_drag${axis.toUpperCase()}`;
        const props = this.visualElement.getProps();
        const externalMotionValue = props[dragKey];
        return externalMotionValue ? externalMotionValue : this.visualElement.getValue(axis, (props.initial ? props.initial[axis] : undefined) || 0);
    }
    snapToCursor(point) {
        (0, _motionDom.eachAxis)((axis)=>{
            const { drag } = this.getProps();
            // If we're not dragging this axis, do an early return.
            if (!shouldDrag(axis, drag, this.currentDirection)) return;
            const { projection } = this.visualElement;
            const axisValue = this.getAxisMotionValue(axis);
            if (projection && projection.layout) {
                const { min, max } = projection.layout.layoutBox[axis];
                /**
                 * The layout measurement includes the current transform value,
                 * so we need to add it back to get the correct snap position.
                 * This fixes an issue where elements with initial coordinates
                 * would snap to the wrong position on the first drag.
                 */ const current = axisValue.get() || 0;
                axisValue.set(point[axis] - (0, _motionDom.mixNumber)(min, max, 0.5) + current);
            }
        });
    }
    /**
     * When the viewport resizes we want to check if the measured constraints
     * have changed and, if so, reposition the element within those new constraints
     * relative to where it was before the resize.
     */ scalePositionWithinConstraints() {
        if (!this.visualElement.current) return;
        const { drag, dragConstraints } = this.getProps();
        const { projection } = this.visualElement;
        if (!(0, _isRefObjectMjs.isRefObject)(dragConstraints) || !projection || !this.constraints) return;
        /**
         * Stop current animations as there can be visual glitching if we try to do
         * this mid-animation
         */ this.stopAnimation();
        /**
         * Record the relative position of the dragged element relative to the
         * constraints box and save as a progress value.
         */ const boxProgress = {
            x: 0,
            y: 0
        };
        (0, _motionDom.eachAxis)((axis)=>{
            const axisValue = this.getAxisMotionValue(axis);
            if (axisValue && this.constraints !== false) {
                const latest = axisValue.get();
                boxProgress[axis] = (0, _constraintsMjs.calcOrigin)({
                    min: latest,
                    max: latest
                }, this.constraints[axis]);
            }
        });
        /**
         * Update the layout of this element and resolve the latest drag constraints
         */ const { transformTemplate } = this.visualElement.getProps();
        this.visualElement.current.style.transform = transformTemplate ? transformTemplate({}, "") : "none";
        projection.root && projection.root.updateScroll();
        projection.updateLayout();
        /**
         * Reset constraints so resolveConstraints() will recalculate them
         * with the freshly measured layout rather than returning the cached value.
         */ this.constraints = false;
        this.resolveConstraints();
        /**
         * For each axis, calculate the current progress of the layout axis
         * within the new constraints.
         */ (0, _motionDom.eachAxis)((axis)=>{
            if (!shouldDrag(axis, drag, null)) return;
            /**
             * Calculate a new transform based on the previous box progress
             */ const axisValue = this.getAxisMotionValue(axis);
            const { min, max } = this.constraints[axis];
            axisValue.set((0, _motionDom.mixNumber)(min, max, boxProgress[axis]));
        });
        /**
         * Flush the updated transform to the DOM synchronously to prevent
         * a visual flash at the element's CSS layout position (0,0) when
         * the transform was stripped for measurement.
         */ this.visualElement.render();
    }
    addListeners() {
        if (!this.visualElement.current) return;
        elementDragControls.set(this.visualElement, this);
        const element = this.visualElement.current;
        /**
         * Attach a pointerdown event listener on this DOM element to initiate drag tracking.
         */ const stopPointerListener = (0, _addPointerEventMjs.addPointerEvent)(element, "pointerdown", (event)=>{
            const { drag, dragListener = true } = this.getProps();
            const target = event.target;
            /**
             * Only block drag if clicking on a text input child element
             * (input, textarea, select, contenteditable) where users might
             * want to select text or interact with the control.
             *
             * Buttons and links don't block drag since they don't have
             * click-and-move actions of their own.
             */ const isClickingTextInputChild = target !== element && (0, _motionDom.isElementTextInput)(target);
            if (drag && dragListener && !isClickingTextInputChild) this.start(event);
        });
        /**
         * If using ref-based constraints, observe both the draggable element
         * and the constraint container for size changes via ResizeObserver.
         * Setup is deferred because dragConstraints.current is null when
         * addListeners first runs (React hasn't committed the ref yet).
         */ let stopResizeObservers;
        const measureDragConstraints = ()=>{
            const { dragConstraints } = this.getProps();
            if ((0, _isRefObjectMjs.isRefObject)(dragConstraints) && dragConstraints.current) {
                this.constraints = this.resolveRefConstraints();
                if (!stopResizeObservers) stopResizeObservers = startResizeObservers(element, dragConstraints.current, ()=>this.scalePositionWithinConstraints());
            }
        };
        const { projection } = this.visualElement;
        const stopMeasureLayoutListener = projection.addEventListener("measure", measureDragConstraints);
        if (projection && !projection.layout) {
            projection.root && projection.root.updateScroll();
            projection.updateLayout();
        }
        (0, _motionDom.frame).read(measureDragConstraints);
        /**
         * Attach a window resize listener to scale the draggable target within its defined
         * constraints as the window resizes.
         */ const stopResizeListener = (0, _motionDom.addDomEvent)(window, "resize", ()=>this.scalePositionWithinConstraints());
        /**
         * If the element's layout changes, calculate the delta and apply that to
         * the drag gesture's origin point.
         */ const stopLayoutUpdateListener = projection.addEventListener("didUpdate", ({ delta, hasLayoutChanged })=>{
            if (this.isDragging && hasLayoutChanged) {
                (0, _motionDom.eachAxis)((axis)=>{
                    const motionValue = this.getAxisMotionValue(axis);
                    if (!motionValue) return;
                    this.originPoint[axis] += delta[axis].translate;
                    motionValue.set(motionValue.get() + delta[axis].translate);
                });
                this.visualElement.render();
            }
        });
        return ()=>{
            stopResizeListener();
            stopPointerListener();
            stopMeasureLayoutListener();
            stopLayoutUpdateListener && stopLayoutUpdateListener();
            stopResizeObservers && stopResizeObservers();
        };
    }
    getProps() {
        const props = this.visualElement.getProps();
        const { drag = false, dragDirectionLock = false, dragPropagation = false, dragConstraints = false, dragElastic = (0, _constraintsMjs.defaultElastic), dragMomentum = true } = props;
        return {
            ...props,
            drag,
            dragDirectionLock,
            dragPropagation,
            dragConstraints,
            dragElastic,
            dragMomentum
        };
    }
}
function skipFirstCall(callback) {
    let isFirst = true;
    return ()=>{
        if (isFirst) {
            isFirst = false;
            return;
        }
        callback();
    };
}
function startResizeObservers(element, constraintsElement, onResize) {
    const stopElement = (0, _motionDom.resize)(element, skipFirstCall(onResize));
    const stopContainer = (0, _motionDom.resize)(constraintsElement, skipFirstCall(onResize));
    return ()=>{
        stopElement();
        stopContainer();
    };
}
function shouldDrag(direction, drag, currentDirection) {
    return (drag === true || drag === direction) && (currentDirection === null || currentDirection === direction);
}
/**
 * Based on an x/y offset determine the current drag direction. If both axis' offsets are lower
 * than the provided threshold, return `null`.
 *
 * @param offset - The x/y offset from origin.
 * @param lockThreshold - (Optional) - the minimum absolute offset before we can determine a drag direction.
 */ function getCurrentDirection(offset, lockThreshold = 10) {
    let direction = null;
    if (Math.abs(offset.y) > lockThreshold) direction = "y";
    else if (Math.abs(offset.x) > lockThreshold) direction = "x";
    return direction;
}

},{"motion-dom":[["addDomEvent","e11Be"],["addValueToWillChange","fVkj9"],["animateMotionValue","5NoWL"],["calcLength","fywoX"],["convertBoundingBoxToBox","iGSIB"],["convertBoxToBoundingBox","iGSIB"],["createBox","5H0uu"],["eachAxis","6q1eY"],["frame","4c192"],["isElementTextInput","kU60h"],["measurePageBox","jzMhe"],["mixNumber","91GSx"],["percent","aXLZR"],["resize","3FQRk"],["setDragLock","IpnbG"]],"motion-utils":"588wx","../../events/add-pointer-event.mjs":"7K50n","../../events/event-info.mjs":"k9t8Z","../../utils/get-context-window.mjs":"h04s9","../../utils/is-ref-object.mjs":"7C36g","../pan/PanSession.mjs":"gGujP","./utils/constraints.mjs":"lN2W4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7K50n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addPointerEvent", ()=>addPointerEvent);
var _motionDom = require("motion-dom");
var _eventInfoMjs = require("./event-info.mjs");
function addPointerEvent(target, eventName, handler, options) {
    return (0, _motionDom.addDomEvent)(target, eventName, (0, _eventInfoMjs.addPointerInfo)(handler), options);
}

},{"motion-dom":"e11Be","./event-info.mjs":"k9t8Z","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k9t8Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addPointerInfo", ()=>addPointerInfo);
parcelHelpers.export(exports, "extractEventInfo", ()=>extractEventInfo);
var _motionDom = require("motion-dom");
function extractEventInfo(event) {
    return {
        point: {
            x: event.pageX,
            y: event.pageY
        }
    };
}
const addPointerInfo = (handler)=>(event)=>(0, _motionDom.isPrimaryPointer)(event) && handler(event, extractEventInfo(event));

},{"motion-dom":"5ALZe","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h04s9":[function(require,module,exports,__globalThis) {
// Fixes https://github.com/motiondivision/motion/issues/2270
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getContextWindow", ()=>getContextWindow);
const getContextWindow = ({ current })=>{
    return current ? current.ownerDocument.defaultView : null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gGujP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanSession", ()=>PanSession);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _addPointerEventMjs = require("../../events/add-pointer-event.mjs");
var _eventInfoMjs = require("../../events/event-info.mjs");
var _distanceMjs = require("../../utils/distance.mjs");
const overflowStyles = /*#__PURE__*/ new Set([
    "auto",
    "scroll"
]);
/**
 * @internal
 */ class PanSession {
    constructor(event, handlers, { transformPagePoint, contextWindow = window, dragSnapToOrigin = false, distanceThreshold = 3, element } = {}){
        /**
         * @internal
         */ this.startEvent = null;
        /**
         * @internal
         */ this.lastMoveEvent = null;
        /**
         * @internal
         */ this.lastMoveEventInfo = null;
        /**
         * Raw (untransformed) event info, re-transformed each frame
         * so transformPagePoint sees the current parent matrix.
         * @internal
         */ this.lastRawMoveEventInfo = null;
        /**
         * @internal
         */ this.handlers = {};
        /**
         * @internal
         */ this.contextWindow = window;
        /**
         * Scroll positions of scrollable ancestors and window.
         * @internal
         */ this.scrollPositions = new Map();
        /**
         * Cleanup function for scroll listeners.
         * @internal
         */ this.removeScrollListeners = null;
        this.onElementScroll = (event)=>{
            this.handleScroll(event.target);
        };
        this.onWindowScroll = ()=>{
            this.handleScroll(window);
        };
        this.updatePoint = ()=>{
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            // Re-transform raw point through current transformPagePoint so
            // animated parent transforms (e.g. rotation) are picked up each frame
            if (this.lastRawMoveEventInfo) this.lastMoveEventInfo = transformPoint(this.lastRawMoveEventInfo, this.transformPagePoint);
            const info = getPanInfo(this.lastMoveEventInfo, this.history);
            const isPanStarted = this.startEvent !== null;
            // Only start panning if the offset is larger than 3 pixels. If we make it
            // any larger than this we'll want to reset the pointer history
            // on the first update to avoid visual snapping to the cursor.
            const isDistancePastThreshold = (0, _distanceMjs.distance2D)(info.offset, {
                x: 0,
                y: 0
            }) >= this.distanceThreshold;
            if (!isPanStarted && !isDistancePastThreshold) return;
            const { point } = info;
            const { timestamp } = (0, _motionDom.frameData);
            this.history.push({
                ...point,
                timestamp
            });
            const { onStart, onMove } = this.handlers;
            if (!isPanStarted) {
                onStart && onStart(this.lastMoveEvent, info);
                this.startEvent = this.lastMoveEvent;
            }
            onMove && onMove(this.lastMoveEvent, info);
        };
        this.handlePointerMove = (event, info)=>{
            this.lastMoveEvent = event;
            this.lastRawMoveEventInfo = info;
            this.lastMoveEventInfo = transformPoint(info, this.transformPagePoint);
            // Throttle mouse move event to once per frame
            (0, _motionDom.frame).update(this.updatePoint, true);
        };
        this.handlePointerUp = (event, info)=>{
            this.end();
            const { onEnd, onSessionEnd, resumeAnimation } = this.handlers;
            // Resume animation if dragSnapToOrigin is set OR if no drag started (user just clicked)
            // This ensures constraint animations continue when interrupted by a click
            if (this.dragSnapToOrigin || !this.startEvent) resumeAnimation && resumeAnimation();
            if (!(this.lastMoveEvent && this.lastMoveEventInfo)) return;
            const panInfo = getPanInfo(event.type === "pointercancel" ? this.lastMoveEventInfo : transformPoint(info, this.transformPagePoint), this.history);
            if (this.startEvent && onEnd) onEnd(event, panInfo);
            onSessionEnd && onSessionEnd(event, panInfo);
        };
        // If we have more than one touch, don't start detecting this gesture
        if (!(0, _motionDom.isPrimaryPointer)(event)) return;
        this.dragSnapToOrigin = dragSnapToOrigin;
        this.handlers = handlers;
        this.transformPagePoint = transformPagePoint;
        this.distanceThreshold = distanceThreshold;
        this.contextWindow = contextWindow || window;
        const info = (0, _eventInfoMjs.extractEventInfo)(event);
        const initialInfo = transformPoint(info, this.transformPagePoint);
        const { point } = initialInfo;
        const { timestamp } = (0, _motionDom.frameData);
        this.history = [
            {
                ...point,
                timestamp
            }
        ];
        const { onSessionStart } = handlers;
        onSessionStart && onSessionStart(event, getPanInfo(initialInfo, this.history));
        this.removeListeners = (0, _motionUtils.pipe)((0, _addPointerEventMjs.addPointerEvent)(this.contextWindow, "pointermove", this.handlePointerMove), (0, _addPointerEventMjs.addPointerEvent)(this.contextWindow, "pointerup", this.handlePointerUp), (0, _addPointerEventMjs.addPointerEvent)(this.contextWindow, "pointercancel", this.handlePointerUp));
        // Start scroll tracking if element provided
        if (element) this.startScrollTracking(element);
    }
    /**
     * Start tracking scroll on ancestors and window.
     */ startScrollTracking(element) {
        // Store initial scroll positions for scrollable ancestors
        let current = element.parentElement;
        while(current){
            const style = getComputedStyle(current);
            if (overflowStyles.has(style.overflowX) || overflowStyles.has(style.overflowY)) this.scrollPositions.set(current, {
                x: current.scrollLeft,
                y: current.scrollTop
            });
            current = current.parentElement;
        }
        // Track window scroll
        this.scrollPositions.set(window, {
            x: window.scrollX,
            y: window.scrollY
        });
        // Capture listener catches element scroll events as they bubble
        window.addEventListener("scroll", this.onElementScroll, {
            capture: true
        });
        // Direct window scroll listener (window scroll doesn't bubble)
        window.addEventListener("scroll", this.onWindowScroll);
        this.removeScrollListeners = ()=>{
            window.removeEventListener("scroll", this.onElementScroll, {
                capture: true
            });
            window.removeEventListener("scroll", this.onWindowScroll);
        };
    }
    /**
     * Handle scroll compensation during drag.
     *
     * For element scroll: adjusts history origin since pageX/pageY doesn't change.
     * For window scroll: adjusts lastMoveEventInfo since pageX/pageY would change.
     */ handleScroll(target) {
        const initial = this.scrollPositions.get(target);
        if (!initial) return;
        const isWindow = target === window;
        const current = isWindow ? {
            x: window.scrollX,
            y: window.scrollY
        } : {
            x: target.scrollLeft,
            y: target.scrollTop
        };
        const delta = {
            x: current.x - initial.x,
            y: current.y - initial.y
        };
        if (delta.x === 0 && delta.y === 0) return;
        if (isWindow) // Window scroll: pageX/pageY changes, so update lastMoveEventInfo
        {
            if (this.lastMoveEventInfo) {
                this.lastMoveEventInfo.point.x += delta.x;
                this.lastMoveEventInfo.point.y += delta.y;
            }
        } else // Element scroll: pageX/pageY unchanged, so adjust history origin
        if (this.history.length > 0) {
            this.history[0].x -= delta.x;
            this.history[0].y -= delta.y;
        }
        this.scrollPositions.set(target, current);
        (0, _motionDom.frame).update(this.updatePoint, true);
    }
    updateHandlers(handlers) {
        this.handlers = handlers;
    }
    end() {
        this.removeListeners && this.removeListeners();
        this.removeScrollListeners && this.removeScrollListeners();
        this.scrollPositions.clear();
        (0, _motionDom.cancelFrame)(this.updatePoint);
    }
}
function transformPoint(info, transformPagePoint) {
    return transformPagePoint ? {
        point: transformPagePoint(info.point)
    } : info;
}
function subtractPoint(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function getPanInfo({ point }, history) {
    return {
        point,
        delta: subtractPoint(point, lastDevicePoint(history)),
        offset: subtractPoint(point, startDevicePoint(history)),
        velocity: getVelocity(history, 0.1)
    };
}
function startDevicePoint(history) {
    return history[0];
}
function lastDevicePoint(history) {
    return history[history.length - 1];
}
function getVelocity(history, timeDelta) {
    if (history.length < 2) return {
        x: 0,
        y: 0
    };
    let i = history.length - 1;
    let timestampedPoint = null;
    const lastPoint = lastDevicePoint(history);
    while(i >= 0){
        timestampedPoint = history[i];
        if (lastPoint.timestamp - timestampedPoint.timestamp > (0, _motionUtils.secondsToMilliseconds)(timeDelta)) break;
        i--;
    }
    if (!timestampedPoint) return {
        x: 0,
        y: 0
    };
    /**
     * If the selected point is the pointer-down origin (history[0]),
     * there are better movement points available, and the time gap
     * is suspiciously large (>2x timeDelta), use the next point instead.
     * This prevents stale pointer-down points from diluting velocity
     * in hold-then-flick gestures.
     */ if (timestampedPoint === history[0] && history.length > 2 && lastPoint.timestamp - timestampedPoint.timestamp > (0, _motionUtils.secondsToMilliseconds)(timeDelta) * 2) timestampedPoint = history[1];
    const time = (0, _motionUtils.millisecondsToSeconds)(lastPoint.timestamp - timestampedPoint.timestamp);
    if (time === 0) return {
        x: 0,
        y: 0
    };
    const currentVelocity = {
        x: (lastPoint.x - timestampedPoint.x) / time,
        y: (lastPoint.y - timestampedPoint.y) / time
    };
    if (currentVelocity.x === Infinity) currentVelocity.x = 0;
    if (currentVelocity.y === Infinity) currentVelocity.y = 0;
    return currentVelocity;
}

},{"motion-dom":[["cancelFrame","4c192"],["frame","4c192"],["frameData","4c192"],["isPrimaryPointer","5ALZe"]],"motion-utils":[["millisecondsToSeconds","dIdtR"],["secondsToMilliseconds","dIdtR"],["pipe","lPgnn"]],"../../events/add-pointer-event.mjs":"7K50n","../../events/event-info.mjs":"k9t8Z","../../utils/distance.mjs":"bGpAg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bGpAg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "distance", ()=>distance);
parcelHelpers.export(exports, "distance2D", ()=>distance2D);
const distance = (a, b)=>Math.abs(a - b);
function distance2D(a, b) {
    // Multi-dimensional
    const xDelta = distance(a.x, b.x);
    const yDelta = distance(a.y, b.y);
    return Math.sqrt(xDelta ** 2 + yDelta ** 2);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lN2W4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "applyConstraints", ()=>applyConstraints);
parcelHelpers.export(exports, "calcOrigin", ()=>calcOrigin);
parcelHelpers.export(exports, "calcRelativeAxisConstraints", ()=>calcRelativeAxisConstraints);
parcelHelpers.export(exports, "calcRelativeConstraints", ()=>calcRelativeConstraints);
parcelHelpers.export(exports, "calcViewportAxisConstraints", ()=>calcViewportAxisConstraints);
parcelHelpers.export(exports, "calcViewportConstraints", ()=>calcViewportConstraints);
parcelHelpers.export(exports, "defaultElastic", ()=>defaultElastic);
parcelHelpers.export(exports, "rebaseAxisConstraints", ()=>rebaseAxisConstraints);
parcelHelpers.export(exports, "resolveAxisElastic", ()=>resolveAxisElastic);
parcelHelpers.export(exports, "resolveDragElastic", ()=>resolveDragElastic);
parcelHelpers.export(exports, "resolvePointElastic", ()=>resolvePointElastic);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
/**
 * Apply constraints to a point. These constraints are both physical along an
 * axis, and an elastic factor that determines how much to constrain the point
 * by if it does lie outside the defined parameters.
 */ function applyConstraints(point, { min, max }, elastic) {
    if (min !== undefined && point < min) // If we have a min point defined, and this is outside of that, constrain
    point = elastic ? (0, _motionDom.mixNumber)(min, point, elastic.min) : Math.max(point, min);
    else if (max !== undefined && point > max) // If we have a max point defined, and this is outside of that, constrain
    point = elastic ? (0, _motionDom.mixNumber)(max, point, elastic.max) : Math.min(point, max);
    return point;
}
/**
 * Calculate constraints in terms of the viewport when defined relatively to the
 * measured axis. This is measured from the nearest edge, so a max constraint of 200
 * on an axis with a max value of 300 would return a constraint of 500 - axis length
 */ function calcRelativeAxisConstraints(axis, min, max) {
    return {
        min: min !== undefined ? axis.min + min : undefined,
        max: max !== undefined ? axis.max + max - (axis.max - axis.min) : undefined
    };
}
/**
 * Calculate constraints in terms of the viewport when
 * defined relatively to the measured bounding box.
 */ function calcRelativeConstraints(layoutBox, { top, left, bottom, right }) {
    return {
        x: calcRelativeAxisConstraints(layoutBox.x, left, right),
        y: calcRelativeAxisConstraints(layoutBox.y, top, bottom)
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative axis
 */ function calcViewportAxisConstraints(layoutAxis, constraintsAxis) {
    let min = constraintsAxis.min - layoutAxis.min;
    let max = constraintsAxis.max - layoutAxis.max;
    // If the constraints axis is actually smaller than the layout axis then we can
    // flip the constraints
    if (constraintsAxis.max - constraintsAxis.min < layoutAxis.max - layoutAxis.min) [min, max] = [
        max,
        min
    ];
    return {
        min,
        max
    };
}
/**
 * Calculate viewport constraints when defined as another viewport-relative box
 */ function calcViewportConstraints(layoutBox, constraintsBox) {
    return {
        x: calcViewportAxisConstraints(layoutBox.x, constraintsBox.x),
        y: calcViewportAxisConstraints(layoutBox.y, constraintsBox.y)
    };
}
/**
 * Calculate a transform origin relative to the source axis, between 0-1, that results
 * in an asthetically pleasing scale/transform needed to project from source to target.
 */ function calcOrigin(source, target) {
    let origin = 0.5;
    const sourceLength = (0, _motionDom.calcLength)(source);
    const targetLength = (0, _motionDom.calcLength)(target);
    if (targetLength > sourceLength) origin = (0, _motionUtils.progress)(target.min, target.max - sourceLength, source.min);
    else if (sourceLength > targetLength) origin = (0, _motionUtils.progress)(source.min, source.max - targetLength, target.min);
    return (0, _motionUtils.clamp)(0, 1, origin);
}
/**
 * Rebase the calculated viewport constraints relative to the layout.min point.
 */ function rebaseAxisConstraints(layout, constraints) {
    const relativeConstraints = {};
    if (constraints.min !== undefined) relativeConstraints.min = constraints.min - layout.min;
    if (constraints.max !== undefined) relativeConstraints.max = constraints.max - layout.min;
    return relativeConstraints;
}
const defaultElastic = 0.35;
/**
 * Accepts a dragElastic prop and returns resolved elastic values for each axis.
 */ function resolveDragElastic(dragElastic = defaultElastic) {
    if (dragElastic === false) dragElastic = 0;
    else if (dragElastic === true) dragElastic = defaultElastic;
    return {
        x: resolveAxisElastic(dragElastic, "left", "right"),
        y: resolveAxisElastic(dragElastic, "top", "bottom")
    };
}
function resolveAxisElastic(dragElastic, minLabel, maxLabel) {
    return {
        min: resolvePointElastic(dragElastic, minLabel),
        max: resolvePointElastic(dragElastic, maxLabel)
    };
}
function resolvePointElastic(dragElastic, label) {
    return typeof dragElastic === "number" ? dragElastic : dragElastic[label] || 0;
}

},{"motion-dom":[["calcLength","fywoX"],["mixNumber","91GSx"]],"motion-utils":[["clamp","b78W4"],["progress","6Q1yP"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"htzn9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PanGesture", ()=>PanGesture);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
var _addPointerEventMjs = require("../../events/add-pointer-event.mjs");
var _getContextWindowMjs = require("../../utils/get-context-window.mjs");
var _panSessionMjs = require("./PanSession.mjs");
const asyncHandler = (handler)=>(event, info)=>{
        if (handler) (0, _motionDom.frame).update(()=>handler(event, info), false, true);
    };
class PanGesture extends (0, _motionDom.Feature) {
    constructor(){
        super(...arguments);
        this.removePointerDownListener = (0, _motionUtils.noop);
    }
    onPointerDown(pointerDownEvent) {
        this.session = new (0, _panSessionMjs.PanSession)(pointerDownEvent, this.createPanHandlers(), {
            transformPagePoint: this.node.getTransformPagePoint(),
            contextWindow: (0, _getContextWindowMjs.getContextWindow)(this.node)
        });
    }
    createPanHandlers() {
        const { onPanSessionStart, onPanStart, onPan, onPanEnd } = this.node.getProps();
        return {
            onSessionStart: asyncHandler(onPanSessionStart),
            onStart: asyncHandler(onPanStart),
            onMove: asyncHandler(onPan),
            onEnd: (event, info)=>{
                delete this.session;
                if (onPanEnd) (0, _motionDom.frame).postRender(()=>onPanEnd(event, info));
            }
        };
    }
    mount() {
        this.removePointerDownListener = (0, _addPointerEventMjs.addPointerEvent)(this.node.current, "pointerdown", (event)=>this.onPointerDown(event));
    }
    update() {
        this.session && this.session.updateHandlers(this.createPanHandlers());
    }
    unmount() {
        this.removePointerDownListener();
        this.session && this.session.end();
    }
}

},{"motion-dom":[["Feature","2NZnJ"],["frame","4c192"]],"motion-utils":"1tDyg","../../events/add-pointer-event.mjs":"7K50n","../../utils/get-context-window.mjs":"h04s9","./PanSession.mjs":"gGujP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"47rO5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MeasureLayout", ()=>MeasureLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _motionDom = require("motion-dom");
var _react = require("react");
var _usePresenceMjs = require("../../../components/AnimatePresence/use-presence.mjs");
var _layoutGroupContextMjs = require("../../../context/LayoutGroupContext.mjs");
var _switchLayoutGroupContextMjs = require("../../../context/SwitchLayoutGroupContext.mjs");
"use client";
/**
 * Track whether we've taken any snapshots yet. If not,
 * we can safely skip notification of didUpdate.
 *
 * Difficult to capture in a test but to prevent flickering
 * we must set this to true either on update or unmount.
 * Running `next-env/layout-id` in Safari will show this behaviour if broken.
 */ let hasTakenAnySnapshot = false;
class MeasureLayoutWithContext extends (0, _react.Component) {
    /**
     * This only mounts projection nodes for components that
     * need measuring, we might want to do it for all components
     * in order to incorporate transforms
     */ componentDidMount() {
        const { visualElement, layoutGroup, switchLayoutGroup, layoutId } = this.props;
        const { projection } = visualElement;
        if (projection) {
            if (layoutGroup.group) layoutGroup.group.add(projection);
            if (switchLayoutGroup && switchLayoutGroup.register && layoutId) switchLayoutGroup.register(projection);
            if (hasTakenAnySnapshot) projection.root.didUpdate();
            projection.addEventListener("animationComplete", ()=>{
                this.safeToRemove();
            });
            projection.setOptions({
                ...projection.options,
                layoutDependency: this.props.layoutDependency,
                onExitComplete: ()=>this.safeToRemove()
            });
        }
        (0, _motionDom.globalProjectionState).hasEverUpdated = true;
    }
    getSnapshotBeforeUpdate(prevProps) {
        const { layoutDependency, visualElement, drag, isPresent } = this.props;
        const { projection } = visualElement;
        if (!projection) return null;
        /**
         * TODO: We use this data in relegate to determine whether to
         * promote a previous element. There's no guarantee its presence data
         * will have updated by this point - if a bug like this arises it will
         * have to be that we markForRelegation and then find a new lead some other way,
         * perhaps in didUpdate
         */ projection.isPresent = isPresent;
        if (prevProps.layoutDependency !== layoutDependency) projection.setOptions({
            ...projection.options,
            layoutDependency
        });
        hasTakenAnySnapshot = true;
        if (drag || prevProps.layoutDependency !== layoutDependency || layoutDependency === undefined || prevProps.isPresent !== isPresent) projection.willUpdate();
        else this.safeToRemove();
        if (prevProps.isPresent !== isPresent) {
            if (isPresent) projection.promote();
            else if (!projection.relegate()) /**
                 * If there's another stack member taking over from this one,
                 * it's in charge of the exit animation and therefore should
                 * be in charge of the safe to remove. Otherwise we call it here.
                 */ (0, _motionDom.frame).postRender(()=>{
                const stack = projection.getStack();
                if (!stack || !stack.members.length) this.safeToRemove();
            });
        }
        return null;
    }
    componentDidUpdate() {
        const { visualElement, layoutAnchor } = this.props;
        const { projection } = visualElement;
        if (projection) {
            projection.options.layoutAnchor = layoutAnchor;
            projection.root.didUpdate();
            (0, _motionDom.microtask).postRender(()=>{
                if (!projection.currentAnimation && projection.isLead()) this.safeToRemove();
            });
        }
    }
    componentWillUnmount() {
        const { visualElement, layoutGroup, switchLayoutGroup: promoteContext } = this.props;
        const { projection } = visualElement;
        hasTakenAnySnapshot = true;
        if (projection) {
            projection.scheduleCheckAfterUnmount();
            if (layoutGroup && layoutGroup.group) layoutGroup.group.remove(projection);
            if (promoteContext && promoteContext.deregister) promoteContext.deregister(projection);
        }
    }
    safeToRemove() {
        const { safeToRemove } = this.props;
        safeToRemove && safeToRemove();
    }
    render() {
        return null;
    }
}
function MeasureLayout(props) {
    const [isPresent, safeToRemove] = (0, _usePresenceMjs.usePresence)();
    const layoutGroup = (0, _react.useContext)((0, _layoutGroupContextMjs.LayoutGroupContext));
    return (0, _jsxRuntime.jsx)(MeasureLayoutWithContext, {
        ...props,
        layoutGroup: layoutGroup,
        switchLayoutGroup: (0, _react.useContext)((0, _switchLayoutGroupContextMjs.SwitchLayoutGroupContext)),
        isPresent: isPresent,
        safeToRemove: safeToRemove
    });
}

},{"react/jsx-runtime":"gonF6","motion-dom":[["frame","4c192"],["globalProjectionState","iPZeA"],["microtask","7uR6H"]],"react":"bmhQu","../../../components/AnimatePresence/use-presence.mjs":"2qRef","../../../context/LayoutGroupContext.mjs":"6GAWV","../../../context/SwitchLayoutGroupContext.mjs":"eSdvu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"GWBKF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "gestureAnimations", ()=>gestureAnimations);
var _hoverMjs = require("../../gestures/hover.mjs");
var _focusMjs = require("../../gestures/focus.mjs");
var _pressMjs = require("../../gestures/press.mjs");
var _indexMjs = require("./viewport/index.mjs");
const gestureAnimations = {
    inView: {
        Feature: (0, _indexMjs.InViewFeature)
    },
    tap: {
        Feature: (0, _pressMjs.PressGesture)
    },
    focus: {
        Feature: (0, _focusMjs.FocusGesture)
    },
    hover: {
        Feature: (0, _hoverMjs.HoverGesture)
    }
};

},{"../../gestures/hover.mjs":"lp3Pd","../../gestures/focus.mjs":"jHC8c","../../gestures/press.mjs":"eOzv9","./viewport/index.mjs":"cJ4pb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lp3Pd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HoverGesture", ()=>HoverGesture);
var _motionDom = require("motion-dom");
var _eventInfoMjs = require("../events/event-info.mjs");
function handleHoverEvent(node, event, lifecycle) {
    const { props } = node;
    if (node.animationState && props.whileHover) node.animationState.setActive("whileHover", lifecycle === "Start");
    const eventName = "onHover" + lifecycle;
    const callback = props[eventName];
    if (callback) (0, _motionDom.frame).postRender(()=>callback(event, (0, _eventInfoMjs.extractEventInfo)(event)));
}
class HoverGesture extends (0, _motionDom.Feature) {
    mount() {
        const { current } = this.node;
        if (!current) return;
        this.unmount = (0, _motionDom.hover)(current, (_element, startEvent)=>{
            handleHoverEvent(this.node, startEvent, "Start");
            return (endEvent)=>handleHoverEvent(this.node, endEvent, "End");
        });
    }
    unmount() {}
}

},{"motion-dom":[["Feature","2NZnJ"],["frame","4c192"],["hover","4tYFv"]],"../events/event-info.mjs":"k9t8Z","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jHC8c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusGesture", ()=>FocusGesture);
var _motionDom = require("motion-dom");
var _motionUtils = require("motion-utils");
class FocusGesture extends (0, _motionDom.Feature) {
    constructor(){
        super(...arguments);
        this.isActive = false;
    }
    onFocus() {
        let isFocusVisible = false;
        /**
         * If this element doesn't match focus-visible then don't
         * apply whileHover. But, if matches throws that focus-visible
         * is not a valid selector then in that browser outline styles will be applied
         * to the element by default and we want to match that behaviour with whileFocus.
         */ try {
            isFocusVisible = this.node.current.matches(":focus-visible");
        } catch (e) {
            isFocusVisible = true;
        }
        if (!isFocusVisible || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", true);
        this.isActive = true;
    }
    onBlur() {
        if (!this.isActive || !this.node.animationState) return;
        this.node.animationState.setActive("whileFocus", false);
        this.isActive = false;
    }
    mount() {
        this.unmount = (0, _motionUtils.pipe)((0, _motionDom.addDomEvent)(this.node.current, "focus", ()=>this.onFocus()), (0, _motionDom.addDomEvent)(this.node.current, "blur", ()=>this.onBlur()));
    }
    unmount() {}
}

},{"motion-dom":[["addDomEvent","e11Be"],["Feature","2NZnJ"]],"motion-utils":"lPgnn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eOzv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PressGesture", ()=>PressGesture);
var _motionDom = require("motion-dom");
var _eventInfoMjs = require("../events/event-info.mjs");
function handlePressEvent(node, event, lifecycle) {
    const { props } = node;
    if (node.current instanceof HTMLButtonElement && node.current.disabled) return;
    if (node.animationState && props.whileTap) node.animationState.setActive("whileTap", lifecycle === "Start");
    const eventName = "onTap" + (lifecycle === "End" ? "" : lifecycle);
    const callback = props[eventName];
    if (callback) (0, _motionDom.frame).postRender(()=>callback(event, (0, _eventInfoMjs.extractEventInfo)(event)));
}
class PressGesture extends (0, _motionDom.Feature) {
    mount() {
        const { current } = this.node;
        if (!current) return;
        const { globalTapTarget, propagate } = this.node.props;
        this.unmount = (0, _motionDom.press)(current, (_element, startEvent)=>{
            handlePressEvent(this.node, startEvent, "Start");
            return (endEvent, { success })=>handlePressEvent(this.node, endEvent, success ? "End" : "Cancel");
        }, {
            useGlobalTarget: globalTapTarget,
            stopPropagation: propagate?.tap === false
        });
    }
    unmount() {}
}

},{"motion-dom":[["Feature","2NZnJ"],["frame","4c192"],["press","8GlfC"]],"../events/event-info.mjs":"k9t8Z","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cJ4pb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InViewFeature", ()=>InViewFeature);
var _motionDom = require("motion-dom");
var _observersMjs = require("./observers.mjs");
const thresholdNames = {
    some: 0,
    all: 1
};
class InViewFeature extends (0, _motionDom.Feature) {
    constructor(){
        super(...arguments);
        this.hasEnteredView = false;
        this.isInView = false;
    }
    startObserver() {
        this.stopObserver?.();
        const { viewport = {} } = this.node.getProps();
        const { root, margin: rootMargin, amount = "some", once } = viewport;
        const options = {
            root: root ? root.current : undefined,
            rootMargin,
            threshold: typeof amount === "number" ? amount : thresholdNames[amount]
        };
        const onIntersectionUpdate = (entry)=>{
            const { isIntersecting } = entry;
            /**
             * If there's been no change in the viewport state, early return.
             */ if (this.isInView === isIntersecting) return;
            this.isInView = isIntersecting;
            /**
             * Handle hasEnteredView. If this is only meant to run once, and
             * element isn't visible, early return. Otherwise set hasEnteredView to true.
             */ if (once && !isIntersecting && this.hasEnteredView) return;
            else if (isIntersecting) this.hasEnteredView = true;
            if (this.node.animationState) this.node.animationState.setActive("whileInView", isIntersecting);
            /**
             * Use the latest committed props rather than the ones in scope
             * when this observer is created
             */ const { onViewportEnter, onViewportLeave } = this.node.getProps();
            const callback = isIntersecting ? onViewportEnter : onViewportLeave;
            callback && callback(entry);
        };
        this.stopObserver = (0, _observersMjs.observeIntersection)(this.node.current, options, onIntersectionUpdate);
    }
    mount() {
        this.startObserver();
    }
    update() {
        if (typeof IntersectionObserver === "undefined") return;
        const { props, prevProps } = this.node;
        const hasOptionsChanged = [
            "amount",
            "margin",
            "root"
        ].some(hasViewportOptionChanged(props, prevProps));
        if (hasOptionsChanged) this.startObserver();
    }
    unmount() {
        this.stopObserver?.();
        this.hasEnteredView = false;
        this.isInView = false;
    }
}
function hasViewportOptionChanged({ viewport = {} }, { viewport: prevViewport = {} } = {}) {
    return (name)=>viewport[name] !== prevViewport[name];
}

},{"motion-dom":"2NZnJ","./observers.mjs":"bOBTc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bOBTc":[function(require,module,exports,__globalThis) {
/**
 * Map an IntersectionHandler callback to an element. We only ever make one handler for one
 * element, so even though these handlers might all be triggered by different
 * observers, we can keep them in the same map.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "observeIntersection", ()=>observeIntersection);
const observerCallbacks = new WeakMap();
/**
 * Multiple observers can be created for multiple element/document roots. Each with
 * different settings. So here we store dictionaries of observers to each root,
 * using serialised settings (threshold/margin) as lookup keys.
 */ const observers = new WeakMap();
const fireObserverCallback = (entry)=>{
    const callback = observerCallbacks.get(entry.target);
    callback && callback(entry);
};
const fireAllObserverCallbacks = (entries)=>{
    entries.forEach(fireObserverCallback);
};
function initIntersectionObserver({ root, ...options }) {
    const lookupRoot = root || document;
    /**
     * If we don't have an observer lookup map for this root, create one.
     */ if (!observers.has(lookupRoot)) observers.set(lookupRoot, {});
    const rootObservers = observers.get(lookupRoot);
    const key = JSON.stringify(options);
    /**
     * If we don't have an observer for this combination of root and settings,
     * create one.
     */ if (!rootObservers[key]) rootObservers[key] = new IntersectionObserver(fireAllObserverCallbacks, {
        root,
        ...options
    });
    return rootObservers[key];
}
function observeIntersection(element, options, callback) {
    const rootInteresectionObserver = initIntersectionObserver(options);
    observerCallbacks.set(element, callback);
    rootInteresectionObserver.observe(element);
    return ()=>{
        observerCallbacks.delete(element);
        rootInteresectionObserver.unobserve(element);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bUUEG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "layout", ()=>layout);
var _motionDom = require("motion-dom");
var _measureLayoutMjs = require("./layout/MeasureLayout.mjs");
const layout = {
    layout: {
        ProjectionNode: (0, _motionDom.HTMLProjectionNode),
        MeasureLayout: (0, _measureLayoutMjs.MeasureLayout)
    }
};

},{"motion-dom":"2kn0n","./layout/MeasureLayout.mjs":"47rO5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iCqio":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _slider = require("@rc-component/slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _warning = require("../_util/warning");
var _context = require("../config-provider/context");
var _disabledContext = require("../config-provider/DisabledContext");
var _disabledContextDefault = parcelHelpers.interopDefault(_disabledContext);
var _context1 = require("./Context");
var _contextDefault = parcelHelpers.interopDefault(_context1);
var _sliderTooltip = require("./SliderTooltip");
var _sliderTooltipDefault = parcelHelpers.interopDefault(_sliderTooltip);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _useRafLock = require("./useRafLock");
var _useRafLockDefault = parcelHelpers.interopDefault(_useRafLock);
"use client";
function getTipFormatter(tipFormatter) {
    if (tipFormatter || tipFormatter === null) return tipFormatter;
    return (val)=>typeof val === 'number' ? val.toString() : '';
}
const Slider = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, range, className, rootClassName, style, disabled, // Deprecated Props
    tooltip = {}, onChangeComplete, classNames, styles, vertical, orientation, ...restProps } = props;
    const [, mergedVertical] = (0, _hooks.useOrientation)(orientation, vertical);
    const { getPrefixCls, direction: contextDirection, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, getPopupContainer } = (0, _context.useComponentConfig)('slider');
    const contextDisabled = (0, _reactDefault.default).useContext((0, _disabledContextDefault.default));
    const mergedDisabled = disabled ?? contextDisabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        disabled: mergedDisabled,
        vertical: mergedVertical
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ============================= Context ==============================
    const { handleRender: contextHandleRender, direction: internalContextDirection } = (0, _reactDefault.default).useContext((0, _contextDefault.default));
    const mergedDirection = internalContextDirection || contextDirection;
    const isRTL = mergedDirection === 'rtl';
    // =============================== Open ===============================
    const [hoverOpen, setHoverOpen] = (0, _useRafLockDefault.default)();
    const [focusOpen, setFocusOpen] = (0, _useRafLockDefault.default)();
    const tooltipProps = {
        ...tooltip
    };
    const { open: tooltipOpen, placement: tooltipPlacement, getPopupContainer: getTooltipPopupContainer, prefixCls: customizeTooltipPrefixCls, formatter: tipFormatter } = tooltipProps;
    const lockOpen = tooltipOpen;
    const activeOpen = (hoverOpen || focusOpen) && lockOpen !== false;
    const mergedTipFormatter = getTipFormatter(tipFormatter);
    // ============================= Change ==============================
    const [dragging, setDragging] = (0, _useRafLockDefault.default)();
    const onInternalChangeComplete = (nextValues)=>{
        onChangeComplete?.(nextValues);
        setDragging(false);
    };
    // ============================ Placement ============================
    const getTooltipPlacement = (placement, vert)=>{
        if (placement) return placement;
        if (!vert) return 'top';
        return isRTL ? 'left' : 'right';
    };
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('slider', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    const rootClassNames = (0, _clsx.clsx)(className, contextClassName, mergedClassNames.root, rootClassName, {
        [`${prefixCls}-rtl`]: isRTL,
        [`${prefixCls}-lock`]: dragging
    }, hashId, cssVarCls);
    // make reverse default on rtl direction
    if (isRTL && !mergedVertical) restProps.reverse = !restProps.reverse;
    var deprecatedName, newName;
    // ============================== Handle ==============================
    (0, _reactDefault.default).useEffect(()=>{
        const onMouseUp = ()=>{
            // Delay for 1 frame to make the click to enable hide tooltip
            // even when the handle is focused
            (0, _rafDefault.default)(()=>{
                setFocusOpen(false);
            }, 1);
        };
        document.addEventListener('mouseup', onMouseUp);
        return ()=>{
            document.removeEventListener('mouseup', onMouseUp);
        };
    }, []);
    const useActiveTooltipHandle = range && !lockOpen;
    const handleRender = contextHandleRender || ((node, info)=>{
        const { index } = info;
        const nodeProps = node.props;
        function proxyEvent(eventName, event, triggerRestPropsEvent) {
            if (triggerRestPropsEvent) restProps[eventName]?.(event);
            nodeProps[eventName]?.(event);
        }
        const passedProps = {
            ...nodeProps,
            onMouseEnter: (e)=>{
                setHoverOpen(true);
                proxyEvent('onMouseEnter', e);
            },
            onMouseLeave: (e)=>{
                setHoverOpen(false);
                proxyEvent('onMouseLeave', e);
            },
            onMouseDown: (e)=>{
                setFocusOpen(true);
                setDragging(true);
                proxyEvent('onMouseDown', e);
            },
            onFocus: (e)=>{
                setFocusOpen(true);
                restProps.onFocus?.(e);
                proxyEvent('onFocus', e, true);
            },
            onBlur: (e)=>{
                setFocusOpen(false);
                restProps.onBlur?.(e);
                proxyEvent('onBlur', e, true);
            }
        };
        const cloneNode = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(node, passedProps);
        const open = (!!lockOpen || activeOpen) && mergedTipFormatter !== null;
        // Wrap on handle with Tooltip when is single mode or multiple with all show tooltip
        if (!useActiveTooltipHandle) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sliderTooltipDefault.default), {
            ...tooltipProps,
            prefixCls: getPrefixCls('tooltip', customizeTooltipPrefixCls),
            title: mergedTipFormatter ? mergedTipFormatter(info.value) : '',
            value: info.value,
            open: open,
            placement: getTooltipPlacement(tooltipPlacement, mergedVertical),
            key: index,
            classNames: {
                root: `${prefixCls}-tooltip`
            },
            getPopupContainer: getTooltipPopupContainer || getPopupContainer
        }, cloneNode);
        return cloneNode;
    });
    // ========================== Active Handle ===========================
    const activeHandleRender = useActiveTooltipHandle ? (handle, info)=>{
        const cloneNode = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(handle, {
            style: {
                ...handle.props.style,
                visibility: 'hidden'
            }
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _sliderTooltipDefault.default), {
            ...tooltipProps,
            prefixCls: getPrefixCls('tooltip', customizeTooltipPrefixCls),
            title: mergedTipFormatter ? mergedTipFormatter(info.value) : '',
            open: mergedTipFormatter !== null && activeOpen,
            placement: getTooltipPlacement(tooltipPlacement, mergedVertical),
            key: "tooltip",
            classNames: {
                root: `${prefixCls}-tooltip`
            },
            getPopupContainer: getTooltipPopupContainer || getPopupContainer,
            draggingDelete: info.draggingDelete
        }, cloneNode);
    } : undefined;
    // ============================== Render ==============================
    const rootStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    return(/*#__PURE__*/ // @ts-ignore
    (0, _reactDefault.default).createElement((0, _sliderDefault.default), {
        ...restProps,
        classNames: mergedClassNames,
        styles: mergedStyles,
        step: restProps.step,
        range: range,
        className: rootClassNames,
        style: rootStyle,
        disabled: mergedDisabled,
        vertical: mergedVertical,
        ref: ref,
        prefixCls: prefixCls,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: onInternalChangeComplete
    }));
});
exports.default = Slider;

},{"react":"bmhQu","@rc-component/slider":"ickFr","@rc-component/util/es/raf":"ajbAx","clsx":"431Ou","../_util/hooks":[["useMergeSemantic","kdnMA"],["useOrientation","k313C"]],"../_util/warning":"95o3w","../config-provider/context":"75zwC","../config-provider/DisabledContext":"h4TcW","./Context":"bvtQ4","./SliderTooltip":"4SC5M","./style":"2r0ST","./useRafLock":"3aJnB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ickFr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnstableContext", ()=>(0, _context.UnstableContext));
var _slider = require("./Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
var _context = require("./context");
exports.default = (0, _sliderDefault.default);

},{"./Slider":"i1F4p","./context":"6x0AC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i1F4p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useControlledState = require("@rc-component/util/es/hooks/useControlledState");
var _useControlledStateDefault = parcelHelpers.interopDefault(_useControlledState);
var _useEvent = require("@rc-component/util/es/hooks/useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var _isEqual = require("@rc-component/util/es/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _clsx = require("clsx");
var _react = require("react");
var _handles = require("./Handles");
var _handlesDefault = parcelHelpers.interopDefault(_handles);
var _marks = require("./Marks");
var _marksDefault = parcelHelpers.interopDefault(_marks);
var _steps = require("./Steps");
var _stepsDefault = parcelHelpers.interopDefault(_steps);
var _tracks = require("./Tracks");
var _tracksDefault = parcelHelpers.interopDefault(_tracks);
var _context = require("./context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _useDrag = require("./hooks/useDrag");
var _useDragDefault = parcelHelpers.interopDefault(_useDrag);
var _useOffset = require("./hooks/useOffset");
var _useOffsetDefault = parcelHelpers.interopDefault(_useOffset);
var _useRange = require("./hooks/useRange");
var _useRangeDefault = parcelHelpers.interopDefault(_useRange);
/**
 * New:
 * - click mark to update range value
 * - handleRender
 * - Fix handle with count not correct
 * - Fix pushable not work in some case
 * - No more FindDOMNode
 * - Move all position related style into inline style
 * - Key: up is plus, down is minus
 * - fix Key with step = null not align with marks
 * - Change range should not trigger onChange
 * - keyboard support pushable
 */ const Slider = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls = 'rc-slider', className, style, classNames, styles, id, // Status
    disabled = false, keyboard = true, autoFocus, onFocus, onBlur, // Value
    min = 0, max = 100, step = 1, value, defaultValue, range, count, onChange, onBeforeChange, onAfterChange, onChangeComplete, // Cross
    allowCross = true, pushable = false, // Direction
    reverse, vertical, // Style
    included = true, startPoint, trackStyle, handleStyle, railStyle, dotStyle, activeDotStyle, // Decorations
    marks, dots, // Components
    handleRender, activeHandleRender, track, // Accessibility
    tabIndex = 0, ariaLabelForHandle, ariaLabelledByForHandle, ariaRequired, ariaValueTextFormatterForHandle } = props;
    const handlesRef = _react.useRef(null);
    const containerRef = _react.useRef(null);
    const direction = _react.useMemo(()=>{
        if (vertical) return reverse ? 'ttb' : 'btt';
        return reverse ? 'rtl' : 'ltr';
    }, [
        reverse,
        vertical
    ]);
    // ============================ Range =============================
    const [rangeEnabled, rangeEditable, rangeDraggableTrack, minCount, maxCount] = (0, _useRangeDefault.default)(range);
    const mergedMin = _react.useMemo(()=>isFinite(min) ? min : 0, [
        min
    ]);
    const mergedMax = _react.useMemo(()=>isFinite(max) ? max : 100, [
        max
    ]);
    // ============================= Step =============================
    const mergedStep = _react.useMemo(()=>step !== null && step <= 0 ? 1 : step, [
        step
    ]);
    // ============================= Push =============================
    const mergedPush = _react.useMemo(()=>{
        if (typeof pushable === 'boolean') return pushable ? mergedStep : false;
        return pushable >= 0 ? pushable : false;
    }, [
        pushable,
        mergedStep
    ]);
    // ============================ Marks =============================
    const markList = _react.useMemo(()=>{
        return Object.keys(marks || {}).map((key)=>{
            const mark = marks[key];
            const markObj = {
                value: Number(key)
            };
            if (mark && typeof mark === 'object' && !/*#__PURE__*/ _react.isValidElement(mark) && ('label' in mark || 'style' in mark)) {
                markObj.style = mark.style;
                markObj.label = mark.label;
            } else markObj.label = mark;
            return markObj;
        }).filter(({ label })=>label || typeof label === 'number').sort((a, b)=>a.value - b.value);
    }, [
        marks
    ]);
    // ============================ Format ============================
    const [formatValue, offsetValues] = (0, _useOffsetDefault.default)(mergedMin, mergedMax, mergedStep, markList, allowCross, mergedPush);
    // ============================ Values ============================
    const [mergedValue, setValue] = (0, _useControlledStateDefault.default)(defaultValue, value);
    const rawValues = _react.useMemo(()=>{
        const valueList = mergedValue === null || mergedValue === undefined ? [] : Array.isArray(mergedValue) ? mergedValue : [
            mergedValue
        ];
        const [val0 = mergedMin] = valueList;
        let returnValues = mergedValue === null ? [] : [
            val0
        ];
        // Format as range
        if (rangeEnabled) {
            returnValues = [
                ...valueList
            ];
            // When count provided or value is `undefined`, we fill values
            if (count || mergedValue === undefined) {
                const pointCount = count >= 0 ? count + 1 : 2;
                returnValues = returnValues.slice(0, pointCount);
                // Fill with count
                while(returnValues.length < pointCount)returnValues.push(returnValues[returnValues.length - 1] ?? mergedMin);
            }
            returnValues.sort((a, b)=>a - b);
        }
        // Align in range
        returnValues.forEach((val, index)=>{
            returnValues[index] = formatValue(val);
        });
        return returnValues;
    }, [
        mergedValue,
        rangeEnabled,
        mergedMin,
        count,
        formatValue
    ]);
    // =========================== onChange ===========================
    const getTriggerValue = (triggerValues)=>rangeEnabled ? triggerValues : triggerValues[0];
    const triggerChange = (0, _useEventDefault.default)((nextValues)=>{
        // Order first
        const cloneNextValues = [
            ...nextValues
        ].sort((a, b)=>a - b);
        // Trigger event if needed
        if (onChange && !(0, _isEqualDefault.default)(cloneNextValues, rawValues, true)) onChange(getTriggerValue(cloneNextValues));
        // We set this later since it will re-render component immediately
        setValue(cloneNextValues);
    });
    const finishChange = (0, _useEventDefault.default)((draggingDelete)=>{
        // Trigger from `useDrag` will tell if it's a delete action
        if (draggingDelete) handlesRef.current.hideHelp();
        const finishValue = getTriggerValue(rawValues);
        onAfterChange?.(finishValue);
        (0, _warningDefault.default)(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
        onChangeComplete?.(finishValue);
    });
    const onDelete = (index)=>{
        if (disabled || !rangeEditable || rawValues.length <= minCount) return;
        const cloneNextValues = [
            ...rawValues
        ];
        cloneNextValues.splice(index, 1);
        onBeforeChange?.(getTriggerValue(cloneNextValues));
        triggerChange(cloneNextValues);
        const nextFocusIndex = Math.max(0, index - 1);
        handlesRef.current.hideHelp();
        handlesRef.current.focus(nextFocusIndex);
    };
    const [draggingIndex, draggingValue, draggingDelete, cacheValues, onStartDrag] = (0, _useDragDefault.default)(containerRef, direction, rawValues, mergedMin, mergedMax, formatValue, triggerChange, finishChange, offsetValues, rangeEditable, minCount);
    /**
   * When `rangeEditable` will insert a new value in the values array.
   * Else it will replace the value in the values array.
   */ const changeToCloseValue = (newValue, e)=>{
        if (!disabled) {
            // Create new values
            const cloneNextValues = [
                ...rawValues
            ];
            let valueIndex = 0;
            let valueBeforeIndex = 0; // Record the index which value < newValue
            let valueDist = mergedMax - mergedMin;
            rawValues.forEach((val, index)=>{
                const dist = Math.abs(newValue - val);
                if (dist <= valueDist) {
                    valueDist = dist;
                    valueIndex = index;
                }
                if (val < newValue) valueBeforeIndex = index;
            });
            let focusIndex = valueIndex;
            if (rangeEditable && valueDist !== 0 && (!maxCount || rawValues.length < maxCount)) {
                cloneNextValues.splice(valueBeforeIndex + 1, 0, newValue);
                focusIndex = valueBeforeIndex + 1;
            } else cloneNextValues[valueIndex] = newValue;
            // Fill value to match default 2 (only when `rawValues` is empty)
            if (rangeEnabled && !rawValues.length && count === undefined) cloneNextValues.push(newValue);
            const nextValue = getTriggerValue(cloneNextValues);
            onBeforeChange?.(nextValue);
            triggerChange(cloneNextValues);
            if (e) {
                document.activeElement?.blur?.();
                handlesRef.current.focus(focusIndex);
                onStartDrag(e, focusIndex, cloneNextValues);
            } else {
                // https://github.com/ant-design/ant-design/issues/49997
                onAfterChange?.(nextValue);
                (0, _warningDefault.default)(!onAfterChange, '[rc-slider] `onAfterChange` is deprecated. Please use `onChangeComplete` instead.');
                onChangeComplete?.(nextValue);
            }
        }
    };
    // ============================ Click =============================
    const onSliderMouseDown = (e)=>{
        e.preventDefault();
        const { width, height, left, top, bottom, right } = containerRef.current.getBoundingClientRect();
        const { clientX, clientY } = e;
        let percent;
        switch(direction){
            case 'btt':
                percent = (bottom - clientY) / height;
                break;
            case 'ttb':
                percent = (clientY - top) / height;
                break;
            case 'rtl':
                percent = (right - clientX) / width;
                break;
            default:
                percent = (clientX - left) / width;
        }
        const nextValue = mergedMin + percent * (mergedMax - mergedMin);
        changeToCloseValue(formatValue(nextValue), e);
    };
    // =========================== Keyboard ===========================
    const [keyboardValue, setKeyboardValue] = _react.useState(null);
    const onHandleOffsetChange = (offset, valueIndex)=>{
        if (!disabled) {
            const next = offsetValues(rawValues, offset, valueIndex);
            onBeforeChange?.(getTriggerValue(rawValues));
            triggerChange(next.values);
            setKeyboardValue(next.value);
        }
    };
    _react.useEffect(()=>{
        if (keyboardValue !== null) {
            const valueIndex = rawValues.indexOf(keyboardValue);
            if (valueIndex >= 0) handlesRef.current.focus(valueIndex);
        }
        setKeyboardValue(null);
    }, [
        keyboardValue
    ]);
    // ============================= Drag =============================
    const mergedDraggableTrack = _react.useMemo(()=>{
        if (rangeDraggableTrack && mergedStep === null) return false;
        return rangeDraggableTrack;
    }, [
        rangeDraggableTrack,
        mergedStep
    ]);
    const onStartMove = (0, _useEventDefault.default)((e, valueIndex)=>{
        onStartDrag(e, valueIndex);
        onBeforeChange?.(getTriggerValue(rawValues));
    });
    // Auto focus for updated handle
    const dragging = draggingIndex !== -1;
    _react.useEffect(()=>{
        if (!dragging) {
            const valueIndex = rawValues.lastIndexOf(draggingValue);
            handlesRef.current.focus(valueIndex);
        }
    }, [
        dragging
    ]);
    // =========================== Included ===========================
    const sortedCacheValues = _react.useMemo(()=>[
            ...cacheValues
        ].sort((a, b)=>a - b), [
        cacheValues
    ]);
    // Provide a range values with included [min, max]
    // Used for Track, Mark & Dot
    const [includedStart, includedEnd] = _react.useMemo(()=>{
        if (!rangeEnabled) return [
            mergedMin,
            sortedCacheValues[0]
        ];
        return [
            sortedCacheValues[0],
            sortedCacheValues[sortedCacheValues.length - 1]
        ];
    }, [
        sortedCacheValues,
        rangeEnabled,
        mergedMin
    ]);
    // ============================= Refs =============================
    _react.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                handlesRef.current.focus(0);
            },
            blur: ()=>{
                const { activeElement } = document;
                if (containerRef.current?.contains(activeElement)) activeElement?.blur();
            }
        }));
    // ========================== Auto Focus ==========================
    _react.useEffect(()=>{
        if (autoFocus) handlesRef.current.focus(0);
    }, []);
    // =========================== Context ============================
    const context = _react.useMemo(()=>({
            min: mergedMin,
            max: mergedMax,
            direction,
            disabled,
            keyboard,
            step: mergedStep,
            included,
            includedStart,
            includedEnd,
            range: rangeEnabled,
            tabIndex,
            ariaLabelForHandle,
            ariaLabelledByForHandle,
            ariaRequired,
            ariaValueTextFormatterForHandle,
            styles: styles || {},
            classNames: classNames || {}
        }), [
        mergedMin,
        mergedMax,
        direction,
        disabled,
        keyboard,
        mergedStep,
        included,
        includedStart,
        includedEnd,
        rangeEnabled,
        tabIndex,
        ariaLabelForHandle,
        ariaLabelledByForHandle,
        ariaRequired,
        ariaValueTextFormatterForHandle,
        styles,
        classNames
    ]);
    // ============================ Render ============================
    return /*#__PURE__*/ _react.createElement((0, _contextDefault.default).Provider, {
        value: context
    }, /*#__PURE__*/ _react.createElement("div", {
        ref: containerRef,
        className: (0, _clsx.clsx)(prefixCls, className, {
            [`${prefixCls}-disabled`]: disabled,
            [`${prefixCls}-vertical`]: vertical,
            [`${prefixCls}-horizontal`]: !vertical,
            [`${prefixCls}-with-marks`]: markList.length
        }),
        style: style,
        onMouseDown: onSliderMouseDown,
        id: id
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-rail`, classNames?.rail),
        style: {
            ...railStyle,
            ...styles?.rail
        }
    }), track !== false && /*#__PURE__*/ _react.createElement((0, _tracksDefault.default), {
        prefixCls: prefixCls,
        style: trackStyle,
        values: rawValues,
        startPoint: startPoint,
        onStartMove: mergedDraggableTrack ? onStartMove : undefined
    }), /*#__PURE__*/ _react.createElement((0, _stepsDefault.default), {
        prefixCls: prefixCls,
        marks: markList,
        dots: dots,
        style: dotStyle,
        activeStyle: activeDotStyle
    }), /*#__PURE__*/ _react.createElement((0, _handlesDefault.default), {
        ref: handlesRef,
        prefixCls: prefixCls,
        style: handleStyle,
        values: cacheValues,
        draggingIndex: draggingIndex,
        draggingDelete: draggingDelete,
        onStartMove: onStartMove,
        onOffsetChange: onHandleOffsetChange,
        onFocus: onFocus,
        onBlur: onBlur,
        handleRender: handleRender,
        activeHandleRender: activeHandleRender,
        onChangeComplete: finishChange,
        onDelete: rangeEditable ? onDelete : undefined
    }), /*#__PURE__*/ _react.createElement((0, _marksDefault.default), {
        prefixCls: prefixCls,
        marks: markList,
        onClick: changeToCloseValue
    })));
});
exports.default = Slider;

},{"@rc-component/util/es/hooks/useControlledState":"2FQtD","@rc-component/util/es/hooks/useEvent":"klq5U","@rc-component/util/es/isEqual":"fBa27","@rc-component/util/es/warning":"hJXDS","clsx":"431Ou","react":"bmhQu","./Handles":"igwBL","./Marks":"3J8lQ","./Steps":"6LVgB","./Tracks":"ao1Gf","./context":"6x0AC","./hooks/useDrag":"imLIr","./hooks/useOffset":"7ZYKU","./hooks/useRange":"cvFzM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2FQtD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useControlledState);
var _react = require("react");
var _useLayoutEffect = require("./useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
function useControlledState(defaultStateValue, value) {
    const [innerValue, setInnerValue] = (0, _react.useState)(defaultStateValue);
    const mergedValue = value !== undefined ? value : innerValue;
    (0, _useLayoutEffectDefault.default)((mount)=>{
        if (!mount) setInnerValue(value);
    }, [
        value
    ]);
    return [
        // Value
        mergedValue,
        // Update function
        setInnerValue
    ];
}

},{"react":"bmhQu","./useLayoutEffect":"azwns","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"azwns":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLayoutUpdateEffect", ()=>useLayoutUpdateEffect);
var _react = require("react");
var _canUseDom = require("../Dom/canUseDom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
/**
 * Wrap `React.useLayoutEffect` which will not throw warning message in test env
 */ const useInternalLayoutEffect = (0, _canUseDomDefault.default)() ? _react.useLayoutEffect : _react.useEffect;
const useLayoutEffect = (callback, deps)=>{
    const firstMountRef = _react.useRef(true);
    useInternalLayoutEffect(()=>{
        return callback(firstMountRef.current);
    }, deps);
    // We tell react that first mount has passed
    useInternalLayoutEffect(()=>{
        firstMountRef.current = false;
        return ()=>{
            firstMountRef.current = true;
        };
    }, []);
};
const useLayoutUpdateEffect = (callback, deps)=>{
    useLayoutEffect((firstMount)=>{
        if (!firstMount) return callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
exports.default = useLayoutEffect;

},{"react":"bmhQu","../Dom/canUseDom":"4Ky1R","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Ky1R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>canUseDom);
function canUseDom() {
    return !!(typeof window !== 'undefined' && window.document && window.document.createElement);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"klq5U":[function(require,module,exports,__globalThis) {
/* eslint-disable @typescript-eslint/ban-types */ /* eslint-disable react-hooks/exhaustive-deps */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
function useEvent(callback) {
    const fnRef = _react.useRef(callback);
    fnRef.current = callback;
    const memoFn = _react.useCallback((...args)=>fnRef.current?.(...args), []);
    return memoFn;
}
exports.default = useEvent;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fBa27":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
/**
 * Deeply compares two object literals.
 * @param obj1 object 1
 * @param obj2 object 2
 * @param shallow shallow compare
 * @returns
 */ function isEqual(obj1, obj2, shallow = false) {
    // https://github.com/mapbox/mapbox-gl-js/pull/5979/files#diff-fde7145050c47cc3a306856efd5f9c3016e86e859de9afbd02c879be5067e58f
    const refSet = new Set();
    function deepEqual(a, b, level = 1) {
        const circular = refSet.has(a);
        (0, _warningDefault.default)(!circular, 'Warning: There may be circular references');
        if (circular) return false;
        if (a === b) return true;
        if (shallow && level > 1) return false;
        refSet.add(a);
        const newLevel = level + 1;
        if (Array.isArray(a)) {
            if (!Array.isArray(b) || a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!deepEqual(a[i], b[i], newLevel)) return false;
            }
            return true;
        }
        if (a && b && typeof a === 'object' && typeof b === 'object') {
            const keys = Object.keys(a);
            if (keys.length !== Object.keys(b).length) return false;
            return keys.every((key)=>deepEqual(a[key], b[key], newLevel));
        }
        // other
        return false;
    }
    return deepEqual(obj1, obj2);
}
exports.default = isEqual;

},{"./warning":"hJXDS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hJXDS":[function(require,module,exports,__globalThis) {
/* eslint-disable no-console */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "preMessage", ()=>preMessage);
/**
 * Warning if condition not match.
 * @param valid Condition
 * @param message Warning message
 * @example
 * ```js
 * warning(false, 'some error'); // print some error
 * warning(true, 'some error'); // print nothing
 * warning(1 === 2, 'some error'); // print some error
 * ```
 */ parcelHelpers.export(exports, "warning", ()=>warning);
/** @see Similar to {@link warning} */ parcelHelpers.export(exports, "note", ()=>note);
parcelHelpers.export(exports, "resetWarned", ()=>resetWarned);
parcelHelpers.export(exports, "call", ()=>call);
/** @see Same as {@link warning}, but only warn once for the same message */ parcelHelpers.export(exports, "warningOnce", ()=>warningOnce);
/** @see Same as {@link warning}, but only warn once for the same message */ parcelHelpers.export(exports, "noteOnce", ()=>noteOnce);
let warned = {};
const preWarningFns = [];
const preMessage = (fn)=>{
    preWarningFns.push(fn);
};
function warning(valid, message) {}
function note(valid, message) {}
function resetWarned() {
    warned = {};
}
function call(method, valid, message) {
    if (!valid && !warned[message]) {
        method(false, message);
        warned[message] = true;
    }
}
function warningOnce(valid, message) {
    call(warning, valid, message);
}
function noteOnce(valid, message) {
    call(note, valid, message);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
exports.default = warningOnce;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"431Ou":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "clsx", ()=>clsx);
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) {
        if (Array.isArray(e)) {
            var o = e.length;
            for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
        } else for(f in e)e[f] && (n && (n += " "), n += f);
    }
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
exports.default = clsx;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"igwBL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDom = require("react-dom");
var _util = require("../util");
var _handle = require("./Handle");
var _handleDefault = parcelHelpers.interopDefault(_handle);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Handles = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls, style, onStartMove, onOffsetChange, values, handleRender, activeHandleRender, draggingIndex, draggingDelete, onFocus, ...restProps } = props;
    const handlesRef = _react.useRef({});
    // =========================== Active ===========================
    const [activeVisible, setActiveVisible] = _react.useState(false);
    const [activeIndex, setActiveIndex] = _react.useState(-1);
    const onActive = (index)=>{
        setActiveIndex(index);
        setActiveVisible(true);
    };
    const onHandleFocus = (e, index)=>{
        onActive(index);
        onFocus?.(e);
    };
    const onHandleMouseEnter = (e, index)=>{
        onActive(index);
    };
    // =========================== Render ===========================
    _react.useImperativeHandle(ref, ()=>({
            focus: (index)=>{
                handlesRef.current[index]?.focus();
            },
            hideHelp: ()=>{
                (0, _reactDom.flushSync)(()=>{
                    setActiveVisible(false);
                });
            }
        }));
    // =========================== Render ===========================
    // Handle Props
    const handleProps = {
        prefixCls,
        onStartMove,
        onOffsetChange,
        render: handleRender,
        onFocus: onHandleFocus,
        onMouseEnter: onHandleMouseEnter,
        ...restProps
    };
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, values.map((value, index)=>{
        const dragging = draggingIndex === index;
        return /*#__PURE__*/ _react.createElement((0, _handleDefault.default), _extends({
            ref: (node)=>{
                if (!node) delete handlesRef.current[index];
                else handlesRef.current[index] = node;
            },
            dragging: dragging,
            draggingDelete: dragging && draggingDelete,
            style: (0, _util.getIndex)(style, index),
            key: index,
            value: value,
            valueIndex: index
        }, handleProps));
    }), activeHandleRender && activeVisible && /*#__PURE__*/ _react.createElement((0, _handleDefault.default), _extends({
        key: "a11y"
    }, handleProps, {
        value: values[activeIndex],
        valueIndex: null,
        dragging: draggingIndex !== -1,
        draggingDelete: draggingDelete,
        render: activeHandleRender,
        style: {
            pointerEvents: 'none'
        },
        tabIndex: null,
        "aria-hidden": true
    })));
});
exports.default = Handles;

},{"react":"bmhQu","react-dom":"82aNB","../util":"2oKWF","./Handle":"2fDuq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2oKWF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOffset", ()=>getOffset);
parcelHelpers.export(exports, "getDirectionStyle", ()=>getDirectionStyle);
/** Return index value if is list or return value directly */ parcelHelpers.export(exports, "getIndex", ()=>getIndex);
function getOffset(value, min, max) {
    return (value - min) / (max - min);
}
function getDirectionStyle(direction, value, min, max) {
    const offset = getOffset(value, min, max);
    const positionStyle = {};
    switch(direction){
        case 'rtl':
            positionStyle.right = `${offset * 100}%`;
            positionStyle.transform = 'translateX(50%)';
            break;
        case 'btt':
            positionStyle.bottom = `${offset * 100}%`;
            positionStyle.transform = 'translateY(50%)';
            break;
        case 'ttb':
            positionStyle.top = `${offset * 100}%`;
            positionStyle.transform = 'translateY(-50%)';
            break;
        default:
            positionStyle.left = `${offset * 100}%`;
            positionStyle.transform = 'translateX(-50%)';
            break;
    }
    return positionStyle;
}
function getIndex(value, index) {
    return Array.isArray(value) ? value[index] : value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2fDuq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _keyCode = require("@rc-component/util/es/KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _util = require("../util");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Handle = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls, value, valueIndex, onStartMove, onDelete, style, render, dragging, draggingDelete, onOffsetChange, onChangeComplete, onFocus, onMouseEnter, ...restProps } = props;
    const { min, max, direction, disabled, keyboard, range, tabIndex, ariaLabelForHandle, ariaLabelledByForHandle, ariaRequired, ariaValueTextFormatterForHandle, styles, classNames } = _react.useContext((0, _contextDefault.default));
    const handlePrefixCls = `${prefixCls}-handle`;
    // ============================ Events ============================
    const onInternalStartMove = (e)=>{
        if (!disabled) onStartMove(e, valueIndex);
    };
    const onInternalFocus = (e)=>{
        onFocus?.(e, valueIndex);
    };
    const onInternalMouseEnter = (e)=>{
        onMouseEnter(e, valueIndex);
    };
    // =========================== Keyboard ===========================
    const onKeyDown = (e)=>{
        if (!disabled && keyboard) {
            let offset = null;
            // Change the value
            switch(e.which || e.keyCode){
                case (0, _keyCodeDefault.default).LEFT:
                    offset = direction === 'ltr' || direction === 'btt' ? -1 : 1;
                    break;
                case (0, _keyCodeDefault.default).RIGHT:
                    offset = direction === 'ltr' || direction === 'btt' ? 1 : -1;
                    break;
                // Up is plus
                case (0, _keyCodeDefault.default).UP:
                    offset = direction !== 'ttb' ? 1 : -1;
                    break;
                // Down is minus
                case (0, _keyCodeDefault.default).DOWN:
                    offset = direction !== 'ttb' ? -1 : 1;
                    break;
                case (0, _keyCodeDefault.default).HOME:
                    offset = 'min';
                    break;
                case (0, _keyCodeDefault.default).END:
                    offset = 'max';
                    break;
                case (0, _keyCodeDefault.default).PAGE_UP:
                    offset = 2;
                    break;
                case (0, _keyCodeDefault.default).PAGE_DOWN:
                    offset = -2;
                    break;
                case (0, _keyCodeDefault.default).BACKSPACE:
                case (0, _keyCodeDefault.default).DELETE:
                    onDelete?.(valueIndex);
                    break;
            }
            if (offset !== null) {
                e.preventDefault();
                onOffsetChange(offset, valueIndex);
            }
        }
    };
    const handleKeyUp = (e)=>{
        switch(e.which || e.keyCode){
            case (0, _keyCodeDefault.default).LEFT:
            case (0, _keyCodeDefault.default).RIGHT:
            case (0, _keyCodeDefault.default).UP:
            case (0, _keyCodeDefault.default).DOWN:
            case (0, _keyCodeDefault.default).HOME:
            case (0, _keyCodeDefault.default).END:
            case (0, _keyCodeDefault.default).PAGE_UP:
            case (0, _keyCodeDefault.default).PAGE_DOWN:
                onChangeComplete?.();
                break;
        }
    };
    // ============================ Offset ============================
    const positionStyle = (0, _util.getDirectionStyle)(direction, value, min, max);
    // ============================ Render ============================
    let divProps = {};
    if (valueIndex !== null) divProps = {
        tabIndex: disabled ? null : (0, _util.getIndex)(tabIndex, valueIndex),
        role: 'slider',
        'aria-valuemin': min,
        'aria-valuemax': max,
        'aria-valuenow': value,
        'aria-disabled': disabled,
        'aria-label': (0, _util.getIndex)(ariaLabelForHandle, valueIndex),
        'aria-labelledby': (0, _util.getIndex)(ariaLabelledByForHandle, valueIndex),
        'aria-required': (0, _util.getIndex)(ariaRequired, valueIndex),
        'aria-valuetext': (0, _util.getIndex)(ariaValueTextFormatterForHandle, valueIndex)?.(value),
        'aria-orientation': direction === 'ltr' || direction === 'rtl' ? 'horizontal' : 'vertical',
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove,
        onFocus: onInternalFocus,
        onMouseEnter: onInternalMouseEnter,
        onKeyDown,
        onKeyUp: handleKeyUp
    };
    let handleNode = /*#__PURE__*/ _react.createElement("div", _extends({
        ref: ref,
        className: (0, _clsx.clsx)(handlePrefixCls, {
            [`${handlePrefixCls}-${valueIndex + 1}`]: valueIndex !== null && range,
            [`${handlePrefixCls}-dragging`]: dragging,
            [`${handlePrefixCls}-dragging-delete`]: draggingDelete
        }, classNames.handle),
        style: {
            ...positionStyle,
            ...style,
            ...styles.handle
        }
    }, divProps, restProps));
    // Customize
    if (render) handleNode = render(handleNode, {
        index: valueIndex,
        prefixCls,
        value,
        dragging,
        draggingDelete
    });
    return handleNode;
});
exports.default = Handle;

},{"clsx":"431Ou","@rc-component/util/es/KeyCode":"6yRlk","react":"bmhQu","../context":"6x0AC","../util":"2oKWF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6yRlk":[function(require,module,exports,__globalThis) {
/**
 * @ignore
 * some key-codes definition and utils from closure-library
 * @author yiminghe@gmail.com
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const KeyCode = {
    /**
   * MAC_ENTER
   */ MAC_ENTER: 3,
    /**
   * BACKSPACE
   */ BACKSPACE: 8,
    /**
   * TAB
   */ TAB: 9,
    /**
   * NUMLOCK on FF/Safari Mac
   */ NUM_CENTER: 12,
    // NUMLOCK on FF/Safari Mac
    /**
   * ENTER
   */ ENTER: 13,
    /**
   * SHIFT
   */ SHIFT: 16,
    /**
   * CTRL
   */ CTRL: 17,
    /**
   * ALT
   */ ALT: 18,
    /**
   * PAUSE
   */ PAUSE: 19,
    /**
   * CAPS_LOCK
   */ CAPS_LOCK: 20,
    /**
   * ESC
   */ ESC: 27,
    /**
   * SPACE
   */ SPACE: 32,
    /**
   * PAGE_UP
   */ PAGE_UP: 33,
    // also NUM_NORTH_EAST
    /**
   * PAGE_DOWN
   */ PAGE_DOWN: 34,
    // also NUM_SOUTH_EAST
    /**
   * END
   */ END: 35,
    // also NUM_SOUTH_WEST
    /**
   * HOME
   */ HOME: 36,
    // also NUM_NORTH_WEST
    /**
   * LEFT
   */ LEFT: 37,
    // also NUM_WEST
    /**
   * UP
   */ UP: 38,
    // also NUM_NORTH
    /**
   * RIGHT
   */ RIGHT: 39,
    // also NUM_EAST
    /**
   * DOWN
   */ DOWN: 40,
    // also NUM_SOUTH
    /**
   * PRINT_SCREEN
   */ PRINT_SCREEN: 44,
    /**
   * INSERT
   */ INSERT: 45,
    // also NUM_INSERT
    /**
   * DELETE
   */ DELETE: 46,
    // also NUM_DELETE
    /**
   * ZERO
   */ ZERO: 48,
    /**
   * ONE
   */ ONE: 49,
    /**
   * TWO
   */ TWO: 50,
    /**
   * THREE
   */ THREE: 51,
    /**
   * FOUR
   */ FOUR: 52,
    /**
   * FIVE
   */ FIVE: 53,
    /**
   * SIX
   */ SIX: 54,
    /**
   * SEVEN
   */ SEVEN: 55,
    /**
   * EIGHT
   */ EIGHT: 56,
    /**
   * NINE
   */ NINE: 57,
    /**
   * QUESTION_MARK
   */ QUESTION_MARK: 63,
    // needs localization
    /**
   * A
   */ A: 65,
    /**
   * B
   */ B: 66,
    /**
   * C
   */ C: 67,
    /**
   * D
   */ D: 68,
    /**
   * E
   */ E: 69,
    /**
   * F
   */ F: 70,
    /**
   * G
   */ G: 71,
    /**
   * H
   */ H: 72,
    /**
   * I
   */ I: 73,
    /**
   * J
   */ J: 74,
    /**
   * K
   */ K: 75,
    /**
   * L
   */ L: 76,
    /**
   * M
   */ M: 77,
    /**
   * N
   */ N: 78,
    /**
   * O
   */ O: 79,
    /**
   * P
   */ P: 80,
    /**
   * Q
   */ Q: 81,
    /**
   * R
   */ R: 82,
    /**
   * S
   */ S: 83,
    /**
   * T
   */ T: 84,
    /**
   * U
   */ U: 85,
    /**
   * V
   */ V: 86,
    /**
   * W
   */ W: 87,
    /**
   * X
   */ X: 88,
    /**
   * Y
   */ Y: 89,
    /**
   * Z
   */ Z: 90,
    /**
   * META
   */ META: 91,
    // WIN_KEY_LEFT
    /**
   * WIN_KEY_RIGHT
   */ WIN_KEY_RIGHT: 92,
    /**
   * CONTEXT_MENU
   */ CONTEXT_MENU: 93,
    /**
   * NUM_ZERO
   */ NUM_ZERO: 96,
    /**
   * NUM_ONE
   */ NUM_ONE: 97,
    /**
   * NUM_TWO
   */ NUM_TWO: 98,
    /**
   * NUM_THREE
   */ NUM_THREE: 99,
    /**
   * NUM_FOUR
   */ NUM_FOUR: 100,
    /**
   * NUM_FIVE
   */ NUM_FIVE: 101,
    /**
   * NUM_SIX
   */ NUM_SIX: 102,
    /**
   * NUM_SEVEN
   */ NUM_SEVEN: 103,
    /**
   * NUM_EIGHT
   */ NUM_EIGHT: 104,
    /**
   * NUM_NINE
   */ NUM_NINE: 105,
    /**
   * NUM_MULTIPLY
   */ NUM_MULTIPLY: 106,
    /**
   * NUM_PLUS
   */ NUM_PLUS: 107,
    /**
   * NUM_MINUS
   */ NUM_MINUS: 109,
    /**
   * NUM_PERIOD
   */ NUM_PERIOD: 110,
    /**
   * NUM_DIVISION
   */ NUM_DIVISION: 111,
    /**
   * F1
   */ F1: 112,
    /**
   * F2
   */ F2: 113,
    /**
   * F3
   */ F3: 114,
    /**
   * F4
   */ F4: 115,
    /**
   * F5
   */ F5: 116,
    /**
   * F6
   */ F6: 117,
    /**
   * F7
   */ F7: 118,
    /**
   * F8
   */ F8: 119,
    /**
   * F9
   */ F9: 120,
    /**
   * F10
   */ F10: 121,
    /**
   * F11
   */ F11: 122,
    /**
   * F12
   */ F12: 123,
    /**
   * NUMLOCK
   */ NUMLOCK: 144,
    /**
   * SEMICOLON
   */ SEMICOLON: 186,
    // needs localization
    /**
   * DASH
   */ DASH: 189,
    // needs localization
    /**
   * EQUALS
   */ EQUALS: 187,
    // needs localization
    /**
   * COMMA
   */ COMMA: 188,
    // needs localization
    /**
   * PERIOD
   */ PERIOD: 190,
    // needs localization
    /**
   * SLASH
   */ SLASH: 191,
    // needs localization
    /**
   * APOSTROPHE
   */ APOSTROPHE: 192,
    // needs localization
    /**
   * SINGLE_QUOTE
   */ SINGLE_QUOTE: 222,
    // needs localization
    /**
   * OPEN_SQUARE_BRACKET
   */ OPEN_SQUARE_BRACKET: 219,
    // needs localization
    /**
   * BACKSLASH
   */ BACKSLASH: 220,
    // needs localization
    /**
   * CLOSE_SQUARE_BRACKET
   */ CLOSE_SQUARE_BRACKET: 221,
    // needs localization
    /**
   * WIN_KEY
   */ WIN_KEY: 224,
    /**
   * MAC_FF_META
   */ MAC_FF_META: 224,
    // Firefox (Gecko) fires this for the meta key instead of 91
    /**
   * WIN_IME
   */ WIN_IME: 229,
    // ======================== Function ========================
    /**
   * whether text and modified key is entered at the same time.
   */ isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
        const { keyCode } = e;
        if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
        keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) return false;
        // The following keys are quite harmless, even in combination with
        // CTRL, ALT or SHIFT.
        switch(keyCode){
            case KeyCode.ALT:
            case KeyCode.CAPS_LOCK:
            case KeyCode.CONTEXT_MENU:
            case KeyCode.CTRL:
            case KeyCode.DOWN:
            case KeyCode.END:
            case KeyCode.ESC:
            case KeyCode.HOME:
            case KeyCode.INSERT:
            case KeyCode.LEFT:
            case KeyCode.MAC_FF_META:
            case KeyCode.META:
            case KeyCode.NUMLOCK:
            case KeyCode.NUM_CENTER:
            case KeyCode.PAGE_DOWN:
            case KeyCode.PAGE_UP:
            case KeyCode.PAUSE:
            case KeyCode.PRINT_SCREEN:
            case KeyCode.RIGHT:
            case KeyCode.SHIFT:
            case KeyCode.UP:
            case KeyCode.WIN_KEY:
            case KeyCode.WIN_KEY_RIGHT:
                return false;
            default:
                return true;
        }
    },
    /**
   * whether character is entered.
   */ isCharacterKey: function isCharacterKey(keyCode) {
        if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) return true;
        if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) return true;
        if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) return true;
        // Safari sends zero key code for non-latin characters.
        if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) return true;
        switch(keyCode){
            case KeyCode.SPACE:
            case KeyCode.QUESTION_MARK:
            case KeyCode.NUM_PLUS:
            case KeyCode.NUM_MINUS:
            case KeyCode.NUM_PERIOD:
            case KeyCode.NUM_DIVISION:
            case KeyCode.SEMICOLON:
            case KeyCode.DASH:
            case KeyCode.EQUALS:
            case KeyCode.COMMA:
            case KeyCode.PERIOD:
            case KeyCode.SLASH:
            case KeyCode.APOSTROPHE:
            case KeyCode.SINGLE_QUOTE:
            case KeyCode.OPEN_SQUARE_BRACKET:
            case KeyCode.BACKSLASH:
            case KeyCode.CLOSE_SQUARE_BRACKET:
                return true;
            default:
                return false;
        }
    }
};
exports.default = KeyCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6x0AC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnstableContext", ()=>UnstableContext);
var _react = require("react");
const SliderContext = /*#__PURE__*/ _react.createContext({
    min: 0,
    max: 0,
    direction: 'ltr',
    step: 1,
    includedStart: 0,
    includedEnd: 0,
    tabIndex: 0,
    keyboard: true,
    styles: {},
    classNames: {}
});
exports.default = SliderContext;
const UnstableContext = /*#__PURE__*/ _react.createContext({});

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3J8lQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _mark = require("./Mark");
var _markDefault = parcelHelpers.interopDefault(_mark);
const Marks = (props)=>{
    const { prefixCls, marks, onClick } = props;
    const markPrefixCls = `${prefixCls}-mark`;
    // Not render mark if empty
    if (!marks.length) return null;
    return /*#__PURE__*/ _react.createElement("div", {
        className: markPrefixCls
    }, marks.map(({ value, style, label })=>/*#__PURE__*/ _react.createElement((0, _markDefault.default), {
            key: value,
            prefixCls: markPrefixCls,
            style: style,
            value: value,
            onClick: onClick
        }, label)));
};
exports.default = Marks;

},{"react":"bmhQu","./Mark":"3D3km","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3D3km":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _util = require("../util");
const Mark = (props)=>{
    const { prefixCls, style, children, value, onClick } = props;
    const { min, max, direction, includedStart, includedEnd, included } = _react.useContext((0, _contextDefault.default));
    const textCls = `${prefixCls}-text`;
    // ============================ Offset ============================
    const positionStyle = (0, _util.getDirectionStyle)(direction, value, min, max);
    return /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(textCls, {
            [`${textCls}-active`]: included && includedStart <= value && value <= includedEnd
        }),
        style: {
            ...positionStyle,
            ...style
        },
        onMouseDown: (e)=>{
            e.stopPropagation();
        },
        onClick: ()=>{
            onClick(value);
        }
    }, children);
};
exports.default = Mark;

},{"clsx":"431Ou","react":"bmhQu","../context":"6x0AC","../util":"2oKWF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6LVgB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _dot = require("./Dot");
var _dotDefault = parcelHelpers.interopDefault(_dot);
const Steps = (props)=>{
    const { prefixCls, marks, dots, style, activeStyle } = props;
    const { min, max, step } = _react.useContext((0, _contextDefault.default));
    const stepDots = _react.useMemo(()=>{
        const dotSet = new Set();
        // Add marks
        marks.forEach((mark)=>{
            dotSet.add(mark.value);
        });
        // Fill dots
        if (dots && step !== null) {
            let current = min;
            while(current <= max){
                dotSet.add(current);
                current += step;
            }
        }
        return Array.from(dotSet);
    }, [
        min,
        max,
        step,
        dots,
        marks
    ]);
    return /*#__PURE__*/ _react.createElement("div", {
        className: `${prefixCls}-step`
    }, stepDots.map((dotValue)=>/*#__PURE__*/ _react.createElement((0, _dotDefault.default), {
            prefixCls: prefixCls,
            key: dotValue,
            value: dotValue,
            style: style,
            activeStyle: activeStyle
        })));
};
exports.default = Steps;

},{"react":"bmhQu","../context":"6x0AC","./Dot":"lX9Qx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lX9Qx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _util = require("../util");
const Dot = (props)=>{
    const { prefixCls, value, style, activeStyle } = props;
    const { min, max, direction, included, includedStart, includedEnd } = _react.useContext((0, _contextDefault.default));
    const dotClassName = `${prefixCls}-dot`;
    const active = included && includedStart <= value && value <= includedEnd;
    // ============================ Offset ============================
    let mergedStyle = {
        ...(0, _util.getDirectionStyle)(direction, value, min, max),
        ...typeof style === 'function' ? style(value) : style
    };
    if (active) mergedStyle = {
        ...mergedStyle,
        ...typeof activeStyle === 'function' ? activeStyle(value) : activeStyle
    };
    return /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(dotClassName, {
            [`${dotClassName}-active`]: active
        }),
        style: mergedStyle
    });
};
exports.default = Dot;

},{"clsx":"431Ou","react":"bmhQu","../context":"6x0AC","../util":"2oKWF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ao1Gf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _util = require("../util");
var _track = require("./Track");
var _trackDefault = parcelHelpers.interopDefault(_track);
const Tracks = (props)=>{
    const { prefixCls, style, values, startPoint, onStartMove } = props;
    const { included, range, min, styles, classNames } = _react.useContext((0, _contextDefault.default));
    // =========================== List ===========================
    const trackList = _react.useMemo(()=>{
        if (!range) {
            // null value do not have track
            if (values.length === 0) return [];
            const startValue = startPoint ?? min;
            const endValue = values[0];
            return [
                {
                    start: Math.min(startValue, endValue),
                    end: Math.max(startValue, endValue)
                }
            ];
        }
        // Multiple
        const list = [];
        for(let i = 0; i < values.length - 1; i += 1)list.push({
            start: values[i],
            end: values[i + 1]
        });
        return list;
    }, [
        values,
        range,
        startPoint,
        min
    ]);
    if (!included) return null;
    // ========================== Render ==========================
    const tracksNode = trackList?.length && (classNames.tracks || styles.tracks) ? /*#__PURE__*/ _react.createElement((0, _trackDefault.default), {
        index: null,
        prefixCls: prefixCls,
        start: trackList[0].start,
        end: trackList[trackList.length - 1].end,
        replaceCls: (0, _clsx.clsx)(classNames.tracks, `${prefixCls}-tracks`),
        style: styles.tracks
    }) : null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, tracksNode, trackList.map(({ start, end }, index)=>/*#__PURE__*/ _react.createElement((0, _trackDefault.default), {
            index: index,
            prefixCls: prefixCls,
            style: {
                ...(0, _util.getIndex)(style, index),
                ...styles.track
            },
            start: start,
            end: end,
            key: index,
            onStartMove: onStartMove
        })));
};
exports.default = Tracks;

},{"clsx":"431Ou","react":"bmhQu","../context":"6x0AC","../util":"2oKWF","./Track":"8mQRp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8mQRp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _util = require("../util");
const Track = (props)=>{
    const { prefixCls, style, start, end, index, onStartMove, replaceCls } = props;
    const { direction, min, max, disabled, range, classNames } = _react.useContext((0, _contextDefault.default));
    const trackPrefixCls = `${prefixCls}-track`;
    const offsetStart = (0, _util.getOffset)(start, min, max);
    const offsetEnd = (0, _util.getOffset)(end, min, max);
    // ============================ Events ============================
    const onInternalStartMove = (e)=>{
        if (!disabled && onStartMove) onStartMove(e, -1);
    };
    // ============================ Render ============================
    const positionStyle = {};
    switch(direction){
        case 'rtl':
            positionStyle.right = `${offsetStart * 100}%`;
            positionStyle.width = `${offsetEnd * 100 - offsetStart * 100}%`;
            break;
        case 'btt':
            positionStyle.bottom = `${offsetStart * 100}%`;
            positionStyle.height = `${offsetEnd * 100 - offsetStart * 100}%`;
            break;
        case 'ttb':
            positionStyle.top = `${offsetStart * 100}%`;
            positionStyle.height = `${offsetEnd * 100 - offsetStart * 100}%`;
            break;
        default:
            positionStyle.left = `${offsetStart * 100}%`;
            positionStyle.width = `${offsetEnd * 100 - offsetStart * 100}%`;
    }
    const className = replaceCls || (0, _clsx.clsx)(trackPrefixCls, {
        [`${trackPrefixCls}-${index + 1}`]: index !== null && range,
        [`${prefixCls}-track-draggable`]: onStartMove
    }, classNames.track);
    return /*#__PURE__*/ _react.createElement("div", {
        className: className,
        style: {
            ...positionStyle,
            ...style
        },
        onMouseDown: onInternalStartMove,
        onTouchStart: onInternalStartMove
    });
};
exports.default = Track;

},{"clsx":"431Ou","react":"bmhQu","../context":"6x0AC","../util":"2oKWF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"imLIr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useEvent = require("@rc-component/util/es/hooks/useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _context = require("../context");
/** Drag to delete offset. It's a user experience number for dragging out */ const REMOVE_DIST = 130;
function getPosition(e) {
    const obj = 'targetTouches' in e ? e.targetTouches[0] : e;
    return {
        pageX: obj.pageX,
        pageY: obj.pageY
    };
}
function useDrag(containerRef, direction, rawValues, min, max, formatValue, triggerChange, finishChange, offsetValues, editable, minCount) {
    const [draggingValue, setDraggingValue] = _react.useState(null);
    const [draggingIndex, setDraggingIndex] = _react.useState(-1);
    const [draggingDelete, setDraggingDelete] = _react.useState(false);
    const [cacheValues, setCacheValues] = _react.useState(rawValues);
    const [originValues, setOriginValues] = _react.useState(rawValues);
    const mouseMoveEventRef = _react.useRef(null);
    const mouseUpEventRef = _react.useRef(null);
    const touchEventTargetRef = _react.useRef(null);
    const { onDragStart, onDragChange } = _react.useContext((0, _context.UnstableContext));
    (0, _useLayoutEffectDefault.default)(()=>{
        if (draggingIndex === -1) setCacheValues(rawValues);
    }, [
        rawValues,
        draggingIndex
    ]);
    // Clean up event
    _react.useEffect(()=>()=>{
            document.removeEventListener('mousemove', mouseMoveEventRef.current);
            document.removeEventListener('mouseup', mouseUpEventRef.current);
            if (touchEventTargetRef.current) {
                touchEventTargetRef.current.removeEventListener('touchmove', mouseMoveEventRef.current);
                touchEventTargetRef.current.removeEventListener('touchend', mouseUpEventRef.current);
            }
        }, []);
    const flushValues = (nextValues, nextValue, deleteMark)=>{
        // Perf: Only update state when value changed
        if (nextValue !== undefined) setDraggingValue(nextValue);
        setCacheValues(nextValues);
        let changeValues = nextValues;
        if (deleteMark) changeValues = nextValues.filter((_, i)=>i !== draggingIndex);
        triggerChange(changeValues);
        if (onDragChange) onDragChange({
            rawValues: nextValues,
            deleteIndex: deleteMark ? draggingIndex : -1,
            draggingIndex,
            draggingValue: nextValue
        });
    };
    const updateCacheValue = (0, _useEventDefault.default)((valueIndex, offsetPercent, deleteMark)=>{
        if (valueIndex === -1) {
            // >>>> Dragging on the track
            const startValue = originValues[0];
            const endValue = originValues[originValues.length - 1];
            const maxStartOffset = min - startValue;
            const maxEndOffset = max - endValue;
            // Get valid offset
            let offset = offsetPercent * (max - min);
            offset = Math.max(offset, maxStartOffset);
            offset = Math.min(offset, maxEndOffset);
            // Use first value to revert back of valid offset (like steps marks)
            const formatStartValue = formatValue(startValue + offset);
            offset = formatStartValue - startValue;
            const cloneCacheValues = originValues.map((val)=>val + offset);
            flushValues(cloneCacheValues);
        } else {
            // >>>> Dragging on the handle
            const offsetDist = (max - min) * offsetPercent;
            // Always start with the valueIndex origin value
            const cloneValues = [
                ...cacheValues
            ];
            cloneValues[valueIndex] = originValues[valueIndex];
            const next = offsetValues(cloneValues, offsetDist, valueIndex, 'dist');
            flushValues(next.values, next.value, deleteMark);
        }
    });
    const onStartMove = (e, valueIndex, startValues)=>{
        e.stopPropagation();
        // 如果是点击 track 触发的，需要传入变化后的初始值，而不能直接用 rawValues
        const initialValues = startValues || rawValues;
        const originValue = initialValues[valueIndex];
        setDraggingIndex(valueIndex);
        setDraggingValue(originValue);
        setOriginValues(initialValues);
        setCacheValues(initialValues);
        setDraggingDelete(false);
        const { pageX: startX, pageY: startY } = getPosition(e);
        // We declare it here since closure can't get outer latest value
        let deleteMark = false;
        // Internal trigger event
        if (onDragStart) onDragStart({
            rawValues: initialValues,
            draggingIndex: valueIndex,
            draggingValue: originValue
        });
        // Moving
        const onMouseMove = (event)=>{
            event.preventDefault();
            const { pageX: moveX, pageY: moveY } = getPosition(event);
            const offsetX = moveX - startX;
            const offsetY = moveY - startY;
            const { width, height } = containerRef.current.getBoundingClientRect();
            let offSetPercent;
            let removeDist;
            switch(direction){
                case 'btt':
                    offSetPercent = -offsetY / height;
                    removeDist = offsetX;
                    break;
                case 'ttb':
                    offSetPercent = offsetY / height;
                    removeDist = offsetX;
                    break;
                case 'rtl':
                    offSetPercent = -offsetX / width;
                    removeDist = offsetY;
                    break;
                default:
                    offSetPercent = offsetX / width;
                    removeDist = offsetY;
            }
            // Check if need mark remove
            deleteMark = editable ? Math.abs(removeDist) > REMOVE_DIST && minCount < cacheValues.length : false;
            setDraggingDelete(deleteMark);
            updateCacheValue(valueIndex, offSetPercent, deleteMark);
        };
        // End
        const onMouseUp = (event)=>{
            event.preventDefault();
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('mousemove', onMouseMove);
            if (touchEventTargetRef.current) {
                touchEventTargetRef.current.removeEventListener('touchmove', mouseMoveEventRef.current);
                touchEventTargetRef.current.removeEventListener('touchend', mouseUpEventRef.current);
            }
            mouseMoveEventRef.current = null;
            mouseUpEventRef.current = null;
            touchEventTargetRef.current = null;
            finishChange(deleteMark);
            setDraggingIndex(-1);
            setDraggingDelete(false);
        };
        document.addEventListener('mouseup', onMouseUp);
        document.addEventListener('mousemove', onMouseMove);
        e.currentTarget.addEventListener('touchend', onMouseUp);
        e.currentTarget.addEventListener('touchmove', onMouseMove);
        mouseMoveEventRef.current = onMouseMove;
        mouseUpEventRef.current = onMouseUp;
        touchEventTargetRef.current = e.currentTarget;
    };
    // Only return cache value when it mapping with rawValues
    const returnValues = _react.useMemo(()=>{
        const sourceValues = [
            ...rawValues
        ].sort((a, b)=>a - b);
        const targetValues = [
            ...cacheValues
        ].sort((a, b)=>a - b);
        const counts = {};
        targetValues.forEach((val)=>{
            counts[val] = (counts[val] || 0) + 1;
        });
        sourceValues.forEach((val)=>{
            counts[val] = (counts[val] || 0) - 1;
        });
        const maxDiffCount = editable ? 1 : 0;
        const diffCount = Object.values(counts).reduce((prev, next)=>prev + Math.abs(next), 0);
        return diffCount <= maxDiffCount ? cacheValues : rawValues;
    }, [
        rawValues,
        cacheValues,
        editable
    ]);
    return [
        draggingIndex,
        draggingValue,
        draggingDelete,
        returnValues,
        onStartMove
    ];
}
exports.default = useDrag;

},{"react":"bmhQu","@rc-component/util/es/hooks/useEvent":"klq5U","@rc-component/util/es/hooks/useLayoutEffect":"azwns","../context":"6x0AC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7ZYKU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOffset);
var _react = require("react");
function useOffset(min, max, step, markList, allowCross, pushable) {
    const formatRangeValue = _react.useCallback((val)=>Math.max(min, Math.min(max, val)), [
        min,
        max
    ]);
    const formatStepValue = _react.useCallback((val)=>{
        if (step !== null) {
            const stepValue = min + Math.round((formatRangeValue(val) - min) / step) * step;
            // Cut number in case to be like 0.30000000000000004
            const getDecimal = (num)=>(String(num).split('.')[1] || '').length;
            const maxDecimal = Math.max(getDecimal(step), getDecimal(max), getDecimal(min));
            const fixedValue = Number(stepValue.toFixed(maxDecimal));
            return min <= fixedValue && fixedValue <= max ? fixedValue : null;
        }
        return null;
    }, [
        step,
        min,
        max,
        formatRangeValue
    ]);
    const formatValue = _react.useCallback((val)=>{
        const formatNextValue = formatRangeValue(val);
        // List align values
        const alignValues = markList.map((mark)=>mark.value);
        if (step !== null) alignValues.push(formatStepValue(val));
        // min & max
        alignValues.push(min, max);
        // Align with marks
        let closeValue = alignValues[0];
        let closeDist = max - min;
        alignValues.forEach((alignValue)=>{
            const dist = Math.abs(formatNextValue - alignValue);
            if (dist <= closeDist) {
                closeValue = alignValue;
                closeDist = dist;
            }
        });
        return closeValue;
    }, [
        min,
        max,
        markList,
        step,
        formatRangeValue,
        formatStepValue
    ]);
    // ========================== Offset ==========================
    // Single Value
    const offsetValue = (values, offset, valueIndex, mode = 'unit')=>{
        if (typeof offset === 'number') {
            let nextValue;
            const originValue = values[valueIndex];
            // Only used for `dist` mode
            const targetDistValue = originValue + offset;
            // Compare next step value & mark value which is best match
            let potentialValues = [];
            markList.forEach((mark)=>{
                potentialValues.push(mark.value);
            });
            // Min & Max
            potentialValues.push(min, max);
            // In case origin value is align with mark but not with step
            potentialValues.push(formatStepValue(originValue));
            // Put offset step value also
            const sign = offset > 0 ? 1 : -1;
            if (mode === 'unit') potentialValues.push(formatStepValue(originValue + sign * step));
            else potentialValues.push(formatStepValue(targetDistValue));
            // Find close one
            potentialValues = potentialValues.filter((val)=>val !== null)// Remove reverse value
            .filter((val)=>offset < 0 ? val <= originValue : val >= originValue);
            if (mode === 'unit') // `unit` mode can not contain itself
            potentialValues = potentialValues.filter((val)=>val !== originValue);
            const compareValue = mode === 'unit' ? originValue : targetDistValue;
            nextValue = potentialValues[0];
            let valueDist = Math.abs(nextValue - compareValue);
            potentialValues.forEach((potentialValue)=>{
                const dist = Math.abs(potentialValue - compareValue);
                if (dist < valueDist) {
                    nextValue = potentialValue;
                    valueDist = dist;
                }
            });
            // Out of range will back to range
            if (nextValue === undefined) return offset < 0 ? min : max;
            // `dist` mode
            if (mode === 'dist') return nextValue;
            // `unit` mode may need another round
            if (Math.abs(offset) > 1) {
                const cloneValues = [
                    ...values
                ];
                cloneValues[valueIndex] = nextValue;
                return offsetValue(cloneValues, offset - sign, valueIndex, mode);
            }
            return nextValue;
        } else if (offset === 'min') return min;
        else if (offset === 'max') return max;
    };
    /** Same as `offsetValue` but return `changed` mark to tell value changed */ const offsetChangedValue = (values, offset, valueIndex, mode = 'unit')=>{
        const originValue = values[valueIndex];
        const nextValue = offsetValue(values, offset, valueIndex, mode);
        return {
            value: nextValue,
            changed: nextValue !== originValue
        };
    };
    const needPush = (dist)=>{
        return pushable === null && dist === 0 || typeof pushable === 'number' && dist < pushable;
    };
    // Values
    const offsetValues = (values, offset, valueIndex, mode = 'unit')=>{
        const nextValues = values.map(formatValue);
        const originValue = nextValues[valueIndex];
        const nextValue = offsetValue(nextValues, offset, valueIndex, mode);
        nextValues[valueIndex] = nextValue;
        if (allowCross === false) {
            // >>>>> Allow Cross
            const pushNum = pushable || 0;
            // ============ AllowCross ===============
            if (valueIndex > 0 && nextValues[valueIndex - 1] !== originValue) nextValues[valueIndex] = Math.max(nextValues[valueIndex], nextValues[valueIndex - 1] + pushNum);
            if (valueIndex < nextValues.length - 1 && nextValues[valueIndex + 1] !== originValue) nextValues[valueIndex] = Math.min(nextValues[valueIndex], nextValues[valueIndex + 1] - pushNum);
        } else if (typeof pushable === 'number' || pushable === null) {
            // >>>>> Pushable
            // =============== Push ==================
            // >>>>>> Basic push
            // End values
            for(let i = valueIndex + 1; i < nextValues.length; i += 1){
                let changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed)({ value: nextValues[i], changed } = offsetChangedValue(nextValues, 1, i));
            }
            // Start values
            for(let i = valueIndex; i > 0; i -= 1){
                let changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed)({ value: nextValues[i - 1], changed } = offsetChangedValue(nextValues, -1, i - 1));
            }
            // >>>>> Revert back to safe push range
            // End to Start
            for(let i = nextValues.length - 1; i > 0; i -= 1){
                let changed = true;
                while(needPush(nextValues[i] - nextValues[i - 1]) && changed)({ value: nextValues[i - 1], changed } = offsetChangedValue(nextValues, -1, i - 1));
            }
            // Start to End
            for(let i = 0; i < nextValues.length - 1; i += 1){
                let changed = true;
                while(needPush(nextValues[i + 1] - nextValues[i]) && changed)({ value: nextValues[i + 1], changed } = offsetChangedValue(nextValues, 1, i + 1));
            }
        }
        return {
            value: nextValues[valueIndex],
            values: nextValues
        };
    };
    return [
        formatValue,
        offsetValues
    ];
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cvFzM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRange);
var _warning = require("@rc-component/util/es/warning");
var _react = require("react");
function useRange(range) {
    return (0, _react.useMemo)(()=>{
        if (range === true || !range) return [
            !!range,
            false,
            false,
            0
        ];
        const { editable, draggableTrack, minCount, maxCount } = range;
        return [
            true,
            editable,
            !editable && draggableTrack,
            minCount || 0,
            maxCount
        ];
    }, [
        range
    ]);
}

},{"@rc-component/util/es/warning":"hJXDS","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ajbAx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
let raf = (callback)=>+setTimeout(callback, 16);
let caf = (num)=>clearTimeout(num);
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
    raf = (callback)=>window.requestAnimationFrame(callback);
    caf = (handle)=>window.cancelAnimationFrame(handle);
}
let rafUUID = 0;
const rafIds = new Map();
function cleanup(id) {
    rafIds.delete(id);
}
const wrapperRaf = (callback, times = 1)=>{
    rafUUID += 1;
    const id = rafUUID;
    function callRef(leftTimes) {
        if (leftTimes === 0) {
            // Clean up
            cleanup(id);
            // Trigger
            callback();
        } else {
            // Next raf
            const realId = raf(()=>{
                callRef(leftTimes - 1);
            });
            // Bind real raf id
            rafIds.set(id, realId);
        }
    }
    callRef(times);
    return id;
};
wrapperRaf.cancel = (id)=>{
    const realId = rafIds.get(id);
    cleanup(id);
    return caf(realId);
};
exports.default = wrapperRaf;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kdnMA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mergeClassNames", ()=>mergeClassNames);
parcelHelpers.export(exports, "mergeStyles", ()=>mergeStyles);
parcelHelpers.export(exports, "resolveStyleOrClass", ()=>resolveStyleOrClass);
parcelHelpers.export(exports, "useMergeSemantic", ()=>useMergeSemantic);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _clsx = require("clsx");
const mergeClassNames = (schema, ...classNames)=>{
    const mergedSchema = schema || {};
    return classNames.filter(Boolean).reduce((acc, cur)=>{
        // Loop keys of the current classNames
        Object.keys(cur || {}).forEach((key)=>{
            const keySchema = mergedSchema[key];
            const curVal = cur[key];
            if (keySchema && typeof keySchema === 'object') {
                if (curVal && typeof curVal === 'object') // Loop fill
                acc[key] = mergeClassNames(keySchema, acc[key], curVal);
                else {
                    // Covert string to object structure
                    const { _default: defaultField } = keySchema;
                    if (defaultField) {
                        acc[key] = acc[key] || {};
                        acc[key][defaultField] = (0, _clsx.clsx)(acc[key][defaultField], curVal);
                    }
                }
            } else // Flatten fill
            acc[key] = (0, _clsx.clsx)(acc[key], curVal);
        });
        return acc;
    }, {});
};
const useSemanticClassNames = (schema, ...classNames)=>{
    return _react.useMemo(()=>mergeClassNames.apply(void 0, [
            schema
        ].concat(classNames)), [
        schema
    ].concat(classNames));
};
const mergeStyles = (...styles)=>{
    return styles.filter(Boolean).reduce((acc, cur = {})=>{
        Object.keys(cur).forEach((key)=>{
            acc[key] = {
                ...acc[key],
                ...cur[key]
            };
        });
        return acc;
    }, {});
};
const useSemanticStyles = (...styles)=>{
    return _react.useMemo(()=>mergeStyles.apply(void 0, styles), [].concat(styles));
};
// =========================== Export ===========================
const fillObjectBySchema = (obj, schema)=>{
    const newObj = {
        ...obj
    };
    Object.keys(schema).forEach((key)=>{
        if (key !== '_default') {
            const nestSchema = schema[key];
            const nextValue = newObj[key] || {};
            newObj[key] = nestSchema ? fillObjectBySchema(nextValue, nestSchema) : nextValue;
        }
    });
    return newObj;
};
const resolveStyleOrClass = (value, info)=>{
    return typeof value === 'function' ? value(info) : value;
};
const useMergeSemantic = (classNamesList, stylesList, info, schema)=>{
    const resolvedClassNamesList = classNamesList.map((classNames)=>classNames ? resolveStyleOrClass(classNames, info) : undefined);
    const resolvedStylesList = stylesList.map((styles)=>styles ? resolveStyleOrClass(styles, info) : undefined);
    const mergedClassNames = useSemanticClassNames.apply(void 0, [
        schema
    ].concat((0, _toConsumableArrayDefault.default)(resolvedClassNamesList)));
    const mergedStyles = useSemanticStyles.apply(void 0, (0, _toConsumableArrayDefault.default)(resolvedStylesList));
    return _react.useMemo(()=>{
        if (!schema) return [
            mergedClassNames,
            mergedStyles
        ];
        return [
            fillObjectBySchema(mergedClassNames, schema),
            fillObjectBySchema(mergedStyles, schema)
        ];
    }, [
        mergedClassNames,
        mergedStyles,
        schema
    ]);
};

},{"@babel/runtime/helpers/esm/toConsumableArray":"inIie","react":"bmhQu","clsx":"431Ou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"inIie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_toConsumableArray);
var _arrayWithoutHolesJs = require("./arrayWithoutHoles.js");
var _arrayWithoutHolesJsDefault = parcelHelpers.interopDefault(_arrayWithoutHolesJs);
var _iterableToArrayJs = require("./iterableToArray.js");
var _iterableToArrayJsDefault = parcelHelpers.interopDefault(_iterableToArrayJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableSpreadJs = require("./nonIterableSpread.js");
var _nonIterableSpreadJsDefault = parcelHelpers.interopDefault(_nonIterableSpreadJs);
function _toConsumableArray(r) {
    return (0, _arrayWithoutHolesJsDefault.default)(r) || (0, _iterableToArrayJsDefault.default)(r) || (0, _unsupportedIterableToArrayJsDefault.default)(r) || (0, _nonIterableSpreadJsDefault.default)();
}

},{"./arrayWithoutHoles.js":"7Gi0e","./iterableToArray.js":"aiqkl","./unsupportedIterableToArray.js":"cL2qX","./nonIterableSpread.js":"7hnyW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7Gi0e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithoutHoles);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _arrayWithoutHoles(r) {
    if (Array.isArray(r)) return (0, _arrayLikeToArrayJsDefault.default)(r);
}

},{"./arrayLikeToArray.js":"9oYS4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9oYS4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayLikeToArray);
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aiqkl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArray);
function _iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cL2qX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_unsupportedIterableToArray);
var _arrayLikeToArrayJs = require("./arrayLikeToArray.js");
var _arrayLikeToArrayJsDefault = parcelHelpers.interopDefault(_arrayLikeToArrayJs);
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, _arrayLikeToArrayJsDefault.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, _arrayLikeToArrayJsDefault.default)(r, a) : void 0;
    }
}

},{"./arrayLikeToArray.js":"9oYS4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7hnyW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableSpread);
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k313C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useOrientation", ()=>useOrientation);
var _react = require("react");
const isValidOrientation = (orientation)=>{
    return orientation === 'horizontal' || orientation === 'vertical';
};
const useOrientation = (orientation, vertical, legacyDirection)=>{
    return (0, _react.useMemo)(()=>{
        const validOrientation = isValidOrientation(orientation);
        let mergedOrientation;
        if (validOrientation) mergedOrientation = orientation;
        else if (typeof vertical === 'boolean') mergedOrientation = vertical ? 'vertical' : 'horizontal';
        else {
            const validLegacyDirection = isValidOrientation(legacyDirection);
            mergedOrientation = validLegacyDirection ? legacyDirection : 'horizontal';
        }
        return [
            mergedOrientation,
            mergedOrientation === 'vertical'
        ];
    }, [
        legacyDirection,
        orientation,
        vertical
    ]);
};

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"95o3w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "resetWarned", ()=>resetWarned);
parcelHelpers.export(exports, "WarningContext", ()=>WarningContext);
parcelHelpers.export(exports, "devUseWarning", ()=>devUseWarning);
var _react = require("react");
var _util = require("@rc-component/util");
function noop() {}
const { resetWarned: rcResetWarned } = (0, _util.warning);
let deprecatedWarnList = null;
function resetWarned() {
    deprecatedWarnList = null;
    rcResetWarned();
}
let _warning = noop;
var valid, component, message;
const warning = _warning;
const WarningContext = /*#__PURE__*/ _react.createContext({});
const devUseWarning = ()=>{
    const noopWarning = ()=>{};
    noopWarning.deprecated = noop;
    return noopWarning;
};
exports.default = warning;

},{"react":"bmhQu","@rc-component/util":"6ZBDN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ZBDN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useEvent", ()=>(0, _useEventDefault.default));
parcelHelpers.export(exports, "useMergedState", ()=>(0, _useMergedStateDefault.default));
parcelHelpers.export(exports, "useControlledState", ()=>(0, _useControlledStateDefault.default));
parcelHelpers.export(exports, "supportNodeRef", ()=>(0, _ref.supportNodeRef));
parcelHelpers.export(exports, "supportRef", ()=>(0, _ref.supportRef));
parcelHelpers.export(exports, "useComposeRef", ()=>(0, _ref.useComposeRef));
parcelHelpers.export(exports, "get", ()=>(0, _getDefault.default));
parcelHelpers.export(exports, "set", ()=>(0, _setDefault.default));
parcelHelpers.export(exports, "merge", ()=>(0, _set.merge));
parcelHelpers.export(exports, "mergeWith", ()=>(0, _set.mergeWith));
parcelHelpers.export(exports, "warning", ()=>(0, _warningDefault.default));
parcelHelpers.export(exports, "noteOnce", ()=>(0, _warning.noteOnce));
parcelHelpers.export(exports, "omit", ()=>(0, _omitDefault.default));
parcelHelpers.export(exports, "toArray", ()=>(0, _toArrayDefault.default));
var _useEvent = require("./hooks/useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var _useMergedState = require("./hooks/useMergedState");
var _useMergedStateDefault = parcelHelpers.interopDefault(_useMergedState);
var _useControlledState = require("./hooks/useControlledState");
var _useControlledStateDefault = parcelHelpers.interopDefault(_useControlledState);
var _ref = require("./ref");
var _get = require("./utils/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _set = require("./utils/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _warning = require("./warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _omit = require("./omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _toArray = require("./Children/toArray");
var _toArrayDefault = parcelHelpers.interopDefault(_toArray);

},{"./hooks/useEvent":"klq5U","./hooks/useMergedState":"hf663","./hooks/useControlledState":"2FQtD","./ref":"jmzjd","./utils/get":"f60uf","./utils/set":"hA7hn","./warning":"hJXDS","./omit":"1VS01","./Children/toArray":"7sTeM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hf663":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMergedState);
var _useEvent = require("./useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var _useLayoutEffect = require("./useLayoutEffect");
var _useState = require("./useState");
var _useStateDefault = parcelHelpers.interopDefault(_useState);
/** We only think `undefined` is empty */ function hasValue(value) {
    return value !== undefined;
}
function useMergedState(defaultStateValue, option) {
    const { defaultValue, value, onChange, postState } = option || {};
    // ======================= Init =======================
    const [innerValue, setInnerValue] = (0, _useStateDefault.default)(()=>{
        if (hasValue(value)) return value;
        else if (hasValue(defaultValue)) return typeof defaultValue === 'function' ? defaultValue() : defaultValue;
        else return typeof defaultStateValue === 'function' ? defaultStateValue() : defaultStateValue;
    });
    const mergedValue = value !== undefined ? value : innerValue;
    const postMergedValue = postState ? postState(mergedValue) : mergedValue;
    // ====================== Change ======================
    const onChangeFn = (0, _useEventDefault.default)(onChange);
    const [prevValue, setPrevValue] = (0, _useStateDefault.default)([
        mergedValue
    ]);
    (0, _useLayoutEffect.useLayoutUpdateEffect)(()=>{
        const prev = prevValue[0];
        if (innerValue !== prev) onChangeFn(innerValue, prev);
    }, [
        prevValue
    ]);
    // Sync value back to `undefined` when it from control to un-control
    (0, _useLayoutEffect.useLayoutUpdateEffect)(()=>{
        if (!hasValue(value)) setInnerValue(value);
    }, [
        value
    ]);
    // ====================== Update ======================
    const triggerChange = (0, _useEventDefault.default)((updater, ignoreDestroy)=>{
        setInnerValue(updater, ignoreDestroy);
        setPrevValue([
            mergedValue
        ], ignoreDestroy);
    });
    return [
        postMergedValue,
        triggerChange
    ];
}

},{"./useEvent":"klq5U","./useLayoutEffect":"azwns","./useState":"lIOMx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lIOMx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSafeState);
var _react = require("react");
function useSafeState(defaultValue) {
    const destroyRef = _react.useRef(false);
    const [value, setValue] = _react.useState(defaultValue);
    _react.useEffect(()=>{
        destroyRef.current = false;
        return ()=>{
            destroyRef.current = true;
        };
    }, []);
    function safeSetState(updater, ignoreDestroy) {
        if (ignoreDestroy && destroyRef.current) return;
        setValue(updater);
    }
    return [
        value,
        safeSetState
    ];
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jmzjd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillRef", ()=>fillRef);
parcelHelpers.export(exports, "composeRef", ()=>composeRef);
parcelHelpers.export(exports, "useComposeRef", ()=>useComposeRef);
parcelHelpers.export(exports, "supportRef", ()=>supportRef);
parcelHelpers.export(exports, "supportNodeRef", ()=>supportNodeRef);
parcelHelpers.export(exports, "getNodeRef", ()=>getNodeRef);
var _react = require("react");
var _reactIs = require("react-is");
var _useMemo = require("./hooks/useMemo");
var _useMemoDefault = parcelHelpers.interopDefault(_useMemo);
var _isFragment = require("./React/isFragment");
var _isFragmentDefault = parcelHelpers.interopDefault(_isFragment);
const ReactMajorVersion = Number((0, _react.version).split('.')[0]);
const fillRef = (ref, node)=>{
    if (typeof ref === 'function') ref(node);
    else if (typeof ref === 'object' && ref && 'current' in ref) ref.current = node;
};
const composeRef = (...refs)=>{
    const refList = refs.filter(Boolean);
    if (refList.length <= 1) return refList[0];
    return (node)=>{
        refs.forEach((ref)=>{
            fillRef(ref, node);
        });
    };
};
const useComposeRef = (...refs)=>{
    return (0, _useMemoDefault.default)(()=>composeRef(...refs), // eslint-disable-next-line react-hooks/exhaustive-deps
    refs, (prev, next)=>prev.length !== next.length || prev.every((ref, i)=>ref !== next[i]));
};
const supportRef = (nodeOrComponent)=>{
    if (!nodeOrComponent) return false;
    // React 19 no need `forwardRef` anymore. So just pass if is a React element.
    if (isReactElement(nodeOrComponent) && ReactMajorVersion >= 19) return true;
    const type = (0, _reactIs.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
    // Function component node
    if (typeof type === 'function' && !type.prototype?.render && type.$$typeof !== (0, _reactIs.ForwardRef)) return false;
    // Class component
    if (typeof nodeOrComponent === 'function' && !nodeOrComponent.prototype?.render && nodeOrComponent.$$typeof !== (0, _reactIs.ForwardRef)) return false;
    return true;
};
function isReactElement(node) {
    return /*#__PURE__*/ (0, _react.isValidElement)(node) && !(0, _isFragmentDefault.default)(node);
}
const supportNodeRef = (node)=>{
    return isReactElement(node) && supportRef(node);
};
const getNodeRef = (node)=>{
    if (node && isReactElement(node)) {
        const ele = node;
        // Source from:
        // https://github.com/mui/material-ui/blob/master/packages/mui-utils/src/getReactNodeRef/getReactNodeRef.ts
        return ele.props.propertyIsEnumerable('ref') ? ele.props.ref : ele.ref;
    }
    return null;
};

},{"react":"bmhQu","react-is":"ewqjW","./hooks/useMemo":"8LJN8","./React/isFragment":"bxy6h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ewqjW":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("b02e9068a87280c6");

},{"b02e9068a87280c6":"2hJcH"}],"2hJcH":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var b = Symbol.for("react.element"), c = Symbol.for("react.portal"), d = Symbol.for("react.fragment"), e = Symbol.for("react.strict_mode"), f = Symbol.for("react.profiler"), g = Symbol.for("react.provider"), h = Symbol.for("react.context"), k = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), n = Symbol.for("react.suspense_list"), p = Symbol.for("react.memo"), q = Symbol.for("react.lazy"), t = Symbol.for("react.offscreen"), u;
u = Symbol.for("react.module.reference");
function v(a) {
    if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch(r){
            case b:
                switch(a = a.type, a){
                    case d:
                    case f:
                    case e:
                    case m:
                    case n:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case k:
                            case h:
                            case l:
                            case q:
                            case p:
                            case g:
                                return a;
                            default:
                                return r;
                        }
                }
            case c:
                return r;
        }
    }
}
exports.ContextConsumer = h;
exports.ContextProvider = g;
exports.Element = b;
exports.ForwardRef = l;
exports.Fragment = d;
exports.Lazy = q;
exports.Memo = p;
exports.Portal = c;
exports.Profiler = f;
exports.StrictMode = e;
exports.Suspense = m;
exports.SuspenseList = n;
exports.isAsyncMode = function() {
    return !1;
};
exports.isConcurrentMode = function() {
    return !1;
};
exports.isContextConsumer = function(a) {
    return v(a) === h;
};
exports.isContextProvider = function(a) {
    return v(a) === g;
};
exports.isElement = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === b;
};
exports.isForwardRef = function(a) {
    return v(a) === l;
};
exports.isFragment = function(a) {
    return v(a) === d;
};
exports.isLazy = function(a) {
    return v(a) === q;
};
exports.isMemo = function(a) {
    return v(a) === p;
};
exports.isPortal = function(a) {
    return v(a) === c;
};
exports.isProfiler = function(a) {
    return v(a) === f;
};
exports.isStrictMode = function(a) {
    return v(a) === e;
};
exports.isSuspense = function(a) {
    return v(a) === m;
};
exports.isSuspenseList = function(a) {
    return v(a) === n;
};
exports.isValidElementType = function(a) {
    return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? !0 : !1;
};
exports.typeOf = v;

},{}],"8LJN8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMemo);
var _react = require("react");
function useMemo(getValue, condition, shouldUpdate) {
    const cacheRef = _react.useRef({});
    if (!('value' in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
        cacheRef.current.value = getValue();
        cacheRef.current.condition = condition;
    }
    return cacheRef.current.value;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bxy6h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isFragment);
const REACT_ELEMENT_TYPE_18 = Symbol.for('react.element');
const REACT_ELEMENT_TYPE_19 = Symbol.for('react.transitional.element');
const REACT_FRAGMENT_TYPE = Symbol.for('react.fragment');
function isFragment(object) {
    return(// Base object type
    object && typeof object === 'object' && // React Element type
    (object.$$typeof === REACT_ELEMENT_TYPE_18 || object.$$typeof === REACT_ELEMENT_TYPE_19) && // React Fragment type
    object.type === REACT_FRAGMENT_TYPE);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f60uf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>get);
function get(entity, path) {
    let current = entity;
    for(let i = 0; i < path.length; i += 1){
        if (current === null || current === undefined) return undefined;
        current = current[path[i]];
    }
    return current;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hA7hn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>set);
// ================================ Merge ================================
/**
 * Merge multiple objects. Support custom merge logic.
 * @param sources object sources
 * @param config.prepareArray Customize array prepare function.
 * It will return empty [] by default.
 * So when match array, it will auto be override with next array in sources.
 */ parcelHelpers.export(exports, "mergeWith", ()=>mergeWith);
/**
 * Merge multiple objects into a new single object.
 * Arrays will be replaced by default.
 */ parcelHelpers.export(exports, "merge", ()=>merge);
var _get = require("./get");
var _getDefault = parcelHelpers.interopDefault(_get);
function internalSet(entity, paths, value, removeIfUndefined) {
    if (!paths.length) return value;
    const [path, ...restPath] = paths;
    let clone;
    if (!entity && typeof path === 'number') clone = [];
    else if (Array.isArray(entity)) clone = [
        ...entity
    ];
    else clone = {
        ...entity
    };
    // Delete prop if `removeIfUndefined` and value is undefined
    if (removeIfUndefined && value === undefined && restPath.length === 1) delete clone[path][restPath[0]];
    else clone[path] = internalSet(clone[path], restPath, value, removeIfUndefined);
    return clone;
}
function set(entity, paths, value, removeIfUndefined = false) {
    // Do nothing if `removeIfUndefined` and parent object not exist
    if (paths.length && removeIfUndefined && value === undefined && !(0, _getDefault.default)(entity, paths.slice(0, -1))) return entity;
    return internalSet(entity, paths, value, removeIfUndefined);
}
function isObject(obj) {
    return typeof obj === 'object' && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function createEmpty(source) {
    return Array.isArray(source) ? [] : {};
}
const keys = typeof Reflect === 'undefined' ? Object.keys : Reflect.ownKeys;
function mergeWith(sources, config = {}) {
    const { prepareArray } = config;
    const finalPrepareArray = prepareArray || (()=>[]);
    let clone = createEmpty(sources[0]);
    sources.forEach((src)=>{
        function internalMerge(path, parentLoopSet) {
            const loopSet = new Set(parentLoopSet);
            const value = (0, _getDefault.default)(src, path);
            const isArr = Array.isArray(value);
            if (isArr || isObject(value)) // Only add not loop obj
            {
                if (!loopSet.has(value)) {
                    loopSet.add(value);
                    const originValue = (0, _getDefault.default)(clone, path);
                    if (isArr) // Array will always be override
                    clone = set(clone, path, finalPrepareArray(originValue, value));
                    else if (!originValue || typeof originValue !== 'object') // Init container if not exist
                    clone = set(clone, path, createEmpty(value));
                    keys(value).forEach((key)=>{
                        if (Object.getOwnPropertyDescriptor(value, key).enumerable) internalMerge([
                            ...path,
                            key
                        ], loopSet);
                    });
                }
            } else clone = set(clone, path, value);
        }
        internalMerge([]);
    });
    return clone;
}
function merge(...sources) {
    return mergeWith(sources);
}

},{"./get":"f60uf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1VS01":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>omit);
function omit(obj, fields) {
    const clone = Object.assign({}, obj);
    if (Array.isArray(fields)) fields.forEach((key)=>{
        delete clone[key];
    });
    return clone;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7sTeM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toArray);
var _isFragment = require("../React/isFragment");
var _isFragmentDefault = parcelHelpers.interopDefault(_isFragment);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function toArray(children, option = {}) {
    let ret = [];
    (0, _reactDefault.default).Children.forEach(children, (child)=>{
        if ((child === undefined || child === null) && !option.keepEmpty) return;
        if (Array.isArray(child)) ret = ret.concat(toArray(child));
        else if ((0, _isFragmentDefault.default)(child) && child.props) ret = ret.concat(toArray(child.props.children, option));
        else ret.push(child);
    });
    return ret;
}

},{"../React/isFragment":"bxy6h","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"75zwC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultPrefixCls", ()=>defaultPrefixCls);
parcelHelpers.export(exports, "defaultIconPrefixCls", ()=>defaultIconPrefixCls);
parcelHelpers.export(exports, "Variants", ()=>Variants);
parcelHelpers.export(exports, "ConfigContext", ()=>ConfigContext);
parcelHelpers.export(exports, "ConfigConsumer", ()=>ConfigConsumer);
/**
 * Get ConfigProvider configured component props.
 * This help to reduce bundle size for saving `?.` operator.
 * Do not use as `useMemo` deps since we do not cache the object here.
 *
 * NOTE: not refactor this with `useMemo` since memo will cost another memory space,
 * which will waste both compare calculation & memory.
 */ parcelHelpers.export(exports, "useComponentConfig", ()=>useComponentConfig);
var _react = require("react");
const defaultPrefixCls = 'ant';
const defaultIconPrefixCls = 'anticon';
const Variants = [
    'outlined',
    'borderless',
    'filled',
    'underlined'
];
const defaultGetPrefixCls = (suffixCls, customizePrefixCls)=>{
    if (customizePrefixCls) return customizePrefixCls;
    return suffixCls ? `${defaultPrefixCls}-${suffixCls}` : defaultPrefixCls;
};
const ConfigContext = /*#__PURE__*/ _react.createContext({
    // We provide a default function for Context without provider
    getPrefixCls: defaultGetPrefixCls,
    iconPrefixCls: defaultIconPrefixCls
});
const { Consumer: ConfigConsumer } = ConfigContext;
const EMPTY_OBJECT = {};
function useComponentConfig(propName) {
    const context = _react.useContext(ConfigContext);
    const { getPrefixCls, direction, getPopupContainer, renderEmpty } = context;
    const propValue = context[propName];
    return {
        classNames: EMPTY_OBJECT,
        styles: EMPTY_OBJECT,
        ...propValue,
        getPrefixCls,
        direction,
        getPopupContainer,
        renderEmpty
    };
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h4TcW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DisabledContextProvider", ()=>DisabledContextProvider);
var _react = require("react");
"use client";
const DisabledContext = /*#__PURE__*/ _react.createContext(false);
const DisabledContextProvider = ({ children, disabled })=>{
    const originDisabled = _react.useContext(DisabledContext);
    return /*#__PURE__*/ _react.createElement(DisabledContext.Provider, {
        value: disabled ?? originDisabled
    }, children);
};
exports.default = DisabledContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bvtQ4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
/** @private Internal context. Do not use in your production. */ const SliderInternalContext = /*#__PURE__*/ (0, _react.createContext)({});
exports.default = SliderInternalContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4SC5M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _ref = require("@rc-component/util/es/ref");
var _tooltip = require("../tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
"use client";
const SliderTooltip = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { open, draggingDelete, value } = props;
    const innerRef = (0, _react.useRef)(null);
    const mergedOpen = open && !draggingDelete;
    const rafRef = (0, _react.useRef)(null);
    function cancelKeepAlign() {
        (0, _rafDefault.default).cancel(rafRef.current);
        rafRef.current = null;
    }
    function keepAlign() {
        rafRef.current = (0, _rafDefault.default)(()=>{
            innerRef.current?.forceAlign();
            rafRef.current = null;
        });
    }
    _react.useEffect(()=>{
        if (mergedOpen) keepAlign();
        else cancelKeepAlign();
        return cancelKeepAlign;
    }, [
        mergedOpen,
        props.title,
        value
    ]);
    return /*#__PURE__*/ _react.createElement((0, _tooltipDefault.default), {
        ref: (0, _ref.composeRef)(innerRef, ref),
        ...props,
        open: mergedOpen
    });
});
exports.default = SliderTooltip;

},{"react":"bmhQu","@rc-component/util/es/raf":"ajbAx","@rc-component/util/es/ref":"jmzjd","../tooltip":"aByoO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aByoO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _tooltip = require("@rc-component/tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _contextIsolator = require("../_util/ContextIsolator");
var _contextIsolatorDefault = parcelHelpers.interopDefault(_contextIsolator);
var _hooks = require("../_util/hooks");
var _motion = require("../_util/motion");
var _placements = require("../_util/placements");
var _placementsDefault = parcelHelpers.interopDefault(_placements);
var _reactNode = require("../_util/reactNode");
var _warning = require("../_util/warning");
var _zindexContext = require("../_util/zindexContext");
var _zindexContextDefault = parcelHelpers.interopDefault(_zindexContext);
var _context = require("../config-provider/context");
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _internal = require("../theme/internal");
var _useMergedArrow = require("./hook/useMergedArrow");
var _useMergedArrowDefault = parcelHelpers.interopDefault(_useMergedArrow);
var _purePanel = require("./PurePanel");
var _purePanelDefault = parcelHelpers.interopDefault(_purePanel);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _uniqueProvider = require("./UniqueProvider");
var _uniqueProviderDefault = parcelHelpers.interopDefault(_uniqueProvider);
var _util1 = require("./util");
"use client";
const InternalTooltip = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, openClassName, getTooltipContainer, color, children, afterOpenChange, arrow: tooltipArrow, destroyTooltipOnHide, destroyOnHidden, title, overlay, trigger, builtinPlacements, autoAdjustOverflow = true, motion, getPopupContainer, placement = 'top', mouseEnterDelay = 0.1, mouseLeaveDelay = 0.1, rootClassName, styles, classNames, onOpenChange, // Legacy
    overlayInnerStyle, overlayStyle, overlayClassName, ...restProps } = props;
    const [, token] = (0, _internal.useToken)();
    const { getPopupContainer: getContextPopupContainer, getPrefixCls, direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow, trigger: contextTrigger } = (0, _context.useComponentConfig)('tooltip');
    const mergedArrow = (0, _useMergedArrowDefault.default)(tooltipArrow, contextArrow);
    const mergedShowArrow = mergedArrow.show;
    const mergedTrigger = trigger || contextTrigger || 'hover';
    // ============================== Ref ===============================
    const warning = (0, _warning.devUseWarning)('Tooltip');
    const tooltipRef = _react.useRef(null);
    const forceAlign = ()=>{
        tooltipRef.current?.forceAlign();
    };
    _react.useImperativeHandle(ref, ()=>({
            forceAlign,
            nativeElement: tooltipRef.current?.nativeElement,
            popupElement: tooltipRef.current?.popupElement
        }));
    var deprecatedName, newName;
    // ============================== Open ==============================
    const [open, setOpen] = (0, _util.useControlledState)(props.defaultOpen ?? false, props.open);
    const noTitle = !title && !overlay && title !== 0; // overlay for old version compatibility
    const onInternalOpenChange = (vis)=>{
        setOpen(noTitle ? false : vis);
        if (!noTitle && onOpenChange) onOpenChange(vis);
    };
    const tooltipPlacements = _react.useMemo(()=>{
        return builtinPlacements || (0, _placementsDefault.default)({
            arrowPointAtCenter: mergedArrow?.pointAtCenter ?? false,
            autoAdjustOverflow,
            arrowWidth: mergedShowArrow ? token.sizePopupArrow : 0,
            borderRadius: token.borderRadius,
            offset: token.marginXXS,
            visibleFirst: true
        });
    }, [
        mergedArrow,
        builtinPlacements,
        token,
        mergedShowArrow,
        autoAdjustOverflow
    ]);
    const memoOverlay = _react.useMemo(()=>{
        if (title === 0) return title;
        return overlay || title || '';
    }, [
        overlay,
        title
    ]);
    const memoOverlayWrapper = /*#__PURE__*/ _react.createElement((0, _contextIsolatorDefault.default), {
        space: true
    }, typeof memoOverlay === 'function' ? memoOverlay() : memoOverlay);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        trigger: mergedTrigger,
        color,
        placement,
        builtinPlacements,
        openClassName,
        arrow: tooltipArrow,
        autoAdjustOverflow,
        getPopupContainer,
        children,
        destroyTooltipOnHide,
        destroyOnHidden
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const injectFromPopover = props['data-popover-inject'];
    let tempOpen = open;
    // Hide tooltip when there is no title
    if (!('open' in props) && noTitle) tempOpen = false;
    // ============================= Render =============================
    const child = /*#__PURE__*/ _react.isValidElement(children) && !(0, _reactNode.isFragment)(children) ? children : /*#__PURE__*/ _react.createElement("span", null, children);
    const childProps = child.props;
    const childCls = !childProps.className || typeof childProps.className === 'string' ? (0, _clsx.clsx)(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
    // Style
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls, !injectFromPopover);
    // Color
    const colorInfo = (0, _util1.parseColor)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const themeCls = (0, _clsx.clsx)(rootCls, hashId, cssVarCls);
    const rootClassNames = (0, _clsx.clsx)(overlayClassName, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, colorInfo.className, rootClassName, themeCls, contextClassName, mergedClassNames.root);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, _hooks.useZIndex)('Tooltip', restProps.zIndex);
    const containerStyle = {
        ...mergedStyles.container,
        ...overlayInnerStyle,
        ...colorInfo.overlayStyle
    };
    const content = /*#__PURE__*/ _react.createElement((0, _tooltipDefault.default), {
        unique: true,
        ...restProps,
        trigger: mergedTrigger,
        zIndex: zIndex,
        showArrow: mergedShowArrow,
        placement: placement,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow,
            uniqueContainer: (0, _clsx.clsx)(themeCls, mergedClassNames.container)
        },
        styles: {
            root: {
                ...arrowContentStyle,
                ...mergedStyles.root,
                ...contextStyle,
                ...overlayStyle
            },
            container: containerStyle,
            uniqueContainer: containerStyle,
            arrow: mergedStyles.arrow
        },
        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
        ref: tooltipRef,
        builtinPlacements: tooltipPlacements,
        overlay: memoOverlayWrapper,
        visible: tempOpen,
        onVisibleChange: onInternalOpenChange,
        afterVisibleChange: afterOpenChange,
        arrowContent: /*#__PURE__*/ _react.createElement("span", {
            className: `${prefixCls}-arrow-content`
        }),
        motion: {
            motionName: (0, _motion.getTransitionName)(rootPrefixCls, 'zoom-big-fast', typeof motion?.motionName === 'string' ? motion?.motionName : undefined),
            motionDeadline: 1000
        },
        destroyOnHidden: destroyOnHidden ?? !!destroyTooltipOnHide
    }, tempOpen ? (0, _reactNode.cloneElement)(child, {
        className: childCls
    }) : child);
    return /*#__PURE__*/ _react.createElement((0, _zindexContextDefault.default).Provider, {
        value: contextZIndex
    }, content);
});
const Tooltip = InternalTooltip;
Tooltip._InternalPanelDoNotUseOrYouWillBeFired = (0, _purePanelDefault.default);
Tooltip.UniqueProvider = (0, _uniqueProviderDefault.default);
exports.default = Tooltip;

},{"react":"bmhQu","@rc-component/tooltip":"9UTy2","@rc-component/util":"6ZBDN","clsx":"431Ou","../_util/ContextIsolator":"5aVQ9","../_util/hooks":[["useMergeSemantic","kdnMA"],["useZIndex","6noQ6"]],"../_util/motion":"kUUSo","../_util/placements":"gti5Y","../_util/reactNode":"78pFx","../_util/warning":"95o3w","../_util/zindexContext":"e9ihh","../config-provider/context":"75zwC","../config-provider/hooks/useCSSVarCls":"gcu2s","../theme/internal":[["useToken","6x222","default"]],"./hook/useMergedArrow":"jKxW0","./PurePanel":"l827w","./style":"6JllX","./UniqueProvider":"5ZqU0","./util":"4stfi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9UTy2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Popup", ()=>(0, _popupDefault.default));
var _popup = require("./Popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
var _tooltip = require("./Tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
exports.default = (0, _tooltipDefault.default);

},{"./Popup":"f0Wyf","./Tooltip":"arg4J","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f0Wyf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _react = require("react");
const Popup = (props)=>{
    const { children, prefixCls, id, classNames, styles, className, style } = props;
    return /*#__PURE__*/ _react.createElement("div", {
        id: id,
        className: (0, _clsx.clsx)(`${prefixCls}-container`, classNames?.container, className),
        style: {
            ...styles?.container,
            ...style
        },
        role: "tooltip"
    }, typeof children === 'function' ? children() : children);
};
exports.default = Popup;

},{"clsx":"431Ou","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"arg4J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trigger = require("@rc-component/trigger");
var _triggerDefault = parcelHelpers.interopDefault(_trigger);
var _useId = require("@rc-component/util/es/hooks/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _clsx = require("clsx");
var _react = require("react");
var _placements = require("./placements");
var _popup = require("./Popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Tooltip = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { trigger = [
        'hover'
    ], mouseEnterDelay = 0, mouseLeaveDelay = 0.1, prefixCls = 'rc-tooltip', children, onVisibleChange, afterVisibleChange, motion, placement = 'right', align = {}, destroyOnHidden = false, defaultVisible, getTooltipContainer, arrowContent, overlay, id, showArrow = true, classNames, styles, ...restProps } = props;
    const mergedId = (0, _useIdDefault.default)(id);
    const triggerRef = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>triggerRef.current);
    const extraProps = {
        ...restProps
    };
    if ('visible' in props) extraProps.popupVisible = props.visible;
    // ========================= Arrow ==========================
    // Process arrow configuration
    const mergedArrow = _react.useMemo(()=>{
        if (!showArrow) return false;
        // Convert true to object for unified processing
        const arrowConfig = showArrow === true ? {} : showArrow;
        // Apply semantic styles with unified logic
        return {
            ...arrowConfig,
            className: (0, _clsx.clsx)(arrowConfig.className, classNames?.arrow),
            style: {
                ...arrowConfig.style,
                ...styles?.arrow
            },
            content: arrowConfig.content ?? arrowContent
        };
    }, [
        showArrow,
        classNames?.arrow,
        styles?.arrow,
        arrowContent
    ]);
    // ======================== Children ========================
    const getChildren = ({ open })=>{
        const child = _react.Children.only(children);
        const ariaProps = {
            'aria-describedby': overlay && open ? mergedId : undefined
        };
        return /*#__PURE__*/ _react.cloneElement(child, ariaProps);
    };
    // ========================= Render =========================
    return /*#__PURE__*/ _react.createElement((0, _triggerDefault.default), _extends({
        popupClassName: classNames?.root,
        prefixCls: prefixCls,
        popup: /*#__PURE__*/ _react.createElement((0, _popupDefault.default), {
            key: "content",
            prefixCls: prefixCls,
            id: mergedId,
            classNames: classNames,
            styles: styles
        }, overlay),
        action: trigger,
        builtinPlacements: (0, _placements.placements),
        popupPlacement: placement,
        ref: triggerRef,
        popupAlign: align,
        getPopupContainer: getTooltipContainer,
        onOpenChange: onVisibleChange,
        afterOpenChange: afterVisibleChange,
        popupMotion: motion,
        defaultPopupVisible: defaultVisible,
        autoDestroy: destroyOnHidden,
        mouseLeaveDelay: mouseLeaveDelay,
        popupStyle: styles?.root,
        mouseEnterDelay: mouseEnterDelay,
        arrow: mergedArrow,
        uniqueContainerClassName: classNames?.uniqueContainer,
        uniqueContainerStyle: styles?.uniqueContainer
    }, extraProps), getChildren);
});
exports.default = Tooltip;

},{"@rc-component/trigger":"8gqi4","@rc-component/util/es/hooks/useId":"910ko","clsx":"431Ou","react":"bmhQu","./placements":"1C4cy","./Popup":"f0Wyf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8gqi4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UniqueProvider", ()=>(0, _uniqueProviderDefault.default));
// Removed Props List
// Seems this can be auto
// getDocument?: (element?: HTMLElement) => Document;
// New version will not wrap popup with `rc-trigger-popup-content` when multiple children
parcelHelpers.export(exports, "generateTrigger", ()=>generateTrigger);
var _portal = require("@rc-component/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _clsx = require("clsx");
var _resizeObserver = require("@rc-component/resize-observer");
var _resizeObserverDefault = parcelHelpers.interopDefault(_resizeObserver);
var _findDOMNode = require("@rc-component/util/es/Dom/findDOMNode");
var _shadow = require("@rc-component/util/es/Dom/shadow");
var _useEvent = require("@rc-component/util/es/hooks/useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var _useId = require("@rc-component/util/es/hooks/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _react = require("react");
var _popup = require("./Popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
var _context = require("./context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _useAction = require("./hooks/useAction");
var _useActionDefault = parcelHelpers.interopDefault(_useAction);
var _useAlign = require("./hooks/useAlign");
var _useAlignDefault = parcelHelpers.interopDefault(_useAlign);
var _useDelay = require("./hooks/useDelay");
var _useDelayDefault = parcelHelpers.interopDefault(_useDelay);
var _useWatch = require("./hooks/useWatch");
var _useWatchDefault = parcelHelpers.interopDefault(_useWatch);
var _useWinClick = require("./hooks/useWinClick");
var _useWinClickDefault = parcelHelpers.interopDefault(_useWinClick);
var _util = require("./util");
var _uniqueProvider = require("./UniqueProvider");
var _uniqueProviderDefault = parcelHelpers.interopDefault(_uniqueProvider);
var _util1 = require("@rc-component/util");
function generateTrigger(PortalComponent = (0, _portalDefault.default)) {
    const Trigger = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
        const { prefixCls = 'rc-trigger-popup', children, // Action
        action = 'hover', showAction, hideAction, // Open
        popupVisible, defaultPopupVisible, onOpenChange, afterOpenChange, onPopupVisibleChange, afterPopupVisibleChange, // Delay
        mouseEnterDelay, mouseLeaveDelay = 0.1, focusDelay, blurDelay, // Mask
        mask, maskClosable = true, // Portal
        getPopupContainer, forceRender, autoDestroy, // Popup
        popup, popupClassName, uniqueContainerClassName, uniqueContainerStyle, popupStyle, popupPlacement, builtinPlacements = {}, popupAlign, zIndex, stretch, getPopupClassNameFromAlign, fresh, unique, alignPoint, onPopupClick, onPopupAlign, // Arrow
        arrow, // Motion
        popupMotion, maskMotion, // Private
        mobile, ...restProps } = props;
        const mergedAutoDestroy = autoDestroy || false;
        const openUncontrolled = popupVisible === undefined;
        // =========================== Mobile ===========================
        const isMobile = !!mobile;
        // ========================== Context ===========================
        const subPopupElements = _react.useRef({});
        const parentContext = _react.useContext((0, _contextDefault.default));
        const context = _react.useMemo(()=>{
            return {
                registerSubPopup: (id, subPopupEle)=>{
                    subPopupElements.current[id] = subPopupEle;
                    parentContext?.registerSubPopup(id, subPopupEle);
                }
            };
        }, [
            parentContext
        ]);
        // ======================== UniqueContext =========================
        const uniqueContext = _react.useContext((0, _context.UniqueContext));
        // =========================== Popup ============================
        const id = (0, _useIdDefault.default)();
        const [popupEle, setPopupEle] = _react.useState(null);
        // Used for forwardRef popup. Not use internal
        const externalPopupRef = _react.useRef(null);
        const setPopupRef = (0, _useEventDefault.default)((node)=>{
            externalPopupRef.current = node;
            if ((0, _findDOMNode.isDOM)(node) && popupEle !== node) setPopupEle(node);
            parentContext?.registerSubPopup(id, node);
        });
        // =========================== Target ===========================
        // Use state to control here since `useRef` update not trigger render
        const [targetEle, setTargetEle] = _react.useState(null);
        // Used for forwardRef target. Not use internal
        const externalForwardRef = _react.useRef(null);
        const setTargetRef = (0, _useEventDefault.default)((node)=>{
            if ((0, _findDOMNode.isDOM)(node) && targetEle !== node) {
                setTargetEle(node);
                externalForwardRef.current = node;
            }
        });
        const cloneProps = {};
        const inPopupOrChild = (0, _useEventDefault.default)((ele)=>{
            const childDOM = targetEle;
            return childDOM?.contains(ele) || (0, _shadow.getShadowRoot)(childDOM)?.host === ele || ele === childDOM || popupEle?.contains(ele) || (0, _shadow.getShadowRoot)(popupEle)?.host === ele || ele === popupEle || Object.values(subPopupElements.current).some((subPopupEle)=>subPopupEle?.contains(ele) || ele === subPopupEle);
        });
        // =========================== Arrow ============================
        const innerArrow = arrow ? {
            // true and Object likely
            ...arrow !== true ? arrow : {}
        } : null;
        // ============================ Open ============================
        const [internalOpen, setInternalOpen] = (0, _util1.useControlledState)(defaultPopupVisible || false, popupVisible);
        const mergedOpen = internalOpen || false;
        // ========================== Children ==========================
        const child = _react.useMemo(()=>{
            const nextChild = typeof children === 'function' ? children({
                open: mergedOpen
            }) : children;
            return _react.Children.only(nextChild);
        }, [
            children,
            mergedOpen
        ]);
        const originChildProps = child?.props || {};
        // Support ref
        const isOpen = (0, _useEventDefault.default)(()=>mergedOpen);
        // Extract common options for UniqueProvider
        const getUniqueOptions = (0, _useEventDefault.default)((delay = 0)=>({
                popup,
                target: targetEle,
                delay,
                prefixCls,
                popupClassName,
                uniqueContainerClassName,
                uniqueContainerStyle,
                popupStyle,
                popupPlacement,
                builtinPlacements,
                popupAlign,
                zIndex,
                mask,
                maskClosable,
                popupMotion,
                maskMotion,
                arrow: innerArrow,
                getPopupContainer,
                getPopupClassNameFromAlign,
                id
            }));
        // Handle controlled state changes for UniqueProvider
        // Only sync to UniqueProvider when it's controlled mode
        // If there is a parentContext, don't call uniqueContext methods
        (0, _useLayoutEffectDefault.default)(()=>{
            if (uniqueContext && unique && targetEle && !openUncontrolled && !parentContext) {
                if (mergedOpen) uniqueContext.show(getUniqueOptions(mouseEnterDelay), isOpen);
                else uniqueContext.hide(mouseLeaveDelay);
            }
        }, [
            mergedOpen,
            targetEle
        ]);
        const openRef = _react.useRef(mergedOpen);
        openRef.current = mergedOpen;
        const lastTriggerRef = _react.useRef([]);
        lastTriggerRef.current = [];
        const internalTriggerOpen = (0, _useEventDefault.default)((nextOpen)=>{
            setInternalOpen(nextOpen);
            // Enter or Pointer will both trigger open state change
            // We only need take one to avoid duplicated change event trigger
            // Use `lastTriggerRef` to record last open type
            if ((lastTriggerRef.current[lastTriggerRef.current.length - 1] ?? mergedOpen) !== nextOpen) {
                lastTriggerRef.current.push(nextOpen);
                onOpenChange?.(nextOpen);
                onPopupVisibleChange?.(nextOpen);
            }
        });
        // Trigger for delay
        const delayInvoke = (0, _useDelayDefault.default)();
        const triggerOpen = (nextOpen, delay = 0)=>{
            // If it's controlled mode, always use internal trigger logic
            // UniqueProvider will be synced through useLayoutEffect
            if (popupVisible !== undefined) {
                delayInvoke(()=>{
                    internalTriggerOpen(nextOpen);
                }, delay);
                return;
            }
            // If UniqueContext exists and not controlled, pass delay to Provider instead of handling it internally
            // If there is a parentContext, don't call uniqueContext methods
            if (uniqueContext && unique && openUncontrolled && !parentContext) {
                if (nextOpen) uniqueContext.show(getUniqueOptions(delay), isOpen);
                else uniqueContext.hide(delay);
                return;
            }
            delayInvoke(()=>{
                internalTriggerOpen(nextOpen);
            }, delay);
        };
        // ========================== Motion ============================
        const [inMotion, setInMotion] = _react.useState(false);
        (0, _useLayoutEffectDefault.default)((firstMount)=>{
            if (!firstMount || mergedOpen) setInMotion(true);
        }, [
            mergedOpen
        ]);
        const [motionPrepareResolve, setMotionPrepareResolve] = _react.useState(null);
        // =========================== Align ============================
        const [mousePos, setMousePos] = _react.useState(null);
        const setMousePosByEvent = (event)=>{
            setMousePos([
                event.clientX,
                event.clientY
            ]);
        };
        const [ready, offsetX, offsetY, offsetR, offsetB, arrowX, arrowY, scaleX, scaleY, alignInfo, onAlign] = (0, _useAlignDefault.default)(mergedOpen, popupEle, alignPoint && mousePos !== null ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign, isMobile);
        const [showActions, hideActions] = (0, _useActionDefault.default)(action, showAction, hideAction);
        const clickToShow = showActions.has('click');
        const clickToHide = hideActions.has('click') || hideActions.has('contextMenu');
        const triggerAlign = (0, _useEventDefault.default)(()=>{
            if (!inMotion) onAlign();
        });
        const onScroll = ()=>{
            if (openRef.current && alignPoint && clickToHide) triggerOpen(false);
        };
        (0, _useWatchDefault.default)(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
        (0, _useLayoutEffectDefault.default)(()=>{
            triggerAlign();
        }, [
            mousePos,
            popupPlacement
        ]);
        // When no builtinPlacements and popupAlign changed
        (0, _useLayoutEffectDefault.default)(()=>{
            if (mergedOpen && !builtinPlacements?.[popupPlacement]) triggerAlign();
        }, [
            JSON.stringify(popupAlign)
        ]);
        const alignedClassName = _react.useMemo(()=>{
            const baseClassName = (0, _util.getAlignPopupClassName)(builtinPlacements, prefixCls, alignInfo, alignPoint);
            return (0, _clsx.clsx)(baseClassName, getPopupClassNameFromAlign?.(alignInfo));
        }, [
            alignInfo,
            getPopupClassNameFromAlign,
            builtinPlacements,
            prefixCls,
            alignPoint
        ]);
        // ============================ Refs ============================
        _react.useImperativeHandle(ref, ()=>({
                nativeElement: externalForwardRef.current,
                popupElement: externalPopupRef.current,
                forceAlign: triggerAlign
            }));
        // ========================== Stretch ===========================
        const [targetWidth, setTargetWidth] = _react.useState(0);
        const [targetHeight, setTargetHeight] = _react.useState(0);
        const syncTargetSize = ()=>{
            if (stretch && targetEle) {
                const rect = targetEle.getBoundingClientRect();
                setTargetWidth(rect.width);
                setTargetHeight(rect.height);
            }
        };
        const onTargetResize = ()=>{
            syncTargetSize();
            triggerAlign();
        };
        // ========================== Motion ============================
        const onVisibleChanged = (visible)=>{
            setInMotion(false);
            onAlign();
            afterOpenChange?.(visible);
            afterPopupVisibleChange?.(visible);
        };
        // We will trigger align when motion is in prepare
        const onPrepare = ()=>new Promise((resolve)=>{
                syncTargetSize();
                setMotionPrepareResolve(()=>resolve);
            });
        (0, _useLayoutEffectDefault.default)(()=>{
            if (motionPrepareResolve) {
                onAlign();
                motionPrepareResolve();
                setMotionPrepareResolve(null);
            }
        }, [
            motionPrepareResolve
        ]);
        // =========================== Action ===========================
        /**
     * Util wrapper for trigger action
     * @param eventName  Listen event name
     * @param nextOpen  Next open state after trigger
     * @param delay Delay to trigger open change
     * @param callback Callback if current event need additional action
     * @param ignoreCheck  Ignore current event if check return true
     */ function wrapperAction(eventName, nextOpen, delay, callback, ignoreCheck) {
            cloneProps[eventName] = (event, ...args)=>{
                if (!ignoreCheck || !ignoreCheck()) {
                    callback?.(event);
                    triggerOpen(nextOpen, delay);
                }
                // Pass to origin
                originChildProps[eventName]?.(event, ...args);
            };
        }
        // ======================= Action: Touch ========================
        const touchToShow = showActions.has('touch');
        const touchToHide = hideActions.has('touch');
        /** Used for prevent `hover` event conflict with mobile env */ const touchedRef = _react.useRef(false);
        if (touchToShow || touchToHide) cloneProps.onTouchStart = (...args)=>{
            touchedRef.current = true;
            if (openRef.current && touchToHide) triggerOpen(false);
            else if (!openRef.current && touchToShow) triggerOpen(true);
            // Pass to origin
            originChildProps.onTouchStart?.(...args);
        };
        // ======================= Action: Click ========================
        if (clickToShow || clickToHide) cloneProps.onClick = (event, ...args)=>{
            if (openRef.current && clickToHide) triggerOpen(false);
            else if (!openRef.current && clickToShow) {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            // Pass to origin
            originChildProps.onClick?.(event, ...args);
            touchedRef.current = false;
        };
        // Click to hide is special action since click popup element should not hide
        const onPopupPointerDown = (0, _useWinClickDefault.default)(mergedOpen, clickToHide || touchToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
        // ======================= Action: Hover ========================
        const hoverToShow = showActions.has('hover');
        const hoverToHide = hideActions.has('hover');
        let onPopupMouseEnter;
        let onPopupMouseLeave;
        const ignoreMouseTrigger = ()=>{
            return touchedRef.current;
        };
        if (hoverToShow) {
            const onMouseEnterCallback = (event)=>{
                setMousePosByEvent(event);
            };
            // Compatible with old browser which not support pointer event
            wrapperAction('onMouseEnter', true, mouseEnterDelay, onMouseEnterCallback, ignoreMouseTrigger);
            wrapperAction('onPointerEnter', true, mouseEnterDelay, onMouseEnterCallback, ignoreMouseTrigger);
            onPopupMouseEnter = (event)=>{
                // Only trigger re-open when popup is visible
                if ((mergedOpen || inMotion) && popupEle?.contains(event.target)) triggerOpen(true, mouseEnterDelay);
            };
            // Align Point
            if (alignPoint) cloneProps.onMouseMove = (event)=>{
                originChildProps.onMouseMove?.(event);
            };
        }
        if (hoverToHide) {
            wrapperAction('onMouseLeave', false, mouseLeaveDelay, undefined, ignoreMouseTrigger);
            wrapperAction('onPointerLeave', false, mouseLeaveDelay, undefined, ignoreMouseTrigger);
            onPopupMouseLeave = ()=>{
                triggerOpen(false, mouseLeaveDelay);
            };
        }
        // ======================= Action: Focus ========================
        if (showActions.has('focus')) wrapperAction('onFocus', true, focusDelay);
        if (hideActions.has('focus')) wrapperAction('onBlur', false, blurDelay);
        // ==================== Action: ContextMenu =====================
        if (showActions.has('contextMenu')) cloneProps.onContextMenu = (event, ...args)=>{
            if (openRef.current && hideActions.has('contextMenu')) triggerOpen(false);
            else {
                setMousePosByEvent(event);
                triggerOpen(true);
            }
            event.preventDefault();
            // Pass to origin
            originChildProps.onContextMenu?.(event, ...args);
        };
        // ============================ Perf ============================
        const rendedRef = _react.useRef(false);
        rendedRef.current ||= forceRender || mergedOpen || inMotion;
        // =========================== Render ===========================
        const mergedChildrenProps = {
            ...originChildProps,
            ...cloneProps
        };
        // Pass props into cloneProps for nest usage
        const passedProps = {};
        const passedEventList = [
            'onContextMenu',
            'onClick',
            'onMouseDown',
            'onTouchStart',
            'onMouseEnter',
            'onMouseLeave',
            'onFocus',
            'onBlur'
        ];
        passedEventList.forEach((eventName)=>{
            if (restProps[eventName]) passedProps[eventName] = (...args)=>{
                mergedChildrenProps[eventName]?.(...args);
                restProps[eventName](...args);
            };
        });
        const arrowPos = {
            x: arrowX,
            y: arrowY
        };
        // Child Node
        const triggerNode = /*#__PURE__*/ _react.cloneElement(child, {
            ...mergedChildrenProps,
            ...passedProps
        });
        // Render
        return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _resizeObserverDefault.default), {
            disabled: !mergedOpen,
            ref: setTargetRef,
            onResize: onTargetResize
        }, triggerNode), rendedRef.current && (!uniqueContext || !unique) && /*#__PURE__*/ _react.createElement((0, _contextDefault.default).Provider, {
            value: context
        }, /*#__PURE__*/ _react.createElement((0, _popupDefault.default), {
            portal: PortalComponent,
            ref: setPopupRef,
            prefixCls: prefixCls,
            popup: popup,
            className: (0, _clsx.clsx)(popupClassName, !isMobile && alignedClassName),
            style: popupStyle,
            target: targetEle,
            onMouseEnter: onPopupMouseEnter,
            onMouseLeave: onPopupMouseLeave,
            onPointerEnter: onPopupMouseEnter,
            zIndex: zIndex,
            open: mergedOpen,
            keepDom: inMotion,
            fresh: fresh,
            onClick: onPopupClick,
            onPointerDownCapture: onPopupPointerDown,
            mask: mask,
            motion: popupMotion,
            maskMotion: maskMotion,
            onVisibleChanged: onVisibleChanged,
            onPrepare: onPrepare,
            forceRender: forceRender,
            autoDestroy: mergedAutoDestroy,
            getPopupContainer: getPopupContainer,
            align: alignInfo,
            arrow: innerArrow,
            arrowPos: arrowPos,
            ready: ready,
            offsetX: offsetX,
            offsetY: offsetY,
            offsetR: offsetR,
            offsetB: offsetB,
            onAlign: triggerAlign,
            stretch: stretch,
            targetWidth: targetWidth / scaleX,
            targetHeight: targetHeight / scaleY,
            mobile: mobile
        })));
    });
    return Trigger;
}
exports.default = generateTrigger((0, _portalDefault.default));

},{"@rc-component/portal":"fYVZK","clsx":"431Ou","@rc-component/resize-observer":"4dgtN","@rc-component/util/es/Dom/findDOMNode":"5IZto","@rc-component/util/es/Dom/shadow":"17j4f","@rc-component/util/es/hooks/useEvent":"klq5U","@rc-component/util/es/hooks/useId":"910ko","@rc-component/util/es/hooks/useLayoutEffect":"azwns","react":"bmhQu","./Popup":"lnvZw","./context":"adq9u","./hooks/useAction":"dAB9Z","./hooks/useAlign":"9Kopn","./hooks/useDelay":"6mBMF","./hooks/useWatch":"eEHBc","./hooks/useWinClick":"djPMI","./util":"6rWry","./UniqueProvider":"2BHnY","@rc-component/util":"6ZBDN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fYVZK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inlineMock", ()=>(0, _mock.inlineMock));
var _portal = require("./Portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _mock = require("./mock");
exports.default = (0, _portalDefault.default);

},{"./Portal":"37CQC","./mock":"66jyX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"37CQC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canUseDom = require("@rc-component/util/es/Dom/canUseDom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
var _ref = require("@rc-component/util/es/ref");
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _react = require("react");
var _reactDom = require("react-dom");
var _context = require("./Context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _mock = require("./mock");
var _useDom = require("./useDom");
var _useDomDefault = parcelHelpers.interopDefault(_useDom);
var _useScrollLocker = require("./useScrollLocker");
var _useScrollLockerDefault = parcelHelpers.interopDefault(_useScrollLocker);
var _useEscKeyDown = require("./useEscKeyDown");
var _useEscKeyDownDefault = parcelHelpers.interopDefault(_useEscKeyDown);
const getPortalContainer = (getContainer)=>{
    if (getContainer === false) return false;
    if (!(0, _canUseDomDefault.default)() || !getContainer) return null;
    if (typeof getContainer === 'string') return document.querySelector(getContainer);
    if (typeof getContainer === 'function') return getContainer();
    return getContainer;
};
const Portal = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { open, autoLock, getContainer, debug, autoDestroy = true, children, onEsc } = props;
    const [shouldRender, setShouldRender] = _react.useState(open);
    const mergedRender = shouldRender || open;
    // ====================== Should Render ======================
    _react.useEffect(()=>{
        if (autoDestroy || open) setShouldRender(open);
    }, [
        open,
        autoDestroy
    ]);
    // ======================== Container ========================
    const [innerContainer, setInnerContainer] = _react.useState(()=>getPortalContainer(getContainer));
    _react.useEffect(()=>{
        const customizeContainer = getPortalContainer(getContainer);
        // Tell component that we check this in effect which is safe to be `null`
        setInnerContainer(customizeContainer ?? null);
    });
    const [defaultContainer, queueCreate] = (0, _useDomDefault.default)(mergedRender && !innerContainer, debug);
    const mergedContainer = innerContainer ?? defaultContainer;
    // ========================= Locker ==========================
    (0, _useScrollLockerDefault.default)(autoLock && open && (0, _canUseDomDefault.default)() && (mergedContainer === defaultContainer || mergedContainer === document.body));
    // ========================= Esc Keydown ==========================
    (0, _useEscKeyDownDefault.default)(open, onEsc);
    // =========================== Ref ===========================
    let childRef = null;
    if (children && (0, _ref.supportRef)(children) && ref) childRef = (0, _ref.getNodeRef)(children);
    const mergedRef = (0, _ref.useComposeRef)(childRef, ref);
    // ========================= Render ==========================
    // Do not render when nothing need render
    // When innerContainer is `undefined`, it may not ready since user use ref in the same render
    if (!mergedRender || !(0, _canUseDomDefault.default)() || innerContainer === undefined) return null;
    // Render inline
    const renderInline = mergedContainer === false || (0, _mock.inlineMock)();
    let reffedChildren = children;
    if (ref) reffedChildren = /*#__PURE__*/ _react.cloneElement(children, {
        ref: mergedRef
    });
    return /*#__PURE__*/ _react.createElement((0, _contextDefault.default).Provider, {
        value: queueCreate
    }, renderInline ? reffedChildren : /*#__PURE__*/ (0, _reactDom.createPortal)(reffedChildren, mergedContainer));
});
exports.default = Portal;

},{"@rc-component/util/es/Dom/canUseDom":"4Ky1R","@rc-component/util/es/ref":"jmzjd","@rc-component/util/es/warning":"hJXDS","react":"bmhQu","react-dom":"82aNB","./Context":"3jkRZ","./mock":"66jyX","./useDom":"bQXrx","./useScrollLocker":"dsjmo","./useEscKeyDown":"asjNW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3jkRZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const OrderContext = /*#__PURE__*/ _react.createContext(null);
exports.default = OrderContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"66jyX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "inline", ()=>inline);
parcelHelpers.export(exports, "inlineMock", ()=>inlineMock);
let inline = false;
function inlineMock(nextInline) {
    if (typeof nextInline === 'boolean') inline = nextInline;
    return inline;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bQXrx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDom);
var _react = require("react");
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _canUseDom = require("@rc-component/util/es/Dom/canUseDom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
var _context = require("./Context");
var _contextDefault = parcelHelpers.interopDefault(_context);
const EMPTY_LIST = [];
function useDom(render, debug) {
    const [ele] = _react.useState(()=>{
        if (!(0, _canUseDomDefault.default)()) return null;
        const defaultEle = document.createElement('div');
        return defaultEle;
    });
    // ========================== Order ==========================
    const appendedRef = _react.useRef(false);
    const queueCreate = _react.useContext((0, _contextDefault.default));
    const [queue, setQueue] = _react.useState(EMPTY_LIST);
    const mergedQueueCreate = queueCreate || (appendedRef.current ? undefined : (appendFn)=>{
        setQueue((origin)=>{
            const newQueue = [
                appendFn,
                ...origin
            ];
            return newQueue;
        });
    });
    // =========================== DOM ===========================
    function append() {
        if (!ele.parentElement) document.body.appendChild(ele);
        appendedRef.current = true;
    }
    function cleanup() {
        ele.parentElement?.removeChild(ele);
        appendedRef.current = false;
    }
    (0, _useLayoutEffectDefault.default)(()=>{
        if (render) {
            if (queueCreate) queueCreate(append);
            else append();
        } else cleanup();
        return cleanup;
    }, [
        render
    ]);
    (0, _useLayoutEffectDefault.default)(()=>{
        if (queue.length) {
            queue.forEach((appendFn)=>appendFn());
            setQueue(EMPTY_LIST);
        }
    }, [
        queue
    ]);
    return [
        ele,
        mergedQueueCreate
    ];
}

},{"react":"bmhQu","@rc-component/util/es/hooks/useLayoutEffect":"azwns","@rc-component/util/es/Dom/canUseDom":"4Ky1R","./Context":"3jkRZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dsjmo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useScrollLocker);
var _react = require("react");
var _dynamicCSS = require("@rc-component/util/es/Dom/dynamicCSS");
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _getScrollBarSize = require("@rc-component/util/es/getScrollBarSize");
var _util = require("./util");
const UNIQUE_ID = `rc-util-locker-${Date.now()}`;
let uuid = 0;
function useScrollLocker(lock) {
    const mergedLock = !!lock;
    const [id] = _react.useState(()=>{
        uuid += 1;
        return `${UNIQUE_ID}_${uuid}`;
    });
    (0, _useLayoutEffectDefault.default)(()=>{
        if (mergedLock) {
            const scrollbarSize = (0, _getScrollBarSize.getTargetScrollBarSize)(document.body).width;
            const isOverflow = (0, _util.isBodyOverflowing)();
            (0, _dynamicCSS.updateCSS)(`
html body {
  overflow-y: hidden;
  ${isOverflow ? `width: calc(100% - ${scrollbarSize}px);` : ''}
}`, id);
        } else (0, _dynamicCSS.removeCSS)(id);
        return ()=>{
            (0, _dynamicCSS.removeCSS)(id);
        };
    }, [
        mergedLock,
        id
    ]);
}

},{"react":"bmhQu","@rc-component/util/es/Dom/dynamicCSS":"3UDeI","@rc-component/util/es/hooks/useLayoutEffect":"azwns","@rc-component/util/es/getScrollBarSize":"gzBiC","./util":"bEmSM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3UDeI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "injectCSS", ()=>injectCSS);
parcelHelpers.export(exports, "removeCSS", ()=>removeCSS);
/**
 * manually clear container cache to avoid global cache in unit testes
 */ parcelHelpers.export(exports, "clearContainerCache", ()=>clearContainerCache);
parcelHelpers.export(exports, "updateCSS", ()=>updateCSS);
var _canUseDom = require("./canUseDom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
var _contains = require("./contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
const APPEND_ORDER = 'data-rc-order';
const APPEND_PRIORITY = 'data-rc-priority';
const MARK_KEY = `rc-util-key`;
const containerCache = new Map();
function getMark({ mark } = {}) {
    if (mark) return mark.startsWith('data-') ? mark : `data-${mark}`;
    return MARK_KEY;
}
function getContainer(option) {
    if (option.attachTo) return option.attachTo;
    const head = document.querySelector('head');
    return head || document.body;
}
function getOrder(prepend) {
    if (prepend === 'queue') return 'prependQueue';
    return prepend ? 'prepend' : 'append';
}
/**
 * Find style which inject by rc-util
 */ function findStyles(container) {
    return Array.from((containerCache.get(container) || container).children).filter((node)=>node.tagName === 'STYLE');
}
function injectCSS(css, option = {}) {
    if (!(0, _canUseDomDefault.default)()) return null;
    const { csp, prepend, priority = 0 } = option;
    const mergedOrder = getOrder(prepend);
    const isPrependQueue = mergedOrder === 'prependQueue';
    const styleNode = document.createElement('style');
    styleNode.setAttribute(APPEND_ORDER, mergedOrder);
    if (isPrependQueue && priority) styleNode.setAttribute(APPEND_PRIORITY, `${priority}`);
    if (csp?.nonce) styleNode.nonce = csp?.nonce;
    styleNode.innerHTML = css;
    const container = getContainer(option);
    const { firstChild } = container;
    if (prepend) {
        // If is queue `prepend`, it will prepend first style and then append rest style
        if (isPrependQueue) {
            const existStyle = (option.styles || findStyles(container)).filter((node)=>{
                // Ignore style which not injected by rc-util with prepend
                if (![
                    'prepend',
                    'prependQueue'
                ].includes(node.getAttribute(APPEND_ORDER))) return false;
                // Ignore style which priority less then new style
                const nodePriority = Number(node.getAttribute(APPEND_PRIORITY) || 0);
                return priority >= nodePriority;
            });
            if (existStyle.length) {
                container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
                return styleNode;
            }
        }
        // Use `insertBefore` as `prepend`
        container.insertBefore(styleNode, firstChild);
    } else container.appendChild(styleNode);
    return styleNode;
}
function findExistNode(key, option = {}) {
    let { styles } = option;
    styles ||= findStyles(getContainer(option));
    return styles.find((node)=>node.getAttribute(getMark(option)) === key);
}
function removeCSS(key, option = {}) {
    const existNode = findExistNode(key, option);
    if (existNode) {
        const container = getContainer(option);
        container.removeChild(existNode);
    }
}
/**
 * qiankun will inject `appendChild` to insert into other
 */ function syncRealContainer(container, option) {
    const cachedRealContainer = containerCache.get(container);
    // Find real container when not cached or cached container removed
    if (!cachedRealContainer || !(0, _containsDefault.default)(document, cachedRealContainer)) {
        const placeholderStyle = injectCSS('', option);
        const { parentNode } = placeholderStyle;
        containerCache.set(container, parentNode);
        container.removeChild(placeholderStyle);
    }
}
function clearContainerCache() {
    containerCache.clear();
}
function updateCSS(css, key, originOption = {}) {
    const container = getContainer(originOption);
    const styles = findStyles(container);
    const option = {
        ...originOption,
        styles
    };
    // Sync real parent
    syncRealContainer(container, option);
    const existNode = findExistNode(key, option);
    if (existNode) {
        if (option.csp?.nonce && existNode.nonce !== option.csp?.nonce) existNode.nonce = option.csp?.nonce;
        if (existNode.innerHTML !== css) existNode.innerHTML = css;
        return existNode;
    }
    const newNode = injectCSS(css, option);
    newNode.setAttribute(getMark(option), key);
    return newNode;
}

},{"./canUseDom":"4Ky1R","./contains":"l6bsP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l6bsP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>contains);
function contains(root, n) {
    if (!root) return false;
    // Use native if support
    if (root.contains) return root.contains(n);
    // `document.contains` not support with IE11
    let node = n;
    while(node){
        if (node === root) return true;
        node = node.parentNode;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gzBiC":[function(require,module,exports,__globalThis) {
/* eslint-disable no-param-reassign */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>getScrollBarSize);
parcelHelpers.export(exports, "getTargetScrollBarSize", ()=>getTargetScrollBarSize);
var _dynamicCSS = require("./Dom/dynamicCSS");
let cached;
function measureScrollbarSize(ele) {
    const randomId = `rc-scrollbar-measure-${Math.random().toString(36).substring(7)}`;
    const measureEle = document.createElement('div');
    measureEle.id = randomId;
    // Create Style
    const measureStyle = measureEle.style;
    measureStyle.position = 'absolute';
    measureStyle.left = '0';
    measureStyle.top = '0';
    measureStyle.width = '100px';
    measureStyle.height = '100px';
    measureStyle.overflow = 'scroll';
    // Clone Style if needed
    let fallbackWidth;
    let fallbackHeight;
    if (ele) {
        const targetStyle = getComputedStyle(ele);
        measureStyle.scrollbarColor = targetStyle.scrollbarColor;
        measureStyle.scrollbarWidth = targetStyle.scrollbarWidth;
        // Set Webkit style
        const webkitScrollbarStyle = getComputedStyle(ele, '::-webkit-scrollbar');
        const width = parseInt(webkitScrollbarStyle.width, 10);
        const height = parseInt(webkitScrollbarStyle.height, 10);
        // Try wrap to handle CSP case
        try {
            const widthStyle = width ? `width: ${webkitScrollbarStyle.width};` : '';
            const heightStyle = height ? `height: ${webkitScrollbarStyle.height};` : '';
            (0, _dynamicCSS.updateCSS)(`
#${randomId}::-webkit-scrollbar {
${widthStyle}
${heightStyle}
}`, randomId);
        } catch (e) {
            // Can't wrap, just log error
            console.error(e);
            // Get from style directly
            fallbackWidth = width;
            fallbackHeight = height;
        }
    }
    document.body.appendChild(measureEle);
    // Measure. Get fallback style if provided
    const scrollWidth = ele && fallbackWidth && !isNaN(fallbackWidth) ? fallbackWidth : measureEle.offsetWidth - measureEle.clientWidth;
    const scrollHeight = ele && fallbackHeight && !isNaN(fallbackHeight) ? fallbackHeight : measureEle.offsetHeight - measureEle.clientHeight;
    // Clean up
    document.body.removeChild(measureEle);
    (0, _dynamicCSS.removeCSS)(randomId);
    return {
        width: scrollWidth,
        height: scrollHeight
    };
}
function getScrollBarSize(fresh) {
    if (typeof document === 'undefined') return 0;
    if (fresh || cached === undefined) cached = measureScrollbarSize();
    return cached.width;
}
function getTargetScrollBarSize(target) {
    if (typeof document === 'undefined' || !target || !(target instanceof Element)) return {
        width: 0,
        height: 0
    };
    return measureScrollbarSize(target);
}

},{"./Dom/dynamicCSS":"3UDeI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bEmSM":[function(require,module,exports,__globalThis) {
/**
 * Test usage export. Do not use in your production
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBodyOverflowing", ()=>isBodyOverflowing);
function isBodyOverflowing() {
    return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"asjNW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stack", ()=>stack);
parcelHelpers.export(exports, "default", ()=>useEscKeyDown);
var _react = require("react");
var _useId = require("@rc-component/util/es/hooks/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _util = require("@rc-component/util");
let stack = []; // export for testing
function useEscKeyDown(open, onEsc) {
    const id = (0, _useIdDefault.default)();
    const handleEscKeyDown = (0, _util.useEvent)((event)=>{
        if (event.key === 'Escape' && !event.isComposing) {
            const top = stack[stack.length - 1] === id;
            onEsc?.({
                top,
                event
            });
        }
    });
    (0, _react.useMemo)(()=>{
        if (open && !stack.includes(id)) stack.push(id);
        else if (!open) stack = stack.filter((item)=>item !== id);
    }, [
        open,
        id
    ]);
    (0, _react.useEffect)(()=>{
        if (!open) return;
        window.addEventListener('keydown', handleEscKeyDown);
        return ()=>{
            stack = stack.filter((item)=>item !== id);
            window.removeEventListener('keydown', handleEscKeyDown);
        };
    }, [
        open,
        id
    ]);
}

},{"react":"bmhQu","@rc-component/util/es/hooks/useId":"910ko","@rc-component/util":"6ZBDN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"910ko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** @private Note only worked in develop env. Not work in production. */ parcelHelpers.export(exports, "resetUuid", ()=>resetUuid);
var _react = require("react");
function getUseId() {
    // We need fully clone React function here to avoid webpack warning React 17 do not export `useId`
    const fullClone = {
        ..._react
    };
    return fullClone.useId;
}
let uuid = 0;
function resetUuid() {}
const useOriginId = getUseId();
exports.default = useOriginId ? // Use React `useId`
function useId(id) {
    const reactId = useOriginId();
    // Developer passed id is single source of truth
    if (id) return id;
    return reactId;
} : // Use compatible of `useId`
function useCompatId(id) {
    // Inner id for accessibility usage. Only work in client side
    const [innerId, setInnerId] = _react.useState('ssr-id');
    _react.useEffect(()=>{
        const nextId = uuid;
        uuid += 1;
        setInnerId(`rc_unique_${nextId}`);
    }, []);
    // Developer passed id is single source of truth
    if (id) return id;
    // Return react native id or inner id
    return innerId;
};

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4dgtN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_rs", ()=>(0, _observerUtil._rs));
var _react = require("react");
var _toArray = require("@rc-component/util/es/Children/toArray");
var _toArrayDefault = parcelHelpers.interopDefault(_toArray);
var _warning = require("@rc-component/util/es/warning");
var _singleObserver = require("./SingleObserver");
var _singleObserverDefault = parcelHelpers.interopDefault(_singleObserver);
var _collection = require("./Collection");
var _observerUtil = require("./utils/observerUtil");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const INTERNAL_PREFIX_KEY = 'rc-observer-key';
function ResizeObserver(props, ref) {
    const { children } = props;
    const childNodes = typeof children === 'function' ? [
        children
    ] : (0, _toArrayDefault.default)(children);
    return childNodes.map((child, index)=>{
        const key = child?.key || `${INTERNAL_PREFIX_KEY}-${index}`;
        return /*#__PURE__*/ _react.createElement((0, _singleObserverDefault.default), _extends({}, props, {
            key: key,
            ref: index === 0 ? ref : undefined
        }), child);
    });
}
const RefResizeObserver = /*#__PURE__*/ _react.forwardRef(ResizeObserver);
RefResizeObserver.Collection = (0, _collection.Collection);
exports.default = RefResizeObserver;

},{"react":"bmhQu","@rc-component/util/es/Children/toArray":"7sTeM","@rc-component/util/es/warning":"hJXDS","./SingleObserver":"cWDfO","./Collection":"5sXO9","./utils/observerUtil":"1FinJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cWDfO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _findDOMNode = require("@rc-component/util/es/Dom/findDOMNode");
var _ref = require("@rc-component/util/es/ref");
var _react = require("react");
var _collection = require("../Collection");
var _observerUtil = require("../utils/observerUtil");
function SingleObserver(props, ref) {
    const { children, disabled } = props;
    const elementRef = _react.useRef(null);
    const onCollectionResize = _react.useContext((0, _collection.CollectionContext));
    // =========================== Children ===========================
    const isRenderProps = typeof children === 'function';
    const mergedChildren = isRenderProps ? children(elementRef) : children;
    // ============================= Size =============================
    const sizeRef = _react.useRef({
        width: -1,
        height: -1,
        offsetWidth: -1,
        offsetHeight: -1
    });
    // ============================= Ref ==============================
    const canRef = !isRenderProps && /*#__PURE__*/ _react.isValidElement(mergedChildren) && (0, _ref.supportRef)(mergedChildren);
    const originRef = canRef ? (0, _ref.getNodeRef)(mergedChildren) : null;
    const mergedRef = (0, _ref.useComposeRef)(originRef, elementRef);
    const getDomElement = ()=>{
        return (0, _findDOMNode.getDOM)(elementRef.current);
    };
    _react.useImperativeHandle(ref, ()=>getDomElement());
    // =========================== Observe ============================
    const propsRef = _react.useRef(props);
    propsRef.current = props;
    // Handler
    const onInternalResize = _react.useCallback((target)=>{
        const { onResize, data } = propsRef.current;
        const { width, height } = target.getBoundingClientRect();
        const { offsetWidth, offsetHeight } = target;
        /**
     * Resize observer trigger when content size changed.
     * In most case we just care about element size,
     * let's use `boundary` instead of `contentRect` here to avoid shaking.
     */ const fixedWidth = Math.floor(width);
        const fixedHeight = Math.floor(height);
        if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
            const size = {
                width: fixedWidth,
                height: fixedHeight,
                offsetWidth,
                offsetHeight
            };
            sizeRef.current = size;
            // IE is strange, right?
            const mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
            const mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
            const sizeInfo = {
                ...size,
                offsetWidth: mergedOffsetWidth,
                offsetHeight: mergedOffsetHeight
            };
            // Let collection know what happened
            onCollectionResize?.(sizeInfo, target, data);
            if (onResize) // defer the callback but not defer to next frame
            Promise.resolve().then(()=>{
                onResize(sizeInfo, target);
            });
        }
    }, []);
    // Dynamic observe
    _react.useEffect(()=>{
        const currentElement = getDomElement();
        if (currentElement && !disabled) (0, _observerUtil.observe)(currentElement, onInternalResize);
        return ()=>(0, _observerUtil.unobserve)(currentElement, onInternalResize);
    }, [
        elementRef.current,
        disabled
    ]);
    // ============================ Render ============================
    return canRef ? /*#__PURE__*/ _react.cloneElement(mergedChildren, {
        ref: mergedRef
    }) : mergedChildren;
}
const RefSingleObserver = /*#__PURE__*/ _react.forwardRef(SingleObserver);
exports.default = RefSingleObserver;

},{"@rc-component/util/es/Dom/findDOMNode":"5IZto","@rc-component/util/es/ref":"jmzjd","react":"bmhQu","../Collection":"5sXO9","../utils/observerUtil":"1FinJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5IZto":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDOM", ()=>isDOM);
/**
 * Retrieves a DOM node via a ref, and does not invoke `findDOMNode`.
 */ parcelHelpers.export(exports, "getDOM", ()=>getDOM);
parcelHelpers.export(exports, "default", ()=>findDOMNode);
function isDOM(node) {
    // https://developer.mozilla.org/en-US/docs/Web/API/Element
    // Since XULElement is also subclass of Element, we only need HTMLElement and SVGElement
    return node instanceof HTMLElement || node instanceof SVGElement;
}
function getDOM(node) {
    if (node && typeof node === 'object' && isDOM(node.nativeElement)) return node.nativeElement;
    if (isDOM(node)) return node;
    return null;
}
function findDOMNode(node) {
    const domNode = getDOM(node);
    if (domNode) return domNode;
    if (node && typeof node === 'object' && 'current' in node) {
        const refDomNode = getDOM(node.current);
        if (refDomNode) return refDomNode;
    }
    return null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5sXO9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CollectionContext", ()=>CollectionContext);
/**
 * Collect all the resize event from children ResizeObserver
 */ parcelHelpers.export(exports, "Collection", ()=>Collection);
var _react = require("react");
const CollectionContext = /*#__PURE__*/ _react.createContext(null);
function Collection({ children, onBatchResize }) {
    const resizeIdRef = _react.useRef(0);
    const resizeInfosRef = _react.useRef([]);
    const onCollectionResize = _react.useContext(CollectionContext);
    const onResize = _react.useCallback((size, element, data)=>{
        resizeIdRef.current += 1;
        const currentId = resizeIdRef.current;
        resizeInfosRef.current.push({
            size,
            element,
            data
        });
        Promise.resolve().then(()=>{
            if (currentId === resizeIdRef.current) {
                onBatchResize?.(resizeInfosRef.current);
                resizeInfosRef.current = [];
            }
        });
        // Continue bubbling if parent exist
        onCollectionResize?.(size, element, data);
    }, [
        onBatchResize,
        onCollectionResize
    ]);
    return /*#__PURE__*/ _react.createElement(CollectionContext.Provider, {
        value: onResize
    }, children);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1FinJ":[function(require,module,exports,__globalThis) {
// =============================== Const ===============================
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_el", ()=>_el);
parcelHelpers.export(exports, "_rs", ()=>_rs);
// ============================== Observe ==============================
parcelHelpers.export(exports, "observe", ()=>observe);
parcelHelpers.export(exports, "unobserve", ()=>unobserve);
const elementListeners = new Map();
function onResize(entities) {
    entities.forEach((entity)=>{
        const { target } = entity;
        elementListeners.get(target)?.forEach((listener)=>listener(target));
    });
}
// Delay create ResizeObserver since it's not supported in server side
let observer;
function ensureResizeObserver() {
    if (!observer) observer = new ResizeObserver(onResize);
    return observer;
}
const _el = null; // eslint-disable-line
const _rs = null; // eslint-disable-line
function observe(element, callback) {
    if (!elementListeners.has(element)) {
        elementListeners.set(element, new Set());
        ensureResizeObserver().observe(element);
    }
    elementListeners.get(element).add(callback);
}
function unobserve(element, callback) {
    if (elementListeners.has(element)) {
        elementListeners.get(element).delete(callback);
        if (!elementListeners.get(element).size) {
            ensureResizeObserver().unobserve(element);
            elementListeners.delete(element);
        }
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"17j4f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Check if is in shadowRoot
 */ parcelHelpers.export(exports, "inShadow", ()=>inShadow);
/**
 * Return shadowRoot if possible
 */ parcelHelpers.export(exports, "getShadowRoot", ()=>getShadowRoot);
function getRoot(ele) {
    return ele?.getRootNode?.();
}
function inShadow(ele) {
    return getRoot(ele) instanceof ShadowRoot;
}
function getShadowRoot(ele) {
    return inShadow(ele) ? getRoot(ele) : null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lnvZw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _motion = require("@rc-component/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
var _resizeObserver = require("@rc-component/resize-observer");
var _resizeObserverDefault = parcelHelpers.interopDefault(_resizeObserver);
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _ref = require("@rc-component/util/es/ref");
var _react = require("react");
var _arrow = require("./Arrow");
var _arrowDefault = parcelHelpers.interopDefault(_arrow);
var _mask = require("./Mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _popupContent = require("./PopupContent");
var _popupContentDefault = parcelHelpers.interopDefault(_popupContent);
var _useOffsetStyle = require("../hooks/useOffsetStyle");
var _useOffsetStyleDefault = parcelHelpers.interopDefault(_useOffsetStyle);
var _util = require("@rc-component/util");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Popup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { popup, className, prefixCls, style, target, onVisibleChanged, // Open
    open, keepDom, fresh, // Click
    onClick, // Mask
    mask, // Arrow
    arrow, arrowPos, align, // Motion
    motion, maskMotion, // Mobile
    mobile, // Portal
    forceRender, getPopupContainer, autoDestroy, portal: Portal, children, zIndex, onMouseEnter, onMouseLeave, onPointerEnter, onPointerDownCapture, ready, offsetX, offsetY, offsetR, offsetB, onAlign, onPrepare, // Resize
    onResize, stretch, targetWidth, targetHeight } = props;
    const popupContent = typeof popup === 'function' ? popup() : popup;
    // We can not remove holder only when motion finished.
    const isNodeVisible = open || keepDom;
    // ========================= Mobile =========================
    const isMobile = !!mobile;
    // ========================== Mask ==========================
    const [mergedMask, mergedMaskMotion, mergedPopupMotion] = _react.useMemo(()=>{
        if (mobile) return [
            mobile.mask,
            mobile.maskMotion,
            mobile.motion
        ];
        return [
            mask,
            maskMotion,
            motion
        ];
    }, [
        mobile,
        mask,
        maskMotion,
        motion
    ]);
    // ======================= Container ========================
    const getPopupContainerNeedParams = getPopupContainer?.length > 0;
    const [show, setShow] = _react.useState(!getPopupContainer || !getPopupContainerNeedParams);
    // Delay to show since `getPopupContainer` need target element
    (0, _useLayoutEffectDefault.default)(()=>{
        if (!show && getPopupContainerNeedParams && target) setShow(true);
    }, [
        show,
        getPopupContainerNeedParams,
        target
    ]);
    // ========================= Resize =========================
    const onInternalResize = (0, _util.useEvent)((size, ele)=>{
        onResize?.(size, ele);
        onAlign();
    });
    // ========================= Styles =========================
    const offsetStyle = (0, _useOffsetStyleDefault.default)(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY);
    // ========================= Render =========================
    if (!show) return null;
    // >>>>> Misc
    const miscStyle = {};
    if (stretch) {
        if (stretch.includes('height') && targetHeight) miscStyle.height = targetHeight;
        else if (stretch.includes('minHeight') && targetHeight) miscStyle.minHeight = targetHeight;
        if (stretch.includes('width') && targetWidth) miscStyle.width = targetWidth;
        else if (stretch.includes('minWidth') && targetWidth) miscStyle.minWidth = targetWidth;
    }
    if (!open) miscStyle.pointerEvents = 'none';
    return /*#__PURE__*/ _react.createElement(Portal, {
        open: forceRender || isNodeVisible,
        getContainer: getPopupContainer && (()=>getPopupContainer(target)),
        autoDestroy: autoDestroy
    }, /*#__PURE__*/ _react.createElement((0, _maskDefault.default), {
        prefixCls: prefixCls,
        open: open,
        zIndex: zIndex,
        mask: mergedMask,
        motion: mergedMaskMotion,
        mobile: isMobile
    }), /*#__PURE__*/ _react.createElement((0, _resizeObserverDefault.default), {
        onResize: onInternalResize,
        disabled: !open
    }, (resizeObserverRef)=>{
        return /*#__PURE__*/ _react.createElement((0, _motionDefault.default), _extends({
            motionAppear: true,
            motionEnter: true,
            motionLeave: true,
            removeOnLeave: false,
            forceRender: forceRender,
            leavedClassName: `${prefixCls}-hidden`
        }, mergedPopupMotion, {
            onAppearPrepare: onPrepare,
            onEnterPrepare: onPrepare,
            visible: open,
            onVisibleChanged: (nextVisible)=>{
                motion?.onVisibleChanged?.(nextVisible);
                onVisibleChanged(nextVisible);
            }
        }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
            const cls = (0, _clsx.clsx)(prefixCls, motionClassName, className, {
                [`${prefixCls}-mobile`]: isMobile
            });
            return /*#__PURE__*/ _react.createElement("div", {
                ref: (0, _ref.composeRef)(resizeObserverRef, ref, motionRef),
                className: cls,
                style: {
                    '--arrow-x': `${arrowPos.x || 0}px`,
                    '--arrow-y': `${arrowPos.y || 0}px`,
                    ...offsetStyle,
                    ...miscStyle,
                    ...motionStyle,
                    boxSizing: 'border-box',
                    zIndex,
                    ...style
                },
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onPointerEnter: onPointerEnter,
                onClick: onClick,
                onPointerDownCapture: onPointerDownCapture
            }, arrow && /*#__PURE__*/ _react.createElement((0, _arrowDefault.default), {
                prefixCls: prefixCls,
                arrow: arrow,
                arrowPos: arrowPos,
                align: align
            }), /*#__PURE__*/ _react.createElement((0, _popupContentDefault.default), {
                cache: !open && !fresh
            }, popupContent));
        });
    }), children);
});
exports.default = Popup;

},{"clsx":"431Ou","@rc-component/motion":"gBwXg","@rc-component/resize-observer":"4dgtN","@rc-component/util/es/hooks/useLayoutEffect":"azwns","@rc-component/util/es/ref":"jmzjd","react":"bmhQu","./Arrow":"jjH3K","./Mask":"6AEh4","./PopupContent":"g3gR7","../hooks/useOffsetStyle":"6biMe","@rc-component/util":"6ZBDN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gBwXg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>(0, _contextDefault.default));
parcelHelpers.export(exports, "CSSMotionList", ()=>(0, _cssmotionListDefault.default));
var _cssmotion = require("./CSSMotion");
var _cssmotionDefault = parcelHelpers.interopDefault(_cssmotion);
var _cssmotionList = require("./CSSMotionList");
var _cssmotionListDefault = parcelHelpers.interopDefault(_cssmotionList);
var _context = require("./context");
var _contextDefault = parcelHelpers.interopDefault(_context);
exports.default = (0, _cssmotionDefault.default);

},{"./CSSMotion":"dIBqX","./CSSMotionList":"8Jex9","./context":"ivynA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dIBqX":[function(require,module,exports,__globalThis) {
/* eslint-disable react/default-props-match-prop-types, react/no-multi-comp, react/prop-types */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * `transitionSupport` is used for none transition test case.
 * Default we use browser transition event support check.
 */ parcelHelpers.export(exports, "genCSSMotion", ()=>genCSSMotion);
var _findDOMNode = require("@rc-component/util/es/Dom/findDOMNode");
var _ref = require("@rc-component/util/es/ref");
var _clsx = require("clsx");
var _react = require("react");
var _context = require("./context");
var _useStatus = require("./hooks/useStatus");
var _useStatusDefault = parcelHelpers.interopDefault(_useStatus);
var _useStepQueue = require("./hooks/useStepQueue");
var _interface = require("./interface");
var _motion = require("./util/motion");
function genCSSMotion(config) {
    let transitionSupport = config;
    if (typeof config === 'object') ({ transitionSupport } = config);
    function isSupportTransition(props, contextMotion) {
        return !!(props.motionName && transitionSupport && contextMotion !== false);
    }
    const CSSMotion = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
        const { // Default config
        visible = true, removeOnLeave = true, forceRender, children, motionName, leavedClassName, eventProps } = props;
        const { motion: contextMotion } = _react.useContext((0, _context.Context));
        const supportMotion = isSupportTransition(props, contextMotion);
        // Ref to the react node, it may be a HTMLElement
        const nodeRef = (0, _react.useRef)();
        function getDomElement() {
            return (0, _findDOMNode.getDOM)(nodeRef.current);
        }
        const [getStatus, statusStep, statusStyle, mergedVisible] = (0, _useStatusDefault.default)(supportMotion, visible, getDomElement, props);
        const status = getStatus();
        // Record whether content has rendered
        // Will return null for un-rendered even when `removeOnLeave={false}`
        const renderedRef = _react.useRef(mergedVisible);
        if (mergedVisible) renderedRef.current = true;
        // ====================== Refs ======================
        const refObj = _react.useMemo(()=>{
            const obj = {};
            Object.defineProperties(obj, {
                nativeElement: {
                    enumerable: true,
                    get: getDomElement
                },
                inMotion: {
                    enumerable: true,
                    get: ()=>()=>getStatus() !== (0, _interface.STATUS_NONE)
                },
                enableMotion: {
                    enumerable: true,
                    get: ()=>()=>supportMotion
                }
            });
            return obj;
        }, []);
        // We lock `deps` here since function return object
        // will repeat trigger ref from `refConfig` -> `null` -> `refConfig`
        _react.useImperativeHandle(ref, ()=>refObj, []);
        // ===================== Render =====================
        let motionChildren;
        const mergedProps = {
            ...eventProps,
            visible
        };
        if (!children) // No children
        motionChildren = null;
        else if (status === (0, _interface.STATUS_NONE)) {
            // Stable children
            if (mergedVisible) motionChildren = children({
                ...mergedProps
            }, nodeRef);
            else if (!removeOnLeave && renderedRef.current && leavedClassName) motionChildren = children({
                ...mergedProps,
                className: leavedClassName
            }, nodeRef);
            else if (forceRender || !removeOnLeave && !leavedClassName) motionChildren = children({
                ...mergedProps,
                style: {
                    display: 'none'
                }
            }, nodeRef);
            else motionChildren = null;
        } else {
            // In motion
            let statusSuffix;
            if (statusStep === (0, _interface.STEP_PREPARE)) statusSuffix = 'prepare';
            else if ((0, _useStepQueue.isActive)(statusStep)) statusSuffix = 'active';
            else if (statusStep === (0, _interface.STEP_START)) statusSuffix = 'start';
            const motionCls = (0, _motion.getTransitionName)(motionName, `${status}-${statusSuffix}`);
            motionChildren = children({
                ...mergedProps,
                className: (0, _clsx.clsx)((0, _motion.getTransitionName)(motionName, status), {
                    [motionCls]: motionCls && statusSuffix,
                    [motionName]: typeof motionName === 'string'
                }),
                style: statusStyle
            }, nodeRef);
        }
        // Auto inject ref if child node not have `ref` props
        if (/*#__PURE__*/ _react.isValidElement(motionChildren) && (0, _ref.supportRef)(motionChildren)) {
            const originNodeRef = (0, _ref.getNodeRef)(motionChildren);
            if (!originNodeRef) motionChildren = /*#__PURE__*/ _react.cloneElement(motionChildren, {
                ref: nodeRef
            });
        }
        return motionChildren;
    });
    CSSMotion.displayName = 'CSSMotion';
    return CSSMotion;
}
exports.default = genCSSMotion((0, _motion.supportTransition));

},{"@rc-component/util/es/Dom/findDOMNode":"5IZto","@rc-component/util/es/ref":"jmzjd","clsx":"431Ou","react":"bmhQu","./context":"ivynA","./hooks/useStatus":"knukC","./hooks/useStepQueue":"crzkn","./interface":"45PsZ","./util/motion":"LL3nA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ivynA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Context", ()=>Context);
parcelHelpers.export(exports, "default", ()=>MotionProvider);
var _react = require("react");
const Context = /*#__PURE__*/ _react.createContext({});
function MotionProvider({ children, ...props }) {
    return /*#__PURE__*/ _react.createElement(Context.Provider, {
        value: props
    }, children);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"knukC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useStatus);
var _util = require("@rc-component/util");
var _useState = require("@rc-component/util/es/hooks/useState");
var _useStateDefault = parcelHelpers.interopDefault(_useState);
var _useSyncState = require("@rc-component/util/es/hooks/useSyncState");
var _useSyncStateDefault = parcelHelpers.interopDefault(_useSyncState);
var _react = require("react");
var _interface = require("../interface");
var _useDomMotionEvents = require("./useDomMotionEvents");
var _useDomMotionEventsDefault = parcelHelpers.interopDefault(_useDomMotionEvents);
var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var _useStepQueue = require("./useStepQueue");
var _useStepQueueDefault = parcelHelpers.interopDefault(_useStepQueue);
function useStatus(supportMotion, visible, getElement, { motionEnter = true, motionAppear = true, motionLeave = true, motionDeadline, motionLeaveImmediately, onAppearPrepare, onEnterPrepare, onLeavePrepare, onAppearStart, onEnterStart, onLeaveStart, onAppearActive, onEnterActive, onLeaveActive, onAppearEnd, onEnterEnd, onLeaveEnd, onVisibleChanged }) {
    // Used for outer render usage to avoid `visible: false & status: none` to render nothing
    const [asyncVisible, setAsyncVisible] = (0, _useStateDefault.default)();
    const [getStatus, setStatus] = (0, _useSyncStateDefault.default)((0, _interface.STATUS_NONE));
    const [style, setStyle] = (0, _useStateDefault.default)(null);
    const currentStatus = getStatus();
    const mountedRef = (0, _react.useRef)(false);
    const deadlineRef = (0, _react.useRef)(null);
    // =========================== Dom Node ===========================
    function getDomElement() {
        return getElement();
    }
    // ========================== Motion End ==========================
    const activeRef = (0, _react.useRef)(false);
    /**
   * Clean up status & style
   */ function updateMotionEndStatus() {
        setStatus((0, _interface.STATUS_NONE));
        setStyle(null, true);
    }
    const onInternalMotionEnd = (0, _util.useEvent)((event)=>{
        const status = getStatus();
        // Do nothing since not in any transition status.
        // This may happen when `motionDeadline` trigger.
        if (status === (0, _interface.STATUS_NONE)) return;
        const element = getDomElement();
        if (event && !event.deadline && event.target !== element) // event exists
        // not initiated by deadline
        // transitionEnd not fired by inner elements
        return;
        const currentActive = activeRef.current;
        let canEnd;
        if (status === (0, _interface.STATUS_APPEAR) && currentActive) canEnd = onAppearEnd?.(element, event);
        else if (status === (0, _interface.STATUS_ENTER) && currentActive) canEnd = onEnterEnd?.(element, event);
        else if (status === (0, _interface.STATUS_LEAVE) && currentActive) canEnd = onLeaveEnd?.(element, event);
        // Only update status when `canEnd` and not destroyed
        if (currentActive && canEnd !== false) updateMotionEndStatus();
    });
    const [patchMotionEvents] = (0, _useDomMotionEventsDefault.default)(onInternalMotionEnd);
    // ============================= Step =============================
    const getEventHandlers = (targetStatus)=>{
        switch(targetStatus){
            case 0, _interface.STATUS_APPEAR:
                return {
                    [(0, _interface.STEP_PREPARE)]: onAppearPrepare,
                    [(0, _interface.STEP_START)]: onAppearStart,
                    [(0, _interface.STEP_ACTIVE)]: onAppearActive
                };
            case 0, _interface.STATUS_ENTER:
                return {
                    [(0, _interface.STEP_PREPARE)]: onEnterPrepare,
                    [(0, _interface.STEP_START)]: onEnterStart,
                    [(0, _interface.STEP_ACTIVE)]: onEnterActive
                };
            case 0, _interface.STATUS_LEAVE:
                return {
                    [(0, _interface.STEP_PREPARE)]: onLeavePrepare,
                    [(0, _interface.STEP_START)]: onLeaveStart,
                    [(0, _interface.STEP_ACTIVE)]: onLeaveActive
                };
            default:
                return {};
        }
    };
    const eventHandlers = _react.useMemo(()=>getEventHandlers(currentStatus), [
        currentStatus
    ]);
    const [startStep, step] = (0, _useStepQueueDefault.default)(currentStatus, !supportMotion, (newStep)=>{
        // Only prepare step can be skip
        if (newStep === (0, _interface.STEP_PREPARE)) {
            const onPrepare = eventHandlers[0, _interface.STEP_PREPARE];
            if (!onPrepare) return 0, _useStepQueue.SkipStep;
            return onPrepare(getDomElement());
        }
        // Rest step is sync update
        if (step in eventHandlers) setStyle(eventHandlers[step]?.(getDomElement(), null) || null);
        if (step === (0, _interface.STEP_ACTIVE) && currentStatus !== (0, _interface.STATUS_NONE)) {
            // Patch events when motion needed
            patchMotionEvents(getDomElement());
            if (motionDeadline > 0) {
                clearTimeout(deadlineRef.current);
                deadlineRef.current = setTimeout(()=>{
                    onInternalMotionEnd({
                        deadline: true
                    });
                }, motionDeadline);
            }
        }
        if (step === (0, _interface.STEP_PREPARED)) updateMotionEndStatus();
        return 0, _useStepQueue.DoStep;
    });
    const active = (0, _useStepQueue.isActive)(step);
    activeRef.current = active;
    // ============================ Status ============================
    const visibleRef = (0, _react.useRef)(null);
    // Update with new status
    (0, _useIsomorphicLayoutEffectDefault.default)(()=>{
        // When use Suspense, the `visible` will repeat trigger,
        // But not real change of the `visible`, we need to skip it.
        // https://github.com/ant-design/ant-design/issues/44379
        if (mountedRef.current && visibleRef.current === visible) return;
        setAsyncVisible(visible);
        const isMounted = mountedRef.current;
        mountedRef.current = true;
        // if (!supportMotion) {
        //   return;
        // }
        let nextStatus;
        // Appear
        if (!isMounted && visible && motionAppear) nextStatus = (0, _interface.STATUS_APPEAR);
        // Enter
        if (isMounted && visible && motionEnter) nextStatus = (0, _interface.STATUS_ENTER);
        // Leave
        if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) nextStatus = (0, _interface.STATUS_LEAVE);
        const nextEventHandlers = getEventHandlers(nextStatus);
        // Update to next status
        if (nextStatus && (supportMotion || nextEventHandlers[0, _interface.STEP_PREPARE])) {
            setStatus(nextStatus);
            startStep();
        } else // Set back in case no motion but prev status has prepare step
        setStatus((0, _interface.STATUS_NONE));
        visibleRef.current = visible;
    }, [
        visible
    ]);
    // ============================ Effect ============================
    // Reset when motion changed
    (0, _react.useEffect)(()=>{
        if (// Cancel appear
        currentStatus === (0, _interface.STATUS_APPEAR) && !motionAppear || // Cancel enter
        currentStatus === (0, _interface.STATUS_ENTER) && !motionEnter || // Cancel leave
        currentStatus === (0, _interface.STATUS_LEAVE) && !motionLeave) setStatus((0, _interface.STATUS_NONE));
    }, [
        motionAppear,
        motionEnter,
        motionLeave
    ]);
    (0, _react.useEffect)(()=>()=>{
            mountedRef.current = false;
            clearTimeout(deadlineRef.current);
        }, []);
    // Trigger `onVisibleChanged`
    const firstMountChangeRef = _react.useRef(false);
    (0, _react.useEffect)(()=>{
        // [visible & motion not end] => [!visible & motion end] still need trigger onVisibleChanged
        if (asyncVisible) firstMountChangeRef.current = true;
        if (asyncVisible !== undefined && currentStatus === (0, _interface.STATUS_NONE)) {
            // Skip first render is invisible since it's nothing changed
            if (firstMountChangeRef.current || asyncVisible) onVisibleChanged?.(asyncVisible);
            firstMountChangeRef.current = true;
        }
    }, [
        asyncVisible,
        currentStatus
    ]);
    // ============================ Styles ============================
    let mergedStyle = style;
    if (eventHandlers[0, _interface.STEP_PREPARE] && step === (0, _interface.STEP_START)) mergedStyle = {
        transition: 'none',
        ...mergedStyle
    };
    return [
        getStatus,
        step,
        mergedStyle,
        asyncVisible ?? visible
    ];
}

},{"@rc-component/util":"6ZBDN","@rc-component/util/es/hooks/useState":"lIOMx","@rc-component/util/es/hooks/useSyncState":"lsc1i","react":"bmhQu","../interface":"45PsZ","./useDomMotionEvents":"lWDci","./useIsomorphicLayoutEffect":"i8jJO","./useStepQueue":"crzkn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lsc1i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSyncState);
var _react = require("react");
var _useEvent = require("./useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
function useSyncState(defaultValue) {
    const [, forceUpdate] = _react.useReducer((x)=>x + 1, 0);
    const currentValueRef = _react.useRef(defaultValue);
    const getValue = (0, _useEventDefault.default)(()=>{
        return currentValueRef.current;
    });
    const setValue = (0, _useEventDefault.default)((updater)=>{
        currentValueRef.current = typeof updater === 'function' ? updater(currentValueRef.current) : updater;
        forceUpdate();
    });
    return [
        getValue,
        setValue
    ];
}

},{"react":"bmhQu","./useEvent":"klq5U","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"45PsZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STATUS_NONE", ()=>STATUS_NONE);
parcelHelpers.export(exports, "STATUS_APPEAR", ()=>STATUS_APPEAR);
parcelHelpers.export(exports, "STATUS_ENTER", ()=>STATUS_ENTER);
parcelHelpers.export(exports, "STATUS_LEAVE", ()=>STATUS_LEAVE);
parcelHelpers.export(exports, "STEP_NONE", ()=>STEP_NONE);
parcelHelpers.export(exports, "STEP_PREPARE", ()=>STEP_PREPARE);
parcelHelpers.export(exports, "STEP_START", ()=>STEP_START);
parcelHelpers.export(exports, "STEP_ACTIVE", ()=>STEP_ACTIVE);
parcelHelpers.export(exports, "STEP_ACTIVATED", ()=>STEP_ACTIVATED);
parcelHelpers.export(exports, "STEP_PREPARED", ()=>STEP_PREPARED);
const STATUS_NONE = 'none';
const STATUS_APPEAR = 'appear';
const STATUS_ENTER = 'enter';
const STATUS_LEAVE = 'leave';
const STEP_NONE = 'none';
const STEP_PREPARE = 'prepare';
const STEP_START = 'start';
const STEP_ACTIVE = 'active';
const STEP_ACTIVATED = 'end';
const STEP_PREPARED = 'prepared';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lWDci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _motion = require("../util/motion");
exports.default = (onInternalMotionEnd)=>{
    const cacheElementRef = (0, _react.useRef)();
    // Remove events
    function removeMotionEvents(element) {
        if (element) {
            element.removeEventListener((0, _motion.transitionEndName), onInternalMotionEnd);
            element.removeEventListener((0, _motion.animationEndName), onInternalMotionEnd);
        }
    }
    // Patch events
    function patchMotionEvents(element) {
        if (cacheElementRef.current && cacheElementRef.current !== element) removeMotionEvents(cacheElementRef.current);
        if (element && element !== cacheElementRef.current) {
            element.addEventListener((0, _motion.transitionEndName), onInternalMotionEnd);
            element.addEventListener((0, _motion.animationEndName), onInternalMotionEnd);
            // Save as cache in case dom removed trigger by `motionDeadline`
            cacheElementRef.current = element;
        }
    }
    // Clean up when removed
    _react.useEffect(()=>()=>{
            removeMotionEvents(cacheElementRef.current);
            cacheElementRef.current = null;
        }, []);
    return [
        patchMotionEvents,
        removeMotionEvents
    ];
};

},{"react":"bmhQu","../util/motion":"LL3nA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"LL3nA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getVendorPrefixes", ()=>getVendorPrefixes);
parcelHelpers.export(exports, "getVendorPrefixedEventName", ()=>getVendorPrefixedEventName);
parcelHelpers.export(exports, "supportTransition", ()=>supportTransition);
parcelHelpers.export(exports, "animationEndName", ()=>animationEndName);
parcelHelpers.export(exports, "transitionEndName", ()=>transitionEndName);
parcelHelpers.export(exports, "getTransitionName", ()=>getTransitionName);
var _canUseDom = require("@rc-component/util/es/Dom/canUseDom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
// ================= Transition =================
// Event wrapper. Copy from react source code
function makePrefixMap(styleProp, eventName) {
    const prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes[`Webkit${styleProp}`] = `webkit${eventName}`;
    prefixes[`Moz${styleProp}`] = `moz${eventName}`;
    prefixes[`ms${styleProp}`] = `MS${eventName}`;
    prefixes[`O${styleProp}`] = `o${eventName.toLowerCase()}`;
    return prefixes;
}
function getVendorPrefixes(domSupport, win) {
    const prefixes = {
        animationend: makePrefixMap('Animation', 'AnimationEnd'),
        transitionend: makePrefixMap('Transition', 'TransitionEnd')
    };
    if (domSupport) {
        if (!('AnimationEvent' in win)) delete prefixes.animationend.animation;
        if (!('TransitionEvent' in win)) delete prefixes.transitionend.transition;
    }
    return prefixes;
}
const vendorPrefixes = getVendorPrefixes((0, _canUseDomDefault.default)(), typeof window !== 'undefined' ? window : {});
let style = {};
if ((0, _canUseDomDefault.default)()) ({ style } = document.createElement('div'));
const prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    const prefixMap = vendorPrefixes[eventName];
    if (prefixMap) {
        const stylePropList = Object.keys(prefixMap);
        const len = stylePropList.length;
        for(let i = 0; i < len; i += 1){
            const styleProp = stylePropList[i];
            if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
                prefixedEventNames[eventName] = prefixMap[styleProp];
                return prefixedEventNames[eventName];
            }
        }
    }
    return '';
}
const internalAnimationEndName = getVendorPrefixedEventName('animationend');
const internalTransitionEndName = getVendorPrefixedEventName('transitionend');
const supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
const animationEndName = internalAnimationEndName || 'animationend';
const transitionEndName = internalTransitionEndName || 'transitionend';
function getTransitionName(transitionName, transitionType) {
    if (!transitionName) return null;
    if (typeof transitionName === 'object') {
        const type = transitionType.replace(/-\w/g, (match)=>match[1].toUpperCase());
        return transitionName[type];
    }
    return `${transitionName}-${transitionType}`;
}

},{"@rc-component/util/es/Dom/canUseDom":"4Ky1R","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i8jJO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canUseDom = require("@rc-component/util/es/Dom/canUseDom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
var _react = require("react");
// It's safe to use `useLayoutEffect` but the warning is annoying
const useIsomorphicLayoutEffect = (0, _canUseDomDefault.default)() ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
exports.default = useIsomorphicLayoutEffect;

},{"@rc-component/util/es/Dom/canUseDom":"4Ky1R","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"crzkn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SkipStep", ()=>SkipStep);
parcelHelpers.export(exports, "DoStep", ()=>DoStep);
parcelHelpers.export(exports, "isActive", ()=>isActive);
var _useState = require("@rc-component/util/es/hooks/useState");
var _useStateDefault = parcelHelpers.interopDefault(_useState);
var _react = require("react");
var _interface = require("../interface");
var _useIsomorphicLayoutEffect = require("./useIsomorphicLayoutEffect");
var _useIsomorphicLayoutEffectDefault = parcelHelpers.interopDefault(_useIsomorphicLayoutEffect);
var _useNextFrame = require("./useNextFrame");
var _useNextFrameDefault = parcelHelpers.interopDefault(_useNextFrame);
const FULL_STEP_QUEUE = [
    (0, _interface.STEP_PREPARE),
    (0, _interface.STEP_START),
    (0, _interface.STEP_ACTIVE),
    (0, _interface.STEP_ACTIVATED)
];
const SIMPLE_STEP_QUEUE = [
    (0, _interface.STEP_PREPARE),
    (0, _interface.STEP_PREPARED)
];
const SkipStep = false;
const DoStep = true;
function isActive(step) {
    return step === (0, _interface.STEP_ACTIVE) || step === (0, _interface.STEP_ACTIVATED);
}
exports.default = (status, prepareOnly, callback)=>{
    const [step, setStep] = (0, _useStateDefault.default)((0, _interface.STEP_NONE));
    const [nextFrame, cancelNextFrame] = (0, _useNextFrameDefault.default)();
    function startQueue() {
        setStep((0, _interface.STEP_PREPARE), true);
    }
    const STEP_QUEUE = prepareOnly ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
    (0, _useIsomorphicLayoutEffectDefault.default)(()=>{
        if (step !== (0, _interface.STEP_NONE) && step !== (0, _interface.STEP_ACTIVATED)) {
            const index = STEP_QUEUE.indexOf(step);
            const nextStep = STEP_QUEUE[index + 1];
            const result = callback(step);
            if (result === SkipStep) // Skip when no needed
            setStep(nextStep, true);
            else if (nextStep) // Do as frame for step update
            nextFrame((info)=>{
                function doNext() {
                    // Skip since current queue is ood
                    if (info.isCanceled()) return;
                    setStep(nextStep, true);
                }
                if (result === true) doNext();
                else // Only promise should be async
                Promise.resolve(result).then(doNext);
            });
        }
    }, [
        status,
        step
    ]);
    _react.useEffect(()=>()=>{
            cancelNextFrame();
        }, []);
    return [
        startQueue,
        step
    ];
};

},{"@rc-component/util/es/hooks/useState":"lIOMx","react":"bmhQu","../interface":"45PsZ","./useIsomorphicLayoutEffect":"i8jJO","./useNextFrame":"8ZsQZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8ZsQZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _react = require("react");
exports.default = ()=>{
    const nextFrameRef = _react.useRef(null);
    function cancelNextFrame() {
        (0, _rafDefault.default).cancel(nextFrameRef.current);
    }
    function nextFrame(callback, delay = 2) {
        cancelNextFrame();
        const nextFrameId = (0, _rafDefault.default)(()=>{
            if (delay <= 1) callback({
                isCanceled: ()=>nextFrameId !== nextFrameRef.current
            });
            else nextFrame(callback, delay - 1);
        });
        nextFrameRef.current = nextFrameId;
    }
    _react.useEffect(()=>()=>{
            cancelNextFrame();
        }, []);
    return [
        nextFrame,
        cancelNextFrame
    ];
};

},{"@rc-component/util/es/raf":"ajbAx","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Jex9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Generate a CSSMotionList component with config
 * @param transitionSupport No need since CSSMotionList no longer depends on transition support
 * @param CSSMotion CSSMotion component
 */ parcelHelpers.export(exports, "genCSSMotionList", ()=>genCSSMotionList);
/* eslint react/prop-types: 0 */ var _react = require("react");
var _cssmotion = require("./CSSMotion");
var _cssmotionDefault = parcelHelpers.interopDefault(_cssmotion);
var _diff = require("./util/diff");
var _motion = require("./util/motion");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const MOTION_PROP_NAMES = [
    'eventProps',
    'visible',
    'children',
    'motionName',
    'motionAppear',
    'motionEnter',
    'motionLeave',
    'motionLeaveImmediately',
    'motionDeadline',
    'removeOnLeave',
    'leavedClassName',
    'onAppearPrepare',
    'onAppearStart',
    'onAppearActive',
    'onAppearEnd',
    'onEnterStart',
    'onEnterActive',
    'onEnterEnd',
    'onLeaveStart',
    'onLeaveActive',
    'onLeaveEnd'
];
function genCSSMotionList(transitionSupport, CSSMotion = (0, _cssmotionDefault.default)) {
    class CSSMotionList extends _react.Component {
        static defaultProps = {
            component: 'div'
        };
        state = {
            keyEntities: []
        };
        static getDerivedStateFromProps({ keys }, { keyEntities }) {
            const parsedKeyObjects = (0, _diff.parseKeys)(keys);
            const mixedKeyEntities = (0, _diff.diffKeys)(keyEntities, parsedKeyObjects);
            return {
                keyEntities: mixedKeyEntities.filter((entity)=>{
                    const prevEntity = keyEntities.find(({ key })=>entity.key === key);
                    // Remove if already mark as removed
                    if (prevEntity && prevEntity.status === (0, _diff.STATUS_REMOVED) && entity.status === (0, _diff.STATUS_REMOVE)) return false;
                    return true;
                })
            };
        }
        // ZombieJ: Return the count of rest keys. It's safe to refactor if need more info.
        removeKey = (removeKey)=>{
            this.setState((prevState)=>{
                const nextKeyEntities = prevState.keyEntities.map((entity)=>{
                    if (entity.key !== removeKey) return entity;
                    return {
                        ...entity,
                        status: (0, _diff.STATUS_REMOVED)
                    };
                });
                return {
                    keyEntities: nextKeyEntities
                };
            }, ()=>{
                const { keyEntities } = this.state;
                const restKeysCount = keyEntities.filter(({ status })=>status !== (0, _diff.STATUS_REMOVED)).length;
                if (restKeysCount === 0 && this.props.onAllRemoved) this.props.onAllRemoved();
            });
        };
        render() {
            const { keyEntities } = this.state;
            const { component, children, onVisibleChanged, onAllRemoved, ...restProps } = this.props;
            const Component = component || _react.Fragment;
            const motionProps = {};
            MOTION_PROP_NAMES.forEach((prop)=>{
                motionProps[prop] = restProps[prop];
                delete restProps[prop];
            });
            delete restProps.keys;
            return /*#__PURE__*/ _react.createElement(Component, restProps, keyEntities.map(({ status, ...eventProps }, index)=>{
                const visible = status === (0, _diff.STATUS_ADD) || status === (0, _diff.STATUS_KEEP);
                return /*#__PURE__*/ _react.createElement(CSSMotion, _extends({}, motionProps, {
                    key: eventProps.key,
                    visible: visible,
                    eventProps: eventProps,
                    onVisibleChanged: (changedVisible)=>{
                        onVisibleChanged?.(changedVisible, {
                            key: eventProps.key
                        });
                        if (!changedVisible) this.removeKey(eventProps.key);
                    }
                }), (props, ref)=>children({
                        ...props,
                        index
                    }, ref));
            }));
        }
    }
    return CSSMotionList;
}
exports.default = genCSSMotionList((0, _motion.supportTransition));

},{"react":"bmhQu","./CSSMotion":"dIBqX","./util/diff":"4A3hj","./util/motion":"LL3nA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4A3hj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "STATUS_ADD", ()=>STATUS_ADD);
parcelHelpers.export(exports, "STATUS_KEEP", ()=>STATUS_KEEP);
parcelHelpers.export(exports, "STATUS_REMOVE", ()=>STATUS_REMOVE);
parcelHelpers.export(exports, "STATUS_REMOVED", ()=>STATUS_REMOVED);
parcelHelpers.export(exports, "wrapKeyToObject", ()=>wrapKeyToObject);
parcelHelpers.export(exports, "parseKeys", ()=>parseKeys);
parcelHelpers.export(exports, "diffKeys", ()=>diffKeys);
const STATUS_ADD = 'add';
const STATUS_KEEP = 'keep';
const STATUS_REMOVE = 'remove';
const STATUS_REMOVED = 'removed';
function wrapKeyToObject(key) {
    let keyObj;
    if (key && typeof key === 'object' && 'key' in key) keyObj = key;
    else keyObj = {
        key: key
    };
    return {
        ...keyObj,
        key: String(keyObj.key)
    };
}
function parseKeys(keys = []) {
    return keys.map(wrapKeyToObject);
}
function diffKeys(prevKeys = [], currentKeys = []) {
    let list = [];
    let currentIndex = 0;
    const currentLen = currentKeys.length;
    const prevKeyObjects = parseKeys(prevKeys);
    const currentKeyObjects = parseKeys(currentKeys);
    // Check prev keys to insert or keep
    prevKeyObjects.forEach((keyObj)=>{
        let hit = false;
        for(let i = currentIndex; i < currentLen; i += 1){
            const currentKeyObj = currentKeyObjects[i];
            if (currentKeyObj.key === keyObj.key) {
                // New added keys should add before current key
                if (currentIndex < i) {
                    list = list.concat(currentKeyObjects.slice(currentIndex, i).map((obj)=>({
                            ...obj,
                            status: STATUS_ADD
                        })));
                    currentIndex = i;
                }
                list.push({
                    ...currentKeyObj,
                    status: STATUS_KEEP
                });
                currentIndex += 1;
                hit = true;
                break;
            }
        }
        // If not hit, it means key is removed
        if (!hit) list.push({
            ...keyObj,
            status: STATUS_REMOVE
        });
    });
    // Add rest to the list
    if (currentIndex < currentLen) list = list.concat(currentKeyObjects.slice(currentIndex).map((obj)=>({
            ...obj,
            status: STATUS_ADD
        })));
    /**
   * Merge same key when it remove and add again:
   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
   */ const keys = {};
    list.forEach(({ key })=>{
        keys[key] = (keys[key] || 0) + 1;
    });
    const duplicatedKeys = Object.keys(keys).filter((key)=>keys[key] > 1);
    duplicatedKeys.forEach((matchKey)=>{
        // Remove `STATUS_REMOVE` node.
        list = list.filter(({ key, status })=>key !== matchKey || status !== STATUS_REMOVE);
        // Update `STATUS_ADD` to `STATUS_KEEP`
        list.forEach((node)=>{
            if (node.key === matchKey) // eslint-disable-next-line no-param-reassign
            node.status = STATUS_KEEP;
        });
    });
    return list;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jjH3K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Arrow);
var _clsx = require("clsx");
var _react = require("react");
function Arrow(props) {
    const { prefixCls, align, arrow, arrowPos } = props;
    const { className, content, style } = arrow || {};
    const { x = 0, y = 0 } = arrowPos;
    const arrowRef = _react.useRef(null);
    // Skip if no align
    if (!align || !align.points) return null;
    const alignStyle = {
        position: 'absolute'
    };
    // Skip if no need to align
    if (align.autoArrow !== false) {
        const popupPoints = align.points[0];
        const targetPoints = align.points[1];
        const popupTB = popupPoints[0];
        const popupLR = popupPoints[1];
        const targetTB = targetPoints[0];
        const targetLR = targetPoints[1];
        // Top & Bottom
        if (popupTB === targetTB || ![
            't',
            'b'
        ].includes(popupTB)) alignStyle.top = y;
        else if (popupTB === 't') alignStyle.top = 0;
        else alignStyle.bottom = 0;
        // Left & Right
        if (popupLR === targetLR || ![
            'l',
            'r'
        ].includes(popupLR)) alignStyle.left = x;
        else if (popupLR === 'l') alignStyle.left = 0;
        else alignStyle.right = 0;
    }
    return /*#__PURE__*/ _react.createElement("div", {
        ref: arrowRef,
        className: (0, _clsx.clsx)(`${prefixCls}-arrow`, className),
        style: {
            ...alignStyle,
            ...style
        }
    }, content);
}

},{"clsx":"431Ou","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6AEh4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Mask);
var _clsx = require("clsx");
var _motion = require("@rc-component/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
var _react = require("react");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function Mask(props) {
    const { prefixCls, open, zIndex, mask, motion, mobile } = props;
    if (!mask) return null;
    return /*#__PURE__*/ _react.createElement((0, _motionDefault.default), _extends({}, motion, {
        motionAppear: true,
        visible: open,
        removeOnLeave: true
    }), ({ className })=>/*#__PURE__*/ _react.createElement("div", {
            style: {
                zIndex
            },
            className: (0, _clsx.clsx)(`${prefixCls}-mask`, mobile && `${prefixCls}-mobile-mask`, className)
        }));
}

},{"clsx":"431Ou","@rc-component/motion":"gBwXg","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g3gR7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const PopupContent = /*#__PURE__*/ _react.memo(({ children })=>children, (_, next)=>next.cache);
exports.default = PopupContent;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6biMe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOffsetStyle);
function useOffsetStyle(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY) {
    // >>>>> Offset
    const AUTO = 'auto';
    const offsetStyle = isMobile ? {} : {
        left: '-1000vw',
        top: '-1000vh',
        right: AUTO,
        bottom: AUTO
    };
    // Set align style
    if (!isMobile && (ready || !open)) {
        const { points } = align;
        const dynamicInset = align.dynamicInset || align._experimental?.dynamicInset;
        const alignRight = dynamicInset && points[0][1] === 'r';
        const alignBottom = dynamicInset && points[0][0] === 'b';
        if (alignRight) {
            offsetStyle.right = offsetR;
            offsetStyle.left = AUTO;
        } else {
            offsetStyle.left = offsetX;
            offsetStyle.right = AUTO;
        }
        if (alignBottom) {
            offsetStyle.bottom = offsetB;
            offsetStyle.top = AUTO;
        } else {
            offsetStyle.top = offsetY;
            offsetStyle.bottom = AUTO;
        }
    }
    return offsetStyle;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"adq9u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UniqueContext", ()=>UniqueContext);
var _react = require("react");
// ===================== Nest =====================
const TriggerContext = /*#__PURE__*/ _react.createContext(null);
exports.default = TriggerContext;
const UniqueContext = /*#__PURE__*/ _react.createContext(null);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dAB9Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAction);
var _react = require("react");
function toArray(val) {
    return val ? Array.isArray(val) ? val : [
        val
    ] : [];
}
function useAction(action, showAction, hideAction) {
    return _react.useMemo(()=>{
        const mergedShowAction = toArray(showAction ?? action);
        const mergedHideAction = toArray(hideAction ?? action);
        const showActionSet = new Set(mergedShowAction);
        const hideActionSet = new Set(mergedHideAction);
        if (showActionSet.has('hover') && !showActionSet.has('click')) showActionSet.add('touch');
        if (hideActionSet.has('hover') && !hideActionSet.has('click')) hideActionSet.add('touch');
        return [
            showActionSet,
            hideActionSet
        ];
    }, [
        action,
        showAction,
        hideAction
    ]);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Kopn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAlign);
var _findDOMNode = require("@rc-component/util/es/Dom/findDOMNode");
var _isVisible = require("@rc-component/util/es/Dom/isVisible");
var _isVisibleDefault = parcelHelpers.interopDefault(_isVisible);
var _useEvent = require("@rc-component/util/es/hooks/useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _react = require("react");
var _util = require("../util");
function getUnitOffset(size, offset = 0) {
    const offsetStr = `${offset}`;
    const cells = offsetStr.match(/^(.*)\%$/);
    if (cells) return size * (parseFloat(cells[1]) / 100);
    return parseFloat(offsetStr);
}
function getNumberOffset(rect, offset) {
    const [offsetX, offsetY] = offset || [];
    return [
        getUnitOffset(rect.width, offsetX),
        getUnitOffset(rect.height, offsetY)
    ];
}
function splitPoints(points = '') {
    return [
        points[0],
        points[1]
    ];
}
function getAlignPoint(rect, points) {
    const topBottom = points[0];
    const leftRight = points[1];
    let x;
    let y;
    // Top & Bottom
    if (topBottom === 't') y = rect.y;
    else if (topBottom === 'b') y = rect.y + rect.height;
    else y = rect.y + rect.height / 2;
    // Left & Right
    if (leftRight === 'l') x = rect.x;
    else if (leftRight === 'r') x = rect.x + rect.width;
    else x = rect.x + rect.width / 2;
    return {
        x,
        y
    };
}
function reversePoints(points, index) {
    const reverseMap = {
        t: 'b',
        b: 't',
        l: 'r',
        r: 'l'
    };
    const clone = [
        ...points
    ];
    clone[index] = reverseMap[points[index]] || 'c';
    return clone;
}
function flatPoints(points) {
    return points.join('');
}
function useAlign(open, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign, mobile) {
    const [offsetInfo, setOffsetInfo] = _react.useState({
        ready: false,
        offsetX: 0,
        offsetY: 0,
        offsetR: 0,
        offsetB: 0,
        arrowX: 0,
        arrowY: 0,
        scaleX: 1,
        scaleY: 1,
        align: builtinPlacements[placement] || {}
    });
    const alignCountRef = _react.useRef(0);
    const scrollerList = _react.useMemo(()=>{
        if (!popupEle || mobile) return [];
        return (0, _util.collectScroller)(popupEle);
    }, [
        popupEle
    ]);
    // ========================= Flip ==========================
    // We will memo flip info.
    // If size change to make flip, it will memo the flip info and use it in next align.
    const prevFlipRef = _react.useRef({});
    const resetFlipCache = ()=>{
        prevFlipRef.current = {};
    };
    if (!open) resetFlipCache();
    // ========================= Align =========================
    const onAlign = (0, _useEventDefault.default)(()=>{
        if (popupEle && target && open && !mobile) {
            const popupElement = popupEle;
            const doc = popupElement.ownerDocument;
            const win = (0, _util.getWin)(popupElement);
            const { position: popupPosition } = win.getComputedStyle(popupElement);
            const originLeft = popupElement.style.left;
            const originTop = popupElement.style.top;
            const originRight = popupElement.style.right;
            const originBottom = popupElement.style.bottom;
            const originOverflow = popupElement.style.overflow;
            // Placement
            const placementInfo = {
                ...builtinPlacements[placement],
                ...popupAlign
            };
            // placeholder element
            const placeholderElement = doc.createElement('div');
            popupElement.parentElement?.appendChild(placeholderElement);
            placeholderElement.style.left = `${popupElement.offsetLeft}px`;
            placeholderElement.style.top = `${popupElement.offsetTop}px`;
            placeholderElement.style.position = popupPosition;
            placeholderElement.style.height = `${popupElement.offsetHeight}px`;
            placeholderElement.style.width = `${popupElement.offsetWidth}px`;
            // Reset first
            popupElement.style.left = '0';
            popupElement.style.top = '0';
            popupElement.style.right = 'auto';
            popupElement.style.bottom = 'auto';
            popupElement.style.overflow = 'hidden';
            // Calculate align style, we should consider `transform` case
            let targetRect;
            if (Array.isArray(target)) targetRect = {
                x: target[0],
                y: target[1],
                width: 0,
                height: 0
            };
            else {
                const rect = target.getBoundingClientRect();
                rect.x = rect.x ?? rect.left;
                rect.y = rect.y ?? rect.top;
                targetRect = {
                    x: rect.x,
                    y: rect.y,
                    width: rect.width,
                    height: rect.height
                };
            }
            const popupRect = popupElement.getBoundingClientRect();
            const { height, width } = win.getComputedStyle(popupElement);
            popupRect.x = popupRect.x ?? popupRect.left;
            popupRect.y = popupRect.y ?? popupRect.top;
            const { clientWidth, clientHeight, scrollWidth, scrollHeight, scrollTop, scrollLeft } = doc.documentElement;
            const popupHeight = popupRect.height;
            const popupWidth = popupRect.width;
            const targetHeight = targetRect.height;
            const targetWidth = targetRect.width;
            // Get bounding of visible area
            const visibleRegion = {
                left: 0,
                top: 0,
                right: clientWidth,
                bottom: clientHeight
            };
            const scrollRegion = {
                left: -scrollLeft,
                top: -scrollTop,
                right: scrollWidth - scrollLeft,
                bottom: scrollHeight - scrollTop
            };
            let { htmlRegion } = placementInfo;
            const VISIBLE = 'visible';
            const VISIBLE_FIRST = 'visibleFirst';
            if (htmlRegion !== 'scroll' && htmlRegion !== VISIBLE_FIRST) htmlRegion = VISIBLE;
            const isVisibleFirst = htmlRegion === VISIBLE_FIRST;
            const scrollRegionArea = (0, _util.getVisibleArea)(scrollRegion, scrollerList);
            const visibleRegionArea = (0, _util.getVisibleArea)(visibleRegion, scrollerList);
            const visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
            // When set to `visibleFirst`,
            // the check `adjust` logic will use `visibleRegion` for check first.
            const adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
            // Record right & bottom align data
            popupElement.style.left = 'auto';
            popupElement.style.top = 'auto';
            popupElement.style.right = '0';
            popupElement.style.bottom = '0';
            const popupMirrorRect = popupElement.getBoundingClientRect();
            // Reset back
            popupElement.style.left = originLeft;
            popupElement.style.top = originTop;
            popupElement.style.right = originRight;
            popupElement.style.bottom = originBottom;
            popupElement.style.overflow = originOverflow;
            popupElement.parentElement?.removeChild(placeholderElement);
            // Calculate scale
            const scaleX = (0, _util.toNum)(Math.round(popupWidth / parseFloat(width) * 1000) / 1000);
            const scaleY = (0, _util.toNum)(Math.round(popupHeight / parseFloat(height) * 1000) / 1000);
            // No need to align since it's not visible in view
            if (scaleX === 0 || scaleY === 0 || (0, _findDOMNode.isDOM)(target) && !(0, _isVisibleDefault.default)(target)) return;
            // Offset
            const { offset, targetOffset } = placementInfo;
            let [popupOffsetX, popupOffsetY] = getNumberOffset(popupRect, offset);
            const [targetOffsetX, targetOffsetY] = getNumberOffset(targetRect, targetOffset);
            targetRect.x -= targetOffsetX;
            targetRect.y -= targetOffsetY;
            // Points
            const [popupPoint, targetPoint] = placementInfo.points || [];
            const targetPoints = splitPoints(targetPoint);
            const popupPoints = splitPoints(popupPoint);
            const targetAlignPoint = getAlignPoint(targetRect, targetPoints);
            const popupAlignPoint = getAlignPoint(popupRect, popupPoints);
            // Real align info may not same as origin one
            const nextAlignInfo = {
                ...placementInfo
            };
            let nextPoints = [
                popupPoints,
                targetPoints
            ];
            // Next Offset
            let nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
            let nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
            // ============== Intersection ===============
            // Get area by position. Used for check if flip area is better
            function getIntersectionVisibleArea(offsetX, offsetY, area = visibleArea) {
                const l = popupRect.x + offsetX;
                const t = popupRect.y + offsetY;
                const r = l + popupWidth;
                const b = t + popupHeight;
                const visibleL = Math.max(l, area.left);
                const visibleT = Math.max(t, area.top);
                const visibleR = Math.min(r, area.right);
                const visibleB = Math.min(b, area.bottom);
                return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
            }
            const originIntersectionVisibleArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY);
            // As `visibleFirst`, we prepare this for check
            const originIntersectionRecommendArea = getIntersectionVisibleArea(nextOffsetX, nextOffsetY, visibleRegionArea);
            // ========================== Overflow ===========================
            const targetAlignPointTL = getAlignPoint(targetRect, [
                't',
                'l'
            ]);
            const popupAlignPointTL = getAlignPoint(popupRect, [
                't',
                'l'
            ]);
            const targetAlignPointBR = getAlignPoint(targetRect, [
                'b',
                'r'
            ]);
            const popupAlignPointBR = getAlignPoint(popupRect, [
                'b',
                'r'
            ]);
            const overflow = placementInfo.overflow || {};
            const { adjustX, adjustY, shiftX, shiftY } = overflow;
            const supportAdjust = (val)=>{
                if (typeof val === 'boolean') return val;
                return val >= 0;
            };
            // Prepare position
            let nextPopupY;
            let nextPopupBottom;
            let nextPopupX;
            let nextPopupRight;
            function syncNextPopupPosition() {
                nextPopupY = popupRect.y + nextOffsetY;
                nextPopupBottom = nextPopupY + popupHeight;
                nextPopupX = popupRect.x + nextOffsetX;
                nextPopupRight = nextPopupX + popupWidth;
            }
            syncNextPopupPosition();
            // >>>>>>>>>> Top & Bottom
            const needAdjustY = supportAdjust(adjustY);
            const sameTB = popupPoints[0] === targetPoints[0];
            // Bottom to Top
            if (needAdjustY && popupPoints[0] === 't' && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
                let tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY -= popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
                const newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.bt = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextPoints = [
                        reversePoints(nextPoints[0], 0),
                        reversePoints(nextPoints[1], 0)
                    ];
                } else prevFlipRef.current.bt = false;
            }
            // Top to Bottom
            if (needAdjustY && popupPoints[0] === 'b' && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
                let tmpNextOffsetY = nextOffsetY;
                if (sameTB) tmpNextOffsetY += popupHeight - targetHeight;
                else tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
                const newVisibleArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.tb = true;
                    nextOffsetY = tmpNextOffsetY;
                    popupOffsetY = -popupOffsetY;
                    nextPoints = [
                        reversePoints(nextPoints[0], 0),
                        reversePoints(nextPoints[1], 0)
                    ];
                } else prevFlipRef.current.tb = false;
            }
            // >>>>>>>>>> Left & Right
            const needAdjustX = supportAdjust(adjustX);
            // >>>>> Flip
            const sameLR = popupPoints[1] === targetPoints[1];
            // Right to Left
            if (needAdjustX && popupPoints[1] === 'l' && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
                let tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX -= popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
                const newVisibleArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.rl = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextPoints = [
                        reversePoints(nextPoints[0], 1),
                        reversePoints(nextPoints[1], 1)
                    ];
                } else prevFlipRef.current.rl = false;
            }
            // Left to Right
            if (needAdjustX && popupPoints[1] === 'r' && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
                let tmpNextOffsetX = nextOffsetX;
                if (sameLR) tmpNextOffsetX += popupWidth - targetWidth;
                else tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
                const newVisibleArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY);
                const newVisibleRecommendArea = getIntersectionVisibleArea(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
                if (// Of course use larger one
                newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
                newVisibleRecommendArea >= originIntersectionRecommendArea)) {
                    prevFlipRef.current.lr = true;
                    nextOffsetX = tmpNextOffsetX;
                    popupOffsetX = -popupOffsetX;
                    nextPoints = [
                        reversePoints(nextPoints[0], 1),
                        reversePoints(nextPoints[1], 1)
                    ];
                } else prevFlipRef.current.lr = false;
            }
            nextAlignInfo.points = [
                flatPoints(nextPoints[0]),
                flatPoints(nextPoints[1])
            ];
            // ============================ Shift ============================
            syncNextPopupPosition();
            const numShiftX = shiftX === true ? 0 : shiftX;
            if (typeof numShiftX === 'number') {
                // Left
                if (nextPopupX < visibleRegionArea.left) {
                    nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
                    if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
                }
                // Right
                if (nextPopupRight > visibleRegionArea.right) {
                    nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
                    if (targetRect.x > visibleRegionArea.right - numShiftX) nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
                }
            }
            const numShiftY = shiftY === true ? 0 : shiftY;
            if (typeof numShiftY === 'number') {
                // Top
                if (nextPopupY < visibleRegionArea.top) {
                    nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
                    // When target if far away from visible area
                    // Stop shift
                    if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
                }
                // Bottom
                if (nextPopupBottom > visibleRegionArea.bottom) {
                    nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
                    if (targetRect.y > visibleRegionArea.bottom - numShiftY) nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
                }
            }
            // ============================ Arrow ============================
            // Arrow center align
            const popupLeft = popupRect.x + nextOffsetX;
            const popupRight = popupLeft + popupWidth;
            const popupTop = popupRect.y + nextOffsetY;
            const popupBottom = popupTop + popupHeight;
            const targetLeft = targetRect.x;
            const targetRight = targetLeft + targetWidth;
            const targetTop = targetRect.y;
            const targetBottom = targetTop + targetHeight;
            /** Max left of the popup and target element */ const maxLeft = Math.max(popupLeft, targetLeft);
            /** Min right of the popup and target element */ const minRight = Math.min(popupRight, targetRight);
            /** The center X of popup & target cross area */ const xCenter = (maxLeft + minRight) / 2;
            /** Arrow X of popup offset */ const nextArrowX = xCenter - popupLeft;
            const maxTop = Math.max(popupTop, targetTop);
            const minBottom = Math.min(popupBottom, targetBottom);
            const yCenter = (maxTop + minBottom) / 2;
            const nextArrowY = yCenter - popupTop;
            onPopupAlign?.(popupEle, nextAlignInfo);
            // Additional calculate right & bottom position
            let offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
            let offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
            if (scaleX === 1) {
                nextOffsetX = Math.round(nextOffsetX);
                offsetX4Right = Math.round(offsetX4Right);
            }
            if (scaleY === 1) {
                nextOffsetY = Math.round(nextOffsetY);
                offsetY4Bottom = Math.round(offsetY4Bottom);
            }
            const nextOffsetInfo = {
                ready: true,
                offsetX: nextOffsetX / scaleX,
                offsetY: nextOffsetY / scaleY,
                offsetR: offsetX4Right / scaleX,
                offsetB: offsetY4Bottom / scaleY,
                arrowX: nextArrowX / scaleX,
                arrowY: nextArrowY / scaleY,
                scaleX,
                scaleY,
                align: nextAlignInfo
            };
            setOffsetInfo(nextOffsetInfo);
        }
    });
    const triggerAlign = ()=>{
        alignCountRef.current += 1;
        const id = alignCountRef.current;
        // Merge all align requirement into one frame
        Promise.resolve().then(()=>{
            if (alignCountRef.current === id) onAlign();
        });
    };
    // Reset ready status when placement & open changed
    const resetReady = ()=>{
        setOffsetInfo((ori)=>({
                ...ori,
                ready: false
            }));
    };
    (0, _useLayoutEffectDefault.default)(resetReady, [
        placement
    ]);
    (0, _useLayoutEffectDefault.default)(()=>{
        if (!open) resetReady();
    }, [
        open
    ]);
    return [
        offsetInfo.ready,
        offsetInfo.offsetX,
        offsetInfo.offsetY,
        offsetInfo.offsetR,
        offsetInfo.offsetB,
        offsetInfo.arrowX,
        offsetInfo.arrowY,
        offsetInfo.scaleX,
        offsetInfo.scaleY,
        offsetInfo.align,
        triggerAlign
    ];
}

},{"@rc-component/util/es/Dom/findDOMNode":"5IZto","@rc-component/util/es/Dom/isVisible":"frSWl","@rc-component/util/es/hooks/useEvent":"klq5U","@rc-component/util/es/hooks/useLayoutEffect":"azwns","react":"bmhQu","../util":"6rWry","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"frSWl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = (element)=>{
    if (!element) return false;
    if (element instanceof Element) {
        if (element.offsetParent) return true;
        if (element.getBBox) {
            const { width, height } = element.getBBox();
            if (width || height) return true;
        }
        if (element.getBoundingClientRect) {
            const { width, height } = element.getBoundingClientRect();
            if (width || height) return true;
        }
    }
    return false;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6rWry":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAlignPopupClassName", ()=>getAlignPopupClassName);
parcelHelpers.export(exports, "getWin", ()=>getWin);
/**
 * Get all the scrollable parent elements of the element
 * @param ele       The element to be detected
 * @param areaOnly  Only return the parent which will cut visible area
 */ parcelHelpers.export(exports, "collectScroller", ()=>collectScroller);
parcelHelpers.export(exports, "toNum", ()=>toNum);
/**
 *
 *
 *  **************************************
 *  *              Border                *
 *  *     **************************     *
 *  *     *                  *     *     *
 *  *  B  *                  *  S  *  B  *
 *  *  o  *                  *  c  *  o  *
 *  *  r  *      Content     *  r  *  r  *
 *  *  d  *                  *  o  *  d  *
 *  *  e  *                  *  l  *  e  *
 *  *  r  ********************  l  *  r  *
 *  *     *        Scroll          *     *
 *  *     **************************     *
 *  *              Border                *
 *  **************************************
 *
 */ /**
 * Get visible area of element
 */ parcelHelpers.export(exports, "getVisibleArea", ()=>getVisibleArea);
function isPointsEq(a1 = [], a2 = [], isAlignPoint) {
    const getVal = (a, index)=>a[index] || '';
    if (isAlignPoint) return getVal(a1, 0) === getVal(a2, 0);
    return getVal(a1, 0) === getVal(a2, 0) && getVal(a1, 1) === getVal(a2, 1);
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
    const { points } = align;
    const placements = Object.keys(builtinPlacements);
    for(let i = 0; i < placements.length; i += 1){
        const placement = placements[i];
        if (isPointsEq(builtinPlacements[placement]?.points, points, isAlignPoint)) return `${prefixCls}-placement-${placement}`;
    }
    return '';
}
function getWin(ele) {
    return ele.ownerDocument.defaultView;
}
function collectScroller(ele) {
    const scrollerList = [];
    let current = ele?.parentElement;
    const scrollStyle = [
        'hidden',
        'scroll',
        'clip',
        'auto'
    ];
    while(current){
        const { overflowX, overflowY, overflow } = getWin(current).getComputedStyle(current);
        if ([
            overflowX,
            overflowY,
            overflow
        ].some((o)=>scrollStyle.includes(o))) scrollerList.push(current);
        current = current.parentElement;
    }
    return scrollerList;
}
function toNum(num, defaultValue = 1) {
    return Number.isNaN(num) ? defaultValue : num;
}
function getPxValue(val) {
    return toNum(parseFloat(val), 0);
}
function getVisibleArea(initArea, scrollerList) {
    const visibleArea = {
        ...initArea
    };
    (scrollerList || []).forEach((ele)=>{
        if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) return;
        // Skip if static position which will not affect visible area
        const { overflow, overflowClipMargin, borderTopWidth, borderBottomWidth, borderLeftWidth, borderRightWidth } = getWin(ele).getComputedStyle(ele);
        const eleRect = ele.getBoundingClientRect();
        const { offsetHeight: eleOutHeight, clientHeight: eleInnerHeight, offsetWidth: eleOutWidth, clientWidth: eleInnerWidth } = ele;
        const borderTopNum = getPxValue(borderTopWidth);
        const borderBottomNum = getPxValue(borderBottomWidth);
        const borderLeftNum = getPxValue(borderLeftWidth);
        const borderRightNum = getPxValue(borderRightWidth);
        const scaleX = toNum(Math.round(eleRect.width / eleOutWidth * 1000) / 1000);
        const scaleY = toNum(Math.round(eleRect.height / eleOutHeight * 1000) / 1000);
        // Original visible area
        const eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
        const eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
        // Cut border size
        const scaledBorderTopWidth = borderTopNum * scaleY;
        const scaledBorderBottomWidth = borderBottomNum * scaleY;
        const scaledBorderLeftWidth = borderLeftNum * scaleX;
        const scaledBorderRightWidth = borderRightNum * scaleX;
        // Clip margin
        let clipMarginWidth = 0;
        let clipMarginHeight = 0;
        if (overflow === 'clip') {
            const clipNum = getPxValue(overflowClipMargin);
            clipMarginWidth = clipNum * scaleX;
            clipMarginHeight = clipNum * scaleY;
        }
        // Region
        const eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
        const eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
        const eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
        const eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
        visibleArea.left = Math.max(visibleArea.left, eleLeft);
        visibleArea.top = Math.max(visibleArea.top, eleTop);
        visibleArea.right = Math.min(visibleArea.right, eleRight);
        visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
    });
    return visibleArea;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6mBMF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDelay);
var _react = require("react");
function useDelay() {
    const delayRef = _react.useRef(null);
    const clearDelay = ()=>{
        if (delayRef.current) {
            clearTimeout(delayRef.current);
            delayRef.current = null;
        }
    };
    const delayInvoke = (callback, delay)=>{
        clearDelay();
        if (delay === 0) callback();
        else delayRef.current = setTimeout(()=>{
            callback();
        }, delay * 1000);
    };
    // Clean up on unmount
    _react.useEffect(()=>{
        return ()=>{
            clearDelay();
        };
    }, []);
    return delayInvoke;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eEHBc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWatch);
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _util = require("../util");
function useWatch(open, target, popup, onAlign, onScroll) {
    (0, _useLayoutEffectDefault.default)(()=>{
        if (open && target && popup) {
            const targetElement = target;
            const popupElement = popup;
            const targetScrollList = (0, _util.collectScroller)(targetElement);
            const popupScrollList = (0, _util.collectScroller)(popupElement);
            const win = (0, _util.getWin)(popupElement);
            const mergedList = new Set([
                win,
                ...targetScrollList,
                ...popupScrollList
            ]);
            function notifyScroll() {
                onAlign();
                onScroll();
            }
            mergedList.forEach((scroller)=>{
                scroller.addEventListener('scroll', notifyScroll, {
                    passive: true
                });
            });
            win.addEventListener('resize', notifyScroll, {
                passive: true
            });
            // First time always do align
            onAlign();
            return ()=>{
                mergedList.forEach((scroller)=>{
                    scroller.removeEventListener('scroll', notifyScroll);
                    win.removeEventListener('resize', notifyScroll);
                });
            };
        }
    }, [
        open,
        target,
        popup
    ]);
}

},{"@rc-component/util/es/hooks/useLayoutEffect":"azwns","../util":"6rWry","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"djPMI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useWinClick);
var _shadow = require("@rc-component/util/es/Dom/shadow");
var _warning = require("@rc-component/util/es/warning");
var _react = require("react");
var _util = require("../util");
function useWinClick(open, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
    const openRef = _react.useRef(open);
    openRef.current = open;
    const popupPointerDownRef = _react.useRef(false);
    // Click to hide is special action since click popup element should not hide
    _react.useEffect(()=>{
        if (clickToHide && popupEle && (!mask || maskClosable)) {
            const onPointerDown = ()=>{
                popupPointerDownRef.current = false;
            };
            const onTriggerClose = (e)=>{
                if (openRef.current && !inPopupOrChild(e.composedPath?.()?.[0] || e.target) && !popupPointerDownRef.current) triggerOpen(false);
            };
            const win = (0, _util.getWin)(popupEle);
            win.addEventListener('pointerdown', onPointerDown, true);
            win.addEventListener('mousedown', onTriggerClose, true);
            win.addEventListener('contextmenu', onTriggerClose, true);
            // shadow root
            const targetShadowRoot = (0, _shadow.getShadowRoot)(targetEle);
            if (targetShadowRoot) {
                targetShadowRoot.addEventListener('mousedown', onTriggerClose, true);
                targetShadowRoot.addEventListener('contextmenu', onTriggerClose, true);
            }
            return ()=>{
                win.removeEventListener('pointerdown', onPointerDown, true);
                win.removeEventListener('mousedown', onTriggerClose, true);
                win.removeEventListener('contextmenu', onTriggerClose, true);
                if (targetShadowRoot) {
                    targetShadowRoot.removeEventListener('mousedown', onTriggerClose, true);
                    targetShadowRoot.removeEventListener('contextmenu', onTriggerClose, true);
                }
            };
        }
    }, [
        clickToHide,
        targetEle,
        popupEle,
        mask,
        maskClosable
    ]);
    function onPopupPointerDown() {
        popupPointerDownRef.current = true;
    }
    return onPopupPointerDown;
}

},{"@rc-component/util/es/Dom/shadow":"17j4f","@rc-component/util/es/warning":"hJXDS","react":"bmhQu","../util":"6rWry","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2BHnY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _portal = require("@rc-component/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _useDelay = require("../hooks/useDelay");
var _useDelayDefault = parcelHelpers.interopDefault(_useDelay);
var _useAlign = require("../hooks/useAlign");
var _useAlignDefault = parcelHelpers.interopDefault(_useAlign);
var _popup = require("../Popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
var _util = require("@rc-component/util");
var _useTargetState = require("./useTargetState");
var _useTargetStateDefault = parcelHelpers.interopDefault(_useTargetState);
var _findDOMNode = require("@rc-component/util/es/Dom/findDOMNode");
var _uniqueContainer = require("./UniqueContainer");
var _uniqueContainerDefault = parcelHelpers.interopDefault(_uniqueContainer);
var _clsx = require("clsx");
var _util1 = require("../util");
const UniqueProvider = ({ children, postTriggerProps })=>{
    const [trigger, open, options, onTargetVisibleChanged] = (0, _useTargetStateDefault.default)();
    // ========================== Options ===========================
    const mergedOptions = _react.useMemo(()=>{
        if (!options || !postTriggerProps) return options;
        return postTriggerProps(options);
    }, [
        options,
        postTriggerProps
    ]);
    // =========================== Popup ============================
    const [popupEle, setPopupEle] = _react.useState(null);
    const [popupSize, setPopupSize] = _react.useState(null);
    // Used for forwardRef popup. Not use internal
    const externalPopupRef = _react.useRef(null);
    const setPopupRef = (0, _util.useEvent)((node)=>{
        externalPopupRef.current = node;
        if ((0, _findDOMNode.isDOM)(node) && popupEle !== node) setPopupEle(node);
    });
    // ========================== Register ==========================
    // Store the isOpen function from the latest show call
    const isOpenRef = _react.useRef(null);
    const delayInvoke = (0, _useDelayDefault.default)();
    const show = (0, _util.useEvent)((showOptions, isOpen)=>{
        // Store the isOpen function for later use in hide
        isOpenRef.current = isOpen;
        delayInvoke(()=>{
            trigger(showOptions);
        }, showOptions.delay);
    });
    const hide = (delay)=>{
        delayInvoke(()=>{
            // Check if we should still hide by calling the isOpen function
            // If isOpen returns true, it means another trigger wants to keep it open
            if (isOpenRef.current?.()) return; // Don't hide if something else wants it open
            trigger(false);
        // Don't clear target, currentNode, options immediately, wait until animation completes
        }, delay);
    };
    // Callback after animation completes
    const onVisibleChanged = (0, _util.useEvent)((visible)=>{
        // Call useTargetState callback to handle animation state
        onTargetVisibleChanged(visible);
    });
    // =========================== Align ============================
    const [ready, offsetX, offsetY, offsetR, offsetB, arrowX, arrowY, , , // scaleY - not used in UniqueProvider
    alignInfo, onAlign] = (0, _useAlignDefault.default)(open, popupEle, mergedOptions?.target, mergedOptions?.popupPlacement, mergedOptions?.builtinPlacements || {}, mergedOptions?.popupAlign, undefined, // onPopupAlign
    false // isMobile
    );
    const alignedClassName = _react.useMemo(()=>{
        if (!mergedOptions) return '';
        const baseClassName = (0, _util1.getAlignPopupClassName)(mergedOptions.builtinPlacements || {}, mergedOptions.prefixCls || '', alignInfo, false // alignPoint is false for UniqueProvider
        );
        return (0, _clsx.clsx)(baseClassName, mergedOptions.getPopupClassNameFromAlign?.(alignInfo));
    }, [
        alignInfo,
        mergedOptions?.getPopupClassNameFromAlign,
        mergedOptions?.builtinPlacements,
        mergedOptions?.prefixCls
    ]);
    const contextValue = _react.useMemo(()=>({
            show,
            hide
        }), []);
    // =========================== Align ============================
    _react.useEffect(()=>{
        onAlign();
    }, [
        mergedOptions?.target
    ]);
    // =========================== Motion ===========================
    const onPrepare = (0, _util.useEvent)(()=>{
        onAlign();
        return Promise.resolve();
    });
    // ======================== Trigger Context =====================
    const subPopupElements = _react.useRef({});
    const parentContext = _react.useContext((0, _contextDefault.default));
    const triggerContextValue = _react.useMemo(()=>({
            registerSubPopup: (id, subPopupEle)=>{
                subPopupElements.current[id] = subPopupEle;
                parentContext?.registerSubPopup(id, subPopupEle);
            }
        }), [
        parentContext
    ]);
    // =========================== Render ===========================
    const prefixCls = mergedOptions?.prefixCls;
    return /*#__PURE__*/ _react.createElement((0, _context.UniqueContext).Provider, {
        value: contextValue
    }, children, mergedOptions && /*#__PURE__*/ _react.createElement((0, _contextDefault.default).Provider, {
        value: triggerContextValue
    }, /*#__PURE__*/ _react.createElement((0, _popupDefault.default), {
        ref: setPopupRef,
        portal: (0, _portalDefault.default),
        prefixCls: prefixCls,
        popup: mergedOptions.popup,
        className: (0, _clsx.clsx)(mergedOptions.popupClassName, alignedClassName, `${prefixCls}-unique-controlled`),
        style: mergedOptions.popupStyle,
        target: mergedOptions.target,
        open: open,
        keepDom: true,
        fresh: true,
        autoDestroy: false,
        onVisibleChanged: onVisibleChanged,
        ready: ready,
        offsetX: offsetX,
        offsetY: offsetY,
        offsetR: offsetR,
        offsetB: offsetB,
        onAlign: onAlign,
        onPrepare: onPrepare,
        onResize: (size)=>setPopupSize({
                width: size.offsetWidth,
                height: size.offsetHeight
            }),
        arrowPos: {
            x: arrowX,
            y: arrowY
        },
        align: alignInfo,
        zIndex: mergedOptions.zIndex,
        mask: mergedOptions.mask,
        arrow: mergedOptions.arrow,
        motion: mergedOptions.popupMotion,
        maskMotion: mergedOptions.maskMotion,
        getPopupContainer: mergedOptions.getPopupContainer
    }, /*#__PURE__*/ _react.createElement((0, _uniqueContainerDefault.default), {
        prefixCls: prefixCls,
        isMobile: false,
        ready: ready,
        open: open,
        align: alignInfo,
        offsetR: offsetR,
        offsetB: offsetB,
        offsetX: offsetX,
        offsetY: offsetY,
        arrowPos: {
            x: arrowX,
            y: arrowY
        },
        popupSize: popupSize,
        motion: mergedOptions.popupMotion,
        uniqueContainerClassName: (0, _clsx.clsx)(mergedOptions.uniqueContainerClassName, alignedClassName),
        uniqueContainerStyle: mergedOptions.uniqueContainerStyle
    }))));
};
exports.default = UniqueProvider;

},{"react":"bmhQu","@rc-component/portal":"fYVZK","../context":"adq9u","../hooks/useDelay":"6mBMF","../hooks/useAlign":"9Kopn","../Popup":"lnvZw","@rc-component/util":"6ZBDN","./useTargetState":"9h3zY","@rc-component/util/es/Dom/findDOMNode":"5IZto","./UniqueContainer":"3qJnU","clsx":"431Ou","../util":"6rWry","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9h3zY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTargetState);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _util = require("@rc-component/util");
function useTargetState() {
    const [options, setOptions] = (0, _reactDefault.default).useState(null);
    const [open, setOpen] = (0, _reactDefault.default).useState(false);
    const [isAnimating, setIsAnimating] = (0, _reactDefault.default).useState(false);
    const pendingOptionsRef = (0, _reactDefault.default).useRef(null);
    const trigger = (0, _util.useEvent)((nextOptions)=>{
        if (nextOptions === false) {
            // Clear pending options when hiding
            pendingOptionsRef.current = null;
            setOpen(false);
        } else if (isAnimating && open) // If animating (appear or enter), cache new options
        pendingOptionsRef.current = nextOptions;
        else {
            setOpen(true);
            // Set new options
            setOptions(nextOptions);
            pendingOptionsRef.current = null;
            // Only mark as animating when transitioning from closed to open
            if (!open) setIsAnimating(true);
        }
    });
    const onVisibleChanged = (0, _util.useEvent)((visible)=>{
        if (visible) {
            // Animation enter completed, check if there are pending options
            setIsAnimating(false);
            if (pendingOptionsRef.current) {
                // Apply pending options
                setOptions(pendingOptionsRef.current);
                pendingOptionsRef.current = null;
            }
        } else {
            // Animation leave completed
            setIsAnimating(false);
            pendingOptionsRef.current = null;
        }
    });
    return [
        trigger,
        open,
        options,
        onVisibleChanged
    ];
}

},{"react":"bmhQu","@rc-component/util":"6ZBDN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3qJnU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useOffsetStyle = require("../hooks/useOffsetStyle");
var _useOffsetStyleDefault = parcelHelpers.interopDefault(_useOffsetStyle);
var _clsx = require("clsx");
var _motion = require("@rc-component/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const UniqueContainer = (props)=>{
    const { prefixCls, isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY, arrowPos, popupSize, motion, uniqueContainerClassName, uniqueContainerStyle } = props;
    const containerCls = `${prefixCls}-unique-container`;
    const [motionVisible, setMotionVisible] = (0, _reactDefault.default).useState(false);
    // ========================= Styles =========================
    const offsetStyle = (0, _useOffsetStyleDefault.default)(isMobile, ready, open, align, offsetR, offsetB, offsetX, offsetY);
    // Cache for offsetStyle when ready is true
    const cachedOffsetStyleRef = (0, _reactDefault.default).useRef(offsetStyle);
    // Update cached offset style when ready is true
    if (ready) cachedOffsetStyleRef.current = offsetStyle;
    // Apply popup size if available
    const sizeStyle = {};
    if (popupSize) {
        sizeStyle.width = popupSize.width;
        sizeStyle.height = popupSize.height;
    }
    // ========================= Render =========================
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _motionDefault.default), _extends({
        motionAppear: true,
        motionEnter: true,
        motionLeave: true,
        removeOnLeave: false,
        leavedClassName: `${containerCls}-hidden`
    }, motion, {
        visible: open,
        onVisibleChanged: (nextVisible)=>{
            setMotionVisible(nextVisible);
        }
    }), ({ className: motionClassName, style: motionStyle })=>{
        const cls = (0, _clsx.clsx)(containerCls, motionClassName, uniqueContainerClassName, {
            [`${containerCls}-visible`]: motionVisible
        });
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            className: cls,
            style: {
                '--arrow-x': `${arrowPos?.x || 0}px`,
                '--arrow-y': `${arrowPos?.y || 0}px`,
                ...cachedOffsetStyleRef.current,
                ...sizeStyle,
                ...motionStyle,
                ...uniqueContainerStyle
            }
        });
    });
};
exports.default = UniqueContainer;

},{"react":"bmhQu","../hooks/useOffsetStyle":"6biMe","clsx":"431Ou","@rc-component/motion":"gBwXg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1C4cy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "placements", ()=>placements);
const autoAdjustOverflowTopBottom = {
    shiftX: 64,
    adjustY: 1
};
const autoAdjustOverflowLeftRight = {
    adjustX: 1,
    shiftY: true
};
const targetOffset = [
    0,
    0
];
const placements = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        overflow: autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        overflow: autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: autoAdjustOverflowTopBottom,
        offset: [
            0,
            -4
        ],
        targetOffset
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: autoAdjustOverflowLeftRight,
        offset: [
            4,
            0
        ],
        targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: autoAdjustOverflowTopBottom,
        offset: [
            0,
            4
        ],
        targetOffset
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: autoAdjustOverflowLeftRight,
        offset: [
            -4,
            0
        ],
        targetOffset
    }
};
exports.default = placements;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5aVQ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("../form/context");
var _compact = require("../space/Compact");
var _isNonNullable = require("./isNonNullable");
var _isNonNullableDefault = parcelHelpers.interopDefault(_isNonNullable);
"use client";
const ContextIsolator = (props)=>{
    const { space, form, children } = props;
    if (!(0, _isNonNullableDefault.default)(children)) return null;
    let result = children;
    if (form) result = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.NoFormStyle), {
        override: true,
        status: true
    }, result);
    if (space) result = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compact.NoCompactStyle), null, result);
    return result;
};
exports.default = ContextIsolator;

},{"react":"bmhQu","../form/context":"krZYn","../space/Compact":"cOSpV","./isNonNullable":"avlqw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"krZYn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormContext", ()=>FormContext);
parcelHelpers.export(exports, "NoStyleItemContext", ()=>NoStyleItemContext);
parcelHelpers.export(exports, "FormProvider", ()=>FormProvider);
parcelHelpers.export(exports, "FormItemPrefixContext", ()=>FormItemPrefixContext);
parcelHelpers.export(exports, "FormItemInputContext", ()=>FormItemInputContext);
parcelHelpers.export(exports, "NoFormStyle", ()=>NoFormStyle);
parcelHelpers.export(exports, "VariantContext", ()=>VariantContext);
var _react = require("react");
var _form = require("@rc-component/form");
var _util = require("@rc-component/util");
"use client";
const FormContext = /*#__PURE__*/ _react.createContext({
    labelAlign: 'right',
    layout: 'horizontal',
    itemRef: ()=>{}
});
const NoStyleItemContext = /*#__PURE__*/ _react.createContext(null);
const FormProvider = (props)=>{
    const providerProps = (0, _util.omit)(props, [
        'prefixCls'
    ]);
    return /*#__PURE__*/ _react.createElement((0, _form.FormProvider), {
        ...providerProps
    });
};
const FormItemPrefixContext = /*#__PURE__*/ _react.createContext({
    prefixCls: ''
});
const FormItemInputContext = /*#__PURE__*/ _react.createContext({});
const NoFormStyle = ({ children, status, override })=>{
    const formItemInputContext = _react.useContext(FormItemInputContext);
    const newFormItemInputContext = _react.useMemo(()=>{
        const newContext = {
            ...formItemInputContext
        };
        if (override) delete newContext.isFormItemInput;
        if (status) {
            delete newContext.status;
            delete newContext.hasFeedback;
            delete newContext.feedbackIcon;
        }
        return newContext;
    }, [
        status,
        override,
        formItemInputContext
    ]);
    return /*#__PURE__*/ _react.createElement(FormItemInputContext.Provider, {
        value: newFormItemInputContext
    }, children);
};
const VariantContext = /*#__PURE__*/ _react.createContext(undefined);

},{"react":"bmhQu","@rc-component/form":"jnip8","@rc-component/util":"6ZBDN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jnip8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Field", ()=>(0, _fieldDefault.default));
parcelHelpers.export(exports, "List", ()=>(0, _listDefault.default));
parcelHelpers.export(exports, "useForm", ()=>(0, _useFormDefault.default));
parcelHelpers.export(exports, "FormProvider", ()=>(0, _formContext.FormProvider));
parcelHelpers.export(exports, "FieldContext", ()=>(0, _fieldContextDefault.default));
parcelHelpers.export(exports, "ListContext", ()=>(0, _listContextDefault.default));
parcelHelpers.export(exports, "useWatch", ()=>(0, _useWatchDefault.default));
var _react = require("react");
var _field = require("./Field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _list = require("./List");
var _listDefault = parcelHelpers.interopDefault(_list);
var _useForm = require("./hooks/useForm");
var _useFormDefault = parcelHelpers.interopDefault(_useForm);
var _form = require("./Form");
var _formDefault = parcelHelpers.interopDefault(_form);
var _formContext = require("./FormContext");
var _fieldContext = require("./FieldContext");
var _fieldContextDefault = parcelHelpers.interopDefault(_fieldContext);
var _listContext = require("./ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _useWatch = require("./hooks/useWatch");
var _useWatchDefault = parcelHelpers.interopDefault(_useWatch);
const InternalForm = /*#__PURE__*/ _react.forwardRef((0, _formDefault.default));
const RefForm = InternalForm;
RefForm.FormProvider = (0, _formContext.FormProvider);
RefForm.Field = (0, _fieldDefault.default);
RefForm.List = (0, _listDefault.default);
RefForm.useForm = (0, _useFormDefault.default);
RefForm.useWatch = (0, _useWatchDefault.default);
exports.default = RefForm;

},{"react":"bmhQu","./Field":"fam7b","./List":"86ZmC","./hooks/useForm":"lwy6I","./Form":"2vlO2","./FormContext":"kZuvQ","./FieldContext":"k8mze","./ListContext":"9Y7SO","./hooks/useWatch":"5TkwY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fam7b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toArray = require("@rc-component/util/es/Children/toArray");
var _toArrayDefault = parcelHelpers.interopDefault(_toArray);
var _isEqual = require("@rc-component/util/es/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _react = require("react");
var _fieldContext = require("./FieldContext");
var _fieldContextDefault = parcelHelpers.interopDefault(_fieldContext);
var _listContext = require("./ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
var _typeUtil = require("./utils/typeUtil");
var _validateUtil = require("./utils/validateUtil");
var _valueUtil = require("./utils/valueUtil");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const EMPTY_ERRORS = [];
const EMPTY_WARNINGS = [];
function requireUpdate(shouldUpdate, prev, next, prevValue, nextValue, info) {
    if (typeof shouldUpdate === 'function') return shouldUpdate(prev, next, 'source' in info ? {
        source: info.source
    } : {});
    return prevValue !== nextValue;
}
// eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
// We use Class instead of Hooks here since it will cost much code by using Hooks.
class Field extends _react.Component {
    static contextType = (0, _fieldContextDefault.default);
    state = {
        resetCount: 0
    };
    cancelRegisterFunc = null;
    mounted = false;
    /**
   * Follow state should not management in State since it will async update by React.
   * This makes first render of form can not get correct state value.
   */ touched = false;
    /**
   * Mark when touched & validated. Currently only used for `dependencies`.
   * Note that we do not think field with `initialValue` is dirty
   * but this will be by `isFieldDirty` func.
   */ dirty = false;
    validatePromise;
    prevValidating;
    errors = EMPTY_ERRORS;
    warnings = EMPTY_WARNINGS;
    // ============================== Subscriptions ==============================
    constructor(props){
        super(props);
        // Register on init
        if (props.fieldContext) {
            const { getInternalHooks } = props.fieldContext;
            const { initEntityValue } = getInternalHooks((0, _fieldContext.HOOK_MARK));
            initEntityValue(this);
        }
    }
    componentDidMount() {
        const { shouldUpdate, fieldContext } = this.props;
        this.mounted = true;
        // Register on init
        if (fieldContext) {
            const { getInternalHooks } = fieldContext;
            const { registerField } = getInternalHooks((0, _fieldContext.HOOK_MARK));
            this.cancelRegisterFunc = registerField(this);
        }
        // One more render for component in case fields not ready
        if (shouldUpdate === true) this.reRender();
    }
    componentWillUnmount() {
        this.cancelRegister();
        this.triggerMetaEvent(true);
        this.mounted = false;
    }
    cancelRegister = ()=>{
        const { preserve, isListField, name } = this.props;
        if (this.cancelRegisterFunc) this.cancelRegisterFunc(isListField, preserve, (0, _valueUtil.getNamePath)(name));
        this.cancelRegisterFunc = null;
    };
    // ================================== Utils ==================================
    getNamePath = ()=>{
        const { name, fieldContext } = this.props;
        const { prefixName = [] } = fieldContext;
        return name !== undefined ? [
            ...prefixName,
            ...name
        ] : [];
    };
    getRules = ()=>{
        const { rules = [], fieldContext } = this.props;
        return rules.map((rule)=>{
            if (typeof rule === 'function') return rule(fieldContext);
            return rule;
        });
    };
    reRender() {
        if (!this.mounted) return;
        this.forceUpdate();
    }
    refresh = ()=>{
        if (!this.mounted) return;
        /**
     * Clean up current node.
     */ this.setState(({ resetCount })=>({
                resetCount: resetCount + 1
            }));
    };
    // Event should only trigger when meta changed
    metaCache = null;
    triggerMetaEvent = (destroy)=>{
        const { onMetaChange } = this.props;
        if (onMetaChange) {
            const meta = {
                ...this.getMeta(),
                destroy
            };
            if (!(0, _isEqualDefault.default)(this.metaCache, meta)) onMetaChange(meta);
            this.metaCache = meta;
        } else this.metaCache = null;
    };
    // ========================= Field Entity Interfaces =========================
    // Trigger by store update. Check if need update the component
    onStoreChange = (prevStore, namePathList, info)=>{
        const { shouldUpdate, dependencies = [], onReset } = this.props;
        const { store } = info;
        const namePath = this.getNamePath();
        const prevValue = this.getValue(prevStore);
        const curValue = this.getValue(store);
        const namePathMatch = namePathList && (0, _valueUtil.containsNamePath)(namePathList, namePath);
        // `setFieldsValue` is a quick access to update related status
        if (info.type === 'valueUpdate' && info.source === 'external' && !(0, _isEqualDefault.default)(prevValue, curValue)) {
            this.touched = true;
            this.dirty = true;
            this.validatePromise = null;
            this.errors = EMPTY_ERRORS;
            this.warnings = EMPTY_WARNINGS;
            this.triggerMetaEvent();
        }
        switch(info.type){
            case 'reset':
                if (!namePathList || namePathMatch) {
                    // Clean up state
                    this.touched = false;
                    this.dirty = false;
                    this.validatePromise = undefined;
                    this.errors = EMPTY_ERRORS;
                    this.warnings = EMPTY_WARNINGS;
                    this.triggerMetaEvent();
                    onReset?.();
                    this.refresh();
                    return;
                }
                break;
            /**
       * In case field with `preserve = false` nest deps like:
       * - A = 1 => show B
       * - B = 1 => show C
       * - Reset A, need clean B, C
       */ case 'remove':
                if (shouldUpdate && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                    this.reRender();
                    return;
                }
                break;
            case 'setField':
                {
                    const { data } = info;
                    if (namePathMatch) {
                        if ('touched' in data) this.touched = data.touched;
                        if ('validating' in data && !('originRCField' in data)) this.validatePromise = data.validating ? Promise.resolve([]) : null;
                        if ('errors' in data) this.errors = data.errors || EMPTY_ERRORS;
                        if ('warnings' in data) this.warnings = data.warnings || EMPTY_WARNINGS;
                        this.dirty = true;
                        this.triggerMetaEvent();
                        this.reRender();
                        return;
                    } else if ('value' in data && (0, _valueUtil.containsNamePath)(namePathList, namePath, true)) {
                        // Contains path with value should also check
                        this.reRender();
                        return;
                    }
                    // Handle update by `setField` with `shouldUpdate`
                    if (shouldUpdate && !namePath.length && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                        this.reRender();
                        return;
                    }
                    break;
                }
            case 'dependenciesUpdate':
                {
                    /**
           * Trigger when marked `dependencies` updated. Related fields will all update
           */ const dependencyList = dependencies.map((0, _valueUtil.getNamePath));
                    // No need for `namePathMath` check and `shouldUpdate` check, since `valueUpdate` will be
                    // emitted earlier and they will work there
                    // If set it may cause unnecessary twice rerendering
                    if (dependencyList.some((dependency)=>(0, _valueUtil.containsNamePath)(info.relatedFields, dependency))) {
                        this.reRender();
                        return;
                    }
                    break;
                }
            default:
                // 1. If `namePath` exists in `namePathList`, means it's related value and should update
                //      For example <List name="list"><Field name={['list', 0]}></List>
                //      If `namePathList` is [['list']] (List value update), Field should be updated
                //      If `namePathList` is [['list', 0]] (Field value update), List shouldn't be updated
                // 2.
                //   2.1 If `dependencies` is set, `name` is not set and `shouldUpdate` is not set,
                //       don't use `shouldUpdate`. `dependencies` is view as a shortcut if `shouldUpdate`
                //       is not provided
                //   2.2 If `shouldUpdate` provided, use customize logic to update the field
                //       else to check if value changed
                if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
                    this.reRender();
                    return;
                }
                break;
        }
        if (shouldUpdate === true) this.reRender();
    };
    validateRules = (options)=>{
        // We should fixed namePath & value to avoid developer change then by form function
        const namePath = this.getNamePath();
        const currentValue = this.getValue();
        const { triggerName, validateOnly = false } = options || {};
        // Force change to async to avoid rule OOD under renderProps field
        const rootPromise = Promise.resolve().then(async ()=>{
            if (!this.mounted) return [];
            const { validateFirst = false, messageVariables, validateDebounce } = this.props;
            // Start validate
            let filteredRules = this.getRules();
            if (triggerName) filteredRules = filteredRules.filter((rule)=>rule).filter((rule)=>{
                const { validateTrigger } = rule;
                if (!validateTrigger) return true;
                const triggerList = (0, _typeUtil.toArray)(validateTrigger);
                return triggerList.includes(triggerName);
            });
            // Wait for debounce. Skip if no `triggerName` since its from `validateFields / submit`
            if (validateDebounce && triggerName) {
                await new Promise((resolve)=>{
                    setTimeout(resolve, validateDebounce);
                });
                // Skip since out of date
                if (this.validatePromise !== rootPromise) return [];
            }
            const promise = (0, _validateUtil.validateRules)(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
            promise.catch((e)=>e).then((ruleErrors = EMPTY_ERRORS)=>{
                if (this.validatePromise === rootPromise) {
                    this.validatePromise = null;
                    // Get errors & warnings
                    const nextErrors = [];
                    const nextWarnings = [];
                    ruleErrors.forEach?.(({ rule: { warningOnly }, errors = EMPTY_ERRORS })=>{
                        if (warningOnly) nextWarnings.push(...errors);
                        else nextErrors.push(...errors);
                    });
                    this.errors = nextErrors;
                    this.warnings = nextWarnings;
                    this.triggerMetaEvent();
                    this.reRender();
                }
            });
            return promise;
        });
        if (validateOnly) return rootPromise;
        this.validatePromise = rootPromise;
        this.dirty = true;
        this.errors = EMPTY_ERRORS;
        this.warnings = EMPTY_WARNINGS;
        this.triggerMetaEvent();
        // Force trigger re-render since we need sync renderProps with new meta
        this.reRender();
        return rootPromise;
    };
    isFieldValidating = ()=>!!this.validatePromise;
    isFieldTouched = ()=>this.touched;
    isFieldDirty = ()=>{
        // Touched or validate or has initialValue
        if (this.dirty || this.props.initialValue !== undefined) return true;
        // Form set initialValue
        const { fieldContext } = this.props;
        const { getInitialValue } = fieldContext.getInternalHooks((0, _fieldContext.HOOK_MARK));
        if (getInitialValue(this.getNamePath()) !== undefined) return true;
        return false;
    };
    getErrors = ()=>this.errors;
    getWarnings = ()=>this.warnings;
    isListField = ()=>this.props.isListField;
    isList = ()=>this.props.isList;
    isPreserve = ()=>this.props.preserve;
    // ============================= Child Component =============================
    getMeta = ()=>{
        // Make error & validating in cache to save perf
        this.prevValidating = this.isFieldValidating();
        const meta = {
            touched: this.isFieldTouched(),
            validating: this.prevValidating,
            errors: this.errors,
            warnings: this.warnings,
            name: this.getNamePath(),
            validated: this.validatePromise === null
        };
        return meta;
    };
    // Only return validate child node. If invalidate, will do nothing about field.
    getOnlyChild = (children)=>{
        // Support render props
        if (typeof children === 'function') {
            const meta = this.getMeta();
            return {
                ...this.getOnlyChild(children(this.getControlled(), meta, this.props.fieldContext)),
                isFunction: true
            };
        }
        // Filed element only
        const childList = (0, _toArrayDefault.default)(children);
        if (childList.length !== 1 || !/*#__PURE__*/ _react.isValidElement(childList[0])) return {
            child: childList,
            isFunction: false
        };
        return {
            child: childList[0],
            isFunction: false
        };
    };
    // ============================== Field Control ==============================
    getValue = (store)=>{
        const { getFieldsValue } = this.props.fieldContext;
        const namePath = this.getNamePath();
        return (0, _valueUtil.getValue)(store || getFieldsValue(true), namePath);
    };
    getControlled = (childProps = {})=>{
        const { name, trigger = 'onChange', validateTrigger, getValueFromEvent, normalize, valuePropName = 'value', getValueProps, fieldContext } = this.props;
        const mergedValidateTrigger = validateTrigger !== undefined ? validateTrigger : fieldContext.validateTrigger;
        const namePath = this.getNamePath();
        const { getInternalHooks, getFieldsValue } = fieldContext;
        const { dispatch } = getInternalHooks((0, _fieldContext.HOOK_MARK));
        const value = this.getValue();
        const mergedGetValueProps = getValueProps || ((val)=>({
                [valuePropName]: val
            }));
        const originTriggerFunc = childProps[trigger];
        const valueProps = name !== undefined ? mergedGetValueProps(value) : {};
        var key;
        const control = {
            ...childProps,
            ...valueProps
        };
        // Add trigger
        control[trigger] = (...args)=>{
            // Mark as touched
            this.touched = true;
            this.dirty = true;
            this.triggerMetaEvent();
            let newValue;
            if (getValueFromEvent) newValue = getValueFromEvent(...args);
            else newValue = (0, _valueUtil.defaultGetValueFromEvent)(valuePropName, ...args);
            if (normalize) newValue = normalize(newValue, value, getFieldsValue(true));
            if (newValue !== value) dispatch({
                type: 'updateValue',
                namePath,
                value: newValue
            });
            if (originTriggerFunc) originTriggerFunc(...args);
        };
        // Add validateTrigger
        const validateTriggerList = (0, _typeUtil.toArray)(mergedValidateTrigger || []);
        validateTriggerList.forEach((triggerName)=>{
            // Wrap additional function of component, so that we can get latest value from store
            const originTrigger = control[triggerName];
            control[triggerName] = (...args)=>{
                if (originTrigger) originTrigger(...args);
                // Always use latest rules
                const { rules } = this.props;
                if (rules && rules.length) // We dispatch validate to root,
                // since it will update related data with other field with same name
                dispatch({
                    type: 'validateField',
                    namePath,
                    triggerName
                });
            };
        });
        return control;
    };
    render() {
        const { resetCount } = this.state;
        const { children } = this.props;
        const { child, isFunction } = this.getOnlyChild(children);
        // Not need to `cloneElement` since user can handle this in render function self
        let returnChildNode;
        if (isFunction) returnChildNode = child;
        else if (/*#__PURE__*/ _react.isValidElement(child)) returnChildNode = /*#__PURE__*/ _react.cloneElement(child, this.getControlled(child.props));
        else {
            (0, _warningDefault.default)(!child, '`children` of Field is not validate ReactElement.');
            returnChildNode = child;
        }
        return /*#__PURE__*/ _react.createElement(_react.Fragment, {
            key: resetCount
        }, returnChildNode);
    }
}
function WrapperField({ name, ...restProps }) {
    const fieldContext = _react.useContext((0, _fieldContextDefault.default));
    const listContext = _react.useContext((0, _listContextDefault.default));
    const namePath = name !== undefined ? (0, _valueUtil.getNamePath)(name) : undefined;
    const isMergedListField = restProps.isListField ?? !!listContext;
    let key = 'keep';
    if (!isMergedListField) key = `_${(namePath || []).join('_')}`;
    return /*#__PURE__*/ _react.createElement(Field, _extends({
        key: key,
        name: namePath,
        isListField: isMergedListField
    }, restProps, {
        fieldContext: fieldContext
    }));
}
exports.default = WrapperField;

},{"@rc-component/util/es/Children/toArray":"7sTeM","@rc-component/util/es/isEqual":"fBa27","@rc-component/util/es/warning":"hJXDS","react":"bmhQu","./FieldContext":"k8mze","./ListContext":"9Y7SO","./utils/typeUtil":"jWjE0","./utils/validateUtil":"ark33","./utils/valueUtil":"hcjiP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k8mze":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HOOK_MARK", ()=>HOOK_MARK);
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _react = require("react");
const HOOK_MARK = 'RC_FORM_INTERNAL_HOOKS';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const warningFunc = ()=>{
    (0, _warningDefault.default)(false, 'Can not find FormContext. Please make sure you wrap Field under Form.');
};
const Context = /*#__PURE__*/ _react.createContext({
    getFieldValue: warningFunc,
    getFieldsValue: warningFunc,
    getFieldError: warningFunc,
    getFieldWarning: warningFunc,
    getFieldsError: warningFunc,
    isFieldsTouched: warningFunc,
    isFieldTouched: warningFunc,
    isFieldValidating: warningFunc,
    isFieldsValidating: warningFunc,
    resetFields: warningFunc,
    setFields: warningFunc,
    setFieldValue: warningFunc,
    setFieldsValue: warningFunc,
    validateFields: warningFunc,
    submit: warningFunc,
    getInternalHooks: ()=>{
        warningFunc();
        return {
            dispatch: warningFunc,
            initEntityValue: warningFunc,
            registerField: warningFunc,
            useSubscribe: warningFunc,
            setInitialValues: warningFunc,
            destroyForm: warningFunc,
            setCallbacks: warningFunc,
            registerWatch: warningFunc,
            getFields: warningFunc,
            setValidateMessages: warningFunc,
            setPreserve: warningFunc,
            getInitialValue: warningFunc
        };
    }
});
exports.default = Context;

},{"@rc-component/util/es/warning":"hJXDS","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Y7SO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const ListContext = /*#__PURE__*/ _react.createContext(null);
exports.default = ListContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jWjE0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toArray", ()=>toArray);
parcelHelpers.export(exports, "isFormInstance", ()=>isFormInstance);
function toArray(value) {
    if (value === undefined || value === null) return [];
    return Array.isArray(value) ? value : [
        value
    ];
}
function isFormInstance(form) {
    return form && !!form._init;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ark33":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * We use `async-validator` to validate the value.
 * But only check one value in a time to avoid namePath validate issue.
 */ parcelHelpers.export(exports, "validateRules", ()=>validateRules);
var _asyncValidator = require("@rc-component/async-validator");
var _asyncValidatorDefault = parcelHelpers.interopDefault(_asyncValidator);
var _react = require("react");
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _messages = require("./messages");
var _set = require("@rc-component/util/es/utils/set");
// Remove incorrect original ts define
const AsyncValidator = (0, _asyncValidatorDefault.default);
/**
 * Replace with template.
 *   `I'm ${name}` + { name: 'bamboo' } = I'm bamboo
 */ function replaceMessage(template, kv) {
    return template.replace(/\\?\$\{\w+\}/g, (str)=>{
        if (str.startsWith('\\')) return str.slice(1);
        const key = str.slice(2, -1);
        return kv[key];
    });
}
const CODE_LOGIC_ERROR = 'CODE_LOGIC_ERROR';
async function validateRule(name, value, rule, options, messageVariables) {
    const cloneRule = {
        ...rule
    };
    // Bug of `async-validator`
    // https://github.com/react-component/field-form/issues/316
    // https://github.com/react-component/field-form/issues/313
    delete cloneRule.ruleIndex;
    // https://github.com/ant-design/ant-design/issues/40497#issuecomment-1422282378
    AsyncValidator.warning = ()=>void 0;
    if (cloneRule.validator) {
        const originValidator = cloneRule.validator;
        cloneRule.validator = (...args)=>{
            try {
                return originValidator(...args);
            } catch (error) {
                console.error(error);
                return Promise.reject(CODE_LOGIC_ERROR);
            }
        };
    }
    // We should special handle array validate
    let subRuleField = null;
    if (cloneRule && cloneRule.type === 'array' && cloneRule.defaultField) {
        subRuleField = cloneRule.defaultField;
        delete cloneRule.defaultField;
    }
    const validator = new AsyncValidator({
        [name]: [
            cloneRule
        ]
    });
    const messages = (0, _set.merge)((0, _messages.defaultValidateMessages), options.validateMessages);
    validator.messages(messages);
    let result = [];
    try {
        await Promise.resolve(validator.validate({
            [name]: value
        }, {
            ...options
        }));
    } catch (errObj) {
        if (errObj.errors) result = errObj.errors.map(({ message }, index)=>{
            const mergedMessage = message === CODE_LOGIC_ERROR ? messages.default : message;
            return /*#__PURE__*/ _react.isValidElement(mergedMessage) ? /*#__PURE__*/ // Wrap ReactNode with `key`
            _react.cloneElement(mergedMessage, {
                key: `error_${index}`
            }) : mergedMessage;
        });
    }
    if (!result.length && subRuleField && Array.isArray(value) && value.length > 0) {
        const subResults = await Promise.all(value.map((subValue, i)=>validateRule(`${name}.${i}`, subValue, subRuleField, options, messageVariables)));
        return subResults.reduce((prev, errors)=>[
                ...prev,
                ...errors
            ], []);
    }
    // Replace message with variables
    const kv = {
        ...rule,
        name,
        enum: (rule.enum || []).join(', '),
        ...messageVariables
    };
    const fillVariableResult = result.map((error)=>{
        if (typeof error === 'string') return replaceMessage(error, kv);
        return error;
    });
    return fillVariableResult;
}
function validateRules(namePath, value, rules, options, validateFirst, messageVariables) {
    const name = namePath.join('.');
    // Fill rule with context
    const filledRules = rules.map((currentRule, ruleIndex)=>{
        const originValidatorFunc = currentRule.validator;
        const cloneRule = {
            ...currentRule,
            ruleIndex
        };
        // Replace validator if needed
        if (originValidatorFunc) cloneRule.validator = (rule, val, callback)=>{
            let hasPromise = false;
            // Wrap callback only accept when promise not provided
            const wrappedCallback = (...args)=>{
                // Wait a tick to make sure return type is a promise
                Promise.resolve().then(()=>{
                    (0, _warningDefault.default)(!hasPromise, 'Your validator function has already return a promise. `callback` will be ignored.');
                    if (!hasPromise) callback(...args);
                });
            };
            // Get promise
            const promise = originValidatorFunc(rule, val, wrappedCallback);
            hasPromise = promise && typeof promise.then === 'function' && typeof promise.catch === 'function';
            /**
         * 1. Use promise as the first priority.
         * 2. If promise not exist, use callback with warning instead
         */ (0, _warningDefault.default)(hasPromise, '`callback` is deprecated. Please return a promise instead.');
            if (hasPromise) promise.then(()=>{
                callback();
            }).catch((err)=>{
                callback(err || ' ');
            });
        };
        return cloneRule;
    }).sort(({ warningOnly: w1, ruleIndex: i1 }, { warningOnly: w2, ruleIndex: i2 })=>{
        if (!!w1 === !!w2) // Let keep origin order
        return i1 - i2;
        if (w1) return 1;
        return -1;
    });
    // Do validate rules
    let summaryPromise;
    if (validateFirst === true) // >>>>> Validate by serialization
    summaryPromise = new Promise(async (resolve, reject)=>{
        /* eslint-disable no-await-in-loop */ for(let i = 0; i < filledRules.length; i += 1){
            const rule = filledRules[i];
            const errors = await validateRule(name, value, rule, options, messageVariables);
            if (errors.length) {
                reject([
                    {
                        errors,
                        rule
                    }
                ]);
                return;
            }
        }
        /* eslint-enable */ resolve([]);
    });
    else {
        // >>>>> Validate by parallel
        const rulePromises = filledRules.map((rule)=>validateRule(name, value, rule, options, messageVariables).then((errors)=>({
                    errors,
                    rule
                })));
        summaryPromise = (validateFirst ? finishOnFirstFailed(rulePromises) : finishOnAllFailed(rulePromises)).then((errors)=>{
            // Always change to rejection for Field to catch
            return Promise.reject(errors);
        });
    }
    // Internal catch error to avoid console error log.
    summaryPromise.catch((e)=>e);
    return summaryPromise;
}
async function finishOnAllFailed(rulePromises) {
    return Promise.all(rulePromises).then((errorsList)=>{
        const errors = [].concat(...errorsList);
        return errors;
    });
}
async function finishOnFirstFailed(rulePromises) {
    let count = 0;
    return new Promise((resolve)=>{
        rulePromises.forEach((promise)=>{
            promise.then((ruleError)=>{
                if (ruleError.errors.length) resolve([
                    ruleError
                ]);
                count += 1;
                if (count === rulePromises.length) resolve([]);
            });
        });
    });
}

},{"@rc-component/async-validator":"cP0O2","react":"bmhQu","@rc-component/util/es/warning":"hJXDS","./messages":"Z9jvF","@rc-component/util/es/utils/set":"hA7hn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cP0O2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _messages = require("./messages");
var _util = require("./util");
var _index = require("./validator/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _interface = require("./interface");
parcelHelpers.exportAll(_interface, exports);
/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */ var Schema = /*#__PURE__*/ function() {
    function Schema(descriptor) {
        (0, _classCallCheckDefault.default)(this, Schema);
        // ======================== Instance ========================
        (0, _definePropertyDefault.default)(this, "rules", null);
        (0, _definePropertyDefault.default)(this, "_messages", (0, _messages.messages));
        this.define(descriptor);
    }
    (0, _createClassDefault.default)(Schema, [
        {
            key: "define",
            value: function define(rules) {
                var _this = this;
                if (!rules) throw new Error('Cannot configure a schema with no rules');
                if ((0, _typeofDefault.default)(rules) !== 'object' || Array.isArray(rules)) throw new Error('Rules must be an object');
                this.rules = {};
                Object.keys(rules).forEach(function(name) {
                    var item = rules[name];
                    _this.rules[name] = Array.isArray(item) ? item : [
                        item
                    ];
                });
            }
        },
        {
            key: "messages",
            value: function messages(_messages1) {
                if (_messages1) this._messages = (0, _util.deepMerge)((0, _messages.newMessages)(), _messages1);
                return this._messages;
            }
        },
        {
            key: "validate",
            value: function validate(source_) {
                var _this2 = this;
                var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function() {};
                var source = source_;
                var options = o;
                var callback = oc;
                if (typeof options === 'function') {
                    callback = options;
                    options = {};
                }
                if (!this.rules || Object.keys(this.rules).length === 0) {
                    if (callback) callback(null, source);
                    return Promise.resolve(source);
                }
                function complete(results) {
                    var errors = [];
                    var fields = {};
                    function add(e) {
                        if (Array.isArray(e)) {
                            var _errors;
                            errors = (_errors = errors).concat.apply(_errors, (0, _toConsumableArrayDefault.default)(e));
                        } else errors.push(e);
                    }
                    for(var i = 0; i < results.length; i++)add(results[i]);
                    if (!errors.length) callback(null, source);
                    else {
                        fields = (0, _util.convertFieldsError)(errors);
                        callback(errors, fields);
                    }
                }
                if (options.messages) {
                    var messages = this.messages();
                    if (messages === (0, _messages.messages)) messages = (0, _messages.newMessages)();
                    (0, _util.deepMerge)(messages, options.messages);
                    options.messages = messages;
                } else options.messages = this.messages();
                var series = {};
                var keys = options.keys || Object.keys(this.rules);
                keys.forEach(function(z) {
                    var arr = _this2.rules[z];
                    var value = source[z];
                    arr.forEach(function(r) {
                        var rule = r;
                        if (typeof rule.transform === 'function') {
                            if (source === source_) source = (0, _objectSpread2Default.default)({}, source);
                            value = source[z] = rule.transform(value);
                            if (value !== undefined && value !== null) rule.type = rule.type || (Array.isArray(value) ? 'array' : (0, _typeofDefault.default)(value));
                        }
                        if (typeof rule === 'function') rule = {
                            validator: rule
                        };
                        else rule = (0, _objectSpread2Default.default)({}, rule);
                        // Fill validator. Skip if nothing need to validate
                        rule.validator = _this2.getValidationMethod(rule);
                        if (!rule.validator) return;
                        rule.field = z;
                        rule.fullField = rule.fullField || z;
                        rule.type = _this2.getType(rule);
                        series[z] = series[z] || [];
                        series[z].push({
                            rule: rule,
                            value: value,
                            source: source,
                            field: z
                        });
                    });
                });
                var errorFields = {};
                return (0, _util.asyncMap)(series, options, function(data, doIt) {
                    var rule = data.rule;
                    var deep = (rule.type === 'object' || rule.type === 'array') && ((0, _typeofDefault.default)(rule.fields) === 'object' || (0, _typeofDefault.default)(rule.defaultField) === 'object');
                    deep = deep && (rule.required || !rule.required && data.value);
                    rule.field = data.field;
                    function addFullField(key, schema) {
                        return (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, schema), {}, {
                            fullField: "".concat(rule.fullField, ".").concat(key),
                            fullFields: rule.fullFields ? [].concat((0, _toConsumableArrayDefault.default)(rule.fullFields), [
                                key
                            ]) : [
                                key
                            ]
                        });
                    }
                    function cb() {
                        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                        var errorList = Array.isArray(e) ? e : [
                            e
                        ];
                        if (!options.suppressWarning && errorList.length) Schema.warning('async-validator:', errorList);
                        if (errorList.length && rule.message !== undefined) errorList = [].concat(rule.message);
                        // Fill error info
                        var filledErrors = errorList.map((0, _util.complementError)(rule, source));
                        if (options.first && filledErrors.length) {
                            errorFields[rule.field] = 1;
                            return doIt(filledErrors);
                        }
                        if (!deep) doIt(filledErrors);
                        else {
                            // if rule is required but the target object
                            // does not exist fail at the rule level and don't
                            // go deeper
                            if (rule.required && !data.value) {
                                if (rule.message !== undefined) filledErrors = [].concat(rule.message).map((0, _util.complementError)(rule, source));
                                else if (options.error) filledErrors = [
                                    options.error(rule, (0, _util.format)(options.messages.required, rule.field))
                                ];
                                return doIt(filledErrors);
                            }
                            var fieldsSchema = {};
                            if (rule.defaultField) Object.keys(data.value).map(function(key) {
                                fieldsSchema[key] = rule.defaultField;
                            });
                            fieldsSchema = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, fieldsSchema), data.rule.fields);
                            var paredFieldsSchema = {};
                            Object.keys(fieldsSchema).forEach(function(field) {
                                var fieldSchema = fieldsSchema[field];
                                var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [
                                    fieldSchema
                                ];
                                paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
                            });
                            var schema = new Schema(paredFieldsSchema);
                            schema.messages(options.messages);
                            if (data.rule.options) {
                                data.rule.options.messages = options.messages;
                                data.rule.options.error = options.error;
                            }
                            schema.validate(data.value, data.rule.options || options, function(errs) {
                                var finalErrors = [];
                                if (filledErrors && filledErrors.length) finalErrors.push.apply(finalErrors, (0, _toConsumableArrayDefault.default)(filledErrors));
                                if (errs && errs.length) finalErrors.push.apply(finalErrors, (0, _toConsumableArrayDefault.default)(errs));
                                doIt(finalErrors.length ? finalErrors : null);
                            });
                        }
                    }
                    var res;
                    if (rule.asyncValidator) res = rule.asyncValidator(rule, data.value, cb, data.source, options);
                    else if (rule.validator) {
                        try {
                            res = rule.validator(rule, data.value, cb, data.source, options);
                        } catch (error) {
                            var _console$error, _console;
                            (_console$error = (_console = console).error) === null || _console$error === void 0 || _console$error.call(_console, error);
                            // rethrow to report error
                            if (!options.suppressValidatorError) setTimeout(function() {
                                throw error;
                            }, 0);
                            cb(error.message);
                        }
                        if (res === true) cb();
                        else if (res === false) cb(typeof rule.message === 'function' ? rule.message(rule.fullField || rule.field) : rule.message || "".concat(rule.fullField || rule.field, " fails"));
                        else if (res instanceof Array) cb(res);
                        else if (res instanceof Error) cb(res.message);
                    }
                    if (res && res.then) res.then(function() {
                        return cb();
                    }, function(e) {
                        return cb(e);
                    });
                }, function(results) {
                    complete(results);
                }, source);
            }
        },
        {
            key: "getType",
            value: function getType(rule) {
                if (rule.type === undefined && rule.pattern instanceof RegExp) rule.type = 'pattern';
                if (typeof rule.validator !== 'function' && rule.type && !(0, _indexDefault.default).hasOwnProperty(rule.type)) throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
                return rule.type || 'string';
            }
        },
        {
            key: "getValidationMethod",
            value: function getValidationMethod(rule) {
                if (typeof rule.validator === 'function') return rule.validator;
                var keys = Object.keys(rule);
                var messageIndex = keys.indexOf('message');
                if (messageIndex !== -1) keys.splice(messageIndex, 1);
                if (keys.length === 1 && keys[0] === 'required') return (0, _indexDefault.default).required;
                return (0, _indexDefault.default)[this.getType(rule)] || undefined;
            }
        }
    ]);
    return Schema;
}();
// ========================= Static =========================
(0, _definePropertyDefault.default)(Schema, "register", function register(type, validator) {
    if (typeof validator !== 'function') throw new Error('Cannot register a validator by type, validator is not a function');
    (0, _indexDefault.default)[type] = validator;
});
(0, _definePropertyDefault.default)(Schema, "warning", (0, _util.warning));
(0, _definePropertyDefault.default)(Schema, "messages", (0, _messages.messages));
(0, _definePropertyDefault.default)(Schema, "validators", (0, _indexDefault.default));
exports.default = Schema;

},{"@babel/runtime/helpers/esm/objectSpread2":"dn9qZ","@babel/runtime/helpers/esm/toConsumableArray":"inIie","@babel/runtime/helpers/esm/typeof":"8oq3j","@babel/runtime/helpers/esm/classCallCheck":"1eYFn","@babel/runtime/helpers/esm/createClass":"89Fc8","@babel/runtime/helpers/esm/defineProperty":"ibVzI","./messages":"dzdfi","./util":"4bqQH","./validator/index":"eETr6","./interface":"fEoBZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dn9qZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_objectSpread2);
var _definePropertyJs = require("./defineProperty.js");
var _definePropertyJsDefault = parcelHelpers.interopDefault(_definePropertyJs);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            (0, _definePropertyJsDefault.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

},{"./defineProperty.js":"ibVzI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ibVzI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_defineProperty);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperty(e, r, t) {
    return (r = (0, _toPropertyKeyJsDefault.default)(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}

},{"./toPropertyKey.js":"awXxm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"awXxm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPropertyKey);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _toPrimitiveJs = require("./toPrimitive.js");
var _toPrimitiveJsDefault = parcelHelpers.interopDefault(_toPrimitiveJs);
function toPropertyKey(t) {
    var i = (0, _toPrimitiveJsDefault.default)(t, "string");
    return "symbol" == (0, _typeofJsDefault.default)(i) ? i : i + "";
}

},{"./typeof.js":"8oq3j","./toPrimitive.js":"e5E6H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8oq3j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_typeof);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e5E6H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toPrimitive);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
function toPrimitive(t, r) {
    if ("object" != (0, _typeofJsDefault.default)(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (0, _typeofJsDefault.default)(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}

},{"./typeof.js":"8oq3j","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1eYFn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_classCallCheck);
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"89Fc8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createClass);
var _toPropertyKeyJs = require("./toPropertyKey.js");
var _toPropertyKeyJsDefault = parcelHelpers.interopDefault(_toPropertyKeyJs);
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, _toPropertyKeyJsDefault.default)(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

},{"./toPropertyKey.js":"awXxm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dzdfi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "newMessages", ()=>newMessages);
parcelHelpers.export(exports, "messages", ()=>messages);
function newMessages() {
    return {
        default: 'Validation error on field %s',
        required: '%s is required',
        enum: '%s must be one of %s',
        whitespace: '%s cannot be empty',
        date: {
            format: '%s date %s is invalid for format %s',
            parse: '%s date could not be parsed, %s is invalid ',
            invalid: '%s date %s is invalid'
        },
        types: {
            string: '%s is not a %s',
            method: '%s is not a %s (function)',
            array: '%s is not an %s',
            object: '%s is not an %s',
            number: '%s is not a %s',
            date: '%s is not a %s',
            boolean: '%s is not a %s',
            integer: '%s is not an %s',
            float: '%s is not a %s',
            regexp: '%s is not a valid %s',
            email: '%s is not a valid %s',
            url: '%s is not a valid %s',
            hex: '%s is not a valid %s'
        },
        string: {
            len: '%s must be exactly %s characters',
            min: '%s must be at least %s characters',
            max: '%s cannot be longer than %s characters',
            range: '%s must be between %s and %s characters'
        },
        number: {
            len: '%s must equal %s',
            min: '%s cannot be less than %s',
            max: '%s cannot be greater than %s',
            range: '%s must be between %s and %s'
        },
        array: {
            len: '%s must be exactly %s in length',
            min: '%s cannot be less than %s in length',
            max: '%s cannot be greater than %s in length',
            range: '%s must be between %s and %s in length'
        },
        pattern: {
            mismatch: '%s value %s does not match pattern %s'
        },
        clone: function clone() {
            var cloned = JSON.parse(JSON.stringify(this));
            cloned.clone = this.clone;
            return cloned;
        }
    };
}
var messages = newMessages();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4bqQH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warning", ()=>warning);
parcelHelpers.export(exports, "convertFieldsError", ()=>convertFieldsError);
parcelHelpers.export(exports, "format", ()=>format);
parcelHelpers.export(exports, "isEmptyValue", ()=>isEmptyValue);
parcelHelpers.export(exports, "isEmptyObject", ()=>isEmptyObject);
parcelHelpers.export(exports, "AsyncValidationError", ()=>AsyncValidationError);
parcelHelpers.export(exports, "asyncMap", ()=>asyncMap);
parcelHelpers.export(exports, "complementError", ()=>complementError);
parcelHelpers.export(exports, "deepMerge", ()=>deepMerge);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _wrapNativeSuper = require("@babel/runtime/helpers/esm/wrapNativeSuper");
var _wrapNativeSuperDefault = parcelHelpers.interopDefault(_wrapNativeSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
/* eslint no-console:0 */ var formatRegExp = /%[sdj%]/g;
var warning = function warning() {};
function convertFieldsError(errors) {
    if (!errors || !errors.length) return null;
    var fields = {};
    errors.forEach(function(error) {
        var field = error.field;
        fields[field] = fields[field] || [];
        fields[field].push(error);
    });
    return fields;
}
function format(template) {
    for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
    var i = 0;
    var len = args.length;
    if (typeof template === 'function') // eslint-disable-next-line prefer-spread
    return template.apply(null, args);
    if (typeof template === 'string') {
        var str = template.replace(formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                    break;
                default:
                    return x;
            }
        });
        return str;
    }
    return template;
}
function isNativeStringType(type) {
    return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'date' || type === 'pattern';
}
function isEmptyValue(value, type) {
    if (value === undefined || value === null) return true;
    if (type === 'array' && Array.isArray(value) && !value.length) return true;
    if (isNativeStringType(type) && typeof value === 'string' && !value) return true;
    return false;
}
function isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
}
function asyncParallelArray(arr, func, callback) {
    var results = [];
    var total = 0;
    var arrLength = arr.length;
    function count(errors) {
        results.push.apply(results, (0, _toConsumableArrayDefault.default)(errors || []));
        total++;
        if (total === arrLength) callback(results);
    }
    arr.forEach(function(a) {
        func(a, count);
    });
}
function asyncSerialArray(arr, func, callback) {
    var index = 0;
    var arrLength = arr.length;
    function next(errors) {
        if (errors && errors.length) {
            callback(errors);
            return;
        }
        var original = index;
        index = index + 1;
        if (original < arrLength) func(arr[original], next);
        else callback([]);
    }
    next([]);
}
function flattenObjArr(objArr) {
    var ret = [];
    Object.keys(objArr).forEach(function(k) {
        ret.push.apply(ret, (0, _toConsumableArrayDefault.default)(objArr[k] || []));
    });
    return ret;
}
var AsyncValidationError = /*#__PURE__*/ function(_Error) {
    (0, _inheritsDefault.default)(AsyncValidationError, _Error);
    var _super = (0, _createSuperDefault.default)(AsyncValidationError);
    function AsyncValidationError(errors, fields) {
        var _this;
        (0, _classCallCheckDefault.default)(this, AsyncValidationError);
        _this = _super.call(this, 'Async Validation Error');
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "errors", void 0);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "fields", void 0);
        _this.errors = errors;
        _this.fields = fields;
        return _this;
    }
    return (0, _createClassDefault.default)(AsyncValidationError);
}(/*#__PURE__*/ (0, _wrapNativeSuperDefault.default)(Error));
function asyncMap(objArr, option, func, callback, source) {
    if (option.first) {
        var _pending = new Promise(function(resolve, reject) {
            var next = function next(errors) {
                callback(errors);
                return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve(source);
            };
            var flattenArr = flattenObjArr(objArr);
            asyncSerialArray(flattenArr, func, next);
        });
        _pending.catch(function(e) {
            return e;
        });
        return _pending;
    }
    var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
    var objArrKeys = Object.keys(objArr);
    var objArrLength = objArrKeys.length;
    var total = 0;
    var results = [];
    var pending = new Promise(function(resolve, reject) {
        var next = function next(errors) {
            // eslint-disable-next-line prefer-spread
            results.push.apply(results, errors);
            total++;
            if (total === objArrLength) {
                callback(results);
                return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve(source);
            }
        };
        if (!objArrKeys.length) {
            callback(results);
            resolve(source);
        }
        objArrKeys.forEach(function(key) {
            var arr = objArr[key];
            if (firstFields.indexOf(key) !== -1) asyncSerialArray(arr, func, next);
            else asyncParallelArray(arr, func, next);
        });
    });
    pending.catch(function(e) {
        return e;
    });
    return pending;
}
function isErrorObj(obj) {
    return !!(obj && obj.message !== undefined);
}
function getValue(value, path) {
    var v = value;
    for(var i = 0; i < path.length; i++){
        if (v == undefined) return v;
        v = v[path[i]];
    }
    return v;
}
function complementError(rule, source) {
    return function(oe) {
        var fieldValue;
        if (rule.fullFields) fieldValue = getValue(source, rule.fullFields);
        else fieldValue = source[oe.field || rule.fullField];
        if (isErrorObj(oe)) {
            oe.field = oe.field || rule.fullField;
            oe.fieldValue = fieldValue;
            return oe;
        }
        return {
            message: typeof oe === 'function' ? oe() : oe,
            fieldValue: fieldValue,
            field: oe.field || rule.fullField
        };
    };
}
function deepMerge(target, source) {
    if (source) {
        for(var s in source)if (source.hasOwnProperty(s)) {
            var value = source[s];
            if ((0, _typeofDefault.default)(value) === 'object' && (0, _typeofDefault.default)(target[s]) === 'object') target[s] = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, target[s]), value);
            else target[s] = value;
        }
    }
    return target;
}

},{"@babel/runtime/helpers/esm/objectSpread2":"dn9qZ","@babel/runtime/helpers/esm/typeof":"8oq3j","@babel/runtime/helpers/esm/createClass":"89Fc8","@babel/runtime/helpers/esm/classCallCheck":"1eYFn","@babel/runtime/helpers/esm/assertThisInitialized":"9WIi6","@babel/runtime/helpers/esm/inherits":"9qeOz","@babel/runtime/helpers/esm/createSuper":"4Z7nH","@babel/runtime/helpers/esm/wrapNativeSuper":"grwLt","@babel/runtime/helpers/esm/defineProperty":"ibVzI","@babel/runtime/helpers/esm/toConsumableArray":"inIie","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9WIi6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_assertThisInitialized);
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9qeOz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_inherits);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, _setPrototypeOfJsDefault.default)(t, e);
}

},{"./setPrototypeOf.js":"9xLGZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9xLGZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_setPrototypeOf);
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Z7nH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_createSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _possibleConstructorReturnJs = require("./possibleConstructorReturn.js");
var _possibleConstructorReturnJsDefault = parcelHelpers.interopDefault(_possibleConstructorReturnJs);
function _createSuper(t) {
    var r = (0, _isNativeReflectConstructJsDefault.default)();
    return function() {
        var e, o = (0, _getPrototypeOfJsDefault.default)(t);
        if (r) {
            var s = (0, _getPrototypeOfJsDefault.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, _possibleConstructorReturnJsDefault.default)(this, e);
    };
}

},{"./getPrototypeOf.js":"39SJu","./isNativeReflectConstruct.js":"iMk6t","./possibleConstructorReturn.js":"h1JP8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"39SJu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_getPrototypeOf);
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iMk6t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeReflectConstruct);
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h1JP8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_possibleConstructorReturn);
var _typeofJs = require("./typeof.js");
var _typeofJsDefault = parcelHelpers.interopDefault(_typeofJs);
var _assertThisInitializedJs = require("./assertThisInitialized.js");
var _assertThisInitializedJsDefault = parcelHelpers.interopDefault(_assertThisInitializedJs);
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == (0, _typeofJsDefault.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, _assertThisInitializedJsDefault.default)(t);
}

},{"./typeof.js":"8oq3j","./assertThisInitialized.js":"9WIi6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"grwLt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_wrapNativeSuper);
var _getPrototypeOfJs = require("./getPrototypeOf.js");
var _getPrototypeOfJsDefault = parcelHelpers.interopDefault(_getPrototypeOfJs);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
var _isNativeFunctionJs = require("./isNativeFunction.js");
var _isNativeFunctionJsDefault = parcelHelpers.interopDefault(_isNativeFunctionJs);
var _constructJs = require("./construct.js");
var _constructJsDefault = parcelHelpers.interopDefault(_constructJs);
function _wrapNativeSuper(t) {
    var r = "function" == typeof Map ? new Map() : void 0;
    return _wrapNativeSuper = function _wrapNativeSuper(t) {
        if (null === t || !(0, _isNativeFunctionJsDefault.default)(t)) return t;
        if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
        if (void 0 !== r) {
            if (r.has(t)) return r.get(t);
            r.set(t, Wrapper);
        }
        function Wrapper() {
            return (0, _constructJsDefault.default)(t, arguments, (0, _getPrototypeOfJsDefault.default)(this).constructor);
        }
        return Wrapper.prototype = Object.create(t.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: !1,
                writable: !0,
                configurable: !0
            }
        }), (0, _setPrototypeOfJsDefault.default)(Wrapper, t);
    }, _wrapNativeSuper(t);
}

},{"./getPrototypeOf.js":"39SJu","./setPrototypeOf.js":"9xLGZ","./isNativeFunction.js":"lCd9d","./construct.js":"2zEXD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lCd9d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_isNativeFunction);
function _isNativeFunction(t) {
    try {
        return -1 !== Function.toString.call(t).indexOf("[native code]");
    } catch (n) {
        return "function" == typeof t;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2zEXD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_construct);
var _isNativeReflectConstructJs = require("./isNativeReflectConstruct.js");
var _isNativeReflectConstructJsDefault = parcelHelpers.interopDefault(_isNativeReflectConstructJs);
var _setPrototypeOfJs = require("./setPrototypeOf.js");
var _setPrototypeOfJsDefault = parcelHelpers.interopDefault(_setPrototypeOfJs);
function _construct(t, e, r) {
    if ((0, _isNativeReflectConstructJsDefault.default)()) return Reflect.construct.apply(null, arguments);
    var o = [
        null
    ];
    o.push.apply(o, e);
    var p = new (t.bind.apply(t, o))();
    return r && (0, _setPrototypeOfJsDefault.default)(p, r.prototype), p;
}

},{"./isNativeReflectConstruct.js":"iMk6t","./setPrototypeOf.js":"9xLGZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eETr6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _any = require("./any");
var _anyDefault = parcelHelpers.interopDefault(_any);
var _array = require("./array");
var _arrayDefault = parcelHelpers.interopDefault(_array);
var _boolean = require("./boolean");
var _booleanDefault = parcelHelpers.interopDefault(_boolean);
var _date = require("./date");
var _dateDefault = parcelHelpers.interopDefault(_date);
var _enum = require("./enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _float = require("./float");
var _floatDefault = parcelHelpers.interopDefault(_float);
var _integer = require("./integer");
var _integerDefault = parcelHelpers.interopDefault(_integer);
var _method = require("./method");
var _methodDefault = parcelHelpers.interopDefault(_method);
var _number = require("./number");
var _numberDefault = parcelHelpers.interopDefault(_number);
var _object = require("./object");
var _objectDefault = parcelHelpers.interopDefault(_object);
var _pattern = require("./pattern");
var _patternDefault = parcelHelpers.interopDefault(_pattern);
var _regexp = require("./regexp");
var _regexpDefault = parcelHelpers.interopDefault(_regexp);
var _required = require("./required");
var _requiredDefault = parcelHelpers.interopDefault(_required);
var _string = require("./string");
var _stringDefault = parcelHelpers.interopDefault(_string);
var _type = require("./type");
var _typeDefault = parcelHelpers.interopDefault(_type);
exports.default = {
    string: (0, _stringDefault.default),
    method: (0, _methodDefault.default),
    number: (0, _numberDefault.default),
    boolean: (0, _booleanDefault.default),
    regexp: (0, _regexpDefault.default),
    integer: (0, _integerDefault.default),
    float: (0, _floatDefault.default),
    array: (0, _arrayDefault.default),
    object: (0, _objectDefault.default),
    enum: (0, _enumDefault.default),
    pattern: (0, _patternDefault.default),
    date: (0, _dateDefault.default),
    url: (0, _typeDefault.default),
    hex: (0, _typeDefault.default),
    email: (0, _typeDefault.default),
    required: (0, _requiredDefault.default),
    any: (0, _anyDefault.default)
};

},{"./any":"7Egn0","./array":"4z3ZB","./boolean":"kTrzL","./date":"jmB0x","./enum":"44OJr","./float":"fAB2i","./integer":"HsxZn","./method":"la6Gx","./number":"2K2Yg","./object":"fut46","./pattern":"h4LAA","./regexp":"18h2r","./required":"6Tr4V","./string":"fDfJ2","./type":"fLBvz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7Egn0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var any = function any(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, _util.isEmptyValue)(value) && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options);
    }
    callback(errors);
};
exports.default = any;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"klpdO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enum = require("./enum");
var _enumDefault = parcelHelpers.interopDefault(_enum);
var _pattern = require("./pattern");
var _patternDefault = parcelHelpers.interopDefault(_pattern);
var _range = require("./range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _required = require("./required");
var _requiredDefault = parcelHelpers.interopDefault(_required);
var _type = require("./type");
var _typeDefault = parcelHelpers.interopDefault(_type);
var _whitespace = require("./whitespace");
var _whitespaceDefault = parcelHelpers.interopDefault(_whitespace);
exports.default = {
    required: (0, _requiredDefault.default),
    whitespace: (0, _whitespaceDefault.default),
    type: (0, _typeDefault.default),
    range: (0, _rangeDefault.default),
    enum: (0, _enumDefault.default),
    pattern: (0, _patternDefault.default)
};

},{"./enum":"l1is3","./pattern":"6Y8ye","./range":"eKwth","./required":"c13Yy","./type":"bhs7h","./whitespace":"euL2M","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l1is3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("../util");
var ENUM = 'enum';
var enumerable = function enumerable(rule, value, source, errors, options) {
    rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
    if (rule[ENUM].indexOf(value) === -1) errors.push((0, _util.format)(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
};
exports.default = enumerable;

},{"../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Y8ye":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("../util");
var pattern = function pattern(rule, value, source, errors, options) {
    if (rule.pattern) {
        if (rule.pattern instanceof RegExp) {
            // if a RegExp instance is passed, reset `lastIndex` in case its `global`
            // flag is accidentally set to `true`, which in a validation scenario
            // is not necessary and the result might be misleading
            rule.pattern.lastIndex = 0;
            if (!rule.pattern.test(value)) errors.push((0, _util.format)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        } else if (typeof rule.pattern === 'string') {
            var _pattern = new RegExp(rule.pattern);
            if (!_pattern.test(value)) errors.push((0, _util.format)(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
        }
    }
};
exports.default = pattern;

},{"../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eKwth":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("../util");
var range = function range(rule, value, source, errors, options) {
    var len = typeof rule.len === 'number';
    var min = typeof rule.min === 'number';
    var max = typeof rule.max === 'number';
    // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
    var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    var val = value;
    var key = null;
    var num = typeof value === 'number';
    var str = typeof value === 'string';
    var arr = Array.isArray(value);
    if (num) key = 'number';
    else if (str) key = 'string';
    else if (arr) key = 'array';
    // if the value is not of a supported type for range validation
    // the validation rule rule should use the
    // type property to also test for a particular type
    if (!key) return false;
    if (arr) val = value.length;
    if (str) // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".length !== 3
    val = value.replace(spRegexp, '_').length;
    if (len) {
        if (val !== rule.len) errors.push((0, _util.format)(options.messages[key].len, rule.fullField, rule.len));
    } else if (min && !max && val < rule.min) errors.push((0, _util.format)(options.messages[key].min, rule.fullField, rule.min));
    else if (max && !min && val > rule.max) errors.push((0, _util.format)(options.messages[key].max, rule.fullField, rule.max));
    else if (min && max && (val < rule.min || val > rule.max)) errors.push((0, _util.format)(options.messages[key].range, rule.fullField, rule.min, rule.max));
};
exports.default = range;

},{"../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c13Yy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("../util");
var required = function required(rule, value, source, errors, options, type) {
    if (rule.required && (!source.hasOwnProperty(rule.field) || (0, _util.isEmptyValue)(value, type || rule.type))) errors.push((0, _util.format)(options.messages.required, rule.fullField));
};
exports.default = required;

},{"../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bhs7h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _util = require("../util");
var _required = require("./required");
var _requiredDefault = parcelHelpers.interopDefault(_required);
var _url = require("./url");
var _urlDefault = parcelHelpers.interopDefault(_url);
/* eslint max-len:0 */ var pattern = {
    // http://emailregex.com/
    email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
    // url: new RegExp(
    //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
    //   'i',
    // ),
    hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types = {
    integer: function integer(value) {
        return types.number(value) && parseInt(value, 10) === value;
    },
    float: function float(value) {
        return types.number(value) && !types.integer(value);
    },
    array: function array(value) {
        return Array.isArray(value);
    },
    regexp: function regexp(value) {
        if (value instanceof RegExp) return true;
        try {
            return new RegExp(value), true;
        } catch (e) {
            return false;
        }
    },
    date: function date(value) {
        return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function' && !isNaN(value.getTime());
    },
    number: function number(value) {
        if (isNaN(value)) return false;
        return typeof value === 'number';
    },
    object: function object(value) {
        return (0, _typeofDefault.default)(value) === 'object' && !types.array(value);
    },
    method: function method(value) {
        return typeof value === 'function';
    },
    email: function email(value) {
        return typeof value === 'string' && value.length <= 320 && !!value.match(pattern.email);
    },
    url: function url(value) {
        return typeof value === 'string' && value.length <= 2048 && !!value.match((0, _urlDefault.default)());
    },
    hex: function hex(value) {
        return typeof value === 'string' && !!value.match(pattern.hex);
    }
};
var type = function type(rule, value, source, errors, options) {
    if (rule.required && value === undefined) {
        (0, _requiredDefault.default)(rule, value, source, errors, options);
        return;
    }
    var custom = [
        'integer',
        'float',
        'array',
        'regexp',
        'object',
        'method',
        'email',
        'number',
        'date',
        'url',
        'hex'
    ];
    var ruleType = rule.type;
    if (custom.indexOf(ruleType) > -1) {
        if (!types[ruleType](value)) errors.push((0, _util.format)(options.messages.types[ruleType], rule.fullField, rule.type));
    } else if (ruleType && (0, _typeofDefault.default)(value) !== rule.type) errors.push((0, _util.format)(options.messages.types[ruleType], rule.fullField, rule.type));
};
exports.default = type;

},{"@babel/runtime/helpers/esm/typeof":"8oq3j","../util":"4bqQH","./required":"c13Yy","./url":"iuMql","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iuMql":[function(require,module,exports,__globalThis) {
// https://github.com/kevva/url-regex/blob/master/index.js
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var urlReg;
exports.default = function() {
    if (urlReg) return urlReg;
    var word = '[a-fA-F\\d:]';
    var b = function b(options) {
        return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=".concat(word, ")|(?<=").concat(word, ")(?=\\s|$))") : '';
    };
    var v4 = '(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}';
    var v6seg = '[a-fA-F\\d]{1,4}';
    var v6List = [
        "(?:".concat(v6seg, ":){7}(?:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){6}(?:").concat(v4, "|:").concat(v6seg, "|:)"),
        "(?:".concat(v6seg, ":){5}(?::").concat(v4, "|(?::").concat(v6seg, "){1,2}|:)"),
        "(?:".concat(v6seg, ":){4}(?:(?::").concat(v6seg, "){0,1}:").concat(v4, "|(?::").concat(v6seg, "){1,3}|:)"),
        "(?:".concat(v6seg, ":){3}(?:(?::").concat(v6seg, "){0,2}:").concat(v4, "|(?::").concat(v6seg, "){1,4}|:)"),
        "(?:".concat(v6seg, ":){2}(?:(?::").concat(v6seg, "){0,3}:").concat(v4, "|(?::").concat(v6seg, "){1,5}|:)"),
        "(?:".concat(v6seg, ":){1}(?:(?::").concat(v6seg, "){0,4}:").concat(v4, "|(?::").concat(v6seg, "){1,6}|:)"),
        "(?::(?:(?::".concat(v6seg, "){0,5}:").concat(v4, "|(?::").concat(v6seg, "){1,7}|:))") // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::
    ];
    var v6Eth0 = "(?:%[0-9a-zA-Z]{1,})?"; // %eth0            %1
    var v6 = "(?:".concat(v6List.join('|'), ")").concat(v6Eth0);
    // Pre-compile only the exact regexes because adding a global flag make regexes stateful
    var v46Exact = new RegExp("(?:^".concat(v4, "$)|(?:^").concat(v6, "$)"));
    var v4exact = new RegExp("^".concat(v4, "$"));
    var v6exact = new RegExp("^".concat(v6, "$"));
    var ip = function ip(options) {
        return options && options.exact ? v46Exact : new RegExp("(?:".concat(b(options)).concat(v4).concat(b(options), ")|(?:").concat(b(options)).concat(v6).concat(b(options), ")"), 'g');
    };
    ip.v4 = function(options) {
        return options && options.exact ? v4exact : new RegExp("".concat(b(options)).concat(v4).concat(b(options)), 'g');
    };
    ip.v6 = function(options) {
        return options && options.exact ? v6exact : new RegExp("".concat(b(options)).concat(v6).concat(b(options)), 'g');
    };
    var protocol = "(?:(?:[a-z]+:)?//)";
    var auth = '(?:\\S+(?::\\S*)?@)?';
    var ipv4 = ip.v4().source;
    var ipv6 = ip.v6().source;
    var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
    var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
    var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
    var port = '(?::\\d{2,5})?';
    var path = '(?:[/?#][^\\s"]*)?';
    var regex = "(?:".concat(protocol, "|www\\.)").concat(auth, "(?:localhost|").concat(ipv4, "|").concat(ipv6, "|").concat(host).concat(domain).concat(tld, ")").concat(port).concat(path);
    urlReg = new RegExp("(?:^".concat(regex, "$)"), 'i');
    return urlReg;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"euL2M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("../util");
/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */ var whitespace = function whitespace(rule, value, source, errors, options) {
    if (/^\s+$/.test(value) || value === '') errors.push((0, _util.format)(options.messages.whitespace, rule.fullField));
};
exports.default = whitespace;

},{"../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4z3ZB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _index = require("../rule/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var array = function array(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((value === undefined || value === null) && !rule.required) return callback();
        (0, _indexDefault.default).required(rule, value, source, errors, options, 'array');
        if (value !== undefined && value !== null) {
            (0, _indexDefault.default).type(rule, value, source, errors, options);
            (0, _indexDefault.default).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
exports.default = array;

},{"../rule/index":"klpdO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kTrzL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var boolean = function boolean(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, _util.isEmptyValue)(value) && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options);
        if (value !== undefined) (0, _ruleDefault.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
exports.default = boolean;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jmB0x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var date = function date(rule, value, callback, source, options) {
    // console.log('integer rule called %j', rule);
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    // console.log('validate on %s value', value);
    if (validate) {
        if ((0, _util.isEmptyValue)(value, 'date') && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options);
        if (!(0, _util.isEmptyValue)(value, 'date')) {
            var dateObject;
            if (value instanceof Date) dateObject = value;
            else dateObject = new Date(value);
            (0, _ruleDefault.default).type(rule, dateObject, source, errors, options);
            if (dateObject) (0, _ruleDefault.default).range(rule, dateObject.getTime(), source, errors, options);
        }
    }
    callback(errors);
};
exports.default = date;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"44OJr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var ENUM = 'enum';
var enumerable = function enumerable(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, _util.isEmptyValue)(value) && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options);
        if (value !== undefined) (0, _ruleDefault.default)[ENUM](rule, value, source, errors, options);
    }
    callback(errors);
};
exports.default = enumerable;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fAB2i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var floatFn = function floatFn(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, _util.isEmptyValue)(value) && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, _ruleDefault.default).type(rule, value, source, errors, options);
            (0, _ruleDefault.default).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
exports.default = floatFn;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"HsxZn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var integer = function integer(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, _util.isEmptyValue)(value) && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, _ruleDefault.default).type(rule, value, source, errors, options);
            (0, _ruleDefault.default).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
exports.default = integer;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"la6Gx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var method = function method(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, _util.isEmptyValue)(value) && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options);
        if (value !== undefined) (0, _ruleDefault.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
exports.default = method;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2K2Yg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var number = function number(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if (value === '') // eslint-disable-next-line no-param-reassign
        value = undefined;
        if ((0, _util.isEmptyValue)(value) && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options);
        if (value !== undefined) {
            (0, _ruleDefault.default).type(rule, value, source, errors, options);
            (0, _ruleDefault.default).range(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
exports.default = number;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fut46":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var object = function object(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, _util.isEmptyValue)(value) && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options);
        if (value !== undefined) (0, _ruleDefault.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
exports.default = object;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h4LAA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var pattern = function pattern(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options);
        if (!(0, _util.isEmptyValue)(value, 'string')) (0, _ruleDefault.default).pattern(rule, value, source, errors, options);
    }
    callback(errors);
};
exports.default = pattern;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"18h2r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var regexp = function regexp(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, _util.isEmptyValue)(value) && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options);
        if (!(0, _util.isEmptyValue)(value)) (0, _ruleDefault.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
exports.default = regexp;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Tr4V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var required = function required(rule, value, callback, source, options) {
    var errors = [];
    var type = Array.isArray(value) ? 'array' : (0, _typeofDefault.default)(value);
    (0, _ruleDefault.default).required(rule, value, source, errors, options, type);
    callback(errors);
};
exports.default = required;

},{"@babel/runtime/helpers/esm/typeof":"8oq3j","../rule":"klpdO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fDfJ2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var string = function string(rule, value, callback, source, options) {
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options, 'string');
        if (!(0, _util.isEmptyValue)(value, 'string')) {
            (0, _ruleDefault.default).type(rule, value, source, errors, options);
            (0, _ruleDefault.default).range(rule, value, source, errors, options);
            (0, _ruleDefault.default).pattern(rule, value, source, errors, options);
            if (rule.whitespace === true) (0, _ruleDefault.default).whitespace(rule, value, source, errors, options);
        }
    }
    callback(errors);
};
exports.default = string;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fLBvz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _rule = require("../rule");
var _ruleDefault = parcelHelpers.interopDefault(_rule);
var _util = require("../util");
var type = function type(rule, value, callback, source, options) {
    var ruleType = rule.type;
    var errors = [];
    var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
    if (validate) {
        if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) return callback();
        (0, _ruleDefault.default).required(rule, value, source, errors, options, ruleType);
        if (!(0, _util.isEmptyValue)(value, ruleType)) (0, _ruleDefault.default).type(rule, value, source, errors, options);
    }
    callback(errors);
};
exports.default = type;

},{"../rule":"klpdO","../util":"4bqQH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fEoBZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Z9jvF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultValidateMessages", ()=>defaultValidateMessages);
const typeTemplate = "'${name}' is not a valid ${type}";
const defaultValidateMessages = {
    default: "Validation error on field '${name}'",
    required: "'${name}' is required",
    enum: "'${name}' must be one of [${enum}]",
    whitespace: "'${name}' cannot be empty",
    date: {
        format: "'${name}' is invalid for format date",
        parse: "'${name}' could not be parsed as date",
        invalid: "'${name}' is invalid date"
    },
    types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
    },
    string: {
        len: "'${name}' must be exactly ${len} characters",
        min: "'${name}' must be at least ${min} characters",
        max: "'${name}' cannot be longer than ${max} characters",
        range: "'${name}' must be between ${min} and ${max} characters"
    },
    number: {
        len: "'${name}' must equal ${len}",
        min: "'${name}' cannot be less than ${min}",
        max: "'${name}' cannot be greater than ${max}",
        range: "'${name}' must be between ${min} and ${max}"
    },
    array: {
        len: "'${name}' must be exactly ${len} in length",
        min: "'${name}' cannot be less than ${min} in length",
        max: "'${name}' cannot be greater than ${max} in length",
        range: "'${name}' must be between ${min} and ${max} in length"
    },
    pattern: {
        mismatch: "'${name}' does not match pattern ${pattern}"
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hcjiP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValue", ()=>(0, _getDefault.default));
parcelHelpers.export(exports, "setValue", ()=>(0, _setDefault.default));
/**
 * Convert name to internal supported format.
 * This function should keep since we still thinking if need support like `a.b.c` format.
 * 'a' => ['a']
 * 123 => [123]
 * ['a', 123] => ['a', 123]
 */ parcelHelpers.export(exports, "getNamePath", ()=>getNamePath);
/**
 * Create a new store object that contains only the values referenced by
 * the provided list of name paths.
 */ parcelHelpers.export(exports, "cloneByNamePathList", ()=>cloneByNamePathList);
/**
 * Check if `namePathList` includes `namePath`.
 * @param namePathList A list of `InternalNamePath[]`
 * @param namePath Compare `InternalNamePath`
 * @param partialMatch True will make `[a, b]` match `[a, b, c]`
 */ parcelHelpers.export(exports, "containsNamePath", ()=>containsNamePath);
/**
 * Check if `namePath` is super set or equal of `subNamePath`.
 * @param namePath A list of `InternalNamePath[]`
 * @param subNamePath Compare `InternalNamePath`
 * @param partialMatch Default false. True will make `[a, b]` match `[a, b, c]`
 */ parcelHelpers.export(exports, "matchNamePath", ()=>matchNamePath);
// Like `shallowEqual`, but we not check the data which may cause re-render
parcelHelpers.export(exports, "isSimilar", ()=>isSimilar);
parcelHelpers.export(exports, "defaultGetValueFromEvent", ()=>defaultGetValueFromEvent);
/**
 * Moves an array item from one position in an array to another.
 *
 * Note: This is a pure function so a new array will be returned, instead
 * of altering the array argument.
 *
 * @param array         Array in which to move an item.         (required)
 * @param moveIndex     The index of the item to move.          (required)
 * @param toIndex       The index to move item at moveIndex to. (required)
 */ parcelHelpers.export(exports, "move", ()=>move);
var _get = require("@rc-component/util/es/utils/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _set = require("@rc-component/util/es/utils/set");
var _setDefault = parcelHelpers.interopDefault(_set);
var _typeUtil = require("./typeUtil");
function getNamePath(path) {
    return (0, _typeUtil.toArray)(path);
}
function cloneByNamePathList(store, namePathList) {
    let newStore = {};
    namePathList.forEach((namePath)=>{
        const value = (0, _getDefault.default)(store, namePath);
        newStore = (0, _setDefault.default)(newStore, namePath, value);
    });
    return newStore;
}
function containsNamePath(namePathList, namePath, partialMatch = false) {
    return namePathList && namePathList.some((path)=>matchNamePath(namePath, path, partialMatch));
}
function matchNamePath(namePath, subNamePath, partialMatch = false) {
    if (!namePath || !subNamePath) return false;
    if (!partialMatch && namePath.length !== subNamePath.length) return false;
    return subNamePath.every((nameUnit, i)=>namePath[i] === nameUnit);
}
function isSimilar(source, target) {
    if (source === target) return true;
    if (!source && target || source && !target) return false;
    if (!source || !target || typeof source !== 'object' || typeof target !== 'object') return false;
    const sourceKeys = Object.keys(source);
    const targetKeys = Object.keys(target);
    const keys = new Set([
        ...sourceKeys,
        ...targetKeys
    ]);
    return [
        ...keys
    ].every((key)=>{
        const sourceValue = source[key];
        const targetValue = target[key];
        if (typeof sourceValue === 'function' && typeof targetValue === 'function') return true;
        return sourceValue === targetValue;
    });
}
function defaultGetValueFromEvent(valuePropName, ...args) {
    const event = args[0];
    if (event && event.target && typeof event.target === 'object' && valuePropName in event.target) return event.target[valuePropName];
    return event;
}
function move(array, moveIndex, toIndex) {
    const { length } = array;
    if (moveIndex < 0 || moveIndex >= length || toIndex < 0 || toIndex >= length) return array;
    const item = array[moveIndex];
    const diff = moveIndex - toIndex;
    if (diff > 0) // move left
    return [
        ...array.slice(0, toIndex),
        item,
        ...array.slice(toIndex, moveIndex),
        ...array.slice(moveIndex + 1, length)
    ];
    if (diff < 0) // move right
    return [
        ...array.slice(0, moveIndex),
        ...array.slice(moveIndex + 1, toIndex + 1),
        item,
        ...array.slice(toIndex + 1, length)
    ];
    return array;
}

},{"@rc-component/util/es/utils/get":"f60uf","@rc-component/util/es/utils/set":"hA7hn","./typeUtil":"jWjE0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"86ZmC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _fieldContext = require("./FieldContext");
var _fieldContextDefault = parcelHelpers.interopDefault(_fieldContext);
var _field = require("./Field");
var _fieldDefault = parcelHelpers.interopDefault(_field);
var _valueUtil = require("./utils/valueUtil");
var _listContext = require("./ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
function List({ name, initialValue, children, rules, validateTrigger, isListField }) {
    const context = _react.useContext((0, _fieldContextDefault.default));
    const wrapperListContext = _react.useContext((0, _listContextDefault.default));
    const keyRef = _react.useRef({
        keys: [],
        id: 0
    });
    const keyManager = keyRef.current;
    const prefixName = _react.useMemo(()=>{
        const parentPrefixName = (0, _valueUtil.getNamePath)(context.prefixName) || [];
        return [
            ...parentPrefixName,
            ...(0, _valueUtil.getNamePath)(name)
        ];
    }, [
        context.prefixName,
        name
    ]);
    const fieldContext = _react.useMemo(()=>({
            ...context,
            prefixName
        }), [
        context,
        prefixName
    ]);
    // List context
    const listContext = _react.useMemo(()=>({
            getKey: (namePath)=>{
                const len = prefixName.length;
                const pathName = namePath[len];
                return [
                    keyManager.keys[pathName],
                    namePath.slice(len + 1)
                ];
            }
        }), [
        keyManager,
        prefixName
    ]);
    // User should not pass `children` as other type.
    if (typeof children !== 'function') {
        (0, _warningDefault.default)(false, 'Form.List only accepts function as children.');
        return null;
    }
    const shouldUpdate = (prevValue, nextValue, { source })=>{
        if (source === 'internal') return false;
        return prevValue !== nextValue;
    };
    return /*#__PURE__*/ _react.createElement((0, _listContextDefault.default).Provider, {
        value: listContext
    }, /*#__PURE__*/ _react.createElement((0, _fieldContextDefault.default).Provider, {
        value: fieldContext
    }, /*#__PURE__*/ _react.createElement((0, _fieldDefault.default), {
        name: [],
        shouldUpdate: shouldUpdate,
        rules: rules,
        validateTrigger: validateTrigger,
        initialValue: initialValue,
        isList: true,
        isListField: isListField ?? !!wrapperListContext
    }, ({ value = [], onChange }, meta)=>{
        const { getFieldValue } = context;
        const getNewValue = ()=>{
            const values = getFieldValue(prefixName || []);
            return values || [];
        };
        /**
     * Always get latest value in case user update fields by `form` api.
     */ const operations = {
            add: (defaultValue, index)=>{
                // Mapping keys
                const newValue = getNewValue();
                if (index >= 0 && index <= newValue.length) {
                    keyManager.keys = [
                        ...keyManager.keys.slice(0, index),
                        keyManager.id,
                        ...keyManager.keys.slice(index)
                    ];
                    onChange([
                        ...newValue.slice(0, index),
                        defaultValue,
                        ...newValue.slice(index)
                    ]);
                } else {
                    keyManager.keys = [
                        ...keyManager.keys,
                        keyManager.id
                    ];
                    onChange([
                        ...newValue,
                        defaultValue
                    ]);
                }
                keyManager.id += 1;
            },
            remove: (index)=>{
                const newValue = getNewValue();
                const indexSet = new Set(Array.isArray(index) ? index : [
                    index
                ]);
                if (indexSet.size <= 0) return;
                keyManager.keys = keyManager.keys.filter((_, keysIndex)=>!indexSet.has(keysIndex));
                // Trigger store change
                onChange(newValue.filter((_, valueIndex)=>!indexSet.has(valueIndex)));
            },
            move (from, to) {
                if (from === to) return;
                const newValue = getNewValue();
                // Do not handle out of range
                if (from < 0 || from >= newValue.length || to < 0 || to >= newValue.length) return;
                keyManager.keys = (0, _valueUtil.move)(keyManager.keys, from, to);
                // Trigger store change
                onChange((0, _valueUtil.move)(newValue, from, to));
            }
        };
        let listValue = value || [];
        if (!Array.isArray(listValue)) listValue = [];
        return children(listValue.map((__, index)=>{
            let key = keyManager.keys[index];
            if (key === undefined) {
                keyManager.keys[index] = keyManager.id;
                key = keyManager.keys[index];
                keyManager.id += 1;
            }
            return {
                name: index,
                key,
                isListField: true
            };
        }), operations, meta);
    })));
}
exports.default = List;

},{"react":"bmhQu","@rc-component/util/es/warning":"hJXDS","./FieldContext":"k8mze","./Field":"fam7b","./utils/valueUtil":"hcjiP","./ListContext":"9Y7SO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lwy6I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormStore", ()=>FormStore);
var _set = require("@rc-component/util/es/utils/set");
var _util = require("@rc-component/util");
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _react = require("react");
var _fieldContext = require("../FieldContext");
var _asyncUtil = require("../utils/asyncUtil");
var _messages = require("../utils/messages");
var _nameMap = require("../utils/NameMap");
var _nameMapDefault = parcelHelpers.interopDefault(_nameMap);
var _valueUtil = require("../utils/valueUtil");
var _useNotifyWatch = require("./useNotifyWatch");
var _useNotifyWatchDefault = parcelHelpers.interopDefault(_useNotifyWatch);
class FormStore {
    formHooked = false;
    forceRootUpdate;
    subscribable = true;
    store = {};
    fieldEntities = [];
    initialValues = {};
    callbacks = {};
    validateMessages = null;
    preserve = null;
    lastValidatePromise = null;
    watcherCenter = new (0, _useNotifyWatchDefault.default)(this);
    constructor(forceRootUpdate){
        this.forceRootUpdate = forceRootUpdate;
    }
    getForm = ()=>({
            getFieldValue: this.getFieldValue,
            getFieldsValue: this.getFieldsValue,
            getFieldError: this.getFieldError,
            getFieldWarning: this.getFieldWarning,
            getFieldsError: this.getFieldsError,
            isFieldsTouched: this.isFieldsTouched,
            isFieldTouched: this.isFieldTouched,
            isFieldValidating: this.isFieldValidating,
            isFieldsValidating: this.isFieldsValidating,
            resetFields: this.resetFields,
            setFields: this.setFields,
            setFieldValue: this.setFieldValue,
            setFieldsValue: this.setFieldsValue,
            validateFields: this.validateFields,
            submit: this.submit,
            _init: true,
            getInternalHooks: this.getInternalHooks
        });
    // ======================== Internal Hooks ========================
    getInternalHooks = (key)=>{
        if (key === (0, _fieldContext.HOOK_MARK)) {
            this.formHooked = true;
            return {
                dispatch: this.dispatch,
                initEntityValue: this.initEntityValue,
                registerField: this.registerField,
                useSubscribe: this.useSubscribe,
                setInitialValues: this.setInitialValues,
                destroyForm: this.destroyForm,
                setCallbacks: this.setCallbacks,
                setValidateMessages: this.setValidateMessages,
                getFields: this.getFields,
                setPreserve: this.setPreserve,
                getInitialValue: this.getInitialValue,
                registerWatch: this.registerWatch
            };
        }
        (0, _warningDefault.default)(false, '`getInternalHooks` is internal usage. Should not call directly.');
        return null;
    };
    useSubscribe = (subscribable)=>{
        this.subscribable = subscribable;
    };
    /**
   * Record prev Form unmount fieldEntities which config preserve false.
   * This need to be refill with initialValues instead of store value.
   */ prevWithoutPreserves = null;
    /**
   * First time `setInitialValues` should update store with initial value
   */ setInitialValues = (initialValues, init)=>{
        this.initialValues = initialValues || {};
        if (init) {
            let nextStore = (0, _set.merge)(initialValues, this.store);
            // We will take consider prev form unmount fields.
            // When the field is not `preserve`, we need fill this with initialValues instead of store.
            // eslint-disable-next-line array-callback-return
            this.prevWithoutPreserves?.map(({ key: namePath })=>{
                nextStore = (0, _valueUtil.setValue)(nextStore, namePath, (0, _valueUtil.getValue)(initialValues, namePath));
            });
            this.prevWithoutPreserves = null;
            this.updateStore(nextStore);
        }
    };
    destroyForm = (clearOnDestroy)=>{
        if (clearOnDestroy) // destroy form reset store
        this.updateStore({});
        else {
            // Fill preserve fields
            const prevWithoutPreserves = new (0, _nameMapDefault.default)();
            this.getFieldEntities(true).forEach((entity)=>{
                if (!this.isMergedPreserve(entity.isPreserve())) prevWithoutPreserves.set(entity.getNamePath(), true);
            });
            this.prevWithoutPreserves = prevWithoutPreserves;
        }
    };
    getInitialValue = (namePath)=>{
        const initValue = (0, _valueUtil.getValue)(this.initialValues, namePath);
        // Not cloneDeep when without `namePath`
        return namePath.length ? (0, _set.merge)(initValue) : initValue;
    };
    setCallbacks = (callbacks)=>{
        this.callbacks = callbacks;
    };
    setValidateMessages = (validateMessages)=>{
        this.validateMessages = validateMessages;
    };
    setPreserve = (preserve)=>{
        this.preserve = preserve;
    };
    // ============================= Watch ============================
    registerWatch = (callback)=>{
        return this.watcherCenter.register(callback);
    };
    notifyWatch = (namePath = [])=>{
        this.watcherCenter.notify(namePath);
    };
    // ========================== Dev Warning =========================
    timeoutId = null;
    warningUnhooked = ()=>{};
    // ============================ Store =============================
    updateStore = (nextStore)=>{
        this.store = nextStore;
    };
    // ============================ Fields ============================
    /**
   * Get registered field entities.
   * @param pure Only return field which has a `name`. Default: false
   */ getFieldEntities = (pure = false)=>{
        if (!pure) return this.fieldEntities;
        return this.fieldEntities.filter((field)=>field.getNamePath().length);
    };
    getFieldsMap = (pure = false)=>{
        const cache = new (0, _nameMapDefault.default)();
        this.getFieldEntities(pure).forEach((field)=>{
            const namePath = field.getNamePath();
            cache.set(namePath, field);
        });
        return cache;
    };
    getFieldEntitiesForNamePathList = (nameList)=>{
        if (!nameList) return this.getFieldEntities(true);
        const cache = this.getFieldsMap(true);
        return nameList.map((name)=>{
            const namePath = (0, _valueUtil.getNamePath)(name);
            return cache.get(namePath) || {
                INVALIDATE_NAME_PATH: (0, _valueUtil.getNamePath)(name)
            };
        });
    };
    getFieldsValue = (nameList, filterFunc)=>{
        this.warningUnhooked();
        // Fill args
        let mergedNameList;
        let mergedFilterFunc;
        if (nameList === true || Array.isArray(nameList)) {
            mergedNameList = nameList;
            mergedFilterFunc = filterFunc;
        } else if (nameList && typeof nameList === 'object') mergedFilterFunc = nameList.filter;
        if (mergedNameList === true && !mergedFilterFunc) return this.store;
        const fieldEntities = this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
        const filteredNameList = [];
        const listNamePaths = [];
        fieldEntities.forEach((entity)=>{
            const namePath = entity.INVALIDATE_NAME_PATH || entity.getNamePath();
            // Ignore when it's a list item and not specific the namePath,
            // since parent field is already take in count
            if (entity.isList?.()) {
                listNamePaths.push(namePath);
                return;
            }
            if (!mergedFilterFunc) filteredNameList.push(namePath);
            else {
                const meta = 'getMeta' in entity ? entity.getMeta() : null;
                if (mergedFilterFunc(meta)) filteredNameList.push(namePath);
            }
        });
        let mergedValues = (0, _valueUtil.cloneByNamePathList)(this.store, filteredNameList.map((0, _valueUtil.getNamePath)));
        // We need fill the list as [] if Form.List is empty
        listNamePaths.forEach((namePath)=>{
            if (!(0, _valueUtil.getValue)(mergedValues, namePath)) mergedValues = (0, _valueUtil.setValue)(mergedValues, namePath, []);
        });
        return mergedValues;
    };
    getFieldValue = (name)=>{
        this.warningUnhooked();
        const namePath = (0, _valueUtil.getNamePath)(name);
        return (0, _valueUtil.getValue)(this.store, namePath);
    };
    getFieldsError = (nameList)=>{
        this.warningUnhooked();
        const fieldEntities = this.getFieldEntitiesForNamePathList(nameList);
        return fieldEntities.map((entity, index)=>{
            if (entity && !entity.INVALIDATE_NAME_PATH) return {
                name: entity.getNamePath(),
                errors: entity.getErrors(),
                warnings: entity.getWarnings()
            };
            return {
                name: (0, _valueUtil.getNamePath)(nameList[index]),
                errors: [],
                warnings: []
            };
        });
    };
    getFieldError = (name)=>{
        this.warningUnhooked();
        const namePath = (0, _valueUtil.getNamePath)(name);
        const fieldError = this.getFieldsError([
            namePath
        ])[0];
        return fieldError.errors;
    };
    getFieldWarning = (name)=>{
        this.warningUnhooked();
        const namePath = (0, _valueUtil.getNamePath)(name);
        const fieldError = this.getFieldsError([
            namePath
        ])[0];
        return fieldError.warnings;
    };
    isFieldsTouched = (...args)=>{
        this.warningUnhooked();
        const [arg0, arg1] = args;
        let namePathList;
        let isAllFieldsTouched = false;
        if (args.length === 0) namePathList = null;
        else if (args.length === 1) {
            if (Array.isArray(arg0)) {
                namePathList = arg0.map((0, _valueUtil.getNamePath));
                isAllFieldsTouched = false;
            } else {
                namePathList = null;
                isAllFieldsTouched = arg0;
            }
        } else {
            namePathList = arg0.map((0, _valueUtil.getNamePath));
            isAllFieldsTouched = arg1;
        }
        const fieldEntities = this.getFieldEntities(true);
        const isFieldTouched = (field)=>field.isFieldTouched();
        // ===== Will get fully compare when not config namePathList =====
        if (!namePathList) return isAllFieldsTouched ? fieldEntities.every((entity)=>isFieldTouched(entity) || entity.isList()) : fieldEntities.some(isFieldTouched);
        // Generate a nest tree for validate
        const map = new (0, _nameMapDefault.default)();
        namePathList.forEach((shortNamePath)=>{
            map.set(shortNamePath, []);
        });
        fieldEntities.forEach((field)=>{
            const fieldNamePath = field.getNamePath();
            // Find matched entity and put into list
            namePathList.forEach((shortNamePath)=>{
                if (shortNamePath.every((nameUnit, i)=>fieldNamePath[i] === nameUnit)) map.update(shortNamePath, (list)=>[
                        ...list,
                        field
                    ]);
            });
        });
        // Check if NameMap value is touched
        const isNamePathListTouched = (entities)=>entities.some(isFieldTouched);
        const namePathListEntities = map.map(({ value })=>value);
        return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
    };
    isFieldTouched = (name)=>{
        this.warningUnhooked();
        return this.isFieldsTouched([
            name
        ]);
    };
    isFieldsValidating = (nameList)=>{
        this.warningUnhooked();
        const fieldEntities = this.getFieldEntities();
        if (!nameList) return fieldEntities.some((testField)=>testField.isFieldValidating());
        const namePathList = nameList.map((0, _valueUtil.getNamePath));
        return fieldEntities.some((testField)=>{
            const fieldNamePath = testField.getNamePath();
            return (0, _valueUtil.containsNamePath)(namePathList, fieldNamePath) && testField.isFieldValidating();
        });
    };
    isFieldValidating = (name)=>{
        this.warningUnhooked();
        return this.isFieldsValidating([
            name
        ]);
    };
    /**
   * Reset Field with field `initialValue` prop.
   * Can pass `entities` or `namePathList` or just nothing.
   */ resetWithFieldInitialValue = (info = {})=>{
        // Create cache
        const cache = new (0, _nameMapDefault.default)();
        const fieldEntities = this.getFieldEntities(true);
        fieldEntities.forEach((field)=>{
            const { initialValue } = field.props;
            const namePath = field.getNamePath();
            // Record only if has `initialValue`
            if (initialValue !== undefined) {
                const records = cache.get(namePath) || new Set();
                records.add({
                    entity: field,
                    value: initialValue
                });
                cache.set(namePath, records);
            }
        });
        // Reset
        const resetWithFields = (entities)=>{
            entities.forEach((field)=>{
                const { initialValue } = field.props;
                if (initialValue !== undefined) {
                    const namePath = field.getNamePath();
                    const formInitialValue = this.getInitialValue(namePath);
                    if (formInitialValue !== undefined) // Warning if conflict with form initialValues and do not modify value
                    (0, _warningDefault.default)(false, `Form already set 'initialValues' with path '${namePath.join('.')}'. Field can not overwrite it.`);
                    else {
                        const records = cache.get(namePath);
                        if (records && records.size > 1) // Warning if multiple field set `initialValue`and do not modify value
                        (0, _warningDefault.default)(false, `Multiple Field with path '${namePath.join('.')}' set 'initialValue'. Can not decide which one to pick.`);
                        else if (records) {
                            const originValue = this.getFieldValue(namePath);
                            const isListField = field.isListField();
                            // Set `initialValue`
                            if (!isListField && (!info.skipExist || originValue === undefined)) this.updateStore((0, _valueUtil.setValue)(this.store, namePath, [
                                ...records
                            ][0].value));
                        }
                    }
                }
            });
        };
        let requiredFieldEntities;
        if (info.entities) requiredFieldEntities = info.entities;
        else if (info.namePathList) {
            requiredFieldEntities = [];
            info.namePathList.forEach((namePath)=>{
                const records = cache.get(namePath);
                if (records) requiredFieldEntities.push(...[
                    ...records
                ].map((r)=>r.entity));
            });
        } else requiredFieldEntities = fieldEntities;
        resetWithFields(requiredFieldEntities);
    };
    resetFields = (nameList)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        if (!nameList) {
            this.updateStore((0, _set.merge)(this.initialValues));
            this.resetWithFieldInitialValue();
            this.notifyObservers(prevStore, null, {
                type: 'reset'
            });
            this.notifyWatch();
            return;
        }
        // Reset by `nameList`
        const namePathList = nameList.map((0, _valueUtil.getNamePath));
        namePathList.forEach((namePath)=>{
            const initialValue = this.getInitialValue(namePath);
            this.updateStore((0, _valueUtil.setValue)(this.store, namePath, initialValue));
        });
        this.resetWithFieldInitialValue({
            namePathList
        });
        this.notifyObservers(prevStore, namePathList, {
            type: 'reset'
        });
        this.notifyWatch(namePathList);
    };
    setFields = (fields)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        const namePathList = [];
        fields.forEach((fieldData)=>{
            const { name, ...data } = fieldData;
            const namePath = (0, _valueUtil.getNamePath)(name);
            namePathList.push(namePath);
            // Value
            if ('value' in data) this.updateStore((0, _valueUtil.setValue)(this.store, namePath, data.value));
            this.notifyObservers(prevStore, [
                namePath
            ], {
                type: 'setField',
                data: fieldData
            });
        });
        this.notifyWatch(namePathList);
    };
    getFields = ()=>{
        const entities = this.getFieldEntities(true);
        const fields = entities.map((field)=>{
            const namePath = field.getNamePath();
            const meta = field.getMeta();
            const fieldData = {
                ...meta,
                name: namePath,
                value: this.getFieldValue(namePath)
            };
            Object.defineProperty(fieldData, 'originRCField', {
                value: true
            });
            return fieldData;
        });
        return fields;
    };
    // =========================== Observer ===========================
    /**
   * This only trigger when a field is on constructor to avoid we get initialValue too late
   */ initEntityValue = (entity)=>{
        const { initialValue } = entity.props;
        if (initialValue !== undefined) {
            const namePath = entity.getNamePath();
            const prevValue = (0, _valueUtil.getValue)(this.store, namePath);
            if (prevValue === undefined) this.updateStore((0, _valueUtil.setValue)(this.store, namePath, initialValue));
        }
    };
    isMergedPreserve = (fieldPreserve)=>{
        const mergedPreserve = fieldPreserve !== undefined ? fieldPreserve : this.preserve;
        return mergedPreserve ?? true;
    };
    registerField = (entity)=>{
        this.fieldEntities.push(entity);
        const namePath = entity.getNamePath();
        this.notifyWatch([
            namePath
        ]);
        // Set initial values
        if (entity.props.initialValue !== undefined) {
            const prevStore = this.store;
            this.resetWithFieldInitialValue({
                entities: [
                    entity
                ],
                skipExist: true
            });
            this.notifyObservers(prevStore, [
                entity.getNamePath()
            ], {
                type: 'valueUpdate',
                source: 'internal'
            });
        }
        // un-register field callback
        return (isListField, preserve, subNamePath = [])=>{
            this.fieldEntities = this.fieldEntities.filter((item)=>item !== entity);
            // Clean up store value if not preserve
            if (!this.isMergedPreserve(preserve) && (!isListField || subNamePath.length > 1)) {
                const defaultValue = isListField ? undefined : this.getInitialValue(namePath);
                if (namePath.length && this.getFieldValue(namePath) !== defaultValue && this.fieldEntities.every((field)=>// Only reset when no namePath exist
                    !(0, _valueUtil.matchNamePath)(field.getNamePath(), namePath))) {
                    const prevStore = this.store;
                    this.updateStore((0, _valueUtil.setValue)(prevStore, namePath, defaultValue, true));
                    // Notify that field is unmount
                    this.notifyObservers(prevStore, [
                        namePath
                    ], {
                        type: 'remove'
                    });
                    // Dependencies update
                    this.triggerDependenciesUpdate(prevStore, namePath);
                }
            }
            this.notifyWatch([
                namePath
            ]);
        };
    };
    dispatch = (action)=>{
        switch(action.type){
            case 'updateValue':
                {
                    const { namePath, value } = action;
                    this.updateValue(namePath, value);
                    break;
                }
            case 'validateField':
                {
                    const { namePath, triggerName } = action;
                    this.validateFields([
                        namePath
                    ], {
                        triggerName
                    });
                    break;
                }
            default:
        }
    };
    notifyObservers = (prevStore, namePathList, info)=>{
        if (this.subscribable) {
            const mergedInfo = {
                ...info,
                store: this.getFieldsValue(true)
            };
            this.getFieldEntities().forEach(({ onStoreChange })=>{
                onStoreChange(prevStore, namePathList, mergedInfo);
            });
        } else this.forceRootUpdate();
    };
    /**
   * Notify dependencies children with parent update
   * We need delay to trigger validate in case Field is under render props
   */ triggerDependenciesUpdate = (prevStore, namePath)=>{
        const childrenFields = this.getDependencyChildrenFields(namePath);
        if (childrenFields.length) this.validateFields(childrenFields);
        this.notifyObservers(prevStore, childrenFields, {
            type: 'dependenciesUpdate',
            relatedFields: [
                namePath,
                ...childrenFields
            ]
        });
        return childrenFields;
    };
    updateValue = (name, value)=>{
        const namePath = (0, _valueUtil.getNamePath)(name);
        const prevStore = this.store;
        this.updateStore((0, _valueUtil.setValue)(this.store, namePath, value));
        this.notifyObservers(prevStore, [
            namePath
        ], {
            type: 'valueUpdate',
            source: 'internal'
        });
        this.notifyWatch([
            namePath
        ]);
        // Dependencies update
        const childrenFields = this.triggerDependenciesUpdate(prevStore, namePath);
        // trigger callback function
        const { onValuesChange } = this.callbacks;
        if (onValuesChange) {
            const fieldEntity = this.getFieldsMap(true).get(namePath);
            const changedValues = (0, _valueUtil.cloneByNamePathList)(this.store, [
                namePath
            ]);
            const allValues = this.getFieldsValue();
            // Merge changedValues into allValues to ensure allValues contains the latest changes
            const mergedAllValues = (0, _util.mergeWith)([
                allValues,
                changedValues
            ], {
                // When value is array, it means trigger by Form.List which should replace directly
                prepareArray: (current)=>fieldEntity?.isList() ? [] : [
                        ...current || []
                    ]
            });
            onValuesChange(changedValues, mergedAllValues);
        }
        this.triggerOnFieldsChange([
            namePath,
            ...childrenFields
        ]);
    };
    // Let all child Field get update.
    setFieldsValue = (store)=>{
        this.warningUnhooked();
        const prevStore = this.store;
        if (store) {
            const nextStore = (0, _set.merge)(this.store, store);
            this.updateStore(nextStore);
        }
        this.notifyObservers(prevStore, null, {
            type: 'valueUpdate',
            source: 'external'
        });
        this.notifyWatch();
    };
    setFieldValue = (name, value)=>{
        this.setFields([
            {
                name,
                value,
                errors: [],
                warnings: [],
                touched: true
            }
        ]);
    };
    getDependencyChildrenFields = (rootNamePath)=>{
        const children = new Set();
        const childrenFields = [];
        const dependencies2fields = new (0, _nameMapDefault.default)();
        /**
     * Generate maps
     * Can use cache to save perf if user report performance issue with this
     */ this.getFieldEntities().forEach((field)=>{
            const { dependencies } = field.props;
            (dependencies || []).forEach((dependency)=>{
                const dependencyNamePath = (0, _valueUtil.getNamePath)(dependency);
                dependencies2fields.update(dependencyNamePath, (fields = new Set())=>{
                    fields.add(field);
                    return fields;
                });
            });
        });
        const fillChildren = (namePath)=>{
            const fields = dependencies2fields.get(namePath) || new Set();
            fields.forEach((field)=>{
                if (!children.has(field)) {
                    children.add(field);
                    const fieldNamePath = field.getNamePath();
                    if (field.isFieldDirty() && fieldNamePath.length) {
                        childrenFields.push(fieldNamePath);
                        fillChildren(fieldNamePath);
                    }
                }
            });
        };
        fillChildren(rootNamePath);
        return childrenFields;
    };
    triggerOnFieldsChange = (namePathList, filedErrors)=>{
        const { onFieldsChange } = this.callbacks;
        if (onFieldsChange) {
            const fields = this.getFields();
            /**
       * Fill errors since `fields` may be replaced by controlled fields
       */ if (filedErrors) {
                const cache = new (0, _nameMapDefault.default)();
                filedErrors.forEach(({ name, errors })=>{
                    cache.set(name, errors);
                });
                fields.forEach((field)=>{
                    // eslint-disable-next-line no-param-reassign
                    field.errors = cache.get(field.name) || field.errors;
                });
            }
            const changedFields = fields.filter(({ name: fieldName })=>(0, _valueUtil.containsNamePath)(namePathList, fieldName));
            if (changedFields.length) onFieldsChange(changedFields, fields);
        }
    };
    // =========================== Validate ===========================
    validateFields = (arg1, arg2)=>{
        this.warningUnhooked();
        let nameList;
        let options;
        if (Array.isArray(arg1) || typeof arg1 === 'string' || typeof arg2 === 'string') {
            nameList = arg1;
            options = arg2;
        } else options = arg1;
        const provideNameList = !!nameList;
        const namePathList = provideNameList ? nameList.map((0, _valueUtil.getNamePath)) : [];
        // Same namePathList, but does not include Form.List name
        const finalValueNamePathList = [
            ...namePathList
        ];
        // Collect result in promise list
        const promiseList = [];
        // We temp save the path which need trigger for `onFieldsChange`
        const TMP_SPLIT = String(Date.now());
        const validateNamePathList = new Set();
        const { recursive, dirty } = options || {};
        this.getFieldEntities(true).forEach((field)=>{
            const fieldNamePath = field.getNamePath();
            // Add field if not provide `nameList`
            if (!provideNameList) {
                if (// If is field, pass directly
                !field.isList() || // If is list, do not add if already exist sub field in the namePathList
                !namePathList.some((name)=>(0, _valueUtil.matchNamePath)(name, fieldNamePath, true))) finalValueNamePathList.push(fieldNamePath);
                namePathList.push(fieldNamePath);
            }
            // Skip if without rule
            if (!field.props.rules || !field.props.rules.length) return;
            // Skip if only validate dirty field
            if (dirty && !field.isFieldDirty()) return;
            validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
            // Add field validate rule in to promise list
            if (!provideNameList || (0, _valueUtil.containsNamePath)(namePathList, fieldNamePath, recursive)) {
                const promise = field.validateRules({
                    validateMessages: {
                        ...(0, _messages.defaultValidateMessages),
                        ...this.validateMessages
                    },
                    ...options
                });
                // Wrap promise with field
                promiseList.push(promise.then(()=>({
                        name: fieldNamePath,
                        errors: [],
                        warnings: []
                    })).catch((ruleErrors)=>{
                    const mergedErrors = [];
                    const mergedWarnings = [];
                    ruleErrors.forEach?.(({ rule: { warningOnly }, errors })=>{
                        if (warningOnly) mergedWarnings.push(...errors);
                        else mergedErrors.push(...errors);
                    });
                    if (mergedErrors.length) return Promise.reject({
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    });
                    return {
                        name: fieldNamePath,
                        errors: mergedErrors,
                        warnings: mergedWarnings
                    };
                }));
            }
        });
        const summaryPromise = (0, _asyncUtil.allPromiseFinish)(promiseList);
        this.lastValidatePromise = summaryPromise;
        // Notify fields with rule that validate has finished and need update
        summaryPromise.catch((results)=>results).then((results)=>{
            const resultNamePathList = results.map(({ name })=>name);
            this.notifyObservers(this.store, resultNamePathList, {
                type: 'validateFinish'
            });
            this.triggerOnFieldsChange(resultNamePathList, results);
        });
        const returnPromise = summaryPromise.then(()=>{
            if (this.lastValidatePromise === summaryPromise) return Promise.resolve(this.getFieldsValue(finalValueNamePathList));
            return Promise.reject([]);
        }).catch((results)=>{
            const errorList = results.filter((result)=>result && result.errors.length);
            const errorMessage = errorList[0]?.errors?.[0];
            return Promise.reject({
                message: errorMessage,
                values: this.getFieldsValue(namePathList),
                errorFields: errorList,
                outOfDate: this.lastValidatePromise !== summaryPromise
            });
        });
        // Do not throw in console
        returnPromise.catch((e)=>e);
        // `validating` changed. Trigger `onFieldsChange`
        const triggerNamePathList = namePathList.filter((namePath)=>validateNamePathList.has(namePath.join(TMP_SPLIT)));
        this.triggerOnFieldsChange(triggerNamePathList);
        return returnPromise;
    };
    // ============================ Submit ============================
    submit = ()=>{
        this.warningUnhooked();
        this.validateFields().then((values)=>{
            const { onFinish } = this.callbacks;
            if (onFinish) try {
                onFinish(values);
            } catch (err) {
                // Should print error if user `onFinish` callback failed
                console.error(err);
            }
        }).catch((e)=>{
            const { onFinishFailed } = this.callbacks;
            if (onFinishFailed) onFinishFailed(e);
        });
    };
}
function useForm(form) {
    const formRef = _react.useRef(null);
    const [, forceUpdate] = _react.useState({});
    // Create singleton FormStore
    if (!formRef.current) {
        if (form) formRef.current = form;
        else {
            // Create a new FormStore if not provided
            const forceReRender = ()=>{
                forceUpdate({});
            };
            const formStore = new FormStore(forceReRender);
            formRef.current = formStore.getForm();
        }
    }
    return [
        formRef.current
    ];
}
exports.default = useForm;

},{"@rc-component/util/es/utils/set":"hA7hn","@rc-component/util":"6ZBDN","@rc-component/util/es/warning":"hJXDS","react":"bmhQu","../FieldContext":"k8mze","../utils/asyncUtil":"czaaT","../utils/messages":"Z9jvF","../utils/NameMap":"iNkfu","../utils/valueUtil":"hcjiP","./useNotifyWatch":"iloxC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"czaaT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "allPromiseFinish", ()=>allPromiseFinish);
function allPromiseFinish(promiseList) {
    let hasError = false;
    let count = promiseList.length;
    const results = [];
    if (!promiseList.length) return Promise.resolve([]);
    return new Promise((resolve, reject)=>{
        promiseList.forEach((promise, index)=>{
            promise.catch((e)=>{
                hasError = true;
                return e;
            }).then((result)=>{
                count -= 1;
                results[index] = result;
                if (count > 0) return;
                if (hasError) reject(results);
                resolve(results);
            });
        });
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iNkfu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const SPLIT = '__@field_split__';
/**
 * Convert name path into string to fast the fetch speed of Map.
 */ function normalize(namePath) {
    return namePath.map((cell)=>`${typeof cell}:${cell}`)// Magic split
    .join(SPLIT);
}
/**
 * NameMap like a `Map` but accepts `string[]` as key.
 */ class NameMap {
    kvs = new Map();
    set(key, value) {
        this.kvs.set(normalize(key), value);
    }
    get(key) {
        return this.kvs.get(normalize(key));
    }
    update(key, updater) {
        const origin = this.get(key);
        const next = updater(origin);
        if (!next) this.delete(key);
        else this.set(key, next);
    }
    delete(key) {
        this.kvs.delete(normalize(key));
    }
    // Since we only use this in test, let simply realize this
    map(callback) {
        return [
            ...this.kvs.entries()
        ].map(([key, value])=>{
            const cells = key.split(SPLIT);
            return callback({
                key: cells.map((cell)=>{
                    const [, type, unit] = cell.match(/^([^:]*):(.*)$/);
                    return type === 'number' ? Number(unit) : unit;
                }),
                value
            });
        });
    }
    toJSON() {
        const json = {};
        this.map(({ key, value })=>{
            json[key.join('.')] = value;
            return null;
        });
        return json;
    }
}
exports.default = NameMap;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iloxC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _valueUtil = require("../utils/valueUtil");
/**
 * Call action with delay in macro task.
 */ const macroTask = (fn)=>{
    const channel = new MessageChannel();
    channel.port1.onmessage = fn;
    channel.port2.postMessage(null);
};
class WatcherCenter {
    namePathList = [];
    taskId = 0;
    watcherList = new Set();
    form;
    constructor(form){
        this.form = form;
    }
    register(callback) {
        this.watcherList.add(callback);
        return ()=>{
            this.watcherList.delete(callback);
        };
    }
    notify(namePath) {
        // Insert with deduplication
        namePath.forEach((path)=>{
            if (this.namePathList.every((exist)=>!(0, _valueUtil.matchNamePath)(exist, path))) this.namePathList.push(path);
        });
        this.doBatch();
    }
    doBatch() {
        this.taskId += 1;
        const currentId = this.taskId;
        macroTask(()=>{
            if (currentId === this.taskId && this.watcherList.size) {
                const formInst = this.form.getForm();
                const values = formInst.getFieldsValue();
                const allValues = formInst.getFieldsValue(true);
                this.watcherList.forEach((callback)=>{
                    callback(values, allValues, this.namePathList);
                });
                this.namePathList = [];
            }
        });
    }
}
exports.default = WatcherCenter;

},{"../utils/valueUtil":"hcjiP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2vlO2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useForm = require("./hooks/useForm");
var _useFormDefault = parcelHelpers.interopDefault(_useForm);
var _fieldContext = require("./FieldContext");
var _fieldContextDefault = parcelHelpers.interopDefault(_fieldContext);
var _formContext = require("./FormContext");
var _formContextDefault = parcelHelpers.interopDefault(_formContext);
var _valueUtil = require("./utils/valueUtil");
var _listContext = require("./ListContext");
var _listContextDefault = parcelHelpers.interopDefault(_listContext);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Form = ({ name, initialValues, fields, form, preserve, children, component: Component = 'form', validateMessages, validateTrigger = 'onChange', onValuesChange, onFieldsChange, onFinish, onFinishFailed, clearOnDestroy, ...restProps }, ref)=>{
    const nativeElementRef = _react.useRef(null);
    const formContext = _react.useContext((0, _formContextDefault.default));
    // We customize handle event since Context will makes all the consumer re-render:
    // https://reactjs.org/docs/context.html#contextprovider
    const [formInstance] = (0, _useFormDefault.default)(form);
    const { useSubscribe, setInitialValues, setCallbacks, setValidateMessages, setPreserve, destroyForm } = formInstance.getInternalHooks((0, _fieldContext.HOOK_MARK));
    // Pass ref with form instance
    _react.useImperativeHandle(ref, ()=>({
            ...formInstance,
            nativeElement: nativeElementRef.current
        }));
    // Register form into Context
    _react.useEffect(()=>{
        formContext.registerForm(name, formInstance);
        return ()=>{
            formContext.unregisterForm(name);
        };
    }, [
        formContext,
        formInstance,
        name
    ]);
    // Pass props to store
    setValidateMessages({
        ...formContext.validateMessages,
        ...validateMessages
    });
    setCallbacks({
        onValuesChange,
        onFieldsChange: (changedFields, ...rest)=>{
            formContext.triggerFormChange(name, changedFields);
            if (onFieldsChange) onFieldsChange(changedFields, ...rest);
        },
        onFinish: (values)=>{
            formContext.triggerFormFinish(name, values);
            if (onFinish) onFinish(values);
        },
        onFinishFailed
    });
    setPreserve(preserve);
    // Set initial value, init store value when first mount
    const mountRef = _react.useRef(null);
    setInitialValues(initialValues, !mountRef.current);
    if (!mountRef.current) mountRef.current = true;
    // ========================== Unmount ===========================
    _react.useEffect(()=>()=>destroyForm(clearOnDestroy), // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    // Prepare children by `children` type
    let childrenNode;
    const childrenRenderProps = typeof children === 'function';
    if (childrenRenderProps) {
        const values = formInstance.getFieldsValue(true);
        childrenNode = children(values, formInstance);
    } else childrenNode = children;
    // Not use subscribe when using render props
    useSubscribe(!childrenRenderProps);
    // Listen if fields provided. We use ref to save prev data here to avoid additional render
    const prevFieldsRef = _react.useRef(null);
    _react.useEffect(()=>{
        if (!(0, _valueUtil.isSimilar)(prevFieldsRef.current || [], fields || [])) formInstance.setFields(fields || []);
        prevFieldsRef.current = fields;
    }, [
        fields,
        formInstance
    ]);
    // =========================== Render ===========================
    const formContextValue = _react.useMemo(()=>({
            ...formInstance,
            validateTrigger
        }), [
        formInstance,
        validateTrigger
    ]);
    const wrapperNode = /*#__PURE__*/ _react.createElement((0, _listContextDefault.default).Provider, {
        value: null
    }, /*#__PURE__*/ _react.createElement((0, _fieldContextDefault.default).Provider, {
        value: formContextValue
    }, childrenNode));
    if (Component === false) return wrapperNode;
    return /*#__PURE__*/ _react.createElement(Component, _extends({}, restProps, {
        ref: nativeElementRef,
        onSubmit: (event)=>{
            event.preventDefault();
            event.stopPropagation();
            formInstance.submit();
        },
        onReset: (event)=>{
            event.preventDefault();
            formInstance.resetFields();
            restProps.onReset?.(event);
        }
    }), wrapperNode);
};
exports.default = Form;

},{"react":"bmhQu","./hooks/useForm":"lwy6I","./FieldContext":"k8mze","./FormContext":"kZuvQ","./utils/valueUtil":"hcjiP","./ListContext":"9Y7SO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kZuvQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FormProvider", ()=>FormProvider);
var _react = require("react");
const FormContext = /*#__PURE__*/ _react.createContext({
    triggerFormChange: ()=>{},
    triggerFormFinish: ()=>{},
    registerForm: ()=>{},
    unregisterForm: ()=>{}
});
const FormProvider = ({ validateMessages, onFormChange, onFormFinish, children })=>{
    const formContext = _react.useContext(FormContext);
    const formsRef = _react.useRef({});
    return /*#__PURE__*/ _react.createElement(FormContext.Provider, {
        value: {
            ...formContext,
            validateMessages: {
                ...formContext.validateMessages,
                ...validateMessages
            },
            // =========================================================
            // =                  Global Form Control                  =
            // =========================================================
            triggerFormChange: (name, changedFields)=>{
                if (onFormChange) onFormChange(name, {
                    changedFields,
                    forms: formsRef.current
                });
                formContext.triggerFormChange(name, changedFields);
            },
            triggerFormFinish: (name, values)=>{
                if (onFormFinish) onFormFinish(name, {
                    values,
                    forms: formsRef.current
                });
                formContext.triggerFormFinish(name, values);
            },
            registerForm: (name, form)=>{
                if (name) formsRef.current = {
                    ...formsRef.current,
                    [name]: form
                };
                formContext.registerForm(name, form);
            },
            unregisterForm: (name)=>{
                const newForms = {
                    ...formsRef.current
                };
                delete newForms[name];
                formsRef.current = newForms;
                formContext.unregisterForm(name);
            }
        }
    }, children);
};
exports.default = FormContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5TkwY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "stringify", ()=>stringify);
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _react = require("react");
var _fieldContext = require("../FieldContext");
var _fieldContextDefault = parcelHelpers.interopDefault(_fieldContext);
var _typeUtil = require("../utils/typeUtil");
var _valueUtil = require("../utils/valueUtil");
var _util = require("@rc-component/util");
function stringify(value) {
    try {
        return JSON.stringify(value);
    } catch  {
        return Math.random();
    }
}
// ------- selector type -------
// ------- selector type end -------
function useWatch(...args) {
    const [dependencies, _form = {}] = args;
    const options = (0, _typeUtil.isFormInstance)(_form) ? {
        form: _form
    } : _form;
    const form = options.form;
    const [value, setValue] = (0, _react.useState)(()=>typeof dependencies === 'function' ? dependencies({}) : undefined);
    const valueStr = (0, _react.useMemo)(()=>stringify(value), [
        value
    ]);
    const valueStrRef = (0, _react.useRef)(valueStr);
    valueStrRef.current = valueStr;
    const fieldContext = (0, _react.useContext)((0, _fieldContextDefault.default));
    const formInstance = form || fieldContext;
    const isValidForm = formInstance && formInstance._init;
    // ============================== Form ==============================
    const { getFieldsValue, getInternalHooks } = formInstance;
    const { registerWatch } = getInternalHooks((0, _fieldContext.HOOK_MARK));
    // ============================= Update =============================
    const triggerUpdate = (0, _util.useEvent)((values, allValues)=>{
        const watchValue = options.preserve ? allValues ?? getFieldsValue(true) : values ?? getFieldsValue();
        const nextValue = typeof dependencies === 'function' ? dependencies(watchValue) : (0, _valueUtil.getValue)(watchValue, (0, _valueUtil.getNamePath)(dependencies));
        if (stringify(value) !== stringify(nextValue)) setValue(nextValue);
    });
    // ============================= Effect =============================
    const flattenDeps = typeof dependencies === 'function' ? dependencies : JSON.stringify(dependencies);
    // Deps changed
    (0, _react.useEffect)(()=>{
        // Skip if not exist form instance
        if (!isValidForm) return;
        triggerUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidForm,
        flattenDeps
    ]);
    // Value changed
    (0, _react.useEffect)(()=>{
        // Skip if not exist form instance
        if (!isValidForm) return;
        const cancelRegister = registerWatch((values, allValues)=>{
            triggerUpdate(values, allValues);
        });
        return cancelRegister;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isValidForm
    ]);
    return value;
}
exports.default = useWatch;

},{"@rc-component/util/es/warning":"hJXDS","react":"bmhQu","../FieldContext":"k8mze","../utils/typeUtil":"jWjE0","../utils/valueUtil":"hcjiP","@rc-component/util":"6ZBDN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cOSpV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpaceCompactItemContext", ()=>SpaceCompactItemContext);
parcelHelpers.export(exports, "useCompactItemContext", ()=>useCompactItemContext);
parcelHelpers.export(exports, "NoCompactStyle", ()=>NoCompactStyle);
var _react = require("react");
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _warning = require("../_util/warning");
var _configProvider = require("../config-provider");
var _useSize = require("../config-provider/hooks/useSize");
var _useSizeDefault = parcelHelpers.interopDefault(_useSize);
var _compact = require("./style/compact");
var _compactDefault = parcelHelpers.interopDefault(_compact);
"use client";
const SpaceCompactItemContext = /*#__PURE__*/ _react.createContext(null);
const useCompactItemContext = (prefixCls, direction)=>{
    const compactItemContext = _react.useContext(SpaceCompactItemContext);
    const compactItemClassnames = _react.useMemo(()=>{
        if (!compactItemContext) return '';
        const { compactDirection, isFirstItem, isLastItem } = compactItemContext;
        const separator = compactDirection === 'vertical' ? '-vertical-' : '-';
        return (0, _clsx.clsx)(`${prefixCls}-compact${separator}item`, {
            [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
            [`${prefixCls}-compact${separator}last-item`]: isLastItem,
            [`${prefixCls}-compact${separator}item-rtl`]: direction === 'rtl'
        });
    }, [
        prefixCls,
        direction,
        compactItemContext
    ]);
    return {
        compactSize: compactItemContext?.compactSize,
        compactDirection: compactItemContext?.compactDirection,
        compactItemClassnames
    };
};
const NoCompactStyle = (props)=>{
    const { children } = props;
    return /*#__PURE__*/ _react.createElement(SpaceCompactItemContext.Provider, {
        value: null
    }, children);
};
const CompactItem = (props)=>{
    const { children, ...others } = props;
    return /*#__PURE__*/ _react.createElement(SpaceCompactItemContext.Provider, {
        value: _react.useMemo(()=>others, [
            others
        ])
    }, children);
};
const Compact = (props)=>{
    const { getPrefixCls, direction: directionConfig } = _react.useContext((0, _configProvider.ConfigContext));
    const { size, direction, orientation, block, prefixCls: customizePrefixCls, className, rootClassName, children, vertical, ...restProps } = props;
    const [mergedOrientation, mergedVertical] = (0, _hooks.useOrientation)(orientation, vertical, direction);
    const mergedSize = (0, _useSizeDefault.default)((ctx)=>size ?? ctx);
    const prefixCls = getPrefixCls('space-compact', customizePrefixCls);
    const [hashId] = (0, _compactDefault.default)(prefixCls);
    const clx = (0, _clsx.clsx)(prefixCls, hashId, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-vertical`]: mergedVertical
    }, className, rootClassName);
    const compactItemContext = _react.useContext(SpaceCompactItemContext);
    const childNodes = (0, _util.toArray)(children);
    const nodes = _react.useMemo(()=>childNodes.map((child, i)=>{
            const key = child?.key || `${prefixCls}-item-${i}`;
            return /*#__PURE__*/ _react.createElement(CompactItem, {
                key: key,
                compactSize: mergedSize,
                compactDirection: mergedOrientation,
                isFirstItem: i === 0 && (!compactItemContext || compactItemContext?.isFirstItem),
                isLastItem: i === childNodes.length - 1 && (!compactItemContext || compactItemContext?.isLastItem)
            }, child);
        }), [
        childNodes,
        compactItemContext,
        mergedOrientation,
        mergedSize,
        prefixCls
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    return /*#__PURE__*/ _react.createElement("div", {
        className: clx,
        ...restProps
    }, nodes);
};
exports.default = Compact;

},{"react":"bmhQu","@rc-component/util":"6ZBDN","clsx":"431Ou","../_util/hooks":"k313C","../_util/warning":"95o3w","../config-provider":"dVeAX","../config-provider/hooks/useSize":"gXe6G","./style/compact":"3nSQX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dVeAX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Variants", ()=>(0, _context3.Variants));
parcelHelpers.export(exports, "warnContext", ()=>warnContext);
parcelHelpers.export(exports, "ConfigConsumer", ()=>(0, _context3.ConfigConsumer));
parcelHelpers.export(exports, "ConfigContext", ()=>(0, _context3.ConfigContext));
parcelHelpers.export(exports, "defaultIconPrefixCls", ()=>(0, _context3.defaultIconPrefixCls));
parcelHelpers.export(exports, "defaultPrefixCls", ()=>(0, _context3.defaultPrefixCls));
parcelHelpers.export(exports, "configConsumerProps", ()=>configConsumerProps);
parcelHelpers.export(exports, "globalConfig", ()=>globalConfig);
var _react = require("react");
var _cssinjs = require("@ant-design/cssinjs");
var _context = require("@ant-design/icons/es/components/Context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _util = require("@rc-component/util");
var _useMemo = require("@rc-component/util/es/hooks/useMemo");
var _useMemoDefault = parcelHelpers.interopDefault(_useMemo);
var _warning = require("../_util/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _validateMessagesContext = require("../form/validateMessagesContext");
var _validateMessagesContextDefault = parcelHelpers.interopDefault(_validateMessagesContext);
var _locale = require("../locale");
var _localeDefault = parcelHelpers.interopDefault(_locale);
var _context1 = require("../locale/context");
var _contextDefault1 = parcelHelpers.interopDefault(_context1);
var _enUS = require("../locale/en_US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
var _context2 = require("../theme/context");
var _seed = require("../theme/themes/seed");
var _seedDefault = parcelHelpers.interopDefault(_seed);
var _uniqueProvider = require("../tooltip/UniqueProvider");
var _uniqueProviderDefault = parcelHelpers.interopDefault(_uniqueProvider);
var _context3 = require("./context");
var _disabledContext = require("./DisabledContext");
var _useConfig = require("./hooks/useConfig");
var _useConfigDefault = parcelHelpers.interopDefault(_useConfig);
var _useTheme = require("./hooks/useTheme");
var _useThemeDefault = parcelHelpers.interopDefault(_useTheme);
var _motionWrapper = require("./MotionWrapper");
var _motionWrapperDefault = parcelHelpers.interopDefault(_motionWrapper);
var _propWarning = require("./PropWarning");
var _propWarningDefault = parcelHelpers.interopDefault(_propWarning);
var _sizeContext = require("./SizeContext");
var _sizeContextDefault = parcelHelpers.interopDefault(_sizeContext);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
/**
 * Since too many feedback using static method like `Modal.confirm` not getting theme, we record the
 * theme register info here to help developer get warning info.
 */ let existThemeConfig = false;
const warnContext = /* istanbul ignore next */ null;
const configConsumerProps = [
    'getTargetContainer',
    'getPopupContainer',
    'rootPrefixCls',
    'getPrefixCls',
    'renderEmpty',
    'csp',
    'autoInsertSpaceInButton',
    'locale'
];
// These props is used by `useContext` directly in sub component
const PASSED_PROPS = [
    'getTargetContainer',
    'getPopupContainer',
    'renderEmpty',
    'input',
    'pagination',
    'form',
    'select',
    'button'
];
let globalPrefixCls;
let globalIconPrefixCls;
let globalTheme;
let globalHolderRender;
function getGlobalPrefixCls() {
    return globalPrefixCls || (0, _context3.defaultPrefixCls);
}
function getGlobalIconPrefixCls() {
    return globalIconPrefixCls || (0, _context3.defaultIconPrefixCls);
}
const setGlobalConfig = (props)=>{
    const { prefixCls, iconPrefixCls, theme, holderRender } = props;
    if (prefixCls !== undefined) globalPrefixCls = prefixCls;
    if (iconPrefixCls !== undefined) globalIconPrefixCls = iconPrefixCls;
    if ('holderRender' in props) globalHolderRender = holderRender;
    if (theme) globalTheme = theme;
};
const globalConfig = ()=>({
        getPrefixCls: (suffixCls, customizePrefixCls)=>{
            if (customizePrefixCls) return customizePrefixCls;
            return suffixCls ? `${getGlobalPrefixCls()}-${suffixCls}` : getGlobalPrefixCls();
        },
        getIconPrefixCls: getGlobalIconPrefixCls,
        getRootPrefixCls: ()=>{
            // If Global prefixCls provided, use this
            if (globalPrefixCls) return globalPrefixCls;
            // Fallback to default prefixCls
            return getGlobalPrefixCls();
        },
        getTheme: ()=>globalTheme,
        holderRender: globalHolderRender
    });
const ProviderChildren = (props)=>{
    const { children, csp: customCsp, autoInsertSpaceInButton, alert, affix, anchor, form, locale, componentSize, direction, space, splitter, virtual, dropdownMatchSelectWidth, popupMatchSelectWidth, popupOverflow, legacyLocale, parentContext, iconPrefixCls: customIconPrefixCls, theme, componentDisabled, segmented, statistic, spin, calendar, carousel, cascader, collapse, typography, checkbox, descriptions, divider, drawer, skeleton, steps, image, layout, list, mentions, modal, progress, result, slider, breadcrumb, masonry, menu, pagination, input, textArea, otp, empty, badge, radio, rate, ribbon, switch: SWITCH, transfer, avatar, message, tag, table, card, cardMeta, tabs, timeline, timePicker, upload, notification, tree, colorPicker, datePicker, rangePicker, flex, wave, dropdown, warning: warningConfig, tour, tooltip, popover, popconfirm, qrcode, floatButton, floatButtonGroup, variant, inputNumber, treeSelect, watermark } = props;
    // =================================== Context ===================================
    const getPrefixCls = _react.useCallback((suffixCls, customizePrefixCls)=>{
        const { prefixCls } = props;
        if (customizePrefixCls) return customizePrefixCls;
        const mergedPrefixCls = prefixCls || parentContext.getPrefixCls('');
        return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
    }, [
        parentContext.getPrefixCls,
        props.prefixCls
    ]);
    const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || (0, _context3.defaultIconPrefixCls);
    const csp = customCsp || parentContext.csp;
    (0, _styleDefault.default)(iconPrefixCls, csp);
    const mergedTheme = (0, _useThemeDefault.default)(theme, parentContext.theme, {
        prefixCls: getPrefixCls('')
    });
    const baseConfig = {
        csp,
        autoInsertSpaceInButton,
        alert,
        affix,
        anchor,
        locale: locale || legacyLocale,
        direction,
        space,
        splitter,
        virtual,
        popupMatchSelectWidth: popupMatchSelectWidth ?? dropdownMatchSelectWidth,
        popupOverflow,
        getPrefixCls,
        iconPrefixCls,
        theme: mergedTheme,
        segmented,
        statistic,
        spin,
        calendar,
        carousel,
        cascader,
        collapse,
        typography,
        checkbox,
        descriptions,
        divider,
        drawer,
        skeleton,
        steps,
        image,
        input,
        textArea,
        otp,
        layout,
        list,
        mentions,
        modal,
        progress,
        result,
        slider,
        breadcrumb,
        masonry,
        menu,
        pagination,
        empty,
        badge,
        radio,
        rate,
        ribbon,
        switch: SWITCH,
        transfer,
        avatar,
        message,
        tag,
        table,
        card,
        cardMeta,
        tabs,
        timeline,
        timePicker,
        upload,
        notification,
        tree,
        colorPicker,
        datePicker,
        rangePicker,
        flex,
        wave,
        dropdown,
        warning: warningConfig,
        tour,
        tooltip,
        popover,
        popconfirm,
        qrcode,
        floatButton,
        floatButtonGroup,
        variant,
        inputNumber,
        treeSelect,
        watermark
    };
    const config = {
        ...parentContext
    };
    Object.keys(baseConfig).forEach((key)=>{
        if (baseConfig[key] !== undefined) config[key] = baseConfig[key];
    });
    // Pass the props used by `useContext` directly with child component.
    // These props should merged into `config`.
    PASSED_PROPS.forEach((propName)=>{
        const propValue = props[propName];
        if (propValue) config[propName] = propValue;
    });
    if (typeof autoInsertSpaceInButton !== 'undefined') // merge deprecated api
    config.button = {
        autoInsertSpace: autoInsertSpaceInButton,
        ...config.button
    };
    // https://github.com/ant-design/ant-design/issues/27617
    const memoedConfig = (0, _useMemoDefault.default)(()=>config, config, (prevConfig, currentConfig)=>{
        const prevKeys = Object.keys(prevConfig);
        const currentKeys = Object.keys(currentConfig);
        return prevKeys.length !== currentKeys.length || prevKeys.some((key)=>prevConfig[key] !== currentConfig[key]);
    });
    const { layer } = _react.useContext((0, _cssinjs.StyleContext));
    const memoIconContextValue = _react.useMemo(()=>({
            prefixCls: iconPrefixCls,
            csp,
            layer: layer ? 'antd' : undefined
        }), [
        iconPrefixCls,
        csp,
        layer
    ]);
    let childNode = /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _propWarningDefault.default), {
        dropdownMatchSelectWidth: dropdownMatchSelectWidth
    }), children);
    const validateMessages = _react.useMemo(()=>(0, _util.merge)((0, _enUSDefault.default).Form?.defaultValidateMessages || {}, memoedConfig.locale?.Form?.defaultValidateMessages || {}, memoedConfig.form?.validateMessages || {}, form?.validateMessages || {}), [
        memoedConfig,
        form?.validateMessages
    ]);
    if (Object.keys(validateMessages).length > 0) childNode = /*#__PURE__*/ _react.createElement((0, _validateMessagesContextDefault.default).Provider, {
        value: validateMessages
    }, childNode);
    if (locale) childNode = /*#__PURE__*/ _react.createElement((0, _localeDefault.default), {
        locale: locale,
        _ANT_MARK__: (0, _locale.ANT_MARK)
    }, childNode);
    if (iconPrefixCls || csp) childNode = /*#__PURE__*/ _react.createElement((0, _contextDefault.default).Provider, {
        value: memoIconContextValue
    }, childNode);
    if (componentSize) childNode = /*#__PURE__*/ _react.createElement((0, _sizeContext.SizeContextProvider), {
        size: componentSize
    }, childNode);
    // =================================== Motion ===================================
    childNode = /*#__PURE__*/ _react.createElement((0, _motionWrapperDefault.default), null, childNode);
    // ================================ Tooltip Unique ===============================
    if (tooltip?.unique) childNode = /*#__PURE__*/ _react.createElement((0, _uniqueProviderDefault.default), null, childNode);
    // ================================ Dynamic theme ================================
    const memoTheme = _react.useMemo(()=>{
        const { algorithm, token, components, cssVar, ...rest } = mergedTheme || {};
        const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? (0, _cssinjs.createTheme)(algorithm) : (0, _context2.defaultTheme);
        const parsedComponents = {};
        Object.entries(components || {}).forEach(([componentName, componentToken])=>{
            const parsedToken = {
                ...componentToken
            };
            if ('algorithm' in parsedToken) {
                if (parsedToken.algorithm === true) parsedToken.theme = themeObj;
                else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === 'function') parsedToken.theme = (0, _cssinjs.createTheme)(parsedToken.algorithm);
                delete parsedToken.algorithm;
            }
            parsedComponents[componentName] = parsedToken;
        });
        const mergedToken = {
            ...(0, _seedDefault.default),
            ...token
        };
        return {
            ...rest,
            theme: themeObj,
            token: mergedToken,
            components: parsedComponents,
            override: {
                override: mergedToken,
                ...parsedComponents
            },
            cssVar
        };
    }, [
        mergedTheme
    ]);
    if (theme) childNode = /*#__PURE__*/ _react.createElement((0, _context2.DesignTokenContext).Provider, {
        value: memoTheme
    }, childNode);
    // ================================== Warning ===================================
    if (memoedConfig.warning) childNode = /*#__PURE__*/ _react.createElement((0, _warning.WarningContext).Provider, {
        value: memoedConfig.warning
    }, childNode);
    // =================================== Render ===================================
    if (componentDisabled !== undefined) childNode = /*#__PURE__*/ _react.createElement((0, _disabledContext.DisabledContextProvider), {
        disabled: componentDisabled
    }, childNode);
    return /*#__PURE__*/ _react.createElement((0, _context3.ConfigContext).Provider, {
        value: memoedConfig
    }, childNode);
};
const ConfigProvider = (props)=>{
    const context = _react.useContext((0, _context3.ConfigContext));
    const antLocale = _react.useContext((0, _contextDefault1.default));
    return /*#__PURE__*/ _react.createElement(ProviderChildren, {
        parentContext: context,
        legacyLocale: antLocale,
        ...props
    });
};
ConfigProvider.ConfigContext = (0, _context3.ConfigContext);
ConfigProvider.SizeContext = (0, _sizeContextDefault.default);
ConfigProvider.config = setGlobalConfig;
ConfigProvider.useConfig = (0, _useConfigDefault.default);
Object.defineProperty(ConfigProvider, 'SizeContext', {
    get: ()=>{
        return 0, _sizeContextDefault.default;
    }
});
exports.default = ConfigProvider;

},{"react":"bmhQu","@ant-design/cssinjs":"2VNL8","@ant-design/icons/es/components/Context":"112Bq","@rc-component/util":"6ZBDN","@rc-component/util/es/hooks/useMemo":"8LJN8","../_util/warning":"95o3w","../form/validateMessagesContext":"hiF2w","../locale":"bXgWZ","../locale/context":"l4UXv","../locale/en_US":"cgwsy","../theme/context":[["defaultTheme","ia1Cg","default"],["DesignTokenContext","25Z4W"]],"../theme/themes/seed":"aeTHW","../tooltip/UniqueProvider":"5ZqU0","./context":"75zwC","./DisabledContext":"h4TcW","./hooks/useConfig":"jkHDn","./hooks/useTheme":"4khBk","./MotionWrapper":"20zJD","./PropWarning":"kZqoG","./SizeContext":"jlQPx","./style":"4Ccbk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2VNL8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Theme", ()=>(0, _theme.Theme));
parcelHelpers.export(exports, "createTheme", ()=>(0, _theme.createTheme));
parcelHelpers.export(exports, "useStyleRegister", ()=>(0, _useStyleRegisterDefault.default));
parcelHelpers.export(exports, "useCSSVarRegister", ()=>(0, _useCSSVarRegisterDefault.default));
parcelHelpers.export(exports, "useCacheToken", ()=>(0, _useCacheTokenDefault.default));
parcelHelpers.export(exports, "createCache", ()=>(0, _styleContext.createCache));
parcelHelpers.export(exports, "StyleProvider", ()=>(0, _styleContext.StyleProvider));
parcelHelpers.export(exports, "StyleContext", ()=>(0, _styleContextDefault.default));
parcelHelpers.export(exports, "Keyframes", ()=>(0, _keyframesDefault.default));
parcelHelpers.export(exports, "extractStyle", ()=>(0, _extractStyleDefault.default));
parcelHelpers.export(exports, "getComputedToken", ()=>(0, _useCacheToken.getComputedToken));
parcelHelpers.export(exports, "autoPrefixTransformer", ()=>// Transformer
    (0, _autoPrefixDefault.default));
parcelHelpers.export(exports, "legacyLogicalPropertiesTransformer", ()=>(0, _legacyLogicalPropertiesDefault.default));
parcelHelpers.export(exports, "px2remTransformer", ()=>(0, _px2RemDefault.default));
parcelHelpers.export(exports, "logicalPropertiesLinter", ()=>// Linters
    (0, _linters.logicalPropertiesLinter));
parcelHelpers.export(exports, "legacyNotSelectorLinter", ()=>(0, _linters.legacyNotSelectorLinter));
parcelHelpers.export(exports, "parentSelectorLinter", ()=>(0, _linters.parentSelectorLinter));
parcelHelpers.export(exports, "NaNLinter", ()=>(0, _linters.NaNLinter));
parcelHelpers.export(exports, "token2CSSVar", ()=>// util
    (0, _cssVariables.token2CSSVar));
parcelHelpers.export(exports, "unit", ()=>(0, _util.unit));
parcelHelpers.export(exports, "genCalc", ()=>(0, _theme.genCalc));
parcelHelpers.export(exports, "_experimental", ()=>_experimental);
var _extractStyle = require("./extractStyle");
var _extractStyleDefault = parcelHelpers.interopDefault(_extractStyle);
var _useCacheToken = require("./hooks/useCacheToken");
var _useCacheTokenDefault = parcelHelpers.interopDefault(_useCacheToken);
var _useCSSVarRegister = require("./hooks/useCSSVarRegister");
var _useCSSVarRegisterDefault = parcelHelpers.interopDefault(_useCSSVarRegister);
var _useStyleRegister = require("./hooks/useStyleRegister");
var _useStyleRegisterDefault = parcelHelpers.interopDefault(_useStyleRegister);
var _keyframes = require("./Keyframes");
var _keyframesDefault = parcelHelpers.interopDefault(_keyframes);
var _linters = require("./linters");
var _styleContext = require("./StyleContext");
var _styleContextDefault = parcelHelpers.interopDefault(_styleContext);
var _theme = require("./theme");
var _autoPrefix = require("./transformers/autoPrefix");
var _autoPrefixDefault = parcelHelpers.interopDefault(_autoPrefix);
var _legacyLogicalProperties = require("./transformers/legacyLogicalProperties");
var _legacyLogicalPropertiesDefault = parcelHelpers.interopDefault(_legacyLogicalProperties);
var _px2Rem = require("./transformers/px2rem");
var _px2RemDefault = parcelHelpers.interopDefault(_px2Rem);
var _util = require("./util");
var _cssVariables = require("./util/css-variables");
const _experimental = {
    supportModernCSS: ()=>(0, _util.supportWhere)() && (0, _util.supportLogicProps)()
};

},{"./extractStyle":"4w4FK","./hooks/useCacheToken":"37agy","./hooks/useCSSVarRegister":"lN11C","./hooks/useStyleRegister":"kzwtR","./Keyframes":"2BRAF","./linters":"hCOnc","./StyleContext":"bAgk8","./theme":"3CH0P","./transformers/autoPrefix":"70iQ0","./transformers/legacyLogicalProperties":"lvjDq","./transformers/px2rem":"joY72","./util":"oHhSW","./util/css-variables":"cr28T","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4w4FK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>extractStyle);
var _useCacheToken = require("./hooks/useCacheToken");
var _useCSSVarRegister = require("./hooks/useCSSVarRegister");
var _useStyleRegister = require("./hooks/useStyleRegister");
var _util = require("./util");
var _cacheMapUtil = require("./util/cacheMapUtil");
const ExtractStyleFns = {
    [(0, _useStyleRegister.STYLE_PREFIX)]: (0, _useStyleRegister.extract),
    [(0, _useCacheToken.TOKEN_PREFIX)]: (0, _useCacheToken.extract),
    [(0, _useCSSVarRegister.CSS_VAR_PREFIX)]: (0, _useCSSVarRegister.extract)
};
function isNotNull(value) {
    return value !== null;
}
function extractStyle(cache, options) {
    const { plain = false, types = [
        'style',
        'token',
        'cssVar'
    ], once = false } = typeof options === 'boolean' ? {
        plain: options
    } : options || {};
    const matchPrefixRegexp = new RegExp(`^(${(typeof types === 'string' ? [
        types
    ] : types).join('|')})%`);
    // prefix with `style` is used for `useStyleRegister` to cache style context
    const styleKeys = Array.from(cache.cache.keys()).filter((key)=>matchPrefixRegexp.test(key));
    // Common effect styles like animation
    const effectStyles = {};
    // Mapping of cachePath to style hash
    const cachePathMap = {};
    let styleText = '';
    styleKeys.map((key)=>{
        if (once && cache.extracted.has(key)) return null; // Skip if already extracted
        const cachePath = key.replace(matchPrefixRegexp, '').replace(/%/g, '|');
        const [prefix] = key.split('%');
        const extractFn = ExtractStyleFns[prefix];
        const extractedStyle = extractFn(cache.cache.get(key)[1], effectStyles, {
            plain
        });
        if (!extractedStyle) return null;
        const updateTime = cache.updateTimes.get(key) || 0;
        const [order, styleId, styleStr] = extractedStyle;
        if (key.startsWith('style')) cachePathMap[cachePath] = styleId;
        // record that this style has been extracted
        cache.extracted.add(key);
        return [
            order,
            styleStr,
            updateTime
        ];
    }).filter(isNotNull).sort(([o1, , u1], [o2, , u2])=>{
        if (o1 !== o2) return o1 - o2;
        return u1 - u2;
    }).forEach(([, style])=>{
        styleText += style;
    });
    // ==================== Fill Cache Path ====================
    styleText += (0, _util.toStyleStr)(`.${(0, _cacheMapUtil.ATTR_CACHE_MAP)}{content:"${(0, _cacheMapUtil.serialize)(cachePathMap)}";}`, undefined, undefined, {
        [(0, _cacheMapUtil.ATTR_CACHE_MAP)]: (0, _cacheMapUtil.ATTR_CACHE_MAP)
    }, plain);
    return styleText;
}

},{"./hooks/useCacheToken":"37agy","./hooks/useCSSVarRegister":"lN11C","./hooks/useStyleRegister":"kzwtR","./util":"oHhSW","./util/cacheMapUtil":"5Ya3U","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"37agy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getComputedToken", ()=>getComputedToken);
parcelHelpers.export(exports, "TOKEN_PREFIX", ()=>TOKEN_PREFIX);
parcelHelpers.export(exports, "default", ()=>useCacheToken);
parcelHelpers.export(exports, "extract", ()=>extract);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _dynamicCSS = require("@rc-component/util/es/Dom/dynamicCSS");
var _react = require("react");
var _styleContext = require("../StyleContext");
var _styleContextDefault = parcelHelpers.interopDefault(_styleContext);
var _util = require("../util");
var _cssVariables = require("../util/css-variables");
var _useGlobalCache = require("./useGlobalCache");
var _useGlobalCacheDefault = parcelHelpers.interopDefault(_useGlobalCache);
const EMPTY_OVERRIDE = {};
// Generate different prefix to make user selector break in production env.
// This helps developer not to do style override directly on the hash id.
const hashPrefix = 'css';
const tokenKeys = new Map();
function recordCleanToken(tokenKey) {
    tokenKeys.set(tokenKey, (tokenKeys.get(tokenKey) || 0) + 1);
}
function removeStyleTags(key, instanceId) {
    if (typeof document !== 'undefined') {
        const styles = document.querySelectorAll(`style[${(0, _styleContext.ATTR_TOKEN)}="${key}"]`);
        styles.forEach((style)=>{
            if (style[0, _styleContext.CSS_IN_JS_INSTANCE] === instanceId) style.parentNode?.removeChild(style);
        });
    }
}
const TOKEN_THRESHOLD = -1;
// Remove will check current keys first
function cleanTokenStyle(tokenKey, instanceId) {
    tokenKeys.set(tokenKey, (tokenKeys.get(tokenKey) || 0) - 1);
    const cleanableKeyList = new Set();
    tokenKeys.forEach((value, key)=>{
        if (value <= 0) cleanableKeyList.add(key);
    });
    // Should keep tokens under threshold for not to insert style too often
    if (tokenKeys.size - cleanableKeyList.size > TOKEN_THRESHOLD) cleanableKeyList.forEach((key)=>{
        removeStyleTags(key, instanceId);
        tokenKeys.delete(key);
    });
}
const getComputedToken = (originToken, overrideToken, theme, format)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    // Merge with override
    let mergedDerivativeToken = {
        ...derivativeToken,
        ...overrideToken
    };
    // Format if needed
    if (format) mergedDerivativeToken = format(mergedDerivativeToken);
    return mergedDerivativeToken;
};
const TOKEN_PREFIX = 'token';
function useCacheToken(theme, tokens, option) {
    const { cache: { instanceId }, container, hashPriority } = (0, _react.useContext)((0, _styleContextDefault.default));
    const { salt = '', override = EMPTY_OVERRIDE, formatToken, getComputedToken: compute, cssVar } = option;
    // Basic - We do basic cache here
    const mergedToken = (0, _util.memoResult)(()=>Object.assign({}, ...tokens), tokens);
    const tokenStr = (0, _util.flattenToken)(mergedToken);
    const overrideTokenStr = (0, _util.flattenToken)(override);
    const cssVarStr = (0, _util.flattenToken)(cssVar);
    const cachedToken = (0, _useGlobalCacheDefault.default)(TOKEN_PREFIX, [
        salt,
        theme.id,
        tokenStr,
        overrideTokenStr,
        cssVarStr
    ], ()=>{
        const mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : getComputedToken(mergedToken, override, theme, formatToken);
        const actualToken = {
            ...mergedDerivativeToken
        };
        // Optimize for `useStyleRegister` performance
        const mergedSalt = `${salt}_${cssVar.prefix}`;
        const hashId = (0, _hashDefault.default)(mergedSalt);
        const hashCls = `${hashPrefix}-${(0, _hashDefault.default)(mergedSalt)}`;
        actualToken._tokenKey = (0, _util.token2key)(actualToken, mergedSalt);
        // Replace token value with css variables
        const [tokenWithCssVar, cssVarsStr] = (0, _cssVariables.transformToken)(mergedDerivativeToken, cssVar.key, {
            prefix: cssVar.prefix,
            ignore: cssVar.ignore,
            unitless: cssVar.unitless,
            preserve: cssVar.preserve,
            hashPriority,
            hashCls: cssVar.hashed ? hashCls : undefined
        });
        tokenWithCssVar._hashId = hashId;
        recordCleanToken(cssVar.key);
        return [
            tokenWithCssVar,
            hashCls,
            actualToken,
            cssVarsStr,
            cssVar.key
        ];
    }, ([, , , , themeKey])=>{
        // Remove token will remove all related style
        cleanTokenStyle(themeKey, instanceId);
    }, ([, , , cssVarsStr, themeKey])=>{
        if (!cssVarsStr) return;
        const style = (0, _dynamicCSS.updateCSS)(cssVarsStr, (0, _hashDefault.default)(`css-var-${themeKey}`), {
            mark: (0, _styleContext.ATTR_MARK),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        });
        style[0, _styleContext.CSS_IN_JS_INSTANCE] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, _styleContext.ATTR_TOKEN), themeKey);
    });
    return cachedToken;
}
const extract = (cache, effectStyles, options)=>{
    const [, , realToken, styleStr, cssVarKey] = cache;
    const { plain } = options || {};
    if (!styleStr) return null;
    const styleId = realToken._tokenKey;
    const order = -999;
    // ====================== Style ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    const styleText = (0, _util.toStyleStr)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};

},{"@emotion/hash":"geaOt","@rc-component/util/es/Dom/dynamicCSS":"3UDeI","react":"bmhQu","../StyleContext":"bAgk8","../util":"oHhSW","../util/css-variables":"cr28T","./useGlobalCache":"k38UD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"geaOt":[function(require,module,exports,__globalThis) {
/* eslint-disable */ // Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function murmur2(str) {
    // 'm' and 'r' are mixing constants generated offline.
    // They're not really 'magic', they just happen to work well.
    // const m = 0x5bd1e995;
    // const r = 24;
    // Initialize the hash
    var h = 0; // Mix 4 bytes at a time into the hash
    var k, i = 0, len = str.length;
    for(; len >= 4; ++i, len -= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
        k ^= /* k >>> r: */ k >>> 24;
        h = /* Math.imul(k, m): */ (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^ /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Handle the last few bytes of the input array
    switch(len){
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    } // Do a few final mixes of the hash to ensure the last few
    // bytes are well-incorporated.
    h ^= h >>> 13;
    h = /* Math.imul(h, m): */ (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
    return ((h ^ h >>> 15) >>> 0).toString(36);
}
exports.default = murmur2;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bAgk8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ATTR_TOKEN", ()=>ATTR_TOKEN);
parcelHelpers.export(exports, "ATTR_MARK", ()=>ATTR_MARK);
parcelHelpers.export(exports, "ATTR_CACHE_PATH", ()=>ATTR_CACHE_PATH);
parcelHelpers.export(exports, "CSS_IN_JS_INSTANCE", ()=>CSS_IN_JS_INSTANCE);
parcelHelpers.export(exports, "createCache", ()=>createCache);
parcelHelpers.export(exports, "StyleProvider", ()=>StyleProvider);
var _useMemo = require("@rc-component/util/es/hooks/useMemo");
var _useMemoDefault = parcelHelpers.interopDefault(_useMemo);
var _isEqual = require("@rc-component/util/es/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _react = require("react");
var _cache = require("./Cache");
var _cacheDefault = parcelHelpers.interopDefault(_cache);
var _autoPrefix = require("./transformers/autoPrefix");
const ATTR_TOKEN = 'data-token-hash';
const ATTR_MARK = 'data-css-hash';
const ATTR_CACHE_PATH = 'data-cache-path';
const CSS_IN_JS_INSTANCE = '__cssinjs_instance__';
function createCache() {
    const cssinjsInstanceId = Math.random().toString(12).slice(2);
    // Tricky SSR: Move all inline style to the head.
    // PS: We do not recommend tricky mode.
    if (typeof document !== 'undefined' && document.head && document.body) {
        const styles = document.body.querySelectorAll(`style[${ATTR_MARK}]`) || [];
        const { firstChild } = document.head;
        Array.from(styles).forEach((style)=>{
            style[CSS_IN_JS_INSTANCE] = style[CSS_IN_JS_INSTANCE] || cssinjsInstanceId;
            // Not force move if no head
            if (style[CSS_IN_JS_INSTANCE] === cssinjsInstanceId) document.head.insertBefore(style, firstChild);
        });
        // Deduplicate of moved styles
        const styleHash = {};
        Array.from(document.querySelectorAll(`style[${ATTR_MARK}]`)).forEach((style)=>{
            const hash = style.getAttribute(ATTR_MARK);
            if (styleHash[hash]) {
                if (style[CSS_IN_JS_INSTANCE] === cssinjsInstanceId) style.parentNode?.removeChild(style);
            } else styleHash[hash] = true;
        });
    }
    return new (0, _cacheDefault.default)(cssinjsInstanceId);
}
const StyleContext = /*#__PURE__*/ _react.createContext({
    hashPriority: 'low',
    cache: createCache(),
    defaultCache: true,
    autoPrefix: false
});
const StyleProvider = (props)=>{
    const { children, ...restProps } = props;
    const parentContext = _react.useContext(StyleContext);
    const context = (0, _useMemoDefault.default)(()=>{
        const mergedContext = {
            ...parentContext
        };
        Object.keys(restProps).forEach((key)=>{
            const value = restProps[key];
            if (restProps[key] !== undefined) mergedContext[key] = value;
        });
        const { cache, transformers = [] } = restProps;
        mergedContext.cache = mergedContext.cache || createCache();
        mergedContext.defaultCache = !cache && parentContext.defaultCache;
        // autoPrefix
        if (transformers.includes((0, _autoPrefix.AUTO_PREFIX))) mergedContext.autoPrefix = true;
        return mergedContext;
    }, [
        parentContext,
        restProps
    ], (prev, next)=>!(0, _isEqualDefault.default)(prev[0], next[0], true) || !(0, _isEqualDefault.default)(prev[1], next[1], true));
    return /*#__PURE__*/ _react.createElement(StyleContext.Provider, {
        value: context
    }, children);
};
exports.default = StyleContext;

},{"@rc-component/util/es/hooks/useMemo":"8LJN8","@rc-component/util/es/isEqual":"fBa27","react":"bmhQu","./Cache":"fILNr","./transformers/autoPrefix":"70iQ0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fILNr":[function(require,module,exports,__globalThis) {
// [times, realValue]
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/** Connect key with `SPLIT` */ parcelHelpers.export(exports, "pathKey", ()=>pathKey);
const SPLIT = '%';
function pathKey(keys) {
    return keys.join(SPLIT);
}
/** Record update id for extract static style order. */ let updateId = 0;
class Entity {
    instanceId;
    constructor(instanceId){
        this.instanceId = instanceId;
    }
    /** @private Internal cache map. Do not access this directly */ cache = new Map();
    /** @private Record update times for each key */ updateTimes = new Map();
    extracted = new Set();
    get(keys) {
        return this.opGet(pathKey(keys));
    }
    /** A fast get cache with `get` concat. */ opGet(keyPathStr) {
        return this.cache.get(keyPathStr) || null;
    }
    update(keys, valueFn) {
        return this.opUpdate(pathKey(keys), valueFn);
    }
    /** A fast get cache with `get` concat. */ opUpdate(keyPathStr, valueFn) {
        const prevValue = this.cache.get(keyPathStr);
        const nextValue = valueFn(prevValue);
        if (nextValue === null) {
            this.cache.delete(keyPathStr);
            this.updateTimes.delete(keyPathStr);
        } else {
            this.cache.set(keyPathStr, nextValue);
            this.updateTimes.set(keyPathStr, updateId);
            updateId += 1;
        }
    }
}
exports.default = Entity;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"70iQ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AUTO_PREFIX", ()=>AUTO_PREFIX);
const AUTO_PREFIX = {};
const transform = AUTO_PREFIX;
exports.default = transform;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"oHhSW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "memoResult", ()=>memoResult);
/**
 * Flatten token to string, this will auto cache the result when token not change
 */ parcelHelpers.export(exports, "flattenToken", ()=>flattenToken);
/**
 * Convert derivative token to key string
 */ parcelHelpers.export(exports, "token2key", ()=>token2key);
parcelHelpers.export(exports, "supportLayer", ()=>supportLayer);
parcelHelpers.export(exports, "supportWhere", ()=>supportWhere);
parcelHelpers.export(exports, "supportLogicProps", ()=>supportLogicProps);
parcelHelpers.export(exports, "isClientSide", ()=>isClientSide);
parcelHelpers.export(exports, "unit", ()=>unit);
parcelHelpers.export(exports, "toStyleStr", ()=>toStyleStr);
parcelHelpers.export(exports, "where", ()=>where);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _canUseDom = require("@rc-component/util/es/Dom/canUseDom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
var _dynamicCSS = require("@rc-component/util/es/Dom/dynamicCSS");
var _styleContext = require("../StyleContext");
var _theme = require("../theme");
// Create a cache for memo concat
const resultCache = new WeakMap();
const RESULT_VALUE = {};
function memoResult(callback, deps) {
    let current = resultCache;
    for(let i = 0; i < deps.length; i += 1){
        const dep = deps[i];
        if (!current.has(dep)) current.set(dep, new WeakMap());
        current = current.get(dep);
    }
    if (!current.has(RESULT_VALUE)) current.set(RESULT_VALUE, callback());
    return current.get(RESULT_VALUE);
}
// Create a cache here to avoid always loop generate
const flattenTokenCache = new WeakMap();
function flattenToken(token) {
    let str = flattenTokenCache.get(token) || '';
    if (!str) {
        Object.keys(token).forEach((key)=>{
            const value = token[key];
            str += key;
            if (value instanceof (0, _theme.Theme)) str += value.id;
            else if (value && typeof value === 'object') str += flattenToken(value);
            else str += value;
        });
        // https://github.com/ant-design/ant-design/issues/48386
        // Should hash the string to avoid style tag name too long
        str = (0, _hashDefault.default)(str);
        // Put in cache
        flattenTokenCache.set(token, str);
    }
    return str;
}
function token2key(token, salt) {
    return (0, _hashDefault.default)(`${salt}_${flattenToken(token)}`);
}
const randomSelectorKey = `random-${Date.now()}-${Math.random()}`.replace(/\./g, '');
// Magic `content` for detect selector support
const checkContent = '_bAmBoO_';
function supportSelector(styleStr, handleElement, supportCheck) {
    if ((0, _canUseDomDefault.default)()) {
        (0, _dynamicCSS.updateCSS)(styleStr, randomSelectorKey);
        const ele = document.createElement('div');
        ele.style.position = 'fixed';
        ele.style.left = '0';
        ele.style.top = '0';
        handleElement?.(ele);
        document.body.appendChild(ele);
        const support = supportCheck ? supportCheck(ele) : getComputedStyle(ele).content?.includes(checkContent);
        ele.parentNode?.removeChild(ele);
        (0, _dynamicCSS.removeCSS)(randomSelectorKey);
        return support;
    }
    return false;
}
let canLayer = undefined;
function supportLayer() {
    if (canLayer === undefined) canLayer = supportSelector(`@layer ${randomSelectorKey} { .${randomSelectorKey} { content: "${checkContent}"!important; } }`, (ele)=>{
        ele.className = randomSelectorKey;
    });
    return canLayer;
}
let canWhere = undefined;
function supportWhere() {
    if (canWhere === undefined) canWhere = supportSelector(`:where(.${randomSelectorKey}) { content: "${checkContent}"!important; }`, (ele)=>{
        ele.className = randomSelectorKey;
    });
    return canWhere;
}
let canLogic = undefined;
function supportLogicProps() {
    if (canLogic === undefined) canLogic = supportSelector(`.${randomSelectorKey} { inset-block: 93px !important; }`, (ele)=>{
        ele.className = randomSelectorKey;
    }, (ele)=>getComputedStyle(ele).bottom === '93px');
    return canLogic;
}
const isClientSide = (0, _canUseDomDefault.default)();
function unit(num) {
    if (typeof num === 'number') return `${num}px`;
    return num;
}
function toStyleStr(style, tokenKey, styleId, customizeAttrs = {}, plain = false) {
    if (plain) return style;
    const attrs = {
        ...customizeAttrs,
        [(0, _styleContext.ATTR_TOKEN)]: tokenKey,
        [(0, _styleContext.ATTR_MARK)]: styleId
    };
    const attrStr = Object.keys(attrs).map((attr)=>{
        const val = attrs[attr];
        return val ? `${attr}="${val}"` : null;
    }).filter((v)=>v).join(' ');
    return `<style ${attrStr}>${style}</style>`;
}
function where(options) {
    const { hashCls, hashPriority = 'low' } = options || {};
    if (!hashCls) return '';
    const hashSelector = `.${hashCls}`;
    return hashPriority === 'low' ? `:where(${hashSelector})` : hashSelector;
}

},{"@emotion/hash":"geaOt","@rc-component/util/es/Dom/canUseDom":"4Ky1R","@rc-component/util/es/Dom/dynamicCSS":"3UDeI","../StyleContext":"bAgk8","../theme":"3CH0P","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3CH0P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genCalc", ()=>(0, _calcDefault.default));
parcelHelpers.export(exports, "createTheme", ()=>(0, _createThemeDefault.default));
parcelHelpers.export(exports, "Theme", ()=>(0, _themeDefault.default));
parcelHelpers.export(exports, "ThemeCache", ()=>(0, _themeCacheDefault.default));
var _calc = require("./calc");
var _calcDefault = parcelHelpers.interopDefault(_calc);
var _createTheme = require("./createTheme");
var _createThemeDefault = parcelHelpers.interopDefault(_createTheme);
var _theme = require("./Theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
var _themeCache = require("./ThemeCache");
var _themeCacheDefault = parcelHelpers.interopDefault(_themeCache);

},{"./calc":"cUITZ","./createTheme":"hZBkL","./Theme":"aN7xq","./ThemeCache":"8x7b6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cUITZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _csscalculator = require("./CSSCalculator");
var _csscalculatorDefault = parcelHelpers.interopDefault(_csscalculator);
var _numCalculator = require("./NumCalculator");
var _numCalculatorDefault = parcelHelpers.interopDefault(_numCalculator);
const genCalc = (type, unitlessCssVar)=>{
    const Calculator = type === 'css' ? (0, _csscalculatorDefault.default) : (0, _numCalculatorDefault.default);
    return (num)=>new Calculator(num, unitlessCssVar);
};
exports.default = genCalc;

},{"./CSSCalculator":"bKTX7","./NumCalculator":"cL2Nm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bKTX7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _calculator = require("./calculator");
var _calculatorDefault = parcelHelpers.interopDefault(_calculator);
const CALC_UNIT = 'CALC_UNIT';
const regexp = new RegExp(CALC_UNIT, 'g');
function unit(value) {
    if (typeof value === 'number') return `${value}${CALC_UNIT}`;
    return value;
}
class CSSCalculator extends (0, _calculatorDefault.default) {
    result = '';
    unitlessCssVar;
    lowPriority;
    constructor(num, unitlessCssVar){
        super();
        const numType = typeof num;
        this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) this.result = `(${num.result})`;
        else if (numType === 'number') this.result = unit(num);
        else if (numType === 'string') this.result = num;
    }
    add(num) {
        if (num instanceof CSSCalculator) this.result = `${this.result} + ${num.getResult()}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} + ${unit(num)}`;
        this.lowPriority = true;
        return this;
    }
    sub(num) {
        if (num instanceof CSSCalculator) this.result = `${this.result} - ${num.getResult()}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} - ${unit(num)}`;
        this.lowPriority = true;
        return this;
    }
    mul(num) {
        if (this.lowPriority) this.result = `(${this.result})`;
        if (num instanceof CSSCalculator) this.result = `${this.result} * ${num.getResult(true)}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} * ${num}`;
        this.lowPriority = false;
        return this;
    }
    div(num) {
        if (this.lowPriority) this.result = `(${this.result})`;
        if (num instanceof CSSCalculator) this.result = `${this.result} / ${num.getResult(true)}`;
        else if (typeof num === 'number' || typeof num === 'string') this.result = `${this.result} / ${num}`;
        this.lowPriority = false;
        return this;
    }
    getResult(force) {
        return this.lowPriority || force ? `(${this.result})` : this.result;
    }
    equal(options) {
        const { unit: cssUnit } = options || {};
        let mergedUnit = true;
        if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
        else if (Array.from(this.unitlessCssVar).some((cssVar)=>this.result.includes(cssVar))) mergedUnit = false;
        this.result = this.result.replace(regexp, mergedUnit ? 'px' : '');
        if (typeof this.lowPriority !== 'undefined') return `calc(${this.result})`;
        return this.result;
    }
}
exports.default = CSSCalculator;

},{"./calculator":"dTLt1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dTLt1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class AbstractCalculator {
}
exports.default = AbstractCalculator;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cL2Nm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _calculator = require("./calculator");
var _calculatorDefault = parcelHelpers.interopDefault(_calculator);
class NumCalculator extends (0, _calculatorDefault.default) {
    result = 0;
    constructor(num){
        super();
        if (num instanceof NumCalculator) this.result = num.result;
        else if (typeof num === 'number') this.result = num;
    }
    add(num) {
        if (num instanceof NumCalculator) this.result += num.result;
        else if (typeof num === 'number') this.result += num;
        return this;
    }
    sub(num) {
        if (num instanceof NumCalculator) this.result -= num.result;
        else if (typeof num === 'number') this.result -= num;
        return this;
    }
    mul(num) {
        if (num instanceof NumCalculator) this.result *= num.result;
        else if (typeof num === 'number') this.result *= num;
        return this;
    }
    div(num) {
        if (num instanceof NumCalculator) this.result /= num.result;
        else if (typeof num === 'number') this.result /= num;
        return this;
    }
    equal() {
        return this.result;
    }
}
exports.default = NumCalculator;

},{"./calculator":"dTLt1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hZBkL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>createTheme);
var _themeCache = require("./ThemeCache");
var _themeCacheDefault = parcelHelpers.interopDefault(_themeCache);
var _theme = require("./Theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
const cacheThemes = new (0, _themeCacheDefault.default)();
function createTheme(derivatives) {
    const derivativeArr = Array.isArray(derivatives) ? derivatives : [
        derivatives
    ];
    // Create new theme if not exist
    if (!cacheThemes.has(derivativeArr)) cacheThemes.set(derivativeArr, new (0, _themeDefault.default)(derivativeArr));
    // Get theme from cache and return
    return cacheThemes.get(derivativeArr);
}

},{"./ThemeCache":"8x7b6","./Theme":"aN7xq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8x7b6":[function(require,module,exports,__globalThis) {
// ================================== Cache ==================================
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sameDerivativeOption", ()=>sameDerivativeOption);
function sameDerivativeOption(left, right) {
    if (left.length !== right.length) return false;
    for(let i = 0; i < left.length; i++){
        if (left[i] !== right[i]) return false;
    }
    return true;
}
class ThemeCache {
    static MAX_CACHE_SIZE = 20;
    static MAX_CACHE_OFFSET = 5;
    cache;
    keys;
    cacheCallTimes;
    constructor(){
        this.cache = new Map();
        this.keys = [];
        this.cacheCallTimes = 0;
    }
    size() {
        return this.keys.length;
    }
    internalGet(derivativeOption, updateCallTimes = false) {
        let cache = {
            map: this.cache
        };
        derivativeOption.forEach((derivative)=>{
            if (!cache) cache = undefined;
            else cache = cache?.map?.get(derivative);
        });
        if (cache?.value && updateCallTimes) cache.value[1] = this.cacheCallTimes++;
        return cache?.value;
    }
    get(derivativeOption) {
        return this.internalGet(derivativeOption, true)?.[0];
    }
    has(derivativeOption) {
        return !!this.internalGet(derivativeOption);
    }
    set(derivativeOption, value) {
        // New cache
        if (!this.has(derivativeOption)) {
            if (this.size() + 1 > ThemeCache.MAX_CACHE_SIZE + ThemeCache.MAX_CACHE_OFFSET) {
                const [targetKey] = this.keys.reduce((result, key)=>{
                    const [, callTimes] = result;
                    if (this.internalGet(key)[1] < callTimes) return [
                        key,
                        this.internalGet(key)[1]
                    ];
                    return result;
                }, [
                    this.keys[0],
                    this.cacheCallTimes
                ]);
                this.delete(targetKey);
            }
            this.keys.push(derivativeOption);
        }
        let cache = this.cache;
        derivativeOption.forEach((derivative, index)=>{
            if (index === derivativeOption.length - 1) cache.set(derivative, {
                value: [
                    value,
                    this.cacheCallTimes++
                ]
            });
            else {
                const cacheValue = cache.get(derivative);
                if (!cacheValue) cache.set(derivative, {
                    map: new Map()
                });
                else if (!cacheValue.map) cacheValue.map = new Map();
                cache = cache.get(derivative).map;
            }
        });
    }
    deleteByPath(currentCache, derivatives) {
        const cache = currentCache.get(derivatives[0]);
        if (derivatives.length === 1) {
            if (!cache.map) currentCache.delete(derivatives[0]);
            else currentCache.set(derivatives[0], {
                map: cache.map
            });
            return cache.value?.[0];
        }
        const result = this.deleteByPath(cache.map, derivatives.slice(1));
        if ((!cache.map || cache.map.size === 0) && !cache.value) currentCache.delete(derivatives[0]);
        return result;
    }
    delete(derivativeOption) {
        // If cache exists
        if (this.has(derivativeOption)) {
            this.keys = this.keys.filter((item)=>!sameDerivativeOption(item, derivativeOption));
            return this.deleteByPath(this.cache, derivativeOption);
        }
        return undefined;
    }
}
exports.default = ThemeCache;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aN7xq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _warning = require("@rc-component/util/es/warning");
let uuid = 0;
class Theme {
    derivatives;
    id;
    constructor(derivatives){
        this.derivatives = Array.isArray(derivatives) ? derivatives : [
            derivatives
        ];
        this.id = uuid;
        if (derivatives.length === 0) (0, _warning.warning)(derivatives.length > 0, '[Ant Design CSS-in-JS] Theme should have at least one derivative function.');
        uuid += 1;
    }
    getDerivativeToken(token) {
        return this.derivatives.reduce((result, derivative)=>derivative(token, result), undefined);
    }
}
exports.default = Theme;

},{"@rc-component/util/es/warning":"hJXDS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cr28T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "token2CSSVar", ()=>token2CSSVar);
parcelHelpers.export(exports, "serializeCSSVar", ()=>serializeCSSVar);
parcelHelpers.export(exports, "transformToken", ()=>transformToken);
var _util = require("../util");
const token2CSSVar = (token, prefix = '')=>{
    return `--${prefix ? `${prefix}-` : ''}${token}`.replace(/([a-z0-9])([A-Z])/g, '$1-$2').replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, '$1-$2').replace(/([a-z])([A-Z0-9])/g, '$1-$2').toLowerCase();
};
const serializeCSSVar = (cssVars, hashId, options)=>{
    const { hashCls, hashPriority = 'low' } = options || {};
    if (!Object.keys(cssVars).length) return '';
    return `${(0, _util.where)({
        hashCls,
        hashPriority
    })}.${hashId}${options?.scope ? `.${options.scope}` : ''}{${Object.entries(cssVars).map(([key, value])=>`${key}:${value};`).join('')}}`;
};
const transformToken = (token, themeKey, config)=>{
    const { hashCls, hashPriority = 'low', prefix, unitless, ignore, preserve } = config || {};
    const cssVars = {};
    const result = {};
    Object.entries(token).forEach(([key, value])=>{
        if (preserve?.[key]) result[key] = value;
        else if ((typeof value === 'string' || typeof value === 'number') && !ignore?.[key]) {
            const cssVar = token2CSSVar(key, prefix);
            cssVars[cssVar] = typeof value === 'number' && !unitless?.[key] ? `${value}px` : String(value);
            result[key] = `var(${cssVar})`;
        }
    });
    return [
        result,
        serializeCSSVar(cssVars, themeKey, {
            scope: config?.scope,
            hashCls,
            hashPriority
        })
    ];
};

},{"../util":"oHhSW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k38UD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useGlobalCache);
var _react = require("react");
var _cache = require("../Cache");
var _styleContext = require("../StyleContext");
var _styleContextDefault = parcelHelpers.interopDefault(_styleContext);
var _useHMR = require("./useHMR");
var _useHMRDefault = parcelHelpers.interopDefault(_useHMR);
const effectMap = new Map();
function useGlobalCache(prefix, keyPath, cacheFn, onCacheRemove, // Add additional effect trigger by `useInsertionEffect`
onCacheEffect) {
    const { cache: globalCache } = _react.useContext((0, _styleContextDefault.default));
    const fullPath = [
        prefix,
        ...keyPath
    ];
    const fullPathStr = (0, _cache.pathKey)(fullPath);
    const HMRUpdate = (0, _useHMRDefault.default)();
    const buildCache = (updater)=>{
        globalCache.opUpdate(fullPathStr, (prevCache)=>{
            const [times = 0, cache] = prevCache || [
                undefined,
                undefined
            ];
            // HMR should always ignore cache since developer may change it
            let tmpCache = cache;
            const mergedCache = tmpCache || cacheFn();
            const data = [
                times,
                mergedCache
            ];
            // Call updater if need additional logic
            return updater ? updater(data) : data;
        });
    };
    // Create cache
    _react.useMemo(()=>{
        buildCache();
    }, /* eslint-disable react-hooks/exhaustive-deps */ [
        fullPathStr
    ]);
    let cacheEntity = globalCache.opGet(fullPathStr);
    const cacheContent = cacheEntity[1];
    // Remove if no need anymore
    (0, _react.useInsertionEffect)(()=>{
        buildCache(([times, cache])=>[
                times + 1,
                cache
            ]);
        if (!effectMap.has(fullPathStr)) {
            onCacheEffect?.(cacheContent);
            effectMap.set(fullPathStr, true);
            // 微任务清理混存，可以认为是单次 batch render 中只触发一次 effect
            Promise.resolve().then(()=>{
                effectMap.delete(fullPathStr);
            });
        }
        return ()=>{
            globalCache.opUpdate(fullPathStr, (prevCache)=>{
                const [times = 0, cache] = prevCache || [];
                const nextCount = times - 1;
                if (nextCount === 0) {
                    onCacheRemove?.(cache, false);
                    effectMap.delete(fullPathStr);
                    return null;
                }
                return [
                    times - 1,
                    cache
                ];
            });
        };
    }, [
        fullPathStr
    ]);
    return cacheContent;
}

},{"react":"bmhQu","../Cache":"fILNr","../StyleContext":"bAgk8","./useHMR":"2Bzmu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Bzmu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function useProdHMR() {
    return false;
}
let webpackHMR = false;
function useDevHMR() {
    return webpackHMR;
}
exports.default = useProdHMR;
var args;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lN11C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSS_VAR_PREFIX", ()=>CSS_VAR_PREFIX);
parcelHelpers.export(exports, "extract", ()=>extract);
var _dynamicCSS = require("@rc-component/util/es/Dom/dynamicCSS");
var _react = require("react");
var _styleContext = require("../StyleContext");
var _styleContextDefault = parcelHelpers.interopDefault(_styleContext);
var _util = require("../util");
var _cssVariables = require("../util/css-variables");
var _useGlobalCache = require("./useGlobalCache");
var _useGlobalCacheDefault = parcelHelpers.interopDefault(_useGlobalCache);
var _useStyleRegister = require("./useStyleRegister");
const CSS_VAR_PREFIX = 'cssVar';
const useCSSVarRegister = (config, fn)=>{
    const { key, prefix, unitless, ignore, token, hashId, scope = '' } = config;
    const { cache: { instanceId }, container, hashPriority } = (0, _react.useContext)((0, _styleContextDefault.default));
    const { _tokenKey: tokenKey } = token;
    const stylePath = [
        ...config.path,
        key,
        scope,
        tokenKey
    ];
    const cache = (0, _useGlobalCacheDefault.default)(CSS_VAR_PREFIX, stylePath, ()=>{
        const originToken = fn();
        const [mergedToken, cssVarsStr] = (0, _cssVariables.transformToken)(originToken, key, {
            prefix,
            unitless,
            ignore,
            scope,
            hashPriority,
            hashCls: hashId
        });
        const styleId = (0, _useStyleRegister.uniqueHash)(stylePath, cssVarsStr);
        return [
            mergedToken,
            cssVarsStr,
            styleId,
            key
        ];
    }, ([, , styleId])=>{
        if (0, _util.isClientSide) (0, _dynamicCSS.removeCSS)(styleId, {
            mark: (0, _styleContext.ATTR_MARK),
            attachTo: container
        });
    }, ([, cssVarsStr, styleId])=>{
        if (!cssVarsStr) return;
        const style = (0, _dynamicCSS.updateCSS)(cssVarsStr, styleId, {
            mark: (0, _styleContext.ATTR_MARK),
            prepend: 'queue',
            attachTo: container,
            priority: -999
        });
        style[0, _styleContext.CSS_IN_JS_INSTANCE] = instanceId;
        // Used for `useCacheToken` to remove on batch when token removed
        style.setAttribute((0, _styleContext.ATTR_TOKEN), key);
    });
    return cache;
};
const extract = (cache, effectStyles, options)=>{
    const [, styleStr, styleId, cssVarKey] = cache;
    const { plain } = options || {};
    if (!styleStr) return null;
    const order = -999;
    // ====================== Style ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    const styleText = (0, _util.toStyleStr)(styleStr, cssVarKey, styleId, sharedAttrs, plain);
    return [
        order,
        styleId,
        styleText
    ];
};
exports.default = useCSSVarRegister;

},{"@rc-component/util/es/Dom/dynamicCSS":"3UDeI","react":"bmhQu","../StyleContext":"bAgk8","../util":"oHhSW","../util/css-variables":"cr28T","./useGlobalCache":"k38UD","./useStyleRegister":"kzwtR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kzwtR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// ============================================================================
// ==                                 Parser                                 ==
// ============================================================================
// Preprocessor style content to browser support one
parcelHelpers.export(exports, "normalizeStyle", ()=>normalizeStyle);
parcelHelpers.export(exports, "parseStyle", ()=>parseStyle);
// ============================================================================
// ==                                Register                                ==
// ============================================================================
parcelHelpers.export(exports, "uniqueHash", ()=>uniqueHash);
parcelHelpers.export(exports, "STYLE_PREFIX", ()=>STYLE_PREFIX);
parcelHelpers.export(exports, "default", ()=>useStyleRegister);
parcelHelpers.export(exports, "extract", ()=>extract);
var _hash = require("@emotion/hash");
var _hashDefault = parcelHelpers.interopDefault(_hash);
var _dynamicCSS = require("@rc-component/util/es/Dom/dynamicCSS");
var _react = require("react");
// @ts-ignore
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
var _stylis = require("stylis");
var _linters = require("../linters");
var _styleContext = require("../StyleContext");
var _styleContextDefault = parcelHelpers.interopDefault(_styleContext);
var _util = require("../util");
var _cacheMapUtil = require("../util/cacheMapUtil");
var _useGlobalCache = require("./useGlobalCache");
var _useGlobalCacheDefault = parcelHelpers.interopDefault(_useGlobalCache);
const SKIP_CHECK = '_skip_check_';
const MULTI_VALUE = '_multi_value_';
function normalizeStyle(styleStr, autoPrefix) {
    const serialized = autoPrefix ? (0, _stylis.serialize)((0, _stylis.compile)(styleStr), (0, _stylis.middleware)([
        (0, _stylis.prefixer),
        (0, _stylis.stringify)
    ])) : (0, _stylis.serialize)((0, _stylis.compile)(styleStr), (0, _stylis.stringify));
    return serialized.replace(/\{%%%\:[^;];}/g, ';');
}
function isCompoundCSSProperty(value) {
    return typeof value === 'object' && value && (SKIP_CHECK in value || MULTI_VALUE in value);
}
// 注入 hash 值
function injectSelectorHash(key, hashId, hashPriority) {
    if (!hashId) return key;
    const hashClassName = `.${hashId}`;
    const hashSelector = hashPriority === 'low' ? `:where(${hashClassName})` : hashClassName;
    // 注入 hashId
    const keys = key.split(',').map((k)=>{
        const fullPath = k.trim().split(/\s+/);
        // 如果 Selector 第一个是 HTML Element，那我们就插到它的后面。反之，就插到最前面。
        let firstPath = fullPath[0] || '';
        const htmlElement = firstPath.match(/^\w+/)?.[0] || '';
        firstPath = `${htmlElement}${hashSelector}${firstPath.slice(htmlElement.length)}`;
        return [
            firstPath,
            ...fullPath.slice(1)
        ].join(' ');
    });
    return keys.join(',');
}
const parseStyle = (interpolation, config = {}, { root, injectHash, parentSelectors } = {
    root: true,
    parentSelectors: []
})=>{
    const { hashId, layer, path, hashPriority, transformers = [], linters = [] } = config;
    let styleStr = '';
    let effectStyle = {};
    function parseKeyframes(keyframes) {
        const animationName = keyframes.getName(hashId);
        if (!effectStyle[animationName]) {
            const [parsedStr] = parseStyle(keyframes.style, config, {
                root: false,
                parentSelectors
            });
            effectStyle[animationName] = `@keyframes ${keyframes.getName(hashId)}${parsedStr}`;
        }
    }
    function flattenList(list, fullList = []) {
        list.forEach((item)=>{
            if (Array.isArray(item)) flattenList(item, fullList);
            else if (item) fullList.push(item);
        });
        return fullList;
    }
    const flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [
        interpolation
    ]);
    flattenStyleList.forEach((originStyle)=>{
        // Only root level can use raw string
        const style = typeof originStyle === 'string' && !root ? {} : originStyle;
        if (typeof style === 'string') styleStr += `${style}\n`;
        else if (style._keyframe) // Keyframe
        parseKeyframes(style);
        else {
            const mergedStyle = transformers.reduce((prev, trans)=>trans?.visit?.(prev) || prev, style);
            // Normal CSSObject
            Object.keys(mergedStyle).forEach((key)=>{
                const value = mergedStyle[key];
                if (typeof value === 'object' && value && (key !== 'animationName' || !value._keyframe) && !isCompoundCSSProperty(value)) {
                    let subInjectHash = false;
                    // 当成嵌套对象来处理
                    let mergedKey = key.trim();
                    // Whether treat child as root. In most case it is false.
                    let nextRoot = false;
                    // 拆分多个选择器
                    if ((root || injectHash) && hashId) {
                        if (mergedKey.startsWith('@')) // 略过媒体查询，交给子节点继续插入 hashId
                        subInjectHash = true;
                        else if (mergedKey === '&') // 抹掉 root selector 上的单个 &
                        mergedKey = injectSelectorHash('', hashId, hashPriority);
                        else // 注入 hashId
                        mergedKey = injectSelectorHash(key, hashId, hashPriority);
                    } else if (root && !hashId && (mergedKey === '&' || mergedKey === '')) {
                        // In case of `{ '&': { a: { color: 'red' } } }` or `{ '': { a: { color: 'red' } } }` without hashId,
                        // we will get `&{a:{color:red;}}` or `{a:{color:red;}}` string for stylis to compile.
                        // But it does not conform to stylis syntax,
                        // and finally we will get `{color:red;}` as css, which is wrong.
                        // So we need to remove key in root, and treat child `{ a: { color: 'red' } }` as root.
                        mergedKey = '';
                        nextRoot = true;
                    }
                    const [parsedStr, childEffectStyle] = parseStyle(value, config, {
                        root: nextRoot,
                        injectHash: subInjectHash,
                        parentSelectors: [
                            ...parentSelectors,
                            mergedKey
                        ]
                    });
                    effectStyle = {
                        ...effectStyle,
                        ...childEffectStyle
                    };
                    styleStr += `${mergedKey}${parsedStr}`;
                } else {
                    function appendStyle(cssKey, cssValue) {
                        var linter;
                        // 如果是样式则直接插入
                        const styleName = cssKey.replace(/[A-Z]/g, (match)=>`-${match.toLowerCase()}`);
                        // Auto suffix with px
                        let formatValue = cssValue;
                        if (!(0, _unitlessDefault.default)[cssKey] && typeof formatValue === 'number' && formatValue !== 0) formatValue = `${formatValue}px`;
                        // handle animationName & Keyframe value
                        if (cssKey === 'animationName' && cssValue?._keyframe) {
                            parseKeyframes(cssValue);
                            formatValue = cssValue.getName(hashId);
                        }
                        styleStr += `${styleName}:${formatValue};`;
                    }
                    const actualValue = value?.value ?? value;
                    if (typeof value === 'object' && value?.[MULTI_VALUE] && Array.isArray(actualValue)) actualValue.forEach((item)=>{
                        appendStyle(key, item);
                    });
                    else appendStyle(key, actualValue);
                }
            });
        }
    });
    if (!root) styleStr = `{${styleStr}}`;
    else if (layer) {
        // fixme: https://github.com/thysultan/stylis/pull/339
        if (styleStr) styleStr = `@layer ${layer.name} {${styleStr}}`;
        if (layer.dependencies) effectStyle[`@layer ${layer.name}`] = layer.dependencies.map((deps)=>`@layer ${deps}, ${layer.name};`).join('\n');
    }
    return [
        styleStr,
        effectStyle
    ];
};
function uniqueHash(path, styleStr) {
    return (0, _hashDefault.default)(`${path.join('%')}${styleStr}`);
}
const STYLE_PREFIX = 'style';
function useStyleRegister(info, styleFn) {
    const { path, hashId, layer, nonce, clientOnly, order = 0 } = info;
    const { mock, hashPriority, container, transformers, linters, cache, layer: enableLayer, autoPrefix } = _react.useContext((0, _styleContextDefault.default));
    const fullPath = [
        hashId || ''
    ];
    if (enableLayer) fullPath.push('layer');
    fullPath.push(...path);
    // Check if need insert style
    let isMergedClientSide = (0, _util.isClientSide);
    (0, _useGlobalCacheDefault.default)(STYLE_PREFIX, fullPath, // Create cache if needed
    ()=>{
        const cachePath = fullPath.join('|');
        // Get style from SSR inline style directly
        if ((0, _cacheMapUtil.existPath)(cachePath)) {
            const [inlineCacheStyleStr, styleHash] = (0, _cacheMapUtil.getStyleAndHash)(cachePath);
            if (inlineCacheStyleStr) return [
                inlineCacheStyleStr,
                styleHash,
                {},
                clientOnly,
                order
            ];
        }
        // Generate style
        const styleObj = styleFn();
        const [parsedStyle, effectStyle] = parseStyle(styleObj, {
            hashId,
            hashPriority,
            layer: enableLayer ? layer : undefined,
            path: path.join('-'),
            transformers,
            linters
        });
        const styleStr = normalizeStyle(parsedStyle, autoPrefix || false);
        const styleId = uniqueHash(fullPath, styleStr);
        return [
            styleStr,
            styleId,
            effectStyle,
            clientOnly,
            order
        ];
    }, // Remove cache if no need
    (cacheValue, fromHMR)=>{
        const [, styleId] = cacheValue;
        if (fromHMR && (0, _util.isClientSide)) (0, _dynamicCSS.removeCSS)(styleId, {
            mark: (0, _styleContext.ATTR_MARK),
            attachTo: container
        });
    }, // Effect: Inject style here
    (cacheValue)=>{
        const [styleStr, styleId, effectStyle, , priority] = cacheValue;
        if (isMergedClientSide && styleStr !== (0, _cacheMapUtil.CSS_FILE_STYLE)) {
            const mergedCSSConfig = {
                mark: (0, _styleContext.ATTR_MARK),
                prepend: enableLayer ? false : 'queue',
                attachTo: container,
                priority
            };
            const nonceStr = typeof nonce === 'function' ? nonce() : nonce;
            if (nonceStr) mergedCSSConfig.csp = {
                nonce: nonceStr
            };
            // ================= Split Effect Style =================
            // We will split effectStyle here since @layer should be at the top level
            const effectLayerKeys = [];
            const effectRestKeys = [];
            Object.keys(effectStyle).forEach((key)=>{
                if (key.startsWith('@layer')) effectLayerKeys.push(key);
                else effectRestKeys.push(key);
            });
            // ================= Inject Layer Style =================
            // Inject layer style
            effectLayerKeys.forEach((effectKey)=>{
                (0, _dynamicCSS.updateCSS)(normalizeStyle(effectStyle[effectKey], autoPrefix || false), `_layer-${effectKey}`, {
                    ...mergedCSSConfig,
                    prepend: true
                });
            });
            // ==================== Inject Style ====================
            // Inject style
            const style = (0, _dynamicCSS.updateCSS)(styleStr, styleId, mergedCSSConfig);
            style[0, _styleContext.CSS_IN_JS_INSTANCE] = cache.instanceId;
            // ================ Inject Effect Style =================
            // Inject client side effect style
            effectRestKeys.forEach((effectKey)=>{
                (0, _dynamicCSS.updateCSS)(normalizeStyle(effectStyle[effectKey], autoPrefix || false), `_effect-${effectKey}`, mergedCSSConfig);
            });
        }
    });
}
const extract = (cache, effectStyles, options)=>{
    const [styleStr, styleId, effectStyle, clientOnly, order] = cache;
    const { plain, autoPrefix } = options || {};
    // Skip client only style
    if (clientOnly) return null;
    let keyStyleText = styleStr;
    // ====================== Share ======================
    // Used for @rc-component/util
    const sharedAttrs = {
        'data-rc-order': 'prependQueue',
        'data-rc-priority': `${order}`
    };
    // ====================== Style ======================
    keyStyleText = (0, _util.toStyleStr)(styleStr, undefined, styleId, sharedAttrs, plain);
    // =============== Create effect style ===============
    if (effectStyle) Object.keys(effectStyle).forEach((effectKey)=>{
        // Effect style can be reused
        if (!effectStyles[effectKey]) {
            effectStyles[effectKey] = true;
            const effectStyleStr = normalizeStyle(effectStyle[effectKey], autoPrefix || false);
            const effectStyleHTML = (0, _util.toStyleStr)(effectStyleStr, undefined, `_effect-${effectKey}`, sharedAttrs, plain);
            if (effectKey.startsWith('@layer')) keyStyleText = effectStyleHTML + keyStyleText;
            else keyStyleText += effectStyleHTML;
        }
    });
    return [
        order,
        styleId,
        keyStyleText
    ];
};

},{"@emotion/hash":"geaOt","@rc-component/util/es/Dom/dynamicCSS":"3UDeI","react":"bmhQu","@emotion/unitless":"gQBa1","stylis":"f4S0f","../linters":"hCOnc","../StyleContext":"bAgk8","../util":"oHhSW","../util/cacheMapUtil":"5Ya3U","./useGlobalCache":"k38UD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gQBa1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var unitlessKeys = {
    animationIterationCount: 1,
    borderImageOutset: 1,
    borderImageSlice: 1,
    borderImageWidth: 1,
    boxFlex: 1,
    boxFlexGroup: 1,
    boxOrdinalGroup: 1,
    columnCount: 1,
    columns: 1,
    flex: 1,
    flexGrow: 1,
    flexPositive: 1,
    flexShrink: 1,
    flexNegative: 1,
    flexOrder: 1,
    gridRow: 1,
    gridRowEnd: 1,
    gridRowSpan: 1,
    gridRowStart: 1,
    gridColumn: 1,
    gridColumnEnd: 1,
    gridColumnSpan: 1,
    gridColumnStart: 1,
    msGridRow: 1,
    msGridRowSpan: 1,
    msGridColumn: 1,
    msGridColumnSpan: 1,
    fontWeight: 1,
    lineHeight: 1,
    opacity: 1,
    order: 1,
    orphans: 1,
    tabSize: 1,
    widows: 1,
    zIndex: 1,
    zoom: 1,
    WebkitLineClamp: 1,
    // SVG-related properties
    fillOpacity: 1,
    floodOpacity: 1,
    stopOpacity: 1,
    strokeDasharray: 1,
    strokeDashoffset: 1,
    strokeMiterlimit: 1,
    strokeOpacity: 1,
    strokeWidth: 1
};
exports.default = unitlessKeys;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f4S0f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHARSET", ()=>f);
parcelHelpers.export(exports, "COMMENT", ()=>c);
parcelHelpers.export(exports, "COUNTER_STYLE", ()=>w);
parcelHelpers.export(exports, "DECLARATION", ()=>s);
parcelHelpers.export(exports, "DOCUMENT", ()=>p);
parcelHelpers.export(exports, "FONT_FACE", ()=>h);
parcelHelpers.export(exports, "FONT_FEATURE_VALUES", ()=>d);
parcelHelpers.export(exports, "IMPORT", ()=>i);
parcelHelpers.export(exports, "KEYFRAMES", ()=>b);
parcelHelpers.export(exports, "LAYER", ()=>g);
parcelHelpers.export(exports, "MEDIA", ()=>u);
parcelHelpers.export(exports, "MOZ", ()=>r);
parcelHelpers.export(exports, "MS", ()=>e);
parcelHelpers.export(exports, "NAMESPACE", ()=>v);
parcelHelpers.export(exports, "PAGE", ()=>t);
parcelHelpers.export(exports, "RULESET", ()=>n);
parcelHelpers.export(exports, "SCOPE", ()=>k);
parcelHelpers.export(exports, "SUPPORTS", ()=>l);
parcelHelpers.export(exports, "VIEWPORT", ()=>o);
parcelHelpers.export(exports, "WEBKIT", ()=>a);
parcelHelpers.export(exports, "abs", ()=>$);
parcelHelpers.export(exports, "alloc", ()=>Y);
parcelHelpers.export(exports, "append", ()=>B);
parcelHelpers.export(exports, "assign", ()=>x);
parcelHelpers.export(exports, "caret", ()=>V);
parcelHelpers.export(exports, "char", ()=>Q);
parcelHelpers.export(exports, "character", ()=>J);
parcelHelpers.export(exports, "characters", ()=>K);
parcelHelpers.export(exports, "charat", ()=>A);
parcelHelpers.export(exports, "column", ()=>G);
parcelHelpers.export(exports, "combine", ()=>D);
parcelHelpers.export(exports, "comment", ()=>oe);
parcelHelpers.export(exports, "commenter", ()=>se);
parcelHelpers.export(exports, "compile", ()=>ue);
parcelHelpers.export(exports, "copy", ()=>N);
parcelHelpers.export(exports, "dealloc", ()=>Z);
parcelHelpers.export(exports, "declaration", ()=>le);
parcelHelpers.export(exports, "delimit", ()=>_);
parcelHelpers.export(exports, "delimiter", ()=>ne);
parcelHelpers.export(exports, "escaping", ()=>ce);
parcelHelpers.export(exports, "filter", ()=>E);
parcelHelpers.export(exports, "from", ()=>m);
parcelHelpers.export(exports, "hash", ()=>y);
parcelHelpers.export(exports, "identifier", ()=>te);
parcelHelpers.export(exports, "indexof", ()=>O);
parcelHelpers.export(exports, "length", ()=>H);
parcelHelpers.export(exports, "lift", ()=>P);
parcelHelpers.export(exports, "line", ()=>F);
parcelHelpers.export(exports, "match", ()=>z);
parcelHelpers.export(exports, "middleware", ()=>he);
parcelHelpers.export(exports, "namespace", ()=>ge);
parcelHelpers.export(exports, "next", ()=>T);
parcelHelpers.export(exports, "node", ()=>L);
parcelHelpers.export(exports, "parse", ()=>ie);
parcelHelpers.export(exports, "peek", ()=>U);
parcelHelpers.export(exports, "position", ()=>I);
parcelHelpers.export(exports, "prefix", ()=>pe);
parcelHelpers.export(exports, "prefixer", ()=>de);
parcelHelpers.export(exports, "prev", ()=>R);
parcelHelpers.export(exports, "replace", ()=>C);
parcelHelpers.export(exports, "ruleset", ()=>fe);
parcelHelpers.export(exports, "rulesheet", ()=>we);
parcelHelpers.export(exports, "serialize", ()=>ve);
parcelHelpers.export(exports, "sizeof", ()=>q);
parcelHelpers.export(exports, "slice", ()=>W);
parcelHelpers.export(exports, "stringify", ()=>be);
parcelHelpers.export(exports, "strlen", ()=>S);
parcelHelpers.export(exports, "substr", ()=>M);
parcelHelpers.export(exports, "token", ()=>X);
parcelHelpers.export(exports, "tokenize", ()=>ee);
parcelHelpers.export(exports, "tokenizer", ()=>ae);
parcelHelpers.export(exports, "trim", ()=>j);
parcelHelpers.export(exports, "whitespace", ()=>re);
var e = "-ms-";
var r = "-moz-";
var a = "-webkit-";
var c = "comm";
var n = "rule";
var s = "decl";
var t = "@page";
var u = "@media";
var i = "@import";
var f = "@charset";
var o = "@viewport";
var l = "@supports";
var p = "@document";
var v = "@namespace";
var b = "@keyframes";
var h = "@font-face";
var w = "@counter-style";
var d = "@font-feature-values";
var g = "@layer";
var k = "@scope";
var $ = Math.abs;
var m = String.fromCharCode;
var x = Object.assign;
function y(e, r) {
    return A(e, 0) ^ 45 ? (((r << 2 ^ A(e, 0)) << 2 ^ A(e, 1)) << 2 ^ A(e, 2)) << 2 ^ A(e, 3) : 0;
}
function j(e) {
    return e.trim();
}
function z(e, r) {
    return (e = r.exec(e)) ? e[0] : e;
}
function C(e, r, a) {
    return e.replace(r, a);
}
function O(e, r, a) {
    return e.indexOf(r, a);
}
function A(e, r) {
    return e.charCodeAt(r) | 0;
}
function M(e, r, a) {
    return e.slice(r, a);
}
function S(e) {
    return e.length;
}
function q(e) {
    return e.length;
}
function B(e, r) {
    return r.push(e), e;
}
function D(e, r) {
    return e.map(r).join("");
}
function E(e, r) {
    return e.filter(function(e) {
        return !z(e, r);
    });
}
var F = 1;
var G = 1;
var H = 0;
var I = 0;
var J = 0;
var K = "";
function L(e, r, a, c, n, s, t, u) {
    return {
        value: e,
        root: r,
        parent: a,
        type: c,
        props: n,
        children: s,
        line: F,
        column: G,
        length: t,
        return: "",
        siblings: u
    };
}
function N(e, r) {
    return x(L("", null, null, "", null, null, 0, e.siblings), e, {
        length: -e.length
    }, r);
}
function P(e) {
    while(e.root)e = N(e.root, {
        children: [
            e
        ]
    });
    B(e, e.siblings);
}
function Q() {
    return J;
}
function R() {
    J = I > 0 ? A(K, --I) : 0;
    if (G--, J === 10) G = 1, F--;
    return J;
}
function T() {
    J = I < H ? A(K, I++) : 0;
    if (G++, J === 10) G = 1, F++;
    return J;
}
function U() {
    return A(K, I);
}
function V() {
    return I;
}
function W(e, r) {
    return M(K, e, r);
}
function X(e) {
    switch(e){
        case 0:
        case 9:
        case 10:
        case 13:
        case 32:
            return 5;
        case 33:
        case 43:
        case 44:
        case 47:
        case 62:
        case 64:
        case 126:
        case 59:
        case 123:
        case 125:
            return 4;
        case 58:
            return 3;
        case 34:
        case 39:
        case 40:
        case 91:
            return 2;
        case 41:
        case 93:
            return 1;
    }
    return 0;
}
function Y(e) {
    return F = G = 1, H = S(K = e), I = 0, [];
}
function Z(e) {
    return K = "", e;
}
function _(e) {
    return j(W(I - 1, ne(e === 91 ? e + 2 : e === 40 ? e + 1 : e)));
}
function ee(e) {
    return Z(ae(Y(e)));
}
function re(e) {
    while(J = U())if (J < 33) T();
    else break;
    return X(e) > 2 || X(J) > 3 ? "" : " ";
}
function ae(e) {
    while(T())switch(X(J)){
        case 0:
            B(te(I - 1), e);
            break;
        case 2:
            B(_(J), e);
            break;
        default:
            B(m(J), e);
    }
    return e;
}
function ce(e, r) {
    while(--r && T())if (J < 48 || J > 102 || J > 57 && J < 65 || J > 70 && J < 97) break;
    return W(e, V() + (r < 6 && U() == 32 && T() == 32));
}
function ne(e) {
    while(T())switch(J){
        case e:
            return I;
        case 34:
        case 39:
            if (e !== 34 && e !== 39) ne(J);
            break;
        case 40:
            if (e === 41) ne(e);
            break;
        case 92:
            T();
            break;
    }
    return I;
}
function se(e, r) {
    while(T())if (e + J === 57) break;
    else if (e + J === 84 && U() === 47) break;
    return "/*" + W(r, I - 1) + "*" + m(e === 47 ? e : T());
}
function te(e) {
    while(!X(U()))T();
    return W(e, I);
}
function ue(e) {
    return Z(ie("", null, null, null, [
        ""
    ], e = Y(e), 0, [
        0
    ], e));
}
function ie(e, r, a, c, n, s, t, u, i) {
    var f = 0;
    var o = 0;
    var l = t;
    var p = 0;
    var v = 0;
    var b = 0;
    var h = 1;
    var w = 1;
    var d = 1;
    var g = 0;
    var k = "";
    var x = n;
    var y = s;
    var j = c;
    var z = k;
    while(w)switch(b = g, g = T()){
        case 40:
            if (b != 108 && A(z, l - 1) == 58) {
                if (O(z += C(_(g), "&", "&\f"), "&\f", $(f ? u[f - 1] : 0)) != -1) d = -1;
                break;
            }
        case 34:
        case 39:
        case 91:
            z += _(g);
            break;
        case 9:
        case 10:
        case 13:
        case 32:
            z += re(b);
            break;
        case 92:
            z += ce(V() - 1, 7);
            continue;
        case 47:
            switch(U()){
                case 42:
                case 47:
                    B(oe(se(T(), V()), r, a, i), i);
                    if ((X(b || 1) == 5 || X(U() || 1) == 5) && S(z) && M(z, -1, void 0) !== " ") z += " ";
                    break;
                default:
                    z += "/";
            }
            break;
        case 123 * h:
            u[f++] = S(z) * d;
        case 125 * h:
        case 59:
        case 0:
            switch(g){
                case 0:
                case 125:
                    w = 0;
                case 59 + o:
                    if (d == -1) z = C(z, /\f/g, "");
                    if (v > 0 && (S(z) - l || h === 0 && b === 47)) B(v > 32 ? le(z + ";", c, a, l - 1, i) : le(C(z, " ", "") + ";", c, a, l - 2, i), i);
                    break;
                case 59:
                    z += ";";
                default:
                    B(j = fe(z, r, a, f, o, n, u, k, x = [], y = [], l, s), s);
                    if (g === 123) {
                        if (o === 0) ie(z, r, j, j, x, s, l, u, y);
                        else {
                            switch(p){
                                case 99:
                                    if (A(z, 3) === 110) break;
                                case 108:
                                    if (A(z, 2) === 97) break;
                                default:
                                    o = 0;
                                case 100:
                                case 109:
                                case 115:
                            }
                            if (o) ie(e, j, j, c && B(fe(e, j, j, 0, 0, n, u, k, n, x = [], l, y), y), n, y, l, u, c ? x : y);
                            else ie(z, j, j, j, [
                                ""
                            ], y, 0, u, y);
                        }
                    }
            }
            f = o = v = 0, h = d = 1, k = z = "", l = t;
            break;
        case 58:
            l = 1 + S(z), v = b;
        default:
            if (h < 1) {
                if (g == 123) --h;
                else if (g == 125 && h++ == 0 && R() == 125) continue;
            }
            switch(z += m(g), g * h){
                case 38:
                    d = o > 0 ? 1 : (z += "\f", -1);
                    break;
                case 44:
                    u[f++] = (S(z) - 1) * d, d = 1;
                    break;
                case 64:
                    if (U() === 45) z += _(T());
                    p = U(), o = l = S(k = z += te(V())), g++;
                    break;
                case 45:
                    if (b === 45 && S(z) == 2) h = 0;
            }
    }
    return s;
}
function fe(e, r, a, c, s, t, u, i, f, o, l, p) {
    var v = s - 1;
    var b = s === 0 ? t : [
        ""
    ];
    var h = q(b);
    for(var w = 0, d = 0, g = 0; w < c; ++w)for(var k = 0, m = M(e, v + 1, v = $(d = u[w])), x = e; k < h; ++k)if (x = j(d > 0 ? b[k] + " " + m : C(m, /&\f/g, b[k]))) f[g++] = x;
    return L(e, r, a, s === 0 ? n : i, f, o, l, p);
}
function oe(e, r, a, n) {
    return L(e, r, a, c, m(Q()), M(e, 2, -2), 0, n);
}
function le(e, r, a, c, n) {
    return L(e, r, a, s, M(e, 0, c), M(e, c + 1, -1), c, n);
}
function pe(c, n, s) {
    switch(y(c, n)){
        case 5103:
            return a + "print-" + c + c;
        case 5737:
        case 4201:
        case 3177:
        case 3433:
        case 1641:
        case 4457:
        case 2921:
        case 5572:
        case 6356:
        case 5844:
        case 3191:
        case 6645:
        case 3005:
        case 4215:
        case 6389:
        case 5109:
        case 5365:
        case 5621:
        case 3829:
        case 6391:
        case 5879:
        case 5623:
        case 6135:
        case 4599:
            return a + c + c;
        case 4855:
            return a + c.replace("add", "source-over").replace("substract", "source-out").replace("intersect", "source-in").replace("exclude", "xor") + c;
        case 4789:
            return r + c + c;
        case 5349:
        case 4246:
        case 4810:
        case 6968:
        case 2756:
            return a + c + r + c + e + c + c;
        case 5936:
            switch(A(c, n + 11)){
                case 114:
                    return a + c + e + C(c, /[svh]\w+-[tblr]{2}/, "tb") + c;
                case 108:
                    return a + c + e + C(c, /[svh]\w+-[tblr]{2}/, "tb-rl") + c;
                case 45:
                    return a + c + e + C(c, /[svh]\w+-[tblr]{2}/, "lr") + c;
            }
        case 6828:
        case 4268:
        case 2903:
            return a + c + e + c + c;
        case 6165:
            return a + c + e + "flex-" + c + c;
        case 5187:
            return a + c + C(c, /(\w+).+(:[^]+)/, a + "box-$1$2" + e + "flex-$1$2") + c;
        case 5443:
            return a + c + e + "flex-item-" + C(c, /flex-|-self/g, "") + (!z(c, /flex-|baseline/) ? e + "grid-row-" + C(c, /flex-|-self/g, "") : "") + c;
        case 4675:
            return a + c + e + "flex-line-pack" + C(c, /align-content|flex-|-self/g, "") + c;
        case 5548:
            return a + c + e + C(c, "shrink", "negative") + c;
        case 5292:
            return a + c + e + C(c, "basis", "preferred-size") + c;
        case 6060:
            return a + "box-" + C(c, "-grow", "") + a + c + e + C(c, "grow", "positive") + c;
        case 4554:
            return a + C(c, /([^-])(transform)/g, "$1" + a + "$2") + c;
        case 6187:
            return C(C(C(c, /(zoom-|grab)/, a + "$1"), /(image-set)/, a + "$1"), c, "") + c;
        case 5495:
        case 3959:
            return C(c, /(image-set\([^]*)/, a + "$1" + "$`$1");
        case 4968:
            return C(C(c, /(.+:)(flex-)?(.*)/, a + "box-pack:$3" + e + "flex-pack:$3"), /space-between/, "justify") + a + c + c;
        case 4200:
            if (!z(c, /flex-|baseline/)) return e + "grid-column-align" + M(c, n) + c;
            break;
        case 2592:
        case 3360:
            return e + C(c, "template-", "") + c;
        case 4384:
        case 3616:
            if (s && s.some(function(e, r) {
                return n = r, z(e.props, /grid-\w+-end/);
            })) return ~O(c + (s = s[n].value), "span", 0) ? c : e + C(c, "-start", "") + c + e + "grid-row-span:" + (~O(s, "span", 0) ? z(s, /\d+/) : +z(s, /\d+/) - +z(c, /\d+/)) + ";";
            return e + C(c, "-start", "") + c;
        case 4896:
        case 4128:
            return s && s.some(function(e) {
                return z(e.props, /grid-\w+-start/);
            }) ? c : e + C(C(c, "-end", "-span"), "span ", "") + c;
        case 4095:
        case 3583:
        case 4068:
        case 2532:
            return C(c, /(.+)-inline(.+)/, a + "$1$2") + c;
        case 8116:
        case 7059:
        case 5753:
        case 5535:
        case 5445:
        case 5701:
        case 4933:
        case 4677:
        case 5533:
        case 5789:
        case 5021:
        case 4765:
            if (S(c) - 1 - n > 6) switch(A(c, n + 1)){
                case 109:
                    if (A(c, n + 4) !== 45) break;
                case 102:
                    return C(c, /(.+:)(.+)-([^]+)/, "$1" + a + "$2-$3" + "$1" + r + (A(c, n + 3) == 108 ? "$3" : "$2-$3")) + c;
                case 115:
                    return ~O(c, "stretch", 0) ? pe(C(c, "stretch", "fill-available"), n, s) + c : c;
            }
            break;
        case 5152:
        case 5920:
            return C(c, /(.+?):(\d+)(\s*\/\s*(span)?\s*(\d+))?(.*)/, function(r, a, n, s, t, u, i) {
                return e + a + ":" + n + i + (s ? e + a + "-span:" + (t ? u : +u - +n) + i : "") + c;
            });
        case 4949:
            if (A(c, n + 6) === 121) return C(c, ":", ":" + a) + c;
            break;
        case 6444:
            switch(A(c, A(c, 14) === 45 ? 18 : 11)){
                case 120:
                    return C(c, /(.+:)([^;\s!]+)(;|(\s+)?!.+)?/, "$1" + a + (A(c, 14) === 45 ? "inline-" : "") + "box$3" + "$1" + a + "$2$3" + "$1" + e + "$2box$3") + c;
                case 100:
                    return C(c, ":", ":" + e) + c;
            }
            break;
        case 5719:
        case 2647:
        case 2135:
        case 3927:
        case 2391:
            return C(c, "scroll-", "scroll-snap-") + c;
    }
    return c;
}
function ve(e, r) {
    var a = "";
    for(var c = 0; c < e.length; c++)a += r(e[c], c, e, r) || "";
    return a;
}
function be(e, r, a, t) {
    switch(e.type){
        case g:
            if (e.children.length) break;
        case i:
        case v:
        case s:
            return e.return = e.return || e.value;
        case c:
            return "";
        case b:
            return e.return = e.value + "{" + ve(e.children, t) + "}";
        case n:
            if (!S(e.value = e.props.join(","))) return "";
    }
    return S(a = ve(e.children, t)) ? e.return = e.value + "{" + a + "}" : "";
}
function he(e) {
    var r = q(e);
    return function(a, c, n, s) {
        var t = "";
        for(var u = 0; u < r; u++)t += e[u](a, c, n, s) || "";
        return t;
    };
}
function we(e) {
    return function(r) {
        if (!r.root) {
            if (r = r.return) e(r);
        }
    };
}
function de(c, t, u, i) {
    if (c.length > -1) {
        if (!c.return) switch(c.type){
            case s:
                c.return = pe(c.value, c.length, u);
                return;
            case b:
                return ve([
                    N(c, {
                        value: C(c.value, "@", "@" + a)
                    })
                ], i);
            case n:
                if (c.length) return D(u = c.props, function(n) {
                    switch(z(n, i = /(::plac\w+|:read-\w+)/)){
                        case ":read-only":
                        case ":read-write":
                            P(N(c, {
                                props: [
                                    C(n, /:(read-\w+)/, ":" + r + "$1")
                                ]
                            }));
                            P(N(c, {
                                props: [
                                    n
                                ]
                            }));
                            x(c, {
                                props: E(u, i)
                            });
                            break;
                        case "::placeholder":
                            P(N(c, {
                                props: [
                                    C(n, /:(plac\w+)/, ":" + a + "input-$1")
                                ]
                            }));
                            P(N(c, {
                                props: [
                                    C(n, /:(plac\w+)/, ":" + r + "$1")
                                ]
                            }));
                            P(N(c, {
                                props: [
                                    C(n, /:(plac\w+)/, e + "input-$1")
                                ]
                            }));
                            P(N(c, {
                                props: [
                                    n
                                ]
                            }));
                            x(c, {
                                props: E(u, i)
                            });
                            break;
                    }
                    return "";
                });
        }
    }
}
function ge(e) {
    switch(e.type){
        case n:
            e.props = e.props.map(function(r) {
                return D(ee(r), function(r, a, c) {
                    switch(A(r, 0)){
                        case 12:
                            return M(r, 1, S(r));
                        case 0:
                        case 40:
                        case 43:
                        case 62:
                        case 126:
                            return r;
                        case 58:
                            if (c[++a] === "global") c[a] = "", c[++a] = "\f" + M(c[a], a = 1, -1);
                        case 32:
                            return a === 1 ? "" : r;
                        default:
                            switch(a){
                                case 0:
                                    e = r;
                                    return q(c) > 1 ? "" : r;
                                case a = q(c) - 1:
                                case 2:
                                    return a === 2 ? r + e + e : r + e;
                                default:
                                    return r;
                            }
                    }
                });
            });
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hCOnc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "contentQuotesLinter", ()=>(0, _contentQuotesLinterDefault.default));
parcelHelpers.export(exports, "hashedAnimationLinter", ()=>(0, _hashedAnimationLinterDefault.default));
parcelHelpers.export(exports, "legacyNotSelectorLinter", ()=>(0, _legacyNotSelectorLinterDefault.default));
parcelHelpers.export(exports, "logicalPropertiesLinter", ()=>(0, _logicalPropertiesLinterDefault.default));
parcelHelpers.export(exports, "NaNLinter", ()=>(0, _naNLinterDefault.default));
parcelHelpers.export(exports, "parentSelectorLinter", ()=>(0, _parentSelectorLinterDefault.default));
var _contentQuotesLinter = require("./contentQuotesLinter");
var _contentQuotesLinterDefault = parcelHelpers.interopDefault(_contentQuotesLinter);
var _hashedAnimationLinter = require("./hashedAnimationLinter");
var _hashedAnimationLinterDefault = parcelHelpers.interopDefault(_hashedAnimationLinter);
var _legacyNotSelectorLinter = require("./legacyNotSelectorLinter");
var _legacyNotSelectorLinterDefault = parcelHelpers.interopDefault(_legacyNotSelectorLinter);
var _logicalPropertiesLinter = require("./logicalPropertiesLinter");
var _logicalPropertiesLinterDefault = parcelHelpers.interopDefault(_logicalPropertiesLinter);
var _naNLinter = require("./NaNLinter");
var _naNLinterDefault = parcelHelpers.interopDefault(_naNLinter);
var _parentSelectorLinter = require("./parentSelectorLinter");
var _parentSelectorLinterDefault = parcelHelpers.interopDefault(_parentSelectorLinter);

},{"./contentQuotesLinter":"5KtJF","./hashedAnimationLinter":"dn9oP","./legacyNotSelectorLinter":"3D1HL","./logicalPropertiesLinter":"iAryQ","./NaNLinter":"gRb9p","./parentSelectorLinter":"73FyQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5KtJF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("./utils");
const linter = (key, value, info)=>{
    if (key === 'content') {
        // From emotion: https://github.com/emotion-js/emotion/blob/main/packages/serialize/src/index.js#L63
        const contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
        const contentValues = [
            'normal',
            'none',
            'initial',
            'inherit',
            'unset'
        ];
        if (typeof value !== 'string' || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && !value.startsWith('var(') && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) (0, _utils.lintWarning)(`You seem to be using a value for 'content' without quotes, try replacing it with \`content: '"${value}"'\`.`, info);
    }
};
exports.default = linter;

},{"./utils":"hmjnT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hmjnT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lintWarning", ()=>lintWarning);
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function lintWarning(message, info) {
    const { path, parentSelectors } = info;
    (0, _warningDefault.default)(false, `[Ant Design CSS-in-JS] ${path ? `Error in ${path}: ` : ''}${message}${parentSelectors.length ? ` Selector: ${parentSelectors.join(' | ')}` : ''}`);
}

},{"@rc-component/util/es/warning":"hJXDS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dn9oP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("./utils");
const linter = (key, value, info)=>{
    if (key === 'animation') {
        if (info.hashId && value !== 'none') (0, _utils.lintWarning)(`You seem to be using hashed animation '${value}', in which case 'animationName' with Keyframe as value is recommended.`, info);
    }
};
exports.default = linter;

},{"./utils":"hmjnT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3D1HL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("./utils");
function isConcatSelector(selector) {
    const notContent = selector.match(/:not\(([^)]*)\)/)?.[1] || '';
    // split selector. e.g.
    // `h1#a.b` => ['h1', #a', '.b']
    const splitCells = notContent.split(/(\[[^[]*])|(?=[.#])/).filter((str)=>str);
    return splitCells.length > 1;
}
function parsePath(info) {
    return info.parentSelectors.reduce((prev, cur)=>{
        if (!prev) return cur;
        return cur.includes('&') ? cur.replace(/&/g, prev) : `${prev} ${cur}`;
    }, '');
}
const linter = (key, value, info)=>{
    const parentSelectorPath = parsePath(info);
    const notList = parentSelectorPath.match(/:not\([^)]*\)/g) || [];
    if (notList.length > 0 && notList.some(isConcatSelector)) (0, _utils.lintWarning)(`Concat ':not' selector not support in legacy browsers.`, info);
};
exports.default = linter;

},{"./utils":"hmjnT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iAryQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("./utils");
const linter = (key, value, info)=>{
    switch(key){
        case 'marginLeft':
        case 'marginRight':
        case 'paddingLeft':
        case 'paddingRight':
        case 'left':
        case 'right':
        case 'borderLeft':
        case 'borderLeftWidth':
        case 'borderLeftStyle':
        case 'borderLeftColor':
        case 'borderRight':
        case 'borderRightWidth':
        case 'borderRightStyle':
        case 'borderRightColor':
        case 'borderTopLeftRadius':
        case 'borderTopRightRadius':
        case 'borderBottomLeftRadius':
        case 'borderBottomRightRadius':
            (0, _utils.lintWarning)(`You seem to be using non-logical property '${key}' which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            return;
        case 'margin':
        case 'padding':
        case 'borderWidth':
        case 'borderStyle':
            // case 'borderColor':
            if (typeof value === 'string') {
                const valueArr = value.split(' ').map((item)=>item.trim());
                if (valueArr.length === 4 && valueArr[1] !== valueArr[3]) (0, _utils.lintWarning)(`You seem to be using '${key}' property with different left ${key} and right ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            }
            return;
        case 'clear':
        case 'textAlign':
            if (value === 'left' || value === 'right') (0, _utils.lintWarning)(`You seem to be using non-logical value '${value}' of ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            return;
        case 'borderRadius':
            if (typeof value === 'string') {
                const radiusGroups = value.split('/').map((item)=>item.trim());
                const invalid = radiusGroups.reduce((result, group)=>{
                    if (result) return result;
                    const radiusArr = group.split(' ').map((item)=>item.trim());
                    // borderRadius: '2px 4px'
                    if (radiusArr.length >= 2 && radiusArr[0] !== radiusArr[1]) return true;
                    // borderRadius: '4px 4px 2px'
                    if (radiusArr.length === 3 && radiusArr[1] !== radiusArr[2]) return true;
                    // borderRadius: '4px 4px 2px 4px'
                    if (radiusArr.length === 4 && radiusArr[2] !== radiusArr[3]) return true;
                    return result;
                }, false);
                if (invalid) (0, _utils.lintWarning)(`You seem to be using non-logical value '${value}' of ${key}, which is not compatible with RTL mode. Please use logical properties and values instead. For more information: https://developer.mozilla.org/en-US/docs/Web/CSS/CSS_Logical_Properties.`, info);
            }
            return;
        default:
    }
};
exports.default = linter;

},{"./utils":"hmjnT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gRb9p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("./utils");
const linter = (key, value, info)=>{
    if (typeof value === 'string' && /NaN/g.test(value) || Number.isNaN(value)) (0, _utils.lintWarning)(`Unexpected 'NaN' in property '${key}: ${value}'.`, info);
};
exports.default = linter;

},{"./utils":"hmjnT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"73FyQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utils = require("./utils");
const linter = (key, value, info)=>{
    if (info.parentSelectors.some((selector)=>{
        const selectors = selector.split(',');
        return selectors.some((item)=>item.split('&').length > 2);
    })) (0, _utils.lintWarning)('Should not use more than one `&` in a selector.', info);
};
exports.default = linter;

},{"./utils":"hmjnT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5Ya3U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ATTR_CACHE_MAP", ()=>ATTR_CACHE_MAP);
parcelHelpers.export(exports, "CSS_FILE_STYLE", ()=>CSS_FILE_STYLE);
parcelHelpers.export(exports, "serialize", ()=>serialize);
/**
 * @private Test usage only. Can save remove if no need.
 */ parcelHelpers.export(exports, "reset", ()=>reset);
parcelHelpers.export(exports, "prepare", ()=>prepare);
parcelHelpers.export(exports, "existPath", ()=>existPath);
parcelHelpers.export(exports, "getStyleAndHash", ()=>getStyleAndHash);
var _canUseDom = require("@rc-component/util/es/Dom/canUseDom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
var _styleContext = require("../StyleContext");
const ATTR_CACHE_MAP = 'data-ant-cssinjs-cache-path';
const CSS_FILE_STYLE = '_FILE_STYLE__';
function serialize(cachePathMap) {
    return Object.keys(cachePathMap).map((path)=>{
        const hash = cachePathMap[path];
        return `${path}:${hash}`;
    }).join(';');
}
let cachePathMap;
let fromCSSFile = true;
function reset(mockCache, fromFile = true) {
    cachePathMap = mockCache;
    fromCSSFile = fromFile;
}
function prepare() {
    if (!cachePathMap) {
        cachePathMap = {};
        if ((0, _canUseDomDefault.default)()) {
            const div = document.createElement('div');
            div.className = ATTR_CACHE_MAP;
            div.style.position = 'fixed';
            div.style.visibility = 'hidden';
            div.style.top = '-9999px';
            document.body.appendChild(div);
            let content = getComputedStyle(div).content || '';
            content = content.replace(/^"/, '').replace(/"$/, '');
            // Fill data
            content.split(';').forEach((item)=>{
                const [path, hash] = item.split(':');
                cachePathMap[path] = hash;
            });
            // Remove inline record style
            const inlineMapStyle = document.querySelector(`style[${ATTR_CACHE_MAP}]`);
            if (inlineMapStyle) {
                fromCSSFile = false;
                inlineMapStyle.parentNode?.removeChild(inlineMapStyle);
            }
            document.body.removeChild(div);
        }
    }
}
function existPath(path) {
    prepare();
    return !!cachePathMap[path];
}
function getStyleAndHash(path) {
    const hash = cachePathMap[path];
    let styleStr = null;
    if (hash && (0, _canUseDomDefault.default)()) {
        if (fromCSSFile) styleStr = CSS_FILE_STYLE;
        else {
            const style = document.querySelector(`style[${(0, _styleContext.ATTR_MARK)}="${cachePathMap[path]}"]`);
            if (style) styleStr = style.innerHTML;
            else // Clean up since not exist anymore
            delete cachePathMap[path];
        }
    }
    return [
        styleStr,
        hash
    ];
}

},{"@rc-component/util/es/Dom/canUseDom":"4Ky1R","../StyleContext":"bAgk8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2BRAF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
class Keyframe {
    name;
    style;
    constructor(name, style){
        this.name = name;
        this.style = style;
    }
    getName(hashId = '') {
        return hashId ? `${hashId}-${this.name}` : this.name;
    }
    _keyframe = true;
}
exports.default = Keyframe;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lvjDq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function splitValues(value) {
    if (typeof value === 'number') return [
        [
            value
        ],
        false
    ];
    const rawStyle = String(value).trim();
    const importantCells = rawStyle.match(/(.*)(!important)/);
    const splitStyle = (importantCells ? importantCells[1] : rawStyle).trim().split(/\s+/);
    // Combine styles split in brackets, like `calc(1px + 2px)`
    let temp = [];
    let brackets = 0;
    return [
        splitStyle.reduce((list, item)=>{
            if (item.includes('(') || item.includes(')')) {
                const left = item.split('(').length - 1;
                const right = item.split(')').length - 1;
                brackets += left - right;
            }
            if (brackets >= 0) temp.push(item);
            if (brackets === 0) {
                list.push(temp.join(' '));
                temp = [];
            }
            return list;
        }, []),
        !!importantCells
    ];
}
function noSplit(list) {
    list.notSplit = true;
    return list;
}
const keyMap = {
    // Inset
    inset: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    insetBlock: [
        'top',
        'bottom'
    ],
    insetBlockStart: [
        'top'
    ],
    insetBlockEnd: [
        'bottom'
    ],
    insetInline: [
        'left',
        'right'
    ],
    insetInlineStart: [
        'left'
    ],
    insetInlineEnd: [
        'right'
    ],
    // Margin
    marginBlock: [
        'marginTop',
        'marginBottom'
    ],
    marginBlockStart: [
        'marginTop'
    ],
    marginBlockEnd: [
        'marginBottom'
    ],
    marginInline: [
        'marginLeft',
        'marginRight'
    ],
    marginInlineStart: [
        'marginLeft'
    ],
    marginInlineEnd: [
        'marginRight'
    ],
    // Padding
    paddingBlock: [
        'paddingTop',
        'paddingBottom'
    ],
    paddingBlockStart: [
        'paddingTop'
    ],
    paddingBlockEnd: [
        'paddingBottom'
    ],
    paddingInline: [
        'paddingLeft',
        'paddingRight'
    ],
    paddingInlineStart: [
        'paddingLeft'
    ],
    paddingInlineEnd: [
        'paddingRight'
    ],
    // Border
    borderBlock: noSplit([
        'borderTop',
        'borderBottom'
    ]),
    borderBlockStart: noSplit([
        'borderTop'
    ]),
    borderBlockEnd: noSplit([
        'borderBottom'
    ]),
    borderInline: noSplit([
        'borderLeft',
        'borderRight'
    ]),
    borderInlineStart: noSplit([
        'borderLeft'
    ]),
    borderInlineEnd: noSplit([
        'borderRight'
    ]),
    // Border width
    borderBlockWidth: [
        'borderTopWidth',
        'borderBottomWidth'
    ],
    borderBlockStartWidth: [
        'borderTopWidth'
    ],
    borderBlockEndWidth: [
        'borderBottomWidth'
    ],
    borderInlineWidth: [
        'borderLeftWidth',
        'borderRightWidth'
    ],
    borderInlineStartWidth: [
        'borderLeftWidth'
    ],
    borderInlineEndWidth: [
        'borderRightWidth'
    ],
    // Border style
    borderBlockStyle: [
        'borderTopStyle',
        'borderBottomStyle'
    ],
    borderBlockStartStyle: [
        'borderTopStyle'
    ],
    borderBlockEndStyle: [
        'borderBottomStyle'
    ],
    borderInlineStyle: [
        'borderLeftStyle',
        'borderRightStyle'
    ],
    borderInlineStartStyle: [
        'borderLeftStyle'
    ],
    borderInlineEndStyle: [
        'borderRightStyle'
    ],
    // Border color
    borderBlockColor: [
        'borderTopColor',
        'borderBottomColor'
    ],
    borderBlockStartColor: [
        'borderTopColor'
    ],
    borderBlockEndColor: [
        'borderBottomColor'
    ],
    borderInlineColor: [
        'borderLeftColor',
        'borderRightColor'
    ],
    borderInlineStartColor: [
        'borderLeftColor'
    ],
    borderInlineEndColor: [
        'borderRightColor'
    ],
    // Border radius
    borderStartStartRadius: [
        'borderTopLeftRadius'
    ],
    borderStartEndRadius: [
        'borderTopRightRadius'
    ],
    borderEndStartRadius: [
        'borderBottomLeftRadius'
    ],
    borderEndEndRadius: [
        'borderBottomRightRadius'
    ]
};
function wrapImportantAndSkipCheck(value, important) {
    let parsedValue = value;
    if (important) parsedValue = `${parsedValue} !important`;
    return {
        _skip_check_: true,
        value: parsedValue
    };
}
/**
 * Convert css logical properties to legacy properties.
 * Such as: `margin-block-start` to `margin-top`.
 * Transform list:
 * - inset
 * - margin
 * - padding
 * - border
 */ const transform = {
    visit: (cssObj)=>{
        const clone = {};
        Object.keys(cssObj).forEach((key)=>{
            const value = cssObj[key];
            const matchValue = keyMap[key];
            if (matchValue && (typeof value === 'number' || typeof value === 'string')) {
                const [values, important] = splitValues(value);
                if (matchValue.length && matchValue.notSplit) // not split means always give same value like border
                matchValue.forEach((matchKey)=>{
                    clone[matchKey] = wrapImportantAndSkipCheck(value, important);
                });
                else if (matchValue.length === 1) // Handle like `marginBlockStart` => `marginTop`
                clone[matchValue[0]] = wrapImportantAndSkipCheck(values[0], important);
                else if (matchValue.length === 2) // Handle like `marginBlock` => `marginTop` & `marginBottom`
                matchValue.forEach((matchKey, index)=>{
                    clone[matchKey] = wrapImportantAndSkipCheck(values[index] ?? values[0], important);
                });
                else if (matchValue.length === 4) // Handle like `inset` => `top` & `right` & `bottom` & `left`
                matchValue.forEach((matchKey, index)=>{
                    clone[matchKey] = wrapImportantAndSkipCheck(values[index] ?? values[index - 2] ?? values[0], important);
                });
                else clone[key] = value;
            } else clone[key] = value;
        });
        return clone;
    }
};
exports.default = transform;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"joY72":[function(require,module,exports,__globalThis) {
/**
 * respect https://github.com/cuth/postcss-pxtorem
 */ // @ts-ignore
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _unitless = require("@emotion/unitless");
var _unitlessDefault = parcelHelpers.interopDefault(_unitless);
const pxRegex = /url\([^)]+\)|var\([^)]+\)|(\d*\.?\d+)px/g;
function toFixed(number, precision) {
    const multiplier = Math.pow(10, precision + 1), wholeNumber = Math.floor(number * multiplier);
    return Math.round(wholeNumber / 10) * 10 / multiplier;
}
const transform = (options = {})=>{
    const { rootValue = 16, precision = 5, mediaQuery = false } = options;
    const pxReplace = (m, $1)=>{
        if (!$1) return m;
        const pixels = parseFloat($1);
        // covenant: pixels <= 1, not transform to rem @zombieJ
        if (pixels <= 1) return m;
        const fixedVal = toFixed(pixels / rootValue, precision);
        return `${fixedVal}rem`;
    };
    const visit = (cssObj)=>{
        const clone = {
            ...cssObj
        };
        Object.entries(cssObj).forEach(([key, value])=>{
            if (typeof value === 'string' && value.includes('px')) {
                const newValue = value.replace(pxRegex, pxReplace);
                clone[key] = newValue;
            }
            // no unit
            if (!(0, _unitlessDefault.default)[key] && typeof value === 'number' && value !== 0) clone[key] = `${value}px`.replace(pxRegex, pxReplace);
            // Media queries
            const mergedKey = key.trim();
            if (mergedKey.startsWith('@') && mergedKey.includes('px') && mediaQuery) {
                const newKey = key.replace(pxRegex, pxReplace);
                clone[newKey] = clone[key];
                delete clone[key];
            }
        });
        return clone;
    };
    return {
        visit
    };
};
exports.default = transform;

},{"@emotion/unitless":"gQBa1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"112Bq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const IconContext = /*#__PURE__*/ (0, _react.createContext)({});
exports.default = IconContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hiF2w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
// ZombieJ: We export single file here since
// ConfigProvider use this which will make loop deps
// to import whole `rc-component/form`
exports.default = /*#__PURE__*/ (0, _react.createContext)(undefined);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bXgWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useLocale", ()=>(0, _useLocaleDefault.default));
parcelHelpers.export(exports, "ANT_MARK", ()=>ANT_MARK);
var _react = require("react");
var _warning = require("../_util/warning");
var _locale = require("../modal/locale");
var _context = require("./context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _useLocale = require("./useLocale");
var _useLocaleDefault = parcelHelpers.interopDefault(_useLocale);
"use client";
const ANT_MARK = 'internalMark';
const LocaleProvider = (props)=>{
    const { locale = {}, children, _ANT_MARK__ } = props;
    _react.useEffect(()=>{
        const clearLocale = (0, _locale.changeConfirmLocale)(locale?.Modal);
        return clearLocale;
    }, [
        locale
    ]);
    const getMemoizedContextValue = _react.useMemo(()=>({
            ...locale,
            exist: true
        }), [
        locale
    ]);
    return /*#__PURE__*/ _react.createElement((0, _contextDefault.default).Provider, {
        value: getMemoizedContextValue
    }, children);
};
exports.default = LocaleProvider;

},{"react":"bmhQu","../_util/warning":"95o3w","../modal/locale":"1mpkH","./context":"l4UXv","./useLocale":"l6QvX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1mpkH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "changeConfirmLocale", ()=>changeConfirmLocale);
parcelHelpers.export(exports, "getConfirmLocale", ()=>getConfirmLocale);
var _enUS = require("../locale/en_US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
let runtimeLocale = {
    ...(0, _enUSDefault.default).Modal
};
let localeList = [];
const generateLocale = ()=>localeList.reduce((merged, locale)=>({
            ...merged,
            ...locale
        }), (0, _enUSDefault.default).Modal);
function changeConfirmLocale(newLocale) {
    if (newLocale) {
        const cloneLocale = {
            ...newLocale
        };
        localeList.push(cloneLocale);
        runtimeLocale = generateLocale();
        return ()=>{
            localeList = localeList.filter((locale)=>locale !== cloneLocale);
            runtimeLocale = generateLocale();
        };
    }
    runtimeLocale = {
        ...(0, _enUSDefault.default).Modal
    };
}
function getConfirmLocale() {
    return runtimeLocale;
}

},{"../locale/en_US":"cgwsy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cgwsy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enUS = require("@rc-component/pagination/es/locale/en_US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
var _enUS1 = require("../calendar/locale/en_US");
var _enUSDefault1 = parcelHelpers.interopDefault(_enUS1);
var _enUS2 = require("../date-picker/locale/en_US");
var _enUSDefault2 = parcelHelpers.interopDefault(_enUS2);
var _enUS3 = require("../time-picker/locale/en_US");
var _enUSDefault3 = parcelHelpers.interopDefault(_enUS3);
const typeTemplate = '${label} is not a valid ${type}';
const localeValues = {
    locale: 'en',
    Pagination: (0, _enUSDefault.default),
    DatePicker: (0, _enUSDefault2.default),
    TimePicker: (0, _enUSDefault3.default),
    Calendar: (0, _enUSDefault1.default),
    global: {
        placeholder: 'Please select',
        close: 'Close',
        sortable: 'sortable'
    },
    Table: {
        filterTitle: 'Filter menu',
        filterConfirm: 'OK',
        filterReset: 'Reset',
        filterEmptyText: 'No filters',
        filterCheckAll: 'Select all items',
        filterSearchPlaceholder: 'Search in filters',
        emptyText: 'No data',
        selectAll: 'Select current page',
        selectInvert: 'Invert current page',
        selectNone: 'Clear all data',
        selectionAll: 'Select all data',
        sortTitle: 'Sort',
        expand: 'Expand row',
        collapse: 'Collapse row',
        triggerDesc: 'Click to sort descending',
        triggerAsc: 'Click to sort ascending',
        cancelSort: 'Click to cancel sorting'
    },
    Tour: {
        Next: 'Next',
        Previous: 'Previous',
        Finish: 'Finish'
    },
    Modal: {
        okText: 'OK',
        cancelText: 'Cancel',
        justOkText: 'OK'
    },
    Popconfirm: {
        okText: 'OK',
        cancelText: 'Cancel'
    },
    Transfer: {
        titles: [
            '',
            ''
        ],
        searchPlaceholder: 'Search here',
        itemUnit: 'item',
        itemsUnit: 'items',
        remove: 'Remove',
        selectCurrent: 'Select current page',
        removeCurrent: 'Remove current page',
        selectAll: 'Select all data',
        deselectAll: 'Deselect all data',
        removeAll: 'Remove all data',
        selectInvert: 'Invert current page'
    },
    Upload: {
        uploading: 'Uploading...',
        removeFile: 'Remove file',
        uploadError: 'Upload error',
        previewFile: 'Preview file',
        downloadFile: 'Download file'
    },
    Empty: {
        description: 'No data'
    },
    Icon: {
        icon: 'icon'
    },
    Text: {
        edit: 'Edit',
        copy: 'Copy',
        copied: 'Copied',
        expand: 'Expand',
        collapse: 'Collapse'
    },
    Form: {
        optional: '(optional)',
        defaultValidateMessages: {
            default: 'Field validation error for ${label}',
            required: 'Please enter ${label}',
            enum: '${label} must be one of [${enum}]',
            whitespace: '${label} cannot be a blank character',
            date: {
                format: '${label} date format is invalid',
                parse: '${label} cannot be converted to a date',
                invalid: '${label} is an invalid date'
            },
            types: {
                string: typeTemplate,
                method: typeTemplate,
                array: typeTemplate,
                object: typeTemplate,
                number: typeTemplate,
                date: typeTemplate,
                boolean: typeTemplate,
                integer: typeTemplate,
                float: typeTemplate,
                regexp: typeTemplate,
                email: typeTemplate,
                url: typeTemplate,
                hex: typeTemplate
            },
            string: {
                len: '${label} must be ${len} characters',
                min: '${label} must be at least ${min} characters',
                max: '${label} must be up to ${max} characters',
                range: '${label} must be between ${min}-${max} characters'
            },
            number: {
                len: '${label} must be equal to ${len}',
                min: '${label} must be minimum ${min}',
                max: '${label} must be maximum ${max}',
                range: '${label} must be between ${min}-${max}'
            },
            array: {
                len: 'Must be ${len} ${label}',
                min: 'At least ${min} ${label}',
                max: 'At most ${max} ${label}',
                range: 'The amount of ${label} must be between ${min}-${max}'
            },
            pattern: {
                mismatch: '${label} does not match the pattern ${pattern}'
            }
        }
    },
    QRCode: {
        expired: 'QR code expired',
        refresh: 'Refresh',
        scanned: 'Scanned'
    },
    ColorPicker: {
        presetEmpty: 'Empty',
        transparent: 'Transparent',
        singleColor: 'Single',
        gradientColor: 'Gradient'
    }
};
exports.default = localeValues;

},{"@rc-component/pagination/es/locale/en_US":"c7F2M","../calendar/locale/en_US":"4DN9A","../date-picker/locale/en_US":"bGutz","../time-picker/locale/en_US":"dCuQS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c7F2M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const locale = {
    // Options
    items_per_page: '/ page',
    jump_to: 'Go to',
    jump_to_confirm: 'confirm',
    page: 'Page',
    // Pagination
    prev_page: 'Previous Page',
    next_page: 'Next Page',
    prev_5: 'Previous 5 Pages',
    next_5: 'Next 5 Pages',
    prev_3: 'Previous 3 Pages',
    next_3: 'Next 3 Pages',
    page_size: 'Page Size'
};
exports.default = locale;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4DN9A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enUS = require("../../date-picker/locale/en_US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
exports.default = (0, _enUSDefault.default);

},{"../../date-picker/locale/en_US":"bGutz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bGutz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _enUS = require("@rc-component/picker/locale/en_US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
var _enUS1 = require("../../time-picker/locale/en_US");
var _enUSDefault1 = parcelHelpers.interopDefault(_enUS1);
// Merge into a locale object
const locale = {
    lang: {
        placeholder: 'Select date',
        yearPlaceholder: 'Select year',
        quarterPlaceholder: 'Select quarter',
        monthPlaceholder: 'Select month',
        weekPlaceholder: 'Select week',
        rangePlaceholder: [
            'Start date',
            'End date'
        ],
        rangeYearPlaceholder: [
            'Start year',
            'End year'
        ],
        rangeQuarterPlaceholder: [
            'Start quarter',
            'End quarter'
        ],
        rangeMonthPlaceholder: [
            'Start month',
            'End month'
        ],
        rangeWeekPlaceholder: [
            'Start week',
            'End week'
        ],
        ...(0, _enUSDefault.default)
    },
    timePickerLocale: {
        ...(0, _enUSDefault1.default)
    }
};
// All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
exports.default = locale;

},{"@rc-component/picker/locale/en_US":"eRNJn","../../time-picker/locale/en_US":"dCuQS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eRNJn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _common = require("./common");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var locale = _objectSpread(_objectSpread({}, (0, _common.commonLocale)), {}, {
    locale: 'en_US',
    today: 'Today',
    now: 'Now',
    backToToday: 'Back to today',
    ok: 'OK',
    clear: 'Clear',
    week: 'Week',
    month: 'Month',
    year: 'Year',
    timeSelect: 'select time',
    dateSelect: 'select date',
    weekSelect: 'Choose a week',
    monthSelect: 'Choose a month',
    yearSelect: 'Choose a year',
    decadeSelect: 'Choose a decade',
    previousMonth: 'Previous month (PageUp)',
    nextMonth: 'Next month (PageDown)',
    previousYear: 'Last year (Control + left)',
    nextYear: 'Next year (Control + right)',
    previousDecade: 'Last decade',
    nextDecade: 'Next decade',
    previousCentury: 'Last century',
    nextCentury: 'Next century'
});
exports.default = locale;

},{"./common":"IxoqI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"IxoqI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "commonLocale", ()=>commonLocale);
var commonLocale = {
    yearFormat: 'YYYY',
    dayFormat: 'D',
    cellMeridiemFormat: 'A',
    monthBeforeYear: true
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dCuQS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const locale = {
    placeholder: 'Select time',
    rangePlaceholder: [
        'Start time',
        'End time'
    ]
};
exports.default = locale;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l4UXv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const LocaleContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
exports.default = LocaleContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l6QvX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _context = require("./context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _enUS = require("./en_US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
const useLocale = (componentName, defaultLocale)=>{
    const fullLocale = _react.useContext((0, _contextDefault.default));
    const getLocale = _react.useMemo(()=>{
        const locale = defaultLocale || (0, _enUSDefault.default)[componentName];
        const localeFromContext = fullLocale?.[componentName] ?? {};
        return {
            ...typeof locale === 'function' ? locale() : locale,
            ...localeFromContext || {}
        };
    }, [
        componentName,
        defaultLocale,
        fullLocale
    ]);
    const getLocaleCode = _react.useMemo(()=>{
        const localeCode = fullLocale?.locale;
        // Had use LocaleProvide but didn't set locale
        if (fullLocale?.exist && !localeCode) return (0, _enUSDefault.default).locale;
        return localeCode;
    }, [
        fullLocale
    ]);
    return [
        getLocale,
        getLocaleCode
    ];
};
exports.default = useLocale;

},{"react":"bmhQu","./context":"l4UXv","./en_US":"cgwsy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ia1Cg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
var _index = require("./index");
var _indexDefault = parcelHelpers.interopDefault(_index);
const defaultTheme = (0, _cssinjs.createTheme)((0, _indexDefault.default));
exports.default = defaultTheme;

},{"@ant-design/cssinjs":"2VNL8","./index":"hZOWL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hZOWL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>derivative);
var _colors = require("@ant-design/colors");
var _seed = require("../seed");
var _genColorMapToken = require("../shared/genColorMapToken");
var _genColorMapTokenDefault = parcelHelpers.interopDefault(_genColorMapToken);
var _genCommonMapToken = require("../shared/genCommonMapToken");
var _genCommonMapTokenDefault = parcelHelpers.interopDefault(_genCommonMapToken);
var _genControlHeight = require("../shared/genControlHeight");
var _genControlHeightDefault = parcelHelpers.interopDefault(_genControlHeight);
var _genFontMapToken = require("../shared/genFontMapToken");
var _genFontMapTokenDefault = parcelHelpers.interopDefault(_genFontMapToken);
var _genSizeMapToken = require("../shared/genSizeMapToken");
var _genSizeMapTokenDefault = parcelHelpers.interopDefault(_genSizeMapToken);
var _colors1 = require("./colors");
function derivative(token) {
    // pink is deprecated name of magenta, keep this for backwards compatibility
    (0, _colors.presetPrimaryColors).pink = (0, _colors.presetPrimaryColors).magenta;
    (0, _colors.presetPalettes).pink = (0, _colors.presetPalettes).magenta;
    const colorPalettes = Object.keys((0, _seed.defaultPresetColors)).map((colorKey)=>{
        const colors = token[colorKey] === (0, _colors.presetPrimaryColors)[colorKey] ? (0, _colors.presetPalettes)[colorKey] : (0, _colors.generate)(token[colorKey]);
        return Array.from({
            length: 10
        }, ()=>1).reduce((prev, _, i)=>{
            prev[`${colorKey}-${i + 1}`] = colors[i];
            prev[`${colorKey}${i + 1}`] = colors[i];
            return prev;
        }, {});
    }).reduce((prev, cur)=>{
        prev = {
            ...prev,
            ...cur
        };
        return prev;
    }, {});
    return {
        ...token,
        ...colorPalettes,
        // Colors
        ...(0, _genColorMapTokenDefault.default)(token, {
            generateColorPalettes: (0, _colors1.generateColorPalettes),
            generateNeutralColorPalettes: (0, _colors1.generateNeutralColorPalettes)
        }),
        // Font
        ...(0, _genFontMapTokenDefault.default)(token.fontSize),
        // Size
        ...(0, _genSizeMapTokenDefault.default)(token),
        // Height
        ...(0, _genControlHeightDefault.default)(token),
        // Others
        ...(0, _genCommonMapTokenDefault.default)(token)
    };
}

},{"@ant-design/colors":"350gL","../seed":"aeTHW","../shared/genColorMapToken":"gfAX9","../shared/genCommonMapToken":"8rQvM","../shared/genControlHeight":"6fvky","../shared/genFontMapToken":"ffxwm","../shared/genSizeMapToken":"9DYNY","./colors":"7QaoO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"350gL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generate", ()=>(0, _generateDefault.default));
var _generate = require("./generate");
var _generateDefault = parcelHelpers.interopDefault(_generate);
var _presets = require("./presets");
parcelHelpers.exportAll(_presets, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./generate":"6nOsh","./presets":"jxWva","./types":"jTuMg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6nOsh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>generate);
var _fastColor = require("@ant-design/fast-color");
const hueStep = 2; // 色相阶梯
const saturationStep = 0.16; // 饱和度阶梯，浅色部分
const saturationStep2 = 0.05; // 饱和度阶梯，深色部分
const brightnessStep1 = 0.05; // 亮度阶梯，浅色部分
const brightnessStep2 = 0.15; // 亮度阶梯，深色部分
const lightColorCount = 5; // 浅色数量，主色上
const darkColorCount = 4; // 深色数量，主色下
// 暗色主题颜色映射关系表
const darkColorMap = [
    {
        index: 7,
        amount: 15
    },
    {
        index: 6,
        amount: 25
    },
    {
        index: 5,
        amount: 30
    },
    {
        index: 5,
        amount: 45
    },
    {
        index: 5,
        amount: 65
    },
    {
        index: 5,
        amount: 85
    },
    {
        index: 4,
        amount: 90
    },
    {
        index: 3,
        amount: 95
    },
    {
        index: 2,
        amount: 97
    },
    {
        index: 1,
        amount: 98
    }
];
function getHue(hsv, i, light) {
    let hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
    else hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
    if (hue < 0) hue += 360;
    else if (hue >= 360) hue -= 360;
    return hue;
}
function getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) return hsv.s;
    let saturation;
    if (light) saturation = hsv.s - saturationStep * i;
    else if (i === darkColorCount) saturation = hsv.s + saturationStep;
    else saturation = hsv.s + saturationStep2 * i;
    // 边界值修正
    if (saturation > 1) saturation = 1;
    // 第一格的 s 限制在 0.06-0.1 之间
    if (light && i === lightColorCount && saturation > 0.1) saturation = 0.1;
    if (saturation < 0.06) saturation = 0.06;
    return Math.round(saturation * 100) / 100;
}
function getValue(hsv, i, light) {
    let value;
    if (light) value = hsv.v + brightnessStep1 * i;
    else value = hsv.v - brightnessStep2 * i;
    // Clamp value between 0 and 1
    value = Math.max(0, Math.min(1, value));
    return Math.round(value * 100) / 100;
}
function generate(color, opts = {}) {
    const patterns = [];
    const pColor = new (0, _fastColor.FastColor)(color);
    const hsv = pColor.toHsv();
    for(let i = lightColorCount; i > 0; i -= 1){
        const c = new (0, _fastColor.FastColor)({
            h: getHue(hsv, i, true),
            s: getSaturation(hsv, i, true),
            v: getValue(hsv, i, true)
        });
        patterns.push(c);
    }
    patterns.push(pColor);
    for(let i = 1; i <= darkColorCount; i += 1){
        const c = new (0, _fastColor.FastColor)({
            h: getHue(hsv, i),
            s: getSaturation(hsv, i),
            v: getValue(hsv, i)
        });
        patterns.push(c);
    }
    // dark theme patterns
    if (opts.theme === 'dark') return darkColorMap.map(({ index, amount })=>new (0, _fastColor.FastColor)(opts.backgroundColor || '#141414').mix(patterns[index], amount).toHexString());
    return patterns.map((c)=>c.toHexString());
}

},{"@ant-design/fast-color":"50VUA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"50VUA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fastColor = require("./FastColor");
parcelHelpers.exportAll(_fastColor, exports);
var _types = require("./types");
parcelHelpers.exportAll(_types, exports);

},{"./FastColor":"iDM9M","./types":"iaEZl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iDM9M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FastColor", ()=>FastColor);
var _presetColors = require("./presetColors");
var _presetColorsDefault = parcelHelpers.interopDefault(_presetColors);
const round = Math.round;
/**
 * Support format, alpha unit will check the % mark:
 * - rgba(102, 204, 255, .5)      -> [102, 204, 255, 0.5]
 * - rgb(102 204 255 / .5)        -> [102, 204, 255, 0.5]
 * - rgb(100%, 50%, 0% / 50%)     -> [255, 128, 0, 0.5]
 * - hsl(270, 60, 40, .5)         -> [270, 60, 40, 0.5]
 * - hsl(270deg 60% 40% / 50%)   -> [270, 60, 40, 0.5]
 *
 * When `base` is provided, the percentage value will be divided by `base`.
 */ function splitColorStr(str, parseNum) {
    const match = str// Remove str before `(`
    .replace(/^[^(]*\((.*)/, '$1')// Remove str after `)`
    .replace(/\).*/, '').match(/\d*\.?\d+%?/g) || [];
    const numList = match.map((item)=>parseFloat(item));
    for(let i = 0; i < 3; i += 1)numList[i] = parseNum(numList[i] || 0, match[i] || '', i);
    // For alpha. 50% should be 0.5
    if (match[3]) numList[3] = match[3].includes('%') ? numList[3] / 100 : numList[3];
    else // By default, alpha is 1
    numList[3] = 1;
    return numList;
}
const parseHSVorHSL = (num, _, index)=>index === 0 ? num : num / 100;
/** round and limit number to integer between 0-255 */ function limitRange(value, max) {
    const mergedMax = max || 255;
    if (value > mergedMax) return mergedMax;
    if (value < 0) return 0;
    return value;
}
class FastColor {
    /**
   * All FastColor objects are valid. So isValid is always true. This property is kept to be compatible with TinyColor.
   */ isValid = true;
    /**
   * Red, R in RGB
   */ r = 0;
    /**
   * Green, G in RGB
   */ g = 0;
    /**
   * Blue, B in RGB
   */ b = 0;
    /**
   * Alpha/Opacity, A in RGBA/HSLA
   */ a = 1;
    // HSV privates
    _h;
    _s;
    _l;
    _v;
    // intermediate variables to calculate HSL/HSV
    _max;
    _min;
    _brightness;
    constructor(input){
        /**
     * Always check 3 char in the object to determine the format.
     * We not use function in check to save bundle size.
     * e.g. 'rgb' -> { r: 0, g: 0, b: 0 }.
     */ function matchFormat(str) {
            return str[0] in input && str[1] in input && str[2] in input;
        }
        if (!input) ;
        else if (typeof input === 'string') {
            const trimStr = input.trim();
            function matchPrefix(prefix) {
                return trimStr.startsWith(prefix);
            }
            if (/^#?[A-F\d]{3,8}$/i.test(trimStr)) this.fromHexString(trimStr);
            else if (matchPrefix('rgb')) this.fromRgbString(trimStr);
            else if (matchPrefix('hsl')) this.fromHslString(trimStr);
            else if (matchPrefix('hsv') || matchPrefix('hsb')) this.fromHsvString(trimStr);
            else {
                // From preset color
                const presetColor = (0, _presetColorsDefault.default)[trimStr.toLowerCase()];
                if (presetColor) this.fromHexString(// Convert 36 hex to 16 hex
                parseInt(presetColor, 36).toString(16).padStart(6, '0'));
            }
        } else if (input instanceof FastColor) {
            this.r = input.r;
            this.g = input.g;
            this.b = input.b;
            this.a = input.a;
            this._h = input._h;
            this._s = input._s;
            this._l = input._l;
            this._v = input._v;
        } else if (matchFormat('rgb')) {
            this.r = limitRange(input.r);
            this.g = limitRange(input.g);
            this.b = limitRange(input.b);
            this.a = typeof input.a === 'number' ? limitRange(input.a, 1) : 1;
        } else if (matchFormat('hsl')) this.fromHsl(input);
        else if (matchFormat('hsv')) this.fromHsv(input);
        else throw new Error('@ant-design/fast-color: unsupported input ' + JSON.stringify(input));
    }
    // ======================= Setter =======================
    setR(value) {
        return this._sc('r', value);
    }
    setG(value) {
        return this._sc('g', value);
    }
    setB(value) {
        return this._sc('b', value);
    }
    setA(value) {
        return this._sc('a', value, 1);
    }
    setHue(value) {
        const hsv = this.toHsv();
        hsv.h = value;
        return this._c(hsv);
    }
    // ======================= Getter =======================
    /**
   * Returns the perceived luminance of a color, from 0-1.
   * @see http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
   */ getLuminance() {
        function adjustGamma(raw) {
            const val = raw / 255;
            return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
        }
        const R = adjustGamma(this.r);
        const G = adjustGamma(this.g);
        const B = adjustGamma(this.b);
        return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    }
    getHue() {
        if (typeof this._h === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._h = 0;
            else this._h = round(60 * (this.r === this.getMax() ? (this.g - this.b) / delta + (this.g < this.b ? 6 : 0) : this.g === this.getMax() ? (this.b - this.r) / delta + 2 : (this.r - this.g) / delta + 4));
        }
        return this._h;
    }
    getSaturation() {
        if (typeof this._s === 'undefined') {
            const delta = this.getMax() - this.getMin();
            if (delta === 0) this._s = 0;
            else this._s = delta / this.getMax();
        }
        return this._s;
    }
    getLightness() {
        if (typeof this._l === 'undefined') this._l = (this.getMax() + this.getMin()) / 510;
        return this._l;
    }
    getValue() {
        if (typeof this._v === 'undefined') this._v = this.getMax() / 255;
        return this._v;
    }
    /**
   * Returns the perceived brightness of the color, from 0-255.
   * Note: this is not the b of HSB
   * @see http://www.w3.org/TR/AERT#color-contrast
   */ getBrightness() {
        if (typeof this._brightness === 'undefined') this._brightness = (this.r * 299 + this.g * 587 + this.b * 114) / 1000;
        return this._brightness;
    }
    // ======================== Func ========================
    darken(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() - amount / 100;
        if (l < 0) l = 0;
        return this._c({
            h,
            s,
            l,
            a: this.a
        });
    }
    lighten(amount = 10) {
        const h = this.getHue();
        const s = this.getSaturation();
        let l = this.getLightness() + amount / 100;
        if (l > 1) l = 1;
        return this._c({
            h,
            s,
            l,
            a: this.a
        });
    }
    /**
   * Mix the current color a given amount with another color, from 0 to 100.
   * 0 means no mixing (return current color).
   */ mix(input, amount = 50) {
        const color = this._c(input);
        const p = amount / 100;
        const calc = (key)=>(color[key] - this[key]) * p + this[key];
        const rgba = {
            r: round(calc('r')),
            g: round(calc('g')),
            b: round(calc('b')),
            a: round(calc('a') * 100) / 100
        };
        return this._c(rgba);
    }
    /**
   * Mix the color with pure white, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return white.
   */ tint(amount = 10) {
        return this.mix({
            r: 255,
            g: 255,
            b: 255,
            a: 1
        }, amount);
    }
    /**
   * Mix the color with pure black, from 0 to 100.
   * Providing 0 will do nothing, providing 100 will always return black.
   */ shade(amount = 10) {
        return this.mix({
            r: 0,
            g: 0,
            b: 0,
            a: 1
        }, amount);
    }
    onBackground(background) {
        const bg = this._c(background);
        const alpha = this.a + bg.a * (1 - this.a);
        const calc = (key)=>{
            return round((this[key] * this.a + bg[key] * bg.a * (1 - this.a)) / alpha);
        };
        return this._c({
            r: calc('r'),
            g: calc('g'),
            b: calc('b'),
            a: alpha
        });
    }
    // ======================= Status =======================
    isDark() {
        return this.getBrightness() < 128;
    }
    isLight() {
        return this.getBrightness() >= 128;
    }
    // ======================== MISC ========================
    equals(other) {
        return this.r === other.r && this.g === other.g && this.b === other.b && this.a === other.a;
    }
    clone() {
        return this._c(this);
    }
    // ======================= Format =======================
    toHexString() {
        let hex = '#';
        const rHex = (this.r || 0).toString(16);
        hex += rHex.length === 2 ? rHex : '0' + rHex;
        const gHex = (this.g || 0).toString(16);
        hex += gHex.length === 2 ? gHex : '0' + gHex;
        const bHex = (this.b || 0).toString(16);
        hex += bHex.length === 2 ? bHex : '0' + bHex;
        if (typeof this.a === 'number' && this.a >= 0 && this.a < 1) {
            const aHex = round(this.a * 255).toString(16);
            hex += aHex.length === 2 ? aHex : '0' + aHex;
        }
        return hex;
    }
    /** CSS support color pattern */ toHsl() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            l: this.getLightness(),
            a: this.a
        };
    }
    /** CSS support color pattern */ toHslString() {
        const h = this.getHue();
        const s = round(this.getSaturation() * 100);
        const l = round(this.getLightness() * 100);
        return this.a !== 1 ? `hsla(${h},${s}%,${l}%,${this.a})` : `hsl(${h},${s}%,${l}%)`;
    }
    /** Same as toHsb */ toHsv() {
        return {
            h: this.getHue(),
            s: this.getSaturation(),
            v: this.getValue(),
            a: this.a
        };
    }
    toRgb() {
        return {
            r: this.r,
            g: this.g,
            b: this.b,
            a: this.a
        };
    }
    toRgbString() {
        return this.a !== 1 ? `rgba(${this.r},${this.g},${this.b},${this.a})` : `rgb(${this.r},${this.g},${this.b})`;
    }
    toString() {
        return this.toRgbString();
    }
    // ====================== Privates ======================
    /** Return a new FastColor object with one channel changed */ _sc(rgb, value, max) {
        const clone = this.clone();
        clone[rgb] = limitRange(value, max);
        return clone;
    }
    _c(input) {
        return new this.constructor(input);
    }
    getMax() {
        if (typeof this._max === 'undefined') this._max = Math.max(this.r, this.g, this.b);
        return this._max;
    }
    getMin() {
        if (typeof this._min === 'undefined') this._min = Math.min(this.r, this.g, this.b);
        return this._min;
    }
    fromHexString(trimStr) {
        const withoutPrefix = trimStr.replace('#', '');
        function connectNum(index1, index2) {
            return parseInt(withoutPrefix[index1] + withoutPrefix[index2 || index1], 16);
        }
        if (withoutPrefix.length < 6) {
            // #rgb or #rgba
            this.r = connectNum(0);
            this.g = connectNum(1);
            this.b = connectNum(2);
            this.a = withoutPrefix[3] ? connectNum(3) / 255 : 1;
        } else {
            // #rrggbb or #rrggbbaa
            this.r = connectNum(0, 1);
            this.g = connectNum(2, 3);
            this.b = connectNum(4, 5);
            this.a = withoutPrefix[6] ? connectNum(6, 7) / 255 : 1;
        }
    }
    fromHsl({ h, s, l, a }) {
        this._h = h % 360;
        this._s = s;
        this._l = l;
        this.a = typeof a === 'number' ? a : 1;
        if (s <= 0) {
            const rgb = round(l * 255);
            this.r = rgb;
            this.g = rgb;
            this.b = rgb;
        }
        let r = 0, g = 0, b = 0;
        const huePrime = h / 60;
        const chroma = (1 - Math.abs(2 * l - 1)) * s;
        const secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
        if (huePrime >= 0 && huePrime < 1) {
            r = chroma;
            g = secondComponent;
        } else if (huePrime >= 1 && huePrime < 2) {
            r = secondComponent;
            g = chroma;
        } else if (huePrime >= 2 && huePrime < 3) {
            g = chroma;
            b = secondComponent;
        } else if (huePrime >= 3 && huePrime < 4) {
            g = secondComponent;
            b = chroma;
        } else if (huePrime >= 4 && huePrime < 5) {
            r = secondComponent;
            b = chroma;
        } else if (huePrime >= 5 && huePrime < 6) {
            r = chroma;
            b = secondComponent;
        }
        const lightnessModification = l - chroma / 2;
        this.r = round((r + lightnessModification) * 255);
        this.g = round((g + lightnessModification) * 255);
        this.b = round((b + lightnessModification) * 255);
    }
    fromHsv({ h, s, v, a }) {
        this._h = h % 360;
        this._s = s;
        this._v = v;
        this.a = typeof a === 'number' ? a : 1;
        const vv = round(v * 255);
        this.r = vv;
        this.g = vv;
        this.b = vv;
        if (s <= 0) return;
        const hh = h / 60;
        const i = Math.floor(hh);
        const ff = hh - i;
        const p = round(v * (1.0 - s) * 255);
        const q = round(v * (1.0 - s * ff) * 255);
        const t = round(v * (1.0 - s * (1.0 - ff)) * 255);
        switch(i){
            case 0:
                this.g = t;
                this.b = p;
                break;
            case 1:
                this.r = q;
                this.b = p;
                break;
            case 2:
                this.r = p;
                this.b = t;
                break;
            case 3:
                this.r = p;
                this.g = q;
                break;
            case 4:
                this.r = t;
                this.g = p;
                break;
            case 5:
            default:
                this.g = p;
                this.b = q;
                break;
        }
    }
    fromHsvString(trimStr) {
        const cells = splitColorStr(trimStr, parseHSVorHSL);
        this.fromHsv({
            h: cells[0],
            s: cells[1],
            v: cells[2],
            a: cells[3]
        });
    }
    fromHslString(trimStr) {
        const cells = splitColorStr(trimStr, parseHSVorHSL);
        this.fromHsl({
            h: cells[0],
            s: cells[1],
            l: cells[2],
            a: cells[3]
        });
    }
    fromRgbString(trimStr) {
        const cells = splitColorStr(trimStr, (num, txt)=>// Convert percentage to number. e.g. 50% -> 128
            txt.includes('%') ? round(num / 100 * 255) : num);
        this.r = cells[0];
        this.g = cells[1];
        this.b = cells[2];
        this.a = cells[3];
    }
}

},{"./presetColors":"7OxPd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7OxPd":[function(require,module,exports,__globalThis) {
// 36 Hex to reduce the size of the file
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = {
    aliceblue: '9ehhb',
    antiquewhite: '9sgk7',
    aqua: '1ekf',
    aquamarine: '4zsno',
    azure: '9eiv3',
    beige: '9lhp8',
    bisque: '9zg04',
    black: '0',
    blanchedalmond: '9zhe5',
    blue: '73',
    blueviolet: '5e31e',
    brown: '6g016',
    burlywood: '8ouiv',
    cadetblue: '3qba8',
    chartreuse: '4zshs',
    chocolate: '87k0u',
    coral: '9yvyo',
    cornflowerblue: '3xael',
    cornsilk: '9zjz0',
    crimson: '8l4xo',
    cyan: '1ekf',
    darkblue: '3v',
    darkcyan: 'rkb',
    darkgoldenrod: '776yz',
    darkgray: '6mbhl',
    darkgreen: 'jr4',
    darkgrey: '6mbhl',
    darkkhaki: '7ehkb',
    darkmagenta: '5f91n',
    darkolivegreen: '3bzfz',
    darkorange: '9yygw',
    darkorchid: '5z6x8',
    darkred: '5f8xs',
    darksalmon: '9441m',
    darkseagreen: '5lwgf',
    darkslateblue: '2th1n',
    darkslategray: '1ugcv',
    darkslategrey: '1ugcv',
    darkturquoise: '14up',
    darkviolet: '5rw7n',
    deeppink: '9yavn',
    deepskyblue: '11xb',
    dimgray: '442g9',
    dimgrey: '442g9',
    dodgerblue: '16xof',
    firebrick: '6y7tu',
    floralwhite: '9zkds',
    forestgreen: '1cisi',
    fuchsia: '9y70f',
    gainsboro: '8m8kc',
    ghostwhite: '9pq0v',
    goldenrod: '8j4f4',
    gold: '9zda8',
    gray: '50i2o',
    green: 'pa8',
    greenyellow: '6senj',
    grey: '50i2o',
    honeydew: '9eiuo',
    hotpink: '9yrp0',
    indianred: '80gnw',
    indigo: '2xcoy',
    ivory: '9zldc',
    khaki: '9edu4',
    lavenderblush: '9ziet',
    lavender: '90c8q',
    lawngreen: '4vk74',
    lemonchiffon: '9zkct',
    lightblue: '6s73a',
    lightcoral: '9dtog',
    lightcyan: '8s1rz',
    lightgoldenrodyellow: '9sjiq',
    lightgray: '89jo3',
    lightgreen: '5nkwg',
    lightgrey: '89jo3',
    lightpink: '9z6wx',
    lightsalmon: '9z2ii',
    lightseagreen: '19xgq',
    lightskyblue: '5arju',
    lightslategray: '4nwk9',
    lightslategrey: '4nwk9',
    lightsteelblue: '6wau6',
    lightyellow: '9zlcw',
    lime: '1edc',
    limegreen: '1zcxe',
    linen: '9shk6',
    magenta: '9y70f',
    maroon: '4zsow',
    mediumaquamarine: '40eju',
    mediumblue: '5p',
    mediumorchid: '79qkz',
    mediumpurple: '5r3rv',
    mediumseagreen: '2d9ip',
    mediumslateblue: '4tcku',
    mediumspringgreen: '1di2',
    mediumturquoise: '2uabw',
    mediumvioletred: '7rn9h',
    midnightblue: 'z980',
    mintcream: '9ljp6',
    mistyrose: '9zg0x',
    moccasin: '9zfzp',
    navajowhite: '9zest',
    navy: '3k',
    oldlace: '9wq92',
    olive: '50hz4',
    olivedrab: '472ub',
    orange: '9z3eo',
    orangered: '9ykg0',
    orchid: '8iu3a',
    palegoldenrod: '9bl4a',
    palegreen: '5yw0o',
    paleturquoise: '6v4ku',
    palevioletred: '8k8lv',
    papayawhip: '9zi6t',
    peachpuff: '9ze0p',
    peru: '80oqn',
    pink: '9z8wb',
    plum: '8nba5',
    powderblue: '6wgdi',
    purple: '4zssg',
    rebeccapurple: '3zk49',
    red: '9y6tc',
    rosybrown: '7cv4f',
    royalblue: '2jvtt',
    saddlebrown: '5fmkz',
    salmon: '9rvci',
    sandybrown: '9jn1c',
    seagreen: '1tdnb',
    seashell: '9zje6',
    sienna: '6973h',
    silver: '7ir40',
    skyblue: '5arjf',
    slateblue: '45e4t',
    slategray: '4e100',
    slategrey: '4e100',
    snow: '9zke2',
    springgreen: '1egv',
    steelblue: '2r1kk',
    tan: '87yx8',
    teal: 'pds',
    thistle: '8ggk8',
    tomato: '9yqfb',
    turquoise: '2j4r4',
    violet: '9b10u',
    wheat: '9ld4j',
    white: '9zldr',
    whitesmoke: '9lhpx',
    yellow: '9zl6o',
    yellowgreen: '61fzm'
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iaEZl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jxWva":[function(require,module,exports,__globalThis) {
// Generated by script. Do NOT modify!
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "presetPrimaryColors", ()=>presetPrimaryColors);
parcelHelpers.export(exports, "red", ()=>red);
parcelHelpers.export(exports, "volcano", ()=>volcano);
parcelHelpers.export(exports, "orange", ()=>orange);
parcelHelpers.export(exports, "gold", ()=>gold);
parcelHelpers.export(exports, "yellow", ()=>yellow);
parcelHelpers.export(exports, "lime", ()=>lime);
parcelHelpers.export(exports, "green", ()=>green);
parcelHelpers.export(exports, "cyan", ()=>cyan);
parcelHelpers.export(exports, "blue", ()=>blue);
parcelHelpers.export(exports, "geekblue", ()=>geekblue);
parcelHelpers.export(exports, "purple", ()=>purple);
parcelHelpers.export(exports, "magenta", ()=>magenta);
parcelHelpers.export(exports, "grey", ()=>grey);
parcelHelpers.export(exports, "gray", ()=>gray);
parcelHelpers.export(exports, "presetPalettes", ()=>presetPalettes);
parcelHelpers.export(exports, "redDark", ()=>redDark);
parcelHelpers.export(exports, "volcanoDark", ()=>volcanoDark);
parcelHelpers.export(exports, "orangeDark", ()=>orangeDark);
parcelHelpers.export(exports, "goldDark", ()=>goldDark);
parcelHelpers.export(exports, "yellowDark", ()=>yellowDark);
parcelHelpers.export(exports, "limeDark", ()=>limeDark);
parcelHelpers.export(exports, "greenDark", ()=>greenDark);
parcelHelpers.export(exports, "cyanDark", ()=>cyanDark);
parcelHelpers.export(exports, "blueDark", ()=>blueDark);
parcelHelpers.export(exports, "geekblueDark", ()=>geekblueDark);
parcelHelpers.export(exports, "purpleDark", ()=>purpleDark);
parcelHelpers.export(exports, "magentaDark", ()=>magentaDark);
parcelHelpers.export(exports, "greyDark", ()=>greyDark);
parcelHelpers.export(exports, "presetDarkPalettes", ()=>presetDarkPalettes);
const presetPrimaryColors = {
    "red": "#F5222D",
    "volcano": "#FA541C",
    "orange": "#FA8C16",
    "gold": "#FAAD14",
    "yellow": "#FADB14",
    "lime": "#A0D911",
    "green": "#52C41A",
    "cyan": "#13C2C2",
    "blue": "#1677FF",
    "geekblue": "#2F54EB",
    "purple": "#722ED1",
    "magenta": "#EB2F96",
    "grey": "#666666"
};
const red = [
    "#fff1f0",
    "#ffccc7",
    "#ffa39e",
    "#ff7875",
    "#ff4d4f",
    "#f5222d",
    "#cf1322",
    "#a8071a",
    "#820014",
    "#5c0011"
];
red.primary = red[5];
const volcano = [
    "#fff2e8",
    "#ffd8bf",
    "#ffbb96",
    "#ff9c6e",
    "#ff7a45",
    "#fa541c",
    "#d4380d",
    "#ad2102",
    "#871400",
    "#610b00"
];
volcano.primary = volcano[5];
const orange = [
    "#fff7e6",
    "#ffe7ba",
    "#ffd591",
    "#ffc069",
    "#ffa940",
    "#fa8c16",
    "#d46b08",
    "#ad4e00",
    "#873800",
    "#612500"
];
orange.primary = orange[5];
const gold = [
    "#fffbe6",
    "#fff1b8",
    "#ffe58f",
    "#ffd666",
    "#ffc53d",
    "#faad14",
    "#d48806",
    "#ad6800",
    "#874d00",
    "#613400"
];
gold.primary = gold[5];
const yellow = [
    "#feffe6",
    "#ffffb8",
    "#fffb8f",
    "#fff566",
    "#ffec3d",
    "#fadb14",
    "#d4b106",
    "#ad8b00",
    "#876800",
    "#614700"
];
yellow.primary = yellow[5];
const lime = [
    "#fcffe6",
    "#f4ffb8",
    "#eaff8f",
    "#d3f261",
    "#bae637",
    "#a0d911",
    "#7cb305",
    "#5b8c00",
    "#3f6600",
    "#254000"
];
lime.primary = lime[5];
const green = [
    "#f6ffed",
    "#d9f7be",
    "#b7eb8f",
    "#95de64",
    "#73d13d",
    "#52c41a",
    "#389e0d",
    "#237804",
    "#135200",
    "#092b00"
];
green.primary = green[5];
const cyan = [
    "#e6fffb",
    "#b5f5ec",
    "#87e8de",
    "#5cdbd3",
    "#36cfc9",
    "#13c2c2",
    "#08979c",
    "#006d75",
    "#00474f",
    "#002329"
];
cyan.primary = cyan[5];
const blue = [
    "#e6f4ff",
    "#bae0ff",
    "#91caff",
    "#69b1ff",
    "#4096ff",
    "#1677ff",
    "#0958d9",
    "#003eb3",
    "#002c8c",
    "#001d66"
];
blue.primary = blue[5];
const geekblue = [
    "#f0f5ff",
    "#d6e4ff",
    "#adc6ff",
    "#85a5ff",
    "#597ef7",
    "#2f54eb",
    "#1d39c4",
    "#10239e",
    "#061178",
    "#030852"
];
geekblue.primary = geekblue[5];
const purple = [
    "#f9f0ff",
    "#efdbff",
    "#d3adf7",
    "#b37feb",
    "#9254de",
    "#722ed1",
    "#531dab",
    "#391085",
    "#22075e",
    "#120338"
];
purple.primary = purple[5];
const magenta = [
    "#fff0f6",
    "#ffd6e7",
    "#ffadd2",
    "#ff85c0",
    "#f759ab",
    "#eb2f96",
    "#c41d7f",
    "#9e1068",
    "#780650",
    "#520339"
];
magenta.primary = magenta[5];
const grey = [
    "#a6a6a6",
    "#999999",
    "#8c8c8c",
    "#808080",
    "#737373",
    "#666666",
    "#404040",
    "#1a1a1a",
    "#000000",
    "#000000"
];
grey.primary = grey[5];
const gray = grey;
const presetPalettes = {
    red,
    volcano,
    orange,
    gold,
    yellow,
    lime,
    green,
    cyan,
    blue,
    geekblue,
    purple,
    magenta,
    grey
};
const redDark = [
    "#2a1215",
    "#431418",
    "#58181c",
    "#791a1f",
    "#a61d24",
    "#d32029",
    "#e84749",
    "#f37370",
    "#f89f9a",
    "#fac8c3"
];
redDark.primary = redDark[5];
const volcanoDark = [
    "#2b1611",
    "#441d12",
    "#592716",
    "#7c3118",
    "#aa3e19",
    "#d84a1b",
    "#e87040",
    "#f3956a",
    "#f8b692",
    "#fad4bc"
];
volcanoDark.primary = volcanoDark[5];
const orangeDark = [
    "#2b1d11",
    "#442a11",
    "#593815",
    "#7c4a15",
    "#aa6215",
    "#d87a16",
    "#e89a3c",
    "#f3b765",
    "#f8cf8d",
    "#fae3b7"
];
orangeDark.primary = orangeDark[5];
const goldDark = [
    "#2b2111",
    "#443111",
    "#594214",
    "#7c5914",
    "#aa7714",
    "#d89614",
    "#e8b339",
    "#f3cc62",
    "#f8df8b",
    "#faedb5"
];
goldDark.primary = goldDark[5];
const yellowDark = [
    "#2b2611",
    "#443b11",
    "#595014",
    "#7c6e14",
    "#aa9514",
    "#d8bd14",
    "#e8d639",
    "#f3ea62",
    "#f8f48b",
    "#fafab5"
];
yellowDark.primary = yellowDark[5];
const limeDark = [
    "#1f2611",
    "#2e3c10",
    "#3e4f13",
    "#536d13",
    "#6f9412",
    "#8bbb11",
    "#a9d134",
    "#c9e75d",
    "#e4f88b",
    "#f0fab5"
];
limeDark.primary = limeDark[5];
const greenDark = [
    "#162312",
    "#1d3712",
    "#274916",
    "#306317",
    "#3c8618",
    "#49aa19",
    "#6abe39",
    "#8fd460",
    "#b2e58b",
    "#d5f2bb"
];
greenDark.primary = greenDark[5];
const cyanDark = [
    "#112123",
    "#113536",
    "#144848",
    "#146262",
    "#138585",
    "#13a8a8",
    "#33bcb7",
    "#58d1c9",
    "#84e2d8",
    "#b2f1e8"
];
cyanDark.primary = cyanDark[5];
const blueDark = [
    "#111a2c",
    "#112545",
    "#15325b",
    "#15417e",
    "#1554ad",
    "#1668dc",
    "#3c89e8",
    "#65a9f3",
    "#8dc5f8",
    "#b7dcfa"
];
blueDark.primary = blueDark[5];
const geekblueDark = [
    "#131629",
    "#161d40",
    "#1c2755",
    "#203175",
    "#263ea0",
    "#2b4acb",
    "#5273e0",
    "#7f9ef3",
    "#a8c1f8",
    "#d2e0fa"
];
geekblueDark.primary = geekblueDark[5];
const purpleDark = [
    "#1a1325",
    "#24163a",
    "#301c4d",
    "#3e2069",
    "#51258f",
    "#642ab5",
    "#854eca",
    "#ab7ae0",
    "#cda8f0",
    "#ebd7fa"
];
purpleDark.primary = purpleDark[5];
const magentaDark = [
    "#291321",
    "#40162f",
    "#551c3b",
    "#75204f",
    "#a02669",
    "#cb2b83",
    "#e0529c",
    "#f37fb7",
    "#f8a8cc",
    "#fad2e3"
];
magentaDark.primary = magentaDark[5];
const greyDark = [
    "#151515",
    "#1f1f1f",
    "#2d2d2d",
    "#393939",
    "#494949",
    "#5a5a5a",
    "#6a6a6a",
    "#7b7b7b",
    "#888888",
    "#969696"
];
greyDark.primary = greyDark[5];
const presetDarkPalettes = {
    red: redDark,
    volcano: volcanoDark,
    orange: orangeDark,
    gold: goldDark,
    yellow: yellowDark,
    lime: limeDark,
    green: greenDark,
    cyan: cyanDark,
    blue: blueDark,
    geekblue: geekblueDark,
    purple: purpleDark,
    magenta: magentaDark,
    grey: greyDark
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jTuMg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aeTHW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultPresetColors", ()=>defaultPresetColors);
const defaultPresetColors = {
    blue: '#1677FF',
    purple: '#722ED1',
    cyan: '#13C2C2',
    green: '#52C41A',
    magenta: '#EB2F96',
    /**
   * @deprecated Use magenta instead
   */ pink: '#EB2F96',
    red: '#F5222D',
    orange: '#FA8C16',
    yellow: '#FADB14',
    volcano: '#FA541C',
    geekblue: '#2F54EB',
    gold: '#FAAD14',
    lime: '#A0D911'
};
const seedToken = {
    // preset color palettes
    ...defaultPresetColors,
    // Color
    colorPrimary: '#1677ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1677ff',
    colorLink: '',
    colorTextBase: '',
    colorBgBase: '',
    // Font
    fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
    fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
    fontSize: 14,
    // Line
    lineWidth: 1,
    lineType: 'solid',
    // Motion
    motionUnit: 0.1,
    motionBase: 0,
    motionEaseOutCirc: 'cubic-bezier(0.08, 0.82, 0.17, 1)',
    motionEaseInOutCirc: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
    motionEaseOut: 'cubic-bezier(0.215, 0.61, 0.355, 1)',
    motionEaseInOut: 'cubic-bezier(0.645, 0.045, 0.355, 1)',
    motionEaseOutBack: 'cubic-bezier(0.12, 0.4, 0.29, 1.46)',
    motionEaseInBack: 'cubic-bezier(0.71, -0.46, 0.88, 0.6)',
    motionEaseInQuint: 'cubic-bezier(0.755, 0.05, 0.855, 0.06)',
    motionEaseOutQuint: 'cubic-bezier(0.23, 1, 0.32, 1)',
    // Radius
    borderRadius: 6,
    // Size
    sizeUnit: 4,
    sizeStep: 4,
    sizePopupArrow: 16,
    // Control Base
    controlHeight: 32,
    // zIndex
    zIndexBase: 0,
    zIndexPopupBase: 1000,
    // Image
    opacityImage: 1,
    // Wireframe
    wireframe: false,
    // Motion
    motion: true
};
exports.default = seedToken;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gfAX9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>genColorMapToken);
var _fastColor = require("@ant-design/fast-color");
function genColorMapToken(seed, { generateColorPalettes, generateNeutralColorPalettes }) {
    const { colorSuccess: colorSuccessBase, colorWarning: colorWarningBase, colorError: colorErrorBase, colorInfo: colorInfoBase, colorPrimary: colorPrimaryBase, colorBgBase, colorTextBase } = seed;
    const primaryColors = generateColorPalettes(colorPrimaryBase);
    const successColors = generateColorPalettes(colorSuccessBase);
    const warningColors = generateColorPalettes(colorWarningBase);
    const errorColors = generateColorPalettes(colorErrorBase);
    const infoColors = generateColorPalettes(colorInfoBase);
    const neutralColors = generateNeutralColorPalettes(colorBgBase, colorTextBase);
    // Color Link
    const colorLink = seed.colorLink || seed.colorInfo;
    const linkColors = generateColorPalettes(colorLink);
    const colorErrorBgFilledHover = new (0, _fastColor.FastColor)(errorColors[1]).mix(new (0, _fastColor.FastColor)(errorColors[3]), 50).toHexString();
    return {
        ...neutralColors,
        colorPrimaryBg: primaryColors[1],
        colorPrimaryBgHover: primaryColors[2],
        colorPrimaryBorder: primaryColors[3],
        colorPrimaryBorderHover: primaryColors[4],
        colorPrimaryHover: primaryColors[5],
        colorPrimary: primaryColors[6],
        colorPrimaryActive: primaryColors[7],
        colorPrimaryTextHover: primaryColors[8],
        colorPrimaryText: primaryColors[9],
        colorPrimaryTextActive: primaryColors[10],
        colorSuccessBg: successColors[1],
        colorSuccessBgHover: successColors[2],
        colorSuccessBorder: successColors[3],
        colorSuccessBorderHover: successColors[4],
        colorSuccessHover: successColors[4],
        colorSuccess: successColors[6],
        colorSuccessActive: successColors[7],
        colorSuccessTextHover: successColors[8],
        colorSuccessText: successColors[9],
        colorSuccessTextActive: successColors[10],
        colorErrorBg: errorColors[1],
        colorErrorBgHover: errorColors[2],
        colorErrorBgFilledHover,
        colorErrorBgActive: errorColors[3],
        colorErrorBorder: errorColors[3],
        colorErrorBorderHover: errorColors[4],
        colorErrorHover: errorColors[5],
        colorError: errorColors[6],
        colorErrorActive: errorColors[7],
        colorErrorTextHover: errorColors[8],
        colorErrorText: errorColors[9],
        colorErrorTextActive: errorColors[10],
        colorWarningBg: warningColors[1],
        colorWarningBgHover: warningColors[2],
        colorWarningBorder: warningColors[3],
        colorWarningBorderHover: warningColors[4],
        colorWarningHover: warningColors[4],
        colorWarning: warningColors[6],
        colorWarningActive: warningColors[7],
        colorWarningTextHover: warningColors[8],
        colorWarningText: warningColors[9],
        colorWarningTextActive: warningColors[10],
        colorInfoBg: infoColors[1],
        colorInfoBgHover: infoColors[2],
        colorInfoBorder: infoColors[3],
        colorInfoBorderHover: infoColors[4],
        colorInfoHover: infoColors[4],
        colorInfo: infoColors[6],
        colorInfoActive: infoColors[7],
        colorInfoTextHover: infoColors[8],
        colorInfoText: infoColors[9],
        colorInfoTextActive: infoColors[10],
        colorLinkHover: linkColors[4],
        colorLink: linkColors[6],
        colorLinkActive: linkColors[7],
        colorBgMask: new (0, _fastColor.FastColor)('#000').setA(0.45).toRgbString(),
        colorWhite: '#fff'
    };
}

},{"@ant-design/fast-color":"50VUA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8rQvM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>genCommonMapToken);
var _genRadius = require("./genRadius");
var _genRadiusDefault = parcelHelpers.interopDefault(_genRadius);
function genCommonMapToken(token) {
    const { motionUnit, motionBase, borderRadius, lineWidth } = token;
    return {
        // motion
        motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
        motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
        motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
        // line
        lineWidthBold: lineWidth + 1,
        // radius
        ...(0, _genRadiusDefault.default)(borderRadius)
    };
}

},{"./genRadius":"1QvHu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1QvHu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const genRadius = (radiusBase)=>{
    let radiusLG = radiusBase;
    let radiusSM = radiusBase;
    let radiusXS = radiusBase;
    let radiusOuter = radiusBase;
    // radiusLG
    if (radiusBase < 6 && radiusBase >= 5) radiusLG = radiusBase + 1;
    else if (radiusBase < 16 && radiusBase >= 6) radiusLG = radiusBase + 2;
    else if (radiusBase >= 16) radiusLG = 16;
    // radiusSM
    if (radiusBase < 7 && radiusBase >= 5) radiusSM = 4;
    else if (radiusBase < 8 && radiusBase >= 7) radiusSM = 5;
    else if (radiusBase < 14 && radiusBase >= 8) radiusSM = 6;
    else if (radiusBase < 16 && radiusBase >= 14) radiusSM = 7;
    else if (radiusBase >= 16) radiusSM = 8;
    // radiusXS
    if (radiusBase < 6 && radiusBase >= 2) radiusXS = 1;
    else if (radiusBase >= 6) radiusXS = 2;
    // radiusOuter
    if (radiusBase > 4 && radiusBase < 8) radiusOuter = 4;
    else if (radiusBase >= 8) radiusOuter = 6;
    return {
        borderRadius: radiusBase,
        borderRadiusXS: radiusXS,
        borderRadiusSM: radiusSM,
        borderRadiusLG: radiusLG,
        borderRadiusOuter: radiusOuter
    };
};
exports.default = genRadius;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6fvky":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const genControlHeight = (token)=>{
    const { controlHeight } = token;
    return {
        controlHeightSM: controlHeight * 0.75,
        controlHeightXS: controlHeight * 0.5,
        controlHeightLG: controlHeight * 1.25
    };
};
exports.default = genControlHeight;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ffxwm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _genFontSizes = require("./genFontSizes");
var _genFontSizesDefault = parcelHelpers.interopDefault(_genFontSizes);
const genFontMapToken = (fontSize)=>{
    const fontSizePairs = (0, _genFontSizesDefault.default)(fontSize);
    const fontSizes = fontSizePairs.map((pair)=>pair.size);
    const lineHeights = fontSizePairs.map((pair)=>pair.lineHeight);
    const fontSizeMD = fontSizes[1];
    const fontSizeSM = fontSizes[0];
    const fontSizeLG = fontSizes[2];
    const lineHeight = lineHeights[1];
    const lineHeightSM = lineHeights[0];
    const lineHeightLG = lineHeights[2];
    return {
        fontSizeSM,
        fontSize: fontSizeMD,
        fontSizeLG,
        fontSizeXL: fontSizes[3],
        fontSizeHeading1: fontSizes[6],
        fontSizeHeading2: fontSizes[5],
        fontSizeHeading3: fontSizes[4],
        fontSizeHeading4: fontSizes[3],
        fontSizeHeading5: fontSizes[2],
        lineHeight,
        lineHeightLG,
        lineHeightSM,
        fontHeight: Math.round(lineHeight * fontSizeMD),
        fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
        fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
        lineHeightHeading1: lineHeights[6],
        lineHeightHeading2: lineHeights[5],
        lineHeightHeading3: lineHeights[4],
        lineHeightHeading4: lineHeights[3],
        lineHeightHeading5: lineHeights[2]
    };
};
exports.default = genFontMapToken;

},{"./genFontSizes":"1W7Zr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1W7Zr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getLineHeight", ()=>getLineHeight);
parcelHelpers.export(exports, "default", ()=>getFontSizes);
function getLineHeight(fontSize) {
    return (fontSize + 8) / fontSize;
}
function getFontSizes(base) {
    const fontSizes = Array.from({
        length: 10
    }).map((_, index)=>{
        const i = index - 1;
        const baseSize = base * Math.E ** (i / 5);
        const intSize = index > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
        // Convert to even
        return Math.floor(intSize / 2) * 2;
    });
    fontSizes[1] = base;
    return fontSizes.map((size)=>({
            size,
            lineHeight: getLineHeight(size)
        }));
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9DYNY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>genSizeMapToken);
function genSizeMapToken(token) {
    const { sizeUnit, sizeStep } = token;
    return {
        sizeXXL: sizeUnit * (sizeStep + 8),
        // 48
        sizeXL: sizeUnit * (sizeStep + 4),
        // 32
        sizeLG: sizeUnit * (sizeStep + 2),
        // 24
        sizeMD: sizeUnit * (sizeStep + 1),
        // 20
        sizeMS: sizeUnit * sizeStep,
        // 16
        size: sizeUnit * sizeStep,
        // 16
        sizeSM: sizeUnit * (sizeStep - 1),
        // 12
        sizeXS: sizeUnit * (sizeStep - 2),
        // 8
        sizeXXS: sizeUnit * (sizeStep - 3 // 4
        )
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7QaoO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateColorPalettes", ()=>generateColorPalettes);
parcelHelpers.export(exports, "generateNeutralColorPalettes", ()=>generateNeutralColorPalettes);
var _colors = require("@ant-design/colors");
var _colorAlgorithm = require("./colorAlgorithm");
const generateColorPalettes = (baseColor)=>{
    const colors = (0, _colors.generate)(baseColor);
    return {
        1: colors[0],
        2: colors[1],
        3: colors[2],
        4: colors[3],
        5: colors[4],
        6: colors[5],
        7: colors[6],
        8: colors[4],
        9: colors[5],
        10: colors[6]
    };
};
const generateNeutralColorPalettes = (bgBaseColor, textBaseColor)=>{
    const colorBgBase = bgBaseColor || '#fff';
    const colorTextBase = textBaseColor || '#000';
    return {
        colorBgBase,
        colorTextBase,
        colorText: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.88),
        colorTextSecondary: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.65),
        colorTextTertiary: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.45),
        colorTextQuaternary: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.25),
        colorFill: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.15),
        colorFillSecondary: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.06),
        colorFillTertiary: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.04),
        colorFillQuaternary: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.02),
        colorBgSolid: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 1),
        colorBgSolidHover: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.75),
        colorBgSolidActive: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.95),
        colorBgLayout: (0, _colorAlgorithm.getSolidColor)(colorBgBase, 4),
        colorBgContainer: (0, _colorAlgorithm.getSolidColor)(colorBgBase, 0),
        colorBgElevated: (0, _colorAlgorithm.getSolidColor)(colorBgBase, 0),
        colorBgSpotlight: (0, _colorAlgorithm.getAlphaColor)(colorTextBase, 0.85),
        colorBgBlur: 'transparent',
        colorBorder: (0, _colorAlgorithm.getSolidColor)(colorBgBase, 15),
        colorBorderDisabled: (0, _colorAlgorithm.getSolidColor)(colorBgBase, 15),
        colorBorderSecondary: (0, _colorAlgorithm.getSolidColor)(colorBgBase, 6)
    };
};

},{"@ant-design/colors":"350gL","./colorAlgorithm":"7SJem","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7SJem":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAlphaColor", ()=>getAlphaColor);
parcelHelpers.export(exports, "getSolidColor", ()=>getSolidColor);
var _fastColor = require("@ant-design/fast-color");
const getAlphaColor = (baseColor, alpha)=>new (0, _fastColor.FastColor)(baseColor).setA(alpha).toRgbString();
const getSolidColor = (baseColor, brightness)=>{
    const instance = new (0, _fastColor.FastColor)(baseColor);
    return instance.darken(brightness).toHexString();
};

},{"@ant-design/fast-color":"50VUA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"25Z4W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTheme", ()=>(0, _themeDefault.default));
parcelHelpers.export(exports, "defaultConfig", ()=>defaultConfig);
parcelHelpers.export(exports, "DesignTokenContext", ()=>DesignTokenContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _seed = require("./themes/seed");
var _seedDefault = parcelHelpers.interopDefault(_seed);
var _theme = require("./themes/default/theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
const defaultConfig = {
    token: (0, _seedDefault.default),
    override: {
        override: (0, _seedDefault.default)
    },
    hashed: true
};
const DesignTokenContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(defaultConfig);

},{"react":"bmhQu","./themes/seed":"aeTHW","./themes/default/theme":"ia1Cg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5ZqU0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _trigger = require("@rc-component/trigger");
var _motionContent = require("./MotionContent");
var _motionContentDefault = parcelHelpers.interopDefault(_motionContent);
"use client";
const cachedPlacements = [
    null,
    null
];
function uniqueBuiltinPlacements(ori) {
    if (cachedPlacements[0] !== ori) {
        const target = {};
        Object.keys(ori).forEach((placement)=>{
            target[placement] = {
                ...ori[placement],
                dynamicInset: false
            };
        });
        cachedPlacements[0] = ori;
        cachedPlacements[1] = target;
    }
    return cachedPlacements[1];
}
const UniqueProvider = ({ children })=>{
    const renderPopup = (options)=>{
        const popupEle = typeof options.popup === 'function' ? options.popup() : options.popup;
        const { id, builtinPlacements } = options;
        const parsedPlacements = uniqueBuiltinPlacements(builtinPlacements);
        return {
            ...options,
            getPopupContainer: null,
            arrow: false,
            popup: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _motionContentDefault.default), {
                key: id
            }, popupEle),
            builtinPlacements: parsedPlacements
        };
    };
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _trigger.UniqueProvider), {
        postTriggerProps: renderPopup
    }, children);
};
exports.default = UniqueProvider;

},{"react":"bmhQu","@rc-component/trigger":"8gqi4","./MotionContent":"4fGDq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4fGDq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _motion = require("@rc-component/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
var _clsx = require("clsx");
var _context = require("../../config-provider/context");
"use client";
const MotionContent = ({ children })=>{
    const { getPrefixCls } = (0, _reactDefault.default).useContext((0, _context.ConfigContext));
    const rootPrefixCls = getPrefixCls();
    // This will never reach since we will not render this when no children
    /* istanbul ignore next */ if (!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(children)) return children;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _motionDefault.default), {
        visible: true,
        motionName: `${rootPrefixCls}-fade`,
        motionAppear: true,
        motionEnter: true,
        motionLeave: false,
        removeOnLeave: false
    }, ({ style: motionStyle, className: motionClassName })=>{
        const { className, style } = children.props;
        const mergedStyles = {
            ...style,
            ...motionStyle
        };
        return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
            className: (0, _clsx.clsx)(className, motionClassName),
            style: mergedStyles
        });
    });
};
exports.default = MotionContent;

},{"react":"bmhQu","@rc-component/motion":"gBwXg","clsx":"431Ou","../../config-provider/context":"75zwC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jkHDn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _disabledContext = require("../DisabledContext");
var _disabledContextDefault = parcelHelpers.interopDefault(_disabledContext);
var _sizeContext = require("../SizeContext");
var _sizeContextDefault = parcelHelpers.interopDefault(_sizeContext);
function useConfig() {
    const componentDisabled = (0, _react.useContext)((0, _disabledContextDefault.default));
    const componentSize = (0, _react.useContext)((0, _sizeContextDefault.default));
    return {
        componentDisabled,
        componentSize
    };
}
exports.default = useConfig;

},{"react":"bmhQu","../DisabledContext":"h4TcW","../SizeContext":"jlQPx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jlQPx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SizeContextProvider", ()=>SizeContextProvider);
var _react = require("react");
"use client";
const SizeContext = /*#__PURE__*/ _react.createContext(undefined);
const SizeContextProvider = ({ children, size })=>{
    const originSize = _react.useContext(SizeContext);
    return /*#__PURE__*/ _react.createElement(SizeContext.Provider, {
        value: size || originSize
    }, children);
};
exports.default = SizeContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4khBk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTheme);
var _react = require("react");
var _useMemo = require("@rc-component/util/es/hooks/useMemo");
var _useMemoDefault = parcelHelpers.interopDefault(_useMemo);
var _isEqual = require("@rc-component/util/es/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _warning = require("../../_util/warning");
var _internal = require("../../theme/internal");
function useTheme(theme, parentTheme, config) {
    const warning = (0, _warning.devUseWarning)('ConfigProvider');
    const themeConfig = theme || {};
    const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? {
        ...(0, _internal.defaultConfig),
        hashed: parentTheme?.hashed ?? (0, _internal.defaultConfig).hashed,
        cssVar: parentTheme?.cssVar
    } : parentTheme;
    // Generate a unique key for cssVar
    const themeKey = (0, _react.useId)();
    return (0, _useMemoDefault.default)(()=>{
        if (!theme) return parentTheme;
        // Override
        const mergedComponents = {
            ...parentThemeConfig.components
        };
        Object.keys(theme.components || {}).forEach((componentName)=>{
            mergedComponents[componentName] = {
                ...mergedComponents[componentName],
                ...theme.components[componentName]
            };
        });
        const cssVarKey = `css-var-${themeKey.replace(/:/g, '')}`;
        const mergedCssVar = {
            prefix: config?.prefixCls,
            // Same as prefixCls by default
            ...parentThemeConfig.cssVar,
            ...themeConfig.cssVar,
            key: themeConfig.cssVar?.key || cssVarKey
        };
        // Base token
        return {
            ...parentThemeConfig,
            ...themeConfig,
            token: {
                ...parentThemeConfig.token,
                ...themeConfig.token
            },
            components: mergedComponents,
            cssVar: mergedCssVar
        };
    }, [
        themeConfig,
        parentThemeConfig
    ], (prev, next)=>prev.some((prevTheme, index)=>{
            const nextTheme = next[index];
            return !(0, _isEqualDefault.default)(prevTheme, nextTheme, true);
        }));
}

},{"react":"bmhQu","@rc-component/util/es/hooks/useMemo":"8LJN8","@rc-component/util/es/isEqual":"fBa27","../../_util/warning":"95o3w","../../theme/internal":"25Z4W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"20zJD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MotionWrapper);
var _react = require("react");
var _motion = require("@rc-component/motion");
var _internal = require("../theme/internal");
"use client";
const MotionCacheContext = /*#__PURE__*/ _react.createContext(true);
function MotionWrapper(props) {
    const parentMotion = _react.useContext(MotionCacheContext);
    const { children } = props;
    const [, token] = (0, _internal.useToken)();
    const { motion } = token;
    const needWrapMotionProviderRef = _react.useRef(false);
    needWrapMotionProviderRef.current || (needWrapMotionProviderRef.current = parentMotion !== motion);
    if (needWrapMotionProviderRef.current) return /*#__PURE__*/ _react.createElement(MotionCacheContext.Provider, {
        value: motion
    }, /*#__PURE__*/ _react.createElement((0, _motion.Provider), {
        motion: motion
    }, children));
    return children;
}

},{"react":"bmhQu","@rc-component/motion":"gBwXg","../theme/internal":[["useToken","6x222","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6x222":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unitless", ()=>unitless);
parcelHelpers.export(exports, "ignore", ()=>ignore);
parcelHelpers.export(exports, "getComputedToken", ()=>getComputedToken);
parcelHelpers.export(exports, "default", ()=>useToken);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _cssinjs = require("@ant-design/cssinjs");
var _version = require("../version");
var _versionDefault = parcelHelpers.interopDefault(_version);
var _context = require("./context");
var _seed = require("./themes/seed");
var _seedDefault = parcelHelpers.interopDefault(_seed);
var _alias = require("./util/alias");
var _aliasDefault = parcelHelpers.interopDefault(_alias);
const unitless = {
    lineHeight: true,
    lineHeightSM: true,
    lineHeightLG: true,
    lineHeightHeading1: true,
    lineHeightHeading2: true,
    lineHeightHeading3: true,
    lineHeightHeading4: true,
    lineHeightHeading5: true,
    opacityLoading: true,
    fontWeightStrong: true,
    zIndexPopupBase: true,
    zIndexBase: true,
    opacityImage: true
};
const ignore = {
    motionBase: true,
    motionUnit: true
};
const preserve = {
    screenXS: true,
    screenXSMin: true,
    screenXSMax: true,
    screenSM: true,
    screenSMMin: true,
    screenSMMax: true,
    screenMD: true,
    screenMDMin: true,
    screenMDMax: true,
    screenLG: true,
    screenLGMin: true,
    screenLGMax: true,
    screenXL: true,
    screenXLMin: true,
    screenXLMax: true,
    screenXXL: true,
    screenXXLMin: true
};
const getComputedToken = (originToken, overrideToken, theme)=>{
    const derivativeToken = theme.getDerivativeToken(originToken);
    const { override, ...components } = overrideToken;
    // Merge with override
    let mergedDerivativeToken = {
        ...derivativeToken,
        override
    };
    // Format if needed
    mergedDerivativeToken = (0, _aliasDefault.default)(mergedDerivativeToken);
    if (components) Object.entries(components).forEach(([key, value])=>{
        const { theme: componentTheme, ...componentTokens } = value;
        let mergedComponentToken = componentTokens;
        if (componentTheme) mergedComponentToken = getComputedToken({
            ...mergedDerivativeToken,
            ...componentTokens
        }, {
            override: componentTokens
        }, componentTheme);
        mergedDerivativeToken[key] = mergedComponentToken;
    });
    return mergedDerivativeToken;
};
function useToken() {
    const { token: rootDesignToken, hashed, theme, override, cssVar: ctxCssVar, zeroRuntime } = (0, _reactDefault.default).useContext((0, _context.DesignTokenContext));
    const cssVar = {
        prefix: ctxCssVar?.prefix ?? 'ant',
        key: ctxCssVar?.key ?? 'css-var-root'
    };
    const salt = `${(0, _versionDefault.default)}-${hashed || ''}`;
    const mergedTheme = theme || (0, _context.defaultTheme);
    const [token, hashId, realToken] = (0, _cssinjs.useCacheToken)(mergedTheme, [
        (0, _seedDefault.default),
        rootDesignToken
    ], {
        salt,
        override,
        getComputedToken,
        cssVar: {
            ...cssVar,
            unitless,
            ignore,
            preserve
        }
    });
    return [
        mergedTheme,
        realToken,
        hashed ? hashId : '',
        token,
        cssVar,
        !!zeroRuntime
    ];
}

},{"react":"bmhQu","@ant-design/cssinjs":"2VNL8","../version":"2cuv8","./context":[["defaultTheme","ia1Cg","default"],["DesignTokenContext","25Z4W"]],"./themes/seed":"aeTHW","./util/alias":"kR3KR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2cuv8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// @ts-ignore
var _version = require("./version");
var _versionDefault = parcelHelpers.interopDefault(_version);
"use client";
exports.default = (0, _versionDefault.default);

},{"./version":"hKhPe","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hKhPe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = '6.1.2';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kR3KR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>formatToken);
var _fastColor = require("@ant-design/fast-color");
var _seed = require("../themes/seed");
var _seedDefault = parcelHelpers.interopDefault(_seed);
var _getAlphaColor = require("./getAlphaColor");
var _getAlphaColorDefault = parcelHelpers.interopDefault(_getAlphaColor);
function formatToken(derivativeToken) {
    const { override, ...restToken } = derivativeToken;
    const overrideTokens = {
        ...override
    };
    Object.keys((0, _seedDefault.default)).forEach((token)=>{
        delete overrideTokens[token];
    });
    const mergedToken = {
        ...restToken,
        ...overrideTokens
    };
    const screenXS = 480;
    const screenSM = 576;
    const screenMD = 768;
    const screenLG = 992;
    const screenXL = 1200;
    const screenXXL = 1600;
    // Motion
    if (mergedToken.motion === false) {
        const fastDuration = '0s';
        mergedToken.motionDurationFast = fastDuration;
        mergedToken.motionDurationMid = fastDuration;
        mergedToken.motionDurationSlow = fastDuration;
    }
    // Generate alias token
    const aliasToken = {
        ...mergedToken,
        // ============== Background ============== //
        colorFillContent: mergedToken.colorFillSecondary,
        colorFillContentHover: mergedToken.colorFill,
        colorFillAlter: mergedToken.colorFillQuaternary,
        colorBgContainerDisabled: mergedToken.colorFillTertiary,
        // ============== Split ============== //
        colorBorderBg: mergedToken.colorBgContainer,
        colorSplit: (0, _getAlphaColorDefault.default)(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
        // ============== Text ============== //
        colorTextPlaceholder: mergedToken.colorTextQuaternary,
        colorTextDisabled: mergedToken.colorTextQuaternary,
        colorTextHeading: mergedToken.colorText,
        colorTextLabel: mergedToken.colorTextSecondary,
        colorTextDescription: mergedToken.colorTextTertiary,
        colorTextLightSolid: mergedToken.colorWhite,
        colorHighlight: mergedToken.colorError,
        colorBgTextHover: mergedToken.colorFillSecondary,
        colorBgTextActive: mergedToken.colorFill,
        colorIcon: mergedToken.colorTextTertiary,
        colorIconHover: mergedToken.colorText,
        colorErrorOutline: (0, _getAlphaColorDefault.default)(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
        colorWarningOutline: (0, _getAlphaColorDefault.default)(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
        // Font
        fontSizeIcon: mergedToken.fontSizeSM,
        // Line
        lineWidthFocus: mergedToken.lineWidth * 3,
        // Control
        lineWidth: mergedToken.lineWidth,
        controlOutlineWidth: mergedToken.lineWidth * 2,
        // Checkbox size and expand icon size
        controlInteractiveSize: mergedToken.controlHeight / 2,
        controlItemBgHover: mergedToken.colorFillTertiary,
        controlItemBgActive: mergedToken.colorPrimaryBg,
        controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
        controlItemBgActiveDisabled: mergedToken.colorFill,
        controlTmpOutline: mergedToken.colorFillQuaternary,
        controlOutline: (0, _getAlphaColorDefault.default)(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
        lineType: mergedToken.lineType,
        borderRadius: mergedToken.borderRadius,
        borderRadiusXS: mergedToken.borderRadiusXS,
        borderRadiusSM: mergedToken.borderRadiusSM,
        borderRadiusLG: mergedToken.borderRadiusLG,
        fontWeightStrong: 600,
        opacityLoading: 0.65,
        linkDecoration: 'none',
        linkHoverDecoration: 'none',
        linkFocusDecoration: 'none',
        controlPaddingHorizontal: 12,
        controlPaddingHorizontalSM: 8,
        paddingXXS: mergedToken.sizeXXS,
        paddingXS: mergedToken.sizeXS,
        paddingSM: mergedToken.sizeSM,
        padding: mergedToken.size,
        paddingMD: mergedToken.sizeMD,
        paddingLG: mergedToken.sizeLG,
        paddingXL: mergedToken.sizeXL,
        paddingContentHorizontalLG: mergedToken.sizeLG,
        paddingContentVerticalLG: mergedToken.sizeMS,
        paddingContentHorizontal: mergedToken.sizeMS,
        paddingContentVertical: mergedToken.sizeSM,
        paddingContentHorizontalSM: mergedToken.size,
        paddingContentVerticalSM: mergedToken.sizeXS,
        marginXXS: mergedToken.sizeXXS,
        marginXS: mergedToken.sizeXS,
        marginSM: mergedToken.sizeSM,
        margin: mergedToken.size,
        marginMD: mergedToken.sizeMD,
        marginLG: mergedToken.sizeLG,
        marginXL: mergedToken.sizeXL,
        marginXXL: mergedToken.sizeXXL,
        boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
        screenXS,
        screenXSMin: screenXS,
        screenXSMax: screenSM - 1,
        screenSM,
        screenSMMin: screenSM,
        screenSMMax: screenMD - 1,
        screenMD,
        screenMDMin: screenMD,
        screenMDMax: screenLG - 1,
        screenLG,
        screenLGMin: screenLG,
        screenLGMax: screenXL - 1,
        screenXL,
        screenXLMin: screenXL,
        screenXLMax: screenXXL - 1,
        screenXXL,
        screenXXLMin: screenXXL,
        boxShadowPopoverArrow: '2px 2px 5px rgba(0, 0, 0, 0.05)',
        boxShadowCard: `
      0 1px 2px -2px ${new (0, _fastColor.FastColor)('rgba(0, 0, 0, 0.16)').toRgbString()},
      0 3px 6px 0 ${new (0, _fastColor.FastColor)('rgba(0, 0, 0, 0.12)').toRgbString()},
      0 5px 12px 4px ${new (0, _fastColor.FastColor)('rgba(0, 0, 0, 0.09)').toRgbString()}
    `,
        boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
        boxShadowTabsOverflowLeft: 'inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowRight: 'inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowTop: 'inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)',
        boxShadowTabsOverflowBottom: 'inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)',
        // Override AliasToken
        ...overrideTokens
    };
    return aliasToken;
}

},{"@ant-design/fast-color":"50VUA","../themes/seed":"aeTHW","./getAlphaColor":"4o7AG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4o7AG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _fastColor = require("@ant-design/fast-color");
function isStableColor(color) {
    return color >= 0 && color <= 255;
}
function getAlphaColor(frontColor, backgroundColor) {
    const { r: fR, g: fG, b: fB, a: originAlpha } = new (0, _fastColor.FastColor)(frontColor).toRgb();
    if (originAlpha < 1) return frontColor;
    const { r: bR, g: bG, b: bB } = new (0, _fastColor.FastColor)(backgroundColor).toRgb();
    for(let fA = 0.01; fA <= 1; fA += 0.01){
        const r = Math.round((fR - bR * (1 - fA)) / fA);
        const g = Math.round((fG - bG * (1 - fA)) / fA);
        const b = Math.round((fB - bB * (1 - fA)) / fA);
        if (isStableColor(r) && isStableColor(g) && isStableColor(b)) return new (0, _fastColor.FastColor)({
            r,
            g,
            b,
            a: Math.round(fA * 100) / 100
        }).toRgbString();
    }
    // fallback
    /* istanbul ignore next */ return new (0, _fastColor.FastColor)({
        r: fR,
        g: fG,
        b: fB,
        a: 1
    }).toRgbString();
}
exports.default = getAlphaColor;

},{"@ant-design/fast-color":"50VUA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kZqoG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _warning = require("../_util/warning");
"use client";
/**
 * Warning for ConfigProviderProps.
 * This will be empty function in production.
 */ const PropWarning = /*#__PURE__*/ _react.memo(({ dropdownMatchSelectWidth })=>{
    const warning = (0, _warning.devUseWarning)('ConfigProvider');
    warning.deprecated(dropdownMatchSelectWidth === undefined, 'dropdownMatchSelectWidth', 'popupMatchSelectWidth');
    return null;
});
exports.default = ()=>null;

},{"react":"bmhQu","../_util/warning":"95o3w","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Ccbk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../style");
var _useToken = require("../useToken");
var _useTokenDefault = parcelHelpers.interopDefault(_useToken);
const useResetIconStyle = (iconPrefixCls, csp)=>{
    const [theme, token] = (0, _useTokenDefault.default)();
    // Generate style for icons
    return (0, _cssinjs.useStyleRegister)({
        theme,
        token,
        hashId: '',
        path: [
            'ant-design-icons',
            iconPrefixCls
        ],
        nonce: ()=>csp?.nonce,
        layer: {
            name: 'antd'
        }
    }, ()=>(0, _style.genIconStyle)(iconPrefixCls));
};
exports.default = useResetIconStyle;

},{"@ant-design/cssinjs":"2VNL8","../../style":"4Ezp0","../useToken":"6x222","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Ezp0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "textEllipsis", ()=>textEllipsis);
parcelHelpers.export(exports, "resetComponent", ()=>resetComponent);
parcelHelpers.export(exports, "resetIcon", ()=>resetIcon);
parcelHelpers.export(exports, "clearFix", ()=>clearFix);
parcelHelpers.export(exports, "genLinkStyle", ()=>genLinkStyle);
parcelHelpers.export(exports, "genCommonStyle", ()=>genCommonStyle);
parcelHelpers.export(exports, "genFocusOutline", ()=>genFocusOutline);
parcelHelpers.export(exports, "genFocusStyle", ()=>genFocusStyle);
parcelHelpers.export(exports, "genIconStyle", ()=>genIconStyle);
parcelHelpers.export(exports, "operationUnit", ()=>operationUnit);
var _cssinjs = require("@ant-design/cssinjs");
"use client";
const textEllipsis = {
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
};
const resetComponent = (token, needInheritFontFamily = false)=>({
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
        color: token.colorText,
        fontSize: token.fontSize,
        // font-variant: @font-variant-base;
        lineHeight: token.lineHeight,
        listStyle: 'none',
        // font-feature-settings: @font-feature-settings-base;
        fontFamily: needInheritFontFamily ? 'inherit' : token.fontFamily
    });
const resetIcon = ()=>({
        display: 'inline-flex',
        alignItems: 'center',
        color: 'inherit',
        fontStyle: 'normal',
        lineHeight: 0,
        textAlign: 'center',
        textTransform: 'none',
        // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
        verticalAlign: '-0.125em',
        textRendering: 'optimizeLegibility',
        '-webkit-font-smoothing': 'antialiased',
        '-moz-osx-font-smoothing': 'grayscale',
        '> *': {
            lineHeight: 1
        },
        svg: {
            display: 'inline-block'
        }
    });
const clearFix = ()=>({
        // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
        '&::before': {
            display: 'table',
            content: '""'
        },
        '&::after': {
            // https://github.com/ant-design/ant-design/issues/21864
            display: 'table',
            clear: 'both',
            content: '""'
        }
    });
const genLinkStyle = (token)=>({
        a: {
            color: token.colorLink,
            textDecoration: token.linkDecoration,
            backgroundColor: 'transparent',
            // remove the gray background on active links in IE 10.
            outline: 'none',
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            '-webkit-text-decoration-skip': 'objects',
            // remove gaps in links underline in iOS 8+ and Safari 8+.
            '&:hover': {
                color: token.colorLinkHover
            },
            '&:active': {
                color: token.colorLinkActive
            },
            '&:active, &:hover': {
                textDecoration: token.linkHoverDecoration,
                outline: 0
            },
            // https://github.com/ant-design/ant-design/issues/22503
            '&:focus': {
                textDecoration: token.linkFocusDecoration,
                outline: 0
            },
            '&[disabled]': {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            }
        }
    });
const genCommonStyle = (token, componentPrefixCls, rootCls, resetFont)=>{
    const prefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
    const rootPrefixSelector = rootCls ? `.${rootCls}` : prefixSelector;
    const resetStyle = {
        boxSizing: 'border-box',
        '&::before, &::after': {
            boxSizing: 'border-box'
        }
    };
    let resetFontStyle = {};
    if (resetFont !== false) resetFontStyle = {
        fontFamily: token.fontFamily,
        fontSize: token.fontSize
    };
    return {
        [rootPrefixSelector]: {
            ...resetFontStyle,
            ...resetStyle,
            [prefixSelector]: resetStyle
        }
    };
};
const genFocusOutline = (token, offset)=>({
        outline: `${(0, _cssinjs.unit)(token.lineWidthFocus)} solid ${token.colorPrimaryBorder}`,
        outlineOffset: offset ?? 1,
        transition: 'outline-offset 0s, outline 0s'
    });
const genFocusStyle = (token, offset)=>({
        '&:focus-visible': genFocusOutline(token, offset)
    });
const genIconStyle = (iconPrefixCls)=>({
        [`.${iconPrefixCls}`]: {
            ...resetIcon(),
            [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
                display: 'block'
            }
        }
    });
const operationUnit = (token)=>({
        // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
        // And Typography use this to generate link style which should not do this.
        color: token.colorLink,
        textDecoration: token.linkDecoration,
        outline: 'none',
        cursor: 'pointer',
        transition: `all ${token.motionDurationSlow}`,
        border: 0,
        padding: 0,
        background: 'none',
        userSelect: 'none',
        ...genFocusStyle(token),
        '&:hover': {
            color: token.colorLinkHover,
            textDecoration: token.linkHoverDecoration
        },
        '&:focus': {
            color: token.colorLinkHover,
            textDecoration: token.linkFocusDecoration
        },
        '&:active': {
            color: token.colorLinkActive,
            textDecoration: token.linkHoverDecoration
        }
    });

},{"@ant-design/cssinjs":"2VNL8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gXe6G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sizeContext = require("../SizeContext");
var _sizeContextDefault = parcelHelpers.interopDefault(_sizeContext);
const useSize = (customSize)=>{
    const size = (0, _reactDefault.default).useContext((0, _sizeContextDefault.default));
    const mergedSize = (0, _reactDefault.default).useMemo(()=>{
        if (!customSize) return size;
        if (typeof customSize === 'string') return customSize ?? size;
        if (typeof customSize === 'function') return customSize(size);
        return size;
    }, [
        customSize,
        size
    ]);
    return mergedSize;
};
exports.default = useSize;

},{"react":"bmhQu","../SizeContext":"jlQPx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3nSQX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _internal = require("../../theme/internal");
const genSpaceCompactStyle = (token)=>{
    const { componentCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-block': {
                display: 'flex',
                width: '100%'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-rtl': {
                direction: 'rtl'
            }
        }
    };
};
// ============================== Export ==============================
exports.default = (0, _internal.genStyleHooks)([
    'Space',
    'Compact'
], (token)=>[
        genSpaceCompactStyle(token)
    ], ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});

},{"../../theme/internal":"eQVSZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eQVSZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genStyleHooks", ()=>genStyleHooks);
parcelHelpers.export(exports, "genComponentStyleHook", ()=>genComponentStyleHook);
parcelHelpers.export(exports, "genSubStyleComponent", ()=>genSubStyleComponent);
parcelHelpers.export(exports, "genCssVar", ()=>genCssVar);
var _react = require("react");
var _cssinjsUtils = require("@ant-design/cssinjs-utils");
var _context = require("../../config-provider/context");
var _style = require("../../style");
var _useToken = require("../useToken");
var _useTokenDefault = parcelHelpers.interopDefault(_useToken);
const { genStyleHooks, genComponentStyleHook, genSubStyleComponent } = (0, _cssinjsUtils.genStyleUtils)({
    usePrefix: ()=>{
        const { getPrefixCls, iconPrefixCls } = (0, _react.useContext)((0, _context.ConfigContext));
        const rootPrefixCls = getPrefixCls();
        return {
            rootPrefixCls,
            iconPrefixCls
        };
    },
    useToken: ()=>{
        const [theme, realToken, hashId, token, cssVar, zeroRuntime] = (0, _useTokenDefault.default)();
        return {
            theme,
            realToken,
            hashId,
            token,
            cssVar,
            zeroRuntime
        };
    },
    useCSP: ()=>{
        const { csp } = (0, _react.useContext)((0, _context.ConfigContext));
        return csp ?? {};
    },
    getResetStyles: (token, config)=>{
        const linkStyle = (0, _style.genLinkStyle)(token);
        return [
            linkStyle,
            {
                '&': linkStyle
            },
            (0, _style.genIconStyle)(config?.prefix.iconPrefixCls ?? (0, _context.defaultIconPrefixCls))
        ];
    },
    getCommonStyle: (0, _style.genCommonStyle),
    getCompUnitless: ()=>(0, _useToken.unitless)
});
const genCssVar = (antCls, componentAbbr)=>{
    const cssPrefix = `--${antCls.replace('.', '')}-${componentAbbr}-`;
    return (name, withVar = false)=>{
        const raw = `${cssPrefix}${name}`;
        return withVar ? `var(${raw})` : raw;
    };
};

},{"react":"bmhQu","@ant-design/cssinjs-utils":"g8twD","../../config-provider/context":"75zwC","../../style":"4Ezp0","../useToken":"6x222","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g8twD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genStyleUtils", ()=>(0, _genStyleUtilsDefault.default));
parcelHelpers.export(exports, "genCalc", ()=>(0, _calcDefault.default));
parcelHelpers.export(exports, "statisticToken", ()=>(0, _statisticDefault.default));
parcelHelpers.export(exports, "mergeToken", ()=>(0, _statistic.merge));
parcelHelpers.export(exports, "statistic", ()=>(0, _statistic.statistic));
var _genStyleUtils = require("./util/genStyleUtils");
var _genStyleUtilsDefault = parcelHelpers.interopDefault(_genStyleUtils);
var _calc = require("./util/calc");
var _calcDefault = parcelHelpers.interopDefault(_calc);
var _statistic = require("./util/statistic");
var _statisticDefault = parcelHelpers.interopDefault(_statistic);

},{"./util/genStyleUtils":"e5Glt","./util/calc":"8MDYt","./util/statistic":"4k5k3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e5Glt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _react = require("react");
var _cssinjs = require("@ant-design/cssinjs");
var _calc = require("./calc");
var _calcDefault = parcelHelpers.interopDefault(_calc);
var _getCompVarPrefix = require("./getCompVarPrefix");
var _getCompVarPrefixDefault = parcelHelpers.interopDefault(_getCompVarPrefix);
var _getComponentToken = require("./getComponentToken");
var _getComponentTokenDefault = parcelHelpers.interopDefault(_getComponentToken);
var _getDefaultComponentToken = require("./getDefaultComponentToken");
var _getDefaultComponentTokenDefault = parcelHelpers.interopDefault(_getDefaultComponentToken);
var _maxmin = require("./maxmin");
var _maxminDefault = parcelHelpers.interopDefault(_maxmin);
var _statistic = require("./statistic");
var _statisticDefault = parcelHelpers.interopDefault(_statistic);
var _useUniqueMemo = require("../_util/hooks/useUniqueMemo");
var _useUniqueMemoDefault = parcelHelpers.interopDefault(_useUniqueMemo);
var _useCSP = require("../hooks/useCSP");
var _useCSPDefault = parcelHelpers.interopDefault(_useCSP);
function genStyleUtils(config) {
    // Dependency inversion for preparing basic config.
    var _config$useCSP = config.useCSP, useCSP = _config$useCSP === void 0 ? (0, _useCSPDefault.default) : _config$useCSP, useToken = config.useToken, usePrefix = config.usePrefix, getResetStyles = config.getResetStyles, getCommonStyle = config.getCommonStyle, getCompUnitless = config.getCompUnitless;
    function genStyleHooks(component, styleFn, getDefaultToken, options) {
        var componentName = Array.isArray(component) ? component[0] : component;
        function prefixToken(key) {
            return "".concat(String(componentName)).concat(key.slice(0, 1).toUpperCase()).concat(key.slice(1));
        }
        // Fill unitless
        var originUnitless = (options === null || options === void 0 ? void 0 : options.unitless) || {};
        var originCompUnitless = typeof getCompUnitless === 'function' ? getCompUnitless(component) : {};
        var compUnitless = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, originCompUnitless), {}, (0, _definePropertyDefault.default)({}, prefixToken('zIndexPopup'), true));
        Object.keys(originUnitless).forEach(function(key) {
            compUnitless[prefixToken(key)] = originUnitless[key];
        });
        // Options
        var mergedOptions = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, options), {}, {
            unitless: compUnitless,
            prefixToken: prefixToken
        });
        // Hooks
        var useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, mergedOptions);
        var useCSSVar = genCSSVarRegister(componentName, getDefaultToken, mergedOptions);
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var hashId = useStyle(prefixCls, rootCls);
            var cssVarCls = useCSSVar(rootCls);
            return [
                hashId,
                cssVarCls
            ];
        };
    }
    function genCSSVarRegister(component, getDefaultToken, options) {
        var compUnitless = options.unitless, prefixToken = options.prefixToken, ignore = options.ignore;
        return function(rootCls) {
            var _useToken = useToken(), cssVar = _useToken.cssVar, realToken = _useToken.realToken;
            (0, _cssinjs.useCSSVarRegister)({
                path: [
                    component
                ],
                prefix: cssVar.prefix,
                key: cssVar.key,
                unitless: compUnitless,
                ignore: ignore,
                token: realToken,
                scope: rootCls
            }, function() {
                var defaultToken = (0, _getDefaultComponentTokenDefault.default)(component, realToken, getDefaultToken);
                var componentToken = (0, _getComponentTokenDefault.default)(component, realToken, defaultToken, {
                    deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
                });
                if (defaultToken) Object.keys(defaultToken).forEach(function(key) {
                    componentToken[prefixToken(key)] = componentToken[key];
                    delete componentToken[key];
                });
                return componentToken;
            });
            return cssVar === null || cssVar === void 0 ? void 0 : cssVar.key;
        };
    }
    function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var cells = Array.isArray(componentName) ? componentName : [
            componentName,
            componentName
        ];
        var _cells = (0, _slicedToArrayDefault.default)(cells, 1), component = _cells[0];
        var concatComponent = cells.join('-');
        var mergedLayer = config.layer || {
            name: 'antd'
        };
        // Return new style hook
        return function(prefixCls) {
            var rootCls = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : prefixCls;
            var _useToken2 = useToken(), theme = _useToken2.theme, realToken = _useToken2.realToken, hashId = _useToken2.hashId, token = _useToken2.token, cssVar = _useToken2.cssVar, zeroRuntime = _useToken2.zeroRuntime;
            // Update of `disabledRuntimeStyle` would cause React hook error, so memoized it and never update.
            var memoizedZeroRuntime = (0, _react.useMemo)(function() {
                return zeroRuntime;
            }, []);
            if (memoizedZeroRuntime) return hashId;
            var _usePrefix = usePrefix(), rootPrefixCls = _usePrefix.rootPrefixCls, iconPrefixCls = _usePrefix.iconPrefixCls;
            var csp = useCSP();
            var type = 'css';
            // Use unique memo to share the result across all instances
            var calc = (0, _useUniqueMemoDefault.default)(function() {
                var unitlessCssVar = new Set();
                Object.keys(options.unitless || {}).forEach(function(key) {
                    // Some component proxy the AliasToken (e.g. Image) and some not (e.g. Modal)
                    // We should both pass in `unitlessCssVar` to make sure the CSSVar can be unitless.
                    unitlessCssVar.add((0, _cssinjs.token2CSSVar)(key, cssVar.prefix));
                    unitlessCssVar.add((0, _cssinjs.token2CSSVar)(key, (0, _getCompVarPrefixDefault.default)(component, cssVar.prefix)));
                });
                return (0, _calcDefault.default)(type, unitlessCssVar);
            }, [
                type,
                component,
                cssVar === null || cssVar === void 0 ? void 0 : cssVar.prefix
            ]);
            var _genMaxMin = (0, _maxminDefault.default)(type), max = _genMaxMin.max, min = _genMaxMin.min;
            // Shared config
            var sharedConfig = {
                theme: theme,
                token: token,
                hashId: hashId,
                nonce: function nonce() {
                    return csp.nonce;
                },
                clientOnly: options.clientOnly,
                layer: mergedLayer,
                // antd is always at top of styles
                order: options.order || -999
            };
            // This if statement is safe, as it will only be used if the generator has the function. It's not dynamic.
            if (typeof getResetStyles === 'function') // Generate style for all need reset tags.
            (0, _cssinjs.useStyleRegister)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, sharedConfig), {}, {
                clientOnly: false,
                path: [
                    'Shared',
                    rootPrefixCls
                ]
            }), function() {
                return getResetStyles(token, {
                    prefix: {
                        rootPrefixCls: rootPrefixCls,
                        iconPrefixCls: iconPrefixCls
                    },
                    csp: csp
                });
            });
            (0, _cssinjs.useStyleRegister)((0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, sharedConfig), {}, {
                path: [
                    concatComponent,
                    prefixCls,
                    iconPrefixCls
                ]
            }), function() {
                if (options.injectStyle === false) return [];
                var _statisticToken = (0, _statisticDefault.default)(token), proxyToken = _statisticToken.token, flush = _statisticToken.flush;
                var defaultComponentToken = (0, _getDefaultComponentTokenDefault.default)(component, realToken, getDefaultToken);
                var componentCls = ".".concat(prefixCls);
                var componentToken = (0, _getComponentTokenDefault.default)(component, realToken, defaultComponentToken, {
                    deprecatedTokens: options.deprecatedTokens
                });
                if (defaultComponentToken && (0, _typeofDefault.default)(defaultComponentToken) === 'object') Object.keys(defaultComponentToken).forEach(function(key) {
                    defaultComponentToken[key] = "var(".concat((0, _cssinjs.token2CSSVar)(key, (0, _getCompVarPrefixDefault.default)(component, cssVar.prefix)), ")");
                });
                var mergedToken = (0, _statistic.merge)(proxyToken, {
                    componentCls: componentCls,
                    prefixCls: prefixCls,
                    iconCls: ".".concat(iconPrefixCls),
                    antCls: ".".concat(rootPrefixCls),
                    calc: calc,
                    max: max,
                    min: min
                }, defaultComponentToken);
                var styleInterpolation = styleFn(mergedToken, {
                    hashId: hashId,
                    prefixCls: prefixCls,
                    rootPrefixCls: rootPrefixCls,
                    iconPrefixCls: iconPrefixCls
                });
                flush(component, componentToken);
                var commonStyle = typeof getCommonStyle === 'function' ? getCommonStyle(mergedToken, prefixCls, rootCls, options.resetFont) : null;
                return [
                    options.resetStyle === false ? null : commonStyle,
                    styleInterpolation
                ];
            });
            return hashId;
        };
    }
    function genSubStyleComponent(componentName, styleFn, getDefaultToken) {
        var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
        var useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, (0, _objectSpread2Default.default)({
            resetStyle: false,
            // Sub Style should default after root one
            order: -998
        }, options));
        var StyledComponent = function StyledComponent(_ref) {
            var prefixCls = _ref.prefixCls, _ref$rootCls = _ref.rootCls, rootCls = _ref$rootCls === void 0 ? prefixCls : _ref$rootCls;
            useStyle(prefixCls, rootCls);
            return null;
        };
        return StyledComponent;
    }
    return {
        genStyleHooks: genStyleHooks,
        genSubStyleComponent: genSubStyleComponent,
        genComponentStyleHook: genComponentStyleHook
    };
}
exports.default = genStyleUtils;

},{"@babel/runtime/helpers/esm/typeof":"8oq3j","@babel/runtime/helpers/esm/slicedToArray":"bem4D","@babel/runtime/helpers/esm/defineProperty":"ibVzI","@babel/runtime/helpers/esm/objectSpread2":"dn9qZ","react":"bmhQu","@ant-design/cssinjs":"2VNL8","./calc":"8MDYt","./getCompVarPrefix":"jypW4","./getComponentToken":"9F8in","./getDefaultComponentToken":"lsIKU","./maxmin":"aFUgI","./statistic":"4k5k3","../_util/hooks/useUniqueMemo":"Px9lB","../hooks/useCSP":"7sq19","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bem4D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_slicedToArray);
var _arrayWithHolesJs = require("./arrayWithHoles.js");
var _arrayWithHolesJsDefault = parcelHelpers.interopDefault(_arrayWithHolesJs);
var _iterableToArrayLimitJs = require("./iterableToArrayLimit.js");
var _iterableToArrayLimitJsDefault = parcelHelpers.interopDefault(_iterableToArrayLimitJs);
var _unsupportedIterableToArrayJs = require("./unsupportedIterableToArray.js");
var _unsupportedIterableToArrayJsDefault = parcelHelpers.interopDefault(_unsupportedIterableToArrayJs);
var _nonIterableRestJs = require("./nonIterableRest.js");
var _nonIterableRestJsDefault = parcelHelpers.interopDefault(_nonIterableRestJs);
function _slicedToArray(r, e) {
    return (0, _arrayWithHolesJsDefault.default)(r) || (0, _iterableToArrayLimitJsDefault.default)(r, e) || (0, _unsupportedIterableToArrayJsDefault.default)(r, e) || (0, _nonIterableRestJsDefault.default)();
}

},{"./arrayWithHoles.js":"6HY0K","./iterableToArrayLimit.js":"eqjO6","./unsupportedIterableToArray.js":"cL2qX","./nonIterableRest.js":"g4mey","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6HY0K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_arrayWithHoles);
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eqjO6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_iterableToArrayLimit);
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g4mey":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>_nonIterableRest);
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8MDYt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _csscalculator = require("./CSSCalculator");
var _csscalculatorDefault = parcelHelpers.interopDefault(_csscalculator);
var _numCalculator = require("./NumCalculator");
var _numCalculatorDefault = parcelHelpers.interopDefault(_numCalculator);
var genCalc = function genCalc(type, unitlessCssVar) {
    var Calculator = type === 'css' ? (0, _csscalculatorDefault.default) : (0, _numCalculatorDefault.default);
    return function(num) {
        return new Calculator(num, unitlessCssVar);
    };
};
exports.default = genCalc;

},{"./CSSCalculator":"gHkVO","./NumCalculator":"8xkTA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gHkVO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>CSSCalculator);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _calculator = require("./calculator");
var _calculatorDefault = parcelHelpers.interopDefault(_calculator);
var CALC_UNIT = 'CALC_UNIT';
var regexp = new RegExp(CALC_UNIT, 'g');
function unit(value) {
    if (typeof value === 'number') return "".concat(value).concat(CALC_UNIT);
    return value;
}
var CSSCalculator = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, _inheritsDefault.default)(CSSCalculator, _AbstractCalculator);
    var _super = (0, _createSuperDefault.default)(CSSCalculator);
    function CSSCalculator(num, unitlessCssVar) {
        var _this;
        (0, _classCallCheckDefault.default)(this, CSSCalculator);
        _this = _super.call(this);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "result", '');
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "unitlessCssVar", void 0);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "lowPriority", void 0);
        var numType = (0, _typeofDefault.default)(num);
        _this.unitlessCssVar = unitlessCssVar;
        if (num instanceof CSSCalculator) _this.result = "(".concat(num.result, ")");
        else if (numType === 'number') _this.result = unit(num);
        else if (numType === 'string') _this.result = num;
        return _this;
    }
    (0, _createClassDefault.default)(CSSCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " + ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " + ").concat(unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " - ").concat(num.getResult());
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " - ").concat(unit(num));
                this.lowPriority = true;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " * ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " * ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (this.lowPriority) this.result = "(".concat(this.result, ")");
                if (num instanceof CSSCalculator) this.result = "".concat(this.result, " / ").concat(num.getResult(true));
                else if (typeof num === 'number' || typeof num === 'string') this.result = "".concat(this.result, " / ").concat(num);
                this.lowPriority = false;
                return this;
            }
        },
        {
            key: "getResult",
            value: function getResult(force) {
                return this.lowPriority || force ? "(".concat(this.result, ")") : this.result;
            }
        },
        {
            key: "equal",
            value: function equal(options) {
                var _this2 = this;
                var _ref = options || {}, cssUnit = _ref.unit;
                var mergedUnit = true;
                if (typeof cssUnit === 'boolean') mergedUnit = cssUnit;
                else if (Array.from(this.unitlessCssVar).some(function(cssVar) {
                    return _this2.result.includes(cssVar);
                })) mergedUnit = false;
                this.result = this.result.replace(regexp, mergedUnit ? 'px' : '');
                if (typeof this.lowPriority !== 'undefined') return "calc(".concat(this.result, ")");
                return this.result;
            }
        }
    ]);
    return CSSCalculator;
}((0, _calculatorDefault.default));

},{"@babel/runtime/helpers/esm/typeof":"8oq3j","@babel/runtime/helpers/esm/classCallCheck":"1eYFn","@babel/runtime/helpers/esm/createClass":"89Fc8","@babel/runtime/helpers/esm/assertThisInitialized":"9WIi6","@babel/runtime/helpers/esm/inherits":"9qeOz","@babel/runtime/helpers/esm/createSuper":"4Z7nH","@babel/runtime/helpers/esm/defineProperty":"ibVzI","./calculator":"kQonn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kQonn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var AbstractCalculator = /*#__PURE__*/ (0, _createClassDefault.default)(function AbstractCalculator() {
    (0, _classCallCheckDefault.default)(this, AbstractCalculator);
});
exports.default = AbstractCalculator;

},{"@babel/runtime/helpers/esm/createClass":"89Fc8","@babel/runtime/helpers/esm/classCallCheck":"1eYFn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8xkTA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _assertThisInitialized = require("@babel/runtime/helpers/esm/assertThisInitialized");
var _assertThisInitializedDefault = parcelHelpers.interopDefault(_assertThisInitialized);
var _inherits = require("@babel/runtime/helpers/esm/inherits");
var _inheritsDefault = parcelHelpers.interopDefault(_inherits);
var _createSuper = require("@babel/runtime/helpers/esm/createSuper");
var _createSuperDefault = parcelHelpers.interopDefault(_createSuper);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _calculator = require("./calculator");
var _calculatorDefault = parcelHelpers.interopDefault(_calculator);
var NumCalculator = /*#__PURE__*/ function(_AbstractCalculator) {
    (0, _inheritsDefault.default)(NumCalculator, _AbstractCalculator);
    var _super = (0, _createSuperDefault.default)(NumCalculator);
    function NumCalculator(num) {
        var _this;
        (0, _classCallCheckDefault.default)(this, NumCalculator);
        _this = _super.call(this);
        (0, _definePropertyDefault.default)((0, _assertThisInitializedDefault.default)(_this), "result", 0);
        if (num instanceof NumCalculator) _this.result = num.result;
        else if (typeof num === 'number') _this.result = num;
        return _this;
    }
    (0, _createClassDefault.default)(NumCalculator, [
        {
            key: "add",
            value: function add(num) {
                if (num instanceof NumCalculator) this.result += num.result;
                else if (typeof num === 'number') this.result += num;
                return this;
            }
        },
        {
            key: "sub",
            value: function sub(num) {
                if (num instanceof NumCalculator) this.result -= num.result;
                else if (typeof num === 'number') this.result -= num;
                return this;
            }
        },
        {
            key: "mul",
            value: function mul(num) {
                if (num instanceof NumCalculator) this.result *= num.result;
                else if (typeof num === 'number') this.result *= num;
                return this;
            }
        },
        {
            key: "div",
            value: function div(num) {
                if (num instanceof NumCalculator) this.result /= num.result;
                else if (typeof num === 'number') this.result /= num;
                return this;
            }
        },
        {
            key: "equal",
            value: function equal() {
                return this.result;
            }
        }
    ]);
    return NumCalculator;
}((0, _calculatorDefault.default));
exports.default = NumCalculator;

},{"@babel/runtime/helpers/esm/classCallCheck":"1eYFn","@babel/runtime/helpers/esm/createClass":"89Fc8","@babel/runtime/helpers/esm/assertThisInitialized":"9WIi6","@babel/runtime/helpers/esm/inherits":"9qeOz","@babel/runtime/helpers/esm/createSuper":"4Z7nH","@babel/runtime/helpers/esm/defineProperty":"ibVzI","./calculator":"kQonn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jypW4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var getCompVarPrefix = function getCompVarPrefix(component, prefix) {
    return "".concat([
        prefix,
        component.replace(/([A-Z]+)([A-Z][a-z]+)/g, '$1-$2').replace(/([a-z])([A-Z])/g, '$1-$2')
    ].filter(Boolean).join('-'));
};
exports.default = getCompVarPrefix;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9F8in":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _slicedToArray = require("@babel/runtime/helpers/esm/slicedToArray");
var _slicedToArrayDefault = parcelHelpers.interopDefault(_slicedToArray);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _util = require("@rc-component/util");
function getComponentToken(component, token, defaultToken, options) {
    var customToken = (0, _objectSpread2Default.default)({}, token[component]);
    if (options !== null && options !== void 0 && options.deprecatedTokens) {
        var deprecatedTokens = options.deprecatedTokens;
        deprecatedTokens.forEach(function(_ref) {
            var _ref2 = (0, _slicedToArrayDefault.default)(_ref, 2), oldTokenKey = _ref2[0], newTokenKey = _ref2[1];
            // Should wrap with `if` clause, or there will be `undefined` in object.
            if (customToken !== null && customToken !== void 0 && customToken[oldTokenKey] || customToken !== null && customToken !== void 0 && customToken[newTokenKey]) {
                var _customToken$newToken;
                (_customToken$newToken = customToken[newTokenKey]) !== null && _customToken$newToken !== void 0 ? _customToken$newToken : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
            }
        });
    }
    var mergedToken = (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, defaultToken), customToken);
    // Remove same value as global token to minimize size
    Object.keys(mergedToken).forEach(function(key) {
        if (mergedToken[key] === token[key]) delete mergedToken[key];
    });
    return mergedToken;
}
exports.default = getComponentToken;

},{"@babel/runtime/helpers/esm/slicedToArray":"bem4D","@babel/runtime/helpers/esm/objectSpread2":"dn9qZ","@rc-component/util":"6ZBDN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lsIKU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _statistic = require("./statistic");
function getDefaultComponentToken(component, token, getDefaultToken) {
    if (typeof getDefaultToken === 'function') {
        var _token$component;
        return getDefaultToken((0, _statistic.merge)(token, (_token$component = token[component]) !== null && _token$component !== void 0 ? _token$component : {}));
    }
    return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
}
exports.default = getDefaultComponentToken;

},{"./statistic":"4k5k3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4k5k3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This function will do as `Object.assign` in production. But will use Object.defineProperty:get to
 * pass all value access in development. To support statistic field usage with alias token.
 */ parcelHelpers.export(exports, "merge", ()=>merge);
parcelHelpers.export(exports, "statistic", ()=>statistic);
parcelHelpers.export(exports, "_statistic_build_", ()=>_statistic_build_);
var _objectSpread2 = require("@babel/runtime/helpers/esm/objectSpread2");
var _objectSpread2Default = parcelHelpers.interopDefault(_objectSpread2);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var enableStatistic = typeof CSSINJS_STATISTIC !== 'undefined';
var recording = true;
function merge() {
    for(var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++)objs[_key] = arguments[_key];
    /* istanbul ignore next */ if (!enableStatistic) return Object.assign.apply(Object, [
        {}
    ].concat(objs));
    recording = false;
    var ret = {};
    objs.forEach(function(obj) {
        if ((0, _typeofDefault.default)(obj) !== 'object') return;
        var keys = Object.keys(obj);
        keys.forEach(function(key) {
            Object.defineProperty(ret, key, {
                configurable: true,
                enumerable: true,
                get: function get() {
                    return obj[key];
                }
            });
        });
    });
    recording = true;
    return ret;
}
var statistic = {};
var _statistic_build_ = {};
/* istanbul ignore next */ function noop() {}
/** Statistic token usage case. Should use `merge` function if you do not want spread record. */ var statisticToken = function statisticToken(token) {
    var tokenKeys;
    var proxy = token;
    var flush = noop;
    if (enableStatistic && typeof Proxy !== 'undefined') {
        tokenKeys = new Set();
        proxy = new Proxy(token, {
            get: function get(obj, prop) {
                if (recording) {
                    var _tokenKeys;
                    (_tokenKeys = tokenKeys) === null || _tokenKeys === void 0 || _tokenKeys.add(prop);
                }
                return obj[prop];
            }
        });
        flush = function flush(componentName, componentToken) {
            var _statistic$componentN;
            statistic[componentName] = {
                global: Array.from(tokenKeys),
                component: (0, _objectSpread2Default.default)((0, _objectSpread2Default.default)({}, (_statistic$componentN = statistic[componentName]) === null || _statistic$componentN === void 0 ? void 0 : _statistic$componentN.component), componentToken)
            };
        };
    }
    return {
        token: proxy,
        keys: tokenKeys,
        flush: flush
    };
};
exports.default = statisticToken;

},{"@babel/runtime/helpers/esm/objectSpread2":"dn9qZ","@babel/runtime/helpers/esm/typeof":"8oq3j","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aFUgI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
function genMaxMin(type) {
    if (type === 'js') return {
        max: Math.max,
        min: Math.min
    };
    return {
        max: function max() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return "max(".concat(args.map(function(value) {
                return (0, _cssinjs.unit)(value);
            }).join(','), ")");
        },
        min: function min() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return "min(".concat(args.map(function(value) {
                return (0, _cssinjs.unit)(value);
            }).join(','), ")");
        }
    };
}
exports.default = genMaxMin;

},{"@ant-design/cssinjs":"2VNL8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Px9lB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _typeof = require("@babel/runtime/helpers/esm/typeof");
var _typeofDefault = parcelHelpers.interopDefault(_typeof);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _defineProperty = require("@babel/runtime/helpers/esm/defineProperty");
var _definePropertyDefault = parcelHelpers.interopDefault(_defineProperty);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var BEAT_LIMIT = 600000;
/**
 * A helper class to map keys to values.
 * It supports both primitive keys and object keys.
 */ var ArrayKeyMap = /*#__PURE__*/ function() {
    function ArrayKeyMap() {
        (0, _classCallCheckDefault.default)(this, ArrayKeyMap);
        (0, _definePropertyDefault.default)(this, "map", new Map());
        // Use WeakMap to avoid memory leak
        (0, _definePropertyDefault.default)(this, "objectIDMap", new WeakMap());
        (0, _definePropertyDefault.default)(this, "nextID", 0);
        (0, _definePropertyDefault.default)(this, "lastAccessBeat", new Map());
        // We will clean up the cache when reach the limit
        (0, _definePropertyDefault.default)(this, "accessBeat", 0);
    }
    (0, _createClassDefault.default)(ArrayKeyMap, [
        {
            key: "set",
            value: function set(keys, value) {
                // New set will trigger clear
                this.clear();
                // Set logic
                var compositeKey = this.getCompositeKey(keys);
                this.map.set(compositeKey, value);
                this.lastAccessBeat.set(compositeKey, Date.now());
            }
        },
        {
            key: "get",
            value: function get(keys) {
                var compositeKey = this.getCompositeKey(keys);
                var cache = this.map.get(compositeKey);
                this.lastAccessBeat.set(compositeKey, Date.now());
                this.accessBeat += 1;
                return cache;
            }
        },
        {
            key: "getCompositeKey",
            value: function getCompositeKey(keys) {
                var _this = this;
                var ids = keys.map(function(key) {
                    if (key && (0, _typeofDefault.default)(key) === 'object') return "obj_".concat(_this.getObjectID(key));
                    return "".concat((0, _typeofDefault.default)(key), "_").concat(key);
                });
                return ids.join('|');
            }
        },
        {
            key: "getObjectID",
            value: function getObjectID(obj) {
                if (this.objectIDMap.has(obj)) return this.objectIDMap.get(obj);
                var id = this.nextID;
                this.objectIDMap.set(obj, id);
                this.nextID += 1;
                return id;
            }
        },
        {
            key: "clear",
            value: function clear() {
                var _this2 = this;
                if (this.accessBeat > 10000) {
                    var now = Date.now();
                    this.lastAccessBeat.forEach(function(beat, key) {
                        if (now - beat > BEAT_LIMIT) {
                            _this2.map.delete(key);
                            _this2.lastAccessBeat.delete(key);
                        }
                    });
                    this.accessBeat = 0;
                }
            }
        }
    ]);
    return ArrayKeyMap;
}();
var uniqueMap = new ArrayKeyMap();
/**
 * Like `useMemo`, but this hook result will be shared across all instances.
 */ function useUniqueMemo(memoFn, deps) {
    return (0, _reactDefault.default).useMemo(function() {
        var cachedValue = uniqueMap.get(deps);
        if (cachedValue) return cachedValue;
        var newValue = memoFn();
        uniqueMap.set(deps, newValue);
        return newValue;
    }, deps);
}
exports.default = useUniqueMemo;

},{"@babel/runtime/helpers/esm/typeof":"8oq3j","@babel/runtime/helpers/esm/classCallCheck":"1eYFn","@babel/runtime/helpers/esm/createClass":"89Fc8","@babel/runtime/helpers/esm/defineProperty":"ibVzI","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7sq19":[function(require,module,exports,__globalThis) {
/**
 * Provide a default hook since not everyone needs to config this.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var useDefaultCSP = function useDefaultCSP() {
    return {};
};
exports.default = useDefaultCSP;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"avlqw":[function(require,module,exports,__globalThis) {
// \b([A-Za-z_$][\w$]*)\s*!==\s*(?:undefined\s*&&\s*\1\s*!==\s*null|null\s*&&\s*\1\s*!==\s*undefined)\b
// \b([A-Za-z_$][\w$\.]*)\s*===\s*(?:undefined|null)\s*\|\|\s*\1\s*===\s*(?:undefined|null)\b
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const isNonNullable = (val)=>{
    return val !== undefined && val !== null;
};
exports.default = isNonNullable;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6noQ6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONTAINER_MAX_OFFSET", ()=>CONTAINER_MAX_OFFSET);
parcelHelpers.export(exports, "containerBaseZIndexOffset", ()=>containerBaseZIndexOffset);
parcelHelpers.export(exports, "consumerBaseZIndexOffset", ()=>consumerBaseZIndexOffset);
parcelHelpers.export(exports, "useZIndex", ()=>useZIndex);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useToken = require("../../theme/useToken");
var _useTokenDefault = parcelHelpers.interopDefault(_useToken);
var _warning = require("../warning");
var _zindexContext = require("../zindexContext");
var _zindexContextDefault = parcelHelpers.interopDefault(_zindexContext);
// Z-Index control range
// Container: 1000 + offset 100 (max base + 10 * offset = 2000)
// Popover: offset 50
// Notification: Container Max zIndex + componentOffset
const CONTAINER_OFFSET = 100;
const CONTAINER_OFFSET_MAX_COUNT = 10;
const CONTAINER_MAX_OFFSET = CONTAINER_OFFSET * CONTAINER_OFFSET_MAX_COUNT;
/**
 * Static function will default be the `CONTAINER_MAX_OFFSET`.
 * But it still may have children component like Select, Dropdown.
 * So the warning zIndex should exceed the `CONTAINER_MAX_OFFSET`.
 */ const CONTAINER_MAX_OFFSET_WITH_CHILDREN = CONTAINER_MAX_OFFSET + CONTAINER_OFFSET;
const containerBaseZIndexOffset = {
    Modal: CONTAINER_OFFSET,
    Drawer: CONTAINER_OFFSET,
    Popover: CONTAINER_OFFSET,
    Popconfirm: CONTAINER_OFFSET,
    Tooltip: CONTAINER_OFFSET,
    Tour: CONTAINER_OFFSET,
    FloatButton: CONTAINER_OFFSET
};
const consumerBaseZIndexOffset = {
    SelectLike: 50,
    Dropdown: 50,
    DatePicker: 50,
    Menu: 50,
    ImagePreview: 1
};
const isContainerType = (type)=>{
    return type in containerBaseZIndexOffset;
};
const useZIndex = (componentType, customZIndex)=>{
    const [, token] = (0, _useTokenDefault.default)();
    const parentZIndex = (0, _reactDefault.default).useContext((0, _zindexContextDefault.default));
    const isContainer = isContainerType(componentType);
    let result;
    if (customZIndex !== undefined) result = [
        customZIndex,
        customZIndex
    ];
    else {
        let zIndex = parentZIndex ?? 0;
        if (isContainer) zIndex += // Use preset token zIndex by default but not stack when has parent container
        (parentZIndex ? 0 : token.zIndexPopupBase) + // Container offset
        containerBaseZIndexOffset[componentType];
        else zIndex += consumerBaseZIndexOffset[componentType];
        result = [
            parentZIndex === undefined ? customZIndex : zIndex,
            zIndex
        ];
    }
    return result;
};

},{"react":"bmhQu","../../theme/useToken":"6x222","../warning":"95o3w","../zindexContext":"e9ihh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e9ihh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const zIndexContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(undefined);
exports.default = zIndexContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kUUSo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTransitionName", ()=>getTransitionName);
var _configProvider = require("../config-provider");
// ================== Collapse Motion ==================
const getCollapsedHeight = ()=>({
        height: 0,
        opacity: 0
    });
const getRealHeight = (node)=>{
    const { scrollHeight } = node;
    return {
        height: scrollHeight,
        opacity: 1
    };
};
const getCurrentHeight = (node)=>({
        height: node ? node.offsetHeight : 0
    });
const skipOpacityTransition = (_, event)=>event?.deadline === true || event.propertyName === 'height';
const initCollapseMotion = (rootCls = (0, _configProvider.defaultPrefixCls))=>({
        motionName: `${rootCls}-motion-collapse`,
        onAppearStart: getCollapsedHeight,
        onEnterStart: getCollapsedHeight,
        onAppearActive: getRealHeight,
        onEnterActive: getRealHeight,
        onLeaveStart: getCurrentHeight,
        onLeaveActive: getCollapsedHeight,
        onAppearEnd: skipOpacityTransition,
        onEnterEnd: skipOpacityTransition,
        onLeaveEnd: skipOpacityTransition,
        motionDeadline: 500
    });
const _SelectPlacements = [
    'bottomLeft',
    'bottomRight',
    'topLeft',
    'topRight'
];
const getTransitionName = (rootPrefixCls, motion, transitionName)=>{
    if (transitionName !== undefined) return transitionName;
    return `${rootPrefixCls}-${motion}`;
};
exports.default = initCollapseMotion;

},{"../config-provider":"dVeAX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gti5Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getOverflowOptions", ()=>getOverflowOptions);
parcelHelpers.export(exports, "default", ()=>getPlacements);
var _placementArrow = require("../style/placementArrow");
function getOverflowOptions(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
    if (autoAdjustOverflow === false) return {
        adjustX: false,
        adjustY: false
    };
    const overflow = autoAdjustOverflow && typeof autoAdjustOverflow === 'object' ? autoAdjustOverflow : {};
    const baseOverflow = {};
    switch(placement){
        case 'top':
        case 'bottom':
            baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
            baseOverflow.shiftY = true;
            baseOverflow.adjustY = true;
            break;
        case 'left':
        case 'right':
            baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
            baseOverflow.shiftX = true;
            baseOverflow.adjustX = true;
            break;
    }
    const mergedOverflow = {
        ...baseOverflow,
        ...overflow
    };
    // Support auto shift
    if (!mergedOverflow.shiftX) mergedOverflow.adjustX = true;
    if (!mergedOverflow.shiftY) mergedOverflow.adjustY = true;
    return mergedOverflow;
}
const PlacementAlignMap = {
    left: {
        points: [
            'cr',
            'cl'
        ]
    },
    right: {
        points: [
            'cl',
            'cr'
        ]
    },
    top: {
        points: [
            'bc',
            'tc'
        ]
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ]
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tr'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ]
    }
};
const ArrowCenterPlacementAlignMap = {
    topLeft: {
        points: [
            'bl',
            'tc'
        ]
    },
    leftTop: {
        points: [
            'tr',
            'cl'
        ]
    },
    topRight: {
        points: [
            'br',
            'tc'
        ]
    },
    rightTop: {
        points: [
            'tl',
            'cr'
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'bc'
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'cr'
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bc'
        ]
    },
    leftBottom: {
        points: [
            'br',
            'cl'
        ]
    }
};
const DisableAutoArrowList = new Set([
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
    'leftTop',
    'leftBottom',
    'rightTop',
    'rightBottom'
]);
function getPlacements(config) {
    const { arrowWidth, autoAdjustOverflow, arrowPointAtCenter, offset, borderRadius, visibleFirst } = config;
    const halfArrowWidth = arrowWidth / 2;
    const placementMap = {};
    // Dynamic offset
    const arrowOffset = (0, _placementArrow.getArrowOffsetToken)({
        contentRadius: borderRadius,
        limitVerticalRadius: true
    });
    Object.keys(PlacementAlignMap).forEach((key)=>{
        const template = arrowPointAtCenter && ArrowCenterPlacementAlignMap[key] || PlacementAlignMap[key];
        const placementInfo = {
            ...template,
            offset: [
                0,
                0
            ],
            dynamicInset: true
        };
        placementMap[key] = placementInfo;
        // Disable autoArrow since design is fixed position
        if (DisableAutoArrowList.has(key)) placementInfo.autoArrow = false;
        // Static offset
        switch(key){
            case 'top':
            case 'topLeft':
            case 'topRight':
                placementInfo.offset[1] = -halfArrowWidth - offset;
                break;
            case 'bottom':
            case 'bottomLeft':
            case 'bottomRight':
                placementInfo.offset[1] = halfArrowWidth + offset;
                break;
            case 'left':
            case 'leftTop':
            case 'leftBottom':
                placementInfo.offset[0] = -halfArrowWidth - offset;
                break;
            case 'right':
            case 'rightTop':
            case 'rightBottom':
                placementInfo.offset[0] = halfArrowWidth + offset;
                break;
        }
        if (arrowPointAtCenter) switch(key){
            case 'topLeft':
            case 'bottomLeft':
                placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
                break;
            case 'topRight':
            case 'bottomRight':
                placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
                break;
            case 'leftTop':
            case 'rightTop':
                placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal * 2 + halfArrowWidth;
                break;
            case 'leftBottom':
            case 'rightBottom':
                placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal * 2 - halfArrowWidth;
                break;
        }
        // Overflow
        placementInfo.overflow = getOverflowOptions(key, arrowOffset, arrowWidth, autoAdjustOverflow);
        // VisibleFirst
        if (visibleFirst) placementInfo.htmlRegion = 'visibleFirst';
    });
    return placementMap;
}

},{"../style/placementArrow":"73A7X","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"73A7X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_VERTICAL_CONTENT_RADIUS", ()=>MAX_VERTICAL_CONTENT_RADIUS);
parcelHelpers.export(exports, "getArrowOffsetToken", ()=>getArrowOffsetToken);
parcelHelpers.export(exports, "default", ()=>getArrowStyle);
var _cssinjs = require("@ant-design/cssinjs");
var _roundedArrow = require("./roundedArrow");
const MAX_VERTICAL_CONTENT_RADIUS = 8;
function getArrowOffsetToken(options) {
    const { contentRadius, limitVerticalRadius } = options;
    const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
    const arrowOffsetVertical = limitVerticalRadius ? MAX_VERTICAL_CONTENT_RADIUS : arrowOffset;
    return {
        arrowOffsetHorizontal: arrowOffset,
        arrowOffsetVertical
    };
}
function isInject(valid, code) {
    if (!valid) return {};
    return code;
}
function getArrowStyle(token, colorBg, options) {
    const { componentCls, boxShadowPopoverArrow, arrowOffsetVertical, arrowOffsetHorizontal } = token;
    const { arrowDistance = 0, arrowPlacement = {
        left: true,
        right: true,
        top: true,
        bottom: true
    } } = options || {};
    return {
        [componentCls]: {
            // ============================ Basic ============================
            [`${componentCls}-arrow`]: [
                {
                    position: 'absolute',
                    zIndex: 1,
                    // lift it up so the menu wouldn't cask shadow on it
                    display: 'block',
                    ...(0, _roundedArrow.genRoundedArrow)(token, colorBg, boxShadowPopoverArrow),
                    '&:before': {
                        background: colorBg
                    }
                }
            ],
            // ========================== Placement ==========================
            // Here handle the arrow position and rotate stuff
            // >>>>> Top
            ...isInject(!!arrowPlacement.top, {
                [[
                    `&-placement-top > ${componentCls}-arrow`,
                    `&-placement-topLeft > ${componentCls}-arrow`,
                    `&-placement-topRight > ${componentCls}-arrow`
                ].join(',')]: {
                    bottom: arrowDistance,
                    transform: 'translateY(100%) rotate(180deg)'
                },
                [`&-placement-top > ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translateX(-50%) translateY(100%) rotate(180deg)'
                },
                '&-placement-topLeft': {
                    '--arrow-offset-horizontal': arrowOffsetHorizontal,
                    [`> ${componentCls}-arrow`]: {
                        left: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                },
                '&-placement-topRight': {
                    '--arrow-offset-horizontal': `calc(100% - ${(0, _cssinjs.unit)(arrowOffsetHorizontal)})`,
                    [`> ${componentCls}-arrow`]: {
                        right: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                }
            }),
            // >>>>> Bottom
            ...isInject(!!arrowPlacement.bottom, {
                [[
                    `&-placement-bottom > ${componentCls}-arrow`,
                    `&-placement-bottomLeft > ${componentCls}-arrow`,
                    `&-placement-bottomRight > ${componentCls}-arrow`
                ].join(',')]: {
                    top: arrowDistance,
                    transform: `translateY(-100%)`
                },
                [`&-placement-bottom > ${componentCls}-arrow`]: {
                    left: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: `translateX(-50%) translateY(-100%)`
                },
                '&-placement-bottomLeft': {
                    '--arrow-offset-horizontal': arrowOffsetHorizontal,
                    [`> ${componentCls}-arrow`]: {
                        left: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                },
                '&-placement-bottomRight': {
                    '--arrow-offset-horizontal': `calc(100% - ${(0, _cssinjs.unit)(arrowOffsetHorizontal)})`,
                    [`> ${componentCls}-arrow`]: {
                        right: {
                            _skip_check_: true,
                            value: arrowOffsetHorizontal
                        }
                    }
                }
            }),
            // >>>>> Left
            ...isInject(!!arrowPlacement.left, {
                [[
                    `&-placement-left > ${componentCls}-arrow`,
                    `&-placement-leftTop > ${componentCls}-arrow`,
                    `&-placement-leftBottom > ${componentCls}-arrow`
                ].join(',')]: {
                    right: {
                        _skip_check_: true,
                        value: arrowDistance
                    },
                    transform: 'translateX(100%) rotate(90deg)'
                },
                [`&-placement-left > ${componentCls}-arrow`]: {
                    top: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translateY(-50%) translateX(100%) rotate(90deg)'
                },
                [`&-placement-leftTop > ${componentCls}-arrow`]: {
                    top: arrowOffsetVertical
                },
                [`&-placement-leftBottom > ${componentCls}-arrow`]: {
                    bottom: arrowOffsetVertical
                }
            }),
            // >>>>> Right
            ...isInject(!!arrowPlacement.right, {
                [[
                    `&-placement-right > ${componentCls}-arrow`,
                    `&-placement-rightTop > ${componentCls}-arrow`,
                    `&-placement-rightBottom > ${componentCls}-arrow`
                ].join(',')]: {
                    left: {
                        _skip_check_: true,
                        value: arrowDistance
                    },
                    transform: 'translateX(-100%) rotate(-90deg)'
                },
                [`&-placement-right > ${componentCls}-arrow`]: {
                    top: {
                        _skip_check_: true,
                        value: '50%'
                    },
                    transform: 'translateY(-50%) translateX(-100%) rotate(-90deg)'
                },
                [`&-placement-rightTop > ${componentCls}-arrow`]: {
                    top: arrowOffsetVertical
                },
                [`&-placement-rightBottom > ${componentCls}-arrow`]: {
                    bottom: arrowOffsetVertical
                }
            })
        }
    };
}

},{"@ant-design/cssinjs":"2VNL8","./roundedArrow":"dmj3M","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dmj3M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getArrowToken", ()=>getArrowToken);
parcelHelpers.export(exports, "genRoundedArrow", ()=>genRoundedArrow);
var _cssinjs = require("@ant-design/cssinjs");
function getArrowToken(token) {
    const { sizePopupArrow, borderRadiusXS, borderRadiusOuter } = token;
    const unitWidth = sizePopupArrow / 2;
    const ax = 0;
    const ay = unitWidth;
    const bx = borderRadiusOuter * 1 / Math.sqrt(2);
    const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
    const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
    const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
    const dx = 2 * unitWidth - cx;
    const dy = cy;
    const ex = 2 * unitWidth - bx;
    const ey = by;
    const fx = 2 * unitWidth - ax;
    const fy = ay;
    const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
    const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
    const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
    const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
    return {
        arrowShadowWidth: shadowWidth,
        arrowPath,
        arrowPolygon
    };
}
const genRoundedArrow = (token, bgColor, boxShadow)=>{
    const { sizePopupArrow, arrowPolygon, arrowPath, arrowShadowWidth, borderRadiusXS, calc } = token;
    return {
        pointerEvents: 'none',
        width: sizePopupArrow,
        height: sizePopupArrow,
        overflow: 'hidden',
        '&::before': {
            position: 'absolute',
            bottom: 0,
            insetInlineStart: 0,
            width: sizePopupArrow,
            height: calc(sizePopupArrow).div(2).equal(),
            background: bgColor,
            clipPath: {
                _multi_value_: true,
                value: [
                    arrowPolygon,
                    arrowPath
                ]
            },
            content: '""'
        },
        '&::after': {
            content: '""',
            position: 'absolute',
            width: arrowShadowWidth,
            height: arrowShadowWidth,
            bottom: 0,
            insetInline: 0,
            margin: 'auto',
            borderRadius: {
                _skip_check_: true,
                value: `0 0 ${(0, _cssinjs.unit)(borderRadiusXS)} 0`
            },
            transform: 'translateY(50%) rotate(-135deg)',
            boxShadow,
            zIndex: 0,
            background: 'transparent'
        }
    };
};

},{"@ant-design/cssinjs":"2VNL8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"78pFx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isFragment", ()=>isFragment);
parcelHelpers.export(exports, "replaceElement", ()=>replaceElement);
parcelHelpers.export(exports, "cloneElement", ()=>cloneElement);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function isFragment(child) {
    return child && /*#__PURE__*/ (0, _reactDefault.default).isValidElement(child) && child.type === (0, _reactDefault.default).Fragment;
}
const replaceElement = (element, replacement, props)=>{
    if (!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(element)) return replacement;
    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(element, typeof props === 'function' ? props(element.props || {}) : props);
};
function cloneElement(element, props) {
    return replaceElement(element, element, props);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gcu2s":[function(require,module,exports,__globalThis) {
/**
 * This hook is only for cssVar to add root className for components.
 * If root ClassName is needed, this hook could be refactored with `-root`
 * @param prefixCls
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const useCSSVarCls = (prefixCls)=>`${prefixCls}-css-var`;
exports.default = useCSSVarCls;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jKxW0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const useMergedArrow = (providedArrow, providedContextArrow)=>{
    const toConfig = (arrow)=>typeof arrow === 'boolean' ? {
            show: arrow
        } : arrow || {};
    return (0, _reactDefault.default).useMemo(()=>{
        const arrowConfig = toConfig(providedArrow);
        const contextArrowConfig = toConfig(providedContextArrow);
        return {
            ...contextArrowConfig,
            ...arrowConfig,
            show: arrowConfig.show ?? contextArrowConfig.show ?? true
        };
    }, [
        providedArrow,
        providedContextArrow
    ]);
};
exports.default = useMergedArrow;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l827w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _tooltip = require("@rc-component/tooltip");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _configProvider = require("../config-provider");
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _util = require("./util");
"use client";
/** @private Internal Component. Do not use in your production. */ const PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className, placement = 'top', title, color, overlayInnerStyle, classNames, styles } = props;
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('tooltip', customizePrefixCls);
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
    // Color
    const colorInfo = (0, _util.parseColor)(prefixCls, color);
    const arrowContentStyle = colorInfo.arrowStyle;
    const innerStyles = _react.useMemo(()=>{
        const mergedStyle = {
            ...overlayInnerStyle,
            ...colorInfo.overlayStyle
        };
        return {
            container: mergedStyle
        };
    }, [
        overlayInnerStyle,
        colorInfo.overlayStyle
    ]);
    const mergedProps = {
        ...props,
        placement
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        classNames
    ], [
        innerStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassName = (0, _clsx.clsx)(rootCls, hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
    return /*#__PURE__*/ _react.createElement("div", {
        className: rootClassName,
        style: arrowContentStyle
    }, /*#__PURE__*/ _react.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ _react.createElement((0, _tooltip.Popup), {
        ...props,
        className: hashId,
        prefixCls: prefixCls,
        classNames: mergedClassNames,
        styles: mergedStyles
    }, title));
};
exports.default = PurePanel;

},{"react":"bmhQu","@rc-component/tooltip":"9UTy2","clsx":"431Ou","../_util/hooks":"kdnMA","../config-provider":"dVeAX","../config-provider/hooks/useCSSVarCls":"gcu2s","./style":"6JllX","./util":"4stfi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6JllX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../style");
var _motion = require("../../style/motion");
var _placementArrow = require("../../style/placementArrow");
var _placementArrowDefault = parcelHelpers.interopDefault(_placementArrow);
var _roundedArrow = require("../../style/roundedArrow");
var _internal = require("../../theme/internal");
const genTooltipStyle = (token)=>{
    const { calc, componentCls, // ant-tooltip
    tooltipMaxWidth, tooltipColor, tooltipBg, tooltipBorderRadius, zIndexPopup, controlHeight, boxShadowSecondary, paddingSM, paddingXS, arrowOffsetHorizontal, sizePopupArrow } = token;
    // arrowOffsetHorizontal + arrowWidth + borderRadius
    const edgeAlignMinWidth = calc(tooltipBorderRadius).add(sizePopupArrow).add(arrowOffsetHorizontal).equal();
    // borderRadius * 2 + arrowWidth
    const centerAlignMinWidth = calc(tooltipBorderRadius).mul(2).add(sizePopupArrow).equal();
    const sharedBodyStyle = {
        minWidth: centerAlignMinWidth,
        minHeight: controlHeight,
        padding: `${(0, _cssinjs.unit)(token.calc(paddingSM).div(2).equal())} ${(0, _cssinjs.unit)(paddingXS)}`,
        color: `var(--ant-tooltip-color, ${tooltipColor})`,
        textAlign: 'start',
        textDecoration: 'none',
        wordWrap: 'break-word',
        backgroundColor: tooltipBg,
        borderRadius: tooltipBorderRadius,
        boxShadow: boxShadowSecondary,
        boxSizing: 'border-box'
    };
    const sharedTransformOrigin = {
        // When use `autoArrow`, origin will follow the arrow position
        '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
        transformOrigin: [
            `var(--valid-offset-x, 50%)`,
            `var(--arrow-y, 50%)`
        ].join(' ')
    };
    return [
        {
            [componentCls]: {
                ...(0, _style.resetComponent)(token),
                position: 'absolute',
                zIndex: zIndexPopup,
                display: 'block',
                width: 'max-content',
                maxWidth: tooltipMaxWidth,
                visibility: 'visible',
                ...sharedTransformOrigin,
                '&-hidden': {
                    display: 'none'
                },
                '--antd-arrow-background-color': tooltipBg,
                // Wrapper for the tooltip content
                [`${componentCls}-container`]: [
                    sharedBodyStyle,
                    (0, _motion.initFadeMotion)(token, true)
                ],
                [`&:has(~ ${componentCls}-unique-container)`]: {
                    [`${componentCls}-container`]: {
                        border: 'none',
                        background: 'transparent',
                        boxShadow: 'none'
                    }
                },
                // Align placement should have another min width
                [[
                    `&-placement-topLeft`,
                    `&-placement-topRight`,
                    `&-placement-bottomLeft`,
                    `&-placement-bottomRight`
                ].join(',')]: {
                    minWidth: edgeAlignMinWidth
                },
                // Limit left and right placement radius
                [[
                    `&-placement-left`,
                    `&-placement-leftTop`,
                    `&-placement-leftBottom`,
                    `&-placement-right`,
                    `&-placement-rightTop`,
                    `&-placement-rightBottom`
                ].join(',')]: {
                    [`${componentCls}-inner`]: {
                        borderRadius: token.min(tooltipBorderRadius, (0, _placementArrow.MAX_VERTICAL_CONTENT_RADIUS))
                    }
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                },
                // generator for preset color
                ...(0, _internal.genPresetColor)(token, (colorKey, { darkColor })=>({
                        [`&${componentCls}-${colorKey}`]: {
                            [`${componentCls}-container`]: {
                                backgroundColor: darkColor
                            },
                            [`${componentCls}-arrow`]: {
                                '--antd-arrow-background-color': darkColor
                            }
                        }
                    })),
                // RTL
                '&-rtl': {
                    direction: 'rtl'
                }
            }
        },
        // Arrow Style
        (0, _placementArrowDefault.default)(token, 'var(--antd-arrow-background-color)'),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow
            }
        },
        // Unique Body
        {
            [`${componentCls}-unique-container`]: {
                ...sharedBodyStyle,
                ...sharedTransformOrigin,
                position: 'absolute',
                zIndex: calc(zIndexPopup).sub(1).equal(),
                '&-hidden': {
                    display: 'none'
                },
                '&-visible': {
                    transition: `all ${token.motionDurationSlow}`
                }
            }
        }
    ];
};
const prepareComponentToken = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 70,
        ...(0, _placementArrow.getArrowOffsetToken)({
            contentRadius: token.borderRadius,
            limitVerticalRadius: true
        }),
        ...(0, _roundedArrow.getArrowToken)((0, _internal.mergeToken)(token, {
            borderRadiusOuter: Math.min(token.borderRadiusOuter, 4)
        }))
    });
exports.default = (prefixCls, rootCls, injectStyle = true)=>{
    const useStyle = (0, _internal.genStyleHooks)('Tooltip', (token)=>{
        const { borderRadius, colorTextLightSolid, colorBgSpotlight } = token;
        const TooltipToken = (0, _internal.mergeToken)(token, {
            // default variables
            tooltipMaxWidth: 250,
            tooltipColor: colorTextLightSolid,
            tooltipBorderRadius: borderRadius,
            tooltipBg: colorBgSpotlight
        });
        return [
            genTooltipStyle(TooltipToken),
            (0, _motion.initZoomMotion)(token, 'zoom-big-fast')
        ];
    }, prepareComponentToken, {
        resetStyle: false,
        // Popover use Tooltip as internal component. We do not need to handle this.
        injectStyle
    });
    return useStyle(prefixCls, rootCls);
};

},{"@ant-design/cssinjs":"2VNL8","../../style":"4Ezp0","../../style/motion":[["initFadeMotion","jD2T8"],["initZoomMotion","dqyUY"]],"../../style/placementArrow":"73A7X","../../style/roundedArrow":"dmj3M","../../theme/internal":[["genPresetColor","dQNfw","default"],["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jD2T8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fadeIn", ()=>fadeIn);
parcelHelpers.export(exports, "fadeOut", ()=>fadeOut);
parcelHelpers.export(exports, "initFadeMotion", ()=>initFadeMotion);
var _cssinjs = require("@ant-design/cssinjs");
var _motion = require("./motion");
const fadeIn = new (0, _cssinjs.Keyframes)('antFadeIn', {
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
const fadeOut = new (0, _cssinjs.Keyframes)('antFadeOut', {
    '0%': {
        opacity: 1
    },
    '100%': {
        opacity: 0
    }
});
const initFadeMotion = (token, sameLevel = false)=>{
    const { antCls } = token;
    const motionCls = `${antCls}-fade`;
    const sameLevelPrefix = sameLevel ? '&' : '';
    return [
        (0, _motion.initMotion)(motionCls, fadeIn, fadeOut, token.motionDurationMid, sameLevel),
        {
            [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: 'linear'
            },
            [`${sameLevelPrefix}${motionCls}-leave`]: {
                animationTimingFunction: 'linear'
            }
        }
    ];
};

},{"@ant-design/cssinjs":"2VNL8","./motion":"eBupP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eBupP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initMotion", ()=>initMotion);
const initMotionCommon = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
// FIXME: origin less code seems same as initMotionCommon. Maybe we can safe remove
const initMotionCommonLeave = (duration)=>({
        animationDuration: duration,
        animationFillMode: 'both'
    });
const initMotion = (motionCls, inKeyframes, outKeyframes, duration, sameLevel = false)=>{
    const sameLevelPrefix = sameLevel ? '&' : '';
    return {
        [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: {
            ...initMotionCommon(duration),
            animationPlayState: 'paused'
        },
        [`${sameLevelPrefix}${motionCls}-leave`]: {
            ...initMotionCommonLeave(duration),
            animationPlayState: 'paused'
        },
        [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
            animationName: inKeyframes,
            animationPlayState: 'running'
        },
        [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
            animationName: outKeyframes,
            animationPlayState: 'running',
            pointerEvents: 'none'
        }
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dqyUY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "zoomIn", ()=>zoomIn);
parcelHelpers.export(exports, "zoomOut", ()=>zoomOut);
parcelHelpers.export(exports, "zoomBigIn", ()=>zoomBigIn);
parcelHelpers.export(exports, "zoomBigOut", ()=>zoomBigOut);
parcelHelpers.export(exports, "zoomUpIn", ()=>zoomUpIn);
parcelHelpers.export(exports, "zoomUpOut", ()=>zoomUpOut);
parcelHelpers.export(exports, "zoomLeftIn", ()=>zoomLeftIn);
parcelHelpers.export(exports, "zoomLeftOut", ()=>zoomLeftOut);
parcelHelpers.export(exports, "zoomRightIn", ()=>zoomRightIn);
parcelHelpers.export(exports, "zoomRightOut", ()=>zoomRightOut);
parcelHelpers.export(exports, "zoomDownIn", ()=>zoomDownIn);
parcelHelpers.export(exports, "zoomDownOut", ()=>zoomDownOut);
parcelHelpers.export(exports, "initZoomMotion", ()=>initZoomMotion);
var _cssinjs = require("@ant-design/cssinjs");
var _motion = require("./motion");
const zoomIn = new (0, _cssinjs.Keyframes)('antZoomIn', {
    '0%': {
        transform: 'scale(0.2)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const zoomOut = new (0, _cssinjs.Keyframes)('antZoomOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.2)',
        opacity: 0
    }
});
const zoomBigIn = new (0, _cssinjs.Keyframes)('antZoomBigIn', {
    '0%': {
        transform: 'scale(0.8)',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        opacity: 1
    }
});
const zoomBigOut = new (0, _cssinjs.Keyframes)('antZoomBigOut', {
    '0%': {
        transform: 'scale(1)'
    },
    '100%': {
        transform: 'scale(0.8)',
        opacity: 0
    }
});
const zoomUpIn = new (0, _cssinjs.Keyframes)('antZoomUpIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    }
});
const zoomUpOut = new (0, _cssinjs.Keyframes)('antZoomUpOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 0%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 0%',
        opacity: 0
    }
});
const zoomLeftIn = new (0, _cssinjs.Keyframes)('antZoomLeftIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    }
});
const zoomLeftOut = new (0, _cssinjs.Keyframes)('antZoomLeftOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '0% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '0% 50%',
        opacity: 0
    }
});
const zoomRightIn = new (0, _cssinjs.Keyframes)('antZoomRightIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    }
});
const zoomRightOut = new (0, _cssinjs.Keyframes)('antZoomRightOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '100% 50%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '100% 50%',
        opacity: 0
    }
});
const zoomDownIn = new (0, _cssinjs.Keyframes)('antZoomDownIn', {
    '0%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    }
});
const zoomDownOut = new (0, _cssinjs.Keyframes)('antZoomDownOut', {
    '0%': {
        transform: 'scale(1)',
        transformOrigin: '50% 100%'
    },
    '100%': {
        transform: 'scale(0.8)',
        transformOrigin: '50% 100%',
        opacity: 0
    }
});
const zoomMotion = {
    zoom: {
        inKeyframes: zoomIn,
        outKeyframes: zoomOut
    },
    'zoom-big': {
        inKeyframes: zoomBigIn,
        outKeyframes: zoomBigOut
    },
    'zoom-big-fast': {
        inKeyframes: zoomBigIn,
        outKeyframes: zoomBigOut
    },
    'zoom-left': {
        inKeyframes: zoomLeftIn,
        outKeyframes: zoomLeftOut
    },
    'zoom-right': {
        inKeyframes: zoomRightIn,
        outKeyframes: zoomRightOut
    },
    'zoom-up': {
        inKeyframes: zoomUpIn,
        outKeyframes: zoomUpOut
    },
    'zoom-down': {
        inKeyframes: zoomDownIn,
        outKeyframes: zoomDownOut
    }
};
const initZoomMotion = (token, motionName)=>{
    const { antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes, outKeyframes } = zoomMotion[motionName];
    return [
        (0, _motion.initMotion)(motionCls, inKeyframes, outKeyframes, motionName === 'zoom-big-fast' ? token.motionDurationFast : token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                transform: 'scale(0)',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc,
                '&-prepare': {
                    transform: 'none'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};

},{"@ant-design/cssinjs":"2VNL8","./motion":"eBupP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dQNfw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>genPresetColor);
var _interface = require("../interface");
function genPresetColor(token, genCss) {
    return (0, _interface.PresetColors).reduce((prev, colorKey)=>{
        const lightColor = token[`${colorKey}1`];
        const lightBorderColor = token[`${colorKey}3`];
        const darkColor = token[`${colorKey}6`];
        const textColor = token[`${colorKey}7`];
        return {
            ...prev,
            ...genCss(colorKey, {
                lightColor,
                lightBorderColor,
                darkColor,
                textColor
            })
        };
    }, {});
}

},{"../interface":"aRwwT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aRwwT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PresetColors", ()=>PresetColors);
const PresetColors = [
    'blue',
    'purple',
    'cyan',
    'green',
    'magenta',
    'pink',
    'red',
    'orange',
    'yellow',
    'volcano',
    'geekblue',
    'lime',
    'gold'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4stfi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseColor", ()=>parseColor);
var _clsx = require("clsx");
var _colors = require("../_util/colors");
var _util = require("../color-picker/util");
function parseColor(prefixCls, color) {
    const isInternalColor = (0, _colors.isPresetColor)(color);
    const className = (0, _clsx.clsx)({
        [`${prefixCls}-${color}`]: color && isInternalColor
    });
    const overlayStyle = {};
    const arrowStyle = {};
    const rgb = (0, _util.generateColor)(color).toRgb();
    const luminance = (0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b) / 255;
    const textColor = luminance < 0.5 ? '#FFF' : '#000';
    if (color && !isInternalColor) {
        overlayStyle.background = color;
        overlayStyle['--ant-tooltip-color'] = textColor;
        // @ts-ignore
        arrowStyle['--antd-arrow-background-color'] = color;
    }
    return {
        className,
        overlayStyle,
        arrowStyle
    };
}

},{"clsx":"431Ou","../_util/colors":"3eP28","../color-picker/util":"4mJWZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3eP28":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PresetStatusColors", ()=>PresetStatusColors);
/**
 * determine if the color keyword belongs to the `Ant Design` {@link PresetColors}.
 * @param color color to be judged
 * @param includeInverse whether to include reversed colors
 */ parcelHelpers.export(exports, "isPresetColor", ()=>isPresetColor);
parcelHelpers.export(exports, "isPresetStatusColor", ()=>isPresetStatusColor);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _interface = require("../theme/interface");
const inverseColors = (0, _interface.PresetColors).map((color)=>`${color}-inverse`);
const PresetStatusColors = [
    'success',
    'processing',
    'error',
    'default',
    'warning'
];
function isPresetColor(color, includeInverse = true) {
    if (includeInverse) return [].concat((0, _toConsumableArrayDefault.default)(inverseColors), (0, _toConsumableArrayDefault.default)((0, _interface.PresetColors))).includes(color);
    return (0, _interface.PresetColors).includes(color);
}
function isPresetStatusColor(color) {
    return PresetStatusColors.includes(color);
}

},{"@babel/runtime/helpers/esm/toConsumableArray":"inIie","../theme/interface":"aRwwT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4mJWZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateColor", ()=>generateColor);
parcelHelpers.export(exports, "getRoundNumber", ()=>getRoundNumber);
parcelHelpers.export(exports, "getColorAlpha", ()=>getColorAlpha);
parcelHelpers.export(exports, "genAlphaColor", ()=>genAlphaColor);
parcelHelpers.export(exports, "getGradientPercentColor", ()=>getGradientPercentColor);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _colorPicker = require("@rc-component/color-picker");
var _color = require("./color");
const generateColor = (color)=>{
    if (color instanceof (0, _color.AggregationColor)) return color;
    return new (0, _color.AggregationColor)(color);
};
const getRoundNumber = (value)=>Math.round(Number(value || 0));
const getColorAlpha = (color)=>getRoundNumber(color.toHsb().a * 100);
const genAlphaColor = (color, alpha)=>{
    const rgba = color.toRgb();
    // Color from hsb input may get `rgb` is (0/0/0) when `hsb.b` is 0
    // So if rgb is empty, we should get from hsb
    if (!rgba.r && !rgba.g && !rgba.b) {
        const hsba = color.toHsb();
        hsba.a = alpha || 1;
        return generateColor(hsba);
    }
    rgba.a = alpha || 1;
    return generateColor(rgba);
};
const getGradientPercentColor = (colors, percent)=>{
    const filledColors = [
        {
            percent: 0,
            color: colors[0].color
        }
    ].concat((0, _toConsumableArrayDefault.default)(colors), [
        {
            percent: 100,
            color: colors[colors.length - 1].color
        }
    ]);
    for(let i = 0; i < filledColors.length - 1; i += 1){
        const startPtg = filledColors[i].percent;
        const endPtg = filledColors[i + 1].percent;
        const startColor = filledColors[i].color;
        const endColor = filledColors[i + 1].color;
        if (startPtg <= percent && percent <= endPtg) {
            const dist = endPtg - startPtg;
            if (dist === 0) return startColor;
            const ratio = (percent - startPtg) / dist * 100;
            const startRcColor = new (0, _colorPicker.Color)(startColor);
            const endRcColor = new (0, _colorPicker.Color)(endColor);
            return startRcColor.mix(endRcColor, ratio).toRgbString();
        }
    }
    // This will never reach
    /* istanbul ignore next */ return '';
};

},{"@babel/runtime/helpers/esm/toConsumableArray":"inIie","@rc-component/color-picker":"kM4Bc","./color":"1LCBg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kM4Bc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Color", ()=>(0, _color.Color));
parcelHelpers.export(exports, "ColorBlock", ()=>(0, _colorBlockDefault.default));
var _colorPicker = require("./ColorPicker");
var _colorPickerDefault = parcelHelpers.interopDefault(_colorPicker);
var _color = require("./color");
var _colorBlock = require("./components/ColorBlock");
var _colorBlockDefault = parcelHelpers.interopDefault(_colorBlock);
var _interface = require("./interface");
parcelHelpers.exportAll(_interface, exports);
exports.default = (0, _colorPickerDefault.default);

},{"./ColorPicker":"35FVA","./color":"CqoD7","./components/ColorBlock":"Zfvn5","./interface":"badas","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"35FVA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _util = require("./util");
var _clsx = require("clsx");
var _color = require("./color");
var _colorBlock = require("./components/ColorBlock");
var _colorBlockDefault = parcelHelpers.interopDefault(_colorBlock);
var _picker = require("./components/Picker");
var _pickerDefault = parcelHelpers.interopDefault(_picker);
var _useColorState = require("./hooks/useColorState");
var _useColorStateDefault = parcelHelpers.interopDefault(_useColorState);
var _useComponent = require("./hooks/useComponent");
var _useComponentDefault = parcelHelpers.interopDefault(_useComponent);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const HUE_COLORS = [
    {
        color: 'rgb(255, 0, 0)',
        percent: 0
    },
    {
        color: 'rgb(255, 255, 0)',
        percent: 17
    },
    {
        color: 'rgb(0, 255, 0)',
        percent: 33
    },
    {
        color: 'rgb(0, 255, 255)',
        percent: 50
    },
    {
        color: 'rgb(0, 0, 255)',
        percent: 67
    },
    {
        color: 'rgb(255, 0, 255)',
        percent: 83
    },
    {
        color: 'rgb(255, 0, 0)',
        percent: 100
    }
];
const ColorPicker = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { value, defaultValue, prefixCls = (0, _util.ColorPickerPrefixCls), onChange, onChangeComplete, className, style, panelRender, disabledAlpha = false, disabled = false, components } = props;
    // ========================== Components ==========================
    const [Slider] = (0, _useComponentDefault.default)(components);
    // ============================ Color =============================
    const [colorValue, setColorValue] = (0, _useColorStateDefault.default)(defaultValue || (0, _util.defaultColor), value);
    const alphaColor = (0, _react.useMemo)(()=>colorValue.setA(1).toRgbString(), [
        colorValue
    ]);
    // ============================ Events ============================
    const handleChange = (data, type)=>{
        if (!value) setColorValue(data);
        onChange?.(data, type);
    };
    // Convert
    const getHueColor = (hue)=>new (0, _color.Color)(colorValue.setHue(hue));
    const getAlphaColor = (alpha)=>new (0, _color.Color)(colorValue.setA(alpha / 100));
    // Slider change
    const onHueChange = (hue)=>{
        handleChange(getHueColor(hue), {
            type: 'hue',
            value: hue
        });
    };
    const onAlphaChange = (alpha)=>{
        handleChange(getAlphaColor(alpha), {
            type: 'alpha',
            value: alpha
        });
    };
    // Complete
    const onHueChangeComplete = (hue)=>{
        if (onChangeComplete) onChangeComplete(getHueColor(hue));
    };
    const onAlphaChangeComplete = (alpha)=>{
        if (onChangeComplete) onChangeComplete(getAlphaColor(alpha));
    };
    // ============================ Render ============================
    const mergeCls = (0, _clsx.clsx)(`${prefixCls}-panel`, className, {
        [`${prefixCls}-panel-disabled`]: disabled
    });
    const sharedSliderProps = {
        prefixCls,
        disabled,
        color: colorValue
    };
    const defaultPanel = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _pickerDefault.default), _extends({
        onChange: handleChange
    }, sharedSliderProps, {
        onChangeComplete: onChangeComplete
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${prefixCls}-slider-container`
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-slider-group`, {
            [`${prefixCls}-slider-group-disabled-alpha`]: disabledAlpha
        })
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement(Slider, _extends({}, sharedSliderProps, {
        type: "hue",
        colors: HUE_COLORS,
        min: 0,
        max: 359,
        value: colorValue.getHue(),
        onChange: onHueChange,
        onChangeComplete: onHueChangeComplete
    })), !disabledAlpha && /*#__PURE__*/ (0, _reactDefault.default).createElement(Slider, _extends({}, sharedSliderProps, {
        type: "alpha",
        colors: [
            {
                percent: 0,
                color: 'rgba(255, 0, 4, 0)'
            },
            {
                percent: 100,
                color: alphaColor
            }
        ],
        min: 0,
        max: 100,
        value: colorValue.a * 100,
        onChange: onAlphaChange,
        onChangeComplete: onAlphaChangeComplete
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _colorBlockDefault.default), {
        color: colorValue.toRgbString(),
        prefixCls: prefixCls
    })));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: mergeCls,
        style: style,
        ref: ref
    }, typeof panelRender === 'function' ? panelRender(defaultPanel) : defaultPanel);
});
exports.default = ColorPicker;

},{"react":"bmhQu","./util":"kowjh","clsx":"431Ou","./color":"CqoD7","./components/ColorBlock":"Zfvn5","./components/Picker":"dAen4","./hooks/useColorState":"9mXUQ","./hooks/useComponent":"2qd0h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kowjh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ColorPickerPrefixCls", ()=>ColorPickerPrefixCls);
parcelHelpers.export(exports, "generateColor", ()=>generateColor);
parcelHelpers.export(exports, "defaultColor", ()=>defaultColor);
parcelHelpers.export(exports, "calculateColor", ()=>calculateColor);
parcelHelpers.export(exports, "calcOffset", ()=>calcOffset);
var _color = require("./color");
const ColorPickerPrefixCls = 'rc-color-picker';
const generateColor = (color)=>{
    if (color instanceof (0, _color.Color)) return color;
    return new (0, _color.Color)(color);
};
const defaultColor = generateColor('#1677ff');
const calculateColor = (props)=>{
    const { offset, targetRef, containerRef, color, type } = props;
    const { width, height } = containerRef.current.getBoundingClientRect();
    const { width: targetWidth, height: targetHeight } = targetRef.current.getBoundingClientRect();
    const centerOffsetX = targetWidth / 2;
    const centerOffsetY = targetHeight / 2;
    const saturation = (offset.x + centerOffsetX) / width;
    const bright = 1 - (offset.y + centerOffsetY) / height;
    const hsb = color.toHsb();
    const alphaOffset = saturation;
    const hueOffset = (offset.x + centerOffsetX) / width * 360;
    if (type) switch(type){
        case 'hue':
            return generateColor({
                ...hsb,
                h: hueOffset <= 0 ? 0 : hueOffset
            });
        case 'alpha':
            return generateColor({
                ...hsb,
                a: alphaOffset <= 0 ? 0 : alphaOffset
            });
    }
    return generateColor({
        h: hsb.h,
        s: saturation <= 0 ? 0 : saturation,
        b: bright >= 1 ? 1 : bright,
        a: hsb.a
    });
};
const calcOffset = (color, type)=>{
    const hsb = color.toHsb();
    switch(type){
        case 'hue':
            return {
                x: hsb.h / 360 * 100,
                y: 50
            };
        case 'alpha':
            return {
                x: color.a * 100,
                y: 50
            };
        // Picker panel
        default:
            return {
                x: hsb.s * 100,
                y: (1 - hsb.b) * 100
            };
    }
};

},{"./color":"CqoD7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"CqoD7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRoundNumber", ()=>getRoundNumber);
parcelHelpers.export(exports, "Color", ()=>Color);
var _fastColor = require("@ant-design/fast-color");
const getRoundNumber = (value)=>Math.round(Number(value || 0));
const convertHsb2Hsv = (color)=>{
    if (color instanceof (0, _fastColor.FastColor)) return color;
    if (color && typeof color === 'object' && 'h' in color && 'b' in color) {
        const { b, ...resets } = color;
        return {
            ...resets,
            v: b
        };
    }
    if (typeof color === 'string' && /hsb/.test(color)) return color.replace(/hsb/, 'hsv');
    return color;
};
class Color extends (0, _fastColor.FastColor) {
    constructor(color){
        super(convertHsb2Hsv(color));
    }
    toHsbString() {
        const hsb = this.toHsb();
        const saturation = getRoundNumber(hsb.s * 100);
        const lightness = getRoundNumber(hsb.b * 100);
        const hue = getRoundNumber(hsb.h);
        const alpha = hsb.a;
        const hsbString = `hsb(${hue}, ${saturation}%, ${lightness}%)`;
        const hsbaString = `hsba(${hue}, ${saturation}%, ${lightness}%, ${alpha.toFixed(alpha === 0 ? 0 : 2)})`;
        return alpha === 1 ? hsbString : hsbaString;
    }
    toHsb() {
        const { v, ...resets } = this.toHsv();
        return {
            ...resets,
            b: v,
            a: this.a
        };
    }
}

},{"@ant-design/fast-color":"50VUA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Zfvn5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ColorBlock = ({ color, prefixCls, className, style, onClick })=>{
    const colorBlockCls = `${prefixCls}-color-block`;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(colorBlockCls, className),
        style: style,
        onClick: onClick
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${colorBlockCls}-inner`,
        style: {
            background: color
        }
    }));
};
exports.default = ColorBlock;

},{"clsx":"431Ou","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dAen4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useColorDrag = require("../hooks/useColorDrag");
var _useColorDragDefault = parcelHelpers.interopDefault(_useColorDrag);
var _util = require("../util");
var _util1 = require("@rc-component/util");
var _handler = require("./Handler");
var _handlerDefault = parcelHelpers.interopDefault(_handler);
var _palette = require("./Palette");
var _paletteDefault = parcelHelpers.interopDefault(_palette);
var _transform = require("./Transform");
var _transformDefault = parcelHelpers.interopDefault(_transform);
const Picker = ({ color, onChange, prefixCls, onChangeComplete, disabled })=>{
    const pickerRef = (0, _react.useRef)();
    const transformRef = (0, _react.useRef)();
    const colorRef = (0, _react.useRef)(color);
    const onDragChange = (0, _util1.useEvent)((offsetValue)=>{
        const calcColor = (0, _util.calculateColor)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: pickerRef,
            color
        });
        colorRef.current = calcColor;
        onChange(calcColor);
    });
    const [offset, dragStartHandle] = (0, _useColorDragDefault.default)({
        color,
        containerRef: pickerRef,
        targetRef: transformRef,
        calculate: ()=>(0, _util.calcOffset)(color),
        onDragChange,
        onDragChangeComplete: ()=>onChangeComplete?.(colorRef.current),
        disabledDrag: disabled
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: pickerRef,
        className: `${prefixCls}-select`,
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paletteDefault.default), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transformDefault.default), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _handlerDefault.default), {
        color: color.toRgbString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${prefixCls}-saturation`,
        style: {
            backgroundColor: `hsl(${color.toHsb().h},100%, 50%)`,
            backgroundImage: 'linear-gradient(0deg, #000, transparent),linear-gradient(90deg, #fff, hsla(0, 0%, 100%, 0))'
        }
    })));
};
exports.default = Picker;

},{"react":"bmhQu","../hooks/useColorDrag":"b8frM","../util":"kowjh","@rc-component/util":"6ZBDN","./Handler":"4iB2q","./Palette":"llFa9","./Transform":"1XXSR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b8frM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
function getPosition(e) {
    const obj = 'touches' in e ? e.touches[0] : e;
    const scrollXOffset = document.documentElement.scrollLeft || document.body.scrollLeft || window.pageXOffset;
    const scrollYOffset = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset;
    return {
        pageX: obj.pageX - scrollXOffset,
        pageY: obj.pageY - scrollYOffset
    };
}
function useColorDrag(props) {
    const { targetRef, containerRef, direction, onDragChange, onDragChangeComplete, calculate, color, disabledDrag } = props;
    const [offsetValue, setOffsetValue] = (0, _react.useState)({
        x: 0,
        y: 0
    });
    const mouseMoveRef = (0, _react.useRef)(null);
    const mouseUpRef = (0, _react.useRef)(null);
    // Always get position from `color`
    (0, _react.useEffect)(()=>{
        setOffsetValue(calculate());
    }, [
        color
    ]);
    (0, _react.useEffect)(()=>()=>{
            document.removeEventListener('mousemove', mouseMoveRef.current);
            document.removeEventListener('mouseup', mouseUpRef.current);
            document.removeEventListener('touchmove', mouseMoveRef.current);
            document.removeEventListener('touchend', mouseUpRef.current);
            mouseMoveRef.current = null;
            mouseUpRef.current = null;
        }, []);
    const updateOffset = (e)=>{
        const { pageX, pageY } = getPosition(e);
        const { x: rectX, y: rectY, width, height } = containerRef.current.getBoundingClientRect();
        const { width: targetWidth, height: targetHeight } = targetRef.current.getBoundingClientRect();
        const centerOffsetX = targetWidth / 2;
        const centerOffsetY = targetHeight / 2;
        const offsetX = Math.max(0, Math.min(pageX - rectX, width)) - centerOffsetX;
        const offsetY = Math.max(0, Math.min(pageY - rectY, height)) - centerOffsetY;
        const calcOffset = {
            x: offsetX,
            y: direction === 'x' ? offsetValue.y : offsetY
        };
        // Exclusion of boundary cases
        if (targetWidth === 0 && targetHeight === 0 || targetWidth !== targetHeight) return false;
        onDragChange?.(calcOffset);
    };
    const onDragMove = (e)=>{
        e.preventDefault();
        updateOffset(e);
    };
    const onDragStop = (e)=>{
        e.preventDefault();
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        document.removeEventListener('touchmove', mouseMoveRef.current);
        document.removeEventListener('touchend', mouseUpRef.current);
        mouseMoveRef.current = null;
        mouseUpRef.current = null;
        onDragChangeComplete?.();
    };
    const onDragStart = (e)=>{
        // https://github.com/ant-design/ant-design/issues/43529
        document.removeEventListener('mousemove', mouseMoveRef.current);
        document.removeEventListener('mouseup', mouseUpRef.current);
        if (disabledDrag) return;
        updateOffset(e);
        document.addEventListener('mousemove', onDragMove);
        document.addEventListener('mouseup', onDragStop);
        document.addEventListener('touchmove', onDragMove);
        document.addEventListener('touchend', onDragStop);
        mouseMoveRef.current = onDragMove;
        mouseUpRef.current = onDragStop;
    };
    return [
        offsetValue,
        onDragStart
    ];
}
exports.default = useColorDrag;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4iB2q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Handler = ({ size = 'default', color, prefixCls })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-handler`, {
            [`${prefixCls}-handler-sm`]: size === 'small'
        }),
        style: {
            backgroundColor: color
        }
    });
};
exports.default = Handler;

},{"clsx":"431Ou","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"llFa9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Palette = ({ children, style, prefixCls })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${prefixCls}-palette`,
        style: {
            position: 'relative',
            ...style
        }
    }, children);
};
exports.default = Palette;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1XXSR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Transform = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { children, x, y } = props;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: ref,
        style: {
            position: 'absolute',
            left: `${x}%`,
            top: `${y}%`,
            zIndex: 1,
            transform: 'translate(-50%, -50%)'
        }
    }, children);
});
exports.default = Transform;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9mXUQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("@rc-component/util");
var _react = require("react");
var _util1 = require("../util");
const useColorState = (defaultValue, value)=>{
    const [mergedValue, setValue] = (0, _util.useControlledState)(defaultValue, value);
    const color = (0, _react.useMemo)(()=>(0, _util1.generateColor)(mergedValue), [
        mergedValue
    ]);
    return [
        color,
        setValue
    ];
};
exports.default = useColorState;

},{"@rc-component/util":"6ZBDN","react":"bmhQu","../util":"kowjh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2qd0h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useComponent);
var _react = require("react");
var _slider = require("../components/Slider");
var _sliderDefault = parcelHelpers.interopDefault(_slider);
function useComponent(components) {
    return _react.useMemo(()=>{
        const { slider } = components || {};
        return [
            slider || (0, _sliderDefault.default)
        ];
    }, [
        components
    ]);
}

},{"react":"bmhQu","../components/Slider":"7v0q7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7v0q7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useColorDrag = require("../hooks/useColorDrag");
var _useColorDragDefault = parcelHelpers.interopDefault(_useColorDrag);
var _palette = require("./Palette");
var _paletteDefault = parcelHelpers.interopDefault(_palette);
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _color = require("../color");
var _util1 = require("../util");
var _gradient = require("./Gradient");
var _gradientDefault = parcelHelpers.interopDefault(_gradient);
var _handler = require("./Handler");
var _handlerDefault = parcelHelpers.interopDefault(_handler);
var _transform = require("./Transform");
var _transformDefault = parcelHelpers.interopDefault(_transform);
const Slider = (props)=>{
    const { prefixCls, colors, disabled, onChange, onChangeComplete, color, type } = props;
    const sliderRef = (0, _react.useRef)(null);
    const transformRef = (0, _react.useRef)(null);
    const colorRef = (0, _react.useRef)(color);
    const getValue = (c)=>{
        return type === 'hue' ? c.getHue() : c.a * 100;
    };
    const onDragChange = (0, _util.useEvent)((offsetValue)=>{
        const calcColor = (0, _util1.calculateColor)({
            offset: offsetValue,
            targetRef: transformRef,
            containerRef: sliderRef,
            color,
            type
        });
        colorRef.current = calcColor;
        onChange(getValue(calcColor));
    });
    const [offset, dragStartHandle] = (0, _useColorDragDefault.default)({
        color,
        targetRef: transformRef,
        containerRef: sliderRef,
        calculate: ()=>(0, _util1.calcOffset)(color, type),
        onDragChange,
        onDragChangeComplete () {
            onChangeComplete(getValue(colorRef.current));
        },
        direction: 'x',
        disabledDrag: disabled
    });
    const handleColor = (0, _reactDefault.default).useMemo(()=>{
        if (type === 'hue') {
            const hsb = color.toHsb();
            hsb.s = 1;
            hsb.b = 1;
            hsb.a = 1;
            const lightColor = new (0, _color.Color)(hsb);
            return lightColor;
        }
        return color;
    }, [
        color,
        type
    ]);
    // ========================= Gradient =========================
    const gradientList = (0, _reactDefault.default).useMemo(()=>colors.map((info)=>`${info.color} ${info.percent}%`), [
        colors
    ]);
    // ========================== Render ==========================
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: sliderRef,
        className: (0, _clsx.clsx)(`${prefixCls}-slider`, `${prefixCls}-slider-${type}`),
        onMouseDown: dragStartHandle,
        onTouchStart: dragStartHandle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _paletteDefault.default), {
        prefixCls: prefixCls
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _transformDefault.default), {
        x: offset.x,
        y: offset.y,
        ref: transformRef
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _handlerDefault.default), {
        size: "small",
        color: handleColor.toHexString(),
        prefixCls: prefixCls
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _gradientDefault.default), {
        colors: gradientList,
        type: type,
        prefixCls: prefixCls
    })));
};
exports.default = Slider;

},{"react":"bmhQu","../hooks/useColorDrag":"b8frM","./Palette":"llFa9","@rc-component/util":"6ZBDN","clsx":"431Ou","../color":"CqoD7","../util":"kowjh","./Gradient":"cxd9O","./Handler":"4iB2q","./Transform":"1XXSR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cxd9O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _color = require("../color");
var _util = require("../util");
const Gradient = ({ colors, children, direction = 'to right', type, prefixCls })=>{
    const gradientColors = (0, _react.useMemo)(()=>colors.map((color, idx)=>{
            let result = (0, _util.generateColor)(color);
            if (type === 'alpha' && idx === colors.length - 1) result = new (0, _color.Color)(result.setA(1));
            return result.toRgbString();
        }).join(','), [
        colors,
        type
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${prefixCls}-gradient`,
        style: {
            position: 'absolute',
            inset: 0,
            background: `linear-gradient(${direction}, ${gradientColors})`
        }
    }, children);
};
exports.default = Gradient;

},{"react":"bmhQu","../color":"CqoD7","../util":"kowjh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"badas":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1LCBg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toHexFormat", ()=>toHexFormat);
parcelHelpers.export(exports, "getHex", ()=>getHex);
parcelHelpers.export(exports, "AggregationColor", ()=>AggregationColor);
var _classCallCheck = require("@babel/runtime/helpers/esm/classCallCheck");
var _classCallCheckDefault = parcelHelpers.interopDefault(_classCallCheck);
var _createClass = require("@babel/runtime/helpers/esm/createClass");
var _createClassDefault = parcelHelpers.interopDefault(_createClass);
var _colorPicker = require("@rc-component/color-picker");
const toHexFormat = (value, alpha)=>value?.replace(/[^\w/]/g, '').slice(0, alpha ? 8 : 6) || '';
const getHex = (value, alpha)=>value ? toHexFormat(value, alpha) : '';
let AggregationColor = /*#__PURE__*/ function() {
    function AggregationColor(color) {
        (0, _classCallCheckDefault.default)(this, AggregationColor);
        this.cleared = false;
        // Clone from another AggregationColor
        if (color instanceof AggregationColor) {
            this.metaColor = color.metaColor.clone();
            this.colors = color.colors?.map((info)=>({
                    color: new AggregationColor(info.color),
                    percent: info.percent
                }));
            this.cleared = color.cleared;
            return;
        }
        const isArray = Array.isArray(color);
        if (isArray && color.length) {
            this.colors = color.map(({ color: c, percent })=>({
                    color: new AggregationColor(c),
                    percent
                }));
            this.metaColor = new (0, _colorPicker.Color)(this.colors[0].color.metaColor);
        } else this.metaColor = new (0, _colorPicker.Color)(isArray ? '' : color);
        if (!color || isArray && !this.colors) {
            this.metaColor = this.metaColor.setA(0);
            this.cleared = true;
        }
    }
    return (0, _createClassDefault.default)(AggregationColor, [
        {
            key: "toHsb",
            value: function toHsb() {
                return this.metaColor.toHsb();
            }
        },
        {
            key: "toHsbString",
            value: function toHsbString() {
                return this.metaColor.toHsbString();
            }
        },
        {
            key: "toHex",
            value: function toHex() {
                return getHex(this.toHexString(), this.metaColor.a < 1);
            }
        },
        {
            key: "toHexString",
            value: function toHexString() {
                return this.metaColor.toHexString();
            }
        },
        {
            key: "toRgb",
            value: function toRgb() {
                return this.metaColor.toRgb();
            }
        },
        {
            key: "toRgbString",
            value: function toRgbString() {
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "isGradient",
            value: function isGradient() {
                return !!this.colors && !this.cleared;
            }
        },
        {
            key: "getColors",
            value: function getColors() {
                return this.colors || [
                    {
                        color: this,
                        percent: 0
                    }
                ];
            }
        },
        {
            key: "toCssString",
            value: function toCssString() {
                const { colors } = this;
                // CSS line-gradient
                if (colors) {
                    const colorsStr = colors.map((c)=>`${c.color.toRgbString()} ${c.percent}%`).join(', ');
                    return `linear-gradient(90deg, ${colorsStr})`;
                }
                return this.metaColor.toRgbString();
            }
        },
        {
            key: "equals",
            value: function equals(color) {
                if (!color || this.isGradient() !== color.isGradient()) return false;
                if (!this.isGradient()) return this.toHexString() === color.toHexString();
                return this.colors.length === color.colors.length && this.colors.every((c, i)=>{
                    const target = color.colors[i];
                    return c.percent === target.percent && c.color.equals(target.color);
                });
            }
        }
    ]);
}();

},{"@babel/runtime/helpers/esm/classCallCheck":"1eYFn","@babel/runtime/helpers/esm/createClass":"89Fc8","@rc-component/color-picker":"kM4Bc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2r0ST":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _cssinjs = require("@ant-design/cssinjs");
var _fastColor = require("@ant-design/fast-color");
var _style = require("../../style");
var _internal = require("../../theme/internal");
// =============================== Base ===============================
const genBaseStyle = (token)=>{
    const { componentCls, antCls, controlSize, dotSize, marginFull, marginPart, colorFillContentHover, handleColorDisabled, calc, handleSize, handleSizeHover, handleActiveColor, handleActiveOutlineColor, handleLineWidth, handleLineWidthHover, motionDurationMid } = token;
    return {
        [componentCls]: {
            ...(0, _style.resetComponent)(token),
            position: 'relative',
            height: controlSize,
            margin: `${(0, _cssinjs.unit)(marginPart)} ${(0, _cssinjs.unit)(marginFull)}`,
            padding: 0,
            cursor: 'pointer',
            touchAction: 'none',
            '&-vertical': {
                margin: `${(0, _cssinjs.unit)(marginFull)} ${(0, _cssinjs.unit)(marginPart)}`
            },
            [`${componentCls}-rail`]: {
                position: 'absolute',
                backgroundColor: token.railBg,
                borderRadius: token.borderRadiusXS,
                transition: `background-color ${motionDurationMid}`
            },
            [`${componentCls}-track,${componentCls}-tracks`]: {
                position: 'absolute',
                transition: `background-color ${motionDurationMid}`
            },
            [`${componentCls}-track`]: {
                backgroundColor: token.trackBg,
                borderRadius: token.borderRadiusXS
            },
            [`${componentCls}-track-draggable`]: {
                boxSizing: 'content-box',
                backgroundClip: 'content-box',
                border: 'solid rgba(0,0,0,0)'
            },
            '&:hover': {
                [`${componentCls}-rail`]: {
                    backgroundColor: token.railHoverBg
                },
                [`${componentCls}-track`]: {
                    backgroundColor: token.trackHoverBg
                },
                [`${componentCls}-dot`]: {
                    borderColor: colorFillContentHover
                },
                [`${componentCls}-handle::after`]: {
                    boxShadow: `0 0 0 ${(0, _cssinjs.unit)(handleLineWidth)} ${token.colorPrimaryBorderHover}`
                },
                [`${componentCls}-dot-active`]: {
                    borderColor: token.dotActiveBorderColor
                }
            },
            [`${componentCls}-handle`]: {
                position: 'absolute',
                width: handleSize,
                height: handleSize,
                outline: 'none',
                userSelect: 'none',
                // Dragging status
                '&-dragging-delete': {
                    opacity: 0
                },
                // 扩大选区
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    insetInlineStart: calc(handleLineWidth).mul(-1).equal(),
                    insetBlockStart: calc(handleLineWidth).mul(-1).equal(),
                    width: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
                    height: calc(handleSize).add(calc(handleLineWidth).mul(2)).equal(),
                    backgroundColor: 'transparent'
                },
                '&::after': {
                    content: '""',
                    position: 'absolute',
                    insetBlockStart: 0,
                    insetInlineStart: 0,
                    width: handleSize,
                    height: handleSize,
                    backgroundColor: token.colorBgElevated,
                    boxShadow: `0 0 0 ${(0, _cssinjs.unit)(handleLineWidth)} ${token.handleColor}`,
                    outline: `0px solid transparent`,
                    borderRadius: '50%',
                    cursor: 'pointer',
                    transition: `
            inset-inline-start ${motionDurationMid},
            inset-block-start ${motionDurationMid},
            width ${motionDurationMid},
            height ${motionDurationMid},
            box-shadow ${motionDurationMid},
            outline ${motionDurationMid}
          `
                },
                '&:hover, &:active, &:focus': {
                    '&::before': {
                        insetInlineStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
                        insetBlockStart: calc(handleSizeHover).sub(handleSize).div(2).add(handleLineWidthHover).mul(-1).equal(),
                        width: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal(),
                        height: calc(handleSizeHover).add(calc(handleLineWidthHover).mul(2)).equal()
                    },
                    '&::after': {
                        boxShadow: `0 0 0 ${(0, _cssinjs.unit)(handleLineWidthHover)} ${handleActiveColor}`,
                        outline: `6px solid ${handleActiveOutlineColor}`,
                        width: handleSizeHover,
                        height: handleSizeHover,
                        insetInlineStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal(),
                        insetBlockStart: token.calc(handleSize).sub(handleSizeHover).div(2).equal()
                    }
                }
            },
            [`&-lock ${componentCls}-handle`]: {
                '&::before, &::after': {
                    transition: 'none'
                }
            },
            [`${componentCls}-mark`]: {
                position: 'absolute',
                fontSize: token.fontSize
            },
            [`${componentCls}-mark-text`]: {
                position: 'absolute',
                display: 'inline-block',
                color: token.colorTextDescription,
                textAlign: 'center',
                wordBreak: 'keep-all',
                cursor: 'pointer',
                userSelect: 'none',
                '&-active': {
                    color: token.colorText
                }
            },
            [`${componentCls}-step`]: {
                position: 'absolute',
                background: 'transparent',
                pointerEvents: 'none'
            },
            [`${componentCls}-dot`]: {
                position: 'absolute',
                width: dotSize,
                height: dotSize,
                backgroundColor: token.colorBgElevated,
                border: `${(0, _cssinjs.unit)(handleLineWidth)} solid ${token.dotBorderColor}`,
                borderRadius: '50%',
                cursor: 'pointer',
                transition: `border-color ${token.motionDurationSlow}`,
                pointerEvents: 'auto',
                '&-active': {
                    borderColor: token.dotActiveBorderColor
                }
            },
            [`&${componentCls}-disabled`]: {
                cursor: 'not-allowed',
                [`${componentCls}-rail`]: {
                    backgroundColor: `${token.railBg} !important`
                },
                [`${componentCls}-track`]: {
                    backgroundColor: `${token.trackBgDisabled} !important`
                },
                [`
          ${componentCls}-dot
        `]: {
                    backgroundColor: token.colorBgElevated,
                    borderColor: token.trackBgDisabled,
                    boxShadow: 'none',
                    cursor: 'not-allowed'
                },
                [`${componentCls}-handle::after`]: {
                    backgroundColor: token.colorBgElevated,
                    cursor: 'not-allowed',
                    width: handleSize,
                    height: handleSize,
                    boxShadow: `0 0 0 ${(0, _cssinjs.unit)(handleLineWidth)} ${handleColorDisabled}`,
                    insetInlineStart: 0,
                    insetBlockStart: 0
                },
                [`
          ${componentCls}-mark-text,
          ${componentCls}-dot
        `]: {
                    cursor: `not-allowed !important`
                }
            },
            [`&-tooltip ${antCls}-tooltip-container`]: {
                minWidth: 'unset'
            }
        }
    };
};
// ============================ Horizontal ============================
const genDirectionStyle = (token, horizontal)=>{
    const { componentCls, railSize, handleSize, dotSize, marginFull, calc } = token;
    const railPadding = horizontal ? 'paddingBlock' : 'paddingInline';
    const full = horizontal ? 'width' : 'height';
    const part = horizontal ? 'height' : 'width';
    const handlePos = horizontal ? 'insetBlockStart' : 'insetInlineStart';
    const markInset = horizontal ? 'top' : 'insetInlineStart';
    const handlePosSize = calc(railSize).mul(3).sub(handleSize).div(2).equal();
    const draggableBorderSize = calc(handleSize).sub(railSize).div(2).equal();
    const draggableBorder = horizontal ? {
        borderWidth: `${(0, _cssinjs.unit)(draggableBorderSize)} 0`,
        transform: `translateY(${(0, _cssinjs.unit)(calc(draggableBorderSize).mul(-1).equal())})`
    } : {
        borderWidth: `0 ${(0, _cssinjs.unit)(draggableBorderSize)}`,
        transform: `translateX(${(0, _cssinjs.unit)(token.calc(draggableBorderSize).mul(-1).equal())})`
    };
    return {
        [railPadding]: railSize,
        [part]: calc(railSize).mul(3).equal(),
        [`${componentCls}-rail`]: {
            [full]: '100%',
            [part]: railSize
        },
        [`${componentCls}-track,${componentCls}-tracks`]: {
            [part]: railSize
        },
        [`${componentCls}-track-draggable`]: {
            ...draggableBorder
        },
        [`${componentCls}-handle`]: {
            [handlePos]: handlePosSize
        },
        [`${componentCls}-mark`]: {
            // Reset all
            insetInlineStart: 0,
            top: 0,
            // https://github.com/ant-design/ant-design/issues/43731
            [markInset]: calc(railSize).mul(3).add(horizontal ? 0 : marginFull).equal(),
            [full]: '100%'
        },
        [`${componentCls}-step`]: {
            // Reset all
            insetInlineStart: 0,
            top: 0,
            [markInset]: railSize,
            [full]: '100%',
            [part]: railSize
        },
        [`${componentCls}-dot`]: {
            position: 'absolute',
            [handlePos]: calc(railSize).sub(dotSize).div(2).equal()
        }
    };
};
// ============================ Horizontal ============================
const genHorizontalStyle = (token)=>{
    const { componentCls, marginPartWithMark } = token;
    return {
        [`${componentCls}-horizontal`]: {
            ...genDirectionStyle(token, true),
            [`&${componentCls}-with-marks`]: {
                marginBottom: marginPartWithMark
            }
        }
    };
};
// ============================= Vertical =============================
const genVerticalStyle = (token)=>{
    const { componentCls } = token;
    return {
        [`${componentCls}-vertical`]: {
            ...genDirectionStyle(token, false),
            height: '100%'
        }
    };
};
const prepareComponentToken = (token)=>{
    // Handle line width is always width-er 1px
    const increaseHandleWidth = 1;
    const controlSize = token.controlHeightLG / 4;
    const controlSizeHover = token.controlHeightSM / 2;
    const handleLineWidth = token.lineWidth + increaseHandleWidth;
    const handleLineWidthHover = token.lineWidth + increaseHandleWidth * 1.5;
    const handleActiveColor = token.colorPrimary;
    const handleActiveOutlineColor = new (0, _fastColor.FastColor)(handleActiveColor).setA(0.2).toRgbString();
    return {
        controlSize,
        railSize: 4,
        handleSize: controlSize,
        handleSizeHover: controlSizeHover,
        dotSize: 8,
        handleLineWidth,
        handleLineWidthHover,
        railBg: token.colorFillTertiary,
        railHoverBg: token.colorFillSecondary,
        trackBg: token.colorPrimaryBorder,
        trackHoverBg: token.colorPrimaryBorderHover,
        handleColor: token.colorPrimaryBorder,
        handleActiveColor,
        handleActiveOutlineColor,
        handleColorDisabled: new (0, _fastColor.FastColor)(token.colorTextDisabled).onBackground(token.colorBgContainer).toHexString(),
        dotBorderColor: token.colorBorderSecondary,
        dotActiveBorderColor: token.colorPrimaryBorder,
        trackBgDisabled: token.colorBgContainerDisabled
    };
};
exports.default = (0, _internal.genStyleHooks)('Slider', (token)=>{
    const sliderToken = (0, _internal.mergeToken)(token, {
        marginPart: token.calc(token.controlHeight).sub(token.controlSize).div(2).equal(),
        marginFull: token.calc(token.controlSize).div(2).equal(),
        marginPartWithMark: token.calc(token.controlHeightLG).sub(token.controlSize).equal()
    });
    return [
        genBaseStyle(sliderToken),
        genHorizontalStyle(sliderToken),
        genVerticalStyle(sliderToken)
    ];
}, prepareComponentToken);

},{"@ant-design/cssinjs":"2VNL8","@ant-design/fast-color":"50VUA","../../style":"4Ezp0","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3aJnB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRafLock);
var _react = require("react");
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
function useRafLock() {
    const [state, setState] = _react.useState(false);
    const rafRef = _react.useRef(null);
    const cleanup = ()=>{
        (0, _rafDefault.default).cancel(rafRef.current);
    };
    const setDelayState = (nextState)=>{
        cleanup();
        if (nextState) setState(nextState);
        else rafRef.current = (0, _rafDefault.default)(()=>{
            setState(nextState);
        });
    };
    _react.useEffect(()=>cleanup, []);
    return [
        state,
        setDelayState
    ];
}

},{"react":"bmhQu","@rc-component/util/es/raf":"ajbAx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e78Rn":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _programUserSelectComponentCss = require("./ProgramUserSelect.component.css");
// 🔹 React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 UI Component Libraries
var _antd = require("antd");
const ProgramUserSelect = ({ users, selectedIds, toggleUser })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "user-select-container",
        children: users.map((user)=>{
            const checked = selectedIds.includes(user._id);
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `user-item ${checked ? 'active' : ''}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _antd.Checkbox), {
                    checked: checked,
                    onChange: (e)=>{
                        e.stopPropagation(); // prevent double trigger
                        toggleUser(user._id);
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                            src: user.avatar,
                            alt: user.name,
                            className: "avatar"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "user-info",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "name",
                                children: user.name
                            })
                        })
                    ]
                })
            }, user._id);
        })
    });
};
exports.default = ProgramUserSelect;

},{"react/jsx-runtime":"gonF6","./ProgramUserSelect.component.css":"43f6m","react":"bmhQu","antd":[["Checkbox","cz5r0","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"43f6m":[function() {},{}],"cz5r0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _checkbox = require("./Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _group = require("./Group");
var _groupDefault = parcelHelpers.interopDefault(_group);
"use client";
const Checkbox = (0, _checkboxDefault.default);
Checkbox.Group = (0, _groupDefault.default);
Checkbox.__ANT_CHECKBOX = true;
exports.default = Checkbox;

},{"./Checkbox":"3mWgv","./Group":"1VVCC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3mWgv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _checkbox = require("@rc-component/checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _ref = require("@rc-component/util/es/ref");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _isNonNullable = require("../_util/isNonNullable");
var _isNonNullableDefault = parcelHelpers.interopDefault(_isNonNullable);
var _warning = require("../_util/warning");
var _wave = require("../_util/wave");
var _waveDefault = parcelHelpers.interopDefault(_wave);
var _interface = require("../_util/wave/interface");
var _context = require("../config-provider/context");
var _disabledContext = require("../config-provider/DisabledContext");
var _disabledContextDefault = parcelHelpers.interopDefault(_disabledContext);
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _context1 = require("../form/context");
var _groupContext = require("./GroupContext");
var _groupContextDefault = parcelHelpers.interopDefault(_groupContext);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _useBubbleLock = require("./useBubbleLock");
var _useBubbleLockDefault = parcelHelpers.interopDefault(_useBubbleLock);
"use client";
const InternalCheckbox = (props, ref)=>{
    const { prefixCls: customizePrefixCls, className, rootClassName, children, indeterminate = false, style, onMouseEnter, onMouseLeave, skipGroup = false, disabled, classNames, styles, ...restProps } = props;
    const { getPrefixCls, direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('checkbox');
    const checkboxGroup = _react.useContext((0, _groupContextDefault.default));
    const { isFormItemInput } = _react.useContext((0, _context1.FormItemInputContext));
    const contextDisabled = _react.useContext((0, _disabledContextDefault.default));
    const mergedDisabled = (checkboxGroup?.disabled || disabled) ?? contextDisabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        indeterminate,
        disabled: mergedDisabled
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const prevValue = _react.useRef(restProps.value);
    const checkboxRef = _react.useRef(null);
    const mergedRef = (0, _ref.composeRef)(ref, checkboxRef);
    _react.useEffect(()=>{
        checkboxGroup?.registerValue(restProps.value);
    }, []);
    _react.useEffect(()=>{
        if (skipGroup) return;
        if (restProps.value !== prevValue.current) {
            checkboxGroup?.cancelValue(prevValue.current);
            checkboxGroup?.registerValue(restProps.value);
            prevValue.current = restProps.value;
        }
        return ()=>checkboxGroup?.cancelValue(restProps.value);
    }, [
        restProps.value
    ]);
    _react.useEffect(()=>{
        if (checkboxRef.current?.input) checkboxRef.current.input.indeterminate = indeterminate;
    }, [
        indeterminate
    ]);
    const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
    const checkboxProps = {
        ...restProps
    };
    if (checkboxGroup && !skipGroup) {
        checkboxProps.onChange = (...args)=>{
            if (restProps.onChange) restProps.onChange.apply(restProps, args);
            if (checkboxGroup.toggleOption) checkboxGroup.toggleOption({
                label: children,
                value: restProps.value
            });
        };
        checkboxProps.name = checkboxGroup.name;
        checkboxProps.checked = checkboxGroup.value.includes(restProps.value);
    }
    const classString = (0, _clsx.clsx)(`${prefixCls}-wrapper`, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-wrapper-checked`]: checkboxProps.checked,
        [`${prefixCls}-wrapper-disabled`]: mergedDisabled,
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput
    }, contextClassName, className, mergedClassNames.root, rootClassName, cssVarCls, rootCls, hashId);
    const checkboxClass = (0, _clsx.clsx)(mergedClassNames.icon, {
        [`${prefixCls}-indeterminate`]: indeterminate
    }, (0, _interface.TARGET_CLS), hashId);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, _useBubbleLockDefault.default)(checkboxProps.onClick);
    // ============================== Render ==============================
    return /*#__PURE__*/ _react.createElement((0, _waveDefault.default), {
        component: "Checkbox",
        disabled: mergedDisabled
    }, /*#__PURE__*/ _react.createElement("label", {
        className: classString,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onClick: onLabelClick
    }, /*#__PURE__*/ _react.createElement((0, _checkboxDefault.default), {
        ...checkboxProps,
        onClick: onInputClick,
        prefixCls: prefixCls,
        className: checkboxClass,
        style: mergedStyles.icon,
        disabled: mergedDisabled,
        ref: mergedRef
    }), (0, _isNonNullableDefault.default)(children) && /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(`${prefixCls}-label`, mergedClassNames.label),
        style: mergedStyles.label
    }, children)));
};
const Checkbox = /*#__PURE__*/ _react.forwardRef(InternalCheckbox);
exports.default = Checkbox;

},{"react":"bmhQu","@rc-component/checkbox":"3GY1u","@rc-component/util/es/ref":"jmzjd","clsx":"431Ou","../_util/hooks":"kdnMA","../_util/isNonNullable":"avlqw","../_util/warning":"95o3w","../_util/wave":"dKIm0","../_util/wave/interface":"jOEZ1","../config-provider/context":"75zwC","../config-provider/DisabledContext":"h4TcW","../config-provider/hooks/useCSSVarCls":"gcu2s","../form/context":"krZYn","./GroupContext":"iABvA","./style":"bqER3","./useBubbleLock":"69M93","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3GY1u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkbox", ()=>Checkbox);
var _useControlledState = require("@rc-component/util/es/hooks/useControlledState");
var _useControlledStateDefault = parcelHelpers.interopDefault(_useControlledState);
var _clsx = require("clsx");
var _react = require("react");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Checkbox = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { prefixCls = 'rc-checkbox', className, style, checked, disabled, defaultChecked = false, type = 'checkbox', title, onChange, ...inputProps } = props;
    const inputRef = (0, _react.useRef)(null);
    const holderRef = (0, _react.useRef)(null);
    const [rawValue, setRawValue] = (0, _useControlledStateDefault.default)(defaultChecked, checked);
    (0, _react.useImperativeHandle)(ref, ()=>({
            focus: (options)=>{
                inputRef.current?.focus(options);
            },
            blur: ()=>{
                inputRef.current?.blur();
            },
            input: inputRef.current,
            nativeElement: holderRef.current
        }));
    const classString = (0, _clsx.clsx)(prefixCls, className, {
        [`${prefixCls}-checked`]: rawValue,
        [`${prefixCls}-disabled`]: disabled
    });
    const handleChange = (e)=>{
        if (disabled) return;
        if (!('checked' in props)) setRawValue(e.target.checked);
        onChange?.({
            target: {
                ...props,
                type,
                checked: e.target.checked
            },
            stopPropagation () {
                e.stopPropagation();
            },
            preventDefault () {
                e.preventDefault();
            },
            nativeEvent: e.nativeEvent
        });
    };
    return /*#__PURE__*/ _react.createElement("span", {
        className: classString,
        title: title,
        style: style,
        ref: holderRef
    }, /*#__PURE__*/ _react.createElement("input", _extends({}, inputProps, {
        className: `${prefixCls}-input`,
        ref: inputRef,
        onChange: handleChange,
        disabled: disabled,
        checked: !!rawValue,
        type: type
    })), /*#__PURE__*/ _react.createElement("span", {
        className: `${prefixCls}-inner`
    }));
});
exports.default = Checkbox;

},{"@rc-component/util/es/hooks/useControlledState":"2FQtD","clsx":"431Ou","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dKIm0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _isVisible = require("@rc-component/util/es/Dom/isVisible");
var _isVisibleDefault = parcelHelpers.interopDefault(_isVisible);
var _ref = require("@rc-component/util/es/ref");
var _clsx = require("clsx");
var _configProvider = require("../../config-provider");
var _reactNode = require("../reactNode");
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _useWave = require("./useWave");
var _useWaveDefault = parcelHelpers.interopDefault(_useWave);
const Wave = (props)=>{
    const { children, disabled, component, colorSource } = props;
    const { getPrefixCls } = (0, _react.useContext)((0, _configProvider.ConfigContext));
    const containerRef = (0, _react.useRef)(null);
    // ============================== Style ===============================
    const prefixCls = getPrefixCls('wave');
    const hashId = (0, _styleDefault.default)(prefixCls);
    // =============================== Wave ===============================
    const showWave = (0, _useWaveDefault.default)(containerRef, (0, _clsx.clsx)(prefixCls, hashId), component, colorSource);
    // ============================== Effect ==============================
    (0, _reactDefault.default).useEffect(()=>{
        const node = containerRef.current;
        if (!node || node.nodeType !== window.Node.ELEMENT_NODE || disabled) return;
        // Click handler
        const onClick = (e)=>{
            // Fix radio button click twice
            if (!(0, _isVisibleDefault.default)(e.target) || // No need wave
            !node.getAttribute || node.getAttribute('disabled') || node.disabled || node.className.includes('disabled') && !node.className.includes('disabled:') || node.getAttribute('aria-disabled') === 'true' || node.className.includes('-leave')) return;
            showWave(e);
        };
        // Bind events
        node.addEventListener('click', onClick, true);
        return ()=>{
            node.removeEventListener('click', onClick, true);
        };
    }, [
        disabled
    ]);
    // ============================== Render ==============================
    if (!/*#__PURE__*/ (0, _reactDefault.default).isValidElement(children)) return children ?? null;
    const ref = (0, _ref.supportRef)(children) ? (0, _ref.composeRef)((0, _ref.getNodeRef)(children), containerRef) : containerRef;
    return (0, _reactNode.cloneElement)(children, {
        ref
    });
};
exports.default = Wave;

},{"react":"bmhQu","@rc-component/util/es/Dom/isVisible":"frSWl","@rc-component/util/es/ref":"jmzjd","clsx":"431Ou","../../config-provider":"dVeAX","../reactNode":"78pFx","./style":"jK8Cb","./useWave":"1dIEt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jK8Cb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _internal = require("../../theme/internal");
const genWaveStyle = (token)=>{
    const { componentCls, colorPrimary } = token;
    return {
        [componentCls]: {
            position: 'absolute',
            background: 'transparent',
            pointerEvents: 'none',
            boxSizing: 'border-box',
            color: `var(--wave-color, ${colorPrimary})`,
            boxShadow: `0 0 0 0 currentcolor`,
            opacity: 0.2,
            // =================== Motion ===================
            '&.wave-motion-appear': {
                transition: [
                    `box-shadow 0.4s ${token.motionEaseOutCirc}`,
                    `opacity 2s ${token.motionEaseOutCirc}`
                ].join(','),
                '&-active': {
                    boxShadow: `0 0 0 6px currentcolor`,
                    opacity: 0
                },
                '&.wave-quick': {
                    transition: [
                        `box-shadow ${token.motionDurationSlow} ${token.motionEaseInOut}`,
                        `opacity ${token.motionDurationSlow} ${token.motionEaseInOut}`
                    ].join(',')
                }
            }
        }
    };
};
exports.default = (0, _internal.genComponentStyleHook)('Wave', genWaveStyle);

},{"../../theme/internal":"eQVSZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1dIEt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("@rc-component/util");
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _configProvider = require("../../config-provider");
var _useToken = require("../../theme/useToken");
var _useTokenDefault = parcelHelpers.interopDefault(_useToken);
var _interface = require("./interface");
var _waveEffect = require("./WaveEffect");
var _waveEffectDefault = parcelHelpers.interopDefault(_waveEffect);
const useWave = (nodeRef, className, component, colorSource)=>{
    const { wave } = _react.useContext((0, _configProvider.ConfigContext));
    const [, token, hashId] = (0, _useTokenDefault.default)();
    const showWave = (0, _util.useEvent)((event)=>{
        const node = nodeRef.current;
        if (wave?.disabled || !node) return;
        const targetNode = node.querySelector(`.${(0, _interface.TARGET_CLS)}`) || node;
        const { showEffect } = wave || {};
        // Customize wave effect
        (showEffect || (0, _waveEffectDefault.default))(targetNode, {
            className,
            token,
            component,
            event,
            hashId,
            colorSource
        });
    });
    const rafId = _react.useRef(null);
    // Clean up RAF on unmount to prevent memory leaks and stale callbacks
    _react.useEffect(()=>()=>{
            (0, _rafDefault.default).cancel(rafId.current);
        }, []);
    // Merge trigger event into one for each frame
    const showDebounceWave = (event)=>{
        (0, _rafDefault.default).cancel(rafId.current);
        rafId.current = (0, _rafDefault.default)(()=>{
            showWave(event);
        });
    };
    return showDebounceWave;
};
exports.default = useWave;

},{"react":"bmhQu","@rc-component/util":"6ZBDN","@rc-component/util/es/raf":"ajbAx","../../config-provider":"dVeAX","../../theme/useToken":"6x222","./interface":"jOEZ1","./WaveEffect":"8Gjum","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jOEZ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TARGET_CLS", ()=>TARGET_CLS);
var _configProvider = require("../../config-provider");
const TARGET_CLS = `${(0, _configProvider.defaultPrefixCls)}-wave-target`;

},{"../../config-provider":"dVeAX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Gjum":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _motion = require("@rc-component/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _render = require("@rc-component/util/es/React/render");
var _ref = require("@rc-component/util/es/ref");
var _clsx = require("clsx");
var _interface = require("./interface");
var _util = require("./util");
"use client";
function validateNum(value) {
    return Number.isNaN(value) ? 0 : value;
}
const WaveEffect = (props)=>{
    const { className, target, component, colorSource } = props;
    const divRef = _react.useRef(null);
    // ===================== Effect =====================
    const [color, setWaveColor] = _react.useState(null);
    const [borderRadius, setBorderRadius] = _react.useState([]);
    const [left, setLeft] = _react.useState(0);
    const [top, setTop] = _react.useState(0);
    const [width, setWidth] = _react.useState(0);
    const [height, setHeight] = _react.useState(0);
    const [enabled, setEnabled] = _react.useState(false);
    const waveStyle = {
        left,
        top,
        width,
        height,
        borderRadius: borderRadius.map((radius)=>`${radius}px`).join(' ')
    };
    if (color) waveStyle['--wave-color'] = color;
    function syncPos() {
        const nodeStyle = getComputedStyle(target);
        // Get wave color from target
        setWaveColor((0, _util.getTargetWaveColor)(target, colorSource));
        const isStatic = nodeStyle.position === 'static';
        // Rect
        const { borderLeftWidth, borderTopWidth } = nodeStyle;
        setLeft(isStatic ? target.offsetLeft : validateNum(-Number.parseFloat(borderLeftWidth)));
        setTop(isStatic ? target.offsetTop : validateNum(-Number.parseFloat(borderTopWidth)));
        setWidth(target.offsetWidth);
        setHeight(target.offsetHeight);
        // Get border radius
        const { borderTopLeftRadius, borderTopRightRadius, borderBottomLeftRadius, borderBottomRightRadius } = nodeStyle;
        setBorderRadius([
            borderTopLeftRadius,
            borderTopRightRadius,
            borderBottomRightRadius,
            borderBottomLeftRadius
        ].map((radius)=>validateNum(Number.parseFloat(radius))));
    }
    _react.useEffect(()=>{
        if (target) {
            // We need delay to check position here
            // since UI may change after click
            const id = (0, _rafDefault.default)(()=>{
                syncPos();
                setEnabled(true);
            });
            // Add resize observer to follow size
            let resizeObserver;
            if (typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(syncPos);
                resizeObserver.observe(target);
            }
            return ()=>{
                (0, _rafDefault.default).cancel(id);
                resizeObserver?.disconnect();
            };
        }
    }, [
        target
    ]);
    if (!enabled) return null;
    const isSmallComponent = (component === 'Checkbox' || component === 'Radio') && target?.classList.contains((0, _interface.TARGET_CLS));
    return /*#__PURE__*/ _react.createElement((0, _motionDefault.default), {
        visible: true,
        motionAppear: true,
        motionName: "wave-motion",
        motionDeadline: 5000,
        onAppearEnd: (_, event)=>{
            if (event.deadline || event.propertyName === 'opacity') {
                const holder = divRef.current?.parentElement;
                (0, _render.unmount)(holder).then(()=>{
                    holder?.remove();
                });
            }
            return false;
        }
    }, ({ className: motionClassName }, ref)=>/*#__PURE__*/ _react.createElement("div", {
            ref: (0, _ref.composeRef)(divRef, ref),
            className: (0, _clsx.clsx)(className, motionClassName, {
                'wave-quick': isSmallComponent
            }),
            style: waveStyle
        }));
};
const showWaveEffect = (target, info)=>{
    const { component } = info;
    // Skip for unchecked checkbox
    if (component === 'Checkbox' && !target.querySelector('input')?.checked) return;
    // Create holder
    const holder = document.createElement('div');
    holder.style.position = 'absolute';
    holder.style.left = '0px';
    holder.style.top = '0px';
    target?.insertBefore(holder, target?.firstChild);
    (0, _render.render)(/*#__PURE__*/ _react.createElement(WaveEffect, {
        ...info,
        target: target
    }), holder);
};
exports.default = showWaveEffect;

},{"react":"bmhQu","@rc-component/motion":"gBwXg","@rc-component/util/es/raf":"ajbAx","@rc-component/util/es/React/render":"jackC","@rc-component/util/es/ref":"jmzjd","clsx":"431Ou","./interface":"jOEZ1","./util":"1i8Id","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jackC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// ========================== Render ==========================
parcelHelpers.export(exports, "render", ()=>render);
// ========================= Unmount ==========================
parcelHelpers.export(exports, "unmount", ()=>unmount);
var _client = require("react-dom/client");
const MARK = '__rc_react_root__';
function render(node, container) {
    const root = container[MARK] || (0, _client.createRoot)(container);
    root.render(node);
    container[MARK] = root;
}
async function unmount(container) {
    // Delay to unmount to avoid React 18 sync warning
    return Promise.resolve().then(()=>{
        container[MARK]?.unmount();
        delete container[MARK];
    });
}

},{"react-dom/client":"5eZdG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1i8Id":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidWaveColor", ()=>isValidWaveColor);
parcelHelpers.export(exports, "getTargetWaveColor", ()=>getTargetWaveColor);
function isValidWaveColor(color) {
    return color && typeof color === 'string' && color !== '#fff' && color !== '#ffffff' && color !== 'rgb(255, 255, 255)' && color !== 'rgba(255, 255, 255, 1)' && !/rgba\((?:\d*, ){3}0\)/.test(color) && // any transparent rgba color
    color !== 'transparent' && color !== 'canvastext';
}
function getTargetWaveColor(node, colorSource = null) {
    const style = getComputedStyle(node);
    const { borderTopColor, borderColor, backgroundColor } = style;
    if (colorSource && isValidWaveColor(style[colorSource])) return style[colorSource];
    return [
        borderTopColor,
        borderColor,
        backgroundColor
    ].find(isValidWaveColor) ?? null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iABvA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const GroupContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);
exports.default = GroupContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bqER3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genCheckboxStyle", ()=>genCheckboxStyle);
// ============================== Export ==============================
parcelHelpers.export(exports, "getStyle", ()=>getStyle);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../style");
var _internal = require("../../theme/internal");
const genCheckboxStyle = (token)=>{
    const { checkboxCls } = token;
    const wrapperCls = `${checkboxCls}-wrapper`;
    return [
        // ===================== Basic =====================
        {
            // Group
            [`${checkboxCls}-group`]: {
                ...(0, _style.resetComponent)(token),
                display: 'inline-flex',
                flexWrap: 'wrap',
                columnGap: token.marginXS,
                // Group > Grid
                [`> ${token.antCls}-row`]: {
                    flex: 1
                }
            },
            // Wrapper
            [wrapperCls]: {
                ...(0, _style.resetComponent)(token),
                display: 'inline-flex',
                alignItems: 'baseline',
                cursor: 'pointer',
                // Fix checkbox & radio in flex align #30260
                '&:after': {
                    display: 'inline-block',
                    width: 0,
                    overflow: 'hidden',
                    content: "'\\a0'"
                },
                // Checkbox near checkbox
                [`& + ${wrapperCls}`]: {
                    marginInlineStart: 0
                },
                [`&${wrapperCls}-in-form-item`]: {
                    'input[type="checkbox"]': {
                        width: 14,
                        // FIXME: magic
                        height: 14 // FIXME: magic
                    }
                }
            },
            // Wrapper > Checkbox
            [checkboxCls]: {
                ...(0, _style.resetComponent)(token),
                position: 'relative',
                whiteSpace: 'nowrap',
                lineHeight: 1,
                cursor: 'pointer',
                borderRadius: token.borderRadiusSM,
                // To make alignment right when `controlHeight` is changed
                // Ref: https://github.com/ant-design/ant-design/issues/41564
                alignSelf: 'center',
                // Wrapper > Checkbox > input
                [`${checkboxCls}-input`]: {
                    position: 'absolute',
                    // Since baseline align will get additional space offset,
                    // we need to move input to top to make it align with text.
                    // Ref: https://github.com/ant-design/ant-design/issues/38926#issuecomment-1486137799
                    inset: 0,
                    zIndex: 1,
                    cursor: 'pointer',
                    opacity: 0,
                    margin: 0,
                    [`&:focus-visible + ${checkboxCls}-inner`]: (0, _style.genFocusOutline)(token)
                },
                // Wrapper > Checkbox > inner
                [`${checkboxCls}-inner`]: {
                    boxSizing: 'border-box',
                    display: 'block',
                    width: token.checkboxSize,
                    height: token.checkboxSize,
                    direction: 'ltr',
                    backgroundColor: token.colorBgContainer,
                    border: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                    borderRadius: token.borderRadiusSM,
                    borderCollapse: 'separate',
                    transition: `all ${token.motionDurationSlow}`,
                    '&:after': {
                        boxSizing: 'border-box',
                        position: 'absolute',
                        top: '50%',
                        insetInlineStart: '25%',
                        display: 'table',
                        width: token.calc(token.checkboxSize).div(14).mul(5).equal(),
                        height: token.calc(token.checkboxSize).div(14).mul(8).equal(),
                        border: `${(0, _cssinjs.unit)(token.lineWidthBold)} solid ${token.colorWhite}`,
                        borderTop: 0,
                        borderInlineStart: 0,
                        transform: 'rotate(45deg) scale(0) translate(-50%,-50%)',
                        opacity: 0,
                        content: '""',
                        transition: `all ${token.motionDurationFast} ${token.motionEaseInBack}, opacity ${token.motionDurationFast}`
                    }
                },
                // Wrapper > Checkbox + Text
                '& + span': {
                    paddingInlineStart: token.paddingXS,
                    paddingInlineEnd: token.paddingXS
                }
            }
        },
        // ===================== Hover =====================
        {
            // Wrapper & Wrapper > Checkbox
            [`
        ${wrapperCls}:not(${wrapperCls}-disabled),
        ${checkboxCls}:not(${checkboxCls}-disabled)
      `]: {
                [`&:hover ${checkboxCls}-inner`]: {
                    borderColor: token.colorPrimary
                }
            },
            [`${wrapperCls}:not(${wrapperCls}-disabled)`]: {
                [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled) ${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimaryHover,
                    borderColor: 'transparent'
                },
                [`&:hover ${checkboxCls}-checked:not(${checkboxCls}-disabled):after`]: {
                    borderColor: token.colorPrimaryHover
                }
            }
        },
        // ==================== Checked ====================
        {
            // Wrapper > Checkbox
            [`${checkboxCls}-checked`]: {
                [`${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimary,
                    borderColor: token.colorPrimary,
                    '&:after': {
                        opacity: 1,
                        transform: 'rotate(45deg) scale(1) translate(-50%,-50%)',
                        transition: `all ${token.motionDurationMid} ${token.motionEaseOutBack} ${token.motionDurationFast}`
                    }
                }
            },
            [`
        ${wrapperCls}-checked:not(${wrapperCls}-disabled),
        ${checkboxCls}-checked:not(${checkboxCls}-disabled)
      `]: {
                [`&:hover ${checkboxCls}-inner`]: {
                    backgroundColor: token.colorPrimaryHover,
                    borderColor: 'transparent'
                }
            }
        },
        // ================= Indeterminate =================
        {
            [checkboxCls]: {
                '&-indeterminate': {
                    '&': {
                        // Wrapper > Checkbox > inner
                        [`${checkboxCls}-inner`]: {
                            backgroundColor: `${token.colorBgContainer}`,
                            borderColor: `${token.colorBorder}`,
                            '&:after': {
                                top: '50%',
                                insetInlineStart: '50%',
                                width: token.calc(token.fontSizeLG).div(2).equal(),
                                height: token.calc(token.fontSizeLG).div(2).equal(),
                                backgroundColor: token.colorPrimary,
                                border: 0,
                                transform: 'translate(-50%, -50%) scale(1)',
                                opacity: 1,
                                content: '""'
                            }
                        },
                        // https://github.com/ant-design/ant-design/issues/50074
                        [`&:hover ${checkboxCls}-inner`]: {
                            backgroundColor: `${token.colorBgContainer}`,
                            borderColor: `${token.colorPrimary}`
                        }
                    }
                }
            }
        },
        // ==================== Disable ====================
        {
            // Wrapper
            [`${wrapperCls}-disabled`]: {
                cursor: 'not-allowed'
            },
            // Wrapper > Checkbox
            [`${checkboxCls}-disabled`]: {
                // Wrapper > Checkbox > input
                [`&, ${checkboxCls}-input`]: {
                    cursor: 'not-allowed',
                    // Disabled for native input to enable Tooltip event handler
                    // ref: https://github.com/ant-design/ant-design/issues/39822#issuecomment-1365075901
                    pointerEvents: 'none'
                },
                // Wrapper > Checkbox > inner
                [`${checkboxCls}-inner`]: {
                    background: token.colorBgContainerDisabled,
                    borderColor: token.colorBorder,
                    '&:after': {
                        borderColor: token.colorTextDisabled
                    }
                },
                '&:after': {
                    display: 'none'
                },
                '& + span': {
                    color: token.colorTextDisabled
                },
                [`&${checkboxCls}-indeterminate ${checkboxCls}-inner::after`]: {
                    background: token.colorTextDisabled
                }
            }
        }
    ];
};
function getStyle(prefixCls, token) {
    const checkboxToken = (0, _internal.mergeToken)(token, {
        checkboxCls: `.${prefixCls}`,
        checkboxSize: token.controlInteractiveSize
    });
    return genCheckboxStyle(checkboxToken);
}
exports.default = (0, _internal.genStyleHooks)('Checkbox', (token, { prefixCls })=>[
        getStyle(prefixCls, token)
    ]);

},{"@ant-design/cssinjs":"2VNL8","../../style":"4Ezp0","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"69M93":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useBubbleLock);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
function useBubbleLock(onOriginInputClick) {
    const labelClickLockRef = (0, _reactDefault.default).useRef(null);
    const clearLock = ()=>{
        (0, _rafDefault.default).cancel(labelClickLockRef.current);
        labelClickLockRef.current = null;
    };
    const onLabelClick = ()=>{
        clearLock();
        labelClickLockRef.current = (0, _rafDefault.default)(()=>{
            labelClickLockRef.current = null;
        });
    };
    const onInputClick = (e)=>{
        if (labelClickLockRef.current) {
            e.stopPropagation();
            clearLock();
        }
        onOriginInputClick?.(e);
    };
    return [
        onLabelClick,
        onInputClick
    ];
}

},{"react":"bmhQu","@rc-component/util/es/raf":"ajbAx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1VVCC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupContext", ()=>(0, _groupContextDefault.default));
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _configProvider = require("../config-provider");
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _checkbox = require("./Checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _groupContext = require("./GroupContext");
var _groupContextDefault = parcelHelpers.interopDefault(_groupContext);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const CheckboxGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { defaultValue, children, options = [], prefixCls: customizePrefixCls, className, rootClassName, style, onChange, ...restProps } = props;
    const { getPrefixCls, direction } = _react.useContext((0, _configProvider.ConfigContext));
    const [value, setValue] = _react.useState(restProps.value || defaultValue || []);
    const [registeredValues, setRegisteredValues] = _react.useState([]);
    _react.useEffect(()=>{
        if ('value' in restProps) setValue(restProps.value || []);
    }, [
        restProps.value
    ]);
    const memoizedOptions = _react.useMemo(()=>options.map((option)=>{
            if (typeof option === 'string' || typeof option === 'number') return {
                label: option,
                value: option
            };
            return option;
        }), [
        options
    ]);
    const cancelValue = (val)=>{
        setRegisteredValues((prevValues)=>prevValues.filter((v)=>v !== val));
    };
    const registerValue = (val)=>{
        setRegisteredValues((prevValues)=>[].concat((0, _toConsumableArrayDefault.default)(prevValues), [
                val
            ]));
    };
    const toggleOption = (option)=>{
        const optionIndex = value.indexOf(option.value);
        const newValue = (0, _toConsumableArrayDefault.default)(value);
        if (optionIndex === -1) newValue.push(option.value);
        else newValue.splice(optionIndex, 1);
        if (!('value' in restProps)) setValue(newValue);
        onChange?.(newValue.filter((val)=>registeredValues.includes(val)).sort((a, b)=>{
            const indexA = memoizedOptions.findIndex((opt)=>opt.value === a);
            const indexB = memoizedOptions.findIndex((opt)=>opt.value === b);
            return indexA - indexB;
        }));
    };
    const prefixCls = getPrefixCls('checkbox', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
    const domProps = (0, _util.omit)(restProps, [
        'value',
        'disabled'
    ]);
    const childrenNode = options.length ? memoizedOptions.map((option)=>/*#__PURE__*/ _react.createElement((0, _checkboxDefault.default), {
            prefixCls: prefixCls,
            key: option.value.toString(),
            disabled: 'disabled' in option ? option.disabled : restProps.disabled,
            value: option.value,
            checked: value.includes(option.value),
            onChange: option.onChange,
            className: (0, _clsx.clsx)(`${groupPrefixCls}-item`, option.className),
            style: option.style,
            title: option.title,
            id: option.id,
            required: option.required
        }, option.label)) : children;
    const memoizedContext = _react.useMemo(()=>({
            toggleOption,
            value,
            disabled: restProps.disabled,
            name: restProps.name,
            // https://github.com/ant-design/ant-design/issues/16376
            registerValue,
            cancelValue
        }), [
        toggleOption,
        value,
        restProps.disabled,
        restProps.name,
        registerValue,
        cancelValue
    ]);
    const classString = (0, _clsx.clsx)(groupPrefixCls, {
        [`${groupPrefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, cssVarCls, rootCls, hashId);
    return /*#__PURE__*/ _react.createElement("div", {
        className: classString,
        style: style,
        ...domProps,
        ref: ref
    }, /*#__PURE__*/ _react.createElement((0, _groupContextDefault.default).Provider, {
        value: memoizedContext
    }, childrenNode));
});
exports.default = CheckboxGroup;

},{"@babel/runtime/helpers/esm/toConsumableArray":"inIie","react":"bmhQu","@rc-component/util":"6ZBDN","clsx":"431Ou","../config-provider":"dVeAX","../config-provider/hooks/useCSSVarCls":"gcu2s","./Checkbox":"3mWgv","./GroupContext":"iABvA","./style":"bqER3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c4HL6":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _trainingNavigationButtonComponentCss = require("./TrainingNavigationButton.component.css");
// 🔹 React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 UI Component Libraries
var _buttonTsx = require("src/components/Button/Button.tsx");
// 🔹 Assets
var _navigationArrowPng = require("url:../../assets/images/navigation-arrow.png");
var _navigationArrowPngDefault = parcelHelpers.interopDefault(_navigationArrowPng);
const TrainingNavigationButton = ({ currentStep, totalSteps = 5, prevStep, nextStep, prevDisable = false, nextDisable = false })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: 'trainer-card-footer',
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: 'navigationWrapper',
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                    onClick: ()=>prevStep(currentStep - 1),
                    variant: "outline",
                    className: `navigationButton leftButton`,
                    disabled: currentStep === 0 || prevDisable,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: (0, _navigationArrowPngDefault.default),
                        alt: ""
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: 'navigationStep',
                    children: Array.from({
                        length: totalSteps
                    }, (_, step)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: `
      ${step === currentStep ? 'navigationStepActive' : ''}
      ${step < currentStep ? 'navigationStepDotActive' : ''}
      navigationStepItem
    `
                        }, step))
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                    onClick: ()=>nextStep(currentStep + 1),
                    variant: "outline",
                    className: `navigationButton rightButton`,
                    disabled: nextDisable,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: (0, _navigationArrowPngDefault.default),
                        alt: ""
                    })
                })
            ]
        })
    });
};
exports.default = TrainingNavigationButton;

},{"react/jsx-runtime":"gonF6","./TrainingNavigationButton.component.css":"25bV1","react":"bmhQu","src/components/Button/Button.tsx":"g0894","url:../../assets/images/navigation-arrow.png":"xO6dQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"25bV1":[function() {},{}],"xO6dQ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fze6M");

},{}],"duzKS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimatedStep", ()=>AnimatedStep);
var _jsxRuntime = require("react/jsx-runtime");
const AnimatedStep = ({ isVisible = false, children, duration = 0.6, offset = 40, center = false, className = '' })=>{
    const style = {
        visibility: isVisible ? 'visible' : 'hidden',
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0px)' : `translateY(${offset}px)`,
        transition: `opacity ${duration}s ease, transform ${duration}s ease`,
        margin: center ? `0 auto` : undefined
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: style,
        className: `${className} animated-step`,
        children: children
    });
};

},{"react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iQJIi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TextAnimate", ()=>TextAnimate);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("motion/react");
'use client';
const cn = (...classes)=>classes.filter(Boolean).join(' ');
const motionMap = {
    div: (0, _react1.motion).div,
    p: (0, _react1.motion).p,
    span: (0, _react1.motion).span,
    h1: (0, _react1.motion).h1,
    h2: (0, _react1.motion).h2,
    h3: (0, _react1.motion).h3,
    h4: (0, _react1.motion).h4,
    h5: (0, _react1.motion).h5,
    h6: (0, _react1.motion).h6
};
const presets = {
    fadeIn: {
        hidden: {
            opacity: 0,
            y: 15
        },
        show: {
            opacity: 1,
            y: 0
        }
    },
    blurIn: {
        hidden: {
            opacity: 0,
            filter: 'blur(10px)'
        },
        show: {
            opacity: 1,
            filter: 'blur(0px)'
        }
    },
    slideUp: {
        hidden: {
            opacity: 0,
            y: 20
        },
        show: {
            opacity: 1,
            y: 0
        }
    },
    slideDown: {
        hidden: {
            opacity: 0,
            y: -20
        },
        show: {
            opacity: 1,
            y: 0
        }
    },
    slideLeft: {
        hidden: {
            opacity: 0,
            x: 20
        },
        show: {
            opacity: 1,
            x: 0
        }
    },
    slideRight: {
        hidden: {
            opacity: 0,
            x: -20
        },
        show: {
            opacity: 1,
            x: 0
        }
    },
    scaleUp: {
        hidden: {
            opacity: 0,
            scale: 0.6
        },
        show: {
            opacity: 1,
            scale: 1
        }
    }
};
const TextAnimateBase = ({ children, className, segmentClassName, as = 'p', by = 'word', animation = 'fadeIn', duration = 0.8, delay = 0, startOnView = true, once = true, center = false, onComplete, ...props })=>{
    const Component = motionMap[as];
    const itemVariants = presets[animation];
    let segments = [];
    switch(by){
        case 'word':
            segments = children.split(/(\s+)/);
            break;
        case 'character':
            segments = children.split('');
            break;
        case 'line':
            segments = children.split('\n');
            break;
        default:
            segments = [
                children
            ];
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.AnimatePresence), {
        mode: "popLayout",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Component, {
            className: cn('whitespace-pre-wrap', center && 'text-center', className),
            initial: "hidden",
            whileInView: startOnView ? 'show' : undefined,
            animate: !startOnView ? 'show' : undefined,
            viewport: {
                once
            },
            transition: {
                staggerChildren: duration / segments.length,
                delayChildren: delay
            },
            onAnimationComplete: (definition)=>{
                // ← new
                if (definition === 'show') onComplete?.();
            },
            ...props,
            children: segments.map((segment, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.motion).span, {
                    variants: itemVariants,
                    transition: {
                        duration: 0.35
                    },
                    className: cn(by === 'line' ? 'block' : 'inline-block whitespace-pre', segmentClassName),
                    children: segment
                }, index))
        })
    });
};
const TextAnimate = /*#__PURE__*/ (0, _react.memo)(TextAnimateBase);
exports.default = TextAnimate;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","motion/react":[["AnimatePresence","QteOV"],["motion","aBn1X"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gpxHy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
const AutoCloseTooltip = ({ title, children, duration = 4000 })=>{
    const [open, setOpen] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        let timer;
        if (open) timer = setTimeout(()=>setOpen(false), duration);
        return ()=>{
            if (timer) clearTimeout(timer);
        };
    }, [
        open,
        duration
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Tooltip), {
        title: title,
        open: open,
        onOpenChange: (visible)=>setOpen(visible),
        rootClassName: "antd-movement-insights",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            onMouseEnter: ()=>setOpen(true),
            style: {
                display: 'inline-block'
            },
            children: [
                children,
                ' '
            ]
        })
    });
};
exports.default = AutoCloseTooltip;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Tooltip","aByoO","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1t08c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _commandDialogModuleCss = require("./CommandDialog.module.css");
const CommandDialog = ({ visible, onClose, type, title, description, confirmText = 'Done', cancelText, onConfirm })=>{
    const getIcon = ()=>{
        switch(type){
            case 'success':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CheckCircleFilled), {
                    style: {
                        fontSize: '64px',
                        color: '#4CAF50'
                    }
                });
            case 'warning':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.ExclamationCircleFilled), {
                    style: {
                        fontSize: '64px',
                        color: '#FAAD14'
                    }
                });
            case 'error':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseCircleFilled), {
                    style: {
                        fontSize: '64px',
                        color: '#FF4D4F'
                    }
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: visible,
        onCancel: onClose,
        footer: null,
        closeIcon: null,
        // But typically success dialogs encourage clicking the main button.
        // Let's stick to simple modal for now, reusing some classes if possible or inline styles for simplicity as I don't want to mess up shared CSS too much without need.
        // User said "similar like to waitlist". WaitlistModal uses `waitlistModalContainer`.
        className: _commandDialogModuleCss.commandDialogContainer,
        styles: {
            body: {
                padding: '40px 32px 32px',
                boxShadow: 'none',
                textAlign: 'center'
            }
        },
        width: '26.563rem',
        centered: true,
        rootClassName: "command-dialog",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '24px'
            },
            children: [
                getIcon(),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '8px',
                        alignItems: 'center'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: _commandDialogModuleCss.modalTitle,
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: _commandDialogModuleCss.modalSubtitle,
                            children: description
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        display: 'flex',
                        gap: '12px',
                        width: '100%',
                        justifyContent: 'center'
                    },
                    children: [
                        cancelText && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Button), {
                            onClick: onClose,
                            className: _commandDialogModuleCss.cancelButtonCustom,
                            children: cancelText
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Button), {
                            type: "primary",
                            onClick: onConfirm || onClose,
                            className: _commandDialogModuleCss.doneButtonCustom,
                            children: confirmText
                        })
                    ]
                })
            ]
        })
    });
};
CommandDialog.displayName = 'CommandDialog';
exports.default = /*#__PURE__*/ (0, _react.memo)(CommandDialog);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Button","8HvYt","default"],["Modal","kY4DD","default"]],"@ant-design/icons":[["CheckCircleFilled","gk31P","default"],["CloseCircleFilled","d3fPr","default"],["ExclamationCircleFilled","24nhX","default"]],"./CommandDialog.module.css":"3aAAX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8HvYt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonHelpers = require("./buttonHelpers");
parcelHelpers.exportAll(_buttonHelpers, exports);
"use client";
exports.default = (0, _buttonDefault.default);

},{"./Button":"gfWzz","./buttonHelpers":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gfWzz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _util = require("@rc-component/util");
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _isNonNullable = require("../_util/isNonNullable");
var _isNonNullableDefault = parcelHelpers.interopDefault(_isNonNullable);
var _warning = require("../_util/warning");
var _wave = require("../_util/wave");
var _waveDefault = parcelHelpers.interopDefault(_wave);
var _context = require("../config-provider/context");
var _disabledContext = require("../config-provider/DisabledContext");
var _disabledContextDefault = parcelHelpers.interopDefault(_disabledContext);
var _useSize = require("../config-provider/hooks/useSize");
var _useSizeDefault = parcelHelpers.interopDefault(_useSize);
var _compact = require("../space/Compact");
var _buttonGroup = require("./ButtonGroup");
var _buttonGroupDefault = parcelHelpers.interopDefault(_buttonGroup);
var _buttonHelpers = require("./buttonHelpers");
var _defaultLoadingIcon = require("./DefaultLoadingIcon");
var _defaultLoadingIconDefault = parcelHelpers.interopDefault(_defaultLoadingIcon);
var _iconWrapper = require("./IconWrapper");
var _iconWrapperDefault = parcelHelpers.interopDefault(_iconWrapper);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _compact1 = require("./style/compact");
var _compactDefault = parcelHelpers.interopDefault(_compact1);
"use client";
function getLoadingConfig(loading) {
    if (typeof loading === 'object' && loading) {
        let delay = loading?.delay;
        delay = !Number.isNaN(delay) && typeof delay === 'number' ? delay : 0;
        return {
            loading: delay <= 0,
            delay
        };
    }
    return {
        loading: !!loading,
        delay: 0
    };
}
const ButtonTypeMap = {
    default: [
        'default',
        'outlined'
    ],
    primary: [
        'primary',
        'solid'
    ],
    dashed: [
        'default',
        'dashed'
    ],
    // `link` is not a real color but we should compatible with it
    link: [
        'link',
        'link'
    ],
    text: [
        'default',
        'text'
    ]
};
const InternalCompoundedButton = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { _skipSemantic, loading = false, prefixCls: customizePrefixCls, color, variant, type, danger = false, shape: customizeShape, size: customizeSize, disabled: customDisabled, className, rootClassName, children, icon, iconPosition, iconPlacement, ghost = false, block = false, // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = 'button', classNames, styles, style, autoInsertSpace, autoFocus, ...rest } = props;
    const childNodes = (0, _util.toArray)(children);
    // https://github.com/ant-design/ant-design/issues/47605
    // Compatible with original `type` behavior
    const mergedType = type || 'default';
    const { button } = (0, _reactDefault.default).useContext((0, _context.ConfigContext));
    const shape = customizeShape || button?.shape || 'default';
    const [parsedColor, parsedVariant] = (0, _react.useMemo)(()=>{
        // >>>>> Local
        // Color & Variant
        if (color && variant) return [
            color,
            variant
        ];
        // Sugar syntax
        if (type || danger) {
            const colorVariantPair = ButtonTypeMap[mergedType] || [];
            if (danger) return [
                'danger',
                colorVariantPair[1]
            ];
            return colorVariantPair;
        }
        // >>> Context fallback
        if (button?.color && button?.variant) return [
            button.color,
            button.variant
        ];
        return [
            'default',
            'outlined'
        ];
    }, [
        color,
        variant,
        type,
        danger,
        button?.color,
        button?.variant,
        mergedType
    ]);
    const [mergedColor, mergedVariant] = (0, _react.useMemo)(()=>{
        if (ghost && parsedVariant === 'solid') return [
            parsedColor,
            'outlined'
        ];
        return [
            parsedColor,
            parsedVariant
        ];
    }, [
        parsedColor,
        parsedVariant,
        ghost
    ]);
    const isDanger = mergedColor === 'danger';
    const mergedColorText = isDanger ? 'dangerous' : mergedColor;
    const { getPrefixCls, direction, autoInsertSpace: contextAutoInsertSpace, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('button');
    const mergedInsertSpace = autoInsertSpace ?? contextAutoInsertSpace ?? true;
    const prefixCls = getPrefixCls('btn', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    const disabled = (0, _react.useContext)((0, _disabledContextDefault.default));
    const mergedDisabled = customDisabled ?? disabled;
    const groupSize = (0, _react.useContext)((0, _buttonGroup.GroupSizeContext));
    const loadingOrDelay = (0, _react.useMemo)(()=>getLoadingConfig(loading), [
        loading
    ]);
    const [innerLoading, setLoading] = (0, _react.useState)(loadingOrDelay.loading);
    const [hasTwoCNChar, setHasTwoCNChar] = (0, _react.useState)(false);
    const buttonRef = (0, _react.useRef)(null);
    const mergedRef = (0, _util.useComposeRef)(ref, buttonRef);
    const needInserted = childNodes.length === 1 && !icon && !(0, _buttonHelpers.isUnBorderedButtonVariant)(mergedVariant);
    // ========================= Mount ==========================
    // Record for mount status.
    // This will help to no to show the animation of loading on the first mount.
    const isMountRef = (0, _react.useRef)(true);
    (0, _reactDefault.default).useEffect(()=>{
        isMountRef.current = false;
        return ()=>{
            isMountRef.current = true;
        };
    }, []);
    // ========================= Effect =========================
    // Loading. Should use `useLayoutEffect` to avoid low perf multiple click issue.
    // https://github.com/ant-design/ant-design/issues/51325
    (0, _useLayoutEffectDefault.default)(()=>{
        let delayTimer = null;
        if (loadingOrDelay.delay > 0) delayTimer = setTimeout(()=>{
            delayTimer = null;
            setLoading(true);
        }, loadingOrDelay.delay);
        else setLoading(loadingOrDelay.loading);
        function cleanupTimer() {
            if (delayTimer) {
                clearTimeout(delayTimer);
                delayTimer = null;
            }
        }
        return cleanupTimer;
    }, [
        loadingOrDelay.delay,
        loadingOrDelay.loading
    ]);
    // Two chinese characters check
    (0, _react.useEffect)(()=>{
        // FIXME: for HOC usage like <FormatMessage />
        if (!buttonRef.current || !mergedInsertSpace) return;
        const buttonText = buttonRef.current.textContent || '';
        if (needInserted && (0, _buttonHelpers.isTwoCNChar)(buttonText)) {
            if (!hasTwoCNChar) setHasTwoCNChar(true);
        } else if (hasTwoCNChar) setHasTwoCNChar(false);
    });
    // Auto focus
    (0, _react.useEffect)(()=>{
        if (autoFocus && buttonRef.current) buttonRef.current.focus();
    }, []);
    // ========================= Events =========================
    const handleClick = (0, _reactDefault.default).useCallback((e)=>{
        // FIXME: https://github.com/ant-design/ant-design/issues/30207
        if (innerLoading || mergedDisabled) {
            e.preventDefault();
            return;
        }
        props.onClick?.('href' in props ? e : e);
    }, [
        props.onClick,
        innerLoading,
        mergedDisabled
    ]);
    // ========================== Size ==========================
    const { compactSize, compactItemClassnames } = (0, _compact.useCompactItemContext)(prefixCls, direction);
    const sizeClassNameMap = {
        large: 'lg',
        small: 'sm',
        middle: undefined
    };
    const sizeFullName = (0, _useSizeDefault.default)((ctxSize)=>customizeSize ?? compactSize ?? groupSize ?? ctxSize);
    const sizeCls = sizeFullName ? sizeClassNameMap[sizeFullName] ?? '' : '';
    const iconType = innerLoading ? 'loading' : icon;
    const mergedIconPlacement = iconPlacement ?? iconPosition ?? 'start';
    const linkButtonRestProps = (0, _util.omit)(rest, [
        'navigate'
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        type: mergedType,
        color: mergedColor,
        variant: mergedVariant,
        danger: isDanger,
        shape,
        size: sizeFullName,
        disabled: mergedDisabled,
        loading: innerLoading,
        iconPlacement: mergedIconPlacement
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        _skipSemantic ? undefined : contextClassNames,
        classNames
    ], [
        _skipSemantic ? undefined : contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ========================= Render =========================
    const classes = (0, _clsx.clsx)(prefixCls, hashId, cssVarCls, {
        [`${prefixCls}-${shape}`]: shape !== 'default' && shape !== 'square' && shape,
        // Compatible with versions earlier than 5.21.0
        [`${prefixCls}-${mergedType}`]: mergedType,
        [`${prefixCls}-dangerous`]: danger,
        [`${prefixCls}-color-${mergedColorText}`]: mergedColorText,
        [`${prefixCls}-variant-${mergedVariant}`]: mergedVariant,
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
        [`${prefixCls}-background-ghost`]: ghost && !(0, _buttonHelpers.isUnBorderedButtonVariant)(mergedVariant),
        [`${prefixCls}-loading`]: innerLoading,
        [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && mergedInsertSpace && !innerLoading,
        [`${prefixCls}-block`]: block,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-icon-end`]: mergedIconPlacement === 'end'
    }, compactItemClassnames, className, rootClassName, contextClassName, mergedClassNames.root);
    const fullStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    const iconSharedProps = {
        className: mergedClassNames.icon,
        style: mergedStyles.icon
    };
    /**
   * Extract icon node
   * If there is a custom icon and not in loading state: show custom icon
   */ const iconWrapperElement = (child)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapperDefault.default), {
            prefixCls: prefixCls,
            ...iconSharedProps
        }, child);
    const defaultLoadingIconElement = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _defaultLoadingIconDefault.default), {
        existIcon: !!icon,
        prefixCls: prefixCls,
        loading: innerLoading,
        mount: isMountRef.current,
        ...iconSharedProps
    });
    /**
   * Using if-else statements can improve code readability without affecting future expansion.
   */ let iconNode;
    if (icon && !innerLoading) iconNode = iconWrapperElement(icon);
    else if (loading && typeof loading === 'object' && loading.icon) iconNode = iconWrapperElement(loading.icon);
    else iconNode = defaultLoadingIconElement;
    const contentNode = (0, _isNonNullableDefault.default)(children) ? (0, _buttonHelpers.spaceChildren)(children, needInserted && mergedInsertSpace, mergedStyles.content, mergedClassNames.content) : null;
    if (linkButtonRestProps.href !== undefined) return /*#__PURE__*/ (0, _reactDefault.default).createElement("a", {
        ...linkButtonRestProps,
        className: (0, _clsx.clsx)(classes, {
            [`${prefixCls}-disabled`]: mergedDisabled
        }),
        href: mergedDisabled ? undefined : linkButtonRestProps.href,
        style: fullStyle,
        onClick: handleClick,
        ref: mergedRef,
        tabIndex: mergedDisabled ? -1 : 0,
        "aria-disabled": mergedDisabled
    }, iconNode, contentNode);
    let buttonNode = /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        ...rest,
        type: htmlType,
        className: classes,
        style: fullStyle,
        onClick: handleClick,
        disabled: mergedDisabled,
        ref: mergedRef
    }, iconNode, contentNode, compactItemClassnames && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _compactDefault.default), {
        prefixCls: prefixCls
    }));
    if (!(0, _buttonHelpers.isUnBorderedButtonVariant)(mergedVariant)) buttonNode = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _waveDefault.default), {
        component: "Button",
        disabled: innerLoading
    }, buttonNode);
    return buttonNode;
});
const Button = InternalCompoundedButton;
Button.Group = (0, _buttonGroupDefault.default);
Button.__ANT_BUTTON = true;
exports.default = Button;

},{"react":"bmhQu","@rc-component/util":"6ZBDN","@rc-component/util/es/hooks/useLayoutEffect":"azwns","clsx":"431Ou","../_util/hooks":"kdnMA","../_util/isNonNullable":"avlqw","../_util/warning":"95o3w","../_util/wave":"dKIm0","../config-provider/context":"75zwC","../config-provider/DisabledContext":"h4TcW","../config-provider/hooks/useSize":"gXe6G","../space/Compact":"cOSpV","./ButtonGroup":"g0SOE","./buttonHelpers":"2L4bZ","./DefaultLoadingIcon":"cjOdP","./IconWrapper":"fKhVR","./style":"gOl6d","./style/compact":"htkzc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g0SOE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GroupSizeContext", ()=>GroupSizeContext);
var _react = require("react");
var _clsx = require("clsx");
var _warning = require("../_util/warning");
var _configProvider = require("../config-provider");
var _internal = require("../theme/internal");
"use client";
const GroupSizeContext = /*#__PURE__*/ _react.createContext(undefined);
const ButtonGroup = (props)=>{
    const { getPrefixCls, direction } = _react.useContext((0, _configProvider.ConfigContext));
    const { prefixCls: customizePrefixCls, size, className, ...others } = props;
    const prefixCls = getPrefixCls('btn-group', customizePrefixCls);
    const [, , hashId] = (0, _internal.useToken)();
    const sizeCls = _react.useMemo(()=>{
        switch(size){
            case 'large':
                return 'lg';
            case 'small':
                return 'sm';
            default:
                return '';
        }
    }, [
        size
    ]);
    const classes = (0, _clsx.clsx)(prefixCls, {
        [`${prefixCls}-${sizeCls}`]: sizeCls,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, hashId);
    return /*#__PURE__*/ _react.createElement(GroupSizeContext.Provider, {
        value: size
    }, /*#__PURE__*/ _react.createElement("div", {
        ...others,
        className: classes
    }));
};
exports.default = ButtonGroup;

},{"react":"bmhQu","clsx":"431Ou","../_util/warning":"95o3w","../config-provider":"dVeAX","../theme/internal":[["useToken","6x222","default"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2L4bZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isTwoCNChar", ()=>isTwoCNChar);
parcelHelpers.export(exports, "convertLegacyProps", ()=>convertLegacyProps);
parcelHelpers.export(exports, "isString", ()=>isString);
parcelHelpers.export(exports, "isUnBorderedButtonVariant", ()=>isUnBorderedButtonVariant);
parcelHelpers.export(exports, "spaceChildren", ()=>spaceChildren);
parcelHelpers.export(exports, "_ButtonVariantTypes", ()=>_ButtonVariantTypes);
parcelHelpers.export(exports, "_ButtonColorTypes", ()=>_ButtonColorTypes);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _isNonNullable = require("../_util/isNonNullable");
var _isNonNullableDefault = parcelHelpers.interopDefault(_isNonNullable);
var _reactNode = require("../_util/reactNode");
var _interface = require("../theme/interface");
"use client";
const rxTwoCNChar = /^[\u4E00-\u9FA5]{2}$/;
const isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function convertLegacyProps(type) {
    if (type === 'danger') return {
        danger: true
    };
    return {
        type
    };
}
function isString(str) {
    return typeof str === 'string';
}
function isUnBorderedButtonVariant(type) {
    return type === 'text' || type === 'link';
}
function splitCNCharsBySpace(child, needInserted, style, className) {
    if (!(0, _isNonNullableDefault.default)(child) || child === '') return;
    const SPACE = needInserted ? ' ' : '';
    if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) return (0, _reactNode.cloneElement)(child, (oriProps)=>({
            ...oriProps,
            children: oriProps.children.split('').join(SPACE),
            className,
            style
        }));
    if (isString(child)) return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: className,
        style: style
    }, isTwoCNChar(child) ? child.split('').join(SPACE) : child);
    if ((0, _reactNode.isFragment)(child)) return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: className,
        style: style
    }, child);
    return (0, _reactNode.cloneElement)(child, (oriProps)=>({
            ...oriProps,
            className: (0, _clsx.clsx)(oriProps.className, className) || undefined,
            style: {
                ...oriProps.style,
                ...style
            }
        }));
}
function spaceChildren(children, needInserted, style, className) {
    let isPrevChildPure = false;
    const childList = [];
    (0, _reactDefault.default).Children.forEach(children, (child)=>{
        const type = typeof child;
        const isCurrentChildPure = type === 'string' || type === 'number';
        if (isPrevChildPure && isCurrentChildPure) {
            const lastIndex = childList.length - 1;
            const lastChild = childList[lastIndex];
            childList[lastIndex] = `${lastChild}${child}`;
        } else childList.push(child);
        isPrevChildPure = isCurrentChildPure;
    });
    return (0, _reactDefault.default).Children.map(childList, (child)=>splitCNCharsBySpace(child, needInserted, style, className));
}
const _ButtonTypes = [
    'default',
    'primary',
    'dashed',
    'link',
    'text'
];
const _ButtonShapes = [
    'default',
    'circle',
    'round',
    'square'
];
const _ButtonHTMLTypes = [
    'submit',
    'button',
    'reset'
];
const _ButtonVariantTypes = [
    'outlined',
    'dashed',
    'solid',
    'filled',
    'text',
    'link'
];
const _ButtonColorTypes = [
    'default',
    'primary',
    'danger'
].concat((0, _toConsumableArrayDefault.default)((0, _interface.PresetColors)));

},{"@babel/runtime/helpers/esm/toConsumableArray":"inIie","react":"bmhQu","clsx":"431Ou","../_util/isNonNullable":"avlqw","../_util/reactNode":"78pFx","../theme/interface":"aRwwT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cjOdP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _loadingOutlined = require("@ant-design/icons/es/icons/LoadingOutlined");
var _loadingOutlinedDefault = parcelHelpers.interopDefault(_loadingOutlined);
var _motion = require("@rc-component/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
var _clsx = require("clsx");
var _iconWrapper = require("./IconWrapper");
var _iconWrapperDefault = parcelHelpers.interopDefault(_iconWrapper);
"use client";
const InnerLoadingIcon = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { prefixCls, className, style, iconClassName } = props;
    const mergedIconCls = (0, _clsx.clsx)(`${prefixCls}-loading-icon`, className);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _iconWrapperDefault.default), {
        prefixCls: prefixCls,
        className: mergedIconCls,
        style: style,
        ref: ref
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _loadingOutlinedDefault.default), {
        className: iconClassName
    }));
});
const getCollapsedWidth = ()=>({
        width: 0,
        opacity: 0,
        transform: 'scale(0)'
    });
const getRealWidth = (node)=>({
        width: node.scrollWidth,
        opacity: 1,
        transform: 'scale(1)'
    });
const DefaultLoadingIcon = (props)=>{
    const { prefixCls, loading, existIcon, className, style, mount } = props;
    const visible = !!loading;
    if (existIcon) return /*#__PURE__*/ (0, _reactDefault.default).createElement(InnerLoadingIcon, {
        prefixCls: prefixCls,
        className: className,
        style: style
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _motionDefault.default), {
        visible: visible,
        // Used for minus flex gap style only
        motionName: `${prefixCls}-loading-icon-motion`,
        motionAppear: !mount,
        motionEnter: !mount,
        motionLeave: !mount,
        removeOnLeave: true,
        onAppearStart: getCollapsedWidth,
        onAppearActive: getRealWidth,
        onEnterStart: getCollapsedWidth,
        onEnterActive: getRealWidth,
        onLeaveStart: getRealWidth,
        onLeaveActive: getCollapsedWidth
    }, ({ className: motionCls, style: motionStyle }, ref)=>{
        const mergedStyle = {
            ...style,
            ...motionStyle
        };
        return /*#__PURE__*/ (0, _reactDefault.default).createElement(InnerLoadingIcon, {
            prefixCls: prefixCls,
            className: (0, _clsx.clsx)(className, motionCls),
            style: mergedStyle,
            ref: ref
        });
    });
};
exports.default = DefaultLoadingIcon;

},{"react":"bmhQu","@ant-design/icons/es/icons/LoadingOutlined":"8Mvdh","@rc-component/motion":"gBwXg","clsx":"431Ou","./IconWrapper":"fKhVR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Mvdh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _loadingOutlined = require("@ant-design/icons-svg/es/asn/LoadingOutlined");
var _loadingOutlinedDefault = parcelHelpers.interopDefault(_loadingOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const LoadingOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _loadingOutlinedDefault.default)
    }));
/**![loading](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk4OCA1NDhjLTE5LjkgMC0zNi0xNi4xLTM2LTM2IDAtNTkuNC0xMS42LTExNy0zNC42LTE3MS4zYTQ0MC40NSA0NDAuNDUgMCAwMC05NC4zLTEzOS45IDQzNy43MSA0MzcuNzEgMCAwMC0xMzkuOS05NC4zQzYyOSA4My42IDU3MS40IDcyIDUxMiA3MmMtMTkuOSAwLTM2LTE2LjEtMzYtMzZzMTYuMS0zNiAzNi0zNmM2OS4xIDAgMTM2LjIgMTMuNSAxOTkuMyA0MC4zQzc3Mi4zIDY2IDgyNyAxMDMgODc0IDE1MGM0NyA0NyA4My45IDEwMS44IDEwOS43IDE2Mi43IDI2LjcgNjMuMSA0MC4yIDEzMC4yIDQwLjIgMTk5LjMuMSAxOS45LTE2IDM2LTM1LjkgMzZ6IiAvPjwvc3ZnPg==) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(LoadingOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/LoadingOutlined":"hfV7S","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hfV7S":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var LoadingOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"
                }
            }
        ]
    },
    "name": "loading",
    "theme": "outlined"
};
exports.default = LoadingOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hjeUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _colors = require("@ant-design/colors");
var _context = require("./Context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _iconBase = require("./IconBase");
var _iconBaseDefault = parcelHelpers.interopDefault(_iconBase);
var _twoTonePrimaryColor = require("./twoTonePrimaryColor");
var _utils = require("../utils");
'use client';
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Initial setting
// should move it to antd main repo?
(0, _twoTonePrimaryColor.setTwoToneColor)((0, _colors.blue).primary);
// https://github.com/DefinitelyTyped/DefinitelyTyped/issues/34757#issuecomment-488848720
const Icon = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { // affect outter <i>...</i>
    className, // affect inner <svg>...</svg>
    icon, spin, rotate, tabIndex, onClick, // other
    twoToneColor, ...restProps } = props;
    const { prefixCls = 'anticon', rootClassName } = _react.useContext((0, _contextDefault.default));
    const classString = (0, _clsx.clsx)(rootClassName, prefixCls, {
        [`${prefixCls}-${icon.name}`]: !!icon.name,
        [`${prefixCls}-spin`]: !!spin || icon.name === 'loading'
    }, className);
    let iconTabIndex = tabIndex;
    if (iconTabIndex === undefined && onClick) iconTabIndex = -1;
    const svgStyle = rotate ? {
        msTransform: `rotate(${rotate}deg)`,
        transform: `rotate(${rotate}deg)`
    } : undefined;
    const [primaryColor, secondaryColor] = (0, _utils.normalizeTwoToneColors)(twoToneColor);
    return /*#__PURE__*/ _react.createElement("span", _extends({
        role: "img",
        "aria-label": icon.name
    }, restProps, {
        ref: ref,
        tabIndex: iconTabIndex,
        onClick: onClick,
        className: classString
    }), /*#__PURE__*/ _react.createElement((0, _iconBaseDefault.default), {
        icon: icon,
        primaryColor: primaryColor,
        secondaryColor: secondaryColor,
        style: svgStyle
    }));
});
Icon.getTwoToneColor = (0, _twoTonePrimaryColor.getTwoToneColor);
Icon.setTwoToneColor = (0, _twoTonePrimaryColor.setTwoToneColor);
exports.default = Icon;

},{"react":"bmhQu","clsx":"431Ou","@ant-design/colors":"350gL","./Context":"112Bq","./IconBase":"aTiL1","./twoTonePrimaryColor":"hehca","../utils":"3vjmB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aTiL1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _utils = require("../utils");
const twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6',
    calculated: false
};
function setTwoToneColors({ primaryColor, secondaryColor }) {
    twoToneColorPalette.primaryColor = primaryColor;
    twoToneColorPalette.secondaryColor = secondaryColor || (0, _utils.getSecondaryColor)(primaryColor);
    twoToneColorPalette.calculated = !!secondaryColor;
}
function getTwoToneColors() {
    return {
        ...twoToneColorPalette
    };
}
const IconBase = (props)=>{
    const { icon, className, onClick, style, primaryColor, secondaryColor, ...restProps } = props;
    const svgRef = _react.useRef(null);
    let colors = twoToneColorPalette;
    if (primaryColor) colors = {
        primaryColor,
        secondaryColor: secondaryColor || (0, _utils.getSecondaryColor)(primaryColor)
    };
    (0, _utils.useInsertStyles)(svgRef);
    (0, _utils.warning)((0, _utils.isIconDefinition)(icon), `icon should be icon definiton, but got ${icon}`);
    if (!(0, _utils.isIconDefinition)(icon)) return null;
    let target = icon;
    if (target && typeof target.icon === 'function') target = {
        ...target,
        icon: target.icon(colors.primaryColor, colors.secondaryColor)
    };
    return (0, _utils.generate)(target.icon, `svg-${target.name}`, {
        className,
        onClick,
        style,
        'data-icon': target.name,
        width: '1em',
        height: '1em',
        fill: 'currentColor',
        'aria-hidden': 'true',
        ...restProps,
        ref: svgRef
    });
};
IconBase.displayName = 'IconReact';
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
exports.default = IconBase;

},{"react":"bmhQu","../utils":"3vjmB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3vjmB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warning", ()=>warning);
parcelHelpers.export(exports, "isIconDefinition", ()=>isIconDefinition);
parcelHelpers.export(exports, "normalizeAttrs", ()=>normalizeAttrs);
parcelHelpers.export(exports, "generate", ()=>generate);
parcelHelpers.export(exports, "getSecondaryColor", ()=>getSecondaryColor);
parcelHelpers.export(exports, "normalizeTwoToneColors", ()=>normalizeTwoToneColors);
parcelHelpers.export(exports, "svgBaseProps", ()=>svgBaseProps);
parcelHelpers.export(exports, "iconStyles", ()=>iconStyles);
parcelHelpers.export(exports, "useInsertStyles", ()=>useInsertStyles);
var _colors = require("@ant-design/colors");
var _dynamicCSS = require("@rc-component/util/es/Dom/dynamicCSS");
var _shadow = require("@rc-component/util/es/Dom/shadow");
var _warning = require("@rc-component/util/es/warning");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("./components/Context");
var _contextDefault = parcelHelpers.interopDefault(_context);
function camelCase(input) {
    return input.replace(/-(.)/g, (match, g)=>g.toUpperCase());
}
function warning(valid, message) {
    (0, _warning.warningOnce)(valid, `[@ant-design/icons] ${message}`);
}
function isIconDefinition(target) {
    return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}
function normalizeAttrs(attrs = {}) {
    return Object.keys(attrs).reduce((acc, key)=>{
        const val = attrs[key];
        switch(key){
            case 'class':
                acc.className = val;
                delete acc.class;
                break;
            default:
                delete acc[key];
                acc[camelCase(key)] = val;
        }
        return acc;
    }, {});
}
function generate(node, key, rootProps) {
    if (!rootProps) return /*#__PURE__*/ (0, _reactDefault.default).createElement(node.tag, {
        key,
        ...normalizeAttrs(node.attrs)
    }, (node.children || []).map((child, index)=>generate(child, `${key}-${node.tag}-${index}`)));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(node.tag, {
        key,
        ...normalizeAttrs(node.attrs),
        ...rootProps
    }, (node.children || []).map((child, index)=>generate(child, `${key}-${node.tag}-${index}`)));
}
function getSecondaryColor(primaryColor) {
    // choose the second color
    return (0, _colors.generate)(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
    if (!twoToneColor) return [];
    return Array.isArray(twoToneColor) ? twoToneColor : [
        twoToneColor
    ];
}
const svgBaseProps = {
    width: '1em',
    height: '1em',
    fill: 'currentColor',
    'aria-hidden': 'true',
    focusable: 'false'
};
const iconStyles = `
.anticon {
  display: inline-flex;
  align-items: center;
  color: inherit;
  font-style: normal;
  line-height: 0;
  text-align: center;
  text-transform: none;
  vertical-align: -0.125em;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.anticon > * {
  line-height: 1;
}

.anticon svg {
  display: inline-block;
  vertical-align: inherit;
}

.anticon::before {
  display: none;
}

.anticon .anticon-icon {
  display: block;
}

.anticon[tabindex] {
  cursor: pointer;
}

.anticon-spin::before,
.anticon-spin {
  display: inline-block;
  -webkit-animation: loadingCircle 1s infinite linear;
  animation: loadingCircle 1s infinite linear;
}

@-webkit-keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes loadingCircle {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
`;
const useInsertStyles = (eleRef)=>{
    const { csp, prefixCls, layer } = (0, _react.useContext)((0, _contextDefault.default));
    let mergedStyleStr = iconStyles;
    if (prefixCls) mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
    if (layer) mergedStyleStr = `@layer ${layer} {\n${mergedStyleStr}\n}`;
    (0, _react.useEffect)(()=>{
        const ele = eleRef.current;
        const shadowRoot = (0, _shadow.getShadowRoot)(ele);
        (0, _dynamicCSS.updateCSS)(mergedStyleStr, '@ant-design-icons', {
            prepend: !layer,
            csp,
            attachTo: shadowRoot
        });
    }, []);
};

},{"@ant-design/colors":"350gL","@rc-component/util/es/Dom/dynamicCSS":"3UDeI","@rc-component/util/es/Dom/shadow":"17j4f","@rc-component/util/es/warning":"hJXDS","react":"bmhQu","./components/Context":"112Bq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hehca":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setTwoToneColor", ()=>setTwoToneColor);
parcelHelpers.export(exports, "getTwoToneColor", ()=>getTwoToneColor);
var _iconBase = require("./IconBase");
var _iconBaseDefault = parcelHelpers.interopDefault(_iconBase);
var _utils = require("../utils");
function setTwoToneColor(twoToneColor) {
    const [primaryColor, secondaryColor] = (0, _utils.normalizeTwoToneColors)(twoToneColor);
    return (0, _iconBaseDefault.default).setTwoToneColors({
        primaryColor,
        secondaryColor
    });
}
function getTwoToneColor() {
    const colors = (0, _iconBaseDefault.default).getTwoToneColors();
    if (!colors.calculated) return colors.primaryColor;
    return [
        colors.primaryColor,
        colors.secondaryColor
    ];
}

},{"./IconBase":"aTiL1","../utils":"3vjmB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fKhVR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
"use client";
const IconWrapper = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { className, style, children, prefixCls } = props;
    const iconWrapperCls = (0, _clsx.clsx)(`${prefixCls}-icon`, className);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        ref: ref,
        className: iconWrapperCls,
        style: style
    }, children);
});
exports.default = IconWrapper;

},{"react":"bmhQu","clsx":"431Ou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gOl6d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../style");
var _internal = require("../../theme/internal");
var _group = require("./group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _token = require("./token");
var _variant = require("./variant");
var _variantDefault = parcelHelpers.interopDefault(_variant);
// ============================== Shared ==============================
const genSharedButtonStyle = (token)=>{
    const { componentCls, iconCls, fontWeight, opacityLoading, motionDurationSlow, motionEaseInOut, iconGap, calc } = token;
    return {
        [componentCls]: {
            outline: 'none',
            position: 'relative',
            display: 'inline-flex',
            gap: iconGap,
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight,
            whiteSpace: 'nowrap',
            textAlign: 'center',
            backgroundImage: 'none',
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid} ${token.motionEaseInOut}`,
            userSelect: 'none',
            touchAction: 'manipulation',
            '&:disabled > *': {
                pointerEvents: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/51380
            [`${componentCls}-icon > svg`]: (0, _style.resetIcon)(),
            '> a': {
                color: 'currentColor'
            },
            '&:not(:disabled)': (0, _style.genFocusStyle)(token),
            [`&${componentCls}-two-chinese-chars::first-letter`]: {
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
                marginInlineEnd: '-0.34em',
                letterSpacing: '0.34em'
            },
            [`&${componentCls}-icon-only`]: {
                paddingInline: 0,
                // make `btn-icon-only` not too narrow
                [`&${componentCls}-compact-item`]: {
                    flex: 'none'
                }
            },
            // Loading
            [`&${componentCls}-loading`]: {
                opacity: opacityLoading,
                cursor: 'default'
            },
            [`${componentCls}-loading-icon`]: {
                transition: [
                    'width',
                    'opacity',
                    'margin'
                ].map((transition)=>`${transition} ${motionDurationSlow} ${motionEaseInOut}`).join(',')
            },
            // iconPlacement
            [`&:not(${componentCls}-icon-end)`]: {
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineEnd: calc(iconGap).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineEnd: 0
                    },
                    '&-leave-start': {
                        marginInlineEnd: 0
                    },
                    '&-leave-active': {
                        marginInlineEnd: calc(iconGap).mul(-1).equal()
                    }
                }
            },
            '&-icon-end': {
                flexDirection: 'row-reverse',
                [`${componentCls}-loading-icon-motion`]: {
                    '&-appear-start, &-enter-start': {
                        marginInlineStart: calc(iconGap).mul(-1).equal()
                    },
                    '&-appear-active, &-enter-active': {
                        marginInlineStart: 0
                    },
                    '&-leave-start': {
                        marginInlineStart: 0
                    },
                    '&-leave-active': {
                        marginInlineStart: calc(iconGap).mul(-1).equal()
                    }
                }
            }
        }
    };
};
// ============================== Shape ===============================
const genCircleButtonStyle = (token)=>({
        minWidth: token.controlHeight,
        paddingInline: 0,
        borderRadius: '50%'
    });
// =============================== Size ===============================
const genButtonStyle = (token, prefixCls = '')=>{
    const { componentCls, controlHeight, fontSize, borderRadius, buttonPaddingHorizontal, iconCls, buttonPaddingVertical, buttonIconOnlyFontSize } = token;
    return [
        {
            [prefixCls]: {
                fontSize,
                height: controlHeight,
                padding: `${(0, _cssinjs.unit)(buttonPaddingVertical)} ${(0, _cssinjs.unit)(buttonPaddingHorizontal)}`,
                borderRadius,
                [`&${componentCls}-icon-only`]: {
                    width: controlHeight,
                    [iconCls]: {
                        fontSize: buttonIconOnlyFontSize
                    }
                }
            }
        },
        // Shape - patch prefixCls again to override solid border radius style
        {
            [`${componentCls}${componentCls}-circle${prefixCls}`]: genCircleButtonStyle(token)
        },
        {
            [`${componentCls}${componentCls}-round${prefixCls}`]: {
                borderRadius: token.controlHeight,
                [`&:not(${componentCls}-icon-only)`]: {
                    paddingInline: token.buttonPaddingHorizontal
                }
            }
        }
    ];
};
const genSizeBaseButtonStyle = (token)=>{
    const baseToken = (0, _internal.mergeToken)(token, {
        fontSize: token.contentFontSize
    });
    return genButtonStyle(baseToken, token.componentCls);
};
const genSizeSmallButtonStyle = (token)=>{
    const smallToken = (0, _internal.mergeToken)(token, {
        controlHeight: token.controlHeightSM,
        fontSize: token.contentFontSizeSM,
        padding: token.paddingXS,
        buttonPaddingHorizontal: token.paddingInlineSM,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusSM,
        buttonIconOnlyFontSize: token.onlyIconSizeSM
    });
    return genButtonStyle(smallToken, `${token.componentCls}-sm`);
};
const genSizeLargeButtonStyle = (token)=>{
    const largeToken = (0, _internal.mergeToken)(token, {
        controlHeight: token.controlHeightLG,
        fontSize: token.contentFontSizeLG,
        buttonPaddingHorizontal: token.paddingInlineLG,
        buttonPaddingVertical: 0,
        borderRadius: token.borderRadiusLG,
        buttonIconOnlyFontSize: token.onlyIconSizeLG
    });
    return genButtonStyle(largeToken, `${token.componentCls}-lg`);
};
const genBlockButtonStyle = (token)=>{
    const { componentCls } = token;
    return {
        [componentCls]: {
            [`&${componentCls}-block`]: {
                width: '100%'
            }
        }
    };
};
// ============================== Export ==============================
exports.default = (0, _internal.genStyleHooks)('Button', (token)=>{
    const buttonToken = (0, _token.prepareToken)(token);
    return [
        // Shared
        genSharedButtonStyle(buttonToken),
        // Size
        genSizeBaseButtonStyle(buttonToken),
        genSizeSmallButtonStyle(buttonToken),
        genSizeLargeButtonStyle(buttonToken),
        // Block
        genBlockButtonStyle(buttonToken),
        // Variant
        (0, _variantDefault.default)(buttonToken),
        // Button Group
        (0, _groupDefault.default)(buttonToken)
    ];
}, (0, _token.prepareComponentToken), {
    unitless: {
        fontWeight: true,
        contentLineHeight: true,
        contentLineHeightSM: true,
        contentLineHeightLG: true
    }
});

},{"@ant-design/cssinjs":"2VNL8","../../style":"4Ezp0","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"./group":"cvYr1","./token":"hGgLT","./variant":"dIeRv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cvYr1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const genButtonBorderStyle = (buttonTypeCls, borderColor)=>({
        // Border
        [`> span, > ${buttonTypeCls}`]: {
            '&:not(:last-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineEndColor: borderColor
                    }
                }
            },
            '&:not(:first-child)': {
                [`&, & > ${buttonTypeCls}`]: {
                    '&:not(:disabled)': {
                        borderInlineStartColor: borderColor
                    }
                }
            }
        }
    });
const genGroupStyle = (token)=>{
    const { componentCls, fontSize, lineWidth, groupBorderColor, colorErrorHover } = token;
    return {
        [`${componentCls}-group`]: [
            {
                position: 'relative',
                display: 'inline-flex',
                // Border
                [`> span, > ${componentCls}`]: {
                    '&:not(:last-child)': {
                        [`&, & > ${componentCls}`]: {
                            borderStartEndRadius: 0,
                            borderEndEndRadius: 0
                        }
                    },
                    '&:not(:first-child)': {
                        marginInlineStart: token.calc(lineWidth).mul(-1).equal(),
                        [`&, & > ${componentCls}`]: {
                            borderStartStartRadius: 0,
                            borderEndStartRadius: 0
                        }
                    }
                },
                [componentCls]: {
                    position: 'relative',
                    zIndex: 1,
                    '&:hover, &:focus, &:active': {
                        zIndex: 2
                    },
                    '&[disabled]': {
                        zIndex: 0
                    }
                },
                [`${componentCls}-icon-only`]: {
                    fontSize
                }
            },
            // Border Color
            genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
            genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
        ]
    };
};
exports.default = genGroupStyle;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hGgLT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareToken", ()=>prepareToken);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _cssinjs = require("@ant-design/cssinjs");
var _color = require("../../color-picker/color");
var _colorPresets = require("../../color-picker/components/ColorPresets");
var _internal = require("../../theme/internal");
var _interface = require("../../theme/interface");
var _getAlphaColor = require("../../theme/util/getAlphaColor");
var _getAlphaColorDefault = parcelHelpers.interopDefault(_getAlphaColor);
const prepareToken = (token)=>{
    const { paddingInline, onlyIconSize, borderColorDisabled } = token;
    const buttonToken = (0, _internal.mergeToken)(token, {
        buttonPaddingHorizontal: paddingInline,
        buttonPaddingVertical: 0,
        buttonIconOnlyFontSize: onlyIconSize,
        colorBorderDisabled: borderColorDisabled
    });
    return buttonToken;
};
const prepareComponentToken = (token)=>{
    const contentFontSize = token.contentFontSize ?? token.fontSize;
    const contentFontSizeSM = token.contentFontSizeSM ?? token.fontSize;
    const contentFontSizeLG = token.contentFontSizeLG ?? token.fontSizeLG;
    const contentLineHeight = token.contentLineHeight ?? (0, _internal.getLineHeight)(contentFontSize);
    const contentLineHeightSM = token.contentLineHeightSM ?? (0, _internal.getLineHeight)(contentFontSizeSM);
    const contentLineHeightLG = token.contentLineHeightLG ?? (0, _internal.getLineHeight)(contentFontSizeLG);
    const solidTextColor = (0, _colorPresets.isBright)(new (0, _color.AggregationColor)(token.colorBgSolid), '#fff') ? '#000' : '#fff';
    const shadowColorTokens = (0, _interface.PresetColors).reduce((prev, colorKey)=>({
            ...prev,
            [`${colorKey}ShadowColor`]: `0 ${(0, _cssinjs.unit)(token.controlOutlineWidth)} 0 ${(0, _getAlphaColorDefault.default)(token[`${colorKey}1`], token.colorBgContainer)}`
        }), {});
    const defaultBgDisabled = token.colorBgContainerDisabled;
    const dashedBgDisabled = token.colorBgContainerDisabled;
    return {
        ...shadowColorTokens,
        fontWeight: 400,
        iconGap: token.marginXS,
        defaultShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlTmpOutline}`,
        primaryShadow: `0 ${token.controlOutlineWidth}px 0 ${token.controlOutline}`,
        dangerShadow: `0 ${token.controlOutlineWidth}px 0 ${token.colorErrorOutline}`,
        primaryColor: token.colorTextLightSolid,
        dangerColor: token.colorTextLightSolid,
        borderColorDisabled: token.colorBorderDisabled,
        defaultGhostColor: token.colorBgContainer,
        ghostBg: 'transparent',
        defaultGhostBorderColor: token.colorBgContainer,
        paddingInline: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineLG: token.paddingContentHorizontal - token.lineWidth,
        paddingInlineSM: 8 - token.lineWidth,
        onlyIconSize: 'inherit',
        onlyIconSizeSM: 'inherit',
        onlyIconSizeLG: 'inherit',
        groupBorderColor: token.colorPrimaryHover,
        linkHoverBg: 'transparent',
        textTextColor: token.colorText,
        textTextHoverColor: token.colorText,
        textTextActiveColor: token.colorText,
        textHoverBg: token.colorFillTertiary,
        defaultColor: token.colorText,
        defaultBg: token.colorBgContainer,
        defaultBorderColor: token.colorBorder,
        defaultBorderColorDisabled: token.colorBorder,
        defaultHoverBg: token.colorBgContainer,
        defaultHoverColor: token.colorPrimaryHover,
        defaultHoverBorderColor: token.colorPrimaryHover,
        defaultActiveBg: token.colorBgContainer,
        defaultActiveColor: token.colorPrimaryActive,
        defaultActiveBorderColor: token.colorPrimaryActive,
        solidTextColor,
        contentFontSize,
        contentFontSizeSM,
        contentFontSizeLG,
        contentLineHeight,
        contentLineHeightSM,
        contentLineHeightLG,
        paddingBlock: Math.max((token.controlHeight - contentFontSize * contentLineHeight) / 2 - token.lineWidth, 0),
        paddingBlockSM: Math.max((token.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token.lineWidth, 0),
        paddingBlockLG: Math.max((token.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token.lineWidth, 0),
        defaultBgDisabled,
        dashedBgDisabled
    };
};

},{"@ant-design/cssinjs":"2VNL8","../../color-picker/color":"1LCBg","../../color-picker/components/ColorPresets":"7pg7p","../../theme/internal":[["getLineHeight","1W7Zr"],["mergeToken","g8twD"]],"../../theme/interface":"aRwwT","../../theme/util/getAlphaColor":"4o7AG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7pg7p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isBright", ()=>isBright);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _colorPicker = require("@rc-component/color-picker");
var _clsx = require("clsx");
var _collapse = require("../../collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _locale = require("../../locale");
var _internal = require("../../theme/internal");
var _util = require("../util");
"use client";
const genPresetColor = (list)=>list.map((value)=>{
        value.colors = value.colors.map((0, _util.generateColor));
        return value;
    });
const isBright = (value, bgColorToken)=>{
    const { r, g, b, a } = value.toRgb();
    const hsv = new (0, _colorPicker.Color)(value.toRgbString()).onBackground(bgColorToken).toHsv();
    if (a <= 0.5) // Adapted to dark mode
    return hsv.v > 0.5;
    return r * 0.299 + g * 0.587 + b * 0.114 > 192;
};
const genCollapsePanelKey = (preset, index)=>{
    const mergedKey = preset.key ?? index;
    return `panel-${mergedKey}`;
};
const ColorPresets = ({ prefixCls, presets, value: color, onChange })=>{
    const [locale] = (0, _locale.useLocale)('ColorPicker');
    const [, token] = (0, _internal.useToken)();
    const presetsValue = (0, _react.useMemo)(()=>genPresetColor(presets), [
        presets
    ]);
    const colorPresetsPrefixCls = `${prefixCls}-presets`;
    const activeKeys = (0, _react.useMemo)(()=>presetsValue.reduce((acc, preset, index)=>{
            const { defaultOpen = true } = preset;
            if (defaultOpen) acc.push(genCollapsePanelKey(preset, index));
            return acc;
        }, []), [
        presetsValue
    ]);
    const handleClick = (colorValue)=>{
        onChange?.(colorValue);
    };
    const items = presetsValue.map((preset, index)=>({
            key: genCollapsePanelKey(preset, index),
            label: /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: `${colorPresetsPrefixCls}-label`
            }, preset?.label),
            children: /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
                className: `${colorPresetsPrefixCls}-items`
            }, Array.isArray(preset?.colors) && preset.colors?.length > 0 ? preset.colors.map((presetColor, index)=>{
                const colorInst = (0, _util.generateColor)(presetColor);
                return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _colorPicker.ColorBlock), {
                    // eslint-disable-next-line react/no-array-index-key
                    key: `preset-${index}-${presetColor.toHexString()}`,
                    color: colorInst.toCssString(),
                    prefixCls: prefixCls,
                    className: (0, _clsx.clsx)(`${colorPresetsPrefixCls}-color`, {
                        [`${colorPresetsPrefixCls}-color-checked`]: presetColor.toCssString() === color?.toCssString(),
                        [`${colorPresetsPrefixCls}-color-bright`]: isBright(presetColor, token.colorBgElevated)
                    }),
                    onClick: ()=>handleClick(presetColor)
                });
            }) : /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                className: `${colorPresetsPrefixCls}-empty`
            }, locale.presetEmpty))
        }));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: colorPresetsPrefixCls
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _collapseDefault.default), {
        defaultActiveKey: activeKeys,
        ghost: true,
        items: items
    }));
};
exports.default = ColorPresets;

},{"react":"bmhQu","@rc-component/color-picker":"kM4Bc","clsx":"431Ou","../../collapse":"eFBoK","../../locale":[["useLocale","l6QvX","default"]],"../../theme/internal":[["useToken","6x222","default"]],"../util":"4mJWZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eFBoK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
"use client";
exports.default = (0, _collapseDefault.default);

},{"./Collapse":"cB2FI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cB2FI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _rightOutlined = require("@ant-design/icons/es/icons/RightOutlined");
var _rightOutlinedDefault = parcelHelpers.interopDefault(_rightOutlined);
var _collapse = require("@rc-component/collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _motion = require("../_util/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
var _reactNode = require("../_util/reactNode");
var _warning = require("../_util/warning");
var _context = require("../config-provider/context");
var _useSize = require("../config-provider/hooks/useSize");
var _useSizeDefault = parcelHelpers.interopDefault(_useSize);
var _collapsePanel = require("./CollapsePanel");
var _collapsePanelDefault = parcelHelpers.interopDefault(_collapsePanel);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const Collapse = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { getPrefixCls, direction, expandIcon: contextExpandIcon, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('collapse');
    const { prefixCls: customizePrefixCls, className, rootClassName, style, bordered = true, ghost, size: customizeSize, expandIconPlacement, expandIconPosition, children, destroyInactivePanel, destroyOnHidden, expandIcon, classNames, styles } = props;
    const mergedSize = (0, _useSizeDefault.default)((ctx)=>customizeSize ?? ctx ?? 'middle');
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    const mergedPlacement = expandIconPlacement ?? expandIconPosition ?? 'start';
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size: mergedSize,
        bordered,
        expandIconPlacement: mergedPlacement
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const mergedExpandIcon = expandIcon ?? contextExpandIcon;
    var deprecatedName, newName;
    const renderExpandIcon = _react.useCallback((panelProps = {})=>{
        const icon = typeof mergedExpandIcon === 'function' ? mergedExpandIcon(panelProps) : /*#__PURE__*/ _react.createElement((0, _rightOutlinedDefault.default), {
            rotate: panelProps.isActive ? direction === 'rtl' ? -90 : 90 : undefined,
            "aria-label": panelProps.isActive ? 'expanded' : 'collapsed'
        });
        return (0, _reactNode.cloneElement)(icon, ()=>({
                className: (0, _clsx.clsx)(icon?.props?.className, `${prefixCls}-arrow`)
            }));
    }, [
        mergedExpandIcon,
        prefixCls,
        direction
    ]);
    const collapseClassName = (0, _clsx.clsx)(`${prefixCls}-icon-placement-${mergedPlacement}`, {
        [`${prefixCls}-borderless`]: !bordered,
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-ghost`]: !!ghost,
        [`${prefixCls}-${mergedSize}`]: mergedSize !== 'middle'
    }, contextClassName, className, rootClassName, hashId, cssVarCls, mergedClassNames.root);
    const openMotion = _react.useMemo(()=>({
            ...(0, _motionDefault.default)(rootPrefixCls),
            motionAppear: false,
            leavedClassName: `${prefixCls}-panel-hidden`
        }), [
        rootPrefixCls,
        prefixCls
    ]);
    const items = _react.useMemo(()=>{
        if (children) return (0, _util.toArray)(children).map((child)=>child);
        return null;
    }, [
        children
    ]);
    return(/*#__PURE__*/ // @ts-ignore
    _react.createElement((0, _collapseDefault.default), {
        ref: ref,
        openMotion: openMotion,
        ...(0, _util.omit)(props, [
            'rootClassName'
        ]),
        expandIcon: renderExpandIcon,
        prefixCls: prefixCls,
        className: collapseClassName,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        classNames: mergedClassNames,
        styles: mergedStyles,
        destroyOnHidden: destroyOnHidden ?? destroyInactivePanel
    }, items));
});
exports.default = Object.assign(Collapse, {
    Panel: (0, _collapsePanelDefault.default)
});

},{"react":"bmhQu","@ant-design/icons/es/icons/RightOutlined":"lRGzb","@rc-component/collapse":"bCkwS","@rc-component/util":"6ZBDN","clsx":"431Ou","../_util/hooks":"kdnMA","../_util/motion":"kUUSo","../_util/reactNode":"78pFx","../_util/warning":"95o3w","../config-provider/context":"75zwC","../config-provider/hooks/useSize":"gXe6G","./CollapsePanel":"9KWZU","./style":"jAa92","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lRGzb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _rightOutlined = require("@ant-design/icons-svg/es/asn/RightOutlined");
var _rightOutlinedDefault = parcelHelpers.interopDefault(_rightOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const RightOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _rightOutlinedDefault.default)
    }));
/**![right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc2NS43IDQ4Ni44TDMxNC45IDEzNC43QTcuOTcgNy45NyAwIDAwMzAyIDE0MXY3Ny4zYzAgNC45IDIuMyA5LjYgNi4xIDEyLjZsMzYwIDI4MS4xLTM2MCAyODEuMWMtMy45IDMtNi4xIDcuNy02LjEgMTIuNlY4ODNjMCA2LjcgNy43IDEwLjQgMTIuOSA2LjNsNDUwLjgtMzUyLjFhMzEuOTYgMzEuOTYgMCAwMDAtNTAuNHoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(RightOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/RightOutlined":"bQo7A","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bQo7A":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var RightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"
                }
            }
        ]
    },
    "name": "right",
    "theme": "outlined"
};
exports.default = RightOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bCkwS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Panel", ()=>Panel);
var _collapse = require("./Collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
exports.default = (0, _collapseDefault.default);
const { Panel } = (0, _collapseDefault.default);

},{"./Collapse":"fULJe","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fULJe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _clsx = require("clsx");
var _util = require("@rc-component/util");
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useItems = require("./hooks/useItems");
var _useItemsDefault = parcelHelpers.interopDefault(_useItems);
var _panel = require("./Panel");
var _panelDefault = parcelHelpers.interopDefault(_panel);
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
function getActiveKeysArray(activeKey) {
    let currentActiveKey = activeKey;
    if (!Array.isArray(currentActiveKey)) {
        const activeKeyType = typeof currentActiveKey;
        currentActiveKey = activeKeyType === 'number' || activeKeyType === 'string' ? [
            currentActiveKey
        ] : [];
    }
    return currentActiveKey.map((key)=>String(key));
}
const Collapse = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { prefixCls = 'rc-collapse', destroyOnHidden = false, style, accordion, className, children, collapsible, openMotion, expandIcon, activeKey: rawActiveKey, defaultActiveKey, onChange, items, classNames: customizeClassNames, styles } = props;
    const collapseClassName = (0, _clsx.clsx)(prefixCls, className);
    const [internalActiveKey, setActiveKey] = (0, _util.useControlledState)(defaultActiveKey, rawActiveKey);
    const activeKey = getActiveKeysArray(internalActiveKey);
    const triggerActiveKey = (0, _util.useEvent)((next)=>{
        const nextKeys = getActiveKeysArray(next);
        setActiveKey(nextKeys);
        onChange?.(nextKeys);
    });
    const onItemClick = (key)=>{
        if (accordion) triggerActiveKey(activeKey[0] === key ? [] : [
            key
        ]);
        else triggerActiveKey(activeKey.includes(key) ? activeKey.filter((item)=>item !== key) : [
            ...activeKey,
            key
        ]);
    };
    // ======================== Children ========================
    (0, _warningDefault.default)(!children, '[rc-collapse] `children` will be removed in next major version. Please use `items` instead.');
    const mergedChildren = (0, _useItemsDefault.default)(items, children, {
        prefixCls,
        accordion,
        openMotion,
        expandIcon,
        collapsible,
        destroyOnHidden,
        onItemClick,
        activeKey,
        classNames: customizeClassNames,
        styles
    });
    // ======================== Render ========================
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", (0, _extendsDefault.default)({
        ref: ref,
        className: collapseClassName,
        style: style,
        role: accordion ? 'tablist' : undefined
    }, (0, _pickAttrsDefault.default)(props, {
        aria: true,
        data: true
    })), mergedChildren);
});
exports.default = Object.assign(Collapse, {
    /**
   * @deprecated use `items` instead, will be removed in `v4.0.0`
   */ Panel: (0, _panelDefault.default)
});

},{"@babel/runtime/helpers/esm/extends":"85Hd3","clsx":"431Ou","@rc-component/util":"6ZBDN","@rc-component/util/es/warning":"hJXDS","react":"bmhQu","./hooks/useItems":"f1WFT","./Panel":"eOzgv","@rc-component/util/es/pickAttrs":"jGMGD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f1WFT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _toArray = require("@rc-component/util/es/Children/toArray");
var _toArrayDefault = parcelHelpers.interopDefault(_toArray);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _panel = require("../Panel");
var _panelDefault = parcelHelpers.interopDefault(_panel);
const convertItemsToNodes = (items, props)=>{
    const { prefixCls, accordion, collapsible, destroyOnHidden, onItemClick, activeKey, openMotion, expandIcon, classNames: collapseClassNames, styles } = props;
    return items.map((item, index)=>{
        const { children, label, key: rawKey, collapsible: rawCollapsible, onItemClick: rawOnItemClick, destroyOnHidden: rawDestroyOnHidden, ...restProps } = item;
        // You may be puzzled why you want to convert them all into strings, me too.
        // Maybe: https://github.com/react-component/collapse/blob/aac303a8b6ff30e35060b4f8fecde6f4556fcbe2/src/Collapse.tsx#L15
        const key = String(rawKey ?? index);
        const mergeCollapsible = rawCollapsible ?? collapsible;
        const mergedDestroyOnHidden = rawDestroyOnHidden ?? destroyOnHidden;
        const handleItemClick = (value)=>{
            if (mergeCollapsible === 'disabled') return;
            onItemClick(value);
            rawOnItemClick?.(value);
        };
        let isActive = false;
        if (accordion) isActive = activeKey[0] === key;
        else isActive = activeKey.indexOf(key) > -1;
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _panelDefault.default), (0, _extendsDefault.default)({}, restProps, {
            classNames: collapseClassNames,
            styles: styles,
            prefixCls: prefixCls,
            key: key,
            panelKey: key,
            isActive: isActive,
            accordion: accordion,
            openMotion: openMotion,
            expandIcon: expandIcon,
            header: label,
            collapsible: mergeCollapsible,
            onItemClick: handleItemClick,
            destroyOnHidden: mergedDestroyOnHidden
        }), children);
    });
};
/**
 * @deprecated The next major version will be removed
 */ const getNewChild = (child, index, props)=>{
    if (!child) return null;
    const { prefixCls, accordion, collapsible, destroyOnHidden, onItemClick, activeKey, openMotion, expandIcon, classNames: collapseClassNames, styles } = props;
    const key = child.key || String(index);
    const { header, headerClass, destroyOnHidden: childDestroyOnHidden, collapsible: childCollapsible, onItemClick: childOnItemClick } = child.props;
    let isActive = false;
    if (accordion) isActive = activeKey[0] === key;
    else isActive = activeKey.indexOf(key) > -1;
    const mergeCollapsible = childCollapsible ?? collapsible;
    const handleItemClick = (value)=>{
        if (mergeCollapsible === 'disabled') return;
        onItemClick(value);
        childOnItemClick?.(value);
    };
    const childProps = {
        key,
        panelKey: key,
        header,
        headerClass,
        classNames: collapseClassNames,
        styles,
        isActive,
        prefixCls,
        destroyOnHidden: childDestroyOnHidden ?? destroyOnHidden,
        openMotion,
        accordion,
        children: child.props.children,
        onItemClick: handleItemClick,
        expandIcon,
        collapsible: mergeCollapsible
    };
    // https://github.com/ant-design/ant-design/issues/20479
    if (typeof child.type === 'string') return child;
    Object.keys(childProps).forEach((propName)=>{
        if (typeof childProps[propName] === 'undefined') delete childProps[propName];
    });
    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(child, childProps);
};
function useItems(items, rawChildren, props) {
    if (Array.isArray(items)) return convertItemsToNodes(items, props);
    return (0, _toArrayDefault.default)(rawChildren).map((child, index)=>getNewChild(child, index, props));
}
exports.default = useItems;

},{"@babel/runtime/helpers/esm/extends":"85Hd3","@rc-component/util/es/Children/toArray":"7sTeM","react":"bmhQu","../Panel":"eOzgv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eOzgv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _clsx = require("clsx");
var _motion = require("@rc-component/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
var _keyCode = require("@rc-component/util/es/KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _panelContent = require("./PanelContent");
var _panelContentDefault = parcelHelpers.interopDefault(_panelContent);
const CollapsePanel = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { showArrow = true, headerClass, isActive, onItemClick, forceRender, className, classNames: customizeClassNames = {}, styles = {}, prefixCls, collapsible, accordion, panelKey, extra, header, expandIcon, openMotion, destroyOnHidden, children, ...resetProps } = props;
    const disabled = collapsible === 'disabled';
    const ifExtraExist = extra !== null && extra !== undefined && typeof extra !== 'boolean';
    const collapsibleProps = {
        onClick: ()=>{
            onItemClick?.(panelKey);
        },
        onKeyDown: (e)=>{
            if (e.key === 'Enter' || e.keyCode === (0, _keyCodeDefault.default).ENTER || e.which === (0, _keyCodeDefault.default).ENTER) onItemClick?.(panelKey);
        },
        role: accordion ? 'tab' : 'button',
        ['aria-expanded']: isActive,
        ['aria-disabled']: disabled,
        tabIndex: disabled ? -1 : 0
    };
    // ======================== Icon ========================
    const iconNodeInner = typeof expandIcon === 'function' ? expandIcon(props) : /*#__PURE__*/ (0, _reactDefault.default).createElement("i", {
        className: "arrow"
    });
    const iconNode = iconNodeInner && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", (0, _extendsDefault.default)({
        className: (0, _clsx.clsx)(`${prefixCls}-expand-icon`, customizeClassNames?.icon),
        style: styles?.icon
    }, [
        'header',
        'icon'
    ].includes(collapsible) ? collapsibleProps : {}), iconNodeInner);
    const collapsePanelClassNames = (0, _clsx.clsx)(`${prefixCls}-item`, {
        [`${prefixCls}-item-active`]: isActive,
        [`${prefixCls}-item-disabled`]: disabled
    }, className);
    const headerClassName = (0, _clsx.clsx)(headerClass, `${prefixCls}-header`, {
        [`${prefixCls}-collapsible-${collapsible}`]: !!collapsible
    }, customizeClassNames?.header);
    // ======================== HeaderProps ========================
    const headerProps = {
        className: headerClassName,
        style: styles?.header,
        ...[
            'header',
            'icon'
        ].includes(collapsible) ? {} : collapsibleProps
    };
    // ======================== Render ========================
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", (0, _extendsDefault.default)({}, resetProps, {
        ref: ref,
        className: collapsePanelClassNames
    }), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", headerProps, showArrow && iconNode, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", (0, _extendsDefault.default)({
        className: (0, _clsx.clsx)(`${prefixCls}-title`, customizeClassNames?.title),
        style: styles?.title
    }, collapsible === 'header' ? collapsibleProps : {}), header), ifExtraExist && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${prefixCls}-extra`
    }, extra)), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _motionDefault.default), (0, _extendsDefault.default)({
        visible: isActive,
        leavedClassName: `${prefixCls}-panel-hidden`
    }, openMotion, {
        forceRender: forceRender,
        removeOnLeave: destroyOnHidden
    }), ({ className: motionClassName, style: motionStyle }, motionRef)=>{
        return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _panelContentDefault.default), {
            ref: motionRef,
            prefixCls: prefixCls,
            className: motionClassName,
            classNames: customizeClassNames,
            style: motionStyle,
            styles: styles,
            isActive: isActive,
            forceRender: forceRender,
            role: accordion ? 'tabpanel' : undefined
        }, children);
    }));
});
exports.default = CollapsePanel;

},{"@babel/runtime/helpers/esm/extends":"85Hd3","clsx":"431Ou","@rc-component/motion":"gBwXg","@rc-component/util/es/KeyCode":"6yRlk","react":"bmhQu","./PanelContent":"h8kMZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h8kMZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const PanelContent = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { prefixCls, forceRender, className, style, children, isActive, role, classNames: customizeClassNames, styles } = props;
    const [rendered, setRendered] = (0, _reactDefault.default).useState(isActive || forceRender);
    (0, _reactDefault.default).useEffect(()=>{
        if (forceRender || isActive) setRendered(true);
    }, [
        forceRender,
        isActive
    ]);
    if (!rendered) return null;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: ref,
        className: (0, _clsx.clsx)(`${prefixCls}-panel`, {
            [`${prefixCls}-panel-active`]: isActive,
            [`${prefixCls}-panel-inactive`]: !isActive
        }, className),
        style: style,
        role: role
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-body`, customizeClassNames?.body),
        style: styles?.body
    }, children));
});
exports.default = PanelContent;

},{"clsx":"431Ou","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jGMGD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>pickAttrs);
const attributes = `accept acceptCharset accessKey action allowFullScreen allowTransparency
    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge
    charSet checked classID className colSpan cols content contentEditable contextMenu
    controls coords crossOrigin data dateTime default defer dir disabled download draggable
    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder
    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity
    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media
    mediaGroup method min minLength multiple muted name noValidate nonce open
    optimum pattern placeholder poster preload radioGroup readOnly rel required
    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected
    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style
    summary tabIndex target title type useMap value width wmode wrap`;
const eventsName = `onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown
    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick
    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown
    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel
    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough
    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata
    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError`;
const propList = `${attributes} ${eventsName}`.split(/[\s\n]+/);
/* eslint-enable max-len */ const ariaPrefix = 'aria-';
const dataPrefix = 'data-';
function match(key, prefix) {
    return key.indexOf(prefix) === 0;
}
function pickAttrs(props, ariaOnly = false) {
    let mergedConfig;
    if (ariaOnly === false) mergedConfig = {
        aria: true,
        data: true,
        attr: true
    };
    else if (ariaOnly === true) mergedConfig = {
        aria: true
    };
    else mergedConfig = {
        ...ariaOnly
    };
    const attrs = {};
    Object.keys(props).forEach((key)=>{
        if (// Aria
        mergedConfig.aria && (key === 'role' || match(key, ariaPrefix)) || // Data
        mergedConfig.data && match(key, dataPrefix) || // Attr
        mergedConfig.attr && propList.includes(key)) attrs[key] = props[key];
    });
    return attrs;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9KWZU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _collapse = require("@rc-component/collapse");
var _collapseDefault = parcelHelpers.interopDefault(_collapse);
var _clsx = require("clsx");
var _warning = require("../_util/warning");
var _configProvider = require("../config-provider");
"use client";
const CollapsePanel = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const { prefixCls: customizePrefixCls, className, showArrow = true } = props;
    const prefixCls = getPrefixCls('collapse', customizePrefixCls);
    const collapsePanelClassName = (0, _clsx.clsx)({
        [`${prefixCls}-no-arrow`]: !showArrow
    }, className);
    return /*#__PURE__*/ _react.createElement((0, _collapseDefault.default).Panel, {
        ref: ref,
        ...props,
        prefixCls: prefixCls,
        className: collapsePanelClassName
    });
});
exports.default = CollapsePanel;

},{"react":"bmhQu","@rc-component/collapse":"bCkwS","clsx":"431Ou","../_util/warning":"95o3w","../config-provider":"dVeAX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jAa92":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genBaseStyle", ()=>genBaseStyle);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../style");
var _motion = require("../../style/motion");
var _internal = require("../../theme/internal");
const genBaseStyle = (token)=>{
    const { componentCls, contentBg, padding, headerBg, headerPadding, collapseHeaderPaddingSM, collapseHeaderPaddingLG, collapsePanelBorderRadius, lineWidth, lineType, colorBorder, colorText, colorTextHeading, colorTextDisabled, fontSizeLG, lineHeight, lineHeightLG, marginSM, paddingSM, paddingLG, paddingXS, motionDurationSlow, fontSizeIcon, contentPadding, fontHeight, fontHeightLG } = token;
    const borderBase = `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorBorder}`;
    return {
        [componentCls]: {
            ...(0, _style.resetComponent)(token),
            backgroundColor: headerBg,
            border: borderBase,
            borderRadius: collapsePanelBorderRadius,
            '&-rtl': {
                direction: 'rtl'
            },
            [`& > ${componentCls}-item`]: {
                borderBottom: borderBase,
                '&:first-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `${(0, _cssinjs.unit)(collapsePanelBorderRadius)} ${(0, _cssinjs.unit)(collapsePanelBorderRadius)} 0 0`
                    }
                },
                '&:last-child': {
                    [`
            &,
            & > ${componentCls}-header`]: {
                        borderRadius: `0 0 ${(0, _cssinjs.unit)(collapsePanelBorderRadius)} ${(0, _cssinjs.unit)(collapsePanelBorderRadius)}`
                    }
                },
                [`> ${componentCls}-header`]: {
                    position: 'relative',
                    // Compatible with old version of antd, should remove in next version
                    display: 'flex',
                    flexWrap: 'nowrap',
                    alignItems: 'flex-start',
                    padding: headerPadding,
                    color: colorTextHeading,
                    lineHeight,
                    cursor: 'pointer',
                    transition: `all ${motionDurationSlow}, visibility 0s`,
                    ...(0, _style.genFocusStyle)(token),
                    [`> ${componentCls}-title`]: {
                        flex: 'auto'
                    },
                    // >>>>> Arrow
                    [`${componentCls}-expand-icon`]: {
                        height: fontHeight,
                        display: 'flex',
                        alignItems: 'center',
                        marginInlineEnd: marginSM
                    },
                    [`${componentCls}-arrow`]: {
                        ...(0, _style.resetIcon)(),
                        fontSize: fontSizeIcon,
                        // when `transform: rotate()` is applied to icon's root element
                        transition: `transform ${motionDurationSlow}`,
                        // when `transform: rotate()` is applied to icon's child element
                        svg: {
                            transition: `transform ${motionDurationSlow}`
                        }
                    },
                    // >>>>> Text
                    [`${componentCls}-title`]: {
                        marginInlineEnd: 'auto'
                    }
                },
                [`${componentCls}-collapsible-header`]: {
                    cursor: 'default',
                    [`${componentCls}-title`]: {
                        flex: 'none',
                        cursor: 'pointer'
                    },
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                },
                [`${componentCls}-collapsible-icon`]: {
                    cursor: 'unset',
                    [`${componentCls}-expand-icon`]: {
                        cursor: 'pointer'
                    }
                }
            },
            [`${componentCls}-panel`]: {
                color: colorText,
                backgroundColor: contentBg,
                borderTop: borderBase,
                [`& > ${componentCls}-body`]: {
                    padding: contentPadding
                },
                '&-hidden': {
                    display: 'none'
                }
            },
            '&-small': {
                [`> ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingSM,
                        paddingInlineStart: paddingXS,
                        [`> ${componentCls}-expand-icon`]: {
                            // Arrow offset
                            marginInlineStart: token.calc(paddingSM).sub(paddingXS).equal()
                        }
                    },
                    [`> ${componentCls}-panel > ${componentCls}-body`]: {
                        padding: paddingSM
                    }
                }
            },
            '&-large': {
                [`> ${componentCls}-item`]: {
                    fontSize: fontSizeLG,
                    lineHeight: lineHeightLG,
                    [`> ${componentCls}-header`]: {
                        padding: collapseHeaderPaddingLG,
                        paddingInlineStart: padding,
                        [`> ${componentCls}-expand-icon`]: {
                            height: fontHeightLG,
                            // Arrow offset
                            marginInlineStart: token.calc(paddingLG).sub(padding).equal()
                        }
                    },
                    [`> ${componentCls}-panel > ${componentCls}-body`]: {
                        padding: paddingLG
                    }
                }
            },
            [`${componentCls}-item:last-child`]: {
                borderBottom: 0,
                [`> ${componentCls}-panel`]: {
                    borderRadius: `0 0 ${(0, _cssinjs.unit)(collapsePanelBorderRadius)} ${(0, _cssinjs.unit)(collapsePanelBorderRadius)}`
                }
            },
            [`& ${componentCls}-item-disabled > ${componentCls}-header`]: {
                [`
          &,
          & > .arrow
        `]: {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                }
            },
            // ========================== Icon Placement ==========================
            [`&${componentCls}-icon-placement-end`]: {
                [`& > ${componentCls}-item`]: {
                    [`> ${componentCls}-header`]: {
                        [`${componentCls}-expand-icon`]: {
                            order: 1,
                            marginInlineEnd: 0,
                            marginInlineStart: marginSM
                        }
                    }
                }
            }
        }
    };
};
const genArrowStyle = (token)=>{
    const { componentCls } = token;
    const fixedSelector = `> ${componentCls}-item > ${componentCls}-header ${componentCls}-arrow`;
    return {
        [`${componentCls}-rtl`]: {
            [fixedSelector]: {
                transform: `rotate(180deg)`
            }
        }
    };
};
const genBorderlessStyle = (token)=>{
    const { componentCls, headerBg, borderlessContentPadding, borderlessContentBg, colorBorder } = token;
    return {
        [`${componentCls}-borderless`]: {
            backgroundColor: headerBg,
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: `1px solid ${colorBorder}`
            },
            [`
        > ${componentCls}-item:last-child,
        > ${componentCls}-item:last-child ${componentCls}-header
      `]: {
                borderRadius: 0
            },
            [`> ${componentCls}-item:last-child`]: {
                borderBottom: 0
            },
            [`> ${componentCls}-item > ${componentCls}-panel`]: {
                backgroundColor: borderlessContentBg,
                borderTop: 0
            },
            [`> ${componentCls}-item > ${componentCls}-panel > ${componentCls}-body`]: {
                padding: borderlessContentPadding
            }
        }
    };
};
const genGhostStyle = (token)=>{
    const { componentCls, paddingSM } = token;
    return {
        [`${componentCls}-ghost`]: {
            backgroundColor: 'transparent',
            border: 0,
            [`> ${componentCls}-item`]: {
                borderBottom: 0,
                [`> ${componentCls}-panel`]: {
                    backgroundColor: 'transparent',
                    border: 0,
                    [`> ${componentCls}-body`]: {
                        paddingBlock: paddingSM
                    }
                }
            }
        }
    };
};
const prepareComponentToken = (token)=>({
        headerPadding: `${token.paddingSM}px ${token.padding}px`,
        headerBg: token.colorFillAlter,
        contentPadding: `${token.padding}px 16px`,
        // Fixed Value
        contentBg: token.colorBgContainer,
        borderlessContentPadding: `${token.paddingXXS}px 16px ${token.padding}px`,
        borderlessContentBg: 'transparent'
    });
exports.default = (0, _internal.genStyleHooks)('Collapse', (token)=>{
    const collapseToken = (0, _internal.mergeToken)(token, {
        collapseHeaderPaddingSM: `${(0, _cssinjs.unit)(token.paddingXS)} ${(0, _cssinjs.unit)(token.paddingSM)}`,
        collapseHeaderPaddingLG: `${(0, _cssinjs.unit)(token.padding)} ${(0, _cssinjs.unit)(token.paddingLG)}`,
        collapsePanelBorderRadius: token.borderRadiusLG
    });
    return [
        genBaseStyle(collapseToken),
        genBorderlessStyle(collapseToken),
        genGhostStyle(collapseToken),
        genArrowStyle(collapseToken),
        (0, _motion.genCollapseMotion)(collapseToken)
    ];
}, prepareComponentToken);

},{"@ant-design/cssinjs":"2VNL8","../../style":"4Ezp0","../../style/motion":[["genCollapseMotion","dERCf","default"]],"../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dERCf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const genCollapseMotion = (token)=>({
        [token.componentCls]: {
            // For common/openAnimation
            [`${token.antCls}-motion-collapse-legacy`]: {
                overflow: 'hidden',
                '&-active': {
                    transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
                }
            },
            [`${token.antCls}-motion-collapse`]: {
                overflow: 'hidden',
                transition: `height ${token.motionDurationMid} ${token.motionEaseInOut},
        opacity ${token.motionDurationMid} ${token.motionEaseInOut} !important`
            }
        }
    });
exports.default = genCollapseMotion;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dIeRv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _interface = require("../../theme/interface");
var _genStyleUtils = require("../../theme/util/genStyleUtils");
const genVariantStyle = (token)=>{
    const { componentCls, antCls } = token;
    // Default: '--ant-btn-'
    const getCssVar = (0, _genStyleUtils.genCssVar)(antCls, 'btn');
    return {
        [componentCls]: [
            // ==============================================================
            // ==                         Variable                         ==
            // ==============================================================
            {
                // Border
                [getCssVar('border-width')]: '1px',
                [getCssVar('border-color')]: '#000',
                [getCssVar('border-color-hover')]: `var(${getCssVar('border-color')})`,
                [getCssVar('border-color-active')]: `var(${getCssVar('border-color')})`,
                [getCssVar('border-color-disabled')]: `var(${getCssVar('border-color')})`,
                [getCssVar('border-style')]: 'solid',
                // Text
                [getCssVar('text-color')]: '#000',
                [getCssVar('text-color-hover')]: `var(${getCssVar('text-color')})`,
                [getCssVar('text-color-active')]: `var(${getCssVar('text-color')})`,
                [getCssVar('text-color-disabled')]: `var(${getCssVar('text-color')})`,
                // Background
                [getCssVar('bg-color')]: '#ddd',
                [getCssVar('bg-color-hover')]: `var(${getCssVar('bg-color')})`,
                [getCssVar('bg-color-active')]: `var(${getCssVar('bg-color')})`,
                [getCssVar('bg-color-disabled')]: token.colorBgContainerDisabled,
                [getCssVar('bg-color-container')]: token.colorBgContainer,
                // Shadow
                [getCssVar('shadow')]: 'none'
            },
            // ==============================================================
            // ==                         Template                         ==
            // ==============================================================
            {
                // Basic
                border: `var(${getCssVar('border-width')}) var(${getCssVar('border-style')}) var(${getCssVar('border-color')})`,
                color: `var(${getCssVar('text-color')})`,
                backgroundColor: `var(${getCssVar('bg-color')})`,
                // Status
                [`&:not(:disabled):not(${componentCls}-disabled)`]: {
                    // Hover
                    '&:hover': {
                        border: `var(${getCssVar('border-width')}) var(${getCssVar('border-style')}) var(${getCssVar('border-color-hover')})`,
                        color: `var(${getCssVar('text-color-hover')})`,
                        backgroundColor: `var(${getCssVar('bg-color-hover')})`
                    },
                    // Active
                    '&:active': {
                        border: `var(${getCssVar('border-width')}) var(${getCssVar('border-style')}) var(${getCssVar('border-color-active')})`,
                        color: `var(${getCssVar('text-color-active')})`,
                        backgroundColor: `var(${getCssVar('bg-color-active')})`
                    }
                }
            },
            // ==============================================================
            // ==                         Variants                         ==
            // ==============================================================
            {
                // >>>>> Solid
                [`&${componentCls}-variant-solid`]: {
                    // Solid Variables
                    [getCssVar('solid-bg-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('solid-bg-color-hover')]: `var(${getCssVar('color-hover')})`,
                    [getCssVar('solid-bg-color-active')]: `var(${getCssVar('color-active')})`,
                    // Variables
                    [getCssVar('border-color')]: 'transparent',
                    [getCssVar('text-color')]: token.colorTextLightSolid,
                    [getCssVar('bg-color')]: `var(${getCssVar('solid-bg-color')})`,
                    [getCssVar('bg-color-hover')]: `var(${getCssVar('solid-bg-color-hover')})`,
                    [getCssVar('bg-color-active')]: `var(${getCssVar('solid-bg-color-active')})`,
                    // Box Shadow
                    boxShadow: `var(${getCssVar('shadow')})`
                },
                // >>>>> Outlined & Dashed
                [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                    [getCssVar('border-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('border-color-hover')]: `var(${getCssVar('color-hover')})`,
                    [getCssVar('border-color-active')]: `var(${getCssVar('color-active')})`,
                    [getCssVar('bg-color')]: `var(${getCssVar('bg-color-container')})`,
                    [getCssVar('text-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('text-color-hover')]: `var(${getCssVar('color-hover')})`,
                    [getCssVar('text-color-active')]: `var(${getCssVar('color-active')})`,
                    // Box Shadow
                    boxShadow: `var(${getCssVar('shadow')})`
                },
                // >>>>> Dashed
                [`&${componentCls}-variant-dashed`]: {
                    [getCssVar('border-style')]: 'dashed',
                    [getCssVar('bg-color-disabled')]: token.dashedBgDisabled
                },
                // >>>>> Filled
                [`&${componentCls}-variant-filled`]: {
                    [getCssVar('border-color')]: 'transparent',
                    [getCssVar('text-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('bg-color')]: `var(${getCssVar('color-light')})`,
                    [getCssVar('bg-color-hover')]: `var(${getCssVar('color-light-hover')})`,
                    [getCssVar('bg-color-active')]: `var(${getCssVar('color-light-active')})`
                },
                // >>>>> Text & Link
                [`&${componentCls}-variant-text, &${componentCls}-variant-link`]: {
                    [getCssVar('border-color')]: 'transparent',
                    [getCssVar('text-color')]: `var(${getCssVar('color-base')})`,
                    [getCssVar('text-color-hover')]: `var(${getCssVar('color-hover')})`,
                    [getCssVar('text-color-active')]: `var(${getCssVar('color-active')})`,
                    [getCssVar('bg-color')]: 'transparent',
                    [getCssVar('bg-color-hover')]: 'transparent',
                    [getCssVar('bg-color-active')]: 'transparent',
                    [`&:disabled, &${token.componentCls}-disabled`]: {
                        background: 'transparent',
                        borderColor: 'transparent'
                    }
                },
                // >>>>> Text
                [`&${componentCls}-variant-text`]: {
                    [getCssVar('bg-color-hover')]: `var(${getCssVar('color-light')})`,
                    [getCssVar('bg-color-active')]: `var(${getCssVar('color-light-active')})`
                }
            },
            // ==============================================================
            // ==                          Colors                          ==
            // ==============================================================
            {
                // ======================== By Default ========================
                // >>>>> Link
                [`&${componentCls}-variant-link`]: {
                    [getCssVar('color-base')]: token.colorLink,
                    [getCssVar('color-hover')]: token.colorLinkHover,
                    [getCssVar('color-active')]: token.colorLinkActive
                },
                // ======================== Compatible ========================
                // >>>>> Primary
                [`&${componentCls}-color-primary`]: {
                    [getCssVar('color-base')]: token.colorPrimary,
                    [getCssVar('color-hover')]: token.colorPrimaryHover,
                    [getCssVar('color-active')]: token.colorPrimaryActive,
                    [getCssVar('color-light')]: token.colorPrimaryBg,
                    [getCssVar('color-light-hover')]: token.colorPrimaryBgHover,
                    [getCssVar('color-light-active')]: token.colorPrimaryBorder,
                    [getCssVar('shadow')]: token.primaryShadow,
                    [`&${componentCls}-variant-solid`]: {
                        [getCssVar('text-color')]: token.primaryColor,
                        [getCssVar('text-color-hover')]: `var(${getCssVar('text-color')})`,
                        [getCssVar('text-color-active')]: `var(${getCssVar('text-color')})`
                    }
                },
                // >>>>> Danger
                [`&${componentCls}-color-dangerous`]: {
                    [getCssVar('color-base')]: token.colorError,
                    [getCssVar('color-hover')]: token.colorErrorHover,
                    [getCssVar('color-active')]: token.colorErrorActive,
                    [getCssVar('color-light')]: token.colorErrorBg,
                    [getCssVar('color-light-hover')]: token.colorErrorBgFilledHover,
                    [getCssVar('color-light-active')]: token.colorErrorBgActive,
                    [getCssVar('shadow')]: token.dangerShadow,
                    [`&${componentCls}-variant-solid`]: {
                        [getCssVar('text-color')]: token.dangerColor,
                        [getCssVar('text-color-hover')]: `var(${getCssVar('text-color')})`,
                        [getCssVar('text-color-active')]: `var(${getCssVar('text-color')})`
                    }
                },
                // >>>>> Default
                [`&${componentCls}-color-default`]: {
                    [getCssVar('solid-bg-color')]: token.colorBgSolid,
                    [getCssVar('solid-bg-color-hover')]: token.colorBgSolidHover,
                    [getCssVar('solid-bg-color-active')]: token.colorBgSolidActive,
                    [getCssVar('color-base')]: token.defaultBorderColor,
                    [getCssVar('color-hover')]: token.defaultHoverBorderColor,
                    [getCssVar('color-active')]: token.defaultActiveBorderColor,
                    [getCssVar('color-light')]: token.colorFillTertiary,
                    [getCssVar('color-light-hover')]: token.colorFillSecondary,
                    [getCssVar('color-light-active')]: token.colorFill,
                    [getCssVar('text-color')]: token.colorText,
                    [getCssVar('text-color-hover')]: token.defaultHoverBorderColor,
                    [getCssVar('text-color-active')]: token.defaultActiveBorderColor,
                    [getCssVar('shadow')]: token.defaultShadow,
                    [`&${componentCls}-variant-solid`]: {
                        [getCssVar('text-color')]: token.solidTextColor,
                        [getCssVar('text-color-hover')]: `var(${getCssVar('text-color')})`,
                        [getCssVar('text-color-active')]: `var(${getCssVar('text-color')})`
                    },
                    [`&${componentCls}-variant-filled, &${componentCls}-variant-text`]: {
                        [getCssVar('text-color-hover')]: `var(${getCssVar('text-color')})`,
                        [getCssVar('text-color-active')]: `var(${getCssVar('text-color')})`
                    },
                    [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                        [getCssVar('bg-color-hover')]: token.defaultHoverBg,
                        [getCssVar('bg-color-active')]: token.defaultActiveBg
                    },
                    [`&${componentCls}-background-ghost`]: {
                        [`&${componentCls}-variant-outlined, &${componentCls}-variant-dashed`]: {
                            [getCssVar('text-color')]: token.defaultGhostColor,
                            [getCssVar('border-color')]: token.defaultGhostBorderColor
                        }
                    }
                }
            },
            // >>>>> Preset Colors
            (0, _interface.PresetColors).map((colorKey)=>{
                const darkColor = token[`${colorKey}6`];
                const lightColor = token[`${colorKey}1`];
                const hoverColor = token[`${colorKey}5`];
                const lightHoverColor = token[`${colorKey}2`];
                const lightActiveColor = token[`${colorKey}3`];
                const activeColor = token[`${colorKey}7`];
                const shadowColor = token[`${colorKey}ShadowColor`];
                return {
                    [`&${componentCls}-color-${colorKey}`]: {
                        [getCssVar('color-base')]: darkColor,
                        [getCssVar('color-hover')]: hoverColor,
                        [getCssVar('color-active')]: activeColor,
                        [getCssVar('color-light')]: lightColor,
                        [getCssVar('color-light-hover')]: lightHoverColor,
                        [getCssVar('color-light-active')]: lightActiveColor,
                        [getCssVar('shadow')]: shadowColor
                    }
                };
            }),
            // ==============================================================
            // ==                         Disabled                         ==
            // ==============================================================
            {
                // Disabled
                [`&:disabled, &${token.componentCls}-disabled`]: {
                    cursor: 'not-allowed',
                    borderColor: token.colorBorderDisabled,
                    background: `var(${getCssVar('bg-color-disabled')})`,
                    color: token.colorTextDisabled,
                    boxShadow: 'none'
                }
            },
            // ==============================================================
            // ==                          Ghost                           ==
            // ==============================================================
            {
                // Ghost
                [`&${componentCls}-background-ghost`]: {
                    [getCssVar('bg-color')]: 'transparent',
                    [getCssVar('shadow')]: 'none'
                }
            }
        ]
    };
};
exports.default = genVariantStyle;

},{"../../theme/interface":"aRwwT","../../theme/util/genStyleUtils":"eQVSZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"htkzc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _compactItem = require("../../style/compact-item");
var _compactItemVertical = require("../../style/compact-item-vertical");
var _internal = require("../../theme/internal");
var _token = require("./token");
const genButtonCompactStyle = (token)=>{
    const { componentCls, colorPrimaryHover, lineWidth, calc } = token;
    const insetOffset = calc(lineWidth).mul(-1).equal();
    const getCompactBorderStyle = (vertical)=>{
        const itemCls = `${componentCls}-compact${vertical ? '-vertical' : ''}-item`;
        const selector = `${itemCls}${componentCls}-primary:not([disabled])`;
        return {
            // TODO: Border color transition should be not cover when has color.
            [itemCls]: {
                transition: `none`
            },
            [`${selector} + ${selector}::before`]: {
                position: 'absolute',
                top: vertical ? insetOffset : 0,
                insetInlineStart: vertical ? 0 : insetOffset,
                backgroundColor: colorPrimaryHover,
                content: '""',
                width: vertical ? '100%' : lineWidth,
                height: vertical ? lineWidth : '100%'
            }
        };
    };
    // Special styles for Primary Button
    return {
        ...getCompactBorderStyle(),
        ...getCompactBorderStyle(true)
    };
};
// ============================== Export ==============================
exports.default = (0, _internal.genSubStyleComponent)([
    'Button',
    'compact'
], (token)=>{
    const buttonToken = (0, _token.prepareToken)(token);
    return [
        // Space Compact
        (0, _compactItem.genCompactItemStyle)(buttonToken),
        (0, _compactItemVertical.genCompactItemVerticalStyle)(buttonToken),
        genButtonCompactStyle(buttonToken)
    ];
}, (0, _token.prepareComponentToken));

},{"../../style/compact-item":"7EW6Y","../../style/compact-item-vertical":"5vnCI","../../theme/internal":"eQVSZ","./token":"hGgLT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7EW6Y":[function(require,module,exports,__globalThis) {
// handle border collapse
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genCompactItemStyle", ()=>genCompactItemStyle);
function compactItemBorder(token, parentCls, options, prefixCls) {
    const { focusElCls, focus, borderElCls } = options;
    const childCombinator = borderElCls ? '> *' : '';
    const hoverEffects = [
        'hover',
        focus ? 'focus' : null,
        'active'
    ].filter(Boolean).map((n)=>`&:${n} ${childCombinator}`).join(',');
    return {
        [`&-item:not(${parentCls}-last-item)`]: {
            marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        '&-item': {
            [hoverEffects]: {
                zIndex: 3
            },
            ...focusElCls ? {
                [`&${focusElCls}`]: {
                    zIndex: 3
                }
            } : {},
            [`&[disabled] ${childCombinator}`]: {
                zIndex: 0
            }
        }
    };
}
// handle border-radius
function compactItemBorderRadius(prefixCls, parentCls, options) {
    const { borderElCls } = options;
    const childCombinator = borderElCls ? `> ${borderElCls}` : '';
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
            borderRadius: 0
        },
        [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
            [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        }
    };
}
function genCompactItemStyle(token, options = {
    focus: true
}) {
    const { componentCls } = token;
    const { componentCls: customizePrefixCls } = options;
    const mergedComponentCls = customizePrefixCls || componentCls;
    const compactCls = `${mergedComponentCls}-compact`;
    return {
        [compactCls]: {
            ...compactItemBorder(token, compactCls, options, mergedComponentCls),
            ...compactItemBorderRadius(mergedComponentCls, compactCls, options)
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5vnCI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genCompactItemVerticalStyle", ()=>genCompactItemVerticalStyle);
function compactItemVerticalBorder(token, parentCls, prefixCls) {
    return {
        // border collapse
        [`&-item:not(${parentCls}-last-item)`]: {
            marginBottom: token.calc(token.lineWidth).mul(-1).equal()
        },
        [`&-item:not(${prefixCls}-status-success)`]: {
            zIndex: 2
        },
        '&-item': {
            '&:hover,&:focus,&:active': {
                zIndex: 3
            },
            '&[disabled]': {
                zIndex: 0
            }
        }
    };
}
function compactItemBorderVerticalRadius(prefixCls, parentCls) {
    return {
        [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
            borderRadius: 0
        },
        [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderEndEndRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
            [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
                borderStartStartRadius: 0,
                borderStartEndRadius: 0
            }
        }
    };
}
function genCompactItemVerticalStyle(token) {
    const compactCls = `${token.componentCls}-compact-vertical`;
    return {
        [compactCls]: {
            ...compactItemVerticalBorder(token, compactCls, token.componentCls),
            ...compactItemBorderVerticalRadius(token.componentCls, compactCls)
        }
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kY4DD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _confirm = require("./confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
var _destroyFns = require("./destroyFns");
var _destroyFnsDefault = parcelHelpers.interopDefault(_destroyFns);
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _purePanel = require("./PurePanel");
var _purePanelDefault = parcelHelpers.interopDefault(_purePanel);
var _useModal = require("./useModal");
var _useModalDefault = parcelHelpers.interopDefault(_useModal);
"use client";
function modalWarn(props) {
    return (0, _confirmDefault.default)((0, _confirm.withWarn)(props));
}
const Modal = (0, _modalDefault.default);
Modal.useModal = (0, _useModalDefault.default);
Modal.info = function infoFn(props) {
    return (0, _confirmDefault.default)((0, _confirm.withInfo)(props));
};
Modal.success = function successFn(props) {
    return (0, _confirmDefault.default)((0, _confirm.withSuccess)(props));
};
Modal.error = function errorFn(props) {
    return (0, _confirmDefault.default)((0, _confirm.withError)(props));
};
Modal.warning = modalWarn;
Modal.warn = modalWarn;
Modal.confirm = function confirmFn(props) {
    return (0, _confirmDefault.default)((0, _confirm.withConfirm)(props));
};
Modal.destroyAll = function destroyAllFn() {
    while((0, _destroyFnsDefault.default).length){
        const close = (0, _destroyFnsDefault.default).pop();
        if (close) close();
    }
};
Modal.config = (0, _confirm.modalGlobalConfig);
Modal._InternalPanelDoNotUseOrYouWillBeFired = (0, _purePanelDefault.default);
exports.default = Modal;

},{"./confirm":"h1iRk","./destroyFns":"doMnz","./Modal":"9thMQ","./PurePanel":"c51ue","./useModal":"fr0ja","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h1iRk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>confirm);
parcelHelpers.export(exports, "withWarn", ()=>withWarn);
parcelHelpers.export(exports, "withInfo", ()=>withInfo);
parcelHelpers.export(exports, "withSuccess", ()=>withSuccess);
parcelHelpers.export(exports, "withError", ()=>withError);
parcelHelpers.export(exports, "withConfirm", ()=>withConfirm);
parcelHelpers.export(exports, "modalGlobalConfig", ()=>modalGlobalConfig);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _render = require("@rc-component/util/es/React/render");
var _warning = require("../_util/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _configProvider = require("../config-provider");
var _configProviderDefault = parcelHelpers.interopDefault(_configProvider);
var _confirmDialog = require("./ConfirmDialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
var _destroyFns = require("./destroyFns");
var _destroyFnsDefault = parcelHelpers.interopDefault(_destroyFns);
var _locale = require("./locale");
"use client";
let defaultRootPrefixCls = '';
function getRootPrefixCls() {
    return defaultRootPrefixCls;
}
const ConfirmDialogWrapper = (props)=>{
    const { prefixCls: customizePrefixCls, getContainer, direction } = props;
    const runtimeLocale = (0, _locale.getConfirmLocale)();
    const config = (0, _react.useContext)((0, _configProvider.ConfigContext));
    const rootPrefixCls = getRootPrefixCls() || config.getPrefixCls();
    // because Modal.config set rootPrefixCls, which is different from other components
    const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
    let mergedGetContainer = getContainer;
    if (mergedGetContainer === false) mergedGetContainer = undefined;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _confirmDialogDefault.default), {
        ...props,
        rootPrefixCls: rootPrefixCls,
        prefixCls: prefixCls,
        iconPrefixCls: config.iconPrefixCls,
        theme: config.theme,
        direction: direction ?? config.direction,
        locale: config.locale?.Modal ?? runtimeLocale,
        getContainer: mergedGetContainer
    });
};
function confirm(config) {
    const global = (0, _configProvider.globalConfig)();
    const container = document.createDocumentFragment();
    let currentConfig = {
        ...config,
        close,
        open: true
    };
    let timeoutId;
    function destroy(...args) {
        const triggerCancel = args.some((param)=>param?.triggerCancel);
        if (triggerCancel) config.onCancel?.(()=>{}, ...args.slice(1));
        for(let i = 0; i < (0, _destroyFnsDefault.default).length; i++){
            const fn = (0, _destroyFnsDefault.default)[i];
            if (fn === close) {
                (0, _destroyFnsDefault.default).splice(i, 1);
                break;
            }
        }
        (0, _render.unmount)(container).then(()=>{
        // Do nothing
        });
    }
    const scheduleRender = (props)=>{
        clearTimeout(timeoutId);
        /**
     * https://github.com/ant-design/ant-design/issues/23623
     *
     * Sync render blocks React event. Let's make this async.
     */ timeoutId = setTimeout(()=>{
            const rootPrefixCls = global.getPrefixCls(undefined, getRootPrefixCls());
            const iconPrefixCls = global.getIconPrefixCls();
            const theme = global.getTheme();
            const dom = /*#__PURE__*/ (0, _reactDefault.default).createElement(ConfirmDialogWrapper, {
                ...props
            });
            (0, _render.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _configProviderDefault.default), {
                prefixCls: rootPrefixCls,
                iconPrefixCls: iconPrefixCls,
                theme: theme
            }, typeof global.holderRender === 'function' ? global.holderRender(dom) : dom), container);
        });
    };
    function close(...args) {
        currentConfig = {
            ...currentConfig,
            open: false,
            afterClose: ()=>{
                if (typeof config.afterClose === 'function') config.afterClose();
                // @ts-ignore
                destroy.apply(this, args);
            }
        };
        scheduleRender(currentConfig);
    }
    function update(configUpdate) {
        if (typeof configUpdate === 'function') currentConfig = configUpdate(currentConfig);
        else currentConfig = {
            ...currentConfig,
            ...configUpdate
        };
        scheduleRender(currentConfig);
    }
    scheduleRender(currentConfig);
    (0, _destroyFnsDefault.default).push(close);
    return {
        destroy: close,
        update
    };
}
function withWarn(props) {
    return {
        ...props,
        type: 'warning'
    };
}
function withInfo(props) {
    return {
        ...props,
        type: 'info'
    };
}
function withSuccess(props) {
    return {
        ...props,
        type: 'success'
    };
}
function withError(props) {
    return {
        ...props,
        type: 'error'
    };
}
function withConfirm(props) {
    return {
        ...props,
        type: 'confirm'
    };
}
function modalGlobalConfig({ rootPrefixCls }) {
    defaultRootPrefixCls = rootPrefixCls;
}

},{"react":"bmhQu","@rc-component/util/es/React/render":"jackC","../_util/warning":"95o3w","../config-provider":"dVeAX","./ConfirmDialog":"jah84","./destroyFns":"doMnz","./locale":"1mpkH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jah84":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConfirmContent", ()=>ConfirmContent);
var _react = require("react");
var _checkCircleFilled = require("@ant-design/icons/es/icons/CheckCircleFilled");
var _checkCircleFilledDefault = parcelHelpers.interopDefault(_checkCircleFilled);
var _closeCircleFilled = require("@ant-design/icons/es/icons/CloseCircleFilled");
var _closeCircleFilledDefault = parcelHelpers.interopDefault(_closeCircleFilled);
var _exclamationCircleFilled = require("@ant-design/icons/es/icons/ExclamationCircleFilled");
var _exclamationCircleFilledDefault = parcelHelpers.interopDefault(_exclamationCircleFilled);
var _infoCircleFilled = require("@ant-design/icons/es/icons/InfoCircleFilled");
var _infoCircleFilledDefault = parcelHelpers.interopDefault(_infoCircleFilled);
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _motion = require("../_util/motion");
var _warning = require("../_util/warning");
var _configProvider = require("../config-provider");
var _configProviderDefault = parcelHelpers.interopDefault(_configProvider);
var _context = require("../config-provider/context");
var _locale = require("../locale");
var _useToken = require("../theme/useToken");
var _useTokenDefault = parcelHelpers.interopDefault(_useToken);
var _confirmCancelBtn = require("./components/ConfirmCancelBtn");
var _confirmCancelBtnDefault = parcelHelpers.interopDefault(_confirmCancelBtn);
var _confirmOkBtn = require("./components/ConfirmOkBtn");
var _confirmOkBtnDefault = parcelHelpers.interopDefault(_confirmOkBtn);
var _context1 = require("./context");
var _modal = require("./Modal");
var _modalDefault = parcelHelpers.interopDefault(_modal);
var _confirm = require("./style/confirm");
var _confirmDefault = parcelHelpers.interopDefault(_confirm);
"use client";
const ConfirmContent = (props)=>{
    const { prefixCls, icon, okText, cancelText, confirmPrefixCls, type, okCancel, footer, // Legacy for static function usage
    locale: staticLocale, ...restProps } = props;
    // Icon
    let mergedIcon = icon;
    // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
    if (!icon && icon !== null) switch(type){
        case 'info':
            mergedIcon = /*#__PURE__*/ _react.createElement((0, _infoCircleFilledDefault.default), null);
            break;
        case 'success':
            mergedIcon = /*#__PURE__*/ _react.createElement((0, _checkCircleFilledDefault.default), null);
            break;
        case 'error':
            mergedIcon = /*#__PURE__*/ _react.createElement((0, _closeCircleFilledDefault.default), null);
            break;
        default:
            mergedIcon = /*#__PURE__*/ _react.createElement((0, _exclamationCircleFilledDefault.default), null);
    }
    // 默认为 true，保持向下兼容
    const mergedOkCancel = okCancel ?? type === 'confirm';
    const autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
    const [locale] = (0, _locale.useLocale)('Modal');
    const mergedLocale = staticLocale || locale;
    // ================== Locale Text ==================
    const okTextLocale = okText || (mergedOkCancel ? mergedLocale?.okText : mergedLocale?.justOkText);
    const cancelTextLocale = cancelText || mergedLocale?.cancelText;
    // ================= Context Value =================
    const { closable } = restProps;
    const { onClose } = closable && typeof closable === 'object' ? closable : {};
    const memoizedValue = _react.useMemo(()=>{
        return {
            autoFocusButton,
            cancelTextLocale,
            okTextLocale,
            mergedOkCancel,
            onClose,
            ...restProps
        };
    }, [
        autoFocusButton,
        cancelTextLocale,
        okTextLocale,
        mergedOkCancel,
        onClose,
        restProps
    ]);
    // ====================== Footer Origin Node ======================
    const footerOriginNode = /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _confirmCancelBtnDefault.default), null), /*#__PURE__*/ _react.createElement((0, _confirmOkBtnDefault.default), null));
    const hasTitle = props.title !== undefined && props.title !== null;
    const bodyCls = `${confirmPrefixCls}-body`;
    return /*#__PURE__*/ _react.createElement("div", {
        className: `${confirmPrefixCls}-body-wrapper`
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(bodyCls, {
            [`${bodyCls}-has-title`]: hasTitle
        })
    }, mergedIcon, /*#__PURE__*/ _react.createElement("div", {
        className: `${confirmPrefixCls}-paragraph`
    }, hasTitle && /*#__PURE__*/ _react.createElement("span", {
        className: `${confirmPrefixCls}-title`
    }, props.title), /*#__PURE__*/ _react.createElement("div", {
        className: `${confirmPrefixCls}-content`
    }, props.content))), footer === undefined || typeof footer === 'function' ? /*#__PURE__*/ _react.createElement((0, _context1.ModalContextProvider), {
        value: memoizedValue
    }, /*#__PURE__*/ _react.createElement("div", {
        className: `${confirmPrefixCls}-btns`
    }, typeof footer === 'function' ? footer(footerOriginNode, {
        OkBtn: (0, _confirmOkBtnDefault.default),
        CancelBtn: (0, _confirmCancelBtnDefault.default)
    }) : footerOriginNode)) : footer, /*#__PURE__*/ _react.createElement((0, _confirmDefault.default), {
        prefixCls: prefixCls
    }));
};
const ConfirmDialog = (props)=>{
    const { close, zIndex, maskStyle, direction, prefixCls, wrapClassName, rootPrefixCls, bodyStyle, closable = false, onConfirm, styles, title, okButtonProps, cancelButtonProps } = props;
    const { cancelButtonProps: contextCancelButtonProps, okButtonProps: contextOkButtonProps } = (0, _context.useComponentConfig)('modal');
    var deprecatedName, newName;
    const confirmPrefixCls = `${prefixCls}-confirm`;
    const width = props.width || 416;
    const style = props.style || {};
    // 默认为 false，保持旧版默认行为
    const maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
    const classString = (0, _clsx.clsx)(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
        [`${confirmPrefixCls}-rtl`]: direction === 'rtl'
    }, props.className);
    // ========================= zIndex =========================
    const [, token] = (0, _useTokenDefault.default)();
    const mergedZIndex = _react.useMemo(()=>{
        if (zIndex !== undefined) return zIndex;
        // Static always use max zIndex
        return token.zIndexPopupBase + (0, _hooks.CONTAINER_MAX_OFFSET);
    }, [
        zIndex,
        token
    ]);
    // ========================= Render =========================
    return /*#__PURE__*/ _react.createElement((0, _modalDefault.default), {
        ...props,
        className: classString,
        wrapClassName: (0, _clsx.clsx)({
            [`${confirmPrefixCls}-centered`]: !!props.centered
        }, wrapClassName),
        onCancel: ()=>{
            close?.({
                triggerCancel: true
            });
            onConfirm?.(false);
        },
        title: title,
        footer: null,
        transitionName: (0, _motion.getTransitionName)(rootPrefixCls || '', 'zoom', props.transitionName),
        maskTransitionName: (0, _motion.getTransitionName)(rootPrefixCls || '', 'fade', props.maskTransitionName),
        maskClosable: maskClosable,
        style: style,
        styles: {
            body: bodyStyle,
            mask: maskStyle,
            ...styles
        },
        width: width,
        zIndex: mergedZIndex,
        closable: closable
    }, /*#__PURE__*/ _react.createElement(ConfirmContent, {
        ...props,
        confirmPrefixCls: confirmPrefixCls,
        okButtonProps: {
            ...contextOkButtonProps,
            ...okButtonProps
        },
        cancelButtonProps: {
            ...contextCancelButtonProps,
            ...cancelButtonProps
        }
    }));
};
const ConfirmDialogWrapper = (props)=>{
    const { rootPrefixCls, iconPrefixCls, direction, theme } = props;
    return /*#__PURE__*/ _react.createElement((0, _configProviderDefault.default), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: iconPrefixCls,
        direction: direction,
        theme: theme
    }, /*#__PURE__*/ _react.createElement(ConfirmDialog, {
        ...props
    }));
};
exports.default = ConfirmDialogWrapper;

},{"react":"bmhQu","@ant-design/icons/es/icons/CheckCircleFilled":"gk31P","@ant-design/icons/es/icons/CloseCircleFilled":"d3fPr","@ant-design/icons/es/icons/ExclamationCircleFilled":"24nhX","@ant-design/icons/es/icons/InfoCircleFilled":"aiTER","clsx":"431Ou","../_util/hooks":"6noQ6","../_util/motion":"kUUSo","../_util/warning":"95o3w","../config-provider":"dVeAX","../config-provider/context":"75zwC","../locale":[["useLocale","l6QvX","default"]],"../theme/useToken":"6x222","./components/ConfirmCancelBtn":"cuYyL","./components/ConfirmOkBtn":"7gbj5","./context":"WhlqL","./Modal":"9thMQ","./style/confirm":"9yFVZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gk31P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _checkCircleFilled = require("@ant-design/icons-svg/es/asn/CheckCircleFilled");
var _checkCircleFilledDefault = parcelHelpers.interopDefault(_checkCircleFilled);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const CheckCircleFilled = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _checkCircleFilledDefault.default)
    }));
/**![check-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xOTMuNSAzMDEuN2wtMjEwLjYgMjkyYTMxLjggMzEuOCAwIDAxLTUxLjcgMEwzMTguNSA0ODQuOWMtMy44LTUuMyAwLTEyLjcgNi41LTEyLjdoNDYuOWMxMC4yIDAgMTkuOSA0LjkgMjUuOSAxMy4zbDcxLjIgOTguOCAxNTcuMi0yMThjNi04LjMgMTUuNi0xMy4zIDI1LjktMTMuM0g2OTljNi41IDAgMTAuMyA3LjQgNi41IDEyLjd6IiAvPjwvc3ZnPg==) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(CheckCircleFilled);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/CheckCircleFilled":"46KLu","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"46KLu":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var CheckCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z"
                }
            }
        ]
    },
    "name": "check-circle",
    "theme": "filled"
};
exports.default = CheckCircleFilled;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d3fPr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _closeCircleFilled = require("@ant-design/icons-svg/es/asn/CloseCircleFilled");
var _closeCircleFilledDefault = parcelHelpers.interopDefault(_closeCircleFilled);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const CloseCircleFilled = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _closeCircleFilledDefault.default)
    }));
/**![close-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNTEyIDY0YzI0Ny40IDAgNDQ4IDIwMC42IDQ0OCA0NDhTNzU5LjQgOTYwIDUxMiA5NjAgNjQgNzU5LjQgNjQgNTEyIDI2NC42IDY0IDUxMiA2NHptMTI3Ljk4IDI3NC44MmgtLjA0bC0uMDguMDZMNTEyIDQ2Ni43NSAzODQuMTQgMzM4Ljg4Yy0uMDQtLjA1LS4wNi0uMDYtLjA4LS4wNmEuMTIuMTIgMCAwMC0uMDcgMGMtLjAzIDAtLjA1LjAxLS4wOS4wNWwtNDUuMDIgNDUuMDJhLjIuMiAwIDAwLS4wNS4wOS4xMi4xMiAwIDAwMCAuMDd2LjAyYS4yNy4yNyAwIDAwLjA2LjA2TDQ2Ni43NSA1MTIgMzM4Ljg4IDYzOS44NmMtLjA1LjA0LS4wNi4wNi0uMDYuMDhhLjEyLjEyIDAgMDAwIC4wN2MwIC4wMy4wMS4wNS4wNS4wOWw0NS4wMiA0NS4wMmEuMi4yIDAgMDAuMDkuMDUuMTIuMTIgMCAwMC4wNyAwYy4wMiAwIC4wNC0uMDEuMDgtLjA1TDUxMiA1NTcuMjVsMTI3Ljg2IDEyNy44N2MuMDQuMDQuMDYuMDUuMDguMDVhLjEyLjEyIDAgMDAuMDcgMGMuMDMgMCAuMDUtLjAxLjA5LS4wNWw0NS4wMi00NS4wMmEuMi4yIDAgMDAuMDUtLjA5LjEyLjEyIDAgMDAwLS4wN3YtLjAyYS4yNy4yNyAwIDAwLS4wNS0uMDZMNTU3LjI1IDUxMmwxMjcuODctMTI3Ljg2Yy4wNC0uMDQuMDUtLjA2LjA1LS4wOGEuMTIuMTIgMCAwMDAtLjA3YzAtLjAzLS4wMS0uMDUtLjA1LS4wOWwtNDUuMDItNDUuMDJhLjIuMiAwIDAwLS4wOS0uMDUuMTIuMTIgMCAwMC0uMDcgMHoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(CloseCircleFilled);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/CloseCircleFilled":"jPDei","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jPDei":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var CloseCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z"
                }
            }
        ]
    },
    "name": "close-circle",
    "theme": "filled"
};
exports.default = CloseCircleFilled;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"24nhX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _exclamationCircleFilled = require("@ant-design/icons-svg/es/asn/ExclamationCircleFilled");
var _exclamationCircleFilledDefault = parcelHelpers.interopDefault(_exclamationCircleFilled);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const ExclamationCircleFilled = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _exclamationCircleFilledDefault.default)
    }));
/**![exclamation-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0tMzIgMjMyYzAtNC40IDMuNi04IDgtOGg0OGM0LjQgMCA4IDMuNiA4IDh2MjcyYzAgNC40LTMuNiA4LTggOGgtNDhjLTQuNCAwLTgtMy42LTgtOFYyOTZ6bTMyIDQ0MGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(ExclamationCircleFilled);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/ExclamationCircleFilled":"jVSfm","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jVSfm":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var ExclamationCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "exclamation-circle",
    "theme": "filled"
};
exports.default = ExclamationCircleFilled;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aiTER":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _infoCircleFilled = require("@ant-design/icons-svg/es/asn/InfoCircleFilled");
var _infoCircleFilledDefault = parcelHelpers.interopDefault(_infoCircleFilled);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const InfoCircleFilled = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _infoCircleFilledDefault.default)
    }));
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0zMiA2NjRjMCA0LjQtMy42IDgtOCA4aC00OGMtNC40IDAtOC0zLjYtOC04VjQ1NmMwLTQuNCAzLjYtOCA4LThoNDhjNC40IDAgOCAzLjYgOCA4djI3MnptLTMyLTM0NGE0OC4wMSA0OC4wMSAwIDAxMC05NiA0OC4wMSA0OC4wMSAwIDAxMCA5NnoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(InfoCircleFilled);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/InfoCircleFilled":"4hxai","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4hxai":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var InfoCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "filled"
};
exports.default = InfoCircleFilled;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cuYyL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _actionButton = require("../../_util/ActionButton");
var _actionButtonDefault = parcelHelpers.interopDefault(_actionButton);
var _context = require("../context");
"use client";
const ConfirmCancelBtn = ()=>{
    const { autoFocusButton, cancelButtonProps, cancelTextLocale, isSilent, mergedOkCancel, rootPrefixCls, close, onCancel, onConfirm, onClose } = (0, _react.useContext)((0, _context.ModalContext));
    return mergedOkCancel ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionButtonDefault.default), {
        isSilent: isSilent,
        actionFn: onCancel,
        close: (...args)=>{
            close?.(...args);
            onConfirm?.(false);
            onClose?.();
        },
        autoFocus: autoFocusButton === 'cancel',
        buttonProps: cancelButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, cancelTextLocale) : null;
};
exports.default = ConfirmCancelBtn;

},{"react":"bmhQu","../../_util/ActionButton":"id9qh","../context":"WhlqL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"id9qh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useState = require("@rc-component/util/es/hooks/useState");
var _useStateDefault = parcelHelpers.interopDefault(_useState);
var _button = require("../button/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonHelpers = require("../button/buttonHelpers");
"use client";
const isThenable = (thing)=>{
    return typeof thing?.then === 'function';
};
const ActionButton = (props)=>{
    const { type, children, prefixCls, buttonProps, close, autoFocus, emitEvent, isSilent, quitOnNullishReturnValue, actionFn } = props;
    const clickedRef = _react.useRef(false);
    const buttonRef = _react.useRef(null);
    const [loading, setLoading] = (0, _useStateDefault.default)(false);
    const onInternalClose = (...args)=>{
        close?.(...args);
    };
    _react.useEffect(()=>{
        let timeoutId = null;
        if (autoFocus) timeoutId = setTimeout(()=>{
            buttonRef.current?.focus({
                preventScroll: true
            });
        });
        return ()=>{
            if (timeoutId) clearTimeout(timeoutId);
        };
    }, [
        autoFocus
    ]);
    const handlePromiseOnOk = (returnValueOfOnOk)=>{
        if (!isThenable(returnValueOfOnOk)) return;
        setLoading(true);
        returnValueOfOnOk.then((...args)=>{
            setLoading(false, true);
            onInternalClose.apply(void 0, args);
            clickedRef.current = false;
        }, (e)=>{
            // See: https://github.com/ant-design/ant-design/issues/6183
            setLoading(false, true);
            clickedRef.current = false;
            // Do not throw if is `await` mode
            if (isSilent?.()) return;
            return Promise.reject(e);
        });
    };
    const onClick = (e)=>{
        if (clickedRef.current) return;
        clickedRef.current = true;
        if (!actionFn) {
            onInternalClose();
            return;
        }
        let returnValueOfOnOk;
        if (emitEvent) {
            returnValueOfOnOk = actionFn(e);
            if (quitOnNullishReturnValue && !isThenable(returnValueOfOnOk)) {
                clickedRef.current = false;
                onInternalClose(e);
                return;
            }
        } else if (actionFn.length) {
            returnValueOfOnOk = actionFn(close);
            // https://github.com/ant-design/ant-design/issues/23358
            clickedRef.current = false;
        } else {
            returnValueOfOnOk = actionFn();
            if (!isThenable(returnValueOfOnOk)) {
                onInternalClose();
                return;
            }
        }
        handlePromiseOnOk(returnValueOfOnOk);
    };
    return /*#__PURE__*/ _react.createElement((0, _buttonDefault.default), {
        ...(0, _buttonHelpers.convertLegacyProps)(type),
        onClick: onClick,
        loading: loading,
        prefixCls: prefixCls,
        ...buttonProps,
        ref: buttonRef
    }, children);
};
exports.default = ActionButton;

},{"react":"bmhQu","@rc-component/util/es/hooks/useState":"lIOMx","../button/Button":"gfWzz","../button/buttonHelpers":"2L4bZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"WhlqL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ModalContext", ()=>ModalContext);
parcelHelpers.export(exports, "ModalContextProvider", ()=>ModalContextProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ModalContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});
const { Provider: ModalContextProvider } = ModalContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7gbj5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _actionButton = require("../../_util/ActionButton");
var _actionButtonDefault = parcelHelpers.interopDefault(_actionButton);
var _context = require("../context");
"use client";
const ConfirmOkBtn = ()=>{
    const { autoFocusButton, close, isSilent, okButtonProps, rootPrefixCls, okTextLocale, okType, onConfirm, onOk, onClose } = (0, _react.useContext)((0, _context.ModalContext));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _actionButtonDefault.default), {
        isSilent: isSilent,
        type: okType || 'primary',
        actionFn: onOk,
        close: (...args)=>{
            close?.(...args);
            onConfirm?.(true);
            onClose?.();
        },
        autoFocus: autoFocusButton === 'ok',
        buttonProps: okButtonProps,
        prefixCls: `${rootPrefixCls}-btn`
    }, okTextLocale);
};
exports.default = ConfirmOkBtn;

},{"react":"bmhQu","../../_util/ActionButton":"id9qh","../context":"WhlqL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9thMQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _closeOutlined = require("@ant-design/icons/es/icons/CloseOutlined");
var _closeOutlinedDefault = parcelHelpers.interopDefault(_closeOutlined);
var _dialog = require("@rc-component/dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
var _ref = require("@rc-component/util/es/ref");
var _clsx = require("clsx");
var _contextIsolator = require("../_util/ContextIsolator");
var _contextIsolatorDefault = parcelHelpers.interopDefault(_contextIsolator);
var _hooks = require("../_util/hooks");
var _motion = require("../_util/motion");
var _styleChecker = require("../_util/styleChecker");
var _warning = require("../_util/warning");
var _zindexContext = require("../_util/zindexContext");
var _zindexContextDefault = parcelHelpers.interopDefault(_zindexContext);
var _configProvider = require("../config-provider");
var _context = require("../config-provider/context");
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _skeleton = require("../skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
var _context1 = require("../watermark/context");
var _shared = require("./shared");
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
let mousePosition;
// ref: https://github.com/ant-design/ant-design/issues/15795
const getClickPosition = (e)=>{
    mousePosition = {
        x: e.pageX,
        y: e.pageY
    };
    // 100ms 内发生过点击事件，则从点击位置动画展示
    // 否则直接 zoom 展示
    // 这样可以兼容非点击方式展开
    setTimeout(()=>{
        mousePosition = null;
    }, 100);
};
// 只有点击事件支持从鼠标位置动画展开
if ((0, _styleChecker.canUseDocElement)()) document.documentElement.addEventListener('click', getClickPosition, true);
const Modal = (props)=>{
    const { prefixCls: customizePrefixCls, className, rootClassName, open, wrapClassName, centered, getContainer, focusTriggerAfterClose = true, style, width = 520, footer, classNames, styles, children, loading, confirmLoading, zIndex: customizeZIndex, mousePosition: customizeMousePosition, onOk, onCancel, okButtonProps, cancelButtonProps, destroyOnHidden, destroyOnClose, panelRef = null, closable, mask: modalMask, modalRender, ...restProps } = props;
    const { getPopupContainer: getContextPopupContainer, getPrefixCls, direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, centered: contextCentered, cancelButtonProps: contextCancelButtonProps, okButtonProps: contextOkButtonProps, mask: contextMask } = (0, _context.useComponentConfig)('modal');
    const { modal: modalContext } = _react.useContext((0, _configProvider.ConfigContext));
    const [closableAfterclose, onClose] = _react.useMemo(()=>{
        if (typeof closable === 'boolean') return [
            undefined,
            undefined
        ];
        return [
            closable?.afterClose,
            closable?.onClose
        ];
    }, [
        closable
    ]);
    const prefixCls = getPrefixCls('modal', customizePrefixCls);
    const rootPrefixCls = getPrefixCls();
    const [mergedMask, maskBlurClassName] = (0, _hooks.useMergedMask)(modalMask, contextMask, prefixCls);
    const handleCancel = (e)=>{
        if (confirmLoading) return;
        onCancel?.(e);
        onClose?.();
    };
    const handleOk = (e)=>{
        onOk?.(e);
        onClose?.();
    };
    var deprecatedName, newName;
    // Style
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
    const wrapClassNameExtended = (0, _clsx.clsx)(wrapClassName, {
        [`${prefixCls}-centered`]: centered ?? contextCentered,
        [`${prefixCls}-wrap-rtl`]: direction === 'rtl'
    });
    const dialogFooter = footer !== null && !loading ? /*#__PURE__*/ _react.createElement((0, _shared.Footer), {
        ...props,
        okButtonProps: {
            ...contextOkButtonProps,
            ...okButtonProps
        },
        onOk: handleOk,
        cancelButtonProps: {
            ...contextCancelButtonProps,
            ...cancelButtonProps
        },
        onCancel: handleCancel
    }) : null;
    const [rawClosable, mergedCloseIcon, closeBtnIsDisabled, ariaProps] = (0, _hooks.useClosable)((0, _hooks.pickClosable)(props), (0, _hooks.pickClosable)(modalContext), {
        closable: true,
        closeIcon: /*#__PURE__*/ _react.createElement((0, _closeOutlinedDefault.default), {
            className: `${prefixCls}-close-icon`
        }),
        closeIconRender: (icon)=>(0, _shared.renderCloseIcon)(prefixCls, icon)
    });
    const mergedClosable = rawClosable ? {
        disabled: closeBtnIsDisabled,
        closeIcon: mergedCloseIcon,
        afterClose: closableAfterclose,
        ...ariaProps
    } : false;
    // ============================ modalRender ============================
    const mergedModalRender = modalRender ? (node)=>/*#__PURE__*/ _react.createElement("div", {
            className: `${prefixCls}-render`
        }, modalRender(node)) : undefined;
    // ============================ Refs ============================
    // Select `ant-modal-container` by `panelRef`
    const panelClassName = `.${prefixCls}-${modalRender ? 'render' : 'container'}`;
    const innerPanelRef = (0, _context1.usePanelRef)(panelClassName);
    const mergedPanelRef = (0, _ref.composeRef)(panelRef, innerPanelRef);
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, _hooks.useZIndex)('Modal', customizeZIndex);
    const mergedProps = {
        ...props,
        width,
        panelRef,
        focusTriggerAfterClose,
        mask: mergedMask,
        zIndex
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames,
        maskBlurClassName
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // =========================== Width ============================
    const [numWidth, responsiveWidth] = _react.useMemo(()=>{
        if (width && typeof width === 'object') return [
            undefined,
            width
        ];
        return [
            width,
            undefined
        ];
    }, [
        width
    ]);
    const responsiveWidthVars = _react.useMemo(()=>{
        const vars = {};
        if (responsiveWidth) Object.keys(responsiveWidth).forEach((breakpoint)=>{
            const breakpointWidth = responsiveWidth[breakpoint];
            if (breakpointWidth !== undefined) vars[`--${prefixCls}-${breakpoint}-width`] = typeof breakpointWidth === 'number' ? `${breakpointWidth}px` : breakpointWidth;
        });
        return vars;
    }, [
        prefixCls,
        responsiveWidth
    ]);
    // =========================== Render ===========================
    return /*#__PURE__*/ _react.createElement((0, _contextIsolatorDefault.default), {
        form: true,
        space: true
    }, /*#__PURE__*/ _react.createElement((0, _zindexContextDefault.default).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ _react.createElement((0, _dialogDefault.default), {
        width: numWidth,
        ...restProps,
        zIndex: zIndex,
        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
        prefixCls: prefixCls,
        rootClassName: (0, _clsx.clsx)(hashId, rootClassName, cssVarCls, rootCls, mergedClassNames.root),
        rootStyle: mergedStyles.root,
        footer: dialogFooter,
        visible: open,
        mousePosition: customizeMousePosition ?? mousePosition,
        onClose: handleCancel,
        closable: mergedClosable,
        closeIcon: mergedCloseIcon,
        focusTriggerAfterClose: focusTriggerAfterClose,
        transitionName: (0, _motion.getTransitionName)(rootPrefixCls, 'zoom', props.transitionName),
        maskTransitionName: (0, _motion.getTransitionName)(rootPrefixCls, 'fade', props.maskTransitionName),
        mask: mergedMask,
        className: (0, _clsx.clsx)(hashId, className, contextClassName),
        style: {
            ...contextStyle,
            ...style,
            ...responsiveWidthVars
        },
        classNames: {
            ...mergedClassNames,
            wrapper: (0, _clsx.clsx)(mergedClassNames.wrapper, wrapClassNameExtended)
        },
        styles: mergedStyles,
        panelRef: mergedPanelRef,
        destroyOnHidden: destroyOnHidden ?? destroyOnClose,
        modalRender: mergedModalRender
    }, loading ? /*#__PURE__*/ _react.createElement((0, _skeletonDefault.default), {
        active: true,
        title: false,
        paragraph: {
            rows: 4
        },
        className: `${prefixCls}-body-skeleton`
    }) : children)));
};
exports.default = Modal;

},{"react":"bmhQu","@ant-design/icons/es/icons/CloseOutlined":"dinn5","@rc-component/dialog":"gTxjZ","@rc-component/util/es/ref":"jmzjd","clsx":"431Ou","../_util/ContextIsolator":"5aVQ9","../_util/hooks":[["pickClosable","cC5so"],["useClosable","cC5so"],["useMergedMask","86SlP"],["useMergeSemantic","kdnMA"],["useZIndex","6noQ6"]],"../_util/motion":"kUUSo","../_util/styleChecker":"6dMz0","../_util/warning":"95o3w","../_util/zindexContext":"e9ihh","../config-provider":"dVeAX","../config-provider/context":"75zwC","../config-provider/hooks/useCSSVarCls":"gcu2s","../skeleton":"dlSQX","../watermark/context":"6gIqj","./shared":"2rdgW","./style":"czUgw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dinn5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _closeOutlined = require("@ant-design/icons-svg/es/asn/CloseOutlined");
var _closeOutlinedDefault = parcelHelpers.interopDefault(_closeOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const CloseOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _closeOutlinedDefault.default)
    }));
/**![close](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIGZpbGwtcnVsZT0iZXZlbm9kZCIgdmlld0JveD0iNjQgNjQgODk2IDg5NiIgZm9jdXNhYmxlPSJmYWxzZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNNzk5Ljg2IDE2Ni4zMWMuMDIgMCAuMDQuMDIuMDguMDZsNTcuNjkgNTcuN2MuMDQuMDMuMDUuMDUuMDYuMDhhLjEyLjEyIDAgMDEwIC4wNmMwIC4wMy0uMDIuMDUtLjA2LjA5TDU2OS45MyA1MTJsMjg3LjcgMjg3LjdjLjA0LjA0LjA1LjA2LjA2LjA5YS4xMi4xMiAwIDAxMCAuMDdjMCAuMDItLjAyLjA0LS4wNi4wOGwtNTcuNyA1Ny42OWMtLjAzLjA0LS4wNS4wNS0uMDcuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMyAwLS4wNS0uMDItLjA5LS4wNkw1MTIgNTY5LjkzbC0yODcuNyAyODcuN2MtLjA0LjA0LS4wNi4wNS0uMDkuMDZhLjEyLjEyIDAgMDEtLjA3IDBjLS4wMiAwLS4wNC0uMDItLjA4LS4wNmwtNTcuNjktNTcuN2MtLjA0LS4wMy0uMDUtLjA1LS4wNi0uMDdhLjEyLjEyIDAgMDEwLS4wN2MwLS4wMy4wMi0uMDUuMDYtLjA5TDQ1NC4wNyA1MTJsLTI4Ny43LTI4Ny43Yy0uMDQtLjA0LS4wNS0uMDYtLjA2LS4wOWEuMTIuMTIgMCAwMTAtLjA3YzAtLjAyLjAyLS4wNC4wNi0uMDhsNTcuNy01Ny42OWMuMDMtLjA0LjA1LS4wNS4wNy0uMDZhLjEyLjEyIDAgMDEuMDcgMGMuMDMgMCAuMDUuMDIuMDkuMDZMNTEyIDQ1NC4wN2wyODcuNy0yODcuN2MuMDQtLjA0LjA2LS4wNS4wOS0uMDZhLjEyLjEyIDAgMDEuMDcgMHoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(CloseOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/CloseOutlined":"l5tfl","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l5tfl":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var CloseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "fill-rule": "evenodd",
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z"
                }
            }
        ]
    },
    "name": "close",
    "theme": "outlined"
};
exports.default = CloseOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gTxjZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Panel", ()=>(0, _panelDefault.default));
var _dialogWrap = require("./DialogWrap");
var _dialogWrapDefault = parcelHelpers.interopDefault(_dialogWrap);
var _panel = require("./Dialog/Content/Panel");
var _panelDefault = parcelHelpers.interopDefault(_panel);
exports.default = (0, _dialogWrapDefault.default);

},{"./DialogWrap":"ceXKh","./Dialog/Content/Panel":"k3LU9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ceXKh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _portal = require("@rc-component/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _react = require("react");
var _context = require("./context");
var _dialog = require("./Dialog");
var _dialogDefault = parcelHelpers.interopDefault(_dialog);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// fix issue #10656
/*
 * getContainer remarks
 * Custom container should not be return, because in the Portal component, it will remove the
 * return container element here, if the custom container is the only child of it's component,
 * like issue #10656, It will has a conflict with removeChild method in react-dom.
 * So here should add a child (div element) to custom container.
 * */ const DialogWrap = (props)=>{
    const { visible, getContainer, forceRender, destroyOnHidden = false, afterClose, closable, panelRef } = props;
    const [animatedVisible, setAnimatedVisible] = _react.useState(visible);
    const refContext = _react.useMemo(()=>({
            panel: panelRef
        }), [
        panelRef
    ]);
    _react.useEffect(()=>{
        if (visible) setAnimatedVisible(true);
    }, [
        visible
    ]);
    // Destroy on close will remove wrapped div
    if (!forceRender && destroyOnHidden && !animatedVisible) return null;
    return /*#__PURE__*/ _react.createElement((0, _context.RefContext).Provider, {
        value: refContext
    }, /*#__PURE__*/ _react.createElement((0, _portalDefault.default), {
        open: visible || forceRender || animatedVisible,
        autoDestroy: false,
        getContainer: getContainer,
        autoLock: visible || animatedVisible
    }, /*#__PURE__*/ _react.createElement((0, _dialogDefault.default), _extends({}, props, {
        destroyOnHidden: destroyOnHidden,
        afterClose: ()=>{
            const closableObj = closable && typeof closable === 'object' ? closable : {};
            const { afterClose: closableAfterClose } = closableObj || {};
            closableAfterClose?.();
            afterClose?.();
            setAnimatedVisible(false);
        }
    }))));
};
exports.default = DialogWrap;

},{"@rc-component/portal":"fYVZK","react":"bmhQu","./context":"4MpGp","./Dialog":"dUVXZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4MpGp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RefContext", ()=>RefContext);
var _react = require("react");
const RefContext = /*#__PURE__*/ _react.createContext({});

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dUVXZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _contains = require("@rc-component/util/es/Dom/contains");
var _containsDefault = parcelHelpers.interopDefault(_contains);
var _useId = require("@rc-component/util/es/hooks/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _keyCode = require("@rc-component/util/es/KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
var _react = require("react");
var _util = require("../util");
var _content = require("./Content");
var _contentDefault = parcelHelpers.interopDefault(_content);
var _mask = require("./Mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _warning = require("@rc-component/util/es/warning");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Dialog = (props)=>{
    const { prefixCls = 'rc-dialog', zIndex, visible = false, keyboard = true, focusTriggerAfterClose = true, // scrollLocker,
    // Wrapper
    wrapStyle, wrapClassName, wrapProps, onClose, afterOpenChange, afterClose, // Dialog
    transitionName, animation, closable = true, // Mask
    mask = true, maskTransitionName, maskAnimation, maskClosable = true, maskStyle, maskProps, rootClassName, rootStyle, classNames: modalClassNames, styles: modalStyles } = props;
    var prop;
    const lastOutSideActiveElementRef = (0, _react.useRef)(null);
    const wrapperRef = (0, _react.useRef)(null);
    const contentRef = (0, _react.useRef)(null);
    const [animatedVisible, setAnimatedVisible] = _react.useState(visible);
    // ========================== Init ==========================
    const ariaId = (0, _useIdDefault.default)();
    function saveLastOutSideActiveElementRef() {
        if (!(0, _containsDefault.default)(wrapperRef.current, document.activeElement)) lastOutSideActiveElementRef.current = document.activeElement;
    }
    function focusDialogContent() {
        if (!(0, _containsDefault.default)(wrapperRef.current, document.activeElement)) contentRef.current?.focus();
    }
    // ========================= Events =========================
    // Close action will trigger by:
    //   1. When hide motion end
    //   2. Controlled `open` to `false` immediately after set to `true` which will not trigger motion
    function doClose() {
        // Clean up scroll bar & focus back
        setAnimatedVisible(false);
        if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
            try {
                lastOutSideActiveElementRef.current.focus({
                    preventScroll: true
                });
            } catch (e) {
            // Do nothing
            }
            lastOutSideActiveElementRef.current = null;
        }
        // Trigger afterClose only when change visible from true to false
        if (animatedVisible) afterClose?.();
    }
    function onDialogVisibleChanged(newVisible) {
        // Try to focus
        if (newVisible) focusDialogContent();
        else doClose();
        afterOpenChange?.(newVisible);
    }
    function onInternalClose(e) {
        onClose?.(e);
    }
    // >>> Content
    const contentClickRef = (0, _react.useRef)(false);
    const contentTimeoutRef = (0, _react.useRef)(null);
    // We need record content click incase content popup out of dialog
    const onContentMouseDown = ()=>{
        clearTimeout(contentTimeoutRef.current);
        contentClickRef.current = true;
    };
    const onContentMouseUp = ()=>{
        contentTimeoutRef.current = setTimeout(()=>{
            contentClickRef.current = false;
        });
    };
    // >>> Wrapper
    // Close only when element not on dialog
    let onWrapperClick = null;
    if (maskClosable) onWrapperClick = (e)=>{
        if (contentClickRef.current) contentClickRef.current = false;
        else if (wrapperRef.current === e.target) onInternalClose(e);
    };
    function onWrapperKeyDown(e) {
        if (keyboard && e.keyCode === (0, _keyCodeDefault.default).ESC) {
            e.stopPropagation();
            onInternalClose(e);
            return;
        }
        // keep focus inside dialog
        if (visible && e.keyCode === (0, _keyCodeDefault.default).TAB) contentRef.current.changeActive(!e.shiftKey);
    }
    // ========================= Effect =========================
    (0, _react.useEffect)(()=>{
        if (visible) {
            setAnimatedVisible(true);
            saveLastOutSideActiveElementRef();
        } else if (animatedVisible && contentRef.current.enableMotion() && !contentRef.current.inMotion()) doClose();
    }, [
        visible
    ]);
    // Remove direct should also check the scroll bar update
    (0, _react.useEffect)(()=>()=>{
            clearTimeout(contentTimeoutRef.current);
        }, []);
    const mergedStyle = {
        zIndex,
        ...wrapStyle,
        ...modalStyles?.wrapper,
        display: !animatedVisible ? 'none' : null
    };
    // ========================= Render =========================
    return /*#__PURE__*/ _react.createElement("div", _extends({
        className: (0, _clsx.clsx)(`${prefixCls}-root`, rootClassName),
        style: rootStyle
    }, (0, _pickAttrsDefault.default)(props, {
        data: true
    })), /*#__PURE__*/ _react.createElement((0, _maskDefault.default), {
        prefixCls: prefixCls,
        visible: mask && visible,
        motionName: (0, _util.getMotionName)(prefixCls, maskTransitionName, maskAnimation),
        style: {
            zIndex,
            ...maskStyle,
            ...modalStyles?.mask
        },
        maskProps: maskProps,
        className: modalClassNames?.mask
    }), /*#__PURE__*/ _react.createElement("div", _extends({
        tabIndex: -1,
        onKeyDown: onWrapperKeyDown,
        className: (0, _clsx.clsx)(`${prefixCls}-wrap`, wrapClassName, modalClassNames?.wrapper),
        ref: wrapperRef,
        onClick: onWrapperClick,
        style: mergedStyle
    }, wrapProps), /*#__PURE__*/ _react.createElement((0, _contentDefault.default), _extends({}, props, {
        onMouseDown: onContentMouseDown,
        onMouseUp: onContentMouseUp,
        ref: contentRef,
        closable: closable,
        ariaId: ariaId,
        prefixCls: prefixCls,
        visible: visible && animatedVisible,
        onClose: onInternalClose,
        onVisibleChanged: onDialogVisibleChanged,
        motionName: (0, _util.getMotionName)(prefixCls, transitionName, animation)
    }))));
};
exports.default = Dialog;

},{"clsx":"431Ou","@rc-component/util/es/Dom/contains":"l6bsP","@rc-component/util/es/hooks/useId":"910ko","@rc-component/util/es/KeyCode":"6yRlk","@rc-component/util/es/pickAttrs":"jGMGD","react":"bmhQu","../util":"acpQl","./Content":"aTmsb","./Mask":"fgwPe","@rc-component/util/es/warning":"hJXDS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"acpQl":[function(require,module,exports,__globalThis) {
// =============================== Motion ===============================
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMotionName", ()=>getMotionName);
parcelHelpers.export(exports, "offset", ()=>offset);
function getMotionName(prefixCls, transitionName, animationName) {
    let motionName = transitionName;
    if (!motionName && animationName) motionName = `${prefixCls}-${animationName}`;
    return motionName;
}
// =============================== Offset ===============================
function getScroll(w, top) {
    let ret = w[`page${top ? 'Y' : 'X'}Offset`];
    const method = `scroll${top ? 'Top' : 'Left'}`;
    if (typeof ret !== 'number') {
        const d = w.document;
        ret = d.documentElement[method];
        if (typeof ret !== 'number') ret = d.body[method];
    }
    return ret;
}
function offset(el) {
    const rect = el.getBoundingClientRect();
    const pos = {
        left: rect.left,
        top: rect.top
    };
    const doc = el.ownerDocument;
    const w = doc.defaultView || doc.parentWindow;
    pos.left += getScroll(w);
    pos.top += getScroll(w, true);
    return pos;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aTmsb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _motion = require("@rc-component/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
var _util = require("../../util");
var _panel = require("./Panel");
var _panelDefault = parcelHelpers.interopDefault(_panel);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Content = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls, title, style, className, visible, forceRender, destroyOnHidden, motionName, ariaId, onVisibleChanged, mousePosition } = props;
    const dialogRef = (0, _react.useRef)(null);
    const panelRef = (0, _react.useRef)(null);
    // ============================== Refs ==============================
    _react.useImperativeHandle(ref, ()=>({
            ...panelRef.current,
            inMotion: dialogRef.current.inMotion,
            enableMotion: dialogRef.current.enableMotion
        }));
    // ============================= Style ==============================
    const [transformOrigin, setTransformOrigin] = _react.useState();
    const contentStyle = {};
    if (transformOrigin) contentStyle.transformOrigin = transformOrigin;
    function onPrepare() {
        const elementOffset = (0, _util.offset)(dialogRef.current.nativeElement);
        setTransformOrigin(mousePosition && (mousePosition.x || mousePosition.y) ? `${mousePosition.x - elementOffset.left}px ${mousePosition.y - elementOffset.top}px` : '');
    }
    // ============================= Render =============================
    return /*#__PURE__*/ _react.createElement((0, _motionDefault.default), {
        visible: visible,
        onVisibleChanged: onVisibleChanged,
        onAppearPrepare: onPrepare,
        onEnterPrepare: onPrepare,
        forceRender: forceRender,
        motionName: motionName,
        removeOnLeave: destroyOnHidden,
        ref: dialogRef
    }, ({ className: motionClassName, style: motionStyle }, motionRef)=>/*#__PURE__*/ _react.createElement((0, _panelDefault.default), _extends({}, props, {
            ref: panelRef,
            title: title,
            ariaId: ariaId,
            prefixCls: prefixCls,
            holderRef: motionRef,
            style: {
                ...motionStyle,
                ...style,
                ...contentStyle
            },
            className: (0, _clsx.clsx)(className, motionClassName)
        })));
});
exports.default = Content;

},{"react":"bmhQu","clsx":"431Ou","@rc-component/motion":"gBwXg","../../util":"acpQl","./Panel":"k3LU9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k3LU9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _ref = require("@rc-component/util/es/ref");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _context = require("../../context");
var _memoChildren = require("./MemoChildren");
var _memoChildrenDefault = parcelHelpers.interopDefault(_memoChildren);
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const sentinelStyle = {
    width: 0,
    height: 0,
    overflow: 'hidden',
    outline: 'none'
};
const entityStyle = {
    outline: 'none'
};
const Panel = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { prefixCls, className, style, title, ariaId, footer, closable, closeIcon, onClose, children, bodyStyle, bodyProps, modalRender, onMouseDown, onMouseUp, holderRef, visible, forceRender, width, height, classNames: modalClassNames, styles: modalStyles } = props;
    // ================================= Refs =================================
    const { panel: panelRef } = (0, _reactDefault.default).useContext((0, _context.RefContext));
    const mergedRef = (0, _ref.useComposeRef)(holderRef, panelRef);
    const sentinelStartRef = (0, _react.useRef)(null);
    const sentinelEndRef = (0, _react.useRef)(null);
    (0, _reactDefault.default).useImperativeHandle(ref, ()=>({
            focus: ()=>{
                sentinelStartRef.current?.focus({
                    preventScroll: true
                });
            },
            changeActive: (next)=>{
                const { activeElement } = document;
                if (next && activeElement === sentinelEndRef.current) sentinelStartRef.current.focus({
                    preventScroll: true
                });
                else if (!next && activeElement === sentinelStartRef.current) sentinelEndRef.current.focus({
                    preventScroll: true
                });
            }
        }));
    // ================================ Style =================================
    const contentStyle = {};
    if (width !== undefined) contentStyle.width = width;
    if (height !== undefined) contentStyle.height = height;
    // ================================ Render ================================
    const footerNode = footer ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-footer`, modalClassNames?.footer),
        style: {
            ...modalStyles?.footer
        }
    }, footer) : null;
    const headerNode = title ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-header`, modalClassNames?.header),
        style: {
            ...modalStyles?.header
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-title`, modalClassNames?.title),
        id: ariaId,
        style: {
            ...modalStyles?.title
        }
    }, title)) : null;
    const closableObj = (0, _react.useMemo)(()=>{
        if (typeof closable === 'object' && closable !== null) return closable;
        if (closable) return {
            closeIcon: closeIcon ?? /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                className: `${prefixCls}-close-x`
            })
        };
        return {};
    }, [
        closable,
        closeIcon,
        prefixCls
    ]);
    const ariaProps = (0, _pickAttrsDefault.default)(closableObj, true);
    const closeBtnIsDisabled = typeof closable === 'object' && closable.disabled;
    const closerNode = closable ? /*#__PURE__*/ (0, _reactDefault.default).createElement("button", _extends({
        type: "button",
        onClick: onClose,
        "aria-label": "Close"
    }, ariaProps, {
        className: `${prefixCls}-close`,
        disabled: closeBtnIsDisabled
    }), closableObj.closeIcon) : null;
    const content = /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-container`, modalClassNames?.container),
        style: modalStyles?.container
    }, closerNode, headerNode, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", _extends({
        className: (0, _clsx.clsx)(`${prefixCls}-body`, modalClassNames?.body),
        style: {
            ...bodyStyle,
            ...modalStyles?.body
        }
    }, bodyProps), children), footerNode);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        key: "dialog-element",
        role: "dialog",
        "aria-labelledby": title ? ariaId : null,
        "aria-modal": "true",
        ref: mergedRef,
        style: {
            ...style,
            ...contentStyle
        },
        className: (0, _clsx.clsx)(prefixCls, className),
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: sentinelStartRef,
        tabIndex: 0,
        style: entityStyle
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _memoChildrenDefault.default), {
        shouldUpdate: visible || forceRender
    }, modalRender ? modalRender(content) : content)), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        tabIndex: 0,
        ref: sentinelEndRef,
        style: sentinelStyle
    }));
});
exports.default = Panel;

},{"clsx":"431Ou","@rc-component/util/es/ref":"jmzjd","react":"bmhQu","../../context":"4MpGp","./MemoChildren":"5as36","@rc-component/util/es/pickAttrs":"jGMGD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5as36":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
exports.default = /*#__PURE__*/ _react.memo(({ children })=>children, (_, { shouldUpdate })=>!shouldUpdate);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fgwPe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _motion = require("@rc-component/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Mask = (props)=>{
    const { prefixCls, style, visible, maskProps, motionName, className } = props;
    return /*#__PURE__*/ _react.createElement((0, _motionDefault.default), {
        key: "mask",
        visible: visible,
        motionName: motionName,
        leavedClassName: `${prefixCls}-mask-hidden`
    }, ({ className: motionClassName, style: motionStyle }, ref)=>/*#__PURE__*/ _react.createElement("div", _extends({
            ref: ref,
            style: {
                ...motionStyle,
                ...style
            },
            className: (0, _clsx.clsx)(`${prefixCls}-mask`, motionClassName, className)
        }, maskProps)));
};
exports.default = Mask;

},{"react":"bmhQu","clsx":"431Ou","@rc-component/motion":"gBwXg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cC5so":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pickClosable", ()=>pickClosable);
parcelHelpers.export(exports, "computeClosable", ()=>computeClosable);
parcelHelpers.export(exports, "useClosable", ()=>useClosable);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _closeOutlined = require("@ant-design/icons/es/icons/CloseOutlined");
var _closeOutlinedDefault = parcelHelpers.interopDefault(_closeOutlined);
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
var _locale = require("../../locale");
var _enUS = require("../../locale/en_US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
var _extendsObject = require("../extendsObject");
var _extendsObjectDefault = parcelHelpers.interopDefault(_extendsObject);
var _isNonNullable = require("../isNonNullable");
var _isNonNullableDefault = parcelHelpers.interopDefault(_isNonNullable);
"use client";
const pickClosable = (context)=>{
    if (!context) return undefined;
    const { closable, closeIcon } = context;
    return {
        closable,
        closeIcon
    };
};
const EmptyFallbackCloseCollection = {};
const computeClosableConfig = (closable, closeIcon)=>{
    if (!closable && (closable === false || closeIcon === false || closeIcon === null)) return false;
    if (closable === undefined && closeIcon === undefined) return null;
    let closableConfig = {
        closeIcon: typeof closeIcon !== 'boolean' && closeIcon !== null ? closeIcon : undefined
    };
    if (closable && typeof closable === 'object') closableConfig = {
        ...closableConfig,
        ...closable
    };
    return closableConfig;
};
const mergeClosableConfigs = (propConfig, contextConfig, fallbackConfig)=>{
    if (propConfig === false) return false;
    if (propConfig) return (0, _extendsObjectDefault.default)(fallbackConfig, contextConfig, propConfig);
    if (contextConfig === false) return false;
    if (contextConfig) return (0, _extendsObjectDefault.default)(fallbackConfig, contextConfig);
    return fallbackConfig.closable ? fallbackConfig : false;
};
const computeCloseIcon = (mergedConfig, fallbackCloseCollection, closeLabel)=>{
    const { closeIconRender } = fallbackCloseCollection;
    const { closeIcon, ...restConfig } = mergedConfig;
    let finalCloseIcon = closeIcon;
    const ariaOrDataProps = (0, _pickAttrsDefault.default)(restConfig, true);
    if ((0, _isNonNullableDefault.default)(finalCloseIcon)) {
        if (closeIconRender) finalCloseIcon = closeIconRender(finalCloseIcon);
        finalCloseIcon = /*#__PURE__*/ (0, _reactDefault.default).isValidElement(finalCloseIcon) ? /*#__PURE__*/ (0, _reactDefault.default).cloneElement(finalCloseIcon, {
            'aria-label': closeLabel,
            ...finalCloseIcon.props,
            ...ariaOrDataProps
        }) : /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            "aria-label": closeLabel,
            ...ariaOrDataProps
        }, finalCloseIcon);
    }
    return [
        finalCloseIcon,
        ariaOrDataProps
    ];
};
const computeClosable = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = EmptyFallbackCloseCollection, closeLabel = 'Close')=>{
    const propConfig = computeClosableConfig(propCloseCollection?.closable, propCloseCollection?.closeIcon);
    const contextConfig = computeClosableConfig(contextCloseCollection?.closable, contextCloseCollection?.closeIcon);
    const mergedFallback = {
        closeIcon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _closeOutlinedDefault.default), null),
        ...fallbackCloseCollection
    };
    const mergedConfig = mergeClosableConfigs(propConfig, contextConfig, mergedFallback);
    const closeBtnIsDisabled = typeof mergedConfig !== 'boolean' ? !!mergedConfig?.disabled : false;
    if (mergedConfig === false) return [
        false,
        null,
        closeBtnIsDisabled,
        {}
    ];
    const [closeIcon, ariaProps] = computeCloseIcon(mergedConfig, mergedFallback, closeLabel);
    return [
        true,
        closeIcon,
        closeBtnIsDisabled,
        ariaProps
    ];
};
const useClosable = (propCloseCollection, contextCloseCollection, fallbackCloseCollection = EmptyFallbackCloseCollection)=>{
    const [contextLocale] = (0, _locale.useLocale)('global', (0, _enUSDefault.default).global);
    return (0, _reactDefault.default).useMemo(()=>{
        return computeClosable(propCloseCollection, contextCloseCollection, {
            closeIcon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _closeOutlinedDefault.default), null),
            ...fallbackCloseCollection
        }, contextLocale.close);
    }, [
        propCloseCollection,
        contextCloseCollection,
        fallbackCloseCollection,
        contextLocale.close
    ]);
};

},{"react":"bmhQu","@ant-design/icons/es/icons/CloseOutlined":"dinn5","@rc-component/util/es/pickAttrs":"jGMGD","../../locale":[["useLocale","l6QvX","default"]],"../../locale/en_US":"cgwsy","../extendsObject":"6r8J9","../isNonNullable":"avlqw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6r8J9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function mergeProps(...items) {
    const ret = {};
    items.forEach((item)=>{
        if (item) Object.keys(item).forEach((key)=>{
            if (item[key] !== undefined) ret[key] = item[key];
        });
    });
    return ret;
}
exports.default = mergeProps;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"86SlP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMergedMask", ()=>useMergedMask);
var _react = require("react");
const normalizeMaskConfig = (mask)=>{
    if (mask && typeof mask === 'object') return mask;
    if (typeof mask === 'boolean') return {
        enabled: mask,
        blur: mask
    };
    return {};
};
const useMergedMask = (mask, contextMask, prefixCls)=>{
    return (0, _react.useMemo)(()=>{
        const maskConfig = normalizeMaskConfig(mask);
        const contextMaskConfig = normalizeMaskConfig(contextMask);
        const mergedConfig = {
            ...contextMaskConfig,
            ...maskConfig
        };
        const className = mergedConfig.blur !== false ? `${prefixCls}-mask-blur` : undefined;
        return [
            mergedConfig.enabled !== false,
            {
                mask: className
            }
        ];
    }, [
        mask,
        contextMask,
        prefixCls
    ]);
};

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6dMz0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "canUseDocElement", ()=>canUseDocElement);
parcelHelpers.export(exports, "isStyleSupport", ()=>(0, _styleChecker.isStyleSupport));
var _canUseDom = require("@rc-component/util/es/Dom/canUseDom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
var _styleChecker = require("@rc-component/util/es/Dom/styleChecker");
const canUseDocElement = ()=>(0, _canUseDomDefault.default)() && window.document.documentElement;

},{"@rc-component/util/es/Dom/canUseDom":"4Ky1R","@rc-component/util/es/Dom/styleChecker":"jCfiG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jCfiG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isStyleSupport", ()=>isStyleSupport);
var _canUseDom = require("./canUseDom");
var _canUseDomDefault = parcelHelpers.interopDefault(_canUseDom);
const isStyleNameSupport = (styleName)=>{
    if ((0, _canUseDomDefault.default)() && window.document.documentElement) {
        const styleNameList = Array.isArray(styleName) ? styleName : [
            styleName
        ];
        const { documentElement } = window.document;
        return styleNameList.some((name)=>name in documentElement.style);
    }
    return false;
};
const isStyleValueSupport = (styleName, value)=>{
    if (!isStyleNameSupport(styleName)) return false;
    const ele = document.createElement('div');
    const origin = ele.style[styleName];
    ele.style[styleName] = value;
    return ele.style[styleName] !== origin;
};
function isStyleSupport(styleName, styleValue) {
    if (!Array.isArray(styleName) && styleValue !== undefined) return isStyleValueSupport(styleName, styleValue);
    return isStyleNameSupport(styleName);
}

},{"./canUseDom":"4Ky1R","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dlSQX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _skeleton = require("./Skeleton");
var _skeletonDefault = parcelHelpers.interopDefault(_skeleton);
"use client";
exports.default = (0, _skeletonDefault.default);

},{"./Skeleton":"Fc2Hj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Fc2Hj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _context = require("../config-provider/context");
var _avatar = require("./Avatar");
var _avatarDefault = parcelHelpers.interopDefault(_avatar);
var _button = require("./Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _element = require("./Element");
var _elementDefault = parcelHelpers.interopDefault(_element);
var _image = require("./Image");
var _imageDefault = parcelHelpers.interopDefault(_image);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
var _paragraph = require("./Paragraph");
var _paragraphDefault = parcelHelpers.interopDefault(_paragraph);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _title = require("./Title");
var _titleDefault = parcelHelpers.interopDefault(_title);
"use client";
function getComponentProps(prop) {
    if (prop && typeof prop === 'object') return prop;
    return {};
}
function getAvatarBasicProps(hasTitle, hasParagraph) {
    if (hasTitle && !hasParagraph) // Square avatar
    return {
        size: 'large',
        shape: 'square'
    };
    return {
        size: 'large',
        shape: 'circle'
    };
}
function getTitleBasicProps(hasAvatar, hasParagraph) {
    if (!hasAvatar && hasParagraph) return {
        width: '38%'
    };
    if (hasAvatar && hasParagraph) return {
        width: '50%'
    };
    return {};
}
function getParagraphBasicProps(hasAvatar, hasTitle) {
    const basicProps = {};
    // Width
    if (!hasAvatar || !hasTitle) basicProps.width = '61%';
    // Rows
    if (!hasAvatar && hasTitle) basicProps.rows = 3;
    else basicProps.rows = 2;
    return basicProps;
}
// Tips: ctx.classNames.root < ctx.className < cpns.classNames.root < cpns.className < rootClassName
const Skeleton = (props)=>{
    const { prefixCls: customizePrefixCls, loading, className, rootClassName, classNames, style, styles, children, avatar = false, title = true, paragraph = true, active, round } = props;
    const { getPrefixCls, direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('skeleton');
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    const mergedProps = {
        ...props,
        avatar,
        title,
        paragraph
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    if (loading || !('loading' in props)) {
        const hasAvatar = !!avatar;
        const hasTitle = !!title;
        const hasParagraph = !!paragraph;
        // Avatar
        let avatarNode;
        if (hasAvatar) {
            const avatarProps = {
                className: mergedClassNames.avatar,
                prefixCls: `${prefixCls}-avatar`,
                ...getAvatarBasicProps(hasTitle, hasParagraph),
                ...getComponentProps(avatar),
                style: mergedStyles.avatar
            };
            // We direct use SkeletonElement as avatar in skeleton internal.
            avatarNode = /*#__PURE__*/ _react.createElement("div", {
                className: (0, _clsx.clsx)(mergedClassNames.header, `${prefixCls}-header`),
                style: mergedStyles.header
            }, /*#__PURE__*/ _react.createElement((0, _elementDefault.default), {
                ...avatarProps
            }));
        }
        let contentNode;
        if (hasTitle || hasParagraph) {
            // Title
            let $title;
            if (hasTitle) {
                const titleProps = {
                    className: mergedClassNames.title,
                    prefixCls: `${prefixCls}-title`,
                    ...getTitleBasicProps(hasAvatar, hasParagraph),
                    ...getComponentProps(title),
                    style: mergedStyles.title
                };
                $title = /*#__PURE__*/ _react.createElement((0, _titleDefault.default), {
                    ...titleProps
                });
            }
            // Paragraph
            let paragraphNode;
            if (hasParagraph) {
                const paragraphProps = {
                    className: mergedClassNames.paragraph,
                    prefixCls: `${prefixCls}-paragraph`,
                    ...getParagraphBasicProps(hasAvatar, hasTitle),
                    ...getComponentProps(paragraph),
                    style: mergedStyles.paragraph
                };
                paragraphNode = /*#__PURE__*/ _react.createElement((0, _paragraphDefault.default), {
                    ...paragraphProps
                });
            }
            contentNode = /*#__PURE__*/ _react.createElement("div", {
                className: (0, _clsx.clsx)(mergedClassNames.section, `${prefixCls}-section`),
                style: mergedStyles.section
            }, $title, paragraphNode);
        }
        const cls = (0, _clsx.clsx)(prefixCls, {
            [`${prefixCls}-with-avatar`]: hasAvatar,
            [`${prefixCls}-active`]: active,
            [`${prefixCls}-rtl`]: direction === 'rtl',
            [`${prefixCls}-round`]: round
        }, mergedClassNames.root, contextClassName, className, rootClassName, hashId, cssVarCls);
        return /*#__PURE__*/ _react.createElement("div", {
            className: cls,
            style: {
                ...mergedStyles.root,
                ...contextStyle,
                ...style
            }
        }, avatarNode, contentNode);
    }
    return children ?? null;
};
Skeleton.Button = (0, _buttonDefault.default);
Skeleton.Avatar = (0, _avatarDefault.default);
Skeleton.Input = (0, _inputDefault.default);
Skeleton.Image = (0, _imageDefault.default);
Skeleton.Node = (0, _nodeDefault.default);
exports.default = Skeleton;

},{"react":"bmhQu","clsx":"431Ou","../_util/hooks":"kdnMA","../config-provider/context":"75zwC","./Avatar":"iEDmD","./Button":"ge8PG","./Element":"9EpTq","./Image":"g89ug","./Input":"eaZCs","./Node":"fGkFN","./Paragraph":"2t7DX","./style":"a9kuG","./Title":"gVXxE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iEDmD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _configProvider = require("../config-provider");
var _element = require("./Element");
var _elementDefault = parcelHelpers.interopDefault(_element);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const SkeletonAvatar = (props)=>{
    const { prefixCls: customizePrefixCls, className, classNames, rootClassName, active, style, styles, shape = 'circle', size = 'default', ...rest } = props;
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    const cls = (0, _clsx.clsx)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ _react.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ _react.createElement((0, _elementDefault.default), {
        prefixCls: `${prefixCls}-avatar`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        shape: shape,
        size: size,
        ...rest
    }));
};
exports.default = SkeletonAvatar;

},{"react":"bmhQu","clsx":"431Ou","../config-provider":"dVeAX","./Element":"9EpTq","./style":"a9kuG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9EpTq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
"use client";
const Element = (props)=>{
    const { prefixCls, className, style, size, shape } = props;
    const sizeCls = (0, _clsx.clsx)({
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-sm`]: size === 'small'
    });
    const shapeCls = (0, _clsx.clsx)({
        [`${prefixCls}-circle`]: shape === 'circle',
        [`${prefixCls}-square`]: shape === 'square',
        [`${prefixCls}-round`]: shape === 'round'
    });
    const sizeStyle = _react.useMemo(()=>typeof size === 'number' ? {
            width: size,
            height: size,
            lineHeight: `${size}px`
        } : {}, [
        size
    ]);
    return /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(prefixCls, sizeCls, shapeCls, className),
        style: {
            ...sizeStyle,
            ...style
        }
    });
};
exports.default = Element;

},{"react":"bmhQu","clsx":"431Ou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a9kuG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _cssinjs = require("@ant-design/cssinjs");
var _internal = require("../../theme/internal");
const skeletonClsLoading = new (0, _cssinjs.Keyframes)(`ant-skeleton-loading`, {
    '0%': {
        backgroundPosition: '100% 50%'
    },
    '100%': {
        backgroundPosition: '0 50%'
    }
});
const genSkeletonElementCommonSize = (size)=>({
        height: size,
        lineHeight: (0, _cssinjs.unit)(size)
    });
const genSkeletonElementSize = (size)=>({
        width: size,
        ...genSkeletonElementCommonSize(size)
    });
const genSkeletonColor = (token)=>({
        background: token.skeletonLoadingBackground,
        backgroundSize: '400% 100%',
        animationName: skeletonClsLoading,
        animationDuration: token.skeletonLoadingMotionDuration,
        animationTimingFunction: 'ease',
        animationIterationCount: 'infinite'
    });
const genSkeletonElementInputSize = (size, calc)=>({
        width: calc(size).mul(5).equal(),
        minWidth: calc(size).mul(5).equal(),
        ...genSkeletonElementCommonSize(size)
    });
const genSkeletonElementAvatar = (token)=>{
    const { skeletonAvatarCls, gradientFromColor, controlHeight, controlHeightLG, controlHeightSM } = token;
    return {
        [skeletonAvatarCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            ...genSkeletonElementSize(controlHeight)
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-circle`]: {
            borderRadius: '50%'
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-lg`]: {
            ...genSkeletonElementSize(controlHeightLG)
        },
        [`${skeletonAvatarCls}${skeletonAvatarCls}-sm`]: {
            ...genSkeletonElementSize(controlHeightSM)
        }
    };
};
const genSkeletonElementInput = (token)=>{
    const { controlHeight, borderRadiusSM, skeletonInputCls, controlHeightLG, controlHeightSM, gradientFromColor, calc } = token;
    return {
        [skeletonInputCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            ...genSkeletonElementInputSize(controlHeight, calc)
        },
        [`${skeletonInputCls}-lg`]: {
            ...genSkeletonElementInputSize(controlHeightLG, calc)
        },
        [`${skeletonInputCls}-sm`]: {
            ...genSkeletonElementInputSize(controlHeightSM, calc)
        }
    };
};
const genSkeletonElementShape = (token)=>{
    const { gradientFromColor, borderRadiusSM, imageSizeBase, calc } = token;
    return {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        verticalAlign: 'middle',
        background: gradientFromColor,
        borderRadius: borderRadiusSM,
        ...genSkeletonElementSize(calc(imageSizeBase).mul(2).equal())
    };
};
const genSkeletonElementNode = (token)=>{
    return {
        [token.skeletonNodeCls]: {
            ...genSkeletonElementShape(token)
        }
    };
};
const genSkeletonElementImage = (token)=>{
    const { skeletonImageCls, imageSizeBase, calc } = token;
    return {
        [skeletonImageCls]: {
            ...genSkeletonElementShape(token),
            [`${skeletonImageCls}-path`]: {
                fill: '#bfbfbf'
            },
            [`${skeletonImageCls}-svg`]: {
                ...genSkeletonElementSize(imageSizeBase),
                maxWidth: calc(imageSizeBase).mul(4).equal(),
                maxHeight: calc(imageSizeBase).mul(4).equal()
            },
            [`${skeletonImageCls}-svg${skeletonImageCls}-svg-circle`]: {
                borderRadius: '50%'
            }
        },
        [`${skeletonImageCls}${skeletonImageCls}-circle`]: {
            borderRadius: '50%'
        }
    };
};
const genSkeletonElementButtonShape = (token, size, buttonCls)=>{
    const { skeletonButtonCls } = token;
    return {
        [`${buttonCls}${skeletonButtonCls}-circle`]: {
            width: size,
            minWidth: size,
            borderRadius: '50%'
        },
        [`${buttonCls}${skeletonButtonCls}-round`]: {
            borderRadius: size
        }
    };
};
const genSkeletonElementButtonSize = (size, calc)=>({
        width: calc(size).mul(2).equal(),
        minWidth: calc(size).mul(2).equal(),
        ...genSkeletonElementCommonSize(size)
    });
const genSkeletonElementButton = (token)=>{
    const { borderRadiusSM, skeletonButtonCls, controlHeight, controlHeightLG, controlHeightSM, gradientFromColor, calc } = token;
    return {
        [skeletonButtonCls]: {
            display: 'inline-block',
            verticalAlign: 'top',
            background: gradientFromColor,
            borderRadius: borderRadiusSM,
            width: calc(controlHeight).mul(2).equal(),
            minWidth: calc(controlHeight).mul(2).equal(),
            ...genSkeletonElementButtonSize(controlHeight, calc)
        },
        ...genSkeletonElementButtonShape(token, controlHeight, skeletonButtonCls),
        [`${skeletonButtonCls}-lg`]: {
            ...genSkeletonElementButtonSize(controlHeightLG, calc)
        },
        ...genSkeletonElementButtonShape(token, controlHeightLG, `${skeletonButtonCls}-lg`),
        [`${skeletonButtonCls}-sm`]: {
            ...genSkeletonElementButtonSize(controlHeightSM, calc)
        },
        ...genSkeletonElementButtonShape(token, controlHeightSM, `${skeletonButtonCls}-sm`)
    };
};
// =============================== Base ===============================
const genBaseStyle = (token)=>{
    const { componentCls, skeletonAvatarCls, skeletonTitleCls, skeletonParagraphCls, skeletonButtonCls, skeletonInputCls, skeletonNodeCls, skeletonImageCls, controlHeight, controlHeightLG, controlHeightSM, gradientFromColor, padding, marginSM, borderRadius, titleHeight, blockRadius, paragraphLiHeight, controlHeightXS, paragraphMarginTop } = token;
    return {
        [componentCls]: {
            display: 'table',
            width: '100%',
            [`${componentCls}-header`]: {
                display: 'table-cell',
                paddingInlineEnd: padding,
                verticalAlign: 'top',
                // Avatar
                [skeletonAvatarCls]: {
                    display: 'inline-block',
                    verticalAlign: 'top',
                    background: gradientFromColor,
                    ...genSkeletonElementSize(controlHeight)
                },
                [`${skeletonAvatarCls}-circle`]: {
                    borderRadius: '50%'
                },
                [`${skeletonAvatarCls}-lg`]: {
                    ...genSkeletonElementSize(controlHeightLG)
                },
                [`${skeletonAvatarCls}-sm`]: {
                    ...genSkeletonElementSize(controlHeightSM)
                }
            },
            [`${componentCls}-section`]: {
                display: 'table-cell',
                width: '100%',
                verticalAlign: 'top',
                // Title
                [skeletonTitleCls]: {
                    width: '100%',
                    height: titleHeight,
                    background: gradientFromColor,
                    borderRadius: blockRadius,
                    [`+ ${skeletonParagraphCls}`]: {
                        marginBlockStart: controlHeightSM
                    }
                },
                // paragraph
                [skeletonParagraphCls]: {
                    padding: 0,
                    '> li': {
                        width: '100%',
                        height: paragraphLiHeight,
                        listStyle: 'none',
                        background: gradientFromColor,
                        borderRadius: blockRadius,
                        '+ li': {
                            marginBlockStart: controlHeightXS
                        }
                    }
                },
                [`${skeletonParagraphCls}> li:last-child:not(:first-child):not(:nth-child(2))`]: {
                    width: '61%'
                }
            },
            [`&-round ${componentCls}-section`]: {
                [`${skeletonTitleCls}, ${skeletonParagraphCls} > li`]: {
                    borderRadius
                }
            }
        },
        [`${componentCls}-with-avatar ${componentCls}-section`]: {
            // Title
            [skeletonTitleCls]: {
                marginBlockStart: marginSM,
                [`+ ${skeletonParagraphCls}`]: {
                    marginBlockStart: paragraphMarginTop
                }
            }
        },
        // Skeleton with element
        [`${componentCls}${componentCls}-element`]: {
            display: 'inline-block',
            width: 'auto',
            ...genSkeletonElementButton(token),
            ...genSkeletonElementAvatar(token),
            ...genSkeletonElementInput(token),
            ...genSkeletonElementNode(token),
            ...genSkeletonElementImage(token)
        },
        // Skeleton Block Button, Input
        [`${componentCls}${componentCls}-block`]: {
            width: '100%',
            [skeletonButtonCls]: {
                width: '100%'
            },
            [skeletonInputCls]: {
                width: '100%'
            }
        },
        // With active animation
        [`${componentCls}${componentCls}-active`]: {
            [`
        ${skeletonTitleCls},
        ${skeletonParagraphCls} > li,
        ${skeletonAvatarCls},
        ${skeletonButtonCls},
        ${skeletonInputCls},
        ${skeletonNodeCls},
        ${skeletonImageCls}
      `]: {
                ...genSkeletonColor(token)
            }
        }
    };
};
const prepareComponentToken = (token)=>{
    const { colorFillContent, colorFill } = token;
    const gradientFromColor = colorFillContent;
    const gradientToColor = colorFill;
    return {
        color: gradientFromColor,
        colorGradientEnd: gradientToColor,
        gradientFromColor,
        gradientToColor,
        titleHeight: token.controlHeight / 2,
        blockRadius: token.borderRadiusSM,
        paragraphMarginTop: token.marginLG + token.marginXXS,
        paragraphLiHeight: token.controlHeight / 2
    };
};
exports.default = (0, _internal.genStyleHooks)('Skeleton', (token)=>{
    const { componentCls, calc } = token;
    const skeletonToken = (0, _internal.mergeToken)(token, {
        skeletonAvatarCls: `${componentCls}-avatar`,
        skeletonTitleCls: `${componentCls}-title`,
        skeletonParagraphCls: `${componentCls}-paragraph`,
        skeletonButtonCls: `${componentCls}-button`,
        skeletonInputCls: `${componentCls}-input`,
        skeletonNodeCls: `${componentCls}-node`,
        skeletonImageCls: `${componentCls}-image`,
        imageSizeBase: calc(token.controlHeight).mul(1.5).equal(),
        borderRadius: 100,
        // Large number to make capsule shape
        skeletonLoadingBackground: `linear-gradient(90deg, ${token.gradientFromColor} 25%, ${token.gradientToColor} 37%, ${token.gradientFromColor} 63%)`,
        skeletonLoadingMotionDuration: '1.4s'
    });
    return genBaseStyle(skeletonToken);
}, prepareComponentToken, {
    deprecatedTokens: [
        [
            'color',
            'gradientFromColor'
        ],
        [
            'colorGradientEnd',
            'gradientToColor'
        ]
    ]
});

},{"@ant-design/cssinjs":"2VNL8","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ge8PG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _configProvider = require("../config-provider");
var _element = require("./Element");
var _elementDefault = parcelHelpers.interopDefault(_element);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const SkeletonButton = (props)=>{
    const { prefixCls: customizePrefixCls, className, rootClassName, classNames, active, style, styles, block = false, size = 'default', ...rest } = props;
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    const cls = (0, _clsx.clsx)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ _react.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ _react.createElement((0, _elementDefault.default), {
        prefixCls: `${prefixCls}-button`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        size: size,
        ...rest
    }));
};
exports.default = SkeletonButton;

},{"react":"bmhQu","clsx":"431Ou","../config-provider":"dVeAX","./Element":"9EpTq","./style":"a9kuG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g89ug":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _configProvider = require("../config-provider");
var _node = require("./Node");
var _nodeDefault = parcelHelpers.interopDefault(_node);
"use client";
const path = 'M365.714286 329.142857q0 45.714286-32.036571 77.677714t-77.677714 32.036571-77.677714-32.036571-32.036571-77.677714 32.036571-77.677714 77.677714-32.036571 77.677714 32.036571 32.036571 77.677714zM950.857143 548.571429l0 256-804.571429 0 0-109.714286 182.857143-182.857143 91.428571 91.428571 292.571429-292.571429zM1005.714286 146.285714l-914.285714 0q-7.460571 0-12.873143 5.412571t-5.412571 12.873143l0 694.857143q0 7.460571 5.412571 12.873143t12.873143 5.412571l914.285714 0q7.460571 0 12.873143-5.412571t5.412571-12.873143l0-694.857143q0-7.460571-5.412571-12.873143t-12.873143-5.412571zM1097.142857 164.571429l0 694.857143q0 37.741714-26.843429 64.585143t-64.585143 26.843429l-914.285714 0q-37.741714 0-64.585143-26.843429t-26.843429-64.585143l0-694.857143q0-37.741714 26.843429-64.585143t64.585143-26.843429l914.285714 0q37.741714 0 64.585143 26.843429t26.843429 64.585143z';
const SkeletonImage = (props)=>{
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('skeleton', props.prefixCls);
    return /*#__PURE__*/ _react.createElement((0, _nodeDefault.default), {
        ...props,
        internalClassName: `${prefixCls}-image`
    }, /*#__PURE__*/ _react.createElement("svg", {
        viewBox: "0 0 1098 1024",
        xmlns: "http://www.w3.org/2000/svg",
        className: `${prefixCls}-image-svg`
    }, /*#__PURE__*/ _react.createElement("title", null, "Image placeholder"), /*#__PURE__*/ _react.createElement("path", {
        d: path,
        className: `${prefixCls}-image-path`
    })));
};
exports.default = SkeletonImage;

},{"react":"bmhQu","../config-provider":"dVeAX","./Node":"fGkFN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fGkFN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _configProvider = require("../config-provider");
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const SkeletonNode = (props)=>{
    const { prefixCls: customizePrefixCls, className, classNames, rootClassName, internalClassName, style, styles, active, children } = props;
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    const cls = (0, _clsx.clsx)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active
    }, hashId, classNames?.root, className, rootClassName, cssVarCls);
    return /*#__PURE__*/ _react.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(classNames?.content, internalClassName || `${prefixCls}-node`),
        style: {
            ...styles?.content,
            ...style
        }
    }, children));
};
exports.default = SkeletonNode;

},{"react":"bmhQu","clsx":"431Ou","../config-provider":"dVeAX","./style":"a9kuG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eaZCs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _configProvider = require("../config-provider");
var _element = require("./Element");
var _elementDefault = parcelHelpers.interopDefault(_element);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const SkeletonInput = (props)=>{
    const { prefixCls: customizePrefixCls, className, classNames, rootClassName, active, block, style, styles, size = 'default', ...rest } = props;
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('skeleton', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    const cls = (0, _clsx.clsx)(prefixCls, `${prefixCls}-element`, {
        [`${prefixCls}-active`]: active,
        [`${prefixCls}-block`]: block
    }, classNames?.root, className, rootClassName, hashId, cssVarCls);
    return /*#__PURE__*/ _react.createElement("div", {
        className: cls,
        style: styles?.root
    }, /*#__PURE__*/ _react.createElement((0, _elementDefault.default), {
        prefixCls: `${prefixCls}-input`,
        className: classNames?.content,
        style: {
            ...styles?.content,
            ...style
        },
        size: size,
        ...rest
    }));
};
exports.default = SkeletonInput;

},{"react":"bmhQu","clsx":"431Ou","../config-provider":"dVeAX","./Element":"9EpTq","./style":"a9kuG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2t7DX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
"use client";
const getWidth = (index, props)=>{
    const { width, rows = 2 } = props;
    if (Array.isArray(width)) return width[index];
    // last paragraph
    if (rows - 1 === index) return width;
    return undefined;
};
const Paragraph = (props)=>{
    const { prefixCls, className, style, rows = 0 } = props;
    const rowList = Array.from({
        length: rows
    }).map((_, index)=>/*#__PURE__*/ // eslint-disable-next-line react/no-array-index-key
        _react.createElement("li", {
            key: index,
            style: {
                width: getWidth(index, props)
            }
        }));
    return /*#__PURE__*/ _react.createElement("ul", {
        className: (0, _clsx.clsx)(prefixCls, className),
        style: style
    }, rowList);
};
exports.default = Paragraph;

},{"react":"bmhQu","clsx":"431Ou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gVXxE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/* eslint-disable jsx-a11y/heading-has-content */ var _react = require("react");
var _clsx = require("clsx");
"use client";
const Title = ({ prefixCls, className, width, style })=>/*#__PURE__*/ // biome-ignore lint/a11y/useHeadingContent: HOC here
    _react.createElement("h3", {
        className: (0, _clsx.clsx)(prefixCls, className),
        style: {
            width,
            ...style
        }
    });
exports.default = Title;

},{"react":"bmhQu","clsx":"431Ou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6gIqj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePanelRef", ()=>usePanelRef);
var _react = require("react");
var _util = require("@rc-component/util");
function voidFunc() {}
const WatermarkContext = /*#__PURE__*/ _react.createContext({
    add: voidFunc,
    remove: voidFunc
});
function usePanelRef(panelSelector) {
    const watermark = _react.useContext(WatermarkContext);
    const panelEleRef = _react.useRef(null);
    const panelRef = (0, _util.useEvent)((ele)=>{
        if (ele) {
            const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
            if (innerContentEle) {
                watermark.add(innerContentEle);
                panelEleRef.current = innerContentEle;
            }
        } else watermark.remove(panelEleRef.current);
    });
    return panelRef;
}
exports.default = WatermarkContext;

},{"react":"bmhQu","@rc-component/util":"6ZBDN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2rdgW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "renderCloseIcon", ()=>renderCloseIcon);
parcelHelpers.export(exports, "Footer", ()=>Footer);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _closeOutlined = require("@ant-design/icons/es/icons/CloseOutlined");
var _closeOutlinedDefault = parcelHelpers.interopDefault(_closeOutlined);
var _disabledContext = require("../config-provider/DisabledContext");
var _locale = require("../locale");
var _normalCancelBtn = require("./components/NormalCancelBtn");
var _normalCancelBtnDefault = parcelHelpers.interopDefault(_normalCancelBtn);
var _normalOkBtn = require("./components/NormalOkBtn");
var _normalOkBtnDefault = parcelHelpers.interopDefault(_normalOkBtn);
var _context = require("./context");
var _locale1 = require("./locale");
"use client";
function renderCloseIcon(prefixCls, closeIcon) {
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
        className: `${prefixCls}-close-x`
    }, closeIcon || /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _closeOutlinedDefault.default), {
        className: `${prefixCls}-close-icon`
    }));
}
const Footer = (props)=>{
    const { okText, okType = 'primary', cancelText, confirmLoading, onOk, onCancel, okButtonProps, cancelButtonProps, footer } = props;
    const [locale] = (0, _locale.useLocale)('Modal', (0, _locale1.getConfirmLocale)());
    // ================== Locale Text ==================
    const okTextLocale = okText || locale?.okText;
    const cancelTextLocale = cancelText || locale?.cancelText;
    const memoizedValue = (0, _reactDefault.default).useMemo(()=>{
        return {
            confirmLoading,
            okButtonProps,
            cancelButtonProps,
            okTextLocale,
            cancelTextLocale,
            okType,
            onOk,
            onCancel
        };
    }, [
        confirmLoading,
        okButtonProps,
        cancelButtonProps,
        okTextLocale,
        cancelTextLocale,
        okType,
        onOk,
        onCancel
    ]);
    let footerNode;
    if (typeof footer === 'function' || typeof footer === 'undefined') {
        footerNode = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _normalCancelBtnDefault.default), null), /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _normalOkBtnDefault.default), null));
        if (typeof footer === 'function') footerNode = footer(footerNode, {
            OkBtn: (0, _normalOkBtnDefault.default),
            CancelBtn: (0, _normalCancelBtnDefault.default)
        });
        footerNode = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _context.ModalContextProvider), {
            value: memoizedValue
        }, footerNode);
    } else footerNode = footer;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _disabledContext.DisabledContextProvider), {
        disabled: false
    }, footerNode);
};

},{"react":"bmhQu","@ant-design/icons/es/icons/CloseOutlined":"dinn5","../config-provider/DisabledContext":"h4TcW","../locale":[["useLocale","l6QvX","default"]],"./components/NormalCancelBtn":"1XbCd","./components/NormalOkBtn":"gmE2e","./context":"WhlqL","./locale":"1mpkH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1XbCd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("../../button/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _context = require("../context");
"use client";
const NormalCancelBtn = ()=>{
    const { cancelButtonProps, cancelTextLocale, onCancel } = (0, _react.useContext)((0, _context.ModalContext));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        onClick: onCancel,
        ...cancelButtonProps
    }, cancelTextLocale);
};
exports.default = NormalCancelBtn;

},{"react":"bmhQu","../../button/Button":"gfWzz","../context":"WhlqL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gmE2e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("../../button/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _buttonHelpers = require("../../button/buttonHelpers");
var _context = require("../context");
"use client";
const NormalOkBtn = ()=>{
    const { confirmLoading, okButtonProps, okType, okTextLocale, onOk } = (0, _react.useContext)((0, _context.ModalContext));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        ...(0, _buttonHelpers.convertLegacyProps)(okType),
        loading: confirmLoading,
        onClick: onOk,
        ...okButtonProps
    }, okTextLocale);
};
exports.default = NormalOkBtn;

},{"react":"bmhQu","../../button/Button":"gfWzz","../../button/buttonHelpers":"2L4bZ","../context":"WhlqL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"czUgw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genModalMaskStyle", ()=>genModalMaskStyle);
parcelHelpers.export(exports, "prepareToken", ()=>prepareToken);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../grid/style");
var _style1 = require("../../style");
var _motion = require("../../style/motion");
var _internal = require("../../theme/internal");
function box(position) {
    return {
        position,
        inset: 0
    };
}
const genModalMaskStyle = (token)=>{
    const { componentCls, antCls } = token;
    return [
        {
            [`${componentCls}-root`]: {
                [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
                    // reset scale avoid mousePosition bug
                    transform: 'none',
                    opacity: 0,
                    animationDuration: token.motionDurationSlow,
                    // https://github.com/ant-design/ant-design/issues/11777
                    userSelect: 'none'
                },
                // https://github.com/ant-design/ant-design/issues/37329
                // https://github.com/ant-design/ant-design/issues/40272
                [`${componentCls}${antCls}-zoom-leave ${componentCls}-container`]: {
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask`]: {
                    ...box('fixed'),
                    zIndex: token.zIndexPopupBase,
                    height: '100%',
                    backgroundColor: token.colorBgMask,
                    pointerEvents: 'none',
                    [`&${componentCls}-mask-blur`]: {
                        backdropFilter: 'blur(4px)'
                    },
                    [`${componentCls}-hidden`]: {
                        display: 'none'
                    }
                },
                [`${componentCls}-wrap`]: {
                    ...box('fixed'),
                    zIndex: token.zIndexPopupBase,
                    overflow: 'auto',
                    outline: 0,
                    WebkitOverflowScrolling: 'touch'
                }
            }
        },
        {
            [`${componentCls}-root`]: (0, _motion.initFadeMotion)(token)
        }
    ];
};
const genModalStyle = (token)=>{
    const { componentCls } = token;
    return [
        // ======================== Root =========================
        {
            [`${componentCls}-root`]: {
                [`${componentCls}-wrap-rtl`]: {
                    direction: 'rtl'
                },
                [`${componentCls}-centered`]: {
                    textAlign: 'center',
                    '&::before': {
                        display: 'inline-block',
                        width: 0,
                        height: '100%',
                        verticalAlign: 'middle',
                        content: '""'
                    },
                    [componentCls]: {
                        top: 0,
                        display: 'inline-block',
                        paddingBottom: 0,
                        textAlign: 'start',
                        verticalAlign: 'middle'
                    }
                },
                [`@media (max-width: ${token.screenSMMax}px)`]: {
                    [componentCls]: {
                        maxWidth: 'calc(100vw - 16px)',
                        margin: `${(0, _cssinjs.unit)(token.marginXS)} auto`
                    },
                    [`${componentCls}-centered`]: {
                        [componentCls]: {
                            flex: 1
                        }
                    }
                }
            }
        },
        // ======================== Modal ========================
        {
            [componentCls]: {
                ...(0, _style1.resetComponent)(token),
                pointerEvents: 'none',
                position: 'relative',
                top: 100,
                width: 'auto',
                maxWidth: `calc(100vw - ${(0, _cssinjs.unit)(token.calc(token.margin).mul(2).equal())})`,
                margin: '0 auto',
                paddingBottom: token.paddingLG,
                [`${componentCls}-title`]: {
                    margin: 0,
                    color: token.titleColor,
                    fontWeight: token.fontWeightStrong,
                    fontSize: token.titleFontSize,
                    lineHeight: token.titleLineHeight,
                    wordWrap: 'break-word'
                },
                [`${componentCls}-container`]: {
                    position: 'relative',
                    backgroundColor: token.contentBg,
                    backgroundClip: 'padding-box',
                    border: 0,
                    borderRadius: token.borderRadiusLG,
                    boxShadow: token.boxShadow,
                    pointerEvents: 'auto',
                    padding: token.contentPadding
                },
                [`${componentCls}-close`]: {
                    position: 'absolute',
                    top: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    insetInlineEnd: token.calc(token.modalHeaderHeight).sub(token.modalCloseBtnSize).div(2).equal(),
                    zIndex: token.calc(token.zIndexPopupBase).add(10).equal(),
                    padding: 0,
                    color: token.modalCloseIconColor,
                    fontWeight: token.fontWeightStrong,
                    lineHeight: 1,
                    textDecoration: 'none',
                    background: 'transparent',
                    borderRadius: token.borderRadiusSM,
                    width: token.modalCloseBtnSize,
                    height: token.modalCloseBtnSize,
                    border: 0,
                    outline: 0,
                    cursor: 'pointer',
                    transition: `color ${token.motionDurationMid}, background-color ${token.motionDurationMid}`,
                    '&-x': {
                        display: 'flex',
                        fontSize: token.fontSizeLG,
                        fontStyle: 'normal',
                        lineHeight: (0, _cssinjs.unit)(token.modalCloseBtnSize),
                        justifyContent: 'center',
                        textTransform: 'none',
                        textRendering: 'auto'
                    },
                    '&:disabled': {
                        pointerEvents: 'none'
                    },
                    '&:hover': {
                        color: token.modalCloseIconHoverColor,
                        backgroundColor: token.colorBgTextHover,
                        textDecoration: 'none'
                    },
                    '&:active': {
                        backgroundColor: token.colorBgTextActive
                    },
                    ...(0, _style1.genFocusStyle)(token)
                },
                [`${componentCls}-header`]: {
                    color: token.colorText,
                    background: token.headerBg,
                    borderRadius: `${(0, _cssinjs.unit)(token.borderRadiusLG)} ${(0, _cssinjs.unit)(token.borderRadiusLG)} 0 0`,
                    marginBottom: token.headerMarginBottom,
                    padding: token.headerPadding,
                    borderBottom: token.headerBorderBottom
                },
                [`${componentCls}-body`]: {
                    fontSize: token.fontSize,
                    lineHeight: token.lineHeight,
                    wordWrap: 'break-word',
                    padding: token.bodyPadding,
                    [`${componentCls}-body-skeleton`]: {
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        margin: `${(0, _cssinjs.unit)(token.margin)} auto`
                    }
                },
                [`${componentCls}-footer`]: {
                    textAlign: 'end',
                    background: token.footerBg,
                    marginTop: token.footerMarginTop,
                    padding: token.footerPadding,
                    borderTop: token.footerBorderTop,
                    borderRadius: token.footerBorderRadius,
                    [`> ${token.antCls}-btn + ${token.antCls}-btn`]: {
                        marginInlineStart: token.marginXS
                    }
                },
                [`${componentCls}-open`]: {
                    overflow: 'hidden'
                }
            }
        },
        // ======================== Pure =========================
        {
            [`${componentCls}-pure-panel`]: {
                top: 'auto',
                padding: 0,
                display: 'flex',
                flexDirection: 'column',
                [`${componentCls}-container,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
                    display: 'flex',
                    flexDirection: 'column',
                    flex: 'auto'
                },
                [`${componentCls}-confirm-body`]: {
                    marginBottom: 'auto'
                }
            }
        }
    ];
};
const genRTLStyle = (token)=>{
    const { componentCls } = token;
    return {
        [`${componentCls}-root`]: {
            [`${componentCls}-wrap-rtl`]: {
                direction: 'rtl',
                [`${componentCls}-confirm-body`]: {
                    direction: 'rtl'
                }
            }
        }
    };
};
const genResponsiveWidthStyle = (token)=>{
    const { componentCls } = token;
    const oriGridMediaSizesMap = (0, _style.getMediaSize)(token);
    const gridMediaSizesMap = {
        ...oriGridMediaSizesMap
    };
    delete gridMediaSizesMap.xs;
    const cssVarPrefix = `--${componentCls.replace('.', '')}-`;
    const responsiveStyles = Object.keys(gridMediaSizesMap).map((key)=>({
            [`@media (min-width: ${(0, _cssinjs.unit)(gridMediaSizesMap[key])})`]: {
                width: `var(${cssVarPrefix}${key}-width)`
            }
        }));
    return {
        [`${componentCls}-root`]: {
            [componentCls]: [].concat((0, _toConsumableArrayDefault.default)(Object.keys(oriGridMediaSizesMap).map((currentKey, index)=>{
                const previousKey = Object.keys(oriGridMediaSizesMap)[index - 1];
                return previousKey ? {
                    [`${cssVarPrefix}${currentKey}-width`]: `var(${cssVarPrefix}${previousKey}-width)`
                } : null;
            })), [
                {
                    width: `var(${cssVarPrefix}xs-width)`
                }
            ], (0, _toConsumableArrayDefault.default)(responsiveStyles))
        }
    };
};
const prepareToken = (token)=>{
    const headerPaddingVertical = token.padding;
    const headerFontSize = token.fontSizeHeading5;
    const headerLineHeight = token.lineHeightHeading5;
    const modalToken = (0, _internal.mergeToken)(token, {
        modalHeaderHeight: token.calc(token.calc(headerLineHeight).mul(headerFontSize).equal()).add(token.calc(headerPaddingVertical).mul(2).equal()).equal(),
        modalFooterBorderColorSplit: token.colorSplit,
        modalFooterBorderStyle: token.lineType,
        modalFooterBorderWidth: token.lineWidth,
        modalCloseIconColor: token.colorIcon,
        modalCloseIconHoverColor: token.colorIconHover,
        modalCloseBtnSize: token.controlHeight,
        modalConfirmIconSize: token.fontHeight,
        modalTitleHeight: token.calc(token.titleFontSize).mul(token.titleLineHeight).equal()
    });
    return modalToken;
};
const prepareComponentToken = (token)=>({
        footerBg: 'transparent',
        headerBg: 'transparent',
        titleLineHeight: token.lineHeightHeading5,
        titleFontSize: token.fontSizeHeading5,
        contentBg: token.colorBgElevated,
        titleColor: token.colorTextHeading,
        // internal
        contentPadding: token.wireframe ? 0 : `${(0, _cssinjs.unit)(token.paddingMD)} ${(0, _cssinjs.unit)(token.paddingContentHorizontalLG)}`,
        headerPadding: token.wireframe ? `${(0, _cssinjs.unit)(token.padding)} ${(0, _cssinjs.unit)(token.paddingLG)}` : 0,
        headerBorderBottom: token.wireframe ? `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        headerMarginBottom: token.wireframe ? 0 : token.marginXS,
        bodyPadding: token.wireframe ? token.paddingLG : 0,
        footerPadding: token.wireframe ? `${(0, _cssinjs.unit)(token.paddingXS)} ${(0, _cssinjs.unit)(token.padding)}` : 0,
        footerBorderTop: token.wireframe ? `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}` : 'none',
        footerBorderRadius: token.wireframe ? `0 0 ${(0, _cssinjs.unit)(token.borderRadiusLG)} ${(0, _cssinjs.unit)(token.borderRadiusLG)}` : 0,
        footerMarginTop: token.wireframe ? 0 : token.marginSM,
        confirmBodyPadding: token.wireframe ? `${(0, _cssinjs.unit)(token.padding * 2)} ${(0, _cssinjs.unit)(token.padding * 2)} ${(0, _cssinjs.unit)(token.paddingLG)}` : 0,
        confirmIconMarginInlineEnd: token.wireframe ? token.margin : token.marginSM,
        confirmBtnsMarginTop: token.wireframe ? token.marginLG : token.marginSM,
        mask: true
    });
exports.default = (0, _internal.genStyleHooks)('Modal', (token)=>{
    const modalToken = prepareToken(token);
    return [
        genModalStyle(modalToken),
        genRTLStyle(modalToken),
        genModalMaskStyle(modalToken),
        (0, _motion.initZoomMotion)(modalToken, 'zoom'),
        genResponsiveWidthStyle(modalToken)
    ];
}, prepareComponentToken, {
    unitless: {
        titleLineHeight: true
    }
});

},{"@babel/runtime/helpers/esm/toConsumableArray":"inIie","@ant-design/cssinjs":"2VNL8","../../grid/style":"g79uF","../../style":"4Ezp0","../../style/motion":[["initFadeMotion","jD2T8"],["initZoomMotion","dqyUY"]],"../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g79uF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareRowComponentToken", ()=>prepareRowComponentToken);
parcelHelpers.export(exports, "prepareColComponentToken", ()=>prepareColComponentToken);
parcelHelpers.export(exports, "useRowStyle", ()=>useRowStyle);
parcelHelpers.export(exports, "getMediaSize", ()=>getMediaSize);
parcelHelpers.export(exports, "useColStyle", ()=>useColStyle);
var _cssinjs = require("@ant-design/cssinjs");
var _internal = require("../../theme/internal");
// ============================== Row-Shared ==============================
const genGridRowStyle = (token)=>{
    const { componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            display: 'flex',
            flexFlow: 'row wrap',
            minWidth: 0,
            '&::before, &::after': {
                display: 'flex'
            },
            '&-no-wrap': {
                flexWrap: 'nowrap'
            },
            // The origin of the X-axis
            '&-start': {
                justifyContent: 'flex-start'
            },
            // The center of the X-axis
            '&-center': {
                justifyContent: 'center'
            },
            // The opposite of the X-axis
            '&-end': {
                justifyContent: 'flex-end'
            },
            '&-space-between': {
                justifyContent: 'space-between'
            },
            '&-space-around': {
                justifyContent: 'space-around'
            },
            '&-space-evenly': {
                justifyContent: 'space-evenly'
            },
            // Align at the top
            '&-top': {
                alignItems: 'flex-start'
            },
            // Align at the center
            '&-middle': {
                alignItems: 'center'
            },
            '&-bottom': {
                alignItems: 'flex-end'
            }
        }
    };
};
// ============================== Col-Shared ==============================
const genGridColStyle = (token)=>{
    const { componentCls } = token;
    return {
        // Grid system
        [componentCls]: {
            position: 'relative',
            maxWidth: '100%',
            // Prevent columns from collapsing when empty
            minHeight: 1
        }
    };
};
const genLoopGridColumnsStyle = (token, sizeCls)=>{
    const { prefixCls, componentCls, gridColumns } = token;
    const gridColumnsStyle = {};
    for(let i = gridColumns; i >= 0; i--)if (i === 0) {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = {
            display: 'none'
        };
        gridColumnsStyle[`${componentCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: 'auto'
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: 0
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: 0
        };
    } else {
        gridColumnsStyle[`${componentCls}${sizeCls}-${i}`] = [
            // https://github.com/ant-design/ant-design/issues/44456
            // Form set `display: flex` on Col which will override `display: block`.
            // Let's get it from css variable to support override.
            {
                ['--ant-display']: 'block',
                // Fallback to display if variable not support
                display: 'block'
            },
            {
                display: 'var(--ant-display)',
                flex: `0 0 ${i / gridColumns * 100}%`,
                maxWidth: `${i / gridColumns * 100}%`
            }
        ];
        gridColumnsStyle[`${componentCls}${sizeCls}-push-${i}`] = {
            insetInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-pull-${i}`] = {
            insetInlineEnd: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-offset-${i}`] = {
            marginInlineStart: `${i / gridColumns * 100}%`
        };
        gridColumnsStyle[`${componentCls}${sizeCls}-order-${i}`] = {
            order: i
        };
    }
    // Flex CSS Var
    gridColumnsStyle[`${componentCls}${sizeCls}-flex`] = {
        flex: `var(--${prefixCls}${sizeCls}-flex)`
    };
    return gridColumnsStyle;
};
const genGridStyle = (token, sizeCls)=>genLoopGridColumnsStyle(token, sizeCls);
const genGridMediaStyle = (token, screenSize, sizeCls)=>({
        [`@media (min-width: ${(0, _cssinjs.unit)(screenSize)})`]: {
            ...genGridStyle(token, sizeCls)
        }
    });
const prepareRowComponentToken = ()=>({});
const prepareColComponentToken = ()=>({});
const useRowStyle = (0, _internal.genStyleHooks)('Grid', genGridRowStyle, prepareRowComponentToken);
const getMediaSize = (token)=>{
    const mediaSizesMap = {
        xs: token.screenXSMin,
        sm: token.screenSMMin,
        md: token.screenMDMin,
        lg: token.screenLGMin,
        xl: token.screenXLMin,
        xxl: token.screenXXLMin
    };
    return mediaSizesMap;
};
const useColStyle = (0, _internal.genStyleHooks)('Grid', (token)=>{
    const gridToken = (0, _internal.mergeToken)(token, {
        gridColumns: 24 // Row is divided into 24 parts in Grid
    });
    const gridMediaSizesMap = getMediaSize(gridToken);
    delete gridMediaSizesMap.xs;
    return [
        genGridColStyle(gridToken),
        genGridStyle(gridToken, ''),
        genGridStyle(gridToken, '-xs'),
        Object.keys(gridMediaSizesMap).map((key)=>genGridMediaStyle(gridToken, gridMediaSizesMap[key], `-${key}`)).reduce((pre, cur)=>({
                ...pre,
                ...cur
            }), {})
    ];
}, prepareColComponentToken);

},{"@ant-design/cssinjs":"2VNL8","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9yFVZ":[function(require,module,exports,__globalThis) {
// Style as confirm component
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
var _ = require(".");
var _style = require("../../style");
var _internal = require("../../theme/internal");
// ============================= Confirm ==============================
const genModalConfirmStyle = (token)=>{
    const { componentCls, titleFontSize, titleLineHeight, modalConfirmIconSize, fontSize, lineHeight, modalTitleHeight, fontHeight, confirmBodyPadding } = token;
    const confirmComponentCls = `${componentCls}-confirm`;
    return {
        [confirmComponentCls]: {
            '&-rtl': {
                direction: 'rtl'
            },
            [`${token.antCls}-modal-header`]: {
                display: 'none'
            },
            [`${confirmComponentCls}-body-wrapper`]: {
                ...(0, _style.clearFix)()
            },
            [`&${componentCls} ${componentCls}-body`]: {
                padding: confirmBodyPadding
            },
            // ====================== Body ======================
            [`${confirmComponentCls}-body`]: {
                display: 'flex',
                flexWrap: 'nowrap',
                alignItems: 'start',
                [`> ${token.iconCls}`]: {
                    flex: 'none',
                    fontSize: modalConfirmIconSize,
                    marginInlineEnd: token.confirmIconMarginInlineEnd,
                    marginTop: token.calc(token.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                },
                [`&-has-title > ${token.iconCls}`]: {
                    marginTop: token.calc(token.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
                }
            },
            [`${confirmComponentCls}-paragraph`]: {
                display: 'flex',
                flexDirection: 'column',
                flex: 'auto',
                rowGap: token.marginXS,
                // https://github.com/ant-design/ant-design/issues/51912
                maxWidth: `calc(100% - ${(0, _cssinjs.unit)(token.marginSM)})`
            },
            // https://github.com/ant-design/ant-design/issues/48159
            [`${token.iconCls} + ${confirmComponentCls}-paragraph`]: {
                maxWidth: `calc(100% - ${(0, _cssinjs.unit)(token.calc(token.modalConfirmIconSize).add(token.marginSM).equal())})`
            },
            [`${confirmComponentCls}-title`]: {
                color: token.colorTextHeading,
                fontWeight: token.fontWeightStrong,
                fontSize: titleFontSize,
                lineHeight: titleLineHeight
            },
            [`${confirmComponentCls}-container`]: {
                color: token.colorText,
                fontSize,
                lineHeight
            },
            // ===================== Footer =====================
            [`${confirmComponentCls}-btns`]: {
                textAlign: 'end',
                marginTop: token.confirmBtnsMarginTop,
                [`${token.antCls}-btn + ${token.antCls}-btn`]: {
                    marginBottom: 0,
                    marginInlineStart: token.marginXS
                }
            }
        },
        [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorError
        },
        [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorWarning
        },
        [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorInfo
        },
        [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token.iconCls}`]: {
            color: token.colorSuccess
        }
    };
};
// ============================== Export ==============================
exports.default = (0, _internal.genSubStyleComponent)([
    'Modal',
    'confirm'
], (token)=>{
    const modalToken = (0, _.prepareToken)(token);
    return genModalConfirmStyle(modalToken);
}, (0, _.prepareComponentToken), {
    // confirm is weak than modal since no conflict here
    order: -1000
});

},{"@ant-design/cssinjs":"2VNL8",".":"czUgw","../../style":"4Ezp0","../../theme/internal":"eQVSZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"doMnz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const destroyFns = [];
exports.default = destroyFns;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c51ue":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _dialog = require("@rc-component/dialog");
var _clsx = require("clsx");
var _purePanel = require("../_util/PurePanel");
var _configProvider = require("../config-provider");
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _confirmDialog = require("./ConfirmDialog");
var _shared = require("./shared");
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className, closeIcon, closable, type, title, children, footer, ...restProps } = props;
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const rootPrefixCls = getPrefixCls();
    const prefixCls = customizePrefixCls || getPrefixCls('modal');
    const rootCls = (0, _useCSSVarClsDefault.default)(rootPrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
    const confirmPrefixCls = `${prefixCls}-confirm`;
    // Choose target props by confirm mark
    let additionalProps = {};
    if (type) additionalProps = {
        closable: closable ?? false,
        title: '',
        footer: '',
        children: /*#__PURE__*/ _react.createElement((0, _confirmDialog.ConfirmContent), {
            ...props,
            prefixCls: prefixCls,
            confirmPrefixCls: confirmPrefixCls,
            rootPrefixCls: rootPrefixCls,
            content: children
        })
    };
    else additionalProps = {
        closable: closable ?? true,
        title,
        footer: footer !== null && /*#__PURE__*/ _react.createElement((0, _shared.Footer), {
            ...props
        }),
        children
    };
    return /*#__PURE__*/ _react.createElement((0, _dialog.Panel), {
        prefixCls: prefixCls,
        className: (0, _clsx.clsx)(hashId, `${prefixCls}-pure-panel`, type && confirmPrefixCls, type && `${confirmPrefixCls}-${type}`, className, cssVarCls, rootCls),
        ...restProps,
        closeIcon: (0, _shared.renderCloseIcon)(prefixCls, closeIcon),
        closable: closable,
        ...additionalProps
    });
};
exports.default = (0, _purePanel.withPureRenderTheme)(PurePanel);

},{"react":"bmhQu","@rc-component/dialog":"gTxjZ","clsx":"431Ou","../_util/PurePanel":"31Oxh","../config-provider":"dVeAX","../config-provider/hooks/useCSSVarCls":"gcu2s","./ConfirmDialog":"jah84","./shared":"2rdgW","./style":"czUgw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"31Oxh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "withPureRenderTheme", ()=>withPureRenderTheme);
var _react = require("react");
var _util = require("@rc-component/util");
var _configProvider = require("../config-provider");
var _configProviderDefault = parcelHelpers.interopDefault(_configProvider);
"use client";
function withPureRenderTheme(Component) {
    return (props)=>/*#__PURE__*/ _react.createElement((0, _configProviderDefault.default), {
            theme: {
                token: {
                    motion: false,
                    zIndexPopupBase: 0
                }
            }
        }, /*#__PURE__*/ _react.createElement(Component, {
            ...props
        }));
}
/* istanbul ignore next */ const genPurePanel = (Component, alignPropName, postProps, defaultPrefixCls, getDropdownCls)=>{
    const PurePanel = (props)=>{
        const { prefixCls: customizePrefixCls, style } = props;
        const holderRef = _react.useRef(null);
        const [popupHeight, setPopupHeight] = _react.useState(0);
        const [popupWidth, setPopupWidth] = _react.useState(0);
        const [open, setOpen] = (0, _util.useControlledState)(false, props.open);
        const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
        const prefixCls = getPrefixCls(defaultPrefixCls || 'select', customizePrefixCls);
        _react.useEffect(()=>{
            // We do not care about ssr
            setOpen(true);
            if (typeof ResizeObserver !== 'undefined') {
                const resizeObserver = new ResizeObserver((entries)=>{
                    const element = entries[0].target;
                    setPopupHeight(element.offsetHeight + 8);
                    setPopupWidth(element.offsetWidth);
                });
                const interval = setInterval(()=>{
                    const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
                    const popup = holderRef.current?.querySelector(dropdownCls);
                    if (popup) {
                        clearInterval(interval);
                        resizeObserver.observe(popup);
                    }
                }, 10);
                return ()=>{
                    clearInterval(interval);
                    resizeObserver.disconnect();
                };
            }
        }, [
            prefixCls
        ]);
        let mergedProps = {
            ...props,
            style: {
                ...style,
                margin: 0
            },
            open,
            getPopupContainer: ()=>holderRef.current
        };
        if (postProps) mergedProps = postProps(mergedProps);
        if (alignPropName) Object.assign(mergedProps, {
            [alignPropName]: {
                overflow: {
                    adjustX: false,
                    adjustY: false
                }
            }
        });
        const mergedStyle = {
            paddingBottom: popupHeight,
            position: 'relative',
            minWidth: popupWidth
        };
        return /*#__PURE__*/ _react.createElement("div", {
            ref: holderRef,
            style: mergedStyle
        }, /*#__PURE__*/ _react.createElement(Component, {
            ...mergedProps
        }));
    };
    return withPureRenderTheme(PurePanel);
};
exports.default = genPurePanel;

},{"react":"bmhQu","@rc-component/util":"6ZBDN","../config-provider":"dVeAX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fr0ja":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _hooks = require("../../_util/hooks");
var _confirm = require("../confirm");
var _destroyFns = require("../destroyFns");
var _destroyFnsDefault = parcelHelpers.interopDefault(_destroyFns);
var _hookModal = require("./HookModal");
var _hookModalDefault = parcelHelpers.interopDefault(_hookModal);
"use client";
let uuid = 0;
const ElementsHolder = /*#__PURE__*/ _react.memo(/*#__PURE__*/ _react.forwardRef((_props, ref)=>{
    const [elements, patchElement] = (0, _hooks.usePatchElement)();
    _react.useImperativeHandle(ref, ()=>({
            patchElement
        }), [
        patchElement
    ]);
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, elements);
}));
function useModal() {
    const holderRef = _react.useRef(null);
    // ========================== Effect ==========================
    const [actionQueue, setActionQueue] = _react.useState([]);
    _react.useEffect(()=>{
        if (actionQueue.length) {
            const cloneQueue = (0, _toConsumableArrayDefault.default)(actionQueue);
            cloneQueue.forEach((action)=>{
                action();
            });
            setActionQueue([]);
        }
    }, [
        actionQueue
    ]);
    // =========================== Hook ===========================
    const getConfirmFunc = _react.useCallback((withFunc)=>function hookConfirm(config) {
            uuid += 1;
            const modalRef = /*#__PURE__*/ _react.createRef();
            // Proxy to promise with `onClose`
            let resolvePromise;
            const promise = new Promise((resolve)=>{
                resolvePromise = resolve;
            });
            let silent = false;
            let closeFunc;
            const modal = /*#__PURE__*/ _react.createElement((0, _hookModalDefault.default), {
                key: `modal-${uuid}`,
                config: withFunc(config),
                ref: modalRef,
                afterClose: ()=>{
                    closeFunc?.();
                },
                isSilent: ()=>silent,
                onConfirm: (confirmed)=>{
                    resolvePromise(confirmed);
                }
            });
            closeFunc = holderRef.current?.patchElement(modal);
            if (closeFunc) (0, _destroyFnsDefault.default).push(closeFunc);
            const instance = {
                destroy: ()=>{
                    function destroyAction() {
                        modalRef.current?.destroy();
                    }
                    if (modalRef.current) destroyAction();
                    else setActionQueue((prev)=>[].concat((0, _toConsumableArrayDefault.default)(prev), [
                            destroyAction
                        ]));
                },
                update: (newConfig)=>{
                    function updateAction() {
                        modalRef.current?.update(newConfig);
                    }
                    if (modalRef.current) updateAction();
                    else setActionQueue((prev)=>[].concat((0, _toConsumableArrayDefault.default)(prev), [
                            updateAction
                        ]));
                },
                then: (resolve)=>{
                    silent = true;
                    return promise.then(resolve);
                }
            };
            return instance;
        }, []);
    const fns = _react.useMemo(()=>({
            info: getConfirmFunc((0, _confirm.withInfo)),
            success: getConfirmFunc((0, _confirm.withSuccess)),
            error: getConfirmFunc((0, _confirm.withError)),
            warning: getConfirmFunc((0, _confirm.withWarn)),
            confirm: getConfirmFunc((0, _confirm.withConfirm))
        }), [
        getConfirmFunc
    ]);
    return [
        fns,
        /*#__PURE__*/ _react.createElement(ElementsHolder, {
            key: "modal-holder",
            ref: holderRef
        })
    ];
}
exports.default = useModal;

},{"@babel/runtime/helpers/esm/toConsumableArray":"inIie","react":"bmhQu","../../_util/hooks":"3ySMJ","../confirm":"h1iRk","../destroyFns":"doMnz","./HookModal":"31mJA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ySMJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "usePatchElement", ()=>usePatchElement);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
const usePatchElement = ()=>{
    const [elements, setElements] = _react.useState([]);
    const patchElement = _react.useCallback((element)=>{
        // append a new element to elements (and create a new ref)
        setElements((originElements)=>[].concat((0, _toConsumableArrayDefault.default)(originElements), [
                element
            ]));
        // return a function that removes the new element out of elements (and create a new ref)
        // it works a little like useEffect
        return ()=>{
            setElements((originElements)=>originElements.filter((ele)=>ele !== element));
        };
    }, []);
    return [
        elements,
        patchElement
    ];
};

},{"@babel/runtime/helpers/esm/toConsumableArray":"inIie","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"31mJA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _configProvider = require("../../config-provider");
var _enUS = require("../../locale/en_US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
var _useLocale = require("../../locale/useLocale");
var _useLocaleDefault = parcelHelpers.interopDefault(_useLocale);
var _confirmDialog = require("../ConfirmDialog");
var _confirmDialogDefault = parcelHelpers.interopDefault(_confirmDialog);
"use client";
const HookModal = ({ afterClose: hookAfterClose, config, ...restProps }, ref)=>{
    const [open, setOpen] = _react.useState(true);
    const [innerConfig, setInnerConfig] = _react.useState(config);
    const { direction, getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('modal');
    const rootPrefixCls = getPrefixCls();
    const afterClose = ()=>{
        hookAfterClose();
        innerConfig.afterClose?.();
    };
    const close = (...args)=>{
        setOpen(false);
        const triggerCancel = args.some((param)=>param?.triggerCancel);
        if (triggerCancel) innerConfig.onCancel?.(()=>{}, ...args.slice(1));
    };
    _react.useImperativeHandle(ref, ()=>({
            destroy: close,
            update: (newConfig)=>{
                setInnerConfig((originConfig)=>{
                    const nextConfig = typeof newConfig === 'function' ? newConfig(originConfig) : newConfig;
                    return {
                        ...originConfig,
                        ...nextConfig
                    };
                });
            }
        }));
    const mergedOkCancel = innerConfig.okCancel ?? innerConfig.type === 'confirm';
    const [contextLocale] = (0, _useLocaleDefault.default)('Modal', (0, _enUSDefault.default).Modal);
    return /*#__PURE__*/ _react.createElement((0, _confirmDialogDefault.default), {
        prefixCls: prefixCls,
        rootPrefixCls: rootPrefixCls,
        ...innerConfig,
        close: close,
        open: open,
        afterClose: afterClose,
        okText: innerConfig.okText || (mergedOkCancel ? contextLocale?.okText : contextLocale?.justOkText),
        direction: innerConfig.direction || direction,
        cancelText: innerConfig.cancelText || contextLocale?.cancelText,
        ...restProps
    });
};
exports.default = /*#__PURE__*/ _react.forwardRef(HookModal);

},{"react":"bmhQu","../../config-provider":"dVeAX","../../locale/en_US":"cgwsy","../../locale/useLocale":"l6QvX","../ConfirmDialog":"jah84","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3aAAX":[function(require,module,exports,__globalThis) {
module.exports["ant-modal-close"] = `q5uRLG_ant-modal-close`;
module.exports["ant-modal-content"] = `q5uRLG_ant-modal-content`;
module.exports["cancelButtonCustom"] = `q5uRLG_cancelButtonCustom`;
module.exports["commandDialogContainer"] = `q5uRLG_commandDialogContainer`;
module.exports["doneButtonCustom"] = `q5uRLG_doneButtonCustom`;
module.exports["modalSubtitle"] = `q5uRLG_modalSubtitle`;
module.exports["modalTitle"] = `q5uRLG_modalTitle`;

},{}],"eYkDC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trainingStore", ()=>trainingStore);
parcelHelpers.export(exports, "setClient", ()=>setClient);
parcelHelpers.export(exports, "setSelectedClient", ()=>setSelectedClient);
parcelHelpers.export(exports, "setSelectedDays", ()=>setSelectedDays);
parcelHelpers.export(exports, "toggleAssessmentDay", ()=>toggleAssessmentDay);
parcelHelpers.export(exports, "setBaselineEnergyLevel", ()=>setBaselineEnergyLevel);
parcelHelpers.export(exports, "setIntensityPreference", ()=>setIntensityPreference);
parcelHelpers.export(exports, "setActivityLevel", ()=>setActivityLevel);
parcelHelpers.export(exports, "setFitnessLevel", ()=>setFitnessLevel);
parcelHelpers.export(exports, "setScheduleFlexibility", ()=>setScheduleFlexibility);
parcelHelpers.export(exports, "setTrainingGoal", ()=>setTrainingGoal);
parcelHelpers.export(exports, "setTrainingStyle", ()=>setTrainingStyle);
parcelHelpers.export(exports, "setMovementInsights", ()=>setMovementInsights);
parcelHelpers.export(exports, "setCurrentStep", ()=>setCurrentStep);
parcelHelpers.export(exports, "nextStep", ()=>nextStep);
parcelHelpers.export(exports, "previousStep", ()=>previousStep);
parcelHelpers.export(exports, "completeAssessment", ()=>completeAssessment);
parcelHelpers.export(exports, "resetAssessment", ()=>resetAssessment);
parcelHelpers.export(exports, "getStepProgress", ()=>getStepProgress);
parcelHelpers.export(exports, "isStepComplete", ()=>isStepComplete);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
const initialAssessment = {
    selectedClient: null,
    baselineEnergyLevel: null,
    intensityPreference: null,
    activityLevel: null,
    fitnessLevel: null,
    scheduleFlexibility: null,
    trainingGoal: null,
    trainingStyle: null,
    movementInsights: null,
    currentStep: 0,
    isComplete: false,
    selectedDays: []
};
const defaultClients = [
    {
        _id: 'emily_demo',
        name: 'Emily Thompson (Demo)',
        avatar: 'https://i.pravatar.cc/128?img=5'
    },
    {
        _id: 'oliver_demo',
        name: 'Oliver Bennett (Demo)',
        avatar: 'https://i.pravatar.cc/128?img=3'
    }
];
const trainingStore = (0, _zustand.create)()((0, _middleware.persist)(()=>({
        assessment: initialAssessment,
        availableClients: defaultClients
    }), {
    name: 'training-storage'
}));
const setClient = (client)=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                selectedClient: client
            }
        }));
const setSelectedClient = (client)=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                selectedClient: client
            }
        }));
const setSelectedDays = (days)=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                selectedDays: days
            }
        }));
const toggleAssessmentDay = (day)=>trainingStore.setState((state)=>{
        const selectedDays = state.assessment.selectedDays || [];
        const newDays = selectedDays.includes(day) ? selectedDays.filter((d)=>d !== day) : [
            ...selectedDays,
            day
        ];
        return {
            assessment: {
                ...state.assessment,
                selectedDays: newDays
            }
        };
    });
const setBaselineEnergyLevel = (level)=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                baselineEnergyLevel: level
            }
        }));
const setIntensityPreference = (preference)=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                intensityPreference: preference
            }
        }));
const setActivityLevel = (level)=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                activityLevel: level
            }
        }));
const setFitnessLevel = (level)=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                fitnessLevel: level
            }
        }));
const setScheduleFlexibility = (flexibility)=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                scheduleFlexibility: flexibility
            }
        }));
const setTrainingGoal = (goal)=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                trainingGoal: goal
            }
        }));
const setTrainingStyle = (style)=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                trainingStyle: style
            }
        }));
const setMovementInsights = (insights)=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                movementInsights: insights
            }
        }));
const setCurrentStep = (step)=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                currentStep: step
            }
        }));
const nextStep = ()=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                currentStep: Math.min(state.assessment.currentStep + 1, 8)
            }
        }));
const previousStep = ()=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                currentStep: Math.max(state.assessment.currentStep - 1, 0)
            }
        }));
const completeAssessment = ()=>trainingStore.setState((state)=>({
            assessment: {
                ...state.assessment,
                isComplete: true
            }
        }));
const resetAssessment = ()=>trainingStore.setState(()=>({
            assessment: initialAssessment
        }));
const getStepProgress = ()=>{
    const { assessment } = trainingStore.getState();
    const totalSteps = 9; // 0-8 steps
    return assessment.currentStep / (totalSteps - 1) * 100;
};
const isStepComplete = (step)=>{
    const { assessment } = trainingStore.getState();
    switch(step){
        case 0:
            return assessment.selectedClient !== null;
        case 1:
            return assessment.baselineEnergyLevel !== null;
        case 2:
            return assessment.intensityPreference !== null;
        case 3:
            return assessment.activityLevel !== null;
        case 4:
            return assessment.fitnessLevel !== null;
        case 5:
            return assessment.scheduleFlexibility !== null;
        case 6:
            return assessment.trainingGoal !== null;
        case 7:
            return assessment.trainingStyle !== null;
        case 8:
            return assessment.movementInsights !== null;
        default:
            return false;
    }
};

},{"zustand":"dodpK","zustand/middleware":"2zkjt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h8xaL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSummarizeInstruction", ()=>useSummarizeInstruction);
parcelHelpers.export(exports, "generateWorkoutProgramCoach", ()=>generateWorkoutProgramCoach);
parcelHelpers.export(exports, "useGenerateWorkoutProgram", ()=>useGenerateWorkoutProgram);
var _reactQuery = require("@tanstack/react-query");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
function useSummarizeInstruction() {
    return (0, _reactQuery.useMutation)({
        mutationFn: async (params)=>{
            const response = await (0, _axiosDefault.default).post(`${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).SUMMARIZE_INSTRUCTION_API_HOST}`, {
                data: params
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            // Firebase Callable responses are wrapped inside 'result' or 'data'
            return response.data?.result || response.data?.data || response.data;
        }
    });
}
const generateWorkoutProgramCoach = async (params)=>{
    const response = await (0, _axiosDefault.default).post(`${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).GENERATE_WORKOUT_PROGRAM_COACH_API_HOST}`, {
        data: params
    }, {
        headers: {
            'Content-Type': 'application/json'
        },
        timeout: 600000
    });
    return response.data?.result || response.data?.data || response.data;
};
function useGenerateWorkoutProgram() {
    return (0, _reactQuery.useMutation)({
        mutationFn: generateWorkoutProgramCoach
    });
}

},{"@tanstack/react-query":"ehKs4","axios":"kL5AO","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ehKs4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMutation", ()=>useMutation);
// src/useMutation.ts
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _queryClientProviderJs = require("./QueryClientProvider.js");
"use client";
function useMutation(options, queryClient) {
    const client = (0, _queryClientProviderJs.useQueryClient)(queryClient);
    const [observer] = _react.useState(()=>new (0, _queryCore.MutationObserver)(client, options));
    _react.useEffect(()=>{
        observer.setOptions(options);
    }, [
        observer,
        options
    ]);
    const result = _react.useSyncExternalStore(_react.useCallback((onStoreChange)=>observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)), [
        observer
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    const mutate = _react.useCallback((variables, mutateOptions)=>{
        observer.mutate(variables, mutateOptions).catch((0, _queryCore.noop));
    }, [
        observer
    ]);
    if (result.error && (0, _queryCore.shouldThrowError)(observer.options.throwOnError, [
        result.error
    ])) throw result.error;
    return {
        ...result,
        mutate,
        mutateAsync: result.mutate
    };
}

},{"react":"bmhQu","@tanstack/query-core":[["MutationObserver","jc7O0"],["noop","ku1P9"],["shouldThrowError","ku1P9"],["notifyManager","egZGk"]],"./QueryClientProvider.js":"97Oud","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jc7O0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationObserver", ()=>MutationObserver);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/mutationObserver.ts
var _mutationJs = require("./mutation.js");
var _notifyManagerJs = require("./notifyManager.js");
var _subscribableJs = require("./subscribable.js");
var _utilsJs = require("./utils.js");
var _client, _currentResult, _currentMutation, _mutateOptions, _MutationObserver_instances, updateResult_fn, notify_fn;
var MutationObserver = class extends (0, _subscribableJs.Subscribable) {
    constructor(client, options){
        super();
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _MutationObserver_instances);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _client);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _currentResult);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _currentMutation);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _mutateOptions);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _client, client);
        this.setOptions(options);
        this.bindMethods();
        (0, _chunkPXG64RU4Js.__privateMethod)(this, _MutationObserver_instances, updateResult_fn).call(this);
    }
    bindMethods() {
        this.mutate = this.mutate.bind(this);
        this.reset = this.reset.bind(this);
    }
    setOptions(options) {
        var _a;
        const prevOptions = this.options;
        this.options = (0, _chunkPXG64RU4Js.__privateGet)(this, _client).defaultMutationOptions(options);
        if (!(0, _utilsJs.shallowEqualObjects)(this.options, prevOptions)) (0, _chunkPXG64RU4Js.__privateGet)(this, _client).getMutationCache().notify({
            type: "observerOptionsUpdated",
            mutation: (0, _chunkPXG64RU4Js.__privateGet)(this, _currentMutation),
            observer: this
        });
        if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && (0, _utilsJs.hashKey)(prevOptions.mutationKey) !== (0, _utilsJs.hashKey)(this.options.mutationKey)) this.reset();
        else if (((_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentMutation)) == null ? void 0 : _a.state.status) === "pending") (0, _chunkPXG64RU4Js.__privateGet)(this, _currentMutation).setOptions(this.options);
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentMutation)) == null || _a.removeObserver(this);
    }
    onMutationUpdate(action) {
        (0, _chunkPXG64RU4Js.__privateMethod)(this, _MutationObserver_instances, updateResult_fn).call(this);
        (0, _chunkPXG64RU4Js.__privateMethod)(this, _MutationObserver_instances, notify_fn).call(this, action);
    }
    getCurrentResult() {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult);
    }
    reset() {
        var _a;
        (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentMutation)) == null || _a.removeObserver(this);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _currentMutation, void 0);
        (0, _chunkPXG64RU4Js.__privateMethod)(this, _MutationObserver_instances, updateResult_fn).call(this);
        (0, _chunkPXG64RU4Js.__privateMethod)(this, _MutationObserver_instances, notify_fn).call(this);
    }
    mutate(variables, options) {
        var _a;
        (0, _chunkPXG64RU4Js.__privateSet)(this, _mutateOptions, options);
        (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentMutation)) == null || _a.removeObserver(this);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _currentMutation, (0, _chunkPXG64RU4Js.__privateGet)(this, _client).getMutationCache().build((0, _chunkPXG64RU4Js.__privateGet)(this, _client), this.options));
        (0, _chunkPXG64RU4Js.__privateGet)(this, _currentMutation).addObserver(this);
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _currentMutation).execute(variables);
    }
};
_client = new WeakMap();
_currentResult = new WeakMap();
_currentMutation = new WeakMap();
_mutateOptions = new WeakMap();
_MutationObserver_instances = new WeakSet();
updateResult_fn = function() {
    var _a;
    const state = ((_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentMutation)) == null ? void 0 : _a.state) ?? (0, _mutationJs.getDefaultState)();
    (0, _chunkPXG64RU4Js.__privateSet)(this, _currentResult, {
        ...state,
        isPending: state.status === "pending",
        isSuccess: state.status === "success",
        isError: state.status === "error",
        isIdle: state.status === "idle",
        mutate: this.mutate,
        reset: this.reset
    });
};
notify_fn = function(action) {
    (0, _notifyManagerJs.notifyManager).batch(()=>{
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if ((0, _chunkPXG64RU4Js.__privateGet)(this, _mutateOptions) && this.hasListeners()) {
            const variables = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult).variables;
            const onMutateResult = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult).context;
            const context = {
                client: (0, _chunkPXG64RU4Js.__privateGet)(this, _client),
                meta: this.options.meta,
                mutationKey: this.options.mutationKey
            };
            if ((action == null ? void 0 : action.type) === "success") {
                (_b = (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _mutateOptions)).onSuccess) == null || _b.call(_a, action.data, variables, onMutateResult, context);
                (_d = (_c = (0, _chunkPXG64RU4Js.__privateGet)(this, _mutateOptions)).onSettled) == null || _d.call(_c, action.data, null, variables, onMutateResult, context);
            } else if ((action == null ? void 0 : action.type) === "error") {
                (_f = (_e = (0, _chunkPXG64RU4Js.__privateGet)(this, _mutateOptions)).onError) == null || _f.call(_e, action.error, variables, onMutateResult, context);
                (_h = (_g = (0, _chunkPXG64RU4Js.__privateGet)(this, _mutateOptions)).onSettled) == null || _h.call(_g, void 0, action.error, variables, onMutateResult, context);
            }
        }
        this.listeners.forEach((listener)=>{
            listener((0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult));
        });
    });
};

},{"./chunk-PXG64RU4.js":"eR9la","./mutation.js":"6HxMS","./notifyManager.js":"egZGk","./subscribable.js":"ifEuT","./utils.js":"ku1P9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eR9la":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__privateGet", ()=>__privateGet);
parcelHelpers.export(exports, "__privateAdd", ()=>__privateAdd);
parcelHelpers.export(exports, "__privateSet", ()=>__privateSet);
parcelHelpers.export(exports, "__privateMethod", ()=>__privateMethod);
parcelHelpers.export(exports, "__privateWrapper", ()=>__privateWrapper);
var __typeError = (msg)=>{
    throw TypeError(msg);
};
var __accessCheck = (obj, member, msg)=>member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter)=>(__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value1)=>member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value1);
var __privateSet = (obj, member, value1, setter)=>(__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value1) : member.set(obj, value1), value1);
var __privateMethod = (obj, member, method)=>(__accessCheck(obj, member, "access private method"), method);
var __privateWrapper = (obj, member, setter, getter)=>({
        set _ (value){
            __privateSet(obj, member, value, setter);
        },
        get _ () {
            return __privateGet(obj, member, getter);
        }
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6HxMS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mutation", ()=>Mutation);
parcelHelpers.export(exports, "getDefaultState", ()=>getDefaultState);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/mutation.ts
var _notifyManagerJs = require("./notifyManager.js");
var _removableJs = require("./removable.js");
var _retryerJs = require("./retryer.js");
var _client, _observers, _mutationCache, _retryer, _Mutation_instances, dispatch_fn;
var Mutation = class extends (0, _removableJs.Removable) {
    constructor(config){
        super();
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _Mutation_instances);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _client);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _observers);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _mutationCache);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _retryer);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _client, config.client);
        this.mutationId = config.mutationId;
        (0, _chunkPXG64RU4Js.__privateSet)(this, _mutationCache, config.mutationCache);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _observers, []);
        this.state = config.state || getDefaultState();
        this.setOptions(config.options);
        this.scheduleGc();
    }
    setOptions(options) {
        this.options = options;
        this.updateGcTime(this.options.gcTime);
    }
    get meta() {
        return this.options.meta;
    }
    addObserver(observer) {
        if (!(0, _chunkPXG64RU4Js.__privateGet)(this, _observers).includes(observer)) {
            (0, _chunkPXG64RU4Js.__privateGet)(this, _observers).push(observer);
            this.clearGcTimeout();
            (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).notify({
                type: "observerAdded",
                mutation: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        (0, _chunkPXG64RU4Js.__privateSet)(this, _observers, (0, _chunkPXG64RU4Js.__privateGet)(this, _observers).filter((x)=>x !== observer));
        this.scheduleGc();
        (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).notify({
            type: "observerRemoved",
            mutation: this,
            observer
        });
    }
    optionalRemove() {
        if (!(0, _chunkPXG64RU4Js.__privateGet)(this, _observers).length) {
            if (this.state.status === "pending") this.scheduleGc();
            else (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).remove(this);
        }
    }
    continue() {
        var _a;
        return ((_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer)) == null ? void 0 : _a.continue()) ?? // continuing a mutation assumes that variables are set, mutation must have been dehydrated before
        this.execute(this.state.variables);
    }
    async execute(variables) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t;
        const onContinue = ()=>{
            (0, _chunkPXG64RU4Js.__privateMethod)(this, _Mutation_instances, dispatch_fn).call(this, {
                type: "continue"
            });
        };
        const mutationFnContext = {
            client: (0, _chunkPXG64RU4Js.__privateGet)(this, _client),
            meta: this.options.meta,
            mutationKey: this.options.mutationKey
        };
        (0, _chunkPXG64RU4Js.__privateSet)(this, _retryer, (0, _retryerJs.createRetryer)({
            fn: ()=>{
                if (!this.options.mutationFn) return Promise.reject(new Error("No mutationFn found"));
                return this.options.mutationFn(variables, mutationFnContext);
            },
            onFail: (failureCount, error)=>{
                (0, _chunkPXG64RU4Js.__privateMethod)(this, _Mutation_instances, dispatch_fn).call(this, {
                    type: "failed",
                    failureCount,
                    error
                });
            },
            onPause: ()=>{
                (0, _chunkPXG64RU4Js.__privateMethod)(this, _Mutation_instances, dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue,
            retry: this.options.retry ?? 0,
            retryDelay: this.options.retryDelay,
            networkMode: this.options.networkMode,
            canRun: ()=>(0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).canRun(this)
        }));
        const restored = this.state.status === "pending";
        const isPaused = !(0, _chunkPXG64RU4Js.__privateGet)(this, _retryer).canStart();
        try {
            if (restored) onContinue();
            else {
                (0, _chunkPXG64RU4Js.__privateMethod)(this, _Mutation_instances, dispatch_fn).call(this, {
                    type: "pending",
                    variables,
                    isPaused
                });
                await ((_b = (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).config).onMutate) == null ? void 0 : _b.call(_a, variables, this, mutationFnContext));
                const context = await ((_d = (_c = this.options).onMutate) == null ? void 0 : _d.call(_c, variables, mutationFnContext));
                if (context !== this.state.context) (0, _chunkPXG64RU4Js.__privateMethod)(this, _Mutation_instances, dispatch_fn).call(this, {
                    type: "pending",
                    context,
                    variables,
                    isPaused
                });
            }
            const data = await (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer).start();
            await ((_f = (_e = (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).config).onSuccess) == null ? void 0 : _f.call(_e, data, variables, this.state.context, this, mutationFnContext));
            await ((_h = (_g = this.options).onSuccess) == null ? void 0 : _h.call(_g, data, variables, this.state.context, mutationFnContext));
            await ((_j = (_i = (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).config).onSettled) == null ? void 0 : _j.call(_i, data, null, this.state.variables, this.state.context, this, mutationFnContext));
            await ((_l = (_k = this.options).onSettled) == null ? void 0 : _l.call(_k, data, null, variables, this.state.context, mutationFnContext));
            (0, _chunkPXG64RU4Js.__privateMethod)(this, _Mutation_instances, dispatch_fn).call(this, {
                type: "success",
                data
            });
            return data;
        } catch (error) {
            try {
                await ((_n = (_m = (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).config).onError) == null ? void 0 : _n.call(_m, error, variables, this.state.context, this, mutationFnContext));
                await ((_p = (_o = this.options).onError) == null ? void 0 : _p.call(_o, error, variables, this.state.context, mutationFnContext));
                await ((_r = (_q = (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).config).onSettled) == null ? void 0 : _r.call(_q, void 0, error, this.state.variables, this.state.context, this, mutationFnContext));
                await ((_t = (_s = this.options).onSettled) == null ? void 0 : _t.call(_s, void 0, error, variables, this.state.context, mutationFnContext));
                throw error;
            } finally{
                (0, _chunkPXG64RU4Js.__privateMethod)(this, _Mutation_instances, dispatch_fn).call(this, {
                    type: "error",
                    error
                });
            }
        } finally{
            (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).runNext(this);
        }
    }
};
_client = new WeakMap();
_observers = new WeakMap();
_mutationCache = new WeakMap();
_retryer = new WeakMap();
_Mutation_instances = new WeakSet();
dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    failureCount: action.failureCount,
                    failureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    isPaused: true
                };
            case "continue":
                return {
                    ...state,
                    isPaused: false
                };
            case "pending":
                return {
                    ...state,
                    context: action.context,
                    data: void 0,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    isPaused: action.isPaused,
                    status: "pending",
                    variables: action.variables,
                    submittedAt: Date.now()
                };
            case "success":
                return {
                    ...state,
                    data: action.data,
                    failureCount: 0,
                    failureReason: null,
                    error: null,
                    status: "success",
                    isPaused: false
                };
            case "error":
                return {
                    ...state,
                    data: void 0,
                    error: action.error,
                    failureCount: state.failureCount + 1,
                    failureReason: action.error,
                    isPaused: false,
                    status: "error"
                };
        }
    };
    this.state = reducer(this.state);
    (0, _notifyManagerJs.notifyManager).batch(()=>{
        (0, _chunkPXG64RU4Js.__privateGet)(this, _observers).forEach((observer)=>{
            observer.onMutationUpdate(action);
        });
        (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).notify({
            mutation: this,
            type: "updated",
            action
        });
    });
};
function getDefaultState() {
    return {
        context: void 0,
        data: void 0,
        error: null,
        failureCount: 0,
        failureReason: null,
        isPaused: false,
        status: "idle",
        variables: void 0,
        submittedAt: 0
    };
}

},{"./chunk-PXG64RU4.js":"eR9la","./notifyManager.js":"egZGk","./removable.js":"22XBM","./retryer.js":"ev2IU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"egZGk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createNotifyManager", ()=>createNotifyManager);
parcelHelpers.export(exports, "defaultScheduler", ()=>defaultScheduler);
parcelHelpers.export(exports, "notifyManager", ()=>notifyManager);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/notifyManager.ts
var _timeoutManagerJs = require("./timeoutManager.js");
var defaultScheduler = (0, _timeoutManagerJs.systemSetTimeoutZero);
function createNotifyManager() {
    let queue = [];
    let transactions = 0;
    let notifyFn = (callback)=>{
        callback();
    };
    let batchNotifyFn = (callback)=>{
        callback();
    };
    let scheduleFn = defaultScheduler;
    const schedule = (callback)=>{
        if (transactions) queue.push(callback);
        else scheduleFn(()=>{
            notifyFn(callback);
        });
    };
    const flush = ()=>{
        const originalQueue = queue;
        queue = [];
        if (originalQueue.length) scheduleFn(()=>{
            batchNotifyFn(()=>{
                originalQueue.forEach((callback)=>{
                    notifyFn(callback);
                });
            });
        });
    };
    return {
        batch: (callback)=>{
            let result;
            transactions++;
            try {
                result = callback();
            } finally{
                transactions--;
                if (!transactions) flush();
            }
            return result;
        },
        /**
     * All calls to the wrapped function will be batched.
     */ batchCalls: (callback)=>{
            return (...args)=>{
                schedule(()=>{
                    callback(...args);
                });
            };
        },
        schedule,
        /**
     * Use this method to set a custom notify function.
     * This can be used to for example wrap notifications with `React.act` while running tests.
     */ setNotifyFunction: (fn)=>{
            notifyFn = fn;
        },
        /**
     * Use this method to set a custom function to batch notifications together into a single tick.
     * By default React Query will use the batch function provided by ReactDOM or React Native.
     */ setBatchNotifyFunction: (fn)=>{
            batchNotifyFn = fn;
        },
        setScheduler: (fn)=>{
            scheduleFn = fn;
        }
    };
}
var notifyManager = createNotifyManager();

},{"./chunk-PXG64RU4.js":"eR9la","./timeoutManager.js":"jOTXc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jOTXc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeoutManager", ()=>TimeoutManager);
parcelHelpers.export(exports, "defaultTimeoutProvider", ()=>defaultTimeoutProvider);
parcelHelpers.export(exports, "systemSetTimeoutZero", ()=>systemSetTimeoutZero);
parcelHelpers.export(exports, "timeoutManager", ()=>timeoutManager);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/timeoutManager.ts
var defaultTimeoutProvider = {
    // We need the wrapper function syntax below instead of direct references to
    // global setTimeout etc.
    //
    // BAD: `setTimeout: setTimeout`
    // GOOD: `setTimeout: (cb, delay) => setTimeout(cb, delay)`
    //
    // If we use direct references here, then anything that wants to spy on or
    // replace the global setTimeout (like tests) won't work since we'll already
    // have a hard reference to the original implementation at the time when this
    // file was imported.
    setTimeout: (callback, delay)=>setTimeout(callback, delay),
    clearTimeout: (timeoutId)=>clearTimeout(timeoutId),
    setInterval: (callback, delay)=>setInterval(callback, delay),
    clearInterval: (intervalId)=>clearInterval(intervalId)
};
var _provider, _providerCalled;
var TimeoutManager = class {
    constructor(){
        // We cannot have TimeoutManager<T> as we must instantiate it with a concrete
        // type at app boot; and if we leave that type, then any new timer provider
        // would need to support ReturnType<typeof setTimeout>, which is infeasible.
        //
        // We settle for type safety for the TimeoutProvider type, and accept that
        // this class is unsafe internally to allow for extension.
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _provider, defaultTimeoutProvider);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _providerCalled, false);
    }
    setTimeoutProvider(provider) {
        (0, _chunkPXG64RU4Js.__privateSet)(this, _provider, provider);
    }
    setTimeout(callback, delay) {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _provider).setTimeout(callback, delay);
    }
    clearTimeout(timeoutId) {
        (0, _chunkPXG64RU4Js.__privateGet)(this, _provider).clearTimeout(timeoutId);
    }
    setInterval(callback, delay) {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _provider).setInterval(callback, delay);
    }
    clearInterval(intervalId) {
        (0, _chunkPXG64RU4Js.__privateGet)(this, _provider).clearInterval(intervalId);
    }
};
_provider = new WeakMap();
_providerCalled = new WeakMap();
var timeoutManager = new TimeoutManager();
function systemSetTimeoutZero(callback) {
    setTimeout(callback, 0);
}

},{"./chunk-PXG64RU4.js":"eR9la","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"22XBM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Removable", ()=>Removable);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/removable.ts
var _timeoutManagerJs = require("./timeoutManager.js");
var _utilsJs = require("./utils.js");
var _gcTimeout;
var Removable = class {
    constructor(){
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _gcTimeout);
    }
    destroy() {
        this.clearGcTimeout();
    }
    scheduleGc() {
        this.clearGcTimeout();
        if ((0, _utilsJs.isValidTimeout)(this.gcTime)) (0, _chunkPXG64RU4Js.__privateSet)(this, _gcTimeout, (0, _timeoutManagerJs.timeoutManager).setTimeout(()=>{
            this.optionalRemove();
        }, this.gcTime));
    }
    updateGcTime(newGcTime) {
        this.gcTime = Math.max(this.gcTime || 0, newGcTime ?? ((0, _utilsJs.isServer) ? Infinity : 300000));
    }
    clearGcTimeout() {
        if ((0, _chunkPXG64RU4Js.__privateGet)(this, _gcTimeout)) {
            (0, _timeoutManagerJs.timeoutManager).clearTimeout((0, _chunkPXG64RU4Js.__privateGet)(this, _gcTimeout));
            (0, _chunkPXG64RU4Js.__privateSet)(this, _gcTimeout, void 0);
        }
    }
};
_gcTimeout = new WeakMap();

},{"./chunk-PXG64RU4.js":"eR9la","./timeoutManager.js":"jOTXc","./utils.js":"ku1P9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ku1P9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addToEnd", ()=>addToEnd);
parcelHelpers.export(exports, "addToStart", ()=>addToStart);
parcelHelpers.export(exports, "ensureQueryFn", ()=>ensureQueryFn);
parcelHelpers.export(exports, "functionalUpdate", ()=>functionalUpdate);
parcelHelpers.export(exports, "hashKey", ()=>hashKey);
parcelHelpers.export(exports, "hashQueryKeyByOptions", ()=>hashQueryKeyByOptions);
parcelHelpers.export(exports, "isPlainArray", ()=>isPlainArray);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "isServer", ()=>isServer);
parcelHelpers.export(exports, "isValidTimeout", ()=>isValidTimeout);
parcelHelpers.export(exports, "keepPreviousData", ()=>keepPreviousData);
parcelHelpers.export(exports, "matchMutation", ()=>matchMutation);
parcelHelpers.export(exports, "matchQuery", ()=>matchQuery);
parcelHelpers.export(exports, "noop", ()=>noop);
parcelHelpers.export(exports, "partialMatchKey", ()=>partialMatchKey);
parcelHelpers.export(exports, "replaceData", ()=>replaceData);
parcelHelpers.export(exports, "replaceEqualDeep", ()=>replaceEqualDeep);
parcelHelpers.export(exports, "resolveEnabled", ()=>resolveEnabled);
parcelHelpers.export(exports, "resolveStaleTime", ()=>resolveStaleTime);
parcelHelpers.export(exports, "shallowEqualObjects", ()=>shallowEqualObjects);
parcelHelpers.export(exports, "shouldThrowError", ()=>shouldThrowError);
parcelHelpers.export(exports, "skipToken", ()=>skipToken);
parcelHelpers.export(exports, "sleep", ()=>sleep);
parcelHelpers.export(exports, "timeUntilStale", ()=>timeUntilStale);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/utils.ts
var _timeoutManagerJs = require("./timeoutManager.js");
var isServer = typeof window === "undefined" || "Deno" in globalThis;
function noop() {}
function functionalUpdate(updater, input) {
    return typeof updater === "function" ? updater(input) : updater;
}
function isValidTimeout(value) {
    return typeof value === "number" && value >= 0 && value !== Infinity;
}
function timeUntilStale(updatedAt, staleTime) {
    return Math.max(updatedAt + (staleTime || 0) - Date.now(), 0);
}
function resolveStaleTime(staleTime, query) {
    return typeof staleTime === "function" ? staleTime(query) : staleTime;
}
function resolveEnabled(enabled, query) {
    return typeof enabled === "function" ? enabled(query) : enabled;
}
function matchQuery(filters, query) {
    const { type = "all", exact, fetchStatus, predicate, queryKey, stale } = filters;
    if (queryKey) {
        if (exact) {
            if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) return false;
        } else if (!partialMatchKey(query.queryKey, queryKey)) return false;
    }
    if (type !== "all") {
        const isActive = query.isActive();
        if (type === "active" && !isActive) return false;
        if (type === "inactive" && isActive) return false;
    }
    if (typeof stale === "boolean" && query.isStale() !== stale) return false;
    if (fetchStatus && fetchStatus !== query.state.fetchStatus) return false;
    if (predicate && !predicate(query)) return false;
    return true;
}
function matchMutation(filters, mutation) {
    const { exact, status, predicate, mutationKey } = filters;
    if (mutationKey) {
        if (!mutation.options.mutationKey) return false;
        if (exact) {
            if (hashKey(mutation.options.mutationKey) !== hashKey(mutationKey)) return false;
        } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) return false;
    }
    if (status && mutation.state.status !== status) return false;
    if (predicate && !predicate(mutation)) return false;
    return true;
}
function hashQueryKeyByOptions(queryKey, options) {
    const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashKey;
    return hashFn(queryKey);
}
function hashKey(queryKey) {
    return JSON.stringify(queryKey, (_, val)=>isPlainObject(val) ? Object.keys(val).sort().reduce((result, key)=>{
            result[key] = val[key];
            return result;
        }, {}) : val);
}
function partialMatchKey(a, b) {
    if (a === b) return true;
    if (typeof a !== typeof b) return false;
    if (a && b && typeof a === "object" && typeof b === "object") return Object.keys(b).every((key)=>partialMatchKey(a[key], b[key]));
    return false;
}
var hasOwn = Object.prototype.hasOwnProperty;
function replaceEqualDeep(a, b) {
    if (a === b) return a;
    const array = isPlainArray(a) && isPlainArray(b);
    if (!array && !(isPlainObject(a) && isPlainObject(b))) return b;
    const aItems = array ? a : Object.keys(a);
    const aSize = aItems.length;
    const bItems = array ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy = array ? new Array(bSize) : {};
    let equalItems = 0;
    for(let i = 0; i < bSize; i++){
        const key = array ? i : bItems[i];
        const aItem = a[key];
        const bItem = b[key];
        if (aItem === bItem) {
            copy[key] = aItem;
            if (array ? i < aSize : hasOwn.call(a, key)) equalItems++;
            continue;
        }
        if (aItem === null || bItem === null || typeof aItem !== "object" || typeof bItem !== "object") {
            copy[key] = bItem;
            continue;
        }
        const v = replaceEqualDeep(aItem, bItem);
        copy[key] = v;
        if (v === aItem) equalItems++;
    }
    return aSize === bSize && equalItems === aSize ? a : copy;
}
function shallowEqualObjects(a, b) {
    if (!b || Object.keys(a).length !== Object.keys(b).length) return false;
    for(const key in a){
        if (a[key] !== b[key]) return false;
    }
    return true;
}
function isPlainArray(value) {
    return Array.isArray(value) && value.length === Object.keys(value).length;
}
function isPlainObject(o) {
    if (!hasObjectPrototype(o)) return false;
    const ctor = o.constructor;
    if (ctor === void 0) return true;
    const prot = ctor.prototype;
    if (!hasObjectPrototype(prot)) return false;
    if (!prot.hasOwnProperty("isPrototypeOf")) return false;
    if (Object.getPrototypeOf(o) !== Object.prototype) return false;
    return true;
}
function hasObjectPrototype(o) {
    return Object.prototype.toString.call(o) === "[object Object]";
}
function sleep(timeout) {
    return new Promise((resolve)=>{
        (0, _timeoutManagerJs.timeoutManager).setTimeout(resolve, timeout);
    });
}
function replaceData(prevData, data, options) {
    if (typeof options.structuralSharing === "function") return options.structuralSharing(prevData, data);
    else if (options.structuralSharing !== false) {
        var error;
        return replaceEqualDeep(prevData, data);
    }
    return data;
}
function keepPreviousData(previousData) {
    return previousData;
}
function addToEnd(items, item, max = 0) {
    const newItems = [
        ...items,
        item
    ];
    return max && newItems.length > max ? newItems.slice(1) : newItems;
}
function addToStart(items, item, max = 0) {
    const newItems = [
        item,
        ...items
    ];
    return max && newItems.length > max ? newItems.slice(0, -1) : newItems;
}
var skipToken = Symbol();
function ensureQueryFn(options, fetchOptions) {
    if (!options.queryFn && (fetchOptions == null ? void 0 : fetchOptions.initialPromise)) return ()=>fetchOptions.initialPromise;
    if (!options.queryFn || options.queryFn === skipToken) return ()=>Promise.reject(new Error(`Missing queryFn: '${options.queryHash}'`));
    return options.queryFn;
}
function shouldThrowError(throwOnError, params) {
    if (typeof throwOnError === "function") return throwOnError(...params);
    return !!throwOnError;
}

},{"./chunk-PXG64RU4.js":"eR9la","./timeoutManager.js":"jOTXc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ev2IU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelledError", ()=>CancelledError);
parcelHelpers.export(exports, "canFetch", ()=>canFetch);
parcelHelpers.export(exports, "createRetryer", ()=>createRetryer);
parcelHelpers.export(exports, "isCancelledError", ()=>isCancelledError);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/retryer.ts
var _focusManagerJs = require("./focusManager.js");
var _onlineManagerJs = require("./onlineManager.js");
var _thenableJs = require("./thenable.js");
var _utilsJs = require("./utils.js");
function defaultRetryDelay(failureCount) {
    return Math.min(1e3 * 2 ** failureCount, 3e4);
}
function canFetch(networkMode) {
    return (networkMode ?? "online") === "online" ? (0, _onlineManagerJs.onlineManager).isOnline() : true;
}
var CancelledError = class extends Error {
    constructor(options){
        super("CancelledError");
        this.revert = options == null ? void 0 : options.revert;
        this.silent = options == null ? void 0 : options.silent;
    }
};
function isCancelledError(value) {
    return value instanceof CancelledError;
}
function createRetryer(config) {
    let isRetryCancelled = false;
    let failureCount = 0;
    let continueFn;
    const thenable = (0, _thenableJs.pendingThenable)();
    const isResolved = ()=>thenable.status !== "pending";
    const cancel = (cancelOptions)=>{
        var _a;
        if (!isResolved()) {
            const error = new CancelledError(cancelOptions);
            reject(error);
            (_a = config.onCancel) == null || _a.call(config, error);
        }
    };
    const cancelRetry = ()=>{
        isRetryCancelled = true;
    };
    const continueRetry = ()=>{
        isRetryCancelled = false;
    };
    const canContinue = ()=>(0, _focusManagerJs.focusManager).isFocused() && (config.networkMode === "always" || (0, _onlineManagerJs.onlineManager).isOnline()) && config.canRun();
    const canStart = ()=>canFetch(config.networkMode) && config.canRun();
    const resolve = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.resolve(value);
        }
    };
    const reject = (value)=>{
        if (!isResolved()) {
            continueFn == null || continueFn();
            thenable.reject(value);
        }
    };
    const pause = ()=>{
        return new Promise((continueResolve)=>{
            var _a;
            continueFn = (value)=>{
                if (isResolved() || canContinue()) continueResolve(value);
            };
            (_a = config.onPause) == null || _a.call(config);
        }).then(()=>{
            var _a;
            continueFn = void 0;
            if (!isResolved()) (_a = config.onContinue) == null || _a.call(config);
        });
    };
    const run = ()=>{
        if (isResolved()) return;
        let promiseOrValue;
        const initialPromise = failureCount === 0 ? config.initialPromise : void 0;
        try {
            promiseOrValue = initialPromise ?? config.fn();
        } catch (error) {
            promiseOrValue = Promise.reject(error);
        }
        Promise.resolve(promiseOrValue).then(resolve).catch((error)=>{
            var _a;
            if (isResolved()) return;
            const retry = config.retry ?? ((0, _utilsJs.isServer) ? 0 : 3);
            const retryDelay = config.retryDelay ?? defaultRetryDelay;
            const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
            const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
            if (isRetryCancelled || !shouldRetry) {
                reject(error);
                return;
            }
            failureCount++;
            (_a = config.onFail) == null || _a.call(config, failureCount, error);
            (0, _utilsJs.sleep)(delay).then(()=>{
                return canContinue() ? void 0 : pause();
            }).then(()=>{
                if (isRetryCancelled) reject(error);
                else run();
            });
        });
    };
    return {
        promise: thenable,
        status: ()=>thenable.status,
        cancel,
        continue: ()=>{
            continueFn == null || continueFn();
            return thenable;
        },
        cancelRetry,
        continueRetry,
        canStart,
        start: ()=>{
            if (canStart()) run();
            else pause().then(run);
            return thenable;
        }
    };
}

},{"./chunk-PXG64RU4.js":"eR9la","./focusManager.js":"5x0my","./onlineManager.js":"iNMaz","./thenable.js":"j8LK5","./utils.js":"ku1P9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5x0my":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FocusManager", ()=>FocusManager);
parcelHelpers.export(exports, "focusManager", ()=>focusManager);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/focusManager.ts
var _subscribableJs = require("./subscribable.js");
var _utilsJs = require("./utils.js");
var _focused, _cleanup, _setup;
var FocusManager = class extends (0, _subscribableJs.Subscribable) {
    constructor(){
        super();
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _focused);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _cleanup);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _setup);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _setup, (onFocus)=>{
            if (!(0, _utilsJs.isServer) && window.addEventListener) {
                const listener = ()=>onFocus();
                window.addEventListener("visibilitychange", listener, false);
                return ()=>{
                    window.removeEventListener("visibilitychange", listener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, _chunkPXG64RU4Js.__privateGet)(this, _cleanup)) this.setEventListener((0, _chunkPXG64RU4Js.__privateGet)(this, _setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _cleanup)) == null || _a.call(this);
            (0, _chunkPXG64RU4Js.__privateSet)(this, _cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, _chunkPXG64RU4Js.__privateSet)(this, _setup, setup);
        (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _cleanup)) == null || _a.call(this);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _cleanup, setup((focused)=>{
            if (typeof focused === "boolean") this.setFocused(focused);
            else this.onFocus();
        }));
    }
    setFocused(focused) {
        const changed = (0, _chunkPXG64RU4Js.__privateGet)(this, _focused) !== focused;
        if (changed) {
            (0, _chunkPXG64RU4Js.__privateSet)(this, _focused, focused);
            this.onFocus();
        }
    }
    onFocus() {
        const isFocused = this.isFocused();
        this.listeners.forEach((listener)=>{
            listener(isFocused);
        });
    }
    isFocused() {
        var _a;
        if (typeof (0, _chunkPXG64RU4Js.__privateGet)(this, _focused) === "boolean") return (0, _chunkPXG64RU4Js.__privateGet)(this, _focused);
        return ((_a = globalThis.document) == null ? void 0 : _a.visibilityState) !== "hidden";
    }
};
_focused = new WeakMap();
_cleanup = new WeakMap();
_setup = new WeakMap();
var focusManager = new FocusManager();

},{"./chunk-PXG64RU4.js":"eR9la","./subscribable.js":"ifEuT","./utils.js":"ku1P9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ifEuT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Subscribable", ()=>Subscribable);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/subscribable.ts
var Subscribable = class {
    constructor(){
        this.listeners = /* @__PURE__ */ new Set();
        this.subscribe = this.subscribe.bind(this);
    }
    subscribe(listener) {
        this.listeners.add(listener);
        this.onSubscribe();
        return ()=>{
            this.listeners.delete(listener);
            this.onUnsubscribe();
        };
    }
    hasListeners() {
        return this.listeners.size > 0;
    }
    onSubscribe() {}
    onUnsubscribe() {}
};

},{"./chunk-PXG64RU4.js":"eR9la","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iNMaz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnlineManager", ()=>OnlineManager);
parcelHelpers.export(exports, "onlineManager", ()=>onlineManager);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/onlineManager.ts
var _subscribableJs = require("./subscribable.js");
var _utilsJs = require("./utils.js");
var _online, _cleanup, _setup;
var OnlineManager = class extends (0, _subscribableJs.Subscribable) {
    constructor(){
        super();
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _online, true);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _cleanup);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _setup);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _setup, (onOnline)=>{
            if (!(0, _utilsJs.isServer) && window.addEventListener) {
                const onlineListener = ()=>onOnline(true);
                const offlineListener = ()=>onOnline(false);
                window.addEventListener("online", onlineListener, false);
                window.addEventListener("offline", offlineListener, false);
                return ()=>{
                    window.removeEventListener("online", onlineListener);
                    window.removeEventListener("offline", offlineListener);
                };
            }
            return;
        });
    }
    onSubscribe() {
        if (!(0, _chunkPXG64RU4Js.__privateGet)(this, _cleanup)) this.setEventListener((0, _chunkPXG64RU4Js.__privateGet)(this, _setup));
    }
    onUnsubscribe() {
        var _a;
        if (!this.hasListeners()) {
            (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _cleanup)) == null || _a.call(this);
            (0, _chunkPXG64RU4Js.__privateSet)(this, _cleanup, void 0);
        }
    }
    setEventListener(setup) {
        var _a;
        (0, _chunkPXG64RU4Js.__privateSet)(this, _setup, setup);
        (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _cleanup)) == null || _a.call(this);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _cleanup, setup(this.setOnline.bind(this)));
    }
    setOnline(online) {
        const changed = (0, _chunkPXG64RU4Js.__privateGet)(this, _online) !== online;
        if (changed) {
            (0, _chunkPXG64RU4Js.__privateSet)(this, _online, online);
            this.listeners.forEach((listener)=>{
                listener(online);
            });
        }
    }
    isOnline() {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _online);
    }
};
_online = new WeakMap();
_cleanup = new WeakMap();
_setup = new WeakMap();
var onlineManager = new OnlineManager();

},{"./chunk-PXG64RU4.js":"eR9la","./subscribable.js":"ifEuT","./utils.js":"ku1P9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j8LK5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pendingThenable", ()=>pendingThenable);
parcelHelpers.export(exports, "tryResolveSync", ()=>tryResolveSync);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/thenable.ts
var _utilsJs = require("./utils.js");
function pendingThenable() {
    let resolve;
    let reject;
    const thenable = new Promise((_resolve, _reject)=>{
        resolve = _resolve;
        reject = _reject;
    });
    thenable.status = "pending";
    thenable.catch(()=>{});
    function finalize(data) {
        Object.assign(thenable, data);
        delete thenable.resolve;
        delete thenable.reject;
    }
    thenable.resolve = (value)=>{
        finalize({
            status: "fulfilled",
            value
        });
        resolve(value);
    };
    thenable.reject = (reason)=>{
        finalize({
            status: "rejected",
            reason
        });
        reject(reason);
    };
    return thenable;
}
function tryResolveSync(promise) {
    var _a;
    let data;
    (_a = promise.then((result)=>{
        data = result;
        return result;
    }, (0, _utilsJs.noop))) == null || _a.catch((0, _utilsJs.noop));
    if (data !== void 0) return {
        data
    };
    return void 0;
}

},{"./chunk-PXG64RU4.js":"eR9la","./utils.js":"ku1P9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kL5AO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>(0, _axiosJsDefault.default));
parcelHelpers.export(exports, "Axios", ()=>Axios);
parcelHelpers.export(exports, "AxiosError", ()=>AxiosError);
parcelHelpers.export(exports, "CanceledError", ()=>CanceledError);
parcelHelpers.export(exports, "isCancel", ()=>isCancel);
parcelHelpers.export(exports, "CancelToken", ()=>CancelToken);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
parcelHelpers.export(exports, "all", ()=>all);
parcelHelpers.export(exports, "Cancel", ()=>Cancel);
parcelHelpers.export(exports, "isAxiosError", ()=>isAxiosError);
parcelHelpers.export(exports, "spread", ()=>spread);
parcelHelpers.export(exports, "toFormData", ()=>toFormData);
parcelHelpers.export(exports, "AxiosHeaders", ()=>AxiosHeaders);
parcelHelpers.export(exports, "HttpStatusCode", ()=>HttpStatusCode);
parcelHelpers.export(exports, "formToJSON", ()=>formToJSON);
parcelHelpers.export(exports, "getAdapter", ()=>getAdapter);
parcelHelpers.export(exports, "mergeConfig", ()=>mergeConfig);
var _axiosJs = require("./lib/axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios, AxiosError, CanceledError, isCancel, CancelToken, VERSION, all, Cancel, isAxiosError, spread, toFormData, AxiosHeaders, HttpStatusCode, formToJSON, getAdapter, mergeConfig } = (0, _axiosJsDefault.default);

},{"./lib/axios.js":"dH7oj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dH7oj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var _axiosJs = require("./core/Axios.js");
var _axiosJsDefault = parcelHelpers.interopDefault(_axiosJs);
var _mergeConfigJs = require("./core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _indexJs = require("./defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("./helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
var _canceledErrorJs = require("./cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _cancelTokenJs = require("./cancel/CancelToken.js");
var _cancelTokenJsDefault = parcelHelpers.interopDefault(_cancelTokenJs);
var _isCancelJs = require("./cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _dataJs = require("./env/data.js");
var _toFormDataJs = require("./helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _axiosErrorJs = require("./core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _spreadJs = require("./helpers/spread.js");
var _spreadJsDefault = parcelHelpers.interopDefault(_spreadJs);
var _isAxiosErrorJs = require("./helpers/isAxiosError.js");
var _isAxiosErrorJsDefault = parcelHelpers.interopDefault(_isAxiosErrorJs);
var _axiosHeadersJs = require("./core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("./adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
var _httpStatusCodeJs = require("./helpers/HttpStatusCode.js");
var _httpStatusCodeJsDefault = parcelHelpers.interopDefault(_httpStatusCodeJs);
'use strict';
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function createInstance(defaultConfig) {
    const context = new (0, _axiosJsDefault.default)(defaultConfig);
    const instance = (0, _bindJsDefault.default)((0, _axiosJsDefault.default).prototype.request, context);
    // Copy axios.prototype to instance
    (0, _utilsJsDefault.default).extend(instance, (0, _axiosJsDefault.default).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, _utilsJsDefault.default).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return createInstance((0, _mergeConfigJsDefault.default)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const axios = createInstance((0, _indexJsDefault.default));
// Expose Axios class to allow class inheritance
axios.Axios = (0, _axiosJsDefault.default);
// Expose Cancel & CancelToken
axios.CanceledError = (0, _canceledErrorJsDefault.default);
axios.CancelToken = (0, _cancelTokenJsDefault.default);
axios.isCancel = (0, _isCancelJsDefault.default);
axios.VERSION = (0, _dataJs.VERSION);
axios.toFormData = (0, _toFormDataJsDefault.default);
// Expose AxiosError class
axios.AxiosError = (0, _axiosErrorJsDefault.default);
// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;
// Expose all/spread
axios.all = function all(promises) {
    return Promise.all(promises);
};
axios.spread = (0, _spreadJsDefault.default);
// Expose isAxiosError
axios.isAxiosError = (0, _isAxiosErrorJsDefault.default);
// Expose mergeConfig
axios.mergeConfig = (0, _mergeConfigJsDefault.default);
axios.AxiosHeaders = (0, _axiosHeadersJsDefault.default);
axios.formToJSON = (thing)=>(0, _formDataToJSONJsDefault.default)((0, _utilsJsDefault.default).isHTMLForm(thing) ? new FormData(thing) : thing);
axios.getAdapter = (0, _adaptersJsDefault.default).getAdapter;
axios.HttpStatusCode = (0, _httpStatusCodeJsDefault.default);
axios.default = axios;
// this module should only have a default export
exports.default = axios;

},{"./utils.js":"4AdI3","./helpers/bind.js":"dVXC5","./core/Axios.js":"lsoIO","./core/mergeConfig.js":"79q17","./defaults/index.js":"6V8DG","./helpers/formDataToJSON.js":"8eWn8","./cancel/CanceledError.js":"h2iVm","./cancel/CancelToken.js":"2bdtR","./cancel/isCancel.js":"2JSXk","./env/data.js":"2JBGK","./helpers/toFormData.js":"g2re0","./core/AxiosError.js":"fZ7SQ","./helpers/spread.js":"axv13","./helpers/isAxiosError.js":"eb8Z2","./core/AxiosHeaders.js":"jKjps","./adapters/adapters.js":"kiY1x","./helpers/HttpStatusCode.js":"lm3tN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4AdI3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _bindJs = require("./helpers/bind.js");
var _bindJsDefault = parcelHelpers.interopDefault(_bindJs);
var global = arguments[3];
'use strict';
// utils is a library of generic helper functions non-specific to axios
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const { iterator, toStringTag } = Symbol;
const kindOf = ((cache)=>(thing)=>{
        const str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>kindOf(thing) === type;
};
const typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const isUndefined = typeOfTest('undefined');
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function isBuffer(val) {
    return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const isArrayBuffer = kindOfTest('ArrayBuffer');
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const isString = typeOfTest('string');
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const isFunction = typeOfTest('function');
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const isNumber = typeOfTest('number');
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const isObject = (thing)=>thing !== null && typeof thing === 'object';
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const isPlainObject = (val)=>{
    if (kindOf(val) !== 'object') return false;
    const prototype = getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(toStringTag in val) && !(iterator in val);
};
/**
 * Determine if a value is an empty object (safely handles Buffers)
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an empty object, otherwise false
 */ const isEmptyObject = (val)=>{
    // Early return for non-objects or Buffers to prevent RangeError
    if (!isObject(val) || isBuffer(val)) return false;
    try {
        return Object.keys(val).length === 0 && Object.getPrototypeOf(val) === Object.prototype;
    } catch (e) {
        // Fallback for any other objects that might cause RangeError with Object.keys()
        return false;
    }
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const isDate = kindOfTest('Date');
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFile = kindOfTest('File');
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const isBlob = kindOfTest('Blob');
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const isFileList = kindOfTest('FileList');
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const isStream = (val)=>isObject(val) && isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === 'function' && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === 'formdata' || // detect form-data instance
    kind === 'object' && isFunction(thing.toString) && thing.toString() === '[object FormData]'));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const isURLSearchParams = kindOfTest('URLSearchParams');
const [isReadableStream, isRequest, isResponse, isHeaders] = [
    'ReadableStream',
    'Request',
    'Response',
    'Headers'
].map(kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function forEach(obj, fn, { allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === 'undefined') return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== 'object') /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if (isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Buffer check
        if (isBuffer(obj)) return;
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function findKey(obj, key) {
    if (isBuffer(obj)) return null;
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const _global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== 'undefined' ? window : global;
})();
const isContextDefined = (context)=>!isUndefined(context) && context !== _global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function merge() {
    const { caseless, skipUndefined } = isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && findKey(result, key) || key;
        if (isPlainObject(result[targetKey]) && isPlainObject(val)) result[targetKey] = merge(result[targetKey], val);
        else if (isPlainObject(val)) result[targetKey] = merge({}, val);
        else if (isArray(val)) result[targetKey] = val.slice();
        else if (!skipUndefined || !isUndefined(val)) result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const extend = (a, b, thisArg, { allOwnKeys } = {})=>{
    forEach(b, (val, key)=>{
        if (thisArg && isFunction(val)) a[key] = (0, _bindJsDefault.default)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, 'super', {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const toArray = (thing)=>{
    if (!thing) return null;
    if (isArray(thing)) return thing;
    let i = thing.length;
    if (!isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== 'undefined' && getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const forEachEntry = (obj, fn)=>{
    const generator = obj && obj[iterator];
    const _iterator = generator.call(obj);
    let result;
    while((result = _iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const isHTMLForm = kindOfTest('HTMLFormElement');
const toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const hasOwnProperty = (({ hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const isRegExp = kindOfTest('RegExp');
const reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const freezeMethods = (obj)=>{
    reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if (isFunction(obj) && [
            'arguments',
            'caller',
            'callee'
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!isFunction(value)) return;
        descriptor.enumerable = false;
        if ('writable' in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error('Can not rewrite read-only method \'' + name + '\'');
        };
    });
};
const toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const noop = ()=>{};
const toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function isSpecCompliantForm(thing) {
    return !!(thing && isFunction(thing.append) && thing[toStringTag] === 'FormData' && thing[iterator]);
}
const toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if (isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            //Buffer check
            if (isBuffer(source)) return source;
            if (!('toJSON' in source)) {
                stack[i] = source;
                const target = isArray(source) ? [] : {};
                forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const isAsyncFn = kindOfTest('AsyncFunction');
const isThenable = (thing)=>thing && (isObject(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const _setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        _global.addEventListener("message", ({ source, data })=>{
            if (source === _global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            _global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === 'function', isFunction(_global.postMessage));
const asap = typeof queueMicrotask !== 'undefined' ? queueMicrotask.bind(_global) : _setImmediate;
// *********************
const isIterable = (thing)=>thing != null && isFunction(thing[iterator]);
exports.default = {
    isArray,
    isArrayBuffer,
    isBuffer,
    isFormData,
    isArrayBufferView,
    isString,
    isNumber,
    isBoolean,
    isObject,
    isPlainObject,
    isEmptyObject,
    isReadableStream,
    isRequest,
    isResponse,
    isHeaders,
    isUndefined,
    isDate,
    isFile,
    isBlob,
    isRegExp,
    isFunction,
    isStream,
    isURLSearchParams,
    isTypedArray,
    isFileList,
    forEach,
    merge,
    extend,
    trim,
    stripBOM,
    inherits,
    toFlatObject,
    kindOf,
    kindOfTest,
    endsWith,
    toArray,
    forEachEntry,
    matchAll,
    isHTMLForm,
    hasOwnProperty,
    hasOwnProp: hasOwnProperty,
    reduceDescriptors,
    freezeMethods,
    toObjectSet,
    toCamelCase,
    noop,
    toFiniteNumber,
    findKey,
    global: _global,
    isContextDefined,
    isSpecCompliantForm,
    toJSONObject,
    isAsyncFn,
    isThenable,
    setImmediate: _setImmediate,
    asap,
    isIterable
};

},{"./helpers/bind.js":"dVXC5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dVXC5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>bind);
'use strict';
function bind(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lsoIO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _buildURLJs = require("../helpers/buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
var _interceptorManagerJs = require("./InterceptorManager.js");
var _interceptorManagerJsDefault = parcelHelpers.interopDefault(_interceptorManagerJs);
var _dispatchRequestJs = require("./dispatchRequest.js");
var _dispatchRequestJsDefault = parcelHelpers.interopDefault(_dispatchRequestJs);
var _mergeConfigJs = require("./mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _buildFullPathJs = require("./buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _validatorJs = require("../helpers/validator.js");
var _validatorJsDefault = parcelHelpers.interopDefault(_validatorJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const validators = (0, _validatorJsDefault.default).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig || {};
        this.interceptors = {
            request: new (0, _interceptorManagerJsDefault.default)(),
            response: new (0, _interceptorManagerJsDefault.default)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, '') : '';
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ''))) err.stack += '\n' + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === 'string') {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const { transitional, paramsSerializer, headers } = config;
        if (transitional !== undefined) (0, _validatorJsDefault.default).assertOptions(transitional, {
            silentJSONParsing: validators.transitional(validators.boolean),
            forcedJSONParsing: validators.transitional(validators.boolean),
            clarifyTimeoutError: validators.transitional(validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, _utilsJsDefault.default).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, _validatorJsDefault.default).assertOptions(paramsSerializer, {
                encode: validators.function,
                serialize: validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, _validatorJsDefault.default).assertOptions(config, {
            baseUrl: validators.spelling('baseURL'),
            withXsrfToken: validators.spelling('withXSRFToken')
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || 'get').toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, _utilsJsDefault.default).merge(headers.common, headers[config.method]);
        headers && (0, _utilsJsDefault.default).forEach([
            'delete',
            'get',
            'head',
            'post',
            'put',
            'patch',
            'common'
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, _axiosHeadersJsDefault.default).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, _dispatchRequestJsDefault.default).bind(this),
                undefined
            ];
            chain.unshift(...requestInterceptorChain);
            chain.push(...responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, _dispatchRequestJsDefault.default).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, _mergeConfigJsDefault.default)(this.defaults, config);
        const fullPath = (0, _buildFullPathJsDefault.default)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, _buildURLJsDefault.default)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'options'
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ Axios.prototype[method] = function(url, config) {
        return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
            method,
            url,
            data: (config || {}).data
        }));
    };
});
(0, _utilsJsDefault.default).forEach([
    'post',
    'put',
    'patch'
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, _mergeConfigJsDefault.default)(config || {}, {
                method,
                headers: isForm ? {
                    'Content-Type': 'multipart/form-data'
                } : {},
                url,
                data
            }));
        };
    }
    Axios.prototype[method] = generateHTTPMethod();
    Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});
exports.default = Axios;

},{"./../utils.js":"4AdI3","../helpers/buildURL.js":"4Gx5k","./InterceptorManager.js":"1SpXj","./dispatchRequest.js":"5W7kJ","./mergeConfig.js":"79q17","./buildFullPath.js":"cRRFe","../helpers/validator.js":"ii46t","./AxiosHeaders.js":"jKjps","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Gx5k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildURL);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosURLSearchParamsJs = require("../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+');
}
function buildURL(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || encode;
    if ((0, _utilsJsDefault.default).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, _utilsJsDefault.default).isURLSearchParams(params) ? params.toString() : new (0, _axiosURLSearchParamsJsDefault.default)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
    }
    return url;
}

},{"../utils.js":"4AdI3","../helpers/AxiosURLSearchParams.js":"445v1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"445v1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
'use strict';
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function encode(str) {
    const charMap = {
        '!': '%21',
        "'": '%27',
        '(': '%28',
        ')': '%29',
        '~': '%7E',
        '%20': '+',
        '%00': '\x00'
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, _toFormDataJsDefault.default)(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, encode);
    } : encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + '=' + _encode(pair[1]);
    }, '').join('&');
};
exports.default = AxiosURLSearchParams;

},{"./toFormData.js":"g2re0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g2re0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
// temporary hotfix to avoid circular references until AxiosURLSearchParams is refactored
var _formDataJs = require("../platform/node/classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var Buffer = require("adfd9b103875c2dd").Buffer;
'use strict';
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function isVisitable(thing) {
    return (0, _utilsJsDefault.default).isPlainObject(thing) || (0, _utilsJsDefault.default).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function removeBrackets(key) {
    return (0, _utilsJsDefault.default).endsWith(key, '[]') ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = removeBrackets(token);
        return !dots && i ? '[' + token + ']' : token;
    }).join(dots ? '.' : '');
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function isFlatArray(arr) {
    return (0, _utilsJsDefault.default).isArray(arr) && !arr.some(isVisitable);
}
const predicates = (0, _utilsJsDefault.default).toFlatObject((0, _utilsJsDefault.default), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function toFormData(obj, formData, options) {
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('target must be an object');
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, _formDataJsDefault.default) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, _utilsJsDefault.default).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, _utilsJsDefault.default).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== 'undefined' && Blob;
    const useBlob = _Blob && (0, _utilsJsDefault.default).isSpecCompliantForm(formData);
    if (!(0, _utilsJsDefault.default).isFunction(visitor)) throw new TypeError('visitor must be a function');
    function convertValue(value) {
        if (value === null) return '';
        if ((0, _utilsJsDefault.default).isDate(value)) return value.toISOString();
        if ((0, _utilsJsDefault.default).isBoolean(value)) return value.toString();
        if (!useBlob && (0, _utilsJsDefault.default).isBlob(value)) throw new (0, _axiosErrorJsDefault.default)('Blob is not supported. Use a Buffer instead.');
        if ((0, _utilsJsDefault.default).isArrayBuffer(value) || (0, _utilsJsDefault.default).isTypedArray(value)) return useBlob && typeof Blob === 'function' ? new Blob([
            value
        ]) : Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === 'object') {
            if ((0, _utilsJsDefault.default).endsWith(key, '{}')) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, _utilsJsDefault.default).isArray(value) && isFlatArray(value) || ((0, _utilsJsDefault.default).isFileList(value) || (0, _utilsJsDefault.default).endsWith(key, '[]')) && (arr = (0, _utilsJsDefault.default).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + '[]', convertValue(el));
                });
                return false;
            }
        }
        if (isVisitable(value)) return true;
        formData.append(renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign(predicates, {
        defaultVisitor,
        convertValue,
        isVisitable
    });
    function build(value, path) {
        if ((0, _utilsJsDefault.default).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error('Circular reference detected in ' + path.join('.'));
        stack.push(value);
        (0, _utilsJsDefault.default).forEach(value, function each(el, key) {
            const result = !((0, _utilsJsDefault.default).isUndefined(el) || el === null) && visitor.call(formData, el, (0, _utilsJsDefault.default).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, _utilsJsDefault.default).isObject(obj)) throw new TypeError('data must be an object');
    build(obj);
    return formData;
}
exports.default = toFormData;

},{"adfd9b103875c2dd":"cjdyz","../utils.js":"4AdI3","../core/AxiosError.js":"fZ7SQ","../platform/node/classes/FormData.js":"b3JVo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cjdyz":[function(require,module,exports,__globalThis) {
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ 'use strict';
const base64 = require("9c62938f1dccc73c");
const ieee754 = require("aceacb6a4531a9d2");
const customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
exports.Buffer = Buffer;
exports.SlowBuffer = SlowBuffer;
exports.INSPECT_MAX_BYTES = 50;
const K_MAX_LENGTH = 0x7fffffff;
exports.kMaxLength = K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty(Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty(Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function createBuffer(length) {
    if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return allocUnsafe(arg);
    }
    return from(arg, encodingOrOffset, length);
}
Buffer.poolSize = 8192 // not used by this implementation
;
function from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
    const b = fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ Buffer.from = function(value, encodingOrOffset, length) {
    return from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf(Buffer, Uint8Array);
function assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function alloc(size, fill, encoding) {
    assertSize(size);
    if (size <= 0) return createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
    return createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ Buffer.alloc = function(size, fill, encoding) {
    return alloc(size, fill, encoding);
};
function allocUnsafe(size) {
    assertSize(size);
    return createBuffer(size < 0 ? 0 : checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ Buffer.allocUnsafe = function(size) {
    return allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ Buffer.allocUnsafeSlow = function(size) {
    return allocUnsafe(size);
};
function fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = byteLength(string, encoding) | 0;
    let buf = createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function fromArrayLike(array) {
    const length = array.length < 0 ? 0 : checked(array.length) | 0;
    const buf = createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function fromArrayView(arrayView) {
    if (isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return fromArrayLike(arrayView);
}
function fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, Buffer.prototype);
    return buf;
}
function fromObject(obj) {
    if (Buffer.isBuffer(obj)) {
        const len = checked(obj.length) | 0;
        const buf = createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
        return fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
}
function checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function SlowBuffer(length) {
    if (+length != length) length = 0;
    return Buffer.alloc(+length);
}
Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
Buffer.compare = function compare(a, b) {
    if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
    if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
    if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if (isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!Buffer.isBuffer(buf)) buf = Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function byteLength(string, encoding) {
    if (Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
Buffer.byteLength = byteLength;
function slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return utf8Slice(this, start, end);
        case 'ascii':
            return asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return latin1Slice(this, start, end);
        case 'base64':
            return base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true;
function swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)swap(this, i, i + 1);
    return this;
};
Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        swap(this, i, i + 3);
        swap(this, i + 1, i + 2);
    }
    return this;
};
Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        swap(this, i, i + 7);
        swap(this, i + 1, i + 6);
        swap(this, i + 2, i + 5);
        swap(this, i + 3, i + 4);
    }
    return this;
};
Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return utf8Slice(this, 0, length);
    return slowToString.apply(this, arguments);
};
Buffer.prototype.toLocaleString = Buffer.prototype.toString;
Buffer.prototype.equals = function equals(b) {
    if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return Buffer.compare(this, b) === 0;
};
Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = exports.INSPECT_MAX_BYTES;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
    if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if (Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if (numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function utf8Write(buf, string, offset, length) {
    return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function asciiWrite(buf, string, offset, length) {
    return blitBuffer(asciiToBytes(string), buf, offset, length);
}
function base64Write(buf, string, offset, length) {
    return blitBuffer(base64ToBytes(string), buf, offset, length);
}
function ucs2Write(buf, string, offset, length) {
    return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return base64.fromByteArray(buf);
    else return base64.fromByteArray(buf.slice(start, end));
}
function utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const MAX_ARGUMENTS_LENGTH = 0x1000;
function decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
    return res;
}
function asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
    return out;
}
function utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
Buffer.prototype.readUintLE = Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
Buffer.prototype.readUintBE = Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
Buffer.prototype.readUint8 = Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    return this[offset];
};
Buffer.prototype.readUint16LE = Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
Buffer.prototype.readUint16BE = Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
Buffer.prototype.readUint32LE = Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
Buffer.prototype.readUint32BE = Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
Buffer.prototype.readBigUInt64LE = defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
Buffer.prototype.readBigUInt64BE = defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
Buffer.prototype.readBigInt64LE = defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
Buffer.prototype.readBigInt64BE = defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, true, 23, 4);
};
Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 4, this.length);
    return ieee754.read(this, offset, false, 23, 4);
};
Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, true, 52, 8);
};
Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) checkOffset(offset, 8, this.length);
    return ieee754.read(this, offset, false, 52, 8);
};
function checkInt(buf, value, offset, ext, max, min) {
    if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
Buffer.prototype.writeUintLE = Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUintBE = Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
Buffer.prototype.writeUint8 = Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeUint16LE = Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeUint16BE = Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeUint32LE = Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeUint32BE = Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function wrtBigUInt64LE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function wrtBigUInt64BE(buf, value, offset, min, max) {
    checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
Buffer.prototype.writeBigUInt64LE = defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeBigUInt64BE = defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
Buffer.prototype.writeBigInt64LE = defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
Buffer.prototype.writeBigInt64BE = defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return writeFloat(this, value, offset, true, noAssert);
};
Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return writeFloat(this, value, offset, false, noAssert);
};
function writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    ieee754.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return writeDouble(this, value, offset, true, noAssert);
};
Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const errors = {};
function E(sym, getMessage, Base) {
    errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function checkBounds(buf, offset, byteLength) {
    validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) boundsError(offset, buf.length - (byteLength + 1));
}
function checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    checkBounds(buf, offset, byteLength);
}
function validateNumber(value, name) {
    if (typeof value !== 'number') throw new errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        validateNumber(value, type);
        throw new errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace(INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function base64ToBytes(str) {
    return base64.toByteArray(base64clean(str));
}
function blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? BufferBigIntNotDefined : fn;
}
function BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

},{"9c62938f1dccc73c":"bICrG","aceacb6a4531a9d2":"7IMNJ"}],"bICrG":[function(require,module,exports,__globalThis) {
'use strict';
exports.byteLength = byteLength;
exports.toByteArray = toByteArray;
exports.fromByteArray = fromByteArray;
var lookup = [];
var revLookup = [];
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var i = 0, len = code.length; i < len; ++i){
    lookup[i] = code[i];
    revLookup[code.charCodeAt(i)] = i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62;
revLookup['_'.charCodeAt(0)] = 63;
function getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function byteLength(b64) {
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function _byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function toByteArray(b64) {
    var tmp;
    var lens = getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = revLookup[b64.charCodeAt(i)] << 18 | revLookup[b64.charCodeAt(i + 1)] << 12 | revLookup[b64.charCodeAt(i + 2)] << 6 | revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = revLookup[b64.charCodeAt(i)] << 2 | revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = revLookup[b64.charCodeAt(i)] << 10 | revLookup[b64.charCodeAt(i + 1)] << 4 | revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function tripletToBase64(num) {
    return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F];
}
function encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push(tripletToBase64(tmp));
    }
    return output.join('');
}
function fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push(encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push(lookup[tmp >> 2] + lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push(lookup[tmp >> 10] + lookup[tmp >> 4 & 0x3F] + lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

},{}],"7IMNJ":[function(require,module,exports,__globalThis) {
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ exports.read = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
exports.write = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

},{}],"fZ7SQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = 'AxiosError';
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, _utilsJsDefault.default).inherits(AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, _utilsJsDefault.default).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const prototype = AxiosError.prototype;
const descriptors = {};
[
    'ERR_BAD_OPTION_VALUE',
    'ERR_BAD_OPTION',
    'ECONNABORTED',
    'ETIMEDOUT',
    'ERR_NETWORK',
    'ERR_FR_TOO_MANY_REDIRECTS',
    'ERR_DEPRECATED',
    'ERR_BAD_RESPONSE',
    'ERR_BAD_REQUEST',
    'ERR_CANCELED',
    'ERR_NOT_SUPPORT',
    'ERR_INVALID_URL'
].forEach((code)=>{
    descriptors[code] = {
        value: code
    };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {
    value: true
});
// eslint-disable-next-line func-names
AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create(prototype);
    (0, _utilsJsDefault.default).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== 'isAxiosError';
    });
    const msg = error && error.message ? error.message : 'Error';
    // Prefer explicit code; otherwise copy the low-level error's code (e.g. ECONNREFUSED)
    const errCode = code == null && error ? error.code : code;
    AxiosError.call(axiosError, msg, errCode, config, request, response);
    // Chain the original error on the standard field; non-enumerable to avoid JSON noise
    if (error && axiosError.cause == null) Object.defineProperty(axiosError, 'cause', {
        value: error,
        configurable: true
    });
    axiosError.name = error && error.name || 'Error';
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
exports.default = AxiosError;

},{"../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b3JVo":[function(require,module,exports,__globalThis) {
// eslint-disable-next-line strict
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
exports.default = null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1SpXj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
class InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled,
            rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {void}
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, _utilsJsDefault.default).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
exports.default = InterceptorManager;

},{"./../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5W7kJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>dispatchRequest);
var _transformDataJs = require("./transformData.js");
var _transformDataJsDefault = parcelHelpers.interopDefault(_transformDataJs);
var _isCancelJs = require("../cancel/isCancel.js");
var _isCancelJsDefault = parcelHelpers.interopDefault(_isCancelJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _adaptersJs = require("../adapters/adapters.js");
var _adaptersJsDefault = parcelHelpers.interopDefault(_adaptersJs);
'use strict';
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, _canceledErrorJsDefault.default)(null, config);
}
function dispatchRequest(config) {
    throwIfCancellationRequested(config);
    config.headers = (0, _axiosHeadersJsDefault.default).from(config.headers);
    // Transform request data
    config.data = (0, _transformDataJsDefault.default).call(config, config.transformRequest);
    if ([
        'post',
        'put',
        'patch'
    ].indexOf(config.method) !== -1) config.headers.setContentType('application/x-www-form-urlencoded', false);
    const adapter = (0, _adaptersJsDefault.default).getAdapter(config.adapter || (0, _indexJsDefault.default).adapter, config);
    return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, response);
        response.headers = (0, _axiosHeadersJsDefault.default).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, _isCancelJsDefault.default)(reason)) {
            throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, _transformDataJsDefault.default).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, _axiosHeadersJsDefault.default).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}

},{"./transformData.js":"5PMg8","../cancel/isCancel.js":"2JSXk","../defaults/index.js":"6V8DG","../cancel/CanceledError.js":"h2iVm","../core/AxiosHeaders.js":"jKjps","../adapters/adapters.js":"kiY1x","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5PMg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>transformData);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../defaults/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
function transformData(fns, response) {
    const config = this || (0, _indexJsDefault.default);
    const context = response || config;
    const headers = (0, _axiosHeadersJsDefault.default).from(context.headers);
    let data = context.data;
    (0, _utilsJsDefault.default).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}

},{"./../utils.js":"4AdI3","../defaults/index.js":"6V8DG","../core/AxiosHeaders.js":"jKjps","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6V8DG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _transitionalJs = require("./transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _toFormDataJs = require("../helpers/toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _toURLEncodedFormJs = require("../helpers/toURLEncodedForm.js");
var _toURLEncodedFormJsDefault = parcelHelpers.interopDefault(_toURLEncodedFormJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _formDataToJSONJs = require("../helpers/formDataToJSON.js");
var _formDataToJSONJsDefault = parcelHelpers.interopDefault(_formDataToJSONJs);
'use strict';
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function stringifySafely(rawValue, parser, encoder) {
    if ((0, _utilsJsDefault.default).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, _utilsJsDefault.default).trim(rawValue);
    } catch (e) {
        if (e.name !== 'SyntaxError') throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const defaults = {
    transitional: (0, _transitionalJsDefault.default),
    adapter: [
        'xhr',
        'http',
        'fetch'
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || '';
            const hasJSONContentType = contentType.indexOf('application/json') > -1;
            const isObjectPayload = (0, _utilsJsDefault.default).isObject(data);
            if (isObjectPayload && (0, _utilsJsDefault.default).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, _utilsJsDefault.default).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, _formDataToJSONJsDefault.default)(data)) : data;
            if ((0, _utilsJsDefault.default).isArrayBuffer(data) || (0, _utilsJsDefault.default).isBuffer(data) || (0, _utilsJsDefault.default).isStream(data) || (0, _utilsJsDefault.default).isFile(data) || (0, _utilsJsDefault.default).isBlob(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if ((0, _utilsJsDefault.default).isArrayBufferView(data)) return data.buffer;
            if ((0, _utilsJsDefault.default).isURLSearchParams(data)) {
                headers.setContentType('application/x-www-form-urlencoded;charset=utf-8', false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf('application/x-www-form-urlencoded') > -1) return (0, _toURLEncodedFormJsDefault.default)(data, this.formSerializer).toString();
                if ((isFileList = (0, _utilsJsDefault.default).isFileList(data)) || contentType.indexOf('multipart/form-data') > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, _toFormDataJsDefault.default)(isFileList ? {
                        'files[]': data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType('application/json', false);
                return stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === 'json';
            if ((0, _utilsJsDefault.default).isResponse(data) || (0, _utilsJsDefault.default).isReadableStream(data)) return data;
            if (data && (0, _utilsJsDefault.default).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data, this.parseReviver);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === 'SyntaxError') throw (0, _axiosErrorJsDefault.default).from(e, (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: 'XSRF-TOKEN',
    xsrfHeaderName: 'X-XSRF-TOKEN',
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, _indexJsDefault.default).classes.FormData,
        Blob: (0, _indexJsDefault.default).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': undefined
        }
    }
};
(0, _utilsJsDefault.default).forEach([
    'delete',
    'get',
    'head',
    'post',
    'put',
    'patch'
], (method)=>{
    defaults.headers[method] = {};
});
exports.default = defaults;

},{"../utils.js":"4AdI3","../core/AxiosError.js":"fZ7SQ","./transitional.js":"jktpl","../helpers/toFormData.js":"g2re0","../helpers/toURLEncodedForm.js":"3U162","../platform/index.js":"dnuuz","../helpers/formDataToJSON.js":"8eWn8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jktpl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3U162":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>toURLEncodedForm);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _toFormDataJs = require("./toFormData.js");
var _toFormDataJsDefault = parcelHelpers.interopDefault(_toFormDataJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
'use strict';
function toURLEncodedForm(data, options) {
    return (0, _toFormDataJsDefault.default)(data, new (0, _indexJsDefault.default).classes.URLSearchParams(), {
        visitor: function(value, key, path, helpers) {
            if ((0, _indexJsDefault.default).isNode && (0, _utilsJsDefault.default).isBuffer(value)) {
                this.append(key, value.toString('base64'));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        },
        ...options
    });
}

},{"../utils.js":"4AdI3","./toFormData.js":"g2re0","../platform/index.js":"dnuuz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dnuuz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("./node/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("./common/utils.js");
exports.default = {
    ..._utilsJs,
    ...(0, _indexJsDefault.default)
};

},{"./node/index.js":"2AMRr","./common/utils.js":"giiKQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2AMRr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _urlsearchParamsJs = require("./classes/URLSearchParams.js");
var _urlsearchParamsJsDefault = parcelHelpers.interopDefault(_urlsearchParamsJs);
var _formDataJs = require("./classes/FormData.js");
var _formDataJsDefault = parcelHelpers.interopDefault(_formDataJs);
var _blobJs = require("./classes/Blob.js");
var _blobJsDefault = parcelHelpers.interopDefault(_blobJs);
exports.default = {
    isBrowser: true,
    classes: {
        URLSearchParams: (0, _urlsearchParamsJsDefault.default),
        FormData: (0, _formDataJsDefault.default),
        Blob: (0, _blobJsDefault.default)
    },
    protocols: [
        'http',
        'https',
        'file',
        'blob',
        'url',
        'data'
    ]
};

},{"./classes/URLSearchParams.js":"lpTM0","./classes/FormData.js":"iMRAt","./classes/Blob.js":"hYmoQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lpTM0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosURLSearchParamsJs = require("../../../helpers/AxiosURLSearchParams.js");
var _axiosURLSearchParamsJsDefault = parcelHelpers.interopDefault(_axiosURLSearchParamsJs);
'use strict';
exports.default = typeof URLSearchParams !== 'undefined' ? URLSearchParams : (0, _axiosURLSearchParamsJsDefault.default);

},{"../../../helpers/AxiosURLSearchParams.js":"445v1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iMRAt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof FormData !== 'undefined' ? FormData : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hYmoQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
exports.default = typeof Blob !== 'undefined' ? Blob : null;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"giiKQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasBrowserEnv", ()=>hasBrowserEnv);
parcelHelpers.export(exports, "hasStandardBrowserWebWorkerEnv", ()=>hasStandardBrowserWebWorkerEnv);
parcelHelpers.export(exports, "hasStandardBrowserEnv", ()=>hasStandardBrowserEnv);
parcelHelpers.export(exports, "navigator", ()=>_navigator);
parcelHelpers.export(exports, "origin", ()=>origin);
const hasBrowserEnv = typeof window !== 'undefined' && typeof document !== 'undefined';
const _navigator = typeof navigator === 'object' && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || [
    'ReactNative',
    'NativeScript',
    'NS'
].indexOf(_navigator.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const hasStandardBrowserWebWorkerEnv = (()=>{
    return typeof WorkerGlobalScope !== 'undefined' && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === 'function';
})();
const origin = hasBrowserEnv && window.location.href || 'http://localhost';

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8eWn8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, _utilsJsDefault.default).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === '[]' ? '' : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === '__proto__') return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, _utilsJsDefault.default).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, _utilsJsDefault.default).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, _utilsJsDefault.default).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, _utilsJsDefault.default).isArray(target[name])) target[name] = arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, _utilsJsDefault.default).isFormData(formData) && (0, _utilsJsDefault.default).isFunction(formData.entries)) {
        const obj = {};
        (0, _utilsJsDefault.default).forEachEntry(formData, (name, value)=>{
            buildPath(parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
exports.default = formDataToJSON;

},{"../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jKjps":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _parseHeadersJs = require("../helpers/parseHeaders.js");
var _parseHeadersJsDefault = parcelHelpers.interopDefault(_parseHeadersJs);
'use strict';
const $internals = Symbol('internals');
function normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, _utilsJsDefault.default).isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, _utilsJsDefault.default).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, _utilsJsDefault.default).isString(value)) return;
    if ((0, _utilsJsDefault.default).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, _utilsJsDefault.default).isRegExp(filter)) return filter.test(value);
}
function formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function buildAccessors(obj, header) {
    const accessorName = (0, _utilsJsDefault.default).toCamelCase(' ' + header);
    [
        'get',
        'set',
        'has'
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = normalizeHeader(_header);
            if (!lHeader) throw new Error('header name must be a non-empty string');
            const key = (0, _utilsJsDefault.default).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, _utilsJsDefault.default).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, _utilsJsDefault.default).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isString(header) && (header = header.trim()) && !isValidHeaderName(header)) setHeaders((0, _parseHeadersJsDefault.default)(header), valueOrRewrite);
        else if ((0, _utilsJsDefault.default).isObject(header) && (0, _utilsJsDefault.default).isIterable(header)) {
            let obj = {}, dest, key;
            for (const entry of header){
                if (!(0, _utilsJsDefault.default).isArray(entry)) throw TypeError('Object iterator must return a key-value pair');
                obj[key = entry[0]] = (dest = obj[key]) ? (0, _utilsJsDefault.default).isArray(dest) ? [
                    ...dest,
                    entry[1]
                ] : [
                    dest,
                    entry[1]
                ] : entry[1];
            }
            setHeaders(obj, valueOrRewrite);
        } else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return parseTokens(value);
                if ((0, _utilsJsDefault.default).isFunction(parser)) return parser.call(this, value, key);
                if ((0, _utilsJsDefault.default).isRegExp(parser)) return parser.exec(value);
                throw new TypeError('parser must be boolean|regexp|function');
            }
        }
    }
    has(header, matcher) {
        header = normalizeHeader(header);
        if (header) {
            const key = (0, _utilsJsDefault.default).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = normalizeHeader(_header);
            if (_header) {
                const key = (0, _utilsJsDefault.default).findKey(self, _header);
                if (key && (!matcher || matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, _utilsJsDefault.default).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            const key = (0, _utilsJsDefault.default).findKey(headers, header);
            if (key) {
                self[key] = normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, _utilsJsDefault.default).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, _utilsJsDefault.default).isArray(value) ? value.join(', ') : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ': ' + value).join('\n');
    }
    getSetCookie() {
        return this.get("set-cookie") || [];
    }
    get [Symbol.toStringTag]() {
        return 'AxiosHeaders';
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$internals] = this[$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = normalizeHeader(_header);
            if (!accessors[lHeader]) {
                buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, _utilsJsDefault.default).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
AxiosHeaders.accessor([
    'Content-Type',
    'Content-Length',
    'Accept',
    'Accept-Encoding',
    'User-Agent',
    'Authorization'
]);
// reserved names hotfix
(0, _utilsJsDefault.default).reduceDescriptors(AxiosHeaders.prototype, ({ value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, _utilsJsDefault.default).freezeMethods(AxiosHeaders);
exports.default = AxiosHeaders;

},{"../utils.js":"4AdI3","../helpers/parseHeaders.js":"hf5eq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hf5eq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const ignoreDuplicateOf = (0, _utilsJsDefault.default).toObjectSet([
    'age',
    'authorization',
    'content-length',
    'content-type',
    'etag',
    'expires',
    'from',
    'host',
    'if-modified-since',
    'if-unmodified-since',
    'last-modified',
    'location',
    'max-forwards',
    'proxy-authorization',
    'referer',
    'retry-after',
    'user-agent'
]);
/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ exports.default = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split('\n').forEach(function parser(line) {
        i = line.indexOf(':');
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && ignoreDuplicateOf[key]) return;
        if (key === 'set-cookie') {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    });
    return parsed;
};

},{"./../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2JSXk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isCancel);
'use strict';
function isCancel(value) {
    return !!(value && value.__CANCEL__);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h2iVm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, _axiosErrorJsDefault.default).call(this, message == null ? 'canceled' : message, (0, _axiosErrorJsDefault.default).ERR_CANCELED, config, request);
    this.name = 'CanceledError';
}
(0, _utilsJsDefault.default).inherits(CanceledError, (0, _axiosErrorJsDefault.default), {
    __CANCEL__: true
});
exports.default = CanceledError;

},{"../core/AxiosError.js":"fZ7SQ","../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kiY1x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _httpJs = require("./http.js");
var _httpJsDefault = parcelHelpers.interopDefault(_httpJs);
var _xhrJs = require("./xhr.js");
var _xhrJsDefault = parcelHelpers.interopDefault(_xhrJs);
var _fetchJs = require("./fetch.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
/**
 * Known adapters mapping.
 * Provides environment-specific adapters for Axios:
 * - `http` for Node.js
 * - `xhr` for browsers
 * - `fetch` for fetch API-based requests
 * 
 * @type {Object<string, Function|Object>}
 */ const knownAdapters = {
    http: (0, _httpJsDefault.default),
    xhr: (0, _xhrJsDefault.default),
    fetch: {
        get: _fetchJs.getFetch
    }
};
// Assign adapter names for easier debugging and identification
(0, _utilsJsDefault.default).forEach(knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, 'name', {
                value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, 'adapterName', {
            value
        });
    }
});
/**
 * Render a rejection reason string for unknown or unsupported adapters
 * 
 * @param {string} reason
 * @returns {string}
 */ const renderReason = (reason)=>`- ${reason}`;
/**
 * Check if the adapter is resolved (function, null, or false)
 * 
 * @param {Function|null|false} adapter
 * @returns {boolean}
 */ const isResolvedHandle = (adapter)=>(0, _utilsJsDefault.default).isFunction(adapter) || adapter === null || adapter === false;
/**
 * Get the first suitable adapter from the provided list.
 * Tries each adapter in order until a supported one is found.
 * Throws an AxiosError if no adapter is suitable.
 * 
 * @param {Array<string|Function>|string|Function} adapters - Adapter(s) by name or function.
 * @param {Object} config - Axios request configuration
 * @throws {AxiosError} If no suitable adapter is available
 * @returns {Function} The resolved adapter function
 */ function getAdapter(adapters, config) {
    adapters = (0, _utilsJsDefault.default).isArray(adapters) ? adapters : [
        adapters
    ];
    const { length } = adapters;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for(let i = 0; i < length; i++){
        nameOrAdapter = adapters[i];
        let id;
        adapter = nameOrAdapter;
        if (!isResolvedHandle(nameOrAdapter)) {
            adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
            if (adapter === undefined) throw new (0, _axiosErrorJsDefault.default)(`Unknown adapter '${id}'`);
        }
        if (adapter && ((0, _utilsJsDefault.default).isFunction(adapter) || (adapter = adapter.get(config)))) break;
        rejectedReasons[id || '#' + i] = adapter;
    }
    if (!adapter) {
        const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? 'is not supported by the environment' : 'is not available in the build'));
        let s = length ? reasons.length > 1 ? 'since :\n' + reasons.map(renderReason).join('\n') : ' ' + renderReason(reasons[0]) : 'as no adapter specified';
        throw new (0, _axiosErrorJsDefault.default)(`There is no suitable adapter to dispatch the request ` + s, 'ERR_NOT_SUPPORT');
    }
    return adapter;
}
/**
 * Exports Axios adapters and utility to resolve an adapter
 */ exports.default = {
    /**
   * Resolve an adapter from a list of adapter names or functions.
   * @type {Function}
   */ getAdapter,
    /**
   * Exposes all known adapters
   * @type {Object<string, Function|Object>}
   */ adapters: knownAdapters
};

},{"../utils.js":"4AdI3","./http.js":"b3JVo","./xhr.js":"f0yTJ","./fetch.js":"1RQlp","../core/AxiosError.js":"fZ7SQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f0yTJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _settleJs = require("./../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
var _transitionalJs = require("../defaults/transitional.js");
var _transitionalJsDefault = parcelHelpers.interopDefault(_transitionalJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _parseProtocolJs = require("../helpers/parseProtocol.js");
var _parseProtocolJsDefault = parcelHelpers.interopDefault(_parseProtocolJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
const isXHRAdapterSupported = typeof XMLHttpRequest !== 'undefined';
exports.default = isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, _resolveConfigJsDefault.default)(config);
        let requestData = _config.data;
        const requestHeaders = (0, _axiosHeadersJsDefault.default).from(_config.headers).normalize();
        let { responseType, onUploadProgress, onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener('abort', onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, _axiosHeadersJsDefault.default).from('getAllResponseHeaders' in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === 'text' || responseType === 'json' ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config,
                request
            };
            (0, _settleJsDefault.default)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ('onloadend' in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, _axiosErrorJsDefault.default)('Request aborted', (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError(event) {
            // Browsers deliver a ProgressEvent in XHR onerror
            // (message may be empty; when present, surface it)
            // See https://developer.mozilla.org/docs/Web/API/XMLHttpRequest/error_event
            const msg = event && event.message ? event.message : 'Network Error';
            const err = new (0, _axiosErrorJsDefault.default)(msg, (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request);
            // attach the underlying event for consumers who want details
            err.event = event || null;
            reject(err);
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? 'timeout of ' + _config.timeout + 'ms exceeded' : 'timeout exceeded';
            const transitional = _config.transitional || (0, _transitionalJsDefault.default);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, _axiosErrorJsDefault.default)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, _axiosErrorJsDefault.default).ETIMEDOUT : (0, _axiosErrorJsDefault.default).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ('setRequestHeader' in request) (0, _utilsJsDefault.default).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, _utilsJsDefault.default).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== 'json') request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, _progressEventReducerJs.progressEventReducer)(onDownloadProgress, true);
            request.addEventListener('progress', downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, _progressEventReducerJs.progressEventReducer)(onUploadProgress);
            request.upload.addEventListener('progress', uploadThrottled);
            request.upload.addEventListener('loadend', flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, _canceledErrorJsDefault.default)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener('abort', onCanceled);
        }
        const protocol = (0, _parseProtocolJsDefault.default)(_config.url);
        if (protocol && (0, _indexJsDefault.default).protocols.indexOf(protocol) === -1) {
            reject(new (0, _axiosErrorJsDefault.default)('Unsupported protocol ' + protocol + ':', (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};

},{"./../utils.js":"4AdI3","./../core/settle.js":"f469A","../defaults/transitional.js":"jktpl","../core/AxiosError.js":"fZ7SQ","../cancel/CanceledError.js":"h2iVm","../helpers/parseProtocol.js":"5fJNM","../platform/index.js":"dnuuz","../core/AxiosHeaders.js":"jKjps","../helpers/progressEventReducer.js":"ctmjb","../helpers/resolveConfig.js":"ed2el","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f469A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>settle);
var _axiosErrorJs = require("./AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
function settle(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, _axiosErrorJsDefault.default)('Request failed with status code ' + response.status, [
        (0, _axiosErrorJsDefault.default).ERR_BAD_REQUEST,
        (0, _axiosErrorJsDefault.default).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}

},{"./AxiosError.js":"fZ7SQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5fJNM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>parseProtocol);
'use strict';
function parseProtocol(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || '';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ctmjb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "progressEventReducer", ()=>progressEventReducer);
parcelHelpers.export(exports, "progressEventDecorator", ()=>progressEventDecorator);
parcelHelpers.export(exports, "asyncDecorator", ()=>asyncDecorator);
var _speedometerJs = require("./speedometer.js");
var _speedometerJsDefault = parcelHelpers.interopDefault(_speedometerJs);
var _throttleJs = require("./throttle.js");
var _throttleJsDefault = parcelHelpers.interopDefault(_throttleJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const progressEventReducer = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, _speedometerJsDefault.default)(50, 250);
    return (0, _throttleJsDefault.default)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded,
            total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? 'download' : 'upload']: true
        };
        listener(data);
    }, freq);
};
const progressEventDecorator = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable,
                total,
                loaded
            }),
        throttled[1]
    ];
};
const asyncDecorator = (fn)=>(...args)=>(0, _utilsJsDefault.default).asap(()=>fn(...args));

},{"./speedometer.js":"eVf9f","./throttle.js":"lGTVn","../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eVf9f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
'use strict';
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
exports.default = speedometer;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lGTVn":[function(require,module,exports,__globalThis) {
/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
function throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn(...args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
exports.default = throttle;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ed2el":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _isURLSameOriginJs = require("./isURLSameOrigin.js");
var _isURLSameOriginJsDefault = parcelHelpers.interopDefault(_isURLSameOriginJs);
var _cookiesJs = require("./cookies.js");
var _cookiesJsDefault = parcelHelpers.interopDefault(_cookiesJs);
var _buildFullPathJs = require("../core/buildFullPath.js");
var _buildFullPathJsDefault = parcelHelpers.interopDefault(_buildFullPathJs);
var _mergeConfigJs = require("../core/mergeConfig.js");
var _mergeConfigJsDefault = parcelHelpers.interopDefault(_mergeConfigJs);
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _buildURLJs = require("./buildURL.js");
var _buildURLJsDefault = parcelHelpers.interopDefault(_buildURLJs);
exports.default = (config)=>{
    const newConfig = (0, _mergeConfigJsDefault.default)({}, config);
    let { data, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth } = newConfig;
    newConfig.headers = headers = (0, _axiosHeadersJsDefault.default).from(headers);
    newConfig.url = (0, _buildURLJsDefault.default)((0, _buildFullPathJsDefault.default)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set('Authorization', 'Basic ' + btoa((auth.username || '') + ':' + (auth.password ? unescape(encodeURIComponent(auth.password)) : '')));
    if ((0, _utilsJsDefault.default).isFormData(data)) {
        if ((0, _indexJsDefault.default).hasStandardBrowserEnv || (0, _indexJsDefault.default).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // browser handles it
        else if ((0, _utilsJsDefault.default).isFunction(data.getHeaders)) {
            // Node.js FormData (like form-data package)
            const formHeaders = data.getHeaders();
            // Only set safe headers to avoid overwriting security headers
            const allowedHeaders = [
                'content-type',
                'content-length'
            ];
            Object.entries(formHeaders).forEach(([key, val])=>{
                if (allowedHeaders.includes(key.toLowerCase())) headers.set(key, val);
            });
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, _indexJsDefault.default).hasStandardBrowserEnv) {
        withXSRFToken && (0, _utilsJsDefault.default).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, _isURLSameOriginJsDefault.default)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, _cookiesJsDefault.default).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};

},{"../platform/index.js":"dnuuz","../utils.js":"4AdI3","./isURLSameOrigin.js":"bJ3hX","./cookies.js":"g1WPK","../core/buildFullPath.js":"cRRFe","../core/mergeConfig.js":"79q17","../core/AxiosHeaders.js":"jKjps","./buildURL.js":"4Gx5k","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bJ3hX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, _indexJsDefault.default).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, _indexJsDefault.default).origin), (0, _indexJsDefault.default).navigator && /(msie|trident)/i.test((0, _indexJsDefault.default).navigator.userAgent)) : ()=>true;

},{"../platform/index.js":"dnuuz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g1WPK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
exports.default = (0, _indexJsDefault.default).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure, sameSite) {
        if (typeof document === 'undefined') return;
        const cookie = [
            `${name}=${encodeURIComponent(value)}`
        ];
        if ((0, _utilsJsDefault.default).isNumber(expires)) cookie.push(`expires=${new Date(expires).toUTCString()}`);
        if ((0, _utilsJsDefault.default).isString(path)) cookie.push(`path=${path}`);
        if ((0, _utilsJsDefault.default).isString(domain)) cookie.push(`domain=${domain}`);
        if (secure === true) cookie.push('secure');
        if ((0, _utilsJsDefault.default).isString(sameSite)) cookie.push(`SameSite=${sameSite}`);
        document.cookie = cookie.join('; ');
    },
    read (name) {
        if (typeof document === 'undefined') return null;
        const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
        return match ? decodeURIComponent(match[1]) : null;
    },
    remove (name) {
        this.write(name, '', Date.now() - 86400000, '/');
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};

},{"./../utils.js":"4AdI3","../platform/index.js":"dnuuz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cRRFe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>buildFullPath);
var _isAbsoluteURLJs = require("../helpers/isAbsoluteURL.js");
var _isAbsoluteURLJsDefault = parcelHelpers.interopDefault(_isAbsoluteURLJs);
var _combineURLsJs = require("../helpers/combineURLs.js");
var _combineURLsJsDefault = parcelHelpers.interopDefault(_combineURLsJs);
'use strict';
function buildFullPath(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, _isAbsoluteURLJsDefault.default)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, _combineURLsJsDefault.default)(baseURL, requestedURL);
    return requestedURL;
}

},{"../helpers/isAbsoluteURL.js":"WNHRO","../helpers/combineURLs.js":"92Aol","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"WNHRO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAbsoluteURL);
'use strict';
function isAbsoluteURL(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"92Aol":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>combineURLs);
'use strict';
function combineURLs(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, '') + '/' + relativeURL.replace(/^\/+/, '') : baseURL;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"79q17":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>mergeConfig);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosHeadersJs = require("./AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
'use strict';
const headersToObject = (thing)=>thing instanceof (0, _axiosHeadersJsDefault.default) ? {
        ...thing
    } : thing;
function mergeConfig(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, _utilsJsDefault.default).isPlainObject(target) && (0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge.call({
            caseless
        }, target, source);
        else if ((0, _utilsJsDefault.default).isPlainObject(source)) return (0, _utilsJsDefault.default).merge({}, source);
        else if ((0, _utilsJsDefault.default).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, _utilsJsDefault.default).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, _utilsJsDefault.default).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties(headersToObject(a), headersToObject(b), prop, true)
    };
    (0, _utilsJsDefault.default).forEach(Object.keys({
        ...config1,
        ...config2
    }), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, _utilsJsDefault.default).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}

},{"../utils.js":"4AdI3","./AxiosHeaders.js":"jKjps","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1RQlp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFetch", ()=>getFetch);
var _indexJs = require("../platform/index.js");
var _indexJsDefault = parcelHelpers.interopDefault(_indexJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _composeSignalsJs = require("../helpers/composeSignals.js");
var _composeSignalsJsDefault = parcelHelpers.interopDefault(_composeSignalsJs);
var _trackStreamJs = require("../helpers/trackStream.js");
var _axiosHeadersJs = require("../core/AxiosHeaders.js");
var _axiosHeadersJsDefault = parcelHelpers.interopDefault(_axiosHeadersJs);
var _progressEventReducerJs = require("../helpers/progressEventReducer.js");
var _resolveConfigJs = require("../helpers/resolveConfig.js");
var _resolveConfigJsDefault = parcelHelpers.interopDefault(_resolveConfigJs);
var _settleJs = require("../core/settle.js");
var _settleJsDefault = parcelHelpers.interopDefault(_settleJs);
const DEFAULT_CHUNK_SIZE = 65536;
const { isFunction } = (0, _utilsJsDefault.default);
const globalFetchAPI = (({ Request, Response })=>({
        Request,
        Response
    }))((0, _utilsJsDefault.default).global);
const { ReadableStream, TextEncoder } = (0, _utilsJsDefault.default).global;
const test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const factory = (env)=>{
    env = (0, _utilsJsDefault.default).merge.call({
        skipUndefined: true
    }, globalFetchAPI, env);
    const { fetch: envFetch, Request, Response } = env;
    const isFetchSupported = envFetch ? isFunction(envFetch) : typeof fetch === 'function';
    const isRequestSupported = isFunction(Request);
    const isResponseSupported = isFunction(Response);
    if (!isFetchSupported) return false;
    const isReadableStreamSupported = isFetchSupported && isFunction(ReadableStream);
    const encodeText = isFetchSupported && (typeof TextEncoder === 'function' ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Request(str).arrayBuffer()));
    const supportsRequestStream = isRequestSupported && isReadableStreamSupported && test(()=>{
        let duplexAccessed = false;
        const hasContentType = new Request((0, _indexJsDefault.default).origin, {
            body: new ReadableStream(),
            method: 'POST',
            get duplex () {
                duplexAccessed = true;
                return 'half';
            }
        }).headers.has('Content-Type');
        return duplexAccessed && !hasContentType;
    });
    const supportsResponseStream = isResponseSupported && isReadableStreamSupported && test(()=>(0, _utilsJsDefault.default).isReadableStream(new Response('').body));
    const resolvers = {
        stream: supportsResponseStream && ((res)=>res.body)
    };
    isFetchSupported && (()=>{
        [
            'text',
            'arrayBuffer',
            'blob',
            'formData',
            'stream'
        ].forEach((type)=>{
            !resolvers[type] && (resolvers[type] = (res, config)=>{
                let method = res && res[type];
                if (method) return method.call(res);
                throw new (0, _axiosErrorJsDefault.default)(`Response type '${type}' is not supported`, (0, _axiosErrorJsDefault.default).ERR_NOT_SUPPORT, config);
            });
        });
    })();
    const getBodyLength = async (body)=>{
        if (body == null) return 0;
        if ((0, _utilsJsDefault.default).isBlob(body)) return body.size;
        if ((0, _utilsJsDefault.default).isSpecCompliantForm(body)) {
            const _request = new Request((0, _indexJsDefault.default).origin, {
                method: 'POST',
                body
            });
            return (await _request.arrayBuffer()).byteLength;
        }
        if ((0, _utilsJsDefault.default).isArrayBufferView(body) || (0, _utilsJsDefault.default).isArrayBuffer(body)) return body.byteLength;
        if ((0, _utilsJsDefault.default).isURLSearchParams(body)) body = body + '';
        if ((0, _utilsJsDefault.default).isString(body)) return (await encodeText(body)).byteLength;
    };
    const resolveBodyLength = async (headers, body)=>{
        const length = (0, _utilsJsDefault.default).toFiniteNumber(headers.getContentLength());
        return length == null ? getBodyLength(body) : length;
    };
    return async (config)=>{
        let { url, method, data, signal, cancelToken, timeout, onDownloadProgress, onUploadProgress, responseType, headers, withCredentials = 'same-origin', fetchOptions } = (0, _resolveConfigJsDefault.default)(config);
        let _fetch = envFetch || fetch;
        responseType = responseType ? (responseType + '').toLowerCase() : 'text';
        let composedSignal = (0, _composeSignalsJsDefault.default)([
            signal,
            cancelToken && cancelToken.toAbortSignal()
        ], timeout);
        let request = null;
        const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
            composedSignal.unsubscribe();
        });
        let requestContentLength;
        try {
            if (onUploadProgress && supportsRequestStream && method !== 'get' && method !== 'head' && (requestContentLength = await resolveBodyLength(headers, data)) !== 0) {
                let _request = new Request(url, {
                    method: 'POST',
                    body: data,
                    duplex: "half"
                });
                let contentTypeHeader;
                if ((0, _utilsJsDefault.default).isFormData(data) && (contentTypeHeader = _request.headers.get('content-type'))) headers.setContentType(contentTypeHeader);
                if (_request.body) {
                    const [onProgress, flush] = (0, _progressEventReducerJs.progressEventDecorator)(requestContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onUploadProgress)));
                    data = (0, _trackStreamJs.trackStream)(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
                }
            }
            if (!(0, _utilsJsDefault.default).isString(withCredentials)) withCredentials = withCredentials ? 'include' : 'omit';
            // Cloudflare Workers throws when credentials are defined
            // see https://github.com/cloudflare/workerd/issues/902
            const isCredentialsSupported = isRequestSupported && "credentials" in Request.prototype;
            const resolvedOptions = {
                ...fetchOptions,
                signal: composedSignal,
                method: method.toUpperCase(),
                headers: headers.normalize().toJSON(),
                body: data,
                duplex: "half",
                credentials: isCredentialsSupported ? withCredentials : undefined
            };
            request = isRequestSupported && new Request(url, resolvedOptions);
            let response = await (isRequestSupported ? _fetch(request, fetchOptions) : _fetch(url, resolvedOptions));
            const isStreamResponse = supportsResponseStream && (responseType === 'stream' || responseType === 'response');
            if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
                const options = {};
                [
                    'status',
                    'statusText',
                    'headers'
                ].forEach((prop)=>{
                    options[prop] = response[prop];
                });
                const responseContentLength = (0, _utilsJsDefault.default).toFiniteNumber(response.headers.get('content-length'));
                const [onProgress, flush] = onDownloadProgress && (0, _progressEventReducerJs.progressEventDecorator)(responseContentLength, (0, _progressEventReducerJs.progressEventReducer)((0, _progressEventReducerJs.asyncDecorator)(onDownloadProgress), true)) || [];
                response = new Response((0, _trackStreamJs.trackStream)(response.body, DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                    flush && flush();
                    unsubscribe && unsubscribe();
                }), options);
            }
            responseType = responseType || 'text';
            let responseData = await resolvers[(0, _utilsJsDefault.default).findKey(resolvers, responseType) || 'text'](response, config);
            !isStreamResponse && unsubscribe && unsubscribe();
            return await new Promise((resolve, reject)=>{
                (0, _settleJsDefault.default)(resolve, reject, {
                    data: responseData,
                    headers: (0, _axiosHeadersJsDefault.default).from(response.headers),
                    status: response.status,
                    statusText: response.statusText,
                    config,
                    request
                });
            });
        } catch (err) {
            unsubscribe && unsubscribe();
            if (err && err.name === 'TypeError' && /Load failed|fetch/i.test(err.message)) throw Object.assign(new (0, _axiosErrorJsDefault.default)('Network Error', (0, _axiosErrorJsDefault.default).ERR_NETWORK, config, request), {
                cause: err.cause || err
            });
            throw (0, _axiosErrorJsDefault.default).from(err, err && err.code, config, request);
        }
    };
};
const seedCache = new Map();
const getFetch = (config)=>{
    let env = config && config.env || {};
    const { fetch: fetch1, Request, Response } = env;
    const seeds = [
        Request,
        Response,
        fetch1
    ];
    let len = seeds.length, i = len, seed, target, map = seedCache;
    while(i--){
        seed = seeds[i];
        target = map.get(seed);
        target === undefined && map.set(seed, target = i ? new Map() : factory(env));
        map = target;
    }
    return target;
};
const adapter = getFetch();
exports.default = adapter;

},{"../platform/index.js":"dnuuz","../utils.js":"4AdI3","../core/AxiosError.js":"fZ7SQ","../helpers/composeSignals.js":"5luDQ","../helpers/trackStream.js":"5CnPE","../core/AxiosHeaders.js":"jKjps","../helpers/progressEventReducer.js":"ctmjb","../helpers/resolveConfig.js":"ed2el","../core/settle.js":"f469A","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5luDQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("../cancel/CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
var _utilsJs = require("../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
const composeSignals = (signals, timeout)=>{
    const { length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, _axiosErrorJsDefault.default) ? err : new (0, _canceledErrorJsDefault.default)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, _axiosErrorJsDefault.default)(`timeout ${timeout} of ms exceeded`, (0, _axiosErrorJsDefault.default).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener('abort', onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener('abort', onabort));
        const { signal } = controller;
        signal.unsubscribe = ()=>(0, _utilsJsDefault.default).asap(unsubscribe);
        return signal;
    }
};
exports.default = composeSignals;

},{"../cancel/CanceledError.js":"h2iVm","../core/AxiosError.js":"fZ7SQ","../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5CnPE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "streamChunk", ()=>streamChunk);
parcelHelpers.export(exports, "readBytes", ()=>readBytes);
parcelHelpers.export(exports, "trackStream", ()=>trackStream);
const streamChunk = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const readBytes = async function*(iterable, chunkSize) {
    for await (const chunk of readStream(iterable))yield* streamChunk(chunk, chunkSize);
};
const readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done, value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const trackStream = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = readBytes(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done, value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ii46t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dataJs = require("../env/data.js");
var _axiosErrorJs = require("../core/AxiosError.js");
var _axiosErrorJsDefault = parcelHelpers.interopDefault(_axiosErrorJs);
'use strict';
const validators = {};
// eslint-disable-next-line func-names
[
    'object',
    'boolean',
    'number',
    'function',
    'string',
    'symbol'
].forEach((type, i)=>{
    validators[type] = function validator(thing) {
        return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
    };
});
const deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return '[Axios v' + (0, _dataJs.VERSION) + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, _axiosErrorJsDefault.default)(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')), (0, _axiosErrorJsDefault.default).ERR_DEPRECATED);
        if (version && !deprecatedWarnings[opt]) {
            deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, ' has been deprecated since v' + version + ' and will be removed in the near future'));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function assertOptions(options, schema, allowUnknown) {
    if (typeof options !== 'object') throw new (0, _axiosErrorJsDefault.default)('options must be an object', (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, _axiosErrorJsDefault.default)('option ' + opt + ' must be ' + result, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, _axiosErrorJsDefault.default)('Unknown option ' + opt, (0, _axiosErrorJsDefault.default).ERR_BAD_OPTION);
    }
}
exports.default = {
    assertOptions,
    validators
};

},{"../env/data.js":"2JBGK","../core/AxiosError.js":"fZ7SQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2JBGK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VERSION", ()=>VERSION);
const VERSION = "1.13.2";

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2bdtR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _canceledErrorJs = require("./CanceledError.js");
var _canceledErrorJsDefault = parcelHelpers.interopDefault(_canceledErrorJs);
'use strict';
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class CancelToken {
    constructor(executor){
        if (typeof executor !== 'function') throw new TypeError('executor must be a function.');
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, _canceledErrorJsDefault.default)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token,
            cancel
        };
    }
}
exports.default = CancelToken;

},{"./CanceledError.js":"h2iVm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"axv13":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>spread);
'use strict';
function spread(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eb8Z2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>isAxiosError);
var _utilsJs = require("./../utils.js");
var _utilsJsDefault = parcelHelpers.interopDefault(_utilsJs);
'use strict';
function isAxiosError(payload) {
    return (0, _utilsJsDefault.default).isObject(payload) && payload.isAxiosError === true;
}

},{"./../utils.js":"4AdI3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lm3tN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511,
    WebServerIsDown: 521,
    ConnectionTimedOut: 522,
    OriginIsUnreachable: 523,
    TimeoutOccurred: 524,
    SslHandshakeFailed: 525,
    InvalidSslCertificate: 526
};
Object.entries(HttpStatusCode).forEach(([key, value])=>{
    HttpStatusCode[value] = key;
});
exports.default = HttpStatusCode;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9oD3c":[function(require,module,exports,__globalThis) {
/* App config for apis
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IS_DEV", ()=>IS_DEV);
parcelHelpers.export(exports, "DOMAIN_NAME", ()=>DOMAIN_NAME);
const IS_DEV = false;
const DOMAIN_NAME = 'https://us-central1-minipt-1.cloudfunctions.net/waitlist/';
const ApiConfig = {
    AUTH_HEADER: '',
    BASE_URL: DOMAIN_NAME,
    SIGNUP: 'signup',
    LOGIN: 'login',
    WAITLIST_API_HOST: 'waitlist',
    CLOUD_FUNCTIONS_BASE_URL: 'https://us-central1-minipt-1.cloudfunctions.net/',
    CREATE_USER_PROFILE_API_HOST: 'create_user_profile',
    SUMMARIZE_INSTRUCTION_API_HOST: 'summarize_instruction',
    SUMMARIZE_INSTRUCTION_PROD_API_HOST: 'summarize_instruction_prod',
    GENERATE_WORKOUT_PROGRAM_COACH_API_HOST: 'generate_workout_program_coach',
    USER_BEHAVIOR_TRACKER_API_HOST: 'user_behavior_tracker',
    // Onboarding API endpoints
    TRAINER_GET_ONBOARDING_MASTER_DATA: 'trainer_get_onboarding_master_data',
    TRAINER_GET_ONBOARDING_STATE: 'trainer_get_onboarding_state',
    TRAINER_SAVE_ONBOARDING_STEP: 'trainer_save_onboarding_step',
    TRAINER_GET_SCHEDULE: 'trainer_get_schedule',
    TRAINER_UPDATE_SCHEDULE: 'trainer_update_schedule',
    TRAINER_CHECK_SCHEDULE_CONFLICTS: 'trainer_check_schedule_conflicts',
    TRAINER_GET_PROGRAM_MASTER_DATA: 'trainer_get_program_master_data',
    TRAINER_SAVE_PROGRAM_PROGRESS: 'trainer_save_program_progress',
    TRAINER_GET_PROGRAMS: 'trainer_get_programs',
    TRAINER_GET_ALL_MOVEMENTS: 'trainer_get_all_movements',
    // Package API endpoints
    TRAINER_GET_PACKAGES: 'trainer_get_packages',
    TRAINER_SAVE_PACKAGE: 'trainer_save_package',
    TRAINER_UNPUBLISH_PACKAGE: 'trainer_unpublish_package',
    TRAINER_DELETE_PACKAGE: 'trainer_delete_package',
    TRAINER_GET_PACKAGE_TEMPLATES: 'trainer_get_package_templates',
    TRAINER_GET_DOCUMENT_TEMPLATES: 'trainer_get_document_templates',
    // Client API endpoints
    TRAINER_ADD_CLIENT: 'trainer_add_client',
    TRAINER_GET_CLIENTS: 'trainer_get_clients',
    TRAINER_UPDATE_CLIENT_STATUS: 'trainer_update_client_status',
    TRAINER_UPDATE_PROFILE: 'trainer_update_profile',
    TRAINER_GET_CLIENT_FITNESS_PROFILE: 'trainer_get_client_fitness_profile',
    TRAINER_GET_CLIENT_WORKOUT_DETAILS: 'trainer_get_client_workout_details',
    TRAINER_GET_CLIENT_PROGRAM_TAB: 'trainer_get_client_program_tab',
    TRAINER_GET_CLIENT_PROFILE_TAB: 'trainer_get_client_profile_tab',
    TRAINER_GET_CLIENT_WORKOUTS_TAB: 'trainer_get_client_workouts_tab',
    TRAINER_GET_CLIENT_OVERVIEW: 'trainer_get_client_overview',
    TRAINER_GET_CLIENT_NOTES: 'trainer_get_client_notes',
    TRAINER_ADD_CLIENT_NOTE: 'trainer_add_client_note',
    TRAINER_DELETE_CLIENT_NOTE: 'trainer_delete_client_note',
    TRAINER_PIN_CLIENT_NOTE: 'trainer_pin_client_note',
    // Messages API endpoints
    TRAINER_GET_MESSAGES: 'trainer_get_messages',
    TRAINER_GET_UNREAD_MESSAGES: 'trainer_get_unread_messages',
    TRAINER_GET_CHAT_MEDIA: 'trainer_get_chat_media',
    TRAINER_SEARCH_CONVERSATION_MESSAGES: 'trainer_search_conversation_messages',
    TRAINER_GET_MESSAGE_CONTEXT_WINDOW: 'trainer_get_message_context_window',
    // Check-ins API endpoints
    TRAINER_GET_CHECKINS: 'trainer_get_checkins',
    TRAINER_GET_CHECKIN_DETAILS: 'trainer_get_checkin_details',
    TRAINER_MARK_CHECKIN_READ: 'trainer_mark_checkin_read',
    TRAINER_CONFIRM_CHECKIN: 'trainer_confirm_checkin',
    TRAINER_COMPLETE_CHECKIN: 'trainer_complete_checkin',
    TRAINER_GET_ZOOM_MEETING_STATUS: 'trainer_get_zoom_meeting_status',
    TRAINER_SUGGEST_CHECKIN: 'trainer_suggest_checkin',
    TRAINER_DECLINE_CHECKIN: 'trainer_decline_checkin',
    TRAINER_SEND_CHECKIN_REMINDER: 'trainer_send_checkin_reminder',
    TRAINER_UPDATE_CHECKIN_ACTION_ITEMS: 'trainer_update_checkin_action_items',
    // Support Reports & Block Client API endpoints
    TRAINER_SUBMIT_SUPPORT_REPORT: 'trainer_submit_support_report',
    TRAINER_BLOCK_CLIENT: 'trainer_block_client',
    TRAINER_UNBLOCK_CLIENT: 'trainer_unblock_client',
    // Program Plan API endpoints
    GENERATE_WORKOUT_PROGRAM_COACH_PROD_API_HOST: 'trainer_generate_workout_program',
    TRAINER_CREATE_PROGRAM_DRAFT: 'trainer_create_program_draft',
    TRAINER_SAVE_PROGRAMME_PLAN: 'trainer_save_programme_plan',
    TRAINER_GET_PROGRAM_PLAN_LIST: 'trainer_get_program_plan_list',
    TRAINER_GET_PROGRAM_PLAN_BY_ID: 'trainer_get_program_plan_by_id',
    TRAINER_ARCHIVE_PROGRAM_PLAN: 'trainer_archive_program_plan',
    TRAINER_DELETE_PROGRAM_PLAN: 'trainer_delete_program_plan',
    TRAINER_DUPLICATE_PROGRAM_PLAN: 'trainer_duplicate_program_plan',
    TRAINER_SEND_PROGRAMME_PLAN_TO_CLIENT: 'trainer_send_programme_plan_to_client',
    TRAINER_UPDATE_PROGRAMME_CALENDAR: 'trainer_update_programme_calendar',
    // Subscription API endpoints
    SUBSCRIPTION_API_BASE: 'subscription_api',
    TRAINER_GET_ENTITLEMENTS: 'trainer_get_entitlements',
    TRAINER_CHECK_FEATURE_ACCESS: 'trainer_check_feature_access',
    TRAINER_GET_SUBSCRIPTION_PLANS: 'trainer_get_subscription_plans',
    TRAINER_GET_TRIAL_ELIGIBILITY: 'trainer_get_trial_eligibility',
    TRAINER_PREVIEW_CHECKOUT: 'trainer_preview_checkout',
    TRAINER_VALIDATE_PROMO_CODE: 'trainer_validate_promo_code',
    TRAINER_CHECKOUT_SUBSCRIPTION: 'trainer_checkout_subscription',
    TRAINER_SYNC_SUBSCRIPTION: 'trainer_sync_subscription',
    TRAINER_GET_PAYMENT_OPERATION_STATUS: 'trainer_get_payment_operation_status',
    TRAINER_GET_TERMS_OF_SERVICE: 'trainer_get_terms_of_service',
    TRAINER_GET_PRIVACY_POLICY: 'trainer_get_privacy_policy',
    TRAINER_RECORD_LEGAL_ACKNOWLEDGEMENT: 'trainer_record_legal_acknowledgement',
    TRAINER_GET_BILLING_PROFILE: 'trainer_get_billing_profile',
    TRAINER_SAVE_BILLING_PROFILE: 'trainer_save_billing_profile',
    TRAINER_VALIDATE_BILLING_PROFILE: 'trainer_validate_billing_profile',
    TRAINER_CREATE_SETUP_INTENT: 'trainer_create_setup_intent',
    TRAINER_GET_STRIPE_CONFIG: 'trainer_get_stripe_config',
    TRAINER_GET_PAYMENT_METHODS: 'trainer_get_payment_methods',
    TRAINER_SAVE_PAYMENT_METHOD: 'trainer_save_payment_method',
    TRAINER_SET_DEFAULT_PAYMENT_METHOD: 'trainer_set_default_payment_method',
    TRAINER_REPLACE_PAYMENT_METHOD: 'trainer_replace_payment_method',
    TRAINER_DELETE_PAYMENT_METHOD: 'trainer_delete_payment_method',
    TRAINER_GET_SUBSCRIPTION_STATE: 'trainer_get_subscription_state',
    TRAINER_CANCEL_SUBSCRIPTION: 'trainer_cancel_subscription',
    TRAINER_REACTIVATE_SUBSCRIPTION: 'trainer_reactivate_subscription',
    TRAINER_SWITCH_BILLING_INTERVAL_PREVIEW: 'trainer_switch_billing_interval_preview',
    TRAINER_SWITCH_BILLING_INTERVAL: 'trainer_switch_billing_interval',
    TRAINER_CANCEL_SCHEDULED_INTERVAL_SWITCH: 'trainer_cancel_scheduled_interval_switch',
    TRAINER_RETRY_INVOICE_PAYMENT: 'trainer_retry_invoice_payment',
    TRAINER_GET_BILLING_HISTORY: 'trainer_get_billing_history',
    TRAINER_GET_INVOICE_DOWNLOAD_URL: 'trainer_get_invoice_download_url',
    TRAINER_DOWNLOAD_ALL_INVOICES: 'trainer_download_all_invoices',
    TRAINER_GET_EXPORT_STATUS: 'trainer_get_export_status',
    TRAINER_GET_SUPPORT_CONFIG: 'trainer_get_support_config',
    TRAINER_CONTACT_SUPPORT: 'trainer_contact_support',
    TRAINER_DELETE_SUPPORT_ATTACHMENT: 'trainer_delete_support_attachment',
    TRAINER_PREVIEW_ACCOUNT_DELETION: 'trainer_preview_account_deletion',
    TRAINER_REQUEST_ACCOUNT_DELETION: 'trainer_request_account_deletion',
    TRAINER_GET_ACCOUNT_DELETION_STATUS: 'trainer_get_account_deletion_status'
};
exports.default = ApiConfig;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"krjj7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trainerProgramUser", ()=>trainerProgramUser);
parcelHelpers.export(exports, "trainerProgramStep", ()=>trainerProgramStep);
parcelHelpers.export(exports, "fitnessLevels", ()=>fitnessLevels);
parcelHelpers.export(exports, "trainingActivityLike", ()=>trainingActivityLike);
parcelHelpers.export(exports, "trainingMovementGrade", ()=>trainingMovementGrade);
parcelHelpers.export(exports, "trainingGoal", ()=>trainingGoal);
parcelHelpers.export(exports, "traniningLimitation", ()=>traniningLimitation);
parcelHelpers.export(exports, "trainingEnergyLevel", ()=>trainingEnergyLevel);
parcelHelpers.export(exports, "trainingScheduleFlexibility", ()=>trainingScheduleFlexibility);
parcelHelpers.export(exports, "trainingIntensity", ()=>trainingIntensity);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// Assets
var _armsWebp = require("url:../assets/images/injuries/arms.webp");
var _armsWebpDefault = parcelHelpers.interopDefault(_armsWebp);
var _shouldersWebp = require("url:../assets/images/injuries/shoulders.webp");
var _shouldersWebpDefault = parcelHelpers.interopDefault(_shouldersWebp);
var _chestWebp = require("url:../assets/images/injuries/chest.webp");
var _chestWebpDefault = parcelHelpers.interopDefault(_chestWebp);
var _coreWebp = require("url:../assets/images/injuries/core.webp");
var _coreWebpDefault = parcelHelpers.interopDefault(_coreWebp);
var _backWebp = require("url:../assets/images/injuries/back.webp");
var _backWebpDefault = parcelHelpers.interopDefault(_backWebp);
var _glutesWebp = require("url:../assets/images/injuries/glutes.webp");
var _glutesWebpDefault = parcelHelpers.interopDefault(_glutesWebp);
var _legsWebp = require("url:../assets/images/injuries/legs.webp");
var _legsWebpDefault = parcelHelpers.interopDefault(_legsWebp);
const trainerProgramUser = [
    {
        _id: 'emily_demo',
        name: 'Emily Thompson (Demo)',
        avatar: 'https://i.pravatar.cc/128?img=5'
    },
    {
        _id: 'oliver_demo',
        name: 'Oliver Bennett (Demo)',
        avatar: 'https://i.pravatar.cc/128?img=3'
    }
];
const trainerProgramStep = [];
const fitnessLevels = [
    {
        name: 'Beginner',
        emoji: "\uD83D\uDFE1",
        descriptions: [
            'New to training or inconsistent experience',
            'Learning basic movement patterns and form',
            'Low strength and endurance base',
            'Needs simple, guided programs'
        ]
    },
    {
        name: 'Early Intermediate',
        emoji: "\uD83D\uDFE0",
        descriptions: [
            'Training consistently for a few months',
            'Improving technique in major exercises',
            'Building strength and confidence',
            'Can handle slightly structured programs'
        ]
    },
    {
        name: 'Intermediate',
        emoji: "\uD83D\uDFE1",
        descriptions: [
            'Regular training (several months to ~2 years)',
            'Good technique in most exercises',
            'Can follow structured programs',
            "Starting to hit plateaus \u2192 needs progression strategies"
        ]
    },
    {
        name: 'Advanced',
        emoji: "\u26AB",
        descriptions: [
            'Several years of consistent training',
            'Strong technique across all major lifts',
            'Requires periodized and goal-specific programming',
            "Progress is slower \u2192 needs precise optimization"
        ]
    },
    {
        name: 'Athlete',
        emoji: "\u26AA",
        descriptions: [
            'Training is sport-specific and performance-driven',
            'High level of strength, endurance, and skill',
            'Follows structured, coach-led programs',
            'Focus on peak performance, recovery, and injury prevention'
        ]
    }
];
const trainingActivityLike = [
    {
        name: 'Mostly sedentary',
        value: 'mostly_sedentary',
        descriptions: [
            'Spends most of the day sitting (desk job, minimal movement).',
            'Little to no structured exercise.'
        ]
    },
    {
        name: 'Lightly active',
        value: 'lightly_active',
        descriptions: [
            'Includes some daily movement (walking, chores, light tasks).',
            'Occasional low-intensity exercise or short workouts.'
        ]
    },
    {
        name: 'Highly active',
        value: 'highly_active',
        descriptions: [
            'Regular physical activity or physically demanding routine.',
            'Frequent workouts, sports, or labor-intensive work.'
        ]
    }
];
const trainingMovementGrade = [
    {
        name: 'Pain',
        value: 'pain'
    },
    {
        name: 'Limited',
        value: 'limited'
    },
    {
        name: 'Good',
        value: 'good'
    }
];
const trainingGoal = [
    {
        name: 'Build muscle',
        value: 'build-muscle',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 30,
            height: 30,
            viewBox: "0 0 30 30",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                    id: "mask0_708_339",
                    style: {
                        maskType: 'luminance'
                    },
                    maskUnits: "userSpaceOnUse",
                    x: 5,
                    y: 5,
                    width: 20,
                    height: 20,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M24.375 5.625H5.625V24.375H24.375V5.625Z",
                        fill: "white"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    mask: "url(#mask0_708_339)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.775 9.57305C9.97461 9.45313 10.282 9.33594 10.7031 9.33594C11.1242 9.33594 11.4316 9.45313 11.6312 9.57305C11.9395 9.75743 12.0316 10.073 12.0363 10.298C12.0453 10.7465 12.0703 12.2254 12.0703 15C12.0703 17.7746 12.0453 19.2535 12.0363 19.702C12.0316 19.9265 11.9395 20.2426 11.6312 20.427C11.4316 20.5469 11.1242 20.664 10.7031 20.664C10.282 20.664 9.97461 20.5469 9.775 20.427C9.4668 20.2426 9.37461 19.927 9.36992 19.702C9.36094 19.2539 9.33594 17.7746 9.33594 15C9.33594 12.2254 9.36094 10.7465 9.36992 10.298C9.37461 10.0734 9.4668 9.75743 9.775 9.57305ZM20.2251 9.57305C20.0254 9.45313 19.7179 9.33594 19.2969 9.33594C18.8758 9.33594 18.5683 9.45313 18.3688 9.57305C18.0609 9.75743 17.9683 10.073 17.9637 10.298C17.9547 10.7461 17.9297 12.2254 17.9297 15C17.9297 17.7746 17.9547 19.2535 17.9637 19.702C17.9683 19.9265 18.0606 20.2426 18.3688 20.427C18.5683 20.5469 18.8758 20.664 19.2969 20.664C19.7179 20.664 20.0254 20.5469 20.2251 20.427C20.5328 20.2426 20.6254 19.927 20.6301 19.702C20.6391 19.2535 20.6641 17.7746 20.6641 15C20.6641 12.2254 20.6391 10.7465 20.6301 10.298C20.6254 10.0734 20.5328 9.75743 20.2251 9.57305ZM7.38281 11.2891C7.125 11.2891 6.91836 11.3359 6.76016 11.3973C6.36329 11.5512 6.24062 11.927 6.23477 12.1785C6.22696 12.5289 6.21094 13.4274 6.21094 15C6.21094 16.5726 6.22656 17.4711 6.23437 17.8215C6.24024 18.073 6.36329 18.4493 6.76016 18.6028C6.91836 18.6641 7.125 18.711 7.38281 18.711C7.64062 18.711 7.84727 18.6641 8.00547 18.6028C8.40235 18.4493 8.525 18.073 8.53086 17.8215C8.53867 17.4711 8.55469 16.5726 8.55469 15C8.55469 13.4274 8.53906 12.5289 8.53125 12.1785C8.5254 11.927 8.40235 11.5508 8.00547 11.3973C7.80639 11.323 7.59528 11.2863 7.38281 11.2891ZM23.2398 11.3973C23.0408 11.323 22.8297 11.2863 22.6172 11.2891C22.3594 11.2891 22.1527 11.3359 21.9946 11.3973C21.5981 11.5512 21.4751 11.927 21.4692 12.1785C21.4613 12.5289 21.4453 13.4274 21.4453 15C21.4453 16.5726 21.4609 17.4711 21.4688 17.8215C21.4746 18.073 21.5977 18.4493 21.9946 18.6028C22.1527 18.6641 22.3598 18.711 22.6172 18.711C22.8751 18.711 23.0817 18.6641 23.2398 18.6028C23.6363 18.4493 23.7594 18.073 23.7652 17.8215C23.7731 17.4711 23.7891 16.5726 23.7891 15C23.7891 13.4274 23.7734 12.5289 23.7657 12.1785C23.7598 11.927 23.6367 11.5508 23.2398 11.3973ZM12.8516 16.116V13.884C12.8516 13.5136 13.1547 13.3191 13.4777 13.2914C13.5444 13.2851 13.6441 13.2784 13.7766 13.2711C14.0422 13.2563 14.4433 13.2422 15.0001 13.2422C15.5567 13.2422 15.9582 13.2563 16.2234 13.2711C16.3559 13.2784 16.4556 13.2851 16.5223 13.2914C16.8453 13.3187 17.1484 13.5136 17.1484 13.884V16.116C17.1484 16.4868 16.8453 16.6809 16.5223 16.7086C16.4556 16.7149 16.3559 16.7216 16.2234 16.7289C15.9578 16.7437 15.5567 16.7578 15.0001 16.7578C14.4433 16.7578 14.0418 16.7437 13.7766 16.7289C13.6441 16.7216 13.5444 16.7149 13.4777 16.7086C13.1547 16.6813 12.8516 16.4864 12.8516 16.116Z",
                        fill: "currentColor"
                    })
                })
            ]
        }),
        styles: [
            {
                name: 'Weight training',
                value: 'weight-training',
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: 30,
                    height: 30,
                    viewBox: "0 0 30 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                            id: "mask0_708_339",
                            style: {
                                maskType: 'luminance'
                            },
                            maskUnits: "userSpaceOnUse",
                            x: 5,
                            y: 5,
                            width: 20,
                            height: 20,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M24.375 5.625H5.625V24.375H24.375V5.625Z",
                                fill: "white"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            mask: "url(#mask0_708_339)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fillRule: "evenodd",
                                clipRule: "evenodd",
                                d: "M9.775 9.57305C9.97461 9.45313 10.282 9.33594 10.7031 9.33594C11.1242 9.33594 11.4316 9.45313 11.6312 9.57305C11.9395 9.75743 12.0316 10.073 12.0363 10.298C12.0453 10.7465 12.0703 12.2254 12.0703 15C12.0703 17.7746 12.0453 19.2535 12.0363 19.702C12.0316 19.9265 11.9395 20.2426 11.6312 20.427C11.4316 20.5469 11.1242 20.664 10.7031 20.664C10.282 20.664 9.97461 20.5469 9.775 20.427C9.4668 20.2426 9.37461 19.927 9.36992 19.702C9.36094 19.2539 9.33594 17.7746 9.33594 15C9.33594 12.2254 9.36094 10.7465 9.36992 10.298C9.37461 10.0734 9.4668 9.75743 9.775 9.57305ZM20.2251 9.57305C20.0254 9.45313 19.7179 9.33594 19.2969 9.33594C18.8758 9.33594 18.5683 9.45313 18.3688 9.57305C18.0609 9.75743 17.9683 10.073 17.9637 10.298C17.9547 10.7461 17.9297 12.2254 17.9297 15C17.9297 17.7746 17.9547 19.2535 17.9637 19.702C17.9683 19.9265 18.0606 20.2426 18.3688 20.427C18.5683 20.5469 18.8758 20.664 19.2969 20.664C19.7179 20.664 20.0254 20.5469 20.2251 20.427C20.5328 20.2426 20.6254 19.927 20.6301 19.702C20.6391 19.2535 20.6641 17.7746 20.6641 15C20.6641 12.2254 20.6391 10.7465 20.6301 10.298C20.6254 10.0734 20.5328 9.75743 20.2251 9.57305ZM7.38281 11.2891C7.125 11.2891 6.91836 11.3359 6.76016 11.3973C6.36329 11.5512 6.24062 11.927 6.23477 12.1785C6.22696 12.5289 6.21094 13.4274 6.21094 15C6.21094 16.5726 6.22656 17.4711 6.23437 17.8215C6.24024 18.073 6.36329 18.4493 6.76016 18.6028C6.91836 18.6641 7.125 18.711 7.38281 18.711C7.64062 18.711 7.84727 18.6641 8.00547 18.6028C8.40235 18.4493 8.525 18.073 8.53086 17.8215C8.53867 17.4711 8.55469 16.5726 8.55469 15C8.55469 13.4274 8.53906 12.5289 8.53125 12.1785C8.5254 11.927 8.40235 11.5508 8.00547 11.3973C7.80639 11.323 7.59528 11.2863 7.38281 11.2891ZM23.2398 11.3973C23.0408 11.323 22.8297 11.2863 22.6172 11.2891C22.3594 11.2891 22.1527 11.3359 21.9946 11.3973C21.5981 11.5512 21.4751 11.927 21.4692 12.1785C21.4613 12.5289 21.4453 13.4274 21.4453 15C21.4453 16.5726 21.4609 17.4711 21.4688 17.8215C21.4746 18.073 21.5977 18.4493 21.9946 18.6028C22.1527 18.6641 22.3598 18.711 22.6172 18.711C22.8751 18.711 23.0817 18.6641 23.2398 18.6028C23.6363 18.4493 23.7594 18.073 23.7652 17.8215C23.7731 17.4711 23.7891 16.5726 23.7891 15C23.7891 13.4274 23.7734 12.5289 23.7657 12.1785C23.7598 11.927 23.6367 11.5508 23.2398 11.3973ZM12.8516 16.116V13.884C12.8516 13.5136 13.1547 13.3191 13.4777 13.2914C13.5444 13.2851 13.6441 13.2784 13.7766 13.2711C14.0422 13.2563 14.4433 13.2422 15.0001 13.2422C15.5567 13.2422 15.9582 13.2563 16.2234 13.2711C16.3559 13.2784 16.4556 13.2851 16.5223 13.2914C16.8453 13.3187 17.1484 13.5136 17.1484 13.884V16.116C17.1484 16.4868 16.8453 16.6809 16.5223 16.7086C16.4556 16.7149 16.3559 16.7216 16.2234 16.7289C15.9578 16.7437 15.5567 16.7578 15.0001 16.7578C14.4433 16.7578 14.0418 16.7437 13.7766 16.7289C13.6441 16.7216 13.5444 16.7149 13.4777 16.7086C13.1547 16.6813 12.8516 16.4864 12.8516 16.116Z",
                                fill: "currentColor"
                            })
                        })
                    ]
                })
            },
            {
                name: 'Functional training',
                value: 'functional-training',
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: 30,
                    height: 30,
                    viewBox: "0 0 30 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                            id: "mask0_736_297",
                            style: {
                                maskType: 'luminance'
                            },
                            maskUnits: "userSpaceOnUse",
                            x: 5,
                            y: 5,
                            width: 20,
                            height: 20,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M24.375 5.625H5.625V24.375H24.375V5.625Z",
                                fill: "white"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                            mask: "url(#mask0_736_297)",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M18.9893 13.2704C17.8943 12.4721 17.0227 11.4027 16.5357 10.1393C15.9754 8.70009 15.7996 7.24991 15.7447 6.43326C15.7264 5.95353 15.3235 5.57999 14.8438 5.5983C14.3641 5.61662 13.9905 6.01945 14.0089 6.49918C14.0272 10.11 15.7153 12.8932 15.7153 12.8932L8.58523 22.8395C8.27765 23.2716 8.3765 23.8722 8.80498 24.1799C9.21875 24.4765 9.7937 24.3995 10.1123 24.0004L14.6094 18.4193L17.1436 20.3822L18.125 23.6672C18.2496 24.0846 18.634 24.3703 19.0699 24.3703C19.6155 24.3703 20.055 23.9272 20.055 23.3815C20.055 23.3119 20.0476 23.246 20.033 23.1801C19.1907 19.1225 17.4439 17.8261 17.4439 17.8261L18.7549 16.3393C19.3519 18.0165 19.5349 19.5875 19.5862 20.4371C19.6082 20.8217 19.9048 21.133 20.2857 21.1769C20.7215 21.2282 21.117 20.9169 21.1683 20.4811C21.1719 20.4591 21.1719 20.4335 21.1719 20.4079C21.3001 15.6545 19.8426 13.893 18.9893 13.2704Z",
                                    fill: "currentColor"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M20.9385 12.0293C21.6978 11.3799 21.8199 10.2765 21.2112 9.5647C20.6026 8.85303 19.4936 8.80255 18.7343 9.45198C17.9749 10.1015 17.8528 11.2049 18.4614 11.9166C19.0701 12.6282 20.1792 12.6787 20.9385 12.0293Z",
                                    fill: "currentColor"
                                })
                            ]
                        })
                    ]
                })
            }
        ]
    },
    {
        name: 'Fat Loss',
        value: 'fat-loss',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 30,
            height: 30,
            viewBox: "0 0 30 30",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                    id: "mask0_708_346",
                    style: {
                        maskType: 'luminance'
                    },
                    maskUnits: "userSpaceOnUse",
                    x: 5,
                    y: 5,
                    width: 20,
                    height: 20,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M24.375 5.625H5.625V24.375H24.375V5.625Z",
                        fill: "white"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    mask: "url(#mask0_708_346)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M10.2428 18.9211C10.2332 18.8242 10.188 18.7346 10.1161 18.6695C10.0442 18.6044 9.95082 18.5686 9.85412 18.5691H8.01935C7.92265 18.5686 7.82925 18.6044 7.75737 18.6695C7.68549 18.7346 7.6403 18.8242 7.63064 18.9211L7.19528 23.0744C7.17233 23.3184 7.2003 23.5645 7.27738 23.797C7.35447 24.0295 7.47897 24.2433 7.6429 24.4245C7.80685 24.6058 8.00662 24.7506 8.22942 24.8498C8.45222 24.9488 8.69313 25 8.93674 25C9.18034 25 9.42125 24.9488 9.64405 24.8498C9.86685 24.7506 10.0666 24.6058 10.2306 24.4245C10.3945 24.2433 10.519 24.0295 10.5961 23.797C10.6732 23.5645 10.7011 23.3184 10.6782 23.0744L10.2428 18.9211ZM23.1173 23.0744L22.6819 18.9211C22.6722 18.8242 22.627 18.7346 22.5552 18.6695C22.4833 18.6044 22.3898 18.5686 22.2932 18.5691H20.4584C20.3617 18.5686 20.2683 18.6044 20.1964 18.6695C20.1245 18.7346 20.0793 18.8242 20.0697 18.9211L19.6343 23.0744C19.6114 23.3184 19.6393 23.5645 19.7164 23.797C19.7935 24.0295 19.918 24.2433 20.0819 24.4245C20.2459 24.6058 20.4457 24.7506 20.6684 24.8498C20.8913 24.9488 21.1322 25 21.3758 25C21.6194 25 21.8603 24.9488 22.083 24.8498C22.3059 24.7506 22.5057 24.6058 22.6697 24.4245C22.8335 24.2433 22.958 24.0295 23.0352 23.797C23.1122 23.5645 23.1402 23.3184 23.1173 23.0744ZM18.1417 8.08809C18.8664 8.37666 19.4882 8.87776 19.9262 9.52634C20.3643 10.1749 20.5984 10.941 20.5983 11.7252V15.2449C20.5983 15.3486 20.5574 15.4481 20.4845 15.5215C20.4115 15.5948 20.3127 15.636 20.2097 15.636C20.1522 15.6369 20.0954 15.6499 20.0432 15.6741C19.991 15.6984 19.9444 15.7334 19.9064 15.7767C19.8713 15.823 19.8462 15.8761 19.8328 15.9327C19.8194 15.9892 19.818 16.0481 19.8287 16.1053L20.023 17.083C20.0409 17.1714 20.0887 17.2507 20.158 17.3077C20.2275 17.3647 20.3144 17.3959 20.4039 17.3959H22.2698C22.3539 17.3959 22.4358 17.3684 22.503 17.3176C22.5703 17.2669 22.6194 17.1955 22.643 17.1142C22.6819 16.9735 22.7597 16.7154 22.9229 16.1053C22.9335 16.0481 22.9322 15.9892 22.9188 15.9327C22.9054 15.8761 22.8803 15.823 22.8452 15.7767C22.8072 15.7334 22.7605 15.6984 22.7083 15.6741C22.6562 15.6499 22.5994 15.6369 22.5419 15.636C22.4388 15.636 22.3399 15.5948 22.267 15.5215C22.1942 15.4481 22.1532 15.3486 22.1532 15.2449V11.7252C22.1532 10.2731 21.5799 8.88042 20.5593 7.85364C19.5387 6.82685 18.1544 6.25 16.7112 6.25C16.2523 6.25105 15.7954 6.30884 15.3507 6.42208C15.2229 6.45326 15.0897 6.45326 14.9619 6.42208C14.5172 6.30884 14.0602 6.25105 13.6014 6.25C12.158 6.25 10.7738 6.82685 9.75324 7.85364C8.73265 8.88042 8.1593 10.2731 8.1593 11.7252V15.2449C8.1593 15.3486 8.11834 15.4481 8.04544 15.5215C7.97254 15.5948 7.87368 15.636 7.77058 15.636C7.71308 15.6369 7.65639 15.6499 7.60417 15.6741C7.55195 15.6984 7.50535 15.7334 7.46738 15.7767C7.43223 15.823 7.40714 15.8761 7.39375 15.9327C7.38035 15.9892 7.37895 16.0481 7.38963 16.1053C7.55289 16.7154 7.63064 16.9735 7.66952 17.1142C7.69307 17.1955 7.74217 17.2669 7.80945 17.3176C7.87674 17.3684 7.95858 17.3959 8.04268 17.3959H9.90854C9.99815 17.3959 10.085 17.3647 10.1544 17.3077C10.2239 17.2507 10.2716 17.1714 10.2895 17.083L10.4916 16.1053C10.5023 16.0481 10.5009 15.9892 10.4875 15.9327C10.4741 15.8761 10.449 15.823 10.4139 15.7767C10.375 15.7324 10.3272 15.6968 10.2735 15.6725C10.2199 15.6483 10.1617 15.6357 10.1029 15.636C9.9998 15.636 9.90093 15.5948 9.82803 15.5215C9.75513 15.4481 9.71418 15.3486 9.71418 15.2449V11.7252C9.71404 10.941 9.94822 10.1749 10.3863 9.52634C10.8244 8.87776 11.4462 8.37666 12.1709 8.08809C12.2099 8.0711 12.2536 8.06805 12.2946 8.07943C12.3356 8.09081 12.3715 8.11594 12.3963 8.15066C12.4228 8.18396 12.4373 8.22534 12.4373 8.26799C12.4373 8.31064 12.4228 8.35201 12.3963 8.38531C11.6647 9.34301 11.2683 10.5172 11.2691 11.7252C11.2691 12.7624 11.6786 13.7571 12.4076 14.4905C13.1365 15.224 14.1253 15.636 15.1563 15.636C16.1872 15.636 17.1759 15.224 17.9049 14.4905C18.6339 13.7571 19.0434 12.7624 19.0434 11.7252C19.0442 10.5172 18.6478 9.34301 17.9162 8.38531C17.8897 8.35201 17.8753 8.31064 17.8753 8.26799C17.8753 8.22534 17.8897 8.18396 17.9162 8.15066C17.941 8.11594 17.9769 8.09081 18.0179 8.07943C18.0589 8.06805 18.1025 8.0711 18.1417 8.08809ZM15.1563 14.0716C14.5377 14.0716 13.9444 13.8245 13.507 13.3844C13.0697 12.9444 12.8239 12.3475 12.8239 11.7252C12.8239 11.0387 13.0035 10.3643 13.3448 9.7698C13.6859 9.1753 14.1767 8.68163 14.7675 8.33839C14.8858 8.26974 15.0198 8.23359 15.1563 8.23359C15.2928 8.23359 15.4268 8.26974 15.545 8.33839C16.1359 8.68163 16.6265 9.1753 16.9678 9.7698C17.3089 10.3643 17.4885 11.0387 17.4885 11.7252C17.4885 12.3475 17.2429 12.9444 16.8054 13.3844C16.368 13.8245 15.7748 14.0716 15.1563 14.0716Z",
                        fill: "currentColor"
                    })
                })
            ]
        }),
        styles: [
            {
                name: 'HITT',
                value: 'hitt',
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: 30,
                    height: 30,
                    viewBox: "0 0 30 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                            id: "mask0_736_308",
                            style: {
                                maskType: 'luminance'
                            },
                            maskUnits: "userSpaceOnUse",
                            x: 5,
                            y: 5,
                            width: 20,
                            height: 20,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M24.375 5.625H5.625V24.375H24.375V5.625Z",
                                fill: "white"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            mask: "url(#mask0_736_308)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M21.4499 14.5419C21.2035 14.2294 20.9036 13.9585 20.6251 13.6877C19.9073 13.0627 19.0932 12.6148 18.4076 11.9585C16.8115 10.4377 16.4579 7.92711 17.4756 6C16.4579 6.23959 15.5688 6.78127 14.8082 7.37504C12.0338 9.54179 10.9411 13.3648 12.248 16.6462C12.2909 16.7503 12.3337 16.8545 12.3337 16.9899C12.3337 17.2191 12.173 17.4274 11.9588 17.5108C11.7124 17.6149 11.4553 17.5524 11.2517 17.3857C11.191 17.3362 11.1401 17.2762 11.1018 17.2087C9.89131 15.719 9.69848 13.5835 10.5126 11.8752C8.72363 13.2919 7.74886 15.6878 7.88813 17.9482C7.95233 18.4691 8.01661 18.99 8.19878 19.5108C8.34871 20.1358 8.63798 20.7608 8.95936 21.313C10.1162 23.1151 12.1195 24.4068 14.2727 24.6672C16.5651 24.9484 19.0182 24.5422 20.775 23.0005C22.7354 21.2713 23.4209 18.5004 22.414 16.1253L22.2748 15.8545C22.0498 15.3753 21.4499 14.5419 21.4499 14.5419ZM18.0648 21.1046C17.7649 21.3546 17.2721 21.6254 16.8865 21.7296C15.6866 22.1463 14.4869 21.5629 13.7799 20.8754C15.0546 20.5837 15.8152 19.6671 16.0402 18.7399C16.2223 17.9066 15.8795 17.2191 15.7403 16.417C15.6117 15.6461 15.6331 14.9899 15.9224 14.2711C16.1259 14.6669 16.3401 15.0628 16.5972 15.3753C17.4221 16.417 18.7183 16.8753 18.9968 18.292C19.0397 18.4378 19.061 18.5837 19.061 18.7399C19.0932 19.5941 18.7076 20.5317 18.0648 21.1046Z",
                                fill: "currentColor"
                            })
                        })
                    ]
                })
            },
            {
                name: 'Cardio',
                value: 'cardio',
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    width: 30,
                    height: 30,
                    viewBox: "0 0 30 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M14.7417 9.57884C13.1009 7.54244 10.1695 7.41988 8.38235 9.31297C7.13016 10.6393 6.80464 12.5754 7.40571 14.2188H10.6096L12.6558 10.1281L14.9995 14.8148L16.1714 12.4718L17.0448 14.2188H22.5933C23.1944 12.5754 22.8688 10.6393 21.6168 9.31297C19.8294 7.41992 16.8981 7.54244 15.2574 9.57884L14.9995 9.89894L14.7417 9.57884ZM21.6374 15.7813H16.2636L14.9995 18.3094L12.6558 13.6219L11.5761 15.7813H8.36165C8.36847 15.7886 8.37537 15.796 8.38235 15.8033L14.9962 22.809L14.9994 22.8125L21.6167 15.8033C21.6236 15.796 21.6305 15.7886 21.6374 15.7813Z",
                        fill: "currentColor"
                    })
                })
            }
        ]
    },
    {
        name: 'Hypertrophy',
        value: 'hypertrophy-goal',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 30,
            height: 30,
            viewBox: "0 0 30 30",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                    id: "mask0_735_290",
                    style: {
                        maskType: 'luminance'
                    },
                    maskUnits: "userSpaceOnUse",
                    x: 5,
                    y: 5,
                    width: 20,
                    height: 20,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M24.375 5.625H5.625V24.375H24.375V5.625Z",
                        fill: "white"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    mask: "url(#mask0_735_290)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M13.4643 8.98263C13.578 8.98263 13.6832 8.92136 13.7391 8.82244C13.7954 8.72359 13.7938 8.60201 13.735 8.50436L12.1269 5.82386H15.0768L15.623 10.7379L14.1962 10.2622C14.0815 10.224 13.9552 10.2546 13.8705 10.3409C13.7858 10.4271 13.7581 10.5544 13.7985 10.6681L14.5888 12.8811L11.8597 8.98263H13.4643ZM13.1759 11.9641L15.4167 15.1652C15.4777 15.2524 15.5753 15.3001 15.6754 15.3001C15.7244 15.3001 15.7739 15.2887 15.8201 15.265C15.9607 15.1924 16.0257 15.0272 15.9727 14.8781L14.6116 11.067L15.8912 11.4938C15.9935 11.5273 16.106 11.5074 16.1897 11.4398C16.2734 11.3722 16.3169 11.2664 16.3049 11.1593L16.1501 9.76593C17.4345 9.02463 18.8123 8.45891 20.2512 8.08774C20.3858 8.05264 20.5241 8.03501 20.6627 8.03501C20.9423 8.03501 21.2016 8.11143 21.4322 8.23496L16.4174 12.5334L16.8287 13.0131L21.9284 8.64206C21.9711 8.69388 22.0131 8.74541 22.0491 8.80196C19.0922 14.3035 14.6075 18.7188 9.06008 21.5892C9.02723 21.5639 8.99528 21.538 8.96468 21.5105L13.717 15.1737L13.2116 14.7947L8.87303 20.5793L9.16936 19.8016C10.1034 17.3501 11.5172 15.1668 13.3718 13.3123L12.9251 12.8657C11.0071 14.7837 9.54488 17.0415 8.57896 19.5767L8.45986 19.8891C8.46083 19.8847 8.46113 19.8803 8.4624 19.8762C9.24863 16.8296 10.8767 14.1026 13.1759 11.9641ZM6.54474 24.3594L5.98438 23.799L7.95698 21.1707C8.1879 21.7174 8.62635 22.1559 9.1731 22.3867L6.54474 24.3594ZM17.5959 20.9859L17.8591 24.1446H15.4818L16.2911 21.7174C16.3232 21.621 16.3068 21.5149 16.2475 21.4328C16.1881 21.3507 16.0927 21.3017 15.9913 21.3017H15.2777L16.623 18.9955V20.67C16.623 20.8446 16.7645 20.9859 16.9389 20.9859H17.5959ZM22.2563 10.0926C21.4332 13.2832 19.7095 16.0971 17.2548 18.27V17.8271C17.2548 17.6843 17.1591 17.5593 17.0213 17.522C16.8836 17.485 16.738 17.5447 16.666 17.6679L15.5408 19.5966C13.9896 20.6431 12.2836 21.4126 10.4676 21.8811C10.3334 21.9158 10.195 21.9335 10.0563 21.9335C9.96946 21.9335 9.88606 21.9208 9.80296 21.9079C15.0731 19.0732 19.3718 14.8557 22.3047 9.64218C22.3053 9.65538 22.3088 9.66776 22.3088 9.68103C22.3088 9.81963 22.2911 9.95801 22.2563 10.0926ZM22.7621 8.79783C22.5311 8.25101 22.0928 7.81263 21.5459 7.58171L24.1743 5.60938L24.7344 6.16942L22.7621 8.79783Z",
                        fill: "currentColor"
                    })
                })
            ]
        }),
        styles: [
            {
                name: 'Weight training',
                value: 'weight-training',
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    width: 30,
                    height: 30,
                    viewBox: "0 0 30 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M9.77502 9.57301C9.97459 9.45309 10.282 9.33594 10.7031 9.33594C11.1242 9.33594 11.4316 9.45309 11.6313 9.57301C11.9394 9.75736 12.0316 10.073 12.0363 10.298C12.0453 10.7465 12.0703 12.2254 12.0703 14.9999C12.0703 17.7746 12.0453 19.2535 12.0363 19.7019C12.0316 19.9265 11.9394 20.2425 11.6313 20.4269C11.4316 20.5469 11.1242 20.664 10.7031 20.664C10.282 20.664 9.97459 20.5469 9.77502 20.4269C9.46677 20.2425 9.37459 19.9269 9.36994 19.7019C9.36094 19.2539 9.33597 17.7746 9.33597 14.9999C9.33597 12.2254 9.36094 10.7465 9.36994 10.298C9.37459 10.0734 9.46677 9.75736 9.77502 9.57301ZM20.225 9.57301C20.0254 9.45309 19.718 9.33594 19.2969 9.33594C18.8758 9.33594 18.5684 9.45309 18.3687 9.57301C18.0609 9.75736 17.9684 10.073 17.9637 10.298C17.9547 10.7461 17.9297 12.2254 17.9297 14.9999C17.9297 17.7746 17.9547 19.2535 17.9637 19.7019C17.9684 19.9265 18.0606 20.2425 18.3687 20.4269C18.5684 20.5469 18.8758 20.664 19.2969 20.664C19.718 20.664 20.0254 20.5469 20.225 20.4269C20.5328 20.2425 20.6254 19.9269 20.6301 19.7019C20.6391 19.2535 20.664 17.7746 20.664 14.9999C20.664 12.2254 20.6391 10.7465 20.6301 10.298C20.6254 10.0734 20.5328 9.75736 20.225 9.57301ZM7.38281 11.289C7.125 11.289 6.91836 11.3359 6.76016 11.3972C6.36328 11.5511 6.24063 11.9269 6.23476 12.1785C6.22696 12.5288 6.21094 13.4273 6.21094 14.9999C6.21094 16.5726 6.22657 17.471 6.23438 17.8214C6.24024 18.073 6.36328 18.4492 6.76016 18.6027C6.91836 18.6641 7.125 18.7109 7.38281 18.7109C7.6406 18.7109 7.84729 18.6641 8.00547 18.6027C8.40237 18.4492 8.52499 18.073 8.53084 17.8214C8.53864 17.471 8.55469 16.5726 8.55469 14.9999C8.55469 13.4273 8.53909 12.5288 8.53122 12.1785C8.52537 11.9269 8.40237 11.5508 8.00547 11.3972C7.80642 11.323 7.59529 11.2863 7.38281 11.289ZM23.2398 11.3972C23.0408 11.323 22.8297 11.2863 22.6172 11.289C22.3593 11.289 22.1527 11.3359 21.9945 11.3972C21.598 11.5511 21.475 11.9269 21.4692 12.1785C21.4613 12.5288 21.4453 13.4273 21.4453 14.9999C21.4453 16.5726 21.4609 17.471 21.4687 17.8214C21.4746 18.073 21.5976 18.4492 21.9945 18.6027C22.1527 18.6641 22.3598 18.7109 22.6172 18.7109C22.875 18.7109 23.0817 18.6641 23.2398 18.6027C23.6363 18.4492 23.7594 18.073 23.7652 17.8214C23.773 17.471 23.7891 16.5726 23.7891 14.9999C23.7891 13.4273 23.7735 12.5288 23.7656 12.1785C23.7597 11.9269 23.6367 11.5508 23.2398 11.3972ZM12.8516 16.116V13.8839C12.8516 13.5137 13.1547 13.3191 13.4778 13.2914C13.5444 13.2851 13.644 13.2784 13.7766 13.271C14.0422 13.2562 14.4434 13.2422 15 13.2422C15.5566 13.2422 15.9582 13.2562 16.2234 13.271C16.356 13.2784 16.4556 13.2851 16.5222 13.2914C16.8453 13.3187 17.1484 13.5137 17.1484 13.8839V16.116C17.1484 16.4867 16.8453 16.6808 16.5222 16.7086C16.4556 16.7148 16.356 16.7216 16.2234 16.7288C15.9578 16.7437 15.5566 16.7578 15 16.7578C14.4434 16.7578 14.0418 16.7437 13.7766 16.7288C13.644 16.7216 13.5444 16.7148 13.4778 16.7086C13.1547 16.6812 12.8516 16.4863 12.8516 16.116Z",
                        fill: "currentColor"
                    })
                })
            },
            {
                name: 'Bodybuilding Split',
                value: 'body-building-split',
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: 30,
                    height: 30,
                    viewBox: "0 0 30 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M23.5631 17.0211C23.5521 17.0055 23.5435 16.9883 23.5377 16.9704C23.5193 16.9144 21.6311 11.3194 17.0916 9.16189C17.0655 9.14824 16.5983 8.89999 16.284 8.36951C16.2703 8.34446 16.071 7.99339 15.3981 7.89844C15.4173 7.94689 15.4353 7.99534 15.4517 8.04424C15.4759 8.11579 15.4971 8.18846 15.517 8.26234C15.531 8.31439 15.5455 8.36636 15.5572 8.41871C15.5748 8.49731 15.587 8.57786 15.5991 8.65841C15.6061 8.70529 15.6159 8.75141 15.6206 8.79874C15.6347 8.92699 15.6429 9.05674 15.6429 9.18851C15.6429 9.55631 15.5865 9.91324 15.4794 10.2534C15.8763 10.3053 16.2336 10.5141 16.4638 10.8433C16.9404 11.5227 17.2531 12.5559 17.3934 13.9144C17.3946 13.941 17.4126 14.8479 17.8641 15.6549C18.1444 15.9574 18.4192 16.3097 18.6812 16.7331C18.7378 16.8249 18.7097 16.9453 18.6178 17.002C18.5256 17.0591 18.4056 17.031 18.3485 16.9386C16.612 14.1349 14.3418 14.3953 13.1424 14.7999C12.6288 14.9735 12.0744 14.9301 11.621 14.6814C9.23043 13.3703 7.10494 14.7295 6.5033 15.183C6.5033 15.183 6.47554 19.6631 6.28516 22.6236L8.99628 23.9985C9.26718 23.8612 10.1628 23.3409 10.4799 22.3167C10.5537 22.0813 10.6089 21.8675 10.6573 21.6787C10.7879 21.1725 10.8821 20.8065 11.1843 20.658C11.4075 20.5493 11.6867 20.5809 12.1182 20.7659C12.2379 20.8171 12.3575 20.8675 12.481 20.9085L13.259 21.1662C13.4126 21.2174 13.5428 21.2526 13.6691 21.2772C15.5369 21.6466 17.5569 21.3999 19.0717 20.6177C20.4935 19.8851 21.2863 19.5591 21.7007 19.4145C22.2629 19.2205 22.7628 18.9148 23.1475 18.5305C23.7253 17.9617 23.8645 17.4547 23.5631 17.0211ZM21.8563 17.1627C21.723 17.7756 21.2367 18.2956 20.4111 18.7084C20.3829 18.7225 20.3532 18.7291 20.3238 18.7291C20.2519 18.7291 20.1831 18.6897 20.1487 18.6208C20.1006 18.5243 20.1397 18.407 20.2363 18.3589C20.949 18.0024 21.3653 17.5731 21.4736 17.0833C21.6123 16.4562 21.1925 15.9191 21.1886 15.9136C21.1214 15.8292 21.135 15.7065 21.2191 15.6392C21.3031 15.5716 21.4259 15.5853 21.4931 15.6689C21.515 15.6967 22.0334 16.3511 21.8563 17.1627Z",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M9.26444 10.7459C9.27577 10.7658 9.28394 10.7885 9.29572 10.8084C9.35549 10.9116 9.42547 11.0063 9.49582 11.1009C9.52124 11.1348 9.54277 11.1728 9.56932 11.206C9.62677 11.2768 9.69172 11.3394 9.75427 11.4046C9.80152 11.4535 9.84494 11.5071 9.89534 11.5527C9.94072 11.5946 9.99232 11.629 10.0404 11.6681C10.1143 11.7283 10.1862 11.7909 10.2648 11.8444C10.2953 11.8647 10.3289 11.8796 10.3602 11.8992C10.4614 11.9621 10.5634 12.025 10.6714 12.0766C10.6909 12.0856 10.712 12.0915 10.732 12.1001C10.8543 12.1556 10.979 12.2068 11.1084 12.2467C11.1377 12.2556 11.1698 12.2596 11.1999 12.2678C11.3215 12.301 11.4439 12.3327 11.5701 12.3514C11.728 12.3753 11.8895 12.3878 12.0533 12.3878C12.2171 12.3878 12.3781 12.3753 12.5361 12.3514C12.6624 12.3327 12.7843 12.3014 12.9055 12.2678C12.9356 12.2596 12.9681 12.2561 12.9982 12.2467C13.1291 12.2064 13.2554 12.1548 13.3793 12.0985C13.3973 12.0903 13.4169 12.0852 13.4348 12.0766C13.5475 12.0227 13.6542 11.9582 13.7593 11.8917C13.7859 11.8749 13.8148 11.8624 13.841 11.8448C13.9251 11.7881 14.0017 11.7216 14.0803 11.6575C14.1229 11.622 14.1694 11.5915 14.2105 11.5536C14.2651 11.5039 14.3125 11.4461 14.3637 11.3921C14.4216 11.3311 14.4829 11.2733 14.5361 11.2072C14.5658 11.1705 14.59 11.1282 14.6182 11.0899C14.6851 10.9992 14.7526 10.9089 14.8102 10.81C14.8227 10.7885 14.8316 10.7643 14.8438 10.7427C14.9106 10.6216 14.9743 10.4973 15.0263 10.3655C15.1756 9.99573 15.2511 9.60048 15.2511 9.19C15.2511 9.07308 15.2437 8.95781 15.2311 8.84321C15.2265 8.80023 15.2182 8.75838 15.2116 8.71616C15.2011 8.64543 15.1901 8.57463 15.1749 8.50511C15.1643 8.45741 15.151 8.41046 15.1385 8.36396C15.121 8.29946 15.1025 8.23533 15.0811 8.17203C15.0658 8.12665 15.049 8.08248 15.0318 8.03831C15.0064 7.97306 14.9786 7.90893 14.9489 7.84518C14.9305 7.80648 14.913 7.76815 14.8934 7.73065C14.8336 7.61493 14.7683 7.50348 14.6968 7.39797C14.6776 7.36943 14.6554 7.34362 14.6354 7.31587C14.5807 7.2412 14.5232 7.16927 14.4634 7.10008C14.4266 7.05825 14.3895 7.01642 14.3508 6.97655C14.2984 6.9222 14.2429 6.87099 14.187 6.82095C14.1186 6.75958 14.0474 6.70093 13.9739 6.64543C13.9184 6.60399 13.8629 6.56216 13.8046 6.52424C13.7519 6.48984 13.6975 6.45739 13.6424 6.42572C13.5823 6.39132 13.5205 6.35926 13.4579 6.32878C13.4086 6.30453 13.3602 6.27913 13.3097 6.25763C13.201 6.2111 13.0893 6.17045 12.9751 6.13682C12.9349 6.12431 12.8934 6.11572 12.8527 6.10516C12.7612 6.08171 12.6686 6.06177 12.5748 6.04652C12.5345 6.03988 12.4942 6.03284 12.4536 6.02776C12.3219 6.01173 12.1885 6 12.0533 6C11.9176 6 11.7847 6.01173 11.653 6.02776C11.6119 6.03284 11.572 6.03988 11.5318 6.04652C11.4376 6.06177 11.3453 6.08171 11.2538 6.10516C11.2128 6.11572 11.1714 6.12471 11.1315 6.13682C11.0173 6.17045 10.9055 6.2111 10.7968 6.25763C10.7461 6.27913 10.6975 6.30453 10.6483 6.32878C10.5857 6.35926 10.5244 6.39132 10.4638 6.42611C10.409 6.45739 10.3547 6.48944 10.3019 6.52424C10.2441 6.56216 10.1886 6.60359 10.1331 6.64543C10.0591 6.70093 9.98722 6.75997 9.91844 6.82174C9.86294 6.87177 9.80782 6.9222 9.75577 6.97615C9.71707 7.01641 9.67957 7.05825 9.64282 7.10047C9.58342 7.16927 9.52672 7.24003 9.47279 7.31391C9.45164 7.34245 9.42899 7.36943 9.40904 7.39875C9.33787 7.50348 9.27382 7.61373 9.21397 7.72833C9.19364 7.76815 9.17452 7.80926 9.15532 7.85028C9.12682 7.91126 9.10019 7.97261 9.07559 8.03478C9.05797 8.08091 9.04042 8.12741 9.02474 8.17436C9.00367 8.23616 8.98567 8.29826 8.96887 8.36081C8.95597 8.40933 8.94224 8.45703 8.93137 8.50623C8.91652 8.57463 8.90557 8.64461 8.89499 8.71421C8.88832 8.75726 8.88014 8.79986 8.87504 8.84321C8.86289 8.95781 8.85547 9.07308 8.85547 9.19C8.85547 9.60085 8.93092 9.99573 9.07949 10.3635C9.13229 10.4973 9.19642 10.6231 9.26444 10.7459ZM11.7054 7.60278C11.7171 7.60046 11.7292 7.59731 11.7409 7.59536C11.8406 7.57586 11.9434 7.56453 12.0486 7.56408C12.1537 7.56453 12.2566 7.57586 12.3562 7.59536C12.3684 7.59731 12.3801 7.60046 12.3919 7.60278C13.126 7.76231 13.678 8.4124 13.678 9.19C13.678 9.8647 13.2671 10.4453 12.6823 10.6943C12.6799 10.695 12.6776 10.6962 12.6753 10.6971C12.5866 10.7342 12.4935 10.7623 12.3977 10.7834C12.3844 10.7862 12.3715 10.7901 12.3578 10.7924C12.2578 10.812 12.1546 10.8233 12.0486 10.8237C11.9427 10.8233 11.8399 10.812 11.7394 10.7924C11.7261 10.7901 11.7132 10.7862 11.6995 10.7834C11.6041 10.7623 11.5107 10.7342 11.422 10.6971C11.42 10.6962 11.4176 10.695 11.4153 10.6943C10.8304 10.4453 10.4192 9.8647 10.4192 9.19C10.4192 8.4124 10.9712 7.76231 11.7054 7.60278Z",
                            fill: "currentColor"
                        })
                    ]
                })
            }
        ]
    },
    {
        name: 'Performance',
        value: 'performance',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 30,
            height: 30,
            viewBox: "0 0 30 30",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                    id: "mask0_708_356",
                    style: {
                        maskType: 'luminance'
                    },
                    maskUnits: "userSpaceOnUse",
                    x: 5,
                    y: 5,
                    width: 20,
                    height: 20,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M24.375 5.625H5.625V24.375H24.375V5.625Z",
                        fill: "white"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    mask: "url(#mask0_708_356)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M7.1877 19.5836C6.9805 19.5836 6.78178 19.6659 6.63527 19.8124C6.48876 19.9589 6.40645 20.1576 6.40645 20.3649V21.5368C6.40645 21.5885 6.42703 21.6383 6.46366 21.6749C6.50028 21.7115 6.54996 21.732 6.60176 21.732H9.33613C9.38793 21.732 9.43762 21.7115 9.47425 21.6749C9.51087 21.6383 9.53145 21.5885 9.53145 21.5368V20.3649C9.53145 20.1576 9.44913 19.9589 9.30262 19.8124C9.15611 19.6659 8.9574 19.5836 8.7502 19.5836H7.1877ZM11.8752 17.2399C11.668 17.2399 11.4693 17.3221 11.3228 17.4686C11.1763 17.6151 11.0939 17.8139 11.0939 18.0211V21.5368C11.0939 21.5885 11.1145 21.6383 11.1512 21.6749C11.1878 21.7115 11.2375 21.732 11.2893 21.732H14.0236C14.0754 21.732 14.1251 21.7115 14.1618 21.6749C14.1984 21.6383 14.219 21.5885 14.219 21.5368V18.0211C14.219 17.8139 14.1366 17.6151 13.9901 17.4686C13.8436 17.3221 13.6449 17.2399 13.4378 17.2399H11.8752ZM16.5628 14.5055C16.3555 14.5055 16.1568 14.5878 16.0103 14.7343C15.8638 14.8808 15.7815 15.0795 15.7815 15.2868V21.5368C15.7815 21.5885 15.802 21.6383 15.8386 21.6749C15.8753 21.7115 15.925 21.732 15.9768 21.732H18.7111C18.7629 21.732 18.8126 21.7115 18.8493 21.6749C18.8859 21.6383 18.9065 21.5885 18.9065 21.5368V15.2868C18.9065 15.0795 18.8241 14.8808 18.6776 14.7343C18.5311 14.5878 18.3324 14.5055 18.1253 14.5055H16.5628ZM20.6643 21.732H23.3986C23.4504 21.732 23.5001 21.7115 23.5368 21.6749C23.5734 21.6383 23.594 21.5885 23.594 21.5368V12.1617C23.594 11.9545 23.5116 11.7558 23.3651 11.6093C23.2186 11.4628 23.0199 11.3805 22.8128 11.3805H21.2503C21.043 11.3805 20.8443 11.4628 20.6978 11.6093C20.5513 11.7558 20.469 11.9545 20.469 12.1617V21.5368C20.469 21.5885 20.4895 21.6383 20.5261 21.6749C20.5628 21.7115 20.6125 21.732 20.6643 21.732ZM19.7424 8.91174L19.9846 9.27111C20.0376 9.35085 20.1096 9.41615 20.1943 9.46115C20.2788 9.50615 20.3731 9.52944 20.469 9.52893C20.5684 9.52533 20.6653 9.4961 20.7501 9.44409C20.835 9.39207 20.905 9.31904 20.9534 9.23205L22.5159 6.49768C22.5733 6.40499 22.6036 6.29811 22.6036 6.18908C22.6036 6.08005 22.5733 5.97318 22.5159 5.88049C22.4581 5.78858 22.375 5.71534 22.2766 5.6696C22.1781 5.62385 22.0686 5.60755 21.9611 5.62268L18.8361 6.0133C18.7371 6.02583 18.643 6.06343 18.5625 6.12254C18.4821 6.18166 18.4181 6.26034 18.3768 6.3511C18.3353 6.44188 18.3176 6.54174 18.3256 6.64121C18.3335 6.7407 18.3668 6.8365 18.4221 6.91955L18.6565 7.27893C18.6709 7.29976 18.6809 7.32333 18.686 7.34816C18.691 7.373 18.691 7.3986 18.6859 7.42344C18.6808 7.44826 18.6708 7.4718 18.6563 7.49261C18.6418 7.51343 18.6233 7.5311 18.6018 7.54455L7.53926 14.9351C7.45338 14.9919 7.37957 15.0651 7.32206 15.1505C7.26455 15.2359 7.22447 15.3318 7.20415 15.4326C7.18382 15.5336 7.18363 15.6375 7.20361 15.7385C7.22357 15.8395 7.26331 15.9355 7.32051 16.0211C7.39217 16.1271 7.48878 16.2139 7.60186 16.2739C7.71492 16.3338 7.84098 16.365 7.96895 16.3649C8.12255 16.3666 8.27282 16.3201 8.39863 16.232L19.469 8.85705C19.4904 8.84244 19.5146 8.83226 19.54 8.8271C19.5655 8.82194 19.5916 8.8219 19.6171 8.82699C19.6426 8.83209 19.6668 8.8422 19.6883 8.85675C19.7098 8.8713 19.7281 8.89 19.7424 8.91174ZM6.40645 24.3726H23.594C23.7796 24.3723 23.959 24.3058 24.1001 24.185C24.2411 24.0644 24.3346 23.8974 24.3638 23.7141C24.3929 23.5308 24.3558 23.343 24.2591 23.1845C24.1625 23.026 24.0125 22.9071 23.8361 22.8493C23.758 22.8235 23.6763 22.8104 23.594 22.8101H6.40645C6.32417 22.8104 6.24243 22.8235 6.16426 22.8493C5.98791 22.9071 5.83795 23.026 5.74127 23.1845C5.64458 23.343 5.6075 23.5308 5.63665 23.7141C5.66578 23.8974 5.75926 24.0644 5.90032 24.185C6.04138 24.3058 6.22081 24.3723 6.40645 24.3726Z",
                        fill: "currentColor"
                    })
                })
            ]
        }),
        styles: [
            {
                name: 'HITT',
                value: 'hitt',
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: 30,
                    height: 30,
                    viewBox: "0 0 30 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                            id: "mask0_736_308",
                            style: {
                                maskType: 'luminance'
                            },
                            maskUnits: "userSpaceOnUse",
                            x: 5,
                            y: 5,
                            width: 20,
                            height: 20,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M24.375 5.625H5.625V24.375H24.375V5.625Z",
                                fill: "white"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            mask: "url(#mask0_736_308)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M21.4499 14.5419C21.2035 14.2294 20.9036 13.9585 20.6251 13.6877C19.9073 13.0627 19.0932 12.6148 18.4076 11.9585C16.8115 10.4377 16.4579 7.92711 17.4756 6C16.4579 6.23959 15.5688 6.78127 14.8082 7.37504C12.0338 9.54179 10.9411 13.3648 12.248 16.6462C12.2909 16.7503 12.3337 16.8545 12.3337 16.9899C12.3337 17.2191 12.173 17.4274 11.9588 17.5108C11.7124 17.6149 11.4553 17.5524 11.2517 17.3857C11.191 17.3362 11.1401 17.2762 11.1018 17.2087C9.89131 15.719 9.69848 13.5835 10.5126 11.8752C8.72363 13.2919 7.74886 15.6878 7.88813 17.9482C7.95233 18.4691 8.01661 18.99 8.19878 19.5108C8.34871 20.1358 8.63798 20.7608 8.95936 21.313C10.1162 23.1151 12.1195 24.4068 14.2727 24.6672C16.5651 24.9484 19.0182 24.5422 20.775 23.0005C22.7354 21.2713 23.4209 18.5004 22.414 16.1253L22.2748 15.8545C22.0498 15.3753 21.4499 14.5419 21.4499 14.5419ZM18.0648 21.1046C17.7649 21.3546 17.2721 21.6254 16.8865 21.7296C15.6866 22.1463 14.4869 21.5629 13.7799 20.8754C15.0546 20.5837 15.8152 19.6671 16.0402 18.7399C16.2223 17.9066 15.8795 17.2191 15.7403 16.417C15.6117 15.6461 15.6331 14.9899 15.9224 14.2711C16.1259 14.6669 16.3401 15.0628 16.5972 15.3753C17.4221 16.417 18.7183 16.8753 18.9968 18.292C19.0397 18.4378 19.061 18.5837 19.061 18.7399C19.0932 19.5941 18.7076 20.5317 18.0648 21.1046Z",
                                fill: "currentColor"
                            })
                        })
                    ]
                })
            },
            {
                name: 'Bodybuilding Split',
                value: 'body-building-split',
                icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: 30,
                    height: 30,
                    viewBox: "0 0 30 30",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M23.5631 17.0211C23.5521 17.0055 23.5435 16.9883 23.5377 16.9704C23.5193 16.9144 21.6311 11.3194 17.0916 9.16189C17.0655 9.14824 16.5983 8.89999 16.284 8.36951C16.2703 8.34446 16.071 7.99339 15.3981 7.89844C15.4173 7.94689 15.4353 7.99534 15.4517 8.04424C15.4759 8.11579 15.4971 8.18846 15.517 8.26234C15.531 8.31439 15.5455 8.36636 15.5572 8.41871C15.5748 8.49731 15.587 8.57786 15.5991 8.65841C15.6061 8.70529 15.6159 8.75141 15.6206 8.79874C15.6347 8.92699 15.6429 9.05674 15.6429 9.18851C15.6429 9.55631 15.5865 9.91324 15.4794 10.2534C15.8763 10.3053 16.2336 10.5141 16.4638 10.8433C16.9404 11.5227 17.2531 12.5559 17.3934 13.9144C17.3946 13.941 17.4126 14.8479 17.8641 15.6549C18.1444 15.9574 18.4192 16.3097 18.6812 16.7331C18.7378 16.8249 18.7097 16.9453 18.6178 17.002C18.5256 17.0591 18.4056 17.031 18.3485 16.9386C16.612 14.1349 14.3418 14.3953 13.1424 14.7999C12.6288 14.9735 12.0744 14.9301 11.621 14.6814C9.23043 13.3703 7.10494 14.7295 6.5033 15.183C6.5033 15.183 6.47554 19.6631 6.28516 22.6236L8.99628 23.9985C9.26718 23.8612 10.1628 23.3409 10.4799 22.3167C10.5537 22.0813 10.6089 21.8675 10.6573 21.6787C10.7879 21.1725 10.8821 20.8065 11.1843 20.658C11.4075 20.5493 11.6867 20.5809 12.1182 20.7659C12.2379 20.8171 12.3575 20.8675 12.481 20.9085L13.259 21.1662C13.4126 21.2174 13.5428 21.2526 13.6691 21.2772C15.5369 21.6466 17.5569 21.3999 19.0717 20.6177C20.4935 19.8851 21.2863 19.5591 21.7007 19.4145C22.2629 19.2205 22.7628 18.9148 23.1475 18.5305C23.7253 17.9617 23.8645 17.4547 23.5631 17.0211ZM21.8563 17.1627C21.723 17.7756 21.2367 18.2956 20.4111 18.7084C20.3829 18.7225 20.3532 18.7291 20.3238 18.7291C20.2519 18.7291 20.1831 18.6897 20.1487 18.6208C20.1006 18.5243 20.1397 18.407 20.2363 18.3589C20.949 18.0024 21.3653 17.5731 21.4736 17.0833C21.6123 16.4562 21.1925 15.9191 21.1886 15.9136C21.1214 15.8292 21.135 15.7065 21.2191 15.6392C21.3031 15.5716 21.4259 15.5853 21.4931 15.6689C21.515 15.6967 22.0334 16.3511 21.8563 17.1627Z",
                            fill: "currentColor"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M9.26444 10.7459C9.27577 10.7658 9.28394 10.7885 9.29572 10.8084C9.35549 10.9116 9.42547 11.0063 9.49582 11.1009C9.52124 11.1348 9.54277 11.1728 9.56932 11.206C9.62677 11.2768 9.69172 11.3394 9.75427 11.4046C9.80152 11.4535 9.84494 11.5071 9.89534 11.5527C9.94072 11.5946 9.99232 11.629 10.0404 11.6681C10.1143 11.7283 10.1862 11.7909 10.2648 11.8444C10.2953 11.8647 10.3289 11.8796 10.3602 11.8992C10.4614 11.9621 10.5634 12.025 10.6714 12.0766C10.6909 12.0856 10.712 12.0915 10.732 12.1001C10.8543 12.1556 10.979 12.2068 11.1084 12.2467C11.1377 12.2556 11.1698 12.2596 11.1999 12.2678C11.3215 12.301 11.4439 12.3327 11.5701 12.3514C11.728 12.3753 11.8895 12.3878 12.0533 12.3878C12.2171 12.3878 12.3781 12.3753 12.5361 12.3514C12.6624 12.3327 12.7843 12.3014 12.9055 12.2678C12.9356 12.2596 12.9681 12.2561 12.9982 12.2467C13.1291 12.2064 13.2554 12.1548 13.3793 12.0985C13.3973 12.0903 13.4169 12.0852 13.4348 12.0766C13.5475 12.0227 13.6542 11.9582 13.7593 11.8917C13.7859 11.8749 13.8148 11.8624 13.841 11.8448C13.9251 11.7881 14.0017 11.7216 14.0803 11.6575C14.1229 11.622 14.1694 11.5915 14.2105 11.5536C14.2651 11.5039 14.3125 11.4461 14.3637 11.3921C14.4216 11.3311 14.4829 11.2733 14.5361 11.2072C14.5658 11.1705 14.59 11.1282 14.6182 11.0899C14.6851 10.9992 14.7526 10.9089 14.8102 10.81C14.8227 10.7885 14.8316 10.7643 14.8438 10.7427C14.9106 10.6216 14.9743 10.4973 15.0263 10.3655C15.1756 9.99573 15.2511 9.60048 15.2511 9.19C15.2511 9.07308 15.2437 8.95781 15.2311 8.84321C15.2265 8.80023 15.2182 8.75838 15.2116 8.71616C15.2011 8.64543 15.1901 8.57463 15.1749 8.50511C15.1643 8.45741 15.151 8.41046 15.1385 8.36396C15.121 8.29946 15.1025 8.23533 15.0811 8.17203C15.0658 8.12665 15.049 8.08248 15.0318 8.03831C15.0064 7.97306 14.9786 7.90893 14.9489 7.84518C14.9305 7.80648 14.913 7.76815 14.8934 7.73065C14.8336 7.61493 14.7683 7.50348 14.6968 7.39797C14.6776 7.36943 14.6554 7.34362 14.6354 7.31587C14.5807 7.2412 14.5232 7.16927 14.4634 7.10008C14.4266 7.05825 14.3895 7.01642 14.3508 6.97655C14.2984 6.9222 14.2429 6.87099 14.187 6.82095C14.1186 6.75958 14.0474 6.70093 13.9739 6.64543C13.9184 6.60399 13.8629 6.56216 13.8046 6.52424C13.7519 6.48984 13.6975 6.45739 13.6424 6.42572C13.5823 6.39132 13.5205 6.35926 13.4579 6.32878C13.4086 6.30453 13.3602 6.27913 13.3097 6.25763C13.201 6.2111 13.0893 6.17045 12.9751 6.13682C12.9349 6.12431 12.8934 6.11572 12.8527 6.10516C12.7612 6.08171 12.6686 6.06177 12.5748 6.04652C12.5345 6.03988 12.4942 6.03284 12.4536 6.02776C12.3219 6.01173 12.1885 6 12.0533 6C11.9176 6 11.7847 6.01173 11.653 6.02776C11.6119 6.03284 11.572 6.03988 11.5318 6.04652C11.4376 6.06177 11.3453 6.08171 11.2538 6.10516C11.2128 6.11572 11.1714 6.12471 11.1315 6.13682C11.0173 6.17045 10.9055 6.2111 10.7968 6.25763C10.7461 6.27913 10.6975 6.30453 10.6483 6.32878C10.5857 6.35926 10.5244 6.39132 10.4638 6.42611C10.409 6.45739 10.3547 6.48944 10.3019 6.52424C10.2441 6.56216 10.1886 6.60359 10.1331 6.64543C10.0591 6.70093 9.98722 6.75997 9.91844 6.82174C9.86294 6.87177 9.80782 6.9222 9.75577 6.97615C9.71707 7.01641 9.67957 7.05825 9.64282 7.10047C9.58342 7.16927 9.52672 7.24003 9.47279 7.31391C9.45164 7.34245 9.42899 7.36943 9.40904 7.39875C9.33787 7.50348 9.27382 7.61373 9.21397 7.72833C9.19364 7.76815 9.17452 7.80926 9.15532 7.85028C9.12682 7.91126 9.10019 7.97261 9.07559 8.03478C9.05797 8.08091 9.04042 8.12741 9.02474 8.17436C9.00367 8.23616 8.98567 8.29826 8.96887 8.36081C8.95597 8.40933 8.94224 8.45703 8.93137 8.50623C8.91652 8.57463 8.90557 8.64461 8.89499 8.71421C8.88832 8.75726 8.88014 8.79986 8.87504 8.84321C8.86289 8.95781 8.85547 9.07308 8.85547 9.19C8.85547 9.60085 8.93092 9.99573 9.07949 10.3635C9.13229 10.4973 9.19642 10.6231 9.26444 10.7459ZM11.7054 7.60278C11.7171 7.60046 11.7292 7.59731 11.7409 7.59536C11.8406 7.57586 11.9434 7.56453 12.0486 7.56408C12.1537 7.56453 12.2566 7.57586 12.3562 7.59536C12.3684 7.59731 12.3801 7.60046 12.3919 7.60278C13.126 7.76231 13.678 8.4124 13.678 9.19C13.678 9.8647 13.2671 10.4453 12.6823 10.6943C12.6799 10.695 12.6776 10.6962 12.6753 10.6971C12.5866 10.7342 12.4935 10.7623 12.3977 10.7834C12.3844 10.7862 12.3715 10.7901 12.3578 10.7924C12.2578 10.812 12.1546 10.8233 12.0486 10.8237C11.9427 10.8233 11.8399 10.812 11.7394 10.7924C11.7261 10.7901 11.7132 10.7862 11.6995 10.7834C11.6041 10.7623 11.5107 10.7342 11.422 10.6971C11.42 10.6962 11.4176 10.695 11.4153 10.6943C10.8304 10.4453 10.4192 9.8647 10.4192 9.19C10.4192 8.4124 10.9712 7.76231 11.7054 7.60278Z",
                            fill: "currentColor"
                        })
                    ]
                })
            }
        ]
    }
];
const traniningLimitation = [
    {
        name: 'Arms',
        value: 'arms',
        image: (0, _armsWebpDefault.default)
    },
    {
        name: 'Shoulders',
        value: 'shoulders',
        image: (0, _shouldersWebpDefault.default)
    },
    {
        name: 'Chest',
        value: 'chest',
        image: (0, _chestWebpDefault.default)
    },
    {
        name: 'Core',
        value: 'core',
        image: (0, _coreWebpDefault.default)
    },
    {
        name: 'Back',
        value: 'back',
        image: (0, _backWebpDefault.default)
    },
    {
        name: 'Glutes',
        value: 'glutes',
        image: (0, _glutesWebpDefault.default)
    },
    {
        name: 'Legs',
        value: 'legs',
        image: (0, _legsWebpDefault.default)
    }
];
const trainingEnergyLevel = [
    {
        name: 'Often low',
        value: 'often_low',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 40,
            height: 40,
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#clip0_9069_48936)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                            id: "mask0_9069_48936",
                            style: {
                                maskType: 'luminance'
                            },
                            maskUnits: "userSpaceOnUse",
                            x: 5,
                            y: 10,
                            width: 26,
                            height: 19,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M26.625 27.6667C30.2917 24.0105 30.2917 18.073 26.625 14.4167C22.9688 10.7501 17.0312 10.7501 13.375 14.4167C9.70833 18.073 9.70833 24.0105 13.375 27.6667",
                                    stroke: "white",
                                    strokeWidth: "2.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M17.7988 25.7621C20.4058 26.9778 23.5047 25.8499 24.7203 23.2429C25.936 20.6359 24.8081 17.5371 22.2011 16.3214C19.5941 15.1058 5.8389 14.4384 5.8389 14.4384C5.8389 14.4384 15.1919 24.5465 17.7988 25.7621Z",
                                    fill: "black"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M18.679 23.8741C20.2431 24.6035 22.1024 23.9268 22.8319 22.3626C23.5613 20.7984 22.8845 18.9391 21.3203 18.2097C19.7561 17.4803 9.61486 16.1994 9.61486 16.1994C9.61486 16.1994 17.1147 23.1447 18.679 23.8741Z",
                                    fill: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            mask: "url(#mask0_9069_48936)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M7.5 7.5H32.5V32.5H7.5V7.5Z",
                                fill: "currentColor"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "clip0_9069_48936",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 25,
                            height: 25,
                            fill: "white",
                            transform: "matrix(-1 0 0 1 32.5 7.5)"
                        })
                    })
                })
            ]
        })
    },
    {
        name: 'Fluctuates',
        value: 'fluctuates',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 40,
            height: 40,
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M13.0639 19.1319C13.4493 19.1319 13.7861 18.8819 13.9016 18.5112L15.2965 13.8567C15.5327 13.1128 16.1993 12.6214 16.9615 12.6214C17.7236 12.6214 18.3903 13.1128 18.6221 13.8437L22.1681 25.644L24.3894 20.6701C24.8044 19.736 25.7393 19.1319 26.7705 19.1319H30.4163V12.1874C30.4163 10.7517 29.2479 9.58325 27.8122 9.58325H12.1872C10.7514 9.58325 9.58301 10.7517 9.58301 12.1874V19.1319H13.0639Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M26.7705 20.8681C26.425 20.8681 26.1125 21.0678 25.9754 21.3768L23.7523 26.3516C23.4867 26.9714 22.8634 27.3785 22.1698 27.3785C21.4077 27.3785 20.741 26.8872 20.5092 26.1563L16.9632 14.356L15.5622 19.0174C15.2184 20.1268 14.2158 20.8681 13.0639 20.8681H9.58301V27.8126C9.58301 29.2483 10.7514 30.4167 12.1872 30.4167H27.8122C29.2479 30.4167 30.4163 29.2483 30.4163 27.8126V20.8681H26.7705Z",
                    fill: "currentColor"
                })
            ]
        })
    },
    {
        name: 'Often high',
        value: 'often_high',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 40,
            height: 40,
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    clipPath: "url(#clip0_9069_48948)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                            id: "mask0_9069_48948",
                            style: {
                                maskType: 'luminance'
                            },
                            maskUnits: "userSpaceOnUse",
                            x: 9,
                            y: 10,
                            width: 26,
                            height: 19,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M13.375 27.6667C9.70833 24.0105 9.70833 18.073 13.375 14.4167C17.0312 10.7501 22.9688 10.7501 26.625 14.4167C30.2917 18.073 30.2917 24.0105 26.625 27.6667",
                                    stroke: "white",
                                    strokeWidth: "2.5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M22.2012 25.7621C19.5942 26.9778 16.4953 25.8499 15.2797 23.2429C14.064 20.6359 15.1919 17.5371 17.7989 16.3214C20.4059 15.1058 34.1611 14.4384 34.1611 14.4384C34.1611 14.4384 24.8081 24.5465 22.2012 25.7621Z",
                                    fill: "black"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M21.321 23.8741C19.7569 24.6035 17.8976 23.9268 17.1681 22.3626C16.4387 20.7984 17.1155 18.9391 18.6797 18.2097C20.2439 17.4803 30.3851 16.1994 30.3851 16.1994C30.3851 16.1994 22.8853 23.1447 21.321 23.8741Z",
                                    fill: "white"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                            mask: "url(#mask0_9069_48948)",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M32.5 7.5H7.5V32.5H32.5V7.5Z",
                                fill: "currentColor"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "clip0_9069_48948",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 25,
                            height: 25,
                            fill: "white",
                            transform: "translate(7.5 7.5)"
                        })
                    })
                })
            ]
        })
    }
];
const trainingScheduleFlexibility = [
    {
        name: 'Limited',
        value: 'limited'
    },
    {
        name: 'Moderate',
        value: 'moderate'
    },
    {
        name: 'Flexible',
        value: 'flexible'
    }
];
const trainingIntensity = [
    {
        name: 'High intensity',
        value: 'high_intensity',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 40,
            height: 40,
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    clipPath: "url(#clip0_9069_49001)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M12.4001 18.8892C12.7286 18.4725 13.1285 18.1114 13.4999 17.7503C14.4569 16.9169 15.5424 16.3197 16.4565 15.4447C18.5847 13.4168 19.056 10.0695 17.6991 7.5C19.056 7.81945 20.2415 8.5417 21.2556 9.33339C24.9549 12.2224 26.4118 17.3197 24.6693 21.6948C24.6121 21.8337 24.555 21.9726 24.555 22.1532C24.555 22.4588 24.7693 22.7365 25.0549 22.8477C25.3834 22.9866 25.7262 22.9032 25.9976 22.681C26.0787 22.615 26.1465 22.5349 26.1976 22.4449C27.8116 20.4587 28.0687 17.6114 26.9831 15.3336C29.3684 17.2225 30.6682 20.417 30.4825 23.431C30.3968 24.1255 30.3111 24.8199 30.0683 25.5144C29.8683 26.3478 29.4827 27.1811 29.0542 27.9172C27.5116 30.3201 24.8407 32.0424 21.9698 32.3896C18.9132 32.7646 15.6424 32.2229 13.2999 30.1673C10.6861 27.8617 9.772 24.1671 11.1146 21.0004L11.3003 20.6393C11.6002 20.0004 12.4001 18.8892 12.4001 18.8892ZM16.9135 27.6395C17.3135 27.9728 17.9705 28.3339 18.4847 28.4728C20.0844 29.0284 21.6841 28.2506 22.6268 27.3339C20.9271 26.945 19.913 25.7227 19.6131 24.4866C19.3702 23.3755 19.8273 22.4588 20.013 21.3893C20.1844 20.3615 20.1558 19.4865 19.7702 18.5281C19.4988 19.0559 19.2131 19.5837 18.8703 20.0004C17.7705 21.3893 16.0423 22.0004 15.6709 23.8894C15.6138 24.0838 15.5852 24.2783 15.5852 24.4866C15.5424 25.6255 16.0566 26.8756 16.9135 27.6395Z",
                        fill: "currentColor"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "clip0_9069_49001",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 26,
                            height: 26,
                            fill: "white",
                            transform: "matrix(-1 0 0 1 33.5 7)"
                        })
                    })
                })
            ]
        })
    },
    {
        name: 'Balanced',
        value: 'balanced',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 40,
            height: 40,
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M33.5327 20.8654H6.46729C6.00173 20.8654 5.625 21.2524 5.625 21.7308C5.625 22.2091 6.00173 22.5962 6.46729 22.5962H18.5123L14.2241 29.9392C13.8874 30.5164 14.2927 31.25 14.9463 31.25H25.0537C25.7061 31.25 26.1132 30.5175 25.7759 29.9392L21.4877 22.5962H33.5327C33.9983 22.5962 34.375 22.2091 34.375 21.7308C34.375 21.2524 33.9983 20.8654 33.5327 20.8654Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M10.6787 19.1346C13.4698 19.1346 15.7324 16.8099 15.7324 13.9423C15.7324 11.0747 13.4698 8.75 10.6787 8.75C7.88762 8.75 5.625 11.0747 5.625 13.9423C5.625 16.8099 7.88762 19.1346 10.6787 19.1346Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M29.3213 19.1346C32.1124 19.1346 34.375 16.8099 34.375 13.9423C34.375 11.0747 32.1124 8.75 29.3213 8.75C26.5302 8.75 24.2676 11.0747 24.2676 13.9423C24.2676 16.8099 26.5302 19.1346 29.3213 19.1346Z",
                    fill: "currentColor"
                })
            ]
        })
    },
    {
        name: 'Low intensity',
        value: 'low_intensity',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            width: 40,
            height: 40,
            viewBox: "0 0 40 40",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M19.9999 24.1667C21.7291 24.1667 23.1249 22.7708 23.1249 21.0417C23.1249 19.875 22.4895 18.8542 21.5624 18.3229L11.4478 12.4688L17.2083 22.4479C17.7291 23.4688 18.7812 24.1667 19.9999 24.1667ZM19.9999 10.625C18.1145 10.625 16.3541 11.1458 14.8228 12L17.0103 13.2604C17.9166 12.9063 18.9583 12.7083 19.9999 12.7083C24.6041 12.7083 28.3333 16.4375 28.3333 21.0417C28.3333 23.3438 27.4062 25.4271 25.8958 26.9271H25.8853C25.7888 27.0235 25.7122 27.1379 25.6599 27.2639C25.6076 27.3899 25.5807 27.525 25.5807 27.6615C25.5807 27.7979 25.6076 27.933 25.6599 28.059C25.7122 28.185 25.7888 28.2995 25.8853 28.3958C26.2916 28.8021 26.9583 28.8021 27.3645 28.4063C28.3332 27.4402 29.1016 26.2923 29.6253 25.0285C30.1491 23.7646 30.418 22.4097 30.4166 21.0417C30.4166 15.3125 25.7291 10.625 19.9999 10.625ZM9.58325 21.0417C9.58325 23.9167 10.7499 26.5208 12.6353 28.4063C13.0416 28.8021 13.6978 28.8021 14.1041 28.3958C14.2007 28.2995 14.2773 28.185 14.3295 28.059C14.3818 27.933 14.4087 27.7979 14.4087 27.6615C14.4087 27.525 14.3818 27.3899 14.3295 27.2639C14.2773 27.1379 14.2007 27.0235 14.1041 26.9271C13.3294 26.1556 12.7151 25.2383 12.2968 24.2281C11.8784 23.218 11.6642 22.135 11.6666 21.0417C11.6666 20 11.8645 18.9583 12.2291 18.0208L10.9687 15.8333C10.1041 17.3958 9.58325 19.1458 9.58325 21.0417Z",
                fill: "currentColor"
            })
        })
    }
];

},{"react/jsx-runtime":"gonF6","react":"bmhQu","url:../assets/images/injuries/arms.webp":"ffHit","url:../assets/images/injuries/shoulders.webp":"fekuZ","url:../assets/images/injuries/chest.webp":"2EGBo","url:../assets/images/injuries/core.webp":"9QDOk","url:../assets/images/injuries/back.webp":"gIUc9","url:../assets/images/injuries/glutes.webp":"9KAfW","url:../assets/images/injuries/legs.webp":"5Hlzv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ffHit":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5JGEQ");

},{}],"fekuZ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("a5yqb");

},{}],"2EGBo":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7Ow16");

},{}],"9QDOk":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("hYlNH");

},{}],"gIUc9":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1qJS6");

},{}],"9KAfW":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kgJlg");

},{}],"5Hlzv":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dmIfb");

},{}],"5knEg":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lMihR");

},{}],"5ZLH7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSliderDotClick", ()=>useSliderDotClick);
var _react = require("react");
function useSliderDotClick({ ref, step, targetStep, onDotClick, delay = 500 }) {
    (0, _react.useEffect)(()=>{
        if (step !== targetStep) return;
        const timer = setTimeout(()=>{
            if (!ref?.current) return;
            const dot = ref.current.querySelector('.ant-slider .ant-slider-dot');
            if (!dot) return;
            dot.addEventListener('click', onDotClick);
            return ()=>{
                dot.removeEventListener('click', onDotClick);
            };
        }, delay);
        return ()=>clearTimeout(timer);
    }, [
        step,
        targetStep,
        ref,
        onDotClick,
        delay
    ]);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dhG6r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScreenTime", ()=>useScreenTime);
var _react = require("react");
var _screenTimeTracker = require("src/utils/screenTimeTracker");
var _useConsent = require("src/hooks/useConsent");
var _constants = require("src/config/constants");
const useScreenTime = (sectionName, active = true)=>{
    const prevSectionRef = (0, _react.useRef)(null);
    // ── Primary effect: start/stop on section change, step change, or mount/unmount ──
    (0, _react.useEffect)(()=>{
        // Never track automated transition pages
        if ((0, _screenTimeTracker.SKIPPED_SECTIONS).has(sectionName)) {
            if (prevSectionRef.current && prevSectionRef.current !== sectionName) (0, _screenTimeTracker.screenTimeTracker).stopSection(prevSectionRef.current);
            prevSectionRef.current = sectionName;
            return;
        }
        // When the consent banner is disabled, treat tracking as always allowed.
        const hasConsent = !(0, _constants.REQUIRE_ANALYTICS_CONSENT) || localStorage.getItem((0, _useConsent.CONSENT_KEY)) === 'accepted';
        if (active && hasConsent) (0, _screenTimeTracker.screenTimeTracker).startSection(sectionName);
        else (0, _screenTimeTracker.screenTimeTracker).stopSection(sectionName);
        prevSectionRef.current = sectionName;
        return ()=>{
            (0, _screenTimeTracker.screenTimeTracker).stopSection(sectionName);
        };
    }, [
        sectionName,
        active
    ]);
    // ── Consent effect: start timing immediately when user accepts ──
    // Runs when the user clicks Accept on the ConsentBanner while this section
    // is already mounted, so we don't wait for a dependency change.
    (0, _react.useEffect)(()=>{
        const handleConsentAccepted = ()=>{
            if (active && !(0, _screenTimeTracker.SKIPPED_SECTIONS).has(sectionName)) (0, _screenTimeTracker.screenTimeTracker).startSection(sectionName);
        };
        window.addEventListener((0, _useConsent.CONSENT_ACCEPTED_EVENT), handleConsentAccepted);
        return ()=>window.removeEventListener((0, _useConsent.CONSENT_ACCEPTED_EVENT), handleConsentAccepted);
    }, [
        sectionName,
        active
    ]);
};

},{"react":"bmhQu","src/utils/screenTimeTracker":"dwAC9","src/hooks/useConsent":"7aJSC","src/config/constants":"uHGJK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dwAC9":[function(require,module,exports,__globalThis) {
/**
 * ScreenTimeTracker
 *
 * A singleton utility class that tracks how long a user spends on each
 * named section of the trainer flow.
 *
 * - Sections that are automated transitions are registered in SKIPPED_SECTIONS
 *   and are silently ignored so their time is never counted.
 * - Multiple sections can be active concurrently (e.g. Section 14 + AI Chat).
 * - Time is persisted to localStorage so it survives soft navigations.
 * - Page visibility changes (tab switch / minimize) are handled automatically:
 *   active sections pause when the tab is hidden and resume when it returns.
 */ // -------------------------------------------
// Section name constants
// -------------------------------------------
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TRAINER_SECTIONS", ()=>TRAINER_SECTIONS);
parcelHelpers.export(exports, "STEP_TO_SECTION", ()=>STEP_TO_SECTION);
parcelHelpers.export(exports, "SKIPPED_SECTIONS", ()=>SKIPPED_SECTIONS);
// -------------------------------------------
// ScreenTimeTracker class
// -------------------------------------------
parcelHelpers.export(exports, "ScreenTimeTracker", ()=>ScreenTimeTracker);
parcelHelpers.export(exports, "screenTimeTracker", ()=>screenTimeTracker);
const TRAINER_SECTIONS = {
    // Trackable sections
    SECTION_1: 'trainer_section_1_program_creator',
    SECTION_2: 'trainer_section_2_client_select',
    SECTION_3: 'trainer_section_3_energy_level',
    SECTION_4: 'trainer_section_4_activity',
    SECTION_5: 'trainer_section_5_intensity',
    SECTION_6: 'trainer_section_6_fitness_level',
    SECTION_7: 'trainer_section_7_training_goal',
    SECTION_8: 'trainer_section_8_movement_insights',
    SECTION_9: 'trainer_section_9_program_duration',
    SECTION_10: 'trainer_section_10_training_frequency',
    SECTION_11: 'trainer_section_11_program_focus',
    SECTION_12: 'trainer_section_12_injuries',
    SECTION_13: 'trainer_section_13_generate_review',
    SECTION_14: 'trainer_section_14_program_generated',
    SECTION_15: 'trainer_section_15_program_completed',
    AI_CHAT: 'trainer_ai_chat_assistant',
    // Automated transitions (always skipped - user has no control)
    AUTOMATED_INTRO: 'automated_intro',
    AUTOMATED_CLIENT_INTRO: 'automated_client_intro',
    AUTOMATED_PROGRAM_INTRO: 'automated_program_intro'
};
const STEP_TO_SECTION = {
    1: TRAINER_SECTIONS.SECTION_1,
    2: TRAINER_SECTIONS.AUTOMATED_INTRO,
    3: TRAINER_SECTIONS.SECTION_2,
    4: TRAINER_SECTIONS.AUTOMATED_CLIENT_INTRO,
    5: TRAINER_SECTIONS.SECTION_3,
    6: TRAINER_SECTIONS.SECTION_4,
    7: TRAINER_SECTIONS.SECTION_5,
    8: TRAINER_SECTIONS.SECTION_6,
    9: TRAINER_SECTIONS.SECTION_7,
    10: TRAINER_SECTIONS.SECTION_8,
    11: TRAINER_SECTIONS.AUTOMATED_PROGRAM_INTRO,
    12: TRAINER_SECTIONS.SECTION_9,
    13: TRAINER_SECTIONS.SECTION_10,
    14: TRAINER_SECTIONS.SECTION_11,
    15: TRAINER_SECTIONS.SECTION_12,
    16: TRAINER_SECTIONS.SECTION_13
};
const SKIPPED_SECTIONS = new Set([
    TRAINER_SECTIONS.AUTOMATED_INTRO,
    TRAINER_SECTIONS.AUTOMATED_CLIENT_INTRO,
    TRAINER_SECTIONS.AUTOMATED_PROGRAM_INTRO
]);
// -------------------------------------------
// Storage key & label map
// -------------------------------------------
const STORAGE_KEY = 'minipt_screen_time_v1';
const SESSION_ID_KEY = 'minipt_behavior_session_id';
const SECTION_LABELS = {
    [TRAINER_SECTIONS.SECTION_1]: 'Section 1 - Program Creator Landing',
    [TRAINER_SECTIONS.SECTION_2]: 'Section 2 - Client Select',
    [TRAINER_SECTIONS.SECTION_3]: 'Section 3 - Baseline Energy Level',
    [TRAINER_SECTIONS.SECTION_4]: 'Section 4 - Non-Gym Activity',
    [TRAINER_SECTIONS.SECTION_5]: 'Section 5 - Intensity Vibe',
    [TRAINER_SECTIONS.SECTION_6]: 'Section 6 - Fitness Level',
    [TRAINER_SECTIONS.SECTION_7]: 'Section 7 - Training Goal',
    [TRAINER_SECTIONS.SECTION_8]: 'Section 8 - Movement Insights',
    [TRAINER_SECTIONS.SECTION_9]: 'Section 9 - Program Duration',
    [TRAINER_SECTIONS.SECTION_10]: 'Section 10 - Training Frequency',
    [TRAINER_SECTIONS.SECTION_11]: 'Section 11 - Program Focus',
    [TRAINER_SECTIONS.SECTION_12]: 'Section 12 - Injuries & Limitations',
    [TRAINER_SECTIONS.SECTION_13]: 'Section 13 - Generate Review',
    [TRAINER_SECTIONS.SECTION_14]: 'Section 14 - Program Generated (/trainer/generated/ai)',
    [TRAINER_SECTIONS.SECTION_15]: 'Section 15 - Program Completed (/trainer/generated/ai/completed)',
    [TRAINER_SECTIONS.AI_CHAT]: 'AI Chat - "How can I assist you today?"'
};
class ScreenTimeTracker {
    static _instance = null;
    records = new Map();
    /**
   * Set of section names whose timers are currently running.
   * Used to pause/resume on tab visibility change.
   */ activeSections = new Set();
    constructor(){
        this._loadFromStorage();
        this._bindVisibilityChange();
    }
    /** Returns the singleton instance, creating it on the first call. */ static getInstance() {
        if (!ScreenTimeTracker._instance) ScreenTimeTracker._instance = new ScreenTimeTracker();
        return ScreenTimeTracker._instance;
    }
    // ---------- Private helpers ----------
    _ensureRecord(name) {
        if (!this.records.has(name)) this.records.set(name, {
            totalMs: 0,
            visitCount: 0,
            lastStartedAt: null
        });
        return this.records.get(name);
    }
    _loadFromStorage() {
        try {
            const raw = localStorage.getItem(STORAGE_KEY);
            if (!raw) return;
            const data = JSON.parse(raw);
            for (const [name, persisted] of Object.entries(data))this.records.set(name, {
                totalMs: persisted.totalMs ?? 0,
                visitCount: persisted.visitCount ?? 0,
                lastStartedAt: null
            });
        } catch  {
        // Corrupted storage - start fresh
        }
    }
    _saveToStorage() {
        try {
            const data = {};
            this.records.forEach((rec, name)=>{
                data[name] = {
                    totalMs: rec.totalMs,
                    visitCount: rec.visitCount
                };
            });
            localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
        } catch  {
        // Ignore quota / security errors
        }
    }
    _bindVisibilityChange() {
        document.addEventListener('visibilitychange', ()=>{
            if (document.hidden) this._pauseAll();
            else this._resumeAll();
        });
    }
    /**
   * Accumulate elapsed time for all active sections without removing
   * them from the active set (they will resume when the tab returns).
   */ _pauseAll() {
        const now = Date.now();
        this.activeSections.forEach((name)=>{
            const rec = this.records.get(name);
            if (rec && rec.lastStartedAt !== null) {
                rec.totalMs += now - rec.lastStartedAt;
                rec.lastStartedAt = null;
            }
        });
        this._saveToStorage();
    }
    /** Restart the timer for all sections that were active before the pause. */ _resumeAll() {
        const now = Date.now();
        this.activeSections.forEach((name)=>{
            const rec = this.records.get(name);
            if (rec && rec.lastStartedAt === null) rec.lastStartedAt = now;
        });
    // Storage will be updated on next stop call
    }
    // ---------- Public API ----------
    /**
   * Begin timing a section.
   * - Silently ignored for sections in `SKIPPED_SECTIONS`.
   * - Idempotent: safe to call multiple times while the section is active.
   */ startSection(sectionName) {
        if (!sectionName || SKIPPED_SECTIONS.has(sectionName)) return;
        const rec = this._ensureRecord(sectionName);
        // Already running - don't double-count
        if (rec.lastStartedAt !== null) return;
        rec.lastStartedAt = Date.now();
        rec.visitCount += 1;
        this.activeSections.add(sectionName);
        this._saveToStorage();
    }
    /**
   * Stop timing a section and accumulate the elapsed duration.
   * - Silently ignored for sections in `SKIPPED_SECTIONS`.
   * - Safe to call on a section that is not currently running (no-op).
   */ stopSection(sectionName) {
        if (!sectionName || SKIPPED_SECTIONS.has(sectionName)) return;
        const rec = this.records.get(sectionName);
        if (!rec || rec.lastStartedAt === null) return;
        rec.totalMs += Date.now() - rec.lastStartedAt;
        rec.lastStartedAt = null;
        this.activeSections.delete(sectionName);
        this._saveToStorage();
    }
    /**
   * Returns the total seconds spent on a section
   * (including any currently-active window).
   */ getSectionSeconds(sectionName) {
        const rec = this.records.get(sectionName);
        if (!rec) return 0;
        const activeMs = rec.lastStartedAt !== null ? Date.now() - rec.lastStartedAt : 0;
        return Math.round((rec.totalMs + activeMs) / 1000);
    }
    /**
   * Returns the session ID previously persisted by `setSessionId()`,
   * or `null` if no session has been established yet.
   *
   * The session ID is generated by the backend on the first
   * `user_behavior_tracker` call and returned in the response.
   * Callers should pass this value on all subsequent requests so the
   * backend can upsert the same Firestore document.
   */ getStoredSessionId() {
        try {
            return localStorage.getItem(SESSION_ID_KEY);
        } catch  {
            return null;
        }
    }
    /**
   * Persists the session ID returned by the backend after the first
   * `user_behavior_tracker` POST request.
   * Call this once when you receive the response from the initial call.
   */ setSessionId(id) {
        try {
            localStorage.setItem(SESSION_ID_KEY, id);
        } catch  {
        // Ignore quota / security errors
        }
    }
    /**
   * Returns a report of all recorded (non-skipped) sections,
   * sorted alphabetically by section name.
   */ getReport() {
        const results = [];
        this.records.forEach((rec, name)=>{
            // Exclude empty names and automated sections from the report
            if (!name || SKIPPED_SECTIONS.has(name)) return;
            const activeMs = rec.lastStartedAt !== null ? Date.now() - rec.lastStartedAt : 0;
            results.push({
                sectionName: name,
                label: SECTION_LABELS[name] ?? name,
                totalSeconds: Math.round((rec.totalMs + activeMs) / 1000),
                visitCount: rec.visitCount
            });
        });
        return results.sort((a, b)=>a.sectionName.localeCompare(b.sectionName));
    }
    /**
   * Logs the current screen-time report to the browser console as a formatted table.
   * Useful for debugging / QA - call `screenTimeTracker.logReport()` from DevTools.
   */ logReport() {
        const report = this.getReport();
        console.group('[ScreenTimeTracker] Screen Time Report');
        console.table(report.map((r)=>({
                Section: r.label,
                'Time (s)': r.totalSeconds,
                'Time (m:ss)': `${Math.floor(r.totalSeconds / 60)}:${String(r.totalSeconds % 60).padStart(2, '0')}`,
                Visits: r.visitCount
            })));
        console.groupEnd();
    }
    /**
   * Clears all tracked data (both in-memory and in localStorage).
   * Stops any currently-active sections first.
   */ reset() {
        this._pauseAll();
        this.records.clear();
        this.activeSections.clear();
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(SESSION_ID_KEY);
    }
}
const screenTimeTracker = ScreenTimeTracker.getInstance();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7aJSC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSENT_KEY", ()=>CONSENT_KEY);
parcelHelpers.export(exports, "CONSENT_ACCEPTED_EVENT", ()=>CONSENT_ACCEPTED_EVENT);
parcelHelpers.export(exports, "CONSENT_RESET_EVENT", ()=>CONSENT_RESET_EVENT);
parcelHelpers.export(exports, "useConsent", ()=>useConsent);
var _react = require("react");
const CONSENT_KEY = 'analytics_consent';
const CONSENT_ACCEPTED_EVENT = 'analytics-consent-accepted';
const CONSENT_RESET_EVENT = 'analytics-consent-reset';
const useConsent = ()=>{
    const [consent, setConsent] = (0, _react.useState)(()=>localStorage.getItem(CONSENT_KEY) ?? null);
    // Listen for consent-reset triggered from elsewhere (e.g. "Privacy Settings" in footer)
    (0, _react.useEffect)(()=>{
        const handleReset = ()=>setConsent(null);
        window.addEventListener(CONSENT_RESET_EVENT, handleReset);
        return ()=>window.removeEventListener(CONSENT_RESET_EVENT, handleReset);
    }, []);
    const accept = ()=>{
        localStorage.setItem(CONSENT_KEY, 'accepted');
        setConsent('accepted');
        // Notify useScreenTime instances to start timing immediately
        window.dispatchEvent(new Event(CONSENT_ACCEPTED_EVENT));
    };
    const reject = ()=>{
        localStorage.setItem(CONSENT_KEY, 'rejected');
        // Clear all stored analytics data as required
        localStorage.removeItem('minipt_screen_time_v1');
        localStorage.removeItem('minipt_behavior_session_id');
        setConsent('rejected');
    };
    /**
   * Clears the stored consent so the banner is shown again.
   * Called by the "Privacy Settings" link in the footer.
   */ const reset = ()=>{
        localStorage.removeItem(CONSENT_KEY);
        setConsent(null);
        window.dispatchEvent(new Event(CONSENT_RESET_EVENT));
    };
    return {
        consent,
        accept,
        reject,
        reset
    };
};

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3nht4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trackUserBehavior", ()=>trackUserBehavior);
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
const trackUserBehavior = async (payload)=>{
    const response = await (0, _axiosDefault.default).post(`${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).USER_BEHAVIOR_TRACKER_API_HOST}`, payload, {
        headers: {
            'Content-Type': 'application/json'
        },
        // Allow up to 10 s for the Cloud Function cold start
        timeout: 10000
    });
    return response.data;
};

},{"axios":"kL5AO","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hM1mR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "programStore", ()=>programStore);
parcelHelpers.export(exports, "setGeneratedProgram", ()=>setGeneratedProgram);
parcelHelpers.export(exports, "updateGeneratedProgram", ()=>updateGeneratedProgram);
parcelHelpers.export(exports, "setStoredWeeks", ()=>setStoredWeeks);
parcelHelpers.export(exports, "clearGeneratedProgram", ()=>clearGeneratedProgram);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
const programStore = (0, _zustand.create)()((0, _middleware.persist)(()=>({
        program: null,
        payload: null,
        weeks: null
    }), {
    name: 'minipt_program_state'
}));
const setGeneratedProgram = (program, payload)=>programStore.setState({
        program,
        payload,
        weeks: null
    });
const updateGeneratedProgram = (program)=>programStore.setState((s)=>({
            ...s,
            program
        }));
const setStoredWeeks = (weeks)=>programStore.setState((s)=>({
            ...s,
            weeks
        }));
const clearGeneratedProgram = ()=>programStore.setState({
        program: null,
        payload: null,
        weeks: null
    });

},{"zustand":"dodpK","zustand/middleware":"2zkjt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9D5GI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MuscleGroupImages", ()=>MuscleGroupImages);
var _programFocusPng = require("url:../../../../../../../assets/images/muscle-group/male/program-focus.png");
var _programFocusPngDefault = parcelHelpers.interopDefault(_programFocusPng);
var _programFocusFullBodyPng = require("url:../../../../../../../assets/images/muscle-group/male/program-focus-full-body.png");
var _programFocusFullBodyPngDefault = parcelHelpers.interopDefault(_programFocusFullBodyPng);
var _programFocusUpperBodyPng = require("url:../../../../../../../assets/images/muscle-group/male/program-focus-upper-body.png");
var _programFocusUpperBodyPngDefault = parcelHelpers.interopDefault(_programFocusUpperBodyPng);
var _programFocusLowerBodyPng = require("url:../../../../../../../assets/images/muscle-group/male/program-focus-lower-body.png");
var _programFocusLowerBodyPngDefault = parcelHelpers.interopDefault(_programFocusLowerBodyPng);
var _programFocusBackPng = require("url:../../../../../../../assets/images/muscle-group/male/program-focus-back.png");
var _programFocusBackPngDefault = parcelHelpers.interopDefault(_programFocusBackPng);
var _programFocusCorePng = require("url:../../../../../../../assets/images/muscle-group/male/program-focus-core.png");
var _programFocusCorePngDefault = parcelHelpers.interopDefault(_programFocusCorePng);
var _programFocusGlutesPng = require("url:../../../../../../../assets/images/muscle-group/male/program-focus-glutes.png");
var _programFocusGlutesPngDefault = parcelHelpers.interopDefault(_programFocusGlutesPng);
var _programFocusPng1 = require("url:../../../../../../../assets/images/muscle-group/female/program-focus.png");
var _programFocusPngDefault1 = parcelHelpers.interopDefault(_programFocusPng1);
var _programFocusFullBodyPng1 = require("url:../../../../../../../assets/images/muscle-group/female/program-focus-full-body.png");
var _programFocusFullBodyPngDefault1 = parcelHelpers.interopDefault(_programFocusFullBodyPng1);
var _programFocusUpperBodyPng1 = require("url:../../../../../../../assets/images/muscle-group/female/program-focus-upper-body.png");
var _programFocusUpperBodyPngDefault1 = parcelHelpers.interopDefault(_programFocusUpperBodyPng1);
var _programFocusLowerBodyPng1 = require("url:../../../../../../../assets/images/muscle-group/female/program-focus-lower-body.png");
var _programFocusLowerBodyPngDefault1 = parcelHelpers.interopDefault(_programFocusLowerBodyPng1);
var _programFocusBackPng1 = require("url:../../../../../../../assets/images/muscle-group/female/program-focus-back.png");
var _programFocusBackPngDefault1 = parcelHelpers.interopDefault(_programFocusBackPng1);
var _programFocusCorePng1 = require("url:../../../../../../../assets/images/muscle-group/female/program-focus-core.png");
var _programFocusCorePngDefault1 = parcelHelpers.interopDefault(_programFocusCorePng1);
var _programFocusGlutesPng1 = require("url:../../../../../../../assets/images/muscle-group/female/program-focus-glutes.png");
var _programFocusGlutesPngDefault1 = parcelHelpers.interopDefault(_programFocusGlutesPng1);
const MuscleGroupImages = {
    male: {
        base: (0, _programFocusPngDefault.default),
        full_body: (0, _programFocusFullBodyPngDefault.default),
        upper_body: (0, _programFocusUpperBodyPngDefault.default),
        lower_body: (0, _programFocusLowerBodyPngDefault.default),
        back: (0, _programFocusBackPngDefault.default),
        core: (0, _programFocusCorePngDefault.default),
        glutes: (0, _programFocusGlutesPngDefault.default)
    },
    female: {
        base: (0, _programFocusPngDefault1.default),
        full_body: (0, _programFocusFullBodyPngDefault1.default),
        upper_body: (0, _programFocusUpperBodyPngDefault1.default),
        lower_body: (0, _programFocusLowerBodyPngDefault1.default),
        back: (0, _programFocusBackPngDefault1.default),
        core: (0, _programFocusCorePngDefault1.default),
        glutes: (0, _programFocusGlutesPngDefault1.default)
    }
};

},{"url:../../../../../../../assets/images/muscle-group/male/program-focus.png":"f47Oy","url:../../../../../../../assets/images/muscle-group/male/program-focus-full-body.png":"i8Gqh","url:../../../../../../../assets/images/muscle-group/male/program-focus-upper-body.png":"czMSK","url:../../../../../../../assets/images/muscle-group/male/program-focus-lower-body.png":"8vnuA","url:../../../../../../../assets/images/muscle-group/male/program-focus-back.png":"4uvDS","url:../../../../../../../assets/images/muscle-group/male/program-focus-core.png":"4aXMy","url:../../../../../../../assets/images/muscle-group/male/program-focus-glutes.png":"5m2yJ","url:../../../../../../../assets/images/muscle-group/female/program-focus.png":"3q5k2","url:../../../../../../../assets/images/muscle-group/female/program-focus-full-body.png":"jSvhU","url:../../../../../../../assets/images/muscle-group/female/program-focus-upper-body.png":"9qeHA","url:../../../../../../../assets/images/muscle-group/female/program-focus-lower-body.png":"gLkwR","url:../../../../../../../assets/images/muscle-group/female/program-focus-back.png":"gCirR","url:../../../../../../../assets/images/muscle-group/female/program-focus-core.png":"9kOFI","url:../../../../../../../assets/images/muscle-group/female/program-focus-glutes.png":"6HQAc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f47Oy":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9QBcS");

},{}],"i8Gqh":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("f4JH9");

},{}],"czMSK":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9NRiB");

},{}],"8vnuA":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fvBrh");

},{}],"4uvDS":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3SSdD");

},{}],"4aXMy":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kUy3y");

},{}],"5m2yJ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2iona");

},{}],"3q5k2":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2jbwA");

},{}],"jSvhU":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dkuWo");

},{}],"9qeHA":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("d1k56");

},{}],"gLkwR":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("bMB73");

},{}],"gCirR":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lJFIC");

},{}],"9kOFI":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("aJvX7");

},{}],"6HQAc":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1VSYO");

},{}],"lgM1o":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgramGenerated", ()=>ProgramGenerated);
var _jsxRuntime = require("react/jsx-runtime");
var _indexCss = require("../../../../index.css");
var _routeCss = require("../../../../route.css");
var _resetCss = require("../../../../reset.css");
var _programGeneratedCss = require("./program-generated.css");
// 🔹 React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 UI Component Libraries
var _antd = require("antd");
// 🔹 Drag & Drop Library
var _core = require("@dnd-kit/core");
// 🔹 Internal Components
var _exerciseCard = require("./ExerciseCard");
var _exerciseLibrary = require("./ExerciseLibrary");
var _programBuilder = require("./ProgramBuilder");
var _commandDialog = require("src/components/Modals/CommandDialog/CommandDialog");
var _commandDialogDefault = parcelHelpers.interopDefault(_commandDialog);
// 🔹 Custom Hooks
var _useProgramStore = require("./useProgramStore");
var _useScreenTime = require("src/hooks/useScreenTime");
var _screenTimeTracker = require("src/utils/screenTimeTracker");
var _reactRouterDom = require("react-router-dom");
var _programStore = require("src/store/programStore");
var _useWorkoutProgram = require("src/api/mutations/useWorkoutProgram");
const regenerateWorkoutProgram = async (payload)=>{
    const data = await (0, _useWorkoutProgram.generateWorkoutProgramCoach)(payload);
    if (!data?.program?.data) throw new Error('Workout program response did not include program data.');
    return data.program;
};
const ProgramGenerated = ()=>{
    // Use
    const { type } = (0, _reactRouterDom.useParams)();
    const location = (0, _reactRouterDom.useLocation)();
    // location.state is populated on a fresh generate navigate.
    // It is null when navigating back from /completed (no state was forwarded).
    // The programStore bridges that gap entirely in-memory.
    const { program: storedProgram, payload: storedPayload } = (0, _programStore.programStore)();
    const payload = location.state?.payload ?? storedPayload;
    const [program, setProgram] = (0, _react.useState)(()=>location.state?.program ?? storedProgram);
    const apiProgramData = program?.data;
    const containerRef = (0, _react.useRef)(null);
    const programBuilderRef = (0, _react.useRef)(null);
    const tourPopupRef = (0, _react.useRef)(null);
    // Store
    // skipStoredWeeks = true on a fresh generation so weeks are always rebuilt
    // from the new apiProgramData instead of using cached values from the store.
    // skipStoredWeeks = false on back-navigation so drag-and-drop additions are restored.
    const isFreshNavigation = Boolean(location.state?.program);
    const store = (0, _useProgramStore.useProgramStore)(type, apiProgramData, isFreshNavigation);
    const { reorderLibrary, placeExercise, filteredExercises } = store;
    // State
    const [isLibraryOpen, setIsLibraryOpen] = (0, _react.useState)(false);
    const [open, setOpen] = (0, _react.useState)(false);
    const [isRemixing, setIsRemixing] = (0, _react.useState)(false);
    const [generateErrorVisible, setGenerateErrorVisible] = (0, _react.useState)(false);
    // AI Modification states
    const [isAIModifying, setIsAIModifying] = (0, _react.useState)(false);
    const [selectedAIOption, setSelectedAIOption] = (0, _react.useState)('');
    const [aiModifySuccess, setAiModifySuccess] = (0, _react.useState)(false);
    // Keep the programStore in sync on every program change.
    // Covers initial load, remix, and AI modifications – ensures back-navigation
    // from /completed always renders the latest state from the store.
    (0, _react.useEffect)(()=>{
        if (!program) return;
        if (payload) (0, _programStore.setGeneratedProgram)(program, payload);
        else (0, _programStore.updateGeneratedProgram)(program);
    }, [
        program,
        payload
    ]);
    (0, _react.useEffect)(()=>{
        if (type === 'ai' && !localStorage.getItem('minipt-tour-done')) setOpen(true);
    }, [
        type
    ]);
    const handleTourClose = ()=>{
        setOpen(false);
        localStorage.setItem('minipt-tour-done', 'true');
        document.body.removeAttribute('data-step');
    };
    const handleRemixWorkout = async ()=>{
        if (isRemixing) return;
        if (!payload) {
            setGenerateErrorVisible(true);
            return;
        }
        setIsRemixing(true);
        try {
            const nextProgram = await regenerateWorkoutProgram(payload);
            setProgram(nextProgram);
            store.resetProgramData(nextProgram.data);
            (0, _antd.message).success('Workout remixed successfully');
        } catch  {
            setGenerateErrorVisible(true);
        } finally{
            setIsRemixing(false);
        }
    };
    const handleAIModifyWorkout = async (option)=>{
        if (isAIModifying) return;
        if (!payload) {
            setGenerateErrorVisible(true);
            return;
        }
        setIsAIModifying(true);
        setSelectedAIOption(option);
        setAiModifySuccess(false);
        try {
            const nextProgram = await regenerateWorkoutProgram({
                ...payload,
                preferences: option
            });
            setProgram(nextProgram);
            store.resetProgramData(nextProgram.data);
            setAiModifySuccess(true);
        } catch  {
            setGenerateErrorVisible(true);
        } finally{
            setIsAIModifying(false);
        }
    };
    const sensors = (0, _core.useSensors)((0, _core.useSensor)((0, _core.PointerSensor), {
        activationConstraint: {
            distance: 8
        }
    }), (0, _core.useSensor)((0, _core.TouchSensor), {
        activationConstraint: {
            delay: 200,
            tolerance: 5
        }
    }));
    const handleDragStart = (event)=>{
        const { active } = event;
        const allExs = Object.values(filteredExercises).flat();
        const ex = allExs.find((e)=>e._id === active.id);
        if (ex) store.setDraggedExercise(ex);
        // Lock body scroll to prevent jitter on mobile
        document.body.style.overflow = 'hidden';
        // Auto-close library on mobile/small-tablet when dragging starts
        if (window.innerWidth < 1024 && isLibraryOpen) setTimeout(()=>{
            setIsLibraryOpen(false);
        }, 100);
    };
    const handleDragEnd = (event)=>{
        const { active, over } = event;
        store.setDraggedExercise(null);
        if (window.innerWidth < 1024) setIsLibraryOpen(true);
        if (!over) return;
        const activeId = active.id;
        const overId = over.id;
        // source: list-A, destination: slot-week1-Mon-warmup (Place Exercise)
        if (overId.startsWith('slot-')) {
            const allExs = Object.values(filteredExercises).flat();
            const ex = allExs.find((e)=>e._id === activeId);
            if (ex) {
                const parts = overId.split('-'); // ["slot", weekId, dayStr, slotType]
                const [, weekId, dayStr, slotType] = parts;
                // Relaxed Validation: Allow drop but show warning if type mismatch
                if (!ex.type.some((t)=>t.toLowerCase() === slotType.toLowerCase())) (0, _antd.message).warning({
                    content: `${ex.name} is ideally for ${ex.type.join('/')}, but I've placed it in ${slotType} for you.`,
                    style: {
                        marginTop: '10vh'
                    }
                });
                placeExercise(weekId, dayStr, slotType, ex);
            }
            return;
        }
        // Handle Library Reorder
        // In dnd-kit, if dropping on another item in the same list
        const allExs = Object.values(filteredExercises).flat();
        const activeEx = allExs.find((e)=>e._id === activeId);
        const overEx = allExs.find((e)=>e._id === overId);
        if (activeEx && overEx) {
            const activeLetter = activeEx.name.charAt(0).toUpperCase();
            const overLetter = overEx.name.charAt(0).toUpperCase();
            if (activeLetter === overLetter) {
                const list = filteredExercises[activeLetter];
                const oldIndex = list.findIndex((e)=>e._id === activeId);
                const newIndex = list.findIndex((e)=>e._id === overId);
                if (oldIndex !== newIndex) reorderLibrary(activeLetter, oldIndex, newIndex);
            }
        }
    };
    // ── Screen time tracking – Section 14 (/trainer/generated/ai) ────────────
    (0, _useScreenTime.useScreenTime)((0, _screenTimeTracker.TRAINER_SECTIONS).SECTION_14);
    const steps = [
        {
            title: null,
            description: "Your client's profile and movement limitations are already loaded. I use these to filter every exercise I suggest.",
            target: ()=>document.getElementById('builder-header-profile')
        },
        {
            title: null,
            description: 'Explore all our exercises. Use the filters to find exactly what you need for your client.',
            target: ()=>document.getElementById('exercise-library')
        },
        {
            title: null,
            description: 'See your weekly schedule and manage exercises by day.',
            target: ()=>document.getElementById('week-days-scroll-container')
        },
        {
            title: null,
            description: 'Refine sets, reps, and rest directly on each exercise.',
            target: ()=>document.getElementById('edit-btn')
        },
        {
            title: null,
            description: 'Toggle to apply changes across all weeks instantly.',
            target: ()=>document.getElementById('checkbox-label')
        },
        {
            title: null,
            description: 'Quickly remix the entire workout logic.',
            target: ()=>document.getElementById('remix-btn')
        },
        {
            title: null,
            description: 'The real power is here. Ask me to "Gradually raise workout intensity" or "Convert to superset format" - I\'m here to refine the program with you in real-time.',
            target: ()=>document.getElementById('ai-btn')
        }
    ].filter((step)=>{
        if (step.target) {
            const target = typeof step.target === 'function' ? step.target() : step.target;
            return !!target;
        }
        return true;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _core.DndContext), {
        sensors: sensors,
        collisionDetection: (0, _core.closestCenter),
        onDragStart: handleDragStart,
        onDragEnd: handleDragEnd,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "program-generated-container",
                ref: containerRef,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        ref: tourPopupRef
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commandDialogDefault.default), {
                        visible: generateErrorVisible,
                        onClose: ()=>setGenerateErrorVisible(false),
                        type: "error",
                        title: "We couldn\u2019t remix the workout",
                        description: "Something went wrong while remixing the workout program. Please try again later.",
                        confirmText: "Okay"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exerciseLibrary.ExerciseLibrary), {
                        store: store,
                        isOpen: isLibraryOpen,
                        onClose: ()=>setIsLibraryOpen(false)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programBuilder.ProgramBuilder), {
                        store: store,
                        onOpenLibrary: ()=>setIsLibraryOpen((prev)=>!prev),
                        programBuilderRef: programBuilderRef,
                        apiProgramData: apiProgramData,
                        payload: payload,
                        onRemixWorkout: handleRemixWorkout,
                        isRemixing: isRemixing,
                        onAIModifyWorkout: handleAIModifyWorkout,
                        isAIModifying: isAIModifying,
                        selectedAIOption: selectedAIOption,
                        aiModifySuccess: aiModifySuccess,
                        setAiModifySuccess: setAiModifySuccess
                    }),
                    open && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Tour), {
                        getPopupContainer: ()=>tourPopupRef.current || containerRef.current || document.body,
                        open: open,
                        onClose: handleTourClose,
                        steps: steps,
                        rootClassName: "minipt-tour",
                        indicatorsRender: (current, total)=>{
                            document.body.setAttribute('data-step', `${current}`);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "tour-indicators",
                                children: Array.from({
                                    length: total
                                }).map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: `tour-dot ${i === current ? 'active' : ''}`
                                    }, i))
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _core.DragOverlay), {
                dropAnimation: null,
                children: store.draggedExercise ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exerciseCard.ExerciseCard), {
                    exercise: store.draggedExercise,
                    index: 0,
                    letterKey: "",
                    isDragging: true,
                    isOverlay: true
                }) : null
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","../../../../index.css":"fW8RG","../../../../route.css":"h1KSg","../../../../reset.css":"3X473","./program-generated.css":"kvily","react":"bmhQu","antd":[["message","4POhF","default"],["Tour","6ZW6d","default"]],"@dnd-kit/core":"kD37e","./ExerciseCard":"eKiBi","./ExerciseLibrary":"b8xmx","./ProgramBuilder":"bEM5Z","src/components/Modals/CommandDialog/CommandDialog":"1t08c","./useProgramStore":"1VSTs","src/hooks/useScreenTime":"dhG6r","src/utils/screenTimeTracker":"dwAC9","react-router-dom":[["useLocation","f3cgC"],["useParams","9oT3O"]],"src/store/programStore":"hM1mR","src/api/mutations/useWorkoutProgram":"h8xaL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fW8RG":[function() {},{}],"h1KSg":[function() {},{}],"3X473":[function() {},{}],"kvily":[function() {},{}],"4POhF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "actWrapper", ()=>actWrapper);
parcelHelpers.export(exports, "actDestroy", ()=>actDestroy);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _render = require("@rc-component/util/es/React/render");
var _context = require("../app/context");
var _configProvider = require("../config-provider");
var _configProviderDefault = parcelHelpers.interopDefault(_configProvider);
var _purePanel = require("./PurePanel");
var _purePanelDefault = parcelHelpers.interopDefault(_purePanel);
var _useMessage = require("./useMessage");
var _useMessageDefault = parcelHelpers.interopDefault(_useMessage);
var _util = require("./util");
"use client";
let message = null;
let act = (callback)=>callback();
let taskQueue = [];
let defaultGlobalConfig = {};
function getGlobalContext() {
    const { getContainer, duration, rtl, maxCount, top } = defaultGlobalConfig;
    const mergedContainer = getContainer?.() || document.body;
    return {
        getContainer: ()=>mergedContainer,
        duration,
        rtl,
        maxCount,
        top
    };
}
const GlobalHolder = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { messageConfig, sync } = props;
    const { getPrefixCls } = (0, _react.useContext)((0, _configProvider.ConfigContext));
    const prefixCls = defaultGlobalConfig.prefixCls || getPrefixCls('message');
    const appConfig = (0, _react.useContext)((0, _context.AppConfigContext));
    const [api, holder] = (0, _useMessage.useInternalMessage)({
        ...messageConfig,
        prefixCls,
        ...appConfig.message
    });
    (0, _reactDefault.default).useImperativeHandle(ref, ()=>{
        const instance = {
            ...api
        };
        Object.keys(instance).forEach((method)=>{
            instance[method] = (...args)=>{
                sync();
                return api[method].apply(api, args);
            };
        });
        return {
            instance,
            sync
        };
    });
    return holder;
});
const GlobalHolderWrapper = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((_, ref)=>{
    const [messageConfig, setMessageConfig] = (0, _reactDefault.default).useState(getGlobalContext);
    const sync = ()=>{
        setMessageConfig(getGlobalContext);
    };
    (0, _reactDefault.default).useEffect(sync, []);
    const global = (0, _configProvider.globalConfig)();
    const rootPrefixCls = global.getRootPrefixCls();
    const rootIconPrefixCls = global.getIconPrefixCls();
    const theme = global.getTheme();
    const dom = /*#__PURE__*/ (0, _reactDefault.default).createElement(GlobalHolder, {
        ref: ref,
        sync: sync,
        messageConfig: messageConfig
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _configProviderDefault.default), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: rootIconPrefixCls,
        theme: theme
    }, global.holderRender ? global.holderRender(dom) : dom);
});
const flushMessageQueue = ()=>{
    if (!message) {
        const holderFragment = document.createDocumentFragment();
        const newMessage = {
            fragment: holderFragment
        };
        message = newMessage;
        // Delay render to avoid sync issue
        act(()=>{
            (0, _render.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement(GlobalHolderWrapper, {
                ref: (node)=>{
                    const { instance, sync } = node || {};
                    // React 18 test env will throw if call immediately in ref
                    Promise.resolve().then(()=>{
                        if (!newMessage.instance && instance) {
                            newMessage.instance = instance;
                            newMessage.sync = sync;
                            flushMessageQueue();
                        }
                    });
                }
            }), holderFragment);
        });
        return;
    }
    // Notification not ready
    if (!message.instance) return;
    // >>> Execute task
    taskQueue.forEach((task)=>{
        const { type, skipped } = task;
        // Only `skipped` when user call notice but cancel it immediately
        // and instance not ready
        if (!skipped) switch(type){
            case 'open':
                act(()=>{
                    const closeFn = message.instance.open({
                        ...defaultGlobalConfig,
                        ...task.config
                    });
                    closeFn?.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
                break;
            case 'destroy':
                act(()=>{
                    message?.instance.destroy(task.key);
                });
                break;
            // Other type open
            default:
                act(()=>{
                    var _message$instance;
                    const closeFn = (_message$instance = message.instance)[type].apply(_message$instance, (0, _toConsumableArrayDefault.default)(task.args));
                    closeFn?.then(task.resolve);
                    task.setCloseFn(closeFn);
                });
        }
    });
    // Clean up
    taskQueue = [];
};
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function setMessageGlobalConfig(config) {
    defaultGlobalConfig = {
        ...defaultGlobalConfig,
        ...config
    };
    // Trigger sync for it
    act(()=>{
        message?.sync?.();
    });
}
function open(config) {
    const result = (0, _util.wrapPromiseFn)((resolve)=>{
        let closeFn;
        const task = {
            type: 'open',
            config,
            resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        taskQueue.push(task);
        return ()=>{
            if (closeFn) act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    flushMessageQueue();
    return result;
}
function typeOpen(type, args) {
    const global = (0, _configProvider.globalConfig)();
    const result = (0, _util.wrapPromiseFn)((resolve)=>{
        let closeFn;
        const task = {
            type,
            args,
            resolve,
            setCloseFn: (fn)=>{
                closeFn = fn;
            }
        };
        taskQueue.push(task);
        return ()=>{
            if (closeFn) act(()=>{
                closeFn();
            });
            else task.skipped = true;
        };
    });
    flushMessageQueue();
    return result;
}
const destroy = (key)=>{
    taskQueue.push({
        type: 'destroy',
        key
    });
    flushMessageQueue();
};
const methods = [
    'success',
    'info',
    'warning',
    'error',
    'loading'
];
const baseStaticMethods = {
    open,
    destroy,
    config: setMessageGlobalConfig,
    useMessage: (0, _useMessageDefault.default),
    _InternalPanelDoNotUseOrYouWillBeFired: (0, _purePanelDefault.default)
};
const staticMethods = baseStaticMethods;
methods.forEach((type)=>{
    staticMethods[type] = (...args)=>typeOpen(type, args);
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const noop = ()=>{};
let _actWrapper = noop;
var wrapper;
const actWrapper = _actWrapper;
let _actDestroy = noop;
const actDestroy = _actDestroy;
exports.default = staticMethods;

},{"@babel/runtime/helpers/esm/toConsumableArray":"inIie","react":"bmhQu","@rc-component/util/es/React/render":"jackC","../app/context":"jadUJ","../config-provider":"dVeAX","./PurePanel":"eo9ge","./useMessage":"9cetQ","./util":"eiLJx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jadUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppConfigContext", ()=>AppConfigContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const AppConfigContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});
const AppContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    message: {},
    notification: {},
    modal: {}
});
exports.default = AppContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eo9ge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TypeIcon", ()=>TypeIcon);
parcelHelpers.export(exports, "PureContent", ()=>PureContent);
var _react = require("react");
var _checkCircleFilled = require("@ant-design/icons/es/icons/CheckCircleFilled");
var _checkCircleFilledDefault = parcelHelpers.interopDefault(_checkCircleFilled);
var _closeCircleFilled = require("@ant-design/icons/es/icons/CloseCircleFilled");
var _closeCircleFilledDefault = parcelHelpers.interopDefault(_closeCircleFilled);
var _exclamationCircleFilled = require("@ant-design/icons/es/icons/ExclamationCircleFilled");
var _exclamationCircleFilledDefault = parcelHelpers.interopDefault(_exclamationCircleFilled);
var _infoCircleFilled = require("@ant-design/icons/es/icons/InfoCircleFilled");
var _infoCircleFilledDefault = parcelHelpers.interopDefault(_infoCircleFilled);
var _loadingOutlined = require("@ant-design/icons/es/icons/LoadingOutlined");
var _loadingOutlinedDefault = parcelHelpers.interopDefault(_loadingOutlined);
var _notification = require("@rc-component/notification");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _reactNode = require("../_util/reactNode");
var _context = require("../config-provider/context");
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const TypeIcon = {
    info: /*#__PURE__*/ _react.createElement((0, _infoCircleFilledDefault.default), null),
    success: /*#__PURE__*/ _react.createElement((0, _checkCircleFilledDefault.default), null),
    error: /*#__PURE__*/ _react.createElement((0, _closeCircleFilledDefault.default), null),
    warning: /*#__PURE__*/ _react.createElement((0, _exclamationCircleFilledDefault.default), null),
    loading: /*#__PURE__*/ _react.createElement((0, _loadingOutlinedDefault.default), null)
};
const PureContent = (props)=>{
    const { prefixCls, type, icon, children, classNames: pureContentClassNames, styles } = props;
    const iconElement = icon || type && TypeIcon[type];
    const iconNode = (0, _reactNode.cloneElement)(iconElement, (currentProps)=>{
        const mergedStyle = {
            ...currentProps?.style,
            ...styles?.icon
        };
        return {
            className: (0, _clsx.clsx)(currentProps.className, pureContentClassNames?.icon),
            style: mergedStyle
        };
    });
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-custom-content`, `${prefixCls}-${type}`)
    }, iconNode, /*#__PURE__*/ _react.createElement("span", {
        className: pureContentClassNames?.content,
        style: styles?.content
    }, children));
};
/** @private Internal Component. Do not use in your production. */ const PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, className, style, type, icon, content, classNames: messageClassNames, styles, ...restProps } = props;
    const { getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('message');
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        messageClassNames
    ], [
        contextStyles,
        styles
    ], {
        props
    });
    return /*#__PURE__*/ _react.createElement((0, _notification.Notice), {
        ...restProps,
        prefixCls: prefixCls,
        className: (0, _clsx.clsx)(contextClassName, mergedClassNames.root, className, hashId, `${prefixCls}-notice-pure-panel`, cssVarCls, rootCls),
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        eventKey: "pure",
        duration: null,
        content: /*#__PURE__*/ _react.createElement(PureContent, {
            prefixCls: prefixCls,
            type: type,
            icon: icon,
            classNames: mergedClassNames,
            styles: mergedStyles
        }, content)
    });
};
exports.default = PurePanel;

},{"react":"bmhQu","@ant-design/icons/es/icons/CheckCircleFilled":"gk31P","@ant-design/icons/es/icons/CloseCircleFilled":"d3fPr","@ant-design/icons/es/icons/ExclamationCircleFilled":"24nhX","@ant-design/icons/es/icons/InfoCircleFilled":"aiTER","@ant-design/icons/es/icons/LoadingOutlined":"8Mvdh","@rc-component/notification":"aCyv5","clsx":"431Ou","../_util/hooks":"kdnMA","../_util/reactNode":"78pFx","../config-provider/context":"75zwC","../config-provider/hooks/useCSSVarCls":"gcu2s","./style":"8hVdF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aCyv5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNotification", ()=>(0, _useNotificationDefault.default));
parcelHelpers.export(exports, "Notice", ()=>(0, _noticeDefault.default));
parcelHelpers.export(exports, "NotificationProvider", ()=>(0, _notificationProviderDefault.default));
var _useNotification = require("./hooks/useNotification");
var _useNotificationDefault = parcelHelpers.interopDefault(_useNotification);
var _notice = require("./Notice");
var _noticeDefault = parcelHelpers.interopDefault(_notice);
var _notificationProvider = require("./NotificationProvider");
var _notificationProviderDefault = parcelHelpers.interopDefault(_notificationProvider);

},{"./hooks/useNotification":"mp8Wi","./Notice":"j3MHu","./NotificationProvider":"lngHl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"mp8Wi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useNotification);
var _react = require("react");
var _notifications = require("../Notifications");
var _notificationsDefault = parcelHelpers.interopDefault(_notifications);
var _util = require("@rc-component/util");
const defaultGetContainer = ()=>document.body;
let uniqueKey = 0;
function mergeConfig(...objList) {
    const clone = {};
    objList.forEach((obj)=>{
        if (obj) Object.keys(obj).forEach((key)=>{
            const val = obj[key];
            if (val !== undefined) clone[key] = val;
        });
    });
    return clone;
}
function useNotification(rootConfig = {}) {
    const { getContainer = defaultGetContainer, motion, prefixCls, maxCount, className, style, onAllRemoved, stack, renderNotifications, ...shareConfig } = rootConfig;
    const [container, setContainer] = _react.useState();
    const notificationsRef = _react.useRef();
    const contextHolder = /*#__PURE__*/ _react.createElement((0, _notificationsDefault.default), {
        container: container,
        ref: notificationsRef,
        prefixCls: prefixCls,
        motion: motion,
        maxCount: maxCount,
        className: className,
        style: style,
        onAllRemoved: onAllRemoved,
        stack: stack,
        renderNotifications: renderNotifications
    });
    const [taskQueue, setTaskQueue] = _react.useState([]);
    const open = (0, _util.useEvent)((config)=>{
        const mergedConfig = mergeConfig(shareConfig, config);
        if (mergedConfig.key === null || mergedConfig.key === undefined) {
            mergedConfig.key = `rc-notification-${uniqueKey}`;
            uniqueKey += 1;
        }
        setTaskQueue((queue)=>[
                ...queue,
                {
                    type: 'open',
                    config: mergedConfig
                }
            ]);
    });
    // ========================= Refs =========================
    const api = _react.useMemo(()=>({
            open: open,
            close: (key)=>{
                setTaskQueue((queue)=>[
                        ...queue,
                        {
                            type: 'close',
                            key
                        }
                    ]);
            },
            destroy: ()=>{
                setTaskQueue((queue)=>[
                        ...queue,
                        {
                            type: 'destroy'
                        }
                    ]);
            }
        }), []);
    // ======================= Container ======================
    // React 18 should all in effect that we will check container in each render
    // Which means getContainer should be stable.
    _react.useEffect(()=>{
        setContainer(getContainer());
    });
    // ======================== Effect ========================
    _react.useEffect(()=>{
        // Flush task when node ready
        if (notificationsRef.current && taskQueue.length) {
            taskQueue.forEach((task)=>{
                switch(task.type){
                    case 'open':
                        notificationsRef.current.open(task.config);
                        break;
                    case 'close':
                        notificationsRef.current.close(task.key);
                        break;
                    case 'destroy':
                        notificationsRef.current.destroy();
                        break;
                }
            });
            // https://github.com/ant-design/ant-design/issues/52590
            // React `startTransition` will run once `useEffect` but many times `setState`,
            // So `setTaskQueue` with filtered array will cause infinite loop.
            // We cache the first match queue instead.
            let oriTaskQueue;
            let tgtTaskQueue;
            // React 17 will mix order of effect & setState in async
            // - open: setState[0]
            // - effect[0]
            // - open: setState[1]
            // - effect setState([]) * here will clean up [0, 1] in React 17
            setTaskQueue((oriQueue)=>{
                if (oriTaskQueue !== oriQueue || !tgtTaskQueue) {
                    oriTaskQueue = oriQueue;
                    tgtTaskQueue = oriQueue.filter((task)=>!taskQueue.includes(task));
                }
                return tgtTaskQueue;
            });
        }
    }, [
        taskQueue
    ]);
    // ======================== Return ========================
    return [
        api,
        contextHolder
    ];
}

},{"react":"bmhQu","../Notifications":"auCjM","@rc-component/util":"6ZBDN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"auCjM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDom = require("react-dom");
var _noticeList = require("./NoticeList");
var _noticeListDefault = parcelHelpers.interopDefault(_noticeList);
// ant-notification ant-notification-topRight
const Notifications = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls = 'rc-notification', container, motion, maxCount, className, style, onAllRemoved, stack, renderNotifications } = props;
    const [configList, setConfigList] = _react.useState([]);
    // ======================== Close =========================
    const onNoticeClose = (key)=>{
        // Trigger close event
        const config = configList.find((item)=>item.key === key);
        const closable = config?.closable;
        const closableObj = closable && typeof closable === 'object' ? closable : {};
        const { onClose: closableOnClose } = closableObj;
        closableOnClose?.();
        config?.onClose?.();
        setConfigList((list)=>list.filter((item)=>item.key !== key));
    };
    // ========================= Refs =========================
    _react.useImperativeHandle(ref, ()=>({
            open: (config)=>{
                setConfigList((list)=>{
                    let clone = [
                        ...list
                    ];
                    // Replace if exist
                    const index = clone.findIndex((item)=>item.key === config.key);
                    const innerConfig = {
                        ...config
                    };
                    if (index >= 0) {
                        innerConfig.times = (list[index]?.times || 0) + 1;
                        clone[index] = innerConfig;
                    } else {
                        innerConfig.times = 0;
                        clone.push(innerConfig);
                    }
                    if (maxCount > 0 && clone.length > maxCount) clone = clone.slice(-maxCount);
                    return clone;
                });
            },
            close: (key)=>{
                onNoticeClose(key);
            },
            destroy: ()=>{
                setConfigList([]);
            }
        }));
    // ====================== Placements ======================
    const [placements, setPlacements] = _react.useState({});
    _react.useEffect(()=>{
        const nextPlacements = {};
        configList.forEach((config)=>{
            const { placement = 'topRight' } = config;
            if (placement) {
                nextPlacements[placement] = nextPlacements[placement] || [];
                nextPlacements[placement].push(config);
            }
        });
        // Fill exist placements to avoid empty list causing remove without motion
        Object.keys(placements).forEach((placement)=>{
            nextPlacements[placement] = nextPlacements[placement] || [];
        });
        setPlacements(nextPlacements);
    }, [
        configList
    ]);
    // Clean up container if all notices fade out
    const onAllNoticeRemoved = (placement)=>{
        setPlacements((originPlacements)=>{
            const clone = {
                ...originPlacements
            };
            const list = clone[placement] || [];
            if (!list.length) delete clone[placement];
            return clone;
        });
    };
    // Effect tell that placements is empty now
    const emptyRef = _react.useRef(false);
    _react.useEffect(()=>{
        if (Object.keys(placements).length > 0) emptyRef.current = true;
        else if (emptyRef.current) {
            // Trigger only when from exist to empty
            onAllRemoved?.();
            emptyRef.current = false;
        }
    }, [
        placements
    ]);
    // ======================== Render ========================
    if (!container) return null;
    const placementList = Object.keys(placements);
    return /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ _react.createElement(_react.Fragment, null, placementList.map((placement)=>{
        const placementConfigList = placements[placement];
        const list = /*#__PURE__*/ _react.createElement((0, _noticeListDefault.default), {
            key: placement,
            configList: placementConfigList,
            placement: placement,
            prefixCls: prefixCls,
            className: className?.(placement),
            style: style?.(placement),
            motion: motion,
            onNoticeClose: onNoticeClose,
            onAllNoticeRemoved: onAllNoticeRemoved,
            stack: stack
        });
        return renderNotifications ? renderNotifications(list, {
            prefixCls,
            key: placement
        }) : list;
    })), container);
});
exports.default = Notifications;

},{"react":"bmhQu","react-dom":"82aNB","./NoticeList":"aIGui","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aIGui":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _motion = require("@rc-component/motion");
var _notice = require("./Notice");
var _noticeDefault = parcelHelpers.interopDefault(_notice);
var _notificationProvider = require("./NotificationProvider");
var _useStack = require("./hooks/useStack");
var _useStackDefault = parcelHelpers.interopDefault(_useStack);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const NoticeList = (props)=>{
    const { configList, placement, prefixCls, className, style, motion, onAllNoticeRemoved, onNoticeClose, stack: stackConfig } = props;
    const { classNames: ctxCls } = (0, _react.useContext)((0, _notificationProvider.NotificationContext));
    const dictRef = (0, _react.useRef)({});
    const [latestNotice, setLatestNotice] = (0, _react.useState)(null);
    const [hoverKeys, setHoverKeys] = (0, _react.useState)([]);
    const keys = configList.map((config)=>({
            config,
            key: String(config.key)
        }));
    const [stack, { offset, threshold, gap }] = (0, _useStackDefault.default)(stackConfig);
    const expanded = stack && (hoverKeys.length > 0 || keys.length <= threshold);
    const placementMotion = typeof motion === 'function' ? motion(placement) : motion;
    // Clean hover key
    (0, _react.useEffect)(()=>{
        if (stack && hoverKeys.length > 1) setHoverKeys((prev)=>prev.filter((key)=>keys.some(({ key: dataKey })=>key === dataKey)));
    }, [
        hoverKeys,
        keys,
        stack
    ]);
    // Force update latest notice
    (0, _react.useEffect)(()=>{
        if (stack && dictRef.current[keys[keys.length - 1]?.key]) setLatestNotice(dictRef.current[keys[keys.length - 1]?.key]);
    }, [
        keys,
        stack
    ]);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _motion.CSSMotionList), _extends({
        key: placement,
        className: (0, _clsx.clsx)(prefixCls, `${prefixCls}-${placement}`, ctxCls?.list, className, {
            [`${prefixCls}-stack`]: !!stack,
            [`${prefixCls}-stack-expanded`]: expanded
        }),
        style: style,
        keys: keys,
        motionAppear: true
    }, placementMotion, {
        onAllRemoved: ()=>{
            onAllNoticeRemoved(placement);
        }
    }), ({ config, className: motionClassName, style: motionStyle, index: motionIndex }, nodeRef)=>{
        const { key, times } = config;
        const strKey = String(key);
        const { className: configClassName, style: configStyle, classNames: configClassNames, styles: configStyles, ...restConfig } = config;
        const dataIndex = keys.findIndex((item)=>item.key === strKey);
        // If dataIndex is -1, that means this notice has been removed in data, but still in dom
        // Should minus (motionIndex - 1) to get the correct index because keys.length is not the same as dom length
        const stackStyle = {};
        if (stack) {
            const index = keys.length - 1 - (dataIndex > -1 ? dataIndex : motionIndex - 1);
            const transformX = placement === 'top' || placement === 'bottom' ? '-50%' : '0';
            if (index > 0) {
                stackStyle.height = expanded ? dictRef.current[strKey]?.offsetHeight : latestNotice?.offsetHeight;
                // Transform
                let verticalOffset = 0;
                for(let i = 0; i < index; i++)verticalOffset += dictRef.current[keys[keys.length - 1 - i].key]?.offsetHeight + gap;
                const transformY = (expanded ? verticalOffset : index * offset) * (placement.startsWith('top') ? 1 : -1);
                const scaleX = !expanded && latestNotice?.offsetWidth && dictRef.current[strKey]?.offsetWidth ? (latestNotice?.offsetWidth - offset * 2 * (index < 3 ? index : 3)) / dictRef.current[strKey]?.offsetWidth : 1;
                stackStyle.transform = `translate3d(${transformX}, ${transformY}px, 0) scaleX(${scaleX})`;
            } else stackStyle.transform = `translate3d(${transformX}, 0, 0)`;
        }
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
            ref: nodeRef,
            className: (0, _clsx.clsx)(`${prefixCls}-notice-wrapper`, motionClassName, configClassNames?.wrapper),
            style: {
                ...motionStyle,
                ...stackStyle,
                ...configStyles?.wrapper
            },
            onMouseEnter: ()=>setHoverKeys((prev)=>prev.includes(strKey) ? prev : [
                        ...prev,
                        strKey
                    ]),
            onMouseLeave: ()=>setHoverKeys((prev)=>prev.filter((k)=>k !== strKey))
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _noticeDefault.default), _extends({}, restConfig, {
            ref: (node)=>{
                if (dataIndex > -1) dictRef.current[strKey] = node;
                else delete dictRef.current[strKey];
            },
            prefixCls: prefixCls,
            classNames: configClassNames,
            styles: configStyles,
            className: (0, _clsx.clsx)(configClassName, ctxCls?.notice),
            style: configStyle,
            times: times,
            key: key,
            eventKey: key,
            onNoticeClose: onNoticeClose,
            hovering: stack && hoverKeys.length > 0
        })));
    });
};
exports.default = NoticeList;

},{"react":"bmhQu","clsx":"431Ou","@rc-component/motion":"gBwXg","./Notice":"j3MHu","./NotificationProvider":"lngHl","./hooks/useStack":"8kNF3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j3MHu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _keyCode = require("@rc-component/util/es/KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
var _react = require("react");
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Notify = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls, style, className, duration = 4.5, showProgress, pauseOnHover = true, eventKey, content, closable, props: divProps, onClick, onNoticeClose, times, hovering: forcedHovering } = props;
    const [hovering, setHovering] = _react.useState(false);
    const [percent, setPercent] = _react.useState(0);
    const [spentTime, setSpentTime] = _react.useState(0);
    const mergedHovering = forcedHovering || hovering;
    const mergedDuration = typeof duration === 'number' ? duration : 0;
    const mergedShowProgress = mergedDuration > 0 && showProgress;
    // ======================== Close =========================
    const onInternalClose = ()=>{
        onNoticeClose(eventKey);
    };
    const onCloseKeyDown = (e)=>{
        if (e.key === 'Enter' || e.code === 'Enter' || e.keyCode === (0, _keyCodeDefault.default).ENTER) onInternalClose();
    };
    // ======================== Effect ========================
    _react.useEffect(()=>{
        if (!mergedHovering && mergedDuration > 0) {
            const start = Date.now() - spentTime;
            const timeout = setTimeout(()=>{
                onInternalClose();
            }, mergedDuration * 1000 - spentTime);
            return ()=>{
                if (pauseOnHover) clearTimeout(timeout);
                setSpentTime(Date.now() - start);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mergedDuration,
        mergedHovering,
        times
    ]);
    _react.useEffect(()=>{
        if (!mergedHovering && mergedShowProgress && (pauseOnHover || spentTime === 0)) {
            const start = performance.now();
            let animationFrame;
            const calculate = ()=>{
                cancelAnimationFrame(animationFrame);
                animationFrame = requestAnimationFrame((timestamp)=>{
                    const runtime = timestamp + spentTime - start;
                    const progress = Math.min(runtime / (mergedDuration * 1000), 1);
                    setPercent(progress * 100);
                    if (progress < 1) calculate();
                });
            };
            calculate();
            return ()=>{
                if (pauseOnHover) cancelAnimationFrame(animationFrame);
            };
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        mergedDuration,
        spentTime,
        mergedHovering,
        mergedShowProgress,
        times
    ]);
    // ======================== Closable ========================
    const closableObj = _react.useMemo(()=>{
        if (typeof closable === 'object' && closable !== null) return closable;
        return {};
    }, [
        closable
    ]);
    const ariaProps = (0, _pickAttrsDefault.default)(closableObj, true);
    // ======================== Progress ========================
    const validPercent = 100 - (!percent || percent < 0 ? 0 : percent > 100 ? 100 : percent);
    // ======================== Render ========================
    const noticePrefixCls = `${prefixCls}-notice`;
    return /*#__PURE__*/ _react.createElement("div", _extends({}, divProps, {
        ref: ref,
        className: (0, _clsx.clsx)(noticePrefixCls, className, {
            [`${noticePrefixCls}-closable`]: closable
        }),
        style: style,
        onMouseEnter: (e)=>{
            setHovering(true);
            divProps?.onMouseEnter?.(e);
        },
        onMouseLeave: (e)=>{
            setHovering(false);
            divProps?.onMouseLeave?.(e);
        },
        onClick: onClick
    }), /*#__PURE__*/ _react.createElement("div", {
        className: `${noticePrefixCls}-content`
    }, content), closable && /*#__PURE__*/ _react.createElement("button", _extends({
        className: `${noticePrefixCls}-close`,
        onKeyDown: onCloseKeyDown,
        "aria-label": "Close"
    }, ariaProps, {
        onClick: (e)=>{
            e.preventDefault();
            e.stopPropagation();
            onInternalClose();
        }
    }), closableObj.closeIcon ?? 'x'), mergedShowProgress && /*#__PURE__*/ _react.createElement("progress", {
        className: `${noticePrefixCls}-progress`,
        max: "100",
        value: validPercent
    }, validPercent + '%'));
});
exports.default = Notify;

},{"clsx":"431Ou","@rc-component/util/es/KeyCode":"6yRlk","react":"bmhQu","@rc-component/util/es/pickAttrs":"jGMGD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lngHl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationContext", ()=>NotificationContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const NotificationContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});
const NotificationProvider = ({ children, classNames })=>{
    return /*#__PURE__*/ (0, _reactDefault.default).createElement(NotificationContext.Provider, {
        value: {
            classNames
        }
    }, children);
};
exports.default = NotificationProvider;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8kNF3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const DEFAULT_OFFSET = 8;
const DEFAULT_THRESHOLD = 3;
const DEFAULT_GAP = 16;
const useStack = (config)=>{
    const result = {
        offset: DEFAULT_OFFSET,
        threshold: DEFAULT_THRESHOLD,
        gap: DEFAULT_GAP
    };
    if (config && typeof config === 'object') {
        result.offset = config.offset ?? DEFAULT_OFFSET;
        result.threshold = config.threshold ?? DEFAULT_THRESHOLD;
        result.gap = config.gap ?? DEFAULT_GAP;
    }
    return [
        !!config,
        result
    ];
};
exports.default = useStack;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8hVdF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _cssinjs = require("@ant-design/cssinjs");
var _hooks = require("../../_util/hooks");
var _style = require("../../style");
var _internal = require("../../theme/internal");
const genMessageStyle = (token)=>{
    const { componentCls, iconCls, boxShadow, colorText, colorSuccess, colorError, colorWarning, colorInfo, fontSizeLG, motionEaseInOutCirc, motionDurationSlow, marginXS, paddingXS, borderRadiusLG, zIndexPopup, // Custom token
    contentPadding, contentBg } = token;
    const noticeCls = `${componentCls}-notice`;
    const messageMoveIn = new (0, _cssinjs.Keyframes)('MessageMoveIn', {
        '0%': {
            padding: 0,
            transform: 'translateY(-100%)',
            opacity: 0
        },
        '100%': {
            padding: paddingXS,
            transform: 'translateY(0)',
            opacity: 1
        }
    });
    const messageMoveOut = new (0, _cssinjs.Keyframes)('MessageMoveOut', {
        '0%': {
            maxHeight: token.height,
            padding: paddingXS,
            opacity: 1
        },
        '100%': {
            maxHeight: 0,
            padding: 0,
            opacity: 0
        }
    });
    const noticeStyle = {
        padding: paddingXS,
        textAlign: 'center',
        [`${componentCls}-custom-content`]: {
            display: 'flex',
            alignItems: 'center'
        },
        [`${componentCls}-custom-content > ${iconCls}`]: {
            marginInlineEnd: marginXS,
            // affected by ltr or rtl
            fontSize: fontSizeLG
        },
        [`${noticeCls}-content`]: {
            display: 'inline-block',
            padding: contentPadding,
            background: contentBg,
            borderRadius: borderRadiusLG,
            boxShadow,
            pointerEvents: 'all'
        },
        [`${componentCls}-success > ${iconCls}`]: {
            color: colorSuccess
        },
        [`${componentCls}-error > ${iconCls}`]: {
            color: colorError
        },
        [`${componentCls}-warning > ${iconCls}`]: {
            color: colorWarning
        },
        [`${componentCls}-info > ${iconCls},
      ${componentCls}-loading > ${iconCls}`]: {
            color: colorInfo
        }
    };
    return [
        // ============================ Holder ============================
        {
            [componentCls]: {
                ...(0, _style.resetComponent)(token),
                color: colorText,
                position: 'fixed',
                top: marginXS,
                width: '100%',
                pointerEvents: 'none',
                zIndex: zIndexPopup,
                [`${componentCls}-move-up`]: {
                    animationFillMode: 'forwards'
                },
                [`
        ${componentCls}-move-up-appear,
        ${componentCls}-move-up-enter
      `]: {
                    animationName: messageMoveIn,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`
        ${componentCls}-move-up-appear${componentCls}-move-up-appear-active,
        ${componentCls}-move-up-enter${componentCls}-move-up-enter-active
      `]: {
                    animationPlayState: 'running'
                },
                [`${componentCls}-move-up-leave`]: {
                    animationName: messageMoveOut,
                    animationDuration: motionDurationSlow,
                    animationPlayState: 'paused',
                    animationTimingFunction: motionEaseInOutCirc
                },
                [`${componentCls}-move-up-leave${componentCls}-move-up-leave-active`]: {
                    animationPlayState: 'running'
                },
                '&-rtl': {
                    direction: 'rtl',
                    span: {
                        direction: 'rtl'
                    }
                }
            }
        },
        // ============================ Notice ============================
        {
            [componentCls]: {
                [`${noticeCls}-wrapper`]: {
                    ...noticeStyle
                }
            }
        },
        // ============================= Pure =============================
        {
            [`${componentCls}-notice-pure-panel`]: {
                ...noticeStyle,
                padding: 0,
                textAlign: 'start'
            }
        }
    ];
};
const prepareComponentToken = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, _hooks.CONTAINER_MAX_OFFSET) + 10,
        contentBg: token.colorBgElevated,
        contentPadding: `${(token.controlHeightLG - token.fontSize * token.lineHeight) / 2}px ${token.paddingSM}px`
    });
// ============================== Export ==============================
exports.default = (0, _internal.genStyleHooks)('Message', (token)=>{
    // Gen-style functions here
    const combinedToken = (0, _internal.mergeToken)(token, {
        height: 150
    });
    return genMessageStyle(combinedToken);
}, prepareComponentToken);

},{"@ant-design/cssinjs":"2VNL8","../../_util/hooks":"6noQ6","../../style":"4Ezp0","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9cetQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInternalMessage", ()=>useInternalMessage);
parcelHelpers.export(exports, "default", ()=>useMessage);
var _react = require("react");
var _notification = require("@rc-component/notification");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _isNonNullable = require("../_util/isNonNullable");
var _isNonNullableDefault = parcelHelpers.interopDefault(_isNonNullable);
var _warning = require("../_util/warning");
var _configProvider = require("../config-provider");
var _context = require("../config-provider/context");
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _purePanel = require("./PurePanel");
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _util = require("./util");
"use client";
const DEFAULT_OFFSET = 8;
const DEFAULT_DURATION = 3;
const Wrapper = ({ children, prefixCls })=>{
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
    return /*#__PURE__*/ _react.createElement((0, _notification.NotificationProvider), {
        classNames: {
            list: (0, _clsx.clsx)(hashId, cssVarCls, rootCls)
        }
    }, children);
};
const renderNotifications = (node, { prefixCls, key })=>/*#__PURE__*/ _react.createElement(Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
const Holder = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { top, prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount, duration = DEFAULT_DURATION, rtl, transitionName, onAllRemoved, pauseOnHover = true } = props;
    const { getPrefixCls, direction, getPopupContainer } = (0, _context.useComponentConfig)('message');
    const { message } = _react.useContext((0, _configProvider.ConfigContext));
    const prefixCls = staticPrefixCls || getPrefixCls('message');
    // =============================== Style ===============================
    const getStyle = ()=>({
            left: '50%',
            transform: 'translateX(-50%)',
            top: top ?? DEFAULT_OFFSET
        });
    const getClassName = ()=>(0, _clsx.clsx)({
            [`${prefixCls}-rtl`]: rtl ?? direction === 'rtl'
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, _util.getMotion)(prefixCls, transitionName);
    // Use useMergeSemantic to merge classNames and styles
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        props?.classNames,
        message?.classNames
    ], [
        props?.styles,
        message?.styles
    ], {
        props
    });
    // ============================== Origin ===============================
    const [api, holder] = (0, _notification.useNotification)({
        prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        // closable=false requires-no closeIcon
        closable: false,
        duration,
        getContainer: ()=>staticGetContainer?.() || getPopupContainer?.() || document.body,
        maxCount,
        onAllRemoved,
        renderNotifications,
        pauseOnHover
    });
    // ================================ Ref ================================
    _react.useImperativeHandle(ref, ()=>({
            ...api,
            prefixCls,
            message,
            classNames: mergedClassNames,
            styles: mergedStyles
        }));
    return holder;
});
// ==============================================================================
// ==                                   Hook                                   ==
// ==============================================================================
let keyIndex = 0;
function useInternalMessage(messageConfig) {
    const holderRef = _react.useRef(null);
    const warning = (0, _warning.devUseWarning)('Message');
    // ================================ API ================================
    const wrapAPI = _react.useMemo(()=>{
        // Wrap with notification content
        // >>> close
        const close = (key)=>{
            holderRef.current?.close(key);
        };
        // >>> Open
        const open = (config)=>{
            if (!holderRef.current) {
                const fakeResult = ()=>{};
                // eslint-disable-next-line react-hooks/immutability
                fakeResult.then = ()=>{};
                return fakeResult;
            }
            const { open: originOpen, prefixCls, message, classNames: originClassNames, styles: originStyles } = holderRef.current;
            const contextClassName = message?.className || {};
            const contextStyle = message?.style || {};
            const rawContextClassNames = message?.classNames || {};
            const rawContextStyles = message?.styles || {};
            const noticePrefixCls = `${prefixCls}-notice`;
            const { content, icon, type, key, className, style, onClose, classNames: configClassNames = {}, styles = {}, ...restConfig } = config;
            let mergedKey = key;
            if (!(0, _isNonNullableDefault.default)(mergedKey)) {
                keyIndex += 1;
                mergedKey = `antd-message-${keyIndex}`;
            }
            const contextConfig = {
                ...messageConfig,
                ...config
            };
            const contextClassNames = (0, _hooks.resolveStyleOrClass)(rawContextClassNames, {
                props: contextConfig
            });
            const semanticClassNames = (0, _hooks.resolveStyleOrClass)(configClassNames, {
                props: contextConfig
            });
            const contextStyles = (0, _hooks.resolveStyleOrClass)(rawContextStyles, {
                props: contextConfig
            });
            const semanticStyles = (0, _hooks.resolveStyleOrClass)(styles, {
                props: contextConfig
            });
            const mergedClassNames = (0, _hooks.mergeClassNames)(undefined, contextClassNames, semanticClassNames, originClassNames);
            const mergedStyles = (0, _hooks.mergeStyles)(contextStyles, semanticStyles, originStyles);
            return (0, _util.wrapPromiseFn)((resolve)=>{
                originOpen({
                    ...restConfig,
                    key: mergedKey,
                    content: /*#__PURE__*/ _react.createElement((0, _purePanel.PureContent), {
                        prefixCls: prefixCls,
                        type: type,
                        icon: icon,
                        classNames: mergedClassNames,
                        styles: mergedStyles
                    }, content),
                    placement: 'top',
                    className: (0, _clsx.clsx)({
                        [`${noticePrefixCls}-${type}`]: type
                    }, className, contextClassName, mergedClassNames.root),
                    style: {
                        ...mergedStyles.root,
                        ...contextStyle,
                        ...style
                    },
                    onClose: ()=>{
                        onClose?.();
                        resolve();
                    }
                });
                // Return close function
                return ()=>{
                    close(mergedKey);
                };
            });
        };
        // >>> destroy
        const destroy = (key)=>{
            if (key !== undefined) close(key);
            else holderRef.current?.destroy();
        };
        const clone = {
            open,
            destroy
        };
        const keys = [
            'info',
            'success',
            'warning',
            'error',
            'loading'
        ];
        keys.forEach((type)=>{
            const typeOpen = (jointContent, duration, onClose)=>{
                let config;
                if (jointContent && typeof jointContent === 'object' && 'content' in jointContent) config = jointContent;
                else config = {
                    content: jointContent
                };
                // Params
                let mergedDuration;
                let mergedOnClose;
                if (typeof duration === 'function') mergedOnClose = duration;
                else {
                    mergedDuration = duration;
                    mergedOnClose = onClose;
                }
                const mergedConfig = {
                    onClose: mergedOnClose,
                    duration: mergedDuration,
                    ...config,
                    type
                };
                return open(mergedConfig);
            };
            clone[type] = typeOpen;
        });
        return clone;
    }, []);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ _react.createElement(Holder, {
            key: "message-holder",
            ...messageConfig,
            ref: holderRef
        })
    ];
}
function useMessage(messageConfig) {
    return useInternalMessage(messageConfig);
}

},{"react":"bmhQu","@rc-component/notification":"aCyv5","clsx":"431Ou","../_util/hooks":"kdnMA","../_util/isNonNullable":"avlqw","../_util/warning":"95o3w","../config-provider":"dVeAX","../config-provider/context":"75zwC","../config-provider/hooks/useCSSVarCls":"gcu2s","./PurePanel":"eo9ge","./style":"8hVdF","./util":"eiLJx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eiLJx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMotion", ()=>getMotion);
/** Wrap message open with promise like function */ parcelHelpers.export(exports, "wrapPromiseFn", ()=>wrapPromiseFn);
function getMotion(prefixCls, transitionName) {
    return {
        motionName: transitionName ?? `${prefixCls}-move-up`
    };
}
function wrapPromiseFn(openFn) {
    let closeFn;
    const closePromise = new Promise((resolve)=>{
        closeFn = openFn(()=>{
            resolve(true);
        });
    });
    const result = ()=>{
        closeFn?.();
    };
    result.then = (filled, rejected)=>closePromise.then(filled, rejected);
    result.promise = closePromise;
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ZW6d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _tour = require("@rc-component/tour");
var _tourDefault = parcelHelpers.interopDefault(_tour);
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _placements = require("../_util/placements");
var _placementsDefault = parcelHelpers.interopDefault(_placements);
var _zindexContext = require("../_util/zindexContext");
var _zindexContextDefault = parcelHelpers.interopDefault(_zindexContext);
var _context = require("../config-provider/context");
var _internal = require("../theme/internal");
var _panelRender = require("./panelRender");
var _panelRenderDefault = parcelHelpers.interopDefault(_panelRender);
var _purePanel = require("./PurePanel");
var _purePanelDefault = parcelHelpers.interopDefault(_purePanel);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const Tour = (props)=>{
    const { prefixCls: customizePrefixCls, type, rootClassName, indicatorsRender, actionsRender, steps, closeIcon, classNames, styles, className, style, ...restProps } = props;
    const { getPrefixCls, direction, closeIcon: contextCloseIcon, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('tour');
    const prefixCls = getPrefixCls('tour', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    const [, token] = (0, _internal.useToken)();
    const mergedSteps = (0, _reactDefault.default).useMemo(()=>steps?.map((step)=>({
                ...step,
                className: (0, _clsx.clsx)(step.className, {
                    [`${prefixCls}-primary`]: (step.type ?? type) === 'primary'
                })
            })), [
        prefixCls,
        steps,
        type
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        steps: mergedSteps
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const builtinPlacements = (config)=>(0, _placementsDefault.default)({
            arrowPointAtCenter: config?.arrowPointAtCenter ?? true,
            autoAdjustOverflow: true,
            offset: token.marginXXS,
            arrowWidth: token.sizePopupArrow,
            borderRadius: token.borderRadius
        });
    const mergedRootClassName = (0, _clsx.clsx)({
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, cssVarCls, rootClassName, contextClassName, mergedClassNames.root, className);
    const semanticStyles = {
        ...mergedStyles,
        mask: {
            ...mergedStyles.root,
            ...mergedStyles.mask,
            ...contextStyle,
            ...style
        }
    };
    const mergedRenderPanel = (stepProps, stepCurrent)=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _panelRenderDefault.default), {
            styles: semanticStyles,
            classNames: mergedClassNames,
            type: type,
            stepProps: stepProps,
            current: stepCurrent,
            indicatorsRender: indicatorsRender,
            actionsRender: actionsRender
        });
    // ============================ zIndex ============================
    const [zIndex, contextZIndex] = (0, _hooks.useZIndex)('Tour', restProps.zIndex);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _zindexContextDefault.default).Provider, {
        value: contextZIndex
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _tourDefault.default), {
        ...restProps,
        styles: semanticStyles,
        classNames: mergedClassNames,
        closeIcon: closeIcon ?? contextCloseIcon,
        zIndex: zIndex,
        rootClassName: mergedRootClassName,
        prefixCls: prefixCls,
        animated: true,
        renderPanel: mergedRenderPanel,
        builtinPlacements: builtinPlacements,
        steps: mergedSteps
    }));
};
Tour._InternalPanelDoNotUseOrYouWillBeFired = (0, _purePanelDefault.default);
exports.default = Tour;

},{"react":"bmhQu","@rc-component/tour":"6NLbc","clsx":"431Ou","../_util/hooks":[["useMergeSemantic","kdnMA"],["useZIndex","6noQ6"]],"../_util/placements":"gti5Y","../_util/zindexContext":"e9ihh","../config-provider/context":"75zwC","../theme/internal":[["useToken","6x222","default"]],"./panelRender":"2SoNj","./PurePanel":"4dOk5","./style":"asGoC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6NLbc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _tour = require("./Tour");
var _tourDefault = parcelHelpers.interopDefault(_tour);
exports.default = (0, _tourDefault.default);

},{"./Tour":"02eCZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"02eCZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _trigger = require("@rc-component/trigger");
var _triggerDefault = parcelHelpers.interopDefault(_trigger);
var _clsx = require("clsx");
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _useControlledState = require("@rc-component/util/es/hooks/useControlledState");
var _useControlledStateDefault = parcelHelpers.interopDefault(_useControlledState);
var _useClosable = require("./hooks/useClosable");
var _useTarget = require("./hooks/useTarget");
var _useTargetDefault = parcelHelpers.interopDefault(_useTarget);
var _mask = require("./Mask");
var _maskDefault = parcelHelpers.interopDefault(_mask);
var _placements = require("./placements");
var _tourStep = require("./TourStep");
var _tourStepDefault = parcelHelpers.interopDefault(_tourStep);
var _util = require("./util");
var _placeholder = require("./Placeholder");
var _placeholderDefault = parcelHelpers.interopDefault(_placeholder);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const CENTER_PLACEHOLDER = {
    left: '50%',
    top: '50%',
    width: 1,
    height: 1
};
const defaultScrollIntoViewOptions = {
    block: 'center',
    inline: 'center'
};
const Tour = (props)=>{
    const { prefixCls = 'rc-tour', steps = [], defaultCurrent, current, onChange, onClose, onFinish, open, defaultOpen, mask = true, arrow = true, rootClassName, placement, renderPanel, gap, animated, scrollIntoViewOptions = defaultScrollIntoViewOptions, zIndex = 1001, closeIcon, closable, builtinPlacements, disabledInteraction, styles, classNames: tourClassNames, className, style, getPopupContainer, ...restProps } = props;
    const triggerRef = _react.useRef();
    const [mergedCurrent, setMergedCurrent] = (0, _useControlledStateDefault.default)(defaultCurrent || 0, current);
    const [internalOpen, setMergedOpen] = (0, _useControlledStateDefault.default)(defaultOpen, open);
    const mergedOpen = mergedCurrent < 0 || mergedCurrent >= steps.length ? false : internalOpen ?? true;
    // Record if already rended in the DOM to avoid `findDOMNode` issue
    const [hasOpened, setHasOpened] = _react.useState(mergedOpen);
    const openRef = _react.useRef(mergedOpen);
    (0, _useLayoutEffectDefault.default)(()=>{
        if (mergedOpen) {
            if (!openRef.current) setMergedCurrent(0);
            setHasOpened(true);
        }
        openRef.current = mergedOpen;
    }, [
        mergedOpen
    ]);
    const { target, placement: stepPlacement, style: stepStyle, arrow: stepArrow, className: stepClassName, mask: stepMask, scrollIntoViewOptions: stepScrollIntoViewOptions = defaultScrollIntoViewOptions, closeIcon: stepCloseIcon, closable: stepClosable } = steps[mergedCurrent] || {};
    const mergedClosable = (0, _useClosable.useClosable)(stepClosable, stepCloseIcon, closable, closeIcon);
    const mergedMask = mergedOpen && (stepMask ?? mask);
    const mergedScrollIntoViewOptions = stepScrollIntoViewOptions ?? scrollIntoViewOptions;
    // ====================== Align Target ======================
    const placeholderRef = _react.useRef(null);
    const inlineMode = getPopupContainer === false;
    const [posInfo, targetElement] = (0, _useTargetDefault.default)(target, open, gap, mergedScrollIntoViewOptions, inlineMode, placeholderRef);
    const mergedPlacement = (0, _util.getPlacement)(targetElement, placement, stepPlacement);
    // ========================= arrow =========================
    const mergedArrow = targetElement ? typeof stepArrow === 'undefined' ? arrow : stepArrow : false;
    const arrowPointAtCenter = typeof mergedArrow === 'object' ? mergedArrow.pointAtCenter : false;
    (0, _useLayoutEffectDefault.default)(()=>{
        triggerRef.current?.forceAlign();
    }, [
        arrowPointAtCenter,
        mergedCurrent
    ]);
    // ========================= Change =========================
    const onInternalChange = (nextCurrent)=>{
        setMergedCurrent(nextCurrent);
        onChange?.(nextCurrent);
    };
    const mergedBuiltinPlacements = (0, _react.useMemo)(()=>{
        if (builtinPlacements) return typeof builtinPlacements === 'function' ? builtinPlacements({
            arrowPointAtCenter
        }) : builtinPlacements;
        return (0, _placements.getPlacements)(arrowPointAtCenter);
    }, [
        builtinPlacements,
        arrowPointAtCenter
    ]);
    // ========================= Render =========================
    // Skip if not init yet
    if (targetElement === undefined || !hasOpened) return null;
    const handleClose = ()=>{
        setMergedOpen(false);
        onClose?.(mergedCurrent);
    };
    const getPopupElement = ()=>/*#__PURE__*/ _react.createElement((0, _tourStepDefault.default), _extends({
            styles: styles,
            classNames: tourClassNames,
            arrow: mergedArrow,
            key: "content",
            prefixCls: prefixCls,
            total: steps.length,
            renderPanel: renderPanel,
            onPrev: ()=>{
                onInternalChange(mergedCurrent - 1);
            },
            onNext: ()=>{
                onInternalChange(mergedCurrent + 1);
            },
            onClose: handleClose,
            current: mergedCurrent,
            onFinish: ()=>{
                handleClose();
                onFinish?.();
            }
        }, steps[mergedCurrent], {
            closable: mergedClosable
        }));
    const mergedShowMask = typeof mergedMask === 'boolean' ? mergedMask : !!mergedMask;
    const mergedMaskStyle = typeof mergedMask === 'boolean' ? undefined : mergedMask;
    // when targetElement is not exist, use body as triggerDOMNode
    const fallbackDOM = ()=>{
        return targetElement || document.body;
    };
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _maskDefault.default), {
        getPopupContainer: getPopupContainer,
        styles: styles,
        classNames: tourClassNames,
        zIndex: zIndex,
        prefixCls: prefixCls,
        pos: posInfo,
        showMask: mergedShowMask,
        style: mergedMaskStyle?.style,
        fill: mergedMaskStyle?.color,
        open: mergedOpen,
        animated: animated,
        rootClassName: rootClassName,
        disabledInteraction: disabledInteraction
    }), /*#__PURE__*/ _react.createElement((0, _triggerDefault.default), _extends({}, restProps, {
        // `rc-portal` def bug not support `false` but does support and in used.
        getPopupContainer: getPopupContainer,
        builtinPlacements: mergedBuiltinPlacements,
        ref: triggerRef,
        popupStyle: stepStyle,
        popupPlacement: mergedPlacement,
        popupVisible: mergedOpen,
        popupClassName: (0, _clsx.clsx)(rootClassName, stepClassName),
        prefixCls: prefixCls,
        popup: getPopupElement,
        forceRender: false,
        autoDestroy: true,
        zIndex: zIndex,
        arrow: !!mergedArrow
    }), /*#__PURE__*/ _react.createElement((0, _placeholderDefault.default), {
        open: mergedOpen,
        autoLock: !inlineMode,
        getContainer: getPopupContainer,
        domRef: placeholderRef,
        fallbackDOM: fallbackDOM,
        className: (0, _clsx.clsx)(className, rootClassName, `${prefixCls}-target-placeholder`),
        style: {
            ...posInfo || CENTER_PLACEHOLDER,
            position: inlineMode ? 'absolute' : 'fixed',
            pointerEvents: 'none',
            ...style
        }
    })));
};
exports.default = Tour;

},{"react":"bmhQu","@rc-component/trigger":"8gqi4","clsx":"431Ou","@rc-component/util/es/hooks/useLayoutEffect":"azwns","@rc-component/util/es/hooks/useControlledState":"2FQtD","./hooks/useClosable":"ahpxG","./hooks/useTarget":"3VRTv","./Mask":"47o0B","./placements":"lhKPZ","./TourStep":"jbk2W","./util":"k2uRb","./Placeholder":"lLfSB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ahpxG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useClosable", ()=>useClosable);
var _react = require("react");
function isConfigObj(closable) {
    return closable !== null && typeof closable === 'object';
}
/**
 * Convert `closable` to ClosableConfig.
 * When `preset` is true, will auto fill ClosableConfig with default value.
 */ function getClosableConfig(closable, closeIcon, preset) {
    if (closable === false || closeIcon === false && (!isConfigObj(closable) || !closable.closeIcon)) return null;
    const mergedCloseIcon = typeof closeIcon !== 'boolean' ? closeIcon : undefined;
    if (isConfigObj(closable)) return {
        ...closable,
        closeIcon: closable.closeIcon ?? mergedCloseIcon
    };
    // When StepClosable no need auto fill, but RootClosable need this.
    return preset || closable || closeIcon ? {
        closeIcon: mergedCloseIcon
    } : 'empty';
}
function useClosable(stepClosable, stepCloseIcon, closable, closeIcon) {
    return _react.useMemo(()=>{
        const stepClosableConfig = getClosableConfig(stepClosable, stepCloseIcon, false);
        const rootClosableConfig = getClosableConfig(closable, closeIcon, true);
        if (stepClosableConfig !== 'empty') return stepClosableConfig;
        return rootClosableConfig;
    }, [
        closable,
        closeIcon,
        stepClosable,
        stepCloseIcon
    ]);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3VRTv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTarget);
var _useEvent = require("@rc-component/util/es/hooks/useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _react = require("react");
var _util = require("../util");
function isValidNumber(val) {
    return typeof val === 'number' && !Number.isNaN(val);
}
function useTarget(target, open, gap, scrollIntoViewOptions, inlineMode, placeholderRef) {
    // ========================= Target =========================
    // We trade `undefined` as not get target by function yet.
    // `null` as empty target.
    const [targetElement, setTargetElement] = (0, _react.useState)(undefined);
    (0, _useLayoutEffectDefault.default)(()=>{
        const nextElement = typeof target === 'function' ? target() : target;
        setTargetElement(nextElement || null);
    });
    // ========================= Align ==========================
    const [posInfo, setPosInfo] = (0, _react.useState)(null);
    const updatePos = (0, _useEventDefault.default)(()=>{
        if (targetElement) {
            // Exist target element. We should scroll and get target position
            if (!inlineMode && !(0, _util.isInViewPort)(targetElement) && open) targetElement.scrollIntoView(scrollIntoViewOptions);
            const { left, top, width, height } = targetElement.getBoundingClientRect();
            const nextPosInfo = {
                left,
                top,
                width,
                height,
                radius: 0
            };
            // If `inlineMode` we need cut off parent offset
            if (inlineMode) {
                const parentRect = placeholderRef.current?.parentElement?.getBoundingClientRect();
                if (parentRect) {
                    nextPosInfo.left -= parentRect.left;
                    nextPosInfo.top -= parentRect.top;
                }
            }
            setPosInfo((origin)=>{
                if (JSON.stringify(origin) !== JSON.stringify(nextPosInfo)) return nextPosInfo;
                return origin;
            });
        } else // Not exist target which means we just show in center
        setPosInfo(null);
    });
    const getGapOffset = (index)=>(Array.isArray(gap?.offset) ? gap?.offset[index] : gap?.offset) ?? 6;
    (0, _useLayoutEffectDefault.default)(()=>{
        updatePos();
        // update when window resize
        window.addEventListener('resize', updatePos);
        // update when `document.body.style.overflow` is set to visible
        // by default, it will be set to hidden
        window.addEventListener('scroll', updatePos);
        return ()=>{
            window.removeEventListener('resize', updatePos);
            window.removeEventListener('scroll', updatePos);
        };
    }, [
        targetElement,
        open,
        updatePos
    ]);
    // ======================== PosInfo =========================
    const mergedPosInfo = (0, _react.useMemo)(()=>{
        if (!posInfo) return posInfo;
        const gapOffsetX = getGapOffset(0);
        const gapOffsetY = getGapOffset(1);
        const gapRadius = isValidNumber(gap?.radius) ? gap?.radius : 2;
        return {
            left: posInfo.left - gapOffsetX,
            top: posInfo.top - gapOffsetY,
            width: posInfo.width + gapOffsetX * 2,
            height: posInfo.height + gapOffsetY * 2,
            radius: gapRadius
        };
    }, [
        posInfo,
        gap
    ]);
    return [
        mergedPosInfo,
        targetElement
    ];
}

},{"@rc-component/util/es/hooks/useEvent":"klq5U","@rc-component/util/es/hooks/useLayoutEffect":"azwns","react":"bmhQu","../util":"k2uRb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k2uRb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isInViewPort", ()=>isInViewPort);
parcelHelpers.export(exports, "getPlacement", ()=>getPlacement);
function isInViewPort(element) {
    const viewWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewHeight = window.innerHeight || document.documentElement.clientHeight;
    const { top, right, bottom, left } = element.getBoundingClientRect();
    return top >= 0 && left >= 0 && right <= viewWidth && bottom <= viewHeight;
}
function getPlacement(targetElement, placement, stepPlacement) {
    return stepPlacement ?? placement ?? (targetElement === null ? 'center' : 'bottom');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"47o0B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _portal = require("@rc-component/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _useId = require("@rc-component/util/es/hooks/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const COVER_PROPS = {
    fill: 'transparent',
    pointerEvents: 'auto'
};
const Mask = (props)=>{
    const { prefixCls, rootClassName, pos, showMask, style = {}, fill = 'rgba(0,0,0,0.5)', open, animated, zIndex, disabledInteraction, styles, classNames: tourClassNames, getPopupContainer } = props;
    const id = (0, _useIdDefault.default)();
    const maskId = `${prefixCls}-mask-${id}`;
    const mergedAnimated = typeof animated === 'object' ? animated?.placeholder : animated;
    const isSafari = typeof navigator !== 'undefined' && /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const maskRectSize = isSafari ? {
        width: '100%',
        height: '100%'
    } : {
        width: '100vw',
        height: '100vh'
    };
    const inlineMode = getPopupContainer === false;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _portalDefault.default), {
        open: open,
        autoLock: !inlineMode,
        getContainer: getPopupContainer
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-mask`, rootClassName, tourClassNames?.mask),
        style: {
            position: inlineMode ? 'absolute' : 'fixed',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            zIndex,
            pointerEvents: pos && !disabledInteraction ? 'none' : 'auto',
            ...style,
            ...styles?.mask
        }
    }, showMask ? /*#__PURE__*/ (0, _reactDefault.default).createElement("svg", {
        style: {
            width: '100%',
            height: '100%'
        }
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("defs", null, /*#__PURE__*/ (0, _reactDefault.default).createElement("mask", {
        id: maskId
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", _extends({
        x: "0",
        y: "0"
    }, maskRectSize, {
        fill: "white"
    })), pos && /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: pos.left,
        y: pos.top,
        rx: pos.radius,
        width: pos.width,
        height: pos.height,
        fill: "black",
        className: mergedAnimated ? `${prefixCls}-placeholder-animated` : ''
    }))), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", {
        x: "0",
        y: "0",
        width: "100%",
        height: "100%",
        fill: fill,
        mask: `url(#${maskId})`
    }), pos && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", _extends({}, COVER_PROPS, {
        x: "0",
        y: "0",
        width: "100%",
        height: Math.max(pos.top, 0)
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", _extends({}, COVER_PROPS, {
        x: "0",
        y: "0",
        width: Math.max(pos.left, 0),
        height: "100%"
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", _extends({}, COVER_PROPS, {
        x: "0",
        y: pos.top + pos.height,
        width: "100%",
        height: `calc(100% - ${pos.top + pos.height}px)`
    })), /*#__PURE__*/ (0, _reactDefault.default).createElement("rect", _extends({}, COVER_PROPS, {
        x: pos.left + pos.width,
        y: "0",
        width: `calc(100% - ${pos.left + pos.width}px)`,
        height: "100%"
    })))) : null));
};
exports.default = Mask;

},{"react":"bmhQu","clsx":"431Ou","@rc-component/portal":"fYVZK","@rc-component/util/es/hooks/useId":"910ko","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lhKPZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPlacements", ()=>getPlacements);
parcelHelpers.export(exports, "placements", ()=>placements);
const autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const targetOffset = [
    0,
    0
];
const basePlacements = {
    left: {
        points: [
            'cr',
            'cl'
        ],
        offset: [
            -8,
            0
        ]
    },
    right: {
        points: [
            'cl',
            'cr'
        ],
        offset: [
            8,
            0
        ]
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        offset: [
            0,
            -8
        ]
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        offset: [
            0,
            8
        ]
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        offset: [
            0,
            -8
        ]
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        offset: [
            -8,
            0
        ]
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        offset: [
            0,
            -8
        ]
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        offset: [
            8,
            0
        ]
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        offset: [
            0,
            8
        ]
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        offset: [
            8,
            0
        ]
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        offset: [
            0,
            8
        ]
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        offset: [
            -8,
            0
        ]
    }
};
function getPlacements(arrowPointAtCenter = false) {
    const placements = {};
    Object.keys(basePlacements).forEach((key)=>{
        placements[key] = {
            ...basePlacements[key],
            autoArrow: arrowPointAtCenter,
            targetOffset
        };
    });
    return placements;
}
const placements = getPlacements();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jbk2W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _defaultPanel = require("./DefaultPanel");
var _defaultPanelDefault = parcelHelpers.interopDefault(_defaultPanel);
const TourStep = (props)=>{
    const { current, renderPanel } = props;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, typeof renderPanel === 'function' ? renderPanel(props, current) : /*#__PURE__*/ _react.createElement((0, _defaultPanelDefault.default), props));
};
exports.default = TourStep;

},{"react":"bmhQu","./DefaultPanel":"fgu6w","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fgu6w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DefaultPanel);
var _react = require("react");
var _clsx = require("clsx");
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function DefaultPanel(props) {
    const { prefixCls, current, total, title, description, onClose, onPrev, onNext, onFinish, className, closable, classNames: tourClassNames, styles } = props;
    const ariaProps = (0, _pickAttrsDefault.default)(closable || {}, true);
    const closeIcon = closable?.closeIcon ?? /*#__PURE__*/ _react.createElement("span", {
        className: `${prefixCls}-close-x`
    }, "\xD7");
    const mergedClosable = !!closable;
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-panel`, className)
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-section`, tourClassNames?.section),
        style: styles?.section
    }, mergedClosable && /*#__PURE__*/ _react.createElement("button", _extends({
        type: "button",
        onClick: onClose,
        "aria-label": "Close"
    }, ariaProps, {
        className: `${prefixCls}-close`
    }), closeIcon), /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-header`, tourClassNames?.header),
        style: styles?.header
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-title`, tourClassNames?.title),
        style: styles?.title
    }, title)), /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-description`, tourClassNames?.description),
        style: styles?.description
    }, description), /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-footer`, tourClassNames?.footer),
        style: styles?.footer
    }, /*#__PURE__*/ _react.createElement("div", {
        className: `${prefixCls}-sliders`
    }, total > 1 ? [
        ...Array.from({
            length: total
        }).keys()
    ].map((item, index)=>{
        return /*#__PURE__*/ _react.createElement("span", {
            key: item,
            className: index === current ? 'active' : ''
        });
    }) : null), /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-actions`, tourClassNames?.actions),
        style: styles?.actions
    }, current !== 0 ? /*#__PURE__*/ _react.createElement("button", {
        className: `${prefixCls}-prev-btn`,
        onClick: onPrev
    }, "Prev") : null, current === total - 1 ? /*#__PURE__*/ _react.createElement("button", {
        className: `${prefixCls}-finish-btn`,
        onClick: onFinish
    }, "Finish") : /*#__PURE__*/ _react.createElement("button", {
        className: `${prefixCls}-next-btn`,
        onClick: onNext
    }, "Next")))));
}

},{"react":"bmhQu","clsx":"431Ou","@rc-component/util/es/pickAttrs":"jGMGD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lLfSB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _portal = require("@rc-component/portal");
var _portalDefault = parcelHelpers.interopDefault(_portal);
var _react = require("react");
const Placeholder = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { open, autoLock, getContainer, domRef, className, style, fallbackDOM } = props;
    _react.useImperativeHandle(ref, ()=>domRef.current || fallbackDOM());
    return /*#__PURE__*/ _react.createElement((0, _portalDefault.default), {
        open: open,
        autoLock: autoLock,
        getContainer: getContainer
    }, /*#__PURE__*/ _react.createElement("div", {
        ref: domRef,
        className: className,
        style: style
    }));
});
exports.default = Placeholder;

},{"@rc-component/portal":"fYVZK","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2SoNj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _closeOutlined = require("@ant-design/icons/es/icons/CloseOutlined");
var _closeOutlinedDefault = parcelHelpers.interopDefault(_closeOutlined);
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
var _clsx = require("clsx");
var _isNonNullable = require("../_util/isNonNullable");
var _isNonNullableDefault = parcelHelpers.interopDefault(_isNonNullable);
var _button = require("../button/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _locale = require("../locale");
var _enUS = require("../locale/en_US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
"use client";
// Due to the independent design of Panel, it will be too coupled to put in rc-tour,
// so a set of Panel logic is implemented separately in antd.
const TourPanel = (props)=>{
    const { stepProps, current, type, indicatorsRender, actionsRender } = props;
    const { prefixCls, total = 1, title, onClose, onPrev, onNext, onFinish, cover, description, nextButtonProps, prevButtonProps, type: stepType, closable, classNames = {}, styles = {} } = stepProps;
    const mergedType = stepType ?? type;
    const ariaProps = (0, _pickAttrsDefault.default)(closable ?? {}, true);
    const [contextLocaleGlobal] = (0, _locale.useLocale)('global', (0, _enUSDefault.default).global);
    const [contextLocaleTour] = (0, _locale.useLocale)('Tour', (0, _enUSDefault.default).Tour);
    const mergedCloseIcon = /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
        type: "button",
        onClick: onClose,
        className: `${prefixCls}-close`,
        "aria-label": contextLocaleGlobal?.close,
        ...ariaProps
    }, closable?.closeIcon || /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _closeOutlinedDefault.default), {
        className: `${prefixCls}-close-icon`
    }));
    const isLastStep = current === total - 1;
    const prevBtnClick = ()=>{
        onPrev?.();
        prevButtonProps?.onClick?.();
    };
    const nextBtnClick = ()=>{
        if (isLastStep) onFinish?.();
        else onNext?.();
        nextButtonProps?.onClick?.();
    };
    const headerNode = (0, _isNonNullableDefault.default)(title) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-header`, classNames.header),
        style: styles.header
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-title`, classNames.title),
        style: styles.title
    }, title)) : null;
    const descriptionNode = (0, _isNonNullableDefault.default)(description) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-description`, classNames.description),
        style: styles.description
    }, description) : null;
    const coverNode = (0, _isNonNullableDefault.default)(cover) ? /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-cover`, classNames.cover),
        style: styles.cover
    }, cover) : null;
    let mergedIndicatorNode;
    if (indicatorsRender) mergedIndicatorNode = indicatorsRender(current, total);
    else mergedIndicatorNode = (0, _toConsumableArrayDefault.default)(Array.from({
        length: total
    }).keys()).map((stepItem, index)=>/*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            key: stepItem,
            className: (0, _clsx.clsx)(index === current && `${prefixCls}-indicator-active`, `${prefixCls}-indicator`, classNames.indicator),
            style: styles.indicator
        }));
    const mainBtnType = mergedType === 'primary' ? 'default' : 'primary';
    const secondaryBtnProps = {
        type: 'default',
        ghost: mergedType === 'primary'
    };
    const defaultActionsNode = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, current !== 0 ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        size: "small",
        ...secondaryBtnProps,
        ...prevButtonProps,
        onClick: prevBtnClick,
        className: (0, _clsx.clsx)(`${prefixCls}-prev-btn`, prevButtonProps?.className)
    }, prevButtonProps?.children ?? contextLocaleTour?.Previous) : null, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _buttonDefault.default), {
        size: "small",
        type: mainBtnType,
        ...nextButtonProps,
        onClick: nextBtnClick,
        className: (0, _clsx.clsx)(`${prefixCls}-next-btn`, nextButtonProps?.className)
    }, nextButtonProps?.children ?? (isLastStep ? contextLocaleTour?.Finish : contextLocaleTour?.Next)));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${prefixCls}-panel`
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-section`, classNames.section),
        style: styles.section
    }, closable && mergedCloseIcon, coverNode, headerNode, descriptionNode, /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-footer`, classNames.footer),
        style: styles.footer
    }, total > 1 && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-indicators`, classNames.indicators),
        style: styles.indicators
    }, mergedIndicatorNode), /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-actions`, classNames.actions),
        style: styles.actions
    }, actionsRender ? actionsRender(defaultActionsNode, {
        current,
        total
    }) : defaultActionsNode))));
};
exports.default = TourPanel;

},{"@babel/runtime/helpers/esm/toConsumableArray":"inIie","react":"bmhQu","@ant-design/icons/es/icons/CloseOutlined":"dinn5","@rc-component/util/es/pickAttrs":"jGMGD","clsx":"431Ou","../_util/isNonNullable":"avlqw","../button/Button":"gfWzz","../locale":[["useLocale","l6QvX","default"]],"../locale/en_US":"cgwsy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4dOk5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _purePanel = require("../_util/PurePanel");
var _reactNode = require("../_util/reactNode");
var _configProvider = require("../config-provider");
var _purePanel1 = require("../popover/PurePanel");
var _panelRender = require("./panelRender");
var _panelRenderDefault = parcelHelpers.interopDefault(_panelRender);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, current = 0, total = 6, className, style, type, closable, closeIcon, ...restProps } = props;
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('tour', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    const [mergedClosable, mergedCloseIcon] = (0, _hooks.useClosable)({
        closable,
        closeIcon
    }, null, {
        closable: true,
        closeIconRender: (icon)=>/*#__PURE__*/ _react.isValidElement(icon) ? (0, _reactNode.cloneElement)(icon, {
                className: (0, _clsx.clsx)(icon.props?.className, `${prefixCls}-close-icon`)
            }) : icon
    });
    return /*#__PURE__*/ _react.createElement((0, _purePanel1.RawPurePanel), {
        prefixCls: prefixCls,
        hashId: hashId,
        className: (0, _clsx.clsx)(className, `${prefixCls}-pure`, type && `${prefixCls}-${type}`, cssVarCls),
        style: style
    }, /*#__PURE__*/ _react.createElement((0, _panelRenderDefault.default), {
        stepProps: {
            ...restProps,
            prefixCls,
            total,
            closable: mergedClosable ? {
                closeIcon: mergedCloseIcon
            } : undefined
        },
        current: current,
        type: type
    }));
};
exports.default = (0, _purePanel.withPureRenderTheme)(PurePanel);

},{"react":"bmhQu","clsx":"431Ou","../_util/hooks":"cC5so","../_util/PurePanel":"31Oxh","../_util/reactNode":"78pFx","../config-provider":"dVeAX","../popover/PurePanel":"cvdfY","./panelRender":"2SoNj","./style":"asGoC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cvdfY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Overlay", ()=>Overlay);
parcelHelpers.export(exports, "RawPurePanel", ()=>RawPurePanel);
var _react = require("react");
var _tooltip = require("@rc-component/tooltip");
var _clsx = require("clsx");
var _getRenderPropValue = require("../_util/getRenderPropValue");
var _hooks = require("../_util/hooks");
var _configProvider = require("../config-provider");
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const Overlay = (props)=>{
    const { title, content, prefixCls, classNames, styles } = props;
    if (!title && !content) return null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, title && /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-title`, classNames?.title),
        style: styles?.title
    }, title), content && /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-content`, classNames?.content),
        style: styles?.content
    }, content));
};
const RawPurePanel = (props)=>{
    const { hashId, prefixCls, className, style, placement = 'top', title, content, children, classNames, styles } = props;
    const titleNode = (0, _getRenderPropValue.getRenderPropValue)(title);
    const contentNode = (0, _getRenderPropValue.getRenderPropValue)(content);
    const mergedProps = {
        ...props,
        placement
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        classNames
    ], [
        styles
    ], {
        props: mergedProps
    });
    const rootClassName = (0, _clsx.clsx)(hashId, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className);
    return /*#__PURE__*/ _react.createElement("div", {
        className: rootClassName,
        style: style
    }, /*#__PURE__*/ _react.createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ _react.createElement((0, _tooltip.Popup), {
        ...props,
        className: hashId,
        prefixCls: prefixCls,
        classNames: mergedClassNames,
        styles: mergedStyles
    }, children || /*#__PURE__*/ _react.createElement(Overlay, {
        prefixCls: prefixCls,
        title: titleNode,
        content: contentNode,
        classNames: mergedClassNames,
        styles: mergedStyles
    })));
};
const PurePanel = (props)=>{
    const { prefixCls: customizePrefixCls, className, ...restProps } = props;
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    return /*#__PURE__*/ _react.createElement(RawPurePanel, {
        ...restProps,
        prefixCls: prefixCls,
        hashId: hashId,
        className: (0, _clsx.clsx)(className, cssVarCls)
    });
};
exports.default = PurePanel;

},{"react":"bmhQu","@rc-component/tooltip":"9UTy2","clsx":"431Ou","../_util/getRenderPropValue":"bxLP4","../_util/hooks":"kdnMA","../config-provider":"dVeAX","./style":"7nbAL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bxLP4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRenderPropValue", ()=>getRenderPropValue);
const getRenderPropValue = (propValue)=>{
    if (!propValue) return null;
    return typeof propValue === 'function' ? propValue() : propValue;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7nbAL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _style = require("../../style");
var _motion = require("../../style/motion");
var _placementArrow = require("../../style/placementArrow");
var _placementArrowDefault = parcelHelpers.interopDefault(_placementArrow);
var _roundedArrow = require("../../style/roundedArrow");
var _internal = require("../../theme/internal");
const genBaseStyle = (token)=>{
    const { componentCls, popoverColor, titleMinWidth, fontWeightStrong, innerPadding, boxShadowSecondary, colorTextHeading, borderRadiusLG, zIndexPopup, titleMarginBottom, colorBgElevated, popoverBg, titleBorderBottom, innerContentPadding, titlePadding } = token;
    return [
        {
            [componentCls]: {
                ...(0, _style.resetComponent)(token),
                position: 'absolute',
                top: 0,
                // use `left` to fix https://github.com/ant-design/ant-design/issues/39195
                left: {
                    _skip_check_: true,
                    value: 0
                },
                zIndex: zIndexPopup,
                fontWeight: 'normal',
                whiteSpace: 'normal',
                textAlign: 'start',
                cursor: 'auto',
                userSelect: 'text',
                // When use `autoArrow`, origin will follow the arrow position
                '--valid-offset-x': 'var(--arrow-offset-horizontal, var(--arrow-x))',
                transformOrigin: [
                    `var(--valid-offset-x, 50%)`,
                    `var(--arrow-y, 50%)`
                ].join(' '),
                '--antd-arrow-background-color': colorBgElevated,
                width: 'max-content',
                maxWidth: '100vw',
                '&-rtl': {
                    direction: 'rtl'
                },
                '&-hidden': {
                    display: 'none'
                },
                [`${componentCls}-content`]: {
                    position: 'relative'
                },
                [`${componentCls}-container`]: {
                    backgroundColor: popoverBg,
                    backgroundClip: 'padding-box',
                    borderRadius: borderRadiusLG,
                    boxShadow: boxShadowSecondary,
                    padding: innerPadding
                },
                [`${componentCls}-title`]: {
                    minWidth: titleMinWidth,
                    marginBottom: titleMarginBottom,
                    color: colorTextHeading,
                    fontWeight: fontWeightStrong,
                    borderBottom: titleBorderBottom,
                    padding: titlePadding
                },
                [`${componentCls}-content`]: {
                    color: popoverColor,
                    padding: innerContentPadding
                }
            }
        },
        // Arrow Style
        (0, _placementArrowDefault.default)(token, 'var(--antd-arrow-background-color)'),
        // Pure Render
        {
            [`${componentCls}-pure`]: {
                position: 'relative',
                maxWidth: 'none',
                margin: token.sizePopupArrow,
                display: 'inline-block'
            }
        }
    ];
};
const genColorStyle = (token)=>{
    const { componentCls } = token;
    return {
        [componentCls]: (0, _internal.PresetColors).map((colorKey)=>{
            const lightColor = token[`${colorKey}6`];
            return {
                [`&${componentCls}-${colorKey}`]: {
                    '--antd-arrow-background-color': lightColor,
                    [`${componentCls}-inner`]: {
                        backgroundColor: lightColor
                    },
                    [`${componentCls}-arrow`]: {
                        background: 'transparent'
                    }
                }
            };
        })
    };
};
const prepareComponentToken = (token)=>{
    const { lineWidth, controlHeight, fontHeight, padding, wireframe, zIndexPopupBase, borderRadiusLG, marginXS, lineType, colorSplit, paddingSM } = token;
    const titlePaddingBlockDist = controlHeight - fontHeight;
    const popoverTitlePaddingBlockTop = titlePaddingBlockDist / 2;
    const popoverTitlePaddingBlockBottom = titlePaddingBlockDist / 2 - lineWidth;
    const popoverPaddingHorizontal = padding;
    return {
        titleMinWidth: 177,
        zIndexPopup: zIndexPopupBase + 30,
        ...(0, _roundedArrow.getArrowToken)(token),
        ...(0, _placementArrow.getArrowOffsetToken)({
            contentRadius: borderRadiusLG,
            limitVerticalRadius: true
        }),
        // internal
        innerPadding: wireframe ? 0 : 12,
        titleMarginBottom: wireframe ? 0 : marginXS,
        titlePadding: wireframe ? `${popoverTitlePaddingBlockTop}px ${popoverPaddingHorizontal}px ${popoverTitlePaddingBlockBottom}px` : 0,
        titleBorderBottom: wireframe ? `${lineWidth}px ${lineType} ${colorSplit}` : 'none',
        innerContentPadding: wireframe ? `${paddingSM}px ${popoverPaddingHorizontal}px` : 0
    };
};
exports.default = (0, _internal.genStyleHooks)('Popover', (token)=>{
    const { colorBgElevated, colorText } = token;
    const popoverToken = (0, _internal.mergeToken)(token, {
        popoverBg: colorBgElevated,
        popoverColor: colorText
    });
    return [
        genBaseStyle(popoverToken),
        genColorStyle(popoverToken),
        (0, _motion.initZoomMotion)(popoverToken, 'zoom-big')
    ];
}, prepareComponentToken, {
    resetStyle: false,
    deprecatedTokens: [
        [
            'width',
            'titleMinWidth'
        ],
        [
            'minWidth',
            'titleMinWidth'
        ]
    ]
});

},{"../../style":"4Ezp0","../../style/motion":"dqyUY","../../style/placementArrow":"73A7X","../../style/roundedArrow":"dmj3M","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"],["PresetColors","aRwwT"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"asGoC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _cssinjs = require("@ant-design/cssinjs");
var _fastColor = require("@ant-design/fast-color");
var _style = require("../../style");
var _placementArrow = require("../../style/placementArrow");
var _placementArrowDefault = parcelHelpers.interopDefault(_placementArrow);
var _roundedArrow = require("../../style/roundedArrow");
var _internal = require("../../theme/internal");
// =============================== Base ===============================
const genBaseStyle = (token)=>{
    const { componentCls, padding, paddingXS, borderRadius, borderRadiusXS, colorPrimary, colorFill, indicatorHeight, indicatorWidth, boxShadowTertiary, zIndexPopup, colorBgElevated, fontWeightStrong, marginXS, colorTextLightSolid, tourBorderRadius, colorWhite, primaryNextBtnHoverBg, closeBtnSize, motionDurationSlow, antCls, primaryPrevBtnBg } = token;
    return [
        {
            [componentCls]: {
                ...(0, _style.resetComponent)(token),
                position: 'absolute',
                zIndex: zIndexPopup,
                maxWidth: 'fit-content',
                visibility: 'visible',
                width: 520,
                '--antd-arrow-background-color': colorBgElevated,
                '&-pure': {
                    maxWidth: '100%',
                    position: 'relative'
                },
                [`&${componentCls}-hidden`]: {
                    display: 'none'
                },
                // ============================= panel content ============================
                [`${componentCls}-panel`]: {
                    position: 'relative'
                },
                [`${componentCls}-section`]: {
                    textAlign: 'start',
                    textDecoration: 'none',
                    borderRadius: tourBorderRadius,
                    boxShadow: boxShadowTertiary,
                    position: 'relative',
                    backgroundColor: colorBgElevated,
                    border: 'none',
                    backgroundClip: 'padding-box',
                    [`${componentCls}-close`]: {
                        position: 'absolute',
                        top: padding,
                        insetInlineEnd: padding,
                        color: token.colorIcon,
                        background: 'none',
                        border: 'none',
                        width: closeBtnSize,
                        height: closeBtnSize,
                        borderRadius: token.borderRadiusSM,
                        transition: `background-color ${token.motionDurationMid}, color ${token.motionDurationMid}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer',
                        '&:hover': {
                            color: token.colorIconHover,
                            backgroundColor: token.colorBgTextHover
                        },
                        '&:active': {
                            backgroundColor: token.colorBgTextActive
                        },
                        ...(0, _style.genFocusStyle)(token)
                    },
                    [`${componentCls}-cover`]: {
                        textAlign: 'center',
                        padding: `${(0, _cssinjs.unit)(token.calc(padding).add(closeBtnSize).add(paddingXS).equal())} ${(0, _cssinjs.unit)(padding)} 0`,
                        img: {
                            width: '100%'
                        }
                    },
                    [`${componentCls}-header`]: {
                        padding: `${(0, _cssinjs.unit)(padding)} ${(0, _cssinjs.unit)(padding)} ${(0, _cssinjs.unit)(paddingXS)}`,
                        width: `calc(100% - ${(0, _cssinjs.unit)(closeBtnSize)})`,
                        wordBreak: 'break-word',
                        [`${componentCls}-title`]: {
                            fontWeight: fontWeightStrong
                        }
                    },
                    [`${componentCls}-description`]: {
                        padding: `0 ${(0, _cssinjs.unit)(padding)}`,
                        wordWrap: 'break-word'
                    },
                    [`${componentCls}-footer`]: {
                        padding: `${(0, _cssinjs.unit)(paddingXS)} ${(0, _cssinjs.unit)(padding)} ${(0, _cssinjs.unit)(padding)}`,
                        textAlign: 'end',
                        borderRadius: `0 0 ${(0, _cssinjs.unit)(borderRadiusXS)} ${(0, _cssinjs.unit)(borderRadiusXS)}`,
                        display: 'flex',
                        [`${componentCls}-indicators`]: {
                            display: 'inline-block',
                            [`${componentCls}-indicator`]: {
                                width: indicatorWidth,
                                height: indicatorHeight,
                                display: 'inline-block',
                                borderRadius: '50%',
                                background: colorFill,
                                '&:not(:last-child)': {
                                    marginInlineEnd: indicatorHeight
                                },
                                '&-active': {
                                    background: colorPrimary
                                }
                            }
                        },
                        [`${componentCls}-actions`]: {
                            marginInlineStart: 'auto',
                            [`${antCls}-btn`]: {
                                marginInlineStart: marginXS
                            }
                        }
                    }
                },
                // =============================  primary type  ===========================
                // `$` for panel, `&$` for pure panel
                [`${componentCls}-primary, &${componentCls}-primary`]: {
                    '--antd-arrow-background-color': colorPrimary,
                    [`${componentCls}-section`]: {
                        color: colorTextLightSolid,
                        textAlign: 'start',
                        textDecoration: 'none',
                        backgroundColor: colorPrimary,
                        borderRadius,
                        boxShadow: boxShadowTertiary,
                        [`${componentCls}-close`]: {
                            color: colorTextLightSolid
                        },
                        [`${componentCls}-indicators`]: {
                            [`${componentCls}-indicator`]: {
                                background: primaryPrevBtnBg,
                                '&-active': {
                                    background: colorTextLightSolid
                                }
                            }
                        },
                        [`${componentCls}-prev-btn`]: {
                            color: colorTextLightSolid,
                            borderColor: primaryPrevBtnBg,
                            backgroundColor: colorPrimary,
                            '&:hover': {
                                backgroundColor: primaryPrevBtnBg,
                                borderColor: 'transparent'
                            }
                        },
                        [`${componentCls}-next-btn`]: {
                            color: colorPrimary,
                            borderColor: 'transparent',
                            background: colorWhite,
                            '&:hover': {
                                background: primaryNextBtnHoverBg
                            }
                        }
                    }
                }
            },
            // ============================= mask ===========================
            [`${componentCls}-mask`]: {
                [`${componentCls}-placeholder-animated`]: {
                    transition: `all ${motionDurationSlow}`
                }
            },
            // =========== Limit left and right placement radius ==============
            [[
                '&-placement-left',
                '&-placement-leftTop',
                '&-placement-leftBottom',
                '&-placement-right',
                '&-placement-rightTop',
                '&-placement-rightBottom'
            ].join(',')]: {
                [`${componentCls}-section`]: {
                    borderRadius: token.min(tourBorderRadius, (0, _placementArrow.MAX_VERTICAL_CONTENT_RADIUS))
                }
            }
        },
        // ============================= Arrow ===========================
        (0, _placementArrowDefault.default)(token, 'var(--antd-arrow-background-color)')
    ];
};
const prepareComponentToken = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 70,
        closeBtnSize: token.fontSize * token.lineHeight,
        primaryPrevBtnBg: new (0, _fastColor.FastColor)(token.colorTextLightSolid).setA(0.15).toRgbString(),
        primaryNextBtnHoverBg: new (0, _fastColor.FastColor)(token.colorBgTextHover).onBackground(token.colorWhite).toRgbString(),
        ...(0, _placementArrow.getArrowOffsetToken)({
            contentRadius: token.borderRadiusLG,
            limitVerticalRadius: true
        }),
        ...(0, _roundedArrow.getArrowToken)(token)
    });
exports.default = (0, _internal.genStyleHooks)('Tour', (token)=>{
    const { borderRadiusLG } = token;
    const TourToken = (0, _internal.mergeToken)(token, {
        indicatorWidth: 6,
        indicatorHeight: 6,
        tourBorderRadius: borderRadiusLG
    });
    return genBaseStyle(TourToken);
}, prepareComponentToken);

},{"@ant-design/cssinjs":"2VNL8","@ant-design/fast-color":"50VUA","../../style":"4Ezp0","../../style/placementArrow":"73A7X","../../style/roundedArrow":"dmj3M","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kD37e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AutoScrollActivator", ()=>AutoScrollActivator);
parcelHelpers.export(exports, "DndContext", ()=>DndContext);
parcelHelpers.export(exports, "DragOverlay", ()=>DragOverlay);
parcelHelpers.export(exports, "KeyboardCode", ()=>KeyboardCode);
parcelHelpers.export(exports, "KeyboardSensor", ()=>KeyboardSensor);
parcelHelpers.export(exports, "MeasuringFrequency", ()=>MeasuringFrequency);
parcelHelpers.export(exports, "MeasuringStrategy", ()=>MeasuringStrategy);
parcelHelpers.export(exports, "MouseSensor", ()=>MouseSensor);
parcelHelpers.export(exports, "PointerSensor", ()=>PointerSensor);
parcelHelpers.export(exports, "TouchSensor", ()=>TouchSensor);
parcelHelpers.export(exports, "TraversalOrder", ()=>TraversalOrder);
parcelHelpers.export(exports, "applyModifiers", ()=>applyModifiers);
parcelHelpers.export(exports, "closestCenter", ()=>closestCenter);
parcelHelpers.export(exports, "closestCorners", ()=>closestCorners);
parcelHelpers.export(exports, "defaultAnnouncements", ()=>defaultAnnouncements);
parcelHelpers.export(exports, "defaultCoordinates", ()=>defaultCoordinates);
parcelHelpers.export(exports, "defaultDropAnimation", ()=>defaultDropAnimationConfiguration);
parcelHelpers.export(exports, "defaultDropAnimationSideEffects", ()=>defaultDropAnimationSideEffects);
parcelHelpers.export(exports, "defaultKeyboardCoordinateGetter", ()=>defaultKeyboardCoordinateGetter);
parcelHelpers.export(exports, "defaultScreenReaderInstructions", ()=>defaultScreenReaderInstructions);
parcelHelpers.export(exports, "getClientRect", ()=>getClientRect);
parcelHelpers.export(exports, "getFirstCollision", ()=>getFirstCollision);
parcelHelpers.export(exports, "getScrollableAncestors", ()=>getScrollableAncestors);
parcelHelpers.export(exports, "pointerWithin", ()=>pointerWithin);
parcelHelpers.export(exports, "rectIntersection", ()=>rectIntersection);
parcelHelpers.export(exports, "useDndContext", ()=>useDndContext);
parcelHelpers.export(exports, "useDndMonitor", ()=>useDndMonitor);
parcelHelpers.export(exports, "useDraggable", ()=>useDraggable);
parcelHelpers.export(exports, "useDroppable", ()=>useDroppable);
parcelHelpers.export(exports, "useSensor", ()=>useSensor);
parcelHelpers.export(exports, "useSensors", ()=>useSensors);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _utilities = require("@dnd-kit/utilities");
var _accessibility = require("@dnd-kit/accessibility");
const DndMonitorContext = /*#__PURE__*/ (0, _react.createContext)(null);
function useDndMonitor(listener) {
    const registerListener = (0, _react.useContext)(DndMonitorContext);
    (0, _react.useEffect)(()=>{
        if (!registerListener) throw new Error('useDndMonitor must be used within a children of <DndContext>');
        const unsubscribe = registerListener(listener);
        return unsubscribe;
    }, [
        listener,
        registerListener
    ]);
}
function useDndMonitorProvider() {
    const [listeners] = (0, _react.useState)(()=>new Set());
    const registerListener = (0, _react.useCallback)((listener)=>{
        listeners.add(listener);
        return ()=>listeners.delete(listener);
    }, [
        listeners
    ]);
    const dispatch = (0, _react.useCallback)((_ref)=>{
        let { type, event } = _ref;
        listeners.forEach((listener)=>{
            var _listener$type;
            return (_listener$type = listener[type]) == null ? void 0 : _listener$type.call(listener, event);
        });
    }, [
        listeners
    ]);
    return [
        dispatch,
        registerListener
    ];
}
const defaultScreenReaderInstructions = {
    draggable: "\n    To pick up a draggable item, press the space bar.\n    While dragging, use the arrow keys to move the item.\n    Press space again to drop the item in its new position, or press escape to cancel.\n  "
};
const defaultAnnouncements = {
    onDragStart (_ref) {
        let { active } = _ref;
        return "Picked up draggable item " + active.id + ".";
    },
    onDragOver (_ref2) {
        let { active, over } = _ref2;
        if (over) return "Draggable item " + active.id + " was moved over droppable area " + over.id + ".";
        return "Draggable item " + active.id + " is no longer over a droppable area.";
    },
    onDragEnd (_ref3) {
        let { active, over } = _ref3;
        if (over) return "Draggable item " + active.id + " was dropped over droppable area " + over.id;
        return "Draggable item " + active.id + " was dropped.";
    },
    onDragCancel (_ref4) {
        let { active } = _ref4;
        return "Dragging was cancelled. Draggable item " + active.id + " was dropped.";
    }
};
function Accessibility(_ref) {
    let { announcements = defaultAnnouncements, container, hiddenTextDescribedById, screenReaderInstructions = defaultScreenReaderInstructions } = _ref;
    const { announce, announcement } = (0, _accessibility.useAnnouncement)();
    const liveRegionId = (0, _utilities.useUniqueId)("DndLiveRegion");
    const [mounted, setMounted] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        setMounted(true);
    }, []);
    useDndMonitor((0, _react.useMemo)(()=>({
            onDragStart (_ref2) {
                let { active } = _ref2;
                announce(announcements.onDragStart({
                    active
                }));
            },
            onDragMove (_ref3) {
                let { active, over } = _ref3;
                if (announcements.onDragMove) announce(announcements.onDragMove({
                    active,
                    over
                }));
            },
            onDragOver (_ref4) {
                let { active, over } = _ref4;
                announce(announcements.onDragOver({
                    active,
                    over
                }));
            },
            onDragEnd (_ref5) {
                let { active, over } = _ref5;
                announce(announcements.onDragEnd({
                    active,
                    over
                }));
            },
            onDragCancel (_ref6) {
                let { active, over } = _ref6;
                announce(announcements.onDragCancel({
                    active,
                    over
                }));
            }
        }), [
        announce,
        announcements
    ]));
    if (!mounted) return null;
    const markup = (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, (0, _reactDefault.default).createElement((0, _accessibility.HiddenText), {
        id: hiddenTextDescribedById,
        value: screenReaderInstructions.draggable
    }), (0, _reactDefault.default).createElement((0, _accessibility.LiveRegion), {
        id: liveRegionId,
        announcement: announcement
    }));
    return container ? (0, _reactDom.createPortal)(markup, container) : markup;
}
var Action;
(function(Action) {
    Action["DragStart"] = "dragStart";
    Action["DragMove"] = "dragMove";
    Action["DragEnd"] = "dragEnd";
    Action["DragCancel"] = "dragCancel";
    Action["DragOver"] = "dragOver";
    Action["RegisterDroppable"] = "registerDroppable";
    Action["SetDroppableDisabled"] = "setDroppableDisabled";
    Action["UnregisterDroppable"] = "unregisterDroppable";
})(Action || (Action = {}));
function noop() {}
function useSensor(sensor, options) {
    return (0, _react.useMemo)(()=>({
            sensor,
            options: options != null ? options : {}
        }), [
        sensor,
        options
    ]);
}
function useSensors() {
    for(var _len = arguments.length, sensors = new Array(_len), _key = 0; _key < _len; _key++)sensors[_key] = arguments[_key];
    return (0, _react.useMemo)(()=>[
            ...sensors
        ].filter((sensor)=>sensor != null), [
        ...sensors
    ]);
}
const defaultCoordinates = /*#__PURE__*/ Object.freeze({
    x: 0,
    y: 0
});
/**
 * Returns the distance between two points
 */ function distanceBetween(p1, p2) {
    return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function getRelativeTransformOrigin(event, rect) {
    const eventCoordinates = (0, _utilities.getEventCoordinates)(event);
    if (!eventCoordinates) return '0 0';
    const transformOrigin = {
        x: (eventCoordinates.x - rect.left) / rect.width * 100,
        y: (eventCoordinates.y - rect.top) / rect.height * 100
    };
    return transformOrigin.x + "% " + transformOrigin.y + "%";
}
/**
 * Sort collisions from smallest to greatest value
 */ function sortCollisionsAsc(_ref, _ref2) {
    let { data: { value: a } } = _ref;
    let { data: { value: b } } = _ref2;
    return a - b;
}
/**
 * Sort collisions from greatest to smallest value
 */ function sortCollisionsDesc(_ref3, _ref4) {
    let { data: { value: a } } = _ref3;
    let { data: { value: b } } = _ref4;
    return b - a;
}
/**
 * Returns the coordinates of the corners of a given rectangle:
 * [TopLeft {x, y}, TopRight {x, y}, BottomLeft {x, y}, BottomRight {x, y}]
 */ function cornersOfRectangle(_ref5) {
    let { left, top, height, width } = _ref5;
    return [
        {
            x: left,
            y: top
        },
        {
            x: left + width,
            y: top
        },
        {
            x: left,
            y: top + height
        },
        {
            x: left + width,
            y: top + height
        }
    ];
}
function getFirstCollision(collisions, property) {
    if (!collisions || collisions.length === 0) return null;
    const [firstCollision] = collisions;
    return property ? firstCollision[property] : firstCollision;
}
/**
 * Returns the coordinates of the center of a given ClientRect
 */ function centerOfRectangle(rect, left, top) {
    if (left === void 0) left = rect.left;
    if (top === void 0) top = rect.top;
    return {
        x: left + rect.width * 0.5,
        y: top + rect.height * 0.5
    };
}
/**
 * Returns the closest rectangles from an array of rectangles to the center of a given
 * rectangle.
 */ const closestCenter = (_ref)=>{
    let { collisionRect, droppableRects, droppableContainers } = _ref;
    const centerRect = centerOfRectangle(collisionRect, collisionRect.left, collisionRect.top);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const distBetween = distanceBetween(centerOfRectangle(rect), centerRect);
            collisions.push({
                id,
                data: {
                    droppableContainer,
                    value: distBetween
                }
            });
        }
    }
    return collisions.sort(sortCollisionsAsc);
};
/**
 * Returns the closest rectangles from an array of rectangles to the corners of
 * another rectangle.
 */ const closestCorners = (_ref)=>{
    let { collisionRect, droppableRects, droppableContainers } = _ref;
    const corners = cornersOfRectangle(collisionRect);
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const rectCorners = cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner, index)=>{
                return accumulator + distanceBetween(rectCorners[index], corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id,
                data: {
                    droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort(sortCollisionsAsc);
};
/**
 * Returns the intersecting rectangle area between two rectangles
 */ function getIntersectionRatio(entry, target) {
    const top = Math.max(target.top, entry.top);
    const left = Math.max(target.left, entry.left);
    const right = Math.min(target.left + target.width, entry.left + entry.width);
    const bottom = Math.min(target.top + target.height, entry.top + entry.height);
    const width = right - left;
    const height = bottom - top;
    if (left < right && top < bottom) {
        const targetArea = target.width * target.height;
        const entryArea = entry.width * entry.height;
        const intersectionArea = width * height;
        const intersectionRatio = intersectionArea / (targetArea + entryArea - intersectionArea);
        return Number(intersectionRatio.toFixed(4));
    } // Rectangles do not overlap, or overlap has an area of zero (edge/corner overlap)
    return 0;
}
/**
 * Returns the rectangles that has the greatest intersection area with a given
 * rectangle in an array of rectangles.
 */ const rectIntersection = (_ref)=>{
    let { collisionRect, droppableRects, droppableContainers } = _ref;
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect) {
            const intersectionRatio = getIntersectionRatio(rect, collisionRect);
            if (intersectionRatio > 0) collisions.push({
                id,
                data: {
                    droppableContainer,
                    value: intersectionRatio
                }
            });
        }
    }
    return collisions.sort(sortCollisionsDesc);
};
/**
 * Check if a given point is contained within a bounding rectangle
 */ function isPointWithinRect(point, rect) {
    const { top, left, bottom, right } = rect;
    return top <= point.y && point.y <= bottom && left <= point.x && point.x <= right;
}
/**
 * Returns the rectangles that the pointer is hovering over
 */ const pointerWithin = (_ref)=>{
    let { droppableContainers, droppableRects, pointerCoordinates } = _ref;
    if (!pointerCoordinates) return [];
    const collisions = [];
    for (const droppableContainer of droppableContainers){
        const { id } = droppableContainer;
        const rect = droppableRects.get(id);
        if (rect && isPointWithinRect(pointerCoordinates, rect)) {
            /* There may be more than a single rectangle intersecting
       * with the pointer coordinates. In order to sort the
       * colliding rectangles, we measure the distance between
       * the pointer and the corners of the intersecting rectangle
       */ const corners = cornersOfRectangle(rect);
            const distances = corners.reduce((accumulator, corner)=>{
                return accumulator + distanceBetween(pointerCoordinates, corner);
            }, 0);
            const effectiveDistance = Number((distances / 4).toFixed(4));
            collisions.push({
                id,
                data: {
                    droppableContainer,
                    value: effectiveDistance
                }
            });
        }
    }
    return collisions.sort(sortCollisionsAsc);
};
function adjustScale(transform, rect1, rect2) {
    return {
        ...transform,
        scaleX: rect1 && rect2 ? rect1.width / rect2.width : 1,
        scaleY: rect1 && rect2 ? rect1.height / rect2.height : 1
    };
}
function getRectDelta(rect1, rect2) {
    return rect1 && rect2 ? {
        x: rect1.left - rect2.left,
        y: rect1.top - rect2.top
    } : defaultCoordinates;
}
function createRectAdjustmentFn(modifier) {
    return function adjustClientRect(rect) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((acc, adjustment)=>({
                ...acc,
                top: acc.top + modifier * adjustment.y,
                bottom: acc.bottom + modifier * adjustment.y,
                left: acc.left + modifier * adjustment.x,
                right: acc.right + modifier * adjustment.x
            }), {
            ...rect
        });
    };
}
const getAdjustedRect = /*#__PURE__*/ createRectAdjustmentFn(1);
function parseTransform(transform) {
    if (transform.startsWith('matrix3d(')) {
        const transformArray = transform.slice(9, -1).split(/, /);
        return {
            x: +transformArray[12],
            y: +transformArray[13],
            scaleX: +transformArray[0],
            scaleY: +transformArray[5]
        };
    } else if (transform.startsWith('matrix(')) {
        const transformArray = transform.slice(7, -1).split(/, /);
        return {
            x: +transformArray[4],
            y: +transformArray[5],
            scaleX: +transformArray[0],
            scaleY: +transformArray[3]
        };
    }
    return null;
}
function inverseTransform(rect, transform, transformOrigin) {
    const parsedTransform = parseTransform(transform);
    if (!parsedTransform) return rect;
    const { scaleX, scaleY, x: translateX, y: translateY } = parsedTransform;
    const x = rect.left - translateX - (1 - scaleX) * parseFloat(transformOrigin);
    const y = rect.top - translateY - (1 - scaleY) * parseFloat(transformOrigin.slice(transformOrigin.indexOf(' ') + 1));
    const w = scaleX ? rect.width / scaleX : rect.width;
    const h = scaleY ? rect.height / scaleY : rect.height;
    return {
        width: w,
        height: h,
        top: y,
        right: x + w,
        bottom: y + h,
        left: x
    };
}
const defaultOptions = {
    ignoreTransform: false
};
/**
 * Returns the bounding client rect of an element relative to the viewport.
 */ function getClientRect(element, options) {
    if (options === void 0) options = defaultOptions;
    let rect = element.getBoundingClientRect();
    if (options.ignoreTransform) {
        const { transform, transformOrigin } = (0, _utilities.getWindow)(element).getComputedStyle(element);
        if (transform) rect = inverseTransform(rect, transform, transformOrigin);
    }
    const { top, left, width, height, bottom, right } = rect;
    return {
        top,
        left,
        width,
        height,
        bottom,
        right
    };
}
/**
 * Returns the bounding client rect of an element relative to the viewport.
 *
 * @remarks
 * The ClientRect returned by this method does not take into account transforms
 * applied to the element it measures.
 *
 */ function getTransformAgnosticClientRect(element) {
    return getClientRect(element, {
        ignoreTransform: true
    });
}
function getWindowClientRect(element) {
    const width = element.innerWidth;
    const height = element.innerHeight;
    return {
        top: 0,
        left: 0,
        right: width,
        bottom: height,
        width,
        height
    };
}
function isFixed(node, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, _utilities.getWindow)(node).getComputedStyle(node);
    return computedStyle.position === 'fixed';
}
function isScrollable(element, computedStyle) {
    if (computedStyle === void 0) computedStyle = (0, _utilities.getWindow)(element).getComputedStyle(element);
    const overflowRegex = /(auto|scroll|overlay)/;
    const properties = [
        'overflow',
        'overflowX',
        'overflowY'
    ];
    return properties.some((property)=>{
        const value = computedStyle[property];
        return typeof value === 'string' ? overflowRegex.test(value) : false;
    });
}
function getScrollableAncestors(element, limit) {
    const scrollParents = [];
    function findScrollableAncestors(node) {
        if (limit != null && scrollParents.length >= limit) return scrollParents;
        if (!node) return scrollParents;
        if ((0, _utilities.isDocument)(node) && node.scrollingElement != null && !scrollParents.includes(node.scrollingElement)) {
            scrollParents.push(node.scrollingElement);
            return scrollParents;
        }
        if (!(0, _utilities.isHTMLElement)(node) || (0, _utilities.isSVGElement)(node)) return scrollParents;
        if (scrollParents.includes(node)) return scrollParents;
        const computedStyle = (0, _utilities.getWindow)(element).getComputedStyle(node);
        if (node !== element) {
            if (isScrollable(node, computedStyle)) scrollParents.push(node);
        }
        if (isFixed(node, computedStyle)) return scrollParents;
        return findScrollableAncestors(node.parentNode);
    }
    if (!element) return scrollParents;
    return findScrollableAncestors(element);
}
function getFirstScrollableAncestor(node) {
    const [firstScrollableAncestor] = getScrollableAncestors(node, 1);
    return firstScrollableAncestor != null ? firstScrollableAncestor : null;
}
function getScrollableElement(element) {
    if (!(0, _utilities.canUseDOM) || !element) return null;
    if ((0, _utilities.isWindow)(element)) return element;
    if (!(0, _utilities.isNode)(element)) return null;
    if ((0, _utilities.isDocument)(element) || element === (0, _utilities.getOwnerDocument)(element).scrollingElement) return window;
    if ((0, _utilities.isHTMLElement)(element)) return element;
    return null;
}
function getScrollXCoordinate(element) {
    if ((0, _utilities.isWindow)(element)) return element.scrollX;
    return element.scrollLeft;
}
function getScrollYCoordinate(element) {
    if ((0, _utilities.isWindow)(element)) return element.scrollY;
    return element.scrollTop;
}
function getScrollCoordinates(element) {
    return {
        x: getScrollXCoordinate(element),
        y: getScrollYCoordinate(element)
    };
}
var Direction;
(function(Direction) {
    Direction[Direction["Forward"] = 1] = "Forward";
    Direction[Direction["Backward"] = -1] = "Backward";
})(Direction || (Direction = {}));
function isDocumentScrollingElement(element) {
    if (!(0, _utilities.canUseDOM) || !element) return false;
    return element === document.scrollingElement;
}
function getScrollPosition(scrollingContainer) {
    const minScroll = {
        x: 0,
        y: 0
    };
    const dimensions = isDocumentScrollingElement(scrollingContainer) ? {
        height: window.innerHeight,
        width: window.innerWidth
    } : {
        height: scrollingContainer.clientHeight,
        width: scrollingContainer.clientWidth
    };
    const maxScroll = {
        x: scrollingContainer.scrollWidth - dimensions.width,
        y: scrollingContainer.scrollHeight - dimensions.height
    };
    const isTop = scrollingContainer.scrollTop <= minScroll.y;
    const isLeft = scrollingContainer.scrollLeft <= minScroll.x;
    const isBottom = scrollingContainer.scrollTop >= maxScroll.y;
    const isRight = scrollingContainer.scrollLeft >= maxScroll.x;
    return {
        isTop,
        isLeft,
        isBottom,
        isRight,
        maxScroll,
        minScroll
    };
}
const defaultThreshold = {
    x: 0.2,
    y: 0.2
};
function getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, _ref, acceleration, thresholdPercentage) {
    let { top, left, right, bottom } = _ref;
    if (acceleration === void 0) acceleration = 10;
    if (thresholdPercentage === void 0) thresholdPercentage = defaultThreshold;
    const { isTop, isBottom, isLeft, isRight } = getScrollPosition(scrollContainer);
    const direction = {
        x: 0,
        y: 0
    };
    const speed = {
        x: 0,
        y: 0
    };
    const threshold = {
        height: scrollContainerRect.height * thresholdPercentage.y,
        width: scrollContainerRect.width * thresholdPercentage.x
    };
    if (!isTop && top <= scrollContainerRect.top + threshold.height) {
        // Scroll Up
        direction.y = Direction.Backward;
        speed.y = acceleration * Math.abs((scrollContainerRect.top + threshold.height - top) / threshold.height);
    } else if (!isBottom && bottom >= scrollContainerRect.bottom - threshold.height) {
        // Scroll Down
        direction.y = Direction.Forward;
        speed.y = acceleration * Math.abs((scrollContainerRect.bottom - threshold.height - bottom) / threshold.height);
    }
    if (!isRight && right >= scrollContainerRect.right - threshold.width) {
        // Scroll Right
        direction.x = Direction.Forward;
        speed.x = acceleration * Math.abs((scrollContainerRect.right - threshold.width - right) / threshold.width);
    } else if (!isLeft && left <= scrollContainerRect.left + threshold.width) {
        // Scroll Left
        direction.x = Direction.Backward;
        speed.x = acceleration * Math.abs((scrollContainerRect.left + threshold.width - left) / threshold.width);
    }
    return {
        direction,
        speed
    };
}
function getScrollElementRect(element) {
    if (element === document.scrollingElement) {
        const { innerWidth, innerHeight } = window;
        return {
            top: 0,
            left: 0,
            right: innerWidth,
            bottom: innerHeight,
            width: innerWidth,
            height: innerHeight
        };
    }
    const { top, left, right, bottom } = element.getBoundingClientRect();
    return {
        top,
        left,
        right,
        bottom,
        width: element.clientWidth,
        height: element.clientHeight
    };
}
function getScrollOffsets(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return (0, _utilities.add)(acc, getScrollCoordinates(node));
    }, defaultCoordinates);
}
function getScrollXOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + getScrollXCoordinate(node);
    }, 0);
}
function getScrollYOffset(scrollableAncestors) {
    return scrollableAncestors.reduce((acc, node)=>{
        return acc + getScrollYCoordinate(node);
    }, 0);
}
function scrollIntoViewIfNeeded(element, measure) {
    if (measure === void 0) measure = getClientRect;
    if (!element) return;
    const { top, left, bottom, right } = measure(element);
    const firstScrollableAncestor = getFirstScrollableAncestor(element);
    if (!firstScrollableAncestor) return;
    if (bottom <= 0 || right <= 0 || top >= window.innerHeight || left >= window.innerWidth) element.scrollIntoView({
        block: 'center',
        inline: 'center'
    });
}
const properties = [
    [
        'x',
        [
            'left',
            'right'
        ],
        getScrollXOffset
    ],
    [
        'y',
        [
            'top',
            'bottom'
        ],
        getScrollYOffset
    ]
];
class Rect {
    constructor(rect, element){
        this.rect = void 0;
        this.width = void 0;
        this.height = void 0;
        this.top = void 0;
        this.bottom = void 0;
        this.right = void 0;
        this.left = void 0;
        const scrollableAncestors = getScrollableAncestors(element);
        const scrollOffsets = getScrollOffsets(scrollableAncestors);
        this.rect = {
            ...rect
        };
        this.width = rect.width;
        this.height = rect.height;
        for (const [axis, keys, getScrollOffset] of properties)for (const key of keys)Object.defineProperty(this, key, {
            get: ()=>{
                const currentOffsets = getScrollOffset(scrollableAncestors);
                const scrollOffsetsDeltla = scrollOffsets[axis] - currentOffsets;
                return this.rect[key] + scrollOffsetsDeltla;
            },
            enumerable: true
        });
        Object.defineProperty(this, 'rect', {
            enumerable: false
        });
    }
}
class Listeners {
    constructor(target){
        this.target = void 0;
        this.listeners = [];
        this.removeAll = ()=>{
            this.listeners.forEach((listener)=>{
                var _this$target;
                return (_this$target = this.target) == null ? void 0 : _this$target.removeEventListener(...listener);
            });
        };
        this.target = target;
    }
    add(eventName, handler, options) {
        var _this$target2;
        (_this$target2 = this.target) == null || _this$target2.addEventListener(eventName, handler, options);
        this.listeners.push([
            eventName,
            handler,
            options
        ]);
    }
}
function getEventListenerTarget(target) {
    // If the `event.target` element is removed from the document events will still be targeted
    // at it, and hence won't always bubble up to the window or document anymore.
    // If there is any risk of an element being removed while it is being dragged,
    // the best practice is to attach the event listeners directly to the target.
    // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget
    const { EventTarget } = (0, _utilities.getWindow)(target);
    return target instanceof EventTarget ? target : (0, _utilities.getOwnerDocument)(target);
}
function hasExceededDistance(delta, measurement) {
    const dx = Math.abs(delta.x);
    const dy = Math.abs(delta.y);
    if (typeof measurement === 'number') return Math.sqrt(dx ** 2 + dy ** 2) > measurement;
    if ('x' in measurement && 'y' in measurement) return dx > measurement.x && dy > measurement.y;
    if ('x' in measurement) return dx > measurement.x;
    if ('y' in measurement) return dy > measurement.y;
    return false;
}
var EventName;
(function(EventName) {
    EventName["Click"] = "click";
    EventName["DragStart"] = "dragstart";
    EventName["Keydown"] = "keydown";
    EventName["ContextMenu"] = "contextmenu";
    EventName["Resize"] = "resize";
    EventName["SelectionChange"] = "selectionchange";
    EventName["VisibilityChange"] = "visibilitychange";
})(EventName || (EventName = {}));
function preventDefault(event) {
    event.preventDefault();
}
function stopPropagation(event) {
    event.stopPropagation();
}
var KeyboardCode;
(function(KeyboardCode) {
    KeyboardCode["Space"] = "Space";
    KeyboardCode["Down"] = "ArrowDown";
    KeyboardCode["Right"] = "ArrowRight";
    KeyboardCode["Left"] = "ArrowLeft";
    KeyboardCode["Up"] = "ArrowUp";
    KeyboardCode["Esc"] = "Escape";
    KeyboardCode["Enter"] = "Enter";
    KeyboardCode["Tab"] = "Tab";
})(KeyboardCode || (KeyboardCode = {}));
const defaultKeyboardCodes = {
    start: [
        KeyboardCode.Space,
        KeyboardCode.Enter
    ],
    cancel: [
        KeyboardCode.Esc
    ],
    end: [
        KeyboardCode.Space,
        KeyboardCode.Enter,
        KeyboardCode.Tab
    ]
};
const defaultKeyboardCoordinateGetter = (event, _ref)=>{
    let { currentCoordinates } = _ref;
    switch(event.code){
        case KeyboardCode.Right:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x + 25
            };
        case KeyboardCode.Left:
            return {
                ...currentCoordinates,
                x: currentCoordinates.x - 25
            };
        case KeyboardCode.Down:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y + 25
            };
        case KeyboardCode.Up:
            return {
                ...currentCoordinates,
                y: currentCoordinates.y - 25
            };
    }
    return undefined;
};
class KeyboardSensor {
    constructor(props){
        this.props = void 0;
        this.autoScrollEnabled = false;
        this.referenceCoordinates = void 0;
        this.listeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        const { event: { target } } = props;
        this.props = props;
        this.listeners = new Listeners((0, _utilities.getOwnerDocument)(target));
        this.windowListeners = new Listeners((0, _utilities.getWindow)(target));
        this.handleKeyDown = this.handleKeyDown.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.attach();
    }
    attach() {
        this.handleStart();
        this.windowListeners.add(EventName.Resize, this.handleCancel);
        this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
        setTimeout(()=>this.listeners.add(EventName.Keydown, this.handleKeyDown));
    }
    handleStart() {
        const { activeNode, onStart } = this.props;
        const node = activeNode.node.current;
        if (node) scrollIntoViewIfNeeded(node);
        onStart(defaultCoordinates);
    }
    handleKeyDown(event) {
        if ((0, _utilities.isKeyboardEvent)(event)) {
            const { active, context, options } = this.props;
            const { keyboardCodes = defaultKeyboardCodes, coordinateGetter = defaultKeyboardCoordinateGetter, scrollBehavior = 'smooth' } = options;
            const { code } = event;
            if (keyboardCodes.end.includes(code)) {
                this.handleEnd(event);
                return;
            }
            if (keyboardCodes.cancel.includes(code)) {
                this.handleCancel(event);
                return;
            }
            const { collisionRect } = context.current;
            const currentCoordinates = collisionRect ? {
                x: collisionRect.left,
                y: collisionRect.top
            } : defaultCoordinates;
            if (!this.referenceCoordinates) this.referenceCoordinates = currentCoordinates;
            const newCoordinates = coordinateGetter(event, {
                active,
                context: context.current,
                currentCoordinates
            });
            if (newCoordinates) {
                const coordinatesDelta = (0, _utilities.subtract)(newCoordinates, currentCoordinates);
                const scrollDelta = {
                    x: 0,
                    y: 0
                };
                const { scrollableAncestors } = context.current;
                for (const scrollContainer of scrollableAncestors){
                    const direction = event.code;
                    const { isTop, isRight, isLeft, isBottom, maxScroll, minScroll } = getScrollPosition(scrollContainer);
                    const scrollElementRect = getScrollElementRect(scrollContainer);
                    const clampedCoordinates = {
                        x: Math.min(direction === KeyboardCode.Right ? scrollElementRect.right - scrollElementRect.width / 2 : scrollElementRect.right, Math.max(direction === KeyboardCode.Right ? scrollElementRect.left : scrollElementRect.left + scrollElementRect.width / 2, newCoordinates.x)),
                        y: Math.min(direction === KeyboardCode.Down ? scrollElementRect.bottom - scrollElementRect.height / 2 : scrollElementRect.bottom, Math.max(direction === KeyboardCode.Down ? scrollElementRect.top : scrollElementRect.top + scrollElementRect.height / 2, newCoordinates.y))
                    };
                    const canScrollX = direction === KeyboardCode.Right && !isRight || direction === KeyboardCode.Left && !isLeft;
                    const canScrollY = direction === KeyboardCode.Down && !isBottom || direction === KeyboardCode.Up && !isTop;
                    if (canScrollX && clampedCoordinates.x !== newCoordinates.x) {
                        const newScrollCoordinates = scrollContainer.scrollLeft + coordinatesDelta.x;
                        const canScrollToNewCoordinates = direction === KeyboardCode.Right && newScrollCoordinates <= maxScroll.x || direction === KeyboardCode.Left && newScrollCoordinates >= minScroll.x;
                        if (canScrollToNewCoordinates && !coordinatesDelta.y) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                left: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.x = scrollContainer.scrollLeft - newScrollCoordinates;
                        else scrollDelta.x = direction === KeyboardCode.Right ? scrollContainer.scrollLeft - maxScroll.x : scrollContainer.scrollLeft - minScroll.x;
                        if (scrollDelta.x) scrollContainer.scrollBy({
                            left: -scrollDelta.x,
                            behavior: scrollBehavior
                        });
                        break;
                    } else if (canScrollY && clampedCoordinates.y !== newCoordinates.y) {
                        const newScrollCoordinates = scrollContainer.scrollTop + coordinatesDelta.y;
                        const canScrollToNewCoordinates = direction === KeyboardCode.Down && newScrollCoordinates <= maxScroll.y || direction === KeyboardCode.Up && newScrollCoordinates >= minScroll.y;
                        if (canScrollToNewCoordinates && !coordinatesDelta.x) {
                            // We don't need to update coordinates, the scroll adjustment alone will trigger
                            // logic to auto-detect the new container we are over
                            scrollContainer.scrollTo({
                                top: newScrollCoordinates,
                                behavior: scrollBehavior
                            });
                            return;
                        }
                        if (canScrollToNewCoordinates) scrollDelta.y = scrollContainer.scrollTop - newScrollCoordinates;
                        else scrollDelta.y = direction === KeyboardCode.Down ? scrollContainer.scrollTop - maxScroll.y : scrollContainer.scrollTop - minScroll.y;
                        if (scrollDelta.y) scrollContainer.scrollBy({
                            top: -scrollDelta.y,
                            behavior: scrollBehavior
                        });
                        break;
                    }
                }
                this.handleMove(event, (0, _utilities.add)((0, _utilities.subtract)(newCoordinates, this.referenceCoordinates), scrollDelta));
            }
        }
    }
    handleMove(event, coordinates) {
        const { onMove } = this.props;
        event.preventDefault();
        onMove(coordinates);
    }
    handleEnd(event) {
        const { onEnd } = this.props;
        event.preventDefault();
        this.detach();
        onEnd();
    }
    handleCancel(event) {
        const { onCancel } = this.props;
        event.preventDefault();
        this.detach();
        onCancel();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll();
    }
}
KeyboardSensor.activators = [
    {
        eventName: 'onKeyDown',
        handler: (event, _ref, _ref2)=>{
            let { keyboardCodes = defaultKeyboardCodes, onActivation } = _ref;
            let { active } = _ref2;
            const { code } = event.nativeEvent;
            if (keyboardCodes.start.includes(code)) {
                const activator = active.activatorNode.current;
                if (activator && event.target !== activator) return false;
                event.preventDefault();
                onActivation == null || onActivation({
                    event: event.nativeEvent
                });
                return true;
            }
            return false;
        }
    }
];
function isDistanceConstraint(constraint) {
    return Boolean(constraint && 'distance' in constraint);
}
function isDelayConstraint(constraint) {
    return Boolean(constraint && 'delay' in constraint);
}
class AbstractPointerSensor {
    constructor(props, events, listenerTarget){
        var _getEventCoordinates;
        if (listenerTarget === void 0) listenerTarget = getEventListenerTarget(props.event.target);
        this.props = void 0;
        this.events = void 0;
        this.autoScrollEnabled = true;
        this.document = void 0;
        this.activated = false;
        this.initialCoordinates = void 0;
        this.timeoutId = null;
        this.listeners = void 0;
        this.documentListeners = void 0;
        this.windowListeners = void 0;
        this.props = props;
        this.events = events;
        const { event } = props;
        const { target } = event;
        this.props = props;
        this.events = events;
        this.document = (0, _utilities.getOwnerDocument)(target);
        this.documentListeners = new Listeners(this.document);
        this.listeners = new Listeners(listenerTarget);
        this.windowListeners = new Listeners((0, _utilities.getWindow)(target));
        this.initialCoordinates = (_getEventCoordinates = (0, _utilities.getEventCoordinates)(event)) != null ? _getEventCoordinates : defaultCoordinates;
        this.handleStart = this.handleStart.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleEnd = this.handleEnd.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleKeydown = this.handleKeydown.bind(this);
        this.removeTextSelection = this.removeTextSelection.bind(this);
        this.attach();
    }
    attach() {
        const { events, props: { options: { activationConstraint, bypassActivationConstraint } } } = this;
        this.listeners.add(events.move.name, this.handleMove, {
            passive: false
        });
        this.listeners.add(events.end.name, this.handleEnd);
        if (events.cancel) this.listeners.add(events.cancel.name, this.handleCancel);
        this.windowListeners.add(EventName.Resize, this.handleCancel);
        this.windowListeners.add(EventName.DragStart, preventDefault);
        this.windowListeners.add(EventName.VisibilityChange, this.handleCancel);
        this.windowListeners.add(EventName.ContextMenu, preventDefault);
        this.documentListeners.add(EventName.Keydown, this.handleKeydown);
        if (activationConstraint) {
            if (bypassActivationConstraint != null && bypassActivationConstraint({
                event: this.props.event,
                activeNode: this.props.activeNode,
                options: this.props.options
            })) return this.handleStart();
            if (isDelayConstraint(activationConstraint)) {
                this.timeoutId = setTimeout(this.handleStart, activationConstraint.delay);
                this.handlePending(activationConstraint);
                return;
            }
            if (isDistanceConstraint(activationConstraint)) {
                this.handlePending(activationConstraint);
                return;
            }
        }
        this.handleStart();
    }
    detach() {
        this.listeners.removeAll();
        this.windowListeners.removeAll(); // Wait until the next event loop before removing document listeners
        // This is necessary because we listen for `click` and `selection` events on the document
        setTimeout(this.documentListeners.removeAll, 50);
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
            this.timeoutId = null;
        }
    }
    handlePending(constraint, offset) {
        const { active, onPending } = this.props;
        onPending(active, constraint, this.initialCoordinates, offset);
    }
    handleStart() {
        const { initialCoordinates } = this;
        const { onStart } = this.props;
        if (initialCoordinates) {
            this.activated = true; // Stop propagation of click events once activation constraints are met
            this.documentListeners.add(EventName.Click, stopPropagation, {
                capture: true
            }); // Remove any text selection from the document
            this.removeTextSelection(); // Prevent further text selection while dragging
            this.documentListeners.add(EventName.SelectionChange, this.removeTextSelection);
            onStart(initialCoordinates);
        }
    }
    handleMove(event) {
        var _getEventCoordinates2;
        const { activated, initialCoordinates, props } = this;
        const { onMove, options: { activationConstraint } } = props;
        if (!initialCoordinates) return;
        const coordinates = (_getEventCoordinates2 = (0, _utilities.getEventCoordinates)(event)) != null ? _getEventCoordinates2 : defaultCoordinates;
        const delta = (0, _utilities.subtract)(initialCoordinates, coordinates); // Constraint validation
        if (!activated && activationConstraint) {
            if (isDistanceConstraint(activationConstraint)) {
                if (activationConstraint.tolerance != null && hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
                if (hasExceededDistance(delta, activationConstraint.distance)) return this.handleStart();
            }
            if (isDelayConstraint(activationConstraint)) {
                if (hasExceededDistance(delta, activationConstraint.tolerance)) return this.handleCancel();
            }
            this.handlePending(activationConstraint, delta);
            return;
        }
        if (event.cancelable) event.preventDefault();
        onMove(coordinates);
    }
    handleEnd() {
        const { onAbort, onEnd } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onEnd();
    }
    handleCancel() {
        const { onAbort, onCancel } = this.props;
        this.detach();
        if (!this.activated) onAbort(this.props.active);
        onCancel();
    }
    handleKeydown(event) {
        if (event.code === KeyboardCode.Esc) this.handleCancel();
    }
    removeTextSelection() {
        var _this$document$getSel;
        (_this$document$getSel = this.document.getSelection()) == null || _this$document$getSel.removeAllRanges();
    }
}
const events = {
    cancel: {
        name: 'pointercancel'
    },
    move: {
        name: 'pointermove'
    },
    end: {
        name: 'pointerup'
    }
};
class PointerSensor extends AbstractPointerSensor {
    constructor(props){
        const { event } = props; // Pointer events stop firing if the target is unmounted while dragging
        // Therefore we attach listeners to the owner document instead
        const listenerTarget = (0, _utilities.getOwnerDocument)(event.target);
        super(props, events, listenerTarget);
    }
}
PointerSensor.activators = [
    {
        eventName: 'onPointerDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation } = _ref2;
            if (!event.isPrimary || event.button !== 0) return false;
            onActivation == null || onActivation({
                event
            });
            return true;
        }
    }
];
const events$1 = {
    move: {
        name: 'mousemove'
    },
    end: {
        name: 'mouseup'
    }
};
var MouseButton;
(function(MouseButton) {
    MouseButton[MouseButton["RightClick"] = 2] = "RightClick";
})(MouseButton || (MouseButton = {}));
class MouseSensor extends AbstractPointerSensor {
    constructor(props){
        super(props, events$1, (0, _utilities.getOwnerDocument)(props.event.target));
    }
}
MouseSensor.activators = [
    {
        eventName: 'onMouseDown',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation } = _ref2;
            if (event.button === MouseButton.RightClick) return false;
            onActivation == null || onActivation({
                event
            });
            return true;
        }
    }
];
const events$2 = {
    cancel: {
        name: 'touchcancel'
    },
    move: {
        name: 'touchmove'
    },
    end: {
        name: 'touchend'
    }
};
class TouchSensor extends AbstractPointerSensor {
    constructor(props){
        super(props, events$2);
    }
    static setup() {
        // Adding a non-capture and non-passive `touchmove` listener in order
        // to force `event.preventDefault()` calls to work in dynamically added
        // touchmove event handlers. This is required for iOS Safari.
        window.addEventListener(events$2.move.name, noop, {
            capture: false,
            passive: false
        });
        return function teardown() {
            window.removeEventListener(events$2.move.name, noop);
        }; // We create a new handler because the teardown function of another sensor
        // could remove our event listener if we use a referentially equal listener.
        function noop() {}
    }
}
TouchSensor.activators = [
    {
        eventName: 'onTouchStart',
        handler: (_ref, _ref2)=>{
            let { nativeEvent: event } = _ref;
            let { onActivation } = _ref2;
            const { touches } = event;
            if (touches.length > 1) return false;
            onActivation == null || onActivation({
                event
            });
            return true;
        }
    }
];
var AutoScrollActivator;
(function(AutoScrollActivator) {
    AutoScrollActivator[AutoScrollActivator["Pointer"] = 0] = "Pointer";
    AutoScrollActivator[AutoScrollActivator["DraggableRect"] = 1] = "DraggableRect";
})(AutoScrollActivator || (AutoScrollActivator = {}));
var TraversalOrder;
(function(TraversalOrder) {
    TraversalOrder[TraversalOrder["TreeOrder"] = 0] = "TreeOrder";
    TraversalOrder[TraversalOrder["ReversedTreeOrder"] = 1] = "ReversedTreeOrder";
})(TraversalOrder || (TraversalOrder = {}));
function useAutoScroller(_ref) {
    let { acceleration, activator = AutoScrollActivator.Pointer, canScroll, draggingRect, enabled, interval = 5, order = TraversalOrder.TreeOrder, pointerCoordinates, scrollableAncestors, scrollableAncestorRects, delta, threshold } = _ref;
    const scrollIntent = useScrollIntent({
        delta,
        disabled: !enabled
    });
    const [setAutoScrollInterval, clearAutoScrollInterval] = (0, _utilities.useInterval)();
    const scrollSpeed = (0, _react.useRef)({
        x: 0,
        y: 0
    });
    const scrollDirection = (0, _react.useRef)({
        x: 0,
        y: 0
    });
    const rect = (0, _react.useMemo)(()=>{
        switch(activator){
            case AutoScrollActivator.Pointer:
                return pointerCoordinates ? {
                    top: pointerCoordinates.y,
                    bottom: pointerCoordinates.y,
                    left: pointerCoordinates.x,
                    right: pointerCoordinates.x
                } : null;
            case AutoScrollActivator.DraggableRect:
                return draggingRect;
        }
    }, [
        activator,
        draggingRect,
        pointerCoordinates
    ]);
    const scrollContainerRef = (0, _react.useRef)(null);
    const autoScroll = (0, _react.useCallback)(()=>{
        const scrollContainer = scrollContainerRef.current;
        if (!scrollContainer) return;
        const scrollLeft = scrollSpeed.current.x * scrollDirection.current.x;
        const scrollTop = scrollSpeed.current.y * scrollDirection.current.y;
        scrollContainer.scrollBy(scrollLeft, scrollTop);
    }, []);
    const sortedScrollableAncestors = (0, _react.useMemo)(()=>order === TraversalOrder.TreeOrder ? [
            ...scrollableAncestors
        ].reverse() : scrollableAncestors, [
        order,
        scrollableAncestors
    ]);
    (0, _react.useEffect)(()=>{
        if (!enabled || !scrollableAncestors.length || !rect) {
            clearAutoScrollInterval();
            return;
        }
        for (const scrollContainer of sortedScrollableAncestors){
            if ((canScroll == null ? void 0 : canScroll(scrollContainer)) === false) continue;
            const index = scrollableAncestors.indexOf(scrollContainer);
            const scrollContainerRect = scrollableAncestorRects[index];
            if (!scrollContainerRect) continue;
            const { direction, speed } = getScrollDirectionAndSpeed(scrollContainer, scrollContainerRect, rect, acceleration, threshold);
            for (const axis of [
                'x',
                'y'
            ])if (!scrollIntent[axis][direction[axis]]) {
                speed[axis] = 0;
                direction[axis] = 0;
            }
            if (speed.x > 0 || speed.y > 0) {
                clearAutoScrollInterval();
                scrollContainerRef.current = scrollContainer;
                setAutoScrollInterval(autoScroll, interval);
                scrollSpeed.current = speed;
                scrollDirection.current = direction;
                return;
            }
        }
        scrollSpeed.current = {
            x: 0,
            y: 0
        };
        scrollDirection.current = {
            x: 0,
            y: 0
        };
        clearAutoScrollInterval();
    }, [
        acceleration,
        autoScroll,
        canScroll,
        clearAutoScrollInterval,
        enabled,
        interval,
        JSON.stringify(rect),
        JSON.stringify(scrollIntent),
        setAutoScrollInterval,
        scrollableAncestors,
        sortedScrollableAncestors,
        scrollableAncestorRects,
        JSON.stringify(threshold)
    ]);
}
const defaultScrollIntent = {
    x: {
        [Direction.Backward]: false,
        [Direction.Forward]: false
    },
    y: {
        [Direction.Backward]: false,
        [Direction.Forward]: false
    }
};
function useScrollIntent(_ref2) {
    let { delta, disabled } = _ref2;
    const previousDelta = (0, _utilities.usePrevious)(delta);
    return (0, _utilities.useLazyMemo)((previousIntent)=>{
        if (disabled || !previousDelta || !previousIntent) // Reset scroll intent tracking when auto-scrolling is disabled
        return defaultScrollIntent;
        const direction = {
            x: Math.sign(delta.x - previousDelta.x),
            y: Math.sign(delta.y - previousDelta.y)
        }; // Keep track of the user intent to scroll in each direction for both axis
        return {
            x: {
                [Direction.Backward]: previousIntent.x[Direction.Backward] || direction.x === -1,
                [Direction.Forward]: previousIntent.x[Direction.Forward] || direction.x === 1
            },
            y: {
                [Direction.Backward]: previousIntent.y[Direction.Backward] || direction.y === -1,
                [Direction.Forward]: previousIntent.y[Direction.Forward] || direction.y === 1
            }
        };
    }, [
        disabled,
        delta,
        previousDelta
    ]);
}
function useCachedNode(draggableNodes, id) {
    const draggableNode = id != null ? draggableNodes.get(id) : undefined;
    const node = draggableNode ? draggableNode.node.current : null;
    return (0, _utilities.useLazyMemo)((cachedNode)=>{
        var _ref;
        if (id == null) return null;
         // In some cases, the draggable node can unmount while dragging
        // This is the case for virtualized lists. In those situations,
        // we fall back to the last known value for that node.
        return (_ref = node != null ? node : cachedNode) != null ? _ref : null;
    }, [
        node,
        id
    ]);
}
function useCombineActivators(sensors, getSyntheticHandler) {
    return (0, _react.useMemo)(()=>sensors.reduce((accumulator, sensor)=>{
            const { sensor: Sensor } = sensor;
            const sensorActivators = Sensor.activators.map((activator)=>({
                    eventName: activator.eventName,
                    handler: getSyntheticHandler(activator.handler, sensor)
                }));
            return [
                ...accumulator,
                ...sensorActivators
            ];
        }, []), [
        sensors,
        getSyntheticHandler
    ]);
}
var MeasuringStrategy;
(function(MeasuringStrategy) {
    MeasuringStrategy[MeasuringStrategy["Always"] = 0] = "Always";
    MeasuringStrategy[MeasuringStrategy["BeforeDragging"] = 1] = "BeforeDragging";
    MeasuringStrategy[MeasuringStrategy["WhileDragging"] = 2] = "WhileDragging";
})(MeasuringStrategy || (MeasuringStrategy = {}));
var MeasuringFrequency;
(function(MeasuringFrequency) {
    MeasuringFrequency["Optimized"] = "optimized";
})(MeasuringFrequency || (MeasuringFrequency = {}));
const defaultValue = /*#__PURE__*/ new Map();
function useDroppableMeasuring(containers, _ref) {
    let { dragging, dependencies, config } = _ref;
    const [queue, setQueue] = (0, _react.useState)(null);
    const { frequency, measure, strategy } = config;
    const containersRef = (0, _react.useRef)(containers);
    const disabled = isDisabled();
    const disabledRef = (0, _utilities.useLatestValue)(disabled);
    const measureDroppableContainers = (0, _react.useCallback)(function(ids) {
        if (ids === void 0) ids = [];
        if (disabledRef.current) return;
        setQueue((value)=>{
            if (value === null) return ids;
            return value.concat(ids.filter((id)=>!value.includes(id)));
        });
    }, [
        disabledRef
    ]);
    const timeoutId = (0, _react.useRef)(null);
    const droppableRects = (0, _utilities.useLazyMemo)((previousValue)=>{
        if (disabled && !dragging) return defaultValue;
        if (!previousValue || previousValue === defaultValue || containersRef.current !== containers || queue != null) {
            const map = new Map();
            for (let container of containers){
                if (!container) continue;
                if (queue && queue.length > 0 && !queue.includes(container.id) && container.rect.current) {
                    // This container does not need to be re-measured
                    map.set(container.id, container.rect.current);
                    continue;
                }
                const node = container.node.current;
                const rect = node ? new Rect(measure(node), node) : null;
                container.rect.current = rect;
                if (rect) map.set(container.id, rect);
            }
            return map;
        }
        return previousValue;
    }, [
        containers,
        queue,
        dragging,
        disabled,
        measure
    ]);
    (0, _react.useEffect)(()=>{
        containersRef.current = containers;
    }, [
        containers
    ]);
    (0, _react.useEffect)(()=>{
        if (disabled) return;
        measureDroppableContainers();
    }, [
        dragging,
        disabled
    ]);
    (0, _react.useEffect)(()=>{
        if (queue && queue.length > 0) setQueue(null);
    }, [
        JSON.stringify(queue)
    ]);
    (0, _react.useEffect)(()=>{
        if (disabled || typeof frequency !== 'number' || timeoutId.current !== null) return;
        timeoutId.current = setTimeout(()=>{
            measureDroppableContainers();
            timeoutId.current = null;
        }, frequency);
    }, [
        frequency,
        disabled,
        measureDroppableContainers,
        ...dependencies
    ]);
    return {
        droppableRects,
        measureDroppableContainers,
        measuringScheduled: queue != null
    };
    function isDisabled() {
        switch(strategy){
            case MeasuringStrategy.Always:
                return false;
            case MeasuringStrategy.BeforeDragging:
                return dragging;
            default:
                return !dragging;
        }
    }
}
function useInitialValue(value, computeFn) {
    return (0, _utilities.useLazyMemo)((previousValue)=>{
        if (!value) return null;
        if (previousValue) return previousValue;
        return typeof computeFn === 'function' ? computeFn(value) : value;
    }, [
        computeFn,
        value
    ]);
}
function useInitialRect(node, measure) {
    return useInitialValue(node, measure);
}
/**
 * Returns a new MutationObserver instance.
 * If `MutationObserver` is undefined in the execution environment, returns `undefined`.
 */ function useMutationObserver(_ref) {
    let { callback, disabled } = _ref;
    const handleMutations = (0, _utilities.useEvent)(callback);
    const mutationObserver = (0, _react.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.MutationObserver === 'undefined') return undefined;
        const { MutationObserver } = window;
        return new MutationObserver(handleMutations);
    }, [
        handleMutations,
        disabled
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>mutationObserver == null ? void 0 : mutationObserver.disconnect();
    }, [
        mutationObserver
    ]);
    return mutationObserver;
}
/**
 * Returns a new ResizeObserver instance bound to the `onResize` callback.
 * If `ResizeObserver` is undefined in the execution environment, returns `undefined`.
 */ function useResizeObserver(_ref) {
    let { callback, disabled } = _ref;
    const handleResize = (0, _utilities.useEvent)(callback);
    const resizeObserver = (0, _react.useMemo)(()=>{
        if (disabled || typeof window === 'undefined' || typeof window.ResizeObserver === 'undefined') return undefined;
        const { ResizeObserver } = window;
        return new ResizeObserver(handleResize);
    }, [
        disabled
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>resizeObserver == null ? void 0 : resizeObserver.disconnect();
    }, [
        resizeObserver
    ]);
    return resizeObserver;
}
function defaultMeasure(element) {
    return new Rect(getClientRect(element), element);
}
function useRect(element, measure, fallbackRect) {
    if (measure === void 0) measure = defaultMeasure;
    const [rect, setRect] = (0, _react.useState)(null);
    function measureRect() {
        setRect((currentRect)=>{
            if (!element) return null;
            if (element.isConnected === false) {
                var _ref;
                // Fall back to last rect we measured if the element is
                // no longer connected to the DOM.
                return (_ref = currentRect != null ? currentRect : fallbackRect) != null ? _ref : null;
            }
            const newRect = measure(element);
            if (JSON.stringify(currentRect) === JSON.stringify(newRect)) return currentRect;
            return newRect;
        });
    }
    const mutationObserver = useMutationObserver({
        callback (records) {
            if (!element) return;
            for (const record of records){
                const { type, target } = record;
                if (type === 'childList' && target instanceof HTMLElement && target.contains(element)) {
                    measureRect();
                    break;
                }
            }
        }
    });
    const resizeObserver = useResizeObserver({
        callback: measureRect
    });
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        measureRect();
        if (element) {
            resizeObserver == null || resizeObserver.observe(element);
            mutationObserver == null || mutationObserver.observe(document.body, {
                childList: true,
                subtree: true
            });
        } else {
            resizeObserver == null || resizeObserver.disconnect();
            mutationObserver == null || mutationObserver.disconnect();
        }
    }, [
        element
    ]);
    return rect;
}
function useRectDelta(rect) {
    const initialRect = useInitialValue(rect);
    return getRectDelta(rect, initialRect);
}
const defaultValue$1 = [];
function useScrollableAncestors(node) {
    const previousNode = (0, _react.useRef)(node);
    const ancestors = (0, _utilities.useLazyMemo)((previousValue)=>{
        if (!node) return defaultValue$1;
        if (previousValue && previousValue !== defaultValue$1 && node && previousNode.current && node.parentNode === previousNode.current.parentNode) return previousValue;
        return getScrollableAncestors(node);
    }, [
        node
    ]);
    (0, _react.useEffect)(()=>{
        previousNode.current = node;
    }, [
        node
    ]);
    return ancestors;
}
function useScrollOffsets(elements) {
    const [scrollCoordinates, setScrollCoordinates] = (0, _react.useState)(null);
    const prevElements = (0, _react.useRef)(elements); // To-do: Throttle the handleScroll callback
    const handleScroll = (0, _react.useCallback)((event)=>{
        const scrollingElement = getScrollableElement(event.target);
        if (!scrollingElement) return;
        setScrollCoordinates((scrollCoordinates)=>{
            if (!scrollCoordinates) return null;
            scrollCoordinates.set(scrollingElement, getScrollCoordinates(scrollingElement));
            return new Map(scrollCoordinates);
        });
    }, []);
    (0, _react.useEffect)(()=>{
        const previousElements = prevElements.current;
        if (elements !== previousElements) {
            cleanup(previousElements);
            const entries = elements.map((element)=>{
                const scrollableElement = getScrollableElement(element);
                if (scrollableElement) {
                    scrollableElement.addEventListener('scroll', handleScroll, {
                        passive: true
                    });
                    return [
                        scrollableElement,
                        getScrollCoordinates(scrollableElement)
                    ];
                }
                return null;
            }).filter((entry)=>entry != null);
            setScrollCoordinates(entries.length ? new Map(entries) : null);
            prevElements.current = elements;
        }
        return ()=>{
            cleanup(elements);
            cleanup(previousElements);
        };
        function cleanup(elements) {
            elements.forEach((element)=>{
                const scrollableElement = getScrollableElement(element);
                scrollableElement == null || scrollableElement.removeEventListener('scroll', handleScroll);
            });
        }
    }, [
        handleScroll,
        elements
    ]);
    return (0, _react.useMemo)(()=>{
        if (elements.length) return scrollCoordinates ? Array.from(scrollCoordinates.values()).reduce((acc, coordinates)=>(0, _utilities.add)(acc, coordinates), defaultCoordinates) : getScrollOffsets(elements);
        return defaultCoordinates;
    }, [
        elements,
        scrollCoordinates
    ]);
}
function useScrollOffsetsDelta(scrollOffsets, dependencies) {
    if (dependencies === void 0) dependencies = [];
    const initialScrollOffsets = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        initialScrollOffsets.current = null;
    }, dependencies);
    (0, _react.useEffect)(()=>{
        const hasScrollOffsets = scrollOffsets !== defaultCoordinates;
        if (hasScrollOffsets && !initialScrollOffsets.current) initialScrollOffsets.current = scrollOffsets;
        if (!hasScrollOffsets && initialScrollOffsets.current) initialScrollOffsets.current = null;
    }, [
        scrollOffsets
    ]);
    return initialScrollOffsets.current ? (0, _utilities.subtract)(scrollOffsets, initialScrollOffsets.current) : defaultCoordinates;
}
function useSensorSetup(sensors) {
    (0, _react.useEffect)(()=>{
        if (!(0, _utilities.canUseDOM)) return;
        const teardownFns = sensors.map((_ref)=>{
            let { sensor } = _ref;
            return sensor.setup == null ? void 0 : sensor.setup();
        });
        return ()=>{
            for (const teardown of teardownFns)teardown == null || teardown();
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    sensors.map((_ref2)=>{
        let { sensor } = _ref2;
        return sensor;
    }));
}
function useSyntheticListeners(listeners, id) {
    return (0, _react.useMemo)(()=>{
        return listeners.reduce((acc, _ref)=>{
            let { eventName, handler } = _ref;
            acc[eventName] = (event)=>{
                handler(event, id);
            };
            return acc;
        }, {});
    }, [
        listeners,
        id
    ]);
}
function useWindowRect(element) {
    return (0, _react.useMemo)(()=>element ? getWindowClientRect(element) : null, [
        element
    ]);
}
const defaultValue$2 = [];
function useRects(elements, measure) {
    if (measure === void 0) measure = getClientRect;
    const [firstElement] = elements;
    const windowRect = useWindowRect(firstElement ? (0, _utilities.getWindow)(firstElement) : null);
    const [rects, setRects] = (0, _react.useState)(defaultValue$2);
    function measureRects() {
        setRects(()=>{
            if (!elements.length) return defaultValue$2;
            return elements.map((element)=>isDocumentScrollingElement(element) ? windowRect : new Rect(measure(element), element));
        });
    }
    const resizeObserver = useResizeObserver({
        callback: measureRects
    });
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        resizeObserver == null || resizeObserver.disconnect();
        measureRects();
        elements.forEach((element)=>resizeObserver == null ? void 0 : resizeObserver.observe(element));
    }, [
        elements
    ]);
    return rects;
}
function getMeasurableNode(node) {
    if (!node) return null;
    if (node.children.length > 1) return node;
    const firstChild = node.children[0];
    return (0, _utilities.isHTMLElement)(firstChild) ? firstChild : node;
}
function useDragOverlayMeasuring(_ref) {
    let { measure } = _ref;
    const [rect, setRect] = (0, _react.useState)(null);
    const handleResize = (0, _react.useCallback)((entries)=>{
        for (const { target } of entries)if ((0, _utilities.isHTMLElement)(target)) {
            setRect((rect)=>{
                const newRect = measure(target);
                return rect ? {
                    ...rect,
                    width: newRect.width,
                    height: newRect.height
                } : newRect;
            });
            break;
        }
    }, [
        measure
    ]);
    const resizeObserver = useResizeObserver({
        callback: handleResize
    });
    const handleNodeChange = (0, _react.useCallback)((element)=>{
        const node = getMeasurableNode(element);
        resizeObserver == null || resizeObserver.disconnect();
        if (node) resizeObserver == null || resizeObserver.observe(node);
        setRect(node ? measure(node) : null);
    }, [
        measure,
        resizeObserver
    ]);
    const [nodeRef, setRef] = (0, _utilities.useNodeRef)(handleNodeChange);
    return (0, _react.useMemo)(()=>({
            nodeRef,
            rect,
            setRef
        }), [
        rect,
        nodeRef,
        setRef
    ]);
}
const defaultSensors = [
    {
        sensor: PointerSensor,
        options: {}
    },
    {
        sensor: KeyboardSensor,
        options: {}
    }
];
const defaultData = {
    current: {}
};
const defaultMeasuringConfiguration = {
    draggable: {
        measure: getTransformAgnosticClientRect
    },
    droppable: {
        measure: getTransformAgnosticClientRect,
        strategy: MeasuringStrategy.WhileDragging,
        frequency: MeasuringFrequency.Optimized
    },
    dragOverlay: {
        measure: getClientRect
    }
};
class DroppableContainersMap extends Map {
    get(id) {
        var _super$get;
        return id != null ? (_super$get = super.get(id)) != null ? _super$get : undefined : undefined;
    }
    toArray() {
        return Array.from(this.values());
    }
    getEnabled() {
        return this.toArray().filter((_ref)=>{
            let { disabled } = _ref;
            return !disabled;
        });
    }
    getNodeFor(id) {
        var _this$get$node$curren, _this$get;
        return (_this$get$node$curren = (_this$get = this.get(id)) == null ? void 0 : _this$get.node.current) != null ? _this$get$node$curren : undefined;
    }
}
const defaultPublicContext = {
    activatorEvent: null,
    active: null,
    activeNode: null,
    activeNodeRect: null,
    collisions: null,
    containerNodeRect: null,
    draggableNodes: /*#__PURE__*/ new Map(),
    droppableRects: /*#__PURE__*/ new Map(),
    droppableContainers: /*#__PURE__*/ new DroppableContainersMap(),
    over: null,
    dragOverlay: {
        nodeRef: {
            current: null
        },
        rect: null,
        setRef: noop
    },
    scrollableAncestors: [],
    scrollableAncestorRects: [],
    measuringConfiguration: defaultMeasuringConfiguration,
    measureDroppableContainers: noop,
    windowRect: null,
    measuringScheduled: false
};
const defaultInternalContext = {
    activatorEvent: null,
    activators: [],
    active: null,
    activeNodeRect: null,
    ariaDescribedById: {
        draggable: ''
    },
    dispatch: noop,
    draggableNodes: /*#__PURE__*/ new Map(),
    over: null,
    measureDroppableContainers: noop
};
const InternalContext = /*#__PURE__*/ (0, _react.createContext)(defaultInternalContext);
const PublicContext = /*#__PURE__*/ (0, _react.createContext)(defaultPublicContext);
function getInitialState() {
    return {
        draggable: {
            active: null,
            initialCoordinates: {
                x: 0,
                y: 0
            },
            nodes: new Map(),
            translate: {
                x: 0,
                y: 0
            }
        },
        droppable: {
            containers: new DroppableContainersMap()
        }
    };
}
function reducer(state, action) {
    switch(action.type){
        case Action.DragStart:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    initialCoordinates: action.initialCoordinates,
                    active: action.active
                }
            };
        case Action.DragMove:
            if (state.draggable.active == null) return state;
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    translate: {
                        x: action.coordinates.x - state.draggable.initialCoordinates.x,
                        y: action.coordinates.y - state.draggable.initialCoordinates.y
                    }
                }
            };
        case Action.DragEnd:
        case Action.DragCancel:
            return {
                ...state,
                draggable: {
                    ...state.draggable,
                    active: null,
                    initialCoordinates: {
                        x: 0,
                        y: 0
                    },
                    translate: {
                        x: 0,
                        y: 0
                    }
                }
            };
        case Action.RegisterDroppable:
            {
                const { element } = action;
                const { id } = element;
                const containers = new DroppableContainersMap(state.droppable.containers);
                containers.set(id, element);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers
                    }
                };
            }
        case Action.SetDroppableDisabled:
            {
                const { id, key, disabled } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new DroppableContainersMap(state.droppable.containers);
                containers.set(id, {
                    ...element,
                    disabled
                });
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers
                    }
                };
            }
        case Action.UnregisterDroppable:
            {
                const { id, key } = action;
                const element = state.droppable.containers.get(id);
                if (!element || key !== element.key) return state;
                const containers = new DroppableContainersMap(state.droppable.containers);
                containers.delete(id);
                return {
                    ...state,
                    droppable: {
                        ...state.droppable,
                        containers
                    }
                };
            }
        default:
            return state;
    }
}
function RestoreFocus(_ref) {
    let { disabled } = _ref;
    const { active, activatorEvent, draggableNodes } = (0, _react.useContext)(InternalContext);
    const previousActivatorEvent = (0, _utilities.usePrevious)(activatorEvent);
    const previousActiveId = (0, _utilities.usePrevious)(active == null ? void 0 : active.id); // Restore keyboard focus on the activator node
    (0, _react.useEffect)(()=>{
        if (disabled) return;
        if (!activatorEvent && previousActivatorEvent && previousActiveId != null) {
            if (!(0, _utilities.isKeyboardEvent)(previousActivatorEvent)) return;
            if (document.activeElement === previousActivatorEvent.target) // No need to restore focus
            return;
            const draggableNode = draggableNodes.get(previousActiveId);
            if (!draggableNode) return;
            const { activatorNode, node } = draggableNode;
            if (!activatorNode.current && !node.current) return;
            requestAnimationFrame(()=>{
                for (const element of [
                    activatorNode.current,
                    node.current
                ]){
                    if (!element) continue;
                    const focusableNode = (0, _utilities.findFirstFocusableNode)(element);
                    if (focusableNode) {
                        focusableNode.focus();
                        break;
                    }
                }
            });
        }
    }, [
        activatorEvent,
        disabled,
        draggableNodes,
        previousActiveId,
        previousActivatorEvent
    ]);
    return null;
}
function applyModifiers(modifiers, _ref) {
    let { transform, ...args } = _ref;
    return modifiers != null && modifiers.length ? modifiers.reduce((accumulator, modifier)=>{
        return modifier({
            transform: accumulator,
            ...args
        });
    }, transform) : transform;
}
function useMeasuringConfiguration(config) {
    return (0, _react.useMemo)(()=>({
            draggable: {
                ...defaultMeasuringConfiguration.draggable,
                ...config == null ? void 0 : config.draggable
            },
            droppable: {
                ...defaultMeasuringConfiguration.droppable,
                ...config == null ? void 0 : config.droppable
            },
            dragOverlay: {
                ...defaultMeasuringConfiguration.dragOverlay,
                ...config == null ? void 0 : config.dragOverlay
            }
        }), [
        config == null ? void 0 : config.draggable,
        config == null ? void 0 : config.droppable,
        config == null ? void 0 : config.dragOverlay
    ]);
}
function useLayoutShiftScrollCompensation(_ref) {
    let { activeNode, measure, initialRect, config = true } = _ref;
    const initialized = (0, _react.useRef)(false);
    const { x, y } = typeof config === 'boolean' ? {
        x: config,
        y: config
    } : config;
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        const disabled = !x && !y;
        if (disabled || !activeNode) {
            initialized.current = false;
            return;
        }
        if (initialized.current || !initialRect) // Return early if layout shift scroll compensation was already attempted
        // or if there is no initialRect to compare to.
        return;
         // Get the most up to date node ref for the active draggable
        const node = activeNode == null ? void 0 : activeNode.node.current;
        if (!node || node.isConnected === false) // Return early if there is no attached node ref or if the node is
        // disconnected from the document.
        return;
        const rect = measure(node);
        const rectDelta = getRectDelta(rect, initialRect);
        if (!x) rectDelta.x = 0;
        if (!y) rectDelta.y = 0;
         // Only perform layout shift scroll compensation once
        initialized.current = true;
        if (Math.abs(rectDelta.x) > 0 || Math.abs(rectDelta.y) > 0) {
            const firstScrollableAncestor = getFirstScrollableAncestor(node);
            if (firstScrollableAncestor) firstScrollableAncestor.scrollBy({
                top: rectDelta.y,
                left: rectDelta.x
            });
        }
    }, [
        activeNode,
        x,
        y,
        initialRect,
        measure
    ]);
}
const ActiveDraggableContext = /*#__PURE__*/ (0, _react.createContext)({
    ...defaultCoordinates,
    scaleX: 1,
    scaleY: 1
});
var Status;
(function(Status) {
    Status[Status["Uninitialized"] = 0] = "Uninitialized";
    Status[Status["Initializing"] = 1] = "Initializing";
    Status[Status["Initialized"] = 2] = "Initialized";
})(Status || (Status = {}));
const DndContext = /*#__PURE__*/ (0, _react.memo)(function DndContext(_ref) {
    var _sensorContext$curren, _dragOverlay$nodeRef$, _dragOverlay$rect, _over$rect;
    let { id, accessibility, autoScroll = true, children, sensors = defaultSensors, collisionDetection = rectIntersection, measuring, modifiers, ...props } = _ref;
    const store = (0, _react.useReducer)(reducer, undefined, getInitialState);
    const [state, dispatch] = store;
    const [dispatchMonitorEvent, registerMonitorListener] = useDndMonitorProvider();
    const [status, setStatus] = (0, _react.useState)(Status.Uninitialized);
    const isInitialized = status === Status.Initialized;
    const { draggable: { active: activeId, nodes: draggableNodes, translate }, droppable: { containers: droppableContainers } } = state;
    const node = activeId != null ? draggableNodes.get(activeId) : null;
    const activeRects = (0, _react.useRef)({
        initial: null,
        translated: null
    });
    const active = (0, _react.useMemo)(()=>{
        var _node$data;
        return activeId != null ? {
            id: activeId,
            // It's possible for the active node to unmount while dragging
            data: (_node$data = node == null ? void 0 : node.data) != null ? _node$data : defaultData,
            rect: activeRects
        } : null;
    }, [
        activeId,
        node
    ]);
    const activeRef = (0, _react.useRef)(null);
    const [activeSensor, setActiveSensor] = (0, _react.useState)(null);
    const [activatorEvent, setActivatorEvent] = (0, _react.useState)(null);
    const latestProps = (0, _utilities.useLatestValue)(props, Object.values(props));
    const draggableDescribedById = (0, _utilities.useUniqueId)("DndDescribedBy", id);
    const enabledDroppableContainers = (0, _react.useMemo)(()=>droppableContainers.getEnabled(), [
        droppableContainers
    ]);
    const measuringConfiguration = useMeasuringConfiguration(measuring);
    const { droppableRects, measureDroppableContainers, measuringScheduled } = useDroppableMeasuring(enabledDroppableContainers, {
        dragging: isInitialized,
        dependencies: [
            translate.x,
            translate.y
        ],
        config: measuringConfiguration.droppable
    });
    const activeNode = useCachedNode(draggableNodes, activeId);
    const activationCoordinates = (0, _react.useMemo)(()=>activatorEvent ? (0, _utilities.getEventCoordinates)(activatorEvent) : null, [
        activatorEvent
    ]);
    const autoScrollOptions = getAutoScrollerOptions();
    const initialActiveNodeRect = useInitialRect(activeNode, measuringConfiguration.draggable.measure);
    useLayoutShiftScrollCompensation({
        activeNode: activeId != null ? draggableNodes.get(activeId) : null,
        config: autoScrollOptions.layoutShiftCompensation,
        initialRect: initialActiveNodeRect,
        measure: measuringConfiguration.draggable.measure
    });
    const activeNodeRect = useRect(activeNode, measuringConfiguration.draggable.measure, initialActiveNodeRect);
    const containerNodeRect = useRect(activeNode ? activeNode.parentElement : null);
    const sensorContext = (0, _react.useRef)({
        activatorEvent: null,
        active: null,
        activeNode,
        collisionRect: null,
        collisions: null,
        droppableRects,
        draggableNodes,
        draggingNode: null,
        draggingNodeRect: null,
        droppableContainers,
        over: null,
        scrollableAncestors: [],
        scrollAdjustedTranslate: null
    });
    const overNode = droppableContainers.getNodeFor((_sensorContext$curren = sensorContext.current.over) == null ? void 0 : _sensorContext$curren.id);
    const dragOverlay = useDragOverlayMeasuring({
        measure: measuringConfiguration.dragOverlay.measure
    }); // Use the rect of the drag overlay if it is mounted
    const draggingNode = (_dragOverlay$nodeRef$ = dragOverlay.nodeRef.current) != null ? _dragOverlay$nodeRef$ : activeNode;
    const draggingNodeRect = isInitialized ? (_dragOverlay$rect = dragOverlay.rect) != null ? _dragOverlay$rect : activeNodeRect : null;
    const usesDragOverlay = Boolean(dragOverlay.nodeRef.current && dragOverlay.rect); // The delta between the previous and new position of the draggable node
    // is only relevant when there is no drag overlay
    const nodeRectDelta = useRectDelta(usesDragOverlay ? null : activeNodeRect); // Get the window rect of the dragging node
    const windowRect = useWindowRect(draggingNode ? (0, _utilities.getWindow)(draggingNode) : null); // Get scrollable ancestors of the dragging node
    const scrollableAncestors = useScrollableAncestors(isInitialized ? overNode != null ? overNode : activeNode : null);
    const scrollableAncestorRects = useRects(scrollableAncestors); // Apply modifiers
    const modifiedTranslate = applyModifiers(modifiers, {
        transform: {
            x: translate.x - nodeRectDelta.x,
            y: translate.y - nodeRectDelta.y,
            scaleX: 1,
            scaleY: 1
        },
        activatorEvent,
        active,
        activeNodeRect,
        containerNodeRect,
        draggingNodeRect,
        over: sensorContext.current.over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors,
        scrollableAncestorRects,
        windowRect
    });
    const pointerCoordinates = activationCoordinates ? (0, _utilities.add)(activationCoordinates, translate) : null;
    const scrollOffsets = useScrollOffsets(scrollableAncestors); // Represents the scroll delta since dragging was initiated
    const scrollAdjustment = useScrollOffsetsDelta(scrollOffsets); // Represents the scroll delta since the last time the active node rect was measured
    const activeNodeScrollDelta = useScrollOffsetsDelta(scrollOffsets, [
        activeNodeRect
    ]);
    const scrollAdjustedTranslate = (0, _utilities.add)(modifiedTranslate, scrollAdjustment);
    const collisionRect = draggingNodeRect ? getAdjustedRect(draggingNodeRect, modifiedTranslate) : null;
    const collisions = active && collisionRect ? collisionDetection({
        active,
        collisionRect,
        droppableRects,
        droppableContainers: enabledDroppableContainers,
        pointerCoordinates
    }) : null;
    const overId = getFirstCollision(collisions, 'id');
    const [over, setOver] = (0, _react.useState)(null); // When there is no drag overlay used, we need to account for the
    // window scroll delta
    const appliedTranslate = usesDragOverlay ? modifiedTranslate : (0, _utilities.add)(modifiedTranslate, activeNodeScrollDelta);
    const transform = adjustScale(appliedTranslate, (_over$rect = over == null ? void 0 : over.rect) != null ? _over$rect : null, activeNodeRect);
    const activeSensorRef = (0, _react.useRef)(null);
    const instantiateSensor = (0, _react.useCallback)((event, _ref2)=>{
        let { sensor: Sensor, options } = _ref2;
        if (activeRef.current == null) return;
        const activeNode = draggableNodes.get(activeRef.current);
        if (!activeNode) return;
        const activatorEvent = event.nativeEvent;
        const sensorInstance = new Sensor({
            active: activeRef.current,
            activeNode,
            event: activatorEvent,
            options,
            // Sensors need to be instantiated with refs for arguments that change over time
            // otherwise they are frozen in time with the stale arguments
            context: sensorContext,
            onAbort (id) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragAbort } = latestProps.current;
                const event = {
                    id
                };
                onDragAbort == null || onDragAbort(event);
                dispatchMonitorEvent({
                    type: 'onDragAbort',
                    event
                });
            },
            onPending (id, constraint, initialCoordinates, offset) {
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragPending } = latestProps.current;
                const event = {
                    id,
                    constraint,
                    initialCoordinates,
                    offset
                };
                onDragPending == null || onDragPending(event);
                dispatchMonitorEvent({
                    type: 'onDragPending',
                    event
                });
            },
            onStart (initialCoordinates) {
                const id = activeRef.current;
                if (id == null) return;
                const draggableNode = draggableNodes.get(id);
                if (!draggableNode) return;
                const { onDragStart } = latestProps.current;
                const event = {
                    activatorEvent,
                    active: {
                        id,
                        data: draggableNode.data,
                        rect: activeRects
                    }
                };
                (0, _reactDom.unstable_batchedUpdates)(()=>{
                    onDragStart == null || onDragStart(event);
                    setStatus(Status.Initializing);
                    dispatch({
                        type: Action.DragStart,
                        initialCoordinates,
                        active: id
                    });
                    dispatchMonitorEvent({
                        type: 'onDragStart',
                        event
                    });
                    setActiveSensor(activeSensorRef.current);
                    setActivatorEvent(activatorEvent);
                });
            },
            onMove (coordinates) {
                dispatch({
                    type: Action.DragMove,
                    coordinates
                });
            },
            onEnd: createHandler(Action.DragEnd),
            onCancel: createHandler(Action.DragCancel)
        });
        activeSensorRef.current = sensorInstance;
        function createHandler(type) {
            return async function handler() {
                const { active, collisions, over, scrollAdjustedTranslate } = sensorContext.current;
                let event = null;
                if (active && scrollAdjustedTranslate) {
                    const { cancelDrop } = latestProps.current;
                    event = {
                        activatorEvent,
                        active: active,
                        collisions,
                        delta: scrollAdjustedTranslate,
                        over
                    };
                    if (type === Action.DragEnd && typeof cancelDrop === 'function') {
                        const shouldCancel = await Promise.resolve(cancelDrop(event));
                        if (shouldCancel) type = Action.DragCancel;
                    }
                }
                activeRef.current = null;
                (0, _reactDom.unstable_batchedUpdates)(()=>{
                    dispatch({
                        type
                    });
                    setStatus(Status.Uninitialized);
                    setOver(null);
                    setActiveSensor(null);
                    setActivatorEvent(null);
                    activeSensorRef.current = null;
                    const eventName = type === Action.DragEnd ? 'onDragEnd' : 'onDragCancel';
                    if (event) {
                        const handler = latestProps.current[eventName];
                        handler == null || handler(event);
                        dispatchMonitorEvent({
                            type: eventName,
                            event
                        });
                    }
                });
            };
        }
    }, [
        draggableNodes
    ]);
    const bindActivatorToSensorInstantiator = (0, _react.useCallback)((handler, sensor)=>{
        return (event, active)=>{
            const nativeEvent = event.nativeEvent;
            const activeDraggableNode = draggableNodes.get(active);
            if (activeRef.current !== null || // No active draggable
            !activeDraggableNode || // Event has already been captured
            nativeEvent.dndKit || nativeEvent.defaultPrevented) return;
            const activationContext = {
                active: activeDraggableNode
            };
            const shouldActivate = handler(event, sensor.options, activationContext);
            if (shouldActivate === true) {
                nativeEvent.dndKit = {
                    capturedBy: sensor.sensor
                };
                activeRef.current = active;
                instantiateSensor(event, sensor);
            }
        };
    }, [
        draggableNodes,
        instantiateSensor
    ]);
    const activators = useCombineActivators(sensors, bindActivatorToSensorInstantiator);
    useSensorSetup(sensors);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        if (activeNodeRect && status === Status.Initializing) setStatus(Status.Initialized);
    }, [
        activeNodeRect,
        status
    ]);
    (0, _react.useEffect)(()=>{
        const { onDragMove } = latestProps.current;
        const { active, activatorEvent, collisions, over } = sensorContext.current;
        if (!active || !activatorEvent) return;
        const event = {
            active,
            activatorEvent,
            collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over
        };
        (0, _reactDom.unstable_batchedUpdates)(()=>{
            onDragMove == null || onDragMove(event);
            dispatchMonitorEvent({
                type: 'onDragMove',
                event
            });
        });
    }, [
        scrollAdjustedTranslate.x,
        scrollAdjustedTranslate.y
    ]);
    (0, _react.useEffect)(()=>{
        const { active, activatorEvent, collisions, droppableContainers, scrollAdjustedTranslate } = sensorContext.current;
        if (!active || activeRef.current == null || !activatorEvent || !scrollAdjustedTranslate) return;
        const { onDragOver } = latestProps.current;
        const overContainer = droppableContainers.get(overId);
        const over = overContainer && overContainer.rect.current ? {
            id: overContainer.id,
            rect: overContainer.rect.current,
            data: overContainer.data,
            disabled: overContainer.disabled
        } : null;
        const event = {
            active,
            activatorEvent,
            collisions,
            delta: {
                x: scrollAdjustedTranslate.x,
                y: scrollAdjustedTranslate.y
            },
            over
        };
        (0, _reactDom.unstable_batchedUpdates)(()=>{
            setOver(over);
            onDragOver == null || onDragOver(event);
            dispatchMonitorEvent({
                type: 'onDragOver',
                event
            });
        });
    }, [
        overId
    ]);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        sensorContext.current = {
            activatorEvent,
            active,
            activeNode,
            collisionRect,
            collisions,
            droppableRects,
            draggableNodes,
            draggingNode,
            draggingNodeRect,
            droppableContainers,
            over,
            scrollableAncestors,
            scrollAdjustedTranslate
        };
        activeRects.current = {
            initial: draggingNodeRect,
            translated: collisionRect
        };
    }, [
        active,
        activeNode,
        collisions,
        collisionRect,
        draggableNodes,
        draggingNode,
        draggingNodeRect,
        droppableRects,
        droppableContainers,
        over,
        scrollableAncestors,
        scrollAdjustedTranslate
    ]);
    useAutoScroller({
        ...autoScrollOptions,
        delta: translate,
        draggingRect: collisionRect,
        pointerCoordinates,
        scrollableAncestors,
        scrollableAncestorRects
    });
    const publicContext = (0, _react.useMemo)(()=>{
        const context = {
            active,
            activeNode,
            activeNodeRect,
            activatorEvent,
            collisions,
            containerNodeRect,
            dragOverlay,
            draggableNodes,
            droppableContainers,
            droppableRects,
            over,
            measureDroppableContainers,
            scrollableAncestors,
            scrollableAncestorRects,
            measuringConfiguration,
            measuringScheduled,
            windowRect
        };
        return context;
    }, [
        active,
        activeNode,
        activeNodeRect,
        activatorEvent,
        collisions,
        containerNodeRect,
        dragOverlay,
        draggableNodes,
        droppableContainers,
        droppableRects,
        over,
        measureDroppableContainers,
        scrollableAncestors,
        scrollableAncestorRects,
        measuringConfiguration,
        measuringScheduled,
        windowRect
    ]);
    const internalContext = (0, _react.useMemo)(()=>{
        const context = {
            activatorEvent,
            activators,
            active,
            activeNodeRect,
            ariaDescribedById: {
                draggable: draggableDescribedById
            },
            dispatch,
            draggableNodes,
            over,
            measureDroppableContainers
        };
        return context;
    }, [
        activatorEvent,
        activators,
        active,
        activeNodeRect,
        dispatch,
        draggableDescribedById,
        draggableNodes,
        over,
        measureDroppableContainers
    ]);
    return (0, _reactDefault.default).createElement(DndMonitorContext.Provider, {
        value: registerMonitorListener
    }, (0, _reactDefault.default).createElement(InternalContext.Provider, {
        value: internalContext
    }, (0, _reactDefault.default).createElement(PublicContext.Provider, {
        value: publicContext
    }, (0, _reactDefault.default).createElement(ActiveDraggableContext.Provider, {
        value: transform
    }, children)), (0, _reactDefault.default).createElement(RestoreFocus, {
        disabled: (accessibility == null ? void 0 : accessibility.restoreFocus) === false
    })), (0, _reactDefault.default).createElement(Accessibility, {
        ...accessibility,
        hiddenTextDescribedById: draggableDescribedById
    }));
    function getAutoScrollerOptions() {
        const activeSensorDisablesAutoscroll = (activeSensor == null ? void 0 : activeSensor.autoScrollEnabled) === false;
        const autoScrollGloballyDisabled = typeof autoScroll === 'object' ? autoScroll.enabled === false : autoScroll === false;
        const enabled = isInitialized && !activeSensorDisablesAutoscroll && !autoScrollGloballyDisabled;
        if (typeof autoScroll === 'object') return {
            ...autoScroll,
            enabled
        };
        return {
            enabled
        };
    }
});
const NullContext = /*#__PURE__*/ (0, _react.createContext)(null);
const defaultRole = 'button';
const ID_PREFIX = 'Draggable';
function useDraggable(_ref) {
    let { id, data, disabled = false, attributes } = _ref;
    const key = (0, _utilities.useUniqueId)(ID_PREFIX);
    const { activators, activatorEvent, active, activeNodeRect, ariaDescribedById, draggableNodes, over } = (0, _react.useContext)(InternalContext);
    const { role = defaultRole, roleDescription = 'draggable', tabIndex = 0 } = attributes != null ? attributes : {};
    const isDragging = (active == null ? void 0 : active.id) === id;
    const transform = (0, _react.useContext)(isDragging ? ActiveDraggableContext : NullContext);
    const [node, setNodeRef] = (0, _utilities.useNodeRef)();
    const [activatorNode, setActivatorNodeRef] = (0, _utilities.useNodeRef)();
    const listeners = useSyntheticListeners(activators, id);
    const dataRef = (0, _utilities.useLatestValue)(data);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        draggableNodes.set(id, {
            id,
            key,
            node,
            activatorNode,
            data: dataRef
        });
        return ()=>{
            const node = draggableNodes.get(id);
            if (node && node.key === key) draggableNodes.delete(id);
        };
    }, [
        draggableNodes,
        id
    ]);
    const memoizedAttributes = (0, _react.useMemo)(()=>({
            role,
            tabIndex,
            'aria-disabled': disabled,
            'aria-pressed': isDragging && role === defaultRole ? true : undefined,
            'aria-roledescription': roleDescription,
            'aria-describedby': ariaDescribedById.draggable
        }), [
        disabled,
        role,
        tabIndex,
        isDragging,
        roleDescription,
        ariaDescribedById.draggable
    ]);
    return {
        active,
        activatorEvent,
        activeNodeRect,
        attributes: memoizedAttributes,
        isDragging,
        listeners: disabled ? undefined : listeners,
        node,
        over,
        setNodeRef,
        setActivatorNodeRef,
        transform
    };
}
function useDndContext() {
    return (0, _react.useContext)(PublicContext);
}
const ID_PREFIX$1 = 'Droppable';
const defaultResizeObserverConfig = {
    timeout: 25
};
function useDroppable(_ref) {
    let { data, disabled = false, id, resizeObserverConfig } = _ref;
    const key = (0, _utilities.useUniqueId)(ID_PREFIX$1);
    const { active, dispatch, over, measureDroppableContainers } = (0, _react.useContext)(InternalContext);
    const previous = (0, _react.useRef)({
        disabled
    });
    const resizeObserverConnected = (0, _react.useRef)(false);
    const rect = (0, _react.useRef)(null);
    const callbackId = (0, _react.useRef)(null);
    const { disabled: resizeObserverDisabled, updateMeasurementsFor, timeout: resizeObserverTimeout } = {
        ...defaultResizeObserverConfig,
        ...resizeObserverConfig
    };
    const ids = (0, _utilities.useLatestValue)(updateMeasurementsFor != null ? updateMeasurementsFor : id);
    const handleResize = (0, _react.useCallback)(()=>{
        if (!resizeObserverConnected.current) {
            // ResizeObserver invokes the `handleResize` callback as soon as `observe` is called,
            // assuming the element is rendered and displayed.
            resizeObserverConnected.current = true;
            return;
        }
        if (callbackId.current != null) clearTimeout(callbackId.current);
        callbackId.current = setTimeout(()=>{
            measureDroppableContainers(Array.isArray(ids.current) ? ids.current : [
                ids.current
            ]);
            callbackId.current = null;
        }, resizeObserverTimeout);
    }, [
        resizeObserverTimeout
    ]);
    const resizeObserver = useResizeObserver({
        callback: handleResize,
        disabled: resizeObserverDisabled || !active
    });
    const handleNodeChange = (0, _react.useCallback)((newElement, previousElement)=>{
        if (!resizeObserver) return;
        if (previousElement) {
            resizeObserver.unobserve(previousElement);
            resizeObserverConnected.current = false;
        }
        if (newElement) resizeObserver.observe(newElement);
    }, [
        resizeObserver
    ]);
    const [nodeRef, setNodeRef] = (0, _utilities.useNodeRef)(handleNodeChange);
    const dataRef = (0, _utilities.useLatestValue)(data);
    (0, _react.useEffect)(()=>{
        if (!resizeObserver || !nodeRef.current) return;
        resizeObserver.disconnect();
        resizeObserverConnected.current = false;
        resizeObserver.observe(nodeRef.current);
    }, [
        nodeRef,
        resizeObserver
    ]);
    (0, _react.useEffect)(()=>{
        dispatch({
            type: Action.RegisterDroppable,
            element: {
                id,
                key,
                disabled,
                node: nodeRef,
                rect,
                data: dataRef
            }
        });
        return ()=>dispatch({
                type: Action.UnregisterDroppable,
                key,
                id
            });
    }, [
        id
    ]);
    (0, _react.useEffect)(()=>{
        if (disabled !== previous.current.disabled) {
            dispatch({
                type: Action.SetDroppableDisabled,
                id,
                key,
                disabled
            });
            previous.current.disabled = disabled;
        }
    }, [
        id,
        key,
        disabled,
        dispatch
    ]);
    return {
        active,
        rect,
        isOver: (over == null ? void 0 : over.id) === id,
        node: nodeRef,
        over,
        setNodeRef
    };
}
function AnimationManager(_ref) {
    let { animation, children } = _ref;
    const [clonedChildren, setClonedChildren] = (0, _react.useState)(null);
    const [element, setElement] = (0, _react.useState)(null);
    const previousChildren = (0, _utilities.usePrevious)(children);
    if (!children && !clonedChildren && previousChildren) setClonedChildren(previousChildren);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        if (!element) return;
        const key = clonedChildren == null ? void 0 : clonedChildren.key;
        const id = clonedChildren == null ? void 0 : clonedChildren.props.id;
        if (key == null || id == null) {
            setClonedChildren(null);
            return;
        }
        Promise.resolve(animation(id, element)).then(()=>{
            setClonedChildren(null);
        });
    }, [
        animation,
        clonedChildren,
        element
    ]);
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children, clonedChildren ? (0, _react.cloneElement)(clonedChildren, {
        ref: setElement
    }) : null);
}
const defaultTransform = {
    x: 0,
    y: 0,
    scaleX: 1,
    scaleY: 1
};
function NullifiedContextProvider(_ref) {
    let { children } = _ref;
    return (0, _reactDefault.default).createElement(InternalContext.Provider, {
        value: defaultInternalContext
    }, (0, _reactDefault.default).createElement(ActiveDraggableContext.Provider, {
        value: defaultTransform
    }, children));
}
const baseStyles = {
    position: 'fixed',
    touchAction: 'none'
};
const defaultTransition = (activatorEvent)=>{
    const isKeyboardActivator = (0, _utilities.isKeyboardEvent)(activatorEvent);
    return isKeyboardActivator ? 'transform 250ms ease' : undefined;
};
const PositionedOverlay = /*#__PURE__*/ (0, _react.forwardRef)((_ref, ref)=>{
    let { as, activatorEvent, adjustScale, children, className, rect, style, transform, transition = defaultTransition } = _ref;
    if (!rect) return null;
    const scaleAdjustedTransform = adjustScale ? transform : {
        ...transform,
        scaleX: 1,
        scaleY: 1
    };
    const styles = {
        ...baseStyles,
        width: rect.width,
        height: rect.height,
        top: rect.top,
        left: rect.left,
        transform: (0, _utilities.CSS).Transform.toString(scaleAdjustedTransform),
        transformOrigin: adjustScale && activatorEvent ? getRelativeTransformOrigin(activatorEvent, rect) : undefined,
        transition: typeof transition === 'function' ? transition(activatorEvent) : transition,
        ...style
    };
    return (0, _reactDefault.default).createElement(as, {
        className,
        style: styles,
        ref
    }, children);
});
const defaultDropAnimationSideEffects = (options)=>(_ref)=>{
        let { active, dragOverlay } = _ref;
        const originalStyles = {};
        const { styles, className } = options;
        if (styles != null && styles.active) for (const [key, value] of Object.entries(styles.active)){
            if (value === undefined) continue;
            originalStyles[key] = active.node.style.getPropertyValue(key);
            active.node.style.setProperty(key, value);
        }
        if (styles != null && styles.dragOverlay) for (const [key, value] of Object.entries(styles.dragOverlay)){
            if (value === undefined) continue;
            dragOverlay.node.style.setProperty(key, value);
        }
        if (className != null && className.active) active.node.classList.add(className.active);
        if (className != null && className.dragOverlay) dragOverlay.node.classList.add(className.dragOverlay);
        return function cleanup() {
            for (const [key, value] of Object.entries(originalStyles))active.node.style.setProperty(key, value);
            if (className != null && className.active) active.node.classList.remove(className.active);
        };
    };
const defaultKeyframeResolver = (_ref2)=>{
    let { transform: { initial, final } } = _ref2;
    return [
        {
            transform: (0, _utilities.CSS).Transform.toString(initial)
        },
        {
            transform: (0, _utilities.CSS).Transform.toString(final)
        }
    ];
};
const defaultDropAnimationConfiguration = {
    duration: 250,
    easing: 'ease',
    keyframes: defaultKeyframeResolver,
    sideEffects: /*#__PURE__*/ defaultDropAnimationSideEffects({
        styles: {
            active: {
                opacity: '0'
            }
        }
    })
};
function useDropAnimation(_ref3) {
    let { config, draggableNodes, droppableContainers, measuringConfiguration } = _ref3;
    return (0, _utilities.useEvent)((id, node)=>{
        if (config === null) return;
        const activeDraggable = draggableNodes.get(id);
        if (!activeDraggable) return;
        const activeNode = activeDraggable.node.current;
        if (!activeNode) return;
        const measurableNode = getMeasurableNode(node);
        if (!measurableNode) return;
        const { transform } = (0, _utilities.getWindow)(node).getComputedStyle(node);
        const parsedTransform = parseTransform(transform);
        if (!parsedTransform) return;
        const animation = typeof config === 'function' ? config : createDefaultDropAnimation(config);
        scrollIntoViewIfNeeded(activeNode, measuringConfiguration.draggable.measure);
        return animation({
            active: {
                id,
                data: activeDraggable.data,
                node: activeNode,
                rect: measuringConfiguration.draggable.measure(activeNode)
            },
            draggableNodes,
            dragOverlay: {
                node,
                rect: measuringConfiguration.dragOverlay.measure(measurableNode)
            },
            droppableContainers,
            measuringConfiguration,
            transform: parsedTransform
        });
    });
}
function createDefaultDropAnimation(options) {
    const { duration, easing, sideEffects, keyframes } = {
        ...defaultDropAnimationConfiguration,
        ...options
    };
    return (_ref4)=>{
        let { active, dragOverlay, transform, ...rest } = _ref4;
        if (!duration) // Do not animate if animation duration is zero.
        return;
        const delta = {
            x: dragOverlay.rect.left - active.rect.left,
            y: dragOverlay.rect.top - active.rect.top
        };
        const scale = {
            scaleX: transform.scaleX !== 1 ? active.rect.width * transform.scaleX / dragOverlay.rect.width : 1,
            scaleY: transform.scaleY !== 1 ? active.rect.height * transform.scaleY / dragOverlay.rect.height : 1
        };
        const finalTransform = {
            x: transform.x - delta.x,
            y: transform.y - delta.y,
            ...scale
        };
        const animationKeyframes = keyframes({
            ...rest,
            active,
            dragOverlay,
            transform: {
                initial: transform,
                final: finalTransform
            }
        });
        const [firstKeyframe] = animationKeyframes;
        const lastKeyframe = animationKeyframes[animationKeyframes.length - 1];
        if (JSON.stringify(firstKeyframe) === JSON.stringify(lastKeyframe)) // The start and end keyframes are the same, infer that there is no animation needed.
        return;
        const cleanup = sideEffects == null ? void 0 : sideEffects({
            active,
            dragOverlay,
            ...rest
        });
        const animation = dragOverlay.node.animate(animationKeyframes, {
            duration,
            easing,
            fill: 'forwards'
        });
        return new Promise((resolve)=>{
            animation.onfinish = ()=>{
                cleanup == null || cleanup();
                resolve();
            };
        });
    };
}
let key = 0;
function useKey(id) {
    return (0, _react.useMemo)(()=>{
        if (id == null) return;
        key++;
        return key;
    }, [
        id
    ]);
}
const DragOverlay = /*#__PURE__*/ (0, _reactDefault.default).memo((_ref)=>{
    let { adjustScale = false, children, dropAnimation: dropAnimationConfig, style, transition, modifiers, wrapperElement = 'div', className, zIndex = 999 } = _ref;
    const { activatorEvent, active, activeNodeRect, containerNodeRect, draggableNodes, droppableContainers, dragOverlay, over, measuringConfiguration, scrollableAncestors, scrollableAncestorRects, windowRect } = useDndContext();
    const transform = (0, _react.useContext)(ActiveDraggableContext);
    const key = useKey(active == null ? void 0 : active.id);
    const modifiedTransform = applyModifiers(modifiers, {
        activatorEvent,
        active,
        activeNodeRect,
        containerNodeRect,
        draggingNodeRect: dragOverlay.rect,
        over,
        overlayNodeRect: dragOverlay.rect,
        scrollableAncestors,
        scrollableAncestorRects,
        transform,
        windowRect
    });
    const initialRect = useInitialValue(activeNodeRect);
    const dropAnimation = useDropAnimation({
        config: dropAnimationConfig,
        draggableNodes,
        droppableContainers,
        measuringConfiguration
    }); // We need to wait for the active node to be measured before connecting the drag overlay ref
    // otherwise collisions can be computed against a mispositioned drag overlay
    const ref = initialRect ? dragOverlay.setRef : undefined;
    return (0, _reactDefault.default).createElement(NullifiedContextProvider, null, (0, _reactDefault.default).createElement(AnimationManager, {
        animation: dropAnimation
    }, active && key ? (0, _reactDefault.default).createElement(PositionedOverlay, {
        key: key,
        id: active.id,
        ref: ref,
        as: wrapperElement,
        activatorEvent: activatorEvent,
        adjustScale: adjustScale,
        className: className,
        transition: transition,
        rect: initialRect,
        style: {
            zIndex,
            ...style
        },
        transform: modifiedTransform
    }, children) : null));
});

},{"react":"bmhQu","react-dom":"82aNB","@dnd-kit/utilities":"iX0Y8","@dnd-kit/accessibility":"6PgpC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iX0Y8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CSS", ()=>CSS);
parcelHelpers.export(exports, "add", ()=>add);
parcelHelpers.export(exports, "canUseDOM", ()=>canUseDOM);
parcelHelpers.export(exports, "findFirstFocusableNode", ()=>findFirstFocusableNode);
parcelHelpers.export(exports, "getEventCoordinates", ()=>getEventCoordinates);
parcelHelpers.export(exports, "getOwnerDocument", ()=>getOwnerDocument);
parcelHelpers.export(exports, "getWindow", ()=>getWindow);
parcelHelpers.export(exports, "hasViewportRelativeCoordinates", ()=>hasViewportRelativeCoordinates);
parcelHelpers.export(exports, "isDocument", ()=>isDocument);
parcelHelpers.export(exports, "isHTMLElement", ()=>isHTMLElement);
parcelHelpers.export(exports, "isKeyboardEvent", ()=>isKeyboardEvent);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isSVGElement", ()=>isSVGElement);
parcelHelpers.export(exports, "isTouchEvent", ()=>isTouchEvent);
parcelHelpers.export(exports, "isWindow", ()=>isWindow);
parcelHelpers.export(exports, "subtract", ()=>subtract);
parcelHelpers.export(exports, "useCombinedRefs", ()=>useCombinedRefs);
parcelHelpers.export(exports, "useEvent", ()=>useEvent);
parcelHelpers.export(exports, "useInterval", ()=>useInterval);
parcelHelpers.export(exports, "useIsomorphicLayoutEffect", ()=>useIsomorphicLayoutEffect);
parcelHelpers.export(exports, "useLatestValue", ()=>useLatestValue);
parcelHelpers.export(exports, "useLazyMemo", ()=>useLazyMemo);
parcelHelpers.export(exports, "useNodeRef", ()=>useNodeRef);
parcelHelpers.export(exports, "usePrevious", ()=>usePrevious);
parcelHelpers.export(exports, "useUniqueId", ()=>useUniqueId);
var _react = require("react");
function useCombinedRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (0, _react.useMemo)(()=>(node)=>{
            refs.forEach((ref)=>ref(node));
        }, refs);
}
// https://github.com/facebook/react/blob/master/packages/shared/ExecutionEnvironment.js
const canUseDOM = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined';
function isWindow(element) {
    const elementString = Object.prototype.toString.call(element);
    return elementString === '[object Window]' || // In Electron context the Window object serializes to [object global]
    elementString === '[object global]';
}
function isNode(node) {
    return 'nodeType' in node;
}
function getWindow(target) {
    var _target$ownerDocument, _target$ownerDocument2;
    if (!target) return window;
    if (isWindow(target)) return target;
    if (!isNode(target)) return window;
    return (_target$ownerDocument = (_target$ownerDocument2 = target.ownerDocument) == null ? void 0 : _target$ownerDocument2.defaultView) != null ? _target$ownerDocument : window;
}
function isDocument(node) {
    const { Document } = getWindow(node);
    return node instanceof Document;
}
function isHTMLElement(node) {
    if (isWindow(node)) return false;
    return node instanceof getWindow(node).HTMLElement;
}
function isSVGElement(node) {
    return node instanceof getWindow(node).SVGElement;
}
function getOwnerDocument(target) {
    if (!target) return document;
    if (isWindow(target)) return target.document;
    if (!isNode(target)) return document;
    if (isDocument(target)) return target;
    if (isHTMLElement(target) || isSVGElement(target)) return target.ownerDocument;
    return document;
}
/**
 * A hook that resolves to useEffect on the server and useLayoutEffect on the client
 * @param callback {function} Callback function that is invoked when the dependencies of the hook change
 */ const useIsomorphicLayoutEffect = canUseDOM ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
function useEvent(handler) {
    const handlerRef = (0, _react.useRef)(handler);
    useIsomorphicLayoutEffect(()=>{
        handlerRef.current = handler;
    });
    return (0, _react.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return handlerRef.current == null ? void 0 : handlerRef.current(...args);
    }, []);
}
function useInterval() {
    const intervalRef = (0, _react.useRef)(null);
    const set = (0, _react.useCallback)((listener, duration)=>{
        intervalRef.current = setInterval(listener, duration);
    }, []);
    const clear = (0, _react.useCallback)(()=>{
        if (intervalRef.current !== null) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
        }
    }, []);
    return [
        set,
        clear
    ];
}
function useLatestValue(value, dependencies) {
    if (dependencies === void 0) dependencies = [
        value
    ];
    const valueRef = (0, _react.useRef)(value);
    useIsomorphicLayoutEffect(()=>{
        if (valueRef.current !== value) valueRef.current = value;
    }, dependencies);
    return valueRef;
}
function useLazyMemo(callback, dependencies) {
    const valueRef = (0, _react.useRef)();
    return (0, _react.useMemo)(()=>{
        const newValue = callback(valueRef.current);
        valueRef.current = newValue;
        return newValue;
    }, [
        ...dependencies
    ]);
}
function useNodeRef(onChange) {
    const onChangeHandler = useEvent(onChange);
    const node = (0, _react.useRef)(null);
    const setNodeRef = (0, _react.useCallback)((element)=>{
        if (element !== node.current) onChangeHandler == null || onChangeHandler(element, node.current);
        node.current = element;
    }, []);
    return [
        node,
        setNodeRef
    ];
}
function usePrevious(value) {
    const ref = (0, _react.useRef)();
    (0, _react.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}
let ids = {};
function useUniqueId(prefix, value) {
    return (0, _react.useMemo)(()=>{
        if (value) return value;
        const id = ids[prefix] == null ? 0 : ids[prefix] + 1;
        ids[prefix] = id;
        return prefix + "-" + id;
    }, [
        prefix,
        value
    ]);
}
function createAdjustmentFn(modifier) {
    return function(object) {
        for(var _len = arguments.length, adjustments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)adjustments[_key - 1] = arguments[_key];
        return adjustments.reduce((accumulator, adjustment)=>{
            const entries = Object.entries(adjustment);
            for (const [key, valueAdjustment] of entries){
                const value = accumulator[key];
                if (value != null) accumulator[key] = value + modifier * valueAdjustment;
            }
            return accumulator;
        }, {
            ...object
        });
    };
}
const add = /*#__PURE__*/ createAdjustmentFn(1);
const subtract = /*#__PURE__*/ createAdjustmentFn(-1);
function hasViewportRelativeCoordinates(event) {
    return 'clientX' in event && 'clientY' in event;
}
function isKeyboardEvent(event) {
    if (!event) return false;
    const { KeyboardEvent } = getWindow(event.target);
    return KeyboardEvent && event instanceof KeyboardEvent;
}
function isTouchEvent(event) {
    if (!event) return false;
    const { TouchEvent } = getWindow(event.target);
    return TouchEvent && event instanceof TouchEvent;
}
/**
 * Returns the normalized x and y coordinates for mouse and touch events.
 */ function getEventCoordinates(event) {
    if (isTouchEvent(event)) {
        if (event.touches && event.touches.length) {
            const { clientX: x, clientY: y } = event.touches[0];
            return {
                x,
                y
            };
        } else if (event.changedTouches && event.changedTouches.length) {
            const { clientX: x, clientY: y } = event.changedTouches[0];
            return {
                x,
                y
            };
        }
    }
    if (hasViewportRelativeCoordinates(event)) return {
        x: event.clientX,
        y: event.clientY
    };
    return null;
}
const CSS = /*#__PURE__*/ Object.freeze({
    Translate: {
        toString (transform) {
            if (!transform) return;
            const { x, y } = transform;
            return "translate3d(" + (x ? Math.round(x) : 0) + "px, " + (y ? Math.round(y) : 0) + "px, 0)";
        }
    },
    Scale: {
        toString (transform) {
            if (!transform) return;
            const { scaleX, scaleY } = transform;
            return "scaleX(" + scaleX + ") scaleY(" + scaleY + ")";
        }
    },
    Transform: {
        toString (transform) {
            if (!transform) return;
            return [
                CSS.Translate.toString(transform),
                CSS.Scale.toString(transform)
            ].join(' ');
        }
    },
    Transition: {
        toString (_ref) {
            let { property, duration, easing } = _ref;
            return property + " " + duration + "ms " + easing;
        }
    }
});
const SELECTOR = 'a,frame,iframe,input:not([type=hidden]):not(:disabled),select:not(:disabled),textarea:not(:disabled),button:not(:disabled),*[tabindex]';
function findFirstFocusableNode(element) {
    if (element.matches(SELECTOR)) return element;
    return element.querySelector(SELECTOR);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6PgpC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HiddenText", ()=>HiddenText);
parcelHelpers.export(exports, "LiveRegion", ()=>LiveRegion);
parcelHelpers.export(exports, "useAnnouncement", ()=>useAnnouncement);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const hiddenStyles = {
    display: 'none'
};
function HiddenText(_ref) {
    let { id, value } = _ref;
    return (0, _reactDefault.default).createElement("div", {
        id: id,
        style: hiddenStyles
    }, value);
}
function LiveRegion(_ref) {
    let { id, announcement, ariaLiveType = "assertive" } = _ref;
    // Hide element visually but keep it readable by screen readers
    const visuallyHidden = {
        position: 'fixed',
        top: 0,
        left: 0,
        width: 1,
        height: 1,
        margin: -1,
        border: 0,
        padding: 0,
        overflow: 'hidden',
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(100%)',
        whiteSpace: 'nowrap'
    };
    return (0, _reactDefault.default).createElement("div", {
        id: id,
        style: visuallyHidden,
        role: "status",
        "aria-live": ariaLiveType,
        "aria-atomic": true
    }, announcement);
}
function useAnnouncement() {
    const [announcement, setAnnouncement] = (0, _react.useState)('');
    const announce = (0, _react.useCallback)((value)=>{
        if (value != null) setAnnouncement(value);
    }, []);
    return {
        announce,
        announcement
    };
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eKiBi":[function(require,module,exports,__globalThis) {
// 🔹 React Core
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExerciseCard", ()=>ExerciseCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 Animation Library
var _framerMotion = require("framer-motion");
const ExerciseCard = ({ exercise, isDragging, isOverlay })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _framerMotion.motion).div, {
        initial: {
            opacity: 0,
            y: 10
        },
        animate: {
            opacity: isDragging ? 0.4 : 1,
            y: 0,
            scale: isDragging && isOverlay ? 1.05 : 1,
            borderColor: isDragging && isOverlay ? 'rgba(255, 161, 0, 0.5)' : 'rgba(255, 255, 255, 0.05)',
            boxShadow: isDragging && isOverlay ? '0 10px 30px rgba(0,0,0,0.5)' : 'none'
        },
        whileHover: {
            scale: 1.01,
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            borderColor: 'rgba(255, 255, 255, 0.2)'
        },
        whileTap: {
            scale: 0.98
        },
        transition: {
            type: 'spring',
            stiffness: 300,
            damping: 25,
            layout: {
                duration: 0.2
            }
        },
        className: `exercise-card ${isDragging ? 'dragging' : ''}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "exercise-drag-handle",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: "12",
                    height: "18",
                    viewBox: "0 0 12 18",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "2",
                            cy: "2",
                            r: "1.5",
                            fill: "currentColor",
                            opacity: "0.3"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "2",
                            cy: "9",
                            r: "1.5",
                            fill: "currentColor",
                            opacity: "0.3"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "2",
                            cy: "16",
                            r: "1.5",
                            fill: "currentColor",
                            opacity: "0.3"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "10",
                            cy: "2",
                            r: "1.5",
                            fill: "currentColor",
                            opacity: "0.3"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "10",
                            cy: "9",
                            r: "1.5",
                            fill: "currentColor",
                            opacity: "0.3"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "10",
                            cy: "16",
                            r: "1.5",
                            fill: "currentColor",
                            opacity: "0.3"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "exercise-thumbnail-box",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: exercise.thumbnail || 'https://via.placeholder.com/60',
                    alt: exercise.name,
                    className: "exercise-thumbnail-img"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "exercise-card-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        className: "exercise-card-name",
                        children: exercise.name
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "exercise-card-tags",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "tag-muscle",
                                children: exercise.muscleGroup
                            }),
                            exercise.type.slice(0, 1).map((t)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: `tag-type tag-${t.toLowerCase()}`,
                                    children: t
                                }, t))
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","framer-motion":"9sgBs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b8xmx":[function(require,module,exports,__globalThis) {
// 🔹 React Core
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EXERCISE_TYPES", ()=>EXERCISE_TYPES);
parcelHelpers.export(exports, "ExerciseLibrary", ()=>ExerciseLibrary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 Drag & Drop Libraries
var _utilities = require("@dnd-kit/utilities");
var _sortable = require("@dnd-kit/sortable");
// 🔹 Internal Components
var _exerciseCard = require("./ExerciseCard");
const MUSCLE_GROUPS = [
    {
        value: 'all',
        label: 'All'
    },
    {
        value: 'lower-body',
        label: 'Lower Body'
    },
    {
        value: 'upper-body',
        label: 'Upper Body'
    },
    {
        value: 'full-body',
        label: 'Full Body'
    },
    {
        value: 'core',
        label: 'Core'
    }
];
const EXERCISE_TYPES = [
    {
        value: 'all',
        label: 'All'
    },
    {
        value: 'warmup',
        label: 'Warmup'
    },
    {
        value: 'main',
        label: 'Main'
    },
    {
        value: 'cooldown',
        label: 'Cooldown'
    },
    {
        value: 'fitness',
        label: 'Fitness'
    },
    {
        value: 'cardio',
        label: 'Cardio'
    }
];
const SortableExerciseItem = ({ ex, index, letter })=>{
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = (0, _sortable.useSortable)({
        id: ex._id
    });
    const style = {
        transform: (0, _utilities.CSS).Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.4 : 1
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: setNodeRef,
        style: style,
        ...attributes,
        ...listeners,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exerciseCard.ExerciseCard), {
            exercise: ex,
            index: index,
            letterKey: letter,
            isDragging: false
        })
    });
};
const ExerciseLibrary = ({ store, isOpen, onClose })=>{
    const { search, setSearch, muscleFilter, setMuscleFilter, typeFilter, setTypeFilter, filteredExercises, exercises, draggedExercise, draggedOverSlot } = store;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("aside", {
        id: "exercise-library",
        className: `exercise-library ${isOpen ? 'open' : ''}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "lib-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "Exercise Library"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "lib-close-btn",
                        onClick: onClose,
                        children: "\xd7"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "lib-search",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        placeholder: "Search movements...",
                        value: search,
                        onChange: (e)=>setSearch(e.target.value)
                    }),
                    search && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "search-clear-btn",
                        onClick: ()=>setSearch(''),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: "16",
                            height: "16",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                    x1: "18",
                                    y1: "6",
                                    x2: "6",
                                    y2: "18"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                    x1: "6",
                                    y1: "6",
                                    x2: "18",
                                    y2: "18"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "lib-filters",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "lib-filter-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: "Muscle Groups"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "pill-container",
                                children: MUSCLE_GROUPS.map((g)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: `filter-pill ${muscleFilter === g.value ? 'active' : ''}`,
                                        onClick: ()=>setMuscleFilter(g.value),
                                        children: g.label
                                    }, g.value))
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "lib-filter-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: "Exercise Type"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "pill-container",
                                children: EXERCISE_TYPES.map((t)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: `filter-pill ${typeFilter === t.value ? 'active' : ''} ${draggedOverSlot && draggedExercise?.type.some((et)=>et.toLowerCase() === t.value) ? 'pulse' : ''}`,
                                        onClick: ()=>setTypeFilter(t.value),
                                        children: t.label
                                    }, t.value))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "lib-list-container",
                children: Object.keys(filteredExercises).sort().map((letter)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "lib-letter-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "lib-letter-header",
                                children: letter
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "lib-letter-items",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sortable.SortableContext), {
                                    items: filteredExercises[letter].map((ex)=>ex._id),
                                    strategy: (0, _sortable.verticalListSortingStrategy),
                                    children: filteredExercises[letter].map((ex, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableExerciseItem, {
                                            ex: ex,
                                            index: index,
                                            letter: letter,
                                            draggedExercise: draggedExercise
                                        }, ex._id))
                                })
                            })
                        ]
                    }, letter))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "lib-footer",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Drag any exercise into a day slot"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        children: [
                            exercises.length,
                            " movements available"
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@dnd-kit/utilities":"iX0Y8","@dnd-kit/sortable":"cMVEG","./ExerciseCard":"eKiBi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cMVEG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SortableContext", ()=>SortableContext);
parcelHelpers.export(exports, "arrayMove", ()=>arrayMove);
parcelHelpers.export(exports, "arraySwap", ()=>arraySwap);
parcelHelpers.export(exports, "defaultAnimateLayoutChanges", ()=>defaultAnimateLayoutChanges);
parcelHelpers.export(exports, "defaultNewIndexGetter", ()=>defaultNewIndexGetter);
parcelHelpers.export(exports, "hasSortableData", ()=>hasSortableData);
parcelHelpers.export(exports, "horizontalListSortingStrategy", ()=>horizontalListSortingStrategy);
parcelHelpers.export(exports, "rectSortingStrategy", ()=>rectSortingStrategy);
parcelHelpers.export(exports, "rectSwappingStrategy", ()=>rectSwappingStrategy);
parcelHelpers.export(exports, "sortableKeyboardCoordinates", ()=>sortableKeyboardCoordinates);
parcelHelpers.export(exports, "useSortable", ()=>useSortable);
parcelHelpers.export(exports, "verticalListSortingStrategy", ()=>verticalListSortingStrategy);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _core = require("@dnd-kit/core");
var _utilities = require("@dnd-kit/utilities");
/**
 * Move an array item to a different position. Returns a new array with the item moved to the new position.
 */ function arrayMove(array, from, to) {
    const newArray = array.slice();
    newArray.splice(to < 0 ? newArray.length + to : to, 0, newArray.splice(from, 1)[0]);
    return newArray;
}
/**
 * Swap an array item to a different position. Returns a new array with the item swapped to the new position.
 */ function arraySwap(array, from, to) {
    const newArray = array.slice();
    newArray[from] = array[to];
    newArray[to] = array[from];
    return newArray;
}
function getSortedRects(items, rects) {
    return items.reduce((accumulator, id, index)=>{
        const rect = rects.get(id);
        if (rect) accumulator[index] = rect;
        return accumulator;
    }, Array(items.length));
}
function isValidIndex(index) {
    return index !== null && index >= 0;
}
function itemsEqual(a, b) {
    if (a === b) return true;
    if (a.length !== b.length) return false;
    for(let i = 0; i < a.length; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function normalizeDisabled(disabled) {
    if (typeof disabled === 'boolean') return {
        draggable: disabled,
        droppable: disabled
    };
    return disabled;
}
// To-do: We should be calculating scale transformation
const defaultScale = {
    scaleX: 1,
    scaleY: 1
};
const horizontalListSortingStrategy = (_ref)=>{
    var _rects$activeIndex;
    let { rects, activeNodeRect: fallbackActiveRect, activeIndex, overIndex, index } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    const itemGap = getItemGap(rects, index, activeIndex);
    if (index === activeIndex) {
        const newIndexRect = rects[overIndex];
        if (!newIndexRect) return null;
        return {
            x: activeIndex < overIndex ? newIndexRect.left + newIndexRect.width - (activeNodeRect.left + activeNodeRect.width) : newIndexRect.left - activeNodeRect.left,
            y: 0,
            ...defaultScale
        };
    }
    if (index > activeIndex && index <= overIndex) return {
        x: -activeNodeRect.width - itemGap,
        y: 0,
        ...defaultScale
    };
    if (index < activeIndex && index >= overIndex) return {
        x: activeNodeRect.width + itemGap,
        y: 0,
        ...defaultScale
    };
    return {
        x: 0,
        y: 0,
        ...defaultScale
    };
};
function getItemGap(rects, index, activeIndex) {
    const currentRect = rects[index];
    const previousRect = rects[index - 1];
    const nextRect = rects[index + 1];
    if (!currentRect || !previousRect && !nextRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.left - (previousRect.left + previousRect.width) : nextRect.left - (currentRect.left + currentRect.width);
    return nextRect ? nextRect.left - (currentRect.left + currentRect.width) : currentRect.left - (previousRect.left + previousRect.width);
}
const rectSortingStrategy = (_ref)=>{
    let { rects, activeIndex, overIndex, index } = _ref;
    const newRects = arrayMove(rects, overIndex, activeIndex);
    const oldRect = rects[index];
    const newRect = newRects[index];
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
const rectSwappingStrategy = (_ref)=>{
    let { activeIndex, index, rects, overIndex } = _ref;
    let oldRect;
    let newRect;
    if (index === activeIndex) {
        oldRect = rects[index];
        newRect = rects[overIndex];
    }
    if (index === overIndex) {
        oldRect = rects[index];
        newRect = rects[activeIndex];
    }
    if (!newRect || !oldRect) return null;
    return {
        x: newRect.left - oldRect.left,
        y: newRect.top - oldRect.top,
        scaleX: newRect.width / oldRect.width,
        scaleY: newRect.height / oldRect.height
    };
};
// To-do: We should be calculating scale transformation
const defaultScale$1 = {
    scaleX: 1,
    scaleY: 1
};
const verticalListSortingStrategy = (_ref)=>{
    var _rects$activeIndex;
    let { activeIndex, activeNodeRect: fallbackActiveRect, index, rects, overIndex } = _ref;
    const activeNodeRect = (_rects$activeIndex = rects[activeIndex]) != null ? _rects$activeIndex : fallbackActiveRect;
    if (!activeNodeRect) return null;
    if (index === activeIndex) {
        const overIndexRect = rects[overIndex];
        if (!overIndexRect) return null;
        return {
            x: 0,
            y: activeIndex < overIndex ? overIndexRect.top + overIndexRect.height - (activeNodeRect.top + activeNodeRect.height) : overIndexRect.top - activeNodeRect.top,
            ...defaultScale$1
        };
    }
    const itemGap = getItemGap$1(rects, index, activeIndex);
    if (index > activeIndex && index <= overIndex) return {
        x: 0,
        y: -activeNodeRect.height - itemGap,
        ...defaultScale$1
    };
    if (index < activeIndex && index >= overIndex) return {
        x: 0,
        y: activeNodeRect.height + itemGap,
        ...defaultScale$1
    };
    return {
        x: 0,
        y: 0,
        ...defaultScale$1
    };
};
function getItemGap$1(clientRects, index, activeIndex) {
    const currentRect = clientRects[index];
    const previousRect = clientRects[index - 1];
    const nextRect = clientRects[index + 1];
    if (!currentRect) return 0;
    if (activeIndex < index) return previousRect ? currentRect.top - (previousRect.top + previousRect.height) : nextRect ? nextRect.top - (currentRect.top + currentRect.height) : 0;
    return nextRect ? nextRect.top - (currentRect.top + currentRect.height) : previousRect ? currentRect.top - (previousRect.top + previousRect.height) : 0;
}
const ID_PREFIX = 'Sortable';
const Context = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    activeIndex: -1,
    containerId: ID_PREFIX,
    disableTransforms: false,
    items: [],
    overIndex: -1,
    useDragOverlay: false,
    sortedRects: [],
    strategy: rectSortingStrategy,
    disabled: {
        draggable: false,
        droppable: false
    }
});
function SortableContext(_ref) {
    let { children, id, items: userDefinedItems, strategy = rectSortingStrategy, disabled: disabledProp = false } = _ref;
    const { active, dragOverlay, droppableRects, over, measureDroppableContainers } = (0, _core.useDndContext)();
    const containerId = (0, _utilities.useUniqueId)(ID_PREFIX, id);
    const useDragOverlay = Boolean(dragOverlay.rect !== null);
    const items = (0, _react.useMemo)(()=>userDefinedItems.map((item)=>typeof item === 'object' && 'id' in item ? item.id : item), [
        userDefinedItems
    ]);
    const isDragging = active != null;
    const activeIndex = active ? items.indexOf(active.id) : -1;
    const overIndex = over ? items.indexOf(over.id) : -1;
    const previousItemsRef = (0, _react.useRef)(items);
    const itemsHaveChanged = !itemsEqual(items, previousItemsRef.current);
    const disableTransforms = overIndex !== -1 && activeIndex === -1 || itemsHaveChanged;
    const disabled = normalizeDisabled(disabledProp);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        if (itemsHaveChanged && isDragging) measureDroppableContainers(items);
    }, [
        itemsHaveChanged,
        items,
        isDragging,
        measureDroppableContainers
    ]);
    (0, _react.useEffect)(()=>{
        previousItemsRef.current = items;
    }, [
        items
    ]);
    const contextValue = (0, _react.useMemo)(()=>({
            activeIndex,
            containerId,
            disabled,
            disableTransforms,
            items,
            overIndex,
            useDragOverlay,
            sortedRects: getSortedRects(items, droppableRects),
            strategy
        }), [
        activeIndex,
        containerId,
        disabled.draggable,
        disabled.droppable,
        disableTransforms,
        items,
        overIndex,
        droppableRects,
        useDragOverlay,
        strategy
    ]);
    return (0, _reactDefault.default).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
const defaultNewIndexGetter = (_ref)=>{
    let { id, items, activeIndex, overIndex } = _ref;
    return arrayMove(items, activeIndex, overIndex).indexOf(id);
};
const defaultAnimateLayoutChanges = (_ref2)=>{
    let { containerId, isSorting, wasDragging, index, items, newIndex, previousItems, previousContainerId, transition } = _ref2;
    if (!transition || !wasDragging) return false;
    if (previousItems !== items && index === newIndex) return false;
    if (isSorting) return true;
    return newIndex !== index && containerId === previousContainerId;
};
const defaultTransition = {
    duration: 200,
    easing: 'ease'
};
const transitionProperty = 'transform';
const disabledTransition = /*#__PURE__*/ (0, _utilities.CSS).Transition.toString({
    property: transitionProperty,
    duration: 0,
    easing: 'linear'
});
const defaultAttributes = {
    roleDescription: 'sortable'
};
/*
 * When the index of an item changes while sorting,
 * we need to temporarily disable the transforms
 */ function useDerivedTransform(_ref) {
    let { disabled, index, node, rect } = _ref;
    const [derivedTransform, setDerivedtransform] = (0, _react.useState)(null);
    const previousIndex = (0, _react.useRef)(index);
    (0, _utilities.useIsomorphicLayoutEffect)(()=>{
        if (!disabled && index !== previousIndex.current && node.current) {
            const initial = rect.current;
            if (initial) {
                const current = (0, _core.getClientRect)(node.current, {
                    ignoreTransform: true
                });
                const delta = {
                    x: initial.left - current.left,
                    y: initial.top - current.top,
                    scaleX: initial.width / current.width,
                    scaleY: initial.height / current.height
                };
                if (delta.x || delta.y) setDerivedtransform(delta);
            }
        }
        if (index !== previousIndex.current) previousIndex.current = index;
    }, [
        disabled,
        index,
        node,
        rect
    ]);
    (0, _react.useEffect)(()=>{
        if (derivedTransform) setDerivedtransform(null);
    }, [
        derivedTransform
    ]);
    return derivedTransform;
}
function useSortable(_ref) {
    let { animateLayoutChanges = defaultAnimateLayoutChanges, attributes: userDefinedAttributes, disabled: localDisabled, data: customData, getNewIndex = defaultNewIndexGetter, id, strategy: localStrategy, resizeObserverConfig, transition = defaultTransition } = _ref;
    const { items, containerId, activeIndex, disabled: globalDisabled, disableTransforms, sortedRects, overIndex, useDragOverlay, strategy: globalStrategy } = (0, _react.useContext)(Context);
    const disabled = normalizeLocalDisabled(localDisabled, globalDisabled);
    const index = items.indexOf(id);
    const data = (0, _react.useMemo)(()=>({
            sortable: {
                containerId,
                index,
                items
            },
            ...customData
        }), [
        containerId,
        customData,
        index,
        items
    ]);
    const itemsAfterCurrentSortable = (0, _react.useMemo)(()=>items.slice(items.indexOf(id)), [
        items,
        id
    ]);
    const { rect, node, isOver, setNodeRef: setDroppableNodeRef } = (0, _core.useDroppable)({
        id,
        data,
        disabled: disabled.droppable,
        resizeObserverConfig: {
            updateMeasurementsFor: itemsAfterCurrentSortable,
            ...resizeObserverConfig
        }
    });
    const { active, activatorEvent, activeNodeRect, attributes, setNodeRef: setDraggableNodeRef, listeners, isDragging, over, setActivatorNodeRef, transform } = (0, _core.useDraggable)({
        id,
        data,
        attributes: {
            ...defaultAttributes,
            ...userDefinedAttributes
        },
        disabled: disabled.draggable
    });
    const setNodeRef = (0, _utilities.useCombinedRefs)(setDroppableNodeRef, setDraggableNodeRef);
    const isSorting = Boolean(active);
    const displaceItem = isSorting && !disableTransforms && isValidIndex(activeIndex) && isValidIndex(overIndex);
    const shouldDisplaceDragSource = !useDragOverlay && isDragging;
    const dragSourceDisplacement = shouldDisplaceDragSource && displaceItem ? transform : null;
    const strategy = localStrategy != null ? localStrategy : globalStrategy;
    const finalTransform = displaceItem ? dragSourceDisplacement != null ? dragSourceDisplacement : strategy({
        rects: sortedRects,
        activeNodeRect,
        activeIndex,
        overIndex,
        index
    }) : null;
    const newIndex = isValidIndex(activeIndex) && isValidIndex(overIndex) ? getNewIndex({
        id,
        items,
        activeIndex,
        overIndex
    }) : index;
    const activeId = active == null ? void 0 : active.id;
    const previous = (0, _react.useRef)({
        activeId,
        items,
        newIndex,
        containerId
    });
    const itemsHaveChanged = items !== previous.current.items;
    const shouldAnimateLayoutChanges = animateLayoutChanges({
        active,
        containerId,
        isDragging,
        isSorting,
        id,
        index,
        items,
        newIndex: previous.current.newIndex,
        previousItems: previous.current.items,
        previousContainerId: previous.current.containerId,
        transition,
        wasDragging: previous.current.activeId != null
    });
    const derivedTransform = useDerivedTransform({
        disabled: !shouldAnimateLayoutChanges,
        index,
        node,
        rect
    });
    (0, _react.useEffect)(()=>{
        if (isSorting && previous.current.newIndex !== newIndex) previous.current.newIndex = newIndex;
        if (containerId !== previous.current.containerId) previous.current.containerId = containerId;
        if (items !== previous.current.items) previous.current.items = items;
    }, [
        isSorting,
        newIndex,
        containerId,
        items
    ]);
    (0, _react.useEffect)(()=>{
        if (activeId === previous.current.activeId) return;
        if (activeId != null && previous.current.activeId == null) {
            previous.current.activeId = activeId;
            return;
        }
        const timeoutId = setTimeout(()=>{
            previous.current.activeId = activeId;
        }, 50);
        return ()=>clearTimeout(timeoutId);
    }, [
        activeId
    ]);
    return {
        active,
        activeIndex,
        attributes,
        data,
        rect,
        index,
        newIndex,
        items,
        isOver,
        isSorting,
        isDragging,
        listeners,
        node,
        overIndex,
        over,
        setNodeRef,
        setActivatorNodeRef,
        setDroppableNodeRef,
        setDraggableNodeRef,
        transform: derivedTransform != null ? derivedTransform : finalTransform,
        transition: getTransition()
    };
    function getTransition() {
        if (derivedTransform || // Or to prevent items jumping to back to their "new" position when items change
        itemsHaveChanged && previous.current.newIndex === index) return disabledTransition;
        if (shouldDisplaceDragSource && !(0, _utilities.isKeyboardEvent)(activatorEvent) || !transition) return undefined;
        if (isSorting || shouldAnimateLayoutChanges) return (0, _utilities.CSS).Transition.toString({
            ...transition,
            property: transitionProperty
        });
        return undefined;
    }
}
function normalizeLocalDisabled(localDisabled, globalDisabled) {
    var _localDisabled$dragga, _localDisabled$droppa;
    if (typeof localDisabled === 'boolean') return {
        draggable: localDisabled,
        // Backwards compatibility
        droppable: false
    };
    return {
        draggable: (_localDisabled$dragga = localDisabled == null ? void 0 : localDisabled.draggable) != null ? _localDisabled$dragga : globalDisabled.draggable,
        droppable: (_localDisabled$droppa = localDisabled == null ? void 0 : localDisabled.droppable) != null ? _localDisabled$droppa : globalDisabled.droppable
    };
}
function hasSortableData(entry) {
    if (!entry) return false;
    const data = entry.data.current;
    if (data && 'sortable' in data && typeof data.sortable === 'object' && 'containerId' in data.sortable && 'items' in data.sortable && 'index' in data.sortable) return true;
    return false;
}
const directions = [
    (0, _core.KeyboardCode).Down,
    (0, _core.KeyboardCode).Right,
    (0, _core.KeyboardCode).Up,
    (0, _core.KeyboardCode).Left
];
const sortableKeyboardCoordinates = (event, _ref)=>{
    let { context: { active, collisionRect, droppableRects, droppableContainers, over, scrollableAncestors } } = _ref;
    if (directions.includes(event.code)) {
        event.preventDefault();
        if (!active || !collisionRect) return;
        const filteredContainers = [];
        droppableContainers.getEnabled().forEach((entry)=>{
            if (!entry || entry != null && entry.disabled) return;
            const rect = droppableRects.get(entry.id);
            if (!rect) return;
            switch(event.code){
                case (0, _core.KeyboardCode).Down:
                    if (collisionRect.top < rect.top) filteredContainers.push(entry);
                    break;
                case (0, _core.KeyboardCode).Up:
                    if (collisionRect.top > rect.top) filteredContainers.push(entry);
                    break;
                case (0, _core.KeyboardCode).Left:
                    if (collisionRect.left > rect.left) filteredContainers.push(entry);
                    break;
                case (0, _core.KeyboardCode).Right:
                    if (collisionRect.left < rect.left) filteredContainers.push(entry);
                    break;
            }
        });
        const collisions = (0, _core.closestCorners)({
            active,
            collisionRect: collisionRect,
            droppableRects,
            droppableContainers: filteredContainers,
            pointerCoordinates: null
        });
        let closestId = (0, _core.getFirstCollision)(collisions, 'id');
        if (closestId === (over == null ? void 0 : over.id) && collisions.length > 1) closestId = collisions[1].id;
        if (closestId != null) {
            const activeDroppable = droppableContainers.get(active.id);
            const newDroppable = droppableContainers.get(closestId);
            const newRect = newDroppable ? droppableRects.get(newDroppable.id) : null;
            const newNode = newDroppable == null ? void 0 : newDroppable.node.current;
            if (newNode && newRect && activeDroppable && newDroppable) {
                const newScrollAncestors = (0, _core.getScrollableAncestors)(newNode);
                const hasDifferentScrollAncestors = newScrollAncestors.some((element, index)=>scrollableAncestors[index] !== element);
                const hasSameContainer = isSameContainer(activeDroppable, newDroppable);
                const isAfterActive = isAfter(activeDroppable, newDroppable);
                const offset = hasDifferentScrollAncestors || !hasSameContainer ? {
                    x: 0,
                    y: 0
                } : {
                    x: isAfterActive ? collisionRect.width - newRect.width : 0,
                    y: isAfterActive ? collisionRect.height - newRect.height : 0
                };
                const rectCoordinates = {
                    x: newRect.left,
                    y: newRect.top
                };
                const newCoordinates = offset.x && offset.y ? rectCoordinates : (0, _utilities.subtract)(rectCoordinates, offset);
                return newCoordinates;
            }
        }
    }
    return undefined;
};
function isSameContainer(a, b) {
    if (!hasSortableData(a) || !hasSortableData(b)) return false;
    return a.data.current.sortable.containerId === b.data.current.sortable.containerId;
}
function isAfter(a, b) {
    if (!hasSortableData(a) || !hasSortableData(b)) return false;
    if (!isSameContainer(a, b)) return false;
    return a.data.current.sortable.index < b.data.current.sortable.index;
}

},{"react":"bmhQu","@dnd-kit/core":"kD37e","@dnd-kit/utilities":"iX0Y8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bEM5Z":[function(require,module,exports,__globalThis) {
// 🔹 React Core
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgramBuilder", ()=>ProgramBuilder);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 UI Component Libraries
var _antd = require("antd");
// 🔹 Internal Components
var _programWeek = require("./ProgramWeek");
var _miniPTAiComponent = require("src/components/MiniPTAi/MiniPTAi.component");
var _miniPTAiComponentDefault = parcelHelpers.interopDefault(_miniPTAiComponent);
// 🔹 Store
var _trainingStore = require("src/store/trainingStore");
var _screenTimeTracker = require("src/utils/screenTimeTracker");
// 🔹 Assets
var _oliverBennettPng = require("url:src/assets/images/oliver-bennett.png");
var _oliverBennettPngDefault = parcelHelpers.interopDefault(_oliverBennettPng);
var _miniPtCareMp4 = require("url:src/assets/videos/mini-pt-care.mp4");
var _miniPtCareMp4Default = parcelHelpers.interopDefault(_miniPtCareMp4);
const getAIText = (option)=>{
    switch(option){
        case 'Gradually raise workout intensity':
            return "I\u2019m working on gradually increasing the workout intensity of this program";
        case 'Adjust for gym equipment':
            return "I\u2019m working on adjusting for gym equipment for this program";
        case 'Progressively increase weights or reps':
            return "I\u2019m working on progressively increasing weights or reps for this program";
        case 'Convert to superset format':
            return "I\u2019m working on converting this program to a superset format";
        default:
            return `I'm working on ${option.toLowerCase()} for this program`;
    }
};
const ProgramBuilder = ({ programBuilderRef, store, onOpenLibrary, apiProgramData, payload, onRemixWorkout, isRemixing, onAIModifyWorkout, isAIModifying, selectedAIOption = '', aiModifySuccess, setAiModifySuccess })=>{
    const { allWeeksSame, setAllWeeksSame, totalExercisesPlaced, weeks, isRemixModalOpen, setRemixModalOpen, isAiAssistantOpen, setAiAssistantOpen } = store;
    // ── Screen time tracking – AI Chat ("How can I assist you today?") ───────
    // Only tracked when the initial options list is visible (not while AI is modifying or showing success)
    const _isAIChatVisible = isAiAssistantOpen && !isAIModifying && !aiModifySuccess;
    (0, _react.useEffect)(()=>{
        if (_isAIChatVisible) (0, _screenTimeTracker.screenTimeTracker).startSection((0, _screenTimeTracker.TRAINER_SECTIONS).AI_CHAT);
        else (0, _screenTimeTracker.screenTimeTracker).stopSection((0, _screenTimeTracker.TRAINER_SECTIONS).AI_CHAT);
        return ()=>{
            (0, _screenTimeTracker.screenTimeTracker).stopSection((0, _screenTimeTracker.TRAINER_SECTIONS).AI_CHAT);
        };
    }, [
        _isAIChatVisible
    ]);
    // Store
    const { assessment } = (0, _trainingStore.trainingStore)();
    const programDurationText = apiProgramData ? `${apiProgramData.duration || 1} weeks \xb7 ${apiProgramData.datetimeList?.length || 0} days` : "8 weeks \xb7 2 days";
    const programGoal = payload?.goals || apiProgramData?.programmeName || apiProgramData?.workoutType || 'Build Muscle';
    const experienceLevel = payload?.fitness_level || 'Intermediate';
    const injuries = payload?.injured_body_parts || 'None';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("main", {
        className: "program-builder",
        ref: programBuilderRef,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                id: "builder-header-profile",
                className: "builder-header-profile",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "profile-info-section",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "profile-avatar",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: assessment?.selectedClient?.avatar || (0, _oliverBennettPngDefault.default),
                                    alt: assessment?.selectedClient?.name || 'Oliver Bennett'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "profile-name",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: assessment?.selectedClient?.name || 'Oliver Bennett'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: programDurationText
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "profile-stats",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "stat",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: "Experience Level:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    marginRight: 8
                                                },
                                                children: experienceLevel
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "experience-dots",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "dot filled"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "dot filled"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "dot filled"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "dot empty"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "dot empty"
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "stat",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: "Program Goal:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: programGoal
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "stat",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: "Pain/Injuries"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: {
                                            textTransform: 'capitalize'
                                        },
                                        children: injuries
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "builder-actions-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "getting-started-text",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                children: "Getting started:"
                            }),
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "text-light",
                                children: "Drag exercises from the library on the left into any day slot below \u2014 or use the AI panel to generate a complete plan instantly."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "action-buttons",
                        id: "builder-actions-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                id: "remix-btn",
                                className: "remix-btn",
                                onClick: onRemixWorkout,
                                disabled: isRemixing || !payload,
                                children: isRemixing ? 'Regenerating...' : 'Regenerate Workout'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                id: "ai-btn",
                                className: "ai-btn",
                                onClick: ()=>setAiAssistantOpen(true),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        style: {
                                            position: 'relative',
                                            top: '2px'
                                        },
                                        width: 16,
                                        height: 16,
                                        viewBox: "0 0 16 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M6.0714 3.63216C6.47007 2.4655 8.08207 2.43016 8.55474 3.52616L8.59474 3.63283L9.13274 5.20616C9.25603 5.56699 9.45527 5.89717 9.71702 6.17444C9.97877 6.45172 10.2969 6.66964 10.6501 6.8135L10.7947 6.8675L12.3681 7.40483C13.5347 7.8035 13.5701 9.4155 12.4747 9.88816L12.3681 9.92816L10.7947 10.4662C10.4338 10.5894 10.1035 10.7886 9.82608 11.0503C9.54869 11.3121 9.33067 11.6303 9.18674 11.9835L9.13274 12.1275L8.5954 13.7015C8.19674 14.8682 6.58474 14.9035 6.11274 13.8082L6.0714 13.7015L5.53407 12.1282C5.41086 11.7672 5.21165 11.4369 4.9499 11.1595C4.68814 10.8821 4.36993 10.6641 4.01674 10.5202L3.87274 10.4662L2.2994 9.92883C1.13207 9.53016 1.09674 7.91816 2.19274 7.44616L2.2994 7.40483L3.87274 6.8675C4.23356 6.7442 4.56374 6.54496 4.84102 6.28321C5.11829 6.02146 5.33621 5.70329 5.48007 5.35016L5.53407 5.20616L6.0714 3.63216ZM12.6667 1.3335C12.7915 1.3335 12.9137 1.36848 13.0195 1.43448C13.1253 1.50047 13.2105 1.59483 13.2654 1.70683L13.2974 1.78483L13.5307 2.46883L14.2154 2.70216C14.3404 2.74463 14.45 2.82324 14.5302 2.92804C14.6105 3.03284 14.6578 3.15911 14.6663 3.29084C14.6747 3.42258 14.6438 3.55385 14.5775 3.66802C14.5113 3.78219 14.4126 3.87412 14.2941 3.93216L14.2154 3.96416L13.5314 4.1975L13.2981 4.88216C13.2555 5.00712 13.1769 5.11663 13.072 5.19682C12.9672 5.27702 12.8409 5.32429 12.7092 5.33264C12.5774 5.341 12.4462 5.31006 12.3321 5.24375C12.2179 5.17744 12.1261 5.07874 12.0681 4.96016L12.0361 4.88216L11.8027 4.19816L11.1181 3.96483C10.9931 3.92237 10.8835 3.84375 10.8033 3.73895C10.723 3.63415 10.6756 3.50788 10.6672 3.37615C10.6588 3.24441 10.6897 3.11314 10.7559 2.99897C10.8222 2.8848 10.9208 2.79287 11.0394 2.73483L11.1181 2.70283L11.8021 2.4695L12.0354 1.78483C12.0804 1.65311 12.1654 1.53877 12.2786 1.45783C12.3918 1.37689 12.5276 1.33341 12.6667 1.3335Z",
                                            fill: "#07092C"
                                        })
                                    }),
                                    ' ',
                                    "Talk to Mini PT AI"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                id: "builder-controls",
                className: "builder-controls",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                        id: "checkbox-label",
                        className: "checkbox-label",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Checkbox), {
                                checked: allWeeksSame,
                                onChange: (e)=>{
                                    const checked = e.target.checked;
                                    setAllWeeksSame(checked);
                                    if (checked) store.toggleWeek('All weeks', true);
                                },
                                className: "all-week-same"
                            }),
                            "All weeks the same"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "placed-counter",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                children: totalExercisesPlaced
                            }),
                            " exercises placed"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "weeks-container",
                children: (allWeeksSame ? [
                    {
                        ...weeks[0],
                        _id: 'All weeks'
                    }
                ] : weeks).map((week)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programWeek.ProgramWeek), {
                        store: store,
                        week: week,
                        onOpenLibrary: onOpenLibrary
                    }, week._id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: isAiAssistantOpen,
                onCancel: ()=>{
                    setAiAssistantOpen(false);
                    if (aiModifySuccess && setAiModifySuccess) setAiModifySuccess(false);
                },
                footer: null,
                centered: true,
                width: 480,
                rootClassName: "antd-remix",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: `remix-modal-content ${isAIModifying ? `ai-program-generating` : ``}`,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miniPTAiComponentDefault.default), {
                            src: (0, _miniPtCareMp4Default.default)
                        }),
                        aiModifySuccess ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "remix-success-content",
                            style: {
                                textAlign: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    className: "mt-0",
                                    style: {
                                        fontSize: '24px',
                                        marginBottom: '24px',
                                        fontWeight: 600,
                                        lineHeight: `36px`
                                    },
                                    children: "The program has been updated with the new information"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    style: {
                                        background: '#fff',
                                        color: '#000',
                                        border: 'none',
                                        padding: '12px 24px',
                                        borderRadius: '12px',
                                        cursor: 'pointer',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        fontSize: '16px',
                                        fontWeight: 500,
                                        transition: 'opacity 0.2s ease',
                                        minHeight: 54
                                    },
                                    onClick: ()=>{
                                        setAiAssistantOpen(false);
                                        if (setAiModifySuccess) setAiModifySuccess(false);
                                    },
                                    onMouseEnter: (e)=>e.currentTarget.style.opacity = '0.9',
                                    onMouseLeave: (e)=>e.currentTarget.style.opacity = '1',
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            width: 13,
                                            height: 10,
                                            viewBox: "0 0 13 10",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M11.6667 5H1M1 5L5 9M1 5L5 1",
                                                stroke: "#07092C",
                                                strokeWidth: 2,
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        "See Program"
                                    ]
                                })
                            ]
                        }) : isAIModifying ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "remix-modifying-content",
                            style: {
                                textAlign: 'center'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                style: {
                                    fontSize: '24px',
                                    fontWeight: 600,
                                    color: '#fff',
                                    lineHeight: `36px`
                                },
                                children: getAIText(selectedAIOption)
                            })
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    children: "How can I assist you today?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "remix-options-list",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "remix-option-btn",
                                            onClick: ()=>onAIModifyWorkout && onAIModifyWorkout('Gradually raise workout intensity'),
                                            children: "Gradually raise workout intensity"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "remix-option-btn",
                                            onClick: ()=>onAIModifyWorkout && onAIModifyWorkout('Adjust for gym equipment'),
                                            children: "Adjust for gym equipment"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "remix-option-btn",
                                            onClick: ()=>onAIModifyWorkout && onAIModifyWorkout('Progressively increase weights or reps'),
                                            children: "Progressively increase weights or reps"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "remix-option-btn",
                                            onClick: ()=>onAIModifyWorkout && onAIModifyWorkout('Convert to superset format'),
                                            children: "Convert to superset format"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: isRemixModalOpen,
                onCancel: ()=>setRemixModalOpen(false),
                footer: null,
                centered: true,
                width: 480,
                rootClassName: "antd-remix",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    className: "text-center",
                    children: "Remix"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "lib-trigger-btn",
                onClick: onOpenLibrary,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: 20,
                    height: 20,
                    viewBox: "0 0 20 20",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M5 3.667C5 2.95967 5.28099 2.28131 5.78115 1.78115C6.28131 1.28099 6.95967 1 7.667 1H16.333C16.6832 1 17.03 1.06898 17.3536 1.20301C17.6772 1.33704 17.9712 1.53349 18.2189 1.78115C18.4665 2.0288 18.663 2.32281 18.797 2.64638C18.931 2.96996 19 3.31676 19 3.667V12.333C19 12.6832 18.931 13.03 18.797 13.3536C18.663 13.6772 18.4665 13.9712 18.2189 14.2189C17.9712 14.4665 17.6772 14.663 17.3536 14.797C17.03 14.931 16.6832 15 16.333 15H7.667C6.95967 15 6.28131 14.719 5.78115 14.2189C5.28099 13.7187 5 13.0403 5 12.333V3.667Z",
                            stroke: "#04051B",
                            strokeWidth: 2,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M2.012 5.26C1.705 5.43443 1.44965 5.68702 1.2719 5.99211C1.09415 6.2972 1.00034 6.64391 1 6.997V16.997C1 18.097 1.9 18.997 3 18.997H13C13.75 18.997 14.158 18.612 14.5 17.997M9 5H14M9 8H15M9 11H12",
                            stroke: "#04051B",
                            strokeWidth: 2,
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Checkbox","cz5r0","default"],["Modal","kY4DD","default"]],"./ProgramWeek":"6J3nT","src/components/MiniPTAi/MiniPTAi.component":"hutSZ","src/store/trainingStore":"eYkDC","src/utils/screenTimeTracker":"dwAC9","url:src/assets/images/oliver-bennett.png":"a8hcL","url:src/assets/videos/mini-pt-care.mp4":"5knEg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6J3nT":[function(require,module,exports,__globalThis) {
// 🔹 React Core
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgramWeek", ()=>ProgramWeek);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 Animation Library
var _framerMotion = require("framer-motion");
// 🔹 Internal Components
var _programDaySlot = require("./ProgramDaySlot");
var _commandDialog = require("src/components/Modals/CommandDialog/CommandDialog");
var _commandDialogDefault = parcelHelpers.interopDefault(_commandDialog);
// 🔹 Constants
var _exerciseLibrary = require("./ExerciseLibrary");
const DAYS_OF_WEEK = [
    'MON',
    'TUE',
    'WED',
    'THU',
    'FRI',
    'SAT',
    'SUN'
];
const ProgramWeek = ({ store, week, onOpenLibrary })=>{
    const { toggleWeek, deleteWeek, toggleDaySelection, formattedDays } = store;
    const [deleteConfirmVisible, setDeleteConfirmVisible] = (0, _react.useState)(false);
    const availableDays = DAYS_OF_WEEK.filter((d)=>formattedDays.includes(d));
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `program-week ${week.isOpen ? 'open' : 'closed'}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "week-header",
                onClick: ()=>toggleWeek(week._id),
                style: {
                    cursor: 'pointer'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "week-header-content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: week._id
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.AnimatePresence), {
                                children: week.isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                                    className: "week-days-selector",
                                    initial: {
                                        opacity: 0,
                                        x: -10
                                    },
                                    animate: {
                                        opacity: 1,
                                        x: 0
                                    },
                                    exit: {
                                        opacity: 0,
                                        x: -10
                                    },
                                    onClick: (e)=>e.stopPropagation(),
                                    children: availableDays.map((day)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `day-pill ${week.selectedDays.includes(day) ? 'selected' : ''}`,
                                            onClick: (e)=>{
                                                e.stopPropagation();
                                                toggleDaySelection(week._id, day);
                                            },
                                            children: day
                                        }, day))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "week-header-actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "toggle-btn",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    toggleWeek(week._id);
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).svg, {
                                    width: 20,
                                    height: 20,
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    animate: {
                                        rotate: !week.isOpen ? 180 : 0
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M4.16732 12.5L10.0007 6.66667L15.834 12.5",
                                        stroke: "white",
                                        strokeWidth: "1.66667",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "delete-btn",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    setDeleteConfirmVisible(true);
                                },
                                disabled: week._id === 'All weeks' || store.weeks.length === 1,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    width: 20,
                                    height: 20,
                                    viewBox: "0 0 20 20",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M15.832 5.83334L15.1095 15.9516C15.0796 16.3721 14.8914 16.7656 14.583 17.053C14.2745 17.3402 13.8686 17.5 13.447 17.5H6.55036C6.12881 17.5 5.72292 17.3402 5.41443 17.053C5.10594 16.7656 4.91779 16.3721 4.88786 15.9516L4.16536 5.83334M8.33203 9.16666V14.1666M11.6654 9.16666V14.1666M12.4987 5.83334V3.33334C12.4987 3.11233 12.4109 2.90036 12.2546 2.74408C12.0983 2.5878 11.8864 2.5 11.6654 2.5H8.33203C8.11101 2.5 7.89906 2.5878 7.74277 2.74408C7.58649 2.90036 7.49869 3.11233 7.49869 3.33334V5.83334M3.33203 5.83334H16.6654",
                                        stroke: "#999999",
                                        strokeWidth: "1.33333",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.AnimatePresence), {
                children: week.isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _framerMotion.motion).div, {
                    initial: {
                        height: 0,
                        opacity: 0
                    },
                    animate: {
                        height: 'auto',
                        opacity: 1
                    },
                    exit: {
                        height: 0,
                        opacity: 0
                    },
                    transition: {
                        duration: 0.3,
                        ease: 'easeInOut'
                    },
                    style: {
                        overflow: 'hidden'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "week-header-mobile",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "week-days-selector",
                                children: availableDays.map((day)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: `day-pill ${week.selectedDays.includes(day) ? 'selected' : ''}`,
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            toggleDaySelection(week._id, day);
                                        },
                                        children: day
                                    }, day))
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            id: week._id === 'Week 1' ? 'week-days-scroll-container' : undefined,
                            className: "week-days-scroll-container",
                            children: [
                                ...week.selectedDays
                            ].sort((a, b)=>DAYS_OF_WEEK.indexOf(a) - DAYS_OF_WEEK.indexOf(b)).map((day)=>{
                                const dayData = week.daysData[day] || {};
                                const exCount = Object.values(dayData).reduce((sum, arr)=>sum + (arr || []).length, 0);
                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "day-column",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "day-column-header",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    children: day
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    children: [
                                                        exCount,
                                                        " ex"
                                                    ]
                                                })
                                            ]
                                        }),
                                        (0, _exerciseLibrary.EXERCISE_TYPES).filter((t)=>![
                                                'all',
                                                'fitness',
                                                'cardio'
                                            ]?.includes(t.value)).map((type)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programDaySlot.ProgramDaySlot), {
                                                store: store,
                                                weekId: week._id,
                                                dayStr: day,
                                                slotType: type.label,
                                                placedExercises: dayData[type.label] || [],
                                                recommendedCount: Math.floor(10 / ((0, _exerciseLibrary.EXERCISE_TYPES).length - 1)),
                                                onOpenLibrary: onOpenLibrary
                                            }, type.value))
                                    ]
                                }, day);
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commandDialogDefault.default), {
                visible: deleteConfirmVisible,
                onClose: ()=>setDeleteConfirmVisible(false),
                onConfirm: ()=>{
                    deleteWeek(week._id);
                    setDeleteConfirmVisible(false);
                },
                type: "warning",
                title: "Delete Week",
                description: `Are you sure you want to delete ${week._id}?`,
                confirmText: "Delete",
                cancelText: "Cancel"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","framer-motion":[["AnimatePresence","QteOV"],["motion","9sgBs"]],"./ProgramDaySlot":"79Z2d","src/components/Modals/CommandDialog/CommandDialog":"1t08c","./ExerciseLibrary":"b8xmx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"79Z2d":[function(require,module,exports,__globalThis) {
// 🔹 React Core
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgramDaySlot", ()=>ProgramDaySlot);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 Drag & Drop Library
var _core = require("@dnd-kit/core");
// 🔹 UI Component Libraries
var _antd = require("antd");
// 🔹 Assets
var _icCopyPng = require("url:../../../../assets/images/program-menu/ic_copy.png");
var _icCopyPngDefault = parcelHelpers.interopDefault(_icCopyPng);
var _icEmptyPng = require("url:../../../../assets/images/program-menu/ic_empty.png");
var _icEmptyPngDefault = parcelHelpers.interopDefault(_icEmptyPng);
var _icPastePng = require("url:../../../../assets/images/program-menu/ic_paste.png");
var _icPastePngDefault = parcelHelpers.interopDefault(_icPastePng);
var _icRemixPng = require("url:../../../../assets/images/program-menu/ic_remix.png");
var _icRemixPngDefault = parcelHelpers.interopDefault(_icRemixPng);
const ProgramDaySlot = ({ store, weekId, dayStr, slotType, placedExercises, recommendedCount, onOpenLibrary })=>{
    const { draggedExercise, removePlacedExercise, updatePlacedExercise, copySlot, pasteSlot, emptySlot, clipboard, setRemixModalOpen } = store;
    const [isEditModalOpen, setIsEditModalOpen] = (0, _react.useState)(false);
    const [isTraineeViewOpen, setIsTraineeViewOpen] = (0, _react.useState)(false);
    const [editingEx, setEditingEx] = (0, _react.useState)(null);
    const [repOrDurationType, setRepOrDurationType] = (0, _react.useState)(3);
    const [repOrDuration, setRepOrDuration] = (0, _react.useState)('');
    const getMetricSummary = (ex)=>{
        if (ex.metricType === 'duration') return `${ex.sets}\xd7${ex.duration || '0s'}`;
        return `${ex.sets}\xd7${ex.reps || 0}`;
    };
    const handleEditOpen = (ex)=>{
        const supportedMetrics = ex.supportedMetrics || [
            'reps',
            'duration'
        ];
        const metricType = ex.metricType || (ex.duration ? 'duration' : 'reps');
        setEditingEx({
            ...ex,
            metricType,
            supportedMetrics,
            restBetweenSets: ex.restBetweenSets || '30s',
            restAfterExercise: ex.restAfterExercise || '30s'
        });
        setRepOrDurationType(supportedMetrics.length === 2 ? 3 : supportedMetrics.includes('duration') ? 2 : 1);
        setRepOrDuration(metricType === 'duration' ? 'Duration' : 'Reps');
        setIsEditModalOpen(true);
    };
    const handleSave = ()=>{
        if (editingEx) updatePlacedExercise(weekId, dayStr, slotType, editingEx.placedId, {
            sets: editingEx.sets,
            reps: editingEx.reps,
            duration: editingEx.duration,
            metricType: editingEx.metricType,
            restBetweenSets: editingEx.restBetweenSets,
            restAfterExercise: editingEx.restAfterExercise
        });
        setIsEditModalOpen(false);
    };
    const handleCopy = ()=>{
        if (placedExercises.length > 0) {
            copySlot(placedExercises, slotType);
            (0, _antd.message).success('Exercises copied to clipboard');
        }
    };
    const handlePaste = ()=>{
        if (!clipboard) {
            (0, _antd.message).info('Clipboard is empty');
            return;
        }
        if (pasteSlot(weekId, dayStr, slotType)) (0, _antd.message).success('Exercises pasted successfully');
        else (0, _antd.message).error(`Cannot paste: Slot type mismatch (Expected ${clipboard.type})`);
    };
    const handleEmpty = ()=>{
        emptySlot(weekId, dayStr, slotType);
        (0, _antd.message).success('Slot cleared');
    };
    const isMatchingType = (0, _react.useMemo)(()=>{
        if (!draggedExercise) return false;
        return draggedExercise.type.some((t)=>t.toLowerCase() === slotType.toLowerCase());
    }, [
        draggedExercise,
        slotType
    ]);
    const { setNodeRef, isOver } = (0, _core.useDroppable)({
        id: `slot-${weekId}-${dayStr}-${slotType}`
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: setNodeRef,
                className: `program-day-slot ${isOver ? isMatchingType ? 'match-over' : 'mismatch-over' : ''} ${placedExercises?.length > 0 ? 'solid' : 'dashed'}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "slot-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                children: [
                                    slotType,
                                    " \xb7 Recommended: ",
                                    recommendedCount
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                menu: {
                                    items: [
                                        {
                                            key: 'copy',
                                            label: 'Copy',
                                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: (0, _icCopyPngDefault.default),
                                                alt: "copy icon",
                                                width: 18,
                                                height: 18
                                            }),
                                            disabled: placedExercises.length === 0,
                                            onClick: handleCopy
                                        },
                                        {
                                            type: 'divider'
                                        },
                                        {
                                            key: 'paste',
                                            label: 'Paste',
                                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: (0, _icPastePngDefault.default),
                                                alt: "paste icon",
                                                width: 18,
                                                height: 18
                                            }),
                                            disabled: !clipboard,
                                            onClick: handlePaste
                                        },
                                        {
                                            type: 'divider'
                                        },
                                        {
                                            key: 'remix',
                                            label: 'Remix',
                                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: (0, _icRemixPngDefault.default),
                                                alt: "remix icon",
                                                width: 18,
                                                height: 18
                                            }),
                                            onClick: ()=>setRemixModalOpen(true),
                                            disabled: true
                                        },
                                        {
                                            type: 'divider'
                                        },
                                        {
                                            key: 'empty',
                                            label: 'Empty',
                                            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: (0, _icEmptyPngDefault.default),
                                                alt: "empty icon",
                                                width: 18,
                                                height: 18
                                            }),
                                            disabled: !placedExercises.length,
                                            onClick: handleEmpty
                                        }
                                    ]
                                },
                                trigger: [
                                    'click'
                                ],
                                placement: "bottomRight",
                                rootClassName: "slot-options",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "slot-options",
                                    children: "\u22EE"
                                })
                            })
                        ]
                    }),
                    placedExercises.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "slot-empty",
                        onClick: onOpenLibrary,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "plus-icon",
                                children: "+"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Drop here"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "slot-items",
                        children: placedExercises.map((ex)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "placed-exercise",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "placed-thumbnail",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: ex.thumbnail || 'https://via.placeholder.com/40',
                                            alt: ex.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "text-ellipsis placed-info",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                className: "text-ellipsis",
                                                title: ex.name,
                                                children: ex.name
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "text-ellipsis",
                                                children: [
                                                    getMetricSummary(ex),
                                                    " \xb7 ",
                                                    ex.rest
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "placed-meta",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "impact-text",
                                                children: ex.impact
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "placed-actions",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        id: "edit-btn",
                                                        className: "edit-btn",
                                                        onClick: ()=>handleEditOpen(ex),
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            width: 16,
                                                            height: 16,
                                                            viewBox: "0 0 16 16",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M9.95545 3.68744L12.3128 6.04477M10.9554 2.68744C11.2681 2.37484 11.692 2.19922 12.1341 2.19922C12.5762 2.19922 13.0002 2.37484 13.3128 2.68744C13.6254 3.00004 13.801 3.42402 13.801 3.86611C13.801 4.30819 13.6254 4.73217 13.3128 5.04477L4.13411 14.2234H1.80078V11.8421L10.9554 2.68744Z",
                                                                stroke: "#FFA100",
                                                                strokeWidth: "1.33333",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "remove-btn",
                                                        onClick: ()=>removePlacedExercise(weekId, dayStr, slotType, ex.placedId),
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            width: 16,
                                                            height: 16,
                                                            viewBox: "0 0 16 16",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M12 4L4 12M4 4L12 12",
                                                                stroke: "#E5E5E5",
                                                                strokeWidth: 2,
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, ex.placedId))
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                title: "Edit Exercise",
                open: isEditModalOpen,
                onCancel: ()=>setIsEditModalOpen(false),
                footer: null,
                centered: true,
                width: 480,
                rootClassName: "pg-edit-modal pg-edit-exercise",
                children: editingEx && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "pg-modal-content",
                    children: isTraineeViewOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "pg-trainee-view-mode",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "trainee-view-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "mt-0",
                                        children: "Trainee View Mode"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: "This is a preview mode example. Your actual selected exercise and media will appear here in the live trainee view."
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        className: "exit-trainee-view-btn",
                                        onClick: ()=>setIsTraineeViewOpen(false),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: "20",
                                                height: "20",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "3"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                        x1: "1",
                                                        y1: "1",
                                                        x2: "23",
                                                        y2: "23"
                                                    })
                                                ]
                                            }),
                                            "Exist View as Trainee"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "phone-mockup",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "phone-frame",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "phone-screen",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "phone-status-bar",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "time",
                                                        children: "9:41"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "status-icons",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                width: 20,
                                                                height: 13,
                                                                viewBox: "0 0 20 13",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M19.2 1.14623C19.2 0.513183 18.7224 0 18.1333 0H17.0667C16.4776 0 16 0.513183 16 1.14623V11.0802C16 11.7132 16.4776 12.2264 17.0667 12.2264H18.1333C18.7224 12.2264 19.2 11.7132 19.2 11.0802V1.14623ZM11.7659 2.44528H12.8326C13.4217 2.44528 13.8992 2.97078 13.8992 3.61902V11.0527C13.8992 11.7009 13.4217 12.2264 12.8326 12.2264H11.7659C11.1768 12.2264 10.6992 11.7009 10.6992 11.0527V3.61902C10.6992 2.97078 11.1768 2.44528 11.7659 2.44528ZM7.43411 5.09433H6.36745C5.77834 5.09433 5.30078 5.62652 5.30078 6.28301V11.0377C5.30078 11.6942 5.77834 12.2264 6.36745 12.2264H7.43411C8.02322 12.2264 8.50078 11.6942 8.50078 11.0377V6.28301C8.50078 5.62652 8.02322 5.09433 7.43411 5.09433ZM2.13333 7.53962H1.06667C0.477563 7.53962 0 8.06421 0 8.71132V11.0547C0 11.7018 0.477563 12.2264 1.06667 12.2264H2.13333C2.72244 12.2264 3.2 11.7018 3.2 11.0547V8.71132C3.2 8.06421 2.72244 7.53962 2.13333 7.53962Z",
                                                                    fill: "#04051B"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                width: 18,
                                                                height: 13,
                                                                viewBox: "0 0 18 13",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    fillRule: "evenodd",
                                                                    clipRule: "evenodd",
                                                                    d: "M8.5713 2.46628C11.0584 2.46639 13.4504 3.38847 15.2529 5.04195C15.3887 5.1696 15.6056 5.16799 15.7393 5.03834L17.0368 3.77487C17.1045 3.70911 17.1422 3.62004 17.1417 3.52735C17.1411 3.43467 17.1023 3.34603 17.0338 3.28104C12.3028 -1.09368 4.83907 -1.09368 0.108056 3.28104C0.039524 3.34598 0.000639766 3.4346 7.82398e-06 3.52728C-0.000624118 3.61996 0.0370483 3.70906 0.104689 3.77487L1.40255 5.03834C1.53615 5.16819 1.75327 5.1698 1.88893 5.04195C3.69167 3.38836 6.08395 2.46628 8.5713 2.46628ZM8.56795 6.68656C9.92527 6.68647 11.2341 7.19821 12.2403 8.12234C12.3763 8.2535 12.5907 8.25065 12.7234 8.11593L14.0106 6.79663C14.0784 6.72742 14.1161 6.63355 14.1151 6.536C14.1141 6.43844 14.0746 6.34536 14.0054 6.27757C10.9416 3.38672 6.19688 3.38672 3.13305 6.27757C3.06384 6.34536 3.02435 6.43849 3.02345 6.53607C3.02254 6.63366 3.06028 6.72752 3.12822 6.79663L4.41513 8.11593C4.54778 8.25065 4.76215 8.2535 4.89823 8.12234C5.90368 7.19882 7.21152 6.68713 8.56795 6.68656ZM11.0924 9.48011C11.0943 9.58546 11.0572 9.68703 10.9899 9.76084L8.81327 12.2156C8.74946 12.2877 8.66247 12.3283 8.5717 12.3283C8.48093 12.3283 8.39394 12.2877 8.33013 12.2156L6.1531 9.76084C6.08585 9.68697 6.04886 9.58537 6.05085 9.48002C6.05284 9.37467 6.09365 9.27491 6.16364 9.20429C7.55374 7.8904 9.58966 7.8904 10.9798 9.20429C11.0497 9.27497 11.0904 9.37476 11.0924 9.48011Z",
                                                                    fill: "#04051B"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                width: 28,
                                                                height: 13,
                                                                viewBox: "0 0 28 13",
                                                                fill: "none",
                                                                xmlns: "http://www.w3.org/2000/svg",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                        opacity: "0.35",
                                                                        x: "0.5",
                                                                        y: "0.5",
                                                                        width: 24,
                                                                        height: 12,
                                                                        rx: "3.8",
                                                                        stroke: "#04051B"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                        opacity: "0.4",
                                                                        d: "M26 4.78113V8.8566C26.8047 8.51143 27.328 7.70847 27.328 6.81886C27.328 5.92926 26.8047 5.1263 26 4.78113Z",
                                                                        fill: "#04051B"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                        x: 2,
                                                                        y: 2,
                                                                        width: 21,
                                                                        height: 9,
                                                                        rx: "2.5",
                                                                        fill: "#04051B"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "phone-nav",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "nav-back",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            width: 24,
                                                            height: 24,
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M15 18L9 12L15 6",
                                                                stroke: "#04051B",
                                                                strokeWidth: 2,
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "nav-title",
                                                        children: "Move details"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: "nav-more",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                            width: 24,
                                                            height: 24,
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z",
                                                                    stroke: "#07092C",
                                                                    strokeWidth: 2,
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M19 13C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11C18.4477 11 18 11.4477 18 12C18 12.5523 18.4477 13 19 13Z",
                                                                    stroke: "#07092C",
                                                                    strokeWidth: 2,
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M5 13C5.55228 13 6 12.5523 6 12C6 11.4477 5.55228 11 5 11C4.44772 11 4 11.4477 4 12C4 12.5523 4.44772 13 5 13Z",
                                                                    stroke: "#07092C",
                                                                    strokeWidth: 2,
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "phone-content",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "exercise-header-nav",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                className: "arrow-btn",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                    width: "16",
                                                                    height: "16",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "2",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                            x1: "19",
                                                                            y1: "12",
                                                                            x2: "5",
                                                                            y2: "12"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                                            points: "12 19 5 12 12 5"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                children: editingEx.name
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                className: "arrow-btn",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                    width: "16",
                                                                    height: "16",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "2",
                                                                    strokeLinecap: "round",
                                                                    strokeLinejoin: "round",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                            x1: "5",
                                                                            y1: "12",
                                                                            x2: "19",
                                                                            y2: "12"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                                            points: "12 5 19 12 12 19"
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "exercise-media",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: editingEx.thumbnail,
                                                                alt: editingEx.name
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                className: "expand-btn",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                    width: 24,
                                                                    height: 24,
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    xmlns: "http://www.w3.org/2000/svg",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                        d: "M20 8V6H18C17.7167 6 17.4793 5.904 17.288 5.712C17.0967 5.52 17.0007 5.28267 17 5C16.9993 4.71733 17.0953 4.48 17.288 4.288C17.4807 4.096 17.718 4 18 4H20C20.55 4 21.021 4.196 21.413 4.588C21.805 4.98 22.0007 5.45067 22 6V8C22 8.28333 21.904 8.521 21.712 8.713C21.52 8.905 21.2827 9.00067 21 9C20.7173 8.99933 20.48 8.90333 20.288 8.712C20.096 8.52067 20 8.28333 20 8ZM2 8V6C2 5.45 2.196 4.97933 2.588 4.588C2.98 4.19667 3.45067 4.00067 4 4H6C6.28333 4 6.521 4.096 6.713 4.288C6.905 4.48 7.00067 4.71733 7 5C6.99933 5.28267 6.90333 5.52033 6.712 5.713C6.52067 5.90567 6.28333 6.00133 6 6H4V8C4 8.28333 3.904 8.521 3.712 8.713C3.52 8.905 3.28267 9.00067 3 9C2.71733 8.99933 2.48 8.90333 2.288 8.712C2.096 8.52067 2 8.28333 2 8ZM20 20H18C17.7167 20 17.4793 19.904 17.288 19.712C17.0967 19.52 17.0007 19.2827 17 19C16.9993 18.7173 17.0953 18.48 17.288 18.288C17.4807 18.096 17.718 18 18 18H20V16C20 15.7167 20.096 15.4793 20.288 15.288C20.48 15.0967 20.7173 15.0007 21 15C21.2827 14.9993 21.5203 15.0953 21.713 15.288C21.9057 15.4807 22.0013 15.718 22 16V18C22 18.55 21.8043 19.021 21.413 19.413C21.0217 19.805 20.5507 20.0007 20 20ZM4 20C3.45 20 2.97933 19.8043 2.588 19.413C2.19667 19.0217 2.00067 18.5507 2 18V16C2 15.7167 2.096 15.4793 2.288 15.288C2.48 15.0967 2.71733 15.0007 3 15C3.28267 14.9993 3.52033 15.0953 3.713 15.288C3.90567 15.4807 4.00133 15.718 4 16V18H6C6.28333 18 6.521 18.096 6.713 18.288C6.905 18.48 7.00067 18.7173 7 19C6.99933 19.2827 6.90333 19.5203 6.712 19.713C6.52067 19.9057 6.28333 20.0013 6 20H4ZM6 14V10C6 9.45 6.196 8.97933 6.588 8.588C6.98 8.19667 7.45067 8.00067 8 8H16C16.55 8 17.021 8.196 17.413 8.588C17.805 8.98 18.0007 9.45067 18 10V14C18 14.55 17.8043 15.021 17.413 15.413C17.0217 15.805 16.5507 16.0007 16 16H8C7.45 16 6.97933 15.8043 6.588 15.413C6.19667 15.0217 6.00067 14.5507 6 14Z",
                                                                        fill: "white"
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "exercise-content",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "exercise-card-mini",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: editingEx.thumbnail,
                                                                        alt: editingEx.name
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "card-mini-info",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                                                                children: editingEx.name
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                children: "Primary muscle group"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "exercise-instructions",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "instructions-header",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h6", {
                                                                                children: [
                                                                                    "How to perform a ",
                                                                                    editingEx.name.toLowerCase()
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                                                width: "12",
                                                                                height: "12",
                                                                                viewBox: "0 0 24 24",
                                                                                fill: "none",
                                                                                stroke: "currentColor",
                                                                                strokeWidth: "2",
                                                                                strokeLinecap: "round",
                                                                                strokeLinejoin: "round",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                                                    points: "18 15 12 9 6 15"
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "instructions-steps",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "step",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "step-num",
                                                                                        children: "1"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                        children: "Stand with feet shoulder-width apart, knees slightly bent."
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "step",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "step-num",
                                                                                        children: "2"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                        children: "Hinge at the hips, keeping your back flat and chest up."
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "step",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "step-num",
                                                                                        children: "3"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                                        children: "Hold the barbell or dumbbells with a pronated grip (palms down)."
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "pg-modal-header-info",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "pg-modal-ex-display",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: editingEx.thumbnail,
                                                alt: editingEx.name
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: editingEx.name
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        className: "pg-view-trainee-btn",
                                        onClick: ()=>setIsTraineeViewOpen(true),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: 16,
                                                height: 16,
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "3"
                                                    })
                                                ]
                                            }),
                                            "View as Trainee"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "modal-hr"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "pg-modal-form",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "pg-form-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "pg-form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        children: "Sets"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "number",
                                                        value: editingEx.sets,
                                                        onChange: (e)=>setEditingEx((prev)=>prev ? {
                                                                    ...prev,
                                                                    sets: parseInt(e.target.value) || 0
                                                                } : null)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: `pg-form-field ${repOrDurationType === 3 ? `justify-content-between` : ``}`,
                                                children: [
                                                    repOrDurationType === 3 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "resp-or-duration",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    className: `${repOrDuration === 'Reps' ? `active` : ``}`,
                                                                    onClick: ()=>{
                                                                        setRepOrDuration('Reps');
                                                                        setEditingEx((prev)=>prev ? {
                                                                                ...prev,
                                                                                metricType: 'reps',
                                                                                reps: prev.reps || 12,
                                                                                duration: ''
                                                                            } : null);
                                                                    },
                                                                    children: "Reps"
                                                                }),
                                                                ' ',
                                                                "|",
                                                                ' ',
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    className: `${repOrDuration === 'Duration' ? `active` : ``}`,
                                                                    onClick: ()=>{
                                                                        setRepOrDuration('Duration');
                                                                        setEditingEx((prev)=>prev ? {
                                                                                ...prev,
                                                                                metricType: 'duration',
                                                                                reps: '',
                                                                                duration: prev.duration || '30s'
                                                                            } : null);
                                                                    },
                                                                    children: "Duration (sec)"
                                                                })
                                                            ]
                                                        })
                                                    }) : repOrDurationType === 2 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        children: "Duration (sec)"
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        children: "Reps"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "number",
                                                        value: editingEx.metricType === 'duration' ? (editingEx.duration || '').replace(/s$/, '') : editingEx.reps,
                                                        onChange: (e)=>{
                                                            const value = e.target.value;
                                                            setEditingEx((prev)=>prev ? prev.metricType === 'duration' ? {
                                                                    ...prev,
                                                                    reps: '',
                                                                    duration: value ? value.replace(/s$/i, '') + 's' : ''
                                                                } : {
                                                                    ...prev,
                                                                    reps: value,
                                                                    duration: ''
                                                                } : null);
                                                        }
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                        className: "modal-hr"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "pg-rest-selector-section",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: "Rest Between Sets"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "pg-rest-pills",
                                                children: [
                                                    '0s',
                                                    '30s',
                                                    '60s',
                                                    '90s'
                                                ].map((time)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: `pg-rest-pill ${editingEx.restBetweenSets === time ? 'active' : ''}`,
                                                        onClick: ()=>setEditingEx((prev)=>prev ? {
                                                                    ...prev,
                                                                    restBetweenSets: time
                                                                } : null),
                                                        children: time
                                                    }, time))
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "pg-form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        children: "Custom (sec)"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "number",
                                                        placeholder: "120",
                                                        value: ![
                                                            '0s',
                                                            '30s',
                                                            '60s',
                                                            '90s'
                                                        ].includes(editingEx.restBetweenSets || '') ? editingEx.restBetweenSets?.replace('s', '') : '',
                                                        onChange: (e)=>setEditingEx((prev)=>prev ? {
                                                                    ...prev,
                                                                    restBetweenSets: e.target.value + 's'
                                                                } : null)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                        className: "modal-hr"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "pg-rest-selector-section",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: "Rest After Exercise"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "pg-rest-pills",
                                                children: [
                                                    '0s',
                                                    '30s',
                                                    '60s',
                                                    '90s'
                                                ].map((time)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: `pg-rest-pill ${editingEx.restAfterExercise === time ? 'active' : ''}`,
                                                        onClick: ()=>setEditingEx((prev)=>prev ? {
                                                                    ...prev,
                                                                    restAfterExercise: time
                                                                } : null),
                                                        children: time
                                                    }, time))
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "pg-form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        children: "Custom (sec)"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "number",
                                                        placeholder: "120",
                                                        value: ![
                                                            '0s',
                                                            '30s',
                                                            '60s',
                                                            '90s'
                                                        ].includes(editingEx.restAfterExercise || '') ? editingEx.restAfterExercise?.replace('s', '') : '',
                                                        onChange: (e)=>setEditingEx((prev)=>prev ? {
                                                                    ...prev,
                                                                    restAfterExercise: e.target.value + 's'
                                                                } : null)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                                className: "modal-hr"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "pg-modal-save-btn",
                                onClick: handleSave,
                                children: "Save"
                            })
                        ]
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@dnd-kit/core":"kD37e","antd":[["Dropdown","cMU6A","default"],["message","4POhF","default"],["Modal","kY4DD","default"]],"url:../../../../assets/images/program-menu/ic_copy.png":"aEYlH","url:../../../../assets/images/program-menu/ic_empty.png":"kTo6W","url:../../../../assets/images/program-menu/ic_paste.png":"cehvd","url:../../../../assets/images/program-menu/ic_remix.png":"i81n7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cMU6A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dropdown = require("./dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _dropdownButton = require("./dropdown-button");
var _dropdownButtonDefault = parcelHelpers.interopDefault(_dropdownButton);
"use client";
const Dropdown = (0, _dropdownDefault.default);
/** @deprecated Please use Space.Compact + Dropdown + Button instead */ Dropdown.Button = (0, _dropdownButtonDefault.default);
exports.default = Dropdown;

},{"./dropdown":"h5C4r","./dropdown-button":"LJNYU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h5C4r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _leftOutlined = require("@ant-design/icons/es/icons/LeftOutlined");
var _leftOutlinedDefault = parcelHelpers.interopDefault(_leftOutlined);
var _rightOutlined = require("@ant-design/icons/es/icons/RightOutlined");
var _rightOutlinedDefault = parcelHelpers.interopDefault(_rightOutlined);
var _dropdown = require("@rc-component/dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _isPrimitive = require("../_util/isPrimitive");
var _isPrimitiveDefault = parcelHelpers.interopDefault(_isPrimitive);
var _placements = require("../_util/placements");
var _placementsDefault = parcelHelpers.interopDefault(_placements);
var _purePanel = require("../_util/PurePanel");
var _purePanelDefault = parcelHelpers.interopDefault(_purePanel);
var _reactNode = require("../_util/reactNode");
var _warning = require("../_util/warning");
var _zindexContext = require("../_util/zindexContext");
var _zindexContextDefault = parcelHelpers.interopDefault(_zindexContext);
var _context = require("../config-provider/context");
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _menu = require("../menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _overrideContext = require("../menu/OverrideContext");
var _internal = require("../theme/internal");
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const _Placements = [
    'topLeft',
    'topCenter',
    'topRight',
    'bottomLeft',
    'bottomCenter',
    'bottomRight',
    'top',
    'bottom'
];
const Dropdown = (props)=>{
    const { menu, arrow, prefixCls: customizePrefixCls, children, trigger, disabled, dropdownRender, popupRender, getPopupContainer, overlayClassName, rootClassName, overlayStyle, open, onOpenChange, mouseEnterDelay = 0.15, mouseLeaveDelay = 0.1, autoAdjustOverflow = true, placement = '', transitionName, classNames, styles, destroyPopupOnHide, destroyOnHidden } = props;
    const { getPrefixCls, direction, getPopupContainer: getContextPopupContainer, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('dropdown');
    const mergedProps = {
        ...props,
        mouseEnterDelay,
        mouseLeaveDelay,
        autoAdjustOverflow
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const mergedRootStyles = {
        ...contextStyle,
        ...overlayStyle,
        ...mergedStyles.root
    };
    const mergedPopupRender = popupRender || dropdownRender;
    // =================== Warning =====================
    const warning = (0, _warning.devUseWarning)('Dropdown');
    var deprecatedName, newName;
    const memoTransitionName = _react.useMemo(()=>{
        const rootPrefixCls = getPrefixCls();
        if (transitionName !== undefined) return transitionName;
        if (placement.includes('top')) return `${rootPrefixCls}-slide-down`;
        return `${rootPrefixCls}-slide-up`;
    }, [
        getPrefixCls,
        placement,
        transitionName
    ]);
    const memoPlacement = _react.useMemo(()=>{
        if (!placement) return direction === 'rtl' ? 'bottomRight' : 'bottomLeft';
        if (placement.includes('Center')) return placement.slice(0, placement.indexOf('Center'));
        return placement;
    }, [
        placement,
        direction
    ]);
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
    const [, token] = (0, _internal.useToken)();
    const child = _react.Children.only((0, _isPrimitiveDefault.default)(children) ? /*#__PURE__*/ _react.createElement("span", null, children) : children);
    const popupTrigger = (0, _reactNode.cloneElement)(child, {
        className: (0, _clsx.clsx)(`${prefixCls}-trigger`, {
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, child.props.className),
        disabled: child.props.disabled ?? disabled
    });
    const triggerActions = disabled ? [] : trigger;
    const alignPoint = !!triggerActions?.includes('contextMenu');
    // =========================== Open ============================
    const [mergedOpen, setOpen] = (0, _util.useControlledState)(false, open);
    const onInnerOpenChange = (0, _util.useEvent)((nextOpen)=>{
        onOpenChange?.(nextOpen, {
            source: 'trigger'
        });
        setOpen(nextOpen);
    });
    // =========================== Overlay ============================
    const overlayClassNameCustomized = (0, _clsx.clsx)(overlayClassName, rootClassName, hashId, cssVarCls, rootCls, contextClassName, mergedClassNames.root, {
        [`${prefixCls}-rtl`]: direction === 'rtl'
    });
    const builtinPlacements = (0, _placementsDefault.default)({
        arrowPointAtCenter: typeof arrow === 'object' && arrow.pointAtCenter,
        autoAdjustOverflow,
        offset: token.marginXXS,
        arrowWidth: arrow ? token.sizePopupArrow : 0,
        borderRadius: token.borderRadius
    });
    const onMenuClick = (0, _util.useEvent)(()=>{
        if (menu?.selectable && menu?.multiple) return;
        onOpenChange?.(false, {
            source: 'menu'
        });
        setOpen(false);
    });
    const renderOverlay = ()=>{
        // @rc-component/dropdown already can process the function of overlay, but we have check logic here.
        // So we need render the element to check and pass back to @rc-component/dropdown.
        const menuClassNames = (0, _util.omit)(mergedClassNames, [
            'root'
        ]);
        const menuStyles = (0, _util.omit)(mergedStyles, [
            'root'
        ]);
        let overlayNode;
        if (menu?.items) overlayNode = /*#__PURE__*/ _react.createElement((0, _menuDefault.default), {
            ...menu,
            classNames: {
                ...menuClassNames,
                subMenu: {
                    ...menuClassNames
                }
            },
            styles: {
                ...menuStyles,
                subMenu: {
                    ...menuStyles
                }
            }
        });
        if (mergedPopupRender) overlayNode = mergedPopupRender(overlayNode);
        overlayNode = _react.Children.only(typeof overlayNode === 'string' ? /*#__PURE__*/ _react.createElement("span", null, overlayNode) : overlayNode);
        return /*#__PURE__*/ _react.createElement((0, _overrideContext.OverrideProvider), {
            prefixCls: `${prefixCls}-menu`,
            rootClassName: (0, _clsx.clsx)(cssVarCls, rootCls),
            expandIcon: /*#__PURE__*/ _react.createElement("span", {
                className: `${prefixCls}-menu-submenu-arrow`
            }, direction === 'rtl' ? /*#__PURE__*/ _react.createElement((0, _leftOutlinedDefault.default), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            }) : /*#__PURE__*/ _react.createElement((0, _rightOutlinedDefault.default), {
                className: `${prefixCls}-menu-submenu-arrow-icon`
            })),
            mode: "vertical",
            selectable: false,
            onClick: onMenuClick,
            validator: ({ mode })=>{}
        }, overlayNode);
    };
    // =========================== zIndex ============================
    const [zIndex, contextZIndex] = (0, _hooks.useZIndex)('Dropdown', mergedRootStyles.zIndex);
    // ============================ Render ============================
    let renderNode = /*#__PURE__*/ _react.createElement((0, _dropdownDefault.default), {
        alignPoint: alignPoint,
        ...(0, _util.omit)(props, [
            'rootClassName',
            'onOpenChange'
        ]),
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        visible: mergedOpen,
        builtinPlacements: builtinPlacements,
        arrow: !!arrow,
        overlayClassName: overlayClassNameCustomized,
        prefixCls: prefixCls,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        transitionName: memoTransitionName,
        trigger: triggerActions,
        overlay: renderOverlay,
        placement: memoPlacement,
        onVisibleChange: onInnerOpenChange,
        overlayStyle: {
            ...mergedRootStyles,
            zIndex
        },
        autoDestroy: destroyOnHidden ?? destroyPopupOnHide
    }, popupTrigger);
    if (zIndex) renderNode = /*#__PURE__*/ _react.createElement((0, _zindexContextDefault.default).Provider, {
        value: contextZIndex
    }, renderNode);
    return renderNode;
};
// We don't care debug panel
const PurePanel = (0, _purePanelDefault.default)(Dropdown, 'align', undefined, 'dropdown', (prefixCls)=>prefixCls);
/* istanbul ignore next */ const WrapPurePanel = (props)=>/*#__PURE__*/ _react.createElement(PurePanel, {
        ...props
    }, /*#__PURE__*/ _react.createElement("span", null));
Dropdown._InternalPanelDoNotUseOrYouWillBeFired = WrapPurePanel;
exports.default = Dropdown;

},{"react":"bmhQu","@ant-design/icons/es/icons/LeftOutlined":"8erTV","@ant-design/icons/es/icons/RightOutlined":"lRGzb","@rc-component/dropdown":"aT3H4","@rc-component/util":"6ZBDN","clsx":"431Ou","../_util/hooks":[["useMergeSemantic","kdnMA"],["useZIndex","6noQ6"]],"../_util/isPrimitive":"fd4Cq","../_util/placements":"gti5Y","../_util/PurePanel":"31Oxh","../_util/reactNode":"78pFx","../_util/warning":"95o3w","../_util/zindexContext":"e9ihh","../config-provider/context":"75zwC","../config-provider/hooks/useCSSVarCls":"gcu2s","../menu":"et8MX","../menu/OverrideContext":"76m8O","../theme/internal":[["useToken","6x222","default"]],"./style":"1qNc0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8erTV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _leftOutlined = require("@ant-design/icons-svg/es/asn/LeftOutlined");
var _leftOutlinedDefault = parcelHelpers.interopDefault(_leftOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const LeftOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _leftOutlinedDefault.default)
    }));
/**![left](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcyNCAyMTguM1YxNDFjMC02LjctNy43LTEwLjQtMTIuOS02LjNMMjYwLjMgNDg2LjhhMzEuODYgMzEuODYgMCAwMDAgNTAuM2w0NTAuOCAzNTIuMWM1LjMgNC4xIDEyLjkuNCAxMi45LTYuM3YtNzcuM2MwLTQuOS0yLjMtOS42LTYuMS0xMi42bC0zNjAtMjgxIDM2MC0yODEuMWMzLjgtMyA2LjEtNy43IDYuMS0xMi42eiIgLz48L3N2Zz4=) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(LeftOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/LeftOutlined":"le5kr","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"le5kr":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var LeftOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"
                }
            }
        ]
    },
    "name": "left",
    "theme": "outlined"
};
exports.default = LeftOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aT3H4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dropdown = require("./Dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
exports.default = (0, _dropdownDefault.default);

},{"./Dropdown":"1vUuB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1vUuB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trigger = require("@rc-component/trigger");
var _triggerDefault = parcelHelpers.interopDefault(_trigger);
var _ref = require("@rc-component/util/es/ref");
var _clsx = require("clsx");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useAccessibility = require("./hooks/useAccessibility");
var _useAccessibilityDefault = parcelHelpers.interopDefault(_useAccessibility);
var _overlay = require("./Overlay");
var _overlayDefault = parcelHelpers.interopDefault(_overlay);
var _placements = require("./placements");
var _placementsDefault = parcelHelpers.interopDefault(_placements);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Dropdown = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { arrow = false, prefixCls = 'rc-dropdown', transitionName, animation, align, placement = 'bottomLeft', placements = (0, _placementsDefault.default), getPopupContainer, showAction, hideAction, overlayClassName, overlayStyle, visible, trigger = [
        'hover'
    ], autoFocus, overlay, children, onVisibleChange, ...otherProps } = props;
    const [triggerVisible, setTriggerVisible] = (0, _reactDefault.default).useState();
    const mergedVisible = 'visible' in props ? visible : triggerVisible;
    const mergedMotionName = animation ? `${prefixCls}-${animation}` : transitionName;
    const triggerRef = (0, _reactDefault.default).useRef(null);
    const overlayRef = (0, _reactDefault.default).useRef(null);
    const childRef = (0, _reactDefault.default).useRef(null);
    (0, _reactDefault.default).useImperativeHandle(ref, ()=>triggerRef.current);
    const handleVisibleChange = (newVisible)=>{
        setTriggerVisible(newVisible);
        onVisibleChange?.(newVisible);
    };
    (0, _useAccessibilityDefault.default)({
        visible: mergedVisible,
        triggerRef: childRef,
        onVisibleChange: handleVisibleChange,
        autoFocus,
        overlayRef
    });
    const onClick = (e)=>{
        const { onOverlayClick } = props;
        setTriggerVisible(false);
        if (onOverlayClick) onOverlayClick(e);
    };
    const getMenuElement = ()=>/*#__PURE__*/ (0, _reactDefault.default).createElement((0, _overlayDefault.default), {
            ref: overlayRef,
            overlay: overlay,
            prefixCls: prefixCls,
            arrow: arrow
        });
    const getMenuElementOrLambda = ()=>{
        if (typeof overlay === 'function') return getMenuElement;
        return getMenuElement();
    };
    const getMinOverlayWidthMatchTrigger = ()=>{
        const { minOverlayWidthMatchTrigger, alignPoint } = props;
        if ('minOverlayWidthMatchTrigger' in props) return minOverlayWidthMatchTrigger;
        return !alignPoint;
    };
    const getOpenClassName = ()=>{
        const { openClassName } = props;
        if (openClassName !== undefined) return openClassName;
        return `${prefixCls}-open`;
    };
    const childrenNode = /*#__PURE__*/ (0, _reactDefault.default).cloneElement(children, {
        className: (0, _clsx.clsx)(children.props?.className, mergedVisible && getOpenClassName()),
        ref: (0, _ref.supportRef)(children) ? (0, _ref.composeRef)(childRef, (0, _ref.getNodeRef)(children)) : undefined
    });
    let triggerHideAction = hideAction;
    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) triggerHideAction = [
        'click'
    ];
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _triggerDefault.default), _extends({
        builtinPlacements: placements
    }, otherProps, {
        prefixCls: prefixCls,
        ref: triggerRef,
        popupClassName: (0, _clsx.clsx)(overlayClassName, {
            [`${prefixCls}-show-arrow`]: arrow
        }),
        popupStyle: overlayStyle,
        action: trigger,
        showAction: showAction,
        hideAction: triggerHideAction,
        popupPlacement: placement,
        popupAlign: align,
        popupMotion: {
            motionName: mergedMotionName
        },
        popupVisible: mergedVisible,
        stretch: getMinOverlayWidthMatchTrigger() ? 'minWidth' : '',
        popup: getMenuElementOrLambda(),
        onOpenChange: handleVisibleChange,
        onPopupClick: onClick,
        getPopupContainer: getPopupContainer
    }), childrenNode);
});
exports.default = Dropdown;

},{"@rc-component/trigger":"8gqi4","@rc-component/util/es/ref":"jmzjd","clsx":"431Ou","react":"bmhQu","./hooks/useAccessibility":"1XBv2","./Overlay":"gHQpF","./placements":"jtlog","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1XBv2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useAccessibility);
var _keyCode = require("@rc-component/util/es/KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _react = require("react");
const { ESC, TAB } = (0, _keyCodeDefault.default);
function useAccessibility({ visible, triggerRef, onVisibleChange, autoFocus, overlayRef }) {
    const focusMenuRef = _react.useRef(false);
    const handleCloseMenuAndReturnFocus = ()=>{
        if (visible) {
            triggerRef.current?.focus?.();
            onVisibleChange?.(false);
        }
    };
    const focusMenu = ()=>{
        if (overlayRef.current?.focus) {
            overlayRef.current.focus();
            focusMenuRef.current = true;
            return true;
        }
        return false;
    };
    const handleKeyDown = (event)=>{
        switch(event.keyCode){
            case ESC:
                handleCloseMenuAndReturnFocus();
                break;
            case TAB:
                {
                    let focusResult = false;
                    if (!focusMenuRef.current) focusResult = focusMenu();
                    if (focusResult) event.preventDefault();
                    else handleCloseMenuAndReturnFocus();
                    break;
                }
        }
    };
    _react.useEffect(()=>{
        if (visible) {
            window.addEventListener('keydown', handleKeyDown);
            if (autoFocus) // FIXME: hack with raf
            (0, _rafDefault.default)(focusMenu, 3);
            return ()=>{
                window.removeEventListener('keydown', handleKeyDown);
                focusMenuRef.current = false;
            };
        }
        return ()=>{
            focusMenuRef.current = false;
        };
    }, [
        visible
    ]); // eslint-disable-line react-hooks/exhaustive-deps
}

},{"@rc-component/util/es/KeyCode":"6yRlk","@rc-component/util/es/raf":"ajbAx","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gHQpF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _ref = require("@rc-component/util/es/ref");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Overlay = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { overlay, arrow, prefixCls } = props;
    const overlayNode = (0, _react.useMemo)(()=>{
        let overlayElement;
        if (typeof overlay === 'function') overlayElement = overlay();
        else overlayElement = overlay;
        return overlayElement;
    }, [
        overlay
    ]);
    const composedRef = (0, _ref.composeRef)(ref, (0, _ref.getNodeRef)(overlayNode));
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, arrow && /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        className: `${prefixCls}-arrow`
    }), /*#__PURE__*/ (0, _reactDefault.default).cloneElement(overlayNode, {
        ref: (0, _ref.supportRef)(overlayNode) ? composedRef : undefined
    }));
});
exports.default = Overlay;

},{"@rc-component/util/es/ref":"jmzjd","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jtlog":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const targetOffset = [
    0,
    0
];
const placements = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset
    },
    top: {
        points: [
            'bc',
            'tc'
        ],
        overflow: autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: autoAdjustOverflow,
        offset: [
            0,
            -4
        ],
        targetOffset
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset
    },
    bottom: {
        points: [
            'tc',
            'bc'
        ],
        overflow: autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: autoAdjustOverflow,
        offset: [
            0,
            4
        ],
        targetOffset
    }
};
exports.default = placements;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fd4Cq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const isPrimitive = (value)=>typeof value !== 'object' && typeof value !== 'function' || value === null;
exports.default = isPrimitive;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"et8MX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _menu = require("@rc-component/menu");
var _sider = require("../layout/Sider");
var _menu1 = require("./menu");
var _menuDefault = parcelHelpers.interopDefault(_menu1);
var _menuDivider = require("./MenuDivider");
var _menuDividerDefault = parcelHelpers.interopDefault(_menuDivider);
var _menuItem = require("./MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _subMenu = require("./SubMenu");
var _subMenuDefault = parcelHelpers.interopDefault(_subMenu);
"use client";
const Menu = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const menuRef = (0, _react.useRef)(null);
    const context = _react.useContext((0, _sider.SiderContext));
    (0, _react.useImperativeHandle)(ref, ()=>({
            menu: menuRef.current,
            focus: (options)=>{
                menuRef.current?.focus(options);
            }
        }));
    return /*#__PURE__*/ _react.createElement((0, _menuDefault.default), {
        ref: menuRef,
        ...props,
        ...context
    });
});
Menu.Item = (0, _menuItemDefault.default);
Menu.SubMenu = (0, _subMenuDefault.default);
Menu.Divider = (0, _menuDividerDefault.default);
Menu.ItemGroup = (0, _menu.ItemGroup);
exports.default = Menu;

},{"react":"bmhQu","@rc-component/menu":"g7yI2","../layout/Sider":"3ck32","./menu":"8xhEq","./MenuDivider":"1Hh87","./MenuItem":"aC16p","./SubMenu":"664My","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g7yI2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubMenu", ()=>(0, _subMenuDefault.default));
parcelHelpers.export(exports, "Item", ()=>(0, _menuItemDefault.default));
parcelHelpers.export(exports, "MenuItem", ()=>(0, _menuItemDefault.default));
parcelHelpers.export(exports, "MenuItemGroup", ()=>(0, _menuItemGroupDefault.default));
parcelHelpers.export(exports, "ItemGroup", ()=>(0, _menuItemGroupDefault.default));
parcelHelpers.export(exports, "Divider", ()=>(0, _dividerDefault.default));
parcelHelpers.export(exports, "useFullPath", ()=>/** @private Only used for antd internal. Do not use in your production. */ (0, _pathContext.useFullPath));
var _menu = require("./Menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _menuItem = require("./MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _subMenu = require("./SubMenu");
var _subMenuDefault = parcelHelpers.interopDefault(_subMenu);
var _menuItemGroup = require("./MenuItemGroup");
var _menuItemGroupDefault = parcelHelpers.interopDefault(_menuItemGroup);
var _pathContext = require("./context/PathContext");
var _divider = require("./Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
const ExportMenu = (0, _menuDefault.default);
ExportMenu.Item = (0, _menuItemDefault.default);
ExportMenu.SubMenu = (0, _subMenuDefault.default);
ExportMenu.ItemGroup = (0, _menuItemGroupDefault.default);
ExportMenu.Divider = (0, _dividerDefault.default);
exports.default = ExportMenu;

},{"./Menu":"laMJF","./MenuItem":"9htRg","./SubMenu":"jTa8G","./MenuItemGroup":"5ITvZ","./context/PathContext":"itogQ","./Divider":"3NedD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"laMJF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _overflow = require("@rc-component/overflow");
var _overflowDefault = parcelHelpers.interopDefault(_overflow);
var _useControlledState = require("@rc-component/util/es/hooks/useControlledState");
var _useControlledStateDefault = parcelHelpers.interopDefault(_useControlledState);
var _useId = require("@rc-component/util/es/hooks/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _isEqual = require("@rc-component/util/es/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _react = require("react");
var _reactDom = require("react-dom");
var _idContext = require("./context/IdContext");
var _menuContext = require("./context/MenuContext");
var _menuContextDefault = parcelHelpers.interopDefault(_menuContext);
var _pathContext = require("./context/PathContext");
var _privateContext = require("./context/PrivateContext");
var _privateContextDefault = parcelHelpers.interopDefault(_privateContext);
var _useAccessibility = require("./hooks/useAccessibility");
var _useKeyRecords = require("./hooks/useKeyRecords");
var _useKeyRecordsDefault = parcelHelpers.interopDefault(_useKeyRecords);
var _useMemoCallback = require("./hooks/useMemoCallback");
var _useMemoCallbackDefault = parcelHelpers.interopDefault(_useMemoCallback);
var _menuItem = require("./MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _subMenu = require("./SubMenu");
var _subMenuDefault = parcelHelpers.interopDefault(_subMenu);
var _nodeUtil = require("./utils/nodeUtil");
var _warnUtil = require("./utils/warnUtil");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * Menu modify after refactor:
 * ## Add
 * - disabled
 *
 * ## Remove
 * - openTransitionName
 * - openAnimation
 * - onDestroy
 * - siderCollapsed: Seems antd do not use this prop (Need test in antd)
 * - collapsedWidth: Seems this logic should be handle by antd Layout.Sider
 */ // optimize for render
const EMPTY_LIST = [];
const Menu = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls = 'rc-menu', rootClassName, style, className, styles, classNames: menuClassNames, tabIndex = 0, items, children, direction, id, // Mode
    mode = 'vertical', inlineCollapsed, // Disabled
    disabled, disabledOverflow, // Open
    subMenuOpenDelay = 0.1, subMenuCloseDelay = 0.1, forceSubMenuRender, defaultOpenKeys, openKeys, // Active
    activeKey, defaultActiveFirst, // Selection
    selectable = true, multiple = false, defaultSelectedKeys, selectedKeys, onSelect, onDeselect, // Level
    inlineIndent = 24, // Motion
    motion, defaultMotions, // Popup
    triggerSubMenuAction = 'hover', builtinPlacements, // Icon
    itemIcon, expandIcon, overflowedIndicator = '...', overflowedIndicatorPopupClassName, // Function
    getPopupContainer, // Events
    onClick, onOpenChange, onKeyDown, // Deprecated
    openAnimation, openTransitionName, // Internal
    _internalRenderMenuItem, _internalRenderSubMenuItem, _internalComponents, popupRender, ...restProps } = props;
    const [childList, measureChildList] = _react.useMemo(()=>[
            (0, _nodeUtil.parseItems)(children, items, EMPTY_LIST, _internalComponents, prefixCls),
            (0, _nodeUtil.parseItems)(children, items, EMPTY_LIST, {}, prefixCls)
        ], [
        children,
        items,
        _internalComponents
    ]);
    const [mounted, setMounted] = _react.useState(false);
    const containerRef = _react.useRef();
    const uuid = (0, _useIdDefault.default)(id ? `rc-menu-uuid-${id}` : 'rc-menu-uuid');
    const isRtl = direction === 'rtl';
    // ========================= Open =========================
    const [innerOpenKeys, setMergedOpenKeys] = (0, _useControlledStateDefault.default)(defaultOpenKeys, openKeys);
    const mergedOpenKeys = innerOpenKeys || EMPTY_LIST;
    // React 18 will merge mouse event which means we open key will not sync
    // ref: https://github.com/ant-design/ant-design/issues/38818
    const triggerOpenKeys = (keys, forceFlush = false)=>{
        function doUpdate() {
            setMergedOpenKeys(keys);
            onOpenChange?.(keys);
        }
        if (forceFlush) (0, _reactDom.flushSync)(doUpdate);
        else doUpdate();
    };
    // >>>>> Cache & Reset open keys when inlineCollapsed changed
    const [inlineCacheOpenKeys, setInlineCacheOpenKeys] = _react.useState(mergedOpenKeys);
    const mountRef = _react.useRef(false);
    // ========================= Mode =========================
    const [mergedMode, mergedInlineCollapsed] = _react.useMemo(()=>{
        if ((mode === 'inline' || mode === 'vertical') && inlineCollapsed) return [
            'vertical',
            inlineCollapsed
        ];
        return [
            mode,
            false
        ];
    }, [
        mode,
        inlineCollapsed
    ]);
    const isInlineMode = mergedMode === 'inline';
    const [internalMode, setInternalMode] = _react.useState(mergedMode);
    const [internalInlineCollapsed, setInternalInlineCollapsed] = _react.useState(mergedInlineCollapsed);
    _react.useEffect(()=>{
        setInternalMode(mergedMode);
        setInternalInlineCollapsed(mergedInlineCollapsed);
        if (!mountRef.current) return;
        // Synchronously update MergedOpenKeys
        if (isInlineMode) setMergedOpenKeys(inlineCacheOpenKeys);
        else // Trigger open event in case its in control
        triggerOpenKeys(EMPTY_LIST);
    }, [
        mergedMode,
        mergedInlineCollapsed
    ]);
    // ====================== Responsive ======================
    const [lastVisibleIndex, setLastVisibleIndex] = _react.useState(0);
    const allVisible = lastVisibleIndex >= childList.length - 1 || internalMode !== 'horizontal' || disabledOverflow;
    // Cache
    _react.useEffect(()=>{
        if (isInlineMode) setInlineCacheOpenKeys(mergedOpenKeys);
    }, [
        mergedOpenKeys
    ]);
    _react.useEffect(()=>{
        mountRef.current = true;
        return ()=>{
            mountRef.current = false;
        };
    }, []);
    // ========================= Path =========================
    const { registerPath, unregisterPath, refreshOverflowKeys, isSubPathKey, getKeyPath, getKeys, getSubPathKeys } = (0, _useKeyRecordsDefault.default)();
    const registerPathContext = _react.useMemo(()=>({
            registerPath,
            unregisterPath
        }), [
        registerPath,
        unregisterPath
    ]);
    const pathUserContext = _react.useMemo(()=>({
            isSubPathKey
        }), [
        isSubPathKey
    ]);
    _react.useEffect(()=>{
        refreshOverflowKeys(allVisible ? EMPTY_LIST : childList.slice(lastVisibleIndex + 1).map((child)=>child.key));
    }, [
        lastVisibleIndex,
        allVisible
    ]);
    // ======================== Active ========================
    const [mergedActiveKey, setMergedActiveKey] = (0, _useControlledStateDefault.default)(activeKey || defaultActiveFirst && childList[0]?.key, activeKey);
    const onActive = (0, _useMemoCallbackDefault.default)((key)=>{
        setMergedActiveKey(key);
    });
    const onInactive = (0, _useMemoCallbackDefault.default)(()=>{
        setMergedActiveKey(undefined);
    });
    (0, _react.useImperativeHandle)(ref, ()=>{
        return {
            list: containerRef.current,
            focus: (options)=>{
                const keys = getKeys();
                const { elements, key2element, element2key } = (0, _useAccessibility.refreshElements)(keys, uuid);
                const focusableElements = (0, _useAccessibility.getFocusableElements)(containerRef.current, elements);
                let shouldFocusKey;
                if (mergedActiveKey && keys.includes(mergedActiveKey)) shouldFocusKey = mergedActiveKey;
                else shouldFocusKey = focusableElements[0] ? element2key.get(focusableElements[0]) : childList.find((node)=>!node.props.disabled)?.key;
                const elementToFocus = key2element.get(shouldFocusKey);
                if (shouldFocusKey && elementToFocus) elementToFocus?.focus?.(options);
            },
            findItem: ({ key: itemKey })=>{
                const keys = getKeys();
                const { key2element } = (0, _useAccessibility.refreshElements)(keys, uuid);
                return key2element.get(itemKey) || null;
            }
        };
    });
    // ======================== Select ========================
    // >>>>> Select keys
    const [internalSelectKeys, setMergedSelectKeys] = (0, _useControlledStateDefault.default)(defaultSelectedKeys || [], selectedKeys);
    const mergedSelectKeys = _react.useMemo(()=>{
        if (Array.isArray(internalSelectKeys)) return internalSelectKeys;
        if (internalSelectKeys === null || internalSelectKeys === undefined) return EMPTY_LIST;
        return [
            internalSelectKeys
        ];
    }, [
        internalSelectKeys
    ]);
    // >>>>> Trigger select
    const triggerSelection = (info)=>{
        if (selectable) {
            // Insert or Remove
            const { key: targetKey } = info;
            const exist = mergedSelectKeys.includes(targetKey);
            let newSelectKeys;
            if (multiple) {
                if (exist) newSelectKeys = mergedSelectKeys.filter((key)=>key !== targetKey);
                else newSelectKeys = [
                    ...mergedSelectKeys,
                    targetKey
                ];
            } else newSelectKeys = [
                targetKey
            ];
            setMergedSelectKeys(newSelectKeys);
            // Trigger event
            const selectInfo = {
                ...info,
                selectedKeys: newSelectKeys
            };
            if (exist) onDeselect?.(selectInfo);
            else onSelect?.(selectInfo);
        }
        // Whatever selectable, always close it
        if (!multiple && mergedOpenKeys.length && internalMode !== 'inline') triggerOpenKeys(EMPTY_LIST);
    };
    // ========================= Open =========================
    /**
   * Click for item. SubMenu do not have selection status
   */ const onInternalClick = (0, _useMemoCallbackDefault.default)((info)=>{
        onClick?.((0, _warnUtil.warnItemProp)(info));
        triggerSelection(info);
    });
    const onInternalOpenChange = (0, _useMemoCallbackDefault.default)((key, open)=>{
        let newOpenKeys = mergedOpenKeys.filter((k)=>k !== key);
        if (open) newOpenKeys.push(key);
        else if (internalMode !== 'inline') {
            // We need find all related popup to close
            const subPathKeys = getSubPathKeys(key);
            newOpenKeys = newOpenKeys.filter((k)=>!subPathKeys.has(k));
        }
        if (!(0, _isEqualDefault.default)(mergedOpenKeys, newOpenKeys, true)) triggerOpenKeys(newOpenKeys, true);
    });
    // ==================== Accessibility =====================
    const triggerAccessibilityOpen = (key, open)=>{
        const nextOpen = open ?? !mergedOpenKeys.includes(key);
        onInternalOpenChange(key, nextOpen);
    };
    const onInternalKeyDown = (0, _useAccessibility.useAccessibility)(internalMode, mergedActiveKey, isRtl, uuid, containerRef, getKeys, getKeyPath, setMergedActiveKey, triggerAccessibilityOpen, onKeyDown);
    // ======================== Effect ========================
    _react.useEffect(()=>{
        setMounted(true);
    }, []);
    // ======================= Context ========================
    const privateContext = _react.useMemo(()=>({
            _internalRenderMenuItem,
            _internalRenderSubMenuItem
        }), [
        _internalRenderMenuItem,
        _internalRenderSubMenuItem
    ]);
    // ======================== Render ========================
    // >>>>> Children
    const wrappedChildList = internalMode !== 'horizontal' || disabledOverflow ? childList : // Need wrap for overflow dropdown that do not response for open
    childList.map((child, index)=>/*#__PURE__*/ // Always wrap provider to avoid sub node re-mount
        _react.createElement((0, _menuContextDefault.default), {
            key: child.key,
            overflowDisabled: index > lastVisibleIndex,
            classNames: menuClassNames,
            styles: styles
        }, child));
    // >>>>> Container
    const container = /*#__PURE__*/ _react.createElement((0, _overflowDefault.default), _extends({
        id: id,
        ref: containerRef,
        prefixCls: `${prefixCls}-overflow`,
        component: "ul",
        itemComponent: (0, _menuItemDefault.default),
        className: (0, _clsx.clsx)(prefixCls, `${prefixCls}-root`, `${prefixCls}-${internalMode}`, className, {
            [`${prefixCls}-inline-collapsed`]: internalInlineCollapsed,
            [`${prefixCls}-rtl`]: isRtl
        }, rootClassName),
        dir: direction,
        style: style,
        role: "menu",
        tabIndex: tabIndex,
        data: wrappedChildList,
        renderRawItem: (node)=>node,
        renderRawRest: (omitItems)=>{
            // We use origin list since wrapped list use context to prevent open
            const len = omitItems.length;
            const originOmitItems = len ? childList.slice(-len) : null;
            return /*#__PURE__*/ _react.createElement((0, _subMenuDefault.default), {
                eventKey: (0, _useKeyRecords.OVERFLOW_KEY),
                title: overflowedIndicator,
                disabled: allVisible,
                internalPopupClose: len === 0,
                popupClassName: overflowedIndicatorPopupClassName
            }, originOmitItems);
        },
        maxCount: internalMode !== 'horizontal' || disabledOverflow ? (0, _overflowDefault.default).INVALIDATE : (0, _overflowDefault.default).RESPONSIVE,
        ssr: "full",
        "data-menu-list": true,
        onVisibleChange: (newLastIndex)=>{
            setLastVisibleIndex(newLastIndex);
        },
        onKeyDown: onInternalKeyDown
    }, restProps));
    // >>>>> Render
    return /*#__PURE__*/ _react.createElement((0, _privateContextDefault.default).Provider, {
        value: privateContext
    }, /*#__PURE__*/ _react.createElement((0, _idContext.IdContext).Provider, {
        value: uuid
    }, /*#__PURE__*/ _react.createElement((0, _menuContextDefault.default), {
        prefixCls: prefixCls,
        rootClassName: rootClassName,
        classNames: menuClassNames,
        styles: styles,
        mode: internalMode,
        openKeys: mergedOpenKeys,
        rtl: isRtl,
        disabled: disabled,
        motion: mounted ? motion : null,
        defaultMotions: mounted ? defaultMotions : null,
        activeKey: mergedActiveKey,
        onActive: onActive,
        onInactive: onInactive,
        selectedKeys: mergedSelectKeys,
        inlineIndent: inlineIndent,
        subMenuOpenDelay: subMenuOpenDelay,
        subMenuCloseDelay: subMenuCloseDelay,
        forceSubMenuRender: forceSubMenuRender,
        builtinPlacements: builtinPlacements,
        triggerSubMenuAction: triggerSubMenuAction,
        getPopupContainer: getPopupContainer,
        itemIcon: itemIcon,
        expandIcon: expandIcon,
        onItemClick: onInternalClick,
        onOpenChange: onInternalOpenChange,
        popupRender: popupRender
    }, /*#__PURE__*/ _react.createElement((0, _pathContext.PathUserContext).Provider, {
        value: pathUserContext
    }, container), /*#__PURE__*/ _react.createElement("div", {
        style: {
            display: 'none'
        },
        "aria-hidden": true
    }, /*#__PURE__*/ _react.createElement((0, _pathContext.PathRegisterContext).Provider, {
        value: registerPathContext
    }, measureChildList)))));
});
exports.default = Menu;

},{"clsx":"431Ou","@rc-component/overflow":"eGFPB","@rc-component/util/es/hooks/useControlledState":"2FQtD","@rc-component/util/es/hooks/useId":"910ko","@rc-component/util/es/isEqual":"fBa27","@rc-component/util/es/warning":"hJXDS","react":"bmhQu","react-dom":"82aNB","./context/IdContext":"8pOM5","./context/MenuContext":"aWHF1","./context/PathContext":"itogQ","./context/PrivateContext":"eVVt2","./hooks/useAccessibility":"exHqj","./hooks/useKeyRecords":"1U5rK","./hooks/useMemoCallback":"dSjCw","./MenuItem":"9htRg","./SubMenu":"jTa8G","./utils/nodeUtil":"6CLs3","./utils/warnUtil":"5KIJz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eGFPB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _overflow = require("./Overflow");
var _overflowDefault = parcelHelpers.interopDefault(_overflow);
exports.default = (0, _overflowDefault.default);

},{"./Overflow":"1ZvmM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1ZvmM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverflowContext", ()=>(0, _context.OverflowContext));
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _resizeObserver = require("@rc-component/resize-observer");
var _resizeObserverDefault = parcelHelpers.interopDefault(_resizeObserver);
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _item = require("./Item");
var _itemDefault = parcelHelpers.interopDefault(_item);
var _useEffectState = require("./hooks/useEffectState");
var _useEffectStateDefault = parcelHelpers.interopDefault(_useEffectState);
var _rawItem = require("./RawItem");
var _rawItemDefault = parcelHelpers.interopDefault(_rawItem);
var _context = require("./context");
const RESPONSIVE = 'responsive';
const INVALIDATE = 'invalidate';
function defaultRenderRest(omittedItems) {
    return `+ ${omittedItems.length} ...`;
}
function Overflow(props, ref) {
    const { prefixCls = 'rc-overflow', data = [], renderItem, renderRawItem, itemKey, itemWidth = 10, ssr, style, className, maxCount, renderRest, renderRawRest, prefix, suffix, component: Component = 'div', itemComponent, onVisibleChange, ...restProps } = props;
    const fullySSR = ssr === 'full';
    const notifyEffectUpdate = (0, _useEffectState.useBatcher)();
    const [containerWidth, setContainerWidth] = (0, _useEffectStateDefault.default)(notifyEffectUpdate, null);
    const mergedContainerWidth = containerWidth || 0;
    const [itemWidths, setItemWidths] = (0, _useEffectStateDefault.default)(notifyEffectUpdate, new Map());
    const [prevRestWidth, setPrevRestWidth] = (0, _useEffectStateDefault.default)(notifyEffectUpdate, 0);
    const [restWidth, setRestWidth] = (0, _useEffectStateDefault.default)(notifyEffectUpdate, 0);
    const [prefixWidth, setPrefixWidth] = (0, _useEffectStateDefault.default)(notifyEffectUpdate, 0);
    const [suffixWidth, setSuffixWidth] = (0, _useEffectStateDefault.default)(notifyEffectUpdate, 0);
    const [suffixFixedStart, setSuffixFixedStart] = (0, _react.useState)(null);
    const [displayCount, setDisplayCount] = (0, _react.useState)(null);
    const mergedDisplayCount = _react.useMemo(()=>{
        if (displayCount === null && fullySSR) return Number.MAX_SAFE_INTEGER;
        return displayCount || 0;
    }, [
        displayCount,
        containerWidth
    ]);
    const [restReady, setRestReady] = (0, _react.useState)(false);
    const itemPrefixCls = `${prefixCls}-item`;
    // Always use the max width to avoid blink
    const mergedRestWidth = Math.max(prevRestWidth, restWidth);
    // ================================= Data =================================
    const isResponsive = maxCount === RESPONSIVE;
    const shouldResponsive = data.length && isResponsive;
    const invalidate = maxCount === INVALIDATE;
    /**
   * When is `responsive`, we will always render rest node to get the real width of it for calculation
   */ const showRest = shouldResponsive || typeof maxCount === 'number' && data.length > maxCount;
    const mergedData = (0, _react.useMemo)(()=>{
        let items = data;
        if (shouldResponsive) {
            if (containerWidth === null && fullySSR) items = data;
            else items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
        } else if (typeof maxCount === 'number') items = data.slice(0, maxCount);
        return items;
    }, [
        data,
        itemWidth,
        containerWidth,
        maxCount,
        shouldResponsive
    ]);
    const omittedItems = (0, _react.useMemo)(()=>{
        if (shouldResponsive) return data.slice(mergedDisplayCount + 1);
        return data.slice(mergedData.length);
    }, [
        data,
        mergedData,
        shouldResponsive,
        mergedDisplayCount
    ]);
    // ================================= Item =================================
    const getKey = (0, _react.useCallback)((item, index)=>{
        if (typeof itemKey === 'function') return itemKey(item);
        return (itemKey && item?.[itemKey]) ?? index;
    }, [
        itemKey
    ]);
    const mergedRenderItem = (0, _react.useCallback)(renderItem || ((item)=>item), [
        renderItem
    ]);
    function updateDisplayCount(count, suffixFixedStartVal, notReady) {
        // React 18 will sync render even when the value is same in some case.
        // We take `mergedData` as deps which may cause dead loop if it's dynamic generate.
        // ref: https://github.com/ant-design/ant-design/issues/36559
        if (displayCount === count && (suffixFixedStartVal === undefined || suffixFixedStartVal === suffixFixedStart)) return;
        setDisplayCount(count);
        if (!notReady) {
            setRestReady(count < data.length - 1);
            onVisibleChange?.(count);
        }
        if (suffixFixedStartVal !== undefined) setSuffixFixedStart(suffixFixedStartVal);
    }
    // ================================= Size =================================
    function onOverflowResize(_, element) {
        setContainerWidth(element.clientWidth);
    }
    function registerSize(key, width) {
        setItemWidths((origin)=>{
            const clone = new Map(origin);
            if (width === null) clone.delete(key);
            else clone.set(key, width);
            return clone;
        });
    }
    function registerOverflowSize(_, width) {
        setRestWidth(width);
        setPrevRestWidth(restWidth);
    }
    function registerPrefixSize(_, width) {
        setPrefixWidth(width);
    }
    function registerSuffixSize(_, width) {
        setSuffixWidth(width);
    }
    // ================================ Effect ================================
    function getItemWidth(index) {
        return itemWidths.get(getKey(mergedData[index], index));
    }
    (0, _useLayoutEffectDefault.default)(()=>{
        if (mergedContainerWidth && typeof mergedRestWidth === 'number' && mergedData) {
            let totalWidth = prefixWidth + suffixWidth;
            const len = mergedData.length;
            const lastIndex = len - 1;
            // When data count change to 0, reset this since not loop will reach
            if (!len) {
                updateDisplayCount(0, null);
                return;
            }
            for(let i = 0; i < len; i += 1){
                let currentItemWidth = getItemWidth(i);
                // Fully will always render
                if (fullySSR) currentItemWidth = currentItemWidth || 0;
                // Break since data not ready
                if (currentItemWidth === undefined) {
                    updateDisplayCount(i - 1, undefined, true);
                    break;
                }
                // Find best match
                totalWidth += currentItemWidth;
                if (// Only one means `totalWidth` is the final width
                lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
                i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth) {
                    // Additional check if match the end
                    updateDisplayCount(lastIndex, null);
                    break;
                } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
                    // Can not hold all the content to show rest
                    updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
                    break;
                }
            }
            if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) setSuffixFixedStart(null);
        }
    }, [
        mergedContainerWidth,
        itemWidths,
        restWidth,
        prefixWidth,
        suffixWidth,
        getKey,
        mergedData
    ]);
    // ================================ Render ================================
    const displayRest = restReady && !!omittedItems.length;
    let suffixStyle = {};
    if (suffixFixedStart !== null && shouldResponsive) suffixStyle = {
        position: 'absolute',
        left: suffixFixedStart,
        top: 0
    };
    const itemSharedProps = {
        prefixCls: itemPrefixCls,
        responsive: shouldResponsive,
        component: itemComponent,
        invalidate
    };
    // >>>>> Choice render fun by `renderRawItem`
    const internalRenderItemNode = renderRawItem ? (item, index)=>{
        const key = getKey(item, index);
        return /*#__PURE__*/ _react.createElement((0, _context.OverflowContext).Provider, {
            key: key,
            value: {
                ...itemSharedProps,
                order: index,
                item,
                itemKey: key,
                registerSize,
                display: index <= mergedDisplayCount
            }
        }, renderRawItem(item, index));
    } : (item, index)=>{
        const key = getKey(item, index);
        return /*#__PURE__*/ _react.createElement((0, _itemDefault.default), (0, _extendsDefault.default)({}, itemSharedProps, {
            order: index,
            key: key,
            item: item,
            renderItem: mergedRenderItem,
            itemKey: key,
            registerSize: registerSize,
            display: index <= mergedDisplayCount
        }));
    };
    // >>>>> Rest node
    const restContextProps = {
        order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
        className: `${itemPrefixCls}-rest`,
        registerSize: registerOverflowSize,
        display: displayRest
    };
    const mergedRenderRest = renderRest || defaultRenderRest;
    const restNode = renderRawRest ? /*#__PURE__*/ _react.createElement((0, _context.OverflowContext).Provider, {
        value: {
            ...itemSharedProps,
            ...restContextProps
        }
    }, renderRawRest(omittedItems)) : /*#__PURE__*/ _react.createElement((0, _itemDefault.default), (0, _extendsDefault.default)({}, itemSharedProps, restContextProps), typeof mergedRenderRest === 'function' ? mergedRenderRest(omittedItems) : mergedRenderRest);
    const overflowNode = /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
        className: (0, _clsx.clsx)(!invalidate && prefixCls, className),
        style: style,
        ref: ref
    }, restProps), prefix && /*#__PURE__*/ _react.createElement((0, _itemDefault.default), (0, _extendsDefault.default)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: -1,
        className: `${itemPrefixCls}-prefix`,
        registerSize: registerPrefixSize,
        display: true
    }), prefix), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /*#__PURE__*/ _react.createElement((0, _itemDefault.default), (0, _extendsDefault.default)({}, itemSharedProps, {
        responsive: isResponsive,
        responsiveDisabled: !shouldResponsive,
        order: mergedDisplayCount,
        className: `${itemPrefixCls}-suffix`,
        registerSize: registerSuffixSize,
        display: true,
        style: suffixStyle
    }), suffix));
    return isResponsive ? /*#__PURE__*/ _react.createElement((0, _resizeObserverDefault.default), {
        onResize: onOverflowResize,
        disabled: !shouldResponsive
    }, overflowNode) : overflowNode;
}
const ForwardOverflow = /*#__PURE__*/ _react.forwardRef(Overflow);
ForwardOverflow.Item = (0, _rawItemDefault.default);
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
// Convert to generic type
exports.default = ForwardOverflow;

},{"@babel/runtime/helpers/esm/extends":"85Hd3","react":"bmhQu","clsx":"431Ou","@rc-component/resize-observer":"4dgtN","@rc-component/util/es/hooks/useLayoutEffect":"azwns","./Item":"3z7ho","./hooks/useEffectState":"eysfj","./RawItem":"iuAcT","./context":"32xXj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3z7ho":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _resizeObserver = require("@rc-component/resize-observer");
var _resizeObserverDefault = parcelHelpers.interopDefault(_resizeObserver);
// Use shared variable to save bundle size
const UNDEFINED = undefined;
function InternalItem(props, ref) {
    const { prefixCls, invalidate, item, renderItem, responsive, responsiveDisabled, registerSize, itemKey, className, style, children, display, order, component: Component = 'div', ...restProps } = props;
    const mergedHidden = responsive && !display;
    // ================================ Effect ================================
    function internalRegisterSize(width) {
        registerSize(itemKey, width);
    }
    _react.useEffect(()=>()=>{
            internalRegisterSize(null);
        }, []);
    // ================================ Render ================================
    const childNode = renderItem && item !== UNDEFINED ? renderItem(item, {
        index: order
    }) : children;
    let overflowStyle;
    if (!invalidate) overflowStyle = {
        opacity: mergedHidden ? 0 : 1,
        height: mergedHidden ? 0 : UNDEFINED,
        overflowY: mergedHidden ? 'hidden' : UNDEFINED,
        order: responsive ? order : UNDEFINED,
        pointerEvents: mergedHidden ? 'none' : UNDEFINED,
        position: mergedHidden ? 'absolute' : UNDEFINED
    };
    const overflowProps = {};
    if (mergedHidden) overflowProps['aria-hidden'] = true;
    let itemNode = /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({
        className: (0, _clsx.clsx)(!invalidate && prefixCls, className),
        style: {
            ...overflowStyle,
            ...style
        }
    }, overflowProps, restProps, {
        ref: ref
    }), childNode);
    if (responsive) itemNode = /*#__PURE__*/ _react.createElement((0, _resizeObserverDefault.default), {
        onResize: ({ offsetWidth })=>{
            internalRegisterSize(offsetWidth);
        },
        disabled: responsiveDisabled
    }, itemNode);
    return itemNode;
}
const Item = /*#__PURE__*/ _react.forwardRef(InternalItem);
exports.default = Item;

},{"@babel/runtime/helpers/esm/extends":"85Hd3","react":"bmhQu","clsx":"431Ou","@rc-component/resize-observer":"4dgtN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eysfj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Batcher for record any `useEffectState` need update.
 */ parcelHelpers.export(exports, "useBatcher", ()=>useBatcher);
parcelHelpers.export(exports, "default", ()=>useEffectState);
var _useEvent = require("@rc-component/util/es/hooks/useEvent");
var _useEventDefault = parcelHelpers.interopDefault(_useEvent);
var _react = require("react");
var _reactDom = require("react-dom");
var _channelUpdate = require("./channelUpdate");
var _channelUpdateDefault = parcelHelpers.interopDefault(_channelUpdate);
function useBatcher() {
    // Updater Trigger
    const updateFuncRef = _react.useRef(null);
    // Notify update
    const notifyEffectUpdate = (callback)=>{
        if (!updateFuncRef.current) {
            updateFuncRef.current = [];
            (0, _channelUpdateDefault.default)(()=>{
                (0, _reactDom.unstable_batchedUpdates)(()=>{
                    updateFuncRef.current.forEach((fn)=>{
                        fn();
                    });
                    updateFuncRef.current = null;
                });
            });
        }
        updateFuncRef.current.push(callback);
    };
    return notifyEffectUpdate;
}
function useEffectState(notifyEffectUpdate, defaultValue) {
    // Value
    const [stateValue, setStateValue] = _react.useState(defaultValue);
    // Set State
    const setEffectVal = (0, _useEventDefault.default)((nextValue)=>{
        notifyEffectUpdate(()=>{
            setStateValue(nextValue);
        });
    });
    return [
        stateValue,
        setEffectVal
    ];
}

},{"@rc-component/util/es/hooks/useEvent":"klq5U","react":"bmhQu","react-dom":"82aNB","./channelUpdate":"76uVi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"76uVi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>channelUpdate);
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
function channelUpdate(callback) {
    if (typeof MessageChannel === 'undefined') (0, _rafDefault.default)(callback);
    else {
        const channel = new MessageChannel();
        channel.port1.onmessage = ()=>callback();
        channel.port2.postMessage(undefined);
    }
}

},{"@rc-component/util/es/raf":"ajbAx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iuAcT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
var _react = require("react");
var _clsx = require("clsx");
var _item = require("./Item");
var _itemDefault = parcelHelpers.interopDefault(_item);
var _context = require("./context");
const InternalRawItem = (props, ref)=>{
    const context = _react.useContext((0, _context.OverflowContext));
    // Render directly when context not provided
    if (!context) {
        const { component: Component = 'div', ...restProps } = props;
        return /*#__PURE__*/ _react.createElement(Component, (0, _extendsDefault.default)({}, restProps, {
            ref: ref
        }));
    }
    const { className: contextClassName, ...restContext } = context;
    const { className, ...restProps } = props;
    // Do not pass context to sub item to avoid multiple measure
    return /*#__PURE__*/ _react.createElement((0, _context.OverflowContext).Provider, {
        value: null
    }, /*#__PURE__*/ _react.createElement((0, _itemDefault.default), (0, _extendsDefault.default)({
        ref: ref,
        className: (0, _clsx.clsx)(contextClassName, className)
    }, restContext, restProps)));
};
const RawItem = /*#__PURE__*/ _react.forwardRef(InternalRawItem);
exports.default = RawItem;

},{"@babel/runtime/helpers/esm/extends":"85Hd3","react":"bmhQu","clsx":"431Ou","./Item":"3z7ho","./context":"32xXj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"32xXj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverflowContext", ()=>OverflowContext);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const OverflowContext = /*#__PURE__*/ (0, _reactDefault.default).createContext(null);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8pOM5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IdContext", ()=>IdContext);
parcelHelpers.export(exports, "getMenuId", ()=>getMenuId);
/**
 * Get `data-menu-id`
 */ parcelHelpers.export(exports, "useMenuId", ()=>useMenuId);
var _react = require("react");
const IdContext = /*#__PURE__*/ _react.createContext(null);
function getMenuId(uuid, eventKey) {
    return `${uuid}-${eventKey}`;
}
function useMenuId(eventKey) {
    const id = _react.useContext(IdContext);
    return getMenuId(id, eventKey);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aWHF1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MenuContext", ()=>MenuContext);
parcelHelpers.export(exports, "default", ()=>InheritableContextProvider);
var _react = require("react");
var _useMemo = require("@rc-component/util/es/hooks/useMemo");
var _useMemoDefault = parcelHelpers.interopDefault(_useMemo);
var _isEqual = require("@rc-component/util/es/isEqual");
var _isEqualDefault = parcelHelpers.interopDefault(_isEqual);
const MenuContext = /*#__PURE__*/ _react.createContext(null);
function mergeProps(origin, target) {
    const clone = {
        ...origin
    };
    Object.keys(target).forEach((key)=>{
        const value = target[key];
        if (value !== undefined) clone[key] = value;
    });
    return clone;
}
function InheritableContextProvider({ children, locked, ...restProps }) {
    const context = _react.useContext(MenuContext);
    const inheritableContext = (0, _useMemoDefault.default)(()=>mergeProps(context, restProps), [
        context,
        restProps
    ], (prev, next)=>!locked && (prev[0] !== next[0] || !(0, _isEqualDefault.default)(prev[1], next[1], true)));
    return /*#__PURE__*/ _react.createElement(MenuContext.Provider, {
        value: inheritableContext
    }, children);
}

},{"react":"bmhQu","@rc-component/util/es/hooks/useMemo":"8LJN8","@rc-component/util/es/isEqual":"fBa27","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"itogQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PathRegisterContext", ()=>PathRegisterContext);
parcelHelpers.export(exports, "useMeasure", ()=>useMeasure);
parcelHelpers.export(exports, "PathTrackerContext", ()=>PathTrackerContext);
parcelHelpers.export(exports, "useFullPath", ()=>useFullPath);
parcelHelpers.export(exports, "PathUserContext", ()=>PathUserContext);
var _react = require("react");
const EmptyList = [];
const PathRegisterContext = /*#__PURE__*/ _react.createContext(null);
function useMeasure() {
    return _react.useContext(PathRegisterContext);
}
const PathTrackerContext = /*#__PURE__*/ _react.createContext(EmptyList);
function useFullPath(eventKey) {
    const parentKeyPath = _react.useContext(PathTrackerContext);
    return _react.useMemo(()=>eventKey !== undefined ? [
            ...parentKeyPath,
            eventKey
        ] : parentKeyPath, [
        parentKeyPath,
        eventKey
    ]);
}
const PathUserContext = /*#__PURE__*/ _react.createContext(null);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eVVt2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
const PrivateContext = /*#__PURE__*/ _react.createContext({});
exports.default = PrivateContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"exHqj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get focusable elements from the element set under provided container
 */ parcelHelpers.export(exports, "getFocusableElements", ()=>getFocusableElements);
parcelHelpers.export(exports, "refreshElements", ()=>refreshElements);
parcelHelpers.export(exports, "useAccessibility", ()=>useAccessibility);
var _focus = require("@rc-component/util/es/Dom/focus");
var _keyCode = require("@rc-component/util/es/KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _react = require("react");
var _idContext = require("../context/IdContext");
// destruct to reduce minify size
const { LEFT, RIGHT, UP, DOWN, ENTER, ESC, HOME, END } = (0, _keyCodeDefault.default);
const ArrowKeys = [
    UP,
    DOWN,
    LEFT,
    RIGHT
];
function getOffset(mode, isRootLevel, isRtl, which) {
    const prev = 'prev';
    const next = 'next';
    const children = 'children';
    const parent = 'parent';
    // Inline enter is special that we use unique operation
    if (mode === 'inline' && which === ENTER) return {
        inlineTrigger: true
    };
    const inline = {
        [UP]: prev,
        [DOWN]: next
    };
    const horizontal = {
        [LEFT]: isRtl ? next : prev,
        [RIGHT]: isRtl ? prev : next,
        [DOWN]: children,
        [ENTER]: children
    };
    const vertical = {
        [UP]: prev,
        [DOWN]: next,
        [ENTER]: children,
        [ESC]: parent,
        [LEFT]: isRtl ? children : parent,
        [RIGHT]: isRtl ? parent : children
    };
    const offsets = {
        inline,
        horizontal,
        vertical,
        inlineSub: inline,
        horizontalSub: vertical,
        verticalSub: vertical
    };
    const type = offsets[`${mode}${isRootLevel ? '' : 'Sub'}`]?.[which];
    switch(type){
        case prev:
            return {
                offset: -1,
                sibling: true
            };
        case next:
            return {
                offset: 1,
                sibling: true
            };
        case parent:
            return {
                offset: -1,
                sibling: false
            };
        case children:
            return {
                offset: 1,
                sibling: false
            };
        default:
            return null;
    }
}
function findContainerUL(element) {
    let current = element;
    while(current){
        if (current.getAttribute('data-menu-list')) return current;
        current = current.parentElement;
    }
    // Normally should not reach this line
    /* istanbul ignore next */ return null;
}
/**
 * Find focused element within element set provided
 */ function getFocusElement(activeElement, elements) {
    let current = activeElement || document.activeElement;
    while(current){
        if (elements.has(current)) return current;
        current = current.parentElement;
    }
    return null;
}
function getFocusableElements(container, elements) {
    const list = (0, _focus.getFocusNodeList)(container, true);
    return list.filter((ele)=>elements.has(ele));
}
function getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offset = 1) {
    // Key on the menu item will not get validate parent container
    if (!parentQueryContainer) return null;
    // List current level menu item elements
    const sameLevelFocusableMenuElementList = getFocusableElements(parentQueryContainer, elements);
    // Find next focus index
    const count = sameLevelFocusableMenuElementList.length;
    let focusIndex = sameLevelFocusableMenuElementList.findIndex((ele)=>focusMenuElement === ele);
    if (offset < 0) {
        if (focusIndex === -1) focusIndex = count - 1;
        else focusIndex -= 1;
    } else if (offset > 0) focusIndex += 1;
    focusIndex = (focusIndex + count) % count;
    // Focus menu item
    return sameLevelFocusableMenuElementList[focusIndex];
}
const refreshElements = (keys, id)=>{
    const elements = new Set();
    const key2element = new Map();
    const element2key = new Map();
    keys.forEach((key)=>{
        const element = document.querySelector(`[data-menu-id='${(0, _idContext.getMenuId)(id, key)}']`);
        if (element) {
            elements.add(element);
            element2key.set(element, key);
            key2element.set(key, element);
        }
    });
    return {
        elements,
        key2element,
        element2key
    };
};
function useAccessibility(mode, activeKey, isRtl, id, containerRef, getKeys, getKeyPath, triggerActiveKey, triggerAccessibilityOpen, originOnKeyDown) {
    const rafRef = _react.useRef();
    const activeRef = _react.useRef();
    activeRef.current = activeKey;
    const cleanRaf = ()=>{
        (0, _rafDefault.default).cancel(rafRef.current);
    };
    _react.useEffect(()=>()=>{
            cleanRaf();
        }, []);
    return (e)=>{
        const { which } = e;
        if ([
            ...ArrowKeys,
            ENTER,
            ESC,
            HOME,
            END
        ].includes(which)) {
            const keys = getKeys();
            let refreshedElements = refreshElements(keys, id);
            const { elements, key2element, element2key } = refreshedElements;
            // First we should find current focused MenuItem/SubMenu element
            const activeElement = key2element.get(activeKey);
            const focusMenuElement = getFocusElement(activeElement, elements);
            const focusMenuKey = element2key.get(focusMenuElement);
            const offsetObj = getOffset(mode, getKeyPath(focusMenuKey, true).length === 1, isRtl, which);
            // Some mode do not have fully arrow operation like inline
            if (!offsetObj && which !== HOME && which !== END) return;
            // Arrow prevent default to avoid page scroll
            if (ArrowKeys.includes(which) || [
                HOME,
                END
            ].includes(which)) e.preventDefault();
            const tryFocus = (menuElement)=>{
                if (menuElement) {
                    let focusTargetElement = menuElement;
                    // Focus to link instead of menu item if possible
                    const link = menuElement.querySelector('a');
                    if (link?.getAttribute('href')) focusTargetElement = link;
                    const targetKey = element2key.get(menuElement);
                    triggerActiveKey(targetKey);
                    /**
           * Do not `useEffect` here since `tryFocus` may trigger async
           * which makes React sync update the `activeKey`
           * that force render before `useRef` set the next activeKey
           */ cleanRaf();
                    rafRef.current = (0, _rafDefault.default)(()=>{
                        if (activeRef.current === targetKey) focusTargetElement.focus();
                    });
                }
            };
            if ([
                HOME,
                END
            ].includes(which) || offsetObj.sibling || !focusMenuElement) {
                // ========================== Sibling ==========================
                // Find walkable focus menu element container
                let parentQueryContainer;
                if (!focusMenuElement || mode === 'inline') parentQueryContainer = containerRef.current;
                else parentQueryContainer = findContainerUL(focusMenuElement);
                // Get next focus element
                let targetElement;
                const focusableElements = getFocusableElements(parentQueryContainer, elements);
                if (which === HOME) targetElement = focusableElements[0];
                else if (which === END) targetElement = focusableElements[focusableElements.length - 1];
                else targetElement = getNextFocusElement(parentQueryContainer, elements, focusMenuElement, offsetObj.offset);
                // Focus menu item
                tryFocus(targetElement);
            // ======================= InlineTrigger =======================
            } else if (offsetObj.inlineTrigger) // Inline trigger no need switch to sub menu item
            triggerAccessibilityOpen(focusMenuKey);
            else if (offsetObj.offset > 0) {
                triggerAccessibilityOpen(focusMenuKey, true);
                cleanRaf();
                rafRef.current = (0, _rafDefault.default)(()=>{
                    // Async should resync elements
                    refreshedElements = refreshElements(keys, id);
                    const controlId = focusMenuElement.getAttribute('aria-controls');
                    const subQueryContainer = document.getElementById(controlId);
                    // Get sub focusable menu item
                    const targetElement = getNextFocusElement(subQueryContainer, refreshedElements.elements);
                    // Focus menu item
                    tryFocus(targetElement);
                }, 5);
            } else if (offsetObj.offset < 0) {
                const keyPath = getKeyPath(focusMenuKey, true);
                const parentKey = keyPath[keyPath.length - 2];
                const parentMenuElement = key2element.get(parentKey);
                // Focus menu item
                triggerAccessibilityOpen(parentKey, false);
                tryFocus(parentMenuElement);
            }
        }
        // Pass origin key down event
        originOnKeyDown?.(e);
    };
}

},{"@rc-component/util/es/Dom/focus":"3rYvz","@rc-component/util/es/KeyCode":"6yRlk","@rc-component/util/es/raf":"ajbAx","react":"bmhQu","../context/IdContext":"8pOM5","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3rYvz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getFocusNodeList", ()=>getFocusNodeList);
// Used for `rc-input` `rc-textarea` `rc-input-number`
/**
 * Focus element and set cursor position for input/textarea elements.
 */ parcelHelpers.export(exports, "triggerFocus", ()=>triggerFocus);
/**
 * Lock focus in the element.
 * It will force back to the first focusable element when focus leaves the element.
 */ parcelHelpers.export(exports, "lockFocus", ()=>lockFocus);
/**
 * Lock focus within an element.
 * When locked, focus will be restricted to focusable elements within the specified element.
 * If multiple elements are locked, only the last locked element will be effective.
 */ parcelHelpers.export(exports, "useLockFocus", ()=>useLockFocus);
var _react = require("react");
var _isVisible = require("./isVisible");
var _isVisibleDefault = parcelHelpers.interopDefault(_isVisible);
function focusable(node, includePositive = false) {
    if ((0, _isVisibleDefault.default)(node)) {
        const nodeName = node.nodeName.toLowerCase();
        const isFocusableElement = // Focusable element
        [
            'input',
            'select',
            'textarea',
            'button'
        ].includes(nodeName) || // Editable element
        node.isContentEditable || // Anchor with href element
        nodeName === 'a' && !!node.getAttribute('href');
        // Get tabIndex
        const tabIndexAttr = node.getAttribute('tabindex');
        const tabIndexNum = Number(tabIndexAttr);
        // Parse as number if validate
        let tabIndex = null;
        if (tabIndexAttr && !Number.isNaN(tabIndexNum)) tabIndex = tabIndexNum;
        else if (isFocusableElement && tabIndex === null) tabIndex = 0;
        // Block focusable if disabled
        if (isFocusableElement && node.disabled) tabIndex = null;
        return tabIndex !== null && (tabIndex >= 0 || includePositive && tabIndex < 0);
    }
    return false;
}
function getFocusNodeList(node, includePositive = false) {
    const res = [
        ...node.querySelectorAll('*')
    ].filter((child)=>{
        return focusable(child, includePositive);
    });
    if (focusable(node, includePositive)) res.unshift(node);
    return res;
}
function triggerFocus(element, option) {
    if (!element) return;
    element.focus(option);
    // Selection content
    const { cursor } = option || {};
    if (cursor && (element instanceof HTMLInputElement || element instanceof HTMLTextAreaElement)) {
        const len = element.value.length;
        switch(cursor){
            case 'start':
                element.setSelectionRange(0, 0);
                break;
            case 'end':
                element.setSelectionRange(len, len);
                break;
            default:
                element.setSelectionRange(0, len);
        }
    }
}
// ======================================================
// ==                    Lock Focus                    ==
// ======================================================
let lastFocusElement = null;
let focusElements = [];
function getLastElement() {
    return focusElements[focusElements.length - 1];
}
function hasFocus(element) {
    const { activeElement } = document;
    return element === activeElement || element.contains(activeElement);
}
function syncFocus() {
    const lastElement = getLastElement();
    const { activeElement } = document;
    if (lastElement && !hasFocus(lastElement)) {
        const focusableList = getFocusNodeList(lastElement);
        const matchElement = focusableList.includes(lastFocusElement) ? lastFocusElement : focusableList[0];
        matchElement?.focus();
    } else lastFocusElement = activeElement;
}
function onWindowKeyDown(e) {
    if (e.key === 'Tab') {
        const { activeElement } = document;
        const lastElement = getLastElement();
        const focusableList = getFocusNodeList(lastElement);
        const last = focusableList[focusableList.length - 1];
        if (e.shiftKey && activeElement === focusableList[0]) // Tab backward on first focusable element
        lastFocusElement = last;
        else if (!e.shiftKey && activeElement === last) // Tab forward on last focusable element
        lastFocusElement = focusableList[0];
    }
}
function lockFocus(element) {
    if (element) {
        // Refresh focus elements
        focusElements = focusElements.filter((ele)=>ele !== element);
        focusElements.push(element);
        // Just add event since it will de-duplicate
        window.addEventListener('focusin', syncFocus);
        window.addEventListener('keydown', onWindowKeyDown, true);
        syncFocus();
    }
    // Always return unregister function
    return ()=>{
        lastFocusElement = null;
        focusElements = focusElements.filter((ele)=>ele !== element);
        if (focusElements.length === 0) {
            window.removeEventListener('focusin', syncFocus);
            window.removeEventListener('keydown', onWindowKeyDown, true);
        }
    };
}
function useLockFocus(lock, getElement) {
    (0, _react.useEffect)(()=>{
        if (lock) {
            const element = getElement();
            if (element) return lockFocus(element);
        }
    }, [
        lock
    ]);
}

},{"react":"bmhQu","./isVisible":"frSWl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1U5rK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OVERFLOW_KEY", ()=>OVERFLOW_KEY);
parcelHelpers.export(exports, "default", ()=>useKeyRecords);
var _react = require("react");
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _timeUtil = require("../utils/timeUtil");
const PATH_SPLIT = '__RC_UTIL_PATH_SPLIT__';
const getPathStr = (keyPath)=>keyPath.join(PATH_SPLIT);
const getPathKeys = (keyPathStr)=>keyPathStr.split(PATH_SPLIT);
const OVERFLOW_KEY = 'rc-menu-more';
function useKeyRecords() {
    const [, internalForceUpdate] = _react.useState({});
    const key2pathRef = (0, _react.useRef)(new Map());
    const path2keyRef = (0, _react.useRef)(new Map());
    const [overflowKeys, setOverflowKeys] = _react.useState([]);
    const updateRef = (0, _react.useRef)(0);
    const destroyRef = (0, _react.useRef)(false);
    const forceUpdate = ()=>{
        if (!destroyRef.current) internalForceUpdate({});
    };
    const registerPath = (0, _react.useCallback)((key, keyPath)=>{
        // Fill map
        const connectedPath = getPathStr(keyPath);
        path2keyRef.current.set(connectedPath, key);
        key2pathRef.current.set(key, connectedPath);
        updateRef.current += 1;
        const id = updateRef.current;
        (0, _timeUtil.nextSlice)(()=>{
            if (id === updateRef.current) forceUpdate();
        });
    }, []);
    const unregisterPath = (0, _react.useCallback)((key, keyPath)=>{
        const connectedPath = getPathStr(keyPath);
        path2keyRef.current.delete(connectedPath);
        key2pathRef.current.delete(key);
    }, []);
    const refreshOverflowKeys = (0, _react.useCallback)((keys)=>{
        setOverflowKeys(keys);
    }, []);
    const getKeyPath = (0, _react.useCallback)((eventKey, includeOverflow)=>{
        const fullPath = key2pathRef.current.get(eventKey) || '';
        const keys = getPathKeys(fullPath);
        if (includeOverflow && overflowKeys.includes(keys[0])) keys.unshift(OVERFLOW_KEY);
        return keys;
    }, [
        overflowKeys
    ]);
    const isSubPathKey = (0, _react.useCallback)((pathKeys, eventKey)=>pathKeys.filter((item)=>item !== undefined).some((pathKey)=>{
            const pathKeyList = getKeyPath(pathKey, true);
            return pathKeyList.includes(eventKey);
        }), [
        getKeyPath
    ]);
    const getKeys = ()=>{
        const keys = [
            ...key2pathRef.current.keys()
        ];
        if (overflowKeys.length) keys.push(OVERFLOW_KEY);
        return keys;
    };
    /**
   * Find current key related child path keys
   */ const getSubPathKeys = (0, _react.useCallback)((key)=>{
        const connectedPath = `${key2pathRef.current.get(key)}${PATH_SPLIT}`;
        const pathKeys = new Set();
        [
            ...path2keyRef.current.keys()
        ].forEach((pathKey)=>{
            if (pathKey.startsWith(connectedPath)) pathKeys.add(path2keyRef.current.get(pathKey));
        });
        return pathKeys;
    }, []);
    _react.useEffect(()=>()=>{
            destroyRef.current = true;
        }, []);
    return {
        // Register
        registerPath,
        unregisterPath,
        refreshOverflowKeys,
        // Util
        isSubPathKey,
        getKeyPath,
        getKeys,
        getSubPathKeys
    };
}

},{"react":"bmhQu","@rc-component/util/es/warning":"hJXDS","../utils/timeUtil":"2U5Cs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2U5Cs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "nextSlice", ()=>nextSlice);
function nextSlice(callback) {
    /* istanbul ignore next */ Promise.resolve().then(callback);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dSjCw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useMemoCallback);
var _react = require("react");
function useMemoCallback(func) {
    const funRef = _react.useRef(func);
    funRef.current = func;
    const callback = _react.useCallback((...args)=>funRef.current?.(...args), []);
    return func ? callback : undefined;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9htRg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _overflow = require("@rc-component/overflow");
var _overflowDefault = parcelHelpers.interopDefault(_overflow);
var _keyCode = require("@rc-component/util/es/KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
var _omit = require("@rc-component/util/es/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _ref = require("@rc-component/util/es/ref");
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _react = require("react");
var _idContext = require("./context/IdContext");
var _menuContext = require("./context/MenuContext");
var _pathContext = require("./context/PathContext");
var _privateContext = require("./context/PrivateContext");
var _privateContextDefault = parcelHelpers.interopDefault(_privateContext);
var _useActive = require("./hooks/useActive");
var _useActiveDefault = parcelHelpers.interopDefault(_useActive);
var _useDirectionStyle = require("./hooks/useDirectionStyle");
var _useDirectionStyleDefault = parcelHelpers.interopDefault(_useDirectionStyle);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _warnUtil = require("./utils/warnUtil");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
// Since Menu event provide the `info.item` which point to the MenuItem node instance.
// We have to use class component here.
// This should be removed from doc & api in future.
class LegacyMenuItem extends _react.Component {
    render() {
        const { title, attribute, elementRef, ...restProps } = this.props;
        // Here the props are eventually passed to the DOM element.
        // React does not recognize non-standard attributes.
        // Therefore, remove the props that is not used here.
        // ref: https://github.com/ant-design/ant-design/issues/41395
        const passedProps = (0, _omitDefault.default)(restProps, [
            'eventKey',
            'popupClassName',
            'popupOffset',
            'onTitleClick'
        ]);
        (0, _warningDefault.default)(!attribute, '`attribute` of Menu.Item is deprecated. Please pass attribute directly.');
        return /*#__PURE__*/ _react.createElement((0, _overflowDefault.default).Item, _extends({}, attribute, {
            title: typeof title === 'string' ? title : undefined
        }, passedProps, {
            ref: elementRef
        }));
    }
}
/**
 * Real Menu Item component
 */ const InternalMenuItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { style, className, eventKey, warnKey, disabled, itemIcon, children, // Aria
    role, // Active
    onMouseEnter, onMouseLeave, onClick, onKeyDown, onFocus, ...restProps } = props;
    const domDataId = (0, _idContext.useMenuId)(eventKey);
    const { prefixCls, onItemClick, disabled: contextDisabled, overflowDisabled, // Icon
    itemIcon: contextItemIcon, // Select
    selectedKeys, // Active
    onActive } = _react.useContext((0, _menuContext.MenuContext));
    const { _internalRenderMenuItem } = _react.useContext((0, _privateContextDefault.default));
    const itemCls = `${prefixCls}-item`;
    const legacyMenuItemRef = _react.useRef();
    const elementRef = _react.useRef();
    const mergedDisabled = contextDisabled || disabled;
    const mergedEleRef = (0, _ref.useComposeRef)(ref, elementRef);
    const connectedKeys = (0, _pathContext.useFullPath)(eventKey);
    // ============================= Info =============================
    const getEventInfo = (e)=>{
        return {
            key: eventKey,
            // Note: For legacy code is reversed which not like other antd component
            keyPath: [
                ...connectedKeys
            ].reverse(),
            item: legacyMenuItemRef.current,
            domEvent: e
        };
    };
    // ============================= Icon =============================
    const mergedItemIcon = itemIcon || contextItemIcon;
    // ============================ Active ============================
    const { active, ...activeProps } = (0, _useActiveDefault.default)(eventKey, mergedDisabled, onMouseEnter, onMouseLeave);
    // ============================ Select ============================
    const selected = selectedKeys.includes(eventKey);
    // ======================== DirectionStyle ========================
    const directionStyle = (0, _useDirectionStyleDefault.default)(connectedKeys.length);
    // ============================ Events ============================
    const onInternalClick = (e)=>{
        if (mergedDisabled) return;
        const info = getEventInfo(e);
        onClick?.((0, _warnUtil.warnItemProp)(info));
        onItemClick(info);
    };
    const onInternalKeyDown = (e)=>{
        onKeyDown?.(e);
        if (e.which === (0, _keyCodeDefault.default).ENTER) {
            const info = getEventInfo(e);
            // Legacy. Key will also trigger click event
            onClick?.((0, _warnUtil.warnItemProp)(info));
            onItemClick(info);
        }
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ const onInternalFocus = (e)=>{
        onActive(eventKey);
        onFocus?.(e);
    };
    // ============================ Render ============================
    const optionRoleProps = {};
    if (props.role === 'option') optionRoleProps['aria-selected'] = selected;
    let renderNode = /*#__PURE__*/ _react.createElement(LegacyMenuItem, _extends({
        ref: legacyMenuItemRef,
        elementRef: mergedEleRef,
        role: role === null ? 'none' : role || 'menuitem',
        tabIndex: disabled ? null : -1,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId
    }, (0, _omitDefault.default)(restProps, [
        'extra'
    ]), activeProps, optionRoleProps, {
        component: "li",
        "aria-disabled": disabled,
        style: {
            ...directionStyle,
            ...style
        },
        className: (0, _clsx.clsx)(itemCls, {
            [`${itemCls}-active`]: active,
            [`${itemCls}-selected`]: selected,
            [`${itemCls}-disabled`]: mergedDisabled
        }, className),
        onClick: onInternalClick,
        onKeyDown: onInternalKeyDown,
        onFocus: onInternalFocus
    }), children, /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
        props: {
            ...props,
            isSelected: selected
        },
        icon: mergedItemIcon
    }));
    if (_internalRenderMenuItem) renderNode = _internalRenderMenuItem(renderNode, props, {
        selected
    });
    return renderNode;
});
function MenuItem(props, ref) {
    const { eventKey } = props;
    // ==================== Record KeyPath ====================
    const measure = (0, _pathContext.useMeasure)();
    const connectedKeyPath = (0, _pathContext.useFullPath)(eventKey);
    // eslint-disable-next-line consistent-return
    _react.useEffect(()=>{
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return ()=>{
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    if (measure) return null;
    // ======================== Render ========================
    return /*#__PURE__*/ _react.createElement(InternalMenuItem, _extends({}, props, {
        ref: ref
    }));
}
exports.default = /*#__PURE__*/ _react.forwardRef(MenuItem);

},{"clsx":"431Ou","@rc-component/overflow":"eGFPB","@rc-component/util/es/KeyCode":"6yRlk","@rc-component/util/es/omit":"1VS01","@rc-component/util/es/ref":"jmzjd","@rc-component/util/es/warning":"hJXDS","react":"bmhQu","./context/IdContext":"8pOM5","./context/MenuContext":"aWHF1","./context/PathContext":"itogQ","./context/PrivateContext":"eVVt2","./hooks/useActive":"7QSGF","./hooks/useDirectionStyle":"gskm8","./Icon":"k19kN","./utils/warnUtil":"5KIJz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7QSGF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useActive);
var _react = require("react");
var _menuContext = require("../context/MenuContext");
function useActive(eventKey, disabled, onMouseEnter, onMouseLeave) {
    const { // Active
    activeKey, onActive, onInactive } = _react.useContext((0, _menuContext.MenuContext));
    const ret = {
        active: activeKey === eventKey
    };
    // Skip when disabled
    if (!disabled) {
        ret.onMouseEnter = (domEvent)=>{
            onMouseEnter?.({
                key: eventKey,
                domEvent
            });
            onActive(eventKey);
        };
        ret.onMouseLeave = (domEvent)=>{
            onMouseLeave?.({
                key: eventKey,
                domEvent
            });
            onInactive(eventKey);
        };
    }
    return ret;
}

},{"react":"bmhQu","../context/MenuContext":"aWHF1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gskm8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDirectionStyle);
var _react = require("react");
var _menuContext = require("../context/MenuContext");
function useDirectionStyle(level) {
    const { mode, rtl, inlineIndent } = _react.useContext((0, _menuContext.MenuContext));
    if (mode !== 'inline') return null;
    const len = level;
    return rtl ? {
        paddingRight: len * inlineIndent
    } : {
        paddingLeft: len * inlineIndent
    };
}

},{"react":"bmhQu","../context/MenuContext":"aWHF1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k19kN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
var _react = require("react");
function Icon({ icon, props, children }) {
    let iconNode;
    if (icon === null || icon === false) return null;
    if (typeof icon === 'function') iconNode = /*#__PURE__*/ _react.createElement(icon, {
        ...props
    });
    else if (typeof icon !== "boolean") // Compatible for origin definition
    iconNode = icon;
    return iconNode || children || null;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5KIJz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * `onClick` event return `info.item` which point to react node directly.
 * We should warning this since it will not work on FC.
 */ parcelHelpers.export(exports, "warnItemProp", ()=>warnItemProp);
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function warnItemProp({ item, ...restInfo }) {
    Object.defineProperty(restInfo, 'item', {
        get: ()=>{
            (0, _warningDefault.default)(false, '`info.item` is deprecated since we will move to function component that not provides React Node instance in future.');
            return item;
        }
    });
    return restInfo;
}

},{"@rc-component/util/es/warning":"hJXDS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jTa8G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _overflow = require("@rc-component/overflow");
var _overflowDefault = parcelHelpers.interopDefault(_overflow);
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _subMenuList = require("./SubMenuList");
var _subMenuListDefault = parcelHelpers.interopDefault(_subMenuList);
var _commonUtil = require("../utils/commonUtil");
var _menuContext = require("../context/MenuContext");
var _menuContextDefault = parcelHelpers.interopDefault(_menuContext);
var _useMemoCallback = require("../hooks/useMemoCallback");
var _useMemoCallbackDefault = parcelHelpers.interopDefault(_useMemoCallback);
var _popupTrigger = require("./PopupTrigger");
var _popupTriggerDefault = parcelHelpers.interopDefault(_popupTrigger);
var _icon = require("../Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _useActive = require("../hooks/useActive");
var _useActiveDefault = parcelHelpers.interopDefault(_useActive);
var _warnUtil = require("../utils/warnUtil");
var _useDirectionStyle = require("../hooks/useDirectionStyle");
var _useDirectionStyleDefault = parcelHelpers.interopDefault(_useDirectionStyle);
var _inlineSubMenuList = require("./InlineSubMenuList");
var _inlineSubMenuListDefault = parcelHelpers.interopDefault(_inlineSubMenuList);
var _pathContext = require("../context/PathContext");
var _idContext = require("../context/IdContext");
var _privateContext = require("../context/PrivateContext");
var _privateContextDefault = parcelHelpers.interopDefault(_privateContext);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const InternalSubMenu = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { style, className, styles, classNames: menuClassNames, title, eventKey, warnKey, disabled, internalPopupClose, children, // Icons
    itemIcon, expandIcon, // Popup
    popupClassName, popupOffset, popupStyle, // Events
    onClick, onMouseEnter, onMouseLeave, onTitleClick, onTitleMouseEnter, onTitleMouseLeave, popupRender: propsPopupRender, ...restProps } = props;
    const domDataId = (0, _idContext.useMenuId)(eventKey);
    const { prefixCls, mode, openKeys, // Disabled
    disabled: contextDisabled, overflowDisabled, // ActiveKey
    activeKey, // SelectKey
    selectedKeys, // Icon
    itemIcon: contextItemIcon, expandIcon: contextExpandIcon, // Events
    onItemClick, onOpenChange, onActive, popupRender: contextPopupRender } = _react.useContext((0, _menuContext.MenuContext));
    const { _internalRenderSubMenuItem } = _react.useContext((0, _privateContextDefault.default));
    const { isSubPathKey } = _react.useContext((0, _pathContext.PathUserContext));
    const connectedPath = (0, _pathContext.useFullPath)();
    const subMenuPrefixCls = `${prefixCls}-submenu`;
    const mergedDisabled = contextDisabled || disabled;
    const elementRef = _react.useRef();
    const popupRef = _react.useRef();
    // ================================ Icon ================================
    const mergedItemIcon = itemIcon ?? contextItemIcon;
    const mergedExpandIcon = expandIcon ?? contextExpandIcon;
    // ================================ Open ================================
    const originOpen = openKeys.includes(eventKey);
    const open = !overflowDisabled && originOpen;
    // =============================== Select ===============================
    const childrenSelected = isSubPathKey(selectedKeys, eventKey);
    // =============================== Active ===============================
    const { active, ...activeProps } = (0, _useActiveDefault.default)(eventKey, mergedDisabled, onTitleMouseEnter, onTitleMouseLeave);
    // Fallback of active check to avoid hover on menu title or disabled item
    const [childrenActive, setChildrenActive] = _react.useState(false);
    const triggerChildrenActive = (newActive)=>{
        if (!mergedDisabled) setChildrenActive(newActive);
    };
    const onInternalMouseEnter = (domEvent)=>{
        triggerChildrenActive(true);
        onMouseEnter?.({
            key: eventKey,
            domEvent
        });
    };
    const onInternalMouseLeave = (domEvent)=>{
        triggerChildrenActive(false);
        onMouseLeave?.({
            key: eventKey,
            domEvent
        });
    };
    const mergedActive = _react.useMemo(()=>{
        if (active) return active;
        if (mode !== 'inline') return childrenActive || isSubPathKey([
            activeKey
        ], eventKey);
        return false;
    }, [
        mode,
        active,
        activeKey,
        childrenActive,
        eventKey,
        isSubPathKey
    ]);
    // ========================== DirectionStyle ==========================
    const directionStyle = (0, _useDirectionStyleDefault.default)(connectedPath.length);
    // =============================== Events ===============================
    // >>>> Title click
    const onInternalTitleClick = (e)=>{
        // Skip if disabled
        if (mergedDisabled) return;
        onTitleClick?.({
            key: eventKey,
            domEvent: e
        });
        // Trigger open by click when mode is `inline`
        if (mode === 'inline') onOpenChange(eventKey, !originOpen);
    };
    // >>>> Context for children click
    const onMergedItemClick = (0, _useMemoCallbackDefault.default)((info)=>{
        onClick?.((0, _warnUtil.warnItemProp)(info));
        onItemClick(info);
    });
    // >>>>> Visible change
    const onPopupVisibleChange = (newVisible)=>{
        if (mode !== 'inline') onOpenChange(eventKey, newVisible);
    };
    /**
   * Used for accessibility. Helper will focus element without key board.
   * We should manually trigger an active
   */ const onInternalFocus = ()=>{
        onActive(eventKey);
    };
    // =============================== Render ===============================
    const popupId = domDataId && `${domDataId}-popup`;
    const expandIconNode = _react.useMemo(()=>/*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
            icon: mode !== 'horizontal' ? mergedExpandIcon : undefined,
            props: {
                ...props,
                isOpen: open,
                // [Legacy] Not sure why need this mark
                isSubMenu: true
            }
        }, /*#__PURE__*/ _react.createElement("i", {
            className: `${subMenuPrefixCls}-arrow`
        })), [
        mode,
        mergedExpandIcon,
        props,
        open,
        subMenuPrefixCls
    ]);
    // >>>>> Title
    let titleNode = /*#__PURE__*/ _react.createElement("div", _extends({
        role: "menuitem",
        style: directionStyle,
        className: `${subMenuPrefixCls}-title`,
        tabIndex: mergedDisabled ? null : -1,
        ref: elementRef,
        title: typeof title === 'string' ? title : null,
        "data-menu-id": overflowDisabled && domDataId ? null : domDataId,
        "aria-expanded": open,
        "aria-haspopup": true,
        "aria-controls": popupId,
        "aria-disabled": mergedDisabled,
        onClick: onInternalTitleClick,
        onFocus: onInternalFocus
    }, activeProps), title, expandIconNode);
    // Cache mode if it change to `inline` which do not have popup motion
    const triggerModeRef = _react.useRef(mode);
    if (mode !== 'inline' && connectedPath.length > 1) triggerModeRef.current = 'vertical';
    else triggerModeRef.current = mode;
    const popupContentTriggerMode = triggerModeRef.current;
    const renderPopupContent = _react.useMemo(()=>{
        const originNode = /*#__PURE__*/ _react.createElement((0, _menuContextDefault.default), {
            classNames: menuClassNames,
            styles: styles,
            mode: popupContentTriggerMode === 'horizontal' ? 'vertical' : popupContentTriggerMode
        }, /*#__PURE__*/ _react.createElement((0, _subMenuListDefault.default), {
            id: popupId,
            ref: popupRef
        }, children));
        const mergedPopupRender = propsPopupRender || contextPopupRender;
        if (mergedPopupRender) {
            const node = mergedPopupRender(originNode, {
                item: props,
                keys: connectedPath
            });
            return node;
        }
        return originNode;
    }, [
        propsPopupRender,
        contextPopupRender,
        connectedPath,
        popupId,
        children,
        props,
        popupContentTriggerMode
    ]);
    if (!overflowDisabled) {
        const triggerMode = triggerModeRef.current;
        // Still wrap with Trigger here since we need avoid react re-mount dom node
        // Which makes motion failed
        titleNode = /*#__PURE__*/ _react.createElement((0, _popupTriggerDefault.default), {
            mode: triggerMode,
            prefixCls: subMenuPrefixCls,
            visible: !internalPopupClose && open && mode !== 'inline',
            popupClassName: popupClassName,
            popupOffset: popupOffset,
            popupStyle: popupStyle,
            popup: renderPopupContent,
            disabled: mergedDisabled,
            onVisibleChange: onPopupVisibleChange
        }, titleNode);
    }
    // >>>>> List node
    let listNode = /*#__PURE__*/ _react.createElement((0, _overflowDefault.default).Item, _extends({
        ref: ref,
        role: "none"
    }, restProps, {
        component: "li",
        style: style,
        className: (0, _clsx.clsx)(subMenuPrefixCls, `${subMenuPrefixCls}-${mode}`, className, {
            [`${subMenuPrefixCls}-open`]: open,
            [`${subMenuPrefixCls}-active`]: mergedActive,
            [`${subMenuPrefixCls}-selected`]: childrenSelected,
            [`${subMenuPrefixCls}-disabled`]: mergedDisabled
        }),
        onMouseEnter: onInternalMouseEnter,
        onMouseLeave: onInternalMouseLeave
    }), titleNode, !overflowDisabled && /*#__PURE__*/ _react.createElement((0, _inlineSubMenuListDefault.default), {
        id: popupId,
        open: open,
        keyPath: connectedPath
    }, children));
    if (_internalRenderSubMenuItem) listNode = _internalRenderSubMenuItem(listNode, props, {
        selected: childrenSelected,
        active: mergedActive,
        open,
        disabled: mergedDisabled
    });
    // >>>>> Render
    return /*#__PURE__*/ _react.createElement((0, _menuContextDefault.default), {
        classNames: menuClassNames,
        styles: styles,
        onItemClick: onMergedItemClick,
        mode: mode === 'horizontal' ? 'vertical' : mode,
        itemIcon: mergedItemIcon,
        expandIcon: mergedExpandIcon
    }, listNode);
});
const SubMenu = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { eventKey, children } = props;
    const connectedKeyPath = (0, _pathContext.useFullPath)(eventKey);
    const childList = (0, _commonUtil.parseChildren)(children, connectedKeyPath);
    // ==================== Record KeyPath ====================
    const measure = (0, _pathContext.useMeasure)();
    // eslint-disable-next-line consistent-return
    _react.useEffect(()=>{
        if (measure) {
            measure.registerPath(eventKey, connectedKeyPath);
            return ()=>{
                measure.unregisterPath(eventKey, connectedKeyPath);
            };
        }
    }, [
        connectedKeyPath
    ]);
    let renderNode;
    // ======================== Render ========================
    if (measure) renderNode = childList;
    else renderNode = /*#__PURE__*/ _react.createElement(InternalSubMenu, _extends({
        ref: ref
    }, props), childList);
    return /*#__PURE__*/ _react.createElement((0, _pathContext.PathTrackerContext).Provider, {
        value: connectedKeyPath
    }, renderNode);
});
exports.default = SubMenu;

},{"react":"bmhQu","clsx":"431Ou","@rc-component/overflow":"eGFPB","@rc-component/util/es/warning":"hJXDS","./SubMenuList":"8YLDe","../utils/commonUtil":"8lBNs","../context/MenuContext":"aWHF1","../hooks/useMemoCallback":"dSjCw","./PopupTrigger":"kgcon","../Icon":"k19kN","../hooks/useActive":"7QSGF","../utils/warnUtil":"5KIJz","../hooks/useDirectionStyle":"gskm8","./InlineSubMenuList":"fyUNq","../context/PathContext":"itogQ","../context/IdContext":"8pOM5","../context/PrivateContext":"eVVt2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8YLDe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _menuContext = require("../context/MenuContext");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const InternalSubMenuList = ({ className, children, ...restProps }, ref)=>{
    const { prefixCls, mode, rtl } = _react.useContext((0, _menuContext.MenuContext));
    return /*#__PURE__*/ _react.createElement("ul", _extends({
        className: (0, _clsx.clsx)(prefixCls, rtl && `${prefixCls}-rtl`, `${prefixCls}-sub`, `${prefixCls}-${mode === 'inline' ? 'inline' : 'vertical'}`, className),
        role: "menu"
    }, restProps, {
        "data-menu-list": true,
        ref: ref
    }), children);
};
const SubMenuList = /*#__PURE__*/ _react.forwardRef(InternalSubMenuList);
exports.default = SubMenuList;

},{"react":"bmhQu","clsx":"431Ou","../context/MenuContext":"aWHF1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8lBNs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseChildren", ()=>parseChildren);
var _toArray = require("@rc-component/util/es/Children/toArray");
var _toArrayDefault = parcelHelpers.interopDefault(_toArray);
var _react = require("react");
function parseChildren(children, keyPath) {
    return (0, _toArrayDefault.default)(children).map((child, index)=>{
        if (/*#__PURE__*/ _react.isValidElement(child)) {
            const { key } = child;
            let eventKey = child.props?.eventKey ?? key;
            const emptyKey = eventKey === null || eventKey === undefined;
            if (emptyKey) eventKey = `tmp_key-${[
                ...keyPath,
                index
            ].join('-')}`;
            const cloneProps = {
                key: eventKey,
                eventKey
            };
            return /*#__PURE__*/ _react.cloneElement(child, cloneProps);
        }
        return child;
    });
}

},{"@rc-component/util/es/Children/toArray":"7sTeM","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kgcon":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PopupTrigger);
var _react = require("react");
var _trigger = require("@rc-component/trigger");
var _triggerDefault = parcelHelpers.interopDefault(_trigger);
var _clsx = require("clsx");
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _menuContext = require("../context/MenuContext");
var _placements = require("../placements");
var _motionUtil = require("../utils/motionUtil");
const popupPlacementMap = {
    horizontal: 'bottomLeft',
    vertical: 'rightTop',
    'vertical-left': 'rightTop',
    'vertical-right': 'leftTop'
};
function PopupTrigger({ prefixCls, visible, children, popup, popupStyle, popupClassName, popupOffset, disabled, mode, onVisibleChange }) {
    const { getPopupContainer, rtl, subMenuOpenDelay, subMenuCloseDelay, builtinPlacements, triggerSubMenuAction, forceSubMenuRender, rootClassName, // Motion
    motion, defaultMotions } = _react.useContext((0, _menuContext.MenuContext));
    const [innerVisible, setInnerVisible] = _react.useState(false);
    const placement = rtl ? {
        ...(0, _placements.placementsRtl),
        ...builtinPlacements
    } : {
        ...(0, _placements.placements),
        ...builtinPlacements
    };
    const popupPlacement = popupPlacementMap[mode];
    const targetMotion = (0, _motionUtil.getMotion)(mode, motion, defaultMotions);
    const targetMotionRef = _react.useRef(targetMotion);
    if (mode !== 'inline') /**
     * PopupTrigger is only used for vertical and horizontal types.
     * When collapsed is unfolded, the inline animation will destroy the vertical animation.
     */ targetMotionRef.current = targetMotion;
    const mergedMotion = {
        ...targetMotionRef.current,
        leavedClassName: `${prefixCls}-hidden`,
        removeOnLeave: false,
        motionAppear: true
    };
    // Delay to change visible
    const visibleRef = _react.useRef();
    _react.useEffect(()=>{
        visibleRef.current = (0, _rafDefault.default)(()=>{
            setInnerVisible(visible);
        });
        return ()=>{
            (0, _rafDefault.default).cancel(visibleRef.current);
        };
    }, [
        visible
    ]);
    return /*#__PURE__*/ _react.createElement((0, _triggerDefault.default), {
        prefixCls: prefixCls,
        popupClassName: (0, _clsx.clsx)(`${prefixCls}-popup`, {
            [`${prefixCls}-rtl`]: rtl
        }, popupClassName, rootClassName),
        stretch: mode === 'horizontal' ? 'minWidth' : null,
        getPopupContainer: getPopupContainer,
        builtinPlacements: placement,
        popupPlacement: popupPlacement,
        popupVisible: innerVisible,
        popup: popup,
        popupStyle: popupStyle,
        popupAlign: popupOffset && {
            offset: popupOffset
        },
        action: disabled ? [] : [
            triggerSubMenuAction
        ],
        mouseEnterDelay: subMenuOpenDelay,
        mouseLeaveDelay: subMenuCloseDelay,
        onPopupVisibleChange: onVisibleChange,
        forceRender: forceSubMenuRender,
        popupMotion: mergedMotion,
        fresh: true
    }, children);
}

},{"react":"bmhQu","@rc-component/trigger":"8gqi4","clsx":"431Ou","@rc-component/util/es/raf":"ajbAx","../context/MenuContext":"aWHF1","../placements":"1PFbs","../utils/motionUtil":"2JGAQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1PFbs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "placements", ()=>placements);
parcelHelpers.export(exports, "placementsRtl", ()=>placementsRtl);
const autoAdjustOverflow = {
    adjustX: 1,
    adjustY: 1
};
const placements = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: autoAdjustOverflow
    }
};
const placementsRtl = {
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        overflow: autoAdjustOverflow
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        overflow: autoAdjustOverflow
    },
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        overflow: autoAdjustOverflow
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        overflow: autoAdjustOverflow
    },
    rightTop: {
        points: [
            'tr',
            'tl'
        ],
        overflow: autoAdjustOverflow
    },
    rightBottom: {
        points: [
            'br',
            'bl'
        ],
        overflow: autoAdjustOverflow
    },
    leftTop: {
        points: [
            'tl',
            'tr'
        ],
        overflow: autoAdjustOverflow
    },
    leftBottom: {
        points: [
            'bl',
            'br'
        ],
        overflow: autoAdjustOverflow
    }
};
exports.default = placements;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2JGAQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMotion", ()=>getMotion);
function getMotion(mode, motion, defaultMotions) {
    if (motion) return motion;
    if (defaultMotions) return defaultMotions[mode] || defaultMotions.other;
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fyUNq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InlineSubMenuList);
var _react = require("react");
var _motion = require("@rc-component/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
var _motionUtil = require("../utils/motionUtil");
var _menuContext = require("../context/MenuContext");
var _menuContextDefault = parcelHelpers.interopDefault(_menuContext);
var _subMenuList = require("./SubMenuList");
var _subMenuListDefault = parcelHelpers.interopDefault(_subMenuList);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function InlineSubMenuList({ id, open, keyPath, children }) {
    const fixedMode = 'inline';
    const { prefixCls, forceSubMenuRender, motion, defaultMotions, mode } = _react.useContext((0, _menuContext.MenuContext));
    // Always use latest mode check
    const sameModeRef = _react.useRef(false);
    sameModeRef.current = mode === fixedMode;
    // We record `destroy` mark here since when mode change from `inline` to others.
    // The inline list should remove when motion end.
    const [destroy, setDestroy] = _react.useState(!sameModeRef.current);
    const mergedOpen = sameModeRef.current ? open : false;
    // ================================= Effect =================================
    // Reset destroy state when mode change back
    _react.useEffect(()=>{
        if (sameModeRef.current) setDestroy(false);
    }, [
        mode
    ]);
    // ================================= Render =================================
    const mergedMotion = {
        ...(0, _motionUtil.getMotion)(fixedMode, motion, defaultMotions)
    };
    // No need appear since nest inlineCollapse changed
    if (keyPath.length > 1) mergedMotion.motionAppear = false;
    // Hide inline list when mode changed and motion end
    const originOnVisibleChanged = mergedMotion.onVisibleChanged;
    mergedMotion.onVisibleChanged = (newVisible)=>{
        if (!sameModeRef.current && !newVisible) setDestroy(true);
        return originOnVisibleChanged?.(newVisible);
    };
    if (destroy) return null;
    return /*#__PURE__*/ _react.createElement((0, _menuContextDefault.default), {
        mode: fixedMode,
        locked: !sameModeRef.current
    }, /*#__PURE__*/ _react.createElement((0, _motionDefault.default), _extends({
        visible: mergedOpen
    }, mergedMotion, {
        forceRender: forceSubMenuRender,
        removeOnLeave: false,
        leavedClassName: `${prefixCls}-hidden`
    }), ({ className: motionClassName, style: motionStyle })=>{
        return /*#__PURE__*/ _react.createElement((0, _subMenuListDefault.default), {
            id: id,
            className: motionClassName,
            style: motionStyle
        }, children);
    }));
}

},{"react":"bmhQu","@rc-component/motion":"gBwXg","../utils/motionUtil":"2JGAQ","../context/MenuContext":"aWHF1","./SubMenuList":"8YLDe","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6CLs3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parseItems", ()=>parseItems);
var _react = require("react");
var _divider = require("../Divider");
var _dividerDefault = parcelHelpers.interopDefault(_divider);
var _menuItem = require("../MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _menuItemGroup = require("../MenuItemGroup");
var _menuItemGroupDefault = parcelHelpers.interopDefault(_menuItemGroup);
var _subMenu = require("../SubMenu");
var _subMenuDefault = parcelHelpers.interopDefault(_subMenu);
var _commonUtil = require("./commonUtil");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function convertItemsToNodes(list, components, prefixCls) {
    const { item: MergedMenuItem, group: MergedMenuItemGroup, submenu: MergedSubMenu, divider: MergedDivider } = components;
    return (list || []).map((opt, index)=>{
        if (opt && typeof opt === 'object') {
            const { label, children, key, type, extra, ...restProps } = opt;
            const mergedKey = key ?? `tmp-${index}`;
            // MenuItemGroup & SubMenuItem
            if (children || type === 'group') {
                if (type === 'group') // Group
                return /*#__PURE__*/ _react.createElement(MergedMenuItemGroup, _extends({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), convertItemsToNodes(children, components, prefixCls));
                // Sub Menu
                return /*#__PURE__*/ _react.createElement(MergedSubMenu, _extends({
                    key: mergedKey
                }, restProps, {
                    title: label
                }), convertItemsToNodes(children, components, prefixCls));
            }
            // MenuItem & Divider
            if (type === 'divider') return /*#__PURE__*/ _react.createElement(MergedDivider, _extends({
                key: mergedKey
            }, restProps));
            return /*#__PURE__*/ _react.createElement(MergedMenuItem, _extends({
                key: mergedKey
            }, restProps, {
                extra: extra
            }), label, (!!extra || extra === 0) && /*#__PURE__*/ _react.createElement("span", {
                className: `${prefixCls}-item-extra`
            }, extra));
        }
        return null;
    }).filter((opt)=>opt);
}
function parseItems(children, items, keyPath, components, prefixCls) {
    let childNodes = children;
    const mergedComponents = {
        divider: (0, _dividerDefault.default),
        item: (0, _menuItemDefault.default),
        group: (0, _menuItemGroupDefault.default),
        submenu: (0, _subMenuDefault.default),
        ...components
    };
    if (items) childNodes = convertItemsToNodes(items, mergedComponents, prefixCls);
    return (0, _commonUtil.parseChildren)(childNodes, keyPath);
}

},{"react":"bmhQu","../Divider":"3NedD","../MenuItem":"9htRg","../MenuItemGroup":"5ITvZ","../SubMenu":"jTa8G","./commonUtil":"8lBNs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3NedD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Divider);
var _react = require("react");
var _clsx = require("clsx");
var _menuContext = require("./context/MenuContext");
var _pathContext = require("./context/PathContext");
function Divider({ className, style }) {
    const { prefixCls } = _react.useContext((0, _menuContext.MenuContext));
    const measure = (0, _pathContext.useMeasure)();
    if (measure) return null;
    return /*#__PURE__*/ _react.createElement("li", {
        role: "separator",
        className: (0, _clsx.clsx)(`${prefixCls}-item-divider`, className),
        style: style
    });
}

},{"react":"bmhQu","clsx":"431Ou","./context/MenuContext":"aWHF1","./context/PathContext":"itogQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5ITvZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _omit = require("@rc-component/util/es/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _react = require("react");
var _menuContext = require("./context/MenuContext");
var _pathContext = require("./context/PathContext");
var _commonUtil = require("./utils/commonUtil");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const InternalMenuItemGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { className, title, eventKey, children, ...restProps } = props;
    const { prefixCls, classNames: menuClassNames, styles } = _react.useContext((0, _menuContext.MenuContext));
    const groupPrefixCls = `${prefixCls}-item-group`;
    return /*#__PURE__*/ _react.createElement("li", _extends({
        ref: ref,
        role: "presentation"
    }, restProps, {
        onClick: (e)=>e.stopPropagation(),
        className: (0, _clsx.clsx)(groupPrefixCls, className)
    }), /*#__PURE__*/ _react.createElement("div", {
        role: "presentation",
        className: (0, _clsx.clsx)(`${groupPrefixCls}-title`, menuClassNames?.listTitle),
        style: styles?.listTitle,
        title: typeof title === 'string' ? title : undefined
    }, title), /*#__PURE__*/ _react.createElement("ul", {
        role: "group",
        className: (0, _clsx.clsx)(`${groupPrefixCls}-list`, menuClassNames?.list),
        style: styles?.list
    }, children));
});
const MenuItemGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { eventKey, children } = props;
    const connectedKeyPath = (0, _pathContext.useFullPath)(eventKey);
    const childList = (0, _commonUtil.parseChildren)(children, connectedKeyPath);
    const measure = (0, _pathContext.useMeasure)();
    if (measure) return childList;
    return /*#__PURE__*/ _react.createElement(InternalMenuItemGroup, _extends({
        ref: ref
    }, (0, _omitDefault.default)(props, [
        'warnKey'
    ])), childList);
});
exports.default = MenuItemGroup;

},{"clsx":"431Ou","@rc-component/util/es/omit":"1VS01","react":"bmhQu","./context/MenuContext":"aWHF1","./context/PathContext":"itogQ","./utils/commonUtil":"8lBNs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ck32":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SiderContext", ()=>SiderContext);
var _react = require("react");
var _barsOutlined = require("@ant-design/icons/es/icons/BarsOutlined");
var _barsOutlinedDefault = parcelHelpers.interopDefault(_barsOutlined);
var _leftOutlined = require("@ant-design/icons/es/icons/LeftOutlined");
var _leftOutlinedDefault = parcelHelpers.interopDefault(_leftOutlined);
var _rightOutlined = require("@ant-design/icons/es/icons/RightOutlined");
var _rightOutlinedDefault = parcelHelpers.interopDefault(_rightOutlined);
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _configProvider = require("../config-provider");
var _context = require("./context");
var _sider = require("./style/sider");
var _siderDefault = parcelHelpers.interopDefault(_sider);
"use client";
const dimensionMaxMap = {
    xs: '479.98px',
    sm: '575.98px',
    md: '767.98px',
    lg: '991.98px',
    xl: '1199.98px',
    xxl: '1599.98px'
};
const isNumeric = (val)=>!Number.isNaN(Number.parseFloat(val)) && Number.isFinite(Number(val));
const SiderContext = /*#__PURE__*/ _react.createContext({});
const generateId = (()=>{
    let i = 0;
    return (prefix = '')=>{
        i += 1;
        return `${prefix}${i}`;
    };
})();
const Sider = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, className, trigger, children, defaultCollapsed = false, theme = 'dark', style = {}, collapsible = false, reverseArrow = false, width = 200, collapsedWidth = 80, zeroWidthTriggerStyle, breakpoint, onCollapse, onBreakpoint, ...otherProps } = props;
    const { siderHook } = (0, _react.useContext)((0, _context.LayoutContext));
    const [collapsed, setCollapsed] = (0, _react.useState)('collapsed' in props ? props.collapsed : defaultCollapsed);
    const [below, setBelow] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        if ('collapsed' in props) setCollapsed(props.collapsed);
    }, [
        props.collapsed
    ]);
    const handleSetCollapsed = (value, type)=>{
        if (!('collapsed' in props)) setCollapsed(value);
        onCollapse?.(value, type);
    };
    // =========================== Prefix ===========================
    const { getPrefixCls, direction } = (0, _react.useContext)((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _siderDefault.default)(prefixCls);
    // ========================= Responsive =========================
    const responsiveHandlerRef = (0, _react.useRef)(null);
    responsiveHandlerRef.current = (mql)=>{
        setBelow(mql.matches);
        onBreakpoint?.(mql.matches);
        if (collapsed !== mql.matches) handleSetCollapsed(mql.matches, 'responsive');
    };
    (0, _react.useEffect)(()=>{
        function responsiveHandler(mql) {
            return responsiveHandlerRef.current?.(mql);
        }
        let mql;
        if (typeof window?.matchMedia !== 'undefined' && breakpoint && breakpoint in dimensionMaxMap) {
            mql = window.matchMedia(`screen and (max-width: ${dimensionMaxMap[breakpoint]})`);
            if (typeof mql?.addEventListener === 'function') mql.addEventListener('change', responsiveHandler);
            responsiveHandler(mql);
        }
        return ()=>{
            if (typeof mql?.removeEventListener === 'function') mql.removeEventListener('change', responsiveHandler);
        };
    }, [
        breakpoint
    ]); // in order to accept dynamic 'breakpoint' property, we need to add 'breakpoint' into dependency array.
    (0, _react.useEffect)(()=>{
        const uniqueId = generateId('ant-sider-');
        siderHook.addSider(uniqueId);
        return ()=>siderHook.removeSider(uniqueId);
    }, []);
    const toggle = ()=>{
        handleSetCollapsed(!collapsed, 'clickTrigger');
    };
    const divProps = (0, _util.omit)(otherProps, [
        'collapsed'
    ]);
    const rawWidth = collapsed ? collapsedWidth : width;
    // use "px" as fallback unit for width
    const siderWidth = isNumeric(rawWidth) ? `${rawWidth}px` : String(rawWidth);
    // special trigger when collapsedWidth == 0
    const zeroWidthTrigger = Number.parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/ _react.createElement("span", {
        onClick: toggle,
        className: (0, _clsx.clsx)(`${prefixCls}-zero-width-trigger`, `${prefixCls}-zero-width-trigger-${reverseArrow ? 'right' : 'left'}`),
        style: zeroWidthTriggerStyle
    }, trigger || /*#__PURE__*/ _react.createElement((0, _barsOutlinedDefault.default), null)) : null;
    const reverseIcon = direction === 'rtl' === !reverseArrow;
    const iconObj = {
        expanded: reverseIcon ? /*#__PURE__*/ _react.createElement((0, _rightOutlinedDefault.default), null) : /*#__PURE__*/ _react.createElement((0, _leftOutlinedDefault.default), null),
        collapsed: reverseIcon ? /*#__PURE__*/ _react.createElement((0, _leftOutlinedDefault.default), null) : /*#__PURE__*/ _react.createElement((0, _rightOutlinedDefault.default), null)
    };
    const status = collapsed ? 'collapsed' : 'expanded';
    const defaultTrigger = iconObj[status];
    const triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/ _react.createElement("div", {
        className: `${prefixCls}-trigger`,
        onClick: toggle,
        style: {
            width: siderWidth
        }
    }, trigger || defaultTrigger) : null;
    const divStyle = {
        ...style,
        flex: `0 0 ${siderWidth}`,
        maxWidth: siderWidth,
        // Fix width transition bug in IE11
        minWidth: siderWidth,
        // https://github.com/ant-design/ant-design/issues/6349
        width: siderWidth
    };
    const siderCls = (0, _clsx.clsx)(prefixCls, `${prefixCls}-${theme}`, {
        [`${prefixCls}-collapsed`]: !!collapsed,
        [`${prefixCls}-has-trigger`]: collapsible && trigger !== null && !zeroWidthTrigger,
        [`${prefixCls}-below`]: !!below,
        [`${prefixCls}-zero-width`]: Number.parseFloat(siderWidth) === 0
    }, className, hashId, cssVarCls);
    const contextValue = _react.useMemo(()=>({
            siderCollapsed: collapsed
        }), [
        collapsed
    ]);
    return /*#__PURE__*/ _react.createElement(SiderContext.Provider, {
        value: contextValue
    }, /*#__PURE__*/ _react.createElement("aside", {
        className: siderCls,
        ...divProps,
        style: divStyle,
        ref: ref
    }, /*#__PURE__*/ _react.createElement("div", {
        className: `${prefixCls}-children`
    }, children), collapsible || below && zeroWidthTrigger ? triggerDom : null));
});
exports.default = Sider;

},{"react":"bmhQu","@ant-design/icons/es/icons/BarsOutlined":"gcc27","@ant-design/icons/es/icons/LeftOutlined":"8erTV","@ant-design/icons/es/icons/RightOutlined":"lRGzb","@rc-component/util":"6ZBDN","clsx":"431Ou","../config-provider":"dVeAX","./context":"5vTUi","./style/sider":"cwPXX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gcc27":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _barsOutlined = require("@ant-design/icons-svg/es/asn/BarsOutlined");
var _barsOutlinedDefault = parcelHelpers.interopDefault(_barsOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BarsOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _barsOutlinedDefault.default)
    }));
/**![bars](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTJIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHptMCAyODRIMzI4Yy00LjQgMC04IDMuNi04IDh2NTZjMCA0LjQgMy42IDggOCA4aDU4NGM0LjQgMCA4LTMuNiA4LTh2LTU2YzAtNC40LTMuNi04LTgtOHpNMTA0IDIyOGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHptMCAyODRhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTAgMjg0YTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAweiIgLz48L3N2Zz4=) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(BarsOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/BarsOutlined":"drFvY","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"drFvY":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var BarsOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0zm0 284a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "bars",
    "theme": "outlined"
};
exports.default = BarsOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5vTUi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LayoutContext", ()=>LayoutContext);
var _react = require("react");
const LayoutContext = /*#__PURE__*/ _react.createContext({
    siderHook: {
        addSider: ()=>null,
        removeSider: ()=>null
    }
});

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cwPXX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
var _ = require(".");
var _internal = require("../../theme/internal");
const genSiderStyle = (token)=>{
    const { componentCls, siderBg, motionDurationMid, motionDurationSlow, antCls, triggerHeight, triggerColor, triggerBg, headerHeight, zeroTriggerWidth, zeroTriggerHeight, borderRadiusLG, lightSiderBg, lightTriggerColor, lightTriggerBg, bodyBg } = token;
    return {
        [componentCls]: {
            position: 'relative',
            // fix firefox can't set width smaller than content on flex item
            minWidth: 0,
            background: siderBg,
            transition: `all ${motionDurationMid}, background 0s`,
            '&-has-trigger': {
                paddingBottom: triggerHeight
            },
            '&-right': {
                order: 1
            },
            [`${componentCls}-children`]: {
                height: '100%',
                // Hack for fixing margin collapse bug
                // https://github.com/ant-design/ant-design/issues/7967
                // solution from https://stackoverflow.com/a/33132624/3040605
                marginTop: -0.1,
                paddingTop: 0.1,
                [`${antCls}-menu${antCls}-menu-inline-collapsed`]: {
                    width: 'auto'
                }
            },
            [`&-zero-width ${componentCls}-children`]: {
                overflow: 'hidden'
            },
            [`${componentCls}-trigger`]: {
                position: 'fixed',
                bottom: 0,
                zIndex: 1,
                height: triggerHeight,
                color: triggerColor,
                lineHeight: (0, _cssinjs.unit)(triggerHeight),
                textAlign: 'center',
                background: triggerBg,
                cursor: 'pointer',
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-zero-width-trigger`]: {
                position: 'absolute',
                top: headerHeight,
                insetInlineEnd: token.calc(zeroTriggerWidth).mul(-1).equal(),
                zIndex: 1,
                width: zeroTriggerWidth,
                height: zeroTriggerHeight,
                color: triggerColor,
                fontSize: token.fontSizeXL,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: siderBg,
                borderRadius: `0 ${(0, _cssinjs.unit)(borderRadiusLG)} ${(0, _cssinjs.unit)(borderRadiusLG)} 0`,
                cursor: 'pointer',
                transition: `background ${motionDurationSlow} ease`,
                '&::after': {
                    position: 'absolute',
                    inset: 0,
                    background: 'transparent',
                    transition: `all ${motionDurationSlow}`,
                    content: '""'
                },
                '&:hover::after': {
                    background: `rgba(255, 255, 255, 0.2)`
                },
                '&-right': {
                    insetInlineStart: token.calc(zeroTriggerWidth).mul(-1).equal(),
                    borderRadius: `${(0, _cssinjs.unit)(borderRadiusLG)} 0 0 ${(0, _cssinjs.unit)(borderRadiusLG)}`
                }
            },
            // Light
            '&-light': {
                background: lightSiderBg,
                [`${componentCls}-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg
                },
                [`${componentCls}-zero-width-trigger`]: {
                    color: lightTriggerColor,
                    background: lightTriggerBg,
                    border: `1px solid ${bodyBg}`,
                    // Safe to modify to any other color
                    borderInlineStart: 0
                }
            }
        }
    };
};
exports.default = (0, _internal.genStyleHooks)([
    'Layout',
    'Sider'
], genSiderStyle, (0, _.prepareComponentToken), {
    deprecatedTokens: (0, _.DEPRECATED_TOKENS)
});

},{"@ant-design/cssinjs":"2VNL8",".":"3VcrG","../../theme/internal":"eQVSZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3VcrG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
parcelHelpers.export(exports, "DEPRECATED_TOKENS", ()=>DEPRECATED_TOKENS);
var _cssinjs = require("@ant-design/cssinjs");
var _internal = require("../../theme/internal");
const genLayoutStyle = (token)=>{
    const { antCls, // .ant
    componentCls, // .ant-layout
    colorText, footerBg, headerHeight, headerPadding, headerColor, footerPadding, fontSize, bodyBg, headerBg } = token;
    return {
        [componentCls]: {
            display: 'flex',
            flex: 'auto',
            flexDirection: 'column',
            /* fix firefox can't set height smaller than content on flex item */ minHeight: 0,
            background: bodyBg,
            '&, *': {
                boxSizing: 'border-box'
            },
            [`&${componentCls}-has-sider`]: {
                flexDirection: 'row',
                [`> ${componentCls}, > ${componentCls}-content`]: {
                    // https://segmentfault.com/a/1190000019498300
                    width: 0
                }
            },
            [`${componentCls}-header, &${componentCls}-footer`]: {
                flex: '0 0 auto'
            },
            // RTL
            '&-rtl': {
                direction: 'rtl'
            }
        },
        // ==================== Header ====================
        [`${componentCls}-header`]: {
            height: headerHeight,
            padding: headerPadding,
            color: headerColor,
            lineHeight: (0, _cssinjs.unit)(headerHeight),
            background: headerBg,
            // Other components/menu/style/index.less line:686
            // Integration with header element so menu items have the same height
            [`${antCls}-menu`]: {
                lineHeight: 'inherit'
            }
        },
        // ==================== Footer ====================
        [`${componentCls}-footer`]: {
            padding: footerPadding,
            color: colorText,
            fontSize,
            background: footerBg
        },
        // =================== Content ====================
        [`${componentCls}-content`]: {
            flex: 'auto',
            color: colorText,
            // fix firefox can't set height smaller than content on flex item
            minHeight: 0
        }
    };
};
const prepareComponentToken = (token)=>{
    const { colorBgLayout, controlHeight, controlHeightLG, colorText, controlHeightSM, marginXXS, colorTextLightSolid, colorBgContainer } = token;
    const paddingInline = controlHeightLG * 1.25;
    return {
        // Deprecated
        colorBgHeader: '#001529',
        colorBgBody: colorBgLayout,
        colorBgTrigger: '#002140',
        bodyBg: colorBgLayout,
        headerBg: '#001529',
        headerHeight: controlHeight * 2,
        headerPadding: `0 ${paddingInline}px`,
        headerColor: colorText,
        footerPadding: `${controlHeightSM}px ${paddingInline}px`,
        footerBg: colorBgLayout,
        siderBg: '#001529',
        triggerHeight: controlHeightLG + marginXXS * 2,
        triggerBg: '#002140',
        triggerColor: colorTextLightSolid,
        zeroTriggerWidth: controlHeightLG,
        zeroTriggerHeight: controlHeightLG,
        lightSiderBg: colorBgContainer,
        lightTriggerBg: colorBgContainer,
        lightTriggerColor: colorText
    };
};
const DEPRECATED_TOKENS = [
    [
        'colorBgBody',
        'bodyBg'
    ],
    [
        'colorBgHeader',
        'headerBg'
    ],
    [
        'colorBgTrigger',
        'triggerBg'
    ]
];
exports.default = (0, _internal.genStyleHooks)('Layout', genLayoutStyle, prepareComponentToken, {
    deprecatedTokens: DEPRECATED_TOKENS
});

},{"@ant-design/cssinjs":"2VNL8","../../theme/internal":"eQVSZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8xhEq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _ellipsisOutlined = require("@ant-design/icons/es/icons/EllipsisOutlined");
var _ellipsisOutlinedDefault = parcelHelpers.interopDefault(_ellipsisOutlined);
var _menu = require("@rc-component/menu");
var _menuDefault = parcelHelpers.interopDefault(_menu);
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _motion = require("../_util/motion");
var _motionDefault = parcelHelpers.interopDefault(_motion);
var _reactNode = require("../_util/reactNode");
var _warning = require("../_util/warning");
var _configProvider = require("../config-provider");
var _context = require("../config-provider/context");
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _menuContext = require("./MenuContext");
var _menuContextDefault = parcelHelpers.interopDefault(_menuContext);
var _menuDivider = require("./MenuDivider");
var _menuDividerDefault = parcelHelpers.interopDefault(_menuDivider);
var _menuItem = require("./MenuItem");
var _menuItemDefault = parcelHelpers.interopDefault(_menuItem);
var _overrideContext = require("./OverrideContext");
var _overrideContextDefault = parcelHelpers.interopDefault(_overrideContext);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _subMenu = require("./SubMenu");
var _subMenuDefault = parcelHelpers.interopDefault(_subMenu);
"use client";
function isEmptyIcon(icon) {
    return icon === null || icon === false;
}
const MENU_COMPONENTS = {
    item: (0, _menuItemDefault.default),
    submenu: (0, _subMenuDefault.default),
    divider: (0, _menuDividerDefault.default)
};
const InternalMenu = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const override = _react.useContext((0, _overrideContextDefault.default));
    const overrideObj = override || {};
    const { prefixCls: customizePrefixCls, className, style, theme = 'light', expandIcon, _internalDisableMenuItemTitleTooltip, inlineCollapsed, siderCollapsed, rootClassName, mode, selectable, onClick, overflowedIndicatorPopupClassName, classNames, styles, ...restProps } = props;
    const { menu } = _react.useContext((0, _configProvider.ConfigContext));
    const { getPrefixCls, getPopupContainer, direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('menu');
    const rootPrefixCls = getPrefixCls();
    const passedProps = (0, _util.omit)(restProps, [
        'collapsedWidth'
    ]);
    overrideObj.validator?.({
        mode
    });
    // ========================== Click ==========================
    // Tell dropdown that item clicked
    const onItemClick = (0, _util.useEvent)((...args)=>{
        onClick?.(...args);
        overrideObj.onClick?.();
    });
    // ========================== Mode ===========================
    const mergedMode = overrideObj.mode || mode;
    // ======================= Selectable ========================
    const mergedSelectable = selectable ?? overrideObj.selectable;
    // ======================== Collapsed ========================
    // Inline Collapsed
    const mergedInlineCollapsed = inlineCollapsed ?? siderCollapsed;
    // ================ Merged Props for Semantic ================
    const mergedProps = {
        ...props,
        mode: mergedMode,
        inlineCollapsed: mergedInlineCollapsed,
        selectable: mergedSelectable,
        theme
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        },
        subMenu: {
            _default: 'item'
        }
    });
    const defaultMotions = {
        horizontal: {
            motionName: `${rootPrefixCls}-slide-up`
        },
        inline: (0, _motionDefault.default)(rootPrefixCls),
        other: {
            motionName: `${rootPrefixCls}-zoom-big`
        }
    };
    const prefixCls = getPrefixCls('menu', customizePrefixCls || overrideObj.prefixCls);
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls, !override);
    const menuClassName = (0, _clsx.clsx)(`${prefixCls}-${theme}`, contextClassName, className);
    // ====================== ExpandIcon ========================
    const mergedExpandIcon = _react.useMemo(()=>{
        if (typeof expandIcon === 'function' || isEmptyIcon(expandIcon)) return expandIcon || null;
        if (typeof overrideObj.expandIcon === 'function' || isEmptyIcon(overrideObj.expandIcon)) return overrideObj.expandIcon || null;
        if (typeof menu?.expandIcon === 'function' || isEmptyIcon(menu?.expandIcon)) return menu?.expandIcon || null;
        const mergedIcon = expandIcon ?? overrideObj?.expandIcon ?? menu?.expandIcon;
        return (0, _reactNode.cloneElement)(mergedIcon, {
            className: (0, _clsx.clsx)(`${prefixCls}-submenu-expand-icon`, /*#__PURE__*/ _react.isValidElement(mergedIcon) ? mergedIcon.props?.className : undefined)
        });
    }, [
        expandIcon,
        overrideObj?.expandIcon,
        menu?.expandIcon,
        prefixCls
    ]);
    // ======================== Context ==========================
    const contextValue = _react.useMemo(()=>({
            prefixCls,
            inlineCollapsed: mergedInlineCollapsed || false,
            direction,
            firstLevel: true,
            theme,
            mode: mergedMode,
            disableMenuItemTitleTooltip: _internalDisableMenuItemTitleTooltip,
            classNames: mergedClassNames,
            styles: mergedStyles
        }), [
        prefixCls,
        mergedInlineCollapsed,
        direction,
        _internalDisableMenuItemTitleTooltip,
        theme,
        mergedMode,
        mergedClassNames,
        mergedStyles
    ]);
    // ========================= Render ==========================
    return /*#__PURE__*/ _react.createElement((0, _overrideContextDefault.default).Provider, {
        value: null
    }, /*#__PURE__*/ _react.createElement((0, _menuContextDefault.default).Provider, {
        value: contextValue
    }, /*#__PURE__*/ _react.createElement((0, _menuDefault.default), {
        getPopupContainer: getPopupContainer,
        overflowedIndicator: /*#__PURE__*/ _react.createElement((0, _ellipsisOutlinedDefault.default), null),
        overflowedIndicatorPopupClassName: (0, _clsx.clsx)(prefixCls, `${prefixCls}-${theme}`, overflowedIndicatorPopupClassName),
        classNames: {
            list: mergedClassNames.list,
            listTitle: mergedClassNames.itemTitle
        },
        styles: {
            list: mergedStyles.list,
            listTitle: mergedStyles.itemTitle
        },
        mode: mergedMode,
        selectable: mergedSelectable,
        onClick: onItemClick,
        ...passedProps,
        inlineCollapsed: mergedInlineCollapsed,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        className: menuClassName,
        prefixCls: prefixCls,
        direction: direction,
        defaultMotions: defaultMotions,
        expandIcon: mergedExpandIcon,
        ref: ref,
        rootClassName: (0, _clsx.clsx)(rootClassName, hashId, overrideObj.rootClassName, cssVarCls, rootCls, mergedClassNames.root),
        _internalComponents: MENU_COMPONENTS
    })));
});
exports.default = InternalMenu;

},{"react":"bmhQu","@ant-design/icons/es/icons/EllipsisOutlined":"dRAyj","@rc-component/menu":"g7yI2","@rc-component/util":"6ZBDN","clsx":"431Ou","../_util/hooks":"kdnMA","../_util/motion":"kUUSo","../_util/reactNode":"78pFx","../_util/warning":"95o3w","../config-provider":"dVeAX","../config-provider/context":"75zwC","../config-provider/hooks/useCSSVarCls":"gcu2s","./MenuContext":"7yALB","./MenuDivider":"1Hh87","./MenuItem":"aC16p","./OverrideContext":"76m8O","./style":"bbqSE","./SubMenu":"664My","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dRAyj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _ellipsisOutlined = require("@ant-design/icons-svg/es/asn/EllipsisOutlined");
var _ellipsisOutlinedDefault = parcelHelpers.interopDefault(_ellipsisOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const EllipsisOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _ellipsisOutlinedDefault.default)
    }));
/**![ellipsis](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTE3NiA1MTFhNTYgNTYgMCAxMDExMiAwIDU2IDU2IDAgMTAtMTEyIDB6bTI4MCAwYTU2IDU2IDAgMTAxMTIgMCA1NiA1NiAwIDEwLTExMiAwem0yODAgMGE1NiA1NiAwIDEwMTEyIDAgNTYgNTYgMCAxMC0xMTIgMHoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(EllipsisOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/EllipsisOutlined":"5rD5T","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5rD5T":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var EllipsisOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z"
                }
            }
        ]
    },
    "name": "ellipsis",
    "theme": "outlined"
};
exports.default = EllipsisOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7yALB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
"use client";
const MenuContext = /*#__PURE__*/ (0, _react.createContext)({
    prefixCls: '',
    firstLevel: true,
    inlineCollapsed: false,
    styles: null,
    classNames: null
});
exports.default = MenuContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Hh87":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _menu = require("@rc-component/menu");
var _clsx = require("clsx");
var _configProvider = require("../config-provider");
"use client";
const MenuDivider = (props)=>{
    const { prefixCls: customizePrefixCls, className, dashed, ...restProps } = props;
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('menu', customizePrefixCls);
    const classString = (0, _clsx.clsx)({
        [`${prefixCls}-item-divider-dashed`]: !!dashed
    }, className);
    return /*#__PURE__*/ _react.createElement((0, _menu.Divider), {
        className: classString,
        ...restProps
    });
};
exports.default = MenuDivider;

},{"react":"bmhQu","@rc-component/menu":"g7yI2","clsx":"431Ou","../config-provider":"dVeAX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aC16p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _menu = require("@rc-component/menu");
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _reactNode = require("../_util/reactNode");
var _sider = require("../layout/Sider");
var _tooltip = require("../tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _menuContext = require("./MenuContext");
var _menuContextDefault = parcelHelpers.interopDefault(_menuContext);
"use client";
const MenuItem = (props)=>{
    const { className, children, icon, title, danger, extra } = props;
    const { prefixCls, firstLevel, direction, disableMenuItemTitleTooltip, inlineCollapsed: isInlineCollapsed, styles, classNames } = _react.useContext((0, _menuContextDefault.default));
    const renderItemChildren = (inlineCollapsed)=>{
        const label = children?.[0];
        const wrapNode = /*#__PURE__*/ _react.createElement("span", {
            className: (0, _clsx.clsx)(`${prefixCls}-title-content`, firstLevel ? classNames.itemContent : classNames.subMenu.itemContent, {
                [`${prefixCls}-title-content-with-extra`]: !!extra || extra === 0
            }),
            style: firstLevel ? styles.itemContent : styles.subMenu.itemContent
        }, children);
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        if (!icon || /*#__PURE__*/ _react.isValidElement(children) && children.type === 'span') {
            if (children && inlineCollapsed && firstLevel && typeof label === 'string') return /*#__PURE__*/ _react.createElement("div", {
                className: `${prefixCls}-inline-collapsed-noicon`
            }, label.charAt(0));
        }
        return wrapNode;
    };
    const { siderCollapsed } = _react.useContext((0, _sider.SiderContext));
    let tooltipTitle = title;
    if (typeof title === 'undefined') tooltipTitle = firstLevel ? children : '';
    else if (title === false) tooltipTitle = '';
    const tooltipProps = {
        title: tooltipTitle
    };
    if (!siderCollapsed && !isInlineCollapsed) {
        tooltipProps.title = null;
        // Reset `open` to fix control mode tooltip display not correct
        // ref: https://github.com/ant-design/ant-design/issues/16742
        tooltipProps.open = false;
    }
    const childrenLength = (0, _util.toArray)(children).length;
    let returnNode = /*#__PURE__*/ _react.createElement((0, _menu.Item), {
        ...(0, _util.omit)(props, [
            'title',
            'icon',
            'danger'
        ]),
        className: (0, _clsx.clsx)(firstLevel ? classNames.item : classNames.subMenu.item, {
            [`${prefixCls}-item-danger`]: danger,
            [`${prefixCls}-item-only-child`]: (icon ? childrenLength + 1 : childrenLength) === 1
        }, className),
        style: {
            ...firstLevel ? styles.item : styles.subMenu.item,
            ...props.style
        },
        title: typeof title === 'string' ? title : undefined
    }, (0, _reactNode.cloneElement)(icon, (oriProps)=>({
            className: (0, _clsx.clsx)(`${prefixCls}-item-icon`, firstLevel ? classNames.itemIcon : classNames.subMenu.itemIcon, oriProps.className),
            style: {
                ...firstLevel ? styles.itemIcon : styles.subMenu.itemIcon,
                ...oriProps.style
            }
        })), renderItemChildren(isInlineCollapsed));
    if (!disableMenuItemTitleTooltip) returnNode = /*#__PURE__*/ _react.createElement((0, _tooltipDefault.default), {
        ...tooltipProps,
        placement: direction === 'rtl' ? 'left' : 'right',
        classNames: {
            root: `${prefixCls}-inline-collapsed-tooltip`
        }
    }, returnNode);
    return returnNode;
};
exports.default = MenuItem;

},{"react":"bmhQu","@rc-component/menu":"g7yI2","@rc-component/util":"6ZBDN","clsx":"431Ou","../_util/reactNode":"78pFx","../layout/Sider":"3ck32","../tooltip":"aByoO","./MenuContext":"7yALB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"76m8O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverrideProvider", ()=>OverrideProvider);
var _react = require("react");
var _ref = require("@rc-component/util/es/ref");
var _contextIsolator = require("../_util/ContextIsolator");
var _contextIsolatorDefault = parcelHelpers.interopDefault(_contextIsolator);
"use client";
const OverrideContext = /*#__PURE__*/ _react.createContext(null);
const OverrideProvider = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { children, ...restProps } = props;
    const override = _react.useContext(OverrideContext);
    const context = _react.useMemo(()=>({
            ...override,
            ...restProps
        }), [
        override,
        restProps.prefixCls,
        // restProps.expandIcon, Not mark as deps since this is a ReactNode
        restProps.mode,
        restProps.selectable,
        restProps.rootClassName
    ]);
    const canRef = (0, _ref.supportNodeRef)(children);
    const mergedRef = (0, _ref.useComposeRef)(ref, canRef ? (0, _ref.getNodeRef)(children) : null);
    return /*#__PURE__*/ _react.createElement(OverrideContext.Provider, {
        value: context
    }, /*#__PURE__*/ _react.createElement((0, _contextIsolatorDefault.default), {
        space: true
    }, canRef ? /*#__PURE__*/ _react.cloneElement(children, {
        ref: mergedRef
    }) : children));
});
/** @internal Only used for Dropdown component. Do not use this in your production. */ exports.default = OverrideContext;

},{"react":"bmhQu","@rc-component/util/es/ref":"jmzjd","../_util/ContextIsolator":"5aVQ9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bbqSE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _cssinjs = require("@ant-design/cssinjs");
var _fastColor = require("@ant-design/fast-color");
var _style = require("../../style");
var _motion = require("../../style/motion");
var _internal = require("../../theme/internal");
var _horizontal = require("./horizontal");
var _horizontalDefault = parcelHelpers.interopDefault(_horizontal);
var _rtl = require("./rtl");
var _rtlDefault = parcelHelpers.interopDefault(_rtl);
var _theme = require("./theme");
var _themeDefault = parcelHelpers.interopDefault(_theme);
var _vertical = require("./vertical");
var _verticalDefault = parcelHelpers.interopDefault(_vertical);
const genMenuItemStyle = (token)=>{
    const { componentCls, motionDurationSlow, motionDurationMid, motionEaseInOut, motionEaseOut, iconCls, iconSize, iconMarginInlineEnd } = token;
    return {
        // >>>>> Item
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            position: 'relative',
            display: 'block',
            margin: 0,
            whiteSpace: 'nowrap',
            cursor: 'pointer',
            transition: [
                `border-color ${motionDurationSlow}`,
                `background ${motionDurationSlow}`,
                `padding calc(${motionDurationSlow} + 0.1s) ${motionEaseInOut}`
            ].join(','),
            [`${componentCls}-item-icon, ${iconCls}`]: {
                minWidth: iconSize,
                fontSize: iconSize,
                transition: [
                    `font-size ${motionDurationMid} ${motionEaseOut}`,
                    `margin ${motionDurationSlow} ${motionEaseInOut}`,
                    `color ${motionDurationSlow}`
                ].join(','),
                '+ span': {
                    marginInlineStart: iconMarginInlineEnd,
                    opacity: 1,
                    transition: [
                        `opacity ${motionDurationSlow} ${motionEaseInOut}`,
                        `margin ${motionDurationSlow}`,
                        `color ${motionDurationSlow}`
                    ].join(',')
                }
            },
            [`${componentCls}-item-icon`]: {
                ...(0, _style.resetIcon)()
            },
            [`&${componentCls}-item-only-child`]: {
                [`> ${iconCls}, > ${componentCls}-item-icon`]: {
                    marginInlineEnd: 0
                }
            }
        },
        // Disabled state sets text to gray and nukes hover/tab effects
        [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
            background: 'none !important',
            cursor: 'not-allowed',
            '&::after': {
                borderColor: 'transparent !important'
            },
            a: {
                color: 'inherit !important',
                cursor: 'not-allowed',
                pointerEvents: 'none'
            },
            [`> ${componentCls}-submenu-title`]: {
                color: 'inherit !important',
                cursor: 'not-allowed'
            }
        }
    };
};
const genSubMenuArrowStyle = (token)=>{
    const { componentCls, motionDurationSlow, motionEaseInOut, borderRadius, menuArrowSize, menuArrowOffset } = token;
    return {
        [`${componentCls}-submenu`]: {
            '&-expand-icon, &-arrow': {
                position: 'absolute',
                top: '50%',
                insetInlineEnd: token.margin,
                width: menuArrowSize,
                color: 'currentcolor',
                transform: 'translateY(-50%)',
                transition: `transform ${motionDurationSlow} ${motionEaseInOut}, opacity ${motionDurationSlow}`
            },
            '&-arrow': {
                // →
                '&::before, &::after': {
                    position: 'absolute',
                    width: token.calc(menuArrowSize).mul(0.6).equal(),
                    height: token.calc(menuArrowSize).mul(0.15).equal(),
                    backgroundColor: 'currentcolor',
                    borderRadius,
                    transition: [
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `transform ${motionDurationSlow} ${motionEaseInOut}`,
                        `top ${motionDurationSlow} ${motionEaseInOut}`,
                        `color ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(','),
                    content: '""'
                },
                '&::before': {
                    transform: `rotate(45deg) translateY(${(0, _cssinjs.unit)(token.calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(-45deg) translateY(${(0, _cssinjs.unit)(menuArrowOffset)})`
                }
            }
        }
    };
};
// =============================== Base ===============================
const getBaseStyle = (token)=>{
    const { antCls, componentCls, fontSize, motionDurationSlow, motionDurationMid, motionEaseInOut, paddingXS, padding, colorSplit, lineWidth, zIndexPopup, borderRadiusLG, subMenuItemBorderRadius, menuArrowSize, menuArrowOffset, lineType, groupTitleLineHeight, groupTitleFontSize } = token;
    return [
        // Misc
        {
            '': {
                [componentCls]: {
                    ...(0, _style.clearFix)(),
                    // Hidden
                    '&-hidden': {
                        display: 'none'
                    }
                }
            },
            [`${componentCls}-submenu-hidden`]: {
                display: 'none'
            }
        },
        {
            [componentCls]: {
                ...(0, _style.resetComponent)(token),
                ...(0, _style.clearFix)(),
                marginBottom: 0,
                paddingInlineStart: 0,
                // Override default ul/ol
                fontSize,
                lineHeight: 0,
                // Fix display inline-block gap
                listStyle: 'none',
                outline: 'none',
                // Magic cubic here but smooth transition
                transition: `width ${motionDurationSlow} cubic-bezier(0.2, 0, 0, 1) 0s`,
                'ul, ol': {
                    margin: 0,
                    padding: 0,
                    listStyle: 'none'
                },
                // Overflow ellipsis
                '&-overflow': {
                    display: 'flex',
                    [`${componentCls}-item`]: {
                        flex: 'none'
                    }
                },
                [`${componentCls}-item, ${componentCls}-submenu, ${componentCls}-submenu-title`]: {
                    borderRadius: token.itemBorderRadius
                },
                [`${componentCls}-item-group-title`]: {
                    padding: `${(0, _cssinjs.unit)(paddingXS)} ${(0, _cssinjs.unit)(padding)}`,
                    fontSize: groupTitleFontSize,
                    lineHeight: groupTitleLineHeight,
                    transition: `all ${motionDurationSlow}`
                },
                [`&-horizontal ${componentCls}-submenu`]: {
                    transition: [
                        `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        `background ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-submenu, ${componentCls}-submenu-inline`]: {
                    transition: [
                        `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `padding ${motionDurationMid} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-submenu ${componentCls}-sub`]: {
                    cursor: 'initial',
                    transition: [
                        `background ${motionDurationSlow} ${motionEaseInOut}`,
                        `padding ${motionDurationSlow} ${motionEaseInOut}`
                    ].join(',')
                },
                [`${componentCls}-title-content`]: {
                    transition: `color ${motionDurationSlow}`,
                    '&-with-extra': {
                        display: 'inline-flex',
                        alignItems: 'center',
                        width: '100%'
                    },
                    // https://github.com/ant-design/ant-design/issues/41143
                    [`> ${antCls}-typography-ellipsis-single-line`]: {
                        display: 'inline',
                        verticalAlign: 'unset'
                    },
                    [`${componentCls}-item-extra`]: {
                        marginInlineStart: 'auto',
                        paddingInlineStart: token.padding
                    }
                },
                [`${componentCls}-item a`]: {
                    '&::before': {
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: 'transparent',
                        content: '""'
                    }
                },
                // Removed a Badge related style seems it's safe
                // https://github.com/ant-design/ant-design/issues/19809
                // >>>>> Divider
                [`${componentCls}-item-divider`]: {
                    overflow: 'hidden',
                    lineHeight: 0,
                    borderColor: colorSplit,
                    borderStyle: lineType,
                    borderWidth: 0,
                    borderTopWidth: lineWidth,
                    marginBlock: lineWidth,
                    padding: 0,
                    '&-dashed': {
                        borderStyle: 'dashed'
                    }
                },
                // Item
                ...genMenuItemStyle(token),
                [`${componentCls}-item-group`]: {
                    [`${componentCls}-item-group-list`]: {
                        margin: 0,
                        padding: 0,
                        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                            paddingInline: `${(0, _cssinjs.unit)(token.calc(fontSize).mul(2).equal())} ${(0, _cssinjs.unit)(padding)}`
                        }
                    }
                },
                // ======================= Sub Menu =======================
                '&-submenu': {
                    '&-popup': {
                        position: 'absolute',
                        zIndex: zIndexPopup,
                        borderRadius: borderRadiusLG,
                        boxShadow: 'none',
                        transformOrigin: '0 0',
                        [`&${componentCls}-submenu`]: {
                            background: 'transparent'
                        },
                        // https://github.com/ant-design/ant-design/issues/13955
                        '&::before': {
                            position: 'absolute',
                            inset: 0,
                            zIndex: -1,
                            width: '100%',
                            height: '100%',
                            opacity: 0,
                            content: '""'
                        },
                        [`> ${componentCls}`]: {
                            borderRadius: borderRadiusLG,
                            ...genMenuItemStyle(token),
                            ...genSubMenuArrowStyle(token),
                            [`${componentCls}-item, ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                                borderRadius: subMenuItemBorderRadius
                            },
                            [`${componentCls}-submenu-title::after`]: {
                                transition: `transform ${motionDurationSlow} ${motionEaseInOut}`
                            }
                        }
                    },
                    [`
          &-placement-leftTop,
          &-placement-bottomRight,
          `]: {
                        transformOrigin: '100% 0'
                    },
                    [`
          &-placement-leftBottom,
          &-placement-topRight,
          `]: {
                        transformOrigin: '100% 100%'
                    },
                    [`
          &-placement-rightBottom,
          &-placement-topLeft,
          `]: {
                        transformOrigin: '0 100%'
                    },
                    [`
          &-placement-bottomLeft,
          &-placement-rightTop,
          `]: {
                        transformOrigin: '0 0'
                    },
                    [`
          &-placement-leftTop,
          &-placement-leftBottom
          `]: {
                        paddingInlineEnd: token.paddingXS
                    },
                    [`
          &-placement-rightTop,
          &-placement-rightBottom
          `]: {
                        paddingInlineStart: token.paddingXS
                    },
                    [`
          &-placement-topRight,
          &-placement-topLeft
          `]: {
                        paddingBottom: token.paddingXS
                    },
                    [`
          &-placement-bottomRight,
          &-placement-bottomLeft
          `]: {
                        paddingTop: token.paddingXS
                    }
                },
                ...genSubMenuArrowStyle(token),
                [`&-inline-collapsed ${componentCls}-submenu-arrow,
        &-inline ${componentCls}-submenu-arrow`]: {
                    // ↓
                    '&::before': {
                        transform: `rotate(-45deg) translateX(${(0, _cssinjs.unit)(menuArrowOffset)})`
                    },
                    '&::after': {
                        transform: `rotate(45deg) translateX(${(0, _cssinjs.unit)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    }
                },
                [`${componentCls}-submenu-open${componentCls}-submenu-inline > ${componentCls}-submenu-title > ${componentCls}-submenu-arrow`]: {
                    // ↑
                    transform: `translateY(${(0, _cssinjs.unit)(token.calc(menuArrowSize).mul(0.2).mul(-1).equal())})`,
                    '&::after': {
                        transform: `rotate(-45deg) translateX(${(0, _cssinjs.unit)(token.calc(menuArrowOffset).mul(-1).equal())})`
                    },
                    '&::before': {
                        transform: `rotate(45deg) translateX(${(0, _cssinjs.unit)(menuArrowOffset)})`
                    }
                }
            }
        },
        // Integration with header element so menu items have the same height
        {
            [`${antCls}-layout-header`]: {
                [componentCls]: {
                    lineHeight: 'inherit'
                }
            }
        }
    ];
};
const prepareComponentToken = (token)=>{
    const { colorPrimary, colorError, colorTextDisabled, colorErrorBg, colorText, colorTextDescription, colorBgContainer, colorFillAlter, colorFillContent, lineWidth, lineWidthBold, controlItemBgActive, colorBgTextHover, controlHeightLG, lineHeight, colorBgElevated, marginXXS, padding, fontSize, controlHeightSM, fontSizeLG, colorTextLightSolid, colorErrorHover } = token;
    const activeBarWidth = token.activeBarWidth ?? 0;
    const activeBarBorderWidth = token.activeBarBorderWidth ?? lineWidth;
    const itemMarginInline = token.itemMarginInline ?? token.marginXXS;
    const colorTextDark = new (0, _fastColor.FastColor)(colorTextLightSolid).setA(0.65).toRgbString();
    return {
        dropdownWidth: 160,
        zIndexPopup: token.zIndexPopupBase + 50,
        radiusItem: token.borderRadiusLG,
        itemBorderRadius: token.borderRadiusLG,
        radiusSubMenuItem: token.borderRadiusSM,
        subMenuItemBorderRadius: token.borderRadiusSM,
        colorItemText: colorText,
        itemColor: colorText,
        colorItemTextHover: colorText,
        itemHoverColor: colorText,
        colorItemTextHoverHorizontal: colorPrimary,
        horizontalItemHoverColor: colorPrimary,
        colorGroupTitle: colorTextDescription,
        groupTitleColor: colorTextDescription,
        colorItemTextSelected: colorPrimary,
        itemSelectedColor: colorPrimary,
        subMenuItemSelectedColor: colorPrimary,
        colorItemTextSelectedHorizontal: colorPrimary,
        horizontalItemSelectedColor: colorPrimary,
        colorItemBg: colorBgContainer,
        itemBg: colorBgContainer,
        colorItemBgHover: colorBgTextHover,
        itemHoverBg: colorBgTextHover,
        colorItemBgActive: colorFillContent,
        itemActiveBg: controlItemBgActive,
        colorSubItemBg: colorFillAlter,
        subMenuItemBg: colorFillAlter,
        colorItemBgSelected: controlItemBgActive,
        itemSelectedBg: controlItemBgActive,
        colorItemBgSelectedHorizontal: 'transparent',
        horizontalItemSelectedBg: 'transparent',
        colorActiveBarWidth: 0,
        activeBarWidth,
        colorActiveBarHeight: lineWidthBold,
        activeBarHeight: lineWidthBold,
        colorActiveBarBorderSize: lineWidth,
        activeBarBorderWidth,
        // Disabled
        colorItemTextDisabled: colorTextDisabled,
        itemDisabledColor: colorTextDisabled,
        // Danger
        colorDangerItemText: colorError,
        dangerItemColor: colorError,
        colorDangerItemTextHover: colorError,
        dangerItemHoverColor: colorError,
        colorDangerItemTextSelected: colorError,
        dangerItemSelectedColor: colorError,
        colorDangerItemBgActive: colorErrorBg,
        dangerItemActiveBg: colorErrorBg,
        colorDangerItemBgSelected: colorErrorBg,
        dangerItemSelectedBg: colorErrorBg,
        itemMarginInline,
        horizontalItemBorderRadius: 0,
        horizontalItemHoverBg: 'transparent',
        itemHeight: controlHeightLG,
        groupTitleLineHeight: lineHeight,
        collapsedWidth: controlHeightLG * 2,
        popupBg: colorBgElevated,
        itemMarginBlock: marginXXS,
        itemPaddingInline: padding,
        horizontalLineHeight: `${controlHeightLG * 1.15}px`,
        iconSize: fontSize,
        iconMarginInlineEnd: controlHeightSM - fontSize,
        collapsedIconSize: fontSizeLG,
        groupTitleFontSize: fontSize,
        // Disabled
        darkItemDisabledColor: new (0, _fastColor.FastColor)(colorTextLightSolid).setA(0.25).toRgbString(),
        // Dark
        darkItemColor: colorTextDark,
        darkDangerItemColor: colorError,
        darkItemBg: '#001529',
        darkPopupBg: '#001529',
        darkSubMenuItemBg: '#000c17',
        darkItemSelectedColor: colorTextLightSolid,
        darkItemSelectedBg: colorPrimary,
        darkDangerItemSelectedBg: colorError,
        darkItemHoverBg: 'transparent',
        darkGroupTitleColor: colorTextDark,
        darkItemHoverColor: colorTextLightSolid,
        darkDangerItemHoverColor: colorErrorHover,
        darkDangerItemSelectedColor: colorTextLightSolid,
        darkDangerItemActiveBg: colorError,
        // internal
        itemWidth: activeBarWidth ? `calc(100% + ${activeBarBorderWidth}px)` : `calc(100% - ${itemMarginInline * 2}px)`
    };
};
// ============================== Export ==============================
exports.default = (prefixCls, rootCls = prefixCls, injectStyle = true)=>{
    const useStyle = (0, _internal.genStyleHooks)('Menu', (token)=>{
        const { colorBgElevated, controlHeightLG, fontSize, darkItemColor, darkDangerItemColor, darkItemBg, darkSubMenuItemBg, darkItemSelectedColor, darkItemSelectedBg, darkDangerItemSelectedBg, darkItemHoverBg, darkGroupTitleColor, darkItemHoverColor, darkItemDisabledColor, darkDangerItemHoverColor, darkDangerItemSelectedColor, darkDangerItemActiveBg, popupBg, darkPopupBg } = token;
        const menuArrowSize = token.calc(fontSize).div(7).mul(5).equal();
        // Menu Token
        const menuToken = (0, _internal.mergeToken)(token, {
            menuArrowSize,
            menuHorizontalHeight: token.calc(controlHeightLG).mul(1.15).equal(),
            menuArrowOffset: token.calc(menuArrowSize).mul(0.25).equal(),
            menuSubMenuBg: colorBgElevated,
            calc: token.calc,
            popupBg
        });
        const menuDarkToken = (0, _internal.mergeToken)(menuToken, {
            itemColor: darkItemColor,
            itemHoverColor: darkItemHoverColor,
            groupTitleColor: darkGroupTitleColor,
            itemSelectedColor: darkItemSelectedColor,
            subMenuItemSelectedColor: darkItemSelectedColor,
            itemBg: darkItemBg,
            popupBg: darkPopupBg,
            subMenuItemBg: darkSubMenuItemBg,
            itemActiveBg: 'transparent',
            itemSelectedBg: darkItemSelectedBg,
            activeBarHeight: 0,
            activeBarBorderWidth: 0,
            itemHoverBg: darkItemHoverBg,
            // Disabled
            itemDisabledColor: darkItemDisabledColor,
            // Danger
            dangerItemColor: darkDangerItemColor,
            dangerItemHoverColor: darkDangerItemHoverColor,
            dangerItemSelectedColor: darkDangerItemSelectedColor,
            dangerItemActiveBg: darkDangerItemActiveBg,
            dangerItemSelectedBg: darkDangerItemSelectedBg,
            menuSubMenuBg: darkSubMenuItemBg,
            // Horizontal
            horizontalItemSelectedColor: darkItemSelectedColor,
            horizontalItemSelectedBg: darkItemSelectedBg
        });
        return [
            // Basic
            getBaseStyle(menuToken),
            // Horizontal
            (0, _horizontalDefault.default)(menuToken),
            // Hard code for some light style
            // Vertical
            (0, _verticalDefault.default)(menuToken),
            // Hard code for some light style
            // Theme
            (0, _themeDefault.default)(menuToken, 'light'),
            (0, _themeDefault.default)(menuDarkToken, 'dark'),
            // RTL
            (0, _rtlDefault.default)(menuToken),
            // Motion
            (0, _motion.genCollapseMotion)(menuToken),
            (0, _motion.initSlideMotion)(menuToken, 'slide-up'),
            (0, _motion.initSlideMotion)(menuToken, 'slide-down'),
            (0, _motion.initZoomMotion)(menuToken, 'zoom-big')
        ];
    }, prepareComponentToken, {
        deprecatedTokens: [
            [
                'colorGroupTitle',
                'groupTitleColor'
            ],
            [
                'radiusItem',
                'itemBorderRadius'
            ],
            [
                'radiusSubMenuItem',
                'subMenuItemBorderRadius'
            ],
            [
                'colorItemText',
                'itemColor'
            ],
            [
                'colorItemTextHover',
                'itemHoverColor'
            ],
            [
                'colorItemTextHoverHorizontal',
                'horizontalItemHoverColor'
            ],
            [
                'colorItemTextSelected',
                'itemSelectedColor'
            ],
            [
                'colorItemTextSelectedHorizontal',
                'horizontalItemSelectedColor'
            ],
            [
                'colorItemTextDisabled',
                'itemDisabledColor'
            ],
            [
                'colorDangerItemText',
                'dangerItemColor'
            ],
            [
                'colorDangerItemTextHover',
                'dangerItemHoverColor'
            ],
            [
                'colorDangerItemTextSelected',
                'dangerItemSelectedColor'
            ],
            [
                'colorDangerItemBgActive',
                'dangerItemActiveBg'
            ],
            [
                'colorDangerItemBgSelected',
                'dangerItemSelectedBg'
            ],
            [
                'colorItemBg',
                'itemBg'
            ],
            [
                'colorItemBgHover',
                'itemHoverBg'
            ],
            [
                'colorSubItemBg',
                'subMenuItemBg'
            ],
            [
                'colorItemBgActive',
                'itemActiveBg'
            ],
            [
                'colorItemBgSelectedHorizontal',
                'horizontalItemSelectedBg'
            ],
            [
                'colorActiveBarWidth',
                'activeBarWidth'
            ],
            [
                'colorActiveBarHeight',
                'activeBarHeight'
            ],
            [
                'colorActiveBarBorderSize',
                'activeBarBorderWidth'
            ],
            [
                'colorItemBgSelected',
                'itemSelectedBg'
            ]
        ],
        // Dropdown will handle menu style self. We do not need to handle this.
        injectStyle,
        unitless: {
            groupTitleLineHeight: true
        }
    });
    return useStyle(prefixCls, rootCls);
};

},{"@ant-design/cssinjs":"2VNL8","@ant-design/fast-color":"50VUA","../../style":"4Ezp0","../../style/motion":[["genCollapseMotion","dERCf","default"],["initSlideMotion","9hH4M"],["initZoomMotion","dqyUY"]],"../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"./horizontal":"fUlS6","./rtl":"8GZ32","./theme":"3KGzE","./vertical":"kAX8j","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9hH4M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "slideUpIn", ()=>slideUpIn);
parcelHelpers.export(exports, "slideUpOut", ()=>slideUpOut);
parcelHelpers.export(exports, "slideDownIn", ()=>slideDownIn);
parcelHelpers.export(exports, "slideDownOut", ()=>slideDownOut);
parcelHelpers.export(exports, "slideLeftIn", ()=>slideLeftIn);
parcelHelpers.export(exports, "slideLeftOut", ()=>slideLeftOut);
parcelHelpers.export(exports, "slideRightIn", ()=>slideRightIn);
parcelHelpers.export(exports, "slideRightOut", ()=>slideRightOut);
parcelHelpers.export(exports, "initSlideMotion", ()=>initSlideMotion);
var _cssinjs = require("@ant-design/cssinjs");
var _motion = require("./motion");
const slideUpIn = new (0, _cssinjs.Keyframes)('antSlideUpIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const slideUpOut = new (0, _cssinjs.Keyframes)('antSlideUpOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const slideDownIn = new (0, _cssinjs.Keyframes)('antSlideDownIn', {
    '0%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    }
});
const slideDownOut = new (0, _cssinjs.Keyframes)('antSlideDownOut', {
    '0%': {
        transform: 'scaleY(1)',
        transformOrigin: '100% 100%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleY(0.8)',
        transformOrigin: '100% 100%',
        opacity: 0
    }
});
const slideLeftIn = new (0, _cssinjs.Keyframes)('antSlideLeftIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    }
});
const slideLeftOut = new (0, _cssinjs.Keyframes)('antSlideLeftOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '0% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '0% 0%',
        opacity: 0
    }
});
const slideRightIn = new (0, _cssinjs.Keyframes)('antSlideRightIn', {
    '0%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    },
    '100%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    }
});
const slideRightOut = new (0, _cssinjs.Keyframes)('antSlideRightOut', {
    '0%': {
        transform: 'scaleX(1)',
        transformOrigin: '100% 0%',
        opacity: 1
    },
    '100%': {
        transform: 'scaleX(0.8)',
        transformOrigin: '100% 0%',
        opacity: 0
    }
});
const slideMotion = {
    'slide-up': {
        inKeyframes: slideUpIn,
        outKeyframes: slideUpOut
    },
    'slide-down': {
        inKeyframes: slideDownIn,
        outKeyframes: slideDownOut
    },
    'slide-left': {
        inKeyframes: slideLeftIn,
        outKeyframes: slideLeftOut
    },
    'slide-right': {
        inKeyframes: slideRightIn,
        outKeyframes: slideRightOut
    }
};
const initSlideMotion = (token, motionName)=>{
    const { antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes, outKeyframes } = slideMotion[motionName];
    return [
        (0, _motion.initMotion)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
                transform: 'scale(0)',
                transformOrigin: '0% 0%',
                opacity: 0,
                animationTimingFunction: token.motionEaseOutQuint,
                '&-prepare': {
                    transform: 'scale(1)'
                }
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInQuint
            }
        }
    ];
};

},{"@ant-design/cssinjs":"2VNL8","./motion":"eBupP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fUlS6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
const getHorizontalStyle = (token)=>{
    const { componentCls, motionDurationSlow, horizontalLineHeight, colorSplit, lineWidth, lineType, itemPaddingInline } = token;
    return {
        [`${componentCls}-horizontal`]: {
            lineHeight: horizontalLineHeight,
            border: 0,
            borderBottom: `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorSplit}`,
            boxShadow: 'none',
            '&::after': {
                display: 'block',
                clear: 'both',
                height: 0,
                content: '"\\20"'
            },
            // ======================= Item =======================
            [`${componentCls}-item, ${componentCls}-submenu`]: {
                position: 'relative',
                display: 'inline-block',
                verticalAlign: 'bottom',
                paddingInline: itemPaddingInline
            },
            [`> ${componentCls}-item:hover,
        > ${componentCls}-item-active,
        > ${componentCls}-submenu ${componentCls}-submenu-title:hover`]: {
                backgroundColor: 'transparent'
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                transition: [
                    `border-color ${motionDurationSlow}`,
                    `background ${motionDurationSlow}`
                ].join(',')
            },
            // ===================== Sub Menu =====================
            [`${componentCls}-submenu-arrow`]: {
                display: 'none'
            }
        }
    };
};
exports.default = getHorizontalStyle;

},{"@ant-design/cssinjs":"2VNL8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8GZ32":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
const getRTLStyle = ({ componentCls, menuArrowOffset, calc })=>({
        [`${componentCls}-rtl`]: {
            direction: 'rtl'
        },
        [`${componentCls}-submenu-rtl`]: {
            transformOrigin: '100% 0'
        },
        // Vertical Arrow
        [`${componentCls}-rtl${componentCls}-vertical,
    ${componentCls}-submenu-rtl ${componentCls}-vertical`]: {
            [`${componentCls}-submenu-arrow`]: {
                '&::before': {
                    transform: `rotate(-45deg) translateY(${(0, _cssinjs.unit)(calc(menuArrowOffset).mul(-1).equal())})`
                },
                '&::after': {
                    transform: `rotate(45deg) translateY(${(0, _cssinjs.unit)(menuArrowOffset)})`
                }
            }
        }
    });
exports.default = getRTLStyle;

},{"@ant-design/cssinjs":"2VNL8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3KGzE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../style");
const accessibilityFocus = (token)=>(0, _style.genFocusOutline)(token);
const getThemeStyle = (token, themeSuffix)=>{
    const { componentCls, itemColor, itemSelectedColor, subMenuItemSelectedColor, groupTitleColor, itemBg, subMenuItemBg, itemSelectedBg, activeBarHeight, activeBarWidth, activeBarBorderWidth, motionDurationSlow, motionEaseInOut, motionEaseOut, itemPaddingInline, motionDurationMid, itemHoverColor, lineType, colorSplit, // Disabled
    itemDisabledColor, // Danger
    dangerItemColor, dangerItemHoverColor, dangerItemSelectedColor, dangerItemActiveBg, dangerItemSelectedBg, // Bg
    popupBg, itemHoverBg, itemActiveBg, menuSubMenuBg, // Horizontal
    horizontalItemSelectedColor, horizontalItemSelectedBg, horizontalItemBorderRadius, horizontalItemHoverBg } = token;
    return {
        [`${componentCls}-${themeSuffix}, ${componentCls}-${themeSuffix} > ${componentCls}`]: {
            color: itemColor,
            background: itemBg,
            [`&${componentCls}-root:focus-visible`]: {
                ...accessibilityFocus(token)
            },
            // ======================== Item ========================
            [`${componentCls}-item`]: {
                '&-group-title, &-extra': {
                    color: groupTitleColor
                }
            },
            [`${componentCls}-submenu-selected > ${componentCls}-submenu-title`]: {
                color: subMenuItemSelectedColor
            },
            [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                color: itemColor,
                [`&:not(${componentCls}-item-disabled):focus-visible`]: {
                    ...accessibilityFocus(token)
                }
            },
            // Disabled
            [`${componentCls}-item-disabled, ${componentCls}-submenu-disabled`]: {
                color: `${itemDisabledColor} !important`
            },
            // Hover
            [`${componentCls}-item:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                [`&:hover, > ${componentCls}-submenu-title:hover`]: {
                    color: itemHoverColor
                }
            },
            [`&:not(${componentCls}-horizontal)`]: {
                [`${componentCls}-item:not(${componentCls}-item-selected)`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                },
                [`${componentCls}-submenu-title`]: {
                    '&:hover': {
                        backgroundColor: itemHoverBg
                    },
                    '&:active': {
                        backgroundColor: itemActiveBg
                    }
                }
            },
            // Danger - only Item has
            [`${componentCls}-item-danger`]: {
                color: dangerItemColor,
                [`&${componentCls}-item:hover`]: {
                    [`&:not(${componentCls}-item-selected):not(${componentCls}-submenu-selected)`]: {
                        color: dangerItemHoverColor
                    }
                },
                [`&${componentCls}-item:active`]: {
                    background: dangerItemActiveBg
                }
            },
            [`${componentCls}-item a`]: {
                '&, &:hover': {
                    color: 'inherit'
                }
            },
            [`${componentCls}-item-selected`]: {
                color: itemSelectedColor,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    color: dangerItemSelectedColor
                },
                'a, a:hover': {
                    color: 'inherit'
                }
            },
            [`& ${componentCls}-item-selected`]: {
                backgroundColor: itemSelectedBg,
                // Danger
                [`&${componentCls}-item-danger`]: {
                    backgroundColor: dangerItemSelectedBg
                }
            },
            [`&${componentCls}-submenu > ${componentCls}`]: {
                backgroundColor: menuSubMenuBg
            },
            // ===== 设置浮层的颜色 =======
            // ！dark 模式会被popupBg 会被rest 为 darkPopupBg
            [`&${componentCls}-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            [`&${componentCls}-submenu-popup > ${componentCls}`]: {
                backgroundColor: popupBg
            },
            // ===== 设置浮层的颜色 end =======
            // ====================== Horizontal ======================
            [`&${componentCls}-horizontal`]: {
                ...themeSuffix === 'dark' ? {
                    borderBottom: 0
                } : {},
                [`> ${componentCls}-item, > ${componentCls}-submenu`]: {
                    top: activeBarBorderWidth,
                    marginTop: token.calc(activeBarBorderWidth).mul(-1).equal(),
                    marginBottom: 0,
                    borderRadius: horizontalItemBorderRadius,
                    '&::after': {
                        position: 'absolute',
                        insetInline: itemPaddingInline,
                        bottom: 0,
                        borderBottom: `${(0, _cssinjs.unit)(activeBarHeight)} solid transparent`,
                        transition: `border-color ${motionDurationSlow} ${motionEaseInOut}`,
                        content: '""'
                    },
                    '&:hover, &-active, &-open': {
                        background: horizontalItemHoverBg,
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    },
                    '&-selected': {
                        color: horizontalItemSelectedColor,
                        backgroundColor: horizontalItemSelectedBg,
                        '&:hover': {
                            backgroundColor: horizontalItemSelectedBg
                        },
                        '&::after': {
                            borderBottomWidth: activeBarHeight,
                            borderBottomColor: horizontalItemSelectedColor
                        }
                    }
                }
            },
            // ================== Inline & Vertical ===================
            //
            [`&${componentCls}-root`]: {
                [`&${componentCls}-inline, &${componentCls}-vertical`]: {
                    borderInlineEnd: `${(0, _cssinjs.unit)(activeBarBorderWidth)} ${lineType} ${colorSplit}`
                }
            },
            // ======================== Inline ========================
            [`&${componentCls}-inline`]: {
                // Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    background: subMenuItemBg
                },
                [`${componentCls}-item`]: {
                    position: 'relative',
                    '&::after': {
                        position: 'absolute',
                        insetBlock: 0,
                        insetInlineEnd: 0,
                        borderInlineEnd: `${(0, _cssinjs.unit)(activeBarWidth)} solid ${itemSelectedColor}`,
                        transform: 'scaleY(0.0001)',
                        opacity: 0,
                        transition: [
                            `transform ${motionDurationMid} ${motionEaseOut}`,
                            `opacity ${motionDurationMid} ${motionEaseOut}`
                        ].join(','),
                        content: '""'
                    },
                    // Danger
                    [`&${componentCls}-item-danger`]: {
                        '&::after': {
                            borderInlineEndColor: dangerItemSelectedColor
                        }
                    }
                },
                [`${componentCls}-selected, ${componentCls}-item-selected`]: {
                    '&::after': {
                        transform: 'scaleY(1)',
                        opacity: 1,
                        transition: [
                            `transform ${motionDurationMid} ${motionEaseInOut}`,
                            `opacity ${motionDurationMid} ${motionEaseInOut}`
                        ].join(',')
                    }
                }
            }
        }
    };
};
exports.default = getThemeStyle;

},{"@ant-design/cssinjs":"2VNL8","../../style":"4Ezp0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kAX8j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../style");
const getVerticalInlineStyle = (token)=>{
    const { componentCls, itemHeight, itemMarginInline, padding, menuArrowSize, marginXS, itemMarginBlock, itemWidth, itemPaddingInline } = token;
    const paddingWithArrow = token.calc(menuArrowSize).add(padding).add(marginXS).equal();
    return {
        [`${componentCls}-item`]: {
            position: 'relative',
            overflow: 'hidden'
        },
        [`${componentCls}-item, ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, _cssinjs.unit)(itemHeight),
            paddingInline: itemPaddingInline,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            marginInline: itemMarginInline,
            marginBlock: itemMarginBlock,
            width: itemWidth
        },
        [`> ${componentCls}-item,
            > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
            height: itemHeight,
            lineHeight: (0, _cssinjs.unit)(itemHeight)
        },
        [`${componentCls}-item-group-list ${componentCls}-submenu-title,
            ${componentCls}-submenu-title`]: {
            paddingInlineEnd: paddingWithArrow
        }
    };
};
const getVerticalStyle = (token)=>{
    const { componentCls, iconCls, itemHeight, colorTextLightSolid, dropdownWidth, controlHeightLG, motionEaseOut, paddingXL, itemMarginInline, fontSizeLG, motionDurationFast, motionDurationSlow, paddingXS, boxShadowSecondary, collapsedWidth, collapsedIconSize } = token;
    const inlineItemStyle = {
        height: itemHeight,
        lineHeight: (0, _cssinjs.unit)(itemHeight),
        listStylePosition: 'inside',
        listStyleType: 'disc'
    };
    return [
        {
            [componentCls]: {
                '&-inline, &-vertical': {
                    [`&${componentCls}-root`]: {
                        boxShadow: 'none'
                    },
                    ...getVerticalInlineStyle(token)
                }
            },
            [`${componentCls}-submenu-popup`]: {
                [`${componentCls}-vertical`]: {
                    ...getVerticalInlineStyle(token),
                    boxShadow: boxShadowSecondary
                }
            }
        },
        // Vertical only
        {
            [`${componentCls}-submenu-popup ${componentCls}-vertical${componentCls}-sub`]: {
                minWidth: dropdownWidth,
                maxHeight: `calc(100vh - ${(0, _cssinjs.unit)(token.calc(controlHeightLG).mul(2.5).equal())})`,
                padding: '0',
                overflow: 'hidden',
                borderInlineEnd: 0,
                // https://github.com/ant-design/ant-design/issues/22244
                // https://github.com/ant-design/ant-design/issues/26812
                "&:not([class*='-active'])": {
                    overflowX: 'hidden',
                    overflowY: 'auto'
                }
            }
        },
        // Inline Only
        {
            [`${componentCls}-inline`]: {
                width: '100%',
                // Motion enhance for first level
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu-title`]: {
                        display: 'flex',
                        alignItems: 'center',
                        transition: [
                            `border-color ${motionDurationSlow}`,
                            `background ${motionDurationSlow}`,
                            `padding ${motionDurationFast} ${motionEaseOut}`
                        ].join(','),
                        [`> ${componentCls}-title-content`]: {
                            flex: 'auto',
                            minWidth: 0,
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        },
                        '> *': {
                            flex: 'none'
                        }
                    }
                },
                // >>>>> Sub
                [`${componentCls}-sub${componentCls}-inline`]: {
                    padding: 0,
                    border: 0,
                    borderRadius: 0,
                    boxShadow: 'none',
                    [`& > ${componentCls}-submenu > ${componentCls}-submenu-title`]: inlineItemStyle,
                    [`& ${componentCls}-item-group-title`]: {
                        paddingInlineStart: paddingXL
                    }
                },
                // >>>>> Item
                [`${componentCls}-item`]: inlineItemStyle
            }
        },
        // Inline Collapse Only
        {
            [`${componentCls}-inline-collapsed`]: {
                width: collapsedWidth,
                [`&${componentCls}-root`]: {
                    [`${componentCls}-item, ${componentCls}-submenu ${componentCls}-submenu-title`]: {
                        [`> ${componentCls}-inline-collapsed-noicon`]: {
                            fontSize: fontSizeLG,
                            textAlign: 'center'
                        }
                    }
                },
                [`> ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-item,
          > ${componentCls}-item-group > ${componentCls}-item-group-list > ${componentCls}-submenu > ${componentCls}-submenu-title,
          > ${componentCls}-submenu > ${componentCls}-submenu-title`]: {
                    insetInlineStart: 0,
                    paddingInline: `calc(50% - ${(0, _cssinjs.unit)(token.calc(collapsedIconSize).div(2).equal())} - ${(0, _cssinjs.unit)(itemMarginInline)})`,
                    textOverflow: 'clip',
                    [`
            ${componentCls}-submenu-arrow,
            ${componentCls}-submenu-expand-icon
          `]: {
                        opacity: 0
                    },
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        margin: 0,
                        fontSize: collapsedIconSize,
                        lineHeight: (0, _cssinjs.unit)(itemHeight),
                        '+ span': {
                            display: 'inline-block',
                            opacity: 0
                        }
                    }
                },
                [`${componentCls}-item-icon, ${iconCls}`]: {
                    display: 'inline-block'
                },
                '&-tooltip': {
                    pointerEvents: 'none',
                    [`${componentCls}-item-icon, ${iconCls}`]: {
                        display: 'none'
                    },
                    'a, a:hover': {
                        color: colorTextLightSolid
                    }
                },
                [`${componentCls}-item-group-title`]: {
                    ...(0, _style.textEllipsis),
                    paddingInline: paddingXS
                }
            }
        }
    ];
};
exports.default = getVerticalStyle;

},{"@ant-design/cssinjs":"2VNL8","../../style":"4Ezp0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"664My":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _menu = require("@rc-component/menu");
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _reactNode = require("../_util/reactNode");
var _menuContext = require("./MenuContext");
var _menuContextDefault = parcelHelpers.interopDefault(_menuContext);
"use client";
const SubMenu = (props)=>{
    const { popupClassName, icon, title, theme: customTheme } = props;
    const context = _react.useContext((0, _menuContextDefault.default));
    const { prefixCls, inlineCollapsed, theme: contextTheme, classNames, styles } = context;
    const parentPath = (0, _menu.useFullPath)();
    let titleNode;
    if (!icon) titleNode = inlineCollapsed && !parentPath.length && title && typeof title === 'string' ? /*#__PURE__*/ _react.createElement("div", {
        className: `${prefixCls}-inline-collapsed-noicon`
    }, title.charAt(0)) : /*#__PURE__*/ _react.createElement("span", {
        className: `${prefixCls}-title-content`
    }, title);
    else {
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        const titleIsSpan = /*#__PURE__*/ _react.isValidElement(title) && title.type === 'span';
        titleNode = /*#__PURE__*/ _react.createElement(_react.Fragment, null, (0, _reactNode.cloneElement)(icon, (oriProps)=>({
                className: (0, _clsx.clsx)(oriProps.className, `${prefixCls}-item-icon`, classNames.itemIcon),
                style: {
                    ...oriProps.style,
                    ...styles.itemIcon
                }
            })), titleIsSpan ? title : /*#__PURE__*/ _react.createElement("span", {
            className: `${prefixCls}-title-content`
        }, title));
    }
    const contextValue = _react.useMemo(()=>({
            ...context,
            firstLevel: false
        }), [
        context
    ]);
    // ============================ zIndex ============================
    const [zIndex] = (0, _hooks.useZIndex)('Menu');
    return /*#__PURE__*/ _react.createElement((0, _menuContextDefault.default).Provider, {
        value: contextValue
    }, /*#__PURE__*/ _react.createElement((0, _menu.SubMenu), {
        ...(0, _util.omit)(props, [
            'icon'
        ]),
        title: titleNode,
        classNames: {
            list: classNames.subMenu.list,
            listTitle: classNames.subMenu.itemTitle
        },
        styles: {
            list: styles.subMenu.list,
            listTitle: styles.subMenu.itemTitle
        },
        popupClassName: (0, _clsx.clsx)(prefixCls, popupClassName, classNames.popup.root, `${prefixCls}-${customTheme || contextTheme}`),
        popupStyle: {
            zIndex,
            // fix: https://github.com/ant-design/ant-design/issues/47826#issuecomment-2360737237
            ...props.popupStyle,
            ...styles.popup.root
        }
    }));
};
exports.default = SubMenu;

},{"react":"bmhQu","@rc-component/menu":"g7yI2","@rc-component/util":"6ZBDN","clsx":"431Ou","../_util/hooks":"6noQ6","../_util/reactNode":"78pFx","./MenuContext":"7yALB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1qNc0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../style");
var _motion = require("../../style/motion");
var _placementArrow = require("../../style/placementArrow");
var _placementArrowDefault = parcelHelpers.interopDefault(_placementArrow);
var _roundedArrow = require("../../style/roundedArrow");
var _internal = require("../../theme/internal");
var _status = require("./status");
var _statusDefault = parcelHelpers.interopDefault(_status);
// =============================== Base ===============================
const genBaseStyle = (token)=>{
    const { componentCls, menuCls, zIndexPopup, dropdownArrowDistance, sizePopupArrow, antCls, iconCls, motionDurationMid, paddingBlock, fontSize, dropdownEdgeChildPadding, colorTextDisabled, fontSizeIcon, controlPaddingHorizontal, colorBgElevated } = token;
    return [
        {
            [componentCls]: {
                position: 'absolute',
                top: -9999,
                left: {
                    _skip_check_: true,
                    value: -9999
                },
                zIndex: zIndexPopup,
                display: 'block',
                // A placeholder out of dropdown visible range to avoid close when user moving
                '&::before': {
                    position: 'absolute',
                    insetBlock: token.calc(sizePopupArrow).div(2).sub(dropdownArrowDistance).equal(),
                    // insetInlineStart: -7, // FIXME: Seems not work for hidden element
                    zIndex: -9999,
                    opacity: 0.0001,
                    content: '""'
                },
                // Makes vertical dropdowns have a scrollbar once they become taller than the viewport.
                '&-menu-vertical': {
                    maxHeight: '100vh',
                    overflowY: 'auto'
                },
                [`&-trigger${antCls}-btn`]: {
                    [`& > ${iconCls}-down, & > ${antCls}-btn-icon > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    }
                },
                [`${componentCls}-wrap`]: {
                    position: 'relative',
                    [`${antCls}-btn > ${iconCls}-down`]: {
                        fontSize: fontSizeIcon
                    },
                    [`${iconCls}-down::before`]: {
                        transition: `transform ${motionDurationMid}`
                    }
                },
                [`${componentCls}-wrap-open`]: {
                    [`${iconCls}-down::before`]: {
                        transform: `rotate(180deg)`
                    }
                },
                [`
        &-hidden,
        &-menu-hidden,
        &-menu-submenu-hidden
      `]: {
                    display: 'none'
                },
                // =============================================================
                // ==                         Motion                          ==
                // =============================================================
                // When position is not enough for dropdown, the placement will revert.
                // We will handle this with revert motion name.
                [`&${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-enter${antCls}-slide-down-enter-active${componentCls}-placement-bottomRight,
          &${antCls}-slide-down-appear${antCls}-slide-down-appear-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, _motion.slideUpIn)
                },
                [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-top,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-top,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-placement-topRight`]: {
                    animationName: (0, _motion.slideDownIn)
                },
                [`&${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomLeft,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottom,
          &${antCls}-slide-down-leave${antCls}-slide-down-leave-active${componentCls}-placement-bottomRight`]: {
                    animationName: (0, _motion.slideUpOut)
                },
                [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-top,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-placement-topRight`]: {
                    animationName: (0, _motion.slideDownOut)
                }
            }
        },
        // =============================================================
        // ==                        Arrow style                      ==
        // =============================================================
        (0, _placementArrowDefault.default)(token, colorBgElevated, {
            arrowPlacement: {
                top: true,
                bottom: true
            }
        }),
        {
            // =============================================================
            // ==                          Menu                           ==
            // =============================================================
            [`${componentCls} ${menuCls}`]: {
                position: 'relative',
                margin: 0
            },
            [`${menuCls}-submenu-popup`]: {
                position: 'absolute',
                zIndex: zIndexPopup,
                background: 'transparent',
                boxShadow: 'none',
                transformOrigin: '0 0',
                'ul, li': {
                    listStyle: 'none',
                    margin: 0
                }
            },
            [`${componentCls}, ${componentCls}-menu-submenu`]: {
                ...(0, _style.resetComponent)(token),
                [menuCls]: {
                    padding: dropdownEdgeChildPadding,
                    listStyleType: 'none',
                    backgroundColor: colorBgElevated,
                    backgroundClip: 'padding-box',
                    borderRadius: token.borderRadiusLG,
                    outline: 'none',
                    boxShadow: token.boxShadowSecondary,
                    ...(0, _style.genFocusStyle)(token),
                    '&:empty': {
                        padding: 0,
                        boxShadow: 'none'
                    },
                    [`${menuCls}-item-group-title`]: {
                        padding: `${(0, _cssinjs.unit)(paddingBlock)} ${(0, _cssinjs.unit)(controlPaddingHorizontal)}`,
                        color: token.colorTextDescription,
                        transition: `all ${motionDurationMid}`
                    },
                    // ======================= Item Content =======================
                    [`${menuCls}-item`]: {
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center'
                    },
                    [`${menuCls}-item-icon`]: {
                        minWidth: fontSize,
                        marginInlineEnd: token.marginXS,
                        fontSize: token.fontSizeSM
                    },
                    [`${menuCls}-title-content`]: {
                        flex: 'auto',
                        '&-with-extra': {
                            display: 'inline-flex',
                            alignItems: 'center',
                            width: '100%'
                        },
                        '> a': {
                            color: 'inherit',
                            transition: `all ${motionDurationMid}`,
                            '&:hover': {
                                color: 'inherit'
                            },
                            '&::after': {
                                position: 'absolute',
                                inset: 0,
                                content: '""'
                            }
                        },
                        [`${menuCls}-item-extra`]: {
                            paddingInlineStart: token.padding,
                            marginInlineStart: 'auto',
                            fontSize: token.fontSizeSM,
                            color: token.colorTextDescription
                        }
                    },
                    // =========================== Item ===========================
                    [`${menuCls}-item, ${menuCls}-submenu-title`]: {
                        display: 'flex',
                        margin: 0,
                        padding: `${(0, _cssinjs.unit)(paddingBlock)} ${(0, _cssinjs.unit)(controlPaddingHorizontal)}`,
                        color: token.colorText,
                        fontWeight: 'normal',
                        fontSize,
                        lineHeight: token.lineHeight,
                        cursor: 'pointer',
                        transition: `all ${motionDurationMid}`,
                        borderRadius: token.borderRadiusSM,
                        '&:hover, &-active': {
                            backgroundColor: token.controlItemBgHover
                        },
                        ...(0, _style.genFocusStyle)(token),
                        '&-selected': {
                            color: token.colorPrimary,
                            backgroundColor: token.controlItemBgActive,
                            '&:hover, &-active': {
                                backgroundColor: token.controlItemBgActiveHover
                            }
                        },
                        '&-disabled': {
                            color: colorTextDisabled,
                            cursor: 'not-allowed',
                            '&:hover': {
                                color: colorTextDisabled,
                                backgroundColor: colorBgElevated,
                                cursor: 'not-allowed'
                            },
                            a: {
                                pointerEvents: 'none'
                            }
                        },
                        '&-divider': {
                            height: 1,
                            // By design
                            margin: `${(0, _cssinjs.unit)(token.marginXXS)} 0`,
                            overflow: 'hidden',
                            lineHeight: 0,
                            backgroundColor: token.colorSplit
                        },
                        [`${componentCls}-menu-submenu-expand-icon`]: {
                            position: 'absolute',
                            insetInlineEnd: token.paddingXS,
                            [`${componentCls}-menu-submenu-arrow-icon`]: {
                                marginInlineEnd: '0 !important',
                                color: token.colorIcon,
                                fontSize: fontSizeIcon,
                                fontStyle: 'normal'
                            }
                        }
                    },
                    [`${menuCls}-item-group-list`]: {
                        margin: `0 ${(0, _cssinjs.unit)(token.marginXS)}`,
                        padding: 0,
                        listStyle: 'none'
                    },
                    [`${menuCls}-submenu-title`]: {
                        paddingInlineEnd: token.calc(controlPaddingHorizontal).add(token.fontSizeSM).equal()
                    },
                    [`${menuCls}-submenu-vertical`]: {
                        position: 'relative'
                    },
                    [`${menuCls}-submenu${menuCls}-submenu-disabled ${componentCls}-menu-submenu-title`]: {
                        [`&, ${componentCls}-menu-submenu-arrow-icon`]: {
                            color: colorTextDisabled,
                            backgroundColor: colorBgElevated,
                            cursor: 'not-allowed'
                        }
                    },
                    // https://github.com/ant-design/ant-design/issues/19264
                    [`${menuCls}-submenu-selected ${componentCls}-menu-submenu-title`]: {
                        color: token.colorPrimary
                    }
                }
            }
        },
        // Follow code may reuse in other components
        [
            (0, _motion.initSlideMotion)(token, 'slide-up'),
            (0, _motion.initSlideMotion)(token, 'slide-down'),
            (0, _motion.initMoveMotion)(token, 'move-up'),
            (0, _motion.initMoveMotion)(token, 'move-down'),
            (0, _motion.initZoomMotion)(token, 'zoom-big')
        ]
    ];
};
const prepareComponentToken = (token)=>({
        zIndexPopup: token.zIndexPopupBase + 50,
        paddingBlock: (token.controlHeight - token.fontSize * token.lineHeight) / 2,
        ...(0, _placementArrow.getArrowOffsetToken)({
            contentRadius: token.borderRadiusLG,
            limitVerticalRadius: true
        }),
        ...(0, _roundedArrow.getArrowToken)(token)
    });
exports.default = (0, _internal.genStyleHooks)('Dropdown', (token)=>{
    const { marginXXS, sizePopupArrow, paddingXXS, componentCls } = token;
    const dropdownToken = (0, _internal.mergeToken)(token, {
        menuCls: `${componentCls}-menu`,
        dropdownArrowDistance: token.calc(sizePopupArrow).div(2).add(marginXXS).equal(),
        dropdownEdgeChildPadding: paddingXXS
    });
    return [
        genBaseStyle(dropdownToken),
        (0, _statusDefault.default)(dropdownToken)
    ];
}, prepareComponentToken, {
    resetStyle: false
});

},{"@ant-design/cssinjs":"2VNL8","../../style":"4Ezp0","../../style/motion":[["initMoveMotion","1R9U2"],["initSlideMotion","9hH4M"],["slideDownIn","9hH4M"],["slideDownOut","9hH4M"],["slideUpIn","9hH4M"],["slideUpOut","9hH4M"],["initZoomMotion","dqyUY"]],"../../style/placementArrow":"73A7X","../../style/roundedArrow":"dmj3M","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"./status":"lXtp0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1R9U2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "moveDownIn", ()=>moveDownIn);
parcelHelpers.export(exports, "moveDownOut", ()=>moveDownOut);
parcelHelpers.export(exports, "moveLeftIn", ()=>moveLeftIn);
parcelHelpers.export(exports, "moveLeftOut", ()=>moveLeftOut);
parcelHelpers.export(exports, "moveRightIn", ()=>moveRightIn);
parcelHelpers.export(exports, "moveRightOut", ()=>moveRightOut);
parcelHelpers.export(exports, "moveUpIn", ()=>moveUpIn);
parcelHelpers.export(exports, "moveUpOut", ()=>moveUpOut);
parcelHelpers.export(exports, "initMoveMotion", ()=>initMoveMotion);
var _cssinjs = require("@ant-design/cssinjs");
var _motion = require("./motion");
const moveDownIn = new (0, _cssinjs.Keyframes)('antMoveDownIn', {
    '0%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const moveDownOut = new (0, _cssinjs.Keyframes)('antMoveDownOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, 100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const moveLeftIn = new (0, _cssinjs.Keyframes)('antMoveLeftIn', {
    '0%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const moveLeftOut = new (0, _cssinjs.Keyframes)('antMoveLeftOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(-100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const moveRightIn = new (0, _cssinjs.Keyframes)('antMoveRightIn', {
    '0%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const moveRightOut = new (0, _cssinjs.Keyframes)('antMoveRightOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(100%, 0, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const moveUpIn = new (0, _cssinjs.Keyframes)('antMoveUpIn', {
    '0%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    },
    '100%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    }
});
const moveUpOut = new (0, _cssinjs.Keyframes)('antMoveUpOut', {
    '0%': {
        transform: 'translate3d(0, 0, 0)',
        transformOrigin: '0 0',
        opacity: 1
    },
    '100%': {
        transform: 'translate3d(0, -100%, 0)',
        transformOrigin: '0 0',
        opacity: 0
    }
});
const moveMotion = {
    'move-up': {
        inKeyframes: moveUpIn,
        outKeyframes: moveUpOut
    },
    'move-down': {
        inKeyframes: moveDownIn,
        outKeyframes: moveDownOut
    },
    'move-left': {
        inKeyframes: moveLeftIn,
        outKeyframes: moveLeftOut
    },
    'move-right': {
        inKeyframes: moveRightIn,
        outKeyframes: moveRightOut
    }
};
const initMoveMotion = (token, motionName)=>{
    const { antCls } = token;
    const motionCls = `${antCls}-${motionName}`;
    const { inKeyframes, outKeyframes } = moveMotion[motionName];
    return [
        (0, _motion.initMotion)(motionCls, inKeyframes, outKeyframes, token.motionDurationMid),
        {
            [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
                opacity: 0,
                animationTimingFunction: token.motionEaseOutCirc
            },
            [`${motionCls}-leave`]: {
                animationTimingFunction: token.motionEaseInOutCirc
            }
        }
    ];
};

},{"@ant-design/cssinjs":"2VNL8","./motion":"eBupP","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lXtp0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
const genStatusStyle = (token)=>{
    const { componentCls, menuCls, colorError, colorTextLightSolid } = token;
    const itemCls = `${menuCls}-item`;
    return {
        [`${componentCls}, ${componentCls}-menu-submenu`]: {
            [`${menuCls} ${itemCls}`]: {
                [`&${itemCls}-danger:not(${itemCls}-disabled)`]: {
                    color: colorError,
                    '&:hover': {
                        color: colorTextLightSolid,
                        backgroundColor: colorError
                    }
                }
            }
        }
    };
};
exports.default = genStatusStyle;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"LJNYU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _ellipsisOutlined = require("@ant-design/icons/es/icons/EllipsisOutlined");
var _ellipsisOutlinedDefault = parcelHelpers.interopDefault(_ellipsisOutlined);
var _clsx = require("clsx");
var _warning = require("../_util/warning");
var _button = require("../button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _configProvider = require("../config-provider");
var _space = require("../space");
var _spaceDefault = parcelHelpers.interopDefault(_space);
var _compact = require("../space/Compact");
var _dropdown = require("./dropdown");
var _dropdownDefault = parcelHelpers.interopDefault(_dropdown);
"use client";
/** @deprecated Please use Space.Compact + Dropdown + Button instead */ const DropdownButton = (props)=>{
    const { getPopupContainer: getContextPopupContainer, getPrefixCls, direction } = _react.useContext((0, _configProvider.ConfigContext));
    const { prefixCls: customizePrefixCls, type = 'default', danger, disabled, loading, onClick, htmlType, children, className, menu, arrow, autoFocus, trigger, align, open, onOpenChange, placement, getPopupContainer, href, icon = /*#__PURE__*/ _react.createElement((0, _ellipsisOutlinedDefault.default), null), title, buttonsRender = (buttons)=>buttons, mouseEnterDelay, mouseLeaveDelay, overlayClassName, overlayStyle, destroyOnHidden, destroyPopupOnHide, dropdownRender, popupRender, ...restProps } = props;
    const prefixCls = getPrefixCls('dropdown', customizePrefixCls);
    const buttonPrefixCls = `${prefixCls}-button`;
    const mergedPopupRender = popupRender || dropdownRender;
    const dropdownProps = {
        menu,
        arrow,
        autoFocus,
        align,
        disabled,
        trigger: disabled ? [] : trigger,
        onOpenChange,
        getPopupContainer: getPopupContainer || getContextPopupContainer,
        mouseEnterDelay,
        mouseLeaveDelay,
        classNames: {
            root: overlayClassName
        },
        styles: {
            root: overlayStyle
        },
        destroyOnHidden,
        popupRender: mergedPopupRender
    };
    const { compactSize, compactItemClassnames } = (0, _compact.useCompactItemContext)(prefixCls, direction);
    const classes = (0, _clsx.clsx)(buttonPrefixCls, compactItemClassnames, className);
    if ('destroyPopupOnHide' in props) dropdownProps.destroyPopupOnHide = destroyPopupOnHide;
    if ('open' in props) dropdownProps.open = open;
    if ('placement' in props) dropdownProps.placement = placement;
    else dropdownProps.placement = direction === 'rtl' ? 'bottomLeft' : 'bottomRight';
    const leftButton = /*#__PURE__*/ _react.createElement((0, _buttonDefault.default), {
        type: type,
        danger: danger,
        disabled: disabled,
        loading: loading,
        onClick: onClick,
        htmlType: htmlType,
        href: href,
        title: title
    }, children);
    const rightButton = /*#__PURE__*/ _react.createElement((0, _buttonDefault.default), {
        type: type,
        danger: danger,
        icon: icon
    });
    const [leftButtonToRender, rightButtonToRender] = buttonsRender([
        leftButton,
        rightButton
    ]);
    return /*#__PURE__*/ _react.createElement((0, _spaceDefault.default).Compact, {
        className: classes,
        size: compactSize,
        block: true,
        ...restProps
    }, leftButtonToRender, /*#__PURE__*/ _react.createElement((0, _dropdownDefault.default), {
        ...dropdownProps
    }, rightButtonToRender));
};
DropdownButton.__ANT_BUTTON = true;
exports.default = DropdownButton;

},{"react":"bmhQu","@ant-design/icons/es/icons/EllipsisOutlined":"dRAyj","clsx":"431Ou","../_util/warning":"95o3w","../button":"8HvYt","../config-provider":"dVeAX","../space":"j7a5D","../space/Compact":"cOSpV","./dropdown":"h5C4r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j7a5D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpaceContext", ()=>(0, _context1.SpaceContext));
var _react = require("react");
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _gapSize = require("../_util/gapSize");
var _hooks = require("../_util/hooks");
var _isNonNullable = require("../_util/isNonNullable");
var _isNonNullableDefault = parcelHelpers.interopDefault(_isNonNullable);
var _warning = require("../_util/warning");
var _context = require("../config-provider/context");
var _compact = require("./Compact");
var _compactDefault = parcelHelpers.interopDefault(_compact);
var _addon = require("./Addon");
var _addonDefault = parcelHelpers.interopDefault(_addon);
var _context1 = require("./context");
var _item = require("./Item");
var _itemDefault = parcelHelpers.interopDefault(_item);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const InternalSpace = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { getPrefixCls, direction: directionConfig, size: contextSize, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('space');
    const { size = contextSize ?? 'small', align, className, rootClassName, children, direction, orientation, prefixCls: customizePrefixCls, split, separator, style, vertical, wrap = false, classNames, styles, ...restProps } = props;
    const [horizontalSize, verticalSize] = Array.isArray(size) ? size : [
        size,
        size
    ];
    const isPresetVerticalSize = (0, _gapSize.isPresetSize)(verticalSize);
    const isPresetHorizontalSize = (0, _gapSize.isPresetSize)(horizontalSize);
    const isValidVerticalSize = (0, _gapSize.isValidGapNumber)(verticalSize);
    const isValidHorizontalSize = (0, _gapSize.isValidGapNumber)(horizontalSize);
    const childNodes = (0, _util.toArray)(children, {
        keepEmpty: true
    });
    const [mergedOrientation, mergedVertical] = (0, _hooks.useOrientation)(orientation, vertical, direction);
    const mergedAlign = align === undefined && !mergedVertical ? 'center' : align;
    const mergedSeparator = separator ?? split;
    const prefixCls = getPrefixCls('space', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size,
        orientation: mergedOrientation,
        align: mergedAlign
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, _clsx.clsx)(prefixCls, contextClassName, hashId, `${prefixCls}-${mergedOrientation}`, {
        [`${prefixCls}-rtl`]: directionConfig === 'rtl',
        [`${prefixCls}-align-${mergedAlign}`]: mergedAlign,
        [`${prefixCls}-gap-row-${verticalSize}`]: isPresetVerticalSize,
        [`${prefixCls}-gap-col-${horizontalSize}`]: isPresetHorizontalSize
    }, className, rootClassName, cssVarCls, mergedClassNames.root);
    const itemClassName = (0, _clsx.clsx)(`${prefixCls}-item`, mergedClassNames.item);
    // Calculate latest one
    const renderedItems = childNodes.map((child, i)=>{
        const key = child?.key || `${itemClassName}-${i}`;
        return /*#__PURE__*/ _react.createElement((0, _itemDefault.default), {
            prefix: prefixCls,
            classNames: mergedClassNames,
            styles: mergedStyles,
            className: itemClassName,
            key: key,
            index: i,
            separator: mergedSeparator,
            style: mergedStyles.item
        }, child);
    });
    var deprecatedName, newName;
    const memoizedSpaceContext = _react.useMemo(()=>{
        const calcLatestIndex = childNodes.reduce((latest, child, i)=>(0, _isNonNullableDefault.default)(child) ? i : latest, 0);
        return {
            latestIndex: calcLatestIndex
        };
    }, [
        childNodes
    ]);
    // =========================== Render ===========================
    if (childNodes.length === 0) return null;
    const gapStyle = {};
    if (wrap) gapStyle.flexWrap = 'wrap';
    if (!isPresetHorizontalSize && isValidHorizontalSize) gapStyle.columnGap = horizontalSize;
    if (!isPresetVerticalSize && isValidVerticalSize) gapStyle.rowGap = verticalSize;
    return /*#__PURE__*/ _react.createElement("div", {
        ref: ref,
        className: rootClassNames,
        style: {
            ...gapStyle,
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        ...restProps
    }, /*#__PURE__*/ _react.createElement((0, _context1.SpaceContextProvider), {
        value: memoizedSpaceContext
    }, renderedItems));
});
const Space = InternalSpace;
Space.Compact = (0, _compactDefault.default);
Space.Addon = (0, _addonDefault.default);
exports.default = Space;

},{"react":"bmhQu","@rc-component/util":"6ZBDN","clsx":"431Ou","../_util/gapSize":"frDe8","../_util/hooks":[["useMergeSemantic","kdnMA"],["useOrientation","k313C"]],"../_util/isNonNullable":"avlqw","../_util/warning":"95o3w","../config-provider/context":"75zwC","./Compact":"cOSpV","./Addon":"9yR8C","./context":"1Z5nX","./Item":"fTNNx","./style":"2nL40","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"frDe8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPresetSize", ()=>isPresetSize);
parcelHelpers.export(exports, "isValidGapNumber", ()=>isValidGapNumber);
function isPresetSize(size) {
    return [
        'small',
        'middle',
        'large'
    ].includes(size);
}
function isValidGapNumber(size) {
    if (!size) // The case of size = 0 is deliberately excluded here, because the default value of the gap attribute in CSS is 0, so if the user passes 0 in, we can directly ignore it.
    return false;
    return typeof size === 'number' && !Number.isNaN(size);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9yR8C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _clsx = require("clsx");
var _statusUtils = require("../_util/statusUtils");
var _configProvider = require("../config-provider");
var _compact = require("./Compact");
var _addon = require("./style/addon");
var _addonDefault = parcelHelpers.interopDefault(_addon);
"use client";
const SpaceAddon = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { className, children, style, prefixCls: customizePrefixCls, variant = 'outlined', disabled, status, ...restProps } = props;
    const { getPrefixCls, direction: directionConfig } = (0, _reactDefault.default).useContext((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('space-addon', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _addonDefault.default)(prefixCls);
    const { compactItemClassnames, compactSize } = (0, _compact.useCompactItemContext)(prefixCls, directionConfig);
    const statusCls = (0, _statusUtils.getStatusClassNames)(prefixCls, status);
    const classes = (0, _clsx.clsx)(prefixCls, hashId, compactItemClassnames, cssVarCls, `${prefixCls}-variant-${variant}`, statusCls, {
        [`${prefixCls}-${compactSize}`]: compactSize,
        [`${prefixCls}-disabled`]: disabled
    }, className);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement("div", {
        ref: ref,
        className: classes,
        style: style,
        ...restProps
    }, children);
});
exports.default = SpaceAddon;

},{"react":"bmhQu","clsx":"431Ou","../_util/statusUtils":"gbJk4","../config-provider":"dVeAX","./Compact":"cOSpV","./style/addon":"6yLZB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gbJk4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStatusClassNames", ()=>getStatusClassNames);
parcelHelpers.export(exports, "getMergedStatus", ()=>getMergedStatus);
var _clsx = require("clsx");
const _InputStatuses = [
    'warning',
    'error',
    '',
    'success',
    'validating'
];
const getStatusClassNames = (prefixCls, status, hasFeedback)=>{
    return (0, _clsx.clsx)({
        [`${prefixCls}-status-success`]: status === 'success',
        [`${prefixCls}-status-warning`]: status === 'warning',
        [`${prefixCls}-status-error`]: status === 'error',
        [`${prefixCls}-status-validating`]: status === 'validating',
        [`${prefixCls}-has-feedback`]: hasFeedback
    });
};
const getMergedStatus = (contextStatus, customStatus)=>customStatus || contextStatus;

},{"clsx":"431Ou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6yLZB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _compactItem = require("../../style/compact-item");
var _internal = require("../../theme/internal");
const genSpaceAddonStyle = (token)=>{
    const { componentCls, borderRadius, paddingSM, colorBorder, paddingXS, fontSizeLG, fontSizeSM, borderRadiusLG, borderRadiusSM, colorBgContainerDisabled, lineWidth } = token;
    return {
        [componentCls]: [
            // ==========================================================
            // ==                         Base                         ==
            // ==========================================================
            {
                display: 'inline-flex',
                alignItems: 'center',
                gap: 0,
                paddingInline: paddingSM,
                margin: 0,
                borderWidth: lineWidth,
                borderStyle: 'solid',
                borderRadius,
                '&:hover': {
                    zIndex: 0
                },
                [`&${componentCls}-disabled`]: {
                    color: token.colorTextDisabled
                },
                '&-large': {
                    fontSize: fontSizeLG,
                    borderRadius: borderRadiusLG
                },
                '&-small': {
                    paddingInline: paddingXS,
                    borderRadius: borderRadiusSM,
                    fontSize: fontSizeSM
                },
                '&-compact-last-item': {
                    borderEndStartRadius: 0,
                    borderStartStartRadius: 0
                },
                '&-compact-first-item': {
                    borderEndEndRadius: 0,
                    borderStartEndRadius: 0
                },
                '&-compact-item:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                },
                '&-compact-item:not(:last-child)': {
                    borderInlineEndWidth: 0
                },
                '&-compact-item:not(:first-child)': {
                    borderInlineStartWidth: 0
                }
            },
            // ==========================================================
            // ==                       Variants                       ==
            // ==========================================================
            {
                '--space-addon-border-color': colorBorder,
                '--space-addon-background': colorBgContainerDisabled,
                // Filled
                '--space-addon-border-color-outlined': colorBorder,
                '--space-addon-background-filled': colorBgContainerDisabled,
                borderColor: 'var(--space-addon-border-color)',
                background: 'var(--space-addon-background)',
                // ======================= Outlined =======================
                '&-variant-outlined': {
                    '--space-addon-border-color': 'var(--space-addon-border-color-outlined)'
                },
                // ======================== Filled ========================
                '&-variant-filled': {
                    '--space-addon-border-color': 'transparent',
                    '--space-addon-background': 'var(--space-addon-background-filled)',
                    // Disabled
                    [`&${componentCls}-disabled`]: {
                        '--space-addon-border-color': colorBorder,
                        '--space-addon-background': colorBgContainerDisabled
                    }
                },
                // ====================== Borderless ======================
                '&-variant-borderless': {
                    border: 'none',
                    background: 'transparent'
                },
                // ====================== Underlined ======================
                '&-variant-underlined': {
                    border: 'none',
                    background: 'transparent'
                }
            },
            // ==========================================================
            // ==                        Status                        ==
            // ==========================================================
            {
                '&-status-error': {
                    '--space-addon-border-color-outlined': token.colorError,
                    '--space-addon-background-filled': token.colorErrorBg,
                    color: token.colorError
                },
                '&-status-warning': {
                    '--space-addon-border-color-outlined': token.colorWarning,
                    '--space-addon-background-filled': token.colorWarningBg,
                    color: token.colorWarning
                }
            }
        ]
    };
};
// ============================== Export ==============================
exports.default = (0, _internal.genStyleHooks)([
    'Space',
    'Addon'
], (token)=>[
        genSpaceAddonStyle(token),
        (0, _compactItem.genCompactItemStyle)(token, {
            focus: false
        })
    ]);

},{"../../style/compact-item":"7EW6Y","../../theme/internal":"eQVSZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Z5nX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SpaceContext", ()=>SpaceContext);
parcelHelpers.export(exports, "SpaceContextProvider", ()=>SpaceContextProvider);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const SpaceContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    latestIndex: 0
});
const SpaceContextProvider = SpaceContext.Provider;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fTNNx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _isNonNullable = require("../_util/isNonNullable");
var _isNonNullableDefault = parcelHelpers.interopDefault(_isNonNullable);
var _context = require("./context");
"use client";
const Item = (props)=>{
    const { className, prefix, index, children, separator, style, classNames, styles } = props;
    const { latestIndex } = _react.useContext((0, _context.SpaceContext));
    if (!(0, _isNonNullableDefault.default)(children)) return null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("div", {
        className: className,
        style: style
    }, children), index < latestIndex && separator && /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(`${prefix}-item-separator`, classNames.separator),
        style: styles.separator
    }, separator));
};
exports.default = Item;

},{"react":"bmhQu","clsx":"431Ou","../_util/isNonNullable":"avlqw","./context":"1Z5nX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2nL40":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _internal = require("../../theme/internal");
const genSpaceStyle = (token)=>{
    const { componentCls, antCls } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            '&-rtl': {
                direction: 'rtl'
            },
            '&-vertical': {
                flexDirection: 'column'
            },
            '&-align': {
                flexDirection: 'column',
                '&-center': {
                    alignItems: 'center'
                },
                '&-start': {
                    alignItems: 'flex-start'
                },
                '&-end': {
                    alignItems: 'flex-end'
                },
                '&-baseline': {
                    alignItems: 'baseline'
                }
            },
            [`${componentCls}-item:empty`]: {
                display: 'none'
            },
            // https://github.com/ant-design/ant-design/issues/47875
            [`${componentCls}-item > ${antCls}-badge-not-a-wrapper:only-child`]: {
                display: 'block'
            }
        }
    };
};
const genSpaceGapStyle = (token)=>{
    const { componentCls } = token;
    return {
        [componentCls]: {
            '&-gap-row-small': {
                rowGap: token.spaceGapSmallSize
            },
            '&-gap-row-middle': {
                rowGap: token.spaceGapMiddleSize
            },
            '&-gap-row-large': {
                rowGap: token.spaceGapLargeSize
            },
            '&-gap-col-small': {
                columnGap: token.spaceGapSmallSize
            },
            '&-gap-col-middle': {
                columnGap: token.spaceGapMiddleSize
            },
            '&-gap-col-large': {
                columnGap: token.spaceGapLargeSize
            }
        }
    };
};
const prepareComponentToken = ()=>({});
exports.default = (0, _internal.genStyleHooks)('Space', (token)=>{
    const spaceToken = (0, _internal.mergeToken)(token, {
        spaceGapSmallSize: token.paddingXS,
        spaceGapMiddleSize: token.padding,
        spaceGapLargeSize: token.paddingLG
    });
    return [
        genSpaceStyle(spaceToken),
        genSpaceGapStyle(spaceToken)
    ];
}, ()=>({}), {
    // Space component don't apply extra font style
    // https://github.com/ant-design/ant-design/issues/40315
    resetStyle: false
});

},{"../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aEYlH":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("39VO2");

},{}],"kTo6W":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("l9Yp7");

},{}],"cehvd":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("26KNz");

},{}],"i81n7":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lSRhr");

},{}],"hutSZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _miniPTAiComponentCss = require("./MiniPTAi.component.css");
// 🔹 Assets
var _miniPtCareMp4 = require("url:../../assets/videos/mini-pt-care.mp4");
var _miniPtCareMp4Default = parcelHelpers.interopDefault(_miniPtCareMp4);
const MiniPTAi = ({ src = (0, _miniPtCareMp4Default.default), title = 'MiniPT Core', autoPlay = true, loop = true, muted = true })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "miniPt",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                src: src,
                className: "miniPtVideo",
                autoPlay: autoPlay,
                loop: loop,
                muted: muted,
                playsInline: true
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "miniPtVideoText",
                children: title
            })
        ]
    });
};
exports.default = MiniPTAi;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./MiniPTAi.component.css":"5UjjX","url:../../assets/videos/mini-pt-care.mp4":"5knEg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5UjjX":[function() {},{}],"a8hcL":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9zf5K");

},{}],"1VSTs":[function(require,module,exports,__globalThis) {
// 🔹 React Core
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "generateId", ()=>generateId);
parcelHelpers.export(exports, "buildProgramWeeks", ()=>buildProgramWeeks);
parcelHelpers.export(exports, "useProgramStore", ()=>useProgramStore);
var _react = require("react");
// 🔹 Store
var _mockData = require("./mockData");
var _trainingStore = require("src/store/trainingStore");
var _programStore = require("src/store/programStore");
const generateId = ()=>Math.random().toString(36).substr(2, 9);
const mapApiExercise = (title, type, list, duration)=>{
    let ex = (0, _mockData.mockExercises).find((exercise)=>exercise.name.toLowerCase() === title.toLowerCase());
    const supportedMetrics = (0, _mockData.getSupportedMetrics)(title);
    const apiHasReps = Boolean(list && list[0]?.reps);
    const apiHasDuration = Boolean(duration);
    const metricType = apiHasDuration && supportedMetrics.includes('duration') ? 'duration' : apiHasReps && supportedMetrics.includes('reps') ? 'reps' : (0, _mockData.getDefaultMetric)(title);
    const repsValue = metricType === 'reps' ? apiHasReps ? list[0].reps : ex?.reps || 12 : '';
    const durationValue = metricType === 'duration' ? apiHasDuration ? `${duration}s` : ex?.duration || '30s' : '';
    if (!ex) ex = {
        _id: `ex_gen_${title.replace(/\\s+/g, '_')}`,
        name: title,
        muscleGroup: 'Full Body',
        type: [
            type
        ],
        thumbnail: (0, _mockData.getClosestExerciseImage)(title),
        sets: list ? list.length : 1,
        reps: repsValue,
        duration: durationValue,
        metricType,
        supportedMetrics,
        rest: list && list[0] ? list[0].rest : '60s',
        impact: 'Medium imp.'
    };
    return {
        ...ex,
        placedId: generateId(),
        sets: list ? list.length : 1,
        reps: repsValue,
        duration: durationValue,
        metricType,
        supportedMetrics: ex.supportedMetrics || supportedMetrics,
        rest: list && list[0] ? list[0].rest : ex.rest
    };
};
const buildProgramWeeks = (initialType, apiProgramData, formattedDays, maxColumns = 3)=>{
    if (initialType === 'ai' && apiProgramData && apiProgramData.datetimeList) {
        const weeksArray = [];
        const sortedDays = [
            ...apiProgramData.datetimeList
        ].sort((a, b)=>new Date(a.ymd).getTime() - new Date(b.ymd).getTime());
        let currentWeekId = 1;
        let weekDaysData = {};
        let weekSelectedDays = [];
        let weekStartDate = sortedDays.length > 0 ? new Date(sortedDays[0].ymd) : new Date();
        sortedDays.forEach((dayData)=>{
            const currentDate = new Date(dayData.ymd);
            const diffTime = Math.abs(currentDate.getTime() - weekStartDate.getTime());
            const diffDays = Math.floor(diffTime / 86400000);
            if (diffDays >= 7) {
                weeksArray.push({
                    _id: `Week ${currentWeekId}`,
                    isOpen: currentWeekId === 1,
                    selectedDays: [
                        ...new Set(weekSelectedDays)
                    ].slice(0, maxColumns),
                    daysData: weekDaysData
                });
                currentWeekId++;
                weekDaysData = {};
                weekSelectedDays = [];
                weekStartDate = currentDate;
            }
            const dayStr = (dayData.weekday2 || dayData.weekday.substring(0, 3)).toUpperCase();
            weekSelectedDays.push(dayStr);
            weekDaysData[dayStr] = {
                Warmup: [],
                Main: [],
                Cooldown: []
            };
            if (dayData.warmUpMoves) dayData.warmUpMoves.forEach((move)=>{
                weekDaysData[dayStr]['Warmup'].push(mapApiExercise(move.title, 'Warmup', [], move.duration));
            });
            if (dayData.moves) dayData.moves.forEach((move)=>{
                weekDaysData[dayStr]['Main'].push(mapApiExercise(move.title, 'Main', move.list));
            });
            if (dayData.coolDownMoves) dayData.coolDownMoves.forEach((move)=>{
                weekDaysData[dayStr]['Cooldown'].push(mapApiExercise(move.title, 'Cooldown', [], move.duration));
            });
        });
        if (weekSelectedDays.length > 0) weeksArray.push({
            _id: `Week ${currentWeekId}`,
            isOpen: currentWeekId === 1,
            selectedDays: [
                ...new Set(weekSelectedDays)
            ].slice(0, maxColumns),
            daysData: weekDaysData
        });
        const targetDuration = parseInt(apiProgramData.duration || '1', 10);
        while(weeksArray.length < targetDuration){
            currentWeekId++;
            const lastWeek = weeksArray[weeksArray.length - 1];
            const clonedDaysData = {};
            Object.keys(lastWeek.daysData).forEach((day)=>{
                clonedDaysData[day] = {};
                Object.keys(lastWeek.daysData[day]).forEach((slot)=>{
                    clonedDaysData[day][slot] = lastWeek.daysData[day][slot].map((ex)=>({
                            ...ex,
                            placedId: generateId()
                        }));
                });
            });
            weeksArray.push({
                _id: `Week ${currentWeekId}`,
                isOpen: false,
                selectedDays: [
                    ...lastWeek.selectedDays
                ],
                daysData: clonedDaysData
            });
        }
        return weeksArray;
    }
    return Array.from({
        length: 6
    }).map((_, index)=>{
        const initialDaysData = {};
        formattedDays.forEach((day)=>{
            initialDaysData[day] = {};
        });
        const defaultSelectedDays = formattedDays.slice(0, maxColumns);
        return {
            _id: `Week ${index + 1}`,
            isOpen: index === 0,
            selectedDays: [
                ...defaultSelectedDays
            ],
            daysData: initialDaysData
        };
    });
};
const useProgramStore = (initialType, apiProgramData, skipStoredWeeks = false)=>{
    // Store
    const assessment = (0, _trainingStore.trainingStore)((state)=>state.assessment || {});
    // Library State
    const [exercises, setExercises] = (0, _react.useState)((0, _mockData.mockExercises));
    const [search, setSearch] = (0, _react.useState)('');
    const [muscleFilter, setMuscleFilter] = (0, _react.useState)('all');
    const [typeFilter, setTypeFilter] = (0, _react.useState)('all');
    // Drag State
    const [draggedExercise, setDraggedExercise] = (0, _react.useState)(null);
    const [draggedOverSlot, setDraggedOverSlot] = (0, _react.useState)(null);
    // Reorder dragging state (within library)
    const [draggedLibIndex, setDraggedLibIndex] = (0, _react.useState)(null);
    const [draggedLibOverIndex, setDraggedLibOverIndex] = (0, _react.useState)(null);
    // Clipboard State
    const [clipboard, setClipboard] = (0, _react.useState)(null);
    const formattedDays = assessment?.selectedDays ? assessment.selectedDays.map((day)=>day.toUpperCase()) : [
        'SUN',
        'MON',
        'TUE',
        'WED',
        'THU',
        'FRI',
        'SAT'
    ];
    const [maxColumns, setMaxColumns] = (0, _react.useState)(()=>{
        if (typeof window !== 'undefined') {
            if (window.innerWidth >= 1200) return 4;
            if (window.innerWidth >= 768) return 3;
            return 1;
        }
        return 3;
    });
    (0, _react.useEffect)(()=>{
        const handleResize = ()=>{
            if (window.innerWidth >= 1200) setMaxColumns(4);
            else if (window.innerWidth >= 768) setMaxColumns(3);
            else setMaxColumns(1);
        };
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    // Program State
    const [allWeeksSame, setAllWeeksSame] = (0, _react.useState)(false);
    const [isRemixModalOpen, setRemixModalOpen] = (0, _react.useState)(false);
    const [isAiAssistantOpen, setAiAssistantOpen] = (0, _react.useState)(false);
    const [weeks, setWeeks] = (0, _react.useState)(()=>{
        // Back-navigation from /completed: restore the trainer's last-saved week/exercise
        // state (including any drag-and-drop additions) from the Zustand store.
        // skipStoredWeeks is true on a fresh generation so we always rebuild from the API.
        if (!skipStoredWeeks) {
            const stored = (0, _programStore.programStore).getState().weeks;
            if (stored && stored.length > 0) return stored;
        }
        const formattedDays = assessment?.selectedDays ? assessment.selectedDays.map((d)=>d.toUpperCase()) : [
            'SUN',
            'MON',
            'TUE',
            'WED',
            'THU',
            'FRI',
            'SAT'
        ];
        const initialMaxCols = typeof window !== 'undefined' ? window.innerWidth >= 1200 ? 4 : window.innerWidth >= 768 ? 3 : 1 : 3;
        if (initialType === 'ai' && apiProgramData && apiProgramData.datetimeList) {
            const weeksArray = [];
            const sortedDays = [
                ...apiProgramData.datetimeList
            ].sort((a, b)=>new Date(a.ymd).getTime() - new Date(b.ymd).getTime());
            let currentWeekId = 1;
            let weekDaysData = {};
            let weekSelectedDays = [];
            let weekStartDate = sortedDays.length > 0 ? new Date(sortedDays[0].ymd) : new Date();
            sortedDays.forEach((dayData)=>{
                const currentDate = new Date(dayData.ymd);
                const diffTime = Math.abs(currentDate.getTime() - weekStartDate.getTime());
                const diffDays = Math.floor(diffTime / 86400000);
                if (diffDays >= 7) {
                    weeksArray.push({
                        _id: `Week ${currentWeekId}`,
                        isOpen: currentWeekId === 1,
                        selectedDays: [
                            ...new Set(weekSelectedDays)
                        ].slice(0, initialMaxCols),
                        daysData: weekDaysData
                    });
                    currentWeekId++;
                    weekDaysData = {};
                    weekSelectedDays = [];
                    weekStartDate = currentDate;
                }
                const dayStr = (dayData.weekday2 || dayData.weekday.substring(0, 3)).toUpperCase();
                weekSelectedDays.push(dayStr);
                weekDaysData[dayStr] = {
                    Warmup: [],
                    Main: [],
                    Cooldown: []
                };
                const mapExercise = (title, type, list, duration)=>{
                    let ex = (0, _mockData.mockExercises).find((e)=>e.name.toLowerCase() === title.toLowerCase());
                    const supportedMetrics = (0, _mockData.getSupportedMetrics)(title);
                    const apiHasReps = Boolean(list && list[0]?.reps);
                    const apiHasDuration = Boolean(duration);
                    const metricType = apiHasDuration && supportedMetrics.includes('duration') ? 'duration' : apiHasReps && supportedMetrics.includes('reps') ? 'reps' : (0, _mockData.getDefaultMetric)(title);
                    const repsValue = metricType === 'reps' ? apiHasReps ? list[0].reps : ex?.reps || 12 : '';
                    const durationValue = metricType === 'duration' ? apiHasDuration ? `${duration}s` : ex?.duration || '30s' : '';
                    if (!ex) ex = {
                        _id: `ex_gen_${title.replace(/\\s+/g, '_')}`,
                        name: title,
                        muscleGroup: 'Full Body',
                        type: [
                            type
                        ],
                        thumbnail: (0, _mockData.getClosestExerciseImage)(title),
                        sets: list ? list.length : 1,
                        reps: repsValue,
                        duration: durationValue,
                        metricType,
                        supportedMetrics,
                        rest: list && list[0] ? list[0].rest : '60s',
                        impact: 'Medium imp.'
                    };
                    return {
                        ...ex,
                        placedId: generateId(),
                        sets: list ? list.length : 1,
                        reps: repsValue,
                        duration: durationValue,
                        metricType,
                        supportedMetrics: ex.supportedMetrics || supportedMetrics,
                        rest: list && list[0] ? list[0].rest : ex.rest
                    };
                };
                if (dayData.warmUpMoves) dayData.warmUpMoves.forEach((move)=>{
                    weekDaysData[dayStr]['Warmup'].push(mapExercise(move.title, 'Warmup', [], move.duration));
                });
                if (dayData.moves) dayData.moves.forEach((move)=>{
                    weekDaysData[dayStr]['Main'].push(mapExercise(move.title, 'Main', move.list));
                });
                if (dayData.coolDownMoves) dayData.coolDownMoves.forEach((move)=>{
                    weekDaysData[dayStr]['Cooldown'].push(mapExercise(move.title, 'Cooldown', [], move.duration));
                });
            });
            if (weekSelectedDays.length > 0) weeksArray.push({
                _id: `Week ${currentWeekId}`,
                isOpen: currentWeekId === 1,
                selectedDays: [
                    ...new Set(weekSelectedDays)
                ].slice(0, initialMaxCols),
                daysData: weekDaysData
            });
            const targetDuration = parseInt(apiProgramData.duration || '1', 10);
            while(weeksArray.length < targetDuration){
                currentWeekId++;
                const lastWeek = weeksArray[weeksArray.length - 1];
                const clonedDaysData = {};
                Object.keys(lastWeek.daysData).forEach((day)=>{
                    clonedDaysData[day] = {};
                    Object.keys(lastWeek.daysData[day]).forEach((slot)=>{
                        clonedDaysData[day][slot] = lastWeek.daysData[day][slot].map((ex)=>({
                                ...ex,
                                placedId: generateId()
                            }));
                    });
                });
                weeksArray.push({
                    _id: `Week ${currentWeekId}`,
                    isOpen: false,
                    selectedDays: [
                        ...lastWeek.selectedDays
                    ],
                    daysData: clonedDaysData
                });
            }
            return weeksArray;
        }
        return Array.from({
            length: 6
        }).map((_, i)=>{
            const initialDaysData = {};
            formattedDays.forEach((day)=>{
                initialDaysData[day] = {};
            // 🔹 AI DATA INITIALIZATION (fallback)
            // if (initialType === 'ai' && i === 0 && !apiProgramData) {
            //   // "exercise first 2 type" -> Warmup (index 0) and Main (index 1) in EXERCISE_TYPES (excl 'all')
            //   const typesToFill = ['Warmup', 'Main'];
            //
            //   typesToFill.forEach((t) => {
            //     const matches = mockExercises.filter((ex) => ex.type.includes(t as any));
            //     if (matches.length > 0) {
            //       // Pick 3 random exercises if available
            //       const shuffled = [...matches].sort(() => 0.5 - Math.random());
            //       const selected = shuffled.slice(0, 3);
            //
            //       initialDaysData[day][t] = selected.map((ex) => ({
            //         ...ex,
            //         placedId: generateId(),
            //       }));
            //     }
            //   });
            // }
            });
            const defaultSelectedDays = formattedDays.slice(0, initialMaxCols);
            return {
                _id: `Week ${i + 1}`,
                isOpen: i === 0,
                selectedDays: [
                    ...defaultSelectedDays
                ],
                daysData: initialDaysData
            };
        });
    });
    const resetProgramData = (nextApiProgramData)=>{
        setWeeks(buildProgramWeeks(initialType, nextApiProgramData, formattedDays, maxColumns));
        setClipboard(null);
        setAllWeeksSame(false);
        setDraggedExercise(null);
        setDraggedOverSlot(null);
        setRemixModalOpen(false);
    };
    // Filtered Exercises Output (Alphabetical grouped)
    const filteredExercises = (0, _react.useMemo)(()=>{
        let sorted = [
            ...exercises
        ];
        if (search.trim()) sorted = sorted.filter((ex)=>ex.name.toLowerCase().includes(search.toLowerCase()));
        if (muscleFilter !== 'all') sorted = sorted.filter((ex)=>{
            const mg = ex.muscleGroup.toLowerCase().replace(' ', '-');
            return mg === muscleFilter || mg === 'full-body';
        });
        if (typeFilter !== 'all') sorted = sorted.filter((ex)=>ex.type.some((t)=>t.toLowerCase() === typeFilter));
        // Group by first letter
        const grouped = {};
        sorted.forEach((ex)=>{
            const letter = ex.name.charAt(0).toUpperCase();
            if (!grouped[letter]) grouped[letter] = [];
            grouped[letter].push(ex);
        });
        return grouped;
    }, [
        exercises,
        search,
        muscleFilter,
        typeFilter
    ]);
    const toggleWeek = (weekId, forceState)=>{
        setWeeks((ws)=>ws.map((w, index)=>{
                if (weekId === 'All weeks' && index === 0) return {
                    ...w,
                    isOpen: forceState !== undefined ? forceState : !w.isOpen
                };
                if (w._id === weekId) return {
                    ...w,
                    isOpen: forceState !== undefined ? forceState : !w.isOpen
                };
                return {
                    ...w,
                    isOpen: false
                };
            }));
    };
    const deleteWeek = (weekId)=>{
        setWeeks((ws)=>ws.filter((w)=>w._id !== weekId));
    };
    const toggleDaySelection = (weekId, dayStr)=>{
        setWeeks((ws)=>ws.map((w)=>{
                if (allWeeksSame || w._id === weekId) {
                    let newSelected = [
                        ...w.selectedDays
                    ];
                    if (newSelected.includes(dayStr)) newSelected = newSelected.filter((d)=>d !== dayStr);
                    else {
                        // Check max columns limit and remove oldest if needed
                        if (newSelected.length >= maxColumns) newSelected.shift(); // Uncheck the first/oldest selected day
                        newSelected.push(dayStr);
                        // Ensure dayData exists
                        if (!w.daysData[dayStr]) w.daysData[dayStr] = {};
                    }
                    return {
                        ...w,
                        selectedDays: newSelected
                    };
                }
                return w;
            }));
    };
    const placeExercise = (weekId, day, slot, exercise)=>{
        const placedEntry = {
            ...exercise,
            placedId: generateId()
        };
        setWeeks((ws)=>ws.map((w)=>{
                // If allWeeksSame is checked, apply to ALL weeks if they have that day
                if (allWeeksSame || w._id === weekId) {
                    // Ensure the day exists
                    if (!w.daysData[day]) w.daysData[day] = {};
                    return {
                        ...w,
                        daysData: {
                            ...w.daysData,
                            [day]: {
                                ...w.daysData[day],
                                [slot]: [
                                    ...w.daysData[day][slot] || [],
                                    {
                                        ...placedEntry,
                                        placedId: generateId()
                                    }
                                ]
                            }
                        }
                    };
                }
                return w;
            }));
    };
    const removePlacedExercise = (weekId, day, slot, placedId)=>{
        setWeeks((ws)=>ws.map((w)=>{
                if (allWeeksSame || w._id === weekId) {
                    if (!w.daysData[day]) return w;
                    return {
                        ...w,
                        daysData: {
                            ...w.daysData,
                            [day]: {
                                ...w.daysData[day],
                                [slot]: (w.daysData[day][slot] || []).filter((e)=>e.placedId !== placedId)
                            }
                        }
                    };
                }
                return w;
            }));
    };
    const updatePlacedExercise = (weekId, day, slot, placedId, updatedData)=>{
        setWeeks((ws)=>ws.map((w)=>{
                if (allWeeksSame || w._id === weekId) {
                    if (!w.daysData[day] || !w.daysData[day][slot]) return w;
                    return {
                        ...w,
                        daysData: {
                            ...w.daysData,
                            [day]: {
                                ...w.daysData[day],
                                [slot]: (w.daysData[day][slot] || []).map((ex)=>ex.placedId === placedId ? {
                                        ...ex,
                                        ...updatedData
                                    } : ex)
                            }
                        }
                    };
                }
                return w;
            }));
    };
    const copySlot = (exercises, slotType)=>{
        setClipboard({
            exercises: [
                ...exercises
            ],
            type: slotType
        });
    };
    const emptySlot = (weekId, day, slot)=>{
        setWeeks((ws)=>ws.map((w)=>{
                if (allWeeksSame || w._id === weekId) {
                    if (!w.daysData[day]) return w;
                    return {
                        ...w,
                        daysData: {
                            ...w.daysData,
                            [day]: {
                                ...w.daysData[day],
                                [slot]: []
                            }
                        }
                    };
                }
                return w;
            }));
    };
    const pasteSlot = (weekId, day, slot)=>{
        if (!clipboard) return false;
        if (clipboard.type.toLowerCase() !== slot.toLowerCase()) return false;
        const newEx = clipboard.exercises.map((ex)=>({
                ...ex,
                placedId: generateId()
            }));
        setWeeks((ws)=>ws.map((w)=>{
                if (allWeeksSame || w._id === weekId) return {
                    ...w,
                    daysData: {
                        ...w.daysData,
                        [day]: {
                            ...w.daysData[day],
                            [slot]: [
                                ...w.daysData[day][slot] || [],
                                ...newEx
                            ]
                        }
                    }
                };
                return w;
            }));
        return true;
    };
    const totalExercisesPlaced = (0, _react.useMemo)(()=>{
        let count = 0;
        weeks.forEach((w)=>{
            Object.keys(w.daysData).forEach((day)=>{
                Object.keys(w.daysData[day]).forEach((slot)=>{
                    count += (w.daysData[day][slot] || []).length;
                });
            });
        });
        return count;
    }, [
        weeks
    ]);
    // Sync weeks to the Zustand programStore on every change.
    // This covers: initial API load, every drag-and-drop, every edit, and remix.
    // The stored value is consumed by the useState initializer above on back-navigation.
    (0, _react.useEffect)(()=>{
        (0, _programStore.setStoredWeeks)(weeks);
    }, [
        weeks
    ]);
    const reorderLibrary = (letterKey, sourceIndex, destinationIndex)=>{
        setExercises((prevEx)=>{
            const justLetter = prevEx.filter((ex)=>ex.name.charAt(0).toUpperCase() === letterKey);
            const others = prevEx.filter((ex)=>ex.name.charAt(0).toUpperCase() !== letterKey);
            const [removed] = justLetter.splice(sourceIndex, 1);
            justLetter.splice(destinationIndex, 0, removed);
            return [
                ...others,
                ...justLetter
            ];
        });
    };
    return {
        // state
        exercises,
        search,
        setSearch,
        muscleFilter,
        setMuscleFilter,
        typeFilter,
        setTypeFilter,
        filteredExercises,
        formattedDays,
        draggedExercise,
        setDraggedExercise,
        draggedOverSlot,
        setDraggedOverSlot,
        draggedLibIndex,
        setDraggedLibIndex,
        draggedLibOverIndex,
        setDraggedLibOverIndex,
        allWeeksSame,
        setAllWeeksSame,
        isRemixModalOpen,
        setRemixModalOpen,
        isAiAssistantOpen,
        setAiAssistantOpen,
        weeks,
        // actions
        toggleWeek,
        deleteWeek,
        toggleDaySelection,
        placeExercise,
        removePlacedExercise,
        updatePlacedExercise,
        copySlot,
        emptySlot,
        pasteSlot,
        clipboard,
        reorderLibrary,
        resetProgramData,
        totalExercisesPlaced
    };
};

},{"react":"bmhQu","./mockData":"dfRTm","src/store/trainingStore":"eYkDC","src/store/programStore":"hM1mR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dfRTm":[function(require,module,exports,__globalThis) {
// 🔹 Assets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exercise_list", ()=>exercise_list);
parcelHelpers.export(exports, "PLACEHOLDER_EXERCISE_IMAGE", ()=>PLACEHOLDER_EXERCISE_IMAGE);
parcelHelpers.export(exports, "getClosestExerciseImage", ()=>getClosestExerciseImage);
parcelHelpers.export(exports, "getMuscleGroup", ()=>getMuscleGroup);
parcelHelpers.export(exports, "getExerciseType", ()=>getExerciseType);
parcelHelpers.export(exports, "getSupportedMetrics", ()=>getSupportedMetrics);
parcelHelpers.export(exports, "getDefaultMetric", ()=>getDefaultMetric);
parcelHelpers.export(exports, "getReps", ()=>getReps);
parcelHelpers.export(exports, "getDuration", ()=>getDuration);
parcelHelpers.export(exports, "getImpact", ()=>getImpact);
parcelHelpers.export(exports, "mockExercises", ()=>mockExercises);
var _exercises = require("src/assets/images/exercises");
const exercise_list = [
    'Squat',
    'Bicep Curl',
    'Shoulder Press',
    'Press Up',
    'Side Lunge',
    'Jumping Jacks',
    'Plank',
    'Knee To Elbow',
    'High Knees',
    'Jabs',
    'Wood Cutter Left to Right',
    'Wood Cutter Right to Left',
    'Upper Cut',
    'Dumbbell Lateral Raise',
    'Squat Jumps',
    'Tricep Dips-Bench',
    'Wall Sit',
    'Burpees'
];
const PLACEHOLDER_EXERCISE_IMAGE = 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80"><rect width="80" height="80" fill="%231f2233"/><text x="50%" y="50%" fill="%23fafafa" font-family="sans-serif" font-size="12" text-anchor="middle" dy=".3em">Exercise</text></svg>';
// 🔹 Dynamic Image Matching
const normalizeExerciseName = (name)=>{
    return name.replace(/([a-z0-9])([A-Z])/g, '$1 $2').toLowerCase().replace('moutain', 'mountain').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
};
const getClosestExerciseImage = (name)=>{
    if (!name) return PLACEHOLDER_EXERCISE_IMAGE;
    const normalized = normalizeExerciseName(name);
    // Exact match
    if ((0, _exercises.exerciseImages)[normalized]) return (0, _exercises.exerciseImages)[normalized];
    // Fuzzy match
    const keys = Object.keys((0, _exercises.exerciseImages));
    for (const key of keys){
        if (key.includes(normalized) || normalized.includes(key)) return (0, _exercises.exerciseImages)[key];
    }
    return PLACEHOLDER_EXERCISE_IMAGE;
};
// 🔹 Generate unique ID from name
const generateId = (name, index)=>name.toLowerCase().replace(/[^a-z0-9]+/g, '_') // replace spaces & special chars
    .replace(/^_|_$/g, '') + `_${index + 1}`;
const getMuscleGroup = (name)=>{
    const lowerName = name.toLowerCase().replace('moutain', 'mountain');
    if (/(squat|lunge|leg|calf|glute|thrust|hamstring)/.test(lowerName)) return 'Lower Body';
    if (/(plank|core|crunch|twist|wood|knee to elbow|dead bug|bird dog)/.test(lowerName)) return 'Core';
    if (/(burpee|jack|mountain climber|jump rope|rowing|cycling|high knee)/.test(lowerName)) return 'Full Body';
    return 'Upper Body'; // default
};
const getExerciseType = (name)=>{
    const lowerName = name.toLowerCase().replace('moutain', 'mountain');
    const types = [];
    if (/(jack|jump rope|cycling|rowing)/.test(lowerName)) types.push('Warmup');
    if (/(burpee|jump|high knee|jab|upper cut|mountain climber|cardio)/.test(lowerName)) types.push('Cardio');
    if (/(wall sit|stretch|cool)/.test(lowerName)) types.push('Cooldown');
    if (types.length === 0) types.push('Main', 'Fitness');
    else if (!types.includes('Cooldown')) types.push('Fitness');
    return types;
};
const getSupportedMetrics = (name)=>{
    const lowerName = name.toLowerCase().replace('moutain', 'mountain');
    if (/(plank|wall sit|stretch|hold)/.test(lowerName)) return [
        'duration'
    ];
    if (/(curl|press|raise|row|extension|fly|crush|dip|squat|lunge|deadlift|thrust|bridge)/.test(lowerName)) return [
        'reps'
    ];
    return [
        'reps',
        'duration'
    ];
};
const getDefaultMetric = (name)=>{
    const metrics = getSupportedMetrics(name);
    return metrics.includes('reps') ? 'reps' : 'duration';
};
const getReps = (name)=>{
    if (!getSupportedMetrics(name).includes('reps')) return '';
    return 12;
};
const getDuration = (name)=>{
    if (!getSupportedMetrics(name).includes('duration')) return '';
    const lowerName = name.toLowerCase().replace('moutain', 'mountain');
    if (/(plank|wall sit|jack|high knee|jab|upper cut|rope|climb|rowing|cycling)/.test(lowerName)) return '30s';
    return '';
};
const getImpact = (name)=>{
    const lowerName = name.toLowerCase().replace('moutain', 'mountain');
    if (/(burpee|high knee|jack|jump|plyo|swing|rope|climber)/.test(lowerName)) return 'High imp.';
    if (/(plank|wall sit|raise|curl|extension|fly|sit-up|crunch)/.test(lowerName)) return 'Low imp.';
    return 'Medium imp.';
};
const mockExercises = exercise_list.map((name, index)=>({
        _id: generateId(name, index),
        name,
        muscleGroup: getMuscleGroup(name),
        type: getExerciseType(name),
        thumbnail: getClosestExerciseImage(name),
        sets: 3,
        reps: getReps(name),
        duration: getDuration(name),
        metricType: getDefaultMetric(name),
        supportedMetrics: getSupportedMetrics(name),
        rest: '45s rest',
        impact: getImpact(name)
    }));

},{"src/assets/images/exercises":"9GMpd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9GMpd":[function(require,module,exports,__globalThis) {
// Auto-generated by flatten_images.py
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exerciseImages", ()=>exerciseImages);
var _armCirclingPng = require("url:./arm-circling.png");
var _armCirclingPngDefault = parcelHelpers.interopDefault(_armCirclingPng);
var _arnoldPressPng = require("url:./arnold-press.png");
var _arnoldPressPngDefault = parcelHelpers.interopDefault(_arnoldPressPng);
var _arnoldPressTempoPng = require("url:./arnold-press-tempo.png");
var _arnoldPressTempoPngDefault = parcelHelpers.interopDefault(_arnoldPressTempoPng);
var _backwardLungePng = require("url:./backward-lunge.png");
var _backwardLungePngDefault = parcelHelpers.interopDefault(_backwardLungePng);
var _barbellBackSquatPng = require("url:./barbell-back-squat.png");
var _barbellBackSquatPngDefault = parcelHelpers.interopDefault(_barbellBackSquatPng);
var _barbellBackSquatDeclinePng = require("url:./barbell-back-squat-decline.png");
var _barbellBackSquatDeclinePngDefault = parcelHelpers.interopDefault(_barbellBackSquatDeclinePng);
var _barbellRowPng = require("url:./barbell-row.png");
var _barbellRowPngDefault = parcelHelpers.interopDefault(_barbellRowPng);
var _benchPressPng = require("url:./bench-press.png");
var _benchPressPngDefault = parcelHelpers.interopDefault(_benchPressPng);
var _benchPressDeclinePng = require("url:./bench-press-decline.png");
var _benchPressDeclinePngDefault = parcelHelpers.interopDefault(_benchPressDeclinePng);
var _bicepCurlPng = require("url:./bicep-curl.png");
var _bicepCurlPngDefault = parcelHelpers.interopDefault(_bicepCurlPng);
var _birdDogPng = require("url:./bird-dog.png");
var _birdDogPngDefault = parcelHelpers.interopDefault(_birdDogPng);
var _birdDogCrunchPng = require("url:./bird-dog-crunch.png");
var _birdDogCrunchPngDefault = parcelHelpers.interopDefault(_birdDogCrunchPng);
var _bulgarianSplitSquatPng = require("url:./bulgarian-split-squat.png");
var _bulgarianSplitSquatPngDefault = parcelHelpers.interopDefault(_bulgarianSplitSquatPng);
var _bulgarianSplitSquatPausedPng = require("url:./bulgarian-split-squat-paused.png");
var _bulgarianSplitSquatPausedPngDefault = parcelHelpers.interopDefault(_bulgarianSplitSquatPausedPng);
var _burpeesPng = require("url:./burpees.png");
var _burpeesPngDefault = parcelHelpers.interopDefault(_burpeesPng);
var _calfRaisesPng = require("url:./calf-raises.png");
var _calfRaisesPngDefault = parcelHelpers.interopDefault(_calfRaisesPng);
var _cyclingPng = require("url:./cycling.png");
var _cyclingPngDefault = parcelHelpers.interopDefault(_cyclingPng);
var _deadBugPng = require("url:./dead-bug.png");
var _deadBugPngDefault = parcelHelpers.interopDefault(_deadBugPng);
var _deadliftPng = require("url:./deadlift.png");
var _deadliftPngDefault = parcelHelpers.interopDefault(_deadliftPng);
var _deadliftResistanceBandPng = require("url:./deadlift-resistance-band.png");
var _deadliftResistanceBandPngDefault = parcelHelpers.interopDefault(_deadliftResistanceBandPng);
var _declineBenchPressTempoPng = require("url:./decline-bench-press-tempo.png");
var _declineBenchPressTempoPngDefault = parcelHelpers.interopDefault(_declineBenchPressTempoPng);
var _dipsPng = require("url:./dips.png");
var _dipsPngDefault = parcelHelpers.interopDefault(_dipsPng);
var _donkeyKickBackPng = require("url:./donkey-kick-back.png");
var _donkeyKickBackPngDefault = parcelHelpers.interopDefault(_donkeyKickBackPng);
var _dumbbellBenchPressPng = require("url:./dumbbell-bench-press.png");
var _dumbbellBenchPressPngDefault = parcelHelpers.interopDefault(_dumbbellBenchPressPng);
var _dumbbellBenchPressPausedPng = require("url:./dumbbell-bench-press-paused.png");
var _dumbbellBenchPressPausedPngDefault = parcelHelpers.interopDefault(_dumbbellBenchPressPausedPng);
var _dumbbellLateralRaisePng = require("url:./dumbbell-lateral-raise.png");
var _dumbbellLateralRaisePngDefault = parcelHelpers.interopDefault(_dumbbellLateralRaisePng);
var _dumbbellRowPng = require("url:./dumbbell-row.png");
var _dumbbellRowPngDefault = parcelHelpers.interopDefault(_dumbbellRowPng);
var _frontRaisePng = require("url:./front-raise.png");
var _frontRaisePngDefault = parcelHelpers.interopDefault(_frontRaisePng);
var _frontSquatPng = require("url:./front-squat.png");
var _frontSquatPngDefault = parcelHelpers.interopDefault(_frontSquatPng);
var _frontSquatResistanceBandPng = require("url:./front-squat-resistance-band.png");
var _frontSquatResistanceBandPngDefault = parcelHelpers.interopDefault(_frontSquatResistanceBandPng);
var _gluteBridgePng = require("url:./glute-bridge.png");
var _gluteBridgePngDefault = parcelHelpers.interopDefault(_gluteBridgePng);
var _gluteBridgeSingleLegPng = require("url:./glute-bridge-single-leg.png");
var _gluteBridgeSingleLegPngDefault = parcelHelpers.interopDefault(_gluteBridgeSingleLegPng);
var _gobletSquatPng = require("url:./goblet-squat.png");
var _gobletSquatPngDefault = parcelHelpers.interopDefault(_gobletSquatPng);
var _gobletSquatTempoPng = require("url:./goblet-squat-tempo.png");
var _gobletSquatTempoPngDefault = parcelHelpers.interopDefault(_gobletSquatTempoPng);
var _hackSquatPng = require("url:./hack-squat.png");
var _hackSquatPngDefault = parcelHelpers.interopDefault(_hackSquatPng);
var _hackSquatDeclinePng = require("url:./hack-squat-decline.png");
var _hackSquatDeclinePngDefault = parcelHelpers.interopDefault(_hackSquatDeclinePng);
var _hammerCurlPng = require("url:./hammer-curl.png");
var _hammerCurlPngDefault = parcelHelpers.interopDefault(_hammerCurlPng);
var _hamstringCurlPng = require("url:./hamstring-curl.png");
var _hamstringCurlPngDefault = parcelHelpers.interopDefault(_hamstringCurlPng);
var _hangingLegRaisePng = require("url:./hanging-leg-raise.png");
var _hangingLegRaisePngDefault = parcelHelpers.interopDefault(_hangingLegRaisePng);
var _heelFlicksPng = require("url:./heel-flicks.png");
var _heelFlicksPngDefault = parcelHelpers.interopDefault(_heelFlicksPng);
var _highKneesPng = require("url:./high-knees.png");
var _highKneesPngDefault = parcelHelpers.interopDefault(_highKneesPng);
var _hipThrustPng = require("url:./hip-thrust.png");
var _hipThrustPngDefault = parcelHelpers.interopDefault(_hipThrustPng);
var _hipThrustPausedPng = require("url:./hip-thrust-paused.png");
var _hipThrustPausedPngDefault = parcelHelpers.interopDefault(_hipThrustPausedPng);
var _inclineBenchPressPng = require("url:./incline-bench-press.png");
var _inclineBenchPressPngDefault = parcelHelpers.interopDefault(_inclineBenchPressPng);
var _inclineBenchPressResistanceBandPng = require("url:./incline-bench-press-resistance-band.png");
var _inclineBenchPressResistanceBandPngDefault = parcelHelpers.interopDefault(_inclineBenchPressResistanceBandPng);
var _inclinePushUpPng = require("url:./incline-push-up.png");
var _inclinePushUpPngDefault = parcelHelpers.interopDefault(_inclinePushUpPng);
var _inclinePushUpInclinePng = require("url:./incline-push-up-incline.png");
var _inclinePushUpInclinePngDefault = parcelHelpers.interopDefault(_inclinePushUpInclinePng);
var _jabsPng = require("url:./jabs.png");
var _jabsPngDefault = parcelHelpers.interopDefault(_jabsPng);
var _jumpRopePng = require("url:./jump-rope.png");
var _jumpRopePngDefault = parcelHelpers.interopDefault(_jumpRopePng);
var _jumpingJacksPng = require("url:./jumping-jacks.png");
var _jumpingJacksPngDefault = parcelHelpers.interopDefault(_jumpingJacksPng);
var _kettlebellSwingPng = require("url:./kettlebell-swing.png");
var _kettlebellSwingPngDefault = parcelHelpers.interopDefault(_kettlebellSwingPng);
var _kneeToElbowPng = require("url:./knee-to-elbow.png");
var _kneeToElbowPngDefault = parcelHelpers.interopDefault(_kneeToElbowPng);
var _latPulldownPng = require("url:./lat-pulldown.png");
var _latPulldownPngDefault = parcelHelpers.interopDefault(_latPulldownPng);
var _lateralRaisePng = require("url:./lateral-raise.png");
var _lateralRaisePngDefault = parcelHelpers.interopDefault(_lateralRaisePng);
var _legExtensionPng = require("url:./leg-extension.png");
var _legExtensionPngDefault = parcelHelpers.interopDefault(_legExtensionPng);
var _legPressInclinePng = require("url:./leg-press-incline.png");
var _legPressInclinePngDefault = parcelHelpers.interopDefault(_legPressInclinePng);
var _maleWoodCutterLeftToRightPng = require("url:./male-wood-cutter-left-to-right.png");
var _maleWoodCutterLeftToRightPngDefault = parcelHelpers.interopDefault(_maleWoodCutterLeftToRightPng);
var _maleWoodCutterRightToLeftPng = require("url:./male-wood-cutter-right-to-left.png");
var _maleWoodCutterRightToLeftPngDefault = parcelHelpers.interopDefault(_maleWoodCutterRightToLeftPng);
var _mountainClimbersPng = require("url:./mountain-climbers.png");
var _mountainClimbersPngDefault = parcelHelpers.interopDefault(_mountainClimbersPng);
var _overheadTricepExtensionPng = require("url:./overhead-tricep-extension.png");
var _overheadTricepExtensionPngDefault = parcelHelpers.interopDefault(_overheadTricepExtensionPng);
var _plankPng = require("url:./plank.png");
var _plankPngDefault = parcelHelpers.interopDefault(_plankPng);
var _preacherCurlPng = require("url:./preacher-curl.png");
var _preacherCurlPngDefault = parcelHelpers.interopDefault(_preacherCurlPng);
var _pressUpPng = require("url:./press-up.png");
var _pressUpPngDefault = parcelHelpers.interopDefault(_pressUpPng);
var _pullUpPng = require("url:./pull-up.png");
var _pullUpPngDefault = parcelHelpers.interopDefault(_pullUpPng);
var _pushPressPng = require("url:./push-press.png");
var _pushPressPngDefault = parcelHelpers.interopDefault(_pushPressPng);
var _pushPressPausedPng = require("url:./push-press-paused.png");
var _pushPressPausedPngDefault = parcelHelpers.interopDefault(_pushPressPausedPng);
var _pushUpPng = require("url:./push-up.png");
var _pushUpPngDefault = parcelHelpers.interopDefault(_pushUpPng);
var _pushUpSingleLegPng = require("url:./push-up-single-leg.png");
var _pushUpSingleLegPngDefault = parcelHelpers.interopDefault(_pushUpSingleLegPng);
var _rearDeltFlyPng = require("url:./rear-delt-fly.png");
var _rearDeltFlyPngDefault = parcelHelpers.interopDefault(_rearDeltFlyPng);
var _romanianDeadliftPng = require("url:./romanian-deadlift.png");
var _romanianDeadliftPngDefault = parcelHelpers.interopDefault(_romanianDeadliftPng);
var _romanianDeadliftTempoPng = require("url:./romanian-deadlift-tempo.png");
var _romanianDeadliftTempoPngDefault = parcelHelpers.interopDefault(_romanianDeadliftTempoPng);
var _rowingPng = require("url:./rowing.png");
var _rowingPngDefault = parcelHelpers.interopDefault(_rowingPng);
var _russianTwistPng = require("url:./russian-twist.png");
var _russianTwistPngDefault = parcelHelpers.interopDefault(_russianTwistPng);
var _seatedCableRowPng = require("url:./seated-cable-row.png");
var _seatedCableRowPngDefault = parcelHelpers.interopDefault(_seatedCableRowPng);
var _shoulderPressPng = require("url:./shoulder-press.png");
var _shoulderPressPngDefault = parcelHelpers.interopDefault(_shoulderPressPng);
var _sideLungePng = require("url:./side-lunge.png");
var _sideLungePngDefault = parcelHelpers.interopDefault(_sideLungePng);
var _sidePlankPng = require("url:./side-plank.png");
var _sidePlankPngDefault = parcelHelpers.interopDefault(_sidePlankPng);
var _sitUpPng = require("url:./sit-up.png");
var _sitUpPngDefault = parcelHelpers.interopDefault(_sitUpPng);
var _skullCrushersPng = require("url:./skull-crushers.png");
var _skullCrushersPngDefault = parcelHelpers.interopDefault(_skullCrushersPng);
var _squatPng = require("url:./squat.png");
var _squatPngDefault = parcelHelpers.interopDefault(_squatPng);
var _squatJumpsPng = require("url:./squat-jumps.png");
var _squatJumpsPngDefault = parcelHelpers.interopDefault(_squatJumpsPng);
var _standingKickBackPng = require("url:./standing-kick-back.png");
var _standingKickBackPngDefault = parcelHelpers.interopDefault(_standingKickBackPng);
var _sumoSquatPng = require("url:./sumo-squat.png");
var _sumoSquatPngDefault = parcelHelpers.interopDefault(_sumoSquatPng);
var _tricepDipsBenchPng = require("url:./tricep-dips-bench.png");
var _tricepDipsBenchPngDefault = parcelHelpers.interopDefault(_tricepDipsBenchPng);
var _tricepPushdownPng = require("url:./tricep-pushdown.png");
var _tricepPushdownPngDefault = parcelHelpers.interopDefault(_tricepPushdownPng);
var _upperCutPng = require("url:./upper-cut.png");
var _upperCutPngDefault = parcelHelpers.interopDefault(_upperCutPng);
var _walkingLungesPng = require("url:./walking-lunges.png");
var _walkingLungesPngDefault = parcelHelpers.interopDefault(_walkingLungesPng);
var _walkingLungesSingleLegPng = require("url:./walking-lunges-single-leg.png");
var _walkingLungesSingleLegPngDefault = parcelHelpers.interopDefault(_walkingLungesSingleLegPng);
var _wallSitPng = require("url:./wall-sit.png");
var _wallSitPngDefault = parcelHelpers.interopDefault(_wallSitPng);
var _woodCutterPng = require("url:./wood-cutter.png");
var _woodCutterPngDefault = parcelHelpers.interopDefault(_woodCutterPng);
var _woodCutterLefttoRightPng = require("url:./wood-cutter-leftto-right.png");
var _woodCutterLefttoRightPngDefault = parcelHelpers.interopDefault(_woodCutterLefttoRightPng);
var _woodCutterRighttoLeftPng = require("url:./wood-cutter-rightto-left.png");
var _woodCutterRighttoLeftPngDefault = parcelHelpers.interopDefault(_woodCutterRighttoLeftPng);
const exerciseImages = {
    'arm-circling': (0, _armCirclingPngDefault.default),
    'arnold-press': (0, _arnoldPressPngDefault.default),
    'arnold-press-tempo': (0, _arnoldPressTempoPngDefault.default),
    'backward-lunge': (0, _backwardLungePngDefault.default),
    'barbell-back-squat': (0, _barbellBackSquatPngDefault.default),
    'barbell-back-squat-decline': (0, _barbellBackSquatDeclinePngDefault.default),
    'barbell-row': (0, _barbellRowPngDefault.default),
    'bench-press': (0, _benchPressPngDefault.default),
    'bench-press-decline': (0, _benchPressDeclinePngDefault.default),
    'bicep-curl': (0, _bicepCurlPngDefault.default),
    'bird-dog': (0, _birdDogPngDefault.default),
    'bird-dog-crunch': (0, _birdDogCrunchPngDefault.default),
    'bulgarian-split-squat': (0, _bulgarianSplitSquatPngDefault.default),
    'bulgarian-split-squat-paused': (0, _bulgarianSplitSquatPausedPngDefault.default),
    burpees: (0, _burpeesPngDefault.default),
    'calf-raises': (0, _calfRaisesPngDefault.default),
    cycling: (0, _cyclingPngDefault.default),
    'dead-bug': (0, _deadBugPngDefault.default),
    deadlift: (0, _deadliftPngDefault.default),
    'deadlift-resistance-band': (0, _deadliftResistanceBandPngDefault.default),
    'decline-bench-press-tempo': (0, _declineBenchPressTempoPngDefault.default),
    dips: (0, _dipsPngDefault.default),
    'donkey-kick-back': (0, _donkeyKickBackPngDefault.default),
    'dumbbell-bench-press': (0, _dumbbellBenchPressPngDefault.default),
    'dumbbell-bench-press-paused': (0, _dumbbellBenchPressPausedPngDefault.default),
    'dumbbell-lateral-raise': (0, _dumbbellLateralRaisePngDefault.default),
    'dumbbell-row': (0, _dumbbellRowPngDefault.default),
    'front-raise': (0, _frontRaisePngDefault.default),
    'front-squat': (0, _frontSquatPngDefault.default),
    'front-squat-resistance-band': (0, _frontSquatResistanceBandPngDefault.default),
    'glute-bridge': (0, _gluteBridgePngDefault.default),
    'glute-bridge-single-leg': (0, _gluteBridgeSingleLegPngDefault.default),
    'goblet-squat': (0, _gobletSquatPngDefault.default),
    'goblet-squat-tempo': (0, _gobletSquatTempoPngDefault.default),
    'hack-squat': (0, _hackSquatPngDefault.default),
    'hack-squat-decline': (0, _hackSquatDeclinePngDefault.default),
    'hammer-curl': (0, _hammerCurlPngDefault.default),
    'hamstring-curl': (0, _hamstringCurlPngDefault.default),
    'hanging-leg-raise': (0, _hangingLegRaisePngDefault.default),
    'heel-flicks': (0, _heelFlicksPngDefault.default),
    'high-knees': (0, _highKneesPngDefault.default),
    'hip-thrust': (0, _hipThrustPngDefault.default),
    'hip-thrust-paused': (0, _hipThrustPausedPngDefault.default),
    'incline-bench-press': (0, _inclineBenchPressPngDefault.default),
    'incline-bench-press-resistance-band': (0, _inclineBenchPressResistanceBandPngDefault.default),
    'incline-push-up': (0, _inclinePushUpPngDefault.default),
    'incline-push-up-incline': (0, _inclinePushUpInclinePngDefault.default),
    jabs: (0, _jabsPngDefault.default),
    'jump-rope': (0, _jumpRopePngDefault.default),
    'jumping-jacks': (0, _jumpingJacksPngDefault.default),
    'kettlebell-swing': (0, _kettlebellSwingPngDefault.default),
    'knee-to-elbow': (0, _kneeToElbowPngDefault.default),
    'lat-pulldown': (0, _latPulldownPngDefault.default),
    'lateral-raise': (0, _lateralRaisePngDefault.default),
    'leg-extension': (0, _legExtensionPngDefault.default),
    'leg-press-incline': (0, _legPressInclinePngDefault.default),
    'male-wood-cutter-left-to-right': (0, _maleWoodCutterLeftToRightPngDefault.default),
    'male-wood-cutter-right-to-left': (0, _maleWoodCutterRightToLeftPngDefault.default),
    'mountain-climbers': (0, _mountainClimbersPngDefault.default),
    'overhead-tricep-extension': (0, _overheadTricepExtensionPngDefault.default),
    plank: (0, _plankPngDefault.default),
    'preacher-curl': (0, _preacherCurlPngDefault.default),
    'press-up': (0, _pressUpPngDefault.default),
    'pull-up': (0, _pullUpPngDefault.default),
    'push-press': (0, _pushPressPngDefault.default),
    'push-press-paused': (0, _pushPressPausedPngDefault.default),
    'push-up': (0, _pushUpPngDefault.default),
    'push-up-single-leg': (0, _pushUpSingleLegPngDefault.default),
    'rear-delt-fly': (0, _rearDeltFlyPngDefault.default),
    'romanian-deadlift': (0, _romanianDeadliftPngDefault.default),
    'romanian-deadlift-tempo': (0, _romanianDeadliftTempoPngDefault.default),
    rowing: (0, _rowingPngDefault.default),
    'russian-twist': (0, _russianTwistPngDefault.default),
    'seated-cable-row': (0, _seatedCableRowPngDefault.default),
    'shoulder-press': (0, _shoulderPressPngDefault.default),
    'side-lunge': (0, _sideLungePngDefault.default),
    'side-plank': (0, _sidePlankPngDefault.default),
    'sit-up': (0, _sitUpPngDefault.default),
    'skull-crushers': (0, _skullCrushersPngDefault.default),
    squat: (0, _squatPngDefault.default),
    'squat-jumps': (0, _squatJumpsPngDefault.default),
    'standing-kick-back': (0, _standingKickBackPngDefault.default),
    'sumo-squat': (0, _sumoSquatPngDefault.default),
    'tricep-dips-bench': (0, _tricepDipsBenchPngDefault.default),
    'tricep-pushdown': (0, _tricepPushdownPngDefault.default),
    'upper-cut': (0, _upperCutPngDefault.default),
    'walking-lunges': (0, _walkingLungesPngDefault.default),
    'walking-lunges-single-leg': (0, _walkingLungesSingleLegPngDefault.default),
    'wall-sit': (0, _wallSitPngDefault.default),
    'wood-cutter': (0, _woodCutterPngDefault.default),
    'wood-cutter-leftto-right': (0, _woodCutterLefttoRightPngDefault.default),
    'wood-cutter-rightto-left': (0, _woodCutterRighttoLeftPngDefault.default)
};

},{"url:./arm-circling.png":"4C7SZ","url:./arnold-press.png":"hFNSg","url:./arnold-press-tempo.png":"6ZkSc","url:./backward-lunge.png":"btyDE","url:./barbell-back-squat.png":"1RKu1","url:./barbell-back-squat-decline.png":"fTQHw","url:./barbell-row.png":"9L1GP","url:./bench-press.png":"l1R5P","url:./bench-press-decline.png":"lTOhq","url:./bicep-curl.png":"7paM0","url:./bird-dog.png":"7Ix6A","url:./bird-dog-crunch.png":"6lidK","url:./bulgarian-split-squat.png":"fnDhY","url:./bulgarian-split-squat-paused.png":"4Q5l0","url:./burpees.png":"l5W4L","url:./calf-raises.png":"2V38T","url:./cycling.png":"fMqRa","url:./dead-bug.png":"gFanQ","url:./deadlift.png":"le2xs","url:./deadlift-resistance-band.png":"68k6h","url:./decline-bench-press-tempo.png":"2R4ZV","url:./dips.png":"lDuWK","url:./donkey-kick-back.png":"2EowD","url:./dumbbell-bench-press.png":"boS3h","url:./dumbbell-bench-press-paused.png":"1I7yK","url:./dumbbell-lateral-raise.png":"eGXoX","url:./dumbbell-row.png":"13GdZ","url:./front-raise.png":"5BAPb","url:./front-squat.png":"9Sjpv","url:./front-squat-resistance-band.png":"gkz1W","url:./glute-bridge.png":"ieOvT","url:./glute-bridge-single-leg.png":"a91Gf","url:./goblet-squat.png":"gmqSA","url:./goblet-squat-tempo.png":"l0rub","url:./hack-squat.png":"Lrrcj","url:./hack-squat-decline.png":"f9uMe","url:./hammer-curl.png":"34Ovl","url:./hamstring-curl.png":"d5Kp9","url:./hanging-leg-raise.png":"3Ao1x","url:./heel-flicks.png":"iiSli","url:./high-knees.png":"lirNq","url:./hip-thrust.png":"3oVqV","url:./hip-thrust-paused.png":"hDbfy","url:./incline-bench-press.png":"6gmWv","url:./incline-bench-press-resistance-band.png":"82jBW","url:./incline-push-up.png":"6sN47","url:./incline-push-up-incline.png":"kiCjA","url:./jabs.png":"3Gjzc","url:./jump-rope.png":"c7GKb","url:./jumping-jacks.png":"e9Z6T","url:./kettlebell-swing.png":"bpN4h","url:./knee-to-elbow.png":"2qNjK","url:./lat-pulldown.png":"jG9LK","url:./lateral-raise.png":"4rRvw","url:./leg-extension.png":"jmR9z","url:./leg-press-incline.png":"6OUs1","url:./male-wood-cutter-left-to-right.png":"7BhVA","url:./male-wood-cutter-right-to-left.png":"f577B","url:./mountain-climbers.png":"5xHX4","url:./overhead-tricep-extension.png":"jO9TR","url:./plank.png":"VoEi9","url:./preacher-curl.png":"jrHzB","url:./press-up.png":"gxe7g","url:./pull-up.png":"6S8KP","url:./push-press.png":"gU5nO","url:./push-press-paused.png":"48z70","url:./push-up.png":"dvC59","url:./push-up-single-leg.png":"2dA2I","url:./rear-delt-fly.png":"akniO","url:./romanian-deadlift.png":"e6dpB","url:./romanian-deadlift-tempo.png":"3FLnH","url:./rowing.png":"ckFwE","url:./russian-twist.png":"gH7E0","url:./seated-cable-row.png":"jTCZg","url:./shoulder-press.png":"g5CSr","url:./side-lunge.png":"qplcG","url:./side-plank.png":"lAalu","url:./sit-up.png":"dWxJY","url:./skull-crushers.png":"5wT5m","url:./squat.png":"3zOz5","url:./squat-jumps.png":"iag5J","url:./standing-kick-back.png":"7zv1M","url:./sumo-squat.png":"6b0Yg","url:./tricep-dips-bench.png":"jtV4s","url:./tricep-pushdown.png":"8MouV","url:./upper-cut.png":"h9ec0","url:./walking-lunges.png":"2FcXt","url:./walking-lunges-single-leg.png":"flp4U","url:./wall-sit.png":"cZXKR","url:./wood-cutter.png":"l7pqk","url:./wood-cutter-leftto-right.png":"7XDOB","url:./wood-cutter-rightto-left.png":"1EaMq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4C7SZ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ekXZf");

},{}],"hFNSg":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("al3bo");

},{}],"6ZkSc":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4eEwb");

},{}],"btyDE":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lnTiw");

},{}],"1RKu1":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("hYimE");

},{}],"fTQHw":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ewD4g");

},{}],"9L1GP":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dGORp");

},{}],"l1R5P":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6NNEK");

},{}],"lTOhq":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1BLGR");

},{}],"7paM0":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("bcWYJ");

},{}],"7Ix6A":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8ctUx");

},{}],"6lidK":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lstAU");

},{}],"fnDhY":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1dU1o");

},{}],"4Q5l0":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7TMBe");

},{}],"l5W4L":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2g8t8");

},{}],"2V38T":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5t4Ot");

},{}],"fMqRa":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("jLij6");

},{}],"gFanQ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("89pnF");

},{}],"le2xs":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("eeY4C");

},{}],"68k6h":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("e2H2y");

},{}],"2R4ZV":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kSXmb");

},{}],"lDuWK":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("j2P5k");

},{}],"2EowD":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3N9Mp");

},{}],"boS3h":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("geBB7");

},{}],"1I7yK":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8MLWy");

},{}],"eGXoX":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gBeU1");

},{}],"13GdZ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kENac");

},{}],"5BAPb":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("iewBq");

},{}],"9Sjpv":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9n2L1");

},{}],"gkz1W":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gp4gM");

},{}],"ieOvT":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dxDBZ");

},{}],"a91Gf":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4vXds");

},{}],"gmqSA":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("jNDep");

},{}],"l0rub":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("iLba4");

},{}],"Lrrcj":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("YzLyB");

},{}],"f9uMe":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cK2Xm");

},{}],"34Ovl":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3qgii");

},{}],"d5Kp9":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5eq9K");

},{}],"3Ao1x":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gTEiz");

},{}],"iiSli":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3JtxE");

},{}],"lirNq":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3Flbj");

},{}],"3oVqV":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ckgXu");

},{}],"hDbfy":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("eoOQ3");

},{}],"6gmWv":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("aVU7a");

},{}],"82jBW":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("NTX47");

},{}],"6sN47":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("55TQt");

},{}],"kiCjA":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("bfJPE");

},{}],"3Gjzc":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7kI5o");

},{}],"c7GKb":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5JjXa");

},{}],"e9Z6T":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8CaPt");

},{}],"bpN4h":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("950TK");

},{}],"2qNjK":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("19Pex");

},{}],"jG9LK":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("m1KQF");

},{}],"4rRvw":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6jKYI");

},{}],"jmR9z":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7Gxsg");

},{}],"6OUs1":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1fa5T");

},{}],"7BhVA":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("c9V33");

},{}],"f577B":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gL0zK");

},{}],"5xHX4":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5jETv");

},{}],"jO9TR":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("hCHta");

},{}],"VoEi9":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6nB1Y");

},{}],"jrHzB":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("34ZBf");

},{}],"gxe7g":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("rPGRd");

},{}],"6S8KP":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5ihER");

},{}],"gU5nO":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("eSseB");

},{}],"48z70":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gXKTF");

},{}],"dvC59":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1xbPc");

},{}],"2dA2I":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kvhp4");

},{}],"akniO":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cPoey");

},{}],"e6dpB":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ckUpg");

},{}],"3FLnH":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9TfQn");

},{}],"ckFwE":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7qIq0");

},{}],"gH7E0":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cEXHf");

},{}],"jTCZg":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("duUHV");

},{}],"g5CSr":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9CrZ7");

},{}],"qplcG":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2HHHh");

},{}],"lAalu":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("aARHs");

},{}],"dWxJY":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7cWCk");

},{}],"5wT5m":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("i0ztD");

},{}],"3zOz5":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("aNSgx");

},{}],"iag5J":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("efh3u");

},{}],"7zv1M":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("88WiY");

},{}],"6b0Yg":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kyPBG");

},{}],"jtV4s":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("k4pWi");

},{}],"8MouV":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("JI9rQ");

},{}],"h9ec0":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7Bw0x");

},{}],"2FcXt":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dinwC");

},{}],"flp4U":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lMoRo");

},{}],"cZXKR":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dzJxh");

},{}],"l7pqk":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("bD5ze");

},{}],"7XDOB":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gP0vN");

},{}],"1EaMq":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1HHz1");

},{}],"WtCGM":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgramCompleted", ()=>ProgramCompleted);
var _jsxRuntime = require("react/jsx-runtime");
var _indexCss = require("../../../../index.css");
var _routeCss = require("../../../../route.css");
var _resetCss = require("../../../../reset.css");
// 🔹 React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 Routing
var _reactRouterDom = require("react-router-dom");
// 🔹 UI Component Libraries
var _framerMotion = require("framer-motion");
var _antd = require("antd");
var _canvasConfetti = require("canvas-confetti");
var _canvasConfettiDefault = parcelHelpers.interopDefault(_canvasConfetti);
// 🔹 Internal Components
var _button = require("src/components/Button/Button");
var _useScreenTime = require("src/hooks/useScreenTime");
var _useUserBehaviorTracker = require("src/api/mutations/useUserBehaviorTracker");
var _screenTimeTracker = require("src/utils/screenTimeTracker");
var _programStore = require("src/store/programStore");
// 🔹 Assets
var _miniPtCareMp4 = require("url:../../../../assets/videos/mini-pt-care.mp4");
var _miniPtCareMp4Default = parcelHelpers.interopDefault(_miniPtCareMp4);
var _useJoinWaitlistTs = require("src/api/mutations/useJoinWaitlist.ts");
// ── SVG shapes from Group_2085663043.svg ────────────────────────────────────
// eslint-disable-next-line import/no-named-as-default-member
const shapeA = (0, _canvasConfettiDefault.default).shapeFromPath({
    path: 'M5.087,0 L7.966,0 Q13.053,0 13.053,5.087 L13.053,13.565 Q13.053,18.652 7.966,18.652 L5.087,18.652 Q0,18.652 0,13.565 L0,5.087 Q0,0 5.087,0Z',
    matrix: new DOMMatrix([
        0.5,
        0,
        0,
        0.5,
        -3.263,
        -4.663
    ])
});
// eslint-disable-next-line import/no-named-as-default-member
const shapeB = (0, _canvasConfettiDefault.default).shapeFromPath({
    path: 'M5.087,0 L10.174,0 Q15.261,0 15.261,5.087 L15.261,13.565 Q15.261,18.652 10.174,18.652 L5.087,18.652 Q0,18.652 0,13.565 L0,5.087 Q0,0 5.087,0Z',
    matrix: new DOMMatrix([
        0.5,
        0,
        0,
        0.5,
        -3.815,
        -4.663
    ])
});
// eslint-disable-next-line import/no-named-as-default-member
const shapeC = (0, _canvasConfettiDefault.default).shapeFromPath({
    path: 'M4.698,0 L10.563,0 Q15.261,0 15.261,4.698 L15.261,4.697 Q15.261,9.395 10.563,9.395 L4.698,9.395 Q0,9.395 0,4.697 L0,4.698 Q0,0 4.698,0Z',
    matrix: new DOMMatrix([
        0.5,
        0,
        0,
        0.5,
        -3.815,
        -2.349
    ])
});
const ProgramCompleted = ()=>{
    // Use
    const navigate = (0, _reactRouterDom.useNavigate)();
    const containerRef = (0, _react.useRef)(null);
    //State
    const [email, setEmail] = (0, _react.useState)('');
    const userType = 'trainer';
    const [success, setSuccess] = (0, _react.useState)(false);
    const [fieldErrors, setFieldErrors] = (0, _react.useState)({});
    const { mutate: joinWaitlist, isPending } = (0, _useJoinWaitlistTs.useJoinWaitlist)();
    // State
    const [feedbackContainer, setFeedbackContainer] = (0, _react.useState)(false);
    const [feedbackValue, setFeedbackValue] = (0, _react.useState)('');
    // Handler
    const feedbackHandler = (value)=>{
        setFeedbackValue(value || '');
    };
    // 🎉 Fire confetti on mount
    (0, _react.useEffect)(()=>{
        (0, _canvasConfettiDefault.default)({
            particleCount: 300,
            shapes: [
                shapeA,
                shapeB,
                shapeC
            ],
            colors: [
                '#FFA100',
                '#FFC665'
            ],
            scalar: 2,
            spread: 500,
            origin: {
                y: -0.1
            },
            startVelocity: -35
        });
    }, []);
    // ── Screen time tracking – Section 15 (/trainer/generated/ai/completed) ──
    (0, _useScreenTime.useScreenTime)((0, _screenTimeTracker.TRAINER_SECTIONS).SECTION_15);
    const handleSubmit = ()=>{
        if (!email || !userType) return;
        setFieldErrors({});
        // Shared helper – sends the analytics snapshot with the confirmed email.
        // Called on both waitlist success and EMAIL_EXISTS (user already registered).
        const sendBehaviorTracker = (confirmedEmail)=>{
            const storedSessionId = (0, _screenTimeTracker.screenTimeTracker).getStoredSessionId();
            (0, _useUserBehaviorTracker.trackUserBehavior)({
                ...storedSessionId ? {
                    sessionId: storedSessionId
                } : {},
                email: confirmedEmail,
                data: (0, _screenTimeTracker.screenTimeTracker).getReport()
            }).then(()=>{
                (0, _screenTimeTracker.screenTimeTracker).reset();
            }).catch(()=>{
            // Silently ignore – analytics are non-critical
            });
        };
        joinWaitlist({
            email,
            type: userType
        }, {
            onSuccess: ()=>{
                setSuccess(true);
                sendBehaviorTracker(email);
                // Wipe stored program data – the trainer has finished this session.
                (0, _programStore.clearGeneratedProgram)();
            },
            onError: (err)=>{
                const axiosErr = err;
                const apiError = axiosErr.response?.data?.error;
                if (!apiError) {
                    setFieldErrors({
                        general: 'Something went wrong. Please try again.'
                    });
                    return;
                }
                // EMAIL_EXISTS means we still know who the user is – send analytics.
                if (apiError.code === 'EMAIL_EXISTS') sendBehaviorTracker(email);
                if (apiError.field === 'email') setFieldErrors({
                    email: apiError.message
                });
                else if (apiError.field === 'type') setFieldErrors({
                    type: apiError.message
                });
                else setFieldErrors({
                    general: apiError.message
                });
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `miniPT-container miniPT-training-container miniPT-animation`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex-center-column miniPT-animation-container",
                style: {
                    position: 'fixed',
                    top: 'calc(var(--padding-top) + 250px + 32px)',
                    left: '50%',
                    width: 250,
                    height: 250,
                    zIndex: 0,
                    pointerEvents: 'none',
                    mixBlendMode: 'lighten',
                    translate: 'none',
                    opacity: 1,
                    transform: 'translate(-50%, -100%)'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                        autoPlay: true,
                        muted: true,
                        loop: true,
                        playsInline: true,
                        preload: "auto",
                        style: {
                            width: '100%',
                            height: '100%',
                            objectFit: 'cover',
                            zIndex: 0,
                            mixBlendMode: 'lighten'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("source", {
                            src: (0, _miniPtCareMp4Default.default),
                            type: "video/mp4"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "mini-pt-text",
                        children: "MiniPT Core"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `background-wrapper flex-center-column px-16`,
                style: {
                    position: 'relative',
                    zIndex: 1,
                    width: '100%'
                },
                ref: containerRef,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "flex-center-column animation-margin-top",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "max-width-576 route-fade-in",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                                    className: "page-sub-title text-center mt-0 mb-12",
                                    children: [
                                        "You rocked the program ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                        " creation demo!"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "text-light text-center mt-0 mb-32",
                                    children: "Be among the first trainers to create smarter, AI-powered programs for your clients."
                                })
                            ]
                        }),
                        !success && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "max-width-420 route-fade-in text-center early-access-container",
                            style: {
                                marginBottom: 40
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    placeholder: "Enter your email",
                                    className: "early-access",
                                    type: "email",
                                    value: email,
                                    onChange: (e)=>setEmail(e.target.value),
                                    style: {
                                        marginBottom: 18
                                    }
                                }),
                                fieldErrors.email && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "text-danger text-start text-small",
                                    children: fieldErrors.email
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    onClick: handleSubmit,
                                    variant: "primary",
                                    className: `bg-gradient-color relative-z-10 continue-manually justify-content-center`,
                                    disabled: !email || isPending,
                                    children: isPending ? 'Please wait...' : 'Get Early Access'
                                })
                            ]
                        }),
                        success && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "text-center mt-0 mb-32 max-width-768",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "mt-0",
                                    children: "You're on the list!"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    children: [
                                        "We've added ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                            children: email
                                        }),
                                        " to our waitlist."
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "max-width-576 route-fade-in mt-auto",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.AnimatePresence), {
                                children: !feedbackContainer && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                                    initial: {
                                        opacity: 1
                                    },
                                    animate: {
                                        opacity: 1
                                    },
                                    exit: {
                                        opacity: 0
                                    },
                                    transition: {
                                        duration: 0.2
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        onClick: ()=>setFeedbackContainer(true),
                                        variant: "outline",
                                        className: "relative-z-10 continue-manually",
                                        children: "I Have Feedback to Offer"
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.AnimatePresence), {
                            children: feedbackContainer && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _framerMotion.motion).div, {
                                className: "max-width-576 text-start",
                                initial: {
                                    opacity: 0,
                                    y: 20
                                },
                                animate: {
                                    opacity: 1,
                                    y: 0
                                },
                                exit: {
                                    opacity: 0,
                                    y: 20
                                },
                                transition: {
                                    duration: 0.4
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "dark-bg-card p-3",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            children: "We're building this for trainers like you, your feedback really helps us improve."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            placeholder: "I would like to see...",
                                            rows: 4,
                                            value: feedbackValue,
                                            onChange: (e)=>feedbackHandler(e.target.value)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            onClick: ()=>{
                                                (0, _antd.message).success("Thanks for your feedback! \uD83D\uDE80");
                                                setTimeout(()=>{
                                                    setFeedbackContainer(false);
                                                    navigate('/');
                                                }, 1000);
                                            },
                                            variant: "primary",
                                            className: "w-100 bg-white justify-content-center",
                                            disabled: !feedbackValue,
                                            children: isPending ? 'Loading...' : 'Send Feedback'
                                        })
                                    ]
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {})
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","../../../../index.css":"fW8RG","../../../../route.css":"h1KSg","../../../../reset.css":"3X473","react":"bmhQu","react-router-dom":"f3cgC","framer-motion":[["AnimatePresence","QteOV"],["motion","9sgBs"]],"antd":[["message","4POhF","default"]],"canvas-confetti":"9r6Rh","src/components/Button/Button":"g0894","src/hooks/useScreenTime":"dhG6r","src/api/mutations/useUserBehaviorTracker":"3nht4","src/utils/screenTimeTracker":"dwAC9","src/store/programStore":"hM1mR","url:../../../../assets/videos/mini-pt-care.mp4":"5knEg","src/api/mutations/useJoinWaitlist.ts":"4RZ0a","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fW8RG":[function() {},{}],"h1KSg":[function() {},{}],"3X473":[function() {},{}],"9r6Rh":[function(require,module,exports,__globalThis) {
// canvas-confetti v1.9.4 built on 2025-10-25T05:14:56.640Z
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "create", ()=>create);
var module = {};
// source content
/* globals Map */ (function main(global, module, isWorker, workerSize) {
    var canUseWorker = !!(global.Worker && global.Blob && global.Promise && global.OffscreenCanvas && global.OffscreenCanvasRenderingContext2D && global.HTMLCanvasElement && global.HTMLCanvasElement.prototype.transferControlToOffscreen && global.URL && global.URL.createObjectURL);
    var canUsePaths = typeof Path2D === 'function' && typeof DOMMatrix === 'function';
    var canDrawBitmap = function() {
        // this mostly supports ssr
        if (!global.OffscreenCanvas) return false;
        try {
            var canvas = new OffscreenCanvas(1, 1);
            var ctx = canvas.getContext('2d');
            ctx.fillRect(0, 0, 1, 1);
            var bitmap = canvas.transferToImageBitmap();
            ctx.createPattern(bitmap, 'no-repeat');
        } catch (e) {
            return false;
        }
        return true;
    }();
    function noop() {}
    // create a promise if it exists, otherwise, just
    // call the function directly
    function promise(func) {
        var ModulePromise = module.exports.Promise;
        var Prom = ModulePromise !== void 0 ? ModulePromise : global.Promise;
        if (typeof Prom === 'function') return new Prom(func);
        func(noop, noop);
        return null;
    }
    var bitmapMapper = function(skipTransform, map) {
        // see https://github.com/catdad/canvas-confetti/issues/209
        // creating canvases is actually pretty expensive, so we should create a
        // 1:1 map for bitmap:canvas, so that we can animate the confetti in
        // a performant manner, but also not store them forever so that we don't
        // have a memory leak
        return {
            transform: function(bitmap) {
                if (skipTransform) return bitmap;
                if (map.has(bitmap)) return map.get(bitmap);
                var canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
                var ctx = canvas.getContext('2d');
                ctx.drawImage(bitmap, 0, 0);
                map.set(bitmap, canvas);
                return canvas;
            },
            clear: function() {
                map.clear();
            }
        };
    }(canDrawBitmap, new Map());
    var raf = function() {
        var TIME = Math.floor(1000 / 60);
        var frame, cancel;
        var frames = {};
        var lastFrameTime = 0;
        if (typeof requestAnimationFrame === 'function' && typeof cancelAnimationFrame === 'function') {
            frame = function(cb) {
                var id = Math.random();
                frames[id] = requestAnimationFrame(function onFrame(time) {
                    if (lastFrameTime === time || lastFrameTime + TIME - 1 < time) {
                        lastFrameTime = time;
                        delete frames[id];
                        cb();
                    } else frames[id] = requestAnimationFrame(onFrame);
                });
                return id;
            };
            cancel = function(id) {
                if (frames[id]) cancelAnimationFrame(frames[id]);
            };
        } else {
            frame = function(cb) {
                return setTimeout(cb, TIME);
            };
            cancel = function(timer) {
                return clearTimeout(timer);
            };
        }
        return {
            frame: frame,
            cancel: cancel
        };
    }();
    var getWorker = function() {
        var worker;
        var prom;
        var resolves = {};
        function decorate(worker) {
            function execute(options, callback) {
                worker.postMessage({
                    options: options || {},
                    callback: callback
                });
            }
            worker.init = function initWorker(canvas) {
                var offscreen = canvas.transferControlToOffscreen();
                worker.postMessage({
                    canvas: offscreen
                }, [
                    offscreen
                ]);
            };
            worker.fire = function fireWorker(options, size, done) {
                if (prom) {
                    execute(options, null);
                    return prom;
                }
                var id = Math.random().toString(36).slice(2);
                prom = promise(function(resolve) {
                    function workerDone(msg) {
                        if (msg.data.callback !== id) return;
                        delete resolves[id];
                        worker.removeEventListener('message', workerDone);
                        prom = null;
                        bitmapMapper.clear();
                        done();
                        resolve();
                    }
                    worker.addEventListener('message', workerDone);
                    execute(options, id);
                    resolves[id] = workerDone.bind(null, {
                        data: {
                            callback: id
                        }
                    });
                });
                return prom;
            };
            worker.reset = function resetWorker() {
                worker.postMessage({
                    reset: true
                });
                for(var id in resolves){
                    resolves[id]();
                    delete resolves[id];
                }
            };
        }
        return function() {
            if (worker) return worker;
            if (!isWorker && canUseWorker) {
                var code = [
                    'var CONFETTI, SIZE = {}, module = {};',
                    '(' + main.toString() + ')(this, module, true, SIZE);',
                    'onmessage = function(msg) {',
                    '  if (msg.data.options) {',
                    '    CONFETTI(msg.data.options).then(function () {',
                    '      if (msg.data.callback) {',
                    '        postMessage({ callback: msg.data.callback });',
                    '      }',
                    '    });',
                    '  } else if (msg.data.reset) {',
                    '    CONFETTI && CONFETTI.reset();',
                    '  } else if (msg.data.resize) {',
                    '    SIZE.width = msg.data.resize.width;',
                    '    SIZE.height = msg.data.resize.height;',
                    '  } else if (msg.data.canvas) {',
                    '    SIZE.width = msg.data.canvas.width;',
                    '    SIZE.height = msg.data.canvas.height;',
                    '    CONFETTI = module.exports.create(msg.data.canvas);',
                    '  }',
                    '}'
                ].join('\n');
                try {
                    worker = new Worker(URL.createObjectURL(new Blob([
                        code
                    ])));
                } catch (e) {
                    // eslint-disable-next-line no-console
                    typeof console !== 'undefined' && typeof console.warn === 'function' && console.warn("\uD83C\uDF8A Could not load worker", e);
                    return null;
                }
                decorate(worker);
            }
            return worker;
        };
    }();
    var defaults = {
        particleCount: 50,
        angle: 90,
        spread: 45,
        startVelocity: 45,
        decay: 0.9,
        gravity: 1,
        drift: 0,
        ticks: 200,
        x: 0.5,
        y: 0.5,
        shapes: [
            'square',
            'circle'
        ],
        zIndex: 100,
        colors: [
            '#26ccff',
            '#a25afd',
            '#ff5e7e',
            '#88ff5a',
            '#fcff42',
            '#ffa62d',
            '#ff36ff'
        ],
        // probably should be true, but back-compat
        disableForReducedMotion: false,
        scalar: 1
    };
    function convert(val, transform) {
        return transform ? transform(val) : val;
    }
    function isOk(val) {
        return !(val === null || val === undefined);
    }
    function prop(options, name, transform) {
        return convert(options && isOk(options[name]) ? options[name] : defaults[name], transform);
    }
    function onlyPositiveInt(number) {
        return number < 0 ? 0 : Math.floor(number);
    }
    function randomInt(min, max) {
        // [min, max)
        return Math.floor(Math.random() * (max - min)) + min;
    }
    function toDecimal(str) {
        return parseInt(str, 16);
    }
    function colorsToRgb(colors) {
        return colors.map(hexToRgb);
    }
    function hexToRgb(str) {
        var val = String(str).replace(/[^0-9a-f]/gi, '');
        if (val.length < 6) val = val[0] + val[0] + val[1] + val[1] + val[2] + val[2];
        return {
            r: toDecimal(val.substring(0, 2)),
            g: toDecimal(val.substring(2, 4)),
            b: toDecimal(val.substring(4, 6))
        };
    }
    function getOrigin(options) {
        var origin = prop(options, 'origin', Object);
        origin.x = prop(origin, 'x', Number);
        origin.y = prop(origin, 'y', Number);
        return origin;
    }
    function setCanvasWindowSize(canvas) {
        canvas.width = document.documentElement.clientWidth;
        canvas.height = document.documentElement.clientHeight;
    }
    function setCanvasRectSize(canvas) {
        var rect = canvas.getBoundingClientRect();
        canvas.width = rect.width;
        canvas.height = rect.height;
    }
    function getCanvas(zIndex) {
        var canvas = document.createElement('canvas');
        canvas.style.position = 'fixed';
        canvas.style.top = '0px';
        canvas.style.left = '0px';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = zIndex;
        return canvas;
    }
    function ellipse(context, x, y, radiusX, radiusY, rotation, startAngle, endAngle, antiClockwise) {
        context.save();
        context.translate(x, y);
        context.rotate(rotation);
        context.scale(radiusX, radiusY);
        context.arc(0, 0, 1, startAngle, endAngle, antiClockwise);
        context.restore();
    }
    function randomPhysics(opts) {
        var radAngle = opts.angle * (Math.PI / 180);
        var radSpread = opts.spread * (Math.PI / 180);
        return {
            x: opts.x,
            y: opts.y,
            wobble: Math.random() * 10,
            wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
            velocity: opts.startVelocity * 0.5 + Math.random() * opts.startVelocity,
            angle2D: -radAngle + (0.5 * radSpread - Math.random() * radSpread),
            tiltAngle: (Math.random() * 0.5 + 0.25) * Math.PI,
            color: opts.color,
            shape: opts.shape,
            tick: 0,
            totalTicks: opts.ticks,
            decay: opts.decay,
            drift: opts.drift,
            random: Math.random() + 2,
            tiltSin: 0,
            tiltCos: 0,
            wobbleX: 0,
            wobbleY: 0,
            gravity: opts.gravity * 3,
            ovalScalar: 0.6,
            scalar: opts.scalar,
            flat: opts.flat
        };
    }
    function updateFetti(context, fetti) {
        fetti.x += Math.cos(fetti.angle2D) * fetti.velocity + fetti.drift;
        fetti.y += Math.sin(fetti.angle2D) * fetti.velocity + fetti.gravity;
        fetti.velocity *= fetti.decay;
        if (fetti.flat) {
            fetti.wobble = 0;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar;
            fetti.wobbleY = fetti.y + 10 * fetti.scalar;
            fetti.tiltSin = 0;
            fetti.tiltCos = 0;
            fetti.random = 1;
        } else {
            fetti.wobble += fetti.wobbleSpeed;
            fetti.wobbleX = fetti.x + 10 * fetti.scalar * Math.cos(fetti.wobble);
            fetti.wobbleY = fetti.y + 10 * fetti.scalar * Math.sin(fetti.wobble);
            fetti.tiltAngle += 0.1;
            fetti.tiltSin = Math.sin(fetti.tiltAngle);
            fetti.tiltCos = Math.cos(fetti.tiltAngle);
            fetti.random = Math.random() + 2;
        }
        var progress = fetti.tick++ / fetti.totalTicks;
        var x1 = fetti.x + fetti.random * fetti.tiltCos;
        var y1 = fetti.y + fetti.random * fetti.tiltSin;
        var x2 = fetti.wobbleX + fetti.random * fetti.tiltCos;
        var y2 = fetti.wobbleY + fetti.random * fetti.tiltSin;
        context.fillStyle = 'rgba(' + fetti.color.r + ', ' + fetti.color.g + ', ' + fetti.color.b + ', ' + (1 - progress) + ')';
        context.beginPath();
        if (canUsePaths && fetti.shape.type === 'path' && typeof fetti.shape.path === 'string' && Array.isArray(fetti.shape.matrix)) context.fill(transformPath2D(fetti.shape.path, fetti.shape.matrix, fetti.x, fetti.y, Math.abs(x2 - x1) * 0.1, Math.abs(y2 - y1) * 0.1, Math.PI / 10 * fetti.wobble));
        else if (fetti.shape.type === 'bitmap') {
            var rotation = Math.PI / 10 * fetti.wobble;
            var scaleX = Math.abs(x2 - x1) * 0.1;
            var scaleY = Math.abs(y2 - y1) * 0.1;
            var width = fetti.shape.bitmap.width * fetti.scalar;
            var height = fetti.shape.bitmap.height * fetti.scalar;
            var matrix = new DOMMatrix([
                Math.cos(rotation) * scaleX,
                Math.sin(rotation) * scaleX,
                -Math.sin(rotation) * scaleY,
                Math.cos(rotation) * scaleY,
                fetti.x,
                fetti.y
            ]);
            // apply the transform matrix from the confetti shape
            matrix.multiplySelf(new DOMMatrix(fetti.shape.matrix));
            var pattern = context.createPattern(bitmapMapper.transform(fetti.shape.bitmap), 'no-repeat');
            pattern.setTransform(matrix);
            context.globalAlpha = 1 - progress;
            context.fillStyle = pattern;
            context.fillRect(fetti.x - width / 2, fetti.y - height / 2, width, height);
            context.globalAlpha = 1;
        } else if (fetti.shape === 'circle') context.ellipse ? context.ellipse(fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI) : ellipse(context, fetti.x, fetti.y, Math.abs(x2 - x1) * fetti.ovalScalar, Math.abs(y2 - y1) * fetti.ovalScalar, Math.PI / 10 * fetti.wobble, 0, 2 * Math.PI);
        else if (fetti.shape === 'star') {
            var rot = Math.PI / 2 * 3;
            var innerRadius = 4 * fetti.scalar;
            var outerRadius = 8 * fetti.scalar;
            var x = fetti.x;
            var y = fetti.y;
            var spikes = 5;
            var step = Math.PI / spikes;
            while(spikes--){
                x = fetti.x + Math.cos(rot) * outerRadius;
                y = fetti.y + Math.sin(rot) * outerRadius;
                context.lineTo(x, y);
                rot += step;
                x = fetti.x + Math.cos(rot) * innerRadius;
                y = fetti.y + Math.sin(rot) * innerRadius;
                context.lineTo(x, y);
                rot += step;
            }
        } else {
            context.moveTo(Math.floor(fetti.x), Math.floor(fetti.y));
            context.lineTo(Math.floor(fetti.wobbleX), Math.floor(y1));
            context.lineTo(Math.floor(x2), Math.floor(y2));
            context.lineTo(Math.floor(x1), Math.floor(fetti.wobbleY));
        }
        context.closePath();
        context.fill();
        return fetti.tick < fetti.totalTicks;
    }
    function animate(canvas, fettis, resizer, size, done) {
        var animatingFettis = fettis.slice();
        var context = canvas.getContext('2d');
        var animationFrame;
        var destroy;
        var prom = promise(function(resolve) {
            function onDone() {
                animationFrame = destroy = null;
                context.clearRect(0, 0, size.width, size.height);
                bitmapMapper.clear();
                done();
                resolve();
            }
            function update() {
                if (isWorker && !(size.width === workerSize.width && size.height === workerSize.height)) {
                    size.width = canvas.width = workerSize.width;
                    size.height = canvas.height = workerSize.height;
                }
                if (!size.width && !size.height) {
                    resizer(canvas);
                    size.width = canvas.width;
                    size.height = canvas.height;
                }
                context.clearRect(0, 0, size.width, size.height);
                animatingFettis = animatingFettis.filter(function(fetti) {
                    return updateFetti(context, fetti);
                });
                if (animatingFettis.length) animationFrame = raf.frame(update);
                else onDone();
            }
            animationFrame = raf.frame(update);
            destroy = onDone;
        });
        return {
            addFettis: function(fettis) {
                animatingFettis = animatingFettis.concat(fettis);
                return prom;
            },
            canvas: canvas,
            promise: prom,
            reset: function() {
                if (animationFrame) raf.cancel(animationFrame);
                if (destroy) destroy();
            }
        };
    }
    function confettiCannon(canvas, globalOpts) {
        var isLibCanvas = !canvas;
        var allowResize = !!prop(globalOpts || {}, 'resize');
        var hasResizeEventRegistered = false;
        var globalDisableForReducedMotion = prop(globalOpts, 'disableForReducedMotion', Boolean);
        var shouldUseWorker = canUseWorker && !!prop(globalOpts || {}, 'useWorker');
        var worker = shouldUseWorker ? getWorker() : null;
        var resizer = isLibCanvas ? setCanvasWindowSize : setCanvasRectSize;
        var initialized = canvas && worker ? !!canvas.__confetti_initialized : false;
        var preferLessMotion = typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion)').matches;
        var animationObj;
        function fireLocal(options, size, done) {
            var particleCount = prop(options, 'particleCount', onlyPositiveInt);
            var angle = prop(options, 'angle', Number);
            var spread = prop(options, 'spread', Number);
            var startVelocity = prop(options, 'startVelocity', Number);
            var decay = prop(options, 'decay', Number);
            var gravity = prop(options, 'gravity', Number);
            var drift = prop(options, 'drift', Number);
            var colors = prop(options, 'colors', colorsToRgb);
            var ticks = prop(options, 'ticks', Number);
            var shapes = prop(options, 'shapes');
            var scalar = prop(options, 'scalar');
            var flat = !!prop(options, 'flat');
            var origin = getOrigin(options);
            var temp = particleCount;
            var fettis = [];
            var startX = canvas.width * origin.x;
            var startY = canvas.height * origin.y;
            while(temp--)fettis.push(randomPhysics({
                x: startX,
                y: startY,
                angle: angle,
                spread: spread,
                startVelocity: startVelocity,
                color: colors[temp % colors.length],
                shape: shapes[randomInt(0, shapes.length)],
                ticks: ticks,
                decay: decay,
                gravity: gravity,
                drift: drift,
                scalar: scalar,
                flat: flat
            }));
            // if we have a previous canvas already animating,
            // add to it
            if (animationObj) return animationObj.addFettis(fettis);
            animationObj = animate(canvas, fettis, resizer, size, done);
            return animationObj.promise;
        }
        function fire(options) {
            var disableForReducedMotion = globalDisableForReducedMotion || prop(options, 'disableForReducedMotion', Boolean);
            var zIndex = prop(options, 'zIndex', Number);
            if (disableForReducedMotion && preferLessMotion) return promise(function(resolve) {
                resolve();
            });
            if (isLibCanvas && animationObj) // use existing canvas from in-progress animation
            canvas = animationObj.canvas;
            else if (isLibCanvas && !canvas) {
                // create and initialize a new canvas
                canvas = getCanvas(zIndex);
                document.body.appendChild(canvas);
            }
            if (allowResize && !initialized) // initialize the size of a user-supplied canvas
            resizer(canvas);
            var size = {
                width: canvas.width,
                height: canvas.height
            };
            if (worker && !initialized) worker.init(canvas);
            initialized = true;
            if (worker) canvas.__confetti_initialized = true;
            function onResize() {
                if (worker) {
                    // TODO this really shouldn't be immediate, because it is expensive
                    var obj = {
                        getBoundingClientRect: function() {
                            if (!isLibCanvas) return canvas.getBoundingClientRect();
                        }
                    };
                    resizer(obj);
                    worker.postMessage({
                        resize: {
                            width: obj.width,
                            height: obj.height
                        }
                    });
                    return;
                }
                // don't actually query the size here, since this
                // can execute frequently and rapidly
                size.width = size.height = null;
            }
            function done() {
                animationObj = null;
                if (allowResize) {
                    hasResizeEventRegistered = false;
                    global.removeEventListener('resize', onResize);
                }
                if (isLibCanvas && canvas) {
                    if (document.body.contains(canvas)) document.body.removeChild(canvas);
                    canvas = null;
                    initialized = false;
                }
            }
            if (allowResize && !hasResizeEventRegistered) {
                hasResizeEventRegistered = true;
                global.addEventListener('resize', onResize, false);
            }
            if (worker) return worker.fire(options, size, done);
            return fireLocal(options, size, done);
        }
        fire.reset = function() {
            if (worker) worker.reset();
            if (animationObj) animationObj.reset();
        };
        return fire;
    }
    // Make default export lazy to defer worker creation until called.
    var defaultFire;
    function getDefaultFire() {
        if (!defaultFire) defaultFire = confettiCannon(null, {
            useWorker: true,
            resize: true
        });
        return defaultFire;
    }
    function transformPath2D(pathString, pathMatrix, x, y, scaleX, scaleY, rotation) {
        var path2d = new Path2D(pathString);
        var t1 = new Path2D();
        t1.addPath(path2d, new DOMMatrix(pathMatrix));
        var t2 = new Path2D();
        // see https://developer.mozilla.org/en-US/docs/Web/API/DOMMatrix/DOMMatrix
        t2.addPath(t1, new DOMMatrix([
            Math.cos(rotation) * scaleX,
            Math.sin(rotation) * scaleX,
            -Math.sin(rotation) * scaleY,
            Math.cos(rotation) * scaleY,
            x,
            y
        ]));
        return t2;
    }
    function shapeFromPath(pathData) {
        if (!canUsePaths) throw new Error('path confetti are not supported in this browser');
        var path, matrix;
        if (typeof pathData === 'string') path = pathData;
        else {
            path = pathData.path;
            matrix = pathData.matrix;
        }
        var path2d = new Path2D(path);
        var tempCanvas = document.createElement('canvas');
        var tempCtx = tempCanvas.getContext('2d');
        if (!matrix) {
            // attempt to figure out the width of the path, up to 1000x1000
            var maxSize = 1000;
            var minX = maxSize;
            var minY = maxSize;
            var maxX = 0;
            var maxY = 0;
            var width, height;
            // do some line skipping... this is faster than checking
            // every pixel and will be mostly still correct
            for(var x = 0; x < maxSize; x += 2){
                for(var y = 0; y < maxSize; y += 2)if (tempCtx.isPointInPath(path2d, x, y, 'nonzero')) {
                    minX = Math.min(minX, x);
                    minY = Math.min(minY, y);
                    maxX = Math.max(maxX, x);
                    maxY = Math.max(maxY, y);
                }
            }
            width = maxX - minX;
            height = maxY - minY;
            var maxDesiredSize = 10;
            var scale = Math.min(maxDesiredSize / width, maxDesiredSize / height);
            matrix = [
                scale,
                0,
                0,
                scale,
                -Math.round(width / 2 + minX) * scale,
                -Math.round(height / 2 + minY) * scale
            ];
        }
        return {
            type: 'path',
            path: path,
            matrix: matrix
        };
    }
    function shapeFromText(textData) {
        var text, scalar = 1, color = '#000000', // see https://nolanlawson.com/2022/04/08/the-struggle-of-using-native-emoji-on-the-web/
        fontFamily = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';
        if (typeof textData === 'string') text = textData;
        else {
            text = textData.text;
            scalar = 'scalar' in textData ? textData.scalar : scalar;
            fontFamily = 'fontFamily' in textData ? textData.fontFamily : fontFamily;
            color = 'color' in textData ? textData.color : color;
        }
        // all other confetti are 10 pixels,
        // so this pixel size is the de-facto 100% scale confetti
        var fontSize = 10 * scalar;
        var font = '' + fontSize + 'px ' + fontFamily;
        var canvas = new OffscreenCanvas(fontSize, fontSize);
        var ctx = canvas.getContext('2d');
        ctx.font = font;
        var size = ctx.measureText(text);
        var width = Math.ceil(size.actualBoundingBoxRight + size.actualBoundingBoxLeft);
        var height = Math.ceil(size.actualBoundingBoxAscent + size.actualBoundingBoxDescent);
        var padding = 2;
        var x = size.actualBoundingBoxLeft + padding;
        var y = size.actualBoundingBoxAscent + padding;
        width += padding + padding;
        height += padding + padding;
        canvas = new OffscreenCanvas(width, height);
        ctx = canvas.getContext('2d');
        ctx.font = font;
        ctx.fillStyle = color;
        ctx.fillText(text, x, y);
        var scale = 1 / scalar;
        return {
            type: 'bitmap',
            // TODO these probably need to be transfered for workers
            bitmap: canvas.transferToImageBitmap(),
            matrix: [
                scale,
                0,
                0,
                scale,
                -width * scale / 2,
                -height * scale / 2
            ]
        };
    }
    module.exports = function() {
        return getDefaultFire().apply(this, arguments);
    };
    module.exports.reset = function() {
        getDefaultFire().reset();
    };
    module.exports.create = confettiCannon;
    module.exports.shapeFromPath = shapeFromPath;
    module.exports.shapeFromText = shapeFromText;
})(function() {
    if (typeof window !== 'undefined') return window;
    if (typeof self !== 'undefined') return self;
    return this || {};
}(), module, false);
// end source content
exports.default = module.exports;
var create = module.exports.create;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4RZ0a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useJoinWaitlist", ()=>useJoinWaitlist);
var _reactQuery = require("@tanstack/react-query");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _apiConfigTs = require("src/config/api-config.ts");
var _apiConfigTsDefault = parcelHelpers.interopDefault(_apiConfigTs);
function useJoinWaitlist() {
    return (0, _reactQuery.useMutation)({
        mutationFn: async (params)=>{
            const response = await (0, _axiosDefault.default).post(`${(0, _apiConfigTsDefault.default).BASE_URL}${(0, _apiConfigTsDefault.default).WAITLIST_API_HOST}`, params, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        }
    });
}

},{"@tanstack/react-query":"ehKs4","axios":"kL5AO","src/config/api-config.ts":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"89OvN":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnboardingTrainer", ()=>OnboardingTrainer);
var _jsxRuntime = require("react/jsx-runtime");
var _onboardingTrainerStyleScss = require("./OnboardingTrainer.style.scss");
var _onboardingTrainerScss = require("./OnboardingTrainer.scss");
// 🔹 React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 Routing
var _reactRouterDom = require("react-router-dom");
// 🔹 Components
var _customToaster = require("./components/CustomToaster");
const OnboardingTrainer = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    const isAuthPage = location.pathname.includes('/login') || location.pathname.includes('/signup') || location.pathname.includes('/dashboard');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `onboarding-Trainer ${isAuthPage ? 'no-padding' : ''}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customToaster.CustomToaster), {}),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {})
        ]
    });
};

},{"react/jsx-runtime":"gonF6","./OnboardingTrainer.style.scss":"8Uate","./OnboardingTrainer.scss":"87OtY","react":"bmhQu","react-router-dom":[["Outlet","9oT3O"],["useLocation","f3cgC"]],"./components/CustomToaster":"hbJ8a","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Uate":[function() {},{}],"87OtY":[function() {},{}],"hbJ8a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CustomToaster", ()=>CustomToaster);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactHotToast = require("react-hot-toast");
var _logoOfNotificationSvg = require("src/assets/images/onboarding-trainer/logo-of-notification.svg");
var _customToasterScss = require("./CustomToaster.scss");
const CustomToaster = ()=>{
    if (typeof document === 'undefined') return null;
    return /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactHotToast.Toaster), {
        position: "top-right",
        toastOptions: {
            duration: 4000
        },
        containerClassName: "custom-toaster",
        containerStyle: {
            zIndex: 9999999
        },
        children: (t)=>{
            let title = 'Notification';
            const description = (0, _reactHotToast.resolveValue)(t.message, t);
            if (t.type === 'success') title = 'Success';
            if (t.type === 'error') title = 'Error';
            if (t.type === 'loading') title = 'Loading';
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "custom-toaster-wrapper",
                style: {
                    opacity: t.visible ? 1 : 0
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "toaster-icon-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoOfNotificationSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "toaster-content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "toaster-title",
                                children: title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "toaster-description",
                                children: description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "toaster-close-btn",
                        onClick: ()=>(0, _reactHotToast.toast).dismiss(t.id),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            width: "24",
                            height: "24",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                    x1: "18",
                                    y1: "6",
                                    x2: "6",
                                    y2: "18"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                    x1: "6",
                                    y1: "6",
                                    x2: "18",
                                    y2: "18"
                                })
                            ]
                        })
                    })
                ]
            });
        }
    }), document.body);
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-dom":"82aNB","react-hot-toast":"3T0Wh","src/assets/images/onboarding-trainer/logo-of-notification.svg":"ptU7W","./CustomToaster.scss":"URxHu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3T0Wh":[function(require,module,exports,__globalThis) {
"use client";
"use strict";
var se = Object.create;
var k = Object.defineProperty;
var ae = Object.getOwnPropertyDescriptor;
var ie = Object.getOwnPropertyNames;
var ne = Object.getPrototypeOf, ce = Object.prototype.hasOwnProperty;
var pe = (e, t)=>{
    for(var o in t)k(e, o, {
        get: t[o],
        enumerable: !0
    });
}, G = (e, t, o, s)=>{
    if (t && typeof t == "object" || typeof t == "function") for (let a of ie(t))!ce.call(e, a) && a !== o && k(e, a, {
        get: ()=>t[a],
        enumerable: !(s = ae(t, a)) || s.enumerable
    });
    return e;
};
var j = (e, t, o)=>(o = e != null ? se(ne(e)) : {}, G(t || !e || !e.__esModule ? k(o, "default", {
        value: e,
        enumerable: !0
    }) : o, e)), de = (e)=>G(k({}, "__esModule", {
        value: !0
    }), e);
var Ue = {};
pe(Ue, {
    CheckmarkIcon: ()=>U,
    ErrorIcon: ()=>C,
    LoaderIcon: ()=>L,
    ToastBar: ()=>N,
    ToastIcon: ()=>$,
    Toaster: ()=>oe,
    default: ()=>Le,
    resolveValue: ()=>g,
    toast: ()=>i,
    useToaster: ()=>M,
    useToasterStore: ()=>w
});
module.exports = de(Ue);
var me = (e)=>typeof e == "function", g = (e, t)=>me(e) ? e(t) : e;
var J = (()=>{
    let e = 0;
    return ()=>(++e).toString();
})(), _ = (()=>{
    let e;
    return ()=>{
        if (e === void 0 && typeof window < "u") {
            let t = matchMedia("(prefers-reduced-motion: reduce)");
            e = !t || t.matches;
        }
        return e;
    };
})();
var A = require("cff97412359109c");
var le = 20, Y = "default";
var K = (e, t)=>{
    let { toastLimit: o } = e.settings;
    switch(t.type){
        case 0:
            return {
                ...e,
                toasts: [
                    t.toast,
                    ...e.toasts
                ].slice(0, o)
            };
        case 1:
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === t.toast.id ? {
                        ...r,
                        ...t.toast
                    } : r)
            };
        case 2:
            let { toast: s } = t;
            return K(e, {
                type: e.toasts.find((r)=>r.id === s.id) ? 1 : 0,
                toast: s
            });
        case 3:
            let { toastId: a } = t;
            return {
                ...e,
                toasts: e.toasts.map((r)=>r.id === a || a === void 0 ? {
                        ...r,
                        dismissed: !0,
                        visible: !1
                    } : r)
            };
        case 4:
            return t.toastId === void 0 ? {
                ...e,
                toasts: []
            } : {
                ...e,
                toasts: e.toasts.filter((r)=>r.id !== t.toastId)
            };
        case 5:
            return {
                ...e,
                pausedAt: t.time
            };
        case 6:
            let n = t.time - (e.pausedAt || 0);
            return {
                ...e,
                pausedAt: void 0,
                toasts: e.toasts.map((r)=>({
                        ...r,
                        pauseDuration: r.pauseDuration + n
                    }))
            };
    }
}, V = [], Z = {
    toasts: [],
    pausedAt: void 0,
    settings: {
        toastLimit: le
    }
}, T = {}, ee = (e, t = Y)=>{
    T[t] = K(T[t] || Z, e), V.forEach(([o, s])=>{
        o === t && s(T[t]);
    });
}, Q = (e)=>Object.keys(T).forEach((t)=>ee(e, t)), te = (e)=>Object.keys(T).find((t)=>T[t].toasts.some((o)=>o.id === e)), P = (e = Y)=>(t)=>{
        ee(t, e);
    }, ue = {
    blank: 4e3,
    error: 4e3,
    success: 2e3,
    loading: 1 / 0,
    custom: 4e3
}, w = (e = {}, t = Y)=>{
    let [o, s] = (0, A.useState)(T[t] || Z), a = (0, A.useRef)(T[t]);
    (0, A.useEffect)(()=>(a.current !== T[t] && s(T[t]), V.push([
            t,
            s
        ]), ()=>{
            let r = V.findIndex(([u])=>u === t);
            r > -1 && V.splice(r, 1);
        }), [
        t
    ]);
    let n = o.toasts.map((r)=>{
        var u, x, y;
        return {
            ...e,
            ...e[r.type],
            ...r,
            removeDelay: r.removeDelay || ((u = e[r.type]) == null ? void 0 : u.removeDelay) || (e == null ? void 0 : e.removeDelay),
            duration: r.duration || ((x = e[r.type]) == null ? void 0 : x.duration) || (e == null ? void 0 : e.duration) || ue[r.type],
            style: {
                ...e.style,
                ...(y = e[r.type]) == null ? void 0 : y.style,
                ...r.style
            }
        };
    });
    return {
        ...o,
        toasts: n
    };
};
var Te = (e, t = "blank", o)=>({
        createdAt: Date.now(),
        visible: !0,
        dismissed: !1,
        type: t,
        ariaProps: {
            role: "status",
            "aria-live": "polite"
        },
        message: e,
        pauseDuration: 0,
        ...o,
        id: (o == null ? void 0 : o.id) || J()
    }), D = (e)=>(t, o)=>{
        let s = Te(t, e, o);
        return P(s.toasterId || te(s.id))({
            type: 2,
            toast: s
        }), s.id;
    }, i = (e, t)=>D("blank")(e, t);
i.error = D("error");
i.success = D("success");
i.loading = D("loading");
i.custom = D("custom");
i.dismiss = (e, t)=>{
    let o = {
        type: 3,
        toastId: e
    };
    t ? P(t)(o) : Q(o);
};
i.dismissAll = (e)=>i.dismiss(void 0, e);
i.remove = (e, t)=>{
    let o = {
        type: 4,
        toastId: e
    };
    t ? P(t)(o) : Q(o);
};
i.removeAll = (e)=>i.remove(void 0, e);
i.promise = (e, t, o)=>{
    let s = i.loading(t.loading, {
        ...o,
        ...o == null ? void 0 : o.loading
    });
    return typeof e == "function" && (e = e()), e.then((a)=>{
        let n = t.success ? g(t.success, a) : void 0;
        return n ? i.success(n, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.success
        }) : i.dismiss(s), a;
    }).catch((a)=>{
        let n = t.error ? g(t.error, a) : void 0;
        n ? i.error(n, {
            id: s,
            ...o,
            ...o == null ? void 0 : o.error
        }) : i.dismiss(s);
    }), e;
};
var l = require("cff97412359109c");
var ye = 1e3, M = (e, t = "default")=>{
    let { toasts: o, pausedAt: s } = w(e, t), a = (0, l.useRef)(new Map).current, n = (0, l.useCallback)((c, m = ye)=>{
        if (a.has(c)) return;
        let p = setTimeout(()=>{
            a.delete(c), r({
                type: 4,
                toastId: c
            });
        }, m);
        a.set(c, p);
    }, []);
    (0, l.useEffect)(()=>{
        if (s) return;
        let c = Date.now(), m = o.map((p)=>{
            if (p.duration === 1 / 0) return;
            let I = (p.duration || 0) + p.pauseDuration - (c - p.createdAt);
            if (I < 0) {
                p.visible && i.dismiss(p.id);
                return;
            }
            return setTimeout(()=>i.dismiss(p.id, t), I);
        });
        return ()=>{
            m.forEach((p)=>p && clearTimeout(p));
        };
    }, [
        o,
        s,
        t
    ]);
    let r = (0, l.useCallback)(P(t), [
        t
    ]), u = (0, l.useCallback)(()=>{
        r({
            type: 5,
            time: Date.now()
        });
    }, [
        r
    ]), x = (0, l.useCallback)((c, m)=>{
        r({
            type: 1,
            toast: {
                id: c,
                height: m
            }
        });
    }, [
        r
    ]), y = (0, l.useCallback)(()=>{
        s && r({
            type: 6,
            time: Date.now()
        });
    }, [
        s,
        r
    ]), d = (0, l.useCallback)((c, m)=>{
        let { reverseOrder: p = !1, gutter: I = 8, defaultPosition: X } = m || {}, W = o.filter((f)=>(f.position || X) === (c.position || X) && f.height), re = W.findIndex((f)=>f.id === c.id), q = W.filter((f, H)=>H < re && f.visible).length;
        return W.filter((f)=>f.visible).slice(...p ? [
            q + 1
        ] : [
            0,
            q
        ]).reduce((f, H)=>f + (H.height || 0) + I, 0);
    }, [
        o
    ]);
    return (0, l.useEffect)(()=>{
        o.forEach((c)=>{
            if (c.dismissed) n(c.id, c.removeDelay);
            else {
                let m = a.get(c.id);
                m && (clearTimeout(m), a.delete(c.id));
            }
        });
    }, [
        o,
        n
    ]), {
        toasts: o,
        handlers: {
            updateHeight: x,
            startPause: u,
            endPause: y,
            calculateOffset: d
        }
    };
};
var h = j(require("cff97412359109c")), v = require("eb1a85e6ba4f13eb");
var S = j(require("cff97412359109c")), E = require("eb1a85e6ba4f13eb");
var R = require("eb1a85e6ba4f13eb"), ge = R.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
 transform: scale(1) rotate(45deg);
  opacity: 1;
}`, he = R.keyframes`
from {
  transform: scale(0);
  opacity: 0;
}
to {
  transform: scale(1);
  opacity: 1;
}`, xe = R.keyframes`
from {
  transform: scale(0) rotate(90deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(90deg);
	opacity: 1;
}`, C = (0, R.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#ff4b4b"};
  position: relative;
  transform: rotate(45deg);

  animation: ${ge} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;

  &:after,
  &:before {
    content: '';
    animation: ${he} 0.15s ease-out forwards;
    animation-delay: 150ms;
    position: absolute;
    border-radius: 3px;
    opacity: 0;
    background: ${(e)=>e.secondary || "#fff"};
    bottom: 9px;
    left: 4px;
    height: 2px;
    width: 12px;
  }

  &:before {
    animation: ${xe} 0.15s ease-out forwards;
    animation-delay: 180ms;
    transform: rotate(90deg);
  }
`;
var F = require("eb1a85e6ba4f13eb"), be = F.keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`, L = (0, F.styled)("div")`
  width: 12px;
  height: 12px;
  box-sizing: border-box;
  border: 2px solid;
  border-radius: 100%;
  border-color: ${(e)=>e.secondary || "#e0e0e0"};
  border-right-color: ${(e)=>e.primary || "#616161"};
  animation: ${be} 1s linear infinite;
`;
var O = require("eb1a85e6ba4f13eb"), Se = O.keyframes`
from {
  transform: scale(0) rotate(45deg);
	opacity: 0;
}
to {
  transform: scale(1) rotate(45deg);
	opacity: 1;
}`, Ae = O.keyframes`
0% {
	height: 0;
	width: 0;
	opacity: 0;
}
40% {
  height: 0;
	width: 6px;
	opacity: 1;
}
100% {
  opacity: 1;
  height: 10px;
}`, U = (0, O.styled)("div")`
  width: 20px;
  opacity: 0;
  height: 20px;
  border-radius: 10px;
  background: ${(e)=>e.primary || "#61d345"};
  position: relative;
  transform: rotate(45deg);

  animation: ${Se} 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
  animation-delay: 100ms;
  &:after {
    content: '';
    box-sizing: border-box;
    animation: ${Ae} 0.2s ease-out forwards;
    opacity: 0;
    animation-delay: 200ms;
    position: absolute;
    border-right: 2px solid;
    border-bottom: 2px solid;
    border-color: ${(e)=>e.secondary || "#fff"};
    bottom: 6px;
    left: 6px;
    height: 10px;
    width: 6px;
  }
`;
var Pe = (0, E.styled)("div")`
  position: absolute;
`, Re = (0, E.styled)("div")`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 20px;
  min-height: 20px;
`, Ee = E.keyframes`
from {
  transform: scale(0.6);
  opacity: 0.4;
}
to {
  transform: scale(1);
  opacity: 1;
}`, ve = (0, E.styled)("div")`
  position: relative;
  transform: scale(0.6);
  opacity: 0.4;
  min-width: 20px;
  animation: ${Ee} 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)
    forwards;
`, $ = ({ toast: e })=>{
    let { icon: t, type: o, iconTheme: s } = e;
    return t !== void 0 ? typeof t == "string" ? S.createElement(ve, null, t) : t : o === "blank" ? null : S.createElement(Re, null, S.createElement(L, {
        ...s
    }), o !== "loading" && S.createElement(Pe, null, o === "error" ? S.createElement(C, {
        ...s
    }) : S.createElement(U, {
        ...s
    })));
};
var De = (e)=>`
0% {transform: translate3d(0,${e * -200}%,0) scale(.6); opacity:.5;}
100% {transform: translate3d(0,0,0) scale(1); opacity:1;}
`, Oe = (e)=>`
0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}
100% {transform: translate3d(0,${e * -150}%,-1px) scale(.6); opacity:0;}
`, Ie = "0%{opacity:0;} 100%{opacity:1;}", ke = "0%{opacity:1;} 100%{opacity:0;}", _e = (0, v.styled)("div")`
  display: flex;
  align-items: center;
  background: #fff;
  color: #363636;
  line-height: 1.3;
  will-change: transform;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);
  max-width: 350px;
  pointer-events: auto;
  padding: 8px 10px;
  border-radius: 8px;
`, Ve = (0, v.styled)("div")`
  display: flex;
  justify-content: center;
  margin: 4px 10px;
  color: inherit;
  flex: 1 1 auto;
  white-space: pre-line;
`, we = (e, t)=>{
    let s = e.includes("top") ? 1 : -1, [a, n] = _() ? [
        Ie,
        ke
    ] : [
        De(s),
        Oe(s)
    ];
    return {
        animation: t ? `${(0, v.keyframes)(a)} 0.35s cubic-bezier(.21,1.02,.73,1) forwards` : `${(0, v.keyframes)(n)} 0.4s forwards cubic-bezier(.06,.71,.55,1)`
    };
}, N = h.memo(({ toast: e, position: t, style: o, children: s })=>{
    let a = e.height ? we(e.position || t || "top-center", e.visible) : {
        opacity: 0
    }, n = h.createElement($, {
        toast: e
    }), r = h.createElement(Ve, {
        ...e.ariaProps
    }, g(e.message, e));
    return h.createElement(_e, {
        className: e.className,
        style: {
            ...a,
            ...o,
            ...e.style
        }
    }, typeof s == "function" ? s({
        icon: n,
        message: r
    }) : h.createElement(h.Fragment, null, n, r));
});
var B = require("eb1a85e6ba4f13eb"), b = j(require("cff97412359109c"));
(0, B.setup)(b.createElement);
var Me = ({ id: e, className: t, style: o, onHeightUpdate: s, children: a })=>{
    let n = b.useCallback((r)=>{
        if (r) {
            let u = ()=>{
                let x = r.getBoundingClientRect().height;
                s(e, x);
            };
            u(), new MutationObserver(u).observe(r, {
                subtree: !0,
                childList: !0,
                characterData: !0
            });
        }
    }, [
        e,
        s
    ]);
    return b.createElement("div", {
        ref: n,
        className: t,
        style: o
    }, a);
}, Ce = (e, t)=>{
    let o = e.includes("top"), s = o ? {
        top: 0
    } : {
        bottom: 0
    }, a = e.includes("center") ? {
        justifyContent: "center"
    } : e.includes("right") ? {
        justifyContent: "flex-end"
    } : {};
    return {
        left: 0,
        right: 0,
        display: "flex",
        position: "absolute",
        transition: _() ? void 0 : "all 230ms cubic-bezier(.21,1.02,.73,1)",
        transform: `translateY(${t * (o ? 1 : -1)}px)`,
        ...s,
        ...a
    };
}, Fe = B.css`
  z-index: 9999;
  > * {
    pointer-events: auto;
  }
`, z = 16, oe = ({ reverseOrder: e, position: t = "top-center", toastOptions: o, gutter: s, children: a, toasterId: n, containerStyle: r, containerClassName: u })=>{
    let { toasts: x, handlers: y } = M(o, n);
    return b.createElement("div", {
        "data-rht-toaster": n || "",
        style: {
            position: "fixed",
            zIndex: 9999,
            top: z,
            left: z,
            right: z,
            bottom: z,
            pointerEvents: "none",
            ...r
        },
        className: u,
        onMouseEnter: y.startPause,
        onMouseLeave: y.endPause
    }, x.map((d)=>{
        let c = d.position || t, m = y.calculateOffset(d, {
            reverseOrder: e,
            gutter: s,
            defaultPosition: t
        }), p = Ce(c, m);
        return b.createElement(Me, {
            id: d.id,
            key: d.id,
            onHeightUpdate: y.updateHeight,
            className: d.visible ? Fe : "",
            style: p
        }, d.type === "custom" ? g(d.message, d) : a ? a(d) : b.createElement(N, {
            toast: d,
            position: c
        }));
    }));
};
var Le = i;

},{"cff97412359109c":"bmhQu","eb1a85e6ba4f13eb":"duLTU"}],"duLTU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "css", ()=>u);
parcelHelpers.export(exports, "extractCss", ()=>r);
parcelHelpers.export(exports, "glob", ()=>b);
parcelHelpers.export(exports, "keyframes", ()=>h);
parcelHelpers.export(exports, "setup", ()=>m);
parcelHelpers.export(exports, "styled", ()=>w);
let e = {
    data: ""
}, t = (t)=>{
    if ("object" == typeof window) {
        let e = (t ? t.querySelector("#_goober") : window._goober) || Object.assign(document.createElement("style"), {
            innerHTML: " ",
            id: "_goober"
        });
        return e.nonce = window.__nonce__, e.parentNode || (t || document.head).appendChild(e), e.firstChild;
    }
    return t || e;
}, r = (e)=>{
    let r = t(e), l = r.data;
    return r.data = "", l;
}, l = /(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g, a = /\/\*[^]*?\*\/|  +/g, n = /\n+/g, o = (e, t)=>{
    let r = "", l = "", a = "";
    for(let n in e){
        let c = e[n];
        "@" == n[0] ? "i" == n[1] ? r = n + " " + c + ";" : l += "f" == n[1] ? o(c, n) : n + "{" + o(c, "k" == n[1] ? "" : t) + "}" : "object" == typeof c ? l += o(c, t ? t.replace(/([^,])+/g, (e)=>n.replace(/([^,]*:\S+\([^)]*\))|([^,])+/g, (t)=>/&/.test(t) ? t.replace(/&/g, e) : e ? e + " " + t : t)) : n) : null != c && (n = /^--/.test(n) ? n : n.replace(/[A-Z]/g, "-$&").toLowerCase(), a += o.p ? o.p(n, c) : n + ":" + c + ";");
    }
    return r + (t && a ? t + "{" + a + "}" : a) + l;
}, c = {}, s = (e)=>{
    if ("object" == typeof e) {
        let t = "";
        for(let r in e)t += r + s(e[r]);
        return t;
    }
    return e;
}, i = (e, t, r, i, p)=>{
    let u = s(e), d = c[u] || (c[u] = ((e)=>{
        let t = 0, r = 11;
        for(; t < e.length;)r = 101 * r + e.charCodeAt(t++) >>> 0;
        return "go" + r;
    })(u));
    if (!c[d]) {
        let t = u !== e ? e : ((e)=>{
            let t, r, o = [
                {}
            ];
            for(; t = l.exec(e.replace(a, ""));)t[4] ? o.shift() : t[3] ? (r = t[3].replace(n, " ").trim(), o.unshift(o[0][r] = o[0][r] || {})) : o[0][t[1]] = t[2].replace(n, " ").trim();
            return o[0];
        })(e);
        c[d] = o(p ? {
            ["@keyframes " + d]: t
        } : t, r ? "" : "." + d);
    }
    let f = r && c.g ? c.g : null;
    return r && (c.g = c[d]), ((e, t, r, l)=>{
        l ? t.data = t.data.replace(l, e) : -1 === t.data.indexOf(e) && (t.data = r ? e + t.data : t.data + e);
    })(c[d], t, i, f), d;
}, p = (e, t, r)=>e.reduce((e, l, a)=>{
        let n = t[a];
        if (n && n.call) {
            let e = n(r), t = e && e.props && e.props.className || /^go/.test(e) && e;
            n = t ? "." + t : e && "object" == typeof e ? e.props ? "" : o(e, "") : !1 === e ? "" : e;
        }
        return e + l + (null == n ? "" : n);
    }, "");
function u(e) {
    let r = this || {}, l = e.call ? e(r.p) : e;
    return i(l.unshift ? l.raw ? p(l, [].slice.call(arguments, 1), r.p) : l.reduce((e, t)=>Object.assign(e, t && t.call ? t(r.p) : t), {}) : l, t(r.target), r.g, r.o, r.k);
}
let d, f, g, b = u.bind({
    g: 1
}), h = u.bind({
    k: 1
});
function m(e, t, r, l) {
    o.p = t, d = e, f = r, g = l;
}
function w(e, t) {
    let r = this || {};
    return function() {
        let l = arguments;
        function a(n, o) {
            let c = Object.assign({}, n), s = c.className || a.className;
            r.p = Object.assign({
                theme: f && f()
            }, c), r.o = / *go\d+/.test(s), c.className = u.apply(r, l) + (s ? " " + s : ""), t && (c.ref = o);
            let i = e;
            return e[0] && (i = c.as || e, delete c.as), g && i[0] && g(c), d(i, c);
        }
        return t ? t(a) : a;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ptU7W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLogoOfNotification);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLogoOfNotification = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 44,
        height: 44,
        fill: "none",
        viewBox: "0 0 44 44",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                d: "M7.586 7.586h28.859v28.859H7.586z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                d: "M33.879 0c4.771 0 7.156 0 8.639 1.482C44 2.965 44 5.35 44 10.122v23.757c0 4.771 0 7.156-1.482 8.639C41.035 44 38.65 44 33.878 44H10.122c-4.771 0-7.156 0-8.639-1.482C0 41.035 0 38.65 0 33.878V10.122C0 5.35 0 2.965 1.482 1.482 2.965 0 5.35 0 10.122 0z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                id: "a",
                width: 44,
                height: 44,
                x: 0,
                y: 0,
                maskUnits: "userSpaceOnUse",
                style: {
                    maskType: "alpha"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#342819",
                        d: "M7.586 7.586h28.859v28.859H7.586z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#342819",
                        d: "M33.879 0c4.771 0 7.156 0 8.639 1.482C44 2.965 44 5.35 44 10.122v23.757c0 4.771 0 7.156-1.482 8.639C41.035 44 38.65 44 33.878 44H10.122c-4.771 0-7.156 0-8.639-1.482C0 41.035 0 38.65 0 33.878V10.122C0 5.35 0 2.965 1.482 1.482 2.965 0 5.35 0 10.122 0z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                fill: "#04051B",
                mask: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M20.144 12.118c-2.482-.016-4.37-1.997-4.355-4.57.016-2.45 1.936-4.337 4.418-4.337 2.622 0 4.683 2.121 4.48 4.727-.187 2.34-2.201 4.196-4.543 4.18M44.824 14.35V8.5l-3.762.983-31.486 8.174-7.149 1.856c-.047.016-.609.156-.671.172-.734.234-1.436.514-2.123.842v6.177A9.2 9.2 0 0 1 2.646 25.3l.67-.171 17.624-4.57c-1.748 4.102-5.557 13.134-6.993 16.519l-.468 1.092c-1.374 3.26-4.511 5.584-8.195 5.709h11.27c.765-.796 1.624-2.34 2.17-3.681 0 0 2.7-6.38 5.136-12.121l13.159 5.522a7.01 7.01 0 0 1 3.653 4.742 6.97 6.97 0 0 1-.953 5.273c-.062.093-.109.171-.171.265h5.307V32.96a6.7 6.7 0 0 0-1.374-1.748c-.89-.81-2.107-1.56-3.028-2.074a14 14 0 0 0-.952-.5c-.266-.14-.437-.202-.437-.202-.39-.187-.734-.343-1-.468l-1.123-.484a4066 4066 0 0 1-10.834-4.617c.953-2.262 1.718-4.087 1.718-4.087z"
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"URxHu":[function() {},{}],"7kqRm":[function(require,module,exports,__globalThis) {
// Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hero", ()=>Hero);
var _jsxRuntime = require("react/jsx-runtime");
var _heroScss = require("./Hero.scss");
// React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _react1 = require("motion/react");
// Routing
var _reactRouterDom = require("react-router-dom");
// Components
var _button = require("../../components/Button/Button");
var _textAnimate = require("src/components/Animation/text-animate");
var _experience = require("../Experience/Experience");
var _clientType = require("../ClientType/ClientType");
var _offer = require("../Offer/Offer");
var _schedule = require("../Schedule/Schedule");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _seo = require("src/components/SEO");
var _seoDefault = parcelHelpers.interopDefault(_seo);
var _firebase = require("src/config/firebase");
var _useGetOnboardingState = require("src/api/mutations/useGetOnboardingState");
var _authUtils = require("src/utils/authUtils");
var _onboardingUtils = require("src/utils/onboardingUtils");
// GSAP
var _gsapSetup = require("src/utils/gsapSetup");
var _gsapSetupDefault = parcelHelpers.interopDefault(_gsapSetup);
// Store
var _sessionStore = require("src/store/sessionStore");
var _uiStore = require("src/store/uiStore");
// Assets
var _miniPtCareMp4 = require("url:../../../../assets/videos/mini-pt-care.mp4");
var _miniPtCareMp4Default = parcelHelpers.interopDefault(_miniPtCareMp4);
var _rightArrowSvg = require("../../../../assets/images/onboarding-trainer/right-arrow.svg");
var _featureProgramBuilderTransparentPng = require("url:../../../../assets/images/onboarding-trainer/landing/feature-program-builder-transparent.png");
var _featureProgramBuilderTransparentPngDefault = parcelHelpers.interopDefault(_featureProgramBuilderTransparentPng);
var _featureAssignClientsTransparentPng = require("url:../../../../assets/images/onboarding-trainer/landing/feature-assign-clients-transparent.png");
var _featureAssignClientsTransparentPngDefault = parcelHelpers.interopDefault(_featureAssignClientsTransparentPng);
var _featureAssignDashboardPng = require("url:../../../../assets/images/onboarding-trainer/landing/feature-assign-dashboard.png");
var _featureAssignDashboardPngDefault = parcelHelpers.interopDefault(_featureAssignDashboardPng);
var _featureAiCoachTransparentPng = require("url:../../../../assets/images/onboarding-trainer/landing/feature-ai-coach-transparent.png");
var _featureAiCoachTransparentPngDefault = parcelHelpers.interopDefault(_featureAiCoachTransparentPng);
var _featureWorkDashboardPng = require("url:../../../../assets/images/onboarding-trainer/landing/feature-work-dashboard.png");
var _featureWorkDashboardPngDefault = parcelHelpers.interopDefault(_featureWorkDashboardPng);
var _featureProgressSyncTransparentPng = require("url:../../../../assets/images/onboarding-trainer/landing/feature-progress-sync-transparent.png");
var _featureProgressSyncTransparentPngDefault = parcelHelpers.interopDefault(_featureProgressSyncTransparentPng);
var _featureSyncListPng = require("url:../../../../assets/images/onboarding-trainer/landing/feature-sync-list.png");
var _featureSyncListPngDefault = parcelHelpers.interopDefault(_featureSyncListPng);
var _featureSyncPerformanceSvg = require("../../../../assets/images/onboarding-trainer/landing/feature-sync-performance.svg");
var _featureGrowEarnPng = require("url:../../../../assets/images/onboarding-trainer/landing/feature-grow-earn.png");
var _featureGrowEarnPngDefault = parcelHelpers.interopDefault(_featureGrowEarnPng);
var _programBuilderSvg = require("../../../../assets/images/onboarding-trainer/landing/about-icons/program-builder.svg");
var _assignClientsSvg = require("../../../../assets/images/onboarding-trainer/landing/about-icons/assign-clients.svg");
var _clientsWorkSvg = require("../../../../assets/images/onboarding-trainer/landing/about-icons/clients-work.svg");
var _progressSyncSvg = require("../../../../assets/images/onboarding-trainer/landing/about-icons/progress-sync.svg");
var _ctaProgramsPng = require("url:../../../../assets/images/onboarding-trainer/landing/cta-programs.png");
var _ctaProgramsPngDefault = parcelHelpers.interopDefault(_ctaProgramsPng);
var _testimonialElaJpeg = require("url:../../../../assets/images/onboarding-trainer/landing/testimonials/testimonial-ela.jpeg");
var _testimonialElaJpegDefault = parcelHelpers.interopDefault(_testimonialElaJpeg);
var _testimonialAlexJpeg = require("url:../../../../assets/images/onboarding-trainer/landing/testimonials/testimonial-alex.jpeg");
var _testimonialAlexJpegDefault = parcelHelpers.interopDefault(_testimonialAlexJpeg);
var _testimonialStephJpeg = require("url:../../../../assets/images/onboarding-trainer/landing/testimonials/testimonial-steph.jpeg");
var _testimonialStephJpegDefault = parcelHelpers.interopDefault(_testimonialStephJpeg);
var _quoteIconSvg = require("../../../../assets/images/onboarding-trainer/landing/testimonials/quote-icon.svg");
var _faqExpandPng = require("url:../../../../assets/images/onboarding-trainer/landing/faq/faq-expand.png");
var _faqExpandPngDefault = parcelHelpers.interopDefault(_faqExpandPng);
var _faqCollapsePng = require("url:../../../../assets/images/onboarding-trainer/landing/faq/faq-collapse.png");
var _faqCollapsePngDefault = parcelHelpers.interopDefault(_faqCollapsePng);
var _heroPerson1Jpeg = require("url:../../../../assets/images/onboarding-trainer/landing/hero/hero-person-1.jpeg");
var _heroPerson1JpegDefault = parcelHelpers.interopDefault(_heroPerson1Jpeg);
var _heroPerson2Jpeg = require("url:../../../../assets/images/onboarding-trainer/landing/hero/hero-person-2.jpeg");
var _heroPerson2JpegDefault = parcelHelpers.interopDefault(_heroPerson2Jpeg);
var _heroPerson3Jpeg = require("url:../../../../assets/images/onboarding-trainer/landing/hero/hero-person-3.jpeg");
var _heroPerson3JpegDefault = parcelHelpers.interopDefault(_heroPerson3Jpeg);
var _heroPerson4Jpeg = require("url:../../../../assets/images/onboarding-trainer/landing/hero/hero-person-4.jpeg");
var _heroPerson4JpegDefault = parcelHelpers.interopDefault(_heroPerson4Jpeg);
var _heroPerson5Jpeg = require("url:../../../../assets/images/onboarding-trainer/landing/hero/hero-person-5.jpeg");
var _heroPerson5JpegDefault = parcelHelpers.interopDefault(_heroPerson5Jpeg);
var _heroPerson6Jpeg = require("url:../../../../assets/images/onboarding-trainer/landing/hero/hero-person-6.jpeg");
var _heroPerson6JpegDefault = parcelHelpers.interopDefault(_heroPerson6Jpeg);
var _trendUpSvg = require("../../../../assets/images/onboarding-trainer/landing/hero/trend-up.svg");
var _quoteSvg = require("../../../../assets/images/onboarding-trainer/landing/hero/quote.svg");
var _starSvg = require("../../../../assets/images/onboarding-trainer/landing/hero/star.svg");
var _laptopSvg = require("../../../../assets/images/onboarding-trainer/landing/hero/laptop.svg");
var _groupSvg = require("../../../../assets/images/onboarding-trainer/landing/hero/group.svg");
var _poundSvg = require("../../../../assets/images/onboarding-trainer/landing/hero/pound.svg");
var _impactArrowSvg = require("../../../../assets/images/onboarding-trainer/landing/hero/impact-arrow.svg");
var _sidebarAvatarJpeg = require("url:../../../../assets/images/onboarding-trainer/landing/platform/sidebar-avatar.jpeg");
var _sidebarAvatarJpegDefault = parcelHelpers.interopDefault(_sidebarAvatarJpeg);
var _manGreyBackPng = require("url:../../../../assets/images/onboarding-trainer/landing/platform/man-grey-back.png");
var _manGreyBackPngDefault = parcelHelpers.interopDefault(_manGreyBackPng);
var _manGreyFrontPng = require("url:../../../../assets/images/onboarding-trainer/landing/platform/man-grey-front.png");
var _manGreyFrontPngDefault = parcelHelpers.interopDefault(_manGreyFrontPng);
var _platformUnionSvg = require("../../../../assets/images/onboarding-trainer/landing/platform/platform-union.svg");
var _buttonSparkSvg = require("../../../../assets/images/onboarding-trainer/landing/platform/button-spark.svg");
var _navLogo1Svg = require("../../../../assets/images/onboarding-trainer/landing/platform/nav-logo-1.svg");
var _navLogo2Svg = require("../../../../assets/images/onboarding-trainer/landing/platform/nav-logo-2.svg");
var _navLogo3Svg = require("../../../../assets/images/onboarding-trainer/landing/platform/nav-logo-3.svg");
var _navLogo4Svg = require("../../../../assets/images/onboarding-trainer/landing/platform/nav-logo-4.svg");
var _navIconPlusSvg = require("../../../../assets/images/onboarding-trainer/landing/platform/nav-icon-plus.svg");
var _navIconClientsSvg = require("../../../../assets/images/onboarding-trainer/landing/platform/nav-icon-clients.svg");
var _navIconFolderSvg = require("../../../../assets/images/onboarding-trainer/landing/platform/nav-icon-folder.svg");
var _navIconMessageSvg = require("../../../../assets/images/onboarding-trainer/landing/platform/nav-icon-message.svg");
var _miniRingSvg = require("../../../../assets/images/onboarding-trainer/landing/platform/mini-ring.svg");
var _clientProfileSvg = require("../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/client_profile.svg");
var _movementInsightsSvg = require("../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/movement_insights.svg");
var _programGoalsSvg = require("../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/program_goals.svg");
var _programSummarySvg = require("../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/program_summary.svg");
var _goalApproachSvg = require("../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/goal_approach.svg");
var _injuriesNotesSvg = require("../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injuries_notes.svg");
var _planStructureSvg = require("../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/plan_structure.svg");
var _intensitySetupSvg = require("../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg");
var _weightSvg = require("../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/weight.svg");
var _barAndBenchSvg = require("../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/bar_and_bench.svg");
var _otherSvg = require("../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/other.svg");
var _painPoint0Svg = require("../../../../assets/images/onboarding-trainer/landing/platform/pain-point-0.svg");
var _painPoint1Svg = require("../../../../assets/images/onboarding-trainer/landing/platform/pain-point-1.svg");
var _painPoint2Svg = require("../../../../assets/images/onboarding-trainer/landing/platform/pain-point-2.svg");
var _painPoint3Svg = require("../../../../assets/images/onboarding-trainer/landing/platform/pain-point-3.svg");
var _painPoint4Svg = require("../../../../assets/images/onboarding-trainer/landing/platform/pain-point-4.svg");
var _painPoint5Svg = require("../../../../assets/images/onboarding-trainer/landing/platform/pain-point-5.svg");
var _painPoint6Svg = require("../../../../assets/images/onboarding-trainer/landing/platform/pain-point-6.svg");
var _donutArrowSvg = require("../../../../assets/images/onboarding-trainer/landing/platform/donut-arrow.svg");
const features = [
    {
        number: '01',
        title: 'AI Program Builder',
        copy: 'AI creates personalised programs in seconds',
        image: (0, _featureProgramBuilderTransparentPngDefault.default),
        Icon: (0, _programBuilderSvg.ReactComponent),
        animation: 'builder',
        alt: 'miniPT AI program builder laptop mockup'
    },
    {
        number: '02',
        title: 'Assign to Clients',
        copy: 'Assign the program to your entire client base in one click',
        image: (0, _featureAssignClientsTransparentPngDefault.default),
        Icon: (0, _assignClientsSvg.ReactComponent),
        animation: 'assign',
        alt: 'miniPT assign clients laptop mockup'
    },
    {
        number: '03',
        title: 'Clients do the Work',
        copy: 'Clients follow the plan in the app and record their workouts.',
        image: (0, _featureAiCoachTransparentPngDefault.default),
        Icon: (0, _clientsWorkSvg.ReactComponent),
        animation: 'work',
        alt: 'miniPT workout details laptop mockup'
    },
    {
        number: '04',
        title: 'Progress Syncs Back',
        copy: 'Performance data and videos sync back to you automatically.',
        image: (0, _featureProgressSyncTransparentPngDefault.default),
        Icon: (0, _progressSyncSvg.ReactComponent),
        animation: 'sync',
        alt: 'miniPT progress sync laptop mockup'
    }
];
// Figma 14686:60542 rows registered to the existing 1072 x 605 laptop export.
const builderFields = {
    x: 458.136,
    y: 239.052,
    width: 188.928,
    height: 34.256,
    step: 39.44656
};
// Figma ShareModal 14686:43385 in the existing 1060 x 776 laptop export.
const assignModal = {
    x: 376.425,
    y: 167.55,
    width: 299.15,
    height: 387.45
};
// Figma ShareModal 14686:70782 in the existing 1072 x 605 laptop export.
const workModal = {
    x: 382.425,
    y: 67.425,
    width: 299.15,
    height: 408.1503
};
const assignMessage = 'Hey, Emily! This new program starts today, it is designed based on your feedback last time. Let me know what you think!';
const AssignMessageAnimation = ()=>{
    const inputRef = (0, _react.useRef)(null);
    const [characterCount, setCharacterCount] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        const modal = inputRef.current?.closest('.trainer-assign-modal');
        const art = modal?.closest('.trainer-assign-art');
        if (!modal || !art) return undefined;
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        let timer;
        let started = false;
        let count = 0;
        const typeNextCharacter = ()=>{
            count += 1;
            setCharacterCount(count);
            if (count < assignMessage.length) {
                const character = assignMessage[count - 1];
                const delay = /[.!]/.test(character) ? 280 : character === ',' ? 170 : 35 + count % 5 * 12;
                timer = setTimeout(typeNextCharacter, delay);
            } else timer = setTimeout(()=>art.classList.add('trainer-assign-resetting'), 2000);
        };
        const startTyping = ()=>{
            if (started) return;
            started = true;
            timer = setTimeout(typeNextCharacter, 300);
        };
        const finishForReducedMotion = ()=>{
            if (!reducedMotion.matches) return;
            started = true;
            clearTimeout(timer);
            art.classList.remove('trainer-assign-resetting');
            setCharacterCount(assignMessage.length);
        };
        const onPopupEnd = (event)=>{
            if (event.target !== modal || reducedMotion.matches) return;
            const animationName = event.animationName;
            if (animationName === 'trainerAssignModalOut') {
                count = 0;
                started = false;
                setCharacterCount(0);
                art.classList.remove('trainer-assign-resetting');
            } else if (animationName === 'trainerAssignModalIn') startTyping();
        };
        modal.addEventListener('animationend', onPopupEnd);
        reducedMotion.addEventListener('change', finishForReducedMotion);
        finishForReducedMotion();
        // Fast Refresh can mount the text after the pop-up has already completed.
        if (modal.getAnimations().some((animation)=>animation.playState === 'finished')) startTyping();
        return ()=>{
            clearTimeout(timer);
            modal.removeEventListener('animationend', onPopupEnd);
            reducedMotion.removeEventListener('change', finishForReducedMotion);
            art.classList.remove('trainer-assign-resetting');
        };
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "trainer-assign-message",
        ref: inputRef,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "trainer-assign-message-text",
                children: [
                    characterCount === 0 ? 'Type here...' : assignMessage.slice(0, characterCount),
                    characterCount > 0 && characterCount < assignMessage.length && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "trainer-assign-typing-caret"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                className: "trainer-assign-message-count",
                children: [
                    characterCount,
                    "/200"
                ]
            })
        ]
    });
};
// Figma 14686:61620; the PNG export includes all eight rows, including clipped rows.
const syncList = {
    x: 301.25366,
    y: 445.45443,
    width: 284.21147,
    rowHeight: 34.26796,
    step: 40.46895
};
const syncExercises = [
    'Dynamic Stretching',
    'Jumping Jack',
    'High knees',
    'Flutter kicks',
    'Leg raises',
    'Plank',
    'Abs crunches',
    'Ab crunches'
];
const SyncListAnimation = ()=>{
    const viewportRef = (0, _react.useRef)(null);
    const clipId = `sync-progress-${(0, _react.useId)().replace(/:/g, '')}`;
    (0, _react.useEffect)(()=>{
        const viewport = viewportRef.current;
        const row = viewport?.closest('.trainer-feature-row');
        if (!viewport || !row) return undefined;
        const media = (0, _gsapSetupDefault.default).matchMedia();
        media.add('(prefers-reduced-motion: no-preference)', ()=>{
            const cards = Array.from(viewport.querySelectorAll('.trainer-sync-exercise'));
            const stack = viewport.querySelector('.trainer-sync-stack');
            const svg = viewport.querySelector('.trainer-sync-progress svg');
            const score = svg?.querySelector('[data-progress-label] tspan');
            const arcs = Array.from(svg?.querySelectorAll('[data-progress-art] path') ?? []).filter((path)=>path.getAttribute('fill')?.toLowerCase() === '#71be41');
            const clip = document.createElementNS('http://www.w3.org/2000/svg', 'clipPath');
            const sector = document.createElementNS('http://www.w3.org/2000/svg', 'polygon');
            clip.id = clipId;
            clip.appendChild(sector);
            svg?.appendChild(clip);
            const progress = {
                value: 0
            };
            const updateProgress = ()=>{
                if (score) score.textContent = `${Math.round(progress.value)}%`;
                // Reveal the original Figma arc from its lower endpoint; never redraw it.
                const sweep = progress.value / 86 * 290;
                const points = [
                    '63.7564,70.5435'
                ];
                for(let step = 0; step <= 64; step += 1){
                    const angle = (75 + sweep * step / 64) * Math.PI / 180;
                    points.push(`${63.7564 + 150 * Math.cos(angle)},${70.5435 + 150 * Math.sin(angle)}`);
                }
                sector.setAttribute('points', points.join(' '));
                arcs.forEach((arc)=>{
                    if (progress.value >= 86) arc.removeAttribute('clip-path');
                    else arc.setAttribute('clip-path', `url(#${clipId})`);
                });
            };
            score?.setAttribute('x', '63.7694');
            score?.setAttribute('text-anchor', 'middle');
            updateProgress();
            const stepPercent = syncList.step / syncList.rowHeight * 100;
            (0, _gsapSetupDefault.default).set(cards, {
                opacity: 0,
                yPercent: -stepPercent,
                y: 0
            });
            const timeline = (0, _gsapSetupDefault.default).timeline({
                paused: true,
                repeat: -1,
                repeatDelay: 0.65
            });
            timeline.set(cards, {
                opacity: 0,
                yPercent: -stepPercent
            });
            timeline.set(stack, {
                opacity: 1
            });
            timeline.set(progress, {
                value: 0,
                onUpdate: updateProgress
            }, 0);
            timeline.to(progress, {
                value: 86,
                duration: 3.8,
                ease: 'power1.inOut',
                onUpdate: updateProgress
            }, 0.45);
            for(let index = cards.length - 1; index >= 0; index -= 1){
                const arrival = 0.45 + (cards.length - 1 - index) * 0.65;
                timeline.to(cards[index], {
                    opacity: 1,
                    yPercent: 0,
                    duration: 0.4,
                    ease: 'power3.out'
                }, arrival);
                for(let older = index + 1; older < cards.length; older += 1)timeline.to(cards[older], {
                    yPercent: (older - index) * stepPercent,
                    duration: 0.4,
                    ease: 'power3.out'
                }, arrival);
            }
            timeline.to(stack, {
                opacity: 0,
                duration: 0.25
            }, '+=2');
            const resetProgress = ()=>{
                progress.value = 86;
                updateProgress();
                clip.remove();
            };
            if (!('IntersectionObserver' in window)) {
                timeline.play();
                return resetProgress;
            }
            const observer = new IntersectionObserver((entries)=>{
                if (entries.some((entry)=>entry.isIntersecting)) {
                    timeline.play();
                    observer.disconnect();
                }
            }, {
                rootMargin: '0px 0px -18% 0px',
                threshold: 0.35
            });
            observer.observe(row);
            return ()=>{
                observer.disconnect();
                resetProgress();
            };
        });
        return ()=>media.revert();
    }, [
        clipId
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "trainer-sync-motion",
        ref: viewportRef,
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "trainer-sync-progress",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _featureSyncPerformanceSvg.ReactComponent), {
                    viewBox: "21.7344 28.5215 85 85"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "trainer-sync-viewport",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "trainer-sync-stack",
                    children: syncExercises.map((exercise, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "trainer-sync-exercise",
                            "data-exercise": exercise,
                            style: {
                                transform: `translateY(${index * syncList.step / syncList.rowHeight * 100}%)`,
                                backgroundImage: `url(${(0, _featureSyncListPngDefault.default)})`,
                                backgroundSize: `100% ${318 / syncList.rowHeight * 100}%`,
                                backgroundPosition: `0 ${index * syncList.step / (318 - syncList.rowHeight) * 100}%`
                            }
                        }, exercise))
                })
            })
        ]
    });
};
const FeatureScreenAnimation = ({ type })=>{
    if (type === 'builder') return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "trainer-builder-glow",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "trainer-builder-fields",
                "aria-hidden": "true",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "trainer-builder-field-glow"
                    }),
                    [
                        0,
                        1,
                        2,
                        3,
                        4
                    ].map((index)=>{
                        const y = builderFields.y + index * builderFields.step;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "trainer-builder-field-face",
                            style: {
                                left: `${builderFields.x / 1072 * 100}%`,
                                top: `${y / 605 * 100}%`,
                                width: `${builderFields.width / 1072 * 100}%`,
                                height: `${builderFields.height / 605 * 100}%`,
                                backgroundImage: `url(${(0, _featureProgramBuilderTransparentPngDefault.default)})`,
                                backgroundSize: `${1072 / builderFields.width * 100}% ${605 / builderFields.height * 100}%`,
                                backgroundPosition: `${builderFields.x / (1072 - builderFields.width) * 100}% ${y / (605 - builderFields.height) * 100}%`
                            }
                        }, index);
                    })
                ]
            })
        ]
    });
    if (type === 'assign') return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "trainer-assign-display",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "trainer-assign-dashboard",
                    src: (0, _featureAssignDashboardPngDefault.default),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "trainer-assign-modal",
                "aria-hidden": "true",
                style: {
                    left: `${assignModal.x / 1060 * 100}%`,
                    top: `${assignModal.y / 776 * 100}%`,
                    width: `${assignModal.width / 1060 * 100}%`,
                    height: `${assignModal.height / 776 * 100}%`,
                    backgroundImage: `url(${(0, _featureAssignClientsTransparentPngDefault.default)})`,
                    backgroundSize: `${1060 / assignModal.width * 100}% ${776 / assignModal.height * 100}%`,
                    backgroundPosition: `${assignModal.x / (1060 - assignModal.width) * 100}% ${assignModal.y / (776 - assignModal.height) * 100}%`
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AssignMessageAnimation, {})
            })
        ]
    });
    if (type === 'work') return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "trainer-work-display",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    className: "trainer-work-dashboard",
                    src: (0, _featureWorkDashboardPngDefault.default),
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "trainer-work-modal",
                "aria-hidden": "true",
                style: {
                    left: `${workModal.x / 1072 * 100}%`,
                    top: `${workModal.y / 605 * 100}%`,
                    width: `${workModal.width / 1072 * 100}%`,
                    height: `${workModal.height / 605 * 100}%`,
                    backgroundImage: `url(${(0, _featureAiCoachTransparentPngDefault.default)})`,
                    backgroundSize: `${1072 / workModal.width * 100}% ${605 / workModal.height * 100}%`,
                    backgroundPosition: `${workModal.x / (1072 - workModal.width) * 100}% ${workModal.y / (605 - workModal.height) * 100}%`
                }
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SyncListAnimation, {});
};
const testimonials = [
    {
        quote: 'I used to spend hours building programs and chasing client updates. Now I can get a solid starting point in minutes and spend more time actually coaching.',
        name: 'Ela Morrigan',
        role: 'Online Personal Trainer',
        avatar: (0, _testimonialElaJpegDefault.default)
    },
    {
        quote: 'The biggest difference is how prepared I feel for every client. I can see their progress, what they have missed and what needs attention before we even start the check-in.',
        name: 'Alex Johnson',
        role: 'Strength & Conditioning Coach',
        avatar: (0, _testimonialAlexJpegDefault.default)
    },
    {
        quote: 'MiniPT helped me turn my in-person clients into an ongoing online service. I can support more people between sessions without adding more admin to my week.',
        name: 'Steph Savyn',
        role: 'Hybrid Fitness Coach',
        avatar: (0, _testimonialStephJpegDefault.default)
    }
];
const pricingPlans = [
    {
        title: 'Basic Plan',
        price: '\u00a30',
        suffix: '/mo',
        copy: 'Best for trainers who want a simple, organised way to manage clients and build programs manually.',
        features: [
            'Manual program creation',
            'Add and manage clients',
            'Client onboarding',
            'Trainer notes',
            'Convert sketches them into structured programs',
            'Edit workouts manually',
            'Save and manage programs'
        ]
    },
    {
        title: 'Pro Plan',
        price: '\u00a335',
        suffix: '/mo',
        copy: 'Best for trainers who want to save time with AI and track client performance more closely.',
        featured: true,
        features: [
            'All Basic Plan features',
            'AI program generation',
            'AI exercise replacement',
            'Shuffle or regenerate workouts',
            'AI-assisted program changes',
            'Client movement and exercise tracking',
            'Progress insights',
            'Advanced analytics'
        ]
    },
    {
        title: 'Gyms Plan',
        price: 'Talk to Our Team',
        copy: 'For gyms that want to give their personal trainers full access to miniPT Pro at a lower team rate.',
        features: [
            'Everything in Pro',
            'From 6 trainer accounts',
            'Reduced price per trainer',
            'Centralised subscription management',
            'Add or remove trainer seats as your team changes',
            'One monthly invoice for the gym',
            'Priority onboarding and support'
        ]
    }
];
const faqs = [
    {
        question: 'What is miniPT for trainers?',
        answer: 'miniPT is an online coaching platform that helps trainers create programs, assign workouts, manage clients, and track progress in one place. Its AI tools reduce repetitive planning work while keeping the trainer in control of every program.'
    },
    {
        question: 'Does AI replace the trainer?',
        answer: 'No. AI creates a strong starting point and handles repetitive admin, while you review, adjust and coach each client.'
    },
    {
        question: 'Can I create workouts manually?',
        answer: 'Yes. You can build programs manually, edit AI-generated workouts, and save templates for later.'
    },
    {
        question: 'What information does the AI use to create a program?',
        answer: 'It uses the client profile, goals, experience level, schedule, equipment, injuries and notes you provide.'
    },
    {
        question: 'Can clients complete workouts without me being there?',
        answer: 'Yes. Clients can follow assigned workouts remotely and keep their progress synced back to you.'
    },
    {
        question: 'What client progress can I track?',
        answer: 'You can track completed sessions, missed workouts, movement notes, progress trends and program adherence.'
    },
    {
        question: 'Can I make changes after assigning a workout?',
        answer: "Yes. Adjust workouts whenever a client's needs change."
    },
    {
        question: 'Is there a free plan?',
        answer: 'Yes. The Basic Plan is free and supports manual program creation and client management.'
    },
    {
        question: 'What is included in the Pro trial?',
        answer: 'The Pro trial includes AI program generation, AI-assisted changes, progress insights and advanced tracking features.'
    }
];
const AnimatedNumber = ({ target, prefix = '', suffix = '', delay = 0, duration = 1400 })=>{
    const [value, setValue] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
            setValue(target);
            return undefined;
        }
        let frameId = 0;
        const timeoutId = window.setTimeout(()=>{
            const start = performance.now();
            const tick = (now)=>{
                const progress = Math.min(1, (now - start) / duration);
                const eased = 1 - Math.pow(1 - progress, 3);
                setValue(Math.round(target * eased));
                if (progress < 1) frameId = window.requestAnimationFrame(tick);
            };
            frameId = window.requestAnimationFrame(tick);
        }, delay);
        return ()=>{
            window.clearTimeout(timeoutId);
            window.cancelAnimationFrame(frameId);
        };
    }, [
        delay,
        duration,
        target
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            prefix,
            value.toLocaleString('en-GB'),
            suffix
        ]
    });
};
const platformTourCards = [
    'client',
    'movement',
    'goals',
    'summary',
    'approach',
    'injuries',
    'plan',
    'intensity'
];
const PlatformIconShell = ({ children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "trainer-platform-icon",
        children: children
    });
const PlatformDots = ({ active = 3, total = 5 })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "trainer-platform-dots",
        children: Array.from({
            length: total
        }).map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                className: index < active ? 'is-on' : ''
            }, index))
    });
const PlatformBars = ({ heights })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: "trainer-platform-bars",
        children: heights.map((height, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                style: {
                    height: `${height}%`
                }
            }, `${height}-${index}`))
    });
const PlatformCard = ({ id, activeId, className = '', children })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("article", {
        className: `trainer-platform-card trainer-platform-card-${id} ${activeId === id ? 'is-spotlight' : activeId ? 'is-dimmed' : ''} ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "trainer-platform-card-float",
            children: children
        })
    });
const TrainerPlatformDemo = ({ isActive })=>{
    const [activeCardIndex, setActiveCardIndex] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        if (!isActive) {
            setActiveCardIndex(null);
            return undefined;
        }
        const startTimer = window.setTimeout(()=>{
            setActiveCardIndex(0);
        }, 3300);
        const interval = window.setInterval(()=>{
            setActiveCardIndex((current)=>{
                if (current === null) return 0;
                return (current + 1) % platformTourCards.length;
            });
        }, 2900);
        return ()=>{
            window.clearTimeout(startTimer);
            window.clearInterval(interval);
        };
    }, [
        isActive
    ]);
    const activeId = activeCardIndex === null ? null : platformTourCards[activeCardIndex % platformTourCards.length];
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "trainer-platform-stage",
        "aria-label": "miniPT trainer program review platform",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _platformUnionSvg.ReactComponent), {
                className: "trainer-platform-union",
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "trainer-platform-shell",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("aside", {
                        className: "trainer-platform-sidebar",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "trainer-platform-logo",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navLogo1Svg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navLogo2Svg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navLogo3Svg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navLogo4Svg.ReactComponent), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "trainer-platform-nav-main",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navIconPlusSvg.ReactComponent), {})
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "trainer-platform-nav-list",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navIconClientsSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navIconFolderSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navIconMessageSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "trainer-platform-avatar",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: (0, _sidebarAvatarJpegDefault.default),
                                    alt: ""
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "trainer-platform-main",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "trainer-platform-top",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "trainer-platform-ring",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miniRingSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "miniPT"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "trainer-platform-title",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                children: "Review the program before we create it"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Tap any card to adjust details before generating the program"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "trainer-platform-cards",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PlatformCard, {
                                        id: "client",
                                        activeId: activeId,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-card-head",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformIconShell, {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientProfileSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Client Profile"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "trainer-platform-row",
                                                children: "Advanced"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            "Energy: ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Fluctuates"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformBars, {
                                                        heights: [
                                                            42,
                                                            58,
                                                            70,
                                                            92,
                                                            76,
                                                            88,
                                                            82,
                                                            86
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            "Activity: ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Lightly Active"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformDots, {
                                                        active: 3,
                                                        total: 6
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PlatformCard, {
                                        id: "movement",
                                        activeId: activeId,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-card-head",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformIconShell, {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movementInsightsSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Movement Insights"
                                                    })
                                                ]
                                            }),
                                            [
                                                [
                                                    'Mobility',
                                                    'Good',
                                                    3
                                                ],
                                                [
                                                    'Stability',
                                                    'Limited',
                                                    2
                                                ],
                                                [
                                                    'Balance',
                                                    'Good',
                                                    3
                                                ],
                                                [
                                                    'Movement Symmetry',
                                                    'Good',
                                                    3
                                                ],
                                                [
                                                    'Movement Quality',
                                                    'Good',
                                                    3
                                                ]
                                            ].map(([label, value, dots])=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "trainer-platform-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            children: [
                                                                label,
                                                                ": ",
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                    children: value
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformDots, {
                                                            active: Number(dots),
                                                            total: 3
                                                        })
                                                    ]
                                                }, label))
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PlatformCard, {
                                        id: "goals",
                                        activeId: activeId,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-card-head",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformIconShell, {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programGoalsSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Program Goals"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-goals-body",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "trainer-platform-orange",
                                                                children: "\u2022 Build Muscle"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                children: [
                                                                    "Priority: ",
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                        children: "Core, Back, Glutes"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                    children: "\u2022 Secondary Support:"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                children: "Mobility, Injury Prevention"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "trainer-platform-donut",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                className: "trainer-platform-donut-ring",
                                                                viewBox: "0 0 72 72",
                                                                "aria-hidden": "true",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                        className: "trainer-platform-donut-track",
                                                                        cx: "36",
                                                                        cy: "36",
                                                                        r: "29"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                        className: "trainer-platform-donut-progress",
                                                                        cx: "36",
                                                                        cy: "36",
                                                                        r: "29"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _donutArrowSvg.ReactComponent), {
                                                                className: "trainer-platform-donut-arrow"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: "85%"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                                                children: "15%"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PlatformCard, {
                                        id: "summary",
                                        activeId: activeId,
                                        className: "is-default-focus",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-card-head",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformIconShell, {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programSummarySvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Alvin Bennett\xa0\xa0\u2022\xa0\xa0Program Summary"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "trainer-platform-summary-copy",
                                                children: "5-week muscle-building program for an advanced client, focused on core, back and glutes, adapted for back and shoulder limitations."
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-tags",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "5 Weeks"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "3 Days / Week"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "45 min"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                className: "trainer-platform-ai-button",
                                                type: "button",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonSparkSvg.ReactComponent), {}),
                                                    "Generate with miniPT AI"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PlatformCard, {
                                        id: "approach",
                                        activeId: activeId,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-card-head",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformIconShell, {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _goalApproachSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Goal Approach"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-two-col",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                children: "Full-Body"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                children: "Hypertrophy"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformBars, {
                                                        heights: [
                                                            36,
                                                            48,
                                                            70,
                                                            58,
                                                            76,
                                                            44,
                                                            34,
                                                            62,
                                                            78,
                                                            56
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PlatformCard, {
                                        id: "injuries",
                                        activeId: activeId,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-card-head",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformIconShell, {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _injuriesNotesSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Injuries & Notes"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-injuries-body",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "trainer-platform-red",
                                                                children: "Back, Shoulders"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                children: "Avoid overhead press"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                children: "No jumping"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "trainer-platform-body-stack",
                                                        "aria-hidden": "true",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "trainer-platform-body-card trainer-platform-body-card-back",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: (0, _manGreyBackPngDefault.default),
                                                                        alt: ""
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _painPoint0Svg.ReactComponent), {
                                                                        className: "pain pain-0"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _painPoint1Svg.ReactComponent), {
                                                                        className: "pain pain-1"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _painPoint2Svg.ReactComponent), {
                                                                        className: "pain pain-2"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "trainer-platform-body-card trainer-platform-body-card-front",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: (0, _manGreyFrontPngDefault.default),
                                                                        alt: ""
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _painPoint3Svg.ReactComponent), {
                                                                        className: "pain pain-3"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _painPoint4Svg.ReactComponent), {
                                                                        className: "pain pain-4"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _painPoint5Svg.ReactComponent), {
                                                                        className: "pain pain-5"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _painPoint6Svg.ReactComponent), {
                                                                        className: "pain pain-6"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PlatformCard, {
                                        id: "plan",
                                        activeId: activeId,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-card-head",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformIconShell, {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planStructureSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Plan Structure"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-plan-body",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                children: "3 Days / Week"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                children: "Evening reminder"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "trainer-platform-calendar",
                                                        "aria-hidden": "true",
                                                        children: [
                                                            [
                                                                'M',
                                                                'T',
                                                                'W',
                                                                'T',
                                                                'F',
                                                                'S',
                                                                'S'
                                                            ].map((day, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: day
                                                                }, `${day}-${index}`)),
                                                            Array.from({
                                                                length: 14
                                                            }).map((_, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("i", {
                                                                    className: [
                                                                        0,
                                                                        2,
                                                                        4
                                                                    ].includes(index) ? 'is-on' : ''
                                                                }, index))
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(PlatformCard, {
                                        id: "intensity",
                                        activeId: activeId,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-card-head",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformIconShell, {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _intensitySetupSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: "Intensity & Setup"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            "Intensity: ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: "Balanced"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(PlatformDots, {
                                                        active: 3,
                                                        total: 6
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "Dumbbells"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "trainer-platform-equipment-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _weightSvg.ReactComponent), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "Machines & Cables"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "trainer-platform-equipment-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _barAndBenchSvg.ReactComponent), {})
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-platform-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "Other +2"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "trainer-platform-equipment-icon",
                                                        "aria-hidden": "true",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _otherSvg.ReactComponent), {})
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
const Step6AIHelp = ({ onComplete })=>{
    const [index, setIndex] = (0, _react.useState)(0);
    const AI_HELP_TEXTS = [
        'Automates check-ins, personalises\nsubstitutions, accelerates prog refresh',
        'Streamlines program creation,\nsuggests progression paths & client\nmessaging',
        'Accelerates programme creation,\nauto-adjustments & client follow-ups'
    ];
    (0, _react.useEffect)(()=>{
        const interval = setInterval(()=>{
            setIndex((prev)=>{
                if (prev >= AI_HELP_TEXTS.length - 1) {
                    clearInterval(interval);
                    return prev;
                }
                return prev + 1;
            });
        }, 4000);
        return ()=>clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "animation-content max-width-768 step6-ai-help-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                style: {
                    fontSize: '18px',
                    color: 'var(--auth-text-muted)',
                    marginBottom: '20px',
                    fontWeight: 400,
                    padding: '0 20px'
                },
                children: "Based on your profile, miniPT AI will help with"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    minHeight: '160px',
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'center',
                    width: '100%',
                    padding: '0 20px'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.AnimatePresence), {
                    mode: "wait",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.motion).div, {
                        initial: {
                            opacity: 0,
                            y: 15
                        },
                        animate: {
                            opacity: 1,
                            y: 0
                        },
                        exit: {
                            opacity: 0,
                            y: -15
                        },
                        transition: {
                            duration: 0.5,
                            ease: 'easeInOut'
                        },
                        style: {
                            textAlign: 'center'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "page-intro-title mt-0",
                            style: {
                                fontSize: '32px',
                                lineHeight: '1.4',
                                whiteSpace: 'pre-wrap',
                                fontWeight: 600
                            },
                            children: AI_HELP_TEXTS[index]
                        })
                    }, index)
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                variant: "primary",
                className: "btn-primary-white",
                onClick: onComplete,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    style: {
                        color: '#000',
                        fontWeight: 'bold'
                    },
                    children: "Great, let's go!"
                })
            })
        ]
    });
};
const Hero = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const isResuming = searchParams.get('resume') === 'true';
    const [step, setStep] = (0, _react.useState)(1);
    const [openFaqIndex, setOpenFaqIndex] = (0, _react.useState)(0);
    const [activePricingIndex, setActivePricingIndex] = (0, _react.useState)(null);
    const [isDemoInView, setIsDemoInView] = (0, _react.useState)(false);
    const landingPageRef = (0, _react.useRef)(null);
    const demoSectionRef = (0, _react.useRef)(null);
    const videoContainerRef = (0, _react.useRef)(null);
    const videoTextRef = (0, _react.useRef)(null);
    const videoRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const video = videoRef.current;
        if (video) {
            video.muted = true;
            video.defaultMuted = true;
            const playPromise = video.play();
            if (playPromise !== undefined) playPromise.catch(()=>{});
        }
    }, [
        step
    ]);
    const isLoggedIn = (0, _sessionStore.sessionStore)((s)=>s.isLoggedIn);
    const token = (0, _sessionStore.sessionStore)((s)=>s.token);
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const hasSignedUp = (0, _uiStore.uiStore)((s)=>s.hasSignedUp);
    const userId = (0, _authUtils.getUserIdFromToken)(token) || (0, _firebase.auth).currentUser?.uid || currentUser?.uid;
    const { data, isLoading } = (0, _useGetOnboardingState.useGetOnboardingState)(userId || undefined);
    const onboardingState = data?.onboarding;
    const profile = data?.profile;
    const firstName = profile?.name ? profile.name.split(' ')[0] : 'Trainer';
    (0, _react.useEffect)(()=>{
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [
        step
    ]);
    (0, _react.useEffect)(()=>{
        const headerEl = document.getElementById('floating-header');
        if (headerEl) {
            if (step >= 2) headerEl.style.display = 'none';
            else headerEl.style.display = '';
        }
        return ()=>{
            const el = document.getElementById('floating-header');
            if (el) el.style.display = '';
        };
    }, [
        step
    ]);
    (0, _react.useEffect)(()=>{
        const demoSection = demoSectionRef.current;
        if (!demoSection || !('IntersectionObserver' in window)) {
            setIsDemoInView(true);
            return undefined;
        }
        const observer = new IntersectionObserver(([entry])=>{
            if (entry.isIntersecting) {
                setIsDemoInView(true);
                observer.disconnect();
            }
        }, {
            threshold: 0.25
        });
        observer.observe(demoSection);
        return ()=>observer.disconnect();
    }, []);
    (0, _react.useEffect)(()=>{
        const featureRows = landingPageRef.current?.querySelectorAll('.trainer-feature-row[data-feature-animation]');
        if (!featureRows?.length) return undefined;
        if (!('IntersectionObserver' in window)) {
            featureRows.forEach((row)=>row.classList.add('trainer-feature-row-active'));
            return undefined;
        }
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    entry.target.classList.add('trainer-feature-row-active');
                    observer.unobserve(entry.target);
                }
            });
        }, {
            rootMargin: '0px 0px -18% 0px',
            threshold: 0.35
        });
        featureRows.forEach((row)=>observer.observe(row));
        return ()=>observer.disconnect();
    }, []);
    const handleGetStarted = ()=>{
        if (!isLoggedIn) {
            if (hasSignedUp) navigate('/onboarding-trainer/login');
            else navigate('/onboarding-trainer/signup');
            return;
        }
        if (step === 2 || step > 2) return;
        const tl = (0, _gsapSetupDefault.default).timeline({
            onComplete: ()=>{
                setStep(2);
            }
        });
        tl.to(landingPageRef.current, {
            y: -30,
            opacity: 0,
            duration: 0.5,
            ease: 'power2.inOut',
            onComplete: ()=>{
                if (landingPageRef.current) (0, _gsapSetupDefault.default).set(landingPageRef.current, {
                    display: 'none'
                });
            }
        }, 0);
        const isMobile = window.innerWidth < 768;
        tl.to(videoContainerRef.current, {
            yPercent: -50,
            xPercent: -50,
            y: isMobile ? -80 : -90,
            scale: 1,
            width: isMobile ? 160 : 240,
            height: isMobile ? 160 : 240,
            opacity: 1,
            duration: 1.5,
            ease: 'power3.inOut'
        }, 0.2);
        tl.to(videoTextRef.current, {
            opacity: 1,
            duration: 0.5,
            ease: 'power2.out'
        }, 1.2);
    };
    const scrollToDemo = ()=>{
        document.getElementById('trainer-demo')?.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    };
    (0, _react.useEffect)(()=>{
        if (videoContainerRef.current && step === 1) {
            (0, _gsapSetupDefault.default).set(videoContainerRef.current, {
                xPercent: -50,
                yPercent: -50,
                y: '70vh',
                scale: 4,
                opacity: 0
            });
            if (window.innerWidth < 576) (0, _gsapSetupDefault.default).set(videoContainerRef.current, {
                width: 150,
                height: 150,
                top: '40%'
            });
        }
        if (videoTextRef.current && step === 1) (0, _gsapSetupDefault.default).set(videoTextRef.current, {
            opacity: 0
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, _react.useEffect)(()=>{
        if (isLoggedIn && !isLoading && step === 1 && videoContainerRef.current && landingPageRef.current) {
            const activeOnboarding = onboardingState ?? profile?.onboarding ?? currentUser?.onboarding;
            const progress = (0, _onboardingUtils.computeOnboardingProgress)(activeOnboarding);
            // If truly completed all 4 steps:
            if (progress.isFullyCompleted) {
                navigate('/onboarding-trainer/dashboard', {
                    replace: true
                });
                return;
            }
            // If skipped and not explicitly resuming via banner, go to dashboard:
            if (progress.isSkipped && !isResuming) {
                navigate('/onboarding-trainer/dashboard', {
                    replace: true
                });
                return;
            }
            const isMobile = window.innerWidth < 768;
            const prepareVideoForStep = ()=>{
                (0, _gsapSetupDefault.default).set(landingPageRef.current, {
                    display: 'none'
                });
                (0, _gsapSetupDefault.default).set(videoContainerRef.current, {
                    top: isMobile ? '16px' : '40px',
                    left: '50%',
                    y: 0,
                    yPercent: 0,
                    xPercent: -50,
                    scale: 1,
                    width: isMobile ? 130 : 200,
                    height: isMobile ? 130 : 200,
                    opacity: 1
                });
                if (videoTextRef.current) (0, _gsapSetupDefault.default).set(videoTextRef.current, {
                    opacity: 1
                });
            };
            if (isResuming || progress.completedStepsCount > 0) {
                prepareVideoForStep();
                setStep(progress.nextHeroWizardStep);
            } else {
                // Brand new logged-in trainer (0 steps completed, not skipped, not resuming):
                // Automatically start the onboarding flow without showing landing page
                (0, _gsapSetupDefault.default).set(landingPageRef.current, {
                    display: 'none'
                });
                setStep(2);
            }
        }
    }, [
        isLoggedIn,
        isLoading,
        navigate,
        onboardingState,
        profile,
        step,
        currentUser,
        isResuming
    ]);
    (0, _react.useEffect)(()=>{
        if (step === 2) {
            if (videoContainerRef.current) {
                const isMobile = window.innerWidth < 768;
                (0, _gsapSetupDefault.default).set(videoContainerRef.current, {
                    top: '50%',
                    left: '50%',
                    xPercent: -50,
                    yPercent: -50,
                    y: isMobile ? -80 : -90,
                    scale: 1,
                    width: isMobile ? 160 : 240,
                    height: isMobile ? 160 : 240,
                    opacity: 1
                });
            }
            if (videoTextRef.current) (0, _gsapSetupDefault.default).set(videoTextRef.current, {
                opacity: 1
            });
            if (videoRef.current) {
                videoRef.current.currentTime = 0;
                videoRef.current.play().catch(()=>{});
            }
        } else if (step >= 3 && videoContainerRef.current) {
            const isMobile = window.innerWidth < 768;
            (0, _gsapSetupDefault.default).set(videoContainerRef.current, {
                top: isMobile ? '16px' : '40px',
                left: '50%',
                y: 0,
                yPercent: 0,
                xPercent: -50,
                scale: 1,
                width: isMobile ? 130 : 200,
                height: isMobile ? 130 : 200,
                opacity: 1
            });
            if (videoTextRef.current) (0, _gsapSetupDefault.default).set(videoTextRef.current, {
                opacity: 1
            });
        }
    }, [
        step
    ]);
    (0, _react.useEffect)(()=>{
        const handleResize = ()=>{
            if (step >= 3 && videoContainerRef.current) {
                const isMobile = window.innerWidth < 768;
                (0, _gsapSetupDefault.default).set(videoContainerRef.current, {
                    top: isMobile ? '16px' : '40px',
                    left: '50%',
                    y: 0,
                    yPercent: 0,
                    xPercent: -50,
                    scale: 1,
                    width: isMobile ? 130 : 200,
                    height: isMobile ? 130 : 200,
                    opacity: 1
                });
            }
        };
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, [
        step
    ]);
    // While checking session state for a logged-in user on initial mount, prevent flashing Step 1
    if (isLoggedIn && step === 1 && (isLoading || currentUser && !onboardingState && (currentUser.experience !== undefined || currentUser.expertise))) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "onboarding-hero",
        style: {
            height: '100vh',
            backgroundColor: '#060723',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
            indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                style: {
                    fontSize: 32,
                    color: '#F59E0B'
                },
                spin: true
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seoDefault.default), {
                title: "Become a miniPT Trainer",
                description: "Join the miniPT platform and take your personal training business to the next level.",
                canonicalUrl: "/onboarding-trainer"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `onboarding-hero ${step === 2 ? 'step-2-active' : ''} ${step >= 3 ? 'step-3-active' : ''}`,
                children: [
                    step === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "trainer-landing-page",
                        ref: landingPageRef,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                className: "trainer-hero",
                                id: "trainers",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "trainer-landing-container trainer-hero-grid",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "trainer-hero-copy",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                    className: "trainer-eyebrow",
                                                    children: [
                                                        "Build for trainer. ",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                            children: "Powered by AI"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                    children: "Turn online coaching into recurring revenue"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "trainer-lead",
                                                    children: "Create programs with AI, assign them remotely and track automatically, so you can help more clients and earn more, every month."
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "trainer-actions",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                            variant: "primary",
                                                            onClick: handleGetStarted,
                                                            svg: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rightArrowSvg.ReactComponent), {}),
                                                            className: "trainer-button trainer-button-primary right-arrow",
                                                            children: "Get Started"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                            variant: "secondary",
                                                            onClick: scrollToDemo,
                                                            className: "trainer-button trainer-button-dark",
                                                            children: "Try Demo"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "trainer-hero-visual",
                                            "aria-label": "miniPT trainer business dashboard preview",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-hero-card-cluster",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("article", {
                                                        className: "trainer-hero-animated-card trainer-revenue-card",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "trainer-hero-card-float",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "trainer-card-label",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "trainer-card-icon",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trendUpSvg.ReactComponent), {})
                                                                        }),
                                                                        "Monthly online revenue"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "trainer-card-value",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnimatedNumber, {
                                                                        target: 4860,
                                                                        prefix: "\xa3",
                                                                        delay: 1500,
                                                                        duration: 1600
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "trainer-card-delta",
                                                                    children: [
                                                                        "\u2191 ",
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnimatedNumber, {
                                                                            target: 24,
                                                                            delay: 1500,
                                                                            duration: 1600
                                                                        }),
                                                                        "% vs last month"
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                    className: "trainer-spark",
                                                                    viewBox: "0 0 220 46",
                                                                    "aria-hidden": "true",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                                                                                id: "trainerSparkFill",
                                                                                x1: "0",
                                                                                y1: "0",
                                                                                x2: "0",
                                                                                y2: "1",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                                                        offset: "0%",
                                                                                        stopColor: "#ffa100",
                                                                                        stopOpacity: "0.45"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                                                                        offset: "100%",
                                                                                        stopColor: "#ffa100",
                                                                                        stopOpacity: "0"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                            className: "trainer-spark-fill",
                                                                            d: "M0,34 L20,30 L45,33 L70,20 L95,24 L120,14 L145,18 L170,8 L195,12 L220,4 L220,46 L0,46 Z"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                            className: "trainer-spark-line",
                                                                            d: "M0,34 L20,30 L45,33 L70,20 L95,24 L120,14 L145,18 L170,8 L195,12 L220,4"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("article", {
                                                        className: "trainer-hero-animated-card trainer-review-card",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "trainer-hero-card-float",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "trainer-quote-mark",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quoteSvg.ReactComponent), {})
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                    children: "I added online clients without adding more gym hours."
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "trainer-hero-divider"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "trainer-hero-person",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "trainer-hero-avatar",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                src: (0, _heroPerson1JpegDefault.default),
                                                                                alt: ""
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "trainer-hero-person-name",
                                                                                    children: "John Trainer"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "trainer-hero-person-role",
                                                                                    children: "Strength Coach"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            className: "trainer-stars",
                                                                            "aria-label": "5.0 rating",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _starSvg.ReactComponent), {}),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    children: "5.0"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("article", {
                                                        className: "trainer-hero-animated-card trainer-clients-card",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "trainer-hero-card-float",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "trainer-clients-heading",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "trainer-clients-icon",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _groupSvg.ReactComponent), {})
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    children: "Active remote clients"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnimatedNumber, {
                                                                                        target: 18,
                                                                                        delay: 1750,
                                                                                        duration: 1100
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "trainer-card-delta trainer-clients-delta",
                                                                    children: "\u2191 3 this month"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "trainer-avatar-stack",
                                                                    children: [
                                                                        [
                                                                            (0, _heroPerson2JpegDefault.default),
                                                                            (0, _heroPerson3JpegDefault.default),
                                                                            (0, _heroPerson4JpegDefault.default),
                                                                            (0, _heroPerson5JpegDefault.default),
                                                                            (0, _heroPerson6JpegDefault.default)
                                                                        ].map((avatar)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "trainer-hero-avatar",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                    src: avatar,
                                                                                    alt: ""
                                                                                })
                                                                            }, avatar)),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "trainer-avatar-more",
                                                                            children: "+8"
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("article", {
                                                        className: "trainer-hero-animated-card trainer-sarah-card",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "trainer-hero-card-float",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "trainer-hero-person",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "trainer-hero-avatar",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                src: (0, _heroPerson2JpegDefault.default),
                                                                                alt: ""
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "trainer-hero-person-name",
                                                                                    children: "Sarah Mitchell"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                    className: "trainer-hero-person-role",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                            className: "trainer-online-dot"
                                                                                        }),
                                                                                        " Online"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "trainer-mini-pills",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "trainer-mini-icon",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _laptopSvg.ReactComponent), {})
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnimatedNumber, {
                                                                                    target: 12,
                                                                                    delay: 1900,
                                                                                    duration: 900
                                                                                }),
                                                                                " online sessions"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "trainer-mini-icon",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _poundSvg.ReactComponent), {})
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnimatedNumber, {
                                                                                    target: 240,
                                                                                    prefix: "\xa3",
                                                                                    delay: 2000,
                                                                                    duration: 1000
                                                                                }),
                                                                                "/month"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("article", {
                                                        className: "trainer-hero-animated-card trainer-impact-card",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "trainer-hero-card-float",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "trainer-impact-icon",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _poundSvg.ReactComponent), {})
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                            children: "More clients. More impact"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            children: "Build recurring income on your terms."
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _impactArrowSvg.ReactComponent), {
                                                                    className: "trainer-impact-arrow"
                                                                })
                                                            ]
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("article", {
                                                        className: "trainer-hero-animated-card trainer-tom-card",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "trainer-hero-card-float",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "trainer-hero-person",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "trainer-hero-avatar",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                src: (0, _heroPerson3JpegDefault.default),
                                                                                alt: ""
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "trainer-hero-person-name",
                                                                                    children: "Tom Edwards"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                    className: "trainer-hero-person-role",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                            className: "trainer-hybrid-dot"
                                                                                        }),
                                                                                        " Hybrid"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "trainer-mini-pills",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "trainer-mini-icon",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _laptopSvg.ReactComponent), {})
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnimatedNumber, {
                                                                                    target: 4,
                                                                                    delay: 2200,
                                                                                    duration: 700
                                                                                }),
                                                                                " of 5 sessions done"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "trainer-mini-icon",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _poundSvg.ReactComponent), {})
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(AnimatedNumber, {
                                                                                    target: 180,
                                                                                    prefix: "\xa3",
                                                                                    delay: 2300,
                                                                                    duration: 900
                                                                                }),
                                                                                "package"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                className: `trainer-section trainer-demo-section ${isDemoInView ? 'trainer-demo-section-active' : ''}`,
                                id: "trainer-demo",
                                ref: demoSectionRef,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "trainer-landing-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            children: "Try it for yourself"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(TrainerPlatformDemo, {
                                            isActive: isDemoInView
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "trainer-section-actions",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                variant: "primary",
                                                onClick: handleGetStarted,
                                                svg: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rightArrowSvg.ReactComponent), {}),
                                                className: "trainer-button trainer-button-primary right-arrow",
                                                children: "Get Started"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                className: "trainer-section trainer-steps",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "trainer-landing-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            children: "Create once. Coach anywhere and Earn more."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "trainer-section-copy",
                                            children: "Scale your personal training business with AI program creation, remote client tracking and automated insights."
                                        }),
                                        features.map((feature)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-feature-row",
                                                "data-feature-animation": feature.animation,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "trainer-feature-copy",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "trainer-step-no",
                                                                children: feature.number
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "trainer-feature-title",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "trainer-feature-icon",
                                                                        "aria-hidden": "true",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(feature.Icon, {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                        children: feature.title
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                children: feature.copy
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "trainer-feature-image",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: `trainer-feature-art trainer-${feature.animation}-art`,
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    src: feature.image,
                                                                    alt: feature.alt
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(FeatureScreenAnimation, {
                                                                    type: feature.animation
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }, feature.number))
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                className: "trainer-section trainer-soft-media-section",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "trainer-landing-container",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                        className: "trainer-wide-art",
                                        src: (0, _featureGrowEarnPngDefault.default),
                                        alt: "Trainer using miniPT to grow and earn more"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                className: "trainer-section",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "trainer-landing-container",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "trainer-growth-card",
                                        style: {
                                            backgroundImage: `url(${(0, _ctaProgramsPngDefault.default)})`
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                    children: "Spend less time building plans. More time being their coach."
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    children: "Create personalised programs, support clients between sessions and grow your coaching without losing the personal connection."
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "trainer-actions",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                            variant: "secondary",
                                                            onClick: handleGetStarted,
                                                            className: "trainer-button trainer-button-dark",
                                                            children: "Get Started"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                            variant: "light",
                                                            onClick: scrollToDemo,
                                                            className: "trainer-button trainer-button-light",
                                                            children: "Try Demo"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                className: "trainer-section trainer-testimonials-section",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "trainer-landing-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            children: "An \u201CINDISPENSABLE\u201D tool"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "trainer-testimonials",
                                            children: testimonials.map((testimonial)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
                                                    className: "trainer-testimonial",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "trainer-icon-box",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quoteIconSvg.ReactComponent), {})
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            children: testimonial.quote
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "trainer-person-row",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "trainer-avatar",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                        src: testimonial.avatar,
                                                                        alt: ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "trainer-person-name",
                                                                            children: testimonial.name
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "trainer-person-role",
                                                                            children: testimonial.role
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, testimonial.name))
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                className: "trainer-section trainer-pricing-section",
                                id: "trainer-pricing",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "trainer-landing-container",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            children: "Pricing"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "trainer-section-copy",
                                            children: "Choose the plan that fits your fitness journey."
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "trainer-pricing-grid",
                                            onMouseLeave: ()=>setActivePricingIndex(null),
                                            children: pricingPlans.map((plan, index)=>{
                                                const isActivePricingCard = activePricingIndex === index;
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
                                                    className: `trainer-price-card ${isActivePricingCard ? 'featured' : ''}`,
                                                    onMouseEnter: ()=>setActivePricingIndex(index),
                                                    onTouchStart: ()=>setActivePricingIndex(index),
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                            children: plan.title
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: `trainer-price ${plan.suffix ? '' : 'trainer-price-pill'}`,
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: plan.price
                                                                }),
                                                                plan.suffix && /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                                                    children: plan.suffix
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            children: plan.copy
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                                            className: "trainer-check-list",
                                                            children: plan.features.map((feature)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("li", {
                                                                    children: feature
                                                                }, feature))
                                                        })
                                                    ]
                                                }, plan.title);
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "trainer-price-action",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                variant: "primary",
                                                onClick: handleGetStarted,
                                                svg: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rightArrowSvg.ReactComponent), {}),
                                                className: "trainer-button trainer-button-primary right-arrow w-100",
                                                children: "Get Started"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("section", {
                                className: "trainer-section trainer-faq-section",
                                id: "trainer-faq",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "trainer-landing-container trainer-faq-grid",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                    children: "Get all your questions answered here"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    children: "We tried to answer all frequent questions. Still confused? Feel free to contact us."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "trainer-faq-list",
                                            children: faqs.map((faq, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("article", {
                                                    className: `trainer-faq-item ${openFaqIndex === index ? 'open' : ''}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                            className: "trainer-faq-question",
                                                            type: "button",
                                                            onClick: ()=>setOpenFaqIndex(openFaqIndex === index ? -1 : index),
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: faq.question
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                    className: "trainer-faq-icon",
                                                                    src: openFaqIndex === index ? (0, _faqCollapsePngDefault.default) : (0, _faqExpandPngDefault.default),
                                                                    alt: "",
                                                                    "aria-hidden": "true"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "trainer-faq-answer",
                                                            children: faq.answer
                                                        })
                                                    ]
                                                }, faq.question))
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    step === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "animation-content max-width-768 animation-text-position",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAnimate.TextAnimate), {
                            animation: "slideUp",
                            by: "word",
                            as: "h2",
                            center: true,
                            className: "page-intro-title mt-0",
                            duration: 1,
                            delay: 0.05,
                            onComplete: ()=>{
                                setTimeout(()=>{
                                    (0, _gsapSetupDefault.default).to('.animation-content', {
                                        opacity: 0,
                                        duration: 0.5
                                    });
                                    const isMobile = window.innerWidth < 768;
                                    (0, _gsapSetupDefault.default).to(videoContainerRef.current, {
                                        top: isMobile ? '16px' : '40px',
                                        left: '50%',
                                        y: 0,
                                        yPercent: 0,
                                        xPercent: -50,
                                        width: isMobile ? 130 : 200,
                                        height: isMobile ? 130 : 200,
                                        duration: 1.2,
                                        ease: 'power3.inOut',
                                        onComplete: ()=>{
                                            setStep(3);
                                        }
                                    });
                                }, 1500);
                            },
                            children: `Hi ${firstName}! Let's personalize\nyour experience`
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "hero-glow-video-container flex-center-column",
                        ref: videoContainerRef,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                                ref: videoRef,
                                src: (0, _miniPtCareMp4Default.default),
                                autoPlay: true,
                                muted: true,
                                loop: true,
                                playsInline: true,
                                preload: "auto",
                                className: "hero-glow-video",
                                onLoadedData: (e)=>{
                                    e.currentTarget.muted = true;
                                    e.currentTarget.play().catch(()=>{});
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                ref: videoTextRef,
                                className: "mini-pt-text",
                                style: {
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    whiteSpace: 'nowrap',
                                    pointerEvents: 'none'
                                },
                                children: "MiniPT Core"
                            })
                        ]
                    }),
                    step === 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: '100%',
                            zIndex: 20
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _experience.Experience), {
                            onNext: ()=>setStep(4),
                            onSkip: ()=>navigate('/onboarding-trainer/dashboard')
                        })
                    }),
                    step === 4 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: '100%',
                            zIndex: 20
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientType.ClientType), {
                            onBack: ()=>setStep(3),
                            onNext: (_ids)=>setStep(5)
                        })
                    }),
                    step === 5 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: '100%',
                            zIndex: 20
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _offer.Offer), {
                            onBack: ()=>setStep(4),
                            onNext: (_offers)=>setStep(6)
                        })
                    }),
                    step === 6 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: '100%',
                            zIndex: 20
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _schedule.Schedule), {
                            mode: "onboarding",
                            onBack: ()=>setStep(5),
                            onNext: ()=>setStep(7)
                        })
                    }),
                    step === 7 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: '100%',
                            zIndex: 20
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(Step6AIHelp, {
                            onComplete: ()=>navigate('/onboarding-trainer/dashboard')
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","./Hero.scss":"3d0gy","react":"bmhQu","motion/react":[["AnimatePresence","QteOV"],["motion","aBn1X"]],"react-router-dom":"f3cgC","../../components/Button/Button":"jLE7r","src/components/Animation/text-animate":"iQJIi","../Experience/Experience":"letTZ","../ClientType/ClientType":"bUlwo","../Offer/Offer":"l7rLP","../Schedule/Schedule":"itZID","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"src/components/SEO":"9lYJS","src/config/firebase":"cmjIE","src/api/mutations/useGetOnboardingState":"3gbTg","src/utils/authUtils":"41GVV","src/utils/onboardingUtils":"gnh1N","src/utils/gsapSetup":"8koI4","src/store/sessionStore":"kPSO3","src/store/uiStore":"hxErL","url:../../../../assets/videos/mini-pt-care.mp4":"5knEg","../../../../assets/images/onboarding-trainer/right-arrow.svg":"jEMFR","url:../../../../assets/images/onboarding-trainer/landing/feature-program-builder-transparent.png":"jjnLA","url:../../../../assets/images/onboarding-trainer/landing/feature-assign-clients-transparent.png":"gKYwy","url:../../../../assets/images/onboarding-trainer/landing/feature-assign-dashboard.png":"4gq5W","url:../../../../assets/images/onboarding-trainer/landing/feature-ai-coach-transparent.png":"ptH8e","url:../../../../assets/images/onboarding-trainer/landing/feature-work-dashboard.png":"5LncY","url:../../../../assets/images/onboarding-trainer/landing/feature-progress-sync-transparent.png":"abHBB","url:../../../../assets/images/onboarding-trainer/landing/feature-sync-list.png":"dLvQ4","../../../../assets/images/onboarding-trainer/landing/feature-sync-performance.svg":"6OsjK","url:../../../../assets/images/onboarding-trainer/landing/feature-grow-earn.png":"5TBqO","../../../../assets/images/onboarding-trainer/landing/about-icons/program-builder.svg":"bCo1h","../../../../assets/images/onboarding-trainer/landing/about-icons/assign-clients.svg":"ic88o","../../../../assets/images/onboarding-trainer/landing/about-icons/clients-work.svg":"38t6B","../../../../assets/images/onboarding-trainer/landing/about-icons/progress-sync.svg":"jXFCf","url:../../../../assets/images/onboarding-trainer/landing/cta-programs.png":"5rI6d","url:../../../../assets/images/onboarding-trainer/landing/testimonials/testimonial-ela.jpeg":"qX3D7","url:../../../../assets/images/onboarding-trainer/landing/testimonials/testimonial-alex.jpeg":"bnu3s","url:../../../../assets/images/onboarding-trainer/landing/testimonials/testimonial-steph.jpeg":"jkz9i","../../../../assets/images/onboarding-trainer/landing/testimonials/quote-icon.svg":"l62KF","url:../../../../assets/images/onboarding-trainer/landing/faq/faq-expand.png":"4D1Kw","url:../../../../assets/images/onboarding-trainer/landing/faq/faq-collapse.png":"4Kv4R","url:../../../../assets/images/onboarding-trainer/landing/hero/hero-person-1.jpeg":"jD0hd","url:../../../../assets/images/onboarding-trainer/landing/hero/hero-person-2.jpeg":"g27c7","url:../../../../assets/images/onboarding-trainer/landing/hero/hero-person-3.jpeg":"bdmCA","url:../../../../assets/images/onboarding-trainer/landing/hero/hero-person-4.jpeg":"aex14","url:../../../../assets/images/onboarding-trainer/landing/hero/hero-person-5.jpeg":"6wj7T","url:../../../../assets/images/onboarding-trainer/landing/hero/hero-person-6.jpeg":"5e2IG","../../../../assets/images/onboarding-trainer/landing/hero/trend-up.svg":"lP9tD","../../../../assets/images/onboarding-trainer/landing/hero/quote.svg":"dL149","../../../../assets/images/onboarding-trainer/landing/hero/star.svg":"1oJN4","../../../../assets/images/onboarding-trainer/landing/hero/laptop.svg":"dQZFv","../../../../assets/images/onboarding-trainer/landing/hero/group.svg":"iy2eE","../../../../assets/images/onboarding-trainer/landing/hero/pound.svg":"89Tk4","../../../../assets/images/onboarding-trainer/landing/hero/impact-arrow.svg":"jWvIy","url:../../../../assets/images/onboarding-trainer/landing/platform/sidebar-avatar.jpeg":"84nYt","url:../../../../assets/images/onboarding-trainer/landing/platform/man-grey-back.png":"bgooQ","url:../../../../assets/images/onboarding-trainer/landing/platform/man-grey-front.png":"8yt52","../../../../assets/images/onboarding-trainer/landing/platform/platform-union.svg":"ksK5R","../../../../assets/images/onboarding-trainer/landing/platform/button-spark.svg":"gdwh4","../../../../assets/images/onboarding-trainer/landing/platform/nav-logo-1.svg":"3Rti9","../../../../assets/images/onboarding-trainer/landing/platform/nav-logo-2.svg":"fERD6","../../../../assets/images/onboarding-trainer/landing/platform/nav-logo-3.svg":"aXbjQ","../../../../assets/images/onboarding-trainer/landing/platform/nav-logo-4.svg":"g2fNl","../../../../assets/images/onboarding-trainer/landing/platform/nav-icon-plus.svg":"h3Sly","../../../../assets/images/onboarding-trainer/landing/platform/nav-icon-clients.svg":"CJrht","../../../../assets/images/onboarding-trainer/landing/platform/nav-icon-folder.svg":"biX9g","../../../../assets/images/onboarding-trainer/landing/platform/nav-icon-message.svg":"gARNz","../../../../assets/images/onboarding-trainer/landing/platform/mini-ring.svg":"lc40Y","../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/client_profile.svg":"4wtpD","../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/movement_insights.svg":"9MrjD","../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/program_goals.svg":"3aLZ1","../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/program_summary.svg":"2sXTH","../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/goal_approach.svg":"hkeyK","../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injuries_notes.svg":"tA9Si","../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/plan_structure.svg":"fb3Cp","../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg":"eHDnc","../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/weight.svg":"59Zgc","../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/bar_and_bench.svg":"aRHII","../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/other.svg":"3Cuql","../../../../assets/images/onboarding-trainer/landing/platform/pain-point-0.svg":"4Xg1S","../../../../assets/images/onboarding-trainer/landing/platform/pain-point-1.svg":"60zbG","../../../../assets/images/onboarding-trainer/landing/platform/pain-point-2.svg":"aduug","../../../../assets/images/onboarding-trainer/landing/platform/pain-point-3.svg":"4trl7","../../../../assets/images/onboarding-trainer/landing/platform/pain-point-4.svg":"koAYG","../../../../assets/images/onboarding-trainer/landing/platform/pain-point-5.svg":"8btDH","../../../../assets/images/onboarding-trainer/landing/platform/pain-point-6.svg":"9mJvw","../../../../assets/images/onboarding-trainer/landing/platform/donut-arrow.svg":"2dyFJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3d0gy":[function() {},{}],"jLE7r":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>Button);
var _jsxRuntime = require("react/jsx-runtime");
var _buttonModuleCss = require("./Button.module.css");
// 🔹 React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const Button = /*#__PURE__*/ (0, _react.memo)(({ className, disabled, isLoading, children, onClick, variant = 'primary', icon, iconWidth = 24, svg, style, type = 'button' })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
        type: type,
        disabled: disabled || isLoading,
        style: style,
        className: `${variant === 'primary' ? `${_buttonModuleCss.primary} primary-button` : variant === 'secondary' ? `${_buttonModuleCss.secondary} secondary-button` : variant === 'light' ? `${_buttonModuleCss.light} light-button` : variant === 'outline' ? `${_buttonModuleCss.outline} outline-button` : ''} ${className ?? ''} ${isLoading ? _buttonModuleCss.loading : ''}`,
        onClick: onClick,
        children: [
            isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                className: _buttonModuleCss.spinner,
                width: "20",
                height: "20",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                strokeWidth: "3",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M21 12a9 9 0 1 1-6.219-8.56"
                })
            }),
            !isLoading && icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                src: icon,
                className: _buttonModuleCss.iconLeft,
                style: {
                    width: iconWidth
                },
                alt: ""
            }),
            !isLoading && svg && svg,
            children
        ]
    });
});
Button.displayName = 'Button';

},{"react/jsx-runtime":"gonF6","./Button.module.css":"exzxn","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"exzxn":[function(require,module,exports,__globalThis) {
module.exports["iconLeft"] = `qaInma_iconLeft`;
module.exports["light"] = `qaInma_light`;
module.exports["loading"] = `qaInma_loading`;
module.exports["outline"] = `qaInma_outline`;
module.exports["primary"] = `qaInma_primary`;
module.exports["secondary"] = `qaInma_secondary`;
module.exports["spin"] = `qaInma_spin`;
module.exports["spin"];
module.exports["spinner"] = `qaInma_spinner`;

},{}],"letTZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Experience", ()=>Experience);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _gsap = require("gsap");
var _experienceScss = require("./Experience.scss");
var _newlyQualifiedPtWebp = require("url:../../../../assets/images/onboarding-trainer/newly-qualified-pt.webp");
var _newlyQualifiedPtWebpDefault = parcelHelpers.interopDefault(_newlyQualifiedPtWebp);
var _growingPersonalTrainerWebp = require("url:../../../../assets/images/onboarding-trainer/growing-personal-trainer.webp");
var _growingPersonalTrainerWebpDefault = parcelHelpers.interopDefault(_growingPersonalTrainerWebp);
var _establishedCoachWebp = require("url:../../../../assets/images/onboarding-trainer/established-coach.webp");
var _establishedCoachWebpDefault = parcelHelpers.interopDefault(_establishedCoachWebp);
var _useGetOnboardingMasterData = require("src/api/mutations/useGetOnboardingMasterData");
var _useSaveOnboardingStep = require("src/api/mutations/useSaveOnboardingStep");
var _sessionStore = require("src/store/sessionStore");
var _authUtils = require("src/utils/authUtils");
var _useGetOnboardingState = require("src/api/mutations/useGetOnboardingState");
const IMAGE_MAP = {
    'newly-qualified': (0, _newlyQualifiedPtWebpDefault.default),
    'growing-trainer': (0, _growingPersonalTrainerWebpDefault.default),
    'established-coach': (0, _establishedCoachWebpDefault.default)
};
const Experience = ({ onNext, onSkip })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [selectedId, setSelectedId] = (0, _react.useState)(null);
    const [isSkipping, setIsSkipping] = (0, _react.useState)(false);
    const cardsRef = (0, _react.useRef)([]);
    const { data: masterData } = (0, _useGetOnboardingMasterData.useGetOnboardingMasterData)();
    const { mutate: saveStep, mutateAsync: saveStepAsync, isPending } = (0, _useSaveOnboardingStep.useSaveOnboardingStep)();
    const token = (0, _sessionStore.sessionStore)((s)=>s.token);
    const userId = (0, _authUtils.getUserIdFromToken)(token);
    const handleSkip = async ()=>{
        if (isPending || isSkipping) return;
        setIsSkipping(true);
        try {
            if (userId) await saveStepAsync({
                uid: userId,
                step: 'skip',
                data: {
                    onboardingSkipped: true
                }
            });
        } catch (err) {
            console.error('Failed to save skip state:', err);
        } finally{
            setIsSkipping(false);
            if (onSkip) onSkip();
            else navigate('/onboarding-trainer/dashboard');
        }
    };
    const handleBack = ()=>{
        if (window.history.length > 1) window.history.back();
        else navigate('/onboarding-trainer/dashboard');
    };
    const experienceData = masterData?.['onboarding_experience'];
    const options = experienceData?.options || [];
    // Mobile specific title based on the screenshot provided by the user
    const isMobile = window.innerWidth <= 768;
    const titleText = isMobile ? 'Which best describes your coaching style?' : 'Which stage best reflects your personal training experience?';
    const { data: stateData } = (0, _useGetOnboardingState.useGetOnboardingState)(userId || undefined);
    (0, _react.useEffect)(()=>{
        if (stateData?.onboarding?.step1_experience && !selectedId) {
            const savedExp = stateData.onboarding.step1_experience;
            setSelectedId(Array.isArray(savedExp) ? savedExp[0] : savedExp);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        stateData?.onboarding?.step1_experience
    ]);
    (0, _react.useEffect)(()=>{
        if (cardsRef.current.length > 0) (0, _gsap.gsap).fromTo(cardsRef.current, {
            opacity: 0,
            y: 25
        }, {
            opacity: 1,
            y: 0,
            duration: 0.85,
            stagger: 0.15,
            ease: 'power3.out'
        });
    }, [
        options.length
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "experience-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "experience-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "title",
                        children: experienceData?.title || titleText
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "subtitle",
                        children: experienceData?.subtitle || 'Choose the option that feels closest to where you are right now.'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "experience-grid",
                children: options.map((option, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        ref: (el)=>{
                            cardsRef.current[index] = el;
                        },
                        className: `experience-card ${selectedId === option.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            if (isPending) return;
                            setSelectedId(option.slug);
                            if (userId) saveStep({
                                uid: userId,
                                step: 1,
                                data: [
                                    option.slug
                                ]
                            });
                            if (onNext) setTimeout(()=>onNext(option.slug), 400);
                        },
                        style: {
                            opacity: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "hexagon-border",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: IMAGE_MAP[option.slug] || (0, _newlyQualifiedPtWebpDefault.default),
                                    alt: option.title
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "radio-circle",
                                children: selectedId === option.slug && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "#000",
                                    strokeWidth: "4",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "20 6 9 17 4 12"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: option.title
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: option.description
                                    })
                                ]
                            })
                        ]
                    }, option.slug))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "experience-footer",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "progress-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "btn-skip-onboarding",
                        onClick: handleSkip,
                        disabled: isPending || isSkipping,
                        "aria-label": "Skip onboarding",
                        children: isSkipping ? 'Skipping...' : 'Skip'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "back-btn-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: "btn-back",
                            onClick: handleBack,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M19 12H5M5 12L12 19M5 12L12 5",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }),
                                'Back'
                            ]
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","gsap":"kKW9v","./Experience.scss":"5yoYz","url:../../../../assets/images/onboarding-trainer/newly-qualified-pt.webp":"R4wb9","url:../../../../assets/images/onboarding-trainer/growing-personal-trainer.webp":"6pFOu","url:../../../../assets/images/onboarding-trainer/established-coach.webp":"1Rds8","src/api/mutations/useGetOnboardingMasterData":"dhU6k","src/api/mutations/useSaveOnboardingStep":"iDROn","src/store/sessionStore":"kPSO3","src/utils/authUtils":"41GVV","src/api/mutations/useGetOnboardingState":"3gbTg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5yoYz":[function() {},{}],"R4wb9":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("a1yW1");

},{}],"6pFOu":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fVoWS");

},{}],"1Rds8":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6z0Ze");

},{}],"dhU6k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchOnboardingMasterData", ()=>fetchOnboardingMasterData);
parcelHelpers.export(exports, "useGetOnboardingMasterData", ()=>useGetOnboardingMasterData);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
const fetchOnboardingMasterData = async ()=>{
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_ONBOARDING_MASTER_DATA}`;
    const response = await fetch(apiUrl);
    if (!response.ok) throw new Error('Failed to fetch master data');
    const res = await response.json();
    const data = res.data;
    // Sort options by 'order' if it exists
    Object.values(data).forEach((category)=>{
        if (category.options && Array.isArray(category.options)) category.options.sort((a, b)=>{
            const orderA = a.order ?? 999;
            const orderB = b.order ?? 999;
            return orderA - orderB;
        });
    });
    return data;
};
function useGetOnboardingMasterData() {
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'onboarding-master-data'
        ],
        queryFn: fetchOnboardingMasterData,
        staleTime: 3600000
    });
}

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lWWNx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useQuery", ()=>useQuery);
// src/useQuery.ts
var _queryCore = require("@tanstack/query-core");
var _useBaseQueryJs = require("./useBaseQuery.js");
"use client";
function useQuery(options, queryClient) {
    return (0, _useBaseQueryJs.useBaseQuery)(options, (0, _queryCore.QueryObserver), queryClient);
}

},{"@tanstack/query-core":"dCKjC","./useBaseQuery.js":"ga9GH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dCKjC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryObserver", ()=>QueryObserver);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/queryObserver.ts
var _focusManagerJs = require("./focusManager.js");
var _notifyManagerJs = require("./notifyManager.js");
var _queryJs = require("./query.js");
var _subscribableJs = require("./subscribable.js");
var _thenableJs = require("./thenable.js");
var _utilsJs = require("./utils.js");
var _timeoutManagerJs = require("./timeoutManager.js");
var _client, _currentQuery, _currentQueryInitialState, _currentResult, _currentResultState, _currentResultOptions, _currentThenable, _selectError, _selectFn, _selectResult, _lastQueryWithDefinedData, _staleTimeoutId, _refetchIntervalId, _currentRefetchInterval, _trackedProps, _QueryObserver_instances, executeFetch_fn, updateStaleTimeout_fn, computeRefetchInterval_fn, updateRefetchInterval_fn, updateTimers_fn, clearStaleTimeout_fn, clearRefetchInterval_fn, updateQuery_fn, notify_fn;
var QueryObserver = class extends (0, _subscribableJs.Subscribable) {
    constructor(client, options){
        super();
        this.options = options;
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _QueryObserver_instances);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _client);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _currentQuery);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _currentQueryInitialState);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _currentResult);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _currentResultState);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _currentResultOptions);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _currentThenable);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _selectError);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _selectFn);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _selectResult);
        // This property keeps track of the last query with defined data.
        // It will be used to pass the previous data and query to the placeholder function between renders.
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _lastQueryWithDefinedData);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _staleTimeoutId);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _refetchIntervalId);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _currentRefetchInterval);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _trackedProps, /* @__PURE__ */ new Set());
        (0, _chunkPXG64RU4Js.__privateSet)(this, _client, client);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _selectError, null);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _currentThenable, (0, _thenableJs.pendingThenable)());
        this.bindMethods();
        this.setOptions(options);
    }
    bindMethods() {
        this.refetch = this.refetch.bind(this);
    }
    onSubscribe() {
        if (this.listeners.size === 1) {
            (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery).addObserver(this);
            if (shouldFetchOnMount((0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery), this.options)) (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, executeFetch_fn).call(this);
            else this.updateResult();
            (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, updateTimers_fn).call(this);
        }
    }
    onUnsubscribe() {
        if (!this.hasListeners()) this.destroy();
    }
    shouldFetchOnReconnect() {
        return shouldFetchOn((0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery), this.options, this.options.refetchOnReconnect);
    }
    shouldFetchOnWindowFocus() {
        return shouldFetchOn((0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery), this.options, this.options.refetchOnWindowFocus);
    }
    destroy() {
        this.listeners = /* @__PURE__ */ new Set();
        (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, clearStaleTimeout_fn).call(this);
        (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, clearRefetchInterval_fn).call(this);
        (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery).removeObserver(this);
    }
    setOptions(options) {
        const prevOptions = this.options;
        const prevQuery = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery);
        this.options = (0, _chunkPXG64RU4Js.__privateGet)(this, _client).defaultQueryOptions(options);
        if (this.options.enabled !== void 0 && typeof this.options.enabled !== "boolean" && typeof this.options.enabled !== "function" && typeof (0, _utilsJs.resolveEnabled)(this.options.enabled, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery)) !== "boolean") throw new Error("Expected enabled to be a boolean or a callback that returns a boolean");
        (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, updateQuery_fn).call(this);
        (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery).setOptions(this.options);
        if (prevOptions._defaulted && !(0, _utilsJs.shallowEqualObjects)(this.options, prevOptions)) (0, _chunkPXG64RU4Js.__privateGet)(this, _client).getQueryCache().notify({
            type: "observerOptionsUpdated",
            query: (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery),
            observer: this
        });
        const mounted = this.hasListeners();
        if (mounted && shouldFetchOptionally((0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery), prevQuery, this.options, prevOptions)) (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, executeFetch_fn).call(this);
        this.updateResult();
        if (mounted && ((0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery) !== prevQuery || (0, _utilsJs.resolveEnabled)(this.options.enabled, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery)) !== (0, _utilsJs.resolveEnabled)(prevOptions.enabled, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery)) || (0, _utilsJs.resolveStaleTime)(this.options.staleTime, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery)) !== (0, _utilsJs.resolveStaleTime)(prevOptions.staleTime, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery)))) (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, updateStaleTimeout_fn).call(this);
        const nextRefetchInterval = (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, computeRefetchInterval_fn).call(this);
        if (mounted && ((0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery) !== prevQuery || (0, _utilsJs.resolveEnabled)(this.options.enabled, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery)) !== (0, _utilsJs.resolveEnabled)(prevOptions.enabled, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery)) || nextRefetchInterval !== (0, _chunkPXG64RU4Js.__privateGet)(this, _currentRefetchInterval))) (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, updateRefetchInterval_fn).call(this, nextRefetchInterval);
    }
    getOptimisticResult(options) {
        const query = (0, _chunkPXG64RU4Js.__privateGet)(this, _client).getQueryCache().build((0, _chunkPXG64RU4Js.__privateGet)(this, _client), options);
        const result = this.createResult(query, options);
        if (shouldAssignObserverCurrentProperties(this, result)) {
            (0, _chunkPXG64RU4Js.__privateSet)(this, _currentResult, result);
            (0, _chunkPXG64RU4Js.__privateSet)(this, _currentResultOptions, this.options);
            (0, _chunkPXG64RU4Js.__privateSet)(this, _currentResultState, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery).state);
        }
        return result;
    }
    getCurrentResult() {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult);
    }
    trackResult(result, onPropTracked) {
        return new Proxy(result, {
            get: (target, key)=>{
                this.trackProp(key);
                onPropTracked == null || onPropTracked(key);
                if (key === "promise") {
                    this.trackProp("data");
                    if (!this.options.experimental_prefetchInRender && (0, _chunkPXG64RU4Js.__privateGet)(this, _currentThenable).status === "pending") (0, _chunkPXG64RU4Js.__privateGet)(this, _currentThenable).reject(new Error("experimental_prefetchInRender feature flag is not enabled"));
                }
                return Reflect.get(target, key);
            }
        });
    }
    trackProp(key) {
        (0, _chunkPXG64RU4Js.__privateGet)(this, _trackedProps).add(key);
    }
    getCurrentQuery() {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery);
    }
    refetch({ ...options } = {}) {
        return this.fetch({
            ...options
        });
    }
    fetchOptimistic(options) {
        const defaultedOptions = (0, _chunkPXG64RU4Js.__privateGet)(this, _client).defaultQueryOptions(options);
        const query = (0, _chunkPXG64RU4Js.__privateGet)(this, _client).getQueryCache().build((0, _chunkPXG64RU4Js.__privateGet)(this, _client), defaultedOptions);
        return query.fetch().then(()=>this.createResult(query, defaultedOptions));
    }
    fetch(fetchOptions) {
        return (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, executeFetch_fn).call(this, {
            ...fetchOptions,
            cancelRefetch: fetchOptions.cancelRefetch ?? true
        }).then(()=>{
            this.updateResult();
            return (0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult);
        });
    }
    createResult(query, options) {
        var _a;
        const prevQuery = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery);
        const prevOptions = this.options;
        const prevResult = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult);
        const prevResultState = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentResultState);
        const prevResultOptions = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentResultOptions);
        const queryChange = query !== prevQuery;
        const queryInitialState = queryChange ? query.state : (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQueryInitialState);
        const { state } = query;
        let newState = {
            ...state
        };
        let isPlaceholderData = false;
        let data;
        if (options._optimisticResults) {
            const mounted = this.hasListeners();
            const fetchOnMount = !mounted && shouldFetchOnMount(query, options);
            const fetchOptionally = mounted && shouldFetchOptionally(query, prevQuery, options, prevOptions);
            if (fetchOnMount || fetchOptionally) newState = {
                ...newState,
                ...(0, _queryJs.fetchState)(state.data, query.options)
            };
            if (options._optimisticResults === "isRestoring") newState.fetchStatus = "idle";
        }
        let { error, errorUpdatedAt, status } = newState;
        data = newState.data;
        let skipSelect = false;
        if (options.placeholderData !== void 0 && data === void 0 && status === "pending") {
            let placeholderData;
            if ((prevResult == null ? void 0 : prevResult.isPlaceholderData) && options.placeholderData === (prevResultOptions == null ? void 0 : prevResultOptions.placeholderData)) {
                placeholderData = prevResult.data;
                skipSelect = true;
            } else placeholderData = typeof options.placeholderData === "function" ? options.placeholderData((_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _lastQueryWithDefinedData)) == null ? void 0 : _a.state.data, (0, _chunkPXG64RU4Js.__privateGet)(this, _lastQueryWithDefinedData)) : options.placeholderData;
            if (placeholderData !== void 0) {
                status = "success";
                data = (0, _utilsJs.replaceData)(prevResult == null ? void 0 : prevResult.data, placeholderData, options);
                isPlaceholderData = true;
            }
        }
        if (options.select && data !== void 0 && !skipSelect) {
            if (prevResult && data === (prevResultState == null ? void 0 : prevResultState.data) && options.select === (0, _chunkPXG64RU4Js.__privateGet)(this, _selectFn)) data = (0, _chunkPXG64RU4Js.__privateGet)(this, _selectResult);
            else try {
                (0, _chunkPXG64RU4Js.__privateSet)(this, _selectFn, options.select);
                data = options.select(data);
                data = (0, _utilsJs.replaceData)(prevResult == null ? void 0 : prevResult.data, data, options);
                (0, _chunkPXG64RU4Js.__privateSet)(this, _selectResult, data);
                (0, _chunkPXG64RU4Js.__privateSet)(this, _selectError, null);
            } catch (selectError) {
                (0, _chunkPXG64RU4Js.__privateSet)(this, _selectError, selectError);
            }
        }
        if ((0, _chunkPXG64RU4Js.__privateGet)(this, _selectError)) {
            error = (0, _chunkPXG64RU4Js.__privateGet)(this, _selectError);
            data = (0, _chunkPXG64RU4Js.__privateGet)(this, _selectResult);
            errorUpdatedAt = Date.now();
            status = "error";
        }
        const isFetching = newState.fetchStatus === "fetching";
        const isPending = status === "pending";
        const isError = status === "error";
        const isLoading = isPending && isFetching;
        const hasData = data !== void 0;
        const result = {
            status,
            fetchStatus: newState.fetchStatus,
            isPending,
            isSuccess: status === "success",
            isError,
            isInitialLoading: isLoading,
            isLoading,
            data,
            dataUpdatedAt: newState.dataUpdatedAt,
            error,
            errorUpdatedAt,
            failureCount: newState.fetchFailureCount,
            failureReason: newState.fetchFailureReason,
            errorUpdateCount: newState.errorUpdateCount,
            isFetched: newState.dataUpdateCount > 0 || newState.errorUpdateCount > 0,
            isFetchedAfterMount: newState.dataUpdateCount > queryInitialState.dataUpdateCount || newState.errorUpdateCount > queryInitialState.errorUpdateCount,
            isFetching,
            isRefetching: isFetching && !isPending,
            isLoadingError: isError && !hasData,
            isPaused: newState.fetchStatus === "paused",
            isPlaceholderData,
            isRefetchError: isError && hasData,
            isStale: isStale(query, options),
            refetch: this.refetch,
            promise: (0, _chunkPXG64RU4Js.__privateGet)(this, _currentThenable),
            isEnabled: (0, _utilsJs.resolveEnabled)(options.enabled, query) !== false
        };
        const nextResult = result;
        if (this.options.experimental_prefetchInRender) {
            const finalizeThenableIfPossible = (thenable)=>{
                if (nextResult.status === "error") thenable.reject(nextResult.error);
                else if (nextResult.data !== void 0) thenable.resolve(nextResult.data);
            };
            const recreateThenable = ()=>{
                const pending = (0, _chunkPXG64RU4Js.__privateSet)(this, _currentThenable, nextResult.promise = (0, _thenableJs.pendingThenable)());
                finalizeThenableIfPossible(pending);
            };
            const prevThenable = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentThenable);
            switch(prevThenable.status){
                case "pending":
                    if (query.queryHash === prevQuery.queryHash) finalizeThenableIfPossible(prevThenable);
                    break;
                case "fulfilled":
                    if (nextResult.status === "error" || nextResult.data !== prevThenable.value) recreateThenable();
                    break;
                case "rejected":
                    if (nextResult.status !== "error" || nextResult.error !== prevThenable.reason) recreateThenable();
                    break;
            }
        }
        return nextResult;
    }
    updateResult() {
        const prevResult = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult);
        const nextResult = this.createResult((0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery), this.options);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _currentResultState, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery).state);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _currentResultOptions, this.options);
        if ((0, _chunkPXG64RU4Js.__privateGet)(this, _currentResultState).data !== void 0) (0, _chunkPXG64RU4Js.__privateSet)(this, _lastQueryWithDefinedData, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery));
        if ((0, _utilsJs.shallowEqualObjects)(nextResult, prevResult)) return;
        (0, _chunkPXG64RU4Js.__privateSet)(this, _currentResult, nextResult);
        const shouldNotifyListeners = ()=>{
            if (!prevResult) return true;
            const { notifyOnChangeProps } = this.options;
            const notifyOnChangePropsValue = typeof notifyOnChangeProps === "function" ? notifyOnChangeProps() : notifyOnChangeProps;
            if (notifyOnChangePropsValue === "all" || !notifyOnChangePropsValue && !(0, _chunkPXG64RU4Js.__privateGet)(this, _trackedProps).size) return true;
            const includedProps = new Set(notifyOnChangePropsValue ?? (0, _chunkPXG64RU4Js.__privateGet)(this, _trackedProps));
            if (this.options.throwOnError) includedProps.add("error");
            return Object.keys((0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult)).some((key)=>{
                const typedKey = key;
                const changed = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult)[typedKey] !== prevResult[typedKey];
                return changed && includedProps.has(typedKey);
            });
        };
        (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, notify_fn).call(this, {
            listeners: shouldNotifyListeners()
        });
    }
    onQueryUpdate() {
        this.updateResult();
        if (this.hasListeners()) (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, updateTimers_fn).call(this);
    }
};
_client = new WeakMap();
_currentQuery = new WeakMap();
_currentQueryInitialState = new WeakMap();
_currentResult = new WeakMap();
_currentResultState = new WeakMap();
_currentResultOptions = new WeakMap();
_currentThenable = new WeakMap();
_selectError = new WeakMap();
_selectFn = new WeakMap();
_selectResult = new WeakMap();
_lastQueryWithDefinedData = new WeakMap();
_staleTimeoutId = new WeakMap();
_refetchIntervalId = new WeakMap();
_currentRefetchInterval = new WeakMap();
_trackedProps = new WeakMap();
_QueryObserver_instances = new WeakSet();
executeFetch_fn = function(fetchOptions) {
    (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, updateQuery_fn).call(this);
    let promise = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery).fetch(this.options, fetchOptions);
    if (!(fetchOptions == null ? void 0 : fetchOptions.throwOnError)) promise = promise.catch((0, _utilsJs.noop));
    return promise;
};
updateStaleTimeout_fn = function() {
    (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, clearStaleTimeout_fn).call(this);
    const staleTime = (0, _utilsJs.resolveStaleTime)(this.options.staleTime, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery));
    if ((0, _utilsJs.isServer) || (0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult).isStale || !(0, _utilsJs.isValidTimeout)(staleTime)) return;
    const time = (0, _utilsJs.timeUntilStale)((0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult).dataUpdatedAt, staleTime);
    const timeout = time + 1;
    (0, _chunkPXG64RU4Js.__privateSet)(this, _staleTimeoutId, (0, _timeoutManagerJs.timeoutManager).setTimeout(()=>{
        if (!(0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult).isStale) this.updateResult();
    }, timeout));
};
computeRefetchInterval_fn = function() {
    return (typeof this.options.refetchInterval === "function" ? this.options.refetchInterval((0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery)) : this.options.refetchInterval) ?? false;
};
updateRefetchInterval_fn = function(nextInterval) {
    (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, clearRefetchInterval_fn).call(this);
    (0, _chunkPXG64RU4Js.__privateSet)(this, _currentRefetchInterval, nextInterval);
    if ((0, _utilsJs.isServer) || (0, _utilsJs.resolveEnabled)(this.options.enabled, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery)) === false || !(0, _utilsJs.isValidTimeout)((0, _chunkPXG64RU4Js.__privateGet)(this, _currentRefetchInterval)) || (0, _chunkPXG64RU4Js.__privateGet)(this, _currentRefetchInterval) === 0) return;
    (0, _chunkPXG64RU4Js.__privateSet)(this, _refetchIntervalId, (0, _timeoutManagerJs.timeoutManager).setInterval(()=>{
        if (this.options.refetchIntervalInBackground || (0, _focusManagerJs.focusManager).isFocused()) (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, executeFetch_fn).call(this);
    }, (0, _chunkPXG64RU4Js.__privateGet)(this, _currentRefetchInterval)));
};
updateTimers_fn = function() {
    (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, updateStaleTimeout_fn).call(this);
    (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, updateRefetchInterval_fn).call(this, (0, _chunkPXG64RU4Js.__privateMethod)(this, _QueryObserver_instances, computeRefetchInterval_fn).call(this));
};
clearStaleTimeout_fn = function() {
    if ((0, _chunkPXG64RU4Js.__privateGet)(this, _staleTimeoutId)) {
        (0, _timeoutManagerJs.timeoutManager).clearTimeout((0, _chunkPXG64RU4Js.__privateGet)(this, _staleTimeoutId));
        (0, _chunkPXG64RU4Js.__privateSet)(this, _staleTimeoutId, void 0);
    }
};
clearRefetchInterval_fn = function() {
    if ((0, _chunkPXG64RU4Js.__privateGet)(this, _refetchIntervalId)) {
        (0, _timeoutManagerJs.timeoutManager).clearInterval((0, _chunkPXG64RU4Js.__privateGet)(this, _refetchIntervalId));
        (0, _chunkPXG64RU4Js.__privateSet)(this, _refetchIntervalId, void 0);
    }
};
updateQuery_fn = function() {
    const query = (0, _chunkPXG64RU4Js.__privateGet)(this, _client).getQueryCache().build((0, _chunkPXG64RU4Js.__privateGet)(this, _client), this.options);
    if (query === (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery)) return;
    const prevQuery = (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery);
    (0, _chunkPXG64RU4Js.__privateSet)(this, _currentQuery, query);
    (0, _chunkPXG64RU4Js.__privateSet)(this, _currentQueryInitialState, query.state);
    if (this.hasListeners()) {
        prevQuery == null || prevQuery.removeObserver(this);
        query.addObserver(this);
    }
};
notify_fn = function(notifyOptions) {
    (0, _notifyManagerJs.notifyManager).batch(()=>{
        if (notifyOptions.listeners) this.listeners.forEach((listener)=>{
            listener((0, _chunkPXG64RU4Js.__privateGet)(this, _currentResult));
        });
        (0, _chunkPXG64RU4Js.__privateGet)(this, _client).getQueryCache().notify({
            query: (0, _chunkPXG64RU4Js.__privateGet)(this, _currentQuery),
            type: "observerResultsUpdated"
        });
    });
};
function shouldLoadOnMount(query, options) {
    return (0, _utilsJs.resolveEnabled)(options.enabled, query) !== false && query.state.data === void 0 && !(query.state.status === "error" && options.retryOnMount === false);
}
function shouldFetchOnMount(query, options) {
    return shouldLoadOnMount(query, options) || query.state.data !== void 0 && shouldFetchOn(query, options, options.refetchOnMount);
}
function shouldFetchOn(query, options, field) {
    if ((0, _utilsJs.resolveEnabled)(options.enabled, query) !== false && (0, _utilsJs.resolveStaleTime)(options.staleTime, query) !== "static") {
        const value = typeof field === "function" ? field(query) : field;
        return value === "always" || value !== false && isStale(query, options);
    }
    return false;
}
function shouldFetchOptionally(query, prevQuery, options, prevOptions) {
    return (query !== prevQuery || (0, _utilsJs.resolveEnabled)(prevOptions.enabled, query) === false) && (!options.suspense || query.state.status !== "error") && isStale(query, options);
}
function isStale(query, options) {
    return (0, _utilsJs.resolveEnabled)(options.enabled, query) !== false && query.isStaleByTime((0, _utilsJs.resolveStaleTime)(options.staleTime, query));
}
function shouldAssignObserverCurrentProperties(observer, optimisticResult) {
    if (!(0, _utilsJs.shallowEqualObjects)(observer.getCurrentResult(), optimisticResult)) return true;
    return false;
}

},{"./chunk-PXG64RU4.js":"eR9la","./focusManager.js":"5x0my","./notifyManager.js":"egZGk","./query.js":"31nNK","./subscribable.js":"ifEuT","./thenable.js":"j8LK5","./utils.js":"ku1P9","./timeoutManager.js":"jOTXc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"31nNK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Query", ()=>Query);
parcelHelpers.export(exports, "fetchState", ()=>fetchState);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/query.ts
var _utilsJs = require("./utils.js");
var _notifyManagerJs = require("./notifyManager.js");
var _retryerJs = require("./retryer.js");
var _removableJs = require("./removable.js");
var _initialState, _revertState, _cache, _client, _retryer, _defaultOptions, _abortSignalConsumed, _Query_instances, dispatch_fn;
var Query = class extends (0, _removableJs.Removable) {
    constructor(config){
        super();
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _Query_instances);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _initialState);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _revertState);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _cache);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _client);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _retryer);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _defaultOptions);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _abortSignalConsumed);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _abortSignalConsumed, false);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _defaultOptions, config.defaultOptions);
        this.setOptions(config.options);
        this.observers = [];
        (0, _chunkPXG64RU4Js.__privateSet)(this, _client, config.client);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _cache, (0, _chunkPXG64RU4Js.__privateGet)(this, _client).getQueryCache());
        this.queryKey = config.queryKey;
        this.queryHash = config.queryHash;
        (0, _chunkPXG64RU4Js.__privateSet)(this, _initialState, getDefaultState(this.options));
        this.state = config.state ?? (0, _chunkPXG64RU4Js.__privateGet)(this, _initialState);
        this.scheduleGc();
    }
    get meta() {
        return this.options.meta;
    }
    get promise() {
        var _a;
        return (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer)) == null ? void 0 : _a.promise;
    }
    setOptions(options) {
        this.options = {
            ...(0, _chunkPXG64RU4Js.__privateGet)(this, _defaultOptions),
            ...options
        };
        this.updateGcTime(this.options.gcTime);
        if (this.state && this.state.data === void 0) {
            const defaultState = getDefaultState(this.options);
            if (defaultState.data !== void 0) {
                this.setState(successState(defaultState.data, defaultState.dataUpdatedAt));
                (0, _chunkPXG64RU4Js.__privateSet)(this, _initialState, defaultState);
            }
        }
    }
    optionalRemove() {
        if (!this.observers.length && this.state.fetchStatus === "idle") (0, _chunkPXG64RU4Js.__privateGet)(this, _cache).remove(this);
    }
    setData(newData, options) {
        const data = (0, _utilsJs.replaceData)(this.state.data, newData, this.options);
        (0, _chunkPXG64RU4Js.__privateMethod)(this, _Query_instances, dispatch_fn).call(this, {
            data,
            type: "success",
            dataUpdatedAt: options == null ? void 0 : options.updatedAt,
            manual: options == null ? void 0 : options.manual
        });
        return data;
    }
    setState(state, setStateOptions) {
        (0, _chunkPXG64RU4Js.__privateMethod)(this, _Query_instances, dispatch_fn).call(this, {
            type: "setState",
            state,
            setStateOptions
        });
    }
    cancel(options) {
        var _a, _b;
        const promise = (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer)) == null ? void 0 : _a.promise;
        (_b = (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer)) == null || _b.cancel(options);
        return promise ? promise.then((0, _utilsJs.noop)).catch((0, _utilsJs.noop)) : Promise.resolve();
    }
    destroy() {
        super.destroy();
        this.cancel({
            silent: true
        });
    }
    reset() {
        this.destroy();
        this.setState((0, _chunkPXG64RU4Js.__privateGet)(this, _initialState));
    }
    isActive() {
        return this.observers.some((observer)=>(0, _utilsJs.resolveEnabled)(observer.options.enabled, this) !== false);
    }
    isDisabled() {
        if (this.getObserversCount() > 0) return !this.isActive();
        return this.options.queryFn === (0, _utilsJs.skipToken) || this.state.dataUpdateCount + this.state.errorUpdateCount === 0;
    }
    isStatic() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>(0, _utilsJs.resolveStaleTime)(observer.options.staleTime, this) === "static");
        return false;
    }
    isStale() {
        if (this.getObserversCount() > 0) return this.observers.some((observer)=>observer.getCurrentResult().isStale);
        return this.state.data === void 0 || this.state.isInvalidated;
    }
    isStaleByTime(staleTime = 0) {
        if (this.state.data === void 0) return true;
        if (staleTime === "static") return false;
        if (this.state.isInvalidated) return true;
        return !(0, _utilsJs.timeUntilStale)(this.state.dataUpdatedAt, staleTime);
    }
    onFocus() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnWindowFocus());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer)) == null || _a.continue();
    }
    onOnline() {
        var _a;
        const observer = this.observers.find((x)=>x.shouldFetchOnReconnect());
        observer == null || observer.refetch({
            cancelRefetch: false
        });
        (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer)) == null || _a.continue();
    }
    addObserver(observer) {
        if (!this.observers.includes(observer)) {
            this.observers.push(observer);
            this.clearGcTimeout();
            (0, _chunkPXG64RU4Js.__privateGet)(this, _cache).notify({
                type: "observerAdded",
                query: this,
                observer
            });
        }
    }
    removeObserver(observer) {
        if (this.observers.includes(observer)) {
            this.observers = this.observers.filter((x)=>x !== observer);
            if (!this.observers.length) {
                if ((0, _chunkPXG64RU4Js.__privateGet)(this, _retryer)) {
                    if ((0, _chunkPXG64RU4Js.__privateGet)(this, _abortSignalConsumed)) (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer).cancel({
                        revert: true
                    });
                    else (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer).cancelRetry();
                }
                this.scheduleGc();
            }
            (0, _chunkPXG64RU4Js.__privateGet)(this, _cache).notify({
                type: "observerRemoved",
                query: this,
                observer
            });
        }
    }
    getObserversCount() {
        return this.observers.length;
    }
    invalidate() {
        if (!this.state.isInvalidated) (0, _chunkPXG64RU4Js.__privateMethod)(this, _Query_instances, dispatch_fn).call(this, {
            type: "invalidate"
        });
    }
    async fetch(options, fetchOptions) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
        if (this.state.fetchStatus !== "idle" && // If the promise in the retyer is already rejected, we have to definitely
        // re-start the fetch; there is a chance that the query is still in a
        // pending state when that happens
        ((_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer)) == null ? void 0 : _a.status()) !== "rejected") {
            if (this.state.data !== void 0 && (fetchOptions == null ? void 0 : fetchOptions.cancelRefetch)) this.cancel({
                silent: true
            });
            else if ((0, _chunkPXG64RU4Js.__privateGet)(this, _retryer)) {
                (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer).continueRetry();
                return (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer).promise;
            }
        }
        if (options) this.setOptions(options);
        if (!this.options.queryFn) {
            const observer = this.observers.find((x)=>x.options.queryFn);
            if (observer) this.setOptions(observer.options);
        }
        const abortController = new AbortController();
        const addSignalProperty = (object)=>{
            Object.defineProperty(object, "signal", {
                enumerable: true,
                get: ()=>{
                    (0, _chunkPXG64RU4Js.__privateSet)(this, _abortSignalConsumed, true);
                    return abortController.signal;
                }
            });
        };
        const fetchFn = ()=>{
            const queryFn = (0, _utilsJs.ensureQueryFn)(this.options, fetchOptions);
            const createQueryFnContext = ()=>{
                const queryFnContext2 = {
                    client: (0, _chunkPXG64RU4Js.__privateGet)(this, _client),
                    queryKey: this.queryKey,
                    meta: this.meta
                };
                addSignalProperty(queryFnContext2);
                return queryFnContext2;
            };
            const queryFnContext = createQueryFnContext();
            (0, _chunkPXG64RU4Js.__privateSet)(this, _abortSignalConsumed, false);
            if (this.options.persister) return this.options.persister(queryFn, queryFnContext, this);
            return queryFn(queryFnContext);
        };
        const createFetchContext = ()=>{
            const context2 = {
                fetchOptions,
                options: this.options,
                queryKey: this.queryKey,
                client: (0, _chunkPXG64RU4Js.__privateGet)(this, _client),
                state: this.state,
                fetchFn
            };
            addSignalProperty(context2);
            return context2;
        };
        const context = createFetchContext();
        (_b = this.options.behavior) == null || _b.onFetch(context, this);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _revertState, this.state);
        if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_c = context.fetchOptions) == null ? void 0 : _c.meta)) (0, _chunkPXG64RU4Js.__privateMethod)(this, _Query_instances, dispatch_fn).call(this, {
            type: "fetch",
            meta: (_d = context.fetchOptions) == null ? void 0 : _d.meta
        });
        (0, _chunkPXG64RU4Js.__privateSet)(this, _retryer, (0, _retryerJs.createRetryer)({
            initialPromise: fetchOptions == null ? void 0 : fetchOptions.initialPromise,
            fn: context.fetchFn,
            onCancel: (error)=>{
                if (error instanceof (0, _retryerJs.CancelledError) && error.revert) this.setState({
                    ...(0, _chunkPXG64RU4Js.__privateGet)(this, _revertState),
                    fetchStatus: "idle"
                });
                abortController.abort();
            },
            onFail: (failureCount, error)=>{
                (0, _chunkPXG64RU4Js.__privateMethod)(this, _Query_instances, dispatch_fn).call(this, {
                    type: "failed",
                    failureCount,
                    error
                });
            },
            onPause: ()=>{
                (0, _chunkPXG64RU4Js.__privateMethod)(this, _Query_instances, dispatch_fn).call(this, {
                    type: "pause"
                });
            },
            onContinue: ()=>{
                (0, _chunkPXG64RU4Js.__privateMethod)(this, _Query_instances, dispatch_fn).call(this, {
                    type: "continue"
                });
            },
            retry: context.options.retry,
            retryDelay: context.options.retryDelay,
            networkMode: context.options.networkMode,
            canRun: ()=>true
        }));
        try {
            const data = await (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer).start();
            if (data === void 0) throw new Error(`${this.queryHash} data is undefined`);
            this.setData(data);
            (_f = (_e = (0, _chunkPXG64RU4Js.__privateGet)(this, _cache).config).onSuccess) == null || _f.call(_e, data, this);
            (_h = (_g = (0, _chunkPXG64RU4Js.__privateGet)(this, _cache).config).onSettled) == null || _h.call(_g, data, this.state.error, this);
            return data;
        } catch (error) {
            if (error instanceof (0, _retryerJs.CancelledError)) {
                if (error.silent) return (0, _chunkPXG64RU4Js.__privateGet)(this, _retryer).promise;
                else if (error.revert) {
                    if (this.state.data === void 0) throw error;
                    return this.state.data;
                }
            }
            (0, _chunkPXG64RU4Js.__privateMethod)(this, _Query_instances, dispatch_fn).call(this, {
                type: "error",
                error
            });
            (_j = (_i = (0, _chunkPXG64RU4Js.__privateGet)(this, _cache).config).onError) == null || _j.call(_i, error, this);
            (_l = (_k = (0, _chunkPXG64RU4Js.__privateGet)(this, _cache).config).onSettled) == null || _l.call(_k, this.state.data, error, this);
            throw error;
        } finally{
            this.scheduleGc();
        }
    }
};
_initialState = new WeakMap();
_revertState = new WeakMap();
_cache = new WeakMap();
_client = new WeakMap();
_retryer = new WeakMap();
_defaultOptions = new WeakMap();
_abortSignalConsumed = new WeakMap();
_Query_instances = new WeakSet();
dispatch_fn = function(action) {
    const reducer = (state)=>{
        switch(action.type){
            case "failed":
                return {
                    ...state,
                    fetchFailureCount: action.failureCount,
                    fetchFailureReason: action.error
                };
            case "pause":
                return {
                    ...state,
                    fetchStatus: "paused"
                };
            case "continue":
                return {
                    ...state,
                    fetchStatus: "fetching"
                };
            case "fetch":
                return {
                    ...state,
                    ...fetchState(state.data, this.options),
                    fetchMeta: action.meta ?? null
                };
            case "success":
                const newState = {
                    ...state,
                    ...successState(action.data, action.dataUpdatedAt),
                    dataUpdateCount: state.dataUpdateCount + 1,
                    ...!action.manual && {
                        fetchStatus: "idle",
                        fetchFailureCount: 0,
                        fetchFailureReason: null
                    }
                };
                (0, _chunkPXG64RU4Js.__privateSet)(this, _revertState, action.manual ? newState : void 0);
                return newState;
            case "error":
                const error = action.error;
                return {
                    ...state,
                    error,
                    errorUpdateCount: state.errorUpdateCount + 1,
                    errorUpdatedAt: Date.now(),
                    fetchFailureCount: state.fetchFailureCount + 1,
                    fetchFailureReason: error,
                    fetchStatus: "idle",
                    status: "error"
                };
            case "invalidate":
                return {
                    ...state,
                    isInvalidated: true
                };
            case "setState":
                return {
                    ...state,
                    ...action.state
                };
        }
    };
    this.state = reducer(this.state);
    (0, _notifyManagerJs.notifyManager).batch(()=>{
        this.observers.forEach((observer)=>{
            observer.onQueryUpdate();
        });
        (0, _chunkPXG64RU4Js.__privateGet)(this, _cache).notify({
            query: this,
            type: "updated",
            action
        });
    });
};
function fetchState(data, options) {
    return {
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchStatus: (0, _retryerJs.canFetch)(options.networkMode) ? "fetching" : "paused",
        ...data === void 0 && {
            error: null,
            status: "pending"
        }
    };
}
function successState(data, dataUpdatedAt) {
    return {
        data,
        dataUpdatedAt: dataUpdatedAt ?? Date.now(),
        error: null,
        isInvalidated: false,
        status: "success"
    };
}
function getDefaultState(options) {
    const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
    const hasData = data !== void 0;
    const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
    return {
        data,
        dataUpdateCount: 0,
        dataUpdatedAt: hasData ? initialDataUpdatedAt ?? Date.now() : 0,
        error: null,
        errorUpdateCount: 0,
        errorUpdatedAt: 0,
        fetchFailureCount: 0,
        fetchFailureReason: null,
        fetchMeta: null,
        isInvalidated: false,
        status: hasData ? "success" : "pending",
        fetchStatus: "idle"
    };
}

},{"./chunk-PXG64RU4.js":"eR9la","./utils.js":"ku1P9","./notifyManager.js":"egZGk","./retryer.js":"ev2IU","./removable.js":"22XBM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ga9GH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useBaseQuery", ()=>useBaseQuery);
// src/useBaseQuery.ts
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
var _queryClientProviderJs = require("./QueryClientProvider.js");
var _queryErrorResetBoundaryJs = require("./QueryErrorResetBoundary.js");
var _errorBoundaryUtilsJs = require("./errorBoundaryUtils.js");
var _isRestoringProviderJs = require("./IsRestoringProvider.js");
var _suspenseJs = require("./suspense.js");
"use client";
function useBaseQuery(options, Observer, queryClient) {
    var _a, _b, _c, _d, _e;
    const isRestoring = (0, _isRestoringProviderJs.useIsRestoring)();
    const errorResetBoundary = (0, _queryErrorResetBoundaryJs.useQueryErrorResetBoundary)();
    const client = (0, _queryClientProviderJs.useQueryClient)(queryClient);
    const defaultedOptions = client.defaultQueryOptions(options);
    (_b = (_a = client.getDefaultOptions().queries) == null ? void 0 : _a._experimental_beforeQuery) == null || _b.call(_a, defaultedOptions);
    defaultedOptions._optimisticResults = isRestoring ? "isRestoring" : "optimistic";
    (0, _suspenseJs.ensureSuspenseTimers)(defaultedOptions);
    (0, _errorBoundaryUtilsJs.ensurePreventErrorBoundaryRetry)(defaultedOptions, errorResetBoundary);
    (0, _errorBoundaryUtilsJs.useClearResetErrorBoundary)(errorResetBoundary);
    const isNewCacheEntry = !client.getQueryCache().get(defaultedOptions.queryHash);
    const [observer] = _react.useState(()=>new Observer(client, defaultedOptions));
    const result = observer.getOptimisticResult(defaultedOptions);
    const shouldSubscribe = !isRestoring && options.subscribed !== false;
    _react.useSyncExternalStore(_react.useCallback((onStoreChange)=>{
        const unsubscribe = shouldSubscribe ? observer.subscribe((0, _queryCore.notifyManager).batchCalls(onStoreChange)) : (0, _queryCore.noop);
        observer.updateResult();
        return unsubscribe;
    }, [
        observer,
        shouldSubscribe
    ]), ()=>observer.getCurrentResult(), ()=>observer.getCurrentResult());
    _react.useEffect(()=>{
        observer.setOptions(defaultedOptions);
    }, [
        defaultedOptions,
        observer
    ]);
    if ((0, _suspenseJs.shouldSuspend)(defaultedOptions, result)) throw (0, _suspenseJs.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary);
    if ((0, _errorBoundaryUtilsJs.getHasError)({
        result,
        errorResetBoundary,
        throwOnError: defaultedOptions.throwOnError,
        query: client.getQueryCache().get(defaultedOptions.queryHash),
        suspense: defaultedOptions.suspense
    })) throw result.error;
    (_d = (_c = client.getDefaultOptions().queries) == null ? void 0 : _c._experimental_afterQuery) == null || _d.call(_c, defaultedOptions, result);
    if (defaultedOptions.experimental_prefetchInRender && !(0, _queryCore.isServer) && (0, _suspenseJs.willFetch)(result, isRestoring)) {
        const promise = isNewCacheEntry ? // Fetch immediately on render in order to ensure `.promise` is resolved even if the component is unmounted
        (0, _suspenseJs.fetchOptimistic)(defaultedOptions, observer, errorResetBoundary) : // subscribe to the "cache promise" so that we can finalize the currentThenable once data comes in
        (_e = client.getQueryCache().get(defaultedOptions.queryHash)) == null ? void 0 : _e.promise;
        promise == null || promise.catch((0, _queryCore.noop)).finally(()=>{
            observer.updateResult();
        });
    }
    return !defaultedOptions.notifyOnChangeProps ? observer.trackResult(result) : result;
}

},{"react":"bmhQu","@tanstack/query-core":[["isServer","ku1P9"],["noop","ku1P9"],["notifyManager","egZGk"]],"./QueryClientProvider.js":"97Oud","./QueryErrorResetBoundary.js":"7l1bA","./errorBoundaryUtils.js":"fuQcd","./IsRestoringProvider.js":"aLOac","./suspense.js":"jrivz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7l1bA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>QueryErrorResetBoundary);
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>useQueryErrorResetBoundary);
// src/QueryErrorResetBoundary.tsx
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
"use client";
function createValue() {
    let isReset = false;
    return {
        clearReset: ()=>{
            isReset = false;
        },
        reset: ()=>{
            isReset = true;
        },
        isReset: ()=>{
            return isReset;
        }
    };
}
var QueryErrorResetBoundaryContext = _react.createContext(createValue());
var useQueryErrorResetBoundary = ()=>_react.useContext(QueryErrorResetBoundaryContext);
var QueryErrorResetBoundary = ({ children })=>{
    const [value] = _react.useState(()=>createValue());
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(QueryErrorResetBoundaryContext.Provider, {
        value,
        children: typeof children === "function" ? children(value) : children
    });
};

},{"react":"bmhQu","react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fuQcd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ensurePreventErrorBoundaryRetry", ()=>ensurePreventErrorBoundaryRetry);
parcelHelpers.export(exports, "getHasError", ()=>getHasError);
parcelHelpers.export(exports, "useClearResetErrorBoundary", ()=>useClearResetErrorBoundary);
// src/errorBoundaryUtils.ts
var _react = require("react");
var _queryCore = require("@tanstack/query-core");
"use client";
var ensurePreventErrorBoundaryRetry = (options, errorResetBoundary)=>{
    if (options.suspense || options.throwOnError || options.experimental_prefetchInRender) {
        if (!errorResetBoundary.isReset()) options.retryOnMount = false;
    }
};
var useClearResetErrorBoundary = (errorResetBoundary)=>{
    _react.useEffect(()=>{
        errorResetBoundary.clearReset();
    }, [
        errorResetBoundary
    ]);
};
var getHasError = ({ result, errorResetBoundary, throwOnError, query, suspense })=>{
    return result.isError && !errorResetBoundary.isReset() && !result.isFetching && query && (suspense && result.data === void 0 || (0, _queryCore.shouldThrowError)(throwOnError, [
        result.error,
        query
    ]));
};

},{"react":"bmhQu","@tanstack/query-core":"ku1P9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aLOac":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IsRestoringProvider", ()=>IsRestoringProvider);
parcelHelpers.export(exports, "useIsRestoring", ()=>useIsRestoring);
// src/IsRestoringProvider.ts
var _react = require("react");
"use client";
var IsRestoringContext = _react.createContext(false);
var useIsRestoring = ()=>_react.useContext(IsRestoringContext);
var IsRestoringProvider = IsRestoringContext.Provider;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jrivz":[function(require,module,exports,__globalThis) {
// src/suspense.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultThrowOnError", ()=>defaultThrowOnError);
parcelHelpers.export(exports, "ensureSuspenseTimers", ()=>ensureSuspenseTimers);
parcelHelpers.export(exports, "fetchOptimistic", ()=>fetchOptimistic);
parcelHelpers.export(exports, "shouldSuspend", ()=>shouldSuspend);
parcelHelpers.export(exports, "willFetch", ()=>willFetch);
var defaultThrowOnError = (_error, query)=>query.state.data === void 0;
var ensureSuspenseTimers = (defaultedOptions)=>{
    if (defaultedOptions.suspense) {
        const MIN_SUSPENSE_TIME_MS = 1e3;
        const clamp = (value)=>value === "static" ? value : Math.max(value ?? MIN_SUSPENSE_TIME_MS, MIN_SUSPENSE_TIME_MS);
        const originalStaleTime = defaultedOptions.staleTime;
        defaultedOptions.staleTime = typeof originalStaleTime === "function" ? (...args)=>clamp(originalStaleTime(...args)) : clamp(originalStaleTime);
        if (typeof defaultedOptions.gcTime === "number") defaultedOptions.gcTime = Math.max(defaultedOptions.gcTime, MIN_SUSPENSE_TIME_MS);
    }
};
var willFetch = (result, isRestoring)=>result.isLoading && result.isFetching && !isRestoring;
var shouldSuspend = (defaultedOptions, result)=>(defaultedOptions == null ? void 0 : defaultedOptions.suspense) && result.isPending;
var fetchOptimistic = (defaultedOptions, observer, errorResetBoundary)=>observer.fetchOptimistic(defaultedOptions).catch(()=>{
        errorResetBoundary.clearReset();
    });

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iDROn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSaveOnboardingStep", ()=>useSaveOnboardingStep);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _sessionStore = require("src/store/sessionStore");
function useSaveOnboardingStep() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const { uid, step, data } = payload;
            if (!uid) throw new Error('User UID is required to save onboarding progress');
            const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_SAVE_ONBOARDING_STEP}`;
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    uid,
                    step,
                    data
                })
            });
            if (!response.ok) throw new Error('Failed to save onboarding progress');
            return response.json();
        },
        onSuccess: (_, variables)=>{
            const queryKey = [
                'onboarding-state',
                variables.uid
            ];
            // Update the cache immediately so if they navigate back, they see the new data
            queryClient.setQueryData(queryKey, (oldData)=>{
                if (!oldData || !oldData.onboarding) return oldData;
                const updatedOnboarding = {
                    ...oldData.onboarding
                };
                if (typeof variables.step === 'number') updatedOnboarding.lastCompletedStep = Math.max(updatedOnboarding.lastCompletedStep ?? 0, variables.step);
                if (variables.step === 1) updatedOnboarding.step1_experience = variables.data;
                else if (variables.step === 2) updatedOnboarding.step2_client_types = variables.data;
                else if (variables.step === 3) updatedOnboarding.step3_offers = variables.data;
                else if (variables.step === 4) {
                    if (typeof variables.data === 'object' && variables.data !== null && ('skipped' in variables.data && variables.data.skipped || 'onboardingSkipped' in variables.data && variables.data.onboardingSkipped)) updatedOnboarding.onboardingSkipped = true;
                    else {
                        updatedOnboarding.step4_schedule = variables.data;
                        updatedOnboarding.lastCompletedStep = 4;
                        updatedOnboarding.onboardingSkipped = false;
                        updatedOnboarding.skipped = false;
                    }
                } else if (variables.step === 'skip') updatedOnboarding.onboardingSkipped = true;
                // Keep session store profile in sync immediately
                (0, _sessionStore.sessionStore).getState().updateProfile({
                    onboarding: updatedOnboarding
                });
                const updatedProfile = oldData.profile ? {
                    ...oldData.profile,
                    onboarding: updatedOnboarding
                } : undefined;
                return {
                    ...oldData,
                    onboarding: updatedOnboarding,
                    ...updatedProfile ? {
                        profile: updatedProfile
                    } : {}
                };
            });
            // Still invalidate so the app fetches the real updated state (including profile, lastCompletedStep, etc)
            queryClient.invalidateQueries({
                queryKey
            });
        }
    });
}

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"src/config/api-config":"9oD3c","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kPSO3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "sessionStore", ()=>sessionStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
var _programGeneratorProgressStore = require("src/store/programGeneratorProgressStore");
var _programStore = require("src/store/programStore");
var _subscriptionStore = require("src/store/subscriptionStore");
var _firebase = require("src/config/firebase");
const sessionStore = (0, _zustand.create)()((0, _middleware.persist)((set, get)=>({
        isLoggedIn: false,
        token: null,
        currentUser: null,
        setToken: (token, user)=>set({
                token,
                currentUser: user ? {
                    ...user,
                    uid: user.uid || (0, _firebase.auth).currentUser?.uid
                } : null,
                isLoggedIn: true
            }),
        updateProfile: (updates)=>set((state)=>{
                if (!state.currentUser) return state;
                const updatedUser = {
                    ...state.currentUser,
                    ...updates,
                    uid: updates.uid || state.currentUser.uid || (0, _firebase.auth).currentUser?.uid
                };
                return {
                    currentUser: updatedUser
                };
            }),
        logout: ()=>{
            const currentUid = get().currentUser?.uid;
            if (currentUid) {
                require("8a3dd3eedb640e70").then(({ setTrainerOnlineStatus })=>{
                    setTrainerOnlineStatus(currentUid, false);
                });
                require("88f9d8fd44bb9221").then(({ unsubscribeBrowserPush })=>{
                    unsubscribeBrowserPush(currentUid, 'trainer');
                });
            }
            (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().resetProgress();
            (0, _programStore.clearGeneratedProgram)();
            (0, _subscriptionStore.clearSubscriptionData)();
            set({
                token: null,
                currentUser: null,
                isLoggedIn: false
            });
        }
    }), {
    name: 'auth-storage'
}));

},{"zustand":"dodpK","zustand/middleware":"2zkjt","src/store/programGeneratorProgressStore":"2iAYB","src/store/programStore":"hM1mR","src/store/subscriptionStore":"rMPpj","src/config/firebase":"cmjIE","8a3dd3eedb640e70":"d1HdY","88f9d8fd44bb9221":"feOFD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2iAYB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useProgramGeneratorProgressStore", ()=>useProgramGeneratorProgressStore);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
const useProgramGeneratorProgressStore = (0, _zustand.create)()((0, _middleware.persist)((set)=>({
        programId: null,
        clientId: null,
        progress: {},
        setProgramId: (id)=>set({
                programId: id
            }),
        setClientId: (id)=>set({
                clientId: id
            }),
        setProgress: (progress)=>set({
                progress
            }),
        updateStepProgress: (stepId, data)=>set((state)=>({
                    progress: {
                        ...state.progress,
                        [stepId]: data
                    }
                })),
        resetProgress: ()=>set({
                programId: null,
                clientId: null,
                progress: {}
            })
    }), {
    name: 'program-generator-storage'
}));

},{"zustand":"dodpK","zustand/middleware":"2zkjt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"rMPpj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSubscriptionStore", ()=>useSubscriptionStore);
parcelHelpers.export(exports, "clearSubscriptionData", ()=>clearSubscriptionData);
var _zustand = require("zustand");
var _middleware = require("zustand/middleware");
const defaultBillingInfo = {
    billingType: 'individual',
    fullName: '',
    companyName: '',
    billingEmail: '',
    country: '',
    stateRegion: '',
    addressLine1: '',
    addressLine2: '',
    city: '',
    postcode: '',
    companyRegistrationNumber: '',
    taxVatNumber: '',
    isDefault: true
};
const defaultPaymentMethods = [];
const defaultInvoices = [];
const useSubscriptionStore = (0, _zustand.create)()((0, _middleware.persist)((set)=>({
        status: 'inactive',
        hasTrial: false,
        trialDays: 0,
        trialEndsDate: '',
        billingCycle: 'monthly',
        planName: '',
        monthlyPrice: 0,
        yearlyPrice: 0,
        taxRate: 0,
        nextBillingDate: '',
        accessEndsDate: '',
        gracePeriodEndsDate: '',
        cancellationReason: '',
        billingInfo: defaultBillingInfo,
        paymentMethods: defaultPaymentMethods,
        invoices: defaultInvoices,
        appliedPromo: null,
        submittedTickets: [],
        setStatus: (status)=>set({
                status
            }),
        setBillingCycle: (billingCycle)=>set({
                billingCycle
            }),
        setHasTrial: (hasTrial)=>set({
                hasTrial
            }),
        updateBillingInfo: (info)=>set((state)=>({
                    billingInfo: {
                        ...state.billingInfo,
                        ...info
                    }
                })),
        addPaymentMethod: (cardData)=>set((state)=>{
                const newId = `card_${Date.now()}`;
                const isFirstCard = state.paymentMethods.length === 0;
                const shouldBeDefault = cardData.isDefault || isFirstCard;
                const updatedExisting = shouldBeDefault ? state.paymentMethods.map((c)=>({
                        ...c,
                        isDefault: false
                    })) : state.paymentMethods;
                const newCard = {
                    ...cardData,
                    id: newId,
                    isDefault: shouldBeDefault
                };
                return {
                    paymentMethods: [
                        newCard,
                        ...updatedExisting
                    ]
                };
            }),
        updatePaymentMethod: (id, cardData)=>set((state)=>{
                const shouldBeDefault = cardData.isDefault;
                return {
                    paymentMethods: state.paymentMethods.map((card)=>{
                        if (card.id === id) return {
                            ...card,
                            ...cardData
                        };
                        if (shouldBeDefault) return {
                            ...card,
                            isDefault: false
                        };
                        return card;
                    })
                };
            }),
        removePaymentMethod: (id)=>set((state)=>{
                const remaining = state.paymentMethods.filter((c)=>c.id !== id);
                if (remaining.length > 0 && !remaining.some((c)=>c.isDefault)) remaining[0].isDefault = true;
                return {
                    paymentMethods: remaining
                };
            }),
        setDefaultPaymentMethod: (id)=>set((state)=>({
                    paymentMethods: state.paymentMethods.map((c)=>({
                            ...c,
                            isDefault: c.id === id
                        }))
                })),
        cancelSubscription: (reason, accessEndsDate)=>set((state)=>({
                    status: 'cancelled',
                    cancellationReason: reason || '',
                    accessEndsDate: accessEndsDate || state.accessEndsDate || ''
                })),
        reactivateSubscription: (nextBillingDate)=>set((state)=>({
                    status: 'active',
                    nextBillingDate: nextBillingDate || state.nextBillingDate || ''
                })),
        applyPromoCode: (rawCode, discountPercent = 0)=>{
            const code = rawCode.trim().toUpperCase();
            set({
                appliedPromo: {
                    code,
                    discountPercent
                }
            });
            return {
                success: true,
                message: `Promo code ${code} applied!`,
                discountPercent
            };
        },
        removePromoCode: ()=>set({
                appliedPromo: null
            }),
        addSupportTicket: (ticket)=>set((state)=>({
                    submittedTickets: [
                        {
                            ...ticket,
                            id: `ticket_${Date.now()}`,
                            createdAt: new Date().toISOString()
                        },
                        ...state.submittedTickets
                    ]
                })),
        resetToDefaults: ()=>set({
                status: 'inactive',
                hasTrial: false,
                trialDays: 0,
                trialEndsDate: '',
                billingCycle: 'monthly',
                planName: '',
                monthlyPrice: 0,
                yearlyPrice: 0,
                taxRate: 0,
                nextBillingDate: '',
                accessEndsDate: '',
                gracePeriodEndsDate: '',
                cancellationReason: '',
                billingInfo: defaultBillingInfo,
                paymentMethods: defaultPaymentMethods,
                invoices: defaultInvoices,
                appliedPromo: null,
                submittedTickets: []
            })
    }), {
    name: 'minipt-subscription-storage',
    partialize: (state)=>{
        // Exclude appliedPromo from persistent storage so a promo code is never
        // retained in cache across transactions or browser reloads.
        const rest = {
            ...state
        };
        delete rest.appliedPromo;
        return rest;
    }
}));
const clearSubscriptionData = ()=>{
    useSubscriptionStore.getState().resetToDefaults();
    try {
        useSubscriptionStore.persist?.clearStorage?.();
    } catch  {
    // Ignore storage access errors
    }
    try {
        localStorage.removeItem('minipt-subscription-storage');
        sessionStorage.removeItem('minipt-subscription-storage');
    } catch  {
    // Ignore storage access errors
    }
};

},{"zustand":"dodpK","zustand/middleware":"2zkjt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cmjIE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "app", ()=>app);
parcelHelpers.export(exports, "auth", ()=>auth);
parcelHelpers.export(exports, "db", ()=>db);
parcelHelpers.export(exports, "storage", ()=>storage);
var _app = require("firebase/app");
var _auth = require("firebase/auth");
var _firestore = require("firebase/firestore");
var _storage = require("firebase/storage");
const firebaseConfig = {
    apiKey: 'AIzaSyDlbcm7DpY9ZqunelqxPUreQtjP7P5sw2s',
    authDomain: 'minipt-1.firebaseapp.com',
    databaseURL: 'https://minipt-1-default-rtdb.firebaseio.com',
    projectId: 'minipt-1',
    storageBucket: 'minipt-1.firebasestorage.app',
    messagingSenderId: '975043765451',
    appId: '1:975043765451:web:8c23140dcd9bab954ca74e',
    measurementId: 'G-1P25DVDH56'
};
const app = (0, _app.initializeApp)(firebaseConfig);
const auth = (0, _auth.getAuth)(app);
const isSafariBrowser = ()=>{
    if (typeof navigator === 'undefined' || !navigator.userAgent) return false;
    const ua = navigator.userAgent.toLowerCase();
    const isChromeOrChromium = /chrome|chromium|crios|android/i.test(ua);
    const isFirefox = /firefox|fxios/i.test(ua);
    const isEdge = /edg/i.test(ua);
    const isSafari = /safari/i.test(ua) && !isChromeOrChromium && !isFirefox && !isEdge;
    const isIOS = /iphone|ipad|ipod/i.test(ua) && /webkit/i.test(ua) && !isChromeOrChromium && !isFirefox;
    return Boolean(isSafari || isIOS);
};
const firestoreSettings = {
    ignoreUndefinedProperties: true,
    ...isSafariBrowser() ? {
        experimentalForceLongPolling: true
    } : {}
};
let firestoreInstance;
try {
    firestoreInstance = (0, _firestore.initializeFirestore)(app, firestoreSettings);
} catch  {
    firestoreInstance = (0, _firestore.getFirestore)(app);
}
const db = firestoreInstance;
const storage = (0, _storage.getStorage)(app); // If you ever want to use the local emulator, you can uncomment this block:
 // if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
 //   connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 //   connectFirestoreEmulator(db, '127.0.0.1', 9000);
 // }

},{"firebase/app":"4uLxM","firebase/auth":"dZ6yw","firebase/firestore":"5IgBQ","firebase/storage":"9JHfQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4uLxM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _app = require("@firebase/app");
parcelHelpers.exportAll(_app, exports);
var name = "firebase";
var version = "12.15.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ (0, _app.registerVersion)(name, version, 'app');

},{"@firebase/app":"iO7sa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iO7sa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FirebaseError", ()=>(0, _util.FirebaseError));
parcelHelpers.export(exports, "SDK_VERSION", ()=>SDK_VERSION);
parcelHelpers.export(exports, "_DEFAULT_ENTRY_NAME", ()=>DEFAULT_ENTRY_NAME);
parcelHelpers.export(exports, "_addComponent", ()=>_addComponent);
parcelHelpers.export(exports, "_addOrOverwriteComponent", ()=>_addOrOverwriteComponent);
parcelHelpers.export(exports, "_apps", ()=>_apps);
parcelHelpers.export(exports, "_clearComponents", ()=>_clearComponents);
parcelHelpers.export(exports, "_components", ()=>_components);
parcelHelpers.export(exports, "_getProvider", ()=>_getProvider);
parcelHelpers.export(exports, "_isFirebaseApp", ()=>_isFirebaseApp);
parcelHelpers.export(exports, "_isFirebaseServerApp", ()=>_isFirebaseServerApp);
parcelHelpers.export(exports, "_isFirebaseServerAppSettings", ()=>_isFirebaseServerAppSettings);
parcelHelpers.export(exports, "_registerComponent", ()=>_registerComponent);
parcelHelpers.export(exports, "_removeServiceInstance", ()=>_removeServiceInstance);
parcelHelpers.export(exports, "_serverApps", ()=>_serverApps);
parcelHelpers.export(exports, "deleteApp", ()=>deleteApp);
parcelHelpers.export(exports, "getApp", ()=>getApp);
parcelHelpers.export(exports, "getApps", ()=>getApps);
parcelHelpers.export(exports, "initializeApp", ()=>initializeApp);
parcelHelpers.export(exports, "initializeServerApp", ()=>initializeServerApp);
parcelHelpers.export(exports, "onLog", ()=>onLog);
parcelHelpers.export(exports, "registerVersion", ()=>registerVersion);
parcelHelpers.export(exports, "setLogLevel", ()=>setLogLevel);
var _component = require("@firebase/component");
var _logger = require("@firebase/logger");
var _util = require("@firebase/util");
var _idb = require("idb");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class PlatformLoggerServiceImpl {
    constructor(container){
        this.container = container;
    }
    // In initial implementation, this will be called by installations on
    // auth token refresh, and installations will send this string.
    getPlatformInfoString() {
        const providers = this.container.getProviders();
        // Loop through providers and get library/version pairs from any that are
        // version components.
        return providers.map((provider)=>{
            if (isVersionServiceProvider(provider)) {
                const service = provider.getImmediate();
                return `${service.library}/${service.version}`;
            } else return null;
        }).filter((logString)=>logString).join(' ');
    }
}
/**
 *
 * @param provider check if this provider provides a VersionService
 *
 * NOTE: Using Provider<'app-version'> is a hack to indicate that the provider
 * provides VersionService. The provider is not necessarily a 'app-version'
 * provider.
 */ function isVersionServiceProvider(provider) {
    const component = provider.getComponent();
    return component?.type === "VERSION" /* ComponentType.VERSION */ ;
}
const name$q = "@firebase/app";
const version$1 = "0.15.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const logger = new (0, _logger.Logger)('@firebase/app');
const name$p = "@firebase/app-compat";
const name$o = "@firebase/analytics-compat";
const name$n = "@firebase/analytics";
const name$m = "@firebase/app-check-compat";
const name$l = "@firebase/app-check";
const name$k = "@firebase/auth";
const name$j = "@firebase/auth-compat";
const name$i = "@firebase/database";
const name$h = "@firebase/data-connect";
const name$g = "@firebase/database-compat";
const name$f = "@firebase/functions";
const name$e = "@firebase/functions-compat";
const name$d = "@firebase/installations";
const name$c = "@firebase/installations-compat";
const name$b = "@firebase/messaging";
const name$a = "@firebase/messaging-compat";
const name$9 = "@firebase/performance";
const name$8 = "@firebase/performance-compat";
const name$7 = "@firebase/remote-config";
const name$6 = "@firebase/remote-config-compat";
const name$5 = "@firebase/storage";
const name$4 = "@firebase/storage-compat";
const name$3 = "@firebase/firestore";
const name$2 = "@firebase/ai";
const name$1 = "@firebase/firestore-compat";
const name = "firebase";
const version = "12.15.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The default app name
 *
 * @internal
 */ const DEFAULT_ENTRY_NAME = '[DEFAULT]';
const PLATFORM_LOG_STRING = {
    [name$q]: 'fire-core',
    [name$p]: 'fire-core-compat',
    [name$n]: 'fire-analytics',
    [name$o]: 'fire-analytics-compat',
    [name$l]: 'fire-app-check',
    [name$m]: 'fire-app-check-compat',
    [name$k]: 'fire-auth',
    [name$j]: 'fire-auth-compat',
    [name$i]: 'fire-rtdb',
    [name$h]: 'fire-data-connect',
    [name$g]: 'fire-rtdb-compat',
    [name$f]: 'fire-fn',
    [name$e]: 'fire-fn-compat',
    [name$d]: 'fire-iid',
    [name$c]: 'fire-iid-compat',
    [name$b]: 'fire-fcm',
    [name$a]: 'fire-fcm-compat',
    [name$9]: 'fire-perf',
    [name$8]: 'fire-perf-compat',
    [name$7]: 'fire-rc',
    [name$6]: 'fire-rc-compat',
    [name$5]: 'fire-gcs',
    [name$4]: 'fire-gcs-compat',
    [name$3]: 'fire-fst',
    [name$1]: 'fire-fst-compat',
    [name$2]: 'fire-vertex',
    'fire-js': 'fire-js',
    [name]: 'fire-js-all'
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ const _apps = new Map();
/**
 * @internal
 */ const _serverApps = new Map();
/**
 * Registered components.
 *
 * @internal
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
const _components = new Map();
/**
 * @param component - the component being added to this app's container
 *
 * @internal
 */ function _addComponent(app, component) {
    try {
        app.container.addComponent(component);
    } catch (e) {
        logger.debug(`Component ${component.name} failed to register with FirebaseApp ${app.name}`, e);
    }
}
/**
 *
 * @internal
 */ function _addOrOverwriteComponent(app, component) {
    app.container.addOrOverwriteComponent(component);
}
/**
 *
 * @param component - the component to register
 * @returns whether or not the component is registered successfully
 *
 * @internal
 */ function _registerComponent(component) {
    const componentName = component.name;
    if (_components.has(componentName)) {
        logger.debug(`There were multiple attempts to register component ${componentName}.`);
        return false;
    }
    _components.set(componentName, component);
    // add the component to existing app instances
    for (const app of _apps.values())_addComponent(app, component);
    for (const serverApp of _serverApps.values())_addComponent(serverApp, component);
    return true;
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 *
 * @returns the provider for the service with the matching name
 *
 * @internal
 */ function _getProvider(app, name) {
    const heartbeatController = app.container.getProvider('heartbeat').getImmediate({
        optional: true
    });
    if (heartbeatController) heartbeatController.triggerHeartbeat();
    return app.container.getProvider(name);
}
/**
 *
 * @param app - FirebaseApp instance
 * @param name - service name
 * @param instanceIdentifier - service instance identifier in case the service supports multiple instances
 *
 * @internal
 */ function _removeServiceInstance(app, name, instanceIdentifier = DEFAULT_ENTRY_NAME) {
    _getProvider(app, name).clearInstance(instanceIdentifier);
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provide object is of type FirebaseApp.
 *
 * @internal
 */ function _isFirebaseApp(obj) {
    return obj.options !== undefined;
}
/**
 *
 * @param obj - an object of type FirebaseApp, FirebaseOptions or FirebaseAppSettings.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function _isFirebaseServerAppSettings(obj) {
    if (_isFirebaseApp(obj)) return false;
    return 'authIdToken' in obj || 'appCheckToken' in obj || 'releaseOnDeref' in obj || 'automaticDataCollectionEnabled' in obj;
}
/**
 *
 * @param obj - an object of type FirebaseApp.
 *
 * @returns true if the provided object is of type FirebaseServerAppImpl.
 *
 * @internal
 */ function _isFirebaseServerApp(obj) {
    if (obj === null || obj === undefined) return false;
    return obj.settings !== undefined;
}
/**
 * Test only
 *
 * @internal
 */ function _clearComponents() {
    _components.clear();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ERRORS = {
    ["no-app" /* AppError.NO_APP */ ]: "No Firebase App '{$appName}' has been created - call initializeApp() first",
    ["bad-app-name" /* AppError.BAD_APP_NAME */ ]: "Illegal App name: '{$appName}'",
    ["duplicate-app" /* AppError.DUPLICATE_APP */ ]: "Firebase App named '{$appName}' already exists with different options or config",
    ["app-deleted" /* AppError.APP_DELETED */ ]: "Firebase App named '{$appName}' already deleted",
    ["server-app-deleted" /* AppError.SERVER_APP_DELETED */ ]: 'Firebase Server App has been deleted',
    ["no-options" /* AppError.NO_OPTIONS */ ]: 'Need to provide options, when not being deployed to hosting via source.',
    ["invalid-app-argument" /* AppError.INVALID_APP_ARGUMENT */ ]: "firebase.{$appName}() takes either no argument or a Firebase App instance.",
    ["invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ ]: 'First argument to `onLog` must be null or a function.',
    ["idb-open" /* AppError.IDB_OPEN */ ]: 'Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-get" /* AppError.IDB_GET */ ]: 'Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-set" /* AppError.IDB_WRITE */ ]: 'Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.',
    ["idb-delete" /* AppError.IDB_DELETE */ ]: 'Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.',
    ["finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ ]: 'FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.',
    ["invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ ]: 'FirebaseServerApp is not for use in browser environments.'
};
const ERROR_FACTORY = new (0, _util.ErrorFactory)('app', 'Firebase', ERRORS);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class FirebaseAppImpl {
    constructor(options, config, container){
        this._isDeleted = false;
        this._options = {
            ...options
        };
        this._config = {
            ...config
        };
        this._name = config.name;
        this._automaticDataCollectionEnabled = config.automaticDataCollectionEnabled;
        this._container = container;
        this.container.addComponent(new (0, _component.Component)('app', ()=>this, "PUBLIC" /* ComponentType.PUBLIC */ ));
    }
    get automaticDataCollectionEnabled() {
        this.checkDestroyed();
        return this._automaticDataCollectionEnabled;
    }
    set automaticDataCollectionEnabled(val) {
        this.checkDestroyed();
        this._automaticDataCollectionEnabled = val;
    }
    get name() {
        this.checkDestroyed();
        return this._name;
    }
    get options() {
        this.checkDestroyed();
        return this._options;
    }
    get config() {
        this.checkDestroyed();
        return this._config;
    }
    get container() {
        return this._container;
    }
    get isDeleted() {
        return this._isDeleted;
    }
    set isDeleted(val) {
        this._isDeleted = val;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw ERROR_FACTORY.create("app-deleted" /* AppError.APP_DELETED */ , {
            appName: this._name
        });
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Parse the token and check to see if the `exp` claim is in the future.
// Reports an error to the console if the token or claim could not be parsed, or if `exp` is in
// the past.
function validateTokenTTL(base64Token, tokenName) {
    const secondPart = (0, _util.base64Decode)(base64Token.split('.')[1]);
    if (secondPart === null) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: second part could not be parsed.`);
        return;
    }
    const expClaim = JSON.parse(secondPart).exp;
    if (expClaim === undefined) {
        console.error(`FirebaseServerApp ${tokenName} is invalid: expiration claim could not be parsed`);
        return;
    }
    const exp = JSON.parse(secondPart).exp * 1000;
    const now = new Date().getTime();
    const diff = exp - now;
    if (diff <= 0) console.error(`FirebaseServerApp ${tokenName} is invalid: the token has expired.`);
}
class FirebaseServerAppImpl extends FirebaseAppImpl {
    constructor(options, serverConfig, name, container){
        // Build configuration parameters for the FirebaseAppImpl base class.
        const automaticDataCollectionEnabled = serverConfig.automaticDataCollectionEnabled !== undefined ? serverConfig.automaticDataCollectionEnabled : true;
        // Create the FirebaseAppSettings object for the FirebaseAppImp constructor.
        const config = {
            name,
            automaticDataCollectionEnabled
        };
        if (options.apiKey !== undefined) // Construct the parent FirebaseAppImp object.
        super(options, config, container);
        else {
            const appImpl = options;
            super(appImpl.options, config, container);
        }
        // Now construct the data for the FirebaseServerAppImpl.
        this._serverConfig = {
            automaticDataCollectionEnabled,
            ...serverConfig
        };
        // Ensure that the current time is within the `authIdtoken` window of validity.
        if (this._serverConfig.authIdToken) validateTokenTTL(this._serverConfig.authIdToken, 'authIdToken');
        // Ensure that the current time is within the `appCheckToken` window of validity.
        if (this._serverConfig.appCheckToken) validateTokenTTL(this._serverConfig.appCheckToken, 'appCheckToken');
        this._finalizationRegistry = null;
        if (typeof FinalizationRegistry !== 'undefined') this._finalizationRegistry = new FinalizationRegistry(()=>{
            this.automaticCleanup();
        });
        this._refCount = 0;
        this.incRefCount(this._serverConfig.releaseOnDeref);
        // Do not retain a hard reference to the dref object, otherwise the FinalizationRegistry
        // will never trigger.
        this._serverConfig.releaseOnDeref = undefined;
        serverConfig.releaseOnDeref = undefined;
        registerVersion(name$q, version$1, 'serverapp');
    }
    toJSON() {
        return undefined;
    }
    get refCount() {
        return this._refCount;
    }
    // Increment the reference count of this server app. If an object is provided, register it
    // with the finalization registry.
    incRefCount(obj) {
        if (this.isDeleted) return;
        this._refCount++;
        if (obj !== undefined && this._finalizationRegistry !== null) this._finalizationRegistry.register(obj, this);
    }
    // Decrement the reference count.
    decRefCount() {
        if (this.isDeleted) return 0;
        return --this._refCount;
    }
    // Invoked by the FinalizationRegistry callback to note that this app should go through its
    // reference counts and delete itself if no reference count remain. The coordinating logic that
    // handles this is in deleteApp(...).
    automaticCleanup() {
        deleteApp(this);
    }
    get settings() {
        this.checkDestroyed();
        return this._serverConfig;
    }
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */ checkDestroyed() {
        if (this.isDeleted) throw ERROR_FACTORY.create("server-app-deleted" /* AppError.SERVER_APP_DELETED */ );
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The current SDK version.
 *
 * @public
 */ const SDK_VERSION = version;
function initializeApp(_options, rawConfig = {}) {
    let options = _options;
    if (typeof rawConfig !== 'object') {
        const name = rawConfig;
        rawConfig = {
            name
        };
    }
    const config = {
        name: DEFAULT_ENTRY_NAME,
        automaticDataCollectionEnabled: true,
        ...rawConfig
    };
    const name = config.name;
    if (typeof name !== 'string' || !name) throw ERROR_FACTORY.create("bad-app-name" /* AppError.BAD_APP_NAME */ , {
        appName: String(name)
    });
    options || (options = (0, _util.getDefaultAppConfig)());
    if (!options) throw ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    const existingApp = _apps.get(name);
    if (existingApp) {
        // return the existing app if options and config deep equal the ones in the existing app.
        if ((0, _util.deepEqual)(options, existingApp.options) && (0, _util.deepEqual)(config, existingApp.config)) return existingApp;
        else throw ERROR_FACTORY.create("duplicate-app" /* AppError.DUPLICATE_APP */ , {
            appName: name
        });
    }
    const container = new (0, _component.ComponentContainer)(name);
    for (const component of _components.values())container.addComponent(component);
    const newApp = new FirebaseAppImpl(options, config, container);
    _apps.set(name, newApp);
    return newApp;
}
function initializeServerApp(_options, _serverAppConfig = {}) {
    if ((0, _util.isBrowser)() && !(0, _util.isWebWorker)()) // FirebaseServerApp isn't designed to be run in browsers.
    throw ERROR_FACTORY.create("invalid-server-app-environment" /* AppError.INVALID_SERVER_APP_ENVIRONMENT */ );
    let firebaseOptions;
    let serverAppSettings = _serverAppConfig || {};
    if (_options) {
        if (_isFirebaseApp(_options)) firebaseOptions = _options.options;
        else if (_isFirebaseServerAppSettings(_options)) serverAppSettings = _options;
        else firebaseOptions = _options;
    }
    if (serverAppSettings.automaticDataCollectionEnabled === undefined) serverAppSettings.automaticDataCollectionEnabled = true;
    firebaseOptions || (firebaseOptions = (0, _util.getDefaultAppConfig)());
    if (!firebaseOptions) throw ERROR_FACTORY.create("no-options" /* AppError.NO_OPTIONS */ );
    // Build an app name based on a hash of the configuration options.
    const nameObj = {
        ...serverAppSettings,
        ...firebaseOptions
    };
    // However, Do not mangle the name based on releaseOnDeref, since it will vary between the
    // construction of FirebaseServerApp instances. For example, if the object is the request headers.
    if (nameObj.releaseOnDeref !== undefined) delete nameObj.releaseOnDeref;
    const hashCode = (s)=>{
        return [
            ...s
        ].reduce((hash, c)=>Math.imul(31, hash) + c.charCodeAt(0) | 0, 0);
    };
    if (serverAppSettings.releaseOnDeref !== undefined) {
        if (typeof FinalizationRegistry === 'undefined') throw ERROR_FACTORY.create("finalization-registry-not-supported" /* AppError.FINALIZATION_REGISTRY_NOT_SUPPORTED */ , {});
    }
    const nameString = '' + hashCode(JSON.stringify(nameObj));
    const existingApp = _serverApps.get(nameString);
    if (existingApp) {
        existingApp.incRefCount(serverAppSettings.releaseOnDeref);
        return existingApp;
    }
    const container = new (0, _component.ComponentContainer)(nameString);
    for (const component of _components.values())container.addComponent(component);
    const newApp = new FirebaseServerAppImpl(firebaseOptions, serverAppSettings, nameString, container);
    _serverApps.set(nameString, newApp);
    return newApp;
}
/**
 * Retrieves a {@link @firebase/app#FirebaseApp} instance.
 *
 * When called with no arguments, the default app is returned. When an app name
 * is provided, the app corresponding to that name is returned.
 *
 * An exception is thrown if the app being retrieved has not yet been
 * initialized.
 *
 * @example
 * ```javascript
 * // Return the default app
 * const app = getApp();
 * ```
 *
 * @example
 * ```javascript
 * // Return a named app
 * const otherApp = getApp("otherApp");
 * ```
 *
 * @param name - Optional name of the app to return. If no name is
 *   provided, the default is `"[DEFAULT]"`.
 *
 * @returns The app corresponding to the provided app name.
 *   If no app name is provided, the default app is returned.
 *
 * @public
 */ function getApp(name = DEFAULT_ENTRY_NAME) {
    const app = _apps.get(name);
    if (!app && name === DEFAULT_ENTRY_NAME && (0, _util.getDefaultAppConfig)()) return initializeApp();
    if (!app) throw ERROR_FACTORY.create("no-app" /* AppError.NO_APP */ , {
        appName: name
    });
    return app;
}
/**
 * A (read-only) array of all initialized apps.
 * @public
 */ function getApps() {
    return Array.from(_apps.values());
}
/**
 * Renders this app unusable and frees the resources of all associated
 * services.
 *
 * @example
 * ```javascript
 * deleteApp(app)
 *   .then(function() {
 *     console.log("App deleted successfully");
 *   })
 *   .catch(function(error) {
 *     console.log("Error deleting app:", error);
 *   });
 * ```
 *
 * @public
 */ async function deleteApp(app) {
    let cleanupProviders = false;
    const name = app.name;
    if (_apps.has(name)) {
        cleanupProviders = true;
        _apps.delete(name);
    } else if (_serverApps.has(name)) {
        const firebaseServerApp = app;
        if (firebaseServerApp.decRefCount() <= 0) {
            _serverApps.delete(name);
            cleanupProviders = true;
        }
    }
    if (cleanupProviders) {
        await Promise.all(app.container.getProviders().map((provider)=>provider.delete()));
        app.isDeleted = true;
    }
}
/**
 * Registers a library's name and version for platform logging purposes.
 * @param library - Name of 1p or 3p library (e.g. firestore, angularfire)
 * @param version - Current version of that library.
 * @param variant - Bundle variant, e.g., node, rn, etc.
 *
 * @public
 */ function registerVersion(libraryKeyOrName, version, variant) {
    // TODO: We can use this check to whitelist strings when/if we set up
    // a good whitelist system.
    let library = PLATFORM_LOG_STRING[libraryKeyOrName] ?? libraryKeyOrName;
    if (variant) library += `-${variant}`;
    const libraryMismatch = library.match(/\s|\//);
    const versionMismatch = version.match(/\s|\//);
    if (libraryMismatch || versionMismatch) {
        const warning = [
            `Unable to register library "${library}" with version "${version}":`
        ];
        if (libraryMismatch) warning.push(`library name "${library}" contains illegal characters (whitespace or "/")`);
        if (libraryMismatch && versionMismatch) warning.push('and');
        if (versionMismatch) warning.push(`version name "${version}" contains illegal characters (whitespace or "/")`);
        logger.warn(warning.join(' '));
        return;
    }
    _registerComponent(new (0, _component.Component)(`${library}-version`, ()=>({
            library,
            version
        }), "VERSION" /* ComponentType.VERSION */ ));
}
/**
 * Sets log handler for all Firebase SDKs.
 * @param logCallback - An optional custom log handler that executes user code whenever
 * the Firebase SDK makes a logging call.
 *
 * @public
 */ function onLog(logCallback, options) {
    if (logCallback !== null && typeof logCallback !== 'function') throw ERROR_FACTORY.create("invalid-log-argument" /* AppError.INVALID_LOG_ARGUMENT */ );
    (0, _logger.setUserLogHandler)(logCallback, options);
}
/**
 * Sets log level for all Firebase SDKs.
 *
 * All of the log types above the current log level are captured (i.e. if
 * you set the log level to `info`, errors are logged, but `debug` and
 * `verbose` logs are not).
 *
 * @public
 */ function setLogLevel(logLevel) {
    (0, _logger.setLogLevel)(logLevel);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DB_NAME = 'firebase-heartbeat-database';
const DB_VERSION = 1;
const STORE_NAME = 'firebase-heartbeat-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) dbPromise = (0, _idb.openDB)(DB_NAME, DB_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    try {
                        db.createObjectStore(STORE_NAME);
                    } catch (e) {
                        // Safari/iOS browsers throw occasional exceptions on
                        // db.createObjectStore() that may be a bug. Avoid blocking
                        // the rest of the app functionality.
                        console.warn(e);
                    }
            }
        }
    }).catch((e)=>{
        throw ERROR_FACTORY.create("idb-open" /* AppError.IDB_OPEN */ , {
            originalErrorMessage: e.message
        });
    });
    return dbPromise;
}
async function readHeartbeatsFromIndexedDB(app) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME);
        const result = await tx.objectStore(STORE_NAME).get(computeKey(app));
        // We already have the value but tx.done can throw,
        // so we need to await it here to catch errors
        await tx.done;
        return result;
    } catch (e) {
        if (e instanceof (0, _util.FirebaseError)) logger.warn(e.message);
        else {
            const idbGetError = ERROR_FACTORY.create("idb-get" /* AppError.IDB_GET */ , {
                originalErrorMessage: e?.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
async function writeHeartbeatsToIndexedDB(app, heartbeatObject) {
    try {
        const db = await getDbPromise();
        const tx = db.transaction(STORE_NAME, 'readwrite');
        const objectStore = tx.objectStore(STORE_NAME);
        await objectStore.put(heartbeatObject, computeKey(app));
        await tx.done;
    } catch (e) {
        if (e instanceof (0, _util.FirebaseError)) logger.warn(e.message);
        else {
            const idbGetError = ERROR_FACTORY.create("idb-set" /* AppError.IDB_WRITE */ , {
                originalErrorMessage: e?.message
            });
            logger.warn(idbGetError.message);
        }
    }
}
function computeKey(app) {
    return `${app.name}!${app.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const MAX_HEADER_BYTES = 1024;
const MAX_NUM_STORED_HEARTBEATS = 30;
class HeartbeatServiceImpl {
    constructor(container){
        this.container = container;
        /**
         * In-memory cache for heartbeats, used by getHeartbeatsHeader() to generate
         * the header string.
         * Stores one record per date. This will be consolidated into the standard
         * format of one record per user agent string before being sent as a header.
         * Populated from indexedDB when the controller is instantiated and should
         * be kept in sync with indexedDB.
         * Leave public for easier testing.
         */ this._heartbeatsCache = null;
        const app = this.container.getProvider('app').getImmediate();
        this._storage = new HeartbeatStorageImpl(app);
        this._heartbeatsCachePromise = this._storage.read().then((result)=>{
            this._heartbeatsCache = result;
            return result;
        });
    }
    /**
     * Called to report a heartbeat. The function will generate
     * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
     * to IndexedDB.
     * Note that we only store one heartbeat per day. So if a heartbeat for today is
     * already logged, subsequent calls to this function in the same day will be ignored.
     */ async triggerHeartbeat() {
        try {
            const platformLogger = this.container.getProvider('platform-logger').getImmediate();
            // This is the "Firebase user agent" string from the platform logger
            // service, not the browser user agent.
            const agent = platformLogger.getPlatformInfoString();
            const date = getUTCDateString();
            if (this._heartbeatsCache?.heartbeats == null) {
                this._heartbeatsCache = await this._heartbeatsCachePromise;
                // If we failed to construct a heartbeats cache, then return immediately.
                if (this._heartbeatsCache?.heartbeats == null) return;
            }
            // Do not store a heartbeat if one is already stored for this day
            // or if a header has already been sent today.
            if (this._heartbeatsCache.lastSentHeartbeatDate === date || this._heartbeatsCache.heartbeats.some((singleDateHeartbeat)=>singleDateHeartbeat.date === date)) return;
            else {
                // There is no entry for this date. Create one.
                this._heartbeatsCache.heartbeats.push({
                    date,
                    agent
                });
                // If the number of stored heartbeats exceeds the maximum number of stored heartbeats, remove the heartbeat with the earliest date.
                // Since this is executed each time a heartbeat is pushed, the limit can only be exceeded by one, so only one needs to be removed.
                if (this._heartbeatsCache.heartbeats.length > MAX_NUM_STORED_HEARTBEATS) {
                    const earliestHeartbeatIdx = getEarliestHeartbeatIdx(this._heartbeatsCache.heartbeats);
                    this._heartbeatsCache.heartbeats.splice(earliestHeartbeatIdx, 1);
                }
            }
            return this._storage.overwrite(this._heartbeatsCache);
        } catch (e) {
            logger.warn(e);
        }
    }
    /**
     * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
     * It also clears all heartbeats from memory as well as in IndexedDB.
     *
     * NOTE: Consuming product SDKs should not send the header if this method
     * returns an empty string.
     */ async getHeartbeatsHeader() {
        try {
            if (this._heartbeatsCache === null) await this._heartbeatsCachePromise;
            // If it's still null or the array is empty, there is no data to send.
            if (this._heartbeatsCache?.heartbeats == null || this._heartbeatsCache.heartbeats.length === 0) return '';
            const date = getUTCDateString();
            // Extract as many heartbeats from the cache as will fit under the size limit.
            const { heartbeatsToSend, unsentEntries } = extractHeartbeatsForHeader(this._heartbeatsCache.heartbeats);
            const headerString = (0, _util.base64urlEncodeWithoutPadding)(JSON.stringify({
                version: 2,
                heartbeats: heartbeatsToSend
            }));
            // Store last sent date to prevent another being logged/sent for the same day.
            this._heartbeatsCache.lastSentHeartbeatDate = date;
            if (unsentEntries.length > 0) {
                // Store any unsent entries if they exist.
                this._heartbeatsCache.heartbeats = unsentEntries;
                // This seems more likely than emptying the array (below) to lead to some odd state
                // since the cache isn't empty and this will be called again on the next request,
                // and is probably safest if we await it.
                await this._storage.overwrite(this._heartbeatsCache);
            } else {
                this._heartbeatsCache.heartbeats = [];
                // Do not wait for this, to reduce latency.
                this._storage.overwrite(this._heartbeatsCache);
            }
            return headerString;
        } catch (e) {
            logger.warn(e);
            return '';
        }
    }
}
function getUTCDateString() {
    const today = new Date();
    // Returns date format 'YYYY-MM-DD'
    return today.toISOString().substring(0, 10);
}
function extractHeartbeatsForHeader(heartbeatsCache, maxSize = MAX_HEADER_BYTES) {
    // Heartbeats grouped by user agent in the standard format to be sent in
    // the header.
    const heartbeatsToSend = [];
    // Single date format heartbeats that are not sent.
    let unsentEntries = heartbeatsCache.slice();
    for (const singleDateHeartbeat of heartbeatsCache){
        // Look for an existing entry with the same user agent.
        const heartbeatEntry = heartbeatsToSend.find((hb)=>hb.agent === singleDateHeartbeat.agent);
        if (!heartbeatEntry) {
            // If no entry for this user agent exists, create one.
            heartbeatsToSend.push({
                agent: singleDateHeartbeat.agent,
                dates: [
                    singleDateHeartbeat.date
                ]
            });
            if (countBytes(heartbeatsToSend) > maxSize) {
                // If the header would exceed max size, remove the added heartbeat
                // entry and stop adding to the header.
                heartbeatsToSend.pop();
                break;
            }
        } else {
            heartbeatEntry.dates.push(singleDateHeartbeat.date);
            // If the header would exceed max size, remove the added date
            // and stop adding to the header.
            if (countBytes(heartbeatsToSend) > maxSize) {
                heartbeatEntry.dates.pop();
                break;
            }
        }
        // Pop unsent entry from queue. (Skipped if adding the entry exceeded
        // quota and the loop breaks early.)
        unsentEntries = unsentEntries.slice(1);
    }
    return {
        heartbeatsToSend,
        unsentEntries
    };
}
class HeartbeatStorageImpl {
    constructor(app){
        this.app = app;
        this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
    }
    async runIndexedDBEnvironmentCheck() {
        if (!(0, _util.isIndexedDBAvailable)()) return false;
        else return (0, _util.validateIndexedDBOpenable)().then(()=>true).catch(()=>false);
    }
    /**
     * Read all heartbeats.
     */ async read() {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return {
            heartbeats: []
        };
        else {
            const idbHeartbeatObject = await readHeartbeatsFromIndexedDB(this.app);
            if (idbHeartbeatObject?.heartbeats) return idbHeartbeatObject;
            else return {
                heartbeats: []
            };
        }
    }
    // overwrite the storage with the provided heartbeats
    async overwrite(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: heartbeatsObject.heartbeats
            });
        }
    }
    // add heartbeats
    async add(heartbeatsObject) {
        const canUseIndexedDB = await this._canUseIndexedDBPromise;
        if (!canUseIndexedDB) return;
        else {
            const existingHeartbeatsObject = await this.read();
            return writeHeartbeatsToIndexedDB(this.app, {
                lastSentHeartbeatDate: heartbeatsObject.lastSentHeartbeatDate ?? existingHeartbeatsObject.lastSentHeartbeatDate,
                heartbeats: [
                    ...existingHeartbeatsObject.heartbeats,
                    ...heartbeatsObject.heartbeats
                ]
            });
        }
    }
}
/**
 * Calculate bytes of a HeartbeatsByUserAgent array after being wrapped
 * in a platform logging header JSON object, stringified, and converted
 * to base 64.
 */ function countBytes(heartbeatsCache) {
    // base64 has a restricted set of characters, all of which should be 1 byte.
    return (0, _util.base64urlEncodeWithoutPadding)(// heartbeatsCache wrapper properties
    JSON.stringify({
        version: 2,
        heartbeats: heartbeatsCache
    })).length;
}
/**
 * Returns the index of the heartbeat with the earliest date.
 * If the heartbeats array is empty, -1 is returned.
 */ function getEarliestHeartbeatIdx(heartbeats) {
    if (heartbeats.length === 0) return -1;
    let earliestHeartbeatIdx = 0;
    let earliestHeartbeatDate = heartbeats[0].date;
    for(let i = 1; i < heartbeats.length; i++)if (heartbeats[i].date < earliestHeartbeatDate) {
        earliestHeartbeatDate = heartbeats[i].date;
        earliestHeartbeatIdx = i;
    }
    return earliestHeartbeatIdx;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function registerCoreComponents(variant) {
    _registerComponent(new (0, _component.Component)('platform-logger', (container)=>new PlatformLoggerServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    _registerComponent(new (0, _component.Component)('heartbeat', (container)=>new HeartbeatServiceImpl(container), "PRIVATE" /* ComponentType.PRIVATE */ ));
    // Register `app` package.
    registerVersion(name$q, version$1, variant);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    registerVersion(name$q, version$1, 'esm2020');
    // Register platform SDK identifier (no version).
    registerVersion('fire-js', '');
}
/**
 * Firebase App
 *
 * @remarks This package coordinates the communication between the different Firebase components
 * @packageDocumentation
 */ registerCoreComponents('');

},{"@firebase/component":"6VF6E","@firebase/logger":"kY52V","@firebase/util":"fHqXn","idb":"d2rZl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6VF6E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Component", ()=>Component);
parcelHelpers.export(exports, "ComponentContainer", ()=>ComponentContainer);
parcelHelpers.export(exports, "Provider", ()=>Provider);
var _util = require("@firebase/util");
/**
 * Component for service name T, e.g. `auth`, `auth-internal`
 */ class Component {
    /**
     *
     * @param name The public service name, e.g. app, auth, firestore, database
     * @param instanceFactory Service factory responsible for creating the public interface
     * @param type whether the service provided by the component is public or private
     */ constructor(name, instanceFactory, type){
        this.name = name;
        this.instanceFactory = instanceFactory;
        this.type = type;
        this.multipleInstances = false;
        /**
         * Properties to be added to the service namespace
         */ this.serviceProps = {};
        this.instantiationMode = "LAZY" /* InstantiationMode.LAZY */ ;
        this.onInstanceCreated = null;
    }
    setInstantiationMode(mode) {
        this.instantiationMode = mode;
        return this;
    }
    setMultipleInstances(multipleInstances) {
        this.multipleInstances = multipleInstances;
        return this;
    }
    setServiceProps(props) {
        this.serviceProps = props;
        return this;
    }
    setInstanceCreatedCallback(callback) {
        this.onInstanceCreated = callback;
        return this;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DEFAULT_ENTRY_NAME = '[DEFAULT]';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for instance for service name T, e.g. 'auth', 'auth-internal'
 * NameServiceMapping[T] is an alias for the type of the instance
 */ class Provider {
    constructor(name, container){
        this.name = name;
        this.container = container;
        this.component = null;
        this.instances = new Map();
        this.instancesDeferred = new Map();
        this.instancesOptions = new Map();
        this.onInitCallbacks = new Map();
    }
    /**
     * @param identifier A provider can provide multiple instances of a service
     * if this.component.multipleInstances is true.
     */ get(identifier) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        if (!this.instancesDeferred.has(normalizedIdentifier)) {
            const deferred = new (0, _util.Deferred)();
            this.instancesDeferred.set(normalizedIdentifier, deferred);
            if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) // initialize the service if it can be auto-initialized
            try {
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                if (instance) deferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception during get(), it should not cause
            // a fatal error. We just return the unresolved promise in this case.
            }
        }
        return this.instancesDeferred.get(normalizedIdentifier).promise;
    }
    getImmediate(options) {
        // if multipleInstances is not supported, use the default name
        const normalizedIdentifier = this.normalizeInstanceIdentifier(options?.identifier);
        const optional = options?.optional ?? false;
        if (this.isInitialized(normalizedIdentifier) || this.shouldAutoInitialize()) try {
            return this.getOrInitializeService({
                instanceIdentifier: normalizedIdentifier
            });
        } catch (e) {
            if (optional) return null;
            else throw e;
        }
        else {
            // In case a component is not initialized and should/cannot be auto-initialized at the moment, return null if the optional flag is set, or throw
            if (optional) return null;
            else throw Error(`Service ${this.name} is not available`);
        }
    }
    getComponent() {
        return this.component;
    }
    setComponent(component) {
        if (component.name !== this.name) throw Error(`Mismatching Component ${component.name} for Provider ${this.name}.`);
        if (this.component) throw Error(`Component for ${this.name} has already been provided`);
        this.component = component;
        // return early without attempting to initialize the component if the component requires explicit initialization (calling `Provider.initialize()`)
        if (!this.shouldAutoInitialize()) return;
        // if the service is eager, initialize the default instance
        if (isComponentEager(component)) try {
            this.getOrInitializeService({
                instanceIdentifier: DEFAULT_ENTRY_NAME
            });
        } catch (e) {
        // when the instance factory for an eager Component throws an exception during the eager
        // initialization, it should not cause a fatal error.
        // TODO: Investigate if we need to make it configurable, because some component may want to cause
        // a fatal error in this case?
        }
        // Create service instances for the pending promises and resolve them
        // NOTE: if this.multipleInstances is false, only the default instance will be created
        // and all promises with resolve with it regardless of the identifier.
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            try {
                // `getOrInitializeService()` should always return a valid instance since a component is guaranteed. use ! to make typescript happy.
                const instance = this.getOrInitializeService({
                    instanceIdentifier: normalizedIdentifier
                });
                instanceDeferred.resolve(instance);
            } catch (e) {
            // when the instance factory throws an exception, it should not cause
            // a fatal error. We just leave the promise unresolved.
            }
        }
    }
    clearInstance(identifier = DEFAULT_ENTRY_NAME) {
        this.instancesDeferred.delete(identifier);
        this.instancesOptions.delete(identifier);
        this.instances.delete(identifier);
    }
    // app.delete() will call this method on every provider to delete the services
    // TODO: should we mark the provider as deleted?
    async delete() {
        const services = Array.from(this.instances.values());
        await Promise.all([
            ...services.filter((service)=>'INTERNAL' in service) // legacy services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service.INTERNAL.delete()),
            ...services.filter((service)=>'_delete' in service) // modularized services
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .map((service)=>service._delete())
        ]);
    }
    isComponentSet() {
        return this.component != null;
    }
    isInitialized(identifier = DEFAULT_ENTRY_NAME) {
        return this.instances.has(identifier);
    }
    getOptions(identifier = DEFAULT_ENTRY_NAME) {
        return this.instancesOptions.get(identifier) || {};
    }
    initialize(opts = {}) {
        const { options = {} } = opts;
        const normalizedIdentifier = this.normalizeInstanceIdentifier(opts.instanceIdentifier);
        if (this.isInitialized(normalizedIdentifier)) throw Error(`${this.name}(${normalizedIdentifier}) has already been initialized`);
        if (!this.isComponentSet()) throw Error(`Component ${this.name} has not been registered yet`);
        const instance = this.getOrInitializeService({
            instanceIdentifier: normalizedIdentifier,
            options
        });
        // resolve any pending promise waiting for the service instance
        for (const [instanceIdentifier, instanceDeferred] of this.instancesDeferred.entries()){
            const normalizedDeferredIdentifier = this.normalizeInstanceIdentifier(instanceIdentifier);
            if (normalizedIdentifier === normalizedDeferredIdentifier) instanceDeferred.resolve(instance);
        }
        return instance;
    }
    /**
     *
     * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
     * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
     *
     * @param identifier An optional instance identifier
     * @returns a function to unregister the callback
     */ onInit(callback, identifier) {
        const normalizedIdentifier = this.normalizeInstanceIdentifier(identifier);
        const existingCallbacks = this.onInitCallbacks.get(normalizedIdentifier) ?? new Set();
        existingCallbacks.add(callback);
        this.onInitCallbacks.set(normalizedIdentifier, existingCallbacks);
        const existingInstance = this.instances.get(normalizedIdentifier);
        if (existingInstance) callback(existingInstance, normalizedIdentifier);
        return ()=>{
            existingCallbacks.delete(callback);
        };
    }
    /**
     * Invoke onInit callbacks synchronously
     * @param instance the service instance`
     */ invokeOnInitCallbacks(instance, identifier) {
        const callbacks = this.onInitCallbacks.get(identifier);
        if (!callbacks) return;
        for (const callback of callbacks)try {
            callback(instance, identifier);
        } catch  {
        // ignore errors in the onInit callback
        }
    }
    getOrInitializeService({ instanceIdentifier, options = {} }) {
        let instance = this.instances.get(instanceIdentifier);
        if (!instance && this.component) {
            instance = this.component.instanceFactory(this.container, {
                instanceIdentifier: normalizeIdentifierForFactory(instanceIdentifier),
                options
            });
            this.instances.set(instanceIdentifier, instance);
            this.instancesOptions.set(instanceIdentifier, options);
            /**
             * Invoke onInit listeners.
             * Note this.component.onInstanceCreated is different, which is used by the component creator,
             * while onInit listeners are registered by consumers of the provider.
             */ this.invokeOnInitCallbacks(instance, instanceIdentifier);
            /**
             * Order is important
             * onInstanceCreated() should be called after this.instances.set(instanceIdentifier, instance); which
             * makes `isInitialized()` return true.
             */ if (this.component.onInstanceCreated) try {
                this.component.onInstanceCreated(this.container, instanceIdentifier, instance);
            } catch  {
            // ignore errors in the onInstanceCreatedCallback
            }
        }
        return instance || null;
    }
    normalizeInstanceIdentifier(identifier = DEFAULT_ENTRY_NAME) {
        if (this.component) return this.component.multipleInstances ? identifier : DEFAULT_ENTRY_NAME;
        else return identifier; // assume multiple instances are supported before the component is provided.
    }
    shouldAutoInitialize() {
        return !!this.component && this.component.instantiationMode !== "EXPLICIT" /* InstantiationMode.EXPLICIT */ ;
    }
}
// undefined should be passed to the service factory for the default instance
function normalizeIdentifierForFactory(identifier) {
    return identifier === DEFAULT_ENTRY_NAME ? undefined : identifier;
}
function isComponentEager(component) {
    return component.instantiationMode === "EAGER" /* InstantiationMode.EAGER */ ;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * ComponentContainer that provides Providers for service name T, e.g. `auth`, `auth-internal`
 */ class ComponentContainer {
    constructor(name){
        this.name = name;
        this.providers = new Map();
    }
    /**
     *
     * @param component Component being added
     * @param overwrite When a component with the same name has already been registered,
     * if overwrite is true: overwrite the existing component with the new component and create a new
     * provider with the new component. It can be useful in tests where you want to use different mocks
     * for different tests.
     * if overwrite is false: throw an exception
     */ addComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) throw new Error(`Component ${component.name} has already been registered with ${this.name}`);
        provider.setComponent(component);
    }
    addOrOverwriteComponent(component) {
        const provider = this.getProvider(component.name);
        if (provider.isComponentSet()) // delete the existing provider from the container, so we can register the new component
        this.providers.delete(component.name);
        this.addComponent(component);
    }
    /**
     * getProvider provides a type safe interface where it can only be called with a field name
     * present in NameServiceMapping interface.
     *
     * Firebase SDKs providing services should extend NameServiceMapping interface to register
     * themselves.
     */ getProvider(name) {
        if (this.providers.has(name)) return this.providers.get(name);
        // create a Provider for a service that hasn't registered with Firebase
        const provider = new Provider(name, this);
        this.providers.set(name, provider);
        return provider;
    }
    getProviders() {
        return Array.from(this.providers.values());
    }
}

},{"@firebase/util":"fHqXn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fHqXn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CONSTANTS", ()=>CONSTANTS);
parcelHelpers.export(exports, "DecodeBase64StringError", ()=>DecodeBase64StringError);
parcelHelpers.export(exports, "Deferred", ()=>Deferred);
parcelHelpers.export(exports, "ErrorFactory", ()=>ErrorFactory);
parcelHelpers.export(exports, "FirebaseError", ()=>FirebaseError);
parcelHelpers.export(exports, "MAX_VALUE_MILLIS", ()=>MAX_VALUE_MILLIS);
parcelHelpers.export(exports, "RANDOM_FACTOR", ()=>RANDOM_FACTOR);
parcelHelpers.export(exports, "Sha1", ()=>Sha1);
parcelHelpers.export(exports, "areCookiesEnabled", ()=>areCookiesEnabled);
parcelHelpers.export(exports, "assert", ()=>assert);
parcelHelpers.export(exports, "assertionError", ()=>assertionError);
parcelHelpers.export(exports, "async", ()=>async);
parcelHelpers.export(exports, "base64", ()=>base64);
parcelHelpers.export(exports, "base64Decode", ()=>base64Decode);
parcelHelpers.export(exports, "base64Encode", ()=>base64Encode);
parcelHelpers.export(exports, "base64urlEncodeWithoutPadding", ()=>base64urlEncodeWithoutPadding);
parcelHelpers.export(exports, "calculateBackoffMillis", ()=>calculateBackoffMillis);
parcelHelpers.export(exports, "contains", ()=>contains);
parcelHelpers.export(exports, "createMockUserToken", ()=>createMockUserToken);
parcelHelpers.export(exports, "createSubscribe", ()=>createSubscribe);
parcelHelpers.export(exports, "decode", ()=>decode);
parcelHelpers.export(exports, "deepCopy", ()=>deepCopy);
parcelHelpers.export(exports, "deepEqual", ()=>deepEqual);
parcelHelpers.export(exports, "deepExtend", ()=>deepExtend);
parcelHelpers.export(exports, "errorPrefix", ()=>errorPrefix);
parcelHelpers.export(exports, "extractQuerystring", ()=>extractQuerystring);
parcelHelpers.export(exports, "generateSHA256Hash", ()=>generateSHA256Hash);
parcelHelpers.export(exports, "getDefaultAppConfig", ()=>getDefaultAppConfig);
parcelHelpers.export(exports, "getDefaultEmulatorHost", ()=>getDefaultEmulatorHost);
parcelHelpers.export(exports, "getDefaultEmulatorHostnameAndPort", ()=>getDefaultEmulatorHostnameAndPort);
parcelHelpers.export(exports, "getDefaults", ()=>getDefaults);
parcelHelpers.export(exports, "getExperimentalSetting", ()=>getExperimentalSetting);
parcelHelpers.export(exports, "getGlobal", ()=>getGlobal);
parcelHelpers.export(exports, "getModularInstance", ()=>getModularInstance);
parcelHelpers.export(exports, "getUA", ()=>getUA);
parcelHelpers.export(exports, "isAdmin", ()=>isAdmin);
parcelHelpers.export(exports, "isBrowser", ()=>isBrowser);
parcelHelpers.export(exports, "isBrowserExtension", ()=>isBrowserExtension);
parcelHelpers.export(exports, "isCloudWorkstation", ()=>isCloudWorkstation);
parcelHelpers.export(exports, "isCloudflareWorker", ()=>isCloudflareWorker);
parcelHelpers.export(exports, "isElectron", ()=>isElectron);
parcelHelpers.export(exports, "isEmpty", ()=>isEmpty);
parcelHelpers.export(exports, "isIE", ()=>isIE);
parcelHelpers.export(exports, "isIndexedDBAvailable", ()=>isIndexedDBAvailable);
parcelHelpers.export(exports, "isMobileCordova", ()=>isMobileCordova);
parcelHelpers.export(exports, "isNode", ()=>isNode);
parcelHelpers.export(exports, "isNodeSdk", ()=>isNodeSdk);
parcelHelpers.export(exports, "isReactNative", ()=>isReactNative);
parcelHelpers.export(exports, "isSafari", ()=>isSafari);
parcelHelpers.export(exports, "isSafariOrWebkit", ()=>isSafariOrWebkit);
parcelHelpers.export(exports, "isUWP", ()=>isUWP);
parcelHelpers.export(exports, "isValidFormat", ()=>isValidFormat);
parcelHelpers.export(exports, "isValidTimestamp", ()=>isValidTimestamp);
parcelHelpers.export(exports, "isWebWorker", ()=>isWebWorker);
parcelHelpers.export(exports, "issuedAtTime", ()=>issuedAtTime);
parcelHelpers.export(exports, "jsonEval", ()=>jsonEval);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "ordinal", ()=>ordinal);
parcelHelpers.export(exports, "pingServer", ()=>pingServer);
parcelHelpers.export(exports, "promiseWithTimeout", ()=>promiseWithTimeout);
parcelHelpers.export(exports, "querystring", ()=>querystring);
parcelHelpers.export(exports, "querystringDecode", ()=>querystringDecode);
parcelHelpers.export(exports, "safeGet", ()=>safeGet);
parcelHelpers.export(exports, "stringLength", ()=>stringLength);
parcelHelpers.export(exports, "stringToByteArray", ()=>stringToByteArray);
parcelHelpers.export(exports, "stringify", ()=>stringify);
parcelHelpers.export(exports, "validateArgCount", ()=>validateArgCount);
parcelHelpers.export(exports, "validateCallback", ()=>validateCallback);
parcelHelpers.export(exports, "validateContextObject", ()=>validateContextObject);
parcelHelpers.export(exports, "validateIndexedDBOpenable", ()=>validateIndexedDBOpenable);
parcelHelpers.export(exports, "validateNamespace", ()=>validateNamespace);
var _postinstallMjs = require("./postinstall.mjs");
var global = arguments[3];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */ const CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */ NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */ NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */ SDK_VERSION: '${JSCORE_VERSION}'
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws an error if the provided assertion is falsy
 */ const assert = function(assertion, message) {
    if (!assertion) throw assertionError(message);
};
/**
 * Returns an Error object suitable for throwing.
 */ const assertionError = function(message) {
    return new Error('Firebase Database (' + CONSTANTS.SDK_VERSION + ') INTERNAL ASSERT FAILED: ' + message);
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const stringToByteArray$1 = function(str) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param bytes Array of numbers representing characters.
 * @return Stringification of the array.
 */ const byteArrayToString = function(bytes) {
    // TODO(user): Use native implementations if/when available
    const out = [];
    let pos = 0, c = 0;
    while(pos < bytes.length){
        const c1 = bytes[pos++];
        if (c1 < 128) out[c++] = String.fromCharCode(c1);
        else if (c1 > 191 && c1 < 224) {
            const c2 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
        } else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            const c4 = bytes[pos++];
            const u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        } else {
            const c2 = bytes[pos++];
            const c3 = bytes[pos++];
            out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
        }
    }
    return out.join('');
};
// We define it as an object literal instead of a class because a class compiled down to es5 can't
// be treeshaked. https://github.com/rollup/rollup/issues/1691
// Static lookup maps, lazily populated by init_()
// TODO(dlarocque): Define this as a class, since we no longer target ES5.
const base64 = {
    /**
     * Maps bytes to characters.
     */ byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     */ charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @private
     */ byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @private
     */ charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     */ ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     */ get ENCODED_VALS () {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     */ get ENCODED_VALS_WEBSAFE () {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     */ HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeByteArray (input, webSafe) {
        if (!Array.isArray(input)) throw Error('encodeByteArray takes an array as a parameter');
        this.init_();
        const byteToCharMap = webSafe ? this.byteToCharMapWebSafe_ : this.byteToCharMap_;
        const output = [];
        for(let i = 0; i < input.length; i += 3){
            const byte1 = input[i];
            const haveByte2 = i + 1 < input.length;
            const byte2 = haveByte2 ? input[i + 1] : 0;
            const haveByte3 = i + 2 < input.length;
            const byte3 = haveByte3 ? input[i + 2] : 0;
            const outByte1 = byte1 >> 2;
            const outByte2 = (byte1 & 0x03) << 4 | byte2 >> 4;
            let outByte3 = (byte2 & 0x0f) << 2 | byte3 >> 6;
            let outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) outByte3 = 64;
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param input A string to encode.
     * @param webSafe If true, we should use the
     *     alternative alphabet.
     * @return The base64 encoded string.
     */ encodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return btoa(input);
        return this.encodeByteArray(stringToByteArray$1(input), webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param input to decode.
     * @param webSafe True if we should use the
     *     alternative alphabet.
     * @return string representing the decoded value.
     */ decodeString (input, webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !webSafe) return atob(input);
        return byteArrayToString(this.decodeStringToByteArray(input, webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param input Input to decode.
     * @param webSafe True if we should use the web-safe alphabet.
     * @return bytes representing the decoded value.
     */ decodeStringToByteArray (input, webSafe) {
        this.init_();
        const charToByteMap = webSafe ? this.charToByteMapWebSafe_ : this.charToByteMap_;
        const output = [];
        for(let i = 0; i < input.length;){
            const byte1 = charToByteMap[input.charAt(i++)];
            const haveByte2 = i < input.length;
            const byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            const haveByte3 = i < input.length;
            const byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            const haveByte4 = i < input.length;
            const byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) throw new DecodeBase64StringError();
            const outByte1 = byte1 << 2 | byte2 >> 4;
            output.push(outByte1);
            if (byte3 !== 64) {
                const outByte2 = byte2 << 4 & 0xf0 | byte3 >> 2;
                output.push(outByte2);
                if (byte4 !== 64) {
                    const outByte3 = byte3 << 6 & 0xc0 | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */ init_ () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for(let i = 0; i < this.ENCODED_VALS.length; i++){
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * An error encountered while decoding base64 string.
 */ class DecodeBase64StringError extends Error {
    constructor(){
        super(...arguments);
        this.name = 'DecodeBase64StringError';
    }
}
/**
 * URL-safe base64 encoding
 */ const base64Encode = function(str) {
    const utf8Bytes = stringToByteArray$1(str);
    return base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 encoding (without "." padding in the end).
 * e.g. Used in JSON Web Token (JWT) parts.
 */ const base64urlEncodeWithoutPadding = function(str) {
    // Use base64url encoding and remove padding in the end (dot characters).
    return base64Encode(str).replace(/\./g, '');
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param str To be decoded
 * @return Decoded result, if possible
 */ const base64Decode = function(str) {
    try {
        return base64.decodeString(str, true);
    } catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */ function deepCopy(value) {
    return deepExtend(undefined, value);
}
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 *
 * Note: we don't merge __proto__ to prevent prototype pollution
 */ function deepExtend(target, source) {
    if (!(source instanceof Object)) return source;
    switch(source.constructor){
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            const dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) target = {};
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for(const prop in source){
        // use isValidKey to guard against prototype pollution. See https://snyk.io/vuln/SNYK-JS-LODASH-450202
        if (!source.hasOwnProperty(prop) || !isValidKey(prop)) continue;
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
function isValidKey(key) {
    return key !== '__proto__';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Polyfill for `globalThis` object.
 * @returns the `globalThis` object for the given environment.
 * @public
 */ function getGlobal() {
    if (typeof self !== 'undefined') return self;
    if (typeof window !== 'undefined') return window;
    if (typeof global !== 'undefined') return global;
    throw new Error('Unable to locate global object.');
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const getDefaultsFromGlobal = ()=>getGlobal().__FIREBASE_DEFAULTS__;
/**
 * Attempt to read defaults from a JSON string provided to
 * process(.)env(.)__FIREBASE_DEFAULTS__ or a JSON file whose path is in
 * process(.)env(.)__FIREBASE_DEFAULTS_PATH__
 * The dots are in parens because certain compilers (Vite?) cannot
 * handle seeing that variable in comments.
 * See https://github.com/firebase/firebase-js-sdk/issues/6838
 */ const getDefaultsFromEnvVariable = ()=>{
    return;
};
const getDefaultsFromCookie = ()=>{
    if (typeof document === 'undefined') return;
    let match;
    try {
        match = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
    } catch (e) {
        // Some environments such as Angular Universal SSR have a
        // `document` object but error on accessing `document.cookie`.
        return;
    }
    const decoded = match && base64Decode(match[1]);
    return decoded && JSON.parse(decoded);
};
/**
 * Get the __FIREBASE_DEFAULTS__ object. It checks in order:
 * (1) if such an object exists as a property of `globalThis`
 * (2) if such an object was provided on a shell environment variable
 * (3) if such an object exists in a cookie
 * @public
 */ const getDefaults = ()=>{
    try {
        return (0, _postinstallMjs.getDefaultsFromPostinstall)() || getDefaultsFromGlobal() || getDefaultsFromEnvVariable() || getDefaultsFromCookie();
    } catch (e) {
        /**
         * Catch-all for being unable to get __FIREBASE_DEFAULTS__ due
         * to any environment case we have not accounted for. Log to
         * info instead of swallowing so we can find these unknown cases
         * and add paths for them if needed.
         */ console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
        return;
    }
};
/**
 * Returns emulator host stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a URL host formatted like `127.0.0.1:9999` or `[::1]:4000` if available
 * @public
 */ const getDefaultEmulatorHost = (productName)=>getDefaults()?.emulatorHosts?.[productName];
/**
 * Returns emulator hostname and port stored in the __FIREBASE_DEFAULTS__ object
 * for the given product.
 * @returns a pair of hostname and port like `["::1", 4000]` if available
 * @public
 */ const getDefaultEmulatorHostnameAndPort = (productName)=>{
    const host = getDefaultEmulatorHost(productName);
    if (!host) return undefined;
    const separatorIndex = host.lastIndexOf(':'); // Finding the last since IPv6 addr also has colons.
    if (separatorIndex <= 0 || separatorIndex + 1 === host.length) throw new Error(`Invalid host ${host} with no separate hostname and port!`);
    // eslint-disable-next-line no-restricted-globals
    const port = parseInt(host.substring(separatorIndex + 1), 10);
    if (host[0] === '[') // Bracket-quoted `[ipv6addr]:port` => return "ipv6addr" (without brackets).
    return [
        host.substring(1, separatorIndex - 1),
        port
    ];
    else return [
        host.substring(0, separatorIndex),
        port
    ];
};
/**
 * Returns Firebase app config stored in the __FIREBASE_DEFAULTS__ object.
 * @public
 */ const getDefaultAppConfig = ()=>getDefaults()?.config;
/**
 * Returns an experimental setting on the __FIREBASE_DEFAULTS__ object (properties
 * prefixed by "_")
 * @public
 */ const getExperimentalSetting = (name)=>getDefaults()?.[`_${name}`];
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class Deferred {
    constructor(){
        this.reject = ()=>{};
        this.resolve = ()=>{};
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
    /**
     * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     */ wrapCallback(callback) {
        return (error, value)=>{
            if (error) this.reject(error);
            else this.resolve(value);
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                this.promise.catch(()=>{});
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) callback(error);
                else callback(error, value);
            }
        };
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function createMockUserToken(token, projectId) {
    if (token.uid) throw new Error('The "uid" field is no longer supported by mockUserToken. Please use "sub" instead for Firebase Auth User ID.');
    // Unsecured JWTs use "none" as the algorithm.
    const header = {
        alg: 'none',
        type: 'JWT'
    };
    const project = projectId || 'demo-project';
    const iat = token.iat || 0;
    const sub = token.sub || token.user_id;
    if (!sub) throw new Error("mockUserToken must contain 'sub' or 'user_id' field!");
    const payload = {
        // Set all required fields to decent defaults
        iss: `https://securetoken.google.com/${project}`,
        aud: project,
        iat,
        exp: iat + 3600,
        auth_time: iat,
        sub,
        user_id: sub,
        firebase: {
            sign_in_provider: 'custom',
            identities: {}
        },
        // Override with user options
        ...token
    };
    // Unsecured JWTs use the empty string as a signature.
    const signature = '';
    return [
        base64urlEncodeWithoutPadding(JSON.stringify(header)),
        base64urlEncodeWithoutPadding(JSON.stringify(payload)),
        signature
    ].join('.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return user agent string
 */ function getUA() {
    if (typeof navigator !== 'undefined' && typeof navigator['userAgent'] === 'string') return navigator['userAgent'];
    else return '';
}
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap
 * in the Ripple emulator) nor Cordova `onDeviceReady`, which would normally
 * wait for a callback.
 */ function isMobileCordova() {
    return typeof window !== 'undefined' && // @ts-ignore Setting up an broadly applicable index signature for Window
    // just to deal with this case would probably be a bad idea.
    !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(getUA());
}
/**
 * Detect Node.js.
 *
 * @return true if Node.js environment is detected or specified.
 */ // Node detection logic from: https://github.com/iliakan/detect-node/
function isNode() {
    const forceEnvironment = getDefaults()?.forceEnvironment;
    if (forceEnvironment === 'node') return true;
    else if (forceEnvironment === 'browser') return false;
    try {
        return Object.prototype.toString.call(global.process) === '[object process]';
    } catch (e) {
        return false;
    }
}
/**
 * Detect Browser Environment.
 * Note: This will return true for certain test frameworks that are incompletely
 * mimicking a browser, and should not lead to assuming all browser APIs are
 * available.
 */ function isBrowser() {
    return typeof window !== 'undefined' || isWebWorker();
}
/**
 * Detect Web Worker context.
 */ function isWebWorker() {
    return typeof WorkerGlobalScope !== 'undefined' && typeof self !== 'undefined' && self instanceof WorkerGlobalScope;
}
/**
 * Detect Cloudflare Worker context.
 */ function isCloudflareWorker() {
    return typeof navigator !== 'undefined' && navigator.userAgent === 'Cloudflare-Workers';
}
function isBrowserExtension() {
    const runtime = typeof chrome === 'object' ? chrome.runtime : typeof browser === 'object' ? browser.runtime : undefined;
    return typeof runtime === 'object' && runtime.id !== undefined;
}
/**
 * Detect React Native.
 *
 * @return true if ReactNative environment is detected.
 */ function isReactNative() {
    return typeof navigator === 'object' && navigator['product'] === 'ReactNative';
}
/** Detects Electron apps. */ function isElectron() {
    return getUA().indexOf('Electron/') >= 0;
}
/** Detects Internet Explorer. */ function isIE() {
    const ua = getUA();
    return ua.indexOf('MSIE ') >= 0 || ua.indexOf('Trident/') >= 0;
}
/** Detects Universal Windows Platform apps. */ function isUWP() {
    return getUA().indexOf('MSAppHost/') >= 0;
}
/**
 * Detect whether the current SDK build is the Node version.
 *
 * @return true if it's the Node SDK build.
 */ function isNodeSdk() {
    return CONSTANTS.NODE_CLIENT === true || CONSTANTS.NODE_ADMIN === true;
}
/** Returns true if we are running in Safari. */ function isSafari() {
    return !isNode() && !!navigator.userAgent && navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome');
}
/** Returns true if we are running in Safari or WebKit */ function isSafariOrWebkit() {
    return !isNode() && !!navigator.userAgent && (navigator.userAgent.includes('Safari') || navigator.userAgent.includes('WebKit')) && !navigator.userAgent.includes('Chrome');
}
/**
 * This method checks if indexedDB is supported by current browser/service worker context
 * @return true if indexedDB is supported by current browser/service worker context
 */ function isIndexedDBAvailable() {
    try {
        return typeof indexedDB === 'object';
    } catch (e) {
        return false;
    }
}
/**
 * This method validates browser/sw context for indexedDB by opening a dummy indexedDB database and reject
 * if errors occur during the database open operation.
 *
 * @throws exception if current browser/sw context can't run idb.open (ex: Safari iframe, Firefox
 * private browsing)
 */ function validateIndexedDBOpenable() {
    return new Promise((resolve, reject)=>{
        try {
            let preExist = true;
            const DB_CHECK_NAME = 'validate-browser-context-for-indexeddb-analytics-module';
            const request = self.indexedDB.open(DB_CHECK_NAME);
            request.onsuccess = ()=>{
                request.result.close();
                // delete database only when it doesn't pre-exist
                if (!preExist) self.indexedDB.deleteDatabase(DB_CHECK_NAME);
                resolve(true);
            };
            request.onupgradeneeded = ()=>{
                preExist = false;
            };
            request.onerror = ()=>{
                reject(request.error?.message || '');
            };
        } catch (error) {
            reject(error);
        }
    });
}
/**
 *
 * This method checks whether cookie is enabled within current browser
 * @return true if cookie is enabled within current browser
 */ function areCookiesEnabled() {
    if (typeof navigator === 'undefined' || !navigator.cookieEnabled) return false;
    return true;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Standardized Firebase Error.
 *
 * Usage:
 *
 *   // TypeScript string literals for type-safe codes
 *   type Err =
 *     'unknown' |
 *     'object-not-found'
 *     ;
 *
 *   // Closure enum for type-safe error codes
 *   // at-enum {string}
 *   var Err = {
 *     UNKNOWN: 'unknown',
 *     OBJECT_NOT_FOUND: 'object-not-found',
 *   }
 *
 *   let errors: Map<Err, string> = {
 *     'generic-error': "Unknown error",
 *     'file-not-found': "Could not find file: {$file}",
 *   };
 *
 *   // Type-safe function - must pass a valid error code as param.
 *   let error = new ErrorFactory<Err>('service', 'Service', errors);
 *
 *   ...
 *   throw error.create(Err.GENERIC);
 *   ...
 *   throw error.create(Err.FILE_NOT_FOUND, {'file': fileName});
 *   ...
 *   // Service: Could not file file: foo.txt (service/file-not-found).
 *
 *   catch (e) {
 *     assert(e.message === "Could not find file: foo.txt.");
 *     if ((e as FirebaseError)?.code === 'service/file-not-found') {
 *       console.log("Could not read file: " + e['file']);
 *     }
 *   }
 */ const ERROR_NAME = 'FirebaseError';
// Based on code from:
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#Custom_Error_Types
class FirebaseError extends Error {
    constructor(/** The error code for this error. */ code, message, /** Custom data for this error. */ customData){
        super(message);
        this.code = code;
        this.customData = customData;
        /** The custom name for all FirebaseErrors. */ this.name = ERROR_NAME;
        // Fix For ES5
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // TODO(dlarocque): Replace this with `new.target`: https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        //                   which we can now use since we no longer target ES5.
        Object.setPrototypeOf(this, FirebaseError.prototype);
        // Maintains proper stack trace for where our error was thrown.
        // Only available on V8.
        if (Error.captureStackTrace) Error.captureStackTrace(this, ErrorFactory.prototype.create);
    }
}
class ErrorFactory {
    constructor(service, serviceName, errors){
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
    }
    create(code, ...data) {
        const customData = data[0] || {};
        const fullCode = `${this.service}/${code}`;
        const template = this.errors[code];
        const message = template ? replaceTemplate(template, customData) : 'Error';
        // Service Name: Error message (service/code).
        const fullMessage = `${this.serviceName}: ${message} (${fullCode}).`;
        const error = new FirebaseError(fullCode, fullMessage, customData);
        return error;
    }
}
function replaceTemplate(template, data) {
    return template.replace(PATTERN, (_, key)=>{
        const value = data[key];
        return value != null ? String(value) : `<${key}?>`;
    });
}
const PATTERN = /\{\$([^}]+)}/g;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */ function jsonEval(str) {
    return JSON.parse(str);
}
/**
 * Returns JSON representing a javascript object.
 * @param {*} data JavaScript object to be stringified.
 * @return {string} The JSON contents of the object.
 */ function stringify(data) {
    return JSON.stringify(data);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const decode = function(token) {
    let header = {}, claims = {}, data = {}, signature = '';
    try {
        const parts = token.split('.');
        header = jsonEval(base64Decode(parts[0]) || '');
        claims = jsonEval(base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    } catch (e) {}
    return {
        header,
        claims,
        data,
        signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const isValidTimestamp = function(token) {
    const claims = decode(token).claims;
    const now = Math.floor(new Date().getTime() / 1000);
    let validSince = 0, validUntil = 0;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) validSince = claims['nbf'];
        else if (claims.hasOwnProperty('iat')) validSince = claims['iat'];
        if (claims.hasOwnProperty('exp')) validUntil = claims['exp'];
        else // token will expire after 24h by default
        validUntil = validSince + 86400;
    }
    return !!now && !!validSince && !!validUntil && now >= validSince && now <= validUntil;
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const issuedAtTime = function(token) {
    const claims = decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) return claims['iat'];
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const isValidFormat = function(token) {
    const decoded = decode(token), claims = decoded.claims;
    return !!claims && typeof claims === 'object' && claims.hasOwnProperty('iat');
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 */ const isAdmin = function(token) {
    const claims = decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function contains(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
function safeGet(obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return obj[key];
    else return undefined;
}
function isEmpty(obj) {
    for(const key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
    }
    return true;
}
function map(obj, fn, contextObj) {
    const res = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res[key] = fn.call(contextObj, obj[key], key, obj);
    return res;
}
/**
 * Deep equal two objects. Support Arrays and Objects.
 */ function deepEqual(a, b) {
    if (a === b) return true;
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    for (const k of aKeys){
        if (!bKeys.includes(k)) return false;
        const aProp = a[k];
        const bProp = b[k];
        if (isObject(aProp) && isObject(bProp)) {
            if (!deepEqual(aProp, bProp)) return false;
        } else if (aProp !== bProp) return false;
    }
    for (const k of bKeys){
        if (!aKeys.includes(k)) return false;
    }
    return true;
}
function isObject(thing) {
    return thing !== null && typeof thing === 'object';
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Rejects if the given promise doesn't resolve in timeInMS milliseconds.
 * @internal
 */ function promiseWithTimeout(promise, timeInMS = 2000) {
    const deferredPromise = new Deferred();
    setTimeout(()=>deferredPromise.reject('timeout!'), timeInMS);
    promise.then(deferredPromise.resolve, deferredPromise.reject);
    return deferredPromise.promise;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a
 * params object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 */ function querystring(querystringParams) {
    const params = [];
    for (const [key, value] of Object.entries(querystringParams))if (Array.isArray(value)) value.forEach((arrayVal)=>{
        params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
    });
    else params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
    return params.length ? '&' + params.join('&') : '';
}
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object
 * (e.g. {arg: 'val', arg2: 'val2'})
 */ function querystringDecode(querystring) {
    const obj = {};
    const tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach((token)=>{
        if (token) {
            const [key, value] = token.split('=');
            obj[decodeURIComponent(key)] = decodeURIComponent(value);
        }
    });
    return obj;
}
/**
 * Extract the query string part of a URL, including the leading question mark (if present).
 */ function extractQuerystring(url) {
    const queryStart = url.indexOf('?');
    if (!queryStart) return '';
    const fragmentStart = url.indexOf('#', queryStart);
    return url.substring(queryStart, fragmentStart > 0 ? fragmentStart : undefined);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */ /**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @final
 * @struct
 */ class Sha1 {
    constructor(){
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @private
         */ this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @private
         */ this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @private
         */ this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @private
         */ this.pad_ = [];
        /**
         * @private {number}
         */ this.inbuf_ = 0;
        /**
         * @private {number}
         */ this.total_ = 0;
        this.blockSize = 64;
        this.pad_[0] = 128;
        for(let i = 1; i < this.blockSize; ++i)this.pad_[i] = 0;
        this.reset();
    }
    reset() {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    }
    /**
     * Internal compress helper function.
     * @param buf Block to compress.
     * @param offset Offset of the block in the buffer.
     * @private
     */ compress_(buf, offset) {
        if (!offset) offset = 0;
        const W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') for(let i = 0; i < 16; i++){
            // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
            // have a bug that turns the post-increment ++ operator into pre-increment
            // during JIT compilation.  We have code that depends heavily on SHA-1 for
            // correctness and which is affected by this bug, so I've removed all uses
            // of post-increment ++ in which the result value is used.  We can revert
            // this change once the Safari bug
            // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
            // most clients have been updated.
            W[i] = buf.charCodeAt(offset) << 24 | buf.charCodeAt(offset + 1) << 16 | buf.charCodeAt(offset + 2) << 8 | buf.charCodeAt(offset + 3);
            offset += 4;
        }
        else for(let i = 0; i < 16; i++){
            W[i] = buf[offset] << 24 | buf[offset + 1] << 16 | buf[offset + 2] << 8 | buf[offset + 3];
            offset += 4;
        }
        // expand to 80 words
        for(let i = 16; i < 80; i++){
            const t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = (t << 1 | t >>> 31) & 0xffffffff;
        }
        let a = this.chain_[0];
        let b = this.chain_[1];
        let c = this.chain_[2];
        let d = this.chain_[3];
        let e = this.chain_[4];
        let f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for(let i = 0; i < 80; i++){
            if (i < 40) {
                if (i < 20) {
                    f = d ^ b & (c ^ d);
                    k = 0x5a827999;
                } else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            } else if (i < 60) {
                f = b & c | d & (b | c);
                k = 0x8f1bbcdc;
            } else {
                f = b ^ c ^ d;
                k = 0xca62c1d6;
            }
            const t = (a << 5 | a >>> 27) + f + e + k + W[i] & 0xffffffff;
            e = d;
            d = c;
            c = (b << 30 | b >>> 2) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = this.chain_[0] + a & 0xffffffff;
        this.chain_[1] = this.chain_[1] + b & 0xffffffff;
        this.chain_[2] = this.chain_[2] + c & 0xffffffff;
        this.chain_[3] = this.chain_[3] + d & 0xffffffff;
        this.chain_[4] = this.chain_[4] + e & 0xffffffff;
    }
    update(bytes, length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) return;
        if (length === undefined) length = bytes.length;
        const lengthMinusBlock = length - this.blockSize;
        let n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        const buf = this.buf_;
        let inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while(n < length){
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf === 0) while(n <= lengthMinusBlock){
                this.compress_(bytes, n);
                n += this.blockSize;
            }
            if (typeof bytes === 'string') while(n < length){
                buf[inbuf] = bytes.charCodeAt(n);
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
            else while(n < length){
                buf[inbuf] = bytes[n];
                ++inbuf;
                ++n;
                if (inbuf === this.blockSize) {
                    this.compress_(buf);
                    inbuf = 0;
                    break;
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += length;
    }
    /** @override */ digest() {
        const digest = [];
        let totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) this.update(this.pad_, 56 - this.inbuf_);
        else this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        // Add # bits.
        for(let i = this.blockSize - 1; i >= 56; i--){
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        let n = 0;
        for(let i = 0; i < 5; i++)for(let j = 24; j >= 0; j -= 8){
            digest[n] = this.chain_[i] >> j & 255;
            ++n;
        }
        return digest;
    }
}
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */ function createSubscribe(executor, onNoObservers) {
    const proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */ class ObserverProxy {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */ constructor(executor, onNoObservers){
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task.then(()=>{
            executor(this);
        }).catch((e)=>{
            this.error(e);
        });
    }
    next(value) {
        this.forEachObserver((observer)=>{
            observer.next(value);
        });
    }
    error(error) {
        this.forEachObserver((observer)=>{
            observer.error(error);
        });
        this.close(error);
    }
    complete() {
        this.forEachObserver((observer)=>{
            observer.complete();
        });
        this.close();
    }
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber synchronously to their
     *   call to subscribe().
     */ subscribe(nextOrObserver, error, complete) {
        let observer;
        if (nextOrObserver === undefined && error === undefined && complete === undefined) throw new Error('Missing Observer.');
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, [
            'next',
            'error',
            'complete'
        ])) observer = nextOrObserver;
        else observer = {
            next: nextOrObserver,
            error,
            complete
        };
        if (observer.next === undefined) observer.next = noop;
        if (observer.error === undefined) observer.error = noop;
        if (observer.complete === undefined) observer.complete = noop;
        const unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            try {
                if (this.finalError) observer.error(this.finalError);
                else observer.complete();
            } catch (e) {
            // nothing
            }
            return;
        });
        this.observers.push(observer);
        return unsub;
    }
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    unsubscribeOne(i) {
        if (this.observers === undefined || this.observers[i] === undefined) return;
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) this.onNoObservers(this);
    }
    forEachObserver(fn) {
        if (this.finalized) // Already closed by previous event....just eat the additional values.
        return;
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for(let i = 0; i < this.observers.length; i++)this.sendOne(i, fn);
    }
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    sendOne(i, fn) {
        // Execute the callback asynchronously
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            if (this.observers !== undefined && this.observers[i] !== undefined) try {
                fn(this.observers[i]);
            } catch (e) {
                // Ignore exceptions raised in Observers or missing methods of an
                // Observer.
                // Log error to console. b/31404806
                if (typeof console !== 'undefined' && console.error) console.error(e);
            }
        });
    }
    close(err) {
        if (this.finalized) return;
        this.finalized = true;
        if (err !== undefined) this.finalError = err;
        // Proxy is no longer needed - garbage collect references
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.task.then(()=>{
            this.observers = undefined;
            this.onNoObservers = undefined;
        });
    }
}
/** Turn synchronous function into one called asynchronously. */ // eslint-disable-next-line @typescript-eslint/ban-types
function async(fn, onError) {
    return (...args)=>{
        Promise.resolve(true).then(()=>{
            fn(...args);
        }).catch((error)=>{
            if (onError) onError(error);
        });
    };
}
/**
 * Return true if the object passed in implements any of the named methods.
 */ function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) return false;
    for (const method of methods){
        if (method in obj && typeof obj[method] === 'function') return true;
    }
    return false;
}
function noop() {
// do nothing
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param fnName The function name
 * @param minCount The minimum number of arguments to allow for the function call
 * @param maxCount The maximum number of argument to allow for the function call
 * @param argCount The actual number of arguments provided.
 */ const validateArgCount = function(fnName, minCount, maxCount, argCount) {
    let argError;
    if (argCount < minCount) argError = 'at least ' + minCount;
    else if (argCount > maxCount) argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    if (argError) {
        const error = fnName + ' failed: Was called with ' + argCount + (argCount === 1 ? ' argument.' : ' arguments.') + ' Expects ' + argError + '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param fnName The function name
 * @param argName The name of the argument
 * @return The prefix to add to the error thrown for validation.
 */ function errorPrefix(fnName, argName) {
    return `${fnName} failed: ${argName} argument `;
}
/**
 * @param fnName
 * @param argumentNumber
 * @param namespace
 * @param optional
 */ function validateNamespace(fnName, namespace, optional) {
    if (optional && !namespace) return;
    if (typeof namespace !== 'string') //TODO: I should do more validation here. We only allow certain chars in namespaces.
    throw new Error(errorPrefix(fnName, 'namespace') + 'must be a valid firebase namespace.');
}
function validateCallback(fnName, argumentName, // eslint-disable-next-line @typescript-eslint/ban-types
callback, optional) {
    if (optional && !callback) return;
    if (typeof callback !== 'function') throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid function.');
}
function validateContextObject(fnName, argumentName, context, optional) {
    if (optional && !context) return;
    if (typeof context !== 'object' || context === null) throw new Error(errorPrefix(fnName, argumentName) + 'must be a valid context object.');
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in JavaScript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */ const stringToByteArray = function(str) {
    const out = [];
    let p = 0;
    for(let i = 0; i < str.length; i++){
        let c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            const high = c - 0xd800; // the high 10 bits.
            i++;
            assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            const low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) out[p++] = c;
        else if (c < 2048) {
            out[p++] = c >> 6 | 192;
            out[p++] = c & 63 | 128;
        } else if (c < 65536) {
            out[p++] = c >> 12 | 224;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        } else {
            out[p++] = c >> 18 | 240;
            out[p++] = c >> 12 & 63 | 128;
            out[p++] = c >> 6 & 63 | 128;
            out[p++] = c & 63 | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */ const stringLength = function(str) {
    let p = 0;
    for(let i = 0; i < str.length; i++){
        const c = str.charCodeAt(i);
        if (c < 128) p++;
        else if (c < 2048) p += 2;
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        } else p += 3;
    }
    return p;
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The amount of milliseconds to exponentially increase.
 */ const DEFAULT_INTERVAL_MILLIS = 1000;
/**
 * The factor to backoff by.
 * Should be a number greater than 1.
 */ const DEFAULT_BACKOFF_FACTOR = 2;
/**
 * The maximum milliseconds to increase to.
 *
 * <p>Visible for testing
 */ const MAX_VALUE_MILLIS = 14400000; // Four hours, like iOS and Android.
/**
 * The percentage of backoff time to randomize by.
 * See
 * http://go/safe-client-behavior#step-1-determine-the-appropriate-retry-interval-to-handle-spike-traffic
 * for context.
 *
 * <p>Visible for testing
 */ const RANDOM_FACTOR = 0.5;
/**
 * Based on the backoff method from
 * https://github.com/google/closure-library/blob/master/closure/goog/math/exponentialbackoff.js.
 * Extracted here so we don't need to pass metadata and a stateful ExponentialBackoff object around.
 */ function calculateBackoffMillis(backoffCount, intervalMillis = DEFAULT_INTERVAL_MILLIS, backoffFactor = DEFAULT_BACKOFF_FACTOR) {
    // Calculates an exponentially increasing value.
    // Deviation: calculates value from count and a constant interval, so we only need to save value
    // and count to restore state.
    const currBaseValue = intervalMillis * Math.pow(backoffFactor, backoffCount);
    // A random "fuzz" to avoid waves of retries.
    // Deviation: randomFactor is required.
    const randomWait = Math.round(// A fraction of the backoff value to add/subtract.
    // Deviation: changes multiplication order to improve readability.
    RANDOM_FACTOR * currBaseValue * // A random float (rounded to int by Math.round above) in the range [-1, 1]. Determines
    // if we add or subtract.
    (Math.random() - 0.5) * 2);
    // Limits backoff to max to avoid effectively permanent backoff.
    return Math.min(MAX_VALUE_MILLIS, currBaseValue + randomWait);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provide English ordinal letters after a number
 */ function ordinal(i) {
    if (!Number.isFinite(i)) return `${i}`;
    return i + indicator(i);
}
function indicator(i) {
    i = Math.abs(i);
    const cent = i % 100;
    if (cent >= 10 && cent <= 20) return 'th';
    const dec = i % 10;
    if (dec === 1) return 'st';
    if (dec === 2) return 'nd';
    if (dec === 3) return 'rd';
    return 'th';
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getModularInstance(service) {
    if (service && service._delegate) return service._delegate;
    else return service;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks whether host is a cloud workstation or not.
 * @public
 */ function isCloudWorkstation(url) {
    // `isCloudWorkstation` is called without protocol in certain connect*Emulator functions
    // In HTTP request builders, it's called with the protocol.
    // If called with protocol prefix, it's a valid URL, so we extract the hostname
    // If called without, we assume the string is the hostname.
    try {
        const host = url.startsWith('http://') || url.startsWith('https://') ? new URL(url).hostname : url;
        return host.endsWith('.cloudworkstations.dev');
    } catch  {
        return false;
    }
}
/**
 * Makes a fetch request to the given server.
 * Mostly used for forwarding cookies in Firebase Studio.
 * @public
 */ async function pingServer(endpoint) {
    const result = await fetch(endpoint, {
        credentials: 'include'
    });
    return result.ok;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @public
 * Generates a SHA-256 hash for the given input string.
 *
 * @param input The string to hash.
 * @returns A promise that resolves to the SHA-256 hash as a hex string.
 */ async function generateSHA256Hash(input) {
    const textEncoder = new TextEncoder();
    const data = textEncoder.encode(input);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    // Convert ArrayBuffer to hex string
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hexHash = hashArray.map((b)=>b.toString(16).padStart(2, '0')).join('');
    return hexHash;
}

},{"./postinstall.mjs":"hw48W","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hw48W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultsFromPostinstall", ()=>getDefaultsFromPostinstall);
const getDefaultsFromPostinstall = ()=>undefined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kY52V":[function(require,module,exports,__globalThis) {
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A container for all of the Logger instances
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LogLevel", ()=>LogLevel);
parcelHelpers.export(exports, "Logger", ()=>Logger);
parcelHelpers.export(exports, "setLogLevel", ()=>setLogLevel);
parcelHelpers.export(exports, "setUserLogHandler", ()=>setUserLogHandler);
const instances = [];
/**
 * The JS SDK supports 5 log levels and also allows a user the ability to
 * silence the logs altogether.
 *
 * The order is a follows:
 * DEBUG < VERBOSE < INFO < WARN < ERROR
 *
 * All of the log types above the current log level will be captured (i.e. if
 * you set the log level to `INFO`, errors will still be logged, but `DEBUG` and
 * `VERBOSE` logs will not)
 */ var LogLevel;
(function(LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 0] = "DEBUG";
    LogLevel[LogLevel["VERBOSE"] = 1] = "VERBOSE";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["WARN"] = 3] = "WARN";
    LogLevel[LogLevel["ERROR"] = 4] = "ERROR";
    LogLevel[LogLevel["SILENT"] = 5] = "SILENT";
})(LogLevel || (LogLevel = {}));
const levelStringToEnum = {
    'debug': LogLevel.DEBUG,
    'verbose': LogLevel.VERBOSE,
    'info': LogLevel.INFO,
    'warn': LogLevel.WARN,
    'error': LogLevel.ERROR,
    'silent': LogLevel.SILENT
};
/**
 * The default log level
 */ const defaultLogLevel = LogLevel.INFO;
/**
 * By default, `console.debug` is not displayed in the developer console (in
 * chrome). To avoid forcing users to have to opt-in to these logs twice
 * (i.e. once for firebase, and once in the console), we are sending `DEBUG`
 * logs to the `console.log` function.
 */ const ConsoleMethod = {
    [LogLevel.DEBUG]: 'log',
    [LogLevel.VERBOSE]: 'log',
    [LogLevel.INFO]: 'info',
    [LogLevel.WARN]: 'warn',
    [LogLevel.ERROR]: 'error'
};
/**
 * The default log handler will forward DEBUG, VERBOSE, INFO, WARN, and ERROR
 * messages on to their corresponding console counterparts (if the log method
 * is supported by the current log level)
 */ const defaultLogHandler = (instance, logType, ...args)=>{
    if (logType < instance.logLevel) return;
    const now = new Date().toISOString();
    const method = ConsoleMethod[logType];
    if (method) console[method](`[${now}]  ${instance.name}:`, ...args);
    else throw new Error(`Attempted to log a message with an invalid logType (value: ${logType})`);
};
class Logger {
    /**
     * Gives you an instance of a Logger to capture messages according to
     * Firebase's logging scheme.
     *
     * @param name The name that the logs will be associated with
     */ constructor(name){
        this.name = name;
        /**
         * The log level of the given Logger instance.
         */ this._logLevel = defaultLogLevel;
        /**
         * The main (internal) log handler for the Logger instance.
         * Can be set to a new function in internal package code but not by user.
         */ this._logHandler = defaultLogHandler;
        /**
         * The optional, additional, user-defined log handler for the Logger instance.
         */ this._userLogHandler = null;
        /**
         * Capture the current instance for later use
         */ instances.push(this);
    }
    get logLevel() {
        return this._logLevel;
    }
    set logLevel(val) {
        if (!(val in LogLevel)) throw new TypeError(`Invalid value "${val}" assigned to \`logLevel\``);
        this._logLevel = val;
    }
    // Workaround for setter/getter having to be the same type.
    setLogLevel(val) {
        this._logLevel = typeof val === 'string' ? levelStringToEnum[val] : val;
    }
    get logHandler() {
        return this._logHandler;
    }
    set logHandler(val) {
        if (typeof val !== 'function') throw new TypeError('Value assigned to `logHandler` must be a function');
        this._logHandler = val;
    }
    get userLogHandler() {
        return this._userLogHandler;
    }
    set userLogHandler(val) {
        this._userLogHandler = val;
    }
    /**
     * The functions below are all based on the `console` interface
     */ debug(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.DEBUG, ...args);
        this._logHandler(this, LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.VERBOSE, ...args);
        this._logHandler(this, LogLevel.VERBOSE, ...args);
    }
    info(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.INFO, ...args);
        this._logHandler(this, LogLevel.INFO, ...args);
    }
    warn(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.WARN, ...args);
        this._logHandler(this, LogLevel.WARN, ...args);
    }
    error(...args) {
        this._userLogHandler && this._userLogHandler(this, LogLevel.ERROR, ...args);
        this._logHandler(this, LogLevel.ERROR, ...args);
    }
}
function setLogLevel(level) {
    instances.forEach((inst)=>{
        inst.setLogLevel(level);
    });
}
function setUserLogHandler(logCallback, options) {
    for (const instance of instances){
        let customLogLevel = null;
        if (options && options.level) customLogLevel = levelStringToEnum[options.level];
        if (logCallback === null) instance.userLogHandler = null;
        else instance.userLogHandler = (instance, level, ...args)=>{
            const message = args.map((arg)=>{
                if (arg == null) return null;
                else if (typeof arg === 'string') return arg;
                else if (typeof arg === 'number' || typeof arg === 'boolean') return arg.toString();
                else if (arg instanceof Error) return arg.message;
                else try {
                    return JSON.stringify(arg);
                } catch (ignored) {
                    return null;
                }
            }).filter((arg)=>arg).join(' ');
            if (level >= (customLogLevel ?? instance.logLevel)) logCallback({
                level: LogLevel[level].toLowerCase(),
                message,
                args,
                type: instance.name
            });
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d2rZl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "unwrap", ()=>(0, _wrapIdbValueJs.u));
parcelHelpers.export(exports, "wrap", ()=>(0, _wrapIdbValueJs.w));
parcelHelpers.export(exports, "deleteDB", ()=>deleteDB);
parcelHelpers.export(exports, "openDB", ()=>openDB);
var _wrapIdbValueJs = require("./wrap-idb-value.js");
/**
 * Open a database.
 *
 * @param name Name of the database.
 * @param version Schema version.
 * @param callbacks Additional callbacks.
 */ function openDB(name, version, { blocked, upgrade, blocking, terminated } = {}) {
    const request = indexedDB.open(name, version);
    const openPromise = (0, _wrapIdbValueJs.w)(request);
    if (upgrade) request.addEventListener('upgradeneeded', (event)=>{
        upgrade((0, _wrapIdbValueJs.w)(request.result), event.oldVersion, event.newVersion, (0, _wrapIdbValueJs.w)(request.transaction), event);
    });
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event.newVersion, event));
    openPromise.then((db)=>{
        if (terminated) db.addEventListener('close', ()=>terminated());
        if (blocking) db.addEventListener('versionchange', (event)=>blocking(event.oldVersion, event.newVersion, event));
    }).catch(()=>{});
    return openPromise;
}
/**
 * Delete a database.
 *
 * @param name Name of the database.
 */ function deleteDB(name, { blocked } = {}) {
    const request = indexedDB.deleteDatabase(name);
    if (blocked) request.addEventListener('blocked', (event)=>blocked(// Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
        event.oldVersion, event));
    return (0, _wrapIdbValueJs.w)(request).then(()=>undefined);
}
const readMethods = [
    'get',
    'getKey',
    'getAll',
    'getAllKeys',
    'count'
];
const writeMethods = [
    'put',
    'add',
    'delete',
    'clear'
];
const cachedMethods = new Map();
function getMethod(target, prop) {
    if (!(target instanceof IDBDatabase && !(prop in target) && typeof prop === 'string')) return;
    if (cachedMethods.get(prop)) return cachedMethods.get(prop);
    const targetFuncName = prop.replace(/FromIndex$/, '');
    const useIndex = prop !== targetFuncName;
    const isWrite = writeMethods.includes(targetFuncName);
    if (// Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(targetFuncName in (useIndex ? IDBIndex : IDBObjectStore).prototype) || !(isWrite || readMethods.includes(targetFuncName))) return;
    const method = async function(storeName, ...args) {
        // isWrite ? 'readwrite' : undefined gzipps better, but fails in Edge :(
        const tx = this.transaction(storeName, isWrite ? 'readwrite' : 'readonly');
        let target = tx.store;
        if (useIndex) target = target.index(args.shift());
        // Must reject if op rejects.
        // If it's a write operation, must reject if tx.done rejects.
        // Must reject with op rejection first.
        // Must resolve with op value.
        // Must handle both promises (no unhandled rejections)
        return (await Promise.all([
            target[targetFuncName](...args),
            isWrite && tx.done
        ]))[0];
    };
    cachedMethods.set(prop, method);
    return method;
}
(0, _wrapIdbValueJs.r)((oldTraps)=>({
        ...oldTraps,
        get: (target, prop, receiver)=>getMethod(target, prop) || oldTraps.get(target, prop, receiver),
        has: (target, prop)=>!!getMethod(target, prop) || oldTraps.has(target, prop)
    }));

},{"./wrap-idb-value.js":"voj9K","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"voj9K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "a", ()=>reverseTransformCache);
parcelHelpers.export(exports, "i", ()=>instanceOfAny);
parcelHelpers.export(exports, "r", ()=>replaceTraps);
parcelHelpers.export(exports, "u", ()=>unwrap);
parcelHelpers.export(exports, "w", ()=>wrap);
const instanceOfAny = (object, constructors)=>constructors.some((c)=>object instanceof c);
let idbProxyableTypes;
let cursorAdvanceMethods;
// This is a function to prevent it throwing up in node environments.
function getIdbProxyableTypes() {
    return idbProxyableTypes || (idbProxyableTypes = [
        IDBDatabase,
        IDBObjectStore,
        IDBIndex,
        IDBCursor,
        IDBTransaction
    ]);
}
// This is a function to prevent it throwing up in node environments.
function getCursorAdvanceMethods() {
    return cursorAdvanceMethods || (cursorAdvanceMethods = [
        IDBCursor.prototype.advance,
        IDBCursor.prototype.continue,
        IDBCursor.prototype.continuePrimaryKey
    ]);
}
const cursorRequestMap = new WeakMap();
const transactionDoneMap = new WeakMap();
const transactionStoreNamesMap = new WeakMap();
const transformCache = new WeakMap();
const reverseTransformCache = new WeakMap();
function promisifyRequest(request) {
    const promise = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            request.removeEventListener('success', success);
            request.removeEventListener('error', error);
        };
        const success = ()=>{
            resolve(wrap(request.result));
            unlisten();
        };
        const error = ()=>{
            reject(request.error);
            unlisten();
        };
        request.addEventListener('success', success);
        request.addEventListener('error', error);
    });
    promise.then((value)=>{
        // Since cursoring reuses the IDBRequest (*sigh*), we cache it for later retrieval
        // (see wrapFunction).
        if (value instanceof IDBCursor) cursorRequestMap.set(value, request);
    // Catching to avoid "Uncaught Promise exceptions"
    }).catch(()=>{});
    // This mapping exists in reverseTransformCache but doesn't doesn't exist in transformCache. This
    // is because we create many promises from a single IDBRequest.
    reverseTransformCache.set(promise, request);
    return promise;
}
function cacheDonePromiseForTransaction(tx) {
    // Early bail if we've already created a done promise for this transaction.
    if (transactionDoneMap.has(tx)) return;
    const done = new Promise((resolve, reject)=>{
        const unlisten = ()=>{
            tx.removeEventListener('complete', complete);
            tx.removeEventListener('error', error);
            tx.removeEventListener('abort', error);
        };
        const complete = ()=>{
            resolve();
            unlisten();
        };
        const error = ()=>{
            reject(tx.error || new DOMException('AbortError', 'AbortError'));
            unlisten();
        };
        tx.addEventListener('complete', complete);
        tx.addEventListener('error', error);
        tx.addEventListener('abort', error);
    });
    // Cache it for later retrieval.
    transactionDoneMap.set(tx, done);
}
let idbProxyTraps = {
    get (target, prop, receiver) {
        if (target instanceof IDBTransaction) {
            // Special handling for transaction.done.
            if (prop === 'done') return transactionDoneMap.get(target);
            // Polyfill for objectStoreNames because of Edge.
            if (prop === 'objectStoreNames') return target.objectStoreNames || transactionStoreNamesMap.get(target);
            // Make tx.store return the only store in the transaction, or undefined if there are many.
            if (prop === 'store') return receiver.objectStoreNames[1] ? undefined : receiver.objectStore(receiver.objectStoreNames[0]);
        }
        // Else transform whatever we get back.
        return wrap(target[prop]);
    },
    set (target, prop, value) {
        target[prop] = value;
        return true;
    },
    has (target, prop) {
        if (target instanceof IDBTransaction && (prop === 'done' || prop === 'store')) return true;
        return prop in target;
    }
};
function replaceTraps(callback) {
    idbProxyTraps = callback(idbProxyTraps);
}
function wrapFunction(func) {
    // Due to expected object equality (which is enforced by the caching in `wrap`), we
    // only create one new func per func.
    // Edge doesn't support objectStoreNames (booo), so we polyfill it here.
    if (func === IDBDatabase.prototype.transaction && !('objectStoreNames' in IDBTransaction.prototype)) return function(storeNames, ...args) {
        const tx = func.call(unwrap(this), storeNames, ...args);
        transactionStoreNamesMap.set(tx, storeNames.sort ? storeNames.sort() : [
            storeNames
        ]);
        return wrap(tx);
    };
    // Cursor methods are special, as the behaviour is a little more different to standard IDB. In
    // IDB, you advance the cursor and wait for a new 'success' on the IDBRequest that gave you the
    // cursor. It's kinda like a promise that can resolve with many values. That doesn't make sense
    // with real promises, so each advance methods returns a new promise for the cursor object, or
    // undefined if the end of the cursor has been reached.
    if (getCursorAdvanceMethods().includes(func)) return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        func.apply(unwrap(this), args);
        return wrap(cursorRequestMap.get(this));
    };
    return function(...args) {
        // Calling the original function with the proxy as 'this' causes ILLEGAL INVOCATION, so we use
        // the original object.
        return wrap(func.apply(unwrap(this), args));
    };
}
function transformCachableValue(value) {
    if (typeof value === 'function') return wrapFunction(value);
    // This doesn't return, it just creates a 'done' promise for the transaction,
    // which is later returned for transaction.done (see idbObjectHandler).
    if (value instanceof IDBTransaction) cacheDonePromiseForTransaction(value);
    if (instanceOfAny(value, getIdbProxyableTypes())) return new Proxy(value, idbProxyTraps);
    // Return the same value back if we're not going to transform it.
    return value;
}
function wrap(value) {
    // We sometimes generate multiple promises from a single IDBRequest (eg when cursoring), because
    // IDB is weird and a single IDBRequest can yield many responses, so these can't be cached.
    if (value instanceof IDBRequest) return promisifyRequest(value);
    // If we've already transformed this value before, reuse the transformed value.
    // This is faster, but it also provides object equality.
    if (transformCache.has(value)) return transformCache.get(value);
    const newValue = transformCachableValue(value);
    // Not all types are transformed.
    // These may be primitive types, so they can't be WeakMap keys.
    if (newValue !== value) {
        transformCache.set(value, newValue);
        reverseTransformCache.set(newValue, value);
    }
    return newValue;
}
const unwrap = (value)=>reverseTransformCache.get(value);

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dZ6yw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _auth = require("@firebase/auth");
parcelHelpers.exportAll(_auth, exports);

},{"@firebase/auth":"fIGSE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fIGSE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActionCodeOperation", ()=>(0, _indexD90D2Ee5Js.A));
parcelHelpers.export(exports, "ActionCodeURL", ()=>(0, _indexD90D2Ee5Js.aj));
parcelHelpers.export(exports, "AuthCredential", ()=>(0, _indexD90D2Ee5Js.M));
parcelHelpers.export(exports, "AuthErrorCodes", ()=>(0, _indexD90D2Ee5Js.J));
parcelHelpers.export(exports, "EmailAuthCredential", ()=>(0, _indexD90D2Ee5Js.N));
parcelHelpers.export(exports, "EmailAuthProvider", ()=>(0, _indexD90D2Ee5Js.W));
parcelHelpers.export(exports, "FacebookAuthProvider", ()=>(0, _indexD90D2Ee5Js.X));
parcelHelpers.export(exports, "FactorId", ()=>(0, _indexD90D2Ee5Js.F));
parcelHelpers.export(exports, "GithubAuthProvider", ()=>(0, _indexD90D2Ee5Js.Z));
parcelHelpers.export(exports, "GoogleAuthProvider", ()=>(0, _indexD90D2Ee5Js.Y));
parcelHelpers.export(exports, "OAuthCredential", ()=>(0, _indexD90D2Ee5Js.Q));
parcelHelpers.export(exports, "OAuthProvider", ()=>(0, _indexD90D2Ee5Js._));
parcelHelpers.export(exports, "OperationType", ()=>(0, _indexD90D2Ee5Js.O));
parcelHelpers.export(exports, "PhoneAuthCredential", ()=>(0, _indexD90D2Ee5Js.U));
parcelHelpers.export(exports, "PhoneAuthProvider", ()=>(0, _indexD90D2Ee5Js.P));
parcelHelpers.export(exports, "PhoneMultiFactorGenerator", ()=>(0, _indexD90D2Ee5Js.n));
parcelHelpers.export(exports, "ProviderId", ()=>(0, _indexD90D2Ee5Js.q));
parcelHelpers.export(exports, "RecaptchaVerifier", ()=>(0, _indexD90D2Ee5Js.R));
parcelHelpers.export(exports, "SAMLAuthProvider", ()=>(0, _indexD90D2Ee5Js.$));
parcelHelpers.export(exports, "SignInMethod", ()=>(0, _indexD90D2Ee5Js.S));
parcelHelpers.export(exports, "TotpMultiFactorGenerator", ()=>(0, _indexD90D2Ee5Js.T));
parcelHelpers.export(exports, "TotpSecret", ()=>(0, _indexD90D2Ee5Js.o));
parcelHelpers.export(exports, "TwitterAuthProvider", ()=>(0, _indexD90D2Ee5Js.a0));
parcelHelpers.export(exports, "applyActionCode", ()=>(0, _indexD90D2Ee5Js.a8));
parcelHelpers.export(exports, "beforeAuthStateChanged", ()=>(0, _indexD90D2Ee5Js.y));
parcelHelpers.export(exports, "browserCookiePersistence", ()=>(0, _indexD90D2Ee5Js.a));
parcelHelpers.export(exports, "browserLocalPersistence", ()=>(0, _indexD90D2Ee5Js.b));
parcelHelpers.export(exports, "browserPopupRedirectResolver", ()=>(0, _indexD90D2Ee5Js.m));
parcelHelpers.export(exports, "browserSessionPersistence", ()=>(0, _indexD90D2Ee5Js.c));
parcelHelpers.export(exports, "checkActionCode", ()=>(0, _indexD90D2Ee5Js.a9));
parcelHelpers.export(exports, "confirmPasswordReset", ()=>(0, _indexD90D2Ee5Js.a7));
parcelHelpers.export(exports, "connectAuthEmulator", ()=>(0, _indexD90D2Ee5Js.L));
parcelHelpers.export(exports, "createUserWithEmailAndPassword", ()=>(0, _indexD90D2Ee5Js.ab));
parcelHelpers.export(exports, "debugErrorMap", ()=>(0, _indexD90D2Ee5Js.H));
parcelHelpers.export(exports, "deleteUser", ()=>(0, _indexD90D2Ee5Js.G));
parcelHelpers.export(exports, "fetchSignInMethodsForEmail", ()=>(0, _indexD90D2Ee5Js.ag));
parcelHelpers.export(exports, "getAdditionalUserInfo", ()=>(0, _indexD90D2Ee5Js.ar));
parcelHelpers.export(exports, "getAuth", ()=>(0, _indexD90D2Ee5Js.p));
parcelHelpers.export(exports, "getIdToken", ()=>(0, _indexD90D2Ee5Js.ao));
parcelHelpers.export(exports, "getIdTokenResult", ()=>(0, _indexD90D2Ee5Js.ap));
parcelHelpers.export(exports, "getMultiFactorResolver", ()=>(0, _indexD90D2Ee5Js.at));
parcelHelpers.export(exports, "getRedirectResult", ()=>(0, _indexD90D2Ee5Js.k));
parcelHelpers.export(exports, "inMemoryPersistence", ()=>(0, _indexD90D2Ee5Js.V));
parcelHelpers.export(exports, "indexedDBLocalPersistence", ()=>(0, _indexD90D2Ee5Js.i));
parcelHelpers.export(exports, "initializeAuth", ()=>(0, _indexD90D2Ee5Js.K));
parcelHelpers.export(exports, "initializeRecaptchaConfig", ()=>(0, _indexD90D2Ee5Js.v));
parcelHelpers.export(exports, "isSignInWithEmailLink", ()=>(0, _indexD90D2Ee5Js.ae));
parcelHelpers.export(exports, "linkWithCredential", ()=>(0, _indexD90D2Ee5Js.a3));
parcelHelpers.export(exports, "linkWithPhoneNumber", ()=>(0, _indexD90D2Ee5Js.l));
parcelHelpers.export(exports, "linkWithPopup", ()=>(0, _indexD90D2Ee5Js.e));
parcelHelpers.export(exports, "linkWithRedirect", ()=>(0, _indexD90D2Ee5Js.h));
parcelHelpers.export(exports, "multiFactor", ()=>(0, _indexD90D2Ee5Js.au));
parcelHelpers.export(exports, "onAuthStateChanged", ()=>(0, _indexD90D2Ee5Js.z));
parcelHelpers.export(exports, "onIdTokenChanged", ()=>(0, _indexD90D2Ee5Js.x));
parcelHelpers.export(exports, "parseActionCodeURL", ()=>(0, _indexD90D2Ee5Js.ak));
parcelHelpers.export(exports, "prodErrorMap", ()=>(0, _indexD90D2Ee5Js.I));
parcelHelpers.export(exports, "reauthenticateWithCredential", ()=>(0, _indexD90D2Ee5Js.a4));
parcelHelpers.export(exports, "reauthenticateWithPhoneNumber", ()=>(0, _indexD90D2Ee5Js.r));
parcelHelpers.export(exports, "reauthenticateWithPopup", ()=>(0, _indexD90D2Ee5Js.f));
parcelHelpers.export(exports, "reauthenticateWithRedirect", ()=>(0, _indexD90D2Ee5Js.j));
parcelHelpers.export(exports, "reload", ()=>(0, _indexD90D2Ee5Js.as));
parcelHelpers.export(exports, "revokeAccessToken", ()=>(0, _indexD90D2Ee5Js.E));
parcelHelpers.export(exports, "sendEmailVerification", ()=>(0, _indexD90D2Ee5Js.ah));
parcelHelpers.export(exports, "sendPasswordResetEmail", ()=>(0, _indexD90D2Ee5Js.a6));
parcelHelpers.export(exports, "sendSignInLinkToEmail", ()=>(0, _indexD90D2Ee5Js.ad));
parcelHelpers.export(exports, "setPersistence", ()=>(0, _indexD90D2Ee5Js.t));
parcelHelpers.export(exports, "signInAnonymously", ()=>(0, _indexD90D2Ee5Js.a1));
parcelHelpers.export(exports, "signInWithCredential", ()=>(0, _indexD90D2Ee5Js.a2));
parcelHelpers.export(exports, "signInWithCustomToken", ()=>(0, _indexD90D2Ee5Js.a5));
parcelHelpers.export(exports, "signInWithEmailAndPassword", ()=>(0, _indexD90D2Ee5Js.ac));
parcelHelpers.export(exports, "signInWithEmailLink", ()=>(0, _indexD90D2Ee5Js.af));
parcelHelpers.export(exports, "signInWithPhoneNumber", ()=>(0, _indexD90D2Ee5Js.s));
parcelHelpers.export(exports, "signInWithPopup", ()=>(0, _indexD90D2Ee5Js.d));
parcelHelpers.export(exports, "signInWithRedirect", ()=>(0, _indexD90D2Ee5Js.g));
parcelHelpers.export(exports, "signOut", ()=>(0, _indexD90D2Ee5Js.D));
parcelHelpers.export(exports, "unlink", ()=>(0, _indexD90D2Ee5Js.aq));
parcelHelpers.export(exports, "updateCurrentUser", ()=>(0, _indexD90D2Ee5Js.C));
parcelHelpers.export(exports, "updateEmail", ()=>(0, _indexD90D2Ee5Js.am));
parcelHelpers.export(exports, "updatePassword", ()=>(0, _indexD90D2Ee5Js.an));
parcelHelpers.export(exports, "updatePhoneNumber", ()=>(0, _indexD90D2Ee5Js.u));
parcelHelpers.export(exports, "updateProfile", ()=>(0, _indexD90D2Ee5Js.al));
parcelHelpers.export(exports, "useDeviceLanguage", ()=>(0, _indexD90D2Ee5Js.B));
parcelHelpers.export(exports, "validatePassword", ()=>(0, _indexD90D2Ee5Js.w));
parcelHelpers.export(exports, "verifyBeforeUpdateEmail", ()=>(0, _indexD90D2Ee5Js.ai));
parcelHelpers.export(exports, "verifyPasswordResetCode", ()=>(0, _indexD90D2Ee5Js.aa));
var _indexD90D2Ee5Js = require("./index-d90d2ee5.js");
var _app = require("@firebase/app");
var _util = require("@firebase/util");
var _logger = require("@firebase/logger");
var _component = require("@firebase/component");

},{"./index-d90d2ee5.js":"844GM","@firebase/app":"iO7sa","@firebase/util":"fHqXn","@firebase/logger":"kY52V","@firebase/component":"6VF6E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"844GM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>SAMLAuthProvider);
parcelHelpers.export(exports, "A", ()=>ActionCodeOperation);
parcelHelpers.export(exports, "B", ()=>useDeviceLanguage);
parcelHelpers.export(exports, "C", ()=>updateCurrentUser);
parcelHelpers.export(exports, "D", ()=>signOut);
parcelHelpers.export(exports, "E", ()=>revokeAccessToken);
parcelHelpers.export(exports, "F", ()=>FactorId);
parcelHelpers.export(exports, "G", ()=>deleteUser);
parcelHelpers.export(exports, "H", ()=>debugErrorMap);
parcelHelpers.export(exports, "I", ()=>prodErrorMap);
parcelHelpers.export(exports, "J", ()=>AUTH_ERROR_CODES_MAP_DO_NOT_USE_INTERNALLY);
parcelHelpers.export(exports, "K", ()=>initializeAuth);
parcelHelpers.export(exports, "L", ()=>connectAuthEmulator);
parcelHelpers.export(exports, "M", ()=>AuthCredential);
parcelHelpers.export(exports, "N", ()=>EmailAuthCredential);
parcelHelpers.export(exports, "O", ()=>OperationType);
parcelHelpers.export(exports, "P", ()=>PhoneAuthProvider);
parcelHelpers.export(exports, "Q", ()=>OAuthCredential);
parcelHelpers.export(exports, "R", ()=>RecaptchaVerifier);
parcelHelpers.export(exports, "S", ()=>SignInMethod);
parcelHelpers.export(exports, "T", ()=>TotpMultiFactorGenerator);
parcelHelpers.export(exports, "U", ()=>PhoneAuthCredential);
parcelHelpers.export(exports, "V", ()=>inMemoryPersistence);
parcelHelpers.export(exports, "W", ()=>EmailAuthProvider);
parcelHelpers.export(exports, "X", ()=>FacebookAuthProvider);
parcelHelpers.export(exports, "Y", ()=>GoogleAuthProvider);
parcelHelpers.export(exports, "Z", ()=>GithubAuthProvider);
parcelHelpers.export(exports, "_", ()=>OAuthProvider);
parcelHelpers.export(exports, "a", ()=>browserCookiePersistence);
parcelHelpers.export(exports, "a0", ()=>TwitterAuthProvider);
parcelHelpers.export(exports, "a1", ()=>signInAnonymously);
parcelHelpers.export(exports, "a2", ()=>signInWithCredential);
parcelHelpers.export(exports, "a3", ()=>linkWithCredential);
parcelHelpers.export(exports, "a4", ()=>reauthenticateWithCredential);
parcelHelpers.export(exports, "a5", ()=>signInWithCustomToken);
parcelHelpers.export(exports, "a6", ()=>sendPasswordResetEmail);
parcelHelpers.export(exports, "a7", ()=>confirmPasswordReset);
parcelHelpers.export(exports, "a8", ()=>applyActionCode);
parcelHelpers.export(exports, "a9", ()=>checkActionCode);
parcelHelpers.export(exports, "aA", ()=>_getProjectConfig);
parcelHelpers.export(exports, "aB", ()=>_isIOS7Or8);
parcelHelpers.export(exports, "aC", ()=>_createError);
parcelHelpers.export(exports, "aD", ()=>_assert);
parcelHelpers.export(exports, "aE", ()=>AuthEventManager);
parcelHelpers.export(exports, "aF", ()=>_getInstance);
parcelHelpers.export(exports, "aG", ()=>_persistenceKeyName);
parcelHelpers.export(exports, "aH", ()=>_getRedirectResult);
parcelHelpers.export(exports, "aI", ()=>_overrideRedirectResult);
parcelHelpers.export(exports, "aJ", ()=>_clearRedirectOutcomes);
parcelHelpers.export(exports, "aK", ()=>_castAuth);
parcelHelpers.export(exports, "aL", ()=>UserImpl);
parcelHelpers.export(exports, "aM", ()=>AuthImpl);
parcelHelpers.export(exports, "aN", ()=>_getClientVersion);
parcelHelpers.export(exports, "aO", ()=>_generateEventId);
parcelHelpers.export(exports, "aP", ()=>AuthPopup);
parcelHelpers.export(exports, "aQ", ()=>FetchProvider);
parcelHelpers.export(exports, "aR", ()=>SAMLAuthCredential);
parcelHelpers.export(exports, "aa", ()=>verifyPasswordResetCode);
parcelHelpers.export(exports, "ab", ()=>createUserWithEmailAndPassword);
parcelHelpers.export(exports, "ac", ()=>signInWithEmailAndPassword);
parcelHelpers.export(exports, "ad", ()=>sendSignInLinkToEmail);
parcelHelpers.export(exports, "ae", ()=>isSignInWithEmailLink);
parcelHelpers.export(exports, "af", ()=>signInWithEmailLink);
parcelHelpers.export(exports, "ag", ()=>fetchSignInMethodsForEmail);
parcelHelpers.export(exports, "ah", ()=>sendEmailVerification);
parcelHelpers.export(exports, "ai", ()=>verifyBeforeUpdateEmail);
parcelHelpers.export(exports, "aj", ()=>ActionCodeURL);
parcelHelpers.export(exports, "ak", ()=>parseActionCodeURL);
parcelHelpers.export(exports, "al", ()=>updateProfile);
parcelHelpers.export(exports, "am", ()=>updateEmail);
parcelHelpers.export(exports, "an", ()=>updatePassword);
parcelHelpers.export(exports, "ao", ()=>getIdToken);
parcelHelpers.export(exports, "ap", ()=>getIdTokenResult);
parcelHelpers.export(exports, "aq", ()=>unlink);
parcelHelpers.export(exports, "ar", ()=>getAdditionalUserInfo);
parcelHelpers.export(exports, "as", ()=>reload);
parcelHelpers.export(exports, "at", ()=>getMultiFactorResolver);
parcelHelpers.export(exports, "au", ()=>multiFactor);
parcelHelpers.export(exports, "av", ()=>debugAssert);
parcelHelpers.export(exports, "aw", ()=>_isIOS);
parcelHelpers.export(exports, "ax", ()=>_isAndroid);
parcelHelpers.export(exports, "ay", ()=>_fail);
parcelHelpers.export(exports, "az", ()=>_getRedirectUrl);
parcelHelpers.export(exports, "b", ()=>browserLocalPersistence);
parcelHelpers.export(exports, "c", ()=>browserSessionPersistence);
parcelHelpers.export(exports, "d", ()=>signInWithPopup);
parcelHelpers.export(exports, "e", ()=>linkWithPopup);
parcelHelpers.export(exports, "f", ()=>reauthenticateWithPopup);
parcelHelpers.export(exports, "g", ()=>signInWithRedirect);
parcelHelpers.export(exports, "h", ()=>linkWithRedirect);
parcelHelpers.export(exports, "i", ()=>indexedDBLocalPersistence);
parcelHelpers.export(exports, "j", ()=>reauthenticateWithRedirect);
parcelHelpers.export(exports, "k", ()=>getRedirectResult);
parcelHelpers.export(exports, "l", ()=>linkWithPhoneNumber);
parcelHelpers.export(exports, "m", ()=>browserPopupRedirectResolver);
parcelHelpers.export(exports, "n", ()=>PhoneMultiFactorGenerator);
parcelHelpers.export(exports, "o", ()=>TotpSecret);
parcelHelpers.export(exports, "p", ()=>getAuth);
parcelHelpers.export(exports, "q", ()=>ProviderId);
parcelHelpers.export(exports, "r", ()=>reauthenticateWithPhoneNumber);
parcelHelpers.export(exports, "s", ()=>signInWithPhoneNumber);
parcelHelpers.export(exports, "t", ()=>setPersistence);
parcelHelpers.export(exports, "u", ()=>updatePhoneNumber);
parcelHelpers.export(exports, "v", ()=>initializeRecaptchaConfig);
parcelHelpers.export(exports, "w", ()=>validatePassword);
parcelHelpers.export(exports, "x", ()=>onIdTokenChanged);
parcelHelpers.export(exports, "y", ()=>beforeAuthStateChanged);
parcelHelpers.export(exports, "z", ()=>onAuthStateChanged);
var _app = require("@firebase/app");
var _util = require("@firebase/util");
var _logger = require("@firebase/logger");
var _component = require("@firebase/component");
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enum of factors that may be used for multifactor authentication.
 *
 * @public
 */ const FactorId = {
    /** Phone as second factor */ PHONE: 'phone',
    TOTP: 'totp'
};
/**
 * Enumeration of supported providers.
 *
 * @public
 */ const ProviderId = {
    /** Facebook provider ID */ FACEBOOK: 'facebook.com',
    /** GitHub provider ID */ GITHUB: 'github.com',
    /** Google provider ID */ GOOGLE: 'google.com',
    /** Password provider */ PASSWORD: 'password',
    /** Phone provider */ PHONE: 'phone',
    /** Twitter provider ID */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported sign-in methods.
 *
 * @public
 */ const SignInMethod = {
    /** Email link sign in method */ EMAIL_LINK: 'emailLink',
    /** Email/password sign in method */ EMAIL_PASSWORD: 'password',
    /** Facebook sign in method */ FACEBOOK: 'facebook.com',
    /** GitHub sign in method */ GITHUB: 'github.com',
    /** Google sign in method */ GOOGLE: 'google.com',
    /** Phone sign in method */ PHONE: 'phone',
    /** Twitter sign in method */ TWITTER: 'twitter.com'
};
/**
 * Enumeration of supported operation types.
 *
 * @public
 */ const OperationType = {
    /** Operation involving linking an additional provider to an already signed-in user. */ LINK: 'link',
    /** Operation involving using a provider to reauthenticate an already signed-in user. */ REAUTHENTICATE: 'reauthenticate',
    /** Operation involving signing in a user. */ SIGN_IN: 'signIn'
};
/**
 * An enumeration of the possible email action types.
 *
 * @public
 */ const ActionCodeOperation = {
    /** The email link sign-in action. */ EMAIL_SIGNIN: 'EMAIL_SIGNIN',
    /** The password reset action. */ PASSWORD_RESET: 'PASSWORD_RESET',
    /** The email revocation action. */ RECOVER_EMAIL: 'RECOVER_EMAIL',
    /** The revert second factor addition email action. */ REVERT_SECOND_FACTOR_ADDITION: 'REVERT_SECOND_FACTOR_ADDITION',
    /** The revert second factor addition email action. */ VERIFY_AND_CHANGE_EMAIL: 'VERIFY_AND_CHANGE_EMAIL',
    /** The email verification action. */ VERIFY_EMAIL: 'VERIFY_EMAIL'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _debugErrorMap() {
    return {
        ["admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ]: 'This operation is restricted to administrators only.',
        ["argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ ]: '',
        ["app-not-authorized" /* AuthErrorCode.APP_NOT_AUTHORIZED */ ]: "This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.",
        ["app-not-installed" /* AuthErrorCode.APP_NOT_INSTALLED */ ]: "The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.",
        ["captcha-check-failed" /* AuthErrorCode.CAPTCHA_CHECK_FAILED */ ]: "The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
        ["code-expired" /* AuthErrorCode.CODE_EXPIRED */ ]: "The SMS code has expired. Please re-send the verification code to try again.",
        ["cordova-not-ready" /* AuthErrorCode.CORDOVA_NOT_READY */ ]: 'Cordova framework is not ready.',
        ["cors-unsupported" /* AuthErrorCode.CORS_UNSUPPORTED */ ]: 'This browser is not supported.',
        ["credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ]: 'This credential is already associated with a different user account.',
        ["custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ]: 'The custom token corresponds to a different audience.',
        ["requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK.",
        ["dynamic-link-not-activated" /* AuthErrorCode.DYNAMIC_LINK_NOT_ACTIVATED */ ]: "Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.",
        ["email-change-needs-verification" /* AuthErrorCode.EMAIL_CHANGE_NEEDS_VERIFICATION */ ]: 'Multi-factor users must always have a verified email.',
        ["email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ]: 'The email address is already in use by another account.',
        ["emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ ]: 'Auth instance has already been used to make a network call. Auth can no longer be configured to use the emulator. Try calling "connectAuthEmulator()" sooner.',
        ["expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ]: 'The action code has expired.',
        ["cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ]: 'This operation has been cancelled due to another conflicting popup being opened.',
        ["internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ]: 'An internal AuthError has occurred.',
        ["invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ ]: "The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
        ["invalid-app-id" /* AuthErrorCode.INVALID_APP_ID */ ]: 'The mobile app identifier is not registered for the current project.',
        ["invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ]: "This user's credential isn't valid for this project. This can happen if the user's token has been tampered with, or if the user isn't for the project associated with this API key.",
        ["invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ]: "The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure to use the verification code provided by the user.",
        ["invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ ]: 'The continue URL provided in the request is invalid.',
        ["invalid-cordova-configuration" /* AuthErrorCode.INVALID_CORDOVA_CONFIGURATION */ ]: "The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.",
        ["invalid-custom-token" /* AuthErrorCode.INVALID_CUSTOM_TOKEN */ ]: 'The custom token format is incorrect. Please check the documentation.',
        ["invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ ]: 'The provided dynamic link domain is not configured or authorized for the current project.',
        ["invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ]: 'The email address is badly formatted.',
        ["invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ ]: 'Emulator URL must start with a valid scheme (http:// or https://).',
        ["invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ ]: 'Your API key is invalid, please check you have copied it correctly.',
        ["invalid-cert-hash" /* AuthErrorCode.INVALID_CERT_HASH */ ]: 'The SHA-1 certificate hash provided is invalid.',
        ["invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ]: 'The supplied auth credential is incorrect, malformed or has expired.',
        ["invalid-message-payload" /* AuthErrorCode.INVALID_MESSAGE_PAYLOAD */ ]: "The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ]: 'The request does not contain a valid proof of first factor successful sign-in.',
        ["invalid-oauth-provider" /* AuthErrorCode.INVALID_OAUTH_PROVIDER */ ]: "EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
        ["invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ]: "The OAuth client ID provided is either invalid or does not match the specified API key.",
        ["unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ ]: "This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.",
        ["invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ]: "The action code is invalid. This can happen if the code is malformed, expired, or has already been used.",
        ["wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ]: 'The password is invalid or the user does not have a password.',
        ["invalid-persistence-type" /* AuthErrorCode.INVALID_PERSISTENCE */ ]: 'The specified persistence type is invalid. It can only be local, session or none.',
        ["invalid-phone-number" /* AuthErrorCode.INVALID_PHONE_NUMBER */ ]: "The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
        ["invalid-provider-id" /* AuthErrorCode.INVALID_PROVIDER_ID */ ]: 'The specified provider ID is invalid.',
        ["invalid-recipient-email" /* AuthErrorCode.INVALID_RECIPIENT_EMAIL */ ]: "The email corresponding to this action failed to send as the provided recipient email address is invalid.",
        ["invalid-sender" /* AuthErrorCode.INVALID_SENDER */ ]: "The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.",
        ["invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ]: 'The verification ID used to create the phone auth credential is invalid.',
        ["invalid-tenant-id" /* AuthErrorCode.INVALID_TENANT_ID */ ]: "The Auth instance's tenant ID is invalid.",
        ["login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ ]: 'Login blocked by user-provided method: {$originalMessage}',
        ["missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ]: 'An Android Package Name must be provided if the Android App is required to be installed.',
        ["auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ ]: "Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.",
        ["missing-app-credential" /* AuthErrorCode.MISSING_APP_CREDENTIAL */ ]: "The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.",
        ["missing-verification-code" /* AuthErrorCode.MISSING_CODE */ ]: 'The phone auth credential was created with an empty SMS verification code.',
        ["missing-continue-uri" /* AuthErrorCode.MISSING_CONTINUE_URI */ ]: 'A continue URL must be provided in the request.',
        ["missing-iframe-start" /* AuthErrorCode.MISSING_IFRAME_START */ ]: 'An internal AuthError has occurred.',
        ["missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ ]: 'An iOS Bundle ID must be provided if an App Store ID is provided.',
        ["missing-or-invalid-nonce" /* AuthErrorCode.MISSING_OR_INVALID_NONCE */ ]: "The request does not contain a valid nonce. This can occur if the SHA-256 hash of the provided raw nonce does not match the hashed nonce in the ID token payload.",
        ["missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ]: 'A non-empty password must be provided',
        ["missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ]: 'No second factor identifier is provided.',
        ["missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ]: 'The request is missing proof of first factor successful sign-in.',
        ["missing-phone-number" /* AuthErrorCode.MISSING_PHONE_NUMBER */ ]: 'To send verification codes, provide a phone number for the recipient.',
        ["missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ]: 'The phone auth credential was created with an empty verification ID.',
        ["app-deleted" /* AuthErrorCode.MODULE_DESTROYED */ ]: 'This instance of FirebaseApp has been deleted.',
        ["multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ]: 'The user does not have a second factor matching the identifier provided.',
        ["multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ ]: 'Proof of ownership of a second factor is required to complete sign-in.',
        ["account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ ]: "An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
        ["network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ]: 'A network AuthError (such as timeout, interrupted connection or unreachable host) has occurred.',
        ["no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ ]: 'An internal AuthError has occurred.',
        ["no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ]: 'User was not linked to an account with the given provider.',
        ["null-user" /* AuthErrorCode.NULL_USER */ ]: "A null user object was provided as the argument for an operation which requires a non-null user object.",
        ["operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ]: "The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.",
        ["operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ]: 'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
        ["popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ ]: 'Unable to establish a connection with the popup. It may have been blocked by the browser.',
        ["popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ]: 'The popup has been closed by the user before finalizing the operation.',
        ["provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */ ]: 'User can only be linked to one identity for the given provider.',
        ["quota-exceeded" /* AuthErrorCode.QUOTA_EXCEEDED */ ]: "The project's quota for this operation has been exceeded.",
        ["redirect-cancelled-by-user" /* AuthErrorCode.REDIRECT_CANCELLED_BY_USER */ ]: 'The redirect operation has been cancelled by the user before finalizing.',
        ["redirect-operation-pending" /* AuthErrorCode.REDIRECT_OPERATION_PENDING */ ]: 'A redirect sign-in operation is already pending.',
        ["rejected-credential" /* AuthErrorCode.REJECTED_CREDENTIAL */ ]: 'The request contains malformed or mismatching credentials.',
        ["second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ]: 'The second factor is already enrolled on this account.',
        ["maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: 'The maximum allowed number of second factors on a user has been exceeded.',
        ["tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ ]: "The provided tenant ID does not match the Auth instance's tenant ID",
        ["timeout" /* AuthErrorCode.TIMEOUT */ ]: 'The operation has timed out.',
        ["user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ]: "The user's credential is no longer valid. The user must sign in again.",
        ["too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "We have blocked all requests from this device due to unusual activity. Try again later.",
        ["unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ]: "The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.",
        ["unsupported-first-factor" /* AuthErrorCode.UNSUPPORTED_FIRST_FACTOR */ ]: 'Enrolling a second factor or signing in with a multi-factor account requires sign-in with a supported first factor.',
        ["unsupported-persistence-type" /* AuthErrorCode.UNSUPPORTED_PERSISTENCE */ ]: 'The current environment does not support the specified persistence type.',
        ["unsupported-tenant-operation" /* AuthErrorCode.UNSUPPORTED_TENANT_OPERATION */ ]: 'This operation is not supported in a multi-tenant context.',
        ["unverified-email" /* AuthErrorCode.UNVERIFIED_EMAIL */ ]: 'The operation requires a verified email.',
        ["user-cancelled" /* AuthErrorCode.USER_CANCELLED */ ]: 'The user did not grant your application the permissions it requested.',
        ["user-not-found" /* AuthErrorCode.USER_DELETED */ ]: "There is no user record corresponding to this identifier. The user may have been deleted.",
        ["user-disabled" /* AuthErrorCode.USER_DISABLED */ ]: 'The user account has been disabled by an administrator.',
        ["user-mismatch" /* AuthErrorCode.USER_MISMATCH */ ]: 'The supplied credentials do not correspond to the previously signed in user.',
        ["user-signed-out" /* AuthErrorCode.USER_SIGNED_OUT */ ]: '',
        ["weak-password" /* AuthErrorCode.WEAK_PASSWORD */ ]: 'The password must be 6 characters long or more.',
        ["web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ]: 'This browser is not supported or 3rd party cookies and data may be disabled.',
        ["already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ ]: "initializeAuth() has already been called with different options. To avoid this error, call initializeAuth() with the same options as when it was originally called, or call getAuth() to return the already initialized instance.",
        ["missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is missing when sending request to the backend.',
        ["invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ]: 'The reCAPTCHA token is invalid when sending request to the backend.',
        ["invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ]: 'The reCAPTCHA action is invalid when sending request to the backend.',
        ["recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ]: 'reCAPTCHA Enterprise integration is not enabled for this project.',
        ["missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ]: 'The reCAPTCHA client type is missing when sending request to the backend.',
        ["missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is missing when sending request to the backend.',
        ["invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ ]: 'Invalid request parameters.',
        ["invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ]: 'The reCAPTCHA version is invalid when sending request to the backend.',
        ["unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ ]: 'The password policy received from the backend uses a schema version that is not supported by this version of the Firebase SDK.',
        ["password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: 'The password does not meet the requirements.',
        ["invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ ]: "The provided Hosting link domain is not configured in Firebase Hosting or is not owned by the current project. This cannot be a default Hosting domain (`web.app` or `firebaseapp.com`)."
    };
}
function _prodErrorMap() {
    // We will include this one message in the prod error map since by the very
    // nature of this error, developers will never be able to see the message
    // using the debugErrorMap (which is installed during auth initialization).
    return {
        ["dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ ]: "Another Firebase SDK was initialized and is trying to use Auth before Auth is initialized. Please be sure to call `initializeAuth` or `getAuth` before starting any other Firebase SDK."
    };
}
/**
 * A verbose error map with detailed descriptions for most error codes.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const debugErrorMap = _debugErrorMap;
/**
 * A minimal error map with all verbose error messages stripped.
 *
 * See discussion at {@link AuthErrorMap}
 *
 * @public
 */ const prodErrorMap = _prodErrorMap;
const _DEFAULT_AUTH_ERROR_FACTORY = new (0, _util.ErrorFactory)('auth', 'Firebase', _prodErrorMap());
/**
 * A map of potential `Auth` error codes, for easier comparison with errors
 * thrown by the SDK.
 *
 * @remarks
 * Note that you can't tree-shake individual keys
 * in the map, so by using the map you might substantially increase your
 * bundle size.
 *
 * @public
 */ const AUTH_ERROR_CODES_MAP_DO_NOT_USE_INTERNALLY = {
    ADMIN_ONLY_OPERATION: 'auth/admin-restricted-operation',
    ARGUMENT_ERROR: 'auth/argument-error',
    APP_NOT_AUTHORIZED: 'auth/app-not-authorized',
    APP_NOT_INSTALLED: 'auth/app-not-installed',
    CAPTCHA_CHECK_FAILED: 'auth/captcha-check-failed',
    CODE_EXPIRED: 'auth/code-expired',
    CORDOVA_NOT_READY: 'auth/cordova-not-ready',
    CORS_UNSUPPORTED: 'auth/cors-unsupported',
    CREDENTIAL_ALREADY_IN_USE: 'auth/credential-already-in-use',
    CREDENTIAL_MISMATCH: 'auth/custom-token-mismatch',
    CREDENTIAL_TOO_OLD_LOGIN_AGAIN: 'auth/requires-recent-login',
    DEPENDENT_SDK_INIT_BEFORE_AUTH: 'auth/dependent-sdk-initialized-before-auth',
    DYNAMIC_LINK_NOT_ACTIVATED: 'auth/dynamic-link-not-activated',
    EMAIL_CHANGE_NEEDS_VERIFICATION: 'auth/email-change-needs-verification',
    EMAIL_EXISTS: 'auth/email-already-in-use',
    EMULATOR_CONFIG_FAILED: 'auth/emulator-config-failed',
    EXPIRED_OOB_CODE: 'auth/expired-action-code',
    EXPIRED_POPUP_REQUEST: 'auth/cancelled-popup-request',
    INTERNAL_ERROR: 'auth/internal-error',
    INVALID_API_KEY: 'auth/invalid-api-key',
    INVALID_APP_CREDENTIAL: 'auth/invalid-app-credential',
    INVALID_APP_ID: 'auth/invalid-app-id',
    INVALID_AUTH: 'auth/invalid-user-token',
    INVALID_AUTH_EVENT: 'auth/invalid-auth-event',
    INVALID_CERT_HASH: 'auth/invalid-cert-hash',
    INVALID_CODE: 'auth/invalid-verification-code',
    INVALID_CONTINUE_URI: 'auth/invalid-continue-uri',
    INVALID_CORDOVA_CONFIGURATION: 'auth/invalid-cordova-configuration',
    INVALID_CUSTOM_TOKEN: 'auth/invalid-custom-token',
    INVALID_DYNAMIC_LINK_DOMAIN: 'auth/invalid-dynamic-link-domain',
    INVALID_EMAIL: 'auth/invalid-email',
    INVALID_EMULATOR_SCHEME: 'auth/invalid-emulator-scheme',
    INVALID_IDP_RESPONSE: 'auth/invalid-credential',
    INVALID_LOGIN_CREDENTIALS: 'auth/invalid-credential',
    INVALID_MESSAGE_PAYLOAD: 'auth/invalid-message-payload',
    INVALID_MFA_SESSION: 'auth/invalid-multi-factor-session',
    INVALID_OAUTH_CLIENT_ID: 'auth/invalid-oauth-client-id',
    INVALID_OAUTH_PROVIDER: 'auth/invalid-oauth-provider',
    INVALID_OOB_CODE: 'auth/invalid-action-code',
    INVALID_ORIGIN: 'auth/unauthorized-domain',
    INVALID_PASSWORD: 'auth/wrong-password',
    INVALID_PERSISTENCE: 'auth/invalid-persistence-type',
    INVALID_PHONE_NUMBER: 'auth/invalid-phone-number',
    INVALID_PROVIDER_ID: 'auth/invalid-provider-id',
    INVALID_RECIPIENT_EMAIL: 'auth/invalid-recipient-email',
    INVALID_SENDER: 'auth/invalid-sender',
    INVALID_SESSION_INFO: 'auth/invalid-verification-id',
    INVALID_TENANT_ID: 'auth/invalid-tenant-id',
    MFA_INFO_NOT_FOUND: 'auth/multi-factor-info-not-found',
    MFA_REQUIRED: 'auth/multi-factor-auth-required',
    MISSING_ANDROID_PACKAGE_NAME: 'auth/missing-android-pkg-name',
    MISSING_APP_CREDENTIAL: 'auth/missing-app-credential',
    MISSING_AUTH_DOMAIN: 'auth/auth-domain-config-required',
    MISSING_CODE: 'auth/missing-verification-code',
    MISSING_CONTINUE_URI: 'auth/missing-continue-uri',
    MISSING_IFRAME_START: 'auth/missing-iframe-start',
    MISSING_IOS_BUNDLE_ID: 'auth/missing-ios-bundle-id',
    MISSING_OR_INVALID_NONCE: 'auth/missing-or-invalid-nonce',
    MISSING_MFA_INFO: 'auth/missing-multi-factor-info',
    MISSING_MFA_SESSION: 'auth/missing-multi-factor-session',
    MISSING_PHONE_NUMBER: 'auth/missing-phone-number',
    MISSING_PASSWORD: 'auth/missing-password',
    MISSING_SESSION_INFO: 'auth/missing-verification-id',
    MODULE_DESTROYED: 'auth/app-deleted',
    NEED_CONFIRMATION: 'auth/account-exists-with-different-credential',
    NETWORK_REQUEST_FAILED: 'auth/network-request-failed',
    NULL_USER: 'auth/null-user',
    NO_AUTH_EVENT: 'auth/no-auth-event',
    NO_SUCH_PROVIDER: 'auth/no-such-provider',
    OPERATION_NOT_ALLOWED: 'auth/operation-not-allowed',
    OPERATION_NOT_SUPPORTED: 'auth/operation-not-supported-in-this-environment',
    POPUP_BLOCKED: 'auth/popup-blocked',
    POPUP_CLOSED_BY_USER: 'auth/popup-closed-by-user',
    PROVIDER_ALREADY_LINKED: 'auth/provider-already-linked',
    QUOTA_EXCEEDED: 'auth/quota-exceeded',
    REDIRECT_CANCELLED_BY_USER: 'auth/redirect-cancelled-by-user',
    REDIRECT_OPERATION_PENDING: 'auth/redirect-operation-pending',
    REJECTED_CREDENTIAL: 'auth/rejected-credential',
    SECOND_FACTOR_ALREADY_ENROLLED: 'auth/second-factor-already-in-use',
    SECOND_FACTOR_LIMIT_EXCEEDED: 'auth/maximum-second-factor-count-exceeded',
    TENANT_ID_MISMATCH: 'auth/tenant-id-mismatch',
    TIMEOUT: 'auth/timeout',
    TOKEN_EXPIRED: 'auth/user-token-expired',
    TOO_MANY_ATTEMPTS_TRY_LATER: 'auth/too-many-requests',
    UNAUTHORIZED_DOMAIN: 'auth/unauthorized-continue-uri',
    UNSUPPORTED_FIRST_FACTOR: 'auth/unsupported-first-factor',
    UNSUPPORTED_PERSISTENCE: 'auth/unsupported-persistence-type',
    UNSUPPORTED_TENANT_OPERATION: 'auth/unsupported-tenant-operation',
    UNVERIFIED_EMAIL: 'auth/unverified-email',
    USER_CANCELLED: 'auth/user-cancelled',
    USER_DELETED: 'auth/user-not-found',
    USER_DISABLED: 'auth/user-disabled',
    USER_MISMATCH: 'auth/user-mismatch',
    USER_SIGNED_OUT: 'auth/user-signed-out',
    WEAK_PASSWORD: 'auth/weak-password',
    WEB_STORAGE_UNSUPPORTED: 'auth/web-storage-unsupported',
    ALREADY_INITIALIZED: 'auth/already-initialized',
    RECAPTCHA_NOT_ENABLED: 'auth/recaptcha-not-enabled',
    MISSING_RECAPTCHA_TOKEN: 'auth/missing-recaptcha-token',
    INVALID_RECAPTCHA_TOKEN: 'auth/invalid-recaptcha-token',
    INVALID_RECAPTCHA_ACTION: 'auth/invalid-recaptcha-action',
    MISSING_CLIENT_TYPE: 'auth/missing-client-type',
    MISSING_RECAPTCHA_VERSION: 'auth/missing-recaptcha-version',
    INVALID_RECAPTCHA_VERSION: 'auth/invalid-recaptcha-version',
    INVALID_REQ_TYPE: 'auth/invalid-req-type',
    INVALID_HOSTING_LINK_DOMAIN: 'auth/invalid-hosting-link-domain'
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const logClient = new (0, _logger.Logger)('@firebase/auth');
function _logWarn(msg, ...args) {
    if (logClient.logLevel <= (0, _logger.LogLevel).WARN) logClient.warn(`Auth (${(0, _app.SDK_VERSION)}): ${msg}`, ...args);
}
function _logError(msg, ...args) {
    if (logClient.logLevel <= (0, _logger.LogLevel).ERROR) logClient.error(`Auth (${(0, _app.SDK_VERSION)}): ${msg}`, ...args);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _fail(authOrCode, ...rest) {
    throw createErrorInternal(authOrCode, ...rest);
}
function _createError(authOrCode, ...rest) {
    return createErrorInternal(authOrCode, ...rest);
}
function _errorWithCustomMessage(auth, code, message) {
    const errorMap = {
        ...prodErrorMap(),
        [code]: message
    };
    const factory = new (0, _util.ErrorFactory)('auth', 'Firebase', errorMap);
    return factory.create(code, {
        appName: auth.name
    });
}
function _serverAppCurrentUserOperationNotSupportedError(auth) {
    return _errorWithCustomMessage(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ , 'Operations that alter the current user are not supported in conjunction with FirebaseServerApp');
}
function _assertInstanceOf(auth, object, instance) {
    const constructorInstance = instance;
    if (!(object instanceof constructorInstance)) {
        if (constructorInstance.name !== object.constructor.name) _fail(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        throw _errorWithCustomMessage(auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , `Type of ${object.constructor.name} does not match expected instance.` + `Did you pass a reference from a different Auth SDK?`);
    }
}
function createErrorInternal(authOrCode, ...rest) {
    if (typeof authOrCode !== 'string') {
        const code = rest[0];
        const fullParams = [
            ...rest.slice(1)
        ];
        if (fullParams[0]) fullParams[0].appName = authOrCode.name;
        return authOrCode._errorFactory.create(code, ...fullParams);
    }
    return _DEFAULT_AUTH_ERROR_FACTORY.create(authOrCode, ...rest);
}
function _assert(assertion, authOrCode, ...rest) {
    if (!assertion) throw createErrorInternal(authOrCode, ...rest);
}
/**
 * Unconditionally fails, throwing an internal error with the given message.
 *
 * @param failure type of failure encountered
 * @throws Error
 */ function debugFail(failure) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    const message = `INTERNAL ASSERTION FAILED: ` + failure;
    _logError(message);
    // NOTE: We don't use FirebaseError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw new Error(message);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * @param assertion
 * @param message
 */ function debugAssert(assertion, message) {
    if (!assertion) debugFail(message);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _getCurrentUrl() {
    return typeof self !== 'undefined' && self.location?.href || '';
}
function _isHttpOrHttps() {
    return _getCurrentScheme() === 'http:' || _getCurrentScheme() === 'https:';
}
function _getCurrentScheme() {
    return typeof self !== 'undefined' && self.location?.protocol || null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine whether the browser is working online
 */ function _isOnline() {
    if (typeof navigator !== 'undefined' && navigator && 'onLine' in navigator && typeof navigator.onLine === 'boolean' && // Apply only for traditional web apps and Chrome extensions.
    // This is especially true for Cordova apps which have unreliable
    // navigator.onLine behavior unless cordova-plugin-network-information is
    // installed which overwrites the native navigator.onLine value and
    // defines navigator.connection.
    (_isHttpOrHttps() || (0, _util.isBrowserExtension)() || 'connection' in navigator)) return navigator.onLine;
    // If we can't determine the state, assume it is online.
    return true;
}
function _getUserLanguage() {
    if (typeof navigator === 'undefined') return null;
    const navigatorLanguage = navigator;
    return(// Most reliable, but only supported in Chrome/Firefox.
    navigatorLanguage.languages && navigatorLanguage.languages[0] || // Supported in most browsers, but returns the language of the browser
    // UI, not the language set in browser settings.
    navigatorLanguage.language || // Couldn't determine language.
    null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A structure to help pick between a range of long and short delay durations
 * depending on the current environment. In general, the long delay is used for
 * mobile environments whereas short delays are used for desktop environments.
 */ class Delay {
    constructor(shortDelay, longDelay){
        this.shortDelay = shortDelay;
        this.longDelay = longDelay;
        // Internal error when improperly initialized.
        debugAssert(longDelay > shortDelay, 'Short delay should be less than long delay!');
        this.isMobile = (0, _util.isMobileCordova)() || (0, _util.isReactNative)();
    }
    get() {
        if (!_isOnline()) // Pick the shorter timeout.
        return Math.min(5000 /* DelayMin.OFFLINE */ , this.shortDelay);
        // If running in a mobile environment, return the long delay, otherwise
        // return the short delay.
        // This could be improved in the future to dynamically change based on other
        // variables instead of just reading the current environment.
        return this.isMobile ? this.longDelay : this.shortDelay;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _emulatorUrl(config, path) {
    debugAssert(config.emulator, 'Emulator should always be set here');
    const { url } = config.emulator;
    if (!path) return url;
    return `${url}${path.startsWith('/') ? path.slice(1) : path}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class FetchProvider {
    static initialize(fetchImpl, headersImpl, responseImpl) {
        this.fetchImpl = fetchImpl;
        if (headersImpl) this.headersImpl = headersImpl;
        if (responseImpl) this.responseImpl = responseImpl;
    }
    static fetch() {
        if (this.fetchImpl) return this.fetchImpl;
        if (typeof self !== 'undefined' && 'fetch' in self) return self.fetch;
        if (typeof globalThis !== 'undefined' && globalThis.fetch) return globalThis.fetch;
        if (typeof fetch !== 'undefined') return fetch;
        debugFail('Could not find fetch implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static headers() {
        if (this.headersImpl) return this.headersImpl;
        if (typeof self !== 'undefined' && 'Headers' in self) return self.Headers;
        if (typeof globalThis !== 'undefined' && globalThis.Headers) return globalThis.Headers;
        if (typeof Headers !== 'undefined') return Headers;
        debugFail('Could not find Headers implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
    static response() {
        if (this.responseImpl) return this.responseImpl;
        if (typeof self !== 'undefined' && 'Response' in self) return self.Response;
        if (typeof globalThis !== 'undefined' && globalThis.Response) return globalThis.Response;
        if (typeof Response !== 'undefined') return Response;
        debugFail('Could not find Response implementation, make sure you call FetchProvider.initialize() with an appropriate polyfill');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Map from errors returned by the server to errors to developer visible errors
 */ const SERVER_ERROR_MAP = {
    // Custom token errors.
    ["CREDENTIAL_MISMATCH" /* ServerError.CREDENTIAL_MISMATCH */ ]: "custom-token-mismatch" /* AuthErrorCode.CREDENTIAL_MISMATCH */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CUSTOM_TOKEN" /* ServerError.MISSING_CUSTOM_TOKEN */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Create Auth URI errors.
    ["INVALID_IDENTIFIER" /* ServerError.INVALID_IDENTIFIER */ ]: "invalid-email" /* AuthErrorCode.INVALID_EMAIL */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_CONTINUE_URI" /* ServerError.MISSING_CONTINUE_URI */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Sign in with email and password errors (some apply to sign up too).
    ["INVALID_PASSWORD" /* ServerError.INVALID_PASSWORD */ ]: "wrong-password" /* AuthErrorCode.INVALID_PASSWORD */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_PASSWORD" /* ServerError.MISSING_PASSWORD */ ]: "missing-password" /* AuthErrorCode.MISSING_PASSWORD */ ,
    // Thrown if Email Enumeration Protection is enabled in the project and the email or password is
    // invalid.
    ["INVALID_LOGIN_CREDENTIALS" /* ServerError.INVALID_LOGIN_CREDENTIALS */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    // Sign up with email and password errors.
    ["EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ]: "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ ,
    ["PASSWORD_LOGIN_DISABLED" /* ServerError.PASSWORD_LOGIN_DISABLED */ ]: "operation-not-allowed" /* AuthErrorCode.OPERATION_NOT_ALLOWED */ ,
    // Verify assertion for sign in with credential errors:
    ["INVALID_IDP_RESPONSE" /* ServerError.INVALID_IDP_RESPONSE */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["INVALID_PENDING_TOKEN" /* ServerError.INVALID_PENDING_TOKEN */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ]: "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_REQ_TYPE" /* ServerError.MISSING_REQ_TYPE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Send Password reset email errors:
    ["EMAIL_NOT_FOUND" /* ServerError.EMAIL_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ ,
    ["RESET_PASSWORD_EXCEED_LIMIT" /* ServerError.RESET_PASSWORD_EXCEED_LIMIT */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["EXPIRED_OOB_CODE" /* ServerError.EXPIRED_OOB_CODE */ ]: "expired-action-code" /* AuthErrorCode.EXPIRED_OOB_CODE */ ,
    ["INVALID_OOB_CODE" /* ServerError.INVALID_OOB_CODE */ ]: "invalid-action-code" /* AuthErrorCode.INVALID_OOB_CODE */ ,
    // This can only happen if the SDK sends a bad request.
    ["MISSING_OOB_CODE" /* ServerError.MISSING_OOB_CODE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Operations that require ID token in request:
    ["CREDENTIAL_TOO_OLD_LOGIN_AGAIN" /* ServerError.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ]: "requires-recent-login" /* AuthErrorCode.CREDENTIAL_TOO_OLD_LOGIN_AGAIN */ ,
    ["INVALID_ID_TOKEN" /* ServerError.INVALID_ID_TOKEN */ ]: "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ ,
    ["TOKEN_EXPIRED" /* ServerError.TOKEN_EXPIRED */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ ,
    // Other errors.
    ["TOO_MANY_ATTEMPTS_TRY_LATER" /* ServerError.TOO_MANY_ATTEMPTS_TRY_LATER */ ]: "too-many-requests" /* AuthErrorCode.TOO_MANY_ATTEMPTS_TRY_LATER */ ,
    ["PASSWORD_DOES_NOT_MEET_REQUIREMENTS" /* ServerError.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ]: "password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ ,
    // Phone Auth related errors.
    ["INVALID_CODE" /* ServerError.INVALID_CODE */ ]: "invalid-verification-code" /* AuthErrorCode.INVALID_CODE */ ,
    ["INVALID_SESSION_INFO" /* ServerError.INVALID_SESSION_INFO */ ]: "invalid-verification-id" /* AuthErrorCode.INVALID_SESSION_INFO */ ,
    ["INVALID_TEMPORARY_PROOF" /* ServerError.INVALID_TEMPORARY_PROOF */ ]: "invalid-credential" /* AuthErrorCode.INVALID_CREDENTIAL */ ,
    ["MISSING_SESSION_INFO" /* ServerError.MISSING_SESSION_INFO */ ]: "missing-verification-id" /* AuthErrorCode.MISSING_SESSION_INFO */ ,
    ["SESSION_EXPIRED" /* ServerError.SESSION_EXPIRED */ ]: "code-expired" /* AuthErrorCode.CODE_EXPIRED */ ,
    // Other action code errors when additional settings passed.
    // MISSING_CONTINUE_URI is getting mapped to INTERNAL_ERROR above.
    // This is OK as this error will be caught by client side validation.
    ["MISSING_ANDROID_PACKAGE_NAME" /* ServerError.MISSING_ANDROID_PACKAGE_NAME */ ]: "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ ,
    ["UNAUTHORIZED_DOMAIN" /* ServerError.UNAUTHORIZED_DOMAIN */ ]: "unauthorized-continue-uri" /* AuthErrorCode.UNAUTHORIZED_DOMAIN */ ,
    // getProjectConfig errors when clientId is passed.
    ["INVALID_OAUTH_CLIENT_ID" /* ServerError.INVALID_OAUTH_CLIENT_ID */ ]: "invalid-oauth-client-id" /* AuthErrorCode.INVALID_OAUTH_CLIENT_ID */ ,
    // User actions (sign-up or deletion) disabled errors.
    ["ADMIN_ONLY_OPERATION" /* ServerError.ADMIN_ONLY_OPERATION */ ]: "admin-restricted-operation" /* AuthErrorCode.ADMIN_ONLY_OPERATION */ ,
    // Multi factor related errors.
    ["INVALID_MFA_PENDING_CREDENTIAL" /* ServerError.INVALID_MFA_PENDING_CREDENTIAL */ ]: "invalid-multi-factor-session" /* AuthErrorCode.INVALID_MFA_SESSION */ ,
    ["MFA_ENROLLMENT_NOT_FOUND" /* ServerError.MFA_ENROLLMENT_NOT_FOUND */ ]: "multi-factor-info-not-found" /* AuthErrorCode.MFA_INFO_NOT_FOUND */ ,
    ["MISSING_MFA_ENROLLMENT_ID" /* ServerError.MISSING_MFA_ENROLLMENT_ID */ ]: "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ ,
    ["MISSING_MFA_PENDING_CREDENTIAL" /* ServerError.MISSING_MFA_PENDING_CREDENTIAL */ ]: "missing-multi-factor-session" /* AuthErrorCode.MISSING_MFA_SESSION */ ,
    ["SECOND_FACTOR_EXISTS" /* ServerError.SECOND_FACTOR_EXISTS */ ]: "second-factor-already-in-use" /* AuthErrorCode.SECOND_FACTOR_ALREADY_ENROLLED */ ,
    ["SECOND_FACTOR_LIMIT_EXCEEDED" /* ServerError.SECOND_FACTOR_LIMIT_EXCEEDED */ ]: "maximum-second-factor-count-exceeded" /* AuthErrorCode.SECOND_FACTOR_LIMIT_EXCEEDED */ ,
    // Blocking functions related errors.
    ["BLOCKING_FUNCTION_ERROR_RESPONSE" /* ServerError.BLOCKING_FUNCTION_ERROR_RESPONSE */ ]: "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ,
    // Recaptcha related errors.
    ["RECAPTCHA_NOT_ENABLED" /* ServerError.RECAPTCHA_NOT_ENABLED */ ]: "recaptcha-not-enabled" /* AuthErrorCode.RECAPTCHA_NOT_ENABLED */ ,
    ["MISSING_RECAPTCHA_TOKEN" /* ServerError.MISSING_RECAPTCHA_TOKEN */ ]: "missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_TOKEN" /* ServerError.INVALID_RECAPTCHA_TOKEN */ ]: "invalid-recaptcha-token" /* AuthErrorCode.INVALID_RECAPTCHA_TOKEN */ ,
    ["INVALID_RECAPTCHA_ACTION" /* ServerError.INVALID_RECAPTCHA_ACTION */ ]: "invalid-recaptcha-action" /* AuthErrorCode.INVALID_RECAPTCHA_ACTION */ ,
    ["MISSING_CLIENT_TYPE" /* ServerError.MISSING_CLIENT_TYPE */ ]: "missing-client-type" /* AuthErrorCode.MISSING_CLIENT_TYPE */ ,
    ["MISSING_RECAPTCHA_VERSION" /* ServerError.MISSING_RECAPTCHA_VERSION */ ]: "missing-recaptcha-version" /* AuthErrorCode.MISSING_RECAPTCHA_VERSION */ ,
    ["INVALID_RECAPTCHA_VERSION" /* ServerError.INVALID_RECAPTCHA_VERSION */ ]: "invalid-recaptcha-version" /* AuthErrorCode.INVALID_RECAPTCHA_VERSION */ ,
    ["INVALID_REQ_TYPE" /* ServerError.INVALID_REQ_TYPE */ ]: "invalid-req-type" /* AuthErrorCode.INVALID_REQ_TYPE */ 
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const CookieAuthProxiedEndpoints = [
    "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ ,
    "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ ,
    "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ ,
    "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ ,
    "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ ,
    "/v1/token" /* Endpoint.TOKEN */ 
];
const DEFAULT_API_TIMEOUT_MS = new Delay(30000, 60000);
function _addTidIfNecessary(auth, request) {
    if (auth.tenantId && !request.tenantId) return {
        ...request,
        tenantId: auth.tenantId
    };
    return request;
}
async function _performApiRequest(auth, method, path, request, customErrorMap = {}) {
    return _performFetchWithErrorHandling(auth, customErrorMap, async ()=>{
        let body = {};
        let params = {};
        if (request) {
            if (method === "GET" /* HttpMethod.GET */ ) params = request;
            else body = {
                body: JSON.stringify(request)
            };
        }
        const query = (0, _util.querystring)({
            ...params,
            key: auth.config.apiKey
        }).slice(1);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/json';
        if (auth.languageCode) headers["X-Firebase-Locale" /* HttpHeader.X_FIREBASE_LOCALE */ ] = auth.languageCode;
        const fetchArgs = {
            method,
            headers,
            ...body
        };
        /* Security-conscious server-side frameworks tend to have built in mitigations for referrer
           problems". See the Cloudflare GitHub issue #487: Error: The 'referrerPolicy' field on
           'RequestInitializerDict' is not implemented."
           https://github.com/cloudflare/next-on-pages/issues/487 */ if (!(0, _util.isCloudflareWorker)()) fetchArgs.referrerPolicy = 'strict-origin-when-cross-origin';
        if (auth.emulatorConfig && (0, _util.isCloudWorkstation)(auth.emulatorConfig.host)) fetchArgs.credentials = 'include';
        return FetchProvider.fetch()(await _getFinalTarget(auth, auth.config.apiHost, path, query), fetchArgs);
    });
}
async function _performFetchWithErrorHandling(auth, customErrorMap, fetchFn) {
    auth._canInitEmulator = false;
    const errorMap = {
        ...SERVER_ERROR_MAP,
        ...customErrorMap
    };
    try {
        const networkTimeout = new NetworkTimeout(auth);
        const response = await Promise.race([
            fetchFn(),
            networkTimeout.promise
        ]);
        // If we've reached this point, the fetch succeeded and the networkTimeout
        // didn't throw; clear the network timeout delay so that Node won't hang
        networkTimeout.clearNetworkTimeout();
        const json = await response.json();
        if ('needConfirmation' in json) throw _makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , json);
        if (response.ok && !('errorMessage' in json)) return json;
        else {
            const errorMessage = response.ok ? json.errorMessage : json.error.message;
            const [serverErrorCode, serverErrorMessage] = errorMessage.split(' : ');
            if (serverErrorCode === "FEDERATED_USER_ID_ALREADY_LINKED" /* ServerError.FEDERATED_USER_ID_ALREADY_LINKED */ ) throw _makeTaggedError(auth, "credential-already-in-use" /* AuthErrorCode.CREDENTIAL_ALREADY_IN_USE */ , json);
            else if (serverErrorCode === "EMAIL_EXISTS" /* ServerError.EMAIL_EXISTS */ ) throw _makeTaggedError(auth, "email-already-in-use" /* AuthErrorCode.EMAIL_EXISTS */ , json);
            else if (serverErrorCode === "USER_DISABLED" /* ServerError.USER_DISABLED */ ) throw _makeTaggedError(auth, "user-disabled" /* AuthErrorCode.USER_DISABLED */ , json);
            const authError = errorMap[serverErrorCode] || serverErrorCode.toLowerCase().replace(/[_\s]+/g, '-');
            if (serverErrorMessage) throw _errorWithCustomMessage(auth, authError, serverErrorMessage);
            else _fail(auth, authError);
        }
    } catch (e) {
        if (e instanceof (0, _util.FirebaseError)) throw e;
        // Changing this to a different error code will log user out when there is a network error
        // because we treat any error other than NETWORK_REQUEST_FAILED as token is invalid.
        // https://github.com/firebase/firebase-js-sdk/blob/4fbc73610d70be4e0852e7de63a39cb7897e8546/packages/auth/src/core/auth/auth_impl.ts#L309-L316
        _fail(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ , {
            'message': String(e)
        });
    }
}
async function _performSignInRequest(auth, method, path, request, customErrorMap = {}) {
    const serverResponse = await _performApiRequest(auth, method, path, request, customErrorMap);
    if ('mfaPendingCredential' in serverResponse) _fail(auth, "multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ , {
        _serverResponse: serverResponse
    });
    return serverResponse;
}
async function _getFinalTarget(auth, host, path, query) {
    const base = `${host}${path}?${query}`;
    const authInternal = auth;
    const finalTarget = authInternal.config.emulator ? _emulatorUrl(auth.config, base) : `${auth.config.apiScheme}://${base}`;
    // Cookie auth works by MiTMing the signIn and token endpoints from the developer's backend,
    // saving the idToken and refreshToken into cookies, and then redacting the refreshToken
    // from the response
    if (CookieAuthProxiedEndpoints.includes(path)) {
        // Persistence manager is async, we need to await it. We can't just wait for auth initialized
        // here since auth initialization calls this function.
        await authInternal._persistenceManagerAvailable;
        if (authInternal._getPersistenceType() === "COOKIE" /* PersistenceType.COOKIE */ ) {
            const cookiePersistence = authInternal._getPersistence();
            return cookiePersistence._getFinalTarget(finalTarget).toString();
        }
    }
    return finalTarget;
}
function _parseEnforcementState(enforcementStateStr) {
    switch(enforcementStateStr){
        case 'ENFORCE':
            return "ENFORCE" /* EnforcementState.ENFORCE */ ;
        case 'AUDIT':
            return "AUDIT" /* EnforcementState.AUDIT */ ;
        case 'OFF':
            return "OFF" /* EnforcementState.OFF */ ;
        default:
            return "ENFORCEMENT_STATE_UNSPECIFIED" /* EnforcementState.ENFORCEMENT_STATE_UNSPECIFIED */ ;
    }
}
class NetworkTimeout {
    clearNetworkTimeout() {
        clearTimeout(this.timer);
    }
    constructor(auth){
        this.auth = auth;
        // Node timers and browser timers are fundamentally incompatible, but we
        // don't care about the value here
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timer = null;
        this.promise = new Promise((_, reject)=>{
            this.timer = setTimeout(()=>{
                return reject(_createError(this.auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, DEFAULT_API_TIMEOUT_MS.get());
        });
    }
}
function _makeTaggedError(auth, code, response) {
    const errorParams = {
        appName: auth.name
    };
    if (response.email) errorParams.email = response.email;
    if (response.phoneNumber) errorParams.phoneNumber = response.phoneNumber;
    const error = _createError(auth, code, errorParams);
    // We know customData is defined on error because errorParams is defined
    error.customData._tokenResponse = response;
    return error;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function isV2(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.getResponse !== undefined;
}
function isEnterprise(grecaptcha) {
    return grecaptcha !== undefined && grecaptcha.enterprise !== undefined;
}
class RecaptchaConfig {
    constructor(response){
        /**
         * The reCAPTCHA site key.
         */ this.siteKey = '';
        /**
         * The list of providers and their enablement status for reCAPTCHA Enterprise.
         */ this.recaptchaEnforcementState = [];
        if (response.recaptchaKey === undefined) throw new Error('recaptchaKey undefined');
        // Example response.recaptchaKey: "projects/proj123/keys/sitekey123"
        this.siteKey = response.recaptchaKey.split('/')[3];
        this.recaptchaEnforcementState = response.recaptchaEnforcementState;
    }
    /**
     * Returns the reCAPTCHA Enterprise enforcement state for the given provider.
     *
     * @param providerStr - The provider whose enforcement state is to be returned.
     * @returns The reCAPTCHA Enterprise enforcement state for the given provider.
     */ getProviderEnforcementState(providerStr) {
        if (!this.recaptchaEnforcementState || this.recaptchaEnforcementState.length === 0) return null;
        for (const recaptchaEnforcementState of this.recaptchaEnforcementState){
            if (recaptchaEnforcementState.provider && recaptchaEnforcementState.provider === providerStr) return _parseEnforcementState(recaptchaEnforcementState.enforcementState);
        }
        return null;
    }
    /**
     * Returns true if the reCAPTCHA Enterprise enforcement state for the provider is set to ENFORCE or AUDIT.
     *
     * @param providerStr - The provider whose enablement state is to be returned.
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for the given provider.
     */ isProviderEnabled(providerStr) {
        return this.getProviderEnforcementState(providerStr) === "ENFORCE" /* EnforcementState.ENFORCE */  || this.getProviderEnforcementState(providerStr) === "AUDIT" /* EnforcementState.AUDIT */ ;
    }
    /**
     * Returns true if reCAPTCHA Enterprise protection is enabled in at least one provider, otherwise
     * returns false.
     *
     * @returns Whether or not reCAPTCHA Enterprise protection is enabled for at least one provider.
     */ isAnyProviderEnabled() {
        return this.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) || this.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function getRecaptchaParams(auth) {
    return (await _performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/recaptchaParams" /* Endpoint.GET_RECAPTCHA_PARAM */ )).recaptchaSiteKey || '';
}
async function getRecaptchaConfig(auth, request) {
    return _performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/recaptchaConfig" /* Endpoint.GET_RECAPTCHA_CONFIG */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function deleteAccount(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:delete" /* Endpoint.DELETE_ACCOUNT */ , request);
}
async function deleteLinkedAccounts(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
async function getAccountInfo(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:lookup" /* Endpoint.GET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function utcTimestampToDateString(utcTimestamp) {
    if (!utcTimestamp) return undefined;
    try {
        // Convert to date object.
        const date = new Date(Number(utcTimestamp));
        // Test date is valid.
        if (!isNaN(date.getTime())) // Convert to UTC date string.
        return date.toUTCString();
    } catch (e) {
    // Do nothing. undefined will be returned.
    }
    return undefined;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ function getIdToken(user, forceRefresh = false) {
    return (0, _util.getModularInstance)(user).getIdToken(forceRefresh);
}
/**
 * Returns a deserialized JSON Web Token (JWT) used to identify the user to a Firebase service.
 *
 * @remarks
 * Returns the current token if it has not expired or if it will not expire in the next five
 * minutes. Otherwise, this will refresh the token and return a new one.
 *
 * @param user - The user.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function getIdTokenResult(user, forceRefresh = false) {
    const userInternal = (0, _util.getModularInstance)(user);
    const token = await userInternal.getIdToken(forceRefresh);
    const claims = _parseToken(token);
    _assert(claims && claims.exp && claims.auth_time && claims.iat, userInternal.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const firebase = typeof claims.firebase === 'object' ? claims.firebase : undefined;
    const signInProvider = firebase?.['sign_in_provider'];
    return {
        claims,
        token,
        authTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.auth_time)),
        issuedAtTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.iat)),
        expirationTime: utcTimestampToDateString(secondsStringToMilliseconds(claims.exp)),
        signInProvider: signInProvider || null,
        signInSecondFactor: firebase?.['sign_in_second_factor'] || null
    };
}
function secondsStringToMilliseconds(seconds) {
    return Number(seconds) * 1000;
}
function _parseToken(token) {
    const [algorithm, payload, signature] = token.split('.');
    if (algorithm === undefined || payload === undefined || signature === undefined) {
        _logError('JWT malformed, contained fewer than 3 sections');
        return null;
    }
    try {
        const decoded = (0, _util.base64Decode)(payload);
        if (!decoded) {
            _logError('Failed to decode base64 JWT payload');
            return null;
        }
        return JSON.parse(decoded);
    } catch (e) {
        _logError('Caught error parsing JWT payload as JSON', e?.toString());
        return null;
    }
}
/**
 * Extract expiresIn TTL from a token by subtracting the expiration from the issuance.
 */ function _tokenExpiresIn(token) {
    const parsedToken = _parseToken(token);
    _assert(parsedToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    _assert(typeof parsedToken.exp !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    _assert(typeof parsedToken.iat !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return Number(parsedToken.exp) - Number(parsedToken.iat);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _logoutIfInvalidated(user, promise, bypassAuthState = false) {
    if (bypassAuthState) return promise;
    try {
        return await promise;
    } catch (e) {
        if (e instanceof (0, _util.FirebaseError) && isUserInvalidated(e)) {
            if (user.auth.currentUser === user) await user.auth.signOut();
        }
        throw e;
    }
}
function isUserInvalidated({ code }) {
    return code === `auth/${"user-disabled" /* AuthErrorCode.USER_DISABLED */ }` || code === `auth/${"user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ }`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class ProactiveRefresh {
    constructor(user){
        this.user = user;
        this.isRunning = false;
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.timerId = null;
        this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
    }
    _start() {
        if (this.isRunning) return;
        this.isRunning = true;
        this.schedule();
    }
    _stop() {
        if (!this.isRunning) return;
        this.isRunning = false;
        if (this.timerId !== null) clearTimeout(this.timerId);
    }
    getInterval(wasError) {
        if (wasError) {
            const interval = this.errorBackoff;
            this.errorBackoff = Math.min(this.errorBackoff * 2, 960000 /* Duration.RETRY_BACKOFF_MAX */ );
            return interval;
        } else {
            // Reset the error backoff
            this.errorBackoff = 30000 /* Duration.RETRY_BACKOFF_MIN */ ;
            const expTime = this.user.stsTokenManager.expirationTime ?? 0;
            const interval = expTime - Date.now() - 300000 /* Duration.OFFSET */ ;
            return Math.max(0, interval);
        }
    }
    schedule(wasError = false) {
        if (!this.isRunning) // Just in case...
        return;
        const interval = this.getInterval(wasError);
        this.timerId = setTimeout(async ()=>{
            await this.iteration();
        }, interval);
    }
    async iteration() {
        try {
            await this.user.getIdToken(true);
        } catch (e) {
            // Only retry on network errors
            if (e?.code === `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) this.schedule(/* wasError */ true);
            return;
        }
        this.schedule();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class UserMetadata {
    constructor(createdAt, lastLoginAt){
        this.createdAt = createdAt;
        this.lastLoginAt = lastLoginAt;
        this._initializeTime();
    }
    _initializeTime() {
        this.lastSignInTime = utcTimestampToDateString(this.lastLoginAt);
        this.creationTime = utcTimestampToDateString(this.createdAt);
    }
    _copy(metadata) {
        this.createdAt = metadata.createdAt;
        this.lastLoginAt = metadata.lastLoginAt;
        this._initializeTime();
    }
    toJSON() {
        return {
            createdAt: this.createdAt,
            lastLoginAt: this.lastLoginAt
        };
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _reloadWithoutSaving(user) {
    const auth = user.auth;
    const idToken = await user.getIdToken();
    const response = await _logoutIfInvalidated(user, getAccountInfo(auth, {
        idToken
    }));
    _assert(response?.users.length, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    const coreAccount = response.users[0];
    user._notifyReloadListener(coreAccount);
    const newProviderData = coreAccount.providerUserInfo?.length ? extractProviderData(coreAccount.providerUserInfo) : [];
    const providerData = mergeProviderData(user.providerData, newProviderData);
    // Preserves the non-nonymous status of the stored user, even if no more
    // credentials (federated or email/password) are linked to the user. If
    // the user was previously anonymous, then use provider data to update.
    // On the other hand, if it was not anonymous before, it should never be
    // considered anonymous now.
    const oldIsAnonymous = user.isAnonymous;
    const newIsAnonymous = !(user.email && coreAccount.passwordHash) && !providerData?.length;
    const isAnonymous = !oldIsAnonymous ? false : newIsAnonymous;
    const updates = {
        uid: coreAccount.localId,
        displayName: coreAccount.displayName || null,
        photoURL: coreAccount.photoUrl || null,
        email: coreAccount.email || null,
        emailVerified: coreAccount.emailVerified || false,
        phoneNumber: coreAccount.phoneNumber || null,
        tenantId: coreAccount.tenantId || null,
        providerData,
        metadata: new UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
        isAnonymous
    };
    Object.assign(user, updates);
}
/**
 * Reloads user account data, if signed in.
 *
 * @param user - The user.
 *
 * @public
 */ async function reload(user) {
    const userInternal = (0, _util.getModularInstance)(user);
    await _reloadWithoutSaving(userInternal);
    // Even though the current user hasn't changed, update
    // current user will trigger a persistence update w/ the
    // new info.
    await userInternal.auth._persistUserIfCurrent(userInternal);
    userInternal.auth._notifyListenersIfCurrent(userInternal);
}
function mergeProviderData(original, newData) {
    const deduped = original.filter((o)=>!newData.some((n)=>n.providerId === o.providerId));
    return [
        ...deduped,
        ...newData
    ];
}
function extractProviderData(providers) {
    return providers.map(({ providerId, ...provider })=>{
        return {
            providerId,
            uid: provider.rawId || '',
            displayName: provider.displayName || null,
            email: provider.email || null,
            phoneNumber: provider.phoneNumber || null,
            photoURL: provider.photoUrl || null
        };
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function requestStsToken(auth, refreshToken) {
    const response = await _performFetchWithErrorHandling(auth, {}, async ()=>{
        const body = (0, _util.querystring)({
            'grant_type': 'refresh_token',
            'refresh_token': refreshToken
        }).slice(1);
        const { tokenApiHost, apiKey } = auth.config;
        const url = await _getFinalTarget(auth, tokenApiHost, "/v1/token" /* Endpoint.TOKEN */ , `key=${apiKey}`);
        const headers = await auth._getAdditionalHeaders();
        headers["Content-Type" /* HttpHeader.CONTENT_TYPE */ ] = 'application/x-www-form-urlencoded';
        const options = {
            method: "POST" /* HttpMethod.POST */ ,
            headers,
            body
        };
        if (auth.emulatorConfig && (0, _util.isCloudWorkstation)(auth.emulatorConfig.host)) options.credentials = 'include';
        return FetchProvider.fetch()(url, options);
    });
    // The response comes back in snake_case. Convert to camel:
    return {
        accessToken: response.access_token,
        expiresIn: response.expires_in,
        refreshToken: response.refresh_token
    };
}
async function revokeToken(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts:revokeToken" /* Endpoint.REVOKE_TOKEN */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * We need to mark this class as internal explicitly to exclude it in the public typings, because
 * it references AuthInternal which has a circular dependency with UserInternal.
 *
 * @internal
 */ class StsTokenManager {
    constructor(){
        this.refreshToken = null;
        this.accessToken = null;
        this.expirationTime = null;
    }
    get isExpired() {
        return !this.expirationTime || Date.now() > this.expirationTime - 30000 /* Buffer.TOKEN_REFRESH */ ;
    }
    updateFromServerResponse(response) {
        _assert(response.idToken, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        _assert(typeof response.idToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        _assert(typeof response.refreshToken !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = 'expiresIn' in response && typeof response.expiresIn !== 'undefined' ? Number(response.expiresIn) : _tokenExpiresIn(response.idToken);
        this.updateTokensAndExpiration(response.idToken, response.refreshToken, expiresIn);
    }
    updateFromIdToken(idToken) {
        _assert(idToken.length !== 0, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const expiresIn = _tokenExpiresIn(idToken);
        this.updateTokensAndExpiration(idToken, null, expiresIn);
    }
    async getToken(auth, forceRefresh = false) {
        if (!forceRefresh && this.accessToken && !this.isExpired) return this.accessToken;
        _assert(this.refreshToken, auth, "user-token-expired" /* AuthErrorCode.TOKEN_EXPIRED */ );
        if (this.refreshToken) {
            await this.refresh(auth, this.refreshToken);
            return this.accessToken;
        }
        return null;
    }
    clearRefreshToken() {
        this.refreshToken = null;
    }
    async refresh(auth, oldToken) {
        const { accessToken, refreshToken, expiresIn } = await requestStsToken(auth, oldToken);
        this.updateTokensAndExpiration(accessToken, refreshToken, Number(expiresIn));
    }
    updateTokensAndExpiration(accessToken, refreshToken, expiresInSec) {
        this.refreshToken = refreshToken || null;
        this.accessToken = accessToken || null;
        this.expirationTime = Date.now() + expiresInSec * 1000;
    }
    static fromJSON(appName, object) {
        const { refreshToken, accessToken, expirationTime } = object;
        const manager = new StsTokenManager();
        if (refreshToken) {
            _assert(typeof refreshToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName
            });
            manager.refreshToken = refreshToken;
        }
        if (accessToken) {
            _assert(typeof accessToken === 'string', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName
            });
            manager.accessToken = accessToken;
        }
        if (expirationTime) {
            _assert(typeof expirationTime === 'number', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
                appName
            });
            manager.expirationTime = expirationTime;
        }
        return manager;
    }
    toJSON() {
        return {
            refreshToken: this.refreshToken,
            accessToken: this.accessToken,
            expirationTime: this.expirationTime
        };
    }
    _assign(stsTokenManager) {
        this.accessToken = stsTokenManager.accessToken;
        this.refreshToken = stsTokenManager.refreshToken;
        this.expirationTime = stsTokenManager.expirationTime;
    }
    _clone() {
        return Object.assign(new StsTokenManager(), this.toJSON());
    }
    _performRefresh() {
        return debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function assertStringOrUndefined(assertion, appName) {
    _assert(typeof assertion === 'string' || typeof assertion === 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ , {
        appName
    });
}
class UserImpl {
    constructor({ uid, auth, stsTokenManager, ...opt }){
        // For the user object, provider is always Firebase.
        this.providerId = "firebase" /* ProviderId.FIREBASE */ ;
        this.proactiveRefresh = new ProactiveRefresh(this);
        this.reloadUserInfo = null;
        this.reloadListener = null;
        this.uid = uid;
        this.auth = auth;
        this.stsTokenManager = stsTokenManager;
        this.accessToken = stsTokenManager.accessToken;
        this.displayName = opt.displayName || null;
        this.email = opt.email || null;
        this.emailVerified = opt.emailVerified || false;
        this.phoneNumber = opt.phoneNumber || null;
        this.photoURL = opt.photoURL || null;
        this.isAnonymous = opt.isAnonymous || false;
        this.tenantId = opt.tenantId || null;
        this.providerData = opt.providerData ? [
            ...opt.providerData
        ] : [];
        this.metadata = new UserMetadata(opt.createdAt || undefined, opt.lastLoginAt || undefined);
    }
    async getIdToken(forceRefresh) {
        const accessToken = await _logoutIfInvalidated(this, this.stsTokenManager.getToken(this.auth, forceRefresh));
        _assert(accessToken, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        if (this.accessToken !== accessToken) {
            this.accessToken = accessToken;
            await this.auth._persistUserIfCurrent(this);
            this.auth._notifyListenersIfCurrent(this);
        }
        return accessToken;
    }
    getIdTokenResult(forceRefresh) {
        return getIdTokenResult(this, forceRefresh);
    }
    reload() {
        return reload(this);
    }
    _assign(user) {
        if (this === user) return;
        _assert(this.uid === user.uid, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.displayName = user.displayName;
        this.photoURL = user.photoURL;
        this.email = user.email;
        this.emailVerified = user.emailVerified;
        this.phoneNumber = user.phoneNumber;
        this.isAnonymous = user.isAnonymous;
        this.tenantId = user.tenantId;
        this.providerData = user.providerData.map((userInfo)=>({
                ...userInfo
            }));
        this.metadata._copy(user.metadata);
        this.stsTokenManager._assign(user.stsTokenManager);
    }
    _clone(auth) {
        const newUser = new UserImpl({
            ...this,
            auth,
            stsTokenManager: this.stsTokenManager._clone()
        });
        newUser.metadata._copy(this.metadata);
        return newUser;
    }
    _onReload(callback) {
        // There should only ever be one listener, and that is a single instance of MultiFactorUser
        _assert(!this.reloadListener, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.reloadListener = callback;
        if (this.reloadUserInfo) {
            this._notifyReloadListener(this.reloadUserInfo);
            this.reloadUserInfo = null;
        }
    }
    _notifyReloadListener(userInfo) {
        if (this.reloadListener) this.reloadListener(userInfo);
        else // If no listener is subscribed yet, save the result so it's available when they do subscribe
        this.reloadUserInfo = userInfo;
    }
    _startProactiveRefresh() {
        this.proactiveRefresh._start();
    }
    _stopProactiveRefresh() {
        this.proactiveRefresh._stop();
    }
    async _updateTokensIfNecessary(response, reload = false) {
        let tokensRefreshed = false;
        if (response.idToken && response.idToken !== this.stsTokenManager.accessToken) {
            this.stsTokenManager.updateFromServerResponse(response);
            tokensRefreshed = true;
        }
        if (reload) await _reloadWithoutSaving(this);
        await this.auth._persistUserIfCurrent(this);
        if (tokensRefreshed) this.auth._notifyListenersIfCurrent(this);
    }
    async delete() {
        if ((0, _app._isFirebaseServerApp)(this.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this.auth));
        const idToken = await this.getIdToken();
        await _logoutIfInvalidated(this, deleteAccount(this.auth, {
            idToken
        }));
        this.stsTokenManager.clearRefreshToken();
        // TODO: Determine if cancellable-promises are necessary to use in this class so that delete()
        //       cancels pending actions...
        return this.auth.signOut();
    }
    toJSON() {
        return {
            uid: this.uid,
            email: this.email || undefined,
            emailVerified: this.emailVerified,
            displayName: this.displayName || undefined,
            isAnonymous: this.isAnonymous,
            photoURL: this.photoURL || undefined,
            phoneNumber: this.phoneNumber || undefined,
            tenantId: this.tenantId || undefined,
            providerData: this.providerData.map((userInfo)=>({
                    ...userInfo
                })),
            stsTokenManager: this.stsTokenManager.toJSON(),
            // Redirect event ID must be maintained in case there is a pending
            // redirect event.
            _redirectEventId: this._redirectEventId,
            ...this.metadata.toJSON(),
            // Required for compatibility with the legacy SDK (go/firebase-auth-sdk-persistence-parsing):
            apiKey: this.auth.config.apiKey,
            appName: this.auth.name
        };
    }
    get refreshToken() {
        return this.stsTokenManager.refreshToken || '';
    }
    static _fromJSON(auth, object) {
        const displayName = object.displayName ?? undefined;
        const email = object.email ?? undefined;
        const phoneNumber = object.phoneNumber ?? undefined;
        const photoURL = object.photoURL ?? undefined;
        const tenantId = object.tenantId ?? undefined;
        const _redirectEventId = object._redirectEventId ?? undefined;
        const createdAt = object.createdAt ?? undefined;
        const lastLoginAt = object.lastLoginAt ?? undefined;
        const { uid, emailVerified, isAnonymous, providerData, stsTokenManager: plainObjectTokenManager } = object;
        _assert(uid && plainObjectTokenManager, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const stsTokenManager = StsTokenManager.fromJSON(this.name, plainObjectTokenManager);
        _assert(typeof uid === 'string', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        assertStringOrUndefined(displayName, auth.name);
        assertStringOrUndefined(email, auth.name);
        _assert(typeof emailVerified === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        _assert(typeof isAnonymous === 'boolean', auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        assertStringOrUndefined(phoneNumber, auth.name);
        assertStringOrUndefined(photoURL, auth.name);
        assertStringOrUndefined(tenantId, auth.name);
        assertStringOrUndefined(_redirectEventId, auth.name);
        assertStringOrUndefined(createdAt, auth.name);
        assertStringOrUndefined(lastLoginAt, auth.name);
        const user = new UserImpl({
            uid,
            auth,
            email,
            emailVerified,
            displayName,
            isAnonymous,
            photoURL,
            phoneNumber,
            tenantId,
            stsTokenManager,
            createdAt,
            lastLoginAt
        });
        if (providerData && Array.isArray(providerData)) user.providerData = providerData.map((userInfo)=>({
                ...userInfo
            }));
        if (_redirectEventId) user._redirectEventId = _redirectEventId;
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromIdTokenResponse(auth, idTokenResponse, isAnonymous = false) {
        const stsTokenManager = new StsTokenManager();
        stsTokenManager.updateFromServerResponse(idTokenResponse);
        // Initialize the Firebase Auth user.
        const user = new UserImpl({
            uid: idTokenResponse.localId,
            auth,
            stsTokenManager,
            isAnonymous
        });
        // Updates the user info and data and resolves with a user instance.
        await _reloadWithoutSaving(user);
        return user;
    }
    /**
     * Initialize a User from an idToken server response
     * @param auth
     * @param idTokenResponse
     */ static async _fromGetAccountInfoResponse(auth, response, idToken) {
        const coreAccount = response.users[0];
        _assert(coreAccount.localId !== undefined, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const providerData = coreAccount.providerUserInfo !== undefined ? extractProviderData(coreAccount.providerUserInfo) : [];
        const isAnonymous = !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length;
        const stsTokenManager = new StsTokenManager();
        stsTokenManager.updateFromIdToken(idToken);
        // Initialize the Firebase Auth user.
        const user = new UserImpl({
            uid: coreAccount.localId,
            auth,
            stsTokenManager,
            isAnonymous
        });
        // update the user with data from the GetAccountInfo response.
        const updates = {
            uid: coreAccount.localId,
            displayName: coreAccount.displayName || null,
            photoURL: coreAccount.photoUrl || null,
            email: coreAccount.email || null,
            emailVerified: coreAccount.emailVerified || false,
            phoneNumber: coreAccount.phoneNumber || null,
            tenantId: coreAccount.tenantId || null,
            providerData,
            metadata: new UserMetadata(coreAccount.createdAt, coreAccount.lastLoginAt),
            isAnonymous: !(coreAccount.email && coreAccount.passwordHash) && !providerData?.length
        };
        Object.assign(user, updates);
        return user;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const instanceCache = new Map();
function _getInstance(cls) {
    debugAssert(cls instanceof Function, 'Expected a class definition');
    let instance = instanceCache.get(cls);
    if (instance) {
        debugAssert(instance instanceof cls, 'Instance stored in cache mismatched with class');
        return instance;
    }
    instance = new cls();
    instanceCache.set(cls, instance);
    return instance;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class InMemoryPersistence {
    constructor(){
        this.type = "NONE" /* PersistenceType.NONE */ ;
        this.storage = {};
    }
    async _isAvailable() {
        return true;
    }
    async _set(key, value) {
        this.storage[key] = value;
    }
    async _get(key) {
        const value = this.storage[key];
        return value === undefined ? null : value;
    }
    async _remove(key) {
        delete this.storage[key];
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for in-memory storage since it cannot be shared across windows/workers
        return;
    }
}
InMemoryPersistence.type = 'NONE';
/**
 * An implementation of {@link Persistence} of type 'NONE'.
 *
 * @public
 */ const inMemoryPersistence = InMemoryPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _persistenceKeyName(key, apiKey, appName) {
    return `${"firebase" /* Namespace.PERSISTENCE */ }:${key}:${apiKey}:${appName}`;
}
class PersistenceUserManager {
    constructor(persistence, auth, userKey){
        this.persistence = persistence;
        this.auth = auth;
        this.userKey = userKey;
        const { config, name } = this.auth;
        this.fullUserKey = _persistenceKeyName(this.userKey, config.apiKey, name);
        this.fullPersistenceKey = _persistenceKeyName("persistence" /* KeyName.PERSISTENCE_USER */ , config.apiKey, name);
        this.boundEventHandler = auth._onStorageEvent.bind(auth);
        this.persistence._addListener(this.fullUserKey, this.boundEventHandler);
    }
    setCurrentUser(user) {
        return this.persistence._set(this.fullUserKey, user.toJSON());
    }
    async getCurrentUser() {
        const blob = await this.persistence._get(this.fullUserKey);
        if (!blob) return null;
        if (typeof blob === 'string') {
            const response = await getAccountInfo(this.auth, {
                idToken: blob
            }).catch(()=>undefined);
            if (!response) return null;
            return UserImpl._fromGetAccountInfoResponse(this.auth, response, blob);
        }
        return UserImpl._fromJSON(this.auth, blob);
    }
    removeCurrentUser() {
        return this.persistence._remove(this.fullUserKey);
    }
    savePersistenceForRedirect() {
        return this.persistence._set(this.fullPersistenceKey, this.persistence.type);
    }
    async setPersistence(newPersistence) {
        if (this.persistence === newPersistence) return;
        const currentUser = await this.getCurrentUser();
        await this.removeCurrentUser();
        this.persistence = newPersistence;
        if (currentUser) return this.setCurrentUser(currentUser);
    }
    delete() {
        this.persistence._removeListener(this.fullUserKey, this.boundEventHandler);
    }
    static async create(auth, persistenceHierarchy, userKey = "authUser" /* KeyName.AUTH_USER */ ) {
        if (!persistenceHierarchy.length) return new PersistenceUserManager(_getInstance(inMemoryPersistence), auth, userKey);
        // Eliminate any persistences that are not available
        const availablePersistences = (await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (await persistence._isAvailable()) return persistence;
            return undefined;
        }))).filter((persistence)=>persistence);
        // Fall back to the first persistence listed, or in memory if none available
        let selectedPersistence = availablePersistences[0] || _getInstance(inMemoryPersistence);
        const key = _persistenceKeyName(userKey, auth.config.apiKey, auth.name);
        // Pull out the existing user, setting the chosen persistence to that
        // persistence if the user exists.
        let userToMigrate = null;
        // Note, here we check for a user in _all_ persistences, not just the
        // ones deemed available. If we can migrate a user out of a broken
        // persistence, we will (but only if that persistence supports migration).
        for (const persistence of persistenceHierarchy)try {
            const blob = await persistence._get(key);
            if (blob) {
                let user;
                if (typeof blob === 'string') {
                    const response = await getAccountInfo(auth, {
                        idToken: blob
                    }).catch(()=>undefined);
                    if (!response) break;
                    user = await UserImpl._fromGetAccountInfoResponse(auth, response, blob);
                } else user = UserImpl._fromJSON(auth, blob); // throws for unparsable blob (wrong format)
                if (persistence !== selectedPersistence) userToMigrate = user;
                selectedPersistence = persistence;
                break;
            }
        } catch  {}
        // If we find the user in a persistence that does support migration, use
        // that migration path (of only persistences that support migration)
        const migrationHierarchy = availablePersistences.filter((p)=>p._shouldAllowMigration);
        // If the persistence does _not_ allow migration, just finish off here
        if (!selectedPersistence._shouldAllowMigration || !migrationHierarchy.length) return new PersistenceUserManager(selectedPersistence, auth, userKey);
        selectedPersistence = migrationHierarchy[0];
        if (userToMigrate) // This normally shouldn't throw since chosenPersistence.isAvailable() is true, but if it does
        // we'll just let it bubble to surface the error.
        await selectedPersistence._set(key, userToMigrate.toJSON());
        // Attempt to clear the key in other persistences but ignore errors. This helps prevent issues
        // such as users getting stuck with a previous account after signing out and refreshing the tab.
        await Promise.all(persistenceHierarchy.map(async (persistence)=>{
            if (persistence !== selectedPersistence) try {
                await persistence._remove(key);
            } catch  {}
        }));
        return new PersistenceUserManager(selectedPersistence, auth, userKey);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Determine the browser for the purposes of reporting usage to the API
 */ function _getBrowserName(userAgent) {
    const ua = userAgent.toLowerCase();
    if (ua.includes('opera/') || ua.includes('opr/') || ua.includes('opios/')) return "Opera" /* BrowserName.OPERA */ ;
    else if (_isIEMobile(ua)) // Windows phone IEMobile browser.
    return "IEMobile" /* BrowserName.IEMOBILE */ ;
    else if (ua.includes('msie') || ua.includes('trident/')) return "IE" /* BrowserName.IE */ ;
    else if (ua.includes('edge/')) return "Edge" /* BrowserName.EDGE */ ;
    else if (_isFirefox(ua)) return "Firefox" /* BrowserName.FIREFOX */ ;
    else if (ua.includes('silk/')) return "Silk" /* BrowserName.SILK */ ;
    else if (_isBlackBerry(ua)) // Blackberry browser.
    return "Blackberry" /* BrowserName.BLACKBERRY */ ;
    else if (_isWebOS(ua)) // WebOS default browser.
    return "Webos" /* BrowserName.WEBOS */ ;
    else if (_isSafari(ua)) return "Safari" /* BrowserName.SAFARI */ ;
    else if ((ua.includes('chrome/') || _isChromeIOS(ua)) && !ua.includes('edge/')) return "Chrome" /* BrowserName.CHROME */ ;
    else if (_isAndroid(ua)) // Android stock browser.
    return "Android" /* BrowserName.ANDROID */ ;
    else {
        // Most modern browsers have name/version at end of user agent string.
        const re = /([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/;
        const matches = userAgent.match(re);
        if (matches?.length === 2) return matches[1];
    }
    return "Other" /* BrowserName.OTHER */ ;
}
function _isFirefox(ua = (0, _util.getUA)()) {
    return /firefox\//i.test(ua);
}
function _isSafari(userAgent = (0, _util.getUA)()) {
    const ua = userAgent.toLowerCase();
    return ua.includes('safari/') && !ua.includes('chrome/') && !ua.includes('crios/') && !ua.includes('android');
}
function _isChromeIOS(ua = (0, _util.getUA)()) {
    return /crios\//i.test(ua);
}
function _isIEMobile(ua = (0, _util.getUA)()) {
    return /iemobile/i.test(ua);
}
function _isAndroid(ua = (0, _util.getUA)()) {
    return /android/i.test(ua);
}
function _isBlackBerry(ua = (0, _util.getUA)()) {
    return /blackberry/i.test(ua);
}
function _isWebOS(ua = (0, _util.getUA)()) {
    return /webos/i.test(ua);
}
function _isIOS(ua = (0, _util.getUA)()) {
    return /iphone|ipad|ipod/i.test(ua) || /macintosh/i.test(ua) && /mobile/i.test(ua);
}
function _isIOS7Or8(ua = (0, _util.getUA)()) {
    return /(iPad|iPhone|iPod).*OS 7_\d/i.test(ua) || /(iPad|iPhone|iPod).*OS 8_\d/i.test(ua);
}
function _isIOSStandalone(ua = (0, _util.getUA)()) {
    return _isIOS(ua) && !!window.navigator?.standalone;
}
function _isIE10() {
    return (0, _util.isIE)() && document.documentMode === 10;
}
function _isMobileBrowser(ua = (0, _util.getUA)()) {
    // TODO: implement getBrowserName equivalent for OS.
    return _isIOS(ua) || _isAndroid(ua) || _isWebOS(ua) || _isBlackBerry(ua) || /windows phone/i.test(ua) || _isIEMobile(ua);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * Determine the SDK version string
 */ function _getClientVersion(clientPlatform, frameworks = []) {
    let reportedPlatform;
    switch(clientPlatform){
        case "Browser" /* ClientPlatform.BROWSER */ :
            // In a browser environment, report the browser name.
            reportedPlatform = _getBrowserName((0, _util.getUA)());
            break;
        case "Worker" /* ClientPlatform.WORKER */ :
            // Technically a worker runs from a browser but we need to differentiate a
            // worker from a browser.
            // For example: Chrome-Worker/JsCore/4.9.1/FirebaseCore-web.
            reportedPlatform = `${_getBrowserName((0, _util.getUA)())}-${clientPlatform}`;
            break;
        default:
            reportedPlatform = clientPlatform;
    }
    const reportedFrameworks = frameworks.length ? frameworks.join(',') : 'FirebaseCore-web'; /* default value if no other framework is used */ 
    return `${reportedPlatform}/${"JsCore" /* ClientImplementation.CORE */ }/${0, _app.SDK_VERSION}/${reportedFrameworks}`;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class AuthMiddlewareQueue {
    constructor(auth){
        this.auth = auth;
        this.queue = [];
    }
    pushCallback(callback, onAbort) {
        // The callback could be sync or async. Wrap it into a
        // function that is always async.
        const wrappedCallback = (user)=>new Promise((resolve, reject)=>{
                try {
                    const result = callback(user);
                    // Either resolve with existing promise or wrap a non-promise
                    // return value into a promise.
                    resolve(result);
                } catch (e) {
                    // Sync callback throws.
                    reject(e);
                }
            });
        // Attach the onAbort if present
        wrappedCallback.onAbort = onAbort;
        this.queue.push(wrappedCallback);
        const index = this.queue.length - 1;
        return ()=>{
            // Unsubscribe. Replace with no-op. Do not remove from array, or it will disturb
            // indexing of other elements.
            this.queue[index] = ()=>Promise.resolve();
        };
    }
    async runMiddleware(nextUser) {
        if (this.auth.currentUser === nextUser) return;
        // While running the middleware, build a temporary stack of onAbort
        // callbacks to call if one middleware callback rejects.
        const onAbortStack = [];
        try {
            for (const beforeStateCallback of this.queue){
                await beforeStateCallback(nextUser);
                // Only push the onAbort if the callback succeeds
                if (beforeStateCallback.onAbort) onAbortStack.push(beforeStateCallback.onAbort);
            }
        } catch (e) {
            // Run all onAbort, with separate try/catch to ignore any errors and
            // continue
            onAbortStack.reverse();
            for (const onAbort of onAbortStack)try {
                onAbort();
            } catch (_) {
            /* swallow error */ }
            throw this.auth._errorFactory.create("login-blocked" /* AuthErrorCode.LOGIN_BLOCKED */ , {
                originalMessage: e?.message
            });
        }
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Fetches the password policy for the currently set tenant or the project if no tenant is set.
 *
 * @param auth Auth object.
 * @param request Password policy request.
 * @returns Password policy response.
 */ async function _getPasswordPolicy(auth, request = {}) {
    return _performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v2/passwordPolicy" /* Endpoint.GET_PASSWORD_POLICY */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Minimum min password length enforced by the backend, even if no minimum length is set.
const MINIMUM_MIN_PASSWORD_LENGTH = 6;
/**
 * Stores password policy requirements and provides password validation against the policy.
 *
 * @internal
 */ class PasswordPolicyImpl {
    constructor(response){
        // Only include custom strength options defined in the response.
        const responseOptions = response.customStrengthOptions;
        this.customStrengthOptions = {};
        // TODO: Remove once the backend is updated to include the minimum min password length instead of undefined when there is no minimum length set.
        this.customStrengthOptions.minPasswordLength = responseOptions.minPasswordLength ?? MINIMUM_MIN_PASSWORD_LENGTH;
        if (responseOptions.maxPasswordLength) this.customStrengthOptions.maxPasswordLength = responseOptions.maxPasswordLength;
        if (responseOptions.containsLowercaseCharacter !== undefined) this.customStrengthOptions.containsLowercaseLetter = responseOptions.containsLowercaseCharacter;
        if (responseOptions.containsUppercaseCharacter !== undefined) this.customStrengthOptions.containsUppercaseLetter = responseOptions.containsUppercaseCharacter;
        if (responseOptions.containsNumericCharacter !== undefined) this.customStrengthOptions.containsNumericCharacter = responseOptions.containsNumericCharacter;
        if (responseOptions.containsNonAlphanumericCharacter !== undefined) this.customStrengthOptions.containsNonAlphanumericCharacter = responseOptions.containsNonAlphanumericCharacter;
        this.enforcementState = response.enforcementState;
        if (this.enforcementState === 'ENFORCEMENT_STATE_UNSPECIFIED') this.enforcementState = 'OFF';
        // Use an empty string if no non-alphanumeric characters are specified in the response.
        this.allowedNonAlphanumericCharacters = response.allowedNonAlphanumericCharacters?.join('') ?? '';
        this.forceUpgradeOnSignin = response.forceUpgradeOnSignin ?? false;
        this.schemaVersion = response.schemaVersion;
    }
    validatePassword(password) {
        const status = {
            isValid: true,
            passwordPolicy: this
        };
        // Check the password length and character options.
        this.validatePasswordLengthOptions(password, status);
        this.validatePasswordCharacterOptions(password, status);
        // Combine the status into single isValid property.
        status.isValid && (status.isValid = status.meetsMinPasswordLength ?? true);
        status.isValid && (status.isValid = status.meetsMaxPasswordLength ?? true);
        status.isValid && (status.isValid = status.containsLowercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsUppercaseLetter ?? true);
        status.isValid && (status.isValid = status.containsNumericCharacter ?? true);
        status.isValid && (status.isValid = status.containsNonAlphanumericCharacter ?? true);
        return status;
    }
    /**
     * Validates that the password meets the length options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordLengthOptions(password, status) {
        const minPasswordLength = this.customStrengthOptions.minPasswordLength;
        const maxPasswordLength = this.customStrengthOptions.maxPasswordLength;
        if (minPasswordLength) status.meetsMinPasswordLength = password.length >= minPasswordLength;
        if (maxPasswordLength) status.meetsMaxPasswordLength = password.length <= maxPasswordLength;
    }
    /**
     * Validates that the password meets the character options for the policy.
     *
     * @param password Password to validate.
     * @param status Validation status.
     */ validatePasswordCharacterOptions(password, status) {
        // Assign statuses for requirements even if the password is an empty string.
        this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ false, /* containsUppercaseCharacter= */ false, /* containsNumericCharacter= */ false, /* containsNonAlphanumericCharacter= */ false);
        let passwordChar;
        for(let i = 0; i < password.length; i++){
            passwordChar = password.charAt(i);
            this.updatePasswordCharacterOptionsStatuses(status, /* containsLowercaseCharacter= */ passwordChar >= 'a' && passwordChar <= 'z', /* containsUppercaseCharacter= */ passwordChar >= 'A' && passwordChar <= 'Z', /* containsNumericCharacter= */ passwordChar >= '0' && passwordChar <= '9', /* containsNonAlphanumericCharacter= */ this.allowedNonAlphanumericCharacters.includes(passwordChar));
        }
    }
    /**
     * Updates the running validation status with the statuses for the character options.
     * Expected to be called each time a character is processed to update each option status
     * based on the current character.
     *
     * @param status Validation status.
     * @param containsLowercaseCharacter Whether the character is a lowercase letter.
     * @param containsUppercaseCharacter Whether the character is an uppercase letter.
     * @param containsNumericCharacter Whether the character is a numeric character.
     * @param containsNonAlphanumericCharacter Whether the character is a non-alphanumeric character.
     */ updatePasswordCharacterOptionsStatuses(status, containsLowercaseCharacter, containsUppercaseCharacter, containsNumericCharacter, containsNonAlphanumericCharacter) {
        if (this.customStrengthOptions.containsLowercaseLetter) status.containsLowercaseLetter || (status.containsLowercaseLetter = containsLowercaseCharacter);
        if (this.customStrengthOptions.containsUppercaseLetter) status.containsUppercaseLetter || (status.containsUppercaseLetter = containsUppercaseCharacter);
        if (this.customStrengthOptions.containsNumericCharacter) status.containsNumericCharacter || (status.containsNumericCharacter = containsNumericCharacter);
        if (this.customStrengthOptions.containsNonAlphanumericCharacter) status.containsNonAlphanumericCharacter || (status.containsNonAlphanumericCharacter = containsNonAlphanumericCharacter);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class AuthImpl {
    constructor(app, heartbeatServiceProvider, appCheckServiceProvider, config){
        this.app = app;
        this.heartbeatServiceProvider = heartbeatServiceProvider;
        this.appCheckServiceProvider = appCheckServiceProvider;
        this.config = config;
        this.currentUser = null;
        this.emulatorConfig = null;
        this.operations = Promise.resolve();
        this.authStateSubscription = new Subscription(this);
        this.idTokenSubscription = new Subscription(this);
        this.beforeStateQueue = new AuthMiddlewareQueue(this);
        this.redirectUser = null;
        this.isProactiveRefreshEnabled = false;
        this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION = 1;
        // Any network calls will set this to true and prevent subsequent emulator
        // initialization
        this._canInitEmulator = true;
        this._isInitialized = false;
        this._deleted = false;
        this._initializationPromise = null;
        this._popupRedirectResolver = null;
        this._errorFactory = _DEFAULT_AUTH_ERROR_FACTORY;
        this._agentRecaptchaConfig = null;
        this._tenantRecaptchaConfigs = {};
        this._projectPasswordPolicy = null;
        this._tenantPasswordPolicies = {};
        this._resolvePersistenceManagerAvailable = undefined;
        // Tracks the last notified UID for state change listeners to prevent
        // repeated calls to the callbacks. Undefined means it's never been
        // called, whereas null means it's been called with a signed out user
        this.lastNotifiedUid = undefined;
        this.languageCode = null;
        this.tenantId = null;
        this.settings = {
            appVerificationDisabledForTesting: false
        };
        this.frameworks = [];
        this.name = app.name;
        this.clientVersion = config.sdkClientVersion;
        // TODO(jamesdaniels) explore less hacky way to do this, cookie authentication needs
        // persistenceMananger to be available. see _getFinalTarget for more context
        this._persistenceManagerAvailable = new Promise((resolve)=>this._resolvePersistenceManagerAvailable = resolve);
    }
    _initializeWithPersistence(persistenceHierarchy, popupRedirectResolver) {
        if (popupRedirectResolver) this._popupRedirectResolver = _getInstance(popupRedirectResolver);
        // Have to check for app deletion throughout initialization (after each
        // promise resolution)
        this._initializationPromise = this.queue(async ()=>{
            if (this._deleted) return;
            this.persistenceManager = await PersistenceUserManager.create(this, persistenceHierarchy);
            this._resolvePersistenceManagerAvailable?.();
            if (this._deleted) return;
            // Initialize the resolver early if necessary (only applicable to web:
            // this will cause the iframe to load immediately in certain cases)
            if (this._popupRedirectResolver?._shouldInitProactively) // If this fails, don't halt auth loading
            try {
                await this._popupRedirectResolver._initialize(this);
            } catch (e) {
            /* Ignore the error */ }
            await this.initializeCurrentUser(popupRedirectResolver);
            this.lastNotifiedUid = this.currentUser?.uid || null;
            if (this._deleted) return;
            this._isInitialized = true;
        });
        return this._initializationPromise;
    }
    /**
     * If the persistence is changed in another window, the user manager will let us know
     */ async _onStorageEvent() {
        if (this._deleted) return;
        const user = await this.assertedPersistence.getCurrentUser();
        if (!this.currentUser && !user) // No change, do nothing (was signed out and remained signed out).
        return;
        // If the same user is to be synchronized.
        if (this.currentUser && user && this.currentUser.uid === user.uid) {
            // Data update, simply copy data changes.
            this._currentUser._assign(user);
            // If tokens changed from previous user tokens, this will trigger
            // notifyAuthListeners_.
            await this.currentUser.getIdToken();
            return;
        }
        // Update current Auth state. Either a new login or logout.
        // Skip blocking callbacks, they should not apply to a change in another tab.
        await this._updateCurrentUser(user, /* skipBeforeStateCallbacks */ true);
    }
    async initializeCurrentUserFromIdToken(idToken) {
        try {
            const response = await getAccountInfo(this, {
                idToken
            });
            const user = await UserImpl._fromGetAccountInfoResponse(this, response, idToken);
            await this.directlySetCurrentUser(user);
        } catch (err) {
            console.warn('FirebaseServerApp could not login user with provided authIdToken: ', err);
            await this.directlySetCurrentUser(null);
        }
    }
    async initializeCurrentUser(popupRedirectResolver) {
        if ((0, _app._isFirebaseServerApp)(this.app)) {
            const idToken = this.app.settings.authIdToken;
            if (idToken) // Start the auth operation in the next tick to allow a moment for the customer's app to
            // attach an emulator, if desired.
            return new Promise((resolve)=>{
                setTimeout(()=>this.initializeCurrentUserFromIdToken(idToken).then(resolve, resolve));
            });
            else return this.directlySetCurrentUser(null);
        }
        // First check to see if we have a pending redirect event.
        const previouslyStoredUser = await this.assertedPersistence.getCurrentUser();
        let futureCurrentUser = previouslyStoredUser;
        let needsTocheckMiddleware = false;
        if (popupRedirectResolver && this.config.authDomain) {
            await this.getOrInitRedirectPersistenceManager();
            const redirectUserEventId = this.redirectUser?._redirectEventId;
            const storedUserEventId = futureCurrentUser?._redirectEventId;
            const result = await this.tryRedirectSignIn(popupRedirectResolver);
            // If the stored user (i.e. the old "currentUser") has a redirectId that
            // matches the redirect user, then we want to initially sign in with the
            // new user object from result.
            // TODO(samgho): More thoroughly test all of this
            if ((!redirectUserEventId || redirectUserEventId === storedUserEventId) && result?.user) {
                futureCurrentUser = result.user;
                needsTocheckMiddleware = true;
            }
        }
        // If no user in persistence, there is no current user. Set to null.
        if (!futureCurrentUser) return this.directlySetCurrentUser(null);
        if (!futureCurrentUser._redirectEventId) {
            // This isn't a redirect link operation, we can reload and bail.
            // First though, ensure that we check the middleware is happy.
            if (needsTocheckMiddleware) try {
                await this.beforeStateQueue.runMiddleware(futureCurrentUser);
            } catch (e) {
                futureCurrentUser = previouslyStoredUser;
                // We know this is available since the bit is only set when the
                // resolver is available
                this._popupRedirectResolver._overrideRedirectResult(this, ()=>Promise.reject(e));
            }
            if (futureCurrentUser) return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
            else return this.directlySetCurrentUser(null);
        }
        _assert(this._popupRedirectResolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        await this.getOrInitRedirectPersistenceManager();
        // If the redirect user's event ID matches the current user's event ID,
        // DO NOT reload the current user, otherwise they'll be cleared from storage.
        // This is important for the reauthenticateWithRedirect() flow.
        if (this.redirectUser && this.redirectUser._redirectEventId === futureCurrentUser._redirectEventId) return this.directlySetCurrentUser(futureCurrentUser);
        return this.reloadAndSetCurrentUserOrClear(futureCurrentUser);
    }
    async tryRedirectSignIn(redirectResolver) {
        // The redirect user needs to be checked (and signed in if available)
        // during auth initialization. All of the normal sign in and link/reauth
        // flows call back into auth and push things onto the promise queue. We
        // need to await the result of the redirect sign in *inside the promise
        // queue*. This presents a problem: we run into deadlock. See:
        //    ┌> [Initialization] ─────┐
        //    ┌> [<other queue tasks>] │
        //    └─ [getRedirectResult] <─┘
        //    where [] are tasks on the queue and arrows denote awaits
        // Initialization will never complete because it's waiting on something
        // that's waiting for initialization to complete!
        //
        // Instead, this method calls getRedirectResult() (stored in
        // _completeRedirectFn) with an optional parameter that instructs all of
        // the underlying auth operations to skip anything that mutates auth state.
        let result = null;
        try {
            // We know this._popupRedirectResolver is set since redirectResolver
            // is passed in. The _completeRedirectFn expects the unwrapped extern.
            result = await this._popupRedirectResolver._completeRedirectFn(this, redirectResolver, true);
        } catch (e) {
            // Swallow any errors here; the code can retrieve them in
            // getRedirectResult().
            await this._setRedirectUser(null);
        }
        return result;
    }
    async reloadAndSetCurrentUserOrClear(user) {
        try {
            await _reloadWithoutSaving(user);
        } catch (e) {
            if (e?.code !== `auth/${"network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ }`) // Something's wrong with the user's token. Log them out and remove
            // them from storage
            return this.directlySetCurrentUser(null);
        }
        return this.directlySetCurrentUser(user);
    }
    useDeviceLanguage() {
        this.languageCode = _getUserLanguage();
    }
    async _delete() {
        this._deleted = true;
    }
    async updateCurrentUser(userExtern) {
        if ((0, _app._isFirebaseServerApp)(this.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this));
        // The public updateCurrentUser method needs to make a copy of the user,
        // and also check that the project matches
        const user = userExtern ? (0, _util.getModularInstance)(userExtern) : null;
        if (user) _assert(user.auth.config.apiKey === this.config.apiKey, this, "invalid-user-token" /* AuthErrorCode.INVALID_AUTH */ );
        return this._updateCurrentUser(user && user._clone(this));
    }
    async _updateCurrentUser(user, skipBeforeStateCallbacks = false) {
        if (this._deleted) return;
        if (user) _assert(this.tenantId === user.tenantId, this, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
        if (!skipBeforeStateCallbacks) await this.beforeStateQueue.runMiddleware(user);
        return this.queue(async ()=>{
            await this.directlySetCurrentUser(user);
            this.notifyAuthListeners();
        });
    }
    async signOut() {
        if ((0, _app._isFirebaseServerApp)(this.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this));
        // Run first, to block _setRedirectUser() if any callbacks fail.
        await this.beforeStateQueue.runMiddleware(null);
        // Clear the redirect user when signOut is called
        if (this.redirectPersistenceManager || this._popupRedirectResolver) await this._setRedirectUser(null);
        // Prevent callbacks from being called again in _updateCurrentUser, as
        // they were already called in the first line.
        return this._updateCurrentUser(null, /* skipBeforeStateCallbacks */ true);
    }
    setPersistence(persistence) {
        if ((0, _app._isFirebaseServerApp)(this.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(this));
        return this.queue(async ()=>{
            await this.assertedPersistence.setPersistence(_getInstance(persistence));
        });
    }
    _getRecaptchaConfig() {
        if (this.tenantId == null) return this._agentRecaptchaConfig;
        else return this._tenantRecaptchaConfigs[this.tenantId];
    }
    async validatePassword(password) {
        if (!this._getPasswordPolicyInternal()) await this._updatePasswordPolicy();
        // Password policy will be defined after fetching.
        const passwordPolicy = this._getPasswordPolicyInternal();
        // Check that the policy schema version is supported by the SDK.
        // TODO: Update this logic to use a max supported policy schema version once we have multiple schema versions.
        if (passwordPolicy.schemaVersion !== this.EXPECTED_PASSWORD_POLICY_SCHEMA_VERSION) return Promise.reject(this._errorFactory.create("unsupported-password-policy-schema-version" /* AuthErrorCode.UNSUPPORTED_PASSWORD_POLICY_SCHEMA_VERSION */ , {}));
        return passwordPolicy.validatePassword(password);
    }
    _getPasswordPolicyInternal() {
        if (this.tenantId === null) return this._projectPasswordPolicy;
        else return this._tenantPasswordPolicies[this.tenantId];
    }
    async _updatePasswordPolicy() {
        const response = await _getPasswordPolicy(this);
        const passwordPolicy = new PasswordPolicyImpl(response);
        if (this.tenantId === null) this._projectPasswordPolicy = passwordPolicy;
        else this._tenantPasswordPolicies[this.tenantId] = passwordPolicy;
    }
    _getPersistenceType() {
        return this.assertedPersistence.persistence.type;
    }
    _getPersistence() {
        return this.assertedPersistence.persistence;
    }
    _updateErrorMap(errorMap) {
        this._errorFactory = new (0, _util.ErrorFactory)('auth', 'Firebase', errorMap());
    }
    onAuthStateChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.authStateSubscription, nextOrObserver, error, completed);
    }
    beforeAuthStateChanged(callback, onAbort) {
        return this.beforeStateQueue.pushCallback(callback, onAbort);
    }
    onIdTokenChanged(nextOrObserver, error, completed) {
        return this.registerStateListener(this.idTokenSubscription, nextOrObserver, error, completed);
    }
    authStateReady() {
        return new Promise((resolve, reject)=>{
            if (this.currentUser) resolve();
            else {
                const unsubscribe = this.onAuthStateChanged(()=>{
                    unsubscribe();
                    resolve();
                }, reject);
            }
        });
    }
    /**
     * Revokes the given access token. Currently only supports Apple OAuth access tokens.
     */ async revokeAccessToken(token) {
        if (this.currentUser) {
            const idToken = await this.currentUser.getIdToken();
            // Generalize this to accept other providers once supported.
            const request = {
                providerId: 'apple.com',
                tokenType: "ACCESS_TOKEN" /* TokenType.ACCESS_TOKEN */ ,
                token,
                idToken
            };
            if (this.tenantId != null) request.tenantId = this.tenantId;
            await revokeToken(this, request);
        }
    }
    toJSON() {
        return {
            apiKey: this.config.apiKey,
            authDomain: this.config.authDomain,
            appName: this.name,
            currentUser: this._currentUser?.toJSON()
        };
    }
    async _setRedirectUser(user, popupRedirectResolver) {
        const redirectManager = await this.getOrInitRedirectPersistenceManager(popupRedirectResolver);
        return user === null ? redirectManager.removeCurrentUser() : redirectManager.setCurrentUser(user);
    }
    async getOrInitRedirectPersistenceManager(popupRedirectResolver) {
        if (!this.redirectPersistenceManager) {
            const resolver = popupRedirectResolver && _getInstance(popupRedirectResolver) || this._popupRedirectResolver;
            _assert(resolver, this, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
            this.redirectPersistenceManager = await PersistenceUserManager.create(this, [
                _getInstance(resolver._redirectPersistence)
            ], "redirectUser" /* KeyName.REDIRECT_USER */ );
            this.redirectUser = await this.redirectPersistenceManager.getCurrentUser();
        }
        return this.redirectPersistenceManager;
    }
    async _redirectUserForId(id) {
        // Make sure we've cleared any pending persistence actions if we're not in
        // the initializer
        if (this._isInitialized) await this.queue(async ()=>{});
        if (this._currentUser?._redirectEventId === id) return this._currentUser;
        if (this.redirectUser?._redirectEventId === id) return this.redirectUser;
        return null;
    }
    async _persistUserIfCurrent(user) {
        if (user === this.currentUser) return this.queue(async ()=>this.directlySetCurrentUser(user));
    }
    /** Notifies listeners only if the user is current */ _notifyListenersIfCurrent(user) {
        if (user === this.currentUser) this.notifyAuthListeners();
    }
    _key() {
        return `${this.config.authDomain}:${this.config.apiKey}:${this.name}`;
    }
    _startProactiveRefresh() {
        this.isProactiveRefreshEnabled = true;
        if (this.currentUser) this._currentUser._startProactiveRefresh();
    }
    _stopProactiveRefresh() {
        this.isProactiveRefreshEnabled = false;
        if (this.currentUser) this._currentUser._stopProactiveRefresh();
    }
    /** Returns the current user cast as the internal type */ get _currentUser() {
        return this.currentUser;
    }
    notifyAuthListeners() {
        if (!this._isInitialized) return;
        this.idTokenSubscription.next(this.currentUser);
        const currentUid = this.currentUser?.uid ?? null;
        if (this.lastNotifiedUid !== currentUid) {
            this.lastNotifiedUid = currentUid;
            this.authStateSubscription.next(this.currentUser);
        }
    }
    registerStateListener(subscription, nextOrObserver, error, completed) {
        if (this._deleted) return ()=>{};
        const cb = typeof nextOrObserver === 'function' ? nextOrObserver : nextOrObserver.next.bind(nextOrObserver);
        let isUnsubscribed = false;
        const promise = this._isInitialized ? Promise.resolve() : this._initializationPromise;
        _assert(promise, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // The callback needs to be called asynchronously per the spec.
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        promise.then(()=>{
            if (isUnsubscribed) return;
            cb(this.currentUser);
        });
        if (typeof nextOrObserver === 'function') {
            const unsubscribe = subscription.addObserver(nextOrObserver, error, completed);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        } else {
            const unsubscribe = subscription.addObserver(nextOrObserver);
            return ()=>{
                isUnsubscribed = true;
                unsubscribe();
            };
        }
    }
    /**
     * Unprotected (from race conditions) method to set the current user. This
     * should only be called from within a queued callback. This is necessary
     * because the queue shouldn't rely on another queued callback.
     */ async directlySetCurrentUser(user) {
        if (this.currentUser && this.currentUser !== user) this._currentUser._stopProactiveRefresh();
        if (user && this.isProactiveRefreshEnabled) user._startProactiveRefresh();
        this.currentUser = user;
        if (user) await this.assertedPersistence.setCurrentUser(user);
        else await this.assertedPersistence.removeCurrentUser();
    }
    queue(action) {
        // In case something errors, the callback still should be called in order
        // to keep the promise chain alive
        this.operations = this.operations.then(action, action);
        return this.operations;
    }
    get assertedPersistence() {
        _assert(this.persistenceManager, this, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.persistenceManager;
    }
    _logFramework(framework) {
        if (!framework || this.frameworks.includes(framework)) return;
        this.frameworks.push(framework);
        // Sort alphabetically so that "FirebaseCore-web,FirebaseUI-web" and
        // "FirebaseUI-web,FirebaseCore-web" aren't viewed as different.
        this.frameworks.sort();
        this.clientVersion = _getClientVersion(this.config.clientPlatform, this._getFrameworks());
    }
    _getFrameworks() {
        return this.frameworks;
    }
    async _getAdditionalHeaders() {
        // Additional headers on every request
        const headers = {
            ["X-Client-Version" /* HttpHeader.X_CLIENT_VERSION */ ]: this.clientVersion
        };
        if (this.app.options.appId) headers["X-Firebase-gmpid" /* HttpHeader.X_FIREBASE_GMPID */ ] = this.app.options.appId;
        // If the heartbeat service exists, add the heartbeat string
        const heartbeatsHeader = await this.heartbeatServiceProvider.getImmediate({
            optional: true
        })?.getHeartbeatsHeader();
        if (heartbeatsHeader) headers["X-Firebase-Client" /* HttpHeader.X_FIREBASE_CLIENT */ ] = heartbeatsHeader;
        // If the App Check service exists, add the App Check token in the headers
        const appCheckToken = await this._getAppCheckToken();
        if (appCheckToken) headers["X-Firebase-AppCheck" /* HttpHeader.X_FIREBASE_APP_CHECK */ ] = appCheckToken;
        return headers;
    }
    async _getAppCheckToken() {
        if ((0, _app._isFirebaseServerApp)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheckTokenResult = await this.appCheckServiceProvider.getImmediate({
            optional: true
        })?.getToken();
        if (appCheckTokenResult?.error) // Context: appCheck.getToken() will never throw even if an error happened.
        // In the error case, a dummy token will be returned along with an error field describing
        // the error. In general, we shouldn't care about the error condition and just use
        // the token (actual or dummy) to send requests.
        _logWarn(`Error while retrieving App Check token: ${appCheckTokenResult.error}`);
        return appCheckTokenResult?.token;
    }
}
/**
 * Method to be used to cast down to our private implementation of Auth.
 * It will also handle unwrapping from the compat type if necessary
 *
 * @param auth Auth object passed in from developer
 */ function _castAuth(auth) {
    return (0, _util.getModularInstance)(auth);
}
/** Helper class to wrap subscriber logic */ class Subscription {
    constructor(auth){
        this.auth = auth;
        this.observer = null;
        this.addObserver = (0, _util.createSubscribe)((observer)=>this.observer = observer);
    }
    get next() {
        _assert(this.observer, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.observer.next.bind(this.observer);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let externalJSProvider = {
    async loadJS () {
        throw new Error('Unable to load external scripts');
    },
    recaptchaV2Script: '',
    recaptchaEnterpriseScript: '',
    gapiScript: ''
};
function _setExternalJSProvider(p) {
    externalJSProvider = p;
}
function _loadJS(url) {
    return externalJSProvider.loadJS(url);
}
function _recaptchaV2ScriptUrl() {
    return externalJSProvider.recaptchaV2Script;
}
function _recaptchaEnterpriseScriptUrl() {
    return externalJSProvider.recaptchaEnterpriseScript;
}
function _gapiScriptUrl() {
    return externalJSProvider.gapiScript;
}
function _generateCallbackName(prefix) {
    return `__${prefix}${Math.floor(Math.random() * 1000000)}`;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const _SOLVE_TIME_MS = 500;
const _EXPIRATION_TIME_MS = 60000;
const _WIDGET_ID_START = 1000000000000;
class MockReCaptcha {
    constructor(auth){
        this.auth = auth;
        this.counter = _WIDGET_ID_START;
        this._widgets = new Map();
    }
    render(container, parameters) {
        const id = this.counter;
        this._widgets.set(id, new MockWidget(container, this.auth.name, parameters || {}));
        this.counter++;
        return id;
    }
    reset(optWidgetId) {
        const id = optWidgetId || _WIDGET_ID_START;
        this._widgets.get(id)?.delete();
        this._widgets.delete(id);
    }
    getResponse(optWidgetId) {
        const id = optWidgetId || _WIDGET_ID_START;
        return this._widgets.get(id)?.getResponse() || '';
    }
    async execute(optWidgetId) {
        const id = optWidgetId || _WIDGET_ID_START;
        this._widgets.get(id)?.execute();
        return '';
    }
}
class MockGreCAPTCHATopLevel {
    constructor(){
        this.enterprise = new MockGreCAPTCHA();
    }
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class MockGreCAPTCHA {
    ready(callback) {
        callback();
    }
    execute(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _siteKey, _options) {
        return Promise.resolve('token');
    }
    render(// eslint-disable-next-line @typescript-eslint/no-unused-vars
    _container, _parameters) {
        return '';
    }
}
class MockWidget {
    constructor(containerOrId, appName, params){
        this.params = params;
        this.timerId = null;
        this.deleted = false;
        this.responseToken = null;
        this.clickHandler = ()=>{
            this.execute();
        };
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        _assert(container, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ , {
            appName
        });
        this.container = container;
        this.isVisible = this.params.size !== 'invisible';
        if (this.isVisible) this.execute();
        else this.container.addEventListener('click', this.clickHandler);
    }
    getResponse() {
        this.checkIfDeleted();
        return this.responseToken;
    }
    delete() {
        this.checkIfDeleted();
        this.deleted = true;
        if (this.timerId) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.container.removeEventListener('click', this.clickHandler);
    }
    execute() {
        this.checkIfDeleted();
        if (this.timerId) return;
        this.timerId = window.setTimeout(()=>{
            this.responseToken = generateRandomAlphaNumericString(50);
            const { callback, 'expired-callback': expiredCallback } = this.params;
            if (callback) try {
                callback(this.responseToken);
            } catch (e) {}
            this.timerId = window.setTimeout(()=>{
                this.timerId = null;
                this.responseToken = null;
                if (expiredCallback) try {
                    expiredCallback();
                } catch (e) {}
                if (this.isVisible) this.execute();
            }, _EXPIRATION_TIME_MS);
        }, _SOLVE_TIME_MS);
    }
    checkIfDeleted() {
        if (this.deleted) throw new Error('reCAPTCHA mock was already deleted!');
    }
}
function generateRandomAlphaNumericString(len) {
    const chars = [];
    const allowedChars = '1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    for(let i = 0; i < len; i++)chars.push(allowedChars.charAt(Math.floor(Math.random() * allowedChars.length)));
    return chars.join('');
}
/* eslint-disable @typescript-eslint/no-require-imports */ const RECAPTCHA_ENTERPRISE_VERIFIER_TYPE = 'recaptcha-enterprise';
const FAKE_TOKEN = 'NO_RECAPTCHA';
const RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME = 'onFirebaseAuthREInstanceReady';
class RecaptchaEnterpriseVerifier {
    /**
     *
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     */ constructor(authExtern){
        /**
         * Identifies the type of application verifier (e.g. "recaptcha-enterprise").
         */ this.type = RECAPTCHA_ENTERPRISE_VERIFIER_TYPE;
        this.auth = _castAuth(authExtern);
    }
    /**
     * Executes the verification process.
     *
     * @returns A Promise for a token that can be used to assert the validity of a request.
     */ async verify(action = 'verify', forceRefresh = false) {
        async function retrieveSiteKey(auth) {
            if (!forceRefresh) {
                if (auth.tenantId == null && auth._agentRecaptchaConfig != null) return auth._agentRecaptchaConfig.siteKey;
                if (auth.tenantId != null && auth._tenantRecaptchaConfigs[auth.tenantId] !== undefined) return auth._tenantRecaptchaConfigs[auth.tenantId].siteKey;
            }
            return new Promise(async (resolve, reject)=>{
                getRecaptchaConfig(auth, {
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }).then((response)=>{
                    if (response.recaptchaKey === undefined) reject(new Error('recaptcha Enterprise site key undefined'));
                    else {
                        const config = new RecaptchaConfig(response);
                        if (auth.tenantId == null) auth._agentRecaptchaConfig = config;
                        else auth._tenantRecaptchaConfigs[auth.tenantId] = config;
                        return resolve(config.siteKey);
                    }
                }).catch((error)=>{
                    reject(error);
                });
            });
        }
        function retrieveRecaptchaToken(siteKey, resolve, reject) {
            const grecaptcha = window.grecaptcha;
            if (isEnterprise(grecaptcha)) grecaptcha.enterprise.ready(()=>{
                grecaptcha.enterprise.execute(siteKey, {
                    action
                }).then((token)=>{
                    resolve(token);
                }).catch(()=>{
                    resolve(FAKE_TOKEN);
                });
            });
            else reject(Error('No reCAPTCHA enterprise script loaded.'));
        }
        // Returns Promise for a mock token when appVerificationDisabledForTesting is true.
        if (this.auth.settings.appVerificationDisabledForTesting) {
            const mockRecaptcha = new MockGreCAPTCHATopLevel();
            return mockRecaptcha.execute('siteKey', {
                action: 'verify'
            });
        }
        return new Promise((resolve, reject)=>{
            retrieveSiteKey(this.auth).then(async (siteKey)=>{
                if (!forceRefresh && isEnterprise(window.grecaptcha) && // If download has already been initiated, do not trigger another
                // download, await the promise here.
                RecaptchaEnterpriseVerifier.scriptInjectionDeferred) {
                    await RecaptchaEnterpriseVerifier.scriptInjectionDeferred.promise;
                    retrieveRecaptchaToken(siteKey, resolve, reject);
                } else {
                    if (typeof window === 'undefined') {
                        reject(new Error('RecaptchaVerifier is only supported in browser'));
                        return;
                    }
                    let url = _recaptchaEnterpriseScriptUrl();
                    if (url.length !== 0) url += siteKey + `&onload=${RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME}`;
                    // Existence of deferred indicates download has been initiated.
                    RecaptchaEnterpriseVerifier.scriptInjectionDeferred = new (0, _util.Deferred)();
                    /**
                     * Script attached to global window object that will be called
                     * when the ReCAPTCHA Enterprise instance is ready.
                     * grecaptcha.ready() is not reliable when there are multiple
                     * scripts on the page, and script.onload only indicates the
                     * script has downloaded, not that it has initialized.
                     */ window[RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME] = ()=>{
                        RecaptchaEnterpriseVerifier.scriptInjectionDeferred?.resolve();
                    };
                    _loadJS(url).then(()=>RecaptchaEnterpriseVerifier.scriptInjectionDeferred?.promise).then(()=>{
                        retrieveRecaptchaToken(siteKey, resolve, reject);
                    }).catch((error)=>{
                        reject(error);
                    });
                }
            }).catch((error)=>{
                reject(error);
            });
        });
    }
}
/**
 * Deferred that resolves when script tag has been injected onto the page
 * and the script is ready (grecaptcha.ready() and script.onload are not
 * reliable indicators, so this resolves when the global
 * `window[RECAPTCHA_ENTERPRISE_ONLOAD_CALLBACK_NAME]()` callback provided to the recaptcha url param "onload"
 * is triggered).
 * As a static variable this is applied to all instances of the class.
 * This will cause an error if users try to create multiple RecaptchaVerifiers
 * with different Recaptcha Enterprise sitekeys, which should be an
 * unuspported use case.
 */ RecaptchaEnterpriseVerifier.scriptInjectionDeferred = null;
async function injectRecaptchaFields(auth, request, action, isCaptchaResp = false, isFakeToken = false) {
    const verifier = new RecaptchaEnterpriseVerifier(auth);
    let captchaResponse;
    if (isFakeToken) captchaResponse = FAKE_TOKEN;
    else try {
        captchaResponse = await verifier.verify(action);
    } catch (error) {
        captchaResponse = await verifier.verify(action, true);
    }
    const newRequest = {
        ...request
    };
    if (action === "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */  || action === "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ ) {
        if ('phoneEnrollmentInfo' in newRequest) {
            const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
            const recaptchaToken = newRequest.phoneEnrollmentInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneEnrollmentInfo': {
                    phoneNumber,
                    recaptchaToken,
                    captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        } else if ('phoneSignInInfo' in newRequest) {
            const recaptchaToken = newRequest.phoneSignInInfo.recaptchaToken;
            Object.assign(newRequest, {
                'phoneSignInInfo': {
                    recaptchaToken,
                    captchaResponse,
                    'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
                    'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
                }
            });
        }
        return newRequest;
    }
    if (!isCaptchaResp) Object.assign(newRequest, {
        captchaResponse
    });
    else Object.assign(newRequest, {
        'captchaResp': captchaResponse
    });
    Object.assign(newRequest, {
        'clientType': "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    });
    Object.assign(newRequest, {
        'recaptchaVersion': "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    return newRequest;
}
async function handleRecaptchaFlow(authInstance, request, actionName, actionMethod, recaptchaAuthProvider) {
    if (recaptchaAuthProvider === "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ )) {
            const requestWithRecaptcha = await injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
            return actionMethod(authInstance, requestWithRecaptcha);
        } else return actionMethod(authInstance, request).catch(async (error)=>{
            if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }`) {
                console.log(`${actionName} is protected by reCAPTCHA Enterprise for this project. Automatically triggering the reCAPTCHA flow and restarting the flow.`);
                const requestWithRecaptcha = await injectRecaptchaFields(authInstance, request, actionName, actionName === "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ );
                return actionMethod(authInstance, requestWithRecaptcha);
            } else return Promise.reject(error);
        });
    } else if (recaptchaAuthProvider === "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) {
        if (authInstance._getRecaptchaConfig()?.isProviderEnabled("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ )) {
            const requestWithRecaptcha = await injectRecaptchaFields(authInstance, request, actionName);
            return actionMethod(authInstance, requestWithRecaptcha).catch(async (error)=>{
                if (authInstance._getRecaptchaConfig()?.getProviderEnforcementState("PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ ) === "AUDIT" /* EnforcementState.AUDIT */ ) // AUDIT mode
                {
                    if (error.code === `auth/${"missing-recaptcha-token" /* AuthErrorCode.MISSING_RECAPTCHA_TOKEN */ }` || error.code === `auth/${"invalid-app-credential" /* AuthErrorCode.INVALID_APP_CREDENTIAL */ }`) {
                        console.log(`Failed to verify with reCAPTCHA Enterprise. Automatically triggering the reCAPTCHA v2 flow to complete the ${actionName} flow.`);
                        // reCAPTCHA Enterprise token is missing or reCAPTCHA Enterprise token
                        // check fails.
                        // Fallback to reCAPTCHA v2 flow.
                        const requestWithRecaptchaFields = await injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
                        );
                        // This will call the PhoneApiCaller to fetch and inject reCAPTCHA v2 token.
                        return actionMethod(authInstance, requestWithRecaptchaFields);
                    }
                }
                // ENFORCE mode or AUDIT mode with any other error.
                return Promise.reject(error);
            });
        } else {
            // Do reCAPTCHA v2 flow.
            const requestWithRecaptchaFields = await injectRecaptchaFields(authInstance, request, actionName, false, true // isFakeToken
            );
            // This will call the PhoneApiCaller to fetch and inject v2 token.
            return actionMethod(authInstance, requestWithRecaptchaFields);
        }
    } else return Promise.reject(recaptchaAuthProvider + ' provider is not supported.');
}
async function _initializeRecaptchaConfig(auth) {
    const authInternal = _castAuth(auth);
    const response = await getRecaptchaConfig(authInternal, {
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ ,
        version: "RECAPTCHA_ENTERPRISE" /* RecaptchaVersion.ENTERPRISE */ 
    });
    const config = new RecaptchaConfig(response);
    if (authInternal.tenantId == null) authInternal._agentRecaptchaConfig = config;
    else authInternal._tenantRecaptchaConfigs[authInternal.tenantId] = config;
    if (config.isAnyProviderEnabled()) {
        const verifier = new RecaptchaEnterpriseVerifier(authInternal);
        verifier.verify();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Initializes an {@link Auth} instance with fine-grained control over
 * {@link Dependencies}.
 *
 * @remarks
 *
 * This function allows more control over the {@link Auth} instance than
 * {@link getAuth}. `getAuth` uses platform-specific defaults to supply
 * the {@link Dependencies}. In general, `getAuth` is the easiest way to
 * initialize Auth and works for most use cases. Use `initializeAuth` if you
 * need control over which persistence layer is used, or to minimize bundle
 * size if you're not using either `signInWithPopup` or `signInWithRedirect`.
 *
 * For example, if your app only uses anonymous accounts and you only want
 * accounts saved for the current session, initialize `Auth` with:
 *
 * ```js
 * const auth = initializeAuth(app, {
 *   persistence: browserSessionPersistence,
 *   popupRedirectResolver: undefined,
 * });
 * ```
 *
 * @public
 */ function initializeAuth(app, deps) {
    const provider = (0, _app._getProvider)(app, 'auth');
    if (provider.isInitialized()) {
        const auth = provider.getImmediate();
        const initialOptions = provider.getOptions();
        if ((0, _util.deepEqual)(initialOptions, deps ?? {})) return auth;
        else _fail(auth, "already-initialized" /* AuthErrorCode.ALREADY_INITIALIZED */ );
    }
    const auth = provider.initialize({
        options: deps
    });
    return auth;
}
function _initializeAuthInstance(auth, deps) {
    const persistence = deps?.persistence || [];
    const hierarchy = (Array.isArray(persistence) ? persistence : [
        persistence
    ]).map(_getInstance);
    if (deps?.errorMap) auth._updateErrorMap(deps.errorMap);
    // This promise is intended to float; auth initialization happens in the
    // background, meanwhile the auth object may be used by the app.
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    auth._initializeWithPersistence(hierarchy, deps?.popupRedirectResolver);
}
/**
 * Changes the {@link Auth} instance to communicate with the Firebase Auth Emulator, instead of production
 * Firebase Auth services.
 *
 * @remarks
 * This must be called synchronously immediately following the first call to
 * {@link initializeAuth}.  Do not use with production credentials as emulator
 * traffic is not encrypted.
 *
 *
 * @example
 * ```javascript
 * connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true });
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param url - The URL at which the emulator is running (eg, 'http://localhost:9099').
 * @param options - Optional. `options.disableWarnings` defaults to `false`. Set it to
 * `true` to disable the warning banner attached to the DOM.
 *
 * @public
 */ function connectAuthEmulator(auth, url, options) {
    const authInternal = _castAuth(auth);
    _assert(/^https?:\/\//.test(url), authInternal, "invalid-emulator-scheme" /* AuthErrorCode.INVALID_EMULATOR_SCHEME */ );
    const disableWarnings = !!options?.disableWarnings;
    const protocol = extractProtocol(url);
    const { host, port } = extractHostAndPort(url);
    const portStr = port === null ? '' : `:${port}`;
    // Always replace path with "/" (even if input url had no path at all, or had a different one).
    const emulator = {
        url: `${protocol}//${host}${portStr}/`
    };
    const emulatorConfig = Object.freeze({
        host,
        port,
        protocol: protocol.replace(':', ''),
        options: Object.freeze({
            disableWarnings
        })
    });
    // There are a few scenarios to guard against if the Auth instance has already started:
    if (!authInternal._canInitEmulator) {
        // Applications may not initialize the emulator for the first time if Auth has already started
        // to make network requests.
        _assert(authInternal.config.emulator && authInternal.emulatorConfig, authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // Applications may not alter the configuration of the emulator (aka pass a different config)
        // once Auth has started to make network requests.
        _assert((0, _util.deepEqual)(emulator, authInternal.config.emulator) && (0, _util.deepEqual)(emulatorConfig, authInternal.emulatorConfig), authInternal, "emulator-config-failed" /* AuthErrorCode.EMULATOR_CONFIG_FAILED */ );
        // It's valid, however, to invoke connectAuthEmulator() after Auth has started making
        // connections, so long as the config matches the existing config. This results in a no-op.
        return;
    }
    authInternal.config.emulator = emulator;
    authInternal.emulatorConfig = emulatorConfig;
    authInternal.settings.appVerificationDisabledForTesting = true;
    // Workaround to get cookies in Firebase Studio
    if ((0, _util.isCloudWorkstation)(host)) (0, _util.pingServer)(`${protocol}//${host}${portStr}`);
    else if (!disableWarnings) emitEmulatorWarning();
}
function extractProtocol(url) {
    const protocolEnd = url.indexOf(':');
    return protocolEnd < 0 ? '' : url.substr(0, protocolEnd + 1);
}
function extractHostAndPort(url) {
    const protocol = extractProtocol(url);
    const authority = /(\/\/)?([^?#/]+)/.exec(url.substr(protocol.length)); // Between // and /, ? or #.
    if (!authority) return {
        host: '',
        port: null
    };
    const hostAndPort = authority[2].split('@').pop() || ''; // Strip out "username:password@".
    const bracketedIPv6 = /^(\[[^\]]+\])(:|$)/.exec(hostAndPort);
    if (bracketedIPv6) {
        const host = bracketedIPv6[1];
        return {
            host,
            port: parsePort(hostAndPort.substr(host.length + 1))
        };
    } else {
        const [host, port] = hostAndPort.split(':');
        return {
            host,
            port: parsePort(port)
        };
    }
}
function parsePort(portStr) {
    if (!portStr) return null;
    const port = Number(portStr);
    if (isNaN(port)) return null;
    return port;
}
function emitEmulatorWarning() {
    function attachBanner() {
        const el = document.createElement('p');
        const sty = el.style;
        el.innerText = 'Running in emulator mode. Do not use with production credentials.';
        sty.position = 'fixed';
        sty.width = '100%';
        sty.backgroundColor = '#ffffff';
        sty.border = '.1em solid #000000';
        sty.color = '#b50000';
        sty.bottom = '0px';
        sty.left = '0px';
        sty.margin = '0px';
        sty.zIndex = '10000';
        sty.textAlign = 'center';
        el.classList.add('firebase-emulator-warning');
        document.body.appendChild(el);
    }
    if (typeof console !== 'undefined' && typeof console.info === 'function') console.info("WARNING: You are using the Auth Emulator, which is intended for local testing only.  Do not use with production credentials.");
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
        if (document.readyState === 'loading') window.addEventListener('DOMContentLoaded', attachBanner);
        else attachBanner();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by an {@link AuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class AuthCredential {
    /** @internal */ constructor(/**
     * The authentication provider ID for the credential.
     *
     * @remarks
     * For example, 'facebook.com', or 'google.com'.
     */ providerId, /**
     * The authentication sign in method for the credential.
     *
     * @remarks
     * For example, {@link SignInMethod}.EMAIL_PASSWORD, or
     * {@link SignInMethod}.EMAIL_LINK. This corresponds to the sign-in method
     * identifier as returned in {@link fetchSignInMethodsForEmail}.
     */ signInMethod){
        this.providerId = providerId;
        this.signInMethod = signInMethod;
    }
    /**
     * Returns a JSON-serializable representation of this object.
     *
     * @returns a JSON-serializable representation of this object.
     */ toJSON() {
        return debugFail('not implemented');
    }
    /** @internal */ _getIdTokenResponse(_auth) {
        return debugFail('not implemented');
    }
    /** @internal */ _linkToIdToken(_auth, _idToken) {
        return debugFail('not implemented');
    }
    /** @internal */ _getReauthenticationResolver(_auth) {
        return debugFail('not implemented');
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function resetPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:resetPassword" /* Endpoint.RESET_PASSWORD */ , _addTidIfNecessary(auth, request));
}
async function updateEmailPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
// Used for linking an email/password account to an existing idToken. Uses the same request/response
// format as updateEmailPassword.
async function linkEmailPassword(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , request);
}
async function applyActionCode$1(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signInWithPassword(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPassword" /* Endpoint.SIGN_IN_WITH_PASSWORD */ , _addTidIfNecessary(auth, request));
}
async function sendOobCode(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendOobCode" /* Endpoint.SEND_OOB_CODE */ , _addTidIfNecessary(auth, request));
}
async function sendEmailVerification$1(auth, request) {
    return sendOobCode(auth, request);
}
async function sendPasswordResetEmail$1(auth, request) {
    return sendOobCode(auth, request);
}
async function sendSignInLinkToEmail$1(auth, request) {
    return sendOobCode(auth, request);
}
async function verifyAndChangeEmail(auth, request) {
    return sendOobCode(auth, request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signInWithEmailLink$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , _addTidIfNecessary(auth, request));
}
async function signInWithEmailLinkForLinking(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithEmailLink" /* Endpoint.SIGN_IN_WITH_EMAIL_LINK */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface that represents the credentials returned by {@link EmailAuthProvider} for
 * {@link ProviderId}.PASSWORD
 *
 * @remarks
 * Covers both {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @public
 */ class EmailAuthCredential extends AuthCredential {
    /** @internal */ constructor(/** @internal */ _email, /** @internal */ _password, signInMethod, /** @internal */ _tenantId = null){
        super("password" /* ProviderId.PASSWORD */ , signInMethod);
        this._email = _email;
        this._password = _password;
        this._tenantId = _tenantId;
    }
    /** @internal */ static _fromEmailAndPassword(email, password) {
        return new EmailAuthCredential(email, password, "password" /* SignInMethod.EMAIL_PASSWORD */ );
    }
    /** @internal */ static _fromEmailAndCode(email, oobCode, tenantId = null) {
        return new EmailAuthCredential(email, oobCode, "emailLink" /* SignInMethod.EMAIL_LINK */ , tenantId);
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        return {
            email: this._email,
            password: this._password,
            signInMethod: this.signInMethod,
            tenantId: this._tenantId
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an {@link  AuthCredential}.
     *
     * @param json - Either `object` or the stringified representation of the object. When string is
     * provided, `JSON.parse` would be called first.
     *
     * @returns If the JSON input does not represent an {@link AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        if (obj?.email && obj?.password) {
            if (obj.signInMethod === "password" /* SignInMethod.EMAIL_PASSWORD */ ) return this._fromEmailAndPassword(obj.email, obj.password);
            else if (obj.signInMethod === "emailLink" /* SignInMethod.EMAIL_LINK */ ) return this._fromEmailAndCode(obj.email, obj.password, obj.tenantId);
        }
        return null;
    }
    /** @internal */ async _getIdTokenResponse(auth) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return handleRecaptchaFlow(auth, request, "signInWithPassword" /* RecaptchaActionName.SIGN_IN_WITH_PASSWORD */ , signInWithPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return signInWithEmailLink$1(auth, {
                    email: this._email,
                    oobCode: this._password
                });
            default:
                _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ async _linkToIdToken(auth, idToken) {
        switch(this.signInMethod){
            case "password" /* SignInMethod.EMAIL_PASSWORD */ :
                const request = {
                    idToken,
                    returnSecureToken: true,
                    email: this._email,
                    password: this._password,
                    clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                };
                return handleRecaptchaFlow(auth, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , linkEmailPassword, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
            case "emailLink" /* SignInMethod.EMAIL_LINK */ :
                return signInWithEmailLinkForLinking(auth, {
                    idToken,
                    email: this._email,
                    oobCode: this._password
                });
            default:
                _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return this._getIdTokenResponse(auth);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signInWithIdp(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithIdp" /* Endpoint.SIGN_IN_WITH_IDP */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const IDP_REQUEST_URI$1 = 'http://localhost';
/**
 * Represents the OAuth credentials returned by an {@link OAuthProvider}.
 *
 * @remarks
 * Implementations specify the details about each auth provider's credential requirements.
 *
 * @public
 */ class OAuthCredential extends AuthCredential {
    constructor(){
        super(...arguments);
        this.pendingToken = null;
    }
    /** @internal */ static _fromParams(params) {
        const cred = new OAuthCredential(params.providerId, params.signInMethod);
        if (params.idToken || params.accessToken) {
            // OAuth 2 and either ID token or access token.
            if (params.idToken) cred.idToken = params.idToken;
            if (params.accessToken) cred.accessToken = params.accessToken;
            // Add nonce if available and no pendingToken is present.
            if (params.nonce && !params.pendingToken) cred.nonce = params.nonce;
            if (params.pendingToken) cred.pendingToken = params.pendingToken;
        } else if (params.oauthToken && params.oauthTokenSecret) {
            // OAuth 1 and OAuth token with token secret
            cred.accessToken = params.oauthToken;
            cred.secret = params.oauthTokenSecret;
        } else _fail("argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return cred;
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            idToken: this.idToken,
            accessToken: this.accessToken,
            secret: this.secret,
            nonce: this.nonce,
            pendingToken: this.pendingToken,
            providerId: this.providerId,
            signInMethod: this.signInMethod
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId, signInMethod, ...rest } = obj;
        if (!providerId || !signInMethod) return null;
        const cred = new OAuthCredential(providerId, signInMethod);
        cred.idToken = rest.idToken || undefined;
        cred.accessToken = rest.accessToken || undefined;
        cred.secret = rest.secret;
        cred.nonce = rest.nonce;
        cred.pendingToken = rest.pendingToken || null;
        return cred;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return signInWithIdp(auth, request);
    }
    buildRequest() {
        const request = {
            requestUri: IDP_REQUEST_URI$1,
            returnSecureToken: true
        };
        if (this.pendingToken) request.pendingToken = this.pendingToken;
        else {
            const postBody = {};
            if (this.idToken) postBody['id_token'] = this.idToken;
            if (this.accessToken) postBody['access_token'] = this.accessToken;
            if (this.secret) postBody['oauth_token_secret'] = this.secret;
            postBody['providerId'] = this.providerId;
            if (this.nonce && !this.pendingToken) postBody['nonce'] = this.nonce;
            request.postBody = (0, _util.querystring)(postBody);
        }
        return request;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function sendPhoneVerificationCode(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:sendVerificationCode" /* Endpoint.SEND_VERIFICATION_CODE */ , _addTidIfNecessary(auth, request));
}
async function signInWithPhoneNumber$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , _addTidIfNecessary(auth, request));
}
async function linkWithPhoneNumber$1(auth, request) {
    const response = await _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , _addTidIfNecessary(auth, request));
    if (response.temporaryProof) throw _makeTaggedError(auth, "account-exists-with-different-credential" /* AuthErrorCode.NEED_CONFIRMATION */ , response);
    return response;
}
const VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_ = {
    ["USER_NOT_FOUND" /* ServerError.USER_NOT_FOUND */ ]: "user-not-found" /* AuthErrorCode.USER_DELETED */ 
};
async function verifyPhoneNumberForExisting(auth, request) {
    const apiRequest = {
        ...request,
        operation: 'REAUTH'
    };
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithPhoneNumber" /* Endpoint.SIGN_IN_WITH_PHONE_NUMBER */ , _addTidIfNecessary(auth, apiRequest), VERIFY_PHONE_NUMBER_FOR_EXISTING_ERROR_MAP_);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the credentials returned by {@link PhoneAuthProvider}.
 *
 * @public
 */ class PhoneAuthCredential extends AuthCredential {
    constructor(params){
        super("phone" /* ProviderId.PHONE */ , "phone" /* SignInMethod.PHONE */ );
        this.params = params;
    }
    /** @internal */ static _fromVerification(verificationId, verificationCode) {
        return new PhoneAuthCredential({
            verificationId,
            verificationCode
        });
    }
    /** @internal */ static _fromTokenResponse(phoneNumber, temporaryProof) {
        return new PhoneAuthCredential({
            phoneNumber,
            temporaryProof
        });
    }
    /** @internal */ _getIdTokenResponse(auth) {
        return signInWithPhoneNumber$1(auth, this._makeVerificationRequest());
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        return linkWithPhoneNumber$1(auth, {
            idToken,
            ...this._makeVerificationRequest()
        });
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        return verifyPhoneNumberForExisting(auth, this._makeVerificationRequest());
    }
    /** @internal */ _makeVerificationRequest() {
        const { temporaryProof, phoneNumber, verificationId, verificationCode } = this.params;
        if (temporaryProof && phoneNumber) return {
            temporaryProof,
            phoneNumber
        };
        return {
            sessionInfo: verificationId,
            code: verificationCode
        };
    }
    /** {@inheritdoc AuthCredential.toJSON} */ toJSON() {
        const obj = {
            providerId: this.providerId
        };
        if (this.params.phoneNumber) obj.phoneNumber = this.params.phoneNumber;
        if (this.params.temporaryProof) obj.temporaryProof = this.params.temporaryProof;
        if (this.params.verificationCode) obj.verificationCode = this.params.verificationCode;
        if (this.params.verificationId) obj.verificationId = this.params.verificationId;
        return obj;
    }
    /** Generates a phone credential based on a plain object or a JSON string. */ static fromJSON(json) {
        if (typeof json === 'string') json = JSON.parse(json);
        const { verificationId, verificationCode, phoneNumber, temporaryProof } = json;
        if (!verificationCode && !verificationId && !phoneNumber && !temporaryProof) return null;
        return new PhoneAuthCredential({
            verificationId,
            verificationCode,
            phoneNumber,
            temporaryProof
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Maps the mode string in action code URL to Action Code Info operation.
 *
 * @param mode
 */ function parseMode(mode) {
    switch(mode){
        case 'recoverEmail':
            return "RECOVER_EMAIL" /* ActionCodeOperation.RECOVER_EMAIL */ ;
        case 'resetPassword':
            return "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ;
        case 'signIn':
            return "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
        case 'verifyEmail':
            return "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ;
        case 'verifyAndChangeEmail':
            return "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ;
        case 'revertSecondFactorAddition':
            return "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ ;
        default:
            return null;
    }
}
/**
 * Helper to parse FDL links
 *
 * @param url
 */ function parseDeepLink(url) {
    const link = (0, _util.querystringDecode)((0, _util.extractQuerystring)(url))['link'];
    // Double link case (automatic redirect).
    const doubleDeepLink = link ? (0, _util.querystringDecode)((0, _util.extractQuerystring)(link))['deep_link_id'] : null;
    // iOS custom scheme links.
    const iOSDeepLink = (0, _util.querystringDecode)((0, _util.extractQuerystring)(url))['deep_link_id'];
    const iOSDoubleDeepLink = iOSDeepLink ? (0, _util.querystringDecode)((0, _util.extractQuerystring)(iOSDeepLink))['link'] : null;
    return iOSDoubleDeepLink || iOSDeepLink || doubleDeepLink || link || url;
}
/**
 * A utility class to parse email action URLs such as password reset, email verification,
 * email link sign in, etc.
 *
 * @public
 */ class ActionCodeURL {
    /**
     * @param actionLink - The link from which to extract the URL.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @internal
     */ constructor(actionLink){
        const searchParams = (0, _util.querystringDecode)((0, _util.extractQuerystring)(actionLink));
        const apiKey = searchParams["apiKey" /* QueryField.API_KEY */ ] ?? null;
        const code = searchParams["oobCode" /* QueryField.CODE */ ] ?? null;
        const operation = parseMode(searchParams["mode" /* QueryField.MODE */ ] ?? null);
        // Validate API key, code and mode.
        _assert(apiKey && code && operation, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.apiKey = apiKey;
        this.operation = operation;
        this.code = code;
        this.continueUrl = searchParams["continueUrl" /* QueryField.CONTINUE_URL */ ] ?? null;
        this.languageCode = searchParams["lang" /* QueryField.LANGUAGE_CODE */ ] ?? null;
        this.tenantId = searchParams["tenantId" /* QueryField.TENANT_ID */ ] ?? null;
    }
    /**
     * Parses the email action link string and returns an {@link ActionCodeURL} if the link is valid,
     * otherwise returns null.
     *
     * @param link  - The email action link string.
     * @returns The {@link ActionCodeURL} object, or null if the link is invalid.
     *
     * @public
     */ static parseLink(link) {
        const actionLink = parseDeepLink(link);
        try {
            return new ActionCodeURL(actionLink);
        } catch  {
            return null;
        }
    }
}
/**
 * Parses the email action link string and returns an {@link ActionCodeURL} if
 * the link is valid, otherwise returns null.
 *
 * @public
 */ function parseActionCodeURL(link) {
    return ActionCodeURL.parseLink(link);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating {@link EmailAuthCredential}.
 *
 * @public
 */ class EmailAuthProvider {
    constructor(){
        /**
         * Always set to {@link ProviderId}.PASSWORD, even for email link.
         */ this.providerId = EmailAuthProvider.PROVIDER_ID;
    }
    /**
     * Initialize an {@link AuthCredential} using an email and password.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credential(email, password);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * const userCredential = await signInWithEmailAndPassword(auth, email, password);
     * ```
     *
     * @param email - Email address.
     * @param password - User account password.
     * @returns The auth provider credential.
     */ static credential(email, password) {
        return EmailAuthCredential._fromEmailAndPassword(email, password);
    }
    /**
     * Initialize an {@link AuthCredential} using an email and an email link after a sign in with
     * email link operation.
     *
     * @example
     * ```javascript
     * const authCredential = EmailAuthProvider.credentialWithLink(auth, email, emailLink);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * ```javascript
     * await sendSignInLinkToEmail(auth, email);
     * // Obtain emailLink from user.
     * const userCredential = await signInWithEmailLink(auth, email, emailLink);
     * ```
     *
     * @param auth - The {@link Auth} instance used to verify the link.
     * @param email - Email address.
     * @param emailLink - Sign-in email link.
     * @returns - The auth provider credential.
     */ static credentialWithLink(email, emailLink) {
        const actionCodeUrl = ActionCodeURL.parseLink(emailLink);
        _assert(actionCodeUrl, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return EmailAuthCredential._fromEmailAndCode(email, actionCodeUrl.code, actionCodeUrl.tenantId);
    }
}
/**
 * Always set to {@link ProviderId}.PASSWORD, even for email link.
 */ EmailAuthProvider.PROVIDER_ID = "password" /* ProviderId.PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_PASSWORD.
 */ EmailAuthProvider.EMAIL_PASSWORD_SIGN_IN_METHOD = "password" /* SignInMethod.EMAIL_PASSWORD */ ;
/**
 * Always set to {@link SignInMethod}.EMAIL_LINK.
 */ EmailAuthProvider.EMAIL_LINK_SIGN_IN_METHOD = "emailLink" /* SignInMethod.EMAIL_LINK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The base class for all Federated providers (OAuth (including OIDC), SAML).
 *
 * This class is not meant to be instantiated directly.
 *
 * @public
 */ class FederatedAuthProvider {
    /**
     * Constructor for generic OAuth providers.
     *
     * @param providerId - Provider for which credentials should be generated.
     */ constructor(providerId){
        this.providerId = providerId;
        /** @internal */ this.defaultLanguageCode = null;
        /** @internal */ this.customParameters = {};
    }
    /**
     * Set the language gode.
     *
     * @param languageCode - language code
     */ setDefaultLanguage(languageCode) {
        this.defaultLanguageCode = languageCode;
    }
    /**
     * Sets the OAuth custom parameters to pass in an OAuth request for popup and redirect sign-in
     * operations.
     *
     * @remarks
     * For a detailed list, check the reserved required OAuth 2.0 parameters such as `client_id`,
     * `redirect_uri`, `scope`, `response_type`, and `state` are not allowed and will be ignored.
     *
     * @param customOAuthParameters - The custom OAuth parameters to pass in the OAuth request.
     */ setCustomParameters(customOAuthParameters) {
        this.customParameters = customOAuthParameters;
        return this;
    }
    /**
     * Retrieve the current list of {@link CustomParameters}.
     */ getCustomParameters() {
        return this.customParameters;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Common code to all OAuth providers. This is separate from the
 * {@link OAuthProvider} so that child providers (like
 * {@link GoogleAuthProvider}) don't inherit the `credential` instance method.
 * Instead, they rely on a static `credential` method.
 */ class BaseOAuthProvider extends FederatedAuthProvider {
    constructor(){
        super(...arguments);
        /** @internal */ this.scopes = [];
    }
    /**
     * Add an OAuth scope to the credential.
     *
     * @param scope - Provider OAuth scope to add.
     */ addScope(scope) {
        // If not already added, add scope to list.
        if (!this.scopes.includes(scope)) this.scopes.push(scope);
        return this;
    }
    /**
     * Retrieve the current list of OAuth scopes.
     */ getScopes() {
        return [
            ...this.scopes
        ];
    }
}
/**
 * Provider for generating generic {@link OAuthCredential}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new OAuthProvider('google.com');
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a OAuth Access Token for the provider.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new OAuthProvider('google.com');
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a OAuth Access Token for the provider.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class OAuthProvider extends BaseOAuthProvider {
    /**
     * Creates an {@link OAuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        _assert('providerId' in obj && 'signInMethod' in obj, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return OAuthCredential._fromParams(obj);
    }
    /**
     * Creates a {@link OAuthCredential} from a generic OAuth provider's access token or ID token.
     *
     * @remarks
     * The raw nonce is required when an ID token with a nonce field is provided. The SHA-256 hash of
     * the raw nonce must match the nonce field in the ID token.
     *
     * @example
     * ```javascript
     * // `googleUser` from the onsuccess Google Sign In callback.
     * // Initialize a generate OAuth provider with a `google.com` providerId.
     * const provider = new OAuthProvider('google.com');
     * const credential = provider.credential({
     *   idToken: googleUser.getAuthResponse().id_token,
     * });
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param params - Either the options object containing the ID token, access token and raw nonce
     * or the ID token string.
     */ credential(params) {
        return this._credential({
            ...params,
            nonce: params.rawNonce
        });
    }
    /** An internal credential method that accepts more permissive options */ _credential(params) {
        _assert(params.idToken || params.accessToken, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        // For OAuthCredential, sign in method is same as providerId.
        return OAuthCredential._fromParams({
            ...params,
            providerId: this.providerId,
            signInMethod: this.providerId
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return OAuthProvider.oauthCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return OAuthProvider.oauthCredentialFromTaggedObject(error.customData || {});
    }
    static oauthCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken, oauthAccessToken, oauthTokenSecret, pendingToken, nonce, providerId } = tokenResponse;
        if (!oauthAccessToken && !oauthTokenSecret && !oauthIdToken && !pendingToken) return null;
        if (!providerId) return null;
        try {
            return new OAuthProvider(providerId)._credential({
                idToken: oauthIdToken,
                accessToken: oauthAccessToken,
                nonce,
                pendingToken
            });
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.FACEBOOK.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('user_birthday');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = FacebookAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * provider.addScope('user_birthday');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = FacebookAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class FacebookAuthProvider extends BaseOAuthProvider {
    constructor(){
        super("facebook.com" /* ProviderId.FACEBOOK */ );
    }
    /**
     * Creates a credential for Facebook.
     *
     * @example
     * ```javascript
     * // `event` from the Facebook auth.authResponseChange callback.
     * const credential = FacebookAuthProvider.credential(event.authResponse.accessToken);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param accessToken - Facebook access token.
     */ static credential(accessToken) {
        return OAuthCredential._fromParams({
            providerId: FacebookAuthProvider.PROVIDER_ID,
            signInMethod: FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return FacebookAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return FacebookAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return FacebookAuthProvider.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.FACEBOOK. */ FacebookAuthProvider.FACEBOOK_SIGN_IN_METHOD = "facebook.com" /* SignInMethod.FACEBOOK */ ;
/** Always set to {@link ProviderId}.FACEBOOK. */ FacebookAuthProvider.PROVIDER_ID = "facebook.com" /* ProviderId.FACEBOOK */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GOOGLE.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GoogleAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('profile');
 * provider.addScope('email');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Google Access Token.
 *   const credential = GoogleAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GoogleAuthProvider();
 * provider.addScope('profile');
 * provider.addScope('email');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Google Access Token.
 * const credential = GoogleAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 *
 * @public
 */ class GoogleAuthProvider extends BaseOAuthProvider {
    constructor(){
        super("google.com" /* ProviderId.GOOGLE */ );
        this.addScope('profile');
    }
    /**
     * Creates a credential for Google. At least one of ID token and access token is required.
     *
     * @example
     * ```javascript
     * // \`googleUser\` from the onsuccess Google Sign In callback.
     * const credential = GoogleAuthProvider.credential(googleUser.getAuthResponse().id_token);
     * const result = await signInWithCredential(credential);
     * ```
     *
     * @param idToken - Google ID token.
     * @param accessToken - Google access token.
     */ static credential(idToken, accessToken) {
        return OAuthCredential._fromParams({
            providerId: GoogleAuthProvider.PROVIDER_ID,
            signInMethod: GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD,
            idToken,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return GoogleAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return GoogleAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthIdToken, oauthAccessToken } = tokenResponse;
        if (!oauthIdToken && !oauthAccessToken) // This could be an oauth 1 credential or a phone credential
        return null;
        try {
            return GoogleAuthProvider.credential(oauthIdToken, oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GOOGLE. */ GoogleAuthProvider.GOOGLE_SIGN_IN_METHOD = "google.com" /* SignInMethod.GOOGLE */ ;
/** Always set to {@link ProviderId}.GOOGLE. */ GoogleAuthProvider.PROVIDER_ID = "google.com" /* ProviderId.GOOGLE */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.GITHUB.
 *
 * @remarks
 * GitHub requires an OAuth 2.0 redirect, so you can either handle the redirect directly, or use
 * the {@link signInWithPopup} handler:
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new GithubAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * provider.addScope('repo');
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a GitHub Access Token.
 *   const credential = GithubAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new GithubAuthProvider();
 * provider.addScope('repo');
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a GitHub Access Token.
 * const credential = GithubAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * ```
 * @public
 */ class GithubAuthProvider extends BaseOAuthProvider {
    constructor(){
        super("github.com" /* ProviderId.GITHUB */ );
    }
    /**
     * Creates a credential for GitHub.
     *
     * @param accessToken - GitHub access token.
     */ static credential(accessToken) {
        return OAuthCredential._fromParams({
            providerId: GithubAuthProvider.PROVIDER_ID,
            signInMethod: GithubAuthProvider.GITHUB_SIGN_IN_METHOD,
            accessToken
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return GithubAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return GithubAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse || !('oauthAccessToken' in tokenResponse)) return null;
        if (!tokenResponse.oauthAccessToken) return null;
        try {
            return GithubAuthProvider.credential(tokenResponse.oauthAccessToken);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.GITHUB. */ GithubAuthProvider.GITHUB_SIGN_IN_METHOD = "github.com" /* SignInMethod.GITHUB */ ;
/** Always set to {@link ProviderId}.GITHUB. */ GithubAuthProvider.PROVIDER_ID = "github.com" /* ProviderId.GITHUB */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const IDP_REQUEST_URI = 'http://localhost';
/**
 * @public
 */ class SAMLAuthCredential extends AuthCredential {
    /** @internal */ constructor(providerId, pendingToken){
        super(providerId, providerId);
        this.pendingToken = pendingToken;
    }
    /** @internal */ _getIdTokenResponse(auth) {
        const request = this.buildRequest();
        return signInWithIdp(auth, request);
    }
    /** @internal */ _linkToIdToken(auth, idToken) {
        const request = this.buildRequest();
        request.idToken = idToken;
        return signInWithIdp(auth, request);
    }
    /** @internal */ _getReauthenticationResolver(auth) {
        const request = this.buildRequest();
        request.autoCreate = false;
        return signInWithIdp(auth, request);
    }
    /** {@inheritdoc AuthCredential.toJSON}  */ toJSON() {
        return {
            signInMethod: this.signInMethod,
            providerId: this.providerId,
            pendingToken: this.pendingToken
        };
    }
    /**
     * Static method to deserialize a JSON representation of an object into an
     * {@link  AuthCredential}.
     *
     * @param json - Input can be either Object or the stringified representation of the object.
     * When string is provided, JSON.parse would be called first.
     *
     * @returns If the JSON input does not represent an {@link  AuthCredential}, null is returned.
     */ static fromJSON(json) {
        const obj = typeof json === 'string' ? JSON.parse(json) : json;
        const { providerId, signInMethod, pendingToken } = obj;
        if (!providerId || !signInMethod || !pendingToken || providerId !== signInMethod) return null;
        return new SAMLAuthCredential(providerId, pendingToken);
    }
    /**
     * Helper static method to avoid exposing the constructor to end users.
     *
     * @internal
     */ static _create(providerId, pendingToken) {
        return new SAMLAuthCredential(providerId, pendingToken);
    }
    buildRequest() {
        return {
            requestUri: IDP_REQUEST_URI,
            returnSecureToken: true,
            pendingToken: this.pendingToken
        };
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const SAML_PROVIDER_PREFIX = 'saml.';
/**
 * An {@link AuthProvider} for SAML.
 *
 * @public
 */ class SAMLAuthProvider extends FederatedAuthProvider {
    /**
     * Constructor. The providerId must start with "saml."
     * @param providerId - SAML provider ID.
     */ constructor(providerId){
        _assert(providerId.startsWith(SAML_PROVIDER_PREFIX), "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        super(providerId);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential} after a
     * successful SAML flow completes.
     *
     * @remarks
     *
     * For example, to get an {@link AuthCredential}, you could write the
     * following code:
     *
     * ```js
     * const userCredential = await signInWithPopup(auth, samlProvider);
     * const credential = SAMLAuthProvider.credentialFromResult(userCredential);
     * ```
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return SAMLAuthProvider.samlCredentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return SAMLAuthProvider.samlCredentialFromTaggedObject(error.customData || {});
    }
    /**
     * Creates an {@link AuthCredential} from a JSON string or a plain object.
     * @param json - A plain object or a JSON string
     */ static credentialFromJSON(json) {
        const credential = SAMLAuthCredential.fromJSON(json);
        _assert(credential, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return credential;
    }
    static samlCredentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { pendingToken, providerId } = tokenResponse;
        if (!pendingToken || !providerId) return null;
        try {
            return SAMLAuthCredential._create(providerId, pendingToken);
        } catch (e) {
            return null;
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link OAuthCredential} for {@link ProviderId}.TWITTER.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new TwitterAuthProvider();
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Twitter Access Token and Secret.
 *   const credential = TwitterAuthProvider.credentialFromResult(result);
 *   const token = credential.accessToken;
 *   const secret = credential.secret;
 * }
 * ```
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new TwitterAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Twitter Access Token and Secret.
 * const credential = TwitterAuthProvider.credentialFromResult(result);
 * const token = credential.accessToken;
 * const secret = credential.secret;
 * ```
 *
 * @public
 */ class TwitterAuthProvider extends BaseOAuthProvider {
    constructor(){
        super("twitter.com" /* ProviderId.TWITTER */ );
    }
    /**
     * Creates a credential for Twitter.
     *
     * @param token - Twitter access token.
     * @param secret - Twitter secret.
     */ static credential(token, secret) {
        return OAuthCredential._fromParams({
            providerId: TwitterAuthProvider.PROVIDER_ID,
            signInMethod: TwitterAuthProvider.TWITTER_SIGN_IN_METHOD,
            oauthToken: token,
            oauthTokenSecret: secret
        });
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link UserCredential}.
     *
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        return TwitterAuthProvider.credentialFromTaggedObject(userCredential);
    }
    /**
     * Used to extract the underlying {@link OAuthCredential} from a {@link AuthError} which was
     * thrown during a sign-in, link, or reauthenticate operation.
     *
     * @param userCredential - The user credential.
     */ static credentialFromError(error) {
        return TwitterAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { oauthAccessToken, oauthTokenSecret } = tokenResponse;
        if (!oauthAccessToken || !oauthTokenSecret) return null;
        try {
            return TwitterAuthProvider.credential(oauthAccessToken, oauthTokenSecret);
        } catch  {
            return null;
        }
    }
}
/** Always set to {@link SignInMethod}.TWITTER. */ TwitterAuthProvider.TWITTER_SIGN_IN_METHOD = "twitter.com" /* SignInMethod.TWITTER */ ;
/** Always set to {@link ProviderId}.TWITTER. */ TwitterAuthProvider.PROVIDER_ID = "twitter.com" /* ProviderId.TWITTER */ ;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signUp(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signUp" /* Endpoint.SIGN_UP */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class UserCredentialImpl {
    constructor(params){
        this.user = params.user;
        this.providerId = params.providerId;
        this._tokenResponse = params._tokenResponse;
        this.operationType = params.operationType;
    }
    static async _fromIdTokenResponse(auth, operationType, idTokenResponse, isAnonymous = false) {
        const user = await UserImpl._fromIdTokenResponse(auth, idTokenResponse, isAnonymous);
        const providerId = providerIdForResponse(idTokenResponse);
        const userCred = new UserCredentialImpl({
            user,
            providerId,
            _tokenResponse: idTokenResponse,
            operationType
        });
        return userCred;
    }
    static async _forOperation(user, operationType, response) {
        await user._updateTokensIfNecessary(response, /* reload */ true);
        const providerId = providerIdForResponse(response);
        return new UserCredentialImpl({
            user,
            providerId,
            _tokenResponse: response,
            operationType
        });
    }
}
function providerIdForResponse(response) {
    if (response.providerId) return response.providerId;
    if ('phoneNumber' in response) return "phone" /* ProviderId.PHONE */ ;
    return null;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in as an anonymous user.
 *
 * @remarks
 * If there is already an anonymous user signed in, that user will be returned; otherwise, a
 * new anonymous user identity will be created and returned.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ async function signInAnonymously(auth) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    await authInternal._initializationPromise;
    if (authInternal.currentUser?.isAnonymous) // If an anonymous user is already signed in, no need to sign them in again.
    return new UserCredentialImpl({
        user: authInternal.currentUser,
        providerId: null,
        operationType: "signIn" /* OperationType.SIGN_IN */ 
    });
    const response = await signUp(authInternal, {
        returnSecureToken: true
    });
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response, true);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MultiFactorError extends (0, _util.FirebaseError) {
    constructor(auth, error, operationType, user){
        super(error.code, error.message);
        this.operationType = operationType;
        this.user = user;
        // https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        Object.setPrototypeOf(this, MultiFactorError.prototype);
        this.customData = {
            appName: auth.name,
            tenantId: auth.tenantId ?? undefined,
            _serverResponse: error.customData._serverResponse,
            operationType
        };
    }
    static _fromErrorAndOperation(auth, error, operationType, user) {
        return new MultiFactorError(auth, error, operationType, user);
    }
}
function _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user) {
    const idTokenProvider = operationType === "reauthenticate" /* OperationType.REAUTHENTICATE */  ? credential._getReauthenticationResolver(auth) : credential._getIdTokenResponse(auth);
    return idTokenProvider.catch((error)=>{
        if (error.code === `auth/${"multi-factor-auth-required" /* AuthErrorCode.MFA_REQUIRED */ }`) throw MultiFactorError._fromErrorAndOperation(auth, error, operationType, user);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Takes a set of UserInfo provider data and converts it to a set of names
 */ function providerDataAsNames(providerData) {
    return new Set(providerData.map(({ providerId })=>providerId).filter((pid)=>!!pid));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unlinks a provider from a user account.
 *
 * @param user - The user.
 * @param providerId - The provider to unlink.
 *
 * @public
 */ async function unlink(user, providerId) {
    const userInternal = (0, _util.getModularInstance)(user);
    await _assertLinkedStatus(true, userInternal, providerId);
    const { providerUserInfo } = await deleteLinkedAccounts(userInternal.auth, {
        idToken: await userInternal.getIdToken(),
        deleteProvider: [
            providerId
        ]
    });
    const providersLeft = providerDataAsNames(providerUserInfo || []);
    userInternal.providerData = userInternal.providerData.filter((pd)=>providersLeft.has(pd.providerId));
    if (!providersLeft.has("phone" /* ProviderId.PHONE */ )) userInternal.phoneNumber = null;
    await userInternal.auth._persistUserIfCurrent(userInternal);
    return userInternal;
}
async function _link$1(user, credential, bypassAuthState = false) {
    const response = await _logoutIfInvalidated(user, credential._linkToIdToken(user.auth, await user.getIdToken()), bypassAuthState);
    return UserCredentialImpl._forOperation(user, "link" /* OperationType.LINK */ , response);
}
async function _assertLinkedStatus(expected, user, provider) {
    await _reloadWithoutSaving(user);
    const providerIds = providerDataAsNames(user.providerData);
    const code = expected === false ? "provider-already-linked" /* AuthErrorCode.PROVIDER_ALREADY_LINKED */  : "no-such-provider" /* AuthErrorCode.NO_SUCH_PROVIDER */ ;
    _assert(providerIds.has(provider) === expected, user.auth, code);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _reauthenticate(user, credential, bypassAuthState = false) {
    const { auth } = user;
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "reauthenticate" /* OperationType.REAUTHENTICATE */ ;
    try {
        const response = await _logoutIfInvalidated(user, _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential, user), bypassAuthState);
        _assert(response.idToken, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const parsed = _parseToken(response.idToken);
        _assert(parsed, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const { sub: localId } = parsed;
        _assert(user.uid === localId, auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        return UserCredentialImpl._forOperation(user, operationType, response);
    } catch (e) {
        // Convert user deleted error into user mismatch
        if (e?.code === `auth/${"user-not-found" /* AuthErrorCode.USER_DELETED */ }`) _fail(auth, "user-mismatch" /* AuthErrorCode.USER_MISMATCH */ );
        throw e;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _signInWithCredential(auth, credential, bypassAuthState = false) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const operationType = "signIn" /* OperationType.SIGN_IN */ ;
    const response = await _processCredentialSavingMfaContextIfNecessary(auth, operationType, credential);
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(auth, operationType, response);
    if (!bypassAuthState) await auth._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param credential - The auth credential.
 *
 * @public
 */ async function signInWithCredential(auth, credential) {
    return _signInWithCredential(_castAuth(auth), credential);
}
/**
 * Links the user account with the given credentials.
 *
 * @remarks
 * An {@link AuthProvider} can be used to generate the credential.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function linkWithCredential(user, credential) {
    const userInternal = (0, _util.getModularInstance)(user);
    await _assertLinkedStatus(false, userInternal, credential.providerId);
    return _link$1(userInternal, credential);
}
/**
 * Re-authenticates a user using a fresh credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in
 * attempts. This method can be used to recover from a `CREDENTIAL_TOO_OLD_LOGIN_AGAIN` error
 * or a `TOKEN_EXPIRED` error.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param credential - The auth credential.
 *
 * @public
 */ async function reauthenticateWithCredential(user, credential) {
    return _reauthenticate((0, _util.getModularInstance)(user), credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function signInWithCustomToken$1(auth, request) {
    return _performSignInRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:signInWithCustomToken" /* Endpoint.SIGN_IN_WITH_CUSTOM_TOKEN */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Asynchronously signs in using a custom token.
 *
 * @remarks
 * Custom tokens are used to integrate Firebase Auth with existing auth systems, and must
 * be generated by an auth backend using the
 * {@link https://firebase.google.com/docs/reference/admin/node/admin.auth.Auth#createcustomtoken | createCustomToken}
 * method in the {@link https://firebase.google.com/docs/auth/admin | Admin SDK} .
 *
 * Fails with an error if the token is invalid, expired, or not accepted by the Firebase Auth service.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param customToken - The custom token to sign in with.
 *
 * @public
 */ async function signInWithCustomToken(auth, customToken) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    const response = await signInWithCustomToken$1(authInternal, {
        token: customToken,
        returnSecureToken: true
    });
    const cred = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(cred.user);
    return cred;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MultiFactorInfoImpl {
    constructor(factorId, response){
        this.factorId = factorId;
        this.uid = response.mfaEnrollmentId;
        this.enrollmentTime = new Date(response.enrolledAt).toUTCString();
        this.displayName = response.displayName;
    }
    static _fromServerResponse(auth, enrollment) {
        if ('phoneInfo' in enrollment) return PhoneMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        else if ('totpInfo' in enrollment) return TotpMultiFactorInfoImpl._fromServerResponse(auth, enrollment);
        return _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
}
class PhoneMultiFactorInfoImpl extends MultiFactorInfoImpl {
    constructor(response){
        super("phone" /* FactorId.PHONE */ , response);
        this.phoneNumber = response.phoneInfo;
    }
    static _fromServerResponse(_auth, enrollment) {
        return new PhoneMultiFactorInfoImpl(enrollment);
    }
}
class TotpMultiFactorInfoImpl extends MultiFactorInfoImpl {
    constructor(response){
        super("totp" /* FactorId.TOTP */ , response);
    }
    static _fromServerResponse(_auth, enrollment) {
        return new TotpMultiFactorInfoImpl(enrollment);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _setActionCodeSettingsOnRequest(auth, request, actionCodeSettings) {
    _assert(actionCodeSettings.url?.length > 0, auth, "invalid-continue-uri" /* AuthErrorCode.INVALID_CONTINUE_URI */ );
    _assert(typeof actionCodeSettings.dynamicLinkDomain === 'undefined' || actionCodeSettings.dynamicLinkDomain.length > 0, auth, "invalid-dynamic-link-domain" /* AuthErrorCode.INVALID_DYNAMIC_LINK_DOMAIN */ );
    _assert(typeof actionCodeSettings.linkDomain === 'undefined' || actionCodeSettings.linkDomain.length > 0, auth, "invalid-hosting-link-domain" /* AuthErrorCode.INVALID_HOSTING_LINK_DOMAIN */ );
    request.continueUrl = actionCodeSettings.url;
    request.dynamicLinkDomain = actionCodeSettings.dynamicLinkDomain;
    request.linkDomain = actionCodeSettings.linkDomain;
    request.canHandleCodeInApp = actionCodeSettings.handleCodeInApp;
    if (actionCodeSettings.iOS) {
        _assert(actionCodeSettings.iOS.bundleId.length > 0, auth, "missing-ios-bundle-id" /* AuthErrorCode.MISSING_IOS_BUNDLE_ID */ );
        request.iOSBundleId = actionCodeSettings.iOS.bundleId;
    }
    if (actionCodeSettings.android) {
        _assert(actionCodeSettings.android.packageName.length > 0, auth, "missing-android-pkg-name" /* AuthErrorCode.MISSING_ANDROID_PACKAGE_NAME */ );
        request.androidInstallApp = actionCodeSettings.android.installApp;
        request.androidMinimumVersionCode = actionCodeSettings.android.minimumVersion;
        request.androidPackageName = actionCodeSettings.android.packageName;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates the password policy cached in the {@link Auth} instance if a policy is already
 * cached for the project or tenant.
 *
 * @remarks
 * We only fetch the password policy if the password did not meet policy requirements and
 * there is an existing policy cached. A developer must call validatePassword at least
 * once for the cache to be automatically updated.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @private
 */ async function recachePasswordPolicy(auth) {
    const authInternal = _castAuth(auth);
    if (authInternal._getPasswordPolicyInternal()) await authInternal._updatePasswordPolicy();
}
/**
 * Sends a password reset email to the given email address. This method does not throw an error when
 * there's no user account with the given email address and
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 *
 * @remarks
 * To complete the password reset, call {@link confirmPasswordReset} with the code supplied in
 * the email sent to the user, along with the new password specified by the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendPasswordResetEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain code from user.
 * await confirmPasswordReset('user@example.com', code);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function sendPasswordResetEmail(auth, email, actionCodeSettings) {
    const authInternal = _castAuth(auth);
    const request = {
        requestType: "PASSWORD_RESET" /* ActionCodeOperation.PASSWORD_RESET */ ,
        email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    if (actionCodeSettings) _setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    await handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , sendPasswordResetEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Completes the password reset process, given a confirmation code and new password.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A confirmation code sent to the user.
 * @param newPassword - The new password.
 *
 * @public
 */ async function confirmPasswordReset(auth, oobCode, newPassword) {
    await resetPassword((0, _util.getModularInstance)(auth), {
        oobCode,
        newPassword
    }).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) recachePasswordPolicy(auth);
        throw error;
    });
// Do not return the email.
}
/**
 * Applies a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function applyActionCode(auth, oobCode) {
    await applyActionCode$1((0, _util.getModularInstance)(auth), {
        oobCode
    });
}
/**
 * Checks a verification code sent to the user by email or other out-of-band mechanism.
 *
 * @returns metadata about the code.
 *
 * @param auth - The {@link Auth} instance.
 * @param oobCode - A verification code sent to the user.
 *
 * @public
 */ async function checkActionCode(auth, oobCode) {
    const authModular = (0, _util.getModularInstance)(auth);
    const response = await resetPassword(authModular, {
        oobCode
    });
    // Email could be empty only if the request type is EMAIL_SIGNIN or
    // VERIFY_AND_CHANGE_EMAIL.
    // New email should not be empty if the request type is
    // VERIFY_AND_CHANGE_EMAIL.
    // Multi-factor info could not be empty if the request type is
    // REVERT_SECOND_FACTOR_ADDITION.
    const operation = response.requestType;
    _assert(operation, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    switch(operation){
        case "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ :
            break;
        case "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ :
            _assert(response.newEmail, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            break;
        case "REVERT_SECOND_FACTOR_ADDITION" /* ActionCodeOperation.REVERT_SECOND_FACTOR_ADDITION */ :
            _assert(response.mfaInfo, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        // fall through
        default:
            _assert(response.email, authModular, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    // The multi-factor info for revert second factor addition
    let multiFactorInfo = null;
    if (response.mfaInfo) multiFactorInfo = MultiFactorInfoImpl._fromServerResponse(_castAuth(authModular), response.mfaInfo);
    return {
        data: {
            email: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.newEmail : response.email) || null,
            previousEmail: (response.requestType === "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */  ? response.email : response.newEmail) || null,
            multiFactorInfo
        },
        operation
    };
}
/**
 * Checks a password reset code sent to the user by email or other out-of-band mechanism.
 *
 * @returns the user's email address if valid.
 *
 * @param auth - The {@link Auth} instance.
 * @param code - A verification code sent to the user.
 *
 * @public
 */ async function verifyPasswordResetCode(auth, code) {
    const { data } = await checkActionCode((0, _util.getModularInstance)(auth), code);
    // Email should always be present since a code was sent to it
    return data.email;
}
/**
 * Creates a new user account associated with the specified email address and password.
 *
 * @remarks
 * On successful creation of the user account, this user will also be signed in to your application.
 *
 * User account creation can fail if the account already exists or the password is invalid.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The email address acts as a unique identifier for the user and enables an email-based
 * password reset. This function will create a new user account and set the initial user password.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param password - The user's chosen password.
 *
 * @public
 */ async function createUserWithEmailAndPassword(auth, email, password) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    const request = {
        returnSecureToken: true,
        email,
        password,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    const signUpResponse = handleRecaptchaFlow(authInternal, request, "signUpPassword" /* RecaptchaActionName.SIGN_UP_PASSWORD */ , signUp, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
    const response = await signUpResponse.catch((error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) recachePasswordPolicy(auth);
        throw error;
    });
    const userCredential = await UserCredentialImpl._fromIdTokenResponse(authInternal, "signIn" /* OperationType.SIGN_IN */ , response);
    await authInternal._updateCurrentUser(userCredential.user);
    return userCredential;
}
/**
 * Asynchronously signs in using an email and password.
 *
 * @remarks
 * Fails with an error if the email address and password do not match. When
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, this method fails with "auth/invalid-credential" in case of an invalid
 * email/password.
 *
 * This method is not supported on {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: The user's password is NOT the password used to access the user's email account. The
 * email address serves as a unique identifier for the user, and the password is used to access
 * the user's account in your Firebase project. See also: {@link createUserWithEmailAndPassword}.
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The users email address.
 * @param password - The users password.
 *
 * @public
 */ function signInWithEmailAndPassword(auth, email, password) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    return signInWithCredential((0, _util.getModularInstance)(auth), EmailAuthProvider.credential(email, password)).catch(async (error)=>{
        if (error.code === `auth/${"password-does-not-meet-requirements" /* AuthErrorCode.PASSWORD_DOES_NOT_MEET_REQUIREMENTS */ }`) recachePasswordPolicy(auth);
        throw error;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sends a sign-in email link to the user with the specified email.
 *
 * @remarks
 * The sign-in operation has to always be completed in the app unlike other out of band email
 * actions (password reset and email verifications). This is because, at the end of the flow,
 * the user is expected to be signed in and their Auth state persisted within the app.
 *
 * To complete sign in with the email link, call {@link signInWithEmailLink} with the email
 * address and the email link supplied in the email sent to the user.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 * @param authInternal - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function sendSignInLinkToEmail(auth, email, actionCodeSettings) {
    const authInternal = _castAuth(auth);
    const request = {
        requestType: "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ,
        email,
        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
    };
    function setActionCodeSettings(request, actionCodeSettings) {
        _assert(actionCodeSettings.handleCodeInApp, authInternal, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (actionCodeSettings) _setActionCodeSettingsOnRequest(authInternal, request, actionCodeSettings);
    }
    setActionCodeSettings(request, actionCodeSettings);
    await handleRecaptchaFlow(authInternal, request, "getOobCode" /* RecaptchaActionName.GET_OOB_CODE */ , sendSignInLinkToEmail$1, "EMAIL_PASSWORD_PROVIDER" /* RecaptchaAuthProvider.EMAIL_PASSWORD_PROVIDER */ );
}
/**
 * Checks if an incoming link is a sign-in with email link suitable for {@link signInWithEmailLink}.
 *
 * @param auth - The {@link Auth} instance.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ function isSignInWithEmailLink(auth, emailLink) {
    const actionCodeUrl = ActionCodeURL.parseLink(emailLink);
    return actionCodeUrl?.operation === "EMAIL_SIGNIN" /* ActionCodeOperation.EMAIL_SIGNIN */ ;
}
/**
 * Asynchronously signs in using an email and sign-in email link.
 *
 * @remarks
 * If no link is passed, the link is inferred from the current URL.
 *
 * Fails with an error if the email address is invalid or OTP in email link expires.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * Note: Confirm the link is a sign-in email link before calling this method firebase.auth.Auth.isSignInWithEmailLink.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendSignInLinkToEmail(auth, 'user@example.com', actionCodeSettings);
 * // Obtain emailLink from the user.
 * if(isSignInWithEmailLink(auth, emailLink)) {
 *   await signInWithEmailLink(auth, 'user@example.com', emailLink);
 * }
 * ```
 *
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 * @param emailLink - The link sent to the user's email address.
 *
 * @public
 */ async function signInWithEmailLink(auth, email, emailLink) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authModular = (0, _util.getModularInstance)(auth);
    const credential = EmailAuthProvider.credentialWithLink(email, emailLink || _getCurrentUrl());
    // Check if the tenant ID in the email link matches the tenant ID on Auth
    // instance.
    _assert(credential._tenantId === (authModular.tenantId || null), authModular, "tenant-id-mismatch" /* AuthErrorCode.TENANT_ID_MISMATCH */ );
    return signInWithCredential(authModular, credential);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function createAuthUri(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:createAuthUri" /* Endpoint.CREATE_AUTH_URI */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Gets the list of possible sign in methods for the given email address. This method returns an
 * empty list when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled, irrespective of the number of authentication methods available for the given email.
 *
 * @remarks
 * This is useful to differentiate methods of sign-in for the same provider, eg.
 * {@link EmailAuthProvider} which has 2 methods of sign-in,
 * {@link SignInMethod}.EMAIL_PASSWORD and
 * {@link SignInMethod}.EMAIL_LINK.
 *
 * @param auth - The {@link Auth} instance.
 * @param email - The user's email address.
 *
 * Deprecated. Migrating off of this method is recommended as a security best-practice.
 * Learn more in the Identity Platform documentation for
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}.
 * @public
 */ async function fetchSignInMethodsForEmail(auth, email) {
    // createAuthUri returns an error if continue URI is not http or https.
    // For environments like Cordova, Chrome extensions, native frameworks, file
    // systems, etc, use http://localhost as continue URL.
    const continueUri = _isHttpOrHttps() ? _getCurrentUrl() : 'http://localhost';
    const request = {
        identifier: email,
        continueUri
    };
    const { signinMethods } = await createAuthUri((0, _util.getModularInstance)(auth), request);
    return signinMethods || [];
}
/**
 * Sends a verification email to a user.
 *
 * @remarks
 * The verification process is completed by calling {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await sendEmailVerification(user, actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function sendEmailVerification(user, actionCodeSettings) {
    const userInternal = (0, _util.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_EMAIL" /* ActionCodeOperation.VERIFY_EMAIL */ ,
        idToken
    };
    if (actionCodeSettings) _setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email } = await sendEmailVerification$1(userInternal.auth, request);
    if (email !== user.email) await user.reload();
}
/**
 * Sends a verification email to a new email address.
 *
 * @remarks
 * The user's email will be updated to the new one after being verified.
 *
 * If you have a custom email action handler, you can complete the verification process by calling
 * {@link applyActionCode}.
 *
 * @example
 * ```javascript
 * const actionCodeSettings = {
 *   url: 'https://www.example.com/?email=user@example.com',
 *   iOS: {
 *      bundleId: 'com.example.ios'
 *   },
 *   android: {
 *     packageName: 'com.example.android',
 *     installApp: true,
 *     minimumVersion: '12'
 *   },
 *   handleCodeInApp: true
 * };
 * await verifyBeforeUpdateEmail(user, 'newemail@example.com', actionCodeSettings);
 * // Obtain code from the user.
 * await applyActionCode(auth, code);
 * ```
 *
 * @param user - The user.
 * @param newEmail - The new email address to be verified before update.
 * @param actionCodeSettings - The {@link ActionCodeSettings}.
 *
 * @public
 */ async function verifyBeforeUpdateEmail(user, newEmail, actionCodeSettings) {
    const userInternal = (0, _util.getModularInstance)(user);
    const idToken = await user.getIdToken();
    const request = {
        requestType: "VERIFY_AND_CHANGE_EMAIL" /* ActionCodeOperation.VERIFY_AND_CHANGE_EMAIL */ ,
        idToken,
        newEmail
    };
    if (actionCodeSettings) _setActionCodeSettingsOnRequest(userInternal.auth, request, actionCodeSettings);
    const { email } = await verifyAndChangeEmail(userInternal.auth, request);
    if (email !== user.email) // If the local copy of the email on user is outdated, reload the
    // user.
    await user.reload();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function updateProfile$1(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v1/accounts:update" /* Endpoint.SET_ACCOUNT_INFO */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates a user's profile data.
 *
 * @param user - The user.
 * @param profile - The profile's `displayName` and `photoURL` to update.
 *
 * @public
 */ async function updateProfile(user, { displayName, photoURL: photoUrl }) {
    if (displayName === undefined && photoUrl === undefined) return;
    const userInternal = (0, _util.getModularInstance)(user);
    const idToken = await userInternal.getIdToken();
    const profileRequest = {
        idToken,
        displayName,
        photoUrl,
        returnSecureToken: true
    };
    const response = await _logoutIfInvalidated(userInternal, updateProfile$1(userInternal.auth, profileRequest));
    userInternal.displayName = response.displayName || null;
    userInternal.photoURL = response.photoUrl || null;
    // Update the password provider as well
    const passwordProvider = userInternal.providerData.find(({ providerId })=>providerId === "password" /* ProviderId.PASSWORD */ );
    if (passwordProvider) {
        passwordProvider.displayName = userInternal.displayName;
        passwordProvider.photoURL = userInternal.photoURL;
    }
    await userInternal._updateTokensIfNecessary(response);
}
/**
 * Updates the user's email address.
 *
 * @remarks
 * An email will be sent to the original email address (if it was set) that allows to revoke the
 * email address change, in order to protect them from account hijacking.
 *
 * This method is not supported on any {@link User} signed in by {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newEmail - The new email address.
 *
 * Throws "auth/operation-not-allowed" error when
 * {@link https://cloud.google.com/identity-platform/docs/admin/email-enumeration-protection | Email Enumeration Protection}
 * is enabled.
 * Deprecated - Use {@link verifyBeforeUpdateEmail} instead.
 *
 * @public
 */ function updateEmail(user, newEmail) {
    const userInternal = (0, _util.getModularInstance)(user);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    return updateEmailOrPassword(userInternal, newEmail, null);
}
/**
 * Updates the user's password.
 *
 * @remarks
 * Important: this is a security sensitive operation that requires the user to have recently signed
 * in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 * @param newPassword - The new password.
 *
 * @public
 */ function updatePassword(user, newPassword) {
    return updateEmailOrPassword((0, _util.getModularInstance)(user), null, newPassword);
}
async function updateEmailOrPassword(user, email, password) {
    const { auth } = user;
    const idToken = await user.getIdToken();
    const request = {
        idToken,
        returnSecureToken: true
    };
    if (email) request.email = email;
    if (password) request.password = password;
    const response = await _logoutIfInvalidated(user, updateEmailPassword(auth, request));
    await user._updateTokensIfNecessary(response, /* reload */ true);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Parse the `AdditionalUserInfo` from the ID token response.
 *
 */ function _fromIdTokenResponse(idTokenResponse) {
    if (!idTokenResponse) return null;
    const { providerId } = idTokenResponse;
    const profile = idTokenResponse.rawUserInfo ? JSON.parse(idTokenResponse.rawUserInfo) : {};
    const isNewUser = idTokenResponse.isNewUser || idTokenResponse.kind === "identitytoolkit#SignupNewUserResponse" /* IdTokenResponseKind.SignupNewUser */ ;
    if (!providerId && idTokenResponse?.idToken) {
        const signInProvider = _parseToken(idTokenResponse.idToken)?.firebase?.['sign_in_provider'];
        if (signInProvider) {
            const filteredProviderId = signInProvider !== "anonymous" /* ProviderId.ANONYMOUS */  && signInProvider !== "custom" /* ProviderId.CUSTOM */  ? signInProvider : null;
            // Uses generic class in accordance with the legacy SDK.
            return new GenericAdditionalUserInfo(isNewUser, filteredProviderId);
        }
    }
    if (!providerId) return null;
    switch(providerId){
        case "facebook.com" /* ProviderId.FACEBOOK */ :
            return new FacebookAdditionalUserInfo(isNewUser, profile);
        case "github.com" /* ProviderId.GITHUB */ :
            return new GithubAdditionalUserInfo(isNewUser, profile);
        case "google.com" /* ProviderId.GOOGLE */ :
            return new GoogleAdditionalUserInfo(isNewUser, profile);
        case "twitter.com" /* ProviderId.TWITTER */ :
            return new TwitterAdditionalUserInfo(isNewUser, profile, idTokenResponse.screenName || null);
        case "custom" /* ProviderId.CUSTOM */ :
        case "anonymous" /* ProviderId.ANONYMOUS */ :
            return new GenericAdditionalUserInfo(isNewUser, null);
        default:
            return new GenericAdditionalUserInfo(isNewUser, providerId, profile);
    }
}
class GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile = {}){
        this.isNewUser = isNewUser;
        this.providerId = providerId;
        this.profile = profile;
    }
}
class FederatedAdditionalUserInfoWithUsername extends GenericAdditionalUserInfo {
    constructor(isNewUser, providerId, profile, username){
        super(isNewUser, providerId, profile);
        this.username = username;
    }
}
class FacebookAdditionalUserInfo extends GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "facebook.com" /* ProviderId.FACEBOOK */ , profile);
    }
}
class GithubAdditionalUserInfo extends FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile){
        super(isNewUser, "github.com" /* ProviderId.GITHUB */ , profile, typeof profile?.login === 'string' ? profile?.login : null);
    }
}
class GoogleAdditionalUserInfo extends GenericAdditionalUserInfo {
    constructor(isNewUser, profile){
        super(isNewUser, "google.com" /* ProviderId.GOOGLE */ , profile);
    }
}
class TwitterAdditionalUserInfo extends FederatedAdditionalUserInfoWithUsername {
    constructor(isNewUser, profile, screenName){
        super(isNewUser, "twitter.com" /* ProviderId.TWITTER */ , profile, screenName);
    }
}
/**
 * Extracts provider specific {@link AdditionalUserInfo} for the given credential.
 *
 * @param userCredential - The user credential.
 *
 * @public
 */ function getAdditionalUserInfo(userCredential) {
    const { user, _tokenResponse } = userCredential;
    if (user.isAnonymous && !_tokenResponse) // Handle the special case where signInAnonymously() gets called twice.
    // No network call is made so there's nothing to actually fill this in
    return {
        providerId: null,
        isNewUser: false,
        profile: null
    };
    return _fromIdTokenResponse(_tokenResponse);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Non-optional auth methods.
/**
 * Changes the type of persistence on the {@link Auth} instance for the currently saved
 * `Auth` session and applies this type of persistence for future sign-in requests, including
 * sign-in with redirect requests.
 *
 * @remarks
 * This makes it easy for a user signing in to specify whether their session should be
 * remembered or not. It also makes it easier to never persist the `Auth` state for applications
 * that are shared by other users or have sensitive data.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * setPersistence(auth, browserSessionPersistence);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param persistence - The {@link Persistence} to use.
 * @returns A `Promise` that resolves once the persistence change has completed
 *
 * @public
 */ function setPersistence(auth, persistence) {
    return (0, _util.getModularInstance)(auth).setPersistence(persistence);
}
/**
 * Loads the reCAPTCHA configuration into the `Auth` instance.
 *
 * @remarks
 * This will load the reCAPTCHA config, which indicates whether the reCAPTCHA
 * verification flow should be triggered for each auth provider, into the
 * current Auth session.
 *
 * If initializeRecaptchaConfig() is not invoked, the auth flow will always start
 * without reCAPTCHA verification. If the provider is configured to require reCAPTCHA
 * verification, the SDK will transparently load the reCAPTCHA config and restart the
 * auth flows.
 *
 * Thus, by calling this optional method, you will reduce the latency of future auth flows.
 * Loading the reCAPTCHA config early will also enhance the signal collected by reCAPTCHA.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * initializeRecaptchaConfig(auth);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function initializeRecaptchaConfig(auth) {
    return _initializeRecaptchaConfig(auth);
}
/**
 * Validates the password against the password policy configured for the project or tenant.
 *
 * @remarks
 * If no tenant ID is set on the `Auth` instance, then this method will use the password
 * policy configured for the project. Otherwise, this method will use the policy configured
 * for the tenant. If a password policy has not been configured, then the default policy
 * configured for all projects will be used.
 *
 * If an auth flow fails because a submitted password does not meet the password policy
 * requirements and this method has previously been called, then this method will use the
 * most recent policy available when called again.
 *
 * @example
 * ```javascript
 * validatePassword(auth, 'some-password');
 * ```
 *
 * @param auth The {@link Auth} instance.
 * @param password The password to validate.
 *
 * @public
 */ async function validatePassword(auth, password) {
    const authInternal = _castAuth(auth);
    return authInternal.validatePassword(password);
}
/**
 * Adds an observer for changes to the signed-in user's ID token.
 *
 * @remarks
 * This includes sign-in, sign-out, and token refresh events.
 * This will not be triggered automatically upon ID token expiration. Use {@link User.getIdToken} to refresh the ID token.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function onIdTokenChanged(auth, nextOrObserver, error, completed) {
    return (0, _util.getModularInstance)(auth).onIdTokenChanged(nextOrObserver, error, completed);
}
/**
 * Adds a blocking callback that runs before an auth state change
 * sets a new user.
 *
 * @param auth - The {@link Auth} instance.
 * @param callback - callback triggered before new user value is set.
 *   If this throws, it blocks the user from being set.
 * @param onAbort - callback triggered if a later `beforeAuthStateChanged()`
 *   callback throws, allowing you to undo any side effects.
 */ function beforeAuthStateChanged(auth, callback, onAbort) {
    return (0, _util.getModularInstance)(auth).beforeAuthStateChanged(callback, onAbort);
}
/**
 * Adds an observer for changes to the user's sign-in state.
 *
 * @remarks
 * To keep the old behavior, see {@link onIdTokenChanged}.
 *
 * @param auth - The {@link Auth} instance.
 * @param nextOrObserver - callback triggered on change.
 * @param error - Deprecated. This callback is never triggered. Errors
 * on signing in/out can be caught in promises returned from
 * sign-in/sign-out functions.
 * @param completed - Deprecated. This callback is never triggered.
 *
 * @public
 */ function onAuthStateChanged(auth, nextOrObserver, error, completed) {
    return (0, _util.getModularInstance)(auth).onAuthStateChanged(nextOrObserver, error, completed);
}
/**
 * Sets the current language to the default device/browser preference.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function useDeviceLanguage(auth) {
    (0, _util.getModularInstance)(auth).useDeviceLanguage();
}
/**
 * Asynchronously sets the provided user as {@link Auth.currentUser} on the
 * {@link Auth} instance.
 *
 * @remarks
 * A new instance copy of the user provided will be made and set as currentUser.
 *
 * This will trigger {@link onAuthStateChanged} and {@link onIdTokenChanged} listeners
 * like other sign in methods.
 *
 * The operation fails with an error if the user to be updated belongs to a different Firebase
 * project.
 *
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 * @param user - The new {@link User}.
 *
 * @public
 */ function updateCurrentUser(auth, user) {
    return (0, _util.getModularInstance)(auth).updateCurrentUser(user);
}
/**
 * Signs out the current user.
 *
 * @remarks
 * This method is not supported by {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @param auth - The {@link Auth} instance.
 *
 * @public
 */ function signOut(auth) {
    return (0, _util.getModularInstance)(auth).signOut();
}
/**
 * Revokes the given access token. Currently only supports Apple OAuth access tokens.
 *
 * @param auth - The {@link Auth} instance.
 * @param token - The Apple OAuth access token.
 *
 * @public
 */ function revokeAccessToken(auth, token) {
    const authInternal = _castAuth(auth);
    return authInternal.revokeAccessToken(token);
}
/**
 * Deletes and signs out the user.
 *
 * @remarks
 * Important: this is a security-sensitive operation that requires the user to have recently
 * signed in. If this requirement isn't met, ask the user to authenticate again and then call
 * {@link reauthenticateWithCredential}.
 *
 * @param user - The user.
 *
 * @public
 */ async function deleteUser(user) {
    return (0, _util.getModularInstance)(user).delete();
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MultiFactorSessionImpl {
    constructor(type, credential, user){
        this.type = type;
        this.credential = credential;
        this.user = user;
    }
    static _fromIdtoken(idToken, user) {
        return new MultiFactorSessionImpl("enroll" /* MultiFactorSessionType.ENROLL */ , idToken, user);
    }
    static _fromMfaPendingCredential(mfaPendingCredential) {
        return new MultiFactorSessionImpl("signin" /* MultiFactorSessionType.SIGN_IN */ , mfaPendingCredential);
    }
    toJSON() {
        const key = this.type === "enroll" /* MultiFactorSessionType.ENROLL */  ? 'idToken' : 'pendingCredential';
        return {
            multiFactorSession: {
                [key]: this.credential
            }
        };
    }
    static fromJSON(obj) {
        if (obj?.multiFactorSession) {
            if (obj.multiFactorSession?.pendingCredential) return MultiFactorSessionImpl._fromMfaPendingCredential(obj.multiFactorSession.pendingCredential);
            else if (obj.multiFactorSession?.idToken) return MultiFactorSessionImpl._fromIdtoken(obj.multiFactorSession.idToken);
        }
        return null;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MultiFactorResolverImpl {
    constructor(session, hints, signInResolver){
        this.session = session;
        this.hints = hints;
        this.signInResolver = signInResolver;
    }
    /** @internal */ static _fromError(authExtern, error) {
        const auth = _castAuth(authExtern);
        const serverResponse = error.customData._serverResponse;
        const hints = (serverResponse.mfaInfo || []).map((enrollment)=>MultiFactorInfoImpl._fromServerResponse(auth, enrollment));
        _assert(serverResponse.mfaPendingCredential, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const session = MultiFactorSessionImpl._fromMfaPendingCredential(serverResponse.mfaPendingCredential);
        return new MultiFactorResolverImpl(session, hints, async (assertion)=>{
            const mfaResponse = await assertion._process(auth, session);
            // Clear out the unneeded fields from the old login response
            delete serverResponse.mfaInfo;
            delete serverResponse.mfaPendingCredential;
            // Use in the new token & refresh token in the old response
            const idTokenResponse = {
                ...serverResponse,
                idToken: mfaResponse.idToken,
                refreshToken: mfaResponse.refreshToken
            };
            // TODO: we should collapse this switch statement into UserCredentialImpl._forOperation and have it support the SIGN_IN case
            switch(error.operationType){
                case "signIn" /* OperationType.SIGN_IN */ :
                    const userCredential = await UserCredentialImpl._fromIdTokenResponse(auth, error.operationType, idTokenResponse);
                    await auth._updateCurrentUser(userCredential.user);
                    return userCredential;
                case "reauthenticate" /* OperationType.REAUTHENTICATE */ :
                    _assert(error.user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                    return UserCredentialImpl._forOperation(error.user, error.operationType, idTokenResponse);
                default:
                    _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
            }
        });
    }
    async resolveSignIn(assertionExtern) {
        const assertion = assertionExtern;
        return this.signInResolver(assertion);
    }
}
/**
 * Provides a {@link MultiFactorResolver} suitable for completion of a
 * multi-factor flow.
 *
 * @param auth - The {@link Auth} instance.
 * @param error - The {@link MultiFactorError} raised during a sign-in, or
 * reauthentication operation.
 *
 * @public
 */ function getMultiFactorResolver(auth, error) {
    const authModular = (0, _util.getModularInstance)(auth);
    const errorInternal = error;
    _assert(error.customData.operationType, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    _assert(errorInternal.customData._serverResponse?.mfaPendingCredential, authModular, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return MultiFactorResolverImpl._fromError(authModular, errorInternal);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function startEnrollPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , _addTidIfNecessary(auth, request));
}
function finalizeEnrollPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , _addTidIfNecessary(auth, request));
}
function startEnrollTotpMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:start" /* Endpoint.START_MFA_ENROLLMENT */ , _addTidIfNecessary(auth, request));
}
function finalizeEnrollTotpMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:finalize" /* Endpoint.FINALIZE_MFA_ENROLLMENT */ , _addTidIfNecessary(auth, request));
}
function withdrawMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaEnrollment:withdraw" /* Endpoint.WITHDRAW_MFA */ , _addTidIfNecessary(auth, request));
}
class MultiFactorUserImpl {
    constructor(user){
        this.user = user;
        this.enrolledFactors = [];
        user._onReload((userInfo)=>{
            if (userInfo.mfaInfo) this.enrolledFactors = userInfo.mfaInfo.map((enrollment)=>MultiFactorInfoImpl._fromServerResponse(user.auth, enrollment));
        });
    }
    static _fromUser(user) {
        return new MultiFactorUserImpl(user);
    }
    async getSession() {
        return MultiFactorSessionImpl._fromIdtoken(await this.user.getIdToken(), this.user);
    }
    async enroll(assertionExtern, displayName) {
        const assertion = assertionExtern;
        const session = await this.getSession();
        const finalizeMfaResponse = await _logoutIfInvalidated(this.user, assertion._process(this.user.auth, session, displayName));
        // New tokens will be issued after enrollment of the new second factors.
        // They need to be updated on the user.
        await this.user._updateTokensIfNecessary(finalizeMfaResponse);
        // The user needs to be reloaded to get the new multi-factor information
        // from server. USER_RELOADED event will be triggered and `enrolledFactors`
        // will be updated.
        return this.user.reload();
    }
    async unenroll(infoOrUid) {
        const mfaEnrollmentId = typeof infoOrUid === 'string' ? infoOrUid : infoOrUid.uid;
        const idToken = await this.user.getIdToken();
        try {
            const idTokenResponse = await _logoutIfInvalidated(this.user, withdrawMfa(this.user.auth, {
                idToken,
                mfaEnrollmentId
            }));
            // Remove the second factor from the user's list.
            this.enrolledFactors = this.enrolledFactors.filter(({ uid })=>uid !== mfaEnrollmentId);
            // Depending on whether the backend decided to revoke the user's session,
            // the tokenResponse may be empty. If the tokens were not updated (and they
            // are now invalid), reloading the user will discover this and invalidate
            // the user's state accordingly.
            await this.user._updateTokensIfNecessary(idTokenResponse);
            await this.user.reload();
        } catch (e) {
            throw e;
        }
    }
}
const multiFactorUserCache = new WeakMap();
/**
 * The {@link MultiFactorUser} corresponding to the user.
 *
 * @remarks
 * This is used to access all multi-factor properties and operations related to the user.
 *
 * @param user - The user.
 *
 * @public
 */ function multiFactor(user) {
    const userModular = (0, _util.getModularInstance)(user);
    if (!multiFactorUserCache.has(userModular)) multiFactorUserCache.set(userModular, MultiFactorUserImpl._fromUser(userModular));
    return multiFactorUserCache.get(userModular);
}
const STORAGE_AVAILABLE_KEY = '__sak';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // There are two different browser persistence types: local and session.
// Both have the same implementation but use a different underlying storage
// object.
class BrowserPersistenceClass {
    constructor(storageRetriever, type){
        this.storageRetriever = storageRetriever;
        this.type = type;
    }
    _isAvailable() {
        try {
            if (!this.storage) return Promise.resolve(false);
            this.storage.setItem(STORAGE_AVAILABLE_KEY, '1');
            this.storage.removeItem(STORAGE_AVAILABLE_KEY);
            return Promise.resolve(true);
        } catch  {
            return Promise.resolve(false);
        }
    }
    _set(key, value) {
        this.storage.setItem(key, JSON.stringify(value));
        return Promise.resolve();
    }
    _get(key) {
        const json = this.storage.getItem(key);
        return Promise.resolve(json ? JSON.parse(json) : null);
    }
    _remove(key) {
        this.storage.removeItem(key);
        return Promise.resolve();
    }
    get storage() {
        return this.storageRetriever();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The polling period in case events are not supported
const _POLLING_INTERVAL_MS$1 = 1000;
// The IE 10 localStorage cross tab synchronization delay in milliseconds
const IE10_LOCAL_STORAGE_SYNC_DELAY = 10;
class BrowserLocalPersistence extends BrowserPersistenceClass {
    constructor(){
        super(()=>window.localStorage, "LOCAL" /* PersistenceType.LOCAL */ );
        this.boundEventHandler = (event, poll)=>this.onStorageEvent(event, poll);
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        // Whether to use polling instead of depending on window events
        this.fallbackToPolling = _isMobileBrowser();
        this._shouldAllowMigration = true;
    }
    forAllChangedKeys(cb) {
        // Check all keys with listeners on them.
        for (const key of Object.keys(this.listeners)){
            // Get value from localStorage.
            const newValue = this.storage.getItem(key);
            const oldValue = this.localCache[key];
            // If local map value does not match, trigger listener with storage event.
            // Differentiate this simulated event from the real storage event.
            if (newValue !== oldValue) cb(key, oldValue, newValue);
        }
    }
    onStorageEvent(event, poll = false) {
        // Key would be null in some situations, like when localStorage is cleared
        if (!event.key) {
            this.forAllChangedKeys((key, _oldValue, newValue)=>{
                this.notifyListeners(key, newValue);
            });
            return;
        }
        const key = event.key;
        // Check the mechanism how this event was detected.
        // The first event will dictate the mechanism to be used.
        if (poll) // Environment detects storage changes via polling.
        // Remove storage event listener to prevent possible event duplication.
        this.detachListener();
        else // Environment detects storage changes via storage event listener.
        // Remove polling listener to prevent possible event duplication.
        this.stopPolling();
        const triggerListeners = ()=>{
            // Keep local map up to date in case storage event is triggered before
            // poll.
            const storedValue = this.storage.getItem(key);
            if (!poll && this.localCache[key] === storedValue) // Real storage event which has already been detected, do nothing.
            // This seems to trigger in some IE browsers for some reason.
            return;
            this.notifyListeners(key, storedValue);
        };
        const storedValue = this.storage.getItem(key);
        if (_isIE10() && storedValue !== event.newValue && event.newValue !== event.oldValue) // IE 10 has this weird bug where a storage event would trigger with the
        // correct key, oldValue and newValue but localStorage.getItem(key) does
        // not yield the updated value until a few milliseconds. This ensures
        // this recovers from that situation.
        setTimeout(triggerListeners, IE10_LOCAL_STORAGE_SYNC_DELAY);
        else triggerListeners();
    }
    notifyListeners(key, value) {
        this.localCache[key] = value;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(value ? JSON.parse(value) : value);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(()=>{
            this.forAllChangedKeys((key, oldValue, newValue)=>{
                this.onStorageEvent(new StorageEvent('storage', {
                    key,
                    oldValue,
                    newValue
                }), /* poll */ true);
            });
        }, _POLLING_INTERVAL_MS$1);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    attachListener() {
        window.addEventListener('storage', this.boundEventHandler);
    }
    detachListener() {
        window.removeEventListener('storage', this.boundEventHandler);
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) {
            // Whether browser can detect storage event when it had already been pushed to the background.
            // This may happen in some mobile browsers. A localStorage change in the foreground window
            // will not be detected in the background window via the storage event.
            // This was detected in iOS 7.x mobile browsers
            if (this.fallbackToPolling) this.startPolling();
            else this.attachListener();
        }
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this.localCache[key] = this.storage.getItem(key);
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) {
            this.detachListener();
            this.stopPolling();
        }
    }
    // Update local cache on base operations:
    async _set(key, value) {
        await super._set(key, value);
        this.localCache[key] = JSON.stringify(value);
    }
    async _get(key) {
        const value = await super._get(key);
        this.localCache[key] = JSON.stringify(value);
        return value;
    }
    async _remove(key) {
        await super._remove(key);
        delete this.localCache[key];
    }
}
BrowserLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `localStorage`
 * for the underlying storage.
 *
 * @public
 */ const browserLocalPersistence = BrowserLocalPersistence;
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const POLLING_INTERVAL_MS = 1000;
// Pull a cookie value from document.cookie
function getDocumentCookie(name) {
    const escapedName = name.replace(/[\\^$.*+?()[\]{}|]/g, '\\$&');
    const matcher = RegExp(`${escapedName}=([^;]+)`);
    return document.cookie.match(matcher)?.[1] ?? null;
}
// Produce a sanitized cookie name from the persistence key
function getCookieName(key) {
    // __HOST- doesn't work in localhost https://issues.chromium.org/issues/40196122 but it has
    // desirable security properties, so lets use a different cookie name while in dev-mode.
    // Already checked isSecureContext in _isAvailable, so if it's http we're hitting local.
    const isDevMode = window.location.protocol === 'http:';
    return `${isDevMode ? '__dev_' : '__HOST-'}FIREBASE_${key.split(':')[3]}`;
}
class CookiePersistence {
    constructor(){
        this.type = "COOKIE" /* PersistenceType.COOKIE */ ;
        this.listenerUnsubscribes = new Map();
    }
    // used to get the URL to the backend to proxy to
    _getFinalTarget(originalUrl) {
        const url = new URL(`${window.location.origin}/__cookies__`);
        url.searchParams.set('finalTarget', originalUrl);
        return url;
    }
    // To be a usable persistence method in a chain browserCookiePersistence ensures that
    // prerequisites have been met, namely that we're in a secureContext, navigator and document are
    // available and cookies are enabled. Not all UAs support these method, so fallback accordingly.
    async _isAvailable() {
        if (typeof isSecureContext === 'boolean' && !isSecureContext) return false;
        if (typeof navigator === 'undefined' || typeof document === 'undefined') return false;
        return navigator.cookieEnabled ?? true;
    }
    // Set should be a noop as we expect middleware to handle this
    async _set(_key, _value) {
        return;
    }
    // Attempt to get the cookie from cookieStore, fallback to document.cookie
    async _get(key) {
        if (!this._isAvailable()) return null;
        const name = getCookieName(key);
        if (window.cookieStore) {
            const cookie = await window.cookieStore.get(name);
            return cookie?.value;
        }
        return getDocumentCookie(name);
    }
    // Log out by overriding the idToken with a sentinel value of ""
    async _remove(key) {
        if (!this._isAvailable()) return;
        // To make sure we don't hit signout over and over again, only do this operation if we need to
        // with the logout sentinel value of "" this can cause race conditions. Unnecessary set-cookie
        // headers will reduce CDN hit rates too.
        const existingValue = await this._get(key);
        if (!existingValue) return;
        const name = getCookieName(key);
        document.cookie = `${name}=;Max-Age=34560000;Partitioned;Secure;SameSite=Strict;Path=/;Priority=High`;
        await fetch(`/__cookies__`, {
            method: 'DELETE'
        }).catch(()=>undefined);
    }
    // Listen for cookie changes, both cookieStore and fallback to polling document.cookie
    _addListener(key, listener) {
        if (!this._isAvailable()) return;
        const name = getCookieName(key);
        if (window.cookieStore) {
            const cb = (event)=>{
                const changedCookie = event.changed.find((change)=>change.name === name);
                if (changedCookie) listener(changedCookie.value);
                const deletedCookie = event.deleted.find((change)=>change.name === name);
                if (deletedCookie) listener(null);
            };
            const unsubscribe = ()=>window.cookieStore.removeEventListener('change', cb);
            this.listenerUnsubscribes.set(listener, unsubscribe);
            return window.cookieStore.addEventListener('change', cb);
        }
        let lastValue = getDocumentCookie(name);
        const interval = setInterval(()=>{
            const currentValue = getDocumentCookie(name);
            if (currentValue !== lastValue) {
                listener(currentValue);
                lastValue = currentValue;
            }
        }, POLLING_INTERVAL_MS);
        const unsubscribe = ()=>clearInterval(interval);
        this.listenerUnsubscribes.set(listener, unsubscribe);
    }
    _removeListener(_key, listener) {
        const unsubscribe = this.listenerUnsubscribes.get(listener);
        if (!unsubscribe) return;
        unsubscribe();
        this.listenerUnsubscribes.delete(listener);
    }
}
CookiePersistence.type = 'COOKIE';
/**
 * An implementation of {@link Persistence} of type `COOKIE`, for use on the client side in
 * applications leveraging hybrid rendering and middleware.
 *
 * @remarks This persistence method requires companion middleware to function, such as that provided
 * by {@link https://firebaseopensource.com/projects/firebaseextended/reactfire/ | ReactFire} for
 * NextJS.
 * @beta
 */ const browserCookiePersistence = CookiePersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class BrowserSessionPersistence extends BrowserPersistenceClass {
    constructor(){
        super(()=>window.sessionStorage, "SESSION" /* PersistenceType.SESSION */ );
    }
    _addListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
    _removeListener(_key, _listener) {
        // Listeners are not supported for session storage since it cannot be shared across windows
        return;
    }
}
BrowserSessionPersistence.type = 'SESSION';
/**
 * An implementation of {@link Persistence} of `SESSION` using `sessionStorage`
 * for the underlying storage.
 *
 * @public
 */ const browserSessionPersistence = BrowserSessionPersistence;
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Shim for Promise.allSettled, note the slightly different format of `fulfilled` vs `status`.
 *
 * @param promises - Array of promises to wait on.
 */ function _allSettled(promises) {
    return Promise.all(promises.map(async (promise)=>{
        try {
            const value = await promise;
            return {
                fulfilled: true,
                value
            };
        } catch (reason) {
            return {
                fulfilled: false,
                reason
            };
        }
    }));
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface class for receiving messages.
 *
 */ class Receiver {
    constructor(eventTarget){
        this.eventTarget = eventTarget;
        this.handlersMap = {};
        this.boundEventHandler = this.handleEvent.bind(this);
    }
    /**
     * Obtain an instance of a Receiver for a given event target, if none exists it will be created.
     *
     * @param eventTarget - An event target (such as window or self) through which the underlying
     * messages will be received.
     */ static _getInstance(eventTarget) {
        // The results are stored in an array since objects can't be keys for other
        // objects. In addition, setting a unique property on an event target as a
        // hash map key may not be allowed due to CORS restrictions.
        const existingInstance = this.receivers.find((receiver)=>receiver.isListeningto(eventTarget));
        if (existingInstance) return existingInstance;
        const newInstance = new Receiver(eventTarget);
        this.receivers.push(newInstance);
        return newInstance;
    }
    isListeningto(eventTarget) {
        return this.eventTarget === eventTarget;
    }
    /**
     * Fans out a MessageEvent to the appropriate listeners.
     *
     * @remarks
     * Sends an {@link Status.ACK} upon receipt and a {@link Status.DONE} once all handlers have
     * finished processing.
     *
     * @param event - The MessageEvent.
     *
     */ async handleEvent(event) {
        const messageEvent = event;
        const { eventId, eventType, data } = messageEvent.data;
        const handlers = this.handlersMap[eventType];
        if (!handlers?.size) return;
        messageEvent.ports[0].postMessage({
            status: "ack" /* _Status.ACK */ ,
            eventId,
            eventType
        });
        const promises = Array.from(handlers).map(async (handler)=>handler(messageEvent.origin, data));
        const response = await _allSettled(promises);
        messageEvent.ports[0].postMessage({
            status: "done" /* _Status.DONE */ ,
            eventId,
            eventType,
            response
        });
    }
    /**
     * Subscribe an event handler for a particular event.
     *
     * @param eventType - Event name to subscribe to.
     * @param eventHandler - The event handler which should receive the events.
     *
     */ _subscribe(eventType, eventHandler) {
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.addEventListener('message', this.boundEventHandler);
        if (!this.handlersMap[eventType]) this.handlersMap[eventType] = new Set();
        this.handlersMap[eventType].add(eventHandler);
    }
    /**
     * Unsubscribe an event handler from a particular event.
     *
     * @param eventType - Event name to unsubscribe from.
     * @param eventHandler - Optional event handler, if none provided, unsubscribe all handlers on this event.
     *
     */ _unsubscribe(eventType, eventHandler) {
        if (this.handlersMap[eventType] && eventHandler) this.handlersMap[eventType].delete(eventHandler);
        if (!eventHandler || this.handlersMap[eventType].size === 0) delete this.handlersMap[eventType];
        if (Object.keys(this.handlersMap).length === 0) this.eventTarget.removeEventListener('message', this.boundEventHandler);
    }
}
Receiver.receivers = [];
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _generateEventId(prefix = '', digits = 10) {
    let random = '';
    for(let i = 0; i < digits; i++)random += Math.floor(Math.random() * 10);
    return prefix + random;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Interface for sending messages and waiting for a completion response.
 *
 */ class Sender {
    constructor(target){
        this.target = target;
        this.handlers = new Set();
    }
    /**
     * Unsubscribe the handler and remove it from our tracking Set.
     *
     * @param handler - The handler to unsubscribe.
     */ removeMessageHandler(handler) {
        if (handler.messageChannel) {
            handler.messageChannel.port1.removeEventListener('message', handler.onMessage);
            handler.messageChannel.port1.close();
        }
        this.handlers.delete(handler);
    }
    /**
     * Send a message to the Receiver located at {@link target}.
     *
     * @remarks
     * We'll first wait a bit for an ACK , if we get one we will wait significantly longer until the
     * receiver has had a chance to fully process the event.
     *
     * @param eventType - Type of event to send.
     * @param data - The payload of the event.
     * @param timeout - Timeout for waiting on an ACK from the receiver.
     *
     * @returns An array of settled promises from all the handlers that were listening on the receiver.
     */ async _send(eventType, data, timeout = 50 /* _TimeoutDuration.ACK */ ) {
        const messageChannel = typeof MessageChannel !== 'undefined' ? new MessageChannel() : null;
        if (!messageChannel) throw new Error("connection_unavailable" /* _MessageError.CONNECTION_UNAVAILABLE */ );
        // Node timers and browser timers return fundamentally different types.
        // We don't actually care what the value is but TS won't accept unknown and
        // we can't cast properly in both environments.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        let completionTimer;
        let handler;
        return new Promise((resolve, reject)=>{
            const eventId = _generateEventId('', 20);
            messageChannel.port1.start();
            const ackTimer = setTimeout(()=>{
                reject(new Error("unsupported_event" /* _MessageError.UNSUPPORTED_EVENT */ ));
            }, timeout);
            handler = {
                messageChannel,
                onMessage (event) {
                    const messageEvent = event;
                    if (messageEvent.data.eventId !== eventId) return;
                    switch(messageEvent.data.status){
                        case "ack" /* _Status.ACK */ :
                            // The receiver should ACK first.
                            clearTimeout(ackTimer);
                            completionTimer = setTimeout(()=>{
                                reject(new Error("timeout" /* _MessageError.TIMEOUT */ ));
                            }, 3000 /* _TimeoutDuration.COMPLETION */ );
                            break;
                        case "done" /* _Status.DONE */ :
                            // Once the receiver's handlers are finished we will get the results.
                            clearTimeout(completionTimer);
                            resolve(messageEvent.data.response);
                            break;
                        default:
                            clearTimeout(ackTimer);
                            clearTimeout(completionTimer);
                            reject(new Error("invalid_response" /* _MessageError.INVALID_RESPONSE */ ));
                            break;
                    }
                }
            };
            this.handlers.add(handler);
            messageChannel.port1.addEventListener('message', handler.onMessage);
            this.target.postMessage({
                eventType,
                eventId,
                data
            }, [
                messageChannel.port2
            ]);
        }).finally(()=>{
            if (handler) this.removeMessageHandler(handler);
        });
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Lazy accessor for window, since the compat layer won't tree shake this out,
 * we need to make sure not to mess with window unless we have to
 */ function _window() {
    return window;
}
function _setWindowLocation(url) {
    _window().location.href = url;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function _isWorker() {
    return typeof _window()['WorkerGlobalScope'] !== 'undefined' && typeof _window()['importScripts'] === 'function';
}
async function _getActiveServiceWorker() {
    if (!navigator?.serviceWorker) return null;
    try {
        const registration = await navigator.serviceWorker.ready;
        return registration.active;
    } catch  {
        return null;
    }
}
function _getServiceWorkerController() {
    return navigator?.serviceWorker?.controller || null;
}
function _getWorkerGlobalScope() {
    return _isWorker() ? self : null;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DB_NAME = 'firebaseLocalStorageDb';
const DB_VERSION = 1;
const DB_OBJECTSTORE_NAME = 'firebaseLocalStorage';
const DB_DATA_KEYPATH = 'fbase_key';
/**
 * Promise wrapper for IDBRequest
 *
 * Unfortunately we can't cleanly extend Promise<T> since promises are not callable in ES6
 *
 */ class DBPromise {
    constructor(request){
        this.request = request;
    }
    toPromise() {
        return new Promise((resolve, reject)=>{
            this.request.addEventListener('success', ()=>{
                resolve(this.request.result);
            });
            this.request.addEventListener('error', ()=>{
                reject(this.request.error);
            });
        });
    }
}
function getObjectStore(db, isReadWrite) {
    return db.transaction([
        DB_OBJECTSTORE_NAME
    ], isReadWrite ? 'readwrite' : 'readonly').objectStore(DB_OBJECTSTORE_NAME);
}
function _deleteDatabase() {
    const request = indexedDB.deleteDatabase(DB_NAME);
    return new DBPromise(request).toPromise();
}
function _openDatabase() {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    return new Promise((resolve, reject)=>{
        request.addEventListener('error', ()=>{
            reject(request.error);
        });
        request.addEventListener('upgradeneeded', ()=>{
            const db = request.result;
            try {
                db.createObjectStore(DB_OBJECTSTORE_NAME, {
                    keyPath: DB_DATA_KEYPATH
                });
            } catch (e) {
                reject(e);
            }
        });
        request.addEventListener('success', async ()=>{
            const db = request.result;
            // Strange bug that occurs in Firefox when multiple tabs are opened at the
            // same time. The only way to recover seems to be deleting the database
            // and re-initializing it.
            // https://github.com/firebase/firebase-js-sdk/issues/634
            if (!db.objectStoreNames.contains(DB_OBJECTSTORE_NAME)) {
                // Need to close the database or else you get a `blocked` event
                db.close();
                await _deleteDatabase();
                resolve(await _openDatabase());
            } else resolve(db);
        });
    });
}
async function _putObject(db, key, value) {
    const request = getObjectStore(db, true).put({
        [DB_DATA_KEYPATH]: key,
        value
    });
    return new DBPromise(request).toPromise();
}
async function getObject(db, key) {
    const request = getObjectStore(db, false).get(key);
    const data = await new DBPromise(request).toPromise();
    return data === undefined ? null : data.value;
}
function _deleteObject(db, key) {
    const request = getObjectStore(db, true).delete(key);
    return new DBPromise(request).toPromise();
}
const _POLLING_INTERVAL_MS = 800;
const _TRANSACTION_RETRY_COUNT = 3;
class IndexedDBLocalPersistence {
    constructor(){
        this.type = "LOCAL" /* PersistenceType.LOCAL */ ;
        this.dbPromise = null;
        this._shouldAllowMigration = true;
        this.listeners = {};
        this.localCache = {};
        // setTimeout return value is platform specific
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.pollTimer = null;
        this.pendingWrites = 0;
        this.receiver = null;
        this.sender = null;
        this.serviceWorkerReceiverAvailable = false;
        this.activeServiceWorker = null;
        // Fire & forget the service worker registration as it may never resolve
        this._workerInitializationPromise = this.initializeServiceWorkerMessaging().then(()=>{}, ()=>{});
    }
    async _openDb() {
        if (this.dbPromise) return this.dbPromise;
        this.dbPromise = _openDatabase();
        this.dbPromise.catch(()=>{
            this.dbPromise = null;
        });
        return this.dbPromise;
    }
    async _withRetries(op) {
        let numAttempts = 0;
        while(true)try {
            const db = await this._openDb();
            return await op(db);
        } catch (e) {
            if (numAttempts++ > _TRANSACTION_RETRY_COUNT) throw e;
            if (this.dbPromise) {
                const db = await this.dbPromise;
                db.close();
                this.dbPromise = null;
            }
        // TODO: consider adding exponential backoff
        }
    }
    /**
     * IndexedDB events do not propagate from the main window to the worker context.  We rely on a
     * postMessage interface to send these events to the worker ourselves.
     */ async initializeServiceWorkerMessaging() {
        return _isWorker() ? this.initializeReceiver() : this.initializeSender();
    }
    /**
     * As the worker we should listen to events from the main window.
     */ async initializeReceiver() {
        this.receiver = Receiver._getInstance(_getWorkerGlobalScope());
        // Refresh from persistence if we receive a KeyChanged message.
        this.receiver._subscribe("keyChanged" /* _EventType.KEY_CHANGED */ , async (_origin, data)=>{
            const keys = await this._poll();
            return {
                keyProcessed: keys.includes(data.key)
            };
        });
        // Let the sender know that we are listening so they give us more timeout.
        this.receiver._subscribe("ping" /* _EventType.PING */ , async (_origin, _data)=>{
            return [
                "keyChanged" /* _EventType.KEY_CHANGED */ 
            ];
        });
    }
    /**
     * As the main window, we should let the worker know when keys change (set and remove).
     *
     * @remarks
     * {@link https://developer.mozilla.org/en-US/docs/Web/API/ServiceWorkerContainer/ready | ServiceWorkerContainer.ready}
     * may not resolve.
     */ async initializeSender() {
        // Check to see if there's an active service worker.
        this.activeServiceWorker = await _getActiveServiceWorker();
        if (!this.activeServiceWorker) return;
        this.sender = new Sender(this.activeServiceWorker);
        // Ping the service worker to check what events they can handle.
        const results = await this.sender._send("ping" /* _EventType.PING */ , {}, 800 /* _TimeoutDuration.LONG_ACK */ );
        if (!results) return;
        if (results[0]?.fulfilled && results[0]?.value.includes("keyChanged" /* _EventType.KEY_CHANGED */ )) this.serviceWorkerReceiverAvailable = true;
    }
    /**
     * Let the worker know about a changed key, the exact key doesn't technically matter since the
     * worker will just trigger a full sync anyway.
     *
     * @remarks
     * For now, we only support one service worker per page.
     *
     * @param key - Storage key which changed.
     */ async notifyServiceWorker(key) {
        if (!this.sender || !this.activeServiceWorker || _getServiceWorkerController() !== this.activeServiceWorker) return;
        try {
            await this.sender._send("keyChanged" /* _EventType.KEY_CHANGED */ , {
                key
            }, // Use long timeout if receiver has previously responded to a ping from us.
            this.serviceWorkerReceiverAvailable ? 800 /* _TimeoutDuration.LONG_ACK */  : 50 /* _TimeoutDuration.ACK */ );
        } catch  {
        // This is a best effort approach. Ignore errors.
        }
    }
    async _isAvailable() {
        try {
            if (!indexedDB) return false;
            await this._withRetries(async (db)=>{
                await _putObject(db, STORAGE_AVAILABLE_KEY, '1');
                await _deleteObject(db, STORAGE_AVAILABLE_KEY);
            });
            return true;
        } catch  {}
        return false;
    }
    async _withPendingWrite(write) {
        this.pendingWrites++;
        try {
            await write();
        } finally{
            this.pendingWrites--;
        }
    }
    async _set(key, value) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>_putObject(db, key, value));
            this.localCache[key] = value;
            return this.notifyServiceWorker(key);
        });
    }
    async _get(key) {
        const obj = await this._withRetries((db)=>getObject(db, key));
        this.localCache[key] = obj;
        return obj;
    }
    async _remove(key) {
        return this._withPendingWrite(async ()=>{
            await this._withRetries((db)=>_deleteObject(db, key));
            delete this.localCache[key];
            return this.notifyServiceWorker(key);
        });
    }
    async _poll() {
        // TODO: check if we need to fallback if getAll is not supported
        const result = await this._withRetries((db)=>{
            const getAllRequest = getObjectStore(db, false).getAll();
            return new DBPromise(getAllRequest).toPromise();
        });
        if (!result) return [];
        // If we have pending writes in progress abort, we'll get picked up on the next poll
        if (this.pendingWrites !== 0) return [];
        const keys = [];
        const keysInResult = new Set();
        if (result.length !== 0) for (const { fbase_key: key, value } of result){
            keysInResult.add(key);
            if (JSON.stringify(this.localCache[key]) !== JSON.stringify(value)) {
                this.notifyListeners(key, value);
                keys.push(key);
            }
        }
        for (const localKey of Object.keys(this.localCache))if (this.localCache[localKey] && !keysInResult.has(localKey)) {
            // Deleted
            this.notifyListeners(localKey, null);
            keys.push(localKey);
        }
        return keys;
    }
    notifyListeners(key, newValue) {
        this.localCache[key] = newValue;
        const listeners = this.listeners[key];
        if (listeners) for (const listener of Array.from(listeners))listener(newValue);
    }
    startPolling() {
        this.stopPolling();
        this.pollTimer = setInterval(async ()=>this._poll(), _POLLING_INTERVAL_MS);
    }
    stopPolling() {
        if (this.pollTimer) {
            clearInterval(this.pollTimer);
            this.pollTimer = null;
        }
    }
    _addListener(key, listener) {
        if (Object.keys(this.listeners).length === 0) this.startPolling();
        if (!this.listeners[key]) {
            this.listeners[key] = new Set();
            // Populate the cache to avoid spuriously triggering on first poll.
            this._get(key); // This can happen in the background async and we can return immediately.
        }
        this.listeners[key].add(listener);
    }
    _removeListener(key, listener) {
        if (this.listeners[key]) {
            this.listeners[key].delete(listener);
            if (this.listeners[key].size === 0) delete this.listeners[key];
        }
        if (Object.keys(this.listeners).length === 0) this.stopPolling();
    }
}
IndexedDBLocalPersistence.type = 'LOCAL';
/**
 * An implementation of {@link Persistence} of type `LOCAL` using `indexedDB`
 * for the underlying storage.
 *
 * @public
 */ const indexedDBLocalPersistence = IndexedDBLocalPersistence;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function startSignInPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:start" /* Endpoint.START_MFA_SIGN_IN */ , _addTidIfNecessary(auth, request));
}
function finalizeSignInPhoneMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , _addTidIfNecessary(auth, request));
}
function finalizeSignInTotpMfa(auth, request) {
    return _performApiRequest(auth, "POST" /* HttpMethod.POST */ , "/v2/accounts/mfaSignIn:finalize" /* Endpoint.FINALIZE_MFA_SIGN_IN */ , _addTidIfNecessary(auth, request));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // ReCaptcha will load using the same callback, so the callback function needs
// to be kept around
const _JSLOAD_CALLBACK = _generateCallbackName('rcb');
const NETWORK_TIMEOUT_DELAY = new Delay(30000, 60000);
/**
 * Loader for the GReCaptcha library. There should only ever be one of this.
 */ class ReCaptchaLoaderImpl {
    constructor(){
        this.hostLanguage = '';
        this.counter = 0;
        /**
         * Check for `render()` method. `window.grecaptcha` will exist if the Enterprise
         * version of the ReCAPTCHA script was loaded by someone else (e.g. App Check) but
         * `window.grecaptcha.render()` will not. Another load will add it.
         */ this.librarySeparatelyLoaded = !!_window().grecaptcha?.render;
    }
    load(auth, hl = '') {
        _assert(isHostLanguageValid(hl), auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        if (this.shouldResolveImmediately(hl) && isV2(_window().grecaptcha)) return Promise.resolve(_window().grecaptcha);
        return new Promise((resolve, reject)=>{
            const networkTimeout = _window().setTimeout(()=>{
                reject(_createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            }, NETWORK_TIMEOUT_DELAY.get());
            _window()[_JSLOAD_CALLBACK] = ()=>{
                _window().clearTimeout(networkTimeout);
                delete _window()[_JSLOAD_CALLBACK];
                const recaptcha = _window().grecaptcha;
                if (!recaptcha || !isV2(recaptcha)) {
                    reject(_createError(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
                    return;
                }
                // Wrap the recaptcha render function so that we know if the developer has
                // called it separately
                const render = recaptcha.render;
                recaptcha.render = (container, params)=>{
                    const widgetId = render(container, params);
                    this.counter++;
                    return widgetId;
                };
                this.hostLanguage = hl;
                resolve(recaptcha);
            };
            const url = `${_recaptchaV2ScriptUrl()}?${(0, _util.querystring)({
                onload: _JSLOAD_CALLBACK,
                render: 'explicit',
                hl
            })}`;
            _loadJS(url).catch(()=>{
                clearTimeout(networkTimeout);
                reject(_createError(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ));
            });
        });
    }
    clearedOneInstance() {
        this.counter--;
    }
    shouldResolveImmediately(hl) {
        // We can resolve immediately if:
        //   • grecaptcha is already defined AND (
        //     1. the requested language codes are the same OR
        //     2. there exists already a ReCaptcha on the page
        //     3. the library was already loaded by the app
        // In cases (2) and (3), we _can't_ reload as it would break the recaptchas
        // that are already in the page
        return !!_window().grecaptcha?.render && (hl === this.hostLanguage || this.counter > 0 || this.librarySeparatelyLoaded);
    }
}
function isHostLanguageValid(hl) {
    return hl.length <= 6 && /^\s*[a-zA-Z0-9\-]*\s*$/.test(hl);
}
class MockReCaptchaLoaderImpl {
    async load(auth) {
        return new MockReCaptcha(auth);
    }
    clearedOneInstance() {}
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const RECAPTCHA_VERIFIER_TYPE = 'recaptcha';
const DEFAULT_PARAMS = {
    theme: 'light',
    type: 'image'
};
/**
 * An {@link https://www.google.com/recaptcha/ | reCAPTCHA}-based application verifier.
 *
 * @remarks
 * `RecaptchaVerifier` does not work in a Node.js environment.
 *
 * @public
 */ class RecaptchaVerifier {
    /**
     * @param authExtern - The corresponding Firebase {@link Auth} instance.
     *
     * @param containerOrId - The reCAPTCHA container parameter.
     *
     * @remarks
     * This has different meaning depending on whether the reCAPTCHA is hidden or visible. For a
     * visible reCAPTCHA the container must be empty. If a string is used, it has to correspond to
     * an element ID. The corresponding element must also must be in the DOM at the time of
     * initialization.
     *
     * @param parameters - The optional reCAPTCHA parameters.
     *
     * @remarks
     * Check the reCAPTCHA docs for a comprehensive list. All parameters are accepted except for
     * the sitekey. Firebase Auth backend provisions a reCAPTCHA for each project and will
     * configure this upon rendering. For an invisible reCAPTCHA, a size key must have the value
     * 'invisible'.
     */ constructor(authExtern, containerOrId, parameters = {
        ...DEFAULT_PARAMS
    }){
        this.parameters = parameters;
        /**
         * The application verifier type.
         *
         * @remarks
         * For a reCAPTCHA verifier, this is 'recaptcha'.
         */ this.type = RECAPTCHA_VERIFIER_TYPE;
        this.destroyed = false;
        this.widgetId = null;
        this.tokenChangeListeners = new Set();
        this.renderPromise = null;
        this.recaptcha = null;
        this.auth = _castAuth(authExtern);
        this.isInvisible = this.parameters.size === 'invisible';
        _assert(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
        const container = typeof containerOrId === 'string' ? document.getElementById(containerOrId) : containerOrId;
        _assert(container, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        this.container = container;
        this.parameters.callback = this.makeTokenCallback(this.parameters.callback);
        this._recaptchaLoader = this.auth.settings.appVerificationDisabledForTesting ? new MockReCaptchaLoaderImpl() : new ReCaptchaLoaderImpl();
        this.validateStartingState();
    // TODO: Figure out if sdk version is needed
    }
    /**
     * Waits for the user to solve the reCAPTCHA and resolves with the reCAPTCHA token.
     *
     * @returns A Promise for the reCAPTCHA token.
     */ async verify() {
        this.assertNotDestroyed();
        const id = await this.render();
        const recaptcha = this.getAssertedRecaptcha();
        const response = recaptcha.getResponse(id);
        if (response) return response;
        return new Promise((resolve)=>{
            const tokenChange = (token)=>{
                if (!token) return; // Ignore token expirations.
                this.tokenChangeListeners.delete(tokenChange);
                resolve(token);
            };
            this.tokenChangeListeners.add(tokenChange);
            if (this.isInvisible) recaptcha.execute(id);
        });
    }
    /**
     * Renders the reCAPTCHA widget on the page.
     *
     * @returns A Promise that resolves with the reCAPTCHA widget ID.
     */ render() {
        try {
            this.assertNotDestroyed();
        } catch (e) {
            // This method returns a promise. Since it's not async (we want to return the
            // _same_ promise if rendering is still occurring), the API surface should
            // reject with the error rather than just throw
            return Promise.reject(e);
        }
        if (this.renderPromise) return this.renderPromise;
        this.renderPromise = this.makeRenderPromise().catch((e)=>{
            this.renderPromise = null;
            throw e;
        });
        return this.renderPromise;
    }
    /** @internal */ _reset() {
        this.assertNotDestroyed();
        if (this.widgetId !== null) this.getAssertedRecaptcha().reset(this.widgetId);
    }
    /**
     * Clears the reCAPTCHA widget from the page and destroys the instance.
     */ clear() {
        this.assertNotDestroyed();
        this.destroyed = true;
        this._recaptchaLoader.clearedOneInstance();
        if (!this.isInvisible) this.container.childNodes.forEach((node)=>{
            this.container.removeChild(node);
        });
    }
    validateStartingState() {
        _assert(!this.parameters.sitekey, this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        _assert(this.isInvisible || !this.container.hasChildNodes(), this.auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        _assert(typeof document !== 'undefined', this.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ );
    }
    makeTokenCallback(existing) {
        return (token)=>{
            this.tokenChangeListeners.forEach((listener)=>listener(token));
            if (typeof existing === 'function') existing(token);
            else if (typeof existing === 'string') {
                const globalFunc = _window()[existing];
                if (typeof globalFunc === 'function') globalFunc(token);
            }
        };
    }
    assertNotDestroyed() {
        _assert(!this.destroyed, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    }
    async makeRenderPromise() {
        await this.init();
        if (!this.widgetId) {
            let container = this.container;
            if (!this.isInvisible) {
                const guaranteedEmpty = document.createElement('div');
                container.appendChild(guaranteedEmpty);
                container = guaranteedEmpty;
            }
            this.widgetId = this.getAssertedRecaptcha().render(container, this.parameters);
        }
        return this.widgetId;
    }
    async init() {
        _assert(_isHttpOrHttps() && !_isWorker(), this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        await domReady();
        this.recaptcha = await this._recaptchaLoader.load(this.auth, this.auth.languageCode || undefined);
        const siteKey = await getRecaptchaParams(this.auth);
        _assert(siteKey, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        this.parameters.sitekey = siteKey;
    }
    getAssertedRecaptcha() {
        _assert(this.recaptcha, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return this.recaptcha;
    }
}
function domReady() {
    let resolver = null;
    return new Promise((resolve)=>{
        if (document.readyState === 'complete') {
            resolve();
            return;
        }
        // Document not ready, wait for load before resolving.
        // Save resolver, so we can remove listener in case it was externally
        // cancelled.
        resolver = ()=>resolve();
        window.addEventListener('load', resolver);
    }).catch((e)=>{
        if (resolver) window.removeEventListener('load', resolver);
        throw e;
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class ConfirmationResultImpl {
    constructor(verificationId, onConfirmation){
        this.verificationId = verificationId;
        this.onConfirmation = onConfirmation;
    }
    confirm(verificationCode) {
        const authCredential = PhoneAuthCredential._fromVerification(this.verificationId, verificationCode);
        return this.onConfirmation(authCredential);
    }
}
/**
 * Asynchronously signs in using a phone number.
 *
 * @remarks
 * This method sends a code via SMS to the given
 * phone number, and returns a {@link ConfirmationResult}. After the user
 * provides the code sent to their phone, call {@link ConfirmationResult.confirm}
 * with the code to sign the user in.
 *
 * For abuse prevention, this method requires a {@link ApplicationVerifier}.
 * This SDK includes an implementation based on reCAPTCHA v2, {@link RecaptchaVerifier}.
 * This function can work on other platforms that do not support the
 * {@link RecaptchaVerifier} (like React Native), but you need to use a
 * third-party {@link ApplicationVerifier} implementation.
 *
 * If you've enabled project-level reCAPTCHA Enterprise bot protection in
 * Enforce mode, you can omit the {@link ApplicationVerifier}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new firebase.auth.RecaptchaVerifier('recaptcha-container');
 * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
 * // Obtain a verificationCode from the user.
 * const credential = await confirmationResult.confirm(verificationCode);
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function signInWithPhoneNumber(auth, phoneNumber, appVerifier) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    const verificationId = await _verifyPhoneNumber(authInternal, phoneNumber, (0, _util.getModularInstance)(appVerifier));
    return new ConfirmationResultImpl(verificationId, (cred)=>signInWithCredential(authInternal, cred));
}
/**
 * Links the user account with the given phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function linkWithPhoneNumber(user, phoneNumber, appVerifier) {
    const userInternal = (0, _util.getModularInstance)(user);
    await _assertLinkedStatus(false, userInternal, "phone" /* ProviderId.PHONE */ );
    const verificationId = await _verifyPhoneNumber(userInternal.auth, phoneNumber, (0, _util.getModularInstance)(appVerifier));
    return new ConfirmationResultImpl(verificationId, (cred)=>linkWithCredential(userInternal, cred));
}
/**
 * Re-authenticates a user using a fresh phone credential.
 *
 * @remarks
 * Use before operations such as {@link updatePassword} that require tokens from recent sign-in attempts.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @param user - The user.
 * @param phoneNumber - The user's phone number in E.164 format (e.g. +16505550101).
 * @param appVerifier - The {@link ApplicationVerifier}.
 *
 * @public
 */ async function reauthenticateWithPhoneNumber(user, phoneNumber, appVerifier) {
    const userInternal = (0, _util.getModularInstance)(user);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    const verificationId = await _verifyPhoneNumber(userInternal.auth, phoneNumber, (0, _util.getModularInstance)(appVerifier));
    return new ConfirmationResultImpl(verificationId, (cred)=>reauthenticateWithCredential(userInternal, cred));
}
/**
 * Returns a verification ID to be used in conjunction with the SMS code that is sent.
 *
 */ async function _verifyPhoneNumber(auth, options, verifier) {
    if (!auth._getRecaptchaConfig()) try {
        await _initializeRecaptchaConfig(auth);
    } catch (error) {
        // If an error occurs while fetching the config, there is no way to know the enablement state
        // of Phone provider, so we proceed with recaptcha V2 verification.
        // The error is likely "recaptchaKey undefined", as reCAPTCHA Enterprise is not
        // enabled for any provider.
        console.log('Failed to initialize reCAPTCHA Enterprise config. Triggering the reCAPTCHA v2 verification.');
    }
    try {
        let phoneInfoOptions;
        if (typeof options === 'string') phoneInfoOptions = {
            phoneNumber: options
        };
        else phoneInfoOptions = options;
        if ('session' in phoneInfoOptions) {
            const session = phoneInfoOptions.session;
            if ('phoneNumber' in phoneInfoOptions) {
                _assert(session.type === "enroll" /* MultiFactorSessionType.ENROLL */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const startPhoneMfaEnrollmentRequest = {
                    idToken: session.credential,
                    phoneEnrollmentInfo: {
                        phoneNumber: phoneInfoOptions.phoneNumber,
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startEnrollPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneEnrollmentInfo.captchaResponse === FAKE_TOKEN) {
                        _assert(verifier?.type === RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await injectRecaptchaV2Token(authInstance, request, verifier);
                        return startEnrollPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return startEnrollPhoneMfa(authInstance, request);
                };
                const startPhoneMfaEnrollmentResponse = handleRecaptchaFlow(auth, startPhoneMfaEnrollmentRequest, "mfaSmsEnrollment" /* RecaptchaActionName.MFA_SMS_ENROLLMENT */ , startEnrollPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaEnrollmentResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneSessionInfo.sessionInfo;
            } else {
                _assert(session.type === "signin" /* MultiFactorSessionType.SIGN_IN */ , auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                const mfaEnrollmentId = phoneInfoOptions.multiFactorHint?.uid || phoneInfoOptions.multiFactorUid;
                _assert(mfaEnrollmentId, auth, "missing-multi-factor-info" /* AuthErrorCode.MISSING_MFA_INFO */ );
                const startPhoneMfaSignInRequest = {
                    mfaPendingCredential: session.credential,
                    mfaEnrollmentId,
                    phoneSignInInfo: {
                        clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
                    }
                };
                const startSignInPhoneMfaActionCallback = async (authInstance, request)=>{
                    // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                    if (request.phoneSignInInfo.captchaResponse === FAKE_TOKEN) {
                        _assert(verifier?.type === RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                        const requestWithRecaptchaV2 = await injectRecaptchaV2Token(authInstance, request, verifier);
                        return startSignInPhoneMfa(authInstance, requestWithRecaptchaV2);
                    }
                    return startSignInPhoneMfa(authInstance, request);
                };
                const startPhoneMfaSignInResponse = handleRecaptchaFlow(auth, startPhoneMfaSignInRequest, "mfaSmsSignIn" /* RecaptchaActionName.MFA_SMS_SIGNIN */ , startSignInPhoneMfaActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
                const response = await startPhoneMfaSignInResponse.catch((error)=>{
                    return Promise.reject(error);
                });
                return response.phoneResponseInfo.sessionInfo;
            }
        } else {
            const sendPhoneVerificationCodeRequest = {
                phoneNumber: phoneInfoOptions.phoneNumber,
                clientType: "CLIENT_TYPE_WEB" /* RecaptchaClientType.WEB */ 
            };
            const sendPhoneVerificationCodeActionCallback = async (authInstance, request)=>{
                // If reCAPTCHA Enterprise token is FAKE_TOKEN, fetch reCAPTCHA v2 token and inject into request.
                if (request.captchaResponse === FAKE_TOKEN) {
                    _assert(verifier?.type === RECAPTCHA_VERIFIER_TYPE, authInstance, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
                    const requestWithRecaptchaV2 = await injectRecaptchaV2Token(authInstance, request, verifier);
                    return sendPhoneVerificationCode(authInstance, requestWithRecaptchaV2);
                }
                return sendPhoneVerificationCode(authInstance, request);
            };
            const sendPhoneVerificationCodeResponse = handleRecaptchaFlow(auth, sendPhoneVerificationCodeRequest, "sendVerificationCode" /* RecaptchaActionName.SEND_VERIFICATION_CODE */ , sendPhoneVerificationCodeActionCallback, "PHONE_PROVIDER" /* RecaptchaAuthProvider.PHONE_PROVIDER */ );
            const response = await sendPhoneVerificationCodeResponse.catch((error)=>{
                return Promise.reject(error);
            });
            return response.sessionInfo;
        }
    } finally{
        verifier?._reset();
    }
}
/**
 * Updates the user's phone number.
 *
 * @remarks
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * await updatePhoneNumber(user, phoneCredential);
 * ```
 *
 * @param user - The user.
 * @param credential - A credential authenticating the new phone number.
 *
 * @public
 */ async function updatePhoneNumber(user, credential) {
    const userInternal = (0, _util.getModularInstance)(user);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    await _link$1(userInternal, credential);
}
// Helper function that fetches and injects a reCAPTCHA v2 token into the request.
async function injectRecaptchaV2Token(auth, request, recaptchaV2Verifier) {
    _assert(recaptchaV2Verifier.type === RECAPTCHA_VERIFIER_TYPE, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const recaptchaV2Token = await recaptchaV2Verifier.verify();
    _assert(typeof recaptchaV2Token === 'string', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    const newRequest = {
        ...request
    };
    if ('phoneEnrollmentInfo' in newRequest) {
        const phoneNumber = newRequest.phoneEnrollmentInfo.phoneNumber;
        const captchaResponse = newRequest.phoneEnrollmentInfo.captchaResponse;
        const clientType = newRequest.phoneEnrollmentInfo.clientType;
        const recaptchaVersion = newRequest.phoneEnrollmentInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneEnrollmentInfo': {
                phoneNumber,
                recaptchaToken: recaptchaV2Token,
                captchaResponse,
                clientType,
                recaptchaVersion
            }
        });
        return newRequest;
    } else if ('phoneSignInInfo' in newRequest) {
        const captchaResponse = newRequest.phoneSignInInfo.captchaResponse;
        const clientType = newRequest.phoneSignInInfo.clientType;
        const recaptchaVersion = newRequest.phoneSignInInfo.recaptchaVersion;
        Object.assign(newRequest, {
            'phoneSignInInfo': {
                recaptchaToken: recaptchaV2Token,
                captchaResponse,
                clientType,
                recaptchaVersion
            }
        });
        return newRequest;
    } else {
        Object.assign(newRequest, {
            'recaptchaToken': recaptchaV2Token
        });
        return newRequest;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provider for generating an {@link PhoneAuthCredential}.
 *
 * @remarks
 * `PhoneAuthProvider` does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // 'recaptcha-container' is the ID of an element in the DOM.
 * const applicationVerifier = new RecaptchaVerifier('recaptcha-container');
 * const provider = new PhoneAuthProvider(auth);
 * const verificationId = await provider.verifyPhoneNumber('+16505550101', applicationVerifier);
 * // Obtain the verificationCode from the user.
 * const phoneCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
 * const userCredential = await signInWithCredential(auth, phoneCredential);
 * ```
 *
 * @public
 */ class PhoneAuthProvider {
    /**
     * @param auth - The Firebase {@link Auth} instance in which sign-ins should occur.
     *
     */ constructor(auth){
        /** Always set to {@link ProviderId}.PHONE. */ this.providerId = PhoneAuthProvider.PROVIDER_ID;
        this.auth = _castAuth(auth);
    }
    /**
     *
     * Starts a phone number authentication flow by sending a verification code to the given phone
     * number.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = await signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param phoneInfoOptions - The user's {@link PhoneInfoOptions}. The phone number should be in
     * E.164 format (e.g. +16505550101).
     * @param applicationVerifier - An {@link ApplicationVerifier}, which prevents
     * requests from unauthorized clients. This SDK includes an implementation
     * based on reCAPTCHA v2, {@link RecaptchaVerifier}. If you've enabled
     * reCAPTCHA Enterprise bot protection in Enforce mode, this parameter is
     * optional; in all other configurations, the parameter is required.
     *
     * @returns A Promise for a verification ID that can be passed to
     * {@link PhoneAuthProvider.credential} to identify this flow.
     */ verifyPhoneNumber(phoneOptions, applicationVerifier) {
        return _verifyPhoneNumber(this.auth, phoneOptions, (0, _util.getModularInstance)(applicationVerifier));
    }
    /**
     * Creates a phone auth credential, given the verification ID from
     * {@link PhoneAuthProvider.verifyPhoneNumber} and the code that was sent to the user's
     * mobile device.
     *
     * @example
     * ```javascript
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = provider.verifyPhoneNumber(phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const authCredential = PhoneAuthProvider.credential(verificationId, verificationCode);
     * const userCredential = signInWithCredential(auth, authCredential);
     * ```
     *
     * @example
     * An alternative flow is provided using the `signInWithPhoneNumber` method.
     * ```javascript
     * const confirmationResult = await signInWithPhoneNumber(auth, phoneNumber, applicationVerifier);
     * // Obtain verificationCode from the user.
     * const userCredential = await confirmationResult.confirm(verificationCode);
     * ```
     *
     * @param verificationId - The verification ID returned from {@link PhoneAuthProvider.verifyPhoneNumber}.
     * @param verificationCode - The verification code sent to the user's mobile device.
     *
     * @returns The auth provider credential.
     */ static credential(verificationId, verificationCode) {
        return PhoneAuthCredential._fromVerification(verificationId, verificationCode);
    }
    /**
     * Generates an {@link AuthCredential} from a {@link UserCredential}.
     * @param userCredential - The user credential.
     */ static credentialFromResult(userCredential) {
        const credential = userCredential;
        return PhoneAuthProvider.credentialFromTaggedObject(credential);
    }
    /**
     * Returns an {@link AuthCredential} when passed an error.
     *
     * @remarks
     *
     * This method works for errors like
     * `auth/account-exists-with-different-credentials`. This is useful for
     * recovering when attempting to set a user's phone number but the number
     * in question is already tied to another account. For example, the following
     * code tries to update the current user's phone number, and if that
     * fails, links the user with the account associated with that number:
     *
     * ```js
     * const provider = new PhoneAuthProvider(auth);
     * const verificationId = await provider.verifyPhoneNumber(number, verifier);
     * try {
     *   const code = ''; // Prompt the user for the verification code
     *   await updatePhoneNumber(
     *       auth.currentUser,
     *       PhoneAuthProvider.credential(verificationId, code));
     * } catch (e) {
     *   if ((e as FirebaseError)?.code === 'auth/account-exists-with-different-credential') {
     *     const cred = PhoneAuthProvider.credentialFromError(e);
     *     await linkWithCredential(auth.currentUser, cred);
     *   }
     * }
     *
     * // At this point, auth.currentUser.phoneNumber === number.
     * ```
     *
     * @param error - The error to generate a credential from.
     */ static credentialFromError(error) {
        return PhoneAuthProvider.credentialFromTaggedObject(error.customData || {});
    }
    static credentialFromTaggedObject({ _tokenResponse: tokenResponse }) {
        if (!tokenResponse) return null;
        const { phoneNumber, temporaryProof } = tokenResponse;
        if (phoneNumber && temporaryProof) return PhoneAuthCredential._fromTokenResponse(phoneNumber, temporaryProof);
        return null;
    }
}
/** Always set to {@link ProviderId}.PHONE. */ PhoneAuthProvider.PROVIDER_ID = "phone" /* ProviderId.PHONE */ ;
/** Always set to {@link SignInMethod}.PHONE. */ PhoneAuthProvider.PHONE_SIGN_IN_METHOD = "phone" /* SignInMethod.PHONE */ ;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Chooses a popup/redirect resolver to use. This prefers the override (which
 * is directly passed in), and falls back to the property set on the auth
 * object. If neither are available, this function errors w/ an argument error.
 */ function _withDefaultResolver(auth, resolverOverride) {
    if (resolverOverride) return _getInstance(resolverOverride);
    _assert(auth._popupRedirectResolver, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
    return auth._popupRedirectResolver;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class IdpCredential extends AuthCredential {
    constructor(params){
        super("custom" /* ProviderId.CUSTOM */ , "custom" /* ProviderId.CUSTOM */ );
        this.params = params;
    }
    _getIdTokenResponse(auth) {
        return signInWithIdp(auth, this._buildIdpRequest());
    }
    _linkToIdToken(auth, idToken) {
        return signInWithIdp(auth, this._buildIdpRequest(idToken));
    }
    _getReauthenticationResolver(auth) {
        return signInWithIdp(auth, this._buildIdpRequest());
    }
    _buildIdpRequest(idToken) {
        const request = {
            requestUri: this.params.requestUri,
            sessionId: this.params.sessionId,
            postBody: this.params.postBody,
            tenantId: this.params.tenantId,
            pendingToken: this.params.pendingToken,
            returnSecureToken: true,
            returnIdpCredential: true
        };
        if (idToken) request.idToken = idToken;
        return request;
    }
}
function _signIn(params) {
    return _signInWithCredential(params.auth, new IdpCredential(params), params.bypassAuthState);
}
function _reauth(params) {
    const { auth, user } = params;
    _assert(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return _reauthenticate(user, new IdpCredential(params), params.bypassAuthState);
}
async function _link(params) {
    const { auth, user } = params;
    _assert(user, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return _link$1(user, new IdpCredential(params), params.bypassAuthState);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 */ class AbstractPopupRedirectOperation {
    constructor(auth, filter, resolver, user, bypassAuthState = false){
        this.auth = auth;
        this.resolver = resolver;
        this.user = user;
        this.bypassAuthState = bypassAuthState;
        this.pendingPromise = null;
        this.eventManager = null;
        this.filter = Array.isArray(filter) ? filter : [
            filter
        ];
    }
    execute() {
        return new Promise(async (resolve, reject)=>{
            this.pendingPromise = {
                resolve,
                reject
            };
            try {
                this.eventManager = await this.resolver._initialize(this.auth);
                await this.onExecution();
                this.eventManager.registerConsumer(this);
            } catch (e) {
                this.reject(e);
            }
        });
    }
    async onAuthEvent(event) {
        const { urlResponse, sessionId, postBody, tenantId, error, type } = event;
        if (error) {
            this.reject(error);
            return;
        }
        const params = {
            auth: this.auth,
            requestUri: urlResponse,
            sessionId: sessionId,
            tenantId: tenantId || undefined,
            postBody: postBody || undefined,
            user: this.user,
            bypassAuthState: this.bypassAuthState
        };
        try {
            this.resolve(await this.getIdpTask(type)(params));
        } catch (e) {
            this.reject(e);
        }
    }
    onError(error) {
        this.reject(error);
    }
    getIdpTask(type) {
        switch(type){
            case "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ :
            case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
                return _signIn;
            case "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ :
            case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
                return _link;
            case "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ :
            case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
                return _reauth;
            default:
                _fail(this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }
    }
    resolve(cred) {
        debugAssert(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.resolve(cred);
        this.unregisterAndCleanUp();
    }
    reject(error) {
        debugAssert(this.pendingPromise, 'Pending promise was never set');
        this.pendingPromise.reject(error);
        this.unregisterAndCleanUp();
    }
    unregisterAndCleanUp() {
        if (this.eventManager) this.eventManager.unregisterConsumer(this);
        this.pendingPromise = null;
        this.cleanUp();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const _POLL_WINDOW_CLOSE_TIMEOUT = new Delay(2000, 10000);
/**
 * Authenticates a Firebase client using a popup-based OAuth authentication flow.
 *
 * @remarks
 * If succeeds, returns the signed in user along with the provider's credential. If sign in was
 * unsuccessful, returns an error object containing additional information about the error.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 *
 * // The signed-in user info.
 * const user = result.user;
 * // This gives you a Facebook Access Token.
 * const credential = provider.credentialFromResult(auth, result);
 * const token = credential.accessToken;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function signInWithPopup(auth, provider, resolver) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_createError(auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    const authInternal = _castAuth(auth);
    _assertInstanceOf(auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(authInternal, resolver);
    const action = new PopupOperation(authInternal, "signInViaPopup" /* AuthEventType.SIGN_IN_VIA_POPUP */ , provider, resolverInternal);
    return action.executeNotNull();
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a pop-up based
 * OAuth flow.
 *
 * @remarks
 * If the reauthentication is successful, the returned result will contain the user and the
 * provider's credential.
 *
 * This method does not work in a Node.js environment or on any {@link User} signed in by
 * {@link Auth} instances created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a popup.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithPopup(auth, provider);
 * // Reauthenticate using a popup.
 * await reauthenticateWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function reauthenticateWithPopup(user, provider, resolver) {
    const userInternal = (0, _util.getModularInstance)(user);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_createError(userInternal.auth, "operation-not-supported-in-this-environment" /* AuthErrorCode.OPERATION_NOT_SUPPORTED */ ));
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    const action = new PopupOperation(userInternal.auth, "reauthViaPopup" /* AuthEventType.REAUTH_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Links the authenticated provider to the user account using a pop-up based OAuth flow.
 *
 * @remarks
 * If the linking is successful, the returned result will contain the user and the provider's credential.
 *
 * This method does not work in a Node.js environment.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a popup.
 * const provider = new FacebookAuthProvider();
 * await linkWithPopup(result.user, provider);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function linkWithPopup(user, provider, resolver) {
    const userInternal = (0, _util.getModularInstance)(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    const action = new PopupOperation(userInternal.auth, "linkViaPopup" /* AuthEventType.LINK_VIA_POPUP */ , provider, resolverInternal, userInternal);
    return action.executeNotNull();
}
/**
 * Popup event manager. Handles the popup's entire lifecycle; listens to auth
 * events
 *
 */ class PopupOperation extends AbstractPopupRedirectOperation {
    constructor(auth, filter, provider, resolver, user){
        super(auth, filter, resolver, user);
        this.provider = provider;
        this.authWindow = null;
        this.pollId = null;
        if (PopupOperation.currentPopupAction) PopupOperation.currentPopupAction.cancel();
        PopupOperation.currentPopupAction = this;
    }
    async executeNotNull() {
        const result = await this.execute();
        _assert(result, this.auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        return result;
    }
    async onExecution() {
        debugAssert(this.filter.length === 1, 'Popup operations only handle one event');
        const eventId = _generateEventId();
        this.authWindow = await this.resolver._openPopup(this.auth, this.provider, this.filter[0], eventId);
        this.authWindow.associatedEvent = eventId;
        // Check for web storage support and origin validation _after_ the popup is
        // loaded. These operations are slow (~1 second or so) Rather than
        // waiting on them before opening the window, optimistically open the popup
        // and check for storage support at the same time. If storage support is
        // not available, this will cause the whole thing to reject properly. It
        // will also close the popup, but since the promise has already rejected,
        // the popup closed by user poll will reject into the void.
        this.resolver._originValidation(this.auth).catch((e)=>{
            this.reject(e);
        });
        this.resolver._isIframeWebStorageSupported(this.auth, (isSupported)=>{
            if (!isSupported) this.reject(_createError(this.auth, "web-storage-unsupported" /* AuthErrorCode.WEB_STORAGE_UNSUPPORTED */ ));
        });
        // Handle user closure. Notice this does *not* use await
        this.pollUserCancellation();
    }
    get eventId() {
        return this.authWindow?.associatedEvent || null;
    }
    cancel() {
        this.reject(_createError(this.auth, "cancelled-popup-request" /* AuthErrorCode.EXPIRED_POPUP_REQUEST */ ));
    }
    cleanUp() {
        if (this.authWindow) this.authWindow.close();
        if (this.pollId) window.clearTimeout(this.pollId);
        this.authWindow = null;
        this.pollId = null;
        PopupOperation.currentPopupAction = null;
    }
    pollUserCancellation() {
        const poll = ()=>{
            if (this.authWindow?.window?.closed) {
                // Make sure that there is sufficient time for whatever action to
                // complete. The window could have closed but the sign in network
                // call could still be in flight. This is specifically true for
                // Firefox or if the opener is in an iframe, in which case the oauth
                // helper closes the popup.
                this.pollId = window.setTimeout(()=>{
                    this.pollId = null;
                    this.reject(_createError(this.auth, "popup-closed-by-user" /* AuthErrorCode.POPUP_CLOSED_BY_USER */ ));
                }, 8000 /* _Timeout.AUTH_EVENT */ );
                return;
            }
            this.pollId = window.setTimeout(poll, _POLL_WINDOW_CLOSE_TIMEOUT.get());
        };
        poll();
    }
}
// Only one popup is ever shown at once. The lifecycle of the current popup
// can be managed / cancelled by the constructor.
PopupOperation.currentPopupAction = null;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const PENDING_REDIRECT_KEY = 'pendingRedirect';
// We only get one redirect outcome for any one auth, so just store it
// in here.
const redirectOutcomeMap = new Map();
class RedirectAction extends AbstractPopupRedirectOperation {
    constructor(auth, resolver, bypassAuthState = false){
        super(auth, [
            "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ,
            "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ ,
            "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ ,
            "unknown" /* AuthEventType.UNKNOWN */ 
        ], resolver, undefined, bypassAuthState);
        this.eventId = null;
    }
    /**
     * Override the execute function; if we already have a redirect result, then
     * just return it.
     */ async execute() {
        let readyOutcome = redirectOutcomeMap.get(this.auth._key());
        if (!readyOutcome) {
            try {
                const hasPendingRedirect = await _getAndClearPendingRedirectStatus(this.resolver, this.auth);
                const result = hasPendingRedirect ? await super.execute() : null;
                readyOutcome = ()=>Promise.resolve(result);
            } catch (e) {
                readyOutcome = ()=>Promise.reject(e);
            }
            redirectOutcomeMap.set(this.auth._key(), readyOutcome);
        }
        // If we're not bypassing auth state, the ready outcome should be set to
        // null.
        if (!this.bypassAuthState) redirectOutcomeMap.set(this.auth._key(), ()=>Promise.resolve(null));
        return readyOutcome();
    }
    async onAuthEvent(event) {
        if (event.type === "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ ) return super.onAuthEvent(event);
        else if (event.type === "unknown" /* AuthEventType.UNKNOWN */ ) {
            // This is a sentinel value indicating there's no pending redirect
            this.resolve(null);
            return;
        }
        if (event.eventId) {
            const user = await this.auth._redirectUserForId(event.eventId);
            if (user) {
                this.user = user;
                return super.onAuthEvent(event);
            } else this.resolve(null);
        }
    }
    async onExecution() {}
    cleanUp() {}
}
async function _getAndClearPendingRedirectStatus(resolver, auth) {
    const key = pendingRedirectKey(auth);
    const persistence = resolverPersistence(resolver);
    if (!await persistence._isAvailable()) return false;
    const hasPendingRedirect = await persistence._get(key) === 'true';
    await persistence._remove(key);
    return hasPendingRedirect;
}
async function _setPendingRedirectStatus(resolver, auth) {
    return resolverPersistence(resolver)._set(pendingRedirectKey(auth), 'true');
}
function _clearRedirectOutcomes() {
    redirectOutcomeMap.clear();
}
function _overrideRedirectResult(auth, result) {
    redirectOutcomeMap.set(auth._key(), result);
}
function resolverPersistence(resolver) {
    return _getInstance(resolver._redirectPersistence);
}
function pendingRedirectKey(auth) {
    return _persistenceKeyName(PENDING_REDIRECT_KEY, auth.config.apiKey, auth.name);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Authenticates a Firebase client using a full-page redirect flow.
 *
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link signInWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function signInWithRedirect(auth, provider, resolver) {
    return _signInWithRedirect(auth, provider, resolver);
}
async function _signInWithRedirect(auth, provider, resolver) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    _assertInstanceOf(auth, provider, FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await authInternal._initializationPromise;
    const resolverInternal = _withDefaultResolver(authInternal, resolver);
    await _setPendingRedirectStatus(resolverInternal, authInternal);
    return resolverInternal._openRedirect(authInternal, provider, "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ );
}
/**
 * Reauthenticates the current user with the specified {@link OAuthProvider} using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link reauthenticateWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * const result = await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * // Reauthenticate using a redirect.
 * await reauthenticateWithRedirect(result.user, provider);
 * // This will again trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function reauthenticateWithRedirect(user, provider, resolver) {
    return _reauthenticateWithRedirect(user, provider, resolver);
}
async function _reauthenticateWithRedirect(user, provider, resolver) {
    const userInternal = (0, _util.getModularInstance)(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    if ((0, _app._isFirebaseServerApp)(userInternal.auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(userInternal.auth));
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    await _setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ , eventId);
}
/**
 * Links the {@link OAuthProvider} to the user account using a full-page redirect flow.
 * @remarks
 * To handle the results and errors for this operation, refer to {@link getRedirectResult}.
 * Follow the {@link https://firebase.google.com/docs/auth/web/redirect-best-practices
 * | best practices} when using {@link linkWithRedirect}.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances
 * created with a {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using some other provider.
 * const result = await signInWithEmailAndPassword(auth, email, password);
 * // Link using a redirect.
 * const provider = new FacebookAuthProvider();
 * await linkWithRedirect(result.user, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * ```
 *
 * @param user - The user.
 * @param provider - The provider to authenticate. The provider has to be an {@link OAuthProvider}.
 * Non-OAuth providers like {@link EmailAuthProvider} will throw an error.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ function linkWithRedirect(user, provider, resolver) {
    return _linkWithRedirect(user, provider, resolver);
}
async function _linkWithRedirect(user, provider, resolver) {
    const userInternal = (0, _util.getModularInstance)(user);
    _assertInstanceOf(userInternal.auth, provider, FederatedAuthProvider);
    // Wait for auth initialization to complete, this will process pending redirects and clear the
    // PENDING_REDIRECT_KEY in persistence. This should be completed before starting a new
    // redirect and creating a PENDING_REDIRECT_KEY entry.
    await userInternal.auth._initializationPromise;
    // Allow the resolver to error before persisting the redirect user
    const resolverInternal = _withDefaultResolver(userInternal.auth, resolver);
    await _assertLinkedStatus(false, userInternal, provider.providerId);
    await _setPendingRedirectStatus(resolverInternal, userInternal.auth);
    const eventId = await prepareUserForRedirect(userInternal);
    return resolverInternal._openRedirect(userInternal.auth, provider, "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ , eventId);
}
/**
 * Returns a {@link UserCredential} from the redirect-based sign-in flow.
 *
 * @remarks
 * If sign-in succeeded, returns the signed in user. If sign-in was unsuccessful, fails with an
 * error. If no redirect operation was called, returns `null`.
 *
 * This method does not work in a Node.js environment or with {@link Auth} instances created with a
 * {@link @firebase/app#FirebaseServerApp}.
 *
 * @example
 * ```javascript
 * // Sign in using a redirect.
 * const provider = new FacebookAuthProvider();
 * // You can add additional scopes to the provider:
 * provider.addScope('user_birthday');
 * // Start a sign in process for an unauthenticated user.
 * await signInWithRedirect(auth, provider);
 * // This will trigger a full page redirect away from your app
 *
 * // After returning from the redirect when your app initializes you can obtain the result
 * const result = await getRedirectResult(auth);
 * if (result) {
 *   // This is the signed-in user
 *   const user = result.user;
 *   // This gives you a Facebook Access Token.
 *   const credential = provider.credentialFromResult(auth, result);
 *   const token = credential.accessToken;
 * }
 * // As this API can be used for sign-in, linking and reauthentication,
 * // check the operationType to determine what triggered this redirect
 * // operation.
 * const operationType = result.operationType;
 * ```
 *
 * @param auth - The {@link Auth} instance.
 * @param resolver - An instance of {@link PopupRedirectResolver}, optional
 * if already supplied to {@link initializeAuth} or provided by {@link getAuth}.
 *
 * @public
 */ async function getRedirectResult(auth, resolver) {
    await _castAuth(auth)._initializationPromise;
    return _getRedirectResult(auth, resolver, false);
}
async function _getRedirectResult(auth, resolverExtern, bypassAuthState = false) {
    if ((0, _app._isFirebaseServerApp)(auth.app)) return Promise.reject(_serverAppCurrentUserOperationNotSupportedError(auth));
    const authInternal = _castAuth(auth);
    const resolver = _withDefaultResolver(authInternal, resolverExtern);
    const action = new RedirectAction(authInternal, resolver, bypassAuthState);
    const result = await action.execute();
    if (result && !bypassAuthState) {
        delete result.user._redirectEventId;
        await authInternal._persistUserIfCurrent(result.user);
        await authInternal._setRedirectUser(null, resolverExtern);
    }
    return result;
}
async function prepareUserForRedirect(user) {
    const eventId = _generateEventId(`${user.uid}:::`);
    user._redirectEventId = eventId;
    await user.auth._setRedirectUser(user);
    await user.auth._persistUserIfCurrent(user);
    return eventId;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The amount of time to store the UIDs of seen events; this is
// set to 10 min by default
const EVENT_DUPLICATION_CACHE_DURATION_MS = 600000;
class AuthEventManager {
    constructor(auth){
        this.auth = auth;
        this.cachedEventUids = new Set();
        this.consumers = new Set();
        this.queuedRedirectEvent = null;
        this.hasHandledPotentialRedirect = false;
        this.lastProcessedEventTime = Date.now();
    }
    registerConsumer(authEventConsumer) {
        this.consumers.add(authEventConsumer);
        if (this.queuedRedirectEvent && this.isEventForConsumer(this.queuedRedirectEvent, authEventConsumer)) {
            this.sendToConsumer(this.queuedRedirectEvent, authEventConsumer);
            this.saveEventToCache(this.queuedRedirectEvent);
            this.queuedRedirectEvent = null;
        }
    }
    unregisterConsumer(authEventConsumer) {
        this.consumers.delete(authEventConsumer);
    }
    onEvent(event) {
        // Check if the event has already been handled
        if (this.hasEventBeenHandled(event)) return false;
        let handled = false;
        this.consumers.forEach((consumer)=>{
            if (this.isEventForConsumer(event, consumer)) {
                handled = true;
                this.sendToConsumer(event, consumer);
                this.saveEventToCache(event);
            }
        });
        if (this.hasHandledPotentialRedirect || !isRedirectEvent(event)) // If we've already seen a redirect before, or this is a popup event,
        // bail now
        return handled;
        this.hasHandledPotentialRedirect = true;
        // If the redirect wasn't handled, hang on to it
        if (!handled) {
            this.queuedRedirectEvent = event;
            handled = true;
        }
        return handled;
    }
    sendToConsumer(event, consumer) {
        if (event.error && !isNullRedirectEvent(event)) {
            const code = event.error.code?.split('auth/')[1] || "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ ;
            consumer.onError(_createError(this.auth, code));
        } else consumer.onAuthEvent(event);
    }
    isEventForConsumer(event, consumer) {
        const eventIdMatches = consumer.eventId === null || !!event.eventId && event.eventId === consumer.eventId;
        return consumer.filter.includes(event.type) && eventIdMatches;
    }
    hasEventBeenHandled(event) {
        if (Date.now() - this.lastProcessedEventTime >= EVENT_DUPLICATION_CACHE_DURATION_MS) this.cachedEventUids.clear();
        return this.cachedEventUids.has(eventUid(event));
    }
    saveEventToCache(event) {
        this.cachedEventUids.add(eventUid(event));
        this.lastProcessedEventTime = Date.now();
    }
}
function eventUid(e) {
    return [
        e.type,
        e.eventId,
        e.sessionId,
        e.tenantId
    ].filter((v)=>v).join('-');
}
function isNullRedirectEvent({ type, error }) {
    return type === "unknown" /* AuthEventType.UNKNOWN */  && error?.code === `auth/${"no-auth-event" /* AuthErrorCode.NO_AUTH_EVENT */ }`;
}
function isRedirectEvent(event) {
    switch(event.type){
        case "signInViaRedirect" /* AuthEventType.SIGN_IN_VIA_REDIRECT */ :
        case "linkViaRedirect" /* AuthEventType.LINK_VIA_REDIRECT */ :
        case "reauthViaRedirect" /* AuthEventType.REAUTH_VIA_REDIRECT */ :
            return true;
        case "unknown" /* AuthEventType.UNKNOWN */ :
            return isNullRedirectEvent(event);
        default:
            return false;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function _getProjectConfig(auth, request = {}) {
    return _performApiRequest(auth, "GET" /* HttpMethod.GET */ , "/v1/projects" /* Endpoint.GET_PROJECT_CONFIG */ , request);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const IP_ADDRESS_REGEX = /^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;
const HTTP_REGEX = /^https?/;
async function _validateOrigin(auth) {
    // Skip origin validation if we are in an emulated environment
    if (auth.config.emulator) return;
    const { authorizedDomains } = await _getProjectConfig(auth);
    for (const domain of authorizedDomains)try {
        if (matchDomain(domain)) return;
    } catch  {
    // Do nothing if there's a URL error; just continue searching
    }
    // In the old SDK, this error also provides helpful messages.
    _fail(auth, "unauthorized-domain" /* AuthErrorCode.INVALID_ORIGIN */ );
}
function matchDomain(expected) {
    const currentUrl = _getCurrentUrl();
    const { protocol, hostname } = new URL(currentUrl);
    if (expected.startsWith('chrome-extension://')) {
        const ceUrl = new URL(expected);
        if (ceUrl.hostname === '' && hostname === '') // For some reason we're not parsing chrome URLs properly
        return protocol === 'chrome-extension:' && expected.replace('chrome-extension://', '') === currentUrl.replace('chrome-extension://', '');
        return protocol === 'chrome-extension:' && ceUrl.hostname === hostname;
    }
    if (!HTTP_REGEX.test(protocol)) return false;
    if (IP_ADDRESS_REGEX.test(expected)) // The domain has to be exactly equal to the pattern, as an IP domain will
    // only contain the IP, no extra character.
    return hostname === expected;
    // Dots in pattern should be escaped.
    const escapedDomainPattern = expected.replace(/\./g, '\\.');
    // Non ip address domains.
    // domain.com = *.domain.com OR domain.com
    const re = new RegExp('^(.+\\.' + escapedDomainPattern + '|' + escapedDomainPattern + ')$', 'i');
    return re.test(hostname);
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const NETWORK_TIMEOUT = new Delay(30000, 60000);
/**
 * Reset unloaded GApi modules. If gapi.load fails due to a network error,
 * it will stop working after a retrial. This is a hack to fix this issue.
 */ function resetUnloadedGapiModules() {
    // Clear last failed gapi.load state to force next gapi.load to first
    // load the failed gapi.iframes module.
    // Get gapix.beacon context.
    const beacon = _window().___jsl;
    // Get current hint.
    if (beacon?.H) // Get gapi hint.
    for (const hint of Object.keys(beacon.H)){
        // Requested modules.
        beacon.H[hint].r = beacon.H[hint].r || [];
        // Loaded modules.
        beacon.H[hint].L = beacon.H[hint].L || [];
        // Set requested modules to a copy of the loaded modules.
        beacon.H[hint].r = [
            ...beacon.H[hint].L
        ];
        // Clear pending callbacks.
        if (beacon.CP) for(let i = 0; i < beacon.CP.length; i++)// Remove all failed pending callbacks.
        beacon.CP[i] = null;
    }
}
function loadGapi(auth) {
    return new Promise((resolve, reject)=>{
        // Function to run when gapi.load is ready.
        function loadGapiIframe() {
            // The developer may have tried to previously run gapi.load and failed.
            // Run this to fix that.
            resetUnloadedGapiModules();
            gapi.load('gapi.iframes', {
                callback: ()=>{
                    resolve(gapi.iframes.getContext());
                },
                ontimeout: ()=>{
                    // The above reset may be sufficient, but having this reset after
                    // failure ensures that if the developer calls gapi.load after the
                    // connection is re-established and before another attempt to embed
                    // the iframe, it would work and would not be broken because of our
                    // failed attempt.
                    // Timeout when gapi.iframes.Iframe not loaded.
                    resetUnloadedGapiModules();
                    reject(_createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
                },
                timeout: NETWORK_TIMEOUT.get()
            });
        }
        if (_window().gapi?.iframes?.Iframe) // If gapi.iframes.Iframe available, resolve.
        resolve(gapi.iframes.getContext());
        else if (!!_window().gapi?.load) // Gapi loader ready, load gapi.iframes.
        loadGapiIframe();
        else {
            // Create a new iframe callback when this is called so as not to overwrite
            // any previous defined callback. This happens if this method is called
            // multiple times in parallel and could result in the later callback
            // overwriting the previous one. This would end up with a iframe
            // timeout.
            const cbName = _generateCallbackName('iframefcb');
            // GApi loader not available, dynamically load platform.js.
            _window()[cbName] = ()=>{
                // GApi loader should be ready.
                if (!!gapi.load) loadGapiIframe();
                else // Gapi loader failed, throw error.
                reject(_createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ ));
            };
            // Load GApi loader.
            return _loadJS(`${_gapiScriptUrl()}?onload=${cbName}`).catch((e)=>reject(e));
        }
    }).catch((error)=>{
        // Reset cached promise to allow for retrial.
        cachedGApiLoader = null;
        throw error;
    });
}
let cachedGApiLoader = null;
function _loadGapi(auth) {
    cachedGApiLoader = cachedGApiLoader || loadGapi(auth);
    return cachedGApiLoader;
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const PING_TIMEOUT = new Delay(5000, 15000);
const IFRAME_PATH = '__/auth/iframe';
const EMULATED_IFRAME_PATH = 'emulator/auth/iframe';
const IFRAME_ATTRIBUTES = {
    style: {
        position: 'absolute',
        top: '-100px',
        width: '1px',
        height: '1px'
    },
    'aria-hidden': 'true',
    tabindex: '-1'
};
// Map from apiHost to endpoint ID for passing into iframe. In current SDK, apiHost can be set to
// anything (not from a list of endpoints with IDs as in legacy), so this is the closest we can get.
const EID_FROM_APIHOST = new Map([
    [
        "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
        'p'
    ],
    [
        'staging-identitytoolkit.sandbox.googleapis.com',
        's'
    ],
    [
        'test-identitytoolkit.sandbox.googleapis.com',
        't'
    ] // test
]);
function getIframeUrl(auth) {
    const config = auth.config;
    _assert(config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    const url = config.emulator ? _emulatorUrl(config, EMULATED_IFRAME_PATH) : `https://${auth.config.authDomain}/${IFRAME_PATH}`;
    const params = {
        apiKey: config.apiKey,
        appName: auth.name,
        v: (0, _app.SDK_VERSION)
    };
    const eid = EID_FROM_APIHOST.get(auth.config.apiHost);
    if (eid) params.eid = eid;
    const frameworks = auth._getFrameworks();
    if (frameworks.length) params.fw = frameworks.join(',');
    return `${url}?${(0, _util.querystring)(params).slice(1)}`;
}
async function _openIframe(auth) {
    const context = await _loadGapi(auth);
    const gapi1 = _window().gapi;
    _assert(gapi1, auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
    return context.open({
        where: document.body,
        url: getIframeUrl(auth),
        messageHandlersFilter: gapi1.iframes.CROSS_ORIGIN_IFRAMES_FILTER,
        attributes: IFRAME_ATTRIBUTES,
        dontclear: true
    }, (iframe)=>new Promise(async (resolve, reject)=>{
            await iframe.restyle({
                // Prevent iframe from closing on mouse out.
                setHideOnLeave: false
            });
            const networkError = _createError(auth, "network-request-failed" /* AuthErrorCode.NETWORK_REQUEST_FAILED */ );
            // Confirm iframe is correctly loaded.
            // To fallback on failure, set a timeout.
            const networkErrorTimer = _window().setTimeout(()=>{
                reject(networkError);
            }, PING_TIMEOUT.get());
            // Clear timer and resolve pending iframe ready promise.
            function clearTimerAndResolve() {
                _window().clearTimeout(networkErrorTimer);
                resolve(iframe);
            }
            // This returns an IThenable. However the reject part does not call
            // when the iframe is not loaded.
            iframe.ping(clearTimerAndResolve).then(clearTimerAndResolve, ()=>{
                reject(networkError);
            });
        }));
}
/**
 * @license
 * Copyright 2020 Google LLC.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const BASE_POPUP_OPTIONS = {
    location: 'yes',
    resizable: 'yes',
    statusbar: 'yes',
    toolbar: 'no'
};
const DEFAULT_WIDTH = 500;
const DEFAULT_HEIGHT = 600;
const TARGET_BLANK = '_blank';
const FIREFOX_EMPTY_URL = 'http://localhost';
class AuthPopup {
    constructor(window1){
        this.window = window1;
        this.associatedEvent = null;
    }
    close() {
        if (this.window) try {
            this.window.close();
        } catch (e) {}
    }
}
function _open(auth, url, name, width = DEFAULT_WIDTH, height = DEFAULT_HEIGHT) {
    const top = Math.max((window.screen.availHeight - height) / 2, 0).toString();
    const left = Math.max((window.screen.availWidth - width) / 2, 0).toString();
    let target = '';
    const options = {
        ...BASE_POPUP_OPTIONS,
        width: width.toString(),
        height: height.toString(),
        top,
        left
    };
    // Chrome iOS 7 and 8 is returning an undefined popup win when target is
    // specified, even though the popup is not necessarily blocked.
    const ua = (0, _util.getUA)().toLowerCase();
    if (name) target = _isChromeIOS(ua) ? TARGET_BLANK : name;
    if (_isFirefox(ua)) {
        // Firefox complains when invalid URLs are popped out. Hacky way to bypass.
        url = url || FIREFOX_EMPTY_URL;
        // Firefox disables by default scrolling on popup windows, which can create
        // issues when the user has many Google accounts, for instance.
        options.scrollbars = 'yes';
    }
    const optionsString = Object.entries(options).reduce((accum, [key, value])=>`${accum}${key}=${value},`, '');
    if (_isIOSStandalone(ua) && target !== '_self') {
        openAsNewWindowIOS(url || '', target);
        return new AuthPopup(null);
    }
    // about:blank getting sanitized causing browsers like IE/Edge to display
    // brief error message before redirecting to handler.
    const newWin = window.open(url || '', target, optionsString);
    _assert(newWin, auth, "popup-blocked" /* AuthErrorCode.POPUP_BLOCKED */ );
    // Flaky on IE edge, encapsulate with a try and catch.
    try {
        newWin.focus();
    } catch (e) {}
    return new AuthPopup(newWin);
}
function openAsNewWindowIOS(url, target) {
    const el = document.createElement('a');
    el.href = url;
    el.target = target;
    const click = document.createEvent('MouseEvent');
    click.initMouseEvent('click', true, true, window, 1, 0, 0, 0, 0, false, false, false, false, 1, null);
    el.dispatchEvent(click);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * URL for Authentication widget which will initiate the OAuth handshake
 *
 * @internal
 */ const WIDGET_PATH = '__/auth/handler';
/**
 * URL for emulated environment
 *
 * @internal
 */ const EMULATOR_WIDGET_PATH = 'emulator/auth/handler';
/**
 * Fragment name for the App Check token that gets passed to the widget
 *
 * @internal
 */ const FIREBASE_APP_CHECK_FRAGMENT_ID = encodeURIComponent('fac');
async function _getRedirectUrl(auth, provider, authType, redirectUrl, eventId, additionalParams) {
    _assert(auth.config.authDomain, auth, "auth-domain-config-required" /* AuthErrorCode.MISSING_AUTH_DOMAIN */ );
    _assert(auth.config.apiKey, auth, "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ );
    const params = {
        apiKey: auth.config.apiKey,
        appName: auth.name,
        authType,
        redirectUrl,
        v: (0, _app.SDK_VERSION),
        eventId
    };
    if (provider instanceof FederatedAuthProvider) {
        provider.setDefaultLanguage(auth.languageCode);
        params.providerId = provider.providerId || '';
        if (!(0, _util.isEmpty)(provider.getCustomParameters())) params.customParameters = JSON.stringify(provider.getCustomParameters());
        // TODO set additionalParams from the provider as well?
        for (const [key, value] of Object.entries(additionalParams || {}))params[key] = value;
    }
    if (provider instanceof BaseOAuthProvider) {
        const scopes = provider.getScopes().filter((scope)=>scope !== '');
        if (scopes.length > 0) params.scopes = scopes.join(',');
    }
    if (auth.tenantId) params.tid = auth.tenantId;
    // TODO: maybe set eid as endpointId
    // TODO: maybe set fw as Frameworks.join(",")
    const paramsDict = params;
    for (const key of Object.keys(paramsDict))if (paramsDict[key] === undefined) delete paramsDict[key];
    // Sets the App Check token to pass to the widget
    const appCheckToken = await auth._getAppCheckToken();
    const appCheckTokenFragment = appCheckToken ? `#${FIREBASE_APP_CHECK_FRAGMENT_ID}=${encodeURIComponent(appCheckToken)}` : '';
    // Start at index 1 to skip the leading '&' in the query string
    return `${getHandlerBase(auth)}?${(0, _util.querystring)(paramsDict).slice(1)}${appCheckTokenFragment}`;
}
function getHandlerBase({ config }) {
    if (!config.emulator) return `https://${config.authDomain}/${WIDGET_PATH}`;
    return _emulatorUrl(config, EMULATOR_WIDGET_PATH);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The special web storage event
 *
 */ const WEB_STORAGE_SUPPORT_KEY = 'webStorageSupport';
class BrowserPopupRedirectResolver {
    constructor(){
        this.eventManagers = {};
        this.iframes = {};
        this.originValidationPromises = {};
        this._redirectPersistence = browserSessionPersistence;
        this._completeRedirectFn = _getRedirectResult;
        this._overrideRedirectResult = _overrideRedirectResult;
    }
    // Wrapping in async even though we don't await anywhere in order
    // to make sure errors are raised as promise rejections
    async _openPopup(auth, provider, authType, eventId) {
        debugAssert(this.eventManagers[auth._key()]?.manager, '_initialize() not called before _openPopup()');
        const url = await _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);
        return _open(auth, url, _generateEventId());
    }
    async _openRedirect(auth, provider, authType, eventId) {
        await this._originValidation(auth);
        const url = await _getRedirectUrl(auth, provider, authType, _getCurrentUrl(), eventId);
        _setWindowLocation(url);
        return new Promise(()=>{});
    }
    _initialize(auth) {
        const key = auth._key();
        if (this.eventManagers[key]) {
            const { manager, promise } = this.eventManagers[key];
            if (manager) return Promise.resolve(manager);
            else {
                debugAssert(promise, 'If manager is not set, promise should be');
                return promise;
            }
        }
        const promise = this.initAndGetManager(auth);
        this.eventManagers[key] = {
            promise
        };
        // If the promise is rejected, the key should be removed so that the
        // operation can be retried later.
        promise.catch(()=>{
            delete this.eventManagers[key];
        });
        return promise;
    }
    async initAndGetManager(auth) {
        const iframe = await _openIframe(auth);
        const manager = new AuthEventManager(auth);
        iframe.register('authEvent', (iframeEvent)=>{
            _assert(iframeEvent?.authEvent, auth, "invalid-auth-event" /* AuthErrorCode.INVALID_AUTH_EVENT */ );
            // TODO: Consider splitting redirect and popup events earlier on
            const handled = manager.onEvent(iframeEvent.authEvent);
            return {
                status: handled ? "ACK" /* GapiOutcome.ACK */  : "ERROR" /* GapiOutcome.ERROR */ 
            };
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
        this.eventManagers[auth._key()] = {
            manager
        };
        this.iframes[auth._key()] = iframe;
        return manager;
    }
    _isIframeWebStorageSupported(auth, cb) {
        const iframe = this.iframes[auth._key()];
        iframe.send(WEB_STORAGE_SUPPORT_KEY, {
            type: WEB_STORAGE_SUPPORT_KEY
        }, (result)=>{
            const isSupported = result?.[0]?.[WEB_STORAGE_SUPPORT_KEY];
            if (isSupported !== undefined) cb(!!isSupported);
            _fail(auth, "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        }, gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER);
    }
    _originValidation(auth) {
        const key = auth._key();
        if (!this.originValidationPromises[key]) this.originValidationPromises[key] = _validateOrigin(auth);
        return this.originValidationPromises[key];
    }
    get _shouldInitProactively() {
        // Mobile browsers and Safari need to optimistically initialize
        return _isMobileBrowser() || _isSafari() || _isIOS();
    }
}
/**
 * An implementation of {@link PopupRedirectResolver} suitable for browser
 * based applications.
 *
 * @remarks
 * This method does not work in a Node.js environment.
 *
 * @public
 */ const browserPopupRedirectResolver = BrowserPopupRedirectResolver;
class MultiFactorAssertionImpl {
    constructor(factorId){
        this.factorId = factorId;
    }
    _process(auth, session, displayName) {
        switch(session.type){
            case "enroll" /* MultiFactorSessionType.ENROLL */ :
                return this._finalizeEnroll(auth, session.credential, displayName);
            case "signin" /* MultiFactorSessionType.SIGN_IN */ :
                return this._finalizeSignIn(auth, session.credential);
            default:
                return debugFail('unexpected MultiFactorSessionType');
        }
    }
}
/**
 * {@inheritdoc PhoneMultiFactorAssertion}
 *
 * @public
 */ class PhoneMultiFactorAssertionImpl extends MultiFactorAssertionImpl {
    constructor(credential){
        super("phone" /* FactorId.PHONE */ );
        this.credential = credential;
    }
    /** @internal */ static _fromCredential(credential) {
        return new PhoneMultiFactorAssertionImpl(credential);
    }
    /** @internal */ _finalizeEnroll(auth, idToken, displayName) {
        return finalizeEnrollPhoneMfa(auth, {
            idToken,
            displayName,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
    /** @internal */ _finalizeSignIn(auth, mfaPendingCredential) {
        return finalizeSignInPhoneMfa(auth, {
            mfaPendingCredential,
            phoneVerificationInfo: this.credential._makeVerificationRequest()
        });
    }
}
/**
 * Provider for generating a {@link PhoneMultiFactorAssertion}.
 *
 * @public
 */ class PhoneMultiFactorGenerator {
    constructor(){}
    /**
     * Provides a {@link PhoneMultiFactorAssertion} to confirm ownership of the phone second factor.
     *
     * @remarks
     * This method does not work in a Node.js environment.
     *
     * @param phoneAuthCredential - A credential provided by {@link PhoneAuthProvider.credential}.
     * @returns A {@link PhoneMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}
     */ static assertion(credential) {
        return PhoneMultiFactorAssertionImpl._fromCredential(credential);
    }
}
/**
 * The identifier of the phone second factor: `phone`.
 */ PhoneMultiFactorGenerator.FACTOR_ID = 'phone';
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * @public
 */ class TotpMultiFactorGenerator {
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of
     * the TOTP (time-based one-time password) second factor.
     * This assertion is used to complete enrollment in TOTP second factor.
     *
     * @param secret A {@link TotpSecret} containing the shared secret key and other TOTP parameters.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorUser.enroll}.
     */ static assertionForEnrollment(secret, oneTimePassword) {
        return TotpMultiFactorAssertionImpl._fromSecret(secret, oneTimePassword);
    }
    /**
     * Provides a {@link TotpMultiFactorAssertion} to confirm ownership of the TOTP second factor.
     * This assertion is used to complete signIn with TOTP as the second factor.
     *
     * @param enrollmentId identifies the enrolled TOTP second factor.
     * @param oneTimePassword One-time password from TOTP App.
     * @returns A {@link TotpMultiFactorAssertion} which can be used with
     * {@link MultiFactorResolver.resolveSignIn}.
     */ static assertionForSignIn(enrollmentId, oneTimePassword) {
        return TotpMultiFactorAssertionImpl._fromEnrollmentId(enrollmentId, oneTimePassword);
    }
    /**
     * Returns a promise to {@link TotpSecret} which contains the TOTP shared secret key and other parameters.
     * Creates a TOTP secret as part of enrolling a TOTP second factor.
     * Used for generating a QR code URL or inputting into a TOTP app.
     * This method uses the auth instance corresponding to the user in the multiFactorSession.
     *
     * @param session The {@link MultiFactorSession} that the user is part of.
     * @returns A promise to {@link TotpSecret}.
     */ static async generateSecret(session) {
        const mfaSession = session;
        _assert(typeof mfaSession.user?.auth !== 'undefined', "internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
        const response = await startEnrollTotpMfa(mfaSession.user.auth, {
            idToken: mfaSession.credential,
            totpEnrollmentInfo: {}
        });
        return TotpSecret._fromStartTotpMfaEnrollmentResponse(response, mfaSession.user.auth);
    }
}
/**
 * The identifier of the TOTP second factor: `totp`.
 */ TotpMultiFactorGenerator.FACTOR_ID = "totp" /* FactorId.TOTP */ ;
class TotpMultiFactorAssertionImpl extends MultiFactorAssertionImpl {
    constructor(otp, enrollmentId, secret){
        super("totp" /* FactorId.TOTP */ );
        this.otp = otp;
        this.enrollmentId = enrollmentId;
        this.secret = secret;
    }
    /** @internal */ static _fromSecret(secret, otp) {
        return new TotpMultiFactorAssertionImpl(otp, undefined, secret);
    }
    /** @internal */ static _fromEnrollmentId(enrollmentId, otp) {
        return new TotpMultiFactorAssertionImpl(otp, enrollmentId);
    }
    /** @internal */ async _finalizeEnroll(auth, idToken, displayName) {
        _assert(typeof this.secret !== 'undefined', auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        return finalizeEnrollTotpMfa(auth, {
            idToken,
            displayName,
            totpVerificationInfo: this.secret._makeTotpVerificationInfo(this.otp)
        });
    }
    /** @internal */ async _finalizeSignIn(auth, mfaPendingCredential) {
        _assert(this.enrollmentId !== undefined && this.otp !== undefined, auth, "argument-error" /* AuthErrorCode.ARGUMENT_ERROR */ );
        const totpVerificationInfo = {
            verificationCode: this.otp
        };
        return finalizeSignInTotpMfa(auth, {
            mfaPendingCredential,
            mfaEnrollmentId: this.enrollmentId,
            totpVerificationInfo
        });
    }
}
/**
 * Provider for generating a {@link TotpMultiFactorAssertion}.
 *
 * Stores the shared secret key and other parameters to generate time-based OTPs.
 * Implements methods to retrieve the shared secret key and generate a QR code URL.
 * @public
 */ class TotpSecret {
    // The public members are declared outside the constructor so the docs can be generated.
    constructor(secretKey, hashingAlgorithm, codeLength, codeIntervalSeconds, enrollmentCompletionDeadline, sessionInfo, auth){
        this.sessionInfo = sessionInfo;
        this.auth = auth;
        this.secretKey = secretKey;
        this.hashingAlgorithm = hashingAlgorithm;
        this.codeLength = codeLength;
        this.codeIntervalSeconds = codeIntervalSeconds;
        this.enrollmentCompletionDeadline = enrollmentCompletionDeadline;
    }
    /** @internal */ static _fromStartTotpMfaEnrollmentResponse(response, auth) {
        return new TotpSecret(response.totpSessionInfo.sharedSecretKey, response.totpSessionInfo.hashingAlgorithm, response.totpSessionInfo.verificationCodeLength, response.totpSessionInfo.periodSec, new Date(response.totpSessionInfo.finalizeEnrollmentTime).toUTCString(), response.totpSessionInfo.sessionInfo, auth);
    }
    /** @internal */ _makeTotpVerificationInfo(otp) {
        return {
            sessionInfo: this.sessionInfo,
            verificationCode: otp
        };
    }
    /**
     * Returns a QR code URL as described in
     * https://github.com/google/google-authenticator/wiki/Key-Uri-Format
     * This can be displayed to the user as a QR code to be scanned into a TOTP app like Google Authenticator.
     * If the optional parameters are unspecified, an accountName of <userEmail> and issuer of <firebaseAppName> are used.
     *
     * @param accountName the name of the account/app along with a user identifier.
     * @param issuer issuer of the TOTP (likely the app name).
     * @returns A QR code URL string.
     */ generateQrCodeUrl(accountName, issuer) {
        let useDefaults = false;
        if (_isEmptyString(accountName) || _isEmptyString(issuer)) useDefaults = true;
        if (useDefaults) {
            if (_isEmptyString(accountName)) accountName = this.auth.currentUser?.email || 'unknownuser';
            if (_isEmptyString(issuer)) issuer = this.auth.name;
        }
        return `otpauth://totp/${issuer}:${accountName}?secret=${this.secretKey}&issuer=${issuer}&algorithm=${this.hashingAlgorithm}&digits=${this.codeLength}`;
    }
}
/** @internal */ function _isEmptyString(input) {
    return typeof input === 'undefined' || input?.length === 0;
}
var name = "@firebase/auth";
var version = "1.13.3";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class AuthInterop {
    constructor(auth){
        this.auth = auth;
        this.internalListeners = new Map();
    }
    getUid() {
        this.assertAuthConfigured();
        return this.auth.currentUser?.uid || null;
    }
    async getToken(forceRefresh) {
        this.assertAuthConfigured();
        await this.auth._initializationPromise;
        if (!this.auth.currentUser) return null;
        const accessToken = await this.auth.currentUser.getIdToken(forceRefresh);
        return {
            accessToken
        };
    }
    addAuthTokenListener(listener) {
        this.assertAuthConfigured();
        if (this.internalListeners.has(listener)) return;
        const unsubscribe = this.auth.onIdTokenChanged((user)=>{
            listener(user?.stsTokenManager.accessToken || null);
        });
        this.internalListeners.set(listener, unsubscribe);
        this.updateProactiveRefresh();
    }
    removeAuthTokenListener(listener) {
        this.assertAuthConfigured();
        const unsubscribe = this.internalListeners.get(listener);
        if (!unsubscribe) return;
        this.internalListeners.delete(listener);
        unsubscribe();
        this.updateProactiveRefresh();
    }
    assertAuthConfigured() {
        _assert(this.auth._initializationPromise, "dependent-sdk-initialized-before-auth" /* AuthErrorCode.DEPENDENT_SDK_INIT_BEFORE_AUTH */ );
    }
    updateProactiveRefresh() {
        if (this.internalListeners.size > 0) this.auth._startProactiveRefresh();
        else this.auth._stopProactiveRefresh();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getVersionForPlatform(clientPlatform) {
    switch(clientPlatform){
        case "Node" /* ClientPlatform.NODE */ :
            return 'node';
        case "ReactNative" /* ClientPlatform.REACT_NATIVE */ :
            return 'rn';
        case "Worker" /* ClientPlatform.WORKER */ :
            return 'webworker';
        case "Cordova" /* ClientPlatform.CORDOVA */ :
            return 'cordova';
        case "WebExtension" /* ClientPlatform.WEB_EXTENSION */ :
            return 'web-extension';
        default:
            return undefined;
    }
}
/** @internal */ function registerAuth(clientPlatform) {
    (0, _app._registerComponent)(new (0, _component.Component)("auth" /* _ComponentName.AUTH */ , (container, { options: deps })=>{
        const app = container.getProvider('app').getImmediate();
        const heartbeatServiceProvider = container.getProvider('heartbeat');
        const appCheckServiceProvider = container.getProvider('app-check-internal');
        const { apiKey, authDomain } = app.options;
        _assert(apiKey && !apiKey.includes(':'), "invalid-api-key" /* AuthErrorCode.INVALID_API_KEY */ , {
            appName: app.name
        });
        const config = {
            apiKey,
            authDomain,
            clientPlatform,
            apiHost: "identitytoolkit.googleapis.com" /* DefaultConfig.API_HOST */ ,
            tokenApiHost: "securetoken.googleapis.com" /* DefaultConfig.TOKEN_API_HOST */ ,
            apiScheme: "https" /* DefaultConfig.API_SCHEME */ ,
            sdkClientVersion: _getClientVersion(clientPlatform)
        };
        const authInstance = new AuthImpl(app, heartbeatServiceProvider, appCheckServiceProvider, config);
        _initializeAuthInstance(authInstance, deps);
        return authInstance;
    }, "PUBLIC" /* ComponentType.PUBLIC */ )/**
         * Auth can only be initialized by explicitly calling getAuth() or initializeAuth()
         * For why we do this, See go/firebase-next-auth-init
         */ .setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ )/**
         * Because all firebase products that depend on auth depend on auth-internal directly,
         * we need to initialize auth-internal after auth is initialized to make it available to other firebase products.
         */ .setInstanceCreatedCallback((container, _instanceIdentifier, _instance)=>{
        const authInternalProvider = container.getProvider("auth-internal" /* _ComponentName.AUTH_INTERNAL */ );
        authInternalProvider.initialize();
    }));
    (0, _app._registerComponent)(new (0, _component.Component)("auth-internal" /* _ComponentName.AUTH_INTERNAL */ , (container)=>{
        const auth = _castAuth(container.getProvider("auth" /* _ComponentName.AUTH */ ).getImmediate());
        return ((auth)=>new AuthInterop(auth))(auth);
    }, "PRIVATE" /* ComponentType.PRIVATE */ ).setInstantiationMode("EXPLICIT" /* InstantiationMode.EXPLICIT */ ));
    (0, _app.registerVersion)(name, version, getVersionForPlatform(clientPlatform));
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, _app.registerVersion)(name, version, 'esm2020');
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DEFAULT_ID_TOKEN_MAX_AGE = 300;
const authIdTokenMaxAge = (0, _util.getExperimentalSetting)('authIdTokenMaxAge') || DEFAULT_ID_TOKEN_MAX_AGE;
let lastPostedIdToken = null;
const mintCookieFactory = (url)=>async (user)=>{
        const idTokenResult = user && await user.getIdTokenResult();
        const idTokenAge = idTokenResult && (new Date().getTime() - Date.parse(idTokenResult.issuedAtTime)) / 1000;
        if (idTokenAge && idTokenAge > authIdTokenMaxAge) return;
        // Specifically trip null => undefined when logged out, to delete any existing cookie
        const idToken = idTokenResult?.token;
        if (lastPostedIdToken === idToken) return;
        lastPostedIdToken = idToken;
        await fetch(url, {
            method: idToken ? 'POST' : 'DELETE',
            headers: idToken ? {
                'Authorization': `Bearer ${idToken}`
            } : {}
        });
    };
/**
 * Returns the Auth instance associated with the provided {@link @firebase/app#FirebaseApp}.
 * If no instance exists, initializes an Auth instance with platform-specific default dependencies.
 *
 * @param app - The Firebase App.
 *
 * @public
 */ function getAuth(app = (0, _app.getApp)()) {
    const provider = (0, _app._getProvider)(app, 'auth');
    if (provider.isInitialized()) return provider.getImmediate();
    const auth = initializeAuth(app, {
        popupRedirectResolver: browserPopupRedirectResolver,
        persistence: [
            indexedDBLocalPersistence,
            browserLocalPersistence,
            browserSessionPersistence
        ]
    });
    const authTokenSyncPath = (0, _util.getExperimentalSetting)('authTokenSyncURL');
    // Only do the Cookie exchange in a secure context
    if (authTokenSyncPath && typeof isSecureContext === 'boolean' && isSecureContext) {
        // Don't allow urls (XSS possibility), only paths on the same domain
        const authTokenSyncUrl = new URL(authTokenSyncPath, location.origin);
        if (location.origin === authTokenSyncUrl.origin) {
            const mintCookie = mintCookieFactory(authTokenSyncUrl.toString());
            beforeAuthStateChanged(auth, mintCookie, ()=>mintCookie(auth.currentUser));
            onIdTokenChanged(auth, (user)=>mintCookie(user));
        }
    }
    const authEmulatorHost = (0, _util.getDefaultEmulatorHost)('auth');
    if (authEmulatorHost) connectAuthEmulator(auth, `http://${authEmulatorHost}`);
    return auth;
}
function getScriptParentElement() {
    return document.getElementsByTagName('head')?.[0] ?? document;
}
_setExternalJSProvider({
    loadJS (url) {
        // TODO: consider adding timeout support & cancellation
        return new Promise((resolve, reject)=>{
            const el = document.createElement('script');
            el.setAttribute('src', url);
            el.onload = resolve;
            el.onerror = (e)=>{
                const error = _createError("internal-error" /* AuthErrorCode.INTERNAL_ERROR */ );
                error.customData = e;
                reject(error);
            };
            el.type = 'text/javascript';
            el.charset = 'UTF-8';
            getScriptParentElement().appendChild(el);
        });
    },
    gapiScript: 'https://apis.google.com/js/api.js',
    recaptchaV2Script: 'https://www.google.com/recaptcha/api.js',
    recaptchaEnterpriseScript: 'https://www.google.com/recaptcha/enterprise.js?render='
});
registerAuth("Browser" /* ClientPlatform.BROWSER */ );

},{"@firebase/app":"iO7sa","@firebase/util":"fHqXn","@firebase/logger":"kY52V","@firebase/component":"6VF6E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5IgBQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _firestore = require("@firebase/firestore");
parcelHelpers.exportAll(_firestore, exports);

},{"@firebase/firestore":"2Ioht","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Ioht":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbstractUserDataWriter", ()=>(0, _common456515BaEsmJs.A));
parcelHelpers.export(exports, "Bytes", ()=>(0, _common456515BaEsmJs.B));
parcelHelpers.export(exports, "CACHE_SIZE_UNLIMITED", ()=>(0, _common456515BaEsmJs.ax));
parcelHelpers.export(exports, "CollectionReference", ()=>(0, _common456515BaEsmJs.ay));
parcelHelpers.export(exports, "DocumentReference", ()=>(0, _common456515BaEsmJs.D));
parcelHelpers.export(exports, "FieldPath", ()=>(0, _common456515BaEsmJs.a0));
parcelHelpers.export(exports, "FieldValue", ()=>(0, _common456515BaEsmJs.az));
parcelHelpers.export(exports, "Firestore", ()=>(0, _common456515BaEsmJs.F));
parcelHelpers.export(exports, "FirestoreError", ()=>(0, _common456515BaEsmJs.d));
parcelHelpers.export(exports, "GeoPoint", ()=>(0, _common456515BaEsmJs.aA));
parcelHelpers.export(exports, "LoadBundleTask", ()=>(0, _common456515BaEsmJs.aB));
parcelHelpers.export(exports, "Query", ()=>(0, _common456515BaEsmJs.Q));
parcelHelpers.export(exports, "Timestamp", ()=>(0, _common456515BaEsmJs.aC));
parcelHelpers.export(exports, "VectorValue", ()=>(0, _common456515BaEsmJs.aD));
parcelHelpers.export(exports, "_AutoId", ()=>(0, _common456515BaEsmJs.T));
parcelHelpers.export(exports, "_ByteString", ()=>(0, _common456515BaEsmJs.aE));
parcelHelpers.export(exports, "_DatabaseId", ()=>(0, _common456515BaEsmJs.aF));
parcelHelpers.export(exports, "_DocumentKey", ()=>(0, _common456515BaEsmJs.v));
parcelHelpers.export(exports, "_EmptyAppCheckTokenProvider", ()=>(0, _common456515BaEsmJs.aG));
parcelHelpers.export(exports, "_EmptyAuthCredentialsProvider", ()=>(0, _common456515BaEsmJs.aH));
parcelHelpers.export(exports, "_FieldPath", ()=>(0, _common456515BaEsmJs.aI));
parcelHelpers.export(exports, "_cast", ()=>(0, _common456515BaEsmJs.y));
parcelHelpers.export(exports, "_debugAssert", ()=>(0, _common456515BaEsmJs.aJ));
parcelHelpers.export(exports, "_internalAggregationQueryToProtoRunAggregationQueryRequest", ()=>(0, _common456515BaEsmJs.aK));
parcelHelpers.export(exports, "_internalQueryToProtoQueryTarget", ()=>(0, _common456515BaEsmJs.aL));
parcelHelpers.export(exports, "_isBase64Available", ()=>(0, _common456515BaEsmJs.aM));
parcelHelpers.export(exports, "_logWarn", ()=>(0, _common456515BaEsmJs.ag));
parcelHelpers.export(exports, "_validateIsNotUsedTogether", ()=>(0, _common456515BaEsmJs.aN));
parcelHelpers.export(exports, "arrayRemove", ()=>(0, _common456515BaEsmJs.aO));
parcelHelpers.export(exports, "arrayUnion", ()=>(0, _common456515BaEsmJs.aP));
parcelHelpers.export(exports, "clearIndexedDbPersistence", ()=>(0, _common456515BaEsmJs.aQ));
parcelHelpers.export(exports, "collection", ()=>(0, _common456515BaEsmJs.aR));
parcelHelpers.export(exports, "collectionGroup", ()=>(0, _common456515BaEsmJs.aS));
parcelHelpers.export(exports, "connectFirestoreEmulator", ()=>(0, _common456515BaEsmJs.aT));
parcelHelpers.export(exports, "deleteField", ()=>(0, _common456515BaEsmJs.aU));
parcelHelpers.export(exports, "disableNetwork", ()=>(0, _common456515BaEsmJs.aV));
parcelHelpers.export(exports, "doc", ()=>(0, _common456515BaEsmJs.a9));
parcelHelpers.export(exports, "documentId", ()=>(0, _common456515BaEsmJs.aW));
parcelHelpers.export(exports, "enableIndexedDbPersistence", ()=>(0, _common456515BaEsmJs.aX));
parcelHelpers.export(exports, "enableMultiTabIndexedDbPersistence", ()=>(0, _common456515BaEsmJs.aY));
parcelHelpers.export(exports, "enableNetwork", ()=>(0, _common456515BaEsmJs.aZ));
parcelHelpers.export(exports, "ensureFirestoreConfigured", ()=>(0, _common456515BaEsmJs.z));
parcelHelpers.export(exports, "getFirestore", ()=>(0, _common456515BaEsmJs.a_));
parcelHelpers.export(exports, "increment", ()=>(0, _common456515BaEsmJs.a$));
parcelHelpers.export(exports, "initializeFirestore", ()=>(0, _common456515BaEsmJs.b0));
parcelHelpers.export(exports, "loadBundle", ()=>(0, _common456515BaEsmJs.ac));
parcelHelpers.export(exports, "maximum", ()=>(0, _common456515BaEsmJs.b1));
parcelHelpers.export(exports, "minimum", ()=>(0, _common456515BaEsmJs.b2));
parcelHelpers.export(exports, "namedQuery", ()=>(0, _common456515BaEsmJs.ad));
parcelHelpers.export(exports, "queryEqual", ()=>(0, _common456515BaEsmJs.x));
parcelHelpers.export(exports, "refEqual", ()=>(0, _common456515BaEsmJs.b3));
parcelHelpers.export(exports, "serverTimestamp", ()=>(0, _common456515BaEsmJs.b4));
parcelHelpers.export(exports, "setLogLevel", ()=>(0, _common456515BaEsmJs.b5));
parcelHelpers.export(exports, "terminate", ()=>(0, _common456515BaEsmJs.b6));
parcelHelpers.export(exports, "vector", ()=>(0, _common456515BaEsmJs.b7));
parcelHelpers.export(exports, "waitForPendingWrites", ()=>(0, _common456515BaEsmJs.b8));
parcelHelpers.export(exports, "AggregateField", ()=>AggregateField);
parcelHelpers.export(exports, "AggregateQuerySnapshot", ()=>AggregateQuerySnapshot);
parcelHelpers.export(exports, "DocumentSnapshot", ()=>DocumentSnapshot);
parcelHelpers.export(exports, "PersistentCacheIndexManager", ()=>PersistentCacheIndexManager);
parcelHelpers.export(exports, "QueryCompositeFilterConstraint", ()=>QueryCompositeFilterConstraint);
parcelHelpers.export(exports, "QueryConstraint", ()=>QueryConstraint);
parcelHelpers.export(exports, "QueryDocumentSnapshot", ()=>QueryDocumentSnapshot);
parcelHelpers.export(exports, "QueryEndAtConstraint", ()=>QueryEndAtConstraint);
parcelHelpers.export(exports, "QueryFieldFilterConstraint", ()=>QueryFieldFilterConstraint);
parcelHelpers.export(exports, "QueryLimitConstraint", ()=>QueryLimitConstraint);
parcelHelpers.export(exports, "QueryOrderByConstraint", ()=>QueryOrderByConstraint);
parcelHelpers.export(exports, "QuerySnapshot", ()=>QuerySnapshot);
parcelHelpers.export(exports, "QueryStartAtConstraint", ()=>QueryStartAtConstraint);
parcelHelpers.export(exports, "SnapshotMetadata", ()=>SnapshotMetadata);
parcelHelpers.export(exports, "Transaction", ()=>Transaction);
parcelHelpers.export(exports, "WriteBatch", ()=>WriteBatch);
parcelHelpers.export(exports, "_TestingHooks", ()=>TestingHooks);
parcelHelpers.export(exports, "addDoc", ()=>addDoc);
parcelHelpers.export(exports, "aggregateFieldEqual", ()=>aggregateFieldEqual);
parcelHelpers.export(exports, "aggregateQuerySnapshotEqual", ()=>aggregateQuerySnapshotEqual);
parcelHelpers.export(exports, "and", ()=>and);
parcelHelpers.export(exports, "average", ()=>average);
parcelHelpers.export(exports, "count", ()=>count);
parcelHelpers.export(exports, "deleteAllPersistentCacheIndexes", ()=>deleteAllPersistentCacheIndexes);
parcelHelpers.export(exports, "deleteDoc", ()=>deleteDoc);
parcelHelpers.export(exports, "disablePersistentCacheIndexAutoCreation", ()=>disablePersistentCacheIndexAutoCreation);
parcelHelpers.export(exports, "documentSnapshotFromJSON", ()=>documentSnapshotFromJSON);
parcelHelpers.export(exports, "enablePersistentCacheIndexAutoCreation", ()=>enablePersistentCacheIndexAutoCreation);
parcelHelpers.export(exports, "endAt", ()=>endAt);
parcelHelpers.export(exports, "endBefore", ()=>endBefore);
parcelHelpers.export(exports, "executeWrite", ()=>executeWrite);
parcelHelpers.export(exports, "getAggregateFromServer", ()=>getAggregateFromServer);
parcelHelpers.export(exports, "getCountFromServer", ()=>getCountFromServer);
parcelHelpers.export(exports, "getDoc", ()=>getDoc);
parcelHelpers.export(exports, "getDocFromCache", ()=>getDocFromCache);
parcelHelpers.export(exports, "getDocFromServer", ()=>getDocFromServer);
parcelHelpers.export(exports, "getDocs", ()=>getDocs);
parcelHelpers.export(exports, "getDocsFromCache", ()=>getDocsFromCache);
parcelHelpers.export(exports, "getDocsFromServer", ()=>getDocsFromServer);
parcelHelpers.export(exports, "getPersistentCacheIndexManager", ()=>getPersistentCacheIndexManager);
parcelHelpers.export(exports, "limit", ()=>limit);
parcelHelpers.export(exports, "limitToLast", ()=>limitToLast);
parcelHelpers.export(exports, "memoryEagerGarbageCollector", ()=>memoryEagerGarbageCollector);
parcelHelpers.export(exports, "memoryLocalCache", ()=>memoryLocalCache);
parcelHelpers.export(exports, "memoryLruGarbageCollector", ()=>memoryLruGarbageCollector);
parcelHelpers.export(exports, "onSnapshot", ()=>onSnapshot);
parcelHelpers.export(exports, "onSnapshotResume", ()=>onSnapshotResume);
parcelHelpers.export(exports, "onSnapshotsInSync", ()=>onSnapshotsInSync);
parcelHelpers.export(exports, "or", ()=>or);
parcelHelpers.export(exports, "orderBy", ()=>orderBy);
parcelHelpers.export(exports, "persistentLocalCache", ()=>persistentLocalCache);
parcelHelpers.export(exports, "persistentMultipleTabManager", ()=>persistentMultipleTabManager);
parcelHelpers.export(exports, "persistentSingleTabManager", ()=>persistentSingleTabManager);
parcelHelpers.export(exports, "query", ()=>query);
parcelHelpers.export(exports, "querySnapshotFromJSON", ()=>querySnapshotFromJSON);
parcelHelpers.export(exports, "runTransaction", ()=>runTransaction);
parcelHelpers.export(exports, "setDoc", ()=>setDoc);
parcelHelpers.export(exports, "setIndexConfiguration", ()=>setIndexConfiguration);
parcelHelpers.export(exports, "snapshotEqual", ()=>snapshotEqual);
parcelHelpers.export(exports, "startAfter", ()=>startAfter);
parcelHelpers.export(exports, "startAt", ()=>startAt);
parcelHelpers.export(exports, "sum", ()=>sum);
parcelHelpers.export(exports, "updateDoc", ()=>updateDoc);
parcelHelpers.export(exports, "where", ()=>where);
parcelHelpers.export(exports, "writeBatch", ()=>writeBatch);
var _app = require("@firebase/app");
var _component = require("@firebase/component");
var _common456515BaEsmJs = require("./common-456515ba.esm.js");
var _util = require("@firebase/util");
var _bloomBlob = require("@firebase/webchannel-wrapper/bloom-blob");
var _logger = require("@firebase/logger");
var _webchannelBlob = require("@firebase/webchannel-wrapper/webchannel-blob");
var _re2Js = require("re2js");
const Yt = "@firebase/firestore", Kt = "4.16.0";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_isPartialObserver(t) {
    /**
 * Returns true if obj is an object and contains at least one of the specified
 * methods.
 */ return function __PRIVATE_implementsAnyMethods(t, e) {
        if ("object" != typeof t || null === t) return !1;
        const n = t;
        for (const t of e)if (t in n && "function" == typeof n[t]) return !0;
        return !1;
    }(t, [
        "next",
        "error",
        "complete"
    ]);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an aggregation that can be performed by Firestore.
 */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
class AggregateField {
    /**
     * Create a new AggregateField<T>
     * @param aggregateType - Specifies the type of aggregation operation to perform.
     * @param _internalFieldPath - Optionally specifies the field that is aggregated.
     * @internal
     */ constructor(t = "count", e){
        this._internalFieldPath = e, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateField", this.aggregateType = t;
    }
}
/**
 * The results of executing an aggregation query.
 */ class AggregateQuerySnapshot {
    /** @hideconstructor */ constructor(t, e, n){
        this._userDataWriter = e, this._data = n, /** A type string to uniquely identify instances of this class. */ this.type = "AggregateQuerySnapshot", this.query = t;
    }
    /**
     * Returns the results of the aggregations performed over the underlying
     * query.
     *
     * The keys of the returned object will be the same as those of the
     * `AggregateSpec` object specified to the aggregation method, and the values
     * will be the corresponding aggregation result.
     *
     * @returns The results of the aggregations performed over the underlying
     * query.
     */ data() {
        return this._userDataWriter.convertObjectMap(this._data);
    }
    /**
     * @internal
     * @private
     *
     * Retrieves all fields in the snapshot as a proto value.
     *
     * @returns An `Object` containing all fields in the snapshot.
     */ _fieldsProto() {
        // Return the cloned value to prevent manipulation of the Snapshot's data
        return new (0, _common456515BaEsmJs.O)({
            mapValue: {
                fields: this._data
            }
        }).clone().value.mapValue.fields;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class DocumentSnapshot$1 {
    // Note: This class is stripped down version of the DocumentSnapshot in
    // the legacy SDK. The changes are:
    // - No support for SnapshotMetadata.
    // - No support for SnapshotOptions.
    /** @hideconstructor protected */ constructor(t, e, n, r, s){
        this._firestore = t, this._userDataWriter = e, this._key = n, this._document = r, this._converter = s;
    }
    /** Property of the `DocumentSnapshot` that provides the document's ID. */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * The `DocumentReference` for the document included in the `DocumentSnapshot`.
     */ get ref() {
        return new (0, _common456515BaEsmJs.D)(this._firestore, this._converter, this._key);
    }
    /**
     * Signals whether or not the document at the snapshot's location exists.
     *
     * @returns true if the document exists.
     */ exists() {
        return null !== this._document;
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ data() {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const t = new QueryDocumentSnapshot$1(this._firestore, this._userDataWriter, this._key, this._document, /* converter= */ null);
                return this._converter.fromFirestore(t);
            }
            return this._userDataWriter.convertValue(this._document.data.value);
        }
    }
    /**
     * @internal
     * @private
     *
     * Retrieves all fields in the document as a proto Value. Returns `undefined` if
     * the document doesn't exist.
     *
     * @returns An `Object` containing all fields in the document or `undefined`
     * if the document doesn't exist.
     */ _fieldsProto() {
        // Return a cloned value to prevent manipulation of the Snapshot's data
        return this._document?.data.clone().value.mapValue.fields ?? void 0;
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t) {
        if (this._document) {
            const e = this._document.data.field((0, _common456515BaEsmJs.j)("DocumentSnapshot.get", t));
            if (null !== e) return this._userDataWriter.convertValue(e);
        }
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ class QueryDocumentSnapshot$1 extends DocumentSnapshot$1 {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * @override
     * @returns An `Object` containing all fields in the document.
     */ data() {
        return super.data();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_validateHasExplicitOrderByForLimitToLast(t) {
    if ("L" /* LimitType.Last */  === t.limitType && 0 === t.explicitOrderBy.length) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).UNIMPLEMENTED, "limitToLast() queries require specifying at least one orderBy() clause");
}
/**
 * An `AppliableConstraint` is an abstraction of a constraint that can be applied
 * to a Firestore query.
 */ class AppliableConstraint {
}
/**
 * A `QueryConstraint` is used to narrow the set of documents returned by a
 * Firestore query. `QueryConstraint`s are created by invoking {@link where},
 * {@link orderBy}, {@link (startAt:1)}, {@link (startAfter:1)}, {@link
 * (endBefore:1)}, {@link (endAt:1)}, {@link limit}, {@link limitToLast} and
 * can then be passed to {@link (query:1)} to create a new query instance that
 * also contains this `QueryConstraint`.
 */ class QueryConstraint extends AppliableConstraint {
}
function query(t, e, ...n) {
    let r = [];
    e instanceof AppliableConstraint && r.push(e), r = r.concat(n), function __PRIVATE_validateQueryConstraintArray(t) {
        const e = t.filter((t)=>t instanceof QueryCompositeFilterConstraint).length, n = t.filter((t)=>t instanceof QueryFieldFilterConstraint).length;
        if (e > 1 || e > 0 && n > 0) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, "InvalidQuery. When using composite filters, you cannot use more than one filter at the top level. Consider nesting the multiple filters within an `and(...)` statement. For example: change `query(query, where(...), or(...))` to `query(query, and(where(...), or(...)))`.");
    }(r);
    for (const e of r)t = e._apply(t);
    return t;
}
/**
 * A `QueryFieldFilterConstraint` is used to narrow the set of documents returned by
 * a Firestore query by filtering on one or more document fields.
 * `QueryFieldFilterConstraint`s are created by invoking {@link where} and can then
 * be passed to {@link (query:1)} to create a new query instance that also contains
 * this `QueryFieldFilterConstraint`.
 */ class QueryFieldFilterConstraint extends QueryConstraint {
    /**
     * @internal
     */ constructor(t, e, n){
        super(), this._field = t, this._op = e, this._value = n, /** The type of this query constraint */ this.type = "where";
    }
    static _create(t, e, n) {
        return new QueryFieldFilterConstraint(t, e, n);
    }
    _apply(t) {
        const e = this._parse(t);
        return __PRIVATE_validateNewFieldFilter(t._query, e), new (0, _common456515BaEsmJs.Q)(t.firestore, t.converter, (0, _common456515BaEsmJs.f)(t._query, e));
    }
    _parse(t) {
        const e = (0, _common456515BaEsmJs.g)(t.firestore), n = function __PRIVATE_newQueryFilter(t, e, n, r, s, a, o) {
            let i;
            if (s.isKeyField()) {
                if ("array-contains" /* Operator.ARRAY_CONTAINS */  === a || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === a) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Invalid Query. You can't perform '${a}' queries on documentId().`);
                if ("in" /* Operator.IN */  === a || "not-in" /* Operator.NOT_IN */  === a) {
                    __PRIVATE_validateDisjunctiveFilterElements(o, a);
                    const e = [];
                    for (const n of o)e.push(__PRIVATE_parseDocumentIdValue(r, t, n));
                    i = {
                        arrayValue: {
                            values: e
                        }
                    };
                } else i = __PRIVATE_parseDocumentIdValue(r, t, o);
            } else "in" /* Operator.IN */  !== a && "not-in" /* Operator.NOT_IN */  !== a && "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  !== a || __PRIVATE_validateDisjunctiveFilterElements(o, a), i = (0, _common456515BaEsmJs.h)(n, e, o, /* allowArrays= */ "in" /* Operator.IN */  === a || "not-in" /* Operator.NOT_IN */  === a);
            const c = (0, _common456515BaEsmJs.i).create(s, a, i);
            return c;
        }(t._query, "where", e, t.firestore._databaseId, this._field, this._op, this._value);
        return n;
    }
}
/**
 * Creates a {@link QueryFieldFilterConstraint} that enforces that documents
 * must contain the specified field and that the value should satisfy the
 * relation constraint provided.
 *
 * @param fieldPath - The path to compare
 * @param opStr - The operation string (e.g "&lt;", "&lt;=", "==", "&lt;",
 *   "&lt;=", "!=").
 * @param value - The value for comparison
 * @returns The created {@link QueryFieldFilterConstraint}.
 */ function where(t, e, n) {
    const r = e, s = (0, _common456515BaEsmJs.j)("where", t);
    return QueryFieldFilterConstraint._create(s, r, n);
}
/**
 * A `QueryCompositeFilterConstraint` is used to narrow the set of documents
 * returned by a Firestore query by performing the logical OR or AND of multiple
 * {@link QueryFieldFilterConstraint}s or {@link QueryCompositeFilterConstraint}s.
 * `QueryCompositeFilterConstraint`s are created by invoking {@link or} or
 * {@link and} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains the `QueryCompositeFilterConstraint`.
 */ class QueryCompositeFilterConstraint extends AppliableConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e){
        super(), this.type = t, this._queryConstraints = e;
    }
    static _create(t, e) {
        return new QueryCompositeFilterConstraint(t, e);
    }
    _parse(t) {
        const e = this._queryConstraints.map((e)=>e._parse(t)).filter((t)=>t.getFilters().length > 0);
        return 1 === e.length ? e[0] : (0, _common456515BaEsmJs.C).create(e, this._getOperator());
    }
    _apply(t) {
        const e = this._parse(t);
        return 0 === e.getFilters().length ? t : (function __PRIVATE_validateNewFilter(t, e) {
            let n = t;
            const r = e.getFlattenedFilters();
            for (const t of r)__PRIVATE_validateNewFieldFilter(n, t), n = (0, _common456515BaEsmJs.f)(n, t);
        }(t._query, e), new (0, _common456515BaEsmJs.Q)(t.firestore, t.converter, (0, _common456515BaEsmJs.f)(t._query, e)));
    }
    _getQueryConstraints() {
        return this._queryConstraints;
    }
    _getOperator() {
        return "and" === this.type ? "and" /* CompositeOperator.AND */  : "or" /* CompositeOperator.OR */ ;
    }
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a disjunction of
 * the given filter constraints. A disjunction filter includes a document if it
 * satisfies any of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a disjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function or(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>__PRIVATE_validateQueryFilterConstraint("or", t)), QueryCompositeFilterConstraint._create("or" /* CompositeOperator.OR */ , t);
}
/**
 * Creates a new {@link QueryCompositeFilterConstraint} that is a conjunction of
 * the given filter constraints. A conjunction filter includes a document if it
 * satisfies all of the given filters.
 *
 * @param queryConstraints - Optional. The list of
 * {@link QueryFilterConstraint}s to perform a conjunction for. These must be
 * created with calls to {@link where}, {@link or}, or {@link and}.
 * @returns The newly created {@link QueryCompositeFilterConstraint}.
 */ function and(...t) {
    // Only support QueryFilterConstraints
    return t.forEach((t)=>__PRIVATE_validateQueryFilterConstraint("and", t)), QueryCompositeFilterConstraint._create("and" /* CompositeOperator.AND */ , t);
}
/**
 * A `QueryOrderByConstraint` is used to sort the set of documents returned by a
 * Firestore query. `QueryOrderByConstraint`s are created by invoking
 * {@link orderBy} and can then be passed to {@link (query:1)} to create a new query
 * instance that also contains this `QueryOrderByConstraint`.
 *
 * Note: Documents that do not contain the orderBy field will not be present in
 * the query result.
 */ class QueryOrderByConstraint extends QueryConstraint {
    /**
     * @internal
     */ constructor(t, e){
        super(), this._field = t, this._direction = e, /** The type of this query constraint */ this.type = "orderBy";
    }
    static _create(t, e) {
        return new QueryOrderByConstraint(t, e);
    }
    _apply(t) {
        const e = function __PRIVATE_newQueryOrderBy(t, e, n) {
            if (null !== t.startAt) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, "Invalid query. You must not call startAt() or startAfter() before calling orderBy().");
            if (null !== t.endAt) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, "Invalid query. You must not call endAt() or endBefore() before calling orderBy().");
            const r = new (0, _common456515BaEsmJs.aq)(e, n);
            return r;
        }(t._query, this._field, this._direction);
        return new (0, _common456515BaEsmJs.Q)(t.firestore, t.converter, (0, _common456515BaEsmJs.k)(t._query, e));
    }
}
/**
 * Creates a {@link QueryOrderByConstraint} that sorts the query result by the
 * specified field, optionally in descending order instead of ascending.
 *
 * Note: Documents that do not contain the specified field will not be present
 * in the query result.
 *
 * @param fieldPath - The field to sort by.
 * @param directionStr - Optional direction to sort by ('asc' or 'desc'). If
 * not specified, order will be ascending.
 * @returns The created {@link QueryOrderByConstraint}.
 */ function orderBy(t, e = "asc") {
    const n = e, r = (0, _common456515BaEsmJs.j)("orderBy", t);
    return QueryOrderByConstraint._create(r, n);
}
/**
 * A `QueryLimitConstraint` is used to limit the number of documents returned by
 * a Firestore query.
 * `QueryLimitConstraint`s are created by invoking {@link limit} or
 * {@link limitToLast} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryLimitConstraint`.
 */ class QueryLimitConstraint extends QueryConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._limit = e, this._limitType = n;
    }
    static _create(t, e, n) {
        return new QueryLimitConstraint(t, e, n);
    }
    _apply(t) {
        return new (0, _common456515BaEsmJs.Q)(t.firestore, t.converter, (0, _common456515BaEsmJs.l)(t._query, this._limit, this._limitType));
    }
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the first matching
 * documents.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function limit(t) {
    return (0, _common456515BaEsmJs.m)("limit", t), QueryLimitConstraint._create("limit", t, "F" /* LimitType.First */ );
}
/**
 * Creates a {@link QueryLimitConstraint} that only returns the last matching
 * documents.
 *
 * You must specify at least one `orderBy` clause for `limitToLast` queries,
 * otherwise an exception will be thrown during execution.
 *
 * @param limit - The maximum number of items to return.
 * @returns The created {@link QueryLimitConstraint}.
 */ function limitToLast(t) {
    return (0, _common456515BaEsmJs.m)("limitToLast", t), QueryLimitConstraint._create("limitToLast", t, "L" /* LimitType.Last */ );
}
/**
 * A `QueryStartAtConstraint` is used to exclude documents from the start of a
 * result set returned by a Firestore query.
 * `QueryStartAtConstraint`s are created by invoking {@link (startAt:1)} or
 * {@link (startAfter:1)} and can then be passed to {@link (query:1)} to create a
 * new query instance that also contains this `QueryStartAtConstraint`.
 */ class QueryStartAtConstraint extends QueryConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new QueryStartAtConstraint(t, e, n);
    }
    _apply(t) {
        const e = __PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new (0, _common456515BaEsmJs.Q)(t.firestore, t.converter, (0, _common456515BaEsmJs.n)(t._query, e));
    }
}
function startAt(...t) {
    return QueryStartAtConstraint._create("startAt", t, /*inclusive=*/ !0);
}
function startAfter(...t) {
    return QueryStartAtConstraint._create("startAfter", t, /*inclusive=*/ !1);
}
/**
 * A `QueryEndAtConstraint` is used to exclude documents from the end of a
 * result set returned by a Firestore query.
 * `QueryEndAtConstraint`s are created by invoking {@link (endAt:1)} or
 * {@link (endBefore:1)} and can then be passed to {@link (query:1)} to create a new
 * query instance that also contains this `QueryEndAtConstraint`.
 */ class QueryEndAtConstraint extends QueryConstraint {
    /**
     * @internal
     */ constructor(/** The type of this query constraint */ t, e, n){
        super(), this.type = t, this._docOrFields = e, this._inclusive = n;
    }
    static _create(t, e, n) {
        return new QueryEndAtConstraint(t, e, n);
    }
    _apply(t) {
        const e = __PRIVATE_newQueryBoundFromDocOrFields(t, this.type, this._docOrFields, this._inclusive);
        return new (0, _common456515BaEsmJs.Q)(t.firestore, t.converter, (0, _common456515BaEsmJs.o)(t._query, e));
    }
}
function endBefore(...t) {
    return QueryEndAtConstraint._create("endBefore", t, /*inclusive=*/ !1);
}
function endAt(...t) {
    return QueryEndAtConstraint._create("endAt", t, /*inclusive=*/ !0);
}
/** Helper function to create a bound from a document or fields */ function __PRIVATE_newQueryBoundFromDocOrFields(t, e, n, r) {
    if (n[0] = (0, _util.getModularInstance)(n[0]), n[0] instanceof DocumentSnapshot$1) return function __PRIVATE_newQueryBoundFromDocument(t, e, n, r, s) {
        if (!r) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).NOT_FOUND, `Can't use a DocumentSnapshot that doesn't exist for ${n}().`);
        const a = [];
        // Because people expect to continue/end a query at the exact document
        // provided, we need to use the implicit sort order rather than the explicit
        // sort order, because it's guaranteed to contain the document key. That way
        // the position becomes unambiguous and the query continues/ends exactly at
        // the provided document. Without the key (by using the explicit sort
        // orders), multiple documents could match the position, yielding duplicate
        // results.
        for (const n of (0, _common456515BaEsmJs.q)(t))if (n.field.isKeyField()) a.push((0, _common456515BaEsmJs.r)(e, r.key));
        else {
            const t = r.data.field(n.field);
            if ((0, _common456515BaEsmJs.s)(t)) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, 'Invalid query. You are trying to start or end a query using a document for which the field "' + n.field + '" is an uncommitted server timestamp. (Since the value of this field is unknown, you cannot start/end a query with it.)');
            if (null === t) {
                const t = n.field.canonicalString();
                throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Invalid query. You are trying to start or end a query using a document for which the field '${t}' (used as the orderBy) does not exist.`);
            }
            a.push(t);
        }
        return new (0, _common456515BaEsmJs.t)(a, s);
    }(t._query, t.firestore._databaseId, e, n[0]._document, r);
    {
        const s = (0, _common456515BaEsmJs.g)(t.firestore);
        return function __PRIVATE_newQueryBoundFromFields(t, e, n, r, s, a) {
            // Use explicit order by's because it has to match the query the user made
            const o = t.explicitOrderBy;
            if (s.length > o.length) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Too many arguments provided to ${r}(). The number of arguments must be less than or equal to the number of orderBy() clauses`);
            const i = [];
            for(let a = 0; a < s.length; a++){
                const c = s[a];
                if (o[a].field.isKeyField()) {
                    if ("string" != typeof c) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Invalid query. Expected a string for document ID in ${r}(), but got a ${typeof c}`);
                    if (!(0, _common456515BaEsmJs.u)(t) && -1 !== c.indexOf("/")) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Invalid query. When querying a collection and ordering by documentId(), the value passed to ${r}() must be a plain document ID, but '${c}' contains a slash.`);
                    const n = t.path.child((0, _common456515BaEsmJs.R).fromString(c));
                    if (!(0, _common456515BaEsmJs.v).isDocumentKey(n)) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Invalid query. When querying a collection group and ordering by documentId(), the value passed to ${r}() must result in a valid document path, but '${n}' is not because it contains an odd number of segments.`);
                    const s = new (0, _common456515BaEsmJs.v)(n);
                    i.push((0, _common456515BaEsmJs.r)(e, s));
                } else {
                    const t = (0, _common456515BaEsmJs.h)(n, r, c);
                    i.push(t);
                }
            }
            return new (0, _common456515BaEsmJs.t)(i, a);
        }(t._query, t.firestore._databaseId, s, e, n, r);
    }
}
function __PRIVATE_parseDocumentIdValue(t, e, n) {
    if ("string" == typeof (n = (0, _util.getModularInstance)(n))) {
        if ("" === n) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, "Invalid query. When querying with documentId(), you must provide a valid document ID, but it was an empty string.");
        if (!(0, _common456515BaEsmJs.u)(e) && -1 !== n.indexOf("/")) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Invalid query. When querying a collection by documentId(), you must provide a plain document ID, but '${n}' contains a '/' character.`);
        const r = e.path.child((0, _common456515BaEsmJs.R).fromString(n));
        if (!(0, _common456515BaEsmJs.v).isDocumentKey(r)) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Invalid query. When querying a collection group by documentId(), the value provided must result in a valid document path, but '${r}' is not because it has an odd number of segments (${r.length}).`);
        return (0, _common456515BaEsmJs.r)(t, new (0, _common456515BaEsmJs.v)(r));
    }
    if (n instanceof (0, _common456515BaEsmJs.D)) return (0, _common456515BaEsmJs.r)(t, n._key);
    throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Invalid query. When querying with documentId(), you must provide a valid string or a DocumentReference, but it was: ${(0, _common456515BaEsmJs.w)(n)}.`);
}
/**
 * Validates that the value passed into a disjunctive filter satisfies all
 * array requirements.
 */ function __PRIVATE_validateDisjunctiveFilterElements(t, e) {
    if (!Array.isArray(t) || 0 === t.length) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Invalid Query. A non-empty array is required for '${e.toString()}' filters.`);
}
/**
 * Given an operator, returns the set of operators that cannot be used with it.
 *
 * This is not a comprehensive check, and this function should be removed in the
 * long term. Validations should occur in the Firestore backend.
 *
 * Operators in a query must adhere to the following set of rules:
 * 1. Only one inequality per query.
 * 2. `NOT_IN` cannot be used with array, disjunctive, or `NOT_EQUAL` operators.
 */ function __PRIVATE_validateNewFieldFilter(t, e) {
    const n = function __PRIVATE_findOpInsideFilters(t, e) {
        for (const n of t)for (const t of n.getFlattenedFilters())if (e.indexOf(t.op) >= 0) return t.op;
        return null;
    }(t.filters, function __PRIVATE_conflictingOps(t) {
        switch(t){
            case "!=" /* Operator.NOT_EQUAL */ :
                return [
                    "!=" /* Operator.NOT_EQUAL */ ,
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
            case "in" /* Operator.IN */ :
                return [
                    "not-in" /* Operator.NOT_IN */ 
                ];
            case "not-in" /* Operator.NOT_IN */ :
                return [
                    "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ,
                    "in" /* Operator.IN */ ,
                    "not-in" /* Operator.NOT_IN */ ,
                    "!=" /* Operator.NOT_EQUAL */ 
                ];
            default:
                return [];
        }
    }(e.op));
    if (null !== n) // Special case when it's a duplicate op to give a slightly clearer error message.
    throw n === e.op ? new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Invalid query. You cannot use more than one '${e.op.toString()}' filter.`) : new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Invalid query. You cannot use '${e.op.toString()}' filters with '${n.toString()}' filters.`);
}
function __PRIVATE_validateQueryFilterConstraint(t, e) {
    if (!(e instanceof QueryFieldFilterConstraint || e instanceof QueryCompositeFilterConstraint)) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Function ${t}() requires AppliableConstraints created with a call to 'where(...)', 'or(...)', or 'and(...)'.`);
}
function __PRIVATE_applyFirestoreDataConverter(t, e, n) {
    let r;
    // Cast to `any` in order to satisfy the union type constraint on
    // toFirestore().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return r = t ? n && (n.merge || n.mergeFields) ? t.toFirestore(e, n) : t.toFirestore(e) : e, r;
}
class __PRIVATE_LiteUserDataWriter extends (0, _common456515BaEsmJs.A) {
    constructor(t){
        super(), this.firestore = t;
    }
    convertBytes(t) {
        return new (0, _common456515BaEsmJs.B)(t);
    }
    convertReference(t) {
        const e = this.convertDocumentKey(t, this.firestore._databaseId);
        return new (0, _common456515BaEsmJs.D)(this.firestore, /* converter= */ null, e);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Create an AggregateField object that can be used to compute the sum of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to sum across the result set.
 */ function sum(t) {
    return new AggregateField("sum", (0, _common456515BaEsmJs.j)("sum", t));
}
/**
 * Create an AggregateField object that can be used to compute the average of
 * a specified field over a range of documents in the result set of a query.
 * @param field - Specifies the field to average across the result set.
 */ function average(t) {
    return new AggregateField("avg", (0, _common456515BaEsmJs.j)("average", t));
}
/**
 * Create an AggregateField object that can be used to compute the count of
 * documents in the result set of a query.
 */ function count() {
    return new AggregateField("count");
}
/**
 * Compares two 'AggregateField` instances for equality.
 *
 * @param left - Compare this AggregateField to the `right`.
 * @param right - Compare this AggregateField to the `left`.
 */ function aggregateFieldEqual(t, e) {
    return t instanceof AggregateField && e instanceof AggregateField && t.aggregateType === e.aggregateType && t._internalFieldPath?.canonicalString() === e._internalFieldPath?.canonicalString();
}
/**
 * Compares two `AggregateQuerySnapshot` instances for equality.
 *
 * Two `AggregateQuerySnapshot` instances are considered "equal" if they have
 * underlying queries that compare equal, and the same data.
 *
 * @param left - The first `AggregateQuerySnapshot` to compare.
 * @param right - The second `AggregateQuerySnapshot` to compare.
 *
 * @returns `true` if the objects are "equal", as defined above, or `false`
 * otherwise.
 */ function aggregateQuerySnapshotEqual(t, e) {
    return (0, _common456515BaEsmJs.x)(t.query, e.query) && (0, _util.deepEqual)(t.data(), e.data());
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the number of documents in the result set of the given query
 * without actually downloading the documents.
 *
 * Using this function to count the documents is efficient because only the
 * final count, not the documents' data, is downloaded. This function can
 * count the documents in cases where the result set is prohibitively large to
 * download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set size is calculated.
 * @returns A Promise that will be resolved with the count; the count can be
 * retrieved from `snapshot.data().count`, where `snapshot` is the
 * `AggregateQuerySnapshot` to which the returned Promise resolves.
 */ function getCountFromServer(t) {
    return getAggregateFromServer(t, {
        count: count()
    });
}
/**
 * Calculates the specified aggregations over the documents in the result
 * set of the given query without actually downloading the documents.
 *
 * Using this function to perform aggregations is efficient because only the
 * final aggregation values, not the documents' data, are downloaded. This
 * function can perform aggregations of the documents in cases where the result
 * set is prohibitively large to download entirely (thousands of documents).
 *
 * The result received from the server is presented, unaltered, without
 * considering any local state. That is, documents in the local cache are not
 * taken into consideration, neither are local modifications not yet
 * synchronized with the server. Previously-downloaded results, if any, are not
 * used. Every invocation of this function necessarily involves a round trip to
 * the server.
 *
 * @param query - The query whose result set is aggregated over.
 * @param aggregateSpec - An `AggregateSpec` object that specifies the aggregates
 * to perform over the result set. The AggregateSpec specifies aliases for each
 * aggregate, which can be used to retrieve the aggregate result.
 * @example
 * ```typescript
 * const aggregateSnapshot = await getAggregateFromServer(query, {
 *   countOfDocs: count(),
 *   totalHours: sum('hours'),
 *   averageScore: average('score')
 * });
 *
 * const countOfDocs: number = aggregateSnapshot.data().countOfDocs;
 * const totalHours: number = aggregateSnapshot.data().totalHours;
 * const averageScore: number | null = aggregateSnapshot.data().averageScore;
 * ```
 */ function getAggregateFromServer(t, e) {
    const n = (0, _common456515BaEsmJs.y)(t.firestore, (0, _common456515BaEsmJs.F)), r = (0, _common456515BaEsmJs.z)(n), s = (0, _common456515BaEsmJs.E)(e, (t, e)=>new (0, _common456515BaEsmJs.ar)(e, t.aggregateType, t._internalFieldPath));
    // Run the aggregation and convert the results
    return (0, _common456515BaEsmJs.G)(r, t._query, s).then((e)=>/**
 * Converts the core aggregation result to an `AggregateQuerySnapshot`
 * that can be returned to the consumer.
 * @param query
 * @param aggregateResult - Core aggregation result
 * @internal
 */ (function __PRIVATE_convertToAggregateQuerySnapshot(t, e, n) {
            const r = new (0, _common456515BaEsmJs.H)(t), s = new AggregateQuerySnapshot(e, r, n);
            return s;
        })(n, t, e));
}
class __PRIVATE_MemoryLocalCacheImpl {
    constructor(t){
        this.kind = "memory", this._onlineComponentProvider = (0, _common456515BaEsmJs.as).provider, this._offlineComponentProvider = t?.garbageCollector ? t.garbageCollector._offlineComponentProvider : {
            build: ()=>new (0, _common456515BaEsmJs.at)(void 0)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class __PRIVATE_PersistentLocalCacheImpl {
    constructor(t){
        let e;
        this.kind = "persistent", t?.tabManager ? (t.tabManager._initialize(t), e = t.tabManager) : (e = persistentSingleTabManager(void 0), e._initialize(t)), this._onlineComponentProvider = e._onlineComponentProvider, this._offlineComponentProvider = e._offlineComponentProvider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class __PRIVATE_MemoryEagerGarbageCollectorImpl {
    constructor(){
        this.kind = "memoryEager", this._offlineComponentProvider = (0, _common456515BaEsmJs.au).provider;
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
class __PRIVATE_MemoryLruGarbageCollectorImpl {
    constructor(t){
        this.kind = "memoryLru", this._offlineComponentProvider = {
            build: ()=>new (0, _common456515BaEsmJs.at)(t)
        };
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
}
/**
 * Creates an instance of `MemoryEagerGarbageCollector`. This is also the
 * default garbage collector unless it is explicitly specified otherwise.
 */ function memoryEagerGarbageCollector() {
    return new __PRIVATE_MemoryEagerGarbageCollectorImpl;
}
/**
 * Creates an instance of `MemoryLruGarbageCollector`.
 *
 * A target size can be specified as part of the setting parameter. The
 * collector will start deleting documents once the cache size exceeds
 * the given size. The default cache size is 40MB (40 * 1024 * 1024 bytes).
 */ function memoryLruGarbageCollector(t) {
    return new __PRIVATE_MemoryLruGarbageCollectorImpl(t?.cacheSizeBytes);
}
/**
 * Creates an instance of `MemoryLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 */ function memoryLocalCache(t) {
    return new __PRIVATE_MemoryLocalCacheImpl(t);
}
/**
 * Creates an instance of `PersistentLocalCache`. The instance can be set to
 * `FirestoreSettings.cache` to tell the SDK which cache layer to use.
 *
 * Persistent cache cannot be used in a Node.js environment.
 */ function persistentLocalCache(t) {
    return new __PRIVATE_PersistentLocalCacheImpl(t);
}
class __PRIVATE_SingleTabManagerImpl {
    constructor(t){
        this.forceOwnership = t, this.kind = "persistentSingleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = (0, _common456515BaEsmJs.as).provider, this._offlineComponentProvider = {
            build: (e)=>new (0, _common456515BaEsmJs.av)(e, t?.cacheSizeBytes, this.forceOwnership)
        };
    }
}
class __PRIVATE_MultiTabManagerImpl {
    constructor(){
        this.kind = "PersistentMultipleTab";
    }
    toJSON() {
        return {
            kind: this.kind
        };
    }
    /**
     * @internal
     */ _initialize(t) {
        this._onlineComponentProvider = (0, _common456515BaEsmJs.as).provider, this._offlineComponentProvider = {
            build: (e)=>new (0, _common456515BaEsmJs.aw)(e, t?.cacheSizeBytes)
        };
    }
}
/**
 * Creates an instance of `PersistentSingleTabManager`.
 *
 * @param settings - Configures the created tab manager.
 */ function persistentSingleTabManager(t) {
    return new __PRIVATE_SingleTabManagerImpl(t?.forceOwnership);
}
/**
 * Creates an instance of `PersistentMultipleTabManager`.
 */ function persistentMultipleTabManager() {
    return new __PRIVATE_MultiTabManagerImpl;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const Xt = "NOT SUPPORTED";
/**
 * Metadata about a snapshot, describing the state of the snapshot.
 */ class SnapshotMetadata {
    /** @hideconstructor */ constructor(t, e){
        this.hasPendingWrites = t, this.fromCache = e;
    }
    /**
     * Returns true if this `SnapshotMetadata` is equal to the provided one.
     *
     * @param other - The `SnapshotMetadata` to compare against.
     * @returns true if this `SnapshotMetadata` is equal to the provided one.
     */ isEqual(t) {
        return this.hasPendingWrites === t.hasPendingWrites && this.fromCache === t.fromCache;
    }
}
/**
 * A `DocumentSnapshot` contains data read from a document in your Firestore
 * database. The data can be extracted with `.data()` or `.get(<field>)` to
 * get a specific field.
 *
 * For a `DocumentSnapshot` that points to a non-existing document, any data
 * access will return 'undefined'. You can use the `exists()` method to
 * explicitly verify a document's existence.
 */ class DocumentSnapshot extends DocumentSnapshot$1 {
    /** @hideconstructor protected */ constructor(t, e, n, r, s, a){
        super(t, e, n, r, a), this._firestore = t, this._firestoreImpl = t, this.metadata = s;
    }
    /**
     * Returns whether or not the data exists. True if the document exists.
     */ exists() {
        return super.exists();
    }
    /**
     * Retrieves all fields in the document as an `Object`. Returns `undefined` if
     * the document doesn't exist.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document or `undefined` if
     * the document doesn't exist.
     */ data(t = {}) {
        if (this._document) {
            if (this._converter) {
                // We only want to use the converter and create a new DocumentSnapshot
                // if a converter has been provided.
                const e = new QueryDocumentSnapshot(this._firestore, this._userDataWriter, this._key, this._document, this.metadata, /* converter= */ null);
                return this._converter.fromFirestore(e, t);
            }
            return this._userDataWriter.convertValue(this._document.data.value, t.serverTimestamps);
        }
    }
    /**
     * Retrieves the field specified by `fieldPath`. Returns `undefined` if the
     * document or field doesn't exist.
     *
     * By default, a `serverTimestamp()` that has not yet been set to
     * its final value will be returned as `null`. You can override this by
     * passing an options object.
     *
     * @param fieldPath - The path (for example 'foo' or 'foo.bar') to a specific
     * field.
     * @param options - An options object to configure how the field is retrieved
     * from the snapshot (for example the desired behavior for server timestamps
     * that have not yet been set to their final value).
     * @returns The data at the specified field location or undefined if no such
     * field exists in the document.
     */ // We are using `any` here to avoid an explicit cast by our users.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    get(t, e = {}) {
        if (this._document) {
            const n = this._document.data.field((0, _common456515BaEsmJs.j)("DocumentSnapshot.get", t));
            if (null !== n) return this._userDataWriter.convertValue(n, e.serverTimestamps);
        }
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentSnapshot` instance.
     *
     * @returns a JSON representation of this object.  Throws a {@link FirestoreError} if this
     * `DocumentSnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).FAILED_PRECONDITION, "DocumentSnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        const t = this._document, e = {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (e.type = DocumentSnapshot._jsonSchemaVersion, e.bundle = "", e.bundleSource = "DocumentSnapshot", e.bundleName = this._key.toString(), !t || !t.isValidDocument() || !t.isFoundDocument()) return e;
        this._userDataWriter.convertObjectMap(t.data.value.mapValue.fields, "previous");
        return e.bundle = (this._firestore, this.ref.path, "NOT SUPPORTED"), e;
    }
}
function documentSnapshotFromJSON(t, e, n) {
    if ((0, _common456515BaEsmJs.I)(e, DocumentSnapshot._jsonSchema)) {
        if (e.bundle === Xt) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = (0, _common456515BaEsmJs.J)(t._databaseId), s = (0, _common456515BaEsmJs.K)(e.bundle, r), a = s.t(), o = new (0, _common456515BaEsmJs.L)(s.getMetadata(), r);
        for (const t of a)o.o(t);
        // Ensure that we have the correct number of documents in the bundle.
        const i = o.documents;
        if (1 !== i.length) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Expected bundle data to contain 1 document, but it contains ${i.length} documents.`);
        // Build out the internal document data.
        const c = (0, _common456515BaEsmJs.M)(r, i[0].document), h = new (0, _common456515BaEsmJs.v)((0, _common456515BaEsmJs.R).fromString(e.bundleName));
        // Return the external facing DocumentSnapshot.
        return new DocumentSnapshot(t, new __PRIVATE_LiteUserDataWriter(t), h, c, new SnapshotMetadata(/* hasPendingWrites= */ !1, /* fromCache= */ !1), n || null);
    }
}
/**
 * A `QueryDocumentSnapshot` contains data read from a document in your
 * Firestore database as part of a query. The document is guaranteed to exist
 * and its data can be extracted with `.data()` or `.get(<field>)` to get a
 * specific field.
 *
 * A `QueryDocumentSnapshot` offers the same API surface as a
 * `DocumentSnapshot`. Since query results contain only existing documents, the
 * `exists` property will always be true and `data()` will never return
 * 'undefined'.
 */ DocumentSnapshot._jsonSchemaVersion = "firestore/documentSnapshot/1.0", DocumentSnapshot._jsonSchema = {
    type: (0, _common456515BaEsmJs.p)("string", DocumentSnapshot._jsonSchemaVersion),
    bundleSource: (0, _common456515BaEsmJs.p)("string", "DocumentSnapshot"),
    bundleName: (0, _common456515BaEsmJs.p)("string"),
    bundle: (0, _common456515BaEsmJs.p)("string")
};
class QueryDocumentSnapshot extends DocumentSnapshot {
    /**
     * Retrieves all fields in the document as an `Object`.
     *
     * By default, `serverTimestamp()` values that have not yet been
     * set to their final value will be returned as `null`. You can override
     * this by passing an options object.
     *
     * @override
     * @param options - An options object to configure how data is retrieved from
     * the snapshot (for example the desired behavior for server timestamps that
     * have not yet been set to their final value).
     * @returns An `Object` containing all fields in the document.
     */ data(t = {}) {
        return super.data(t);
    }
}
/**
 * A `QuerySnapshot` contains zero or more `DocumentSnapshot` objects
 * representing the results of a query. The documents can be accessed as an
 * array via the `docs` property or enumerated using the `forEach` method. The
 * number of documents can be determined via the `empty` and `size`
 * properties.
 */ class QuerySnapshot {
    /** @hideconstructor */ constructor(t, e, n, r){
        this._firestore = t, this._userDataWriter = e, this._snapshot = r, this.metadata = new SnapshotMetadata(r.hasPendingWrites, r.fromCache), this.query = n;
    }
    /** An array of all the documents in the `QuerySnapshot`. */ get docs() {
        const t = [];
        return this.forEach((e)=>t.push(e)), t;
    }
    /** The number of documents in the `QuerySnapshot`. */ get size() {
        return this._snapshot.docs.size;
    }
    /** True if there are no documents in the `QuerySnapshot`. */ get empty() {
        return 0 === this.size;
    }
    /**
     * Enumerates all of the documents in the `QuerySnapshot`.
     *
     * @param callback - A callback to be called with a `QueryDocumentSnapshot` for
     * each document in the snapshot.
     * @param thisArg - The `this` binding for the callback.
     */ forEach(t, e) {
        this._snapshot.docs.forEach((n)=>{
            t.call(e, new QueryDocumentSnapshot(this._firestore, this._userDataWriter, n.key, n, new SnapshotMetadata(this._snapshot.mutatedKeys.has(n.key), this._snapshot.fromCache), this.query.converter));
        });
    }
    /**
     * Returns an array of the documents changes since the last snapshot. If this
     * is the first snapshot, all documents will be in the list as 'added'
     * changes.
     *
     * @param options - `SnapshotListenOptions` that control whether metadata-only
     * changes (i.e. only `DocumentSnapshot.metadata` changed) should trigger
     * snapshot events.
     */ docChanges(t = {}) {
        const e = !!t.includeMetadataChanges;
        if (e && this._snapshot.excludesMetadataChanges) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, "To include metadata changes with your document changes, you must also pass { includeMetadataChanges:true } to onSnapshot().");
        return this._cachedChanges && this._cachedChangesIncludeMetadataChanges === e || (this._cachedChanges = /** Calculates the array of `DocumentChange`s for a given `ViewSnapshot`. */ function __PRIVATE_changesFromSnapshot(t, e) {
            if (t._snapshot.oldDocs.isEmpty()) {
                let e = 0;
                return t._snapshot.docChanges.map((n)=>{
                    (0, _common456515BaEsmJs.N)(t._snapshot.query) ? (0, _common456515BaEsmJs.P)(t._snapshot.query) : (0, _common456515BaEsmJs.S)(t.query._query);
                    const r = new QueryDocumentSnapshot(t._firestore, t._userDataWriter, n.doc.key, n.doc, new SnapshotMetadata(t._snapshot.mutatedKeys.has(n.doc.key), t._snapshot.fromCache), t.query.converter);
                    return n.doc, {
                        type: "added",
                        doc: r,
                        oldIndex: -1,
                        newIndex: e++
                    };
                });
            }
            {
                // A `DocumentSet` that is updated incrementally as changes are applied to use
                // to lookup the index of a document.
                let n = t._snapshot.oldDocs;
                return t._snapshot.docChanges.filter((t)=>e || 3 /* ChangeType.Metadata */  !== t.type).map((e)=>{
                    const r = new QueryDocumentSnapshot(t._firestore, t._userDataWriter, e.doc.key, e.doc, new SnapshotMetadata(t._snapshot.mutatedKeys.has(e.doc.key), t._snapshot.fromCache), t.query.converter);
                    let s = -1, a = -1;
                    return 0 /* ChangeType.Added */  !== e.type && (s = n.indexOf(e.doc.key), n = n.delete(e.doc.key)), 1 /* ChangeType.Removed */  !== e.type && (n = n.add(e.doc), a = n.indexOf(e.doc.key)), {
                        type: __PRIVATE_resultChangeType(e.type),
                        doc: r,
                        oldIndex: s,
                        newIndex: a
                    };
                });
            }
        }(this, e), this._cachedChangesIncludeMetadataChanges = e), this._cachedChanges;
    }
    /**
     * Returns a JSON-serializable representation of this `QuerySnapshot` instance.
     *
     * @returns a JSON representation of this object. Throws a {@link FirestoreError} if this
     * `QuerySnapshot` has pending writes.
     */ toJSON() {
        if (this.metadata.hasPendingWrites) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).FAILED_PRECONDITION, "QuerySnapshot.toJSON() attempted to serialize a document with pending writes. Await waitForPendingWrites() before invoking toJSON().");
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const t = {};
        t.type = QuerySnapshot._jsonSchemaVersion, t.bundleSource = "QuerySnapshot", t.bundleName = (0, _common456515BaEsmJs.T).newId(), this._firestore._databaseId.database, this._firestore._databaseId.projectId;
        const e = [], n = [], r = [];
        return this.docs.forEach((t)=>{
            null !== t._document && (e.push(t._document), n.push(this._userDataWriter.convertObjectMap(t._document.data.value.mapValue.fields, "previous")), r.push(t.ref.path));
        }), t.bundle = (this._firestore, this.query._query, t.bundleName, "NOT SUPPORTED"), t;
    }
}
function querySnapshotFromJSON(t, e, n) {
    if ((0, _common456515BaEsmJs.I)(e, QuerySnapshot._jsonSchema)) {
        if (e.bundle === Xt) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, "The provided JSON object was created in a client environment, which is not supported.");
        // Parse the bundle data.
        const r = (0, _common456515BaEsmJs.J)(t._databaseId), s = (0, _common456515BaEsmJs.K)(e.bundle, r), a = s.t(), o = new (0, _common456515BaEsmJs.L)(s.getMetadata(), r);
        for (const t of a)o.o(t);
        if (1 !== o.queries.length) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `Snapshot data expected 1 query but found ${o.queries.length} queries.`);
        // Create an internal Query object from the named query in the bundle.
        const i = (0, _common456515BaEsmJs.U)(o.queries[0].bundledQuery), c = o.documents;
        // Construct the arrays of document data for the query.
        let h = new (0, _common456515BaEsmJs.V);
        c.map((t)=>{
            const e = (0, _common456515BaEsmJs.M)(r, t.document);
            h = h.add(e);
        });
        // Create a view snapshot of the query and documents.
        const d = (0, _common456515BaEsmJs.W).fromInitialDocuments(i, h, (0, _common456515BaEsmJs.X)(), /* fromCache= */ !1, /* hasCachedResults= */ !1), p = new (0, _common456515BaEsmJs.Q)(t, n || null, i);
        // Create an external Query object, required to construct the QuerySnapshot.
        // Return a new QuerySnapshot with all of the collected data.
        return new QuerySnapshot(t, new __PRIVATE_LiteUserDataWriter(t), p, d);
    }
}
function __PRIVATE_resultChangeType(t) {
    switch(t){
        case 0 /* ChangeType.Added */ :
            return "added";
        case 2 /* ChangeType.Modified */ :
        case 3 /* ChangeType.Metadata */ :
            return "modified";
        case 1 /* ChangeType.Removed */ :
            return "removed";
        default:
            return (0, _common456515BaEsmJs.Y)(61501, {
                type: t
            });
    }
}
// TODO(firestoreexp): Add tests for snapshotEqual with different snapshot
// metadata
/**
 * Returns true if the provided snapshots are equal.
 *
 * @param left - A snapshot to compare.
 * @param right - A snapshot to compare.
 * @returns true if the snapshots are equal.
 */ function snapshotEqual(t, e) {
    return t instanceof DocumentSnapshot && e instanceof DocumentSnapshot ? t._firestore === e._firestore && t._key.isEqual(e._key) && (null === t._document ? null === e._document : t._document.isEqual(e._document)) && t._converter === e._converter : t instanceof QuerySnapshot && e instanceof QuerySnapshot && t._firestore === e._firestore && (0, _common456515BaEsmJs.x)(t.query, e.query) && t.metadata.isEqual(e.metadata) && t._snapshot.isEqual(e._snapshot);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ QuerySnapshot._jsonSchemaVersion = "firestore/querySnapshot/1.0", QuerySnapshot._jsonSchema = {
    type: (0, _common456515BaEsmJs.p)("string", QuerySnapshot._jsonSchemaVersion),
    bundleSource: (0, _common456515BaEsmJs.p)("string", "QuerySnapshot"),
    bundleName: (0, _common456515BaEsmJs.p)("string"),
    bundle: (0, _common456515BaEsmJs.p)("string")
};
const Zt = {
    maxAttempts: 5
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A write batch, used to perform multiple writes as a single atomic unit.
 *
 * A `WriteBatch` object can be acquired by calling {@link writeBatch}. It
 * provides methods for adding writes to the write batch. None of the writes
 * will be committed (or visible locally) until {@link WriteBatch.commit} is
 * called.
 */ class WriteBatch {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._commitHandler = e, this._mutations = [], this._committed = !1, this._dataReader = (0, _common456515BaEsmJs.g)(t);
    }
    set(t, e, n) {
        this._verifyNotCommitted();
        const r = __PRIVATE_validateReference(t, this._firestore), s = __PRIVATE_applyFirestoreDataConverter(r.converter, e, n), a = (0, _common456515BaEsmJs.Z)(this._dataReader, "WriteBatch.set", r._key, s, null !== r.converter, n);
        return this._mutations.push(a.toMutation(r._key, (0, _common456515BaEsmJs.$).none())), this;
    }
    update(t, e, n, ...r) {
        this._verifyNotCommitted();
        const s = __PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let a;
        return a = "string" == typeof (e = (0, _util.getModularInstance)(e)) || e instanceof (0, _common456515BaEsmJs.a0) ? (0, _common456515BaEsmJs.a1)(this._dataReader, "WriteBatch.update", s._key, e, n, r) : (0, _common456515BaEsmJs.a2)(this._dataReader, "WriteBatch.update", s._key, e), this._mutations.push(a.toMutation(s._key, (0, _common456515BaEsmJs.$).exists(!0))), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `WriteBatch` instance. Used for chaining method calls.
     */ delete(t) {
        this._verifyNotCommitted();
        const e = __PRIVATE_validateReference(t, this._firestore);
        return this._mutations = this._mutations.concat(new (0, _common456515BaEsmJs.a3)(e._key, (0, _common456515BaEsmJs.$).none())), this;
    }
    /**
     * Commits all of the writes in this write batch as a single atomic unit.
     *
     * The result of these writes will only be reflected in document reads that
     * occur after the returned promise resolves. If the client is offline, the
     * write fails. If you would like to see local modifications or buffer writes
     * until the client is online, use the full Firestore SDK.
     *
     * @returns A `Promise` resolved once all of the writes in the batch have been
     * successfully written to the backend as an atomic unit (note that it won't
     * resolve while you're offline).
     */ commit() {
        return this._verifyNotCommitted(), this._committed = !0, this._mutations.length > 0 ? this._commitHandler(this._mutations) : Promise.resolve();
    }
    _verifyNotCommitted() {
        if (this._committed) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).FAILED_PRECONDITION, "A write batch can no longer be used after commit() has been called.");
    }
}
function __PRIVATE_validateReference(t, e) {
    if ((t = (0, _util.getModularInstance)(t)).firestore !== e) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, "Provided document reference is from a different Firestore instance.");
    return t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // TODO(mrschmidt) Consider using `BaseTransaction` as the base class in the
// legacy SDK.
/**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class Transaction$1 {
    /** @hideconstructor */ constructor(t, e){
        this._firestore = t, this._transaction = e, this._dataReader = (0, _common456515BaEsmJs.g)(t);
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = __PRIVATE_validateReference(t, this._firestore), n = new __PRIVATE_LiteUserDataWriter(this._firestore);
        return this._transaction.lookup([
            e._key
        ]).then((t)=>{
            if (!t || 1 !== t.length) return (0, _common456515BaEsmJs.Y)(24041);
            const r = t[0];
            if (r.isFoundDocument()) return new DocumentSnapshot$1(this._firestore, n, r.key, r, e.converter);
            if (r.isNoDocument()) return new DocumentSnapshot$1(this._firestore, n, e._key, null, e.converter);
            throw (0, _common456515BaEsmJs.Y)(18433, {
                doc: r
            });
        });
    }
    set(t, e, n) {
        const r = __PRIVATE_validateReference(t, this._firestore), s = __PRIVATE_applyFirestoreDataConverter(r.converter, e, n), a = (0, _common456515BaEsmJs.Z)(this._dataReader, "Transaction.set", r._key, s, null !== r.converter, n);
        return this._transaction.set(r._key, a), this;
    }
    update(t, e, n, ...r) {
        const s = __PRIVATE_validateReference(t, this._firestore);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        let a;
        return a = "string" == typeof (e = (0, _util.getModularInstance)(e)) || e instanceof (0, _common456515BaEsmJs.a0) ? (0, _common456515BaEsmJs.a1)(this._dataReader, "Transaction.update", s._key, e, n, r) : (0, _common456515BaEsmJs.a2)(this._dataReader, "Transaction.update", s._key, e), this._transaction.update(s._key, a), this;
    }
    /**
     * Deletes the document referred to by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be deleted.
     * @returns This `Transaction` instance. Used for chaining method calls.
     */ delete(t) {
        const e = __PRIVATE_validateReference(t, this._firestore);
        return this._transaction.delete(e._key), this;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A reference to a transaction.
 *
 * The `Transaction` object passed to a transaction's `updateFunction` provides
 * the methods to read and write data within the transaction context. See
 * {@link runTransaction}.
 */ class Transaction extends Transaction$1 {
    // This class implements the same logic as the Transaction API in the Lite SDK
    // but is subclassed in order to return its own DocumentSnapshot types.
    /** @hideconstructor */ constructor(t, e){
        super(t, e), this._firestore = t;
    }
    /**
     * Reads the document referenced by the provided {@link DocumentReference}.
     *
     * @param documentRef - A reference to the document to be read.
     * @returns A `DocumentSnapshot` with the read data.
     */ get(t) {
        const e = __PRIVATE_validateReference(t, this._firestore), n = new (0, _common456515BaEsmJs.H)(this._firestore);
        return super.get(t).then((t)=>new DocumentSnapshot(this._firestore, n, e._key, t._document, new SnapshotMetadata(/* hasPendingWrites= */ !1, /* fromCache= */ !1), e.converter));
    }
}
/**
 * Executes the given `updateFunction` and then attempts to commit the changes
 * applied within the transaction. If any document read within the transaction
 * has changed, Cloud Firestore retries the `updateFunction`. If it fails to
 * commit after 5 attempts, the transaction fails.
 *
 * The maximum number of writes allowed in a single transaction is 500.
 *
 * @param firestore - A reference to the Firestore database to run this
 * transaction against.
 * @param updateFunction - The function to execute within the transaction
 * context.
 * @param options - An options object to configure maximum number of attempts to
 * commit.
 * @returns If the transaction completed successfully or was explicitly aborted
 * (the `updateFunction` returned a failed promise), the promise returned by the
 * `updateFunction `is returned here. Otherwise, if the transaction failed, a
 * rejected promise with the corresponding failure error is returned.
 */ function runTransaction(t, e, n) {
    t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.F));
    const r = {
        ...Zt,
        ...n
    };
    !function __PRIVATE_validateTransactionOptions(t) {
        if (t.maxAttempts < 1) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, "Max attempts must be at least 1");
    }(r);
    const s = (0, _common456515BaEsmJs.z)(t);
    return (0, _common456515BaEsmJs.a4)(s, (n)=>e(new Transaction(t, n)), r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Reads the document referred to by this `DocumentReference`.
 *
 * Note: `getDoc()` attempts to provide up-to-date data when possible by waiting
 * for data from the server, but it may return cached data or fail if you are
 * offline and the server cannot be reached. To specify this behavior, invoke
 * {@link getDocFromCache} or {@link getDocFromServer}.
 *
 * @param reference - The reference of the document to fetch.
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function getDoc(t) {
    t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.D));
    const e = (0, _common456515BaEsmJs.y)(t.firestore, (0, _common456515BaEsmJs.F)), n = (0, _common456515BaEsmJs.z)(e);
    return (0, _common456515BaEsmJs.a5)(n, t._key).then((n)=>__PRIVATE_convertToDocSnapshot(e, t, n));
}
/**
 * Reads the document referred to by this `DocumentReference` from cache.
 * Returns an error if the document is not currently cached.
 *
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function getDocFromCache(t) {
    t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.D));
    const e = (0, _common456515BaEsmJs.y)(t.firestore, (0, _common456515BaEsmJs.F)), n = (0, _common456515BaEsmJs.z)(e), r = new (0, _common456515BaEsmJs.H)(e);
    return (0, _common456515BaEsmJs.a6)(n, t._key).then((n)=>new DocumentSnapshot(e, r, t._key, n, new SnapshotMetadata(null !== n && n.hasLocalMutations, /* fromCache= */ !0), t.converter));
}
/**
 * Reads the document referred to by this `DocumentReference` from the server.
 * Returns an error if the network is not available.
 *
 * @returns A `Promise` that resolves with a `DocumentSnapshot` containing the
 * document contents.
 */ function getDocFromServer(t) {
    t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.D));
    const e = (0, _common456515BaEsmJs.y)(t.firestore, (0, _common456515BaEsmJs.F)), n = (0, _common456515BaEsmJs.z)(e);
    return (0, _common456515BaEsmJs.a5)(n, t._key, {
        source: "server"
    }).then((n)=>__PRIVATE_convertToDocSnapshot(e, t, n));
}
function getDocs(t) {
    t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.Q));
    const e = (0, _common456515BaEsmJs.y)(t.firestore, (0, _common456515BaEsmJs.F)), n = (0, _common456515BaEsmJs.z)(e), r = new (0, _common456515BaEsmJs.H)(e);
    return __PRIVATE_validateHasExplicitOrderByForLimitToLast(t._query), (0, _common456515BaEsmJs.a7)(n, t._query).then((n)=>new QuerySnapshot(e, r, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from cache.
 * Returns an empty result set if no documents matching the query are currently
 * cached.
 *
 * @returns A `Promise` that resolves with the results of the query.
 */ function getDocsFromCache(t) {
    t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.Q));
    const e = (0, _common456515BaEsmJs.y)(t.firestore, (0, _common456515BaEsmJs.F)), n = (0, _common456515BaEsmJs.z)(e), r = new (0, _common456515BaEsmJs.H)(e);
    return (0, _common456515BaEsmJs.a8)(n, t._query).then((n)=>new QuerySnapshot(e, r, t, n));
}
/**
 * Executes the query and returns the results as a `QuerySnapshot` from the
 * server. Returns an error if the network is not available.
 *
 * @returns A `Promise` that resolves with the results of the query.
 */ function getDocsFromServer(t) {
    t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.Q));
    const e = (0, _common456515BaEsmJs.y)(t.firestore, (0, _common456515BaEsmJs.F)), n = (0, _common456515BaEsmJs.z)(e), r = new (0, _common456515BaEsmJs.H)(e);
    return (0, _common456515BaEsmJs.a7)(n, t._query, {
        source: "server"
    }).then((n)=>new QuerySnapshot(e, r, t, n));
}
function setDoc(t, e, n) {
    t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.D));
    const r = (0, _common456515BaEsmJs.y)(t.firestore, (0, _common456515BaEsmJs.F)), s = __PRIVATE_applyFirestoreDataConverter(t.converter, e, n), o = (0, _common456515BaEsmJs.g)(r);
    return executeWrite(r, [
        (0, _common456515BaEsmJs.Z)(o, "setDoc", t._key, s, null !== t.converter, n).toMutation(t._key, (0, _common456515BaEsmJs.$).none())
    ]);
}
function updateDoc(t, e, n, ...r) {
    t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.D));
    const s = (0, _common456515BaEsmJs.y)(t.firestore, (0, _common456515BaEsmJs.F)), o = (0, _common456515BaEsmJs.g)(s);
    let i;
    i = "string" == typeof // For Compat types, we have to "extract" the underlying types before
    // performing validation.
    (e = (0, _util.getModularInstance)(e)) || e instanceof (0, _common456515BaEsmJs.a0) ? (0, _common456515BaEsmJs.a1)(o, "updateDoc", t._key, e, n, r) : (0, _common456515BaEsmJs.a2)(o, "updateDoc", t._key, e);
    return executeWrite(s, [
        i.toMutation(t._key, (0, _common456515BaEsmJs.$).exists(!0))
    ]);
}
/**
 * Deletes the document referred to by the specified `DocumentReference`.
 *
 * Note that the returned `Promise` does _not_ resolve until the document is
 * successfully deleted from the remote Firestore backend and, similarly, is not
 * rejected until the remote Firestore backend reports an error deleting the given
 * document. So if the client cannot reach the backend (for example, due to being
 * offline) then the returned `Promise` will not resolve for a potentially-long
 * time (for example, until the client has gone back online). That being said,
 * the given data _will_ be immediately deleted from the local cache and will be
 * reflected in future "get" operations as if it had been successfully
 * deleted from the remote Firestore server, a feature of Firestore called
 * "latency compensation". The document will _eventually_ be deleted from the remote
 * Firestore backend once a connection can be established. Therefore, it is
 * usually undesirable to `await` the `Promise` returned from this function
 * because the indefinite amount of time before which the promise resolves or
 * rejects can block application logic unnecessarily.
 *
 * @param reference - A reference to the document to delete.
 * @returns A `Promise` that resolves once the document has been successfully
 * deleted from the backend or rejects once the backend reports an error
 * deleting the document.
 */ function deleteDoc(t) {
    return executeWrite((0, _common456515BaEsmJs.y)(t.firestore, (0, _common456515BaEsmJs.F)), [
        new (0, _common456515BaEsmJs.a3)(t._key, (0, _common456515BaEsmJs.$).none())
    ]);
}
/**
 * Add a new document to specified `CollectionReference` with the given data,
 * assigning it a document ID automatically.
 *
 * Note that the returned `Promise` does _not_ resolve until the document is
 * successfully created to the remote Firestore backend and, similarly, is not
 * rejected until the remote Firestore backend reports an error creating the given
 * document. So if the client cannot reach the backend (for example, due to being
 * offline) then the returned `Promise` will not resolve for a potentially-long
 * time (for example, until the client has gone back online). That being said,
 * the given document _will_ be immediately created in the local cache and will be
 * incorporated into future "get" operations as if it had been successfully
 * created in the remote Firestore server, a feature of Firestore called
 * "latency compensation". The document will _eventually_ be created in the remote
 * Firestore backend once a connection can be established. Therefore, it is
 * usually undesirable to `await` the `Promise` returned from this function
 * because the indefinite amount of time before which the promise resolves or
 * rejects can block application logic unnecessarily.
 *
 * @param reference - A reference to the collection to add this document to.
 * @param data - An Object containing the data for the new document.
 * @returns A `Promise` that resolves once the docoument has been successfully
 * created in the backend or rejects once the backend reports an error creating
 * the document.
 */ function addDoc(t, e) {
    const n = (0, _common456515BaEsmJs.y)(t.firestore, (0, _common456515BaEsmJs.F)), r = (0, _common456515BaEsmJs.a9)(t), s = __PRIVATE_applyFirestoreDataConverter(t.converter, e), o = (0, _common456515BaEsmJs.g)(t.firestore);
    return executeWrite(n, [
        (0, _common456515BaEsmJs.Z)(o, "addDoc", r._key, s, null !== t.converter, {}).toMutation(r._key, (0, _common456515BaEsmJs.$).exists(!1))
    ]).then(()=>r);
}
function onSnapshot(t, ...e) {
    // onSnapshot for Query or Document.
    t = (0, _util.getModularInstance)(t);
    let n = {
        includeMetadataChanges: !1,
        source: "default"
    }, r = 0;
    "object" != typeof e[r] || __PRIVATE_isPartialObserver(e[r]) || (n = e[r++]);
    const s = {
        includeMetadataChanges: n.includeMetadataChanges,
        source: n.source
    };
    if (__PRIVATE_isPartialObserver(e[r])) {
        const t = e[r];
        e[r] = t.next?.bind(t), e[r + 1] = t.error?.bind(t), e[r + 2] = t.complete?.bind(t);
    }
    let o, i, c;
    if (t instanceof (0, _common456515BaEsmJs.D)) i = (0, _common456515BaEsmJs.y)(t.firestore, (0, _common456515BaEsmJs.F)), c = (0, _common456515BaEsmJs.aa)(t._key.path), o = {
        next: (n)=>{
            e[r] && e[r](__PRIVATE_convertToDocSnapshot(i, t, n));
        },
        error: e[r + 1],
        complete: e[r + 2]
    };
    else {
        const n = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.Q));
        i = (0, _common456515BaEsmJs.y)(n.firestore, (0, _common456515BaEsmJs.F)), c = n._query;
        const s = new (0, _common456515BaEsmJs.H)(i);
        o = {
            next: (t)=>{
                e[r] && e[r](new QuerySnapshot(i, s, n, t));
            },
            error: e[r + 1],
            complete: e[r + 2]
        }, __PRIVATE_validateHasExplicitOrderByForLimitToLast(t._query);
    }
    const h = (0, _common456515BaEsmJs.z)(i);
    return (0, _common456515BaEsmJs.ab)(h, c, s, o);
}
function onSnapshotResume(t, e, ...n) {
    const r = (0, _util.getModularInstance)(t), s = /**
 * Ensures the data required to construct an {@link onSnapshot} listener exist in a `snapshotJson`
 * object that originates from {@link DocumentSnapshot.toJSON} or {@link Querysnapshot.toJSON}. The
 * data is normalized into a typed object.
 *
 * @param snapshotJson - The JSON object that the app provided to {@link onSnapshot}.
 * @returns A normalized object that contains all of the required bundle JSON fields. If
 * {@link snapshotJson} doesn't contain the required fields, or if the fields exist as empty
 * strings, then the {@link snapshotJson.error} field will be a non empty string.
 *
 * @internal
 */ function __PRIVATE_normalizeSnapshotJsonFields(t) {
        const e = {
            bundle: "",
            bundleName: "",
            bundleSource: ""
        }, n = [
            "bundle",
            "bundleName",
            "bundleSource"
        ];
        for (const r of n){
            if (!(r in t)) {
                e.error = `snapshotJson missing required field: ${r}`;
                break;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const n = t[r];
            if ("string" != typeof n) {
                e.error = `snapshotJson field '${r}' must be a string.`;
                break;
            }
            if (0 === n.length) {
                e.error = `snapshotJson field '${r}' cannot be an empty string.`;
                break;
            }
            "bundle" === r ? e.bundle = n : "bundleName" === r ? e.bundleName = n : "bundleSource" === r && (e.bundleSource = n);
        }
        return e;
    }(e);
    if (s.error) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, s.error);
    let a, o = 0;
    if ("object" != typeof n[o] || __PRIVATE_isPartialObserver(n[o]) || (a = n[o++]), "QuerySnapshot" === s.bundleSource) {
        let t = null;
        if ("object" == typeof n[o] && __PRIVATE_isPartialObserver(n[o])) {
            const e = n[o++];
            t = {
                next: e.next,
                error: e.error,
                complete: e.complete
            };
        } else t = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        /**
 * Loads the bundle in a separate task and then invokes {@link onSnapshot} with a
 * {@link Query} that represents the Query in the bundle.
 *
 * @param firestore - The {@link Firestore} instance for the {@link onSnapshot} operation request.
 * @param json - The JSON bundle to load, produced by {@link QuerySnapshot.toJSON}.
 * @param options - Options controlling the listen behavior.
 * @param observer - A single object containing `next` and `error` callbacks.
 * @param converter - An optional object that converts objects from Firestore before the onNext
 * listener is invoked.
 * @returns An unsubscribe function that can be called to cancel the snapshot
 * listener.
 *
 * @internal
 */ return function __PRIVATE_onSnapshotQuerySnapshotBundle(t, e, n, r, s) {
            let a, o = !1;
            const i = (0, _common456515BaEsmJs.ac)(t, e.bundle);
            return i.then(()=>(0, _common456515BaEsmJs.ad)(t, e.bundleName)).then((t)=>{
                if (t && !o) s && t.withConverter(s), a = onSnapshot(t, n || {}, r);
            }).catch((t)=>(r.error && r.error(t), ()=>{})), ()=>{
                o || (o = !0, a && a());
            };
        }(r, s, a, t, n[o]);
    }
    if ("DocumentSnapshot" === s.bundleSource) {
        let t = null;
        if ("object" == typeof n[o] && __PRIVATE_isPartialObserver(n[o])) {
            const e = n[o++];
            t = {
                next: e.next,
                error: e.error,
                complete: e.complete
            };
        } else t = {
            next: n[o++],
            error: n[o++],
            complete: n[o++]
        };
        return function __PRIVATE_onSnapshotDocumentSnapshotBundle(t, e, n, r, s) {
            let a, o = !1;
            const i = (0, _common456515BaEsmJs.ac)(t, e.bundle);
            return i.then(()=>{
                if (!o) {
                    const o = new (0, _common456515BaEsmJs.D)(t, s || null, (0, _common456515BaEsmJs.v).fromPath(e.bundleName));
                    a = onSnapshot(o, n || {}, r);
                }
            }).catch((t)=>(r.error && r.error(t), ()=>{})), ()=>{
                o || (o = !0, a && a());
            };
        }(r, s, a, t, n[o]);
    }
    throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, `unsupported bundle source: ${s.bundleSource}`);
}
function onSnapshotsInSync(t, e) {
    t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.F));
    const n = (0, _common456515BaEsmJs.z)(t), r = __PRIVATE_isPartialObserver(e) ? e : {
        next: e
    };
    return (0, _common456515BaEsmJs.ae)(n, r);
}
/**
 * Locally writes `mutations` on the async queue.
 * @internal
 */ function executeWrite(t, e) {
    const n = (0, _common456515BaEsmJs.z)(t);
    return (0, _common456515BaEsmJs.af)(n, e);
}
/**
 * Converts a {@link ViewSnapshot} that contains the single document specified by `ref`
 * to a {@link DocumentSnapshot}.
 */ function __PRIVATE_convertToDocSnapshot(t, e, n) {
    const r = n.docs.get(e._key), s = new (0, _common456515BaEsmJs.H)(t);
    return new DocumentSnapshot(t, s, e._key, r, new SnapshotMetadata(n.hasPendingWrites, n.fromCache), e.converter);
}
function writeBatch(t) {
    return t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.F)), (0, _common456515BaEsmJs.z)(t), new WriteBatch(t, (e)=>executeWrite(t, e));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function setIndexConfiguration(t, e) {
    t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.F));
    const n = (0, _common456515BaEsmJs.z)(t);
    if (!n._uninitializedComponentsProvider || "memory" === n._uninitializedComponentsProvider._offline.kind) // PORTING NOTE: We don't return an error if the user has not enabled
    // persistence since `enableIndexeddbPersistence()` can fail on the Web.
    return (0, _common456515BaEsmJs.ag)("Cannot enable indexes when persistence is disabled"), Promise.resolve();
    const r = function __PRIVATE_parseIndexes(t) {
        const e = "string" == typeof t ? function __PRIVATE_tryParseJson(t) {
            try {
                return JSON.parse(t);
            } catch (t) {
                throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, "Failed to parse JSON: " + t?.message);
            }
        }(t) : t, n = [];
        if (Array.isArray(e.indexes)) for (const t of e.indexes){
            const e = __PRIVATE_tryGetString(t, "collectionGroup"), r = [];
            if (Array.isArray(t.fields)) for (const e of t.fields){
                const t = __PRIVATE_tryGetString(e, "fieldPath"), n = (0, _common456515BaEsmJs.ah)("setIndexConfiguration", t);
                "CONTAINS" === e.arrayConfig ? r.push(new (0, _common456515BaEsmJs.ai)(n, 2 /* IndexKind.CONTAINS */ )) : "ASCENDING" === e.order ? r.push(new (0, _common456515BaEsmJs.ai)(n, 0 /* IndexKind.ASCENDING */ )) : "DESCENDING" === e.order && r.push(new (0, _common456515BaEsmJs.ai)(n, 1 /* IndexKind.DESCENDING */ ));
            }
            n.push(new (0, _common456515BaEsmJs.aj)((0, _common456515BaEsmJs.aj).UNKNOWN_ID, e, r, (0, _common456515BaEsmJs.ak).empty()));
        }
        return n;
    }(e);
    return (0, _common456515BaEsmJs.al)(n, r);
}
function __PRIVATE_tryGetString(t, e) {
    if ("string" != typeof t[e]) throw new (0, _common456515BaEsmJs.d)((0, _common456515BaEsmJs.e).INVALID_ARGUMENT, "Missing string value for: " + e);
    return t[e];
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `PersistentCacheIndexManager` for configuring persistent cache indexes used
 * for local query execution.
 *
 * To use, call `getPersistentCacheIndexManager()` to get an instance.
 */ class PersistentCacheIndexManager {
    /** @hideconstructor */ constructor(t){
        this._firestore = t, /** A type string to uniquely identify instances of this class. */ this.type = "PersistentCacheIndexManager";
    }
}
/**
 * Returns the PersistentCache Index Manager used by the given `Firestore`
 * object.
 *
 * @returns The `PersistentCacheIndexManager` instance, or `null` if local
 * persistent storage is not in use.
 */ function getPersistentCacheIndexManager(t) {
    t = (0, _common456515BaEsmJs.y)(t, (0, _common456515BaEsmJs.F));
    const e = te.get(t);
    if (e) return e;
    const n = (0, _common456515BaEsmJs.z)(t);
    if ("persistent" !== n._uninitializedComponentsProvider?._offline.kind) return null;
    const r = new PersistentCacheIndexManager(t);
    return te.set(t, r), r;
}
/**
 * Enables the SDK to create persistent cache indexes automatically for local
 * query execution when the SDK believes cache indexes can help improve
 * performance.
 *
 * This feature is disabled by default.
 */ function enablePersistentCacheIndexAutoCreation(t) {
    __PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, !0);
}
/**
 * Stops creating persistent cache indexes automatically for local query
 * execution. The indexes which have been created by calling
 * `enablePersistentCacheIndexAutoCreation()` still take effect.
 */ function disablePersistentCacheIndexAutoCreation(t) {
    __PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, !1);
}
/**
 * Removes all persistent cache indexes.
 *
 * Please note this function will also deletes indexes generated by
 * `setIndexConfiguration()`, which is deprecated.
 */ function deleteAllPersistentCacheIndexes(t) {
    const e = (0, _common456515BaEsmJs.z)(t._firestore);
    (0, _common456515BaEsmJs.am)(e).then((t)=>(0, _common456515BaEsmJs.an)("deleting all persistent cache indexes succeeded")).catch((t)=>(0, _common456515BaEsmJs.ag)("deleting all persistent cache indexes failed", t));
}
function __PRIVATE_setPersistentCacheIndexAutoCreationEnabled(t, e) {
    const n = (0, _common456515BaEsmJs.z)(t._firestore);
    (0, _common456515BaEsmJs.ao)(n, e).then((t)=>(0, _common456515BaEsmJs.an)(`setting persistent cache index auto creation isEnabled=${e} succeeded`)).catch((t)=>(0, _common456515BaEsmJs.ag)(`setting persistent cache index auto creation isEnabled=${e} failed`, t));
}
/**
 * Maps `Firestore` instances to their corresponding
 * `PersistentCacheIndexManager` instances.
 *
 * Use a `WeakMap` so that the mapping will be automatically dropped when the
 * `Firestore` instance is garbage collected. This emulates a private member
 * as described in https://goo.gle/454yvug.
 */ const te = new WeakMap;
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Testing hooks for use by Firestore's integration test suite to reach into the
 * SDK internals to validate logic and behavior that is not visible from the
 * public API surface.
 *
 * @internal
 */ class TestingHooks {
    constructor(){
        throw new Error("instances of this class should not be created");
    }
    /**
     * Registers a callback to be notified when an existence filter mismatch
     * occurs in the Watch listen stream.
     *
     * The relative order in which callbacks are notified is unspecified; do not
     * rely on any particular ordering. If a given callback is registered multiple
     * times then it will be notified multiple times, once per registration.
     *
     * @param callback - the callback to invoke upon existence filter mismatch.
     *
     * @returns a function that, when called, unregisters the given callback; only
     * the first invocation of the returned function does anything; all subsequent
     * invocations do nothing.
     */ static onExistenceFilterMismatch(t) {
        return __PRIVATE_TestingHooksSpiImpl.instance.onExistenceFilterMismatch(t);
    }
}
/**
 * The implementation of `TestingHooksSpi`.
 */ class __PRIVATE_TestingHooksSpiImpl {
    constructor(){
        this.i = new Map;
    }
    static get instance() {
        return ee || (ee = new __PRIVATE_TestingHooksSpiImpl, (0, _common456515BaEsmJs.ap)(ee)), ee;
    }
    u(t) {
        this.i.forEach((e)=>e(t));
    }
    onExistenceFilterMismatch(t) {
        const e = Symbol(), n = this.i;
        return n.set(e, t), ()=>n.delete(e);
    }
}
let ee = null;
/**
 * Cloud Firestore
 *
 * @packageDocumentation
 */ !function __PRIVATE_registerFirestore(h, d = !0) {
    (0, _common456515BaEsmJs._)((0, _app.SDK_VERSION)), (0, _app._registerComponent)(new (0, _component.Component)("firestore", (t, { instanceIdentifier: e, options: n })=>{
        const r = t.getProvider("app").getImmediate(), s = new (0, _common456515BaEsmJs.F)(new (0, _common456515BaEsmJs.a)(t.getProvider("auth-internal")), new (0, _common456515BaEsmJs.b)(r, t.getProvider("app-check-internal")), (0, _common456515BaEsmJs.c)(r, e), r);
        return n = {
            useFetchStreams: d,
            ...n
        }, s._setSettings(n), s;
    }, "PUBLIC").setMultipleInstances(!0)), (0, _app.registerVersion)(Yt, Kt, h), // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, _app.registerVersion)(Yt, Kt, "esm2020");
}();

},{"@firebase/app":"iO7sa","@firebase/component":"6VF6E","./common-456515ba.esm.js":"6ApoN","@firebase/util":"fHqXn","@firebase/webchannel-wrapper/bloom-blob":"hHRTT","@firebase/logger":"kY52V","@firebase/webchannel-wrapper/webchannel-blob":"bHKNb","re2js":"gJUT3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ApoN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "$", ()=>Precondition);
parcelHelpers.export(exports, "A", ()=>AbstractUserDataWriter);
parcelHelpers.export(exports, "B", ()=>Bytes);
parcelHelpers.export(exports, "C", ()=>CompositeFilter);
parcelHelpers.export(exports, "D", ()=>DocumentReference);
parcelHelpers.export(exports, "E", ()=>__PRIVATE_mapToArray);
parcelHelpers.export(exports, "F", ()=>Firestore);
parcelHelpers.export(exports, "G", ()=>__PRIVATE_firestoreClientRunAggregateQuery);
parcelHelpers.export(exports, "H", ()=>__PRIVATE_ExpUserDataWriter);
parcelHelpers.export(exports, "I", ()=>__PRIVATE_validateJSON);
parcelHelpers.export(exports, "J", ()=>__PRIVATE_newSerializer);
parcelHelpers.export(exports, "K", ()=>__PRIVATE_createBundleReaderSync);
parcelHelpers.export(exports, "L", ()=>__PRIVATE_BundleLoader);
parcelHelpers.export(exports, "M", ()=>fromDocument);
parcelHelpers.export(exports, "N", ()=>__PRIVATE_isPipeline);
parcelHelpers.export(exports, "O", ()=>ObjectValue);
parcelHelpers.export(exports, "P", ()=>__PRIVATE_newPipelineComparator);
parcelHelpers.export(exports, "Q", ()=>Query);
parcelHelpers.export(exports, "R", ()=>ResourcePath);
parcelHelpers.export(exports, "S", ()=>__PRIVATE_newQueryComparator);
parcelHelpers.export(exports, "T", ()=>__PRIVATE_AutoId);
parcelHelpers.export(exports, "U", ()=>__PRIVATE_fromBundledQuery);
parcelHelpers.export(exports, "V", ()=>DocumentSet);
parcelHelpers.export(exports, "W", ()=>ViewSnapshot);
parcelHelpers.export(exports, "X", ()=>__PRIVATE_documentKeySet);
parcelHelpers.export(exports, "Y", ()=>fail);
parcelHelpers.export(exports, "Z", ()=>__PRIVATE_parseSetData);
parcelHelpers.export(exports, "_", ()=>__PRIVATE_setSDKVersion);
parcelHelpers.export(exports, "a", ()=>__PRIVATE_FirebaseAuthCredentialsProvider);
parcelHelpers.export(exports, "a$", ()=>increment);
parcelHelpers.export(exports, "a0", ()=>FieldPath);
parcelHelpers.export(exports, "a1", ()=>__PRIVATE_parseUpdateVarargs);
parcelHelpers.export(exports, "a2", ()=>__PRIVATE_parseUpdateData);
parcelHelpers.export(exports, "a3", ()=>__PRIVATE_DeleteMutation);
parcelHelpers.export(exports, "a4", ()=>__PRIVATE_firestoreClientTransaction);
parcelHelpers.export(exports, "a5", ()=>__PRIVATE_firestoreClientGetDocumentViaSnapshotListener);
parcelHelpers.export(exports, "a6", ()=>__PRIVATE_firestoreClientGetDocumentFromLocalCache);
parcelHelpers.export(exports, "a7", ()=>__PRIVATE_firestoreClientGetDocumentsViaSnapshotListener);
parcelHelpers.export(exports, "a8", ()=>__PRIVATE_firestoreClientGetDocumentsFromLocalCache);
parcelHelpers.export(exports, "a9", ()=>doc);
parcelHelpers.export(exports, "aA", ()=>GeoPoint);
parcelHelpers.export(exports, "aB", ()=>LoadBundleTask);
parcelHelpers.export(exports, "aC", ()=>Timestamp);
parcelHelpers.export(exports, "aD", ()=>VectorValue);
parcelHelpers.export(exports, "aE", ()=>ByteString);
parcelHelpers.export(exports, "aF", ()=>DatabaseId);
parcelHelpers.export(exports, "aG", ()=>__PRIVATE_EmptyAppCheckTokenProvider);
parcelHelpers.export(exports, "aH", ()=>__PRIVATE_EmptyAuthCredentialsProvider);
parcelHelpers.export(exports, "aI", ()=>FieldPath$1);
parcelHelpers.export(exports, "aJ", ()=>__PRIVATE_debugAssert);
parcelHelpers.export(exports, "aK", ()=>_internalAggregationQueryToProtoRunAggregationQueryRequest);
parcelHelpers.export(exports, "aL", ()=>_internalQueryToProtoQueryTarget);
parcelHelpers.export(exports, "aM", ()=>__PRIVATE_isBase64Available);
parcelHelpers.export(exports, "aN", ()=>__PRIVATE_validateIsNotUsedTogether);
parcelHelpers.export(exports, "aO", ()=>arrayRemove);
parcelHelpers.export(exports, "aP", ()=>arrayUnion);
parcelHelpers.export(exports, "aQ", ()=>clearIndexedDbPersistence);
parcelHelpers.export(exports, "aR", ()=>collection);
parcelHelpers.export(exports, "aS", ()=>collectionGroup);
parcelHelpers.export(exports, "aT", ()=>connectFirestoreEmulator);
parcelHelpers.export(exports, "aU", ()=>deleteField);
parcelHelpers.export(exports, "aV", ()=>disableNetwork);
parcelHelpers.export(exports, "aW", ()=>documentId$1);
parcelHelpers.export(exports, "aX", ()=>enableIndexedDbPersistence);
parcelHelpers.export(exports, "aY", ()=>enableMultiTabIndexedDbPersistence);
parcelHelpers.export(exports, "aZ", ()=>enableNetwork);
parcelHelpers.export(exports, "a_", ()=>getFirestore);
parcelHelpers.export(exports, "aa", ()=>__PRIVATE_newQueryForPath);
parcelHelpers.export(exports, "ab", ()=>__PRIVATE_firestoreClientListen);
parcelHelpers.export(exports, "ac", ()=>loadBundle);
parcelHelpers.export(exports, "ad", ()=>namedQuery);
parcelHelpers.export(exports, "ae", ()=>__PRIVATE_firestoreClientAddSnapshotsInSyncListener);
parcelHelpers.export(exports, "af", ()=>__PRIVATE_firestoreClientWrite);
parcelHelpers.export(exports, "ag", ()=>__PRIVATE_logWarn);
parcelHelpers.export(exports, "ah", ()=>__PRIVATE_fieldPathFromDotSeparatedString);
parcelHelpers.export(exports, "ai", ()=>IndexSegment);
parcelHelpers.export(exports, "aj", ()=>FieldIndex);
parcelHelpers.export(exports, "ak", ()=>IndexState);
parcelHelpers.export(exports, "al", ()=>__PRIVATE_firestoreClientSetIndexConfiguration);
parcelHelpers.export(exports, "am", ()=>__PRIVATE_firestoreClientDeleteAllFieldIndexes);
parcelHelpers.export(exports, "an", ()=>__PRIVATE_logDebug);
parcelHelpers.export(exports, "ao", ()=>__PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled);
parcelHelpers.export(exports, "ap", ()=>__PRIVATE_setTestingHooksSpi);
parcelHelpers.export(exports, "aq", ()=>OrderBy);
parcelHelpers.export(exports, "ar", ()=>__PRIVATE_AggregateImpl);
parcelHelpers.export(exports, "as", ()=>OnlineComponentProvider);
parcelHelpers.export(exports, "at", ()=>__PRIVATE_LruGcMemoryOfflineComponentProvider);
parcelHelpers.export(exports, "au", ()=>__PRIVATE_MemoryOfflineComponentProvider);
parcelHelpers.export(exports, "av", ()=>__PRIVATE_IndexedDbOfflineComponentProvider);
parcelHelpers.export(exports, "aw", ()=>__PRIVATE_MultiTabOfflineComponentProvider);
parcelHelpers.export(exports, "ax", ()=>fn);
parcelHelpers.export(exports, "ay", ()=>CollectionReference);
parcelHelpers.export(exports, "az", ()=>FieldValue);
parcelHelpers.export(exports, "b", ()=>__PRIVATE_FirebaseAppCheckTokenProvider);
parcelHelpers.export(exports, "b$", ()=>AliasedAggregate);
parcelHelpers.export(exports, "b0", ()=>initializeFirestore);
parcelHelpers.export(exports, "b1", ()=>maximum$1);
parcelHelpers.export(exports, "b2", ()=>minimum$1);
parcelHelpers.export(exports, "b3", ()=>refEqual);
parcelHelpers.export(exports, "b4", ()=>serverTimestamp);
parcelHelpers.export(exports, "b5", ()=>setLogLevel);
parcelHelpers.export(exports, "b6", ()=>terminate);
parcelHelpers.export(exports, "b7", ()=>vector);
parcelHelpers.export(exports, "b8", ()=>waitForPendingWrites);
parcelHelpers.export(exports, "b9", ()=>__PRIVATE_isField);
parcelHelpers.export(exports, "bA", ()=>Expression);
parcelHelpers.export(exports, "bB", ()=>constant);
parcelHelpers.export(exports, "bC", ()=>__PRIVATE_FindNearest);
parcelHelpers.export(exports, "bD", ()=>__PRIVATE_isExpr);
parcelHelpers.export(exports, "bE", ()=>documentMatches);
parcelHelpers.export(exports, "bF", ()=>__PRIVATE_isOrdering);
parcelHelpers.export(exports, "bG", ()=>__PRIVATE_Search);
parcelHelpers.export(exports, "bH", ()=>__PRIVATE_Sort);
parcelHelpers.export(exports, "bI", ()=>__PRIVATE_Replace);
parcelHelpers.export(exports, "bJ", ()=>__PRIVATE_Sample);
parcelHelpers.export(exports, "bK", ()=>__PRIVATE_Union);
parcelHelpers.export(exports, "bL", ()=>_field);
parcelHelpers.export(exports, "bM", ()=>__PRIVATE_Unnest);
parcelHelpers.export(exports, "bN", ()=>AggregateFunction);
parcelHelpers.export(exports, "bO", ()=>__PRIVATE_isPlainObject);
parcelHelpers.export(exports, "bP", ()=>__PRIVATE__mapValue);
parcelHelpers.export(exports, "bQ", ()=>__PRIVATE__constant);
parcelHelpers.export(exports, "bR", ()=>__PRIVATE_RawStage);
parcelHelpers.export(exports, "bS", ()=>__PRIVATE_DatabaseSource);
parcelHelpers.export(exports, "bT", ()=>__PRIVATE_StructuredPipelineOptions);
parcelHelpers.export(exports, "bU", ()=>Field);
parcelHelpers.export(exports, "bV", ()=>AliasedExpression);
parcelHelpers.export(exports, "bW", ()=>__PRIVATE_isFirestoreValue);
parcelHelpers.export(exports, "bX", ()=>map);
parcelHelpers.export(exports, "bY", ()=>array);
parcelHelpers.export(exports, "bZ", ()=>pipelineValue);
parcelHelpers.export(exports, "b_", ()=>StructuredPipeline);
parcelHelpers.export(exports, "ba", ()=>__PRIVATE_isOptionalEqual);
parcelHelpers.export(exports, "bb", ()=>__PRIVATE_isString$1);
parcelHelpers.export(exports, "bc", ()=>__PRIVATE_isCollectionReference);
parcelHelpers.export(exports, "bd", ()=>__PRIVATE_CollectionSource);
parcelHelpers.export(exports, "be", ()=>__PRIVATE_CollectionGroupSource);
parcelHelpers.export(exports, "bf", ()=>__PRIVATE_DocumentsSource);
parcelHelpers.export(exports, "bg", ()=>__PRIVATE_toPipelineStages);
parcelHelpers.export(exports, "bh", ()=>__PRIVATE_SubcollectionSource);
parcelHelpers.export(exports, "bi", ()=>__PRIVATE_firestoreClientExecutePipeline);
parcelHelpers.export(exports, "bj", ()=>__PRIVATE_isSelectable);
parcelHelpers.export(exports, "bk", ()=>__PRIVATE_AddFields);
parcelHelpers.export(exports, "bl", ()=>field);
parcelHelpers.export(exports, "bm", ()=>__PRIVATE_RemoveFields);
parcelHelpers.export(exports, "bn", ()=>__PRIVATE_isAliasedExpr);
parcelHelpers.export(exports, "bo", ()=>__PRIVATE_Define);
parcelHelpers.export(exports, "bp", ()=>FunctionExpression);
parcelHelpers.export(exports, "bq", ()=>__PRIVATE_Select);
parcelHelpers.export(exports, "br", ()=>__PRIVATE_isBooleanExpr);
parcelHelpers.export(exports, "bs", ()=>__PRIVATE_Where);
parcelHelpers.export(exports, "bt", ()=>__PRIVATE_isNumber$1);
parcelHelpers.export(exports, "bu", ()=>__PRIVATE_Offset);
parcelHelpers.export(exports, "bv", ()=>__PRIVATE_Limit);
parcelHelpers.export(exports, "bw", ()=>__PRIVATE_Distinct);
parcelHelpers.export(exports, "bx", ()=>__PRIVATE_isAliasedAggregate);
parcelHelpers.export(exports, "by", ()=>__PRIVATE_Aggregate);
parcelHelpers.export(exports, "bz", ()=>__PRIVATE_toField);
parcelHelpers.export(exports, "c", ()=>__PRIVATE_databaseIdFromApp);
parcelHelpers.export(exports, "c$", ()=>ifNull);
parcelHelpers.export(exports, "c0", ()=>BooleanExpression);
parcelHelpers.export(exports, "c1", ()=>Ordering);
parcelHelpers.export(exports, "c2", ()=>_internalPipelineToExecutePipelineRequestProto);
parcelHelpers.export(exports, "c3", ()=>abs);
parcelHelpers.export(exports, "c4", ()=>add);
parcelHelpers.export(exports, "c5", ()=>and);
parcelHelpers.export(exports, "c6", ()=>arrayAgg);
parcelHelpers.export(exports, "c7", ()=>arrayAggDistinct);
parcelHelpers.export(exports, "c8", ()=>arrayConcat);
parcelHelpers.export(exports, "c9", ()=>arrayContains);
parcelHelpers.export(exports, "cA", ()=>collectionId);
parcelHelpers.export(exports, "cB", ()=>concat);
parcelHelpers.export(exports, "cC", ()=>conditional);
parcelHelpers.export(exports, "cD", ()=>cosineDistance);
parcelHelpers.export(exports, "cE", ()=>count);
parcelHelpers.export(exports, "cF", ()=>countAll);
parcelHelpers.export(exports, "cG", ()=>countDistinct);
parcelHelpers.export(exports, "cH", ()=>countIf);
parcelHelpers.export(exports, "cI", ()=>currentDocument);
parcelHelpers.export(exports, "cJ", ()=>currentTimestamp);
parcelHelpers.export(exports, "cK", ()=>descending);
parcelHelpers.export(exports, "cL", ()=>divide);
parcelHelpers.export(exports, "cM", ()=>documentId);
parcelHelpers.export(exports, "cN", ()=>dotProduct);
parcelHelpers.export(exports, "cO", ()=>endsWith);
parcelHelpers.export(exports, "cP", ()=>equal);
parcelHelpers.export(exports, "cQ", ()=>equalAny);
parcelHelpers.export(exports, "cR", ()=>euclideanDistance);
parcelHelpers.export(exports, "cS", ()=>exists);
parcelHelpers.export(exports, "cT", ()=>exp);
parcelHelpers.export(exports, "cU", ()=>first);
parcelHelpers.export(exports, "cV", ()=>floor);
parcelHelpers.export(exports, "cW", ()=>geoDistance);
parcelHelpers.export(exports, "cX", ()=>greaterThan);
parcelHelpers.export(exports, "cY", ()=>greaterThanOrEqual);
parcelHelpers.export(exports, "cZ", ()=>ifAbsent);
parcelHelpers.export(exports, "c_", ()=>ifError);
parcelHelpers.export(exports, "ca", ()=>arrayContainsAll);
parcelHelpers.export(exports, "cb", ()=>arrayContainsAny);
parcelHelpers.export(exports, "cc", ()=>arrayFilter);
parcelHelpers.export(exports, "cd", ()=>arrayFirst);
parcelHelpers.export(exports, "ce", ()=>arrayFirstN);
parcelHelpers.export(exports, "cf", ()=>arrayGet);
parcelHelpers.export(exports, "cg", ()=>arrayIndexOf);
parcelHelpers.export(exports, "ch", ()=>arrayIndexOfAll);
parcelHelpers.export(exports, "ci", ()=>arrayLast);
parcelHelpers.export(exports, "cj", ()=>arrayLastIndexOf);
parcelHelpers.export(exports, "ck", ()=>arrayLastN);
parcelHelpers.export(exports, "cl", ()=>arrayLength);
parcelHelpers.export(exports, "cm", ()=>arrayMaximum);
parcelHelpers.export(exports, "cn", ()=>arrayMaximumN);
parcelHelpers.export(exports, "co", ()=>arrayMinimum);
parcelHelpers.export(exports, "cp", ()=>arrayMinimumN);
parcelHelpers.export(exports, "cq", ()=>arraySlice);
parcelHelpers.export(exports, "cr", ()=>arraySum);
parcelHelpers.export(exports, "cs", ()=>arrayTransform);
parcelHelpers.export(exports, "ct", ()=>arrayTransformWithIndex);
parcelHelpers.export(exports, "cu", ()=>ascending);
parcelHelpers.export(exports, "cv", ()=>average);
parcelHelpers.export(exports, "cw", ()=>byteLength);
parcelHelpers.export(exports, "cx", ()=>ceil);
parcelHelpers.export(exports, "cy", ()=>charLength);
parcelHelpers.export(exports, "cz", ()=>coalesce);
parcelHelpers.export(exports, "d", ()=>FirestoreError);
parcelHelpers.export(exports, "d$", ()=>timestampToUnixSeconds);
parcelHelpers.export(exports, "d0", ()=>isAbsent);
parcelHelpers.export(exports, "d1", ()=>isError);
parcelHelpers.export(exports, "d2", ()=>isType);
parcelHelpers.export(exports, "d3", ()=>join);
parcelHelpers.export(exports, "d4", ()=>last);
parcelHelpers.export(exports, "d5", ()=>length);
parcelHelpers.export(exports, "d6", ()=>lessThan);
parcelHelpers.export(exports, "d7", ()=>lessThanOrEqual);
parcelHelpers.export(exports, "d8", ()=>like);
parcelHelpers.export(exports, "d9", ()=>ln);
parcelHelpers.export(exports, "dA", ()=>regexFind);
parcelHelpers.export(exports, "dB", ()=>regexFindAll);
parcelHelpers.export(exports, "dC", ()=>regexMatch);
parcelHelpers.export(exports, "dD", ()=>reverse);
parcelHelpers.export(exports, "dE", ()=>round);
parcelHelpers.export(exports, "dF", ()=>rtrim);
parcelHelpers.export(exports, "dG", ()=>score);
parcelHelpers.export(exports, "dH", ()=>split);
parcelHelpers.export(exports, "dI", ()=>sqrt);
parcelHelpers.export(exports, "dJ", ()=>startsWith);
parcelHelpers.export(exports, "dK", ()=>stringConcat);
parcelHelpers.export(exports, "dL", ()=>stringContains);
parcelHelpers.export(exports, "dM", ()=>stringIndexOf);
parcelHelpers.export(exports, "dN", ()=>stringRepeat);
parcelHelpers.export(exports, "dO", ()=>stringReplaceAll);
parcelHelpers.export(exports, "dP", ()=>stringReplaceOne);
parcelHelpers.export(exports, "dQ", ()=>stringReverse);
parcelHelpers.export(exports, "dR", ()=>substring);
parcelHelpers.export(exports, "dS", ()=>subtract);
parcelHelpers.export(exports, "dT", ()=>sum);
parcelHelpers.export(exports, "dU", ()=>switchOn);
parcelHelpers.export(exports, "dV", ()=>timestampAdd);
parcelHelpers.export(exports, "dW", ()=>timestampDiff);
parcelHelpers.export(exports, "dX", ()=>timestampExtract);
parcelHelpers.export(exports, "dY", ()=>timestampSubtract);
parcelHelpers.export(exports, "dZ", ()=>timestampToUnixMicros);
parcelHelpers.export(exports, "d_", ()=>timestampToUnixMillis);
parcelHelpers.export(exports, "da", ()=>log);
parcelHelpers.export(exports, "db", ()=>log10);
parcelHelpers.export(exports, "dc", ()=>logicalMaximum);
parcelHelpers.export(exports, "dd", ()=>logicalMinimum);
parcelHelpers.export(exports, "de", ()=>ltrim);
parcelHelpers.export(exports, "df", ()=>mapEntries);
parcelHelpers.export(exports, "dg", ()=>mapGet);
parcelHelpers.export(exports, "dh", ()=>mapKeys);
parcelHelpers.export(exports, "di", ()=>mapMerge);
parcelHelpers.export(exports, "dj", ()=>mapRemove);
parcelHelpers.export(exports, "dk", ()=>mapSet);
parcelHelpers.export(exports, "dl", ()=>mapValues);
parcelHelpers.export(exports, "dm", ()=>maximum);
parcelHelpers.export(exports, "dn", ()=>minimum);
parcelHelpers.export(exports, "dp", ()=>mod);
parcelHelpers.export(exports, "dq", ()=>multiply);
parcelHelpers.export(exports, "dr", ()=>nor);
parcelHelpers.export(exports, "ds", ()=>not);
parcelHelpers.export(exports, "dt", ()=>notEqual);
parcelHelpers.export(exports, "du", ()=>notEqualAny);
parcelHelpers.export(exports, "dv", ()=>or);
parcelHelpers.export(exports, "dw", ()=>parent);
parcelHelpers.export(exports, "dx", ()=>pow);
parcelHelpers.export(exports, "dy", ()=>rand);
parcelHelpers.export(exports, "dz", ()=>regexContains);
parcelHelpers.export(exports, "e", ()=>D);
parcelHelpers.export(exports, "e0", ()=>timestampTruncate);
parcelHelpers.export(exports, "e1", ()=>toLower);
parcelHelpers.export(exports, "e2", ()=>toUpper);
parcelHelpers.export(exports, "e3", ()=>trim);
parcelHelpers.export(exports, "e4", ()=>trunc);
parcelHelpers.export(exports, "e5", ()=>type);
parcelHelpers.export(exports, "e6", ()=>unixMicrosToTimestamp);
parcelHelpers.export(exports, "e7", ()=>unixMillisToTimestamp);
parcelHelpers.export(exports, "e8", ()=>unixSecondsToTimestamp);
parcelHelpers.export(exports, "e9", ()=>variable);
parcelHelpers.export(exports, "ea", ()=>vectorLength);
parcelHelpers.export(exports, "eb", ()=>xor);
parcelHelpers.export(exports, "f", ()=>__PRIVATE_queryWithAddedFilter);
parcelHelpers.export(exports, "g", ()=>__PRIVATE_newUserDataReader);
parcelHelpers.export(exports, "h", ()=>__PRIVATE_parseQueryValue);
parcelHelpers.export(exports, "i", ()=>FieldFilter);
parcelHelpers.export(exports, "j", ()=>__PRIVATE_fieldPathFromArgument);
parcelHelpers.export(exports, "k", ()=>__PRIVATE_queryWithAddedOrderBy);
parcelHelpers.export(exports, "l", ()=>__PRIVATE_queryWithLimit);
parcelHelpers.export(exports, "m", ()=>__PRIVATE_validatePositiveNumber);
parcelHelpers.export(exports, "n", ()=>__PRIVATE_queryWithStartAt);
parcelHelpers.export(exports, "o", ()=>__PRIVATE_queryWithEndAt);
parcelHelpers.export(exports, "p", ()=>property);
parcelHelpers.export(exports, "q", ()=>__PRIVATE_queryNormalizedOrderBy);
parcelHelpers.export(exports, "r", ()=>__PRIVATE_refValue);
parcelHelpers.export(exports, "s", ()=>__PRIVATE_isServerTimestamp);
parcelHelpers.export(exports, "t", ()=>Bound);
parcelHelpers.export(exports, "u", ()=>__PRIVATE_isCollectionGroupQuery);
parcelHelpers.export(exports, "v", ()=>DocumentKey);
parcelHelpers.export(exports, "w", ()=>__PRIVATE_valueDescription);
parcelHelpers.export(exports, "x", ()=>queryEqual);
parcelHelpers.export(exports, "y", ()=>__PRIVATE_cast);
parcelHelpers.export(exports, "z", ()=>ensureFirestoreConfigured);
var _app = require("@firebase/app");
var _util = require("@firebase/util");
var _bloomBlob = require("@firebase/webchannel-wrapper/bloom-blob");
var _logger = require("@firebase/logger");
var _webchannelBlob = require("@firebase/webchannel-wrapper/webchannel-blob");
var _re2Js = require("re2js");
var Buffer = require("907a2703743caaff").Buffer;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Simple wrapper around a nullable UID. Mostly exists to make code more
 * readable.
 */ class User {
    constructor(e){
        this.uid = e;
    }
    isAuthenticated() {
        return null != this.uid;
    }
    /**
     * Returns a key representing this user, suitable for inclusion in a
     * dictionary.
     */ toKey() {
        return this.isAuthenticated() ? "uid:" + this.uid : "anonymous-user";
    }
    isEqual(e) {
        return e.uid === this.uid;
    }
}
/** A user with a null UID. */ User.UNAUTHENTICATED = new User(null), // TODO(mikelehen): Look into getting a proper uid-equivalent for
// non-FirebaseAuth providers.
User.GOOGLE_CREDENTIALS = new User("google-credentials-uid"), User.FIRST_PARTY = new User("first-party-uid"), User.MOCK_USER = new User("mock-user");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let v = "12.15.0";
function __PRIVATE_setSDKVersion(e) {
    v = e;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Formats an object as a JSON string, suitable for logging. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const S = new (0, _logger.Logger)("@firebase/firestore");
// Helper methods are needed because variables can't be exported as read/write
function __PRIVATE_getLogLevel() {
    return S.logLevel;
}
/**
 * Sets the verbosity of Cloud Firestore logs (debug, error, or silent).
 *
 * @param logLevel - The verbosity you set for activity and error logging. Can
 *   be any of the following values:
 *
 *   <ul>
 *     <li>`debug` for the most verbose logging level, primarily for
 *     debugging.</li>
 *     <li>`error` to log errors only.</li>
 *     <li><code>`silent` to turn off logging.</li>
 *   </ul>
 */ function setLogLevel(e) {
    S.setLogLevel(e);
}
function __PRIVATE_logDebug(e, ...t) {
    if (S.logLevel <= (0, _logger.LogLevel).DEBUG) {
        const n = t.map(__PRIVATE_argToString);
        S.debug(`Firestore (${v}): ${e}`, ...n);
    }
}
function __PRIVATE_logError(e, ...t) {
    if (S.logLevel <= (0, _logger.LogLevel).ERROR) {
        const n = t.map(__PRIVATE_argToString);
        S.error(`Firestore (${v}): ${e}`, ...n);
    }
}
/**
 * @internal
 */ function __PRIVATE_logWarn(e, ...t) {
    if (S.logLevel <= (0, _logger.LogLevel).WARN) {
        const n = t.map(__PRIVATE_argToString);
        S.warn(`Firestore (${v}): ${e}`, ...n);
    }
}
/**
 * Converts an additional log parameter to a string representation.
 */ function __PRIVATE_argToString(e) {
    if ("string" == typeof e) return e;
    try {
        return function __PRIVATE_formatJSON(e) {
            return JSON.stringify(e);
        }(e);
    } catch (t) {
        // Converting to JSON failed, just log the object directly
        return e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function fail(e, t, n) {
    let r = "Unexpected state";
    "string" == typeof t ? r = t : n = t, __PRIVATE__fail(e, r, n);
}
function __PRIVATE__fail(e, t, n) {
    // Log the failure in addition to throw an exception, just in case the
    // exception is swallowed.
    let r = `FIRESTORE (${v}) INTERNAL ASSERTION FAILED: ${t} (ID: ${e.toString(16)})`;
    if (void 0 !== n) try {
        r += " CONTEXT: " + JSON.stringify(n);
    } catch (e) {
        r += " CONTEXT: " + n;
    }
    // NOTE: We don't use FirestoreError here because these are internal failures
    // that cannot be handled by the user. (Also it would create a circular
    // dependency between the error and assert modules which doesn't work.)
    throw __PRIVATE_logError(r), new Error(r);
}
function __PRIVATE_hardAssert(e, t, n, r) {
    let i = "Unexpected state";
    "string" == typeof n ? i = n : r = n, e || __PRIVATE__fail(t, i, r);
}
/**
 * Fails if the given assertion condition is false, throwing an Error with the
 * given message if it did.
 *
 * The code of callsites invoking this function are stripped out in production
 * builds. Any side-effects of code within the debugAssert() invocation will not
 * happen in this case.
 *
 * @internal
 */ function __PRIVATE_debugAssert(e, t) {
    e || fail(57014, t);
}
/**
 * Casts `obj` to `T`. In non-production builds, verifies that `obj` is an
 * instance of `T` before casting.
 */ function __PRIVATE_debugCast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    return e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const D = {
    // Causes are copied from:
    // https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
    /** Not an error; returned on success. */ OK: "ok",
    /** The operation was cancelled (typically by the caller). */ CANCELLED: "cancelled",
    /** Unknown error or an error from a different error domain. */ UNKNOWN: "unknown",
    /**
     * Client specified an invalid argument. Note that this differs from
     * FAILED_PRECONDITION. INVALID_ARGUMENT indicates arguments that are
     * problematic regardless of the state of the system (e.g., a malformed file
     * name).
     */ INVALID_ARGUMENT: "invalid-argument",
    /**
     * Deadline expired before operation could complete. For operations that
     * change the state of the system, this error may be returned even if the
     * operation has completed successfully. For example, a successful response
     * from a server could have been delayed long enough for the deadline to
     * expire.
     */ DEADLINE_EXCEEDED: "deadline-exceeded",
    /** Some requested entity (e.g., file or directory) was not found. */ NOT_FOUND: "not-found",
    /**
     * Some entity that we attempted to create (e.g., file or directory) already
     * exists.
     */ ALREADY_EXISTS: "already-exists",
    /**
     * The caller does not have permission to execute the specified operation.
     * PERMISSION_DENIED must not be used for rejections caused by exhausting
     * some resource (use RESOURCE_EXHAUSTED instead for those errors).
     * PERMISSION_DENIED must not be used if the caller cannot be identified
     * (use UNAUTHENTICATED instead for those errors).
     */ PERMISSION_DENIED: "permission-denied",
    /**
     * The request does not have valid authentication credentials for the
     * operation.
     */ UNAUTHENTICATED: "unauthenticated",
    /**
     * Some resource has been exhausted, perhaps a per-user quota, or perhaps the
     * entire file system is out of space.
     */ RESOURCE_EXHAUSTED: "resource-exhausted",
    /**
     * Operation was rejected because the system is not in a state required for
     * the operation's execution. For example, directory to be deleted may be
     * non-empty, an rmdir operation is applied to a non-directory, etc.
     *
     * A litmus test that may help a service implementor in deciding
     * between FAILED_PRECONDITION, ABORTED, and UNAVAILABLE:
     *  (a) Use UNAVAILABLE if the client can retry just the failing call.
     *  (b) Use ABORTED if the client should retry at a higher-level
     *      (e.g., restarting a read-modify-write sequence).
     *  (c) Use FAILED_PRECONDITION if the client should not retry until
     *      the system state has been explicitly fixed. E.g., if an "rmdir"
     *      fails because the directory is non-empty, FAILED_PRECONDITION
     *      should be returned since the client should not retry unless
     *      they have first fixed up the directory by deleting files from it.
     *  (d) Use FAILED_PRECONDITION if the client performs conditional
     *      REST Get/Update/Delete on a resource and the resource on the
     *      server does not match the condition. E.g., conflicting
     *      read-modify-write on the same resource.
     */ FAILED_PRECONDITION: "failed-precondition",
    /**
     * The operation was aborted, typically due to a concurrency issue like
     * sequencer check failures, transaction aborts, etc.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ ABORTED: "aborted",
    /**
     * Operation was attempted past the valid range. E.g., seeking or reading
     * past end of file.
     *
     * Unlike INVALID_ARGUMENT, this error indicates a problem that may be fixed
     * if the system state changes. For example, a 32-bit file system will
     * generate INVALID_ARGUMENT if asked to read at an offset that is not in the
     * range [0,2^32-1], but it will generate OUT_OF_RANGE if asked to read from
     * an offset past the current file size.
     *
     * There is a fair bit of overlap between FAILED_PRECONDITION and
     * OUT_OF_RANGE. We recommend using OUT_OF_RANGE (the more specific error)
     * when it applies so that callers who are iterating through a space can
     * easily look for an OUT_OF_RANGE error to detect when they are done.
     */ OUT_OF_RANGE: "out-of-range",
    /** Operation is not implemented or not supported/enabled in this service. */ UNIMPLEMENTED: "unimplemented",
    /**
     * Internal errors. Means some invariants expected by underlying System has
     * been broken. If you see one of these errors, Something is very broken.
     */ INTERNAL: "internal",
    /**
     * The service is currently unavailable. This is a most likely a transient
     * condition and may be corrected by retrying with a backoff.
     *
     * See litmus test above for deciding between FAILED_PRECONDITION, ABORTED,
     * and UNAVAILABLE.
     */ UNAVAILABLE: "unavailable",
    /** Unrecoverable data loss or corruption. */ DATA_LOSS: "data-loss"
};
/** An error returned by a Firestore operation. */ class FirestoreError extends (0, _util.FirebaseError) {
    /** @hideconstructor */ constructor(/**
     * The backend error code associated with this error.
     */ e, /**
     * A custom error description.
     */ t){
        super(e, t), this.code = e, this.message = t, // HACK: We write a toString property directly because Error is not a real
        // class and so inheritance does not work correctly. We could alternatively
        // do the same "back-door inheritance" trick that FirebaseError does.
        this.toString = ()=>`${this.name}: [code=${this.code}]: ${this.message}`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_Deferred {
    constructor(){
        this.promise = new Promise((e, t)=>{
            this.resolve = e, this.reject = t;
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_OAuthToken {
    constructor(e, t){
        this.user = t, this.type = "OAuth", this.headers = new Map, this.headers.set("Authorization", `Bearer ${e}`);
    }
}
/**
 * A CredentialsProvider that always yields an empty token.
 * @internal
 */ class __PRIVATE_EmptyAuthCredentialsProvider {
    getToken() {
        return Promise.resolve(null);
    }
    invalidateToken() {}
    start(e, t) {
        // Fire with initial user.
        e.enqueueRetryable(()=>t(User.UNAUTHENTICATED));
    }
    shutdown() {}
}
/**
 * A CredentialsProvider that always returns a constant token. Used for
 * emulator token mocking.
 */ class __PRIVATE_EmulatorAuthCredentialsProvider {
    constructor(e){
        this.token = e, /**
         * Stores the listener registered with setChangeListener()
         * This isn't actually necessary since the UID never changes, but we use this
         * to verify the listen contract is adhered to in tests.
         */ this.changeListener = null;
    }
    getToken() {
        return Promise.resolve(this.token);
    }
    invalidateToken() {}
    start(e, t) {
        this.changeListener = t, // Fire with initial user.
        e.enqueueRetryable(()=>t(this.token.user));
    }
    shutdown() {
        this.changeListener = null;
    }
}
class __PRIVATE_FirebaseAuthCredentialsProvider {
    constructor(e){
        this.t = e, /** Tracks the current User. */ this.currentUser = User.UNAUTHENTICATED, /**
         * Counter used to detect if the token changed while a getToken request was
         * outstanding.
         */ this.i = 0, this.forceRefresh = !1, this.auth = null;
    }
    start(e, t) {
        __PRIVATE_hardAssert(void 0 === this.o, 42304);
        let n = this.i;
        // A change listener that prevents double-firing for the same token change.
        const __PRIVATE_guardedChangeListener = (e)=>this.i !== n ? (n = this.i, t(e)) : Promise.resolve();
        // A promise that can be waited on to block on the next token change.
        // This promise is re-created after each change.
        let r = new __PRIVATE_Deferred;
        this.o = ()=>{
            this.i++, this.currentUser = this.u(), r.resolve(), r = new __PRIVATE_Deferred, e.enqueueRetryable(()=>__PRIVATE_guardedChangeListener(this.currentUser));
        };
        const __PRIVATE_awaitNextToken = ()=>{
            const t = r;
            e.enqueueRetryable(async ()=>{
                await t.promise, await __PRIVATE_guardedChangeListener(this.currentUser);
            });
        }, __PRIVATE_registerAuth = (e)=>{
            __PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth detected"), this.auth = e, this.o && (this.auth.addAuthTokenListener(this.o), __PRIVATE_awaitNextToken());
        };
        this.t.onInit((e)=>__PRIVATE_registerAuth(e)), // Our users can initialize Auth right after Firestore, so we give it
        // a chance to register itself with the component framework before we
        // determine whether to start up in unauthenticated mode.
        setTimeout(()=>{
            if (!this.auth) {
                const e = this.t.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAuth(e) : // If auth is still not available, proceed with `null` user
                (__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "Auth not yet detected"), r.resolve(), r = new __PRIVATE_Deferred);
            }
        }, 0), __PRIVATE_awaitNextToken();
    }
    getToken() {
        // Take note of the current value of the tokenCounter so that this method
        // can fail (with an ABORTED error) if there is a token change while the
        // request is outstanding.
        const e = this.i, t = this.forceRefresh;
        return this.forceRefresh = !1, this.auth ? this.auth.getToken(t).then((t)=>// Cancel the request since the token changed while the request was
            // outstanding so the response is potentially for a previous user (which
            // user, we can't be sure).
            this.i !== e ? (__PRIVATE_logDebug("FirebaseAuthCredentialsProvider", "getToken aborted due to token change."), this.getToken()) : t ? (__PRIVATE_hardAssert("string" == typeof t.accessToken, 31837, {
                l: t
            }), new __PRIVATE_OAuthToken(t.accessToken, this.currentUser)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.auth && this.o && this.auth.removeAuthTokenListener(this.o), this.o = void 0;
    }
    // Auth.getUid() can return null even with a user logged in. It is because
    // getUid() is synchronous, but the auth code populating Uid is asynchronous.
    // This method should only be called in the AuthTokenListener callback
    // to guarantee to get the actual user.
    u() {
        const e = this.auth && this.auth.getUid();
        return __PRIVATE_hardAssert(null === e || "string" == typeof e, 2055, {
            h: e
        }), new User(e);
    }
}
/*
 * FirstPartyToken provides a fresh token each time its value
 * is requested, because if the token is too old, requests will be rejected.
 * Technically this may no longer be necessary since the SDK should gracefully
 * recover from unauthenticated errors (see b/33147818 for context), but it's
 * safer to keep the implementation as-is.
 */ class __PRIVATE_FirstPartyToken {
    constructor(e, t, n){
        this.T = e, this.P = t, this.R = n, this.type = "FirstParty", this.user = User.FIRST_PARTY, this.I = new Map;
    }
    /**
     * Gets an authorization token, using a provided factory function, or return
     * null.
     */ A() {
        return this.R ? this.R() : null;
    }
    get headers() {
        this.I.set("X-Goog-AuthUser", this.T);
        // Use array notation to prevent minification
        const e = this.A();
        return e && this.I.set("Authorization", e), this.P && this.I.set("X-Goog-Iam-Authorization-Token", this.P), this.I;
    }
}
/*
 * Provides user credentials required for the Firestore JavaScript SDK
 * to authenticate the user, using technique that is only available
 * to applications hosted by Google.
 */ class __PRIVATE_FirstPartyAuthCredentialsProvider {
    constructor(e, t, n){
        this.T = e, this.P = t, this.R = n;
    }
    getToken() {
        return Promise.resolve(new __PRIVATE_FirstPartyToken(this.T, this.P, this.R));
    }
    start(e, t) {
        // Fire with initial uid.
        e.enqueueRetryable(()=>t(User.FIRST_PARTY));
    }
    shutdown() {}
    invalidateToken() {}
}
class AppCheckToken {
    constructor(e){
        this.value = e, this.type = "AppCheck", this.headers = new Map, e && e.length > 0 && this.headers.set("x-firebase-appcheck", this.value);
    }
}
class __PRIVATE_FirebaseAppCheckTokenProvider {
    constructor(t, n){
        this.V = n, this.forceRefresh = !1, this.appCheck = null, this.m = null, this.p = null, (0, _app._isFirebaseServerApp)(t) && t.settings.appCheckToken && (this.p = t.settings.appCheckToken);
    }
    start(e, t) {
        __PRIVATE_hardAssert(void 0 === this.o, 3512);
        const onTokenChanged = (e)=>{
            null != e.error && __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Error getting App Check token; using placeholder token instead. Error: ${e.error.message}`);
            const n = e.token !== this.m;
            return this.m = e.token, __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", `Received ${n ? "new" : "existing"} token.`), n ? t(e.token) : Promise.resolve();
        };
        this.o = (t)=>{
            e.enqueueRetryable(()=>onTokenChanged(t));
        };
        const __PRIVATE_registerAppCheck = (e)=>{
            __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck detected"), this.appCheck = e, this.o && this.appCheck.addTokenListener(this.o);
        };
        this.V.onInit((e)=>__PRIVATE_registerAppCheck(e)), // Our users can initialize AppCheck after Firestore, so we give it
        // a chance to register itself with the component framework.
        setTimeout(()=>{
            if (!this.appCheck) {
                const e = this.V.getImmediate({
                    optional: !0
                });
                e ? __PRIVATE_registerAppCheck(e) : // If AppCheck is still not available, proceed without it.
                __PRIVATE_logDebug("FirebaseAppCheckTokenProvider", "AppCheck not yet detected");
            }
        }, 0);
    }
    getToken() {
        if (this.p) return Promise.resolve(new AppCheckToken(this.p));
        const e = this.forceRefresh;
        return this.forceRefresh = !1, this.appCheck ? this.appCheck.getToken(e).then((e)=>e ? (__PRIVATE_hardAssert("string" == typeof e.token, 44558, {
                tokenResult: e
            }), this.m = e.token, new AppCheckToken(e.token)) : null) : Promise.resolve(null);
    }
    invalidateToken() {
        this.forceRefresh = !0;
    }
    shutdown() {
        this.appCheck && this.o && this.appCheck.removeTokenListener(this.o), this.o = void 0;
    }
}
/**
 * An AppCheck token provider that always yields an empty token.
 * @internal
 */ class __PRIVATE_EmptyAppCheckTokenProvider {
    getToken() {
        return Promise.resolve(new AppCheckToken(""));
    }
    invalidateToken() {}
    start(e, t) {}
    shutdown() {}
}
/**
 * Builds a CredentialsProvider depending on the type of
 * the credentials passed in.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Generates `nBytes` of random bytes.
 *
 * If `nBytes < 0` , an error will be thrown.
 */ function __PRIVATE_randomBytes(e) {
    // Polyfills for IE and WebWorker by using `self` and `msCrypto` when `crypto` is not available.
    const t = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    "undefined" != typeof self && (self.crypto || self.msCrypto), n = new Uint8Array(e);
    if (t && "function" == typeof t.getRandomValues) t.getRandomValues(n);
    else // Falls back to Math.random
    for(let t = 0; t < e; t++)n[t] = Math.floor(256 * Math.random());
    return n;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A utility class for generating unique alphanumeric IDs of a specified length.
 *
 * @internal
 * Exported internally for testing purposes.
 */ class __PRIVATE_AutoId {
    static newId() {
        // Alphanumeric characters
        const e = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789", t = 62 * Math.floor(256 / 62);
        // The largest byte value that is a multiple of `char.length`.
        let n = "";
        for(; n.length < 20;){
            const r = __PRIVATE_randomBytes(40);
            for(let i = 0; i < r.length; ++i)// Only accept values that are [0, maxMultiple), this ensures they can
            // be evenly mapped to indices of `chars` via a modulo operation.
            n.length < 20 && r[i] < t && (n += e.charAt(r[i] % 62));
        }
        return n;
    }
}
function __PRIVATE_primitiveComparator(e, t) {
    return e < t ? -1 : e > t ? 1 : 0;
}
/** Compare strings in UTF-8 encoded byte order */ function __PRIVATE_compareUtf8Strings(e, t) {
    // Find the first differing character (a.k.a. "UTF-16 code unit") in the two strings and,
    // if found, use that character to determine the relative ordering of the two strings as a
    // whole. Comparing UTF-16 strings in UTF-8 byte order can be done simply and efficiently by
    // comparing the UTF-16 code units (chars). This serendipitously works because of the way UTF-8
    // and UTF-16 happen to represent Unicode code points.
    // After finding the first pair of differing characters, there are two cases:
    // Case 1: Both characters are non-surrogates (code points less than or equal to 0xFFFF) or
    // both are surrogates from a surrogate pair (that collectively represent code points greater
    // than 0xFFFF). In this case their numeric order as UTF-16 code units is the same as the
    // lexicographical order of their corresponding UTF-8 byte sequences. A direct comparison is
    // sufficient.
    // Case 2: One character is a surrogate and the other is not. In this case the surrogate-
    // containing string is always ordered after the non-surrogate. This is because surrogates are
    // used to represent code points greater than 0xFFFF which have 4-byte UTF-8 representations
    // and are lexicographically greater than the 1, 2, or 3-byte representations of code points
    // less than or equal to 0xFFFF.
    // An example of why Case 2 is required is comparing the following two Unicode code points:
    // |-----------------------|------------|---------------------|-----------------|
    // | Name                  | Code Point | UTF-8 Encoding      | UTF-16 Encoding |
    // |-----------------------|------------|---------------------|-----------------|
    // | Replacement Character | U+FFFD     | 0xEF 0xBF 0xBD      | 0xFFFD          |
    // | Grinning Face         | U+1F600    | 0xF0 0x9F 0x98 0x80 | 0xD83D 0xDE00   |
    // |-----------------------|------------|---------------------|-----------------|
    // A lexicographical comparison of the UTF-8 encodings of these code points would order
    // "Replacement Character" _before_ "Grinning Face" because 0xEF is less than 0xF0. However, a
    // direct comparison of the UTF-16 code units, as would be done in case 1, would erroneously
    // produce the _opposite_ ordering, because 0xFFFD is _greater than_ 0xD83D. As it turns out,
    // this relative ordering holds for all comparisons of UTF-16 code points requiring a surrogate
    // pair with those that do not.
    const n = Math.min(e.length, t.length);
    for(let r = 0; r < n; r++){
        const n = e.charAt(r), i = t.charAt(r);
        if (n !== i) return __PRIVATE_isSurrogate(n) === __PRIVATE_isSurrogate(i) ? __PRIVATE_primitiveComparator(n, i) : __PRIVATE_isSurrogate(n) ? 1 : -1;
    }
    // Use the lengths of the strings to determine the overall comparison result since either the
    // strings were equal or one is a prefix of the other.
    return __PRIVATE_primitiveComparator(e.length, t.length);
}
const x = 55296, C = 57343;
function __PRIVATE_isSurrogate(e) {
    const t = e.charCodeAt(0);
    return t >= x && t <= C;
}
/** Helper to compare arrays using isEqual(). */ function __PRIVATE_arrayEquals(e, t, n) {
    return e.length === t.length && e.every((e, r)=>n(e, t[r]));
}
/**
 * Verifies equality for an optional value.
 */ function __PRIVATE_isOptionalEqual(e, t, n) {
    return void 0 === e && void 0 === t || void 0 !== e && void 0 !== t && n(e, t);
}
/**
 * Returns the immediate lexicographically-following string. This is useful to
 * construct an inclusive range for indexeddb iterators.
 */ function __PRIVATE_immediateSuccessor(e) {
    // Return the input string, with an additional NUL byte appended.
    return e + "\0";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const F = "__name__";
/**
 * Path represents an ordered sequence of string segments.
 */ class BasePath {
    constructor(e, t, n){
        void 0 === t ? t = 0 : t > e.length && fail(637, {
            offset: t,
            range: e.length
        }), void 0 === n ? n = e.length - t : n > e.length - t && fail(1746, {
            length: n,
            range: e.length - t
        }), this.segments = e, this.offset = t, this.len = n;
    }
    get length() {
        return this.len;
    }
    isEqual(e) {
        return 0 === BasePath.comparator(this, e);
    }
    child(e) {
        const t = this.segments.slice(this.offset, this.limit());
        return e instanceof BasePath ? e.forEach((e)=>{
            t.push(e);
        }) : t.push(e), this.construct(t);
    }
    /** The index of one past the last segment of the path. */ limit() {
        return this.offset + this.length;
    }
    popFirst(e) {
        return e = void 0 === e ? 1 : e, this.construct(this.segments, this.offset + e, this.length - e);
    }
    popLast() {
        return this.construct(this.segments, this.offset, this.length - 1);
    }
    firstSegment() {
        return this.segments[this.offset];
    }
    lastSegment() {
        return this.get(this.length - 1);
    }
    get(e) {
        return this.segments[this.offset + e];
    }
    isEmpty() {
        return 0 === this.length;
    }
    isPrefixOf(e) {
        if (e.length < this.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    isImmediateParentOf(e) {
        if (this.length + 1 !== e.length) return !1;
        for(let t = 0; t < this.length; t++)if (this.get(t) !== e.get(t)) return !1;
        return !0;
    }
    forEach(e) {
        for(let t = this.offset, n = this.limit(); t < n; t++)e(this.segments[t]);
    }
    toArray() {
        return this.segments.slice(this.offset, this.limit());
    }
    /**
     * Compare 2 paths segment by segment, prioritizing numeric IDs
     * (e.g., "__id123__") in numeric ascending order, followed by string
     * segments in lexicographical order.
     */ static comparator(e, t) {
        const n = Math.min(e.length, t.length);
        for(let r = 0; r < n; r++){
            const n = BasePath.compareSegments(e.get(r), t.get(r));
            if (0 !== n) return n;
        }
        return __PRIVATE_primitiveComparator(e.length, t.length);
    }
    static compareSegments(e, t) {
        const n = BasePath.isNumericId(e), r = BasePath.isNumericId(t);
        return n && !r ? -1 : !n && r ? 1 : n && r ? BasePath.extractNumericId(e).compare(BasePath.extractNumericId(t)) : __PRIVATE_compareUtf8Strings(e, t);
    }
    // Checks if a segment is a numeric ID (starts with "__id" and ends with "__").
    static isNumericId(e) {
        return e.startsWith("__id") && e.endsWith("__");
    }
    static extractNumericId(e) {
        return (0, _bloomBlob.Integer).fromString(e.substring(4, e.length - 2));
    }
}
/**
 * A slash-separated path for navigating resources (documents and collections)
 * within Firestore.
 *
 * @internal
 */ class ResourcePath extends BasePath {
    construct(e, t, n) {
        return new ResourcePath(e, t, n);
    }
    canonicalString() {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        return this.toArray().join("/");
    }
    toString() {
        return this.canonicalString();
    }
    toStringWithLeadingSlash() {
        return `/${this.canonicalString()}`;
    }
    /**
     * Returns a string representation of this path
     * where each path segment has been encoded with
     * `encodeURIComponent`.
     */ toUriEncodedString() {
        return this.toArray().map(encodeURIComponent).join("/");
    }
    /**
     * Creates a resource path from the given slash-delimited string. If multiple
     * arguments are provided, all components are combined. Leading and trailing
     * slashes from all components are ignored.
     */ static fromString(...e) {
        // NOTE: The client is ignorant of any path segments containing escape
        // sequences (e.g. __id123__) and just passes them through raw (they exist
        // for legacy reasons and should not be used frequently).
        const t = [];
        for (const n of e){
            if (n.indexOf("//") >= 0) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid segment (${n}). Paths must not contain // in them.`);
            // Strip leading and trailing slashed.
            t.push(...n.split("/").filter((e)=>e.length > 0));
        }
        return new ResourcePath(t);
    }
    static emptyPath() {
        return new ResourcePath([]);
    }
}
const O = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * A dot-separated path for navigating sub-objects within a document.
 * @internal
 */ class FieldPath$1 extends BasePath {
    construct(e, t, n) {
        return new FieldPath$1(e, t, n);
    }
    /**
     * Returns true if the string could be used as a segment in a field path
     * without escaping.
     */ static isValidIdentifier(e) {
        return O.test(e);
    }
    canonicalString() {
        return this.toArray().map((e)=>(e = e.replace(/\\/g, "\\\\").replace(/`/g, "\\`"), FieldPath$1.isValidIdentifier(e) || (e = "`" + e + "`"), e)).join(".");
    }
    toString() {
        return this.canonicalString();
    }
    /**
     * Returns true if this field references the key of a document.
     */ isKeyField() {
        return 1 === this.length && this.get(0) === F;
    }
    /**
     * The field designating the key of a document.
     */ static keyField() {
        return new FieldPath$1([
            F
        ]);
    }
    /**
     * Parses a field string from the given server-formatted string.
     *
     * - Splitting the empty string is not allowed (for now at least).
     * - Empty segments within the string (e.g. if there are two consecutive
     *   separators) are not allowed.
     *
     * TODO(b/37244157): we should make this more strict. Right now, it allows
     * non-identifier path components, even if they aren't escaped.
     */ static fromServerFormat(e) {
        const t = [];
        let n = "", r = 0;
        const __PRIVATE_addCurrentSegment = ()=>{
            if (0 === n.length) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid field path (${e}). Paths must not be empty, begin with '.', end with '.', or contain '..'`);
            t.push(n), n = "";
        };
        let i = !1;
        for(; r < e.length;){
            const t = e[r];
            if ("\\" === t) {
                if (r + 1 === e.length) throw new FirestoreError(D.INVALID_ARGUMENT, "Path has trailing escape character: " + e);
                const t = e[r + 1];
                if ("\\" !== t && "." !== t && "`" !== t) throw new FirestoreError(D.INVALID_ARGUMENT, "Path has invalid escape sequence: " + e);
                n += t, r += 2;
            } else "`" === t ? (i = !i, r++) : "." !== t || i ? (n += t, r++) : (__PRIVATE_addCurrentSegment(), r++);
        }
        if (__PRIVATE_addCurrentSegment(), i) throw new FirestoreError(D.INVALID_ARGUMENT, "Unterminated ` in path: " + e);
        return new FieldPath$1(t);
    }
    static emptyPath() {
        return new FieldPath$1([]);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 */ class DocumentKey {
    constructor(e){
        this.path = e;
    }
    static fromPath(e) {
        return new DocumentKey(ResourcePath.fromString(e));
    }
    static fromName(e) {
        return new DocumentKey(ResourcePath.fromString(e).popFirst(5));
    }
    static empty() {
        return new DocumentKey(ResourcePath.emptyPath());
    }
    get collectionGroup() {
        return this.path.popLast().lastSegment();
    }
    /** Returns true if the document is in the specified collectionId. */ hasCollectionId(e) {
        return this.path.length >= 2 && this.path.get(this.path.length - 2) === e;
    }
    /** Returns the collection group (i.e. the name of the parent collection) for this key. */ getCollectionGroup() {
        return this.path.get(this.path.length - 2);
    }
    /** Returns the fully qualified path to the parent collection. */ getCollectionPath() {
        return this.path.popLast();
    }
    isEqual(e) {
        return null !== e && 0 === ResourcePath.comparator(this.path, e.path);
    }
    toString() {
        return this.path.toString();
    }
    static comparator(e, t) {
        return ResourcePath.comparator(e.path, t.path);
    }
    static isDocumentKey(e) {
        return e.length % 2 == 0;
    }
    /**
     * Creates and returns a new document key with the given segments.
     *
     * @param segments - The segments of the path to the document
     * @returns A new instance of DocumentKey
     */ static fromSegments(e) {
        return new DocumentKey(new ResourcePath(e.slice()));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_validateNonEmptyArgument(e, t, n) {
    if (!n) throw new FirestoreError(D.INVALID_ARGUMENT, `Function ${e}() cannot be called with an empty ${t}.`);
}
/**
 * Validates that two boolean options are not set at the same time.
 * @internal
 */ function __PRIVATE_validateIsNotUsedTogether(e, t, n, r) {
    if (!0 === t && !0 === r) throw new FirestoreError(D.INVALID_ARGUMENT, `${e} and ${n} cannot be used together.`);
}
/**
 * Validates that `path` refers to a document (indicated by the fact it contains
 * an even numbers of segments).
 */ function __PRIVATE_validateDocumentPath(e) {
    if (!DocumentKey.isDocumentKey(e)) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid document reference. Document references must have an even number of segments, but ${e} has ${e.length}.`);
}
/**
 * Validates that `path` refers to a collection (indicated by the fact it
 * contains an odd numbers of segments).
 */ function __PRIVATE_validateCollectionPath(e) {
    if (DocumentKey.isDocumentKey(e)) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid collection reference. Collection references must have an odd number of segments, but ${e} has ${e.length}.`);
}
/**
 * Returns true if it's a non-null object without a custom prototype
 * (i.e. excludes Array, Date, etc.).
 */ function __PRIVATE_isPlainObject(e) {
    return "object" == typeof e && null !== e && (Object.getPrototypeOf(e) === Object.prototype || null === Object.getPrototypeOf(e));
}
/** Returns a string describing the type / value of the provided input. */ function __PRIVATE_valueDescription(e) {
    if (void 0 === e) return "undefined";
    if (null === e) return "null";
    if ("string" == typeof e) return e.length > 20 && (e = `${e.substring(0, 20)}...`), JSON.stringify(e);
    if ("number" == typeof e || "boolean" == typeof e) return "" + e;
    if ("object" == typeof e) {
        if (e instanceof Array) return "an array";
        {
            const t = /** try to get the constructor name for an object. */ function __PRIVATE_tryGetCustomObjectType(e) {
                if (e.constructor) return e.constructor.name;
                return null;
            }(e);
            return t ? `a custom ${t} object` : "an object";
        }
    }
    return "function" == typeof e ? "a function" : fail(12329, {
        type: typeof e
    });
}
function __PRIVATE_cast(e, // eslint-disable-next-line @typescript-eslint/no-explicit-any
t) {
    if ("_delegate" in e && // Unwrap Compat types
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e = e._delegate), !(e instanceof t)) {
        if (t.name === e.constructor.name) throw new FirestoreError(D.INVALID_ARGUMENT, "Type does not match the expected instance. Did you pass a reference from a different Firestore SDK?");
        {
            const n = __PRIVATE_valueDescription(e);
            throw new FirestoreError(D.INVALID_ARGUMENT, `Expected type '${t.name}', but it was: ${n}`);
        }
    }
    return e;
}
function __PRIVATE_validatePositiveNumber(e, t) {
    if (t <= 0) throw new FirestoreError(D.INVALID_ARGUMENT, `Function ${e}() requires a positive number, but it was: ${t}.`);
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper function to define a JSON schema {@link Property}.
 * @private
 * @internal
 */ function property(e, t) {
    const n = {
        typeString: e
    };
    return t && (n.value = t), n;
}
/**
 * Validates the JSON object based on the provided schema, and narrows the type to the provided
 * JSON schema.
 * @private
 * @internal
 *
 * @param json - A JSON object to validate.
 * @param scheme - a {@link JsonSchema} that defines the properties to validate.
 * @returns true if the JSON schema exists within the object. Throws a FirestoreError otherwise.
 */ function __PRIVATE_validateJSON(e, t) {
    if (!__PRIVATE_isPlainObject(e)) throw new FirestoreError(D.INVALID_ARGUMENT, "JSON must be an object");
    let n;
    for(const r in t)if (t[r]) {
        const i = t[r].typeString, s = "value" in t[r] ? {
            value: t[r].value
        } : void 0;
        if (!(r in e)) {
            n = `JSON missing required field: '${r}'`;
            break;
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const _ = e[r];
        if (i && typeof _ !== i) {
            n = `JSON field '${r}' must be a ${i}.`;
            break;
        }
        if (void 0 !== s && _ !== s.value) {
            n = `Expected '${r}' field to equal '${s.value}'`;
            break;
        }
    }
    if (n) throw new FirestoreError(D.INVALID_ARGUMENT, n);
    return !0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The earliest date supported by Firestore timestamps (0001-01-01T00:00:00Z).
const M = -62135596800, N = 1e6;
// Number of nanoseconds in a millisecond.
/**
 * A `Timestamp` represents a point in time independent of any time zone or
 * calendar, represented as seconds and fractions of seconds at nanosecond
 * resolution in UTC Epoch time.
 *
 * It is encoded using the Proleptic Gregorian Calendar which extends the
 * Gregorian calendar backwards to year one. It is encoded assuming all minutes
 * are 60 seconds long, i.e. leap seconds are "smeared" so that no leap second
 * table is needed for interpretation. Range is from 0001-01-01T00:00:00Z to
 * 9999-12-31T23:59:59.999999999Z.
 *
 * For examples and further specifications, refer to the
 * {@link https://github.com/google/protobuf/blob/master/src/google/protobuf/timestamp.proto | Timestamp definition}.
 */ class Timestamp {
    /**
     * Creates a new timestamp with the current date, with millisecond precision.
     *
     * @returns a new timestamp representing the current date.
     */ static now() {
        return Timestamp.fromMillis(Date.now());
    }
    /**
     * Creates a new timestamp from the given date.
     *
     * @param date - The date to initialize the `Timestamp` from.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     date.
     */ static fromDate(e) {
        return Timestamp.fromMillis(e.getTime());
    }
    /**
     * Creates a new timestamp from the given number of milliseconds.
     *
     * @param milliseconds - Number of milliseconds since Unix epoch
     *     1970-01-01T00:00:00Z.
     * @returns A new `Timestamp` representing the same point in time as the given
     *     number of milliseconds.
     */ static fromMillis(e) {
        const t = Math.floor(e / 1e3), n = Math.floor((e - 1e3 * t) * N);
        return new Timestamp(t, n);
    }
    /**
     * Creates a new timestamp.
     *
     * @param seconds - The number of seconds of UTC time since Unix epoch
     *     1970-01-01T00:00:00Z. Must be from 0001-01-01T00:00:00Z to
     *     9999-12-31T23:59:59Z inclusive.
     * @param nanoseconds - The non-negative fractions of a second at nanosecond
     *     resolution. Negative second values with fractions must still have
     *     non-negative nanoseconds values that count forward in time. Must be
     *     from 0 to 999,999,999 inclusive.
     */ constructor(/**
     * The number of seconds of UTC time since Unix epoch 1970-01-01T00:00:00Z.
     */ e, /**
     * The fractions of a second at nanosecond resolution.*
     */ t){
        if (this.seconds = e, this.nanoseconds = t, t < 0) throw new FirestoreError(D.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (t >= 1e9) throw new FirestoreError(D.INVALID_ARGUMENT, "Timestamp nanoseconds out of range: " + t);
        if (e < M) throw new FirestoreError(D.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
        // This will break in the year 10,000.
        if (e >= 253402300800) throw new FirestoreError(D.INVALID_ARGUMENT, "Timestamp seconds out of range: " + e);
    }
    /**
     * Converts a `Timestamp` to a JavaScript `Date` object. This conversion
     * causes a loss of precision since `Date` objects only support millisecond
     * precision.
     *
     * @returns JavaScript `Date` object representing the same point in time as
     *     this `Timestamp`, with millisecond precision.
     */ toDate() {
        return new Date(this.toMillis());
    }
    /**
     * Converts a `Timestamp` to a numeric timestamp (in milliseconds since
     * epoch). This operation causes a loss of precision.
     *
     * @returns The point in time corresponding to this timestamp, represented as
     *     the number of milliseconds since Unix epoch 1970-01-01T00:00:00Z.
     */ toMillis() {
        return 1e3 * this.seconds + this.nanoseconds / N;
    }
    _compareTo(e) {
        return this.seconds === e.seconds ? __PRIVATE_primitiveComparator(this.nanoseconds, e.nanoseconds) : __PRIVATE_primitiveComparator(this.seconds, e.seconds);
    }
    /**
     * Returns true if this `Timestamp` is equal to the provided one.
     *
     * @param other - The `Timestamp` to compare against.
     * @returns true if this `Timestamp` is equal to the provided one.
     */ isEqual(e) {
        return e.seconds === this.seconds && e.nanoseconds === this.nanoseconds;
    }
    /** Returns a textual representation of this `Timestamp`. */ toString() {
        return "Timestamp(seconds=" + this.seconds + ", nanoseconds=" + this.nanoseconds + ")";
    }
    /**
     * Returns a JSON-serializable representation of this `Timestamp`.
     */ toJSON() {
        return {
            type: Timestamp._jsonSchemaVersion,
            seconds: this.seconds,
            nanoseconds: this.nanoseconds
        };
    }
    /**
     * Builds a `Timestamp` instance from a JSON object created by {@link Timestamp.toJSON}.
     */ static fromJSON(e) {
        if (__PRIVATE_validateJSON(e, Timestamp._jsonSchema)) return new Timestamp(e.seconds, e.nanoseconds);
    }
    /**
     * Converts this object to a primitive string, which allows `Timestamp` objects
     * to be compared using the `>`, `<=`, `>=` and `>` operators.
     */ valueOf() {
        // This method returns a string of the form <seconds>.<nanoseconds> where
        // <seconds> is translated to have a non-negative value and both <seconds>
        // and <nanoseconds> are left-padded with zeroes to be a consistent length.
        // Strings with this format then have a lexicographical ordering that matches
        // the expected ordering. The <seconds> translation is done to avoid having
        // a leading negative sign (i.e. a leading '-' character) in its string
        // representation, which would affect its lexicographical ordering.
        const e = this.seconds - M;
        // Note: Up to 12 decimal digits are required to represent all valid
        // 'seconds' values.
        return String(e).padStart(12, "0") + "." + String(this.nanoseconds).padStart(9, "0");
    }
}
Timestamp._jsonSchemaVersion = "firestore/timestamp/1.0", Timestamp._jsonSchema = {
    type: property("string", Timestamp._jsonSchemaVersion),
    seconds: property("number"),
    nanoseconds: property("number")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A version of a document in Firestore. This corresponds to the version
 * timestamp, such as update_time or read_time.
 */ class SnapshotVersion {
    static fromTimestamp(e) {
        return new SnapshotVersion(e);
    }
    static min() {
        return new SnapshotVersion(new Timestamp(0, 0));
    }
    static max() {
        return new SnapshotVersion(new Timestamp(253402300799, 999999999));
    }
    constructor(e){
        this.timestamp = e;
    }
    compareTo(e) {
        return this.timestamp._compareTo(e.timestamp);
    }
    isEqual(e) {
        return this.timestamp.isEqual(e.timestamp);
    }
    /** Returns a number representation of the version for use in spec tests. */ toMicroseconds() {
        // Convert to microseconds.
        return 1e6 * this.timestamp.seconds + this.timestamp.nanoseconds / 1e3;
    }
    toString() {
        return "SnapshotVersion(" + this.timestamp.toString() + ")";
    }
    toTimestamp() {
        return this.timestamp;
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The initial mutation batch id for each index. Gets updated during index
 * backfill.
 */ const L = -1;
/**
 * The initial sequence number for each index. Gets updated during index
 * backfill.
 */ /**
 * An index definition for field indexes in Firestore.
 *
 * Every index is associated with a collection. The definition contains a list
 * of fields and their index kind (which can be `ASCENDING`, `DESCENDING` or
 * `CONTAINS` for ArrayContains/ArrayContainsAny queries).
 *
 * Unlike the backend, the SDK does not differentiate between collection or
 * collection group-scoped indices. Every index can be used for both single
 * collection and collection group queries.
 */ class FieldIndex {
    constructor(/**
     * The index ID. Returns -1 if the index ID is not available (e.g. the index
     * has not yet been persisted).
     */ e, /** The collection ID this index applies to. */ t, /** The field segments for this index. */ n, /** Shows how up-to-date the index is for the current user. */ r){
        this.indexId = e, this.collectionGroup = t, this.fields = n, this.indexState = r;
    }
}
/** An ID for an index that has not yet been added to persistence.  */ /** Returns the ArrayContains/ArrayContainsAny segment for this index. */ function __PRIVATE_fieldIndexGetArraySegment(e) {
    return e.fields.find((e)=>2 /* IndexKind.CONTAINS */  === e.kind);
}
/** Returns all directional (ascending/descending) segments for this index. */ function __PRIVATE_fieldIndexGetDirectionalSegments(e) {
    return e.fields.filter((e)=>2 /* IndexKind.CONTAINS */  !== e.kind);
}
/**
 * Returns the order of the document key component for the given index.
 *
 * PORTING NOTE: This is only used in the Web IndexedDb implementation.
 */ /**
 * Compares indexes by collection group and segments. Ignores update time and
 * index ID.
 */ function __PRIVATE_fieldIndexSemanticComparator(e, t) {
    let n = __PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
    if (0 !== n) return n;
    for(let r = 0; r < Math.min(e.fields.length, t.fields.length); ++r)if (n = __PRIVATE_indexSegmentComparator(e.fields[r], t.fields[r]), 0 !== n) return n;
    return __PRIVATE_primitiveComparator(e.fields.length, t.fields.length);
}
/** Returns a debug representation of the field index */ FieldIndex.UNKNOWN_ID = -1;
/** An index component consisting of field path and index type.  */ class IndexSegment {
    constructor(/** The field path of the component. */ e, /** The fields sorting order. */ t){
        this.fieldPath = e, this.kind = t;
    }
}
function __PRIVATE_indexSegmentComparator(e, t) {
    const n = FieldPath$1.comparator(e.fieldPath, t.fieldPath);
    return 0 !== n ? n : __PRIVATE_primitiveComparator(e.kind, t.kind);
}
/**
 * Stores the "high water mark" that indicates how updated the Index is for the
 * current user.
 */ class IndexState {
    constructor(/**
     * Indicates when the index was last updated (relative to other indexes).
     */ e, /** The the latest indexed read time, document and batch id. */ t){
        this.sequenceNumber = e, this.offset = t;
    }
    /** The state of an index that has not yet been backfilled. */ static empty() {
        return new IndexState(0, IndexOffset.min());
    }
}
/**
 * Creates an offset that matches all documents with a read time higher than
 * `readTime`.
 */ function __PRIVATE_newIndexOffsetSuccessorFromReadTime(e, t) {
    // We want to create an offset that matches all documents with a read time
    // greater than the provided read time. To do so, we technically need to
    // create an offset for `(readTime, MAX_DOCUMENT_KEY)`. While we could use
    // Unicode codepoints to generate MAX_DOCUMENT_KEY, it is much easier to use
    // `(readTime + 1, DocumentKey.empty())` since `> DocumentKey.empty()` matches
    // all valid document IDs.
    const n = e.toTimestamp().seconds, r = e.toTimestamp().nanoseconds + 1, i = SnapshotVersion.fromTimestamp(1e9 === r ? new Timestamp(n + 1, 0) : new Timestamp(n, r));
    return new IndexOffset(i, DocumentKey.empty(), t);
}
/** Creates a new offset based on the provided document. */ function __PRIVATE_newIndexOffsetFromDocument(e) {
    return new IndexOffset(e.readTime, e.key, L);
}
/**
 * Stores the latest read time, document and batch ID that were processed for an
 * index.
 */ class IndexOffset {
    constructor(/**
     * The latest read time version that has been indexed by Firestore for this
     * field index.
     */ e, /**
     * The key of the last document that was indexed for this query. Use
     * `DocumentKey.empty()` if no document has been indexed.
     */ t, /*
     * The largest mutation batch id that's been processed by Firestore.
     */ n){
        this.readTime = e, this.documentKey = t, this.largestBatchId = n;
    }
    /** Returns an offset that sorts before all regular offsets. */ static min() {
        return new IndexOffset(SnapshotVersion.min(), DocumentKey.empty(), L);
    }
    /** Returns an offset that sorts after all regular offsets. */ static max() {
        return new IndexOffset(SnapshotVersion.max(), DocumentKey.empty(), L);
    }
}
function __PRIVATE_indexOffsetComparator(e, t) {
    let n = e.readTime.compareTo(t.readTime);
    return 0 !== n ? n : (n = DocumentKey.comparator(e.documentKey, t.documentKey), 0 !== n ? n : __PRIVATE_primitiveComparator(e.largestBatchId, t.largestBatchId));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const B = "The current tab is not in the required state to perform this operation. It might be necessary to refresh the browser tab.";
/**
 * A base class representing a persistence transaction, encapsulating both the
 * transaction's sequence numbers as well as a list of onCommitted listeners.
 *
 * When you call Persistence.runTransaction(), it will create a transaction and
 * pass it to your callback. You then pass it to any method that operates
 * on persistence.
 */ class PersistenceTransaction {
    constructor(){
        this.onCommittedListeners = [];
    }
    addOnCommittedListener(e) {
        this.onCommittedListeners.push(e);
    }
    raiseOnCommittedEvent() {
        this.onCommittedListeners.forEach((e)=>e());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Verifies the error thrown by a LocalStore operation. If a LocalStore
 * operation fails because the primary lease has been taken by another client,
 * we ignore the error (the persistence layer will immediately call
 * `applyPrimaryLease` to propagate the primary state change). All other errors
 * are re-thrown.
 *
 * @param err - An error returned by a LocalStore operation.
 * @returns A Promise that resolves after we recovered, or the original error.
 */ async function __PRIVATE_ignoreIfPrimaryLeaseLoss(e) {
    if (e.code !== D.FAILED_PRECONDITION || e.message !== B) throw e;
    __PRIVATE_logDebug("LocalStore", "Unexpectedly lost primary lease");
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * PersistencePromise is essentially a re-implementation of Promise except
 * it has a .next() method instead of .then() and .next() and .catch() callbacks
 * are executed synchronously when a PersistencePromise resolves rather than
 * asynchronously (Promise implementations use setImmediate() or similar).
 *
 * This is necessary to interoperate with IndexedDB which will automatically
 * commit transactions if control is returned to the event loop without
 * synchronously initiating another operation on the transaction.
 *
 * NOTE: .then() and .catch() only allow a single consumer, unlike normal
 * Promises.
 */ class PersistencePromise {
    constructor(e){
        // NOTE: next/catchCallback will always point to our own wrapper functions,
        // not the user's raw next() or catch() callbacks.
        this.nextCallback = null, this.catchCallback = null, // When the operation resolves, we'll set result or error and mark isDone.
        this.result = void 0, this.error = void 0, this.isDone = !1, // Set to true when .then() or .catch() are called and prevents additional
        // chaining.
        this.callbackAttached = !1, e((e)=>{
            this.isDone = !0, this.result = e, this.nextCallback && // value should be defined unless T is Void, but we can't express
            // that in the type system.
            this.nextCallback(e);
        }, (e)=>{
            this.isDone = !0, this.error = e, this.catchCallback && this.catchCallback(e);
        });
    }
    catch(e) {
        return this.next(void 0, e);
    }
    next(e, t) {
        return this.callbackAttached && fail(59440), this.callbackAttached = !0, this.isDone ? this.error ? this.wrapFailure(t, this.error) : this.wrapSuccess(e, this.result) : new PersistencePromise((n, r)=>{
            this.nextCallback = (t)=>{
                this.wrapSuccess(e, t).next(n, r);
            }, this.catchCallback = (e)=>{
                this.wrapFailure(t, e).next(n, r);
            };
        });
    }
    toPromise() {
        return new Promise((e, t)=>{
            this.next(e, t);
        });
    }
    wrapUserFunction(e) {
        try {
            const t = e();
            return t instanceof PersistencePromise ? t : PersistencePromise.resolve(t);
        } catch (e) {
            return PersistencePromise.reject(e);
        }
    }
    wrapSuccess(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : PersistencePromise.resolve(t);
    }
    wrapFailure(e, t) {
        return e ? this.wrapUserFunction(()=>e(t)) : PersistencePromise.reject(t);
    }
    static resolve(e) {
        return new PersistencePromise((t, n)=>{
            t(e);
        });
    }
    static reject(e) {
        return new PersistencePromise((t, n)=>{
            n(e);
        });
    }
    static waitFor(// Accept all Promise types in waitFor().
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    e) {
        return new PersistencePromise((t, n)=>{
            let r = 0, i = 0, s = !1;
            e.forEach((e)=>{
                ++r, e.next(()=>{
                    ++i, s && i === r && t();
                }, (e)=>n(e));
            }), s = !0, i === r && t();
        });
    }
    /**
     * Given an array of predicate functions that asynchronously evaluate to a
     * boolean, implements a short-circuiting `or` between the results. Predicates
     * will be evaluated until one of them returns `true`, then stop. The final
     * result will be whether any of them returned `true`.
     */ static or(e) {
        let t = PersistencePromise.resolve(!1);
        for (const n of e)t = t.next((e)=>e ? PersistencePromise.resolve(e) : n());
        return t;
    }
    static forEach(e, t) {
        const n = [];
        return e.forEach((e, r)=>{
            n.push(t.call(this, e, r));
        }), this.waitFor(n);
    }
    /**
     * Concurrently map all array elements through asynchronous function.
     */ static mapArray(e, t) {
        return new PersistencePromise((n, r)=>{
            const i = e.length, s = new Array(i);
            let _ = 0;
            for(let o = 0; o < i; o++){
                const a = o;
                t(e[a]).next((e)=>{
                    s[a] = e, ++_, _ === i && n(s);
                }, (e)=>r(e));
            }
        });
    }
    /**
     * An alternative to recursive PersistencePromise calls, that avoids
     * potential memory problems from unbounded chains of promises.
     *
     * The `action` will be called repeatedly while `condition` is true.
     */ static doWhile(e, t) {
        return new PersistencePromise((n, r)=>{
            const process = ()=>{
                !0 === e() ? t().next(()=>{
                    process();
                }, r) : n();
            };
            process();
        });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `indexedDB` are guarded by SimpleDb.isAvailable() and getGlobal()
/* eslint-disable no-restricted-globals */ const U = "SimpleDb";
/**
 * The maximum number of retry attempts for an IndexedDb transaction that fails
 * with a DOMException.
 */ /**
 * Wraps an IDBTransaction and exposes a store() method to get a handle to a
 * specific object store.
 */ class __PRIVATE_SimpleDbTransaction {
    static open(e, t, n, r) {
        try {
            return new __PRIVATE_SimpleDbTransaction(t, e.transaction(r, n));
        } catch (e) {
            throw new __PRIVATE_IndexedDbTransactionError(t, e);
        }
    }
    constructor(e, t){
        this.action = e, this.transaction = t, this.aborted = !1, /**
         * A `Promise` that resolves with the result of the IndexedDb transaction.
         */ this.v = new __PRIVATE_Deferred, this.transaction.oncomplete = ()=>{
            this.v.resolve();
        }, this.transaction.onabort = ()=>{
            t.error ? this.v.reject(new __PRIVATE_IndexedDbTransactionError(e, t.error)) : this.v.resolve();
        }, this.transaction.onerror = (t)=>{
            const n = __PRIVATE_checkForAndReportiOSError(t.target.error);
            this.v.reject(new __PRIVATE_IndexedDbTransactionError(e, n));
        };
    }
    get S() {
        return this.v.promise;
    }
    abort(e) {
        e && this.v.reject(e), this.aborted || (__PRIVATE_logDebug(U, "Aborting transaction:", e ? e.message : "Client-initiated abort"), this.aborted = !0, this.transaction.abort());
    }
    D() {
        // If the browser supports V3 IndexedDB, we invoke commit() explicitly to
        // speed up index DB processing if the event loop remains blocks.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const e = this.transaction;
        this.aborted || "function" != typeof e.commit || e.commit();
    }
    /**
     * Returns a SimpleDbStore<KeyType, ValueType> for the specified store. All
     * operations performed on the SimpleDbStore happen within the context of this
     * transaction and it cannot be used anymore once the transaction is
     * completed.
     *
     * Note that we can't actually enforce that the KeyType and ValueType are
     * correct, but they allow type safety through the rest of the consuming code.
     */ store(e) {
        const t = this.transaction.objectStore(e);
        return new __PRIVATE_SimpleDbStore(t);
    }
}
/**
 * Provides a wrapper around IndexedDb with a simplified interface that uses
 * Promise-like return values to chain operations. Real promises cannot be used
 * since .then() continuations are executed asynchronously (e.g. via
 * .setImmediate), which would cause IndexedDB to end the transaction.
 * See PersistencePromise for more details.
 */ class __PRIVATE_SimpleDb {
    /** Deletes the specified database. */ static delete(e) {
        __PRIVATE_logDebug(U, "Removing database:", e);
        return __PRIVATE_wrapRequest((0, _util.getGlobal)().indexedDB.deleteDatabase(e)).toPromise();
    }
    /** Returns true if IndexedDB is available in the current environment. */ static C() {
        if (!(0, _util.isIndexedDBAvailable)()) return !1;
        if (__PRIVATE_SimpleDb.F()) return !0;
        // We extensively use indexed array values and compound keys,
        // which IE and Edge do not support. However, they still have indexedDB
        // defined on the window, so we need to check for them here and make sure
        // to return that persistence is not enabled for those browsers.
        // For tracking support of this feature, see here:
        // https://developer.microsoft.com/en-us/microsoft-edge/platform/status/indexeddbarraysandmultientrysupport/
        // Check the UA string to find out the browser.
        const e = (0, _util.getUA)(), t = __PRIVATE_SimpleDb.O(e), n = 0 < t && t < 10, r = __PRIVATE_getAndroidVersion(e), i = 0 < r && r < 4.5;
        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';
        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';
        // Edge
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML,
        // like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';
        // iOS Safari: Disable for users running iOS version < 10.
        return !(e.indexOf("MSIE ") > 0 || e.indexOf("Trident/") > 0 || e.indexOf("Edge/") > 0 || n || i);
    }
    /**
     * Returns true if the backing IndexedDB store is the Node IndexedDBShim
     * (see https://github.com/axemclion/IndexedDBShim).
     */ static F() {
        return false;
    }
    /** Helper to get a typed SimpleDbStore from a transaction. */ static M(e, t) {
        return e.store(t);
    }
    // visible for testing
    /** Parse User Agent to determine iOS version. Returns -1 if not found. */ static O(e) {
        const t = e.match(/i(?:phone|pad|pod) os ([\d_]+)/i), n = t ? t[1].split("_").slice(0, 2).join(".") : "-1";
        return Number(n);
    }
    /*
     * Creates a new SimpleDb wrapper for IndexedDb database `name`.
     *
     * Note that `version` must not be a downgrade. IndexedDB does not support
     * downgrading the schema version. We currently do not support any way to do
     * versioning outside of IndexedDB's versioning mechanism, as only
     * version-upgrade transactions are allowed to do things like create
     * objectstores.
     */ constructor(e, t, n){
        this.name = e, this.version = t, this.N = n, this.L = null;
        // NOTE: According to https://bugs.webkit.org/show_bug.cgi?id=197050, the
        // bug we're checking for should exist in iOS >= 12.2 and < 13, but for
        // whatever reason it's much harder to hit after 12.2 so we only proactively
        // log on 12.2.
        12.2 === __PRIVATE_SimpleDb.O((0, _util.getUA)()) && __PRIVATE_logError("Firestore persistence suffers from a bug in iOS 12.2 Safari that may cause your app to stop working. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.");
    }
    /**
     * Opens the specified database, creating or upgrading it if necessary.
     */ async B(e) {
        return this.db || (__PRIVATE_logDebug(U, "Opening database:", this.name), this.db = await new Promise((t, n)=>{
            // TODO(mikelehen): Investigate browser compatibility.
            // https://developer.mozilla.org/en-US/docs/Web/API/IndexedDB_API/Using_IndexedDB
            // suggests IE9 and older WebKit browsers handle upgrade
            // differently. They expect setVersion, as described here:
            // https://developer.mozilla.org/en-US/docs/Web/API/IDBVersionChangeRequest/setVersion
            const r = indexedDB.open(this.name, this.version);
            r.onsuccess = (e)=>{
                const n = e.target.result;
                t(n);
            }, r.onblocked = ()=>{
                n(new __PRIVATE_IndexedDbTransactionError(e, "Cannot upgrade IndexedDB schema while another tab is open. Close all tabs that access Firestore and reload this page to proceed."));
            }, r.onerror = (t)=>{
                const r = t.target.error;
                "VersionError" === r.name ? n(new FirestoreError(D.FAILED_PRECONDITION, "A newer version of the Firestore SDK was previously used and so the persisted data is not compatible with the version of the SDK you are now using. The SDK will operate with persistence disabled. If you need persistence, please re-upgrade to a newer version of the SDK or else clear the persisted IndexedDB data for your app to start fresh.")) : "InvalidStateError" === r.name ? n(new FirestoreError(D.FAILED_PRECONDITION, "Unable to open an IndexedDB connection. This could be due to running in a private browsing session on a browser whose private browsing sessions do not support IndexedDB: " + r)) : n(new __PRIVATE_IndexedDbTransactionError(e, r));
            }, r.onupgradeneeded = (e)=>{
                __PRIVATE_logDebug(U, 'Database "' + this.name + '" requires upgrade from version:', e.oldVersion);
                const t = e.target.result;
                this.N.U(t, r.transaction, e.oldVersion, this.version).next(()=>{
                    __PRIVATE_logDebug(U, "Database upgrade to version " + this.version + " complete");
                });
            };
        })), this.k && (this.db.onversionchange = (e)=>this.k(e)), this.db;
    }
    q(e) {
        this.k = e, this.db && (this.db.onversionchange = (t)=>e(t));
    }
    async runTransaction(e, t, n, r) {
        const i = "readonly" === t;
        let s = 0;
        for(;;){
            ++s;
            try {
                this.db = await this.B(e);
                const t = __PRIVATE_SimpleDbTransaction.open(this.db, e, i ? "readonly" : "readwrite", n), s = r(t).next((e)=>(t.D(), e)).catch((e)=>// Abort the transaction if there was an error.
                    (t.abort(e), PersistencePromise.reject(e))).toPromise();
                // As noted above, errors are propagated by aborting the transaction. So
                // we swallow any error here to avoid the browser logging it as unhandled.
                return s.catch(()=>{}), // Wait for the transaction to complete (i.e. IndexedDb's onsuccess event to
                // fire), but still return the original transactionFnResult back to the
                // caller.
                await t.S, s;
            } catch (e) {
                const t = e, n = "FirebaseError" !== t.name && s < 3;
                // TODO(schmidt-sebastian): We could probably be smarter about this and
                // not retry exceptions that are likely unrecoverable (such as quota
                // exceeded errors).
                // Note: We cannot use an instanceof check for FirestoreException, since the
                // exception is wrapped in a generic error by our async/await handling.
                if (__PRIVATE_logDebug(U, "Transaction failed with error:", t.message, "Retrying:", n), this.close(), !n) return Promise.reject(t);
            }
        }
    }
    close() {
        this.db && this.db.close(), this.db = void 0;
    }
}
/** Parse User Agent to determine Android version. Returns -1 if not found. */ function __PRIVATE_getAndroidVersion(e) {
    const t = e.match(/Android ([\d.]+)/i), n = t ? t[1].split(".").slice(0, 2).join(".") : "-1";
    return Number(n);
}
/**
 * A controller for iterating over a key range or index. It allows an iterate
 * callback to delete the currently-referenced object, or jump to a new key
 * within the key range or index.
 */ class __PRIVATE_IterationController {
    constructor(e){
        this.$ = e, this.K = !1, this.W = null;
    }
    get isDone() {
        return this.K;
    }
    get G() {
        return this.W;
    }
    set cursor(e) {
        this.$ = e;
    }
    /**
     * This function can be called to stop iteration at any point.
     */ done() {
        this.K = !0;
    }
    /**
     * This function can be called to skip to that next key, which could be
     * an index or a primary key.
     */ j(e) {
        this.W = e;
    }
    /**
     * Delete the current cursor value from the object store.
     *
     * NOTE: You CANNOT do this with a keysOnly query.
     */ delete() {
        return __PRIVATE_wrapRequest(this.$.delete());
    }
}
/** An error that wraps exceptions that thrown during IndexedDB execution. */ class __PRIVATE_IndexedDbTransactionError extends FirestoreError {
    constructor(e, t){
        super(D.UNAVAILABLE, `IndexedDB transaction '${e}' failed: ${t}`), this.name = "IndexedDbTransactionError";
    }
}
/** Verifies whether `e` is an IndexedDbTransactionError. */ function __PRIVATE_isIndexedDbTransactionError(e) {
    // Use name equality, as instanceof checks on errors don't work with errors
    // that wrap other errors.
    return "IndexedDbTransactionError" === e.name;
}
/**
 * A wrapper around an IDBObjectStore providing an API that:
 *
 * 1) Has generic KeyType / ValueType parameters to provide strongly-typed
 * methods for acting against the object store.
 * 2) Deals with IndexedDB's onsuccess / onerror event callbacks, making every
 * method return a PersistencePromise instead.
 * 3) Provides a higher-level API to avoid needing to do excessive wrapping of
 * intermediate IndexedDB types (IDBCursorWithValue, etc.)
 */ class __PRIVATE_SimpleDbStore {
    constructor(e){
        this.store = e;
    }
    put(e, t) {
        let n;
        return void 0 !== t ? (__PRIVATE_logDebug(U, "PUT", this.store.name, e, t), n = this.store.put(t, e)) : (__PRIVATE_logDebug(U, "PUT", this.store.name, "<auto-key>", e), n = this.store.put(e)), __PRIVATE_wrapRequest(n);
    }
    /**
     * Adds a new value into an Object Store and returns the new key. Similar to
     * IndexedDb's `add()`, this method will fail on primary key collisions.
     *
     * @param value - The object to write.
     * @returns The key of the value to add.
     */ add(e) {
        __PRIVATE_logDebug(U, "ADD", this.store.name, e, e);
        return __PRIVATE_wrapRequest(this.store.add(e));
    }
    /**
     * Gets the object with the specified key from the specified store, or null
     * if no object exists with the specified key.
     *
     * @key The key of the object to get.
     * @returns The object with the specified key or null if no object exists.
     */ get(e) {
        // We're doing an unsafe cast to ValueType.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return __PRIVATE_wrapRequest(this.store.get(e)).next((t)=>// Normalize nonexistence to null.
            (void 0 === t && (t = null), __PRIVATE_logDebug(U, "GET", this.store.name, e, t), t));
    }
    delete(e) {
        __PRIVATE_logDebug(U, "DELETE", this.store.name, e);
        return __PRIVATE_wrapRequest(this.store.delete(e));
    }
    /**
     * If we ever need more of the count variants, we can add overloads. For now,
     * all we need is to count everything in a store.
     *
     * Returns the number of rows in the store.
     */ count() {
        __PRIVATE_logDebug(U, "COUNT", this.store.name);
        return __PRIVATE_wrapRequest(this.store.count());
    }
    H(e, t) {
        const n = this.options(e, t), r = n.index ? this.store.index(n.index) : this.store;
        // Use `getAll()` if the browser supports IndexedDB v3, as it is roughly
        // 20% faster.
        if ("function" == typeof r.getAll) {
            const e = r.getAll(n.range);
            return new PersistencePromise((t, n)=>{
                e.onerror = (e)=>{
                    n(e.target.error);
                }, e.onsuccess = (e)=>{
                    t(e.target.result);
                };
            });
        }
        {
            const e = this.cursor(n), t = [];
            return this.J(e, (e, n)=>{
                t.push(n);
            }).next(()=>t);
        }
    }
    /**
     * Loads the first `count` elements from the provided index range. Loads all
     * elements if no limit is provided.
     */ Y(e, t) {
        const n = this.store.getAll(e, null === t ? void 0 : t);
        return new PersistencePromise((e, t)=>{
            n.onerror = (e)=>{
                t(e.target.error);
            }, n.onsuccess = (t)=>{
                e(t.target.result);
            };
        });
    }
    Z(e, t) {
        __PRIVATE_logDebug(U, "DELETE ALL", this.store.name);
        const n = this.options(e, t);
        n.X = !1;
        const r = this.cursor(n);
        return this.J(r, (e, t, n)=>n.delete());
    }
    ee(e, t) {
        let n;
        t ? n = e : (n = {}, t = e);
        const r = this.cursor(n);
        return this.J(r, t);
    }
    /**
     * Iterates over a store, but waits for the given callback to complete for
     * each entry before iterating the next entry. This allows the callback to do
     * asynchronous work to determine if this iteration should continue.
     *
     * The provided callback should return `true` to continue iteration, and
     * `false` otherwise.
     */ te(e) {
        const t = this.cursor({});
        return new PersistencePromise((n, r)=>{
            t.onerror = (e)=>{
                const t = __PRIVATE_checkForAndReportiOSError(e.target.error);
                r(t);
            }, t.onsuccess = (t)=>{
                const r = t.target.result;
                r ? e(r.primaryKey, r.value).next((e)=>{
                    e ? r.continue() : n();
                }) : n();
            };
        });
    }
    J(e, t) {
        const n = [];
        return new PersistencePromise((r, i)=>{
            e.onerror = (e)=>{
                i(e.target.error);
            }, e.onsuccess = (e)=>{
                const i = e.target.result;
                if (!i) return void r();
                const s = new __PRIVATE_IterationController(i), _ = t(i.primaryKey, i.value, s);
                if (_ instanceof PersistencePromise) {
                    const e = _.catch((e)=>(s.done(), PersistencePromise.reject(e)));
                    n.push(e);
                }
                s.isDone ? r() : null === s.G ? i.continue() : i.continue(s.G);
            };
        }).next(()=>PersistencePromise.waitFor(n));
    }
    options(e, t) {
        let n;
        return void 0 !== e && ("string" == typeof e ? n = e : t = e), {
            index: n,
            range: t
        };
    }
    cursor(e) {
        let t = "next";
        if (e.reverse && (t = "prev"), e.index) {
            const n = this.store.index(e.index);
            return e.X ? n.openKeyCursor(e.range, t) : n.openCursor(e.range, t);
        }
        return this.store.openCursor(e.range, t);
    }
}
/**
 * Wraps an IDBRequest in a PersistencePromise, using the onsuccess / onerror
 * handlers to resolve / reject the PersistencePromise as appropriate.
 */ function __PRIVATE_wrapRequest(e) {
    return new PersistencePromise((t, n)=>{
        e.onsuccess = (e)=>{
            const n = e.target.result;
            t(n);
        }, e.onerror = (e)=>{
            const t = __PRIVATE_checkForAndReportiOSError(e.target.error);
            n(t);
        };
    });
}
// Guard so we only report the error once.
let k = !1;
function __PRIVATE_checkForAndReportiOSError(e) {
    const t = __PRIVATE_SimpleDb.O((0, _util.getUA)());
    if (t >= 12.2 && t < 13) {
        const t = "An internal error was encountered in the Indexed Database server";
        if (e.message.indexOf(t) >= 0) {
            // Wrap error in a more descriptive one.
            const e = new FirestoreError("internal", `IOS_INDEXEDDB_BUG1: IndexedDb has thrown '${t}'. This is likely due to an unavoidable bug in iOS. See https://stackoverflow.com/q/56496296/110915 for details and a potential workaround.`);
            return k || (k = !0, // Throw a global exception outside of this promise chain, for the user to
            // potentially catch.
            setTimeout(()=>{
                throw e;
            }, 0)), e;
        }
    }
    return e;
}
const q = "IndexBackfiller";
/** How long we wait to try running index backfill after SDK initialization. */ /** This class is responsible for the scheduling of Index Backfiller. */ class __PRIVATE_IndexBackfillerScheduler {
    constructor(e, t){
        this.asyncQueue = e, this.ne = t, this.task = null;
    }
    start() {
        this.re(15e3);
    }
    stop() {
        this.task && (this.task.cancel(), this.task = null);
    }
    get started() {
        return null !== this.task;
    }
    re(e) {
        __PRIVATE_logDebug(q, `Scheduled in ${e}ms`), this.task = this.asyncQueue.enqueueAfterDelay("index_backfill" /* TimerId.IndexBackfill */ , e, async ()=>{
            this.task = null;
            try {
                const e = await this.ne.ie();
                __PRIVATE_logDebug(q, `Documents written: ${e}`);
            } catch (e) {
                __PRIVATE_isIndexedDbTransactionError(e) ? __PRIVATE_logDebug(q, "Ignoring IndexedDB error during index backfill: ", e) : await __PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.re(6e4);
        });
    }
}
/** Implements the steps for backfilling indexes. */ class __PRIVATE_IndexBackfiller {
    constructor(/**
     * LocalStore provides access to IndexManager and LocalDocumentView.
     * These properties will update when the user changes. Consequently,
     * making a local copy of IndexManager and LocalDocumentView will require
     * updates over time. The simpler solution is to rely on LocalStore to have
     * an up-to-date references to IndexManager and LocalDocumentStore.
     */ e, t){
        this.localStore = e, this.persistence = t;
    }
    async ie(e = 50) {
        return this.persistence.runTransaction("Backfill Indexes", "readwrite-primary", (t)=>this.se(t, e));
    }
    /** Writes index entries until the cap is reached. Returns the number of documents processed. */ se(e, t) {
        const n = new Set;
        let r = t, i = !0;
        return PersistencePromise.doWhile(()=>!0 === i && r > 0, ()=>this.localStore.indexManager.getNextCollectionGroupToUpdate(e).next((t)=>{
                if (null !== t && !n.has(t)) return __PRIVATE_logDebug(q, `Processing collection: ${t}`), this._e(e, t, r).next((e)=>{
                    r -= e, n.add(t);
                });
                i = !1;
            })).next(()=>t - r);
    }
    /**
     * Writes entries for the provided collection group. Returns the number of documents processed.
     */ _e(e, t, n) {
        // Use the earliest offset of all field indexes to query the local cache.
        return this.localStore.indexManager.getMinOffsetFromCollectionGroup(e, t).next((r)=>this.localStore.localDocuments.getNextDocuments(e, t, r, n).next((n)=>{
                const i = n.changes;
                return this.localStore.indexManager.updateIndexEntries(e, i).next(()=>this.oe(r, n)).next((n)=>(__PRIVATE_logDebug(q, `Updating offset: ${n}`), this.localStore.indexManager.updateCollectionGroup(e, t, n))).next(()=>i.size);
            }));
    }
    /** Returns the next offset based on the provided documents. */ oe(e, t) {
        let n = e;
        return t.changes.forEach((e, t)=>{
            const r = __PRIVATE_newIndexOffsetFromDocument(t);
            __PRIVATE_indexOffsetComparator(r, n) > 0 && (n = r);
        }), new IndexOffset(n.readTime, n.documentKey, Math.max(t.batchId, e.largestBatchId));
    }
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * `ListenSequence` is a monotonic sequence. It is initialized with a minimum value to
 * exceed. All subsequent calls to next will return increasing values. If provided with a
 * `SequenceNumberSyncer`, it will additionally bump its next value when told of a new value, as
 * well as write out sequence numbers that it produces via `next()`.
 */ class __PRIVATE_ListenSequence {
    constructor(e, t){
        this.previousValue = e, t && (t.sequenceNumberHandler = (e)=>this.ae(e), this.ue = (e)=>t.writeSequenceNumber(e));
    }
    ae(e) {
        return this.previousValue = Math.max(e, this.previousValue), this.previousValue;
    }
    next() {
        const e = ++this.previousValue;
        return this.ue && this.ue(e), e;
    }
}
__PRIVATE_ListenSequence.ce = -1;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Sentinel value that sorts before any Mutation Batch ID. */ const $ = -1;
/**
 * Returns whether a variable is either undefined or null.
 */ function __PRIVATE_isNullOrUndefined(e) {
    return null == e;
}
/** Returns whether the value represents -0. */ function __PRIVATE_isNegativeZero(e) {
    // Detect if the value is -0.0. Based on polyfill from
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
    return 0 === e && 1 / e == -1 / 0;
}
function __PRIVATE_isNumber$1(e) {
    return "number" == typeof e;
}
/**
 * Returns whether a value is an integer and in the safe integer range
 * @param value - The value to test for being an integer and in the safe range
 */ function isSafeInteger(e) {
    return "number" == typeof e && Number.isInteger(e) && !__PRIVATE_isNegativeZero(e) && e <= Number.MAX_SAFE_INTEGER && e >= Number.MIN_SAFE_INTEGER;
}
function __PRIVATE_isString$1(e) {
    return "string" == typeof e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const K = "";
/**
 * Encodes a resource path into a IndexedDb-compatible string form.
 */ function __PRIVATE_encodeResourcePath(e) {
    let t = "";
    for(let n = 0; n < e.length; n++)t.length > 0 && (t = __PRIVATE_encodeSeparator(t)), t = __PRIVATE_encodeSegment(e.get(n), t);
    return __PRIVATE_encodeSeparator(t);
}
/** Encodes a single segment of a resource path into the given result */ function __PRIVATE_encodeSegment(e, t) {
    let n = t;
    const r = e.length;
    for(let t = 0; t < r; t++){
        const r = e.charAt(t);
        switch(r){
            case "\0":
                n += "";
                break;
            case K:
                n += "";
                break;
            default:
                n += r;
        }
    }
    return n;
}
/** Encodes a path separator into the given result */ function __PRIVATE_encodeSeparator(e) {
    return e + K + "";
}
/**
 * Decodes the given IndexedDb-compatible string form of a resource path into
 * a ResourcePath instance. Note that this method is not suitable for use with
 * decoding resource names from the server; those are One Platform format
 * strings.
 */ function __PRIVATE_decodeResourcePath(e) {
    // Event the empty path must encode as a path of at least length 2. A path
    // with exactly 2 must be the empty path.
    const t = e.length;
    if (__PRIVATE_hardAssert(t >= 2, 64408, {
        path: e
    }), 2 === t) return __PRIVATE_hardAssert(e.charAt(0) === K && "" === e.charAt(1), 56145, {
        path: e
    }), ResourcePath.emptyPath();
    // Escape characters cannot exist past the second-to-last position in the
    // source value.
    const __PRIVATE_lastReasonableEscapeIndex = t - 2, n = [];
    let r = "";
    for(let i = 0; i < t;){
        // The last two characters of a valid encoded path must be a separator, so
        // there must be an end to this segment.
        const t = e.indexOf(K, i);
        (t < 0 || t > __PRIVATE_lastReasonableEscapeIndex) && fail(50515, {
            path: e
        });
        switch(e.charAt(t + 1)){
            case "":
                const s = e.substring(i, t);
                let _;
                0 === r.length ? // Avoid copying for the common case of a segment that excludes \0
                // and \001
                _ = s : (r += s, _ = r, r = ""), n.push(_);
                break;
            case "":
                r += e.substring(i, t), r += "\0";
                break;
            case "":
                // The escape character can be used in the output to encode itself.
                r += e.substring(i, t + 1);
                break;
            default:
                fail(61167, {
                    path: e
                });
        }
        i = t + 2;
    }
    return new ResourcePath(n);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const W = "remoteDocuments", Q = "owner", G = "owner", z = "mutationQueues", j = "userId", H = "mutations", J = "batchId", Y = "userMutationsIndex", Z = [
    "userId",
    "batchId"
];
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Name of the IndexedDb object store.
 *
 * Note that the name 'owner' is chosen to ensure backwards compatibility with
 * older clients that only supported single locked access to the persistence
 * layer.
 */ /**
 * Creates a [userId, encodedPath] key for use in the DbDocumentMutations
 * index to iterate over all at document mutations for a given path or lower.
 */ function __PRIVATE_newDbDocumentMutationPrefixForPath(e, t) {
    return [
        e,
        __PRIVATE_encodeResourcePath(t)
    ];
}
/**
 * Creates a full index key of [userId, encodedPath, batchId] for inserting
 * and deleting into the DbDocumentMutations index.
 */ function __PRIVATE_newDbDocumentMutationKey(e, t, n) {
    return [
        e,
        __PRIVATE_encodeResourcePath(t),
        n
    ];
}
/**
 * Because we store all the useful information for this store in the key,
 * there is no useful information to store as the value. The raw (unencoded)
 * path cannot be stored because IndexedDb doesn't store prototype
 * information.
 */ const X = {}, ee = "documentMutations", te = "remoteDocumentsV14", ne = [
    "prefixPath",
    "collectionGroup",
    "readTime",
    "documentId"
], re = "documentKeyIndex", ie = [
    "prefixPath",
    "collectionGroup",
    "documentId"
], se = "collectionGroupIndex", _e = [
    "collectionGroup",
    "readTime",
    "prefixPath",
    "documentId"
], oe = "remoteDocumentGlobal", ae = "remoteDocumentGlobalKey", ue = "targets", ce = "queryTargetsIndex", le = [
    "canonicalId",
    "targetId"
], Ee = "targetDocuments", he = [
    "targetId",
    "path"
], Te = "documentTargetsIndex", Pe = [
    "path",
    "targetId"
], Re = "targetGlobalKey", Ie = "targetGlobal", Ae = "collectionParents", Ve = [
    "collectionId",
    "parent"
], de = "clientMetadata", fe = "clientId", me = "bundles", pe = "bundleId", ge = "namedQueries", ye = "name", we = "indexConfiguration", be = "indexId", ve = "collectionGroupIndex", Se = "collectionGroup", De = "indexState", xe = [
    "indexId",
    "uid"
], Ce = "sequenceNumberIndex", Fe = [
    "uid",
    "sequenceNumber"
], Oe = "indexEntries", Me = [
    "indexId",
    "uid",
    "arrayValue",
    "directionalValue",
    "orderedDocumentKey",
    "documentKey"
], Ne = "documentKeyIndex", Le = [
    "indexId",
    "uid",
    "orderedDocumentKey"
], Be = "documentOverlays", Ue = [
    "userId",
    "collectionPath",
    "documentId"
], ke = "collectionPathOverlayIndex", qe = [
    "userId",
    "collectionPath",
    "largestBatchId"
], $e = "collectionGroupOverlayIndex", Ke = [
    "userId",
    "collectionGroup",
    "largestBatchId"
], We = "globals", Qe = "name", Ge = [
    z,
    H,
    ee,
    W,
    ue,
    Q,
    Ie,
    Ee,
    de,
    oe,
    Ae,
    me,
    ge
], ze = [
    ...Ge,
    Be
], je = [
    z,
    H,
    ee,
    te,
    ue,
    Q,
    Ie,
    Ee,
    de,
    oe,
    Ae,
    me,
    ge,
    Be
], He = je, Je = [
    ...He,
    we,
    De,
    Oe
], Ye = Je, Ze = [
    ...Je,
    We
], Xe = Ze;
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_IndexedDbTransaction extends PersistenceTransaction {
    constructor(e, t){
        super(), this.le = e, this.currentSequenceNumber = t;
    }
}
function __PRIVATE_getStore(e, t) {
    const n = __PRIVATE_debugCast(e);
    return __PRIVATE_SimpleDb.M(n.le, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // An immutable sorted map implementation, based on a Left-leaning Red-Black
// tree.
class SortedMap {
    constructor(e, t){
        this.comparator = e, this.root = t || LLRBNode.EMPTY;
    }
    // Returns a copy of the map, with the specified key/value added or replaced.
    insert(e, t) {
        return new SortedMap(this.comparator, this.root.insert(e, t, this.comparator).copy(null, null, LLRBNode.BLACK, null, null));
    }
    // Returns a copy of the map, with the specified key removed.
    remove(e) {
        return new SortedMap(this.comparator, this.root.remove(e, this.comparator).copy(null, null, LLRBNode.BLACK, null, null));
    }
    // Returns the value of the node with the given key, or null.
    get(e) {
        let t = this.root;
        for(; !t.isEmpty();){
            const n = this.comparator(e, t.key);
            if (0 === n) return t.value;
            n < 0 ? t = t.left : n > 0 && (t = t.right);
        }
        return null;
    }
    // Returns the index of the element in this sorted map, or -1 if it doesn't
    // exist.
    indexOf(e) {
        // Number of nodes that were pruned when descending right
        let t = 0, n = this.root;
        for(; !n.isEmpty();){
            const r = this.comparator(e, n.key);
            if (0 === r) return t + n.left.size;
            r < 0 ? n = n.left : // Count all nodes left of the node plus the node itself
            (t += n.left.size + 1, n = n.right);
        }
        // Node not found
        return -1;
    }
    isEmpty() {
        return this.root.isEmpty();
    }
    // Returns the total number of nodes in the map.
    get size() {
        return this.root.size;
    }
    // Returns the minimum key in the map.
    minKey() {
        return this.root.minKey();
    }
    // Returns the maximum key in the map.
    maxKey() {
        return this.root.maxKey();
    }
    // Traverses the map in key order and calls the specified action function
    // for each key/value pair. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.root.inorderTraversal(e);
    }
    forEach(e) {
        this.inorderTraversal((t, n)=>(e(t, n), !1));
    }
    toString() {
        const e = [];
        return this.inorderTraversal((t, n)=>(e.push(`${t}:${n}`), !1)), `{${e.join(", ")}}`;
    }
    // Traverses the map in reverse key order and calls the specified action
    // function for each key/value pair. If action returns true, traversal is
    // aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.root.reverseTraversal(e);
    }
    // Returns an iterator over the SortedMap.
    getIterator() {
        return new SortedMapIterator(this.root, null, this.comparator, !1);
    }
    getIteratorFrom(e) {
        return new SortedMapIterator(this.root, e, this.comparator, !1);
    }
    getReverseIterator() {
        return new SortedMapIterator(this.root, null, this.comparator, !0);
    }
    getReverseIteratorFrom(e) {
        return new SortedMapIterator(this.root, e, this.comparator, !0);
    }
}
// end SortedMap
// An iterator over an LLRBNode.
class SortedMapIterator {
    constructor(e, t, n, r){
        this.isReverse = r, this.nodeStack = [];
        let i = 1;
        for(; !e.isEmpty();)if (i = t ? n(e.key, t) : 1, // flip the comparison if we're going in reverse
        t && r && (i *= -1), i < 0) // This node is less than our start key. ignore it
        e = this.isReverse ? e.left : e.right;
        else {
            if (0 === i) {
                // This node is exactly equal to our start key. Push it on the stack,
                // but stop iterating;
                this.nodeStack.push(e);
                break;
            }
            // This node is greater than our start key, add it to the stack and move
            // to the next one
            this.nodeStack.push(e), e = this.isReverse ? e.right : e.left;
        }
    }
    getNext() {
        let e = this.nodeStack.pop();
        const t = {
            key: e.key,
            value: e.value
        };
        if (this.isReverse) for(e = e.left; !e.isEmpty();)this.nodeStack.push(e), e = e.right;
        else for(e = e.right; !e.isEmpty();)this.nodeStack.push(e), e = e.left;
        return t;
    }
    hasNext() {
        return this.nodeStack.length > 0;
    }
    peek() {
        if (0 === this.nodeStack.length) return null;
        const e = this.nodeStack[this.nodeStack.length - 1];
        return {
            key: e.key,
            value: e.value
        };
    }
}
// end SortedMapIterator
// Represents a node in a Left-leaning Red-Black tree.
class LLRBNode {
    constructor(e, t, n, r, i){
        this.key = e, this.value = t, this.color = null != n ? n : LLRBNode.RED, this.left = null != r ? r : LLRBNode.EMPTY, this.right = null != i ? i : LLRBNode.EMPTY, this.size = this.left.size + 1 + this.right.size;
    }
    // Returns a copy of the current node, optionally replacing pieces of it.
    copy(e, t, n, r, i) {
        return new LLRBNode(null != e ? e : this.key, null != t ? t : this.value, null != n ? n : this.color, null != r ? r : this.left, null != i ? i : this.right);
    }
    isEmpty() {
        return !1;
    }
    // Traverses the tree in key order and calls the specified action function
    // for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    inorderTraversal(e) {
        return this.left.inorderTraversal(e) || e(this.key, this.value) || this.right.inorderTraversal(e);
    }
    // Traverses the tree in reverse key order and calls the specified action
    // function for each node. If action returns true, traversal is aborted.
    // Returns the first truthy value returned by action, or the last falsey
    // value returned by action.
    reverseTraversal(e) {
        return this.right.reverseTraversal(e) || e(this.key, this.value) || this.left.reverseTraversal(e);
    }
    // Returns the minimum node in the tree.
    min() {
        return this.left.isEmpty() ? this : this.left.min();
    }
    // Returns the maximum key in the tree.
    minKey() {
        return this.min().key;
    }
    // Returns the maximum key in the tree.
    maxKey() {
        return this.right.isEmpty() ? this.key : this.right.maxKey();
    }
    // Returns new tree, with the key/value added.
    insert(e, t, n) {
        let r = this;
        const i = n(e, r.key);
        return r = i < 0 ? r.copy(null, null, null, r.left.insert(e, t, n), null) : 0 === i ? r.copy(null, t, null, null, null) : r.copy(null, null, null, null, r.right.insert(e, t, n)), r.fixUp();
    }
    removeMin() {
        if (this.left.isEmpty()) return LLRBNode.EMPTY;
        let e = this;
        return e.left.isRed() || e.left.left.isRed() || (e = e.moveRedLeft()), e = e.copy(null, null, null, e.left.removeMin(), null), e.fixUp();
    }
    // Returns new tree, with the specified item removed.
    remove(e, t) {
        let n, r = this;
        if (t(e, r.key) < 0) r.left.isEmpty() || r.left.isRed() || r.left.left.isRed() || (r = r.moveRedLeft()), r = r.copy(null, null, null, r.left.remove(e, t), null);
        else {
            if (r.left.isRed() && (r = r.rotateRight()), r.right.isEmpty() || r.right.isRed() || r.right.left.isRed() || (r = r.moveRedRight()), 0 === t(e, r.key)) {
                if (r.right.isEmpty()) return LLRBNode.EMPTY;
                n = r.right.min(), r = r.copy(n.key, n.value, null, null, r.right.removeMin());
            }
            r = r.copy(null, null, null, null, r.right.remove(e, t));
        }
        return r.fixUp();
    }
    isRed() {
        return this.color;
    }
    // Returns new tree after performing any needed rotations.
    fixUp() {
        let e = this;
        return e.right.isRed() && !e.left.isRed() && (e = e.rotateLeft()), e.left.isRed() && e.left.left.isRed() && (e = e.rotateRight()), e.left.isRed() && e.right.isRed() && (e = e.colorFlip()), e;
    }
    moveRedLeft() {
        let e = this.colorFlip();
        return e.right.left.isRed() && (e = e.copy(null, null, null, null, e.right.rotateRight()), e = e.rotateLeft(), e = e.colorFlip()), e;
    }
    moveRedRight() {
        let e = this.colorFlip();
        return e.left.left.isRed() && (e = e.rotateRight(), e = e.colorFlip()), e;
    }
    rotateLeft() {
        const e = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, e, null);
    }
    rotateRight() {
        const e = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, e);
    }
    colorFlip() {
        const e = this.left.copy(null, null, !this.left.color, null, null), t = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, e, t);
    }
    // For testing.
    checkMaxDepth() {
        const e = this.check();
        return Math.pow(2, e) <= this.size + 1;
    }
    // In a balanced RB tree, the black-depth (number of black nodes) from root to
    // leaves is equal on both sides.  This function verifies that or asserts.
    check() {
        if (this.isRed() && this.left.isRed()) throw fail(43730, {
            key: this.key,
            value: this.value
        });
        if (this.right.isRed()) throw fail(14113, {
            key: this.key,
            value: this.value
        });
        const e = this.left.check();
        if (e !== this.right.check()) throw fail(27949);
        return e + (this.isRed() ? 0 : 1);
    }
}
// end LLRBNode
// Empty node is shared between all LLRB trees.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
LLRBNode.EMPTY = null, LLRBNode.RED = !0, LLRBNode.BLACK = !1;
// end LLRBEmptyNode
LLRBNode.EMPTY = new // Represents an empty node (a leaf node in the Red-Black Tree).
class LLRBEmptyNode {
    constructor(){
        this.size = 0;
    }
    get key() {
        throw fail(57766);
    }
    get value() {
        throw fail(16141);
    }
    get color() {
        throw fail(16727);
    }
    get left() {
        throw fail(29726);
    }
    get right() {
        throw fail(36894);
    }
    // Returns a copy of the current node.
    copy(e, t, n, r, i) {
        return this;
    }
    // Returns a copy of the tree, with the specified key/value added.
    insert(e, t, n) {
        return new LLRBNode(e, t);
    }
    // Returns a copy of the tree, with the specified key removed.
    remove(e, t) {
        return this;
    }
    isEmpty() {
        return !0;
    }
    inorderTraversal(e) {
        return !1;
    }
    reverseTraversal(e) {
        return !1;
    }
    minKey() {
        return null;
    }
    maxKey() {
        return null;
    }
    isRed() {
        return !1;
    }
    // For testing.
    checkMaxDepth() {
        return !0;
    }
    check() {
        return 0;
    }
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * SortedSet is an immutable (copy-on-write) collection that holds elements
 * in order specified by the provided comparator.
 *
 * NOTE: if provided comparator returns 0 for two elements, we consider them to
 * be equal!
 */ class SortedSet {
    constructor(e){
        this.comparator = e, this.data = new SortedMap(this.comparator);
    }
    has(e) {
        return null !== this.data.get(e);
    }
    first() {
        return this.data.minKey();
    }
    last() {
        return this.data.maxKey();
    }
    get size() {
        return this.data.size;
    }
    indexOf(e) {
        return this.data.indexOf(e);
    }
    /** Iterates elements in order defined by "comparator" */ forEach(e) {
        this.data.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Iterates over `elem`s such that: range[0] &lt;= elem &lt; range[1]. */ forEachInRange(e, t) {
        const n = this.data.getIteratorFrom(e[0]);
        for(; n.hasNext();){
            const r = n.getNext();
            if (this.comparator(r.key, e[1]) >= 0) return;
            t(r.key);
        }
    }
    /**
     * Iterates over `elem`s such that: start &lt;= elem until false is returned.
     */ forEachWhile(e, t) {
        let n;
        for(n = void 0 !== t ? this.data.getIteratorFrom(t) : this.data.getIterator(); n.hasNext();){
            if (!e(n.getNext().key)) return;
        }
    }
    /** Finds the least element greater than or equal to `elem`. */ firstAfterOrEqual(e) {
        const t = this.data.getIteratorFrom(e);
        return t.hasNext() ? t.getNext().key : null;
    }
    getIterator() {
        return new SortedSetIterator(this.data.getIterator());
    }
    getIteratorFrom(e) {
        return new SortedSetIterator(this.data.getIteratorFrom(e));
    }
    /** Inserts or updates an element */ add(e) {
        return this.copy(this.data.remove(e).insert(e, !0));
    }
    /** Deletes an element */ delete(e) {
        return this.has(e) ? this.copy(this.data.remove(e)) : this;
    }
    isEmpty() {
        return this.data.isEmpty();
    }
    unionWith(e) {
        let t = this;
        // Make sure `result` always refers to the larger one of the two sets.
        return t.size < e.size && (t = e, e = this), e.forEach((e)=>{
            t = t.add(e);
        }), t;
    }
    isEqual(e) {
        if (!(e instanceof SortedSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.data.getIterator(), n = e.data.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (0 !== this.comparator(e, r)) return !1;
        }
        return !0;
    }
    toArray() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t);
        }), e;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>e.push(t)), "SortedSet(" + e.toString() + ")";
    }
    copy(e) {
        const t = new SortedSet(this.comparator);
        return t.data = e, t;
    }
}
class SortedSetIterator {
    constructor(e){
        this.iter = e;
    }
    getNext() {
        return this.iter.getNext().key;
    }
    hasNext() {
        return this.iter.hasNext();
    }
}
/**
 * Compares two sorted sets for equality using their natural ordering. The
 * method computes the intersection and invokes `onAdd` for every element that
 * is in `after` but not `before`. `onRemove` is invoked for every element in
 * `before` but missing from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original set.
 * @param after - The elements to diff against the original set.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * Returns the next element from the iterator or `undefined` if none available.
 */ function __PRIVATE_advanceIterator(e) {
    return e.hasNext() ? e.getNext() : void 0;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a set of fields that can be used to partially patch a document.
 * FieldMask is used in conjunction with ObjectValue.
 * Examples:
 *   foo - Overwrites foo entirely with the provided value. If foo is not
 *         present in the companion ObjectValue, the field is deleted.
 *   foo.bar - Overwrites only the field bar of the object foo.
 *             If foo is not an object, foo is replaced with an object
 *             containing foo
 */ class FieldMask {
    constructor(e){
        this.fields = e, // TODO(dimond): validation of FieldMask
        // Sort the field mask to support `FieldMask.isEqual()` and assert below.
        e.sort(FieldPath$1.comparator);
    }
    static empty() {
        return new FieldMask([]);
    }
    /**
     * Returns a new FieldMask object that is the result of adding all the given
     * fields paths to this field mask.
     */ unionWith(e) {
        let t = new SortedSet(FieldPath$1.comparator);
        for (const e of this.fields)t = t.add(e);
        for (const n of e)t = t.add(n);
        return new FieldMask(t.toArray());
    }
    /**
     * Verifies that `fieldPath` is included by at least one field in this field
     * mask.
     *
     * This is an O(n) operation, where `n` is the size of the field mask.
     */ covers(e) {
        for (const t of this.fields)if (t.isPrefixOf(e)) return !0;
        return !1;
    }
    isEqual(e) {
        return __PRIVATE_arrayEquals(this.fields, e.fields, (e, t)=>e.isEqual(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_objectSize(e) {
    let t = 0;
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t++;
    return t;
}
function forEach(e, t) {
    for(const n in e)Object.prototype.hasOwnProperty.call(e, n) && t(n, e[n]);
}
function __PRIVATE_mapToArray(e, t) {
    const n = [];
    for(const r in e)Object.prototype.hasOwnProperty.call(e, r) && n.push(t(e[r], r, e));
    return n;
}
function isEmpty(e) {
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) return !1;
    return !0;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error encountered while decoding base64 string.
 */ class __PRIVATE_Base64DecodeError extends Error {
    constructor(){
        super(...arguments), this.name = "Base64DecodeError";
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ /** True if and only if the Base64 conversion functions are available. */ function __PRIVATE_isBase64Available() {
    return "undefined" != typeof atob;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Immutable class that represents a "proto" byte string.
 *
 * Proto byte strings can either be Base64-encoded strings or Uint8Arrays when
 * sent on the wire. This class abstracts away this differentiation by holding
 * the proto byte string in a common class that must be converted into a string
 * before being sent as a proto.
 * @internal
 */ class ByteString {
    constructor(e){
        this.binaryString = e;
    }
    static fromBase64String(e) {
        const t = function __PRIVATE_decodeBase64(e) {
            try {
                return atob(e);
            } catch (e) {
                // Check that `DOMException` is defined before using it to avoid
                // "ReferenceError: Property 'DOMException' doesn't exist" in react-native.
                // (https://github.com/firebase/firebase-js-sdk/issues/7115)
                throw "undefined" != typeof DOMException && e instanceof DOMException ? new __PRIVATE_Base64DecodeError("Invalid base64 string: " + e) : e;
            }
        }(e);
        return new ByteString(t);
    }
    static fromUint8Array(e) {
        // TODO(indexing); Remove the copy of the byte string here as this method
        // is frequently called during indexing.
        const t = /**
 * Helper function to convert an Uint8array to a binary string.
 */ function __PRIVATE_binaryStringFromUint8Array(e) {
            let t = "";
            for(let n = 0; n < e.length; ++n)t += String.fromCharCode(e[n]);
            return t;
        }(e);
        return new ByteString(t);
    }
    [Symbol.iterator]() {
        let e = 0;
        return {
            next: ()=>e < this.binaryString.length ? {
                    value: this.binaryString.charCodeAt(e++),
                    done: !1
                } : {
                    value: void 0,
                    done: !0
                }
        };
    }
    toBase64() {
        return function __PRIVATE_encodeBase64(e) {
            return btoa(e);
        }(this.binaryString);
    }
    toUint8Array() {
        return function __PRIVATE_uint8ArrayFromBinaryString(e) {
            const t = new Uint8Array(e.length);
            for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
            return t;
        }(this.binaryString);
    }
    approximateByteSize() {
        return 2 * this.binaryString.length;
    }
    compareTo(e) {
        return __PRIVATE_primitiveComparator(this.binaryString, e.binaryString);
    }
    isEqual(e) {
        return this.binaryString === e.binaryString;
    }
}
ByteString.EMPTY_BYTE_STRING = new ByteString("");
const et = new RegExp(/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(?:\.(\d+))?Z$/);
/**
 * Converts the possible Proto values for a timestamp value into a "seconds and
 * nanos" representation.
 */ function __PRIVATE_normalizeTimestamp(e) {
    // The json interface (for the browser) will return an iso timestamp string,
    // while the proto js library (for node) will return a
    // google.protobuf.Timestamp instance.
    if (__PRIVATE_hardAssert(!!e, 39018), "string" == typeof e) {
        // The date string can have higher precision (nanos) than the Date class
        // (millis), so we do some custom parsing here.
        // Parse the nanos right out of the string.
        let t = 0;
        const n = et.exec(e);
        if (__PRIVATE_hardAssert(!!n, 46558, {
            timestamp: e
        }), n[1]) {
            // Pad the fraction out to 9 digits (nanos).
            let e = n[1];
            e = (e + "000000000").substr(0, 9), t = Number(e);
        }
        // Parse the date to get the seconds.
        const r = new Date(e);
        return {
            seconds: Math.floor(r.getTime() / 1e3),
            nanos: t
        };
    }
    return {
        seconds: __PRIVATE_normalizeNumber(e.seconds),
        nanos: __PRIVATE_normalizeNumber(e.nanos)
    };
}
/**
 * Converts the possible Proto types for numbers into a JavaScript number.
 * Returns 0 if the value is not numeric.
 */ function __PRIVATE_normalizeNumber(e) {
    // TODO(bjornick): Handle int64 greater than 53 bits.
    return "number" == typeof e ? e : "string" == typeof e ? Number(e) : 0;
}
/** Converts the possible Proto types for Blobs into a ByteString. */ function __PRIVATE_normalizeByteString(e) {
    return "string" == typeof e ? ByteString.fromBase64String(e) : ByteString.fromUint8Array(e);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a locally-applied ServerTimestamp.
 *
 * Server Timestamps are backed by MapValues that contain an internal field
 * `__type__` with a value of `server_timestamp`. The previous value and local
 * write time are stored in its `__previous_value__` and `__local_write_time__`
 * fields respectively.
 *
 * Notes:
 * - ServerTimestampValue instances are created as the result of applying a
 *   transform. They can only exist in the local view of a document. Therefore
 *   they do not need to be parsed or serialized.
 * - When evaluated locally (e.g. for snapshot.data()), they by default
 *   evaluate to `null`. This behavior can be configured by passing custom
 *   FieldValueOptions to value().
 * - With respect to other ServerTimestampValues, they sort by their
 *   localWriteTime.
 */ const tt = "server_timestamp", nt = "__type__", rt = "__previous_value__", it = "__local_write_time__";
function __PRIVATE_isServerTimestamp(e) {
    const t = (e?.mapValue?.fields || {})[nt]?.stringValue;
    return t === tt;
}
/**
 * Creates a new ServerTimestamp proto value (using the internal format).
 */ /**
 * Returns the value of the field before this ServerTimestamp was set.
 *
 * Preserving the previous values allows the user to display the last resoled
 * value until the backend responds with the timestamp.
 */ function __PRIVATE_getPreviousValue(e) {
    const t = e.mapValue.fields[rt];
    return __PRIVATE_isServerTimestamp(t) ? __PRIVATE_getPreviousValue(t) : t;
}
/**
 * Returns the local time at which this timestamp was first set.
 */ function __PRIVATE_getLocalWriteTime(e) {
    const t = __PRIVATE_normalizeTimestamp(e.mapValue.fields[it].timestampValue);
    return new Timestamp(t.seconds, t.nanos);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class DatabaseInfo {
    /**
     * Constructs a DatabaseInfo using the provided host, databaseId and
     * persistenceKey.
     *
     * @param databaseId - The database to use.
     * @param appId - The Firebase App Id.
     * @param persistenceKey - A unique identifier for this Firestore's local
     * storage (used in conjunction with the databaseId).
     * @param host - The Firestore backend host to connect to.
     * @param ssl - Whether to use SSL when connecting.
     * @param forceLongPolling - Whether to use the forceLongPolling option
     * when using WebChannel as the network transport.
     * @param autoDetectLongPolling - Whether to use the detectBufferingProxy
     * option when using WebChannel as the network transport.
     * @param longPollingOptions - Options that configure long-polling.
     * @param useFetchStreams - Whether to use the Fetch API instead of
     * XMLHTTPRequest
     */ constructor(e, t, n, r, i, s, _, o, a, u, c){
        this.databaseId = e, this.appId = t, this.persistenceKey = n, this.host = r, this.ssl = i, this.forceLongPolling = s, this.autoDetectLongPolling = _, this.longPollingOptions = o, this.useFetchStreams = a, this.isUsingEmulator = u, this.apiKey = c;
    }
}
/** The default database name for a project. */ const st = "(default)";
/**
 * Represents the database ID a Firestore client is associated with.
 * @internal
 */ class DatabaseId {
    constructor(e, t){
        this.projectId = e, this.database = t || st;
    }
    static empty() {
        return new DatabaseId("", "");
    }
    get isDefaultDatabase() {
        return this.database === st;
    }
    isEqual(e) {
        return e instanceof DatabaseId && e.projectId === this.projectId && e.database === this.database;
    }
}
function __PRIVATE_databaseIdFromApp(e, t) {
    if (!Object.prototype.hasOwnProperty.apply(e.options, [
        "projectId"
    ])) throw new FirestoreError(D.INVALID_ARGUMENT, '"projectId" not provided in firebase.initializeApp.');
    return new DatabaseId(e.options.projectId, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const _t = "__type__", ot = "__max__", at = {
    mapValue: {
        fields: {
            __type__: {
                stringValue: ot
            }
        }
    }
}, ut = "__vector__", ct = "value", lt = {
    nullValue: "NULL_VALUE"
}, Et = {
    booleanValue: !0
}, ht = {
    booleanValue: !1
};
/** Extracts the backend's type order for the provided value. */ function __PRIVATE_typeOrder(e) {
    return "nullValue" in e ? 0 /* TypeOrder.NullValue */  : "booleanValue" in e ? 1 /* TypeOrder.BooleanValue */  : "integerValue" in e || "doubleValue" in e ? 2 /* TypeOrder.NumberValue */  : "timestampValue" in e ? 3 /* TypeOrder.TimestampValue */  : "stringValue" in e ? 5 /* TypeOrder.StringValue */  : "bytesValue" in e ? 6 /* TypeOrder.BlobValue */  : "referenceValue" in e ? 7 /* TypeOrder.RefValue */  : "geoPointValue" in e ? 8 /* TypeOrder.GeoPointValue */  : "arrayValue" in e ? 9 /* TypeOrder.ArrayValue */  : "mapValue" in e ? __PRIVATE_isServerTimestamp(e) ? 4 /* TypeOrder.ServerTimestampValue */  : __PRIVATE_isMaxValue(e) ? 9007199254740991 /* TypeOrder.MaxValue */  : __PRIVATE_isVectorValue(e) ? 10 /* TypeOrder.VectorValue */  : 11 /* TypeOrder.ObjectValue */  : fail(28295, {
        value: e
    });
}
/** Tests `left` and `right` for equality based on the backend semantics. */ function __PRIVATE_valueEquals$1(e, t, n) {
    if (e === t) return !0;
    const r = __PRIVATE_typeOrder(e);
    if (r !== __PRIVATE_typeOrder(t)) return !1;
    switch(r){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return !0;
        case 1 /* TypeOrder.BooleanValue */ :
            return e.booleanValue === t.booleanValue;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return __PRIVATE_getLocalWriteTime(e).isEqual(__PRIVATE_getLocalWriteTime(t));
        case 3 /* TypeOrder.TimestampValue */ :
            return function __PRIVATE_timestampEquals(e, t) {
                if ("string" == typeof e.timestampValue && "string" == typeof t.timestampValue && e.timestampValue.length === t.timestampValue.length) // Use string equality for ISO 8601 timestamps
                return e.timestampValue === t.timestampValue;
                const n = __PRIVATE_normalizeTimestamp(e.timestampValue), r = __PRIVATE_normalizeTimestamp(t.timestampValue);
                return n.seconds === r.seconds && n.nanos === r.nanos;
            }(e, t);
        case 5 /* TypeOrder.StringValue */ :
            return e.stringValue === t.stringValue;
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_blobEquals(e, t) {
                return __PRIVATE_normalizeByteString(e.bytesValue).isEqual(__PRIVATE_normalizeByteString(t.bytesValue));
            }(e, t);
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue === t.referenceValue;
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_geoPointEquals(e, t) {
                return __PRIVATE_normalizeNumber(e.geoPointValue.latitude) === __PRIVATE_normalizeNumber(t.geoPointValue.latitude) && __PRIVATE_normalizeNumber(e.geoPointValue.longitude) === __PRIVATE_normalizeNumber(t.geoPointValue.longitude);
            }(e, t);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_numberEquals(e, t, n) {
                if ("integerValue" in e && "integerValue" in t) return __PRIVATE_normalizeNumber(e.integerValue) === __PRIVATE_normalizeNumber(t.integerValue);
                let r, i;
                if ("doubleValue" in e && "doubleValue" in t) r = __PRIVATE_normalizeNumber(e.doubleValue), i = __PRIVATE_normalizeNumber(t.doubleValue);
                else {
                    if (!n?.Ee) return !1;
                    r = __PRIVATE_normalizeNumber(e.integerValue ?? e.doubleValue), i = __PRIVATE_normalizeNumber(t.integerValue ?? t.doubleValue);
                }
                if (r === i) return !!n?.he || __PRIVATE_isNegativeZero(r) === __PRIVATE_isNegativeZero(i);
                return !!(void 0 === n || n.Te) && isNaN(r) && isNaN(i);
            }(e, t, n);
        case 9 /* TypeOrder.ArrayValue */ :
            return __PRIVATE_arrayEquals(e.arrayValue.values || [], t.arrayValue.values || [], (e, t)=>__PRIVATE_valueEquals$1(e, t, n));
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_objectEquals(e, t, n) {
                const r = e.mapValue.fields || {}, i = t.mapValue.fields || {};
                if (__PRIVATE_objectSize(r) !== __PRIVATE_objectSize(i)) return !1;
                for(const e in r)if (r.hasOwnProperty(e) && (void 0 === i[e] || !__PRIVATE_valueEquals$1(r[e], i[e], n))) return !1;
                return !0;
            }(e, t, n);
        default:
            return fail(52216, {
                left: e
            });
    }
}
function __PRIVATE_arrayValueContains(e, t) {
    return void 0 !== (e.values || []).find((e)=>__PRIVATE_valueEquals$1(e, t));
}
function __PRIVATE_valueCompare(e, t) {
    if (e === t) return 0;
    const n = __PRIVATE_typeOrder(e), r = __PRIVATE_typeOrder(t);
    if (n !== r) return __PRIVATE_primitiveComparator(n, r);
    switch(n){
        case 0 /* TypeOrder.NullValue */ :
        case 9007199254740991 /* TypeOrder.MaxValue */ :
            return 0;
        case 1 /* TypeOrder.BooleanValue */ :
            return __PRIVATE_primitiveComparator(e.booleanValue, t.booleanValue);
        case 2 /* TypeOrder.NumberValue */ :
            return function __PRIVATE_compareNumbers(e, t) {
                const n = __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue), r = __PRIVATE_normalizeNumber(t.integerValue || t.doubleValue);
                return n < r ? -1 : n > r ? 1 : n === r ? 0 : // one or both are NaN.
                isNaN(n) ? isNaN(r) ? 0 : -1 : 1;
            }(e, t);
        case 3 /* TypeOrder.TimestampValue */ :
            return __PRIVATE_compareTimestamps(e.timestampValue, t.timestampValue);
        case 4 /* TypeOrder.ServerTimestampValue */ :
            return __PRIVATE_compareTimestamps(__PRIVATE_getLocalWriteTime(e), __PRIVATE_getLocalWriteTime(t));
        case 5 /* TypeOrder.StringValue */ :
            return __PRIVATE_compareUtf8Strings(e.stringValue, t.stringValue);
        case 6 /* TypeOrder.BlobValue */ :
            return function __PRIVATE_compareBlobs(e, t) {
                const n = __PRIVATE_normalizeByteString(e), r = __PRIVATE_normalizeByteString(t);
                return n.compareTo(r);
            }(e.bytesValue, t.bytesValue);
        case 7 /* TypeOrder.RefValue */ :
            return function __PRIVATE_compareReferences(e, t) {
                const n = e.split("/"), r = t.split("/");
                for(let e = 0; e < n.length && e < r.length; e++){
                    const t = __PRIVATE_primitiveComparator(n[e], r[e]);
                    if (0 !== t) return t;
                }
                return __PRIVATE_primitiveComparator(n.length, r.length);
            }(e.referenceValue, t.referenceValue);
        case 8 /* TypeOrder.GeoPointValue */ :
            return function __PRIVATE_compareGeoPoints(e, t) {
                const n = __PRIVATE_primitiveComparator(__PRIVATE_normalizeNumber(e.latitude), __PRIVATE_normalizeNumber(t.latitude));
                if (0 !== n) return n;
                return __PRIVATE_primitiveComparator(__PRIVATE_normalizeNumber(e.longitude), __PRIVATE_normalizeNumber(t.longitude));
            }(e.geoPointValue, t.geoPointValue);
        case 9 /* TypeOrder.ArrayValue */ :
            return __PRIVATE_compareArrays(e.arrayValue, t.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
            return function __PRIVATE_compareVectors(e, t) {
                const n = e.fields || {}, r = t.fields || {}, i = n[ct]?.arrayValue, s = r[ct]?.arrayValue, _ = __PRIVATE_primitiveComparator(i?.values?.length || 0, s?.values?.length || 0);
                if (0 !== _) return _;
                return __PRIVATE_compareArrays(i, s);
            }(e.mapValue, t.mapValue);
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_compareMaps(e, t) {
                if (e === at.mapValue && t === at.mapValue) return 0;
                if (e === at.mapValue) return 1;
                if (t === at.mapValue) return -1;
                const n = e.fields || {}, r = Object.keys(n), i = t.fields || {}, s = Object.keys(i);
                // Even though MapValues are likely sorted correctly based on their insertion
                // order (e.g. when received from the backend), local modifications can bring
                // elements out of order. We need to re-sort the elements to ensure that
                // canonical IDs are independent of insertion order.
                r.sort(), s.sort();
                for(let e = 0; e < r.length && e < s.length; ++e){
                    const t = __PRIVATE_compareUtf8Strings(r[e], s[e]);
                    if (0 !== t) return t;
                    const _ = __PRIVATE_valueCompare(n[r[e]], i[s[e]]);
                    if (0 !== _) return _;
                }
                return __PRIVATE_primitiveComparator(r.length, s.length);
            }(e.mapValue, t.mapValue);
        default:
            throw fail(23264, {
                Pe: n
            });
    }
}
function __PRIVATE_compareTimestamps(e, t) {
    if ("string" == typeof e && "string" == typeof t && e.length === t.length) return __PRIVATE_primitiveComparator(e, t);
    const n = __PRIVATE_normalizeTimestamp(e), r = __PRIVATE_normalizeTimestamp(t), i = __PRIVATE_primitiveComparator(n.seconds, r.seconds);
    return 0 !== i ? i : __PRIVATE_primitiveComparator(n.nanos, r.nanos);
}
function __PRIVATE_compareArrays(e, t) {
    const n = e.values || [], r = t.values || [];
    for(let e = 0; e < n.length && e < r.length; ++e){
        const t = __PRIVATE_valueCompare(n[e], r[e]);
        if (void 0 !== t && 0 !== t) return t;
    }
    return __PRIVATE_primitiveComparator(n.length, r.length);
}
function canonicalId(e) {
    return __PRIVATE_canonifyValue(e);
}
function __PRIVATE_canonifyValue(e) {
    return "nullValue" in e ? "null" : "booleanValue" in e ? "" + e.booleanValue : "integerValue" in e ? "" + e.integerValue : "doubleValue" in e ? "" + e.doubleValue : "timestampValue" in e ? function __PRIVATE_canonifyTimestamp(e) {
        const t = __PRIVATE_normalizeTimestamp(e);
        return `time(${t.seconds},${t.nanos})`;
    }(e.timestampValue) : "stringValue" in e ? e.stringValue : "bytesValue" in e ? function __PRIVATE_canonifyByteString(e) {
        return __PRIVATE_normalizeByteString(e).toBase64();
    }(e.bytesValue) : "referenceValue" in e ? function __PRIVATE_canonifyReference(e) {
        return DocumentKey.fromName(e).toString();
    }(e.referenceValue) : "geoPointValue" in e ? function __PRIVATE_canonifyGeoPoint(e) {
        return `geo(${e.latitude},${e.longitude})`;
    }(e.geoPointValue) : "arrayValue" in e ? function __PRIVATE_canonifyArray(e) {
        let t = "[", n = !0;
        for (const r of e.values || [])n ? n = !1 : t += ",", t += __PRIVATE_canonifyValue(r);
        return t + "]";
    }(e.arrayValue) : "mapValue" in e ? function __PRIVATE_canonifyMap(e) {
        // Iteration order in JavaScript is not guaranteed. To ensure that we generate
        // matching canonical IDs for identical maps, we need to sort the keys.
        const t = Object.keys(e.fields || {}).sort();
        let n = "{", r = !0;
        for (const i of t)r ? r = !1 : n += ",", n += `${i}:${__PRIVATE_canonifyValue(e.fields[i])}`;
        return n + "}";
    }(e.mapValue) : fail(61005, {
        value: e
    });
}
function __PRIVATE_estimateByteSize(e) {
    switch(__PRIVATE_typeOrder(e)){
        case 0 /* TypeOrder.NullValue */ :
        case 1 /* TypeOrder.BooleanValue */ :
            return 4;
        case 2 /* TypeOrder.NumberValue */ :
            return 8;
        case 3 /* TypeOrder.TimestampValue */ :
        case 8 /* TypeOrder.GeoPointValue */ :
            // GeoPoints are made up of two distinct numbers (latitude + longitude)
            return 16;
        case 4 /* TypeOrder.ServerTimestampValue */ :
            const t = __PRIVATE_getPreviousValue(e);
            return t ? 16 + __PRIVATE_estimateByteSize(t) : 16;
        case 5 /* TypeOrder.StringValue */ :
            // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Data_structures:
            // "JavaScript's String type is [...] a set of elements of 16-bit unsigned
            // integer values"
            return 2 * e.stringValue.length;
        case 6 /* TypeOrder.BlobValue */ :
            return __PRIVATE_normalizeByteString(e.bytesValue).approximateByteSize();
        case 7 /* TypeOrder.RefValue */ :
            return e.referenceValue.length;
        case 9 /* TypeOrder.ArrayValue */ :
            return function __PRIVATE_estimateArrayByteSize(e) {
                return (e.values || []).reduce((e, t)=>e + __PRIVATE_estimateByteSize(t), 0);
            }(e.arrayValue);
        case 10 /* TypeOrder.VectorValue */ :
        case 11 /* TypeOrder.ObjectValue */ :
            return function __PRIVATE_estimateMapByteSize(e) {
                let t = 0;
                return forEach(e.fields, (e, n)=>{
                    t += e.length + __PRIVATE_estimateByteSize(n);
                }), t;
            }(e.mapValue);
        default:
            throw fail(13486, {
                value: e
            });
    }
}
function __PRIVATE_refValue(e, t) {
    return {
        referenceValue: `projects/${e.projectId}/databases/${e.database}/documents/${t.path.canonicalString()}`
    };
}
/** Returns true if `value` is an BooleanValue . */ /** Returns true if `value` is an IntegerValue . */ function isInteger(e) {
    return !!e && "integerValue" in e;
}
/** Returns true if `value` is a DoubleValue. */ function __PRIVATE_isDouble(e) {
    return !!e && "doubleValue" in e;
}
/** Returns true if `value` is either an IntegerValue or a DoubleValue. */ function __PRIVATE_isNumber(e) {
    return isInteger(e) || __PRIVATE_isDouble(e);
}
/** Returns true if `value` is an ArrayValue. */ function isArray(e) {
    return !!e && "arrayValue" in e;
}
/** Returns true if `value` is an ArrayValue. */ /** Returns true if `value` is a NullValue. */ function __PRIVATE_isNullValue(e) {
    return !!e && "nullValue" in e;
}
/** Returns true if `value` is NaN. */ function __PRIVATE_isNanValue(e) {
    return !!e && "doubleValue" in e && isNaN(Number(e.doubleValue));
}
/** Returns true if `value` is Timestamp. */ /** Returns true if `value` is a MapValue. */ function __PRIVATE_isMapValue(e) {
    return !!e && "mapValue" in e;
}
/** Returns true if `value` is a VetorValue. */ function __PRIVATE_isVectorValue(e) {
    const t = (e?.mapValue?.fields || {})[_t]?.stringValue;
    return t === ut;
}
/** Returns true if `value` is a VetorValue. */ function __PRIVATE_getVectorValue(e) {
    return (e?.mapValue?.fields || {})[ct]?.arrayValue;
}
/** Creates a deep copy of `source`. */ function __PRIVATE_deepClone(e) {
    if (e.geoPointValue) return {
        geoPointValue: {
            ...e.geoPointValue
        }
    };
    if (e.timestampValue && "object" == typeof e.timestampValue) return {
        timestampValue: {
            ...e.timestampValue
        }
    };
    if (e.mapValue) {
        const t = {
            mapValue: {
                fields: {}
            }
        };
        return forEach(e.mapValue.fields, (e, n)=>t.mapValue.fields[e] = __PRIVATE_deepClone(n)), t;
    }
    if (e.arrayValue) {
        const t = {
            arrayValue: {
                values: []
            }
        };
        for(let n = 0; n < (e.arrayValue.values || []).length; ++n)t.arrayValue.values[n] = __PRIVATE_deepClone(e.arrayValue.values[n]);
        return t;
    }
    return {
        ...e
    };
}
/** Returns true if the Value represents the canonical {@link #MAX_VALUE} . */ function __PRIVATE_isMaxValue(e) {
    return (((e.mapValue || {}).fields || {}).__type__ || {}).stringValue === ot;
}
const Tt = {
    mapValue: {
        fields: {
            [_t]: {
                stringValue: ut
            },
            [ct]: {
                arrayValue: {}
            }
        }
    }
};
/** Returns the lowest value for the given value type (inclusive). */ function __PRIVATE_valuesGetLowerBound(e) {
    return "nullValue" in e ? lt : "booleanValue" in e ? {
        booleanValue: !1
    } : "integerValue" in e || "doubleValue" in e ? {
        doubleValue: NaN
    } : "timestampValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "stringValue" in e ? {
        stringValue: ""
    } : "bytesValue" in e ? {
        bytesValue: ""
    } : "referenceValue" in e ? __PRIVATE_refValue(DatabaseId.empty(), DocumentKey.empty()) : "geoPointValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "arrayValue" in e ? {
        arrayValue: {}
    } : "mapValue" in e ? __PRIVATE_isVectorValue(e) ? Tt : {
        mapValue: {}
    } : fail(35942, {
        value: e
    });
}
/** Returns the largest value for the given value type (exclusive). */ function __PRIVATE_valuesGetUpperBound(e) {
    return "nullValue" in e ? {
        booleanValue: !1
    } : "booleanValue" in e ? {
        doubleValue: NaN
    } : "integerValue" in e || "doubleValue" in e ? {
        timestampValue: {
            seconds: Number.MIN_SAFE_INTEGER
        }
    } : "timestampValue" in e ? {
        stringValue: ""
    } : "stringValue" in e ? {
        bytesValue: ""
    } : "bytesValue" in e ? __PRIVATE_refValue(DatabaseId.empty(), DocumentKey.empty()) : "referenceValue" in e ? {
        geoPointValue: {
            latitude: -90,
            longitude: -180
        }
    } : "geoPointValue" in e ? {
        arrayValue: {}
    } : "arrayValue" in e ? Tt : "mapValue" in e ? __PRIVATE_isVectorValue(e) ? {
        mapValue: {}
    } : at : fail(61959, {
        value: e
    });
}
function __PRIVATE_lowerBoundCompare(e, t) {
    const n = __PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? -1 : !e.inclusive && t.inclusive ? 1 : 0;
}
function __PRIVATE_upperBoundCompare(e, t) {
    const n = __PRIVATE_valueCompare(e.value, t.value);
    return 0 !== n ? n : e.inclusive && !t.inclusive ? 1 : !e.inclusive && t.inclusive ? -1 : 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ObjectValue represents a MapValue in the Firestore Proto and offers the
 * ability to add and remove fields (via the ObjectValueBuilder).
 */ class ObjectValue {
    constructor(e){
        this.value = e;
    }
    static empty() {
        return new ObjectValue({
            mapValue: {}
        });
    }
    /**
     * Returns the value at the given path or null.
     *
     * @param path - the path to search
     * @returns The value at the path or null if the path is not set.
     */ field(e) {
        if (e.isEmpty()) return this.value;
        {
            let t = this.value;
            for(let n = 0; n < e.length - 1; ++n)if (t = (t.mapValue.fields || {})[e.get(n)], !__PRIVATE_isMapValue(t)) return null;
            return t = (t.mapValue.fields || {})[e.lastSegment()], t || null;
        }
    }
    /**
     * Sets the field to the provided value.
     *
     * @param path - The field path to set.
     * @param value - The value to set.
     */ set(e, t) {
        this.getFieldsMap(e.popLast())[e.lastSegment()] = __PRIVATE_deepClone(t);
    }
    /**
     * Sets the provided fields to the provided values.
     *
     * @param data - A map of fields to values (or null for deletes).
     */ setAll(e) {
        let t = FieldPath$1.emptyPath(), n = {}, r = [];
        e.forEach((e, i)=>{
            if (!t.isImmediateParentOf(i)) {
                // Insert the accumulated changes at this parent location
                const e = this.getFieldsMap(t);
                this.applyChanges(e, n, r), n = {}, r = [], t = i.popLast();
            }
            e ? n[i.lastSegment()] = __PRIVATE_deepClone(e) : r.push(i.lastSegment());
        });
        const i = this.getFieldsMap(t);
        this.applyChanges(i, n, r);
    }
    /**
     * Removes the field at the specified path. If there is no field at the
     * specified path, nothing is changed.
     *
     * @param path - The field path to remove.
     */ delete(e) {
        const t = this.field(e.popLast());
        __PRIVATE_isMapValue(t) && t.mapValue.fields && delete t.mapValue.fields[e.lastSegment()];
    }
    isEqual(e) {
        return __PRIVATE_valueEquals$1(this.value, e.value);
    }
    /**
     * Returns the map that contains the leaf element of `path`. If the parent
     * entry does not yet exist, or if it is not a map, a new map will be created.
     */ getFieldsMap(e) {
        let t = this.value;
        t.mapValue.fields || (t.mapValue = {
            fields: {}
        });
        for(let n = 0; n < e.length; ++n){
            let r = t.mapValue.fields[e.get(n)];
            __PRIVATE_isMapValue(r) && r.mapValue.fields || (r = {
                mapValue: {
                    fields: {}
                }
            }, t.mapValue.fields[e.get(n)] = r), t = r;
        }
        return t.mapValue.fields;
    }
    /**
     * Modifies `fieldsMap` by adding, replacing or deleting the specified
     * entries.
     */ applyChanges(e, t, n) {
        forEach(t, (t, n)=>e[t] = n);
        for (const t of n)delete e[t];
    }
    clone() {
        return new ObjectValue(__PRIVATE_deepClone(this.value));
    }
}
/**
 * Returns a FieldMask built from all fields in a MapValue.
 */ function __PRIVATE_extractFieldMask(e) {
    const t = [];
    return forEach(e.fields, (e, n)=>{
        const r = new FieldPath$1([
            e
        ]);
        if (__PRIVATE_isMapValue(n)) {
            const e = __PRIVATE_extractFieldMask(n.mapValue).fields;
            if (0 === e.length) // Preserve the empty map by adding it to the FieldMask.
            t.push(r);
            else // For nested and non-empty ObjectValues, add the FieldPath of the
            // leaf nodes.
            for (const n of e)t.push(r.child(n));
        } else // For nested and non-empty ObjectValues, add the FieldPath of the leaf
        // nodes.
        t.push(r);
    }), new FieldMask(t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an DoubleValue for `value` that is encoded based the serializer's
 * `useProto3Json` setting.
 */ function __PRIVATE_toDouble(e, t) {
    if (e.useProto3Json) {
        if (isNaN(t)) return {
            doubleValue: "NaN"
        };
        if (t === 1 / 0) return {
            doubleValue: "Infinity"
        };
        if (t === -1 / 0) return {
            doubleValue: "-Infinity"
        };
    }
    return {
        doubleValue: __PRIVATE_isNegativeZero(t) ? "-0" : t
    };
}
/**
 * Returns an IntegerValue for `value`.
 */ function __PRIVATE_toInteger(e) {
    return {
        integerValue: "" + e
    };
}
/**
 * Returns a value for a number that's appropriate to put into a proto.
 * The return value is an IntegerValue if it can safely represent the value,
 * otherwise a DoubleValue is returned.
 */ function toNumber(e, t, n) {
    return Number.isInteger(t) && n?.preferIntegers || isSafeInteger(t) ? __PRIVATE_toInteger(t) : __PRIVATE_toDouble(e, t);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Used to represent a field transform on a mutation. */ class TransformOperation {
    constructor(){
        // Make sure that the structural type of `TransformOperation` is unique.
        // See https://github.com/microsoft/TypeScript/issues/5451
        this._ = void 0;
    }
}
/**
 * Computes the local transform result against the provided `previousValue`,
 * optionally using the provided localWriteTime.
 */ function __PRIVATE_applyTransformOperationToLocalView(e, t, n) {
    return e instanceof __PRIVATE_ServerTimestampTransform ? function serverTimestamp$1(e, t) {
        const n = {
            fields: {
                [nt]: {
                    stringValue: tt
                },
                [it]: {
                    timestampValue: {
                        seconds: e.seconds,
                        nanos: e.nanoseconds
                    }
                }
            }
        };
        // We should avoid storing deeply nested server timestamp map values
        // because we never use the intermediate "previous values".
        // For example:
        // previous: 42L, add: t1, result: t1 -> 42L
        // previous: t1,  add: t2, result: t2 -> 42L (NOT t2 -> t1 -> 42L)
        // previous: t2,  add: t3, result: t3 -> 42L (NOT t3 -> t2 -> t1 -> 42L)
        // `getPreviousValue` recursively traverses server timestamps to find the
        // least recent Value.
        return t && __PRIVATE_isServerTimestamp(t) && (t = __PRIVATE_getPreviousValue(t)), t && (n.fields[rt] = t), {
            mapValue: n
        };
    }(n, t) : e instanceof __PRIVATE_ArrayUnionTransformOperation ? __PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof __PRIVATE_ArrayRemoveTransformOperation ? __PRIVATE_applyArrayRemoveTransformOperation(e, t) : e instanceof __PRIVATE_NumericIncrementTransformOperation ? function __PRIVATE_applyNumericIncrementTransformOperationToLocalView(e, t) {
        // PORTING NOTE: Since JavaScript's integer arithmetic is limited to 53 bit
        // precision and resolves overflows by reducing precision, we do not
        // manually cap overflows at 2^63.
        const n = __PRIVATE_computeTransformOperationBaseValue(e, t), r = asNumber(n) + asNumber(e.Re);
        return isInteger(n) && isInteger(e.Re) ? __PRIVATE_toInteger(r) : __PRIVATE_toDouble(e.serializer, r);
    }(e, t) : e instanceof __PRIVATE_NumericMinimumTransformOperation ? function __PRIVATE_applyNumericMinimumTransformOperationToLocalView(e, t) {
        return __PRIVATE_applyNumericTransformOperationToLocalView(e, t, Math.min);
    }(e, t) : e instanceof __PRIVATE_NumericMaximumTransformOperation ? function __PRIVATE_applyNumericMaximumTransformOperationToLocalView(e, t) {
        return __PRIVATE_applyNumericTransformOperationToLocalView(e, t, Math.max);
    }(e, t) : void 0;
}
/**
 * Computes a final transform result after the transform has been acknowledged
 * by the server, potentially using the server-provided transformResult.
 */ function __PRIVATE_applyTransformOperationToRemoteDocument(e, t, n) {
    // The server just sends null as the transform result for array operations,
    // so we have to calculate a result the same as we do for local
    // applications.
    return e instanceof __PRIVATE_ArrayUnionTransformOperation ? __PRIVATE_applyArrayUnionTransformOperation(e, t) : e instanceof __PRIVATE_ArrayRemoveTransformOperation ? __PRIVATE_applyArrayRemoveTransformOperation(e, t) : n;
}
/**
 * If this transform operation is not idempotent, returns the base value to
 * persist for this transform. If a base value is returned, the transform
 * operation is always applied to this base value, even if document has
 * already been updated.
 *
 * Base values provide consistent behavior for non-idempotent transforms and
 * allow us to return the same latency-compensated value even if the backend
 * has already applied the transform operation. The base value is null for
 * idempotent transforms, as they can be re-played even if the backend has
 * already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent transforms.
 */ function __PRIVATE_computeTransformOperationBaseValue(e, t) {
    return e instanceof __PRIVATE_NumericIncrementTransformOperation ? __PRIVATE_isNumber(t) ? t : {
        integerValue: 0
    } : null;
}
/** Transforms a value into a server-generated timestamp. */ class __PRIVATE_ServerTimestampTransform extends TransformOperation {
}
/** Transforms an array value via a union operation. */ class __PRIVATE_ArrayUnionTransformOperation extends TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function __PRIVATE_applyArrayUnionTransformOperation(e, t) {
    const n = __PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n.some((e)=>__PRIVATE_valueEquals$1(e, t)) || n.push(t);
    return {
        arrayValue: {
            values: n
        }
    };
}
/** Transforms an array value via a remove operation. */ class __PRIVATE_ArrayRemoveTransformOperation extends TransformOperation {
    constructor(e){
        super(), this.elements = e;
    }
}
function __PRIVATE_applyArrayRemoveTransformOperation(e, t) {
    let n = __PRIVATE_coercedFieldValuesArray(t);
    for (const t of e.elements)n = n.filter((e)=>!__PRIVATE_valueEquals$1(e, t));
    return {
        arrayValue: {
            values: n
        }
    };
}
/**
 * Implements the backend semantics for locally computed NUMERIC_ADD (increment)
 * transforms. Converts all field values to integers or doubles, but unlike the
 * backend does not cap integer values at 2^63. Instead, JavaScript number
 * arithmetic is used and precision loss can occur for values greater than 2^53.
 */ class __PRIVATE_NumericTransformOperation extends TransformOperation {
    constructor(e, t){
        super(), this.serializer = e, this.Re = t;
    }
}
class __PRIVATE_NumericIncrementTransformOperation extends __PRIVATE_NumericTransformOperation {
}
class __PRIVATE_NumericMinimumTransformOperation extends __PRIVATE_NumericTransformOperation {
}
class __PRIVATE_NumericMaximumTransformOperation extends __PRIVATE_NumericTransformOperation {
}
function __PRIVATE_applyNumericTransformOperationToLocalView(e, t, n) {
    if (!__PRIVATE_isNumber(t)) return e.Re;
    const r = n(asNumber(t), asNumber(e.Re));
    return isInteger(t) && isInteger(e.Re) ? __PRIVATE_toInteger(r) : __PRIVATE_toDouble(e.serializer, r);
}
function asNumber(e) {
    return __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
}
function __PRIVATE_coercedFieldValuesArray(e) {
    return isArray(e) && e.arrayValue.values ? e.arrayValue.values.slice() : [];
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A field path and the TransformOperation to perform upon it. */ class FieldTransform {
    constructor(e, t){
        this.field = e, this.transform = t;
    }
}
function __PRIVATE_fieldTransformEquals(e, t) {
    return e.field.isEqual(t.field) && function __PRIVATE_transformOperationEquals(e, t) {
        return e instanceof __PRIVATE_ArrayUnionTransformOperation && t instanceof __PRIVATE_ArrayUnionTransformOperation || e instanceof __PRIVATE_ArrayRemoveTransformOperation && t instanceof __PRIVATE_ArrayRemoveTransformOperation ? __PRIVATE_arrayEquals(e.elements, t.elements, __PRIVATE_valueEquals$1) : e instanceof __PRIVATE_NumericIncrementTransformOperation && t instanceof __PRIVATE_NumericIncrementTransformOperation || e instanceof __PRIVATE_NumericMinimumTransformOperation && t instanceof __PRIVATE_NumericMinimumTransformOperation || e instanceof __PRIVATE_NumericMaximumTransformOperation && t instanceof __PRIVATE_NumericMaximumTransformOperation ? __PRIVATE_valueEquals$1(e.Re, t.Re) : e instanceof __PRIVATE_ServerTimestampTransform && t instanceof __PRIVATE_ServerTimestampTransform;
    }(e.transform, t.transform);
}
/** The result of successfully applying a mutation to the backend. */ class MutationResult {
    constructor(/**
     * The version at which the mutation was committed:
     *
     * - For most operations, this is the updateTime in the WriteResult.
     * - For deletes, the commitTime of the WriteResponse (because deletes are
     *   not stored and have no updateTime).
     *
     * Note that these versions can be different: No-op writes will not change
     * the updateTime even though the commitTime advances.
     */ e, /**
     * The resulting fields returned from the backend after a mutation
     * containing field transforms has been committed. Contains one FieldValue
     * for each FieldTransform that was in the mutation.
     *
     * Will be empty if the mutation did not contain any field transforms.
     */ t){
        this.version = e, this.transformResults = t;
    }
}
/**
 * Encodes a precondition for a mutation. This follows the model that the
 * backend accepts with the special case of an explicit "empty" precondition
 * (meaning no precondition).
 */ class Precondition {
    constructor(e, t){
        this.updateTime = e, this.exists = t;
    }
    /** Creates a new empty Precondition. */ static none() {
        return new Precondition;
    }
    /** Creates a new Precondition with an exists flag. */ static exists(e) {
        return new Precondition(void 0, e);
    }
    /** Creates a new Precondition based on a version a document exists at. */ static updateTime(e) {
        return new Precondition(e);
    }
    /** Returns whether this Precondition is empty. */ get isNone() {
        return void 0 === this.updateTime && void 0 === this.exists;
    }
    isEqual(e) {
        return this.exists === e.exists && (this.updateTime ? !!e.updateTime && this.updateTime.isEqual(e.updateTime) : !e.updateTime);
    }
}
/** Returns true if the preconditions is valid for the given document. */ function __PRIVATE_preconditionIsValidForDocument(e, t) {
    return void 0 !== e.updateTime ? t.isFoundDocument() && t.version.isEqual(e.updateTime) : void 0 === e.exists || e.exists === t.isFoundDocument();
}
/**
 * A mutation describes a self-contained change to a document. Mutations can
 * create, replace, delete, and update subsets of documents.
 *
 * Mutations not only act on the value of the document but also its version.
 *
 * For local mutations (mutations that haven't been committed yet), we preserve
 * the existing version for Set and Patch mutations. For Delete mutations, we
 * reset the version to 0.
 *
 * Here's the expected transition table.
 *
 * MUTATION           APPLIED TO            RESULTS IN
 *
 * SetMutation        Document(v3)          Document(v3)
 * SetMutation        NoDocument(v3)        Document(v0)
 * SetMutation        InvalidDocument(v0)   Document(v0)
 * PatchMutation      Document(v3)          Document(v3)
 * PatchMutation      NoDocument(v3)        NoDocument(v3)
 * PatchMutation      InvalidDocument(v0)   UnknownDocument(v3)
 * DeleteMutation     Document(v3)          NoDocument(v0)
 * DeleteMutation     NoDocument(v3)        NoDocument(v0)
 * DeleteMutation     InvalidDocument(v0)   NoDocument(v0)
 *
 * For acknowledged mutations, we use the updateTime of the WriteResponse as
 * the resulting version for Set and Patch mutations. As deletes have no
 * explicit update time, we use the commitTime of the WriteResponse for
 * Delete mutations.
 *
 * If a mutation is acknowledged by the backend but fails the precondition check
 * locally, we transition to an `UnknownDocument` and rely on Watch to send us
 * the updated version.
 *
 * Field transforms are used only with Patch and Set Mutations. We use the
 * `updateTransforms` message to store transforms, rather than the `transforms`s
 * messages.
 *
 * ## Subclassing Notes
 *
 * Every type of mutation needs to implement its own applyToRemoteDocument() and
 * applyToLocalView() to implement the actual behavior of applying the mutation
 * to some source document (see `setMutationApplyToRemoteDocument()` for an
 * example).
 */ class Mutation {
}
/**
 * A utility method to calculate a `Mutation` representing the overlay from the
 * final state of the document, and a `FieldMask` representing the fields that
 * are mutated by the local mutations.
 */ function __PRIVATE_calculateOverlayMutation(e, t) {
    if (!e.hasLocalMutations || t && 0 === t.fields.length) return null;
    // mask is null when sets or deletes are applied to the current document.
    if (null === t) return e.isNoDocument() ? new __PRIVATE_DeleteMutation(e.key, Precondition.none()) : new __PRIVATE_SetMutation(e.key, e.data, Precondition.none());
    {
        const n = e.data, r = ObjectValue.empty();
        let i = new SortedSet(FieldPath$1.comparator);
        for (let e of t.fields)if (!i.has(e)) {
            let t = n.field(e);
            // If we are deleting a nested field, we take the immediate parent as
            // the mask used to construct the resulting mutation.
            // Justification: Nested fields can create parent fields implicitly. If
            // only a leaf entry is deleted in later mutations, the parent field
            // should still remain, but we may have lost this information.
            // Consider mutation (foo.bar 1), then mutation (foo.bar delete()).
            // This leaves the final result (foo, {}). Despite the fact that `doc`
            // has the correct result, `foo` is not in `mask`, and the resulting
            // mutation would miss `foo`.
            null === t && e.length > 1 && (e = e.popLast(), t = n.field(e)), null === t ? r.delete(e) : r.set(e, t), i = i.add(e);
        }
        return new __PRIVATE_PatchMutation(e.key, r, new FieldMask(i.toArray()), Precondition.none());
    }
}
/**
 * Applies this mutation to the given document for the purposes of computing a
 * new remote document. If the input document doesn't match the expected state
 * (e.g. it is invalid or outdated), the document type may transition to
 * unknown.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param mutationResult - The result of applying the mutation from the backend.
 */ function __PRIVATE_mutationApplyToRemoteDocument(e, t, n) {
    e instanceof __PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToRemoteDocument(e, t, n) {
        // Unlike setMutationApplyToLocalView, if we're applying a mutation to a
        // remote document the server has accepted the mutation so the precondition
        // must have held.
        const r = e.value.clone(), i = __PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults);
        r.setAll(i), t.convertToFoundDocument(n.version, r).setHasCommittedMutations();
    }(e, t, n) : e instanceof __PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToRemoteDocument(e, t, n) {
        if (!__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // Since the mutation was not rejected, we know that the precondition
        // matched on the backend. We therefore must not have the expected version
        // of the document in our cache and convert to an UnknownDocument with a
        // known updateTime.
        return void t.convertToUnknownDocument(n.version);
        const r = __PRIVATE_serverTransformResults(e.fieldTransforms, t, n.transformResults), i = t.data;
        i.setAll(__PRIVATE_getPatch(e)), i.setAll(r), t.convertToFoundDocument(n.version, i).setHasCommittedMutations();
    }(e, t, n) : function __PRIVATE_deleteMutationApplyToRemoteDocument(e, t, n) {
        // Unlike applyToLocalView, if we're applying a mutation to a remote
        // document the server has accepted the mutation so the precondition must
        // have held.
        t.convertToNoDocument(n.version).setHasCommittedMutations();
    }(0, t, n);
}
/**
 * Applies this mutation to the given document for the purposes of computing
 * the new local view of a document. If the input document doesn't match the
 * expected state, the document is not modified.
 *
 * @param mutation - The mutation to apply.
 * @param document - The document to mutate. The input document can be an
 *     invalid document if the client has no knowledge of the pre-mutation state
 *     of the document.
 * @param previousMask - The fields that have been updated before applying this mutation.
 * @param localWriteTime - A timestamp indicating the local write time of the
 *     batch this mutation is a part of.
 * @returns A `FieldMask` representing the fields that are changed by applying this mutation.
 */ function __PRIVATE_mutationApplyToLocalView(e, t, n, r) {
    return e instanceof __PRIVATE_SetMutation ? function __PRIVATE_setMutationApplyToLocalView(e, t, n, r) {
        if (!__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) // The mutation failed to apply (e.g. a document ID created with add()
        // caused a name collision).
        return n;
        const i = e.value.clone(), s = __PRIVATE_localTransformResults(e.fieldTransforms, r, t);
        return i.setAll(s), t.convertToFoundDocument(t.version, i).setHasLocalMutations(), null;
    // SetMutation overwrites all fields.
    }(e, t, n, r) : e instanceof __PRIVATE_PatchMutation ? function __PRIVATE_patchMutationApplyToLocalView(e, t, n, r) {
        if (!__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return n;
        const i = __PRIVATE_localTransformResults(e.fieldTransforms, r, t), s = t.data;
        if (s.setAll(__PRIVATE_getPatch(e)), s.setAll(i), t.convertToFoundDocument(t.version, s).setHasLocalMutations(), null === n) return null;
        return n.unionWith(e.fieldMask.fields).unionWith(e.fieldTransforms.map((e)=>e.field));
    }(e, t, n, r) : function __PRIVATE_deleteMutationApplyToLocalView(e, t, n) {
        if (__PRIVATE_preconditionIsValidForDocument(e.precondition, t)) return t.convertToNoDocument(t.version).setHasLocalMutations(), null;
        return n;
    }(e, t, n);
}
/**
 * If this mutation is not idempotent, returns the base value to persist with
 * this mutation. If a base value is returned, the mutation is always applied
 * to this base value, even if document has already been updated.
 *
 * The base value is a sparse object that consists of only the document
 * fields for which this mutation contains a non-idempotent transformation
 * (e.g. a numeric increment). The provided value guarantees consistent
 * behavior for non-idempotent transforms and allow us to return the same
 * latency-compensated value even if the backend has already applied the
 * mutation. The base value is null for idempotent mutations, as they can be
 * re-played even if the backend has already applied them.
 *
 * @returns a base value to store along with the mutation, or null for
 * idempotent mutations.
 */ function __PRIVATE_mutationExtractBaseValue(e, t) {
    let n = null;
    for (const r of e.fieldTransforms){
        const e = t.data.field(r.field), i = __PRIVATE_computeTransformOperationBaseValue(r.transform, e || null);
        null != i && (null === n && (n = ObjectValue.empty()), n.set(r.field, i));
    }
    return n || null;
}
function __PRIVATE_mutationEquals(e, t) {
    return e.type === t.type && !!e.key.isEqual(t.key) && !!e.precondition.isEqual(t.precondition) && !!function __PRIVATE_fieldTransformsAreEqual(e, t) {
        return void 0 === e && void 0 === t || !(!e || !t) && __PRIVATE_arrayEquals(e, t, (e, t)=>__PRIVATE_fieldTransformEquals(e, t));
    }(e.fieldTransforms, t.fieldTransforms) && (0 /* MutationType.Set */  === e.type ? e.value.isEqual(t.value) : 1 /* MutationType.Patch */  !== e.type || e.data.isEqual(t.data) && e.fieldMask.isEqual(t.fieldMask));
}
/**
 * A mutation that creates or replaces the document at the given key with the
 * object value contents.
 */ class __PRIVATE_SetMutation extends Mutation {
    constructor(e, t, n, r = []){
        super(), this.key = e, this.value = t, this.precondition = n, this.fieldTransforms = r, this.type = 0 /* MutationType.Set */ ;
    }
    getFieldMask() {
        return null;
    }
}
class __PRIVATE_PatchMutation extends Mutation {
    constructor(e, t, n, r, i = []){
        super(), this.key = e, this.data = t, this.fieldMask = n, this.precondition = r, this.fieldTransforms = i, this.type = 1 /* MutationType.Patch */ ;
    }
    getFieldMask() {
        return this.fieldMask;
    }
}
function __PRIVATE_getPatch(e) {
    const t = new Map;
    return e.fieldMask.fields.forEach((n)=>{
        if (!n.isEmpty()) {
            const r = e.data.field(n);
            t.set(n, r);
        }
    }), t;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use after a mutation
 * containing transforms has been acknowledged by the server.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param mutableDocument - The current state of the document after applying all
 * previous mutations.
 * @param serverTransformResults - The transform results received by the server.
 * @returns The transform results list.
 */ function __PRIVATE_serverTransformResults(e, t, n) {
    const r = new Map;
    __PRIVATE_hardAssert(e.length === n.length, 32656, {
        Ie: n.length,
        Ae: e.length
    });
    for(let i = 0; i < n.length; i++){
        const s = e[i], _ = s.transform, o = t.data.field(s.field);
        r.set(s.field, __PRIVATE_applyTransformOperationToRemoteDocument(_, o, n[i]));
    }
    return r;
}
/**
 * Creates a list of "transform results" (a transform result is a field value
 * representing the result of applying a transform) for use when applying a
 * transform locally.
 *
 * @param fieldTransforms - The field transforms to apply the result to.
 * @param localWriteTime - The local time of the mutation (used to
 *     generate ServerTimestampValues).
 * @param mutableDocument - The document to apply transforms on.
 * @returns The transform results list.
 */ function __PRIVATE_localTransformResults(e, t, n) {
    const r = new Map;
    for (const i of e){
        const e = i.transform, s = n.data.field(i.field);
        r.set(i.field, __PRIVATE_applyTransformOperationToLocalView(e, s, t));
    }
    return r;
}
/** A mutation that deletes the document at the given key. */ class __PRIVATE_DeleteMutation extends Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 2 /* MutationType.Delete */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
class __PRIVATE_VerifyMutation extends Mutation {
    constructor(e, t){
        super(), this.key = e, this.precondition = t, this.type = 3 /* MutationType.Verify */ , this.fieldTransforms = [];
    }
    getFieldMask() {
        return null;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Concrete implementation of the Aggregate type.
 */ class __PRIVATE_AggregateImpl {
    constructor(e, t, n){
        this.alias = e, this.aggregateType = t, this.fieldPath = n;
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a bound of a query.
 *
 * The bound is specified with the given components representing a position and
 * whether it's just before or just after the position (relative to whatever the
 * query order is).
 *
 * The position represents a logical index position for a query. It's a prefix
 * of values for the (potentially implicit) order by clauses of a query.
 *
 * Bound provides a function to determine whether a document comes before or
 * after a bound. This is influenced by whether the position is just before or
 * just after the provided values.
 */ class Bound {
    constructor(e, t){
        this.position = e, this.inclusive = t;
    }
}
function __PRIVATE_boundCompareToDocument(e, t, n) {
    let r = 0;
    for(let i = 0; i < e.position.length; i++){
        const s = t[i], _ = e.position[i];
        if (s.field.isKeyField()) r = DocumentKey.comparator(DocumentKey.fromName(_.referenceValue), n.key);
        else r = __PRIVATE_valueCompare(_, n.data.field(s.field));
        if ("desc" /* Direction.DESCENDING */  === s.dir && (r *= -1), 0 !== r) break;
    }
    return r;
}
/**
 * Returns true if a document sorts after a bound using the provided sort
 * order.
 */ function __PRIVATE_boundEquals(e, t) {
    if (null === e) return null === t;
    if (null === t) return !1;
    if (e.inclusive !== t.inclusive || e.position.length !== t.position.length) return !1;
    for(let n = 0; n < e.position.length; n++){
        if (!__PRIVATE_valueEquals$1(e.position[n], t.position[n])) return !1;
    }
    return !0;
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class Filter {
}
class FieldFilter extends Filter {
    constructor(e, t, n){
        super(), this.field = e, this.op = t, this.value = n;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t, n) {
        return e.isKeyField() ? "in" /* Operator.IN */  === t || "not-in" /* Operator.NOT_IN */  === t ? this.createKeyFieldInFilter(e, t, n) : new __PRIVATE_KeyFieldFilter(e, t, n) : "array-contains" /* Operator.ARRAY_CONTAINS */  === t ? new __PRIVATE_ArrayContainsFilter(e, n) : "in" /* Operator.IN */  === t ? new __PRIVATE_InFilter(e, n) : "not-in" /* Operator.NOT_IN */  === t ? new __PRIVATE_NotInFilter(e, n) : "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === t ? new __PRIVATE_ArrayContainsAnyFilter(e, n) : new FieldFilter(e, t, n);
    }
    static createKeyFieldInFilter(e, t, n) {
        return "in" /* Operator.IN */  === t ? new __PRIVATE_KeyFieldInFilter(e, n) : new __PRIVATE_KeyFieldNotInFilter(e, n);
    }
    matches(e) {
        const t = e.data.field(this.field);
        // Types do not have to match in NOT_EQUAL filters.
        return "!=" /* Operator.NOT_EQUAL */  === this.op ? null !== t && void 0 === t.nullValue && this.matchesComparison(__PRIVATE_valueCompare(t, this.value)) : null !== t && __PRIVATE_typeOrder(this.value) === __PRIVATE_typeOrder(t) && this.matchesComparison(__PRIVATE_valueCompare(t, this.value));
    // Only compare types with matching backend order (such as double and int).
    }
    matchesComparison(e) {
        switch(this.op){
            case "<" /* Operator.LESS_THAN */ :
                return e < 0;
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return e <= 0;
            case "==" /* Operator.EQUAL */ :
                return 0 === e;
            case "!=" /* Operator.NOT_EQUAL */ :
                return 0 !== e;
            case ">" /* Operator.GREATER_THAN */ :
                return e > 0;
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return e >= 0;
            default:
                return fail(47266, {
                    operator: this.op
                });
        }
    }
    isInequality() {
        return [
            "<" /* Operator.LESS_THAN */ ,
            "<=" /* Operator.LESS_THAN_OR_EQUAL */ ,
            ">" /* Operator.GREATER_THAN */ ,
            ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ,
            "!=" /* Operator.NOT_EQUAL */ ,
            "not-in" /* Operator.NOT_IN */ 
        ].indexOf(this.op) >= 0;
    }
    getFlattenedFilters() {
        return [
            this
        ];
    }
    getFilters() {
        return [
            this
        ];
    }
}
class CompositeFilter extends Filter {
    constructor(e, t){
        super(), this.filters = e, this.op = t, this.Ve = null;
    }
    /**
     * Creates a filter based on the provided arguments.
     */ static create(e, t) {
        return new CompositeFilter(e, t);
    }
    matches(e) {
        return __PRIVATE_compositeFilterIsConjunction(this) ? void 0 === this.filters.find((t)=>!t.matches(e)) : void 0 !== this.filters.find((t)=>t.matches(e));
    }
    getFlattenedFilters() {
        return null !== this.Ve || (this.Ve = this.filters.reduce((e, t)=>e.concat(t.getFlattenedFilters()), [])), this.Ve;
    }
    // Returns a mutable copy of `this.filters`
    getFilters() {
        return Object.assign([], this.filters);
    }
}
function __PRIVATE_compositeFilterIsConjunction(e) {
    return "and" /* CompositeOperator.AND */  === e.op;
}
function __PRIVATE_compositeFilterIsDisjunction(e) {
    return "or" /* CompositeOperator.OR */  === e.op;
}
/**
 * Returns true if this filter is a conjunction of field filters only. Returns false otherwise.
 */ function __PRIVATE_compositeFilterIsFlatConjunction(e) {
    return __PRIVATE_compositeFilterIsFlat(e) && __PRIVATE_compositeFilterIsConjunction(e);
}
/**
 * Returns true if this filter does not contain any composite filters. Returns false otherwise.
 */ function __PRIVATE_compositeFilterIsFlat(e) {
    for (const t of e.filters)if (t instanceof CompositeFilter) return !1;
    return !0;
}
function __PRIVATE_canonifyFilter(e) {
    if (e instanceof FieldFilter) // TODO(b/29183165): Technically, this won't be unique if two values have
    // the same description, such as the int 3 and the string "3". So we should
    // add the types in here somehow, too.
    return e.field.canonicalString() + e.op.toString() + canonicalId(e.value);
    if (__PRIVATE_compositeFilterIsFlatConjunction(e)) // Older SDK versions use an implicit AND operation between their filters.
    // In the new SDK versions, the developer may use an explicit AND filter.
    // To stay consistent with the old usages, we add a special case to ensure
    // the canonical ID for these two are the same. For example:
    // `col.whereEquals("a", 1).whereEquals("b", 2)` should have the same
    // canonical ID as `col.where(and(equals("a",1), equals("b",2)))`.
    return e.filters.map((e)=>__PRIVATE_canonifyFilter(e)).join(",");
    {
        // filter instanceof CompositeFilter
        const t = e.filters.map((e)=>__PRIVATE_canonifyFilter(e)).join(",");
        return `${e.op}(${t})`;
    }
}
function __PRIVATE_filterEquals(e, t) {
    return e instanceof FieldFilter ? function __PRIVATE_fieldFilterEquals(e, t) {
        return t instanceof FieldFilter && e.op === t.op && e.field.isEqual(t.field) && __PRIVATE_valueEquals$1(e.value, t.value);
    }(e, t) : e instanceof CompositeFilter ? function __PRIVATE_compositeFilterEquals(e, t) {
        if (t instanceof CompositeFilter && e.op === t.op && e.filters.length === t.filters.length) return e.filters.reduce((e, n, r)=>e && __PRIVATE_filterEquals(n, t.filters[r]), !0);
        return !1;
    }(e, t) : void fail(19439);
}
function __PRIVATE_compositeFilterWithAddedFilters(e, t) {
    const n = e.filters.concat(t);
    return CompositeFilter.create(n, e.op);
}
/** Returns a debug description for `filter`. */ function __PRIVATE_stringifyFilter(e) {
    return e instanceof FieldFilter ? function __PRIVATE_stringifyFieldFilter(e) {
        return `${e.field.canonicalString()} ${e.op} ${canonicalId(e.value)}`;
    }(e) : e instanceof CompositeFilter ? function __PRIVATE_stringifyCompositeFilter(e) {
        return e.op.toString() + " {" + e.getFilters().map(__PRIVATE_stringifyFilter).join(" ,") + "}";
    }(e) : "Filter";
}
class __PRIVATE_KeyFieldFilter extends FieldFilter {
    constructor(e, t, n){
        super(e, t, n), this.key = DocumentKey.fromName(n.referenceValue);
    }
    matches(e) {
        const t = DocumentKey.comparator(e.key, this.key);
        return this.matchesComparison(t);
    }
}
/** Filter that matches on key fields within an array. */ class __PRIVATE_KeyFieldInFilter extends FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t), this.keys = __PRIVATE_extractDocumentKeysFromArrayValue("in" /* Operator.IN */ , t);
    }
    matches(e) {
        return this.keys.some((t)=>t.isEqual(e.key));
    }
}
/** Filter that matches on key fields not present within an array. */ class __PRIVATE_KeyFieldNotInFilter extends FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t), this.keys = __PRIVATE_extractDocumentKeysFromArrayValue("not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        return !this.keys.some((t)=>t.isEqual(e.key));
    }
}
function __PRIVATE_extractDocumentKeysFromArrayValue(e, t) {
    return (t.arrayValue?.values || []).map((e)=>DocumentKey.fromName(e.referenceValue));
}
/** A Filter that implements the array-contains operator. */ class __PRIVATE_ArrayContainsFilter extends FieldFilter {
    constructor(e, t){
        super(e, "array-contains" /* Operator.ARRAY_CONTAINS */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return isArray(t) && __PRIVATE_arrayValueContains(t.arrayValue, this.value);
    }
}
/** A Filter that implements the IN operator. */ class __PRIVATE_InFilter extends FieldFilter {
    constructor(e, t){
        super(e, "in" /* Operator.IN */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return null !== t && __PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the not-in operator. */ class __PRIVATE_NotInFilter extends FieldFilter {
    constructor(e, t){
        super(e, "not-in" /* Operator.NOT_IN */ , t);
    }
    matches(e) {
        if (__PRIVATE_arrayValueContains(this.value.arrayValue, {
            nullValue: "NULL_VALUE"
        })) return !1;
        const t = e.data.field(this.field);
        return null !== t && void 0 === t.nullValue && !__PRIVATE_arrayValueContains(this.value.arrayValue, t);
    }
}
/** A Filter that implements the array-contains-any operator. */ class __PRIVATE_ArrayContainsAnyFilter extends FieldFilter {
    constructor(e, t){
        super(e, "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ , t);
    }
    matches(e) {
        const t = e.data.field(this.field);
        return !(!isArray(t) || !t.arrayValue.values) && t.arrayValue.values.some((e)=>__PRIVATE_arrayValueContains(this.value.arrayValue, e));
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An ordering on a field, in some Direction. Direction defaults to ASCENDING.
 */ class OrderBy {
    constructor(e, t = "asc" /* Direction.ASCENDING */ ){
        this.field = e, this.dir = t;
    }
}
function __PRIVATE_orderByEquals(e, t) {
    return e.dir === t.dir && e.field.isEqual(t.field);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a document in Firestore with a key, version, data and whether it
 * has local mutations applied to it.
 *
 * Documents can transition between states via `convertToFoundDocument()`,
 * `convertToNoDocument()` and `convertToUnknownDocument()`. If a document does
 * not transition to one of these states even after all mutations have been
 * applied, `isValidDocument()` returns false and the document should be removed
 * from all views.
 */ class MutableDocument {
    constructor(e, t, n, r, i, s, _){
        this.key = e, this.documentType = t, this.version = n, this.readTime = r, this.createTime = i, this.data = s, this.documentState = _;
    }
    /**
     * Creates a document with no known version or data, but which can serve as
     * base document for mutations.
     */ static newInvalidDocument(e) {
        return new MutableDocument(e, 0 /* DocumentType.INVALID */ , /* version */ SnapshotVersion.min(), /* readTime */ SnapshotVersion.min(), /* createTime */ SnapshotVersion.min(), ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist with the given data at the
     * given version.
     */ static newFoundDocument(e, t, n, r) {
        return new MutableDocument(e, 1 /* DocumentType.FOUND_DOCUMENT */ , /* version */ t, /* readTime */ SnapshotVersion.min(), /* createTime */ n, r, 0 /* DocumentState.SYNCED */ );
    }
    /** Creates a new document that is known to not exist at the given version. */ static newNoDocument(e, t) {
        return new MutableDocument(e, 2 /* DocumentType.NO_DOCUMENT */ , /* version */ t, /* readTime */ SnapshotVersion.min(), /* createTime */ SnapshotVersion.min(), ObjectValue.empty(), 0 /* DocumentState.SYNCED */ );
    }
    /**
     * Creates a new document that is known to exist at the given version but
     * whose data is not known (e.g. a document that was updated without a known
     * base document).
     */ static newUnknownDocument(e, t) {
        return new MutableDocument(e, 3 /* DocumentType.UNKNOWN_DOCUMENT */ , /* version */ t, /* readTime */ SnapshotVersion.min(), /* createTime */ SnapshotVersion.min(), ObjectValue.empty(), 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ );
    }
    /**
     * Changes the document type to indicate that it exists and that its version
     * and data are known.
     */ convertToFoundDocument(e, t) {
        // If a document is switching state from being an invalid or deleted
        // document to a valid (FOUND_DOCUMENT) document, either due to receiving an
        // update from Watch or due to applying a local set mutation on top
        // of a deleted document, our best guess about its createTime would be the
        // version at which the document transitioned to a FOUND_DOCUMENT.
        return !this.createTime.isEqual(SnapshotVersion.min()) || 2 /* DocumentType.NO_DOCUMENT */  !== this.documentType && 0 /* DocumentType.INVALID */  !== this.documentType || (this.createTime = e), this.version = e, this.documentType = 1 /* DocumentType.FOUND_DOCUMENT */ , this.data = t, this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it doesn't exist at the given
     * version.
     */ convertToNoDocument(e) {
        return this.version = e, this.documentType = 2 /* DocumentType.NO_DOCUMENT */ , this.data = ObjectValue.empty(), this.documentState = 0 /* DocumentState.SYNCED */ , this;
    }
    /**
     * Changes the document type to indicate that it exists at a given version but
     * that its data is not known (e.g. a document that was updated without a known
     * base document).
     */ convertToUnknownDocument(e) {
        return this.version = e, this.documentType = 3 /* DocumentType.UNKNOWN_DOCUMENT */ , this.data = ObjectValue.empty(), this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasCommittedMutations() {
        return this.documentState = 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */ , this;
    }
    setHasLocalMutations() {
        return this.documentState = 1 /* DocumentState.HAS_LOCAL_MUTATIONS */ , this.version = SnapshotVersion.min(), this;
    }
    setReadTime(e) {
        return this.readTime = e, this;
    }
    get hasLocalMutations() {
        return 1 /* DocumentState.HAS_LOCAL_MUTATIONS */  === this.documentState;
    }
    get hasCommittedMutations() {
        return 2 /* DocumentState.HAS_COMMITTED_MUTATIONS */  === this.documentState;
    }
    get hasPendingWrites() {
        return this.hasLocalMutations || this.hasCommittedMutations;
    }
    isValidDocument() {
        return 0 /* DocumentType.INVALID */  !== this.documentType;
    }
    isFoundDocument() {
        return 1 /* DocumentType.FOUND_DOCUMENT */  === this.documentType;
    }
    isNoDocument() {
        return 2 /* DocumentType.NO_DOCUMENT */  === this.documentType;
    }
    isUnknownDocument() {
        return 3 /* DocumentType.UNKNOWN_DOCUMENT */  === this.documentType;
    }
    isEqual(e) {
        return e instanceof MutableDocument && this.key.isEqual(e.key) && this.version.isEqual(e.version) && this.documentType === e.documentType && this.documentState === e.documentState && this.data.isEqual(e.data);
    }
    mutableCopy() {
        return new MutableDocument(this.key, this.documentType, this.version, this.readTime, this.createTime, this.data.clone(), this.documentState);
    }
    toString() {
        return `Document(${this.key}, ${this.version}, ${JSON.stringify(this.data.value)}, {createTime: ${this.createTime}}), {documentType: ${this.documentType}}), {documentState: ${this.documentState}})`;
    }
}
/**
 * Compares the value for field `field` in the provided documents. Throws if
 * the field does not exist in both documents.
 */ /**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Visible for testing
class __PRIVATE_TargetImpl {
    constructor(e, t = null, n = [], r = [], i = null, s = null, _ = null){
        this.path = e, this.collectionGroup = t, this.orderBy = n, this.filters = r, this.limit = i, this.startAt = s, this.endAt = _, this.de = null;
    }
}
/**
 * Initializes a Target with a path and optional additional query constraints.
 * Path must currently be empty if this is a collection group query.
 *
 * NOTE: you should always construct `Target` from `Query.toTarget` instead of
 * using this factory method, because `Query` provides an implicit `orderBy`
 * property.
 */ function __PRIVATE_newTarget(e, t = null, n = [], r = [], i = null, s = null, _ = null) {
    return new __PRIVATE_TargetImpl(e, t, n, r, i, s, _);
}
function __PRIVATE_canonifyTarget(e) {
    const t = __PRIVATE_debugCast(e);
    if (null === t.de) {
        let e = t.path.canonicalString();
        null !== t.collectionGroup && (e += "|cg:" + t.collectionGroup), e += "|f:", e += t.filters.map((e)=>__PRIVATE_canonifyFilter(e)).join(","), e += "|ob:", e += t.orderBy.map((e)=>(function __PRIVATE_canonifyOrderBy(e) {
                // TODO(b/29183165): Make this collision robust.
                return e.field.canonicalString() + e.dir;
            })(e)).join(","), __PRIVATE_isNullOrUndefined(t.limit) || (e += "|l:", e += t.limit), t.startAt && (e += "|lb:", e += t.startAt.inclusive ? "b:" : "a:", e += t.startAt.position.map((e)=>canonicalId(e)).join(",")), t.endAt && (e += "|ub:", e += t.endAt.inclusive ? "a:" : "b:", e += t.endAt.position.map((e)=>canonicalId(e)).join(",")), t.de = e;
    }
    return t.de;
}
function __PRIVATE_targetEquals(e, t) {
    if (e.limit !== t.limit) return !1;
    if (e.orderBy.length !== t.orderBy.length) return !1;
    for(let n = 0; n < e.orderBy.length; n++)if (!__PRIVATE_orderByEquals(e.orderBy[n], t.orderBy[n])) return !1;
    if (e.filters.length !== t.filters.length) return !1;
    for(let n = 0; n < e.filters.length; n++)if (!__PRIVATE_filterEquals(e.filters[n], t.filters[n])) return !1;
    return e.collectionGroup === t.collectionGroup && !!e.path.isEqual(t.path) && !!__PRIVATE_boundEquals(e.startAt, t.startAt) && __PRIVATE_boundEquals(e.endAt, t.endAt);
}
function __PRIVATE_targetIsPipelineTarget(e) {
    // Workaround for circular dependency
    return !!e.isCorePipeline;
}
function __PRIVATE_targetIsDocumentTarget(e) {
    return !!e.path && DocumentKey.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/** Returns the field filters that target the given field path. */ function __PRIVATE_targetGetFieldFiltersForPath(e, t) {
    return e.filters.filter((e)=>e instanceof FieldFilter && e.field.isEqual(t));
}
/**
 * Returns the values that are used in ARRAY_CONTAINS or ARRAY_CONTAINS_ANY
 * filters. Returns `null` if there are no such filters.
 */ /**
 * Returns the value to use as the lower bound for ascending index segment at
 * the provided `fieldPath` (or the upper bound for an descending segment).
 */ function __PRIVATE_targetGetAscendingBound(e, t, n) {
    let r = lt, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of __PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = lt, t = !0;
        switch(n.op){
            case "<" /* Operator.LESS_THAN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = __PRIVATE_valuesGetLowerBound(n.value);
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case ">" /* Operator.GREATER_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = lt;
        }
        __PRIVATE_lowerBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) < 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            __PRIVATE_lowerBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) < 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/**
 * Returns the value to use as the upper bound for ascending index segment at
 * the provided `fieldPath` (or the lower bound for a descending segment).
 */ function __PRIVATE_targetGetDescendingBound(e, t, n) {
    let r = at, i = !0;
    // Process all filters to find a value for the current field segment
    for (const n of __PRIVATE_targetGetFieldFiltersForPath(e, t)){
        let e = at, t = !0;
        switch(n.op){
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
            case ">" /* Operator.GREATER_THAN */ :
                e = __PRIVATE_valuesGetUpperBound(n.value), t = !1;
                break;
            case "==" /* Operator.EQUAL */ :
            case "in" /* Operator.IN */ :
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                e = n.value;
                break;
            case "<" /* Operator.LESS_THAN */ :
                e = n.value, t = !1;
                break;
            case "!=" /* Operator.NOT_EQUAL */ :
            case "not-in" /* Operator.NOT_IN */ :
                e = at;
        }
        __PRIVATE_upperBoundCompare({
            value: r,
            inclusive: i
        }, {
            value: e,
            inclusive: t
        }) > 0 && (r = e, i = t);
    }
    // If there is an additional bound, compare the values against the existing
    // range to see if we can narrow the scope.
    if (null !== n) {
        for(let s = 0; s < e.orderBy.length; ++s)if (e.orderBy[s].field.isEqual(t)) {
            const e = n.position[s];
            __PRIVATE_upperBoundCompare({
                value: r,
                inclusive: i
            }, {
                value: e,
                inclusive: n.inclusive
            }) > 0 && (r = e, i = n.inclusive);
            break;
        }
    }
    return {
        value: r,
        inclusive: i
    };
}
/** Returns the number of segments of a perfect index for this target. */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Query encapsulates all the query attributes we support in the SDK. It can
 * be run against the LocalStore, as well as be converted to a `Target` to
 * query the RemoteStore results.
 *
 * Visible for testing.
 */ class __PRIVATE_QueryImpl {
    /**
     * Initializes a Query with a path and optional additional query constraints.
     * Path must currently be empty if this is a collection group query.
     */ constructor(e, t = null, n = [], r = [], i = null, s = "F" /* LimitType.First */ , _ = null, o = null){
        this.path = e, this.collectionGroup = t, this.explicitOrderBy = n, this.filters = r, this.limit = i, this.limitType = s, this.startAt = _, this.endAt = o, this.fe = null, // The corresponding `Target` of this `Query` instance, for use with
        // non-aggregate queries.
        this.me = null, // The corresponding `Target` of this `Query` instance, for use with
        // aggregate queries. Unlike targets for non-aggregate queries,
        // aggregate query targets do not contain normalized order-bys, they only
        // contain explicit order-bys.
        this.pe = null, this.startAt, this.endAt;
    }
}
/** Creates a new Query instance with the options provided. */ function __PRIVATE_newQuery(e, t, n, r, i, s, _, o) {
    return new __PRIVATE_QueryImpl(e, t, n, r, i, s, _, o);
}
/** Creates a new Query for a query that matches all documents at `path` */ function __PRIVATE_newQueryForPath(e) {
    return new __PRIVATE_QueryImpl(e);
}
/**
 * Helper to convert a collection group query into a collection query at a
 * specific path. This is used when executing collection group queries, since
 * we have to split the query into a set of collection queries at multiple
 * paths.
 */ /**
 * Returns true if this query does not specify any query constraints that
 * could remove results.
 */ function __PRIVATE_queryMatchesAllDocuments(e) {
    return 0 === e.filters.length && null === e.limit && null == e.startAt && null == e.endAt && (0 === e.explicitOrderBy.length || 1 === e.explicitOrderBy.length && e.explicitOrderBy[0].field.isKeyField());
}
// Returns the sorted set of inequality filter fields used in this query.
/**
 * Returns whether the query matches a single document by path (rather than a
 * collection).
 */ function __PRIVATE_isDocumentQuery$1(e) {
    return DocumentKey.isDocumentKey(e.path) && null === e.collectionGroup && 0 === e.filters.length;
}
/**
 * Returns whether the query matches a collection group rather than a specific
 * collection.
 */ function __PRIVATE_isCollectionGroupQuery(e) {
    return null !== e.collectionGroup;
}
/**
 * Returns the normalized order-by constraint that is used to execute the Query,
 * which can be different from the order-by constraints the user provided (e.g.
 * the SDK and backend always orders by `__name__`). The normalized order-by
 * includes implicit order-bys in addition to the explicit user provided
 * order-bys.
 */ function __PRIVATE_queryNormalizedOrderBy(e) {
    const t = __PRIVATE_debugCast(e);
    if (null === t.fe) {
        t.fe = [];
        const e = new Set;
        // Any explicit order by fields should be added as is.
        for (const n of t.explicitOrderBy)t.fe.push(n), e.add(n.field.canonicalString());
        // The order of the implicit ordering always matches the last explicit order by.
        const n = t.explicitOrderBy.length > 0 ? t.explicitOrderBy[t.explicitOrderBy.length - 1].dir : "asc" /* Direction.ASCENDING */ , r = function __PRIVATE_getInequalityFilterFields(e) {
            let t = new SortedSet(FieldPath$1.comparator);
            return e.filters.forEach((e)=>{
                e.getFlattenedFilters().forEach((e)=>{
                    e.isInequality() && (t = t.add(e.field));
                });
            }), t;
        }(t);
        // Any inequality fields not explicitly ordered should be implicitly ordered in a lexicographical
        // order. When there are multiple inequality filters on the same field, the field should be added
        // only once.
        // Note: `SortedSet<FieldPath>` sorts the key field before other fields. However, we want the key
        // field to be sorted last.
        r.forEach((r)=>{
            e.has(r.canonicalString()) || r.isKeyField() || t.fe.push(new OrderBy(r, n));
        }), // Add the document key field to the last if it is not explicitly ordered.
        e.has(FieldPath$1.keyField().canonicalString()) || t.fe.push(new OrderBy(FieldPath$1.keyField(), n));
    }
    return t.fe;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation.
 */ function __PRIVATE_queryToTarget(e) {
    const t = __PRIVATE_debugCast(e);
    return t.me || (t.me = __PRIVATE__queryToTarget(t, __PRIVATE_queryNormalizedOrderBy(e))), t.me;
}
/**
 * Converts this `Query` instance to its corresponding `Target` representation,
 * for use within an aggregate query. Unlike targets for non-aggregate queries,
 * aggregate query targets do not contain normalized order-bys, they only
 * contain explicit order-bys.
 */ function __PRIVATE_queryToAggregateTarget(e) {
    const t = __PRIVATE_debugCast(e);
    return t.pe || // Do not include implicit order-bys for aggregate queries.
    (t.pe = __PRIVATE__queryToTarget(t, e.explicitOrderBy)), t.pe;
}
function __PRIVATE__queryToTarget(e, t) {
    if ("F" /* LimitType.First */  === e.limitType) return __PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, e.startAt, e.endAt);
    {
        // Flip the orderBy directions since we want the last results
        t = t.map((e)=>{
            const t = "desc" /* Direction.DESCENDING */  === e.dir ? "asc" /* Direction.ASCENDING */  : "desc" /* Direction.DESCENDING */ ;
            return new OrderBy(e.field, t);
        });
        // We need to swap the cursors to match the now-flipped query ordering.
        const n = e.endAt ? new Bound(e.endAt.position, e.endAt.inclusive) : null, r = e.startAt ? new Bound(e.startAt.position, e.startAt.inclusive) : null;
        // Now return as a LimitType.First query.
        return __PRIVATE_newTarget(e.path, e.collectionGroup, t, e.filters, e.limit, n, r);
    }
}
function __PRIVATE_queryWithAddedFilter(e, t) {
    const n = e.filters.concat([
        t
    ]);
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), n, e.limit, e.limitType, e.startAt, e.endAt);
}
function __PRIVATE_queryWithAddedOrderBy(e, t) {
    // TODO(dimond): validate that orderBy does not list the same key twice.
    const n = e.explicitOrderBy.concat([
        t
    ]);
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, n, e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
}
function __PRIVATE_queryWithLimit(e, t, n) {
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), t, n, e.startAt, e.endAt);
}
function __PRIVATE_queryWithStartAt(e, t) {
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, t, e.endAt);
}
function __PRIVATE_queryWithEndAt(e, t) {
    return new __PRIVATE_QueryImpl(e.path, e.collectionGroup, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, t);
}
function __PRIVATE_queryEquals(e, t) {
    return __PRIVATE_targetEquals(__PRIVATE_queryToTarget(e), __PRIVATE_queryToTarget(t)) && e.limitType === t.limitType;
}
// TODO(b/29183165): This is used to get a unique string from a query to, for
// example, use as a dictionary key, but the implementation is subject to
// collisions. Make it collision-free.
function __PRIVATE_stringifyQuery(e) {
    return `Query(target=${function __PRIVATE_stringifyTarget(e) {
        let t = e.path.canonicalString();
        return null !== e.collectionGroup && (t += " collectionGroup=" + e.collectionGroup), e.filters.length > 0 && (t += `, filters: [${e.filters.map((e)=>__PRIVATE_stringifyFilter(e)).join(", ")}]`), __PRIVATE_isNullOrUndefined(e.limit) || (t += ", limit: " + e.limit), e.orderBy.length > 0 && (t += `, orderBy: [${e.orderBy.map((e)=>(function __PRIVATE_stringifyOrderBy(e) {
                return `${e.field.canonicalString()} (${e.dir})`;
            })(e)).join(", ")}]`), e.startAt && (t += ", startAt: ", t += e.startAt.inclusive ? "b:" : "a:", t += e.startAt.position.map((e)=>canonicalId(e)).join(",")), e.endAt && (t += ", endAt: ", t += e.endAt.inclusive ? "a:" : "b:", t += e.endAt.position.map((e)=>canonicalId(e)).join(",")), `Target(${t})`;
    }(__PRIVATE_queryToTarget(e))}; limitType=${e.limitType})`;
}
/** Returns whether `doc` matches the constraints of `query`. */ function __PRIVATE_queryMatches(e, t) {
    return t.isFoundDocument() && function __PRIVATE_queryMatchesPathAndCollectionGroup(e, t) {
        const n = t.key.path;
        return null !== e.collectionGroup ? t.key.hasCollectionId(e.collectionGroup) && e.path.isPrefixOf(n) : DocumentKey.isDocumentKey(e.path) ? e.path.isEqual(n) : e.path.isImmediateParentOf(n);
    }(e, t) && function __PRIVATE_queryMatchesOrderBy(e, t) {
        // We must use `queryNormalizedOrderBy()` to get the list of all orderBys (both implicit and explicit).
        // Note that for OR queries, orderBy applies to all disjunction terms and implicit orderBys must
        // be taken into account. For example, the query "a > 1 || b==1" has an implicit "orderBy a" due
        // to the inequality, and is evaluated as "a > 1 orderBy a || b==1 orderBy a".
        // A document with content of {b:1} matches the filters, but does not match the orderBy because
        // it's missing the field 'a'.
        for (const n of __PRIVATE_queryNormalizedOrderBy(e))// order-by key always matches
        if (!n.field.isKeyField() && null === t.data.field(n.field)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesFilters(e, t) {
        for (const n of e.filters)if (!n.matches(t)) return !1;
        return !0;
    }(e, t) && function __PRIVATE_queryMatchesBounds(e, t) {
        if (e.startAt && !/**
 * Returns true if a document sorts before a bound using the provided sort
 * order.
 */ function __PRIVATE_boundSortsBeforeDocument(e, t, n) {
            const r = __PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r <= 0 : r < 0;
        }(e.startAt, __PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        if (e.endAt && !function __PRIVATE_boundSortsAfterDocument(e, t, n) {
            const r = __PRIVATE_boundCompareToDocument(e, t, n);
            return e.inclusive ? r >= 0 : r > 0;
        }(e.endAt, __PRIVATE_queryNormalizedOrderBy(e), t)) return !1;
        return !0;
    }(e, t);
}
/**
 * Returns a new comparator function that can be used to compare two documents
 * based on the Query's ordering constraint.
 */ function __PRIVATE_newQueryComparator(e) {
    return (t, n)=>{
        let r = !1;
        for (const i of __PRIVATE_queryNormalizedOrderBy(e)){
            const e = __PRIVATE_compareDocs(i, t, n);
            if (0 !== e) return e;
            r = r || i.field.isKeyField();
        }
        return 0;
    };
}
function __PRIVATE_compareDocs(e, t, n) {
    const r = e.field.isKeyField() ? DocumentKey.comparator(t.key, n.key) : function __PRIVATE_compareDocumentsByField(e, t, n) {
        const r = t.data.field(e), i = n.data.field(e);
        return null !== r && null !== i ? __PRIVATE_valueCompare(r, i) : fail(42886);
    }(e.field, t, n);
    switch(e.dir){
        case "asc" /* Direction.ASCENDING */ :
            return r;
        case "desc" /* Direction.DESCENDING */ :
            return -1 * r;
        default:
            return fail(19790, {
                direction: e.dir
            });
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class ExistenceFilter {
    constructor(e, t){
        this.count = e, this.unchangedNames = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Error Codes describing the different ways GRPC can fail. These are copied
 * directly from GRPC's sources here:
 *
 * https://github.com/grpc/grpc/blob/bceec94ea4fc5f0085d81235d8e1c06798dc341a/include/grpc%2B%2B/impl/codegen/status_code_enum.h
 *
 * Important! The names of these identifiers matter because the string forms
 * are used for reverse lookups from the webchannel stream. Do NOT change the
 * names of these identifiers or change this into a const enum.
 */ var Pt, Rt;
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a non-write operation.
 *
 * See isPermanentWriteError for classifying write errors.
 */ function __PRIVATE_isPermanentError(e) {
    switch(e){
        case D.OK:
            return fail(64938);
        case D.CANCELLED:
        case D.UNKNOWN:
        case D.DEADLINE_EXCEEDED:
        case D.RESOURCE_EXHAUSTED:
        case D.INTERNAL:
        case D.UNAVAILABLE:
        // Unauthenticated means something went wrong with our token and we need
        // to retry with new credentials which will happen automatically.
        case D.UNAUTHENTICATED:
            return !1;
        case D.INVALID_ARGUMENT:
        case D.NOT_FOUND:
        case D.ALREADY_EXISTS:
        case D.PERMISSION_DENIED:
        case D.FAILED_PRECONDITION:
        // Aborted might be retried in some scenarios, but that is dependent on
        // the context and should handled individually by the calling code.
        // See https://cloud.google.com/apis/design/errors.
        case D.ABORTED:
        case D.OUT_OF_RANGE:
        case D.UNIMPLEMENTED:
        case D.DATA_LOSS:
            return !0;
        default:
            return fail(15467, {
                code: e
            });
    }
}
/**
 * Determines whether an error code represents a permanent error when received
 * in response to a write operation.
 *
 * Write operations must be handled specially because as of b/119437764, ABORTED
 * errors on the write stream should be retried too (even though ABORTED errors
 * are not generally retryable).
 *
 * Note that during the initial handshake on the write stream an ABORTED error
 * signals that we should discard our stream token (i.e. it is permanent). This
 * means a handshake error should be classified with isPermanentError, above.
 */ /**
 * Maps an error Code from GRPC status code number, like 0, 1, or 14. These
 * are not the same as HTTP status codes.
 *
 * @returns The Code equivalent to the given GRPC status code. Fails if there
 *     is no match.
 */ function __PRIVATE_mapCodeFromRpcCode(e) {
    if (void 0 === e) // This shouldn't normally happen, but in certain error cases (like trying
    // to send invalid proto messages) we may get an error with no GRPC code.
    return __PRIVATE_logError("GRPC error has no .code"), D.UNKNOWN;
    switch(e){
        case Pt.OK:
            return D.OK;
        case Pt.CANCELLED:
            return D.CANCELLED;
        case Pt.UNKNOWN:
            return D.UNKNOWN;
        case Pt.DEADLINE_EXCEEDED:
            return D.DEADLINE_EXCEEDED;
        case Pt.RESOURCE_EXHAUSTED:
            return D.RESOURCE_EXHAUSTED;
        case Pt.INTERNAL:
            return D.INTERNAL;
        case Pt.UNAVAILABLE:
            return D.UNAVAILABLE;
        case Pt.UNAUTHENTICATED:
            return D.UNAUTHENTICATED;
        case Pt.INVALID_ARGUMENT:
            return D.INVALID_ARGUMENT;
        case Pt.NOT_FOUND:
            return D.NOT_FOUND;
        case Pt.ALREADY_EXISTS:
            return D.ALREADY_EXISTS;
        case Pt.PERMISSION_DENIED:
            return D.PERMISSION_DENIED;
        case Pt.FAILED_PRECONDITION:
            return D.FAILED_PRECONDITION;
        case Pt.ABORTED:
            return D.ABORTED;
        case Pt.OUT_OF_RANGE:
            return D.OUT_OF_RANGE;
        case Pt.UNIMPLEMENTED:
            return D.UNIMPLEMENTED;
        case Pt.DATA_LOSS:
            return D.DATA_LOSS;
        default:
            return fail(39323, {
                code: e
            });
    }
}
/**
 * Converts an HTTP response's error status to the equivalent error code.
 *
 * @param status - An HTTP error response status ("FAILED_PRECONDITION",
 * "UNKNOWN", etc.)
 * @returns The equivalent Code. Non-matching responses are mapped to
 *     Code.UNKNOWN.
 */ (Rt = Pt || (Pt = {}))[Rt.OK = 0] = "OK", Rt[Rt.CANCELLED = 1] = "CANCELLED", Rt[Rt.UNKNOWN = 2] = "UNKNOWN", Rt[Rt.INVALID_ARGUMENT = 3] = "INVALID_ARGUMENT", Rt[Rt.DEADLINE_EXCEEDED = 4] = "DEADLINE_EXCEEDED", Rt[Rt.NOT_FOUND = 5] = "NOT_FOUND", Rt[Rt.ALREADY_EXISTS = 6] = "ALREADY_EXISTS", Rt[Rt.PERMISSION_DENIED = 7] = "PERMISSION_DENIED", Rt[Rt.UNAUTHENTICATED = 16] = "UNAUTHENTICATED", Rt[Rt.RESOURCE_EXHAUSTED = 8] = "RESOURCE_EXHAUSTED", Rt[Rt.FAILED_PRECONDITION = 9] = "FAILED_PRECONDITION", Rt[Rt.ABORTED = 10] = "ABORTED", Rt[Rt.OUT_OF_RANGE = 11] = "OUT_OF_RANGE", Rt[Rt.UNIMPLEMENTED = 12] = "UNIMPLEMENTED", Rt[Rt.INTERNAL = 13] = "INTERNAL", Rt[Rt.UNAVAILABLE = 14] = "UNAVAILABLE", Rt[Rt.DATA_LOSS = 15] = "DATA_LOSS";
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A map implementation that uses objects as keys. Objects must have an
 * associated equals function and must be immutable. Entries in the map are
 * stored together with the key being produced from the mapKeyFn. This map
 * automatically handles collisions of keys.
 */ class ObjectMap {
    constructor(e, t){
        this.mapKeyFn = e, this.equalsFn = t, /**
         * The inner map for a key/value pair. Due to the possibility of collisions we
         * keep a list of entries that we do a linear search through to find an actual
         * match. Note that collisions should be rare, so we still expect near
         * constant time lookups in practice.
         */ this.inner = {}, /** The number of entries stored in the map */ this.innerSize = 0;
    }
    /** Get a value for this key, or undefined if it does not exist. */ get(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 !== n) {
            for (const [t, r] of n)if (this.equalsFn(t, e)) return r;
        }
    }
    has(e) {
        return void 0 !== this.get(e);
    }
    /** Put this key and value in the map. */ set(e, t) {
        const n = this.mapKeyFn(e), r = this.inner[n];
        if (void 0 === r) return this.inner[n] = [
            [
                e,
                t
            ]
        ], void this.innerSize++;
        for(let n = 0; n < r.length; n++)if (this.equalsFn(r[n][0], e)) // This is updating an existing entry and does not increase `innerSize`.
        return void (r[n] = [
            e,
            t
        ]);
        r.push([
            e,
            t
        ]), this.innerSize++;
    }
    /**
     * Remove this key from the map. Returns a boolean if anything was deleted.
     */ delete(e) {
        const t = this.mapKeyFn(e), n = this.inner[t];
        if (void 0 === n) return !1;
        for(let r = 0; r < n.length; r++)if (this.equalsFn(n[r][0], e)) return 1 === n.length ? delete this.inner[t] : n.splice(r, 1), this.innerSize--, !0;
        return !1;
    }
    forEach(e) {
        forEach(this.inner, (t, n)=>{
            for (const [t, r] of n)e(t, r);
        });
    }
    isEmpty() {
        return isEmpty(this.inner);
    }
    size() {
        return this.innerSize;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const It = new SortedMap(DocumentKey.comparator);
function __PRIVATE_mutableDocumentMap() {
    return It;
}
const At = new SortedMap(DocumentKey.comparator);
function documentMap(...e) {
    let t = At;
    for (const n of e)t = t.insert(n.key, n);
    return t;
}
function __PRIVATE_convertOverlayedDocumentMapToDocumentMap(e) {
    let t = At;
    return e.forEach((e, n)=>t = t.insert(e, n.overlayedDocument)), t;
}
function __PRIVATE_newOverlayMap() {
    return __PRIVATE_newDocumentKeyMap();
}
function __PRIVATE_newMutationMap() {
    return __PRIVATE_newDocumentKeyMap();
}
function __PRIVATE_newDocumentKeyMap() {
    return new ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
}
const Vt = new SortedMap(DocumentKey.comparator);
const dt = new SortedSet(DocumentKey.comparator);
function __PRIVATE_documentKeySet(...e) {
    let t = dt;
    for (const n of e)t = t.add(n);
    return t;
}
const ft = new SortedSet(__PRIVATE_primitiveComparator);
function __PRIVATE_targetIdSet() {
    return ft;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The global, singleton instance of TestingHooksSpi.
 *
 * This variable will be `null` in all cases _except_ when running from
 * integration tests that have registered callbacks to be notified of events
 * that happen during the test execution.
 */ let mt = null;
/**
 * Sets the value of the `testingHooksSpi` object.
 * @param instance - the instance to set.
 */ function __PRIVATE_setTestingHooksSpi(e) {
    if (mt) throw new Error("a TestingHooksSpi instance is already set");
    mt = e;
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An instance of the Platform's 'TextEncoder' implementation.
 */ function __PRIVATE_newTextEncoder() {
    return new TextEncoder;
}
/**
 * An instance of the Platform's 'TextDecoder' implementation.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const pt = new (0, _bloomBlob.Integer)([
    4294967295,
    4294967295
], 0);
// Hash a string using md5 hashing algorithm.
function __PRIVATE_getMd5HashValue(e) {
    const t = __PRIVATE_newTextEncoder().encode(e), n = new (0, _bloomBlob.Md5);
    return n.update(t), new Uint8Array(n.digest());
}
// Interpret the 16 bytes array as two 64-bit unsigned integers, encoded using
// 2’s complement using little endian.
function __PRIVATE_get64BitUints(e) {
    const t = new DataView(e.buffer), n = t.getUint32(0, /* littleEndian= */ !0), r = t.getUint32(4, /* littleEndian= */ !0), i = t.getUint32(8, /* littleEndian= */ !0), s = t.getUint32(12, /* littleEndian= */ !0);
    return [
        new (0, _bloomBlob.Integer)([
            n,
            r
        ], 0),
        new (0, _bloomBlob.Integer)([
            i,
            s
        ], 0)
    ];
}
class BloomFilter {
    constructor(e, t, n){
        if (this.bitmap = e, this.padding = t, this.hashCount = n, t < 0 || t >= 8) throw new __PRIVATE_BloomFilterError(`Invalid padding: ${t}`);
        if (n < 0) throw new __PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (e.length > 0 && 0 === this.hashCount) // Only empty bloom filter can have 0 hash count.
        throw new __PRIVATE_BloomFilterError(`Invalid hash count: ${n}`);
        if (0 === e.length && 0 !== t) // Empty bloom filter should have 0 padding.
        throw new __PRIVATE_BloomFilterError(`Invalid padding when bitmap length is 0: ${t}`);
        this.ge = 8 * e.length - t, // Set the bit count in Integer to avoid repetition in mightContain().
        this.ye = (0, _bloomBlob.Integer).fromNumber(this.ge);
    }
    // Calculate the ith hash value based on the hashed 64bit integers,
    // and calculate its corresponding bit index in the bitmap to be checked.
    we(e, t, n) {
        // Calculate hashed value h(i) = h1 + (i * h2).
        let r = e.add(t.multiply((0, _bloomBlob.Integer).fromNumber(n)));
        // Wrap if hash value overflow 64bit.
        return 1 === r.compare(pt) && (r = new (0, _bloomBlob.Integer)([
            r.getBits(0),
            r.getBits(1)
        ], 0)), r.modulo(this.ye).toNumber();
    }
    // Return whether the bit on the given index in the bitmap is set to 1.
    be(e) {
        return !!(this.bitmap[Math.floor(e / 8)] & 1 << e % 8);
    }
    mightContain(e) {
        // Empty bitmap should always return false on membership check.
        if (0 === this.ge) return !1;
        const t = __PRIVATE_getMd5HashValue(e), [n, r] = __PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.we(n, r, e);
            if (!this.be(t)) return !1;
        }
        return !0;
    }
    /** Create bloom filter for testing purposes only. */ static create(e, t, n) {
        const r = e % 8 == 0 ? 0 : 8 - e % 8, i = new Uint8Array(Math.ceil(e / 8)), s = new BloomFilter(i, r, t);
        return n.forEach((e)=>s.insert(e)), s;
    }
    insert(e) {
        if (0 === this.ge) return;
        const t = __PRIVATE_getMd5HashValue(e), [n, r] = __PRIVATE_get64BitUints(t);
        for(let e = 0; e < this.hashCount; e++){
            const t = this.we(n, r, e);
            this.ve(t);
        }
    }
    ve(e) {
        const t = Math.floor(e / 8), n = e % 8;
        this.bitmap[t] |= 1 << n;
    }
}
class __PRIVATE_BloomFilterError extends Error {
    constructor(){
        super(...arguments), this.name = "BloomFilterError";
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event from the RemoteStore. It is split into targetChanges (changes to the
 * state or the set of documents in our watched targets) and documentUpdates
 * (changes to the actual documents).
 */ class RemoteEvent {
    constructor(/**
     * The snapshot version this event brings us up to, or MIN if not set.
     */ e, /**
     * A map from target to changes to the target. See TargetChange.
     */ t, /**
     * A map of targets that is known to be inconsistent, and the purpose for
     * re-listening. Listens for these targets should be re-established without
     * resume tokens.
     */ n, /**
     * A set of which documents have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ r, /**
     * A set of which augmented documents (pipeline) have changed or been deleted, along with the
     * doc's new values (if not deleted).
     */ i, /**
     * A set of which document updates are due only to limbo resolution targets.
     */ s){
        this.snapshotVersion = e, this.targetChanges = t, this.targetMismatches = n, this.documentUpdates = r, this.augmentedDocumentUpdates = i, this.resolvedLimboDocuments = s;
    }
    /**
     * HACK: Views require RemoteEvents in order to determine whether the view is
     * CURRENT, but secondary tabs don't receive remote events. So this method is
     * used to create a synthesized RemoteEvent that can be used to apply a
     * CURRENT status change to a View, for queries executed in a different tab.
     */ // PORTING NOTE: Multi-tab only
    static createSynthesizedRemoteEventForCurrentChange(e, t, n) {
        const r = new Map;
        return r.set(e, TargetChange.createSynthesizedTargetChangeForCurrentChange(e, t, n)), new RemoteEvent(SnapshotVersion.min(), r, new SortedMap(__PRIVATE_primitiveComparator), __PRIVATE_mutableDocumentMap(), __PRIVATE_mutableDocumentMap(), __PRIVATE_documentKeySet());
    }
}
/**
 * A TargetChange specifies the set of changes for a specific target as part of
 * a RemoteEvent. These changes track which documents are added, modified or
 * removed, as well as the target's resume token and whether the target is
 * marked CURRENT.
 * The actual changes *to* documents are not part of the TargetChange since
 * documents may be part of multiple targets.
 */ class TargetChange {
    constructor(/**
     * An opaque, server-assigned token that allows watching a query to be resumed
     * after disconnecting without retransmitting all the data that matches the
     * query. The resume token essentially identifies a point in time from which
     * the server should resume sending results.
     */ e, /**
     * The "current" (synced) status of this target. Note that "current"
     * has special meaning in the RPC protocol that implies that a target is
     * both up-to-date and consistent with the rest of the watch stream.
     */ t, /**
     * The set of documents that were newly assigned to this target as part of
     * this remote event.
     */ n, /**
     * The set of documents that were already assigned to this target but received
     * an update during this remote event.
     */ r, /**
     * The set of documents that were removed from this target as part of this
     * remote event.
     */ i){
        this.resumeToken = e, this.current = t, this.addedDocuments = n, this.modifiedDocuments = r, this.removedDocuments = i;
    }
    /**
     * This method is used to create a synthesized TargetChanges that can be used to
     * apply a CURRENT status change to a View (for queries executed in a different
     * tab) or for new queries (to raise snapshots with correct CURRENT status).
     */ static createSynthesizedTargetChangeForCurrentChange(e, t, n) {
        return new TargetChange(n, t, __PRIVATE_documentKeySet(), __PRIVATE_documentKeySet(), __PRIVATE_documentKeySet());
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a changed document and a list of target ids to which this change
 * applies.
 *
 * If document has been deleted NoDocument will be provided.
 */ class __PRIVATE_DocumentWatchChange {
    constructor(/** The new document applies to all of these targets. */ e, /** The new document is removed from all of these targets. */ t, /** The key of the document for this change. */ n, /**
     * The new document or NoDocument if it was deleted. Is null if the
     * document went out of view without the server sending a new document.
     */ r){
        this.Se = e, this.removedTargetIds = t, this.key = n, this.De = r;
    }
}
class __PRIVATE_ExistenceFilterChange {
    constructor(e, t){
        this.targetId = e, this.xe = t;
    }
}
class __PRIVATE_WatchTargetChange {
    constructor(/** What kind of change occurred to the watch target. */ e, /** The target IDs that were added/removed/set. */ t, /**
     * An opaque, server-assigned token that allows watching a target to be
     * resumed after disconnecting without retransmitting all the data that
     * matches the target. The resume token essentially identifies a point in
     * time from which the server should resume sending results.
     */ n = ByteString.EMPTY_BYTE_STRING, r = null){
        this.state = e, this.targetIds = t, this.resumeToken = n, this.cause = r;
    }
}
/** Tracks the internal state of a Watch target. */ class __PRIVATE_TargetState {
    /**
     * Track the targetId for logging.
     */ constructor(e){
        this.targetId = e, /**
         * The number of pending responses (adds or removes) that we are waiting on.
         * We only consider targets active that have no pending responses.
         */ this.Ce = 0, /**
         * Keeps track of the document changes since the last raised snapshot.
         *
         * These changes are continuously updated as we receive document updates and
         * always reflect the current set of changes against the last issued snapshot.
         */ this.Fe = __PRIVATE_snapshotChangesMap(), /** See public getters for explanations of these fields. */ this.Oe = ByteString.EMPTY_BYTE_STRING, this.Me = !1, /**
         * Whether this target state should be included in the next snapshot. We
         * initialize to true so that newly-added targets are included in the next
         * RemoteEvent.
         */ this.Ne = !0;
    }
    /**
     * Whether this target has been marked 'current'.
     *
     * 'Current' has special meaning in the RPC protocol: It implies that the
     * Watch backend has sent us all changes up to the point at which the target
     * was added and that the target is consistent with the rest of the watch
     * stream.
     */ get current() {
        return this.Me;
    }
    /** The last resume token sent to us for this target. */ get resumeToken() {
        return this.Oe;
    }
    /** Whether this target has pending target adds or target removes. */ get Le() {
        return 0 !== this.Ce;
    }
    /** Whether we have modified any state that should trigger a snapshot. */ get Be() {
        return this.Ne;
    }
    /**
     * Applies the resume token to the TargetChange, but only when it has a new
     * value. Empty resumeTokens are discarded.
     */ Ue(e) {
        e.approximateByteSize() > 0 && (this.Ne = !0, this.Oe = e);
    }
    /**
     * Creates a target change from the current set of changes.
     *
     * To reset the document changes after raising this snapshot, call
     * `clearPendingChanges()`.
     */ ke() {
        let e = __PRIVATE_documentKeySet(), t = __PRIVATE_documentKeySet(), n = __PRIVATE_documentKeySet();
        return this.Fe.forEach((r, i)=>{
            switch(i){
                case 0 /* ChangeType.Added */ :
                    e = e.add(r);
                    break;
                case 2 /* ChangeType.Modified */ :
                    t = t.add(r);
                    break;
                case 1 /* ChangeType.Removed */ :
                    n = n.add(r);
                    break;
                default:
                    fail(38017, {
                        changeType: i
                    });
            }
        }), new TargetChange(this.Oe, this.Me, e, t, n);
    }
    /**
     * Resets the document changes and sets `hasPendingChanges` to false.
     */ qe() {
        this.Ne = !1, this.Fe = __PRIVATE_snapshotChangesMap();
    }
    $e(e, t) {
        this.Ne = !0, this.Fe = this.Fe.insert(e, t);
    }
    Ke(e) {
        this.Ne = !0, this.Fe = this.Fe.remove(e);
    }
    We() {
        this.Ce += 1;
    }
    Qe() {
        this.Ce -= 1, __PRIVATE_hardAssert(this.Ce >= 0, 3241, {
            Ce: this.Ce,
            targetId: this.targetId
        });
    }
    Ge() {
        this.Ne = !0, this.Me = !0;
    }
}
const gt = "WatchChangeAggregator";
/**
 * A helper class to accumulate watch changes into a RemoteEvent.
 */ class __PRIVATE_WatchChangeAggregator {
    constructor(e){
        this.ze = e, /**
         * The internal state of all tracked targets.
         *
         * Targets have the following lifecycle of [states] within the WatchChangeAggregator:
         * [unknown] -> recordPendingTargetRequest(t)
         *           -> [pending]
         *           -> handleTargetChange(t, Added)
         *           -> [added / !pending]
         *           -> recordPendingTargetRequest(t)
         *           -> [pending]
         *           -> handleTargetChange(t, Removed)
         *           -> [unknown]
         *
         * A reset on an [added] target leaves the target in an [added] state.
         * [added / !pending] -> handleTargetChange(t, Reset)
         *                    -> [added / !pending]
         *
         * [active]: is a substate of [added], where also `remoteStore.listenTargets.has(t) === true`.
         *           Generally it is expected that when a target is [active / !pending]
         *           then it is also [active], but the implementation does not guarantee
         *           this will always be true.
         *
         */ this.je = new Map, /** Keeps track of the documents to update since the last raised snapshot. */ this.He = __PRIVATE_mutableDocumentMap(), this.Je = __PRIVATE_documentTargetMap(), /** Keeps track of the augmented documents to update since the last raised snapshot. */ this.Ye = __PRIVATE_mutableDocumentMap(), /** A mapping of document keys to their set of target IDs. */ this.Ze = __PRIVATE_documentTargetMap(), /**
         * A map of targets with existence filter mismatches. These targets are
         * known to be inconsistent and their listens needs to be re-established by
         * RemoteStore.
         */ this.Xe = new SortedMap(__PRIVATE_primitiveComparator);
    }
    /**
     * Processes and adds the DocumentWatchChange to the current set of changes.
     */ et(e) {
        for (const t of e.Se)e.De && e.De.isFoundDocument() ? this.tt(t, e.De) : this.nt(t, e.key, e.De);
        for (const t of e.removedTargetIds)this.nt(t, e.key, e.De);
    }
    /** Processes and adds the WatchTargetChange to the current set of changes. */ rt(e) {
        this.forEachTarget(e, (t)=>{
            const n = this.je.get(t);
            // skip unknown target state, this indicates the target change is for
            // an old target
            if (n) switch(e.state){
                case 0 /* WatchTargetChangeState.NoChange */ :
                    this.it(t) && n.Ue(e.resumeToken);
                    break;
                case 1 /* WatchTargetChangeState.Added */ :
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Qe(), n.Le || // We have a freshly added target, so we need to reset any state
                    // that we had previously. This can happen e.g. when remove and add
                    // back a target for existence filter mismatches.
                    n.qe(), n.Ue(e.resumeToken);
                    break;
                case 2 /* WatchTargetChangeState.Removed */ :
                    // We need to keep track of removed targets to we can post-filter and
                    // remove any target changes.
                    // We need to decrement the number of pending acks needed from watch
                    // for this targetId.
                    n.Qe(), n.Le || this.removeTarget(t);
                    break;
                case 3 /* WatchTargetChangeState.Current */ :
                    this.it(t) && (n.Ge(), n.Ue(e.resumeToken));
                    break;
                case 4 /* WatchTargetChangeState.Reset */ :
                    this.it(t) && // Reset the target and synthesizes removes for all existing
                    // documents. The backend will re-add any documents that still
                    // match the target before it sends the next global snapshot.
                    (this.st(t), n.Ue(e.resumeToken));
                    break;
                default:
                    fail(56790, {
                        state: e.state
                    });
            }
            else __PRIVATE_logDebug(gt, `handleTargetChange received targetChange for untracked target ID (${t}) with state (${e.state})`);
        });
    }
    /**
     * Iterates over all targetIds that the watch change applies to: either the
     * targetIds explicitly listed in the change or the targetIds of all currently
     * active targets.
     */ forEachTarget(e, t) {
        e.targetIds.length > 0 ? e.targetIds.forEach(t) : this.je.forEach((e, n)=>{
            this.it(n) && t(n);
        });
    }
    _t(e) {
        return __PRIVATE_targetIsPipelineTarget(e) ? "documents" === e.getPipelineSourceType() && 1 === e.getPipelineDocuments()?.length : __PRIVATE_targetIsDocumentTarget(e);
    }
    /**
     * Handles existence filters and synthesizes deletes for filter mismatches.
     * Targets that are invalidated by filter mismatches are added to
     * `pendingTargetResets`.
     */ ot(e) {
        const t = e.targetId, n = e.xe.count, r = this.ut(t);
        if (r) {
            const i = r.target;
            if (this._t(i)) {
                if (0 === n) {
                    // The existence filter told us the document does not exist. We deduce
                    // that this document does not exist and apply a deleted document to
                    // our updates. Without applying this deleted document there might be
                    // another query that will raise this document as part of a snapshot
                    // until it is resolved, essentially exposing inconsistency between
                    // queries.
                    const e = new DocumentKey(__PRIVATE_targetIsPipelineTarget(i) ? ResourcePath.fromString(i.getPipelineDocuments()[0]) : i.path);
                    this.nt(t, e, MutableDocument.newNoDocument(e, SnapshotVersion.min()));
                } else __PRIVATE_hardAssert(1 === n, 20013, "Single document existence filter with count: " + n);
            } else {
                const r = this.ct(t);
                // Existence filter mismatch. Mark the documents as being in limbo, and
                // raise a snapshot with `isFromCache:true`.
                if (r !== n) {
                    // Apply bloom filter to identify and mark removed documents.
                    const n = this.lt(e), i = n ? this.Et(n, e, r) : 1 /* BloomFilterApplicationStatus.Skipped */ ;
                    if (0 /* BloomFilterApplicationStatus.Success */  !== i) {
                        // If bloom filter application fails, we reset the mapping and
                        // trigger re-run of the query.
                        this.st(t);
                        const e = 2 /* BloomFilterApplicationStatus.FalsePositive */  === i ? "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */  : "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ ;
                        this.Xe = this.Xe.insert(t, e);
                    }
                    mt?.u(function __PRIVATE_createExistenceFilterMismatchInfoForTestingHooks(e, t, n, r, i) {
                        const s = {
                            localCacheCount: e,
                            existenceFilterCount: t.count,
                            databaseId: n.database,
                            projectId: n.projectId
                        }, _ = t.unchangedNames;
                        _ && (s.bloomFilter = {
                            applied: 0 /* BloomFilterApplicationStatus.Success */  === i,
                            hashCount: _?.hashCount ?? 0,
                            bitmapLength: _?.bits?.bitmap?.length ?? 0,
                            padding: _?.bits?.padding ?? 0,
                            mightContain: (e)=>r?.mightContain(e) ?? !1
                        });
                        return s;
                    }(r, e.xe, this.ze.Tt(), n, i));
                }
            }
        }
    }
    /**
     * Parse the bloom filter from the "unchanged_names" field of an existence
     * filter.
     */ lt(e) {
        const t = e.xe.unchangedNames;
        if (!t || !t.bits) return null;
        const { bits: { bitmap: n = "", padding: r = 0 }, hashCount: i = 0 } = t;
        let s, _;
        try {
            s = __PRIVATE_normalizeByteString(n).toUint8Array();
        } catch (e) {
            if (e instanceof __PRIVATE_Base64DecodeError) return __PRIVATE_logWarn("Decoding the base64 bloom filter in existence filter failed (" + e.message + "); ignoring the bloom filter and falling back to full re-query."), null;
            throw e;
        }
        try {
            // BloomFilter throws error if the inputs are invalid.
            _ = new BloomFilter(s, r, i);
        } catch (e) {
            return __PRIVATE_logWarn(e instanceof __PRIVATE_BloomFilterError ? "BloomFilter error: " : "Applying bloom filter failed: ", e), null;
        }
        return 0 === _.ge ? null : _;
    }
    /**
     * Apply bloom filter to remove the deleted documents, and return the
     * application status.
     */ Et(e, t, n) {
        return t.xe.count === n - this.Pt(e, t.targetId) ? 0 /* BloomFilterApplicationStatus.Success */  : 2 /* BloomFilterApplicationStatus.FalsePositive */ ;
    }
    /**
     * Filter out removed documents based on bloom filter membership result and
     * return number of documents removed.
     */ Pt(e, t) {
        const n = this.ze.getRemoteKeysForTarget(t);
        let r = 0;
        return n.forEach((n)=>{
            const i = this.ze.Tt(), s = `projects/${i.projectId}/databases/${i.database}/documents/${n.path.canonicalString()}`;
            e.mightContain(s) || (this.nt(t, n, /*updatedDocument=*/ null), r++);
        }), r;
    }
    /**
     * Converts the currently accumulated state into a remote event at the
     * provided snapshot version. Resets the accumulated changes before returning.
     */ Rt(e) {
        const t = new Map;
        this.je.forEach((n, r)=>{
            const i = this.ut(r);
            if (i) {
                if (n.current && this._t(i.target)) {
                    // Document queries for document that don't exist can produce an empty
                    // result set. To update our local cache, we synthesize a document
                    // delete if we have not previously received the document for this
                    // target. This resolves the limbo state of the document, removing it
                    // from limboDocumentRefs.
                    // TODO(dimond): Ideally we would have an explicit lookup target
                    // instead resulting in an explicit delete message and we could
                    // remove this special logic.
                    const t = __PRIVATE_targetIsPipelineTarget(i.target) ? ResourcePath.fromString(i.target.getPipelineDocuments()[0]) : i.target.path, n = new DocumentKey(t);
                    this.It(n).has(r) || this.At(r, n) || this.nt(r, n, MutableDocument.newNoDocument(n, e));
                }
                n.Be && (t.set(r, n.ke()), n.qe());
            }
        });
        let n = __PRIVATE_documentKeySet();
        // We extract the set of limbo-only document updates as the GC logic
        // special-cases documents that do not appear in the target cache.
        // TODO(gsoltis): Expand on this comment once GC is available in the JS
        // client.
        this.Ze.forEach((e, t)=>{
            let r = !0;
            t.forEachWhile((e)=>{
                const t = this.ut(e);
                return !t || "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */  === t.purpose || (r = !1, !1);
            }), r && (n = n.add(e));
        }), this.He.forEach((t, n)=>n.setReadTime(e)), this.Ye.forEach((t, n)=>n.setReadTime(e));
        const r = new RemoteEvent(e, t, this.Xe, this.He, this.Ye, n);
        return this.He = __PRIVATE_mutableDocumentMap(), this.Je = __PRIVATE_documentTargetMap(), this.Ye = __PRIVATE_mutableDocumentMap(), this.Ze = __PRIVATE_documentTargetMap(), this.Xe = new SortedMap(__PRIVATE_primitiveComparator), r;
    }
    /**
     * Adds the provided document to the internal list of document updates and
     * its document key to the given target's mapping.
     */ // Visible for testing.
    tt(e, t) {
        const n = this.je.get(e);
        // skip unknown or inactive targets
        if (!n || !this.it(e)) return void __PRIVATE_logDebug(gt, `addDocumentToTarget received document for unknown inactive target (${e})`);
        const r = this.At(e, t.key) ? 2 /* ChangeType.Modified */  : 0 /* ChangeType.Added */ ;
        n.$e(t.key, r), __PRIVATE_targetIsPipelineTarget(this.ut(e).target) && "exact" !== this.ut(e).target.getPipelineFlavor() ? this.Ye = this.Ye.insert(t.key, t) : this.He = this.He.insert(t.key, t), this.Je = this.Je.insert(t.key, this.It(t.key).add(e)), this.Ze = this.Ze.insert(t.key, this.Vt(t.key).add(e));
    }
    /**
     * Removes the provided document from the target mapping. If the
     * document no longer matches the target, but the document's state is still
     * known (e.g. we know that the document was deleted or we received the change
     * that caused the filter mismatch), the new document can be provided
     * to update the remote document cache.
     */ // Visible for testing.
    nt(e, t, n) {
        const r = this.je.get(e);
        // skip unknown target state, this indicates the target change is for
        // an old target
        r && this.it(e) ? (this.At(e, t) ? r.$e(t, 1 /* ChangeType.Removed */ ) : // The document may have entered and left the target before we raised a
        // snapshot, so we can just ignore the change.
        r.Ke(t), this.Ze = this.Ze.insert(t, this.Vt(t).delete(e)), this.Ze = this.Ze.insert(t, this.Vt(t).add(e)), n && (__PRIVATE_targetIsPipelineTarget(this.ut(e).target) && "exact" !== this.ut(e).target.getPipelineFlavor() ? this.Ye = this.Ye.insert(t, n) : this.He = this.He.insert(t, n))) : __PRIVATE_logDebug(gt, `removeDocumentFromTarget received document for unknown or inactive target (${e})`);
    }
    removeTarget(e) {
        this.je.delete(e);
    }
    /**
     * Returns the current count of documents in the target. This includes both
     * the number of documents that the LocalStore considers to be part of the
     * target as well as any accumulated changes.
     */ ct(e) {
        const t = this.je.get(e);
        // skip unknown target state
        if (!t) return 0;
        const n = t.ke();
        return this.ze.getRemoteKeysForTarget(e).size + n.addedDocuments.size - n.removedDocuments.size;
    }
    /**
     * Increment the number of acks needed from watch before we can consider the
     * server to be 'in-sync' with the client's active targets.
     */ We(e) {
        // For each request we get we need to record we need a response for it.
        let t = this.je.get(e);
        t || (__PRIVATE_logDebug(gt, `recordPendingTargetRequest set up tracking for target ID ${e}`), t = new __PRIVATE_TargetState(e), this.je.set(e, t)), t.We();
    }
    Vt(e) {
        let t = this.Ze.get(e);
        return t || (t = new SortedSet(__PRIVATE_primitiveComparator), this.Ze = this.Ze.insert(e, t)), t;
    }
    It(e) {
        let t = this.Je.get(e);
        return t || (t = new SortedSet(__PRIVATE_primitiveComparator), this.Je = this.Je.insert(e, t)), t;
    }
    /**
     * Verifies that the user is still interested in this target (by calling
     * `getTargetDataForTarget()`) and that we are not waiting for pending ADDs
     * from watch.
     */ it(e) {
        const t = null !== this.ut(e);
        return t || __PRIVATE_logDebug(gt, "Detected inactive target", e), t;
    }
    /**
     * Returns the TargetData for an active target (i.e. a target that the user
     * is still interested in that has no outstanding target change requests).
     */ ut(e) {
        const t = this.je.get(e);
        return void 0 === t || t.Le ? null : this.ze.dt(e);
    }
    /**
     * Resets the state of a Watch target to its initial state (e.g. sets
     * 'current' to false, clears the resume token and removes its target mapping
     * from all documents).
     */ st(e) {
        this.je.set(e, new __PRIVATE_TargetState(e));
        this.ze.getRemoteKeysForTarget(e).forEach((t)=>{
            this.nt(e, t, /*updatedDocument=*/ null);
        });
    }
    /**
     * Returns whether the LocalStore considers the document to be part of the
     * specified target.
     */ At(e, t) {
        return this.ze.getRemoteKeysForTarget(e).has(t);
    }
}
function __PRIVATE_documentTargetMap() {
    return new SortedMap(DocumentKey.comparator);
}
function __PRIVATE_snapshotChangesMap() {
    return new SortedMap(DocumentKey.comparator);
}
const yt = (()=>{
    const e = {
        asc: "ASCENDING",
        desc: "DESCENDING"
    };
    return e;
})(), wt = (()=>{
    const e = {
        "<": "LESS_THAN",
        "<=": "LESS_THAN_OR_EQUAL",
        ">": "GREATER_THAN",
        ">=": "GREATER_THAN_OR_EQUAL",
        "==": "EQUAL",
        "!=": "NOT_EQUAL",
        "array-contains": "ARRAY_CONTAINS",
        in: "IN",
        "not-in": "NOT_IN",
        "array-contains-any": "ARRAY_CONTAINS_ANY"
    };
    return e;
})(), bt = (()=>{
    const e = {
        and: "AND",
        or: "OR"
    };
    return e;
})();
/**
 * This class generates JsonObject values for the Datastore API suitable for
 * sending to either GRPC stub methods or via the JSON/HTTP REST API.
 *
 * The serializer supports both Protobuf.js and Proto3 JSON formats. By
 * setting `useProto3Json` to true, the serializer will use the Proto3 JSON
 * format.
 *
 * For a description of the Proto3 JSON format check
 * https://developers.google.com/protocol-buffers/docs/proto3#json
 *
 * TODO(klimt): We can remove the databaseId argument if we keep the full
 * resource name in documents.
 */ class JsonProtoSerializer {
    constructor(e, t){
        this.databaseId = e, this.useProto3Json = t;
    }
}
/**
 * Returns a value for a number (or null) that's appropriate to put into
 * a google.protobuf.Int32Value proto.
 * DO NOT USE THIS FOR ANYTHING ELSE.
 * This method cheats. It's typed as returning "number" because that's what
 * our generated proto interfaces say Int32Value must be. But GRPC actually
 * expects a { value: <number> } struct.
 */ function __PRIVATE_toInt32Proto(e, t) {
    return e.useProto3Json || __PRIVATE_isNullOrUndefined(t) ? t : {
        value: t
    };
}
/**
 * Returns a number (or null) from a google.protobuf.Int32Value proto.
 */ /**
 * Returns a value for a Date that's appropriate to put into a proto.
 */ function toTimestamp(e, t) {
    if (e.useProto3Json) return `${new Date(1e3 * t.seconds).toISOString().replace(/\.\d*/, "").replace("Z", "")}.${("000000000" + t.nanoseconds).slice(-9)}Z`;
    return {
        seconds: "" + t.seconds,
        nanos: t.nanoseconds
    };
}
/**
 * Returns a Timestamp typed object given protobuf timestamp value.
 */ function fromTimestamp(e) {
    const t = __PRIVATE_normalizeTimestamp(e);
    return new Timestamp(t.seconds, t.nanos);
}
/**
 * Returns a value for bytes that's appropriate to put in a proto.
 *
 * Visible for testing.
 */ function __PRIVATE_toBytes(e, t) {
    return e.useProto3Json ? t.toBase64() : t.toUint8Array();
}
/**
 * Returns a ByteString based on the proto string value.
 */ function __PRIVATE_toVersion(e, t) {
    return toTimestamp(e, t.toTimestamp());
}
function __PRIVATE_fromVersion(e) {
    return __PRIVATE_hardAssert(!!e, 49232), SnapshotVersion.fromTimestamp(fromTimestamp(e));
}
function __PRIVATE_toResourceName(e, t) {
    return __PRIVATE_toResourcePath(e, t).canonicalString();
}
function __PRIVATE_toResourcePath(e, t) {
    const n = (function __PRIVATE_fullyQualifiedPrefixPath(e) {
        return new ResourcePath([
            "projects",
            e.projectId,
            "databases",
            e.database
        ]);
    })(e).child("documents");
    return void 0 === t ? n : n.child(t);
}
function __PRIVATE_fromResourceName(e) {
    const t = ResourcePath.fromString(e);
    return __PRIVATE_hardAssert(__PRIVATE_isValidResourceName(t), 10190, {
        key: t.toString()
    }), t;
}
function __PRIVATE_toName(e, t) {
    return __PRIVATE_toResourceName(e.databaseId, t.path);
}
function fromName(e, t) {
    const n = __PRIVATE_fromResourceName(t);
    if (n.get(1) !== e.databaseId.projectId) throw new FirestoreError(D.INVALID_ARGUMENT, "Tried to deserialize key from different project: " + n.get(1) + " vs " + e.databaseId.projectId);
    if (n.get(3) !== e.databaseId.database) throw new FirestoreError(D.INVALID_ARGUMENT, "Tried to deserialize key from different database: " + n.get(3) + " vs " + e.databaseId.database);
    return new DocumentKey(__PRIVATE_extractLocalPathFromResourceName(n));
}
function __PRIVATE_toQueryPath(e, t) {
    return __PRIVATE_toResourceName(e.databaseId, t);
}
function __PRIVATE_fromQueryPath(e) {
    const t = __PRIVATE_fromResourceName(e);
    // In v1beta1 queries for collections at the root did not have a trailing
    // "/documents". In v1 all resource paths contain "/documents". Preserve the
    // ability to read the v1beta1 form for compatibility with queries persisted
    // in the local target cache.
    return 4 === t.length ? ResourcePath.emptyPath() : __PRIVATE_extractLocalPathFromResourceName(t);
}
function __PRIVATE_getEncodedDatabaseId(e) {
    return new ResourcePath([
        "projects",
        e.databaseId.projectId,
        "databases",
        e.databaseId.database
    ]).canonicalString();
}
function __PRIVATE_extractLocalPathFromResourceName(e) {
    return __PRIVATE_hardAssert(e.length > 4 && "documents" === e.get(4), 29091, {
        key: e.toString()
    }), e.popFirst(5);
}
/** Creates a Document proto from key and fields (but no create/update time) */ function __PRIVATE_toMutationDocument(e, t, n) {
    return {
        name: __PRIVATE_toName(e, t),
        fields: n.value.mapValue.fields
    };
}
function __PRIVATE_fromPipelineResponse(e, t, n) {
    const r = {};
    t.transaction?.length && (r.transaction = t.transaction);
    const i = t.executionTime ? __PRIVATE_fromVersion(t.executionTime) : void 0;
    return r.executionTime = i, n && (r.key = n.name ? fromName(e, n.name) : void 0, r.fields = new ObjectValue({
        mapValue: {
            fields: n.fields
        }
    }), r.createTime = n.createTime ? __PRIVATE_fromVersion(n.createTime) : void 0, r.updateTime = n.updateTime ? __PRIVATE_fromVersion(n.updateTime) : void 0), r;
}
function fromDocument(e, t, n) {
    const r = fromName(e, t.name), i = __PRIVATE_fromVersion(t.updateTime), s = t.createTime ? __PRIVATE_fromVersion(t.createTime) : SnapshotVersion.min(), _ = new ObjectValue({
        mapValue: {
            fields: t.fields
        }
    }), o = MutableDocument.newFoundDocument(r, i, s, _);
    return n && o.setHasCommittedMutations(), n ? o.setHasCommittedMutations() : o;
}
function __PRIVATE_fromBatchGetDocumentsResponse(e, t) {
    return "found" in t ? function __PRIVATE_fromFound(e, t) {
        __PRIVATE_hardAssert(!!t.found, 43571), t.found.name, t.found.updateTime;
        const n = fromName(e, t.found.name), r = __PRIVATE_fromVersion(t.found.updateTime), i = t.found.createTime ? __PRIVATE_fromVersion(t.found.createTime) : SnapshotVersion.min(), s = new ObjectValue({
            mapValue: {
                fields: t.found.fields
            }
        });
        return MutableDocument.newFoundDocument(n, r, i, s);
    }(e, t) : "missing" in t ? function __PRIVATE_fromMissing(e, t) {
        __PRIVATE_hardAssert(!!t.missing, 3894), __PRIVATE_hardAssert(!!t.readTime, 22933);
        const n = fromName(e, t.missing), r = __PRIVATE_fromVersion(t.readTime);
        return MutableDocument.newNoDocument(n, r);
    }(e, t) : fail(7234, {
        result: t
    });
}
function __PRIVATE_fromWatchChange(e, t) {
    let n;
    if ("targetChange" in t) {
        t.targetChange;
        // proto3 default value is unset in JSON (undefined), so use 'NO_CHANGE'
        // if unset
        const r = function __PRIVATE_fromWatchTargetChangeState(e) {
            return "NO_CHANGE" === e ? 0 /* WatchTargetChangeState.NoChange */  : "ADD" === e ? 1 /* WatchTargetChangeState.Added */  : "REMOVE" === e ? 2 /* WatchTargetChangeState.Removed */  : "CURRENT" === e ? 3 /* WatchTargetChangeState.Current */  : "RESET" === e ? 4 /* WatchTargetChangeState.Reset */  : fail(39313, {
                state: e
            });
        }(t.targetChange.targetChangeType || "NO_CHANGE"), i = t.targetChange.targetIds || [], s = function __PRIVATE_fromBytes(e, t) {
            return e.useProto3Json ? (__PRIVATE_hardAssert(void 0 === t || "string" == typeof t, 58123), ByteString.fromBase64String(t || "")) : (__PRIVATE_hardAssert(void 0 === t || // Check if the value is an instance of both Buffer and Uint8Array,
            // despite the fact that Buffer extends Uint8Array. In some
            // environments, such as jsdom, the prototype chain of Buffer
            // does not indicate that it extends Uint8Array.
            t instanceof Buffer || t instanceof Uint8Array, 16193), ByteString.fromUint8Array(t || new Uint8Array));
        }(e, t.targetChange.resumeToken), _ = t.targetChange.cause, o = _ && function __PRIVATE_fromRpcStatus(e) {
            const t = void 0 === e.code ? D.UNKNOWN : __PRIVATE_mapCodeFromRpcCode(e.code);
            return new FirestoreError(t, e.message || "");
        }(_);
        n = new __PRIVATE_WatchTargetChange(r, i, s, o || null);
    } else if ("documentChange" in t) {
        t.documentChange;
        const r = t.documentChange;
        r.document, r.document.name, r.document.updateTime;
        const i = fromName(e, r.document.name), s = __PRIVATE_fromVersion(r.document.updateTime), _ = r.document.createTime ? __PRIVATE_fromVersion(r.document.createTime) : SnapshotVersion.min(), o = new ObjectValue({
            mapValue: {
                fields: r.document.fields
            }
        }), a = MutableDocument.newFoundDocument(i, s, _, o), u = r.targetIds || [], c = r.removedTargetIds || [];
        n = new __PRIVATE_DocumentWatchChange(u, c, a.key, a);
    } else if ("documentDelete" in t) {
        t.documentDelete;
        const r = t.documentDelete;
        r.document;
        const i = fromName(e, r.document), s = r.readTime ? __PRIVATE_fromVersion(r.readTime) : SnapshotVersion.min(), _ = MutableDocument.newNoDocument(i, s), o = r.removedTargetIds || [];
        n = new __PRIVATE_DocumentWatchChange([], o, _.key, _);
    } else if ("documentRemove" in t) {
        t.documentRemove;
        const r = t.documentRemove;
        r.document;
        const i = fromName(e, r.document), s = r.removedTargetIds || [];
        n = new __PRIVATE_DocumentWatchChange([], s, i, null);
    } else {
        if (!("filter" in t)) return fail(11601, {
            ft: t
        });
        {
            t.filter;
            const e = t.filter;
            e.targetId;
            const { count: r = 0, unchangedNames: i } = e, s = new ExistenceFilter(r, i), _ = e.targetId;
            n = new __PRIVATE_ExistenceFilterChange(_, s);
        }
    }
    return n;
}
function toMutation(e, t) {
    let n;
    if (t instanceof __PRIVATE_SetMutation) n = {
        update: __PRIVATE_toMutationDocument(e, t.key, t.value)
    };
    else if (t instanceof __PRIVATE_DeleteMutation) n = {
        delete: __PRIVATE_toName(e, t.key)
    };
    else if (t instanceof __PRIVATE_PatchMutation) n = {
        update: __PRIVATE_toMutationDocument(e, t.key, t.data),
        updateMask: __PRIVATE_toDocumentMask(t.fieldMask)
    };
    else {
        if (!(t instanceof __PRIVATE_VerifyMutation)) return fail(16599, {
            gt: t.type
        });
        n = {
            verify: __PRIVATE_toName(e, t.key)
        };
    }
    return t.fieldTransforms.length > 0 && (n.updateTransforms = t.fieldTransforms.map((e)=>(function __PRIVATE_toFieldTransform(e, t) {
            const n = t.transform;
            if (n instanceof __PRIVATE_ServerTimestampTransform) return {
                fieldPath: t.field.canonicalString(),
                setToServerValue: "REQUEST_TIME"
            };
            if (n instanceof __PRIVATE_ArrayUnionTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                appendMissingElements: {
                    values: n.elements
                }
            };
            if (n instanceof __PRIVATE_ArrayRemoveTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                removeAllFromArray: {
                    values: n.elements
                }
            };
            if (n instanceof __PRIVATE_NumericIncrementTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                increment: n.Re
            };
            if (n instanceof __PRIVATE_NumericMinimumTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                minimum: n.Re
            };
            if (n instanceof __PRIVATE_NumericMaximumTransformOperation) return {
                fieldPath: t.field.canonicalString(),
                maximum: n.Re
            };
            throw fail(20930, {
                transform: t.transform
            });
        })(0, e))), t.precondition.isNone || (n.currentDocument = function __PRIVATE_toPrecondition(e, t) {
        return void 0 !== t.updateTime ? {
            updateTime: __PRIVATE_toVersion(e, t.updateTime)
        } : void 0 !== t.exists ? {
            exists: t.exists
        } : fail(27497);
    }(e, t.precondition)), n;
}
function __PRIVATE_fromMutation(e, t) {
    const n = t.currentDocument ? function __PRIVATE_fromPrecondition(e) {
        return void 0 !== e.updateTime ? Precondition.updateTime(__PRIVATE_fromVersion(e.updateTime)) : void 0 !== e.exists ? Precondition.exists(e.exists) : Precondition.none();
    }(t.currentDocument) : Precondition.none(), r = t.updateTransforms ? t.updateTransforms.map((t)=>(function __PRIVATE_fromFieldTransform(e, t) {
            let n = null;
            if ("setToServerValue" in t) __PRIVATE_hardAssert("REQUEST_TIME" === t.setToServerValue, 16630, {
                proto: t
            }), n = new __PRIVATE_ServerTimestampTransform;
            else if ("appendMissingElements" in t) {
                const e = t.appendMissingElements.values || [];
                n = new __PRIVATE_ArrayUnionTransformOperation(e);
            } else if ("removeAllFromArray" in t) {
                const e = t.removeAllFromArray.values || [];
                n = new __PRIVATE_ArrayRemoveTransformOperation(e);
            } else "increment" in t ? n = new __PRIVATE_NumericIncrementTransformOperation(e, t.increment) : "minimum" in t ? n = new __PRIVATE_NumericMinimumTransformOperation(e, t.minimum) : "maximum" in t ? n = new __PRIVATE_NumericMaximumTransformOperation(e, t.maximum) : fail(16584, {
                proto: t
            });
            const r = FieldPath$1.fromServerFormat(t.fieldPath);
            return new FieldTransform(r, n);
        })(e, t)) : [];
    if (t.update) {
        t.update.name;
        const i = fromName(e, t.update.name), s = new ObjectValue({
            mapValue: {
                fields: t.update.fields
            }
        });
        if (t.updateMask) {
            const e = function __PRIVATE_fromDocumentMask(e) {
                const t = e.fieldPaths || [];
                return new FieldMask(t.map((e)=>FieldPath$1.fromServerFormat(e)));
            }(t.updateMask);
            return new __PRIVATE_PatchMutation(i, s, e, n, r);
        }
        return new __PRIVATE_SetMutation(i, s, n, r);
    }
    if (t.delete) {
        const r = fromName(e, t.delete);
        return new __PRIVATE_DeleteMutation(r, n);
    }
    if (t.verify) {
        const r = fromName(e, t.verify);
        return new __PRIVATE_VerifyMutation(r, n);
    }
    return fail(1463, {
        proto: t
    });
}
function __PRIVATE_fromWriteResults(e, t) {
    return e && e.length > 0 ? (__PRIVATE_hardAssert(void 0 !== t, 14353), e.map((e)=>(function __PRIVATE_fromWriteResult(e, t) {
            // NOTE: Deletes don't have an updateTime.
            let n = e.updateTime ? __PRIVATE_fromVersion(e.updateTime) : __PRIVATE_fromVersion(t);
            return n.isEqual(SnapshotVersion.min()) && // The Firestore Emulator currently returns an update time of 0 for
            // deletes of non-existing documents (rather than null). This breaks the
            // test "get deleted doc while offline with source=cache" as NoDocuments
            // with version 0 are filtered by IndexedDb's RemoteDocumentCache.
            // TODO(#2149): Remove this when Emulator is fixed
            (n = __PRIVATE_fromVersion(t)), new MutationResult(n, e.transformResults || []);
        })(e, t))) : [];
}
function __PRIVATE_toDocumentsTarget(e, t) {
    return {
        documents: [
            __PRIVATE_toQueryPath(e, t.path)
        ]
    };
}
function __PRIVATE_toQueryTarget(e, t) {
    // Dissect the path into parent, collectionId, and optional key filter.
    const n = {
        structuredQuery: {}
    }, r = t.path;
    let i;
    null !== t.collectionGroup ? (i = r, n.structuredQuery.from = [
        {
            collectionId: t.collectionGroup,
            allDescendants: !0
        }
    ]) : (i = r.popLast(), n.structuredQuery.from = [
        {
            collectionId: r.lastSegment()
        }
    ]), n.parent = __PRIVATE_toQueryPath(e, i);
    const s = function __PRIVATE_toFilters(e) {
        if (0 === e.length) return;
        return __PRIVATE_toFilter(CompositeFilter.create(e, "and" /* CompositeOperator.AND */ ));
    }(t.filters);
    s && (n.structuredQuery.where = s);
    const _ = function __PRIVATE_toOrder(e) {
        if (0 === e.length) return;
        return e.map((e)=>// visible for testing
            (function __PRIVATE_toPropertyOrder(e) {
                return {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    direction: __PRIVATE_toDirection(e.dir)
                };
            })(e));
    }(t.orderBy);
    _ && (n.structuredQuery.orderBy = _);
    const o = __PRIVATE_toInt32Proto(e, t.limit);
    return null !== o && (n.structuredQuery.limit = o), t.startAt && (n.structuredQuery.startAt = function __PRIVATE_toStartAtCursor(e) {
        return {
            before: e.inclusive,
            values: e.position
        };
    }(t.startAt)), t.endAt && (n.structuredQuery.endAt = function __PRIVATE_toEndAtCursor(e) {
        return {
            before: !e.inclusive,
            values: e.position
        };
    }(t.endAt)), {
        yt: n,
        parent: i
    };
}
function __PRIVATE_toRunAggregationQueryRequest(e, t, n, r) {
    const { yt: i, parent: s } = __PRIVATE_toQueryTarget(e, t), _ = {}, o = [];
    let a = 0;
    return n.forEach((e)=>{
        // Map all client-side aliases to a unique short-form
        // alias. This avoids issues with client-side aliases that
        // exceed the 1500-byte string size limit.
        const t = r ? e.alias : "aggregate_" + a++;
        _[t] = e.alias, "count" === e.aggregateType ? o.push({
            alias: t,
            count: {}
        }) : "avg" === e.aggregateType ? o.push({
            alias: t,
            avg: {
                field: __PRIVATE_toFieldPathReference(e.fieldPath)
            }
        }) : "sum" === e.aggregateType && o.push({
            alias: t,
            sum: {
                field: __PRIVATE_toFieldPathReference(e.fieldPath)
            }
        });
    }), {
        request: {
            structuredAggregationQuery: {
                aggregations: o,
                structuredQuery: i.structuredQuery
            },
            parent: i.parent
        },
        wt: _,
        parent: s
    };
}
function __PRIVATE_convertQueryTargetToQuery(e) {
    let t = __PRIVATE_fromQueryPath(e.parent);
    const n = e.structuredQuery, r = n.from ? n.from.length : 0;
    let i = null;
    if (r > 0) {
        __PRIVATE_hardAssert(1 === r, 65062);
        const e = n.from[0];
        e.allDescendants ? i = e.collectionId : t = t.child(e.collectionId);
    }
    let s = [];
    n.where && (s = function __PRIVATE_fromFilters(e) {
        const t = __PRIVATE_fromFilter(e);
        if (t instanceof CompositeFilter && __PRIVATE_compositeFilterIsFlatConjunction(t)) return t.getFilters();
        return [
            t
        ];
    }(n.where));
    let _ = [];
    n.orderBy && (_ = function __PRIVATE_fromOrder(e) {
        return e.map((e)=>(function __PRIVATE_fromPropertyOrder(e) {
                return new OrderBy(__PRIVATE_fromFieldPathReference(e.field), // visible for testing
                function __PRIVATE_fromDirection(e) {
                    switch(e){
                        case "ASCENDING":
                            return "asc" /* Direction.ASCENDING */ ;
                        case "DESCENDING":
                            return "desc" /* Direction.DESCENDING */ ;
                        default:
                            return;
                    }
                }(e.direction));
            })(e));
    }(n.orderBy));
    let o = null;
    n.limit && (o = function __PRIVATE_fromInt32Proto(e) {
        let t;
        return t = "object" == typeof e ? e.value : e, __PRIVATE_isNullOrUndefined(t) ? null : t;
    }(n.limit));
    let a = null;
    n.startAt && (a = function __PRIVATE_fromStartAtCursor(e) {
        const t = !!e.before, n = e.values || [];
        return new Bound(n, t);
    }(n.startAt));
    let u = null;
    return n.endAt && (u = function __PRIVATE_fromEndAtCursor(e) {
        const t = !e.before, n = e.values || [];
        return new Bound(n, t);
    }(n.endAt)), __PRIVATE_newQuery(t, i, _, s, o, "F" /* LimitType.First */ , a, u);
}
function __PRIVATE_toListenRequestLabels(e, t) {
    const n = function __PRIVATE_toLabel(e) {
        switch(e){
            case "TargetPurposeListen" /* TargetPurpose.Listen */ :
                return null;
            case "TargetPurposeExistenceFilterMismatch" /* TargetPurpose.ExistenceFilterMismatch */ :
                return "existence-filter-mismatch";
            case "TargetPurposeExistenceFilterMismatchBloom" /* TargetPurpose.ExistenceFilterMismatchBloom */ :
                return "existence-filter-mismatch-bloom";
            case "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ :
                return "limbo-document";
            default:
                return fail(28987, {
                    purpose: e
                });
        }
    }(t.purpose);
    return null == n ? null : {
        "goog-listen-tags": n
    };
}
function __PRIVATE_toPipelineTarget(e, t) {
    return {
        structuredPipeline: {
            pipeline: {
                stages: t.stages.map((t)=>t._toProto(e))
            }
        }
    };
}
function __PRIVATE_fromFilter(e) {
    return void 0 !== e.unaryFilter ? function __PRIVATE_fromUnaryFilter(e) {
        switch(e.unaryFilter.op){
            case "IS_NAN":
                const t = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return FieldFilter.create(t, "==" /* Operator.EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NULL":
                const n = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return FieldFilter.create(n, "==" /* Operator.EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "IS_NOT_NAN":
                const r = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return FieldFilter.create(r, "!=" /* Operator.NOT_EQUAL */ , {
                    doubleValue: NaN
                });
            case "IS_NOT_NULL":
                const i = __PRIVATE_fromFieldPathReference(e.unaryFilter.field);
                return FieldFilter.create(i, "!=" /* Operator.NOT_EQUAL */ , {
                    nullValue: "NULL_VALUE"
                });
            case "OPERATOR_UNSPECIFIED":
                return fail(61313);
            default:
                return fail(60726);
        }
    }(e) : void 0 !== e.fieldFilter ? function __PRIVATE_fromFieldFilter(e) {
        return FieldFilter.create(__PRIVATE_fromFieldPathReference(e.fieldFilter.field), function __PRIVATE_fromOperatorName(e) {
            switch(e){
                case "EQUAL":
                    return "==" /* Operator.EQUAL */ ;
                case "NOT_EQUAL":
                    return "!=" /* Operator.NOT_EQUAL */ ;
                case "GREATER_THAN":
                    return ">" /* Operator.GREATER_THAN */ ;
                case "GREATER_THAN_OR_EQUAL":
                    return ">=" /* Operator.GREATER_THAN_OR_EQUAL */ ;
                case "LESS_THAN":
                    return "<" /* Operator.LESS_THAN */ ;
                case "LESS_THAN_OR_EQUAL":
                    return "<=" /* Operator.LESS_THAN_OR_EQUAL */ ;
                case "ARRAY_CONTAINS":
                    return "array-contains" /* Operator.ARRAY_CONTAINS */ ;
                case "IN":
                    return "in" /* Operator.IN */ ;
                case "NOT_IN":
                    return "not-in" /* Operator.NOT_IN */ ;
                case "ARRAY_CONTAINS_ANY":
                    return "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ ;
                case "OPERATOR_UNSPECIFIED":
                    return fail(58110);
                default:
                    return fail(50506);
            }
        }(e.fieldFilter.op), e.fieldFilter.value);
    }(e) : void 0 !== e.compositeFilter ? function __PRIVATE_fromCompositeFilter(e) {
        return CompositeFilter.create(e.compositeFilter.filters.map((e)=>__PRIVATE_fromFilter(e)), function __PRIVATE_fromCompositeOperatorName(e) {
            switch(e){
                case "AND":
                    return "and" /* CompositeOperator.AND */ ;
                case "OR":
                    return "or" /* CompositeOperator.OR */ ;
                default:
                    return fail(1026);
            }
        }(e.compositeFilter.op));
    }(e) : fail(30097, {
        filter: e
    });
}
function __PRIVATE_toDirection(e) {
    return yt[e];
}
function __PRIVATE_toOperatorName(e) {
    return wt[e];
}
function __PRIVATE_toCompositeOperatorName(e) {
    return bt[e];
}
function __PRIVATE_toFieldPathReference(e) {
    return {
        fieldPath: e.canonicalString()
    };
}
function __PRIVATE_fromFieldPathReference(e) {
    return FieldPath$1.fromServerFormat(e.fieldPath);
}
function __PRIVATE_toFilter(e) {
    return e instanceof FieldFilter ? function __PRIVATE_toUnaryOrFieldFilter(e) {
        if ("==" /* Operator.EQUAL */  === e.op) {
            if (__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NAN"
                }
            };
            if (__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NULL"
                }
            };
        } else if ("!=" /* Operator.NOT_EQUAL */  === e.op) {
            if (__PRIVATE_isNanValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NAN"
                }
            };
            if (__PRIVATE_isNullValue(e.value)) return {
                unaryFilter: {
                    field: __PRIVATE_toFieldPathReference(e.field),
                    op: "IS_NOT_NULL"
                }
            };
        }
        return {
            fieldFilter: {
                field: __PRIVATE_toFieldPathReference(e.field),
                op: __PRIVATE_toOperatorName(e.op),
                value: e.value
            }
        };
    }(e) : e instanceof CompositeFilter ? function __PRIVATE_toCompositeFilter(e) {
        const t = e.getFilters().map((e)=>__PRIVATE_toFilter(e));
        if (1 === t.length) return t[0];
        return {
            compositeFilter: {
                op: __PRIVATE_toCompositeOperatorName(e.op),
                filters: t
            }
        };
    }(e) : fail(54877, {
        filter: e
    });
}
function __PRIVATE_toDocumentMask(e) {
    const t = [];
    return e.fields.forEach((e)=>t.push(e.canonicalString())), {
        fieldPaths: t
    };
}
function __PRIVATE_isValidResourceName(e) {
    // Resource names have at least 4 components (project ID, database ID)
    return e.length >= 4 && "projects" === e.get(0) && "databases" === e.get(2);
}
function __PRIVATE_isProtoValueSerializable(// eslint-disable-next-line @typescript-eslint/no-explicit-any
e) {
    return !!e && "function" == typeof e._toProto && "ProtoValue" === e._protoValueType;
}
function toMapValue(e, t) {
    const n = {
        fields: {}
    };
    return t.forEach((t, r)=>{
        if ("string" != typeof r) throw new Error(`Cannot encode map with non-string key: ${r}`);
        n.fields[r] = t._toProto(e);
    }), {
        mapValue: n
    };
}
function __PRIVATE_toStringValue(e) {
    return {
        stringValue: e
    };
}
function __PRIVATE_toPipelineValue(e) {
    return {
        pipelineValue: e
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_newSerializer(e) {
    return new JsonProtoSerializer(e, /* useProto3Json= */ !0);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing an array of bytes.
 */ class Bytes {
    /** @hideconstructor */ constructor(e){
        this._byteString = e;
    }
    /**
     * Creates a new `Bytes` object from the given Base64 string, converting it to
     * bytes.
     *
     * @param base64 - The Base64 string used to create the `Bytes` object.
     */ static fromBase64String(e) {
        try {
            return new Bytes(ByteString.fromBase64String(e));
        } catch (e) {
            throw new FirestoreError(D.INVALID_ARGUMENT, "Failed to construct data from Base64 string: " + e);
        }
    }
    /**
     * Creates a new `Bytes` object from the given Uint8Array.
     *
     * @param array - The Uint8Array used to create the `Bytes` object.
     */ static fromUint8Array(e) {
        return new Bytes(ByteString.fromUint8Array(e));
    }
    /**
     * Returns the underlying bytes as a Base64-encoded string.
     *
     * @returns The Base64-encoded string created from the `Bytes` object.
     */ toBase64() {
        return this._byteString.toBase64();
    }
    /**
     * Returns the underlying bytes in a new `Uint8Array`.
     *
     * @returns The Uint8Array created from the `Bytes` object.
     */ toUint8Array() {
        return this._byteString.toUint8Array();
    }
    /**
     * Returns a string representation of the `Bytes` object.
     *
     * @returns A string representation of the `Bytes` object.
     */ toString() {
        return "Bytes(base64: " + this.toBase64() + ")";
    }
    /**
     * Returns true if this `Bytes` object is equal to the provided one.
     *
     * @param other - The `Bytes` object to compare against.
     * @returns true if this `Bytes` object is equal to the provided one.
     */ isEqual(e) {
        return this._byteString.isEqual(e._byteString);
    }
    /**
     * Returns a JSON-serializable representation of this `Bytes` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: Bytes._jsonSchemaVersion,
            bytes: this.toBase64()
        };
    }
    /**
     * Builds a `Bytes` instance from a JSON object created by {@link Bytes.toJSON}.
     *
     * @param json - a JSON object represention of a `Bytes` instance
     * @returns an instance of {@link Bytes} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if (__PRIVATE_validateJSON(e, Bytes._jsonSchema)) return Bytes.fromBase64String(e.bytes);
    }
}
Bytes._jsonSchemaVersion = "firestore/bytes/1.0", Bytes._jsonSchema = {
    type: property("string", Bytes._jsonSchemaVersion),
    bytes: property("string")
};
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `FieldPath` refers to a field in a document. The path may consist of a
 * single field name (referring to a top-level field in the document), or a
 * list of field names (referring to a nested field in the document).
 *
 * Create a `FieldPath` by providing field names. If more than one field
 * name is provided, the path will point to a nested field in a document.
 */ class FieldPath {
    /**
     * Creates a `FieldPath` from the provided field names. If more than one field
     * name is provided, the path will point to a nested field in a document.
     *
     * @param fieldNames - A list of field names.
     */ constructor(...e){
        for(let t = 0; t < e.length; ++t)if (0 === e[t].length) throw new FirestoreError(D.INVALID_ARGUMENT, "Invalid field name at argument $(i + 1). Field names must not be empty.");
        this._internalPath = new FieldPath$1(e);
    }
    /**
     * Returns true if this `FieldPath` is equal to the provided one.
     *
     * @param other - The `FieldPath` to compare against.
     * @returns true if this `FieldPath` is equal to the provided one.
     */ isEqual(e) {
        return this._internalPath.isEqual(e._internalPath);
    }
}
/**
 * Returns a special sentinel `FieldPath` to refer to the ID of a document.
 * It can be used in queries to sort or filter by the document ID.
 */ function documentId$1() {
    return new FieldPath(F);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sentinel values that can be used when writing document fields with `set()`
 * or `update()`.
 */ class FieldValue {
    /**
     * @param _methodName - The public API endpoint that returns this class.
     * @hideconstructor
     */ constructor(e){
        this._methodName = e;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable object representing a geographic location in Firestore. The
 * location is represented as latitude/longitude pair.
 *
 * Latitude values are in the range of [-90, 90].
 * Longitude values are in the range of [-180, 180].
 */ class GeoPoint {
    /**
     * Creates a new immutable `GeoPoint` object with the provided latitude and
     * longitude values.
     * @param latitude - The latitude as number between -90 and 90.
     * @param longitude - The longitude as number between -180 and 180.
     */ constructor(e, t){
        if (!isFinite(e) || e < -90 || e > 90) throw new FirestoreError(D.INVALID_ARGUMENT, "Latitude must be a number between -90 and 90, but was: " + e);
        if (!isFinite(t) || t < -180 || t > 180) throw new FirestoreError(D.INVALID_ARGUMENT, "Longitude must be a number between -180 and 180, but was: " + t);
        this._lat = e, this._long = t;
    }
    /**
     * The latitude of this `GeoPoint` instance.
     */ get latitude() {
        return this._lat;
    }
    /**
     * The longitude of this `GeoPoint` instance.
     */ get longitude() {
        return this._long;
    }
    /**
     * Returns true if this `GeoPoint` is equal to the provided one.
     *
     * @param other - The `GeoPoint` to compare against.
     * @returns true if this `GeoPoint` is equal to the provided one.
     */ isEqual(e) {
        return this._lat === e._lat && this._long === e._long;
    }
    /**
     * Actually private to JS consumers of our API, so this function is prefixed
     * with an underscore.
     */ _compareTo(e) {
        return __PRIVATE_primitiveComparator(this._lat, e._lat) || __PRIVATE_primitiveComparator(this._long, e._long);
    }
    /**
     * Returns a JSON-serializable representation of this `GeoPoint` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            latitude: this._lat,
            longitude: this._long,
            type: GeoPoint._jsonSchemaVersion
        };
    }
    /**
     * Builds a `GeoPoint` instance from a JSON object created by {@link GeoPoint.toJSON}.
     *
     * @param json - a JSON object represention of a `GeoPoint` instance
     * @returns an instance of {@link GeoPoint} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if (__PRIVATE_validateJSON(e, GeoPoint._jsonSchema)) return new GeoPoint(e.latitude, e.longitude);
    }
}
/**
 * Creates and returns a new `ExperimentalLongPollingOptions` with the same
 * option values as the given instance.
 */ function __PRIVATE_cloneLongPollingOptions(e) {
    const t = {};
    return void 0 !== e.timeoutSeconds && (t.timeoutSeconds = e.timeoutSeconds), t;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ GeoPoint._jsonSchemaVersion = "firestore/geoPoint/1.0", GeoPoint._jsonSchema = {
    type: property("string", GeoPoint._jsonSchemaVersion),
    latitude: property("number"),
    longitude: property("number")
};
class __PRIVATE_NoopConnectivityMonitor {
    bt(e) {
    // No-op.
    }
    shutdown() {
    // No-op.
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // References to `window` are guarded by BrowserConnectivityMonitor.isAvailable()
/* eslint-disable no-restricted-globals */ const vt = "ConnectivityMonitor";
/**
 * Browser implementation of ConnectivityMonitor.
 */ class __PRIVATE_BrowserConnectivityMonitor {
    constructor(){
        this.vt = ()=>this.St(), this.Dt = ()=>this.xt(), this.Ct = [], this.Ft();
    }
    bt(e) {
        this.Ct.push(e);
    }
    shutdown() {
        window.removeEventListener("online", this.vt), window.removeEventListener("offline", this.Dt);
    }
    Ft() {
        window.addEventListener("online", this.vt), window.addEventListener("offline", this.Dt);
    }
    St() {
        __PRIVATE_logDebug(vt, "Network connectivity changed: AVAILABLE");
        for (const e of this.Ct)e(0 /* NetworkStatus.AVAILABLE */ );
    }
    xt() {
        __PRIVATE_logDebug(vt, "Network connectivity changed: UNAVAILABLE");
        for (const e of this.Ct)e(1 /* NetworkStatus.UNAVAILABLE */ );
    }
    // TODO(chenbrian): Consider passing in window either into this component or
    // here for testing via FakeWindow.
    /** Checks that all used attributes of window are available. */ static C() {
        return "undefined" != typeof window && void 0 !== window.addEventListener && void 0 !== window.removeEventListener;
    }
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The value returned from the most recent invocation of
 * `generateUniqueDebugId()`, or null if it has never been invoked.
 */ let St = null;
/**
 * Generates and returns an initial value for `lastUniqueDebugId`.
 *
 * The returned value is randomly selected from a range of integers that are
 * represented as 8 hexadecimal digits. This means that (within reason) any
 * numbers generated by incrementing the returned number by 1 will also be
 * represented by 8 hexadecimal digits. This leads to all "IDs" having the same
 * length when converted to a hexadecimal string, making reading logs containing
 * these IDs easier to follow. And since the return value is randomly selected
 * it will help to differentiate between logs from different executions.
 */ /**
 * Generates and returns a unique ID as a hexadecimal string.
 *
 * The returned ID is intended to be used in debug logging messages to help
 * correlate log messages that may be spatially separated in the logs, but
 * logically related. For example, a network connection could include the same
 * "debug ID" string in all of its log messages to help trace a specific
 * connection over time.
 *
 * @returns the 10-character generated ID (e.g. "0xa1b2c3d4").
 */ function __PRIVATE_generateUniqueDebugId() {
    return null === St ? St = function __PRIVATE_generateInitialUniqueDebugId() {
        return 268435456 + Math.round(2147483648 * Math.random());
    }() : St++, "0x" + St.toString(16);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const Dt = "RestConnection", xt = {
    BatchGetDocuments: "batchGet",
    Commit: "commit",
    RunQuery: "runQuery",
    RunAggregationQuery: "runAggregationQuery",
    ExecutePipeline: "executePipeline"
};
/**
 * Maps RPC names to the corresponding REST endpoint name.
 *
 * We use array notation to avoid mangling.
 */ /**
 * Base class for all Rest-based connections to the backend (WebChannel and
 * HTTP).
 */ class __PRIVATE_RestConnection {
    get Ot() {
        // Both `invokeRPC()` and `invokeStreamingRPC()` use their `path` arguments to determine
        // where to run the query, and expect the `request` to NOT specify the "path".
        return !1;
    }
    constructor(e){
        this.databaseInfo = e, this.databaseId = e.databaseId;
        const t = e.ssl ? "https" : "http", n = encodeURIComponent(this.databaseId.projectId), r = encodeURIComponent(this.databaseId.database);
        this.Mt = t + "://" + e.host, this.Nt = `projects/${n}/databases/${r}`, this.Lt = this.databaseId.database === st ? `project_id=${n}` : `project_id=${n}&database_id=${r}`;
    }
    Bt(e, t, n, r, i) {
        const s = __PRIVATE_generateUniqueDebugId(), _ = this.Ut(e, t.toUriEncodedString());
        __PRIVATE_logDebug(Dt, `Sending RPC '${e}' ${s}:`, _, n);
        const a = {
            "google-cloud-resource-prefix": this.Nt,
            "x-goog-request-params": this.Lt
        };
        this.kt(a, r, i);
        const { host: u } = new URL(_), c = (0, _util.isCloudWorkstation)(u);
        return this.qt(e, _, a, n, c).then((t)=>(__PRIVATE_logDebug(Dt, `Received RPC '${e}' ${s}: `, t), t), (t)=>{
            throw __PRIVATE_logWarn(Dt, `RPC '${e}' ${s} failed with error: `, t, "url: ", _, "request:", n), t;
        });
    }
    $t(e, t, n, r, i, s) {
        // The REST API automatically aggregates all of the streamed results, so we
        // can just use the normal invoke() method.
        return this.Bt(e, t, n, r, i);
    }
    /**
     * Modifies the headers for a request, adding any authorization token if
     * present and any additional headers for the request.
     */ kt(e, t, n) {
        e["X-Goog-Api-Client"] = // SDK_VERSION is updated to different value at runtime depending on the entry point,
        // so we need to get its value when we need it in a function.
        function __PRIVATE_getGoogApiClientValue() {
            return "gl-js/ fire/" + v;
        }(), // Content-Type: text/plain will avoid preflight requests which might
        // mess with CORS and redirects by proxies. If we add custom headers
        // we will need to change this code to potentially use the $httpOverwrite
        // parameter supported by ESF to avoid triggering preflight requests.
        e["Content-Type"] = "text/plain", this.databaseInfo.appId && (e["X-Firebase-GMPID"] = this.databaseInfo.appId), t && t.headers.forEach((t, n)=>e[n] = t), n && n.headers.forEach((t, n)=>e[n] = t);
    }
    Ut(e, t) {
        const n = xt[e];
        let r = `${this.Mt}/v1/${t}:${n}`;
        return this.databaseInfo.apiKey && (r = `${r}?key=${encodeURIComponent(this.databaseInfo.apiKey)}`), r;
    }
    /**
     * Closes and cleans up any resources associated with the connection. This
     * implementation is a no-op because there are no resources associated
     * with the RestConnection that need to be cleaned up.
     */ terminate() {
    // No-op
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides a simple helper class that implements the Stream interface to
 * bridge to other implementations that are streams but do not implement the
 * interface. The stream callbacks are invoked with the callOn... methods.
 */ class __PRIVATE_StreamBridge {
    constructor(e){
        this.Kt = e.Kt, this.Wt = e.Wt;
    }
    Qt(e) {
        this.Gt = e;
    }
    zt(e) {
        this.jt = e;
    }
    Ht(e) {
        this.Jt = e;
    }
    onMessage(e) {
        this.Yt = e;
    }
    close() {
        this.Wt();
    }
    send(e) {
        this.Kt(e);
    }
    Zt() {
        this.Gt();
    }
    Xt() {
        this.jt();
    }
    en(e) {
        this.Jt(e);
    }
    tn(e) {
        this.Yt(e);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const Ct = "WebChannelConnection", __PRIVATE_unguardedEventListen = (e, t, n)=>{
    // TODO(dimond): closure typing seems broken because WebChannel does
    // not implement goog.events.Listenable
    e.listen(t, (e)=>{
        try {
            n(e);
        } catch (e) {
            setTimeout(()=>{
                throw e;
            }, 0);
        }
    });
};
class __PRIVATE_WebChannelConnection extends __PRIVATE_RestConnection {
    constructor(e){
        super(e), /** A collection of open WebChannel instances */ this.nn = [], this.forceLongPolling = e.forceLongPolling, this.autoDetectLongPolling = e.autoDetectLongPolling, this.useFetchStreams = e.useFetchStreams, this.longPollingOptions = e.longPollingOptions;
    }
    /**
     * Initialize STAT_EVENT listener once. Subsequent calls are a no-op.
     * getStatEventTarget() returns the same target every time.
     */ static rn() {
        if (!__PRIVATE_WebChannelConnection.sn) {
            const e = (0, _webchannelBlob.getStatEventTarget)();
            __PRIVATE_unguardedEventListen(e, (0, _webchannelBlob.Event).STAT_EVENT, (e)=>{
                e.stat === (0, _webchannelBlob.Stat).PROXY ? __PRIVATE_logDebug(Ct, "STAT_EVENT: detected buffering proxy") : e.stat === (0, _webchannelBlob.Stat).NOPROXY && __PRIVATE_logDebug(Ct, "STAT_EVENT: detected no buffering proxy");
            }), __PRIVATE_WebChannelConnection.sn = !0;
        }
    }
    qt(e, t, n, r, i) {
        const s = __PRIVATE_generateUniqueDebugId();
        return new Promise((i, _)=>{
            const o = new (0, _webchannelBlob.XhrIo);
            o.setWithCredentials(!0), o.listenOnce((0, _webchannelBlob.EventType).COMPLETE, ()=>{
                try {
                    switch(o.getLastErrorCode()){
                        case (0, _webchannelBlob.ErrorCode).NO_ERROR:
                            const t = o.getResponseJson();
                            __PRIVATE_logDebug(Ct, `XHR for RPC '${e}' ${s} received:`, JSON.stringify(t)), i(t);
                            break;
                        case (0, _webchannelBlob.ErrorCode).TIMEOUT:
                            __PRIVATE_logDebug(Ct, `RPC '${e}' ${s} timed out`), _(new FirestoreError(D.DEADLINE_EXCEEDED, "Request time out"));
                            break;
                        case (0, _webchannelBlob.ErrorCode).HTTP_ERROR:
                            const n = o.getStatus();
                            if (__PRIVATE_logDebug(Ct, `RPC '${e}' ${s} failed with status:`, n, "response text:", o.getResponseText()), n > 0) {
                                let e = o.getResponseJson();
                                Array.isArray(e) && (e = e[0]);
                                const t = e?.error;
                                if (t && t.status && t.message) {
                                    const e = function __PRIVATE_mapCodeFromHttpResponseErrorStatus(e) {
                                        const t = e.toLowerCase().replace(/_/g, "-");
                                        return Object.values(D).indexOf(t) >= 0 ? t : D.UNKNOWN;
                                    }(t.status);
                                    _(new FirestoreError(e, t.message));
                                } else _(new FirestoreError(D.UNKNOWN, "Server responded with status " + o.getStatus()));
                            } else // If we received an HTTP_ERROR but there's no status code,
                            // it's most probably a connection issue
                            _(new FirestoreError(D.UNAVAILABLE, "Connection failed."));
                            break;
                        default:
                            fail(9055, {
                                _n: e,
                                streamId: s,
                                an: o.getLastErrorCode(),
                                un: o.getLastError()
                            });
                    }
                } finally{
                    __PRIVATE_logDebug(Ct, `RPC '${e}' ${s} completed.`);
                }
            });
            const a = JSON.stringify(r);
            __PRIVATE_logDebug(Ct, `RPC '${e}' ${s} sending request:`, r), o.send(t, "POST", a, n, 15);
        });
    }
    cn(e, t, n) {
        const r = __PRIVATE_generateUniqueDebugId(), i = [
            this.Mt,
            "/",
            "google.firestore.v1.Firestore",
            "/",
            e,
            "/channel"
        ], s = this.createWebChannelTransport(), _ = {
            // Required for backend stickiness, routing behavior is based on this
            // parameter.
            httpSessionIdParam: "gsessionid",
            initMessageHeaders: {},
            messageUrlParams: {
                // This param is used to improve routing and project isolation by the
                // backend and must be included in every request.
                database: `projects/${this.databaseId.projectId}/databases/${this.databaseId.database}`
            },
            sendRawJson: !0,
            supportsCrossDomainXhr: !0,
            internalChannelParams: {
                // Override the default timeout (randomized between 10-20 seconds) since
                // a large write batch on a slow internet connection may take a long
                // time to send to the backend. Rather than have WebChannel impose a
                // tight timeout which could lead to infinite timeouts and retries, we
                // set it very large (5-10 minutes) and rely on the browser's builtin
                // timeouts to kick in if the request isn't working.
                forwardChannelRequestTimeoutMs: 6e5
            },
            forceLongPolling: this.forceLongPolling,
            detectBufferingProxy: this.autoDetectLongPolling
        }, o = this.longPollingOptions.timeoutSeconds;
        void 0 !== o && (_.longPollingTimeout = Math.round(1e3 * o)), this.useFetchStreams && (_.useFetchStreams = !0), this.kt(_.initMessageHeaders, t, n), // Sending the custom headers we just added to request.initMessageHeaders
        // (Authorization, etc.) will trigger the browser to make a CORS preflight
        // request because the XHR will no longer meet the criteria for a "simple"
        // CORS request:
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/CORS#Simple_requests
        // Therefore to avoid the CORS preflight request (an extra network
        // roundtrip), we use the encodeInitMessageHeaders option to specify that
        // the headers should instead be encoded in the request's POST payload,
        // which is recognized by the webchannel backend.
        _.encodeInitMessageHeaders = !0;
        const a = i.join("");
        __PRIVATE_logDebug(Ct, `Creating RPC '${e}' stream ${r}: ${a}`, _);
        const u = s.createWebChannel(a, _);
        this.En(u);
        // WebChannel supports sending the first message with the handshake - saving
        // a network round trip. However, it will have to call send in the same
        // JS event loop as open. In order to enforce this, we delay actually
        // opening the WebChannel until send is called. Whether we have called
        // open is tracked with this variable.
        let c = !1, l = !1;
        // A flag to determine whether the stream was closed (by us or through an
        // error/close event) to avoid delivering multiple close events or sending
        // on a closed stream
        const E = new __PRIVATE_StreamBridge({
            Kt: (t)=>{
                l ? __PRIVATE_logDebug(Ct, `Not sending because RPC '${e}' stream ${r} is closed:`, t) : (c || (__PRIVATE_logDebug(Ct, `Opening RPC '${e}' stream ${r} transport.`), u.open(), c = !0), __PRIVATE_logDebug(Ct, `RPC '${e}' stream ${r} sending:`, t), u.send(t));
            },
            Wt: ()=>u.close()
        });
        return __PRIVATE_unguardedEventListen(u, (0, _webchannelBlob.WebChannel).EventType.OPEN, ()=>{
            l || (__PRIVATE_logDebug(Ct, `RPC '${e}' stream ${r} transport opened.`), E.Zt());
        }), __PRIVATE_unguardedEventListen(u, (0, _webchannelBlob.WebChannel).EventType.CLOSE, ()=>{
            l || (l = !0, __PRIVATE_logDebug(Ct, `RPC '${e}' stream ${r} transport closed`), E.en(), this.hn(u));
        }), __PRIVATE_unguardedEventListen(u, (0, _webchannelBlob.WebChannel).EventType.ERROR, (t)=>{
            l || (l = !0, __PRIVATE_logWarn(Ct, `RPC '${e}' stream ${r} transport errored. Name:`, t.name, "Message:", t.message), E.en(new FirestoreError(D.UNAVAILABLE, "The operation could not be completed")));
        }), __PRIVATE_unguardedEventListen(u, (0, _webchannelBlob.WebChannel).EventType.MESSAGE, (t)=>{
            if (!l) {
                const n = t.data[0];
                __PRIVATE_hardAssert(!!n, 16349);
                // TODO(b/35143891): There is a bug in One Platform that caused errors
                // (and only errors) to be wrapped in an extra array. To be forward
                // compatible with the bug we need to check either condition. The latter
                // can be removed once the fix has been rolled out.
                // Use any because msgData.error is not typed.
                const i = n, s = i?.error || i[0]?.error;
                if (s) {
                    __PRIVATE_logDebug(Ct, `RPC '${e}' stream ${r} received error:`, s);
                    // error.status will be a string like 'OK' or 'NOT_FOUND'.
                    const t = s.status;
                    let n = /**
 * Maps an error Code from a GRPC status identifier like 'NOT_FOUND'.
 *
 * @returns The Code equivalent to the given status string or undefined if
 *     there is no match.
 */ function __PRIVATE_mapCodeFromRpcStatus(e) {
                        // lookup by string
                        // eslint-disable-next-line @typescript-eslint/no-explicit-any
                        const t = Pt[e];
                        if (void 0 !== t) return __PRIVATE_mapCodeFromRpcCode(t);
                    }(t), i = s.message;
                    "NOT_FOUND" === t && i.includes("database") && i.includes("does not exist") && i.includes(this.databaseId.database) && __PRIVATE_logWarn(`Database '${this.databaseId.database}' not found. Please check your project configuration.`), void 0 === n && (n = D.INTERNAL, i = "Unknown error status: " + t + " with message " + s.message), // Mark closed so no further events are propagated
                    l = !0, E.en(new FirestoreError(n, i)), u.close();
                } else __PRIVATE_logDebug(Ct, `RPC '${e}' stream ${r} received:`, n), E.tn(n);
            }
        }), // Ensure that event listeners are configured for STAT_EVENTs.
        __PRIVATE_WebChannelConnection.rn(), setTimeout(()=>{
            // Technically we could/should wait for the WebChannel opened event,
            // but because we want to send the first message with the WebChannel
            // handshake we pretend the channel opened here (asynchronously), and
            // then delay the actual open until the first message is sent.
            E.Xt();
        }, 0), E;
    }
    /**
     * Closes and cleans up any resources associated with the connection.
     */ terminate() {
        // If the Firestore instance is terminated, we will explicitly
        // close any remaining open WebChannel instances.
        this.nn.forEach((e)=>e.close()), this.nn = [];
    }
    /**
     * Add a WebChannel instance to the collection of open instances.
     * @param webChannel
     */ En(e) {
        this.nn.push(e);
    }
    /**
     * Remove a WebChannel instance from the collection of open instances.
     * @param webChannel
     */ hn(e) {
        this.nn = this.nn.filter((t)=>t === e);
    }
    /**
     * Modifies the headers for a request, adding the api key if present,
     * and then calling super.modifyHeadersForRequest
     */ kt(e, t, n) {
        super.kt(e, t, n), // For web channel streams, we want to send the api key in the headers.
        this.databaseInfo.apiKey && (e["x-goog-api-key"] = this.databaseInfo.apiKey);
    }
    /**
     * Wrapped for mocking.
     * @protected
     */ createWebChannelTransport() {
        return (0, _webchannelBlob.createWebChannelTransport)();
    }
}
/**
 * Track if the STAT_EVENT listener has been initialized.
 */ /**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Initializes the WebChannelConnection for the browser. */ function __PRIVATE_newConnection(e) {
    return new __PRIVATE_WebChannelConnection(e);
}
/** Return the Platform-specific connectivity monitor. */ __PRIVATE_WebChannelConnection.sn = !1;
/**
 * A helper for running delayed tasks following an exponential backoff curve
 * between attempts.
 *
 * Each delay is made up of a "base" delay which follows the exponential
 * backoff curve, and a +/- 50% "jitter" that is calculated and added to the
 * base delay. This prevents clients from accidentally synchronizing their
 * delays causing spikes of load to the backend.
 */ class __PRIVATE_ExponentialBackoff {
    constructor(/**
     * The AsyncQueue to run backoff operations on.
     */ e, /**
     * The ID to use when scheduling backoff operations on the AsyncQueue.
     */ t, /**
     * The initial delay (used as the base delay on the first retry attempt).
     * Note that jitter will still be applied, so the actual delay could be as
     * little as 0.5*initialDelayMs.
     */ n = 1e3, r = 1.5, i = 6e4){
        this.Tn = e, this.timerId = t, this.Pn = n, this.Rn = r, this.In = i, this.An = 0, this.Vn = null, /** The last backoff attempt, as epoch milliseconds. */ this.dn = Date.now(), this.reset();
    }
    /**
     * Resets the backoff delay.
     *
     * The very next backoffAndWait() will have no delay. If it is called again
     * (i.e. due to an error), initialDelayMs (plus jitter) will be used, and
     * subsequent ones will increase according to the backoffFactor.
     */ reset() {
        this.An = 0;
    }
    /**
     * Resets the backoff delay to the maximum delay (e.g. for use after a
     * RESOURCE_EXHAUSTED error).
     */ fn() {
        this.An = this.In;
    }
    /**
     * Returns a promise that resolves after currentDelayMs, and increases the
     * delay for any subsequent attempts. If there was a pending backoff operation
     * already, it will be canceled.
     */ mn(e) {
        // Cancel any pending backoff operation.
        this.cancel();
        // First schedule using the current base (which may be 0 and should be
        // honored as such).
        const t = Math.floor(this.An + this.pn()), n = Math.max(0, Date.now() - this.dn), r = Math.max(0, t - n);
        // Guard against lastAttemptTime being in the future due to a clock change.
        r > 0 && __PRIVATE_logDebug("ExponentialBackoff", `Backing off for ${r} ms (base delay: ${this.An} ms, delay with jitter: ${t} ms, last attempt: ${n} ms ago)`), this.Vn = this.Tn.enqueueAfterDelay(this.timerId, r, ()=>(this.dn = Date.now(), e())), // Apply backoff factor to determine next delay and ensure it is within
        // bounds.
        this.An *= this.Rn, this.An < this.Pn && (this.An = this.Pn), this.An > this.In && (this.An = this.In);
    }
    gn() {
        null !== this.Vn && (this.Vn.skipDelay(), this.Vn = null);
    }
    cancel() {
        null !== this.Vn && (this.Vn.cancel(), this.Vn = null);
    }
    /** Returns a random value in the range [-currentBaseMs/2, currentBaseMs/2] */ pn() {
        return (Math.random() - .5) * this.An;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const Ft = "PersistentStream";
/** The time a stream stays open after it is marked idle. */ /**
 * A PersistentStream is an abstract base class that represents a streaming RPC
 * to the Firestore backend. It's built on top of the connections own support
 * for streaming RPCs, and adds several critical features for our clients:
 *
 *   - Exponential backoff on failure
 *   - Authentication via CredentialsProvider
 *   - Dispatching all callbacks into the shared worker queue
 *   - Closing idle streams after 60 seconds of inactivity
 *
 * Subclasses of PersistentStream implement serialization of models to and
 * from the JSON representation of the protocol buffers for a specific
 * streaming RPC.
 *
 * ## Starting and Stopping
 *
 * Streaming RPCs are stateful and need to be start()ed before messages can
 * be sent and received. The PersistentStream will call the onOpen() function
 * of the listener once the stream is ready to accept requests.
 *
 * Should a start() fail, PersistentStream will call the registered onClose()
 * listener with a FirestoreError indicating what went wrong.
 *
 * A PersistentStream can be started and stopped repeatedly.
 *
 * Generic types:
 *  SendType: The type of the outgoing message of the underlying
 *    connection stream
 *  ReceiveType: The type of the incoming message of the underlying
 *    connection stream
 *  ListenerType: The type of the listener that will be used for callbacks
 */ class __PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s, _, o){
        this.Tn = e, this.yn = n, this.wn = r, this.connection = i, this.authCredentialsProvider = s, this.appCheckCredentialsProvider = _, this.listener = o, this.state = 0 /* PersistentStreamState.Initial */ , /**
         * A close count that's incremented every time the stream is closed; used by
         * getCloseGuardedDispatcher() to invalidate callbacks that happen after
         * close.
         */ this.bn = 0, this.vn = null, this.Sn = null, this.stream = null, /**
         * Count of response messages received.
         */ this.Dn = 0, this.xn = new __PRIVATE_ExponentialBackoff(e, t);
    }
    /**
     * Returns true if start() has been called and no error has occurred. True
     * indicates the stream is open or in the process of opening (which
     * encompasses respecting backoff, getting auth tokens, and starting the
     * actual RPC). Use isOpen() to determine if the stream is open and ready for
     * outbound requests.
     */ Cn() {
        return 1 /* PersistentStreamState.Starting */  === this.state || 5 /* PersistentStreamState.Backoff */  === this.state || this.Fn();
    }
    /**
     * Returns true if the underlying RPC is open (the onOpen() listener has been
     * called) and the stream is ready for outbound requests.
     */ Fn() {
        return 2 /* PersistentStreamState.Open */  === this.state || 3 /* PersistentStreamState.Healthy */  === this.state;
    }
    /**
     * Starts the RPC. Only allowed if isStarted() returns false. The stream is
     * not immediately ready for use: onOpen() will be invoked when the RPC is
     * ready for outbound requests, at which point isOpen() will return true.
     *
     * When start returns, isStarted() will return true.
     */ start() {
        this.Dn = 0, 4 /* PersistentStreamState.Error */  !== this.state ? this.auth() : this.On();
    }
    /**
     * Stops the RPC. This call is idempotent and allowed regardless of the
     * current isStarted() state.
     *
     * When stop returns, isStarted() and isOpen() will both return false.
     */ async stop() {
        this.Cn() && await this.close(0 /* PersistentStreamState.Initial */ );
    }
    /**
     * After an error the stream will usually back off on the next attempt to
     * start it. If the error warrants an immediate restart of the stream, the
     * sender can use this to indicate that the receiver should not back off.
     *
     * Each error will call the onClose() listener. That function can decide to
     * inhibit backoff if required.
     */ Mn() {
        this.state = 0 /* PersistentStreamState.Initial */ , this.xn.reset();
    }
    /**
     * Marks this stream as idle. If no further actions are performed on the
     * stream for one minute, the stream will automatically close itself and
     * notify the stream's onClose() handler with Status.OK. The stream will then
     * be in a !isStarted() state, requiring the caller to start the stream again
     * before further use.
     *
     * Only streams that are in state 'Open' can be marked idle, as all other
     * states imply pending network operations.
     */ Nn() {
        // Starts the idle time if we are in state 'Open' and are not yet already
        // running a timer (in which case the previous idle timeout still applies).
        this.Fn() && null === this.vn && (this.vn = this.Tn.enqueueAfterDelay(this.yn, 6e4, ()=>this.Ln()));
    }
    /** Sends a message to the underlying stream. */ Bn(e) {
        this.Un(), this.stream.send(e);
    }
    /** Called by the idle timer when the stream should close due to inactivity. */ async Ln() {
        if (this.Fn()) // When timing out an idle stream there's no reason to force the stream into backoff when
        // it restarts so set the stream state to Initial instead of Error.
        return this.close(0 /* PersistentStreamState.Initial */ );
    }
    /** Marks the stream as active again. */ Un() {
        this.vn && (this.vn.cancel(), this.vn = null);
    }
    /** Cancels the health check delayed operation. */ kn() {
        this.Sn && (this.Sn.cancel(), this.Sn = null);
    }
    /**
     * Closes the stream and cleans up as necessary:
     *
     * * closes the underlying GRPC stream;
     * * calls the onClose handler with the given 'error';
     * * sets internal stream state to 'finalState';
     * * adjusts the backoff timer based on the error
     *
     * A new stream can be opened by calling start().
     *
     * @param finalState - the intended state of the stream after closing.
     * @param error - the error the connection was closed with.
     */ async close(e, t) {
        // Cancel any outstanding timers (they're guaranteed not to execute).
        this.Un(), this.kn(), this.xn.cancel(), // Invalidates any stream-related callbacks (e.g. from auth or the
        // underlying stream), guaranteeing they won't execute.
        this.bn++, 4 /* PersistentStreamState.Error */  !== e ? // If this is an intentional close ensure we don't delay our next connection attempt.
        this.xn.reset() : t && t.code === D.RESOURCE_EXHAUSTED ? // Log the error. (Probably either 'quota exceeded' or 'max queue length reached'.)
        (__PRIVATE_logError(t.toString()), __PRIVATE_logError("Using maximum backoff delay to prevent overloading the backend."), this.xn.fn()) : t && t.code === D.UNAUTHENTICATED && 3 /* PersistentStreamState.Healthy */  !== this.state && // "unauthenticated" error means the token was rejected. This should rarely
        // happen since both Auth and AppCheck ensure a sufficient TTL when we
        // request a token. If a user manually resets their system clock this can
        // fail, however. In this case, we should get a Code.UNAUTHENTICATED error
        // before we received the first message and we need to invalidate the token
        // to ensure that we fetch a new token.
        (this.authCredentialsProvider.invalidateToken(), this.appCheckCredentialsProvider.invalidateToken()), // Clean up the underlying stream because we are no longer interested in events.
        null !== this.stream && (this.qn(), this.stream.close(), this.stream = null), // This state must be assigned before calling onClose() to allow the callback to
        // inhibit backoff or otherwise manipulate the state in its non-started state.
        this.state = e, // Notify the listener that the stream closed.
        await this.listener.Ht(t);
    }
    /**
     * Can be overridden to perform additional cleanup before the stream is closed.
     * Calling super.tearDown() is not required.
     */ qn() {}
    auth() {
        this.state = 1 /* PersistentStreamState.Starting */ ;
        const e = this.$n(this.bn), t = this.bn;
        // TODO(mikelehen): Just use dispatchIfNotClosed, but see TODO below.
        Promise.all([
            this.authCredentialsProvider.getToken(),
            this.appCheckCredentialsProvider.getToken()
        ]).then(([e, n])=>{
            // Stream can be stopped while waiting for authentication.
            // TODO(mikelehen): We really should just use dispatchIfNotClosed
            // and let this dispatch onto the queue, but that opened a spec test can
            // of worms that I don't want to deal with in this PR.
            this.bn === t && // Normally we'd have to schedule the callback on the AsyncQueue.
            // However, the following calls are safe to be called outside the
            // AsyncQueue since they don't chain asynchronous calls
            this.Kn(e, n);
        }, (t)=>{
            e(()=>{
                const e = new FirestoreError(D.UNKNOWN, "Fetching auth token failed: " + t.message);
                return this.Wn(e);
            });
        });
    }
    Kn(e, t) {
        const n = this.$n(this.bn);
        this.stream = this.Qn(e, t), this.stream.Qt(()=>{
            n(()=>this.listener.Qt());
        }), this.stream.zt(()=>{
            n(()=>(this.state = 2 /* PersistentStreamState.Open */ , this.Sn = this.Tn.enqueueAfterDelay(this.wn, 1e4, ()=>(this.Fn() && (this.state = 3 /* PersistentStreamState.Healthy */ ), Promise.resolve())), this.listener.zt()));
        }), this.stream.Ht((e)=>{
            n(()=>this.Wn(e));
        }), this.stream.onMessage((e)=>{
            n(()=>1 == ++this.Dn ? this.Gn(e) : this.onNext(e));
        });
    }
    On() {
        this.state = 5 /* PersistentStreamState.Backoff */ , this.xn.mn(async ()=>{
            this.state = 0 /* PersistentStreamState.Initial */ , this.start();
        });
    }
    // Visible for tests
    Wn(e) {
        // In theory the stream could close cleanly, however, in our current model
        // we never expect this to happen because if we stop a stream ourselves,
        // this callback will never be called. To prevent cases where we retry
        // without a backoff accidentally, we set the stream to error in all cases.
        return __PRIVATE_logDebug(Ft, `close with error: ${e}`), this.stream = null, this.close(4 /* PersistentStreamState.Error */ , e);
    }
    /**
     * Returns a "dispatcher" function that dispatches operations onto the
     * AsyncQueue but only runs them if closeCount remains unchanged. This allows
     * us to turn auth / stream callbacks into no-ops if the stream is closed /
     * re-opened, etc.
     */ $n(e) {
        return (t)=>{
            this.Tn.enqueueAndForget(()=>this.bn === e ? t() : (__PRIVATE_logDebug(Ft, "stream callback skipped by getCloseGuardedDispatcher."), Promise.resolve()));
        };
    }
}
/**
 * A PersistentStream that implements the Listen RPC.
 *
 * Once the Listen stream has called the onOpen() listener, any number of
 * listen() and unlisten() calls can be made to control what changes will be
 * sent from the server for ListenResponses.
 */ class __PRIVATE_PersistentListenStream extends __PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "listen_stream_connection_backoff" /* TimerId.ListenStreamConnectionBackoff */ , "listen_stream_idle" /* TimerId.ListenStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    Qn(e, t) {
        return this.connection.cn("Listen", e, t);
    }
    Gn(e) {
        return this.onNext(e);
    }
    onNext(e) {
        // A successful response means the stream is healthy
        this.xn.reset();
        const t = __PRIVATE_fromWatchChange(this.serializer, e), n = function __PRIVATE_versionFromListenResponse(e) {
            // We have only reached a consistent snapshot for the entire stream if there
            // is a read_time set and it applies to all targets (i.e. the list of
            // targets is empty). The backend is guaranteed to send such responses.
            if (!("targetChange" in e)) return SnapshotVersion.min();
            const t = e.targetChange;
            return t.targetIds && t.targetIds.length ? SnapshotVersion.min() : t.readTime ? __PRIVATE_fromVersion(t.readTime) : SnapshotVersion.min();
        }(e);
        return this.listener.zn(t, n);
    }
    /**
     * Registers interest in the results of the given target. If the target
     * includes a resumeToken it will be included in the request. Results that
     * affect the target will be streamed back as WatchChange messages that
     * reference the targetId.
     */ jn(e) {
        const t = {};
        t.database = __PRIVATE_getEncodedDatabaseId(this.serializer), t.addTarget = function __PRIVATE_toTarget(e, t) {
            let n;
            const r = t.target;
            if (n = __PRIVATE_targetIsPipelineTarget(r) ? {
                pipelineQuery: __PRIVATE_toPipelineTarget(e, r)
            } : __PRIVATE_targetIsDocumentTarget(r) ? {
                documents: __PRIVATE_toDocumentsTarget(e, r)
            } : {
                query: __PRIVATE_toQueryTarget(e, r).yt
            }, n.targetId = t.targetId, t.resumeToken.approximateByteSize() > 0) {
                n.resumeToken = __PRIVATE_toBytes(e, t.resumeToken);
                const r = __PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            } else if (t.snapshotVersion.compareTo(SnapshotVersion.min()) > 0) {
                // TODO(wuandy): Consider removing above check because it is most likely true.
                // Right now, many tests depend on this behaviour though (leaving min() out
                // of serialization).
                n.readTime = toTimestamp(e, t.snapshotVersion.toTimestamp());
                const r = __PRIVATE_toInt32Proto(e, t.expectedCount);
                null !== r && (n.expectedCount = r);
            }
            return n;
        }(this.serializer, e);
        const n = __PRIVATE_toListenRequestLabels(this.serializer, e);
        n && (t.labels = n), this.Bn(t);
    }
    /**
     * Unregisters interest in the results of the target associated with the
     * given targetId.
     */ Hn(e) {
        const t = {};
        t.database = __PRIVATE_getEncodedDatabaseId(this.serializer), t.removeTarget = e, this.Bn(t);
    }
}
/**
 * A Stream that implements the Write RPC.
 *
 * The Write RPC requires the caller to maintain special streamToken
 * state in between calls, to help the server understand which responses the
 * client has processed by the time the next request is made. Every response
 * will contain a streamToken; this value must be passed to the next
 * request.
 *
 * After calling start() on this stream, the next request must be a handshake,
 * containing whatever streamToken is on hand. Once a response to this
 * request is received, all pending mutations may be submitted. When
 * submitting multiple batches of mutations at the same time, it's
 * okay to use the same streamToken for the calls to writeMutations.
 *
 * TODO(b/33271235): Use proto types
 */ class __PRIVATE_PersistentWriteStream extends __PRIVATE_PersistentStream {
    constructor(e, t, n, r, i, s){
        super(e, "write_stream_connection_backoff" /* TimerId.WriteStreamConnectionBackoff */ , "write_stream_idle" /* TimerId.WriteStreamIdle */ , "health_check_timeout" /* TimerId.HealthCheckTimeout */ , t, n, r, s), this.serializer = i;
    }
    /**
     * Tracks whether or not a handshake has been successfully exchanged and
     * the stream is ready to accept mutations.
     */ get Jn() {
        return this.Dn > 0;
    }
    // Override of PersistentStream.start
    start() {
        this.lastStreamToken = void 0, super.start();
    }
    qn() {
        this.Jn && this.Yn([]);
    }
    Qn(e, t) {
        return this.connection.cn("Write", e, t);
    }
    Gn(e) {
        // Always capture the last stream token.
        return __PRIVATE_hardAssert(!!e.streamToken, 31322), this.lastStreamToken = e.streamToken, // The first response is always the handshake response
        __PRIVATE_hardAssert(!e.writeResults || 0 === e.writeResults.length, 55816), this.listener.Zn();
    }
    onNext(e) {
        // Always capture the last stream token.
        __PRIVATE_hardAssert(!!e.streamToken, 12678), this.lastStreamToken = e.streamToken, // A successful first write response means the stream is healthy,
        // Note, that we could consider a successful handshake healthy, however,
        // the write itself might be causing an error we want to back off from.
        this.xn.reset();
        const t = __PRIVATE_fromWriteResults(e.writeResults, e.commitTime), n = __PRIVATE_fromVersion(e.commitTime);
        return this.listener.Xn(n, t);
    }
    /**
     * Sends an initial streamToken to the server, performing the handshake
     * required to make the StreamingWrite RPC work. Subsequent
     * calls should wait until onHandshakeComplete was called.
     */ er() {
        // TODO(dimond): Support stream resumption. We intentionally do not set the
        // stream token on the handshake, ignoring any stream token we might have.
        const e = {};
        e.database = __PRIVATE_getEncodedDatabaseId(this.serializer), this.Bn(e);
    }
    /** Sends a group of mutations to the Firestore backend to apply. */ Yn(e) {
        const t = {
            streamToken: this.lastStreamToken,
            writes: e.map((e)=>toMutation(this.serializer, e))
        };
        this.Bn(t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Datastore and its related methods are a wrapper around the external Google
 * Cloud Datastore grpc API, which provides an interface that is more convenient
 * for the rest of the client SDK architecture to consume.
 */ class Datastore {
}
/**
 * An implementation of Datastore that exposes additional state for internal
 * consumption.
 */ class __PRIVATE_DatastoreImpl extends Datastore {
    constructor(e, t, n, r){
        super(), this.authCredentials = e, this.appCheckCredentials = t, this.connection = n, this.serializer = r, this.tr = !1;
    }
    nr() {
        if (this.tr) throw new FirestoreError(D.FAILED_PRECONDITION, "The client has already been terminated.");
    }
    /** Invokes the provided RPC with auth and AppCheck tokens. */ Bt(e, t, n, r) {
        return this.nr(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([i, s])=>this.connection.Bt(e, __PRIVATE_toResourcePath(t, n), r, i, s)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === D.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new FirestoreError(D.UNKNOWN, e.toString());
        });
    }
    /** Invokes the provided RPC with streamed results with auth and AppCheck tokens. */ $t(e, t, n, r, i) {
        return this.nr(), Promise.all([
            this.authCredentials.getToken(),
            this.appCheckCredentials.getToken()
        ]).then(([s, _])=>this.connection.$t(e, __PRIVATE_toResourcePath(t, n), r, s, _, i)).catch((e)=>{
            throw "FirebaseError" === e.name ? (e.code === D.UNAUTHENTICATED && (this.authCredentials.invalidateToken(), this.appCheckCredentials.invalidateToken()), e) : new FirestoreError(D.UNKNOWN, e.toString());
        });
    }
    terminate() {
        this.tr = !0, this.connection.terminate();
    }
}
// TODO(firestorexp): Make sure there is only one Datastore instance per
// firestore-exp client.
function __PRIVATE_newDatastore(e, t, n, r) {
    return new __PRIVATE_DatastoreImpl(e, t, n, r);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const Ot = "ComponentProvider", Mt = new Map;
/**
 * An instance map that ensures only one Datastore exists per Firestore
 * instance.
 */ function __PRIVATE_makeDatabaseInfo(e, t, n, r, i) {
    return new DatabaseInfo(e, t, n, i.host, i.ssl, i.experimentalForceLongPolling, i.experimentalAutoDetectLongPolling, __PRIVATE_cloneLongPollingOptions(i.experimentalLongPollingOptions), i.useFetchStreams, i.isUsingEmulator, r);
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const Nt = {
    didRun: !1,
    sequenceNumbersCollected: 0,
    targetsRemoved: 0,
    documentsRemoved: 0
}, Lt = 41943040;
class LruParams {
    static withCacheSize(e) {
        return new LruParams(e, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT);
    }
    constructor(// When we attempt to collect, we will only do so if the cache size is greater than this
    // threshold. Passing `COLLECTION_DISABLED` here will cause collection to always be skipped.
    e, // The percentage of sequence numbers that we will attempt to collect
    t, // A cap on the total number of sequence numbers that will be collected. This prevents
    // us from collecting a huge number of sequence numbers if the cache has grown very large.
    n){
        this.cacheSizeCollectionThreshold = e, this.percentileToCollect = t, this.maximumSequenceNumbersToCollect = n;
    }
}
LruParams.DEFAULT_COLLECTION_PERCENTILE = 10, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT = 1e3, LruParams.DEFAULT = new LruParams(Lt, LruParams.DEFAULT_COLLECTION_PERCENTILE, LruParams.DEFAULT_MAX_SEQUENCE_NUMBERS_TO_COLLECT), LruParams.DISABLED = new LruParams(-1, 0, 0);
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const Bt = "LruGarbageCollector", Ut = 1048576;
function __PRIVATE_bufferEntryComparator([e, t], [n, r]) {
    const i = __PRIVATE_primitiveComparator(e, n);
    return 0 === i ? __PRIVATE_primitiveComparator(t, r) : i;
}
/**
 * Used to calculate the nth sequence number. Keeps a rolling buffer of the
 * lowest n values passed to `addElement`, and finally reports the largest of
 * them in `maxValue`.
 */ class __PRIVATE_RollingSequenceNumberBuffer {
    constructor(e){
        this.rr = e, this.buffer = new SortedSet(__PRIVATE_bufferEntryComparator), this.ir = 0;
    }
    sr() {
        return ++this.ir;
    }
    _r(e) {
        const t = [
            e,
            this.sr()
        ];
        if (this.buffer.size < this.rr) this.buffer = this.buffer.add(t);
        else {
            const e = this.buffer.last();
            __PRIVATE_bufferEntryComparator(t, e) < 0 && (this.buffer = this.buffer.delete(e).add(t));
        }
    }
    get maxValue() {
        // Guaranteed to be non-empty. If we decide we are not collecting any
        // sequence numbers, nthSequenceNumber below short-circuits. If we have
        // decided that we are collecting n sequence numbers, it's because n is some
        // percentage of the existing sequence numbers. That means we should never
        // be in a situation where we are collecting sequence numbers but don't
        // actually have any.
        return this.buffer.last()[0];
    }
}
/**
 * This class is responsible for the scheduling of LRU garbage collection. It handles checking
 * whether or not GC is enabled, as well as which delay to use before the next run.
 */ class __PRIVATE_LruScheduler {
    constructor(e, t, n){
        this.garbageCollector = e, this.asyncQueue = t, this.localStore = n, this.ar = null;
    }
    start() {
        -1 !== this.garbageCollector.params.cacheSizeCollectionThreshold && this.ur(6e4);
    }
    stop() {
        this.ar && (this.ar.cancel(), this.ar = null);
    }
    get started() {
        return null !== this.ar;
    }
    ur(e) {
        __PRIVATE_logDebug(Bt, `Garbage collection scheduled in ${e}ms`), this.ar = this.asyncQueue.enqueueAfterDelay("lru_garbage_collection" /* TimerId.LruGarbageCollection */ , e, async ()=>{
            this.ar = null;
            try {
                await this.localStore.collectGarbage(this.garbageCollector);
            } catch (e) {
                __PRIVATE_isIndexedDbTransactionError(e) ? __PRIVATE_logDebug(Bt, "Ignoring IndexedDB error during garbage collection: ", e) : await __PRIVATE_ignoreIfPrimaryLeaseLoss(e);
            }
            await this.ur(3e5);
        });
    }
}
/**
 * Implements the steps for LRU garbage collection.
 */ class __PRIVATE_LruGarbageCollectorImpl {
    constructor(e, t){
        this.cr = e, this.params = t;
    }
    calculateTargetCount(e, t) {
        return this.cr.lr(e).next((e)=>Math.floor(t / 100 * e));
    }
    nthSequenceNumber(e, t) {
        if (0 === t) return PersistencePromise.resolve(__PRIVATE_ListenSequence.ce);
        const n = new __PRIVATE_RollingSequenceNumberBuffer(t);
        return this.cr.forEachTarget(e, (e)=>n._r(e.sequenceNumber)).next(()=>this.cr.Er(e, (e)=>n._r(e))).next(()=>n.maxValue);
    }
    removeTargets(e, t, n) {
        return this.cr.removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        return this.cr.removeOrphanedDocuments(e, t);
    }
    collect(e, t) {
        return -1 === this.params.cacheSizeCollectionThreshold ? (__PRIVATE_logDebug("LruGarbageCollector", "Garbage collection skipped; disabled"), PersistencePromise.resolve(Nt)) : this.getCacheSize(e).next((n)=>n < this.params.cacheSizeCollectionThreshold ? (__PRIVATE_logDebug("LruGarbageCollector", `Garbage collection skipped; Cache size ${n} is lower than threshold ${this.params.cacheSizeCollectionThreshold}`), Nt) : this.hr(e, t));
    }
    getCacheSize(e) {
        return this.cr.getCacheSize(e);
    }
    hr(e, t) {
        let n, r, i, s, _, o, a;
        const u = Date.now();
        return this.calculateTargetCount(e, this.params.percentileToCollect).next((t)=>// Cap at the configured max
            (t > this.params.maximumSequenceNumbersToCollect ? (__PRIVATE_logDebug("LruGarbageCollector", `Capping sequence numbers to collect down to the maximum of ${this.params.maximumSequenceNumbersToCollect} from ${t}`), r = this.params.maximumSequenceNumbersToCollect) : r = t, s = Date.now(), this.nthSequenceNumber(e, r))).next((r)=>(n = r, _ = Date.now(), this.removeTargets(e, n, t))).next((t)=>(i = t, o = Date.now(), this.removeOrphanedDocuments(e, n))).next((e)=>{
            if (a = Date.now(), __PRIVATE_getLogLevel() <= (0, _logger.LogLevel).DEBUG) __PRIVATE_logDebug("LruGarbageCollector", `LRU Garbage Collection\n\tCounted targets in ${s - u}ms\n\tDetermined least recently used ${r} in ` + (_ - s) + "ms\n" + `\tRemoved ${i} targets in ` + (o - _) + "ms\n" + `\tRemoved ${e} documents in ` + (a - o) + "ms\n" + `Total Duration: ${a - u}ms`);
            return PersistencePromise.resolve({
                didRun: !0,
                sequenceNumbersCollected: r,
                targetsRemoved: i,
                documentsRemoved: e
            });
        });
    }
}
function __PRIVATE_newLruGarbageCollector(e, t) {
    return new __PRIVATE_LruGarbageCollectorImpl(e, t);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // settings() defaults:
const kt = "firestore.googleapis.com", qt = !0;
/**
 * A concrete type describing all the values that can be applied via a
 * user-supplied `FirestoreSettings` object. This is a separate type so that
 * defaults can be supplied and the value can be checked for equality.
 */ class FirestoreSettingsImpl {
    constructor(e){
        if (void 0 === e.host) {
            if (void 0 !== e.ssl) throw new FirestoreError(D.INVALID_ARGUMENT, "Can't provide ssl option if host option is not set");
            this.host = kt, this.ssl = qt;
        } else this.host = e.host, this.ssl = e.ssl ?? qt;
        if (this.isUsingEmulator = void 0 !== e.emulatorOptions, this.credentials = e.credentials, this.ignoreUndefinedProperties = !!e.ignoreUndefinedProperties, this.localCache = e.localCache, void 0 === e.cacheSizeBytes) this.cacheSizeBytes = Lt;
        else {
            if (-1 !== e.cacheSizeBytes && e.cacheSizeBytes < Ut) throw new FirestoreError(D.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
            this.cacheSizeBytes = e.cacheSizeBytes;
        }
        __PRIVATE_validateIsNotUsedTogether("experimentalForceLongPolling", e.experimentalForceLongPolling, "experimentalAutoDetectLongPolling", e.experimentalAutoDetectLongPolling), this.experimentalForceLongPolling = !!e.experimentalForceLongPolling, this.experimentalForceLongPolling ? this.experimentalAutoDetectLongPolling = !1 : void 0 === e.experimentalAutoDetectLongPolling ? this.experimentalAutoDetectLongPolling = true : // For backwards compatibility, coerce the value to boolean even though
        // the TypeScript compiler has narrowed the type to boolean already.
        // noinspection PointlessBooleanExpressionJS
        this.experimentalAutoDetectLongPolling = !!e.experimentalAutoDetectLongPolling, this.experimentalLongPollingOptions = __PRIVATE_cloneLongPollingOptions(e.experimentalLongPollingOptions ?? {}), function __PRIVATE_validateLongPollingOptions(e) {
            if (void 0 !== e.timeoutSeconds) {
                if (isNaN(e.timeoutSeconds)) throw new FirestoreError(D.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (must not be NaN)`);
                if (e.timeoutSeconds < 5) throw new FirestoreError(D.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (minimum allowed value is 5)`);
                if (e.timeoutSeconds > 30) throw new FirestoreError(D.INVALID_ARGUMENT, `invalid long polling timeout: ${e.timeoutSeconds} (maximum allowed value is 30)`);
            }
        }(this.experimentalLongPollingOptions), this.useFetchStreams = !!e.useFetchStreams;
    }
    isEqual(e) {
        return this.host === e.host && this.ssl === e.ssl && this.credentials === e.credentials && this.cacheSizeBytes === e.cacheSizeBytes && this.experimentalForceLongPolling === e.experimentalForceLongPolling && this.experimentalAutoDetectLongPolling === e.experimentalAutoDetectLongPolling && /**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two `ExperimentalLongPollingOptions` objects for equality.
 */ function __PRIVATE_longPollingOptionsEqual(e, t) {
            return e.timeoutSeconds === t.timeoutSeconds;
        }(this.experimentalLongPollingOptions, e.experimentalLongPollingOptions) && this.ignoreUndefinedProperties === e.ignoreUndefinedProperties && this.useFetchStreams === e.useFetchStreams;
    }
}
class Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        this._authCredentials = e, this._appCheckCredentials = t, this._databaseId = n, this._app = r, /**
         * Whether it's a Firestore or Firestore Lite instance.
         */ this.type = "firestore-lite", this._persistenceKey = "(lite)", this._settings = new FirestoreSettingsImpl({}), this._settingsFrozen = !1, this._emulatorOptions = {}, // A task that is assigned when the terminate() is invoked and resolved when
        // all components have shut down. Otherwise, Firestore is not terminated,
        // which can mean either the FirestoreClient is in the process of starting,
        // or restarting.
        this._terminateTask = "notTerminated";
    }
    /**
     * The {@link @firebase/app#FirebaseApp} associated with this `Firestore` service
     * instance.
     */ get app() {
        if (!this._app) throw new FirestoreError(D.FAILED_PRECONDITION, "Firestore was not initialized using the Firebase SDK. 'app' is not available");
        return this._app;
    }
    get _initialized() {
        return this._settingsFrozen;
    }
    get _terminated() {
        return "notTerminated" !== this._terminateTask;
    }
    _setSettings(e) {
        if (this._settingsFrozen) throw new FirestoreError(D.FAILED_PRECONDITION, "Firestore has already been started and its settings can no longer be changed. You can only modify settings before calling any other methods on a Firestore object.");
        this._settings = new FirestoreSettingsImpl(e), this._emulatorOptions = e.emulatorOptions || {}, void 0 !== e.credentials && (this._authCredentials = function __PRIVATE_makeAuthCredentialsProvider(e) {
            if (!e) return new __PRIVATE_EmptyAuthCredentialsProvider;
            switch(e.type){
                case "firstParty":
                    return new __PRIVATE_FirstPartyAuthCredentialsProvider(e.sessionIndex || "0", e.iamToken || null, e.authTokenFactory || null);
                case "provider":
                    return e.client;
                default:
                    throw new FirestoreError(D.INVALID_ARGUMENT, "makeAuthCredentialsProvider failed due to invalid credential type");
            }
        }(e.credentials));
    }
    _getSettings() {
        return this._settings;
    }
    _getEmulatorOptions() {
        return this._emulatorOptions;
    }
    _freezeSettings() {
        return this._settingsFrozen = !0, this._settings;
    }
    _delete() {
        // The `_terminateTask` must be assigned future that completes when
        // terminate is complete. The existence of this future puts SDK in state
        // that will not accept further API interaction.
        return "notTerminated" === this._terminateTask && (this._terminateTask = this._terminate()), this._terminateTask;
    }
    async _restart() {
        // The `_terminateTask` must equal 'notTerminated' after restart to
        // signal that client is in a state that accepts API calls.
        "notTerminated" === this._terminateTask ? await this._terminate() : this._terminateTask = "notTerminated";
    }
    /** Returns a JSON-serializable representation of this `Firestore` instance. */ toJSON() {
        return {
            app: this._app,
            databaseId: this._databaseId,
            settings: this._settings
        };
    }
    /**
     * Terminates all components used by this client. Subclasses can override
     * this method to clean up their own dependencies, but must also call this
     * method.
     *
     * Only ever called once.
     */ _terminate() {
        /**
 * Removes all components associated with the provided instance. Must be called
 * when the `Firestore` instance is terminated.
 */ return function __PRIVATE_removeComponents(e) {
            const t = Mt.get(e);
            t && (__PRIVATE_logDebug(Ot, "Removing Datastore"), Mt.delete(e), t.terminate());
        }(this), Promise.resolve();
    }
}
/**
 * Modify this instance to communicate with the Cloud Firestore emulator.
 *
 * Note: This must be called before this instance has been used to do any
 * operations.
 *
 * @param firestore - The `Firestore` instance to configure to connect to the
 * emulator.
 * @param host - the emulator host (ex: localhost).
 * @param port - the emulator port (ex: 9000).
 * @param options.mockUserToken - the mock auth token to use for unit testing
 * Security Rules.
 */ function connectFirestoreEmulator(e, t, n, r = {}) {
    e = __PRIVATE_cast(e, Firestore$1);
    const i = (0, _util.isCloudWorkstation)(t), s = e._getSettings(), _ = {
        ...s,
        emulatorOptions: e._getEmulatorOptions()
    }, l = `${t}:${n}`;
    i && (0, _util.pingServer)(`https://${l}`), s.host !== kt && s.host !== l && __PRIVATE_logWarn("Host has been set in both settings() and connectFirestoreEmulator(), emulator host will be used.");
    const E = {
        ...s,
        host: l,
        ssl: i,
        emulatorOptions: r
    };
    // No-op if the new configuration matches the current configuration. This supports SSR
    // enviornments which might call `connectFirestoreEmulator` multiple times as a standard practice.
    if (!(0, _util.deepEqual)(E, _) && (e._setSettings(E), r.mockUserToken)) {
        let t, n;
        if ("string" == typeof r.mockUserToken) t = r.mockUserToken, n = User.MOCK_USER;
        else {
            // Let createMockUserToken validate first (catches common mistakes like
            // invalid field "uid" and missing field "sub" / "user_id".)
            t = (0, _util.createMockUserToken)(r.mockUserToken, e._app?.options.projectId);
            const i = r.mockUserToken.sub || r.mockUserToken.user_id;
            if (!i) throw new FirestoreError(D.INVALID_ARGUMENT, "mockUserToken must contain 'sub' or 'user_id' field!");
            n = new User(i);
        }
        e._authCredentials = new __PRIVATE_EmulatorAuthCredentialsProvider(new __PRIVATE_OAuthToken(t, n));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A `Query` refers to a query which you can read or listen to. You can also
 * construct refined `Query` objects by adding filters and ordering.
 */ class Query {
    // This is the lite version of the Query class in the main SDK.
    /** @hideconstructor protected */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._query = n, /** The type of this Firestore reference. */ this.type = "query", this.firestore = e;
    }
    withConverter(e) {
        return new Query(this.firestore, e, this._query);
    }
}
/**
 * A `DocumentReference` refers to a document location in a Firestore database
 * and can be used to write, read, or listen to the location. The document at
 * the referenced location may or may not exist.
 */ class DocumentReference {
    /** @hideconstructor */ constructor(e, /**
     * If provided, the `FirestoreDataConverter` associated with this instance.
     */ t, n){
        this.converter = t, this._key = n, /** The type of this Firestore reference. */ this.type = "document", this.firestore = e;
    }
    get _path() {
        return this._key.path;
    }
    /**
     * The document's identifier within its collection.
     */ get id() {
        return this._key.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced document (relative
     * to the root of the database).
     */ get path() {
        return this._key.path.canonicalString();
    }
    /**
     * The collection this `DocumentReference` belongs to.
     */ get parent() {
        return new CollectionReference(this.firestore, this.converter, this._key.path.popLast());
    }
    withConverter(e) {
        return new DocumentReference(this.firestore, e, this._key);
    }
    /**
     * Returns a JSON-serializable representation of this `DocumentReference` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: DocumentReference._jsonSchemaVersion,
            referencePath: this._key.toString()
        };
    }
    static fromJSON(e, t, n) {
        if (__PRIVATE_validateJSON(t, DocumentReference._jsonSchema)) return new DocumentReference(e, n || null, new DocumentKey(ResourcePath.fromString(t.referencePath)));
    }
}
DocumentReference._jsonSchemaVersion = "firestore/documentReference/1.0", DocumentReference._jsonSchema = {
    type: property("string", DocumentReference._jsonSchemaVersion),
    referencePath: property("string")
};
/**
 * A `CollectionReference` object can be used for adding documents, getting
 * document references, and querying for documents (using {@link (query:1)}).
 */ class CollectionReference extends Query {
    /** @hideconstructor */ constructor(e, t, n){
        super(e, t, __PRIVATE_newQueryForPath(n)), this._path = n, /** The type of this Firestore reference. */ this.type = "collection";
    }
    /** The collection's identifier. */ get id() {
        return this._query.path.lastSegment();
    }
    /**
     * A string representing the path of the referenced collection (relative
     * to the root of the database).
     */ get path() {
        return this._query.path.canonicalString();
    }
    /**
     * A reference to the containing `DocumentReference` if this is a
     * subcollection. If this isn't a subcollection, the reference is null.
     */ get parent() {
        const e = this._path.popLast();
        return e.isEmpty() ? null : new DocumentReference(this.firestore, /* converter= */ null, new DocumentKey(e));
    }
    withConverter(e) {
        return new CollectionReference(this.firestore, e, this._path);
    }
}
function __PRIVATE_isCollectionReference(e) {
    return e instanceof CollectionReference;
}
function collection(e, t, ...n) {
    if (e = (0, _util.getModularInstance)(e), __PRIVATE_validateNonEmptyArgument("collection", "path", t), e instanceof Firestore$1) {
        const r = ResourcePath.fromString(t, ...n);
        return __PRIVATE_validateCollectionPath(r), new CollectionReference(e, /* converter= */ null, r);
    }
    {
        if (!(e instanceof DocumentReference || e instanceof CollectionReference)) throw new FirestoreError(D.INVALID_ARGUMENT, "Expected first argument to collection() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child(ResourcePath.fromString(t, ...n));
        return __PRIVATE_validateCollectionPath(r), new CollectionReference(e.firestore, /* converter= */ null, r);
    }
}
// TODO(firestorelite): Consider using ErrorFactory -
// https://github.com/firebase/firebase-js-sdk/blob/0131e1f/packages/util/src/errors.ts#L106
/**
 * Creates and returns a new `Query` instance that includes all documents in the
 * database that are contained in a collection or subcollection with the
 * given `collectionId`.
 *
 * @param firestore - A reference to the root `Firestore` instance.
 * @param collectionId - Identifies the collections to query over. Every
 * collection or subcollection with this ID as the last segment of its path
 * will be included. Cannot contain a slash.
 * @returns The created `Query`.
 */ function collectionGroup(e, t) {
    if (e = __PRIVATE_cast(e, Firestore$1), __PRIVATE_validateNonEmptyArgument("collectionGroup", "collection id", t), t.indexOf("/") >= 0) throw new FirestoreError(D.INVALID_ARGUMENT, `Invalid collection ID '${t}' passed to function collectionGroup(). Collection IDs must not contain '/'.`);
    return new Query(e, /* converter= */ null, function __PRIVATE_newQueryForCollectionGroup(e) {
        return new __PRIVATE_QueryImpl(ResourcePath.emptyPath(), e);
    }(t));
}
function doc(e, t, ...n) {
    if (e = (0, _util.getModularInstance)(e), // We allow omission of 'pathString' but explicitly prohibit passing in both
    // 'undefined' and 'null'.
    1 === arguments.length && (t = __PRIVATE_AutoId.newId()), __PRIVATE_validateNonEmptyArgument("doc", "path", t), e instanceof Firestore$1) {
        const r = ResourcePath.fromString(t, ...n);
        return __PRIVATE_validateDocumentPath(r), new DocumentReference(e, /* converter= */ null, new DocumentKey(r));
    }
    {
        if (!(e instanceof DocumentReference || e instanceof CollectionReference)) throw new FirestoreError(D.INVALID_ARGUMENT, "Expected first argument to doc() to be a CollectionReference, a DocumentReference or FirebaseFirestore");
        const r = e._path.child(ResourcePath.fromString(t, ...n));
        return __PRIVATE_validateDocumentPath(r), new DocumentReference(e.firestore, e instanceof CollectionReference ? e.converter : null, new DocumentKey(r));
    }
}
/**
 * Returns true if the provided references are equal.
 *
 * @param left - A reference to compare.
 * @param right - A reference to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function refEqual(e, t) {
    return e = (0, _util.getModularInstance)(e), t = (0, _util.getModularInstance)(t), (e instanceof DocumentReference || e instanceof CollectionReference) && (t instanceof DocumentReference || t instanceof CollectionReference) && e.firestore === t.firestore && e.path === t.path && e.converter === t.converter;
}
/**
 * Returns true if the provided queries point to the same collection and apply
 * the same constraints.
 *
 * @param left - A `Query` to compare.
 * @param right - A `Query` to compare.
 * @returns true if the references point to the same location in the same
 * Firestore database.
 */ function queryEqual(e, t) {
    return e = (0, _util.getModularInstance)(e), t = (0, _util.getModularInstance)(t), e instanceof Query && t instanceof Query && e.firestore === t.firestore && __PRIVATE_queryEquals(e._query, t._query) && e.converter === t.converter;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Compares two array for equality using comparator. The method computes the
 * intersection and invokes `onAdd` for every element that is in `after` but not
 * `before`. `onRemove` is invoked for every element in `before` but missing
 * from `after`.
 *
 * The method creates a copy of both `before` and `after` and runs in O(n log
 * n), where n is the size of the two lists.
 *
 * @param before - The elements that exist in the original array.
 * @param after - The elements to diff against the original array.
 * @param comparator - The comparator for the elements in before and after.
 * @param onAdd - A function to invoke for every element that is part of `
 * after` but not `before`.
 * @param onRemove - A function to invoke for every element that is part of
 * `before` but not `after`.
 */ /**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a vector type in Firestore documents.
 * Create an instance with <code>{@link vector}</code>.
 */ class VectorValue {
    /**
     * @private
     * @internal
     */ constructor(e){
        // Making a copy of the parameter.
        this._values = (e || []).map((e)=>e);
    }
    /**
     * Returns a copy of the raw number array form of the vector.
     */ toArray() {
        return this._values.map((e)=>e);
    }
    /**
     * Returns `true` if the two `VectorValue` values have the same raw number arrays, returns `false` otherwise.
     */ isEqual(e) {
        /**
 * Verifies equality for an array of primitives.
 *
 * @private
 * @internal
 * @param left - Array of primitives.
 * @param right - Array of primitives.
 * @returns True if arrays are equal.
 */ return function __PRIVATE_isPrimitiveArrayEqual(e, t) {
            if (e.length !== t.length) return !1;
            for(let n = 0; n < e.length; ++n)if (e[n] !== t[n]) return !1;
            return !0;
        }(this._values, e._values);
    }
    /**
     * Returns a JSON-serializable representation of this `VectorValue` instance.
     *
     * @returns a JSON representation of this object.
     */ toJSON() {
        return {
            type: VectorValue._jsonSchemaVersion,
            vectorValues: this._values
        };
    }
    /**
     * Builds a `VectorValue` instance from a JSON object created by {@link VectorValue.toJSON}.
     *
     * @param json - a JSON object represention of a `VectorValue` instance.
     * @returns an instance of {@link VectorValue} if the JSON object could be parsed. Throws a
     * {@link FirestoreError} if an error occurs.
     */ static fromJSON(e) {
        if (__PRIVATE_validateJSON(e, VectorValue._jsonSchema)) {
            if (Array.isArray(e.vectorValues) && e.vectorValues.every((e)=>"number" == typeof e)) return new VectorValue(e.vectorValues);
            throw new FirestoreError(D.INVALID_ARGUMENT, "Expected 'vectorValues' field to be a number array");
        }
    }
}
VectorValue._jsonSchemaVersion = "firestore/vectorValue/1.0", VectorValue._jsonSchema = {
    type: property("string", VectorValue._jsonSchemaVersion),
    vectorValues: property("object")
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $t = /^__.*__$/;
/** The result of parsing document data (e.g. for a setData call). */ class ParsedSetData {
    constructor(e, t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return null !== this.fieldMask ? new __PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms) : new __PRIVATE_SetMutation(e, this.data, t, this.fieldTransforms);
    }
}
/** The result of parsing "update" data (i.e. for an updateData call). */ class ParsedUpdateData {
    constructor(e, // The fieldMask does not include document transforms.
    t, n){
        this.data = e, this.fieldMask = t, this.fieldTransforms = n;
    }
    toMutation(e, t) {
        return new __PRIVATE_PatchMutation(e, this.data, this.fieldMask, t, this.fieldTransforms);
    }
}
function __PRIVATE_isWrite(e) {
    switch(e){
        case 0 /* UserDataSource.Set */ :
        // fall through
        case 2 /* UserDataSource.MergeSet */ :
        // fall through
        case 1 /* UserDataSource.Update */ :
            return !0;
        case 3 /* UserDataSource.Argument */ :
        case 4 /* UserDataSource.ArrayArgument */ :
            return !1;
        default:
            throw fail(40011, {
                dataSource: e
            });
    }
}
/** A "context" object passed around while parsing user data. */ class ParseContextImpl {
    /**
     * Initializes a ParseContext with the given source and path.
     *
     * @param settings - The settings for the parser.
     * @param databaseId - The database ID of the Firestore instance.
     * @param serializer - The serializer to use to generate the Value proto.
     * @param ignoreUndefinedProperties - Whether to ignore undefined properties
     * rather than throw.
     * @param fieldTransforms - A mutable list of field transforms encountered
     * while parsing the data.
     * @param fieldMask - A mutable list of field paths encountered while parsing
     * the data.
     *
     * TODO(b/34871131): We don't support array paths right now, so path can be
     * null to indicate the context represents any location within an array (in
     * which case certain features will not work and errors will be somewhat
     * compromised).
     */ constructor(e, t, n, r, i, s){
        this.settings = e, this.databaseId = t, this.serializer = n, this.ignoreUndefinedProperties = r, // Minor hack: If fieldTransforms is undefined, we assume this is an
        // external call and we need to validate the entire path.
        void 0 === i && this.validatePath(), this.fieldTransforms = i || [], this.fieldMask = s || [];
    }
    get path() {
        return this.settings.path;
    }
    get dataSource() {
        return this.settings.dataSource;
    }
    /** Returns a new context with the specified settings overwritten. */ contextWith(e) {
        return new ParseContextImpl({
            ...this.settings,
            ...e
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties, this.fieldTransforms, this.fieldMask);
    }
    childContextForField(e) {
        const t = this.path?.child(e), n = this.contextWith({
            path: t,
            arrayElement: !1
        });
        return n.validatePathSegment(e), n;
    }
    childContextForFieldPath(e) {
        const t = this.path?.child(e), n = this.contextWith({
            path: t,
            arrayElement: !1
        });
        return n.validatePath(), n;
    }
    childContextForArray(e) {
        // TODO(b/34871131): We don't support array paths right now; so make path
        // undefined.
        return this.contextWith({
            path: void 0,
            arrayElement: !0
        });
    }
    createError(e) {
        return createError(e, this.settings.methodName, this.settings.hasConverter || !1, this.path, this.settings.targetDoc);
    }
    /** Returns 'true' if 'fieldPath' was traversed when creating this context. */ contains(e) {
        return void 0 !== this.fieldMask.find((t)=>e.isPrefixOf(t)) || void 0 !== this.fieldTransforms.find((t)=>e.isPrefixOf(t.field));
    }
    validatePath() {
        // TODO(b/34871131): Remove null check once we have proper paths for fields
        // within arrays.
        if (this.path) for(let e = 0; e < this.path.length; e++)this.validatePathSegment(this.path.get(e));
    }
    validatePathSegment(e) {
        if (0 === e.length) throw this.createError("Document fields must not be empty");
        if (__PRIVATE_isWrite(this.dataSource) && $t.test(e)) throw this.createError('Document fields cannot begin and end with "__"');
    }
}
/**
 * Helper for parsing raw user input (provided via the API) into internal model
 * classes.
 */ class UserDataReader {
    constructor(e, t, n){
        this.databaseId = e, this.ignoreUndefinedProperties = t, this.serializer = n || __PRIVATE_newSerializer(e);
    }
    /** Creates a new top-level parse context. */ createContext(e, t, n, r = !1) {
        return new ParseContextImpl({
            dataSource: e,
            methodName: t,
            targetDoc: n,
            path: FieldPath$1.emptyPath(),
            arrayElement: !1,
            hasConverter: r
        }, this.databaseId, this.serializer, this.ignoreUndefinedProperties);
    }
}
function __PRIVATE_newUserDataReader(e) {
    const t = e._freezeSettings(), n = __PRIVATE_newSerializer(e._databaseId);
    return new UserDataReader(e._databaseId, !!t.ignoreUndefinedProperties, n);
}
/** Parse document data from a set() call. */ function __PRIVATE_parseSetData(e, t, n, r, i, s = {}) {
    const _ = e.createContext(s.merge || s.mergeFields ? 2 /* UserDataSource.MergeSet */  : 0 /* UserDataSource.Set */ , t, n, i);
    __PRIVATE_validatePlainObject("Data must be an object, but it was:", _, r);
    const o = __PRIVATE_parseObject(r, _);
    let a, u;
    if (s.merge) a = new FieldMask(_.fieldMask), u = _.fieldTransforms;
    else if (s.mergeFields) {
        const e = [];
        for (const r of s.mergeFields){
            const i = __PRIVATE_fieldPathFromArgument(t, r, n);
            if (!_.contains(i)) throw new FirestoreError(D.INVALID_ARGUMENT, `Field '${i}' is specified in your field mask but missing from your input data.`);
            __PRIVATE_fieldMaskContains(e, i) || e.push(i);
        }
        a = new FieldMask(e), u = _.fieldTransforms.filter((e)=>a.covers(e.field));
    } else a = null, u = _.fieldTransforms;
    return new ParsedSetData(new ObjectValue(o), a, u);
}
class __PRIVATE_DeleteFieldValueImpl extends FieldValue {
    _toFieldTransform(e) {
        if (2 /* UserDataSource.MergeSet */  !== e.dataSource) throw 1 /* UserDataSource.Update */  === e.dataSource ? e.createError(`${this._methodName}() can only appear at the top level of your update data`) : e.createError(`${this._methodName}() cannot be used with set() unless you pass {merge:true}`);
        // No transform to add for a delete, but we need to add it to our
        // fieldMask so it gets deleted.
        return e.fieldMask.push(e.path), null;
    }
    isEqual(e) {
        return e instanceof __PRIVATE_DeleteFieldValueImpl;
    }
}
/**
 * Creates a child context for parsing SerializableFieldValues.
 *
 * This is different than calling `ParseContext.contextWith` because it keeps
 * the fieldTransforms and fieldMask separate.
 *
 * The created context has its `dataSource` set to `UserDataSource.Argument`.
 * Although these values are used with writes, any elements in these FieldValues
 * are not considered writes since they cannot contain any FieldValue sentinels,
 * etc.
 *
 * @param fieldValue - The sentinel FieldValue for which to create a child
 *     context.
 * @param context - The parent context.
 * @param arrayElement - Whether or not the FieldValue has an array.
 */ function __PRIVATE_createSentinelChildContext(e, t, n) {
    return new ParseContextImpl({
        dataSource: 3 /* UserDataSource.Argument */ ,
        targetDoc: t.settings.targetDoc,
        methodName: e._methodName,
        arrayElement: n
    }, t.databaseId, t.serializer, t.ignoreUndefinedProperties);
}
class __PRIVATE_ServerTimestampFieldValueImpl extends FieldValue {
    _toFieldTransform(e) {
        return new FieldTransform(e.path, new __PRIVATE_ServerTimestampTransform);
    }
    isEqual(e) {
        return e instanceof __PRIVATE_ServerTimestampFieldValueImpl;
    }
}
class __PRIVATE_ArrayUnionFieldValueImpl extends FieldValue {
    constructor(e, t){
        super(e), this.Tr = t;
    }
    _toFieldTransform(e) {
        const t = __PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Tr.map((e)=>__PRIVATE_parseData(e, t)), r = new __PRIVATE_ArrayUnionTransformOperation(n);
        return new FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof __PRIVATE_ArrayUnionFieldValueImpl && (0, _util.deepEqual)(this.Tr, e.Tr);
    }
}
class __PRIVATE_ArrayRemoveFieldValueImpl extends FieldValue {
    constructor(e, t){
        super(e), this.Tr = t;
    }
    _toFieldTransform(e) {
        const t = __PRIVATE_createSentinelChildContext(this, e, /*array=*/ !0), n = this.Tr.map((e)=>__PRIVATE_parseData(e, t)), r = new __PRIVATE_ArrayRemoveTransformOperation(n);
        return new FieldTransform(e.path, r);
    }
    isEqual(e) {
        return e instanceof __PRIVATE_ArrayRemoveFieldValueImpl && (0, _util.deepEqual)(this.Tr, e.Tr);
    }
}
class __PRIVATE_NumericIncrementFieldValueImpl extends FieldValue {
    constructor(e, t){
        super(e), this.Pr = t;
    }
    _toFieldTransform(e) {
        const t = new __PRIVATE_NumericIncrementTransformOperation(e.serializer, toNumber(e.serializer, this.Pr));
        return new FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof __PRIVATE_NumericIncrementFieldValueImpl && (this.Pr === e.Pr || Number.isNaN(this.Pr) && Number.isNaN(e.Pr));
    }
}
class __PRIVATE_NumericMinimumFieldValueImpl extends FieldValue {
    constructor(e, t){
        super(e), this.Pr = t;
    }
    _toFieldTransform(e) {
        const t = new __PRIVATE_NumericMinimumTransformOperation(e.serializer, toNumber(e.serializer, this.Pr));
        return new FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof __PRIVATE_NumericMinimumFieldValueImpl && (this.Pr === e.Pr || Number.isNaN(this.Pr) && Number.isNaN(e.Pr));
    }
}
class __PRIVATE_NumericMaximumFieldValueImpl extends FieldValue {
    constructor(e, t){
        super(e), this.Pr = t;
    }
    _toFieldTransform(e) {
        const t = new __PRIVATE_NumericMaximumTransformOperation(e.serializer, toNumber(e.serializer, this.Pr));
        return new FieldTransform(e.path, t);
    }
    isEqual(e) {
        return e instanceof __PRIVATE_NumericMaximumFieldValueImpl && (this.Pr === e.Pr || Number.isNaN(this.Pr) && Number.isNaN(e.Pr));
    }
}
/** Parse update data from an update() call. */ function __PRIVATE_parseUpdateData(e, t, n, r) {
    const i = e.createContext(1 /* UserDataSource.Update */ , t, n);
    __PRIVATE_validatePlainObject("Data must be an object, but it was:", i, r);
    const s = [], _ = ObjectValue.empty();
    forEach(r, (e, r)=>{
        const o = __PRIVATE_fieldPathFromDotSeparatedString(t, e, n);
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        r = (0, _util.getModularInstance)(r);
        const a = i.childContextForFieldPath(o);
        if (r instanceof __PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        s.push(o);
        else {
            const e = __PRIVATE_parseData(r, a);
            null != e && (s.push(o), _.set(o, e));
        }
    });
    const o = new FieldMask(s);
    return new ParsedUpdateData(_, o, i.fieldTransforms);
}
/** Parse update data from a list of field/value arguments. */ function __PRIVATE_parseUpdateVarargs(e, t, n, r, i, s) {
    const _ = e.createContext(1 /* UserDataSource.Update */ , t, n), o = [
        __PRIVATE_fieldPathFromArgument(t, r, n)
    ], a = [
        i
    ];
    if (s.length % 2 != 0) throw new FirestoreError(D.INVALID_ARGUMENT, `Function ${t}() needs to be called with an even number of arguments that alternate between field names and values.`);
    for(let e = 0; e < s.length; e += 2)o.push(__PRIVATE_fieldPathFromArgument(t, s[e])), a.push(s[e + 1]);
    const u = [], c = ObjectValue.empty();
    // We iterate in reverse order to pick the last value for a field if the
    // user specified the field multiple times.
    for(let e = o.length - 1; e >= 0; --e)if (!__PRIVATE_fieldMaskContains(u, o[e])) {
        const t = o[e];
        let n = a[e];
        // For Compat types, we have to "extract" the underlying types before
        // performing validation.
        n = (0, _util.getModularInstance)(n);
        const r = _.childContextForFieldPath(t);
        if (n instanceof __PRIVATE_DeleteFieldValueImpl) // Add it to the field mask, but don't add anything to updateData.
        u.push(t);
        else {
            const e = __PRIVATE_parseData(n, r);
            null != e && (u.push(t), c.set(t, e));
        }
    }
    const E = new FieldMask(u);
    return new ParsedUpdateData(c, E, _.fieldTransforms);
}
/**
 * Parse a "query value" (e.g. value in a where filter or a value in a cursor
 * bound).
 *
 * @param allowArrays - Whether the query value is an array that may directly
 * contain additional arrays (e.g. the operand of an `in` query).
 */ function __PRIVATE_parseQueryValue(e, t, n, r = !1) {
    return __PRIVATE_parseData(n, e.createContext(r ? 4 /* UserDataSource.ArrayArgument */  : 3 /* UserDataSource.Argument */ , t));
}
/**
 * Parses user data to Protobuf Values.
 *
 * @param input - Data to be parsed.
 * @param context - A context object representing the current path being parsed,
 * the source of the data being parsed, etc.
 * @returns The parsed value, or null if the value was a FieldValue sentinel
 * that should not be included in the resulting parsed data.
 */ function __PRIVATE_parseData(e, t, n) {
    if (__PRIVATE_looksLikeJsonObject(// Unwrap the API type from the Compat SDK. This will return the API type
    // from firestore-exp.
    e = (0, _util.getModularInstance)(e))) return __PRIVATE_validatePlainObject("Unsupported field value:", t, e), __PRIVATE_parseObject(e, t);
    if (e instanceof FieldValue) // FieldValues usually parse into transforms (except deleteField())
    // in which case we do not want to include this field in our parsed data
    // (as doing so will overwrite the field directly prior to the transform
    // trying to transform it). So we don't add this location to
    // context.fieldMask and we return null as our parsing result.
    /**
 * "Parses" the provided FieldValueImpl, adding any necessary transforms to
 * context.fieldTransforms.
 */ return function __PRIVATE_parseSentinelFieldValue(e, t) {
        // Sentinels are only supported with writes, and not within arrays.
        if (!__PRIVATE_isWrite(t.dataSource)) throw t.createError(`${e._methodName}() can only be used with update() and set()`);
        if (!t.path) throw t.createError(`${e._methodName}() is not currently supported inside arrays`);
        const n = e._toFieldTransform(t);
        n && t.fieldTransforms.push(n);
    }(e, t), null;
    if (void 0 === e && t.ignoreUndefinedProperties) // If the input is undefined it can never participate in the fieldMask, so
    // don't handle this below. If `ignoreUndefinedProperties` is false,
    // `parseScalarValue` will reject an undefined value.
    return null;
    if (// If context.path is null we are inside an array and we don't support
    // field mask paths more granular than the top-level array.
    t.path && t.fieldMask.push(t.path), e instanceof Array) {
        // TODO(b/34871131): Include the path containing the array in the error
        // message.
        // In the case of IN queries, the parsed data is an array (representing
        // the set of values to be included for the IN query) that may directly
        // contain additional arrays (each representing an individual field
        // value), so we disable this validation.
        if (t.settings.arrayElement && 4 /* UserDataSource.ArrayArgument */  !== t.dataSource) throw t.createError("Nested arrays are not supported");
        return function __PRIVATE_parseArray(e, t) {
            const n = [];
            let r = 0;
            for (const i of e){
                let e = __PRIVATE_parseData(i, t.childContextForArray(r));
                null == e && // Just include nulls in the array for fields being replaced with a
                // sentinel.
                (e = {
                    nullValue: "NULL_VALUE"
                }), n.push(e), r++;
            }
            return {
                arrayValue: {
                    values: n
                }
            };
        }(e, t);
    }
    return function __PRIVATE_parseScalarValue(e, t, n) {
        if (null === (e = (0, _util.getModularInstance)(e))) return {
            nullValue: "NULL_VALUE"
        };
        if ("number" == typeof e) return toNumber(t.serializer, e, n);
        if ("boolean" == typeof e) return {
            booleanValue: e
        };
        if ("string" == typeof e) return {
            stringValue: e
        };
        if (e instanceof Date) {
            const n = Timestamp.fromDate(e);
            return {
                timestampValue: toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof Timestamp) {
            // Firestore backend truncates precision down to microseconds. To ensure
            // offline mode works the same with regards to truncation, perform the
            // truncation immediately without waiting for the backend to do that.
            const n = new Timestamp(e.seconds, 1e3 * Math.floor(e.nanoseconds / 1e3));
            return {
                timestampValue: toTimestamp(t.serializer, n)
            };
        }
        if (e instanceof GeoPoint) return {
            geoPointValue: {
                latitude: e.latitude,
                longitude: e.longitude
            }
        };
        if (e instanceof Bytes) return {
            bytesValue: __PRIVATE_toBytes(t.serializer, e._byteString)
        };
        if (e instanceof DocumentReference) {
            const n = t.databaseId, r = e.firestore._databaseId;
            if (!r.isEqual(n)) throw t.createError(`Document reference is for database ${r.projectId}/${r.database} but should be for database ${n.projectId}/${n.database}`);
            return {
                referenceValue: __PRIVATE_toResourceName(e.firestore._databaseId || t.databaseId, e._key.path)
            };
        }
        if (e instanceof VectorValue) /**
 * Creates a new VectorValue proto value (using the internal format).
 */ return function __PRIVATE_parseVectorValue(e, t) {
            const n = e instanceof VectorValue ? e.toArray() : e, r = {
                fields: {
                    [_t]: {
                        stringValue: ut
                    },
                    [ct]: {
                        arrayValue: {
                            values: n.map((e)=>{
                                if ("number" != typeof e) throw t.createError("VectorValues must only contain numeric values.");
                                return __PRIVATE_toDouble(t.serializer, e);
                            })
                        }
                    }
                }
            };
            return {
                mapValue: r
            };
        }(e, t);
        if (__PRIVATE_isProtoValueSerializable(e)) return e._toProto(t.serializer);
        throw t.createError(`Unsupported field value: ${__PRIVATE_valueDescription(e)}`);
    }(e, t, n);
}
function __PRIVATE_parseObject(e, t) {
    const n = {};
    return isEmpty(e) ? // If we encounter an empty object, we explicitly add it to the update
    // mask to ensure that the server creates a map entry.
    t.path && t.path.length > 0 && t.fieldMask.push(t.path) : forEach(e, (e, r)=>{
        const i = __PRIVATE_parseData(r, t.childContextForField(e));
        null != i && (n[e] = i);
    }), {
        mapValue: {
            fields: n
        }
    };
}
function __PRIVATE_looksLikeJsonObject(e) {
    return !("object" != typeof e || null === e || e instanceof Array || e instanceof Date || e instanceof Timestamp || e instanceof GeoPoint || e instanceof Bytes || e instanceof DocumentReference || e instanceof FieldValue || e instanceof VectorValue || __PRIVATE_isProtoValueSerializable(e));
}
function __PRIVATE_validatePlainObject(e, t, n) {
    if (!__PRIVATE_looksLikeJsonObject(n) || !__PRIVATE_isPlainObject(n)) {
        const r = __PRIVATE_valueDescription(n);
        throw "an object" === r ? t.createError(e + " a custom object") : t.createError(e + " " + r);
    }
}
/**
 * Helper that calls fromDotSeparatedString() but wraps any error thrown.
 */ function __PRIVATE_fieldPathFromArgument(e, t, n) {
    if (// If required, replace the FieldPath Compat class with the firestore-exp
    // FieldPath.
    (t = (0, _util.getModularInstance)(t)) instanceof FieldPath) return t._internalPath;
    if ("string" == typeof t) return __PRIVATE_fieldPathFromDotSeparatedString(e, t);
    throw createError("Field path arguments must be of type string or ", e, /* hasConverter= */ !1, /* path= */ void 0, n);
}
/**
 * Matches any characters in a field path string that are reserved.
 */ const Kt = new RegExp("[~\\*/\\[\\]]");
/**
 * Wraps fromDotSeparatedString with an error message about the method that
 * was thrown.
 * @param methodName - The publicly visible method name
 * @param path - The dot-separated string form of a field path which will be
 * split on dots.
 * @param targetDoc - The document against which the field path will be
 * evaluated.
 */ function __PRIVATE_fieldPathFromDotSeparatedString(e, t, n) {
    if (t.search(Kt) >= 0) throw createError(`Invalid field path (${t}). Paths must not contain '~', '*', '/', '[', or ']'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    try {
        return new FieldPath(...t.split("."))._internalPath;
    } catch (r) {
        throw createError(`Invalid field path (${t}). Paths must not be empty, begin with '.', end with '.', or contain '..'`, e, /* hasConverter= */ !1, /* path= */ void 0, n);
    }
}
function createError(e, t, n, r, i) {
    const s = r && !r.isEmpty(), _ = void 0 !== i;
    let o = `Function ${t}() called with invalid data`;
    n && (o += " (via `toFirestore()`)"), o += ". ";
    let a = "";
    return (s || _) && (a += " (found", s && (a += ` in field ${r}`), _ && (a += ` in document ${i}`), a += ")"), new FirestoreError(D.INVALID_ARGUMENT, o + e + a);
}
/** Checks `haystack` if FieldPath `needle` is present. Runs in O(n). */ function __PRIVATE_fieldMaskContains(e, t) {
    return e.some((e)=>e.isEqual(t));
}
function __PRIVATE_isUserData(e) {
    return "function" == typeof e._readUserData;
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class OptionsUtil {
    constructor(e){
        this.optionDefinitions = e;
    }
    _getKnownOptions(e, t) {
        const n = ObjectValue.empty();
        // SERIALIZE KNOWN OPTIONS
        for(const r in this.optionDefinitions)if (this.optionDefinitions.hasOwnProperty(r)) {
            const i = this.optionDefinitions[r];
            if (r in e) {
                const s = e[r];
                let _;
                if (i.nestedOptions && __PRIVATE_isPlainObject(s)) _ = {
                    mapValue: {
                        fields: new OptionsUtil(i.nestedOptions).getOptionsProto(t, s)
                    }
                };
                else s && (_ = __PRIVATE_parseData(s, t) ?? void 0);
                _ && n.set(FieldPath$1.fromServerFormat(i.serverName), _);
            }
        }
        return n;
    }
    getOptionsProto(e, t, n) {
        const r = this._getKnownOptions(t, e);
        // APPLY OPTIONS OVERRIDES
        if (n) {
            const t = new Map(__PRIVATE_mapToArray(n, (t, n)=>[
                    FieldPath$1.fromServerFormat(n),
                    void 0 !== t ? __PRIVATE_parseData(t, e) : null
                ]));
            r.setAll(t);
        }
        // Return MapValue from `result` or empty map value
        return r.value.mapValue.fields ?? {};
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint @typescript-eslint/no-explicit-any: 0 */ function __PRIVATE_isFirestoreValue(e) {
    return "object" == typeof e && null !== e && !!("nullValue" in e && (null === e.nullValue || "NULL_VALUE" === e.nullValue) || "booleanValue" in e && (null === e.booleanValue || "boolean" == typeof e.booleanValue) || "integerValue" in e && (null === e.integerValue || "number" == typeof e.integerValue || "string" == typeof e.integerValue) || "doubleValue" in e && (null === e.doubleValue || "number" == typeof e.doubleValue) || "timestampValue" in e && (null === e.timestampValue || function __PRIVATE_isITimestamp(e) {
        return "object" == typeof e && null !== e && "seconds" in e && (null === e.seconds || "number" == typeof e.seconds || "string" == typeof e.seconds) && "nanos" in e && (null === e.nanos || "number" == typeof e.nanos);
    }(e.timestampValue)) || "stringValue" in e && (null === e.stringValue || "string" == typeof e.stringValue) || "bytesValue" in e && (null === e.bytesValue || e.bytesValue instanceof Uint8Array) || "referenceValue" in e && (null === e.referenceValue || "string" == typeof e.referenceValue) || "geoPointValue" in e && (null === e.geoPointValue || function __PRIVATE_isILatLng(e) {
        return "object" == typeof e && null !== e && "latitude" in e && (null === e.latitude || "number" == typeof e.latitude) && "longitude" in e && (null === e.longitude || "number" == typeof e.longitude);
    }(e.geoPointValue)) || "arrayValue" in e && (null === e.arrayValue || function __PRIVATE_isIArrayValue(e) {
        return "object" == typeof e && null !== e && !(!("values" in e) || null !== e.values && !Array.isArray(e.values));
    }(e.arrayValue)) || "mapValue" in e && (null === e.mapValue || function __PRIVATE_isIMapValue(e) {
        return "object" == typeof e && null !== e && !(!("fields" in e) || null !== e.fields && !__PRIVATE_isPlainObject(e.fields));
    }(e.mapValue)) || "fieldReferenceValue" in e && (null === e.fieldReferenceValue || "string" == typeof e.fieldReferenceValue) || "functionValue" in e && (null === e.functionValue || function __PRIVATE_isIFunction(e) {
        return "object" == typeof e && null !== e && !(!("name" in e) || null !== e.name && "string" != typeof e.name || !("args" in e) || null !== e.args && !Array.isArray(e.args));
    }(e.functionValue)) || "pipelineValue" in e && (null === e.pipelineValue || function __PRIVATE_isIPipeline(e) {
        return "object" == typeof e && null !== e && !(!("stages" in e) || null !== e.stages && !Array.isArray(e.stages));
    }(e.pipelineValue)));
// Check optional properties and their types
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a sentinel for use with {@link @firebase/firestore/lite#(updateDoc:1)} or
 * {@link @firebase/firestore/lite#(setDoc:1)} with `{merge: true}` to mark a field for deletion.
 */ function deleteField() {
    return new __PRIVATE_DeleteFieldValueImpl("deleteField");
}
/**
 * Returns a sentinel used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link @firebase/firestore/lite#(updateDoc:1)} to
 * include a server-generated timestamp in the written data.
 */ function serverTimestamp() {
    return new __PRIVATE_ServerTimestampFieldValueImpl("serverTimestamp");
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to union the given elements with any array
 * value that already exists on the server. Each specified element that doesn't
 * already exist in the array will be added to the end. If the field being
 * modified is not already an array it will be overwritten with an array
 * containing exactly the specified elements.
 *
 * @param elements - The elements to union into the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`.
 */ function arrayUnion(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new __PRIVATE_ArrayUnionFieldValueImpl("arrayUnion", e);
}
/**
 * Returns a special value that can be used with {@link (setDoc:1)} or {@link
 * updateDoc:1} that tells the server to remove the given elements from any
 * array value that already exists on the server. All instances of each element
 * specified will be removed from the array. If the field being modified is not
 * already an array it will be overwritten with an empty array.
 *
 * @param elements - The elements to remove from the array.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function arrayRemove(...e) {
    // NOTE: We don't actually parse the data until it's used in set() or
    // update() since we'd need the Firestore instance to do this.
    return new __PRIVATE_ArrayRemoveFieldValueImpl("arrayRemove", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to increment the field's current value by
 * the given value.
 *
 * If either the operand or the current field value uses floating point
 * precision, all arithmetic follows IEEE 754 semantics. If both values are
 * integers, values outside of JavaScript's safe number range
 * (`Number.MIN_SAFE_INTEGER` to `Number.MAX_SAFE_INTEGER`) are also subject to
 * precision loss. Furthermore, once processed by the Firestore backend, all
 * integer operations are capped between -2^63 and 2^63-1.
 *
 * If the current field value is not of type `number`, or if the field does not
 * yet exist, the transformation sets the field to the given value.
 *
 * @param n - The value to increment by.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function increment(e) {
    return new __PRIVATE_NumericIncrementFieldValueImpl("increment", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to set the field to the numeric minimum of the
 * field's current and the given value.
 *
 * @param n - The value to compare to the existing field value.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function minimum$1(e) {
    return new __PRIVATE_NumericMinimumFieldValueImpl("minimum", e);
}
/**
 * Returns a special value that can be used with {@link @firebase/firestore/lite#(setDoc:1)} or {@link
 * @firebase/firestore/lite#(updateDoc:1)} that tells the server to set the field to the numeric maximum of the
 * field's current and the given value.
 *
 * @param n - The value to compare to the existing field value.
 * @returns The `FieldValue` sentinel for use in a call to `setDoc()` or
 * `updateDoc()`
 */ function maximum$1(e) {
    return new __PRIVATE_NumericMaximumFieldValueImpl("maximum", e);
}
/**
 * Creates a new `VectorValue` constructed with a copy of the given array of numbers.
 *
 * @param values - Create a `VectorValue` instance with a copy of this array of numbers.
 *
 * @returns A new `VectorValue` constructed with a copy of the given array of numbers.
 */ function vector(e) {
    return new VectorValue(e);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts a value to an Expression, Returning either a Constant, MapFunction,
 * ArrayFunction, or the input itself (if it's already an expression).
 *
 * @private
 * @internal
 * @param value
 */ function __PRIVATE_valueToDefaultExpr(e) {
    let t;
    return e instanceof Expression ? e : (t = __PRIVATE_isPlainObject(e) ? __PRIVATE__map(e) : e instanceof Array ? array(e) : __PRIVATE__constant(e, void 0), t);
}
/**
 * Converts a value to an Expression, Returning either a Constant, MapFunction,
 * ArrayFunction, or the input itself (if it's already an expression).
 *
 * @private
 * @internal
 * @param value
 */ function __PRIVATE_vectorToExpr(e) {
    if (e instanceof Expression) return e;
    if (e instanceof VectorValue) return constant(e);
    if (Array.isArray(e)) return constant(vector(e));
    throw new Error("Unsupported value: " + typeof e);
}
/**
 * Converts a value to an Expression, Returning either a Constant, MapFunction,
 * ArrayFunction, or the input itself (if it's already an expression).
 * If the input is a string, it is assumed to be a field name, and a
 * field(value) is returned.
 *
 * @private
 * @internal
 * @param value
 */ function __PRIVATE_fieldOrExpression(e) {
    if (__PRIVATE_isString$1(e)) return field(e);
    return __PRIVATE_valueToDefaultExpr(e);
}
/**
 *
 * Represents an expression that can be evaluated to a value within the execution of a {@link
 * @firebase/firestore/pipelines#Pipeline}.
 *
 * Expressions are the building blocks for creating complex queries and transformations in
 * Firestore pipelines. They can represent:
 *
 * - **Field references:** Access values from document fields.
 * - **Literals:** Represent constant values (strings, numbers, booleans).
 * - **Function calls:** Apply functions to one or more expressions.
 *
 * The `Expression` class provides a fluent API for building expressions. You can chain together
 * method calls to create complex expressions.
 */ class Expression {
    constructor(){
        this._protoValueType = "ProtoValue";
    }
    /**
     * Creates an expression that adds this expression to another expression.
     *
     * @example
     * ```typescript
     * // Add the value of the 'quantity' field and the 'reserve' field.
     * field("quantity").add(field("reserve"));
     * ```
     *
     * @param second - The expression or literal to add to this expression.
     * @param others - Optional additional expressions or literals to add to this expression.
     * @returns A new `Expression` representing the addition operation.
     */ add(e) {
        return new FunctionExpression("add", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "add");
    }
    /**
     * Wraps the expression in a [BooleanExpression].
     *
     * @returns A [BooleanExpression] representing the same expression.
     */ asBoolean() {
        if (this instanceof BooleanExpression) return this;
        if (this instanceof Constant) return new __PRIVATE_BooleanConstant(this);
        if (this instanceof Field) return new __PRIVATE_BooleanField(this);
        if (this instanceof FunctionExpression) return new __PRIVATE_BooleanFunctionExpression(this);
        throw new FirestoreError("invalid-argument", `Conversion of type ${typeof this} to BooleanExpression not supported.`);
    }
    subtract(e) {
        return new FunctionExpression("subtract", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "subtract");
    }
    /**
     * Creates an expression that multiplies this expression by another expression.
     *
     * @example
     * ```typescript
     * // Multiply the 'quantity' field by the 'price' field
     * field("quantity").multiply(field("price"));
     * ```
     *
     * @param second - The second expression or literal to multiply by.
     * @param others - Optional additional expressions or literals to multiply by.
     * @returns A new `Expression` representing the multiplication operation.
     */ multiply(e) {
        return new FunctionExpression("multiply", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "multiply");
    }
    divide(e) {
        return new FunctionExpression("divide", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "divide");
    }
    mod(e) {
        return new FunctionExpression("mod", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "mod");
    }
    equal(e) {
        return new FunctionExpression("equal", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "equal").asBoolean();
    }
    notEqual(e) {
        return new FunctionExpression("not_equal", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "notEqual").asBoolean();
    }
    lessThan(e) {
        return new FunctionExpression("less_than", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "lessThan").asBoolean();
    }
    lessThanOrEqual(e) {
        return new FunctionExpression("less_than_or_equal", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "lessThanOrEqual").asBoolean();
    }
    greaterThan(e) {
        return new FunctionExpression("greater_than", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "greaterThan").asBoolean();
    }
    greaterThanOrEqual(e) {
        return new FunctionExpression("greater_than_or_equal", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "greaterThanOrEqual").asBoolean();
    }
    /**
     * Creates an expression that concatenates an array expression with one or more other arrays.
     *
     * @example
     * ```typescript
     * // Combine the 'items' array with another array field.
     * field("items").arrayConcat(field("otherItems"));
     * ```
     * @param secondArray - Second array expression or array literal to concatenate.
     * @param otherArrays - Optional additional array expressions or array literals to concatenate.
     * @returns A new `Expression` representing the concatenated array.
     */ arrayConcat(e, ...t) {
        const n = [
            e,
            ...t
        ].map((e)=>__PRIVATE_valueToDefaultExpr(e));
        return new FunctionExpression("array_concat", [
            this,
            ...n
        ], "arrayConcat");
    }
    arrayContains(e) {
        return new FunctionExpression("array_contains", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "arrayContains").asBoolean();
    }
    arrayContainsAll(e) {
        const t = Array.isArray(e) ? new __PRIVATE_ListOfExprs(e.map(__PRIVATE_valueToDefaultExpr), "arrayContainsAll") : e;
        return new FunctionExpression("array_contains_all", [
            this,
            t
        ], "arrayContainsAll").asBoolean();
    }
    arrayContainsAny(e) {
        const t = Array.isArray(e) ? new __PRIVATE_ListOfExprs(e.map(__PRIVATE_valueToDefaultExpr), "arrayContainsAny") : e;
        return new FunctionExpression("array_contains_any", [
            this,
            t
        ], "arrayContainsAny").asBoolean();
    }
    /**
     * Creates an expression that reverses an array.
     *
     * @example
     * ```typescript
     * // Reverse the value of the 'myArray' field.
     * field("myArray").arrayReverse();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the reversed array.
     */ arrayReverse() {
        return new FunctionExpression("array_reverse", [
            this
        ]);
    }
    /**
     * Creates an expression that calculates the length of an array.
     *
     * @example
     * ```typescript
     * // Get the number of items in the 'cart' array
     * field("cart").arrayLength();
     * ```
     *
     * @returns A new `Expression` representing the length of the array.
     */ arrayLength() {
        return new FunctionExpression("array_length", [
            this
        ], "arrayLength");
    }
    equalAny(e) {
        const t = Array.isArray(e) ? new __PRIVATE_ListOfExprs(e.map(__PRIVATE_valueToDefaultExpr), "equalAny") : e;
        return new FunctionExpression("equal_any", [
            this,
            t
        ], "equalAny").asBoolean();
    }
    notEqualAny(e) {
        const t = Array.isArray(e) ? new __PRIVATE_ListOfExprs(e.map(__PRIVATE_valueToDefaultExpr), "notEqualAny") : e;
        return new FunctionExpression("not_equal_any", [
            this,
            t
        ], "notEqualAny").asBoolean();
    }
    /**
     * Creates an expression that checks if a field exists in the document.
     *
     * @example
     * ```typescript
     * // Check if the document has a field named "phoneNumber"
     * field("phoneNumber").exists();
     * ```
     *
     * @returns A new `Expression` representing the 'exists' check.
     */ exists() {
        return new FunctionExpression("exists", [
            this
        ], "exists").asBoolean();
    }
    /**
     * Creates an expression that calculates the character length of a string in UTF-8.
     *
     * @example
     * ```typescript
     * // Get the character length of the 'name' field in its UTF-8 form.
     * field("name").charLength();
     * ```
     *
     * @returns A new `Expression` representing the length of the string.
     */ charLength() {
        return new FunctionExpression("char_length", [
            this
        ], "charLength");
    }
    like(e) {
        return new FunctionExpression("like", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "like").asBoolean();
    }
    regexContains(e) {
        return new FunctionExpression("regex_contains", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "regexContains").asBoolean();
    }
    regexFind(e) {
        return new FunctionExpression("regex_find", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "regexFind");
    }
    regexFindAll(e) {
        return new FunctionExpression("regex_find_all", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "regexFindAll");
    }
    regexMatch(e) {
        return new FunctionExpression("regex_match", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "regexMatch").asBoolean();
    }
    stringContains(e) {
        return new FunctionExpression("string_contains", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "stringContains").asBoolean();
    }
    startsWith(e) {
        return new FunctionExpression("starts_with", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "startsWith").asBoolean();
    }
    endsWith(e) {
        return new FunctionExpression("ends_with", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "endsWith").asBoolean();
    }
    /**
     * Creates an expression that converts a string to lowercase.
     *
     * @example
     * ```typescript
     * // Convert the 'name' field to lowercase
     * field("name").toLower();
     * ```
     *
     * @returns A new `Expression` representing the lowercase string.
     */ toLower() {
        return new FunctionExpression("to_lower", [
            this
        ], "toLower");
    }
    /**
     * Creates an expression that converts a string to uppercase.
     *
     * @example
     * ```typescript
     * // Convert the 'title' field to uppercase
     * field("title").toUpper();
     * ```
     *
     * @returns A new `Expression` representing the uppercase string.
     */ toUpper() {
        return new FunctionExpression("to_upper", [
            this
        ], "toUpper");
    }
    /**
     * Creates an expression that removes leading and trailing characters from a string or byte array.
     *
     * @example
     * ```typescript
     * // Trim whitespace from the 'userInput' field
     * field("userInput").trim();
     *
     * // Trim quotes from the 'userInput' field
     * field("userInput").trim('"');
     * ```
     * @param valueToTrim - Optional This parameter is treated as a set of characters or bytes that will be
     * trimmed from the input. If not specified, then whitespace will be trimmed.
     * @returns A new `Expression` representing the trimmed string or byte array.
     */ trim(e) {
        const t = [
            this
        ];
        return e && t.push(__PRIVATE_valueToDefaultExpr(e)), new FunctionExpression("trim", t, "trim");
    }
    /**
     * Trims whitespace or a specified set of characters/bytes from the beginning of a string or byte array.
     *
     * @example
     * ```typescript
     * // Trim whitespace from the beginning of the 'userInput' field
     * field("userInput").ltrim();
     *
     * // Trim quotes from the beginning of the 'userInput' field
     * field("userInput").ltrim('"');
     * ```
     *
     * @param valueToTrim - Optional. A string or byte array containing the characters/bytes to trim.
     * If not specified, whitespace will be trimmed.
     * @returns A new `Expression` representing the trimmed string.
     */ ltrim(e) {
        const t = [
            this
        ];
        return e && t.push(__PRIVATE_valueToDefaultExpr(e)), new FunctionExpression("ltrim", t, "ltrim");
    }
    /**
     * Trims whitespace or a specified set of characters/bytes from the end of a string or byte array.
     *
     * @example
     * ```typescript
     * // Trim whitespace from the end of the 'userInput' field
     * field("userInput").rtrim();
     *
     * // Trim quotes from the end of the 'userInput' field
     * field("userInput").rtrim('"');
     * ```
     *
     * @param valueToTrim - Optional. A string or byte array containing the characters/bytes to trim.
     * If not specified, whitespace will be trimmed.
     * @returns A new `Expression` representing the trimmed string or byte array.
     */ rtrim(e) {
        const t = [
            this
        ];
        return e && t.push(__PRIVATE_valueToDefaultExpr(e)), new FunctionExpression("rtrim", t, "rtrim");
    }
    /**
     * Creates an expression that returns the data type of this expression's result, as a string.
     *
     * @remarks
     * This is evaluated on the backend. This means:
     * 1. Generic typed elements (like `array<string>`) evaluate strictly to the primitive `'array'`.
     * 2. Any custom `FirestoreDataConverter` mappings are ignored.
     * 3. For numeric values, the backend does not yield the JavaScript `"number"` type; it evaluates
     *    precisely as `"int64"` or `"float64"`.
     * 4. For date or timestamp objects, the backend evaluates to `"timestamp"`.
     *
     * @example
     * ```typescript
     * // Get the data type of the value in field 'title'
     * field('title').type()
     * ```
     *
     * @returns A new `Expression` representing the data type.
     */ type() {
        return new FunctionExpression("type", [
            this
        ]);
    }
    /**
     * Creates an expression that checks if the result of this expression is of the given type.
     *
     * @remarks Null or undefined fields evaluate to skip/error. Use `ifAbsent()` / `isAbsent()` to evaluate missing data.
     * Supported values for `type` are:
     * `'null'`, `'array'`, `'boolean'`, `'bytes'`, `'timestamp'`, `'geo_point'`, `'number'`,
     * `'int32'`, `'int64'`, `'float64'`, `'decimal128'`, `'map'`, `'reference'`, `'string'`,
     * `'vector'`, `'max_key'`, `'min_key'`, `'object_id'`, `'regex'`, `'request_timestamp'`.
     *
     * @example
     * ```typescript
     * // Check if the 'price' field is specifically an integer (not just 'number')
     * field('price').isType('int64');
     * ```
     *
     * @param type - The type to check for.
     * @returns A new `BooleanExpression` that evaluates to true if the expression's result is of the given type, false otherwise.
     */ isType(e) {
        return new FunctionExpression("is_type", [
            this,
            constant(e)
        ], "isType").asBoolean();
    }
    /**
     * Creates an expression that concatenates string expressions together.
     *
     * @example
     * ```typescript
     * // Combine the 'firstName', " ", and 'lastName' fields into a single string
     * field("firstName").stringConcat(constant(" "), field("lastName"));
     * ```
     *
     * @param secondString - The additional expression or string literal to concatenate.
     * @param otherStrings - Optional additional expressions or string literals to concatenate.
     * @returns A new `Expression` representing the concatenated string.
     */ stringConcat(e, ...t) {
        const n = [
            e,
            ...t
        ].map(__PRIVATE_valueToDefaultExpr);
        return new FunctionExpression("string_concat", [
            this,
            ...n
        ], "stringConcat");
    }
    /**
     * Creates an expression that finds the index of the first occurrence of a substring or byte sequence.
     *
     * @example
     * ```typescript
     * // Find the index of "foo" in the 'text' field
     * field("text").stringIndexOf("foo");
     * ```
     *
     * @param search - The substring or byte sequence to search for.
     * @returns A new `Expression` representing the index of the first occurrence.
     */ stringIndexOf(e) {
        return new FunctionExpression("string_index_of", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "stringIndexOf");
    }
    /**
     * Creates an expression that repeats a string or byte array a specified number of times.
     *
     * @example
     * ```typescript
     * // Repeat the 'label' field 3 times
     * field("label").stringRepeat(3);
     * ```
     *
     * @param repetitions - The number of times to repeat the string or byte array.
     * @returns A new `Expression` representing the repeated string or byte array.
     */ stringRepeat(e) {
        return new FunctionExpression("string_repeat", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "stringRepeat");
    }
    /**
     * Creates an expression that replaces all occurrences of a substring or byte sequence with a replacement.
     *
     * @example
     * ```typescript
     * // Replace all occurrences of "foo" with "bar" in the 'text' field
     * field("text").stringReplaceAll("foo", "bar");
     * ```
     *
     * @param find - The substring or byte sequence to search for.
     * @param replacement - The replacement string or byte sequence.
     * @returns A new `Expression` representing the string or byte array with replacements.
     */ stringReplaceAll(e, t) {
        return new FunctionExpression("string_replace_all", [
            this,
            __PRIVATE_valueToDefaultExpr(e),
            __PRIVATE_valueToDefaultExpr(t)
        ], "stringReplaceAll");
    }
    /**
     * Creates an expression that replaces the first occurrence of a substring or byte sequence with a replacement.
     *
     * @example
     * ```typescript
     * // Replace the first occurrence of "foo" with "bar" in the 'text' field
     * field("text").stringReplaceOne("foo", "bar");
     * ```
     *
     * @param find - The substring or byte sequence to search for.
     * @param replacement - The replacement string or byte sequence.
     * @returns A new `Expression` representing the string or byte array with the replacement.
     */ stringReplaceOne(e, t) {
        return new FunctionExpression("string_replace_one", [
            this,
            __PRIVATE_valueToDefaultExpr(e),
            __PRIVATE_valueToDefaultExpr(t)
        ], "stringReplaceOne");
    }
    /**
     * Creates an expression that concatenates expression results together.
     *
     * @example
     * ```typescript
     * // Combine the 'firstName', ' ', and 'lastName' fields into a single value.
     * field("firstName").concat(constant(" "), field("lastName"));
     * ```
     *
     * @param second - The additional expression or literal to concatenate.
     * @param others - Optional additional expressions or literals to concatenate.
     * @returns A new `Expression` representing the concatenated value.
     */ concat(e, ...t) {
        const n = [
            e,
            ...t
        ].map(__PRIVATE_valueToDefaultExpr);
        return new FunctionExpression("concat", [
            this,
            ...n
        ], "concat");
    }
    /**
     * Creates an expression that reverses this string expression.
     *
     * @example
     * ```typescript
     * // Reverse the value of the 'myString' field.
     * field("myString").reverse();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the reversed string.
     */ reverse() {
        return new FunctionExpression("reverse", [
            this
        ], "reverse");
    }
    /**
     * Filters the array using a provided alias and predicate expression.
     *
     * @example
     * ```typescript
     * // Filter the 'items' array to only include those where the 'price' is greater than 10
     * field("items").arrayFilter('item', greaterThan(variable('item.price'), 10));
     * ```
     *
     * @param alias - The variable name to use for each element.
     * @param filter - The predicate boolean expression to filter by.
     * @returns A new `Expression` representing the filtered array.
     */ arrayFilter(e, t) {
        return new FunctionExpression("array_filter", [
            this,
            __PRIVATE_valueToDefaultExpr(e),
            t
        ], "arrayFilter");
    }
    /**
     * Creates an expression that applies a provided transformation to each element in an array.
     *
     * @example
     * ```typescript
     * // Transform the 'scores' array by multiplying each score by 10
     * field("scores").arrayTransform("score", multiply(variable("score"), 10));
     * ```
     *
     * @param elementAlias - The variable name to use for each element.
     * @param transform - The lambda expression used to transform the elements.
     * @returns A new `Expression` representing the arrayTransform operation.
     */ arrayTransform(e, t) {
        return new FunctionExpression("array_transform", [
            this,
            __PRIVATE_valueToDefaultExpr(e),
            t
        ], "arrayTransform");
    }
    /**
     * Creates an expression that applies a provided transformation to each element in an array, providing the element's index to the transformation expression.
     *
     * @example
     * ```typescript
     * // Transform the 'scores' array by adding the index to each score
     * field("scores").arrayTransformWithIndex("score", "i", add(variable("score"), variable("i")));
     * ```
     *
     * @param elementAlias - The variable name to use for each element.
     * @param indexAlias - The variable name to use for the current index.
     * @param transform - The lambda expression used to transform the elements.
     * @returns A new `Expression` representing the arrayTransformWithIndex operation.
     */ arrayTransformWithIndex(e, t, n) {
        return new FunctionExpression("array_transform", [
            this,
            __PRIVATE_valueToDefaultExpr(e),
            __PRIVATE_valueToDefaultExpr(t),
            n
        ], "arrayTransformWithIndex");
    }
    /**
     * Returns a subset of the array.
     *
     * @example
     * ```typescript
     * // Get 5 elements from the 'items' array starting from index 2
     * field("items").arraySlice(2, 5);
     *
     * // Get n number of elements from the 'items' array starting from index 2
     * field("items").arraySlice(2, field("count"));
     * ```
     *
     * @param offset - The starting offset.
     * @param length - The optional length of the slice.
     * @returns A new `Expression` representing the sliced array.
     */ arraySlice(e, t) {
        const n = [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ];
        return void 0 !== t && n.push(__PRIVATE_valueToDefaultExpr(t)), new FunctionExpression("array_slice", n, "arraySlice");
    }
    /**
     * Returns the first element of the array.
     *
     * @example
     * ```typescript
     * // Get the first element of the 'myArray' field.
     * field("myArray").arrayFirst();
     * ```
     *
     * @returns A new `Expression` representing the first element.
     */ arrayFirst() {
        return new FunctionExpression("array_first", [
            this
        ], "arrayFirst");
    }
    arrayFirstN(e) {
        return new FunctionExpression("array_first_n", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "arrayFirstN");
    }
    /**
     * Returns the last element of the array.
     *
     * @example
     * ```typescript
     * // Get the last element of the 'myArray' field.
     * field("myArray").arrayLast();
     * ```
     *
     * @returns A new `Expression` representing the last element.
     */ arrayLast() {
        return new FunctionExpression("array_last", [
            this
        ], "arrayLast");
    }
    arrayLastN(e) {
        return new FunctionExpression("array_last_n", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "arrayLastN");
    }
    /**
     * Returns the maximum value in the array.
     *
     * @example
     * ```typescript
     * // Get the maximum value of the 'myArray' field.
     * field("myArray").arrayMaximum();
     * ```
     *
     * @returns A new `Expression` representing the maximum value.
     */ arrayMaximum() {
        return new FunctionExpression("maximum", [
            this
        ], "arrayMaximum");
    }
    arrayMaximumN(e) {
        return new FunctionExpression("maximum_n", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "arrayMaximumN");
    }
    /**
     * Returns the minimum value in the array.
     *
     * @example
     * ```typescript
     * // Get the minimum value of the 'myArray' field.
     * field("myArray").arrayMinimum();
     * ```
     *
     * @returns A new `Expression` representing the minimum value.
     */ arrayMinimum() {
        return new FunctionExpression("minimum", [
            this
        ], "arrayMinimum");
    }
    arrayMinimumN(e) {
        return new FunctionExpression("minimum_n", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "arrayMinimumN");
    }
    arrayIndexOf(e) {
        return new FunctionExpression("array_index_of", [
            this,
            __PRIVATE_valueToDefaultExpr(e),
            __PRIVATE_valueToDefaultExpr("first")
        ], "arrayIndexOf");
    }
    arrayLastIndexOf(e) {
        return new FunctionExpression("array_index_of", [
            this,
            __PRIVATE_valueToDefaultExpr(e),
            __PRIVATE_valueToDefaultExpr("last")
        ], "arrayLastIndexOf");
    }
    arrayIndexOfAll(e) {
        return new FunctionExpression("array_index_of_all", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "arrayIndexOfAll");
    }
    /**
     * Creates an expression that calculates the length of this string expression in bytes.
     *
     * @example
     * ```typescript
     * // Calculate the length of the 'myString' field in bytes.
     * field("myString").byteLength();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the length of the string in bytes.
     */ byteLength() {
        return new FunctionExpression("byte_length", [
            this
        ], "byteLength");
    }
    /**
     * Creates an expression that computes the ceiling of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the ceiling of the 'price' field.
     * field("price").ceil();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the ceiling of the numeric value.
     */ ceil() {
        return new FunctionExpression("ceil", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the floor of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the floor of the 'price' field.
     * field("price").floor();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the floor of the numeric value.
     */ floor() {
        return new FunctionExpression("floor", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the absolute value of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the absolute value of the 'price' field.
     * field("price").abs();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the absolute value of the numeric value.
     */ abs() {
        return new FunctionExpression("abs", [
            this
        ]);
    }
    /**
     * Creates an expression that computes e to the power of this expression.
     *
     * @example
     * ```typescript
     * // Compute e to the power of the 'value' field.
     * field("value").exp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the exp of the numeric value.
     */ exp() {
        return new FunctionExpression("exp", [
            this
        ]);
    }
    /**
     * Accesses a value from a map (object) field using the provided key.
     *
     * @example
     * ```typescript
     * // Get the 'city' value from the 'address' map field
     * field("address").mapGet("city");
     * ```
     *
     * @param subfield - The key to access in the map.
     * @returns A new `Expression` representing the value associated with the given key in the map.
     */ mapGet(e) {
        return new FunctionExpression("map_get", [
            this,
            constant(e)
        ], "mapGet");
    }
    /**
     * Creates an expression that returns a new map with the specified entries added or updated.
     *
     * @remarks
     * Note that `mapSet` only performs shallow updates to the map. Setting a value to `null`
     * will retain the key with a `null` value. To remove a key entirely, use `mapRemove`.
     *
     * @example
     * ```typescript
     * // Set the 'city' to "San Francisco" in the 'address' map
     * field("address").mapSet("city", "San Francisco");
     * ```
     *
     * @param key - The key to set. Must be a string or a constant string expression.
     * @param value - The value to set.
     * @param moreKeyValues - Additional key-value pairs to set.
     * @returns A new `Expression` representing the map with the entries set.
     */ mapSet(e, t, ...n) {
        const r = [
            this,
            __PRIVATE_valueToDefaultExpr(e),
            __PRIVATE_valueToDefaultExpr(t),
            ...n.map(__PRIVATE_valueToDefaultExpr)
        ];
        return new FunctionExpression("map_set", r, "mapSet");
    }
    /**
     * Creates an expression that returns the keys of a map.
     *
     * @remarks
     * While the backend generally preserves insertion order, relying on the
     * order of the output array is not guaranteed and should be avoided.
     *
     * @example
     * ```typescript
     * // Get the keys of the 'address' map
     * field("address").mapKeys();
     * ```
     *
     * @returns A new `Expression` representing the keys of the map.
     */ mapKeys() {
        return new FunctionExpression("map_keys", [
            this
        ], "mapKeys");
    }
    /**
     * Creates an expression that returns the values of a map.
     *
     * @remarks
     * While the backend generally preserves insertion order, relying on the
     * order of the output array is not guaranteed and should be avoided.
     *
     * @example
     * ```typescript
     * // Get the values of the 'address' map
     * field("address").mapValues();
     * ```
     *
     * @returns A new `Expression` representing the values of the map.
     */ mapValues() {
        return new FunctionExpression("map_values", [
            this
        ], "mapValues");
    }
    /**
     * Creates an expression that returns the entries of a map as an array of maps,
     * where each map contains a `"k"` property for the key and a `"v"` property for the value.
     * For example: `[{ k: "key1", v: "value1" }, ...]`.
     *
     * @example
     * ```typescript
     * // Get the entries of the 'address' map
     * field("address").mapEntries();
     * ```
     *
     * @returns A new `Expression` representing the entries of the map.
     */ mapEntries() {
        return new FunctionExpression("map_entries", [
            this
        ], "mapEntries");
    }
    /**
     * @public
     * Creates an expression that returns the value of a field from the document that results from the evaluation of this expression.
     *
     * @example
     * ```typescript
     * // Get the value of the "city" field in the "address" document.
     * field("address").getField("city")
     * ```
     *
     * @param key The field to access in the document.
     * @returns A new `Expression` representing the value of the field in the document.
     */ getField(e) {
        return new FunctionExpression("get_field", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "get_field");
    }
    /**
     * Creates an aggregation that counts the number of stage inputs with valid evaluations of the
     * expression or field.
     *
     * @example
     * ```typescript
     * // Count the total number of products
     * field("productId").count().as("totalProducts");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'count' aggregation.
     */ count() {
        return AggregateFunction._create("count", [
            this
        ], "count");
    }
    /**
     * Creates an aggregation that calculates the sum of a numeric field across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Calculate the total revenue from a set of orders
     * field("orderAmount").sum().as("totalRevenue");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'sum' aggregation.
     */ sum() {
        return AggregateFunction._create("sum", [
            this
        ], "sum");
    }
    /**
     * Creates an aggregation that calculates the average (mean) of a numeric field across multiple
     * stage inputs.
     *
     * @example
     * ```typescript
     * // Calculate the average age of users
     * field("age").average().as("averageAge");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'average' aggregation.
     */ average() {
        return AggregateFunction._create("average", [
            this
        ], "average");
    }
    /**
     * Creates an aggregation that finds the minimum value of a field across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the lowest price of all products
     * field("price").minimum().as("lowestPrice");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'minimum' aggregation.
     */ minimum() {
        return AggregateFunction._create("minimum", [
            this
        ], "minimum");
    }
    /**
     * Creates an aggregation that finds the maximum value of a field across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the highest score in a leaderboard
     * field("score").maximum().as("highestScore");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'maximum' aggregation.
     */ maximum() {
        return AggregateFunction._create("maximum", [
            this
        ], "maximum");
    }
    /**
     * Creates an aggregation that finds the first value of an expression across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the first value of the 'rating' field
     * field("rating").first().as("firstRating");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'first' aggregation.
     */ first() {
        return AggregateFunction._create("first", [
            this
        ], "first");
    }
    /**
     * Creates an aggregation that finds the last value of an expression across multiple stage inputs.
     *
     * @example
     * ```typescript
     * // Find the last value of the 'rating' field
     * field("rating").last().as("lastRating");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'last' aggregation.
     */ last() {
        return AggregateFunction._create("last", [
            this
        ], "last");
    }
    /**
     * Creates an aggregation that collects all values of an expression across multiple stage inputs
     * into an array.
     *
     * @remarks
     * If the expression resolves to an absent value, it is converted to `null`.
     * The order of elements in the output array is not stable and shouldn't be relied upon.
     *
     * @example
     * ```typescript
     * // Collect all tags from books into an array
     * field("tags").arrayAgg().as("allTags");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'array_agg' aggregation.
     */ arrayAgg() {
        return AggregateFunction._create("array_agg", [
            this
        ], "arrayAgg");
    }
    /**
     * Creates an aggregation that collects all distinct values of an expression across multiple stage
     * inputs into an array.
     *
     * @remarks
     * If the expression resolves to an absent value, it is converted to `null`.
     * The order of elements in the output array is not stable and shouldn't be relied upon.
     *
     * @example
     * ```typescript
     * // Collect all distinct tags from books into an array
     * field("tags").arrayAggDistinct().as("allDistinctTags");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'array_agg_distinct' aggregation.
     */ arrayAggDistinct() {
        return AggregateFunction._create("array_agg_distinct", [
            this
        ], "arrayAggDistinct");
    }
    /**
     * Creates an aggregation that counts the number of distinct values of the expression or field.
     *
     * @example
     * ```typescript
     * // Count the distinct number of products
     * field("productId").countDistinct().as("distinctProducts");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'count_distinct' aggregation.
     */ countDistinct() {
        return AggregateFunction._create("count_distinct", [
            this
        ], "countDistinct");
    }
    /**
     * Creates an expression that returns the larger value between this expression and another expression, based on Firestore's value type ordering.
     *
     * @example
     * ```typescript
     * // Returns the larger value between the 'timestamp' field and the current timestamp.
     * field("timestamp").logicalMaximum(currentTimestamp());
     * ```
     *
     * @param second - The second expression or literal to compare with.
     * @param others - Optional additional expressions or literals to compare with.
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical maximum operation.
     */ logicalMaximum(e, ...t) {
        const n = [
            e,
            ...t
        ];
        return new FunctionExpression("maximum", [
            this,
            ...n.map(__PRIVATE_valueToDefaultExpr)
        ], "logicalMaximum");
    }
    /**
     * Creates an expression that returns the smaller value between this expression and another expression, based on Firestore's value type ordering.
     *
     * @example
     * ```typescript
     * // Returns the smaller value between the 'timestamp' field and the current timestamp.
     * field("timestamp").logicalMinimum(currentTimestamp());
     * ```
     *
     * @param second - The second expression or literal to compare with.
     * @param others - Optional additional expressions or literals to compare with.
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical minimum operation.
     */ logicalMinimum(e, ...t) {
        const n = [
            e,
            ...t
        ];
        return new FunctionExpression("minimum", [
            this,
            ...n.map(__PRIVATE_valueToDefaultExpr)
        ], "minimum");
    }
    /**
     * Creates an expression that calculates the length (number of dimensions) of this Firestore Vector expression.
     *
     * @example
     * ```typescript
     * // Get the vector length (dimension) of the field 'embedding'.
     * field("embedding").vectorLength();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the length of the vector.
     */ vectorLength() {
        return new FunctionExpression("vector_length", [
            this
        ], "vectorLength");
    }
    cosineDistance(e) {
        return new FunctionExpression("cosine_distance", [
            this,
            __PRIVATE_vectorToExpr(e)
        ], "cosineDistance");
    }
    dotProduct(e) {
        return new FunctionExpression("dot_product", [
            this,
            __PRIVATE_vectorToExpr(e)
        ], "dotProduct");
    }
    euclideanDistance(e) {
        return new FunctionExpression("euclidean_distance", [
            this,
            __PRIVATE_vectorToExpr(e)
        ], "euclideanDistance");
    }
    /**
     * Creates an expression that interprets this expression as the number of microseconds since the Unix epoch (1970-01-01 00:00:00 UTC)
     * and returns a timestamp.
     *
     * @example
     * ```typescript
     * // Interpret the 'microseconds' field as microseconds since epoch.
     * field("microseconds").unixMicrosToTimestamp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the timestamp.
     */ unixMicrosToTimestamp() {
        return new FunctionExpression("unix_micros_to_timestamp", [
            this
        ], "unixMicrosToTimestamp");
    }
    /**
     * Creates an expression that converts this timestamp expression to the number of microseconds since the Unix epoch (1970-01-01 00:00:00 UTC).
     *
     * @example
     * ```typescript
     * // Convert the 'timestamp' field to microseconds since epoch.
     * field("timestamp").timestampToUnixMicros();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the number of microseconds since epoch.
     */ timestampToUnixMicros() {
        return new FunctionExpression("timestamp_to_unix_micros", [
            this
        ], "timestampToUnixMicros");
    }
    /**
     * Creates an expression that interprets this expression as the number of milliseconds since the Unix epoch (1970-01-01 00:00:00 UTC)
     * and returns a timestamp.
     *
     * @example
     * ```typescript
     * // Interpret the 'milliseconds' field as milliseconds since epoch.
     * field("milliseconds").unixMillisToTimestamp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the timestamp.
     */ unixMillisToTimestamp() {
        return new FunctionExpression("unix_millis_to_timestamp", [
            this
        ], "unixMillisToTimestamp");
    }
    /**
     * Creates an expression that converts this timestamp expression to the number of milliseconds since the Unix epoch (1970-01-01 00:00:00 UTC).
     *
     * @example
     * ```typescript
     * // Convert the 'timestamp' field to milliseconds since epoch.
     * field("timestamp").timestampToUnixMillis();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the number of milliseconds since epoch.
     */ timestampToUnixMillis() {
        return new FunctionExpression("timestamp_to_unix_millis", [
            this
        ], "timestampToUnixMillis");
    }
    /**
     * Creates an expression that interprets this expression as the number of seconds since the Unix epoch (1970-01-01 00:00:00 UTC)
     * and returns a timestamp.
     *
     * @example
     * ```typescript
     * // Interpret the 'seconds' field as seconds since epoch.
     * field("seconds").unixSecondsToTimestamp();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the timestamp.
     */ unixSecondsToTimestamp() {
        return new FunctionExpression("unix_seconds_to_timestamp", [
            this
        ], "unixSecondsToTimestamp");
    }
    /**
     * Creates an expression that converts this timestamp expression to the number of seconds since the Unix epoch (1970-01-01 00:00:00 UTC).
     *
     * @example
     * ```typescript
     * // Convert the 'timestamp' field to seconds since epoch.
     * field("timestamp").timestampToUnixSeconds();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the number of seconds since epoch.
     */ timestampToUnixSeconds() {
        return new FunctionExpression("timestamp_to_unix_seconds", [
            this
        ], "timestampToUnixSeconds");
    }
    timestampAdd(e, t) {
        return new FunctionExpression("timestamp_add", [
            this,
            __PRIVATE_valueToDefaultExpr(e),
            __PRIVATE_valueToDefaultExpr(t)
        ], "timestampAdd");
    }
    timestampSubtract(e, t) {
        return new FunctionExpression("timestamp_subtract", [
            this,
            __PRIVATE_valueToDefaultExpr(e),
            __PRIVATE_valueToDefaultExpr(t)
        ], "timestampSubtract");
    }
    timestampDiff(e, t) {
        return new FunctionExpression("timestamp_diff", [
            this,
            __PRIVATE_fieldOrExpression(e),
            __PRIVATE_valueToDefaultExpr(t)
        ], "timestampDiff");
    }
    timestampExtract(e, t) {
        const n = [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ];
        return t && n.push(__PRIVATE_valueToDefaultExpr(t)), new FunctionExpression("timestamp_extract", n, "timestampExtract");
    }
    /**
     *
     * Creates an expression that returns the document ID from a path.
     *
     * @example
     * ```typescript
     * // Get the document ID from a path.
     * field("__path__").documentId();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the documentId operation.
     */ documentId() {
        return new FunctionExpression("document_id", [
            this
        ], "documentId");
    }
    /**
     *
     * Creates an expression that returns the parent document reference of a document reference.
     *
     * @example
     * ```typescript
     * // Get the parent document reference of a document reference.
     * field("__path__").parent();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the parent operation.
     */ parent() {
        return new FunctionExpression("parent", [
            this
        ], "parent");
    }
    substring(e, t) {
        const n = __PRIVATE_valueToDefaultExpr(e);
        return new FunctionExpression("substring", void 0 === t ? [
            this,
            n
        ] : [
            this,
            n,
            __PRIVATE_valueToDefaultExpr(t)
        ], "substring");
    }
    arrayGet(e) {
        return new FunctionExpression("array_get", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "arrayGet");
    }
    /**
     *
     * Creates an expression that checks if a given expression produces an error.
     *
     * @example
     * ```typescript
     * // Check if the result of a calculation is an error
     * field("title").arrayContains(1).isError();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#BooleanExpression} representing the 'isError' check.
     */ isError() {
        return new FunctionExpression("is_error", [
            this
        ], "isError").asBoolean();
    }
    ifError(e) {
        const t = new FunctionExpression("if_error", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "ifError");
        return e instanceof BooleanExpression ? t.asBoolean() : t;
    }
    /**
     *
     * Creates an expression that returns `true` if the result of this expression
     * is absent. Otherwise, returns `false` even if the value is `null`.
     *
     * @example
     * ```typescript
     * // Check if the field `value` is absent.
     * field("value").isAbsent();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#BooleanExpression} representing the 'isAbsent' check.
     */ isAbsent() {
        return new FunctionExpression("is_absent", [
            this
        ], "isAbsent").asBoolean();
    }
    mapRemove(e) {
        return new FunctionExpression("map_remove", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "mapRemove");
    }
    /**
     *
     * Creates an expression that merges multiple map values.
     *
     * @example
     * ```
     * // Merges the map in the settings field with, a map literal, and a map in
     * // that is conditionally returned by another expression
     * field('settings').mapMerge({ enabled: true }, conditional(field('isAdmin'), { admin: true}, {})
     * ```
     *
     * @param secondMap - A required second map to merge. Represented as a literal or
     * an expression that returns a map.
     * @param otherMaps - Optional additional maps to merge. Each map is represented
     * as a literal or an expression that returns a map.
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the 'mapMerge' operation.
     */ mapMerge(e, ...t) {
        const n = __PRIVATE_valueToDefaultExpr(e), r = t.map(__PRIVATE_valueToDefaultExpr);
        return new FunctionExpression("map_merge", [
            this,
            n,
            ...r
        ], "mapMerge");
    }
    pow(e) {
        return new FunctionExpression("pow", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ]);
    }
    trunc(e) {
        return void 0 === e ? new FunctionExpression("trunc", [
            this
        ]) : new FunctionExpression("trunc", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "trunc");
    }
    round(e) {
        return void 0 === e ? new FunctionExpression("round", [
            this
        ]) : new FunctionExpression("round", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "round");
    }
    /**
     * Creates an expression that returns the collection ID from a path.
     *
     * @example
     * ```typescript
     * // Get the collection ID from a path.
     * field("__path__").collectionId();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the collectionId operation.
     */ collectionId() {
        return new FunctionExpression("collection_id", [
            this
        ]);
    }
    /**
     * Creates an expression that calculates the length of a string, array, map, vector, or bytes.
     *
     * @example
     * ```typescript
     * // Get the length of the 'name' field.
     * field("name").length();
     *
     * // Get the number of items in the 'cart' array.
     * field("cart").length();
     * ```
     *
     * @returns A new `Expression` representing the length of the string, array, map, vector, or bytes.
     */ length() {
        return new FunctionExpression("length", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the natural logarithm of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the natural logarithm of the 'value' field.
     * field("value").ln();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the natural logarithm of the numeric value.
     */ ln() {
        return new FunctionExpression("ln", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the square root of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the square root of the 'value' field.
     * field("value").sqrt();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the square root of the numeric value.
     */ sqrt() {
        return new FunctionExpression("sqrt", [
            this
        ]);
    }
    /**
     * Creates an expression that reverses a string.
     *
     * @example
     * ```typescript
     * // Reverse the value of the 'myString' field.
     * field("myString").stringReverse();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the reversed string.
     */ stringReverse() {
        return new FunctionExpression("string_reverse", [
            this
        ]);
    }
    ifAbsent(e) {
        return new FunctionExpression("if_absent", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "ifAbsent");
    }
    ifNull(e) {
        return new FunctionExpression("if_null", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "ifNull");
    }
    /**
     * Creates an expression that returns the first non-null, non-absent argument, without evaluating
     * the rest of the arguments. When all arguments are null or absent, returns the last argument.
     *
     * @example
     * ```typescript
     * // Returns the value of the first non-null, non-absent field among 'preferredName', 'fullName',
     * // or the last argument if all previous fields are null.
     * field("preferredName").coalesce(field("fullName"), "Anonymous");
     * ```
     *
     * @param replacement - The value to use if this expression evaluates to null.
     * @param others - Optional additional values to check if previous values are null.
     * @returns A new `Expression` representing the coalesce operation.
     */ coalesce(e, ...t) {
        return new FunctionExpression("coalesce", [
            this,
            __PRIVATE_valueToDefaultExpr(e),
            ...t.map(__PRIVATE_valueToDefaultExpr)
        ], "coalesce");
    }
    join(e) {
        return new FunctionExpression("join", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "join");
    }
    /**
     * Creates an expression that computes the base-10 logarithm of a numeric value.
     *
     * @example
     * ```typescript
     * // Compute the base-10 logarithm of the 'value' field.
     * field("value").log10();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the base-10 logarithm of the numeric value.
     */ log10() {
        return new FunctionExpression("log10", [
            this
        ]);
    }
    /**
     * Creates an expression that computes the sum of the elements in an array.
     *
     * @example
     * ```typescript
     * // Compute the sum of the elements in the 'scores' field.
     * field("scores").arraySum();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the sum of the elements in the array.
     */ arraySum() {
        return new FunctionExpression("sum", [
            this
        ]);
    }
    split(e) {
        return new FunctionExpression("split", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ]);
    }
    timestampTruncate(e, t) {
        const n = [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ];
        return t && n.push(__PRIVATE_valueToDefaultExpr(t)), new FunctionExpression("timestamp_trunc", n);
    }
    // TODO(search) enable with backend support
    // /**
    //  * Evaluates if the result of this `expression` is between
    //  * the `lowerBound` (inclusive) and `upperBound` (inclusive).
    //  *
    //  * @example
    //  * ```
    //  * // Evaluate if the 'tireWidth' is between 2.2 and 2.4
    //  * field('tireWidth').between(constant(2.2), constant(2.4))
    //  *
    //  * // This is functionally equivalent to
    //  * and(field('tireWidth').greaterThanOrEqual(contant(2.2)), field('tireWidth').lessThanOrEqual(constant(2.4)))
    //  * ```
    //  *
    //  * @param lowerBound - Lower bound (inclusive) of the range.
    //  * @param upperBound - Upper bound (inclusive) of the range.
    //  */
    // between(lowerBound: Expression, upperBound: Expression): BooleanExpression;
    // /**
    //  * Evaluates if the result of this `expression` is between
    //  * the `lowerBound` (inclusive) and `upperBound` (inclusive).
    //  *
    //  * @example
    //  * ```
    //  * // Evaluate if the 'tireWidth' is between 2.2 and 2.4
    //  * field('tireWidth').between(2.2, 2.4)
    //  *
    //  * // This is functionally equivalent to
    //  * and(field('tireWidth').greaterThanOrEqual(2.2), field('tireWidth').lessThanOrEqual(2.4))
    //  * ```
    //  *
    //  * @param lowerBound - Lower bound (inclusive) of the range.
    //  * @param upperBound - Upper bound (inclusive) of the range.
    //  */
    // between(lowerBound: unknown, upperBound: unknown): BooleanExpression;
    // between(lowerBound: unknown, upperBound: unknown): BooleanExpression {
    //   return new FunctionExpression('between', [
    //     this,
    //     valueToDefaultExpr(lowerBound),
    //     valueToDefaultExpr(upperBound)
    //   ]).asBoolean();
    // }
    // TODO(search) enable with backend support
    // /**
    //  * Evaluates to an HTML-formatted text snippet that renders terms matching
    //  * the search query in `<b>bold</b>`.
    //  *
    //  * @remarks This Expression can only be used within a `search` stage.
    //  *
    //  * @param rquery Define the search query using the search domain-specific language (DSL).
    //  */
    // snippet(rquery: string): Expression;
    // /**
    //  * Evaluates to an HTML-formatted text snippet that renders terms matching
    //  * the search query in `<b>bold</b>`.
    //  *
    //  * @remarks This Expression can only be used within a `search` stage.
    //  *
    //  * @param options Define how snippeting behaves.
    //  */
    // snippet(options: SnippetOptions): Expression;
    // snippet(queryOrOptions: string | SnippetOptions): Expression {
    //   const options: SnippetOptions = isString(queryOrOptions)
    //     ? { rquery: queryOrOptions }
    //     : queryOrOptions;
    //   const rquery = options.rquery;
    //   const internalOptions = {
    //     maxSnippetWidth: options.maxSnippetWidth,
    //     maxSnippets: options.maxSnippets,
    //     separator: options.separator
    //   };
    //   return new SnippetExpression([this, constant(rquery)], internalOptions);
    // }
    // TODO(new-expression): Add new expression method definitions above this line
    /**
     * Creates an {@link @firebase/firestore/pipelines#Ordering} that sorts documents in ascending order based on this expression.
     *
     * @example
     * ```typescript
     * // Sort documents by the 'name' field in ascending order
     * firestore.pipeline().collection("users")
     *   .sort(field("name").ascending());
     * ```
     *
     * @returns A new `Ordering` for ascending sorting.
     */ ascending() {
        return ascending(this);
    }
    /**
     * Creates an {@link @firebase/firestore/pipelines#Ordering} that sorts documents in descending order based on this expression.
     *
     * @example
     * ```typescript
     * // Sort documents by the 'createdAt' field in descending order
     * firestore.pipeline().collection("users")
     *   .sort(field("createdAt").descending());
     * ```
     *
     * @returns A new `Ordering` for descending sorting.
     */ descending() {
        return descending(this);
    }
    /**
     * Assigns an alias to this expression.
     *
     * Aliases are useful for renaming fields in the output of a stage or for giving meaningful
     * names to calculated values.
     *
     * @example
     * ```typescript
     * // Calculate the total price and assign it the alias "totalPrice" and add it to the output.
     * firestore.pipeline().collection("items")
     *   .addFields(field("price").multiply(field("quantity")).as("totalPrice"));
     * ```
     *
     * @param name - The alias to assign to this expression.
     * @returns A new {@link @firebase/firestore/pipelines#AliasedExpression} that wraps this
     *     expression and associates it with the provided alias.
     */ as(e) {
        return new AliasedExpression(this, e, "as");
    }
}
/**
 *
 * A class that represents an aggregate function.
 */ class AggregateFunction {
    constructor(e, t){
        this.name = e, this.params = t, this.exprType = "AggregateFunction", this._protoValueType = "ProtoValue";
    }
    /**
     * @internal
     * @private
     */ static _create(e, t, n) {
        const r = new AggregateFunction(e, t);
        return r._methodName = n, r;
    }
    /**
     * Assigns an alias to this AggregateFunction. The alias specifies the name that
     * the aggregated value will have in the output document.
     *
     * @example
     * ```typescript
     * // Calculate the average price of all items and assign it the alias "averagePrice".
     * firestore.pipeline().collection("items")
     *   .aggregate(field("price").average().as("averagePrice"));
     * ```
     *
     * @param name - The alias to assign to this AggregateFunction.
     * @returns A new {@link @firebase/firestore/pipelines#AliasedAggregate} that wraps this
     *     AggregateFunction and associates it with the provided alias.
     */ as(e) {
        return new AliasedAggregate(this, e, "as");
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            functionValue: {
                name: this.name,
                args: this.params.map((t)=>t._toProto(e))
            }
        };
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        e = this._methodName ? e.contextWith({
            methodName: this._methodName
        }) : e, this.params.forEach((t)=>t._readUserData(e));
    }
}
/**
 *
 * An AggregateFunction with alias.
 */ class AliasedAggregate {
    constructor(e, t, n){
        this.aggregate = e, this.alias = t, this._methodName = n;
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this.aggregate._readUserData(e);
    }
}
class AliasedExpression {
    constructor(e, t, n){
        this.expr = e, this.alias = t, this._methodName = n, this.exprType = "AliasedExpression", this.selectable = !0;
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this.expr._readUserData(e);
    }
}
/**
 * @internal
 */ class __PRIVATE_ListOfExprs extends Expression {
    constructor(e, t){
        super(), this.Rr = e, this._methodName = t, this.expressionType = "ListOfExpressions";
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            arrayValue: {
                values: this.Rr.map((t)=>t._toProto(e))
            }
        };
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this.Rr.forEach((t)=>t._readUserData(e));
    }
}
/**
 *
 * Represents a reference to a field in a Firestore document, or outputs of a {@link @firebase/firestore/pipelines#Pipeline} stage.
 *
 * <p>Field references are used to access document field values in expressions and to specify fields
 * for sorting, filtering, and projecting data in Firestore pipelines.
 *
 * <p>You can create a `Field` instance using the static {@link @firebase/firestore/pipelines#field} method:
 *
 * @example
 * ```typescript
 * // Create a Field instance for the 'name' field
 * const nameField = field("name");
 *
 * // Create a Field instance for a nested field 'address.city'
 * const cityField = field("address.city");
 * ```
 */ class Field extends Expression {
    /**
     * @internal
     * @private
     * @hideconstructor
     * @param fieldPath
     */ constructor(e, t){
        super(), this.fieldPath = e, this._methodName = t, this.expressionType = "Field", this.selectable = !0;
    }
    get _fieldPath() {
        return this.fieldPath;
    }
    get fieldName() {
        return this.fieldPath.canonicalString();
    }
    get alias() {
        return this.fieldName;
    }
    get expr() {
        return this;
    }
    // TODO(search) enable with backend support
    // /**
    //  * Perform a full-text search on this field.
    //  *
    //  * @remarks This Expression can only be used within a `search` stage.
    //  *
    //  * @param rquery Define the search query using the search domain-specific language (DSL).
    //  */
    // matches(rquery: string | Expression): BooleanExpression {
    //   return new FunctionExpression(
    //     'matches',
    //     [this, valueToDefaultExpr(rquery)],
    //     'matches'
    //   ).asBoolean();
    // }
    /**
     * @beta
     * Evaluates to the distance in meters between the location specified
     * by this field and the query location.
     *
     * @remarks This Expression can only be used within a `search` stage.
     *
     * @param location - Compute distance to this GeoPoint.
     */ geoDistance(e) {
        return new FunctionExpression("geo_distance", [
            this,
            __PRIVATE_valueToDefaultExpr(e)
        ], "geoDistance");
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            fieldReferenceValue: this.fieldPath.canonicalString()
        };
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {}
}
function field(e) {
    return _field(e, "field");
}
function _field(e, t) {
    return new Field("string" == typeof e ? F === e ? documentId$1()._internalPath : __PRIVATE_fieldPathFromArgument("field", e) : e._internalPath, t);
}
/**
 * @internal
 *
 * Represents a constant value that can be used in a Firestore pipeline expression.
 *
 * You can create a `Constant` instance using the static {@link @firebase/firestore/pipelines#field} method:
 *
 * @example
 * ```typescript
 * // Create a Constant instance for the number 10
 * const ten = constant(10);
 *
 * // Create a Constant instance for the string "hello"
 * const hello = constant("hello");
 * ```
 */ class Constant extends Expression {
    /**
     * @private
     * @internal
     * @hideconstructor
     * @param value - The value of the constant.
     */ constructor(e, t){
        super(), this.value = e, this._methodName = t, this.expressionType = "Constant";
    }
    /**
     * @private
     * @internal
     */ static _fromProto(e) {
        const t = new Constant(e, void 0);
        return t._protoValue = e, t;
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return __PRIVATE_hardAssert(void 0 !== this._protoValue, 237), this._protoValue;
    }
    _getValue() {
        return this._protoValue;
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        e = this._methodName ? e.contextWith({
            methodName: this._methodName
        }) : e, __PRIVATE_isFirestoreValue(this._protoValue) || (this._protoValue = __PRIVATE_parseData(this.value, e));
    }
}
function constant(e, t) {
    return __PRIVATE__constant(e, "constant");
}
/**
 * @internal
 * @private
 * @param value
 * @param methodName
 */ function __PRIVATE__constant(e, t) {
    const n = new Constant(e, t);
    return "boolean" == typeof e ? new __PRIVATE_BooleanConstant(n) : n;
}
/**
 * Internal only
 * @internal
 * @private
 */ class MapValue extends Expression {
    constructor(e, t){
        super(), this.Ir = e, this._methodName = t, this.expressionType = "Constant";
    }
    _readUserData(e) {
        e = this._methodName ? e.contextWith({
            methodName: this._methodName
        }) : e, this.Ir.forEach((t)=>{
            t._readUserData(e);
        });
    }
    _toProto(e) {
        return toMapValue(e, this.Ir);
    }
}
/**
 *
 * This class defines the base class for Firestore {@link @firebase/firestore/pipelines#Pipeline} functions, which can be evaluated within pipeline
 * execution.
 *
 * Typically, you would not use this class or its children directly. Use either the functions like {@link @firebase/firestore/pipelines#and}, {@link @firebase/firestore/pipelines#(equal:1)},
 * or the methods on {@link @firebase/firestore/pipelines#Expression} ({@link @firebase/firestore/pipelines#Expression.(equal:1)}, {@link @firebase/firestore/pipelines#Expression.(lessThan:1)}, etc.) to construct new Function instances.
 */ class FunctionExpression extends Expression {
    /**
     * @hideconstructor
     */ constructor(e, t, n, r){
        super(), this.name = e, this.params = t, this.expressionType = "Function", /**
         * @private
         * @internal
         */ this._optionsProto = void 0, void 0 !== n && (this._methodName = n), void 0 !== r && (this._options = r);
    }
    /**
     * @private
     * @internal
     */ get _optionsUtil() {
        return new OptionsUtil({});
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        const t = {
            functionValue: {
                name: this.name,
                args: this.params.map((t)=>t._toProto(e))
            }
        };
        return this._optionsProto && (t.functionValue.options = this._optionsProto), t;
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        e = this._methodName ? e.contextWith({
            methodName: this._methodName
        }) : e, this.params.forEach((t)=>t._readUserData(e)), this._options && (this._optionsProto = this._optionsUtil.getOptionsProto(e, this._options));
    }
}
/**
 *
 * An interface that represents a filter condition.
 */ class BooleanExpression extends Expression {
    get _methodName() {
        return this._expr._methodName;
    }
    /**
     * Creates an aggregation that finds the count of input documents satisfying
     * this boolean expression.
     *
     * @example
     * ```typescript
     * // Find the count of documents with a score greater than 90
     * field("score").greaterThan(90).countIf().as("highestScore");
     * ```
     *
     * @returns A new `AggregateFunction` representing the 'countIf' aggregation.
     */ countIf() {
        return AggregateFunction._create("count_if", [
            this
        ], "countIf");
    }
    /**
     * Creates an expression that negates this boolean expression.
     *
     * @example
     * ```typescript
     * // Find documents where the 'tags' field does not contain 'completed'
     * field("tags").arrayContains("completed").not();
     * ```
     *
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the negated filter condition.
     */ not() {
        return new FunctionExpression("not", [
            this
        ], "not").asBoolean();
    }
    /**
     * Creates a conditional expression that evaluates to the 'then' expression
     * if `this` expression evaluates to `true`,
     * or evaluates to the 'else' expression if `this` expressions evaluates `false`.
     *
     * @example
     * ```typescript
     * // If 'age' is greater than 18, return "Adult"; otherwise, return "Minor".
     * field("age").greaterThanOrEqual(18).conditional(constant("Adult"), constant("Minor"));
     * ```
     *
     * @param thenExpr - The expression to evaluate if the condition is true.
     * @param elseExpr - The expression to evaluate if the condition is false.
     * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the conditional expression.
     */ conditional(e, t) {
        return new FunctionExpression("conditional", [
            this,
            e,
            t
        ], "conditional");
    }
    ifError(e) {
        const t = __PRIVATE_valueToDefaultExpr(e), n = new FunctionExpression("if_error", [
            this,
            t
        ], "ifError");
        return t instanceof BooleanExpression ? n.asBoolean() : n;
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return this._expr._toProto(e);
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this._expr._readUserData(e);
    }
}
class __PRIVATE_BooleanFunctionExpression extends BooleanExpression {
    constructor(e){
        super(), this._expr = e, this.expressionType = "Function";
    }
}
class __PRIVATE_BooleanConstant extends BooleanExpression {
    constructor(e){
        super(), this._expr = e, this.expressionType = "Constant";
    }
    _getValue() {
        return this._expr._getValue();
    }
}
class __PRIVATE_BooleanField extends BooleanExpression {
    constructor(e){
        super(), this._expr = e, this.expressionType = "Field";
    }
}
/**
 * Creates an aggregation that counts the number of stage inputs where the provided
 * boolean expression evaluates to true.
 *
 * @example
 * ```typescript
 * // Count the number of documents where 'is_active' field equals true
 * countIf(field("is_active").equal(true)).as("numActiveDocuments");
 * ```
 *
 * @param booleanExpr - The boolean expression to evaluate on each input.
 * @returns A new `AggregateFunction` representing the 'countIf' aggregation.
 */ function countIf(e) {
    return e.countIf();
}
function arrayGet(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayGet(__PRIVATE_valueToDefaultExpr(t));
}
/**
 *
 * Creates an expression that checks if a given expression produces an error.
 *
 * @example
 * ```typescript
 * // Check if the result of a calculation is an error
 * isError(field("title").arrayContains(1));
 * ```
 *
 * @param value - The expression to check.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the 'isError' check.
 */ function isError(e) {
    return e.isError().asBoolean();
}
function ifError(e, t) {
    return e instanceof BooleanExpression && t instanceof BooleanExpression ? e.ifError(t).asBoolean() : e.ifError(__PRIVATE_valueToDefaultExpr(t));
}
function isAbsent(e) {
    return __PRIVATE_fieldOrExpression(e).isAbsent();
}
function mapRemove(e, t) {
    return __PRIVATE_fieldOrExpression(e).mapRemove(__PRIVATE_valueToDefaultExpr(t));
}
function mapMerge(e, t, ...n) {
    const r = __PRIVATE_valueToDefaultExpr(t), i = n.map(__PRIVATE_valueToDefaultExpr);
    return __PRIVATE_fieldOrExpression(e).mapMerge(r, ...i);
}
function documentId(e) {
    return __PRIVATE_valueToDefaultExpr(e).documentId();
}
function parent(e) {
    return __PRIVATE_valueToDefaultExpr(e).parent();
}
function substring(e, t, n) {
    const r = __PRIVATE_fieldOrExpression(e), i = __PRIVATE_valueToDefaultExpr(t), s = void 0 === n ? void 0 : __PRIVATE_valueToDefaultExpr(n);
    return r.substring(i, s);
}
function add(e, t) {
    return __PRIVATE_fieldOrExpression(e).add(__PRIVATE_valueToDefaultExpr(t));
}
function subtract(e, t) {
    const n = "string" == typeof e ? field(e) : e, r = __PRIVATE_valueToDefaultExpr(t);
    return n.subtract(r);
}
function multiply(e, t) {
    return __PRIVATE_fieldOrExpression(e).multiply(__PRIVATE_valueToDefaultExpr(t));
}
function divide(e, t) {
    const n = "string" == typeof e ? field(e) : e, r = __PRIVATE_valueToDefaultExpr(t);
    return n.divide(r);
}
function mod(e, t) {
    const n = "string" == typeof e ? field(e) : e, r = __PRIVATE_valueToDefaultExpr(t);
    return n.mod(r);
}
/**
 *
 * Creates an expression that creates a Firestore map value from an input object.
 *
 * @example
 * ```typescript
 * // Create a map from the input object and reference the 'baz' field value from the input document.
 * map({foo: 'bar', baz: field('baz')}).as('data');
 * ```
 *
 * @param elements - The input map to evaluate in the expression.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the map function.
 */ function map(e) {
    return __PRIVATE__map(e);
}
function __PRIVATE__map(e, t) {
    const n = [];
    for(const t in e)if (Object.prototype.hasOwnProperty.call(e, t)) {
        const r = e[t];
        n.push(constant(t)), n.push(__PRIVATE_valueToDefaultExpr(r));
    }
    return new FunctionExpression("map", n, "map");
}
/**
 * Internal use only
 * Converts a plainObject to a mapValue in the proto representation,
 * rather than a functionValue+map that is the result of the map(...) function.
 * This behaves different from constant(plainObject) because it
 * traverses the input object, converts values in the object to expressions,
 * and calls _readUserData on each of these expressions.
 * @private
 * @internal
 * @param plainObject
 */ function __PRIVATE__mapValue(e) {
    const t = new Map;
    for(const n in e)if (Object.prototype.hasOwnProperty.call(e, n)) {
        const r = e[n];
        t.set(n, __PRIVATE_valueToDefaultExpr(r));
    }
    return new MapValue(t, void 0);
}
/**
 *
 * Creates an expression that creates a Firestore array value from an input array.
 *
 * @example
 * ```typescript
 * // Create an array value from the input array and reference the 'baz' field value from the input document.
 * array(['bar', field('baz')]).as('foo');
 * ```
 *
 * @param elements - The input array to evaluate in the expression.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the array function.
 */ function array(e) {
    return function __PRIVATE__array(e, t) {
        return new FunctionExpression("array", e.map((e)=>__PRIVATE_valueToDefaultExpr(e)), t);
    }(e, "array");
}
function equal(e, t) {
    const n = e instanceof Expression ? e : field(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.equal(r);
}
function notEqual(e, t) {
    const n = e instanceof Expression ? e : field(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.notEqual(r);
}
function lessThan(e, t) {
    const n = e instanceof Expression ? e : field(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.lessThan(r);
}
function lessThanOrEqual(e, t) {
    const n = e instanceof Expression ? e : field(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.lessThanOrEqual(r);
}
function greaterThan(e, t) {
    const n = e instanceof Expression ? e : field(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.greaterThan(r);
}
function greaterThanOrEqual(e, t) {
    const n = e instanceof Expression ? e : field(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.greaterThanOrEqual(r);
}
function arrayConcat(e, t, ...n) {
    const r = n.map((e)=>__PRIVATE_valueToDefaultExpr(e));
    return __PRIVATE_fieldOrExpression(e).arrayConcat(__PRIVATE_fieldOrExpression(t), ...r);
}
function arrayContains(e, t) {
    const n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.arrayContains(r);
}
function arrayContainsAny(e, t) {
    // @ts-ignore implementation accepts both types
    return __PRIVATE_fieldOrExpression(e).arrayContainsAny(t);
}
function arrayContainsAll(e, t) {
    // @ts-ignore implementation accepts both types
    return __PRIVATE_fieldOrExpression(e).arrayContainsAll(t);
}
function arrayLength(e) {
    return __PRIVATE_fieldOrExpression(e).arrayLength();
}
function equalAny(e, t) {
    // @ts-ignore implementation accepts both types
    return __PRIVATE_fieldOrExpression(e).equalAny(t);
}
function notEqualAny(e, t) {
    // @ts-ignore implementation accepts both types
    return __PRIVATE_fieldOrExpression(e).notEqualAny(t);
}
/**
 *
 * Creates an expression that performs a logical 'XOR' (exclusive OR) operation on multiple BooleanExpressions.
 *
 * @example
 * ```typescript
 * // Check if only one of the conditions is true: 'age' greater than 18, 'city' is "London",
 * // or 'status' is "active".
 * const condition = xor(
 *     greaterThan("age", 18),
 *     equal("city", "London"),
 *     equal("status", "active"));
 * ```
 *
 * @param first - The first condition.
 * @param second - The second condition.
 * @param additionalConditions - Additional conditions to 'XOR' together.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical 'XOR' operation.
 */ function xor(e, t, ...n) {
    return new FunctionExpression("xor", [
        e,
        t,
        ...n
    ], "xor").asBoolean();
}
/**
 *
 * Creates a conditional expression that evaluates to a 'then' expression if a condition is true
 * and an 'else' expression if the condition is false.
 *
 * @example
 * ```typescript
 * // If 'age' is greater than 18, return "Adult"; otherwise, return "Minor".
 * conditional(
 *     greaterThan("age", 18), constant("Adult"), constant("Minor"));
 * ```
 *
 * @param condition - The condition to evaluate.
 * @param thenExpr - The expression to evaluate if the condition is true.
 * @param elseExpr - The expression to evaluate if the condition is false.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the conditional expression.
 */ function conditional(e, t, n) {
    return new FunctionExpression("conditional", [
        e,
        t,
        n
    ], "conditional");
}
/**
 *
 * Creates an expression that negates a filter condition.
 *
 * @example
 * ```typescript
 * // Find documents where the 'completed' field is NOT true
 * not(equal("completed", true));
 * ```
 *
 * @param booleanExpr - The filter condition to negate.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the negated filter condition.
 */ function not(e) {
    return e.not();
}
function logicalMaximum(e, t, ...n) {
    return __PRIVATE_fieldOrExpression(e).logicalMaximum(__PRIVATE_valueToDefaultExpr(t), ...n.map((e)=>__PRIVATE_valueToDefaultExpr(e)));
}
function logicalMinimum(e, t, ...n) {
    return __PRIVATE_fieldOrExpression(e).logicalMinimum(__PRIVATE_valueToDefaultExpr(t), ...n.map((e)=>__PRIVATE_valueToDefaultExpr(e)));
}
function exists(e) {
    return __PRIVATE_fieldOrExpression(e).exists();
}
function reverse(e) {
    return __PRIVATE_fieldOrExpression(e).reverse();
}
function byteLength(e) {
    return __PRIVATE_fieldOrExpression(e).byteLength();
}
function exp(e) {
    return __PRIVATE_fieldOrExpression(e).exp();
}
function ceil(e) {
    return __PRIVATE_fieldOrExpression(e).ceil();
}
function floor(e) {
    return __PRIVATE_fieldOrExpression(e).floor();
}
/**
 * Creates an aggregation that counts the number of distinct values of a field.
 *
 * @param expr - The expression or field to count distinct values of.
 * @returns A new `AggregateFunction` representing the 'count_distinct' aggregation.
 */ function countDistinct(e) {
    return __PRIVATE_fieldOrExpression(e).countDistinct();
}
function charLength(e) {
    return __PRIVATE_fieldOrExpression(e).charLength();
}
function like(e, t) {
    const n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.like(r);
}
function regexContains(e, t) {
    const n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.regexContains(r);
}
function arrayFilter(e, t, n) {
    return __PRIVATE_fieldOrExpression(e).arrayFilter(t, n);
}
function arrayTransform(e, t, n) {
    return __PRIVATE_fieldOrExpression(e).arrayTransform(t, n);
}
function arrayTransformWithIndex(e, t, n, r) {
    return __PRIVATE_fieldOrExpression(e).arrayTransformWithIndex(t, n, r);
}
function arraySlice(e, t, n) {
    return __PRIVATE_fieldOrExpression(e).arraySlice(t, n);
}
function arrayFirst(e) {
    return __PRIVATE_fieldOrExpression(e).arrayFirst();
}
function arrayFirstN(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayFirstN(__PRIVATE_valueToDefaultExpr(t));
}
function arrayLast(e) {
    return __PRIVATE_fieldOrExpression(e).arrayLast();
}
function arrayLastN(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayLastN(__PRIVATE_valueToDefaultExpr(t));
}
function arrayMaximum(e) {
    return __PRIVATE_fieldOrExpression(e).arrayMaximum();
}
function arrayMaximumN(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayMaximumN(__PRIVATE_valueToDefaultExpr(t));
}
function arrayMinimum(e) {
    return __PRIVATE_fieldOrExpression(e).arrayMinimum();
}
function arrayMinimumN(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayMinimumN(__PRIVATE_valueToDefaultExpr(t));
}
function arrayIndexOf(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayIndexOf(__PRIVATE_valueToDefaultExpr(t));
}
function arrayLastIndexOf(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayLastIndexOf(__PRIVATE_valueToDefaultExpr(t));
}
function arrayIndexOfAll(e, t) {
    return __PRIVATE_fieldOrExpression(e).arrayIndexOfAll(__PRIVATE_valueToDefaultExpr(t));
}
function regexFind(e, t) {
    const n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.regexFind(r);
}
function regexFindAll(e, t) {
    const n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.regexFindAll(r);
}
function regexMatch(e, t) {
    const n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.regexMatch(r);
}
function stringContains(e, t) {
    const n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_valueToDefaultExpr(t);
    return n.stringContains(r);
}
function startsWith(e, t) {
    return __PRIVATE_fieldOrExpression(e).startsWith(__PRIVATE_valueToDefaultExpr(t));
}
function endsWith(e, t) {
    return __PRIVATE_fieldOrExpression(e).endsWith(__PRIVATE_valueToDefaultExpr(t));
}
function toLower(e) {
    return __PRIVATE_fieldOrExpression(e).toLower();
}
function toUpper(e) {
    return __PRIVATE_fieldOrExpression(e).toUpper();
}
function trim(e, t) {
    return __PRIVATE_fieldOrExpression(e).trim(t);
}
function ltrim(e, t) {
    return __PRIVATE_fieldOrExpression(e).ltrim(t);
}
function rtrim(e, t) {
    return __PRIVATE_fieldOrExpression(e).rtrim(t);
}
function type(e) {
    return __PRIVATE_fieldOrExpression(e).type();
}
function isType(e, t) {
    return __PRIVATE_fieldOrExpression(e).isType(t);
}
function stringConcat(e, t, ...n) {
    return __PRIVATE_fieldOrExpression(e).stringConcat(__PRIVATE_valueToDefaultExpr(t), ...n.map(__PRIVATE_valueToDefaultExpr));
}
function stringIndexOf(e, t) {
    return __PRIVATE_fieldOrExpression(e).stringIndexOf(t);
}
function stringRepeat(e, t) {
    return __PRIVATE_fieldOrExpression(e).stringRepeat(t);
}
function stringReplaceAll(e, t, n) {
    return __PRIVATE_fieldOrExpression(e).stringReplaceAll(t, n);
}
function stringReplaceOne(e, t, n) {
    return __PRIVATE_fieldOrExpression(e).stringReplaceOne(t, n);
}
function mapGet(e, t) {
    return __PRIVATE_fieldOrExpression(e).mapGet(t);
}
function mapSet(e, t, n, ...r) {
    return __PRIVATE_fieldOrExpression(e).mapSet(t, n, ...r);
}
function mapKeys(e) {
    return __PRIVATE_fieldOrExpression(e).mapKeys();
}
function mapValues(e) {
    return __PRIVATE_fieldOrExpression(e).mapValues();
}
function mapEntries(e) {
    return __PRIVATE_fieldOrExpression(e).mapEntries();
}
/**
 * Creates an aggregation that counts the total number of stage inputs.
 *
 * @example
 * ```typescript
 * // Count the total number of input documents
 * countAll().as("totalDocument");
 * ```
 *
 * @returns A new {@link @firebase/firestore/pipelines#AggregateFunction} representing the 'countAll' aggregation.
 */ function countAll() {
    return AggregateFunction._create("count", [], "count");
}
function count(e) {
    return __PRIVATE_fieldOrExpression(e).count();
}
function sum(e) {
    return __PRIVATE_fieldOrExpression(e).sum();
}
function average(e) {
    return __PRIVATE_fieldOrExpression(e).average();
}
function minimum(e) {
    return __PRIVATE_fieldOrExpression(e).minimum();
}
function maximum(e) {
    return __PRIVATE_fieldOrExpression(e).maximum();
}
function first(e) {
    return __PRIVATE_fieldOrExpression(e).first();
}
function last(e) {
    return __PRIVATE_fieldOrExpression(e).last();
}
function arrayAgg(e) {
    return __PRIVATE_fieldOrExpression(e).arrayAgg();
}
function arrayAggDistinct(e) {
    return __PRIVATE_fieldOrExpression(e).arrayAggDistinct();
}
function cosineDistance(e, t) {
    const n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_vectorToExpr(t);
    return n.cosineDistance(r);
}
function dotProduct(e, t) {
    const n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_vectorToExpr(t);
    return n.dotProduct(r);
}
function euclideanDistance(e, t) {
    const n = __PRIVATE_fieldOrExpression(e), r = __PRIVATE_vectorToExpr(t);
    return n.euclideanDistance(r);
}
function vectorLength(e) {
    return __PRIVATE_fieldOrExpression(e).vectorLength();
}
function unixMicrosToTimestamp(e) {
    return __PRIVATE_fieldOrExpression(e).unixMicrosToTimestamp();
}
function timestampToUnixMicros(e) {
    return __PRIVATE_fieldOrExpression(e).timestampToUnixMicros();
}
function unixMillisToTimestamp(e) {
    return __PRIVATE_fieldOrExpression(e).unixMillisToTimestamp();
}
function timestampToUnixMillis(e) {
    return __PRIVATE_fieldOrExpression(e).timestampToUnixMillis();
}
function unixSecondsToTimestamp(e) {
    return __PRIVATE_fieldOrExpression(e).unixSecondsToTimestamp();
}
function timestampToUnixSeconds(e) {
    return __PRIVATE_fieldOrExpression(e).timestampToUnixSeconds();
}
function timestampAdd(e, t, n) {
    const r = __PRIVATE_fieldOrExpression(e), i = __PRIVATE_valueToDefaultExpr(t), s = __PRIVATE_valueToDefaultExpr(n);
    return r.timestampAdd(i, s);
}
function timestampSubtract(e, t, n) {
    const r = __PRIVATE_fieldOrExpression(e), i = __PRIVATE_valueToDefaultExpr(t), s = __PRIVATE_valueToDefaultExpr(n);
    return r.timestampSubtract(i, s);
}
/**
 *
 * Creates an expression that evaluates to the current server timestamp.
 *
 * @example
 * ```typescript
 * // Get the current server timestamp
 * currentTimestamp()
 * ```
 *
 * @returns A new Expression representing the current server timestamp.
 */ function currentTimestamp() {
    return new FunctionExpression("current_timestamp", [], "currentTimestamp");
}
/**
 *
 * Creates an expression that performs a logical 'AND' operation on multiple filter conditions.
 *
 * @example
 * ```typescript
 * // Check if the 'age' field is greater than 18 AND the 'city' field is "London" AND
 * // the 'status' field is "active"
 * const condition = and(greaterThan("age", 18), equal("city", "London"), equal("status", "active"));
 * ```
 *
 * @param first - The first filter condition.
 * @param second - The second filter condition.
 * @param more - Additional filter conditions to 'AND' together.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical 'AND' operation.
 */ function and(e, t, ...n) {
    return new FunctionExpression("and", [
        e,
        t,
        ...n
    ], "and").asBoolean();
}
/**
 *
 * Creates an expression that performs a logical 'OR' operation on multiple filter conditions.
 *
 * @example
 * ```typescript
 * // Check if the 'age' field is greater than 18 OR the 'city' field is "London" OR
 * // the 'status' field is "active"
 * const condition = or(greaterThan("age", 18), equal("city", "London"), equal("status", "active"));
 * ```
 *
 * @param first - The first filter condition.
 * @param second - The second filter condition.
 * @param more - Additional filter conditions to 'OR' together.
 * @returns A new {@link @firebase/firestore/pipelines#Expression} representing the logical 'OR' operation.
 */ function or(e, t, ...n) {
    return new FunctionExpression("or", [
        e,
        t,
        ...n
    ], "xor").asBoolean();
}
/**
 *
 * Creates an expression that performs a logical 'NOR' operation on multiple filter conditions.
 *
 * @example
 * ```typescript
 * // Check if neither the 'age' field is greater than 18 nor the 'city' field is "London"
 * const condition = nor(
 *   greaterThan("age", 18),
 *   equal("city", "London")
 * );
 * ```
 *
 * @param first - The first filter condition.
 * @param second - The second filter condition.
 * @param more - Additional filter conditions to 'NOR' together.
 * @returns A new {@link @firebase/firestore/pipelines#BooleanExpression} representing the logical 'NOR' operation.
 */ function nor(e, t, ...n) {
    return new FunctionExpression("nor", [
        e,
        t,
        ...n
    ], "nor").asBoolean();
}
function pow(e, t) {
    return __PRIVATE_fieldOrExpression(e).pow(t);
}
/**
 *
 * Creates an expression that generates a random number between 0.0 and 1.0 but not including 1.0.
 *
 * @example
 * ```typescript
 * // Generate a random number between 0.0 and 1.0.
 * rand();
 * ```
 *
 * @returns A new `Expression` representing the rand operation.
 */ function rand() {
    return new FunctionExpression("rand", [], "rand");
}
function round(e, t) {
    return void 0 === t ? __PRIVATE_fieldOrExpression(e).round() : __PRIVATE_fieldOrExpression(e).round(__PRIVATE_valueToDefaultExpr(t));
}
function trunc(e, t) {
    return void 0 === t ? __PRIVATE_fieldOrExpression(e).trunc() : __PRIVATE_fieldOrExpression(e).trunc(__PRIVATE_valueToDefaultExpr(t));
}
function collectionId(e) {
    return __PRIVATE_fieldOrExpression(e).collectionId();
}
function length(e) {
    return __PRIVATE_fieldOrExpression(e).length();
}
function ln(e) {
    return __PRIVATE_fieldOrExpression(e).ln();
}
function log(e, t) {
    return new FunctionExpression("log", [
        __PRIVATE_fieldOrExpression(e),
        __PRIVATE_valueToDefaultExpr(t)
    ]);
}
function sqrt(e) {
    return __PRIVATE_fieldOrExpression(e).sqrt();
}
function stringReverse(e) {
    return __PRIVATE_fieldOrExpression(e).stringReverse();
}
function concat(e, t, ...n) {
    return new FunctionExpression("concat", [
        __PRIVATE_fieldOrExpression(e),
        __PRIVATE_valueToDefaultExpr(t),
        ...n.map(__PRIVATE_valueToDefaultExpr)
    ]);
}
function abs(e) {
    return __PRIVATE_fieldOrExpression(e).abs();
}
function ifAbsent(e, t) {
    return __PRIVATE_fieldOrExpression(e).ifAbsent(__PRIVATE_valueToDefaultExpr(t));
}
function ifNull(e, t) {
    return __PRIVATE_fieldOrExpression(e).ifNull(t);
}
function coalesce(e, t, ...n) {
    return __PRIVATE_fieldOrExpression(e).coalesce(t, ...n);
}
/**
 * Creates an expression that evaluates to the result corresponding to the first true condition.
 *
 * @remarks
 * This function behaves like a `switch` statement. It accepts an alternating sequence of conditions
 * and their corresponding results.
 * If an odd number of arguments is provided, the final argument serves as a default fallback result.
 * If no default is provided and no condition evaluates to true, it throws an error.
 *
 * @example
 * ```typescript
 * // Return "Active" if field "status" is 1, "Pending" if field "status" is 2,
 * // and default to "Unknown" if none of the conditions are true.
 * switchOn(
 *   equal(field("status"), 1), constant("Active"),
 *   equal(field("status"), 2), constant("Pending"),
 *   constant("Unknown")
 * )
 * ```
 *
 * @param condition - The first condition to check.
 * @param result - The result if the first condition is true.
 * @param others - Additional conditions and results, and optionally a default value.
 * @returns A new Expression representing the switch operation.
 */ function switchOn(e, t, ...n) {
    return new FunctionExpression("switch_on", [
        __PRIVATE_valueToDefaultExpr(e),
        __PRIVATE_valueToDefaultExpr(t),
        ...n.map(__PRIVATE_valueToDefaultExpr)
    ], "switchOn");
}
function join(e, t) {
    return __PRIVATE_fieldOrExpression(e).join(__PRIVATE_valueToDefaultExpr(t));
}
function log10(e) {
    return __PRIVATE_fieldOrExpression(e).log10();
}
function arraySum(e) {
    return __PRIVATE_fieldOrExpression(e).arraySum();
}
function split(e, t) {
    return __PRIVATE_fieldOrExpression(e).split(__PRIVATE_valueToDefaultExpr(t));
}
function timestampTruncate(e, t, n) {
    const r = __PRIVATE_isString$1(t) ? __PRIVATE_valueToDefaultExpr(t) : t;
    return __PRIVATE_fieldOrExpression(e).timestampTruncate(r, n);
}
/**
 * @public
 * Creates an expression that retrieves the value of a variable bound via `define()`.
 *
 * @example
 * ```typescript
 * db.pipeline().collection("products")
 *   .define(
 *     field("price").multiply(0.9).as("discountedPrice"),
 *     field("stock").add(10).as("newStock")
 *   )
 *   .where(variable("discountedPrice").lessThan(100))
 *   .select(field("name"), variable("newStock"));
 * ```
 *
 * @param name - The name of the variable to retrieve.
 * @returns An {@link @firebase/firestore/pipelines#Expression} representing the variable's value.
 */ function variable(e) {
    return new __PRIVATE_VariableExpression(e);
}
/**
 * @internal
 *
 * Expression representing a variable reference. This evaluates to the value of a variable
 * defined in a pipeline.
 */ class __PRIVATE_VariableExpression extends Expression {
    /**
     * @hideconstructor
     */ constructor(e){
        super(), this.name = e, this.expressionType = "Variable";
    }
    /**
     * @internal
     */ _toProto(e) {
        return {
            variableReferenceValue: this.name
        };
    }
    /**
     * @internal
     */ _readUserData(e) {}
}
/**
 * @public
 * Creates an expression that represents the current document being processed.
 *
 * @example
 * ```typescript
 * // Define the current document as a variable "doc"
 * firestore.pipeline().collection("books")
 *     .define(currentDocument().as("doc"))
 *     // Access a field from the defined document variable
 *     .select(variable("doc").mapGet("title"));
 * ```
 *
 * @returns An {@link @firebase/firestore/pipelines#Expression} representing the current document.
 */ function currentDocument() {
    return new FunctionExpression("current_document", []);
}
/**
 * @internal
 */ function pipelineValue(e) {
    return new __PRIVATE_PipelineValueExpression(e);
}
/**
 * @internal
 */ class __PRIVATE_PipelineValueExpression extends Expression {
    /**
     * @hideconstructor
     */ constructor(e){
        super(), this.pipeline = e, this.expressionType = "PipelineValue";
    }
    /**
     * @internal
     */ _toProto(e) {
        return __PRIVATE_toPipelineValue(this.pipeline._toProto(e));
    }
    /**
     * @internal
     */ _readUserData(e) {
        this.pipeline._readUserData(e);
    }
}
function timestampDiff(e, t, n) {
    const r = __PRIVATE_fieldOrExpression(e), i = __PRIVATE_fieldOrExpression(t), s = __PRIVATE_valueToDefaultExpr(n);
    return r.timestampDiff(i, s);
}
function timestampExtract(e, t, n) {
    return __PRIVATE_fieldOrExpression(e).timestampExtract(__PRIVATE_valueToDefaultExpr(t), n);
}
// TODO(search) enable with backend support
// /**
//  * Perform a full-text search on the specified field.
//  *
//  * @remarks This Expression can only be used within a `search` stage.
//  *
//  * @example
//  * ```typescript
//  * db.pipeline().collection('restaurants').search({
//  *   query: matches('menu', 'waffles')
//  * })
//  * ```
//  *
//  * @param searchField Search the specified field.
//  * @param rquery Define the search query using the search domain-specific language (DSL).
//  */
// export function matches(
//   searchField: string | Field,
//   rquery: string | Expression
// ): BooleanExpression {
//   return toField(searchField).matches(rquery);
// }
/**
 * @beta
 * Perform a full-text search on all indexed search fields in the document.
 *
 * @remarks This Expression can only be used within a `search` stage.
 *
 * @example
 * ```typescript
 * db.pipeline().collection('restaurants').search({
 *   query: documentMatches('waffles OR pancakes')
 * })
 * ```
 *
 * @param rquery Define the search query using the search domain-specific language (DSL).
 */ function documentMatches(e) {
    return new FunctionExpression("document_matches", [
        __PRIVATE_valueToDefaultExpr(e)
    ], "documentMatches").asBoolean();
}
/**
 * @beta
 *
 * Evaluates to the search score that reflects the topicality of the document
 * to all of the text predicates (for example: `documentMatches`)
 * in the search query. If `SearchOptions.query` is not set or does not contain
 * any text predicates, then this topicality score will always be `0`.
 *
 * @example
 * ```typescript
 * db.pipeline().collection('restaurants').search({
 *   query: 'waffles',
 *   sort: score().descending()
 * })
 * ```
 *
 * @remarks This Expression can only be used within a `search` stage.
 */ function score() {
    return new FunctionExpression("score", [], "score");
}
// TODO(search) enable with backend support
// /**
//  * Options defining how a snippet expression is evaluated.
//  */
// export interface SnippetOptions {
//   /**
//    * Define the search query using the search domain-specific language (DSL).
//    */
//   rquery: string;
//   /**
//    * The maximum width of the string estimated for a variable width font. The
//    * unit is tenths of ems. The default is `160`.
//    */
//   maxSnippetWidth?: number;
//   /**
//    * The maximum number of non-contiguous pieces of text in the returned snippet.
//    * The default is `1`.
//    */
//   maxSnippets?: number;
//   /**
//    * The string to join the pieces. The default value is '\n'
//    */
//   separator?: string;
// }
// /**
//  * Evaluates to an HTML-formatted text snippet that highlights terms matching
//  * the search query in `<b>bold</b>`.
//  *
//  * @remarks This Expression can only be used within a `search` stage.
//  *
//  * @example
//  * ```typescript
//  * db.pipeline().collection('restaurants').search({
//  *   query: 'waffles',
//  *   addFields: { snippet: snippet('menu', 'waffles') }
//  * })
//  * ```
//  *
//  * @param searchField Search the specified field for matching terms.
//  * @param rquery Define the search query using the search domain-specific language (DSL).
//  */
// export function snippet(
//   searchField: string | Field,
//   rquery: string
// ): Expression;
// /**
//  * Evaluates to an HTML-formatted text snippet that highlights terms matching
//  * the search query in `<b>bold</b>`.
//  *
//  * @remarks This Expression can only be used within a `search` stage.
//  *
//  * @param searchField Search the specified field for matching terms.
//  * @param options Define the search query using the search domain-specific language (DSL).
//  */
// export function snippet(
//   searchField: string | Field,
//   options: SnippetOptions
// ): Expression;
// export function snippet(
//   field: string | Field,
//   queryOrOptions: string | SnippetOptions
// ): Expression {
//   return toField(field).snippet(
//     isString(queryOrOptions) ? { rquery: queryOrOptions } : queryOrOptions
//   );
// }
/**
 * @beta
 * Evaluates to the distance in meters between the location in the specified
 * field and the query location.
 *
 * @remarks This Expression can only be used within a `search` stage.
 *
 * @example
 * ```typescript
 * db.pipeline().collection('restaurants').search({
 *   query: 'waffles',
 *   sort: geoDistance('location', new GeoPoint(37.0, -122.0)).ascending()
 * })
 * ```
 *
 * @param fieldName - Specifies the field in the document which contains
 * the first GeoPoint for distance computation.
 * @param location - Compute distance to this GeoPoint.
 */ function geoDistance(e, t) {
    return __PRIVATE_toField(e).geoDistance(t);
}
function ascending(e) {
    return new Ordering(__PRIVATE_fieldOrExpression(e), "ascending", "ascending");
}
function descending(e) {
    return new Ordering(__PRIVATE_fieldOrExpression(e), "descending", "descending");
}
/**
 *
 * Represents an ordering criterion for sorting documents in a Firestore pipeline.
 *
 * You create `Ordering` instances using the `ascending` and `descending` helper functions.
 */ class Ordering {
    constructor(e, t, n){
        this.expr = e, this.direction = t, this._methodName = n, this._protoValueType = "ProtoValue";
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            mapValue: {
                fields: {
                    direction: __PRIVATE_toStringValue(this.direction),
                    expression: this.expr._toProto(e)
                }
            }
        };
    }
    /**
     * @private
     * @internal
     */ _readUserData(e) {
        this.expr._readUserData(e);
    }
}
function __PRIVATE_isSelectable(e) {
    const t = e;
    return t.selectable && __PRIVATE_isString$1(t.alias) && __PRIVATE_isExpr(t.expr);
}
function __PRIVATE_isOrdering(e) {
    const t = e;
    return null != t && __PRIVATE_isExpr(t.expr) && ("ascending" === t.direction || "descending" === t.direction);
}
function __PRIVATE_isAliasedAggregate(e) {
    const t = e;
    return __PRIVATE_isString$1(t.alias) && t.aggregate instanceof AggregateFunction;
}
function __PRIVATE_isExpr(e) {
    return e instanceof Expression;
}
function __PRIVATE_isBooleanExpr(e) {
    return e instanceof BooleanExpression;
}
function __PRIVATE_isAliasedExpr(e) {
    return e instanceof AliasedExpression;
}
function __PRIVATE_isField(e) {
    return e instanceof Field;
}
function __PRIVATE_toField(e) {
    if (__PRIVATE_isString$1(e)) return field(e);
    return e;
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class Stage {
    constructor(e){
        /**
         * Store _optionsProto parsed by _readUserData.
         * @private
         * @internal
         * @protected
         */ this.optionsProto = void 0, { rawOptions: this.rawOptions, ...this.knownOptions } = e;
    }
    _readUserData(e) {
        this.optionsProto = this._optionsUtil.getOptionsProto(e, this.knownOptions, this.rawOptions);
    }
    _toProto(e) {
        return {
            name: this._name,
            options: this.optionsProto
        };
    }
}
class __PRIVATE_AddFields extends Stage {
    get _name() {
        return "add_fields";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.fields = e;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                toMapValue(e, this.fields)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), __PRIVATE_readUserDataHelper(this.fields, e);
    }
}
class __PRIVATE_RemoveFields extends Stage {
    get _name() {
        return "remove_fields";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.fields = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: this.fields.map((t)=>t._toProto(e))
        };
    }
    _readUserData(e) {
        super._readUserData(e), __PRIVATE_readUserDataHelper(this.fields, e);
    }
}
/**
 * @public
 */ class __PRIVATE_Define extends Stage {
    get _name() {
        return "let";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.Ar = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                toMapValue(e, this.Ar)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), __PRIVATE_readUserDataHelper(this.Ar, e);
    }
}
class __PRIVATE_Aggregate extends Stage {
    get _name() {
        return "aggregate";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t, n){
        super(n), this.groups = e, this.accumulators = t;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                toMapValue(e, this.accumulators),
                toMapValue(e, this.groups)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), __PRIVATE_readUserDataHelper(this.groups, e), __PRIVATE_readUserDataHelper(this.accumulators, e);
    }
}
class __PRIVATE_Distinct extends Stage {
    get _name() {
        return "distinct";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.groups = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                toMapValue(e, this.groups)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), __PRIVATE_readUserDataHelper(this.groups, e);
    }
}
class __PRIVATE_CollectionSource extends Stage {
    get _name() {
        return "collection";
    }
    get _optionsUtil() {
        return new OptionsUtil({
            forceIndex: {
                serverName: "force_index"
            }
        });
    }
    constructor(e, t){
        super(t), // prepend slash to collection string
        this.Vr = e.startsWith("/") ? e : "/" + e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                {
                    referenceValue: this.Vr
                }
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class __PRIVATE_CollectionGroupSource extends Stage {
    get _name() {
        return "collection_group";
    }
    get _optionsUtil() {
        return new OptionsUtil({
            forceIndex: {
                serverName: "force_index"
            }
        });
    }
    constructor(e, t){
        super(t), this.collectionId = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                {
                    referenceValue: ""
                },
                {
                    stringValue: this.collectionId
                }
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class __PRIVATE_SubcollectionSource extends Stage {
    get _name() {
        return "subcollection";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.path = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                {
                    stringValue: this.path
                }
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class __PRIVATE_DatabaseSource extends Stage {
    get _name() {
        return "database";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e)
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class __PRIVATE_DocumentsSource extends Stage {
    get _name() {
        return "documents";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        if (super(t), !e || 0 === e.length) throw new FirestoreError(D.INVALID_ARGUMENT, "Empty document paths are not allowed in DocumentsSource");
        const n = e.map((e)=>e.startsWith("/") ? e : "/" + e), r = new Set(n);
        if (r.size !== n.length) throw new FirestoreError(D.INVALID_ARGUMENT, "Duplicate document paths are not allowed in DocumentsSource");
        this.dr = n, this.mr = r;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: this.dr.map((e)=>({
                    referenceValue: e
                }))
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class __PRIVATE_Where extends Stage {
    get _name() {
        return "where";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.condition = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                this.condition._toProto(e)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), __PRIVATE_readUserDataHelper(this.condition, e);
    }
}
class __PRIVATE_FindNearest extends Stage {
    get _name() {
        return "find_nearest";
    }
    get _optionsUtil() {
        return new OptionsUtil({
            limit: {
                serverName: "limit"
            },
            distanceField: {
                serverName: "distance_field"
            }
        });
    }
    constructor(e, t, n, r){
        super(r), this.vectorValue = e, this.field = t, this.distanceMeasure = n;
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                this.field._toProto(e),
                this.vectorValue._toProto(e),
                __PRIVATE_toStringValue(this.distanceMeasure)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), __PRIVATE_readUserDataHelper(this.vectorValue, e), __PRIVATE_readUserDataHelper(this.field, e);
    }
}
class __PRIVATE_Limit extends Stage {
    get _name() {
        return "limit";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        __PRIVATE_hardAssert(!isNaN(e) && e !== 1 / 0 && e !== -1 / 0, 34860), super(t), this.limit = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                toNumber(e, this.limit)
            ]
        };
    }
}
class __PRIVATE_Offset extends Stage {
    get _name() {
        return "offset";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.offset = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                toNumber(e, this.offset)
            ]
        };
    }
}
class __PRIVATE_Select extends Stage {
    get _name() {
        return "select";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.selections = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                toMapValue(e, this.selections)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), __PRIVATE_readUserDataHelper(this.selections, e);
    }
}
class __PRIVATE_Sort extends Stage {
    get _name() {
        return "sort";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.orderings = e;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: this.orderings.map((t)=>t._toProto(e))
        };
    }
    _readUserData(e) {
        super._readUserData(e), __PRIVATE_readUserDataHelper(this.orderings, e);
    }
}
class __PRIVATE_Sample extends Stage {
    get _name() {
        return "sample";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t, n){
        super(n), this.rate = e, this.mode = t;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                toNumber(e, this.rate),
                __PRIVATE_toStringValue(this.mode)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e);
    }
}
class __PRIVATE_Union extends Stage {
    get _name() {
        return "union";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.other = e;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                __PRIVATE_toPipelineValue(this.other._toProto(e))
            ]
        };
    }
    _readUserData(e) {
        this.other._readUserData(e), super._readUserData(e);
    }
}
class __PRIVATE_Unnest extends Stage {
    get _name() {
        return "unnest";
    }
    get _optionsUtil() {
        return new OptionsUtil({
            indexField: {
                serverName: "index_field"
            }
        });
    }
    constructor(e, t, n){
        super(n), this.alias = e, this.expr = t;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                this.expr._toProto(e),
                field(this.alias)._toProto(e)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), __PRIVATE_readUserDataHelper(this.expr, e);
    }
}
class __PRIVATE_Replace extends Stage {
    get _name() {
        return "replace_with";
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
    constructor(e, t){
        super(t), this.map = e;
    }
    _toProto(e) {
        return {
            ...super._toProto(e),
            args: [
                this.map._toProto(e),
                __PRIVATE_toStringValue(__PRIVATE_Replace.pr)
            ]
        };
    }
    _readUserData(e) {
        super._readUserData(e), __PRIVATE_readUserDataHelper(this.map, e);
    }
}
__PRIVATE_Replace.pr = "full_replace";
/**
 * @beta
 */ class __PRIVATE_Search extends Stage {
    constructor(e){
        super(e), this.gr = e;
    }
    get _name() {
        return "search";
    }
    get _optionsUtil() {
        return new OptionsUtil({
            query: {
                serverName: "query"
            },
            limit: {
                serverName: "limit"
            },
            retrievalDepth: {
                serverName: "retrieval_depth"
            },
            sort: {
                serverName: "sort"
            },
            addFields: {
                serverName: "add_fields"
            },
            select: {
                serverName: "select"
            },
            offset: {
                serverName: "offset"
            },
            yr: {
                serverName: "query_enhancement"
            },
            languageCode: {
                serverName: "language_code"
            }
        });
    }
    /**
     * @private
     * @internal
     */ _toProto(e) {
        return {
            ...super._toProto(e),
            args: []
        };
    }
    _readUserData(e) {
        __PRIVATE_readUserDataHelper(this.gr.query, e), this.gr.addFields && __PRIVATE_readUserDataHelper(this.gr.addFields, e), this.gr.select && __PRIVATE_readUserDataHelper(this.gr.select, e), this.gr.sort && __PRIVATE_readUserDataHelper(this.gr.sort, e), super._readUserData(e);
    }
}
/**
 * @beta
 */ class __PRIVATE_RawStage extends Stage {
    /**
     * @private
     * @internal
     */ constructor(e, t, n){
        super({
            rawOptions: n
        }), this.name = e, this.params = t;
    }
    /**
     * @internal
     * @private
     */ _toProto(e) {
        return {
            name: this.name,
            args: this.params.map((t)=>t._toProto(e)),
            options: this.optionsProto
        };
    }
    _readUserData(e) {
        super._readUserData(e), __PRIVATE_readUserDataHelper(this.params, e);
    }
    get _name() {
        return this.name;
    }
    get _optionsUtil() {
        return new OptionsUtil({});
    }
}
/**
 * Helper to read user data across a number of different formats.
 * @param name - Name of the calling function. Used for error messages when invalid user data is encountered.
 * @param expressionMap
 * @returns the expressionMap argument.
 * @private
 */ function __PRIVATE_readUserDataHelper(e, t) {
    return __PRIVATE_isUserData(e) ? e._readUserData(t) : Array.isArray(e) ? e.forEach((e)=>e._readUserData(t)) : e instanceof Map ? e.forEach((e)=>e._readUserData(t)) : Object.values(e).forEach((e)=>e._readUserData(t)), e;
}
// Copyright 2024 Google LLC* @license
class CorePipeline {
    constructor(e, t, n){
        this.serializer = e, this.stages = t, this.listenOptions = n, this.isCorePipeline = !0;
    }
    getPipelineCollection() {
        return getPipelineCollection(this);
    }
    getPipelineCollectionGroup() {
        return getPipelineCollectionGroup(this);
    }
    getPipelineCollectionId() {
        return getPipelineCollectionId(this);
    }
    getPipelineDocuments() {
        return getPipelineDocuments(this);
    }
    getPipelineFlavor() {
        return function getPipelineFlavor(e) {
            let t = "exact";
            return e.stages.forEach((n, r)=>{
                n._name !== __PRIVATE_Distinct.name && n._name !== __PRIVATE_Aggregate.name || (t = "keyless"), n._name === __PRIVATE_Select.name && "exact" === t && (t = "augmented"), // TODO(pipeline): verify the last stage is addFields, and it is added by the SDK.
                n._name === __PRIVATE_AddFields.name && r < e.stages.length - 1 && "exact" === t && (t = "augmented");
            }), t;
        }(this);
    }
    getPipelineSourceType() {
        return getPipelineSourceType(this);
    }
}
function getPipelineSourceType(e) {
    const t = e.stages[0];
    return t instanceof __PRIVATE_CollectionSource || t instanceof __PRIVATE_CollectionGroupSource || t instanceof __PRIVATE_DatabaseSource || t instanceof __PRIVATE_DocumentsSource ? t._name : "unknown";
}
function getPipelineCollection(e) {
    if ("collection" === getPipelineSourceType(e)) return e.stages[0].Vr;
}
function getPipelineCollectionGroup(e) {
    if ("collection_group" === getPipelineSourceType(e)) return e.stages[0].collectionId;
}
function getPipelineCollectionId(e) {
    switch(getPipelineSourceType(e)){
        case "collection":
            return ResourcePath.fromString(getPipelineCollection(e)).lastSegment();
        case "collection_group":
            return getPipelineCollectionGroup(e);
        default:
            return;
    }
}
function getPipelineDocuments(e) {
    if ("documents" === getPipelineSourceType(e)) return e.stages[0].dr;
}
class __PRIVATE_RealtimePipeline {
    /**
     * @internal
     * @private
     * @param _db
     * @param userDataReader
     * @param _userDataWriter
     * @param _documentReferenceFactory
     * @param stages
     */ constructor(/**
     * @internal
     * @private
     */ e, /**
     * @internal
     * @private
     */ t, /**
     * @internal
     * @private
     */ n, r){
        this._db = e, this.userDataReader = t, this._userDataWriter = n, this.stages = r;
    }
    /**
     * Reads user data for each expression in the expressionMap.
     * @param name Name of the calling function. Used for error messages when invalid user data is encountered.
     * @param expressionMap
     * @return the expressionMap argument.
     * @private
     * @internal
     */ wr(e, t) {
        const n = this.userDataReader.createContext(3 /* UserDataSource.Argument */ , e);
        return __PRIVATE_isUserData(t) ? t._readUserData(n) : Array.isArray(t) ? t.forEach((e)=>e._readUserData(n)) : t.forEach((e)=>e._readUserData(n)), t;
    }
    where(e) {
        const t = this.stages.map((e)=>e);
        return this.wr("where", e), t.push(new __PRIVATE_Where(e, {})), new __PRIVATE_RealtimePipeline(this._db, this.userDataReader, this._userDataWriter, t);
    }
    limit(e) {
        const t = this.stages.map((e)=>e);
        return t.push(new __PRIVATE_Limit(e, {})), new __PRIVATE_RealtimePipeline(this._db, this.userDataReader, this._userDataWriter, t);
    }
    sort(e, ...t) {
        const n = this.stages.map((e)=>e);
        // Option object
        return "orderings" in e ? n.push(new __PRIVATE_Sort(this.wr("sort", e.orderings), {})) : // Ordering object
        n.push(new __PRIVATE_Sort(this.wr("sort", [
            e,
            ...t
        ]), {})), new __PRIVATE_RealtimePipeline(this._db, this.userDataReader, this._userDataWriter, n);
    }
    /**
     * @internal
     * @private
     */ br(e) {
        return {
            pipeline: {
                stages: this.stages.map((t)=>t._toProto(e))
            }
        };
    }
}
// Copyright 2024 Google LLC* @license
class __PRIVATE_EvaluateResult {
    constructor(e, t){
        this.type = e, this.value = t;
    }
    static vr() {
        return new __PRIVATE_EvaluateResult("ERROR", void 0);
    }
    static Sr() {
        return new __PRIVATE_EvaluateResult("UNSET", void 0);
    }
    static Dr() {
        return new __PRIVATE_EvaluateResult("NULL", lt);
    }
    static newValue(e) {
        return __PRIVATE_isNullValue(e) ? new __PRIVATE_EvaluateResult("NULL", lt) : function __PRIVATE_isBoolean(e) {
            return !!e && "booleanValue" in e;
        }(e) ? new __PRIVATE_EvaluateResult("BOOLEAN", e) : isInteger(e) ? new __PRIVATE_EvaluateResult("INT", e) : __PRIVATE_isDouble(e) ? new __PRIVATE_EvaluateResult("DOUBLE", e) : function __PRIVATE_isTimestampValue(e) {
            return !!e && "timestampValue" in e && !!e.timestampValue;
        }(e) ? new __PRIVATE_EvaluateResult("TIMESTAMP", e) : function __PRIVATE_isString(e) {
            return !!e && "stringValue" in e;
        }(e) ? new __PRIVATE_EvaluateResult("STRING", e) : function __PRIVATE_isBytes(e) {
            return !!e && "bytesValue" in e;
        }(e) ? new __PRIVATE_EvaluateResult("BYTES", e) : e.referenceValue ? new __PRIVATE_EvaluateResult("REFERENCE", e) : e.geoPointValue ? new __PRIVATE_EvaluateResult("GEO_POINT", e) : isArray(e) ? new __PRIVATE_EvaluateResult("ARRAY", e) : __PRIVATE_isVectorValue(e) ? new __PRIVATE_EvaluateResult("VECTOR", e) : __PRIVATE_isMapValue(e) ? new __PRIVATE_EvaluateResult("MAP", e) : new __PRIVATE_EvaluateResult("ERROR", void 0);
    }
    Cr() {
        return "ERROR" === this.type || "UNSET" === this.type;
    }
    Fr() {
        return "NULL" === this.type;
    }
}
function __PRIVATE_valueOrUndefined(e) {
    if (!e.Cr()) return e.value;
}
function __PRIVATE_unwrapExpression(e) {
    return e instanceof BooleanExpression ? e._expr : e;
}
function __PRIVATE_toEvaluable(e) {
    if ((e = __PRIVATE_unwrapExpression(e)) instanceof Field) return new __PRIVATE_CoreField(e);
    if (e instanceof Constant) return new __PRIVATE_CoreConstant(e);
    if (e instanceof __PRIVATE_ListOfExprs) return new __PRIVATE_CoreListOfExprs(e);
    if (e instanceof FunctionExpression) {
        // TODO(pipeline): We should define all supported function names as constants somewhere instead of magic strings.
        if ("add" === e.name) return new __PRIVATE_CoreAdd(e);
        if ("subtract" === e.name) return new __PRIVATE_CoreSubtract(e);
        if ("multiply" === e.name) return new __PRIVATE_CoreMultiply(e);
        if ("divide" === e.name) return new __PRIVATE_CoreDivide(e);
        if ("mod" === e.name) return new __PRIVATE_CoreMod(e);
        if ("and" === e.name) return new __PRIVATE_CoreAnd(e);
        if ("equal" === e.name) return new __PRIVATE_CoreEq(e);
        if ("not_equal" === e.name) return new __PRIVATE_CoreNeq(e);
        if ("less_than" === e.name) return new __PRIVATE_CoreLt(e);
        if ("less_than_or_equal" === e.name) return new __PRIVATE_CoreLte(e);
        if ("greater_than" === e.name) return new __PRIVATE_CoreGt(e);
        if ("greater_than_or_equal" === e.name) return new __PRIVATE_CoreGte(e);
        if ("array_concat" === e.name) return new __PRIVATE_CoreArrayConcat(e);
        if ("array_reverse" === e.name) return new __PRIVATE_CoreArrayReverse(e);
        if ("array_contains" === e.name) return new __PRIVATE_CoreArrayContains(e);
        if ("array_contains_all" === e.name) return new __PRIVATE_CoreArrayContainsAll(e);
        if ("array_contains_any" === e.name) return new __PRIVATE_CoreArrayContainsAny(e);
        if ("array_length" === e.name) return new __PRIVATE_CoreArrayLength(e);
        if ("array_element" === e.name) return new __PRIVATE_CoreArrayElement(e);
        if ("equal_any" === e.name) return new __PRIVATE_CoreEqAny(e);
        if ("not_equal_any" === e.name) return new __PRIVATE_CoreNotEqAny(e);
        if ("is_nan" === e.name) return new __PRIVATE_CoreIsNan(e);
        if ("is_not_nan" === e.name) return new __PRIVATE_CoreIsNotNan(e);
        if ("is_null" === e.name) return new __PRIVATE_CoreIsNull(e);
        if ("is_not_null" === e.name) return new __PRIVATE_CoreIsNotNull(e);
        if ("is_error" === e.name) return new __PRIVATE_CoreIsError(e);
        if ("exists" === e.name) return new __PRIVATE_CoreExists(e);
        if ("not" === e.name) return new __PRIVATE_CoreNot(e);
        if ("or" === e.name) return new __PRIVATE_CoreOr(e);
        if ("xor" === e.name) return new __PRIVATE_CoreXor(e);
        if ("conditional" === e.name) return new __PRIVATE_CoreCond(e);
        if ("maximum" === e.name) return new __PRIVATE_CoreLogicalMaximum(e);
        if ("minimum" === e.name) return new __PRIVATE_CoreLogicalMinimum(e);
        if ("reverse" === e.name) return new __PRIVATE_CoreReverse(e);
        if ("replace_first" === e.name) return new __PRIVATE_CoreReplaceFirst(e);
        if ("replace_all" === e.name) return new __PRIVATE_CoreReplaceAll(e);
        if ("char_length" === e.name) return new __PRIVATE_CoreCharLength(e);
        if ("byte_length" === e.name) return new __PRIVATE_CoreByteLength(e);
        if ("like" === e.name) return new __PRIVATE_CoreLike(e);
        if ("regex_contains" === e.name) return new __PRIVATE_CoreRegexContains(e);
        if ("regex_match" === e.name) return new __PRIVATE_CoreRegexMatch(e);
        if ("string_contains" === e.name) return new __PRIVATE_CoreStrContains(e);
        if ("starts_with" === e.name) return new __PRIVATE_CoreStartsWith(e);
        if ("ends_with" === e.name) return new __PRIVATE_CoreEndsWith(e);
        if ("to_lower" === e.name) return new __PRIVATE_CoreToLower(e);
        if ("to_upper" === e.name) return new __PRIVATE_CoreToUpper(e);
        if ("trim" === e.name) return new __PRIVATE_CoreTrim(e);
        if ("string_concat" === e.name) return new __PRIVATE_CoreStrConcat(e);
        if ("map_get" === e.name) return new __PRIVATE_CoreMapGet(e);
        if ("cosine_distance" === e.name) return new __PRIVATE_CoreCosineDistance(e);
        if ("dot_product" === e.name) return new __PRIVATE_CoreDotProduct(e);
        if ("euclidean_distance" === e.name) return new __PRIVATE_CoreEuclideanDistance(e);
        if ("vector_length" === e.name) return new __PRIVATE_CoreVectorLength(e);
        if ("unix_micros_to_timestamp" === e.name) return new __PRIVATE_CoreUnixMicrosToTimestamp(e);
        if ("timestamp_to_unix_micros" === e.name) return new __PRIVATE_CoreTimestampToUnixMicros(e);
        if ("unix_millis_to_timestamp" === e.name) return new __PRIVATE_CoreUnixMillisToTimestamp(e);
        if ("timestamp_to_unix_millis" === e.name) return new __PRIVATE_CoreTimestampToUnixMillis(e);
        if ("unix_seconds_to_timestamp" === e.name) return new __PRIVATE_CoreUnixSecondsToTimestamp(e);
        if ("timestamp_to_unix_seconds" === e.name) return new __PRIVATE_CoreTimestampToUnixSeconds(e);
        if ("timestamp_add" === e.name) return new __PRIVATE_CoreTimestampAdd(e);
        if ("timestamp_subtract" === e.name) return new __PRIVATE_CoreTimestampSub(e);
    }
    throw new Error(`Unknown Expr : ${e}`);
}
class __PRIVATE_CoreField {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        if (this.expr.fieldName === F) return __PRIVATE_EvaluateResult.newValue({
            referenceValue: __PRIVATE_toName(e.serializer, t.key)
        });
        if ("__update_time__" === this.expr.fieldName) return __PRIVATE_EvaluateResult.newValue({
            timestampValue: __PRIVATE_toVersion(e.serializer, t.version)
        });
        if ("__create_time__" === this.expr.fieldName) return __PRIVATE_EvaluateResult.newValue({
            timestampValue: __PRIVATE_toVersion(e.serializer, t.createTime)
        });
        // Return 'UNSET' if the field doesn't exist, otherwise the Value.
        const n = t.data.field(this.expr._fieldPath);
        return n ? __PRIVATE_isServerTimestamp(n) ? __PRIVATE_EvaluateResult.newValue(function __PRIVATE_getServerTimestampValue(e, t) {
            if ("estimate" === e.serverTimestampBehavior) return {
                timestampValue: __PRIVATE_toVersion(e.serializer, SnapshotVersion.fromTimestamp(__PRIVATE_getLocalWriteTime(t)))
            };
            if ("previous" === e.serverTimestampBehavior) {
                const e = __PRIVATE_getPreviousValue(t);
                if (e) return e;
            }
            return {
                nullValue: "NULL_VALUE"
            };
        }(e, n)) : __PRIVATE_EvaluateResult.newValue(n) : __PRIVATE_EvaluateResult.Sr();
    }
}
class __PRIVATE_CoreConstant {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        return __PRIVATE_EvaluateResult.newValue(this.expr._getValue());
    }
}
class __PRIVATE_CoreListOfExprs {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        const n = this.expr.Rr.map((n)=>__PRIVATE_toEvaluable(n).evaluate(e, t));
        // If any sub-expression resulted in error or was unset, the list evaluation fails.
        return n.some((e)=>e.Cr()) ? __PRIVATE_EvaluateResult.vr() : __PRIVATE_EvaluateResult.newValue({
            arrayValue: {
                values: n.map((e)=>e.value)
            }
        });
    }
}
function __PRIVATE_asDouble(e) {
    return __PRIVATE_isDouble(e) ? Number(e.doubleValue) : Number(e.integerValue);
}
function __PRIVATE_asBigInt(e) {
    return BigInt(e.integerValue);
}
const Wt = BigInt("0x7fffffffffffffff"), Qt = -BigInt("0x8000000000000000");
class __PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(this.expr.params.length >= 2, 24778);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t), r = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        let i = this.Or(n, r);
        for (const n of this.expr.params.slice(2)){
            const r = __PRIVATE_toEvaluable(n).evaluate(e, t);
            i = this.Or(i, r);
        }
        return i;
    }
    Or(e, t) {
        // If any operand is error or unset, the result is error.
        if (e.Cr() || t.Cr()) return __PRIVATE_EvaluateResult.vr();
        if (e.Fr() || t.Fr()) return __PRIVATE_EvaluateResult.Dr();
        // Type check: Both must be numbers (integer or double).
        // We know left and right are Value here due to the check above.
        const n = e.value, r = t.value;
        if (!__PRIVATE_isDouble(n) && !isInteger(n) || !__PRIVATE_isDouble(r) && !isInteger(r)) return __PRIVATE_EvaluateResult.vr(); // Type error
        // Perform arithmetic based on types.
        if (__PRIVATE_isDouble(n) || __PRIVATE_isDouble(r)) {
            const e = this.Mr(n, r);
            return e ? __PRIVATE_EvaluateResult.newValue(e) : __PRIVATE_EvaluateResult.vr();
        }
        if (isInteger(n) && isInteger(r)) {
            // Pass the narrowed Value types
            const e = this.Nr(n, r);
            return void 0 === e ? __PRIVATE_EvaluateResult.vr() : "number" == typeof e ? __PRIVATE_EvaluateResult.newValue({
                doubleValue: e
            }) : e < Qt || e > Wt ? __PRIVATE_EvaluateResult.vr() : __PRIVATE_EvaluateResult.newValue({
                integerValue: `${e}`
            });
        }
        // Should not be reached due to initial type checks
        return __PRIVATE_EvaluateResult.vr();
    }
}
function __PRIVATE_strictValueEquals(e, t) {
    return __PRIVATE_typeOrder(e) !== __PRIVATE_typeOrder(t) ? "TYPE_MISMATCH" : __PRIVATE_isNanValue(e) || __PRIVATE_isNanValue(t) ? "NOT_EQ" : __PRIVATE_isNullValue(e) && __PRIVATE_isNullValue(t) ? "EQ" : __PRIVATE_isNullValue(e) || __PRIVATE_isNullValue(t) ? "NULL" : isArray(e) && isArray(t) ? function __PRIVATE_strictArrayValueEquals(e, t) {
        if (e.values?.length !== t.values?.length) return "NOT_EQ";
        let n = !1;
        for(let r = 0; r < (e.values?.length ?? 0); r++){
            const i = e.values[r], s = t.values[r];
            switch(__PRIVATE_strictValueEquals(i, s)){
                case "EQ":
                    break;
                case "NOT_EQ":
                case "TYPE_MISMATCH":
                    return "NOT_EQ";
                case "NULL":
                    n = !0;
                    break;
                default:
                    fail(44609, {
                        Lr: i,
                        Br: s
                    });
            }
        }
        if (n) return "NULL";
        return "EQ";
    }(e.arrayValue, t.arrayValue) : __PRIVATE_isVectorValue(e) && __PRIVATE_isVectorValue(t) || __PRIVATE_isMapValue(e) && __PRIVATE_isMapValue(t) ? function __PRIVATE_strictObjectValueEquals(e, t) {
        const n = e.fields || {}, r = t.fields || {};
        if (__PRIVATE_objectSize(n) !== __PRIVATE_objectSize(r)) return "NOT_EQ";
        let i = !1;
        for(const e in n)if (n.hasOwnProperty(e)) {
            if (void 0 === r[e]) return "NOT_EQ";
            switch(__PRIVATE_strictValueEquals(n[e], r[e])){
                case "NOT_EQ":
                case "TYPE_MISMATCH":
                    return "NOT_EQ";
                case "NULL":
                    i = !0;
            }
        }
        if (i) return "NULL";
        return "EQ";
    }(e.mapValue, t.mapValue) : function __PRIVATE_valueEquals(e, t) {
        return __PRIVATE_valueEquals$1(e, t, {
            Te: !1,
            Ee: !0,
            he: !0
        });
    }(e, t) ? "EQ" : "NOT_EQ";
}
class __PRIVATE_CoreAdd extends __PRIVATE_BigIntOrDoubleArithmetics {
    Nr(e, t) {
        return __PRIVATE_asBigInt(e) + __PRIVATE_asBigInt(t);
    }
    Mr(e, t) {
        return {
            doubleValue: __PRIVATE_asDouble(e) + __PRIVATE_asDouble(t)
        };
    }
}
class __PRIVATE_CoreSubtract extends __PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        super(e), this.expr = e;
    }
    Nr(e, t) {
        return __PRIVATE_asBigInt(e) - __PRIVATE_asBigInt(t);
    }
    Mr(e, t) {
        return {
            doubleValue: __PRIVATE_asDouble(e) - __PRIVATE_asDouble(t)
        };
    }
}
class __PRIVATE_CoreMultiply extends __PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        super(e), this.expr = e;
    }
    Nr(e, t) {
        return __PRIVATE_asBigInt(e) * __PRIVATE_asBigInt(t);
    }
    Mr(e, t) {
        return {
            doubleValue: __PRIVATE_asDouble(e) * __PRIVATE_asDouble(t)
        };
    }
}
class __PRIVATE_CoreDivide extends __PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        super(e), this.expr = e;
    }
    Nr(e, t) {
        const n = __PRIVATE_asBigInt(t);
        if (n !== BigInt(0)) return __PRIVATE_asBigInt(e) / n;
    }
    Mr(e, t) {
        const n = __PRIVATE_asDouble(t);
        return 0 === n ? {
            doubleValue: __PRIVATE_isNegativeZero(n) ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY
        } : {
            doubleValue: __PRIVATE_asDouble(e) / n
        };
    }
}
class __PRIVATE_CoreMod extends __PRIVATE_BigIntOrDoubleArithmetics {
    constructor(e){
        super(e), this.expr = e;
    }
    Nr(e, t) {
        const n = __PRIVATE_asBigInt(t);
        if (n !== BigInt(0)) return __PRIVATE_asBigInt(e) % n;
    }
    Mr(e, t) {
        const n = __PRIVATE_asDouble(t);
        if (0 !== n) return {
            doubleValue: __PRIVATE_asDouble(e) % n
        };
    }
}
class __PRIVATE_CoreAnd {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        let n = !1, r = !1;
        for (const i of this.expr.params){
            const s = __PRIVATE_toEvaluable(i).evaluate(e, t);
            switch(s.type){
                case "BOOLEAN":
                    if (!s.value?.booleanValue) return __PRIVATE_EvaluateResult.newValue(ht);
                    break;
                case "NULL":
                    r = !0;
                    break;
                default:
                    n = !0;
            }
        }
        return n ? __PRIVATE_EvaluateResult.vr() : r ? __PRIVATE_EvaluateResult.Dr() : __PRIVATE_EvaluateResult.newValue(Et);
    }
}
class __PRIVATE_CoreNot {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 9634);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "BOOLEAN":
                return __PRIVATE_EvaluateResult.newValue({
                    booleanValue: !n.value?.booleanValue
                });
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreOr {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        let n = !1, r = !1;
        for (const i of this.expr.params){
            const s = __PRIVATE_toEvaluable(i).evaluate(e, t);
            switch(s.type){
                case "BOOLEAN":
                    if (s.value?.booleanValue) return __PRIVATE_EvaluateResult.newValue(Et);
                    break;
                case "NULL":
                    r = !0;
                    break;
                default:
                    n = !0;
            }
        }
        return n ? __PRIVATE_EvaluateResult.vr() : r ? __PRIVATE_EvaluateResult.Dr() : __PRIVATE_EvaluateResult.newValue(ht);
    }
}
class __PRIVATE_CoreXor {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        let n = !1, r = !1;
        for (const i of this.expr.params){
            const s = __PRIVATE_toEvaluable(i).evaluate(e, t);
            switch(s.type){
                case "BOOLEAN":
                    n = __PRIVATE_CoreXor.xor(n, !!s.value?.booleanValue);
                    break;
                case "NULL":
                    r = !0;
                    break;
                default:
                    return __PRIVATE_EvaluateResult.vr();
            }
        }
        return r ? __PRIVATE_EvaluateResult.Dr() : __PRIVATE_EvaluateResult.newValue({
            booleanValue: n
        });
    }
    // XOR(a, b) is equivalent to (a OR b) AND NOT(a AND b)
    // It is required to evaluate all arguments to ensure that the correct error semantics are
    // applied.
    static xor(e, t) {
        return (e || t) && !(e && t);
    }
}
class __PRIVATE_CoreEqAny {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(2 === this.expr.params.length, 55094);
        let n = !1;
        const r = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "NULL":
                n = !0;
                break;
            case "ERROR":
            case "UNSET":
                return __PRIVATE_EvaluateResult.vr();
        }
        const i = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "ARRAY":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        if (n) return __PRIVATE_EvaluateResult.Dr();
        for (const e of i.value?.arrayValue?.values ?? [])switch(__PRIVATE_isNullValue(r.value) && __PRIVATE_isNullValue(e) ? "EQ" : __PRIVATE_strictValueEquals(r.value, e)){
            case "EQ":
                return __PRIVATE_EvaluateResult.newValue(Et);
            case "NOT_EQ":
            case "TYPE_MISMATCH":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                fail(44608, {
                    value: r.value,
                    candidate: e
                });
        }
        return n ? __PRIVATE_EvaluateResult.Dr() : __PRIVATE_EvaluateResult.newValue(ht);
    }
}
class __PRIVATE_CoreNotEqAny {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        return new __PRIVATE_CoreNot(new FunctionExpression("not", [
            new FunctionExpression("equal_any", this.expr.params)
        ])).evaluate(e, t);
    }
}
class __PRIVATE_CoreIsNan {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 23322);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "INT":
                return __PRIVATE_EvaluateResult.newValue(ht);
            case "DOUBLE":
                return __PRIVATE_EvaluateResult.newValue({
                    booleanValue: isNaN(__PRIVATE_asDouble(n.value))
                });
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreIsNotNan {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 50406);
        return new __PRIVATE_CoreNot(new FunctionExpression("not", [
            new FunctionExpression("is_nan", this.expr.params)
        ])).evaluate(e, t);
    }
}
class __PRIVATE_CoreIsNull {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 23123);
        switch(__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t).type){
            case "NULL":
                return __PRIVATE_EvaluateResult.newValue(Et);
            case "UNSET":
            case "ERROR":
                return __PRIVATE_EvaluateResult.vr();
            default:
                return __PRIVATE_EvaluateResult.newValue(ht);
        }
    }
}
class __PRIVATE_CoreIsNotNull {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 23167);
        return new __PRIVATE_CoreNot(new FunctionExpression("not", [
            new FunctionExpression("is_null", this.expr.params)
        ])).evaluate(e, t);
    }
}
class __PRIVATE_CoreIsError {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 5228);
        return "ERROR" === __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t).type ? __PRIVATE_EvaluateResult.newValue(Et) : __PRIVATE_EvaluateResult.newValue(ht);
    }
}
class __PRIVATE_CoreExists {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 6877);
        switch(__PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t).type){
            case "ERROR":
                return __PRIVATE_EvaluateResult.vr();
            case "UNSET":
                return __PRIVATE_EvaluateResult.newValue(ht);
            default:
                return __PRIVATE_EvaluateResult.newValue(Et);
        }
    }
}
class __PRIVATE_CoreCond {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(3 === this.expr.params.length, 11706);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "BOOLEAN":
                return n.value?.booleanValue ? __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t) : __PRIVATE_toEvaluable(this.expr.params[2]).evaluate(e, t);
            case "NULL":
                return __PRIVATE_toEvaluable(this.expr.params[2]).evaluate(e, t);
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreLogicalMaximum {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        const n = this.expr.params.map((n)=>__PRIVATE_toEvaluable(n).evaluate(e, t));
        let r;
        for (const e of n)switch(e.type){
            case "ERROR":
            case "UNSET":
            case "NULL":
                continue;
            default:
                r = void 0 === r || __PRIVATE_valueCompare(e.value, r.value) > 0 ? e : r;
        }
        return void 0 === r ? __PRIVATE_EvaluateResult.Dr() : r;
    }
}
class __PRIVATE_CoreLogicalMinimum {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        const n = this.expr.params.map((n)=>__PRIVATE_toEvaluable(n).evaluate(e, t));
        let r;
        for (const e of n)switch(e.type){
            case "ERROR":
            case "UNSET":
            case "NULL":
                continue;
            default:
                r = void 0 === r || __PRIVATE_valueCompare(e.value, r.value) < 0 ? e : r;
        }
        return void 0 === r ? __PRIVATE_EvaluateResult.Dr() : r;
    }
}
class __PRIVATE_ComparisonBase {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(2 === this.expr.params.length, 31033, `${this.expr.name}() function should have exactly 2 params`);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "ERROR":
            case "UNSET":
                return __PRIVATE_EvaluateResult.vr();
        }
        const r = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(r.type){
            case "ERROR":
            case "UNSET":
                return __PRIVATE_EvaluateResult.vr();
        }
        return this.Ur(n, r);
    }
}
class __PRIVATE_CoreEq extends __PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Ur(e, t) {
        if (e.Fr() && t.Fr()) return __PRIVATE_EvaluateResult.newValue(Et);
        if (e.Fr() || t.Fr()) return __PRIVATE_EvaluateResult.newValue(ht);
        if (__PRIVATE_isNanValue(e.value) || __PRIVATE_isNanValue(t.value)) return __PRIVATE_EvaluateResult.newValue(ht);
        if (__PRIVATE_typeOrder(e.value) !== __PRIVATE_typeOrder(t.value)) return __PRIVATE_EvaluateResult.newValue(ht);
        switch(__PRIVATE_strictValueEquals(e.value, t.value)){
            case "EQ":
                return __PRIVATE_EvaluateResult.newValue(Et);
            case "NOT_EQ":
                return __PRIVATE_EvaluateResult.newValue(ht);
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            default:
                fail(44615, {
                    left: e,
                    right: t
                });
        }
    }
}
class __PRIVATE_CoreNeq extends __PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Ur(e, t) {
        switch(__PRIVATE_strictValueEquals(e.value, t.value)){
            case "EQ":
                return __PRIVATE_EvaluateResult.newValue(ht);
            case "NOT_EQ":
            case "TYPE_MISMATCH":
                return __PRIVATE_EvaluateResult.newValue(Et);
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            default:
                fail(44614, {
                    left: e,
                    right: t
                });
        }
    }
}
class __PRIVATE_CoreLt extends __PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Ur(e, t) {
        return __PRIVATE_typeOrder(e.value) !== __PRIVATE_typeOrder(t.value) || __PRIVATE_isNanValue(e.value) || __PRIVATE_isNanValue(t.value) ? __PRIVATE_EvaluateResult.newValue(ht) : __PRIVATE_EvaluateResult.newValue({
            booleanValue: __PRIVATE_valueCompare(e.value, t.value) < 0
        });
    }
}
class __PRIVATE_CoreLte extends __PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Ur(e, t) {
        return __PRIVATE_typeOrder(e.value) !== __PRIVATE_typeOrder(t.value) || __PRIVATE_isNanValue(e.value) || __PRIVATE_isNanValue(t.value) ? __PRIVATE_EvaluateResult.newValue(ht) : "EQ" === __PRIVATE_strictValueEquals(e.value, t.value) ? __PRIVATE_EvaluateResult.newValue(Et) : __PRIVATE_EvaluateResult.newValue({
            booleanValue: __PRIVATE_valueCompare(e.value, t.value) < 0
        });
    }
}
class __PRIVATE_CoreGt extends __PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Ur(e, t) {
        return __PRIVATE_typeOrder(e.value) !== __PRIVATE_typeOrder(t.value) || __PRIVATE_isNanValue(e.value) || __PRIVATE_isNanValue(t.value) ? __PRIVATE_EvaluateResult.newValue(ht) : __PRIVATE_EvaluateResult.newValue({
            booleanValue: __PRIVATE_valueCompare(e.value, t.value) > 0
        });
    }
}
class __PRIVATE_CoreGte extends __PRIVATE_ComparisonBase {
    constructor(e){
        super(e), this.expr = e;
    }
    Ur(e, t) {
        return __PRIVATE_typeOrder(e.value) !== __PRIVATE_typeOrder(t.value) || __PRIVATE_isNanValue(e.value) || __PRIVATE_isNanValue(t.value) ? __PRIVATE_EvaluateResult.newValue(ht) : "EQ" === __PRIVATE_strictValueEquals(e.value, t.value) ? __PRIVATE_EvaluateResult.newValue(Et) : __PRIVATE_EvaluateResult.newValue({
            booleanValue: __PRIVATE_valueCompare(e.value, t.value) > 0
        });
    }
}
class __PRIVATE_CoreArrayConcat {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        throw new Error("Unimplemented");
    }
}
class __PRIVATE_CoreArrayReverse {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 216);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            case "ARRAY":
                {
                    const e = n.value.arrayValue?.values ?? [];
                    return __PRIVATE_EvaluateResult.newValue({
                        arrayValue: {
                            values: [
                                ...e
                            ].reverse()
                        }
                    });
                }
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreArrayContains {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        return __PRIVATE_hardAssert(2 === this.expr.params.length, 52884), new __PRIVATE_CoreEqAny(new FunctionExpression("eq_any", [
            this.expr.params[1],
            this.expr.params[0]
        ])).evaluate(e, t);
    }
}
class __PRIVATE_CoreArrayContainsAll {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(2 === this.expr.params.length, 1392);
        let n = !1;
        const r = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "ARRAY":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        const i = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "ARRAY":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        if (n) return __PRIVATE_EvaluateResult.Dr();
        const s = i.value?.arrayValue?.values ?? [], _ = r.value?.arrayValue?.values ?? [];
        for (const e of s){
            let t = !1;
            n = !1;
            for (const r of _){
                switch(__PRIVATE_isNullValue(e) && __PRIVATE_isNullValue(r) ? "EQ" : __PRIVATE_strictValueEquals(e, r)){
                    case "EQ":
                        t = !0;
                        break;
                    case "NOT_EQ":
                    case "TYPE_MISMATCH":
                        break;
                    case "NULL":
                        n = !0;
                        break;
                    default:
                        fail(44613, {
                            value: r,
                            search: e
                        });
                }
                if (t) break;
            }
            if (!t) // false case - we didn't find a match, short circuit
            return __PRIVATE_EvaluateResult.newValue(ht);
        }
        return __PRIVATE_EvaluateResult.newValue(Et);
    }
}
class __PRIVATE_CoreArrayContainsAny {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(2 === this.expr.params.length, 2680);
        let n = !1;
        const r = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "ARRAY":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        const i = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "ARRAY":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        if (n) return __PRIVATE_EvaluateResult.Dr();
        const s = i.value?.arrayValue?.values ?? [], _ = r.value?.arrayValue?.values ?? [];
        for (const e of _)for (const t of s)switch(__PRIVATE_isNullValue(e) && __PRIVATE_isNullValue(t) ? "EQ" : __PRIVATE_strictValueEquals(e, t)){
            case "EQ":
                return __PRIVATE_EvaluateResult.newValue(Et);
            case "NOT_EQ":
            case "TYPE_MISMATCH":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                fail(44608, {
                    value: e,
                    search: t
                });
        }
        return n ? __PRIVATE_EvaluateResult.Dr() : __PRIVATE_EvaluateResult.newValue(ht);
    }
}
class __PRIVATE_CoreArrayLength {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 38605);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            case "ARRAY":
                return __PRIVATE_EvaluateResult.newValue({
                    integerValue: `${n.value?.arrayValue?.values?.length ?? 0}`
                });
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreArrayElement {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        throw new Error("Unimplemented");
    }
}
class __PRIVATE_CoreReverse {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 1508);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            case "BYTES":
                {
                    const e = n.value?.bytesValue;
                    if ("string" == typeof e) {
                        const t = ByteString.fromBase64String(e).toUint8Array();
                        return t.reverse(), __PRIVATE_EvaluateResult.newValue({
                            bytesValue: ByteString.fromUint8Array(t).toBase64()
                        });
                    }
                    return __PRIVATE_EvaluateResult.newValue({
                        bytesValue: new Uint8Array(e).reverse()
                    });
                }
            case "STRING":
                {
                    const e = n.value?.stringValue, t = new Intl.__PRIVATE_Segmenter(void 0, {
                        granularity: "grapheme"
                    }).segment(e), r = Array.from(t, (e)=>e.segment).reverse();
                    return __PRIVATE_EvaluateResult.newValue({
                        stringValue: r.join("")
                    });
                }
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreReplaceFirst {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        throw new Error("Unimplemented");
    }
}
class __PRIVATE_CoreReplaceAll {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        throw new Error("Unimplemented");
    }
}
class __PRIVATE_CoreCharLength {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 19400);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            case "STRING":
                {
                    const e = function __PRIVATE_getUnicodePointCount(e) {
                        let t = 0;
                        for(let n = 0; n < e.length; n++){
                            const r = e.codePointAt(n);
                            if (void 0 === r) return; // Should not happen with valid JS strings
                            // BMP character (including lone surrogates, which count as 1)
                            if (r <= 65535) {
                                // Check specifically for lone surrogates which are invalid UTF-16 sequences
                                if (r >= 55296 && r <= 57343) {
                                    // High surrogate: check if followed by low surrogate
                                    if (r <= 56319) {
                                        const r = e.codePointAt(n + 1);
                                        void 0 !== r && r >= 56320 && r <= 57343 ? // Valid surrogate pair (counts as one character)
                                        (t += 1, n++) : // Lone high surrogate - treat as one character for length, but invalid for byte length
                                        t += 1;
                                    } else // Lone low surrogate - treat as one character
                                    t += 1;
                                } else // Regular BMP character
                                t += 1;
                            } else {
                                if (!(r <= 1114111)) return;
                                // Invalid code point
                                t += 1, n++;
                            }
                        }
                        return t;
                    }(n.value.stringValue);
                    // If counting failed (e.g., invalid sequence), return error
                    return void 0 === e ? __PRIVATE_EvaluateResult.vr() : __PRIVATE_EvaluateResult.newValue({
                        integerValue: e
                    });
                }
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreByteLength {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 8486);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "BYTES":
                {
                    const e = n.value?.bytesValue;
                    return "string" == typeof e ? __PRIVATE_EvaluateResult.newValue({
                        integerValue: ByteString.fromBase64String(e).toUint8Array().length
                    }) : __PRIVATE_EvaluateResult.newValue({
                        integerValue: new Uint8Array(e).length
                    });
                }
            case "STRING":
                {
                    // return the number of bytes in the string
                    const e = function __PRIVATE_getUtf8ByteLength(e) {
                        let t = 0;
                        for(let n = 0; n < e.length; n++){
                            const r = e.codePointAt(n);
                            // Check for out of range of lone surrogate
                            if (void 0 === r) return;
                            if (r >= 55296 && r <= 57343) {
                                // If it is a high surrogate, check if a low surrogate follows
                                if (!(r <= 56319)) return;
                                // Lone low surrogate
                                {
                                    const r = e.codePointAt(n + 1);
                                    if (void 0 === r || !(r >= 56320 && r <= 57343)) return; // Lone high surrogate
                                    // Valid surrogate pair
                                    t += 4, n++;
                                }
                            } else if (r <= 127) t += 1;
                            else if (r <= 2047) t += 2;
                            else if (r <= 65535) t += 3;
                            else {
                                if (!(r <= 1114111)) return;
                                // Invalid code point (should not normally happen)
                                t += 4, n++;
                            }
                        }
                        return t;
                    }(n.value?.stringValue);
                    return void 0 === e ? __PRIVATE_EvaluateResult.vr() : __PRIVATE_EvaluateResult.newValue({
                        integerValue: e
                    });
                }
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_StringSearchFunctionBase {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(2 === this.expr.params.length, 39773, `${this.expr.name}() function should have exactly two parameters`);
        let n = !1;
        const r = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "STRING":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        const i = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "STRING":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        return n ? __PRIVATE_EvaluateResult.Dr() : this.kr(r.value?.stringValue, i.value?.stringValue);
    }
}
class __PRIVATE_CoreLike extends __PRIVATE_StringSearchFunctionBase {
    kr(e, t) {
        try {
            const n = function __PRIVATE_likeToRegex(e) {
                let t = "";
                for(let n = 0; n < e.length; n++){
                    const r = e.charAt(n);
                    switch(r){
                        case "_":
                            t += ".";
                            break;
                        case "%":
                            t += ".*";
                            break;
                        // Escape regex special characters
                        case "\\":
                        // Need to escape backslash itself
                        case ".":
                        case "*":
                        case "?":
                        case "+":
                        case "^":
                        case "$":
                        case "|":
                        case "(":
                        case ")":
                        case "[":
                        case "]":
                        case "{":
                        case "}":
                            t += "\\" + r;
                            break;
                        default:
                            t += r;
                    }
                }
                // Anchor the regex to match the entire string
                return "^" + t + "$";
            }(t), r = (0, _re2Js.RE2JS).compile(n);
            return __PRIVATE_EvaluateResult.newValue({
                booleanValue: r.matches(e)
            });
        } catch (e) {
            return __PRIVATE_logWarn(`Invalid LIKE pattern converted to regex: ${t}, returning error. Error: ${e}`), __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreRegexContains extends __PRIVATE_StringSearchFunctionBase {
    kr(e, t) {
        try {
            const n = (0, _re2Js.RE2JS).compile(t);
            return __PRIVATE_EvaluateResult.newValue({
                booleanValue: n.matcher(e).find()
            });
        } catch (e) {
            return __PRIVATE_logWarn(`Invalid regex pattern found in regex_contains: ${t}, returning error`), __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreRegexMatch extends __PRIVATE_StringSearchFunctionBase {
    kr(e, t) {
        try {
            // Use matches() for full string match semantics
            return __PRIVATE_EvaluateResult.newValue({
                booleanValue: (0, _re2Js.RE2JS).compile(t).matches(e)
            });
        } catch (e) {
            return __PRIVATE_logWarn(`Invalid regex pattern found in regex_match: ${t}, returning error`), __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreStrContains extends __PRIVATE_StringSearchFunctionBase {
    kr(e, t) {
        return __PRIVATE_EvaluateResult.newValue({
            booleanValue: e.includes(t)
        });
    }
}
class __PRIVATE_CoreStartsWith extends __PRIVATE_StringSearchFunctionBase {
    kr(e, t) {
        return __PRIVATE_EvaluateResult.newValue({
            booleanValue: e.startsWith(t)
        });
    }
}
class __PRIVATE_CoreEndsWith extends __PRIVATE_StringSearchFunctionBase {
    kr(e, t) {
        return __PRIVATE_EvaluateResult.newValue({
            booleanValue: e.endsWith(t)
        });
    }
}
class __PRIVATE_CoreToLower {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 29079);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "STRING":
                return __PRIVATE_EvaluateResult.newValue({
                    stringValue: n.value?.stringValue?.toLowerCase()
                });
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreToUpper {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 60487);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "STRING":
                return __PRIVATE_EvaluateResult.newValue({
                    stringValue: n.value?.stringValue?.toUpperCase()
                });
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreTrim {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 28544);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "STRING":
                return __PRIVATE_EvaluateResult.newValue({
                    stringValue: n.value?.stringValue?.trim()
                });
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreStrConcat {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        const n = this.expr.params.map((n)=>__PRIVATE_toEvaluable(n).evaluate(e, t));
        // If any part is error or unset, or not a string (and not null), result is error
        // If any part is null, result is null
        let r = "", i = !1;
        for (const e of n)switch(e.type){
            case "STRING":
                r += e.value.stringValue;
                break;
            case "NULL":
                i = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        return i ? __PRIVATE_EvaluateResult.Dr() : __PRIVATE_EvaluateResult.newValue({
            stringValue: r
        });
    }
}
class __PRIVATE_CoreMapGet {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(2 === this.expr.params.length, 4483);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "UNSET":
                return __PRIVATE_EvaluateResult.Sr();
            case "MAP":
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        const r = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        if ("STRING" !== r.type) return __PRIVATE_EvaluateResult.vr();
        const i = n.value?.mapValue?.fields?.[r.value?.stringValue];
        return void 0 === i ? __PRIVATE_EvaluateResult.Sr() : __PRIVATE_EvaluateResult.newValue(i);
    }
}
class __PRIVATE_DistanceBase {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(2 === this.expr.params.length, 25231, `${this.expr.name}() function should have exactly 2 params`);
        let n = !1;
        const r = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "VECTOR":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        const i = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        switch(i.type){
            case "VECTOR":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        if (n) return __PRIVATE_EvaluateResult.Dr();
        const s = __PRIVATE_getVectorValue(r.value), _ = __PRIVATE_getVectorValue(i.value);
        // Mismatched lengths or undefined vectors result in error
        if (void 0 === s || void 0 === _ || s.values?.length !== _.values?.length) return __PRIVATE_EvaluateResult.vr();
        const o = this.qr(s, _);
        // NaN or undefined distance calculation results in error
        return void 0 === o || isNaN(o) ? __PRIVATE_EvaluateResult.vr() : __PRIVATE_EvaluateResult.newValue({
            doubleValue: o
        });
    }
}
class __PRIVATE_CoreCosineDistance extends __PRIVATE_DistanceBase {
    qr(e, t) {
        const n = e?.values ?? [], r = t?.values ?? [];
        if (0 === n.length) return;
        // Distance undefined for empty vectors
        let i = 0, s = 0, _ = 0;
        for(let e = 0; e < n.length; e++){
            // Error if any element is not a number
            if (!__PRIVATE_isNumber(n[e]) || !__PRIVATE_isNumber(r[e])) return;
            const t = __PRIVATE_asDouble(n[e]), o = __PRIVATE_asDouble(r[e]);
            i += t * o, s += t * t, _ += o * o;
        }
        const o = Math.sqrt(s) * Math.sqrt(_);
        // Distance undefined if either vector has zero magnitude
        if (0 === o) return;
        // Clamp cosine similarity to [-1, 1] due to potential floating point inaccuracies
        return 1 - Math.max(-1, Math.min(1, i / o));
    }
}
class __PRIVATE_CoreDotProduct extends __PRIVATE_DistanceBase {
    qr(e, t) {
        const n = e?.values ?? [], r = t?.values ?? [];
        if (0 === n.length) return 0;
        // Dot product of empty vectors is 0
        let i = 0;
        for(let e = 0; e < n.length; e++){
            // Error if any element is not a number
            if (!__PRIVATE_isNumber(n[e]) || !__PRIVATE_isNumber(r[e])) return;
            i += __PRIVATE_asDouble(n[e]) * __PRIVATE_asDouble(r[e]);
        }
        return i;
    }
}
class __PRIVATE_CoreEuclideanDistance extends __PRIVATE_DistanceBase {
    qr(e, t) {
        const n = e?.values ?? [], r = t?.values ?? [];
        if (0 === n.length) return 0;
        // Distance between empty vectors is 0
        let i = 0;
        for(let e = 0; e < n.length; e++){
            // Error if any element is not a number
            if (!__PRIVATE_isNumber(n[e]) || !__PRIVATE_isNumber(r[e])) return;
            const t = __PRIVATE_asDouble(n[e]), s = __PRIVATE_asDouble(r[e]);
            i += Math.pow(t - s, 2);
        }
        return Math.sqrt(i);
    }
}
class __PRIVATE_CoreVectorLength {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 39044);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "VECTOR":
                {
                    const e = __PRIVATE_getVectorValue(n.value);
                    return __PRIVATE_EvaluateResult.newValue({
                        integerValue: e?.values?.length ?? 0
                    });
                }
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
// 0001-01-01T00:00:00Z
const Gt = BigInt(-62135596800), zt = BigInt(253402300799), jt = BigInt(1e3), Ht = BigInt(1e6), Jt = Gt * jt, Yt = zt * jt + BigInt(999), Zt = Gt * Ht, Xt = zt * Ht + BigInt(999999);
// 9999-12-31T23:59:59Z - but the max timestamp has 999,999,999 nanoseconds
// Max sub-second micros
function __PRIVATE_isMicrosInBounds(e) {
    return e >= Zt && e <= Xt;
}
function __PRIVATE_isSecondsInBounds(e) {
    return e >= Gt && e <= zt;
}
function __PRIVATE_isTimestampInBounds(e, t) {
    const n = BigInt(e);
    return !(n < Gt || n > zt) && // Nanos must be non-negative and less than 1 second
    !(t < 0 || t >= 1e9) && // Additional check for min/max boundaries
    (n !== Gt || 0 === t) && !(n === zt && t > 999999999);
}
// Helper function to adjust timestamp for negative nanoseconds
function __PRIVATE_adjustTimestamp(e, t) {
    return t < 0 ? {
        seconds: e - 1,
        nanos: t + 1e9
    } : {
        seconds: e,
        nanos: t
    };
}
function __PRIVATE_timestampToMicros(e) {
    return BigInt(e.seconds) * Ht + // Integer division truncates towards zero
    BigInt(Math.trunc(e.nanoseconds / 1e3));
}
class __PRIVATE_UnixToTimestamp {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 49262, `${this.expr.name}() function should have exactly one parameter`);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "INT":
                return this.toTimestamp(BigInt(n.value.integerValue));
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
    }
}
class __PRIVATE_CoreUnixMicrosToTimestamp extends __PRIVATE_UnixToTimestamp {
    toTimestamp(e) {
        if (!__PRIVATE_isMicrosInBounds(e)) return __PRIVATE_EvaluateResult.vr();
        let t = Number(e / Ht), n = Number(e % Ht * BigInt(1e3));
        // Note: BigInt modulo can result in negative values if the dividend is negative.
        // Adjust for negative nanoseconds
        const r = __PRIVATE_adjustTimestamp(t, n);
        // Final bounds check after adjustment
        return t = r.seconds, n = r.nanos, __PRIVATE_isTimestampInBounds(t, n) ? __PRIVATE_EvaluateResult.newValue({
            timestampValue: {
                seconds: t,
                nanos: n
            }
        }) : __PRIVATE_EvaluateResult.vr();
    }
}
class __PRIVATE_CoreUnixMillisToTimestamp extends __PRIVATE_UnixToTimestamp {
    toTimestamp(e) {
        if (!function __PRIVATE_isMillisInBounds(e) {
            return e >= Jt && e <= Yt;
        }(e)) return __PRIVATE_EvaluateResult.vr();
        let t = Number(e / jt), n = Number(e % jt * BigInt(1e6));
        // Adjust for negative nanoseconds
        const r = __PRIVATE_adjustTimestamp(t, n);
        // Final bounds check after adjustment
        return t = r.seconds, n = r.nanos, __PRIVATE_isTimestampInBounds(t, n) ? __PRIVATE_EvaluateResult.newValue({
            timestampValue: {
                seconds: t,
                nanos: n
            }
        }) : __PRIVATE_EvaluateResult.vr();
    }
}
class __PRIVATE_CoreUnixSecondsToTimestamp extends __PRIVATE_UnixToTimestamp {
    toTimestamp(e) {
        if (!__PRIVATE_isSecondsInBounds(e)) return __PRIVATE_EvaluateResult.vr();
        const t = Number(e);
        return __PRIVATE_EvaluateResult.newValue({
            timestampValue: {
                seconds: t,
                nanos: 0
            }
        });
    }
}
class __PRIVATE_TimestampToUnix {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(1 === this.expr.params.length, 1265, `${this.expr.name}() function should have exactly one parameter`);
        const n = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(n.type){
            case "TIMESTAMP":
                break;
            case "NULL":
                return __PRIVATE_EvaluateResult.Dr();
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        const r = fromTimestamp(n.value.timestampValue);
        // Check if the input timestamp is within valid bounds
        return __PRIVATE_isTimestampInBounds(r.seconds, r.nanoseconds) ? this.$r(r) : __PRIVATE_EvaluateResult.vr();
    }
}
class __PRIVATE_CoreTimestampToUnixMicros extends __PRIVATE_TimestampToUnix {
    $r(e) {
        const t = __PRIVATE_timestampToMicros(e);
        // Check if the resulting micros are within representable bounds
        return __PRIVATE_isMicrosInBounds(t) ? __PRIVATE_EvaluateResult.newValue({
            integerValue: `${t.toString()}`
        }) : __PRIVATE_EvaluateResult.vr();
    }
}
class __PRIVATE_CoreTimestampToUnixMillis extends __PRIVATE_TimestampToUnix {
    $r(e) {
        const t = __PRIVATE_timestampToMicros(e), n = t / BigInt(1e3), r = t % BigInt(1e3);
        // Perform division, truncating towards zero (default JS BigInt division)
        return n > BigInt(0) || r === BigInt(0) ? __PRIVATE_EvaluateResult.newValue({
            integerValue: n.toString()
        }) : __PRIVATE_EvaluateResult.newValue({
            integerValue: (n - BigInt(1)).toString()
        });
    }
}
class __PRIVATE_CoreTimestampToUnixSeconds extends __PRIVATE_TimestampToUnix {
    $r(e) {
        // Seconds are directly available
        const t = BigInt(e.seconds);
        // Check if the resulting seconds are within representable bounds
        return __PRIVATE_isSecondsInBounds(t) ? __PRIVATE_EvaluateResult.newValue({
            integerValue: t.toString()
        }) : __PRIVATE_EvaluateResult.vr();
    }
}
class __PRIVATE_TimestampArithmetic {
    constructor(e){
        this.expr = e;
    }
    evaluate(e, t) {
        __PRIVATE_hardAssert(3 === this.expr.params.length, 2775, `${this.expr.name}() function should have exactly 3 parameters`);
        let n = !1;
        const r = __PRIVATE_toEvaluable(this.expr.params[0]).evaluate(e, t);
        switch(r.type){
            case "TIMESTAMP":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        const i = __PRIVATE_toEvaluable(this.expr.params[1]).evaluate(e, t);
        let s;
        switch(i.type){
            case "STRING":
                if (s = function __PRIVATE_asTimeUnit(e) {
                    switch(e){
                        case "microsecond":
                            return "microsecond";
                        case "millisecond":
                            return "millisecond";
                        case "second":
                            return "second";
                        case "minute":
                            return "minute";
                        case "hour":
                            return "hour";
                        case "day":
                            return "day";
                        default:
                            return;
                    }
                }(i.value.stringValue), void 0 === s) return __PRIVATE_EvaluateResult.vr();
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        const _ = __PRIVATE_toEvaluable(this.expr.params[2]).evaluate(e, t);
        switch(_.type){
            case "INT":
                break;
            case "NULL":
                n = !0;
                break;
            default:
                return __PRIVATE_EvaluateResult.vr();
        }
        if (n) return __PRIVATE_EvaluateResult.Dr();
        const o = BigInt(_.value.integerValue);
        let a;
        try {
            switch(s){
                case "microsecond":
                    a = o;
                    break;
                case "millisecond":
                    a = o * BigInt(1e3);
                    break;
                case "second":
                    a = o * BigInt(1e6);
                    break;
                case "minute":
                    a = o * BigInt(6e7);
                    break;
                case "hour":
                    a = o * BigInt(36e8);
                    break;
                case "day":
                    a = o * BigInt(864e8);
                    break;
                default:
                    return __PRIVATE_EvaluateResult.vr();
            }
            // Check for potential overflow during multiplication
            if ("microsecond" !== s && o !== BigInt(0) && a / o !== BigInt(this.Kr(s))) return __PRIVATE_EvaluateResult.vr();
        } catch (e) {
            // Catch potential BigInt errors (though unlikely with isInteger check)
            return __PRIVATE_logWarn(`Error during timestamp arithmetic: ${e}`), __PRIVATE_EvaluateResult.vr();
        }
        const u = fromTimestamp(r.value.timestampValue);
        // Check initial timestamp bounds
        if (!__PRIVATE_isTimestampInBounds(u.seconds, u.nanoseconds)) return __PRIVATE_EvaluateResult.vr();
        const c = __PRIVATE_timestampToMicros(u), l = this.Wr(c, a);
        // Check final microsecond bounds
        if (!__PRIVATE_isMicrosInBounds(l)) return __PRIVATE_EvaluateResult.vr();
        // Convert back to seconds and nanos
        const E = Number(l / Ht), h = l % Ht, T = Number((h < 0 ? h + Ht : h) * BigInt(1e3)), P = h < 0 ? E - 1 : E;
        // Final check on calculated timestamp bounds
        return __PRIVATE_isTimestampInBounds(P, T) ? __PRIVATE_EvaluateResult.newValue({
            timestampValue: {
                seconds: P,
                nanos: T
            }
        }) : __PRIVATE_EvaluateResult.vr();
    }
    Kr(e) {
        switch(e){
            case "millisecond":
                return 1e3;
            case "second":
                return 1e6;
            case "minute":
                return 6e7;
            case "hour":
                return 36e8;
            case "day":
                return 864e8;
            default:
                return 1;
        }
    }
}
class __PRIVATE_CoreTimestampAdd extends __PRIVATE_TimestampArithmetic {
    Wr(e, t) {
        return e + t;
    }
}
class __PRIVATE_CoreTimestampSub extends __PRIVATE_TimestampArithmetic {
    Wr(e, t) {
        return e - t;
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /* eslint @typescript-eslint/no-explicit-any: 0 */ function __PRIVATE_toPipelineBooleanExpr(e) {
    if (e instanceof FieldFilter) {
        const t = field(e.field.toString()), n = e.value;
        // Comparison filters
        switch(e.op){
            case "<" /* Operator.LESS_THAN */ :
                return and(t.exists(), t.lessThan(Constant._fromProto(n)));
            case "<=" /* Operator.LESS_THAN_OR_EQUAL */ :
                return and(t.exists(), t.lessThanOrEqual(Constant._fromProto(n)));
            case ">" /* Operator.GREATER_THAN */ :
                return and(t.exists(), t.greaterThan(Constant._fromProto(n)));
            case ">=" /* Operator.GREATER_THAN_OR_EQUAL */ :
                return and(t.exists(), t.greaterThanOrEqual(Constant._fromProto(n)));
            case "==" /* Operator.EQUAL */ :
                return and(t.exists(), t.equal(Constant._fromProto(n)));
            case "!=" /* Operator.NOT_EQUAL */ :
                return t.notEqual(Constant._fromProto(n));
            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                return and(t.exists(), t.arrayContains(Constant._fromProto(n)));
            case "in" /* Operator.IN */ :
                {
                    const e = n?.arrayValue?.values?.map((e)=>Constant._fromProto(e));
                    return e ? 1 === e.length ? and(t.exists(), t.equal(e[0])) : and(t.exists(), t.equalAny(e)) : and(t.exists(), t.equalAny([]));
                }
            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                {
                    const e = n?.arrayValue?.values?.map((e)=>Constant._fromProto(e));
                    return and(t.exists(), t.arrayContainsAny(e));
                }
            case "not-in" /* Operator.NOT_IN */ :
                {
                    const e = n?.arrayValue?.values?.map((e)=>Constant._fromProto(e));
                    return e ? 1 === e.length ? t.notEqual(e[0]) : t.notEqualAny(e) : t.notEqualAny([]);
                }
            default:
                fail(36935);
        }
    } else if (e instanceof CompositeFilter) switch(e.op){
        case "and" /* CompositeOperator.AND */ :
            {
                const t = e.getFilters().map((e)=>__PRIVATE_toPipelineBooleanExpr(e));
                return and(t[0], t[1], ...t.slice(2));
            }
        case "or" /* CompositeOperator.OR */ :
            {
                const t = e.getFilters().map((e)=>__PRIVATE_toPipelineBooleanExpr(e));
                return or(t[0], t[1], ...t.slice(2));
            }
        default:
            fail(35306);
    }
    throw new Error(`Failed to convert filter to pipeline conditions: ${e}`);
}
function __PRIVATE_toPipelineStages(e, t) {
    let n;
    n = __PRIVATE_isCollectionGroupQuery(e) ? t.pipeline().collectionGroup(e.collectionGroup) : __PRIVATE_isDocumentQuery$1(e) ? t.pipeline().documents([
        doc(t, e.path.canonicalString())
    ]) : t.pipeline().collection(e.path.canonicalString());
    // filters
    for (const t of e.filters)n = n.where(__PRIVATE_toPipelineBooleanExpr(t));
    // orders
    const r = __PRIVATE_queryNormalizedOrderBy(e), i = r.map((e)=>field(e.field.canonicalString()).exists());
    n = i.length > 1 ? n.where(and(i[0], i[1], ...i.slice(2))) : n.where(i[0]);
    const s = r.map((e)=>"asc" /* Direction.ASCENDING */  === e.dir ? field(e.field.canonicalString()).ascending() : field(e.field.canonicalString()).descending());
    if (s.length > 0) {
        if ("L" /* LimitType.Last */  === e.limitType) {
            const t = function __PRIVATE_reverseOrderings(e) {
                return e.map((e)=>new Ordering(e.expr, "ascending" === e.direction ? "descending" : "ascending", void 0));
            }(s);
            n = n.sort(t[0], ...t.slice(1)), // cursors
            null !== e.startAt && (n = n.where(__PRIVATE_whereConditionsFromCursor(e.startAt, s, "after"))), null !== e.endAt && (n = n.where(__PRIVATE_whereConditionsFromCursor(e.endAt, s, "before"))), n = n.limit(e.limit), n = n.sort(s[0], ...s.slice(1));
        } else n = n.sort(s[0], ...s.slice(1)), null !== e.startAt && (n = n.where(__PRIVATE_whereConditionsFromCursor(e.startAt, s, "after"))), null !== e.endAt && (n = n.where(__PRIVATE_whereConditionsFromCursor(e.endAt, s, "before"))), null !== e.limit && (n = n.limit(e.limit));
    }
    return n.stages;
}
function __PRIVATE_whereConditionsFromCursor(e, t, n) {
    // The filterFunc is either greater than or less than
    const r = "before" === n ? lessThan : greaterThan, i = e.position.map((e)=>Constant._fromProto(e)), s = i.length;
    let _ = t[s - 1].expr, o = i[s - 1], a = r(_, o);
    e.inclusive && // When the cursor bound is inclusive, then the last bound
    // can be equal to the value, otherwise it's not equal
    (a = or(a, _.equal(o)));
    // Iterate backwards over the remaining bounds, adding
    // a condition for each one
    for(let e = s - 2; e >= 0; e--)_ = t[e].expr, o = i[e], // For each field in the orderings, the condition is either
    // a) lt|gt the cursor value,
    // b) or equal the cursor value and lt|gt the cursor values for other fields
    a = or(r(_, o), and(_.equal(o), a));
    return a;
}
function __PRIVATE_canonifyExpr(e) {
    if ((e = __PRIVATE_unwrapExpression(e)) instanceof Field) return `fld(${e.fieldName})`;
    if (e instanceof Constant) return `cst(${function __PRIVATE_canonifyConstantValue(e) {
        return null === e ? "null" : "number" == typeof e ? e.toString() : "string" == typeof e ? `"${e}"` : e instanceof DocumentReference ? `ref(${e.path})` : e instanceof VectorValue ? `vec(${JSON.stringify(e)})` : JSON.stringify(e);
    }(e.value)})`;
    if (e instanceof FunctionExpression) return `fn(${e.name},[${e.params.map(__PRIVATE_canonifyExpr).join(",")}])`;
    if ("ListOfExpressions" === e.expressionType) return `list([${e.Rr.map(__PRIVATE_canonifyExpr).join(",")}])`;
    throw new Error(`Unrecognized expr ${JSON.stringify(e, null, 2)}`);
}
function __PRIVATE_canonifyStage(e) {
    if (e instanceof __PRIVATE_AddFields) return `${e._name}(${__PRIVATE_canonifyExprMap(e.fields)})`;
    if (e instanceof __PRIVATE_Aggregate) {
        let t = `${e._name}(${__PRIVATE_canonifyExprMap(e.accumulators)})`;
        return e.groups.size > 0 && (t += `grouping(${__PRIVATE_canonifyExprMap(e.groups)})`), t;
    }
    if (e instanceof __PRIVATE_Distinct) return `${e._name}(${__PRIVATE_canonifyExprMap(e.groups)})`;
    if (e instanceof __PRIVATE_CollectionSource) return `${e._name}(${e.Vr})`;
    if (e instanceof __PRIVATE_CollectionGroupSource) return `${e._name}(${e.collectionId})`;
    if (e instanceof __PRIVATE_DatabaseSource) return `${e._name}()`;
    if (e instanceof __PRIVATE_DocumentsSource) return `${e._name}(${e.dr.sort()})`;
    if (e instanceof __PRIVATE_Where) return `${e._name}(${__PRIVATE_canonifyExpr(e.condition)})`;
    if (e instanceof __PRIVATE_Limit) return `${e._name}(${e.limit})`;
    if (e instanceof __PRIVATE_Sort) return `${e._name}(${function __PRIVATE_canonifySortOrderings(e) {
        return e.map((e)=>`${__PRIVATE_canonifyExpr(e.expr)}${e.direction}`).join(",");
    }(e.orderings)})`;
    throw new Error(`Unrecognized stage ${e._name}`);
}
function __PRIVATE_canonifyExprMap(e) {
    return `${Array.from(e.entries()).sort().map(([e, t])=>`${e}=${__PRIVATE_canonifyExpr(t)}`).join(",")}`;
}
function __PRIVATE_canonifyPipeline(e) {
    return e.stages.map((e)=>__PRIVATE_canonifyStage(e)).join("|");
}
// TODO(pipeline): do a proper implementation for eq.
function __PRIVATE_pipelineEq(e, t) {
    return __PRIVATE_canonifyPipeline(e) === __PRIVATE_canonifyPipeline(t);
}
function __PRIVATE_isPipeline(e) {
    return e instanceof CorePipeline;
}
function __PRIVATE_stringifyQueryOrPipeline(e) {
    return __PRIVATE_isPipeline(e) ? __PRIVATE_canonifyPipeline(e) : __PRIVATE_stringifyQuery(e);
}
function __PRIVATE_canonifyQueryOrPipeline(e) {
    return __PRIVATE_isPipeline(e) ? __PRIVATE_canonifyPipeline(e) : function __PRIVATE_canonifyQuery(e) {
        return `${__PRIVATE_canonifyTarget(__PRIVATE_queryToTarget(e))}|lt:${e.limitType}`;
    }(e);
}
function __PRIVATE_queryOrPipelineEqual(e, t) {
    return e instanceof CorePipeline && t instanceof CorePipeline ? __PRIVATE_pipelineEq(e, t) : !(e instanceof CorePipeline && !(t instanceof CorePipeline) || !(e instanceof CorePipeline) && t instanceof CorePipeline) && __PRIVATE_queryEquals(e, t);
}
function __PRIVATE_canonifyTargetOrPipeline(e) {
    return __PRIVATE_targetIsPipelineTarget(e) ? __PRIVATE_canonifyPipeline(e) : __PRIVATE_canonifyTarget(e);
}
function __PRIVATE_targetOrPipelineEqual(e, t) {
    return e instanceof CorePipeline && t instanceof CorePipeline ? __PRIVATE_pipelineEq(e, t) : !(e instanceof CorePipeline && !(t instanceof CorePipeline) || !(e instanceof CorePipeline) && t instanceof CorePipeline) && __PRIVATE_targetEquals(e, t);
}
// function addSystemFields(
//   fields: Map<string, Expression>
// ): Map<string, Expression> {
//   const newFields = new Map<string, Expression>(fields);
//   newFields.set(DOCUMENT_KEY_NAME, field(DOCUMENT_KEY_NAME));
//   newFields.set(CREATE_TIME_NAME, field(CREATE_TIME_NAME));
//   newFields.set(UPDATE_TIME_NAME, field(UPDATE_TIME_NAME));
//   return newFields;
// }
function __PRIVATE_toCorePipeline(e, t) {
    const n = function __PRIVATE_rewriteStages(e) {
        let t = !1;
        const n = [];
        for (const r of e)// For stages that provide ordering semantics
        if (r instanceof __PRIVATE_Sort) {
            // Ensure we have a stable ordering
            if (t = !0, r.orderings.some((e)=>e.expr instanceof Field && e.expr.fieldName === F)) n.push(r);
            else {
                const e = r.orderings.map((e)=>e);
                e.push(field(F).ascending()), n.push(new __PRIVATE_Sort(e, {}));
            }
        } else r instanceof __PRIVATE_Limit ? (t || (n.push(new __PRIVATE_Sort([
            field(F).ascending()
        ], {})), t = !0), n.push(r)) : n.push(r);
        return t || n.push(new __PRIVATE_Sort([
            field(F).ascending()
        ], {})), n;
    }(e.stages);
    if (e.userDataReader) {
        const t = e.userDataReader.createContext(3 /* UserDataSource.Argument */ , "toCorePipeline");
        n.forEach((e)=>e._readUserData(t));
    }
    return new CorePipeline(e.userDataReader.serializer, n, t);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A batch of mutations that will be sent as one unit to the backend.
 */ class MutationBatch {
    /**
     * @param batchId - The unique ID of this mutation batch.
     * @param localWriteTime - The original write time of this mutation.
     * @param baseMutations - Mutations that are used to populate the base
     * values when this mutation is applied locally. This can be used to locally
     * overwrite values that are persisted in the remote document cache. Base
     * mutations are never sent to the backend.
     * @param mutations - The user-provided mutations in this mutation batch.
     * User-provided mutations are applied both locally and remotely on the
     * backend.
     */ constructor(e, t, n, r){
        this.batchId = e, this.localWriteTime = t, this.baseMutations = n, this.mutations = r;
    }
    /**
     * Applies all the mutations in this MutationBatch to the specified document
     * to compute the state of the remote document
     *
     * @param document - The document to apply mutations to.
     * @param batchResult - The result of applying the MutationBatch to the
     * backend.
     */ applyToRemoteDocument(e, t) {
        const n = t.mutationResults;
        for(let t = 0; t < this.mutations.length; t++){
            const r = this.mutations[t];
            if (r.key.isEqual(e.key)) __PRIVATE_mutationApplyToRemoteDocument(r, e, n[t]);
        }
    }
    /**
     * Computes the local view of a document given all the mutations in this
     * batch.
     *
     * @param document - The document to apply mutations to.
     * @param mutatedFields - Fields that have been updated before applying this mutation batch.
     * @returns A `FieldMask` representing all the fields that are mutated.
     */ applyToLocalView(e, t) {
        // First, apply the base state. This allows us to apply non-idempotent
        // transform against a consistent set of values.
        for (const n of this.baseMutations)n.key.isEqual(e.key) && (t = __PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        // Second, apply all user-provided mutations.
        for (const n of this.mutations)n.key.isEqual(e.key) && (t = __PRIVATE_mutationApplyToLocalView(n, e, t, this.localWriteTime));
        return t;
    }
    /**
     * Computes the local view for all provided documents given the mutations in
     * this batch. Returns a `DocumentKey` to `Mutation` map which can be used to
     * replace all the mutation applications.
     */ applyToLocalDocumentSet(e, t) {
        // TODO(mrschmidt): This implementation is O(n^2). If we apply the mutations
        // directly (as done in `applyToLocalView()`), we can reduce the complexity
        // to O(n).
        const n = __PRIVATE_newMutationMap();
        return this.mutations.forEach((r)=>{
            const i = e.get(r.key), s = i.overlayedDocument;
            // TODO(mutabledocuments): This method should take a MutableDocumentMap
            // and we should remove this cast.
            let _ = this.applyToLocalView(s, i.mutatedFields);
            // Set mutatedFields to null if the document is only from local mutations.
            // This creates a Set or Delete mutation, instead of trying to create a
            // patch mutation as the overlay.
            _ = t.has(r.key) ? null : _;
            const o = __PRIVATE_calculateOverlayMutation(s, _);
            null !== o && n.set(r.key, o), s.isValidDocument() || s.convertToNoDocument(SnapshotVersion.min());
        }), n;
    }
    keys() {
        return this.mutations.reduce((e, t)=>e.add(t.key), __PRIVATE_documentKeySet());
    }
    isEqual(e) {
        return this.batchId === e.batchId && __PRIVATE_arrayEquals(this.mutations, e.mutations, (e, t)=>__PRIVATE_mutationEquals(e, t)) && __PRIVATE_arrayEquals(this.baseMutations, e.baseMutations, (e, t)=>__PRIVATE_mutationEquals(e, t));
    }
}
/** The result of applying a mutation batch to the backend. */ class MutationBatchResult {
    constructor(e, t, n, /**
     * A pre-computed mapping from each mutated document to the resulting
     * version.
     */ r){
        this.batch = e, this.commitVersion = t, this.mutationResults = n, this.docVersions = r;
    }
    /**
     * Creates a new MutationBatchResult for the given batch and results. There
     * must be one result for each mutation in the batch. This static factory
     * caches a document=&gt;version mapping (docVersions).
     */ static from(e, t, n) {
        __PRIVATE_hardAssert(e.mutations.length === n.length, 58842, {
            Qr: e.mutations.length,
            Gr: n.length
        });
        let r = function __PRIVATE_documentVersionMap() {
            return Vt;
        }();
        const i = e.mutations;
        for(let e = 0; e < i.length; e++)r = r.insert(i[e].key, n[e].version);
        return new MutationBatchResult(e, t, n, r);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Representation of an overlay computed by Firestore.
 *
 * Holds information about a mutation and the largest batch id in Firestore when
 * the mutation was created.
 */ class Overlay {
    constructor(e, t){
        this.largestBatchId = e, this.mutation = t;
    }
    getKey() {
        return this.mutation.key;
    }
    isEqual(e) {
        return null !== e && this.mutation === e.mutation;
    }
    toString() {
        return `Overlay{\n      largestBatchId: ${this.largestBatchId},\n      mutation: ${this.mutation.toString()}\n    }`;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An immutable set of metadata that the local store tracks for each target.
 */ class TargetData {
    constructor(/** The target being listened to. */ e, /**
     * The target ID to which the target corresponds; Assigned by the
     * LocalStore for user listens and by the SyncEngine for limbo watches.
     */ t, /** The purpose of the target. */ n, /**
     * The sequence number of the last transaction during which this target data
     * was modified.
     */ r, /** The latest snapshot version seen for this target. */ i = SnapshotVersion.min(), s = SnapshotVersion.min(), _ = ByteString.EMPTY_BYTE_STRING, o = null){
        this.target = e, this.targetId = t, this.purpose = n, this.sequenceNumber = r, this.snapshotVersion = i, this.lastLimboFreeSnapshotVersion = s, this.resumeToken = _, this.expectedCount = o;
    }
    /** Creates a new target data instance with an updated sequence number. */ withSequenceNumber(e) {
        return new TargetData(this.target, this.targetId, this.purpose, e, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, this.expectedCount);
    }
    /**
     * Creates a new target data instance with an updated resume token and
     * snapshot version.
     */ withResumeToken(e, t) {
        return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, t, this.lastLimboFreeSnapshotVersion, e, /* expectedCount= */ null);
    }
    /**
     * Creates a new target data instance with an updated expected count.
     */ withExpectedCount(e) {
        return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, this.lastLimboFreeSnapshotVersion, this.resumeToken, e);
    }
    /**
     * Creates a new target data instance with an updated last limbo free
     * snapshot version number.
     */ withLastLimboFreeSnapshotVersion(e) {
        return new TargetData(this.target, this.targetId, this.purpose, this.sequenceNumber, this.snapshotVersion, e, this.resumeToken, this.expectedCount);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Serializer for values stored in the LocalStore. */ class __PRIVATE_LocalSerializer {
    constructor(e){
        this.zr = e;
    }
}
/** Decodes a remote document from storage locally to a Document. */ function __PRIVATE_fromDbRemoteDocument(e, t) {
    let n;
    if (t.document) n = fromDocument(e.zr, t.document, !!t.hasCommittedMutations);
    else if (t.noDocument) {
        const e = DocumentKey.fromSegments(t.noDocument.path), r = __PRIVATE_fromDbTimestamp(t.noDocument.readTime);
        n = MutableDocument.newNoDocument(e, r), t.hasCommittedMutations && n.setHasCommittedMutations();
    } else {
        if (!t.unknownDocument) return fail(56709);
        {
            const e = DocumentKey.fromSegments(t.unknownDocument.path), r = __PRIVATE_fromDbTimestamp(t.unknownDocument.version);
            n = MutableDocument.newUnknownDocument(e, r);
        }
    }
    return t.readTime && n.setReadTime(function __PRIVATE_fromDbTimestampKey(e) {
        const t = new Timestamp(e[0], e[1]);
        return SnapshotVersion.fromTimestamp(t);
    }(t.readTime)), n;
}
/** Encodes a document for storage locally. */ function __PRIVATE_toDbRemoteDocument(e, t) {
    const n = t.key, r = {
        prefixPath: n.getCollectionPath().popLast().toArray(),
        collectionGroup: n.collectionGroup,
        documentId: n.path.lastSegment(),
        readTime: __PRIVATE_toDbTimestampKey(t.readTime),
        hasCommittedMutations: t.hasCommittedMutations
    };
    if (t.isFoundDocument()) r.document = function __PRIVATE_toDocument(e, t) {
        return {
            name: __PRIVATE_toName(e, t.key),
            fields: t.data.value.mapValue.fields,
            updateTime: toTimestamp(e, t.version.toTimestamp()),
            createTime: toTimestamp(e, t.createTime.toTimestamp())
        };
    }(e.zr, t);
    else if (t.isNoDocument()) r.noDocument = {
        path: n.path.toArray(),
        readTime: __PRIVATE_toDbTimestamp(t.version)
    };
    else {
        if (!t.isUnknownDocument()) return fail(57904, {
            document: t
        });
        r.unknownDocument = {
            path: n.path.toArray(),
            version: __PRIVATE_toDbTimestamp(t.version)
        };
    }
    return r;
}
function __PRIVATE_toDbTimestampKey(e) {
    const t = e.toTimestamp();
    return [
        t.seconds,
        t.nanoseconds
    ];
}
function __PRIVATE_toDbTimestamp(e) {
    const t = e.toTimestamp();
    return {
        seconds: t.seconds,
        nanoseconds: t.nanoseconds
    };
}
function __PRIVATE_fromDbTimestamp(e) {
    const t = new Timestamp(e.seconds, e.nanoseconds);
    return SnapshotVersion.fromTimestamp(t);
}
/** Encodes a batch of mutations into a DbMutationBatch for local storage. */ /** Decodes a DbMutationBatch into a MutationBatch */ function __PRIVATE_fromDbMutationBatch(e, t) {
    const n = (t.baseMutations || []).map((t)=>__PRIVATE_fromMutation(e.zr, t));
    // Squash old transform mutations into existing patch or set mutations.
    // The replacement of representing `transforms` with `update_transforms`
    // on the SDK means that old `transform` mutations stored in IndexedDB need
    // to be updated to `update_transforms`.
    // TODO(b/174608374): Remove this code once we perform a schema migration.
    for(let e = 0; e < t.mutations.length - 1; ++e){
        const n = t.mutations[e];
        if (e + 1 < t.mutations.length && void 0 !== t.mutations[e + 1].transform) {
            const r = t.mutations[e + 1];
            n.updateTransforms = r.transform.fieldTransforms, t.mutations.splice(e + 1, 1), ++e;
        }
    }
    const r = t.mutations.map((t)=>__PRIVATE_fromMutation(e.zr, t)), i = Timestamp.fromMillis(t.localWriteTimeMs);
    return new MutationBatch(t.batchId, i, n, r);
}
/** Decodes a DbTarget into TargetData */ function __PRIVATE_fromDbTarget(e, t) {
    const n = __PRIVATE_fromDbTimestamp(t.readTime), r = void 0 !== t.lastLimboFreeSnapshotVersion ? __PRIVATE_fromDbTimestamp(t.lastLimboFreeSnapshotVersion) : SnapshotVersion.min();
    let i;
    return i = function __PRIVATE_isPipelineQueryTarget(e) {
        return void 0 !== e.structuredPipeline;
    }(t.query) ? function __PRIVATE_fromPipelineTarget(e, t) {
        const n = e.structuredPipeline;
        __PRIVATE_hardAssert((n?.pipeline?.stages ?? []).length > 0, 1845);
        const r = n?.pipeline?.stages.map(__PRIVATE_stageFromProto);
        return new CorePipeline(t, r);
    }(t.query, e.zr) : function __PRIVATE_isDocumentQuery(e) {
        return void 0 !== e.documents;
    }(t.query) ? function __PRIVATE_fromDocumentsTarget(e) {
        const t = e.documents.length;
        return __PRIVATE_hardAssert(1 === t, 1966, {
            count: t
        }), __PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(__PRIVATE_fromQueryPath(e.documents[0])));
    }(t.query) : function __PRIVATE_fromQueryTarget(e) {
        return __PRIVATE_queryToTarget(__PRIVATE_convertQueryTargetToQuery(e));
    }(t.query), new TargetData(i, t.targetId, "TargetPurposeListen" /* TargetPurpose.Listen */ , t.lastListenSequenceNumber, n, r, ByteString.fromBase64String(t.resumeToken));
}
/** Encodes TargetData into a DbTarget for storage locally. */ function __PRIVATE_toDbTarget(e, t) {
    const n = __PRIVATE_toDbTimestamp(t.snapshotVersion), r = __PRIVATE_toDbTimestamp(t.lastLimboFreeSnapshotVersion);
    let i;
    i = __PRIVATE_targetIsPipelineTarget(t.target) ? __PRIVATE_toPipelineTarget(e.zr, t.target) : __PRIVATE_targetIsDocumentTarget(t.target) ? __PRIVATE_toDocumentsTarget(e.zr, t.target) : __PRIVATE_toQueryTarget(e.zr, t.target).yt;
    // We can't store the resumeToken as a ByteString in IndexedDb, so we
    // convert it to a base64 string for storage.
    const s = t.resumeToken.toBase64();
    // lastListenSequenceNumber is always 0 until we do real GC.
    return {
        targetId: t.targetId,
        canonicalId: __PRIVATE_canonifyTargetOrPipeline(t.target),
        readTime: n,
        resumeToken: s,
        lastListenSequenceNumber: t.sequenceNumber,
        lastLimboFreeSnapshotVersion: r,
        query: i
    };
}
/**
 * Encodes a `BundledQuery` from bundle proto to a Query object.
 *
 * This reconstructs the original query used to build the bundle being loaded,
 * including features exists only in SDKs (for example: limit-to-last).
 */ function __PRIVATE_fromBundledQuery(e) {
    const t = __PRIVATE_convertQueryTargetToQuery({
        parent: e.parent,
        structuredQuery: e.structuredQuery
    });
    return "LAST" === e.limitType ? __PRIVATE_queryWithLimit(t, t.limit, "L" /* LimitType.Last */ ) : t;
}
/** Encodes a NamedQuery proto object to a NamedQuery model object. */ /** Encodes a DbDocumentOverlay object to an Overlay model object. */ function __PRIVATE_fromDbDocumentOverlay(e, t) {
    return new Overlay(t.largestBatchId, __PRIVATE_fromMutation(e.zr, t.overlayMutation));
}
/** Decodes an Overlay model object into a DbDocumentOverlay object. */ /**
 * Returns the DbDocumentOverlayKey corresponding to the given user and
 * document key.
 */ function __PRIVATE_toDbDocumentOverlayKey(e, t) {
    const n = t.path.lastSegment();
    return [
        e,
        __PRIVATE_encodeResourcePath(t.path.popLast()),
        n
    ];
}
function __PRIVATE_toDbIndexState(e, t, n, r) {
    return {
        indexId: e,
        uid: t,
        sequenceNumber: n,
        readTime: __PRIVATE_toDbTimestamp(r.readTime),
        documentKey: __PRIVATE_encodeResourcePath(r.documentKey.path),
        largestBatchId: r.largestBatchId
    };
}
function __PRIVATE_stageFromProto(e) {
    switch(e.name){
        case "collection":
            return new __PRIVATE_CollectionSource(e.args[0].referenceValue, {});
        case "collection_group":
            return new __PRIVATE_CollectionGroupSource(e.args[1].stringValue, {});
        case "database":
            return new __PRIVATE_DatabaseSource({});
        case "documents":
            return new __PRIVATE_DocumentsSource(e.args.map((e)=>e.referenceValue), {});
        case "where":
            return new __PRIVATE_Where(__PRIVATE_exprFromProto(e.args[0]), {});
        case "limit":
            {
                const t = e.args[0].integerValue ?? e.args[0].doubleValue;
                return new __PRIVATE_Limit("number" == typeof t ? t : Number(t), {});
            }
        case "sort":
            return new __PRIVATE_Sort(e.args.map((e)=>(function __PRIVATE_orderingFromProto(e) {
                    const t = e.mapValue?.fields;
                    return new Ordering(__PRIVATE_exprFromProto(t.expression), t.direction?.stringValue, "orderingFromProto");
                })(e)), {});
        default:
            throw new Error(`Stage type: ${e.name} not supported.`);
    }
}
function __PRIVATE_exprFromProto(e) {
    return e.fieldReferenceValue ? new Field(__PRIVATE_fieldPathFromArgument("_exprFromProto", e.fieldReferenceValue), "_exprFromProto") : e.functionValue ? function __PRIVATE_functionFromProto(e) {
        // TODO(pipeline): When aggregation is supported, we need to return AggregateFunction for the functions
        // with aggregate names (sum, count, etc).
        return new FunctionExpression(e.functionValue.name, e.functionValue.args?.map(__PRIVATE_exprFromProto) || []);
    }(e) : Constant._fromProto(e);
}
class __PRIVATE_IndexedDbBundleCache {
    getBundleMetadata(e, t) {
        return __PRIVATE_bundlesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbBundle(e) {
                return {
                    id: e.bundleId,
                    createTime: __PRIVATE_fromDbTimestamp(e.createTime),
                    version: e.version
                };
            }(e);
        });
    }
    saveBundleMetadata(e, t) {
        return __PRIVATE_bundlesStore(e).put(function __PRIVATE_toDbBundle(e) {
            return {
                bundleId: e.id,
                createTime: __PRIVATE_toDbTimestamp(__PRIVATE_fromVersion(e.createTime)),
                version: e.version
            };
        }(t));
    }
    getNamedQuery(e, t) {
        return __PRIVATE_namedQueriesStore(e).get(t).next((e)=>{
            if (e) return function __PRIVATE_fromDbNamedQuery(e) {
                return {
                    name: e.name,
                    query: __PRIVATE_fromBundledQuery(e.bundledQuery),
                    readTime: __PRIVATE_fromDbTimestamp(e.readTime)
                };
            }(e);
        });
    }
    saveNamedQuery(e, t) {
        return __PRIVATE_namedQueriesStore(e).put(function __PRIVATE_toDbNamedQuery(e) {
            return {
                name: e.name,
                readTime: __PRIVATE_toDbTimestamp(__PRIVATE_fromVersion(e.readTime)),
                bundledQuery: e.bundledQuery
            };
        }(t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the bundles object store.
 */ function __PRIVATE_bundlesStore(e) {
    return __PRIVATE_getStore(e, me);
}
/**
 * Helper to get a typed SimpleDbStore for the namedQueries object store.
 */ function __PRIVATE_namedQueriesStore(e) {
    return __PRIVATE_getStore(e, ge);
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Implementation of DocumentOverlayCache using IndexedDb.
 */ class __PRIVATE_IndexedDbDocumentOverlayCache {
    /**
     * @param serializer - The document serializer.
     * @param userId - The userId for which we are accessing overlays.
     */ constructor(e, t){
        this.serializer = e, this.userId = t;
    }
    static jr(e, t) {
        const n = t.uid || "";
        return new __PRIVATE_IndexedDbDocumentOverlayCache(e, n);
    }
    getOverlay(e, t) {
        return __PRIVATE_documentOverlayStore(e).get(__PRIVATE_toDbDocumentOverlayKey(this.userId, t)).next((e)=>e ? __PRIVATE_fromDbDocumentOverlay(this.serializer, e) : null);
    }
    getOverlays(e, t) {
        const n = __PRIVATE_newOverlayMap();
        return PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    getAllOverlays(e, t) {
        const n = __PRIVATE_newOverlayMap();
        // TODO(pipeline): should we create an index for this? But how often people really expect
        // querying entire database to be fast?
        return __PRIVATE_documentOverlayStore(e).ee((e, r)=>{
            const i = __PRIVATE_fromDbDocumentOverlay(this.serializer, r);
            i.largestBatchId > t && n.set(i.getKey(), i);
        }).next(()=>n);
    }
    saveOverlays(e, t, n) {
        const r = [];
        return n.forEach((n, i)=>{
            const s = new Overlay(t, i);
            r.push(this.Hr(e, s));
        }), PersistencePromise.waitFor(r);
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = new Set;
        // Get the set of unique collection paths.
        t.forEach((e)=>r.add(__PRIVATE_encodeResourcePath(e.getCollectionPath())));
        const i = [];
        return r.forEach((t)=>{
            const r = IDBKeyRange.bound([
                this.userId,
                t,
                n
            ], [
                this.userId,
                t,
                n + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
            i.push(__PRIVATE_documentOverlayStore(e).Z(ke, r));
        }), PersistencePromise.waitFor(i);
    }
    getOverlaysForCollection(e, t, n) {
        const r = __PRIVATE_newOverlayMap(), i = __PRIVATE_encodeResourcePath(t), s = IDBKeyRange.bound([
            this.userId,
            i,
            n
        ], [
            this.userId,
            i,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return __PRIVATE_documentOverlayStore(e).H(ke, s).next((e)=>{
            for (const t of e){
                const e = __PRIVATE_fromDbDocumentOverlay(this.serializer, t);
                r.set(e.getKey(), e);
            }
            return r;
        });
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        const i = __PRIVATE_newOverlayMap();
        let s;
        // We want batch IDs larger than `sinceBatchId`, and so the lower bound
        // is not inclusive.
        const _ = IDBKeyRange.bound([
            this.userId,
            t,
            n
        ], [
            this.userId,
            t,
            Number.POSITIVE_INFINITY
        ], /*lowerOpen=*/ !0);
        return __PRIVATE_documentOverlayStore(e).ee({
            index: $e,
            range: _
        }, (e, t, n)=>{
            // We do not want to return partial batch overlays, even if the size
            // of the result set exceeds the given `count` argument. Therefore, we
            // continue to aggregate results even after the result size exceeds
            // `count` if there are more overlays from the `currentBatchId`.
            const _ = __PRIVATE_fromDbDocumentOverlay(this.serializer, t);
            i.size() < r || _.largestBatchId === s ? (i.set(_.getKey(), _), s = _.largestBatchId) : n.done();
        }).next(()=>i);
    }
    Hr(e, t) {
        return __PRIVATE_documentOverlayStore(e).put(function __PRIVATE_toDbDocumentOverlay(e, t, n) {
            const [r, i, s] = __PRIVATE_toDbDocumentOverlayKey(t, n.mutation.key);
            return {
                userId: t,
                collectionPath: i,
                documentId: s,
                collectionGroup: n.mutation.key.getCollectionGroup(),
                largestBatchId: n.largestBatchId,
                overlayMutation: toMutation(e.zr, n.mutation)
            };
        }(this.serializer, this.userId, t));
    }
}
/**
 * Helper to get a typed SimpleDbStore for the document overlay object store.
 */ function __PRIVATE_documentOverlayStore(e) {
    return __PRIVATE_getStore(e, Be);
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_IndexedDbGlobalsCache {
    Jr(e) {
        return __PRIVATE_getStore(e, We);
    }
    getSessionToken(e) {
        return this.Jr(e).get("sessionToken").next((e)=>{
            const t = e?.value;
            return t ? ByteString.fromUint8Array(t) : ByteString.EMPTY_BYTE_STRING;
        });
    }
    setSessionToken(e, t) {
        return this.Jr(e).put({
            name: "sessionToken",
            value: t.toUint8Array()
        });
    }
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // Note: This code is copied from the backend. Code that is not used by
// Firestore was removed.
/** Firestore index value writer.  */ class __PRIVATE_FirestoreIndexValueWriter {
    constructor(){}
    // The write methods below short-circuit writing terminators for values
    // containing a (terminating) truncated value.
    // As an example, consider the resulting encoding for:
    // ["bar", [2, "foo"]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TERM, TERM, TERM)
    // ["bar", [2, truncated("foo")]] -> (STRING, "bar", TERM, ARRAY, NUMBER, 2, STRING, "foo", TRUNC)
    // ["bar", truncated(["foo"])] -> (STRING, "bar", TERM, ARRAY. STRING, "foo", TERM, TRUNC)
    /** Writes an index value.  */ Yr(e, t) {
        this.Zr(e, t), // Write separator to split index values
        // (see go/firestore-storage-format#encodings).
        t.Xr();
    }
    Zr(e, t) {
        if ("nullValue" in e) this.ei(t, 5);
        else if ("booleanValue" in e) this.ei(t, 10), t.ti(e.booleanValue ? 1 : 0);
        else if ("integerValue" in e) this.ei(t, 15), t.ti(__PRIVATE_normalizeNumber(e.integerValue));
        else if ("doubleValue" in e) {
            const n = __PRIVATE_normalizeNumber(e.doubleValue);
            isNaN(n) ? this.ei(t, 13) : (this.ei(t, 15), __PRIVATE_isNegativeZero(n) ? // -0.0, 0 and 0.0 are all considered the same
            t.ti(0) : t.ti(n));
        } else if ("timestampValue" in e) {
            let n = e.timestampValue;
            this.ei(t, 20), "string" == typeof n && (n = __PRIVATE_normalizeTimestamp(n)), t.ni(`${n.seconds || ""}`), t.ti(n.nanos || 0);
        } else if ("stringValue" in e) this.ri(e.stringValue, t), this.ii(t);
        else if ("bytesValue" in e) this.ei(t, 30), t.si(__PRIVATE_normalizeByteString(e.bytesValue)), this.ii(t);
        else if ("referenceValue" in e) this._i(e.referenceValue, t);
        else if ("geoPointValue" in e) {
            const n = e.geoPointValue;
            this.ei(t, 45), t.ti(n.latitude || 0), t.ti(n.longitude || 0);
        } else "mapValue" in e ? __PRIVATE_isMaxValue(e) ? this.ei(t, Number.MAX_SAFE_INTEGER) : __PRIVATE_isVectorValue(e) ? this.oi(e.mapValue, t) : (this.ai(e.mapValue, t), this.ii(t)) : "arrayValue" in e ? (this.ui(e.arrayValue, t), this.ii(t)) : fail(19022, {
            ci: e
        });
    }
    ri(e, t) {
        this.ei(t, 25), this.li(e, t);
    }
    li(e, t) {
        t.ni(e);
    }
    ai(e, t) {
        const n = e.fields || {};
        this.ei(t, 55);
        for (const e of Object.keys(n))this.ri(e, t), this.Zr(n[e], t);
    }
    oi(e, t) {
        const n = e.fields || {};
        this.ei(t, 53);
        // Vectors sort first by length
        const r = ct, i = n[r].arrayValue?.values?.length || 0;
        this.ei(t, 15), t.ti(__PRIVATE_normalizeNumber(i)), // Vectors then sort by position value
        this.ri(r, t), this.Zr(n[r], t);
    }
    ui(e, t) {
        const n = e.values || [];
        this.ei(t, 50);
        for (const e of n)this.Zr(e, t);
    }
    _i(e, t) {
        this.ei(t, 37);
        DocumentKey.fromName(e).path.forEach((e)=>{
            this.ei(t, 60), this.li(e, t);
        });
    }
    ei(e, t) {
        e.ti(t);
    }
    ii(e) {
        // While the SDK does not implement truncation, the truncation marker is
        // used to terminate all variable length values (which are strings, bytes,
        // references, arrays and maps).
        e.ti(2);
    }
}
__PRIVATE_FirestoreIndexValueWriter.Ei = new __PRIVATE_FirestoreIndexValueWriter;
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law | agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES | CONDITIONS OF ANY KIND, either express | implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** These constants are taken from the backend. */ const en = 255;
/**
 * Counts the number of zeros in a byte.
 *
 * Visible for testing.
 */ function __PRIVATE_numberOfLeadingZerosInByte(e) {
    if (0 === e) return 8;
    let t = 0;
    return e >> 4 || // Test if the first four bits are zero.
    (t += 4, e <<= 4), e >> 6 || // Test if the first two (or next two) bits are zero.
    (t += 2, e <<= 2), e >> 7 || // Test if the remaining bit is zero.
    (t += 1), t;
}
/** Counts the number of leading zeros in the given byte array. */ /**
 * Returns the number of bytes required to store "value". Leading zero bytes
 * are skipped.
 */ function __PRIVATE_unsignedNumLength(e) {
    // This is just the number of bytes for the unsigned representation of the number.
    const t = 64 - function __PRIVATE_numberOfLeadingZeros(e) {
        let t = 0;
        for(let n = 0; n < 8; ++n){
            const r = __PRIVATE_numberOfLeadingZerosInByte(255 & e[n]);
            if (t += r, 8 !== r) break;
        }
        return t;
    }(e);
    return Math.ceil(t / 8);
}
/**
 * OrderedCodeWriter is a minimal-allocation implementation of the writing
 * behavior defined by the backend.
 *
 * The code is ported from its Java counterpart.
 */ class __PRIVATE_OrderedCodeWriter {
    constructor(){
        this.buffer = new Uint8Array(1024), this.position = 0;
    }
    hi(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Ti(n.value), n = t.next();
        this.Pi();
    }
    Ri(e) {
        const t = e[Symbol.iterator]();
        let n = t.next();
        for(; !n.done;)this.Ii(n.value), n = t.next();
        this.Ai();
    }
    /** Writes utf8 bytes into this byte sequence, ascending. */ Vi(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Ti(e);
            else if (e < 2048) this.Ti(960 | e >>> 6), this.Ti(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Ti(480 | e >>> 12), this.Ti(128 | 63 & e >>> 6), this.Ti(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Ti(240 | e >>> 18), this.Ti(128 | 63 & e >>> 12), this.Ti(128 | 63 & e >>> 6), this.Ti(128 | 63 & e);
            }
        }
        this.Pi();
    }
    /** Writes utf8 bytes into this byte sequence, descending */ di(e) {
        for (const t of e){
            const e = t.charCodeAt(0);
            if (e < 128) this.Ii(e);
            else if (e < 2048) this.Ii(960 | e >>> 6), this.Ii(128 | 63 & e);
            else if (t < "\ud800" || "\udbff" < t) this.Ii(480 | e >>> 12), this.Ii(128 | 63 & e >>> 6), this.Ii(128 | 63 & e);
            else {
                const e = t.codePointAt(0);
                this.Ii(240 | e >>> 18), this.Ii(128 | 63 & e >>> 12), this.Ii(128 | 63 & e >>> 6), this.Ii(128 | 63 & e);
            }
        }
        this.Ai();
    }
    fi(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // actual value in big-endian format with leading 0 bytes dropped.
        const t = this.mi(e), n = __PRIVATE_unsignedNumLength(t);
        this.pi(1 + n), this.buffer[this.position++] = 255 & n;
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = 255 & t[e];
    }
    gi(e) {
        // Values are encoded with a single byte length prefix, followed by the
        // inverted value in big-endian format with leading 0 bytes dropped.
        const t = this.mi(e), n = __PRIVATE_unsignedNumLength(t);
        this.pi(1 + n), this.buffer[this.position++] = ~(255 & n);
        // Write the length
        for(let e = t.length - n; e < t.length; ++e)this.buffer[this.position++] = ~(255 & t[e]);
    }
    /**
     * Writes the "infinity" byte sequence that sorts after all other byte
     * sequences written in ascending order.
     */ yi() {
        this.wi(en), this.wi(255);
    }
    /**
     * Writes the "infinity" byte sequence that sorts before all other byte
     * sequences written in descending order.
     */ bi() {
        this.Si(en), this.Si(255);
    }
    /**
     * Resets the buffer such that it is the same as when it was newly
     * constructed.
     */ reset() {
        this.position = 0;
    }
    seed(e) {
        this.pi(e.length), this.buffer.set(e, this.position), this.position += e.length;
    }
    /** Makes a copy of the encoded bytes in this buffer.  */ Di() {
        return this.buffer.slice(0, this.position);
    }
    /**
     * Encodes `val` into an encoding so that the order matches the IEEE 754
     * floating-point comparison results with the following exceptions:
     *   -0.0 < 0.0
     *   all non-NaN < NaN
     *   NaN = NaN
     */ mi(e) {
        const t = /** Converts a JavaScript number to a byte array (using big endian encoding). */ function __PRIVATE_doubleToLongBits(e) {
            const t = new DataView(new ArrayBuffer(8));
            return t.setFloat64(0, e, /* littleEndian= */ !1), new Uint8Array(t.buffer);
        }(e), n = !!(128 & t[0]);
        // Check if the first bit is set. We use a bit mask since value[0] is
        // encoded as a number from 0 to 255.
        // Revert the two complement to get natural ordering
        t[0] ^= n ? 255 : 128;
        for(let e = 1; e < t.length; ++e)t[e] ^= n ? 255 : 0;
        return t;
    }
    /** Writes a single byte ascending to the buffer. */ Ti(e) {
        const t = 255 & e;
        0 === t ? (this.wi(0), this.wi(255)) : t === en ? (this.wi(en), this.wi(0)) : this.wi(t);
    }
    /** Writes a single byte descending to the buffer.  */ Ii(e) {
        const t = 255 & e;
        0 === t ? (this.Si(0), this.Si(255)) : t === en ? (this.Si(en), this.Si(0)) : this.Si(e);
    }
    Pi() {
        this.wi(0), this.wi(1);
    }
    Ai() {
        this.Si(0), this.Si(1);
    }
    wi(e) {
        this.pi(1), this.buffer[this.position++] = e;
    }
    Si(e) {
        this.pi(1), this.buffer[this.position++] = ~e;
    }
    pi(e) {
        const t = e + this.position;
        if (t <= this.buffer.length) return;
        // Try doubling.
        let n = 2 * this.buffer.length;
        // Still not big enough? Just allocate the right size.
        n < t && (n = t);
        // Create the new buffer.
        const r = new Uint8Array(n);
        r.set(this.buffer), this.buffer = r;
    }
}
class __PRIVATE_AscendingIndexByteEncoder {
    constructor(e){
        this.xi = e;
    }
    si(e) {
        this.xi.hi(e);
    }
    ni(e) {
        this.xi.Vi(e);
    }
    ti(e) {
        this.xi.fi(e);
    }
    Xr() {
        this.xi.yi();
    }
}
class __PRIVATE_DescendingIndexByteEncoder {
    constructor(e){
        this.xi = e;
    }
    si(e) {
        this.xi.Ri(e);
    }
    ni(e) {
        this.xi.di(e);
    }
    ti(e) {
        this.xi.gi(e);
    }
    Xr() {
        this.xi.bi();
    }
}
/**
 * Implements `DirectionalIndexByteEncoder` using `OrderedCodeWriter` for the
 * actual encoding.
 */ class __PRIVATE_IndexByteEncoder {
    constructor(){
        this.xi = new __PRIVATE_OrderedCodeWriter, this.ascending = new __PRIVATE_AscendingIndexByteEncoder(this.xi), this.descending = new __PRIVATE_DescendingIndexByteEncoder(this.xi);
    }
    seed(e) {
        this.xi.seed(e);
    }
    Ci(e) {
        return 0 /* IndexKind.ASCENDING */  === e ? this.ascending : this.descending;
    }
    Di() {
        return this.xi.Di();
    }
    reset() {
        this.xi.reset();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Represents an index entry saved by the SDK in persisted storage. */ class __PRIVATE_IndexEntry {
    constructor(e, t, n, r){
        this.Fi = e, this.Oi = t, this.Mi = n, this.Ni = r;
    }
    /**
     * Returns an IndexEntry entry that sorts immediately after the current
     * directional value.
     */ Li() {
        const e = this.Ni.length, t = 0 === e || 255 === this.Ni[e - 1] ? e + 1 : e, n = new Uint8Array(t);
        return n.set(this.Ni, 0), t !== e ? n.set([
            0
        ], this.Ni.length) : ++n[n.length - 1], new __PRIVATE_IndexEntry(this.Fi, this.Oi, this.Mi, n);
    }
    // Create a representation of the Index Entry as a DbIndexEntry
    Bi(e, t, n) {
        return {
            indexId: this.Fi,
            uid: e,
            arrayValue: __PRIVATE_encodeKeySafeBytes(this.Mi),
            directionalValue: __PRIVATE_encodeKeySafeBytes(this.Ni),
            orderedDocumentKey: __PRIVATE_encodeKeySafeBytes(t),
            documentKey: n.path.toArray()
        };
    }
    // Create a representation of the Index Entry as a DbIndexEntryKey
    Ui(e, t, n) {
        const r = this.Bi(e, t, n);
        return [
            r.indexId,
            r.uid,
            r.arrayValue,
            r.directionalValue,
            r.orderedDocumentKey,
            r.documentKey
        ];
    }
}
function __PRIVATE_indexEntryComparator(e, t) {
    let n = e.Fi - t.Fi;
    return 0 !== n ? n : (n = __PRIVATE_compareByteArrays(e.Mi, t.Mi), 0 !== n ? n : (n = __PRIVATE_compareByteArrays(e.Ni, t.Ni), 0 !== n ? n : DocumentKey.comparator(e.Oi, t.Oi)));
}
function __PRIVATE_compareByteArrays(e, t) {
    for(let n = 0; n < e.length && n < t.length; ++n){
        const r = e[n] - t[n];
        if (0 !== r) return r;
    }
    return e.length - t.length;
}
/**
 * Workaround for WebKit bug: https://bugs.webkit.org/show_bug.cgi?id=292721
 * Create a key safe representation of Uint8Array values.
 * If the browser is detected as Safari or WebKit, then
 * the input array will be converted to "sortable byte string".
 * Otherwise, the input array will be returned in its original type.
 */ function __PRIVATE_encodeKeySafeBytes(e) {
    return (0, _util.isSafariOrWebkit)() ? /**
 * Encodes a Uint8Array into a "sortable byte string".
 * A "sortable byte string" sorts in the same order as the Uint8Array.
 * This works because JS string comparison sorts strings based on code points.
 */ function __PRIVATE_encodeUint8ArrayToSortableString(e) {
        let t = "";
        for(let n = 0; n < e.length; n++)t += String.fromCharCode(e[n]);
        return t;
    }(e) : e;
}
/**
 * Reverts the key safe representation of Uint8Array (created by
 * encodeKeySafeBytes) to a normal Uint8Array.
 */ function __PRIVATE_decodeKeySafeBytes(e) {
    return "string" != typeof e ? e : function __PRIVATE_decodeSortableStringToUint8Array(e) {
        const t = new Uint8Array(e.length);
        for(let n = 0; n < e.length; n++)t[n] = e.charCodeAt(n);
        return t;
    }(e);
}
class __PRIVATE_TargetIndexMatcher {
    constructor(e){
        // The inequality filters of the target (if it exists).
        // Note: The sort on FieldFilters is not required. Using SortedSet here just to utilize the custom
        // comparator.
        this.ki = new SortedSet((e, t)=>FieldPath$1.comparator(e.field, t.field)), this.collectionId = null != e.collectionGroup ? e.collectionGroup : e.path.lastSegment(), this.qi = e.orderBy, this.$i = [];
        for (const t of e.filters){
            const e = t;
            e.isInequality() ? this.ki = this.ki.add(e) : this.$i.push(e);
        }
    }
    get Ki() {
        return this.ki.size > 1;
    }
    /**
     * Returns whether the index can be used to serve the TargetIndexMatcher's
     * target.
     *
     * An index is considered capable of serving the target when:
     * - The target uses all index segments for its filters and orderBy clauses.
     *   The target can have additional filter and orderBy clauses, but not
     *   fewer.
     * - If an ArrayContains/ArrayContainsAnyfilter is used, the index must also
     *   have a corresponding `CONTAINS` segment.
     * - All directional index segments can be mapped to the target as a series of
     *   equality filters, a single inequality filter and a series of orderBy
     *   clauses.
     * - The segments that represent the equality filters may appear out of order.
     * - The optional segment for the inequality filter must appear after all
     *   equality segments.
     * - The segments that represent that orderBy clause of the target must appear
     *   in order after all equality and inequality segments. Single orderBy
     *   clauses cannot be skipped, but a continuous orderBy suffix may be
     *   omitted.
     */ Wi(e) {
        if (__PRIVATE_hardAssert(e.collectionGroup === this.collectionId, 49279), this.Ki) // Only single inequality is supported for now.
        // TODO(Add support for multiple inequality query): b/298441043
        return !1;
        // If there is an array element, find a matching filter.
        const t = __PRIVATE_fieldIndexGetArraySegment(e);
        if (void 0 !== t && !this.Qi(t)) return !1;
        const n = __PRIVATE_fieldIndexGetDirectionalSegments(e);
        let r = new Set, i = 0, s = 0;
        // Process all equalities first. Equalities can appear out of order.
        for(; i < n.length && this.Qi(n[i]); ++i)r = r.add(n[i].fieldPath.canonicalString());
        // If we already have processed all segments, all segments are used to serve
        // the equality filters and we do not need to map any segments to the
        // target's inequality and orderBy clauses.
        if (i === n.length) return !0;
        if (this.ki.size > 0) {
            // Only a single inequality is currently supported. Get the only entry in the set.
            const e = this.ki.getIterator().getNext();
            // If there is an inequality filter and the field was not in one of the
            // equality filters above, the next segment must match both the filter
            // and the first orderBy clause.
            if (!r.has(e.field.canonicalString())) {
                const t = n[i];
                if (!this.Gi(e, t) || !this.zi(this.qi[s++], t)) return !1;
            }
            ++i;
        }
        // All remaining segments need to represent the prefix of the target's
        // orderBy.
        for(; i < n.length; ++i){
            const e = n[i];
            if (s >= this.qi.length || !this.zi(this.qi[s++], e)) return !1;
        }
        return !0;
    }
    /**
     * Returns a full matched field index for this target. Currently multiple
     * inequality query is not supported so function returns null.
     */ ji() {
        if (this.Ki) return null;
        // We want to make sure only one segment created for one field. For example,
        // in case like a == 3 and a > 2, Index {a ASCENDING} will only be created
        // once.
        let e = new SortedSet(FieldPath$1.comparator);
        const t = [];
        for (const n of this.$i){
            if (n.field.isKeyField()) continue;
            if ("array-contains" /* Operator.ARRAY_CONTAINS */  === n.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === n.op) t.push(new IndexSegment(n.field, 2 /* IndexKind.CONTAINS */ ));
            else {
                if (e.has(n.field)) continue;
                e = e.add(n.field), t.push(new IndexSegment(n.field, 0 /* IndexKind.ASCENDING */ ));
            }
        }
        // Note: We do not explicitly check `this.inequalityFilter` but rather rely
        // on the target defining an appropriate "order by" to ensure that the
        // required index segment is added. The query engine would reject a query
        // with an inequality filter that lacks the required order-by clause.
        for (const n of this.qi)// Stop adding more segments if we see a order-by on key. Typically this
        // is the default implicit order-by which is covered in the index_entry
        // table as a separate column. If it is not the default order-by, the
        // generated index will be missing some segments optimized for order-bys,
        // which is probably fine.
        n.field.isKeyField() || e.has(n.field) || (e = e.add(n.field), t.push(new IndexSegment(n.field, "asc" /* Direction.ASCENDING */  === n.dir ? 0 /* IndexKind.ASCENDING */  : 1 /* IndexKind.DESCENDING */ )));
        return new FieldIndex(FieldIndex.UNKNOWN_ID, this.collectionId, t, IndexState.empty());
    }
    Qi(e) {
        for (const t of this.$i)if (this.Gi(t, e)) return !0;
        return !1;
    }
    Gi(e, t) {
        if (void 0 === e || !e.field.isEqual(t.fieldPath)) return !1;
        const n = "array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op;
        return 2 /* IndexKind.CONTAINS */  === t.kind === n;
    }
    zi(e, t) {
        return !!e.field.isEqual(t.fieldPath) && (0 /* IndexKind.ASCENDING */  === t.kind && "asc" /* Direction.ASCENDING */  === e.dir || 1 /* IndexKind.DESCENDING */  === t.kind && "desc" /* Direction.DESCENDING */  === e.dir);
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides utility functions that help with boolean logic transformations needed for handling
 * complex filters used in queries.
 */ /**
 * The `in` filter is only a syntactic sugar over a disjunction of equalities. For instance: `a in
 * [1,2,3]` is in fact `a==1 || a==2 || a==3`. This method expands any `in` filter in the given
 * input into a disjunction of equality filters and returns the expanded filter.
 */ function __PRIVATE_computeInExpansion(e) {
    if (__PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter, 20012), e instanceof FieldFilter) {
        if (e instanceof __PRIVATE_InFilter) {
            const t = e.value.arrayValue?.values?.map((t)=>FieldFilter.create(e.field, "==" /* Operator.EQUAL */ , t)) || [];
            return CompositeFilter.create(t, "or" /* CompositeOperator.OR */ );
        }
        // We have reached other kinds of field filters.
        return e;
    }
    // We have a composite filter.
    const t = e.filters.map((e)=>__PRIVATE_computeInExpansion(e));
    return CompositeFilter.create(t, e.op);
}
/**
 * Given a composite filter, returns the list of terms in its disjunctive normal form.
 *
 * <p>Each element in the return value is one term of the resulting DNF. For instance: For the
 * input: (A || B) && C, the DNF form is: (A && C) || (B && C), and the return value is a list
 * with two elements: a composite filter that performs (A && C), and a composite filter that
 * performs (B && C).
 *
 * @param filter - the composite filter to calculate DNF transform for.
 * @returns the terms in the DNF transform.
 */ function __PRIVATE_getDnfTerms(e) {
    if (0 === e.getFilters().length) return [];
    const t = __PRIVATE_computeDistributedNormalForm(__PRIVATE_computeInExpansion(e));
    return __PRIVATE_hardAssert(__PRIVATE_isDisjunctiveNormalForm(t), 7391), __PRIVATE_isSingleFieldFilter(t) || __PRIVATE_isFlatConjunction(t) ? [
        t
    ] : t.getFilters();
}
/** Returns true if the given filter is a single field filter. e.g. (a == 10). */ function __PRIVATE_isSingleFieldFilter(e) {
    return e instanceof FieldFilter;
}
/**
 * Returns true if the given filter is the conjunction of one or more field filters. e.g. (a == 10
 * && b == 20)
 */ function __PRIVATE_isFlatConjunction(e) {
    return e instanceof CompositeFilter && __PRIVATE_compositeFilterIsFlatConjunction(e);
}
/**
 * Returns whether or not the given filter is in disjunctive normal form (DNF).
 *
 * <p>In boolean logic, a disjunctive normal form (DNF) is a canonical normal form of a logical
 * formula consisting of a disjunction of conjunctions; it can also be described as an OR of ANDs.
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Disjunctive_normal_form
 */ function __PRIVATE_isDisjunctiveNormalForm(e) {
    return __PRIVATE_isSingleFieldFilter(e) || __PRIVATE_isFlatConjunction(e) || /**
 * Returns true if the given filter is the disjunction of one or more "flat conjunctions" and
 * field filters. e.g. (a == 10) || (b==20 && c==30)
 */ function __PRIVATE_isDisjunctionOfFieldFiltersAndFlatConjunctions(e) {
        if (e instanceof CompositeFilter && __PRIVATE_compositeFilterIsDisjunction(e)) {
            for (const t of e.getFilters())if (!__PRIVATE_isSingleFieldFilter(t) && !__PRIVATE_isFlatConjunction(t)) return !1;
            return !0;
        }
        return !1;
    }(e);
}
function __PRIVATE_computeDistributedNormalForm(e) {
    if (__PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter, 34018), e instanceof FieldFilter) return e;
    if (1 === e.filters.length) return __PRIVATE_computeDistributedNormalForm(e.filters[0]);
    // Compute DNF for each of the subfilters first
    const t = e.filters.map((e)=>__PRIVATE_computeDistributedNormalForm(e));
    let n = CompositeFilter.create(t, e.op);
    return n = __PRIVATE_applyAssociation(n), __PRIVATE_isDisjunctiveNormalForm(n) ? n : (__PRIVATE_hardAssert(n instanceof CompositeFilter, 64498), __PRIVATE_hardAssert(__PRIVATE_compositeFilterIsConjunction(n), 40251), __PRIVATE_hardAssert(n.filters.length > 1, 57927), n.filters.reduce((e, t)=>__PRIVATE_applyDistribution(e, t)));
}
function __PRIVATE_applyDistribution(e, t) {
    let n;
    return __PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter, 38388), __PRIVATE_hardAssert(t instanceof FieldFilter || t instanceof CompositeFilter, 25473), // FieldFilter FieldFilter
    n = e instanceof FieldFilter ? t instanceof FieldFilter ? function __PRIVATE_applyDistributionFieldFilters(e, t) {
        // Conjunction distribution for two field filters is the conjunction of them.
        return CompositeFilter.create([
            e,
            t
        ], "and" /* CompositeOperator.AND */ );
    }(e, t) : __PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) : t instanceof FieldFilter ? __PRIVATE_applyDistributionFieldAndCompositeFilters(t, e) : function __PRIVATE_applyDistributionCompositeFilters(e, t) {
        // There are four cases:
        // (A & B) & (C & D) --> (A & B & C & D)
        // (A & B) & (C | D) --> (A & B & C) | (A & B & D)
        // (A | B) & (C & D) --> (C & D & A) | (C & D & B)
        // (A | B) & (C | D) --> (A & C) | (A & D) | (B & C) | (B & D)
        // Case 1 is a merge.
        if (__PRIVATE_hardAssert(e.filters.length > 0 && t.filters.length > 0, 48005), __PRIVATE_compositeFilterIsConjunction(e) && __PRIVATE_compositeFilterIsConjunction(t)) return __PRIVATE_compositeFilterWithAddedFilters(e, t.getFilters());
        // Case 2,3,4 all have at least one side (lhs or rhs) that is a disjunction. In all three cases
        // we should take each element of the disjunction and distribute it over the other side, and
        // return the disjunction of the distribution results.
        const n = __PRIVATE_compositeFilterIsDisjunction(e) ? e : t, r = __PRIVATE_compositeFilterIsDisjunction(e) ? t : e, i = n.filters.map((e)=>__PRIVATE_applyDistribution(e, r));
        return CompositeFilter.create(i, "or" /* CompositeOperator.OR */ );
    }(e, t), __PRIVATE_applyAssociation(n);
}
function __PRIVATE_applyDistributionFieldAndCompositeFilters(e, t) {
    // There are two cases:
    // A & (B & C) --> (A & B & C)
    // A & (B | C) --> (A & B) | (A & C)
    if (__PRIVATE_compositeFilterIsConjunction(t)) // Case 1
    return __PRIVATE_compositeFilterWithAddedFilters(t, e.getFilters());
    {
        // Case 2
        const n = t.filters.map((t)=>__PRIVATE_applyDistribution(e, t));
        return CompositeFilter.create(n, "or" /* CompositeOperator.OR */ );
    }
}
/**
 * Applies the associativity property to the given filter and returns the resulting filter.
 *
 * <ul>
 *   <li>A | (B | C) == (A | B) | C == (A | B | C)
 *   <li>A & (B & C) == (A & B) & C == (A & B & C)
 * </ul>
 *
 * <p>For more info, visit: https://en.wikipedia.org/wiki/Associative_property#Propositional_logic
 */ function __PRIVATE_applyAssociation(e) {
    if (__PRIVATE_hardAssert(e instanceof FieldFilter || e instanceof CompositeFilter, 11850), e instanceof FieldFilter) return e;
    const t = e.getFilters();
    // If the composite filter only contains 1 filter, apply associativity to it.
    if (1 === t.length) return __PRIVATE_applyAssociation(t[0]);
    // Associativity applied to a flat composite filter results is itself.
    if (__PRIVATE_compositeFilterIsFlat(e)) return e;
    // First apply associativity to all subfilters. This will in turn recursively apply
    // associativity to all nested composite filters and field filters.
    const n = t.map((e)=>__PRIVATE_applyAssociation(e)), r = [];
    // For composite subfilters that perform the same kind of logical operation as `compositeFilter`
    // take out their filters and add them to `compositeFilter`. For example:
    // compositeFilter = (A | (B | C | D))
    // compositeSubfilter = (B | C | D)
    // Result: (A | B | C | D)
    // Note that the `compositeSubfilter` has been eliminated, and its filters (B, C, D) have been
    // added to the top-level "compositeFilter".
    return n.forEach((t)=>{
        t instanceof FieldFilter ? r.push(t) : t instanceof CompositeFilter && (t.op === e.op ? // compositeFilter: (A | (B | C))
        // compositeSubfilter: (B | C)
        // Result: (A | B | C)
        r.push(...t.filters) : // compositeFilter: (A | (B & C))
        // compositeSubfilter: (B & C)
        // Result: (A | (B & C))
        r.push(t));
    }), 1 === r.length ? r[0] : CompositeFilter.create(r, e.op);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of IndexManager.
 */ class __PRIVATE_MemoryIndexManager {
    constructor(){
        this.Hi = new __PRIVATE_MemoryCollectionParentIndex;
    }
    addToCollectionParentIndex(e, t) {
        return this.Hi.add(t), PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        return PersistencePromise.resolve(this.Hi.getEntries(t));
    }
    addFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve();
    }
    deleteFieldIndex(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve();
    }
    deleteAllFieldIndexes(e) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve();
    }
    createTargetIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve();
    }
    getDocumentsMatchingTarget(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve(null);
    }
    getIndexType(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve(0 /* IndexType.NONE */ );
    }
    getFieldIndexes(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve([]);
    }
    getNextCollectionGroupToUpdate(e) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve(null);
    }
    getMinOffset(e, t) {
        return PersistencePromise.resolve(IndexOffset.min());
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return PersistencePromise.resolve(IndexOffset.min());
    }
    updateCollectionGroup(e, t, n) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve();
    }
    updateIndexEntries(e, t) {
        // Field indices are not supported with memory persistence.
        return PersistencePromise.resolve();
    }
}
/**
 * Internal implementation of the collection-parent index exposed by MemoryIndexManager.
 * Also used for in-memory caching by IndexedDbIndexManager and initial index population
 * in indexeddb_schema.ts
 */ class __PRIVATE_MemoryCollectionParentIndex {
    constructor(){
        this.index = {};
    }
    // Returns false if the entry already existed.
    add(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t] || new SortedSet(ResourcePath.comparator), i = !r.has(n);
        return this.index[t] = r.add(n), i;
    }
    has(e) {
        const t = e.lastSegment(), n = e.popLast(), r = this.index[t];
        return r && r.has(n);
    }
    getEntries(e) {
        return (this.index[e] || new SortedSet(ResourcePath.comparator)).toArray();
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const tn = "IndexedDbIndexManager", nn = new Uint8Array(0);
/**
 * A persisted implementation of IndexManager.
 *
 * PORTING NOTE: Unlike iOS and Android, the Web SDK does not memoize index
 * data as it supports multi-tab access.
 */ class __PRIVATE_IndexedDbIndexManager {
    constructor(e, t){
        this.databaseId = t, /**
         * An in-memory copy of the index entries we've already written since the SDK
         * launched. Used to avoid re-writing the same entry repeatedly.
         *
         * This is *NOT* a complete cache of what's in persistence and so can never be
         * used to satisfy reads.
         */ this.Ji = new __PRIVATE_MemoryCollectionParentIndex, /**
         * Maps from a target to its equivalent list of sub-targets. Each sub-target
         * contains only one term from the target's disjunctive normal form (DNF).
         */ this.Yi = new ObjectMap((e)=>__PRIVATE_canonifyTarget(e), (e, t)=>__PRIVATE_targetEquals(e, t)), this.uid = e.uid || "";
    }
    /**
     * Adds a new entry to the collection parent index.
     *
     * Repeated calls for the same collectionPath should be avoided within a
     * transaction as IndexedDbIndexManager only caches writes once a transaction
     * has been committed.
     */ addToCollectionParentIndex(e, t) {
        if (!this.Ji.has(t)) {
            const n = t.lastSegment(), r = t.popLast();
            e.addOnCommittedListener(()=>{
                // Add the collection to the in memory cache only if the transaction was
                // successfully committed.
                this.Ji.add(t);
            });
            const i = {
                collectionId: n,
                parent: __PRIVATE_encodeResourcePath(r)
            };
            return __PRIVATE_collectionParentsStore(e).put(i);
        }
        return PersistencePromise.resolve();
    }
    getCollectionParents(e, t) {
        const n = [], r = IDBKeyRange.bound([
            t,
            ""
        ], [
            __PRIVATE_immediateSuccessor(t),
            ""
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return __PRIVATE_collectionParentsStore(e).H(r).next((e)=>{
            for (const r of e){
                // This collectionId guard shouldn't be necessary (and isn't as long
                // as we're running in a real browser), but there's a bug in
                // indexeddbshim that breaks our range in our tests running in node:
                // https://github.com/axemclion/IndexedDBShim/issues/334
                if (r.collectionId !== t) break;
                n.push(__PRIVATE_decodeResourcePath(r.parent));
            }
            return n;
        });
    }
    addFieldIndex(e, t) {
        // TODO(indexing): Verify that the auto-incrementing index ID works in
        // Safari & Firefox.
        const n = __PRIVATE_indexConfigurationStore(e), r = function __PRIVATE_toDbIndexConfiguration(e) {
            return {
                indexId: e.indexId,
                collectionGroup: e.collectionGroup,
                fields: e.fields.map((e)=>[
                        e.fieldPath.canonicalString(),
                        e.kind
                    ])
            };
        }(t);
        delete r.indexId;
        // `indexId` is auto-populated by IndexedDb
        const i = n.add(r);
        if (t.indexState) {
            const n = __PRIVATE_indexStateStore(e);
            return i.next((e)=>{
                n.put(__PRIVATE_toDbIndexState(e, this.uid, t.indexState.sequenceNumber, t.indexState.offset));
            });
        }
        return i.next();
    }
    deleteFieldIndex(e, t) {
        const n = __PRIVATE_indexConfigurationStore(e), r = __PRIVATE_indexStateStore(e), i = __PRIVATE_indexEntriesStore(e);
        return n.delete(t.indexId).next(()=>r.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0))).next(()=>i.delete(IDBKeyRange.bound([
                t.indexId
            ], [
                t.indexId + 1
            ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0)));
    }
    deleteAllFieldIndexes(e) {
        const t = __PRIVATE_indexConfigurationStore(e), n = __PRIVATE_indexEntriesStore(e), r = __PRIVATE_indexStateStore(e);
        return t.Z().next(()=>n.Z()).next(()=>r.Z());
    }
    createTargetIndexes(e, t) {
        return PersistencePromise.forEach(this.Zi(t), (t)=>this.getIndexType(e, t).next((n)=>{
                if (0 /* IndexType.NONE */  === n || 1 /* IndexType.PARTIAL */  === n) {
                    const n = new __PRIVATE_TargetIndexMatcher(t).ji();
                    if (null != n) return this.addFieldIndex(e, n);
                }
            }));
    }
    getDocumentsMatchingTarget(e, t) {
        const n = __PRIVATE_indexEntriesStore(e);
        let r = !0;
        const i = new Map;
        return PersistencePromise.forEach(this.Zi(t), (t)=>this.Xi(e, t).next((e)=>{
                r && (r = !!e), i.set(t, e);
            })).next(()=>{
            if (r) {
                let e = __PRIVATE_documentKeySet();
                const r = [];
                return PersistencePromise.forEach(i, (i, s)=>{
                    __PRIVATE_logDebug(tn, `Using index ${function __PRIVATE_fieldIndexToString(e) {
                        return `id=${e.indexId}|cg=${e.collectionGroup}|f=${e.fields.map((e)=>`${e.fieldPath}:${e.kind}`).join(",")}`;
                    }(i)} to execute ${__PRIVATE_canonifyTarget(t)}`);
                    const _ = function __PRIVATE_targetGetArrayValues(e, t) {
                        const n = __PRIVATE_fieldIndexGetArraySegment(t);
                        if (void 0 === n) return null;
                        for (const t of __PRIVATE_targetGetFieldFiltersForPath(e, n.fieldPath))switch(t.op){
                            case "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */ :
                                return t.value.arrayValue.values || [];
                            case "array-contains" /* Operator.ARRAY_CONTAINS */ :
                                return [
                                    t.value
                                ];
                        }
                        return null;
                    }(s, i), o = function __PRIVATE_targetGetNotInValues(e, t) {
                        const n = new Map;
                        for (const r of __PRIVATE_fieldIndexGetDirectionalSegments(t))for (const t of __PRIVATE_targetGetFieldFiltersForPath(e, r.fieldPath))switch(t.op){
                            case "==" /* Operator.EQUAL */ :
                            case "in" /* Operator.IN */ :
                                // Encode equality prefix, which is encoded in the index value before
                                // the inequality (e.g. `a == 'a' && b != 'b'` is encoded to
                                // `value != 'ab'`).
                                n.set(r.fieldPath.canonicalString(), t.value);
                                break;
                            case "not-in" /* Operator.NOT_IN */ :
                            case "!=" /* Operator.NOT_EQUAL */ :
                                // NotIn/NotEqual is always a suffix. There cannot be any remaining
                                // segments and hence we can return early here.
                                return n.set(r.fieldPath.canonicalString(), t.value), Array.from(n.values());
                        }
                        return null;
                    }(s, i), a = function __PRIVATE_targetGetLowerBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve a lower bound if there is a suitable filter or
                        // startAt.
                        for (const i of __PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? __PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.startAt) : __PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.startAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new Bound(n, r);
                    }(s, i), u = function __PRIVATE_targetGetUpperBound(e, t) {
                        const n = [];
                        let r = !0;
                        // For each segment, retrieve an upper bound if there is a suitable filter or
                        // endAt.
                        for (const i of __PRIVATE_fieldIndexGetDirectionalSegments(t)){
                            const t = 0 /* IndexKind.ASCENDING */  === i.kind ? __PRIVATE_targetGetDescendingBound(e, i.fieldPath, e.endAt) : __PRIVATE_targetGetAscendingBound(e, i.fieldPath, e.endAt);
                            n.push(t.value), r && (r = t.inclusive);
                        }
                        return new Bound(n, r);
                    }(s, i), c = this.es(i, s, a), l = this.es(i, s, u), E = this.ts(i, s, o), h = this.ns(i.indexId, _, c, a.inclusive, l, u.inclusive, E);
                    return PersistencePromise.forEach(h, (i)=>n.Y(i, t.limit).next((t)=>{
                            t.forEach((t)=>{
                                const n = DocumentKey.fromSegments(t.documentKey);
                                e.has(n) || (e = e.add(n), r.push(n));
                            });
                        }));
                }).next(()=>r);
            }
            return PersistencePromise.resolve(null);
        });
    }
    Zi(e) {
        let t = this.Yi.get(e);
        if (t) return t;
        if (0 === e.filters.length) t = [
            e
        ];
        else t = __PRIVATE_getDnfTerms(CompositeFilter.create(e.filters, "and" /* CompositeOperator.AND */ )).map((t)=>__PRIVATE_newTarget(e.path, e.collectionGroup, e.orderBy, t.getFilters(), e.limit, e.startAt, e.endAt));
        return this.Yi.set(e, t), t;
    }
    /**
     * Constructs a key range query on `DbIndexEntryStore` that unions all
     * bounds.
     */ ns(e, t, n, r, i, s, _) {
        // The number of total index scans we union together. This is similar to a
        // distributed normal form, but adapted for array values. We create a single
        // index range per value in an ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filter
        // combined with the values from the query bounds.
        const o = (null != t ? t.length : 1) * Math.max(n.length, i.length), a = o / (null != t ? t.length : 1), u = [];
        for(let c = 0; c < o; ++c){
            const o = t ? this.rs(t[c / a]) : nn, l = this.ss(e, o, n[c % a], r), E = this._s(e, o, i[c % a], s), h = _.map((t)=>this.ss(e, o, t, /* inclusive= */ !0));
            u.push(...this.createRange(l, E, h));
        }
        return u;
    }
    /** Generates the lower bound for `arrayValue` and `directionalValue`. */ ss(e, t, n, r) {
        const i = new __PRIVATE_IndexEntry(e, DocumentKey.empty(), t, n);
        return r ? i : i.Li();
    }
    /** Generates the upper bound for `arrayValue` and `directionalValue`. */ _s(e, t, n, r) {
        const i = new __PRIVATE_IndexEntry(e, DocumentKey.empty(), t, n);
        return r ? i.Li() : i;
    }
    Xi(e, t) {
        const n = new __PRIVATE_TargetIndexMatcher(t), r = null != t.collectionGroup ? t.collectionGroup : t.path.lastSegment();
        return this.getFieldIndexes(e, r).next((e)=>{
            // Return the index with the most number of segments.
            let t = null;
            for (const r of e)n.Wi(r) && (!t || r.fields.length > t.fields.length) && (t = r);
            return t;
        });
    }
    getIndexType(e, t) {
        let n = 2 /* IndexType.FULL */ ;
        const r = this.Zi(t);
        return PersistencePromise.forEach(r, (t)=>this.Xi(e, t).next((e)=>{
                e ? 0 /* IndexType.NONE */  !== n && e.fields.length < function __PRIVATE_targetGetSegmentCount(e) {
                    let t = new SortedSet(FieldPath$1.comparator), n = !1;
                    for (const r of e.filters)for (const e of r.getFlattenedFilters())// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    e.field.isKeyField() || // ARRAY_CONTAINS or ARRAY_CONTAINS_ANY filters must be counted separately.
                    // For instance, it is possible to have an index for "a ARRAY a ASC". Even
                    // though these are on the same field, they should be counted as two
                    // separate segments in an index.
                    ("array-contains" /* Operator.ARRAY_CONTAINS */  === e.op || "array-contains-any" /* Operator.ARRAY_CONTAINS_ANY */  === e.op ? n = !0 : t = t.add(e.field));
                    for (const n of e.orderBy)// __name__ is not an explicit segment of any index, so we don't need to
                    // count it.
                    n.field.isKeyField() || (t = t.add(n.field));
                    return t.size + (n ? 1 : 0);
                }(t) && (n = 1 /* IndexType.PARTIAL */ ) : n = 0 /* IndexType.NONE */ ;
            })).next(()=>// OR queries have more than one sub-target (one sub-target per DNF term). We currently consider
            // OR queries that have a `limit` to have a partial index. For such queries we perform sorting
            // and apply the limit in memory as a post-processing step.
            (function __PRIVATE_targetHasLimit(e) {
                return null !== e.limit;
            })(t) && r.length > 1 && 2 /* IndexType.FULL */  === n ? 1 /* IndexType.PARTIAL */  : n);
    }
    /**
     * Returns the byte encoded form of the directional values in the field index.
     * Returns `null` if the document does not have all fields specified in the
     * index.
     */ us(e, t) {
        const n = new __PRIVATE_IndexByteEncoder;
        for (const r of __PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = t.data.field(r.fieldPath);
            if (null == e) return null;
            const i = n.Ci(r.kind);
            __PRIVATE_FirestoreIndexValueWriter.Ei.Yr(e, i);
        }
        return n.Di();
    }
    /** Encodes a single value to the ascending index format. */ rs(e) {
        const t = new __PRIVATE_IndexByteEncoder;
        return __PRIVATE_FirestoreIndexValueWriter.Ei.Yr(e, t.Ci(0 /* IndexKind.ASCENDING */ )), t.Di();
    }
    /**
     * Returns an encoded form of the document key that sorts based on the key
     * ordering of the field index.
     */ cs(e, t) {
        const n = new __PRIVATE_IndexByteEncoder;
        return __PRIVATE_FirestoreIndexValueWriter.Ei.Yr(__PRIVATE_refValue(this.databaseId, t), n.Ci(function __PRIVATE_fieldIndexGetKeyOrder(e) {
            const t = __PRIVATE_fieldIndexGetDirectionalSegments(e);
            return 0 === t.length ? 0 /* IndexKind.ASCENDING */  : t[t.length - 1].kind;
        }(e))), n.Di();
    }
    /**
     * Encodes the given field values according to the specification in `target`.
     * For IN queries, a list of possible values is returned.
     */ ts(e, t, n) {
        if (null === n) return [];
        let r = [];
        r.push(new __PRIVATE_IndexByteEncoder);
        let i = 0;
        for (const s of __PRIVATE_fieldIndexGetDirectionalSegments(e)){
            const e = n[i++];
            for (const n of r)if (this.ls(t, s.fieldPath) && isArray(e)) r = this.Es(r, s, e);
            else {
                const t = n.Ci(s.kind);
                __PRIVATE_FirestoreIndexValueWriter.Ei.Yr(e, t);
            }
        }
        return this.hs(r);
    }
    /**
     * Encodes the given bounds according to the specification in `target`. For IN
     * queries, a list of possible values is returned.
     */ es(e, t, n) {
        return this.ts(e, t, n.position);
    }
    /** Returns the byte representation for the provided encoders. */ hs(e) {
        const t = [];
        for(let n = 0; n < e.length; ++n)t[n] = e[n].Di();
        return t;
    }
    /**
     * Creates a separate encoder for each element of an array.
     *
     * The method appends each value to all existing encoders (e.g. filter("a",
     * "==", "a1").filter("b", "in", ["b1", "b2"]) becomes ["a1,b1", "a1,b2"]). A
     * list of new encoders is returned.
     */ Es(e, t, n) {
        const r = [
            ...e
        ], i = [];
        for (const e of n.arrayValue.values || [])for (const n of r){
            const r = new __PRIVATE_IndexByteEncoder;
            r.seed(n.Di()), __PRIVATE_FirestoreIndexValueWriter.Ei.Yr(e, r.Ci(t.kind)), i.push(r);
        }
        return i;
    }
    ls(e, t) {
        return !!e.filters.find((e)=>e instanceof FieldFilter && e.field.isEqual(t) && ("in" /* Operator.IN */  === e.op || "not-in" /* Operator.NOT_IN */  === e.op));
    }
    getFieldIndexes(e, t) {
        const n = __PRIVATE_indexConfigurationStore(e), r = __PRIVATE_indexStateStore(e);
        return (t ? n.H(ve, IDBKeyRange.bound(t, t)) : n.H()).next((e)=>{
            const t = [];
            return PersistencePromise.forEach(e, (e)=>r.get([
                    e.indexId,
                    this.uid
                ]).next((n)=>{
                    t.push(function __PRIVATE_fromDbIndexConfiguration(e, t) {
                        const n = t ? new IndexState(t.sequenceNumber, new IndexOffset(__PRIVATE_fromDbTimestamp(t.readTime), new DocumentKey(__PRIVATE_decodeResourcePath(t.documentKey)), t.largestBatchId)) : IndexState.empty(), r = e.fields.map(([e, t])=>new IndexSegment(FieldPath$1.fromServerFormat(e), t));
                        return new FieldIndex(e.indexId, e.collectionGroup, r, n);
                    }(e, n));
                })).next(()=>t);
        });
    }
    getNextCollectionGroupToUpdate(e) {
        return this.getFieldIndexes(e).next((e)=>0 === e.length ? null : (e.sort((e, t)=>{
                const n = e.indexState.sequenceNumber - t.indexState.sequenceNumber;
                return 0 !== n ? n : __PRIVATE_primitiveComparator(e.collectionGroup, t.collectionGroup);
            }), e[0].collectionGroup));
    }
    updateCollectionGroup(e, t, n) {
        const r = __PRIVATE_indexConfigurationStore(e), i = __PRIVATE_indexStateStore(e);
        return this.Ts(e).next((e)=>r.H(ve, IDBKeyRange.bound(t, t)).next((t)=>PersistencePromise.forEach(t, (t)=>i.put(__PRIVATE_toDbIndexState(t.indexId, this.uid, e, n)))));
    }
    updateIndexEntries(e, t) {
        // Porting Note: `getFieldIndexes()` on Web does not cache index lookups as
        // it could be used across different IndexedDB transactions. As any cached
        // data might be invalidated by other multi-tab clients, we can only trust
        // data within a single IndexedDB transaction. We therefore add a cache
        // here.
        const n = new Map;
        return PersistencePromise.forEach(t, (t, r)=>{
            const i = n.get(t.collectionGroup);
            return (i ? PersistencePromise.resolve(i) : this.getFieldIndexes(e, t.collectionGroup)).next((i)=>(n.set(t.collectionGroup, i), PersistencePromise.forEach(i, (n)=>this.Ps(e, t, n).next((t)=>{
                        const i = this.Rs(r, n);
                        return t.isEqual(i) ? PersistencePromise.resolve() : this.Is(e, r, n, t, i);
                    }))));
        });
    }
    As(e, t, n, r) {
        return __PRIVATE_indexEntriesStore(e).put(r.Bi(this.uid, this.cs(n, t.key), t.key));
    }
    Vs(e, t, n, r) {
        return __PRIVATE_indexEntriesStore(e).delete(r.Ui(this.uid, this.cs(n, t.key), t.key));
    }
    Ps(e, t, n) {
        const r = __PRIVATE_indexEntriesStore(e);
        let i = new SortedSet(__PRIVATE_indexEntryComparator);
        return r.ee({
            index: Ne,
            range: IDBKeyRange.only([
                n.indexId,
                this.uid,
                __PRIVATE_encodeKeySafeBytes(this.cs(n, t))
            ])
        }, (e, r)=>{
            i = i.add(new __PRIVATE_IndexEntry(n.indexId, t, __PRIVATE_decodeKeySafeBytes(r.arrayValue), __PRIVATE_decodeKeySafeBytes(r.directionalValue)));
        }).next(()=>i);
    }
    /** Creates the index entries for the given document. */ Rs(e, t) {
        let n = new SortedSet(__PRIVATE_indexEntryComparator);
        const r = this.us(t, e);
        if (null == r) return n;
        const i = __PRIVATE_fieldIndexGetArraySegment(t);
        if (null != i) {
            const s = e.data.field(i.fieldPath);
            if (isArray(s)) for (const i of s.arrayValue.values || [])n = n.add(new __PRIVATE_IndexEntry(t.indexId, e.key, this.rs(i), r));
        } else n = n.add(new __PRIVATE_IndexEntry(t.indexId, e.key, nn, r));
        return n;
    }
    /**
     * Updates the index entries for the provided document by deleting entries
     * that are no longer referenced in `newEntries` and adding all newly added
     * entries.
     */ Is(e, t, n, r, i) {
        __PRIVATE_logDebug(tn, "Updating index entries for document '%s'", t.key);
        const s = [];
        return function __PRIVATE_diffSortedSets(e, t, n, r, i) {
            const s = e.getIterator(), _ = t.getIterator();
            let o = __PRIVATE_advanceIterator(s), a = __PRIVATE_advanceIterator(_);
            // Walk through the two sets at the same time, using the ordering defined by
            // `comparator`.
            for(; o || a;){
                let e = !1, t = !1;
                if (o && a) {
                    const r = n(o, a);
                    r < 0 ? // The element was removed if the next element in our ordered
                    // walkthrough is only in `before`.
                    t = !0 : r > 0 && // The element was added if the next element in our ordered walkthrough
                    // is only in `after`.
                    (e = !0);
                } else null != o ? t = !0 : e = !0;
                e ? (r(a), a = __PRIVATE_advanceIterator(_)) : t ? (i(o), o = __PRIVATE_advanceIterator(s)) : (o = __PRIVATE_advanceIterator(s), a = __PRIVATE_advanceIterator(_));
            }
        }(r, i, __PRIVATE_indexEntryComparator, /* onAdd= */ (r)=>{
            s.push(this.As(e, t, n, r));
        }, /* onRemove= */ (r)=>{
            s.push(this.Vs(e, t, n, r));
        }), PersistencePromise.waitFor(s);
    }
    Ts(e) {
        let t = 1;
        return __PRIVATE_indexStateStore(e).ee({
            index: Ce,
            reverse: !0,
            range: IDBKeyRange.upperBound([
                this.uid,
                Number.MAX_SAFE_INTEGER
            ])
        }, (e, n, r)=>{
            r.done(), t = n.sequenceNumber + 1;
        }).next(()=>t);
    }
    /**
     * Returns a new set of IDB ranges that splits the existing range and excludes
     * any values that match the `notInValue` from these ranges. As an example,
     * '[foo > 2 && foo != 3]` becomes  `[foo > 2 && < 3, foo > 3]`.
     */ createRange(e, t, n) {
        // The notIn values need to be sorted and unique so that we can return a
        // sorted set of non-overlapping ranges.
        n = n.sort((e, t)=>__PRIVATE_indexEntryComparator(e, t)).filter((e, t, n)=>!t || 0 !== __PRIVATE_indexEntryComparator(e, n[t - 1]));
        const r = [];
        r.push(e);
        for (const i of n){
            const n = __PRIVATE_indexEntryComparator(i, e), s = __PRIVATE_indexEntryComparator(i, t);
            if (0 === n) // `notInValue` is the lower bound. We therefore need to raise the bound
            // to the next value.
            r[0] = e.Li();
            else if (n > 0 && s < 0) // `notInValue` is in the middle of the range
            r.push(i), r.push(i.Li());
            else if (s > 0) break;
        }
        r.push(t);
        const i = [];
        for(let e = 0; e < r.length; e += 2){
            // If we encounter two bounds that will create an unmatchable key range,
            // then we return an empty set of key ranges.
            if (this.ds(r[e], r[e + 1])) return [];
            const t = r[e].Ui(this.uid, nn, DocumentKey.empty()), n = r[e + 1].Ui(this.uid, nn, DocumentKey.empty());
            i.push(IDBKeyRange.bound(t, n));
        }
        return i;
    }
    ds(e, t) {
        // If lower bound is greater than the upper bound, then the key
        // range can never be matched.
        return __PRIVATE_indexEntryComparator(e, t) > 0;
    }
    getMinOffsetFromCollectionGroup(e, t) {
        return this.getFieldIndexes(e, t).next(__PRIVATE_getMinOffsetFromFieldIndexes);
    }
    getMinOffset(e, t) {
        return PersistencePromise.mapArray(this.Zi(t), (t)=>this.Xi(e, t).next((e)=>e || fail(44426))).next(__PRIVATE_getMinOffsetFromFieldIndexes);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the collectionParents
 * document store.
 */ function __PRIVATE_collectionParentsStore(e) {
    return __PRIVATE_getStore(e, Ae);
}
/**
 * Helper to get a typed SimpleDbStore for the index entry object store.
 */ function __PRIVATE_indexEntriesStore(e) {
    return __PRIVATE_getStore(e, Oe);
}
/**
 * Helper to get a typed SimpleDbStore for the index configuration object store.
 */ function __PRIVATE_indexConfigurationStore(e) {
    return __PRIVATE_getStore(e, we);
}
/**
 * Helper to get a typed SimpleDbStore for the index state object store.
 */ function __PRIVATE_indexStateStore(e) {
    return __PRIVATE_getStore(e, De);
}
function __PRIVATE_getMinOffsetFromFieldIndexes(e) {
    __PRIVATE_hardAssert(0 !== e.length, 28825);
    let t = e[0].indexState.offset, n = t.largestBatchId;
    for(let r = 1; r < e.length; r++){
        const i = e[r].indexState.offset;
        __PRIVATE_indexOffsetComparator(i, t) < 0 && (t = i), n < i.largestBatchId && (n = i.largestBatchId);
    }
    return new IndexOffset(t.readTime, t.documentKey, n);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Delete a mutation batch and the associated document mutations.
 * @returns A PersistencePromise of the document mutations that were removed.
 */ function removeMutationBatch(e, t, n) {
    const r = e.store(H), i = e.store(ee), s = [], _ = IDBKeyRange.only(n.batchId);
    let o = 0;
    const a = r.ee({
        range: _
    }, (e, t, n)=>(o++, n.delete()));
    s.push(a.next(()=>{
        __PRIVATE_hardAssert(1 === o, 47070, {
            batchId: n.batchId
        });
    }));
    const u = [];
    for (const e of n.mutations){
        const r = __PRIVATE_newDbDocumentMutationKey(t, e.key.path, n.batchId);
        s.push(i.delete(r)), u.push(e.key);
    }
    return PersistencePromise.waitFor(s).next(()=>u);
}
/**
 * Returns an approximate size for the given document.
 */ function __PRIVATE_dbDocumentSize(e) {
    if (!e) return 0;
    let t;
    if (e.document) t = e.document;
    else if (e.unknownDocument) t = e.unknownDocument;
    else {
        if (!e.noDocument) throw fail(14731);
        t = e.noDocument;
    }
    return JSON.stringify(t).length;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** A mutation queue for a specific user, backed by IndexedDB. */ class __PRIVATE_IndexedDbMutationQueue {
    constructor(/**
     * The normalized userId (e.g. null UID => "" userId) used to store /
     * retrieve mutations.
     */ e, t, n, r){
        this.userId = e, this.serializer = t, this.indexManager = n, this.referenceDelegate = r, /**
         * Caches the document keys for pending mutation batches. If the mutation
         * has been removed from IndexedDb, the cached value may continue to
         * be used to retrieve the batch's document keys. To remove a cached value
         * locally, `removeCachedMutationKeys()` should be invoked either directly
         * or through `removeMutationBatches()`.
         *
         * With multi-tab, when the primary client acknowledges or rejects a mutation,
         * this cache is used by secondary clients to invalidate the local
         * view of the documents that were previously affected by the mutation.
         */ // PORTING NOTE: Multi-tab only.
        this.fs = {};
    }
    /**
     * Creates a new mutation queue for the given user.
     * @param user - The user for which to create a mutation queue.
     * @param serializer - The serializer to use when persisting to IndexedDb.
     */ static jr(e, t, n, r) {
        // TODO(mcg): Figure out what constraints there are on userIDs
        // In particular, are there any reserved characters? are empty ids allowed?
        // For the moment store these together in the same mutations table assuming
        // that empty userIDs aren't allowed.
        __PRIVATE_hardAssert("" !== e.uid, 64387);
        const i = e.isAuthenticated() ? e.uid : "";
        return new __PRIVATE_IndexedDbMutationQueue(i, t, n, r);
    }
    checkEmpty(e) {
        let t = !0;
        const n = IDBKeyRange.bound([
            this.userId,
            Number.NEGATIVE_INFINITY
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return __PRIVATE_mutationsStore(e).ee({
            index: Y,
            range: n
        }, (e, n, r)=>{
            t = !1, r.done();
        }).next(()=>t);
    }
    addMutationBatch(e, t, n, r) {
        const i = __PRIVATE_documentMutationsStore(e), s = __PRIVATE_mutationsStore(e);
        // The IndexedDb implementation in Chrome (and Firefox) does not handle
        // compound indices that include auto-generated keys correctly. To ensure
        // that the index entry is added correctly in all browsers, we perform two
        // writes: The first write is used to retrieve the next auto-generated Batch
        // ID, and the second write populates the index and stores the actual
        // mutation batch.
        // See: https://bugs.chromium.org/p/chromium/issues/detail?id=701972
        // We write an empty object to obtain key
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return s.add({}).next((_)=>{
            __PRIVATE_hardAssert("number" == typeof _, 49019);
            const o = new MutationBatch(_, t, n, r), a = function __PRIVATE_toDbMutationBatch(e, t, n) {
                const r = n.baseMutations.map((t)=>toMutation(e.zr, t)), i = n.mutations.map((t)=>toMutation(e.zr, t));
                return {
                    userId: t,
                    batchId: n.batchId,
                    localWriteTimeMs: n.localWriteTime.toMillis(),
                    baseMutations: r,
                    mutations: i
                };
            }(this.serializer, this.userId, o), u = [];
            let c = new SortedSet((e, t)=>__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
            for (const e of r){
                const t = __PRIVATE_newDbDocumentMutationKey(this.userId, e.key.path, _);
                c = c.add(e.key.path.popLast()), u.push(s.put(a)), u.push(i.put(t, X));
            }
            return c.forEach((t)=>{
                u.push(this.indexManager.addToCollectionParentIndex(e, t));
            }), e.addOnCommittedListener(()=>{
                this.fs[_] = o.keys();
            }), PersistencePromise.waitFor(u).next(()=>o);
        });
    }
    lookupMutationBatch(e, t) {
        return __PRIVATE_mutationsStore(e).get(t).next((e)=>e ? (__PRIVATE_hardAssert(e.userId === this.userId, 48, "Unexpected user for mutation batch", {
                userId: e.userId,
                batchId: t
            }), __PRIVATE_fromDbMutationBatch(this.serializer, e)) : null);
    }
    /**
     * Returns the document keys for the mutation batch with the given batchId.
     * For primary clients, this method returns `null` after
     * `removeMutationBatches()` has been called. Secondary clients return a
     * cached result until `removeCachedMutationKeys()` is invoked.
     */ // PORTING NOTE: Multi-tab only.
    ps(e, t) {
        return this.fs[t] ? PersistencePromise.resolve(this.fs[t]) : this.lookupMutationBatch(e, t).next((e)=>{
            if (e) {
                const n = e.keys();
                return this.fs[t] = n, n;
            }
            return null;
        });
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = IDBKeyRange.lowerBound([
            this.userId,
            n
        ]);
        let i = null;
        return __PRIVATE_mutationsStore(e).ee({
            index: Y,
            range: r
        }, (e, t, r)=>{
            t.userId === this.userId && (__PRIVATE_hardAssert(t.batchId >= n, 47524, {
                gs: n
            }), i = __PRIVATE_fromDbMutationBatch(this.serializer, t)), r.done();
        }).next(()=>i);
    }
    getHighestUnacknowledgedBatchId(e) {
        const t = IDBKeyRange.upperBound([
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        let n = $;
        return __PRIVATE_mutationsStore(e).ee({
            index: Y,
            range: t,
            reverse: !0
        }, (e, t, r)=>{
            n = t.batchId, r.done();
        }).next(()=>n);
    }
    getAllMutationBatches(e) {
        const t = IDBKeyRange.bound([
            this.userId,
            $
        ], [
            this.userId,
            Number.POSITIVE_INFINITY
        ]);
        return __PRIVATE_mutationsStore(e).H(Y, t).next((e)=>e.map((e)=>__PRIVATE_fromDbMutationBatch(this.serializer, e)));
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        // Scan the document-mutation index starting with a prefix starting with
        // the given documentKey.
        const n = __PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), r = IDBKeyRange.lowerBound(n), i = [];
        return __PRIVATE_documentMutationsStore(e).ee({
            range: r
        }, (n, r, s)=>{
            const [_, o, a] = n, u = __PRIVATE_decodeResourcePath(o);
            // Only consider rows matching exactly the specific key of
            // interest. Note that because we order by path first, and we
            // order terminators before path separators, we'll encounter all
            // the index rows for documentKey contiguously. In particular, all
            // the rows for documentKey will occur before any rows for
            // documents nested in a subcollection beneath documentKey so we
            // can stop as soon as we hit any such row.
            if (_ === this.userId && t.path.isEqual(u)) // Look up the mutation batch in the store.
            return __PRIVATE_mutationsStore(e).get(a).next((e)=>{
                if (!e) throw fail(61480, {
                    ys: n,
                    batchId: a
                });
                __PRIVATE_hardAssert(e.userId === this.userId, 10503, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: a
                }), i.push(__PRIVATE_fromDbMutationBatch(this.serializer, e));
            });
            s.done();
        }).next(()=>i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new SortedSet(__PRIVATE_primitiveComparator);
        const r = [];
        return t.forEach((t)=>{
            const i = __PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, t.path), s = IDBKeyRange.lowerBound(i), _ = __PRIVATE_documentMutationsStore(e).ee({
                range: s
            }, (e, r, i)=>{
                const [s, _, o] = e, a = __PRIVATE_decodeResourcePath(_);
                // Only consider rows matching exactly the specific key of
                // interest. Note that because we order by path first, and we
                // order terminators before path separators, we'll encounter all
                // the index rows for documentKey contiguously. In particular, all
                // the rows for documentKey will occur before any rows for
                // documents nested in a subcollection beneath documentKey so we
                // can stop as soon as we hit any such row.
                s === this.userId && t.path.isEqual(a) ? n = n.add(o) : i.done();
            });
            r.push(_);
        }), PersistencePromise.waitFor(r).next(()=>this.ws(e, n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        const n = t.path, r = n.length + 1, i = __PRIVATE_newDbDocumentMutationPrefixForPath(this.userId, n), s = IDBKeyRange.lowerBound(i);
        // Collect up unique batchIDs encountered during a scan of the index. Use a
        // SortedSet to accumulate batch IDs so they can be traversed in order in a
        // scan of the main table.
        let _ = new SortedSet(__PRIVATE_primitiveComparator);
        return __PRIVATE_documentMutationsStore(e).ee({
            range: s
        }, (e, t, i)=>{
            const [s, o, a] = e, u = __PRIVATE_decodeResourcePath(o);
            s === this.userId && n.isPrefixOf(u) ? // Rows with document keys more than one segment longer than the
            // query path can't be matches. For example, a query on 'rooms'
            // can't match the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            u.length === r && (_ = _.add(a)) : i.done();
        }).next(()=>this.ws(e, _));
    }
    ws(e, t) {
        const n = [], r = [];
        // TODO(rockwood): Implement this using iterate.
        return t.forEach((t)=>{
            r.push(__PRIVATE_mutationsStore(e).get(t).next((e)=>{
                if (null === e) throw fail(35274, {
                    batchId: t
                });
                __PRIVATE_hardAssert(e.userId === this.userId, 9748, "Unexpected user for mutation batch", {
                    userId: e.userId,
                    batchId: t
                }), n.push(__PRIVATE_fromDbMutationBatch(this.serializer, e));
            }));
        }), PersistencePromise.waitFor(r).next(()=>n);
    }
    removeMutationBatch(e, t) {
        return removeMutationBatch(e.le, this.userId, t).next((n)=>(e.addOnCommittedListener(()=>{
                this.bs(t.batchId);
            }), PersistencePromise.forEach(n, (t)=>this.referenceDelegate.markPotentiallyOrphaned(e, t))));
    }
    /**
     * Clears the cached keys for a mutation batch. This method should be
     * called by secondary clients after they process mutation updates.
     *
     * Note that this method does not have to be called from primary clients as
     * the corresponding cache entries are cleared when an acknowledged or
     * rejected batch is removed from the mutation queue.
     */ // PORTING NOTE: Multi-tab only
    bs(e) {
        delete this.fs[e];
    }
    performConsistencyCheck(e) {
        return this.checkEmpty(e).next((t)=>{
            if (!t) return PersistencePromise.resolve();
            // Verify that there are no entries in the documentMutations index if
            // the queue is empty.
            const n = IDBKeyRange.lowerBound(/**
 * Creates a [userId] key for use in the DbDocumentMutations index to iterate
 * over all of a user's document mutations.
 */ function __PRIVATE_newDbDocumentMutationPrefixForUser(e) {
                return [
                    e
                ];
            }(this.userId)), r = [];
            return __PRIVATE_documentMutationsStore(e).ee({
                range: n
            }, (e, t, n)=>{
                if (e[0] === this.userId) {
                    const t = __PRIVATE_decodeResourcePath(e[1]);
                    r.push(t);
                } else n.done();
            }).next(()=>{
                __PRIVATE_hardAssert(0 === r.length, 56720, {
                    vs: r.map((e)=>e.canonicalString())
                });
            });
        });
    }
    containsKey(e, t) {
        return __PRIVATE_mutationQueueContainsKey(e, this.userId, t);
    }
    // PORTING NOTE: Multi-tab only (state is held in memory in other clients).
    /** Returns the mutation queue's metadata from IndexedDb. */ Ss(e) {
        return __PRIVATE_mutationQueuesStore(e).get(this.userId).next((e)=>e || {
                userId: this.userId,
                lastAcknowledgedBatchId: $,
                lastStreamToken: ""
            });
    }
}
/**
 * @returns true if the mutation queue for the given user contains a pending
 *         mutation for the given key.
 */ function __PRIVATE_mutationQueueContainsKey(e, t, n) {
    const r = __PRIVATE_newDbDocumentMutationPrefixForPath(t, n.path), i = r[1], s = IDBKeyRange.lowerBound(r);
    let _ = !1;
    return __PRIVATE_documentMutationsStore(e).ee({
        range: s,
        X: !0
    }, (e, n, r)=>{
        const [s, o, /*batchID*/ a] = e;
        s === t && o === i && (_ = !0), r.done();
    }).next(()=>_);
}
/** Returns true if any mutation queue contains the given document. */ /**
 * Helper to get a typed SimpleDbStore for the mutations object store.
 */ function __PRIVATE_mutationsStore(e) {
    return __PRIVATE_getStore(e, H);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function __PRIVATE_documentMutationsStore(e) {
    return __PRIVATE_getStore(e, ee);
}
/**
 * Helper to get a typed SimpleDbStore for the mutationQueues object store.
 */ function __PRIVATE_mutationQueuesStore(e) {
    return __PRIVATE_getStore(e, z);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Offset to ensure non-overlapping target ids. */ /**
 * Generates monotonically increasing target IDs for sending targets to the
 * watch stream.
 *
 * The client constructs two generators, one for the target cache, and one for
 * for the sync engine (to generate limbo documents targets). These
 * generators produce non-overlapping IDs (by using even and odd IDs
 * respectively).
 *
 * By separating the target ID space, the query cache can generate target IDs
 * that persist across client restarts, while sync engine can independently
 * generate in-memory target IDs that are transient and can be reused after a
 * restart.
 */ class __PRIVATE_TargetIdGenerator {
    constructor(e){
        this.Ds = e;
    }
    next() {
        return this.Ds += 2, this.Ds;
    }
    static xs() {
        // The target cache generator must return '2' in its first call to `next()`
        // as there is no differentiation in the protocol layer between an unset
        // number and the number '0'. If we were to sent a target with target ID
        // '0', the backend would consider it unset and replace it with its own ID.
        return new __PRIVATE_TargetIdGenerator(0);
    }
    static Cs() {
        // Sync engine assigns target IDs for limbo document detection.
        return new __PRIVATE_TargetIdGenerator(-1);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_IndexedDbTargetCache {
    constructor(e, t){
        this.referenceDelegate = e, this.serializer = t;
    }
    // PORTING NOTE: We don't cache global metadata for the target cache, since
    // some of it (in particular `highestTargetId`) can be modified by secondary
    // tabs. We could perhaps be more granular (and e.g. still cache
    // `lastRemoteSnapshotVersion` in memory) but for simplicity we currently go
    // to IndexedDb whenever we need to read metadata. We can revisit if it turns
    // out to have a meaningful performance impact.
    allocateTargetId(e) {
        return this.Fs(e).next((t)=>{
            const n = new __PRIVATE_TargetIdGenerator(t.highestTargetId);
            return t.highestTargetId = n.next(), this.Os(e, t).next(()=>t.highestTargetId);
        });
    }
    getLastRemoteSnapshotVersion(e) {
        return this.Fs(e).next((e)=>SnapshotVersion.fromTimestamp(new Timestamp(e.lastRemoteSnapshotVersion.seconds, e.lastRemoteSnapshotVersion.nanoseconds)));
    }
    getHighestSequenceNumber(e) {
        return this.Fs(e).next((e)=>e.highestListenSequenceNumber);
    }
    setTargetsMetadata(e, t, n) {
        return this.Fs(e).next((r)=>(r.highestListenSequenceNumber = t, n && (r.lastRemoteSnapshotVersion = n.toTimestamp()), t > r.highestListenSequenceNumber && (r.highestListenSequenceNumber = t), this.Os(e, r)));
    }
    addTargetData(e, t) {
        return this.Ms(e, t).next(()=>this.Fs(e).next((n)=>(n.targetCount += 1, this.Ns(t, n), this.Os(e, n))));
    }
    updateTargetData(e, t) {
        return this.Ms(e, t);
    }
    removeTargetData(e, t) {
        return this.removeMatchingKeysForTargetId(e, t.targetId).next(()=>__PRIVATE_targetsStore(e).delete(t.targetId)).next(()=>this.Fs(e)).next((t)=>(__PRIVATE_hardAssert(t.targetCount > 0, 8065), t.targetCount -= 1, this.Os(e, t)));
    }
    /**
     * Drops any targets with sequence number less than or equal to the upper bound, excepting those
     * present in `activeTargetIds`. Document associations for the removed targets are also removed.
     * Returns the number of targets removed.
     */ removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return __PRIVATE_targetsStore(e).ee((s, _)=>{
            const o = __PRIVATE_fromDbTarget(this.serializer, _);
            o.sequenceNumber <= t && null === n.get(o.targetId) && (r++, i.push(this.removeTargetData(e, o)));
        }).next(()=>PersistencePromise.waitFor(i)).next(()=>r);
    }
    /**
     * Call provided function with each `TargetData` that we have cached.
     */ forEachTarget(e, t) {
        return __PRIVATE_targetsStore(e).ee((e, n)=>{
            const r = __PRIVATE_fromDbTarget(this.serializer, n);
            t(r);
        });
    }
    Fs(e) {
        return __PRIVATE_globalTargetStore(e).get(Re).next((e)=>(__PRIVATE_hardAssert(null !== e, 2888), e));
    }
    Os(e, t) {
        return __PRIVATE_globalTargetStore(e).put(Re, t);
    }
    Ms(e, t) {
        return __PRIVATE_targetsStore(e).put(__PRIVATE_toDbTarget(this.serializer, t));
    }
    /**
     * In-place updates the provided metadata to account for values in the given
     * TargetData. Saving is done separately. Returns true if there were any
     * changes to the metadata.
     */ Ns(e, t) {
        let n = !1;
        return e.targetId > t.highestTargetId && (t.highestTargetId = e.targetId, n = !0), e.sequenceNumber > t.highestListenSequenceNumber && (t.highestListenSequenceNumber = e.sequenceNumber, n = !0), n;
    }
    getTargetCount(e) {
        return this.Fs(e).next((e)=>e.targetCount);
    }
    getTargetData(e, t) {
        // Iterating by the canonicalId may yield more than one result because
        // canonicalId values are not required to be unique per target. This query
        // depends on the queryTargets index to be efficient.
        const n = __PRIVATE_canonifyTargetOrPipeline(t), r = IDBKeyRange.bound([
            n,
            Number.NEGATIVE_INFINITY
        ], [
            n,
            Number.POSITIVE_INFINITY
        ]);
        let i = null;
        return __PRIVATE_targetsStore(e).ee({
            range: r,
            index: ce
        }, (e, n, r)=>{
            const s = __PRIVATE_fromDbTarget(this.serializer, n);
            // After finding a potential match, check that the target is
            // actually equal to the requested target.
            __PRIVATE_targetOrPipelineEqual(t, s.target) && (i = s, r.done());
        }).next(()=>i);
    }
    addMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = [], i = __PRIVATE_documentTargetStore(e);
        return t.forEach((t)=>{
            const s = __PRIVATE_encodeResourcePath(t.path);
            r.push(i.put({
                targetId: n,
                path: s
            })), r.push(this.referenceDelegate.addReference(e, n, t));
        }), PersistencePromise.waitFor(r);
    }
    removeMatchingKeys(e, t, n) {
        // PORTING NOTE: The reverse index (documentsTargets) is maintained by
        // IndexedDb.
        const r = __PRIVATE_documentTargetStore(e);
        return PersistencePromise.forEach(t, (t)=>{
            const i = __PRIVATE_encodeResourcePath(t.path);
            return PersistencePromise.waitFor([
                r.delete([
                    n,
                    i
                ]),
                this.referenceDelegate.removeReference(e, n, t)
            ]);
        });
    }
    removeMatchingKeysForTargetId(e, t) {
        const n = __PRIVATE_documentTargetStore(e), r = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        return n.delete(r);
    }
    getMatchingKeysForTargetId(e, t) {
        const n = IDBKeyRange.bound([
            t
        ], [
            t + 1
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0), r = __PRIVATE_documentTargetStore(e);
        let i = __PRIVATE_documentKeySet();
        return r.ee({
            range: n,
            X: !0
        }, (e, t, n)=>{
            const r = __PRIVATE_decodeResourcePath(e[1]), s = new DocumentKey(r);
            i = i.add(s);
        }).next(()=>i);
    }
    containsKey(e, t) {
        const n = __PRIVATE_encodeResourcePath(t.path), r = IDBKeyRange.bound([
            n
        ], [
            __PRIVATE_immediateSuccessor(n)
        ], /*lowerOpen=*/ !1, /*upperOpen=*/ !0);
        let i = 0;
        return __PRIVATE_documentTargetStore(e).ee({
            index: Te,
            X: !0,
            range: r
        }, ([e, t], n, r)=>{
            // Having a sentinel row for a document does not count as containing that document;
            // For the target cache, containing the document means the document is part of some
            // target.
            0 !== e && (i++, r.done());
        }).next(()=>i > 0);
    }
    /**
     * Looks up a TargetData entry by target ID.
     *
     * @param targetId - The target ID of the TargetData entry to look up.
     * @returns The cached TargetData entry, or null if the cache has no entry for
     * the target.
     */ // PORTING NOTE: Multi-tab only.
    dt(e, t) {
        return __PRIVATE_targetsStore(e).get(t).next((e)=>e ? __PRIVATE_fromDbTarget(this.serializer, e) : null);
    }
}
/**
 * Helper to get a typed SimpleDbStore for the queries object store.
 */ function __PRIVATE_targetsStore(e) {
    return __PRIVATE_getStore(e, ue);
}
/**
 * Helper to get a typed SimpleDbStore for the target globals object store.
 */ function __PRIVATE_globalTargetStore(e) {
    return __PRIVATE_getStore(e, Ie);
}
/**
 * Helper to get a typed SimpleDbStore for the document target object store.
 */ function __PRIVATE_documentTargetStore(e) {
    return __PRIVATE_getStore(e, Ee);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Provides LRU functionality for IndexedDB persistence. */ class __PRIVATE_IndexedDbLruDelegateImpl {
    constructor(e, t){
        this.db = e, this.garbageCollector = __PRIVATE_newLruGarbageCollector(this, t);
    }
    lr(e) {
        const t = this.Ls(e);
        return this.db.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    Ls(e) {
        let t = 0;
        return this.Er(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    forEachTarget(e, t) {
        return this.db.getTargetCache().forEachTarget(e, t);
    }
    Er(e, t) {
        return this.Bs(e, (e, n)=>t(n));
    }
    addReference(e, t, n) {
        return __PRIVATE_writeSentinelKey(e, n);
    }
    removeReference(e, t, n) {
        return __PRIVATE_writeSentinelKey(e, n);
    }
    removeTargets(e, t, n) {
        return this.db.getTargetCache().removeTargets(e, t, n);
    }
    markPotentiallyOrphaned(e, t) {
        return __PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Returns true if anything would prevent this document from being garbage
     * collected, given that the document in question is not present in any
     * targets and has a sequence number less than or equal to the upper bound for
     * the collection run.
     */ Us(e, t) {
        return function __PRIVATE_mutationQueuesContainKey(e, t) {
            let n = !1;
            return __PRIVATE_mutationQueuesStore(e).te((r)=>__PRIVATE_mutationQueueContainsKey(e, r, t).next((e)=>(e && (n = !0), PersistencePromise.resolve(!e)))).next(()=>n);
        }(e, t);
    }
    removeOrphanedDocuments(e, t) {
        const n = this.db.getRemoteDocumentCache().newChangeBuffer(), r = [];
        let i = 0;
        return this.Bs(e, (s, _)=>{
            if (_ <= t) {
                const t = this.Us(e, s).next((t)=>{
                    if (!t) // Our size accounting requires us to read all documents before
                    // removing them.
                    return i++, n.getEntry(e, s).next(()=>(n.removeEntry(s, SnapshotVersion.min()), __PRIVATE_documentTargetStore(e).delete(function __PRIVATE_sentinelKey$1(e) {
                            return [
                                0,
                                __PRIVATE_encodeResourcePath(e.path)
                            ];
                        }(s))));
                });
                r.push(t);
            }
        }).next(()=>PersistencePromise.waitFor(r)).next(()=>n.apply(e)).next(()=>i);
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.db.getTargetCache().updateTargetData(e, n);
    }
    updateLimboDocument(e, t) {
        return __PRIVATE_writeSentinelKey(e, t);
    }
    /**
     * Call provided function for each document in the cache that is 'orphaned'. Orphaned
     * means not a part of any target, so the only entry in the target-document index for
     * that document will be the sentinel row (targetId 0), which will also have the sequence
     * number for the last time the document was accessed.
     */ Bs(e, t) {
        const n = __PRIVATE_documentTargetStore(e);
        let r, i = __PRIVATE_ListenSequence.ce;
        return n.ee({
            index: Te
        }, ([e, n], { path: s, sequenceNumber: _ })=>{
            0 === e ? // if nextToReport is valid, report it, this is a new key so the
            // last one must not be a member of any targets.
            (i !== __PRIVATE_ListenSequence.ce && t(new DocumentKey(__PRIVATE_decodeResourcePath(r)), i), // set nextToReport to be this sequence number. It's the next one we
            // might report, if we don't find any targets for this document.
            // Note that the sequence number must be defined when the targetId
            // is 0.
            i = _, r = s) : // set nextToReport to be invalid, we know we don't need to report
            // this one since we found a target for it.
            i = __PRIVATE_ListenSequence.ce;
        }).next(()=>{
            // Since we report sequence numbers after getting to the next key, we
            // need to check if the last key we iterated over was an orphaned
            // document and report it.
            i !== __PRIVATE_ListenSequence.ce && t(new DocumentKey(__PRIVATE_decodeResourcePath(r)), i);
        });
    }
    getCacheSize(e) {
        return this.db.getRemoteDocumentCache().getSize(e);
    }
}
function __PRIVATE_writeSentinelKey(e, t) {
    return __PRIVATE_documentTargetStore(e).put(function __PRIVATE_sentinelRow(e, t) {
        return {
            targetId: 0,
            path: __PRIVATE_encodeResourcePath(e.path),
            sequenceNumber: t
        };
    }(t, e.currentSequenceNumber));
}
// Copyright 2024 Google LLC* @license
function __PRIVATE_runPipeline(e, t) {
    let n = t;
    for (const t of e.stages)n = evaluate({
        serializer: e.serializer,
        serverTimestampBehavior: e.listenOptions?.serverTimestampBehavior
    }, t, n);
    return n;
}
function __PRIVATE_pipelineMatches(e, t) {
    // TODO(pipeline): this is not true for aggregations, and we need to examine if there are other
    // stages that will not work this way.
    return __PRIVATE_runPipeline(e, [
        t
    ]).length > 0;
}
function __PRIVATE_queryOrPipelineMatches(e, t) {
    return __PRIVATE_isPipeline(e) ? __PRIVATE_pipelineMatches(e, t) : __PRIVATE_queryMatches(e, t);
}
function evaluate(e, t, n) {
    if (t instanceof __PRIVATE_CollectionSource) return function __PRIVATE_evaluateCollection(e, t, n) {
        return n.filter((e)=>e.isFoundDocument() && `/${e.key.getCollectionPath().canonicalString()}` === t.Vr);
    }(0, t, n);
    if (t instanceof __PRIVATE_Where) return function __PRIVATE_evaluateWhere(e, t, n) {
        return n.filter((n)=>{
            const r = __PRIVATE_valueOrUndefined(__PRIVATE_toEvaluable(t.condition).evaluate(e, n));
            return void 0 !== r && __PRIVATE_valueEquals$1(r, Et);
        });
    }(e, t, n);
    if (t instanceof __PRIVATE_CollectionGroupSource) return function __PRIVATE_evaluateCollectionGroup(e, t, n) {
        // return those records in input whose collection id is stage.collectionId
        return n.filter((e)=>e.isFoundDocument() && e.key.getCollectionPath().lastSegment() === t.collectionId);
    }(0, t, n);
    if (t instanceof __PRIVATE_DatabaseSource) return function __PRIVATE_evaluateDatabase(e, t, n) {
        return n.filter((e)=>e.isFoundDocument());
    }(0, 0, n);
    if (t instanceof __PRIVATE_DocumentsSource) return function __PRIVATE_evaluateDocuments(e, t, n) {
        return n.filter((e)=>e.isFoundDocument() && t.mr.has(e.key.path.toStringWithLeadingSlash()));
    }(0, t, n);
    if (t instanceof __PRIVATE_Limit) return function __PRIVATE_evaluateLimit(e, t, n) {
        return n.slice(0, t.limit);
    }(0, t, n);
    if (t instanceof __PRIVATE_Sort) return function __PRIVATE_evaluateSort(e, t, n) {
        const r = t.orderings.map((e)=>({
                ks: __PRIVATE_toEvaluable(e.expr),
                direction: e.direction
            }));
        return [
            ...n
        ].sort((t, n)=>{
            // Evaluate expressions in stage.orderings against left and right, and use them to compare
            // the documents
            for (const { ks: i, direction: s } of r){
                const r = __PRIVATE_valueOrUndefined(i.evaluate(e, t)), _ = __PRIVATE_valueOrUndefined(i.evaluate(e, n)), o = __PRIVATE_valueCompare(r ?? lt, _ ?? lt);
                if (0 !== o) // Return the comparison result if documents are not equal
                return "ascending" === s ? o : -o;
            }
            return 0;
        });
    }(e, t, n);
    throw new Error(`Unknown stage: ${t._name}`);
}
function __PRIVATE_newPipelineComparator(e) {
    const t = function __PRIVATE_lastEffectiveSort(e) {
        // return the last sort stage, throws exception if it doesn't exist
        // TODO(pipeline): this implementation is wrong, there are stages that can invalidate
        // the orderings later. The proper way to manipulate the pipeline so that last Sort
        // always has effects.
        for(let t = e.stages.length - 1; t >= 0; t--){
            const n = e.stages[t];
            if (n instanceof __PRIVATE_Sort) return n.orderings;
        }
        throw new Error("Pipeline must contain at least one Sort stage");
    }(e);
    return (n, r)=>{
        for (const i of t){
            // TODO(pipeline): consider the possibility of memoizing the evaluation
            const t = __PRIVATE_valueOrUndefined(__PRIVATE_toEvaluable(i.expr).evaluate({
                serializer: e.serializer
            }, n)), s = __PRIVATE_valueOrUndefined(__PRIVATE_toEvaluable(i.expr).evaluate({
                serializer: e.serializer
            }, r)), _ = __PRIVATE_valueCompare(t || lt, s || lt);
            if (0 !== _) return "ascending" === i.direction ? _ : -_;
        }
        return 0;
    };
}
function __PRIVATE_getLastEffectiveLimit(e) {
    // TODO(pipeline): Consider other stages that might imply a limit,
    // e.g., FindNearestStage, once they are implemented.
    for(let t = e.stages.length - 1; t >= 0; t--){
        const n = e.stages[t];
        if (n instanceof __PRIVATE_Limit) return {
            limit: n.limit
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory buffer of entries to be written to a RemoteDocumentCache.
 * It can be used to batch up a set of changes to be written to the cache, but
 * additionally supports reading entries back with the `getEntry()` method,
 * falling back to the underlying RemoteDocumentCache if no entry is
 * buffered.
 *
 * Entries added to the cache *must* be read first. This is to facilitate
 * calculating the size delta of the pending changes.
 *
 * PORTING NOTE: This class was implemented then removed from other platforms.
 * If byte-counting ends up being needed on the other platforms, consider
 * porting this class as part of that implementation work.
 */ class RemoteDocumentChangeBuffer {
    constructor(){
        // A mapping of document key to the new cache entry that should be written.
        this.changes = new ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t)), this.changesApplied = !1;
    }
    /**
     * Buffers a `RemoteDocumentCache.addEntry()` call.
     *
     * You can only modify documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ addEntry(e) {
        this.assertNotApplied(), this.changes.set(e.key, e);
    }
    /**
     * Buffers a `RemoteDocumentCache.removeEntry()` call.
     *
     * You can only remove documents that have already been retrieved via
     * `getEntry()/getEntries()` (enforced via IndexedDbs `apply()`).
     */ removeEntry(e, t) {
        this.assertNotApplied(), this.changes.set(e, MutableDocument.newInvalidDocument(e).setReadTime(t));
    }
    /**
     * Looks up an entry in the cache. The buffered changes will first be checked,
     * and if no buffered change applies, this will forward to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document or an invalid document if we have nothing
     * cached.
     */ getEntry(e, t) {
        this.assertNotApplied();
        const n = this.changes.get(t);
        return void 0 !== n ? PersistencePromise.resolve(n) : this.getFromCache(e, t);
    }
    /**
     * Looks up several entries in the cache, forwarding to
     * `RemoteDocumentCache.getEntry()`.
     *
     * @param transaction - The transaction in which to perform any persistence
     *     operations.
     * @param documentKeys - The keys of the entries to look up.
     * @returns A map of cached documents, indexed by key. If an entry cannot be
     *     found, the corresponding key will be mapped to an invalid document.
     */ getEntries(e, t) {
        return this.getAllFromCache(e, t);
    }
    /**
     * Applies buffered changes to the underlying RemoteDocumentCache, using
     * the provided transaction.
     */ apply(e) {
        return this.assertNotApplied(), this.changesApplied = !0, this.applyChanges(e);
    }
    /** Helper to assert this.changes is not null  */ assertNotApplied() {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newIndexedDbRemoteDocumentCache()`.
 */ class __PRIVATE_IndexedDbRemoteDocumentCacheImpl {
    constructor(e){
        this.serializer = e;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entries to the cache.
     *
     * All calls of `addEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ addEntry(e, t, n) {
        return __PRIVATE_remoteDocumentsStore(e).put(n);
    }
    /**
     * Removes a document from the cache.
     *
     * All calls of `removeEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()` to ensure proper accounting of metadata.
     */ removeEntry(e, t, n) {
        return __PRIVATE_remoteDocumentsStore(e).delete(/**
 * Returns a key that can be used for document lookups via the primary key of
 * the DbRemoteDocument object store.
 */ function __PRIVATE_dbReadTimeKey(e, t) {
            const n = e.path.toArray();
            return [
                /* prefix path */ n.slice(0, n.length - 2),
                /* collection id */ n[n.length - 2],
                __PRIVATE_toDbTimestampKey(t),
                /* document id */ n[n.length - 1]
            ];
        }(t, n));
    }
    /**
     * Updates the current cache size.
     *
     * Callers to `addEntry()` and `removeEntry()` *must* call this afterwards to update the
     * cache's metadata.
     */ updateMetadata(e, t) {
        return this.getMetadata(e).next((n)=>(n.byteSize += t, this.qs(e, n)));
    }
    getEntry(e, t) {
        let n = MutableDocument.newInvalidDocument(t);
        return __PRIVATE_remoteDocumentsStore(e).ee({
            index: re,
            range: IDBKeyRange.only(__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = this.$s(t, r);
        }).next(()=>n);
    }
    /**
     * Looks up an entry in the cache.
     *
     * @param documentKey - The key of the entry to look up.
     * @returns The cached document entry and its size.
     */ Ks(e, t) {
        let n = {
            size: 0,
            document: MutableDocument.newInvalidDocument(t)
        };
        return __PRIVATE_remoteDocumentsStore(e).ee({
            index: re,
            range: IDBKeyRange.only(__PRIVATE_dbKey(t))
        }, (e, r)=>{
            n = {
                document: this.$s(t, r),
                size: __PRIVATE_dbDocumentSize(r)
            };
        }).next(()=>n);
    }
    getEntries(e, t) {
        let n = __PRIVATE_mutableDocumentMap();
        return this.Ws(e, t, (e, t)=>{
            const r = this.$s(e, t);
            n = n.insert(e, r);
        }).next(()=>n);
    }
    getAllEntries(e) {
        let t = __PRIVATE_mutableDocumentMap();
        return __PRIVATE_remoteDocumentsStore(e).ee((e, n)=>{
            const r = this.$s(DocumentKey.fromSegments(n.prefixPath.concat(n.collectionGroup, n.documentId)), n);
            t = t.insert(r.key, r);
        }).next(()=>t);
    }
    /**
     * Looks up several entries in the cache.
     *
     * @param documentKeys - The set of keys entries to look up.
     * @returns A map of documents indexed by key and a map of sizes indexed by
     *     key (zero if the document does not exist).
     */ Qs(e, t) {
        let n = __PRIVATE_mutableDocumentMap(), r = new SortedMap(DocumentKey.comparator);
        return this.Ws(e, t, (e, t)=>{
            const i = this.$s(e, t);
            n = n.insert(e, i), r = r.insert(e, __PRIVATE_dbDocumentSize(t));
        }).next(()=>({
                documents: n,
                Gs: r
            }));
    }
    Ws(e, t, n) {
        if (t.isEmpty()) return PersistencePromise.resolve();
        let r = new SortedSet(__PRIVATE_dbKeyComparator);
        t.forEach((e)=>r = r.add(e));
        const i = IDBKeyRange.bound(__PRIVATE_dbKey(r.first()), __PRIVATE_dbKey(r.last())), s = r.getIterator();
        let _ = s.getNext();
        return __PRIVATE_remoteDocumentsStore(e).ee({
            index: re,
            range: i
        }, (e, t, r)=>{
            const i = DocumentKey.fromSegments([
                ...t.prefixPath,
                t.collectionGroup,
                t.documentId
            ]);
            // Go through keys not found in cache.
            for(; _ && __PRIVATE_dbKeyComparator(_, i) < 0;)n(_, null), _ = s.getNext();
            _ && _.isEqual(i) && // Key found in cache.
            (n(_, t), _ = s.hasNext() ? s.getNext() : null), // Skip to the next key (if there is one).
            _ ? r.j(__PRIVATE_dbKey(_)) : r.done();
        }).next(()=>{
            // The rest of the keys are not in the cache. One case where `iterate`
            // above won't go through them is when the cache is empty.
            for(; _;)n(_, null), _ = s.hasNext() ? s.getNext() : null;
        });
    }
    getDocumentsMatchingQuery(e, t, n, r, i) {
        const s = __PRIVATE_isPipeline(t) ? ResourcePath.fromString(getPipelineCollection(t)) : t.path, _ = [
            s.popLast().toArray(),
            s.lastSegment(),
            __PRIVATE_toDbTimestampKey(n.readTime),
            n.documentKey.path.isEmpty() ? "" : n.documentKey.path.lastSegment()
        ], o = [
            s.popLast().toArray(),
            s.lastSegment(),
            [
                Number.MAX_SAFE_INTEGER,
                Number.MAX_SAFE_INTEGER
            ],
            ""
        ];
        return __PRIVATE_remoteDocumentsStore(e).H(IDBKeyRange.bound(_, o, !0)).next((e)=>{
            i?.incrementDocumentReadCount(e.length);
            let n = __PRIVATE_mutableDocumentMap();
            for (const i of e){
                const e = this.$s(DocumentKey.fromSegments(i.prefixPath.concat(i.collectionGroup, i.documentId)), i);
                e.isFoundDocument() && (__PRIVATE_queryOrPipelineMatches(t, e) || r.has(e.key)) && // Either the document matches the given query, or it is mutated.
                (n = n.insert(e.key, e));
            }
            return n;
        });
    }
    getAllFromCollectionGroup(e, t, n, r) {
        let i = __PRIVATE_mutableDocumentMap();
        const s = __PRIVATE_dbCollectionGroupKey(t, n), _ = __PRIVATE_dbCollectionGroupKey(t, IndexOffset.max());
        return __PRIVATE_remoteDocumentsStore(e).ee({
            index: se,
            range: IDBKeyRange.bound(s, _, !0)
        }, (e, t, n)=>{
            const s = this.$s(DocumentKey.fromSegments(t.prefixPath.concat(t.collectionGroup, t.documentId)), t);
            i = i.insert(s.key, s), i.size === r && n.done();
        }).next(()=>i);
    }
    newChangeBuffer(e) {
        return new __PRIVATE_IndexedDbRemoteDocumentChangeBuffer(this, !!e && e.trackRemovals);
    }
    getSize(e) {
        return this.getMetadata(e).next((e)=>e.byteSize);
    }
    getMetadata(e) {
        return __PRIVATE_documentGlobalStore(e).get(ae).next((e)=>(__PRIVATE_hardAssert(!!e, 20021), e));
    }
    qs(e, t) {
        return __PRIVATE_documentGlobalStore(e).put(ae, t);
    }
    /**
     * Decodes `dbRemoteDoc` and returns the document (or an invalid document if
     * the document corresponds to the format used for sentinel deletes).
     */ $s(e, t) {
        if (t) {
            const e = __PRIVATE_fromDbRemoteDocument(this.serializer, t);
            // Whether the document is a sentinel removal and should only be used in the
            // `getNewDocumentChanges()`
            if (!(e.isNoDocument() && e.version.isEqual(SnapshotVersion.min()))) return e;
        }
        return MutableDocument.newInvalidDocument(e);
    }
}
/** Creates a new IndexedDbRemoteDocumentCache. */ function __PRIVATE_newIndexedDbRemoteDocumentCache(e) {
    return new __PRIVATE_IndexedDbRemoteDocumentCacheImpl(e);
}
/**
 * Handles the details of adding and updating documents in the IndexedDbRemoteDocumentCache.
 *
 * Unlike the MemoryRemoteDocumentChangeBuffer, the IndexedDb implementation computes the size
 * delta for all submitted changes. This avoids having to re-read all documents from IndexedDb
 * when we apply the changes.
 */ class __PRIVATE_IndexedDbRemoteDocumentChangeBuffer extends RemoteDocumentChangeBuffer {
    /**
     * @param documentCache - The IndexedDbRemoteDocumentCache to apply the changes to.
     * @param trackRemovals - Whether to create sentinel deletes that can be tracked by
     * `getNewDocumentChanges()`.
     */ constructor(e, t){
        super(), this.zs = e, this.trackRemovals = t, // A map of document sizes and read times prior to applying the changes in
        // this buffer.
        this.js = new ObjectMap((e)=>e.toString(), (e, t)=>e.isEqual(t));
    }
    applyChanges(e) {
        const t = [];
        let n = 0, r = new SortedSet((e, t)=>__PRIVATE_primitiveComparator(e.canonicalString(), t.canonicalString()));
        return this.changes.forEach((i, s)=>{
            const _ = this.js.get(i);
            if (t.push(this.zs.removeEntry(e, i, _.readTime)), s.isValidDocument()) {
                const o = __PRIVATE_toDbRemoteDocument(this.zs.serializer, s);
                r = r.add(i.path.popLast());
                const a = __PRIVATE_dbDocumentSize(o);
                n += a - _.size, t.push(this.zs.addEntry(e, i, o));
            } else if (n -= _.size, this.trackRemovals) {
                // In order to track removals, we store a "sentinel delete" in the
                // RemoteDocumentCache. This entry is represented by a NoDocument
                // with a version of 0 and ignored by `maybeDecodeDocument()` but
                // preserved in `getNewDocumentChanges()`.
                const n = __PRIVATE_toDbRemoteDocument(this.zs.serializer, s.convertToNoDocument(SnapshotVersion.min()));
                t.push(this.zs.addEntry(e, i, n));
            }
        }), r.forEach((n)=>{
            t.push(this.zs.indexManager.addToCollectionParentIndex(e, n));
        }), t.push(this.zs.updateMetadata(e, n)), PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute a delta later.
        return this.zs.Ks(e, t).next((e)=>(this.js.set(t, {
                size: e.size,
                readTime: e.document.readTime
            }), e.document));
    }
    getAllFromCache(e, t) {
        // Record the size of everything we load from the cache so we can compute
        // a delta later.
        return this.zs.Qs(e, t).next(({ documents: e, Gs: t })=>// Note: `getAllFromCache` returns two maps instead of a single map from
            // keys to `DocumentSizeEntry`s. This is to allow returning the
            // `MutableDocumentMap` directly, without a conversion.
            (t.forEach((t, n)=>{
                this.js.set(t, {
                    size: n,
                    readTime: e.get(t).readTime
                });
            }), e));
    }
}
function __PRIVATE_documentGlobalStore(e) {
    return __PRIVATE_getStore(e, oe);
}
/**
 * Helper to get a typed SimpleDbStore for the remoteDocuments object store.
 */ function __PRIVATE_remoteDocumentsStore(e) {
    return __PRIVATE_getStore(e, te);
}
/**
 * Returns a key that can be used for document lookups on the
 * `DbRemoteDocumentDocumentKeyIndex` index.
 */ function __PRIVATE_dbKey(e) {
    const t = e.path.toArray();
    return [
        /* prefix path */ t.slice(0, t.length - 2),
        /* collection id */ t[t.length - 2],
        /* document id */ t[t.length - 1]
    ];
}
function __PRIVATE_dbCollectionGroupKey(e, t) {
    const n = t.documentKey.path.toArray();
    return [
        /* collection id */ e,
        __PRIVATE_toDbTimestampKey(t.readTime),
        /* prefix path */ n.slice(0, n.length - 2),
        /* document id */ n.length > 0 ? n[n.length - 1] : ""
    ];
}
/**
 * Comparator that compares document keys according to the primary key sorting
 * used by the `DbRemoteDocumentDocument` store (by prefix path, collection id
 * and then document ID).
 *
 * Visible for testing.
 */ function __PRIVATE_dbKeyComparator(e, t) {
    const n = e.path.toArray(), r = t.path.toArray();
    // The ordering is based on https://chromium.googlesource.com/chromium/blink/+/fe5c21fef94dae71c1c3344775b8d8a7f7e6d9ec/Source/modules/indexeddb/IDBKey.cpp#74
    let i = 0;
    for(let e = 0; e < n.length - 2 && e < r.length - 2; ++e)if (i = __PRIVATE_primitiveComparator(n[e], r[e]), i) return i;
    return i = __PRIVATE_primitiveComparator(n.length, r.length), i || (i = __PRIVATE_primitiveComparator(n[n.length - 2], r[r.length - 2]), i || __PRIVATE_primitiveComparator(n[n.length - 1], r[r.length - 1]));
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Schema Version for the Web client:
 * 1.  Initial version including Mutation Queue, Query Cache, and Remote
 *     Document Cache
 * 2.  Used to ensure a targetGlobal object exists and add targetCount to it. No
 *     longer required because migration 3 unconditionally clears it.
 * 3.  Dropped and re-created Query Cache to deal with cache corruption related
 *     to limbo resolution. Addresses
 *     https://github.com/firebase/firebase-ios-sdk/issues/1548
 * 4.  Multi-Tab Support.
 * 5.  Removal of held write acks.
 * 6.  Create document global for tracking document cache size.
 * 7.  Ensure every cached document has a sentinel row with a sequence number.
 * 8.  Add collection-parent index for Collection Group queries.
 * 9.  Change RemoteDocumentChanges store to be keyed by readTime rather than
 *     an auto-incrementing ID. This is required for Index-Free queries.
 * 10. Rewrite the canonical IDs to the explicit Protobuf-based format.
 * 11. Add bundles and named_queries for bundle support.
 * 12. Add document overlays.
 * 13. Rewrite the keys of the remote document cache to allow for efficient
 *     document lookup via `getAll()`.
 * 14. Add overlays.
 * 15. Add indexing support.
 * 16. Parse timestamp strings before creating index entries.
 * 17. TODO(tomandersen)
 * 18. Encode key safe representations of IndexEntry in DbIndexEntryStore.
 */ /**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a local view (overlay) of a document, and the fields that are
 * locally mutated.
 */ class OverlayedDocument {
    constructor(e, /**
     * The fields that are locally mutated by patch mutations.
     *
     * If the overlayed	document is from set or delete mutations, this is `null`.
     * If there is no overlay (mutation) for the document, this is an empty `FieldMask`.
     */ t){
        this.overlayedDocument = e, this.mutatedFields = t;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A readonly view of the local state of all documents we're tracking (i.e. we
 * have a cached version in remoteDocumentCache or local mutations for the
 * document). The view is computed by applying the mutations in the
 * MutationQueue to the RemoteDocumentCache.
 */ class LocalDocumentsView {
    constructor(e, t, n, r){
        this.remoteDocumentCache = e, this.mutationQueue = t, this.documentOverlayCache = n, this.indexManager = r;
    }
    /**
     * Get the local view of the document identified by `key`.
     *
     * @returns Local view of the document or null if we don't have any cached
     * state for it.
     */ getDocument(e, t) {
        let n = null;
        return this.documentOverlayCache.getOverlay(e, t).next((r)=>(n = r, this.remoteDocumentCache.getEntry(e, t))).next((e)=>(null !== n && __PRIVATE_mutationApplyToLocalView(n.mutation, e, FieldMask.empty(), Timestamp.now()), e));
    }
    /**
     * Gets the local view of the documents identified by `keys`.
     *
     * If we don't have cached state for a document in `keys`, a NoDocument will
     * be stored for that key in the resulting set.
     */ getDocuments(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.getLocalViewOfDocuments(e, t, __PRIVATE_documentKeySet()).next(()=>t));
    }
    /**
     * Similar to `getDocuments`, but creates the local view from the given
     * `baseDocs` without retrieving documents from the local store.
     *
     * @param transaction - The transaction this operation is scoped to.
     * @param docs - The documents to apply local mutations to get the local views.
     * @param existenceStateChanged - The set of document keys whose existence state
     *   is changed. This is useful to determine if some documents overlay needs
     *   to be recalculated.
     */ getLocalViewOfDocuments(e, t, n = __PRIVATE_documentKeySet()) {
        const r = __PRIVATE_newOverlayMap();
        return this.populateOverlays(e, r, t).next(()=>this.computeViews(e, t, r, n).next((e)=>{
                let t = documentMap();
                return e.forEach((e, n)=>{
                    t = t.insert(e, n.overlayedDocument);
                }), t;
            }));
    }
    /**
     * Gets the overlayed documents for the given document map, which will include
     * the local view of those documents and a `FieldMask` indicating which fields
     * are mutated locally, `null` if overlay is a Set or Delete mutation.
     */ getOverlayedDocuments(e, t) {
        const n = __PRIVATE_newOverlayMap();
        return this.populateOverlays(e, n, t).next(()=>this.computeViews(e, t, n, __PRIVATE_documentKeySet()));
    }
    /**
     * Fetches the overlays for {@code docs} and adds them to provided overlay map
     * if the map does not already contain an entry for the given document key.
     */ populateOverlays(e, t, n) {
        const r = [];
        return n.forEach((e)=>{
            t.has(e) || r.push(e);
        }), this.documentOverlayCache.getOverlays(e, r).next((e)=>{
            e.forEach((e, n)=>{
                t.set(e, n);
            });
        });
    }
    /**
     * Computes the local view for the given documents.
     *
     * @param docs - The documents to compute views for. It also has the base
     *   version of the documents.
     * @param overlays - The overlays that need to be applied to the given base
     *   version of the documents.
     * @param existenceStateChanged - A set of documents whose existence states
     *   might have changed. This is used to determine if we need to re-calculate
     *   overlays from mutation queues.
     * @returns A map represents the local documents view.
     */ computeViews(e, t, n, r) {
        let i = __PRIVATE_mutableDocumentMap();
        const s = __PRIVATE_newDocumentKeyMap(), _ = function __PRIVATE_newOverlayedDocumentMap() {
            return __PRIVATE_newDocumentKeyMap();
        }();
        return t.forEach((e, t)=>{
            const _ = n.get(t.key);
            // Recalculate an overlay if the document's existence state changed due to
            // a remote event *and* the overlay is a PatchMutation. This is because
            // document existence state can change if some patch mutation's
            // preconditions are met.
            // NOTE: we recalculate when `overlay` is undefined as well, because there
            // might be a patch mutation whose precondition does not match before the
            // change (hence overlay is undefined), but would now match.
            r.has(t.key) && (void 0 === _ || _.mutation instanceof __PRIVATE_PatchMutation) ? i = i.insert(t.key, t) : void 0 !== _ ? (s.set(t.key, _.mutation.getFieldMask()), __PRIVATE_mutationApplyToLocalView(_.mutation, t, _.mutation.getFieldMask(), Timestamp.now())) : // no overlay exists
            // Using EMPTY to indicate there is no overlay for the document.
            s.set(t.key, FieldMask.empty());
        }), this.recalculateAndSaveOverlays(e, i).next((e)=>(e.forEach((e, t)=>s.set(e, t)), t.forEach((e, t)=>_.set(e, new OverlayedDocument(t, s.get(e) ?? null))), _));
    }
    recalculateAndSaveOverlays(e, t) {
        const n = __PRIVATE_newDocumentKeyMap();
        // A reverse lookup map from batch id to the documents within that batch.
        let r = new SortedMap((e, t)=>e - t), i = __PRIVATE_documentKeySet();
        return this.mutationQueue.getAllMutationBatchesAffectingDocumentKeys(e, t).next((e)=>{
            for (const i of e)i.keys().forEach((e)=>{
                const s = t.get(e);
                if (null === s) return;
                let _ = n.get(e) || FieldMask.empty();
                _ = i.applyToLocalView(s, _), n.set(e, _);
                const o = (r.get(i.batchId) || __PRIVATE_documentKeySet()).add(e);
                r = r.insert(i.batchId, o);
            });
        }).next(()=>{
            const s = [], _ = r.getReverseIterator();
            // Iterate in descending order of batch IDs, and skip documents that are
            // already saved.
            for(; _.hasNext();){
                const r = _.getNext(), o = r.key, a = r.value, u = __PRIVATE_newMutationMap();
                a.forEach((e)=>{
                    if (!i.has(e)) {
                        const r = __PRIVATE_calculateOverlayMutation(t.get(e), n.get(e));
                        null !== r && u.set(e, r), i = i.add(e);
                    }
                }), s.push(this.documentOverlayCache.saveOverlays(e, o, u));
            }
            return PersistencePromise.waitFor(s);
        }).next(()=>n);
    }
    /**
     * Recalculates overlays by reading the documents from remote document cache
     * first, and saves them after they are calculated.
     */ recalculateAndSaveOverlaysForDocumentKeys(e, t) {
        return this.remoteDocumentCache.getEntries(e, t).next((t)=>this.recalculateAndSaveOverlays(e, t));
    }
    /**
     * Performs a query against the local view of all documents.
     *
     * @param transaction - The persistence transaction.
     * @param query - The query to match documents against.
     * @param offset - Read time and key to start scanning by (exclusive).
     * @param context - A optional tracker to keep a record of important details
     *   during database local query execution.
     */ getDocumentsMatchingQuery(e, t, n, r) {
        return __PRIVATE_isPipeline(t) ? this.getDocumentsMatchingPipeline(e, t, n, r) : __PRIVATE_isDocumentQuery$1(t) ? this.getDocumentsMatchingDocumentQuery(e, t.path) : __PRIVATE_isCollectionGroupQuery(t) ? this.getDocumentsMatchingCollectionGroupQuery(e, t, n, r) : this.getDocumentsMatchingCollectionQuery(e, t, n, r);
    }
    /**
     * Given a collection group, returns the next documents that follow the provided offset, along
     * with an updated batch ID.
     *
     * <p>The documents returned by this method are ordered by remote version from the provided
     * offset. If there are no more remote documents after the provided offset, documents with
     * mutations in order of batch id from the offset are returned. Since all documents in a batch are
     * returned together, the total number of documents returned can exceed {@code count}.
     *
     * @param transaction
     * @param collectionGroup - The collection group for the documents.
     * @param offset - The offset to index into.
     * @param count - The number of documents to return
     * @returns A LocalWriteResult with the documents that follow the provided offset and the last processed batch id.
     */ getNextDocuments(e, t, n, r) {
        return this.remoteDocumentCache.getAllFromCollectionGroup(e, t, n, r).next((i)=>{
            const s = r - i.size > 0 ? this.documentOverlayCache.getOverlaysForCollectionGroup(e, t, n.largestBatchId, r - i.size) : PersistencePromise.resolve(__PRIVATE_newOverlayMap());
            // The callsite will use the largest batch ID together with the latest read time to create
            // a new index offset. Since we only process batch IDs if all remote documents have been read,
            // no overlay will increase the overall read time. This is why we only need to special case
            // the batch id.
            let _ = L, o = i;
            return s.next((t)=>PersistencePromise.forEach(t, (t, n)=>(_ < n.largestBatchId && (_ = n.largestBatchId), i.get(t) ? PersistencePromise.resolve() : this.remoteDocumentCache.getEntry(e, t).next((e)=>{
                        o = o.insert(t, e);
                    }))).next(()=>this.populateOverlays(e, t, i)).next(()=>this.computeViews(e, o, t, __PRIVATE_documentKeySet())).next((e)=>({
                        batchId: _,
                        changes: __PRIVATE_convertOverlayedDocumentMapToDocumentMap(e)
                    })));
        });
    }
    getDocumentsMatchingDocumentQuery(e, t) {
        // Just do a simple document lookup.
        return this.getDocument(e, new DocumentKey(t)).next((e)=>{
            let t = documentMap();
            return e.isFoundDocument() && (t = t.insert(e.key, e)), t;
        });
    }
    getDocumentsMatchingCollectionGroupQuery(e, t, n, r) {
        const i = t.collectionGroup;
        let s = documentMap();
        return this.indexManager.getCollectionParents(e, i).next((_)=>PersistencePromise.forEach(_, (_)=>{
                const o = function __PRIVATE_asCollectionQueryAtPath(e, t) {
                    return new __PRIVATE_QueryImpl(t, /*collectionGroup=*/ null, e.explicitOrderBy.slice(), e.filters.slice(), e.limit, e.limitType, e.startAt, e.endAt);
                }(t, _.child(i));
                return this.getDocumentsMatchingCollectionQuery(e, o, n, r).next((e)=>{
                    e.forEach((e, t)=>{
                        s = s.insert(e, t);
                    });
                });
            }).next(()=>s));
    }
    getDocumentsMatchingCollectionQuery(e, t, n, r) {
        // Query the remote documents and overlay mutations.
        let i;
        return this.documentOverlayCache.getOverlaysForCollection(e, t.path, n.largestBatchId).next((s)=>(i = s, this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r))).next((e)=>this.retrieveMatchingLocalDocuments(i, e, (e)=>__PRIVATE_queryMatches(t, e)));
    }
    getDocumentsMatchingPipeline(e, t, n, r) {
        if ("collection_group" === getPipelineSourceType(t)) {
            const i = getPipelineCollectionGroup(t);
            let s = documentMap();
            return this.indexManager.getCollectionParents(e, i).next((_)=>PersistencePromise.forEach(_, (_)=>{
                    const o = function __PRIVATE_asCollectionPipelineAtPath(e, t) {
                        const n = e.stages.map((e)=>e instanceof __PRIVATE_CollectionGroupSource ? new __PRIVATE_CollectionSource(t.canonicalString(), {}) : e);
                        return new CorePipeline(e.serializer, n);
                    }(t, _.child(i));
                    return this.getDocumentsMatchingPipeline(e, o, n, r).next((e)=>{
                        e.forEach((e, t)=>{
                            s = s.insert(e, t);
                        });
                    });
                }).next(()=>s));
        }
        {
            // Query the remote documents and overlay mutations.
            let i;
            return this.getOverlaysForPipeline(e, t, n.largestBatchId).next((s)=>{
                switch(i = s, getPipelineSourceType(t)){
                    case "collection":
                        return this.remoteDocumentCache.getDocumentsMatchingQuery(e, t, n, i, r);
                    case "documents":
                        let s1 = __PRIVATE_documentKeySet();
                        for (const e of getPipelineDocuments(t))s1 = s1.add(DocumentKey.fromPath(e));
                        return this.remoteDocumentCache.getEntries(e, s1);
                    case "database":
                        return this.remoteDocumentCache.getAllEntries(e);
                    default:
                        throw new FirestoreError("invalid-argument", `Invalid pipeline source to execute offline: ${__PRIVATE_canonifyPipeline(t)}`);
                }
            }).next((e)=>this.retrieveMatchingLocalDocuments(i, e, (e)=>__PRIVATE_pipelineMatches(t, e)));
        }
    }
    retrieveMatchingLocalDocuments(e, t, n) {
        // As documents might match the query because of their overlay we need to
        // include documents for all overlays in the initial document set.
        e.forEach((e, n)=>{
            const r = n.getKey();
            null === t.get(r) && (t = t.insert(r, MutableDocument.newInvalidDocument(r)));
        });
        // Apply the overlays and match against the query.
        let r = documentMap();
        return t.forEach((t, i)=>{
            const s = e.get(t);
            void 0 !== s && __PRIVATE_mutationApplyToLocalView(s.mutation, i, FieldMask.empty(), Timestamp.now()), // Finally, insert the documents that still match the query
            n(i) && (r = r.insert(t, i));
        }), r;
    }
    getOverlaysForPipeline(e, t, n) {
        switch(getPipelineSourceType(t)){
            case "collection":
                return this.documentOverlayCache.getOverlaysForCollection(e, ResourcePath.fromString(getPipelineCollection(t)), n);
            case "collection_group":
                throw new FirestoreError("invalid-argument", `Unexpected collection group pipeline: ${__PRIVATE_canonifyPipeline(t)}`);
            case "documents":
                return this.documentOverlayCache.getOverlays(e, getPipelineDocuments(t).map((e)=>DocumentKey.fromPath(e)));
            case "database":
                return this.documentOverlayCache.getAllOverlays(e, n);
            default:
                throw new FirestoreError("invalid-argument", `Failed to get overlays for pipeline: ${__PRIVATE_canonifyPipeline(t)}`);
        }
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_MemoryBundleCache {
    constructor(e){
        this.serializer = e, this.Hs = new Map, this.Js = new Map;
    }
    getBundleMetadata(e, t) {
        return PersistencePromise.resolve(this.Hs.get(t));
    }
    saveBundleMetadata(e, t) {
        return this.Hs.set(t.id, /** Decodes a BundleMetadata proto into a BundleMetadata object. */ function __PRIVATE_fromBundleMetadata(e) {
            return {
                id: e.id,
                version: e.version,
                createTime: __PRIVATE_fromVersion(e.createTime)
            };
        }(t)), PersistencePromise.resolve();
    }
    getNamedQuery(e, t) {
        return PersistencePromise.resolve(this.Js.get(t));
    }
    saveNamedQuery(e, t) {
        return this.Js.set(t.name, function __PRIVATE_fromProtoNamedQuery(e) {
            return {
                name: e.name,
                query: __PRIVATE_fromBundledQuery(e.bundledQuery),
                readTime: __PRIVATE_fromVersion(e.readTime)
            };
        }(t)), PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An in-memory implementation of DocumentOverlayCache.
 */ class __PRIVATE_MemoryDocumentOverlayCache {
    constructor(){
        // A map sorted by DocumentKey, whose value is a pair of the largest batch id
        // for the overlay and the overlay itself.
        this.overlays = new SortedMap(DocumentKey.comparator), this.Ys = new Map;
    }
    getOverlay(e, t) {
        return PersistencePromise.resolve(this.overlays.get(t));
    }
    getOverlays(e, t) {
        const n = __PRIVATE_newOverlayMap();
        return PersistencePromise.forEach(t, (t)=>this.getOverlay(e, t).next((e)=>{
                null !== e && n.set(t, e);
            })).next(()=>n);
    }
    getAllOverlays(e, t) {
        const n = __PRIVATE_newOverlayMap();
        return this.overlays.forEach((e, r)=>{
            r.largestBatchId > t && n.set(e, r);
        }), PersistencePromise.resolve(n);
    }
    saveOverlays(e, t, n) {
        return n.forEach((n, r)=>{
            this.Hr(e, t, r);
        }), PersistencePromise.resolve();
    }
    removeOverlaysForBatchId(e, t, n) {
        const r = this.Ys.get(n);
        return void 0 !== r && (r.forEach((e)=>this.overlays = this.overlays.remove(e)), this.Ys.delete(n)), PersistencePromise.resolve();
    }
    getOverlaysForCollection(e, t, n) {
        const r = __PRIVATE_newOverlayMap(), i = t.length + 1, s = new DocumentKey(t.child("")), _ = this.overlays.getIteratorFrom(s);
        for(; _.hasNext();){
            const e = _.getNext().value, s = e.getKey();
            if (!t.isPrefixOf(s.path)) break;
            // Documents from sub-collections
            s.path.length === i && e.largestBatchId > n && r.set(e.getKey(), e);
        }
        return PersistencePromise.resolve(r);
    }
    getOverlaysForCollectionGroup(e, t, n, r) {
        let i = new SortedMap((e, t)=>e - t);
        const s = this.overlays.getIterator();
        for(; s.hasNext();){
            const e = s.getNext().value;
            if (e.getKey().getCollectionGroup() === t && e.largestBatchId > n) {
                let t = i.get(e.largestBatchId);
                null === t && (t = __PRIVATE_newOverlayMap(), i = i.insert(e.largestBatchId, t)), t.set(e.getKey(), e);
            }
        }
        const _ = __PRIVATE_newOverlayMap(), o = i.getIterator();
        for(; o.hasNext();){
            if (o.getNext().value.forEach((e, t)=>_.set(e, t)), _.size() >= r) break;
        }
        return PersistencePromise.resolve(_);
    }
    Hr(e, t, n) {
        // Remove the association of the overlay to its batch id.
        const r = this.overlays.get(n.key);
        if (null !== r) {
            const e = this.Ys.get(r.largestBatchId).delete(n.key);
            this.Ys.set(r.largestBatchId, e);
        }
        this.overlays = this.overlays.insert(n.key, new Overlay(t, n));
        // Create the association of this overlay to the given largestBatchId.
        let i = this.Ys.get(t);
        void 0 === i && (i = __PRIVATE_documentKeySet(), this.Ys.set(t, i)), this.Ys.set(t, i.add(n.key));
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_MemoryGlobalsCache {
    constructor(){
        this.sessionToken = ByteString.EMPTY_BYTE_STRING;
    }
    getSessionToken(e) {
        return PersistencePromise.resolve(this.sessionToken);
    }
    setSessionToken(e, t) {
        return this.sessionToken = t, PersistencePromise.resolve();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A collection of references to a document from some kind of numbered entity
 * (either a target ID or batch ID). As references are added to or removed from
 * the set corresponding events are emitted to a registered garbage collector.
 *
 * Each reference is represented by a DocumentReference object. Each of them
 * contains enough information to uniquely identify the reference. They are all
 * stored primarily in a set sorted by key. A document is considered garbage if
 * there's no references in that set (this can be efficiently checked thanks to
 * sorting by key).
 *
 * ReferenceSet also keeps a secondary set that contains references sorted by
 * IDs. This one is used to efficiently implement removal of all references by
 * some target ID.
 */ class __PRIVATE_ReferenceSet {
    constructor(){
        // A set of outstanding references to a document sorted by key.
        this.Zs = new SortedSet(__PRIVATE_DocReference.Xs), // A set of outstanding references to a document sorted by target id.
        this.e_ = new SortedSet(__PRIVATE_DocReference.t_);
    }
    /** Returns true if the reference set contains no references. */ isEmpty() {
        return this.Zs.isEmpty();
    }
    /** Adds a reference to the given document key for the given ID. */ addReference(e, t) {
        const n = new __PRIVATE_DocReference(e, t);
        this.Zs = this.Zs.add(n), this.e_ = this.e_.add(n);
    }
    /** Add references to the given document keys for the given ID. */ n_(e, t) {
        e.forEach((e)=>this.addReference(e, t));
    }
    /**
     * Removes a reference to the given document key for the given
     * ID.
     */ removeReference(e, t) {
        this.r_(new __PRIVATE_DocReference(e, t));
    }
    i_(e, t) {
        e.forEach((e)=>this.removeReference(e, t));
    }
    /**
     * Clears all references with a given ID. Calls removeRef() for each key
     * removed.
     */ s_(e) {
        const t = new DocumentKey(new ResourcePath([])), n = new __PRIVATE_DocReference(t, e), r = new __PRIVATE_DocReference(t, e + 1), i = [];
        return this.e_.forEachInRange([
            n,
            r
        ], (e)=>{
            this.r_(e), i.push(e.key);
        }), i;
    }
    __() {
        this.Zs.forEach((e)=>this.r_(e));
    }
    r_(e) {
        this.Zs = this.Zs.delete(e), this.e_ = this.e_.delete(e);
    }
    o_(e) {
        const t = new DocumentKey(new ResourcePath([])), n = new __PRIVATE_DocReference(t, e), r = new __PRIVATE_DocReference(t, e + 1);
        let i = __PRIVATE_documentKeySet();
        return this.e_.forEachInRange([
            n,
            r
        ], (e)=>{
            i = i.add(e.key);
        }), i;
    }
    containsKey(e) {
        const t = new __PRIVATE_DocReference(e, 0), n = this.Zs.firstAfterOrEqual(t);
        return null !== n && e.isEqual(n.key);
    }
}
class __PRIVATE_DocReference {
    constructor(e, t){
        this.key = e, this.a_ = t;
    }
    /** Compare by key then by ID */ static Xs(e, t) {
        return DocumentKey.comparator(e.key, t.key) || __PRIVATE_primitiveComparator(e.a_, t.a_);
    }
    /** Compare by ID then by key */ static t_(e, t) {
        return __PRIVATE_primitiveComparator(e.a_, t.a_) || DocumentKey.comparator(e.key, t.key);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_MemoryMutationQueue {
    constructor(e, t){
        this.indexManager = e, this.referenceDelegate = t, /**
         * The set of all mutations that have been sent but not yet been applied to
         * the backend.
         */ this.mutationQueue = [], /** Next value to use when assigning sequential IDs to each mutation batch. */ this.gs = 1, /** An ordered mapping between documents and the mutations batch IDs. */ this.u_ = new SortedSet(__PRIVATE_DocReference.Xs);
    }
    checkEmpty(e) {
        return PersistencePromise.resolve(0 === this.mutationQueue.length);
    }
    addMutationBatch(e, t, n, r) {
        const i = this.gs;
        this.gs++, this.mutationQueue.length > 0 && this.mutationQueue[this.mutationQueue.length - 1];
        const s = new MutationBatch(i, t, n, r);
        this.mutationQueue.push(s);
        // Track references by document key and index collection parents.
        for (const t of r)this.u_ = this.u_.add(new __PRIVATE_DocReference(t.key, i)), this.indexManager.addToCollectionParentIndex(e, t.key.path.popLast());
        return PersistencePromise.resolve(s);
    }
    lookupMutationBatch(e, t) {
        return PersistencePromise.resolve(this.c_(t));
    }
    getNextMutationBatchAfterBatchId(e, t) {
        const n = t + 1, r = this.l_(n), i = r < 0 ? 0 : r;
        // The requested batchId may still be out of range so normalize it to the
        // start of the queue.
        return PersistencePromise.resolve(this.mutationQueue.length > i ? this.mutationQueue[i] : null);
    }
    getHighestUnacknowledgedBatchId() {
        return PersistencePromise.resolve(0 === this.mutationQueue.length ? $ : this.gs - 1);
    }
    getAllMutationBatches(e) {
        return PersistencePromise.resolve(this.mutationQueue.slice());
    }
    getAllMutationBatchesAffectingDocumentKey(e, t) {
        const n = new __PRIVATE_DocReference(t, 0), r = new __PRIVATE_DocReference(t, Number.POSITIVE_INFINITY), i = [];
        return this.u_.forEachInRange([
            n,
            r
        ], (e)=>{
            const t = this.c_(e.a_);
            i.push(t);
        }), PersistencePromise.resolve(i);
    }
    getAllMutationBatchesAffectingDocumentKeys(e, t) {
        let n = new SortedSet(__PRIVATE_primitiveComparator);
        return t.forEach((e)=>{
            const t = new __PRIVATE_DocReference(e, 0), r = new __PRIVATE_DocReference(e, Number.POSITIVE_INFINITY);
            this.u_.forEachInRange([
                t,
                r
            ], (e)=>{
                n = n.add(e.a_);
            });
        }), PersistencePromise.resolve(this.E_(n));
    }
    getAllMutationBatchesAffectingQuery(e, t) {
        // Use the query path as a prefix for testing if a document matches the
        // query.
        const n = t.path, r = n.length + 1;
        // Construct a document reference for actually scanning the index. Unlike
        // the prefix the document key in this reference must have an even number of
        // segments. The empty segment can be used a suffix of the query path
        // because it precedes all other segments in an ordered traversal.
        let i = n;
        DocumentKey.isDocumentKey(i) || (i = i.child(""));
        const s = new __PRIVATE_DocReference(new DocumentKey(i), 0);
        // Find unique batchIDs referenced by all documents potentially matching the
        // query.
        let _ = new SortedSet(__PRIVATE_primitiveComparator);
        return this.u_.forEachWhile((e)=>{
            const t = e.key.path;
            return !!n.isPrefixOf(t) && // Rows with document keys more than one segment longer than the query
            // path can't be matches. For example, a query on 'rooms' can't match
            // the document /rooms/abc/messages/xyx.
            // TODO(mcg): we'll need a different scanner when we implement
            // ancestor queries.
            (t.length === r && (_ = _.add(e.a_)), !0);
        }, s), PersistencePromise.resolve(this.E_(_));
    }
    E_(e) {
        // Construct an array of matching batches, sorted by batchID to ensure that
        // multiple mutations affecting the same document key are applied in order.
        const t = [];
        return e.forEach((e)=>{
            const n = this.c_(e);
            null !== n && t.push(n);
        }), t;
    }
    removeMutationBatch(e, t) {
        __PRIVATE_hardAssert(0 === this.h_(t.batchId, "removed"), 55003), this.mutationQueue.shift();
        let n = this.u_;
        return PersistencePromise.forEach(t.mutations, (r)=>{
            const i = new __PRIVATE_DocReference(r.key, t.batchId);
            return n = n.delete(i), this.referenceDelegate.markPotentiallyOrphaned(e, r.key);
        }).next(()=>{
            this.u_ = n;
        });
    }
    bs(e) {
    // No-op since the memory mutation queue does not maintain a separate cache.
    }
    containsKey(e, t) {
        const n = new __PRIVATE_DocReference(t, 0), r = this.u_.firstAfterOrEqual(n);
        return PersistencePromise.resolve(t.isEqual(r && r.key));
    }
    performConsistencyCheck(e) {
        return this.mutationQueue.length, PersistencePromise.resolve();
    }
    /**
     * Finds the index of the given batchId in the mutation queue and asserts that
     * the resulting index is within the bounds of the queue.
     *
     * @param batchId - The batchId to search for
     * @param action - A description of what the caller is doing, phrased in passive
     * form (e.g. "acknowledged" in a routine that acknowledges batches).
     */ h_(e, t) {
        return this.l_(e);
    }
    /**
     * Finds the index of the given batchId in the mutation queue. This operation
     * is O(1).
     *
     * @returns The computed index of the batch with the given batchId, based on
     * the state of the queue. Note this index can be negative if the requested
     * batchId has already been removed from the queue or past the end of the
     * queue if the batchId is larger than the last added batch.
     */ l_(e) {
        if (0 === this.mutationQueue.length) // As an index this is past the end of the queue
        return 0;
        // Examine the front of the queue to figure out the difference between the
        // batchId and indexes in the array. Note that since the queue is ordered
        // by batchId, if the first batch has a larger batchId then the requested
        // batchId doesn't exist in the queue.
        return e - this.mutationQueue[0].batchId;
    }
    /**
     * A version of lookupMutationBatch that doesn't return a promise, this makes
     * other functions that uses this code easier to read and more efficient.
     */ c_(e) {
        const t = this.l_(e);
        if (t < 0 || t >= this.mutationQueue.length) return null;
        return this.mutationQueue[t];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The smallest value representable by a 64-bit signed integer (long).
 */ /**
 * The memory-only RemoteDocumentCache for IndexedDb. To construct, invoke
 * `newMemoryRemoteDocumentCache()`.
 */ class __PRIVATE_MemoryRemoteDocumentCacheImpl {
    /**
     * @param sizer - Used to assess the size of a document. For eager GC, this is
     * expected to just return 0 to avoid unnecessarily doing the work of
     * calculating the size.
     */ constructor(e){
        this.T_ = e, /** Underlying cache of documents and their read times. */ this.docs = function __PRIVATE_documentEntryMap() {
            return new SortedMap(DocumentKey.comparator);
        }(), /** Size of all cached documents. */ this.size = 0;
    }
    setIndexManager(e) {
        this.indexManager = e;
    }
    /**
     * Adds the supplied entry to the cache and updates the cache size as appropriate.
     *
     * All calls of `addEntry`  are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ addEntry(e, t) {
        const n = t.key, r = this.docs.get(n), i = r ? r.size : 0, s = this.T_(t);
        return this.docs = this.docs.insert(n, {
            document: t.mutableCopy(),
            size: s
        }), this.size += s - i, this.indexManager.addToCollectionParentIndex(e, n.path.popLast());
    }
    /**
     * Removes the specified entry from the cache and updates the cache size as appropriate.
     *
     * All calls of `removeEntry` are required to go through the RemoteDocumentChangeBuffer
     * returned by `newChangeBuffer()`.
     */ removeEntry(e) {
        const t = this.docs.get(e);
        t && (this.docs = this.docs.remove(e), this.size -= t.size);
    }
    getEntry(e, t) {
        const n = this.docs.get(t);
        return PersistencePromise.resolve(n ? n.document.mutableCopy() : MutableDocument.newInvalidDocument(t));
    }
    getEntries(e, t) {
        let n = __PRIVATE_mutableDocumentMap();
        return t.forEach((e)=>{
            const t = this.docs.get(e);
            n = n.insert(e, t ? t.document.mutableCopy() : MutableDocument.newInvalidDocument(e));
        }), PersistencePromise.resolve(n);
    }
    getAllEntries(e) {
        let t = __PRIVATE_mutableDocumentMap();
        return this.docs.forEach((e, n)=>{
            t = t.insert(e, n.document);
        }), PersistencePromise.resolve(t);
    }
    getDocumentsMatchingQuery(e, t, n, r) {
        // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        let i, s;
        __PRIVATE_isPipeline(t) ? // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        (i = ResourcePath.fromString(getPipelineCollection(t)), s = (e)=>__PRIVATE_pipelineMatches(t, e)) : // Documents are ordered by key, so we can use a prefix scan to narrow down
        // the documents we need to match the query against.
        (i = t.path, s = (e)=>__PRIVATE_queryMatches(t, e));
        let _ = __PRIVATE_mutableDocumentMap();
        // Document keys are ordered first by numeric value ("__id<Long>__"),
        // then lexicographically by string value. Start the iterator at the minimum
        // possible Document key value.
        const o = new DocumentKey(i.child("__id-9223372036854775808__")), a = this.docs.getIteratorFrom(o);
        for(; a.hasNext();){
            const { key: e, value: { document: t } } = a.getNext();
            if (!i.isPrefixOf(e.path)) break;
            e.path.length > i.length + 1 || __PRIVATE_indexOffsetComparator(__PRIVATE_newIndexOffsetFromDocument(t), n) <= 0 || (r.has(t.key) || s(t)) && (_ = _.insert(t.key, t.mutableCopy()));
        }
        return PersistencePromise.resolve(_);
    }
    getAllFromCollectionGroup(e, t, n, r) {
        // This method should only be called from the IndexBackfiller if persistence
        // is enabled.
        fail(9500);
    }
    P_(e, t) {
        return PersistencePromise.forEach(this.docs, (e)=>t(e));
    }
    newChangeBuffer(e) {
        // `trackRemovals` is ignores since the MemoryRemoteDocumentCache keeps
        // a separate changelog and does not need special handling for removals.
        return new __PRIVATE_MemoryRemoteDocumentChangeBuffer(this);
    }
    getSize(e) {
        return PersistencePromise.resolve(this.size);
    }
}
/**
 * Creates a new memory-only RemoteDocumentCache.
 *
 * @param sizer - Used to assess the size of a document. For eager GC, this is
 * expected to just return 0 to avoid unnecessarily doing the work of
 * calculating the size.
 */ /**
 * Handles the details of adding and updating documents in the MemoryRemoteDocumentCache.
 */ class __PRIVATE_MemoryRemoteDocumentChangeBuffer extends RemoteDocumentChangeBuffer {
    constructor(e){
        super(), this.zs = e;
    }
    applyChanges(e) {
        const t = [];
        return this.changes.forEach((n, r)=>{
            r.isValidDocument() ? t.push(this.zs.addEntry(e, r)) : this.zs.removeEntry(n);
        }), PersistencePromise.waitFor(t);
    }
    getFromCache(e, t) {
        return this.zs.getEntry(e, t);
    }
    getAllFromCache(e, t) {
        return this.zs.getEntries(e, t);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_MemoryTargetCache {
    constructor(e){
        this.persistence = e, /**
         * Maps a target to the data about that target
         */ this.R_ = new ObjectMap((e)=>__PRIVATE_canonifyTargetOrPipeline(e), __PRIVATE_targetOrPipelineEqual), /** The last received snapshot version. */ this.lastRemoteSnapshotVersion = SnapshotVersion.min(), /** The highest numbered target ID encountered. */ this.highestTargetId = 0, /** The highest sequence number encountered. */ this.I_ = 0, /**
         * A ordered bidirectional mapping between documents and the remote target
         * IDs.
         */ this.A_ = new __PRIVATE_ReferenceSet, this.targetCount = 0, this.V_ = __PRIVATE_TargetIdGenerator.xs();
    }
    forEachTarget(e, t) {
        return this.R_.forEach((e, n)=>t(n)), PersistencePromise.resolve();
    }
    getLastRemoteSnapshotVersion(e) {
        return PersistencePromise.resolve(this.lastRemoteSnapshotVersion);
    }
    getHighestSequenceNumber(e) {
        return PersistencePromise.resolve(this.I_);
    }
    allocateTargetId(e) {
        return this.highestTargetId = this.V_.next(), PersistencePromise.resolve(this.highestTargetId);
    }
    setTargetsMetadata(e, t, n) {
        return n && (this.lastRemoteSnapshotVersion = n), t > this.I_ && (this.I_ = t), PersistencePromise.resolve();
    }
    Ms(e) {
        this.R_.set(e.target, e);
        const t = e.targetId;
        t > this.highestTargetId && (this.V_ = new __PRIVATE_TargetIdGenerator(t), this.highestTargetId = t), e.sequenceNumber > this.I_ && (this.I_ = e.sequenceNumber);
    }
    addTargetData(e, t) {
        return this.Ms(t), this.targetCount += 1, PersistencePromise.resolve();
    }
    updateTargetData(e, t) {
        return this.Ms(t), PersistencePromise.resolve();
    }
    removeTargetData(e, t) {
        return this.R_.delete(t.target), this.A_.s_(t.targetId), this.targetCount -= 1, PersistencePromise.resolve();
    }
    removeTargets(e, t, n) {
        let r = 0;
        const i = [];
        return this.R_.forEach((s, _)=>{
            _.sequenceNumber <= t && null === n.get(_.targetId) && (this.R_.delete(s), i.push(this.removeMatchingKeysForTargetId(e, _.targetId)), r++);
        }), PersistencePromise.waitFor(i).next(()=>r);
    }
    getTargetCount(e) {
        return PersistencePromise.resolve(this.targetCount);
    }
    getTargetData(e, t) {
        const n = this.R_.get(t) || null;
        return PersistencePromise.resolve(n);
    }
    addMatchingKeys(e, t, n) {
        return this.A_.n_(t, n), PersistencePromise.resolve();
    }
    removeMatchingKeys(e, t, n) {
        this.A_.i_(t, n);
        const r = this.persistence.referenceDelegate, i = [];
        return r && t.forEach((t)=>{
            i.push(r.markPotentiallyOrphaned(e, t));
        }), PersistencePromise.waitFor(i);
    }
    removeMatchingKeysForTargetId(e, t) {
        return this.A_.s_(t), PersistencePromise.resolve();
    }
    getMatchingKeysForTargetId(e, t) {
        const n = this.A_.o_(t);
        return PersistencePromise.resolve(n);
    }
    containsKey(e, t) {
        return PersistencePromise.resolve(this.A_.containsKey(t));
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A memory-backed instance of Persistence. Data is stored only in RAM and
 * not persisted across sessions.
 */ class __PRIVATE_MemoryPersistence {
    /**
     * The constructor accepts a factory for creating a reference delegate. This
     * allows both the delegate and this instance to have strong references to
     * each other without having nullable fields that would then need to be
     * checked or asserted on every access.
     */ constructor(e, t){
        this.d_ = {}, this.overlays = {}, this.f_ = new __PRIVATE_ListenSequence(0), this.m_ = !1, this.m_ = !0, this.p_ = new __PRIVATE_MemoryGlobalsCache, this.referenceDelegate = e(this), this.g_ = new __PRIVATE_MemoryTargetCache(this);
        this.indexManager = new __PRIVATE_MemoryIndexManager, this.remoteDocumentCache = function __PRIVATE_newMemoryRemoteDocumentCache(e) {
            return new __PRIVATE_MemoryRemoteDocumentCacheImpl(e);
        }((e)=>this.referenceDelegate.y_(e)), this.serializer = new __PRIVATE_LocalSerializer(t), this.w_ = new __PRIVATE_MemoryBundleCache(this.serializer);
    }
    start() {
        return Promise.resolve();
    }
    shutdown() {
        // No durable state to ensure is closed on shutdown.
        return this.m_ = !1, Promise.resolve();
    }
    get started() {
        return this.m_;
    }
    setDatabaseDeletedListener() {
    // No op.
    }
    setNetworkEnabled() {
    // No op.
    }
    getIndexManager(e) {
        // We do not currently support indices for memory persistence, so we can
        // return the same shared instance of the memory index manager.
        return this.indexManager;
    }
    getDocumentOverlayCache(e) {
        let t = this.overlays[e.toKey()];
        return t || (t = new __PRIVATE_MemoryDocumentOverlayCache, this.overlays[e.toKey()] = t), t;
    }
    getMutationQueue(e, t) {
        let n = this.d_[e.toKey()];
        return n || (n = new __PRIVATE_MemoryMutationQueue(t, this.referenceDelegate), this.d_[e.toKey()] = n), n;
    }
    getGlobalsCache() {
        return this.p_;
    }
    getTargetCache() {
        return this.g_;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getBundleCache() {
        return this.w_;
    }
    runTransaction(e, t, n) {
        __PRIVATE_logDebug("MemoryPersistence", "Starting transaction:", e);
        const r = new __PRIVATE_MemoryTransaction(this.f_.next());
        return this.referenceDelegate.b_(), n(r).next((e)=>this.referenceDelegate.v_(r).next(()=>e)).toPromise().then((e)=>(r.raiseOnCommittedEvent(), e));
    }
    S_(e, t) {
        return PersistencePromise.or(Object.values(this.d_).map((n)=>()=>n.containsKey(e, t)));
    }
}
/**
 * Memory persistence is not actually transactional, but future implementations
 * may have transaction-scoped state.
 */ class __PRIVATE_MemoryTransaction extends PersistenceTransaction {
    constructor(e){
        super(), this.currentSequenceNumber = e;
    }
}
class __PRIVATE_MemoryEagerDelegate {
    constructor(e){
        this.persistence = e, /** Tracks all documents that are active in Query views. */ this.D_ = new __PRIVATE_ReferenceSet, /** The list of documents that are potentially GCed after each transaction. */ this.x_ = null;
    }
    static C_(e) {
        return new __PRIVATE_MemoryEagerDelegate(e);
    }
    get F_() {
        if (this.x_) return this.x_;
        throw fail(60996);
    }
    addReference(e, t, n) {
        return this.D_.addReference(n, t), this.F_.delete(n.toString()), PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.D_.removeReference(n, t), this.F_.add(n.toString()), PersistencePromise.resolve();
    }
    markPotentiallyOrphaned(e, t) {
        return this.F_.add(t.toString()), PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        this.D_.s_(t.targetId).forEach((e)=>this.F_.add(e.toString()));
        const n = this.persistence.getTargetCache();
        return n.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
            e.forEach((e)=>this.F_.add(e.toString()));
        }).next(()=>n.removeTargetData(e, t));
    }
    b_() {
        this.x_ = new Set;
    }
    v_(e) {
        // Remove newly orphaned documents.
        const t = this.persistence.getRemoteDocumentCache().newChangeBuffer();
        return PersistencePromise.forEach(this.F_, (n)=>{
            const r = DocumentKey.fromPath(n);
            return this.O_(e, r).next((e)=>{
                e || t.removeEntry(r, SnapshotVersion.min());
            });
        }).next(()=>(this.x_ = null, t.apply(e)));
    }
    updateLimboDocument(e, t) {
        return this.O_(e, t).next((e)=>{
            e ? this.F_.delete(t.toString()) : this.F_.add(t.toString());
        });
    }
    y_(e) {
        // For eager GC, we don't care about the document size, there are no size thresholds.
        return 0;
    }
    O_(e, t) {
        return PersistencePromise.or([
            ()=>PersistencePromise.resolve(this.D_.containsKey(t)),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>this.persistence.S_(e, t)
        ]);
    }
}
class __PRIVATE_MemoryLruDelegate {
    constructor(e, t){
        this.persistence = e, this.M_ = new ObjectMap((e)=>__PRIVATE_encodeResourcePath(e.path), (e, t)=>e.isEqual(t)), this.garbageCollector = __PRIVATE_newLruGarbageCollector(this, t);
    }
    static C_(e, t) {
        return new __PRIVATE_MemoryLruDelegate(e, t);
    }
    // No-ops, present so memory persistence doesn't have to care which delegate
    // it has.
    b_() {}
    v_(e) {
        return PersistencePromise.resolve();
    }
    forEachTarget(e, t) {
        return this.persistence.getTargetCache().forEachTarget(e, t);
    }
    lr(e) {
        const t = this.Ls(e);
        return this.persistence.getTargetCache().getTargetCount(e).next((e)=>t.next((t)=>e + t));
    }
    Ls(e) {
        let t = 0;
        return this.Er(e, (e)=>{
            t++;
        }).next(()=>t);
    }
    Er(e, t) {
        return PersistencePromise.forEach(this.M_, (n, r)=>this.Us(e, n, r).next((e)=>e ? PersistencePromise.resolve() : t(r)));
    }
    removeTargets(e, t, n) {
        return this.persistence.getTargetCache().removeTargets(e, t, n);
    }
    removeOrphanedDocuments(e, t) {
        let n = 0;
        const r = this.persistence.getRemoteDocumentCache(), i = r.newChangeBuffer();
        return r.P_(e, (r)=>this.Us(e, r, t).next((e)=>{
                e || (n++, i.removeEntry(r, SnapshotVersion.min()));
            })).next(()=>i.apply(e)).next(()=>n);
    }
    markPotentiallyOrphaned(e, t) {
        return this.M_.set(t, e.currentSequenceNumber), PersistencePromise.resolve();
    }
    removeTarget(e, t) {
        const n = t.withSequenceNumber(e.currentSequenceNumber);
        return this.persistence.getTargetCache().updateTargetData(e, n);
    }
    addReference(e, t, n) {
        return this.M_.set(n, e.currentSequenceNumber), PersistencePromise.resolve();
    }
    removeReference(e, t, n) {
        return this.M_.set(n, e.currentSequenceNumber), PersistencePromise.resolve();
    }
    updateLimboDocument(e, t) {
        return this.M_.set(t, e.currentSequenceNumber), PersistencePromise.resolve();
    }
    y_(e) {
        let t = e.key.toString().length;
        return e.isFoundDocument() && (t += __PRIVATE_estimateByteSize(e.data.value)), t;
    }
    Us(e, t, n) {
        return PersistencePromise.or([
            ()=>this.persistence.S_(e, t),
            ()=>this.persistence.getTargetCache().containsKey(e, t),
            ()=>{
                const e = this.M_.get(t);
                return PersistencePromise.resolve(void 0 !== e && e > n);
            }
        ]);
    }
    getCacheSize(e) {
        return this.persistence.getRemoteDocumentCache().getSize(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Performs database creation and schema upgrades. */ class __PRIVATE_SchemaConverter {
    constructor(e){
        this.serializer = e;
    }
    /**
     * Performs database creation and schema upgrades.
     *
     * Note that in production, this method is only ever used to upgrade the schema
     * to SCHEMA_VERSION. Different values of toVersion are only used for testing
     * and local feature development.
     */ U(e, t, n, r) {
        const i = new __PRIVATE_SimpleDbTransaction("createOrUpgrade", t);
        n < 1 && r >= 1 && (!function __PRIVATE_createPrimaryClientStore(e) {
            e.createObjectStore(Q);
        }(e), function __PRIVATE_createMutationQueue(e) {
            e.createObjectStore(z, {
                keyPath: j
            });
            const t = e.createObjectStore(H, {
                keyPath: J,
                autoIncrement: !0
            });
            t.createIndex(Y, Z, {
                unique: !0
            }), e.createObjectStore(ee);
        }(e), __PRIVATE_createQueryCache(e), function __PRIVATE_createLegacyRemoteDocumentCache(e) {
            e.createObjectStore(W);
        }(e));
        // Migration 2 to populate the targetGlobal object no longer needed since
        // migration 3 unconditionally clears it.
        let s = PersistencePromise.resolve();
        return n < 3 && r >= 3 && // Brand new clients don't need to drop and recreate--only clients that
        // potentially have corrupt data.
        (0 !== n && (!function __PRIVATE_dropQueryCache(e) {
            e.deleteObjectStore(Ee), e.deleteObjectStore(ue), e.deleteObjectStore(Ie);
        }(e), __PRIVATE_createQueryCache(e)), s = s.next(()=>/**
 * Creates the target global singleton row.
 *
 * @param txn - The version upgrade transaction for indexeddb
 */ (function __PRIVATE_writeEmptyTargetGlobalEntry(e) {
                const t = e.store(Ie), n = {
                    highestTargetId: 0,
                    highestListenSequenceNumber: 0,
                    lastRemoteSnapshotVersion: SnapshotVersion.min().toTimestamp(),
                    targetCount: 0
                };
                return t.put(Re, n);
            })(i))), n < 4 && r >= 4 && (0 !== n && // Schema version 3 uses auto-generated keys to generate globally unique
        // mutation batch IDs (this was previously ensured internally by the
        // client). To migrate to the new schema, we have to read all mutations
        // and write them back out. We preserve the existing batch IDs to guarantee
        // consistency with other object stores. Any further mutation batch IDs will
        // be auto-generated.
        (s = s.next(()=>(function __PRIVATE_upgradeMutationBatchSchemaAndMigrateData(e, t) {
                const n = t.store(H);
                return n.H().next((n)=>{
                    e.deleteObjectStore(H);
                    e.createObjectStore(H, {
                        keyPath: J,
                        autoIncrement: !0
                    }).createIndex(Y, Z, {
                        unique: !0
                    });
                    const r = t.store(H), i = n.map((e)=>r.put(e));
                    return PersistencePromise.waitFor(i);
                });
            })(e, i))), s = s.next(()=>{
            !function __PRIVATE_createClientMetadataStore(e) {
                e.createObjectStore(de, {
                    keyPath: fe
                });
            }(e);
        })), n < 5 && r >= 5 && (s = s.next(()=>this.N_(i))), n < 6 && r >= 6 && (s = s.next(()=>((function __PRIVATE_createDocumentGlobalStore(e) {
                e.createObjectStore(oe);
            })(e), this.L_(i)))), n < 7 && r >= 7 && (s = s.next(()=>this.B_(i))), n < 8 && r >= 8 && (s = s.next(()=>this.U_(e, i))), n < 9 && r >= 9 && (s = s.next(()=>{
            // Multi-Tab used to manage its own changelog, but this has been moved
            // to the DbRemoteDocument object store itself. Since the previous change
            // log only contained transient data, we can drop its object store.
            !function __PRIVATE_dropRemoteDocumentChangesStore(e) {
                e.objectStoreNames.contains("remoteDocumentChanges") && e.deleteObjectStore("remoteDocumentChanges");
            }(e);
        // Note: Schema version 9 used to create a read time index for the
        // RemoteDocumentCache. This is now done with schema version 13.
        })), n < 10 && r >= 10 && (s = s.next(()=>this.k_(i))), n < 11 && r >= 11 && (s = s.next(()=>{
            !function __PRIVATE_createBundlesStore(e) {
                e.createObjectStore(me, {
                    keyPath: pe
                });
            }(e), function __PRIVATE_createNamedQueriesStore(e) {
                e.createObjectStore(ge, {
                    keyPath: ye
                });
            }(e);
        })), n < 12 && r >= 12 && (s = s.next(()=>{
            !function __PRIVATE_createDocumentOverlayStore(e) {
                const t = e.createObjectStore(Be, {
                    keyPath: Ue
                });
                t.createIndex(ke, qe, {
                    unique: !1
                }), t.createIndex($e, Ke, {
                    unique: !1
                });
            }(e);
        })), n < 13 && r >= 13 && (s = s.next(()=>(function __PRIVATE_createRemoteDocumentCache(e) {
                const t = e.createObjectStore(te, {
                    keyPath: ne
                });
                t.createIndex(re, ie), t.createIndex(se, _e);
            })(e)).next(()=>this.q_(e, i)).next(()=>e.deleteObjectStore(W))), n < 14 && r >= 14 && (s = s.next(()=>this.K_(e, i))), n < 15 && r >= 15 && (s = s.next(()=>(function __PRIVATE_createFieldIndex(e) {
                const t = e.createObjectStore(we, {
                    keyPath: be,
                    autoIncrement: !0
                });
                t.createIndex(ve, Se, {
                    unique: !1
                });
                const n = e.createObjectStore(De, {
                    keyPath: xe
                });
                n.createIndex(Ce, Fe, {
                    unique: !1
                });
                const r = e.createObjectStore(Oe, {
                    keyPath: Me
                });
                r.createIndex(Ne, Le, {
                    unique: !1
                });
            })(e))), n < 16 && r >= 16 && // Clear the object stores to remove possibly corrupted index entries
        (s = s.next(()=>{
            t.objectStore(De).clear();
        }).next(()=>{
            t.objectStore(Oe).clear();
        })), n < 17 && r >= 17 && (s = s.next(()=>{
            !function __PRIVATE_createGlobalsStore(e) {
                e.createObjectStore(We, {
                    keyPath: Qe
                });
            }(e);
        })), n < 18 && r >= 18 && (0, _util.isSafariOrWebkit)() && (s = s.next(()=>{
            t.objectStore(De).clear();
        }).next(()=>{
            t.objectStore(Oe).clear();
        })), s;
    }
    L_(e) {
        let t = 0;
        return e.store(W).ee((e, n)=>{
            t += __PRIVATE_dbDocumentSize(n);
        }).next(()=>{
            const n = {
                byteSize: t
            };
            return e.store(oe).put(ae, n);
        });
    }
    N_(e) {
        const t = e.store(z), n = e.store(H);
        return t.H().next((t)=>PersistencePromise.forEach(t, (t)=>{
                const r = IDBKeyRange.bound([
                    t.userId,
                    $
                ], [
                    t.userId,
                    t.lastAcknowledgedBatchId
                ]);
                return n.H(Y, r).next((n)=>PersistencePromise.forEach(n, (n)=>{
                        __PRIVATE_hardAssert(n.userId === t.userId, 18650, "Cannot process batch from unexpected user", {
                            batchId: n.batchId
                        });
                        const r = __PRIVATE_fromDbMutationBatch(this.serializer, n);
                        return removeMutationBatch(e, t.userId, r).next(()=>{});
                    }));
            }));
    }
    /**
     * Ensures that every document in the remote document cache has a corresponding sentinel row
     * with a sequence number. Missing rows are given the most recently used sequence number.
     */ B_(e) {
        const t = e.store(Ee), n = e.store(W);
        return e.store(Ie).get(Re).next((e)=>{
            const r = [];
            return n.ee((n, i)=>{
                const s = new ResourcePath(n), _ = function __PRIVATE_sentinelKey(e) {
                    return [
                        0,
                        __PRIVATE_encodeResourcePath(e)
                    ];
                }(s);
                r.push(t.get(_).next((n)=>n ? PersistencePromise.resolve() : ((n)=>t.put({
                            targetId: 0,
                            path: __PRIVATE_encodeResourcePath(n),
                            sequenceNumber: e.highestListenSequenceNumber
                        }))(s)));
            }).next(()=>PersistencePromise.waitFor(r));
        });
    }
    U_(e, t) {
        // Create the index.
        e.createObjectStore(Ae, {
            keyPath: Ve
        });
        const n = t.store(Ae), r = new __PRIVATE_MemoryCollectionParentIndex, addEntry = (e)=>{
            if (r.add(e)) {
                const t = e.lastSegment(), r = e.popLast();
                return n.put({
                    collectionId: t,
                    parent: __PRIVATE_encodeResourcePath(r)
                });
            }
        };
        // Helper to add an index entry iff we haven't already written it.
        // Index existing remote documents.
        return t.store(W).ee({
            X: !0
        }, (e, t)=>{
            const n = new ResourcePath(e);
            return addEntry(n.popLast());
        }).next(()=>t.store(ee).ee({
                X: !0
            }, ([e, t, n], r)=>{
                const i = __PRIVATE_decodeResourcePath(t);
                return addEntry(i.popLast());
            }));
    }
    k_(e) {
        const t = e.store(ue);
        return t.ee((e, n)=>{
            const r = __PRIVATE_fromDbTarget(this.serializer, n), i = __PRIVATE_toDbTarget(this.serializer, r);
            return t.put(i);
        });
    }
    q_(e, t) {
        const n = t.store(W), r = [];
        return n.ee((e, n)=>{
            const i = t.store(te), s = (function __PRIVATE_extractKey(e) {
                return e.document ? new DocumentKey(ResourcePath.fromString(e.document.name).popFirst(5)) : e.noDocument ? DocumentKey.fromSegments(e.noDocument.path) : e.unknownDocument ? DocumentKey.fromSegments(e.unknownDocument.path) : fail(36783);
            })(n).path.toArray(), _ = {
                prefixPath: s.slice(0, s.length - 2),
                collectionGroup: s[s.length - 2],
                documentId: s[s.length - 1],
                readTime: n.readTime || [
                    0,
                    0
                ],
                unknownDocument: n.unknownDocument,
                noDocument: n.noDocument,
                document: n.document,
                hasCommittedMutations: !!n.hasCommittedMutations
            };
            r.push(i.put(_));
        }).next(()=>PersistencePromise.waitFor(r));
    }
    K_(e, t) {
        const n = t.store(H), r = __PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), i = new __PRIVATE_MemoryPersistence(__PRIVATE_MemoryEagerDelegate.C_, this.serializer.zr);
        return n.H().next((e)=>{
            const n = new Map;
            return e.forEach((e)=>{
                let t = n.get(e.userId) ?? __PRIVATE_documentKeySet();
                __PRIVATE_fromDbMutationBatch(this.serializer, e).keys().forEach((e)=>t = t.add(e)), n.set(e.userId, t);
            }), PersistencePromise.forEach(n, (e, n)=>{
                const s = new User(n), _ = __PRIVATE_IndexedDbDocumentOverlayCache.jr(this.serializer, s), o = i.getIndexManager(s), a = __PRIVATE_IndexedDbMutationQueue.jr(s, this.serializer, o, i.referenceDelegate);
                return new LocalDocumentsView(r, a, _, o).recalculateAndSaveOverlaysForDocumentKeys(new __PRIVATE_IndexedDbTransaction(t, __PRIVATE_ListenSequence.ce), e).next();
            });
        });
    }
}
function __PRIVATE_createQueryCache(e) {
    e.createObjectStore(Ee, {
        keyPath: he
    }).createIndex(Te, Pe, {
        unique: !0
    });
    // NOTE: This is unique only because the TargetId is the suffix.
    e.createObjectStore(ue, {
        keyPath: "targetId"
    }).createIndex(ce, le, {
        unique: !0
    }), e.createObjectStore(Ie);
}
const rn = "IndexedDbPersistence", sn = 18e5, _n = 5e3, on = "Failed to obtain exclusive access to the persistence layer. To allow shared access, multi-tab synchronization has to be enabled in all tabs. If you are using `experimentalForceOwningTab:true`, make sure that only one tab has persistence enabled at any given time.", an = "main";
/**
 * Oldest acceptable age in milliseconds for client metadata before the client
 * is considered inactive and its associated data is garbage collected.
 */ /**
 * An IndexedDB-backed instance of Persistence. Data is stored persistently
 * across sessions.
 *
 * On Web only, the Firestore SDKs support shared access to its persistence
 * layer. This allows multiple browser tabs to read and write to IndexedDb and
 * to synchronize state even without network connectivity. Shared access is
 * currently optional and not enabled unless all clients invoke
 * `enablePersistence()` with `{synchronizeTabs:true}`.
 *
 * In multi-tab mode, if multiple clients are active at the same time, the SDK
 * will designate one client as the "primary client". An effort is made to pick
 * a visible, network-connected and active client, and this client is
 * responsible for letting other clients know about its presence. The primary
 * client writes a unique client-generated identifier (the client ID) to
 * IndexedDb’s "owner" store every 4 seconds. If the primary client fails to
 * update this entry, another client can acquire the lease and take over as
 * primary.
 *
 * Some persistence operations in the SDK are designated as primary-client only
 * operations. This includes the acknowledgment of mutations and all updates of
 * remote documents. The effects of these operations are written to persistence
 * and then broadcast to other tabs via LocalStorage (see
 * `WebStorageSharedClientState`), which then refresh their state from
 * persistence.
 *
 * Similarly, the primary client listens to notifications sent by secondary
 * clients to discover persistence changes written by secondary clients, such as
 * the addition of new mutations and query targets.
 *
 * If multi-tab is not enabled and another tab already obtained the primary
 * lease, IndexedDbPersistence enters a failed state and all subsequent
 * operations will automatically fail.
 *
 * Additionally, there is an optimization so that when a tab is closed, the
 * primary lease is released immediately (this is especially important to make
 * sure that a refreshed tab is able to immediately re-acquire the primary
 * lease). Unfortunately, IndexedDB cannot be reliably used in window.unload
 * since it is an asynchronous API. So in addition to attempting to give up the
 * lease, the leaseholder writes its client ID to a "zombiedClient" entry in
 * LocalStorage which acts as an indicator that another tab should go ahead and
 * take the primary lease immediately regardless of the current lease timestamp.
 *
 * TODO(b/114226234): Remove `synchronizeTabs` section when multi-tab is no
 * longer optional.
 */ class __PRIVATE_IndexedDbPersistence {
    constructor(/**
     * Whether to synchronize the in-memory state of multiple tabs and share
     * access to local persistence.
     */ e, t, n, r, i, s, _, o, a, /**
     * If set to true, forcefully obtains database access. Existing tabs will
     * no longer be able to access IndexedDB.
     */ u, c = 18){
        if (this.allowTabSynchronization = e, this.persistenceKey = t, this.clientId = n, this.Tn = i, this.window = s, this.document = _, this.W_ = a, this.Q_ = u, this.G_ = c, this.f_ = null, this.m_ = !1, this.isPrimary = !1, this.networkEnabled = !0, /** Our window.unload handler, if registered. */ this.z_ = null, this.inForeground = !1, /** Our 'visibilitychange' listener if registered. */ this.j_ = null, /** The client metadata refresh task. */ this.H_ = null, /** The last time we garbage collected the client metadata object store. */ this.J_ = Number.NEGATIVE_INFINITY, /** A listener to notify on primary state changes. */ this.Y_ = (e)=>Promise.resolve(), !__PRIVATE_IndexedDbPersistence.C()) throw new FirestoreError(D.UNIMPLEMENTED, "This platform is either missing IndexedDB or is known to have an incomplete implementation. Offline persistence has been disabled.");
        this.referenceDelegate = new __PRIVATE_IndexedDbLruDelegateImpl(this, r), this.Z_ = t + an, this.serializer = new __PRIVATE_LocalSerializer(o), this.X_ = new __PRIVATE_SimpleDb(this.Z_, this.G_, new __PRIVATE_SchemaConverter(this.serializer)), this.p_ = new __PRIVATE_IndexedDbGlobalsCache, this.g_ = new __PRIVATE_IndexedDbTargetCache(this.referenceDelegate, this.serializer), this.remoteDocumentCache = __PRIVATE_newIndexedDbRemoteDocumentCache(this.serializer), this.w_ = new __PRIVATE_IndexedDbBundleCache, this.window && this.window.localStorage ? this.eo = this.window.localStorage : (this.eo = null, !1 === u && __PRIVATE_logError(rn, "LocalStorage is unavailable. As a result, persistence may not work reliably. In particular enablePersistence() could fail immediately after refreshing the page."));
    }
    /**
     * Attempt to start IndexedDb persistence.
     *
     * @returns Whether persistence was enabled.
     */ start() {
        // NOTE: This is expected to fail sometimes (in the case of another tab
        // already having the persistence lock), so it's the first thing we should
        // do.
        return this.no().then(()=>{
            if (!this.isPrimary && !this.allowTabSynchronization) // Fail `start()` if `synchronizeTabs` is disabled and we cannot
            // obtain the primary lease.
            throw new FirestoreError(D.FAILED_PRECONDITION, on);
            return this.ro(), this.io(), this.so(), this.runTransaction("getHighestListenSequenceNumber", "readonly", (e)=>this.g_.getHighestSequenceNumber(e));
        }).then((e)=>{
            this.f_ = new __PRIVATE_ListenSequence(e, this.W_);
        }).then(()=>{
            this.m_ = !0;
        }).catch((e)=>(this.X_ && this.X_.close(), Promise.reject(e)));
    }
    /**
     * Registers a listener that gets called when the primary state of the
     * instance changes. Upon registering, this listener is invoked immediately
     * with the current primary state.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ _o(e) {
        return this.Y_ = async (t)=>{
            if (this.started) return e(t);
        }, e(this.isPrimary);
    }
    /**
     * Registers a listener that gets called when the database receives a
     * version change event indicating that it has deleted.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setDatabaseDeletedListener(e) {
        this.X_.q(async (t)=>{
            // Check if an attempt is made to delete IndexedDB.
            null === t.newVersion && await e();
        });
    }
    /**
     * Adjusts the current network state in the client's metadata, potentially
     * affecting the primary lease.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ setNetworkEnabled(e) {
        this.networkEnabled !== e && (this.networkEnabled = e, // Schedule a primary lease refresh for immediate execution. The eventual
        // lease update will be propagated via `primaryStateListener`.
        this.Tn.enqueueAndForget(async ()=>{
            this.started && await this.no();
        }));
    }
    /**
     * Updates the client metadata in IndexedDb and attempts to either obtain or
     * extend the primary lease for the local client. Asynchronously notifies the
     * primary state listener if the client either newly obtained or released its
     * primary lease.
     */ no() {
        return this.runTransaction("updateClientMetadataAndTryBecomePrimary", "readwrite", (e)=>__PRIVATE_clientMetadataStore(e).put({
                clientId: this.clientId,
                updateTimeMs: Date.now(),
                networkEnabled: this.networkEnabled,
                inForeground: this.inForeground
            }).next(()=>{
                if (this.isPrimary) return this.oo(e).next((e)=>{
                    e || (this.isPrimary = !1, this.Tn.enqueueRetryable(()=>this.Y_(!1)));
                });
            }).next(()=>this.ao(e)).next((t)=>this.isPrimary && !t ? this.uo(e).next(()=>!1) : !!t && this.co(e).next(()=>!0))).catch((e)=>{
            if (__PRIVATE_isIndexedDbTransactionError(e)) // Proceed with the existing state. Any subsequent access to
            // IndexedDB will verify the lease.
            return __PRIVATE_logDebug(rn, "Failed to extend owner lease: ", e), this.isPrimary;
            if (!this.allowTabSynchronization) throw e;
            return __PRIVATE_logDebug(rn, "Releasing owner lease after error during lease refresh", e), /* isPrimary= */ !1;
        }).then((e)=>{
            this.isPrimary !== e && this.Tn.enqueueRetryable(()=>this.Y_(e)), this.isPrimary = e;
        });
    }
    oo(e) {
        return __PRIVATE_primaryClientStore(e).get(G).next((e)=>PersistencePromise.resolve(this.lo(e)));
    }
    Eo(e) {
        return __PRIVATE_clientMetadataStore(e).delete(this.clientId);
    }
    /**
     * If the garbage collection threshold has passed, prunes the
     * RemoteDocumentChanges and the ClientMetadata store based on the last update
     * time of all clients.
     */ async ho() {
        if (this.isPrimary && !this.To(this.J_, sn)) {
            this.J_ = Date.now();
            const e = await this.runTransaction("maybeGarbageCollectMultiClientState", "readwrite-primary", (e)=>{
                const t = __PRIVATE_getStore(e, de);
                return t.H().next((e)=>{
                    const n = this.Po(e, sn), r = e.filter((e)=>-1 === n.indexOf(e));
                    // Delete metadata for clients that are no longer considered active.
                    return PersistencePromise.forEach(r, (e)=>t.delete(e.clientId)).next(()=>r);
                });
            }).catch(()=>[]);
            // Delete potential leftover entries that may continue to mark the
            // inactive clients as zombied in LocalStorage.
            // Ideally we'd delete the IndexedDb and LocalStorage zombie entries for
            // the client atomically, but we can't. So we opt to delete the IndexedDb
            // entries first to avoid potentially reviving a zombied client.
            if (this.eo) for (const t of e)this.eo.removeItem(this.Ro(t.clientId));
        }
    }
    /**
     * Schedules a recurring timer to update the client metadata and to either
     * extend or acquire the primary lease if the client is eligible.
     */ so() {
        this.H_ = this.Tn.enqueueAfterDelay("client_metadata_refresh" /* TimerId.ClientMetadataRefresh */ , 4e3, ()=>this.no().then(()=>this.ho()).then(()=>this.so()));
    }
    /** Checks whether `client` is the local client. */ lo(e) {
        return !!e && e.ownerId === this.clientId;
    }
    /**
     * Evaluate the state of all active clients and determine whether the local
     * client is or can act as the holder of the primary lease. Returns whether
     * the client is eligible for the lease, but does not actually acquire it.
     * May return 'false' even if there is no active leaseholder and another
     * (foreground) client should become leaseholder instead.
     */ ao(e) {
        if (this.Q_) return PersistencePromise.resolve(!0);
        return __PRIVATE_primaryClientStore(e).get(G).next((t)=>{
            // A client is eligible for the primary lease if:
            // - its network is enabled and the client's tab is in the foreground.
            // - its network is enabled and no other client's tab is in the
            //   foreground.
            // - every clients network is disabled and the client's tab is in the
            //   foreground.
            // - every clients network is disabled and no other client's tab is in
            //   the foreground.
            // - the `forceOwningTab` setting was passed in.
            if (null !== t && this.To(t.leaseTimestampMs, _n) && !this.Io(t.ownerId)) {
                if (this.lo(t) && this.networkEnabled) return !0;
                if (!this.lo(t)) {
                    if (!t.allowTabSynchronization) // Fail the `canActAsPrimary` check if the current leaseholder has
                    // not opted into multi-tab synchronization. If this happens at
                    // client startup, we reject the Promise returned by
                    // `enablePersistence()` and the user can continue to use Firestore
                    // with in-memory persistence.
                    // If this fails during a lease refresh, we will instead block the
                    // AsyncQueue from executing further operations. Note that this is
                    // acceptable since mixing & matching different `synchronizeTabs`
                    // settings is not supported.
                    // TODO(b/114226234): Remove this check when `synchronizeTabs` can
                    // no longer be turned off.
                    throw new FirestoreError(D.FAILED_PRECONDITION, on);
                    return !1;
                }
            }
            return !(!this.networkEnabled || !this.inForeground) || __PRIVATE_clientMetadataStore(e).H().next((e)=>void 0 === this.Po(e, _n).find((e)=>{
                    if (this.clientId !== e.clientId) {
                        const t = !this.networkEnabled && e.networkEnabled, n = !this.inForeground && e.inForeground, r = this.networkEnabled === e.networkEnabled;
                        if (t || n && r) return !0;
                    }
                    return !1;
                }));
        }).next((e)=>(this.isPrimary !== e && __PRIVATE_logDebug(rn, `Client ${e ? "is" : "is not"} eligible for a primary lease.`), e));
    }
    async shutdown() {
        // The shutdown() operations are idempotent and can be called even when
        // start() aborted (e.g. because it couldn't acquire the persistence lease).
        this.m_ = !1, this.Ao(), this.H_ && (this.H_.cancel(), this.H_ = null), this.Vo(), this.fo(), // Use `SimpleDb.runTransaction` directly to avoid failing if another tab
        // has obtained the primary lease.
        await this.X_.runTransaction("shutdown", "readwrite", [
            Q,
            de
        ], (e)=>{
            const t = new __PRIVATE_IndexedDbTransaction(e, __PRIVATE_ListenSequence.ce);
            return this.uo(t).next(()=>this.Eo(t));
        }), this.X_.close(), // Remove the entry marking the client as zombied from LocalStorage since
        // we successfully deleted its metadata from IndexedDb.
        this.mo();
    }
    /**
     * Returns clients that are not zombied and have an updateTime within the
     * provided threshold.
     */ Po(e, t) {
        return e.filter((e)=>this.To(e.updateTimeMs, t) && !this.Io(e.clientId));
    }
    /**
     * Returns the IDs of the clients that are currently active. If multi-tab
     * is not supported, returns an array that only contains the local client's
     * ID.
     *
     * PORTING NOTE: This is only used for Web multi-tab.
     */ po() {
        return this.runTransaction("getActiveClients", "readonly", (e)=>__PRIVATE_clientMetadataStore(e).H().next((e)=>this.Po(e, sn).map((e)=>e.clientId)));
    }
    get started() {
        return this.m_;
    }
    getGlobalsCache() {
        return this.p_;
    }
    getMutationQueue(e, t) {
        return __PRIVATE_IndexedDbMutationQueue.jr(e, this.serializer, t, this.referenceDelegate);
    }
    getTargetCache() {
        return this.g_;
    }
    getRemoteDocumentCache() {
        return this.remoteDocumentCache;
    }
    getIndexManager(e) {
        return new __PRIVATE_IndexedDbIndexManager(e, this.serializer.zr.databaseId);
    }
    getDocumentOverlayCache(e) {
        return __PRIVATE_IndexedDbDocumentOverlayCache.jr(this.serializer, e);
    }
    getBundleCache() {
        return this.w_;
    }
    runTransaction(e, t, n) {
        __PRIVATE_logDebug(rn, "Starting transaction:", e);
        const r = "readonly" === t ? "readonly" : "readwrite", i = /** Returns the object stores for the provided schema. */ function __PRIVATE_getObjectStores(e) {
            return 18 === e ? Xe : 17 === e ? Ze : 16 === e ? Ye : 15 === e ? Je : 14 === e ? He : 13 === e ? je : 12 === e ? ze : 11 === e ? Ge : void fail(60245);
        }(this.G_);
        let s;
        // Do all transactions as readwrite against all object stores, since we
        // are the only reader/writer.
        return this.X_.runTransaction(e, r, i, (r)=>(s = new __PRIVATE_IndexedDbTransaction(r, this.f_ ? this.f_.next() : __PRIVATE_ListenSequence.ce), "readwrite-primary" === t ? this.oo(s).next((e)=>!!e || this.ao(s)).next((t)=>{
                if (!t) throw __PRIVATE_logError(`Failed to obtain primary lease for action '${e}'.`), this.isPrimary = !1, this.Tn.enqueueRetryable(()=>this.Y_(!1)), new FirestoreError(D.FAILED_PRECONDITION, B);
                return n(s);
            }).next((e)=>this.co(s).next(()=>e)) : this.yo(s).next(()=>n(s)))).then((e)=>(s.raiseOnCommittedEvent(), e));
    }
    /**
     * Verifies that the current tab is the primary leaseholder or alternatively
     * that the leaseholder has opted into multi-tab synchronization.
     */ // TODO(b/114226234): Remove this check when `synchronizeTabs` can no longer
    // be turned off.
    yo(e) {
        return __PRIVATE_primaryClientStore(e).get(G).next((e)=>{
            if (null !== e && this.To(e.leaseTimestampMs, _n) && !this.Io(e.ownerId) && !this.lo(e) && !(this.Q_ || this.allowTabSynchronization && e.allowTabSynchronization)) throw new FirestoreError(D.FAILED_PRECONDITION, on);
        });
    }
    /**
     * Obtains or extends the new primary lease for the local client. This
     * method does not verify that the client is eligible for this lease.
     */ co(e) {
        const t = {
            ownerId: this.clientId,
            allowTabSynchronization: this.allowTabSynchronization,
            leaseTimestampMs: Date.now()
        };
        return __PRIVATE_primaryClientStore(e).put(G, t);
    }
    static C() {
        return __PRIVATE_SimpleDb.C();
    }
    /** Checks the primary lease and removes it if we are the current primary. */ uo(e) {
        const t = __PRIVATE_primaryClientStore(e);
        return t.get(G).next((e)=>this.lo(e) ? (__PRIVATE_logDebug(rn, "Releasing primary lease."), t.delete(G)) : PersistencePromise.resolve());
    }
    /** Verifies that `updateTimeMs` is within `maxAgeMs`. */ To(e, t) {
        const n = Date.now();
        return !(e < n - t) && (!(e > n) || (__PRIVATE_logError(`Detected an update time that is in the future: ${e} > ${n}`), !1));
    }
    ro() {
        null !== this.document && "function" == typeof this.document.addEventListener && (this.j_ = ()=>{
            this.Tn.enqueueAndForget(()=>(this.inForeground = "visible" === this.document.visibilityState, this.no()));
        }, this.document.addEventListener("visibilitychange", this.j_), this.inForeground = "visible" === this.document.visibilityState);
    }
    Vo() {
        this.j_ && (this.document.removeEventListener("visibilitychange", this.j_), this.j_ = null);
    }
    /**
     * Attaches a window.unload handler that will synchronously write our
     * clientId to a "zombie client id" location in LocalStorage. This can be used
     * by tabs trying to acquire the primary lease to determine that the lease
     * is no longer valid even if the timestamp is recent. This is particularly
     * important for the refresh case (so the tab correctly re-acquires the
     * primary lease). LocalStorage is used for this rather than IndexedDb because
     * it is a synchronous API and so can be used reliably from  an unload
     * handler.
     */ io() {
        "function" == typeof this.window?.addEventListener && (this.z_ = ()=>{
            // Note: In theory, this should be scheduled on the AsyncQueue since it
            // accesses internal state. We execute this code directly during shutdown
            // to make sure it gets a chance to run.
            this.Ao();
            const e = /(?:Version|Mobile)\/1[456]/;
            (0, _util.isSafari)() && (navigator.appVersion.match(e) || navigator.userAgent.match(e)) && // On Safari 14, 15, and 16, we do not run any cleanup actions as it might
            // trigger a bug that prevents Safari from re-opening IndexedDB during
            // the next page load.
            // See https://bugs.webkit.org/show_bug.cgi?id=226547
            this.Tn.enterRestrictedMode(/* purgeExistingTasks= */ !0), this.Tn.enqueueAndForget(()=>this.shutdown());
        }, this.window.addEventListener("pagehide", this.z_));
    }
    fo() {
        this.z_ && (this.window.removeEventListener("pagehide", this.z_), this.z_ = null);
    }
    /**
     * Returns whether a client is "zombied" based on its LocalStorage entry.
     * Clients become zombied when their tab closes without running all of the
     * cleanup logic in `shutdown()`.
     */ Io(e) {
        try {
            const t = null !== this.eo?.getItem(this.Ro(e));
            return __PRIVATE_logDebug(rn, `Client '${e}' ${t ? "is" : "is not"} zombied in LocalStorage`), t;
        } catch (e) {
            // Gracefully handle if LocalStorage isn't working.
            return __PRIVATE_logError(rn, "Failed to get zombied client id.", e), !1;
        }
    }
    /**
     * Record client as zombied (a client that had its tab closed). Zombied
     * clients are ignored during primary tab selection.
     */ Ao() {
        if (this.eo) try {
            this.eo.setItem(this.Ro(this.clientId), String(Date.now()));
        } catch (e) {
            // Gracefully handle if LocalStorage isn't available / working.
            __PRIVATE_logError("Failed to set zombie client id.", e);
        }
    }
    /** Removes the zombied client entry if it exists. */ mo() {
        if (this.eo) try {
            this.eo.removeItem(this.Ro(this.clientId));
        } catch (e) {
        // Ignore
        }
    }
    Ro(e) {
        return `firestore_zombie_${this.persistenceKey}_${e}`;
    }
}
/**
 * Helper to get a typed SimpleDbStore for the primary client object store.
 */ function __PRIVATE_primaryClientStore(e) {
    return __PRIVATE_getStore(e, Q);
}
/**
 * Helper to get a typed SimpleDbStore for the client metadata object store.
 */ function __PRIVATE_clientMetadataStore(e) {
    return __PRIVATE_getStore(e, de);
}
/**
 * Generates a string used as a prefix when storing data in IndexedDB and
 * LocalStorage.
 */ function __PRIVATE_indexedDbStoragePrefix(e, t) {
    // Use two different prefix formats:
    //   * firestore / persistenceKey / projectID . databaseID / ...
    //   * firestore / persistenceKey / projectID / ...
    // projectIDs are DNS-compatible names and cannot contain dots
    // so there's no danger of collisions.
    let n = e.projectId;
    return e.isDefaultDatabase || (n += "." + e.database), "firestore/" + t + "/" + n + "/";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A set of changes to what documents are currently in view and out of view for
 * a given query. These changes are sent to the LocalStore by the View (via
 * the SyncEngine) and are used to pin / unpin documents as appropriate.
 */ class __PRIVATE_LocalViewChanges {
    constructor(e, t, n, r){
        this.targetId = e, this.fromCache = t, this.wo = n, this.bo = r;
    }
    static vo(e, t) {
        let n = __PRIVATE_documentKeySet(), r = __PRIVATE_documentKeySet();
        for (const e of t.docChanges)switch(e.type){
            case 0 /* ChangeType.Added */ :
                n = n.add(e.doc.key);
                break;
            case 1 /* ChangeType.Removed */ :
                r = r.add(e.doc.key);
        }
        return new __PRIVATE_LocalViewChanges(e, t.fromCache, n, r);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function __PRIVATE_compareByKey(e, t) {
    return DocumentKey.comparator(e.key, t.key);
}
/**
 * @license
 * Copyright 2023 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A tracker to keep a record of important details during database local query
 * execution.
 */ class QueryContext {
    constructor(){
        /**
         * Counts the number of documents passed through during local query execution.
         */ this._documentReadCount = 0;
    }
    get documentReadCount() {
        return this._documentReadCount;
    }
    incrementDocumentReadCount(e) {
        this._documentReadCount += e;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * The Firestore query engine.
 *
 * Firestore queries can be executed in three modes. The Query Engine determines
 * what mode to use based on what data is persisted. The mode only determines
 * the runtime complexity of the query - the result set is equivalent across all
 * implementations.
 *
 * The Query engine will use indexed-based execution if a user has configured
 * any index that can be used to execute query (via `setIndexConfiguration()`).
 * Otherwise, the engine will try to optimize the query by re-using a previously
 * persisted query result. If that is not possible, the query will be executed
 * via a full collection scan.
 *
 * Index-based execution is the default when available. The query engine
 * supports partial indexed execution and merges the result from the index
 * lookup with documents that have not yet been indexed. The index evaluation
 * matches the backend's format and as such, the SDK can use indexing for all
 * queries that the backend supports.
 *
 * If no index exists, the query engine tries to take advantage of the target
 * document mapping in the TargetCache. These mappings exists for all queries
 * that have been synced with the backend at least once and allow the query
 * engine to only read documents that previously matched a query plus any
 * documents that were edited after the query was last listened to.
 *
 * There are some cases when this optimization is not guaranteed to produce
 * the same results as full collection scans. In these cases, query
 * processing falls back to full scans. These cases are:
 *
 * - Limit queries where a document that matched the query previously no longer
 *   matches the query.
 *
 * - Limit queries where a document edit may cause the document to sort below
 *   another document that is in the local cache.
 *
 * - Queries that have never been CURRENT or free of limbo documents.
 */ class __PRIVATE_QueryEngine {
    constructor(){
        this.So = !1, this.Do = !1, /**
         * SDK only decides whether it should create index when collection size is
         * larger than this.
         */ this.xo = 100, this.Co = /**
 * This cost represents the evaluation result of
 * (([index, docKey] + [docKey, docContent]) per document in the result set)
 * / ([docKey, docContent] per documents in full collection scan) coming from
 * experiment [enter PR experiment URL here].
 */ function __PRIVATE_getDefaultRelativeIndexReadCostPerDocument() {
            // These values were derived from an experiment where several members of the
            // Firestore SDK team ran a performance test in various environments.
            // Googlers can see b/299284287 for details.
            return (0, _util.isSafari)() ? 8 : __PRIVATE_getAndroidVersion((0, _util.getUA)()) > 0 ? 6 : 4;
        }();
    }
    /** Sets the document view to query against. */ initialize(e, t) {
        this.Fo = e, this.indexManager = t, this.So = !0;
    }
    /** Returns all local documents matching the specified query. */ getDocumentsMatchingQuery(e, t, n, r) {
        // Stores the result from executing the query; using this object is more
        // convenient than passing the result between steps of the persistence
        // transaction and improves readability comparatively.
        const i = {
            result: null
        };
        return this.Oo(e, t).next((e)=>{
            i.result = e;
        }).next(()=>{
            if (!i.result) return this.Mo(e, t, r, n).next((e)=>{
                i.result = e;
            });
        }).next(()=>{
            if (i.result) return;
            const n = new QueryContext;
            return this.No(e, t, n).next((r)=>{
                if (i.result = r, this.Do) return this.Lo(e, t, n, r.size);
            });
        }).next(()=>i.result);
    }
    Lo(e, t, n, r) {
        return __PRIVATE_isPipeline(t) ? PersistencePromise.resolve() : n.documentReadCount < this.xo ? (__PRIVATE_getLogLevel() <= (0, _logger.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "SDK will not create cache indexes for query:", __PRIVATE_stringifyQuery(t), "since it only creates cache indexes for collection contains", "more than or equal to", this.xo, "documents"), PersistencePromise.resolve()) : (__PRIVATE_getLogLevel() <= (0, _logger.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "Query:", __PRIVATE_stringifyQuery(t), "scans", n.documentReadCount, "local documents and returns", r, "documents as results."), n.documentReadCount > this.Co * r ? (__PRIVATE_getLogLevel() <= (0, _logger.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "The SDK decides to create cache indexes for query:", __PRIVATE_stringifyQuery(t), "as using cache indexes may help improve performance."), this.indexManager.createTargetIndexes(e, __PRIVATE_queryToTarget(t))) : PersistencePromise.resolve());
    }
    /**
     * Performs an indexed query that evaluates the query based on a collection's
     * persisted index values. Returns `null` if an index is not available.
     */ Oo(e, t) {
        if (__PRIVATE_isPipeline(t)) return PersistencePromise.resolve(null);
        let n = t;
        if (__PRIVATE_queryMatchesAllDocuments(n)) // Queries that match all documents don't benefit from using
        // key-based lookups. It is more efficient to scan all documents in a
        // collection, rather than to perform individual lookups.
        return PersistencePromise.resolve(null);
        let r = __PRIVATE_queryToTarget(n);
        return this.indexManager.getIndexType(e, r).next((t)=>0 /* IndexType.NONE */  === t ? null : (null !== n.limit && 1 /* IndexType.PARTIAL */  === t && // We cannot apply a limit for targets that are served using a partial
            // index. If a partial index will be used to serve the target, the
            // query may return a superset of documents that match the target
            // (e.g. if the index doesn't include all the target's filters), or
            // may return the correct set of documents in the wrong order (e.g. if
            // the index doesn't include a segment for one of the orderBys).
            // Therefore, a limit should not be applied in such cases.
            (n = __PRIVATE_queryWithLimit(n, null, "F" /* LimitType.First */ ), r = __PRIVATE_queryToTarget(n)), this.indexManager.getDocumentsMatchingTarget(e, r).next((t)=>{
                const i = __PRIVATE_documentKeySet(...t);
                return this.Fo.getDocuments(e, i).next((t)=>this.indexManager.getMinOffset(e, r).next((r)=>{
                        const s = this.Bo(n, t);
                        return this.Uo(n, s, i, r.readTime) ? this.Oo(e, __PRIVATE_queryWithLimit(n, null, "F" /* LimitType.First */ )) : this.ko(e, s, n, r);
                    }));
            })));
    }
    /**
     * Performs a query based on the target's persisted query mapping. Returns
     * `null` if the mapping is not available or cannot be used.
     */ Mo(e, t, n, r) {
        return (__PRIVATE_isPipeline(t) ? function __PRIVATE_pipelineMatchesAllDocuments(e) {
            for (const t of e.stages){
                if (t instanceof __PRIVATE_Limit || t instanceof __PRIVATE_Offset) return !1;
                // Check if it's the special 'exists(__name__)' case
                if (t instanceof __PRIVATE_Where) {
                    if (t.condition instanceof __PRIVATE_BooleanFunctionExpression && "exists" === t.condition._expr.name && t.condition._expr.params[0] instanceof Field && t.condition._expr.params[0].fieldName === F) continue;
                    return !1;
                }
            }
            return !0;
        }(t) : __PRIVATE_queryMatchesAllDocuments(t)) || r.isEqual(SnapshotVersion.min()) ? PersistencePromise.resolve(null) : this.Fo.getDocuments(e, n).next((i)=>{
            const s = this.Bo(t, i);
            return this.Uo(t, s, n, r) ? PersistencePromise.resolve(null) : (__PRIVATE_getLogLevel() <= (0, _logger.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "Re-using previous result from %s to execute query: %s", r.toString(), __PRIVATE_stringifyQueryOrPipeline(t)), this.ko(e, s, t, __PRIVATE_newIndexOffsetSuccessorFromReadTime(r, L)).next((e)=>e));
        });
    // Queries that have never seen a snapshot without limbo free documents
    // should also be run as a full collection scan.
    }
    /** Applies the query filter and sorting to the provided documents.  */ Bo(e, t) {
        let n, r;
        return __PRIVATE_isPipeline(e) ? // TODO(pipeline): the order here does not actually matter, not until we implement
        // refill logic for pipelines as well.
        (n = new SortedSet(__PRIVATE_compareByKey), r = (t)=>__PRIVATE_pipelineMatches(e, t)) : // Sort the documents and re-apply the query filter since previously
        // matching documents do not necessarily still match the query.
        (n = new SortedSet(__PRIVATE_newQueryComparator(e)), r = (t)=>__PRIVATE_queryMatches(e, t)), t.forEach((e, t)=>{
            r(t) && (n = n.add(t));
        }), n;
    }
    /**
     * Determines if a limit query needs to be refilled from cache, making it
     * ineligible for index-free execution.
     *
     * @param query - The query.
     * @param sortedPreviousResults - The documents that matched the query when it
     * was last synchronized, sorted by the query's comparator.
     * @param remoteKeys - The document keys that matched the query at the last
     * snapshot.
     * @param limboFreeSnapshotVersion - The version of the snapshot when the
     * query was last synchronized.
     */ Uo(e, t, n, r) {
        // TODO(pipeline): For pipelines it is simple for now, we refill for all limit/offset.
        // we should implement a similar approach for query at some point.
        if (__PRIVATE_isPipeline(e)) return function __PRIVATE_pipelineHasRanges(e) {
            return e.stages.some((e)=>e instanceof __PRIVATE_Limit || e instanceof __PRIVATE_Offset);
        }(e);
        if (null === e.limit) // Queries without limits do not need to be refilled.
        return !1;
        if (n.size !== t.size) // The query needs to be refilled if a previously matching document no
        // longer matches.
        return !0;
        // Limit queries are not eligible for index-free query execution if there is
        // a potential that an older document from cache now sorts before a document
        // that was previously part of the limit. This, however, can only happen if
        // the document at the edge of the limit goes out of limit.
        // If a document that is not the limit boundary sorts differently,
        // the boundary of the limit itself did not change and documents from cache
        // will continue to be "rejected" by this boundary. Therefore, we can ignore
        // any modifications that don't affect the last document.
        const i = "F" /* LimitType.First */  === e.limitType ? t.last() : t.first();
        return !!i && (i.hasPendingWrites || i.version.compareTo(r) > 0);
    }
    No(e, t, n) {
        return __PRIVATE_getLogLevel() <= (0, _logger.LogLevel).DEBUG && __PRIVATE_logDebug("QueryEngine", "Using full collection scan to execute query:", __PRIVATE_stringifyQueryOrPipeline(t)), this.Fo.getDocumentsMatchingQuery(e, t, IndexOffset.min(), n);
    }
    /**
     * Combines the results from an indexed execution with the remaining documents
     * that have not yet been indexed.
     */ ko(e, t, n, r) {
        // Retrieve all results for documents that were updated since the offset.
        return this.Fo.getDocumentsMatchingQuery(e, n, r).next((e)=>// Merge with existing results
            (t.forEach((t)=>{
                e = e.insert(t.key, t);
            }), e));
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const un = "LocalStore", cn = 3e8;
/**
 * The maximum time to leave a resume token buffered without writing it out.
 * This value is arbitrary: it's long enough to avoid several writes
 * (possibly indefinitely if updates come more frequently than this) but
 * short enough that restarting after crashing will still have a pretty
 * recent resume token.
 */ /**
 * Implements `LocalStore` interface.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class __PRIVATE_LocalStoreImpl {
    constructor(/** Manages our in-memory or durable persistence. */ e, t, n, r){
        this.persistence = e, this.qo = t, this.serializer = r, /**
         * Maps a targetID to data about its target.
         *
         * PORTING NOTE: We are using an immutable data structure on Web to make re-runs
         * of `applyRemoteEvent()` idempotent.
         */ this.$o = new SortedMap(__PRIVATE_primitiveComparator), /** Maps a target to its targetID. */ // TODO(wuandy): Evaluate if TargetId can be part of Target.
        this.Ko = new ObjectMap((e)=>__PRIVATE_canonifyTargetOrPipeline(e), __PRIVATE_targetOrPipelineEqual), /**
         * A per collection group index of the last read time processed by
         * `getNewDocumentChanges()`.
         *
         * PORTING NOTE: This is only used for multi-tab synchronization.
         */ this.Wo = new Map, this.Qo = e.getRemoteDocumentCache(), this.g_ = e.getTargetCache(), this.w_ = e.getBundleCache(), this.Go(n);
    }
    Go(e) {
        // TODO(indexing): Add spec tests that test these components change after a
        // user change
        this.documentOverlayCache = this.persistence.getDocumentOverlayCache(e), this.indexManager = this.persistence.getIndexManager(e), this.mutationQueue = this.persistence.getMutationQueue(e, this.indexManager), this.localDocuments = new LocalDocumentsView(this.Qo, this.mutationQueue, this.documentOverlayCache, this.indexManager), this.Qo.setIndexManager(this.indexManager), this.qo.initialize(this.localDocuments, this.indexManager);
    }
    collectGarbage(e) {
        return this.persistence.runTransaction("Collect garbage", "readwrite-primary", (t)=>e.collect(t, this.$o));
    }
}
function __PRIVATE_newLocalStore(/** Manages our in-memory or durable persistence. */ e, t, n, r) {
    return new __PRIVATE_LocalStoreImpl(e, t, n, r);
}
/**
 * Tells the LocalStore that the currently authenticated user has changed.
 *
 * In response the local store switches the mutation queue to the new user and
 * returns any resulting document changes.
 */ // PORTING NOTE: Android and iOS only return the documents affected by the
// change.
async function __PRIVATE_localStoreHandleUserChange(e, t) {
    const n = __PRIVATE_debugCast(e);
    return await n.persistence.runTransaction("Handle user change", "readonly", (e)=>{
        // Swap out the mutation queue, grabbing the pending mutation batches
        // before and after.
        let r;
        return n.mutationQueue.getAllMutationBatches(e).next((i)=>(r = i, n.Go(t), n.mutationQueue.getAllMutationBatches(e))).next((t)=>{
            const i = [], s = [];
            // Union the old/new changed keys.
            let _ = __PRIVATE_documentKeySet();
            for (const e of r){
                i.push(e.batchId);
                for (const t of e.mutations)_ = _.add(t.key);
            }
            for (const e of t){
                s.push(e.batchId);
                for (const t of e.mutations)_ = _.add(t.key);
            }
            // Return the set of all (potentially) changed documents and the list
            // of mutation batch IDs that were affected by change.
            return n.localDocuments.getDocuments(e, _).next((e)=>({
                    zo: e,
                    removedBatchIds: i,
                    addedBatchIds: s
                }));
        });
    });
}
/* Accepts locally generated Mutations and commit them to storage. */ /**
 * Acknowledges the given batch.
 *
 * On the happy path when a batch is acknowledged, the local store will
 *
 *  + remove the batch from the mutation queue;
 *  + apply the changes to the remote document cache;
 *  + recalculate the latency compensated view implied by those changes (there
 *    may be mutations in the queue that affect the documents but haven't been
 *    acknowledged yet); and
 *  + give the changed documents back the sync engine
 *
 * @returns The resulting (modified) documents.
 */ function __PRIVATE_localStoreAcknowledgeBatch(e, t) {
    const n = __PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Acknowledge batch", "readwrite-primary", (e)=>{
        const r = t.batch.keys(), i = n.Qo.newChangeBuffer({
            trackRemovals: !0
        });
        return (function __PRIVATE_applyWriteToRemoteDocuments(e, t, n, r) {
            const i = n.batch, s = i.keys();
            let _ = PersistencePromise.resolve();
            return s.forEach((e)=>{
                _ = _.next(()=>r.getEntry(t, e)).next((t)=>{
                    const s = n.docVersions.get(e);
                    __PRIVATE_hardAssert(null !== s, 48541), t.version.compareTo(s) < 0 && (i.applyToRemoteDocument(t, n), t.isValidDocument() && // We use the commitVersion as the readTime rather than the
                    // document's updateTime since the updateTime is not advanced
                    // for updates that do not modify the underlying document.
                    (t.setReadTime(n.commitVersion), r.addEntry(t)));
                });
            }), _.next(()=>e.mutationQueue.removeMutationBatch(t, i));
        })(n, e, t, i).next(()=>i.apply(e)).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t.batch.batchId)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, function __PRIVATE_getKeysWithTransformResults(e) {
                let t = __PRIVATE_documentKeySet();
                for(let n = 0; n < e.mutationResults.length; ++n)e.mutationResults[n].transformResults.length > 0 && (t = t.add(e.batch.mutations[n].key));
                return t;
            }(t))).next(()=>n.localDocuments.getDocuments(e, r));
    });
}
/**
 * Returns the last consistent snapshot processed (used by the RemoteStore to
 * determine whether to buffer incoming snapshots from the backend).
 */ function __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e) {
    const t = __PRIVATE_debugCast(e);
    return t.persistence.runTransaction("Get last remote snapshot version", "readonly", (e)=>t.g_.getLastRemoteSnapshotVersion(e));
}
/**
 * Updates the "ground-state" (remote) documents. We assume that the remote
 * event reflects any write batches that have been acknowledged or rejected
 * (i.e. we do not re-apply local mutations to updates from this event).
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ function __PRIVATE_localStoreApplyRemoteEventToLocalCache(e, t) {
    const n = __PRIVATE_debugCast(e), r = t.snapshotVersion;
    let i = n.$o;
    return n.persistence.runTransaction("Apply remote event", "readwrite-primary", (e)=>{
        const s = n.Qo.newChangeBuffer({
            trackRemovals: !0
        });
        // Reset newTargetDataByTargetMap in case this transaction gets re-run.
        i = n.$o;
        const _ = [];
        t.targetChanges.forEach((s, o)=>{
            const a = i.get(o);
            if (!a) return;
            // Only update the remote keys if the target is still active. This
            // ensures that we can persist the updated target data along with
            // the updated assignment.
            _.push(n.g_.removeMatchingKeys(e, s.removedDocuments, o).next(()=>n.g_.addMatchingKeys(e, s.addedDocuments, o)));
            let u = a.withSequenceNumber(e.currentSequenceNumber);
            null !== t.targetMismatches.get(o) ? u = u.withResumeToken(ByteString.EMPTY_BYTE_STRING, SnapshotVersion.min()).withLastLimboFreeSnapshotVersion(SnapshotVersion.min()) : s.resumeToken.approximateByteSize() > 0 && (u = u.withResumeToken(s.resumeToken, r)), i = i.insert(o, u), // Update the target data if there are target changes (or if
            // sufficient time has passed since the last update).
            /**
 * Returns true if the newTargetData should be persisted during an update of
 * an active target. TargetData should always be persisted when a target is
 * being released and should not call this function.
 *
 * While the target is active, TargetData updates can be omitted when nothing
 * about the target has changed except metadata like the resume token or
 * snapshot version. Occasionally it's worth the extra write to prevent these
 * values from getting too stale after a crash, but this doesn't have to be
 * too frequent.
 */ function __PRIVATE_shouldPersistTargetData(e, t, n) {
                // Always persist target data if we don't already have a resume token.
                if (0 === e.resumeToken.approximateByteSize()) return !0;
                // Don't allow resume token changes to be buffered indefinitely. This
                // allows us to be reasonably up-to-date after a crash and avoids needing
                // to loop over all active queries on shutdown. Especially in the browser
                // we may not get time to do anything interesting while the current tab is
                // closing.
                const r = t.snapshotVersion.toMicroseconds() - e.snapshotVersion.toMicroseconds();
                if (r >= cn) return !0;
                // Otherwise if the only thing that has changed about a target is its resume
                // token it's not worth persisting. Note that the RemoteStore keeps an
                // in-memory view of the currently active targets which includes the current
                // resume token, so stream failure or user changes will still use an
                // up-to-date resume token regardless of what we do here.
                const i = n.addedDocuments.size + n.modifiedDocuments.size + n.removedDocuments.size;
                return i > 0;
            }(a, u, s) && _.push(n.g_.updateTargetData(e, u));
        });
        let o = __PRIVATE_mutableDocumentMap(), a = __PRIVATE_documentKeySet();
        // HACK: The only reason we allow a null snapshot version is so that we
        // can synthesize remote events when we get permission denied errors while
        // trying to resolve the state of a locally cached document that is in
        // limbo.
        if (t.documentUpdates.forEach((r)=>{
            t.resolvedLimboDocuments.has(r) && _.push(n.persistence.referenceDelegate.updateLimboDocument(e, r));
        }), // Each loop iteration only affects its "own" doc, so it's safe to get all
        // the remote documents in advance in a single call.
        _.push(__PRIVATE_populateDocumentChangeBuffer(e, s, t.documentUpdates).next((e)=>{
            o = e.jo, a = e.Ho;
        })), !r.isEqual(SnapshotVersion.min())) {
            const t = n.g_.getLastRemoteSnapshotVersion(e).next((t)=>n.g_.setTargetsMetadata(e, e.currentSequenceNumber, r));
            _.push(t);
        }
        return PersistencePromise.waitFor(_).next(()=>s.apply(e)).next(()=>n.localDocuments.getLocalViewOfDocuments(e, o, a)).next(()=>o);
    }).then((e)=>(n.$o = i, e));
}
/**
 * Populates document change buffer with documents from backend or a bundle.
 * Returns the document changes resulting from applying those documents, and
 * also a set of documents whose existence state are changed as a result.
 *
 * @param txn - Transaction to use to read existing documents from storage.
 * @param documentBuffer - Document buffer to collect the resulted changes to be
 *        applied to storage.
 * @param documents - Documents to be applied.
 */ function __PRIVATE_populateDocumentChangeBuffer(e, t, n) {
    let r = __PRIVATE_documentKeySet(), i = __PRIVATE_documentKeySet();
    return n.forEach((e)=>r = r.add(e)), t.getEntries(e, r).next((e)=>{
        let r = __PRIVATE_mutableDocumentMap();
        return n.forEach((n, s)=>{
            const _ = e.get(n);
            // Check if see if there is a existence state change for this document.
            s.isFoundDocument() !== _.isFoundDocument() && (i = i.add(n)), // Note: The order of the steps below is important, since we want
            // to ensure that rejected limbo resolutions (which fabricate
            // NoDocuments with SnapshotVersion.min()) never add documents to
            // cache.
            s.isNoDocument() && s.version.isEqual(SnapshotVersion.min()) ? // NoDocuments with SnapshotVersion.min() are used in manufactured
            // events. We remove these documents from cache since we lost
            // access.
            (t.removeEntry(n, s.readTime), r = r.insert(n, s)) : !_.isValidDocument() || s.version.compareTo(_.version) > 0 || 0 === s.version.compareTo(_.version) && _.hasPendingWrites ? (t.addEntry(s), r = r.insert(n, s)) : __PRIVATE_logDebug(un, "Ignoring outdated watch update for ", n, ". Current version:", _.version, " Watch version:", s.version);
        }), {
            jo: r,
            Ho: i
        };
    });
}
/**
 * Gets the mutation batch after the passed in batchId in the mutation queue
 * or null if empty.
 * @param afterBatchId - If provided, the batch to search after.
 * @returns The next mutation or null if there wasn't one.
 */ function __PRIVATE_localStoreGetNextMutationBatch(e, t) {
    const n = __PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Get next mutation batch", "readonly", (e)=>(void 0 === t && (t = $), n.mutationQueue.getNextMutationBatchAfterBatchId(e, t)));
}
/**
 * Reads the current value of a Document with a given key or null if not
 * found - used for testing.
 */ /**
 * Assigns the given target an internal ID so that its results can be pinned so
 * they don't get GC'd. A target must be allocated in the local store before
 * the store can be used to manage its view.
 *
 * Allocating an already allocated `Target` will return the existing `TargetData`
 * for that `Target`.
 */ function __PRIVATE_localStoreAllocateTarget(e, t) {
    const n = __PRIVATE_debugCast(e);
    return n.persistence.runTransaction("Allocate target", "readwrite", (e)=>{
        let r;
        return n.g_.getTargetData(e, t).next((i)=>i ? // This target has been listened to previously, so reuse the
            // previous targetID.
            // TODO(mcg): freshen last accessed date?
            (r = i, PersistencePromise.resolve(r)) : n.g_.allocateTargetId(e).next((i)=>(r = new TargetData(t, i, "TargetPurposeListen" /* TargetPurpose.Listen */ , e.currentSequenceNumber), n.g_.addTargetData(e, r).next(()=>r))));
    }).then((e)=>{
        // If Multi-Tab is enabled, the existing target data may be newer than
        // the in-memory data
        const r = n.$o.get(e.targetId);
        return (null === r || e.snapshotVersion.compareTo(r.snapshotVersion) > 0) && (n.$o = n.$o.insert(e.targetId, e), n.Ko.set(t, e.targetId)), e;
    });
}
/**
 * Returns the TargetData as seen by the LocalStore, including updates that may
 * have not yet been persisted to the TargetCache.
 */ // Visible for testing.
/**
 * Unpins all the documents associated with the given target. If
 * `keepPersistedTargetData` is set to false and Eager GC enabled, the method
 * directly removes the associated target data from the target cache.
 *
 * Releasing a non-existing `Target` is a no-op.
 */ // PORTING NOTE: `keepPersistedTargetData` is multi-tab only.
async function __PRIVATE_localStoreReleaseTarget(e, t, n) {
    const r = __PRIVATE_debugCast(e), i = r.$o.get(t), s = n ? "readwrite" : "readwrite-primary";
    try {
        n || await r.persistence.runTransaction("Release target", s, (e)=>r.persistence.referenceDelegate.removeTarget(e, i));
    } catch (e) {
        if (!__PRIVATE_isIndexedDbTransactionError(e)) throw e;
        // All `releaseTarget` does is record the final metadata state for the
        // target, but we've been recording this periodically during target
        // activity. If we lose this write this could cause a very slight
        // difference in the order of target deletion during GC, but we
        // don't define exact LRU semantics so this is acceptable.
        __PRIVATE_logDebug(un, `Failed to update sequence numbers for target ${t}: ${e}`);
    }
    r.$o = r.$o.remove(t), // TODO(pipeline): This needs to handle pipeline properly.
    r.Ko.delete(i.target);
}
/**
 * Runs the specified query against the local store and returns the results,
 * potentially taking advantage of query data from previous executions (such
 * as the set of remote keys).
 *
 * @param usePreviousResults - Whether results from previous executions can
 * be used to optimize this query execution.
 */ function __PRIVATE_localStoreExecuteQuery(e, t, n) {
    const r = __PRIVATE_debugCast(e);
    let i = SnapshotVersion.min(), s = __PRIVATE_documentKeySet();
    return r.persistence.runTransaction("Execute query", "readwrite", // Use readwrite instead of readonly so indexes can be created
    (e)=>(function __PRIVATE_localStoreGetTargetData(e, t, n) {
            const r = __PRIVATE_debugCast(e), i = r.Ko.get(n);
            return void 0 !== i ? PersistencePromise.resolve(r.$o.get(i)) : r.g_.getTargetData(t, n);
        })(r, e, __PRIVATE_isPipeline(t) ? t : __PRIVATE_queryToTarget(t)).next((t)=>{
            if (t) return i = t.lastLimboFreeSnapshotVersion, r.g_.getMatchingKeysForTargetId(e, t.targetId).next((e)=>{
                s = e;
            });
        }).next(()=>r.qo.getDocumentsMatchingQuery(e, t, n ? i : SnapshotVersion.min(), n ? s : __PRIVATE_documentKeySet())).next((e)=>// TODO(pipeline): this needs to be adapted to support other pipeline flavors.
            // For now, only 'exact' flavor is supported and it is enough.
            (__PRIVATE_setMaxReadTime(r, e), {
                documents: e,
                Jo: s
            })));
}
// PORTING NOTE: Multi-Tab only.
function __PRIVATE_localStoreGetCachedTarget(e, t) {
    const n = __PRIVATE_debugCast(e), r = __PRIVATE_debugCast(n.g_), i = n.$o.get(t);
    return i ? Promise.resolve(i.target ?? null) : n.persistence.runTransaction("Get target data", "readonly", (e)=>r.dt(e, t).next((e)=>e?.target ?? null));
}
// PORTING NOTE: Multi-Tab only.
/**
 * Returns the set of documents that have been updated since the last call.
 * If this is the first call, returns the set of changes since client
 * initialization. Further invocations will return document that have changed
 * since the prior call.
 */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_localStoreGetNewDocumentChanges(e, t) {
    const n = __PRIVATE_debugCast(e), r = n.Wo.get(t) || SnapshotVersion.min();
    // Get the current maximum read time for the collection. This should always
    // exist, but to reduce the chance for regressions we default to
    // SnapshotVersion.Min()
    // TODO(indexing): Consider removing the default value.
    return n.persistence.runTransaction("Get new document changes", "readonly", (e)=>n.Qo.getAllFromCollectionGroup(e, t, __PRIVATE_newIndexOffsetSuccessorFromReadTime(r, L), /* limit= */ Number.MAX_SAFE_INTEGER)).then((e)=>(__PRIVATE_setMaxReadTime(n, e), e));
}
/** Sets the collection group's maximum read time from the given documents. */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_setMaxReadTime(e, t) {
    t.forEach((t, n)=>{
        const r = n.key.getCollectionGroup(), i = e.Wo.get(r) || SnapshotVersion.min();
        n.readTime.compareTo(i) > 0 && e.Wo.set(r, n.readTime);
    });
}
/**
 * Creates a new target using the given bundle name, which will be used to
 * hold the keys of all documents from the bundle in query-document mappings.
 * This ensures that the loaded documents do not get garbage collected
 * right away.
 */ /**
 * Applies the documents from a bundle to the "ground-state" (remote)
 * documents.
 *
 * LocalDocuments are re-calculated if there are remaining mutations in the
 * queue.
 */ async function __PRIVATE_localStoreApplyBundledDocuments(e, t, n, r) {
    const i = __PRIVATE_debugCast(e);
    let s = __PRIVATE_documentKeySet(), _ = __PRIVATE_mutableDocumentMap();
    for (const e of n){
        const n = t.Yo(e.metadata.name);
        e.document && (s = s.add(n));
        const r = t.Zo(e);
        r.setReadTime(t.Xo(e.metadata.readTime)), _ = _.insert(n, r);
    }
    const o = i.Qo.newChangeBuffer({
        trackRemovals: !0
    }), a = await __PRIVATE_localStoreAllocateTarget(i, function __PRIVATE_umbrellaTarget(e) {
        // It is OK that the path used for the query is not valid, because this will
        // not be read and queried.
        return __PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(ResourcePath.fromString(`__bundle__/docs/${e}`)));
    }(r));
    // Allocates a target to hold all document keys from the bundle, such that
    // they will not get garbage collected right away.
    return i.persistence.runTransaction("Apply bundle documents", "readwrite", (e)=>__PRIVATE_populateDocumentChangeBuffer(e, o, _).next((t)=>(o.apply(e), t)).next((t)=>i.g_.removeMatchingKeysForTargetId(e, a.targetId).next(()=>i.g_.addMatchingKeys(e, s, a.targetId)).next(()=>i.localDocuments.getLocalViewOfDocuments(e, t.jo, t.Ho)).next(()=>t.jo)));
}
/**
 * Returns a promise of a boolean to indicate if the given bundle has already
 * been loaded and the create time is newer than the current loading bundle.
 */ /**
 * Saves the given `NamedQuery` to local persistence.
 */ async function __PRIVATE_localStoreSaveNamedQuery(e, t, n = __PRIVATE_documentKeySet()) {
    // Allocate a target for the named query such that it can be resumed
    // from associated read time if users use it to listen.
    // NOTE: this also means if no corresponding target exists, the new target
    // will remain active and will not get collected, unless users happen to
    // unlisten the query somehow.
    const r = await __PRIVATE_localStoreAllocateTarget(e, __PRIVATE_queryToTarget(__PRIVATE_fromBundledQuery(t.bundledQuery))), i = __PRIVATE_debugCast(e);
    return i.persistence.runTransaction("Save named query", "readwrite", (e)=>{
        const s = __PRIVATE_fromVersion(t.readTime);
        // Simply save the query itself if it is older than what the SDK already
        // has.
        if (r.snapshotVersion.compareTo(s) >= 0) return i.w_.saveNamedQuery(e, t);
        // Update existing target data because the query from the bundle is newer.
        const _ = r.withResumeToken(ByteString.EMPTY_BYTE_STRING, s);
        return i.$o = i.$o.insert(_.targetId, _), i.g_.updateTargetData(e, _).next(()=>i.g_.removeMatchingKeysForTargetId(e, r.targetId)).next(()=>i.g_.addMatchingKeys(e, n, r.targetId)).next(()=>i.w_.saveNamedQuery(e, t));
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // The format of the LocalStorage key that stores the client state is:
//     firestore_clients_<persistence_prefix>_<instance_key>
const En = "firestore_clients";
/** Assembles the key for a client state in WebStorage */ function createWebStorageClientStateKey(e, t) {
    return `${En}_${e}_${t}`;
}
// The format of the WebStorage key that stores the mutation state is:
//     firestore_mutations_<persistence_prefix>_<batch_id>
//     (for unauthenticated users)
// or: firestore_mutations_<persistence_prefix>_<batch_id>_<user_uid>
// 'user_uid' is last to avoid needing to escape '_' characters that it might
// contain.
const hn = "firestore_mutations";
/** Assembles the key for a mutation batch in WebStorage */ function createWebStorageMutationBatchKey(e, t, n) {
    let r = `${hn}_${e}_${n}`;
    return t.isAuthenticated() && (r += `_${t.uid}`), r;
}
// The format of the WebStorage key that stores a query target's metadata is:
//     firestore_targets_<persistence_prefix>_<target_id>
const Tn = "firestore_targets";
/** Assembles the key for a query state in WebStorage */ function createWebStorageQueryTargetMetadataKey(e, t) {
    return `${Tn}_${e}_${t}`;
}
// The WebStorage prefix that stores the primary tab's online state. The
// format of the key is:
//     firestore_online_state_<persistence_prefix>
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const Pn = "SharedClientState";
/**
 * Holds the state of a mutation batch, including its user ID, batch ID and
 * whether the batch is 'pending', 'acknowledged' or 'rejected'.
 */ // Visible for testing
class __PRIVATE_MutationMetadata {
    constructor(e, t, n, r){
        this.user = e, this.batchId = t, this.state = n, this.error = r;
    }
    /**
     * Parses a MutationMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ea(e, t, n) {
        const r = JSON.parse(n);
        let i, s = "object" == typeof r && -1 !== [
            "pending",
            "acknowledged",
            "rejected"
        ].indexOf(r.state) && (void 0 === r.error || "object" == typeof r.error);
        return s && r.error && (s = "string" == typeof r.error.message && "string" == typeof r.error.code, s && (i = new FirestoreError(r.error.code, r.error.message))), s ? new __PRIVATE_MutationMetadata(e, t, r.state, i) : (__PRIVATE_logError(Pn, `Failed to parse mutation state for ID '${t}': ${n}`), null);
    }
    ta() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * Holds the state of a query target, including its target ID and whether the
 * target is 'not-current', 'current' or 'rejected'.
 */ // Visible for testing
class __PRIVATE_QueryTargetMetadata {
    constructor(e, t, n){
        this.targetId = e, this.state = t, this.error = n;
    }
    /**
     * Parses a QueryTargetMetadata from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ea(e, t) {
        const n = JSON.parse(t);
        let r, i = "object" == typeof n && -1 !== [
            "not-current",
            "current",
            "rejected"
        ].indexOf(n.state) && (void 0 === n.error || "object" == typeof n.error);
        return i && n.error && (i = "string" == typeof n.error.message && "string" == typeof n.error.code, i && (r = new FirestoreError(n.error.code, n.error.message))), i ? new __PRIVATE_QueryTargetMetadata(e, n.state, r) : (__PRIVATE_logError(Pn, `Failed to parse target state for ID '${e}': ${t}`), null);
    }
    ta() {
        const e = {
            state: this.state,
            updateTimeMs: Date.now()
        };
        return this.error && (e.error = {
            code: this.error.code,
            message: this.error.message
        }), JSON.stringify(e);
    }
}
/**
 * This class represents the immutable ClientState for a client read from
 * WebStorage, containing the list of active query targets.
 */ class __PRIVATE_RemoteClientState {
    constructor(e, t){
        this.clientId = e, this.activeTargetIds = t;
    }
    /**
     * Parses a RemoteClientState from the JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ea(e, t) {
        const n = JSON.parse(t);
        let r = "object" == typeof n && n.activeTargetIds instanceof Array, i = __PRIVATE_targetIdSet();
        for(let e = 0; r && e < n.activeTargetIds.length; ++e)r = isSafeInteger(n.activeTargetIds[e]), i = i.add(n.activeTargetIds[e]);
        return r ? new __PRIVATE_RemoteClientState(e, i) : (__PRIVATE_logError(Pn, `Failed to parse client data for instance '${e}': ${t}`), null);
    }
}
/**
 * This class represents the online state for all clients participating in
 * multi-tab. The online state is only written to by the primary client, and
 * used in secondary clients to update their query views.
 */ class __PRIVATE_SharedOnlineState {
    constructor(e, t){
        this.clientId = e, this.onlineState = t;
    }
    /**
     * Parses a SharedOnlineState from its JSON representation in WebStorage.
     * Logs a warning and returns null if the format of the data is not valid.
     */ static ea(e) {
        const t = JSON.parse(e);
        return "object" == typeof t && -1 !== [
            "Unknown",
            "Online",
            "Offline"
        ].indexOf(t.onlineState) && "string" == typeof t.clientId ? new __PRIVATE_SharedOnlineState(t.clientId, t.onlineState) : (__PRIVATE_logError(Pn, `Failed to parse online state: ${e}`), null);
    }
}
/**
 * Metadata state of the local client. Unlike `RemoteClientState`, this class is
 * mutable and keeps track of all pending mutations, which allows us to
 * update the range of pending mutation batch IDs as new mutations are added or
 * removed.
 *
 * The data in `LocalClientState` is not read from WebStorage and instead
 * updated via its instance methods. The updated state can be serialized via
 * `toWebStorageJSON()`.
 */ // Visible for testing.
class __PRIVATE_LocalClientState {
    constructor(){
        this.activeTargetIds = __PRIVATE_targetIdSet();
    }
    na(e) {
        this.activeTargetIds = this.activeTargetIds.add(e);
    }
    ra(e) {
        this.activeTargetIds = this.activeTargetIds.delete(e);
    }
    /**
     * Converts this entry into a JSON-encoded format we can use for WebStorage.
     * Does not encode `clientId` as it is part of the key in WebStorage.
     */ ta() {
        const e = {
            activeTargetIds: this.activeTargetIds.toArray(),
            updateTimeMs: Date.now()
        };
        return JSON.stringify(e);
    }
}
/**
 * `WebStorageSharedClientState` uses WebStorage (window.localStorage) as the
 * backing store for the SharedClientState. It keeps track of all active
 * clients and supports modifications of the local client's data.
 */ class __PRIVATE_WebStorageSharedClientState {
    constructor(e, t, n, r, i){
        this.window = e, this.Tn = t, this.persistenceKey = n, this.ia = r, this.syncEngine = null, this.onlineStateHandler = null, this.sequenceNumberHandler = null, this.sa = this._a.bind(this), this.oa = new SortedMap(__PRIVATE_primitiveComparator), this.started = !1, /**
         * Captures WebStorage events that occur before `start()` is called. These
         * events are replayed once `WebStorageSharedClientState` is started.
         */ this.aa = [];
        // Escape the special characters mentioned here:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Regular_Expressions
        const s = n.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        this.storage = this.window.localStorage, this.currentUser = i, this.ua = createWebStorageClientStateKey(this.persistenceKey, this.ia), this.ca = /** Assembles the key for the current sequence number. */ function createWebStorageSequenceNumberKey(e) {
            return `firestore_sequence_number_${e}`;
        }(this.persistenceKey), this.oa = this.oa.insert(this.ia, new __PRIVATE_LocalClientState), this.la = new RegExp(`^${En}_${s}_([^_]*)$`), this.Ea = new RegExp(`^${hn}_${s}_(\\d+)(?:_(.*))?$`), this.ha = new RegExp(`^${Tn}_${s}_(\\d+)$`), this.Ta = /** Assembles the key for the online state of the primary tab. */ function createWebStorageOnlineStateKey(e) {
            return `firestore_online_state_${e}`;
        }(this.persistenceKey), this.Pa = function createBundleLoadedKey(e) {
            return `firestore_bundle_loaded_v2_${e}`;
        }(this.persistenceKey), // Rather than adding the storage observer during start(), we add the
        // storage observer during initialization. This ensures that we collect
        // events before other components populate their initial state (during their
        // respective start() calls). Otherwise, we might for example miss a
        // mutation that is added after LocalStore's start() processed the existing
        // mutations but before we observe WebStorage events.
        this.window.addEventListener("storage", this.sa);
    }
    /** Returns 'true' if WebStorage is available in the current environment. */ static C(e) {
        return !(!e || !e.localStorage);
    }
    async start() {
        // Retrieve the list of existing clients to backfill the data in
        // SharedClientState.
        const e = await this.syncEngine.po();
        for (const t of e){
            if (t === this.ia) continue;
            const e = this.getItem(createWebStorageClientStateKey(this.persistenceKey, t));
            if (e) {
                const n = __PRIVATE_RemoteClientState.ea(t, e);
                n && (this.oa = this.oa.insert(n.clientId, n));
            }
        }
        this.Ra();
        // Check if there is an existing online state and call the callback handler
        // if applicable.
        const t = this.storage.getItem(this.Ta);
        if (t) {
            const e = this.Ia(t);
            e && this.Aa(e);
        }
        for (const e of this.aa)this._a(e);
        this.aa = [], // Register a window unload hook to remove the client metadata entry from
        // WebStorage even if `shutdown()` was not called.
        this.window.addEventListener("pagehide", ()=>this.shutdown()), this.started = !0;
    }
    writeSequenceNumber(e) {
        this.setItem(this.ca, JSON.stringify(e));
    }
    getAllActiveQueryTargets() {
        return this.Va(this.oa);
    }
    isActiveQueryTarget(e) {
        let t = !1;
        return this.oa.forEach((n, r)=>{
            r.activeTargetIds.has(e) && (t = !0);
        }), t;
    }
    addPendingMutation(e) {
        this.da(e, "pending");
    }
    updateMutationState(e, t, n) {
        this.da(e, t, n), // Once a final mutation result is observed by other clients, they no longer
        // access the mutation's metadata entry. Since WebStorage replays events
        // in order, it is safe to delete the entry right after updating it.
        this.fa(e);
    }
    addLocalQueryTarget(e, t = !0) {
        let n = "not-current";
        // Lookup an existing query state if the target ID was already registered
        // by another tab
        if (this.isActiveQueryTarget(e)) {
            const t = this.storage.getItem(createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
            if (t) {
                const r = __PRIVATE_QueryTargetMetadata.ea(e, t);
                r && (n = r.state);
            }
        }
        // If the query is listening to cache only, the target ID should not be registered with the
        // local Firestore client as an active watch target.
        return t && this.ma.na(e), this.Ra(), n;
    }
    removeLocalQueryTarget(e) {
        this.ma.ra(e), this.Ra();
    }
    isLocalQueryTarget(e) {
        return this.ma.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        this.removeItem(createWebStorageQueryTargetMetadataKey(this.persistenceKey, e));
    }
    updateQueryState(e, t, n) {
        this.pa(e, t, n);
    }
    handleUserChange(e, t, n) {
        t.forEach((e)=>{
            this.fa(e);
        }), this.currentUser = e, n.forEach((e)=>{
            this.addPendingMutation(e);
        });
    }
    setOnlineState(e) {
        this.ga(e);
    }
    notifyBundleLoaded(e) {
        this.ya(e);
    }
    shutdown() {
        this.started && (this.window.removeEventListener("storage", this.sa), this.removeItem(this.ua), this.started = !1);
    }
    getItem(e) {
        const t = this.storage.getItem(e);
        return __PRIVATE_logDebug(Pn, "READ", e, t), t;
    }
    setItem(e, t) {
        __PRIVATE_logDebug(Pn, "SET", e, t), this.storage.setItem(e, t);
    }
    removeItem(e) {
        __PRIVATE_logDebug(Pn, "REMOVE", e), this.storage.removeItem(e);
    }
    _a(e) {
        // Note: The function is typed to take Event to be interface-compatible with
        // `Window.addEventListener`.
        const t = e;
        if (t.storageArea === this.storage) {
            if (__PRIVATE_logDebug(Pn, "EVENT", t.key, t.newValue), t.key === this.ua) return void __PRIVATE_logError("Received WebStorage notification for local change. Another client might have garbage-collected our state");
            this.Tn.enqueueRetryable(async ()=>{
                if (this.started) {
                    if (null !== t.key) {
                        if (this.la.test(t.key)) {
                            if (null == t.newValue) {
                                const e = this.wa(t.key);
                                return this.ba(e, null);
                            }
                            {
                                const e = this.va(t.key, t.newValue);
                                if (e) return this.ba(e.clientId, e);
                            }
                        } else if (this.Ea.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.Sa(t.key, t.newValue);
                                if (e) return this.Da(e);
                            }
                        } else if (this.ha.test(t.key)) {
                            if (null !== t.newValue) {
                                const e = this.xa(t.key, t.newValue);
                                if (e) return this.Ca(e);
                            }
                        } else if (t.key === this.Ta) {
                            if (null !== t.newValue) {
                                const e = this.Ia(t.newValue);
                                if (e) return this.Aa(e);
                            }
                        } else if (t.key === this.ca) {
                            const e = function __PRIVATE_fromWebStorageSequenceNumber(e) {
                                let t = __PRIVATE_ListenSequence.ce;
                                if (null != e) try {
                                    const n = JSON.parse(e);
                                    __PRIVATE_hardAssert("number" == typeof n, 30636, {
                                        Fa: e
                                    }), t = n;
                                } catch (e) {
                                    __PRIVATE_logError(Pn, "Failed to read sequence number from WebStorage", e);
                                }
                                return t;
                            }(t.newValue);
                            e !== __PRIVATE_ListenSequence.ce && this.sequenceNumberHandler(e);
                        } else if (t.key === this.Pa) {
                            const e = this.Oa(t.newValue);
                            await Promise.all(e.map((e)=>this.syncEngine.Ma(e)));
                        }
                    }
                } else this.aa.push(t);
            });
        }
    }
    get ma() {
        return this.oa.get(this.ia);
    }
    Ra() {
        this.setItem(this.ua, this.ma.ta());
    }
    da(e, t, n) {
        const r = new __PRIVATE_MutationMetadata(this.currentUser, e, t, n), i = createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.setItem(i, r.ta());
    }
    fa(e) {
        const t = createWebStorageMutationBatchKey(this.persistenceKey, this.currentUser, e);
        this.removeItem(t);
    }
    ga(e) {
        const t = {
            clientId: this.ia,
            onlineState: e
        };
        this.storage.setItem(this.Ta, JSON.stringify(t));
    }
    pa(e, t, n) {
        const r = createWebStorageQueryTargetMetadataKey(this.persistenceKey, e), i = new __PRIVATE_QueryTargetMetadata(e, t, n);
        this.setItem(r, i.ta());
    }
    ya(e) {
        const t = JSON.stringify(Array.from(e));
        this.setItem(this.Pa, t);
    }
    /**
     * Parses a client state key in WebStorage. Returns null if the key does not
     * match the expected key format.
     */ wa(e) {
        const t = this.la.exec(e);
        return t ? t[1] : null;
    }
    /**
     * Parses a client state in WebStorage. Returns 'null' if the value could not
     * be parsed.
     */ va(e, t) {
        const n = this.wa(e);
        return __PRIVATE_RemoteClientState.ea(n, t);
    }
    /**
     * Parses a mutation batch state in WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Sa(e, t) {
        const n = this.Ea.exec(e), r = Number(n[1]), i = void 0 !== n[2] ? n[2] : null;
        return __PRIVATE_MutationMetadata.ea(new User(i), r, t);
    }
    /**
     * Parses a query target state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ xa(e, t) {
        const n = this.ha.exec(e), r = Number(n[1]);
        return __PRIVATE_QueryTargetMetadata.ea(r, t);
    }
    /**
     * Parses an online state from WebStorage. Returns 'null' if the value
     * could not be parsed.
     */ Ia(e) {
        return __PRIVATE_SharedOnlineState.ea(e);
    }
    Oa(e) {
        return JSON.parse(e);
    }
    async Da(e) {
        if (e.user.uid === this.currentUser.uid) return this.syncEngine.Na(e.batchId, e.state, e.error);
        __PRIVATE_logDebug(Pn, `Ignoring mutation for non-active user ${e.user.uid}`);
    }
    Ca(e) {
        return this.syncEngine.La(e.targetId, e.state, e.error);
    }
    ba(e, t) {
        const n = t ? this.oa.insert(e, t) : this.oa.remove(e), r = this.Va(this.oa), i = this.Va(n), s = [], _ = [];
        return i.forEach((e)=>{
            r.has(e) || s.push(e);
        }), r.forEach((e)=>{
            i.has(e) || _.push(e);
        }), this.syncEngine.Ba(s, _).then(()=>{
            this.oa = n;
        });
    }
    Aa(e) {
        // We check whether the client that wrote this online state is still active
        // by comparing its client ID to the list of clients kept active in
        // IndexedDb. If a client does not update their IndexedDb client state
        // within 5 seconds, it is considered inactive and we don't emit an online
        // state event.
        this.oa.get(e.clientId) && this.onlineStateHandler(e.onlineState);
    }
    Va(e) {
        let t = __PRIVATE_targetIdSet();
        return e.forEach((e, n)=>{
            t = t.unionWith(n.activeTargetIds);
        }), t;
    }
}
class __PRIVATE_MemorySharedClientState {
    constructor(){
        this.Ua = new __PRIVATE_LocalClientState, this.ka = {}, this.onlineStateHandler = null, this.sequenceNumberHandler = null;
    }
    addPendingMutation(e) {
    // No op.
    }
    updateMutationState(e, t, n) {
    // No op.
    }
    addLocalQueryTarget(e, t = !0) {
        return t && this.Ua.na(e), this.ka[e] || "not-current";
    }
    updateQueryState(e, t, n) {
        this.ka[e] = t;
    }
    removeLocalQueryTarget(e) {
        this.Ua.ra(e);
    }
    isLocalQueryTarget(e) {
        return this.Ua.activeTargetIds.has(e);
    }
    clearQueryState(e) {
        delete this.ka[e];
    }
    getAllActiveQueryTargets() {
        return this.Ua.activeTargetIds;
    }
    isActiveQueryTarget(e) {
        return this.Ua.activeTargetIds.has(e);
    }
    start() {
        return this.Ua = new __PRIVATE_LocalClientState, Promise.resolve();
    }
    handleUserChange(e, t, n) {
    // No op.
    }
    setOnlineState(e) {
    // No op.
    }
    shutdown() {}
    writeSequenceNumber(e) {}
    notifyBundleLoaded(e) {
    // No op.
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** The Platform's 'window' implementation or null if not available. */ function __PRIVATE_getWindow() {
    // `window` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof window ? window : null;
}
/** The Platform's 'document' implementation or null if not available. */ function getDocument() {
    // `document` is not always available, e.g. in ReactNative and WebWorkers.
    // eslint-disable-next-line no-restricted-globals
    return "undefined" != typeof document ? document : null;
}
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A component used by the RemoteStore to track the OnlineState (that is,
 * whether or not the client as a whole should be considered to be online or
 * offline), implementing the appropriate heuristics.
 *
 * In particular, when the client is trying to connect to the backend, we
 * allow up to MAX_WATCH_STREAM_FAILURES within ONLINE_STATE_TIMEOUT_MS for
 * a connection to succeed. If we have too many failures or the timeout elapses,
 * then we set the OnlineState to Offline, and the client will behave as if
 * it is offline (get()s will return cached data, etc.).
 */ class __PRIVATE_OnlineStateTracker {
    constructor(e, t){
        this.asyncQueue = e, this.onlineStateHandler = t, /** The current OnlineState. */ this.state = "Unknown" /* OnlineState.Unknown */ , /**
         * A count of consecutive failures to open the stream. If it reaches the
         * maximum defined by MAX_WATCH_STREAM_FAILURES, we'll set the OnlineState to
         * Offline.
         */ this.qa = 0, /**
         * A timer that elapses after ONLINE_STATE_TIMEOUT_MS, at which point we
         * transition from OnlineState.Unknown to OnlineState.Offline without waiting
         * for the stream to actually fail (MAX_WATCH_STREAM_FAILURES times).
         */ this.$a = null, /**
         * Whether the client should log a warning message if it fails to connect to
         * the backend (initially true, cleared after a successful stream, or if we've
         * logged the message already).
         */ this.Ka = !0;
    }
    /**
     * Called by RemoteStore when a watch stream is started (including on each
     * backoff attempt).
     *
     * If this is the first attempt, it sets the OnlineState to Unknown and starts
     * the onlineStateTimer.
     */ Wa() {
        0 === this.qa && (this.Qa("Unknown" /* OnlineState.Unknown */ ), this.$a = this.asyncQueue.enqueueAfterDelay("online_state_timeout" /* TimerId.OnlineStateTimeout */ , 1e4, ()=>(this.$a = null, this.Ga("Backend didn't respond within 10 seconds."), this.Qa("Offline" /* OnlineState.Offline */ ), Promise.resolve())));
    }
    /**
     * Updates our OnlineState as appropriate after the watch stream reports a
     * failure. The first failure moves us to the 'Unknown' state. We then may
     * allow multiple failures (based on MAX_WATCH_STREAM_FAILURES) before we
     * actually transition to the 'Offline' state.
     */ za(e) {
        "Online" /* OnlineState.Online */  === this.state ? this.Qa("Unknown" /* OnlineState.Unknown */ ) : (this.qa++, this.qa >= 1 && (this.ja(), this.Ga(`Connection failed 1 times. Most recent error: ${e.toString()}`), this.Qa("Offline" /* OnlineState.Offline */ )));
    }
    /**
     * Explicitly sets the OnlineState to the specified state.
     *
     * Note that this resets our timers / failure counters, etc. used by our
     * Offline heuristics, so must not be used in place of
     * handleWatchStreamStart() and handleWatchStreamFailure().
     */ set(e) {
        this.ja(), this.qa = 0, "Online" /* OnlineState.Online */  === e && // We've connected to watch at least once. Don't warn the developer
        // about being offline going forward.
        (this.Ka = !1), this.Qa(e);
    }
    Qa(e) {
        e !== this.state && (this.state = e, this.onlineStateHandler(e));
    }
    Ga(e) {
        const t = `Could not reach Cloud Firestore backend. ${e}\nThis typically indicates that your device does not have a healthy Internet connection at the moment. The client will operate in offline mode until it is able to successfully connect to the backend.`;
        this.Ka ? (__PRIVATE_logError(t), this.Ka = !1) : __PRIVATE_logDebug("OnlineStateTracker", t);
    }
    ja() {
        null !== this.$a && (this.$a.cancel(), this.$a = null);
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const Rn = "RemoteStore";
// TODO(b/35853402): Negotiate this with the stream.
class __PRIVATE_RemoteStoreImpl {
    constructor(/**
     * The local store, used to fill the write pipeline with outbound mutations.
     */ e, /** The client-side proxy for interacting with the backend. */ t, n, r, i){
        this.localStore = e, this.datastore = t, this.asyncQueue = n, this.remoteSyncer = {}, /**
         * A list of up to MAX_PENDING_WRITES writes that we have fetched from the
         * LocalStore via fillWritePipeline() and have or will send to the write
         * stream.
         *
         * Whenever writePipeline.length > 0 the RemoteStore will attempt to start or
         * restart the write stream. When the stream is established the writes in the
         * pipeline will be sent in order.
         *
         * Writes remain in writePipeline until they are acknowledged by the backend
         * and thus will automatically be re-sent if the stream is interrupted /
         * restarted before they're acknowledged.
         *
         * Write responses from the backend are linked to their originating request
         * purely based on order, and so we can just shift() writes from the front of
         * the writePipeline as we receive responses.
         */ this.Ha = [], /**
         * A mapping of watched targets that the client cares about tracking and the
         * user has explicitly called a 'listen' for this target.
         *
         * These targets may or may not have been sent to or acknowledged by the
         * server. On re-establishing the listen stream, these targets should be sent
         * to the server. The targets removed with unlistens are removed eagerly
         * without waiting for confirmation from the listen stream.
         */ this.Ja = new Map, this.Ya = new Map, this.Za = new Map, this.Xa = new __PRIVATE_TargetIdGenerator(1e3), this.eu = new __PRIVATE_TargetIdGenerator(1001), /**
         * A set of reasons for why the RemoteStore may be offline. If empty, the
         * RemoteStore may start its network connections.
         */ this.tu = new Set, /**
         * Event handlers that get called when the network is disabled or enabled.
         *
         * PORTING NOTE: These functions are used on the Web client to create the
         * underlying streams (to support tree-shakeable streams). On Android and iOS,
         * the streams are created during construction of RemoteStore.
         */ this.nu = [], this.ru = i, this.ru.bt((e)=>{
            n.enqueueAndForget(async ()=>{
                // Porting Note: Unlike iOS, `restartNetwork()` is called even when the
                // network becomes unreachable as we don't have any other way to tear
                // down our streams.
                __PRIVATE_canUseNetwork(this) && (__PRIVATE_logDebug(Rn, "Restarting streams for network reachability change."), await async function __PRIVATE_restartNetwork(e) {
                    const t = __PRIVATE_debugCast(e);
                    t.tu.add(4 /* OfflineCause.ConnectivityChange */ ), await __PRIVATE_disableNetworkInternal(t), t.iu.set("Unknown" /* OnlineState.Unknown */ ), t.tu.delete(4 /* OfflineCause.ConnectivityChange */ ), await __PRIVATE_enableNetworkInternal(t);
                }(this));
            });
        }), this.iu = new __PRIVATE_OnlineStateTracker(n, r);
    }
}
async function __PRIVATE_enableNetworkInternal(e) {
    if (__PRIVATE_canUseNetwork(e)) for (const t of e.nu)await t(/* enabled= */ !0);
}
/**
 * Temporarily disables the network. The network can be re-enabled using
 * enableNetwork().
 */ async function __PRIVATE_disableNetworkInternal(e) {
    for (const t of e.nu)await t(/* enabled= */ !1);
}
/**
 * Returns the remote target ID currently mapped to this
 * sdkTargetId. Or returns `0` if the SDK target ID
 * is not currently mapped.
 * @param remoteStoreImpl
 * @param sdkTargetId
 */ function __PRIVATE_getRemoteTargetId(e, t) {
    return e.Ya.get(t) || void 0;
}
/**
 * Generates a new remote target ID that is acceptable
 * to map to the given SDK target ID.
 * @param remoteStoreImpl
 * @param sdkTargetId
 */ /**
 * Starts new listen for the given target. Uses resume token if provided. It
 * is a no-op if the target of given `TargetData` is already being listened to.
 */ function __PRIVATE_remoteStoreListen(e, t) {
    const n = __PRIVATE_debugCast(e), r = __PRIVATE_getRemoteTargetId(n, t.targetId);
    // Get any remote target ID currently mapped to the targetData
    // If remote store is still listening for this remote target ID, this is a no-op.
    if (void 0 !== r && n.Ja.has(r)) return;
    // Generate and map a new remote ID to the SDK target ID
    const i = /**
 * Generate a new remote target ID for the given SDK target ID.
 * Re-map the given SDK to the new remote ID.
 * Delete any mapping of the old remote ID, if given.
 * @param remoteStoreImpl
 * @param sdkTargetId
 * @return The new remote ID.
 */ function __PRIVATE_allocateRemoteTargetId(e, t) {
        const n = __PRIVATE_getRemoteTargetId(e, t);
        void 0 !== n && // If there was an existing remote target ID mapped to that SDK target ID, forget about the old remote ID.
        e.Za.delete(n);
        // Generate a new unique remote target ID
        const r = function __PRIVATE_generateRemoteTargetId(e, t) {
            // If the given sdkTargetId is odd, map it to an odd (sync engine) target ID
            return t % 2 != 0 ? e.eu.next() : e.Xa.next();
        }(e, t);
        return e.Ya.set(t, r), e.Za.set(r, t), r;
    }(n, t.targetId);
    __PRIVATE_logDebug(Rn, "remoteStoreListen mapping SDK target ID to remote", t.targetId, i);
    // Create a new TargetData for remote use, which uses
    // the remote TargetID.
    const s = new TargetData(t.target, i, t.purpose, t.sequenceNumber, t.snapshotVersion, t.lastLimboFreeSnapshotVersion, t.resumeToken);
    // Mark this as something the client is currently listening for.
    n.Ja.set(i, s), __PRIVATE_shouldStartWatchStream(n) ? // The listen will be sent in onWatchStreamOpen
    __PRIVATE_startWatchStream(n) : __PRIVATE_ensureWatchStream(n).Fn() && __PRIVATE_sendWatchRequest(n, s);
}
/**
 * Removes the listen from server. It is a no-op if the given target id is
 * not being listened to.
 */ function __PRIVATE_remoteStoreUnlisten(e, t) {
    const n = __PRIVATE_debugCast(e), r = __PRIVATE_ensureWatchStream(n), i = __PRIVATE_getRemoteTargetId(n, t);
    __PRIVATE_logDebug(Rn, "remoteStoreUnlisten removing mapping of SDK target ID to remote", t, i), n.Ja.delete(i), n.Ya.delete(t), n.Za.delete(i), r.Fn() && __PRIVATE_sendUnwatchRequest(n, i), 0 === n.Ja.size && (r.Fn() ? r.Nn() : __PRIVATE_canUseNetwork(n) && // Revert to OnlineState.Unknown if the watch stream is not open and we
    // have no listeners, since without any listens to send we cannot
    // confirm if the stream is healthy and upgrade to OnlineState.Online.
    n.iu.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the ack to process any messages from this target.
 */ function __PRIVATE_sendWatchRequest(e, t) {
    if (e.su.We(t.targetId), t.resumeToken.approximateByteSize() > 0 || t.snapshotVersion.compareTo(SnapshotVersion.min()) > 0) {
        const n = e.Za.get(t.targetId);
        if (void 0 === n) // There's already a new remoteStoreListen request for the original
        // target, so ignore this.
        return void __PRIVATE_logDebug(Rn, "SDK target ID not found for remote ID: " + t.targetId);
        const r = e.remoteSyncer.getRemoteKeysForTarget(n).size;
        t = t.withExpectedCount(r);
    }
    __PRIVATE_ensureWatchStream(e).jn(t);
}
/**
 * We need to increment the expected number of pending responses we're due
 * from watch so we wait for the removal on the server before we process any
 * messages from this target.
 */ function __PRIVATE_sendUnwatchRequest(e, t) {
    e.su.We(t), __PRIVATE_ensureWatchStream(e).Hn(t);
}
function __PRIVATE_startWatchStream(e) {
    e.su = new __PRIVATE_WatchChangeAggregator({
        getRemoteKeysForTarget: (t)=>{
            // Remote syncer uses SDK target IDs, so we need to map the remote
            // id to external id
            const n = e.Za.get(t);
            // If no sdkTargetId is mapped, return an empty key set
            return void 0 !== n ? e.remoteSyncer.getRemoteKeysForTarget(n) : __PRIVATE_documentKeySet();
        },
        dt: (t)=>e.Ja.get(t) || null,
        Tt: ()=>e.datastore.serializer.databaseId
    }), __PRIVATE_ensureWatchStream(e).start(), e.iu.Wa();
}
/**
 * Returns whether the watch stream should be started because it's necessary
 * and has not yet been started.
 */ function __PRIVATE_shouldStartWatchStream(e) {
    return __PRIVATE_canUseNetwork(e) && !__PRIVATE_ensureWatchStream(e).Cn() && e.Ja.size > 0;
}
function __PRIVATE_canUseNetwork(e) {
    return 0 === __PRIVATE_debugCast(e).tu.size;
}
function __PRIVATE_cleanUpWatchStreamState(e) {
    e.su = void 0;
}
async function __PRIVATE_onWatchStreamConnected(e) {
    // Mark the client as online since we got a "connected" notification.
    e.iu.set("Online" /* OnlineState.Online */ );
}
async function __PRIVATE_onWatchStreamOpen(e) {
    e.Ja.forEach((t, n)=>{
        __PRIVATE_sendWatchRequest(e, t);
    });
}
async function __PRIVATE_onWatchStreamClose(e, t) {
    __PRIVATE_cleanUpWatchStreamState(e), // If we still need the watch stream, retry the connection.
    __PRIVATE_shouldStartWatchStream(e) ? (e.iu.za(t), __PRIVATE_startWatchStream(e)) : // No need to restart watch stream because there are no active targets.
    // The online state is set to unknown because there is no active attempt
    // at establishing a connection
    e.iu.set("Unknown" /* OnlineState.Unknown */ );
}
async function __PRIVATE_onWatchStreamChange(e, t, n) {
    if (// Mark the client as online since we got a message from the server
    e.iu.set("Online" /* OnlineState.Online */ ), t instanceof __PRIVATE_WatchTargetChange && 2 /* WatchTargetChangeState.Removed */  === t.state && t.cause) // There was an error on a target, don't wait for a consistent snapshot
    // to raise events
    try {
        /** Handles an error on a target */ await async function __PRIVATE_handleTargetError(e, t) {
            const n = t.cause;
            for (const r of t.targetIds){
                // A watched target might have been removed already.
                if (e.Ja.has(r)) {
                    const t = e.Za.get(r);
                    // If we still track the remote target ID, then notify the remoteSyncer
                    // of the error and then free up the remote ID.
                    void 0 !== t && (await e.remoteSyncer.rejectListen(t, n), e.Ya.delete(t), e.Za.delete(r)), e.Ja.delete(r);
                }
                e.su.removeTarget(r);
            }
        }(e, t);
    } catch (n) {
        __PRIVATE_logDebug(Rn, "Failed to remove targets %s: %s ", t.targetIds.join(","), n), await __PRIVATE_disableNetworkUntilRecovery(e, n);
    }
    else if (t instanceof __PRIVATE_DocumentWatchChange ? e.su.et(t) : t instanceof __PRIVATE_ExistenceFilterChange ? e.su.ot(t) : e.su.rt(t), !n.isEqual(SnapshotVersion.min())) try {
        const t = await __PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore);
        n.compareTo(t) >= 0 && // We have received a target change with a global snapshot if the snapshot
        // version is not equal to SnapshotVersion.min().
        /**
 * Takes a batch of changes from the Datastore, repackages them as a
 * RemoteEvent, and passes that on to the listener, which is typically the
 * SyncEngine.
 */ await function __PRIVATE_raiseWatchSnapshot(e, t) {
            const n = e.su.Rt(t);
            // Update in-memory resume tokens. LocalStore will update the
            // persistent view of these when applying the completed RemoteEvent.
            n.targetChanges.forEach((n, r)=>{
                if (n.resumeToken.approximateByteSize() > 0) {
                    const i = e.Ja.get(r);
                    // A watched target might have been removed already.
                    i && e.Ja.set(r, i.withResumeToken(n.resumeToken, t));
                }
            }), // Re-establish listens for the targets that have been invalidated by
            // existence filter mismatches.
            // TODO ideally this would use a new remote target ID
            n.targetMismatches.forEach((t, n)=>{
                const r = e.Ja.get(t);
                if (!r) // A watched target might have been removed already.
                return;
                // Clear the resume token for the target, since we're in a known mismatch
                // state.
                e.Ja.set(t, r.withResumeToken(ByteString.EMPTY_BYTE_STRING, r.snapshotVersion)), // Cause a hard reset by unwatching and rewatching immediately, but
                // deliberately don't send a resume token so that we get a full update.
                __PRIVATE_sendUnwatchRequest(e, t);
                // Mark the target we send as being on behalf of an existence filter
                // mismatch, but don't actually retain that in listenTargets. This ensures
                // that we flag the first re-listen this way without impacting future
                // listens of this target (that might happen e.g. on reconnect).
                const i = new TargetData(r.target, t, n, r.sequenceNumber);
                __PRIVATE_sendWatchRequest(e, i);
            });
            const r = /**
 * Convert a RemoteEvent with remote IDs to a RemoteEvent with
 * SDK IDs and dropped updates
 * for any targets we no longer track.
 *
 * @param remoteStoreImpl
 * @param remoteEvent
 * @return a new RemoteEvent with SDK IDs and dropped updates
 * for any targets we no longer track.
 */ function __PRIVATE_toSdkRemoteEvent(e, t) {
                // Map TargetChanges to TargetChanges with SDK ID
                const n = new Map;
                t.targetChanges.forEach((t, r)=>{
                    // If we no longer track the remote ID, then drop the TargetChange
                    // otherwise propagate the TargetChange
                    const i = e.Za.get(r);
                    void 0 !== i && n.set(i, t);
                });
                // Map target mismatches to target mismatches with SDK ID
                let r = new SortedMap(__PRIVATE_primitiveComparator);
                return t.targetMismatches.forEach((t, n)=>{
                    // If we no longer track the remote ID, then drop the target mismatch
                    // otherwise propagate the target mismatch
                    const i = e.Za.get(t);
                    void 0 !== i && (r = r.insert(i, n));
                }), new RemoteEvent(t.snapshotVersion, n, r, t.documentUpdates, t.augmentedDocumentUpdates, t.resolvedLimboDocuments);
            }(e, n);
            return e.remoteSyncer.applyRemoteEvent(r);
        }(e, n);
    } catch (t) {
        __PRIVATE_logDebug(Rn, "Failed to raise snapshot:", t), await __PRIVATE_disableNetworkUntilRecovery(e, t);
    }
}
/**
 * Recovery logic for IndexedDB errors that takes the network offline until
 * `op` succeeds. Retries are scheduled with backoff using
 * `enqueueRetryable()`. If `op()` is not provided, IndexedDB access is
 * validated via a generic operation.
 *
 * The returned Promise is resolved once the network is disabled and before
 * any retry attempt.
 */ async function __PRIVATE_disableNetworkUntilRecovery(e, t, n) {
    if (!__PRIVATE_isIndexedDbTransactionError(t)) throw t;
    e.tu.add(1 /* OfflineCause.IndexedDbFailed */ ), // Disable network and raise offline snapshots
    await __PRIVATE_disableNetworkInternal(e), e.iu.set("Offline" /* OnlineState.Offline */ ), n || // Use a simple read operation to determine if IndexedDB recovered.
    // Ideally, we would expose a health check directly on SimpleDb, but
    // RemoteStore only has access to persistence through LocalStore.
    (n = ()=>__PRIVATE_localStoreGetLastRemoteSnapshotVersion(e.localStore)), // Probe IndexedDB periodically and re-enable network
    e.asyncQueue.enqueueRetryable(async ()=>{
        __PRIVATE_logDebug(Rn, "Retrying IndexedDB access"), await n(), e.tu.delete(1 /* OfflineCause.IndexedDbFailed */ ), await __PRIVATE_enableNetworkInternal(e);
    });
}
/**
 * Executes `op`. If `op` fails, takes the network offline until `op`
 * succeeds. Returns after the first attempt.
 */ function __PRIVATE_executeWithRecovery(e, t) {
    return t().catch((n)=>__PRIVATE_disableNetworkUntilRecovery(e, n, t));
}
async function __PRIVATE_fillWritePipeline(e) {
    const t = __PRIVATE_debugCast(e), n = __PRIVATE_ensureWriteStream(t);
    let r = t.Ha.length > 0 ? t.Ha[t.Ha.length - 1].batchId : $;
    for(; __PRIVATE_canAddToWritePipeline(t);)try {
        const e = await __PRIVATE_localStoreGetNextMutationBatch(t.localStore, r);
        if (null === e) {
            0 === t.Ha.length && n.Nn();
            break;
        }
        r = e.batchId, __PRIVATE_addToWritePipeline(t, e);
    } catch (e) {
        await __PRIVATE_disableNetworkUntilRecovery(t, e);
    }
    __PRIVATE_shouldStartWriteStream(t) && __PRIVATE_startWriteStream(t);
}
/**
 * Returns true if we can add to the write pipeline (i.e. the network is
 * enabled and the write pipeline is not full).
 */ function __PRIVATE_canAddToWritePipeline(e) {
    return __PRIVATE_canUseNetwork(e) && e.Ha.length < 10;
}
/**
 * Queues additional writes to be sent to the write stream, sending them
 * immediately if the write stream is established.
 */ function __PRIVATE_addToWritePipeline(e, t) {
    e.Ha.push(t);
    const n = __PRIVATE_ensureWriteStream(e);
    n.Fn() && n.Jn && n.Yn(t.mutations);
}
function __PRIVATE_shouldStartWriteStream(e) {
    return __PRIVATE_canUseNetwork(e) && !__PRIVATE_ensureWriteStream(e).Cn() && e.Ha.length > 0;
}
function __PRIVATE_startWriteStream(e) {
    __PRIVATE_ensureWriteStream(e).start();
}
async function __PRIVATE_onWriteStreamOpen(e) {
    __PRIVATE_ensureWriteStream(e).er();
}
async function __PRIVATE_onWriteHandshakeComplete(e) {
    const t = __PRIVATE_ensureWriteStream(e);
    // Send the write pipeline now that the stream is established.
    for (const n of e.Ha)t.Yn(n.mutations);
}
async function __PRIVATE_onMutationResult(e, t, n) {
    const r = e.Ha.shift(), i = MutationBatchResult.from(r, t, n);
    await __PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.applySuccessfulWrite(i)), // It's possible that with the completion of this mutation another
    // slot has freed up.
    await __PRIVATE_fillWritePipeline(e);
}
async function __PRIVATE_onWriteStreamClose(e, t) {
    // If the write stream closed after the write handshake completes, a write
    // operation failed and we fail the pending operation.
    t && __PRIVATE_ensureWriteStream(e).Jn && // This error affects the actual write.
    await async function __PRIVATE_handleWriteError(e, t) {
        // Only handle permanent errors here. If it's transient, just let the retry
        // logic kick in.
        if (function __PRIVATE_isPermanentWriteError(e) {
            return __PRIVATE_isPermanentError(e) && e !== D.ABORTED;
        }(t.code)) {
            // This was a permanent error, the request itself was the problem
            // so it's not going to succeed if we resend it.
            const n = e.Ha.shift();
            // In this case it's also unlikely that the server itself is melting
            // down -- this was just a bad request so inhibit backoff on the next
            // restart.
            __PRIVATE_ensureWriteStream(e).Mn(), await __PRIVATE_executeWithRecovery(e, ()=>e.remoteSyncer.rejectFailedWrite(n.batchId, t)), // It's possible that with the completion of this mutation
            // another slot has freed up.
            await __PRIVATE_fillWritePipeline(e);
        }
    }(e, t), // The write stream might have been started by refilling the write
    // pipeline for failed writes
    __PRIVATE_shouldStartWriteStream(e) && __PRIVATE_startWriteStream(e);
}
async function __PRIVATE_remoteStoreHandleCredentialChange(e, t) {
    const n = __PRIVATE_debugCast(e);
    n.asyncQueue.verifyOperationInProgress(), __PRIVATE_logDebug(Rn, "RemoteStore received new credentials");
    const r = __PRIVATE_canUseNetwork(n);
    // Tear down and re-create our network streams. This will ensure we get a
    // fresh auth token for the new user and re-fill the write pipeline with
    // new mutations from the LocalStore (since mutations are per-user).
    n.tu.add(3 /* OfflineCause.CredentialChange */ ), await __PRIVATE_disableNetworkInternal(n), r && // Don't set the network status to Unknown if we are offline.
    n.iu.set("Unknown" /* OnlineState.Unknown */ ), await n.remoteSyncer.handleCredentialChange(t), n.tu.delete(3 /* OfflineCause.CredentialChange */ ), await __PRIVATE_enableNetworkInternal(n);
}
/**
 * Toggles the network state when the client gains or loses its primary lease.
 */ async function __PRIVATE_remoteStoreApplyPrimaryState(e, t) {
    const n = __PRIVATE_debugCast(e);
    t ? (n.tu.delete(2 /* OfflineCause.IsSecondary */ ), await __PRIVATE_enableNetworkInternal(n)) : t || (n.tu.add(2 /* OfflineCause.IsSecondary */ ), await __PRIVATE_disableNetworkInternal(n), n.iu.set("Unknown" /* OnlineState.Unknown */ ));
}
/**
 * If not yet initialized, registers the WatchStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WatchStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function __PRIVATE_ensureWatchStream(e) {
    return e._u || // Create stream (but note that it is not started yet).
    (e._u = function __PRIVATE_newPersistentWatchStream(e, t, n) {
        const r = __PRIVATE_debugCast(e);
        return r.nr(), new __PRIVATE_PersistentListenStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Qt: __PRIVATE_onWatchStreamConnected.bind(null, e),
        zt: __PRIVATE_onWatchStreamOpen.bind(null, e),
        Ht: __PRIVATE_onWatchStreamClose.bind(null, e),
        zn: __PRIVATE_onWatchStreamChange.bind(null, e)
    }), e.nu.push(async (t)=>{
        t ? (e._u.Mn(), __PRIVATE_shouldStartWatchStream(e) ? __PRIVATE_startWatchStream(e) : e.iu.set("Unknown" /* OnlineState.Unknown */ )) : (await e._u.stop(), __PRIVATE_cleanUpWatchStreamState(e));
    })), e._u;
}
/**
 * If not yet initialized, registers the WriteStream and its network state
 * callback with `remoteStoreImpl`. Returns the existing stream if one is
 * already available.
 *
 * PORTING NOTE: On iOS and Android, the WriteStream gets registered on startup.
 * This is not done on Web to allow it to be tree-shaken.
 */ function __PRIVATE_ensureWriteStream(e) {
    return e.ou || // Create stream (but note that it is not started yet).
    (e.ou = function __PRIVATE_newPersistentWriteStream(e, t, n) {
        const r = __PRIVATE_debugCast(e);
        return r.nr(), new __PRIVATE_PersistentWriteStream(t, r.connection, r.authCredentials, r.appCheckCredentials, r.serializer, n);
    }(e.datastore, e.asyncQueue, {
        Qt: ()=>Promise.resolve(),
        zt: __PRIVATE_onWriteStreamOpen.bind(null, e),
        Ht: __PRIVATE_onWriteStreamClose.bind(null, e),
        Zn: __PRIVATE_onWriteHandshakeComplete.bind(null, e),
        Xn: __PRIVATE_onMutationResult.bind(null, e)
    }), e.nu.push(async (t)=>{
        t ? (e.ou.Mn(), // This will start the write stream if necessary.
        await __PRIVATE_fillWritePipeline(e)) : (await e.ou.stop(), e.Ha.length > 0 && (__PRIVATE_logDebug(Rn, `Stopping write stream with ${e.Ha.length} pending writes`), e.Ha = []));
    })), e.ou;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents an operation scheduled to be run in the future on an AsyncQueue.
 *
 * It is created via DelayedOperation.createAndSchedule().
 *
 * Supports cancellation (via cancel()) and early execution (via skipDelay()).
 *
 * Note: We implement `PromiseLike` instead of `Promise`, as the `Promise` type
 * in newer versions of TypeScript defines `finally`, which is not available in
 * IE.
 */ class DelayedOperation {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.timerId = t, this.targetTimeMs = n, this.op = r, this.removalCallback = i, this.deferred = new __PRIVATE_Deferred, this.then = this.deferred.promise.then.bind(this.deferred.promise), // It's normal for the deferred promise to be canceled (due to cancellation)
        // and so we attach a dummy catch callback to avoid
        // 'UnhandledPromiseRejectionWarning' log spam.
        this.deferred.promise.catch((e)=>{});
    }
    get promise() {
        return this.deferred.promise;
    }
    /**
     * Creates and returns a DelayedOperation that has been scheduled to be
     * executed on the provided asyncQueue after the provided delayMs.
     *
     * @param asyncQueue - The queue to schedule the operation on.
     * @param id - A Timer ID identifying the type of operation this is.
     * @param delayMs - The delay (ms) before the operation should be scheduled.
     * @param op - The operation to run.
     * @param removalCallback - A callback to be called synchronously once the
     *   operation is executed or canceled, notifying the AsyncQueue to remove it
     *   from its delayedOperations list.
     *   PORTING NOTE: This exists to prevent making removeDelayedOperation() and
     *   the DelayedOperation class public.
     */ static createAndSchedule(e, t, n, r, i) {
        const s = Date.now() + n, _ = new DelayedOperation(e, t, s, r, i);
        return _.start(n), _;
    }
    /**
     * Starts the timer. This is called immediately after construction by
     * createAndSchedule().
     */ start(e) {
        this.timerHandle = setTimeout(()=>this.handleDelayElapsed(), e);
    }
    /**
     * Queues the operation to run immediately (if it hasn't already been run or
     * canceled).
     */ skipDelay() {
        return this.handleDelayElapsed();
    }
    /**
     * Cancels the operation if it hasn't already been executed or canceled. The
     * promise will be rejected.
     *
     * As long as the operation has not yet been run, calling cancel() provides a
     * guarantee that the operation will not be run.
     */ cancel(e) {
        null !== this.timerHandle && (this.clearTimeout(), this.deferred.reject(new FirestoreError(D.CANCELLED, "Operation cancelled" + (e ? ": " + e : ""))));
    }
    handleDelayElapsed() {
        this.asyncQueue.enqueueAndForget(()=>null !== this.timerHandle ? (this.clearTimeout(), this.op().then((e)=>this.deferred.resolve(e))) : Promise.resolve());
    }
    clearTimeout() {
        null !== this.timerHandle && (this.removalCallback(this), clearTimeout(this.timerHandle), this.timerHandle = null);
    }
}
/**
 * Returns a FirestoreError that can be surfaced to the user if the provided
 * error is an IndexedDbTransactionError. Re-throws the error otherwise.
 */ function __PRIVATE_wrapInUserErrorIfRecoverable(e, t) {
    if (__PRIVATE_logError("AsyncQueue", `${t}: ${e}`), __PRIVATE_isIndexedDbTransactionError(e)) return new FirestoreError(D.UNAVAILABLE, `${t}: ${e}`);
    throw e;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentSet is an immutable (copy-on-write) collection that holds documents
 * in order specified by the provided comparator. We always add a document key
 * comparator on top of what is provided to guarantee document equality based on
 * the key.
 */ class DocumentSet {
    /**
     * Returns an empty copy of the existing DocumentSet, using the same
     * comparator.
     */ static emptySet(e) {
        return new DocumentSet(e.comparator);
    }
    /** The default ordering is by key if the comparator is omitted */ constructor(e){
        // We are adding document key comparator to the end as it's the only
        // guaranteed unique property of a document.
        this.comparator = e ? (t, n)=>e(t, n) || DocumentKey.comparator(t.key, n.key) : (e, t)=>DocumentKey.comparator(e.key, t.key), this.keyedMap = documentMap(), this.sortedSet = new SortedMap(this.comparator);
    }
    has(e) {
        return null != this.keyedMap.get(e);
    }
    get(e) {
        return this.keyedMap.get(e);
    }
    first() {
        return this.sortedSet.minKey();
    }
    last() {
        return this.sortedSet.maxKey();
    }
    isEmpty() {
        return this.sortedSet.isEmpty();
    }
    /**
     * Returns the index of the provided key in the document set, or -1 if the
     * document key is not present in the set;
     */ indexOf(e) {
        const t = this.keyedMap.get(e);
        return t ? this.sortedSet.indexOf(t) : -1;
    }
    get size() {
        return this.sortedSet.size;
    }
    /** Iterates documents in order defined by "comparator" */ forEach(e) {
        this.sortedSet.inorderTraversal((t, n)=>(e(t), !1));
    }
    /** Inserts or updates a document with the same key */ add(e) {
        // First remove the element if we have it.
        const t = this.delete(e.key);
        return t.copy(t.keyedMap.insert(e.key, e), t.sortedSet.insert(e, null));
    }
    /** Deletes a document with a given key */ delete(e) {
        const t = this.get(e);
        return t ? this.copy(this.keyedMap.remove(e), this.sortedSet.remove(t)) : this;
    }
    isEqual(e) {
        if (!(e instanceof DocumentSet)) return !1;
        if (this.size !== e.size) return !1;
        const t = this.sortedSet.getIterator(), n = e.sortedSet.getIterator();
        for(; t.hasNext();){
            const e = t.getNext().key, r = n.getNext().key;
            if (!e.isEqual(r)) return !1;
        }
        return !0;
    }
    toString() {
        const e = [];
        return this.forEach((t)=>{
            e.push(t.toString());
        }), 0 === e.length ? "DocumentSet ()" : "DocumentSet (\n  " + e.join("  \n") + "\n)";
    }
    copy(e, t) {
        const n = new DocumentSet;
        return n.comparator = this.comparator, n.keyedMap = e, n.sortedSet = t, n;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * DocumentChangeSet keeps track of a set of changes to docs in a query, merging
 * duplicate events for the same doc.
 */ class __PRIVATE_DocumentChangeSet {
    constructor(){
        this.au = new SortedMap(DocumentKey.comparator);
    }
    track(e) {
        const t = e.doc.key, n = this.au.get(t);
        n ? // Merge the new change with the existing change.
        0 /* ChangeType.Added */  !== e.type && 3 /* ChangeType.Metadata */  === n.type ? this.au = this.au.insert(t, e) : 3 /* ChangeType.Metadata */  === e.type && 1 /* ChangeType.Removed */  !== n.type ? this.au = this.au.insert(t, {
            type: n.type,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.au = this.au.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : 2 /* ChangeType.Modified */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.au = this.au.insert(t, {
            type: 0 /* ChangeType.Added */ ,
            doc: e.doc
        }) : 1 /* ChangeType.Removed */  === e.type && 0 /* ChangeType.Added */  === n.type ? this.au = this.au.remove(t) : 1 /* ChangeType.Removed */  === e.type && 2 /* ChangeType.Modified */  === n.type ? this.au = this.au.insert(t, {
            type: 1 /* ChangeType.Removed */ ,
            doc: n.doc
        }) : 0 /* ChangeType.Added */  === e.type && 1 /* ChangeType.Removed */  === n.type ? this.au = this.au.insert(t, {
            type: 2 /* ChangeType.Modified */ ,
            doc: e.doc
        }) : // This includes these cases, which don't make sense:
        // Added->Added
        // Removed->Removed
        // Modified->Added
        // Removed->Modified
        // Metadata->Added
        // Removed->Metadata
        fail(63341, {
            ft: e,
            uu: n
        }) : this.au = this.au.insert(t, e);
    }
    cu() {
        const e = [];
        return this.au.inorderTraversal((t, n)=>{
            e.push(n);
        }), e;
    }
}
class ViewSnapshot {
    constructor(e, t, n, r, i, s, _, o, a){
        this.query = e, this.docs = t, this.oldDocs = n, this.docChanges = r, this.mutatedKeys = i, this.fromCache = s, this.syncStateChanged = _, this.excludesMetadataChanges = o, this.hasCachedResults = a;
    }
    /** Returns a view snapshot as if all documents in the snapshot were added. */ static fromInitialDocuments(e, t, n, r, i) {
        const s = [];
        return t.forEach((e)=>{
            s.push({
                type: 0 /* ChangeType.Added */ ,
                doc: e
            });
        }), new ViewSnapshot(e, t, DocumentSet.emptySet(t), s, n, r, /* syncStateChanged= */ !0, /* excludesMetadataChanges= */ !1, i);
    }
    get hasPendingWrites() {
        return !this.mutatedKeys.isEmpty();
    }
    isEqual(e) {
        if (!(this.fromCache === e.fromCache && this.hasCachedResults === e.hasCachedResults && this.syncStateChanged === e.syncStateChanged && this.mutatedKeys.isEqual(e.mutatedKeys) && __PRIVATE_queryOrPipelineEqual(this.query, e.query) && this.docs.isEqual(e.docs) && this.oldDocs.isEqual(e.oldDocs))) return !1;
        const t = this.docChanges, n = e.docChanges;
        if (t.length !== n.length) return !1;
        for(let e = 0; e < t.length; e++)if (t[e].type !== n[e].type || !t[e].doc.isEqual(n[e].doc)) return !1;
        return !0;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Holds the listeners and the last received ViewSnapshot for a query being
 * tracked by EventManager.
 */ class __PRIVATE_QueryListenersInfo {
    constructor(){
        this.lu = void 0, this.Eu = [];
    }
    // Helper methods that checks if the query has listeners that listening to remote store
    hu() {
        return this.Eu.some((e)=>e.Tu());
    }
}
class __PRIVATE_EventManagerImpl {
    constructor(){
        this.queries = __PRIVATE_newQueriesObjectMap(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.Pu = new Set;
    }
    terminate() {
        !function __PRIVATE_errorAllTargets(e, t) {
            const n = __PRIVATE_debugCast(e), r = n.queries;
            // Prevent further access by clearing ObjectMap.
            n.queries = __PRIVATE_newQueriesObjectMap(), r.forEach((e, n)=>{
                for (const e of n.Eu)e.onError(t);
            });
        }(this, new FirestoreError(D.ABORTED, "Firestore shutting down"));
    }
}
function __PRIVATE_newQueriesObjectMap() {
    return new ObjectMap((e)=>__PRIVATE_canonifyQueryOrPipeline(e), __PRIVATE_queryOrPipelineEqual);
}
async function __PRIVATE_eventManagerListen(e, t) {
    const n = __PRIVATE_debugCast(e);
    let r = 3 /* ListenerSetupAction.NoActionRequired */ ;
    const i = t.query;
    let s = n.queries.get(i);
    s ? !s.hu() && t.Tu() && // Query has been listening to local cache, and tries to add a new listener sourced from watch.
    (r = 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ ) : (s = new __PRIVATE_QueryListenersInfo, r = t.Tu() ? 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */  : 1 /* ListenerSetupAction.InitializeLocalListenOnly */ );
    try {
        switch(r){
            case 0 /* ListenerSetupAction.InitializeLocalListenAndRequireWatchConnection */ :
                s.lu = await n.onListen(i, /** enableRemoteListen= */ !0);
                break;
            case 1 /* ListenerSetupAction.InitializeLocalListenOnly */ :
                s.lu = await n.onListen(i, /** enableRemoteListen= */ !1);
                break;
            case 2 /* ListenerSetupAction.RequireWatchConnectionOnly */ :
                await n.onFirstRemoteStoreListen(i);
        }
    } catch (e) {
        const n = __PRIVATE_wrapInUserErrorIfRecoverable(e, `Initialization of query '${__PRIVATE_isPipeline(t.query) ? __PRIVATE_canonifyPipeline(t.query) : __PRIVATE_stringifyQuery(t.query)}' failed`);
        return void t.onError(n);
    }
    if (n.queries.set(i, s), s.Eu.push(t), // Run global snapshot listeners if a consistent snapshot has been emitted.
    t.Ru(n.onlineState), s.lu) t.Iu(s.lu) && __PRIVATE_raiseSnapshotsInSyncEvent(n);
}
async function __PRIVATE_eventManagerUnlisten(e, t) {
    const n = __PRIVATE_debugCast(e), r = t.query;
    let i = 3 /* ListenerRemovalAction.NoActionRequired */ ;
    const s = n.queries.get(r);
    if (s) {
        const e = s.Eu.indexOf(t);
        e >= 0 && (s.Eu.splice(e, 1), 0 === s.Eu.length ? i = t.Tu() ? 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */  : 1 /* ListenerRemovalAction.TerminateLocalListenOnly */  : !s.hu() && t.Tu() && // The removed listener is the last one that sourced from watch.
        (i = 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ ));
    }
    switch(i){
        case 0 /* ListenerRemovalAction.TerminateLocalListenAndRequireWatchDisconnection */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !0);
        case 1 /* ListenerRemovalAction.TerminateLocalListenOnly */ :
            return n.queries.delete(r), n.onUnlisten(r, /** disableRemoteListen= */ !1);
        case 2 /* ListenerRemovalAction.RequireWatchDisconnectionOnly */ :
            return n.onLastRemoteStoreUnlisten(r);
        default:
            return;
    }
}
function __PRIVATE_eventManagerOnWatchChange(e, t) {
    const n = __PRIVATE_debugCast(e);
    let r = !1;
    for (const e of t){
        const t = e.query, i = n.queries.get(t);
        if (i) {
            for (const t of i.Eu)t.Iu(e) && (r = !0);
            i.lu = e;
        }
    }
    r && __PRIVATE_raiseSnapshotsInSyncEvent(n);
}
function __PRIVATE_eventManagerOnWatchError(e, t, n) {
    const r = __PRIVATE_debugCast(e), i = r.queries.get(t);
    if (i) for (const e of i.Eu)e.onError(n);
    // Remove all listeners. NOTE: We don't need to call syncEngine.unlisten()
    // after an error.
    r.queries.delete(t);
}
function __PRIVATE_raiseSnapshotsInSyncEvent(e) {
    e.Pu.forEach((e)=>{
        e.next();
    });
}
var In;
!function(e) {
    /** Listen to both cache and server changes */ e.Default = "default", /** Listen to changes in cache only */ e.Cache = "cache";
}(In || (In = {}));
/**
 * QueryListener takes a series of internal view snapshots and determines
 * when to raise the event.
 *
 * It uses an Observer to dispatch events.
 */ class __PRIVATE_QueryListener {
    constructor(e, t, n){
        this.query = e, this.Au = t, /**
         * Initial snapshots (e.g. from cache) may not be propagated to the wrapped
         * observer. This flag is set to true once we've actually raised an event.
         */ this.Vu = !1, this.du = null, this.onlineState = "Unknown" /* OnlineState.Unknown */ , this.options = n || {};
    }
    /**
     * Applies the new ViewSnapshot to this listener, raising a user-facing event
     * if applicable (depending on what changed, whether the user has opted into
     * metadata-only changes, etc.). Returns true if a user-facing event was
     * indeed raised.
     */ Iu(e) {
        if (!this.options.includeMetadataChanges) {
            // Remove the metadata only changes.
            const t = [];
            for (const n of e.docChanges)3 /* ChangeType.Metadata */  !== n.type && t.push(n);
            e = new ViewSnapshot(e.query, e.docs, e.oldDocs, t, e.mutatedKeys, e.fromCache, e.syncStateChanged, /* excludesMetadataChanges= */ !0, e.hasCachedResults);
        }
        let t = !1;
        return this.Vu ? this.fu(e) && (this.Au.next(e), t = !0) : this.mu(e, this.onlineState) && (this.pu(e), t = !0), this.du = e, t;
    }
    onError(e) {
        this.Au.error(e);
    }
    /** Returns whether a snapshot was raised. */ Ru(e) {
        this.onlineState = e;
        let t = !1;
        return this.du && !this.Vu && this.mu(this.du, e) && (this.pu(this.du), t = !0), t;
    }
    mu(e, t) {
        // Always raise the first event when we're synced
        if (!e.fromCache) return !0;
        // Always raise event if listening to cache
        if (!this.Tu()) return !0;
        // NOTE: We consider OnlineState.Unknown as online (it should become Offline
        // or Online if we wait long enough).
        const n = "Offline" /* OnlineState.Offline */  !== t;
        // Don't raise the event if we're online, aren't synced yet (checked
        // above) and are waiting for a sync.
        return (!this.options.waitForSyncWhenOnline || !n) && (!e.docs.isEmpty() || e.hasCachedResults || "Offline" /* OnlineState.Offline */  === t);
    // Raise data from cache if we have any documents, have cached results before,
    // or we are offline.
    }
    fu(e) {
        // We don't need to handle includeDocumentMetadataChanges here because
        // the Metadata only changes have already been stripped out if needed.
        // At this point the only changes we will see are the ones we should
        // propagate.
        if (e.docChanges.length > 0) return !0;
        const t = this.du && this.du.hasPendingWrites !== e.hasPendingWrites;
        return !(!e.syncStateChanged && !t) && !0 === this.options.includeMetadataChanges;
    // Generally we should have hit one of the cases above, but it's possible
    // to get here if there were only metadata docChanges and they got
    // stripped out.
    }
    pu(e) {
        e = ViewSnapshot.fromInitialDocuments(e.query, e.docs, e.mutatedKeys, e.fromCache, e.hasCachedResults), this.Vu = !0, this.Au.next(e);
    }
    Tu() {
        return this.options.source !== In.Cache;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A complete element in the bundle stream, together with the byte length it
 * occupies in the stream.
 */ class __PRIVATE_SizedBundleElement {
    constructor(e, // How many bytes this element takes to store in the bundle.
    t){
        this.gu = e, this.byteLength = t;
    }
    yu() {
        return "metadata" in this.gu;
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Helper to convert objects from bundles to model objects in the SDK.
 */ class __PRIVATE_BundleConverterImpl {
    constructor(e){
        this.serializer = e;
    }
    Yo(e) {
        return fromName(this.serializer, e);
    }
    /**
     * Converts a BundleDocument to a MutableDocument.
     */ Zo(e) {
        return e.metadata.exists ? fromDocument(this.serializer, e.document, !1) : MutableDocument.newNoDocument(this.Yo(e.metadata.name), this.Xo(e.metadata.readTime));
    }
    Xo(e) {
        return __PRIVATE_fromVersion(e);
    }
}
/**
 * A class to process the elements from a bundle, and optionally load them into local
 * storage and provide progress update while loading.
 */ class __PRIVATE_BundleLoader {
    constructor(e, t){
        this.wu = e, this.serializer = t, /** Batched queries to be saved into storage */ this.bu = [], /** Batched documents to be saved into storage */ this.vu = [], /** The collection groups affected by this bundle. */ this.collectionGroups = new Set, this.progress = __PRIVATE_bundleInitialProgress(e);
    }
    /**
     * Returns the named queries that have been parsed from the SizeBundleElements added by
     * calling {@link adSizedElement}.
     */ get queries() {
        return this.bu;
    }
    /**
     * Returns the BundledDocuments that have been parsed from the SizeBundleElements added by
     * calling {@link addSizedElement}.
     */ get documents() {
        return this.vu;
    }
    /**
     * Adds an element from the bundle to the loader.
     *
     * Returns a new progress if adding the element leads to a new progress,
     * otherwise returns null.
     */ o(e) {
        this.progress.bytesLoaded += e.byteLength;
        let t = this.progress.documentsLoaded;
        if (e.gu.namedQuery) this.bu.push(e.gu.namedQuery);
        else if (e.gu.documentMetadata) {
            this.vu.push({
                metadata: e.gu.documentMetadata
            }), e.gu.documentMetadata.exists || ++t;
            const n = ResourcePath.fromString(e.gu.documentMetadata.name);
            this.collectionGroups.add(n.get(n.length - 2));
        } else e.gu.document && (this.vu[this.vu.length - 1].document = e.gu.document, ++t);
        return t !== this.progress.documentsLoaded ? (this.progress.documentsLoaded = t, {
            ...this.progress
        }) : null;
    }
    Du(e) {
        const t = new Map, n = new __PRIVATE_BundleConverterImpl(this.serializer);
        for (const r of e)if (r.metadata.queries) {
            const e = n.Yo(r.metadata.name);
            for (const n of r.metadata.queries){
                const r = (t.get(n) || __PRIVATE_documentKeySet()).add(e);
                t.set(n, r);
            }
        }
        return t;
    }
    /**
     * Update the progress to 'Success' and return the updated progress.
     */ async xu(e) {
        const t = await __PRIVATE_localStoreApplyBundledDocuments(e, new __PRIVATE_BundleConverterImpl(this.serializer), this.vu, this.wu.id), n = this.Du(this.documents);
        for (const t of this.bu)await __PRIVATE_localStoreSaveNamedQuery(e, t, n.get(t.name));
        return this.progress.taskState = "Success", {
            progress: this.progress,
            Cu: this.collectionGroups,
            Fu: t
        };
    }
}
/**
 * Returns a `LoadBundleTaskProgress` representing the initial progress of
 * loading a bundle.
 */ function __PRIVATE_bundleInitialProgress(e) {
    return {
        taskState: "Running",
        documentsLoaded: 0,
        bytesLoaded: 0,
        totalDocuments: e.totalDocuments,
        totalBytes: e.totalBytes
    };
}
/**
 * Returns a `LoadBundleTaskProgress` representing the progress that the loading
 * has succeeded.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_AddedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
class __PRIVATE_RemovedLimboDocument {
    constructor(e){
        this.key = e;
    }
}
/**
 * View is responsible for computing the final merged truth of what docs are in
 * a query. It gets notified of local and remote changes to docs, and applies
 * the query filters and limits to determine the most correct possible results.
 */ class __PRIVATE_View {
    constructor(e, /** Documents included in the remote target */ t){
        this.query = e, this.Ou = t, this.Mu = null, this.hasCachedResults = !1, /**
         * A flag whether the view is current with the backend. A view is considered
         * current after it has seen the current flag from the backend and did not
         * lose consistency within the watch stream (e.g. because of an existence
         * filter mismatch).
         */ this.current = !1, /** Documents in the view but not in the remote target */ this.Nu = __PRIVATE_documentKeySet(), /** Document Keys that have local changes */ this.mutatedKeys = __PRIVATE_documentKeySet(), this.Lu = __PRIVATE_isPipeline(e) ? __PRIVATE_newPipelineComparator(e) : __PRIVATE_newQueryComparator(e), this.Bu = new DocumentSet(this.Lu);
    }
    /**
     * The set of remote documents that the server has told us belongs to the target associated with
     * this view.
     */ get Uu() {
        return this.Ou;
    }
    /**
     * Iterates over a set of doc changes, applies the query limit, and computes
     * what the new results should be, what the changes were, and whether we may
     * need to go back to the local cache for more results. Does not make any
     * changes to the view.
     * @param docChanges - The doc changes to apply to this view.
     * @param previousChanges - If this is being called with a refill, then start
     *        with this set of docs and changes instead of the current view.
     * @returns a new set of docs, changes, and refill flag.
     */ ku(e, t) {
        const n = t ? t.qu : new __PRIVATE_DocumentChangeSet, r = t ? t.Bu : this.Bu;
        let i = t ? t.mutatedKeys : this.mutatedKeys, s = r, _ = !1;
        const [o, a] = this.$u(this.query, r);
        e.inorderTraversal((e, t)=>{
            const u = r.get(e), c = __PRIVATE_queryOrPipelineMatches(this.query, t) ? t : null, l = !!u && this.mutatedKeys.has(u.key), E = !!c && (c.hasLocalMutations || // We only consider committed mutations for documents that were
            // mutated during the lifetime of the view.
            this.mutatedKeys.has(c.key) && c.hasCommittedMutations);
            let h = !1;
            // Calculate change
            if (u && c) u.data.isEqual(c.data) ? l !== E && (n.track({
                type: 3 /* ChangeType.Metadata */ ,
                doc: c
            }), h = !0) : this.Ku(u, c) || (n.track({
                type: 2 /* ChangeType.Modified */ ,
                doc: c
            }), h = !0, (o && this.Lu(c, o) > 0 || a && this.Lu(c, a) < 0) && // This doc moved from inside the limit to outside the limit.
            // That means there may be some other doc in the local cache
            // that should be included instead.
            (_ = !0));
            else !u && c ? (n.track({
                type: 0 /* ChangeType.Added */ ,
                doc: c
            }), h = !0) : u && !c && (n.track({
                type: 1 /* ChangeType.Removed */ ,
                doc: u
            }), h = !0, (o || a) && // A doc was removed from a full limit query. We'll need to
            // requery from the local cache to see if we know about some other
            // doc that should be in the results.
            (_ = !0));
            h && (c ? (s = s.add(c), i = E ? i.add(e) : i.delete(e)) : (s = s.delete(e), i = i.delete(e)));
        });
        // Drop documents out to meet limit/limitToLast requirement.
        const u = this.Wu(this.query);
        if (u) {
            if (__PRIVATE_isPipeline(this.query)) {
                // TODO(pipeline): Not very efficient obviously, but should be fine for now.
                // Longer term, limit queries should be evaluated from query engine as well.
                const e = [];
                s.forEach((t)=>e.push(t));
                const t = __PRIVATE_runPipeline(this.query, e);
                let r = new DocumentSet(__PRIVATE_newPipelineComparator(this.query));
                for (const e of t)r = r.add(e);
                s.forEach((e)=>{
                    r.has(e.key) || (i = i.delete(e.key), n.track({
                        type: 1 /* ChangeType.Removed */ ,
                        doc: e
                    }));
                }), s = r;
            } else {
                const e = this.Qu(this.query);
                for(; s.size > u;){
                    const t = "F" /* LimitType.First */  === e ? s.last() : s.first();
                    s = s.delete(t.key), i = i.delete(t.key), n.track({
                        type: 1 /* ChangeType.Removed */ ,
                        doc: t
                    });
                }
            }
        }
        return {
            Bu: s,
            qu: n,
            Uo: _,
            mutatedKeys: i
        };
    }
    Wu(e) {
        return __PRIVATE_isPipeline(e) ? __PRIVATE_getLastEffectiveLimit(e)?.limit : e.limit || void 0;
    }
    Qu(e) {
        if (__PRIVATE_isPipeline(e)) {
            const t = __PRIVATE_getLastEffectiveLimit(e);
            return t && t.limit < 0 ? "L" /* LimitType.Last */  : "F" /* LimitType.First */ ;
        }
        return e.limitType;
    }
    $u(e, t) {
        if (__PRIVATE_isPipeline(e)) {
            const n = __PRIVATE_getLastEffectiveLimit(e)?.limit;
            return [
                t.size === n ? t.last() : null,
                null
            ];
        }
        return [
            "F" /* LimitType.First */  === e.limitType && t.size === this.Wu(this.query) ? t.last() : null,
            "L" /* LimitType.Last */  === e.limitType && t.size === this.Wu(this.query) ? t.first() : null
        ];
    }
    Ku(e, t) {
        // We suppress the initial change event for documents that were modified as
        // part of a write acknowledgment (e.g. when the value of a server transform
        // is applied) as Watch will send us the same document again.
        // By suppressing the event, we only raise two user visible events (one with
        // `hasPendingWrites` and the final state of the document) instead of three
        // (one with `hasPendingWrites`, the modified document with
        // `hasPendingWrites` and the final state of the document).
        return e.hasLocalMutations && t.hasCommittedMutations && !t.hasLocalMutations;
    }
    /**
     * Updates the view with the given ViewDocumentChanges and optionally updates
     * limbo docs and sync state from the provided target change.
     * @param docChanges - The set of changes to make to the view's docs.
     * @param limboResolutionEnabled - Whether to update limbo documents based on
     *        this change.
     * @param targetChange - A target change to apply for computing limbo docs and
     *        sync state.
     * @param targetIsPendingReset - Whether the target is pending to reset due to
     *        existence filter mismatch. If not explicitly specified, it is treated
     *        equivalently to `false`.
     * @returns A new ViewChange with the given docs, changes, and sync state.
     */ // PORTING NOTE: The iOS/Android clients always compute limbo document changes.
    applyChanges(e, t, n, r) {
        const i = this.Bu;
        this.Bu = e.Bu, this.mutatedKeys = e.mutatedKeys;
        // Sort changes based on type and query comparator
        const s = e.qu.cu();
        s.sort((e, t)=>(function __PRIVATE_compareChangeType(e, t) {
                const order = (e)=>{
                    switch(e){
                        case 0 /* ChangeType.Added */ :
                            return 1;
                        case 2 /* ChangeType.Modified */ :
                        case 3 /* ChangeType.Metadata */ :
                            // A metadata change is converted to a modified change at the public
                            // api layer.  Since we sort by document key and then change type,
                            // metadata and modified changes must be sorted equivalently.
                            return 2;
                        case 1 /* ChangeType.Removed */ :
                            return 0;
                        default:
                            return fail(20277, {
                                ft: e
                            });
                    }
                };
                return order(e) - order(t);
            })(e.type, t.type) || this.Lu(e.doc, t.doc)), this.Gu(n), r = r ?? !1;
        const _ = t && !r ? this.zu() : [], o = 0 === this.Nu.size && this.current && !r ? 1 /* SyncState.Synced */  : 0 /* SyncState.Local */ , a = o !== this.Mu;
        // We are at synced state if there is no limbo docs are waiting to be resolved, view is current
        // with the backend, and the query is not pending to reset due to existence filter mismatch.
        if (this.Mu = o, 0 !== s.length || a) return {
            snapshot: new ViewSnapshot(this.query, e.Bu, i, s, e.mutatedKeys, 0 /* SyncState.Local */  === o, a, /* excludesMetadataChanges= */ !1, !!n && n.resumeToken.approximateByteSize() > 0),
            ju: _
        };
        // no changes
        return {
            ju: _
        };
    }
    /**
     * Applies an OnlineState change to the view, potentially generating a
     * ViewChange if the view's syncState changes as a result.
     */ Ru(e) {
        return this.current && "Offline" /* OnlineState.Offline */  === e ? // If we're offline, set `current` to false and then call applyChanges()
        // to refresh our syncState and generate a ViewChange as appropriate. We
        // are guaranteed to get a new TargetChange that sets `current` back to
        // true once the client is back online.
        (this.current = !1, this.applyChanges({
            Bu: this.Bu,
            qu: new __PRIVATE_DocumentChangeSet,
            mutatedKeys: this.mutatedKeys,
            Uo: !1
        }, /* limboResolutionEnabled= */ !1)) : {
            ju: []
        };
    }
    /**
     * Returns whether the doc for the given key should be in limbo.
     */ Hu(e) {
        // If the remote end says it's part of this query, it's not in limbo.
        return !this.Ou.has(e) && // The local store doesn't think it's a result, so it shouldn't be in limbo.
        !!this.Bu.has(e) && !this.Bu.get(e).hasLocalMutations;
    }
    /**
     * Updates syncedDocuments, current, and limbo docs based on the given change.
     * Returns the list of changes to which docs are in limbo.
     */ Gu(e) {
        e && (e.addedDocuments.forEach((e)=>this.Ou = this.Ou.add(e)), e.modifiedDocuments.forEach((e)=>{}), e.removedDocuments.forEach((e)=>this.Ou = this.Ou.delete(e)), this.current = e.current);
    }
    zu() {
        // We can only determine limbo documents when we're in-sync with the server.
        if (!this.current) return [];
        // TODO(klimt): Do this incrementally so that it's not quadratic when
        // updating many documents.
        const e = this.Nu;
        this.Nu = __PRIVATE_documentKeySet(), this.Bu.forEach((e)=>{
            this.Hu(e.key) && (this.Nu = this.Nu.add(e.key));
        });
        // Diff the new limbo docs with the old limbo docs.
        const t = [];
        return e.forEach((e)=>{
            this.Nu.has(e) || t.push(new __PRIVATE_RemovedLimboDocument(e));
        }), this.Nu.forEach((n)=>{
            e.has(n) || t.push(new __PRIVATE_AddedLimboDocument(n));
        }), t;
    }
    /**
     * Update the in-memory state of the current view with the state read from
     * persistence.
     *
     * We update the query view whenever a client's primary status changes:
     * - When a client transitions from primary to secondary, it can miss
     *   LocalStorage updates and its query views may temporarily not be
     *   synchronized with the state on disk.
     * - For secondary to primary transitions, the client needs to update the list
     *   of `syncedDocuments` since secondary clients update their query views
     *   based purely on synthesized RemoteEvents.
     *
     * @param queryResult.documents - The documents that match the query according
     * to the LocalStore.
     * @param queryResult.remoteKeys - The keys of the documents that match the
     * query according to the backend.
     *
     * @returns The ViewChange that resulted from this synchronization.
     */ // PORTING NOTE: Multi-tab only.
    Ju(e) {
        this.Ou = e.Jo, this.Nu = __PRIVATE_documentKeySet();
        const t = this.ku(e.documents);
        return this.applyChanges(t, /* limboResolutionEnabled= */ !0);
    }
    /**
     * Returns a view snapshot as if this query was just listened to. Contains
     * a document add for every existing document and the `fromCache` and
     * `hasPendingWrites` status of the already established view.
     */ // PORTING NOTE: Multi-tab only.
    Yu() {
        return ViewSnapshot.fromInitialDocuments(this.query, this.Bu, this.mutatedKeys, 0 /* SyncState.Local */  === this.Mu, this.hasCachedResults);
    }
}
const An = "SyncEngine";
/**
 * QueryView contains all of the data that SyncEngine needs to keep track of for
 * a particular query.
 */ class __PRIVATE_QueryView {
    constructor(/**
     * The query itself.
     */ e, /**
     * The target number created by the client that is used in the watch
     * stream to identify this query.
     */ t, /**
     * The view is responsible for computing the final merged truth of what
     * docs are in the query. It gets notified of local and remote changes,
     * and applies the query filters and limits to determine the most correct
     * possible results.
     */ n){
        this.query = e, this.targetId = t, this.view = n;
    }
}
/** Tracks a limbo resolution. */ class LimboResolution {
    constructor(e){
        this.key = e, /**
         * Set to true once we've received a document. This is used in
         * getRemoteKeysForTarget() and ultimately used by WatchChangeAggregator to
         * decide whether it needs to manufacture a delete event for the target once
         * the target is CURRENT.
         */ this.Zu = !1;
    }
}
/**
 * An implementation of `SyncEngine` coordinating with other parts of SDK.
 *
 * The parts of SyncEngine that act as a callback to RemoteStore need to be
 * registered individually. This is done in `syncEngineWrite()` and
 * `syncEngineListen()` (as well as `applyPrimaryState()`) as these methods
 * serve as entry points to RemoteStore's functionality.
 *
 * Note: some field defined in this class might have public access level, but
 * the class is not exported so they are only accessible from this module.
 * This is useful to implement optional features (like bundles) in free
 * functions, such that they are tree-shakeable.
 */ class __PRIVATE_SyncEngineImpl {
    constructor(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
    r, i, s){
        this.localStore = e, this.remoteStore = t, this.eventManager = n, this.sharedClientState = r, this.currentUser = i, this.maxConcurrentLimboResolutions = s, this.Xu = {}, this.ec = new ObjectMap((e)=>__PRIVATE_canonifyQueryOrPipeline(e), __PRIVATE_queryOrPipelineEqual), this.tc = new Map, /**
         * The keys of documents that are in limbo for which we haven't yet started a
         * limbo resolution query. The strings in this set are the result of calling
         * `key.path.canonicalString()` where `key` is a `DocumentKey` object.
         *
         * The `Set` type was chosen because it provides efficient lookup and removal
         * of arbitrary elements and it also maintains insertion order, providing the
         * desired queue-like FIFO semantics.
         */ this.nc = new Set, /**
         * Keeps track of the target ID for each document that is in limbo with an
         * active target.
         */ this.rc = new SortedMap(DocumentKey.comparator), /**
         * Keeps track of the information about an active limbo resolution for each
         * active target ID that was started for the purpose of limbo resolution.
         */ this.sc = new Map, this._c = new __PRIVATE_ReferenceSet, /** Stores user completion handlers, indexed by User and BatchId. */ this.oc = {}, /** Stores user callbacks waiting for all pending writes to be acknowledged. */ this.ac = new Map, this.uc = __PRIVATE_TargetIdGenerator.Cs(), this.onlineState = "Unknown" /* OnlineState.Unknown */ , // The primary state is set to `true` or `false` immediately after Firestore
        // startup. In the interim, a client should only be considered primary if
        // `isPrimary` is true.
        this.cc = void 0;
    }
    get isPrimaryClient() {
        return !0 === this.cc;
    }
}
/**
 * Initiates the new listen, resolves promise when listen enqueued to the
 * server. All the subsequent view snapshots or errors are sent to the
 * subscribed handlers. Returns the initial snapshot.
 */ async function __PRIVATE_syncEngineListen(e, t, n = !0) {
    const r = __PRIVATE_ensureWatchCallbacks(e);
    let i;
    const s = r.ec.get(t);
    return s ? // PORTING NOTE: With Multi-Tab Web, it is possible that a query view
    // already exists when EventManager calls us for the first time. This
    // happens when the primary tab is already listening to this query on
    // behalf of another tab and the user of the primary also starts listening
    // to the query. EventManager will not have an assigned target ID in this
    // case and calls `listen` to obtain this ID.
    (r.sharedClientState.addLocalQueryTarget(s.targetId), i = s.view.Yu()) : i = await __PRIVATE_allocateTargetAndMaybeListen(r, t, n, /** shouldInitializeView= */ !0), i;
}
/** Query has been listening to the cache, and tries to initiate the remote store listen */ async function __PRIVATE_triggerRemoteStoreListen(e, t) {
    const n = __PRIVATE_ensureWatchCallbacks(e);
    await __PRIVATE_allocateTargetAndMaybeListen(n, t, /** shouldListenToRemote= */ !0, /** shouldInitializeView= */ !1);
}
async function __PRIVATE_allocateTargetAndMaybeListen(e, t, n, r) {
    const i = await __PRIVATE_localStoreAllocateTarget(e.localStore, __PRIVATE_isPipeline(t) ? t : __PRIVATE_queryToTarget(t)), s = i.targetId, _ = e.sharedClientState.addLocalQueryTarget(s, n);
    let o;
    return r && (o = await __PRIVATE_initializeViewAndComputeSnapshot(e, t, s, "current" === _, i.resumeToken)), e.isPrimaryClient && n && __PRIVATE_remoteStoreListen(e.remoteStore, i), o;
}
/**
 * Registers a view for a previously unknown query and computes its initial
 * snapshot.
 */ async function __PRIVATE_initializeViewAndComputeSnapshot(e, t, n, r, i) {
    // PORTING NOTE: On Web only, we inject the code that registers new Limbo
    // targets based on view changes. This allows us to only depend on Limbo
    // changes when user code includes queries.
    e.lc = (t, n, r)=>(async function __PRIVATE_applyDocChanges(e, t, n, r) {
            let i = t.view.ku(n);
            i.Uo && // The query has a limit and some docs were removed, so we need
            // to re-run the query against the local store to make sure we
            // didn't lose any good docs that had been past the limit.
            (i = await __PRIVATE_localStoreExecuteQuery(e.localStore, t.query, /* usePreviousResults= */ !1).then(({ documents: e })=>t.view.ku(e, i)));
            const s = r && r.targetChanges.get(t.targetId), _ = r && null != r.targetMismatches.get(t.targetId), o = t.view.applyChanges(i, /* limboResolutionEnabled= */ e.isPrimaryClient, s, _);
            return __PRIVATE_updateTrackedLimbos(e, t.targetId, o.ju), o.snapshot;
        })(e, t, n, r);
    const s = await __PRIVATE_localStoreExecuteQuery(e.localStore, t, /* usePreviousResults= */ !0), _ = new __PRIVATE_View(t, s.Jo), o = _.ku(s.documents), a = TargetChange.createSynthesizedTargetChangeForCurrentChange(n, r && "Offline" /* OnlineState.Offline */  !== e.onlineState, i), u = _.applyChanges(o, /* limboResolutionEnabled= */ e.isPrimaryClient, a);
    __PRIVATE_updateTrackedLimbos(e, n, u.ju);
    const c = new __PRIVATE_QueryView(t, n, _);
    return e.ec.set(t, c), e.tc.has(n) ? e.tc.get(n).push(t) : e.tc.set(n, [
        t
    ]), u.snapshot;
}
/** Stops listening to the query. */ async function __PRIVATE_syncEngineUnlisten(e, t, n) {
    const r = __PRIVATE_debugCast(e), i = r.ec.get(t), s = r.tc.get(i.targetId);
    if (s.length > 1) return r.tc.set(i.targetId, s.filter((e)=>!__PRIVATE_queryOrPipelineEqual(e, t))), void r.ec.delete(t);
    // No other queries are mapped to the target, clean up the query and the target.
    if (r.isPrimaryClient) {
        // We need to remove the local query target first to allow us to verify
        // whether any other client is still interested in this target.
        r.sharedClientState.removeLocalQueryTarget(i.targetId);
        r.sharedClientState.isActiveQueryTarget(i.targetId) || await __PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !1).then(()=>{
            r.sharedClientState.clearQueryState(i.targetId), n && __PRIVATE_remoteStoreUnlisten(r.remoteStore, i.targetId), __PRIVATE_removeAndCleanupTarget(r, i.targetId);
        }).catch(__PRIVATE_ignoreIfPrimaryLeaseLoss);
    } else __PRIVATE_removeAndCleanupTarget(r, i.targetId), await __PRIVATE_localStoreReleaseTarget(r.localStore, i.targetId, /*keepPersistedTargetData=*/ !0);
}
/** Unlistens to the remote store while still listening to the cache. */ async function __PRIVATE_triggerRemoteStoreUnlisten(e, t) {
    const n = __PRIVATE_debugCast(e), r = n.ec.get(t), i = n.tc.get(r.targetId);
    n.isPrimaryClient && 1 === i.length && // PORTING NOTE: Unregister the target ID with local Firestore client as
    // watch target.
    (n.sharedClientState.removeLocalQueryTarget(r.targetId), __PRIVATE_remoteStoreUnlisten(n.remoteStore, r.targetId));
}
/**
 * Initiates the write of local mutation batch which involves adding the
 * writes to the mutation queue, notifying the remote store about new
 * mutations and raising events for any changes this write caused.
 *
 * The promise returned by this call is resolved when the above steps
 * have completed, *not* when the write was acked by the backend. The
 * userCallback is resolved once the write was acked/rejected by the
 * backend (or failed locally for any other reason).
 */ async function __PRIVATE_syncEngineWrite(e, t, n) {
    const r = __PRIVATE_syncEngineEnsureWriteCallbacks(e);
    try {
        const e = await function __PRIVATE_localStoreWriteLocally(e, t) {
            const n = __PRIVATE_debugCast(e), r = Timestamp.now(), i = t.reduce((e, t)=>e.add(t.key), __PRIVATE_documentKeySet());
            let s, _;
            return n.persistence.runTransaction("Locally write mutations", "readwrite", (e)=>{
                // Figure out which keys do not have a remote version in the cache, this
                // is needed to create the right overlay mutation: if no remote version
                // presents, we do not need to create overlays as patch mutations.
                // TODO(Overlay): Is there a better way to determine this? Using the
                //  document version does not work because local mutations set them back
                //  to 0.
                let o = __PRIVATE_mutableDocumentMap(), a = __PRIVATE_documentKeySet();
                return n.Qo.getEntries(e, i).next((e)=>{
                    o = e, o.forEach((e, t)=>{
                        t.isValidDocument() || (a = a.add(e));
                    });
                }).next(()=>n.localDocuments.getOverlayedDocuments(e, o)).next((i)=>{
                    s = i;
                    // For non-idempotent mutations (such as `FieldValue.increment()`),
                    // we record the base state in a separate patch mutation. This is
                    // later used to guarantee consistent values and prevents flicker
                    // even if the backend sends us an update that already includes our
                    // transform.
                    const _ = [];
                    for (const e of t){
                        const t = __PRIVATE_mutationExtractBaseValue(e, s.get(e.key).overlayedDocument);
                        null != t && // NOTE: The base state should only be applied if there's some
                        // existing document to override, so use a Precondition of
                        // exists=true
                        _.push(new __PRIVATE_PatchMutation(e.key, t, __PRIVATE_extractFieldMask(t.value.mapValue), Precondition.exists(!0)));
                    }
                    return n.mutationQueue.addMutationBatch(e, r, _, t);
                }).next((t)=>{
                    _ = t;
                    const r = t.applyToLocalDocumentSet(s, a);
                    return n.documentOverlayCache.saveOverlays(e, t.batchId, r);
                });
            }).then(()=>({
                    batchId: _.batchId,
                    changes: __PRIVATE_convertOverlayedDocumentMapToDocumentMap(s)
                }));
        }(r.localStore, t);
        r.sharedClientState.addPendingMutation(e.batchId), function __PRIVATE_addMutationCallback(e, t, n) {
            let r = e.oc[e.currentUser.toKey()];
            r || (r = new SortedMap(__PRIVATE_primitiveComparator));
            r = r.insert(t, n), e.oc[e.currentUser.toKey()] = r;
        }(r, e.batchId, n), await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e.changes), await __PRIVATE_fillWritePipeline(r.remoteStore);
    } catch (e) {
        // If we can't persist the mutation, we reject the user callback and
        // don't send the mutation. The user can then retry the write.
        const t = __PRIVATE_wrapInUserErrorIfRecoverable(e, "Failed to persist write");
        n.reject(t);
    }
}
/**
 * Applies one remote event to the sync engine, notifying any views of the
 * changes, and releasing any pending mutation batches that would become
 * visible because of the snapshot version the remote event contains.
 */ async function __PRIVATE_syncEngineApplyRemoteEvent(e, t) {
    const n = __PRIVATE_debugCast(e);
    try {
        const e = await __PRIVATE_localStoreApplyRemoteEventToLocalCache(n.localStore, t);
        // Update `receivedDocument` as appropriate for any limbo targets.
        t.targetChanges.forEach((e, t)=>{
            const r = n.sc.get(t);
            r && // Since this is a limbo resolution lookup, it's for a single document
            // and it could be added, modified, or removed, but not a combination.
            (__PRIVATE_hardAssert(e.addedDocuments.size + e.modifiedDocuments.size + e.removedDocuments.size <= 1, 22616), e.addedDocuments.size > 0 ? r.Zu = !0 : e.modifiedDocuments.size > 0 ? __PRIVATE_hardAssert(r.Zu, 14607) : e.removedDocuments.size > 0 && (__PRIVATE_hardAssert(r.Zu, 42227), r.Zu = !1));
        }), await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e, t);
    } catch (e) {
        await __PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
/**
 * Applies an OnlineState change to the sync engine and notifies any views of
 * the change.
 */ function __PRIVATE_syncEngineApplyOnlineStateChange(e, t, n) {
    const r = __PRIVATE_debugCast(e);
    // If we are the secondary client, we explicitly ignore the remote store's
    // online state (the local client may go offline, even though the primary
    // tab remains online) and only apply the primary tab's online state from
    // SharedClientState.
    if (r.isPrimaryClient && 0 /* OnlineStateSource.RemoteStore */  === n || !r.isPrimaryClient && 1 /* OnlineStateSource.SharedClientState */  === n) {
        const e = [];
        r.ec.forEach((n, r)=>{
            const i = r.view.Ru(t);
            i.snapshot && e.push(i.snapshot);
        }), function __PRIVATE_eventManagerOnOnlineStateChange(e, t) {
            const n = __PRIVATE_debugCast(e);
            n.onlineState = t;
            let r = !1;
            n.queries.forEach((e, n)=>{
                for (const e of n.Eu)// Run global snapshot listeners if a consistent snapshot has been emitted.
                e.Ru(t) && (r = !0);
            }), r && __PRIVATE_raiseSnapshotsInSyncEvent(n);
        }(r.eventManager, t), e.length && r.Xu.zn(e), r.onlineState = t, r.isPrimaryClient && r.sharedClientState.setOnlineState(t);
    }
}
/**
 * Rejects the listen for the given targetID. This can be triggered by the
 * backend for any active target.
 *
 * @param syncEngine - The sync engine implementation.
 * @param targetId - The targetID corresponds to one previously initiated by the
 * user as part of TargetData passed to listen() on RemoteStore.
 * @param err - A description of the condition that has forced the rejection.
 * Nearly always this will be an indication that the user is no longer
 * authorized to see the data matching the target.
 */ async function __PRIVATE_syncEngineRejectListen(e, t, n) {
    const r = __PRIVATE_debugCast(e);
    // PORTING NOTE: Multi-tab only.
    r.sharedClientState.updateQueryState(t, "rejected", n);
    const i = r.sc.get(t), s = i && i.key;
    if (s) {
        // TODO(klimt): We really only should do the following on permission
        // denied errors, but we don't have the cause code here.
        // It's a limbo doc. Create a synthetic event saying it was deleted.
        // This is kind of a hack. Ideally, we would have a method in the local
        // store to purge a document. However, it would be tricky to keep all of
        // the local store's invariants with another method.
        let e = new SortedMap(DocumentKey.comparator);
        // TODO(b/217189216): This limbo document should ideally have a read time,
        // so that it is picked up by any read-time based scans. The backend,
        // however, does not send a read time for target removals.
        e = e.insert(s, MutableDocument.newNoDocument(s, SnapshotVersion.min()));
        const n = __PRIVATE_documentKeySet().add(s), i = new RemoteEvent(SnapshotVersion.min(), /* targetChanges= */ new Map, /* targetMismatches= */ new SortedMap(__PRIVATE_primitiveComparator), e, __PRIVATE_mutableDocumentMap(), n);
        await __PRIVATE_syncEngineApplyRemoteEvent(r, i), // Since this query failed, we won't want to manually unlisten to it.
        // We only remove it from bookkeeping after we successfully applied the
        // RemoteEvent. If `applyRemoteEvent()` throws, we want to re-listen to
        // this query when the RemoteStore restarts the Watch stream, which should
        // re-trigger the target failure.
        r.rc = r.rc.remove(s), r.sc.delete(t), __PRIVATE_pumpEnqueuedLimboResolutions(r);
    } else await __PRIVATE_localStoreReleaseTarget(r.localStore, t, /* keepPersistedTargetData */ !1).then(()=>__PRIVATE_removeAndCleanupTarget(r, t, n)).catch(__PRIVATE_ignoreIfPrimaryLeaseLoss);
}
async function __PRIVATE_syncEngineApplySuccessfulWrite(e, t) {
    const n = __PRIVATE_debugCast(e), r = t.batch.batchId;
    try {
        const e = await __PRIVATE_localStoreAcknowledgeBatch(n.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught
        // up), so we raise user callbacks first so that they consistently happen
        // before listen events.
        __PRIVATE_processUserCallback(n, r, /*error=*/ null), __PRIVATE_triggerPendingWritesCallbacks(n, r), n.sharedClientState.updateMutationState(r, "acknowledged"), await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e);
    } catch (e) {
        await __PRIVATE_ignoreIfPrimaryLeaseLoss(e);
    }
}
async function __PRIVATE_syncEngineRejectFailedWrite(e, t, n) {
    const r = __PRIVATE_debugCast(e);
    try {
        const e = await function __PRIVATE_localStoreRejectBatch(e, t) {
            const n = __PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Reject batch", "readwrite-primary", (e)=>{
                let r;
                return n.mutationQueue.lookupMutationBatch(e, t).next((t)=>(__PRIVATE_hardAssert(null !== t, 37113), r = t.keys(), n.mutationQueue.removeMutationBatch(e, t))).next(()=>n.mutationQueue.performConsistencyCheck(e)).next(()=>n.documentOverlayCache.removeOverlaysForBatchId(e, r, t)).next(()=>n.localDocuments.recalculateAndSaveOverlaysForDocumentKeys(e, r)).next(()=>n.localDocuments.getDocuments(e, r));
            });
        }(r.localStore, t);
        // The local store may or may not be able to apply the write result and
        // raise events immediately (depending on whether the watcher is caught up),
        // so we raise user callbacks first so that they consistently happen before
        // listen events.
        __PRIVATE_processUserCallback(r, t, n), __PRIVATE_triggerPendingWritesCallbacks(r, t), r.sharedClientState.updateMutationState(t, "rejected", n), await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(r, e);
    } catch (n) {
        await __PRIVATE_ignoreIfPrimaryLeaseLoss(n);
    }
}
/**
 * Registers a user callback that resolves when all pending mutations at the moment of calling
 * are acknowledged .
 */ async function __PRIVATE_syncEngineRegisterPendingWritesCallback(e, t) {
    const n = __PRIVATE_debugCast(e);
    __PRIVATE_canUseNetwork(n.remoteStore) || __PRIVATE_logDebug(An, "The network is disabled. The task returned by 'awaitPendingWrites()' will not complete until the network is enabled.");
    try {
        const e = await function __PRIVATE_localStoreGetHighestUnacknowledgedBatchId(e) {
            const t = __PRIVATE_debugCast(e);
            return t.persistence.runTransaction("Get highest unacknowledged batch id", "readonly", (e)=>t.mutationQueue.getHighestUnacknowledgedBatchId(e));
        }(n.localStore);
        if (e === $) // Trigger the callback right away if there is no pending writes at the moment.
        return void t.resolve();
        const r = n.ac.get(e) || [];
        r.push(t), n.ac.set(e, r);
    } catch (e) {
        const n = __PRIVATE_wrapInUserErrorIfRecoverable(e, "Initialization of waitForPendingWrites() operation failed");
        t.reject(n);
    }
}
/**
 * Triggers the callbacks that are waiting for this batch id to get acknowledged by server,
 * if there are any.
 */ function __PRIVATE_triggerPendingWritesCallbacks(e, t) {
    (e.ac.get(t) || []).forEach((e)=>{
        e.resolve();
    }), e.ac.delete(t);
}
/** Reject all outstanding callbacks waiting for pending writes to complete. */ function __PRIVATE_processUserCallback(e, t, n) {
    const r = __PRIVATE_debugCast(e);
    let i = r.oc[r.currentUser.toKey()];
    // NOTE: Mutations restored from persistence won't have callbacks, so it's
    // okay for there to be no callback for this ID.
    if (i) {
        const e = i.get(t);
        e && (n ? e.reject(n) : e.resolve(), i = i.remove(t)), r.oc[r.currentUser.toKey()] = i;
    }
}
function __PRIVATE_removeAndCleanupTarget(e, t, n = null) {
    e.sharedClientState.removeLocalQueryTarget(t);
    for (const r of e.tc.get(t))e.ec.delete(r), n && e.Xu.Ec(r, n);
    if (e.tc.delete(t), e.isPrimaryClient) e._c.s_(t).forEach((t)=>{
        e._c.containsKey(t) || // We removed the last reference for this key
        __PRIVATE_removeLimboTarget(e, t);
    });
}
function __PRIVATE_removeLimboTarget(e, t) {
    e.nc.delete(t.path.canonicalString());
    // It's possible that the target already got removed because the query failed. In that case,
    // the key won't exist in `limboTargetsByKey`. Only do the cleanup if we still have the target.
    const n = e.rc.get(t);
    null !== n && (__PRIVATE_remoteStoreUnlisten(e.remoteStore, n), e.rc = e.rc.remove(t), e.sc.delete(n), __PRIVATE_pumpEnqueuedLimboResolutions(e));
}
function __PRIVATE_updateTrackedLimbos(e, t, n) {
    for (const r of n)if (r instanceof __PRIVATE_AddedLimboDocument) e._c.addReference(r.key, t), __PRIVATE_trackLimboChange(e, r);
    else if (r instanceof __PRIVATE_RemovedLimboDocument) {
        __PRIVATE_logDebug(An, "Document no longer in limbo: " + r.key), e._c.removeReference(r.key, t);
        e._c.containsKey(r.key) || // We removed the last reference for this key
        __PRIVATE_removeLimboTarget(e, r.key);
    } else fail(19791, {
        hc: r
    });
}
function __PRIVATE_trackLimboChange(e, t) {
    const n = t.key, r = n.path.canonicalString();
    e.rc.get(n) || e.nc.has(r) || (__PRIVATE_logDebug(An, "New document in limbo: " + n), e.nc.add(r), __PRIVATE_pumpEnqueuedLimboResolutions(e));
}
/**
 * Starts listens for documents in limbo that are enqueued for resolution,
 * subject to a maximum number of concurrent resolutions.
 *
 * Without bounding the number of concurrent resolutions, the server can fail
 * with "resource exhausted" errors which can lead to pathological client
 * behavior as seen in https://github.com/firebase/firebase-js-sdk/issues/2683.
 */ function __PRIVATE_pumpEnqueuedLimboResolutions(e) {
    for(; e.nc.size > 0 && e.rc.size < e.maxConcurrentLimboResolutions;){
        const t = e.nc.values().next().value;
        e.nc.delete(t);
        const n = new DocumentKey(ResourcePath.fromString(t)), r = e.uc.next();
        e.sc.set(r, new LimboResolution(n)), e.rc = e.rc.insert(n, r), __PRIVATE_remoteStoreListen(e.remoteStore, new TargetData(__PRIVATE_queryToTarget(__PRIVATE_newQueryForPath(n.path)), r, "TargetPurposeLimboResolution" /* TargetPurpose.LimboResolution */ , __PRIVATE_ListenSequence.ce));
    }
}
async function __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, t, n) {
    const r = __PRIVATE_debugCast(e), i = [], s = [], _ = [];
    r.ec.isEmpty() || (r.ec.forEach((e, o)=>{
        _.push(r.lc(o, t, n).then((e)=>{
            // If there are changes, or we are handling a global snapshot, notify
            // secondary clients to update query state.
            if ((e || n) && r.isPrimaryClient) {
                // Query state is set to `current` if:
                // - There is a view change and it is up-to-date, or,
                // - There is a global snapshot, the Target is current, and no changes to be resolved
                const t = e ? !e.fromCache : n?.targetChanges.get(o.targetId)?.current;
                r.sharedClientState.updateQueryState(o.targetId, t ? "current" : "not-current");
            }
            // Update views if there are actual changes.
            if (e) {
                i.push(e);
                const t = __PRIVATE_LocalViewChanges.vo(o.targetId, e);
                s.push(t);
            }
        }));
    }), await Promise.all(_), r.Xu.zn(i), await async function __PRIVATE_localStoreNotifyLocalViewChanges(e, t) {
        const n = __PRIVATE_debugCast(e);
        try {
            await n.persistence.runTransaction("notifyLocalViewChanges", "readwrite", (e)=>PersistencePromise.forEach(t, (t)=>PersistencePromise.forEach(t.wo, (r)=>n.persistence.referenceDelegate.addReference(e, t.targetId, r)).next(()=>PersistencePromise.forEach(t.bo, (r)=>n.persistence.referenceDelegate.removeReference(e, t.targetId, r)))));
        } catch (e) {
            if (!__PRIVATE_isIndexedDbTransactionError(e)) throw e;
            // If `notifyLocalViewChanges` fails, we did not advance the sequence
            // number for the documents that were included in this transaction.
            // This might trigger them to be deleted earlier than they otherwise
            // would have, but it should not invalidate the integrity of the data.
            __PRIVATE_logDebug(un, "Failed to update sequence numbers: " + e);
        }
        for (const e of t){
            const t = e.targetId;
            if (!e.fromCache) {
                const e = n.$o.get(t), r = e.snapshotVersion, i = e.withLastLimboFreeSnapshotVersion(r);
                // Advance the last limbo free snapshot version
                n.$o = n.$o.insert(t, i);
            }
        }
    }(r.localStore, s));
}
async function __PRIVATE_syncEngineHandleCredentialChange(e, t) {
    const n = __PRIVATE_debugCast(e);
    if (!n.currentUser.isEqual(t)) {
        __PRIVATE_logDebug(An, "User change. New user:", t.toKey());
        const e = await __PRIVATE_localStoreHandleUserChange(n.localStore, t);
        n.currentUser = t, // Fails tasks waiting for pending writes requested by previous user.
        function __PRIVATE_rejectOutstandingPendingWritesCallbacks(e, t) {
            e.ac.forEach((e)=>{
                e.forEach((e)=>{
                    e.reject(new FirestoreError(D.CANCELLED, t));
                });
            }), e.ac.clear();
        }(n, "'waitForPendingWrites' promise is rejected due to a user change."), // TODO(b/114226417): Consider calling this only in the primary tab.
        n.sharedClientState.handleUserChange(t, e.removedBatchIds, e.addedBatchIds), await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e.zo);
    }
}
function __PRIVATE_syncEngineGetRemoteKeysForTarget(e, t) {
    const n = __PRIVATE_debugCast(e), r = n.sc.get(t);
    if (r && r.Zu) return __PRIVATE_documentKeySet().add(r.key);
    {
        let e = __PRIVATE_documentKeySet();
        const r = n.tc.get(t);
        if (!r) return e;
        for (const t of r ?? []){
            const r = n.ec.get(t);
            e = e.unionWith(r.view.Uu);
        }
        return e;
    }
}
/**
 * Reconcile the list of synced documents in an existing view with those
 * from persistence.
 */ async function __PRIVATE_synchronizeViewAndComputeSnapshot(e, t) {
    const n = __PRIVATE_debugCast(e), r = await __PRIVATE_localStoreExecuteQuery(n.localStore, t.query, /* usePreviousResults= */ !0), i = t.view.Ju(r);
    return n.isPrimaryClient && __PRIVATE_updateTrackedLimbos(n, t.targetId, i.ju), i;
}
/**
 * Retrieves newly changed documents from remote document cache and raises
 * snapshots if needed.
 */ // PORTING NOTE: Multi-Tab only.
async function __PRIVATE_syncEngineSynchronizeWithChangedDocuments(e, t) {
    const n = __PRIVATE_debugCast(e);
    return __PRIVATE_localStoreGetNewDocumentChanges(n.localStore, t).then((e)=>__PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(n, e));
}
/** Applies a mutation state to an existing batch.  */ // PORTING NOTE: Multi-Tab only.
async function __PRIVATE_syncEngineApplyBatchState(e, t, n, r) {
    const i = __PRIVATE_debugCast(e), s = await function __PRIVATE_localStoreLookupMutationDocuments(e, t) {
        const n = __PRIVATE_debugCast(e), r = __PRIVATE_debugCast(n.mutationQueue);
        return n.persistence.runTransaction("Lookup mutation documents", "readonly", (e)=>r.ps(e, t).next((t)=>t ? n.localDocuments.getDocuments(e, t) : PersistencePromise.resolve(null)));
    }(i.localStore, t);
    null !== s ? ("pending" === n ? // If we are the primary client, we need to send this write to the
    // backend. Secondary clients will ignore these writes since their remote
    // connection is disabled.
    await __PRIVATE_fillWritePipeline(i.remoteStore) : "acknowledged" === n || "rejected" === n ? // NOTE: Both these methods are no-ops for batches that originated from
    // other clients.
    (__PRIVATE_processUserCallback(i, t, r || null), __PRIVATE_triggerPendingWritesCallbacks(i, t), function __PRIVATE_localStoreRemoveCachedMutationBatchMetadata(e, t) {
        __PRIVATE_debugCast(__PRIVATE_debugCast(e).mutationQueue).bs(t);
    }(i.localStore, t)) : fail(6720, "Unknown batchState", {
        Tc: n
    }), await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, s)) : // A throttled tab may not have seen the mutation before it was completed
    // and removed from the mutation queue, in which case we won't have cached
    // the affected documents. In this case we can safely ignore the update
    // since that means we didn't apply the mutation locally at all (if we
    // had, we would have cached the affected documents), and so we will just
    // see any resulting document changes via normal remote document updates
    // as applicable.
    __PRIVATE_logDebug(An, "Cannot apply mutation batch with id: " + t);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function __PRIVATE_syncEngineApplyPrimaryState(e, t) {
    const n = __PRIVATE_debugCast(e);
    if (__PRIVATE_ensureWatchCallbacks(n), __PRIVATE_syncEngineEnsureWriteCallbacks(n), !0 === t && !0 !== n.cc) {
        // Secondary tabs only maintain Views for their local listeners and the
        // Views internal state may not be 100% populated (in particular
        // secondary tabs don't track syncedDocuments, the set of documents the
        // server considers to be in the target). So when a secondary becomes
        // primary, we need to need to make sure that all views for all targets
        // match the state on disk.
        const e = n.sharedClientState.getAllActiveQueryTargets(), t = await __PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e.toArray());
        n.cc = !0, await __PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !0);
        for (const e of t)__PRIVATE_remoteStoreListen(n.remoteStore, e);
    } else if (!1 === t && !1 !== n.cc) {
        const e = [];
        let t = Promise.resolve();
        n.tc.forEach((r, i)=>{
            n.sharedClientState.isLocalQueryTarget(i) ? e.push(i) : t = t.then(()=>(__PRIVATE_removeAndCleanupTarget(n, i), __PRIVATE_localStoreReleaseTarget(n.localStore, i, /*keepPersistedTargetData=*/ !0))), __PRIVATE_remoteStoreUnlisten(n.remoteStore, i);
        }), await t, await __PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(n, e), // PORTING NOTE: Multi-Tab only.
        function __PRIVATE_resetLimboDocuments(e) {
            const t = __PRIVATE_debugCast(e);
            t.sc.forEach((e, n)=>{
                __PRIVATE_remoteStoreUnlisten(t.remoteStore, n);
            }), t._c.__(), t.sc = new Map, t.rc = new SortedMap(DocumentKey.comparator);
        }(n), n.cc = !1, await __PRIVATE_remoteStoreApplyPrimaryState(n.remoteStore, !1);
    }
}
async function __PRIVATE_synchronizeQueryViewsAndRaiseSnapshots(e, t, n) {
    const r = __PRIVATE_debugCast(e), i = [], s = [];
    for (const e of t){
        let t;
        const n = r.tc.get(e);
        if (n && 0 !== n.length) {
            // For queries that have a local View, we fetch their current state
            // from LocalStore (as the resume token and the snapshot version
            // might have changed) and reconcile their views with the persisted
            // state (the list of syncedDocuments may have gotten out of sync).
            t = await __PRIVATE_localStoreAllocateTarget(r.localStore, __PRIVATE_isPipeline(n[0]) ? n[0] : __PRIVATE_queryToTarget(n[0]));
            for (const e of n){
                const t = r.ec.get(e), n = await __PRIVATE_synchronizeViewAndComputeSnapshot(r, t);
                n.snapshot && s.push(n.snapshot);
            }
        } else {
            // For queries that never executed on this client, we need to
            // allocate the target in LocalStore and initialize a new View.
            const n = await __PRIVATE_localStoreGetCachedTarget(r.localStore, e);
            t = await __PRIVATE_localStoreAllocateTarget(r.localStore, n), await __PRIVATE_initializeViewAndComputeSnapshot(r, __PRIVATE_synthesizeTargetToQuery(n), e, /*current=*/ !1, t.resumeToken);
        }
        i.push(t);
    }
    return r.Xu.zn(s), i;
}
/**
 * Creates a `Query` object from the specified `Target`. There is no way to
 * obtain the original `Query`, so we synthesize a `Query` from the `Target`
 * object.
 *
 * The synthesized result might be different from the original `Query`, but
 * since the synthesized `Query` should return the same results as the
 * original one (only the presentation of results might differ), the potential
 * difference will not cause issues.
 */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_synthesizeTargetToQuery(e) {
    return __PRIVATE_targetIsPipelineTarget(e) ? e : __PRIVATE_newQuery(e.path, e.collectionGroup, e.orderBy, e.filters, e.limit, "F" /* LimitType.First */ , e.startAt, e.endAt);
}
/** Returns the IDs of the clients that are currently active. */ // PORTING NOTE: Multi-Tab only.
function __PRIVATE_syncEngineGetActiveClients(e) {
    return function __PRIVATE_localStoreGetActiveClients(e) {
        return __PRIVATE_debugCast(__PRIVATE_debugCast(e).persistence).po();
    }(__PRIVATE_debugCast(e).localStore);
}
/** Applies a query target change from a different tab. */ // PORTING NOTE: Multi-Tab only.
async function __PRIVATE_syncEngineApplyTargetState(e, t, n, r) {
    const i = __PRIVATE_debugCast(e);
    if (i.cc) // If we receive a target state notification via WebStorage, we are
    // either already secondary or another tab has taken the primary lease.
    return void __PRIVATE_logDebug(An, "Ignoring unexpected query state notification.");
    const s = i.tc.get(t);
    if (s && s.length > 0) switch(n){
        case "current":
        case "not-current":
            {
                let e;
                if (__PRIVATE_isPipeline(s[0])) switch(getPipelineSourceType(s[0])){
                    case "collection_group":
                    case "collection":
                        e = await __PRIVATE_localStoreGetNewDocumentChanges(i.localStore, getPipelineCollectionId(s[0]));
                        break;
                    case "documents":
                        e = await function __PRIVATE_localStoreGetDocuments(e, t) {
                            const n = __PRIVATE_debugCast(e), r = __PRIVATE_documentKeySet(...getPipelineDocuments(t).map((e)=>DocumentKey.fromPath(e)));
                            return n.persistence.runTransaction("Get documents for pipeline", "readonly", (e)=>n.Qo.getEntries(e, r)).then((e)=>e);
                        }(i.localStore, s[0]);
                        break;
                    default:
                        __PRIVATE_logWarn(""), e = documentMap();
                }
                else e = await __PRIVATE_localStoreGetNewDocumentChanges(i.localStore, function __PRIVATE_queryCollectionGroup(e) {
                    return e.collectionGroup || (e.path.length % 2 == 1 ? e.path.lastSegment() : e.path.get(e.path.length - 2));
                }(s[0]));
                const r = RemoteEvent.createSynthesizedRemoteEventForCurrentChange(t, "current" === n, ByteString.EMPTY_BYTE_STRING);
                await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(i, e, r);
                break;
            }
        case "rejected":
            await __PRIVATE_localStoreReleaseTarget(i.localStore, t, /* keepPersistedTargetData */ !0), __PRIVATE_removeAndCleanupTarget(i, t, r);
            break;
        default:
            fail(64155, n);
    }
}
/** Adds or removes Watch targets for queries from different tabs. */ async function __PRIVATE_syncEngineApplyActiveTargetsChange(e, t, n) {
    const r = __PRIVATE_ensureWatchCallbacks(e);
    if (r.cc) {
        for (const e of t){
            if (r.tc.has(e) && r.sharedClientState.isActiveQueryTarget(e)) {
                __PRIVATE_logDebug(An, "Adding an already active target " + e);
                continue;
            }
            const t = await __PRIVATE_localStoreGetCachedTarget(r.localStore, e), n = await __PRIVATE_localStoreAllocateTarget(r.localStore, t);
            await __PRIVATE_initializeViewAndComputeSnapshot(r, __PRIVATE_synthesizeTargetToQuery(t), n.targetId, /*current=*/ !1, n.resumeToken), __PRIVATE_remoteStoreListen(r.remoteStore, n);
        }
        for (const e of n)// Check that the target is still active since the target might have been
        // removed if it has been rejected by the backend.
        r.tc.has(e) && // Release queries that are still active.
        await __PRIVATE_localStoreReleaseTarget(r.localStore, e, /* keepPersistedTargetData */ !1).then(()=>{
            __PRIVATE_remoteStoreUnlisten(r.remoteStore, e), __PRIVATE_removeAndCleanupTarget(r, e);
        }).catch(__PRIVATE_ignoreIfPrimaryLeaseLoss);
    }
}
function __PRIVATE_ensureWatchCallbacks(e) {
    const t = __PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applyRemoteEvent = __PRIVATE_syncEngineApplyRemoteEvent.bind(null, t), t.remoteStore.remoteSyncer.getRemoteKeysForTarget = __PRIVATE_syncEngineGetRemoteKeysForTarget.bind(null, t), t.remoteStore.remoteSyncer.rejectListen = __PRIVATE_syncEngineRejectListen.bind(null, t), t.Xu.zn = __PRIVATE_eventManagerOnWatchChange.bind(null, t.eventManager), t.Xu.Ec = __PRIVATE_eventManagerOnWatchError.bind(null, t.eventManager), t;
}
function __PRIVATE_syncEngineEnsureWriteCallbacks(e) {
    const t = __PRIVATE_debugCast(e);
    return t.remoteStore.remoteSyncer.applySuccessfulWrite = __PRIVATE_syncEngineApplySuccessfulWrite.bind(null, t), t.remoteStore.remoteSyncer.rejectFailedWrite = __PRIVATE_syncEngineRejectFailedWrite.bind(null, t), t;
}
/**
 * Loads a Firestore bundle into the SDK. The returned promise resolves when
 * the bundle finished loading.
 *
 * @param syncEngine - SyncEngine to use.
 * @param bundleReader - Bundle to load into the SDK.
 * @param task - LoadBundleTask used to update the loading progress to public API.
 */ function __PRIVATE_syncEngineLoadBundle(e, t, n) {
    const r = __PRIVATE_debugCast(e);
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    /** Loads a bundle and returns the list of affected collection groups. */ (async function __PRIVATE_loadBundleImpl(e, t, n) {
        try {
            const r = await t.getMetadata();
            if (await function __PRIVATE_localStoreHasNewerBundle(e, t) {
                const n = __PRIVATE_debugCast(e), r = __PRIVATE_fromVersion(t.createTime);
                return n.persistence.runTransaction("hasNewerBundle", "readonly", (e)=>n.w_.getBundleMetadata(e, t.id)).then((e)=>!!e && e.createTime.compareTo(r) >= 0);
            }(e.localStore, r)) return await t.close(), n._completeWith(function __PRIVATE_bundleSuccessProgress(e) {
                return {
                    taskState: "Success",
                    documentsLoaded: e.totalDocuments,
                    bytesLoaded: e.totalBytes,
                    totalDocuments: e.totalDocuments,
                    totalBytes: e.totalBytes
                };
            }(r)), Promise.resolve(new Set);
            n._updateProgress(__PRIVATE_bundleInitialProgress(r));
            const i = new __PRIVATE_BundleLoader(r, t.serializer);
            let s = await t.Pc();
            for(; s;){
                const e = await i.o(s);
                e && n._updateProgress(e), s = await t.Pc();
            }
            const _ = await i.xu(e.localStore);
            return await __PRIVATE_syncEngineEmitNewSnapsAndNotifyLocalStore(e, _.Fu, /* remoteEvent */ void 0), // Save metadata, so loading the same bundle will skip.
            await function __PRIVATE_localStoreSaveBundle(e, t) {
                const n = __PRIVATE_debugCast(e);
                return n.persistence.runTransaction("Save bundle", "readwrite", (e)=>n.w_.saveBundleMetadata(e, t));
            }(e.localStore, r), n._completeWith(_.progress), Promise.resolve(_.Cu);
        } catch (e) {
            return __PRIVATE_logWarn(An, `Loading bundle failed with ${e}`), n._failWith(e), Promise.resolve(new Set);
        }
    })(r, t, n).then((e)=>{
        r.sharedClientState.notifyBundleLoaded(e);
    });
}
class __PRIVATE_MemoryOfflineComponentProvider {
    constructor(){
        this.kind = "memory", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        this.serializer = __PRIVATE_newSerializer(e.databaseInfo.databaseId), this.sharedClientState = this.Rc(e), this.persistence = this.Ic(e), await this.persistence.start(), this.localStore = this.Ac(e), this.gcScheduler = this.Vc(e, this.localStore), this.indexBackfillerScheduler = this.dc(e, this.localStore);
    }
    Vc(e, t) {
        return null;
    }
    dc(e, t) {
        return null;
    }
    Ac(e) {
        return __PRIVATE_newLocalStore(this.persistence, new __PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Ic(e) {
        return new __PRIVATE_MemoryPersistence(__PRIVATE_MemoryEagerDelegate.C_, this.serializer);
    }
    Rc(e) {
        return new __PRIVATE_MemorySharedClientState;
    }
    async terminate() {
        this.gcScheduler?.stop(), this.indexBackfillerScheduler?.stop(), this.sharedClientState.shutdown(), await this.persistence.shutdown();
    }
}
__PRIVATE_MemoryOfflineComponentProvider.provider = {
    build: ()=>new __PRIVATE_MemoryOfflineComponentProvider
};
class __PRIVATE_LruGcMemoryOfflineComponentProvider extends __PRIVATE_MemoryOfflineComponentProvider {
    constructor(e){
        super(), this.cacheSizeBytes = e;
    }
    Vc(e, t) {
        __PRIVATE_hardAssert(this.persistence.referenceDelegate instanceof __PRIVATE_MemoryLruDelegate, 46915);
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new __PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    Ic(e) {
        const t = void 0 !== this.cacheSizeBytes ? LruParams.withCacheSize(this.cacheSizeBytes) : LruParams.DEFAULT;
        return new __PRIVATE_MemoryPersistence((e)=>__PRIVATE_MemoryLruDelegate.C_(e, t), this.serializer);
    }
}
/**
 * Provides all components needed for Firestore with IndexedDB persistence.
 */ class __PRIVATE_IndexedDbOfflineComponentProvider extends __PRIVATE_MemoryOfflineComponentProvider {
    constructor(e, t, n){
        super(), this.fc = e, this.cacheSizeBytes = t, this.forceOwnership = n, this.kind = "persistent", this.synchronizeTabs = !1;
    }
    async initialize(e) {
        await super.initialize(e), await this.fc.initialize(this, e), // Enqueue writes from a previous session
        await __PRIVATE_syncEngineEnsureWriteCallbacks(this.fc.syncEngine), await __PRIVATE_fillWritePipeline(this.fc.remoteStore), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence._o(()=>(this.gcScheduler && !this.gcScheduler.started && this.gcScheduler.start(), this.indexBackfillerScheduler && !this.indexBackfillerScheduler.started && this.indexBackfillerScheduler.start(), Promise.resolve()));
    }
    Ac(e) {
        return __PRIVATE_newLocalStore(this.persistence, new __PRIVATE_QueryEngine, e.initialUser, this.serializer);
    }
    Vc(e, t) {
        const n = this.persistence.referenceDelegate.garbageCollector;
        return new __PRIVATE_LruScheduler(n, e.asyncQueue, t);
    }
    dc(e, t) {
        const n = new __PRIVATE_IndexBackfiller(t, this.persistence);
        return new __PRIVATE_IndexBackfillerScheduler(e.asyncQueue, n);
    }
    Ic(e) {
        const t = __PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey), n = void 0 !== this.cacheSizeBytes ? LruParams.withCacheSize(this.cacheSizeBytes) : LruParams.DEFAULT;
        return new __PRIVATE_IndexedDbPersistence(this.synchronizeTabs, t, e.clientId, n, e.asyncQueue, __PRIVATE_getWindow(), getDocument(), this.serializer, this.sharedClientState, !!this.forceOwnership);
    }
    Rc(e) {
        return new __PRIVATE_MemorySharedClientState;
    }
}
/**
 * Provides all components needed for Firestore with multi-tab IndexedDB
 * persistence.
 *
 * In the legacy client, this provider is used to provide both multi-tab and
 * non-multi-tab persistence since we cannot tell at build time whether
 * `synchronizeTabs` will be enabled.
 */ class __PRIVATE_MultiTabOfflineComponentProvider extends __PRIVATE_IndexedDbOfflineComponentProvider {
    constructor(e, t){
        super(e, t, /* forceOwnership= */ !1), this.fc = e, this.cacheSizeBytes = t, this.synchronizeTabs = !0;
    }
    async initialize(e) {
        await super.initialize(e);
        const t = this.fc.syncEngine;
        this.sharedClientState instanceof __PRIVATE_WebStorageSharedClientState && (this.sharedClientState.syncEngine = {
            Na: __PRIVATE_syncEngineApplyBatchState.bind(null, t),
            La: __PRIVATE_syncEngineApplyTargetState.bind(null, t),
            Ba: __PRIVATE_syncEngineApplyActiveTargetsChange.bind(null, t),
            po: __PRIVATE_syncEngineGetActiveClients.bind(null, t),
            Ma: __PRIVATE_syncEngineSynchronizeWithChangedDocuments.bind(null, t)
        }, await this.sharedClientState.start()), // NOTE: This will immediately call the listener, so we make sure to
        // set it after localStore / remoteStore are started.
        await this.persistence._o(async (e)=>{
            await __PRIVATE_syncEngineApplyPrimaryState(this.fc.syncEngine, e), this.gcScheduler && (e && !this.gcScheduler.started ? this.gcScheduler.start() : e || this.gcScheduler.stop()), this.indexBackfillerScheduler && (e && !this.indexBackfillerScheduler.started ? this.indexBackfillerScheduler.start() : e || this.indexBackfillerScheduler.stop());
        });
    }
    Rc(e) {
        const t = __PRIVATE_getWindow();
        if (!__PRIVATE_WebStorageSharedClientState.C(t)) throw new FirestoreError(D.UNIMPLEMENTED, "IndexedDB persistence is only available on platforms that support LocalStorage.");
        const n = __PRIVATE_indexedDbStoragePrefix(e.databaseInfo.databaseId, e.databaseInfo.persistenceKey);
        return new __PRIVATE_WebStorageSharedClientState(t, e.asyncQueue, n, e.clientId, e.initialUser);
    }
}
/**
 * Initializes and wires the components that are needed to interface with the
 * network.
 */ class OnlineComponentProvider {
    async initialize(e, t) {
        this.localStore || (this.localStore = e.localStore, this.sharedClientState = e.sharedClientState, this.datastore = this.createDatastore(t), this.remoteStore = this.createRemoteStore(t), this.eventManager = this.createEventManager(t), this.syncEngine = this.createSyncEngine(t, /* startAsPrimary=*/ !e.synchronizeTabs), this.sharedClientState.onlineStateHandler = (e)=>__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 1 /* OnlineStateSource.SharedClientState */ ), this.remoteStore.remoteSyncer.handleCredentialChange = __PRIVATE_syncEngineHandleCredentialChange.bind(null, this.syncEngine), await __PRIVATE_remoteStoreApplyPrimaryState(this.remoteStore, this.syncEngine.isPrimaryClient));
    }
    createEventManager(e) {
        return function __PRIVATE_newEventManager() {
            return new __PRIVATE_EventManagerImpl;
        }();
    }
    createDatastore(e) {
        const t = __PRIVATE_newSerializer(e.databaseInfo.databaseId), n = __PRIVATE_newConnection(e.databaseInfo);
        return __PRIVATE_newDatastore(e.authCredentials, e.appCheckCredentials, n, t);
    }
    createRemoteStore(e) {
        return function __PRIVATE_newRemoteStore(e, t, n, r, i) {
            return new __PRIVATE_RemoteStoreImpl(e, t, n, r, i);
        }(this.localStore, this.datastore, e.asyncQueue, (e)=>__PRIVATE_syncEngineApplyOnlineStateChange(this.syncEngine, e, 0 /* OnlineStateSource.RemoteStore */ ), function __PRIVATE_newConnectivityMonitor() {
            return __PRIVATE_BrowserConnectivityMonitor.C() ? new __PRIVATE_BrowserConnectivityMonitor : new __PRIVATE_NoopConnectivityMonitor;
        }());
    }
    createSyncEngine(e, t) {
        return function __PRIVATE_newSyncEngine(e, t, n, // PORTING NOTE: Manages state synchronization in multi-tab environments.
        r, i, s, _) {
            const o = new __PRIVATE_SyncEngineImpl(e, t, n, r, i, s);
            return _ && (o.cc = !0), o;
        }(this.localStore, this.remoteStore, this.eventManager, this.sharedClientState, e.initialUser, e.maxConcurrentLimboResolutions, t);
    }
    async terminate() {
        await async function __PRIVATE_remoteStoreShutdown(e) {
            const t = __PRIVATE_debugCast(e);
            __PRIVATE_logDebug(Rn, "RemoteStore shutting down."), t.tu.add(5 /* OfflineCause.Shutdown */ ), await __PRIVATE_disableNetworkInternal(t), t.ru.shutdown(), // Set the OnlineState to Unknown (rather than Offline) to avoid potentially
            // triggering spurious listener events with cached data, etc.
            t.iu.set("Unknown" /* OnlineState.Unknown */ );
        }(this.remoteStore), this.datastore?.terminate(), this.eventManager?.terminate();
    }
}
OnlineComponentProvider.provider = {
    build: ()=>new OnlineComponentProvider
};
/**
 * Builds a `ByteStreamReader` from a UInt8Array.
 * @param source - The data source to use.
 * @param bytesPerRead - How many bytes each `read()` from the returned reader
 *        will read.
 */ function __PRIVATE_toByteStreamReaderHelper(e, t = 10240) {
    let n = 0;
    // The TypeScript definition for ReadableStreamReader changed. We use
    // `any` here to allow this code to compile with different versions.
    // See https://github.com/microsoft/TypeScript/issues/42970
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        async read () {
            if (n < e.byteLength) {
                const r = {
                    value: e.slice(n, n + t),
                    done: !1
                };
                return n += t, r;
            }
            return {
                done: !0
            };
        },
        async cancel () {},
        releaseLock () {},
        closed: Promise.resolve()
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * On web, a `ReadableStream` is wrapped around by a `ByteStreamReader`.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /*
 * A wrapper implementation of Observer<T> that will dispatch events
 * asynchronously. To allow immediate silencing, a mute call is added which
 * causes events scheduled to no longer be raised.
 */ class __PRIVATE_AsyncObserver {
    constructor(e){
        this.observer = e, /**
         * When set to true, will not raise future events. Necessary to deal with
         * async detachment of listener.
         */ this.muted = !1;
    }
    next(e) {
        this.muted || this.observer.next && this.mc(this.observer.next, e);
    }
    error(e) {
        this.muted || (this.observer.error ? this.mc(this.observer.error, e) : __PRIVATE_logError("Uncaught Error in snapshot listener:", e.toString()));
    }
    gc() {
        this.muted = !0;
    }
    mc(e, t) {
        setTimeout(()=>{
            this.muted || e(t);
        }, 0);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class representing a bundle.
 *
 * Takes a bundle stream or buffer, and presents abstractions to read bundled
 * elements out of the underlying content.
 */ class __PRIVATE_BundleReaderImpl {
    constructor(/** The reader to read from underlying binary bundle data source. */ e, t){
        this.yc = e, this.serializer = t, /** Cached bundle metadata. */ this.metadata = new __PRIVATE_Deferred, /**
         * Internal buffer to hold bundle content, accumulating incomplete element
         * content.
         */ this.buffer = new Uint8Array, this.wc = function __PRIVATE_newTextDecoder() {
            return new TextDecoder("utf-8");
        }(), // Read the metadata (which is the first element).
        this.bc().then((e)=>{
            e && e.yu() ? this.metadata.resolve(e.gu.metadata) : this.metadata.reject(new Error(`The first element of the bundle is not a metadata, it is\n             ${JSON.stringify(e?.gu)}`));
        }, (e)=>this.metadata.reject(e));
    }
    close() {
        return this.yc.cancel();
    }
    async getMetadata() {
        return this.metadata.promise;
    }
    async Pc() {
        // Makes sure metadata is read before proceeding.
        return await this.getMetadata(), this.bc();
    }
    /**
     * Reads from the head of internal buffer, and pulling more data from
     * underlying stream if a complete element cannot be found, until an
     * element(including the prefixed length and the JSON string) is found.
     *
     * Once a complete element is read, it is dropped from internal buffer.
     *
     * Returns either the bundled element, or null if we have reached the end of
     * the stream.
     */ async bc() {
        const e = await this.vc();
        if (null === e) return null;
        const t = this.wc.decode(e), n = Number(t);
        isNaN(n) && this.Sc(`length string (${t}) is not valid number`);
        const r = await this.Dc(n);
        return new __PRIVATE_SizedBundleElement(JSON.parse(r), e.length + n);
    }
    /** First index of '{' from the underlying buffer. */ xc() {
        return this.buffer.findIndex((e)=>e === "{".charCodeAt(0));
    }
    /**
     * Reads from the beginning of the internal buffer, until the first '{', and
     * return the content.
     *
     * If reached end of the stream, returns a null.
     */ async vc() {
        for(; this.xc() < 0;){
            if (await this.Cc()) break;
        }
        // Broke out of the loop because underlying stream is closed, and there
        // happens to be no more data to process.
        if (0 === this.buffer.length) return null;
        const e = this.xc();
        // Broke out of the loop because underlying stream is closed, but still
        // cannot find an open bracket.
        e < 0 && this.Sc("Reached the end of bundle when a length string is expected.");
        const t = this.buffer.slice(0, e);
        // Update the internal buffer to drop the read length.
        return this.buffer = this.buffer.slice(e), t;
    }
    /**
     * Reads from a specified position from the internal buffer, for a specified
     * number of bytes, pulling more data from the underlying stream if needed.
     *
     * Returns a string decoded from the read bytes.
     */ async Dc(e) {
        for(; this.buffer.length < e;)await this.Cc() && this.Sc("Reached the end of bundle when more is expected.");
        const t = this.wc.decode(this.buffer.slice(0, e));
        // Update the internal buffer to drop the read json string.
        return this.buffer = this.buffer.slice(e), t;
    }
    Sc(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        throw this.yc.cancel(), new Error(`Invalid bundle format: ${e}`);
    }
    /**
     * Pulls more data from underlying stream to internal buffer.
     * Returns a boolean indicating whether the stream is finished.
     */ async Cc() {
        const e = await this.yc.read();
        if (!e.done) {
            const t = new Uint8Array(this.buffer.length + e.value.length);
            t.set(this.buffer), t.set(e.value, this.buffer.length), this.buffer = t;
        }
        return e.done;
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A class that can parse a bundle form the string serialization of a bundle.
 */ class __PRIVATE_BundleReaderSyncImpl {
    constructor(e, t){
        this.bundleData = e, this.serializer = t, this.cursor = 0, this.elements = [];
        let n = this.Pc();
        if (!n || !n.yu()) throw new Error(`The first element of the bundle is not a metadata object, it is\n         ${JSON.stringify(n?.gu)}`);
        this.metadata = n;
        do n = this.Pc(), null !== n && this.elements.push(n);
        while (null !== n);
    }
    /* Returns the parsed metadata of the bundle. */ getMetadata() {
        return this.metadata;
    }
    /* Returns the DocumentSnapshot or NamedQuery elements of the bundle. */ t() {
        return this.elements;
    }
    /**
     * Parses the next element of the bundle.
     *
     * @returns a SizedBundleElement representation of the next element in the bundle, or null if
     * no more elements exist.
     */ Pc() {
        if (this.cursor === this.bundleData.length) return null;
        const e = this.vc(), t = this.Dc(e);
        return new __PRIVATE_SizedBundleElement(JSON.parse(t), e);
    }
    /**
     * Reads from a specified position from the bundleData string, for a specified
     * number of bytes.
     *
     * @param length - how many characters to read.
     * @returns a string parsed from the bundle.
     */ Dc(e) {
        if (this.cursor + e > this.bundleData.length) throw new FirestoreError(D.INTERNAL, "Reached the end of bundle when more is expected.");
        return this.bundleData.slice(this.cursor, this.cursor += e);
    }
    /**
     * Reads from the current cursor until the first '{'.
     *
     * @returns  A string to integer represention of the parsed value.
     * @throws An {@link Error} if the cursor has reached the end of the stream, since lengths
     * prefix bundle objects.
     */ vc() {
        const e = this.cursor;
        let t = this.cursor;
        for(; t < this.bundleData.length;){
            if ("{" === this.bundleData[t]) {
                if (t === e) throw new Error("First character is a bracket and not a number");
                return this.cursor = t, Number(this.bundleData.slice(e, t));
            }
            t++;
        }
        throw new Error("Reached the end of bundle when more is expected.");
    }
}
/**
 *  Creates an instance of BundleReader without exposing the BundleReaderSyncImpl class type.
 */ /**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Internal transaction object responsible for accumulating the mutations to
 * perform and the base versions for any documents read.
 */ class Transaction {
    constructor(e){
        this.datastore = e, // The version of each document that was read during this transaction.
        this.readVersions = new Map, this.mutations = [], this.committed = !1, /**
         * A deferred usage error that occurred previously in this transaction that
         * will cause the transaction to fail once it actually commits.
         */ this.lastTransactionError = null, /**
         * Set of documents that have been written in the transaction.
         *
         * When there's more than one write to the same key in a transaction, any
         * writes after the first are handled differently.
         */ this.writtenDocs = new Set;
    }
    async lookup(e) {
        if (this.ensureCommitNotCalled(), this.mutations.length > 0) throw this.lastTransactionError = new FirestoreError(D.INVALID_ARGUMENT, "Firestore transactions require all reads to be executed before all writes."), this.lastTransactionError;
        const t = await async function __PRIVATE_invokeBatchGetDocumentsRpc(e, t) {
            const n = __PRIVATE_debugCast(e), r = {
                documents: t.map((e)=>__PRIVATE_toName(n.serializer, e))
            }, i = await n.$t("BatchGetDocuments", n.serializer.databaseId, ResourcePath.emptyPath(), r, t.length), s = new Map;
            i.forEach((e)=>{
                const t = __PRIVATE_fromBatchGetDocumentsResponse(n.serializer, e);
                s.set(t.key.toString(), t);
            });
            const _ = [];
            return t.forEach((e)=>{
                const t = s.get(e.toString());
                __PRIVATE_hardAssert(!!t, 55234, {
                    key: e
                }), _.push(t);
            }), _;
        }(this.datastore, e);
        return t.forEach((e)=>this.recordVersion(e)), t;
    }
    set(e, t) {
        this.write(t.toMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    update(e, t) {
        try {
            this.write(t.toMutation(e, this.preconditionForUpdate(e)));
        } catch (e) {
            this.lastTransactionError = e;
        }
        this.writtenDocs.add(e.toString());
    }
    delete(e) {
        this.write(new __PRIVATE_DeleteMutation(e, this.precondition(e))), this.writtenDocs.add(e.toString());
    }
    async commit() {
        if (this.ensureCommitNotCalled(), this.lastTransactionError) throw this.lastTransactionError;
        const e = this.readVersions;
        // For each mutation, note that the doc was written.
        this.mutations.forEach((t)=>{
            e.delete(t.key.toString());
        }), // For each document that was read but not written to, we want to perform
        // a `verify` operation.
        e.forEach((e, t)=>{
            const n = DocumentKey.fromPath(t);
            this.mutations.push(new __PRIVATE_VerifyMutation(n, this.precondition(n)));
        }), await async function __PRIVATE_invokeCommitRpc(e, t) {
            const n = __PRIVATE_debugCast(e), r = {
                writes: t.map((e)=>toMutation(n.serializer, e))
            };
            await n.Bt("Commit", n.serializer.databaseId, ResourcePath.emptyPath(), r);
        }(this.datastore, this.mutations), this.committed = !0;
    }
    recordVersion(e) {
        let t;
        if (e.isFoundDocument()) t = e.version;
        else {
            if (!e.isNoDocument()) throw fail(50498, {
                Oc: e.constructor.name
            });
            // Represent a deleted doc using SnapshotVersion.min().
            t = SnapshotVersion.min();
        }
        const n = this.readVersions.get(e.key.toString());
        if (n) {
            if (!t.isEqual(n)) // This transaction will fail no matter what.
            throw new FirestoreError(D.ABORTED, "Document version changed between two reads.");
        } else this.readVersions.set(e.key.toString(), t);
    }
    /**
     * Returns the version of this document when it was read in this transaction,
     * as a precondition, or no precondition if it was not read.
     */ precondition(e) {
        const t = this.readVersions.get(e.toString());
        return !this.writtenDocs.has(e.toString()) && t ? t.isEqual(SnapshotVersion.min()) ? Precondition.exists(!1) : Precondition.updateTime(t) : Precondition.none();
    }
    /**
     * Returns the precondition for a document if the operation is an update.
     */ preconditionForUpdate(e) {
        const t = this.readVersions.get(e.toString());
        // The first time a document is written, we want to take into account the
        // read time and existence
        if (!this.writtenDocs.has(e.toString()) && t) {
            if (t.isEqual(SnapshotVersion.min())) // The document doesn't exist, so fail the transaction.
            // This has to be validated locally because you can't send a
            // precondition that a document does not exist without changing the
            // semantics of the backend write to be an insert. This is the reverse
            // of what we want, since we want to assert that the document doesn't
            // exist but then send the update and have it fail. Since we can't
            // express that to the backend, we have to validate locally.
            // Note: this can change once we can send separate verify writes in the
            // transaction.
            throw new FirestoreError(D.INVALID_ARGUMENT, "Can't update a document that doesn't exist.");
            // Document exists, base precondition on document update time.
            return Precondition.updateTime(t);
        }
        // Document was not read, so we just use the preconditions for a blind
        // update.
        return Precondition.exists(!0);
    }
    write(e) {
        this.ensureCommitNotCalled(), this.mutations.push(e);
    }
    ensureCommitNotCalled() {}
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * TransactionRunner encapsulates the logic needed to run and retry transactions
 * with backoff.
 */ class __PRIVATE_TransactionRunner {
    constructor(e, t, n, r, i){
        this.asyncQueue = e, this.datastore = t, this.options = n, this.updateFunction = r, this.deferred = i, this.Mc = n.maxAttempts, this.xn = new __PRIVATE_ExponentialBackoff(this.asyncQueue, "transaction_retry" /* TimerId.TransactionRetry */ );
    }
    /** Runs the transaction and sets the result on deferred. */ Nc() {
        this.Mc -= 1, this.Lc();
    }
    Lc() {
        this.xn.mn(async ()=>{
            const e = new Transaction(this.datastore), t = this.Bc(e);
            t && t.then((t)=>{
                this.asyncQueue.enqueueAndForget(()=>e.commit().then(()=>{
                        this.deferred.resolve(t);
                    }).catch((e)=>{
                        this.Uc(e);
                    }));
            }).catch((e)=>{
                this.Uc(e);
            });
        });
    }
    Bc(e) {
        try {
            const t = this.updateFunction(e);
            return !__PRIVATE_isNullOrUndefined(t) && t.catch && t.then ? t : (this.deferred.reject(Error("Transaction callback must return a Promise")), null);
        } catch (e) {
            // Do not retry errors thrown by user provided updateFunction.
            return this.deferred.reject(e), null;
        }
    }
    Uc(e) {
        this.Mc > 0 && this.kc(e) ? (this.Mc -= 1, this.asyncQueue.enqueueAndForget(()=>(this.Lc(), Promise.resolve()))) : this.deferred.reject(e);
    }
    kc(e) {
        if ("FirebaseError" === e?.name) {
            // In transactions, the backend will fail outdated reads with FAILED_PRECONDITION and
            // non-matching document versions with ABORTED. These errors should be retried.
            const t = e.code;
            return "aborted" === t || "failed-precondition" === t || "already-exists" === t || !__PRIVATE_isPermanentError(t);
        }
        return !1;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const Vn = "FirestoreClient";
/**
 * FirestoreClient is a top-level class that constructs and owns all of the //
 * pieces of the client SDK architecture. It is responsible for creating the //
 * async queue that is shared by all of the other components in the system. //
 */ class FirestoreClient {
    constructor(e, t, /**
     * Asynchronous queue responsible for all of our internal processing. When
     * we get incoming work from the user (via public API) or the network
     * (incoming GRPC messages), we should always schedule onto this queue.
     * This ensures all of our work is properly serialized (e.g. we don't
     * start processing a new operation while the previous one is waiting for
     * an async I/O to complete).
     */ n, /**
     * Exposed for testing
     */ r, i){
        this.authCredentials = e, this.appCheckCredentials = t, this.asyncQueue = n, this._databaseInfo = r, this.user = User.UNAUTHENTICATED, this.clientId = __PRIVATE_AutoId.newId(), this.authCredentialListener = ()=>Promise.resolve(), this.appCheckCredentialListener = ()=>Promise.resolve(), this._uninitializedComponentsProvider = i, this.authCredentials.start(n, async (e)=>{
            __PRIVATE_logDebug(Vn, "Received user=", e.uid), await this.authCredentialListener(e), this.user = e;
        }), this.appCheckCredentials.start(n, (e)=>(__PRIVATE_logDebug(Vn, "Received new app check token=", e), this.appCheckCredentialListener(e, this.user)));
    }
    get configuration() {
        return {
            asyncQueue: this.asyncQueue,
            databaseInfo: this._databaseInfo,
            clientId: this.clientId,
            authCredentials: this.authCredentials,
            appCheckCredentials: this.appCheckCredentials,
            initialUser: this.user,
            maxConcurrentLimboResolutions: 100
        };
    }
    setCredentialChangeListener(e) {
        this.authCredentialListener = e;
    }
    setAppCheckTokenChangeListener(e) {
        this.appCheckCredentialListener = e;
    }
    terminate() {
        this.asyncQueue.enterRestrictedMode();
        const e = new __PRIVATE_Deferred;
        return this.asyncQueue.enqueueAndForgetEvenWhileRestricted(async ()=>{
            try {
                this._onlineComponents && await this._onlineComponents.terminate(), this._offlineComponents && await this._offlineComponents.terminate(), // The credentials provider must be terminated after shutting down the
                // RemoteStore as it will prevent the RemoteStore from retrieving auth
                // tokens.
                this.authCredentials.shutdown(), this.appCheckCredentials.shutdown(), e.resolve();
            } catch (t) {
                const n = __PRIVATE_wrapInUserErrorIfRecoverable(t, "Failed to shutdown persistence");
                e.reject(n);
            }
        }), e.promise;
    }
}
async function __PRIVATE_setOfflineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress(), __PRIVATE_logDebug(Vn, "Initializing OfflineComponentProvider");
    const n = e.configuration;
    await t.initialize(n);
    let r = n.initialUser;
    e.setCredentialChangeListener(async (e)=>{
        r.isEqual(e) || (await __PRIVATE_localStoreHandleUserChange(t.localStore, e), r = e);
    }), // When a user calls clearPersistence() in one client, all other clients
    // need to be terminated to allow the delete to succeed.
    t.persistence.setDatabaseDeletedListener(()=>e.terminate()), e._offlineComponents = t;
}
async function __PRIVATE_setOnlineComponentProvider(e, t) {
    e.asyncQueue.verifyOperationInProgress();
    const n = await __PRIVATE_ensureOfflineComponents(e);
    __PRIVATE_logDebug(Vn, "Initializing OnlineComponentProvider"), await t.initialize(n, e.configuration), // The CredentialChangeListener of the online component provider takes
    // precedence over the offline component provider.
    e.setCredentialChangeListener((e)=>__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, e)), e.setAppCheckTokenChangeListener((e, n)=>__PRIVATE_remoteStoreHandleCredentialChange(t.remoteStore, n)), e._onlineComponents = t;
}
/**
 * Decides whether the provided error allows us to gracefully disable
 * persistence (as opposed to crashing the client).
 */ async function __PRIVATE_ensureOfflineComponents(e) {
    if (!e._offlineComponents) {
        if (e._uninitializedComponentsProvider) {
            __PRIVATE_logDebug(Vn, "Using user provided OfflineComponentProvider");
            try {
                await __PRIVATE_setOfflineComponentProvider(e, e._uninitializedComponentsProvider._offline);
            } catch (t) {
                const n = t;
                if (!function __PRIVATE_canFallbackFromIndexedDbError(e) {
                    return "FirebaseError" === e.name ? e.code === D.FAILED_PRECONDITION || e.code === D.UNIMPLEMENTED : !("undefined" != typeof DOMException && e instanceof DOMException) || // When the browser is out of quota we could get either quota exceeded
                    // or an aborted error depending on whether the error happened during
                    // schema migration.
                    22 === e.code || 20 === e.code || // Firefox Private Browsing mode disables IndexedDb and returns
                    // INVALID_STATE for any usage.
                    11 === e.code;
                }(n)) throw n;
                __PRIVATE_logWarn("Error using user provided cache. Falling back to memory cache: " + n), await __PRIVATE_setOfflineComponentProvider(e, new __PRIVATE_MemoryOfflineComponentProvider);
            }
        } else __PRIVATE_logDebug(Vn, "Using default OfflineComponentProvider"), await __PRIVATE_setOfflineComponentProvider(e, new __PRIVATE_LruGcMemoryOfflineComponentProvider(void 0));
    }
    return e._offlineComponents;
}
async function __PRIVATE_ensureOnlineComponents(e) {
    return e._onlineComponents || (e._uninitializedComponentsProvider ? (__PRIVATE_logDebug(Vn, "Using user provided OnlineComponentProvider"), await __PRIVATE_setOnlineComponentProvider(e, e._uninitializedComponentsProvider._online)) : (__PRIVATE_logDebug(Vn, "Using default OnlineComponentProvider"), await __PRIVATE_setOnlineComponentProvider(e, new OnlineComponentProvider))), e._onlineComponents;
}
function __PRIVATE_getPersistence(e) {
    return __PRIVATE_ensureOfflineComponents(e).then((e)=>e.persistence);
}
function __PRIVATE_getLocalStore(e) {
    return __PRIVATE_ensureOfflineComponents(e).then((e)=>e.localStore);
}
function __PRIVATE_getRemoteStore(e) {
    return __PRIVATE_ensureOnlineComponents(e).then((e)=>e.remoteStore);
}
function __PRIVATE_getSyncEngine(e) {
    return __PRIVATE_ensureOnlineComponents(e).then((e)=>e.syncEngine);
}
function __PRIVATE_getDatastore(e) {
    return __PRIVATE_ensureOnlineComponents(e).then((e)=>e.datastore);
}
async function __PRIVATE_getEventManager(e) {
    const t = await __PRIVATE_ensureOnlineComponents(e), n = t.eventManager;
    return n.onListen = __PRIVATE_syncEngineListen.bind(null, t.syncEngine), n.onUnlisten = __PRIVATE_syncEngineUnlisten.bind(null, t.syncEngine), n.onFirstRemoteStoreListen = __PRIVATE_triggerRemoteStoreListen.bind(null, t.syncEngine), n.onLastRemoteStoreUnlisten = __PRIVATE_triggerRemoteStoreUnlisten.bind(null, t.syncEngine), n;
}
/** Enables the network connection and re-enqueues all pending operations. */ function __PRIVATE_firestoreClientEnableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await __PRIVATE_getPersistence(e), n = await __PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!0), function __PRIVATE_remoteStoreEnableNetwork(e) {
            const t = __PRIVATE_debugCast(e);
            return t.tu.delete(0 /* OfflineCause.UserDisabled */ ), __PRIVATE_enableNetworkInternal(t);
        }(n);
    });
}
/** Disables the network connection. Pending operations will not complete. */ function __PRIVATE_firestoreClientDisableNetwork(e) {
    return e.asyncQueue.enqueue(async ()=>{
        const t = await __PRIVATE_getPersistence(e), n = await __PRIVATE_getRemoteStore(e);
        return t.setNetworkEnabled(!1), async function __PRIVATE_remoteStoreDisableNetwork(e) {
            const t = __PRIVATE_debugCast(e);
            t.tu.add(0 /* OfflineCause.UserDisabled */ ), await __PRIVATE_disableNetworkInternal(t), // Set the OnlineState to Offline so get()s return from cache, etc.
            t.iu.set("Offline" /* OnlineState.Offline */ );
        }(n);
    });
}
/**
 * Returns a Promise that resolves when all writes that were pending at the time
 * this method was called received server acknowledgement. An acknowledgement
 * can be either acceptance or rejection.
 */ function __PRIVATE_firestoreClientListen(e, t, n, r) {
    const i = new __PRIVATE_AsyncObserver(r), s = new __PRIVATE_QueryListener(t, i, n);
    return e.asyncQueue.enqueueAndForget(async ()=>__PRIVATE_eventManagerListen(await __PRIVATE_getEventManager(e), s)), ()=>{
        i.gc(), e.asyncQueue.enqueueAndForget(async ()=>__PRIVATE_eventManagerUnlisten(await __PRIVATE_getEventManager(e), s));
    };
}
function __PRIVATE_firestoreClientGetDocumentFromLocalCache(e, t) {
    const n = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_readDocumentFromCache(e, t, n) {
            try {
                const r = await function __PRIVATE_localStoreReadDocument(e, t) {
                    const n = __PRIVATE_debugCast(e);
                    return n.persistence.runTransaction("read document", "readonly", (e)=>n.localDocuments.getDocument(e, t));
                }(e, t);
                r.isFoundDocument() ? n.resolve(r) : r.isNoDocument() ? n.resolve(null) : n.reject(new FirestoreError(D.UNAVAILABLE, "Failed to get document from cache. (However, this document may exist on the server. Run again without setting 'source' in the GetOptions to attempt to retrieve the document from the server.)"));
            } catch (e) {
                const r = __PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to get document '${t} from cache`);
                n.reject(r);
            }
        })(await __PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function __PRIVATE_firestoreClientGetDocumentViaSnapshotListener(e, t, n = {}) {
    const r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_readDocumentViaSnapshotListener(e, t, n, r, i) {
            const s = new __PRIVATE_AsyncObserver({
                next: (o)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.gc(), t.enqueueAndForget(()=>__PRIVATE_eventManagerUnlisten(e, _));
                    const a = o.docs.has(n);
                    !a && o.fromCache ? // TODO(dimond): If we're online and the document doesn't
                    // exist then we resolve with a doc.exists set to false. If
                    // we're offline however, we reject the Promise in this
                    // case. Two options: 1) Cache the negative response from
                    // the server so we can deliver that even when you're
                    // offline 2) Actually reject the Promise in the online case
                    // if the document doesn't exist.
                    i.reject(new FirestoreError(D.UNAVAILABLE, "Failed to get document because the client is offline.")) : a && o.fromCache && r && "server" === r.source ? i.reject(new FirestoreError(D.UNAVAILABLE, 'Failed to get document from server. (However, this document does exist in the local cache. Run again without setting source to "server" to retrieve the cached document.)')) : i.resolve(o);
                },
                error: (e)=>i.reject(e)
            }), _ = new __PRIVATE_QueryListener(__PRIVATE_newQueryForPath(n.path), s, {
                includeMetadataChanges: !0,
                waitForSyncWhenOnline: !0
            });
            return __PRIVATE_eventManagerListen(e, _);
        })(await __PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function __PRIVATE_firestoreClientGetDocumentsFromLocalCache(e, t) {
    const n = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(async function __PRIVATE_executeQueryFromCache(e, t, n) {
            try {
                const r = await __PRIVATE_localStoreExecuteQuery(e, t, /* usePreviousResults= */ !0), i = new __PRIVATE_View(t, r.Jo), s = i.ku(r.documents), _ = i.applyChanges(s, /* limboResolutionEnabled= */ !1);
                n.resolve(_.snapshot);
            } catch (e) {
                const r = __PRIVATE_wrapInUserErrorIfRecoverable(e, `Failed to execute query '${t} against cache`);
                n.reject(r);
            }
        })(await __PRIVATE_getLocalStore(e), t, n)), n.promise;
}
function __PRIVATE_firestoreClientGetDocumentsViaSnapshotListener(e, t, n = {}) {
    const r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_executeQueryViaSnapshotListener(e, t, n, r, i) {
            const s = new __PRIVATE_AsyncObserver({
                next: (n)=>{
                    // Mute and remove query first before passing event to user to avoid
                    // user actions affecting the now stale query.
                    s.gc(), t.enqueueAndForget(()=>__PRIVATE_eventManagerUnlisten(e, _)), n.fromCache && "server" === r.source ? i.reject(new FirestoreError(D.UNAVAILABLE, 'Failed to get documents from server. (However, these documents may exist in the local cache. Run again without setting source to "server" to retrieve the cached documents.)')) : i.resolve(n);
                },
                error: (e)=>i.reject(e)
            }), _ = new __PRIVATE_QueryListener(n instanceof __PRIVATE_RealtimePipeline ? __PRIVATE_toCorePipeline(n) : n, s, {
                includeMetadataChanges: !0,
                waitForSyncWhenOnline: !0
            });
            return __PRIVATE_eventManagerListen(e, _);
        })(await __PRIVATE_getEventManager(e), e.asyncQueue, t, n, r)), r.promise;
}
function __PRIVATE_firestoreClientRunAggregateQuery(e, t, n) {
    const r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        // Implement and call executeAggregateQueryViaSnapshotListener, similar
        // to the implementation in firestoreClientGetDocumentsViaSnapshotListener
        // above
        try {
            // TODO(b/277628384): check `canUseNetwork()` and handle multi-tab.
            const i = await __PRIVATE_getDatastore(e);
            r.resolve(async function __PRIVATE_invokeRunAggregationQueryRpc(e, t, n) {
                const r = __PRIVATE_debugCast(e), { request: i, wt: s, parent: _ } = __PRIVATE_toRunAggregationQueryRequest(r.serializer, __PRIVATE_queryToAggregateTarget(t), n);
                r.connection.Ot || delete i.parent;
                const o = (await r.$t("RunAggregationQuery", r.serializer.databaseId, _, i, /*expectedResponseCount=*/ 1)).filter((e)=>!!e.result);
                // Omit RunAggregationQueryResponse that only contain readTimes.
                __PRIVATE_hardAssert(1 === o.length, 64727);
                // Remap the short-form aliases that were sent to the server
                // to the client-side aliases. Users will access the results
                // using the client-side alias.
                const a = o[0].result?.aggregateFields;
                return Object.keys(a).reduce((e, t)=>(e[s[t]] = a[t], e), {});
            }(i, t, n));
        } catch (e) {
            r.reject(e);
        }
    }), r.promise;
}
function __PRIVATE_firestoreClientExecutePipeline(e, t) {
    const n = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        try {
            const r = await __PRIVATE_getDatastore(e);
            n.resolve(async function __PRIVATE_invokeExecutePipeline(e, t) {
                const n = __PRIVATE_debugCast(e), r = {
                    database: __PRIVATE_getEncodedDatabaseId(n.serializer),
                    structuredPipeline: t._toProto(n.serializer)
                }, i = await n.$t("ExecutePipeline", n.serializer.databaseId, ResourcePath.emptyPath(), r), s = [];
                return i.forEach((e)=>{
                    if (e.results && 0 !== e.results.length) return e.results.forEach((t)=>s.push(__PRIVATE_fromPipelineResponse(n.serializer, e, t)));
                    s.push(__PRIVATE_fromPipelineResponse(n.serializer, e));
                }), s;
            }(r, t));
        } catch (e) {
            n.reject(e);
        }
    }), n.promise;
}
function __PRIVATE_firestoreClientWrite(e, t) {
    const n = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>__PRIVATE_syncEngineWrite(await __PRIVATE_getSyncEngine(e), t, n)), n.promise;
}
function __PRIVATE_firestoreClientAddSnapshotsInSyncListener(e, t) {
    const n = new __PRIVATE_AsyncObserver(t);
    return e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_addSnapshotsInSyncListener(e, t) {
            __PRIVATE_debugCast(e).Pu.add(t), // Immediately fire an initial event, indicating all existing listeners
            // are in-sync.
            t.next();
        })(await __PRIVATE_getEventManager(e), n)), ()=>{
        n.gc(), e.asyncQueue.enqueueAndForget(async ()=>(function __PRIVATE_removeSnapshotsInSyncListener(e, t) {
                __PRIVATE_debugCast(e).Pu.delete(t);
            })(await __PRIVATE_getEventManager(e), n));
    };
}
/**
 * Takes an updateFunction in which a set of reads and writes can be performed
 * atomically. In the updateFunction, the client can read and write values
 * using the supplied transaction object. After the updateFunction, all
 * changes will be committed. If a retryable error occurs (ex: some other
 * client has changed any of the data referenced), then the updateFunction
 * will be called again after a backoff. If the updateFunction still fails
 * after all retries, then the transaction will be rejected.
 *
 * The transaction object passed to the updateFunction contains methods for
 * accessing documents and collections. Unlike other datastore access, data
 * accessed with the transaction will not reflect local changes that have not
 * been committed. For this reason, it is required that all reads are
 * performed before any writes. Transactions must be performed while online.
 */ function __PRIVATE_firestoreClientTransaction(e, t, n) {
    const r = new __PRIVATE_Deferred;
    return e.asyncQueue.enqueueAndForget(async ()=>{
        const i = await __PRIVATE_getDatastore(e);
        new __PRIVATE_TransactionRunner(e.asyncQueue, i, n, t, r).Nc();
    }), r.promise;
}
function __PRIVATE_firestoreClientLoadBundle(e, t, n, r) {
    const i = function __PRIVATE_createBundleReader(e, t) {
        let n;
        n = "string" == typeof e ? __PRIVATE_newTextEncoder().encode(e) : e;
        return function __PRIVATE_newBundleReader(e, t) {
            return new __PRIVATE_BundleReaderImpl(e, t);
        }(function __PRIVATE_toByteStreamReader(e, t) {
            if (e instanceof Uint8Array) return __PRIVATE_toByteStreamReaderHelper(e, t);
            if (e instanceof ArrayBuffer) return __PRIVATE_toByteStreamReaderHelper(new Uint8Array(e), t);
            if (e instanceof ReadableStream) return e.getReader();
            throw new Error("Source of `toByteStreamReader` has to be a ArrayBuffer or ReadableStream");
        }(n), t);
    }(n, __PRIVATE_newSerializer(t));
    e.asyncQueue.enqueueAndForget(async ()=>{
        __PRIVATE_syncEngineLoadBundle(await __PRIVATE_getSyncEngine(e), i, r);
    });
}
function __PRIVATE_firestoreClientGetNamedQuery(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreGetNamedQuery(e, t) {
            const n = __PRIVATE_debugCast(e);
            return n.persistence.runTransaction("Get named query", "readonly", (e)=>n.w_.getNamedQuery(e, t));
        })(await __PRIVATE_getLocalStore(e), t));
}
function __PRIVATE_createBundleReaderSync(e, t) {
    return function __PRIVATE_newBundleReaderSync(e, t) {
        return new __PRIVATE_BundleReaderSyncImpl(e, t);
    }(e, t);
}
function __PRIVATE_firestoreClientSetIndexConfiguration(e, t) {
    return e.asyncQueue.enqueue(async ()=>(async function __PRIVATE_localStoreConfigureFieldIndexes(e, t) {
            const n = __PRIVATE_debugCast(e), r = n.indexManager, i = [];
            return n.persistence.runTransaction("Configure indexes", "readwrite", (e)=>r.getFieldIndexes(e).next((n)=>(function __PRIVATE_diffArrays(e, t, n, r, i) {
                        e = [
                            ...e
                        ], t = [
                            ...t
                        ], e.sort(n), t.sort(n);
                        const s = e.length, _ = t.length;
                        let o = 0, a = 0;
                        for(; o < _ && a < s;){
                            const s = n(e[a], t[o]);
                            s < 0 ? // The element was removed if the next element in our ordered
                            // walkthrough is only in `before`.
                            i(e[a++]) : s > 0 ? // The element was added if the next element in our ordered walkthrough
                            // is only in `after`.
                            r(t[o++]) : (o++, a++);
                        }
                        for(; o < _;)r(t[o++]);
                        for(; a < s;)i(e[a++]);
                    })(n, t, __PRIVATE_fieldIndexSemanticComparator, (t)=>{
                        i.push(r.addFieldIndex(e, t));
                    }, (t)=>{
                        i.push(r.deleteFieldIndex(e, t));
                    })).next(()=>PersistencePromise.waitFor(i)));
        })(await __PRIVATE_getLocalStore(e), t));
}
function __PRIVATE_firestoreClientSetPersistentCacheIndexAutoCreationEnabled(e, t) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreSetIndexAutoCreationEnabled(e, t) {
            __PRIVATE_debugCast(e).qo.Do = t;
        })(await __PRIVATE_getLocalStore(e), t));
}
function __PRIVATE_firestoreClientDeleteAllFieldIndexes(e) {
    return e.asyncQueue.enqueue(async ()=>(function __PRIVATE_localStoreDeleteAllFieldIndexes(e) {
            const t = __PRIVATE_debugCast(e), n = t.indexManager;
            return t.persistence.runTransaction("Delete All Indexes", "readwrite", (e)=>n.deleteAllFieldIndexes(e));
        })(await __PRIVATE_getLocalStore(e)));
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const dn = "AsyncQueue";
class __PRIVATE_AsyncQueueImpl {
    constructor(e = Promise.resolve()){
        // A list of retryable operations. Retryable operations are run in order and
        // retried with backoff.
        this.qc = [], // Is this AsyncQueue being shut down? Once it is set to true, it will not
        // be changed again.
        this.$c = !1, // Operations scheduled to be queued in the future. Operations are
        // automatically removed after they are run or canceled.
        this.Kc = [], // visible for testing
        this.Wc = null, // Flag set while there's an outstanding AsyncQueue operation, used for
        // assertion sanity-checks.
        this.Qc = !1, // Enabled during shutdown on Safari to prevent future access to IndexedDB.
        this.Gc = !1, // List of TimerIds to fast-forward delays for.
        this.zc = [], // Backoff timer used to schedule retries for retryable operations
        this.xn = new __PRIVATE_ExponentialBackoff(this, "async_queue_retry" /* TimerId.AsyncQueueRetry */ ), // Visibility handler that triggers an immediate retry of all retryable
        // operations. Meant to speed up recovery when we regain file system access
        // after page comes into foreground.
        this.jc = ()=>{
            const e = getDocument();
            e && __PRIVATE_logDebug(dn, "Visibility state changed to " + e.visibilityState), this.xn.gn();
        }, this.Hc = e;
        const t = getDocument();
        t && "function" == typeof t.addEventListener && t.addEventListener("visibilitychange", this.jc);
    }
    get isShuttingDown() {
        return this.$c;
    }
    /**
     * Adds a new operation to the queue without waiting for it to complete (i.e.
     * we ignore the Promise result).
     */ enqueueAndForget(e) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.enqueue(e);
    }
    enqueueAndForgetEvenWhileRestricted(e) {
        this.Jc(), // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this.Yc(e);
    }
    enterRestrictedMode(e) {
        if (!this.$c) {
            this.$c = !0, this.Gc = e || !1;
            const t = getDocument();
            t && "function" == typeof t.removeEventListener && t.removeEventListener("visibilitychange", this.jc);
        }
    }
    enqueue(e) {
        if (this.Jc(), this.$c) // Return a Promise which never resolves.
        return new Promise(()=>{});
        // Create a deferred Promise that we can return to the callee. This
        // allows us to return a "hanging Promise" only to the callee and still
        // advance the queue even when the operation is not run.
        const t = new __PRIVATE_Deferred;
        return this.Yc(()=>this.$c && this.Gc ? Promise.resolve() : (e().then(t.resolve, t.reject), t.promise)).then(()=>t.promise);
    }
    enqueueRetryable(e) {
        this.enqueueAndForget(()=>(this.qc.push(e), this.Zc()));
    }
    /**
     * Runs the next operation from the retryable queue. If the operation fails,
     * reschedules with backoff.
     */ async Zc() {
        if (0 !== this.qc.length) {
            try {
                await this.qc[0](), this.qc.shift(), this.xn.reset();
            } catch (e) {
                if (!__PRIVATE_isIndexedDbTransactionError(e)) throw e;
                // Failure will be handled by AsyncQueue
                __PRIVATE_logDebug(dn, "Operation failed with retryable error: " + e);
            }
            this.qc.length > 0 && // If there are additional operations, we re-schedule `retryNextOp()`.
            // This is necessary to run retryable operations that failed during
            // their initial attempt since we don't know whether they are already
            // enqueued. If, for example, `op1`, `op2`, `op3` are enqueued and `op1`
            // needs to  be re-run, we will run `op1`, `op1`, `op2` using the
            // already enqueued calls to `retryNextOp()`. `op3()` will then run in the
            // call scheduled here.
            // Since `backoffAndRun()` cancels an existing backoff and schedules a
            // new backoff on every call, there is only ever a single additional
            // operation in the queue.
            this.xn.mn(()=>this.Zc());
        }
    }
    Yc(e) {
        const t = this.Hc.then(()=>(this.Qc = !0, e().catch((e)=>{
                this.Wc = e, this.Qc = !1;
                // Re-throw the error so that this.tail becomes a rejected Promise and
                // all further attempts to chain (via .then) will just short-circuit
                // and return the rejected Promise.
                throw __PRIVATE_logError("INTERNAL UNHANDLED ERROR: ", __PRIVATE_getMessageOrStack(e)), e;
            }).then((e)=>(this.Qc = !1, e))));
        return this.Hc = t, t;
    }
    enqueueAfterDelay(e, t, n) {
        this.Jc(), // Fast-forward delays for timerIds that have been overridden.
        this.zc.indexOf(e) > -1 && (t = 0);
        const r = DelayedOperation.createAndSchedule(this, e, t, n, (e)=>this.Xc(e));
        return this.Kc.push(r), r;
    }
    Jc() {
        this.Wc && fail(47125, {
            el: __PRIVATE_getMessageOrStack(this.Wc)
        });
    }
    verifyOperationInProgress() {}
    /**
     * Waits until all currently queued tasks are finished executing. Delayed
     * operations are not run.
     */ async tl() {
        // Operations in the queue prior to draining may have enqueued additional
        // operations. Keep draining the queue until the tail is no longer advanced,
        // which indicates that no more new operations were enqueued and that all
        // operations were executed.
        let e;
        do e = this.Hc, await e;
        while (e !== this.Hc);
    }
    /**
     * For Tests: Determine if a delayed operation with a particular TimerId
     * exists.
     */ nl(e) {
        for (const t of this.Kc)if (t.timerId === e) return !0;
        return !1;
    }
    /**
     * For Tests: Runs some or all delayed operations early.
     *
     * @param lastTimerId - Delayed operations up to and including this TimerId
     * will be drained. Pass TimerId.All to run all delayed operations.
     * @returns a Promise that resolves once all operations have been run.
     */ rl(e) {
        // Note that draining may generate more delayed ops, so we do that first.
        return this.tl().then(()=>{
            // Run ops in the same order they'd run if they ran naturally.
            /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.Kc.sort((e, t)=>e.targetTimeMs - t.targetTimeMs);
            for (const t of this.Kc)if (t.skipDelay(), "all" /* TimerId.All */  !== e && t.timerId === e) break;
            return this.tl();
        });
    }
    /**
     * For Tests: Skip all subsequent delays for a timer id.
     */ il(e) {
        this.zc.push(e);
    }
    /** Called once a DelayedOperation is run or canceled. */ Xc(e) {
        // NOTE: indexOf / slice are O(n), but delayedOperations is expected to be small.
        const t = this.Kc.indexOf(e);
        /* eslint-disable-next-line @typescript-eslint/no-floating-promises */ this.Kc.splice(t, 1);
    }
}
/**
 * Chrome includes Error.message in Error.stack. Other browsers do not.
 * This returns expected output of message + stack when available.
 * @param error - Error or FirestoreError
 */ function __PRIVATE_getMessageOrStack(e) {
    let t = e.message || "";
    return e.stack && (t = e.stack.includes(e.message) ? e.stack : e.message + "\n" + e.stack), t;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents the task of loading a Firestore bundle. It provides progress of bundle
 * loading, as well as task completion and error events.
 *
 * The API is compatible with `Promise<LoadBundleTaskProgress>`.
 */ class LoadBundleTask {
    constructor(){
        this._progressObserver = {}, this._taskCompletionResolver = new __PRIVATE_Deferred, this._lastProgress = {
            taskState: "Running",
            totalBytes: 0,
            totalDocuments: 0,
            bytesLoaded: 0,
            documentsLoaded: 0
        };
    }
    /**
     * Registers functions to listen to bundle loading progress events.
     * @param next - Called when there is a progress update from bundle loading. Typically `next` calls occur
     *   each time a Firestore document is loaded from the bundle.
     * @param error - Called when an error occurs during bundle loading. The task aborts after reporting the
     *   error, and there should be no more updates after this.
     * @param complete - Called when the loading task is complete.
     */ onProgress(e, t, n) {
        this._progressObserver = {
            next: e,
            error: t,
            complete: n
        };
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.catch` interface.
     *
     * @param onRejected - Called when an error occurs during bundle loading.
     */ catch(e) {
        return this._taskCompletionResolver.promise.catch(e);
    }
    /**
     * Implements the `Promise<LoadBundleTaskProgress>.then` interface.
     *
     * @param onFulfilled - Called on the completion of the loading task with a final `LoadBundleTaskProgress` update.
     *   The update will always have its `taskState` set to `"Success"`.
     * @param onRejected - Called when an error occurs during bundle loading.
     */ then(e, t) {
        return this._taskCompletionResolver.promise.then(e, t);
    }
    /**
     * Notifies all observers that bundle loading has completed, with a provided
     * `LoadBundleTaskProgress` object.
     *
     * @private
     */ _completeWith(e) {
        this._updateProgress(e), this._progressObserver.complete && this._progressObserver.complete(), this._taskCompletionResolver.resolve(e);
    }
    /**
     * Notifies all observers that bundle loading has failed, with a provided
     * `Error` as the reason.
     *
     * @private
     */ _failWith(e) {
        this._lastProgress.taskState = "Error", this._progressObserver.next && this._progressObserver.next(this._lastProgress), this._progressObserver.error && this._progressObserver.error(e), this._taskCompletionResolver.reject(e);
    }
    /**
     * Notifies a progress update of loading a bundle.
     * @param progress - The new progress.
     *
     * @private
     */ _updateProgress(e) {
        this._lastProgress = e, this._progressObserver.next && this._progressObserver.next(e);
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Constant used to indicate the LRU garbage collection should be disabled.
 * Set this value as the `cacheSizeBytes` on the settings passed to the
 * {@link Firestore} instance.
 */ const fn = -1;
/**
 * The Cloud Firestore service interface.
 *
 * Do not call this constructor directly. Instead, use {@link (getFirestore:1)}.
 */ class Firestore extends Firestore$1 {
    /** @hideconstructor */ constructor(e, t, n, r){
        super(e, t, n, r), /**
         * Whether it's a {@link Firestore} or Firestore Lite instance.
         */ this.type = "firestore", this._queue = new __PRIVATE_AsyncQueueImpl, this._persistenceKey = r?.name || "[DEFAULT]";
    }
    async _terminate() {
        if (this._firestoreClient) {
            const e = this._firestoreClient.terminate();
            this._queue = new __PRIVATE_AsyncQueueImpl(e), this._firestoreClient = void 0, await e;
        }
    }
}
/**
 * Initializes a new instance of {@link Firestore} with the provided settings.
 * Can only be called before any other function, including
 * {@link (getFirestore:1)}. If the custom settings are empty, this function is
 * equivalent to calling {@link (getFirestore:1)}.
 *
 * @param app - The {@link @firebase/app#FirebaseApp} with which the {@link Firestore} instance will
 * be associated.
 * @param settings - A settings object to configure the {@link Firestore} instance.
 * @param databaseId - The name of the database.
 * @returns A newly initialized {@link Firestore} instance.
 */ function initializeFirestore(e, t, n) {
    n || (n = st);
    const r = (0, _app._getProvider)(e, "firestore");
    if (r.isInitialized(n)) {
        const e = r.getImmediate({
            identifier: n
        }), i = r.getOptions(n);
        if ((0, _util.deepEqual)(i, t)) return e;
        throw new FirestoreError(D.FAILED_PRECONDITION, "initializeFirestore() has already been called with different options. To avoid this error, call initializeFirestore() with the same options as when it was originally called, or call getFirestore() to return the already initialized instance.");
    }
    if (void 0 !== t.cacheSizeBytes && void 0 !== t.localCache) throw new FirestoreError(D.INVALID_ARGUMENT, "cache and cacheSizeBytes cannot be specified at the same time as cacheSizeBytes willbe deprecated. Instead, specify the cache size in the cache object");
    if (void 0 !== t.cacheSizeBytes && -1 !== t.cacheSizeBytes && t.cacheSizeBytes < Ut) throw new FirestoreError(D.INVALID_ARGUMENT, "cacheSizeBytes must be at least 1048576");
    // Workaround to get cookies in Firebase Studio
    return t.host && (0, _util.isCloudWorkstation)(t.host) && (0, _util.pingServer)(t.host), r.initialize({
        options: t,
        instanceIdentifier: n
    });
}
function getFirestore(e, n) {
    const r = "object" == typeof e ? e : (0, _app.getApp)(), i = "string" == typeof e ? e : n || st, s = (0, _app._getProvider)(r, "firestore").getImmediate({
        identifier: i
    });
    if (!s._initialized) {
        const e = (0, _util.getDefaultEmulatorHostnameAndPort)("firestore");
        e && connectFirestoreEmulator(s, ...e);
    }
    return s;
}
/**
 * @internal
 */ function ensureFirestoreConfigured(e) {
    if (e._terminated) throw new FirestoreError(D.FAILED_PRECONDITION, "The client has already been terminated.");
    return e._firestoreClient || __PRIVATE_configureFirestore(e), e._firestoreClient;
}
function __PRIVATE_configureFirestore(e) {
    const t = e._freezeSettings(), n = __PRIVATE_makeDatabaseInfo(e._databaseId, e._app?.options.appId || "", e._persistenceKey, e._app?.options.apiKey, t);
    e._componentsProvider || t.localCache?._offlineComponentProvider && t.localCache?._onlineComponentProvider && (e._componentsProvider = {
        _offline: t.localCache._offlineComponentProvider,
        _online: t.localCache._onlineComponentProvider
    }), e._firestoreClient = new FirestoreClient(e._authCredentials, e._appCheckCredentials, e._queue, n, e._componentsProvider && function __PRIVATE_buildComponentProvider(e) {
        const t = e?._online.build();
        return {
            _offline: e?._offline.build(t),
            _online: t
        };
    }(e._componentsProvider));
}
function enableIndexedDbPersistence(e, t) {
    __PRIVATE_logWarn("enableIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const n = e._freezeSettings();
    return __PRIVATE_setPersistenceProviders(e, OnlineComponentProvider.provider, {
        build: (e)=>new __PRIVATE_IndexedDbOfflineComponentProvider(e, n.cacheSizeBytes, t?.forceOwnership)
    }), Promise.resolve();
}
/**
 * Attempts to enable multi-tab persistent storage, if possible. If enabled
 * across all tabs, all operations share access to local persistence, including
 * shared execution of queries and latency-compensated local document updates
 * across all connected instances.
 *
 * On failure, `enableMultiTabIndexedDbPersistence()` will reject the promise or
 * throw an exception. There are several reasons why this can fail, which can be
 * identified by the `code` on the error.
 *
 *   * failed-precondition: The app is already open in another browser tab and
 *     multi-tab is not enabled.
 *   * unimplemented: The browser is incompatible with the offline persistence
 *     implementation.
 *
 * Note that even after a failure, the {@link Firestore} instance will remain
 * usable, however offline persistence will be disabled.
 *
 * @param firestore - The {@link Firestore} instance to enable persistence for.
 * @returns A `Promise` that represents successfully enabling persistent
 * storage.
 * @deprecated This function will be removed in a future major release. Instead, set
 * `FirestoreSettings.localCache` to an instance of `PersistentLocalCache` to
 * turn on indexeddb cache. Calling this function when `FirestoreSettings.localCache`
 * is already specified will throw an exception.
 */ async function enableMultiTabIndexedDbPersistence(e) {
    __PRIVATE_logWarn("enableMultiTabIndexedDbPersistence() will be deprecated in the future, you can use `FirestoreSettings.cache` instead.");
    const t = e._freezeSettings();
    __PRIVATE_setPersistenceProviders(e, OnlineComponentProvider.provider, {
        build: (e)=>new __PRIVATE_MultiTabOfflineComponentProvider(e, t.cacheSizeBytes)
    });
}
/**
 * Registers both the `OfflineComponentProvider` and `OnlineComponentProvider`.
 * If the operation fails with a recoverable error (see
 * `canRecoverFromIndexedDbError()` below), the returned Promise is rejected
 * but the client remains usable.
 */ function __PRIVATE_setPersistenceProviders(e, t, n) {
    if ((e = __PRIVATE_cast(e, Firestore))._firestoreClient || e._terminated) throw new FirestoreError(D.FAILED_PRECONDITION, "Firestore has already been started and persistence can no longer be enabled. You can only enable persistence before calling any other methods on a Firestore object.");
    if (e._componentsProvider || e._getSettings().localCache) throw new FirestoreError(D.FAILED_PRECONDITION, "SDK cache is already specified.");
    e._componentsProvider = {
        _online: t,
        _offline: n
    }, __PRIVATE_configureFirestore(e);
}
/**
 * Clears the persistent storage. This includes pending writes and cached
 * documents.
 *
 * Must be called while the {@link Firestore} instance is not started (after the app is
 * terminated or when the app is first initialized). On startup, this function
 * must be called before other functions (other than {@link
 * initializeFirestore} or {@link (getFirestore:1)})). If the {@link Firestore}
 * instance is still running, the promise will be rejected with the error code
 * of `failed-precondition`.
 *
 * Note: `clearIndexedDbPersistence()` is primarily intended to help write
 * reliable tests that use Cloud Firestore. It uses an efficient mechanism for
 * dropping existing data but does not attempt to securely overwrite or
 * otherwise make cached data unrecoverable. For applications that are sensitive
 * to the disclosure of cached data in between user sessions, we strongly
 * recommend not enabling persistence at all.
 *
 * @param firestore - The {@link Firestore} instance to clear persistence for.
 * @returns A `Promise` that is resolved when the persistent storage is
 * cleared. Otherwise, the promise is rejected with an error.
 */ function clearIndexedDbPersistence(e) {
    if (e._initialized && !e._terminated) throw new FirestoreError(D.FAILED_PRECONDITION, "Persistence can only be cleared before a Firestore instance is initialized or after it is terminated.");
    const t = new __PRIVATE_Deferred;
    return e._queue.enqueueAndForgetEvenWhileRestricted(async ()=>{
        try {
            await async function __PRIVATE_indexedDbClearPersistence(e) {
                if (!__PRIVATE_SimpleDb.C()) return Promise.resolve();
                const t = e + an;
                await __PRIVATE_SimpleDb.delete(t);
            }(__PRIVATE_indexedDbStoragePrefix(e._databaseId, e._persistenceKey)), t.resolve();
        } catch (e) {
            t.reject(e);
        }
    }), t.promise;
}
/**
 * Waits until all currently pending writes for the active user have been
 * acknowledged by the backend.
 *
 * The returned promise resolves immediately if there are no outstanding writes.
 * Otherwise, the promise waits for all previously issued writes (including
 * those written in a previous app session), but it does not wait for writes
 * that were added after the function is called. If you want to wait for
 * additional writes, call `waitForPendingWrites()` again.
 *
 * Any outstanding `waitForPendingWrites()` promises are rejected during user
 * changes.
 *
 * @returns A `Promise` which resolves when all currently pending writes have been
 * acknowledged by the backend.
 */ function waitForPendingWrites(e) {
    return function __PRIVATE_firestoreClientWaitForPendingWrites(e) {
        const t = new __PRIVATE_Deferred;
        return e.asyncQueue.enqueueAndForget(async ()=>__PRIVATE_syncEngineRegisterPendingWritesCallback(await __PRIVATE_getSyncEngine(e), t)), t.promise;
    }(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)));
}
/**
 * Re-enables use of the network for this {@link Firestore} instance after a prior
 * call to {@link disableNetwork}.
 *
 * @returns A `Promise` that is resolved once the network has been enabled.
 */ function enableNetwork(e) {
    return __PRIVATE_firestoreClientEnableNetwork(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)));
}
/**
 * Disables network usage for this instance. It can be re-enabled via {@link
 * enableNetwork}. While the network is disabled, any snapshot listeners,
 * `getDoc()` or `getDocs()` calls will return results from cache, and any write
 * operations will be queued until the network is restored.
 *
 * @returns A `Promise` that is resolved once the network has been disabled.
 */ function disableNetwork(e) {
    return __PRIVATE_firestoreClientDisableNetwork(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)));
}
/**
 * Terminates the provided {@link Firestore} instance.
 *
 * After calling `terminate()` only the `clearIndexedDbPersistence()` function
 * may be used. Any other function will throw a `FirestoreError`.
 *
 * To restart after termination, create a new instance of FirebaseFirestore with
 * {@link (getFirestore:1)}.
 *
 * Termination does not cancel any pending writes, and any promises that are
 * awaiting a response from the server will not be resolved. If you have
 * persistence enabled, the next time you start this instance, it will resume
 * sending these writes to the server.
 *
 * Note: Under normal circumstances, calling `terminate()` is not required. This
 * function is useful only when you want to force this instance to release all
 * of its resources or in combination with `clearIndexedDbPersistence()` to
 * ensure that all local state is destroyed between test runs.
 *
 * @returns A `Promise` that is resolved when the instance has been successfully
 * terminated.
 */ function terminate(e) {
    return (0, _app._removeServiceInstance)(e.app, "firestore", e._databaseId.database), e._delete();
}
/**
 * Loads a Firestore bundle into the local cache.
 *
 * @param firestore - The {@link Firestore} instance to load bundles for.
 * @param bundleData - An object representing the bundle to be loaded. Valid
 * objects are `ArrayBuffer`, `ReadableStream<Uint8Array>` or `string`.
 *
 * @returns A `LoadBundleTask` object, which notifies callers with progress
 * updates, and completion or error events. It can be used as a
 * `Promise<LoadBundleTaskProgress>`.
 */ function loadBundle(e, t) {
    const n = ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)), r = new LoadBundleTask;
    return __PRIVATE_firestoreClientLoadBundle(n, e._databaseId, t, r), r;
}
/**
 * Reads a Firestore {@link Query} from local cache, identified by the given
 * name.
 *
 * The named queries are packaged  into bundles on the server side (along
 * with resulting documents), and loaded to local cache using `loadBundle`. Once
 * in local cache, use this method to extract a {@link Query} by name.
 *
 * @param firestore - The {@link Firestore} instance to read the query from.
 * @param name - The name of the query.
 * @returns A `Promise` that is resolved with the Query or `null`.
 */ function namedQuery(e, t) {
    return __PRIVATE_firestoreClientGetNamedQuery(ensureFirestoreConfigured(e = __PRIVATE_cast(e, Firestore)), t).then((t)=>t ? new Query(e, null, t.query) : null);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Converts Firestore's internal types to the JavaScript types that we expose
 * to the user.
 *
 * @internal
 */ class AbstractUserDataWriter {
    convertValue(e, t = "none") {
        switch(__PRIVATE_typeOrder(e)){
            case 0 /* TypeOrder.NullValue */ :
                return null;
            case 1 /* TypeOrder.BooleanValue */ :
                return e.booleanValue;
            case 2 /* TypeOrder.NumberValue */ :
                return __PRIVATE_normalizeNumber(e.integerValue || e.doubleValue);
            case 3 /* TypeOrder.TimestampValue */ :
                return this.convertTimestamp(e.timestampValue);
            case 4 /* TypeOrder.ServerTimestampValue */ :
                return this.convertServerTimestamp(e, t);
            case 5 /* TypeOrder.StringValue */ :
                return e.stringValue;
            case 6 /* TypeOrder.BlobValue */ :
                return this.convertBytes(__PRIVATE_normalizeByteString(e.bytesValue));
            case 7 /* TypeOrder.RefValue */ :
                return this.convertReference(e.referenceValue);
            case 8 /* TypeOrder.GeoPointValue */ :
                return this.convertGeoPoint(e.geoPointValue);
            case 9 /* TypeOrder.ArrayValue */ :
                return this.convertArray(e.arrayValue, t);
            case 11 /* TypeOrder.ObjectValue */ :
                return this.convertObject(e.mapValue, t);
            case 10 /* TypeOrder.VectorValue */ :
                return this.convertVectorValue(e.mapValue);
            default:
                throw fail(62114, {
                    value: e
                });
        }
    }
    convertObject(e, t) {
        return this.convertObjectMap(e.fields, t);
    }
    /**
     * @internal
     */ convertObjectMap(e, t = "none") {
        const n = {};
        return forEach(e, (e, r)=>{
            n[e] = this.convertValue(r, t);
        }), n;
    }
    /**
     * @internal
     */ convertVectorValue(e) {
        const t = e.fields?.[ct].arrayValue?.values?.map((e)=>__PRIVATE_normalizeNumber(e.doubleValue));
        return new VectorValue(t);
    }
    convertGeoPoint(e) {
        return new GeoPoint(__PRIVATE_normalizeNumber(e.latitude), __PRIVATE_normalizeNumber(e.longitude));
    }
    convertArray(e, t) {
        return (e.values || []).map((e)=>this.convertValue(e, t));
    }
    convertServerTimestamp(e, t) {
        switch(t){
            case "previous":
                const n = __PRIVATE_getPreviousValue(e);
                return null == n ? null : this.convertValue(n, t);
            case "estimate":
                return this.convertTimestamp(__PRIVATE_getLocalWriteTime(e));
            default:
                return null;
        }
    }
    convertTimestamp(e) {
        const t = __PRIVATE_normalizeTimestamp(e);
        return new Timestamp(t.seconds, t.nanos);
    }
    convertDocumentKey(e, t) {
        const n = ResourcePath.fromString(e);
        __PRIVATE_hardAssert(__PRIVATE_isValidResourceName(n), 9688, {
            name: e
        });
        const r = new DatabaseId(n.get(1), n.get(3)), i = new DocumentKey(n.popFirst(5));
        return r.isEqual(t) || // TODO(b/64130202): Somehow support foreign references.
        __PRIVATE_logError(`Document ${i} contains a document reference within a different database (${r.projectId}/${r.database}) which is not supported. It will be treated as a reference in the current database (${t.projectId}/${t.database}) instead.`), i;
    }
}
/**
 * @license
 * Copyright 2024 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_ExpUserDataWriter extends AbstractUserDataWriter {
    constructor(e){
        super(), this.firestore = e;
    }
    convertBytes(e) {
        return new Bytes(e);
    }
    convertReference(e) {
        const t = this.convertDocumentKey(e, this.firestore._databaseId);
        return new DocumentReference(this.firestore, /* converter= */ null, t);
    }
}
/**
 * @license
 * Copyright 2025 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class __PRIVATE_StructuredPipelineOptions {
    constructor(e = {}, t = {}){
        this.sl = e, this._l = t, this.ol = new OptionsUtil({
            indexMode: {
                serverName: "index_mode"
            }
        });
    }
    _readUserData(e) {
        this.proto = this.ol.getOptionsProto(e, this.sl, this._l);
    }
}
class StructuredPipeline {
    constructor(e, t){
        this.pipeline = e, this.options = t;
    }
    _toProto(e) {
        return {
            pipeline: this.pipeline._toProto(e),
            options: this.options.proto
        };
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `QueryTarget` representation of the given query. Returns `null`
 * if the Firestore client associated with the given query has not been
 * initialized or has been terminated.
 *
 * @param query - The Query to convert to proto representation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function _internalQueryToProtoQueryTarget(e) {
    const t = ensureFirestoreConfigured(__PRIVATE_cast(e.firestore, Firestore)), n = t._onlineComponents?.datastore.serializer;
    return void 0 === n ? null : __PRIVATE_toQueryTarget(n, __PRIVATE_queryToTarget(e._query)).yt;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns `RunAggregationQueryRequest` which contains the proto representation
 * of the given aggregation query request. Returns null if the Firestore client
 * associated with the given query has not been initialized or has been
 * terminated.
 *
 * @param query - The Query to convert to proto representation.
 * @param aggregateSpec - The set of aggregations and their aliases.
 */ function _internalAggregationQueryToProtoRunAggregationQueryRequest(e, t) {
    const n = __PRIVATE_mapToArray(t, (e, t)=>new __PRIVATE_AggregateImpl(t, e.aggregateType, e._internalFieldPath)), r = ensureFirestoreConfigured(__PRIVATE_cast(e.firestore, Firestore)), i = r._onlineComponents?.datastore.serializer;
    return void 0 === i ? null : __PRIVATE_toRunAggregationQueryRequest(i, __PRIVATE_queryToAggregateTarget(e._query), n, /* skipAliasing= */ !0).request;
}
/**
 * @internal
 * @private
 *
 * This function is for internal use only.
 *
 * Returns the `ExecutePipelineRequest` representation of the given query.
 * Returns `null` if the Firestore client associated with the given query has
 * not been initialized or has been terminated.
 *
 * @param pipeline - The Pipeline to convert to proto representation.
 */ function _internalPipelineToExecutePipelineRequestProto(e) {
    if (!e._db) throw new FirestoreError(D.FAILED_PRECONDITION, "This pipeline was created without a database and cannot be serialized for execution.");
    const t = __PRIVATE_cast(e._db, Firestore), n = __PRIVATE_newUserDataReader(t).createContext(3 /* UserDataSource.Argument */ , "_internalPipelineToExecutePipelineRequestProto");
    e._readUserData(n);
    const r = /**
 * Returns an initialized and started Datastore for the given Firestore
 * instance. Callers must invoke removeComponents() when the Firestore
 * instance is terminated.
 */ function __PRIVATE_getDatastore$1(e) {
        if (e._terminated) throw new FirestoreError(D.FAILED_PRECONDITION, "The client has already been terminated.");
        if (!Mt.has(e)) {
            __PRIVATE_logDebug(Ot, "Initializing Datastore");
            const t = __PRIVATE_newConnection(__PRIVATE_makeDatabaseInfo(e._databaseId, e.app.options.appId || "", e._persistenceKey, e.app.options.apiKey, e._freezeSettings())), n = __PRIVATE_newSerializer(e._databaseId), r = __PRIVATE_newDatastore(e._authCredentials, e._appCheckCredentials, t, n);
            Mt.set(e, r);
        }
        return Mt.get(e);
    }(t), i = r.serializer;
    if (void 0 === i) return null;
    const s = new StructuredPipeline(e, new __PRIVATE_StructuredPipelineOptions);
    return {
        database: __PRIVATE_getEncodedDatabaseId(i),
        structuredPipeline: s._toProto(i)
    };
}

},{"907a2703743caaff":"cjdyz","@firebase/app":"iO7sa","@firebase/util":"fHqXn","@firebase/webchannel-wrapper/bloom-blob":"hHRTT","@firebase/logger":"kY52V","@firebase/webchannel-wrapper/webchannel-blob":"bHKNb","re2js":"gJUT3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hHRTT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Integer", ()=>Integer);
parcelHelpers.export(exports, "Md5", ()=>Md5);
parcelHelpers.export(exports, "default", ()=>bloom_blob_es2018);
var global = arguments[3];
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var bloom_blob_es2018 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var Integer;
var Md5;
(function() {
    var h; /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    function k(d, a) {
        function c() {}
        c.prototype = a.prototype;
        d.F = a.prototype;
        d.prototype = new c;
        d.prototype.constructor = d;
        d.D = function(f, e, g) {
            for(var b = Array(arguments.length - 2), r = 2; r < arguments.length; r++)b[r - 2] = arguments[r];
            return a.prototype[e].apply(f, b);
        };
    }
    function l() {
        this.blockSize = -1;
    }
    function m() {
        this.blockSize = -1;
        this.blockSize = 64;
        this.g = Array(4);
        this.C = Array(this.blockSize);
        this.o = this.h = 0;
        this.u();
    }
    k(m, l);
    m.prototype.u = function() {
        this.g[0] = 1732584193;
        this.g[1] = 4023233417;
        this.g[2] = 2562383102;
        this.g[3] = 271733878;
        this.o = this.h = 0;
    };
    function n(d, a, c) {
        c || (c = 0);
        const f = Array(16);
        if (typeof a === "string") for(var e = 0; e < 16; ++e)f[e] = a.charCodeAt(c++) | a.charCodeAt(c++) << 8 | a.charCodeAt(c++) << 16 | a.charCodeAt(c++) << 24;
        else for(e = 0; e < 16; ++e)f[e] = a[c++] | a[c++] << 8 | a[c++] << 16 | a[c++] << 24;
        a = d.g[0];
        c = d.g[1];
        e = d.g[2];
        let g = d.g[3], b;
        b = a + (g ^ c & (e ^ g)) + f[0] + 3614090360 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[1] + 3905402710 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[2] + 606105819 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[3] + 3250441966 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[4] + 4118548399 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[5] + 1200080426 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[6] + 2821735955 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[7] + 4249261313 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[8] + 1770035416 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[9] + 2336552879 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[10] + 4294925233 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[11] + 2304563134 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (g ^ c & (e ^ g)) + f[12] + 1804603682 & 4294967295;
        a = c + (b << 7 & 4294967295 | b >>> 25);
        b = g + (e ^ a & (c ^ e)) + f[13] + 4254626195 & 4294967295;
        g = a + (b << 12 & 4294967295 | b >>> 20);
        b = e + (c ^ g & (a ^ c)) + f[14] + 2792965006 & 4294967295;
        e = g + (b << 17 & 4294967295 | b >>> 15);
        b = c + (a ^ e & (g ^ a)) + f[15] + 1236535329 & 4294967295;
        c = e + (b << 22 & 4294967295 | b >>> 10);
        b = a + (e ^ g & (c ^ e)) + f[1] + 4129170786 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[6] + 3225465664 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[11] + 643717713 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[0] + 3921069994 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[5] + 3593408605 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[10] + 38016083 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[15] + 3634488961 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[4] + 3889429448 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[9] + 568446438 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[14] + 3275163606 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[3] + 4107603335 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[8] + 1163531501 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (e ^ g & (c ^ e)) + f[13] + 2850285829 & 4294967295;
        a = c + (b << 5 & 4294967295 | b >>> 27);
        b = g + (c ^ e & (a ^ c)) + f[2] + 4243563512 & 4294967295;
        g = a + (b << 9 & 4294967295 | b >>> 23);
        b = e + (a ^ c & (g ^ a)) + f[7] + 1735328473 & 4294967295;
        e = g + (b << 14 & 4294967295 | b >>> 18);
        b = c + (g ^ a & (e ^ g)) + f[12] + 2368359562 & 4294967295;
        c = e + (b << 20 & 4294967295 | b >>> 12);
        b = a + (c ^ e ^ g) + f[5] + 4294588738 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[8] + 2272392833 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[11] + 1839030562 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[14] + 4259657740 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[1] + 2763975236 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[4] + 1272893353 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[7] + 4139469664 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[10] + 3200236656 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[13] + 681279174 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[0] + 3936430074 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[3] + 3572445317 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[6] + 76029189 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (c ^ e ^ g) + f[9] + 3654602809 & 4294967295;
        a = c + (b << 4 & 4294967295 | b >>> 28);
        b = g + (a ^ c ^ e) + f[12] + 3873151461 & 4294967295;
        g = a + (b << 11 & 4294967295 | b >>> 21);
        b = e + (g ^ a ^ c) + f[15] + 530742520 & 4294967295;
        e = g + (b << 16 & 4294967295 | b >>> 16);
        b = c + (e ^ g ^ a) + f[2] + 3299628645 & 4294967295;
        c = e + (b << 23 & 4294967295 | b >>> 9);
        b = a + (e ^ (c | ~g)) + f[0] + 4096336452 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[7] + 1126891415 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[14] + 2878612391 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[5] + 4237533241 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[12] + 1700485571 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[3] + 2399980690 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[10] + 4293915773 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[1] + 2240044497 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[8] + 1873313359 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[15] + 4264355552 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[6] + 2734768916 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[13] + 1309151649 & 4294967295;
        c = e + (b << 21 & 4294967295 | b >>> 11);
        b = a + (e ^ (c | ~g)) + f[4] + 4149444226 & 4294967295;
        a = c + (b << 6 & 4294967295 | b >>> 26);
        b = g + (c ^ (a | ~e)) + f[11] + 3174756917 & 4294967295;
        g = a + (b << 10 & 4294967295 | b >>> 22);
        b = e + (a ^ (g | ~c)) + f[2] + 718787259 & 4294967295;
        e = g + (b << 15 & 4294967295 | b >>> 17);
        b = c + (g ^ (e | ~a)) + f[9] + 3951481745 & 4294967295;
        d.g[0] = d.g[0] + a & 4294967295;
        d.g[1] = d.g[1] + (e + (b << 21 & 4294967295 | b >>> 11)) & 4294967295;
        d.g[2] = d.g[2] + e & 4294967295;
        d.g[3] = d.g[3] + g & 4294967295;
    }
    m.prototype.v = function(d, a) {
        a === void 0 && (a = d.length);
        const c = a - this.blockSize, f = this.C;
        let e = this.h, g = 0;
        for(; g < a;){
            if (e == 0) for(; g <= c;)n(this, d, g), g += this.blockSize;
            if (typeof d === "string") {
                for(; g < a;)if (f[e++] = d.charCodeAt(g++), e == this.blockSize) {
                    n(this, f);
                    e = 0;
                    break;
                }
            } else for(; g < a;)if (f[e++] = d[g++], e == this.blockSize) {
                n(this, f);
                e = 0;
                break;
            }
        }
        this.h = e;
        this.o += a;
    };
    m.prototype.A = function() {
        var d = Array((this.h < 56 ? this.blockSize : this.blockSize * 2) - this.h);
        d[0] = 128;
        for(var a = 1; a < d.length - 8; ++a)d[a] = 0;
        a = this.o * 8;
        for(var c = d.length - 8; c < d.length; ++c)d[c] = a & 255, a /= 256;
        this.v(d);
        d = Array(16);
        a = 0;
        for(c = 0; c < 4; ++c)for(let f = 0; f < 32; f += 8)d[a++] = this.g[c] >>> f & 255;
        return d;
    };
    function p(d, a) {
        var c = q;
        return Object.prototype.hasOwnProperty.call(c, d) ? c[d] : c[d] = a(d);
    }
    function t(d, a) {
        this.h = a;
        const c = [];
        let f = !0;
        for(let e = d.length - 1; e >= 0; e--){
            const g = d[e] | 0;
            f && g == a || (c[e] = g, f = !1);
        }
        this.g = c;
    }
    var q = {};
    function u(d) {
        return -128 <= d && d < 128 ? p(d, function(a) {
            return new t([
                a | 0
            ], a < 0 ? -1 : 0);
        }) : new t([
            d | 0
        ], d < 0 ? -1 : 0);
    }
    function v(d) {
        if (isNaN(d) || !isFinite(d)) return w;
        if (d < 0) return x(v(-d));
        const a = [];
        let c = 1;
        for(let f = 0; d >= c; f++)a[f] = d / c | 0, c *= 4294967296;
        return new t(a, 0);
    }
    function y(d, a) {
        if (d.length == 0) throw Error("number format error: empty string");
        a = a || 10;
        if (a < 2 || 36 < a) throw Error("radix out of range: " + a);
        if (d.charAt(0) == "-") return x(y(d.substring(1), a));
        if (d.indexOf("-") >= 0) throw Error('number format error: interior "-" character');
        const c = v(Math.pow(a, 8));
        let f = w;
        for(let g = 0; g < d.length; g += 8){
            var e = Math.min(8, d.length - g);
            const b = parseInt(d.substring(g, g + e), a);
            e < 8 ? (e = v(Math.pow(a, e)), f = f.j(e).add(v(b))) : (f = f.j(c), f = f.add(v(b)));
        }
        return f;
    }
    var w = u(0), z = u(1), A = u(16777216);
    h = t.prototype;
    h.m = function() {
        if (B(this)) return -x(this).m();
        let d = 0, a = 1;
        for(let c = 0; c < this.g.length; c++){
            const f = this.i(c);
            d += (f >= 0 ? f : 4294967296 + f) * a;
            a *= 4294967296;
        }
        return d;
    };
    h.toString = function(d) {
        d = d || 10;
        if (d < 2 || 36 < d) throw Error("radix out of range: " + d);
        if (C(this)) return "0";
        if (B(this)) return "-" + x(this).toString(d);
        const a = v(Math.pow(d, 6));
        var c = this;
        let f = "";
        for(;;){
            const e = D(c, a).g;
            c = F(c, e.j(a));
            let g = ((c.g.length > 0 ? c.g[0] : c.h) >>> 0).toString(d);
            c = e;
            if (C(c)) return g + f;
            for(; g.length < 6;)g = "0" + g;
            f = g + f;
        }
    };
    h.i = function(d) {
        return d < 0 ? 0 : d < this.g.length ? this.g[d] : this.h;
    };
    function C(d) {
        if (d.h != 0) return !1;
        for(let a = 0; a < d.g.length; a++)if (d.g[a] != 0) return !1;
        return !0;
    }
    function B(d) {
        return d.h == -1;
    }
    h.l = function(d) {
        d = F(this, d);
        return B(d) ? -1 : C(d) ? 0 : 1;
    };
    function x(d) {
        const a = d.g.length, c = [];
        for(let f = 0; f < a; f++)c[f] = ~d.g[f];
        return new t(c, ~d.h).add(z);
    }
    h.abs = function() {
        return B(this) ? x(this) : this;
    };
    h.add = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        let f = 0;
        for(let e = 0; e <= a; e++){
            let g = f + (this.i(e) & 65535) + (d.i(e) & 65535), b = (g >>> 16) + (this.i(e) >>> 16) + (d.i(e) >>> 16);
            f = b >>> 16;
            g &= 65535;
            b &= 65535;
            c[e] = b << 16 | g;
        }
        return new t(c, c[c.length - 1] & -2147483648 ? -1 : 0);
    };
    function F(d, a) {
        return d.add(x(a));
    }
    h.j = function(d) {
        if (C(this) || C(d)) return w;
        if (B(this)) return B(d) ? x(this).j(x(d)) : x(x(this).j(d));
        if (B(d)) return x(this.j(x(d)));
        if (this.l(A) < 0 && d.l(A) < 0) return v(this.m() * d.m());
        const a = this.g.length + d.g.length, c = [];
        for(var f = 0; f < 2 * a; f++)c[f] = 0;
        for(f = 0; f < this.g.length; f++)for(let e = 0; e < d.g.length; e++){
            const g = this.i(f) >>> 16, b = this.i(f) & 65535, r = d.i(e) >>> 16, E = d.i(e) & 65535;
            c[2 * f + 2 * e] += b * E;
            G(c, 2 * f + 2 * e);
            c[2 * f + 2 * e + 1] += g * E;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 1] += b * r;
            G(c, 2 * f + 2 * e + 1);
            c[2 * f + 2 * e + 2] += g * r;
            G(c, 2 * f + 2 * e + 2);
        }
        for(d = 0; d < a; d++)c[d] = c[2 * d + 1] << 16 | c[2 * d];
        for(d = a; d < 2 * a; d++)c[d] = 0;
        return new t(c, 0);
    };
    function G(d, a) {
        for(; (d[a] & 65535) != d[a];)d[a + 1] += d[a] >>> 16, d[a] &= 65535, a++;
    }
    function H(d, a) {
        this.g = d;
        this.h = a;
    }
    function D(d, a) {
        if (C(a)) throw Error("division by zero");
        if (C(d)) return new H(w, w);
        if (B(d)) return a = D(x(d), a), new H(x(a.g), x(a.h));
        if (B(a)) return a = D(d, x(a)), new H(x(a.g), a.h);
        if (d.g.length > 30) {
            if (B(d) || B(a)) throw Error("slowDivide_ only works with positive integers.");
            for(var c = z, f = a; f.l(d) <= 0;)c = I(c), f = I(f);
            var e = J(c, 1), g = J(f, 1);
            f = J(f, 2);
            for(c = J(c, 2); !C(f);){
                var b = g.add(f);
                b.l(d) <= 0 && (e = e.add(c), g = b);
                f = J(f, 1);
                c = J(c, 1);
            }
            a = F(d, e.j(a));
            return new H(e, a);
        }
        for(e = w; d.l(a) >= 0;){
            c = Math.max(1, Math.floor(d.m() / a.m()));
            f = Math.ceil(Math.log(c) / Math.LN2);
            f = f <= 48 ? 1 : Math.pow(2, f - 48);
            g = v(c);
            for(b = g.j(a); B(b) || b.l(d) > 0;)c -= f, g = v(c), b = g.j(a);
            C(g) && (g = z);
            e = e.add(g);
            d = F(d, b);
        }
        return new H(e, d);
    }
    h.B = function(d) {
        return D(this, d).h;
    };
    h.and = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) & d.i(f);
        return new t(c, this.h & d.h);
    };
    h.or = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) | d.i(f);
        return new t(c, this.h | d.h);
    };
    h.xor = function(d) {
        const a = Math.max(this.g.length, d.g.length), c = [];
        for(let f = 0; f < a; f++)c[f] = this.i(f) ^ d.i(f);
        return new t(c, this.h ^ d.h);
    };
    function I(d) {
        const a = d.g.length + 1, c = [];
        for(let f = 0; f < a; f++)c[f] = d.i(f) << 1 | d.i(f - 1) >>> 31;
        return new t(c, d.h);
    }
    function J(d, a) {
        const c = a >> 5;
        a %= 32;
        const f = d.g.length - c, e = [];
        for(let g = 0; g < f; g++)e[g] = a > 0 ? d.i(g + c) >>> a | d.i(g + c + 1) << 32 - a : d.i(g + c);
        return new t(e, d.h);
    }
    m.prototype.digest = m.prototype.A;
    m.prototype.reset = m.prototype.u;
    m.prototype.update = m.prototype.v;
    Md5 = bloom_blob_es2018.Md5 = m;
    t.prototype.add = t.prototype.add;
    t.prototype.multiply = t.prototype.j;
    t.prototype.modulo = t.prototype.B;
    t.prototype.compare = t.prototype.l;
    t.prototype.toNumber = t.prototype.m;
    t.prototype.toString = t.prototype.toString;
    t.prototype.getBits = t.prototype.i;
    t.fromNumber = v;
    t.fromString = y;
    Integer = bloom_blob_es2018.Integer = t;
}).apply(typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bHKNb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ErrorCode", ()=>ErrorCode);
parcelHelpers.export(exports, "Event", ()=>Event);
parcelHelpers.export(exports, "EventType", ()=>EventType);
parcelHelpers.export(exports, "FetchXmlHttpFactory", ()=>FetchXmlHttpFactory);
parcelHelpers.export(exports, "Stat", ()=>Stat);
parcelHelpers.export(exports, "WebChannel", ()=>WebChannel);
parcelHelpers.export(exports, "XhrIo", ()=>XhrIo);
parcelHelpers.export(exports, "createWebChannelTransport", ()=>createWebChannelTransport);
parcelHelpers.export(exports, "default", ()=>webchannel_blob_es2018);
parcelHelpers.export(exports, "getStatEventTarget", ()=>getStatEventTarget);
var global = arguments[3];
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
var webchannel_blob_es2018 = {};
/** @license
Copyright The Closure Library Authors.
SPDX-License-Identifier: Apache-2.0
*/ var XhrIo;
var FetchXmlHttpFactory;
var WebChannel;
var EventType;
var ErrorCode;
var Stat;
var Event;
var getStatEventTarget;
var createWebChannelTransport;
(function() {
    var h, aa = Object.defineProperty;
    function ba(a) {
        a = [
            "object" == typeof globalThis && globalThis,
            a,
            "object" == typeof window && window,
            "object" == typeof self && self,
            "object" == typeof commonjsGlobal && commonjsGlobal
        ];
        for(var b = 0; b < a.length; ++b){
            var c = a[b];
            if (c && c.Math == Math) return c;
        }
        throw Error("Cannot find global object");
    }
    var ca = ba(this);
    function da(a, b) {
        if (b) a: {
            var c = ca;
            a = a.split(".");
            for(var d = 0; d < a.length - 1; d++){
                var e = a[d];
                if (!(e in c)) break a;
                c = c[e];
            }
            a = a[a.length - 1];
            d = c[a];
            b = b(d);
            b != d && b != null && aa(c, a, {
                configurable: !0,
                writable: !0,
                value: b
            });
        }
    }
    da("Symbol.dispose", function(a) {
        return a ? a : Symbol("Symbol.dispose");
    });
    da("Array.prototype.values", function(a) {
        return a ? a : function() {
            return this[Symbol.iterator]();
        };
    });
    da("Object.entries", function(a) {
        return a ? a : function(b) {
            var c = [], d;
            for(d in b)Object.prototype.hasOwnProperty.call(b, d) && c.push([
                d,
                b[d]
            ]);
            return c;
        };
    }); /** @license

 Copyright The Closure Library Authors.
 SPDX-License-Identifier: Apache-2.0
*/ 
    var ea = ea || {}, l = this || self;
    function n(a) {
        var b = typeof a;
        return b == "object" && a != null || b == "function";
    }
    function fa(a, b, c) {
        return a.call.apply(a.bind, arguments);
    }
    function p(a, b, c) {
        p = fa;
        return p.apply(null, arguments);
    }
    function ha(a, b) {
        var c = Array.prototype.slice.call(arguments, 1);
        return function() {
            var d = c.slice();
            d.push.apply(d, arguments);
            return a.apply(this, d);
        };
    }
    function t(a, b) {
        function c() {}
        c.prototype = b.prototype;
        a.Z = b.prototype;
        a.prototype = new c;
        a.prototype.constructor = a;
        a.Ob = function(d, e, f) {
            for(var g = Array(arguments.length - 2), k = 2; k < arguments.length; k++)g[k - 2] = arguments[k];
            return b.prototype[e].apply(d, g);
        };
    }
    var ia = typeof AsyncContext !== "undefined" && typeof AsyncContext.Snapshot === "function" ? (a)=>a && AsyncContext.Snapshot.wrap(a) : (a)=>a;
    function ja(a) {
        const b = a.length;
        if (b > 0) {
            const c = Array(b);
            for(let d = 0; d < b; d++)c[d] = a[d];
            return c;
        }
        return [];
    }
    function ka(a, b) {
        for(let d = 1; d < arguments.length; d++){
            const e = arguments[d];
            var c = typeof e;
            c = c != "object" ? c : e ? Array.isArray(e) ? "array" : c : "null";
            if (c == "array" || c == "object" && typeof e.length == "number") {
                c = a.length || 0;
                const f = e.length || 0;
                a.length = c + f;
                for(let g = 0; g < f; g++)a[c + g] = e[g];
            } else a.push(e);
        }
    }
    class la {
        constructor(a, b){
            this.i = a;
            this.j = b;
            this.h = 0;
            this.g = null;
        }
        get() {
            let a;
            this.h > 0 ? (this.h--, a = this.g, this.g = a.next, a.next = null) : a = this.i();
            return a;
        }
    }
    function ma(a) {
        l.setTimeout(()=>{
            throw a;
        }, 0);
    }
    function na() {
        var a = oa;
        let b = null;
        a.g && (b = a.g, a.g = a.g.next, a.g || (a.h = null), b.next = null);
        return b;
    }
    class pa {
        constructor(){
            this.h = this.g = null;
        }
        add(a, b) {
            const c = qa.get();
            c.set(a, b);
            this.h ? this.h.next = c : this.g = c;
            this.h = c;
        }
    }
    var qa = new la(()=>new ra, (a)=>a.reset());
    class ra {
        constructor(){
            this.next = this.g = this.h = null;
        }
        set(a, b) {
            this.h = a;
            this.g = b;
            this.next = null;
        }
        reset() {
            this.next = this.g = this.h = null;
        }
    }
    let u, v = !1, oa = new pa, ta = ()=>{
        const a = Promise.resolve(void 0);
        u = ()=>{
            a.then(sa);
        };
    };
    function sa() {
        for(var a; a = na();){
            try {
                a.h.call(a.g);
            } catch (c) {
                ma(c);
            }
            var b = qa;
            b.j(a);
            b.h < 100 && (b.h++, a.next = b.g, b.g = a);
        }
        v = !1;
    }
    function w() {
        this.u = this.u;
        this.C = this.C;
    }
    w.prototype.u = !1;
    w.prototype.dispose = function() {
        this.u || (this.u = !0, this.N());
    };
    w.prototype[Symbol.dispose] = function() {
        this.dispose();
    };
    w.prototype.N = function() {
        if (this.C) for(; this.C.length;)this.C.shift()();
    };
    function x(a, b) {
        this.type = a;
        this.g = this.target = b;
        this.defaultPrevented = !1;
    }
    x.prototype.h = function() {
        this.defaultPrevented = !0;
    };
    var ua = function() {
        if (!l.addEventListener || !Object.defineProperty) return !1;
        var a = !1, b = Object.defineProperty({}, "passive", {
            get: function() {
                a = !0;
            }
        });
        try {
            const c = ()=>{};
            l.addEventListener("test", c, b);
            l.removeEventListener("test", c, b);
        } catch (c) {}
        return a;
    }();
    function y(a) {
        return /^[\s\xa0]*$/.test(a);
    }
    function z(a, b) {
        x.call(this, a ? a.type : "");
        this.relatedTarget = this.g = this.target = null;
        this.button = this.screenY = this.screenX = this.clientY = this.clientX = 0;
        this.key = "";
        this.metaKey = this.shiftKey = this.altKey = this.ctrlKey = !1;
        this.state = null;
        this.pointerId = 0;
        this.pointerType = "";
        this.i = null;
        a && this.init(a, b);
    }
    t(z, x);
    z.prototype.init = function(a, b) {
        const c = this.type = a.type, d = a.changedTouches && a.changedTouches.length ? a.changedTouches[0] : null;
        this.target = a.target || a.srcElement;
        this.g = b;
        b = a.relatedTarget;
        b || (c == "mouseover" ? b = a.fromElement : c == "mouseout" && (b = a.toElement));
        this.relatedTarget = b;
        d ? (this.clientX = d.clientX !== void 0 ? d.clientX : d.pageX, this.clientY = d.clientY !== void 0 ? d.clientY : d.pageY, this.screenX = d.screenX || 0, this.screenY = d.screenY || 0) : (this.clientX = a.clientX !== void 0 ? a.clientX : a.pageX, this.clientY = a.clientY !== void 0 ? a.clientY : a.pageY, this.screenX = a.screenX || 0, this.screenY = a.screenY || 0);
        this.button = a.button;
        this.key = a.key || "";
        this.ctrlKey = a.ctrlKey;
        this.altKey = a.altKey;
        this.shiftKey = a.shiftKey;
        this.metaKey = a.metaKey;
        this.pointerId = a.pointerId || 0;
        this.pointerType = a.pointerType;
        this.state = a.state;
        this.i = a;
        a.defaultPrevented && z.Z.h.call(this);
    };
    z.prototype.h = function() {
        z.Z.h.call(this);
        const a = this.i;
        a.preventDefault ? a.preventDefault() : a.returnValue = !1;
    };
    var B = "closure_listenable_" + (Math.random() * 1E6 | 0);
    var va = 0;
    function wa(a, b, c, d, e) {
        this.listener = a;
        this.proxy = null;
        this.src = b;
        this.type = c;
        this.capture = !!d;
        this.ha = e;
        this.key = ++va;
        this.da = this.fa = !1;
    }
    function xa(a) {
        a.da = !0;
        a.listener = null;
        a.proxy = null;
        a.src = null;
        a.ha = null;
    }
    function ya(a, b, c) {
        for(const d in a)b.call(c, a[d], d, a);
    }
    function Aa(a, b) {
        for(const c in a)b.call(void 0, a[c], c, a);
    }
    function Ba(a) {
        const b = {};
        for(const c in a)b[c] = a[c];
        return b;
    }
    const Ca = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
    function Da(a, b) {
        let c, d;
        for(let e = 1; e < arguments.length; e++){
            d = arguments[e];
            for(c in d)a[c] = d[c];
            for(let f = 0; f < Ca.length; f++)c = Ca[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c]);
        }
    }
    function Ea(a) {
        this.src = a;
        this.g = {};
        this.h = 0;
    }
    Ea.prototype.add = function(a, b, c, d, e) {
        const f = a.toString();
        a = this.g[f];
        a || (a = this.g[f] = [], this.h++);
        const g = Fa(a, b, d, e);
        g > -1 ? (b = a[g], c || (b.fa = !1)) : (b = new wa(b, this.src, f, !!d, e), b.fa = c, a.push(b));
        return b;
    };
    function Ga(a, b) {
        const c = b.type;
        if (c in a.g) {
            var d = a.g[c], e = Array.prototype.indexOf.call(d, b, void 0), f;
            (f = e >= 0) && Array.prototype.splice.call(d, e, 1);
            f && (xa(b), a.g[c].length == 0 && (delete a.g[c], a.h--));
        }
    }
    function Fa(a, b, c, d) {
        for(let e = 0; e < a.length; ++e){
            const f = a[e];
            if (!f.da && f.listener == b && f.capture == !!c && f.ha == d) return e;
        }
        return -1;
    }
    var Ha = "closure_lm_" + (Math.random() * 1E6 | 0), Ia = {};
    function Ka(a, b, c, d, e) {
        if (d && d.once) return La(a, b, c, d, e);
        if (Array.isArray(b)) {
            for(let f = 0; f < b.length; f++)Ka(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.J(b, c, n(d) ? !!d.capture : !!d, e) : Na(a, b, c, !1, d, e);
    }
    function Na(a, b, c, d, e, f) {
        if (!b) throw Error("Invalid event type");
        const g = n(e) ? !!e.capture : !!e;
        let k = Oa(a);
        k || (a[Ha] = k = new Ea(a));
        c = k.add(b, c, d, g, f);
        if (c.proxy) return c;
        d = Pa();
        c.proxy = d;
        d.src = a;
        d.listener = c;
        if (a.addEventListener) ua || (e = g), e === void 0 && (e = !1), a.addEventListener(b.toString(), d, e);
        else if (a.attachEvent) a.attachEvent(Qa(b.toString()), d);
        else if (a.addListener && a.removeListener) a.addListener(d);
        else throw Error("addEventListener and attachEvent are unavailable.");
        return c;
    }
    function Pa() {
        function a(c) {
            return b.call(a.src, a.listener, c);
        }
        const b = Ra;
        return a;
    }
    function La(a, b, c, d, e) {
        if (Array.isArray(b)) {
            for(let f = 0; f < b.length; f++)La(a, b[f], c, d, e);
            return null;
        }
        c = Ma(c);
        return a && a[B] ? a.K(b, c, n(d) ? !!d.capture : !!d, e) : Na(a, b, c, !0, d, e);
    }
    function Sa(a, b, c, d, e) {
        if (Array.isArray(b)) for(var f = 0; f < b.length; f++)Sa(a, b[f], c, d, e);
        else (d = n(d) ? !!d.capture : !!d, c = Ma(c), a && a[B]) ? (a = a.i, f = String(b).toString(), f in a.g && (b = a.g[f], c = Fa(b, c, d, e), c > -1 && (xa(b[c]), Array.prototype.splice.call(b, c, 1), b.length == 0 && (delete a.g[f], a.h--)))) : a && (a = Oa(a)) && (b = a.g[b.toString()], a = -1, b && (a = Fa(b, c, d, e)), (c = a > -1 ? b[a] : null) && Ta(c));
    }
    function Ta(a) {
        if (typeof a !== "number" && a && !a.da) {
            var b = a.src;
            if (b && b[B]) Ga(b.i, a);
            else {
                var c = a.type, d = a.proxy;
                b.removeEventListener ? b.removeEventListener(c, d, a.capture) : b.detachEvent ? b.detachEvent(Qa(c), d) : b.addListener && b.removeListener && b.removeListener(d);
                (c = Oa(b)) ? (Ga(c, a), c.h == 0 && (c.src = null, b[Ha] = null)) : xa(a);
            }
        }
    }
    function Qa(a) {
        return a in Ia ? Ia[a] : Ia[a] = "on" + a;
    }
    function Ra(a, b) {
        if (a.da) a = !0;
        else {
            b = new z(b, this);
            const c = a.listener, d = a.ha || a.src;
            a.fa && Ta(a);
            a = c.call(d, b);
        }
        return a;
    }
    function Oa(a) {
        a = a[Ha];
        return a instanceof Ea ? a : null;
    }
    var Ua = "__closure_events_fn_" + (Math.random() * 1E9 >>> 0);
    function Ma(a) {
        if (typeof a === "function") return a;
        a[Ua] || (a[Ua] = function(b) {
            return a.handleEvent(b);
        });
        return a[Ua];
    }
    function C() {
        w.call(this);
        this.i = new Ea(this);
        this.M = this;
        this.G = null;
    }
    t(C, w);
    C.prototype[B] = !0;
    C.prototype.removeEventListener = function(a, b, c, d) {
        Sa(this, a, b, c, d);
    };
    function D(a, b) {
        var c, d = a.G;
        if (d) for(c = []; d; d = d.G)c.push(d);
        a = a.M;
        d = b.type || b;
        if (typeof b === "string") b = new x(b, a);
        else if (b instanceof x) b.target = b.target || a;
        else {
            var e = b;
            b = new x(d, a);
            Da(b, e);
        }
        e = !0;
        let f, g;
        if (c) for(g = c.length - 1; g >= 0; g--)f = b.g = c[g], e = Va(f, d, !0, b) && e;
        f = b.g = a;
        e = Va(f, d, !0, b) && e;
        e = Va(f, d, !1, b) && e;
        if (c) for(g = 0; g < c.length; g++)f = b.g = c[g], e = Va(f, d, !1, b) && e;
    }
    C.prototype.N = function() {
        C.Z.N.call(this);
        if (this.i) {
            var a = this.i;
            for(const c in a.g){
                const d = a.g[c];
                for(let e = 0; e < d.length; e++)xa(d[e]);
                delete a.g[c];
                a.h--;
            }
        }
        this.G = null;
    };
    C.prototype.J = function(a, b, c, d) {
        return this.i.add(String(a), b, !1, c, d);
    };
    C.prototype.K = function(a, b, c, d) {
        return this.i.add(String(a), b, !0, c, d);
    };
    function Va(a, b, c, d) {
        b = a.i.g[String(b)];
        if (!b) return !0;
        b = b.concat();
        let e = !0;
        for(let f = 0; f < b.length; ++f){
            const g = b[f];
            if (g && !g.da && g.capture == c) {
                const k = g.listener, q = g.ha || g.src;
                g.fa && Ga(a.i, g);
                e = k.call(q, d) !== !1 && e;
            }
        }
        return e && !d.defaultPrevented;
    }
    function Wa(a, b) {
        if (typeof a !== "function") {
            if (a && typeof a.handleEvent == "function") a = p(a.handleEvent, a);
            else throw Error("Invalid listener argument");
        }
        return Number(b) > 2147483647 ? -1 : l.setTimeout(a, b || 0);
    }
    function Xa(a) {
        a.g = Wa(()=>{
            a.g = null;
            a.i && (a.i = !1, Xa(a));
        }, a.l);
        const b = a.h;
        a.h = null;
        a.m.apply(null, b);
    }
    class Ya extends w {
        constructor(a, b){
            super();
            this.m = a;
            this.l = b;
            this.h = null;
            this.i = !1;
            this.g = null;
        }
        j(a) {
            this.h = arguments;
            this.g ? this.i = !0 : Xa(this);
        }
        N() {
            super.N();
            this.g && (l.clearTimeout(this.g), this.g = null, this.i = !1, this.h = null);
        }
    }
    function E(a) {
        w.call(this);
        this.h = a;
        this.g = {};
    }
    t(E, w);
    var Za = [];
    function $a(a) {
        ya(a.g, function(b, c) {
            this.g.hasOwnProperty(c) && Ta(b);
        }, a);
        a.g = {};
    }
    E.prototype.N = function() {
        E.Z.N.call(this);
        $a(this);
    };
    E.prototype.handleEvent = function() {
        throw Error("EventHandler.handleEvent not implemented");
    };
    var ab = l.JSON.stringify;
    var cb = l.JSON.parse;
    var db = class {
        stringify(a) {
            return l.JSON.stringify(a, void 0);
        }
        parse(a) {
            return l.JSON.parse(a, void 0);
        }
    };
    function eb() {}
    function fb() {}
    var H = {
        OPEN: "a",
        hb: "b",
        ERROR: "c",
        tb: "d"
    };
    function gb() {
        x.call(this, "d");
    }
    t(gb, x);
    function hb() {
        x.call(this, "c");
    }
    t(hb, x);
    var I = {}, ib = null;
    function jb() {
        return ib = ib || new C;
    }
    I.Ia = "serverreachability";
    function kb(a) {
        x.call(this, I.Ia, a);
    }
    t(kb, x);
    function lb(a) {
        const b = jb();
        D(b, new kb(b));
    }
    I.STAT_EVENT = "statevent";
    function mb(a, b) {
        x.call(this, I.STAT_EVENT, a);
        this.stat = b;
    }
    t(mb, x);
    function J(a) {
        const b = jb();
        D(b, new mb(b, a));
    }
    I.Ja = "timingevent";
    function nb(a, b) {
        x.call(this, I.Ja, a);
        this.size = b;
    }
    t(nb, x);
    function ob(a, b) {
        if (typeof a !== "function") throw Error("Fn must not be null and must be a function");
        return l.setTimeout(function() {
            a();
        }, b);
    }
    function pb() {
        this.g = !0;
    }
    pb.prototype.ua = function() {
        this.g = !1;
    };
    function qb(a, b, c, d, e, f) {
        a.info(function() {
            if (a.g) {
                if (f) {
                    var g = "";
                    var k = f.split("&");
                    for(let m = 0; m < k.length; m++){
                        var q = k[m].split("=");
                        if (q.length > 1) {
                            const r = q[0];
                            q = q[1];
                            const A = r.split("_");
                            g = A.length >= 2 && A[1] == "type" ? g + (r + "=" + q + "&") : g + (r + "=redacted&");
                        }
                    }
                } else g = null;
            } else g = f;
            return "XMLHTTP REQ (" + d + ") [attempt " + e + "]: " + b + "\n" + c + "\n" + g;
        });
    }
    function rb(a, b, c, d, e, f, g) {
        a.info(function() {
            return "XMLHTTP RESP (" + d + ") [ attempt " + e + "]: " + b + "\n" + c + "\n" + f + " " + g;
        });
    }
    function K(a, b, c, d) {
        a.info(function() {
            return "XMLHTTP TEXT (" + b + "): " + sb(a, c) + (d ? " " + d : "");
        });
    }
    function tb(a, b) {
        a.info(function() {
            return "TIMEOUT: " + b;
        });
    }
    pb.prototype.info = function() {};
    function sb(a, b) {
        if (!a.g) return b;
        if (!b) return null;
        try {
            const f = JSON.parse(b);
            if (f) {
                for(a = 0; a < f.length; a++)if (Array.isArray(f[a])) {
                    var c = f[a];
                    if (!(c.length < 2)) {
                        var d = c[1];
                        if (Array.isArray(d) && !(d.length < 1)) {
                            var e = d[0];
                            if (e != "noop" && e != "stop" && e != "close") for(let g = 1; g < d.length; g++)d[g] = "";
                        }
                    }
                }
            }
            return ab(f);
        } catch (f) {
            return b;
        }
    }
    var ub = {
        NO_ERROR: 0,
        cb: 1,
        qb: 2,
        pb: 3,
        kb: 4,
        ob: 5,
        rb: 6,
        Ga: 7,
        TIMEOUT: 8,
        ub: 9
    };
    var vb = {
        ib: "complete",
        Fb: "success",
        ERROR: "error",
        Ga: "abort",
        xb: "ready",
        yb: "readystatechange",
        TIMEOUT: "timeout",
        sb: "incrementaldata",
        wb: "progress",
        lb: "downloadprogress",
        Nb: "uploadprogress"
    };
    var wb;
    function xb() {}
    t(xb, eb);
    xb.prototype.g = function() {
        return new XMLHttpRequest;
    };
    wb = new xb;
    function L(a) {
        return encodeURIComponent(String(a));
    }
    function yb(a) {
        var b = 1;
        a = a.split(":");
        const c = [];
        for(; b > 0 && a.length;)c.push(a.shift()), b--;
        a.length && c.push(a.join(":"));
        return c;
    }
    function N(a, b, c, d) {
        this.j = a;
        this.i = b;
        this.l = c;
        this.S = d || 1;
        this.V = new E(this);
        this.H = 45E3;
        this.J = null;
        this.o = !1;
        this.u = this.B = this.A = this.M = this.F = this.T = this.D = null;
        this.G = [];
        this.g = null;
        this.C = 0;
        this.m = this.v = null;
        this.X = -1;
        this.K = !1;
        this.P = 0;
        this.O = null;
        this.W = this.L = this.U = this.R = !1;
        this.h = new zb;
    }
    function zb() {
        this.i = null;
        this.g = "";
        this.h = !1;
    }
    var Ab = {}, Bb = {};
    function Cb(a, b, c) {
        a.M = 1;
        a.A = Db(O(b));
        a.u = c;
        a.R = !0;
        Eb(a, null);
    }
    function Eb(a, b) {
        a.F = Date.now();
        Fb(a);
        a.B = O(a.A);
        var c = a.B, d = a.S;
        Array.isArray(d) || (d = [
            String(d)
        ]);
        Gb(c.i, "t", d);
        a.C = 0;
        c = a.j.L;
        a.h = new zb;
        a.g = Hb(a.j, c ? b : null, !a.u);
        a.P > 0 && (a.O = new Ya(p(a.Y, a, a.g), a.P));
        b = a.V;
        c = a.g;
        d = a.ba;
        var e = "readystatechange";
        Array.isArray(e) || (e && (Za[0] = e.toString()), e = Za);
        for(let f = 0; f < e.length; f++){
            const g = Ka(c, e[f], d || b.handleEvent, !1, b.h || b);
            if (!g) break;
            b.g[g.key] = g;
        }
        b = a.J ? Ba(a.J) : {};
        a.u ? (a.v || (a.v = "POST"), b["Content-Type"] = "application/x-www-form-urlencoded", a.g.ea(a.B, a.v, a.u, b)) : (a.v = "GET", a.g.ea(a.B, a.v, null, b));
        lb();
        qb(a.i, a.v, a.B, a.l, a.S, a.u);
    }
    N.prototype.ba = function(a) {
        a = a.target;
        const b = this.O;
        b && P(a) == 3 ? b.j() : this.Y(a);
    };
    N.prototype.Y = function(a) {
        try {
            if (a == this.g) a: {
                const k = P(this.g), q = this.g.ya(), m = this.g.ca();
                if (!(k < 3) && (k != 3 || this.g && (this.h.h || this.g.la() || Ib(this.g)))) {
                    this.K || k != 4 || q == 7 || (q == 8 || m <= 0 ? lb(3) : lb(2));
                    Jb(this);
                    var b = this.g.ca();
                    this.X = b;
                    var c = Kb(this);
                    this.o = b == 200;
                    rb(this.i, this.v, this.B, this.l, this.S, k, b);
                    if (this.o) {
                        if (this.U && !this.L) {
                            b: {
                                if (this.g) {
                                    var d, e = this.g;
                                    if ((d = e.g ? e.g.getResponseHeader("X-HTTP-Initial-Response") : null) && !y(d)) {
                                        var f = d;
                                        break b;
                                    }
                                }
                                f = null;
                            }
                            if (a = f) K(this.i, this.l, a, "Initial handshake response via X-HTTP-Initial-Response"), this.L = !0, Lb(this, a);
                            else {
                                this.o = !1;
                                this.m = 3;
                                J(12);
                                Q(this);
                                Mb(this);
                                break a;
                            }
                        }
                        if (this.R) {
                            a = !0;
                            let r;
                            for(; !this.K && this.C < c.length;)if (r = Nb(this, c), r == Bb) {
                                k == 4 && (this.m = 4, J(14), a = !1);
                                K(this.i, this.l, null, "[Incomplete Response]");
                                break;
                            } else if (r == Ab) {
                                this.m = 4;
                                J(15);
                                K(this.i, this.l, c, "[Invalid Chunk]");
                                a = !1;
                                break;
                            } else K(this.i, this.l, r, null), Lb(this, r);
                            Ob(this) && this.C != 0 && (this.h.g = this.h.g.slice(this.C), this.C = 0);
                            k != 4 || c.length != 0 || this.h.h || (this.m = 1, J(16), a = !1);
                            this.o = this.o && a;
                            if (!a) K(this.i, this.l, c, "[Invalid Chunked Response]"), Q(this), Mb(this);
                            else if (c.length > 0 && !this.W) {
                                this.W = !0;
                                var g = this.j;
                                g.g == this && g.aa && !g.P && (g.j.info("Great, no buffering proxy detected. Bytes received: " + c.length), Pb(g), g.P = !0, J(11));
                            }
                        } else K(this.i, this.l, c, null), Lb(this, c);
                        k == 4 && Q(this);
                        this.o && !this.K && (k == 4 ? Qb(this.j, this) : (this.o = !1, Fb(this)));
                    } else Rb(this.g), b == 400 && c.indexOf("Unknown SID") > 0 ? (this.m = 3, J(12)) : (this.m = 0, J(13)), Q(this), Mb(this);
                }
            }
        } catch (k) {} finally{}
    };
    function Kb(a) {
        if (!Ob(a)) return a.g.la();
        const b = Ib(a.g);
        if (b === "") return "";
        let c = "";
        const d = b.length, e = P(a.g) == 4;
        if (!a.h.i) {
            if (typeof TextDecoder === "undefined") return Q(a), Mb(a), "";
            a.h.i = new l.TextDecoder;
        }
        for(let f = 0; f < d; f++)a.h.h = !0, c += a.h.i.decode(b[f], {
            stream: !(e && f == d - 1)
        });
        b.length = 0;
        a.h.g += c;
        a.C = 0;
        return a.h.g;
    }
    function Ob(a) {
        return a.g ? a.v == "GET" && a.M != 2 && a.j.Aa : !1;
    }
    function Nb(a, b) {
        var c = a.C, d = b.indexOf("\n", c);
        if (d == -1) return Bb;
        c = Number(b.substring(c, d));
        if (isNaN(c)) return Ab;
        d += 1;
        if (d + c > b.length) return Bb;
        b = b.slice(d, d + c);
        a.C = d + c;
        return b;
    }
    N.prototype.cancel = function() {
        this.K = !0;
        Q(this);
    };
    function Fb(a) {
        a.T = Date.now() + a.H;
        Sb(a, a.H);
    }
    function Sb(a, b) {
        if (a.D != null) throw Error("WatchDog timer not null");
        a.D = ob(p(a.aa, a), b);
    }
    function Jb(a) {
        a.D && (l.clearTimeout(a.D), a.D = null);
    }
    N.prototype.aa = function() {
        this.D = null;
        const a = Date.now();
        a - this.T >= 0 ? (tb(this.i, this.B), this.M != 2 && (lb(), J(17)), Q(this), this.m = 2, Mb(this)) : Sb(this, this.T - a);
    };
    function Mb(a) {
        a.j.I == 0 || a.K || Qb(a.j, a);
    }
    function Q(a) {
        Jb(a);
        var b = a.O;
        b && typeof b.dispose == "function" && b.dispose();
        a.O = null;
        $a(a.V);
        a.g && (b = a.g, a.g = null, b.abort(), b.dispose());
    }
    function Lb(a, b) {
        try {
            var c = a.j;
            if (c.I != 0 && (c.g == a || Tb(c.h, a))) {
                if (!a.L && Tb(c.h, a) && c.I == 3) {
                    try {
                        var d = c.Ba.g.parse(b);
                    } catch (m) {
                        d = null;
                    }
                    if (Array.isArray(d) && d.length == 3) {
                        var e = d;
                        if (e[0] == 0) {
                            a: if (!c.v) {
                                if (c.g) {
                                    if (c.g.F + 3E3 < a.F) Ub(c), Vb(c);
                                    else break a;
                                }
                                Wb(c);
                                J(18);
                            }
                        } else c.xa = e[1], 0 < c.xa - c.K && e[2] < 37500 && c.F && c.A == 0 && !c.C && (c.C = ob(p(c.Va, c), 6E3));
                        Xb(c.h) <= 1 && c.ta && (c.ta = void 0);
                    } else R(c, 11);
                } else if ((a.L || c.g == a) && Ub(c), !y(b)) for(e = c.Ba.g.parse(b), b = 0; b < e.length; b++){
                    let m = e[b];
                    const r = m[0];
                    if (!(r <= c.K)) {
                        if (c.K = r, m = m[1], c.I == 2) {
                            if (m[0] == "c") {
                                c.M = m[1];
                                c.ba = m[2];
                                const A = m[3];
                                A != null && (c.ka = A, c.j.info("VER=" + c.ka));
                                const M = m[4];
                                M != null && (c.za = M, c.j.info("SVER=" + c.za));
                                const F = m[5];
                                F != null && typeof F === "number" && F > 0 && (d = 1.5 * F, c.O = d, c.j.info("backChannelRequestTimeoutMs_=" + d));
                                d = c;
                                const G = a.g;
                                if (G) {
                                    const za = G.g ? G.g.getResponseHeader("X-Client-Wire-Protocol") : null;
                                    if (za) {
                                        var f = d.h;
                                        f.g || za.indexOf("spdy") == -1 && za.indexOf("quic") == -1 && za.indexOf("h2") == -1 || (f.j = f.l, f.g = new Set, f.h && (Yb(f, f.h), f.h = null));
                                    }
                                    if (d.G) {
                                        const bb = G.g ? G.g.getResponseHeader("X-HTTP-Session-Id") : null;
                                        bb && (d.wa = bb, S(d.J, d.G, bb));
                                    }
                                }
                                c.I = 3;
                                c.l && c.l.ra();
                                c.aa && (c.T = Date.now() - a.F, c.j.info("Handshake RTT: " + c.T + "ms"));
                                d = c;
                                var g = a;
                                d.na = Zb(d, d.L ? d.ba : null, d.W);
                                if (g.L) {
                                    $b(d.h, g);
                                    var k = g, q = d.O;
                                    q && (k.H = q);
                                    k.D && (Jb(k), Fb(k));
                                    d.g = g;
                                } else ac(d);
                                c.i.length > 0 && bc(c);
                            } else m[0] != "stop" && m[0] != "close" || R(c, 7);
                        } else c.I == 3 && (m[0] == "stop" || m[0] == "close" ? m[0] == "stop" ? R(c, 7) : cc(c) : m[0] != "noop" && c.l && c.l.qa(m), c.A = 0);
                    }
                }
            }
            lb(4);
        } catch (m) {}
    }
    var dc = class {
        constructor(a, b){
            this.g = a;
            this.map = b;
        }
    };
    function ec(a) {
        this.l = a || 10;
        l.PerformanceNavigationTiming ? (a = l.performance.getEntriesByType("navigation"), a = a.length > 0 && (a[0].nextHopProtocol == "hq" || a[0].nextHopProtocol == "h2")) : a = !!(l.chrome && l.chrome.loadTimes && l.chrome.loadTimes() && l.chrome.loadTimes().wasFetchedViaSpdy);
        this.j = a ? this.l : 1;
        this.g = null;
        this.j > 1 && (this.g = new Set);
        this.h = null;
        this.i = [];
    }
    function fc(a) {
        return a.h ? !0 : a.g ? a.g.size >= a.j : !1;
    }
    function Xb(a) {
        return a.h ? 1 : a.g ? a.g.size : 0;
    }
    function Tb(a, b) {
        return a.h ? a.h == b : a.g ? a.g.has(b) : !1;
    }
    function Yb(a, b) {
        a.g ? a.g.add(b) : a.h = b;
    }
    function $b(a, b) {
        a.h && a.h == b ? a.h = null : a.g && a.g.has(b) && a.g.delete(b);
    }
    ec.prototype.cancel = function() {
        this.i = hc(this);
        if (this.h) this.h.cancel(), this.h = null;
        else if (this.g && this.g.size !== 0) {
            for (const a of this.g.values())a.cancel();
            this.g.clear();
        }
    };
    function hc(a) {
        if (a.h != null) return a.i.concat(a.h.G);
        if (a.g != null && a.g.size !== 0) {
            let b = a.i;
            for (const c of a.g.values())b = b.concat(c.G);
            return b;
        }
        return ja(a.i);
    }
    var ic = RegExp("^(?:([^:/?#.]+):)?(?://(?:([^\\\\/?#]*)@)?([^\\\\/?#]*?)(?::([0-9]+))?(?=[\\\\/?#]|$))?([^?#]+)?(?:\\?([^#]*))?(?:#([\\s\\S]*))?$");
    function jc(a, b) {
        if (a) {
            a = a.split("&");
            for(let c = 0; c < a.length; c++){
                const d = a[c].indexOf("=");
                let e, f = null;
                d >= 0 ? (e = a[c].substring(0, d), f = a[c].substring(d + 1)) : e = a[c];
                b(e, f ? decodeURIComponent(f.replace(/\+/g, " ")) : "");
            }
        }
    }
    function T(a) {
        this.g = this.o = this.j = "";
        this.u = null;
        this.m = this.h = "";
        this.l = !1;
        let b;
        a instanceof T ? (this.l = a.l, kc(this, a.j), this.o = a.o, this.g = a.g, lc(this, a.u), this.h = a.h, mc(this, nc(a.i)), this.m = a.m) : a && (b = String(a).match(ic)) ? (this.l = !1, kc(this, b[1] || "", !0), this.o = oc(b[2] || ""), this.g = oc(b[3] || "", !0), lc(this, b[4]), this.h = oc(b[5] || "", !0), mc(this, b[6] || "", !0), this.m = oc(b[7] || "")) : (this.l = !1, this.i = new pc(null, this.l));
    }
    T.prototype.toString = function() {
        const a = [];
        var b = this.j;
        b && a.push(qc(b, rc, !0), ":");
        var c = this.g;
        if (c || b == "file") a.push("//"), (b = this.o) && a.push(qc(b, rc, !0), "@"), a.push(L(c).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.u, c != null && a.push(":", String(c));
        if (c = this.h) this.g && c.charAt(0) != "/" && a.push("/"), a.push(qc(c, c.charAt(0) == "/" ? sc : tc, !0));
        (c = this.i.toString()) && a.push("?", c);
        (c = this.m) && a.push("#", qc(c, uc));
        return a.join("");
    };
    T.prototype.resolve = function(a) {
        const b = O(this);
        let c = !!a.j;
        c ? kc(b, a.j) : c = !!a.o;
        c ? b.o = a.o : c = !!a.g;
        c ? b.g = a.g : c = a.u != null;
        var d = a.h;
        if (c) lc(b, a.u);
        else if (c = !!a.h) {
            if (d.charAt(0) != "/") {
                if (this.g && !this.h) d = "/" + d;
                else {
                    var e = b.h.lastIndexOf("/");
                    e != -1 && (d = b.h.slice(0, e + 1) + d);
                }
            }
            e = d;
            if (e == ".." || e == ".") d = "";
            else if (e.indexOf("./") != -1 || e.indexOf("/.") != -1) {
                d = e.lastIndexOf("/", 0) == 0;
                e = e.split("/");
                const f = [];
                for(let g = 0; g < e.length;){
                    const k = e[g++];
                    k == "." ? d && g == e.length && f.push("") : k == ".." ? ((f.length > 1 || f.length == 1 && f[0] != "") && f.pop(), d && g == e.length && f.push("")) : (f.push(k), d = !0);
                }
                d = f.join("/");
            } else d = e;
        }
        c ? b.h = d : c = a.i.toString() !== "";
        c ? mc(b, nc(a.i)) : c = !!a.m;
        c && (b.m = a.m);
        return b;
    };
    function O(a) {
        return new T(a);
    }
    function kc(a, b, c) {
        a.j = c ? oc(b, !0) : b;
        a.j && (a.j = a.j.replace(/:$/, ""));
    }
    function lc(a, b) {
        if (b) {
            b = Number(b);
            if (isNaN(b) || b < 0) throw Error("Bad port number " + b);
            a.u = b;
        } else a.u = null;
    }
    function mc(a, b, c) {
        b instanceof pc ? (a.i = b, vc(a.i, a.l)) : (c || (b = qc(b, wc)), a.i = new pc(b, a.l));
    }
    function S(a, b, c) {
        a.i.set(b, c);
    }
    function Db(a) {
        S(a, "zx", Math.floor(Math.random() * 2147483648).toString(36) + Math.abs(Math.floor(Math.random() * 2147483648) ^ Date.now()).toString(36));
        return a;
    }
    function oc(a, b) {
        return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : "";
    }
    function qc(a, b, c) {
        return typeof a === "string" ? (a = encodeURI(a).replace(b, xc), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null;
    }
    function xc(a) {
        a = a.charCodeAt(0);
        return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16);
    }
    var rc = /[#\/\?@]/g, tc = /[#\?:]/g, sc = /[#\?]/g, wc = /[#\?@]/g, uc = /#/g;
    function pc(a, b) {
        this.h = this.g = null;
        this.i = a || null;
        this.j = !!b;
    }
    function U(a) {
        a.g || (a.g = new Map, a.h = 0, a.i && jc(a.i, function(b, c) {
            a.add(decodeURIComponent(b.replace(/\+/g, " ")), c);
        }));
    }
    h = pc.prototype;
    h.add = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        let c = this.g.get(a);
        c || this.g.set(a, c = []);
        c.push(b);
        this.h += 1;
        return this;
    };
    function yc(a, b) {
        U(a);
        b = V(a, b);
        a.g.has(b) && (a.i = null, a.h -= a.g.get(b).length, a.g.delete(b));
    }
    function zc(a, b) {
        U(a);
        b = V(a, b);
        return a.g.has(b);
    }
    h.forEach = function(a, b) {
        U(this);
        this.g.forEach(function(c, d) {
            c.forEach(function(e) {
                a.call(b, e, d, this);
            }, this);
        }, this);
    };
    function Ac(a, b) {
        U(a);
        let c = [];
        if (typeof b === "string") zc(a, b) && (c = c.concat(a.g.get(V(a, b))));
        else for(a = Array.from(a.g.values()), b = 0; b < a.length; b++)c = c.concat(a[b]);
        return c;
    }
    h.set = function(a, b) {
        U(this);
        this.i = null;
        a = V(this, a);
        zc(this, a) && (this.h -= this.g.get(a).length);
        this.g.set(a, [
            b
        ]);
        this.h += 1;
        return this;
    };
    h.get = function(a, b) {
        if (!a) return b;
        a = Ac(this, a);
        return a.length > 0 ? String(a[0]) : b;
    };
    function Gb(a, b, c) {
        yc(a, b);
        c.length > 0 && (a.i = null, a.g.set(V(a, b), ja(c)), a.h += c.length);
    }
    h.toString = function() {
        if (this.i) return this.i;
        if (!this.g) return "";
        const a = [], b = Array.from(this.g.keys());
        for(let d = 0; d < b.length; d++){
            var c = b[d];
            const e = L(c);
            c = Ac(this, c);
            for(let f = 0; f < c.length; f++){
                let g = e;
                c[f] !== "" && (g += "=" + L(c[f]));
                a.push(g);
            }
        }
        return this.i = a.join("&");
    };
    function nc(a) {
        const b = new pc;
        b.i = a.i;
        a.g && (b.g = new Map(a.g), b.h = a.h);
        return b;
    }
    function V(a, b) {
        b = String(b);
        a.j && (b = b.toLowerCase());
        return b;
    }
    function vc(a, b) {
        b && !a.j && (U(a), a.i = null, a.g.forEach(function(c, d) {
            const e = d.toLowerCase();
            d != e && (yc(this, d), Gb(this, e, c));
        }, a));
        a.j = b;
    }
    function Bc(a, b) {
        const c = new pb;
        if (l.Image) {
            const d = new Image;
            d.onload = ha(W, c, "TestLoadImage: loaded", !0, b, d);
            d.onerror = ha(W, c, "TestLoadImage: error", !1, b, d);
            d.onabort = ha(W, c, "TestLoadImage: abort", !1, b, d);
            d.ontimeout = ha(W, c, "TestLoadImage: timeout", !1, b, d);
            l.setTimeout(function() {
                if (d.ontimeout) d.ontimeout();
            }, 1E4);
            d.src = a;
        } else b(!1);
    }
    function Cc(a, b) {
        const c = new pb, d = new AbortController, e = setTimeout(()=>{
            d.abort();
            W(c, "TestPingServer: timeout", !1, b);
        }, 1E4);
        fetch(a, {
            signal: d.signal
        }).then((f)=>{
            clearTimeout(e);
            f.ok ? W(c, "TestPingServer: ok", !0, b) : W(c, "TestPingServer: server error", !1, b);
        }).catch(()=>{
            clearTimeout(e);
            W(c, "TestPingServer: error", !1, b);
        });
    }
    function W(a, b, c, d, e) {
        try {
            e && (e.onload = null, e.onerror = null, e.onabort = null, e.ontimeout = null), d(c);
        } catch (f) {}
    }
    function Dc() {
        this.g = new db;
    }
    function Ec(a) {
        this.i = a.Sb || null;
        this.h = a.ab || !1;
    }
    t(Ec, eb);
    Ec.prototype.g = function() {
        return new Fc(this.i, this.h);
    };
    function Fc(a, b) {
        C.call(this);
        this.H = a;
        this.o = b;
        this.m = void 0;
        this.status = this.readyState = 0;
        this.responseType = this.responseText = this.response = this.statusText = "";
        this.onreadystatechange = null;
        this.A = new Headers;
        this.h = null;
        this.F = "GET";
        this.D = "";
        this.g = !1;
        this.B = this.j = this.l = null;
        this.v = new AbortController;
    }
    t(Fc, C);
    h = Fc.prototype;
    h.open = function(a, b) {
        if (this.readyState != 0) throw this.abort(), Error("Error reopening a connection");
        this.F = a;
        this.D = b;
        this.readyState = 1;
        Gc(this);
    };
    h.send = function(a) {
        if (this.readyState != 1) throw this.abort(), Error("need to call open() first. ");
        if (this.v.signal.aborted) throw this.abort(), Error("Request was aborted.");
        this.g = !0;
        const b = {
            headers: this.A,
            method: this.F,
            credentials: this.m,
            cache: void 0,
            signal: this.v.signal
        };
        a && (b.body = a);
        (this.H || l).fetch(new Request(this.D, b)).then(this.Pa.bind(this), this.ga.bind(this));
    };
    h.abort = function() {
        this.response = this.responseText = "";
        this.A = new Headers;
        this.status = 0;
        this.v.abort();
        this.j && this.j.cancel("Request was aborted.").catch(()=>{});
        this.readyState >= 1 && this.g && this.readyState != 4 && (this.g = !1, Hc(this));
        this.readyState = 0;
    };
    h.Pa = function(a) {
        if (this.g && (this.l = a, this.h || (this.status = this.l.status, this.statusText = this.l.statusText, this.h = a.headers, this.readyState = 2, Gc(this)), this.g && (this.readyState = 3, Gc(this), this.g))) {
            if (this.responseType === "arraybuffer") a.arrayBuffer().then(this.Na.bind(this), this.ga.bind(this));
            else if (typeof l.ReadableStream !== "undefined" && "body" in a) {
                this.j = a.body.getReader();
                if (this.o) {
                    if (this.responseType) throw Error('responseType must be empty for "streamBinaryChunks" mode responses.');
                    this.response = [];
                } else this.response = this.responseText = "", this.B = new TextDecoder;
                Ic(this);
            } else a.text().then(this.Oa.bind(this), this.ga.bind(this));
        }
    };
    function Ic(a) {
        a.j.read().then(a.Ma.bind(a)).catch(a.ga.bind(a));
    }
    h.Ma = function(a) {
        if (this.g) {
            if (this.o && a.value) this.response.push(a.value);
            else if (!this.o) {
                var b = a.value ? a.value : new Uint8Array(0);
                if (b = this.B.decode(b, {
                    stream: !a.done
                })) this.response = this.responseText += b;
            }
            a.done ? Hc(this) : Gc(this);
            this.readyState == 3 && Ic(this);
        }
    };
    h.Oa = function(a) {
        this.g && (this.response = this.responseText = a, Hc(this));
    };
    h.Na = function(a) {
        this.g && (this.response = a, Hc(this));
    };
    h.ga = function() {
        this.g && Hc(this);
    };
    function Hc(a) {
        a.readyState = 4;
        a.l = null;
        a.j = null;
        a.B = null;
        Gc(a);
    }
    h.setRequestHeader = function(a, b) {
        this.A.append(a, b);
    };
    h.getResponseHeader = function(a) {
        return this.h ? this.h.get(a.toLowerCase()) || "" : "";
    };
    h.getAllResponseHeaders = function() {
        if (!this.h) return "";
        const a = [], b = this.h.entries();
        for(var c = b.next(); !c.done;)c = c.value, a.push(c[0] + ": " + c[1]), c = b.next();
        return a.join("\r\n");
    };
    function Gc(a) {
        a.onreadystatechange && a.onreadystatechange.call(a);
    }
    Object.defineProperty(Fc.prototype, "withCredentials", {
        get: function() {
            return this.m === "include";
        },
        set: function(a) {
            this.m = a ? "include" : "same-origin";
        }
    });
    function Jc(a) {
        let b = "";
        ya(a, function(c, d) {
            b += d;
            b += ":";
            b += c;
            b += "\r\n";
        });
        return b;
    }
    function Kc(a, b, c) {
        a: {
            for(d in c){
                var d = !1;
                break a;
            }
            d = !0;
        }
        d || (c = Jc(c), typeof a === "string" ? c != null && L(c) : S(a, b, c));
    }
    function X(a) {
        C.call(this);
        this.headers = new Map;
        this.L = a || null;
        this.h = !1;
        this.g = null;
        this.D = "";
        this.o = 0;
        this.l = "";
        this.j = this.B = this.v = this.A = !1;
        this.m = null;
        this.F = "";
        this.H = !1;
    }
    t(X, C);
    var Lc = /^https?$/i, Mc = [
        "POST",
        "PUT"
    ];
    h = X.prototype;
    h.Fa = function(a) {
        this.H = a;
    };
    h.ea = function(a, b, c, d) {
        if (this.g) throw Error("[goog.net.XhrIo] Object is active with another request=" + this.D + "; newUri=" + a);
        b = b ? b.toUpperCase() : "GET";
        this.D = a;
        this.l = "";
        this.o = 0;
        this.A = !1;
        this.h = !0;
        this.g = this.L ? this.L.g() : wb.g();
        this.g.onreadystatechange = ia(p(this.Ca, this));
        try {
            this.B = !0, this.g.open(b, String(a), !0), this.B = !1;
        } catch (f) {
            Nc(this, f);
            return;
        }
        a = c || "";
        c = new Map(this.headers);
        if (d) {
            if (Object.getPrototypeOf(d) === Object.prototype) for(var e in d)c.set(e, d[e]);
            else if (typeof d.keys === "function" && typeof d.get === "function") for (const f of d.keys())c.set(f, d.get(f));
            else throw Error("Unknown input type for opt_headers: " + String(d));
        }
        d = Array.from(c.keys()).find((f)=>"content-type" == f.toLowerCase());
        e = l.FormData && a instanceof l.FormData;
        !(Array.prototype.indexOf.call(Mc, b, void 0) >= 0) || d || e || c.set("Content-Type", "application/x-www-form-urlencoded;charset=utf-8");
        for (const [f, g] of c)this.g.setRequestHeader(f, g);
        this.F && (this.g.responseType = this.F);
        "withCredentials" in this.g && this.g.withCredentials !== this.H && (this.g.withCredentials = this.H);
        try {
            this.m && (clearTimeout(this.m), this.m = null), this.v = !0, this.g.send(a), this.v = !1;
        } catch (f) {
            Nc(this, f);
        }
    };
    function Nc(a, b) {
        a.h = !1;
        a.g && (a.j = !0, a.g.abort(), a.j = !1);
        a.l = b;
        a.o = 5;
        Oc(a);
        Pc(a);
    }
    function Oc(a) {
        a.A || (a.A = !0, D(a, "complete"), D(a, "error"));
    }
    h.abort = function(a) {
        this.g && this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1, this.o = a || 7, D(this, "complete"), D(this, "abort"), Pc(this));
    };
    h.N = function() {
        this.g && (this.h && (this.h = !1, this.j = !0, this.g.abort(), this.j = !1), Pc(this, !0));
        X.Z.N.call(this);
    };
    h.Ca = function() {
        this.u || (this.B || this.v || this.j ? Qc(this) : this.Xa());
    };
    h.Xa = function() {
        Qc(this);
    };
    function Qc(a) {
        if (a.h && typeof ea != "undefined") {
            if (a.v && P(a) == 4) setTimeout(a.Ca.bind(a), 0);
            else if (D(a, "readystatechange"), P(a) == 4) {
                a.h = !1;
                try {
                    const f = a.ca();
                    a: switch(f){
                        case 200:
                        case 201:
                        case 202:
                        case 204:
                        case 206:
                        case 304:
                        case 1223:
                            var b = !0;
                            break a;
                        default:
                            b = !1;
                    }
                    var c;
                    if (!(c = b)) {
                        var d;
                        if (d = f === 0) {
                            let g = String(a.D).match(ic)[1] || null;
                            !g && l.self && l.self.location && (g = l.self.location.protocol.slice(0, -1));
                            d = !Lc.test(g ? g.toLowerCase() : "");
                        }
                        c = d;
                    }
                    if (c) D(a, "complete"), D(a, "success");
                    else {
                        a.o = 6;
                        try {
                            var e = P(a) > 2 ? a.g.statusText : "";
                        } catch (g) {
                            e = "";
                        }
                        a.l = e + " [" + a.ca() + "]";
                        Oc(a);
                    }
                } finally{
                    Pc(a);
                }
            }
        }
    }
    function Pc(a, b) {
        if (a.g) {
            a.m && (clearTimeout(a.m), a.m = null);
            const c = a.g;
            a.g = null;
            b || D(a, "ready");
            try {
                c.onreadystatechange = null;
            } catch (d) {}
        }
    }
    h.isActive = function() {
        return !!this.g;
    };
    function P(a) {
        return a.g ? a.g.readyState : 0;
    }
    h.ca = function() {
        try {
            return P(this) > 2 ? this.g.status : -1;
        } catch (a) {
            return -1;
        }
    };
    h.la = function() {
        try {
            return this.g ? this.g.responseText : "";
        } catch (a) {
            return "";
        }
    };
    h.La = function(a) {
        if (this.g) {
            var b = this.g.responseText;
            a && b.indexOf(a) == 0 && (b = b.substring(a.length));
            return cb(b);
        }
    };
    function Ib(a) {
        try {
            if (!a.g) return null;
            if ("response" in a.g) return a.g.response;
            switch(a.F){
                case "":
                case "text":
                    return a.g.responseText;
                case "arraybuffer":
                    if ("mozResponseArrayBuffer" in a.g) return a.g.mozResponseArrayBuffer;
            }
            return null;
        } catch (b) {
            return null;
        }
    }
    function Rb(a) {
        const b = {};
        a = (a.g && P(a) >= 2 ? a.g.getAllResponseHeaders() || "" : "").split("\r\n");
        for(let d = 0; d < a.length; d++){
            if (y(a[d])) continue;
            var c = yb(a[d]);
            const e = c[0];
            c = c[1];
            if (typeof c !== "string") continue;
            c = c.trim();
            const f = b[e] || [];
            b[e] = f;
            f.push(c);
        }
        Aa(b, function(d) {
            return d.join(", ");
        });
    }
    h.ya = function() {
        return this.o;
    };
    h.Ha = function() {
        return typeof this.l === "string" ? this.l : String(this.l);
    };
    function Rc(a, b, c) {
        return c && c.internalChannelParams ? c.internalChannelParams[a] || b : b;
    }
    function Sc(a) {
        this.za = 0;
        this.i = [];
        this.j = new pb;
        this.ba = this.na = this.J = this.W = this.g = this.wa = this.G = this.H = this.u = this.U = this.o = null;
        this.Ya = this.V = 0;
        this.Sa = Rc("failFast", !1, a);
        this.F = this.C = this.v = this.m = this.l = null;
        this.X = !0;
        this.xa = this.K = -1;
        this.Y = this.A = this.D = 0;
        this.Qa = Rc("baseRetryDelayMs", 5E3, a);
        this.Za = Rc("retryDelaySeedMs", 1E4, a);
        this.Ta = Rc("forwardChannelMaxRetries", 2, a);
        this.va = Rc("forwardChannelRequestTimeoutMs", 2E4, a);
        this.ma = a && a.xmlHttpFactory || void 0;
        this.Ua = a && a.Rb || void 0;
        this.Aa = a && a.useFetchStreams || !1;
        this.O = void 0;
        this.L = a && a.supportsCrossDomainXhr || !1;
        this.M = "";
        this.h = new ec(a && a.concurrentRequestLimit);
        this.Ba = new Dc;
        this.S = a && a.fastHandshake || !1;
        this.R = a && a.encodeInitMessageHeaders || !1;
        this.S && this.R && (this.R = !1);
        this.Ra = a && a.Pb || !1;
        a && a.ua && this.j.ua();
        a && a.forceLongPolling && (this.X = !1);
        this.aa = !this.S && this.X && a && a.detectBufferingProxy || !1;
        this.ia = void 0;
        a && a.longPollingTimeout && a.longPollingTimeout > 0 && (this.ia = a.longPollingTimeout);
        this.ta = void 0;
        this.T = 0;
        this.P = !1;
        this.ja = this.B = null;
    }
    h = Sc.prototype;
    h.ka = 8;
    h.I = 1;
    h.connect = function(a, b, c, d) {
        J(0);
        this.W = a;
        this.H = b || {};
        c && d !== void 0 && (this.H.OSID = c, this.H.OAID = d);
        this.F = this.X;
        this.J = Zb(this, null, this.W);
        bc(this);
    };
    function cc(a) {
        Tc(a);
        if (a.I == 3) {
            var b = a.V++, c = O(a.J);
            S(c, "SID", a.M);
            S(c, "RID", b);
            S(c, "TYPE", "terminate");
            Uc(a, c);
            b = new N(a, a.j, b);
            b.M = 2;
            b.A = Db(O(c));
            c = !1;
            if (l.navigator && l.navigator.sendBeacon) try {
                c = l.navigator.sendBeacon(b.A.toString(), "");
            } catch (d) {}
            !c && l.Image && ((new Image).src = b.A, c = !0);
            c || (b.g = Hb(b.j, null), b.g.ea(b.A));
            b.F = Date.now();
            Fb(b);
        }
        Vc(a);
    }
    function Vb(a) {
        a.g && (Pb(a), a.g.cancel(), a.g = null);
    }
    function Tc(a) {
        Vb(a);
        a.v && (l.clearTimeout(a.v), a.v = null);
        Ub(a);
        a.h.cancel();
        a.m && (typeof a.m === "number" && l.clearTimeout(a.m), a.m = null);
    }
    function bc(a) {
        if (!fc(a.h) && !a.m) {
            a.m = !0;
            var b = a.Ea;
            u || ta();
            v || (u(), v = !0);
            oa.add(b, a);
            a.D = 0;
        }
    }
    function Wc(a, b) {
        if (Xb(a.h) >= a.h.j - (a.m ? 1 : 0)) return !1;
        if (a.m) return a.i = b.G.concat(a.i), !0;
        if (a.I == 1 || a.I == 2 || a.D >= (a.Sa ? 0 : a.Ta)) return !1;
        a.m = ob(p(a.Ea, a, b), Xc(a, a.D));
        a.D++;
        return !0;
    }
    h.Ea = function(a) {
        if (this.m) {
            if (this.m = null, this.I == 1) {
                if (!a) {
                    this.V = Math.floor(Math.random() * 1E5);
                    a = this.V++;
                    const e = new N(this, this.j, a);
                    let f = this.o;
                    this.U && (f ? (f = Ba(f), Da(f, this.U)) : f = this.U);
                    this.u !== null || this.R || (e.J = f, f = null);
                    if (this.S) a: {
                        var b = 0;
                        for(var c = 0; c < this.i.length; c++){
                            b: {
                                var d = this.i[c];
                                if ("__data__" in d.map && (d = d.map.__data__, typeof d === "string")) {
                                    d = d.length;
                                    break b;
                                }
                                d = void 0;
                            }
                            if (d === void 0) break;
                            b += d;
                            if (b > 4096) {
                                b = c;
                                break a;
                            }
                            if (b === 4096 || c === this.i.length - 1) {
                                b = c + 1;
                                break a;
                            }
                        }
                        b = 1E3;
                    }
                    else b = 1E3;
                    b = Yc(this, e, b);
                    c = O(this.J);
                    S(c, "RID", a);
                    S(c, "CVER", 22);
                    this.G && S(c, "X-HTTP-Session-Id", this.G);
                    Uc(this, c);
                    f && (this.R ? b = "headers=" + L(Jc(f)) + "&" + b : this.u && Kc(c, this.u, f));
                    Yb(this.h, e);
                    this.Ra && S(c, "TYPE", "init");
                    this.S ? (S(c, "$req", b), S(c, "SID", "null"), e.U = !0, Cb(e, c, null)) : Cb(e, c, b);
                    this.I = 2;
                }
            } else this.I == 3 && (a ? Zc(this, a) : this.i.length == 0 || fc(this.h) || Zc(this));
        }
    };
    function Zc(a, b) {
        var c;
        b ? c = b.l : c = a.V++;
        const d = O(a.J);
        S(d, "SID", a.M);
        S(d, "RID", c);
        S(d, "AID", a.K);
        Uc(a, d);
        a.u && a.o && Kc(d, a.u, a.o);
        c = new N(a, a.j, c, a.D + 1);
        a.u === null && (c.J = a.o);
        b && (a.i = b.G.concat(a.i));
        b = Yc(a, c, 1E3);
        c.H = Math.round(a.va * .5) + Math.round(a.va * .5 * Math.random());
        Yb(a.h, c);
        Cb(c, d, b);
    }
    function Uc(a, b) {
        a.H && ya(a.H, function(c, d) {
            S(b, d, c);
        });
        a.l && ya({}, function(c, d) {
            S(b, d, c);
        });
    }
    function Yc(a, b, c) {
        c = Math.min(a.i.length, c);
        const d = a.l ? p(a.l.Ka, a.l, a) : null;
        a: {
            var e = a.i;
            let k = -1;
            for(;;){
                const q = [
                    "count=" + c
                ];
                k == -1 ? c > 0 ? (k = e[0].g, q.push("ofs=" + k)) : k = 0 : q.push("ofs=" + k);
                let m = !0;
                for(let r = 0; r < c; r++){
                    var f = e[r].g;
                    const A = e[r].map;
                    f -= k;
                    if (f < 0) k = Math.max(0, e[r].g - 100), m = !1;
                    else try {
                        f = "req" + f + "_";
                        try {
                            var g = A instanceof Map ? A : Object.entries(A);
                            for (const [M, F] of g){
                                let G = F;
                                n(F) && (G = ab(F));
                                q.push(f + M + "=" + encodeURIComponent(G));
                            }
                        } catch (M) {
                            throw q.push(f + "type=" + encodeURIComponent("_badmap")), M;
                        }
                    } catch (M) {
                        d && d(A);
                    }
                }
                if (m) {
                    g = q.join("&");
                    break a;
                }
            }
            g = void 0;
        }
        a = a.i.splice(0, c);
        b.G = a;
        return g;
    }
    function ac(a) {
        if (!a.g && !a.v) {
            a.Y = 1;
            var b = a.Da;
            u || ta();
            v || (u(), v = !0);
            oa.add(b, a);
            a.A = 0;
        }
    }
    function Wb(a) {
        if (a.g || a.v || a.A >= 3) return !1;
        a.Y++;
        a.v = ob(p(a.Da, a), Xc(a, a.A));
        a.A++;
        return !0;
    }
    h.Da = function() {
        this.v = null;
        $c(this);
        if (this.aa && !(this.P || this.g == null || this.T <= 0)) {
            var a = 4 * this.T;
            this.j.info("BP detection timer enabled: " + a);
            this.B = ob(p(this.Wa, this), a);
        }
    };
    h.Wa = function() {
        this.B && (this.B = null, this.j.info("BP detection timeout reached."), this.j.info("Buffering proxy detected and switch to long-polling!"), this.F = !1, this.P = !0, J(10), Vb(this), $c(this));
    };
    function Pb(a) {
        a.B != null && (l.clearTimeout(a.B), a.B = null);
    }
    function $c(a) {
        a.g = new N(a, a.j, "rpc", a.Y);
        a.u === null && (a.g.J = a.o);
        a.g.P = 0;
        var b = O(a.na);
        S(b, "RID", "rpc");
        S(b, "SID", a.M);
        S(b, "AID", a.K);
        S(b, "CI", a.F ? "0" : "1");
        !a.F && a.ia && S(b, "TO", a.ia);
        S(b, "TYPE", "xmlhttp");
        Uc(a, b);
        a.u && a.o && Kc(b, a.u, a.o);
        a.O && (a.g.H = a.O);
        var c = a.g;
        a = a.ba;
        c.M = 1;
        c.A = Db(O(b));
        c.u = null;
        c.R = !0;
        Eb(c, a);
    }
    h.Va = function() {
        this.C != null && (this.C = null, Vb(this), Wb(this), J(19));
    };
    function Ub(a) {
        a.C != null && (l.clearTimeout(a.C), a.C = null);
    }
    function Qb(a, b) {
        var c = null;
        if (a.g == b) {
            Ub(a);
            Pb(a);
            a.g = null;
            var d = 2;
        } else if (Tb(a.h, b)) c = b.G, $b(a.h, b), d = 1;
        else return;
        if (a.I != 0) {
            if (b.o) {
                if (d == 1) {
                    c = b.u ? b.u.length : 0;
                    b = Date.now() - b.F;
                    var e = a.D;
                    d = jb();
                    D(d, new nb(d, c));
                    bc(a);
                } else ac(a);
            } else if (e = b.m, e == 3 || e == 0 && b.X > 0 || !(d == 1 && Wc(a, b) || d == 2 && Wb(a))) switch(c && c.length > 0 && (b = a.h, b.i = b.i.concat(c)), e){
                case 1:
                    R(a, 5);
                    break;
                case 4:
                    R(a, 10);
                    break;
                case 3:
                    R(a, 6);
                    break;
                default:
                    R(a, 2);
            }
        }
    }
    function Xc(a, b) {
        let c = a.Qa + Math.floor(Math.random() * a.Za);
        a.isActive() || (c *= 2);
        return c * b;
    }
    function R(a, b) {
        a.j.info("Error code " + b);
        if (b == 2) {
            var c = p(a.bb, a), d = a.Ua;
            const e = !d;
            d = new T(d || "//www.google.com/images/cleardot.gif");
            l.location && l.location.protocol == "http" || kc(d, "https");
            Db(d);
            e ? Bc(d.toString(), c) : Cc(d.toString(), c);
        } else J(2);
        a.I = 0;
        a.l && a.l.pa(b);
        Vc(a);
        Tc(a);
    }
    h.bb = function(a) {
        a ? (this.j.info("Successfully pinged google.com"), J(2)) : (this.j.info("Failed to ping google.com"), J(1));
    };
    function Vc(a) {
        a.I = 0;
        a.ja = [];
        if (a.l) {
            const b = hc(a.h);
            if (b.length != 0 || a.i.length != 0) ka(a.ja, b), ka(a.ja, a.i), a.h.i.length = 0, ja(a.i), a.i.length = 0;
            a.l.oa();
        }
    }
    function Zb(a, b, c) {
        var d = c instanceof T ? O(c) : new T(c);
        if (d.g != "") b && (d.g = b + "." + d.g), lc(d, d.u);
        else {
            var e = l.location;
            d = e.protocol;
            b = b ? b + "." + e.hostname : e.hostname;
            e = +e.port;
            const f = new T(null);
            d && kc(f, d);
            b && (f.g = b);
            e && lc(f, e);
            c && (f.h = c);
            d = f;
        }
        c = a.G;
        b = a.wa;
        c && b && S(d, c, b);
        S(d, "VER", a.ka);
        Uc(a, d);
        return d;
    }
    function Hb(a, b, c) {
        if (b && !a.L) throw Error("Can't create secondary domain capable XhrIo object.");
        b = a.Aa && !a.ma ? new X(new Ec({
            ab: c
        })) : new X(a.ma);
        b.Fa(a.L);
        return b;
    }
    h.isActive = function() {
        return !!this.l && this.l.isActive(this);
    };
    function ad() {}
    h = ad.prototype;
    h.ra = function() {};
    h.qa = function() {};
    h.pa = function() {};
    h.oa = function() {};
    h.isActive = function() {
        return !0;
    };
    h.Ka = function() {};
    function bd() {}
    bd.prototype.g = function(a, b) {
        return new Y(a, b);
    };
    function Y(a, b) {
        C.call(this);
        this.g = new Sc(b);
        this.l = a;
        this.h = b && b.messageUrlParams || null;
        a = b && b.messageHeaders || null;
        b && b.clientProtocolHeaderRequired && (a ? a["X-Client-Protocol"] = "webchannel" : a = {
            "X-Client-Protocol": "webchannel"
        });
        this.g.o = a;
        a = b && b.initMessageHeaders || null;
        b && b.messageContentType && (a ? a["X-WebChannel-Content-Type"] = b.messageContentType : a = {
            "X-WebChannel-Content-Type": b.messageContentType
        });
        b && b.sa && (a ? a["X-WebChannel-Client-Profile"] = b.sa : a = {
            "X-WebChannel-Client-Profile": b.sa
        });
        this.g.U = a;
        (a = b && b.Qb) && !y(a) && (this.g.u = a);
        this.A = b && b.supportsCrossDomainXhr || !1;
        this.v = b && b.sendRawJson || !1;
        (b = b && b.httpSessionIdParam) && !y(b) && (this.g.G = b, a = this.h, a !== null && b in a && (a = this.h, b in a && delete a[b]));
        this.j = new Z(this);
    }
    t(Y, C);
    Y.prototype.m = function() {
        this.g.l = this.j;
        this.A && (this.g.L = !0);
        this.g.connect(this.l, this.h || void 0);
    };
    Y.prototype.close = function() {
        cc(this.g);
    };
    Y.prototype.o = function(a) {
        var b = this.g;
        if (typeof a === "string") {
            var c = {};
            c.__data__ = a;
            a = c;
        } else this.v && (c = {}, c.__data__ = ab(a), a = c);
        b.i.push(new dc(b.Ya++, a));
        b.I == 3 && bc(b);
    };
    Y.prototype.N = function() {
        this.g.l = null;
        delete this.j;
        cc(this.g);
        delete this.g;
        Y.Z.N.call(this);
    };
    function cd(a) {
        gb.call(this);
        a.__headers__ && (this.headers = a.__headers__, this.statusCode = a.__status__, delete a.__headers__, delete a.__status__);
        var b = a.__sm__;
        if (b) {
            a: {
                for(const c in b){
                    a = c;
                    break a;
                }
                a = void 0;
            }
            if (this.i = a) a = this.i, b = b !== null && a in b ? b[a] : void 0;
            this.data = b;
        } else this.data = a;
    }
    t(cd, gb);
    function dd() {
        hb.call(this);
        this.status = 1;
    }
    t(dd, hb);
    function Z(a) {
        this.g = a;
    }
    t(Z, ad);
    Z.prototype.ra = function() {
        D(this.g, "a");
    };
    Z.prototype.qa = function(a) {
        D(this.g, new cd(a));
    };
    Z.prototype.pa = function(a) {
        D(this.g, new dd());
    };
    Z.prototype.oa = function() {
        D(this.g, "b");
    };
    bd.prototype.createWebChannel = bd.prototype.g;
    Y.prototype.send = Y.prototype.o;
    Y.prototype.open = Y.prototype.m;
    Y.prototype.close = Y.prototype.close;
    createWebChannelTransport = webchannel_blob_es2018.createWebChannelTransport = function() {
        return new bd;
    };
    getStatEventTarget = webchannel_blob_es2018.getStatEventTarget = function() {
        return jb();
    };
    Event = webchannel_blob_es2018.Event = I;
    Stat = webchannel_blob_es2018.Stat = {
        jb: 0,
        mb: 1,
        nb: 2,
        Hb: 3,
        Mb: 4,
        Jb: 5,
        Kb: 6,
        Ib: 7,
        Gb: 8,
        Lb: 9,
        PROXY: 10,
        NOPROXY: 11,
        Eb: 12,
        Ab: 13,
        Bb: 14,
        zb: 15,
        Cb: 16,
        Db: 17,
        fb: 18,
        eb: 19,
        gb: 20
    };
    ub.NO_ERROR = 0;
    ub.TIMEOUT = 8;
    ub.HTTP_ERROR = 6;
    ErrorCode = webchannel_blob_es2018.ErrorCode = ub;
    vb.COMPLETE = "complete";
    EventType = webchannel_blob_es2018.EventType = vb;
    fb.EventType = H;
    H.OPEN = "a";
    H.CLOSE = "b";
    H.ERROR = "c";
    H.MESSAGE = "d";
    C.prototype.listen = C.prototype.J;
    WebChannel = webchannel_blob_es2018.WebChannel = fb;
    FetchXmlHttpFactory = webchannel_blob_es2018.FetchXmlHttpFactory = Ec;
    X.prototype.listenOnce = X.prototype.K;
    X.prototype.getLastError = X.prototype.Ha;
    X.prototype.getLastErrorCode = X.prototype.ya;
    X.prototype.getStatus = X.prototype.ca;
    X.prototype.getResponseJson = X.prototype.La;
    X.prototype.getResponseText = X.prototype.la;
    X.prototype.send = X.prototype.ea;
    X.prototype.setWithCredentials = X.prototype.Fa;
    XhrIo = webchannel_blob_es2018.XhrIo = X;
}).apply(typeof commonjsGlobal !== 'undefined' ? commonjsGlobal : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gJUT3":[function(require,module,exports,__globalThis) {
/*!
 * re2js
 * RE2JS is the JavaScript port of RE2, a regular expression engine that provides linear time matching
 *
 * @version v0.4.3
 * @author Alexey Vasiliev
 * @homepage https://github.com/le0pard/re2js#readme
 * @repository github:le0pard/re2js
 * @license MIT
 */ //// Parser flags.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RE2JS", ()=>RE2JS);
parcelHelpers.export(exports, "RE2JSCompileException", ()=>RE2JSCompileException);
parcelHelpers.export(exports, "RE2JSException", ()=>RE2JSException);
parcelHelpers.export(exports, "RE2JSFlagsException", ()=>RE2JSFlagsException);
parcelHelpers.export(exports, "RE2JSGroupException", ()=>RE2JSGroupException);
parcelHelpers.export(exports, "RE2JSSyntaxException", ()=>RE2JSSyntaxException);
class RE2Flags {
    // Fold case during matching (case-insensitive).
    static FOLD_CASE = 0x01;
    // Treat pattern as a literal string instead of a regexp.
    static LITERAL = 0x02;
    // Allow character classes like [^a-z] and [[:space:]] to match newline.
    static CLASS_NL = 0x04;
    // Allow '.' to match newline.
    static DOT_NL = 0x08;
    // Treat ^ and $ as only matching at beginning and end of text, not
    // around embedded newlines.  (Perl's default).
    static ONE_LINE = 0x10;
    // Make repetition operators default to non-greedy.
    static NON_GREEDY = 0x20;
    // allow Perl extensions:
    //   non-capturing parens - (?: )
    //   non-greedy operators - *? +? ?? {}?
    //   flag edits - (?i) (?-i) (?i: )
    //     i - FoldCase
    //     m - !OneLine
    //     s - DotNL
    //     U - NonGreedy
    //   line ends: \A \z
    //   \Q and \E to disable/enable metacharacters
    //   (?P<name>expr) for named captures
    // \C (any byte) is not supported.
    static PERL_X = 0x40;
    // Allow \p{Han}, \P{Han} for Unicode group and negation.
    static UNICODE_GROUPS = 0x80;
    // Regexp END_TEXT was $, not \z.  Internal use only.
    static WAS_DOLLAR = 0x100;
    static MATCH_NL = (()=>RE2Flags.CLASS_NL | RE2Flags.DOT_NL)();
    // As close to Perl as possible.
    static PERL = (()=>RE2Flags.CLASS_NL | RE2Flags.ONE_LINE | RE2Flags.PERL_X | RE2Flags.UNICODE_GROUPS)();
    // POSIX syntax.
    static POSIX = 0;
    //// Anchors
    static UNANCHORED = 0;
    static ANCHOR_START = 1;
    static ANCHOR_BOTH = 2;
}
/**
 * Various constants and helper for unicode codepoints.
 */ class Codepoint {
    // codePointAt(0)
    static CODES = (()=>new Map([
            [
                '\x07',
                7
            ],
            [
                '\b',
                8
            ],
            [
                '\t',
                9
            ],
            [
                '\n',
                10
            ],
            [
                '\v',
                11
            ],
            [
                '\f',
                12
            ],
            [
                '\r',
                13
            ],
            [
                ' ',
                32
            ],
            [
                '"',
                34
            ],
            [
                '$',
                36
            ],
            [
                '&',
                38
            ],
            [
                '(',
                40
            ],
            [
                ')',
                41
            ],
            [
                '*',
                42
            ],
            [
                '+',
                43
            ],
            [
                '-',
                45
            ],
            [
                '.',
                46
            ],
            [
                '0',
                48
            ],
            [
                '1',
                49
            ],
            [
                '2',
                50
            ],
            [
                '3',
                51
            ],
            [
                '4',
                52
            ],
            [
                '5',
                53
            ],
            [
                '6',
                54
            ],
            [
                '7',
                55
            ],
            [
                '8',
                56
            ],
            [
                '9',
                57
            ],
            [
                ':',
                58
            ],
            [
                '<',
                60
            ],
            [
                '>',
                62
            ],
            [
                '?',
                63
            ],
            [
                'A',
                65
            ],
            [
                'B',
                66
            ],
            [
                'C',
                67
            ],
            [
                'F',
                70
            ],
            [
                'P',
                80
            ],
            [
                'Q',
                81
            ],
            [
                'U',
                85
            ],
            [
                'Z',
                90
            ],
            [
                '[',
                91
            ],
            [
                '\\',
                92
            ],
            [
                ']',
                93
            ],
            [
                '^',
                94
            ],
            [
                '_',
                95
            ],
            [
                'a',
                97
            ],
            [
                'b',
                98
            ],
            [
                'f',
                102
            ],
            [
                'i',
                105
            ],
            [
                'm',
                109
            ],
            [
                'n',
                110
            ],
            [
                'r',
                114
            ],
            [
                's',
                115
            ],
            [
                't',
                116
            ],
            [
                'v',
                118
            ],
            [
                'x',
                120
            ],
            [
                'z',
                122
            ],
            [
                '{',
                123
            ],
            [
                '|',
                124
            ],
            [
                '}',
                125
            ]
        ]))();
    // convert unicode codepoint to upper case codepoint
    // return same codepoint, if cannot do it (or codepoint not have upper variation)
    static toUpperCase(codepoint) {
        const s = String.fromCodePoint(codepoint).toUpperCase();
        if (s.length > 1) return codepoint;
        const sOrigin = String.fromCodePoint(s.codePointAt(0)).toLowerCase();
        if (sOrigin.length > 1 || sOrigin.codePointAt(0) !== codepoint) return codepoint;
        return s.codePointAt(0);
    }
    // convert unicode codepoint to lower case codepoint
    // return same codepoint, if cannot do it (or codepoint not have lower variation)
    static toLowerCase(codepoint) {
        const s = String.fromCodePoint(codepoint).toLowerCase();
        if (s.length > 1) return codepoint;
        const sOrigin = String.fromCodePoint(s.codePointAt(0)).toUpperCase();
        if (sOrigin.length > 1 || sOrigin.codePointAt(0) !== codepoint) return codepoint;
        return s.codePointAt(0);
    }
}
// GENERATED BY tools/scripts/genUnicodeTable.js; DO NOT EDIT.
// yarn node ./tools/scripts/genUnicodeTable.js > src/UnicodeTables.js
class UnicodeTables {
    static CASE_ORBIT = (()=>new Map([
            [
                75,
                107
            ],
            [
                107,
                8490
            ],
            [
                8490,
                75
            ],
            [
                83,
                115
            ],
            [
                115,
                383
            ],
            [
                383,
                83
            ],
            [
                181,
                924
            ],
            [
                924,
                956
            ],
            [
                956,
                181
            ],
            [
                197,
                229
            ],
            [
                229,
                8491
            ],
            [
                8491,
                197
            ],
            [
                452,
                453
            ],
            [
                453,
                454
            ],
            [
                454,
                452
            ],
            [
                455,
                456
            ],
            [
                456,
                457
            ],
            [
                457,
                455
            ],
            [
                458,
                459
            ],
            [
                459,
                460
            ],
            [
                460,
                458
            ],
            [
                497,
                498
            ],
            [
                498,
                499
            ],
            [
                499,
                497
            ],
            [
                837,
                921
            ],
            [
                921,
                953
            ],
            [
                953,
                8126
            ],
            [
                8126,
                837
            ],
            [
                914,
                946
            ],
            [
                946,
                976
            ],
            [
                976,
                914
            ],
            [
                917,
                949
            ],
            [
                949,
                1013
            ],
            [
                1013,
                917
            ],
            [
                920,
                952
            ],
            [
                952,
                977
            ],
            [
                977,
                1012
            ],
            [
                1012,
                920
            ],
            [
                922,
                954
            ],
            [
                954,
                1008
            ],
            [
                1008,
                922
            ],
            [
                928,
                960
            ],
            [
                960,
                982
            ],
            [
                982,
                928
            ],
            [
                929,
                961
            ],
            [
                961,
                1009
            ],
            [
                1009,
                929
            ],
            [
                931,
                962
            ],
            [
                962,
                963
            ],
            [
                963,
                931
            ],
            [
                934,
                966
            ],
            [
                966,
                981
            ],
            [
                981,
                934
            ],
            [
                937,
                969
            ],
            [
                969,
                8486
            ],
            [
                8486,
                937
            ],
            [
                1042,
                1074
            ],
            [
                1074,
                7296
            ],
            [
                7296,
                1042
            ],
            [
                1044,
                1076
            ],
            [
                1076,
                7297
            ],
            [
                7297,
                1044
            ],
            [
                1054,
                1086
            ],
            [
                1086,
                7298
            ],
            [
                7298,
                1054
            ],
            [
                1057,
                1089
            ],
            [
                1089,
                7299
            ],
            [
                7299,
                1057
            ],
            [
                1058,
                1090
            ],
            [
                1090,
                7300
            ],
            [
                7300,
                7301
            ],
            [
                7301,
                1058
            ],
            [
                1066,
                1098
            ],
            [
                1098,
                7302
            ],
            [
                7302,
                1066
            ],
            [
                1122,
                1123
            ],
            [
                1123,
                7303
            ],
            [
                7303,
                1122
            ],
            [
                7304,
                42570
            ],
            [
                42570,
                42571
            ],
            [
                42571,
                7304
            ],
            [
                7776,
                7777
            ],
            [
                7777,
                7835
            ],
            [
                7835,
                7776
            ],
            [
                223,
                7838
            ],
            [
                7838,
                223
            ],
            [
                8064,
                8072
            ],
            [
                8072,
                8064
            ],
            [
                8065,
                8073
            ],
            [
                8073,
                8065
            ],
            [
                8066,
                8074
            ],
            [
                8074,
                8066
            ],
            [
                8067,
                8075
            ],
            [
                8075,
                8067
            ],
            [
                8068,
                8076
            ],
            [
                8076,
                8068
            ],
            [
                8069,
                8077
            ],
            [
                8077,
                8069
            ],
            [
                8070,
                8078
            ],
            [
                8078,
                8070
            ],
            [
                8071,
                8079
            ],
            [
                8079,
                8071
            ],
            [
                8080,
                8088
            ],
            [
                8088,
                8080
            ],
            [
                8081,
                8089
            ],
            [
                8089,
                8081
            ],
            [
                8082,
                8090
            ],
            [
                8090,
                8082
            ],
            [
                8083,
                8091
            ],
            [
                8091,
                8083
            ],
            [
                8084,
                8092
            ],
            [
                8092,
                8084
            ],
            [
                8085,
                8093
            ],
            [
                8093,
                8085
            ],
            [
                8086,
                8094
            ],
            [
                8094,
                8086
            ],
            [
                8087,
                8095
            ],
            [
                8095,
                8087
            ],
            [
                8096,
                8104
            ],
            [
                8104,
                8096
            ],
            [
                8097,
                8105
            ],
            [
                8105,
                8097
            ],
            [
                8098,
                8106
            ],
            [
                8106,
                8098
            ],
            [
                8099,
                8107
            ],
            [
                8107,
                8099
            ],
            [
                8100,
                8108
            ],
            [
                8108,
                8100
            ],
            [
                8101,
                8109
            ],
            [
                8109,
                8101
            ],
            [
                8102,
                8110
            ],
            [
                8110,
                8102
            ],
            [
                8103,
                8111
            ],
            [
                8111,
                8103
            ],
            [
                8115,
                8124
            ],
            [
                8124,
                8115
            ],
            [
                8131,
                8140
            ],
            [
                8140,
                8131
            ],
            [
                912,
                8147
            ],
            [
                8147,
                912
            ],
            [
                944,
                8163
            ],
            [
                8163,
                944
            ],
            [
                8179,
                8188
            ],
            [
                8188,
                8179
            ],
            [
                64261,
                64262
            ],
            [
                64262,
                64261
            ],
            [
                66560,
                66600
            ],
            [
                66600,
                66560
            ],
            [
                66561,
                66601
            ],
            [
                66601,
                66561
            ],
            [
                66562,
                66602
            ],
            [
                66602,
                66562
            ],
            [
                66563,
                66603
            ],
            [
                66603,
                66563
            ],
            [
                66564,
                66604
            ],
            [
                66604,
                66564
            ],
            [
                66565,
                66605
            ],
            [
                66605,
                66565
            ],
            [
                66566,
                66606
            ],
            [
                66606,
                66566
            ],
            [
                66567,
                66607
            ],
            [
                66607,
                66567
            ],
            [
                66568,
                66608
            ],
            [
                66608,
                66568
            ],
            [
                66569,
                66609
            ],
            [
                66609,
                66569
            ],
            [
                66570,
                66610
            ],
            [
                66610,
                66570
            ],
            [
                66571,
                66611
            ],
            [
                66611,
                66571
            ],
            [
                66572,
                66612
            ],
            [
                66612,
                66572
            ],
            [
                66573,
                66613
            ],
            [
                66613,
                66573
            ],
            [
                66574,
                66614
            ],
            [
                66614,
                66574
            ],
            [
                66575,
                66615
            ],
            [
                66615,
                66575
            ],
            [
                66576,
                66616
            ],
            [
                66616,
                66576
            ],
            [
                66577,
                66617
            ],
            [
                66617,
                66577
            ],
            [
                66578,
                66618
            ],
            [
                66618,
                66578
            ],
            [
                66579,
                66619
            ],
            [
                66619,
                66579
            ],
            [
                66580,
                66620
            ],
            [
                66620,
                66580
            ],
            [
                66581,
                66621
            ],
            [
                66621,
                66581
            ],
            [
                66582,
                66622
            ],
            [
                66622,
                66582
            ],
            [
                66583,
                66623
            ],
            [
                66623,
                66583
            ],
            [
                66584,
                66624
            ],
            [
                66624,
                66584
            ],
            [
                66585,
                66625
            ],
            [
                66625,
                66585
            ],
            [
                66586,
                66626
            ],
            [
                66626,
                66586
            ],
            [
                66587,
                66627
            ],
            [
                66627,
                66587
            ],
            [
                66588,
                66628
            ],
            [
                66628,
                66588
            ],
            [
                66589,
                66629
            ],
            [
                66629,
                66589
            ],
            [
                66590,
                66630
            ],
            [
                66630,
                66590
            ],
            [
                66591,
                66631
            ],
            [
                66631,
                66591
            ],
            [
                66592,
                66632
            ],
            [
                66632,
                66592
            ],
            [
                66593,
                66633
            ],
            [
                66633,
                66593
            ],
            [
                66594,
                66634
            ],
            [
                66634,
                66594
            ],
            [
                66595,
                66635
            ],
            [
                66635,
                66595
            ],
            [
                66596,
                66636
            ],
            [
                66636,
                66596
            ],
            [
                66597,
                66637
            ],
            [
                66637,
                66597
            ],
            [
                66598,
                66638
            ],
            [
                66638,
                66598
            ],
            [
                66599,
                66639
            ],
            [
                66639,
                66599
            ],
            [
                66736,
                66776
            ],
            [
                66776,
                66736
            ],
            [
                66737,
                66777
            ],
            [
                66777,
                66737
            ],
            [
                66738,
                66778
            ],
            [
                66778,
                66738
            ],
            [
                66739,
                66779
            ],
            [
                66779,
                66739
            ],
            [
                66740,
                66780
            ],
            [
                66780,
                66740
            ],
            [
                66741,
                66781
            ],
            [
                66781,
                66741
            ],
            [
                66742,
                66782
            ],
            [
                66782,
                66742
            ],
            [
                66743,
                66783
            ],
            [
                66783,
                66743
            ],
            [
                66744,
                66784
            ],
            [
                66784,
                66744
            ],
            [
                66745,
                66785
            ],
            [
                66785,
                66745
            ],
            [
                66746,
                66786
            ],
            [
                66786,
                66746
            ],
            [
                66747,
                66787
            ],
            [
                66787,
                66747
            ],
            [
                66748,
                66788
            ],
            [
                66788,
                66748
            ],
            [
                66749,
                66789
            ],
            [
                66789,
                66749
            ],
            [
                66750,
                66790
            ],
            [
                66790,
                66750
            ],
            [
                66751,
                66791
            ],
            [
                66791,
                66751
            ],
            [
                66752,
                66792
            ],
            [
                66792,
                66752
            ],
            [
                66753,
                66793
            ],
            [
                66793,
                66753
            ],
            [
                66754,
                66794
            ],
            [
                66794,
                66754
            ],
            [
                66755,
                66795
            ],
            [
                66795,
                66755
            ],
            [
                66756,
                66796
            ],
            [
                66796,
                66756
            ],
            [
                66757,
                66797
            ],
            [
                66797,
                66757
            ],
            [
                66758,
                66798
            ],
            [
                66798,
                66758
            ],
            [
                66759,
                66799
            ],
            [
                66799,
                66759
            ],
            [
                66760,
                66800
            ],
            [
                66800,
                66760
            ],
            [
                66761,
                66801
            ],
            [
                66801,
                66761
            ],
            [
                66762,
                66802
            ],
            [
                66802,
                66762
            ],
            [
                66763,
                66803
            ],
            [
                66803,
                66763
            ],
            [
                66764,
                66804
            ],
            [
                66804,
                66764
            ],
            [
                66765,
                66805
            ],
            [
                66805,
                66765
            ],
            [
                66766,
                66806
            ],
            [
                66806,
                66766
            ],
            [
                66767,
                66807
            ],
            [
                66807,
                66767
            ],
            [
                66768,
                66808
            ],
            [
                66808,
                66768
            ],
            [
                66769,
                66809
            ],
            [
                66809,
                66769
            ],
            [
                66770,
                66810
            ],
            [
                66810,
                66770
            ],
            [
                66771,
                66811
            ],
            [
                66811,
                66771
            ],
            [
                66928,
                66967
            ],
            [
                66967,
                66928
            ],
            [
                66929,
                66968
            ],
            [
                66968,
                66929
            ],
            [
                66930,
                66969
            ],
            [
                66969,
                66930
            ],
            [
                66931,
                66970
            ],
            [
                66970,
                66931
            ],
            [
                66932,
                66971
            ],
            [
                66971,
                66932
            ],
            [
                66933,
                66972
            ],
            [
                66972,
                66933
            ],
            [
                66934,
                66973
            ],
            [
                66973,
                66934
            ],
            [
                66935,
                66974
            ],
            [
                66974,
                66935
            ],
            [
                66936,
                66975
            ],
            [
                66975,
                66936
            ],
            [
                66937,
                66976
            ],
            [
                66976,
                66937
            ],
            [
                66938,
                66977
            ],
            [
                66977,
                66938
            ],
            [
                66940,
                66979
            ],
            [
                66979,
                66940
            ],
            [
                66941,
                66980
            ],
            [
                66980,
                66941
            ],
            [
                66942,
                66981
            ],
            [
                66981,
                66942
            ],
            [
                66943,
                66982
            ],
            [
                66982,
                66943
            ],
            [
                66944,
                66983
            ],
            [
                66983,
                66944
            ],
            [
                66945,
                66984
            ],
            [
                66984,
                66945
            ],
            [
                66946,
                66985
            ],
            [
                66985,
                66946
            ],
            [
                66947,
                66986
            ],
            [
                66986,
                66947
            ],
            [
                66948,
                66987
            ],
            [
                66987,
                66948
            ],
            [
                66949,
                66988
            ],
            [
                66988,
                66949
            ],
            [
                66950,
                66989
            ],
            [
                66989,
                66950
            ],
            [
                66951,
                66990
            ],
            [
                66990,
                66951
            ],
            [
                66952,
                66991
            ],
            [
                66991,
                66952
            ],
            [
                66953,
                66992
            ],
            [
                66992,
                66953
            ],
            [
                66954,
                66993
            ],
            [
                66993,
                66954
            ],
            [
                66956,
                66995
            ],
            [
                66995,
                66956
            ],
            [
                66957,
                66996
            ],
            [
                66996,
                66957
            ],
            [
                66958,
                66997
            ],
            [
                66997,
                66958
            ],
            [
                66959,
                66998
            ],
            [
                66998,
                66959
            ],
            [
                66960,
                66999
            ],
            [
                66999,
                66960
            ],
            [
                66961,
                67000
            ],
            [
                67000,
                66961
            ],
            [
                66962,
                67001
            ],
            [
                67001,
                66962
            ],
            [
                66964,
                67003
            ],
            [
                67003,
                66964
            ],
            [
                66965,
                67004
            ],
            [
                67004,
                66965
            ],
            [
                68736,
                68800
            ],
            [
                68800,
                68736
            ],
            [
                68737,
                68801
            ],
            [
                68801,
                68737
            ],
            [
                68738,
                68802
            ],
            [
                68802,
                68738
            ],
            [
                68739,
                68803
            ],
            [
                68803,
                68739
            ],
            [
                68740,
                68804
            ],
            [
                68804,
                68740
            ],
            [
                68741,
                68805
            ],
            [
                68805,
                68741
            ],
            [
                68742,
                68806
            ],
            [
                68806,
                68742
            ],
            [
                68743,
                68807
            ],
            [
                68807,
                68743
            ],
            [
                68744,
                68808
            ],
            [
                68808,
                68744
            ],
            [
                68745,
                68809
            ],
            [
                68809,
                68745
            ],
            [
                68746,
                68810
            ],
            [
                68810,
                68746
            ],
            [
                68747,
                68811
            ],
            [
                68811,
                68747
            ],
            [
                68748,
                68812
            ],
            [
                68812,
                68748
            ],
            [
                68749,
                68813
            ],
            [
                68813,
                68749
            ],
            [
                68750,
                68814
            ],
            [
                68814,
                68750
            ],
            [
                68751,
                68815
            ],
            [
                68815,
                68751
            ],
            [
                68752,
                68816
            ],
            [
                68816,
                68752
            ],
            [
                68753,
                68817
            ],
            [
                68817,
                68753
            ],
            [
                68754,
                68818
            ],
            [
                68818,
                68754
            ],
            [
                68755,
                68819
            ],
            [
                68819,
                68755
            ],
            [
                68756,
                68820
            ],
            [
                68820,
                68756
            ],
            [
                68757,
                68821
            ],
            [
                68821,
                68757
            ],
            [
                68758,
                68822
            ],
            [
                68822,
                68758
            ],
            [
                68759,
                68823
            ],
            [
                68823,
                68759
            ],
            [
                68760,
                68824
            ],
            [
                68824,
                68760
            ],
            [
                68761,
                68825
            ],
            [
                68825,
                68761
            ],
            [
                68762,
                68826
            ],
            [
                68826,
                68762
            ],
            [
                68763,
                68827
            ],
            [
                68827,
                68763
            ],
            [
                68764,
                68828
            ],
            [
                68828,
                68764
            ],
            [
                68765,
                68829
            ],
            [
                68829,
                68765
            ],
            [
                68766,
                68830
            ],
            [
                68830,
                68766
            ],
            [
                68767,
                68831
            ],
            [
                68831,
                68767
            ],
            [
                68768,
                68832
            ],
            [
                68832,
                68768
            ],
            [
                68769,
                68833
            ],
            [
                68833,
                68769
            ],
            [
                68770,
                68834
            ],
            [
                68834,
                68770
            ],
            [
                68771,
                68835
            ],
            [
                68835,
                68771
            ],
            [
                68772,
                68836
            ],
            [
                68836,
                68772
            ],
            [
                68773,
                68837
            ],
            [
                68837,
                68773
            ],
            [
                68774,
                68838
            ],
            [
                68838,
                68774
            ],
            [
                68775,
                68839
            ],
            [
                68839,
                68775
            ],
            [
                68776,
                68840
            ],
            [
                68840,
                68776
            ],
            [
                68777,
                68841
            ],
            [
                68841,
                68777
            ],
            [
                68778,
                68842
            ],
            [
                68842,
                68778
            ],
            [
                68779,
                68843
            ],
            [
                68843,
                68779
            ],
            [
                68780,
                68844
            ],
            [
                68844,
                68780
            ],
            [
                68781,
                68845
            ],
            [
                68845,
                68781
            ],
            [
                68782,
                68846
            ],
            [
                68846,
                68782
            ],
            [
                68783,
                68847
            ],
            [
                68847,
                68783
            ],
            [
                68784,
                68848
            ],
            [
                68848,
                68784
            ],
            [
                68785,
                68849
            ],
            [
                68849,
                68785
            ],
            [
                68786,
                68850
            ],
            [
                68850,
                68786
            ],
            [
                71840,
                71872
            ],
            [
                71872,
                71840
            ],
            [
                71841,
                71873
            ],
            [
                71873,
                71841
            ],
            [
                71842,
                71874
            ],
            [
                71874,
                71842
            ],
            [
                71843,
                71875
            ],
            [
                71875,
                71843
            ],
            [
                71844,
                71876
            ],
            [
                71876,
                71844
            ],
            [
                71845,
                71877
            ],
            [
                71877,
                71845
            ],
            [
                71846,
                71878
            ],
            [
                71878,
                71846
            ],
            [
                71847,
                71879
            ],
            [
                71879,
                71847
            ],
            [
                71848,
                71880
            ],
            [
                71880,
                71848
            ],
            [
                71849,
                71881
            ],
            [
                71881,
                71849
            ],
            [
                71850,
                71882
            ],
            [
                71882,
                71850
            ],
            [
                71851,
                71883
            ],
            [
                71883,
                71851
            ],
            [
                71852,
                71884
            ],
            [
                71884,
                71852
            ],
            [
                71853,
                71885
            ],
            [
                71885,
                71853
            ],
            [
                71854,
                71886
            ],
            [
                71886,
                71854
            ],
            [
                71855,
                71887
            ],
            [
                71887,
                71855
            ],
            [
                71856,
                71888
            ],
            [
                71888,
                71856
            ],
            [
                71857,
                71889
            ],
            [
                71889,
                71857
            ],
            [
                71858,
                71890
            ],
            [
                71890,
                71858
            ],
            [
                71859,
                71891
            ],
            [
                71891,
                71859
            ],
            [
                71860,
                71892
            ],
            [
                71892,
                71860
            ],
            [
                71861,
                71893
            ],
            [
                71893,
                71861
            ],
            [
                71862,
                71894
            ],
            [
                71894,
                71862
            ],
            [
                71863,
                71895
            ],
            [
                71895,
                71863
            ],
            [
                71864,
                71896
            ],
            [
                71896,
                71864
            ],
            [
                71865,
                71897
            ],
            [
                71897,
                71865
            ],
            [
                71866,
                71898
            ],
            [
                71898,
                71866
            ],
            [
                71867,
                71899
            ],
            [
                71899,
                71867
            ],
            [
                71868,
                71900
            ],
            [
                71900,
                71868
            ],
            [
                71869,
                71901
            ],
            [
                71901,
                71869
            ],
            [
                71870,
                71902
            ],
            [
                71902,
                71870
            ],
            [
                71871,
                71903
            ],
            [
                71903,
                71871
            ],
            [
                93760,
                93792
            ],
            [
                93792,
                93760
            ],
            [
                93761,
                93793
            ],
            [
                93793,
                93761
            ],
            [
                93762,
                93794
            ],
            [
                93794,
                93762
            ],
            [
                93763,
                93795
            ],
            [
                93795,
                93763
            ],
            [
                93764,
                93796
            ],
            [
                93796,
                93764
            ],
            [
                93765,
                93797
            ],
            [
                93797,
                93765
            ],
            [
                93766,
                93798
            ],
            [
                93798,
                93766
            ],
            [
                93767,
                93799
            ],
            [
                93799,
                93767
            ],
            [
                93768,
                93800
            ],
            [
                93800,
                93768
            ],
            [
                93769,
                93801
            ],
            [
                93801,
                93769
            ],
            [
                93770,
                93802
            ],
            [
                93802,
                93770
            ],
            [
                93771,
                93803
            ],
            [
                93803,
                93771
            ],
            [
                93772,
                93804
            ],
            [
                93804,
                93772
            ],
            [
                93773,
                93805
            ],
            [
                93805,
                93773
            ],
            [
                93774,
                93806
            ],
            [
                93806,
                93774
            ],
            [
                93775,
                93807
            ],
            [
                93807,
                93775
            ],
            [
                93776,
                93808
            ],
            [
                93808,
                93776
            ],
            [
                93777,
                93809
            ],
            [
                93809,
                93777
            ],
            [
                93778,
                93810
            ],
            [
                93810,
                93778
            ],
            [
                93779,
                93811
            ],
            [
                93811,
                93779
            ],
            [
                93780,
                93812
            ],
            [
                93812,
                93780
            ],
            [
                93781,
                93813
            ],
            [
                93813,
                93781
            ],
            [
                93782,
                93814
            ],
            [
                93814,
                93782
            ],
            [
                93783,
                93815
            ],
            [
                93815,
                93783
            ],
            [
                93784,
                93816
            ],
            [
                93816,
                93784
            ],
            [
                93785,
                93817
            ],
            [
                93817,
                93785
            ],
            [
                93786,
                93818
            ],
            [
                93818,
                93786
            ],
            [
                93787,
                93819
            ],
            [
                93819,
                93787
            ],
            [
                93788,
                93820
            ],
            [
                93820,
                93788
            ],
            [
                93789,
                93821
            ],
            [
                93821,
                93789
            ],
            [
                93790,
                93822
            ],
            [
                93822,
                93790
            ],
            [
                93791,
                93823
            ],
            [
                93823,
                93791
            ],
            [
                125184,
                125218
            ],
            [
                125218,
                125184
            ],
            [
                125185,
                125219
            ],
            [
                125219,
                125185
            ],
            [
                125186,
                125220
            ],
            [
                125220,
                125186
            ],
            [
                125187,
                125221
            ],
            [
                125221,
                125187
            ],
            [
                125188,
                125222
            ],
            [
                125222,
                125188
            ],
            [
                125189,
                125223
            ],
            [
                125223,
                125189
            ],
            [
                125190,
                125224
            ],
            [
                125224,
                125190
            ],
            [
                125191,
                125225
            ],
            [
                125225,
                125191
            ],
            [
                125192,
                125226
            ],
            [
                125226,
                125192
            ],
            [
                125193,
                125227
            ],
            [
                125227,
                125193
            ],
            [
                125194,
                125228
            ],
            [
                125228,
                125194
            ],
            [
                125195,
                125229
            ],
            [
                125229,
                125195
            ],
            [
                125196,
                125230
            ],
            [
                125230,
                125196
            ],
            [
                125197,
                125231
            ],
            [
                125231,
                125197
            ],
            [
                125198,
                125232
            ],
            [
                125232,
                125198
            ],
            [
                125199,
                125233
            ],
            [
                125233,
                125199
            ],
            [
                125200,
                125234
            ],
            [
                125234,
                125200
            ],
            [
                125201,
                125235
            ],
            [
                125235,
                125201
            ],
            [
                125202,
                125236
            ],
            [
                125236,
                125202
            ],
            [
                125203,
                125237
            ],
            [
                125237,
                125203
            ],
            [
                125204,
                125238
            ],
            [
                125238,
                125204
            ],
            [
                125205,
                125239
            ],
            [
                125239,
                125205
            ],
            [
                125206,
                125240
            ],
            [
                125240,
                125206
            ],
            [
                125207,
                125241
            ],
            [
                125241,
                125207
            ],
            [
                125208,
                125242
            ],
            [
                125242,
                125208
            ],
            [
                125209,
                125243
            ],
            [
                125243,
                125209
            ],
            [
                125210,
                125244
            ],
            [
                125244,
                125210
            ],
            [
                125211,
                125245
            ],
            [
                125245,
                125211
            ],
            [
                125212,
                125246
            ],
            [
                125246,
                125212
            ],
            [
                125213,
                125247
            ],
            [
                125247,
                125213
            ],
            [
                125214,
                125248
            ],
            [
                125248,
                125214
            ],
            [
                125215,
                125249
            ],
            [
                125249,
                125215
            ],
            [
                125216,
                125250
            ],
            [
                125250,
                125216
            ],
            [
                125217,
                125251
            ],
            [
                125251,
                125217
            ]
        ]))();
    static C = [
        [
            0,
            31,
            1
        ],
        [
            127,
            159,
            1
        ],
        [
            173,
            888,
            715
        ],
        [
            889,
            896,
            7
        ],
        [
            897,
            899,
            1
        ],
        [
            907,
            909,
            2
        ],
        [
            930,
            1328,
            398
        ],
        [
            1367,
            1368,
            1
        ],
        [
            1419,
            1420,
            1
        ],
        [
            1424,
            1480,
            56
        ],
        [
            1481,
            1487,
            1
        ],
        [
            1515,
            1518,
            1
        ],
        [
            1525,
            1541,
            1
        ],
        [
            1564,
            1757,
            193
        ],
        [
            1806,
            1807,
            1
        ],
        [
            1867,
            1868,
            1
        ],
        [
            1970,
            1983,
            1
        ],
        [
            2043,
            2044,
            1
        ],
        [
            2094,
            2095,
            1
        ],
        [
            2111,
            2140,
            29
        ],
        [
            2141,
            2143,
            2
        ],
        [
            2155,
            2159,
            1
        ],
        [
            2191,
            2199,
            1
        ],
        [
            2274,
            2436,
            162
        ],
        [
            2445,
            2446,
            1
        ],
        [
            2449,
            2450,
            1
        ],
        [
            2473,
            2481,
            8
        ],
        [
            2483,
            2485,
            1
        ],
        [
            2490,
            2491,
            1
        ],
        [
            2501,
            2502,
            1
        ],
        [
            2505,
            2506,
            1
        ],
        [
            2511,
            2518,
            1
        ],
        [
            2520,
            2523,
            1
        ],
        [
            2526,
            2532,
            6
        ],
        [
            2533,
            2559,
            26
        ],
        [
            2560,
            2564,
            4
        ],
        [
            2571,
            2574,
            1
        ],
        [
            2577,
            2578,
            1
        ],
        [
            2601,
            2609,
            8
        ],
        [
            2612,
            2618,
            3
        ],
        [
            2619,
            2621,
            2
        ],
        [
            2627,
            2630,
            1
        ],
        [
            2633,
            2634,
            1
        ],
        [
            2638,
            2640,
            1
        ],
        [
            2642,
            2648,
            1
        ],
        [
            2653,
            2655,
            2
        ],
        [
            2656,
            2661,
            1
        ],
        [
            2679,
            2688,
            1
        ],
        [
            2692,
            2702,
            10
        ],
        [
            2706,
            2729,
            23
        ],
        [
            2737,
            2740,
            3
        ],
        [
            2746,
            2747,
            1
        ],
        [
            2758,
            2766,
            4
        ],
        [
            2767,
            2769,
            2
        ],
        [
            2770,
            2783,
            1
        ],
        [
            2788,
            2789,
            1
        ],
        [
            2802,
            2808,
            1
        ],
        [
            2816,
            2820,
            4
        ],
        [
            2829,
            2830,
            1
        ],
        [
            2833,
            2834,
            1
        ],
        [
            2857,
            2865,
            8
        ],
        [
            2868,
            2874,
            6
        ],
        [
            2875,
            2885,
            10
        ],
        [
            2886,
            2889,
            3
        ],
        [
            2890,
            2894,
            4
        ],
        [
            2895,
            2900,
            1
        ],
        [
            2904,
            2907,
            1
        ],
        [
            2910,
            2916,
            6
        ],
        [
            2917,
            2936,
            19
        ],
        [
            2937,
            2945,
            1
        ],
        [
            2948,
            2955,
            7
        ],
        [
            2956,
            2957,
            1
        ],
        [
            2961,
            2966,
            5
        ],
        [
            2967,
            2968,
            1
        ],
        [
            2971,
            2973,
            2
        ],
        [
            2976,
            2978,
            1
        ],
        [
            2981,
            2983,
            1
        ],
        [
            2987,
            2989,
            1
        ],
        [
            3002,
            3005,
            1
        ],
        [
            3011,
            3013,
            1
        ],
        [
            3017,
            3022,
            5
        ],
        [
            3023,
            3025,
            2
        ],
        [
            3026,
            3030,
            1
        ],
        [
            3032,
            3045,
            1
        ],
        [
            3067,
            3071,
            1
        ],
        [
            3085,
            3089,
            4
        ],
        [
            3113,
            3130,
            17
        ],
        [
            3131,
            3141,
            10
        ],
        [
            3145,
            3150,
            5
        ],
        [
            3151,
            3156,
            1
        ],
        [
            3159,
            3163,
            4
        ],
        [
            3164,
            3166,
            2
        ],
        [
            3167,
            3172,
            5
        ],
        [
            3173,
            3184,
            11
        ],
        [
            3185,
            3190,
            1
        ],
        [
            3213,
            3217,
            4
        ],
        [
            3241,
            3252,
            11
        ],
        [
            3258,
            3259,
            1
        ],
        [
            3269,
            3273,
            4
        ],
        [
            3278,
            3284,
            1
        ],
        [
            3287,
            3292,
            1
        ],
        [
            3295,
            3300,
            5
        ],
        [
            3301,
            3312,
            11
        ],
        [
            3316,
            3327,
            1
        ],
        [
            3341,
            3345,
            4
        ],
        [
            3397,
            3401,
            4
        ],
        [
            3408,
            3411,
            1
        ],
        [
            3428,
            3429,
            1
        ],
        [
            3456,
            3460,
            4
        ],
        [
            3479,
            3481,
            1
        ],
        [
            3506,
            3516,
            10
        ],
        [
            3518,
            3519,
            1
        ],
        [
            3527,
            3529,
            1
        ],
        [
            3531,
            3534,
            1
        ],
        [
            3541,
            3543,
            2
        ],
        [
            3552,
            3557,
            1
        ],
        [
            3568,
            3569,
            1
        ],
        [
            3573,
            3584,
            1
        ],
        [
            3643,
            3646,
            1
        ],
        [
            3676,
            3712,
            1
        ],
        [
            3715,
            3717,
            2
        ],
        [
            3723,
            3748,
            25
        ],
        [
            3750,
            3774,
            24
        ],
        [
            3775,
            3781,
            6
        ],
        [
            3783,
            3791,
            8
        ],
        [
            3802,
            3803,
            1
        ],
        [
            3808,
            3839,
            1
        ],
        [
            3912,
            3949,
            37
        ],
        [
            3950,
            3952,
            1
        ],
        [
            3992,
            4029,
            37
        ],
        [
            4045,
            4059,
            14
        ],
        [
            4060,
            4095,
            1
        ],
        [
            4294,
            4296,
            2
        ],
        [
            4297,
            4300,
            1
        ],
        [
            4302,
            4303,
            1
        ],
        [
            4681,
            4686,
            5
        ],
        [
            4687,
            4695,
            8
        ],
        [
            4697,
            4702,
            5
        ],
        [
            4703,
            4745,
            42
        ],
        [
            4750,
            4751,
            1
        ],
        [
            4785,
            4790,
            5
        ],
        [
            4791,
            4799,
            8
        ],
        [
            4801,
            4806,
            5
        ],
        [
            4807,
            4823,
            16
        ],
        [
            4881,
            4886,
            5
        ],
        [
            4887,
            4955,
            68
        ],
        [
            4956,
            4989,
            33
        ],
        [
            4990,
            4991,
            1
        ],
        [
            5018,
            5023,
            1
        ],
        [
            5110,
            5111,
            1
        ],
        [
            5118,
            5119,
            1
        ],
        [
            5789,
            5791,
            1
        ],
        [
            5881,
            5887,
            1
        ],
        [
            5910,
            5918,
            1
        ],
        [
            5943,
            5951,
            1
        ],
        [
            5972,
            5983,
            1
        ],
        [
            5997,
            6001,
            4
        ],
        [
            6004,
            6015,
            1
        ],
        [
            6110,
            6111,
            1
        ],
        [
            6122,
            6127,
            1
        ],
        [
            6138,
            6143,
            1
        ],
        [
            6158,
            6170,
            12
        ],
        [
            6171,
            6175,
            1
        ],
        [
            6265,
            6271,
            1
        ],
        [
            6315,
            6319,
            1
        ],
        [
            6390,
            6399,
            1
        ],
        [
            6431,
            6444,
            13
        ],
        [
            6445,
            6447,
            1
        ],
        [
            6460,
            6463,
            1
        ],
        [
            6465,
            6467,
            1
        ],
        [
            6510,
            6511,
            1
        ],
        [
            6517,
            6527,
            1
        ],
        [
            6572,
            6575,
            1
        ],
        [
            6602,
            6607,
            1
        ],
        [
            6619,
            6621,
            1
        ],
        [
            6684,
            6685,
            1
        ],
        [
            6751,
            6781,
            30
        ],
        [
            6782,
            6794,
            12
        ],
        [
            6795,
            6799,
            1
        ],
        [
            6810,
            6815,
            1
        ],
        [
            6830,
            6831,
            1
        ],
        [
            6863,
            6911,
            1
        ],
        [
            6989,
            6991,
            1
        ],
        [
            7039,
            7156,
            117
        ],
        [
            7157,
            7163,
            1
        ],
        [
            7224,
            7226,
            1
        ],
        [
            7242,
            7244,
            1
        ],
        [
            7305,
            7311,
            1
        ],
        [
            7355,
            7356,
            1
        ],
        [
            7368,
            7375,
            1
        ],
        [
            7419,
            7423,
            1
        ],
        [
            7958,
            7959,
            1
        ],
        [
            7966,
            7967,
            1
        ],
        [
            8006,
            8007,
            1
        ],
        [
            8014,
            8015,
            1
        ],
        [
            8024,
            8030,
            2
        ],
        [
            8062,
            8063,
            1
        ],
        [
            8117,
            8133,
            16
        ],
        [
            8148,
            8149,
            1
        ],
        [
            8156,
            8176,
            20
        ],
        [
            8177,
            8181,
            4
        ],
        [
            8191,
            8203,
            12
        ],
        [
            8204,
            8207,
            1
        ],
        [
            8234,
            8238,
            1
        ],
        [
            8288,
            8303,
            1
        ],
        [
            8306,
            8307,
            1
        ],
        [
            8335,
            8349,
            14
        ],
        [
            8350,
            8351,
            1
        ],
        [
            8385,
            8399,
            1
        ],
        [
            8433,
            8447,
            1
        ],
        [
            8588,
            8591,
            1
        ],
        [
            9255,
            9279,
            1
        ],
        [
            9291,
            9311,
            1
        ],
        [
            11124,
            11125,
            1
        ],
        [
            11158,
            11508,
            350
        ],
        [
            11509,
            11512,
            1
        ],
        [
            11558,
            11560,
            2
        ],
        [
            11561,
            11564,
            1
        ],
        [
            11566,
            11567,
            1
        ],
        [
            11624,
            11630,
            1
        ],
        [
            11633,
            11646,
            1
        ],
        [
            11671,
            11679,
            1
        ],
        [
            11687,
            11743,
            8
        ],
        [
            11870,
            11903,
            1
        ],
        [
            11930,
            12020,
            90
        ],
        [
            12021,
            12031,
            1
        ],
        [
            12246,
            12271,
            1
        ],
        [
            12352,
            12439,
            87
        ],
        [
            12440,
            12544,
            104
        ],
        [
            12545,
            12548,
            1
        ],
        [
            12592,
            12687,
            95
        ],
        [
            12772,
            12782,
            1
        ],
        [
            12831,
            42125,
            29294
        ],
        [
            42126,
            42127,
            1
        ],
        [
            42183,
            42191,
            1
        ],
        [
            42540,
            42559,
            1
        ],
        [
            42744,
            42751,
            1
        ],
        [
            42955,
            42959,
            1
        ],
        [
            42962,
            42964,
            2
        ],
        [
            42970,
            42993,
            1
        ],
        [
            43053,
            43055,
            1
        ],
        [
            43066,
            43071,
            1
        ],
        [
            43128,
            43135,
            1
        ],
        [
            43206,
            43213,
            1
        ],
        [
            43226,
            43231,
            1
        ],
        [
            43348,
            43358,
            1
        ],
        [
            43389,
            43391,
            1
        ],
        [
            43470,
            43482,
            12
        ],
        [
            43483,
            43485,
            1
        ],
        [
            43519,
            43575,
            56
        ],
        [
            43576,
            43583,
            1
        ],
        [
            43598,
            43599,
            1
        ],
        [
            43610,
            43611,
            1
        ],
        [
            43715,
            43738,
            1
        ],
        [
            43767,
            43776,
            1
        ],
        [
            43783,
            43784,
            1
        ],
        [
            43791,
            43792,
            1
        ],
        [
            43799,
            43807,
            1
        ],
        [
            43815,
            43823,
            8
        ],
        [
            43884,
            43887,
            1
        ],
        [
            44014,
            44015,
            1
        ],
        [
            44026,
            44031,
            1
        ],
        [
            55204,
            55215,
            1
        ],
        [
            55239,
            55242,
            1
        ],
        [
            55292,
            63743,
            1
        ],
        [
            64110,
            64111,
            1
        ],
        [
            64218,
            64255,
            1
        ],
        [
            64263,
            64274,
            1
        ],
        [
            64280,
            64284,
            1
        ],
        [
            64311,
            64317,
            6
        ],
        [
            64319,
            64325,
            3
        ],
        [
            64451,
            64466,
            1
        ],
        [
            64912,
            64913,
            1
        ],
        [
            64968,
            64974,
            1
        ],
        [
            64976,
            65007,
            1
        ],
        [
            65050,
            65055,
            1
        ],
        [
            65107,
            65127,
            20
        ],
        [
            65132,
            65135,
            1
        ],
        [
            65141,
            65277,
            136
        ],
        [
            65278,
            65280,
            1
        ],
        [
            65471,
            65473,
            1
        ],
        [
            65480,
            65481,
            1
        ],
        [
            65488,
            65489,
            1
        ],
        [
            65496,
            65497,
            1
        ],
        [
            65501,
            65503,
            1
        ],
        [
            65511,
            65519,
            8
        ],
        [
            65520,
            65531,
            1
        ],
        [
            65534,
            65535,
            1
        ],
        [
            65548,
            65575,
            27
        ],
        [
            65595,
            65598,
            3
        ],
        [
            65614,
            65615,
            1
        ],
        [
            65630,
            65663,
            1
        ],
        [
            65787,
            65791,
            1
        ],
        [
            65795,
            65798,
            1
        ],
        [
            65844,
            65846,
            1
        ],
        [
            65935,
            65949,
            14
        ],
        [
            65950,
            65951,
            1
        ],
        [
            65953,
            65999,
            1
        ],
        [
            66046,
            66175,
            1
        ],
        [
            66205,
            66207,
            1
        ],
        [
            66257,
            66271,
            1
        ],
        [
            66300,
            66303,
            1
        ],
        [
            66340,
            66348,
            1
        ],
        [
            66379,
            66383,
            1
        ],
        [
            66427,
            66431,
            1
        ],
        [
            66462,
            66500,
            38
        ],
        [
            66501,
            66503,
            1
        ],
        [
            66518,
            66559,
            1
        ],
        [
            66718,
            66719,
            1
        ],
        [
            66730,
            66735,
            1
        ],
        [
            66772,
            66775,
            1
        ],
        [
            66812,
            66815,
            1
        ],
        [
            66856,
            66863,
            1
        ],
        [
            66916,
            66926,
            1
        ],
        [
            66939,
            66955,
            16
        ],
        [
            66963,
            66966,
            3
        ],
        [
            66978,
            66994,
            16
        ],
        [
            67002,
            67005,
            3
        ],
        [
            67006,
            67071,
            1
        ],
        [
            67383,
            67391,
            1
        ],
        [
            67414,
            67423,
            1
        ],
        [
            67432,
            67455,
            1
        ],
        [
            67462,
            67505,
            43
        ],
        [
            67515,
            67583,
            1
        ],
        [
            67590,
            67591,
            1
        ],
        [
            67593,
            67638,
            45
        ],
        [
            67641,
            67643,
            1
        ],
        [
            67645,
            67646,
            1
        ],
        [
            67670,
            67743,
            73
        ],
        [
            67744,
            67750,
            1
        ],
        [
            67760,
            67807,
            1
        ],
        [
            67827,
            67830,
            3
        ],
        [
            67831,
            67834,
            1
        ],
        [
            67868,
            67870,
            1
        ],
        [
            67898,
            67902,
            1
        ],
        [
            67904,
            67967,
            1
        ],
        [
            68024,
            68027,
            1
        ],
        [
            68048,
            68049,
            1
        ],
        [
            68100,
            68103,
            3
        ],
        [
            68104,
            68107,
            1
        ],
        [
            68116,
            68120,
            4
        ],
        [
            68150,
            68151,
            1
        ],
        [
            68155,
            68158,
            1
        ],
        [
            68169,
            68175,
            1
        ],
        [
            68185,
            68191,
            1
        ],
        [
            68256,
            68287,
            1
        ],
        [
            68327,
            68330,
            1
        ],
        [
            68343,
            68351,
            1
        ],
        [
            68406,
            68408,
            1
        ],
        [
            68438,
            68439,
            1
        ],
        [
            68467,
            68471,
            1
        ],
        [
            68498,
            68504,
            1
        ],
        [
            68509,
            68520,
            1
        ],
        [
            68528,
            68607,
            1
        ],
        [
            68681,
            68735,
            1
        ],
        [
            68787,
            68799,
            1
        ],
        [
            68851,
            68857,
            1
        ],
        [
            68904,
            68911,
            1
        ],
        [
            68922,
            69215,
            1
        ],
        [
            69247,
            69290,
            43
        ],
        [
            69294,
            69295,
            1
        ],
        [
            69298,
            69372,
            1
        ],
        [
            69416,
            69423,
            1
        ],
        [
            69466,
            69487,
            1
        ],
        [
            69514,
            69551,
            1
        ],
        [
            69580,
            69599,
            1
        ],
        [
            69623,
            69631,
            1
        ],
        [
            69710,
            69713,
            1
        ],
        [
            69750,
            69758,
            1
        ],
        [
            69821,
            69827,
            6
        ],
        [
            69828,
            69839,
            1
        ],
        [
            69865,
            69871,
            1
        ],
        [
            69882,
            69887,
            1
        ],
        [
            69941,
            69960,
            19
        ],
        [
            69961,
            69967,
            1
        ],
        [
            70007,
            70015,
            1
        ],
        [
            70112,
            70133,
            21
        ],
        [
            70134,
            70143,
            1
        ],
        [
            70162,
            70210,
            48
        ],
        [
            70211,
            70271,
            1
        ],
        [
            70279,
            70281,
            2
        ],
        [
            70286,
            70302,
            16
        ],
        [
            70314,
            70319,
            1
        ],
        [
            70379,
            70383,
            1
        ],
        [
            70394,
            70399,
            1
        ],
        [
            70404,
            70413,
            9
        ],
        [
            70414,
            70417,
            3
        ],
        [
            70418,
            70441,
            23
        ],
        [
            70449,
            70452,
            3
        ],
        [
            70458,
            70469,
            11
        ],
        [
            70470,
            70473,
            3
        ],
        [
            70474,
            70478,
            4
        ],
        [
            70479,
            70481,
            2
        ],
        [
            70482,
            70486,
            1
        ],
        [
            70488,
            70492,
            1
        ],
        [
            70500,
            70501,
            1
        ],
        [
            70509,
            70511,
            1
        ],
        [
            70517,
            70655,
            1
        ],
        [
            70748,
            70754,
            6
        ],
        [
            70755,
            70783,
            1
        ],
        [
            70856,
            70863,
            1
        ],
        [
            70874,
            71039,
            1
        ],
        [
            71094,
            71095,
            1
        ],
        [
            71134,
            71167,
            1
        ],
        [
            71237,
            71247,
            1
        ],
        [
            71258,
            71263,
            1
        ],
        [
            71277,
            71295,
            1
        ],
        [
            71354,
            71359,
            1
        ],
        [
            71370,
            71423,
            1
        ],
        [
            71451,
            71452,
            1
        ],
        [
            71468,
            71471,
            1
        ],
        [
            71495,
            71679,
            1
        ],
        [
            71740,
            71839,
            1
        ],
        [
            71923,
            71934,
            1
        ],
        [
            71943,
            71944,
            1
        ],
        [
            71946,
            71947,
            1
        ],
        [
            71956,
            71959,
            3
        ],
        [
            71990,
            71993,
            3
        ],
        [
            71994,
            72007,
            13
        ],
        [
            72008,
            72015,
            1
        ],
        [
            72026,
            72095,
            1
        ],
        [
            72104,
            72105,
            1
        ],
        [
            72152,
            72153,
            1
        ],
        [
            72165,
            72191,
            1
        ],
        [
            72264,
            72271,
            1
        ],
        [
            72355,
            72367,
            1
        ],
        [
            72441,
            72447,
            1
        ],
        [
            72458,
            72703,
            1
        ],
        [
            72713,
            72759,
            46
        ],
        [
            72774,
            72783,
            1
        ],
        [
            72813,
            72815,
            1
        ],
        [
            72848,
            72849,
            1
        ],
        [
            72872,
            72887,
            15
        ],
        [
            72888,
            72959,
            1
        ],
        [
            72967,
            72970,
            3
        ],
        [
            73015,
            73017,
            1
        ],
        [
            73019,
            73022,
            3
        ],
        [
            73032,
            73039,
            1
        ],
        [
            73050,
            73055,
            1
        ],
        [
            73062,
            73065,
            3
        ],
        [
            73103,
            73106,
            3
        ],
        [
            73113,
            73119,
            1
        ],
        [
            73130,
            73439,
            1
        ],
        [
            73465,
            73471,
            1
        ],
        [
            73489,
            73531,
            42
        ],
        [
            73532,
            73533,
            1
        ],
        [
            73562,
            73647,
            1
        ],
        [
            73649,
            73663,
            1
        ],
        [
            73714,
            73726,
            1
        ],
        [
            74650,
            74751,
            1
        ],
        [
            74863,
            74869,
            6
        ],
        [
            74870,
            74879,
            1
        ],
        [
            75076,
            77711,
            1
        ],
        [
            77811,
            77823,
            1
        ],
        [
            78896,
            78911,
            1
        ],
        [
            78934,
            82943,
            1
        ],
        [
            83527,
            92159,
            1
        ],
        [
            92729,
            92735,
            1
        ],
        [
            92767,
            92778,
            11
        ],
        [
            92779,
            92781,
            1
        ],
        [
            92863,
            92874,
            11
        ],
        [
            92875,
            92879,
            1
        ],
        [
            92910,
            92911,
            1
        ],
        [
            92918,
            92927,
            1
        ],
        [
            92998,
            93007,
            1
        ],
        [
            93018,
            93026,
            8
        ],
        [
            93048,
            93052,
            1
        ],
        [
            93072,
            93759,
            1
        ],
        [
            93851,
            93951,
            1
        ],
        [
            94027,
            94030,
            1
        ],
        [
            94088,
            94094,
            1
        ],
        [
            94112,
            94175,
            1
        ],
        [
            94181,
            94191,
            1
        ],
        [
            94194,
            94207,
            1
        ],
        [
            100344,
            100351,
            1
        ],
        [
            101590,
            101631,
            1
        ],
        [
            101641,
            110575,
            1
        ],
        [
            110580,
            110588,
            8
        ],
        [
            110591,
            110883,
            292
        ],
        [
            110884,
            110897,
            1
        ],
        [
            110899,
            110927,
            1
        ],
        [
            110931,
            110932,
            1
        ],
        [
            110934,
            110947,
            1
        ],
        [
            110952,
            110959,
            1
        ],
        [
            111356,
            113663,
            1
        ],
        [
            113771,
            113775,
            1
        ],
        [
            113789,
            113791,
            1
        ],
        [
            113801,
            113807,
            1
        ],
        [
            113818,
            113819,
            1
        ],
        [
            113824,
            118527,
            1
        ],
        [
            118574,
            118575,
            1
        ],
        [
            118599,
            118607,
            1
        ],
        [
            118724,
            118783,
            1
        ],
        [
            119030,
            119039,
            1
        ],
        [
            119079,
            119080,
            1
        ],
        [
            119155,
            119162,
            1
        ],
        [
            119275,
            119295,
            1
        ],
        [
            119366,
            119487,
            1
        ],
        [
            119508,
            119519,
            1
        ],
        [
            119540,
            119551,
            1
        ],
        [
            119639,
            119647,
            1
        ],
        [
            119673,
            119807,
            1
        ],
        [
            119893,
            119965,
            72
        ],
        [
            119968,
            119969,
            1
        ],
        [
            119971,
            119972,
            1
        ],
        [
            119975,
            119976,
            1
        ],
        [
            119981,
            119994,
            13
        ],
        [
            119996,
            120004,
            8
        ],
        [
            120070,
            120075,
            5
        ],
        [
            120076,
            120085,
            9
        ],
        [
            120093,
            120122,
            29
        ],
        [
            120127,
            120133,
            6
        ],
        [
            120135,
            120137,
            1
        ],
        [
            120145,
            120486,
            341
        ],
        [
            120487,
            120780,
            293
        ],
        [
            120781,
            121484,
            703
        ],
        [
            121485,
            121498,
            1
        ],
        [
            121504,
            121520,
            16
        ],
        [
            121521,
            122623,
            1
        ],
        [
            122655,
            122660,
            1
        ],
        [
            122667,
            122879,
            1
        ],
        [
            122887,
            122905,
            18
        ],
        [
            122906,
            122914,
            8
        ],
        [
            122917,
            122923,
            6
        ],
        [
            122924,
            122927,
            1
        ],
        [
            122990,
            123022,
            1
        ],
        [
            123024,
            123135,
            1
        ],
        [
            123181,
            123183,
            1
        ],
        [
            123198,
            123199,
            1
        ],
        [
            123210,
            123213,
            1
        ],
        [
            123216,
            123535,
            1
        ],
        [
            123567,
            123583,
            1
        ],
        [
            123642,
            123646,
            1
        ],
        [
            123648,
            124111,
            1
        ],
        [
            124154,
            124895,
            1
        ],
        [
            124903,
            124908,
            5
        ],
        [
            124911,
            124927,
            16
        ],
        [
            125125,
            125126,
            1
        ],
        [
            125143,
            125183,
            1
        ],
        [
            125260,
            125263,
            1
        ],
        [
            125274,
            125277,
            1
        ],
        [
            125280,
            126064,
            1
        ],
        [
            126133,
            126208,
            1
        ],
        [
            126270,
            126463,
            1
        ],
        [
            126468,
            126496,
            28
        ],
        [
            126499,
            126501,
            2
        ],
        [
            126502,
            126504,
            2
        ],
        [
            126515,
            126520,
            5
        ],
        [
            126522,
            126524,
            2
        ],
        [
            126525,
            126529,
            1
        ],
        [
            126531,
            126534,
            1
        ],
        [
            126536,
            126540,
            2
        ],
        [
            126544,
            126547,
            3
        ],
        [
            126549,
            126550,
            1
        ],
        [
            126552,
            126560,
            2
        ],
        [
            126563,
            126565,
            2
        ],
        [
            126566,
            126571,
            5
        ],
        [
            126579,
            126589,
            5
        ],
        [
            126591,
            126602,
            11
        ],
        [
            126620,
            126624,
            1
        ],
        [
            126628,
            126634,
            6
        ],
        [
            126652,
            126703,
            1
        ],
        [
            126706,
            126975,
            1
        ],
        [
            127020,
            127023,
            1
        ],
        [
            127124,
            127135,
            1
        ],
        [
            127151,
            127152,
            1
        ],
        [
            127168,
            127184,
            16
        ],
        [
            127222,
            127231,
            1
        ],
        [
            127406,
            127461,
            1
        ],
        [
            127491,
            127503,
            1
        ],
        [
            127548,
            127551,
            1
        ],
        [
            127561,
            127567,
            1
        ],
        [
            127570,
            127583,
            1
        ],
        [
            127590,
            127743,
            1
        ],
        [
            128728,
            128731,
            1
        ],
        [
            128749,
            128751,
            1
        ],
        [
            128765,
            128767,
            1
        ],
        [
            128887,
            128890,
            1
        ],
        [
            128986,
            128991,
            1
        ],
        [
            129004,
            129007,
            1
        ],
        [
            129009,
            129023,
            1
        ],
        [
            129036,
            129039,
            1
        ],
        [
            129096,
            129103,
            1
        ],
        [
            129114,
            129119,
            1
        ],
        [
            129160,
            129167,
            1
        ],
        [
            129198,
            129199,
            1
        ],
        [
            129202,
            129279,
            1
        ],
        [
            129620,
            129631,
            1
        ],
        [
            129646,
            129647,
            1
        ],
        [
            129661,
            129663,
            1
        ],
        [
            129673,
            129679,
            1
        ],
        [
            129726,
            129734,
            8
        ],
        [
            129735,
            129741,
            1
        ],
        [
            129756,
            129759,
            1
        ],
        [
            129769,
            129775,
            1
        ],
        [
            129785,
            129791,
            1
        ],
        [
            129939,
            129995,
            56
        ],
        [
            129996,
            130031,
            1
        ],
        [
            130042,
            131071,
            1
        ],
        [
            173792,
            173823,
            1
        ],
        [
            177978,
            177983,
            1
        ],
        [
            178206,
            178207,
            1
        ],
        [
            183970,
            183983,
            1
        ],
        [
            191457,
            191471,
            1
        ],
        [
            192094,
            194559,
            1
        ],
        [
            195102,
            196607,
            1
        ],
        [
            201547,
            201551,
            1
        ],
        [
            205744,
            917759,
            1
        ],
        [
            918000,
            1114111,
            1
        ]
    ];
    static Cc = [
        [
            0,
            31,
            1
        ],
        [
            127,
            159,
            1
        ]
    ];
    static Cf = [
        [
            173,
            1536,
            1363
        ],
        [
            1537,
            1541,
            1
        ],
        [
            1564,
            1757,
            193
        ],
        [
            1807,
            2192,
            385
        ],
        [
            2193,
            2274,
            81
        ],
        [
            6158,
            8203,
            2045
        ],
        [
            8204,
            8207,
            1
        ],
        [
            8234,
            8238,
            1
        ],
        [
            8288,
            8292,
            1
        ],
        [
            8294,
            8303,
            1
        ],
        [
            65279,
            65529,
            250
        ],
        [
            65530,
            65531,
            1
        ],
        [
            69821,
            69837,
            16
        ],
        [
            78896,
            78911,
            1
        ],
        [
            113824,
            113827,
            1
        ],
        [
            119155,
            119162,
            1
        ],
        [
            917505,
            917536,
            31
        ],
        [
            917537,
            917631,
            1
        ]
    ];
    static Co = [
        [
            57344,
            63743,
            1
        ],
        [
            983040,
            1048573,
            1
        ],
        [
            1048576,
            1114109,
            1
        ]
    ];
    static Cs = [
        [
            55296,
            57343,
            1
        ]
    ];
    static L = [
        [
            65,
            90,
            1
        ],
        [
            97,
            122,
            1
        ],
        [
            170,
            181,
            11
        ],
        [
            186,
            192,
            6
        ],
        [
            193,
            214,
            1
        ],
        [
            216,
            246,
            1
        ],
        [
            248,
            705,
            1
        ],
        [
            710,
            721,
            1
        ],
        [
            736,
            740,
            1
        ],
        [
            748,
            750,
            2
        ],
        [
            880,
            884,
            1
        ],
        [
            886,
            887,
            1
        ],
        [
            890,
            893,
            1
        ],
        [
            895,
            902,
            7
        ],
        [
            904,
            906,
            1
        ],
        [
            908,
            910,
            2
        ],
        [
            911,
            929,
            1
        ],
        [
            931,
            1013,
            1
        ],
        [
            1015,
            1153,
            1
        ],
        [
            1162,
            1327,
            1
        ],
        [
            1329,
            1366,
            1
        ],
        [
            1369,
            1376,
            7
        ],
        [
            1377,
            1416,
            1
        ],
        [
            1488,
            1514,
            1
        ],
        [
            1519,
            1522,
            1
        ],
        [
            1568,
            1610,
            1
        ],
        [
            1646,
            1647,
            1
        ],
        [
            1649,
            1747,
            1
        ],
        [
            1749,
            1765,
            16
        ],
        [
            1766,
            1774,
            8
        ],
        [
            1775,
            1786,
            11
        ],
        [
            1787,
            1788,
            1
        ],
        [
            1791,
            1808,
            17
        ],
        [
            1810,
            1839,
            1
        ],
        [
            1869,
            1957,
            1
        ],
        [
            1969,
            1994,
            25
        ],
        [
            1995,
            2026,
            1
        ],
        [
            2036,
            2037,
            1
        ],
        [
            2042,
            2048,
            6
        ],
        [
            2049,
            2069,
            1
        ],
        [
            2074,
            2084,
            10
        ],
        [
            2088,
            2112,
            24
        ],
        [
            2113,
            2136,
            1
        ],
        [
            2144,
            2154,
            1
        ],
        [
            2160,
            2183,
            1
        ],
        [
            2185,
            2190,
            1
        ],
        [
            2208,
            2249,
            1
        ],
        [
            2308,
            2361,
            1
        ],
        [
            2365,
            2384,
            19
        ],
        [
            2392,
            2401,
            1
        ],
        [
            2417,
            2432,
            1
        ],
        [
            2437,
            2444,
            1
        ],
        [
            2447,
            2448,
            1
        ],
        [
            2451,
            2472,
            1
        ],
        [
            2474,
            2480,
            1
        ],
        [
            2482,
            2486,
            4
        ],
        [
            2487,
            2489,
            1
        ],
        [
            2493,
            2510,
            17
        ],
        [
            2524,
            2525,
            1
        ],
        [
            2527,
            2529,
            1
        ],
        [
            2544,
            2545,
            1
        ],
        [
            2556,
            2565,
            9
        ],
        [
            2566,
            2570,
            1
        ],
        [
            2575,
            2576,
            1
        ],
        [
            2579,
            2600,
            1
        ],
        [
            2602,
            2608,
            1
        ],
        [
            2610,
            2611,
            1
        ],
        [
            2613,
            2614,
            1
        ],
        [
            2616,
            2617,
            1
        ],
        [
            2649,
            2652,
            1
        ],
        [
            2654,
            2674,
            20
        ],
        [
            2675,
            2676,
            1
        ],
        [
            2693,
            2701,
            1
        ],
        [
            2703,
            2705,
            1
        ],
        [
            2707,
            2728,
            1
        ],
        [
            2730,
            2736,
            1
        ],
        [
            2738,
            2739,
            1
        ],
        [
            2741,
            2745,
            1
        ],
        [
            2749,
            2768,
            19
        ],
        [
            2784,
            2785,
            1
        ],
        [
            2809,
            2821,
            12
        ],
        [
            2822,
            2828,
            1
        ],
        [
            2831,
            2832,
            1
        ],
        [
            2835,
            2856,
            1
        ],
        [
            2858,
            2864,
            1
        ],
        [
            2866,
            2867,
            1
        ],
        [
            2869,
            2873,
            1
        ],
        [
            2877,
            2908,
            31
        ],
        [
            2909,
            2911,
            2
        ],
        [
            2912,
            2913,
            1
        ],
        [
            2929,
            2947,
            18
        ],
        [
            2949,
            2954,
            1
        ],
        [
            2958,
            2960,
            1
        ],
        [
            2962,
            2965,
            1
        ],
        [
            2969,
            2970,
            1
        ],
        [
            2972,
            2974,
            2
        ],
        [
            2975,
            2979,
            4
        ],
        [
            2980,
            2984,
            4
        ],
        [
            2985,
            2986,
            1
        ],
        [
            2990,
            3001,
            1
        ],
        [
            3024,
            3077,
            53
        ],
        [
            3078,
            3084,
            1
        ],
        [
            3086,
            3088,
            1
        ],
        [
            3090,
            3112,
            1
        ],
        [
            3114,
            3129,
            1
        ],
        [
            3133,
            3160,
            27
        ],
        [
            3161,
            3162,
            1
        ],
        [
            3165,
            3168,
            3
        ],
        [
            3169,
            3200,
            31
        ],
        [
            3205,
            3212,
            1
        ],
        [
            3214,
            3216,
            1
        ],
        [
            3218,
            3240,
            1
        ],
        [
            3242,
            3251,
            1
        ],
        [
            3253,
            3257,
            1
        ],
        [
            3261,
            3293,
            32
        ],
        [
            3294,
            3296,
            2
        ],
        [
            3297,
            3313,
            16
        ],
        [
            3314,
            3332,
            18
        ],
        [
            3333,
            3340,
            1
        ],
        [
            3342,
            3344,
            1
        ],
        [
            3346,
            3386,
            1
        ],
        [
            3389,
            3406,
            17
        ],
        [
            3412,
            3414,
            1
        ],
        [
            3423,
            3425,
            1
        ],
        [
            3450,
            3455,
            1
        ],
        [
            3461,
            3478,
            1
        ],
        [
            3482,
            3505,
            1
        ],
        [
            3507,
            3515,
            1
        ],
        [
            3517,
            3520,
            3
        ],
        [
            3521,
            3526,
            1
        ],
        [
            3585,
            3632,
            1
        ],
        [
            3634,
            3635,
            1
        ],
        [
            3648,
            3654,
            1
        ],
        [
            3713,
            3714,
            1
        ],
        [
            3716,
            3718,
            2
        ],
        [
            3719,
            3722,
            1
        ],
        [
            3724,
            3747,
            1
        ],
        [
            3749,
            3751,
            2
        ],
        [
            3752,
            3760,
            1
        ],
        [
            3762,
            3763,
            1
        ],
        [
            3773,
            3776,
            3
        ],
        [
            3777,
            3780,
            1
        ],
        [
            3782,
            3804,
            22
        ],
        [
            3805,
            3807,
            1
        ],
        [
            3840,
            3904,
            64
        ],
        [
            3905,
            3911,
            1
        ],
        [
            3913,
            3948,
            1
        ],
        [
            3976,
            3980,
            1
        ],
        [
            4096,
            4138,
            1
        ],
        [
            4159,
            4176,
            17
        ],
        [
            4177,
            4181,
            1
        ],
        [
            4186,
            4189,
            1
        ],
        [
            4193,
            4197,
            4
        ],
        [
            4198,
            4206,
            8
        ],
        [
            4207,
            4208,
            1
        ],
        [
            4213,
            4225,
            1
        ],
        [
            4238,
            4256,
            18
        ],
        [
            4257,
            4293,
            1
        ],
        [
            4295,
            4301,
            6
        ],
        [
            4304,
            4346,
            1
        ],
        [
            4348,
            4680,
            1
        ],
        [
            4682,
            4685,
            1
        ],
        [
            4688,
            4694,
            1
        ],
        [
            4696,
            4698,
            2
        ],
        [
            4699,
            4701,
            1
        ],
        [
            4704,
            4744,
            1
        ],
        [
            4746,
            4749,
            1
        ],
        [
            4752,
            4784,
            1
        ],
        [
            4786,
            4789,
            1
        ],
        [
            4792,
            4798,
            1
        ],
        [
            4800,
            4802,
            2
        ],
        [
            4803,
            4805,
            1
        ],
        [
            4808,
            4822,
            1
        ],
        [
            4824,
            4880,
            1
        ],
        [
            4882,
            4885,
            1
        ],
        [
            4888,
            4954,
            1
        ],
        [
            4992,
            5007,
            1
        ],
        [
            5024,
            5109,
            1
        ],
        [
            5112,
            5117,
            1
        ],
        [
            5121,
            5740,
            1
        ],
        [
            5743,
            5759,
            1
        ],
        [
            5761,
            5786,
            1
        ],
        [
            5792,
            5866,
            1
        ],
        [
            5873,
            5880,
            1
        ],
        [
            5888,
            5905,
            1
        ],
        [
            5919,
            5937,
            1
        ],
        [
            5952,
            5969,
            1
        ],
        [
            5984,
            5996,
            1
        ],
        [
            5998,
            6000,
            1
        ],
        [
            6016,
            6067,
            1
        ],
        [
            6103,
            6108,
            5
        ],
        [
            6176,
            6264,
            1
        ],
        [
            6272,
            6276,
            1
        ],
        [
            6279,
            6312,
            1
        ],
        [
            6314,
            6320,
            6
        ],
        [
            6321,
            6389,
            1
        ],
        [
            6400,
            6430,
            1
        ],
        [
            6480,
            6509,
            1
        ],
        [
            6512,
            6516,
            1
        ],
        [
            6528,
            6571,
            1
        ],
        [
            6576,
            6601,
            1
        ],
        [
            6656,
            6678,
            1
        ],
        [
            6688,
            6740,
            1
        ],
        [
            6823,
            6917,
            94
        ],
        [
            6918,
            6963,
            1
        ],
        [
            6981,
            6988,
            1
        ],
        [
            7043,
            7072,
            1
        ],
        [
            7086,
            7087,
            1
        ],
        [
            7098,
            7141,
            1
        ],
        [
            7168,
            7203,
            1
        ],
        [
            7245,
            7247,
            1
        ],
        [
            7258,
            7293,
            1
        ],
        [
            7296,
            7304,
            1
        ],
        [
            7312,
            7354,
            1
        ],
        [
            7357,
            7359,
            1
        ],
        [
            7401,
            7404,
            1
        ],
        [
            7406,
            7411,
            1
        ],
        [
            7413,
            7414,
            1
        ],
        [
            7418,
            7424,
            6
        ],
        [
            7425,
            7615,
            1
        ],
        [
            7680,
            7957,
            1
        ],
        [
            7960,
            7965,
            1
        ],
        [
            7968,
            8005,
            1
        ],
        [
            8008,
            8013,
            1
        ],
        [
            8016,
            8023,
            1
        ],
        [
            8025,
            8031,
            2
        ],
        [
            8032,
            8061,
            1
        ],
        [
            8064,
            8116,
            1
        ],
        [
            8118,
            8124,
            1
        ],
        [
            8126,
            8130,
            4
        ],
        [
            8131,
            8132,
            1
        ],
        [
            8134,
            8140,
            1
        ],
        [
            8144,
            8147,
            1
        ],
        [
            8150,
            8155,
            1
        ],
        [
            8160,
            8172,
            1
        ],
        [
            8178,
            8180,
            1
        ],
        [
            8182,
            8188,
            1
        ],
        [
            8305,
            8319,
            14
        ],
        [
            8336,
            8348,
            1
        ],
        [
            8450,
            8455,
            5
        ],
        [
            8458,
            8467,
            1
        ],
        [
            8469,
            8473,
            4
        ],
        [
            8474,
            8477,
            1
        ],
        [
            8484,
            8490,
            2
        ],
        [
            8491,
            8493,
            1
        ],
        [
            8495,
            8505,
            1
        ],
        [
            8508,
            8511,
            1
        ],
        [
            8517,
            8521,
            1
        ],
        [
            8526,
            8579,
            53
        ],
        [
            8580,
            11264,
            2684
        ],
        [
            11265,
            11492,
            1
        ],
        [
            11499,
            11502,
            1
        ],
        [
            11506,
            11507,
            1
        ],
        [
            11520,
            11557,
            1
        ],
        [
            11559,
            11565,
            6
        ],
        [
            11568,
            11623,
            1
        ],
        [
            11631,
            11648,
            17
        ],
        [
            11649,
            11670,
            1
        ],
        [
            11680,
            11686,
            1
        ],
        [
            11688,
            11694,
            1
        ],
        [
            11696,
            11702,
            1
        ],
        [
            11704,
            11710,
            1
        ],
        [
            11712,
            11718,
            1
        ],
        [
            11720,
            11726,
            1
        ],
        [
            11728,
            11734,
            1
        ],
        [
            11736,
            11742,
            1
        ],
        [
            11823,
            12293,
            470
        ],
        [
            12294,
            12337,
            43
        ],
        [
            12338,
            12341,
            1
        ],
        [
            12347,
            12348,
            1
        ],
        [
            12353,
            12438,
            1
        ],
        [
            12445,
            12447,
            1
        ],
        [
            12449,
            12538,
            1
        ],
        [
            12540,
            12543,
            1
        ],
        [
            12549,
            12591,
            1
        ],
        [
            12593,
            12686,
            1
        ],
        [
            12704,
            12735,
            1
        ],
        [
            12784,
            12799,
            1
        ],
        [
            13312,
            19903,
            1
        ],
        [
            19968,
            42124,
            1
        ],
        [
            42192,
            42237,
            1
        ],
        [
            42240,
            42508,
            1
        ],
        [
            42512,
            42527,
            1
        ],
        [
            42538,
            42539,
            1
        ],
        [
            42560,
            42606,
            1
        ],
        [
            42623,
            42653,
            1
        ],
        [
            42656,
            42725,
            1
        ],
        [
            42775,
            42783,
            1
        ],
        [
            42786,
            42888,
            1
        ],
        [
            42891,
            42954,
            1
        ],
        [
            42960,
            42961,
            1
        ],
        [
            42963,
            42965,
            2
        ],
        [
            42966,
            42969,
            1
        ],
        [
            42994,
            43009,
            1
        ],
        [
            43011,
            43013,
            1
        ],
        [
            43015,
            43018,
            1
        ],
        [
            43020,
            43042,
            1
        ],
        [
            43072,
            43123,
            1
        ],
        [
            43138,
            43187,
            1
        ],
        [
            43250,
            43255,
            1
        ],
        [
            43259,
            43261,
            2
        ],
        [
            43262,
            43274,
            12
        ],
        [
            43275,
            43301,
            1
        ],
        [
            43312,
            43334,
            1
        ],
        [
            43360,
            43388,
            1
        ],
        [
            43396,
            43442,
            1
        ],
        [
            43471,
            43488,
            17
        ],
        [
            43489,
            43492,
            1
        ],
        [
            43494,
            43503,
            1
        ],
        [
            43514,
            43518,
            1
        ],
        [
            43520,
            43560,
            1
        ],
        [
            43584,
            43586,
            1
        ],
        [
            43588,
            43595,
            1
        ],
        [
            43616,
            43638,
            1
        ],
        [
            43642,
            43646,
            4
        ],
        [
            43647,
            43695,
            1
        ],
        [
            43697,
            43701,
            4
        ],
        [
            43702,
            43705,
            3
        ],
        [
            43706,
            43709,
            1
        ],
        [
            43712,
            43714,
            2
        ],
        [
            43739,
            43741,
            1
        ],
        [
            43744,
            43754,
            1
        ],
        [
            43762,
            43764,
            1
        ],
        [
            43777,
            43782,
            1
        ],
        [
            43785,
            43790,
            1
        ],
        [
            43793,
            43798,
            1
        ],
        [
            43808,
            43814,
            1
        ],
        [
            43816,
            43822,
            1
        ],
        [
            43824,
            43866,
            1
        ],
        [
            43868,
            43881,
            1
        ],
        [
            43888,
            44002,
            1
        ],
        [
            44032,
            55203,
            1
        ],
        [
            55216,
            55238,
            1
        ],
        [
            55243,
            55291,
            1
        ],
        [
            63744,
            64109,
            1
        ],
        [
            64112,
            64217,
            1
        ],
        [
            64256,
            64262,
            1
        ],
        [
            64275,
            64279,
            1
        ],
        [
            64285,
            64287,
            2
        ],
        [
            64288,
            64296,
            1
        ],
        [
            64298,
            64310,
            1
        ],
        [
            64312,
            64316,
            1
        ],
        [
            64318,
            64320,
            2
        ],
        [
            64321,
            64323,
            2
        ],
        [
            64324,
            64326,
            2
        ],
        [
            64327,
            64433,
            1
        ],
        [
            64467,
            64829,
            1
        ],
        [
            64848,
            64911,
            1
        ],
        [
            64914,
            64967,
            1
        ],
        [
            65008,
            65019,
            1
        ],
        [
            65136,
            65140,
            1
        ],
        [
            65142,
            65276,
            1
        ],
        [
            65313,
            65338,
            1
        ],
        [
            65345,
            65370,
            1
        ],
        [
            65382,
            65470,
            1
        ],
        [
            65474,
            65479,
            1
        ],
        [
            65482,
            65487,
            1
        ],
        [
            65490,
            65495,
            1
        ],
        [
            65498,
            65500,
            1
        ],
        [
            65536,
            65547,
            1
        ],
        [
            65549,
            65574,
            1
        ],
        [
            65576,
            65594,
            1
        ],
        [
            65596,
            65597,
            1
        ],
        [
            65599,
            65613,
            1
        ],
        [
            65616,
            65629,
            1
        ],
        [
            65664,
            65786,
            1
        ],
        [
            66176,
            66204,
            1
        ],
        [
            66208,
            66256,
            1
        ],
        [
            66304,
            66335,
            1
        ],
        [
            66349,
            66368,
            1
        ],
        [
            66370,
            66377,
            1
        ],
        [
            66384,
            66421,
            1
        ],
        [
            66432,
            66461,
            1
        ],
        [
            66464,
            66499,
            1
        ],
        [
            66504,
            66511,
            1
        ],
        [
            66560,
            66717,
            1
        ],
        [
            66736,
            66771,
            1
        ],
        [
            66776,
            66811,
            1
        ],
        [
            66816,
            66855,
            1
        ],
        [
            66864,
            66915,
            1
        ],
        [
            66928,
            66938,
            1
        ],
        [
            66940,
            66954,
            1
        ],
        [
            66956,
            66962,
            1
        ],
        [
            66964,
            66965,
            1
        ],
        [
            66967,
            66977,
            1
        ],
        [
            66979,
            66993,
            1
        ],
        [
            66995,
            67001,
            1
        ],
        [
            67003,
            67004,
            1
        ],
        [
            67072,
            67382,
            1
        ],
        [
            67392,
            67413,
            1
        ],
        [
            67424,
            67431,
            1
        ],
        [
            67456,
            67461,
            1
        ],
        [
            67463,
            67504,
            1
        ],
        [
            67506,
            67514,
            1
        ],
        [
            67584,
            67589,
            1
        ],
        [
            67592,
            67594,
            2
        ],
        [
            67595,
            67637,
            1
        ],
        [
            67639,
            67640,
            1
        ],
        [
            67644,
            67647,
            3
        ],
        [
            67648,
            67669,
            1
        ],
        [
            67680,
            67702,
            1
        ],
        [
            67712,
            67742,
            1
        ],
        [
            67808,
            67826,
            1
        ],
        [
            67828,
            67829,
            1
        ],
        [
            67840,
            67861,
            1
        ],
        [
            67872,
            67897,
            1
        ],
        [
            67968,
            68023,
            1
        ],
        [
            68030,
            68031,
            1
        ],
        [
            68096,
            68112,
            16
        ],
        [
            68113,
            68115,
            1
        ],
        [
            68117,
            68119,
            1
        ],
        [
            68121,
            68149,
            1
        ],
        [
            68192,
            68220,
            1
        ],
        [
            68224,
            68252,
            1
        ],
        [
            68288,
            68295,
            1
        ],
        [
            68297,
            68324,
            1
        ],
        [
            68352,
            68405,
            1
        ],
        [
            68416,
            68437,
            1
        ],
        [
            68448,
            68466,
            1
        ],
        [
            68480,
            68497,
            1
        ],
        [
            68608,
            68680,
            1
        ],
        [
            68736,
            68786,
            1
        ],
        [
            68800,
            68850,
            1
        ],
        [
            68864,
            68899,
            1
        ],
        [
            69248,
            69289,
            1
        ],
        [
            69296,
            69297,
            1
        ],
        [
            69376,
            69404,
            1
        ],
        [
            69415,
            69424,
            9
        ],
        [
            69425,
            69445,
            1
        ],
        [
            69488,
            69505,
            1
        ],
        [
            69552,
            69572,
            1
        ],
        [
            69600,
            69622,
            1
        ],
        [
            69635,
            69687,
            1
        ],
        [
            69745,
            69746,
            1
        ],
        [
            69749,
            69763,
            14
        ],
        [
            69764,
            69807,
            1
        ],
        [
            69840,
            69864,
            1
        ],
        [
            69891,
            69926,
            1
        ],
        [
            69956,
            69959,
            3
        ],
        [
            69968,
            70002,
            1
        ],
        [
            70006,
            70019,
            13
        ],
        [
            70020,
            70066,
            1
        ],
        [
            70081,
            70084,
            1
        ],
        [
            70106,
            70108,
            2
        ],
        [
            70144,
            70161,
            1
        ],
        [
            70163,
            70187,
            1
        ],
        [
            70207,
            70208,
            1
        ],
        [
            70272,
            70278,
            1
        ],
        [
            70280,
            70282,
            2
        ],
        [
            70283,
            70285,
            1
        ],
        [
            70287,
            70301,
            1
        ],
        [
            70303,
            70312,
            1
        ],
        [
            70320,
            70366,
            1
        ],
        [
            70405,
            70412,
            1
        ],
        [
            70415,
            70416,
            1
        ],
        [
            70419,
            70440,
            1
        ],
        [
            70442,
            70448,
            1
        ],
        [
            70450,
            70451,
            1
        ],
        [
            70453,
            70457,
            1
        ],
        [
            70461,
            70480,
            19
        ],
        [
            70493,
            70497,
            1
        ],
        [
            70656,
            70708,
            1
        ],
        [
            70727,
            70730,
            1
        ],
        [
            70751,
            70753,
            1
        ],
        [
            70784,
            70831,
            1
        ],
        [
            70852,
            70853,
            1
        ],
        [
            70855,
            71040,
            185
        ],
        [
            71041,
            71086,
            1
        ],
        [
            71128,
            71131,
            1
        ],
        [
            71168,
            71215,
            1
        ],
        [
            71236,
            71296,
            60
        ],
        [
            71297,
            71338,
            1
        ],
        [
            71352,
            71424,
            72
        ],
        [
            71425,
            71450,
            1
        ],
        [
            71488,
            71494,
            1
        ],
        [
            71680,
            71723,
            1
        ],
        [
            71840,
            71903,
            1
        ],
        [
            71935,
            71942,
            1
        ],
        [
            71945,
            71948,
            3
        ],
        [
            71949,
            71955,
            1
        ],
        [
            71957,
            71958,
            1
        ],
        [
            71960,
            71983,
            1
        ],
        [
            71999,
            72001,
            2
        ],
        [
            72096,
            72103,
            1
        ],
        [
            72106,
            72144,
            1
        ],
        [
            72161,
            72163,
            2
        ],
        [
            72192,
            72203,
            11
        ],
        [
            72204,
            72242,
            1
        ],
        [
            72250,
            72272,
            22
        ],
        [
            72284,
            72329,
            1
        ],
        [
            72349,
            72368,
            19
        ],
        [
            72369,
            72440,
            1
        ],
        [
            72704,
            72712,
            1
        ],
        [
            72714,
            72750,
            1
        ],
        [
            72768,
            72818,
            50
        ],
        [
            72819,
            72847,
            1
        ],
        [
            72960,
            72966,
            1
        ],
        [
            72968,
            72969,
            1
        ],
        [
            72971,
            73008,
            1
        ],
        [
            73030,
            73056,
            26
        ],
        [
            73057,
            73061,
            1
        ],
        [
            73063,
            73064,
            1
        ],
        [
            73066,
            73097,
            1
        ],
        [
            73112,
            73440,
            328
        ],
        [
            73441,
            73458,
            1
        ],
        [
            73474,
            73476,
            2
        ],
        [
            73477,
            73488,
            1
        ],
        [
            73490,
            73523,
            1
        ],
        [
            73648,
            73728,
            80
        ],
        [
            73729,
            74649,
            1
        ],
        [
            74880,
            75075,
            1
        ],
        [
            77712,
            77808,
            1
        ],
        [
            77824,
            78895,
            1
        ],
        [
            78913,
            78918,
            1
        ],
        [
            82944,
            83526,
            1
        ],
        [
            92160,
            92728,
            1
        ],
        [
            92736,
            92766,
            1
        ],
        [
            92784,
            92862,
            1
        ],
        [
            92880,
            92909,
            1
        ],
        [
            92928,
            92975,
            1
        ],
        [
            92992,
            92995,
            1
        ],
        [
            93027,
            93047,
            1
        ],
        [
            93053,
            93071,
            1
        ],
        [
            93760,
            93823,
            1
        ],
        [
            93952,
            94026,
            1
        ],
        [
            94032,
            94099,
            67
        ],
        [
            94100,
            94111,
            1
        ],
        [
            94176,
            94177,
            1
        ],
        [
            94179,
            94208,
            29
        ],
        [
            94209,
            100343,
            1
        ],
        [
            100352,
            101589,
            1
        ],
        [
            101632,
            101640,
            1
        ],
        [
            110576,
            110579,
            1
        ],
        [
            110581,
            110587,
            1
        ],
        [
            110589,
            110590,
            1
        ],
        [
            110592,
            110882,
            1
        ],
        [
            110898,
            110928,
            30
        ],
        [
            110929,
            110930,
            1
        ],
        [
            110933,
            110948,
            15
        ],
        [
            110949,
            110951,
            1
        ],
        [
            110960,
            111355,
            1
        ],
        [
            113664,
            113770,
            1
        ],
        [
            113776,
            113788,
            1
        ],
        [
            113792,
            113800,
            1
        ],
        [
            113808,
            113817,
            1
        ],
        [
            119808,
            119892,
            1
        ],
        [
            119894,
            119964,
            1
        ],
        [
            119966,
            119967,
            1
        ],
        [
            119970,
            119973,
            3
        ],
        [
            119974,
            119977,
            3
        ],
        [
            119978,
            119980,
            1
        ],
        [
            119982,
            119993,
            1
        ],
        [
            119995,
            119997,
            2
        ],
        [
            119998,
            120003,
            1
        ],
        [
            120005,
            120069,
            1
        ],
        [
            120071,
            120074,
            1
        ],
        [
            120077,
            120084,
            1
        ],
        [
            120086,
            120092,
            1
        ],
        [
            120094,
            120121,
            1
        ],
        [
            120123,
            120126,
            1
        ],
        [
            120128,
            120132,
            1
        ],
        [
            120134,
            120138,
            4
        ],
        [
            120139,
            120144,
            1
        ],
        [
            120146,
            120485,
            1
        ],
        [
            120488,
            120512,
            1
        ],
        [
            120514,
            120538,
            1
        ],
        [
            120540,
            120570,
            1
        ],
        [
            120572,
            120596,
            1
        ],
        [
            120598,
            120628,
            1
        ],
        [
            120630,
            120654,
            1
        ],
        [
            120656,
            120686,
            1
        ],
        [
            120688,
            120712,
            1
        ],
        [
            120714,
            120744,
            1
        ],
        [
            120746,
            120770,
            1
        ],
        [
            120772,
            120779,
            1
        ],
        [
            122624,
            122654,
            1
        ],
        [
            122661,
            122666,
            1
        ],
        [
            122928,
            122989,
            1
        ],
        [
            123136,
            123180,
            1
        ],
        [
            123191,
            123197,
            1
        ],
        [
            123214,
            123536,
            322
        ],
        [
            123537,
            123565,
            1
        ],
        [
            123584,
            123627,
            1
        ],
        [
            124112,
            124139,
            1
        ],
        [
            124896,
            124902,
            1
        ],
        [
            124904,
            124907,
            1
        ],
        [
            124909,
            124910,
            1
        ],
        [
            124912,
            124926,
            1
        ],
        [
            124928,
            125124,
            1
        ],
        [
            125184,
            125251,
            1
        ],
        [
            125259,
            126464,
            1205
        ],
        [
            126465,
            126467,
            1
        ],
        [
            126469,
            126495,
            1
        ],
        [
            126497,
            126498,
            1
        ],
        [
            126500,
            126503,
            3
        ],
        [
            126505,
            126514,
            1
        ],
        [
            126516,
            126519,
            1
        ],
        [
            126521,
            126523,
            2
        ],
        [
            126530,
            126535,
            5
        ],
        [
            126537,
            126541,
            2
        ],
        [
            126542,
            126543,
            1
        ],
        [
            126545,
            126546,
            1
        ],
        [
            126548,
            126551,
            3
        ],
        [
            126553,
            126561,
            2
        ],
        [
            126562,
            126564,
            2
        ],
        [
            126567,
            126570,
            1
        ],
        [
            126572,
            126578,
            1
        ],
        [
            126580,
            126583,
            1
        ],
        [
            126585,
            126588,
            1
        ],
        [
            126590,
            126592,
            2
        ],
        [
            126593,
            126601,
            1
        ],
        [
            126603,
            126619,
            1
        ],
        [
            126625,
            126627,
            1
        ],
        [
            126629,
            126633,
            1
        ],
        [
            126635,
            126651,
            1
        ],
        [
            131072,
            173791,
            1
        ],
        [
            173824,
            177977,
            1
        ],
        [
            177984,
            178205,
            1
        ],
        [
            178208,
            183969,
            1
        ],
        [
            183984,
            191456,
            1
        ],
        [
            191472,
            192093,
            1
        ],
        [
            194560,
            195101,
            1
        ],
        [
            196608,
            201546,
            1
        ],
        [
            201552,
            205743,
            1
        ]
    ];
    static foldL = [
        [
            837,
            837,
            1
        ]
    ];
    static Ll = [
        [
            97,
            122,
            1
        ],
        [
            181,
            223,
            42
        ],
        [
            224,
            246,
            1
        ],
        [
            248,
            255,
            1
        ],
        [
            257,
            311,
            2
        ],
        [
            312,
            328,
            2
        ],
        [
            329,
            375,
            2
        ],
        [
            378,
            382,
            2
        ],
        [
            383,
            384,
            1
        ],
        [
            387,
            389,
            2
        ],
        [
            392,
            396,
            4
        ],
        [
            397,
            402,
            5
        ],
        [
            405,
            409,
            4
        ],
        [
            410,
            411,
            1
        ],
        [
            414,
            417,
            3
        ],
        [
            419,
            421,
            2
        ],
        [
            424,
            426,
            2
        ],
        [
            427,
            429,
            2
        ],
        [
            432,
            436,
            4
        ],
        [
            438,
            441,
            3
        ],
        [
            442,
            445,
            3
        ],
        [
            446,
            447,
            1
        ],
        [
            454,
            460,
            3
        ],
        [
            462,
            476,
            2
        ],
        [
            477,
            495,
            2
        ],
        [
            496,
            499,
            3
        ],
        [
            501,
            505,
            4
        ],
        [
            507,
            563,
            2
        ],
        [
            564,
            569,
            1
        ],
        [
            572,
            575,
            3
        ],
        [
            576,
            578,
            2
        ],
        [
            583,
            591,
            2
        ],
        [
            592,
            659,
            1
        ],
        [
            661,
            687,
            1
        ],
        [
            881,
            883,
            2
        ],
        [
            887,
            891,
            4
        ],
        [
            892,
            893,
            1
        ],
        [
            912,
            940,
            28
        ],
        [
            941,
            974,
            1
        ],
        [
            976,
            977,
            1
        ],
        [
            981,
            983,
            1
        ],
        [
            985,
            1007,
            2
        ],
        [
            1008,
            1011,
            1
        ],
        [
            1013,
            1019,
            3
        ],
        [
            1020,
            1072,
            52
        ],
        [
            1073,
            1119,
            1
        ],
        [
            1121,
            1153,
            2
        ],
        [
            1163,
            1215,
            2
        ],
        [
            1218,
            1230,
            2
        ],
        [
            1231,
            1327,
            2
        ],
        [
            1376,
            1416,
            1
        ],
        [
            4304,
            4346,
            1
        ],
        [
            4349,
            4351,
            1
        ],
        [
            5112,
            5117,
            1
        ],
        [
            7296,
            7304,
            1
        ],
        [
            7424,
            7467,
            1
        ],
        [
            7531,
            7543,
            1
        ],
        [
            7545,
            7578,
            1
        ],
        [
            7681,
            7829,
            2
        ],
        [
            7830,
            7837,
            1
        ],
        [
            7839,
            7935,
            2
        ],
        [
            7936,
            7943,
            1
        ],
        [
            7952,
            7957,
            1
        ],
        [
            7968,
            7975,
            1
        ],
        [
            7984,
            7991,
            1
        ],
        [
            8000,
            8005,
            1
        ],
        [
            8016,
            8023,
            1
        ],
        [
            8032,
            8039,
            1
        ],
        [
            8048,
            8061,
            1
        ],
        [
            8064,
            8071,
            1
        ],
        [
            8080,
            8087,
            1
        ],
        [
            8096,
            8103,
            1
        ],
        [
            8112,
            8116,
            1
        ],
        [
            8118,
            8119,
            1
        ],
        [
            8126,
            8130,
            4
        ],
        [
            8131,
            8132,
            1
        ],
        [
            8134,
            8135,
            1
        ],
        [
            8144,
            8147,
            1
        ],
        [
            8150,
            8151,
            1
        ],
        [
            8160,
            8167,
            1
        ],
        [
            8178,
            8180,
            1
        ],
        [
            8182,
            8183,
            1
        ],
        [
            8458,
            8462,
            4
        ],
        [
            8463,
            8467,
            4
        ],
        [
            8495,
            8505,
            5
        ],
        [
            8508,
            8509,
            1
        ],
        [
            8518,
            8521,
            1
        ],
        [
            8526,
            8580,
            54
        ],
        [
            11312,
            11359,
            1
        ],
        [
            11361,
            11365,
            4
        ],
        [
            11366,
            11372,
            2
        ],
        [
            11377,
            11379,
            2
        ],
        [
            11380,
            11382,
            2
        ],
        [
            11383,
            11387,
            1
        ],
        [
            11393,
            11491,
            2
        ],
        [
            11492,
            11500,
            8
        ],
        [
            11502,
            11507,
            5
        ],
        [
            11520,
            11557,
            1
        ],
        [
            11559,
            11565,
            6
        ],
        [
            42561,
            42605,
            2
        ],
        [
            42625,
            42651,
            2
        ],
        [
            42787,
            42799,
            2
        ],
        [
            42800,
            42801,
            1
        ],
        [
            42803,
            42865,
            2
        ],
        [
            42866,
            42872,
            1
        ],
        [
            42874,
            42876,
            2
        ],
        [
            42879,
            42887,
            2
        ],
        [
            42892,
            42894,
            2
        ],
        [
            42897,
            42899,
            2
        ],
        [
            42900,
            42901,
            1
        ],
        [
            42903,
            42921,
            2
        ],
        [
            42927,
            42933,
            6
        ],
        [
            42935,
            42947,
            2
        ],
        [
            42952,
            42954,
            2
        ],
        [
            42961,
            42969,
            2
        ],
        [
            42998,
            43002,
            4
        ],
        [
            43824,
            43866,
            1
        ],
        [
            43872,
            43880,
            1
        ],
        [
            43888,
            43967,
            1
        ],
        [
            64256,
            64262,
            1
        ],
        [
            64275,
            64279,
            1
        ],
        [
            65345,
            65370,
            1
        ],
        [
            66600,
            66639,
            1
        ],
        [
            66776,
            66811,
            1
        ],
        [
            66967,
            66977,
            1
        ],
        [
            66979,
            66993,
            1
        ],
        [
            66995,
            67001,
            1
        ],
        [
            67003,
            67004,
            1
        ],
        [
            68800,
            68850,
            1
        ],
        [
            71872,
            71903,
            1
        ],
        [
            93792,
            93823,
            1
        ],
        [
            119834,
            119859,
            1
        ],
        [
            119886,
            119892,
            1
        ],
        [
            119894,
            119911,
            1
        ],
        [
            119938,
            119963,
            1
        ],
        [
            119990,
            119993,
            1
        ],
        [
            119995,
            119997,
            2
        ],
        [
            119998,
            120003,
            1
        ],
        [
            120005,
            120015,
            1
        ],
        [
            120042,
            120067,
            1
        ],
        [
            120094,
            120119,
            1
        ],
        [
            120146,
            120171,
            1
        ],
        [
            120198,
            120223,
            1
        ],
        [
            120250,
            120275,
            1
        ],
        [
            120302,
            120327,
            1
        ],
        [
            120354,
            120379,
            1
        ],
        [
            120406,
            120431,
            1
        ],
        [
            120458,
            120485,
            1
        ],
        [
            120514,
            120538,
            1
        ],
        [
            120540,
            120545,
            1
        ],
        [
            120572,
            120596,
            1
        ],
        [
            120598,
            120603,
            1
        ],
        [
            120630,
            120654,
            1
        ],
        [
            120656,
            120661,
            1
        ],
        [
            120688,
            120712,
            1
        ],
        [
            120714,
            120719,
            1
        ],
        [
            120746,
            120770,
            1
        ],
        [
            120772,
            120777,
            1
        ],
        [
            120779,
            122624,
            1845
        ],
        [
            122625,
            122633,
            1
        ],
        [
            122635,
            122654,
            1
        ],
        [
            122661,
            122666,
            1
        ],
        [
            125218,
            125251,
            1
        ]
    ];
    static foldLl = [
        [
            65,
            90,
            1
        ],
        [
            192,
            214,
            1
        ],
        [
            216,
            222,
            1
        ],
        [
            256,
            302,
            2
        ],
        [
            306,
            310,
            2
        ],
        [
            313,
            327,
            2
        ],
        [
            330,
            376,
            2
        ],
        [
            377,
            381,
            2
        ],
        [
            385,
            386,
            1
        ],
        [
            388,
            390,
            2
        ],
        [
            391,
            393,
            2
        ],
        [
            394,
            395,
            1
        ],
        [
            398,
            401,
            1
        ],
        [
            403,
            404,
            1
        ],
        [
            406,
            408,
            1
        ],
        [
            412,
            413,
            1
        ],
        [
            415,
            416,
            1
        ],
        [
            418,
            422,
            2
        ],
        [
            423,
            425,
            2
        ],
        [
            428,
            430,
            2
        ],
        [
            431,
            433,
            2
        ],
        [
            434,
            435,
            1
        ],
        [
            437,
            439,
            2
        ],
        [
            440,
            444,
            4
        ],
        [
            452,
            453,
            1
        ],
        [
            455,
            456,
            1
        ],
        [
            458,
            459,
            1
        ],
        [
            461,
            475,
            2
        ],
        [
            478,
            494,
            2
        ],
        [
            497,
            498,
            1
        ],
        [
            500,
            502,
            2
        ],
        [
            503,
            504,
            1
        ],
        [
            506,
            562,
            2
        ],
        [
            570,
            571,
            1
        ],
        [
            573,
            574,
            1
        ],
        [
            577,
            579,
            2
        ],
        [
            580,
            582,
            1
        ],
        [
            584,
            590,
            2
        ],
        [
            837,
            880,
            43
        ],
        [
            882,
            886,
            4
        ],
        [
            895,
            902,
            7
        ],
        [
            904,
            906,
            1
        ],
        [
            908,
            910,
            2
        ],
        [
            911,
            913,
            2
        ],
        [
            914,
            929,
            1
        ],
        [
            931,
            939,
            1
        ],
        [
            975,
            984,
            9
        ],
        [
            986,
            1006,
            2
        ],
        [
            1012,
            1015,
            3
        ],
        [
            1017,
            1018,
            1
        ],
        [
            1021,
            1071,
            1
        ],
        [
            1120,
            1152,
            2
        ],
        [
            1162,
            1216,
            2
        ],
        [
            1217,
            1229,
            2
        ],
        [
            1232,
            1326,
            2
        ],
        [
            1329,
            1366,
            1
        ],
        [
            4256,
            4293,
            1
        ],
        [
            4295,
            4301,
            6
        ],
        [
            5024,
            5109,
            1
        ],
        [
            7312,
            7354,
            1
        ],
        [
            7357,
            7359,
            1
        ],
        [
            7680,
            7828,
            2
        ],
        [
            7838,
            7934,
            2
        ],
        [
            7944,
            7951,
            1
        ],
        [
            7960,
            7965,
            1
        ],
        [
            7976,
            7983,
            1
        ],
        [
            7992,
            7999,
            1
        ],
        [
            8008,
            8013,
            1
        ],
        [
            8025,
            8031,
            2
        ],
        [
            8040,
            8047,
            1
        ],
        [
            8072,
            8079,
            1
        ],
        [
            8088,
            8095,
            1
        ],
        [
            8104,
            8111,
            1
        ],
        [
            8120,
            8124,
            1
        ],
        [
            8136,
            8140,
            1
        ],
        [
            8152,
            8155,
            1
        ],
        [
            8168,
            8172,
            1
        ],
        [
            8184,
            8188,
            1
        ],
        [
            8486,
            8490,
            4
        ],
        [
            8491,
            8498,
            7
        ],
        [
            8579,
            11264,
            2685
        ],
        [
            11265,
            11311,
            1
        ],
        [
            11360,
            11362,
            2
        ],
        [
            11363,
            11364,
            1
        ],
        [
            11367,
            11373,
            2
        ],
        [
            11374,
            11376,
            1
        ],
        [
            11378,
            11381,
            3
        ],
        [
            11390,
            11392,
            1
        ],
        [
            11394,
            11490,
            2
        ],
        [
            11499,
            11501,
            2
        ],
        [
            11506,
            42560,
            31054
        ],
        [
            42562,
            42604,
            2
        ],
        [
            42624,
            42650,
            2
        ],
        [
            42786,
            42798,
            2
        ],
        [
            42802,
            42862,
            2
        ],
        [
            42873,
            42877,
            2
        ],
        [
            42878,
            42886,
            2
        ],
        [
            42891,
            42893,
            2
        ],
        [
            42896,
            42898,
            2
        ],
        [
            42902,
            42922,
            2
        ],
        [
            42923,
            42926,
            1
        ],
        [
            42928,
            42932,
            1
        ],
        [
            42934,
            42948,
            2
        ],
        [
            42949,
            42951,
            1
        ],
        [
            42953,
            42960,
            7
        ],
        [
            42966,
            42968,
            2
        ],
        [
            42997,
            65313,
            22316
        ],
        [
            65314,
            65338,
            1
        ],
        [
            66560,
            66599,
            1
        ],
        [
            66736,
            66771,
            1
        ],
        [
            66928,
            66938,
            1
        ],
        [
            66940,
            66954,
            1
        ],
        [
            66956,
            66962,
            1
        ],
        [
            66964,
            66965,
            1
        ],
        [
            68736,
            68786,
            1
        ],
        [
            71840,
            71871,
            1
        ],
        [
            93760,
            93791,
            1
        ],
        [
            125184,
            125217,
            1
        ]
    ];
    static Lm = [
        [
            688,
            705,
            1
        ],
        [
            710,
            721,
            1
        ],
        [
            736,
            740,
            1
        ],
        [
            748,
            750,
            2
        ],
        [
            884,
            890,
            6
        ],
        [
            1369,
            1600,
            231
        ],
        [
            1765,
            1766,
            1
        ],
        [
            2036,
            2037,
            1
        ],
        [
            2042,
            2074,
            32
        ],
        [
            2084,
            2088,
            4
        ],
        [
            2249,
            2417,
            168
        ],
        [
            3654,
            3782,
            128
        ],
        [
            4348,
            6103,
            1755
        ],
        [
            6211,
            6823,
            612
        ],
        [
            7288,
            7293,
            1
        ],
        [
            7468,
            7530,
            1
        ],
        [
            7544,
            7579,
            35
        ],
        [
            7580,
            7615,
            1
        ],
        [
            8305,
            8319,
            14
        ],
        [
            8336,
            8348,
            1
        ],
        [
            11388,
            11389,
            1
        ],
        [
            11631,
            11823,
            192
        ],
        [
            12293,
            12337,
            44
        ],
        [
            12338,
            12341,
            1
        ],
        [
            12347,
            12445,
            98
        ],
        [
            12446,
            12540,
            94
        ],
        [
            12541,
            12542,
            1
        ],
        [
            40981,
            42232,
            1251
        ],
        [
            42233,
            42237,
            1
        ],
        [
            42508,
            42623,
            115
        ],
        [
            42652,
            42653,
            1
        ],
        [
            42775,
            42783,
            1
        ],
        [
            42864,
            42888,
            24
        ],
        [
            42994,
            42996,
            1
        ],
        [
            43000,
            43001,
            1
        ],
        [
            43471,
            43494,
            23
        ],
        [
            43632,
            43741,
            109
        ],
        [
            43763,
            43764,
            1
        ],
        [
            43868,
            43871,
            1
        ],
        [
            43881,
            65392,
            21511
        ],
        [
            65438,
            65439,
            1
        ],
        [
            67456,
            67461,
            1
        ],
        [
            67463,
            67504,
            1
        ],
        [
            67506,
            67514,
            1
        ],
        [
            92992,
            92995,
            1
        ],
        [
            94099,
            94111,
            1
        ],
        [
            94176,
            94177,
            1
        ],
        [
            94179,
            110576,
            16397
        ],
        [
            110577,
            110579,
            1
        ],
        [
            110581,
            110587,
            1
        ],
        [
            110589,
            110590,
            1
        ],
        [
            122928,
            122989,
            1
        ],
        [
            123191,
            123197,
            1
        ],
        [
            124139,
            125259,
            1120
        ]
    ];
    static Lo = [
        [
            170,
            186,
            16
        ],
        [
            443,
            448,
            5
        ],
        [
            449,
            451,
            1
        ],
        [
            660,
            1488,
            828
        ],
        [
            1489,
            1514,
            1
        ],
        [
            1519,
            1522,
            1
        ],
        [
            1568,
            1599,
            1
        ],
        [
            1601,
            1610,
            1
        ],
        [
            1646,
            1647,
            1
        ],
        [
            1649,
            1747,
            1
        ],
        [
            1749,
            1774,
            25
        ],
        [
            1775,
            1786,
            11
        ],
        [
            1787,
            1788,
            1
        ],
        [
            1791,
            1808,
            17
        ],
        [
            1810,
            1839,
            1
        ],
        [
            1869,
            1957,
            1
        ],
        [
            1969,
            1994,
            25
        ],
        [
            1995,
            2026,
            1
        ],
        [
            2048,
            2069,
            1
        ],
        [
            2112,
            2136,
            1
        ],
        [
            2144,
            2154,
            1
        ],
        [
            2160,
            2183,
            1
        ],
        [
            2185,
            2190,
            1
        ],
        [
            2208,
            2248,
            1
        ],
        [
            2308,
            2361,
            1
        ],
        [
            2365,
            2384,
            19
        ],
        [
            2392,
            2401,
            1
        ],
        [
            2418,
            2432,
            1
        ],
        [
            2437,
            2444,
            1
        ],
        [
            2447,
            2448,
            1
        ],
        [
            2451,
            2472,
            1
        ],
        [
            2474,
            2480,
            1
        ],
        [
            2482,
            2486,
            4
        ],
        [
            2487,
            2489,
            1
        ],
        [
            2493,
            2510,
            17
        ],
        [
            2524,
            2525,
            1
        ],
        [
            2527,
            2529,
            1
        ],
        [
            2544,
            2545,
            1
        ],
        [
            2556,
            2565,
            9
        ],
        [
            2566,
            2570,
            1
        ],
        [
            2575,
            2576,
            1
        ],
        [
            2579,
            2600,
            1
        ],
        [
            2602,
            2608,
            1
        ],
        [
            2610,
            2611,
            1
        ],
        [
            2613,
            2614,
            1
        ],
        [
            2616,
            2617,
            1
        ],
        [
            2649,
            2652,
            1
        ],
        [
            2654,
            2674,
            20
        ],
        [
            2675,
            2676,
            1
        ],
        [
            2693,
            2701,
            1
        ],
        [
            2703,
            2705,
            1
        ],
        [
            2707,
            2728,
            1
        ],
        [
            2730,
            2736,
            1
        ],
        [
            2738,
            2739,
            1
        ],
        [
            2741,
            2745,
            1
        ],
        [
            2749,
            2768,
            19
        ],
        [
            2784,
            2785,
            1
        ],
        [
            2809,
            2821,
            12
        ],
        [
            2822,
            2828,
            1
        ],
        [
            2831,
            2832,
            1
        ],
        [
            2835,
            2856,
            1
        ],
        [
            2858,
            2864,
            1
        ],
        [
            2866,
            2867,
            1
        ],
        [
            2869,
            2873,
            1
        ],
        [
            2877,
            2908,
            31
        ],
        [
            2909,
            2911,
            2
        ],
        [
            2912,
            2913,
            1
        ],
        [
            2929,
            2947,
            18
        ],
        [
            2949,
            2954,
            1
        ],
        [
            2958,
            2960,
            1
        ],
        [
            2962,
            2965,
            1
        ],
        [
            2969,
            2970,
            1
        ],
        [
            2972,
            2974,
            2
        ],
        [
            2975,
            2979,
            4
        ],
        [
            2980,
            2984,
            4
        ],
        [
            2985,
            2986,
            1
        ],
        [
            2990,
            3001,
            1
        ],
        [
            3024,
            3077,
            53
        ],
        [
            3078,
            3084,
            1
        ],
        [
            3086,
            3088,
            1
        ],
        [
            3090,
            3112,
            1
        ],
        [
            3114,
            3129,
            1
        ],
        [
            3133,
            3160,
            27
        ],
        [
            3161,
            3162,
            1
        ],
        [
            3165,
            3168,
            3
        ],
        [
            3169,
            3200,
            31
        ],
        [
            3205,
            3212,
            1
        ],
        [
            3214,
            3216,
            1
        ],
        [
            3218,
            3240,
            1
        ],
        [
            3242,
            3251,
            1
        ],
        [
            3253,
            3257,
            1
        ],
        [
            3261,
            3293,
            32
        ],
        [
            3294,
            3296,
            2
        ],
        [
            3297,
            3313,
            16
        ],
        [
            3314,
            3332,
            18
        ],
        [
            3333,
            3340,
            1
        ],
        [
            3342,
            3344,
            1
        ],
        [
            3346,
            3386,
            1
        ],
        [
            3389,
            3406,
            17
        ],
        [
            3412,
            3414,
            1
        ],
        [
            3423,
            3425,
            1
        ],
        [
            3450,
            3455,
            1
        ],
        [
            3461,
            3478,
            1
        ],
        [
            3482,
            3505,
            1
        ],
        [
            3507,
            3515,
            1
        ],
        [
            3517,
            3520,
            3
        ],
        [
            3521,
            3526,
            1
        ],
        [
            3585,
            3632,
            1
        ],
        [
            3634,
            3635,
            1
        ],
        [
            3648,
            3653,
            1
        ],
        [
            3713,
            3714,
            1
        ],
        [
            3716,
            3718,
            2
        ],
        [
            3719,
            3722,
            1
        ],
        [
            3724,
            3747,
            1
        ],
        [
            3749,
            3751,
            2
        ],
        [
            3752,
            3760,
            1
        ],
        [
            3762,
            3763,
            1
        ],
        [
            3773,
            3776,
            3
        ],
        [
            3777,
            3780,
            1
        ],
        [
            3804,
            3807,
            1
        ],
        [
            3840,
            3904,
            64
        ],
        [
            3905,
            3911,
            1
        ],
        [
            3913,
            3948,
            1
        ],
        [
            3976,
            3980,
            1
        ],
        [
            4096,
            4138,
            1
        ],
        [
            4159,
            4176,
            17
        ],
        [
            4177,
            4181,
            1
        ],
        [
            4186,
            4189,
            1
        ],
        [
            4193,
            4197,
            4
        ],
        [
            4198,
            4206,
            8
        ],
        [
            4207,
            4208,
            1
        ],
        [
            4213,
            4225,
            1
        ],
        [
            4238,
            4352,
            114
        ],
        [
            4353,
            4680,
            1
        ],
        [
            4682,
            4685,
            1
        ],
        [
            4688,
            4694,
            1
        ],
        [
            4696,
            4698,
            2
        ],
        [
            4699,
            4701,
            1
        ],
        [
            4704,
            4744,
            1
        ],
        [
            4746,
            4749,
            1
        ],
        [
            4752,
            4784,
            1
        ],
        [
            4786,
            4789,
            1
        ],
        [
            4792,
            4798,
            1
        ],
        [
            4800,
            4802,
            2
        ],
        [
            4803,
            4805,
            1
        ],
        [
            4808,
            4822,
            1
        ],
        [
            4824,
            4880,
            1
        ],
        [
            4882,
            4885,
            1
        ],
        [
            4888,
            4954,
            1
        ],
        [
            4992,
            5007,
            1
        ],
        [
            5121,
            5740,
            1
        ],
        [
            5743,
            5759,
            1
        ],
        [
            5761,
            5786,
            1
        ],
        [
            5792,
            5866,
            1
        ],
        [
            5873,
            5880,
            1
        ],
        [
            5888,
            5905,
            1
        ],
        [
            5919,
            5937,
            1
        ],
        [
            5952,
            5969,
            1
        ],
        [
            5984,
            5996,
            1
        ],
        [
            5998,
            6000,
            1
        ],
        [
            6016,
            6067,
            1
        ],
        [
            6108,
            6176,
            68
        ],
        [
            6177,
            6210,
            1
        ],
        [
            6212,
            6264,
            1
        ],
        [
            6272,
            6276,
            1
        ],
        [
            6279,
            6312,
            1
        ],
        [
            6314,
            6320,
            6
        ],
        [
            6321,
            6389,
            1
        ],
        [
            6400,
            6430,
            1
        ],
        [
            6480,
            6509,
            1
        ],
        [
            6512,
            6516,
            1
        ],
        [
            6528,
            6571,
            1
        ],
        [
            6576,
            6601,
            1
        ],
        [
            6656,
            6678,
            1
        ],
        [
            6688,
            6740,
            1
        ],
        [
            6917,
            6963,
            1
        ],
        [
            6981,
            6988,
            1
        ],
        [
            7043,
            7072,
            1
        ],
        [
            7086,
            7087,
            1
        ],
        [
            7098,
            7141,
            1
        ],
        [
            7168,
            7203,
            1
        ],
        [
            7245,
            7247,
            1
        ],
        [
            7258,
            7287,
            1
        ],
        [
            7401,
            7404,
            1
        ],
        [
            7406,
            7411,
            1
        ],
        [
            7413,
            7414,
            1
        ],
        [
            7418,
            8501,
            1083
        ],
        [
            8502,
            8504,
            1
        ],
        [
            11568,
            11623,
            1
        ],
        [
            11648,
            11670,
            1
        ],
        [
            11680,
            11686,
            1
        ],
        [
            11688,
            11694,
            1
        ],
        [
            11696,
            11702,
            1
        ],
        [
            11704,
            11710,
            1
        ],
        [
            11712,
            11718,
            1
        ],
        [
            11720,
            11726,
            1
        ],
        [
            11728,
            11734,
            1
        ],
        [
            11736,
            11742,
            1
        ],
        [
            12294,
            12348,
            54
        ],
        [
            12353,
            12438,
            1
        ],
        [
            12447,
            12449,
            2
        ],
        [
            12450,
            12538,
            1
        ],
        [
            12543,
            12549,
            6
        ],
        [
            12550,
            12591,
            1
        ],
        [
            12593,
            12686,
            1
        ],
        [
            12704,
            12735,
            1
        ],
        [
            12784,
            12799,
            1
        ],
        [
            13312,
            19903,
            1
        ],
        [
            19968,
            40980,
            1
        ],
        [
            40982,
            42124,
            1
        ],
        [
            42192,
            42231,
            1
        ],
        [
            42240,
            42507,
            1
        ],
        [
            42512,
            42527,
            1
        ],
        [
            42538,
            42539,
            1
        ],
        [
            42606,
            42656,
            50
        ],
        [
            42657,
            42725,
            1
        ],
        [
            42895,
            42999,
            104
        ],
        [
            43003,
            43009,
            1
        ],
        [
            43011,
            43013,
            1
        ],
        [
            43015,
            43018,
            1
        ],
        [
            43020,
            43042,
            1
        ],
        [
            43072,
            43123,
            1
        ],
        [
            43138,
            43187,
            1
        ],
        [
            43250,
            43255,
            1
        ],
        [
            43259,
            43261,
            2
        ],
        [
            43262,
            43274,
            12
        ],
        [
            43275,
            43301,
            1
        ],
        [
            43312,
            43334,
            1
        ],
        [
            43360,
            43388,
            1
        ],
        [
            43396,
            43442,
            1
        ],
        [
            43488,
            43492,
            1
        ],
        [
            43495,
            43503,
            1
        ],
        [
            43514,
            43518,
            1
        ],
        [
            43520,
            43560,
            1
        ],
        [
            43584,
            43586,
            1
        ],
        [
            43588,
            43595,
            1
        ],
        [
            43616,
            43631,
            1
        ],
        [
            43633,
            43638,
            1
        ],
        [
            43642,
            43646,
            4
        ],
        [
            43647,
            43695,
            1
        ],
        [
            43697,
            43701,
            4
        ],
        [
            43702,
            43705,
            3
        ],
        [
            43706,
            43709,
            1
        ],
        [
            43712,
            43714,
            2
        ],
        [
            43739,
            43740,
            1
        ],
        [
            43744,
            43754,
            1
        ],
        [
            43762,
            43777,
            15
        ],
        [
            43778,
            43782,
            1
        ],
        [
            43785,
            43790,
            1
        ],
        [
            43793,
            43798,
            1
        ],
        [
            43808,
            43814,
            1
        ],
        [
            43816,
            43822,
            1
        ],
        [
            43968,
            44002,
            1
        ],
        [
            44032,
            55203,
            1
        ],
        [
            55216,
            55238,
            1
        ],
        [
            55243,
            55291,
            1
        ],
        [
            63744,
            64109,
            1
        ],
        [
            64112,
            64217,
            1
        ],
        [
            64285,
            64287,
            2
        ],
        [
            64288,
            64296,
            1
        ],
        [
            64298,
            64310,
            1
        ],
        [
            64312,
            64316,
            1
        ],
        [
            64318,
            64320,
            2
        ],
        [
            64321,
            64323,
            2
        ],
        [
            64324,
            64326,
            2
        ],
        [
            64327,
            64433,
            1
        ],
        [
            64467,
            64829,
            1
        ],
        [
            64848,
            64911,
            1
        ],
        [
            64914,
            64967,
            1
        ],
        [
            65008,
            65019,
            1
        ],
        [
            65136,
            65140,
            1
        ],
        [
            65142,
            65276,
            1
        ],
        [
            65382,
            65391,
            1
        ],
        [
            65393,
            65437,
            1
        ],
        [
            65440,
            65470,
            1
        ],
        [
            65474,
            65479,
            1
        ],
        [
            65482,
            65487,
            1
        ],
        [
            65490,
            65495,
            1
        ],
        [
            65498,
            65500,
            1
        ],
        [
            65536,
            65547,
            1
        ],
        [
            65549,
            65574,
            1
        ],
        [
            65576,
            65594,
            1
        ],
        [
            65596,
            65597,
            1
        ],
        [
            65599,
            65613,
            1
        ],
        [
            65616,
            65629,
            1
        ],
        [
            65664,
            65786,
            1
        ],
        [
            66176,
            66204,
            1
        ],
        [
            66208,
            66256,
            1
        ],
        [
            66304,
            66335,
            1
        ],
        [
            66349,
            66368,
            1
        ],
        [
            66370,
            66377,
            1
        ],
        [
            66384,
            66421,
            1
        ],
        [
            66432,
            66461,
            1
        ],
        [
            66464,
            66499,
            1
        ],
        [
            66504,
            66511,
            1
        ],
        [
            66640,
            66717,
            1
        ],
        [
            66816,
            66855,
            1
        ],
        [
            66864,
            66915,
            1
        ],
        [
            67072,
            67382,
            1
        ],
        [
            67392,
            67413,
            1
        ],
        [
            67424,
            67431,
            1
        ],
        [
            67584,
            67589,
            1
        ],
        [
            67592,
            67594,
            2
        ],
        [
            67595,
            67637,
            1
        ],
        [
            67639,
            67640,
            1
        ],
        [
            67644,
            67647,
            3
        ],
        [
            67648,
            67669,
            1
        ],
        [
            67680,
            67702,
            1
        ],
        [
            67712,
            67742,
            1
        ],
        [
            67808,
            67826,
            1
        ],
        [
            67828,
            67829,
            1
        ],
        [
            67840,
            67861,
            1
        ],
        [
            67872,
            67897,
            1
        ],
        [
            67968,
            68023,
            1
        ],
        [
            68030,
            68031,
            1
        ],
        [
            68096,
            68112,
            16
        ],
        [
            68113,
            68115,
            1
        ],
        [
            68117,
            68119,
            1
        ],
        [
            68121,
            68149,
            1
        ],
        [
            68192,
            68220,
            1
        ],
        [
            68224,
            68252,
            1
        ],
        [
            68288,
            68295,
            1
        ],
        [
            68297,
            68324,
            1
        ],
        [
            68352,
            68405,
            1
        ],
        [
            68416,
            68437,
            1
        ],
        [
            68448,
            68466,
            1
        ],
        [
            68480,
            68497,
            1
        ],
        [
            68608,
            68680,
            1
        ],
        [
            68864,
            68899,
            1
        ],
        [
            69248,
            69289,
            1
        ],
        [
            69296,
            69297,
            1
        ],
        [
            69376,
            69404,
            1
        ],
        [
            69415,
            69424,
            9
        ],
        [
            69425,
            69445,
            1
        ],
        [
            69488,
            69505,
            1
        ],
        [
            69552,
            69572,
            1
        ],
        [
            69600,
            69622,
            1
        ],
        [
            69635,
            69687,
            1
        ],
        [
            69745,
            69746,
            1
        ],
        [
            69749,
            69763,
            14
        ],
        [
            69764,
            69807,
            1
        ],
        [
            69840,
            69864,
            1
        ],
        [
            69891,
            69926,
            1
        ],
        [
            69956,
            69959,
            3
        ],
        [
            69968,
            70002,
            1
        ],
        [
            70006,
            70019,
            13
        ],
        [
            70020,
            70066,
            1
        ],
        [
            70081,
            70084,
            1
        ],
        [
            70106,
            70108,
            2
        ],
        [
            70144,
            70161,
            1
        ],
        [
            70163,
            70187,
            1
        ],
        [
            70207,
            70208,
            1
        ],
        [
            70272,
            70278,
            1
        ],
        [
            70280,
            70282,
            2
        ],
        [
            70283,
            70285,
            1
        ],
        [
            70287,
            70301,
            1
        ],
        [
            70303,
            70312,
            1
        ],
        [
            70320,
            70366,
            1
        ],
        [
            70405,
            70412,
            1
        ],
        [
            70415,
            70416,
            1
        ],
        [
            70419,
            70440,
            1
        ],
        [
            70442,
            70448,
            1
        ],
        [
            70450,
            70451,
            1
        ],
        [
            70453,
            70457,
            1
        ],
        [
            70461,
            70480,
            19
        ],
        [
            70493,
            70497,
            1
        ],
        [
            70656,
            70708,
            1
        ],
        [
            70727,
            70730,
            1
        ],
        [
            70751,
            70753,
            1
        ],
        [
            70784,
            70831,
            1
        ],
        [
            70852,
            70853,
            1
        ],
        [
            70855,
            71040,
            185
        ],
        [
            71041,
            71086,
            1
        ],
        [
            71128,
            71131,
            1
        ],
        [
            71168,
            71215,
            1
        ],
        [
            71236,
            71296,
            60
        ],
        [
            71297,
            71338,
            1
        ],
        [
            71352,
            71424,
            72
        ],
        [
            71425,
            71450,
            1
        ],
        [
            71488,
            71494,
            1
        ],
        [
            71680,
            71723,
            1
        ],
        [
            71935,
            71942,
            1
        ],
        [
            71945,
            71948,
            3
        ],
        [
            71949,
            71955,
            1
        ],
        [
            71957,
            71958,
            1
        ],
        [
            71960,
            71983,
            1
        ],
        [
            71999,
            72001,
            2
        ],
        [
            72096,
            72103,
            1
        ],
        [
            72106,
            72144,
            1
        ],
        [
            72161,
            72163,
            2
        ],
        [
            72192,
            72203,
            11
        ],
        [
            72204,
            72242,
            1
        ],
        [
            72250,
            72272,
            22
        ],
        [
            72284,
            72329,
            1
        ],
        [
            72349,
            72368,
            19
        ],
        [
            72369,
            72440,
            1
        ],
        [
            72704,
            72712,
            1
        ],
        [
            72714,
            72750,
            1
        ],
        [
            72768,
            72818,
            50
        ],
        [
            72819,
            72847,
            1
        ],
        [
            72960,
            72966,
            1
        ],
        [
            72968,
            72969,
            1
        ],
        [
            72971,
            73008,
            1
        ],
        [
            73030,
            73056,
            26
        ],
        [
            73057,
            73061,
            1
        ],
        [
            73063,
            73064,
            1
        ],
        [
            73066,
            73097,
            1
        ],
        [
            73112,
            73440,
            328
        ],
        [
            73441,
            73458,
            1
        ],
        [
            73474,
            73476,
            2
        ],
        [
            73477,
            73488,
            1
        ],
        [
            73490,
            73523,
            1
        ],
        [
            73648,
            73728,
            80
        ],
        [
            73729,
            74649,
            1
        ],
        [
            74880,
            75075,
            1
        ],
        [
            77712,
            77808,
            1
        ],
        [
            77824,
            78895,
            1
        ],
        [
            78913,
            78918,
            1
        ],
        [
            82944,
            83526,
            1
        ],
        [
            92160,
            92728,
            1
        ],
        [
            92736,
            92766,
            1
        ],
        [
            92784,
            92862,
            1
        ],
        [
            92880,
            92909,
            1
        ],
        [
            92928,
            92975,
            1
        ],
        [
            93027,
            93047,
            1
        ],
        [
            93053,
            93071,
            1
        ],
        [
            93952,
            94026,
            1
        ],
        [
            94032,
            94208,
            176
        ],
        [
            94209,
            100343,
            1
        ],
        [
            100352,
            101589,
            1
        ],
        [
            101632,
            101640,
            1
        ],
        [
            110592,
            110882,
            1
        ],
        [
            110898,
            110928,
            30
        ],
        [
            110929,
            110930,
            1
        ],
        [
            110933,
            110948,
            15
        ],
        [
            110949,
            110951,
            1
        ],
        [
            110960,
            111355,
            1
        ],
        [
            113664,
            113770,
            1
        ],
        [
            113776,
            113788,
            1
        ],
        [
            113792,
            113800,
            1
        ],
        [
            113808,
            113817,
            1
        ],
        [
            122634,
            123136,
            502
        ],
        [
            123137,
            123180,
            1
        ],
        [
            123214,
            123536,
            322
        ],
        [
            123537,
            123565,
            1
        ],
        [
            123584,
            123627,
            1
        ],
        [
            124112,
            124138,
            1
        ],
        [
            124896,
            124902,
            1
        ],
        [
            124904,
            124907,
            1
        ],
        [
            124909,
            124910,
            1
        ],
        [
            124912,
            124926,
            1
        ],
        [
            124928,
            125124,
            1
        ],
        [
            126464,
            126467,
            1
        ],
        [
            126469,
            126495,
            1
        ],
        [
            126497,
            126498,
            1
        ],
        [
            126500,
            126503,
            3
        ],
        [
            126505,
            126514,
            1
        ],
        [
            126516,
            126519,
            1
        ],
        [
            126521,
            126523,
            2
        ],
        [
            126530,
            126535,
            5
        ],
        [
            126537,
            126541,
            2
        ],
        [
            126542,
            126543,
            1
        ],
        [
            126545,
            126546,
            1
        ],
        [
            126548,
            126551,
            3
        ],
        [
            126553,
            126561,
            2
        ],
        [
            126562,
            126564,
            2
        ],
        [
            126567,
            126570,
            1
        ],
        [
            126572,
            126578,
            1
        ],
        [
            126580,
            126583,
            1
        ],
        [
            126585,
            126588,
            1
        ],
        [
            126590,
            126592,
            2
        ],
        [
            126593,
            126601,
            1
        ],
        [
            126603,
            126619,
            1
        ],
        [
            126625,
            126627,
            1
        ],
        [
            126629,
            126633,
            1
        ],
        [
            126635,
            126651,
            1
        ],
        [
            131072,
            173791,
            1
        ],
        [
            173824,
            177977,
            1
        ],
        [
            177984,
            178205,
            1
        ],
        [
            178208,
            183969,
            1
        ],
        [
            183984,
            191456,
            1
        ],
        [
            191472,
            192093,
            1
        ],
        [
            194560,
            195101,
            1
        ],
        [
            196608,
            201546,
            1
        ],
        [
            201552,
            205743,
            1
        ]
    ];
    static Lt = [
        [
            453,
            459,
            3
        ],
        [
            498,
            8072,
            7574
        ],
        [
            8073,
            8079,
            1
        ],
        [
            8088,
            8095,
            1
        ],
        [
            8104,
            8111,
            1
        ],
        [
            8124,
            8140,
            16
        ],
        [
            8188,
            8188,
            1
        ]
    ];
    static foldLt = [
        [
            452,
            454,
            2
        ],
        [
            455,
            457,
            2
        ],
        [
            458,
            460,
            2
        ],
        [
            497,
            499,
            2
        ],
        [
            8064,
            8071,
            1
        ],
        [
            8080,
            8087,
            1
        ],
        [
            8096,
            8103,
            1
        ],
        [
            8115,
            8131,
            16
        ],
        [
            8179,
            8179,
            1
        ]
    ];
    static Lu = [
        [
            65,
            90,
            1
        ],
        [
            192,
            214,
            1
        ],
        [
            216,
            222,
            1
        ],
        [
            256,
            310,
            2
        ],
        [
            313,
            327,
            2
        ],
        [
            330,
            376,
            2
        ],
        [
            377,
            381,
            2
        ],
        [
            385,
            386,
            1
        ],
        [
            388,
            390,
            2
        ],
        [
            391,
            393,
            2
        ],
        [
            394,
            395,
            1
        ],
        [
            398,
            401,
            1
        ],
        [
            403,
            404,
            1
        ],
        [
            406,
            408,
            1
        ],
        [
            412,
            413,
            1
        ],
        [
            415,
            416,
            1
        ],
        [
            418,
            422,
            2
        ],
        [
            423,
            425,
            2
        ],
        [
            428,
            430,
            2
        ],
        [
            431,
            433,
            2
        ],
        [
            434,
            435,
            1
        ],
        [
            437,
            439,
            2
        ],
        [
            440,
            444,
            4
        ],
        [
            452,
            461,
            3
        ],
        [
            463,
            475,
            2
        ],
        [
            478,
            494,
            2
        ],
        [
            497,
            500,
            3
        ],
        [
            502,
            504,
            1
        ],
        [
            506,
            562,
            2
        ],
        [
            570,
            571,
            1
        ],
        [
            573,
            574,
            1
        ],
        [
            577,
            579,
            2
        ],
        [
            580,
            582,
            1
        ],
        [
            584,
            590,
            2
        ],
        [
            880,
            882,
            2
        ],
        [
            886,
            895,
            9
        ],
        [
            902,
            904,
            2
        ],
        [
            905,
            906,
            1
        ],
        [
            908,
            910,
            2
        ],
        [
            911,
            913,
            2
        ],
        [
            914,
            929,
            1
        ],
        [
            931,
            939,
            1
        ],
        [
            975,
            978,
            3
        ],
        [
            979,
            980,
            1
        ],
        [
            984,
            1006,
            2
        ],
        [
            1012,
            1015,
            3
        ],
        [
            1017,
            1018,
            1
        ],
        [
            1021,
            1071,
            1
        ],
        [
            1120,
            1152,
            2
        ],
        [
            1162,
            1216,
            2
        ],
        [
            1217,
            1229,
            2
        ],
        [
            1232,
            1326,
            2
        ],
        [
            1329,
            1366,
            1
        ],
        [
            4256,
            4293,
            1
        ],
        [
            4295,
            4301,
            6
        ],
        [
            5024,
            5109,
            1
        ],
        [
            7312,
            7354,
            1
        ],
        [
            7357,
            7359,
            1
        ],
        [
            7680,
            7828,
            2
        ],
        [
            7838,
            7934,
            2
        ],
        [
            7944,
            7951,
            1
        ],
        [
            7960,
            7965,
            1
        ],
        [
            7976,
            7983,
            1
        ],
        [
            7992,
            7999,
            1
        ],
        [
            8008,
            8013,
            1
        ],
        [
            8025,
            8031,
            2
        ],
        [
            8040,
            8047,
            1
        ],
        [
            8120,
            8123,
            1
        ],
        [
            8136,
            8139,
            1
        ],
        [
            8152,
            8155,
            1
        ],
        [
            8168,
            8172,
            1
        ],
        [
            8184,
            8187,
            1
        ],
        [
            8450,
            8455,
            5
        ],
        [
            8459,
            8461,
            1
        ],
        [
            8464,
            8466,
            1
        ],
        [
            8469,
            8473,
            4
        ],
        [
            8474,
            8477,
            1
        ],
        [
            8484,
            8490,
            2
        ],
        [
            8491,
            8493,
            1
        ],
        [
            8496,
            8499,
            1
        ],
        [
            8510,
            8511,
            1
        ],
        [
            8517,
            8579,
            62
        ],
        [
            11264,
            11311,
            1
        ],
        [
            11360,
            11362,
            2
        ],
        [
            11363,
            11364,
            1
        ],
        [
            11367,
            11373,
            2
        ],
        [
            11374,
            11376,
            1
        ],
        [
            11378,
            11381,
            3
        ],
        [
            11390,
            11392,
            1
        ],
        [
            11394,
            11490,
            2
        ],
        [
            11499,
            11501,
            2
        ],
        [
            11506,
            42560,
            31054
        ],
        [
            42562,
            42604,
            2
        ],
        [
            42624,
            42650,
            2
        ],
        [
            42786,
            42798,
            2
        ],
        [
            42802,
            42862,
            2
        ],
        [
            42873,
            42877,
            2
        ],
        [
            42878,
            42886,
            2
        ],
        [
            42891,
            42893,
            2
        ],
        [
            42896,
            42898,
            2
        ],
        [
            42902,
            42922,
            2
        ],
        [
            42923,
            42926,
            1
        ],
        [
            42928,
            42932,
            1
        ],
        [
            42934,
            42948,
            2
        ],
        [
            42949,
            42951,
            1
        ],
        [
            42953,
            42960,
            7
        ],
        [
            42966,
            42968,
            2
        ],
        [
            42997,
            65313,
            22316
        ],
        [
            65314,
            65338,
            1
        ],
        [
            66560,
            66599,
            1
        ],
        [
            66736,
            66771,
            1
        ],
        [
            66928,
            66938,
            1
        ],
        [
            66940,
            66954,
            1
        ],
        [
            66956,
            66962,
            1
        ],
        [
            66964,
            66965,
            1
        ],
        [
            68736,
            68786,
            1
        ],
        [
            71840,
            71871,
            1
        ],
        [
            93760,
            93791,
            1
        ],
        [
            119808,
            119833,
            1
        ],
        [
            119860,
            119885,
            1
        ],
        [
            119912,
            119937,
            1
        ],
        [
            119964,
            119966,
            2
        ],
        [
            119967,
            119973,
            3
        ],
        [
            119974,
            119977,
            3
        ],
        [
            119978,
            119980,
            1
        ],
        [
            119982,
            119989,
            1
        ],
        [
            120016,
            120041,
            1
        ],
        [
            120068,
            120069,
            1
        ],
        [
            120071,
            120074,
            1
        ],
        [
            120077,
            120084,
            1
        ],
        [
            120086,
            120092,
            1
        ],
        [
            120120,
            120121,
            1
        ],
        [
            120123,
            120126,
            1
        ],
        [
            120128,
            120132,
            1
        ],
        [
            120134,
            120138,
            4
        ],
        [
            120139,
            120144,
            1
        ],
        [
            120172,
            120197,
            1
        ],
        [
            120224,
            120249,
            1
        ],
        [
            120276,
            120301,
            1
        ],
        [
            120328,
            120353,
            1
        ],
        [
            120380,
            120405,
            1
        ],
        [
            120432,
            120457,
            1
        ],
        [
            120488,
            120512,
            1
        ],
        [
            120546,
            120570,
            1
        ],
        [
            120604,
            120628,
            1
        ],
        [
            120662,
            120686,
            1
        ],
        [
            120720,
            120744,
            1
        ],
        [
            120778,
            125184,
            4406
        ],
        [
            125185,
            125217,
            1
        ]
    ];
    static Upper = this.Lu;
    static foldLu = [
        [
            97,
            122,
            1
        ],
        [
            181,
            223,
            42
        ],
        [
            224,
            246,
            1
        ],
        [
            248,
            255,
            1
        ],
        [
            257,
            303,
            2
        ],
        [
            307,
            311,
            2
        ],
        [
            314,
            328,
            2
        ],
        [
            331,
            375,
            2
        ],
        [
            378,
            382,
            2
        ],
        [
            383,
            384,
            1
        ],
        [
            387,
            389,
            2
        ],
        [
            392,
            396,
            4
        ],
        [
            402,
            405,
            3
        ],
        [
            409,
            410,
            1
        ],
        [
            414,
            417,
            3
        ],
        [
            419,
            421,
            2
        ],
        [
            424,
            429,
            5
        ],
        [
            432,
            436,
            4
        ],
        [
            438,
            441,
            3
        ],
        [
            445,
            447,
            2
        ],
        [
            453,
            454,
            1
        ],
        [
            456,
            457,
            1
        ],
        [
            459,
            460,
            1
        ],
        [
            462,
            476,
            2
        ],
        [
            477,
            495,
            2
        ],
        [
            498,
            499,
            1
        ],
        [
            501,
            505,
            4
        ],
        [
            507,
            543,
            2
        ],
        [
            547,
            563,
            2
        ],
        [
            572,
            575,
            3
        ],
        [
            576,
            578,
            2
        ],
        [
            583,
            591,
            2
        ],
        [
            592,
            596,
            1
        ],
        [
            598,
            599,
            1
        ],
        [
            601,
            603,
            2
        ],
        [
            604,
            608,
            4
        ],
        [
            609,
            613,
            2
        ],
        [
            614,
            616,
            2
        ],
        [
            617,
            620,
            1
        ],
        [
            623,
            625,
            2
        ],
        [
            626,
            629,
            3
        ],
        [
            637,
            640,
            3
        ],
        [
            642,
            643,
            1
        ],
        [
            647,
            652,
            1
        ],
        [
            658,
            669,
            11
        ],
        [
            670,
            837,
            167
        ],
        [
            881,
            883,
            2
        ],
        [
            887,
            891,
            4
        ],
        [
            892,
            893,
            1
        ],
        [
            940,
            943,
            1
        ],
        [
            945,
            974,
            1
        ],
        [
            976,
            977,
            1
        ],
        [
            981,
            983,
            1
        ],
        [
            985,
            1007,
            2
        ],
        [
            1008,
            1011,
            1
        ],
        [
            1013,
            1019,
            3
        ],
        [
            1072,
            1119,
            1
        ],
        [
            1121,
            1153,
            2
        ],
        [
            1163,
            1215,
            2
        ],
        [
            1218,
            1230,
            2
        ],
        [
            1231,
            1327,
            2
        ],
        [
            1377,
            1414,
            1
        ],
        [
            4304,
            4346,
            1
        ],
        [
            4349,
            4351,
            1
        ],
        [
            5112,
            5117,
            1
        ],
        [
            7296,
            7304,
            1
        ],
        [
            7545,
            7549,
            4
        ],
        [
            7566,
            7681,
            115
        ],
        [
            7683,
            7829,
            2
        ],
        [
            7835,
            7841,
            6
        ],
        [
            7843,
            7935,
            2
        ],
        [
            7936,
            7943,
            1
        ],
        [
            7952,
            7957,
            1
        ],
        [
            7968,
            7975,
            1
        ],
        [
            7984,
            7991,
            1
        ],
        [
            8000,
            8005,
            1
        ],
        [
            8017,
            8023,
            2
        ],
        [
            8032,
            8039,
            1
        ],
        [
            8048,
            8061,
            1
        ],
        [
            8112,
            8113,
            1
        ],
        [
            8126,
            8144,
            18
        ],
        [
            8145,
            8160,
            15
        ],
        [
            8161,
            8165,
            4
        ],
        [
            8526,
            8580,
            54
        ],
        [
            11312,
            11359,
            1
        ],
        [
            11361,
            11365,
            4
        ],
        [
            11366,
            11372,
            2
        ],
        [
            11379,
            11382,
            3
        ],
        [
            11393,
            11491,
            2
        ],
        [
            11500,
            11502,
            2
        ],
        [
            11507,
            11520,
            13
        ],
        [
            11521,
            11557,
            1
        ],
        [
            11559,
            11565,
            6
        ],
        [
            42561,
            42605,
            2
        ],
        [
            42625,
            42651,
            2
        ],
        [
            42787,
            42799,
            2
        ],
        [
            42803,
            42863,
            2
        ],
        [
            42874,
            42876,
            2
        ],
        [
            42879,
            42887,
            2
        ],
        [
            42892,
            42897,
            5
        ],
        [
            42899,
            42900,
            1
        ],
        [
            42903,
            42921,
            2
        ],
        [
            42933,
            42947,
            2
        ],
        [
            42952,
            42954,
            2
        ],
        [
            42961,
            42967,
            6
        ],
        [
            42969,
            42998,
            29
        ],
        [
            43859,
            43888,
            29
        ],
        [
            43889,
            43967,
            1
        ],
        [
            65345,
            65370,
            1
        ],
        [
            66600,
            66639,
            1
        ],
        [
            66776,
            66811,
            1
        ],
        [
            66967,
            66977,
            1
        ],
        [
            66979,
            66993,
            1
        ],
        [
            66995,
            67001,
            1
        ],
        [
            67003,
            67004,
            1
        ],
        [
            68800,
            68850,
            1
        ],
        [
            71872,
            71903,
            1
        ],
        [
            93792,
            93823,
            1
        ],
        [
            125218,
            125251,
            1
        ]
    ];
    static M = [
        [
            768,
            879,
            1
        ],
        [
            1155,
            1161,
            1
        ],
        [
            1425,
            1469,
            1
        ],
        [
            1471,
            1473,
            2
        ],
        [
            1474,
            1476,
            2
        ],
        [
            1477,
            1479,
            2
        ],
        [
            1552,
            1562,
            1
        ],
        [
            1611,
            1631,
            1
        ],
        [
            1648,
            1750,
            102
        ],
        [
            1751,
            1756,
            1
        ],
        [
            1759,
            1764,
            1
        ],
        [
            1767,
            1768,
            1
        ],
        [
            1770,
            1773,
            1
        ],
        [
            1809,
            1840,
            31
        ],
        [
            1841,
            1866,
            1
        ],
        [
            1958,
            1968,
            1
        ],
        [
            2027,
            2035,
            1
        ],
        [
            2045,
            2070,
            25
        ],
        [
            2071,
            2073,
            1
        ],
        [
            2075,
            2083,
            1
        ],
        [
            2085,
            2087,
            1
        ],
        [
            2089,
            2093,
            1
        ],
        [
            2137,
            2139,
            1
        ],
        [
            2200,
            2207,
            1
        ],
        [
            2250,
            2273,
            1
        ],
        [
            2275,
            2307,
            1
        ],
        [
            2362,
            2364,
            1
        ],
        [
            2366,
            2383,
            1
        ],
        [
            2385,
            2391,
            1
        ],
        [
            2402,
            2403,
            1
        ],
        [
            2433,
            2435,
            1
        ],
        [
            2492,
            2494,
            2
        ],
        [
            2495,
            2500,
            1
        ],
        [
            2503,
            2504,
            1
        ],
        [
            2507,
            2509,
            1
        ],
        [
            2519,
            2530,
            11
        ],
        [
            2531,
            2558,
            27
        ],
        [
            2561,
            2563,
            1
        ],
        [
            2620,
            2622,
            2
        ],
        [
            2623,
            2626,
            1
        ],
        [
            2631,
            2632,
            1
        ],
        [
            2635,
            2637,
            1
        ],
        [
            2641,
            2672,
            31
        ],
        [
            2673,
            2677,
            4
        ],
        [
            2689,
            2691,
            1
        ],
        [
            2748,
            2750,
            2
        ],
        [
            2751,
            2757,
            1
        ],
        [
            2759,
            2761,
            1
        ],
        [
            2763,
            2765,
            1
        ],
        [
            2786,
            2787,
            1
        ],
        [
            2810,
            2815,
            1
        ],
        [
            2817,
            2819,
            1
        ],
        [
            2876,
            2878,
            2
        ],
        [
            2879,
            2884,
            1
        ],
        [
            2887,
            2888,
            1
        ],
        [
            2891,
            2893,
            1
        ],
        [
            2901,
            2903,
            1
        ],
        [
            2914,
            2915,
            1
        ],
        [
            2946,
            3006,
            60
        ],
        [
            3007,
            3010,
            1
        ],
        [
            3014,
            3016,
            1
        ],
        [
            3018,
            3021,
            1
        ],
        [
            3031,
            3072,
            41
        ],
        [
            3073,
            3076,
            1
        ],
        [
            3132,
            3134,
            2
        ],
        [
            3135,
            3140,
            1
        ],
        [
            3142,
            3144,
            1
        ],
        [
            3146,
            3149,
            1
        ],
        [
            3157,
            3158,
            1
        ],
        [
            3170,
            3171,
            1
        ],
        [
            3201,
            3203,
            1
        ],
        [
            3260,
            3262,
            2
        ],
        [
            3263,
            3268,
            1
        ],
        [
            3270,
            3272,
            1
        ],
        [
            3274,
            3277,
            1
        ],
        [
            3285,
            3286,
            1
        ],
        [
            3298,
            3299,
            1
        ],
        [
            3315,
            3328,
            13
        ],
        [
            3329,
            3331,
            1
        ],
        [
            3387,
            3388,
            1
        ],
        [
            3390,
            3396,
            1
        ],
        [
            3398,
            3400,
            1
        ],
        [
            3402,
            3405,
            1
        ],
        [
            3415,
            3426,
            11
        ],
        [
            3427,
            3457,
            30
        ],
        [
            3458,
            3459,
            1
        ],
        [
            3530,
            3535,
            5
        ],
        [
            3536,
            3540,
            1
        ],
        [
            3542,
            3544,
            2
        ],
        [
            3545,
            3551,
            1
        ],
        [
            3570,
            3571,
            1
        ],
        [
            3633,
            3636,
            3
        ],
        [
            3637,
            3642,
            1
        ],
        [
            3655,
            3662,
            1
        ],
        [
            3761,
            3764,
            3
        ],
        [
            3765,
            3772,
            1
        ],
        [
            3784,
            3790,
            1
        ],
        [
            3864,
            3865,
            1
        ],
        [
            3893,
            3897,
            2
        ],
        [
            3902,
            3903,
            1
        ],
        [
            3953,
            3972,
            1
        ],
        [
            3974,
            3975,
            1
        ],
        [
            3981,
            3991,
            1
        ],
        [
            3993,
            4028,
            1
        ],
        [
            4038,
            4139,
            101
        ],
        [
            4140,
            4158,
            1
        ],
        [
            4182,
            4185,
            1
        ],
        [
            4190,
            4192,
            1
        ],
        [
            4194,
            4196,
            1
        ],
        [
            4199,
            4205,
            1
        ],
        [
            4209,
            4212,
            1
        ],
        [
            4226,
            4237,
            1
        ],
        [
            4239,
            4250,
            11
        ],
        [
            4251,
            4253,
            1
        ],
        [
            4957,
            4959,
            1
        ],
        [
            5906,
            5909,
            1
        ],
        [
            5938,
            5940,
            1
        ],
        [
            5970,
            5971,
            1
        ],
        [
            6002,
            6003,
            1
        ],
        [
            6068,
            6099,
            1
        ],
        [
            6109,
            6155,
            46
        ],
        [
            6156,
            6157,
            1
        ],
        [
            6159,
            6277,
            118
        ],
        [
            6278,
            6313,
            35
        ],
        [
            6432,
            6443,
            1
        ],
        [
            6448,
            6459,
            1
        ],
        [
            6679,
            6683,
            1
        ],
        [
            6741,
            6750,
            1
        ],
        [
            6752,
            6780,
            1
        ],
        [
            6783,
            6832,
            49
        ],
        [
            6833,
            6862,
            1
        ],
        [
            6912,
            6916,
            1
        ],
        [
            6964,
            6980,
            1
        ],
        [
            7019,
            7027,
            1
        ],
        [
            7040,
            7042,
            1
        ],
        [
            7073,
            7085,
            1
        ],
        [
            7142,
            7155,
            1
        ],
        [
            7204,
            7223,
            1
        ],
        [
            7376,
            7378,
            1
        ],
        [
            7380,
            7400,
            1
        ],
        [
            7405,
            7412,
            7
        ],
        [
            7415,
            7417,
            1
        ],
        [
            7616,
            7679,
            1
        ],
        [
            8400,
            8432,
            1
        ],
        [
            11503,
            11505,
            1
        ],
        [
            11647,
            11744,
            97
        ],
        [
            11745,
            11775,
            1
        ],
        [
            12330,
            12335,
            1
        ],
        [
            12441,
            12442,
            1
        ],
        [
            42607,
            42610,
            1
        ],
        [
            42612,
            42621,
            1
        ],
        [
            42654,
            42655,
            1
        ],
        [
            42736,
            42737,
            1
        ],
        [
            43010,
            43014,
            4
        ],
        [
            43019,
            43043,
            24
        ],
        [
            43044,
            43047,
            1
        ],
        [
            43052,
            43136,
            84
        ],
        [
            43137,
            43188,
            51
        ],
        [
            43189,
            43205,
            1
        ],
        [
            43232,
            43249,
            1
        ],
        [
            43263,
            43302,
            39
        ],
        [
            43303,
            43309,
            1
        ],
        [
            43335,
            43347,
            1
        ],
        [
            43392,
            43395,
            1
        ],
        [
            43443,
            43456,
            1
        ],
        [
            43493,
            43561,
            68
        ],
        [
            43562,
            43574,
            1
        ],
        [
            43587,
            43596,
            9
        ],
        [
            43597,
            43643,
            46
        ],
        [
            43644,
            43645,
            1
        ],
        [
            43696,
            43698,
            2
        ],
        [
            43699,
            43700,
            1
        ],
        [
            43703,
            43704,
            1
        ],
        [
            43710,
            43711,
            1
        ],
        [
            43713,
            43755,
            42
        ],
        [
            43756,
            43759,
            1
        ],
        [
            43765,
            43766,
            1
        ],
        [
            44003,
            44010,
            1
        ],
        [
            44012,
            44013,
            1
        ],
        [
            64286,
            65024,
            738
        ],
        [
            65025,
            65039,
            1
        ],
        [
            65056,
            65071,
            1
        ],
        [
            66045,
            66272,
            227
        ],
        [
            66422,
            66426,
            1
        ],
        [
            68097,
            68099,
            1
        ],
        [
            68101,
            68102,
            1
        ],
        [
            68108,
            68111,
            1
        ],
        [
            68152,
            68154,
            1
        ],
        [
            68159,
            68325,
            166
        ],
        [
            68326,
            68900,
            574
        ],
        [
            68901,
            68903,
            1
        ],
        [
            69291,
            69292,
            1
        ],
        [
            69373,
            69375,
            1
        ],
        [
            69446,
            69456,
            1
        ],
        [
            69506,
            69509,
            1
        ],
        [
            69632,
            69634,
            1
        ],
        [
            69688,
            69702,
            1
        ],
        [
            69744,
            69747,
            3
        ],
        [
            69748,
            69759,
            11
        ],
        [
            69760,
            69762,
            1
        ],
        [
            69808,
            69818,
            1
        ],
        [
            69826,
            69888,
            62
        ],
        [
            69889,
            69890,
            1
        ],
        [
            69927,
            69940,
            1
        ],
        [
            69957,
            69958,
            1
        ],
        [
            70003,
            70016,
            13
        ],
        [
            70017,
            70018,
            1
        ],
        [
            70067,
            70080,
            1
        ],
        [
            70089,
            70092,
            1
        ],
        [
            70094,
            70095,
            1
        ],
        [
            70188,
            70199,
            1
        ],
        [
            70206,
            70209,
            3
        ],
        [
            70367,
            70378,
            1
        ],
        [
            70400,
            70403,
            1
        ],
        [
            70459,
            70460,
            1
        ],
        [
            70462,
            70468,
            1
        ],
        [
            70471,
            70472,
            1
        ],
        [
            70475,
            70477,
            1
        ],
        [
            70487,
            70498,
            11
        ],
        [
            70499,
            70502,
            3
        ],
        [
            70503,
            70508,
            1
        ],
        [
            70512,
            70516,
            1
        ],
        [
            70709,
            70726,
            1
        ],
        [
            70750,
            70832,
            82
        ],
        [
            70833,
            70851,
            1
        ],
        [
            71087,
            71093,
            1
        ],
        [
            71096,
            71104,
            1
        ],
        [
            71132,
            71133,
            1
        ],
        [
            71216,
            71232,
            1
        ],
        [
            71339,
            71351,
            1
        ],
        [
            71453,
            71467,
            1
        ],
        [
            71724,
            71738,
            1
        ],
        [
            71984,
            71989,
            1
        ],
        [
            71991,
            71992,
            1
        ],
        [
            71995,
            71998,
            1
        ],
        [
            72000,
            72002,
            2
        ],
        [
            72003,
            72145,
            142
        ],
        [
            72146,
            72151,
            1
        ],
        [
            72154,
            72160,
            1
        ],
        [
            72164,
            72193,
            29
        ],
        [
            72194,
            72202,
            1
        ],
        [
            72243,
            72249,
            1
        ],
        [
            72251,
            72254,
            1
        ],
        [
            72263,
            72273,
            10
        ],
        [
            72274,
            72283,
            1
        ],
        [
            72330,
            72345,
            1
        ],
        [
            72751,
            72758,
            1
        ],
        [
            72760,
            72767,
            1
        ],
        [
            72850,
            72871,
            1
        ],
        [
            72873,
            72886,
            1
        ],
        [
            73009,
            73014,
            1
        ],
        [
            73018,
            73020,
            2
        ],
        [
            73021,
            73023,
            2
        ],
        [
            73024,
            73029,
            1
        ],
        [
            73031,
            73098,
            67
        ],
        [
            73099,
            73102,
            1
        ],
        [
            73104,
            73105,
            1
        ],
        [
            73107,
            73111,
            1
        ],
        [
            73459,
            73462,
            1
        ],
        [
            73472,
            73473,
            1
        ],
        [
            73475,
            73524,
            49
        ],
        [
            73525,
            73530,
            1
        ],
        [
            73534,
            73538,
            1
        ],
        [
            78912,
            78919,
            7
        ],
        [
            78920,
            78933,
            1
        ],
        [
            92912,
            92916,
            1
        ],
        [
            92976,
            92982,
            1
        ],
        [
            94031,
            94033,
            2
        ],
        [
            94034,
            94087,
            1
        ],
        [
            94095,
            94098,
            1
        ],
        [
            94180,
            94192,
            12
        ],
        [
            94193,
            113821,
            19628
        ],
        [
            113822,
            118528,
            4706
        ],
        [
            118529,
            118573,
            1
        ],
        [
            118576,
            118598,
            1
        ],
        [
            119141,
            119145,
            1
        ],
        [
            119149,
            119154,
            1
        ],
        [
            119163,
            119170,
            1
        ],
        [
            119173,
            119179,
            1
        ],
        [
            119210,
            119213,
            1
        ],
        [
            119362,
            119364,
            1
        ],
        [
            121344,
            121398,
            1
        ],
        [
            121403,
            121452,
            1
        ],
        [
            121461,
            121476,
            15
        ],
        [
            121499,
            121503,
            1
        ],
        [
            121505,
            121519,
            1
        ],
        [
            122880,
            122886,
            1
        ],
        [
            122888,
            122904,
            1
        ],
        [
            122907,
            122913,
            1
        ],
        [
            122915,
            122916,
            1
        ],
        [
            122918,
            122922,
            1
        ],
        [
            123023,
            123184,
            161
        ],
        [
            123185,
            123190,
            1
        ],
        [
            123566,
            123628,
            62
        ],
        [
            123629,
            123631,
            1
        ],
        [
            124140,
            124143,
            1
        ],
        [
            125136,
            125142,
            1
        ],
        [
            125252,
            125258,
            1
        ],
        [
            917760,
            917999,
            1
        ]
    ];
    static foldM = [
        [
            921,
            953,
            32
        ],
        [
            8126,
            8126,
            1
        ]
    ];
    static Mc = [
        [
            2307,
            2363,
            56
        ],
        [
            2366,
            2368,
            1
        ],
        [
            2377,
            2380,
            1
        ],
        [
            2382,
            2383,
            1
        ],
        [
            2434,
            2435,
            1
        ],
        [
            2494,
            2496,
            1
        ],
        [
            2503,
            2504,
            1
        ],
        [
            2507,
            2508,
            1
        ],
        [
            2519,
            2563,
            44
        ],
        [
            2622,
            2624,
            1
        ],
        [
            2691,
            2750,
            59
        ],
        [
            2751,
            2752,
            1
        ],
        [
            2761,
            2763,
            2
        ],
        [
            2764,
            2818,
            54
        ],
        [
            2819,
            2878,
            59
        ],
        [
            2880,
            2887,
            7
        ],
        [
            2888,
            2891,
            3
        ],
        [
            2892,
            2903,
            11
        ],
        [
            3006,
            3007,
            1
        ],
        [
            3009,
            3010,
            1
        ],
        [
            3014,
            3016,
            1
        ],
        [
            3018,
            3020,
            1
        ],
        [
            3031,
            3073,
            42
        ],
        [
            3074,
            3075,
            1
        ],
        [
            3137,
            3140,
            1
        ],
        [
            3202,
            3203,
            1
        ],
        [
            3262,
            3264,
            2
        ],
        [
            3265,
            3268,
            1
        ],
        [
            3271,
            3272,
            1
        ],
        [
            3274,
            3275,
            1
        ],
        [
            3285,
            3286,
            1
        ],
        [
            3315,
            3330,
            15
        ],
        [
            3331,
            3390,
            59
        ],
        [
            3391,
            3392,
            1
        ],
        [
            3398,
            3400,
            1
        ],
        [
            3402,
            3404,
            1
        ],
        [
            3415,
            3458,
            43
        ],
        [
            3459,
            3535,
            76
        ],
        [
            3536,
            3537,
            1
        ],
        [
            3544,
            3551,
            1
        ],
        [
            3570,
            3571,
            1
        ],
        [
            3902,
            3903,
            1
        ],
        [
            3967,
            4139,
            172
        ],
        [
            4140,
            4145,
            5
        ],
        [
            4152,
            4155,
            3
        ],
        [
            4156,
            4182,
            26
        ],
        [
            4183,
            4194,
            11
        ],
        [
            4195,
            4196,
            1
        ],
        [
            4199,
            4205,
            1
        ],
        [
            4227,
            4228,
            1
        ],
        [
            4231,
            4236,
            1
        ],
        [
            4239,
            4250,
            11
        ],
        [
            4251,
            4252,
            1
        ],
        [
            5909,
            5940,
            31
        ],
        [
            6070,
            6078,
            8
        ],
        [
            6079,
            6085,
            1
        ],
        [
            6087,
            6088,
            1
        ],
        [
            6435,
            6438,
            1
        ],
        [
            6441,
            6443,
            1
        ],
        [
            6448,
            6449,
            1
        ],
        [
            6451,
            6456,
            1
        ],
        [
            6681,
            6682,
            1
        ],
        [
            6741,
            6743,
            2
        ],
        [
            6753,
            6755,
            2
        ],
        [
            6756,
            6765,
            9
        ],
        [
            6766,
            6770,
            1
        ],
        [
            6916,
            6965,
            49
        ],
        [
            6971,
            6973,
            2
        ],
        [
            6974,
            6977,
            1
        ],
        [
            6979,
            6980,
            1
        ],
        [
            7042,
            7073,
            31
        ],
        [
            7078,
            7079,
            1
        ],
        [
            7082,
            7143,
            61
        ],
        [
            7146,
            7148,
            1
        ],
        [
            7150,
            7154,
            4
        ],
        [
            7155,
            7204,
            49
        ],
        [
            7205,
            7211,
            1
        ],
        [
            7220,
            7221,
            1
        ],
        [
            7393,
            7415,
            22
        ],
        [
            12334,
            12335,
            1
        ],
        [
            43043,
            43044,
            1
        ],
        [
            43047,
            43136,
            89
        ],
        [
            43137,
            43188,
            51
        ],
        [
            43189,
            43203,
            1
        ],
        [
            43346,
            43347,
            1
        ],
        [
            43395,
            43444,
            49
        ],
        [
            43445,
            43450,
            5
        ],
        [
            43451,
            43454,
            3
        ],
        [
            43455,
            43456,
            1
        ],
        [
            43567,
            43568,
            1
        ],
        [
            43571,
            43572,
            1
        ],
        [
            43597,
            43643,
            46
        ],
        [
            43645,
            43755,
            110
        ],
        [
            43758,
            43759,
            1
        ],
        [
            43765,
            44003,
            238
        ],
        [
            44004,
            44006,
            2
        ],
        [
            44007,
            44009,
            2
        ],
        [
            44010,
            44012,
            2
        ],
        [
            69632,
            69634,
            2
        ],
        [
            69762,
            69808,
            46
        ],
        [
            69809,
            69810,
            1
        ],
        [
            69815,
            69816,
            1
        ],
        [
            69932,
            69957,
            25
        ],
        [
            69958,
            70018,
            60
        ],
        [
            70067,
            70069,
            1
        ],
        [
            70079,
            70080,
            1
        ],
        [
            70094,
            70188,
            94
        ],
        [
            70189,
            70190,
            1
        ],
        [
            70194,
            70195,
            1
        ],
        [
            70197,
            70368,
            171
        ],
        [
            70369,
            70370,
            1
        ],
        [
            70402,
            70403,
            1
        ],
        [
            70462,
            70463,
            1
        ],
        [
            70465,
            70468,
            1
        ],
        [
            70471,
            70472,
            1
        ],
        [
            70475,
            70477,
            1
        ],
        [
            70487,
            70498,
            11
        ],
        [
            70499,
            70709,
            210
        ],
        [
            70710,
            70711,
            1
        ],
        [
            70720,
            70721,
            1
        ],
        [
            70725,
            70832,
            107
        ],
        [
            70833,
            70834,
            1
        ],
        [
            70841,
            70843,
            2
        ],
        [
            70844,
            70846,
            1
        ],
        [
            70849,
            71087,
            238
        ],
        [
            71088,
            71089,
            1
        ],
        [
            71096,
            71099,
            1
        ],
        [
            71102,
            71216,
            114
        ],
        [
            71217,
            71218,
            1
        ],
        [
            71227,
            71228,
            1
        ],
        [
            71230,
            71340,
            110
        ],
        [
            71342,
            71343,
            1
        ],
        [
            71350,
            71456,
            106
        ],
        [
            71457,
            71462,
            5
        ],
        [
            71724,
            71726,
            1
        ],
        [
            71736,
            71984,
            248
        ],
        [
            71985,
            71989,
            1
        ],
        [
            71991,
            71992,
            1
        ],
        [
            71997,
            72000,
            3
        ],
        [
            72002,
            72145,
            143
        ],
        [
            72146,
            72147,
            1
        ],
        [
            72156,
            72159,
            1
        ],
        [
            72164,
            72249,
            85
        ],
        [
            72279,
            72280,
            1
        ],
        [
            72343,
            72751,
            408
        ],
        [
            72766,
            72873,
            107
        ],
        [
            72881,
            72884,
            3
        ],
        [
            73098,
            73102,
            1
        ],
        [
            73107,
            73108,
            1
        ],
        [
            73110,
            73461,
            351
        ],
        [
            73462,
            73475,
            13
        ],
        [
            73524,
            73525,
            1
        ],
        [
            73534,
            73535,
            1
        ],
        [
            73537,
            94033,
            20496
        ],
        [
            94034,
            94087,
            1
        ],
        [
            94192,
            94193,
            1
        ],
        [
            119141,
            119142,
            1
        ],
        [
            119149,
            119154,
            1
        ]
    ];
    static Me = [
        [
            1160,
            1161,
            1
        ],
        [
            6846,
            8413,
            1567
        ],
        [
            8414,
            8416,
            1
        ],
        [
            8418,
            8420,
            1
        ],
        [
            42608,
            42610,
            1
        ]
    ];
    static Mn = [
        [
            768,
            879,
            1
        ],
        [
            1155,
            1159,
            1
        ],
        [
            1425,
            1469,
            1
        ],
        [
            1471,
            1473,
            2
        ],
        [
            1474,
            1476,
            2
        ],
        [
            1477,
            1479,
            2
        ],
        [
            1552,
            1562,
            1
        ],
        [
            1611,
            1631,
            1
        ],
        [
            1648,
            1750,
            102
        ],
        [
            1751,
            1756,
            1
        ],
        [
            1759,
            1764,
            1
        ],
        [
            1767,
            1768,
            1
        ],
        [
            1770,
            1773,
            1
        ],
        [
            1809,
            1840,
            31
        ],
        [
            1841,
            1866,
            1
        ],
        [
            1958,
            1968,
            1
        ],
        [
            2027,
            2035,
            1
        ],
        [
            2045,
            2070,
            25
        ],
        [
            2071,
            2073,
            1
        ],
        [
            2075,
            2083,
            1
        ],
        [
            2085,
            2087,
            1
        ],
        [
            2089,
            2093,
            1
        ],
        [
            2137,
            2139,
            1
        ],
        [
            2200,
            2207,
            1
        ],
        [
            2250,
            2273,
            1
        ],
        [
            2275,
            2306,
            1
        ],
        [
            2362,
            2364,
            2
        ],
        [
            2369,
            2376,
            1
        ],
        [
            2381,
            2385,
            4
        ],
        [
            2386,
            2391,
            1
        ],
        [
            2402,
            2403,
            1
        ],
        [
            2433,
            2492,
            59
        ],
        [
            2497,
            2500,
            1
        ],
        [
            2509,
            2530,
            21
        ],
        [
            2531,
            2558,
            27
        ],
        [
            2561,
            2562,
            1
        ],
        [
            2620,
            2625,
            5
        ],
        [
            2626,
            2631,
            5
        ],
        [
            2632,
            2635,
            3
        ],
        [
            2636,
            2637,
            1
        ],
        [
            2641,
            2672,
            31
        ],
        [
            2673,
            2677,
            4
        ],
        [
            2689,
            2690,
            1
        ],
        [
            2748,
            2753,
            5
        ],
        [
            2754,
            2757,
            1
        ],
        [
            2759,
            2760,
            1
        ],
        [
            2765,
            2786,
            21
        ],
        [
            2787,
            2810,
            23
        ],
        [
            2811,
            2815,
            1
        ],
        [
            2817,
            2876,
            59
        ],
        [
            2879,
            2881,
            2
        ],
        [
            2882,
            2884,
            1
        ],
        [
            2893,
            2901,
            8
        ],
        [
            2902,
            2914,
            12
        ],
        [
            2915,
            2946,
            31
        ],
        [
            3008,
            3021,
            13
        ],
        [
            3072,
            3076,
            4
        ],
        [
            3132,
            3134,
            2
        ],
        [
            3135,
            3136,
            1
        ],
        [
            3142,
            3144,
            1
        ],
        [
            3146,
            3149,
            1
        ],
        [
            3157,
            3158,
            1
        ],
        [
            3170,
            3171,
            1
        ],
        [
            3201,
            3260,
            59
        ],
        [
            3263,
            3270,
            7
        ],
        [
            3276,
            3277,
            1
        ],
        [
            3298,
            3299,
            1
        ],
        [
            3328,
            3329,
            1
        ],
        [
            3387,
            3388,
            1
        ],
        [
            3393,
            3396,
            1
        ],
        [
            3405,
            3426,
            21
        ],
        [
            3427,
            3457,
            30
        ],
        [
            3530,
            3538,
            8
        ],
        [
            3539,
            3540,
            1
        ],
        [
            3542,
            3633,
            91
        ],
        [
            3636,
            3642,
            1
        ],
        [
            3655,
            3662,
            1
        ],
        [
            3761,
            3764,
            3
        ],
        [
            3765,
            3772,
            1
        ],
        [
            3784,
            3790,
            1
        ],
        [
            3864,
            3865,
            1
        ],
        [
            3893,
            3897,
            2
        ],
        [
            3953,
            3966,
            1
        ],
        [
            3968,
            3972,
            1
        ],
        [
            3974,
            3975,
            1
        ],
        [
            3981,
            3991,
            1
        ],
        [
            3993,
            4028,
            1
        ],
        [
            4038,
            4141,
            103
        ],
        [
            4142,
            4144,
            1
        ],
        [
            4146,
            4151,
            1
        ],
        [
            4153,
            4154,
            1
        ],
        [
            4157,
            4158,
            1
        ],
        [
            4184,
            4185,
            1
        ],
        [
            4190,
            4192,
            1
        ],
        [
            4209,
            4212,
            1
        ],
        [
            4226,
            4229,
            3
        ],
        [
            4230,
            4237,
            7
        ],
        [
            4253,
            4957,
            704
        ],
        [
            4958,
            4959,
            1
        ],
        [
            5906,
            5908,
            1
        ],
        [
            5938,
            5939,
            1
        ],
        [
            5970,
            5971,
            1
        ],
        [
            6002,
            6003,
            1
        ],
        [
            6068,
            6069,
            1
        ],
        [
            6071,
            6077,
            1
        ],
        [
            6086,
            6089,
            3
        ],
        [
            6090,
            6099,
            1
        ],
        [
            6109,
            6155,
            46
        ],
        [
            6156,
            6157,
            1
        ],
        [
            6159,
            6277,
            118
        ],
        [
            6278,
            6313,
            35
        ],
        [
            6432,
            6434,
            1
        ],
        [
            6439,
            6440,
            1
        ],
        [
            6450,
            6457,
            7
        ],
        [
            6458,
            6459,
            1
        ],
        [
            6679,
            6680,
            1
        ],
        [
            6683,
            6742,
            59
        ],
        [
            6744,
            6750,
            1
        ],
        [
            6752,
            6754,
            2
        ],
        [
            6757,
            6764,
            1
        ],
        [
            6771,
            6780,
            1
        ],
        [
            6783,
            6832,
            49
        ],
        [
            6833,
            6845,
            1
        ],
        [
            6847,
            6862,
            1
        ],
        [
            6912,
            6915,
            1
        ],
        [
            6964,
            6966,
            2
        ],
        [
            6967,
            6970,
            1
        ],
        [
            6972,
            6978,
            6
        ],
        [
            7019,
            7027,
            1
        ],
        [
            7040,
            7041,
            1
        ],
        [
            7074,
            7077,
            1
        ],
        [
            7080,
            7081,
            1
        ],
        [
            7083,
            7085,
            1
        ],
        [
            7142,
            7144,
            2
        ],
        [
            7145,
            7149,
            4
        ],
        [
            7151,
            7153,
            1
        ],
        [
            7212,
            7219,
            1
        ],
        [
            7222,
            7223,
            1
        ],
        [
            7376,
            7378,
            1
        ],
        [
            7380,
            7392,
            1
        ],
        [
            7394,
            7400,
            1
        ],
        [
            7405,
            7412,
            7
        ],
        [
            7416,
            7417,
            1
        ],
        [
            7616,
            7679,
            1
        ],
        [
            8400,
            8412,
            1
        ],
        [
            8417,
            8421,
            4
        ],
        [
            8422,
            8432,
            1
        ],
        [
            11503,
            11505,
            1
        ],
        [
            11647,
            11744,
            97
        ],
        [
            11745,
            11775,
            1
        ],
        [
            12330,
            12333,
            1
        ],
        [
            12441,
            12442,
            1
        ],
        [
            42607,
            42612,
            5
        ],
        [
            42613,
            42621,
            1
        ],
        [
            42654,
            42655,
            1
        ],
        [
            42736,
            42737,
            1
        ],
        [
            43010,
            43014,
            4
        ],
        [
            43019,
            43045,
            26
        ],
        [
            43046,
            43052,
            6
        ],
        [
            43204,
            43205,
            1
        ],
        [
            43232,
            43249,
            1
        ],
        [
            43263,
            43302,
            39
        ],
        [
            43303,
            43309,
            1
        ],
        [
            43335,
            43345,
            1
        ],
        [
            43392,
            43394,
            1
        ],
        [
            43443,
            43446,
            3
        ],
        [
            43447,
            43449,
            1
        ],
        [
            43452,
            43453,
            1
        ],
        [
            43493,
            43561,
            68
        ],
        [
            43562,
            43566,
            1
        ],
        [
            43569,
            43570,
            1
        ],
        [
            43573,
            43574,
            1
        ],
        [
            43587,
            43596,
            9
        ],
        [
            43644,
            43696,
            52
        ],
        [
            43698,
            43700,
            1
        ],
        [
            43703,
            43704,
            1
        ],
        [
            43710,
            43711,
            1
        ],
        [
            43713,
            43756,
            43
        ],
        [
            43757,
            43766,
            9
        ],
        [
            44005,
            44008,
            3
        ],
        [
            44013,
            64286,
            20273
        ],
        [
            65024,
            65039,
            1
        ],
        [
            65056,
            65071,
            1
        ],
        [
            66045,
            66272,
            227
        ],
        [
            66422,
            66426,
            1
        ],
        [
            68097,
            68099,
            1
        ],
        [
            68101,
            68102,
            1
        ],
        [
            68108,
            68111,
            1
        ],
        [
            68152,
            68154,
            1
        ],
        [
            68159,
            68325,
            166
        ],
        [
            68326,
            68900,
            574
        ],
        [
            68901,
            68903,
            1
        ],
        [
            69291,
            69292,
            1
        ],
        [
            69373,
            69375,
            1
        ],
        [
            69446,
            69456,
            1
        ],
        [
            69506,
            69509,
            1
        ],
        [
            69633,
            69688,
            55
        ],
        [
            69689,
            69702,
            1
        ],
        [
            69744,
            69747,
            3
        ],
        [
            69748,
            69759,
            11
        ],
        [
            69760,
            69761,
            1
        ],
        [
            69811,
            69814,
            1
        ],
        [
            69817,
            69818,
            1
        ],
        [
            69826,
            69888,
            62
        ],
        [
            69889,
            69890,
            1
        ],
        [
            69927,
            69931,
            1
        ],
        [
            69933,
            69940,
            1
        ],
        [
            70003,
            70016,
            13
        ],
        [
            70017,
            70070,
            53
        ],
        [
            70071,
            70078,
            1
        ],
        [
            70089,
            70092,
            1
        ],
        [
            70095,
            70191,
            96
        ],
        [
            70192,
            70193,
            1
        ],
        [
            70196,
            70198,
            2
        ],
        [
            70199,
            70206,
            7
        ],
        [
            70209,
            70367,
            158
        ],
        [
            70371,
            70378,
            1
        ],
        [
            70400,
            70401,
            1
        ],
        [
            70459,
            70460,
            1
        ],
        [
            70464,
            70502,
            38
        ],
        [
            70503,
            70508,
            1
        ],
        [
            70512,
            70516,
            1
        ],
        [
            70712,
            70719,
            1
        ],
        [
            70722,
            70724,
            1
        ],
        [
            70726,
            70750,
            24
        ],
        [
            70835,
            70840,
            1
        ],
        [
            70842,
            70847,
            5
        ],
        [
            70848,
            70850,
            2
        ],
        [
            70851,
            71090,
            239
        ],
        [
            71091,
            71093,
            1
        ],
        [
            71100,
            71101,
            1
        ],
        [
            71103,
            71104,
            1
        ],
        [
            71132,
            71133,
            1
        ],
        [
            71219,
            71226,
            1
        ],
        [
            71229,
            71231,
            2
        ],
        [
            71232,
            71339,
            107
        ],
        [
            71341,
            71344,
            3
        ],
        [
            71345,
            71349,
            1
        ],
        [
            71351,
            71453,
            102
        ],
        [
            71454,
            71455,
            1
        ],
        [
            71458,
            71461,
            1
        ],
        [
            71463,
            71467,
            1
        ],
        [
            71727,
            71735,
            1
        ],
        [
            71737,
            71738,
            1
        ],
        [
            71995,
            71996,
            1
        ],
        [
            71998,
            72003,
            5
        ],
        [
            72148,
            72151,
            1
        ],
        [
            72154,
            72155,
            1
        ],
        [
            72160,
            72193,
            33
        ],
        [
            72194,
            72202,
            1
        ],
        [
            72243,
            72248,
            1
        ],
        [
            72251,
            72254,
            1
        ],
        [
            72263,
            72273,
            10
        ],
        [
            72274,
            72278,
            1
        ],
        [
            72281,
            72283,
            1
        ],
        [
            72330,
            72342,
            1
        ],
        [
            72344,
            72345,
            1
        ],
        [
            72752,
            72758,
            1
        ],
        [
            72760,
            72765,
            1
        ],
        [
            72767,
            72850,
            83
        ],
        [
            72851,
            72871,
            1
        ],
        [
            72874,
            72880,
            1
        ],
        [
            72882,
            72883,
            1
        ],
        [
            72885,
            72886,
            1
        ],
        [
            73009,
            73014,
            1
        ],
        [
            73018,
            73020,
            2
        ],
        [
            73021,
            73023,
            2
        ],
        [
            73024,
            73029,
            1
        ],
        [
            73031,
            73104,
            73
        ],
        [
            73105,
            73109,
            4
        ],
        [
            73111,
            73459,
            348
        ],
        [
            73460,
            73472,
            12
        ],
        [
            73473,
            73526,
            53
        ],
        [
            73527,
            73530,
            1
        ],
        [
            73536,
            73538,
            2
        ],
        [
            78912,
            78919,
            7
        ],
        [
            78920,
            78933,
            1
        ],
        [
            92912,
            92916,
            1
        ],
        [
            92976,
            92982,
            1
        ],
        [
            94031,
            94095,
            64
        ],
        [
            94096,
            94098,
            1
        ],
        [
            94180,
            113821,
            19641
        ],
        [
            113822,
            118528,
            4706
        ],
        [
            118529,
            118573,
            1
        ],
        [
            118576,
            118598,
            1
        ],
        [
            119143,
            119145,
            1
        ],
        [
            119163,
            119170,
            1
        ],
        [
            119173,
            119179,
            1
        ],
        [
            119210,
            119213,
            1
        ],
        [
            119362,
            119364,
            1
        ],
        [
            121344,
            121398,
            1
        ],
        [
            121403,
            121452,
            1
        ],
        [
            121461,
            121476,
            15
        ],
        [
            121499,
            121503,
            1
        ],
        [
            121505,
            121519,
            1
        ],
        [
            122880,
            122886,
            1
        ],
        [
            122888,
            122904,
            1
        ],
        [
            122907,
            122913,
            1
        ],
        [
            122915,
            122916,
            1
        ],
        [
            122918,
            122922,
            1
        ],
        [
            123023,
            123184,
            161
        ],
        [
            123185,
            123190,
            1
        ],
        [
            123566,
            123628,
            62
        ],
        [
            123629,
            123631,
            1
        ],
        [
            124140,
            124143,
            1
        ],
        [
            125136,
            125142,
            1
        ],
        [
            125252,
            125258,
            1
        ],
        [
            917760,
            917999,
            1
        ]
    ];
    static foldMn = [
        [
            921,
            953,
            32
        ],
        [
            8126,
            8126,
            1
        ]
    ];
    static N = [
        [
            48,
            57,
            1
        ],
        [
            178,
            179,
            1
        ],
        [
            185,
            188,
            3
        ],
        [
            189,
            190,
            1
        ],
        [
            1632,
            1641,
            1
        ],
        [
            1776,
            1785,
            1
        ],
        [
            1984,
            1993,
            1
        ],
        [
            2406,
            2415,
            1
        ],
        [
            2534,
            2543,
            1
        ],
        [
            2548,
            2553,
            1
        ],
        [
            2662,
            2671,
            1
        ],
        [
            2790,
            2799,
            1
        ],
        [
            2918,
            2927,
            1
        ],
        [
            2930,
            2935,
            1
        ],
        [
            3046,
            3058,
            1
        ],
        [
            3174,
            3183,
            1
        ],
        [
            3192,
            3198,
            1
        ],
        [
            3302,
            3311,
            1
        ],
        [
            3416,
            3422,
            1
        ],
        [
            3430,
            3448,
            1
        ],
        [
            3558,
            3567,
            1
        ],
        [
            3664,
            3673,
            1
        ],
        [
            3792,
            3801,
            1
        ],
        [
            3872,
            3891,
            1
        ],
        [
            4160,
            4169,
            1
        ],
        [
            4240,
            4249,
            1
        ],
        [
            4969,
            4988,
            1
        ],
        [
            5870,
            5872,
            1
        ],
        [
            6112,
            6121,
            1
        ],
        [
            6128,
            6137,
            1
        ],
        [
            6160,
            6169,
            1
        ],
        [
            6470,
            6479,
            1
        ],
        [
            6608,
            6618,
            1
        ],
        [
            6784,
            6793,
            1
        ],
        [
            6800,
            6809,
            1
        ],
        [
            6992,
            7001,
            1
        ],
        [
            7088,
            7097,
            1
        ],
        [
            7232,
            7241,
            1
        ],
        [
            7248,
            7257,
            1
        ],
        [
            8304,
            8308,
            4
        ],
        [
            8309,
            8313,
            1
        ],
        [
            8320,
            8329,
            1
        ],
        [
            8528,
            8578,
            1
        ],
        [
            8581,
            8585,
            1
        ],
        [
            9312,
            9371,
            1
        ],
        [
            9450,
            9471,
            1
        ],
        [
            10102,
            10131,
            1
        ],
        [
            11517,
            12295,
            778
        ],
        [
            12321,
            12329,
            1
        ],
        [
            12344,
            12346,
            1
        ],
        [
            12690,
            12693,
            1
        ],
        [
            12832,
            12841,
            1
        ],
        [
            12872,
            12879,
            1
        ],
        [
            12881,
            12895,
            1
        ],
        [
            12928,
            12937,
            1
        ],
        [
            12977,
            12991,
            1
        ],
        [
            42528,
            42537,
            1
        ],
        [
            42726,
            42735,
            1
        ],
        [
            43056,
            43061,
            1
        ],
        [
            43216,
            43225,
            1
        ],
        [
            43264,
            43273,
            1
        ],
        [
            43472,
            43481,
            1
        ],
        [
            43504,
            43513,
            1
        ],
        [
            43600,
            43609,
            1
        ],
        [
            44016,
            44025,
            1
        ],
        [
            65296,
            65305,
            1
        ],
        [
            65799,
            65843,
            1
        ],
        [
            65856,
            65912,
            1
        ],
        [
            65930,
            65931,
            1
        ],
        [
            66273,
            66299,
            1
        ],
        [
            66336,
            66339,
            1
        ],
        [
            66369,
            66378,
            9
        ],
        [
            66513,
            66517,
            1
        ],
        [
            66720,
            66729,
            1
        ],
        [
            67672,
            67679,
            1
        ],
        [
            67705,
            67711,
            1
        ],
        [
            67751,
            67759,
            1
        ],
        [
            67835,
            67839,
            1
        ],
        [
            67862,
            67867,
            1
        ],
        [
            68028,
            68029,
            1
        ],
        [
            68032,
            68047,
            1
        ],
        [
            68050,
            68095,
            1
        ],
        [
            68160,
            68168,
            1
        ],
        [
            68221,
            68222,
            1
        ],
        [
            68253,
            68255,
            1
        ],
        [
            68331,
            68335,
            1
        ],
        [
            68440,
            68447,
            1
        ],
        [
            68472,
            68479,
            1
        ],
        [
            68521,
            68527,
            1
        ],
        [
            68858,
            68863,
            1
        ],
        [
            68912,
            68921,
            1
        ],
        [
            69216,
            69246,
            1
        ],
        [
            69405,
            69414,
            1
        ],
        [
            69457,
            69460,
            1
        ],
        [
            69573,
            69579,
            1
        ],
        [
            69714,
            69743,
            1
        ],
        [
            69872,
            69881,
            1
        ],
        [
            69942,
            69951,
            1
        ],
        [
            70096,
            70105,
            1
        ],
        [
            70113,
            70132,
            1
        ],
        [
            70384,
            70393,
            1
        ],
        [
            70736,
            70745,
            1
        ],
        [
            70864,
            70873,
            1
        ],
        [
            71248,
            71257,
            1
        ],
        [
            71360,
            71369,
            1
        ],
        [
            71472,
            71483,
            1
        ],
        [
            71904,
            71922,
            1
        ],
        [
            72016,
            72025,
            1
        ],
        [
            72784,
            72812,
            1
        ],
        [
            73040,
            73049,
            1
        ],
        [
            73120,
            73129,
            1
        ],
        [
            73552,
            73561,
            1
        ],
        [
            73664,
            73684,
            1
        ],
        [
            74752,
            74862,
            1
        ],
        [
            92768,
            92777,
            1
        ],
        [
            92864,
            92873,
            1
        ],
        [
            93008,
            93017,
            1
        ],
        [
            93019,
            93025,
            1
        ],
        [
            93824,
            93846,
            1
        ],
        [
            119488,
            119507,
            1
        ],
        [
            119520,
            119539,
            1
        ],
        [
            119648,
            119672,
            1
        ],
        [
            120782,
            120831,
            1
        ],
        [
            123200,
            123209,
            1
        ],
        [
            123632,
            123641,
            1
        ],
        [
            124144,
            124153,
            1
        ],
        [
            125127,
            125135,
            1
        ],
        [
            125264,
            125273,
            1
        ],
        [
            126065,
            126123,
            1
        ],
        [
            126125,
            126127,
            1
        ],
        [
            126129,
            126132,
            1
        ],
        [
            126209,
            126253,
            1
        ],
        [
            126255,
            126269,
            1
        ],
        [
            127232,
            127244,
            1
        ],
        [
            130032,
            130041,
            1
        ]
    ];
    static Nd = [
        [
            48,
            57,
            1
        ],
        [
            1632,
            1641,
            1
        ],
        [
            1776,
            1785,
            1
        ],
        [
            1984,
            1993,
            1
        ],
        [
            2406,
            2415,
            1
        ],
        [
            2534,
            2543,
            1
        ],
        [
            2662,
            2671,
            1
        ],
        [
            2790,
            2799,
            1
        ],
        [
            2918,
            2927,
            1
        ],
        [
            3046,
            3055,
            1
        ],
        [
            3174,
            3183,
            1
        ],
        [
            3302,
            3311,
            1
        ],
        [
            3430,
            3439,
            1
        ],
        [
            3558,
            3567,
            1
        ],
        [
            3664,
            3673,
            1
        ],
        [
            3792,
            3801,
            1
        ],
        [
            3872,
            3881,
            1
        ],
        [
            4160,
            4169,
            1
        ],
        [
            4240,
            4249,
            1
        ],
        [
            6112,
            6121,
            1
        ],
        [
            6160,
            6169,
            1
        ],
        [
            6470,
            6479,
            1
        ],
        [
            6608,
            6617,
            1
        ],
        [
            6784,
            6793,
            1
        ],
        [
            6800,
            6809,
            1
        ],
        [
            6992,
            7001,
            1
        ],
        [
            7088,
            7097,
            1
        ],
        [
            7232,
            7241,
            1
        ],
        [
            7248,
            7257,
            1
        ],
        [
            42528,
            42537,
            1
        ],
        [
            43216,
            43225,
            1
        ],
        [
            43264,
            43273,
            1
        ],
        [
            43472,
            43481,
            1
        ],
        [
            43504,
            43513,
            1
        ],
        [
            43600,
            43609,
            1
        ],
        [
            44016,
            44025,
            1
        ],
        [
            65296,
            65305,
            1
        ],
        [
            66720,
            66729,
            1
        ],
        [
            68912,
            68921,
            1
        ],
        [
            69734,
            69743,
            1
        ],
        [
            69872,
            69881,
            1
        ],
        [
            69942,
            69951,
            1
        ],
        [
            70096,
            70105,
            1
        ],
        [
            70384,
            70393,
            1
        ],
        [
            70736,
            70745,
            1
        ],
        [
            70864,
            70873,
            1
        ],
        [
            71248,
            71257,
            1
        ],
        [
            71360,
            71369,
            1
        ],
        [
            71472,
            71481,
            1
        ],
        [
            71904,
            71913,
            1
        ],
        [
            72016,
            72025,
            1
        ],
        [
            72784,
            72793,
            1
        ],
        [
            73040,
            73049,
            1
        ],
        [
            73120,
            73129,
            1
        ],
        [
            73552,
            73561,
            1
        ],
        [
            92768,
            92777,
            1
        ],
        [
            92864,
            92873,
            1
        ],
        [
            93008,
            93017,
            1
        ],
        [
            120782,
            120831,
            1
        ],
        [
            123200,
            123209,
            1
        ],
        [
            123632,
            123641,
            1
        ],
        [
            124144,
            124153,
            1
        ],
        [
            125264,
            125273,
            1
        ],
        [
            130032,
            130041,
            1
        ]
    ];
    static Nl = [
        [
            5870,
            5872,
            1
        ],
        [
            8544,
            8578,
            1
        ],
        [
            8581,
            8584,
            1
        ],
        [
            12295,
            12321,
            26
        ],
        [
            12322,
            12329,
            1
        ],
        [
            12344,
            12346,
            1
        ],
        [
            42726,
            42735,
            1
        ],
        [
            65856,
            65908,
            1
        ],
        [
            66369,
            66378,
            9
        ],
        [
            66513,
            66517,
            1
        ],
        [
            74752,
            74862,
            1
        ]
    ];
    static No = [
        [
            178,
            179,
            1
        ],
        [
            185,
            188,
            3
        ],
        [
            189,
            190,
            1
        ],
        [
            2548,
            2553,
            1
        ],
        [
            2930,
            2935,
            1
        ],
        [
            3056,
            3058,
            1
        ],
        [
            3192,
            3198,
            1
        ],
        [
            3416,
            3422,
            1
        ],
        [
            3440,
            3448,
            1
        ],
        [
            3882,
            3891,
            1
        ],
        [
            4969,
            4988,
            1
        ],
        [
            6128,
            6137,
            1
        ],
        [
            6618,
            8304,
            1686
        ],
        [
            8308,
            8313,
            1
        ],
        [
            8320,
            8329,
            1
        ],
        [
            8528,
            8543,
            1
        ],
        [
            8585,
            9312,
            727
        ],
        [
            9313,
            9371,
            1
        ],
        [
            9450,
            9471,
            1
        ],
        [
            10102,
            10131,
            1
        ],
        [
            11517,
            12690,
            1173
        ],
        [
            12691,
            12693,
            1
        ],
        [
            12832,
            12841,
            1
        ],
        [
            12872,
            12879,
            1
        ],
        [
            12881,
            12895,
            1
        ],
        [
            12928,
            12937,
            1
        ],
        [
            12977,
            12991,
            1
        ],
        [
            43056,
            43061,
            1
        ],
        [
            65799,
            65843,
            1
        ],
        [
            65909,
            65912,
            1
        ],
        [
            65930,
            65931,
            1
        ],
        [
            66273,
            66299,
            1
        ],
        [
            66336,
            66339,
            1
        ],
        [
            67672,
            67679,
            1
        ],
        [
            67705,
            67711,
            1
        ],
        [
            67751,
            67759,
            1
        ],
        [
            67835,
            67839,
            1
        ],
        [
            67862,
            67867,
            1
        ],
        [
            68028,
            68029,
            1
        ],
        [
            68032,
            68047,
            1
        ],
        [
            68050,
            68095,
            1
        ],
        [
            68160,
            68168,
            1
        ],
        [
            68221,
            68222,
            1
        ],
        [
            68253,
            68255,
            1
        ],
        [
            68331,
            68335,
            1
        ],
        [
            68440,
            68447,
            1
        ],
        [
            68472,
            68479,
            1
        ],
        [
            68521,
            68527,
            1
        ],
        [
            68858,
            68863,
            1
        ],
        [
            69216,
            69246,
            1
        ],
        [
            69405,
            69414,
            1
        ],
        [
            69457,
            69460,
            1
        ],
        [
            69573,
            69579,
            1
        ],
        [
            69714,
            69733,
            1
        ],
        [
            70113,
            70132,
            1
        ],
        [
            71482,
            71483,
            1
        ],
        [
            71914,
            71922,
            1
        ],
        [
            72794,
            72812,
            1
        ],
        [
            73664,
            73684,
            1
        ],
        [
            93019,
            93025,
            1
        ],
        [
            93824,
            93846,
            1
        ],
        [
            119488,
            119507,
            1
        ],
        [
            119520,
            119539,
            1
        ],
        [
            119648,
            119672,
            1
        ],
        [
            125127,
            125135,
            1
        ],
        [
            126065,
            126123,
            1
        ],
        [
            126125,
            126127,
            1
        ],
        [
            126129,
            126132,
            1
        ],
        [
            126209,
            126253,
            1
        ],
        [
            126255,
            126269,
            1
        ],
        [
            127232,
            127244,
            1
        ]
    ];
    static P = [
        [
            33,
            35,
            1
        ],
        [
            37,
            42,
            1
        ],
        [
            44,
            47,
            1
        ],
        [
            58,
            59,
            1
        ],
        [
            63,
            64,
            1
        ],
        [
            91,
            93,
            1
        ],
        [
            95,
            123,
            28
        ],
        [
            125,
            161,
            36
        ],
        [
            167,
            171,
            4
        ],
        [
            182,
            183,
            1
        ],
        [
            187,
            191,
            4
        ],
        [
            894,
            903,
            9
        ],
        [
            1370,
            1375,
            1
        ],
        [
            1417,
            1418,
            1
        ],
        [
            1470,
            1472,
            2
        ],
        [
            1475,
            1478,
            3
        ],
        [
            1523,
            1524,
            1
        ],
        [
            1545,
            1546,
            1
        ],
        [
            1548,
            1549,
            1
        ],
        [
            1563,
            1565,
            2
        ],
        [
            1566,
            1567,
            1
        ],
        [
            1642,
            1645,
            1
        ],
        [
            1748,
            1792,
            44
        ],
        [
            1793,
            1805,
            1
        ],
        [
            2039,
            2041,
            1
        ],
        [
            2096,
            2110,
            1
        ],
        [
            2142,
            2404,
            262
        ],
        [
            2405,
            2416,
            11
        ],
        [
            2557,
            2678,
            121
        ],
        [
            2800,
            3191,
            391
        ],
        [
            3204,
            3572,
            368
        ],
        [
            3663,
            3674,
            11
        ],
        [
            3675,
            3844,
            169
        ],
        [
            3845,
            3858,
            1
        ],
        [
            3860,
            3898,
            38
        ],
        [
            3899,
            3901,
            1
        ],
        [
            3973,
            4048,
            75
        ],
        [
            4049,
            4052,
            1
        ],
        [
            4057,
            4058,
            1
        ],
        [
            4170,
            4175,
            1
        ],
        [
            4347,
            4960,
            613
        ],
        [
            4961,
            4968,
            1
        ],
        [
            5120,
            5742,
            622
        ],
        [
            5787,
            5788,
            1
        ],
        [
            5867,
            5869,
            1
        ],
        [
            5941,
            5942,
            1
        ],
        [
            6100,
            6102,
            1
        ],
        [
            6104,
            6106,
            1
        ],
        [
            6144,
            6154,
            1
        ],
        [
            6468,
            6469,
            1
        ],
        [
            6686,
            6687,
            1
        ],
        [
            6816,
            6822,
            1
        ],
        [
            6824,
            6829,
            1
        ],
        [
            7002,
            7008,
            1
        ],
        [
            7037,
            7038,
            1
        ],
        [
            7164,
            7167,
            1
        ],
        [
            7227,
            7231,
            1
        ],
        [
            7294,
            7295,
            1
        ],
        [
            7360,
            7367,
            1
        ],
        [
            7379,
            8208,
            829
        ],
        [
            8209,
            8231,
            1
        ],
        [
            8240,
            8259,
            1
        ],
        [
            8261,
            8273,
            1
        ],
        [
            8275,
            8286,
            1
        ],
        [
            8317,
            8318,
            1
        ],
        [
            8333,
            8334,
            1
        ],
        [
            8968,
            8971,
            1
        ],
        [
            9001,
            9002,
            1
        ],
        [
            10088,
            10101,
            1
        ],
        [
            10181,
            10182,
            1
        ],
        [
            10214,
            10223,
            1
        ],
        [
            10627,
            10648,
            1
        ],
        [
            10712,
            10715,
            1
        ],
        [
            10748,
            10749,
            1
        ],
        [
            11513,
            11516,
            1
        ],
        [
            11518,
            11519,
            1
        ],
        [
            11632,
            11776,
            144
        ],
        [
            11777,
            11822,
            1
        ],
        [
            11824,
            11855,
            1
        ],
        [
            11858,
            11869,
            1
        ],
        [
            12289,
            12291,
            1
        ],
        [
            12296,
            12305,
            1
        ],
        [
            12308,
            12319,
            1
        ],
        [
            12336,
            12349,
            13
        ],
        [
            12448,
            12539,
            91
        ],
        [
            42238,
            42239,
            1
        ],
        [
            42509,
            42511,
            1
        ],
        [
            42611,
            42622,
            11
        ],
        [
            42738,
            42743,
            1
        ],
        [
            43124,
            43127,
            1
        ],
        [
            43214,
            43215,
            1
        ],
        [
            43256,
            43258,
            1
        ],
        [
            43260,
            43310,
            50
        ],
        [
            43311,
            43359,
            48
        ],
        [
            43457,
            43469,
            1
        ],
        [
            43486,
            43487,
            1
        ],
        [
            43612,
            43615,
            1
        ],
        [
            43742,
            43743,
            1
        ],
        [
            43760,
            43761,
            1
        ],
        [
            44011,
            64830,
            20819
        ],
        [
            64831,
            65040,
            209
        ],
        [
            65041,
            65049,
            1
        ],
        [
            65072,
            65106,
            1
        ],
        [
            65108,
            65121,
            1
        ],
        [
            65123,
            65128,
            5
        ],
        [
            65130,
            65131,
            1
        ],
        [
            65281,
            65283,
            1
        ],
        [
            65285,
            65290,
            1
        ],
        [
            65292,
            65295,
            1
        ],
        [
            65306,
            65307,
            1
        ],
        [
            65311,
            65312,
            1
        ],
        [
            65339,
            65341,
            1
        ],
        [
            65343,
            65371,
            28
        ],
        [
            65373,
            65375,
            2
        ],
        [
            65376,
            65381,
            1
        ],
        [
            65792,
            65794,
            1
        ],
        [
            66463,
            66512,
            49
        ],
        [
            66927,
            67671,
            744
        ],
        [
            67871,
            67903,
            32
        ],
        [
            68176,
            68184,
            1
        ],
        [
            68223,
            68336,
            113
        ],
        [
            68337,
            68342,
            1
        ],
        [
            68409,
            68415,
            1
        ],
        [
            68505,
            68508,
            1
        ],
        [
            69293,
            69461,
            168
        ],
        [
            69462,
            69465,
            1
        ],
        [
            69510,
            69513,
            1
        ],
        [
            69703,
            69709,
            1
        ],
        [
            69819,
            69820,
            1
        ],
        [
            69822,
            69825,
            1
        ],
        [
            69952,
            69955,
            1
        ],
        [
            70004,
            70005,
            1
        ],
        [
            70085,
            70088,
            1
        ],
        [
            70093,
            70107,
            14
        ],
        [
            70109,
            70111,
            1
        ],
        [
            70200,
            70205,
            1
        ],
        [
            70313,
            70731,
            418
        ],
        [
            70732,
            70735,
            1
        ],
        [
            70746,
            70747,
            1
        ],
        [
            70749,
            70854,
            105
        ],
        [
            71105,
            71127,
            1
        ],
        [
            71233,
            71235,
            1
        ],
        [
            71264,
            71276,
            1
        ],
        [
            71353,
            71484,
            131
        ],
        [
            71485,
            71486,
            1
        ],
        [
            71739,
            72004,
            265
        ],
        [
            72005,
            72006,
            1
        ],
        [
            72162,
            72255,
            93
        ],
        [
            72256,
            72262,
            1
        ],
        [
            72346,
            72348,
            1
        ],
        [
            72350,
            72354,
            1
        ],
        [
            72448,
            72457,
            1
        ],
        [
            72769,
            72773,
            1
        ],
        [
            72816,
            72817,
            1
        ],
        [
            73463,
            73464,
            1
        ],
        [
            73539,
            73551,
            1
        ],
        [
            73727,
            74864,
            1137
        ],
        [
            74865,
            74868,
            1
        ],
        [
            77809,
            77810,
            1
        ],
        [
            92782,
            92783,
            1
        ],
        [
            92917,
            92983,
            66
        ],
        [
            92984,
            92987,
            1
        ],
        [
            92996,
            93847,
            851
        ],
        [
            93848,
            93850,
            1
        ],
        [
            94178,
            113823,
            19645
        ],
        [
            121479,
            121483,
            1
        ],
        [
            125278,
            125279,
            1
        ]
    ];
    static Pc = [
        [
            95,
            8255,
            8160
        ],
        [
            8256,
            8276,
            20
        ],
        [
            65075,
            65076,
            1
        ],
        [
            65101,
            65103,
            1
        ],
        [
            65343,
            65343,
            1
        ]
    ];
    static Pd = [
        [
            45,
            1418,
            1373
        ],
        [
            1470,
            5120,
            3650
        ],
        [
            6150,
            8208,
            2058
        ],
        [
            8209,
            8213,
            1
        ],
        [
            11799,
            11802,
            3
        ],
        [
            11834,
            11835,
            1
        ],
        [
            11840,
            11869,
            29
        ],
        [
            12316,
            12336,
            20
        ],
        [
            12448,
            65073,
            52625
        ],
        [
            65074,
            65112,
            38
        ],
        [
            65123,
            65293,
            170
        ],
        [
            69293,
            69293,
            1
        ]
    ];
    static Pe = [
        [
            41,
            93,
            52
        ],
        [
            125,
            3899,
            3774
        ],
        [
            3901,
            5788,
            1887
        ],
        [
            8262,
            8318,
            56
        ],
        [
            8334,
            8969,
            635
        ],
        [
            8971,
            9002,
            31
        ],
        [
            10089,
            10101,
            2
        ],
        [
            10182,
            10215,
            33
        ],
        [
            10217,
            10223,
            2
        ],
        [
            10628,
            10648,
            2
        ],
        [
            10713,
            10715,
            2
        ],
        [
            10749,
            11811,
            1062
        ],
        [
            11813,
            11817,
            2
        ],
        [
            11862,
            11868,
            2
        ],
        [
            12297,
            12305,
            2
        ],
        [
            12309,
            12315,
            2
        ],
        [
            12318,
            12319,
            1
        ],
        [
            64830,
            65048,
            218
        ],
        [
            65078,
            65092,
            2
        ],
        [
            65096,
            65114,
            18
        ],
        [
            65116,
            65118,
            2
        ],
        [
            65289,
            65341,
            52
        ],
        [
            65373,
            65379,
            3
        ]
    ];
    static Pf = [
        [
            187,
            8217,
            8030
        ],
        [
            8221,
            8250,
            29
        ],
        [
            11779,
            11781,
            2
        ],
        [
            11786,
            11789,
            3
        ],
        [
            11805,
            11809,
            4
        ]
    ];
    static Pi = [
        [
            171,
            8216,
            8045
        ],
        [
            8219,
            8220,
            1
        ],
        [
            8223,
            8249,
            26
        ],
        [
            11778,
            11780,
            2
        ],
        [
            11785,
            11788,
            3
        ],
        [
            11804,
            11808,
            4
        ]
    ];
    static Po = [
        [
            33,
            35,
            1
        ],
        [
            37,
            39,
            1
        ],
        [
            42,
            46,
            2
        ],
        [
            47,
            58,
            11
        ],
        [
            59,
            63,
            4
        ],
        [
            64,
            92,
            28
        ],
        [
            161,
            167,
            6
        ],
        [
            182,
            183,
            1
        ],
        [
            191,
            894,
            703
        ],
        [
            903,
            1370,
            467
        ],
        [
            1371,
            1375,
            1
        ],
        [
            1417,
            1472,
            55
        ],
        [
            1475,
            1478,
            3
        ],
        [
            1523,
            1524,
            1
        ],
        [
            1545,
            1546,
            1
        ],
        [
            1548,
            1549,
            1
        ],
        [
            1563,
            1565,
            2
        ],
        [
            1566,
            1567,
            1
        ],
        [
            1642,
            1645,
            1
        ],
        [
            1748,
            1792,
            44
        ],
        [
            1793,
            1805,
            1
        ],
        [
            2039,
            2041,
            1
        ],
        [
            2096,
            2110,
            1
        ],
        [
            2142,
            2404,
            262
        ],
        [
            2405,
            2416,
            11
        ],
        [
            2557,
            2678,
            121
        ],
        [
            2800,
            3191,
            391
        ],
        [
            3204,
            3572,
            368
        ],
        [
            3663,
            3674,
            11
        ],
        [
            3675,
            3844,
            169
        ],
        [
            3845,
            3858,
            1
        ],
        [
            3860,
            3973,
            113
        ],
        [
            4048,
            4052,
            1
        ],
        [
            4057,
            4058,
            1
        ],
        [
            4170,
            4175,
            1
        ],
        [
            4347,
            4960,
            613
        ],
        [
            4961,
            4968,
            1
        ],
        [
            5742,
            5867,
            125
        ],
        [
            5868,
            5869,
            1
        ],
        [
            5941,
            5942,
            1
        ],
        [
            6100,
            6102,
            1
        ],
        [
            6104,
            6106,
            1
        ],
        [
            6144,
            6149,
            1
        ],
        [
            6151,
            6154,
            1
        ],
        [
            6468,
            6469,
            1
        ],
        [
            6686,
            6687,
            1
        ],
        [
            6816,
            6822,
            1
        ],
        [
            6824,
            6829,
            1
        ],
        [
            7002,
            7008,
            1
        ],
        [
            7037,
            7038,
            1
        ],
        [
            7164,
            7167,
            1
        ],
        [
            7227,
            7231,
            1
        ],
        [
            7294,
            7295,
            1
        ],
        [
            7360,
            7367,
            1
        ],
        [
            7379,
            8214,
            835
        ],
        [
            8215,
            8224,
            9
        ],
        [
            8225,
            8231,
            1
        ],
        [
            8240,
            8248,
            1
        ],
        [
            8251,
            8254,
            1
        ],
        [
            8257,
            8259,
            1
        ],
        [
            8263,
            8273,
            1
        ],
        [
            8275,
            8277,
            2
        ],
        [
            8278,
            8286,
            1
        ],
        [
            11513,
            11516,
            1
        ],
        [
            11518,
            11519,
            1
        ],
        [
            11632,
            11776,
            144
        ],
        [
            11777,
            11782,
            5
        ],
        [
            11783,
            11784,
            1
        ],
        [
            11787,
            11790,
            3
        ],
        [
            11791,
            11798,
            1
        ],
        [
            11800,
            11801,
            1
        ],
        [
            11803,
            11806,
            3
        ],
        [
            11807,
            11818,
            11
        ],
        [
            11819,
            11822,
            1
        ],
        [
            11824,
            11833,
            1
        ],
        [
            11836,
            11839,
            1
        ],
        [
            11841,
            11843,
            2
        ],
        [
            11844,
            11855,
            1
        ],
        [
            11858,
            11860,
            1
        ],
        [
            12289,
            12291,
            1
        ],
        [
            12349,
            12539,
            190
        ],
        [
            42238,
            42239,
            1
        ],
        [
            42509,
            42511,
            1
        ],
        [
            42611,
            42622,
            11
        ],
        [
            42738,
            42743,
            1
        ],
        [
            43124,
            43127,
            1
        ],
        [
            43214,
            43215,
            1
        ],
        [
            43256,
            43258,
            1
        ],
        [
            43260,
            43310,
            50
        ],
        [
            43311,
            43359,
            48
        ],
        [
            43457,
            43469,
            1
        ],
        [
            43486,
            43487,
            1
        ],
        [
            43612,
            43615,
            1
        ],
        [
            43742,
            43743,
            1
        ],
        [
            43760,
            43761,
            1
        ],
        [
            44011,
            65040,
            21029
        ],
        [
            65041,
            65046,
            1
        ],
        [
            65049,
            65072,
            23
        ],
        [
            65093,
            65094,
            1
        ],
        [
            65097,
            65100,
            1
        ],
        [
            65104,
            65106,
            1
        ],
        [
            65108,
            65111,
            1
        ],
        [
            65119,
            65121,
            1
        ],
        [
            65128,
            65130,
            2
        ],
        [
            65131,
            65281,
            150
        ],
        [
            65282,
            65283,
            1
        ],
        [
            65285,
            65287,
            1
        ],
        [
            65290,
            65294,
            2
        ],
        [
            65295,
            65306,
            11
        ],
        [
            65307,
            65311,
            4
        ],
        [
            65312,
            65340,
            28
        ],
        [
            65377,
            65380,
            3
        ],
        [
            65381,
            65792,
            411
        ],
        [
            65793,
            65794,
            1
        ],
        [
            66463,
            66512,
            49
        ],
        [
            66927,
            67671,
            744
        ],
        [
            67871,
            67903,
            32
        ],
        [
            68176,
            68184,
            1
        ],
        [
            68223,
            68336,
            113
        ],
        [
            68337,
            68342,
            1
        ],
        [
            68409,
            68415,
            1
        ],
        [
            68505,
            68508,
            1
        ],
        [
            69461,
            69465,
            1
        ],
        [
            69510,
            69513,
            1
        ],
        [
            69703,
            69709,
            1
        ],
        [
            69819,
            69820,
            1
        ],
        [
            69822,
            69825,
            1
        ],
        [
            69952,
            69955,
            1
        ],
        [
            70004,
            70005,
            1
        ],
        [
            70085,
            70088,
            1
        ],
        [
            70093,
            70107,
            14
        ],
        [
            70109,
            70111,
            1
        ],
        [
            70200,
            70205,
            1
        ],
        [
            70313,
            70731,
            418
        ],
        [
            70732,
            70735,
            1
        ],
        [
            70746,
            70747,
            1
        ],
        [
            70749,
            70854,
            105
        ],
        [
            71105,
            71127,
            1
        ],
        [
            71233,
            71235,
            1
        ],
        [
            71264,
            71276,
            1
        ],
        [
            71353,
            71484,
            131
        ],
        [
            71485,
            71486,
            1
        ],
        [
            71739,
            72004,
            265
        ],
        [
            72005,
            72006,
            1
        ],
        [
            72162,
            72255,
            93
        ],
        [
            72256,
            72262,
            1
        ],
        [
            72346,
            72348,
            1
        ],
        [
            72350,
            72354,
            1
        ],
        [
            72448,
            72457,
            1
        ],
        [
            72769,
            72773,
            1
        ],
        [
            72816,
            72817,
            1
        ],
        [
            73463,
            73464,
            1
        ],
        [
            73539,
            73551,
            1
        ],
        [
            73727,
            74864,
            1137
        ],
        [
            74865,
            74868,
            1
        ],
        [
            77809,
            77810,
            1
        ],
        [
            92782,
            92783,
            1
        ],
        [
            92917,
            92983,
            66
        ],
        [
            92984,
            92987,
            1
        ],
        [
            92996,
            93847,
            851
        ],
        [
            93848,
            93850,
            1
        ],
        [
            94178,
            113823,
            19645
        ],
        [
            121479,
            121483,
            1
        ],
        [
            125278,
            125279,
            1
        ]
    ];
    static Ps = [
        [
            40,
            91,
            51
        ],
        [
            123,
            3898,
            3775
        ],
        [
            3900,
            5787,
            1887
        ],
        [
            8218,
            8222,
            4
        ],
        [
            8261,
            8317,
            56
        ],
        [
            8333,
            8968,
            635
        ],
        [
            8970,
            9001,
            31
        ],
        [
            10088,
            10100,
            2
        ],
        [
            10181,
            10214,
            33
        ],
        [
            10216,
            10222,
            2
        ],
        [
            10627,
            10647,
            2
        ],
        [
            10712,
            10714,
            2
        ],
        [
            10748,
            11810,
            1062
        ],
        [
            11812,
            11816,
            2
        ],
        [
            11842,
            11861,
            19
        ],
        [
            11863,
            11867,
            2
        ],
        [
            12296,
            12304,
            2
        ],
        [
            12308,
            12314,
            2
        ],
        [
            12317,
            64831,
            52514
        ],
        [
            65047,
            65077,
            30
        ],
        [
            65079,
            65091,
            2
        ],
        [
            65095,
            65113,
            18
        ],
        [
            65115,
            65117,
            2
        ],
        [
            65288,
            65339,
            51
        ],
        [
            65371,
            65375,
            4
        ],
        [
            65378,
            65378,
            1
        ]
    ];
    static S = [
        [
            36,
            43,
            7
        ],
        [
            60,
            62,
            1
        ],
        [
            94,
            96,
            2
        ],
        [
            124,
            126,
            2
        ],
        [
            162,
            166,
            1
        ],
        [
            168,
            169,
            1
        ],
        [
            172,
            174,
            2
        ],
        [
            175,
            177,
            1
        ],
        [
            180,
            184,
            4
        ],
        [
            215,
            247,
            32
        ],
        [
            706,
            709,
            1
        ],
        [
            722,
            735,
            1
        ],
        [
            741,
            747,
            1
        ],
        [
            749,
            751,
            2
        ],
        [
            752,
            767,
            1
        ],
        [
            885,
            900,
            15
        ],
        [
            901,
            1014,
            113
        ],
        [
            1154,
            1421,
            267
        ],
        [
            1422,
            1423,
            1
        ],
        [
            1542,
            1544,
            1
        ],
        [
            1547,
            1550,
            3
        ],
        [
            1551,
            1758,
            207
        ],
        [
            1769,
            1789,
            20
        ],
        [
            1790,
            2038,
            248
        ],
        [
            2046,
            2047,
            1
        ],
        [
            2184,
            2546,
            362
        ],
        [
            2547,
            2554,
            7
        ],
        [
            2555,
            2801,
            246
        ],
        [
            2928,
            3059,
            131
        ],
        [
            3060,
            3066,
            1
        ],
        [
            3199,
            3407,
            208
        ],
        [
            3449,
            3647,
            198
        ],
        [
            3841,
            3843,
            1
        ],
        [
            3859,
            3861,
            2
        ],
        [
            3862,
            3863,
            1
        ],
        [
            3866,
            3871,
            1
        ],
        [
            3892,
            3896,
            2
        ],
        [
            4030,
            4037,
            1
        ],
        [
            4039,
            4044,
            1
        ],
        [
            4046,
            4047,
            1
        ],
        [
            4053,
            4056,
            1
        ],
        [
            4254,
            4255,
            1
        ],
        [
            5008,
            5017,
            1
        ],
        [
            5741,
            6107,
            366
        ],
        [
            6464,
            6622,
            158
        ],
        [
            6623,
            6655,
            1
        ],
        [
            7009,
            7018,
            1
        ],
        [
            7028,
            7036,
            1
        ],
        [
            8125,
            8127,
            2
        ],
        [
            8128,
            8129,
            1
        ],
        [
            8141,
            8143,
            1
        ],
        [
            8157,
            8159,
            1
        ],
        [
            8173,
            8175,
            1
        ],
        [
            8189,
            8190,
            1
        ],
        [
            8260,
            8274,
            14
        ],
        [
            8314,
            8316,
            1
        ],
        [
            8330,
            8332,
            1
        ],
        [
            8352,
            8384,
            1
        ],
        [
            8448,
            8449,
            1
        ],
        [
            8451,
            8454,
            1
        ],
        [
            8456,
            8457,
            1
        ],
        [
            8468,
            8470,
            2
        ],
        [
            8471,
            8472,
            1
        ],
        [
            8478,
            8483,
            1
        ],
        [
            8485,
            8489,
            2
        ],
        [
            8494,
            8506,
            12
        ],
        [
            8507,
            8512,
            5
        ],
        [
            8513,
            8516,
            1
        ],
        [
            8522,
            8525,
            1
        ],
        [
            8527,
            8586,
            59
        ],
        [
            8587,
            8592,
            5
        ],
        [
            8593,
            8967,
            1
        ],
        [
            8972,
            9000,
            1
        ],
        [
            9003,
            9254,
            1
        ],
        [
            9280,
            9290,
            1
        ],
        [
            9372,
            9449,
            1
        ],
        [
            9472,
            10087,
            1
        ],
        [
            10132,
            10180,
            1
        ],
        [
            10183,
            10213,
            1
        ],
        [
            10224,
            10626,
            1
        ],
        [
            10649,
            10711,
            1
        ],
        [
            10716,
            10747,
            1
        ],
        [
            10750,
            11123,
            1
        ],
        [
            11126,
            11157,
            1
        ],
        [
            11159,
            11263,
            1
        ],
        [
            11493,
            11498,
            1
        ],
        [
            11856,
            11857,
            1
        ],
        [
            11904,
            11929,
            1
        ],
        [
            11931,
            12019,
            1
        ],
        [
            12032,
            12245,
            1
        ],
        [
            12272,
            12287,
            1
        ],
        [
            12292,
            12306,
            14
        ],
        [
            12307,
            12320,
            13
        ],
        [
            12342,
            12343,
            1
        ],
        [
            12350,
            12351,
            1
        ],
        [
            12443,
            12444,
            1
        ],
        [
            12688,
            12689,
            1
        ],
        [
            12694,
            12703,
            1
        ],
        [
            12736,
            12771,
            1
        ],
        [
            12783,
            12800,
            17
        ],
        [
            12801,
            12830,
            1
        ],
        [
            12842,
            12871,
            1
        ],
        [
            12880,
            12896,
            16
        ],
        [
            12897,
            12927,
            1
        ],
        [
            12938,
            12976,
            1
        ],
        [
            12992,
            13311,
            1
        ],
        [
            19904,
            19967,
            1
        ],
        [
            42128,
            42182,
            1
        ],
        [
            42752,
            42774,
            1
        ],
        [
            42784,
            42785,
            1
        ],
        [
            42889,
            42890,
            1
        ],
        [
            43048,
            43051,
            1
        ],
        [
            43062,
            43065,
            1
        ],
        [
            43639,
            43641,
            1
        ],
        [
            43867,
            43882,
            15
        ],
        [
            43883,
            64297,
            20414
        ],
        [
            64434,
            64450,
            1
        ],
        [
            64832,
            64847,
            1
        ],
        [
            64975,
            65020,
            45
        ],
        [
            65021,
            65023,
            1
        ],
        [
            65122,
            65124,
            2
        ],
        [
            65125,
            65126,
            1
        ],
        [
            65129,
            65284,
            155
        ],
        [
            65291,
            65308,
            17
        ],
        [
            65309,
            65310,
            1
        ],
        [
            65342,
            65344,
            2
        ],
        [
            65372,
            65374,
            2
        ],
        [
            65504,
            65510,
            1
        ],
        [
            65512,
            65518,
            1
        ],
        [
            65532,
            65533,
            1
        ],
        [
            65847,
            65855,
            1
        ],
        [
            65913,
            65929,
            1
        ],
        [
            65932,
            65934,
            1
        ],
        [
            65936,
            65948,
            1
        ],
        [
            65952,
            66000,
            48
        ],
        [
            66001,
            66044,
            1
        ],
        [
            67703,
            67704,
            1
        ],
        [
            68296,
            71487,
            3191
        ],
        [
            73685,
            73713,
            1
        ],
        [
            92988,
            92991,
            1
        ],
        [
            92997,
            113820,
            20823
        ],
        [
            118608,
            118723,
            1
        ],
        [
            118784,
            119029,
            1
        ],
        [
            119040,
            119078,
            1
        ],
        [
            119081,
            119140,
            1
        ],
        [
            119146,
            119148,
            1
        ],
        [
            119171,
            119172,
            1
        ],
        [
            119180,
            119209,
            1
        ],
        [
            119214,
            119274,
            1
        ],
        [
            119296,
            119361,
            1
        ],
        [
            119365,
            119552,
            187
        ],
        [
            119553,
            119638,
            1
        ],
        [
            120513,
            120539,
            26
        ],
        [
            120571,
            120597,
            26
        ],
        [
            120629,
            120655,
            26
        ],
        [
            120687,
            120713,
            26
        ],
        [
            120745,
            120771,
            26
        ],
        [
            120832,
            121343,
            1
        ],
        [
            121399,
            121402,
            1
        ],
        [
            121453,
            121460,
            1
        ],
        [
            121462,
            121475,
            1
        ],
        [
            121477,
            121478,
            1
        ],
        [
            123215,
            123647,
            432
        ],
        [
            126124,
            126128,
            4
        ],
        [
            126254,
            126704,
            450
        ],
        [
            126705,
            126976,
            271
        ],
        [
            126977,
            127019,
            1
        ],
        [
            127024,
            127123,
            1
        ],
        [
            127136,
            127150,
            1
        ],
        [
            127153,
            127167,
            1
        ],
        [
            127169,
            127183,
            1
        ],
        [
            127185,
            127221,
            1
        ],
        [
            127245,
            127405,
            1
        ],
        [
            127462,
            127490,
            1
        ],
        [
            127504,
            127547,
            1
        ],
        [
            127552,
            127560,
            1
        ],
        [
            127568,
            127569,
            1
        ],
        [
            127584,
            127589,
            1
        ],
        [
            127744,
            128727,
            1
        ],
        [
            128732,
            128748,
            1
        ],
        [
            128752,
            128764,
            1
        ],
        [
            128768,
            128886,
            1
        ],
        [
            128891,
            128985,
            1
        ],
        [
            128992,
            129003,
            1
        ],
        [
            129008,
            129024,
            16
        ],
        [
            129025,
            129035,
            1
        ],
        [
            129040,
            129095,
            1
        ],
        [
            129104,
            129113,
            1
        ],
        [
            129120,
            129159,
            1
        ],
        [
            129168,
            129197,
            1
        ],
        [
            129200,
            129201,
            1
        ],
        [
            129280,
            129619,
            1
        ],
        [
            129632,
            129645,
            1
        ],
        [
            129648,
            129660,
            1
        ],
        [
            129664,
            129672,
            1
        ],
        [
            129680,
            129725,
            1
        ],
        [
            129727,
            129733,
            1
        ],
        [
            129742,
            129755,
            1
        ],
        [
            129760,
            129768,
            1
        ],
        [
            129776,
            129784,
            1
        ],
        [
            129792,
            129938,
            1
        ],
        [
            129940,
            129994,
            1
        ]
    ];
    static Sc = [
        [
            36,
            162,
            126
        ],
        [
            163,
            165,
            1
        ],
        [
            1423,
            1547,
            124
        ],
        [
            2046,
            2047,
            1
        ],
        [
            2546,
            2547,
            1
        ],
        [
            2555,
            2801,
            246
        ],
        [
            3065,
            3647,
            582
        ],
        [
            6107,
            8352,
            2245
        ],
        [
            8353,
            8384,
            1
        ],
        [
            43064,
            65020,
            21956
        ],
        [
            65129,
            65284,
            155
        ],
        [
            65504,
            65505,
            1
        ],
        [
            65509,
            65510,
            1
        ],
        [
            73693,
            73696,
            1
        ],
        [
            123647,
            126128,
            2481
        ]
    ];
    static Sk = [
        [
            94,
            96,
            2
        ],
        [
            168,
            175,
            7
        ],
        [
            180,
            184,
            4
        ],
        [
            706,
            709,
            1
        ],
        [
            722,
            735,
            1
        ],
        [
            741,
            747,
            1
        ],
        [
            749,
            751,
            2
        ],
        [
            752,
            767,
            1
        ],
        [
            885,
            900,
            15
        ],
        [
            901,
            2184,
            1283
        ],
        [
            8125,
            8127,
            2
        ],
        [
            8128,
            8129,
            1
        ],
        [
            8141,
            8143,
            1
        ],
        [
            8157,
            8159,
            1
        ],
        [
            8173,
            8175,
            1
        ],
        [
            8189,
            8190,
            1
        ],
        [
            12443,
            12444,
            1
        ],
        [
            42752,
            42774,
            1
        ],
        [
            42784,
            42785,
            1
        ],
        [
            42889,
            42890,
            1
        ],
        [
            43867,
            43882,
            15
        ],
        [
            43883,
            64434,
            20551
        ],
        [
            64435,
            64450,
            1
        ],
        [
            65342,
            65344,
            2
        ],
        [
            65507,
            127995,
            62488
        ],
        [
            127996,
            127999,
            1
        ]
    ];
    static Sm = [
        [
            43,
            60,
            17
        ],
        [
            61,
            62,
            1
        ],
        [
            124,
            126,
            2
        ],
        [
            172,
            177,
            5
        ],
        [
            215,
            247,
            32
        ],
        [
            1014,
            1542,
            528
        ],
        [
            1543,
            1544,
            1
        ],
        [
            8260,
            8274,
            14
        ],
        [
            8314,
            8316,
            1
        ],
        [
            8330,
            8332,
            1
        ],
        [
            8472,
            8512,
            40
        ],
        [
            8513,
            8516,
            1
        ],
        [
            8523,
            8592,
            69
        ],
        [
            8593,
            8596,
            1
        ],
        [
            8602,
            8603,
            1
        ],
        [
            8608,
            8614,
            3
        ],
        [
            8622,
            8654,
            32
        ],
        [
            8655,
            8658,
            3
        ],
        [
            8660,
            8692,
            32
        ],
        [
            8693,
            8959,
            1
        ],
        [
            8992,
            8993,
            1
        ],
        [
            9084,
            9115,
            31
        ],
        [
            9116,
            9139,
            1
        ],
        [
            9180,
            9185,
            1
        ],
        [
            9655,
            9665,
            10
        ],
        [
            9720,
            9727,
            1
        ],
        [
            9839,
            10176,
            337
        ],
        [
            10177,
            10180,
            1
        ],
        [
            10183,
            10213,
            1
        ],
        [
            10224,
            10239,
            1
        ],
        [
            10496,
            10626,
            1
        ],
        [
            10649,
            10711,
            1
        ],
        [
            10716,
            10747,
            1
        ],
        [
            10750,
            11007,
            1
        ],
        [
            11056,
            11076,
            1
        ],
        [
            11079,
            11084,
            1
        ],
        [
            64297,
            65122,
            825
        ],
        [
            65124,
            65126,
            1
        ],
        [
            65291,
            65308,
            17
        ],
        [
            65309,
            65310,
            1
        ],
        [
            65372,
            65374,
            2
        ],
        [
            65506,
            65513,
            7
        ],
        [
            65514,
            65516,
            1
        ],
        [
            120513,
            120539,
            26
        ],
        [
            120571,
            120597,
            26
        ],
        [
            120629,
            120655,
            26
        ],
        [
            120687,
            120713,
            26
        ],
        [
            120745,
            120771,
            26
        ],
        [
            126704,
            126705,
            1
        ]
    ];
    static So = [
        [
            166,
            169,
            3
        ],
        [
            174,
            176,
            2
        ],
        [
            1154,
            1421,
            267
        ],
        [
            1422,
            1550,
            128
        ],
        [
            1551,
            1758,
            207
        ],
        [
            1769,
            1789,
            20
        ],
        [
            1790,
            2038,
            248
        ],
        [
            2554,
            2928,
            374
        ],
        [
            3059,
            3064,
            1
        ],
        [
            3066,
            3199,
            133
        ],
        [
            3407,
            3449,
            42
        ],
        [
            3841,
            3843,
            1
        ],
        [
            3859,
            3861,
            2
        ],
        [
            3862,
            3863,
            1
        ],
        [
            3866,
            3871,
            1
        ],
        [
            3892,
            3896,
            2
        ],
        [
            4030,
            4037,
            1
        ],
        [
            4039,
            4044,
            1
        ],
        [
            4046,
            4047,
            1
        ],
        [
            4053,
            4056,
            1
        ],
        [
            4254,
            4255,
            1
        ],
        [
            5008,
            5017,
            1
        ],
        [
            5741,
            6464,
            723
        ],
        [
            6622,
            6655,
            1
        ],
        [
            7009,
            7018,
            1
        ],
        [
            7028,
            7036,
            1
        ],
        [
            8448,
            8449,
            1
        ],
        [
            8451,
            8454,
            1
        ],
        [
            8456,
            8457,
            1
        ],
        [
            8468,
            8470,
            2
        ],
        [
            8471,
            8478,
            7
        ],
        [
            8479,
            8483,
            1
        ],
        [
            8485,
            8489,
            2
        ],
        [
            8494,
            8506,
            12
        ],
        [
            8507,
            8522,
            15
        ],
        [
            8524,
            8525,
            1
        ],
        [
            8527,
            8586,
            59
        ],
        [
            8587,
            8597,
            10
        ],
        [
            8598,
            8601,
            1
        ],
        [
            8604,
            8607,
            1
        ],
        [
            8609,
            8610,
            1
        ],
        [
            8612,
            8613,
            1
        ],
        [
            8615,
            8621,
            1
        ],
        [
            8623,
            8653,
            1
        ],
        [
            8656,
            8657,
            1
        ],
        [
            8659,
            8661,
            2
        ],
        [
            8662,
            8691,
            1
        ],
        [
            8960,
            8967,
            1
        ],
        [
            8972,
            8991,
            1
        ],
        [
            8994,
            9000,
            1
        ],
        [
            9003,
            9083,
            1
        ],
        [
            9085,
            9114,
            1
        ],
        [
            9140,
            9179,
            1
        ],
        [
            9186,
            9254,
            1
        ],
        [
            9280,
            9290,
            1
        ],
        [
            9372,
            9449,
            1
        ],
        [
            9472,
            9654,
            1
        ],
        [
            9656,
            9664,
            1
        ],
        [
            9666,
            9719,
            1
        ],
        [
            9728,
            9838,
            1
        ],
        [
            9840,
            10087,
            1
        ],
        [
            10132,
            10175,
            1
        ],
        [
            10240,
            10495,
            1
        ],
        [
            11008,
            11055,
            1
        ],
        [
            11077,
            11078,
            1
        ],
        [
            11085,
            11123,
            1
        ],
        [
            11126,
            11157,
            1
        ],
        [
            11159,
            11263,
            1
        ],
        [
            11493,
            11498,
            1
        ],
        [
            11856,
            11857,
            1
        ],
        [
            11904,
            11929,
            1
        ],
        [
            11931,
            12019,
            1
        ],
        [
            12032,
            12245,
            1
        ],
        [
            12272,
            12287,
            1
        ],
        [
            12292,
            12306,
            14
        ],
        [
            12307,
            12320,
            13
        ],
        [
            12342,
            12343,
            1
        ],
        [
            12350,
            12351,
            1
        ],
        [
            12688,
            12689,
            1
        ],
        [
            12694,
            12703,
            1
        ],
        [
            12736,
            12771,
            1
        ],
        [
            12783,
            12800,
            17
        ],
        [
            12801,
            12830,
            1
        ],
        [
            12842,
            12871,
            1
        ],
        [
            12880,
            12896,
            16
        ],
        [
            12897,
            12927,
            1
        ],
        [
            12938,
            12976,
            1
        ],
        [
            12992,
            13311,
            1
        ],
        [
            19904,
            19967,
            1
        ],
        [
            42128,
            42182,
            1
        ],
        [
            43048,
            43051,
            1
        ],
        [
            43062,
            43063,
            1
        ],
        [
            43065,
            43639,
            574
        ],
        [
            43640,
            43641,
            1
        ],
        [
            64832,
            64847,
            1
        ],
        [
            64975,
            65021,
            46
        ],
        [
            65022,
            65023,
            1
        ],
        [
            65508,
            65512,
            4
        ],
        [
            65517,
            65518,
            1
        ],
        [
            65532,
            65533,
            1
        ],
        [
            65847,
            65855,
            1
        ],
        [
            65913,
            65929,
            1
        ],
        [
            65932,
            65934,
            1
        ],
        [
            65936,
            65948,
            1
        ],
        [
            65952,
            66000,
            48
        ],
        [
            66001,
            66044,
            1
        ],
        [
            67703,
            67704,
            1
        ],
        [
            68296,
            71487,
            3191
        ],
        [
            73685,
            73692,
            1
        ],
        [
            73697,
            73713,
            1
        ],
        [
            92988,
            92991,
            1
        ],
        [
            92997,
            113820,
            20823
        ],
        [
            118608,
            118723,
            1
        ],
        [
            118784,
            119029,
            1
        ],
        [
            119040,
            119078,
            1
        ],
        [
            119081,
            119140,
            1
        ],
        [
            119146,
            119148,
            1
        ],
        [
            119171,
            119172,
            1
        ],
        [
            119180,
            119209,
            1
        ],
        [
            119214,
            119274,
            1
        ],
        [
            119296,
            119361,
            1
        ],
        [
            119365,
            119552,
            187
        ],
        [
            119553,
            119638,
            1
        ],
        [
            120832,
            121343,
            1
        ],
        [
            121399,
            121402,
            1
        ],
        [
            121453,
            121460,
            1
        ],
        [
            121462,
            121475,
            1
        ],
        [
            121477,
            121478,
            1
        ],
        [
            123215,
            126124,
            2909
        ],
        [
            126254,
            126976,
            722
        ],
        [
            126977,
            127019,
            1
        ],
        [
            127024,
            127123,
            1
        ],
        [
            127136,
            127150,
            1
        ],
        [
            127153,
            127167,
            1
        ],
        [
            127169,
            127183,
            1
        ],
        [
            127185,
            127221,
            1
        ],
        [
            127245,
            127405,
            1
        ],
        [
            127462,
            127490,
            1
        ],
        [
            127504,
            127547,
            1
        ],
        [
            127552,
            127560,
            1
        ],
        [
            127568,
            127569,
            1
        ],
        [
            127584,
            127589,
            1
        ],
        [
            127744,
            127994,
            1
        ],
        [
            128000,
            128727,
            1
        ],
        [
            128732,
            128748,
            1
        ],
        [
            128752,
            128764,
            1
        ],
        [
            128768,
            128886,
            1
        ],
        [
            128891,
            128985,
            1
        ],
        [
            128992,
            129003,
            1
        ],
        [
            129008,
            129024,
            16
        ],
        [
            129025,
            129035,
            1
        ],
        [
            129040,
            129095,
            1
        ],
        [
            129104,
            129113,
            1
        ],
        [
            129120,
            129159,
            1
        ],
        [
            129168,
            129197,
            1
        ],
        [
            129200,
            129201,
            1
        ],
        [
            129280,
            129619,
            1
        ],
        [
            129632,
            129645,
            1
        ],
        [
            129648,
            129660,
            1
        ],
        [
            129664,
            129672,
            1
        ],
        [
            129680,
            129725,
            1
        ],
        [
            129727,
            129733,
            1
        ],
        [
            129742,
            129755,
            1
        ],
        [
            129760,
            129768,
            1
        ],
        [
            129776,
            129784,
            1
        ],
        [
            129792,
            129938,
            1
        ],
        [
            129940,
            129994,
            1
        ]
    ];
    static Z = [
        [
            32,
            160,
            128
        ],
        [
            5760,
            8192,
            2432
        ],
        [
            8193,
            8202,
            1
        ],
        [
            8232,
            8233,
            1
        ],
        [
            8239,
            8287,
            48
        ],
        [
            12288,
            12288,
            1
        ]
    ];
    static Zl = [
        [
            8232,
            8232,
            1
        ]
    ];
    static Zp = [
        [
            8233,
            8233,
            1
        ]
    ];
    static Zs = [
        [
            32,
            160,
            128
        ],
        [
            5760,
            8192,
            2432
        ],
        [
            8193,
            8202,
            1
        ],
        [
            8239,
            8287,
            48
        ],
        [
            12288,
            12288,
            1
        ]
    ];
    static Adlam = [
        [
            125184,
            125259,
            1
        ],
        [
            125264,
            125273,
            1
        ],
        [
            125278,
            125279,
            1
        ]
    ];
    static Ahom = [
        [
            71424,
            71450,
            1
        ],
        [
            71453,
            71467,
            1
        ],
        [
            71472,
            71494,
            1
        ]
    ];
    static Anatolian_Hieroglyphs = [
        [
            82944,
            83526,
            1
        ]
    ];
    static Arabic = [
        [
            1536,
            1540,
            1
        ],
        [
            1542,
            1547,
            1
        ],
        [
            1549,
            1562,
            1
        ],
        [
            1564,
            1566,
            1
        ],
        [
            1568,
            1599,
            1
        ],
        [
            1601,
            1610,
            1
        ],
        [
            1622,
            1647,
            1
        ],
        [
            1649,
            1756,
            1
        ],
        [
            1758,
            1791,
            1
        ],
        [
            1872,
            1919,
            1
        ],
        [
            2160,
            2190,
            1
        ],
        [
            2192,
            2193,
            1
        ],
        [
            2200,
            2273,
            1
        ],
        [
            2275,
            2303,
            1
        ],
        [
            64336,
            64450,
            1
        ],
        [
            64467,
            64829,
            1
        ],
        [
            64832,
            64911,
            1
        ],
        [
            64914,
            64967,
            1
        ],
        [
            64975,
            65008,
            33
        ],
        [
            65009,
            65023,
            1
        ],
        [
            65136,
            65140,
            1
        ],
        [
            65142,
            65276,
            1
        ],
        [
            69216,
            69246,
            1
        ],
        [
            69373,
            69375,
            1
        ],
        [
            126464,
            126467,
            1
        ],
        [
            126469,
            126495,
            1
        ],
        [
            126497,
            126498,
            1
        ],
        [
            126500,
            126503,
            3
        ],
        [
            126505,
            126514,
            1
        ],
        [
            126516,
            126519,
            1
        ],
        [
            126521,
            126523,
            2
        ],
        [
            126530,
            126535,
            5
        ],
        [
            126537,
            126541,
            2
        ],
        [
            126542,
            126543,
            1
        ],
        [
            126545,
            126546,
            1
        ],
        [
            126548,
            126551,
            3
        ],
        [
            126553,
            126561,
            2
        ],
        [
            126562,
            126564,
            2
        ],
        [
            126567,
            126570,
            1
        ],
        [
            126572,
            126578,
            1
        ],
        [
            126580,
            126583,
            1
        ],
        [
            126585,
            126588,
            1
        ],
        [
            126590,
            126592,
            2
        ],
        [
            126593,
            126601,
            1
        ],
        [
            126603,
            126619,
            1
        ],
        [
            126625,
            126627,
            1
        ],
        [
            126629,
            126633,
            1
        ],
        [
            126635,
            126651,
            1
        ],
        [
            126704,
            126705,
            1
        ]
    ];
    static Armenian = [
        [
            1329,
            1366,
            1
        ],
        [
            1369,
            1418,
            1
        ],
        [
            1421,
            1423,
            1
        ],
        [
            64275,
            64279,
            1
        ]
    ];
    static Avestan = [
        [
            68352,
            68405,
            1
        ],
        [
            68409,
            68415,
            1
        ]
    ];
    static Balinese = [
        [
            6912,
            6988,
            1
        ],
        [
            6992,
            7038,
            1
        ]
    ];
    static Bamum = [
        [
            42656,
            42743,
            1
        ],
        [
            92160,
            92728,
            1
        ]
    ];
    static Bassa_Vah = [
        [
            92880,
            92909,
            1
        ],
        [
            92912,
            92917,
            1
        ]
    ];
    static Batak = [
        [
            7104,
            7155,
            1
        ],
        [
            7164,
            7167,
            1
        ]
    ];
    static Bengali = [
        [
            2432,
            2435,
            1
        ],
        [
            2437,
            2444,
            1
        ],
        [
            2447,
            2448,
            1
        ],
        [
            2451,
            2472,
            1
        ],
        [
            2474,
            2480,
            1
        ],
        [
            2482,
            2486,
            4
        ],
        [
            2487,
            2489,
            1
        ],
        [
            2492,
            2500,
            1
        ],
        [
            2503,
            2504,
            1
        ],
        [
            2507,
            2510,
            1
        ],
        [
            2519,
            2524,
            5
        ],
        [
            2525,
            2527,
            2
        ],
        [
            2528,
            2531,
            1
        ],
        [
            2534,
            2558,
            1
        ]
    ];
    static Bhaiksuki = [
        [
            72704,
            72712,
            1
        ],
        [
            72714,
            72758,
            1
        ],
        [
            72760,
            72773,
            1
        ],
        [
            72784,
            72812,
            1
        ]
    ];
    static Bopomofo = [
        [
            746,
            747,
            1
        ],
        [
            12549,
            12591,
            1
        ],
        [
            12704,
            12735,
            1
        ]
    ];
    static Brahmi = [
        [
            69632,
            69709,
            1
        ],
        [
            69714,
            69749,
            1
        ],
        [
            69759,
            69759,
            1
        ]
    ];
    static Braille = [
        [
            10240,
            10495,
            1
        ]
    ];
    static Buginese = [
        [
            6656,
            6683,
            1
        ],
        [
            6686,
            6687,
            1
        ]
    ];
    static Buhid = [
        [
            5952,
            5971,
            1
        ]
    ];
    static Canadian_Aboriginal = [
        [
            5120,
            5759,
            1
        ],
        [
            6320,
            6389,
            1
        ],
        [
            72368,
            72383,
            1
        ]
    ];
    static Carian = [
        [
            66208,
            66256,
            1
        ]
    ];
    static Caucasian_Albanian = [
        [
            66864,
            66915,
            1
        ],
        [
            66927,
            66927,
            1
        ]
    ];
    static Chakma = [
        [
            69888,
            69940,
            1
        ],
        [
            69942,
            69959,
            1
        ]
    ];
    static Cham = [
        [
            43520,
            43574,
            1
        ],
        [
            43584,
            43597,
            1
        ],
        [
            43600,
            43609,
            1
        ],
        [
            43612,
            43615,
            1
        ]
    ];
    static Cherokee = [
        [
            5024,
            5109,
            1
        ],
        [
            5112,
            5117,
            1
        ],
        [
            43888,
            43967,
            1
        ]
    ];
    static Chorasmian = [
        [
            69552,
            69579,
            1
        ]
    ];
    static Common = [
        [
            0,
            64,
            1
        ],
        [
            91,
            96,
            1
        ],
        [
            123,
            169,
            1
        ],
        [
            171,
            185,
            1
        ],
        [
            187,
            191,
            1
        ],
        [
            215,
            247,
            32
        ],
        [
            697,
            735,
            1
        ],
        [
            741,
            745,
            1
        ],
        [
            748,
            767,
            1
        ],
        [
            884,
            894,
            10
        ],
        [
            901,
            903,
            2
        ],
        [
            1541,
            1548,
            7
        ],
        [
            1563,
            1567,
            4
        ],
        [
            1600,
            1757,
            157
        ],
        [
            2274,
            2404,
            130
        ],
        [
            2405,
            3647,
            1242
        ],
        [
            4053,
            4056,
            1
        ],
        [
            4347,
            5867,
            1520
        ],
        [
            5868,
            5869,
            1
        ],
        [
            5941,
            5942,
            1
        ],
        [
            6146,
            6147,
            1
        ],
        [
            6149,
            7379,
            1230
        ],
        [
            7393,
            7401,
            8
        ],
        [
            7402,
            7404,
            1
        ],
        [
            7406,
            7411,
            1
        ],
        [
            7413,
            7415,
            1
        ],
        [
            7418,
            8192,
            774
        ],
        [
            8193,
            8203,
            1
        ],
        [
            8206,
            8292,
            1
        ],
        [
            8294,
            8304,
            1
        ],
        [
            8308,
            8318,
            1
        ],
        [
            8320,
            8334,
            1
        ],
        [
            8352,
            8384,
            1
        ],
        [
            8448,
            8485,
            1
        ],
        [
            8487,
            8489,
            1
        ],
        [
            8492,
            8497,
            1
        ],
        [
            8499,
            8525,
            1
        ],
        [
            8527,
            8543,
            1
        ],
        [
            8585,
            8587,
            1
        ],
        [
            8592,
            9254,
            1
        ],
        [
            9280,
            9290,
            1
        ],
        [
            9312,
            10239,
            1
        ],
        [
            10496,
            11123,
            1
        ],
        [
            11126,
            11157,
            1
        ],
        [
            11159,
            11263,
            1
        ],
        [
            11776,
            11869,
            1
        ],
        [
            12272,
            12292,
            1
        ],
        [
            12294,
            12296,
            2
        ],
        [
            12297,
            12320,
            1
        ],
        [
            12336,
            12343,
            1
        ],
        [
            12348,
            12351,
            1
        ],
        [
            12443,
            12444,
            1
        ],
        [
            12448,
            12539,
            91
        ],
        [
            12540,
            12688,
            148
        ],
        [
            12689,
            12703,
            1
        ],
        [
            12736,
            12771,
            1
        ],
        [
            12783,
            12832,
            49
        ],
        [
            12833,
            12895,
            1
        ],
        [
            12927,
            13007,
            1
        ],
        [
            13055,
            13144,
            89
        ],
        [
            13145,
            13311,
            1
        ],
        [
            19904,
            19967,
            1
        ],
        [
            42752,
            42785,
            1
        ],
        [
            42888,
            42890,
            1
        ],
        [
            43056,
            43065,
            1
        ],
        [
            43310,
            43471,
            161
        ],
        [
            43867,
            43882,
            15
        ],
        [
            43883,
            64830,
            20947
        ],
        [
            64831,
            65040,
            209
        ],
        [
            65041,
            65049,
            1
        ],
        [
            65072,
            65106,
            1
        ],
        [
            65108,
            65126,
            1
        ],
        [
            65128,
            65131,
            1
        ],
        [
            65279,
            65281,
            2
        ],
        [
            65282,
            65312,
            1
        ],
        [
            65339,
            65344,
            1
        ],
        [
            65371,
            65381,
            1
        ],
        [
            65392,
            65438,
            46
        ],
        [
            65439,
            65504,
            65
        ],
        [
            65505,
            65510,
            1
        ],
        [
            65512,
            65518,
            1
        ],
        [
            65529,
            65533,
            1
        ],
        [
            65792,
            65794,
            1
        ],
        [
            65799,
            65843,
            1
        ],
        [
            65847,
            65855,
            1
        ],
        [
            65936,
            65948,
            1
        ],
        [
            66000,
            66044,
            1
        ],
        [
            66273,
            66299,
            1
        ],
        [
            113824,
            113827,
            1
        ],
        [
            118608,
            118723,
            1
        ],
        [
            118784,
            119029,
            1
        ],
        [
            119040,
            119078,
            1
        ],
        [
            119081,
            119142,
            1
        ],
        [
            119146,
            119162,
            1
        ],
        [
            119171,
            119172,
            1
        ],
        [
            119180,
            119209,
            1
        ],
        [
            119214,
            119274,
            1
        ],
        [
            119488,
            119507,
            1
        ],
        [
            119520,
            119539,
            1
        ],
        [
            119552,
            119638,
            1
        ],
        [
            119648,
            119672,
            1
        ],
        [
            119808,
            119892,
            1
        ],
        [
            119894,
            119964,
            1
        ],
        [
            119966,
            119967,
            1
        ],
        [
            119970,
            119973,
            3
        ],
        [
            119974,
            119977,
            3
        ],
        [
            119978,
            119980,
            1
        ],
        [
            119982,
            119993,
            1
        ],
        [
            119995,
            119997,
            2
        ],
        [
            119998,
            120003,
            1
        ],
        [
            120005,
            120069,
            1
        ],
        [
            120071,
            120074,
            1
        ],
        [
            120077,
            120084,
            1
        ],
        [
            120086,
            120092,
            1
        ],
        [
            120094,
            120121,
            1
        ],
        [
            120123,
            120126,
            1
        ],
        [
            120128,
            120132,
            1
        ],
        [
            120134,
            120138,
            4
        ],
        [
            120139,
            120144,
            1
        ],
        [
            120146,
            120485,
            1
        ],
        [
            120488,
            120779,
            1
        ],
        [
            120782,
            120831,
            1
        ],
        [
            126065,
            126132,
            1
        ],
        [
            126209,
            126269,
            1
        ],
        [
            126976,
            127019,
            1
        ],
        [
            127024,
            127123,
            1
        ],
        [
            127136,
            127150,
            1
        ],
        [
            127153,
            127167,
            1
        ],
        [
            127169,
            127183,
            1
        ],
        [
            127185,
            127221,
            1
        ],
        [
            127232,
            127405,
            1
        ],
        [
            127462,
            127487,
            1
        ],
        [
            127489,
            127490,
            1
        ],
        [
            127504,
            127547,
            1
        ],
        [
            127552,
            127560,
            1
        ],
        [
            127568,
            127569,
            1
        ],
        [
            127584,
            127589,
            1
        ],
        [
            127744,
            128727,
            1
        ],
        [
            128732,
            128748,
            1
        ],
        [
            128752,
            128764,
            1
        ],
        [
            128768,
            128886,
            1
        ],
        [
            128891,
            128985,
            1
        ],
        [
            128992,
            129003,
            1
        ],
        [
            129008,
            129024,
            16
        ],
        [
            129025,
            129035,
            1
        ],
        [
            129040,
            129095,
            1
        ],
        [
            129104,
            129113,
            1
        ],
        [
            129120,
            129159,
            1
        ],
        [
            129168,
            129197,
            1
        ],
        [
            129200,
            129201,
            1
        ],
        [
            129280,
            129619,
            1
        ],
        [
            129632,
            129645,
            1
        ],
        [
            129648,
            129660,
            1
        ],
        [
            129664,
            129672,
            1
        ],
        [
            129680,
            129725,
            1
        ],
        [
            129727,
            129733,
            1
        ],
        [
            129742,
            129755,
            1
        ],
        [
            129760,
            129768,
            1
        ],
        [
            129776,
            129784,
            1
        ],
        [
            129792,
            129938,
            1
        ],
        [
            129940,
            129994,
            1
        ],
        [
            130032,
            130041,
            1
        ],
        [
            917505,
            917536,
            31
        ],
        [
            917537,
            917631,
            1
        ]
    ];
    static foldCommon = [
        [
            924,
            956,
            32
        ]
    ];
    static Coptic = [
        [
            994,
            1007,
            1
        ],
        [
            11392,
            11507,
            1
        ],
        [
            11513,
            11519,
            1
        ]
    ];
    static Cuneiform = [
        [
            73728,
            74649,
            1
        ],
        [
            74752,
            74862,
            1
        ],
        [
            74864,
            74868,
            1
        ],
        [
            74880,
            75075,
            1
        ]
    ];
    static Cypriot = [
        [
            67584,
            67589,
            1
        ],
        [
            67592,
            67594,
            2
        ],
        [
            67595,
            67637,
            1
        ],
        [
            67639,
            67640,
            1
        ],
        [
            67644,
            67647,
            3
        ]
    ];
    static Cypro_Minoan = [
        [
            77712,
            77810,
            1
        ]
    ];
    static Cyrillic = [
        [
            1024,
            1156,
            1
        ],
        [
            1159,
            1327,
            1
        ],
        [
            7296,
            7304,
            1
        ],
        [
            7467,
            7544,
            77
        ],
        [
            11744,
            11775,
            1
        ],
        [
            42560,
            42655,
            1
        ],
        [
            65070,
            65071,
            1
        ],
        [
            122928,
            122989,
            1
        ],
        [
            123023,
            123023,
            1
        ]
    ];
    static Deseret = [
        [
            66560,
            66639,
            1
        ]
    ];
    static Devanagari = [
        [
            2304,
            2384,
            1
        ],
        [
            2389,
            2403,
            1
        ],
        [
            2406,
            2431,
            1
        ],
        [
            43232,
            43263,
            1
        ],
        [
            72448,
            72457,
            1
        ]
    ];
    static Dives_Akuru = [
        [
            71936,
            71942,
            1
        ],
        [
            71945,
            71948,
            3
        ],
        [
            71949,
            71955,
            1
        ],
        [
            71957,
            71958,
            1
        ],
        [
            71960,
            71989,
            1
        ],
        [
            71991,
            71992,
            1
        ],
        [
            71995,
            72006,
            1
        ],
        [
            72016,
            72025,
            1
        ]
    ];
    static Dogra = [
        [
            71680,
            71739,
            1
        ]
    ];
    static Duployan = [
        [
            113664,
            113770,
            1
        ],
        [
            113776,
            113788,
            1
        ],
        [
            113792,
            113800,
            1
        ],
        [
            113808,
            113817,
            1
        ],
        [
            113820,
            113823,
            1
        ]
    ];
    static Egyptian_Hieroglyphs = [
        [
            77824,
            78933,
            1
        ]
    ];
    static Elbasan = [
        [
            66816,
            66855,
            1
        ]
    ];
    static Elymaic = [
        [
            69600,
            69622,
            1
        ]
    ];
    static Ethiopic = [
        [
            4608,
            4680,
            1
        ],
        [
            4682,
            4685,
            1
        ],
        [
            4688,
            4694,
            1
        ],
        [
            4696,
            4698,
            2
        ],
        [
            4699,
            4701,
            1
        ],
        [
            4704,
            4744,
            1
        ],
        [
            4746,
            4749,
            1
        ],
        [
            4752,
            4784,
            1
        ],
        [
            4786,
            4789,
            1
        ],
        [
            4792,
            4798,
            1
        ],
        [
            4800,
            4802,
            2
        ],
        [
            4803,
            4805,
            1
        ],
        [
            4808,
            4822,
            1
        ],
        [
            4824,
            4880,
            1
        ],
        [
            4882,
            4885,
            1
        ],
        [
            4888,
            4954,
            1
        ],
        [
            4957,
            4988,
            1
        ],
        [
            4992,
            5017,
            1
        ],
        [
            11648,
            11670,
            1
        ],
        [
            11680,
            11686,
            1
        ],
        [
            11688,
            11694,
            1
        ],
        [
            11696,
            11702,
            1
        ],
        [
            11704,
            11710,
            1
        ],
        [
            11712,
            11718,
            1
        ],
        [
            11720,
            11726,
            1
        ],
        [
            11728,
            11734,
            1
        ],
        [
            11736,
            11742,
            1
        ],
        [
            43777,
            43782,
            1
        ],
        [
            43785,
            43790,
            1
        ],
        [
            43793,
            43798,
            1
        ],
        [
            43808,
            43814,
            1
        ],
        [
            43816,
            43822,
            1
        ],
        [
            124896,
            124902,
            1
        ],
        [
            124904,
            124907,
            1
        ],
        [
            124909,
            124910,
            1
        ],
        [
            124912,
            124926,
            1
        ]
    ];
    static Georgian = [
        [
            4256,
            4293,
            1
        ],
        [
            4295,
            4301,
            6
        ],
        [
            4304,
            4346,
            1
        ],
        [
            4348,
            4351,
            1
        ],
        [
            7312,
            7354,
            1
        ],
        [
            7357,
            7359,
            1
        ],
        [
            11520,
            11557,
            1
        ],
        [
            11559,
            11565,
            6
        ]
    ];
    static Glagolitic = [
        [
            11264,
            11359,
            1
        ],
        [
            122880,
            122886,
            1
        ],
        [
            122888,
            122904,
            1
        ],
        [
            122907,
            122913,
            1
        ],
        [
            122915,
            122916,
            1
        ],
        [
            122918,
            122922,
            1
        ]
    ];
    static Gothic = [
        [
            66352,
            66378,
            1
        ]
    ];
    static Grantha = [
        [
            70400,
            70403,
            1
        ],
        [
            70405,
            70412,
            1
        ],
        [
            70415,
            70416,
            1
        ],
        [
            70419,
            70440,
            1
        ],
        [
            70442,
            70448,
            1
        ],
        [
            70450,
            70451,
            1
        ],
        [
            70453,
            70457,
            1
        ],
        [
            70460,
            70468,
            1
        ],
        [
            70471,
            70472,
            1
        ],
        [
            70475,
            70477,
            1
        ],
        [
            70480,
            70487,
            7
        ],
        [
            70493,
            70499,
            1
        ],
        [
            70502,
            70508,
            1
        ],
        [
            70512,
            70516,
            1
        ]
    ];
    static Greek = [
        [
            880,
            883,
            1
        ],
        [
            885,
            887,
            1
        ],
        [
            890,
            893,
            1
        ],
        [
            895,
            900,
            5
        ],
        [
            902,
            904,
            2
        ],
        [
            905,
            906,
            1
        ],
        [
            908,
            910,
            2
        ],
        [
            911,
            929,
            1
        ],
        [
            931,
            993,
            1
        ],
        [
            1008,
            1023,
            1
        ],
        [
            7462,
            7466,
            1
        ],
        [
            7517,
            7521,
            1
        ],
        [
            7526,
            7530,
            1
        ],
        [
            7615,
            7936,
            321
        ],
        [
            7937,
            7957,
            1
        ],
        [
            7960,
            7965,
            1
        ],
        [
            7968,
            8005,
            1
        ],
        [
            8008,
            8013,
            1
        ],
        [
            8016,
            8023,
            1
        ],
        [
            8025,
            8031,
            2
        ],
        [
            8032,
            8061,
            1
        ],
        [
            8064,
            8116,
            1
        ],
        [
            8118,
            8132,
            1
        ],
        [
            8134,
            8147,
            1
        ],
        [
            8150,
            8155,
            1
        ],
        [
            8157,
            8175,
            1
        ],
        [
            8178,
            8180,
            1
        ],
        [
            8182,
            8190,
            1
        ],
        [
            8486,
            43877,
            35391
        ],
        [
            65856,
            65934,
            1
        ],
        [
            65952,
            119296,
            53344
        ],
        [
            119297,
            119365,
            1
        ]
    ];
    static foldGreek = [
        [
            181,
            837,
            656
        ]
    ];
    static Gujarati = [
        [
            2689,
            2691,
            1
        ],
        [
            2693,
            2701,
            1
        ],
        [
            2703,
            2705,
            1
        ],
        [
            2707,
            2728,
            1
        ],
        [
            2730,
            2736,
            1
        ],
        [
            2738,
            2739,
            1
        ],
        [
            2741,
            2745,
            1
        ],
        [
            2748,
            2757,
            1
        ],
        [
            2759,
            2761,
            1
        ],
        [
            2763,
            2765,
            1
        ],
        [
            2768,
            2784,
            16
        ],
        [
            2785,
            2787,
            1
        ],
        [
            2790,
            2801,
            1
        ],
        [
            2809,
            2815,
            1
        ]
    ];
    static Gunjala_Gondi = [
        [
            73056,
            73061,
            1
        ],
        [
            73063,
            73064,
            1
        ],
        [
            73066,
            73102,
            1
        ],
        [
            73104,
            73105,
            1
        ],
        [
            73107,
            73112,
            1
        ],
        [
            73120,
            73129,
            1
        ]
    ];
    static Gurmukhi = [
        [
            2561,
            2563,
            1
        ],
        [
            2565,
            2570,
            1
        ],
        [
            2575,
            2576,
            1
        ],
        [
            2579,
            2600,
            1
        ],
        [
            2602,
            2608,
            1
        ],
        [
            2610,
            2611,
            1
        ],
        [
            2613,
            2614,
            1
        ],
        [
            2616,
            2617,
            1
        ],
        [
            2620,
            2622,
            2
        ],
        [
            2623,
            2626,
            1
        ],
        [
            2631,
            2632,
            1
        ],
        [
            2635,
            2637,
            1
        ],
        [
            2641,
            2649,
            8
        ],
        [
            2650,
            2652,
            1
        ],
        [
            2654,
            2662,
            8
        ],
        [
            2663,
            2678,
            1
        ]
    ];
    static Han = [
        [
            11904,
            11929,
            1
        ],
        [
            11931,
            12019,
            1
        ],
        [
            12032,
            12245,
            1
        ],
        [
            12293,
            12295,
            2
        ],
        [
            12321,
            12329,
            1
        ],
        [
            12344,
            12347,
            1
        ],
        [
            13312,
            19903,
            1
        ],
        [
            19968,
            40959,
            1
        ],
        [
            63744,
            64109,
            1
        ],
        [
            64112,
            64217,
            1
        ],
        [
            94178,
            94179,
            1
        ],
        [
            94192,
            94193,
            1
        ],
        [
            131072,
            173791,
            1
        ],
        [
            173824,
            177977,
            1
        ],
        [
            177984,
            178205,
            1
        ],
        [
            178208,
            183969,
            1
        ],
        [
            183984,
            191456,
            1
        ],
        [
            191472,
            192093,
            1
        ],
        [
            194560,
            195101,
            1
        ],
        [
            196608,
            201546,
            1
        ],
        [
            201552,
            205743,
            1
        ]
    ];
    static Hangul = [
        [
            4352,
            4607,
            1
        ],
        [
            12334,
            12335,
            1
        ],
        [
            12593,
            12686,
            1
        ],
        [
            12800,
            12830,
            1
        ],
        [
            12896,
            12926,
            1
        ],
        [
            43360,
            43388,
            1
        ],
        [
            44032,
            55203,
            1
        ],
        [
            55216,
            55238,
            1
        ],
        [
            55243,
            55291,
            1
        ],
        [
            65440,
            65470,
            1
        ],
        [
            65474,
            65479,
            1
        ],
        [
            65482,
            65487,
            1
        ],
        [
            65490,
            65495,
            1
        ],
        [
            65498,
            65500,
            1
        ]
    ];
    static Hanifi_Rohingya = [
        [
            68864,
            68903,
            1
        ],
        [
            68912,
            68921,
            1
        ]
    ];
    static Hanunoo = [
        [
            5920,
            5940,
            1
        ]
    ];
    static Hatran = [
        [
            67808,
            67826,
            1
        ],
        [
            67828,
            67829,
            1
        ],
        [
            67835,
            67839,
            1
        ]
    ];
    static Hebrew = [
        [
            1425,
            1479,
            1
        ],
        [
            1488,
            1514,
            1
        ],
        [
            1519,
            1524,
            1
        ],
        [
            64285,
            64310,
            1
        ],
        [
            64312,
            64316,
            1
        ],
        [
            64318,
            64320,
            2
        ],
        [
            64321,
            64323,
            2
        ],
        [
            64324,
            64326,
            2
        ],
        [
            64327,
            64335,
            1
        ]
    ];
    static Hiragana = [
        [
            12353,
            12438,
            1
        ],
        [
            12445,
            12447,
            1
        ],
        [
            110593,
            110879,
            1
        ],
        [
            110898,
            110928,
            30
        ],
        [
            110929,
            110930,
            1
        ],
        [
            127488,
            127488,
            1
        ]
    ];
    static Imperial_Aramaic = [
        [
            67648,
            67669,
            1
        ],
        [
            67671,
            67679,
            1
        ]
    ];
    static Inherited = [
        [
            768,
            879,
            1
        ],
        [
            1157,
            1158,
            1
        ],
        [
            1611,
            1621,
            1
        ],
        [
            1648,
            2385,
            737
        ],
        [
            2386,
            2388,
            1
        ],
        [
            6832,
            6862,
            1
        ],
        [
            7376,
            7378,
            1
        ],
        [
            7380,
            7392,
            1
        ],
        [
            7394,
            7400,
            1
        ],
        [
            7405,
            7412,
            7
        ],
        [
            7416,
            7417,
            1
        ],
        [
            7616,
            7679,
            1
        ],
        [
            8204,
            8205,
            1
        ],
        [
            8400,
            8432,
            1
        ],
        [
            12330,
            12333,
            1
        ],
        [
            12441,
            12442,
            1
        ],
        [
            65024,
            65039,
            1
        ],
        [
            65056,
            65069,
            1
        ],
        [
            66045,
            66272,
            227
        ],
        [
            70459,
            118528,
            48069
        ],
        [
            118529,
            118573,
            1
        ],
        [
            118576,
            118598,
            1
        ],
        [
            119143,
            119145,
            1
        ],
        [
            119163,
            119170,
            1
        ],
        [
            119173,
            119179,
            1
        ],
        [
            119210,
            119213,
            1
        ],
        [
            917760,
            917999,
            1
        ]
    ];
    static foldInherited = [
        [
            921,
            953,
            32
        ],
        [
            8126,
            8126,
            1
        ]
    ];
    static Inscriptional_Pahlavi = [
        [
            68448,
            68466,
            1
        ],
        [
            68472,
            68479,
            1
        ]
    ];
    static Inscriptional_Parthian = [
        [
            68416,
            68437,
            1
        ],
        [
            68440,
            68447,
            1
        ]
    ];
    static Javanese = [
        [
            43392,
            43469,
            1
        ],
        [
            43472,
            43481,
            1
        ],
        [
            43486,
            43487,
            1
        ]
    ];
    static Kaithi = [
        [
            69760,
            69826,
            1
        ],
        [
            69837,
            69837,
            1
        ]
    ];
    static Kannada = [
        [
            3200,
            3212,
            1
        ],
        [
            3214,
            3216,
            1
        ],
        [
            3218,
            3240,
            1
        ],
        [
            3242,
            3251,
            1
        ],
        [
            3253,
            3257,
            1
        ],
        [
            3260,
            3268,
            1
        ],
        [
            3270,
            3272,
            1
        ],
        [
            3274,
            3277,
            1
        ],
        [
            3285,
            3286,
            1
        ],
        [
            3293,
            3294,
            1
        ],
        [
            3296,
            3299,
            1
        ],
        [
            3302,
            3311,
            1
        ],
        [
            3313,
            3315,
            1
        ]
    ];
    static Katakana = [
        [
            12449,
            12538,
            1
        ],
        [
            12541,
            12543,
            1
        ],
        [
            12784,
            12799,
            1
        ],
        [
            13008,
            13054,
            1
        ],
        [
            13056,
            13143,
            1
        ],
        [
            65382,
            65391,
            1
        ],
        [
            65393,
            65437,
            1
        ],
        [
            110576,
            110579,
            1
        ],
        [
            110581,
            110587,
            1
        ],
        [
            110589,
            110590,
            1
        ],
        [
            110592,
            110880,
            288
        ],
        [
            110881,
            110882,
            1
        ],
        [
            110933,
            110948,
            15
        ],
        [
            110949,
            110951,
            1
        ]
    ];
    static Kawi = [
        [
            73472,
            73488,
            1
        ],
        [
            73490,
            73530,
            1
        ],
        [
            73534,
            73561,
            1
        ]
    ];
    static Kayah_Li = [
        [
            43264,
            43309,
            1
        ],
        [
            43311,
            43311,
            1
        ]
    ];
    static Kharoshthi = [
        [
            68096,
            68099,
            1
        ],
        [
            68101,
            68102,
            1
        ],
        [
            68108,
            68115,
            1
        ],
        [
            68117,
            68119,
            1
        ],
        [
            68121,
            68149,
            1
        ],
        [
            68152,
            68154,
            1
        ],
        [
            68159,
            68168,
            1
        ],
        [
            68176,
            68184,
            1
        ]
    ];
    static Khitan_Small_Script = [
        [
            94180,
            101120,
            6940
        ],
        [
            101121,
            101589,
            1
        ]
    ];
    static Khmer = [
        [
            6016,
            6109,
            1
        ],
        [
            6112,
            6121,
            1
        ],
        [
            6128,
            6137,
            1
        ],
        [
            6624,
            6655,
            1
        ]
    ];
    static Khojki = [
        [
            70144,
            70161,
            1
        ],
        [
            70163,
            70209,
            1
        ]
    ];
    static Khudawadi = [
        [
            70320,
            70378,
            1
        ],
        [
            70384,
            70393,
            1
        ]
    ];
    static Lao = [
        [
            3713,
            3714,
            1
        ],
        [
            3716,
            3718,
            2
        ],
        [
            3719,
            3722,
            1
        ],
        [
            3724,
            3747,
            1
        ],
        [
            3749,
            3751,
            2
        ],
        [
            3752,
            3773,
            1
        ],
        [
            3776,
            3780,
            1
        ],
        [
            3782,
            3784,
            2
        ],
        [
            3785,
            3790,
            1
        ],
        [
            3792,
            3801,
            1
        ],
        [
            3804,
            3807,
            1
        ]
    ];
    static Latin = [
        [
            65,
            90,
            1
        ],
        [
            97,
            122,
            1
        ],
        [
            170,
            186,
            16
        ],
        [
            192,
            214,
            1
        ],
        [
            216,
            246,
            1
        ],
        [
            248,
            696,
            1
        ],
        [
            736,
            740,
            1
        ],
        [
            7424,
            7461,
            1
        ],
        [
            7468,
            7516,
            1
        ],
        [
            7522,
            7525,
            1
        ],
        [
            7531,
            7543,
            1
        ],
        [
            7545,
            7614,
            1
        ],
        [
            7680,
            7935,
            1
        ],
        [
            8305,
            8319,
            14
        ],
        [
            8336,
            8348,
            1
        ],
        [
            8490,
            8491,
            1
        ],
        [
            8498,
            8526,
            28
        ],
        [
            8544,
            8584,
            1
        ],
        [
            11360,
            11391,
            1
        ],
        [
            42786,
            42887,
            1
        ],
        [
            42891,
            42954,
            1
        ],
        [
            42960,
            42961,
            1
        ],
        [
            42963,
            42965,
            2
        ],
        [
            42966,
            42969,
            1
        ],
        [
            42994,
            43007,
            1
        ],
        [
            43824,
            43866,
            1
        ],
        [
            43868,
            43876,
            1
        ],
        [
            43878,
            43881,
            1
        ],
        [
            64256,
            64262,
            1
        ],
        [
            65313,
            65338,
            1
        ],
        [
            65345,
            65370,
            1
        ],
        [
            67456,
            67461,
            1
        ],
        [
            67463,
            67504,
            1
        ],
        [
            67506,
            67514,
            1
        ],
        [
            122624,
            122654,
            1
        ],
        [
            122661,
            122666,
            1
        ]
    ];
    static Lepcha = [
        [
            7168,
            7223,
            1
        ],
        [
            7227,
            7241,
            1
        ],
        [
            7245,
            7247,
            1
        ]
    ];
    static Limbu = [
        [
            6400,
            6430,
            1
        ],
        [
            6432,
            6443,
            1
        ],
        [
            6448,
            6459,
            1
        ],
        [
            6464,
            6468,
            4
        ],
        [
            6469,
            6479,
            1
        ]
    ];
    static Linear_A = [
        [
            67072,
            67382,
            1
        ],
        [
            67392,
            67413,
            1
        ],
        [
            67424,
            67431,
            1
        ]
    ];
    static Linear_B = [
        [
            65536,
            65547,
            1
        ],
        [
            65549,
            65574,
            1
        ],
        [
            65576,
            65594,
            1
        ],
        [
            65596,
            65597,
            1
        ],
        [
            65599,
            65613,
            1
        ],
        [
            65616,
            65629,
            1
        ],
        [
            65664,
            65786,
            1
        ]
    ];
    static Lisu = [
        [
            42192,
            42239,
            1
        ],
        [
            73648,
            73648,
            1
        ]
    ];
    static Lycian = [
        [
            66176,
            66204,
            1
        ]
    ];
    static Lydian = [
        [
            67872,
            67897,
            1
        ],
        [
            67903,
            67903,
            1
        ]
    ];
    static Mahajani = [
        [
            69968,
            70006,
            1
        ]
    ];
    static Makasar = [
        [
            73440,
            73464,
            1
        ]
    ];
    static Malayalam = [
        [
            3328,
            3340,
            1
        ],
        [
            3342,
            3344,
            1
        ],
        [
            3346,
            3396,
            1
        ],
        [
            3398,
            3400,
            1
        ],
        [
            3402,
            3407,
            1
        ],
        [
            3412,
            3427,
            1
        ],
        [
            3430,
            3455,
            1
        ]
    ];
    static Mandaic = [
        [
            2112,
            2139,
            1
        ],
        [
            2142,
            2142,
            1
        ]
    ];
    static Manichaean = [
        [
            68288,
            68326,
            1
        ],
        [
            68331,
            68342,
            1
        ]
    ];
    static Marchen = [
        [
            72816,
            72847,
            1
        ],
        [
            72850,
            72871,
            1
        ],
        [
            72873,
            72886,
            1
        ]
    ];
    static Masaram_Gondi = [
        [
            72960,
            72966,
            1
        ],
        [
            72968,
            72969,
            1
        ],
        [
            72971,
            73014,
            1
        ],
        [
            73018,
            73020,
            2
        ],
        [
            73021,
            73023,
            2
        ],
        [
            73024,
            73031,
            1
        ],
        [
            73040,
            73049,
            1
        ]
    ];
    static Medefaidrin = [
        [
            93760,
            93850,
            1
        ]
    ];
    static Meetei_Mayek = [
        [
            43744,
            43766,
            1
        ],
        [
            43968,
            44013,
            1
        ],
        [
            44016,
            44025,
            1
        ]
    ];
    static Mende_Kikakui = [
        [
            124928,
            125124,
            1
        ],
        [
            125127,
            125142,
            1
        ]
    ];
    static Meroitic_Cursive = [
        [
            68000,
            68023,
            1
        ],
        [
            68028,
            68047,
            1
        ],
        [
            68050,
            68095,
            1
        ]
    ];
    static Meroitic_Hieroglyphs = [
        [
            67968,
            67999,
            1
        ]
    ];
    static Miao = [
        [
            93952,
            94026,
            1
        ],
        [
            94031,
            94087,
            1
        ],
        [
            94095,
            94111,
            1
        ]
    ];
    static Modi = [
        [
            71168,
            71236,
            1
        ],
        [
            71248,
            71257,
            1
        ]
    ];
    static Mongolian = [
        [
            6144,
            6145,
            1
        ],
        [
            6148,
            6150,
            2
        ],
        [
            6151,
            6169,
            1
        ],
        [
            6176,
            6264,
            1
        ],
        [
            6272,
            6314,
            1
        ],
        [
            71264,
            71276,
            1
        ]
    ];
    static Mro = [
        [
            92736,
            92766,
            1
        ],
        [
            92768,
            92777,
            1
        ],
        [
            92782,
            92783,
            1
        ]
    ];
    static Multani = [
        [
            70272,
            70278,
            1
        ],
        [
            70280,
            70282,
            2
        ],
        [
            70283,
            70285,
            1
        ],
        [
            70287,
            70301,
            1
        ],
        [
            70303,
            70313,
            1
        ]
    ];
    static Myanmar = [
        [
            4096,
            4255,
            1
        ],
        [
            43488,
            43518,
            1
        ],
        [
            43616,
            43647,
            1
        ]
    ];
    static Nabataean = [
        [
            67712,
            67742,
            1
        ],
        [
            67751,
            67759,
            1
        ]
    ];
    static Nag_Mundari = [
        [
            124112,
            124153,
            1
        ]
    ];
    static Nandinagari = [
        [
            72096,
            72103,
            1
        ],
        [
            72106,
            72151,
            1
        ],
        [
            72154,
            72164,
            1
        ]
    ];
    static New_Tai_Lue = [
        [
            6528,
            6571,
            1
        ],
        [
            6576,
            6601,
            1
        ],
        [
            6608,
            6618,
            1
        ],
        [
            6622,
            6623,
            1
        ]
    ];
    static Newa = [
        [
            70656,
            70747,
            1
        ],
        [
            70749,
            70753,
            1
        ]
    ];
    static Nko = [
        [
            1984,
            2042,
            1
        ],
        [
            2045,
            2047,
            1
        ]
    ];
    static Nushu = [
        [
            94177,
            110960,
            16783
        ],
        [
            110961,
            111355,
            1
        ]
    ];
    static Nyiakeng_Puachue_Hmong = [
        [
            123136,
            123180,
            1
        ],
        [
            123184,
            123197,
            1
        ],
        [
            123200,
            123209,
            1
        ],
        [
            123214,
            123215,
            1
        ]
    ];
    static Ogham = [
        [
            5760,
            5788,
            1
        ]
    ];
    static Ol_Chiki = [
        [
            7248,
            7295,
            1
        ]
    ];
    static Old_Hungarian = [
        [
            68736,
            68786,
            1
        ],
        [
            68800,
            68850,
            1
        ],
        [
            68858,
            68863,
            1
        ]
    ];
    static Old_Italic = [
        [
            66304,
            66339,
            1
        ],
        [
            66349,
            66351,
            1
        ]
    ];
    static Old_North_Arabian = [
        [
            68224,
            68255,
            1
        ]
    ];
    static Old_Permic = [
        [
            66384,
            66426,
            1
        ]
    ];
    static Old_Persian = [
        [
            66464,
            66499,
            1
        ],
        [
            66504,
            66517,
            1
        ]
    ];
    static Old_Sogdian = [
        [
            69376,
            69415,
            1
        ]
    ];
    static Old_South_Arabian = [
        [
            68192,
            68223,
            1
        ]
    ];
    static Old_Turkic = [
        [
            68608,
            68680,
            1
        ]
    ];
    static Old_Uyghur = [
        [
            69488,
            69513,
            1
        ]
    ];
    static Oriya = [
        [
            2817,
            2819,
            1
        ],
        [
            2821,
            2828,
            1
        ],
        [
            2831,
            2832,
            1
        ],
        [
            2835,
            2856,
            1
        ],
        [
            2858,
            2864,
            1
        ],
        [
            2866,
            2867,
            1
        ],
        [
            2869,
            2873,
            1
        ],
        [
            2876,
            2884,
            1
        ],
        [
            2887,
            2888,
            1
        ],
        [
            2891,
            2893,
            1
        ],
        [
            2901,
            2903,
            1
        ],
        [
            2908,
            2909,
            1
        ],
        [
            2911,
            2915,
            1
        ],
        [
            2918,
            2935,
            1
        ]
    ];
    static Osage = [
        [
            66736,
            66771,
            1
        ],
        [
            66776,
            66811,
            1
        ]
    ];
    static Osmanya = [
        [
            66688,
            66717,
            1
        ],
        [
            66720,
            66729,
            1
        ]
    ];
    static Pahawh_Hmong = [
        [
            92928,
            92997,
            1
        ],
        [
            93008,
            93017,
            1
        ],
        [
            93019,
            93025,
            1
        ],
        [
            93027,
            93047,
            1
        ],
        [
            93053,
            93071,
            1
        ]
    ];
    static Palmyrene = [
        [
            67680,
            67711,
            1
        ]
    ];
    static Pau_Cin_Hau = [
        [
            72384,
            72440,
            1
        ]
    ];
    static Phags_Pa = [
        [
            43072,
            43127,
            1
        ]
    ];
    static Phoenician = [
        [
            67840,
            67867,
            1
        ],
        [
            67871,
            67871,
            1
        ]
    ];
    static Psalter_Pahlavi = [
        [
            68480,
            68497,
            1
        ],
        [
            68505,
            68508,
            1
        ],
        [
            68521,
            68527,
            1
        ]
    ];
    static Rejang = [
        [
            43312,
            43347,
            1
        ],
        [
            43359,
            43359,
            1
        ]
    ];
    static Runic = [
        [
            5792,
            5866,
            1
        ],
        [
            5870,
            5880,
            1
        ]
    ];
    static Samaritan = [
        [
            2048,
            2093,
            1
        ],
        [
            2096,
            2110,
            1
        ]
    ];
    static Saurashtra = [
        [
            43136,
            43205,
            1
        ],
        [
            43214,
            43225,
            1
        ]
    ];
    static Sharada = [
        [
            70016,
            70111,
            1
        ]
    ];
    static Shavian = [
        [
            66640,
            66687,
            1
        ]
    ];
    static Siddham = [
        [
            71040,
            71093,
            1
        ],
        [
            71096,
            71133,
            1
        ]
    ];
    static SignWriting = [
        [
            120832,
            121483,
            1
        ],
        [
            121499,
            121503,
            1
        ],
        [
            121505,
            121519,
            1
        ]
    ];
    static Sinhala = [
        [
            3457,
            3459,
            1
        ],
        [
            3461,
            3478,
            1
        ],
        [
            3482,
            3505,
            1
        ],
        [
            3507,
            3515,
            1
        ],
        [
            3517,
            3520,
            3
        ],
        [
            3521,
            3526,
            1
        ],
        [
            3530,
            3535,
            5
        ],
        [
            3536,
            3540,
            1
        ],
        [
            3542,
            3544,
            2
        ],
        [
            3545,
            3551,
            1
        ],
        [
            3558,
            3567,
            1
        ],
        [
            3570,
            3572,
            1
        ],
        [
            70113,
            70132,
            1
        ]
    ];
    static Sogdian = [
        [
            69424,
            69465,
            1
        ]
    ];
    static Sora_Sompeng = [
        [
            69840,
            69864,
            1
        ],
        [
            69872,
            69881,
            1
        ]
    ];
    static Soyombo = [
        [
            72272,
            72354,
            1
        ]
    ];
    static Sundanese = [
        [
            7040,
            7103,
            1
        ],
        [
            7360,
            7367,
            1
        ]
    ];
    static Syloti_Nagri = [
        [
            43008,
            43052,
            1
        ]
    ];
    static Syriac = [
        [
            1792,
            1805,
            1
        ],
        [
            1807,
            1866,
            1
        ],
        [
            1869,
            1871,
            1
        ],
        [
            2144,
            2154,
            1
        ]
    ];
    static Tagalog = [
        [
            5888,
            5909,
            1
        ],
        [
            5919,
            5919,
            1
        ]
    ];
    static Tagbanwa = [
        [
            5984,
            5996,
            1
        ],
        [
            5998,
            6000,
            1
        ],
        [
            6002,
            6003,
            1
        ]
    ];
    static Tai_Le = [
        [
            6480,
            6509,
            1
        ],
        [
            6512,
            6516,
            1
        ]
    ];
    static Tai_Tham = [
        [
            6688,
            6750,
            1
        ],
        [
            6752,
            6780,
            1
        ],
        [
            6783,
            6793,
            1
        ],
        [
            6800,
            6809,
            1
        ],
        [
            6816,
            6829,
            1
        ]
    ];
    static Tai_Viet = [
        [
            43648,
            43714,
            1
        ],
        [
            43739,
            43743,
            1
        ]
    ];
    static Takri = [
        [
            71296,
            71353,
            1
        ],
        [
            71360,
            71369,
            1
        ]
    ];
    static Tamil = [
        [
            2946,
            2947,
            1
        ],
        [
            2949,
            2954,
            1
        ],
        [
            2958,
            2960,
            1
        ],
        [
            2962,
            2965,
            1
        ],
        [
            2969,
            2970,
            1
        ],
        [
            2972,
            2974,
            2
        ],
        [
            2975,
            2979,
            4
        ],
        [
            2980,
            2984,
            4
        ],
        [
            2985,
            2986,
            1
        ],
        [
            2990,
            3001,
            1
        ],
        [
            3006,
            3010,
            1
        ],
        [
            3014,
            3016,
            1
        ],
        [
            3018,
            3021,
            1
        ],
        [
            3024,
            3031,
            7
        ],
        [
            3046,
            3066,
            1
        ],
        [
            73664,
            73713,
            1
        ],
        [
            73727,
            73727,
            1
        ]
    ];
    static Tangsa = [
        [
            92784,
            92862,
            1
        ],
        [
            92864,
            92873,
            1
        ]
    ];
    static Tangut = [
        [
            94176,
            94208,
            32
        ],
        [
            94209,
            100343,
            1
        ],
        [
            100352,
            101119,
            1
        ],
        [
            101632,
            101640,
            1
        ]
    ];
    static Telugu = [
        [
            3072,
            3084,
            1
        ],
        [
            3086,
            3088,
            1
        ],
        [
            3090,
            3112,
            1
        ],
        [
            3114,
            3129,
            1
        ],
        [
            3132,
            3140,
            1
        ],
        [
            3142,
            3144,
            1
        ],
        [
            3146,
            3149,
            1
        ],
        [
            3157,
            3158,
            1
        ],
        [
            3160,
            3162,
            1
        ],
        [
            3165,
            3168,
            3
        ],
        [
            3169,
            3171,
            1
        ],
        [
            3174,
            3183,
            1
        ],
        [
            3191,
            3199,
            1
        ]
    ];
    static Thaana = [
        [
            1920,
            1969,
            1
        ]
    ];
    static Thai = [
        [
            3585,
            3642,
            1
        ],
        [
            3648,
            3675,
            1
        ]
    ];
    static Tibetan = [
        [
            3840,
            3911,
            1
        ],
        [
            3913,
            3948,
            1
        ],
        [
            3953,
            3991,
            1
        ],
        [
            3993,
            4028,
            1
        ],
        [
            4030,
            4044,
            1
        ],
        [
            4046,
            4052,
            1
        ],
        [
            4057,
            4058,
            1
        ]
    ];
    static Tifinagh = [
        [
            11568,
            11623,
            1
        ],
        [
            11631,
            11632,
            1
        ],
        [
            11647,
            11647,
            1
        ]
    ];
    static Tirhuta = [
        [
            70784,
            70855,
            1
        ],
        [
            70864,
            70873,
            1
        ]
    ];
    static Toto = [
        [
            123536,
            123566,
            1
        ]
    ];
    static Ugaritic = [
        [
            66432,
            66461,
            1
        ],
        [
            66463,
            66463,
            1
        ]
    ];
    static Vai = [
        [
            42240,
            42539,
            1
        ]
    ];
    static Vithkuqi = [
        [
            66928,
            66938,
            1
        ],
        [
            66940,
            66954,
            1
        ],
        [
            66956,
            66962,
            1
        ],
        [
            66964,
            66965,
            1
        ],
        [
            66967,
            66977,
            1
        ],
        [
            66979,
            66993,
            1
        ],
        [
            66995,
            67001,
            1
        ],
        [
            67003,
            67004,
            1
        ]
    ];
    static Wancho = [
        [
            123584,
            123641,
            1
        ],
        [
            123647,
            123647,
            1
        ]
    ];
    static Warang_Citi = [
        [
            71840,
            71922,
            1
        ],
        [
            71935,
            71935,
            1
        ]
    ];
    static Yezidi = [
        [
            69248,
            69289,
            1
        ],
        [
            69291,
            69293,
            1
        ],
        [
            69296,
            69297,
            1
        ]
    ];
    static Yi = [
        [
            40960,
            42124,
            1
        ],
        [
            42128,
            42182,
            1
        ]
    ];
    static Zanabazar_Square = [
        [
            72192,
            72263,
            1
        ]
    ];
    static CATEGORIES = (()=>new Map([
            [
                'C',
                UnicodeTables.C
            ],
            [
                'Cc',
                UnicodeTables.Cc
            ],
            [
                'Cf',
                UnicodeTables.Cf
            ],
            [
                'Co',
                UnicodeTables.Co
            ],
            [
                'Cs',
                UnicodeTables.Cs
            ],
            [
                'L',
                UnicodeTables.L
            ],
            [
                'Ll',
                UnicodeTables.Ll
            ],
            [
                'Lm',
                UnicodeTables.Lm
            ],
            [
                'Lo',
                UnicodeTables.Lo
            ],
            [
                'Lt',
                UnicodeTables.Lt
            ],
            [
                'Lu',
                UnicodeTables.Lu
            ],
            [
                'M',
                UnicodeTables.M
            ],
            [
                'Mc',
                UnicodeTables.Mc
            ],
            [
                'Me',
                UnicodeTables.Me
            ],
            [
                'Mn',
                UnicodeTables.Mn
            ],
            [
                'N',
                UnicodeTables.N
            ],
            [
                'Nd',
                UnicodeTables.Nd
            ],
            [
                'Nl',
                UnicodeTables.Nl
            ],
            [
                'No',
                UnicodeTables.No
            ],
            [
                'P',
                UnicodeTables.P
            ],
            [
                'Pc',
                UnicodeTables.Pc
            ],
            [
                'Pd',
                UnicodeTables.Pd
            ],
            [
                'Pe',
                UnicodeTables.Pe
            ],
            [
                'Pf',
                UnicodeTables.Pf
            ],
            [
                'Pi',
                UnicodeTables.Pi
            ],
            [
                'Po',
                UnicodeTables.Po
            ],
            [
                'Ps',
                UnicodeTables.Ps
            ],
            [
                'S',
                UnicodeTables.S
            ],
            [
                'Sc',
                UnicodeTables.Sc
            ],
            [
                'Sk',
                UnicodeTables.Sk
            ],
            [
                'Sm',
                UnicodeTables.Sm
            ],
            [
                'So',
                UnicodeTables.So
            ],
            [
                'Z',
                UnicodeTables.Z
            ],
            [
                'Zl',
                UnicodeTables.Zl
            ],
            [
                'Zp',
                UnicodeTables.Zp
            ],
            [
                'Zs',
                UnicodeTables.Zs
            ]
        ]))();
    static SCRIPTS = (()=>new Map([
            [
                'Adlam',
                UnicodeTables.Adlam
            ],
            [
                'Ahom',
                UnicodeTables.Ahom
            ],
            [
                'Anatolian_Hieroglyphs',
                UnicodeTables.Anatolian_Hieroglyphs
            ],
            [
                'Arabic',
                UnicodeTables.Arabic
            ],
            [
                'Armenian',
                UnicodeTables.Armenian
            ],
            [
                'Avestan',
                UnicodeTables.Avestan
            ],
            [
                'Balinese',
                UnicodeTables.Balinese
            ],
            [
                'Bamum',
                UnicodeTables.Bamum
            ],
            [
                'Bassa_Vah',
                UnicodeTables.Bassa_Vah
            ],
            [
                'Batak',
                UnicodeTables.Batak
            ],
            [
                'Bengali',
                UnicodeTables.Bengali
            ],
            [
                'Bhaiksuki',
                UnicodeTables.Bhaiksuki
            ],
            [
                'Bopomofo',
                UnicodeTables.Bopomofo
            ],
            [
                'Brahmi',
                UnicodeTables.Brahmi
            ],
            [
                'Braille',
                UnicodeTables.Braille
            ],
            [
                'Buginese',
                UnicodeTables.Buginese
            ],
            [
                'Buhid',
                UnicodeTables.Buhid
            ],
            [
                'Canadian_Aboriginal',
                UnicodeTables.Canadian_Aboriginal
            ],
            [
                'Carian',
                UnicodeTables.Carian
            ],
            [
                'Caucasian_Albanian',
                UnicodeTables.Caucasian_Albanian
            ],
            [
                'Chakma',
                UnicodeTables.Chakma
            ],
            [
                'Cham',
                UnicodeTables.Cham
            ],
            [
                'Cherokee',
                UnicodeTables.Cherokee
            ],
            [
                'Chorasmian',
                UnicodeTables.Chorasmian
            ],
            [
                'Common',
                UnicodeTables.Common
            ],
            [
                'Coptic',
                UnicodeTables.Coptic
            ],
            [
                'Cuneiform',
                UnicodeTables.Cuneiform
            ],
            [
                'Cypriot',
                UnicodeTables.Cypriot
            ],
            [
                'Cypro_Minoan',
                UnicodeTables.Cypro_Minoan
            ],
            [
                'Cyrillic',
                UnicodeTables.Cyrillic
            ],
            [
                'Deseret',
                UnicodeTables.Deseret
            ],
            [
                'Devanagari',
                UnicodeTables.Devanagari
            ],
            [
                'Dives_Akuru',
                UnicodeTables.Dives_Akuru
            ],
            [
                'Dogra',
                UnicodeTables.Dogra
            ],
            [
                'Duployan',
                UnicodeTables.Duployan
            ],
            [
                'Egyptian_Hieroglyphs',
                UnicodeTables.Egyptian_Hieroglyphs
            ],
            [
                'Elbasan',
                UnicodeTables.Elbasan
            ],
            [
                'Elymaic',
                UnicodeTables.Elymaic
            ],
            [
                'Ethiopic',
                UnicodeTables.Ethiopic
            ],
            [
                'Georgian',
                UnicodeTables.Georgian
            ],
            [
                'Glagolitic',
                UnicodeTables.Glagolitic
            ],
            [
                'Gothic',
                UnicodeTables.Gothic
            ],
            [
                'Grantha',
                UnicodeTables.Grantha
            ],
            [
                'Greek',
                UnicodeTables.Greek
            ],
            [
                'Gujarati',
                UnicodeTables.Gujarati
            ],
            [
                'Gunjala_Gondi',
                UnicodeTables.Gunjala_Gondi
            ],
            [
                'Gurmukhi',
                UnicodeTables.Gurmukhi
            ],
            [
                'Han',
                UnicodeTables.Han
            ],
            [
                'Hangul',
                UnicodeTables.Hangul
            ],
            [
                'Hanifi_Rohingya',
                UnicodeTables.Hanifi_Rohingya
            ],
            [
                'Hanunoo',
                UnicodeTables.Hanunoo
            ],
            [
                'Hatran',
                UnicodeTables.Hatran
            ],
            [
                'Hebrew',
                UnicodeTables.Hebrew
            ],
            [
                'Hiragana',
                UnicodeTables.Hiragana
            ],
            [
                'Imperial_Aramaic',
                UnicodeTables.Imperial_Aramaic
            ],
            [
                'Inherited',
                UnicodeTables.Inherited
            ],
            [
                'Inscriptional_Pahlavi',
                UnicodeTables.Inscriptional_Pahlavi
            ],
            [
                'Inscriptional_Parthian',
                UnicodeTables.Inscriptional_Parthian
            ],
            [
                'Javanese',
                UnicodeTables.Javanese
            ],
            [
                'Kaithi',
                UnicodeTables.Kaithi
            ],
            [
                'Kannada',
                UnicodeTables.Kannada
            ],
            [
                'Katakana',
                UnicodeTables.Katakana
            ],
            [
                'Kawi',
                UnicodeTables.Kawi
            ],
            [
                'Kayah_Li',
                UnicodeTables.Kayah_Li
            ],
            [
                'Kharoshthi',
                UnicodeTables.Kharoshthi
            ],
            [
                'Khitan_Small_Script',
                UnicodeTables.Khitan_Small_Script
            ],
            [
                'Khmer',
                UnicodeTables.Khmer
            ],
            [
                'Khojki',
                UnicodeTables.Khojki
            ],
            [
                'Khudawadi',
                UnicodeTables.Khudawadi
            ],
            [
                'Lao',
                UnicodeTables.Lao
            ],
            [
                'Latin',
                UnicodeTables.Latin
            ],
            [
                'Lepcha',
                UnicodeTables.Lepcha
            ],
            [
                'Limbu',
                UnicodeTables.Limbu
            ],
            [
                'Linear_A',
                UnicodeTables.Linear_A
            ],
            [
                'Linear_B',
                UnicodeTables.Linear_B
            ],
            [
                'Lisu',
                UnicodeTables.Lisu
            ],
            [
                'Lycian',
                UnicodeTables.Lycian
            ],
            [
                'Lydian',
                UnicodeTables.Lydian
            ],
            [
                'Mahajani',
                UnicodeTables.Mahajani
            ],
            [
                'Makasar',
                UnicodeTables.Makasar
            ],
            [
                'Malayalam',
                UnicodeTables.Malayalam
            ],
            [
                'Mandaic',
                UnicodeTables.Mandaic
            ],
            [
                'Manichaean',
                UnicodeTables.Manichaean
            ],
            [
                'Marchen',
                UnicodeTables.Marchen
            ],
            [
                'Masaram_Gondi',
                UnicodeTables.Masaram_Gondi
            ],
            [
                'Medefaidrin',
                UnicodeTables.Medefaidrin
            ],
            [
                'Meetei_Mayek',
                UnicodeTables.Meetei_Mayek
            ],
            [
                'Mende_Kikakui',
                UnicodeTables.Mende_Kikakui
            ],
            [
                'Meroitic_Cursive',
                UnicodeTables.Meroitic_Cursive
            ],
            [
                'Meroitic_Hieroglyphs',
                UnicodeTables.Meroitic_Hieroglyphs
            ],
            [
                'Miao',
                UnicodeTables.Miao
            ],
            [
                'Modi',
                UnicodeTables.Modi
            ],
            [
                'Mongolian',
                UnicodeTables.Mongolian
            ],
            [
                'Mro',
                UnicodeTables.Mro
            ],
            [
                'Multani',
                UnicodeTables.Multani
            ],
            [
                'Myanmar',
                UnicodeTables.Myanmar
            ],
            [
                'Nabataean',
                UnicodeTables.Nabataean
            ],
            [
                'Nag_Mundari',
                UnicodeTables.Nag_Mundari
            ],
            [
                'Nandinagari',
                UnicodeTables.Nandinagari
            ],
            [
                'New_Tai_Lue',
                UnicodeTables.New_Tai_Lue
            ],
            [
                'Newa',
                UnicodeTables.Newa
            ],
            [
                'Nko',
                UnicodeTables.Nko
            ],
            [
                'Nushu',
                UnicodeTables.Nushu
            ],
            [
                'Nyiakeng_Puachue_Hmong',
                UnicodeTables.Nyiakeng_Puachue_Hmong
            ],
            [
                'Ogham',
                UnicodeTables.Ogham
            ],
            [
                'Ol_Chiki',
                UnicodeTables.Ol_Chiki
            ],
            [
                'Old_Hungarian',
                UnicodeTables.Old_Hungarian
            ],
            [
                'Old_Italic',
                UnicodeTables.Old_Italic
            ],
            [
                'Old_North_Arabian',
                UnicodeTables.Old_North_Arabian
            ],
            [
                'Old_Permic',
                UnicodeTables.Old_Permic
            ],
            [
                'Old_Persian',
                UnicodeTables.Old_Persian
            ],
            [
                'Old_Sogdian',
                UnicodeTables.Old_Sogdian
            ],
            [
                'Old_South_Arabian',
                UnicodeTables.Old_South_Arabian
            ],
            [
                'Old_Turkic',
                UnicodeTables.Old_Turkic
            ],
            [
                'Old_Uyghur',
                UnicodeTables.Old_Uyghur
            ],
            [
                'Oriya',
                UnicodeTables.Oriya
            ],
            [
                'Osage',
                UnicodeTables.Osage
            ],
            [
                'Osmanya',
                UnicodeTables.Osmanya
            ],
            [
                'Pahawh_Hmong',
                UnicodeTables.Pahawh_Hmong
            ],
            [
                'Palmyrene',
                UnicodeTables.Palmyrene
            ],
            [
                'Pau_Cin_Hau',
                UnicodeTables.Pau_Cin_Hau
            ],
            [
                'Phags_Pa',
                UnicodeTables.Phags_Pa
            ],
            [
                'Phoenician',
                UnicodeTables.Phoenician
            ],
            [
                'Psalter_Pahlavi',
                UnicodeTables.Psalter_Pahlavi
            ],
            [
                'Rejang',
                UnicodeTables.Rejang
            ],
            [
                'Runic',
                UnicodeTables.Runic
            ],
            [
                'Samaritan',
                UnicodeTables.Samaritan
            ],
            [
                'Saurashtra',
                UnicodeTables.Saurashtra
            ],
            [
                'Sharada',
                UnicodeTables.Sharada
            ],
            [
                'Shavian',
                UnicodeTables.Shavian
            ],
            [
                'Siddham',
                UnicodeTables.Siddham
            ],
            [
                'SignWriting',
                UnicodeTables.SignWriting
            ],
            [
                'Sinhala',
                UnicodeTables.Sinhala
            ],
            [
                'Sogdian',
                UnicodeTables.Sogdian
            ],
            [
                'Sora_Sompeng',
                UnicodeTables.Sora_Sompeng
            ],
            [
                'Soyombo',
                UnicodeTables.Soyombo
            ],
            [
                'Sundanese',
                UnicodeTables.Sundanese
            ],
            [
                'Syloti_Nagri',
                UnicodeTables.Syloti_Nagri
            ],
            [
                'Syriac',
                UnicodeTables.Syriac
            ],
            [
                'Tagalog',
                UnicodeTables.Tagalog
            ],
            [
                'Tagbanwa',
                UnicodeTables.Tagbanwa
            ],
            [
                'Tai_Le',
                UnicodeTables.Tai_Le
            ],
            [
                'Tai_Tham',
                UnicodeTables.Tai_Tham
            ],
            [
                'Tai_Viet',
                UnicodeTables.Tai_Viet
            ],
            [
                'Takri',
                UnicodeTables.Takri
            ],
            [
                'Tamil',
                UnicodeTables.Tamil
            ],
            [
                'Tangsa',
                UnicodeTables.Tangsa
            ],
            [
                'Tangut',
                UnicodeTables.Tangut
            ],
            [
                'Telugu',
                UnicodeTables.Telugu
            ],
            [
                'Thaana',
                UnicodeTables.Thaana
            ],
            [
                'Thai',
                UnicodeTables.Thai
            ],
            [
                'Tibetan',
                UnicodeTables.Tibetan
            ],
            [
                'Tifinagh',
                UnicodeTables.Tifinagh
            ],
            [
                'Tirhuta',
                UnicodeTables.Tirhuta
            ],
            [
                'Toto',
                UnicodeTables.Toto
            ],
            [
                'Ugaritic',
                UnicodeTables.Ugaritic
            ],
            [
                'Vai',
                UnicodeTables.Vai
            ],
            [
                'Vithkuqi',
                UnicodeTables.Vithkuqi
            ],
            [
                'Wancho',
                UnicodeTables.Wancho
            ],
            [
                'Warang_Citi',
                UnicodeTables.Warang_Citi
            ],
            [
                'Yezidi',
                UnicodeTables.Yezidi
            ],
            [
                'Yi',
                UnicodeTables.Yi
            ],
            [
                'Zanabazar_Square',
                UnicodeTables.Zanabazar_Square
            ]
        ]))();
    static FOLD_CATEGORIES = (()=>new Map([
            [
                'L',
                UnicodeTables.foldL
            ],
            [
                'Ll',
                UnicodeTables.foldLl
            ],
            [
                'Lt',
                UnicodeTables.foldLt
            ],
            [
                'Lu',
                UnicodeTables.foldLu
            ],
            [
                'M',
                UnicodeTables.foldM
            ],
            [
                'Mn',
                UnicodeTables.foldMn
            ]
        ]))();
    static FOLD_SCRIPT = (()=>new Map([
            [
                'Common',
                UnicodeTables.foldCommon
            ],
            [
                'Greek',
                UnicodeTables.foldGreek
            ],
            [
                'Inherited',
                UnicodeTables.foldInherited
            ]
        ]))();
}
/**
 * Utilities for dealing with Unicode better than JS does.
 */ class Unicode {
    // The highest legal rune value.
    static MAX_RUNE = 0x10ffff;
    // The highest legal ASCII value.
    static MAX_ASCII = 0x7f;
    // The highest legal Latin-1 value.
    static MAX_LATIN1 = 0xff;
    // The highest legal Basic Multilingual Plane (BMP) value.
    static MAX_BMP = 0xffff;
    // Minimum and maximum runes involved in folding.
    // Checked during test.
    static MIN_FOLD = 0x0041;
    static MAX_FOLD = 0x1e943;
    // is32 uses binary search to test whether rune is in the specified
    // slice of 32-bit ranges.
    static is32(ranges, r) {
        // binary search over ranges
        let lo = 0;
        let hi = ranges.length;
        while(lo < hi){
            let m = lo + Math.floor((hi - lo) / 2);
            let range = ranges[m];
            if (range[0] <= r && r <= range[1]) return (r - range[0]) % range[2] === 0;
            if (r < range[0]) hi = m;
            else lo = m + 1;
        }
        return false;
    }
    // is tests whether rune is in the specified table of ranges.
    static is(ranges, r) {
        // common case: rune is ASCII or Latin-1, so use linear search.
        if (r <= this.MAX_LATIN1) {
            for (let range of ranges){
                // range = [lo, hi, stride]
                if (r > range[1]) continue;
                if (r < range[0]) return false;
                return (r - range[0]) % range[2] === 0;
            }
            return false;
        }
        return ranges.length > 0 && r >= ranges[0][0] && this.is32(ranges, r);
    }
    // isUpper reports whether the rune is an upper case letter.
    static isUpper(r) {
        if (r <= this.MAX_LATIN1) {
            const s = String.fromCodePoint(r);
            return s.toUpperCase() === s && s.toLowerCase() !== s;
        }
        return this.is(UnicodeTables.Upper, r);
    }
    // isPrint reports whether the rune is printable (Unicode L/M/N/P/S or ' ').
    static isPrint(r) {
        if (r <= this.MAX_LATIN1) return r >= 0x20 && r < 0x7f || r >= 0xa1 && r !== 0xad;
        return this.is(UnicodeTables.L, r) || this.is(UnicodeTables.M, r) || this.is(UnicodeTables.N, r) || this.is(UnicodeTables.P, r) || this.is(UnicodeTables.S, r);
    }
    // simpleFold iterates over Unicode code points equivalent under
    // the Unicode-defined simple case folding.  Among the code points
    // equivalent to rune (including rune itself), SimpleFold returns the
    // smallest r >= rune if one exists, or else the smallest r >= 0.
    //
    // For example:
    //      SimpleFold('A') = 'a'
    //      SimpleFold('a') = 'A'
    //
    //      SimpleFold('K') = 'k'
    //      SimpleFold('k') = '\u212A' (Kelvin symbol, K)
    //      SimpleFold('\u212A') = 'K'
    //
    //      SimpleFold('1') = '1'
    //
    // Derived from Go's unicode.SimpleFold.
    //
    static simpleFold(r) {
        // Consult caseOrbit table for special cases.
        if (UnicodeTables.CASE_ORBIT.has(r)) return UnicodeTables.CASE_ORBIT.get(r);
        // No folding specified.  This is a one- or two-element
        // equivalence class containing rune and toLower(rune)
        // and toUpper(rune) if they are different from rune.
        const l = Codepoint.toLowerCase(r);
        if (l !== r) return l;
        return Codepoint.toUpperCase(r);
    }
    // equalsIgnoreCase performs case-insensitive equality comparison
    // on the given runes |r1| and |r2|, with special consideration
    // for the likely scenario where both runes are ASCII characters.
    // If non-ASCII, Unicode case folding will be performed on |r1|
    // to compare it to |r2|.
    // -1 is interpreted as the end-of-file mark.
    static equalsIgnoreCase(r1, r2) {
        // Runes already match, or one of them is EOF
        if (r1 < 0 || r2 < 0 || r1 === r2) return true;
        // Fast path for the common case where both runes are ASCII characters.
        // Coerces both runes to lowercase if applicable.
        if (r1 <= this.MAX_ASCII && r2 <= this.MAX_ASCII) {
            if (Codepoint.CODES.get('A') <= r1 && r1 <= Codepoint.CODES.get('Z')) r1 |= 0x20;
            if (Codepoint.CODES.get('A') <= r2 && r2 <= Codepoint.CODES.get('Z')) r2 |= 0x20;
            return r1 === r2;
        }
        // Fall back to full Unicode case folding otherwise.
        // Invariant: r1 must be non-negative
        for(let r = this.simpleFold(r1); r !== r1; r = this.simpleFold(r)){
            if (r === r2) return true;
        }
        return false;
    }
}
/**
 * Various constants and helper utilities.
 */ class Utils {
    static METACHARACTERS = '\\.+*?()|[]{}^$';
    //// EMPTY_* flags
    static EMPTY_BEGIN_LINE = 0x01;
    static EMPTY_END_LINE = 0x02;
    static EMPTY_BEGIN_TEXT = 0x04;
    static EMPTY_END_TEXT = 0x08;
    static EMPTY_WORD_BOUNDARY = 0x10;
    static EMPTY_NO_WORD_BOUNDARY = 0x20;
    static EMPTY_ALL = (()=>-1)();
    static emptyInts() {
        return [];
    }
    // Returns true iff |c| is an ASCII letter or decimal digit.
    static isalnum(c) {
        return Codepoint.CODES.get('0') <= c && c <= Codepoint.CODES.get('9') || Codepoint.CODES.get('a') <= c && c <= Codepoint.CODES.get('z') || Codepoint.CODES.get('A') <= c && c <= Codepoint.CODES.get('Z');
    }
    // If |c| is an ASCII hex digit, returns its value, otherwise -1.
    static unhex(c) {
        if (Codepoint.CODES.get('0') <= c && c <= Codepoint.CODES.get('9')) return c - Codepoint.CODES.get('0');
        if (Codepoint.CODES.get('a') <= c && c <= Codepoint.CODES.get('f')) return c - Codepoint.CODES.get('a') + 10;
        if (Codepoint.CODES.get('A') <= c && c <= Codepoint.CODES.get('F')) return c - Codepoint.CODES.get('A') + 10;
        return -1;
    }
    // Appends a RE2 literal to |out| for rune |rune|,
    // with regexp metacharacters escaped.
    static escapeRune(rune) {
        let out = '';
        if (Unicode.isPrint(rune)) {
            if (this.METACHARACTERS.indexOf(String.fromCodePoint(rune)) >= 0) out += '\\';
            out += String.fromCodePoint(rune);
        } else switch(rune){
            case Codepoint.CODES.get('"'):
                // '"'
                out += '\\"';
                break;
            case Codepoint.CODES.get('\\'):
                // '\\'
                out += '\\\\';
                break;
            case Codepoint.CODES.get('\t'):
                // '\t'
                out += '\\t';
                break;
            case Codepoint.CODES.get('\n'):
                // '\n'
                out += '\\n';
                break;
            case Codepoint.CODES.get('\r'):
                // '\r'
                out += '\\r';
                break;
            case Codepoint.CODES.get('\b'):
                // '\b'
                out += '\\b';
                break;
            case Codepoint.CODES.get('\f'):
                // '\f'
                out += '\\f';
                break;
            default:
                {
                    let s = rune.toString(16);
                    if (rune < 0x100) {
                        out += '\\x';
                        if (s.length === 1) out += '0';
                        out += s;
                    } else out += `\\x{${s}}`;
                    break;
                }
        }
        return out;
    }
    // Returns the array of runes in the specified Java UTF-16 string.
    static stringToRunes(str) {
        return String(str).split('').map((s)=>s.codePointAt(0));
    }
    // Returns the Java UTF-16 string containing the single rune |r|.
    static runeToString(r) {
        return String.fromCodePoint(r);
    }
    // isWordRune reports whether r is consider a ``word character''
    // during the evaluation of the \b and \B zero-width assertions.
    // These assertions are ASCII-only: the word characters are [A-Za-z0-9_].
    static isWordRune(r) {
        return Codepoint.CODES.get('a') <= r && r <= Codepoint.CODES.get('z') || Codepoint.CODES.get('A') <= r && r <= Codepoint.CODES.get('Z') || Codepoint.CODES.get('0') <= r && r <= Codepoint.CODES.get('9') || r === Codepoint.CODES.get('_');
    }
    // emptyOpContext returns the zero-width assertions satisfied at the position
    // between the runes r1 and r2, a bitmask of EMPTY_* flags.
    // Passing r1 == -1 indicates that the position is at the beginning of the
    // text.
    // Passing r2 == -1 indicates that the position is at the end of the text.
    // eslint-disable-next-line no-warning-comments
    // TODO(adonovan): move to Machine.
    static emptyOpContext(r1, r2) {
        let op = 0;
        if (r1 < 0) op |= this.EMPTY_BEGIN_TEXT | this.EMPTY_BEGIN_LINE;
        if (r1 === Codepoint.CODES.get('\n')) op |= this.EMPTY_BEGIN_LINE;
        if (r2 < 0) op |= this.EMPTY_END_TEXT | this.EMPTY_END_LINE;
        if (r2 === Codepoint.CODES.get('\n')) op |= this.EMPTY_END_LINE;
        if (this.isWordRune(r1) !== this.isWordRune(r2)) op |= this.EMPTY_WORD_BOUNDARY;
        else op |= this.EMPTY_NO_WORD_BOUNDARY;
        return op;
    }
    /**
   * Returns a string that quotes all regular expression metacharacters inside the argument text;
   * the returned string is a regular expression matching the literal text. For example,
   * {@code quoteMeta("[foo]").equals("\\[foo\\]")}.
   * @param {string} s
   * @returns {string}
   */ static quoteMeta(str) {
        return str.split('') // A char loop is correct because all metacharacters fit in one UTF-16 code.
        .map((s)=>{
            if (this.METACHARACTERS.indexOf(s) >= 0) return `\\${s}`;
            return s;
        }).join('');
    }
    static charCount(codePoint) {
        return codePoint > Unicode.MAX_BMP ? 2 : 1;
    }
    static stringToUtf8ByteArray(str) {
        if (globalThis.TextEncoder) return Array.from(new TextEncoder().encode(str));
        else {
            // fallback, if no TextEncoder
            let out = [], p = 0;
            for(let i = 0; i < str.length; i++){
                let c = str.charCodeAt(i);
                if (c < 128) out[p++] = c;
                else if (c < 2048) {
                    out[p++] = c >> 6 | 192;
                    out[p++] = c & 63 | 128;
                } else if ((c & 0xfc00) === 0xd800 && i + 1 < str.length && (str.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
                    // Surrogate Pair
                    c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
                    out[p++] = c >> 18 | 240;
                    out[p++] = c >> 12 & 63 | 128;
                    out[p++] = c >> 6 & 63 | 128;
                    out[p++] = c & 63 | 128;
                } else {
                    out[p++] = c >> 12 | 224;
                    out[p++] = c >> 6 & 63 | 128;
                    out[p++] = c & 63 | 128;
                }
            }
            return out;
        }
    }
    static utf8ByteArrayToString(bytes) {
        if (globalThis.TextDecoder) return new TextDecoder('utf-8').decode(new Uint8Array(bytes));
        else {
            // fallback, if no TextDecoder
            let out = [], pos = 0, c = 0;
            while(pos < bytes.length){
                let c1 = bytes[pos++];
                if (c1 < 128) out[c++] = String.fromCharCode(c1);
                else if (c1 > 191 && c1 < 224) {
                    let c2 = bytes[pos++];
                    out[c++] = String.fromCharCode((c1 & 31) << 6 | c2 & 63);
                } else if (c1 > 239 && c1 < 365) {
                    // Surrogate Pair
                    let c2 = bytes[pos++];
                    let c3 = bytes[pos++];
                    let c4 = bytes[pos++];
                    let u = ((c1 & 7) << 18 | (c2 & 63) << 12 | (c3 & 63) << 6 | c4 & 63) - 0x10000;
                    out[c++] = String.fromCharCode(0xd800 + (u >> 10));
                    out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
                } else {
                    let c2 = bytes[pos++];
                    let c3 = bytes[pos++];
                    out[c++] = String.fromCharCode((c1 & 15) << 12 | (c2 & 63) << 6 | c3 & 63);
                }
            }
            return out.join('');
        }
    }
}
// helper to create enums
// example
// Encoding[(Encoding['UTF_16'] = 0)] = 'UTF_16'
// Encoding[(Encoding['UTF_8'] = 1)] = 'UTF_8'
const createEnum = (values = [], initNum = 0)=>{
    const enumObject = {};
    for(let i = 0; i < values.length; i++){
        const val = values[i];
        const keyVal = initNum + i;
        enumObject[val] = keyVal;
        enumObject[keyVal] = val;
    }
    return Object.freeze(enumObject);
};
/**
 * Abstract the representations of input text supplied to Matcher.
 */ class MatcherInputBase {
    static Encoding = (()=>createEnum([
            'UTF_16',
            'UTF_8'
        ]))();
    getEncoding() {
        throw Error('not implemented');
    }
    /**
   *
   * @returns {boolean}
   */ isUTF8Encoding() {
        return this.getEncoding() === MatcherInputBase.Encoding.UTF_8;
    }
    /**
   *
   * @returns {boolean}
   */ isUTF16Encoding() {
        return this.getEncoding() === MatcherInputBase.Encoding.UTF_16;
    }
}
class Utf8MatcherInput extends MatcherInputBase {
    constructor(bytes = null){
        super();
        this.bytes = bytes;
    }
    getEncoding() {
        return MatcherInputBase.Encoding.UTF_8;
    }
    /**
   *
   * @returns {string}
   */ asCharSequence() {
        return Utils.utf8ByteArrayToString(this.bytes);
    }
    /**
   *
   * @returns {number[]}
   */ asBytes() {
        return this.bytes;
    }
    /**
   *
   * @returns {number}
   */ length() {
        return this.bytes.length;
    }
}
class Utf16MatcherInput extends MatcherInputBase {
    constructor(charSequence = null){
        super();
        this.charSequence = charSequence;
    }
    getEncoding() {
        return MatcherInputBase.Encoding.UTF_16;
    }
    /**
   *
   * @returns {string}
   */ asCharSequence() {
        return this.charSequence;
    }
    /**
   *
   * @returns {number[]}
   */ asBytes() {
        return this.charSequence.toString().split('').map((s)=>s.codePointAt(0));
    }
    /**
   *
   * @returns {number}
   */ length() {
        return this.charSequence.length;
    }
}
class MatcherInput {
    /**
   * Return the MatcherInput for UTF_16 encoding.
   * @returns {Utf16MatcherInput}
   */ static utf16(charSequence) {
        return new Utf16MatcherInput(charSequence);
    }
    /**
   * Return the MatcherInput for UTF_8 encoding.
   * @returns {Utf8MatcherInput}
   */ static utf8(input) {
        if (Array.isArray(input)) return new Utf8MatcherInput(input);
        return new Utf8MatcherInput(Utils.stringToUtf8ByteArray(input));
    }
}
class RE2JSException extends Error {
    constructor(message){
        super(message);
        this.name = 'RE2JSException';
    }
}
/**
 * An exception thrown by the parser if the pattern was invalid.
 */ class RE2JSSyntaxException extends RE2JSException {
    constructor(error, input = null){
        let message = `error parsing regexp: ${error}`;
        if (input) message += `: \`${input}\``;
        super(message);
        this.name = 'RE2JSSyntaxException';
        this.message = message;
        this.error = error;
        this.input = input;
    }
    /**
   * Retrieves the description of the error.
   */ getDescription() {
        return this.error;
    }
    /**
   * Retrieves the erroneous regular-expression pattern.
   */ getPattern() {
        return this.input;
    }
}
/**
 * An exception thrown by the compiler
 */ class RE2JSCompileException extends RE2JSException {
    constructor(message){
        super(message);
        this.name = 'RE2JSCompileException';
    }
}
/**
 * An exception thrown by using groups
 */ class RE2JSGroupException extends RE2JSException {
    constructor(message){
        super(message);
        this.name = 'RE2JSGroupException';
    }
}
/**
 * An exception thrown by flags
 */ class RE2JSFlagsException extends RE2JSException {
    constructor(message){
        super(message);
        this.name = 'RE2JSFlagsException';
    }
}
/**
 * A stateful iterator that interprets a regex {@code RE2JS} on a specific input.
 *
 * Conceptually, a Matcher consists of four parts:
 * <ol>
 * <li>A compiled regular expression {@code RE2JS}, set at construction and fixed for the lifetime
 * of the matcher.</li>
 *
 * <li>The remainder of the input string, set at construction or {@link #reset()} and advanced by
 * each match operation such as {@link #find}, {@link #matches} or {@link #lookingAt}.</li>
 *
 * <li>The current match information, accessible via {@link #start}, {@link #end}, and
 * {@link #group}, and updated by each match operation.</li>
 *
 * <li>The append position, used and advanced by {@link #appendReplacement} and {@link #appendTail}
 * if performing a search and replace from the input to an external {@code StringBuffer}.
 *
 * </ol>
 *
 *
 * @author rsc@google.com (Russ Cox)
 */ class Matcher {
    /**
   * Quotes '\' and '$' in {@code s}, so that the returned string could be used in
   * {@link #appendReplacement} as a literal replacement of {@code s}.
   *
   * @param {string} str the string to be quoted
   * @returns {string} the quoted string
   */ static quoteReplacement(str) {
        if (str.indexOf('\\') < 0 && str.indexOf('$') < 0) return str;
        return str.split('').map((s)=>{
            const c = s.codePointAt(0);
            if (c === Codepoint.CODES['\\'] || c === Codepoint.CODES['$']) return `\\${s}`;
            return s;
        }).join('');
    }
    /**
   *
   * @param {RE2JS} pattern
   * @param {Utf8MatcherInput|Utf16MatcherInput|number[]|string} input
   */ constructor(pattern, input){
        if (pattern === null) throw new Error('pattern is null');
        // The pattern being matched.
        this.patternInput = pattern;
        const re2 = this.patternInput.re2();
        // The number of submatches (groups) in the pattern.
        this.patternGroupCount = re2.numberOfCapturingGroups();
        // The group indexes, in [start, end) pairs.  Zeroth pair is overall match.
        this.groups = [];
        this.namedGroups = re2.namedGroups;
        if (input instanceof MatcherInputBase) this.resetMatcherInput(input);
        else if (Array.isArray(input)) this.resetMatcherInput(MatcherInput.utf8(input));
        else this.resetMatcherInput(MatcherInput.utf16(input));
    }
    /**
   * Returns the {@code RE2JS} associated with this {@code Matcher}.
   * @returns {RE2JS}
   */ pattern() {
        return this.patternInput;
    }
    /**
   * Resets the {@code Matcher}, rewinding input and discarding any match information.
   *
   * @returns {Matcher} the {@code Matcher} itself, for chained method calls
   */ reset() {
        // The input length in UTF16 codes.
        this.matcherInputLength = this.matcherInput.length();
        // The append position: where the next append should start.
        this.appendPos = 0;
        // Is there a current match?
        this.hasMatch = false;
        // Have we found the submatches (groups) of the current match?
        // group[0], group[1] are set regardless.
        this.hasGroups = false;
        // The anchor flag to use when repeating the match to find subgroups.
        this.anchorFlag = 0;
        return this;
    }
    /**
   * Resets the {@code Matcher} and changes the input.
   * @returns {Matcher} the {@code Matcher} itself, for chained method calls
   */ resetMatcherInput(input) {
        if (input === null) throw new Error('input is null');
        this.matcherInput = input;
        this.reset();
        return this;
    }
    /**
   * Returns the start of the named group of the most recent match, or -1 if the group was not
   * matched.
   * @param {string|number} [group=0]
   * @returns {string}
   */ start(group = 0) {
        if (typeof group === 'string') {
            const groupInt = this.namedGroups[group];
            if (!Number.isFinite(groupInt)) throw new RE2JSGroupException(`group '${group}' not found`);
            group = groupInt;
        }
        this.loadGroup(group);
        return this.groups[2 * group];
    }
    /**
   * Returns the end of the named group of the most recent match, or -1 if the group was not
   * matched.
   * @param {string|number} [group=0]
   * @returns {string}
   */ end(group = 0) {
        if (typeof group === 'string') {
            const groupInt = this.namedGroups[group];
            if (!Number.isFinite(groupInt)) throw new RE2JSGroupException(`group '${group}' not found`);
            group = groupInt;
        }
        this.loadGroup(group);
        return this.groups[2 * group + 1];
    }
    /**
   * Returns the named group of the most recent match, or {@code null} if the group was not matched.
   * @param {string|number} [group=0]
   * @returns {string}
   */ group(group = 0) {
        if (typeof group === 'string') {
            const groupInt = this.namedGroups[group];
            if (!Number.isFinite(groupInt)) throw new RE2JSGroupException(`group '${group}' not found`);
            group = groupInt;
        }
        const start = this.start(group);
        const end = this.end(group);
        if (start < 0 && end < 0) return null;
        return this.substring(start, end);
    }
    /**
   * Returns the number of subgroups in this pattern.
   *
   * @returns {number} the number of subgroups; the overall match (group 0) does not count
   */ groupCount() {
        return this.patternGroupCount;
    }
    /**
   * Helper: finds subgroup information if needed for group.
   * @param {number} group
   * @private
   */ loadGroup(group) {
        if (group < 0 || group > this.patternGroupCount) throw new RE2JSGroupException(`Group index out of bounds: ${group}`);
        if (!this.hasMatch) throw new RE2JSGroupException('perhaps no match attempted');
        if (group === 0 || this.hasGroups) return;
        let end = this.groups[1] + 1;
        if (end > this.matcherInputLength) end = this.matcherInputLength;
        const res = this.patternInput.re2().matchMachineInput(this.matcherInput, this.groups[0], end, this.anchorFlag, 1 + this.patternGroupCount);
        const ok = res[0];
        if (!ok) throw new RE2JSGroupException('inconsistency in matching group data');
        this.groups = res[1];
        this.hasGroups = true;
    }
    /**
   * Matches the entire input against the pattern (anchored start and end). If there is a match,
   * {@code matches} sets the match state to describe it.
   *
   * @returns {boolean} true if the entire input matches the pattern
   */ matches() {
        return this.genMatch(0, RE2Flags.ANCHOR_BOTH);
    }
    /**
   * Matches the beginning of input against the pattern (anchored start). If there is a match,
   * {@code lookingAt} sets the match state to describe it.
   *
   * @returns {boolean} true if the beginning of the input matches the pattern
   */ lookingAt() {
        return this.genMatch(0, RE2Flags.ANCHOR_START);
    }
    /**
   * Matches the input against the pattern (unanchored), starting at a specified position. If there
   * is a match, {@code find} sets the match state to describe it.
   *
   * @param {string|number} [start=null] the input position where the search begins
   * @returns {boolean} if it finds a match
   * @throws IndexOutOfBoundsException if start is not a valid input position
   */ find(start = null) {
        if (start !== null) {
            if (start < 0 || start > this.matcherInputLength) throw new RE2JSGroupException(`start index out of bounds: ${start}`);
            this.reset();
            return this.genMatch(start, 0);
        }
        // no start
        start = 0;
        if (this.hasMatch) {
            start = this.groups[1];
            if (this.groups[0] === this.groups[1]) start++;
        }
        return this.genMatch(start, RE2Flags.UNANCHORED);
    }
    /**
   * Helper: does match starting at start, with RE2 anchor flag.
   * @param {number} startByte
   * @param {number} anchor
   * @returns {boolean}
   * @private
   */ genMatch(startByte, anchor) {
        const res = this.patternInput.re2().matchMachineInput(this.matcherInput, startByte, this.matcherInputLength, anchor, 1);
        const ok = res[0];
        if (!ok) return false;
        this.groups = res[1];
        this.hasMatch = true;
        this.hasGroups = false;
        this.anchorFlag = anchor;
        return true;
    }
    /**
   * Helper: return substring for [start, end).
   * @param {number} start
   * @param {number} end
   * @returns {string}
   */ substring(start, end) {
        if (this.matcherInput.isUTF8Encoding()) return Utils.utf8ByteArrayToString(this.matcherInput.asBytes().slice(start, end));
        return this.matcherInput.asCharSequence().substring(start, end).toString();
    }
    /**
   * Helper for Pattern: return input length.
   * @returns {number}
   */ inputLength() {
        return this.matcherInputLength;
    }
    /**
   * Appends to result two strings: the text from the append position up to the beginning of the
   * most recent match, and then the replacement with submatch groups substituted for references of
   * the form {@code $n}, where {@code n} is the group number in decimal. It advances the append
   * position to where the most recent match ended.
   *
   * To embed a literal {@code $}, use \$ (actually {@code "\\$"} with string escapes). The escape
   * is only necessary when {@code $} is followed by a digit, but it is always allowed. Only
   * {@code $} and {@code \} need escaping, but any character can be escaped.
   *
   * The group number {@code n} in {@code $n} is always at least one digit and expands to use more
   * digits as long as the resulting number is a valid group number for this pattern. To cut it off
   * earlier, escape the first digit that should not be used.
   *
   * @param {string} replacement the replacement string
   * @param {boolean} [perlMode=false] activate perl/js mode (different behaviour for capture groups and special characters)
   * @returns {string}
   * @throws IllegalStateException if there was no most recent match
   * @throws IndexOutOfBoundsException if replacement refers to an invalid group
   * @private
   */ appendReplacement(replacement, perlMode = false) {
        let res = '';
        const s = this.start();
        const e = this.end();
        if (this.appendPos < s) res += this.substring(this.appendPos, s);
        this.appendPos = e;
        res += perlMode ? this.appendReplacementInternalPerl(replacement) : this.appendReplacementInternal(replacement);
        return res;
    }
    /**
   * @param {string} replacement - the replacement string
   * @returns {string}
   * @private
   */ appendReplacementInternal(replacement) {
        let res = '';
        let last = 0;
        const m = replacement.length;
        for(let i = 0; i < m - 1; i++){
            if (replacement.codePointAt(i) === Codepoint.CODES.get('\\')) {
                if (last < i) res += replacement.substring(last, i);
                i++;
                last = i;
                continue;
            }
            if (replacement.codePointAt(i) === Codepoint.CODES.get('$')) {
                let c = replacement.codePointAt(i + 1);
                if (Codepoint.CODES.get('0') <= c && c <= Codepoint.CODES.get('9')) {
                    let n = c - Codepoint.CODES.get('0');
                    if (last < i) res += replacement.substring(last, i);
                    for(i += 2; i < m; i++){
                        c = replacement.codePointAt(i);
                        if (c < Codepoint.CODES.get('0') || c > Codepoint.CODES.get('9') || n * 10 + c - Codepoint.CODES.get('0') > this.patternGroupCount) break;
                        n = n * 10 + c - Codepoint.CODES.get('0');
                    }
                    if (n > this.patternGroupCount) throw new RE2JSGroupException(`n > number of groups: ${n}`);
                    const group = this.group(n);
                    if (group !== null) res += group;
                    last = i;
                    i--;
                    continue;
                } else if (c === Codepoint.CODES.get('{')) {
                    if (last < i) res += replacement.substring(last, i);
                    i++;
                    let j = i + 1;
                    while(j < replacement.length && replacement.codePointAt(j) !== Codepoint.CODES.get('}') && replacement.codePointAt(j) !== Codepoint.CODES.get(' '))j++;
                    if (j === replacement.length || replacement.codePointAt(j) !== Codepoint.CODES.get('}')) throw new RE2JSGroupException("named capture group is missing trailing '}'");
                    const groupName = replacement.substring(i + 1, j);
                    res += this.group(groupName);
                    last = j + 1;
                }
            }
        }
        if (last < m) res += replacement.substring(last, m);
        return res;
    }
    /**
   * @param {string} replacement - the replacement string
   * @returns {string}
   * @private
   */ appendReplacementInternalPerl(replacement) {
        let res = '';
        let last = 0;
        const m = replacement.length;
        for(let i = 0; i < m - 1; i++)if (replacement.codePointAt(i) === Codepoint.CODES.get('$')) {
            let c = replacement.codePointAt(i + 1);
            if (Codepoint.CODES.get('$') === c) {
                if (last < i) res += replacement.substring(last, i);
                res += '$';
                i++;
                last = i + 1;
                continue;
            } else if (Codepoint.CODES.get('&') === c) {
                if (last < i) res += replacement.substring(last, i);
                const group = this.group(0);
                if (group !== null) res += group;
                else res += '$&';
                i++;
                last = i + 1;
                continue;
            } else if (Codepoint.CODES.get('1') <= c && c <= Codepoint.CODES.get('9')) {
                let n = c - Codepoint.CODES.get('0');
                if (last < i) res += replacement.substring(last, i);
                for(i += 2; i < m; i++){
                    c = replacement.codePointAt(i);
                    if (c < Codepoint.CODES.get('0') || c > Codepoint.CODES.get('9') || n * 10 + c - Codepoint.CODES.get('0') > this.patternGroupCount) break;
                    n = n * 10 + c - Codepoint.CODES.get('0');
                }
                if (n > this.patternGroupCount) {
                    res += `$${n}`;
                    last = i;
                    i--;
                    continue;
                }
                const group = this.group(n);
                if (group !== null) res += group;
                last = i;
                i--;
                continue;
            } else if (c === Codepoint.CODES.get('<')) {
                if (last < i) res += replacement.substring(last, i);
                i++;
                let j = i + 1;
                while(j < replacement.length && replacement.codePointAt(j) !== Codepoint.CODES.get('>') && replacement.codePointAt(j) !== Codepoint.CODES.get(' '))j++;
                if (j === replacement.length || replacement.codePointAt(j) !== Codepoint.CODES.get('>')) {
                    res += replacement.substring(i - 1, j + 1);
                    last = j + 1;
                    continue;
                }
                const groupName = replacement.substring(i + 1, j);
                if (Object.prototype.hasOwnProperty.call(this.namedGroups, groupName)) res += this.group(groupName);
                else res += `$<${groupName}>`;
                last = j + 1;
            }
        }
        if (last < m) res += replacement.substring(last, m);
        return res;
    }
    /**
   * Return the substring of the input from the append position to the end of the
   * input.
   * @returns {string}
   */ appendTail() {
        return this.substring(this.appendPos, this.matcherInputLength);
    }
    /**
   * Returns the input with all matches replaced by {@code replacement}, interpreted as for
   * {@code appendReplacement}.
   *
   * @param {string} replacement - the replacement string
   * @param {boolean} [perlMode=false] - activate perl/js mode (different behaviour for capture groups and special characters)
   * @returns {string} the input string with the matches replaced
   * @throws IndexOutOfBoundsException if replacement refers to an invalid group and perlMode is false
   */ replaceAll(replacement, perlMode = false) {
        return this.replace(replacement, true, perlMode);
    }
    /**
   * Returns the input with the first match replaced by {@code replacement}, interpreted as for
   * {@code appendReplacement}.
   *
   * @param {string} replacement - the replacement string
   * @param {boolean} [perlMode=false] - activate perl/js mode (different behaviour for capture groups and special characters)
   * @returns {string} the input string with the first match replaced
   * @throws IndexOutOfBoundsException if replacement refers to an invalid group and perlMode is false
   */ replaceFirst(replacement, perlMode = false) {
        return this.replace(replacement, false, perlMode);
    }
    /**
   * Helper: replaceAll/replaceFirst hybrid.
   * @param {string} replacement - the replacement string
   * @param {boolean} [all=true] - replace all matches
   * @param {boolean} [perlMode=false] - activate perl/js mode (different behaviour for capture groups and special characters)
   * @returns {string}
   * @private
   */ replace(replacement, all = true, perlMode = false) {
        let res = '';
        this.reset();
        while(this.find()){
            res += this.appendReplacement(replacement, perlMode);
            if (!all) break;
        }
        res += this.appendTail();
        return res;
    }
}
/**
 * MachineInput abstracts different representations of the input text supplied to the Machine. It
 * provides one-character lookahead.
 */ class MachineInputBase {
    static EOF() {
        return -8;
    }
    // can we look ahead without losing info?
    canCheckPrefix() {
        return true;
    }
    // Returns the end position in the same units as step().
    endPos() {
        return this.end;
    }
}
// An implementation of MachineInput for UTF-8 byte arrays.
// |pos| and |width| are byte indices.
class MachineUTF8Input extends MachineInputBase {
    constructor(bytes, start = 0, end = bytes.length){
        super();
        this.bytes = bytes;
        this.start = start;
        this.end = end;
    }
    // Returns the rune at the specified index; the units are
    // unspecified, but could be UTF-8 byte, UTF-16 char, or rune
    // indices.  Returns the width (in the same units) of the rune in
    // the lower 3 bits, and the rune (Unicode code point) in the high
    // bits.  Never negative, except for EOF which is represented as -1
    // << 3 | 0.
    step(i) {
        i += this.start;
        if (i >= this.end) return MachineInputBase.EOF();
        let x = this.bytes[i++] & 255;
        if ((x & 128) === 0) return x << 3 | 1;
        else if ((x & 224) === 192) {
            x = x & 31;
            if (i >= this.end) return MachineInputBase.EOF();
            x = x << 6 | this.bytes[i++] & 63;
            return x << 3 | 2;
        } else if ((x & 240) === 224) {
            x = x & 15;
            if (i + 1 >= this.end) return MachineInputBase.EOF();
            x = x << 6 | this.bytes[i++] & 63;
            x = x << 6 | this.bytes[i++] & 63;
            return x << 3 | 3;
        } else {
            x = x & 7;
            if (i + 2 >= this.end) return MachineInputBase.EOF();
            x = x << 6 | this.bytes[i++] & 63;
            x = x << 6 | this.bytes[i++] & 63;
            x = x << 6 | this.bytes[i++] & 63;
            return x << 3 | 4;
        }
    }
    // Returns the index relative to |pos| at which |re2.prefix| is found
    // in this input stream, or a negative value if not found.
    index(re2, pos) {
        pos += this.start;
        const i = this.indexOf(this.bytes, re2.prefixUTF8, pos);
        return i < 0 ? i : i - pos;
    }
    // Returns a bitmask of EMPTY_* flags.
    context(pos) {
        pos += this.start;
        let r1 = -1;
        if (pos > this.start && pos <= this.end) {
            let start = pos - 1;
            r1 = this.bytes[start--];
            if (r1 >= 128) {
                let lim = pos - 4;
                if (lim < this.start) lim = this.start;
                while(start >= lim && (this.bytes[start] & 192) === 128)start--;
                if (start < this.start) start = this.start;
                r1 = this.step(start) >> 3;
            }
        }
        const r2 = pos < this.end ? this.step(pos) >> 3 : -1;
        return Utils.emptyOpContext(r1, r2);
    }
    // Returns the index of the first occurrence of array |target| within
    // array |source| after |fromIndex|, or -1 if not found.
    indexOf(source, target, fromIndex = 0) {
        let targetLength = target.length;
        if (targetLength === 0) return -1;
        let sourceLength = source.length;
        for(let i = fromIndex; i <= sourceLength - targetLength; i++)for(let j = 0; j < targetLength; j++){
            if (source[i + j] !== target[j]) break;
            else if (j === targetLength - 1) return i;
        }
        return -1;
    }
}
// |pos| and |width| are in JS "char" units.
class MachineUTF16Input extends MachineInputBase {
    constructor(charSequence, start = 0, end = charSequence.length){
        super();
        this.charSequence = charSequence;
        this.start = start;
        this.end = end;
    }
    // Returns the rune at the specified index; the units are
    // unspecified, but could be UTF-8 byte, UTF-16 char, or rune
    // indices.  Returns the width (in the same units) of the rune in
    // the lower 3 bits, and the rune (Unicode code point) in the high
    // bits.  Never negative, except for EOF which is represented as -1
    // << 3 | 0.
    step(pos) {
        pos += this.start;
        if (pos < this.end) {
            const rune = this.charSequence.codePointAt(pos);
            return rune << 3 | Utils.charCount(rune);
        } else return MachineInputBase.EOF();
    }
    // Returns the index relative to |pos| at which |re2.prefix| is found
    // in this input stream, or a negative value if not found.
    index(re2, pos) {
        pos += this.start;
        const i = this.charSequence.indexOf(re2.prefix, pos);
        return i < 0 ? i : i - pos;
    }
    // Returns a bitmask of EMPTY_* flags.
    context(pos) {
        pos += this.start;
        const r1 = pos > 0 && pos <= this.charSequence.length ? this.charSequence.codePointAt(pos - 1) : -1;
        const r2 = pos < this.charSequence.length ? this.charSequence.codePointAt(pos) : -1;
        return Utils.emptyOpContext(r1, r2);
    }
}
class MachineInput {
    static fromUTF8(bytes, start = 0, end = bytes.length) {
        return new MachineUTF8Input(bytes, start, end);
    }
    static fromUTF16(charSequence, start = 0, end = charSequence.length) {
        return new MachineUTF16Input(charSequence, start, end);
    }
}
/**
 * Regular expression abstract syntax tree. Produced by parser, used by compiler. NB, this
 * corresponds to {@code syntax.regexp} in the Go implementation; Go's {@code regexp} is called
 * {@code RE2} in Java.
 */ class Regexp {
    static Op = (()=>createEnum([
            'NO_MATCH',
            // Matches no strings.
            'EMPTY_MATCH',
            // Matches empty string.
            'LITERAL',
            // Matches runes[] sequence
            'CHAR_CLASS',
            // Matches Runes interpreted as range pair list
            'ANY_CHAR_NOT_NL',
            // Matches any character except '\n'
            'ANY_CHAR',
            // Matches any character
            'BEGIN_LINE',
            // Matches empty string at end of line
            'END_LINE',
            // Matches empty string at end of line
            'BEGIN_TEXT',
            // Matches empty string at beginning of text
            'END_TEXT',
            // Matches empty string at end of text
            'WORD_BOUNDARY',
            // Matches word boundary `\b`
            'NO_WORD_BOUNDARY',
            // Matches word non-boundary `\B`
            'CAPTURE',
            // Capturing subexpr with index cap, optional name name
            'STAR',
            // Matches subs[0] zero or more times.
            'PLUS',
            // Matches subs[0] one or more times.
            'QUEST',
            // Matches subs[0] zero or one times.
            'REPEAT',
            // Matches subs[0] [min, max] times; max=-1 => no limit.
            'CONCAT',
            // Matches concatenation of subs[]
            'ALTERNATE',
            // Matches union of subs[]
            // Pseudo ops, used internally by Parser for parsing stack:
            'LEFT_PAREN',
            'VERTICAL_BAR'
        ]))();
    static isPseudoOp(op) {
        return op >= Regexp.Op.LEFT_PAREN;
    }
    static emptySubs() {
        return [];
    }
    static quoteIfHyphen(rune) {
        if (rune === Codepoint.CODES.get('-')) return '\\';
        return '';
    }
    static fromRegexp(re) {
        const regex = new Regexp(re.op);
        regex.flags = re.flags;
        regex.subs = re.subs;
        regex.runes = re.runes;
        regex.cap = re.cap;
        regex.min = re.min;
        regex.max = re.max;
        regex.name = re.name;
        regex.namedGroups = re.namedGroups;
        return regex;
    }
    constructor(op){
        this.op = op; // operator
        this.flags = 0; // bitmap of parse flags
        // subexpressions, if any.  Never null.
        // subs[0] is used as the freelist.
        this.subs = Regexp.emptySubs();
        this.runes = null; // matched runes, for LITERAL, CHAR_CLASS
        this.min = 0; // min for REPEAT
        this.max = 0; // max for REPEAT
        this.cap = 0; // capturing index, for CAPTURE
        this.name = null; // capturing name, for CAPTURE
        this.namedGroups = {}; // map of group name -> capturing index
    }
    reinit() {
        this.flags = 0;
        this.subs = Regexp.emptySubs();
        this.runes = null;
        this.cap = 0;
        this.min = 0;
        this.max = 0;
        this.name = null;
        this.namedGroups = {};
    }
    toString() {
        return this.appendTo();
    }
    // appendTo() appends the Perl syntax for |this| regular expression to out
    appendTo() {
        let out = '';
        switch(this.op){
            case Regexp.Op.NO_MATCH:
                out += '[^\\x00-\\x{10FFFF}]';
                break;
            case Regexp.Op.EMPTY_MATCH:
                out += '(?:)';
                break;
            case Regexp.Op.STAR:
            case Regexp.Op.PLUS:
            case Regexp.Op.QUEST:
            case Regexp.Op.REPEAT:
                {
                    const sub = this.subs[0];
                    if (sub.op > Regexp.Op.CAPTURE || sub.op === Regexp.Op.LITERAL && sub.runes.length > 1) out += `(?:${sub.appendTo()})`;
                    else out += sub.appendTo();
                    switch(this.op){
                        case Regexp.Op.STAR:
                            out += '*';
                            break;
                        case Regexp.Op.PLUS:
                            out += '+';
                            break;
                        case Regexp.Op.QUEST:
                            out += '?';
                            break;
                        case Regexp.Op.REPEAT:
                            out += `{${this.min}`;
                            if (this.min !== this.max) {
                                out += ',';
                                if (this.max >= 0) out += this.max;
                            }
                            out += '}';
                            break;
                    }
                    if ((this.flags & RE2Flags.NON_GREEDY) !== 0) out += '?';
                    break;
                }
            case Regexp.Op.CONCAT:
                for (let sub of this.subs)if (sub.op === Regexp.Op.ALTERNATE) out += `(?:${sub.appendTo()})`;
                else out += sub.appendTo();
                break;
            case Regexp.Op.ALTERNATE:
                {
                    let sep = '';
                    for (let sub of this.subs){
                        out += sep;
                        sep = '|';
                        out += sub.appendTo();
                    }
                    break;
                }
            case Regexp.Op.LITERAL:
                if ((this.flags & RE2Flags.FOLD_CASE) !== 0) out += '(?i:';
                for (let rune of this.runes)out += Utils.escapeRune(rune);
                if ((this.flags & RE2Flags.FOLD_CASE) !== 0) out += ')';
                break;
            case Regexp.Op.ANY_CHAR_NOT_NL:
                out += '(?-s:.)';
                break;
            case Regexp.Op.ANY_CHAR:
                out += '(?s:.)';
                break;
            case Regexp.Op.CAPTURE:
                if (this.name === null || this.name.length === 0) out += '(';
                else out += `(?P<${this.name}>`;
                if (this.subs[0].op !== Regexp.Op.EMPTY_MATCH) out += this.subs[0].appendTo();
                out += ')';
                break;
            case Regexp.Op.BEGIN_TEXT:
                out += '\\A';
                break;
            case Regexp.Op.END_TEXT:
                if ((this.flags & RE2Flags.WAS_DOLLAR) !== 0) out += '(?-m:$)';
                else out += '\\z';
                break;
            case Regexp.Op.BEGIN_LINE:
                out += '^';
                break;
            case Regexp.Op.END_LINE:
                out += '$';
                break;
            case Regexp.Op.WORD_BOUNDARY:
                out += '\\b';
                break;
            case Regexp.Op.NO_WORD_BOUNDARY:
                out += '\\B';
                break;
            case Regexp.Op.CHAR_CLASS:
                if (this.runes.length % 2 !== 0) {
                    out += '[invalid char class]';
                    break;
                }
                out += '[';
                if (this.runes.length === 0) out += '^\\x00-\\x{10FFFF}';
                else if (this.runes[0] === 0 && this.runes[this.runes.length - 1] === Unicode.MAX_RUNE) {
                    out += '^';
                    for(let i = 1; i < this.runes.length - 1; i += 2){
                        const lo = this.runes[i] + 1;
                        const hi = this.runes[i + 1] - 1;
                        out += Regexp.quoteIfHyphen(lo);
                        out += Utils.escapeRune(lo);
                        if (lo !== hi) {
                            out += '-';
                            out += Regexp.quoteIfHyphen(hi);
                            out += Utils.escapeRune(hi);
                        }
                    }
                } else for(let i = 0; i < this.runes.length; i += 2){
                    const lo = this.runes[i];
                    const hi = this.runes[i + 1];
                    out += Regexp.quoteIfHyphen(lo);
                    out += Utils.escapeRune(lo);
                    if (lo !== hi) {
                        out += '-';
                        out += Regexp.quoteIfHyphen(hi);
                        out += Utils.escapeRune(hi);
                    }
                }
                out += ']';
                break;
            default:
                out += this.op;
                break;
        }
        return out;
    }
    // maxCap() walks the regexp to find the maximum capture index.
    maxCap() {
        let m = 0;
        if (this.op === Regexp.Op.CAPTURE) m = this.cap;
        if (this.subs !== null) for (let sub of this.subs){
            const n = sub.maxCap();
            if (m < n) m = n;
        }
        return m;
    }
    // equals() returns true if this and that have identical structure.
    equals(that) {
        if (!(that !== null && that instanceof Regexp)) return false;
        if (this.op !== that.op) return false;
        switch(this.op){
            case Regexp.Op.END_TEXT:
                if ((this.flags & RE2Flags.WAS_DOLLAR) !== (that.flags & RE2Flags.WAS_DOLLAR)) return false;
                break;
            case Regexp.Op.LITERAL:
            case Regexp.Op.CHAR_CLASS:
                if (this.runes === null && that.runes === null) break;
                if (this.runes === null || that.runes === null) return false;
                if (this.runes.length !== that.runes.length) return false;
                for(let i = 0; i < this.runes.length; i++){
                    if (this.runes[i] !== that.runes[i]) return false;
                }
                break;
            case Regexp.Op.ALTERNATE:
            case Regexp.Op.CONCAT:
                if (this.subs.length !== that.subs.length) return false;
                for(let i = 0; i < this.subs.length; ++i){
                    if (!this.subs[i].equals(that.subs[i])) return false;
                }
                break;
            case Regexp.Op.STAR:
            case Regexp.Op.PLUS:
            case Regexp.Op.QUEST:
                if ((this.flags & RE2Flags.NON_GREEDY) !== (that.flags & RE2Flags.NON_GREEDY) || !this.subs[0].equals(that.subs[0])) return false;
                break;
            case Regexp.Op.REPEAT:
                if ((this.flags & RE2Flags.NON_GREEDY) !== (that.flags & RE2Flags.NON_GREEDY) || this.min !== that.min || this.max !== that.max || !this.subs[0].equals(that.subs[0])) return false;
                break;
            case Regexp.Op.CAPTURE:
                if (this.cap !== that.cap || (this.name === null ? that.name !== null : this.name !== that.name) || !this.subs[0].equals(that.subs[0])) return false;
                break;
        }
        return true;
    }
}
/**
 * A single instruction in the regular expression virtual machine.
 *
 * @see http://swtch.com/~rsc/regexp/regexp2.html
 */ class Inst {
    static ALT = 1;
    static ALT_MATCH = 2;
    static CAPTURE = 3;
    static EMPTY_WIDTH = 4;
    static FAIL = 5;
    static MATCH = 6;
    static NOP = 7;
    static RUNE = 8;
    static RUNE1 = 9;
    static RUNE_ANY = 10;
    static RUNE_ANY_NOT_NL = 11;
    static isRuneOp(op) {
        return Inst.RUNE <= op && op <= Inst.RUNE_ANY_NOT_NL;
    }
    // Returns an RE2 expression matching exactly |runes|.
    static escapeRunes(runes) {
        let out = '"';
        for (let rune of runes)out += Utils.escapeRune(rune);
        out += '"';
        return out;
    }
    constructor(op){
        this.op = op;
        this.out = 0; // all but MATCH, FAIL
        this.arg = 0; // ALT, ALT_MATCH, CAPTURE, EMPTY_WIDTH
        // length==1 => exact match
        // otherwise a list of [lo,hi] pairs.  hi is *inclusive*.
        this.runes = null;
    }
    // MatchRune returns true if the instruction matches (and consumes) r.
    // It should only be called when op == InstRune.
    matchRune(r) {
        // Special case: single-rune slice is from literal string, not char
        // class.
        if (this.runes.length === 1) {
            const r0 = this.runes[0];
            // If this pattern is case-insensitive, apply Unicode case folding to compare the two runes.
            // Note that this may result in a case-folding loop when executed,
            // so attempt to reduce the chance of that occurring
            // by performing case folding on |r0| from the pattern rather than |r| from the input.
            if ((this.arg & RE2Flags.FOLD_CASE) !== 0) return Unicode.equalsIgnoreCase(r0, r);
            return r === r0;
        }
        // Peek at the first few pairs.
        // Should handle ASCII well.
        for(let j = 0; j < this.runes.length && j <= 8; j += 2){
            if (r < this.runes[j]) return false;
            if (r <= this.runes[j + 1]) return true;
        }
        // Otherwise binary search.
        let lo = 0;
        let hi = this.runes.length / 2 | 0;
        while(lo < hi){
            const m = lo + ((hi - lo) / 2 | 0);
            const c = this.runes[2 * m];
            if (c <= r) {
                if (r <= this.runes[2 * m + 1]) return true;
                lo = m + 1;
            } else hi = m;
        }
        return false;
    }
    /**
   *
   * @returns {string}
   */ toString() {
        switch(this.op){
            case Inst.ALT:
                return `alt -> ${this.out}, ${this.arg}`;
            case Inst.ALT_MATCH:
                return `altmatch -> ${this.out}, ${this.arg}`;
            case Inst.CAPTURE:
                return `cap ${this.arg} -> ${this.out}`;
            case Inst.EMPTY_WIDTH:
                return `empty ${this.arg} -> ${this.out}`;
            case Inst.MATCH:
                return 'match';
            case Inst.FAIL:
                return 'fail';
            case Inst.NOP:
                return `nop -> ${this.out}`;
            case Inst.RUNE:
                if (this.runes === null) return 'rune <null>';
                return [
                    'rune ',
                    Inst.escapeRunes(this.runes),
                    (this.arg & RE2Flags.FOLD_CASE) !== 0 ? '/i' : '',
                    ' -> ',
                    this.out
                ].join('');
            case Inst.RUNE1:
                return `rune1 ${Inst.escapeRunes(this.runes)} -> ${this.out}`;
            case Inst.RUNE_ANY:
                return `any -> ${this.out}`;
            case Inst.RUNE_ANY_NOT_NL:
                return `anynotnl -> ${this.out}`;
            default:
                throw new Error('unhandled case in Inst.toString');
        }
    }
}
/**
 * A Prog is a compiled regular expression program.
 */ class Prog {
    constructor(){
        this.inst = [];
        this.start = 0; // index of start instruction
        // number of CAPTURE insts in re
        // 2 => implicit ( and ) for whole match $0
        this.numCap = 2;
    }
    // Returns the instruction at the specified pc.
    // Precondition: pc > 0 && pc < numInst().
    getInst(pc) {
        return this.inst[pc];
    }
    // Returns the number of instructions in this program.
    numInst() {
        return this.inst.length;
    }
    // Adds a new instruction to this program, with operator |op| and |pc| equal
    // to |numInst()|.
    addInst(op) {
        this.inst.push(new Inst(op));
    }
    // skipNop() follows any no-op or capturing instructions and returns the
    // resulting instruction.
    skipNop(pc) {
        let i = this.inst[pc];
        while(i.op === Inst.NOP || i.op === Inst.CAPTURE){
            i = this.inst[pc];
            pc = i.out;
        }
        return i;
    }
    // prefix() returns a pair of a literal string that all matches for the
    // regexp must start with, and a boolean which is true if the prefix is the
    // entire match.  The string is returned by appending to |prefix|.
    prefix() {
        let prefix = '';
        let i = this.skipNop(this.start);
        if (!Inst.isRuneOp(i.op) || i.runes.length !== 1) return [
            i.op === Inst.MATCH,
            prefix
        ];
        while(Inst.isRuneOp(i.op) && i.runes.length === 1 && (i.arg & RE2Flags.FOLD_CASE) === 0){
            prefix += String.fromCodePoint(i.runes[0]);
            i = this.skipNop(i.out);
        }
        return [
            i.op === Inst.MATCH,
            prefix
        ];
    }
    // startCond() returns the leading empty-width conditions that must be true
    // in any match.  It returns -1 (all bits set) if no matches are possible.
    startCond() {
        let flag = 0;
        let pc = this.start;
        loop: for(;;){
            const i = this.inst[pc];
            switch(i.op){
                case Inst.EMPTY_WIDTH:
                    flag |= i.arg;
                    break;
                case Inst.FAIL:
                    return -1;
                case Inst.CAPTURE:
                case Inst.NOP:
                    break;
                default:
                    break loop;
            }
            pc = i.out;
        }
        return flag;
    }
    // --- Patch list ---
    // A patchlist is a list of instruction pointers that need to be filled in
    // (patched).  Because the pointers haven't been filled in yet, we can reuse
    // their storage to hold the list.  It's kind of sleazy, but works well in
    // practice.  See http://swtch.com/~rsc/regexp/regexp1.html for inspiration.
    // These aren't really pointers: they're integers, so we can reinterpret them
    // this way without using package unsafe.  A value l denotes p.inst[l>>1].out
    // (l&1==0) or .arg (l&1==1).  l == 0 denotes the empty list, okay because we
    // start every program with a fail instruction, so we'll never want to point
    // at its output link.
    next(l) {
        const i = this.inst[l >> 1];
        if ((l & 1) === 0) return i.out;
        return i.arg;
    }
    patch(l, val) {
        while(l !== 0){
            const i = this.inst[l >> 1];
            if ((l & 1) === 0) {
                l = i.out;
                i.out = val;
            } else {
                l = i.arg;
                i.arg = val;
            }
        }
    }
    append(l1, l2) {
        if (l1 === 0) return l2;
        if (l2 === 0) return l1;
        let last = l1;
        for(;;){
            const next = this.next(last);
            if (next === 0) break;
            last = next;
        }
        const i = this.inst[last >> 1];
        if ((last & 1) === 0) i.out = l2;
        else i.arg = l2;
        return l1;
    }
    /**
   *
   * @returns {string}
   */ toString() {
        let out = '';
        for(let pc = 0; pc < this.inst.length; pc++){
            const len = out.length;
            out += pc;
            if (pc === this.start) out += '*';
            out += '        '.substring(out.length - len);
            out += this.inst[pc];
            out += '\n';
        }
        return out;
    }
}
/**
 * A fragment of a compiled regular expression program.
 *
 * @see http://swtch.com/~rsc/regexp/regexp1.html
 * @class
 */ class Frag {
    constructor(i = 0, out = 0, nullable = false){
        this.i = i; // an instruction address (pc).
        this.out = out; // a patch list; see explanation in Prog.js
        this.nullable = nullable; // whether the fragment can match the empty string
    }
}
/**
 * Compiler from {@code Regexp} (RE2 abstract syntax) to {@code RE2} (compiled regular expression).
 *
 * The only entry point is {@link #compileRegexp}.
 */ class Compiler {
    static ANY_RUNE_NOT_NL() {
        return [
            0,
            Codepoint.CODES.get('\n') - 1,
            Codepoint.CODES.get('\n') + 1,
            Unicode.MAX_RUNE
        ];
    }
    static ANY_RUNE() {
        return [
            0,
            Unicode.MAX_RUNE
        ];
    }
    static compileRegexp(re) {
        const c = new Compiler();
        const f = c.compile(re);
        c.prog.patch(f.out, c.newInst(Inst.MATCH).i);
        c.prog.start = f.i;
        return c.prog;
    }
    constructor(){
        this.prog = new Prog();
        this.newInst(Inst.FAIL);
    }
    newInst(op) {
        this.prog.addInst(op);
        return new Frag(this.prog.numInst() - 1, 0, true);
    }
    // Returns a no-op fragment.  Sometimes unavoidable.
    nop() {
        const f = this.newInst(Inst.NOP);
        f.out = f.i << 1;
        return f;
    }
    fail() {
        return new Frag();
    }
    // Given fragment a, returns (a) capturing as \n.
    // Given a fragment a, returns a fragment with capturing parens around a.
    cap(arg) {
        const f = this.newInst(Inst.CAPTURE);
        f.out = f.i << 1;
        this.prog.getInst(f.i).arg = arg;
        if (this.prog.numCap < arg + 1) this.prog.numCap = arg + 1;
        return f;
    }
    // Given fragments a and b, returns ab; a|b
    cat(f1, f2) {
        // concat of failure is failure
        if (f1.i === 0 || f2.i === 0) return this.fail();
        // eslint-disable-next-line no-warning-comments
        // TODO(rsc): elide nop
        this.prog.patch(f1.out, f2.i);
        return new Frag(f1.i, f2.out, f1.nullable && f2.nullable);
    }
    // Given fragments for a and b, returns fragment for a|b.
    alt(f1, f2) {
        // alt of failure is other
        if (f1.i === 0) return f2;
        if (f2.i === 0) return f1;
        const f = this.newInst(Inst.ALT);
        const i = this.prog.getInst(f.i);
        i.out = f1.i;
        i.arg = f2.i;
        f.out = this.prog.append(f1.out, f2.out);
        f.nullable = f1.nullable || f2.nullable;
        return f;
    }
    // loop returns the fragment for the main loop of a plus or star.
    // For plus, it can be used directly. with f1.i as the entry.
    // For star, it can be used directly when f1 can't match an empty string.
    // (When f1 can match an empty string, f1* must be implemented as (f1+)?
    // to get the priority match order correct.)
    loop(f1, nongreedy) {
        const f = this.newInst(Inst.ALT);
        const i = this.prog.getInst(f.i);
        if (nongreedy) {
            i.arg = f1.i;
            f.out = f.i << 1;
        } else {
            i.out = f1.i;
            f.out = f.i << 1 | 1;
        }
        this.prog.patch(f1.out, f.i);
        return f;
    }
    // Given a fragment for a, returns a fragment for a? or a?? (if nongreedy)
    quest(f1, nongreedy) {
        const f = this.newInst(Inst.ALT);
        const i = this.prog.getInst(f.i);
        if (nongreedy) {
            i.arg = f1.i;
            f.out = f.i << 1;
        } else {
            i.out = f1.i;
            f.out = f.i << 1 | 1;
        }
        f.out = this.prog.append(f.out, f1.out);
        return f;
    }
    // Given a fragment a, returns a fragment for a* or a*? (if nongreedy)
    star(f1, nongreedy) {
        if (f1.nullable) return this.quest(this.plus(f1, nongreedy), nongreedy);
        return this.loop(f1, nongreedy);
    }
    // Given a fragment for a, returns a fragment for a+ or a+? (if nongreedy)
    plus(f1, nongreedy) {
        return new Frag(f1.i, this.loop(f1, nongreedy).out, f1.nullable);
    }
    // op is a bitmask of EMPTY_* flags.
    empty(op) {
        const f = this.newInst(Inst.EMPTY_WIDTH);
        this.prog.getInst(f.i).arg = op;
        f.out = f.i << 1;
        return f;
    }
    // flags : parser flags
    rune(runes, flags) {
        const f = this.newInst(Inst.RUNE);
        f.nullable = false;
        const i = this.prog.getInst(f.i);
        i.runes = runes;
        flags &= RE2Flags.FOLD_CASE;
        if (runes.length !== 1 || Unicode.simpleFold(runes[0]) === runes[0]) flags &= ~RE2Flags.FOLD_CASE;
        i.arg = flags;
        f.out = f.i << 1;
        if ((flags & RE2Flags.FOLD_CASE) === 0 && runes.length === 1 || runes.length === 2 && runes[0] === runes[1]) i.op = Inst.RUNE1;
        else if (runes.length === 2 && runes[0] === 0 && runes[1] === Unicode.MAX_RUNE) i.op = Inst.RUNE_ANY;
        else if (runes.length === 4 && runes[0] === 0 && runes[1] === Codepoint.CODES.get('\n') - 1 && runes[2] === Codepoint.CODES.get('\n') + 1 && runes[3] === Unicode.MAX_RUNE) i.op = Inst.RUNE_ANY_NOT_NL;
        return f;
    }
    compile(re) {
        switch(re.op){
            case Regexp.Op.NO_MATCH:
                return this.fail();
            case Regexp.Op.EMPTY_MATCH:
                return this.nop();
            case Regexp.Op.LITERAL:
                if (re.runes.length === 0) return this.nop();
                else {
                    let f = null;
                    for (let r of re.runes){
                        const f1 = this.rune([
                            r
                        ], re.flags);
                        f = f === null ? f1 : this.cat(f, f1);
                    }
                    return f;
                }
            case Regexp.Op.CHAR_CLASS:
                return this.rune(re.runes, re.flags);
            case Regexp.Op.ANY_CHAR_NOT_NL:
                return this.rune(Compiler.ANY_RUNE_NOT_NL(), 0);
            case Regexp.Op.ANY_CHAR:
                return this.rune(Compiler.ANY_RUNE(), 0);
            case Regexp.Op.BEGIN_LINE:
                return this.empty(Utils.EMPTY_BEGIN_LINE);
            case Regexp.Op.END_LINE:
                return this.empty(Utils.EMPTY_END_LINE);
            case Regexp.Op.BEGIN_TEXT:
                return this.empty(Utils.EMPTY_BEGIN_TEXT);
            case Regexp.Op.END_TEXT:
                return this.empty(Utils.EMPTY_END_TEXT);
            case Regexp.Op.WORD_BOUNDARY:
                return this.empty(Utils.EMPTY_WORD_BOUNDARY);
            case Regexp.Op.NO_WORD_BOUNDARY:
                return this.empty(Utils.EMPTY_NO_WORD_BOUNDARY);
            case Regexp.Op.CAPTURE:
                {
                    const bra = this.cap(re.cap << 1);
                    const sub = this.compile(re.subs[0]);
                    const ket = this.cap(re.cap << 1 | 1);
                    return this.cat(this.cat(bra, sub), ket);
                }
            case Regexp.Op.STAR:
                return this.star(this.compile(re.subs[0]), (re.flags & RE2Flags.NON_GREEDY) !== 0);
            case Regexp.Op.PLUS:
                return this.plus(this.compile(re.subs[0]), (re.flags & RE2Flags.NON_GREEDY) !== 0);
            case Regexp.Op.QUEST:
                return this.quest(this.compile(re.subs[0]), (re.flags & RE2Flags.NON_GREEDY) !== 0);
            case Regexp.Op.CONCAT:
                if (re.subs.length === 0) return this.nop();
                else {
                    let f = null;
                    for (let sub of re.subs){
                        const f1 = this.compile(sub);
                        f = f === null ? f1 : this.cat(f, f1);
                    }
                    return f;
                }
            case Regexp.Op.ALTERNATE:
                if (re.subs.length === 0) return this.nop();
                else {
                    let f = null;
                    for (let sub of re.subs){
                        const f1 = this.compile(sub);
                        f = f === null ? f1 : this.alt(f, f1);
                    }
                    return f;
                }
            default:
                throw new RE2JSCompileException('regexp: unhandled case in compile');
        }
    }
}
class Simplify {
    // Simplify returns a regexp equivalent to re but without counted
    // repetitions and with various other simplifications, such as
    // rewriting /(?:a+)+/ to /a+/.  The resulting regexp will execute
    // correctly but its string representation will not produce the same
    // parse tree, because capturing parentheses may have been duplicated
    // or removed.  For example, the simplified form for /(x){1,2}/ is
    // /(x)(x)?/ but both parentheses capture as $1.  The returned regexp
    // may share structure with or be the original.
    static simplify(re) {
        if (re === null) return null;
        switch(re.op){
            case Regexp.Op.CAPTURE:
            case Regexp.Op.CONCAT:
            case Regexp.Op.ALTERNATE:
                {
                    let nre = re;
                    for(let i = 0; i < re.subs.length; i++){
                        const sub = re.subs[i];
                        const nsub = Simplify.simplify(sub);
                        if (nre === re && nsub !== sub) {
                            nre = Regexp.fromRegexp(re);
                            nre.runes = null;
                            nre.subs = re.subs.slice(0, re.subs.length);
                        }
                        if (nre !== re) nre.subs[i] = nsub;
                    }
                    return nre;
                }
            case Regexp.Op.STAR:
            case Regexp.Op.PLUS:
            case Regexp.Op.QUEST:
                {
                    const sub = Simplify.simplify(re.subs[0]);
                    return Simplify.simplify1(re.op, re.flags, sub, re);
                }
            case Regexp.Op.REPEAT:
                {
                    // Special special case: x{0} matches the empty string
                    // and doesn't even need to consider x.
                    if (re.min === 0 && re.max === 0) return new Regexp(Regexp.Op.EMPTY_MATCH);
                    // The fun begins.
                    const sub = Simplify.simplify(re.subs[0]);
                    // x{n,} means at least n matches of x.
                    if (re.max === -1) {
                        // Special case: x{0,} is x*.
                        if (re.min === 0) return Simplify.simplify1(Regexp.Op.STAR, re.flags, sub, null);
                        // Special case: x{1,} is x+.
                        if (re.min === 1) return Simplify.simplify1(Regexp.Op.PLUS, re.flags, sub, null);
                        // General case: x{4,} is xxxx+.
                        const nre = new Regexp(Regexp.Op.CONCAT);
                        const subs = [];
                        for(let i = 0; i < re.min - 1; i++)subs.push(sub);
                        subs.push(Simplify.simplify1(Regexp.Op.PLUS, re.flags, sub, null));
                        nre.subs = subs.slice(0);
                        return nre;
                    }
                    // Special case x{0} handled above.
                    // Special case: x{1} is just x.
                    if (re.min === 1 && re.max === 1) return sub;
                    // General case: x{n,m} means n copies of x and m copies of x?
                    // The machine will do less work if we nest the final m copies,
                    // so that x{2,5} = xx(x(x(x)?)?)?
                    // Build leading prefix: xx.
                    let prefixSubs = null;
                    if (re.min > 0) {
                        prefixSubs = [];
                        for(let i = 0; i < re.min; i++)prefixSubs.push(sub);
                    }
                    // Build and attach suffix: (x(x(x)?)?)?
                    if (re.max > re.min) {
                        let suffix = Simplify.simplify1(Regexp.Op.QUEST, re.flags, sub, null);
                        for(let i = re.min + 1; i < re.max; i++){
                            const nre2 = new Regexp(Regexp.Op.CONCAT);
                            nre2.subs = [
                                sub,
                                suffix
                            ];
                            suffix = Simplify.simplify1(Regexp.Op.QUEST, re.flags, nre2, null);
                        }
                        if (prefixSubs === null) return suffix;
                        prefixSubs.push(suffix);
                    }
                    if (prefixSubs !== null) {
                        const prefix = new Regexp(Regexp.Op.CONCAT);
                        prefix.subs = prefixSubs.slice(0);
                        return prefix;
                    }
                    // Some degenerate case like min > max or min < max < 0.
                    // Handle as impossible match.
                    return new Regexp(Regexp.Op.NO_MATCH);
                }
        }
        return re;
    }
    // simplify1 implements Simplify for the unary OpStar,
    // OpPlus, and OpQuest operators.  It returns the simple regexp
    // equivalent to
    //
    //      Regexp{Op: op, Flags: flags, Sub: {sub}}
    //
    // under the assumption that sub is already simple, and
    // without first allocating that structure.  If the regexp
    // to be returned turns out to be equivalent to re, simplify1
    // returns re instead.
    //
    // simplify1 is factored out of Simplify because the implementation
    // for other operators generates these unary expressions.
    // Letting them call simplify1 makes sure the expressions they
    // generate are simple.
    static simplify1(op, flags, sub, re) {
        // Special case: repeat the empty string as much as
        // you want, but it's still the empty string.
        if (sub.op === Regexp.Op.EMPTY_MATCH) return sub;
        // The operators are idempotent if the flags match.
        if (op === sub.op && (flags & RE2Flags.NON_GREEDY) === (sub.flags & RE2Flags.NON_GREEDY)) return sub;
        if (re !== null && re.op === op && (re.flags & RE2Flags.NON_GREEDY) === (flags & RE2Flags.NON_GREEDY) && sub === re.subs[0]) return re;
        re = new Regexp(op);
        re.flags = flags;
        re.subs = [
            sub
        ];
        return re;
    }
}
// GENERATED BY tools/scripts/make_perl_groups.pl; DO NOT EDIT.
// ./tools/scripts/make_perl_groups.pl  > src/CharGroup.js
class CharGroup {
    constructor(sign, cls){
        this.sign = sign;
        this.cls = cls;
    }
}
const code1 = [
    0x30,
    0x39
];
const code2 = [
    0x9,
    0xa,
    0xc,
    0xd,
    0x20,
    0x20
];
const code3 = [
    0x30,
    0x39,
    0x41,
    0x5a,
    0x5f,
    0x5f,
    0x61,
    0x7a
];
const PERL_GROUPS = new Map([
    [
        '\\d',
        new CharGroup(1, code1)
    ],
    [
        '\\D',
        new CharGroup(-1, code1)
    ],
    [
        '\\s',
        new CharGroup(1, code2)
    ],
    [
        '\\S',
        new CharGroup(-1, code2)
    ],
    [
        '\\w',
        new CharGroup(1, code3)
    ],
    [
        '\\W',
        new CharGroup(-1, code3)
    ]
]);
const code4 = [
    0x30,
    0x39,
    0x41,
    0x5a,
    0x61,
    0x7a
];
const code5 = [
    0x41,
    0x5a,
    0x61,
    0x7a
];
const code6 = [
    0x0,
    0x7f
];
const code7 = [
    0x9,
    0x9,
    0x20,
    0x20
];
const code8 = [
    0x0,
    0x1f,
    0x7f,
    0x7f
];
const code9 = [
    0x30,
    0x39
];
const code10 = [
    0x21,
    0x7e
];
const code11 = [
    0x61,
    0x7a
];
const code12 = [
    0x20,
    0x7e
];
const code13 = [
    0x21,
    0x2f,
    0x3a,
    0x40,
    0x5b,
    0x60,
    0x7b,
    0x7e
];
const code14 = [
    0x9,
    0xd,
    0x20,
    0x20
];
const code15 = [
    0x41,
    0x5a
];
const code16 = [
    0x30,
    0x39,
    0x41,
    0x5a,
    0x5f,
    0x5f,
    0x61,
    0x7a
];
const code17 = [
    0x30,
    0x39,
    0x41,
    0x46,
    0x61,
    0x66
];
const POSIX_GROUPS = new Map([
    [
        '[:alnum:]',
        new CharGroup(1, code4)
    ],
    [
        '[:^alnum:]',
        new CharGroup(-1, code4)
    ],
    [
        '[:alpha:]',
        new CharGroup(1, code5)
    ],
    [
        '[:^alpha:]',
        new CharGroup(-1, code5)
    ],
    [
        '[:ascii:]',
        new CharGroup(1, code6)
    ],
    [
        '[:^ascii:]',
        new CharGroup(-1, code6)
    ],
    [
        '[:blank:]',
        new CharGroup(1, code7)
    ],
    [
        '[:^blank:]',
        new CharGroup(-1, code7)
    ],
    [
        '[:cntrl:]',
        new CharGroup(1, code8)
    ],
    [
        '[:^cntrl:]',
        new CharGroup(-1, code8)
    ],
    [
        '[:digit:]',
        new CharGroup(1, code9)
    ],
    [
        '[:^digit:]',
        new CharGroup(-1, code9)
    ],
    [
        '[:graph:]',
        new CharGroup(1, code10)
    ],
    [
        '[:^graph:]',
        new CharGroup(-1, code10)
    ],
    [
        '[:lower:]',
        new CharGroup(1, code11)
    ],
    [
        '[:^lower:]',
        new CharGroup(-1, code11)
    ],
    [
        '[:print:]',
        new CharGroup(1, code12)
    ],
    [
        '[:^print:]',
        new CharGroup(-1, code12)
    ],
    [
        '[:punct:]',
        new CharGroup(1, code13)
    ],
    [
        '[:^punct:]',
        new CharGroup(-1, code13)
    ],
    [
        '[:space:]',
        new CharGroup(1, code14)
    ],
    [
        '[:^space:]',
        new CharGroup(-1, code14)
    ],
    [
        '[:upper:]',
        new CharGroup(1, code15)
    ],
    [
        '[:^upper:]',
        new CharGroup(-1, code15)
    ],
    [
        '[:word:]',
        new CharGroup(1, code16)
    ],
    [
        '[:^word:]',
        new CharGroup(-1, code16)
    ],
    [
        '[:xdigit:]',
        new CharGroup(1, code17)
    ],
    [
        '[:^xdigit:]',
        new CharGroup(-1, code17)
    ]
]);
/**
 * A "builder"-style helper class for manipulating character classes represented as an array of
 * pairs of runes [lo, hi], each denoting an inclusive interval.
 *
 * All methods mutate the internal state and return {@code this}, allowing operations to be chained.
 */ class CharClass {
    // Exposed, since useful for debugging CharGroups too.
    static charClassToString(r, len) {
        let result = '[';
        for(let i = 0; i < len; i += 2){
            if (i > 0) result += ' ';
            const lo = r[i];
            const hi = r[i + 1];
            if (lo === hi) result += `0x${lo.toString(16)}`;
            else result += `0x${lo.toString(16)}-0x${hi.toString(16)}`;
        }
        result += ']';
        return result;
    }
    // cmp() returns the ordering of the pair (a[i], a[i+1]) relative to
    // (pivotFrom, pivotTo), where the first component of the pair (lo) is
    // ordered naturally and the second component (hi) is in reverse order.
    static cmp(array, i, pivotFrom, pivotTo) {
        const cmp = array[i] - pivotFrom;
        return cmp !== 0 ? cmp : pivotTo - array[i + 1];
    }
    // qsortIntPair() quicksorts pairs of ints in |array| according to lt().
    // Precondition: |left|, |right|, |this.len| must all be even; |this.len > 1|.
    static qsortIntPair(array, left, right) {
        const pivotIndex = ((left + right) / 2 | 0) & -2;
        const pivotFrom = array[pivotIndex];
        const pivotTo = array[pivotIndex + 1];
        let i = left;
        let j = right;
        while(i <= j){
            while(i < right && CharClass.cmp(array, i, pivotFrom, pivotTo) < 0)i += 2;
            while(j > left && CharClass.cmp(array, j, pivotFrom, pivotTo) > 0)j -= 2;
            if (i <= j) {
                if (i !== j) {
                    let temp = array[i];
                    array[i] = array[j];
                    array[j] = temp;
                    temp = array[i + 1];
                    array[i + 1] = array[j + 1];
                    array[j + 1] = temp;
                }
                i += 2;
                j -= 2;
            }
        }
        if (left < j) CharClass.qsortIntPair(array, left, j);
        if (i < right) CharClass.qsortIntPair(array, i, right);
    }
    constructor(r = Utils.emptyInts()){
        this.r = r; // inclusive ranges, pairs of [lo,hi].  r.length is even.
        this.len = r.length; // prefix of |r| that is defined.  Even.
    }
    // Returns the character class as an int array.  Subsequent CharClass
    // operations may mutate this array, so typically this is the last operation
    // performed on a given CharClass instance.
    toArray() {
        if (this.len === this.r.length) return this.r;
        else return this.r.slice(0, this.len);
    }
    // cleanClass() sorts the ranges (pairs of elements) of this CharClass,
    // merges them, and eliminates duplicates.
    cleanClass() {
        if (this.len < 4) return this;
        // Sort by lo increasing, hi decreasing to break ties.
        CharClass.qsortIntPair(this.r, 0, this.len - 2);
        // Merge abutting, overlapping.
        let w = 2; // write index
        for(let i = 2; i < this.len; i += 2){
            const lo = this.r[i];
            const hi = this.r[i + 1];
            if (lo <= this.r[w - 1] + 1) {
                // merge with previous range
                if (hi > this.r[w - 1]) this.r[w - 1] = hi;
                continue;
            }
            // new disjoint range
            this.r[w] = lo;
            this.r[w + 1] = hi;
            w += 2;
        }
        this.len = w;
        return this;
    }
    // appendLiteral() appends the literal |x| to this CharClass.
    appendLiteral(x, flags) {
        return (flags & RE2Flags.FOLD_CASE) !== 0 ? this.appendFoldedRange(x, x) : this.appendRange(x, x);
    }
    // appendRange() appends the range [lo-hi] (inclusive) to this CharClass.
    appendRange(lo, hi) {
        // Expand last range or next to last range if it overlaps or abuts.
        // Checking two ranges helps when appending case-folded
        // alphabets, so that one range can be expanding A-Z and the
        // other expanding a-z.
        if (this.len > 0) {
            for(let i = 2; i <= 4; i += 2)// twice, using i=2, i=4
            if (this.len >= i) {
                const rlo = this.r[this.len - i];
                const rhi = this.r[this.len - i + 1];
                if (lo <= rhi + 1 && rlo <= hi + 1) {
                    if (lo < rlo) this.r[this.len - i] = lo;
                    if (hi > rhi) this.r[this.len - i + 1] = hi;
                    return this;
                }
            }
        }
        this.r[this.len++] = lo;
        this.r[this.len++] = hi;
        return this;
    }
    // appendFoldedRange() appends the range [lo-hi] and its case
    // folding-equivalent runes to this CharClass.
    appendFoldedRange(lo, hi) {
        // Optimizations.
        if (lo <= Unicode.MIN_FOLD && hi >= Unicode.MAX_FOLD) // Range is full: folding can't add more.
        return this.appendRange(lo, hi);
        if (hi < Unicode.MIN_FOLD || lo > Unicode.MAX_FOLD) // Range is outside folding possibilities.
        return this.appendRange(lo, hi);
        if (lo < Unicode.MIN_FOLD) {
            // [lo, minFold-1] needs no folding.
            this.appendRange(lo, Unicode.MIN_FOLD - 1);
            lo = Unicode.MIN_FOLD;
        }
        if (hi > Unicode.MAX_FOLD) {
            // [maxFold+1, hi] needs no folding.
            this.appendRange(Unicode.MAX_FOLD + 1, hi);
            hi = Unicode.MAX_FOLD;
        }
        // Brute force.  Depend on appendRange to coalesce ranges on the fly.
        for(let c = lo; c <= hi; c++){
            this.appendRange(c, c);
            for(let f = Unicode.simpleFold(c); f !== c; f = Unicode.simpleFold(f))this.appendRange(f, f);
        }
        return this;
    }
    // appendClass() appends the class |x| to this CharClass.
    // It assumes |x| is clean.  Does not mutate |x|.
    appendClass(x) {
        for(let i = 0; i < x.length; i += 2)this.appendRange(x[i], x[i + 1]);
        return this;
    }
    // appendFoldedClass() appends the case folding of the class |x| to this
    // CharClass.  Does not mutate |x|.
    appendFoldedClass(x) {
        for(let i = 0; i < x.length; i += 2)this.appendFoldedRange(x[i], x[i + 1]);
        return this;
    }
    // appendNegatedClass() append the negation of the class |x| to this
    // CharClass.  It assumes |x| is clean.  Does not mutate |x|.
    appendNegatedClass(x) {
        let nextLo = 0;
        for(let i = 0; i < x.length; i += 2){
            const lo = x[i];
            const hi = x[i + 1];
            if (nextLo <= lo - 1) this.appendRange(nextLo, lo - 1);
            nextLo = hi + 1;
        }
        if (nextLo <= Unicode.MAX_RUNE) this.appendRange(nextLo, Unicode.MAX_RUNE);
        return this;
    }
    // appendTable() appends the Unicode range table |table| to this CharClass.
    // Does not mutate |table|.
    appendTable(table) {
        for (let triple of table){
            const lo = triple[0];
            const hi = triple[1];
            const stride = triple[2];
            if (stride === 1) {
                this.appendRange(lo, hi);
                continue;
            }
            for(let c = lo; c <= hi; c += stride)this.appendRange(c, c);
        }
        return this;
    }
    // appendNegatedTable() returns the result of appending the negation of range
    // table |table| to this CharClass.  Does not mutate |table|.
    appendNegatedTable(table) {
        let nextLo = 0;
        for (let triple of table){
            const lo = triple[0];
            const hi = triple[1];
            const stride = triple[2];
            if (stride === 1) {
                if (nextLo <= lo - 1) this.appendRange(nextLo, lo - 1);
                nextLo = hi + 1;
                continue;
            }
            for(let c = lo; c <= hi; c += stride){
                if (nextLo <= c - 1) this.appendRange(nextLo, c - 1);
                nextLo = c + 1;
            }
        }
        if (nextLo <= Unicode.MAX_RUNE) this.appendRange(nextLo, Unicode.MAX_RUNE);
        return this;
    }
    // appendTableWithSign() calls append{,Negated}Table depending on sign.
    // Does not mutate |table|.
    appendTableWithSign(table, sign) {
        return sign < 0 ? this.appendNegatedTable(table) : this.appendTable(table);
    }
    // negateClass() negates this CharClass, which must already be clean.
    negateClass() {
        let nextLo = 0; // lo end of next class to add
        let w = 0; // write index
        for(let i = 0; i < this.len; i += 2){
            const lo = this.r[i];
            const hi = this.r[i + 1];
            if (nextLo <= lo - 1) {
                this.r[w] = nextLo;
                this.r[w + 1] = lo - 1;
                w += 2;
            }
            nextLo = hi + 1;
        }
        this.len = w;
        if (nextLo <= Unicode.MAX_RUNE) {
            this.r[this.len++] = nextLo;
            this.r[this.len++] = Unicode.MAX_RUNE;
        }
        return this;
    }
    // appendClassWithSign() calls appendClass() if sign is +1 or
    // appendNegatedClass if sign is -1.  Does not mutate |x|.
    appendClassWithSign(x, sign) {
        return sign < 0 ? this.appendNegatedClass(x) : this.appendClass(x);
    }
    // appendGroup() appends CharGroup |g| to this CharClass, folding iff
    // |foldCase|.  Does not mutate |g|.
    appendGroup(g, foldCase) {
        let cls = g.cls;
        if (foldCase) cls = new CharClass().appendFoldedClass(cls).cleanClass().toArray();
        return this.appendClassWithSign(cls, g.sign);
    }
    toString() {
        return CharClass.charClassToString(this.r, this.len);
    }
}
class Pair {
    static of(first, second) {
        return new Pair(first, second);
    }
    constructor(first, second){
        this.first = first;
        this.second = second;
    }
}
// StringIterator: a stream of runes with an opaque cursor, permitting
// rewinding.  The units of the cursor are not specified beyond the
// fact that ASCII characters are single width.  (Cursor positions
// could be UTF-8 byte indices, UTF-16 code indices or rune indices.)
//
// In particular, be careful with:
// - skip: only use this to advance over ASCII characters
//   since these always have a width of 1.
// - skipString: only use this to advance over strings which are
//   known to be at the current position, e.g. due to prior call to
//   lookingAt().
// Only use pop() to advance over possibly non-ASCII runes.
class StringIterator {
    constructor(str){
        this.str = str;
        this.position = 0;
    }
    // Returns the cursor position.  Do not interpret the result!
    pos() {
        return this.position;
    }
    // Resets the cursor position to a previous value returned by pos().
    rewindTo(pos) {
        this.position = pos;
    }
    // Returns true unless the stream is exhausted.
    more() {
        return this.position < this.str.length;
    }
    // Returns the rune at the cursor position.
    // Precondition: |more()|.
    peek() {
        return this.str.codePointAt(this.position);
    }
    // Advances the cursor by |n| positions, which must be ASCII runes.
    //
    // (In practise, this is only ever used to skip over regexp
    // metacharacters that are ASCII, so there is no numeric difference
    // between indices into  UTF-8 bytes, UTF-16 codes and runes.)
    skip(n) {
        this.position += n;
    }
    // Advances the cursor by the number of cursor positions in |s|.
    skipString(s) {
        this.position += s.length;
    }
    // Returns the rune at the cursor position, and advances the cursor
    // past it.  Precondition: |more()|.
    pop() {
        const r = this.str.codePointAt(this.position);
        this.position += Utils.charCount(r);
        return r;
    }
    lookingAt(s) {
        return this.rest().startsWith(s);
    }
    // Returns the rest of the pattern as a Java UTF-16 string.
    rest() {
        return this.str.substring(this.position);
    }
    // Returns the substring from |beforePos| to the current position.
    // |beforePos| must have been previously returned by |pos()|.
    from(beforePos) {
        return this.str.substring(beforePos, this.position);
    }
    toString() {
        return this.rest();
    }
}
/**
 * A parser of regular expression patterns.
 *
 * The only public entry point is {@link #parse(String pattern, int flags)}.
 */ class Parser {
    // Unexpected error
    static ERR_INTERNAL_ERROR = 'regexp/syntax: internal error';
    // Parse errors
    static ERR_INVALID_CHAR_RANGE = 'invalid character class range';
    static ERR_INVALID_ESCAPE = 'invalid escape sequence';
    static ERR_INVALID_NAMED_CAPTURE = 'invalid named capture';
    static ERR_INVALID_PERL_OP = 'invalid or unsupported Perl syntax';
    static ERR_INVALID_REPEAT_OP = 'invalid nested repetition operator';
    static ERR_INVALID_REPEAT_SIZE = 'invalid repeat count';
    static ERR_MISSING_BRACKET = 'missing closing ]';
    static ERR_MISSING_PAREN = 'missing closing )';
    static ERR_MISSING_REPEAT_ARGUMENT = 'missing argument to repetition operator';
    static ERR_TRAILING_BACKSLASH = 'trailing backslash at end of expression';
    static ERR_DUPLICATE_NAMED_CAPTURE = 'duplicate capture group name';
    // RangeTables are represented as int[][], a list of triples (start, end,
    // stride).
    static ANY_TABLE() {
        return [
            [
                0,
                Unicode.MAX_RUNE,
                1
            ]
        ];
    }
    // unicodeTable() returns the Unicode RangeTable identified by name
    // and the table of additional fold-equivalent code points.
    // Returns null if |name| does not identify a Unicode character range.
    static unicodeTable(name) {
        if (name === 'Any') return Pair.of(Parser.ANY_TABLE(), Parser.ANY_TABLE());
        if (UnicodeTables.CATEGORIES.has(name)) return Pair.of(UnicodeTables.CATEGORIES.get(name), UnicodeTables.FOLD_CATEGORIES.get(name));
        if (UnicodeTables.SCRIPTS.has(name)) return Pair.of(UnicodeTables.SCRIPTS.get(name), UnicodeTables.FOLD_SCRIPT.get(name));
        return null;
    }
    // minFoldRune returns the minimum rune fold-equivalent to r.
    static minFoldRune(r) {
        if (r < Unicode.MIN_FOLD || r > Unicode.MAX_FOLD) return r;
        let min = r;
        const r0 = r;
        for(r = Unicode.simpleFold(r); r !== r0; r = Unicode.simpleFold(r))if (min > r) min = r;
        return min;
    }
    // leadingRegexp returns the leading regexp that re begins with.
    // The regexp refers to storage in re or its children.
    static leadingRegexp(re) {
        if (re.op === Regexp.Op.EMPTY_MATCH) return null;
        if (re.op === Regexp.Op.CONCAT && re.subs.length > 0) {
            const sub = re.subs[0];
            if (sub.op === Regexp.Op.EMPTY_MATCH) return null;
            return sub;
        }
        return re;
    }
    static literalRegexp(s, flags) {
        const re = new Regexp(Regexp.Op.LITERAL);
        re.flags = flags;
        re.runes = Utils.stringToRunes(s);
        return re;
    }
    /**
   * Parse regular expression pattern {@code pattern} with mode flags {@code flags}.
   * @param {string} pattern
   * @param {number} flags
   */ static parse(pattern, flags) {
        return new Parser(pattern, flags).parseInternal();
    }
    // parseRepeat parses {min} (max=min) or {min,} (max=-1) or {min,max}.
    // If |t| is not of that form, it returns -1.
    // If |t| has the right form but the values are negative or too big,
    // it returns -2.
    // On success, returns a nonnegative number encoding min/max in the
    // high/low signed halfwords of the result.  (Note: min >= 0; max may
    // be -1.)
    //
    // On success, advances |t| beyond the repeat; otherwise |t.pos()| is
    // undefined.
    static parseRepeat(t) {
        const start = t.pos();
        if (!t.more() || !t.lookingAt('{')) return -1;
        t.skip(1);
        const min = Parser.parseInt(t);
        if (min === -1) return -1;
        if (!t.more()) return -1;
        let max;
        if (!t.lookingAt(',')) max = min;
        else {
            t.skip(1);
            if (!t.more()) return -1;
            if (t.lookingAt('}')) max = -1;
            else if ((max = Parser.parseInt(t)) === -1) return -1;
        }
        if (!t.more() || !t.lookingAt('}')) return -1;
        t.skip(1);
        if (min < 0 || min > 1000 || max === -2 || max > 1000 || max >= 0 && min > max) throw new RE2JSSyntaxException(Parser.ERR_INVALID_REPEAT_SIZE, t.from(start));
        return min << 16 | max & Unicode.MAX_BMP;
    }
    // isValidCaptureName reports whether name
    // is a valid capture name: [A-Za-z0-9_]+.
    // PCRE limits names to 32 bytes.
    // Python rejects names starting with digits.
    // We don't enforce either of those.
    static isValidCaptureName(name) {
        if (name.length === 0) return false;
        for(let i = 0; i < name.length; i++){
            const c = name.codePointAt(i);
            if (c !== Codepoint.CODES.get('_') && !Utils.isalnum(c)) return false;
        }
        return true;
    }
    // parseInt parses a nonnegative decimal integer.
    // -1 => bad format.  -2 => format ok, but integer overflow.
    static parseInt(t) {
        const start = t.pos();
        while(t.more() && t.peek() >= Codepoint.CODES.get('0') && t.peek() <= Codepoint.CODES.get('9'))t.skip(1);
        const n = t.from(start);
        if (n.length === 0 || n.length > 1 && n.codePointAt(0) === Codepoint.CODES.get('0')) return -1;
        if (n.length > 8) return -2;
        return parseFloat(n, 10);
    }
    // can this be represented as a character class?
    // single-rune literal string, char class, ., and .|\n.
    static isCharClass(re) {
        return re.op === Regexp.Op.LITERAL && re.runes.length === 1 || re.op === Regexp.Op.CHAR_CLASS || re.op === Regexp.Op.ANY_CHAR_NOT_NL || re.op === Regexp.Op.ANY_CHAR;
    }
    // does re match r?
    static matchRune(re, r) {
        switch(re.op){
            case Regexp.Op.LITERAL:
                return re.runes.length === 1 && re.runes[0] === r;
            case Regexp.Op.CHAR_CLASS:
                for(let i = 0; i < re.runes.length; i += 2){
                    if (re.runes[i] <= r && r <= re.runes[i + 1]) return true;
                }
                return false;
            case Regexp.Op.ANY_CHAR_NOT_NL:
                return r !== Codepoint.CODES.get('\n');
            case Regexp.Op.ANY_CHAR:
                return true;
        }
        return false;
    }
    // mergeCharClass makes dst = dst|src.
    // The caller must ensure that dst.Op >= src.Op,
    // to reduce the amount of copying.
    static mergeCharClass(dst, src) {
        switch(dst.op){
            case Regexp.Op.ANY_CHAR:
                break;
            case Regexp.Op.ANY_CHAR_NOT_NL:
                if (Parser.matchRune(src, Codepoint.CODES.get('\n'))) dst.op = Regexp.Op.ANY_CHAR;
                break;
            case Regexp.Op.CHAR_CLASS:
                if (src.op === Regexp.Op.LITERAL) dst.runes = new CharClass(dst.runes).appendLiteral(src.runes[0], src.flags).toArray();
                else dst.runes = new CharClass(dst.runes).appendClass(src.runes).toArray();
                break;
            case Regexp.Op.LITERAL:
                if (src.runes[0] === dst.runes[0] && src.flags === dst.flags) break;
                dst.op = Regexp.Op.CHAR_CLASS;
                dst.runes = new CharClass().appendLiteral(dst.runes[0], dst.flags).appendLiteral(src.runes[0], src.flags).toArray();
                break;
        }
    }
    // parseEscape parses an escape sequence at the beginning of s
    // and returns the rune.
    // Pre: t at '\\'.  Post: after escape.
    static parseEscape(t) {
        const startPos = t.pos();
        t.skip(1); // '\\'
        if (!t.more()) throw new RE2JSSyntaxException(Parser.ERR_TRAILING_BACKSLASH);
        let c = t.pop();
        bigswitch: switch(c){
            case Codepoint.CODES.get('1'):
            case Codepoint.CODES.get('2'):
            case Codepoint.CODES.get('3'):
            case Codepoint.CODES.get('4'):
            case Codepoint.CODES.get('5'):
            case Codepoint.CODES.get('6'):
            case Codepoint.CODES.get('7'):
                if (!t.more() || t.peek() < Codepoint.CODES.get('0') || t.peek() > Codepoint.CODES.get('7')) break;
            // eslint-disable-next-line no-fallthrough
            case Codepoint.CODES.get('0'):
                {
                    let r = c - Codepoint.CODES.get('0');
                    for(let i = 1; i < 3; i++){
                        if (!t.more() || t.peek() < Codepoint.CODES.get('0') || t.peek() > Codepoint.CODES.get('7')) break;
                        r = r * 8 + t.peek() - Codepoint.CODES.get('0');
                        t.skip(1);
                    }
                    return r;
                }
            case Codepoint.CODES.get('x'):
                {
                    if (!t.more()) break;
                    c = t.pop();
                    if (c === Codepoint.CODES.get('{')) {
                        let nhex = 0;
                        let r = 0;
                        // eslint-disable-next-line no-constant-condition
                        while(true){
                            if (!t.more()) break bigswitch;
                            c = t.pop();
                            if (c === Codepoint.CODES.get('}')) break;
                            const v = Utils.unhex(c);
                            if (v < 0) break bigswitch;
                            r = r * 16 + v;
                            if (r > Unicode.MAX_RUNE) break bigswitch;
                            nhex++;
                        }
                        if (nhex === 0) break bigswitch;
                        return r;
                    }
                    const x = Utils.unhex(c);
                    if (!t.more()) break;
                    c = t.pop();
                    const y = Utils.unhex(c);
                    if (x < 0 || y < 0) break;
                    return x * 16 + y;
                }
            case Codepoint.CODES.get('a'):
                return Codepoint.CODES.get('\x07');
            case Codepoint.CODES.get('f'):
                return Codepoint.CODES.get('\f');
            case Codepoint.CODES.get('n'):
                return Codepoint.CODES.get('\n');
            case Codepoint.CODES.get('r'):
                return Codepoint.CODES.get('\r');
            case Codepoint.CODES.get('t'):
                return Codepoint.CODES.get('\t');
            case Codepoint.CODES.get('v'):
                return Codepoint.CODES.get('\v');
            default:
                if (!Utils.isalnum(c)) return c;
                break;
        }
        throw new RE2JSSyntaxException(Parser.ERR_INVALID_ESCAPE, t.from(startPos));
    }
    // parseClassChar parses a character class character and returns it.
    // wholeClassPos is the position of the start of the entire class "[...".
    // Pre: t at class char; Post: t after it.
    static parseClassChar(t, wholeClassPos) {
        if (!t.more()) throw new RE2JSSyntaxException(Parser.ERR_MISSING_BRACKET, t.from(wholeClassPos));
        if (t.lookingAt('\\')) return Parser.parseEscape(t);
        return t.pop();
    }
    static concatRunes(x, y) {
        return [
            ...x,
            ...y
        ];
    }
    constructor(wholeRegexp, flags = 0){
        this.wholeRegexp = wholeRegexp;
        // Flags control the behavior of the parser and record information about
        // regexp context.
        this.flags = flags;
        // number of capturing groups seen
        this.numCap = 0;
        this.namedGroups = {};
        // Stack of parsed expressions.
        this.stack = [];
        this.free = null;
    }
    // Allocate a Regexp, from the free list if possible.
    newRegexp(op) {
        let re = this.free;
        if (re !== null && re.subs !== null && re.subs.length > 0) {
            this.free = re.subs[0];
            re.reinit();
            re.op = op;
        } else re = new Regexp(op);
        return re;
    }
    reuse(re) {
        if (re.subs !== null && re.subs.length > 0) re.subs[0] = this.free;
        this.free = re;
    }
    // Parse stack manipulation.
    pop() {
        return this.stack.pop();
    }
    popToPseudo() {
        const n = this.stack.length;
        let i = n;
        while(i > 0 && !Regexp.isPseudoOp(this.stack[i - 1].op))i--;
        const r = this.stack.slice(i, n);
        this.stack = this.stack.slice(0, i);
        return r;
    }
    // push pushes the regexp re onto the parse stack and returns the regexp.
    // Returns null for a CHAR_CLASS that can be merged with the top-of-stack.
    push(re) {
        if (re.op === Regexp.Op.CHAR_CLASS && re.runes.length === 2 && re.runes[0] === re.runes[1]) {
            if (this.maybeConcat(re.runes[0], this.flags & ~RE2Flags.FOLD_CASE)) return null;
            re.op = Regexp.Op.LITERAL;
            re.runes = [
                re.runes[0]
            ];
            re.flags = this.flags & ~RE2Flags.FOLD_CASE;
        } else if (re.op === Regexp.Op.CHAR_CLASS && re.runes.length === 4 && re.runes[0] === re.runes[1] && re.runes[2] === re.runes[3] && Unicode.simpleFold(re.runes[0]) === re.runes[2] && Unicode.simpleFold(re.runes[2]) === re.runes[0] || re.op === Regexp.Op.CHAR_CLASS && re.runes.length === 2 && re.runes[0] + 1 === re.runes[1] && Unicode.simpleFold(re.runes[0]) === re.runes[1] && Unicode.simpleFold(re.runes[1]) === re.runes[0]) {
            // Case-insensitive rune like [Aa] or [Δδ].
            if (this.maybeConcat(re.runes[0], this.flags | RE2Flags.FOLD_CASE)) return null;
            // Rewrite as (case-insensitive) literal.
            re.op = Regexp.Op.LITERAL;
            re.runes = [
                re.runes[0]
            ];
            re.flags = this.flags | RE2Flags.FOLD_CASE;
        } else // Incremental concatenation.
        this.maybeConcat(-1, 0);
        this.stack.push(re);
        return re;
    }
    // maybeConcat implements incremental concatenation
    // of literal runes into string nodes.  The parser calls this
    // before each push, so only the top fragment of the stack
    // might need processing.  Since this is called before a push,
    // the topmost literal is no longer subject to operators like *
    // (Otherwise ab* would turn into (ab)*.)
    // If (r >= 0 and there's a node left over, maybeConcat uses it
    // to push r with the given flags.
    // maybeConcat reports whether r was pushed.
    maybeConcat(r, flags) {
        const n = this.stack.length;
        if (n < 2) return false;
        const re1 = this.stack[n - 1];
        const re2 = this.stack[n - 2];
        if (re1.op !== Regexp.Op.LITERAL || re2.op !== Regexp.Op.LITERAL || (re1.flags & RE2Flags.FOLD_CASE) !== (re2.flags & RE2Flags.FOLD_CASE)) return false;
        // Push re1 into re2.
        re2.runes = Parser.concatRunes(re2.runes, re1.runes);
        // Reuse re1 if possible.
        if (r >= 0) {
            re1.runes = [
                r
            ];
            re1.flags = flags;
            return true;
        }
        this.pop();
        this.reuse(re1);
        return false; // did not push r
    }
    // newLiteral returns a new LITERAL Regexp with the given flags
    newLiteral(r, flags) {
        const re = this.newRegexp(Regexp.Op.LITERAL);
        re.flags = flags;
        if ((flags & RE2Flags.FOLD_CASE) !== 0) r = Parser.minFoldRune(r);
        re.runes = [
            r
        ];
        return re;
    }
    // literal pushes a literal regexp for the rune r on the stack
    // and returns that regexp.
    literal(r) {
        this.push(this.newLiteral(r, this.flags));
    }
    // op pushes a regexp with the given op onto the stack
    // and returns that regexp.
    op(op) {
        const re = this.newRegexp(op);
        re.flags = this.flags;
        return this.push(re);
    }
    // repeat replaces the top stack element with itself repeated according to
    // op, min, max.  beforePos is the start position of the repetition operator.
    // Pre: t is positioned after the initial repetition operator.
    // Post: t advances past an optional perl-mode '?', or stays put.
    //       Or, it fails with RE2JSSyntaxException.
    repeat(op, min, max, beforePos, t, lastRepeatPos) {
        let flags = this.flags;
        if ((flags & RE2Flags.PERL_X) !== 0) {
            if (t.more() && t.lookingAt('?')) {
                t.skip(1);
                flags ^= RE2Flags.NON_GREEDY;
            }
            if (lastRepeatPos !== -1) // In Perl it is not allowed to stack repetition operators:
            // a** is a syntax error, not a doubled star, and a++ means
            // something else entirely, which we don't support!
            throw new RE2JSSyntaxException(Parser.ERR_INVALID_REPEAT_OP, t.from(lastRepeatPos));
        }
        const n = this.stack.length;
        if (n === 0) throw new RE2JSSyntaxException(Parser.ERR_MISSING_REPEAT_ARGUMENT, t.from(beforePos));
        const sub = this.stack[n - 1];
        if (Regexp.isPseudoOp(sub.op)) throw new RE2JSSyntaxException(Parser.ERR_MISSING_REPEAT_ARGUMENT, t.from(beforePos));
        const re = this.newRegexp(op);
        re.min = min;
        re.max = max;
        re.flags = flags;
        re.subs = [
            sub
        ];
        this.stack[n - 1] = re;
    }
    // concat replaces the top of the stack (above the topmost '|' or '(') with
    // its concatenation.
    concat() {
        this.maybeConcat(-1, 0);
        const subs = this.popToPseudo();
        if (subs.length === 0) return this.push(this.newRegexp(Regexp.Op.EMPTY_MATCH));
        return this.push(this.collapse(subs, Regexp.Op.CONCAT));
    }
    // alternate replaces the top of the stack (above the topmost '(') with its
    // alternation.
    alternate() {
        // Scan down to find pseudo-operator (.
        // There are no | above (.
        const subs = this.popToPseudo();
        // Make sure top class is clean.
        // All the others already are (see swapVerticalBar).
        if (subs.length > 0) this.cleanAlt(subs[subs.length - 1]);
        // Empty alternate is special case
        // (shouldn't happen but easy to handle).
        if (subs.length === 0) return this.push(this.newRegexp(Regexp.Op.NO_MATCH));
        return this.push(this.collapse(subs, Regexp.Op.ALTERNATE));
    }
    // cleanAlt cleans re for eventual inclusion in an alternation.
    cleanAlt(re) {
        if (re.op === Regexp.Op.CHAR_CLASS) {
            re.runes = new CharClass(re.runes).cleanClass().toArray();
            if (re.runes.length === 2 && re.runes[0] === 0 && re.runes[1] === Unicode.MAX_RUNE) {
                re.runes = null;
                re.op = Regexp.Op.ANY_CHAR;
            } else if (re.runes.length === 4 && re.runes[0] === 0 && re.runes[1] === Codepoint.CODES.get('\n') - 1 && re.runes[2] === Codepoint.CODES.get('\n') + 1 && re.runes[3] === Unicode.MAX_RUNE) {
                re.runes = null;
                re.op = Regexp.Op.ANY_CHAR_NOT_NL;
            }
        }
    }
    // collapse returns the result of applying op to subs[start:end].
    // If (sub contains op nodes, they all get hoisted up
    // so that there is never a concat of a concat or an
    // alternate of an alternate.
    collapse(subs, op) {
        if (subs.length === 1) return subs[0];
        // Concatenate subs iff op is same.
        // Compute length in first pass.
        let len = 0;
        for (let sub of subs)len += sub.op === op ? sub.subs.length : 1;
        let newsubs = new Array(len).fill(null);
        let i = 0;
        for (let sub of subs)if (sub.op === op) {
            newsubs.splice(i, sub.subs.length, ...sub.subs);
            i += sub.subs.length;
            this.reuse(sub);
        } else newsubs[i++] = sub;
        let re = this.newRegexp(op);
        re.subs = newsubs;
        if (op === Regexp.Op.ALTERNATE) {
            // re.subs = this.factor(re.subs, re.flags)
            re.subs = this.factor(re.subs);
            if (re.subs.length === 1) {
                const old = re;
                re = re.subs[0];
                this.reuse(old);
            }
        }
        return re;
    }
    // factor factors common prefixes from the alternation list sub.  It
    // returns a replacement list that reuses the same storage and frees
    // (passes to p.reuse) any removed *Regexps.
    //
    // For example,
    //     ABC|ABD|AEF|BCX|BCY
    // simplifies by literal prefix extraction to
    //     A(B(C|D)|EF)|BC(X|Y)
    // which simplifies by character class introduction to
    //     A(B[CD]|EF)|BC[XY]
    //
    factor(array) {
        if (array.length < 2) return array;
        // The following code is subtle, because it's a literal JS
        // translation of code that makes clever use of Go "slices".
        // A slice is a triple (array, offset, length), and the Go
        // implementation uses two slices, |sub| and |out| backed by the
        // same array.  In JS, we have to be explicit about all of these
        // variables, so:
        //
        // Go    JS
        // sub   (array, s, lensub)
        // out   (array, 0, lenout)   // (always a prefix of |array|)
        //
        // In the comments we'll use the logical notation of go slices, e.g. sub[i]
        // even though the JS code will read array[s + i].
        let s = 0; // offset of first |sub| within array.
        let lensub = array.length; // = len(sub)
        let lenout = 0; // = len(out)
        // Round 1: Factor out common literal prefixes.
        // Note: (str, strlen) and (istr, istrlen) are like Go slices
        // onto a prefix of some Regexp's runes array (hence offset=0).
        let str = null;
        let strlen = 0;
        let strflags = 0;
        let start = 0;
        for(let i = 0; i <= lensub; i++){
            // Invariant: the Regexps that were in sub[0:start] have been
            // used or marked for reuse, and the slice space has been reused
            // for out (len <= start).
            //
            // Invariant: sub[start:i] consists of regexps that all begin
            // with str as modified by strflags.
            let istr = null;
            let istrlen = 0;
            let iflags = 0;
            if (i < lensub) {
                // NB, we inlined Go's leadingString() since Java has no pair return.
                let re = array[s + i];
                if (re.op === Regexp.Op.CONCAT && re.subs.length > 0) re = re.subs[0];
                if (re.op === Regexp.Op.LITERAL) {
                    istr = re.runes;
                    istrlen = re.runes.length;
                    iflags = re.flags & RE2Flags.FOLD_CASE;
                }
                // istr is the leading literal string that re begins with.
                // The string refers to storage in re or its children.
                if (iflags === strflags) {
                    let same = 0;
                    while(same < strlen && same < istrlen && str[same] === istr[same])same++;
                    if (same > 0) {
                        // Matches at least one rune in current range.
                        // Keep going around.
                        strlen = same;
                        continue;
                    }
                }
            }
            // Found end of a run with common leading literal string:
            // sub[start:i] all begin with str[0:strlen], but sub[i]
            // does not even begin with str[0].
            //
            // Factor out common string and append factored expression to out.
            if (i === start) ;
            else if (i === start + 1) // Just one: don't bother factoring.
            array[lenout++] = array[s + start];
            else {
                // Construct factored form: prefix(suffix1|suffix2|...)
                const prefix = this.newRegexp(Regexp.Op.LITERAL);
                prefix.flags = strflags;
                prefix.runes = str.slice(0, strlen);
                for(let j = start; j < i; j++)array[s + j] = this.removeLeadingString(array[s + j], strlen);
                // Recurse.
                const suffix = this.collapse(array.slice(s + start, s + i), Regexp.Op.ALTERNATE);
                const re = this.newRegexp(Regexp.Op.CONCAT);
                re.subs = [
                    prefix,
                    suffix
                ];
                array[lenout++] = re;
            }
            // Prepare for next iteration.
            start = i;
            str = istr;
            strlen = istrlen;
            strflags = iflags;
        }
        // In Go: sub = out
        lensub = lenout;
        s = 0;
        // Round 2: Factor out common complex prefixes,
        // just the first piece of each concatenation,
        // whatever it is.  This is good enough a lot of the time.
        start = 0;
        lenout = 0;
        let first = null;
        for(let i = 0; i <= lensub; i++){
            // Invariant: the Regexps that were in sub[0:start] have been
            // used or marked for reuse, and the slice space has been reused
            // for out (lenout <= start).
            //
            // Invariant: sub[start:i] consists of regexps that all begin with
            // ifirst.
            let ifirst = null;
            if (i < lensub) {
                ifirst = Parser.leadingRegexp(array[s + i]);
                if (first !== null && first.equals(ifirst) && (Parser.isCharClass(first) || first.op === Regexp.Op.REPEAT && first.min === first.max && Parser.isCharClass(first.subs[0]))) continue;
            }
            // Found end of a run with common leading regexp:
            // sub[start:i] all begin with first but sub[i] does not.
            //
            // Factor out common regexp and append factored expression to out.
            if (i === start) ;
            else if (i === start + 1) // Just one: don't bother factoring.
            array[lenout++] = array[s + start];
            else {
                // Construct factored form: prefix(suffix1|suffix2|...)
                const prefix = first;
                for(let j = start; j < i; j++){
                    const reuse = j !== start; // prefix came from sub[start]
                    array[s + j] = this.removeLeadingRegexp(array[s + j], reuse);
                }
                // recurse
                const suffix = this.collapse(array.slice(s + start, s + i), Regexp.Op.ALTERNATE);
                const re = this.newRegexp(Regexp.Op.CONCAT);
                re.subs = [
                    prefix,
                    suffix
                ];
                array[lenout++] = re;
            }
            // Prepare for next iteration.
            start = i;
            first = ifirst;
        }
        // In Go: sub = out
        lensub = lenout;
        s = 0;
        // Round 3: Collapse runs of single literals into character classes.
        start = 0;
        lenout = 0;
        for(let i = 0; i <= lensub; i++){
            // Invariant: the Regexps that were in sub[0:start] have been
            // used or marked for reuse, and the slice space has been reused
            // for out (lenout <= start).
            //
            // Invariant: sub[start:i] consists of regexps that are either
            // literal runes or character classes.
            if (i < lensub && Parser.isCharClass(array[s + i])) continue;
            // sub[i] is not a char or char class;
            // emit char class for sub[start:i]...
            if (i === start) ;
            else if (i === start + 1) // Just one: don't bother factoring.
            array[lenout++] = array[s + start];
            else {
                // Make new char class.
                // Start with most complex regexp in sub[start].
                let max = start;
                for(let j = start + 1; j < i; j++){
                    const subMax = array[s + max];
                    const subJ = array[s + j];
                    if (subMax.op < subJ.op || subMax.op === subJ.op && (subMax.runes !== null ? subMax.runes.length : 0) < (subJ.runes !== null ? subJ.runes.length : 0)) max = j;
                }
                // swap sub[start], sub[max].
                const tmp = array[s + start];
                array[s + start] = array[s + max];
                array[s + max] = tmp;
                for(let j = start + 1; j < i; j++){
                    Parser.mergeCharClass(array[s + start], array[s + j]);
                    this.reuse(array[s + j]);
                }
                this.cleanAlt(array[s + start]);
                array[lenout++] = array[s + start];
            }
            // ... and then emit sub[i].
            if (i < lensub) array[lenout++] = array[s + i];
            start = i + 1;
        }
        // In Go: sub = out
        lensub = lenout;
        s = 0;
        // Round 4: Collapse runs of empty matches into a single empty match.
        start = 0;
        lenout = 0;
        for(let i = 0; i < lensub; ++i){
            if (i + 1 < lensub && array[s + i].op === Regexp.Op.EMPTY_MATCH && array[s + i + 1].op === Regexp.Op.EMPTY_MATCH) continue;
            array[lenout++] = array[s + i];
        }
        // In Go: sub = out
        lensub = lenout;
        s = 0;
        return array.slice(s, lensub);
    }
    // removeLeadingString removes the first n leading runes
    // from the beginning of re.  It returns the replacement for re.
    removeLeadingString(re, n) {
        if (re.op === Regexp.Op.CONCAT && re.subs.length > 0) {
            // Removing a leading string in a concatenation
            // might simplify the concatenation.
            const sub = this.removeLeadingString(re.subs[0], n);
            re.subs[0] = sub;
            if (sub.op === Regexp.Op.EMPTY_MATCH) {
                this.reuse(sub);
                switch(re.subs.length){
                    case 0:
                    case 1:
                        // Impossible but handle.
                        re.op = Regexp.Op.EMPTY_MATCH;
                        re.subs = null;
                        break;
                    case 2:
                        {
                            const old = re;
                            re = re.subs[1];
                            this.reuse(old);
                            break;
                        }
                    default:
                        re.subs = re.subs.slice(1, re.subs.length);
                        break;
                }
            }
            return re;
        }
        if (re.op === Regexp.Op.LITERAL) {
            re.runes = re.runes.slice(n, re.runes.length);
            if (re.runes.length === 0) re.op = Regexp.Op.EMPTY_MATCH;
        }
        return re;
    }
    // removeLeadingRegexp removes the leading regexp in re.
    // It returns the replacement for re.
    // If reuse is true, it passes the removed regexp (if no longer needed) to
    // reuse.
    removeLeadingRegexp(re, reuse) {
        if (re.op === Regexp.Op.CONCAT && re.subs.length > 0) {
            if (reuse) this.reuse(re.subs[0]);
            re.subs = re.subs.slice(1, re.subs.length);
            switch(re.subs.length){
                case 0:
                    re.op = Regexp.Op.EMPTY_MATCH;
                    re.subs = Regexp.emptySubs();
                    break;
                case 1:
                    {
                        const old = re;
                        re = re.subs[0];
                        this.reuse(old);
                        break;
                    }
            }
            return re;
        }
        if (reuse) this.reuse(re);
        return this.newRegexp(Regexp.Op.EMPTY_MATCH);
    }
    parseInternal() {
        if ((this.flags & RE2Flags.LITERAL) !== 0) // Trivial parser for literal string.
        return Parser.literalRegexp(this.wholeRegexp, this.flags);
        // Otherwise, must do real work.
        let lastRepeatPos = -1;
        let min = -1;
        let max = -1;
        const t = new StringIterator(this.wholeRegexp);
        while(t.more()){
            let repeatPos = -1;
            bigswitch: switch(t.peek()){
                case Codepoint.CODES.get('('):
                    if ((this.flags & RE2Flags.PERL_X) !== 0 && t.lookingAt('(?')) {
                        // Flag changes and non-capturing groups.
                        this.parsePerlFlags(t);
                        break;
                    }
                    this.op(Regexp.Op.LEFT_PAREN).cap = ++this.numCap;
                    t.skip(1); // '('
                    break;
                case Codepoint.CODES.get('|'):
                    this.parseVerticalBar(); // '|'
                    t.skip(1); // '|'
                    break;
                case Codepoint.CODES.get(')'):
                    this.parseRightParen();
                    t.skip(1); // ')'
                    break;
                case Codepoint.CODES.get('^'):
                    if ((this.flags & RE2Flags.ONE_LINE) !== 0) this.op(Regexp.Op.BEGIN_TEXT);
                    else this.op(Regexp.Op.BEGIN_LINE);
                    t.skip(1); // '^'
                    break;
                case Codepoint.CODES.get('$'):
                    if ((this.flags & RE2Flags.ONE_LINE) !== 0) this.op(Regexp.Op.END_TEXT).flags |= RE2Flags.WAS_DOLLAR;
                    else this.op(Regexp.Op.END_LINE);
                    t.skip(1); // '$'
                    break;
                case Codepoint.CODES.get('.'):
                    if ((this.flags & RE2Flags.DOT_NL) !== 0) this.op(Regexp.Op.ANY_CHAR);
                    else this.op(Regexp.Op.ANY_CHAR_NOT_NL);
                    t.skip(1); // '.'
                    break;
                case Codepoint.CODES.get('['):
                    this.parseClass(t);
                    break;
                case Codepoint.CODES.get('*'):
                case Codepoint.CODES.get('+'):
                case Codepoint.CODES.get('?'):
                    {
                        repeatPos = t.pos();
                        let op = null;
                        switch(t.pop()){
                            case Codepoint.CODES.get('*'):
                                op = Regexp.Op.STAR;
                                break;
                            case Codepoint.CODES.get('+'):
                                op = Regexp.Op.PLUS;
                                break;
                            case Codepoint.CODES.get('?'):
                                op = Regexp.Op.QUEST;
                                break;
                        }
                        this.repeat(op, min, max, repeatPos, t, lastRepeatPos);
                        break;
                    }
                case Codepoint.CODES.get('{'):
                    {
                        repeatPos = t.pos();
                        const minMax = Parser.parseRepeat(t);
                        if (minMax < 0) {
                            // If the repeat cannot be parsed, { is a literal.
                            t.rewindTo(repeatPos);
                            this.literal(t.pop()); // '{'
                            break;
                        }
                        min = minMax >> 16;
                        max = (minMax & Unicode.MAX_BMP) << 16 >> 16;
                        this.repeat(Regexp.Op.REPEAT, min, max, repeatPos, t, lastRepeatPos);
                        break;
                    }
                case Codepoint.CODES.get('\\'):
                    {
                        const savedPos = t.pos();
                        t.skip(1); // '\\'
                        if ((this.flags & RE2Flags.PERL_X) !== 0 && t.more()) {
                            const c = t.pop();
                            switch(c){
                                case Codepoint.CODES.get('A'):
                                    this.op(Regexp.Op.BEGIN_TEXT);
                                    break bigswitch;
                                case Codepoint.CODES.get('b'):
                                    this.op(Regexp.Op.WORD_BOUNDARY);
                                    break bigswitch;
                                case Codepoint.CODES.get('B'):
                                    this.op(Regexp.Op.NO_WORD_BOUNDARY);
                                    break bigswitch;
                                case Codepoint.CODES.get('C'):
                                    // any byte; not supported
                                    throw new RE2JSSyntaxException(Parser.ERR_INVALID_ESCAPE, '\\C');
                                case Codepoint.CODES.get('Q'):
                                    {
                                        // \Q ... \E: the ... is always literals
                                        let lit = t.rest();
                                        const i = lit.indexOf('\\E');
                                        if (i >= 0) lit = lit.substring(0, i);
                                        t.skipString(lit);
                                        t.skipString('\\E');
                                        let j = 0;
                                        while(j < lit.length){
                                            const codepoint = lit.codePointAt(j);
                                            this.literal(codepoint);
                                            j += Utils.charCount(codepoint);
                                        }
                                        break bigswitch;
                                    }
                                case Codepoint.CODES.get('z'):
                                    this.op(Regexp.Op.END_TEXT);
                                    break bigswitch;
                                default:
                                    t.rewindTo(savedPos);
                                    break;
                            }
                        }
                        const re = this.newRegexp(Regexp.Op.CHAR_CLASS);
                        re.flags = this.flags;
                        // Look for Unicode character group like \p{Han}
                        if (t.lookingAt('\\p') || t.lookingAt('\\P')) {
                            const cc = new CharClass();
                            if (this.parseUnicodeClass(t, cc)) {
                                re.runes = cc.toArray();
                                this.push(re);
                                break bigswitch;
                            }
                        }
                        // Perl character class escape.
                        const cc = new CharClass();
                        if (this.parsePerlClassEscape(t, cc)) {
                            re.runes = cc.toArray();
                            this.push(re);
                            break bigswitch;
                        }
                        t.rewindTo(savedPos);
                        this.reuse(re);
                        // Ordinary single-character escape.
                        this.literal(Parser.parseEscape(t));
                        break;
                    }
                default:
                    this.literal(t.pop());
                    break;
            }
            lastRepeatPos = repeatPos;
        }
        this.concat();
        if (this.swapVerticalBar()) this.pop(); // pop vertical bar
        this.alternate();
        const n = this.stack.length;
        if (n !== 1) throw new RE2JSSyntaxException(Parser.ERR_MISSING_PAREN, this.wholeRegexp);
        this.stack[0].namedGroups = this.namedGroups;
        return this.stack[0];
    }
    // parsePerlFlags parses a Perl flag setting or non-capturing group or both,
    // like (?i) or (?: or (?i:.
    // Pre: t at "(?".  Post: t after ")".
    // Sets numCap.
    parsePerlFlags(t) {
        const startPos = t.pos();
        // Check for named captures, first introduced in Python's regexp library.
        // As usual, there are three slightly different syntaxes:
        //
        //   (?P<name>expr)   the original, introduced by Python
        //   (?<name>expr)    the .NET alteration, adopted by Perl 5.10
        //   (?'name'expr)    another .NET alteration, adopted by Perl 5.10
        //
        // Perl 5.10 gave in and implemented the Python version too,
        // but they claim that the last two are the preferred forms.
        // PCRE and languages based on it (specifically, PHP and Ruby)
        // support all three as well.  EcmaScript 4 uses only the Python form.
        //
        // In both the open source world (via Code Search) and the
        // Google source tree, (?P<name>expr) and (?<name>expr) are the
        // dominant forms of named captures and both are supported.
        const s = t.rest();
        if (s.startsWith('(?P<') || s.startsWith('(?<')) {
            // Pull out name.
            const begin = s.charAt(2) === 'P' ? 4 : 3;
            const end = s.indexOf('>');
            if (end < 0) throw new RE2JSSyntaxException(Parser.ERR_INVALID_NAMED_CAPTURE, s);
            const name = s.substring(begin, end); // "name"
            t.skipString(name);
            t.skip(begin + 1); // "(?P<>" or "(?<>"
            if (!Parser.isValidCaptureName(name)) // "(?P<name>"
            throw new RE2JSSyntaxException(Parser.ERR_INVALID_NAMED_CAPTURE, s.substring(0, end + 1)); // "(?P<name>" or "(?<name>"
            // Like ordinary capture, but named.
            const re = this.op(Regexp.Op.LEFT_PAREN);
            re.cap = ++this.numCap;
            if (this.namedGroups[name]) throw new RE2JSSyntaxException(Parser.ERR_DUPLICATE_NAMED_CAPTURE, name);
            this.namedGroups[name] = this.numCap;
            re.name = name;
            return;
        }
        // Non-capturing group.  Might also twiddle Perl flags.
        t.skip(2); // "(?"
        let flags = this.flags;
        let sign = 1;
        let sawFlag = false;
        loop: while(t.more()){
            const c = t.pop();
            switch(c){
                case Codepoint.CODES.get('i'):
                    flags |= RE2Flags.FOLD_CASE;
                    sawFlag = true;
                    break;
                case Codepoint.CODES.get('m'):
                    flags &= ~RE2Flags.ONE_LINE;
                    sawFlag = true;
                    break;
                case Codepoint.CODES.get('s'):
                    flags |= RE2Flags.DOT_NL;
                    sawFlag = true;
                    break;
                case Codepoint.CODES.get('U'):
                    flags |= RE2Flags.NON_GREEDY;
                    sawFlag = true;
                    break;
                // Switch to negation.
                case Codepoint.CODES.get('-'):
                    if (sign < 0) break loop;
                    sign = -1;
                    // Invert flags so that | above turn into &~ and vice versa.
                    // We'll invert flags again before using it below.
                    flags = ~flags;
                    sawFlag = false;
                    break;
                // End of flags, starting group or not.
                case Codepoint.CODES.get(':'):
                case Codepoint.CODES.get(')'):
                    if (sign < 0) {
                        if (!sawFlag) break loop;
                        flags = ~flags;
                    }
                    if (c === Codepoint.CODES.get(':')) // Open new group
                    this.op(Regexp.Op.LEFT_PAREN);
                    this.flags = flags;
                    return;
                default:
                    break loop;
            }
        }
        throw new RE2JSSyntaxException(Parser.ERR_INVALID_PERL_OP, t.from(startPos));
    }
    // parseVerticalBar handles a | in the input.
    parseVerticalBar() {
        this.concat();
        // The concatenation we just parsed is on top of the stack.
        // If it sits above an opVerticalBar, swap it below
        // (things below an opVerticalBar become an alternation).
        // Otherwise, push a new vertical bar.
        if (!this.swapVerticalBar()) this.op(Regexp.Op.VERTICAL_BAR);
    }
    // If the top of the stack is an element followed by an opVerticalBar
    // swapVerticalBar swaps the two and returns true.
    // Otherwise it returns false.
    swapVerticalBar() {
        const n = this.stack.length;
        // If above and below vertical bar are literal or char class,
        // can merge into a single char class.
        if (n >= 3 && this.stack[n - 2].op === Regexp.Op.VERTICAL_BAR && Parser.isCharClass(this.stack[n - 1]) && Parser.isCharClass(this.stack[n - 3])) {
            let re1 = this.stack[n - 1];
            let re3 = this.stack[n - 3];
            // Make re3 the more complex of the two.
            if (re1.op > re3.op) {
                const tmp = re3;
                re3 = re1;
                re1 = tmp;
                this.stack[n - 3] = re3;
            }
            Parser.mergeCharClass(re3, re1);
            this.reuse(re1);
            this.pop();
            return true;
        }
        if (n >= 2) {
            const re1 = this.stack[n - 1];
            const re2 = this.stack[n - 2];
            if (re2.op === Regexp.Op.VERTICAL_BAR) {
                if (n >= 3) // Now out of reach.
                // Clean opportunistically.
                this.cleanAlt(this.stack[n - 3]);
                this.stack[n - 2] = re1;
                this.stack[n - 1] = re2;
                return true;
            }
        }
        return false;
    }
    // parseRightParen handles a ')' in the input.
    parseRightParen() {
        this.concat();
        if (this.swapVerticalBar()) this.pop(); // pop vertical bar
        this.alternate();
        const n = this.stack.length;
        if (n < 2) throw new RE2JSSyntaxException(Parser.ERR_INTERNAL_ERROR, 'stack underflow');
        const re1 = this.pop();
        const re2 = this.pop();
        if (re2.op !== Regexp.Op.LEFT_PAREN) throw new RE2JSSyntaxException(Parser.ERR_MISSING_PAREN, this.wholeRegexp);
        // Restore flags at time of paren.
        this.flags = re2.flags;
        if (re2.cap === 0) // Just for grouping.
        this.push(re1);
        else {
            re2.op = Regexp.Op.CAPTURE;
            re2.subs = [
                re1
            ];
            this.push(re2);
        }
    }
    // parsePerlClassEscape parses a leading Perl character class escape like \d
    // from the beginning of |t|.  If one is present, it appends the characters
    // to cc and returns true.  The iterator is advanced past the escape
    // on success, undefined on failure, in which case false is returned.
    parsePerlClassEscape(t, cc) {
        const beforePos = t.pos();
        if ((this.flags & RE2Flags.PERL_X) === 0 || !t.more() || t.pop() !== Codepoint.CODES.get('\\') || !t.more()) return false;
        t.pop(); // e.g. advance past 'd' in "\\d"
        const p = t.from(beforePos);
        const g = PERL_GROUPS.has(p) ? PERL_GROUPS.get(p) : null;
        if (g === null) return false;
        cc.appendGroup(g, (this.flags & RE2Flags.FOLD_CASE) !== 0);
        return true;
    }
    // parseNamedClass parses a leading POSIX named character class like
    // [:alnum:] from the beginning of t.  If one is present, it appends the
    // characters to cc, advances the iterator, and returns true.
    // Pre: t at "[:".  Post: t after ":]".
    // On failure (no class of than name), throws RE2JSSyntaxException.
    // On misparse, returns false; t.pos() is undefined.
    parseNamedClass(t, cc) {
        // (Go precondition check deleted.)
        const cls = t.rest();
        const i = cls.indexOf(':]');
        if (i < 0) return false;
        const name = cls.substring(0, i + 2); // "[:alnum:]"
        t.skipString(name);
        const g = POSIX_GROUPS.has(name) ? POSIX_GROUPS.get(name) : null;
        if (g === null) throw new RE2JSSyntaxException(Parser.ERR_INVALID_CHAR_RANGE, name);
        cc.appendGroup(g, (this.flags & RE2Flags.FOLD_CASE) !== 0);
        return true;
    }
    // parseUnicodeClass() parses a leading Unicode character class like \p{Han}
    // from the beginning of t.  If one is present, it appends the characters to
    // to |cc|, advances |t| and returns true.
    //
    // Returns false if such a pattern is not present or UNICODE_GROUPS
    // flag is not enabled; |t.pos()| is not advanced in this case.
    // Indicates error by throwing RE2JSSyntaxException.
    parseUnicodeClass(t, cc) {
        const startPos = t.pos();
        if ((this.flags & RE2Flags.UNICODE_GROUPS) === 0 || !t.lookingAt('\\p') && !t.lookingAt('\\P')) return false;
        t.skip(1); // '\\'
        // Committed to parse or throw exception.
        let sign = 1;
        let c = t.pop(); // 'p' or 'P'
        if (c === Codepoint.CODES.get('P')) sign = -1;
        if (!t.more()) {
            t.rewindTo(startPos);
            throw new RE2JSSyntaxException(Parser.ERR_INVALID_CHAR_RANGE, t.rest());
        }
        c = t.pop();
        let name;
        if (c !== Codepoint.CODES.get('{')) // Single-letter name.
        name = Utils.runeToString(c);
        else {
            // Name is in braces.
            const rest = t.rest();
            const end = rest.indexOf('}');
            if (end < 0) {
                t.rewindTo(startPos);
                throw new RE2JSSyntaxException(Parser.ERR_INVALID_CHAR_RANGE, t.rest());
            }
            name = rest.substring(0, end); // e.g. "Han"
            t.skipString(name);
            t.skip(1);
        // Don't use skip(end) because it assumes UTF-16 coding, and
        // StringIterator doesn't guarantee that.
        }
        // Group can have leading negation too.
        //  \p{^Han} == \P{Han}, \P{^Han} == \p{Han}.
        if (!(name.length === 0) && name.codePointAt(0) === Codepoint.CODES.get('^')) {
            sign = 0 - sign; // -sign
            name = name.substring(1);
        }
        const pair = Parser.unicodeTable(name);
        if (pair === null) throw new RE2JSSyntaxException(Parser.ERR_INVALID_CHAR_RANGE, t.from(startPos));
        const tab = pair.first;
        const fold = pair.second; // fold-equivalent table
        // Variation of CharClass.appendGroup() for tables.
        if ((this.flags & RE2Flags.FOLD_CASE) === 0 || fold === null) cc.appendTableWithSign(tab, sign);
        else {
            // Merge and clean tab and fold in a temporary buffer.
            // This is necessary for the negative case and just tidy
            // for the positive case.
            const tmp = new CharClass().appendTable(tab).appendTable(fold).cleanClass().toArray();
            cc.appendClassWithSign(tmp, sign);
        }
        return true;
    }
    // parseClass parses a character class and pushes it onto the parse stack.
    //
    // NOTES:
    // Pre: at '['; Post: after ']'.
    // Mutates stack.  Advances iterator.  May throw.
    parseClass(t) {
        const startPos = t.pos();
        t.skip(1); // '['
        const re = this.newRegexp(Regexp.Op.CHAR_CLASS);
        re.flags = this.flags;
        const cc = new CharClass();
        let sign = 1;
        if (t.more() && t.lookingAt('^')) {
            sign = -1;
            t.skip(1); // '^'
            // If character class does not match \n, add it here,
            // so that negation later will do the right thing.
            if ((this.flags & RE2Flags.CLASS_NL) === 0) cc.appendRange(Codepoint.CODES.get('\n'), Codepoint.CODES.get('\n'));
        }
        let first = true; // ']' and '-' are okay as first char in class
        while(!t.more() || t.peek() !== Codepoint.CODES.get(']') || first){
            // POSIX: - is only okay unescaped as first or last in class.
            // Perl: - is okay anywhere.
            if (t.more() && t.lookingAt('-') && (this.flags & RE2Flags.PERL_X) === 0 && !first) {
                const s = t.rest();
                if (s === '-' || !s.startsWith('-]')) {
                    t.rewindTo(startPos);
                    throw new RE2JSSyntaxException(Parser.ERR_INVALID_CHAR_RANGE, t.rest());
                }
            }
            first = false;
            const beforePos = t.pos();
            // Look for POSIX [:alnum:] etc.
            if (t.lookingAt('[:')) {
                if (this.parseNamedClass(t, cc)) continue;
                t.rewindTo(beforePos);
            }
            // Look for Unicode character group like \p{Han}.
            if (this.parseUnicodeClass(t, cc)) continue;
            // Look for Perl character class symbols (extension).
            if (this.parsePerlClassEscape(t, cc)) continue;
            t.rewindTo(beforePos);
            // Single character or simple range.
            const lo = Parser.parseClassChar(t, startPos);
            let hi = lo;
            if (t.more() && t.lookingAt('-')) {
                t.skip(1);
                if (t.more() && t.lookingAt(']')) // [a-] means (a|-) so check for final ].
                t.skip(-1);
                else {
                    hi = Parser.parseClassChar(t, startPos);
                    if (hi < lo) throw new RE2JSSyntaxException(Parser.ERR_INVALID_CHAR_RANGE, t.from(beforePos));
                }
            }
            if ((this.flags & RE2Flags.FOLD_CASE) === 0) cc.appendRange(lo, hi);
            else cc.appendFoldedRange(lo, hi);
        }
        t.skip(1); // ']'
        cc.cleanClass();
        if (sign < 0) cc.negateClass();
        re.runes = cc.toArray();
        this.push(re);
    }
}
// A logical thread in the NFA.
class Thread {
    constructor(){
        this.inst = null;
        this.cap = [];
    }
}
// A queue is a 'sparse array' holding pending threads of execution.  See:
// research.swtch.com/2008/03/using-uninitialized-memory-for-fun-and.html
class Queue {
    constructor(){
        this.sparse = []; // may contain stale but in-bounds values.
        this.densePcs = []; // may contain stale pc in slots >= size
        this.denseThreads = []; // may contain stale Thread in slots >= size
        this.size = 0;
    }
    contains(pc) {
        const j = this.sparse[pc];
        return j < this.size && this.densePcs[j] === pc;
    }
    isEmpty() {
        return this.size === 0;
    }
    add(pc) {
        const j = this.size++;
        this.sparse[pc] = j;
        this.denseThreads[j] = null;
        this.densePcs[j] = pc;
        return j;
    }
    clear() {
        this.sparse = [];
        this.densePcs = [];
        this.denseThreads = [];
        this.size = 0;
    }
    toString() {
        let out = '{';
        for(let i = 0; i < this.size; i++){
            if (i !== 0) out += ', ';
            out += this.densePcs[i];
        }
        out += '}';
        return out;
    }
}
// A Machine matches an input string of Unicode characters against an
// RE2 instance using a simple NFA.
//
// Called by RE2.doExecute.
class Machine {
    static fromRE2(re2) {
        const m = new Machine();
        m.prog = re2.prog;
        m.re2 = re2;
        m.q0 = new Queue(m.prog.numInst());
        m.q1 = new Queue(m.prog.numInst());
        m.pool = [];
        m.poolSize = 0;
        m.matched = false;
        m.matchcap = Array(m.prog.numCap < 2 ? 2 : m.prog.numCap).fill(0);
        m.ncap = 0;
        return m;
    }
    static fromMachine(machine) {
        const m = new Machine();
        m.re2 = machine.re2;
        m.prog = machine.prog;
        m.q0 = machine.q0;
        m.q1 = machine.q1;
        m.pool = machine.pool;
        m.poolSize = machine.poolSize;
        m.matched = machine.matched;
        m.matchcap = machine.matchcap;
        m.ncap = machine.ncap;
        return m;
    }
    // init() reinitializes an existing Machine for re-use on a new input.
    init(ncap) {
        this.ncap = ncap;
        if (ncap > this.matchcap.length) this.initNewCap(ncap);
        else this.resetCap(ncap);
    }
    resetCap(ncap) {
        for(let i = 0; i < this.poolSize; i++){
            const t = this.pool[i];
            t.cap = Array(ncap).fill(0);
        }
    }
    initNewCap(ncap) {
        for(let i = 0; i < this.poolSize; i++){
            const t = this.pool[i];
            t.cap = Array(ncap).fill(0);
        }
        this.matchcap = Array(ncap).fill(0);
    }
    submatches() {
        if (this.ncap === 0) return Utils.emptyInts();
        return this.matchcap.slice(0, this.ncap);
    }
    // alloc() allocates a new thread with the given instruction.
    // It uses the free pool if possible.
    alloc(inst) {
        let t;
        if (this.poolSize > 0) {
            this.poolSize--;
            t = this.pool[this.poolSize];
        } else t = new Thread();
        t.inst = inst;
        return t;
    }
    // Frees all threads on the thread queue, returning them to the free pool.
    freeQueue(queue, from = 0) {
        const numberOfThread = queue.size - from;
        const requiredPoolLength = this.poolSize + numberOfThread;
        if (this.pool.length < requiredPoolLength) this.pool = this.pool.slice(0, Math.max(this.pool.length * 2, requiredPoolLength));
        for(let i = from; i < queue.size; i++){
            const t = queue.denseThreads[i];
            if (t !== null) {
                this.pool[this.poolSize] = t;
                this.poolSize++;
            }
        }
        queue.clear();
    }
    // freeThread() returns t to the free pool.
    freeThread(t) {
        if (this.pool.length <= this.poolSize) this.pool = this.pool.slice(0, this.pool.length * 2);
        this.pool[this.poolSize] = t;
        this.poolSize++;
    }
    match(input, pos, anchor) {
        const startCond = this.re2.cond;
        if (startCond === Utils.EMPTY_ALL) return false;
        if ((anchor === RE2Flags.ANCHOR_START || anchor === RE2Flags.ANCHOR_BOTH) && pos !== 0) return false;
        this.matched = false;
        this.matchcap = Array(this.prog.numCap).fill(-1);
        let runq = this.q0;
        let nextq = this.q1;
        let r = input.step(pos);
        let rune = r >> 3;
        let width = r & 7;
        let rune1 = -1;
        let width1 = 0;
        if (r !== MachineInputBase.EOF()) {
            r = input.step(pos + width);
            rune1 = r >> 3;
            width1 = r & 7;
        }
        let flag;
        if (pos === 0) flag = Utils.emptyOpContext(-1, rune);
        else flag = input.context(pos);
        // eslint-disable-next-line no-constant-condition
        while(true){
            if (runq.isEmpty()) {
                if ((startCond & Utils.EMPTY_BEGIN_TEXT) !== 0 && pos !== 0) break;
                if (this.matched) break;
                if (!(this.re2.prefix.length === 0) && rune1 !== this.re2.prefixRune && input.canCheckPrefix()) {
                    const advance = input.index(this.re2, pos);
                    if (advance < 0) break;
                    pos += advance;
                    r = input.step(pos);
                    rune = r >> 3;
                    width = r & 7;
                    r = input.step(pos + width);
                    rune1 = r >> 3;
                    width1 = r & 7;
                }
            }
            if (!this.matched && (pos === 0 || anchor === RE2Flags.UNANCHORED)) {
                if (this.ncap > 0) this.matchcap[0] = pos;
                this.add(runq, this.prog.start, pos, this.matchcap, flag, null);
            }
            const nextPos = pos + width;
            flag = input.context(nextPos);
            this.step(runq, nextq, pos, nextPos, rune, flag, anchor, pos === input.endPos());
            if (width === 0) break;
            if (this.ncap === 0 && this.matched) break;
            pos += width;
            rune = rune1;
            width = width1;
            if (rune !== -1) {
                r = input.step(pos + width);
                rune1 = r >> 3;
                width1 = r & 7;
            }
            const tmpq = runq;
            runq = nextq;
            nextq = tmpq;
        }
        this.freeQueue(nextq);
        return this.matched;
    }
    step(runq, nextq, pos, nextPos, c, nextCond, anchor, atEnd) {
        const longest = this.re2.longest;
        for(let j = 0; j < runq.size; j++){
            let t = runq.denseThreads[j];
            if (t === null) continue;
            if (longest && this.matched && this.ncap > 0 && this.matchcap[0] < t.cap[0]) {
                this.freeThread(t);
                continue;
            }
            const i = t.inst;
            let add = false;
            switch(i.op){
                case Inst.MATCH:
                    if (anchor === RE2Flags.ANCHOR_BOTH && !atEnd) break;
                    if (this.ncap > 0 && (!longest || !this.matched || this.matchcap[1] < pos)) {
                        t.cap[1] = pos;
                        this.matchcap = t.cap.slice(0, this.ncap);
                    }
                    if (!longest) this.freeQueue(runq, j + 1);
                    this.matched = true;
                    break;
                case Inst.RUNE:
                    add = i.matchRune(c);
                    break;
                case Inst.RUNE1:
                    add = c === i.runes[0];
                    break;
                case Inst.RUNE_ANY:
                    add = true;
                    break;
                case Inst.RUNE_ANY_NOT_NL:
                    add = c !== Codepoint.CODES.get('\n');
                    break;
                default:
                    throw new Error('bad inst');
            }
            if (add) t = this.add(nextq, i.out, nextPos, t.cap, nextCond, t);
            if (t !== null) {
                this.freeThread(t);
                runq.denseThreads[j] = null;
            }
        }
        runq.clear();
    }
    add(q, pc, pos, cap, cond, t) {
        if (pc === 0) return t;
        if (q.contains(pc)) return t;
        const d = q.add(pc);
        const inst = this.prog.inst[pc];
        switch(inst.op){
            case Inst.FAIL:
                break;
            case Inst.ALT:
            case Inst.ALT_MATCH:
                t = this.add(q, inst.out, pos, cap, cond, t);
                t = this.add(q, inst.arg, pos, cap, cond, t);
                break;
            case Inst.EMPTY_WIDTH:
                if ((inst.arg & ~cond) === 0) t = this.add(q, inst.out, pos, cap, cond, t);
                break;
            case Inst.NOP:
                t = this.add(q, inst.out, pos, cap, cond, t);
                break;
            case Inst.CAPTURE:
                if (inst.arg < this.ncap) {
                    const opos = cap[inst.arg];
                    cap[inst.arg] = pos;
                    this.add(q, inst.out, pos, cap, cond, null);
                    cap[inst.arg] = opos;
                } else t = this.add(q, inst.out, pos, cap, cond, t);
                break;
            case Inst.MATCH:
            case Inst.RUNE:
            case Inst.RUNE1:
            case Inst.RUNE_ANY:
            case Inst.RUNE_ANY_NOT_NL:
                if (t === null) t = this.alloc(inst);
                else t.inst = inst;
                if (this.ncap > 0 && t.cap !== cap) t.cap = cap.slice(0, this.ncap);
                q.denseThreads[d] = t;
                t = null;
                break;
            default:
                throw new Error('unhandled');
        }
        return t;
    }
}
class AtomicReference {
    constructor(initialValue){
        this.value = initialValue;
    }
    // Returns the current value
    get() {
        return this.value;
    }
    // Sets to the given value
    set(newValue) {
        this.value = newValue;
    }
    // Atomically sets to the given value and returns true if the current value == the expected value
    compareAndSet(expect, update) {
        if (this.value === expect) {
            this.value = update;
            return true;
        }
        return false;
    }
}
/**
 * An RE2 class instance is a compiled representation of an RE2 regular expression, independent of
 * the public Java-like Pattern/Matcher API.
 *
 * This class also contains various implementation helpers for RE2 regular expressions.
 *
 * Use the {@link #quoteMeta(String)} utility function to quote all regular expression
 * metacharacters in an arbitrary string.
 *
 */ class RE2 {
    // This is visible for testing.
    static initTest(expr) {
        const re2 = RE2.compile(expr);
        const res = new RE2(re2.expr, re2.prog, re2.numSubexp, re2.longest);
        res.cond = re2.cond;
        res.prefix = re2.prefix;
        res.prefixUTF8 = re2.prefixUTF8;
        res.prefixComplete = re2.prefixComplete;
        res.prefixRune = re2.prefixRune;
        return res;
    }
    /**
   * Parses a regular expression and returns, if successful, an {@code RE2} instance that can be
   * used to match against text.
   *
   * When matching against text, the regexp returns a match that begins as early as possible in the
   * input (leftmost), and among those it chooses the one that a backtracking search would have
   * found first. This so-called leftmost-first matching is the same semantics that Perl, Python,
   * and other implementations use, although this package implements it without the expense of
   * backtracking. For POSIX leftmost-longest matching, see {@link #compilePOSIX}.
   */ static compile(expr) {
        return RE2.compileImpl(expr, RE2Flags.PERL, false);
    }
    /**
   * {@code compilePOSIX} is like {@link #compile} but restricts the regular expression to POSIX ERE
   * (egrep) syntax and changes the match semantics to leftmost-longest.
   *
   * That is, when matching against text, the regexp returns a match that begins as early as
   * possible in the input (leftmost), and among those it chooses a match that is as long as
   * possible. This so-called leftmost-longest matching is the same semantics that early regular
   * expression implementations used and that POSIX specifies.
   *
   * However, there can be multiple leftmost-longest matches, with different submatch choices, and
   * here this package diverges from POSIX. Among the possible leftmost-longest matches, this
   * package chooses the one that a backtracking search would have found first, while POSIX
   * specifies that the match be chosen to maximize the length of the first subexpression, then the
   * second, and so on from left to right. The POSIX rule is computationally prohibitive and not
   * even well-defined. See http://swtch.com/~rsc/regexp/regexp2.html#posix
   */ static compilePOSIX(expr) {
        return RE2.compileImpl(expr, RE2Flags.POSIX, true);
    }
    // Exposed to ExecTests.
    static compileImpl(expr, mode, longest) {
        let re = Parser.parse(expr, mode);
        const maxCap = re.maxCap();
        re = Simplify.simplify(re);
        const prog = Compiler.compileRegexp(re);
        const re2 = new RE2(expr, prog, maxCap, longest);
        const [prefixCompl, prefixStr] = prog.prefix();
        re2.prefixComplete = prefixCompl;
        re2.prefix = prefixStr;
        re2.prefixUTF8 = Utils.stringToUtf8ByteArray(re2.prefix);
        if (re2.prefix.length > 0) re2.prefixRune = re2.prefix.codePointAt(0);
        re2.namedGroups = re.namedGroups;
        return re2;
    }
    /**
   * Returns true iff textual regular expression {@code pattern} matches string {@code s}.
   *
   * More complicated queries need to use {@link #compile} and the full {@code RE2} interface.
   */ // This is visible for testing.
    static match(pattern, s) {
        return RE2.compile(pattern).match(s);
    }
    constructor(expr, prog, numSubexp = 0, longest = 0){
        this.expr = expr; // as passed to Compile
        this.prog = prog; // compiled program
        this.numSubexp = numSubexp;
        this.longest = longest;
        this.cond = prog.startCond(); // EMPTY_* bitmask: empty-width conditions
        this.prefix = null; // required UTF-16 prefix in unanchored matches
        this.prefixUTF8 = null; // required UTF-8 prefix in unanchored matches
        this.prefixComplete = false; // true if prefix is the entire regexp
        this.prefixRune = 0; // first rune in prefix
        this.pooled = new AtomicReference(); // Cache of machines for running regexp. Forms a Treiber stack.
    }
    /**
   * Returns the number of parenthesized subexpressions in this regular expression.
   */ numberOfCapturingGroups() {
        return this.numSubexp;
    }
    // get() returns a machine to use for matching |this|.  It uses |this|'s
    // machine cache if possible, to avoid unnecessary allocation.
    get() {
        // Pop a machine off the stack if available.
        let head;
        do head = this.pooled.get();
        while (head && !this.pooled.compareAndSet(head, head.next));
        return head;
    }
    // Clears the memory associated with this machine.
    reset() {
        this.pooled.set(null);
    }
    // put() returns a machine to |this|'s machine cache.  There is no attempt to
    // limit the size of the cache, so it will grow to the maximum number of
    // simultaneous matches run using |this|.  (The cache empties when |this|
    // gets garbage collected or reset is called.)
    put(m, isNew) {
        // To avoid allocation in the single-thread or uncontended case, reuse a node only if
        // it was the only element in the stack when it was popped, and it's the only element
        // in the stack when it's pushed back after use.
        let head = this.pooled.get();
        do {
            head = this.pooled.get();
            if (!isNew && head) {
                // If an element had a null next pointer and it was previously in the stack, another thread
                // might be trying to pop it out right now, and if it sees the same node now in the
                // stack the pop will succeed, but the new top of the stack will be the stale (null) value
                // of next. Allocate a new Machine so that the CAS will not succeed if this node has been
                // popped and re-pushed.
                m = Machine.fromMachine(m);
                isNew = true;
            }
            // Without this comparison, TSAN will complain about a race condition:
            // Thread A, B, and C all attempt to do a match on the same pattern.
            //
            // A: Allocates Machine 1; executes match; put machine 1. State is now:
            //
            // pooled -> machine 1 -> null
            //
            // B reads pooled, sees machine 1
            //
            // C reads pooled, sees machine 1
            //
            // B successfully CASes pooled to null
            //
            // B executes match; put machine 1, which involves setting machine1.next to
            // null (even though it's already null); preempted before CAS
            //
            // C resumes, and reads machine1.next in order to execute cas(head, head.next)
            //
            // There is no happens-before relationship between B's redundant null write
            // and C's read, thus triggering TSAN.
            //
            // Not needed for JS code
            if (m.next !== head) m.next = head;
        }while (!this.pooled.compareAndSet(head, m));
    }
    toString() {
        return this.expr;
    }
    // doExecute() finds the leftmost match in the input and returns
    // the position of its subexpressions.
    // Derived from exec.go.
    doExecute(input, pos, anchor, ncap) {
        let m = this.get();
        // The Treiber stack cannot reuse nodes, unless the node to be reused has only ever been at
        // the bottom of the stack (i.e., next == null).
        let isNew = false;
        if (!m) {
            m = Machine.fromRE2(this);
            isNew = true;
        } else if (m.next !== null) {
            m = Machine.fromMachine(m);
            isNew = true;
        }
        m.init(ncap);
        const cap = m.match(input, pos, anchor) ? m.submatches() : null;
        this.put(m, isNew);
        return cap;
    }
    match(s) {
        return this.doExecute(MachineInput.fromUTF16(s), 0, RE2Flags.UNANCHORED, 0) !== null;
    }
    /**
   * Matches the regular expression against input starting at position start and ending at position
   * end, with the given anchoring. Records the submatch boundaries in group, which is [start, end)
   * pairs of byte offsets. The number of boundaries needed is inferred from the size of the group
   * array. It is most efficient not to ask for submatch boundaries.
   *
   * @param input the input byte array
   * @param start the beginning position in the input
   * @param end the end position in the input
   * @param anchor the anchoring flag (UNANCHORED, ANCHOR_START, ANCHOR_BOTH)
   * @param group the array to fill with submatch positions
   * @param ngroup the number of array pairs to fill in
   * @returns true if a match was found
   */ matchWithGroup(input, start, end, anchor, ngroup) {
        if (!(input instanceof MatcherInputBase)) input = MatcherInput.utf16(input);
        return this.matchMachineInput(input, start, end, anchor, ngroup);
    }
    matchMachineInput(input, start, end, anchor, ngroup) {
        if (start > end) return [
            false,
            null
        ];
        const machineInput = input.isUTF16Encoding() ? MachineInput.fromUTF16(input.asCharSequence(), 0, end) : MachineInput.fromUTF8(input.asBytes(), 0, end);
        const groupMatch = this.doExecute(machineInput, start, anchor, 2 * ngroup);
        if (groupMatch === null) return [
            false,
            null
        ];
        return [
            true,
            groupMatch
        ];
    }
    /**
   * Returns true iff this regexp matches the UTF-8 byte array {@code b}.
   */ // This is visible for testing.
    matchUTF8(b) {
        return this.doExecute(MachineInput.fromUTF8(b), 0, RE2Flags.UNANCHORED, 0) !== null;
    }
    /**
   * Returns a copy of {@code src} in which all matches for this regexp have been replaced by
   * {@code repl}. No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
   * replacement string.
   */ // This is visible for testing.
    replaceAll(src, repl) {
        return this.replaceAllFunc(src, ()=>repl, 2 * src.length + 1);
    }
    /**
   * Returns a copy of {@code src} in which only the first match for this regexp has been replaced
   * by {@code repl}. No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
   * replacement string.
   */ // This is visible for testing.
    replaceFirst(src, repl) {
        return this.replaceAllFunc(src, ()=>repl, 1);
    }
    /**
   * Returns a copy of {@code src} in which at most {@code maxReplaces} matches for this regexp have
   * been replaced by the return value of of function {@code repl} (whose first argument is the
   * matched string). No support is provided for expressions (e.g. {@code \1} or {@code $1}) in the
   * replacement string.
   */ // This is visible for testing.
    replaceAllFunc(src, replFunc, maxReplaces) {
        let lastMatchEnd = 0;
        let searchPos = 0;
        let out = '';
        const input = MachineInput.fromUTF16(src);
        let numReplaces = 0;
        while(searchPos <= src.length){
            const a = this.doExecute(input, searchPos, RE2Flags.UNANCHORED, 2);
            if (a === null || a.length === 0) break;
            out += src.substring(lastMatchEnd, a[0]);
            if (a[1] > lastMatchEnd || a[0] === 0) {
                out += replFunc(src.substring(a[0], a[1]));
                numReplaces++;
            }
            lastMatchEnd = a[1];
            const width = input.step(searchPos) & 7;
            if (searchPos + width > a[1]) searchPos += width;
            else if (searchPos + 1 > a[1]) searchPos++;
            else searchPos = a[1];
            if (numReplaces >= maxReplaces) break;
        }
        out += src.substring(lastMatchEnd);
        return out;
    }
    // The number of capture values in the program may correspond
    // to fewer capturing expressions than are in the regexp.
    // For example, "(a){0}" turns into an empty program, so the
    // maximum capture in the program is 0 but we need to return
    // an expression for \1.  Pad returns a with -1s appended as needed;
    // the result may alias a.
    pad(a) {
        if (a === null) return null;
        let n = (1 + this.numSubexp) * 2;
        if (a.length < n) {
            let a2 = new Array(n).fill(-1);
            for(let i = 0; i < a.length; i++)a2[i] = a[i];
            a = a2;
        }
        return a;
    }
    // Find matches in input.
    allMatches(input, n, deliverFun = (v)=>v) {
        let result = [];
        const end = input.endPos();
        if (n < 0) n = end + 1;
        let pos = 0;
        let i = 0;
        let prevMatchEnd = -1;
        while(i < n && pos <= end){
            const matches = this.doExecute(input, pos, RE2Flags.UNANCHORED, this.prog.numCap);
            if (matches === null || matches.length === 0) break;
            let accept = true;
            if (matches[1] === pos) {
                if (matches[0] === prevMatchEnd) accept = false;
                const r = input.step(pos);
                if (r < 0) pos = end + 1;
                else pos += r & 7;
            } else pos = matches[1];
            prevMatchEnd = matches[1];
            if (accept) {
                result.push(deliverFun(this.pad(matches)));
                i++;
            }
        }
        return result;
    }
    // Legacy Go-style interface; preserved (package-private) for better
    // test coverage.
    //
    // There are 16 methods of RE2 that match a regular expression and
    // identify the matched text.  Their names are matched by this regular
    // expression:
    //
    //    find(All)?(UTF8)?(Submatch)?(Index)?
    //
    // If 'All' is present, the routine matches successive non-overlapping
    // matches of the entire expression.  Empty matches abutting a
    // preceding match are ignored.  The return value is an array
    // containing the successive return values of the corresponding
    // non-All routine.  These routines take an extra integer argument, n;
    // if n >= 0, the function returns at most n matches/submatches.
    //
    // If 'UTF8' is present, the argument is a UTF-8 encoded byte[] array;
    // otherwise it is a UTF-16 encoded js string; return values
    // are adjusted as appropriate.
    //
    // If 'Submatch' is present, the return value is an list identifying
    // the successive submatches of the expression.  Submatches are
    // matches of parenthesized subexpressions within the regular
    // expression, numbered from left to right in order of opening
    // parenthesis.  Submatch 0 is the match of the entire expression,
    // submatch 1 the match of the first parenthesized subexpression, and
    // so on.
    //
    // If 'Index' is present, matches and submatches are identified by
    // byte index pairs within the input string: result[2*n:2*n+1]
    // identifies the indexes of the nth submatch.  The pair for n==0
    // identifies the match of the entire expression.  If 'Index' is not
    // present, the match is identified by the text of the match/submatch.
    // If an index is negative, it means that subexpression did not match
    // any string in the input.
    /**
   * Returns an array holding the text of the leftmost match in {@code b} of this regular
   * expression.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findUTF8(b) {
        const a = this.doExecute(MachineInput.fromUTF8(b), 0, RE2Flags.UNANCHORED, 2);
        if (a === null) return null;
        return b.slice(a[0], a[1]);
    }
    /**
   * Returns a two-element array of integers defining the location of the leftmost match in
   * {@code b} of this regular expression. The match itself is at {@code b[loc[0]...loc[1]]}.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findUTF8Index(b) {
        const a = this.doExecute(MachineInput.fromUTF8(b), 0, RE2Flags.UNANCHORED, 2);
        if (a === null) return null;
        return a.slice(0, 2);
    }
    /**
   * Returns a string holding the text of the leftmost match in {@code s} of this regular
   * expression.
   *
   * If there is no match, the return value is an empty string, but it will also be empty if the
   * regular expression successfully matches an empty string. Use {@link #findIndex} or
   * {@link #findSubmatch} if it is necessary to distinguish these cases.
   */ // This is visible for testing.
    find(s) {
        const a = this.doExecute(MachineInput.fromUTF16(s), 0, RE2Flags.UNANCHORED, 2);
        if (a === null) return '';
        return s.substring(a[0], a[1]);
    }
    /**
   * Returns a two-element array of integers defining the location of the leftmost match in
   * {@code s} of this regular expression. The match itself is at
   * {@code s.substring(loc[0], loc[1])}.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findIndex(s) {
        return this.doExecute(MachineInput.fromUTF16(s), 0, RE2Flags.UNANCHORED, 2);
    }
    /**
   * Returns an array of arrays the text of the leftmost match of the regular expression in
   * {@code b} and the matches, if any, of its subexpressions, as defined by the <a
   * href='#submatch'>Submatch</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findUTF8Submatch(b) {
        const a = this.doExecute(MachineInput.fromUTF8(b), 0, RE2Flags.UNANCHORED, this.prog.numCap);
        if (a === null) return null;
        const ret = new Array(1 + this.numSubexp).fill(null);
        for(let i = 0; i < ret.length; i++)if (2 * i < a.length && a[2 * i] >= 0) ret[i] = b.slice(a[2 * i], a[2 * i + 1]);
        return ret;
    }
    /**
   * Returns an array holding the index pairs identifying the leftmost match of this regular
   * expression in {@code b} and the matches, if any, of its subexpressions, as defined by the the
   * <a href='#submatch'>Submatch</a> and <a href='#index'>Index</a> descriptions above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findUTF8SubmatchIndex(b) {
        return this.pad(this.doExecute(MachineInput.fromUTF8(b), 0, RE2Flags.UNANCHORED, this.prog.numCap));
    }
    /**
   * Returns an array of strings holding the text of the leftmost match of the regular expression in
   * {@code s} and the matches, if any, of its subexpressions, as defined by the <a
   * href='#submatch'>Submatch</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findSubmatch(s) {
        const a = this.doExecute(MachineInput.fromUTF16(s), 0, RE2Flags.UNANCHORED, this.prog.numCap);
        if (a === null) return null;
        const ret = new Array(1 + this.numSubexp).fill(null);
        for(let i = 0; i < ret.length; i++)if (2 * i < a.length && a[2 * i] >= 0) ret[i] = s.substring(a[2 * i], a[2 * i + 1]);
        return ret;
    }
    /**
   * Returns an array holding the index pairs identifying the leftmost match of this regular
   * expression in {@code s} and the matches, if any, of its subexpressions, as defined by the <a
   * href='#submatch'>Submatch</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findSubmatchIndex(s) {
        return this.pad(this.doExecute(MachineInput.fromUTF16(s), 0, RE2Flags.UNANCHORED, this.prog.numCap));
    }
    /**
   * {@code findAllUTF8()} is the <a href='#all'>All</a> version of {@link #findUTF8}; it returns a
   * list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   *
   * TODO(adonovan): think about defining a byte slice view class, like a read-only Go slice backed
   * by |b|.
   */ // This is visible for testing.
    findAllUTF8(b, n) {
        const result = this.allMatches(MachineInput.fromUTF8(b), n, (match)=>b.slice(match[0], match[1]));
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllUTF8Index} is the <a href='#all'>All</a> version of {@link #findUTF8Index}; it
   * returns a list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllUTF8Index(b, n) {
        const result = this.allMatches(MachineInput.fromUTF8(b), n, (match)=>match.slice(0, 2));
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAll} is the <a href='#all'>All</a> version of {@link #find}; it returns a list of up
   * to {@code n} successive matches of the expression, as defined by the <a href='#all'>All</a>
   * description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAll(s, n) {
        const result = this.allMatches(MachineInput.fromUTF16(s), n, (match)=>s.substring(match[0], match[1]));
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllIndex} is the <a href='#all'>All</a> version of {@link #findIndex}; it returns a
   * list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllIndex(s, n) {
        const result = this.allMatches(MachineInput.fromUTF16(s), n, (match)=>match.slice(0, 2));
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllUTF8Submatch} is the <a href='#all'>All</a> version of {@link #findUTF8Submatch};
   * it returns a list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllUTF8Submatch(b, n) {
        const result = this.allMatches(MachineInput.fromUTF8(b), n, (match)=>{
            let slice = new Array(match.length / 2 | 0).fill(null);
            for(let j = 0; j < slice.length; j++)if (match[2 * j] >= 0) slice[j] = b.slice(match[2 * j], match[2 * j + 1]);
            return slice;
        });
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllUTF8SubmatchIndex} is the <a href='#all'>All</a> version of
   * {@link #findUTF8SubmatchIndex}; it returns a list of up to {@code n} successive matches of the
   * expression, as defined by the <a href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllUTF8SubmatchIndex(b, n) {
        const result = this.allMatches(MachineInput.fromUTF8(b), n);
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllSubmatch} is the <a href='#all'>All</a> version of {@link #findSubmatch}; it
   * returns a list of up to {@code n} successive matches of the expression, as defined by the <a
   * href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllSubmatch(s, n) {
        const result = this.allMatches(MachineInput.fromUTF16(s), n, (match)=>{
            let slice = new Array(match.length / 2 | 0).fill(null);
            for(let j = 0; j < slice.length; j++)if (match[2 * j] >= 0) slice[j] = s.substring(match[2 * j], match[2 * j + 1]);
            return slice;
        });
        if (result.length === 0) return null;
        return result;
    }
    /**
   * {@code findAllSubmatchIndex} is the <a href='#all'>All</a> version of
   * {@link #findSubmatchIndex}; it returns a list of up to {@code n} successive matches of the
   * expression, as defined by the <a href='#all'>All</a> description above.
   *
   * A return value of null indicates no match.
   */ // This is visible for testing.
    findAllSubmatchIndex(s, n) {
        const result = this.allMatches(MachineInput.fromUTF16(s), n);
        if (result.length === 0) return null;
        return result;
    }
}
/**
 * A compiled representation of an RE2 regular expression
 *
 * The matching functions take {@code String} arguments instead of the more general Java
 * {@code CharSequence} since the latter doesn't provide UTF-16 decoding.
 *
 *
 * @author rsc@google.com (Russ Cox)
 * @class
 */ class RE2JS {
    /**
   * Flag: case insensitive matching.
   */ static CASE_INSENSITIVE = 1;
    /**
   * Flag: dot ({@code .}) matches all characters, including newline.
   */ static DOTALL = 2;
    /**
   * Flag: multiline matching: {@code ^} and {@code $} match at beginning and end of line, not just
   * beginning and end of input.
   */ static MULTILINE = 4;
    /**
   * Flag: Unicode groups (e.g. {@code \p\ Greek\} ) will be syntax errors.
   */ static DISABLE_UNICODE_GROUPS = 8;
    /**
   * Flag: matches longest possible string.
   */ static LONGEST_MATCH = 16;
    /**
   * Returns a literal pattern string for the specified string.
   *
   * This method produces a string that can be used to create a <code>RE2JS</code> that would
   * match the string <code>s</code> as if it were a literal pattern.
   *
   * Metacharacters or escape sequences in the input sequence will be given no special meaning.
   *
   * @param {string} str The string to be literalized
   * @returns {string} A literal string replacement
   */ static quote(str) {
        return Utils.quoteMeta(str);
    }
    /**
   * Helper: create new RE2JS with given regex and flags. Flregex is the regex with flags applied.
   * @param {string} regex
   * @param {number} [flags=0]
   * @returns {RE2JS}
   */ static compile(regex, flags = 0) {
        let fregex = regex;
        if ((flags & RE2JS.CASE_INSENSITIVE) !== 0) fregex = `(?i)${fregex}`;
        if ((flags & RE2JS.DOTALL) !== 0) fregex = `(?s)${fregex}`;
        if ((flags & RE2JS.MULTILINE) !== 0) fregex = `(?m)${fregex}`;
        if ((flags & ~(RE2JS.MULTILINE | RE2JS.DOTALL | RE2JS.CASE_INSENSITIVE | RE2JS.DISABLE_UNICODE_GROUPS | RE2JS.LONGEST_MATCH)) !== 0) throw new RE2JSFlagsException('Flags should only be a combination of MULTILINE, DOTALL, CASE_INSENSITIVE, DISABLE_UNICODE_GROUPS, LONGEST_MATCH');
        let re2Flags = RE2Flags.PERL;
        if ((flags & RE2JS.DISABLE_UNICODE_GROUPS) !== 0) re2Flags &= ~RE2Flags.UNICODE_GROUPS;
        const p = new RE2JS(regex, flags);
        // The compiled RE2 regexp.
        p.re2Input = RE2.compileImpl(fregex, re2Flags, (flags & RE2JS.LONGEST_MATCH) !== 0);
        return p;
    }
    /**
   * Matches a string against a regular expression.
   *
   * @param {string} regex the regular expression
   * @param {string|number[]} input the input
   * @returns {boolean} true if the regular expression matches the entire input
   * @throws RE2JSSyntaxException if the regular expression is malformed
   */ static matches(regex, input) {
        return RE2JS.compile(regex).matcher(input).matches();
    }
    /**
   * This is visible for testing.
   * @private
   */ static initTest(pattern, flags, re2) {
        if (pattern == null) throw new Error('pattern is null');
        if (re2 == null) throw new Error('re2 is null');
        const p = new RE2JS(pattern, flags);
        // The compiled RE2 regexp.
        p.re2Input = re2;
        return p;
    }
    /**
   *
   * @param {string} pattern
   * @param {number} flags
   */ constructor(pattern, flags){
        // The pattern string at construction time.
        this.patternInput = pattern;
        // The flags at construction time.
        this.flagsInput = flags;
    }
    /**
   * Releases memory used by internal caches associated with this pattern. Does not change the
   * observable behaviour. Useful for tests that detect memory leaks via allocation tracking.
   */ reset() {
        this.re2Input.reset();
    }
    /**
   * Returns the flags used in the constructor.
   * @returns {number}
   */ flags() {
        return this.flagsInput;
    }
    /**
   * Returns the pattern used in the constructor.
   * @returns {string}
   */ pattern() {
        return this.patternInput;
    }
    re2() {
        return this.re2Input;
    }
    /**
   * Matches a string against a regular expression.
   *
   * @param {string|number[]} input the input
   * @returns {boolean} true if the regular expression matches the entire input
   */ matches(input) {
        return this.matcher(input).matches();
    }
    /**
   * Creates a new {@code Matcher} matching the pattern against the input.
   *
   * @param {string|number[]} input the input string
   * @returns {Matcher}
   */ matcher(input) {
        if (Array.isArray(input)) input = MatcherInput.utf8(input);
        return new Matcher(this, input);
    }
    /**
   * Splits input around instances of the regular expression. It returns an array giving the strings
   * that occur before, between, and after instances of the regular expression.
   *
   * If {@code limit <= 0}, there is no limit on the size of the returned array. If
   * {@code limit == 0}, empty strings that would occur at the end of the array are omitted. If
   * {@code limit > 0}, at most limit strings are returned. The final string contains the remainder
   * of the input, possibly including additional matches of the pattern.
   *
   * @param {string} input the input string to be split
   * @param {number} [limit=0] the limit
   * @returns {string[]} the split strings
   */ split(input, limit = 0) {
        const m = this.matcher(input);
        const result = [];
        let emptiesSkipped = 0;
        let last = 0;
        while(m.find()){
            if (last === 0 && m.end() === 0) {
                // Zero-width match at the beginning, skip
                last = m.end();
                continue;
            }
            if (limit > 0 && result.length === limit - 1) break;
            if (last === m.start()) // Empty match, may or may not be trailing.
            {
                if (limit === 0) {
                    emptiesSkipped += 1;
                    last = m.end();
                    continue;
                }
            } else // If emptiesSkipped > 0 then limit == 0 and we have non-trailing empty matches to add before
            // this non-empty match.
            while(emptiesSkipped > 0){
                result.push('');
                emptiesSkipped -= 1;
            }
            result.push(m.substring(last, m.start()));
            last = m.end();
        }
        if (limit === 0 && last !== m.inputLength()) {
            // Unlimited match, no more delimiters but we have a non-empty input at the end. Catch up any skipped empty
            // matches, then emit the final match.
            while(emptiesSkipped > 0){
                result.push('');
                emptiesSkipped -= 1;
            }
            result.push(m.substring(last, m.inputLength()));
        }
        if (limit !== 0 || result.length === 0) result.push(m.substring(last, m.inputLength()));
        return result;
    }
    /**
   *
   * @returns {string}
   */ toString() {
        return this.patternInput;
    }
    /**
   * Returns the number of capturing groups in this matcher's pattern. Group zero denotes the entire
   * pattern and is excluded from this count.
   *
   * @returns {number} the number of capturing groups in this pattern
   */ groupCount() {
        return this.re2Input.numberOfCapturingGroups();
    }
    /**
   * Return a map of the capturing groups in this matcher's pattern, where key is the name and value
   * is the index of the group in the pattern.
   * @returns {*}
   */ namedGroups() {
        return this.re2Input.namedGroups;
    }
    /**
   *
   * @param {*} other
   * @returns {boolean}
   */ equals(other) {
        if (this === other) return true;
        if (other === null || this.constructor !== other.constructor) return false;
        return this.flagsInput === other.flagsInput && this.patternInput === other.patternInput;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9JHfQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _storage = require("@firebase/storage");
parcelHelpers.exportAll(_storage, exports);

},{"@firebase/storage":"jaXA2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jaXA2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StorageError", ()=>StorageError);
parcelHelpers.export(exports, "StorageErrorCode", ()=>StorageErrorCode);
parcelHelpers.export(exports, "StringFormat", ()=>StringFormat);
parcelHelpers.export(exports, "_FbsBlob", ()=>FbsBlob);
parcelHelpers.export(exports, "_Location", ()=>Location);
parcelHelpers.export(exports, "_TaskEvent", ()=>TaskEvent);
parcelHelpers.export(exports, "_TaskState", ()=>TaskState);
parcelHelpers.export(exports, "_UploadTask", ()=>UploadTask);
parcelHelpers.export(exports, "_dataFromString", ()=>dataFromString);
parcelHelpers.export(exports, "_getChild", ()=>_getChild);
parcelHelpers.export(exports, "_invalidArgument", ()=>invalidArgument);
parcelHelpers.export(exports, "_invalidRootOperation", ()=>invalidRootOperation);
parcelHelpers.export(exports, "connectStorageEmulator", ()=>connectStorageEmulator);
parcelHelpers.export(exports, "deleteObject", ()=>deleteObject);
parcelHelpers.export(exports, "getBlob", ()=>getBlob);
parcelHelpers.export(exports, "getBytes", ()=>getBytes);
parcelHelpers.export(exports, "getDownloadURL", ()=>getDownloadURL);
parcelHelpers.export(exports, "getMetadata", ()=>getMetadata);
parcelHelpers.export(exports, "getStorage", ()=>getStorage);
parcelHelpers.export(exports, "getStream", ()=>getStream);
parcelHelpers.export(exports, "list", ()=>list);
parcelHelpers.export(exports, "listAll", ()=>listAll);
parcelHelpers.export(exports, "ref", ()=>ref);
parcelHelpers.export(exports, "updateMetadata", ()=>updateMetadata);
parcelHelpers.export(exports, "uploadBytes", ()=>uploadBytes);
parcelHelpers.export(exports, "uploadBytesResumable", ()=>uploadBytesResumable);
parcelHelpers.export(exports, "uploadString", ()=>uploadString);
var _app = require("@firebase/app");
var _util = require("@firebase/util");
var _component = require("@firebase/component");
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Constants used in the Firebase Storage library.
 */ /**
 * Domain name for firebase storage.
 */ const DEFAULT_HOST = 'firebasestorage.googleapis.com';
/**
 * The key in Firebase config json for the storage bucket.
 */ const CONFIG_STORAGE_BUCKET_KEY = 'storageBucket';
/**
 * 2 minutes
 *
 * The timeout for all operations except upload.
 */ const DEFAULT_MAX_OPERATION_RETRY_TIME = 120000;
/**
 * 10 minutes
 *
 * The timeout for upload.
 */ const DEFAULT_MAX_UPLOAD_RETRY_TIME = 600000;
/**
 * 1 second
 */ const DEFAULT_MIN_SLEEP_TIME_MILLIS = 1000;
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An error returned by the Firebase Storage SDK.
 * @public
 */ class StorageError extends (0, _util.FirebaseError) {
    /**
     * @param code - A `StorageErrorCode` string to be prefixed with 'storage/' and
     *  added to the end of the message.
     * @param message  - Error message.
     * @param status_ - Corresponding HTTP Status Code
     */ constructor(code, message, status_ = 0){
        super(prependCode(code), `Firebase Storage: ${message} (${prependCode(code)})`);
        this.status_ = status_;
        /**
         * Stores custom error data unique to the `StorageError`.
         */ this.customData = {
            serverResponse: null
        };
        this._baseMessage = this.message;
        // Without this, `instanceof StorageError`, in tests for example,
        // returns false.
        Object.setPrototypeOf(this, StorageError.prototype);
    }
    get status() {
        return this.status_;
    }
    set status(status) {
        this.status_ = status;
    }
    /**
     * Compares a `StorageErrorCode` against this error's code, filtering out the prefix.
     */ _codeEquals(code) {
        return prependCode(code) === this.code;
    }
    /**
     * Optional response message that was added by the server.
     */ get serverResponse() {
        return this.customData.serverResponse;
    }
    set serverResponse(serverResponse) {
        this.customData.serverResponse = serverResponse;
        if (this.customData.serverResponse) this.message = `${this._baseMessage}\n${this.customData.serverResponse}`;
        else this.message = this._baseMessage;
    }
}
/**
 * @public
 * Error codes that can be attached to `StorageError` objects.
 */ var StorageErrorCode;
(function(StorageErrorCode) {
    // Shared between all platforms
    StorageErrorCode["UNKNOWN"] = "unknown";
    StorageErrorCode["OBJECT_NOT_FOUND"] = "object-not-found";
    StorageErrorCode["BUCKET_NOT_FOUND"] = "bucket-not-found";
    StorageErrorCode["PROJECT_NOT_FOUND"] = "project-not-found";
    StorageErrorCode["QUOTA_EXCEEDED"] = "quota-exceeded";
    StorageErrorCode["UNAUTHENTICATED"] = "unauthenticated";
    StorageErrorCode["UNAUTHORIZED"] = "unauthorized";
    StorageErrorCode["UNAUTHORIZED_APP"] = "unauthorized-app";
    StorageErrorCode["RETRY_LIMIT_EXCEEDED"] = "retry-limit-exceeded";
    StorageErrorCode["INVALID_CHECKSUM"] = "invalid-checksum";
    StorageErrorCode["CANCELED"] = "canceled";
    // JS specific
    StorageErrorCode["INVALID_EVENT_NAME"] = "invalid-event-name";
    StorageErrorCode["INVALID_URL"] = "invalid-url";
    StorageErrorCode["INVALID_DEFAULT_BUCKET"] = "invalid-default-bucket";
    StorageErrorCode["NO_DEFAULT_BUCKET"] = "no-default-bucket";
    StorageErrorCode["CANNOT_SLICE_BLOB"] = "cannot-slice-blob";
    StorageErrorCode["SERVER_FILE_WRONG_SIZE"] = "server-file-wrong-size";
    StorageErrorCode["NO_DOWNLOAD_URL"] = "no-download-url";
    StorageErrorCode["INVALID_ARGUMENT"] = "invalid-argument";
    StorageErrorCode["INVALID_ARGUMENT_COUNT"] = "invalid-argument-count";
    StorageErrorCode["APP_DELETED"] = "app-deleted";
    StorageErrorCode["INVALID_ROOT_OPERATION"] = "invalid-root-operation";
    StorageErrorCode["INVALID_FORMAT"] = "invalid-format";
    StorageErrorCode["INTERNAL_ERROR"] = "internal-error";
    StorageErrorCode["UNSUPPORTED_ENVIRONMENT"] = "unsupported-environment";
})(StorageErrorCode || (StorageErrorCode = {}));
function prependCode(code) {
    return 'storage/' + code;
}
function unknown() {
    const message = "An unknown error occurred, please check the error payload for server response.";
    return new StorageError(StorageErrorCode.UNKNOWN, message);
}
function objectNotFound(path) {
    return new StorageError(StorageErrorCode.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function quotaExceeded(bucket) {
    return new StorageError(StorageErrorCode.QUOTA_EXCEEDED, "Quota for bucket '" + bucket + "' exceeded, please view quota on " + 'https://firebase.google.com/pricing/.');
}
function unauthenticated() {
    const message = "User is not authenticated, please authenticate using Firebase Authentication and try again.";
    return new StorageError(StorageErrorCode.UNAUTHENTICATED, message);
}
function unauthorizedApp() {
    return new StorageError(StorageErrorCode.UNAUTHORIZED_APP, 'This app does not have permission to access Firebase Storage on this project.');
}
function unauthorized(path) {
    return new StorageError(StorageErrorCode.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function retryLimitExceeded() {
    return new StorageError(StorageErrorCode.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function canceled() {
    return new StorageError(StorageErrorCode.CANCELED, 'User canceled the upload/download.');
}
function invalidUrl(url) {
    return new StorageError(StorageErrorCode.INVALID_URL, "Invalid URL '" + url + "'.");
}
function invalidDefaultBucket(bucket) {
    return new StorageError(StorageErrorCode.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function noDefaultBucket() {
    return new StorageError(StorageErrorCode.NO_DEFAULT_BUCKET, "No default bucket found. Did you set the '" + CONFIG_STORAGE_BUCKET_KEY + "' property when initializing the app?");
}
function cannotSliceBlob() {
    return new StorageError(StorageErrorCode.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function serverFileWrongSize() {
    return new StorageError(StorageErrorCode.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function noDownloadURL() {
    return new StorageError(StorageErrorCode.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function missingPolyFill(polyFill) {
    return new StorageError(StorageErrorCode.UNSUPPORTED_ENVIRONMENT, `${polyFill} is missing. Make sure to install the required polyfills. See https://firebase.google.com/docs/web/environments-js-sdk#polyfills for more information.`);
}
/**
 * @internal
 */ function invalidArgument(message) {
    return new StorageError(StorageErrorCode.INVALID_ARGUMENT, message);
}
function appDeleted() {
    return new StorageError(StorageErrorCode.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name - The name of the operation that was invalid.
 *
 * @internal
 */ function invalidRootOperation(name) {
    return new StorageError(StorageErrorCode.INVALID_ROOT_OPERATION, "The operation '" + name + "' cannot be performed on a root reference, create a non-root " + "reference using child, such as .child('file.png').");
}
/**
 * @param format - The format that was not valid.
 * @param message - A message describing the format violation.
 */ function invalidFormat(format, message) {
    return new StorageError(StorageErrorCode.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message - A message describing the internal error.
 */ function internalError(message) {
    throw new StorageError(StorageErrorCode.INTERNAL_ERROR, 'Internal error: ' + message);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Firebase Storage location data.
 *
 * @internal
 */ class Location {
    constructor(bucket, path){
        this.bucket = bucket;
        this.path_ = path;
    }
    get path() {
        return this.path_;
    }
    get isRoot() {
        return this.path.length === 0;
    }
    fullServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    }
    bucketOnlyServerUrl() {
        const encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    }
    static makeFromBucketSpec(bucketString, host) {
        let bucketLocation;
        try {
            bucketLocation = Location.makeFromUrl(bucketString, host);
        } catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new Location(bucketString, '');
        }
        if (bucketLocation.path === '') return bucketLocation;
        else throw invalidDefaultBucket(bucketString);
    }
    static makeFromUrl(url, host) {
        let location = null;
        const bucketDomain = '([A-Za-z0-9.\\-_]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') loc.path_ = loc.path_.slice(0, -1);
        }
        const gsPath = '(/(.*))?$';
        const gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        const gsIndices = {
            bucket: 1,
            path: 3
        };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        const version = 'v[A-Za-z0-9_]+';
        const firebaseStorageHost = host.replace(/[.]/g, '\\.');
        const firebaseStoragePath = '(/([^?#]*).*)?$';
        const firebaseStorageRegExp = new RegExp(`^https?://${firebaseStorageHost}/${version}/b/${bucketDomain}/o${firebaseStoragePath}`, 'i');
        const firebaseStorageIndices = {
            bucket: 1,
            path: 3
        };
        const cloudStorageHost = host === DEFAULT_HOST ? '(?:storage.googleapis.com|storage.cloud.google.com)' : host;
        const cloudStoragePath = '([^?#]*)';
        const cloudStorageRegExp = new RegExp(`^https?://${cloudStorageHost}/${bucketDomain}/${cloudStoragePath}`, 'i');
        const cloudStorageIndices = {
            bucket: 1,
            path: 2
        };
        const groups = [
            {
                regex: gsRegex,
                indices: gsIndices,
                postModify: gsModify
            },
            {
                regex: firebaseStorageRegExp,
                indices: firebaseStorageIndices,
                postModify: httpModify
            },
            {
                regex: cloudStorageRegExp,
                indices: cloudStorageIndices,
                postModify: httpModify
            }
        ];
        for(let i = 0; i < groups.length; i++){
            const group = groups[i];
            const captures = group.regex.exec(url);
            if (captures) {
                const bucketValue = captures[group.indices.bucket];
                let pathValue = captures[group.indices.path];
                if (!pathValue) pathValue = '';
                location = new Location(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) throw invalidUrl(url);
        return location;
    }
}
/**
 * A request whose promise always fails.
 */ class FailRequest {
    constructor(error){
        this.promise_ = Promise.reject(error);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(_appDelete = false) {}
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Accepts a callback for an action to perform (`doRequest`),
 * and then a callback for when the backoff has completed (`backoffCompleteCb`).
 * The callback sent to start requires an argument to call (`onRequestComplete`).
 * When `start` calls `doRequest`, it passes a callback for when the request has
 * completed, `onRequestComplete`. Based on this, the backoff continues, with
 * another call to `doRequest` and the above loop continues until the timeout
 * is hit, or a successful response occurs.
 * @description
 * @param doRequest Callback to perform request
 * @param backoffCompleteCb Callback to call when backoff has been completed
 */ function start(doRequest, // eslint-disable-next-line @typescript-eslint/no-explicit-any
backoffCompleteCb, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    let waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    // TODO: find a way to exclude Node type definition for storage because storage only works in browser
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let retryTimeoutId = null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let globalTimeoutId = null;
    let hitTimeout = false;
    let cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    let triggeredCallback = false;
    function triggerCallback(...args) {
        if (!triggeredCallback) {
            triggeredCallback = true;
            backoffCompleteCb.apply(null, args);
        }
    }
    function callWithDelay(millis) {
        retryTimeoutId = setTimeout(()=>{
            retryTimeoutId = null;
            doRequest(responseHandler, canceled());
        }, millis);
    }
    function clearGlobalTimeout() {
        if (globalTimeoutId) clearTimeout(globalTimeoutId);
    }
    function responseHandler(success, ...args) {
        if (triggeredCallback) {
            clearGlobalTimeout();
            return;
        }
        if (success) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        const mustStop = canceled() || hitTimeout;
        if (mustStop) {
            clearGlobalTimeout();
            triggerCallback.call(null, success, ...args);
            return;
        }
        if (waitSeconds < 64) /* TODO(andysoto): don't back off so quickly if we know we're offline. */ waitSeconds *= 2;
        let waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        } else waitMillis = (waitSeconds + Math.random()) * 1000;
        callWithDelay(waitMillis);
    }
    let stopped = false;
    function stop(wasTimeout) {
        if (stopped) return;
        stopped = true;
        clearGlobalTimeout();
        if (triggeredCallback) return;
        if (retryTimeoutId !== null) {
            if (!wasTimeout) cancelState = 2;
            clearTimeout(retryTimeoutId);
            callWithDelay(0);
        } else if (!wasTimeout) cancelState = 1;
    }
    callWithDelay(0);
    globalTimeoutId = setTimeout(()=>{
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */ function stop(id) {
    id(false);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function isJustDef(p) {
    return p !== void 0;
}
// eslint-disable-next-line @typescript-eslint/ban-types
function isFunction(p) {
    return typeof p === 'function';
}
function isNonArrayObject(p) {
    return typeof p === 'object' && !Array.isArray(p);
}
function isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function isNativeBlob(p) {
    return isNativeBlobDefined() && p instanceof Blob;
}
function isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}
function validateNumber(argument, minValue, maxValue, value) {
    if (value < minValue) throw invalidArgument(`Invalid value for '${argument}'. Expected ${minValue} or greater.`);
    if (value > maxValue) throw invalidArgument(`Invalid value for '${argument}'. Expected ${maxValue} or less.`);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function makeUrl(urlPart, host, protocol) {
    let origin = host;
    if (protocol == null) origin = `https://${host}`;
    return `${protocol}://${origin}/v0${urlPart}`;
}
function makeQueryString(params) {
    const encode = encodeURIComponent;
    let queryPart = '?';
    for(const key in params)if (params.hasOwnProperty(key)) {
        const nextPart = encode(key) + '=' + encode(params[key]);
        queryPart = queryPart + nextPart + '&';
    }
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}
/**
 * Error codes for requests made by the XhrIo wrapper.
 */ var ErrorCode;
(function(ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})(ErrorCode || (ErrorCode = {}));
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks the status code to see if the action should be retried.
 *
 * @param status Current HTTP status code returned by server.
 * @param additionalRetryCodes additional retry codes to check against
 */ function isRetryStatusCode(status, additionalRetryCodes) {
    // The codes for which to retry came from this page:
    // https://cloud.google.com/storage/docs/exponential-backoff
    const isFiveHundredCode = status >= 500 && status < 600;
    const extraRetryCodes = [
        // Request Timeout: web server didn't receive full request in time.
        408,
        // Too Many Requests: you're getting rate-limited, basically.
        429
    ];
    const isExtraRetryCode = extraRetryCodes.indexOf(status) !== -1;
    const isAdditionalRetryCode = additionalRetryCodes.indexOf(status) !== -1;
    return isFiveHundredCode || isExtraRetryCode || isAdditionalRetryCode;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Handles network logic for all Storage Requests, including error reporting and
 * retries with backoff.
 *
 * @param I - the type of the backend's network response.
 * @param - O the output type used by the rest of the SDK. The conversion
 * happens in the specified `callback_`.
 */ class NetworkRequest {
    constructor(url_, method_, headers_, body_, successCodes_, additionalRetryCodes_, callback_, errorCallback_, timeout_, progressCallback_, connectionFactory_, retry = true, isUsingEmulator = false){
        this.url_ = url_;
        this.method_ = method_;
        this.headers_ = headers_;
        this.body_ = body_;
        this.successCodes_ = successCodes_;
        this.additionalRetryCodes_ = additionalRetryCodes_;
        this.callback_ = callback_;
        this.errorCallback_ = errorCallback_;
        this.timeout_ = timeout_;
        this.progressCallback_ = progressCallback_;
        this.connectionFactory_ = connectionFactory_;
        this.retry = retry;
        this.isUsingEmulator = isUsingEmulator;
        this.pendingConnection_ = null;
        this.backoffId_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.promise_ = new Promise((resolve, reject)=>{
            this.resolve_ = resolve;
            this.reject_ = reject;
            this.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */ start_() {
        const doTheRequest = (backoffCallback, canceled)=>{
            if (canceled) {
                backoffCallback(false, new RequestEndStatus(false, null, true));
                return;
            }
            const connection = this.connectionFactory_();
            this.pendingConnection_ = connection;
            const progressListener = (progressEvent)=>{
                const loaded = progressEvent.loaded;
                const total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (this.progressCallback_ !== null) this.progressCallback_(loaded, total);
            };
            if (this.progressCallback_ !== null) connection.addUploadProgressListener(progressListener);
            // connection.send() never rejects, so we don't need to have a error handler or use catch on the returned promise.
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            connection.send(this.url_, this.method_, this.isUsingEmulator, this.body_, this.headers_).then(()=>{
                if (this.progressCallback_ !== null) connection.removeUploadProgressListener(progressListener);
                this.pendingConnection_ = null;
                const hitServer = connection.getErrorCode() === ErrorCode.NO_ERROR;
                const status = connection.getStatus();
                if (!hitServer || isRetryStatusCode(status, this.additionalRetryCodes_) && this.retry) {
                    const wasCanceled = connection.getErrorCode() === ErrorCode.ABORT;
                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                const successCode = this.successCodes_.indexOf(status) !== -1;
                backoffCallback(true, new RequestEndStatus(successCode, connection));
            });
        };
        /**
         * @param requestWentThrough - True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */ const backoffDone = (requestWentThrough, status)=>{
            const resolve = this.resolve_;
            const reject = this.reject_;
            const connection = status.connection;
            if (status.wasSuccessCode) try {
                const result = this.callback_(connection, connection.getResponse());
                if (isJustDef(result)) resolve(result);
                else resolve();
            } catch (e) {
                reject(e);
            }
            else {
                if (connection !== null) {
                    const err = unknown();
                    err.serverResponse = connection.getErrorText();
                    if (this.errorCallback_) reject(this.errorCallback_(connection, err));
                    else reject(err);
                } else if (status.canceled) {
                    const err = this.appDelete_ ? appDeleted() : canceled();
                    reject(err);
                } else {
                    const err = retryLimitExceeded();
                    reject(err);
                }
            }
        };
        if (this.canceled_) backoffDone(false, new RequestEndStatus(false, null, true));
        else this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
    }
    /** @inheritDoc */ getPromise() {
        return this.promise_;
    }
    /** @inheritDoc */ cancel(appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) stop(this.backoffId_);
        if (this.pendingConnection_ !== null) this.pendingConnection_.abort();
    }
}
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled - Defaults to false.
 */ class RequestEndStatus {
    constructor(wasSuccessCode, connection, canceled){
        this.wasSuccessCode = wasSuccessCode;
        this.connection = connection;
        this.canceled = !!canceled;
    }
}
function addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) headers['Authorization'] = 'Firebase ' + authToken;
}
function addVersionHeader_(headers, firebaseVersion) {
    headers['X-Firebase-Storage-Version'] = 'webjs/' + (firebaseVersion ?? 'AppManager');
}
function addGmpidHeader_(headers, appId) {
    if (appId) headers['X-Firebase-GMPID'] = appId;
}
function addAppCheckHeader_(headers, appCheckToken) {
    if (appCheckToken !== null) headers['X-Firebase-AppCheck'] = appCheckToken;
}
function makeRequest(requestInfo, appId, authToken, appCheckToken, requestFactory, firebaseVersion, retry = true, isUsingEmulator = false) {
    const queryPart = makeQueryString(requestInfo.urlParams);
    const url = requestInfo.url + queryPart;
    const headers = Object.assign({}, requestInfo.headers);
    addGmpidHeader_(headers, appId);
    addAuthHeader_(headers, authToken);
    addVersionHeader_(headers, firebaseVersion);
    addAppCheckHeader_(headers, appCheckToken);
    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, requestFactory, retry, isUsingEmulator);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') return BlobBuilder;
    else if (typeof WebKitBlobBuilder !== 'undefined') return WebKitBlobBuilder;
    else return undefined;
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param args The values that will make up the resulting blob.
 * @return The blob.
 */ function getBlob$1(...args) {
    const BlobBuilder1 = getBlobBuilder();
    if (BlobBuilder1 !== undefined) {
        const bb = new BlobBuilder1();
        for(let i = 0; i < args.length; i++)bb.append(args[i]);
        return bb.getBlob();
    } else {
        if (isNativeBlobDefined()) return new Blob(args);
        else throw new StorageError(StorageErrorCode.UNSUPPORTED_ENVIRONMENT, "This browser doesn't seem to support creating Blobs");
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */ function sliceBlob(blob, start, end) {
    if (blob.webkitSlice) return blob.webkitSlice(start, end);
    else if (blob.mozSlice) return blob.mozSlice(start, end);
    else if (blob.slice) return blob.slice(start, end);
    return null;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Converts a Base64 encoded string to a binary string. */ function decodeBase64(encoded) {
    if (typeof atob === 'undefined') throw missingPolyFill('base-64');
    return atob(encoded);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An enumeration of the possible string formats for upload.
 * @public
 */ const StringFormat = {
    /**
     * Indicates the string should be interpreted "raw", that is, as normal text.
     * The string will be interpreted as UTF-16, then uploaded as a UTF-8 byte
     * sequence.
     * Example: The string 'Hello! \\ud83d\\ude0a' becomes the byte sequence
     * 48 65 6c 6c 6f 21 20 f0 9f 98 8a
     */ RAW: 'raw',
    /**
     * Indicates the string should be interpreted as base64-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO++E6t7/rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64: 'base64',
    /**
     * Indicates the string should be interpreted as base64url-encoded data.
     * Padding characters (trailing '='s) are optional.
     * Example: The string 'rWmO--E6t7_rlw==' becomes the byte sequence
     * ad 69 8e fb e1 3a b7 bf eb 97
     */ BASE64URL: 'base64url',
    /**
     * Indicates the string is a data URL, such as one obtained from
     * canvas.toDataURL().
     * Example: the string 'data:application/octet-stream;base64,aaaa'
     * becomes the byte sequence
     * 69 a6 9a
     * (the content-type "application/octet-stream" is also applied, but can
     * be overridden in the metadata object).
     */ DATA_URL: 'data_url'
};
class StringData {
    constructor(data, contentType){
        this.data = data;
        this.contentType = contentType || null;
    }
}
/**
 * @internal
 */ function dataFromString(format, stringData) {
    switch(format){
        case StringFormat.RAW:
            return new StringData(utf8Bytes_(stringData));
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
            return new StringData(base64Bytes_(format, stringData));
        case StringFormat.DATA_URL:
            return new StringData(dataURLBytes_(stringData), dataURLContentType_(stringData));
    }
    // assert(false);
    throw unknown();
}
function utf8Bytes_(value) {
    const b = [];
    for(let i = 0; i < value.length; i++){
        let c = value.charCodeAt(i);
        if (c <= 127) b.push(c);
        else if (c <= 2047) b.push(192 | c >> 6, 128 | c & 63);
        else {
            if ((c & 64512) === 55296) {
                // The start of a surrogate pair.
                const valid = i < value.length - 1 && (value.charCodeAt(i + 1) & 64512) === 56320;
                if (!valid) // The second surrogate wasn't there.
                b.push(239, 191, 189);
                else {
                    const hi = c;
                    const lo = value.charCodeAt(++i);
                    c = 65536 | (hi & 1023) << 10 | lo & 1023;
                    b.push(240 | c >> 18, 128 | c >> 12 & 63, 128 | c >> 6 & 63, 128 | c & 63);
                }
            } else if ((c & 64512) === 56320) // Invalid low surrogate.
            b.push(239, 191, 189);
            else b.push(224 | c >> 12, 128 | c >> 6 & 63, 128 | c & 63);
        }
    }
    return new Uint8Array(b);
}
function percentEncodedBytes_(value) {
    let decoded;
    try {
        decoded = decodeURIComponent(value);
    } catch (e) {
        throw invalidFormat(StringFormat.DATA_URL, 'Malformed data URL.');
    }
    return utf8Bytes_(decoded);
}
function base64Bytes_(format, value) {
    switch(format){
        case StringFormat.BASE64:
            {
                const hasMinus = value.indexOf('-') !== -1;
                const hasUnder = value.indexOf('_') !== -1;
                if (hasMinus || hasUnder) {
                    const invalidChar = hasMinus ? '-' : '_';
                    throw invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64url encoded?");
                }
                break;
            }
        case StringFormat.BASE64URL:
            {
                const hasPlus = value.indexOf('+') !== -1;
                const hasSlash = value.indexOf('/') !== -1;
                if (hasPlus || hasSlash) {
                    const invalidChar = hasPlus ? '+' : '/';
                    throw invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
                }
                value = value.replace(/-/g, '+').replace(/_/g, '/');
                break;
            }
    }
    let bytes;
    try {
        bytes = decodeBase64(value);
    } catch (e) {
        if (e.message.includes('polyfill')) throw e;
        throw invalidFormat(format, 'Invalid character found');
    }
    const array = new Uint8Array(bytes.length);
    for(let i = 0; i < bytes.length; i++)array[i] = bytes.charCodeAt(i);
    return array;
}
class DataURLParts {
    constructor(dataURL){
        this.base64 = false;
        this.contentType = null;
        const matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) throw invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        const middle = matches[1] || null;
        if (middle != null) {
            this.base64 = endsWith(middle, ';base64');
            this.contentType = this.base64 ? middle.substring(0, middle.length - 7) : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
}
function dataURLBytes_(dataUrl) {
    const parts = new DataURLParts(dataUrl);
    if (parts.base64) return base64Bytes_(StringFormat.BASE64, parts.rest);
    else return percentEncodedBytes_(parts.rest);
}
function dataURLContentType_(dataUrl) {
    const parts = new DataURLParts(dataUrl);
    return parts.contentType;
}
function endsWith(s, end) {
    const longEnough = s.length >= end.length;
    if (!longEnough) return false;
    return s.substring(s.length - end.length) === end;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @param opt_elideCopy - If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 *
 * @internal
 */ class FbsBlob {
    constructor(data, elideCopy){
        let size = 0;
        let blobType = '';
        if (isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        } else if (data instanceof ArrayBuffer) {
            if (elideCopy) this.data_ = new Uint8Array(data);
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        } else if (data instanceof Uint8Array) {
            if (elideCopy) this.data_ = data;
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    size() {
        return this.size_;
    }
    type() {
        return this.type_;
    }
    slice(startByte, endByte) {
        if (isNativeBlob(this.data_)) {
            const realBlob = this.data_;
            const sliced = sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) return null;
            return new FbsBlob(sliced);
        } else {
            const slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new FbsBlob(slice, true);
        }
    }
    static getBlob(...args) {
        if (isNativeBlobDefined()) {
            const blobby = args.map((val)=>{
                if (val instanceof FbsBlob) return val.data_;
                else return val;
            });
            return new FbsBlob(getBlob$1.apply(null, blobby));
        } else {
            const uint8Arrays = args.map((val)=>{
                if (isString(val)) return dataFromString(StringFormat.RAW, val).data;
                else // Blobs don't exist, so this has to be a Uint8Array.
                return val.data_;
            });
            let finalLength = 0;
            uint8Arrays.forEach((array)=>{
                finalLength += array.byteLength;
            });
            const merged = new Uint8Array(finalLength);
            let index = 0;
            uint8Arrays.forEach((array)=>{
                for(let i = 0; i < array.length; i++)merged[index++] = array[i];
            });
            return new FbsBlob(merged, true);
        }
    }
    uploadData() {
        return this.data_;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */ function jsonObjectOrNull(s) {
    let obj;
    try {
        obj = JSON.parse(s);
    } catch (e) {
        return null;
    }
    if (isNonArrayObject(obj)) return obj;
    else return null;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * @fileoverview Contains helper methods for manipulating paths.
 */ /**
 * @return Null if the path is already at the root.
 */ function parent(path) {
    if (path.length === 0) return null;
    const index = path.lastIndexOf('/');
    if (index === -1) return '';
    const newPath = path.slice(0, index);
    return newPath;
}
function child(path, childPath) {
    const canonicalChildPath = childPath.split('/').filter((component)=>component.length > 0).join('/');
    if (path.length === 0) return canonicalChildPath;
    else return path + '/' + canonicalChildPath;
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */ function lastComponent(path) {
    const index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) return path;
    else return path.slice(index + 1);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function noXform_(metadata, value) {
    return value;
}
class Mapping {
    constructor(server, local, writable, xform){
        this.server = server;
        this.local = local || server;
        this.writable = !!writable;
        this.xform = xform || noXform_;
    }
}
let mappings_ = null;
function xformPath(fullPath) {
    if (!isString(fullPath) || fullPath.length < 2) return fullPath;
    else return lastComponent(fullPath);
}
function getMappings() {
    if (mappings_) return mappings_;
    const mappings = [];
    mappings.push(new Mapping('bucket'));
    mappings.push(new Mapping('generation'));
    mappings.push(new Mapping('metageneration'));
    mappings.push(new Mapping('name', 'fullPath', true));
    function mappingsXformPath(_metadata, fullPath) {
        return xformPath(fullPath);
    }
    const nameMapping = new Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */ function xformSize(_metadata, size) {
        if (size !== undefined) return Number(size);
        else return size;
    }
    const sizeMapping = new Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new Mapping('timeCreated'));
    mappings.push(new Mapping('updated'));
    mappings.push(new Mapping('md5Hash', null, true));
    mappings.push(new Mapping('cacheControl', null, true));
    mappings.push(new Mapping('contentDisposition', null, true));
    mappings.push(new Mapping('contentEncoding', null, true));
    mappings.push(new Mapping('contentLanguage', null, true));
    mappings.push(new Mapping('contentType', null, true));
    mappings.push(new Mapping('metadata', 'customMetadata', true));
    mappings_ = mappings;
    return mappings_;
}
function addRef(metadata, service) {
    function generateRef() {
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const loc = new Location(bucket, path);
        return service._makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', {
        get: generateRef
    });
}
function fromResource(service, resource, mappings) {
    const metadata = {};
    metadata['type'] = 'file';
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    addRef(metadata, service);
    return metadata;
}
function fromResourceString(service, resourceString, mappings) {
    const obj = jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return fromResource(service, resource, mappings);
}
function downloadUrlFromResourceString(metadata, resourceString, host, protocol) {
    const obj = jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    if (!isString(obj['downloadTokens'])) // This can happen if objects are uploaded through GCS and retrieved
    // through list, so we don't want to throw an Error.
    return null;
    const tokens = obj['downloadTokens'];
    if (tokens.length === 0) return null;
    const encode = encodeURIComponent;
    const tokensList = tokens.split(',');
    const urls = tokensList.map((token)=>{
        const bucket = metadata['bucket'];
        const path = metadata['fullPath'];
        const urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
        const base = makeUrl(urlPart, host, protocol);
        const queryString = makeQueryString({
            alt: 'media',
            token
        });
        return base + queryString;
    });
    return urls[0];
}
function toResourceString(metadata, mappings) {
    const resource = {};
    const len = mappings.length;
    for(let i = 0; i < len; i++){
        const mapping = mappings[i];
        if (mapping.writable) resource[mapping.server] = metadata[mapping.local];
    }
    return JSON.stringify(resource);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const PREFIXES_KEY = 'prefixes';
const ITEMS_KEY = 'items';
function fromBackendResponse(service, bucket, resource) {
    const listResult = {
        prefixes: [],
        items: [],
        nextPageToken: resource['nextPageToken']
    };
    if (resource[PREFIXES_KEY]) for (const path of resource[PREFIXES_KEY]){
        const pathWithoutTrailingSlash = path.replace(/\/$/, '');
        const reference = service._makeStorageReference(new Location(bucket, pathWithoutTrailingSlash));
        listResult.prefixes.push(reference);
    }
    if (resource[ITEMS_KEY]) for (const item of resource[ITEMS_KEY]){
        const reference = service._makeStorageReference(new Location(bucket, item['name']));
        listResult.items.push(reference);
    }
    return listResult;
}
function fromResponseString(service, bucket, resourceString) {
    const obj = jsonObjectOrNull(resourceString);
    if (obj === null) return null;
    const resource = obj;
    return fromBackendResponse(service, bucket, resource);
}
/**
 * Contains a fully specified request.
 *
 * @param I - the type of the backend's network response.
 * @param O - the output response type used by the rest of the SDK.
 */ class RequestInfo {
    constructor(url, method, /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */ handler, timeout){
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */ this.progressCallback = null;
        this.successCodes = [
            200
        ];
        this.additionalRetryCodes = [];
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Throws the UNKNOWN StorageError if cndn is false.
 */ function handlerCheck(cndn) {
    if (!cndn) throw unknown();
}
function metadataHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = fromResourceString(service, text, mappings);
        handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function listHandler(service, bucket) {
    function handler(xhr, text) {
        const listResult = fromResponseString(service, bucket, text);
        handlerCheck(listResult !== null);
        return listResult;
    }
    return handler;
}
function downloadUrlHandler(service, mappings) {
    function handler(xhr, text) {
        const metadata = fromResourceString(service, text, mappings);
        handlerCheck(metadata !== null);
        return downloadUrlFromResourceString(metadata, text, service.host, service._protocol);
    }
    return handler;
}
function sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        let newErr;
        if (xhr.getStatus() === 401) {
            if (// This exact message string is the only consistent part of the
            // server's error response that identifies it as an App Check error.
            xhr.getErrorText().includes('Firebase App Check token is invalid')) newErr = unauthorizedApp();
            else newErr = unauthenticated();
        } else {
            if (xhr.getStatus() === 402) newErr = quotaExceeded(location.bucket);
            else if (xhr.getStatus() === 403) newErr = unauthorized(location.path);
            else newErr = err;
        }
        newErr.status = xhr.getStatus();
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function objectErrorHandler(location) {
    const shared = sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        let newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) newErr = objectNotFound(location.path);
        newErr.serverResponse = err.serverResponse;
        return newErr;
    }
    return errorHandler;
}
function getMetadata$2(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new RequestInfo(url, method, metadataHandler(service, mappings), timeout);
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function list$2(service, location, delimiter, pageToken, maxResults) {
    const urlParams = {};
    if (location.isRoot) urlParams['prefix'] = '';
    else urlParams['prefix'] = location.path + '/';
    if (delimiter && delimiter.length > 0) urlParams['delimiter'] = delimiter;
    if (pageToken) urlParams['pageToken'] = pageToken;
    if (maxResults) urlParams['maxResults'] = maxResults;
    const urlPart = location.bucketOnlyServerUrl();
    const url = makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new RequestInfo(url, method, listHandler(service, location.bucket), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
function getBytes$1(service, location, maxDownloadSizeBytes) {
    const urlPart = location.fullServerUrl();
    const url = makeUrl(urlPart, service.host, service._protocol) + '?alt=media';
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new RequestInfo(url, method, (_, data)=>data, timeout);
    requestInfo.errorHandler = objectErrorHandler(location);
    if (maxDownloadSizeBytes !== undefined) {
        requestInfo.headers['Range'] = `bytes=0-${maxDownloadSizeBytes}`;
        requestInfo.successCodes = [
            200 /* OK */ ,
            206 /* Partial Content */ 
        ];
    }
    return requestInfo;
}
function getDownloadUrl(service, location, mappings) {
    const urlPart = location.fullServerUrl();
    const url = makeUrl(urlPart, service.host, service._protocol);
    const method = 'GET';
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new RequestInfo(url, method, downloadUrlHandler(service, mappings), timeout);
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function updateMetadata$2(service, location, metadata, mappings) {
    const urlPart = location.fullServerUrl();
    const url = makeUrl(urlPart, service.host, service._protocol);
    const method = 'PATCH';
    const body = toResourceString(metadata, mappings);
    const headers = {
        'Content-Type': 'application/json; charset=utf-8'
    };
    const timeout = service.maxOperationRetryTime;
    const requestInfo = new RequestInfo(url, method, metadataHandler(service, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function deleteObject$2(service, location) {
    const urlPart = location.fullServerUrl();
    const url = makeUrl(urlPart, service.host, service._protocol);
    const method = 'DELETE';
    const timeout = service.maxOperationRetryTime;
    function handler(_xhr, _text) {}
    const requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [
        200,
        204
    ];
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function determineContentType_(metadata, blob) {
    return metadata && metadata['contentType'] || blob && blob.type() || 'application/octet-stream';
}
function metadataForUpload_(location, blob, metadata) {
    const metadataClone = Object.assign({}, metadata);
    metadataClone['fullPath'] = location.path;
    metadataClone['size'] = blob.size();
    if (!metadataClone['contentType']) metadataClone['contentType'] = determineContentType_(null, blob);
    return metadataClone;
}
/**
 * Prepare RequestInfo for uploads as Content-Type: multipart.
 */ function multipartUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        let str = '';
        for(let i = 0; i < 2; i++)str = str + Math.random().toString().slice(2);
        return str;
    }
    const boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    const metadata_ = metadataForUpload_(location, blob, metadata);
    const metadataString = toResourceString(metadata_, mappings);
    const preBlobPart = '--' + boundary + '\r\n' + 'Content-Type: application/json; charset=utf-8\r\n\r\n' + metadataString + '\r\n--' + boundary + '\r\n' + 'Content-Type: ' + metadata_['contentType'] + '\r\n\r\n';
    const postBlobPart = '\r\n--' + boundary + '--';
    const body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) throw cannotSliceBlob();
    const urlParams = {
        name: metadata_['fullPath']
    };
    const url = makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new RequestInfo(url, method, metadataHandler(service, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 */ class ResumableUploadStatus {
    constructor(current, total, finalized, metadata){
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
}
function checkResumeHeader_(xhr, allowed) {
    let status = null;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    } catch (e) {
        handlerCheck(false);
    }
    const allowedStatus = allowed || [
        'active'
    ];
    handlerCheck(!!status && allowedStatus.indexOf(status) !== -1);
    return status;
}
function createResumableUpload(service, location, mappings, blob, metadata) {
    const urlPart = location.bucketOnlyServerUrl();
    const metadataForUpload = metadataForUpload_(location, blob, metadata);
    const urlParams = {
        name: metadataForUpload['fullPath']
    };
    const url = makeUrl(urlPart, service.host, service._protocol);
    const method = 'POST';
    const headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': `${blob.size()}`,
        'X-Goog-Upload-Header-Content-Type': metadataForUpload['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    const body = toResourceString(metadataForUpload, mappings);
    const timeout = service.maxUploadRetryTime;
    function handler(xhr) {
        checkResumeHeader_(xhr);
        let url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        } catch (e) {
            handlerCheck(false);
        }
        handlerCheck(isString(url));
        return url;
    }
    const requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */ function getResumableUploadStatus(service, location, url, blob) {
    const headers = {
        'X-Goog-Upload-Command': 'query'
    };
    function handler(xhr) {
        const status = checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        let sizeString = null;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        } catch (e) {
            handlerCheck(false);
        }
        if (!sizeString) // null or empty string
        handlerCheck(false);
        const size = Number(sizeString);
        handlerCheck(!isNaN(size));
        return new ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */ const RESUMABLE_UPLOAD_CHUNK_SIZE = 262144;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */ function continueResumableUpload(location, service, url, blob, chunkSize, mappings, status, progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    const status_ = new ResumableUploadStatus(0, 0);
    if (status) {
        status_.current = status.current;
        status_.total = status.total;
    } else {
        status_.current = 0;
        status_.total = blob.size();
    }
    if (blob.size() !== status_.total) throw serverFileWrongSize();
    const bytesLeft = status_.total - status_.current;
    let bytesToUpload = bytesLeft;
    if (chunkSize > 0) bytesToUpload = Math.min(bytesToUpload, chunkSize);
    const startByte = status_.current;
    const endByte = startByte + bytesToUpload;
    let uploadCommand = '';
    if (bytesToUpload === 0) uploadCommand = 'finalize';
    else if (bytesLeft === bytesToUpload) uploadCommand = 'upload, finalize';
    else uploadCommand = 'upload';
    const headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': `${status_.current}`
    };
    const body = blob.slice(startByte, endByte);
    if (body === null) throw cannotSliceBlob();
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        const uploadStatus = checkResumeHeader_(xhr, [
            'active',
            'final'
        ]);
        const newCurrent = status_.current + bytesToUpload;
        const size = blob.size();
        let metadata;
        if (uploadStatus === 'final') metadata = metadataHandler(service, mappings)(xhr, text);
        else metadata = null;
        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    const method = 'POST';
    const timeout = service.maxUploadRetryTime;
    const requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = progressCallback || null;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * An event that is triggered on a task.
 * @internal
 */ const TaskEvent = {
    /**
     * For this event,
     * <ul>
     *   <li>The `next` function is triggered on progress updates and when the
     *       task is paused/resumed with an `UploadTaskSnapshot` as the first
     *       argument.</li>
     *   <li>The `error` function is triggered if the upload is canceled or fails
     *       for another reason.</li>
     *   <li>The `complete` function is triggered if the upload completes
     *       successfully.</li>
     * </ul>
     */ STATE_CHANGED: 'state_changed'
};
// type keys = keyof TaskState
/**
 * Represents the current state of a running upload.
 * @internal
 */ const TaskState = {
    /** The task is currently transferring data. */ RUNNING: 'running',
    /** The task was paused by the user. */ PAUSED: 'paused',
    /** The task completed successfully. */ SUCCESS: 'success',
    /** The task was canceled. */ CANCELED: 'canceled',
    /** The task failed with an error. */ ERROR: 'error'
};
function taskStateFromInternalTaskState(state) {
    switch(state){
        case "running" /* InternalTaskState.RUNNING */ :
        case "pausing" /* InternalTaskState.PAUSING */ :
        case "canceling" /* InternalTaskState.CANCELING */ :
            return TaskState.RUNNING;
        case "paused" /* InternalTaskState.PAUSED */ :
            return TaskState.PAUSED;
        case "success" /* InternalTaskState.SUCCESS */ :
            return TaskState.SUCCESS;
        case "canceled" /* InternalTaskState.CANCELED */ :
            return TaskState.CANCELED;
        case "error" /* InternalTaskState.ERROR */ :
            return TaskState.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return TaskState.ERROR;
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class Observer {
    constructor(nextOrObserver, error, complete){
        const asFunctions = isFunction(nextOrObserver) || error != null || complete != null;
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = error ?? undefined;
            this.complete = complete ?? undefined;
        } else {
            const observer = nextOrObserver;
            this.next = observer.next;
            this.error = observer.error;
            this.complete = observer.complete;
        }
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function async(f) {
    return (...argsToForward)=>{
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.resolve().then(()=>f(...argsToForward));
    };
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** An override for the text-based Connection. Used in tests. */ let textFactoryOverride = null;
/**
 * Network layer for browsers. We use this instead of goog.net.XhrIo because
 * goog.net.XhrIo is hyuuuuge and doesn't work in React Native on Android.
 */ class XhrConnection {
    constructor(){
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.initXhr();
        this.errorCode_ = ErrorCode.NO_ERROR;
        this.sendPromise_ = new Promise((resolve)=>{
            this.xhr_.addEventListener('abort', ()=>{
                this.errorCode_ = ErrorCode.ABORT;
                resolve();
            });
            this.xhr_.addEventListener('error', ()=>{
                this.errorCode_ = ErrorCode.NETWORK_ERROR;
                resolve();
            });
            this.xhr_.addEventListener('load', ()=>{
                resolve();
            });
        });
    }
    send(url, method, isUsingEmulator, body, headers) {
        if (this.sent_) throw internalError('cannot .send() more than once');
        if ((0, _util.isCloudWorkstation)(url) && isUsingEmulator) this.xhr_.withCredentials = true;
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (headers !== undefined) {
            for(const key in headers)if (headers.hasOwnProperty(key)) this.xhr_.setRequestHeader(key, headers[key].toString());
        }
        if (body !== undefined) this.xhr_.send(body);
        else this.xhr_.send();
        return this.sendPromise_;
    }
    getErrorCode() {
        if (!this.sent_) throw internalError('cannot .getErrorCode() before sending');
        return this.errorCode_;
    }
    getStatus() {
        if (!this.sent_) throw internalError('cannot .getStatus() before sending');
        try {
            return this.xhr_.status;
        } catch (e) {
            return -1;
        }
    }
    getResponse() {
        if (!this.sent_) throw internalError('cannot .getResponse() before sending');
        return this.xhr_.response;
    }
    getErrorText() {
        if (!this.sent_) throw internalError('cannot .getErrorText() before sending');
        return this.xhr_.statusText;
    }
    /** Aborts the request. */ abort() {
        this.xhr_.abort();
    }
    getResponseHeader(header) {
        return this.xhr_.getResponseHeader(header);
    }
    addUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.addEventListener('progress', listener);
    }
    removeUploadProgressListener(listener) {
        if (this.xhr_.upload != null) this.xhr_.upload.removeEventListener('progress', listener);
    }
}
class XhrTextConnection extends XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'text';
    }
}
function newTextConnection() {
    return textFactoryOverride ? textFactoryOverride() : new XhrTextConnection();
}
class XhrBytesConnection extends XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'arraybuffer';
    }
}
function newBytesConnection() {
    return new XhrBytesConnection();
}
class XhrBlobConnection extends XhrConnection {
    initXhr() {
        this.xhr_.responseType = 'blob';
    }
}
function newBlobConnection() {
    return new XhrBlobConnection();
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 * @internal
 */ class UploadTask {
    isExponentialBackoffExpired() {
        return this.sleepTime > this.maxSleepTime;
    }
    /**
     * @param ref - The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob - The blob to upload.
     */ constructor(ref, blob, metadata = null){
        /**
         * Number of bytes transferred so far.
         */ this._transferred = 0;
        this._needToFetchStatus = false;
        this._needToFetchMetadata = false;
        this._observers = [];
        this._error = undefined;
        this._uploadUrl = undefined;
        this._request = undefined;
        this._chunkMultiplier = 1;
        this._resolve = undefined;
        this._reject = undefined;
        this._ref = ref;
        this._blob = blob;
        this._metadata = metadata;
        this._mappings = getMappings();
        this._resumable = this._shouldDoResumable(this._blob);
        this._state = "running" /* InternalTaskState.RUNNING */ ;
        this._errorHandler = (error)=>{
            this._request = undefined;
            this._chunkMultiplier = 1;
            if (error._codeEquals(StorageErrorCode.CANCELED)) {
                this._needToFetchStatus = true;
                this.completeTransitions_();
            } else {
                const backoffExpired = this.isExponentialBackoffExpired();
                if (isRetryStatusCode(error.status, [])) {
                    if (backoffExpired) error = retryLimitExceeded();
                    else {
                        this.sleepTime = Math.max(this.sleepTime * 2, DEFAULT_MIN_SLEEP_TIME_MILLIS);
                        this._needToFetchStatus = true;
                        this.completeTransitions_();
                        return;
                    }
                }
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this._metadataErrorHandler = (error)=>{
            this._request = undefined;
            if (error._codeEquals(StorageErrorCode.CANCELED)) this.completeTransitions_();
            else {
                this._error = error;
                this._transition("error" /* InternalTaskState.ERROR */ );
            }
        };
        this.sleepTime = 0;
        this.maxSleepTime = this._ref.storage.maxUploadRetryTime;
        this._promise = new Promise((resolve, reject)=>{
            this._resolve = resolve;
            this._reject = reject;
            this._start();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this._promise.then(null, ()=>{});
    }
    _makeProgressCallback() {
        const sizeBefore = this._transferred;
        return (loaded)=>this._updateProgress(sizeBefore + loaded);
    }
    _shouldDoResumable(blob) {
        return blob.size() > 262144;
    }
    _start() {
        if (this._state !== "running" /* InternalTaskState.RUNNING */ ) // This can happen if someone pauses us in a resume callback, for example.
        return;
        if (this._request !== undefined) return;
        if (this._resumable) {
            if (this._uploadUrl === undefined) this._createResumable();
            else {
                if (this._needToFetchStatus) this._fetchStatus();
                else if (this._needToFetchMetadata) // Happens if we miss the metadata on upload completion.
                this._fetchMetadata();
                else this.pendingTimeout = setTimeout(()=>{
                    this.pendingTimeout = undefined;
                    this._continueUpload();
                }, this.sleepTime);
            }
        } else this._oneShotUpload();
    }
    _resolveToken(callback) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        Promise.all([
            this._ref.storage._getAuthToken(),
            this._ref.storage._getAppCheckToken()
        ]).then(([authToken, appCheckToken])=>{
            switch(this._state){
                case "running" /* InternalTaskState.RUNNING */ :
                    callback(authToken, appCheckToken);
                    break;
                case "canceling" /* InternalTaskState.CANCELING */ :
                    this._transition("canceled" /* InternalTaskState.CANCELED */ );
                    break;
                case "pausing" /* InternalTaskState.PAUSING */ :
                    this._transition("paused" /* InternalTaskState.PAUSED */ );
                    break;
            }
        });
    }
    // TODO(andysoto): assert false
    _createResumable() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = createResumableUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const createRequest = this._ref.storage._makeRequest(requestInfo, newTextConnection, authToken, appCheckToken);
            this._request = createRequest;
            createRequest.getPromise().then((url)=>{
                this._request = undefined;
                this._uploadUrl = url;
                this._needToFetchStatus = false;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _fetchStatus() {
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = getResumableUploadStatus(this._ref.storage, this._ref._location, url, this._blob);
            const statusRequest = this._ref.storage._makeRequest(requestInfo, newTextConnection, authToken, appCheckToken);
            this._request = statusRequest;
            statusRequest.getPromise().then((status)=>{
                status;
                this._request = undefined;
                this._updateProgress(status.current);
                this._needToFetchStatus = false;
                if (status.finalized) this._needToFetchMetadata = true;
                this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _continueUpload() {
        const chunkSize = RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        const status = new ResumableUploadStatus(this._transferred, this._blob.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        const url = this._uploadUrl;
        this._resolveToken((authToken, appCheckToken)=>{
            let requestInfo;
            try {
                requestInfo = continueResumableUpload(this._ref._location, this._ref.storage, url, this._blob, chunkSize, this._mappings, status, this._makeProgressCallback());
            } catch (e) {
                this._error = e;
                this._transition("error" /* InternalTaskState.ERROR */ );
                return;
            }
            const uploadRequest = this._ref.storage._makeRequest(requestInfo, newTextConnection, authToken, appCheckToken, /*retry=*/ false // Upload requests should not be retried as each retry should be preceded by another query request. Which is handled in this file.
            );
            this._request = uploadRequest;
            uploadRequest.getPromise().then((newStatus)=>{
                this._increaseMultiplier();
                this._request = undefined;
                this._updateProgress(newStatus.current);
                if (newStatus.finalized) {
                    this._metadata = newStatus.metadata;
                    this._transition("success" /* InternalTaskState.SUCCESS */ );
                } else this.completeTransitions_();
            }, this._errorHandler);
        });
    }
    _increaseMultiplier() {
        const currentSize = RESUMABLE_UPLOAD_CHUNK_SIZE * this._chunkMultiplier;
        // Max chunk size is 32M.
        if (currentSize * 2 < 33554432) this._chunkMultiplier *= 2;
    }
    _fetchMetadata() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = getMetadata$2(this._ref.storage, this._ref._location, this._mappings);
            const metadataRequest = this._ref.storage._makeRequest(requestInfo, newTextConnection, authToken, appCheckToken);
            this._request = metadataRequest;
            metadataRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._metadataErrorHandler);
        });
    }
    _oneShotUpload() {
        this._resolveToken((authToken, appCheckToken)=>{
            const requestInfo = multipartUpload(this._ref.storage, this._ref._location, this._mappings, this._blob, this._metadata);
            const multipartRequest = this._ref.storage._makeRequest(requestInfo, newTextConnection, authToken, appCheckToken);
            this._request = multipartRequest;
            multipartRequest.getPromise().then((metadata)=>{
                this._request = undefined;
                this._metadata = metadata;
                this._updateProgress(this._blob.size());
                this._transition("success" /* InternalTaskState.SUCCESS */ );
            }, this._errorHandler);
        });
    }
    _updateProgress(transferred) {
        const old = this._transferred;
        this._transferred = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this._transferred !== old) this._notifyObservers();
    }
    _transition(state) {
        if (this._state === state) return;
        switch(state){
            case "canceling" /* InternalTaskState.CANCELING */ :
            case "pausing" /* InternalTaskState.PAUSING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                if (this._request !== undefined) this._request.cancel();
                else if (this.pendingTimeout) {
                    clearTimeout(this.pendingTimeout);
                    this.pendingTimeout = undefined;
                    this.completeTransitions_();
                }
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                const wasPaused = this._state === "paused" /* InternalTaskState.PAUSED */ ;
                this._state = state;
                if (wasPaused) {
                    this._notifyObservers();
                    this._start();
                }
                break;
            case "paused" /* InternalTaskState.PAUSED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this._state = state;
                this._notifyObservers();
                break;
            case "canceled" /* InternalTaskState.CANCELED */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._error = canceled();
                this._state = state;
                this._notifyObservers();
                break;
            case "error" /* InternalTaskState.ERROR */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
            case "success" /* InternalTaskState.SUCCESS */ :
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this._state = state;
                this._notifyObservers();
                break;
        }
    }
    completeTransitions_() {
        switch(this._state){
            case "pausing" /* InternalTaskState.PAUSING */ :
                this._transition("paused" /* InternalTaskState.PAUSED */ );
                break;
            case "canceling" /* InternalTaskState.CANCELING */ :
                this._transition("canceled" /* InternalTaskState.CANCELED */ );
                break;
            case "running" /* InternalTaskState.RUNNING */ :
                this._start();
                break;
        }
    }
    /**
     * A snapshot of the current task state.
     */ get snapshot() {
        const externalState = taskStateFromInternalTaskState(this._state);
        return {
            bytesTransferred: this._transferred,
            totalBytes: this._blob.size(),
            state: externalState,
            metadata: this._metadata,
            task: this,
            ref: this._ref
        };
    }
    /**
     * Adds a callback for an event.
     * @param type - The type of event to listen for.
     * @param nextOrObserver -
     *     The `next` function, which gets called for each item in
     *     the event stream, or an observer object with some or all of these three
     *     properties (`next`, `error`, `complete`).
     * @param error - A function that gets called with a `StorageError`
     *     if the event stream ends due to an error.
     * @param completed - A function that gets called if the
     *     event stream ends normally.
     * @returns
     *     If only the event argument is passed, returns a function you can use to
     *     add callbacks (see the examples above). If more than just the event
     *     argument is passed, returns a function you can call to unregister the
     *     callbacks.
     */ on(type, nextOrObserver, error, completed) {
        // Note: `type` isn't being used. Its type is also incorrect. TaskEvent should not be a string.
        const observer = new Observer(nextOrObserver || undefined, error || undefined, completed || undefined);
        this._addObserver(observer);
        return ()=>{
            this._removeObserver(observer);
        };
    }
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled - The fulfillment callback. Promise chaining works as normal.
     * @param onRejected - The rejection callback.
     */ then(onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this._promise.then(onFulfilled, onRejected);
    }
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */ catch(onRejected) {
        return this.then(null, onRejected);
    }
    /**
     * Adds the given observer.
     */ _addObserver(observer) {
        this._observers.push(observer);
        this._notifyObserver(observer);
    }
    /**
     * Removes the given observer.
     */ _removeObserver(observer) {
        const i = this._observers.indexOf(observer);
        if (i !== -1) this._observers.splice(i, 1);
    }
    _notifyObservers() {
        this._finishPromise();
        const observers = this._observers.slice();
        observers.forEach((observer)=>{
            this._notifyObserver(observer);
        });
    }
    _finishPromise() {
        if (this._resolve !== undefined) {
            let triggered = true;
            switch(taskStateFromInternalTaskState(this._state)){
                case TaskState.SUCCESS:
                    async(this._resolve.bind(null, this.snapshot))();
                    break;
                case TaskState.CANCELED:
                case TaskState.ERROR:
                    const toCall = this._reject;
                    async(toCall.bind(null, this._error))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this._resolve = undefined;
                this._reject = undefined;
            }
        }
    }
    _notifyObserver(observer) {
        const externalState = taskStateFromInternalTaskState(this._state);
        switch(externalState){
            case TaskState.RUNNING:
            case TaskState.PAUSED:
                if (observer.next) async(observer.next.bind(observer, this.snapshot))();
                break;
            case TaskState.SUCCESS:
                if (observer.complete) async(observer.complete.bind(observer))();
                break;
            case TaskState.CANCELED:
            case TaskState.ERROR:
                if (observer.error) async(observer.error.bind(observer, this._error))();
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error) async(observer.error.bind(observer, this._error))();
        }
    }
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ resume() {
        const valid = this._state === "paused" /* InternalTaskState.PAUSED */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("running" /* InternalTaskState.RUNNING */ );
        return valid;
    }
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @returns True if the operation took effect, false if ignored.
     */ pause() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */ ;
        if (valid) this._transition("pausing" /* InternalTaskState.PAUSING */ );
        return valid;
    }
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @returns True if the operation took effect, false if ignored.
     */ cancel() {
        const valid = this._state === "running" /* InternalTaskState.RUNNING */  || this._state === "pausing" /* InternalTaskState.PAUSING */ ;
        if (valid) this._transition("canceling" /* InternalTaskState.CANCELING */ );
        return valid;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @internal
 * @param _location - An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */ class Reference {
    constructor(_service, location){
        this._service = _service;
        if (location instanceof Location) this._location = location;
        else this._location = Location.makeFromUrl(location, _service.host);
    }
    /**
     * Returns the URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */ toString() {
        return 'gs://' + this._location.bucket + '/' + this._location.path;
    }
    _newRef(service, location) {
        return new Reference(service, location);
    }
    /**
     * A reference to the root of this object's bucket.
     */ get root() {
        const location = new Location(this._location.bucket, '');
        return this._newRef(this._service, location);
    }
    /**
     * The name of the bucket containing this reference's object.
     */ get bucket() {
        return this._location.bucket;
    }
    /**
     * The full path of this object.
     */ get fullPath() {
        return this._location.path;
    }
    /**
     * The short name of this object, which is the last component of the full path.
     * For example, if fullPath is 'full/path/image.png', name is 'image.png'.
     */ get name() {
        return lastComponent(this._location.path);
    }
    /**
     * The `StorageService` instance this `StorageReference` is associated with.
     */ get storage() {
        return this._service;
    }
    /**
     * A `StorageReference` pointing to the parent location of this `StorageReference`, or null if
     * this reference is the root.
     */ get parent() {
        const newPath = parent(this._location.path);
        if (newPath === null) return null;
        const location = new Location(this._location.bucket, newPath);
        return new Reference(this._service, location);
    }
    /**
     * Utility function to throw an error in methods that do not accept a root reference.
     */ _throwIfRoot(name) {
        if (this._location.path === '') throw invalidRootOperation(name);
    }
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded bytes.
 */ function getBytesInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBytes');
    const requestInfo = getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, newBytesConnection).then((bytes)=>maxDownloadSizeBytes !== undefined ? bytes.slice(0, maxDownloadSizeBytes) : bytes);
}
/**
 * Download the bytes at the object's location.
 * @returns A Promise containing the downloaded blob.
 */ function getBlobInternal(ref, maxDownloadSizeBytes) {
    ref._throwIfRoot('getBlob');
    const requestInfo = getBytes$1(ref.storage, ref._location, maxDownloadSizeBytes);
    return ref.storage.makeRequestWithTokens(requestInfo, newBlobConnection).then((blob)=>maxDownloadSizeBytes !== undefined ? blob.slice(0, maxDownloadSizeBytes) : blob);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 *
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns A Promise containing an UploadResult
 */ function uploadBytes$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytes');
    const requestInfo = multipartUpload(ref.storage, ref._location, getMappings(), new FbsBlob(data, true), metadata);
    return ref.storage.makeRequestWithTokens(requestInfo, newTextConnection).then((finalMetadata)=>{
        return {
            metadata: finalMetadata,
            ref
        };
    });
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - StorageReference where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the newly uploaded data.
 * @returns An UploadTask
 */ function uploadBytesResumable$1(ref, data, metadata) {
    ref._throwIfRoot('uploadBytesResumable');
    return new UploadTask(ref, new FbsBlob(data), metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - StorageReference where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the newly uploaded string.
 * @returns A Promise containing an UploadResult
 */ function uploadString$1(ref, value, format = StringFormat.RAW, metadata) {
    ref._throwIfRoot('uploadString');
    const data = dataFromString(format, value);
    const metadataClone = {
        ...metadata
    };
    if (metadataClone['contentType'] == null && data.contentType != null) metadataClone['contentType'] = data.contentType;
    return uploadBytes$1(ref, data.data, metadataClone);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: listAll may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - StorageReference to get list from.
 *
 * @returns A Promise that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function listAll$1(ref) {
    const accumulator = {
        prefixes: [],
        items: []
    };
    return listAllHelper(ref, accumulator).then(()=>accumulator);
}
/**
 * Separated from listAll because async functions can't use "arguments".
 * @param ref
 * @param accumulator
 * @param pageToken
 */ async function listAllHelper(ref, accumulator, pageToken) {
    const opt = {
        // maxResults is 1000 by default.
        pageToken
    };
    const nextPage = await list$1(ref, opt);
    accumulator.prefixes.push(...nextPage.prefixes);
    accumulator.items.push(...nextPage.items);
    if (nextPage.nextPageToken != null) await listAllHelper(ref, accumulator, nextPage.nextPageToken);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - StorageReference to get list from.
 * @param options - See ListOptions for details.
 * @returns A Promise that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function list$1(ref, options) {
    if (options != null) {
        if (typeof options.maxResults === 'number') validateNumber('options.maxResults', /* minValue= */ 1, /* maxValue= */ 1000, options.maxResults);
    }
    const op = options || {};
    const requestInfo = list$2(ref.storage, ref._location, /*delimiter= */ '/', op.pageToken, op.maxResults);
    return ref.storage.makeRequestWithTokens(requestInfo, newTextConnection);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - StorageReference to get metadata from.
 */ function getMetadata$1(ref) {
    ref._throwIfRoot('getMetadata');
    const requestInfo = getMetadata$2(ref.storage, ref._location, getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, newTextConnection);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - StorageReference to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves
 *     with the new metadata for this object.
 *     See `firebaseStorage.Reference.prototype.getMetadata`
 */ function updateMetadata$1(ref, metadata) {
    ref._throwIfRoot('updateMetadata');
    const requestInfo = updateMetadata$2(ref.storage, ref._location, metadata, getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, newTextConnection);
}
/**
 * Returns the download URL for the given Reference.
 * @public
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function getDownloadURL$1(ref) {
    ref._throwIfRoot('getDownloadURL');
    const requestInfo = getDownloadUrl(ref.storage, ref._location, getMappings());
    return ref.storage.makeRequestWithTokens(requestInfo, newTextConnection).then((url)=>{
        if (url === null) throw noDownloadURL();
        return url;
    });
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - StorageReference for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function deleteObject$1(ref) {
    ref._throwIfRoot('deleteObject');
    const requestInfo = deleteObject$2(ref.storage, ref._location);
    return ref.storage.makeRequestWithTokens(requestInfo, newTextConnection);
}
/**
 * Returns reference for object obtained by appending `childPath` to `ref`.
 *
 * @param ref - StorageReference to get child of.
 * @param childPath - Child path from provided ref.
 * @returns A reference to the object obtained by
 * appending childPath, removing any duplicate, beginning, or trailing
 * slashes.
 *
 */ function _getChild$1(ref, childPath) {
    const newPath = child(ref._location.path, childPath);
    const location = new Location(ref._location.bucket, newPath);
    return new Reference(ref.storage, location);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function isUrl(path) {
    return /^[A-Za-z]+:\/\//.test(path);
}
/**
 * Returns a firebaseStorage.Reference for the given url.
 */ function refFromURL(service, url) {
    return new Reference(service, url);
}
/**
 * Returns a firebaseStorage.Reference for the given path in the default
 * bucket.
 */ function refFromPath(ref, path) {
    if (ref instanceof FirebaseStorageImpl) {
        const service = ref;
        if (service._bucket == null) throw noDefaultBucket();
        const reference = new Reference(service, service._bucket);
        if (path != null) return refFromPath(reference, path);
        else return reference;
    } else {
        // ref is a Reference
        if (path !== undefined) return _getChild$1(ref, path);
        else return ref;
    }
}
function ref$1(serviceOrRef, pathOrUrl) {
    if (pathOrUrl && isUrl(pathOrUrl)) {
        if (serviceOrRef instanceof FirebaseStorageImpl) return refFromURL(serviceOrRef, pathOrUrl);
        else throw invalidArgument('To use ref(service, url), the first argument must be a Storage instance.');
    } else return refFromPath(serviceOrRef, pathOrUrl);
}
function extractBucket(host, config) {
    const bucketString = config?.[CONFIG_STORAGE_BUCKET_KEY];
    if (bucketString == null) return null;
    return Location.makeFromBucketSpec(bucketString, host);
}
function connectStorageEmulator$1(storage, host, port, options = {}) {
    storage.host = `${host}:${port}`;
    const useSsl = (0, _util.isCloudWorkstation)(host);
    // Workaround to get cookies in Firebase Studio
    if (useSsl) (0, _util.pingServer)(`https://${storage.host}/b`);
    storage._isUsingEmulator = true;
    storage._protocol = useSsl ? 'https' : 'http';
    const { mockUserToken } = options;
    if (mockUserToken) storage._overrideAuthToken = typeof mockUserToken === 'string' ? mockUserToken : (0, _util.createMockUserToken)(mockUserToken, storage.app.options.projectId);
}
/**
 * A service that provides Firebase Storage Reference instances.
 * @param opt_url - gs:// url to a custom Storage Bucket
 *
 * @internal
 */ class FirebaseStorageImpl {
    constructor(/**
     * FirebaseApp associated with this StorageService instance.
     */ app, _authProvider, /**
     * @internal
     */ _appCheckProvider, /**
     * @internal
     */ _url, _firebaseVersion, _isUsingEmulator = false){
        this.app = app;
        this._authProvider = _authProvider;
        this._appCheckProvider = _appCheckProvider;
        this._url = _url;
        this._firebaseVersion = _firebaseVersion;
        this._isUsingEmulator = _isUsingEmulator;
        this._bucket = null;
        /**
         * This string can be in the formats:
         * - host
         * - host:port
         */ this._host = DEFAULT_HOST;
        this._protocol = 'https';
        this._appId = null;
        this._deleted = false;
        this._maxOperationRetryTime = DEFAULT_MAX_OPERATION_RETRY_TIME;
        this._maxUploadRetryTime = DEFAULT_MAX_UPLOAD_RETRY_TIME;
        this._requests = new Set();
        if (_url != null) this._bucket = Location.makeFromBucketSpec(_url, this._host);
        else this._bucket = extractBucket(this._host, this.app.options);
    }
    /**
     * The host string for this service, in the form of `host` or
     * `host:port`.
     */ get host() {
        return this._host;
    }
    set host(host) {
        this._host = host;
        if (this._url != null) this._bucket = Location.makeFromBucketSpec(this._url, host);
        else this._bucket = extractBucket(host, this.app.options);
    }
    /**
     * The maximum time to retry uploads in milliseconds.
     */ get maxUploadRetryTime() {
        return this._maxUploadRetryTime;
    }
    set maxUploadRetryTime(time) {
        validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxUploadRetryTime = time;
    }
    /**
     * The maximum time to retry operations other than uploads or downloads in
     * milliseconds.
     */ get maxOperationRetryTime() {
        return this._maxOperationRetryTime;
    }
    set maxOperationRetryTime(time) {
        validateNumber('time', /* minValue=*/ 0, /* maxValue= */ Number.POSITIVE_INFINITY, time);
        this._maxOperationRetryTime = time;
    }
    async _getAuthToken() {
        if (this._overrideAuthToken) return this._overrideAuthToken;
        const auth = this._authProvider.getImmediate({
            optional: true
        });
        if (auth) {
            const tokenData = await auth.getToken();
            if (tokenData !== null) return tokenData.accessToken;
        }
        return null;
    }
    async _getAppCheckToken() {
        if ((0, _app._isFirebaseServerApp)(this.app) && this.app.settings.appCheckToken) return this.app.settings.appCheckToken;
        const appCheck = this._appCheckProvider.getImmediate({
            optional: true
        });
        if (appCheck) {
            const result = await appCheck.getToken();
            // TODO: What do we want to do if there is an error getting the token?
            // Context: appCheck.getToken() will never throw even if an error happened. In the error case, a dummy token will be
            // returned along with an error field describing the error. In general, we shouldn't care about the error condition and just use
            // the token (actual or dummy) to send requests.
            return result.token;
        }
        return null;
    }
    /**
     * Stop running requests and prevent more from being created.
     */ _delete() {
        if (!this._deleted) {
            this._deleted = true;
            this._requests.forEach((request)=>request.cancel());
            this._requests.clear();
        }
        return Promise.resolve();
    }
    /**
     * Returns a new firebaseStorage.Reference object referencing this StorageService
     * at the given Location.
     */ _makeStorageReference(loc) {
        return new Reference(this, loc);
    }
    /**
     * @param requestInfo - HTTP RequestInfo object
     * @param authToken - Firebase auth token
     */ _makeRequest(requestInfo, requestFactory, authToken, appCheckToken, retry = true) {
        if (!this._deleted) {
            const request = makeRequest(requestInfo, this._appId, authToken, appCheckToken, requestFactory, this._firebaseVersion, retry, this._isUsingEmulator);
            this._requests.add(request);
            // Request removes itself from set when complete.
            request.getPromise().then(()=>this._requests.delete(request), ()=>this._requests.delete(request));
            return request;
        } else return new FailRequest(appDeleted());
    }
    async makeRequestWithTokens(requestInfo, requestFactory) {
        const [authToken, appCheckToken] = await Promise.all([
            this._getAuthToken(),
            this._getAppCheckToken()
        ]);
        return this._makeRequest(requestInfo, requestFactory, authToken, appCheckToken).getPromise();
    }
}
const name = "@firebase/storage";
const version = "0.14.3";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Type constant for Firebase Storage.
 */ const STORAGE_TYPE = 'storage';
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise containing the object's bytes
 */ function getBytes(ref, maxDownloadSizeBytes) {
    ref = (0, _util.getModularInstance)(ref);
    return getBytesInternal(ref, maxDownloadSizeBytes);
}
/**
 * Uploads data to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns A Promise containing an UploadResult
 */ function uploadBytes(ref, data, metadata) {
    ref = (0, _util.getModularInstance)(ref);
    return uploadBytes$1(ref, data, metadata);
}
/**
 * Uploads a string to this object's location.
 * The upload is not resumable.
 * @public
 * @param ref - {@link StorageReference} where string should be uploaded.
 * @param value - The string to upload.
 * @param format - The format of the string to upload.
 * @param metadata - Metadata for the string to upload.
 * @returns A Promise containing an UploadResult
 */ function uploadString(ref, value, format, metadata) {
    ref = (0, _util.getModularInstance)(ref);
    return uploadString$1(ref, value, format, metadata);
}
/**
 * Uploads data to this object's location.
 * The upload can be paused and resumed, and exposes progress updates.
 * @public
 * @param ref - {@link StorageReference} where data should be uploaded.
 * @param data - The data to upload.
 * @param metadata - Metadata for the data to upload.
 * @returns An UploadTask
 */ function uploadBytesResumable(ref, data, metadata) {
    ref = (0, _util.getModularInstance)(ref);
    return uploadBytesResumable$1(ref, data, metadata);
}
/**
 * A `Promise` that resolves with the metadata for this object. If this
 * object doesn't exist or metadata cannot be retrieved, the promise is
 * rejected.
 * @public
 * @param ref - {@link StorageReference} to get metadata from.
 */ function getMetadata(ref) {
    ref = (0, _util.getModularInstance)(ref);
    return getMetadata$1(ref);
}
/**
 * Updates the metadata for this object.
 * @public
 * @param ref - {@link StorageReference} to update metadata for.
 * @param metadata - The new metadata for the object.
 *     Only values that have been explicitly set will be changed. Explicitly
 *     setting a value to null will remove the metadata.
 * @returns A `Promise` that resolves with the new metadata for this object.
 */ function updateMetadata(ref, metadata) {
    ref = (0, _util.getModularInstance)(ref);
    return updateMetadata$1(ref, metadata);
}
/**
 * List items (files) and prefixes (folders) under this storage reference.
 *
 * List API is only available for Firebase Rules Version 2.
 *
 * GCS is a key-blob store. Firebase Storage imposes the semantic of '/'
 * delimited folder structure.
 * Refer to GCS's List API if you want to learn more.
 *
 * To adhere to Firebase Rules's Semantics, Firebase Storage does not
 * support objects whose paths end with "/" or contain two consecutive
 * "/"s. Firebase Storage List API will filter these unsupported objects.
 * list() may fail if there are too many unsupported objects in the bucket.
 * @public
 *
 * @param ref - {@link StorageReference} to get list from.
 * @param options - See {@link ListOptions} for details.
 * @returns A `Promise` that resolves with the items and prefixes.
 *      `prefixes` contains references to sub-folders and `items`
 *      contains references to objects in this folder. `nextPageToken`
 *      can be used to get the rest of the results.
 */ function list(ref, options) {
    ref = (0, _util.getModularInstance)(ref);
    return list$1(ref, options);
}
/**
 * List all items (files) and prefixes (folders) under this storage reference.
 *
 * This is a helper method for calling list() repeatedly until there are
 * no more results. The default pagination size is 1000.
 *
 * Note: The results may not be consistent if objects are changed while this
 * operation is running.
 *
 * Warning: `listAll` may potentially consume too many resources if there are
 * too many results.
 * @public
 * @param ref - {@link StorageReference} to get list from.
 *
 * @returns A `Promise` that resolves with all the items and prefixes under
 *      the current storage reference. `prefixes` contains references to
 *      sub-directories and `items` contains references to objects in this
 *      folder. `nextPageToken` is never returned.
 */ function listAll(ref) {
    ref = (0, _util.getModularInstance)(ref);
    return listAll$1(ref);
}
/**
 * Returns the download URL for the given {@link StorageReference}.
 * @public
 * @param ref - {@link StorageReference} to get the download URL for.
 * @returns A `Promise` that resolves with the download
 *     URL for this object.
 */ function getDownloadURL(ref) {
    ref = (0, _util.getModularInstance)(ref);
    return getDownloadURL$1(ref);
}
/**
 * Deletes the object at this location.
 * @public
 * @param ref - {@link StorageReference} for object to delete.
 * @returns A `Promise` that resolves if the deletion succeeds.
 */ function deleteObject(ref) {
    ref = (0, _util.getModularInstance)(ref);
    return deleteObject$1(ref);
}
function ref(serviceOrRef, pathOrUrl) {
    serviceOrRef = (0, _util.getModularInstance)(serviceOrRef);
    return ref$1(serviceOrRef, pathOrUrl);
}
/**
 * @internal
 */ function _getChild(ref, childPath) {
    return _getChild$1(ref, childPath);
}
/**
 * Gets a {@link FirebaseStorage} instance for the given Firebase app.
 * @public
 * @param app - Firebase app to get {@link FirebaseStorage} instance for.
 * @param bucketUrl - The gs:// url to your Firebase Storage Bucket.
 * If not passed, uses the app's default Storage Bucket.
 * @returns A {@link FirebaseStorage} instance.
 */ function getStorage(app = (0, _app.getApp)(), bucketUrl) {
    app = (0, _util.getModularInstance)(app);
    const storageProvider = (0, _app._getProvider)(app, STORAGE_TYPE);
    const storageInstance = storageProvider.getImmediate({
        identifier: bucketUrl
    });
    const emulator = (0, _util.getDefaultEmulatorHostnameAndPort)('storage');
    if (emulator) connectStorageEmulator(storageInstance, ...emulator);
    return storageInstance;
}
/**
 * Modify this {@link FirebaseStorage} instance to communicate with the Cloud Storage emulator.
 *
 * @param storage - The {@link FirebaseStorage} instance
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @param options - Emulator options. `options.mockUserToken` is the mock auth
 * token to use for unit testing Security Rules.
 * @public
 */ function connectStorageEmulator(storage, host, port, options = {}) {
    connectStorageEmulator$1(storage, host, port, options);
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Downloads the data at the object's location. Returns an error if the object
 * is not found.
 *
 * To use this functionality, you have to whitelist your app's origin in your
 * Cloud Storage bucket. See also
 * https://cloud.google.com/storage/docs/configuring-cors
 *
 * This API is not available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A Promise that resolves with a Blob containing the object's bytes
 */ function getBlob(ref, maxDownloadSizeBytes) {
    ref = (0, _util.getModularInstance)(ref);
    return getBlobInternal(ref, maxDownloadSizeBytes);
}
/**
 * Downloads the data at the object's location. Raises an error event if the
 * object is not found.
 *
 * This API is only available in Node.
 *
 * @public
 * @param ref - StorageReference where data should be downloaded.
 * @param maxDownloadSizeBytes - If set, the maximum allowed size in bytes to
 * retrieve.
 * @returns A stream with the object's data as bytes
 */ function getStream(ref, maxDownloadSizeBytes) {
    throw new Error('getStream() is only supported by NodeJS builds');
}
/**
 * Cloud Storage for Firebase
 *
 * @packageDocumentation
 */ function factory(container, { instanceIdentifier: url }) {
    const app = container.getProvider('app').getImmediate();
    const authProvider = container.getProvider('auth-internal');
    const appCheckProvider = container.getProvider('app-check-internal');
    return new FirebaseStorageImpl(app, authProvider, appCheckProvider, url, (0, _app.SDK_VERSION));
}
function registerStorage() {
    (0, _app._registerComponent)(new (0, _component.Component)(STORAGE_TYPE, factory, "PUBLIC" /* ComponentType.PUBLIC */ ).setMultipleInstances(true));
    //RUNTIME_ENV will be replaced during the compilation to "node" for nodejs and an empty string for browser
    (0, _app.registerVersion)(name, version, '');
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, _app.registerVersion)(name, version, 'esm2020');
}
registerStorage();

},{"@firebase/app":"iO7sa","@firebase/util":"fHqXn","@firebase/component":"6VF6E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d1HdY":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("8wUar"));

},{}],"feOFD":[function(require,module,exports,__globalThis) {
module.exports = Promise.resolve(module.bundle.root("xSUJJ"));

},{}],"41GVV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getUserIdFromToken", ()=>getUserIdFromToken);
const getUserIdFromToken = (token)=>{
    if (!token) return null;
    try {
        const base64Url = token.split('.')[1];
        if (!base64Url) return null;
        // Convert base64url to base64
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        // Decode base64 and handle URI components for special characters
        const jsonPayload = decodeURIComponent(atob(base64).split('').map((c)=>'%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
        const payload = JSON.parse(jsonPayload);
        // Firebase auth ID token puts the UID in the user_id field
        return payload.user_id || payload.sub || null;
    } catch (e) {
        console.error('Failed to parse token payload:', e);
        return null;
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3gbTg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchOnboardingState", ()=>fetchOnboardingState);
parcelHelpers.export(exports, "useGetOnboardingState", ()=>useGetOnboardingState);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _sessionStore = require("src/store/sessionStore");
const fetchOnboardingState = async (uid)=>{
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_ONBOARDING_STATE}?uid=${uid}`;
    const response = await fetch(apiUrl);
    if (!response.ok) {
        if (response.status === 404) return {
            onboarding: {},
            profile: {}
        };
        throw new Error('Failed to fetch onboarding state');
    }
    const res = await response.json();
    // Automatically sync the user profile into the global sessionStore
    if (res.profile) {
        const currentToken = (0, _sessionStore.sessionStore).getState().token;
        if (currentToken) (0, _sessionStore.sessionStore).getState().setToken(currentToken, {
            ...res.profile,
            uid: res.profile.uid || uid
        });
    }
    return {
        onboarding: res.data || {},
        profile: res.profile || {}
    };
};
function useGetOnboardingState(uid) {
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'onboarding-state',
            uid
        ],
        queryFn: async ()=>{
            if (!uid) return null;
            return fetchOnboardingState(uid);
        },
        enabled: !!uid,
        staleTime: 300000
    });
}

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bUlwo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientType", ()=>ClientType);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _gsap = require("gsap");
var _clientTypeScss = require("./ClientType.scss");
var _useGetOnboardingMasterData = require("src/api/mutations/useGetOnboardingMasterData");
var _useSaveOnboardingStep = require("src/api/mutations/useSaveOnboardingStep");
var _sessionStore = require("src/store/sessionStore");
var _authUtils = require("src/utils/authUtils");
var _useGetOnboardingState = require("src/api/mutations/useGetOnboardingState");
var _appAlert = require("src/utils/appAlert");
var _appAlertDefault = parcelHelpers.interopDefault(_appAlert);
var _healthMobilityLifestyleSvg = require("../../../../assets/images/onboarding-trainer/client-type/health_mobility_lifestyle.svg");
var _performanceStrengthSvg = require("../../../../assets/images/onboarding-trainer/client-type/performance__strength.svg");
var _bodyTransformationSvg = require("../../../../assets/images/onboarding-trainer/client-type/body_transformation.svg");
var _generalFitnessSvg = require("../../../../assets/images/onboarding-trainer/client-type/general_fitness.svg");
var _goalSpecificSvg = require("../../../../assets/images/onboarding-trainer/client-type/goal_specific.svg");
var _beginnerSvg = require("../../../../assets/images/onboarding-trainer/client-type/beginner.svg");
const ICON_MAP = {
    'goal-specific': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _goalSpecificSvg.ReactComponent), {}),
    beginner: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _beginnerSvg.ReactComponent), {}),
    'general-fitness': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalFitnessSvg.ReactComponent), {}),
    'body-transformation': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bodyTransformationSvg.ReactComponent), {}),
    'performance-strength': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _performanceStrengthSvg.ReactComponent), {}),
    'health-mobility': /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _healthMobilityLifestyleSvg.ReactComponent), {})
};
const ClientType = ({ onNext, onBack })=>{
    const [selectedIds, setSelectedIds] = (0, _react.useState)([]);
    const cardsRef = (0, _react.useRef)([]);
    const { data: masterData } = (0, _useGetOnboardingMasterData.useGetOnboardingMasterData)();
    const { mutate: saveStep, isPending } = (0, _useSaveOnboardingStep.useSaveOnboardingStep)();
    const token = (0, _sessionStore.sessionStore)((s)=>s.token);
    const userId = (0, _authUtils.getUserIdFromToken)(token);
    const clientTypeData = masterData?.['onboarding_client_type'];
    const options = clientTypeData?.options || [];
    // Mobile specific title based on the screenshot
    const titleText = clientTypeData?.title || 'What type of clients are you looking for?';
    const { data: stateData } = (0, _useGetOnboardingState.useGetOnboardingState)(userId || undefined);
    (0, _react.useEffect)(()=>{
        if (stateData?.onboarding?.step2_client_types && selectedIds.length === 0) setSelectedIds(stateData.onboarding.step2_client_types);
    }, [
        selectedIds.length,
        stateData?.onboarding.step2_client_types
    ]);
    (0, _react.useEffect)(()=>{
        if (cardsRef.current.length > 0) (0, _gsap.gsap).fromTo(cardsRef.current, {
            opacity: 0,
            y: 25
        }, {
            opacity: 1,
            y: 0,
            duration: 0.85,
            stagger: 0.15,
            ease: 'power3.out'
        });
    }, [
        options.length
    ]);
    const handleToggle = (id)=>{
        if (selectedIds.includes(id)) setSelectedIds(selectedIds.filter((i)=>i !== id));
        else {
            if (selectedIds.length >= 3) {
                (0, _appAlertDefault.default).error('You can select a maximum of 3 client types.');
                return;
            }
            setSelectedIds([
                ...selectedIds,
                id
            ]);
        }
    };
    const handleNext = ()=>{
        if (selectedIds.length > 0) {
            if (userId) saveStep({
                uid: userId,
                step: 2,
                data: selectedIds
            });
            if (onNext) onNext(selectedIds);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "client-type-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "client-type-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "title",
                        children: titleText
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "subtitle",
                        children: clientTypeData?.subtitle || 'Select all that apply'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "client-type-grid",
                children: options.map((option, index)=>{
                    const isSelected = selectedIds.includes(option.slug);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        ref: (el)=>{
                            cardsRef.current[index] = el;
                        },
                        className: `client-type-card ${isSelected ? 'selected' : ''}`,
                        onClick: ()=>handleToggle(option.slug),
                        style: {
                            opacity: 0
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "card-header-icon",
                                        children: ICON_MAP[option.slug]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: option.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "radio-circle",
                                children: isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "#000",
                                    strokeWidth: "4",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "20 6 9 17 4 12"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: option.description
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                        className: "feature-list",
                                        children: (option.bullets || []).map((feature, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "check-icon",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            width: "12",
                                                            height: "10",
                                                            viewBox: "0 0 12 10",
                                                            fill: "none",
                                                            xmlns: "http://www.w3.org/2000/svg",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M1 5L4.5 8.5L11 1",
                                                                stroke: "#fff",
                                                                strokeWidth: "1.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        })
                                                    }),
                                                    feature
                                                ]
                                            }, i))
                                    })
                                ]
                            })
                        ]
                    }, option.slug);
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "client-type-footer",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "progress-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: '66%'
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "footer-actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "back-btn-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "btn-back",
                                    onClick: onBack,
                                    disabled: isPending,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M19 12H5M5 12L12 19M5 12L12 5",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        }),
                                        "Back"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next-btn-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: `btn-next ${selectedIds.length > 0 ? 'active' : ''}`,
                                    onClick: handleNext,
                                    disabled: selectedIds.length === 0,
                                    children: [
                                        "Next",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M5 12H19M19 12L12 5M19 12L12 19",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","gsap":"kKW9v","./ClientType.scss":"8O1dB","src/api/mutations/useGetOnboardingMasterData":"dhU6k","src/api/mutations/useSaveOnboardingStep":"iDROn","src/store/sessionStore":"kPSO3","src/utils/authUtils":"41GVV","src/api/mutations/useGetOnboardingState":"3gbTg","src/utils/appAlert":"de4Mq","../../../../assets/images/onboarding-trainer/client-type/health_mobility_lifestyle.svg":"1JoNG","../../../../assets/images/onboarding-trainer/client-type/performance__strength.svg":"hpXNV","../../../../assets/images/onboarding-trainer/client-type/body_transformation.svg":"39Brm","../../../../assets/images/onboarding-trainer/client-type/general_fitness.svg":"kHRDZ","../../../../assets/images/onboarding-trainer/client-type/goal_specific.svg":"2FFJm","../../../../assets/images/onboarding-trainer/client-type/beginner.svg":"2rQxo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8O1dB":[function() {},{}],"de4Mq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AppAlert", ()=>AppAlert);
parcelHelpers.export(exports, "toast", ()=>customToast);
var _reactHotToast = require("react-hot-toast");
const extractId = (message)=>{
    if (typeof message === 'string') return message;
    return undefined;
};
const customToast = (message, options)=>{
    const id = options?.id || extractId(message);
    return (0, _reactHotToast.toast)(message, {
        id,
        ...options
    });
};
customToast.error = (message, options)=>{
    const id = options?.id || extractId(message);
    return (0, _reactHotToast.toast).error(message, {
        id,
        ...options
    });
};
customToast.success = (message, options)=>{
    const id = options?.id || extractId(message);
    return (0, _reactHotToast.toast).success(message, {
        id,
        ...options
    });
};
customToast.loading = (message, options)=>{
    const id = options?.id || extractId(message);
    return (0, _reactHotToast.toast).loading(message, {
        id,
        ...options
    });
};
customToast.dismiss = (0, _reactHotToast.toast).dismiss;
customToast.remove = (0, _reactHotToast.toast).remove;
customToast.promise = (0, _reactHotToast.toast).promise;
customToast.custom = (0, _reactHotToast.toast).custom;
const AppAlert = {
    error (message, id) {
        customToast.error(message, {
            id
        });
    },
    warning (message, id) {
        customToast(message, {
            icon: "\u26A0\uFE0F",
            id
        });
    },
    success (message, id) {
        customToast.success(message, {
            id
        });
    },
    show (message, id) {
        customToast(message, {
            id
        });
    }
};
exports.default = customToast;

},{"react-hot-toast":"3T0Wh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1JoNG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgHealthMobilityLifestyle);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgHealthMobilityLifestyle = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M24 .25C37.117.25 47.75 10.883 47.75 24S37.117 47.75 24 47.75.25 37.117.25 24 10.883.25 24 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M24 .25C37.117.25 47.75 10.883 47.75 24S37.117 47.75 24 47.75.25 37.117.25 24 10.883.25 24 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                id: "c",
                width: 21,
                height: 23,
                x: 13.25,
                y: 12.25,
                fill: "#000",
                maskUnits: "userSpaceOnUse",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M13.25 12.25h21v23h-21z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M24 14.75a1.75 1.75 0 1 0 0 3.502 1.75 1.75 0 0 0 0-3.502m-3.25 1.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M24 21.77a6 6 0 0 0-.86.052l-.892.15c-2.013.339-3.498 2.102-3.498 4.178a3.25 3.25 0 0 1-1.43 2.696l-.1.069a3.4 3.4 0 0 1-.823.406l-1.157.39a.75.75 0 1 1-.48-1.422l1.16-.39q.245-.082.461-.228l.102-.069a1.75 1.75 0 0 0 .767-1.452c0-2.797 2.003-5.195 4.748-5.657l.89-.15A7 7 0 0 1 24 20.271a7 7 0 0 1 1.112.072l.89.15c2.746.462 4.748 2.86 4.748 5.657 0 .586.29 1.13.768 1.452l.101.069q.218.145.463.228l1.158.39a.75.75 0 0 1-.48 1.422l-1.157-.39a3.4 3.4 0 0 1-.822-.406l-.1-.069a3.25 3.25 0 0 1-1.43-2.696c0-2.076-1.486-3.839-3.498-4.178l-.892-.15a6 6 0 0 0-.86-.051m-3.1 5.78a.75.75 0 1 1 1.2.9l-.924 1.233-.022.029q-.158.219-.34.42a2.75 2.75 0 0 1-1.007.67c-.155.058-.316.098-.52.15l-.035.008-1.794.449a.935.935 0 0 0 .227 1.841h.684c1.546 0 3.05-.501 4.287-1.429L24.55 30.4a.75.75 0 1 1 .9 1.2l-.904.678.491.185c.534.2.775.29 1.017.366a9.3 9.3 0 0 0 2.243.407c.253.014.51.014 1.08.014h.94a.935.935 0 0 0 .225-1.841l-1.473-.369-.082-.02c-.476-.119-.85-.212-1.186-.406a3 3 0 0 1-.29-.192c-.308-.234-.54-.543-.833-.936l-.05-.067-.728-.969a.75.75 0 1 1 1.2-.9l.727.969c.368.491.471.618.591.709q.063.046.132.087c.13.075.287.121.883.27l1.473.368a2.435 2.435 0 0 1-.59 4.797h-.963c-.539 0-.84 0-1.14-.017a10.8 10.8 0 0 1-2.607-.473c-.286-.09-.567-.195-1.072-.384l-1.432-.537a8.65 8.65 0 0 1-4.733 1.411h-.684a2.435 2.435 0 0 1-.59-4.797l1.793-.448c.255-.064.324-.082.384-.105.173-.066.33-.17.458-.304.044-.047.088-.102.246-.313z",
                        clipRule: "evenodd"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                fillRule: "evenodd",
                d: "M24 14.75a1.75 1.75 0 1 0 0 3.502 1.75 1.75 0 0 0 0-3.502m-3.25 1.75a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0M24 21.77a6 6 0 0 0-.86.052l-.892.15c-2.013.339-3.498 2.102-3.498 4.178a3.25 3.25 0 0 1-1.43 2.696l-.1.069a3.4 3.4 0 0 1-.823.406l-1.157.39a.75.75 0 1 1-.48-1.422l1.16-.39q.245-.082.461-.228l.102-.069a1.75 1.75 0 0 0 .767-1.452c0-2.797 2.003-5.195 4.748-5.657l.89-.15A7 7 0 0 1 24 20.271a7 7 0 0 1 1.112.072l.89.15c2.746.462 4.748 2.86 4.748 5.657 0 .586.29 1.13.768 1.452l.101.069q.218.145.463.228l1.158.39a.75.75 0 0 1-.48 1.422l-1.157-.39a3.4 3.4 0 0 1-.822-.406l-.1-.069a3.25 3.25 0 0 1-1.43-2.696c0-2.076-1.486-3.839-3.498-4.178l-.892-.15a6 6 0 0 0-.86-.051m-3.1 5.78a.75.75 0 1 1 1.2.9l-.924 1.233-.022.029q-.158.219-.34.42a2.75 2.75 0 0 1-1.007.67c-.155.058-.316.098-.52.15l-.035.008-1.794.449a.935.935 0 0 0 .227 1.841h.684c1.546 0 3.05-.501 4.287-1.429L24.55 30.4a.75.75 0 1 1 .9 1.2l-.904.678.491.185c.534.2.775.29 1.017.366a9.3 9.3 0 0 0 2.243.407c.253.014.51.014 1.08.014h.94a.935.935 0 0 0 .225-1.841l-1.473-.369-.082-.02c-.476-.119-.85-.212-1.186-.406a3 3 0 0 1-.29-.192c-.308-.234-.54-.543-.833-.936l-.05-.067-.728-.969a.75.75 0 1 1 1.2-.9l.727.969c.368.491.471.618.591.709q.063.046.132.087c.13.075.287.121.883.27l1.473.368a2.435 2.435 0 0 1-.59 4.797h-.963c-.539 0-.84 0-1.14-.017a10.8 10.8 0 0 1-2.607-.473c-.286-.09-.567-.195-1.072-.384l-1.432-.537a8.65 8.65 0 0 1-4.733 1.411h-.684a2.435 2.435 0 0 1-.59-4.797l1.793-.448c.255-.064.324-.082.384-.105.173-.066.33-.17.458-.304.044-.047.088-.102.246-.313z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                d: "M24 14.75v.2zm0-1.5v-.2zm3.25 3.25h.2zm-4.11 5.322-.026-.198h-.007zm-.892.15-.033-.197zM18.75 26.15h-.2zm-1.43 2.696-.112-.166-.001.001zm-.1.069.112.166.002-.001zm-.823.406-.063-.19zm-1.157.39-.063-.19zm-.48-1.422-.063-.19zm1.16-.39.063.19zm.461-.228.112.166zm.102-.069.113.166zm.767-1.452h-.2zm4.748-5.657.034.197zm.89-.15-.028-.198h-.005zM24 20.271l-.003.2h.006zm1.112.072.034-.197h-.005zm.89.15-.033.197zm5.516 7.109.113-.165zm.101.069-.112.165.001.001zm.463.228-.063.19zm1.158.39.064-.19zm-.48 1.422.064-.19zm-1.157-.39.064-.19zm-.822-.406-.112.165zm-.1-.069.112-.165zm-1.43-2.696h.2zm-3.498-4.178.034-.197zm-.892-.15.034-.197-.007-.001zm-3.96 5.729.16.12zm1.2.9-.16-.12zm-.924 1.233.16.12zm-.022.029-.159-.12-.003.003zm-.34.42.145.138.004-.004zm-1.007.67.07.187h.002zm-.52.15.045.195.005-.001zm-.035.008-.044-.195-.004.001zm-1.794.449-.048-.194h-.001zm.227 1.841v.2zm4.971-1.429.12.16zM24.55 30.4l-.12-.16zm.9 1.2.12.16zm-.904.678-.12-.16-.291.219.34.128zm.491.185-.07.187zm1.017.366-.06.19zm2.243.407-.01.2zm2.02.014v.2zm.225-1.841.05-.194h-.001zm-1.473-.369.049-.194h-.001zm-.082-.02-.048.194h.001zm-1.186-.406-.1.173zm-.29-.192-.12.16zm-.833-.936.16-.12v-.001zm-.05-.067-.16.12v.001zm-.728-.969-.16.12zm1.2-.9-.16.12zm.727.969.16-.12zm.591.709-.12.16.003.002zm.132.087-.102.172.003.001zm.883.27-.048.194zm1.473.368.049-.194zm-.59 4.797v.2zm-2.103-.017.012-.2zm-2.607-.473-.06.19zm-1.072-.384-.07.187zm-1.432-.537.07-.187-.094-.036-.085.056zM18.37 34.75v.2zm-.684 0v.2zm-.59-4.797-.048-.194zm1.793-.448.049.194zm.384-.105-.07-.187H19.2zm.458-.304.145.138.001-.001zm.246-.313-.16-.12zM24 14.75v-.2c-.256 0-.51.05-.746.148l.077.185.076.185A1.6 1.6 0 0 1 24 14.95zm-.67.133-.076-.185a2 2 0 0 0-.632.423l.141.142.141.141a1.6 1.6 0 0 1 .503-.336zm-.567.38-.141-.142a2 2 0 0 0-.423.633l.185.076.184.077a1.6 1.6 0 0 1 .336-.503zm-.38.567-.184-.076a2 2 0 0 0-.149.746h.4c0-.203.04-.405.118-.593zm-.133.67h-.2c0 .256.05.51.149.746l.185-.076.184-.077a1.6 1.6 0 0 1-.118-.593zm.134.67-.185.076c.098.237.241.452.423.633l.141-.142.141-.141a1.6 1.6 0 0 1-.336-.503zm.379.567-.141.142c.18.18.396.325.632.423l.077-.185.076-.185a1.6 1.6 0 0 1-.503-.336zm.568.38-.077.185c.237.098.49.148.746.148v-.4a1.6 1.6 0 0 1-.593-.118zm.67.133v.2a1.95 1.95 0 0 0 1.378-.571l-.141-.142-.142-.141A1.55 1.55 0 0 1 24 18.05zm1.237-.513.141.142a1.95 1.95 0 0 0 .571-1.379h-.4c0 .411-.163.805-.454 1.096zm.512-1.237h.2a1.95 1.95 0 0 0-.57-1.379l-.142.142-.142.141c.291.29.454.685.454 1.096zm-.512-1.237.141-.142A1.95 1.95 0 0 0 24 14.55v.4c.412 0 .806.163 1.096.454zM20.75 16.5h.2c0-.809.322-1.585.894-2.157l-.142-.141-.141-.142a3.45 3.45 0 0 0-1.01 2.44zm.952-2.298.142.141A3.05 3.05 0 0 1 24 13.45v-.4a3.45 3.45 0 0 0-2.44 1.01zM24 13.25v.2a3.05 3.05 0 0 1 2.157.893l.142-.141.14-.142A3.45 3.45 0 0 0 24 13.05zm2.299.952-.142.141a3.05 3.05 0 0 1 .893 2.157h.4a3.45 3.45 0 0 0-1.01-2.44zm.951 2.298h-.2a3.05 3.05 0 0 1-.893 2.157l.142.141.14.142a3.45 3.45 0 0 0 1.011-2.44zm-.951 2.298-.142-.141A3.05 3.05 0 0 1 24 19.55v.4a3.45 3.45 0 0 0 2.44-1.01zM24 19.75v-.2a3.05 3.05 0 0 1-2.156-.893l-.142.141-.141.142A3.45 3.45 0 0 0 24 19.95zm-2.298-.952.142-.141a3.05 3.05 0 0 1-.894-2.157h-.4a3.45 3.45 0 0 0 1.01 2.44zM24 21.77l.003-.2a6 6 0 0 0-.889.054l.026.198.027.198q.413-.054.831-.05zm-.86.052-.033-.197-.892.15.033.197.034.197.892-.15zm-.892.15-.033-.197c-2.11.355-3.665 2.203-3.665 4.375h.4c0-1.98 1.416-3.658 3.332-3.98zM18.75 26.15h-.2c0 .5-.121.991-.355 1.433l.177.093.176.094a3.45 3.45 0 0 0 .402-1.62zm-.378 1.526-.177-.093a3.05 3.05 0 0 1-.987 1.097l.112.166.112.166a3.45 3.45 0 0 0 1.116-1.242zm-1.052 1.17-.113-.165-.1.07.113.164.114.165.1-.07zm-.1.069-.111-.166q-.361.244-.775.382l.063.19.064.19c.308-.104.602-.248.871-.43zm-.823.406-.063-.19-1.157.39.063.19.064.19 1.157-.39zm-1.157.39-.064-.19a.55.55 0 0 1-.42-.028l-.089.18-.088.179a.95.95 0 0 0 .725.049zm-.573-.038.09-.18a.55.55 0 0 1-.278-.317l-.19.064-.19.064a.95.95 0 0 0 .48.548zm-.378-.433.19-.064a.55.55 0 0 1 .028-.42l-.179-.089-.18-.089a.95.95 0 0 0-.048.726zm.039-.573.18.089a.55.55 0 0 1 .316-.277l-.064-.19-.064-.19a.95.95 0 0 0-.547.48zm.432-.378.064.19 1.16-.39-.065-.19-.063-.19-1.16.39zm1.16-.39.063.19q.271-.091.51-.252l-.112-.166-.111-.166q-.194.13-.415.204zm.461-.228.113.166.102-.07-.113-.165-.112-.166-.102.07zm.102-.069.113.165c.264-.179.48-.42.629-.702l-.177-.094-.177-.093a1.55 1.55 0 0 1-.5.558zm.565-.63.177.093c.149-.282.226-.597.225-.916l-.2.001h-.2c.001.254-.06.504-.179.728zm.202-.822h.2c0-2.7 1.934-5.014 4.582-5.46l-.034-.197-.033-.197c-2.843.478-4.915 2.96-4.915 5.854zm4.748-5.657.034.197.89-.15-.034-.197-.033-.197-.89.15zm.89-.15.03.198a7 7 0 0 1 1.08-.07l.002-.2.003-.2a7 7 0 0 0-1.143.074zM24 20.271l.003.2q.544-.009 1.08.07l.03-.198.028-.198a7 7 0 0 0-1.144-.074zm1.112.072-.033.197.89.15.033-.197.034-.197-.89-.15zm.89.15-.033.197c2.648.446 4.581 2.759 4.581 5.46h.4c0-2.893-2.07-5.376-4.914-5.854zm4.748 5.657h-.2c0 .652.323 1.258.857 1.618l.111-.166.112-.166a1.55 1.55 0 0 1-.68-1.286zm.768 1.452-.112.165.1.07.113-.166.113-.165-.1-.07zm.101.069-.11.166q.239.16.51.252l.063-.19.064-.19a1.8 1.8 0 0 1-.416-.204zm.463.228-.063.19 1.158.39.063-.19.064-.19-1.158-.39zm1.158.39-.064.19a.55.55 0 0 1 .318.277l.179-.089.18-.089a.95.95 0 0 0-.549-.479zm.433.378-.18.089a.55.55 0 0 1 .029.42l.19.064.189.064a.95.95 0 0 0-.049-.726zm.038.573-.19-.064a.55.55 0 0 1-.276.317l.089.18.088.179a.95.95 0 0 0 .479-.548zm-.377.433-.09-.18a.55.55 0 0 1-.42.029l-.064.189-.064.19c.24.08.5.063.726-.05zm-.574.038.064-.19-1.157-.39-.064.19-.064.19 1.157.39zm-1.157-.39.064-.19a3.2 3.2 0 0 1-.774-.382l-.112.166-.111.166c.269.182.562.326.87.43zm-.822-.406.113-.165-.1-.07-.114.166-.112.165.1.07zm-.1-.069.111-.166a3.05 3.05 0 0 1-.986-1.097l-.177.093-.176.094a3.45 3.45 0 0 0 1.115 1.242zm-1.052-1.17.177-.093a3.05 3.05 0 0 1-.356-1.433h-.4c0 .565.138 1.121.403 1.62zm-.379-1.526h.2c0-2.172-1.554-4.02-3.663-4.375l-.034.197-.033.197c1.915.323 3.33 2.001 3.33 3.981zm-3.497-4.178.034-.197-.892-.15-.034.197-.033.197.892.15zm-.892-.15.027-.198a6 6 0 0 0-.89-.053l.003.2.003.2q.418-.005.831.05zm-3.96 5.729.16.12a.6.6 0 0 1 .16-.143l-.102-.172-.102-.173a1 1 0 0 0-.276.248zm.218-.195.102.172a.6.6 0 0 1 .203-.072l-.029-.197-.028-.198a1 1 0 0 0-.35.122zm.276-.098.029.198a.6.6 0 0 1 .214.012l.05-.194.05-.193a1 1 0 0 0-.37-.02zm.293.017-.05.193a.6.6 0 0 1 .193.093l.12-.16.12-.16a1 1 0 0 0-.334-.16zm.263.126-.12.16a.6.6 0 0 1 .144.16l.172-.102.172-.102a1 1 0 0 0-.248-.276zm.196.218-.172.102a.6.6 0 0 1 .07.202l.199-.028.198-.028a1 1 0 0 0-.123-.35zm.097.276-.198.028a.6.6 0 0 1-.012.215l.194.05.194.049a1 1 0 0 0 .02-.37zm-.016.292-.194-.05a.6.6 0 0 1-.093.194l.16.12.16.12a1 1 0 0 0 .16-.334zm-.127.264-.16-.12-.924 1.233.16.12.16.12.925-1.233zm-.924 1.233-.159-.12-.022.028.16.121.159.12.022-.028zm-.022.029-.162-.117q-.152.21-.326.403l.148.134.149.134q.19-.21.353-.437zm-.34.42-.144-.138a2.55 2.55 0 0 1-.934.621l.071.187.072.187a2.95 2.95 0 0 0 1.08-.719zm-1.007.67-.07-.187c-.142.053-.291.09-.499.143l.05.194.049.194c.2-.051.373-.094.54-.157zm-.52.15-.044-.195-.035.008.044.195.045.195.035-.008zm-.035.008-.048-.194-1.794.449.048.194.049.194 1.794-.449zm-1.794.449-.049-.194a1.14 1.14 0 0 0-.657.46l.165.113.166.112a.74.74 0 0 1 .425-.297zm-.54.379-.166-.113a1.14 1.14 0 0 0-.189.779l.198-.025.199-.024a.74.74 0 0 1 .123-.505zm-.157.641-.198.025c.034.274.166.526.373.71l.133-.15.132-.15a.74.74 0 0 1-.241-.459zm.308.585-.133.15c.206.183.472.285.749.286v-.2l.001-.2a.74.74 0 0 1-.485-.185zm.616.236v.2h.684v-.4h-.684zm.684 0v.2a7.34 7.34 0 0 0 4.407-1.469l-.12-.16-.12-.16a6.94 6.94 0 0 1-4.167 1.389zm4.287-1.429.12.16 1.893-1.422-.12-.16-.12-.16-1.893 1.422zM24.55 30.4l.12.16a.6.6 0 0 1 .194-.093l-.05-.194-.05-.193a1 1 0 0 0-.334.16zm.264-.127.05.194a.6.6 0 0 1 .214-.011l.029-.198.028-.198a1 1 0 0 0-.37.02zm.293-.015-.029.198a.6.6 0 0 1 .203.07l.102-.171.101-.172a1 1 0 0 0-.35-.123zm.276.097-.102.172a.6.6 0 0 1 .16.143l.16-.12.16-.12a1 1 0 0 0-.277-.247zm.217.195-.16.12a.6.6 0 0 1 .093.193l.194-.05.194-.049a1 1 0 0 0-.16-.334zm.127.264-.194.05a.6.6 0 0 1 .012.214l.198.028.198.028a1 1 0 0 0-.02-.37zm.016.292-.198-.028a.6.6 0 0 1-.071.202l.172.102.172.102a1 1 0 0 0 .123-.35zm-.097.276-.172-.102a.6.6 0 0 1-.144.16l.12.16.12.16a1 1 0 0 0 .248-.276zm-.196.218-.12-.16-.904.678.12.16.12.16.904-.678zm-.904.678-.07.187.49.185.071-.187.07-.187-.49-.185zm.491.185-.07.187c.532.2.78.292 1.027.37l.06-.191.06-.19c-.235-.075-.47-.163-1.006-.363zm1.017.366-.06.19a9.5 9.5 0 0 0 2.292.417l.011-.2.012-.2a9 9 0 0 1-2.195-.398zm2.243.407-.01.2c.26.014.523.014 1.09.014v-.4c-.572 0-.822 0-1.069-.014zm1.08.014v.2h.94v-.4h-.94zm.94 0v.2c.276-.002.543-.104.749-.287l-.133-.15-.133-.149a.74.74 0 0 1-.485.186zm.616-.236.133.15c.206-.184.338-.437.372-.71l-.199-.025-.198-.024a.74.74 0 0 1-.241.46zm.306-.585.199.024a1.14 1.14 0 0 0-.19-.778l-.165.113-.165.112a.74.74 0 0 1 .123.505zm-.156-.642.166-.112a1.14 1.14 0 0 0-.657-.46l-.05.194-.049.194c.173.044.324.15.425.297zm-.54-.378.048-.194-1.473-.369-.049.194-.048.194 1.473.369zm-1.474-.369.048-.194-.082-.02-.048.194-.047.194.082.02zm-.082-.02.049-.194c-.483-.12-.828-.208-1.134-.385l-.1.173-.1.173c.363.21.768.31 1.237.427zm-1.186-.406.101-.173a3 3 0 0 1-.27-.18l-.12.161-.12.16q.148.112.309.205zm-.29-.192.121-.16c-.281-.213-.497-.498-.793-.896l-.16.12-.16.12c.288.388.537.721.871.975zm-.833-.936.16-.121-.051-.067-.16.121-.159.121.051.067zm-.05-.067.16-.12-.728-.969-.16.12-.16.12.727.969zm-.728-.969.16-.12a.6.6 0 0 1-.092-.193l-.194.05-.194.049q.048.182.16.334zm-.126-.264.194-.05a.6.6 0 0 1-.012-.214l-.198-.028-.198-.028a1 1 0 0 0 .02.37zm-.016-.292.198.028a.6.6 0 0 1 .071-.202l-.172-.102-.172-.102a1 1 0 0 0-.123.35zm.097-.276.172.102a.6.6 0 0 1 .143-.16l-.12-.16-.12-.16a1 1 0 0 0-.247.276zm.195-.218.12.16a.6.6 0 0 1 .194-.093l-.05-.194-.05-.193a1 1 0 0 0-.334.16zm.264-.127.05.194a.6.6 0 0 1 .214-.011l.029-.198.028-.198a1 1 0 0 0-.37.02zm.293-.015-.029.198a.6.6 0 0 1 .203.07l.102-.171.101-.172a1 1 0 0 0-.35-.123zm.276.097-.102.172a.6.6 0 0 1 .16.143l.16-.12.16-.12a1 1 0 0 0-.277-.247zm.217.195-.16.12.727.969.16-.12.16-.12-.727-.969zm.727.969-.16.12c.36.48.483.636.63.748l.121-.159.121-.16c-.092-.07-.176-.167-.552-.669zm.591.709-.117.162q.07.05.147.097l.102-.172.103-.172q-.061-.037-.117-.076zm.132.087-.1.173c.16.093.352.145.935.291l.048-.194.049-.194c-.609-.152-.732-.192-.832-.25zm.883.27-.048.194 1.473.368.048-.194.049-.194-1.473-.368zm1.473.368-.048.194c.529.133.99.454 1.3.903l.164-.113.165-.113a2.64 2.64 0 0 0-1.532-1.065zm1.416.984-.165.113c.309.45.443.997.376 1.538l.198.024.199.025a2.64 2.64 0 0 0-.443-1.813zm.41 1.675-.2-.024a2.23 2.23 0 0 1-.736 1.4l.133.15.132.15c.481-.426.79-1.013.869-1.651zm-.803 1.526-.133-.15a2.24 2.24 0 0 1-1.48.562v.4c.643 0 1.264-.236 1.745-.662zm-1.613.612v-.2h-.963v.4h.963zm-.963 0v-.2c-.54 0-.835 0-1.128-.017l-.012.2-.01.2c.306.017.613.017 1.15.017zm-1.14-.017.012-.2a10.6 10.6 0 0 1-2.559-.464l-.06.191-.06.19c.863.27 1.755.432 2.656.483zm-2.607-.473.06-.19a22 22 0 0 1-1.061-.381l-.07.187-.07.187c.503.189.79.296 1.081.388zm-1.072-.384.07-.187-1.431-.537-.07.187-.07.187 1.431.537zm-1.432-.537-.11-.167a8.45 8.45 0 0 1-4.623 1.378v.4a8.85 8.85 0 0 0 4.843-1.444zM18.37 34.75v-.2h-.684v.4h.684zm-.684 0v-.2c-.545 0-1.071-.2-1.48-.561l-.132.15-.132.149a2.64 2.64 0 0 0 1.744.662zm-1.612-.612.133-.15a2.23 2.23 0 0 1-.737-1.4l-.199.024-.198.025c.078.638.387 1.225.869 1.651zm-.803-1.526.199-.024a2.24 2.24 0 0 1 .375-1.538l-.164-.113-.165-.113a2.64 2.64 0 0 0-.443 1.813zm.41-1.675.164.113c.309-.45.771-.77 1.3-.903l-.049-.194-.048-.194a2.64 2.64 0 0 0-1.532 1.065zm1.415-.984.049.194 1.793-.448-.049-.194-.048-.194-1.793.448zm1.793-.448.05.194a4 4 0 0 0 .406-.112l-.072-.187-.071-.187a4 4 0 0 1-.361.098zm.384-.105.072.187c.2-.077.382-.197.531-.353l-.145-.138-.144-.138c-.108.112-.24.2-.385.255zm.458-.304.146.137c.053-.057.104-.122.26-.33l-.16-.12-.16-.12c-.16.213-.197.259-.232.296zm.246-.313.16.12.925-1.232-.16-.12-.16-.12-.924 1.232z",
                mask: "url(#c)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 50.175,
                        x2: 12.891,
                        y1: 48.012,
                        y2: -12.312,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 24,
                        x2: 24,
                        y1: 0,
                        y2: 48,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hpXNV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPerformanceStrength);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPerformanceStrength = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M24 .25C37.117.25 47.75 10.883 47.75 24S37.117 47.75 24 47.75.25 37.117.25 24 10.883.25 24 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M24 .25C37.117.25 47.75 10.883 47.75 24S37.117 47.75 24 47.75.25 37.117.25 24 10.883.25 24 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "m26.402 26.4-4.8-4.8m9.058 11.885a2 2 0 0 1-2.83-2.828l-1.767 1.768a2 2 0 0 1-2.829-2.829l6.364-6.364a2 2 0 1 1 2.83 2.83l-1.769 1.766a2 2 0 0 1 2.828 2.83zm2.842.015-1.4-1.4M15.9 15.9l-1.4-1.4m3.905 10.268a2 2 0 0 1-2.83-2.83l1.769-1.766a2 2 0 1 1-2.828-2.83l2.828-2.827a2 2 0 1 1 2.829 2.828l1.767-1.768a2 2 0 1 1 2.829 2.829z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 50.175,
                        x2: 12.891,
                        y1: 48.012,
                        y2: -12.312,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 24,
                        x2: 24,
                        y1: 0,
                        y2: 48,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"39Brm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBodyTransformation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBodyTransformation = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M24 .25C37.117.25 47.75 10.883 47.75 24S37.117 47.75 24 47.75.25 37.117.25 24 10.883.25 24 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M24 .25C37.117.25 47.75 10.883 47.75 24S37.117 47.75 24 47.75.25 37.117.25 24 10.883.25 24 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M14.02 32.305c1.129 1.615 6.04 2.882 8.362-.14 2.51 1.2 6.649.828 10.02-1.052.468-.26.91-.59 1.183-1.054.613-1.045.627-2.495-.491-4.634-1.865-4.654-5.218-8.74-6.572-10.383-.278-.253-2.051-.613-3.133-.96-.478-.147-1.367-.245-2.43 1.157-.505.664-2.796 2.297.11 3.394.45.115.782.326 2.837-.049.267-.046.935 0 1.406.826l.984 1.407a.96.96 0 0 1 .169.44c.172 1.5.166 3.375 1.002 4.326-1.29-.934-4.664-2.042-7.206 1.112m-6.257-1.755a6.715 6.715 0 0 1 8.416-.418"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 50.175,
                        x2: 12.891,
                        y1: 48.012,
                        y2: -12.312,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 24,
                        x2: 24,
                        y1: 0,
                        y2: 48,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kHRDZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGeneralFitness);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGeneralFitness = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M24 .25C37.117.25 47.75 10.883 47.75 24S37.117 47.75 24 47.75.25 37.117.25 24 10.883.25 24 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M24 .25C37.117.25 47.75 10.883 47.75 24S37.117 47.75 24 47.75.25 37.117.25 24 10.883.25 24 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#c)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    stroke: "#FFA100",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M33 25.5v-5.386c0-4.067-3.022-7.364-6.75-7.364s-6.75 3.297-6.75 7.364a4.72 4.72 0 0 0 4.5 4.909 4.72 4.72 0 0 0 4.5-4.909c0-4.067-3.022-7.364-6.75-7.364S15 16.047 15 20.114V25.5m-2.25 3h4.5m13.5 0h4.5M12.75 33a2.25 2.25 0 0 0 4.5 0v-6.75a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75zm18 0a2.25 2.25 0 0 0 4.5 0v-6.75a.75.75 0 0 0-.75-.75h-3a.75.75 0 0 0-.75.75z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 50.175,
                        x2: 12.891,
                        y1: 48.012,
                        y2: -12.312,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 24,
                        x2: 24,
                        y1: 0,
                        y2: 48,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "c",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M12 12h24v24H12z"
                        })
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2FFJm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGoalSpecific);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGoalSpecific = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M24 .25C37.117.25 47.75 10.883 47.75 24S37.117 47.75 24 47.75.25 37.117.25 24 10.883.25 24 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M24 .25C37.117.25 47.75 10.883 47.75 24S37.117 47.75 24 47.75.25 37.117.25 24 10.883.25 24 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#FFA100",
                clipPath: "url(#c)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M32.17 18.75h-1.86l-4.566 4.564a1.874 1.874 0 1 1-1.06-1.06l4.564-4.565v-1.86a.94.94 0 0 1 .275-.665l1.73-1.73a.25.25 0 0 1 .424.128l.46 2.301 2.3.46a.25.25 0 0 1 .193.306.25.25 0 0 1-.066.116l-1.73 1.73a.94.94 0 0 1-.664.275"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "#FFA100",
                        strokeWidth: 0.2,
                        d: "M27.026 13.447a.854.854 0 0 1 .588 1.053.85.85 0 0 1-1.055.582 9.3 9.3 0 0 0-9.118 2.36 9.276 9.276 0 1 0 15.477 3.998l-.001-.003a.85.85 0 0 1 .59-1.022.85.85 0 0 1 1.043.554v.004c.277.963.425 1.978.425 3.027 0 6.061-4.914 10.975-10.975 10.975S13.025 30.06 13.025 24 17.94 13.025 24 13.025l.384.006c.894.03 1.78.17 2.642.416Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "#FFA100",
                        strokeWidth: 0.2,
                        d: "M20.878 18.328a6.5 6.5 0 0 1 3.863-.76.845.845 0 0 1 .764.942.85.85 0 0 1-.96.746v-.001a4.78 4.78 0 0 0-3.723 1.18A4.78 4.78 0 0 0 19.224 24a4.78 4.78 0 0 0 3.147 4.468 4.774 4.774 0 0 0 6.37-5.026.848.848 0 0 1 1.187-.901.85.85 0 0 1 .502.709h-.001a6.473 6.473 0 0 1-12.813 1.833 6.48 6.48 0 0 1 3.262-6.755Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 50.175,
                        x2: 12.891,
                        y1: 48.012,
                        y2: -12.312,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 24,
                        x2: 24,
                        y1: 0,
                        y2: 48,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "c",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M12 12h24v24H12z"
                        })
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2rQxo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBeginner);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBeginner = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 48,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M24 .25C37.117.25 47.75 10.883 47.75 24S37.117 47.75 24 47.75.25 37.117.25 24 10.883.25 24 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M24 .25C37.117.25 47.75 10.883 47.75 24S37.117 47.75 24 47.75.25 37.117.25 24 10.883.25 24 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M31 32.75a1 1 0 0 0 1-1v-1.246c.004-2.806-3.974-5.004-8-5.004s-8 2.198-8 5.004v1.246a1 1 0 0 0 1 1zm-3.396-13.896a3.604 3.604 0 1 1-7.209 0 3.604 3.604 0 0 1 7.209 0"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 50.175,
                        x2: 12.891,
                        y1: 48.012,
                        y2: -12.312,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 24,
                        x2: 24,
                        y1: 0,
                        y2: 48,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l7rLP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Offer", ()=>Offer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _gsap = require("gsap");
var _offerScss = require("./Offer.scss");
var _useGetOnboardingMasterData = require("src/api/mutations/useGetOnboardingMasterData");
var _useSaveOnboardingStep = require("src/api/mutations/useSaveOnboardingStep");
var _sessionStore = require("src/store/sessionStore");
var _authUtils = require("src/utils/authUtils");
var _appAlert = require("src/utils/appAlert");
var _appAlertDefault = parcelHelpers.interopDefault(_appAlert);
var _useGetOnboardingState = require("src/api/mutations/useGetOnboardingState");
const Offer = ({ onNext, onBack })=>{
    const [selectedOffers, setSelectedOffers] = (0, _react.useState)([]);
    const [customOffers, setCustomOffers] = (0, _react.useState)([]);
    const [customInputValue, setCustomInputValue] = (0, _react.useState)('');
    const [errorMsg, setErrorMsg] = (0, _react.useState)('');
    const pillsRef = (0, _react.useRef)([]);
    const { data: masterData } = (0, _useGetOnboardingMasterData.useGetOnboardingMasterData)();
    const { mutate: saveStep, isPending } = (0, _useSaveOnboardingStep.useSaveOnboardingStep)();
    const token = (0, _sessionStore.sessionStore)((s)=>s.token);
    const userId = (0, _authUtils.getUserIdFromToken)(token);
    const offerData = masterData?.['onboarding_offer'];
    const PREDEFINED_OFFERS = (0, _react.useMemo)(()=>offerData?.options || [], [
        offerData?.options
    ]);
    // Render order: Predefined -> Custom -> "Other"
    const allOffersToRender = [
        ...PREDEFINED_OFFERS,
        ...customOffers.map((title)=>({
                slug: title,
                title,
                isCustom: true
            })),
        {
            slug: 'other',
            title: 'Other'
        }
    ];
    const { data: stateData } = (0, _useGetOnboardingState.useGetOnboardingState)(userId || undefined);
    (0, _react.useEffect)(()=>{
        if (stateData?.onboarding?.step3_offers && selectedOffers.length === 0) {
            const savedOffers = stateData.onboarding.step3_offers;
            setSelectedOffers(savedOffers);
            // Identify custom offers
            if (PREDEFINED_OFFERS.length > 0) {
                const predefinedSlugs = PREDEFINED_OFFERS.map((o)=>o.slug);
                const customs = savedOffers.filter((o)=>!predefinedSlugs.includes(o) && o !== 'other');
                setCustomOffers(customs);
            }
        }
    }, [
        stateData?.onboarding.step3_offers,
        PREDEFINED_OFFERS,
        selectedOffers.length
    ]);
    (0, _react.useEffect)(()=>{
        // Only animate pills that haven't been animated yet (they still have inline opacity: 0)
        const newPills = pillsRef.current.filter((el)=>el && el.style.opacity === '0');
        if (newPills.length > 0) (0, _gsap.gsap).fromTo(newPills, {
            opacity: 0,
            scale: 0.8,
            y: 15
        }, {
            opacity: 1,
            scale: 1,
            y: 0,
            duration: 0.5,
            stagger: 0.05,
            ease: 'back.out(1.5)'
        });
    }, [
        allOffersToRender.length
    ]);
    const handleToggleOffer = (offer)=>{
        setSelectedOffers((prev)=>prev.includes(offer) ? prev.filter((o)=>o !== offer) : [
                ...prev,
                offer
            ]);
    };
    const handleAddCustomOffer = ()=>{
        const rawTokens = customInputValue.split(',').map((s)=>s.trim()).filter(Boolean);
        if (!rawTokens.length) return;
        const invalidTokens = rawTokens.filter((token)=>!/\p{L}/u.test(token));
        if (invalidTokens.length > 0) {
            setErrorMsg('Offers must contain at least one valid letter.');
            return;
        }
        const newCustomOffers = [
            ...customOffers
        ];
        const newSelectedOffers = [
            ...selectedOffers
        ];
        rawTokens.forEach((trimmed)=>{
            const existingPredefined = PREDEFINED_OFFERS.find((o)=>o.title.toLowerCase() === trimmed.toLowerCase());
            if (existingPredefined) {
                if (!newSelectedOffers.includes(existingPredefined.slug)) newSelectedOffers.push(existingPredefined.slug);
            } else {
                if (!newCustomOffers.includes(trimmed)) newCustomOffers.push(trimmed);
                if (!newSelectedOffers.includes(trimmed)) newSelectedOffers.push(trimmed);
            }
        });
        setCustomOffers(newCustomOffers);
        setSelectedOffers(newSelectedOffers);
        setCustomInputValue('');
    };
    const handleNext = ()=>{
        if (selectedOffers.length === 0) return;
        const isOtherSelectedLocal = selectedOffers.includes('other');
        if (isOtherSelectedLocal && customOffers.length === 0 && !customInputValue.trim()) {
            setErrorMsg('Please specify what else you offer.');
            return;
        } else setErrorMsg('');
        const finalSelectedOffers = [
            ...selectedOffers
        ];
        const newCustomOffers = [
            ...customOffers
        ];
        // Auto-add if they typed something but forgot to click Add
        if (isOtherSelectedLocal && customInputValue.trim()) {
            const rawTokens = customInputValue.split(',').map((s)=>s.trim()).filter(Boolean);
            const invalidTokens = rawTokens.filter((token)=>!/\p{L}/u.test(token));
            if (invalidTokens.length > 0) {
                setErrorMsg('Offers must contain at least one valid letter.');
                return;
            }
            rawTokens.forEach((trimmed)=>{
                const existingPredefined = PREDEFINED_OFFERS.find((o)=>o.title.toLowerCase() === trimmed.toLowerCase());
                if (existingPredefined) {
                    if (!finalSelectedOffers.includes(existingPredefined.slug)) finalSelectedOffers.push(existingPredefined.slug);
                } else {
                    if (!newCustomOffers.includes(trimmed)) newCustomOffers.push(trimmed);
                    if (!finalSelectedOffers.includes(trimmed)) finalSelectedOffers.push(trimmed);
                }
            });
        }
        // Don't save 'other' to backend
        const payloadData = finalSelectedOffers.filter((o)=>o !== 'other');
        if (payloadData.length === 0) {
            (0, _appAlertDefault.default).error('Please select at least one valid offer.');
            return;
        }
        if (userId) saveStep({
            uid: userId,
            step: 3,
            data: payloadData
        });
        if (onNext) onNext(payloadData);
    };
    const isOtherSelected = selectedOffers.includes('other');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "offer-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "offer-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "title",
                        children: offerData?.title || 'What do you offer?'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "subtitle",
                        children: offerData?.subtitle || 'Select as many as you like'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "offer-pills-container",
                children: allOffersToRender.map((offer, index)=>{
                    const isSelected = selectedOffers.includes(offer.slug);
                    const isCustom = offer.isCustom;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        ref: (el)=>{
                            pillsRef.current[index] = el;
                        },
                        className: `offer-pill ${isSelected ? 'selected' : ''} ${isCustom ? 'custom-pill' : ''}`,
                        onClick: ()=>handleToggleOffer(offer.slug),
                        style: {
                            opacity: 0
                        },
                        children: [
                            offer.title,
                            isCustom && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "remove-custom",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    setCustomOffers((prev)=>prev.filter((o)=>o !== offer.slug));
                                    setSelectedOffers((prev)=>prev.filter((o)=>o !== offer.slug));
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    width: "12",
                                    height: "12",
                                    viewBox: "0 0 12 12",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M9 3L3 9M3 3L9 9",
                                        stroke: "currentColor",
                                        strokeWidth: "1.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            })
                        ]
                    }, offer.slug);
                })
            }),
            isOtherSelected && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "custom-input-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        className: "custom-input-label",
                        children: "Please specify what else you offer:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "custom-input-wrapper",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                placeholder: "E.g., Yoga, Pilates...",
                                value: customInputValue,
                                onChange: (e)=>{
                                    setCustomInputValue(e.target.value);
                                    if (errorMsg) setErrorMsg('');
                                },
                                onKeyDown: (e)=>{
                                    if (e.key === 'Enter') handleAddCustomOffer();
                                }
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "btn-add",
                                onClick: handleAddCustomOffer,
                                disabled: !customInputValue.trim(),
                                children: "Add"
                            })
                        ]
                    }),
                    errorMsg && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "error-text",
                        style: {
                            color: '#E44E4E',
                            fontSize: '14px',
                            marginTop: '8px'
                        },
                        children: errorMsg
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "offer-footer",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "progress-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "footer-actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                className: "btn-back",
                                onClick: onBack || (()=>window.history.back()),
                                disabled: isPending,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M19 12H5M5 12L12 19M5 12L12 5",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    }),
                                    "Back"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "next-btn-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: `btn-next ${selectedOffers.length > 0 ? 'active' : ''}`,
                                    onClick: handleNext,
                                    disabled: selectedOffers.length === 0,
                                    children: [
                                        "Next",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            xmlns: "http://www.w3.org/2000/svg",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M5 12H19M19 12L12 5M19 12L12 19",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","gsap":"kKW9v","./Offer.scss":"6V3zV","src/api/mutations/useGetOnboardingMasterData":"dhU6k","src/api/mutations/useSaveOnboardingStep":"iDROn","src/store/sessionStore":"kPSO3","src/utils/authUtils":"41GVV","src/utils/appAlert":"de4Mq","src/api/mutations/useGetOnboardingState":"3gbTg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6V3zV":[function() {},{}],"itZID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MAX_SLOTS_PER_DAY", ()=>MAX_SLOTS_PER_DAY);
parcelHelpers.export(exports, "SCHEDULE_SYNC_DAYS_AHEAD", ()=>SCHEDULE_SYNC_DAYS_AHEAD);
parcelHelpers.export(exports, "DEFAULT_SLOT_PROGRESSION", ()=>DEFAULT_SLOT_PROGRESSION);
parcelHelpers.export(exports, "Schedule", ()=>Schedule);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _timezoneUtils = require("./utils/timezoneUtils");
var _timeSlotPicker = require("./components/TimeSlotPicker");
var _timezoneSelector = require("./components/TimezoneSelector");
var _antd = require("antd");
var _profileRemove2Svg = require("src/assets/images/onboarding-trainer/dashboard/profile/components/profile-remove2.svg");
var _useSaveOnboardingStep = require("src/api/mutations/useSaveOnboardingStep");
var _useUpdateTrainerSchedule = require("src/api/mutations/useUpdateTrainerSchedule");
var _useGetTrainerSchedule = require("src/api/queries/useGetTrainerSchedule");
var _sessionStore = require("src/store/sessionStore");
var _authUtils = require("src/utils/authUtils");
var _appAlert = require("src/utils/appAlert");
var _appAlertDefault = parcelHelpers.interopDefault(_appAlert);
var _scheduleScss = require("./Schedule.scss");
const MAX_SLOTS_PER_DAY = 4;
const SCHEDULE_SYNC_DAYS_AHEAD = 60;
const DEFAULT_SLOT_PROGRESSION = {
    1: [
        {
            start: '09:00',
            end: '17:00'
        }
    ],
    2: [
        {
            start: '09:00',
            end: '13:00'
        },
        {
            start: '13:00',
            end: '17:00'
        }
    ],
    3: [
        {
            start: '09:00',
            end: '12:00'
        },
        {
            start: '12:00',
            end: '14:30'
        },
        {
            start: '14:30',
            end: '17:00'
        }
    ],
    4: [
        {
            start: '09:00',
            end: '11:00'
        },
        {
            start: '11:00',
            end: '13:00'
        },
        {
            start: '13:00',
            end: '15:00'
        },
        {
            start: '15:00',
            end: '17:00'
        }
    ]
};
const Schedule = ({ mode = 'onboarding', onNext, onBack })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const token = (0, _sessionStore.sessionStore)((s)=>s.token);
    const userId = (0, _authUtils.getUserIdFromToken)(token);
    // Timezone state: auto-detect on mount
    const [timezone, setTimezone] = (0, _react.useState)(()=>{
        const initialTz = (0, _timezoneUtils.getBrowserTimezone)();
        console.log('[Schedule] Initial detected timezone state:', initialTz);
        return initialTz;
    });
    const [schedule, setSchedule] = (0, _react.useState)((0, _timezoneUtils.DEFAULT_WEEKLY_SCHEDULE));
    const [errorMsg, setErrorMsg] = (0, _react.useState)('');
    const [dayErrors, setDayErrors] = (0, _react.useState)({});
    // Confirmation modal state for disabling active days
    const [confirmModal, setConfirmModal] = (0, _react.useState)({
        isOpen: false,
        dayKey: null
    });
    // Booking conflict modal state when updating schedule
    const [conflictModal, setConflictModal] = (0, _react.useState)({
        isOpen: false,
        conflicts: []
    });
    // Queries and mutations
    const { data: existingScheduleData, isLoading: isScheduleLoading } = (0, _useGetTrainerSchedule.useGetTrainerSchedule)(userId || undefined);
    const { mutate: saveOnboardingStep, isPending: isSavingStep } = (0, _useSaveOnboardingStep.useSaveOnboardingStep)();
    const { mutate: updateSchedule, isPending: isUpdatingSchedule } = (0, _useUpdateTrainerSchedule.useUpdateTrainerSchedule)();
    const isPending = isSavingStep || isUpdatingSchedule;
    // Always reset scroll to top on mount or mode change
    (0, _react.useEffect)(()=>{
        const scrollableMain = document.getElementById('scrollableDashboardMain');
        if (scrollableMain) scrollableMain.scrollTop = 0;
        const scheduleContainer = document.querySelector('.schedule-page-container');
        if (scheduleContainer) scheduleContainer.scrollTop = 0;
        window.scrollTo(0, 0);
        if (document.documentElement) document.documentElement.scrollTop = 0;
        if (document.body) document.body.scrollTop = 0;
    }, [
        mode
    ]);
    // Hydrate from existing data if available
    (0, _react.useEffect)(()=>{
        console.log('[Schedule] existingScheduleData query state:', {
            isLoading: isScheduleLoading,
            hasData: Boolean(existingScheduleData?.data),
            backendTimezone: existingScheduleData?.data?.timezone,
            scheduleKeys: existingScheduleData?.data?.weekly_schedule ? Object.keys(existingScheduleData.data.weekly_schedule) : []
        });
        if (existingScheduleData?.data) {
            if (existingScheduleData.data.timezone) {
                console.log('[Schedule] Applying timezone from backend:', existingScheduleData.data.timezone);
                setTimezone(existingScheduleData.data.timezone);
            } else {
                // If backend has empty timezone, ensure we have browser timezone
                const fallback = (0, _timezoneUtils.getBrowserTimezone)();
                console.log('[Schedule] Backend timezone is empty, using browser fallback:', fallback);
                if (fallback) setTimezone((current)=>current || fallback);
            }
            if (existingScheduleData.data.weekly_schedule && Object.keys(existingScheduleData.data.weekly_schedule).length > 0) setSchedule({
                ...(0, _timezoneUtils.DEFAULT_WEEKLY_SCHEDULE),
                ...existingScheduleData.data.weekly_schedule
            });
        }
    }, [
        existingScheduleData,
        isScheduleLoading
    ]);
    // Handle Day Toggle
    const handleToggleDay = (dayKey)=>{
        // Clear error for this day
        setDayErrors((prev)=>{
            const next = {
                ...prev
            };
            delete next[dayKey];
            return next;
        });
        const currentDay = schedule?.[dayKey] || (0, _timezoneUtils.DEFAULT_WEEKLY_SCHEDULE)[dayKey];
        if (currentDay.enabled) {
            // If turning off and day has slots, confirm first
            if (currentDay.slots && currentDay.slots.length > 0) {
                setConfirmModal({
                    isOpen: true,
                    dayKey
                });
                return;
            }
            // If no slots, simply disable
            setSchedule((prev)=>({
                    ...prev,
                    [dayKey]: {
                        ...prev?.[dayKey] || (0, _timezoneUtils.DEFAULT_WEEKLY_SCHEDULE)[dayKey],
                        enabled: false
                    }
                }));
        } else {
            // Enabling day: if empty, add default 09:00 - 17:00 slot
            const defaultSlots = currentDay.slots && currentDay.slots.length > 0 ? currentDay.slots : [
                {
                    id: `slot-${dayKey}-1`,
                    start: '09:00',
                    end: '17:00'
                }
            ];
            setSchedule((prev)=>({
                    ...prev,
                    [dayKey]: {
                        enabled: true,
                        slots: defaultSlots
                    }
                }));
        }
    };
    // Confirm disabling day
    const handleConfirmDisable = ()=>{
        if (confirmModal.dayKey) {
            const dayKey = confirmModal.dayKey;
            setDayErrors((prev)=>{
                const next = {
                    ...prev
                };
                delete next[dayKey];
                return next;
            });
            setSchedule((prev)=>({
                    ...prev,
                    [dayKey]: {
                        enabled: false,
                        slots: []
                    }
                }));
        }
        setConfirmModal({
            isOpen: false,
            dayKey: null
        });
    };
    // Add slot to day (up to MAX_SLOTS_PER_DAY)
    const handleAddSlot = (dayKey)=>{
        const day = schedule[dayKey];
        if (day.slots.length >= MAX_SLOTS_PER_DAY) {
            setDayErrors((prev)=>({
                    ...prev,
                    [dayKey]: `Maximum ${MAX_SLOTS_PER_DAY} slots allowed per day.`
                }));
            return;
        }
        const sorted = (0, _timezoneUtils.sortSlots)(day.slots);
        const currentCount = sorted.length;
        const nextCount = currentCount + 1;
        const currentPattern = DEFAULT_SLOT_PROGRESSION[currentCount];
        const nextPattern = DEFAULT_SLOT_PROGRESSION[nextCount];
        // Check if existing slots match the default progression preset
        const isMatchingDefaultPattern = Boolean(currentPattern && nextPattern) && sorted.every((slot, idx)=>slot.start === currentPattern[idx]?.start && slot.end === currentPattern[idx]?.end);
        let updatedSlots = [];
        if (isMatchingDefaultPattern && nextPattern) updatedSlots = nextPattern.map((slotDef, idx)=>({
                id: sorted[idx]?.id || `slot-${dayKey}-${Date.now()}-${idx + 1}`,
                start: slotDef.start,
                end: slotDef.end
            }));
        else {
            // Find next available gap or start immediately at end of last slot
            const lastSlot = sorted[sorted.length - 1];
            let newStart = '13:00';
            let newEnd = '17:00';
            if (lastSlot) {
                const lastEndMin = (0, _timezoneUtils.timeToMinutes)(lastSlot.end);
                if (lastEndMin + 60 <= 1440) {
                    newStart = (0, _timezoneUtils.minutesToTime)(lastEndMin);
                    newEnd = (0, _timezoneUtils.minutesToTime)(Math.min(1440, lastEndMin + 240));
                } else {
                    newStart = '08:00';
                    newEnd = '12:00';
                }
            }
            // Verify it doesn't overlap
            const hasOverlap = sorted.some((s)=>(0, _timezoneUtils.doSlotsOverlap)(s.start, s.end, newStart, newEnd));
            if (hasOverlap) {
                // Find a non-overlapping 1-hour window
                let foundStart = null;
                for(let m = 0; m <= 1380; m += 30){
                    const testStart = (0, _timezoneUtils.minutesToTime)(m);
                    const testEnd = (0, _timezoneUtils.minutesToTime)(m + 60);
                    if (!sorted.some((s)=>(0, _timezoneUtils.doSlotsOverlap)(s.start, s.end, testStart, testEnd))) {
                        foundStart = m;
                        break;
                    }
                }
                if (foundStart !== null) {
                    newStart = (0, _timezoneUtils.minutesToTime)(foundStart);
                    newEnd = (0, _timezoneUtils.minutesToTime)(foundStart + 60);
                } else {
                    setDayErrors((prev)=>({
                            ...prev,
                            [dayKey]: 'No available non-overlapping time slot left on this day.'
                        }));
                    return;
                }
            }
            const newSlot = {
                id: `slot-${dayKey}-${Date.now()}`,
                start: newStart,
                end: newEnd
            };
            updatedSlots = (0, _timezoneUtils.sortSlots)([
                ...day.slots,
                newSlot
            ]);
        }
        const err = (0, _timezoneUtils.validateDaySlots)(updatedSlots);
        setDayErrors((prev)=>{
            const next = {
                ...prev
            };
            if (err) next[dayKey] = err;
            else delete next[dayKey];
            return next;
        });
        setSchedule((prev)=>({
                ...prev,
                [dayKey]: {
                    ...prev[dayKey],
                    slots: updatedSlots
                }
            }));
    };
    // Remove slot from day
    const handleRemoveSlot = (dayKey, slotId)=>{
        const day = schedule[dayKey];
        const updatedSlots = day.slots.filter((s)=>s.id !== slotId);
        const err = (0, _timezoneUtils.validateDaySlots)(updatedSlots);
        setDayErrors((prev)=>{
            const next = {
                ...prev
            };
            if (err) next[dayKey] = err;
            else delete next[dayKey];
            return next;
        });
        setSchedule((prev)=>({
                ...prev,
                [dayKey]: {
                    ...prev[dayKey],
                    slots: updatedSlots
                }
            }));
    };
    // Update slot time
    const handleSlotChange = (dayKey, slotId, field, newValue)=>{
        const day = schedule[dayKey];
        const targetSlot = day.slots.find((s)=>s.id === slotId);
        if (!targetSlot) return;
        const updatedStart = field === 'start' ? newValue : targetSlot.start;
        let updatedEnd = field === 'end' ? newValue : targetSlot.end;
        const startMins = (0, _timezoneUtils.timeToMinutes)(updatedStart);
        let endMins = (0, _timezoneUtils.timeToMinutes)(updatedEnd);
        // If start time moved to or past end time, bump end time by at least 1h (60m)
        if (field === 'start') {
            if (endMins <= startMins || endMins - startMins < 60) {
                endMins = Math.min(1440, startMins + 60);
                updatedEnd = (0, _timezoneUtils.minutesToTime)(endMins);
            } else if (endMins - startMins > 480) {
                endMins = Math.min(1440, startMins + 480);
                updatedEnd = (0, _timezoneUtils.minutesToTime)(endMins);
            }
        }
        const updatedSlots = day.slots.map((s)=>s.id === slotId ? {
                ...s,
                start: updatedStart,
                end: updatedEnd
            } : s);
        const err = (0, _timezoneUtils.validateDaySlots)(updatedSlots);
        setDayErrors((prev)=>{
            const next = {
                ...prev
            };
            if (err) next[dayKey] = err;
            else delete next[dayKey];
            return next;
        });
        setSchedule((prev)=>({
                ...prev,
                [dayKey]: {
                    ...prev[dayKey],
                    slots: (0, _timezoneUtils.sortSlots)(updatedSlots)
                }
            }));
    };
    // Direct save execution
    const executeSave = (force = false)=>{
        const payload = {
            timezone,
            weekly_schedule: schedule,
            days: SCHEDULE_SYNC_DAYS_AHEAD
        };
        if (mode === 'onboarding') {
            if (userId) saveOnboardingStep({
                uid: userId,
                step: 4,
                data: payload
            }, {
                onSuccess: ()=>{
                    if (onNext) onNext();
                    else navigate('/onboarding-trainer/dashboard');
                },
                onError: (err)=>{
                    (0, _appAlertDefault.default).error(err.message || 'Failed to save schedule');
                }
            });
            else if (onNext) onNext();
        } else // Profile edit mode
        if (userId) updateSchedule({
            uid: userId,
            timezone,
            weekly_schedule: schedule,
            days: SCHEDULE_SYNC_DAYS_AHEAD,
            force
        }, {
            onSuccess: (res)=>{
                if (res?.hasConflicts && res.conflicts && res.conflicts.length > 0) {
                    setConflictModal({
                        isOpen: true,
                        conflicts: res.conflicts
                    });
                    return;
                }
                (0, _appAlertDefault.default).success('Availability schedule saved successfully.');
                if (onBack) onBack();
                else navigate('/onboarding-trainer/dashboard/profile');
            },
            onError: (err)=>{
                (0, _appAlertDefault.default).error(err.message || 'Failed to update schedule');
            }
        });
    };
    // Confirm and proceed after reviewing conflicts
    const handleConfirmConflicts = ()=>{
        setConflictModal({
            isOpen: false,
            conflicts: []
        });
        executeSave(true);
    };
    // Save / Next handler (validates locally and calls unified API)
    const handleSave = ()=>{
        if (!timezone.trim()) {
            setErrorMsg('Please select a valid timezone to proceed.');
            return;
        }
        const errors = {};
        let hasAnyError = false;
        for (const dayConf of (0, _timezoneUtils.DAYS_CONFIG)){
            const dayData = schedule[dayConf.key];
            if (dayData?.enabled && dayData.slots?.length > 0) {
                const err = (0, _timezoneUtils.validateDaySlots)(dayData.slots);
                if (err) {
                    errors[dayConf.key] = err;
                    hasAnyError = true;
                }
            }
        }
        if (hasAnyError || Object.keys(dayErrors).length > 0) {
            setDayErrors((prev)=>({
                    ...prev,
                    ...errors
                }));
            return;
        }
        setErrorMsg('');
        executeSave(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `schedule-page-container ${mode}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "schedule-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "schedule-title",
                        children: mode === 'profile' ? 'Edit Availability Schedule' : "Let\u2019s set your schedule"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "schedule-subtitle",
                        children: "Choose when clients can book a check-in or message you."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "schedule-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "schedule-card-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "timezone-label-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        className: "globe-icon",
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: "12",
                                                cy: "12",
                                                r: "10"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "2",
                                                y1: "12",
                                                x2: "22",
                                                y2: "12"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "label-text",
                                        children: "Time zone"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timezoneSelector.TimezoneSelector), {
                                value: timezone,
                                onChange: (newTz)=>{
                                    setTimezone(newTz);
                                    if (errorMsg) setErrorMsg('');
                                },
                                error: errorMsg
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "days-schedule-list",
                        children: (0, _timezoneUtils.DAYS_CONFIG).map(({ key, label })=>{
                            const dayData = schedule?.[key] || (0, _timezoneUtils.DEFAULT_WEEKLY_SCHEDULE)[key];
                            const isEnabled = !!dayData?.enabled;
                            const slots = dayData?.slots || [];
                            const canAddSlot = isEnabled && slots.length < MAX_SLOTS_PER_DAY;
                            const currentDayError = dayErrors[key];
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "day-item-wrapper",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: `day-row ${!isEnabled ? 'disabled-day' : ''} ${currentDayError ? 'has-error' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "day-info-col",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "day-name",
                                                        children: label
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        className: `day-toggle-switch ${isEnabled ? 'checked' : ''}`,
                                                        onClick: ()=>handleToggleDay(key),
                                                        role: "switch",
                                                        "aria-checked": isEnabled,
                                                        "aria-label": `Toggle availability for ${label}`,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "toggle-thumb"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "day-slots-col",
                                                children: !isEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "unavailable-text",
                                                    children: "Unavailable"
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "slots-wrapper",
                                                            children: slots.map((slot)=>{
                                                                const startMin = (0, _timezoneUtils.timeToMinutes)(slot.start);
                                                                const minEnd = (0, _timezoneUtils.minutesToTime)(Math.min(1440, startMin + 60));
                                                                const maxEnd = (0, _timezoneUtils.minutesToTime)(Math.min(1440, startMin + 480));
                                                                const isSlotInvalid = (0, _timezoneUtils.isSlotConflicting)(slot, slots);
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: `single-slot-box ${isSlotInvalid ? 'has-error' : ''}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeSlotPicker.TimeSlotPicker), {
                                                                            value: slot.start,
                                                                            type: "start",
                                                                            onChange: (newStart)=>handleSlotChange(key, slot.id, 'start', newStart)
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "slot-separator",
                                                                            children: "\u2014"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeSlotPicker.TimeSlotPicker), {
                                                                            value: slot.end,
                                                                            type: "end",
                                                                            minTime: minEnd,
                                                                            maxTime: maxEnd,
                                                                            onChange: (newEnd)=>handleSlotChange(key, slot.id, 'end', newEnd)
                                                                        }),
                                                                        slots.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                            type: "button",
                                                                            className: "btn-remove-slot",
                                                                            onClick: ()=>handleRemoveSlot(key, slot.id),
                                                                            "aria-label": "Remove slot",
                                                                            title: "Remove slot",
                                                                            children: "\xd7"
                                                                        })
                                                                    ]
                                                                }, slot.id);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            type: "button",
                                                            className: `btn-add-slot ${!canAddSlot ? 'disabled' : ''}`,
                                                            onClick: ()=>canAddSlot && handleAddSlot(key),
                                                            disabled: !canAddSlot,
                                                            "aria-label": `Add time slot for ${label}`,
                                                            title: slots.length >= MAX_SLOTS_PER_DAY ? `Maximum ${MAX_SLOTS_PER_DAY} slots per day` : 'Add new slot',
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                width: "16",
                                                                height: "16",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                        x1: "12",
                                                                        y1: "5",
                                                                        x2: "12",
                                                                        y2: "19"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                        x1: "5",
                                                                        y1: "12",
                                                                        x2: "19",
                                                                        y2: "12"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    currentDayError && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "day-inline-error",
                                        role: "alert",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                className: "error-icon",
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "10"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                        x1: "12",
                                                        y1: "8",
                                                        x2: "12",
                                                        y2: "12"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                        x1: "12",
                                                        y1: "16",
                                                        x2: "12.01",
                                                        y2: "16"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: currentDayError
                                            })
                                        ]
                                    })
                                ]
                            }, key);
                        })
                    })
                ]
            }),
            mode === 'onboarding' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "schedule-footer",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "progress-bar",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-fill",
                            style: {
                                width: '100%'
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "footer-actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: "btn-back",
                                onClick: onBack,
                                disabled: isPending,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "19",
                                                y1: "12",
                                                x2: "5",
                                                y2: "12"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                points: "12 19 5 12 12 5"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Back"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: "btn-next",
                                onClick: handleSave,
                                disabled: isPending || isScheduleLoading,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: isPending ? 'Saving...' : 'Next'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "5",
                                                y1: "12",
                                                x2: "19",
                                                y2: "12"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                points: "12 5 19 12 12 19"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "schedule-profile-footer",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        className: "btn-profile-back",
                        onClick: onBack ? onBack : ()=>navigate('/onboarding-trainer/dashboard/profile'),
                        disabled: isPending,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "19",
                                        y1: "12",
                                        x2: "5",
                                        y2: "12"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "12 19 5 12 12 5"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: "Back to Profile"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "btn-profile-save",
                        onClick: handleSave,
                        disabled: isPending || isScheduleLoading,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: isPending ? 'Saving...' : 'Save Changes'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: confirmModal.isOpen,
                footer: null,
                onCancel: ()=>setConfirmModal({
                        isOpen: false,
                        dayKey: null
                    }),
                centered: true,
                width: 400,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileRemove2Svg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                            children: [
                                "Disable",
                                ' ',
                                confirmModal.dayKey ? (0, _timezoneUtils.DAYS_CONFIG).find((d)=>d.key === confirmModal.dayKey)?.label : '',
                                ' ',
                                "availability?"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "This will clear all configured time slots for this day. Are you sure you want to proceed?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-logout",
                                    onClick: handleConfirmDisable,
                                    children: "Disable & Clear"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setConfirmModal({
                                            isOpen: false,
                                            dayKey: null
                                        }),
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: conflictModal.isOpen,
                footer: null,
                onCancel: ()=>setConflictModal({
                        isOpen: false,
                        conflicts: []
                    }),
                centered: true,
                width: 440,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileRemove2Svg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Existing Bookings Affected"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                textAlign: 'left',
                                marginTop: '12px',
                                width: '100%'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    style: {
                                        marginBottom: '10px',
                                        color: '#94a3b8',
                                        fontSize: '13px',
                                        textAlign: 'center'
                                    },
                                    children: [
                                        "The following ",
                                        conflictModal.conflicts.length,
                                        " client booking(s) in the next 60 days fall outside your new schedule hours and will be removed:"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        maxHeight: '160px',
                                        overflowY: 'auto',
                                        background: 'rgba(255, 255, 255, 0.05)',
                                        borderRadius: '8px',
                                        padding: '10px 14px',
                                        border: '1px solid rgba(255, 255, 255, 0.1)',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '8px'
                                    },
                                    children: conflictModal.conflicts.map((c, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: {
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                fontSize: '13px',
                                                color: '#ffffff'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    style: {
                                                        fontWeight: 500
                                                    },
                                                    children: [
                                                        "\uD83D\uDCC5 ",
                                                        c.day,
                                                        ", ",
                                                        c.date,
                                                        " at ",
                                                        c.time
                                                    ]
                                                }),
                                                c.clientName && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    style: {
                                                        color: '#f59e0b',
                                                        fontSize: '12px'
                                                    },
                                                    children: [
                                                        "(",
                                                        c.clientName,
                                                        ")"
                                                    ]
                                                })
                                            ]
                                        }, `${c.date}-${c.time}-${idx}`))
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    style: {
                                        marginTop: '12px',
                                        fontSize: '12px',
                                        color: '#F16A6A',
                                        textAlign: 'center'
                                    },
                                    children: "Are you sure you want to proceed and update your schedule?"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-logout",
                                    onClick: handleConfirmConflicts,
                                    children: "Confirm & Update"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setConflictModal({
                                            isOpen: false,
                                            conflicts: []
                                        }),
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./utils/timezoneUtils":"3cRmo","./components/TimeSlotPicker":"8ZJ4j","./components/TimezoneSelector":"13NLc","antd":[["Modal","kY4DD","default"]],"src/assets/images/onboarding-trainer/dashboard/profile/components/profile-remove2.svg":"lzWT7","src/api/mutations/useSaveOnboardingStep":"iDROn","src/api/mutations/useUpdateTrainerSchedule":"5jf2V","src/api/queries/useGetTrainerSchedule":"2n68F","src/store/sessionStore":"kPSO3","src/utils/authUtils":"41GVV","src/utils/appAlert":"de4Mq","./Schedule.scss":"hHqzR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3cRmo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DAYS_CONFIG", ()=>DAYS_CONFIG);
parcelHelpers.export(exports, "DEFAULT_WEEKLY_SCHEDULE", ()=>DEFAULT_WEEKLY_SCHEDULE);
parcelHelpers.export(exports, "TIME_SLOTS_30_MIN", ()=>TIME_SLOTS_30_MIN);
parcelHelpers.export(exports, "END_TIME_SLOTS_30_MIN", ()=>END_TIME_SLOTS_30_MIN);
parcelHelpers.export(exports, "timeToMinutes", ()=>timeToMinutes);
parcelHelpers.export(exports, "minutesToTime", ()=>minutesToTime);
/**
 * Format timezone using date-fns-tz with fallback for Safari/edge cases
 */ parcelHelpers.export(exports, "formatTimezoneOption", ()=>formatTimezoneOption);
parcelHelpers.export(exports, "normalizeTimezone", ()=>normalizeTimezone);
parcelHelpers.export(exports, "findTimezoneOption", ()=>findTimezoneOption);
parcelHelpers.export(exports, "getBrowserTimezone", ()=>getBrowserTimezone);
parcelHelpers.export(exports, "getAllSupportedTimezones", ()=>getAllSupportedTimezones);
parcelHelpers.export(exports, "searchTimezones", ()=>searchTimezones);
parcelHelpers.export(exports, "doSlotsOverlap", ()=>doSlotsOverlap);
parcelHelpers.export(exports, "validateDaySlots", ()=>validateDaySlots);
parcelHelpers.export(exports, "isSlotConflicting", ()=>isSlotConflicting);
parcelHelpers.export(exports, "sortSlots", ()=>sortSlots);
var _dateFnsTz = require("date-fns-tz");
var _dateFns = require("date-fns");
const DAYS_CONFIG = [
    {
        key: 'monday',
        label: 'Monday'
    },
    {
        key: 'tuesday',
        label: 'Tuesday'
    },
    {
        key: 'wednesday',
        label: 'Wednesday'
    },
    {
        key: 'thursday',
        label: 'Thursday'
    },
    {
        key: 'friday',
        label: 'Friday'
    },
    {
        key: 'saturday',
        label: 'Saturday'
    },
    {
        key: 'sunday',
        label: 'Sunday'
    }
];
const DEFAULT_WEEKLY_SCHEDULE = {
    monday: {
        enabled: true,
        slots: [
            {
                id: 'slot-mon-1',
                start: '09:00',
                end: '17:00'
            }
        ]
    },
    tuesday: {
        enabled: true,
        slots: [
            {
                id: 'slot-tue-1',
                start: '09:00',
                end: '17:00'
            }
        ]
    },
    wednesday: {
        enabled: true,
        slots: [
            {
                id: 'slot-wed-1',
                start: '09:00',
                end: '17:00'
            }
        ]
    },
    thursday: {
        enabled: true,
        slots: [
            {
                id: 'slot-thu-1',
                start: '09:00',
                end: '17:00'
            }
        ]
    },
    friday: {
        enabled: true,
        slots: [
            {
                id: 'slot-fri-1',
                start: '09:00',
                end: '17:00'
            }
        ]
    },
    saturday: {
        enabled: false,
        slots: []
    },
    sunday: {
        enabled: false,
        slots: []
    }
};
const TIME_SLOTS_30_MIN = (()=>{
    const slots = [];
    for(let h = 0; h < 24; h++){
        const hh = h.toString().padStart(2, '0');
        slots.push(`${hh}:00`);
        slots.push(`${hh}:30`);
    }
    return slots;
})();
const END_TIME_SLOTS_30_MIN = [
    ...TIME_SLOTS_30_MIN.slice(1),
    '24:00'
];
function timeToMinutes(timeStr) {
    if (!timeStr) return 0;
    if (timeStr === '24:00') return 1440;
    try {
        const baseDate = (0, _dateFns.parse)(timeStr, 'HH:mm', new Date(2000, 0, 1));
        return baseDate.getHours() * 60 + baseDate.getMinutes();
    } catch  {
        const [hStr, mStr] = timeStr.split(':');
        return (parseInt(hStr, 10) || 0) * 60 + (parseInt(mStr, 10) || 0);
    }
}
function minutesToTime(minutes) {
    if (minutes >= 1440) return '24:00';
    const baseDate = (0, _dateFns.addMinutes)(new Date(2000, 0, 1, 0, 0, 0), minutes);
    return (0, _dateFns.format)(baseDate, 'HH:mm');
}
function formatTimezoneOption(tz) {
    try {
        const now = new Date();
        let offset = (0, _dateFnsTz.formatInTimeZone)(now, tz, 'O');
        // ➡️ fallback if offset is not useful (Safari / edge cases)
        if (!offset || offset === 'GMT') {
            const raw = (0, _dateFnsTz.formatInTimeZone)(now, tz, 'xxx'); // +05:30
            offset = `GMT${raw}`;
        }
        const city = tz.split('/').pop()?.replace(/_/g, ' ') || tz;
        const formattedLabel = `${tz.replace(/_/g, ' ')} (${offset})`;
        return {
            id: tz,
            label: formattedLabel,
            city,
            offset
        };
    } catch  {
        const city = tz.split('/').pop()?.replace(/_/g, ' ') || tz;
        return {
            id: tz,
            label: tz.replace(/_/g, ' '),
            city,
            offset: ''
        };
    }
}
const TIMEZONE_ALIASES = {
    'Asia/Calcutta': 'Asia/Kolkata',
    'Asia/Saigon': 'Asia/Ho_Chi_Minh',
    'Asia/Katmandu': 'Asia/Kathmandu',
    'Asia/Rangoon': 'Asia/Yangon',
    'Europe/Kiev': 'Europe/Kyiv',
    'US/Eastern': 'America/New_York',
    'US/Central': 'America/Chicago',
    'US/Mountain': 'America/Denver',
    'US/Pacific': 'America/Los_Angeles',
    'US/Hawaii': 'Pacific/Honolulu',
    'US/Alaska': 'America/Anchorage'
};
function normalizeTimezone(tz) {
    if (!tz) return '';
    if (TIMEZONE_ALIASES[tz]) return TIMEZONE_ALIASES[tz];
    return tz;
}
function findTimezoneOption(tzId, optionsList) {
    if (!tzId) return undefined;
    let match = optionsList.find((tz)=>tz.id === tzId);
    if (match) return match;
    const normalized = normalizeTimezone(tzId);
    match = optionsList.find((tz)=>tz.id === normalized);
    if (match) return match;
    const lower = tzId.toLowerCase();
    match = optionsList.find((tz)=>tz.id.toLowerCase() === lower);
    if (match) return match;
    const aliasKey = Object.keys(TIMEZONE_ALIASES).find((k)=>TIMEZONE_ALIASES[k] === tzId);
    if (aliasKey) {
        match = optionsList.find((tz)=>tz.id === aliasKey);
        if (match) return match;
    }
    return formatTimezoneOption(tzId);
}
function getBrowserTimezone() {
    try {
        const resolved = Intl?.DateTimeFormat?.()?.resolvedOptions?.();
        const tz = resolved?.timeZone || '';
        return normalizeTimezone(tz);
    } catch  {
        return '';
    }
}
function getAllSupportedTimezones() {
    let timezones = [];
    try {
        if (typeof Intl !== 'undefined' && 'supportedValuesOf' in Intl) timezones = Intl.supportedValuesOf('timeZone');
    } catch  {
        timezones = [];
    }
    if (!timezones || timezones.length === 0) timezones = [
        'UTC',
        'Asia/Kolkata',
        'Asia/Dubai',
        'Asia/Singapore',
        'Asia/Tokyo',
        'Europe/London',
        'Europe/Berlin',
        'Europe/Paris',
        'Europe/Moscow',
        'America/New_York',
        'America/Chicago',
        'America/Denver',
        'America/Los_Angeles',
        'America/Sao_Paulo',
        'Australia/Sydney',
        'Pacific/Auckland'
    ];
    return timezones.map((tz)=>formatTimezoneOption(tz));
}
function searchTimezones(query, allOptions) {
    const q = query.trim().toLowerCase();
    if (!q) return allOptions;
    return allOptions.filter((opt)=>{
        return opt.id.toLowerCase().includes(q) || opt.city.toLowerCase().includes(q) || opt.offset.toLowerCase().includes(q) || opt.label.toLowerCase().includes(q);
    });
}
function doSlotsOverlap(startA, endA, startB, endB) {
    const aStartMin = timeToMinutes(startA);
    const aEndMin = timeToMinutes(endA);
    const bStartMin = timeToMinutes(startB);
    const bEndMin = timeToMinutes(endB);
    return aStartMin < bEndMin && bStartMin < aEndMin;
}
function validateDaySlots(slots) {
    if (!slots || slots.length === 0) return null;
    for(let i = 0; i < slots.length; i++){
        const slot = slots[i];
        const sMin = timeToMinutes(slot.start);
        const eMin = timeToMinutes(slot.end);
        if (eMin <= sMin) return 'End time must be after start time.';
        const duration = eMin - sMin;
        if (duration < 60) return 'Slot duration must be at least 1 hour.';
        if (duration > 480) return 'Slot duration cannot exceed 8 hours.';
    }
    for(let i = 0; i < slots.length; i++)for(let j = i + 1; j < slots.length; j++){
        if (doSlotsOverlap(slots[i].start, slots[i].end, slots[j].start, slots[j].end)) return 'Time slot cannot overlap with another slot on the same day.';
    }
    return null;
}
function isSlotConflicting(slot, allSlots) {
    const sMin = timeToMinutes(slot.start);
    const eMin = timeToMinutes(slot.end);
    if (eMin <= sMin || eMin - sMin < 60 || eMin - sMin > 480) return true;
    return allSlots.some((other)=>other.id !== slot.id && doSlotsOverlap(slot.start, slot.end, other.start, other.end));
}
function sortSlots(slots) {
    return [
        ...slots
    ].sort((a, b)=>timeToMinutes(a.start) - timeToMinutes(b.start));
}

},{"date-fns-tz":"loyBd","date-fns":[["addMinutes","2P7h2"],["format","3AWAR"],["parse","6d3x3"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"loyBd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "format", ()=>(0, _indexJs.format));
parcelHelpers.export(exports, "formatInTimeZone", ()=>(0, _indexJs1.formatInTimeZone));
parcelHelpers.export(exports, "fromZonedTime", ()=>(0, _indexJs2.fromZonedTime));
parcelHelpers.export(exports, "toZonedTime", ()=>(0, _indexJs3.toZonedTime));
parcelHelpers.export(exports, "getTimezoneOffset", ()=>(0, _indexJs4.getTimezoneOffset));
parcelHelpers.export(exports, "toDate", ()=>(0, _indexJs5.toDate));
var _indexJs = require("./format/index.js");
var _indexJs1 = require("./formatInTimeZone/index.js");
var _indexJs2 = require("./fromZonedTime/index.js");
var _indexJs3 = require("./toZonedTime/index.js");
var _indexJs4 = require("./getTimezoneOffset/index.js");
var _indexJs5 = require("./toDate/index.js");

},{"./format/index.js":"7fSGh","./formatInTimeZone/index.js":"cIzOr","./fromZonedTime/index.js":"7uc4c","./toZonedTime/index.js":"f2gxJ","./getTimezoneOffset/index.js":"3AC4d","./toDate/index.js":"fsrFV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7fSGh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may consty by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 8     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 8     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Su            | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Su            |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aaa  | AM, PM                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 1, 2, ..., 11, 0                  |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | PDT, EST, CEST                    | 6     |
 * |                                 | zzzz    | Pacific Daylight Time             | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 05/29/1453                        | 7     |
 * |                                 | PP      | May 29, 1453                      | 7     |
 * |                                 | PPP     | May 29th, 1453                    | 7     |
 * |                                 | PPPP    | Sunday, May 29th, 1453            | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 05/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | May 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | May 29th, 1453 at ...             | 7     |
 * |                                 | PPPPpppp| Sunday, May 29th, 1453 at ...     | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are created using the Intl browser API. The output is determined by the
 *    preferred standard of the current locale (en-US by default) which may not always give the expected result.
 *    For this reason it is recommended to supply a `locale` in the format options when formatting a time zone name.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. These tokens are often confused with others. See: https://git.io/fxCyr
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole
 *   library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard
 *   #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table). See [this
 *   post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param date the original date
 * @param formatStr the string of tokens
 * @param options the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 * @param {Date|Number} [options.originalDate] - can be used to pass the original unmodified date to `format` to
 *   improve correctness of the replaced timezone token close to the DST threshold.
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.awareOfUnicodeTokens` must be set to `true` to use `XX` token; see:
 *   https://git.io/fxCyr
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ parcelHelpers.export(exports, "format", ()=>format);
var _format = require("date-fns/format");
var _indexJs = require("./formatters/index.js");
var _indexJs1 = require("../toDate/index.js");
const tzFormattingTokensRegExp = /([xXOz]+)|''|'(''|[^'])+('|$)/g;
function format(date, formatStr, options = {}) {
    formatStr = String(formatStr);
    const matches = formatStr.match(tzFormattingTokensRegExp);
    if (matches) {
        const d = (0, _indexJs1.toDate)(options.originalDate || date, options);
        // Work through each match and replace the tz token in the format string with the quoted
        // formatted time zone so the remaining tokens can be filled in by date-fns#format.
        formatStr = matches.reduce(function(result, token) {
            if (token[0] === "'") return result; // This is a quoted portion, matched only to ensure we don't match inside it
            const pos = result.indexOf(token);
            const precededByQuotedSection = result[pos - 1] === "'";
            const replaced = result.replace(token, "'" + (0, _indexJs.formatters)[token[0]](d, token, options) + "'");
            // If the replacement results in two adjoining quoted strings, the back to back quotes
            // are removed, so it doesn't look like an escaped quote.
            return precededByQuotedSection ? replaced.substring(0, pos - 1) + replaced.substring(pos + 1) : replaced;
        }, formatStr);
    }
    return (0, _format.format)(date, formatStr, options);
}

},{"date-fns/format":"3AWAR","./formatters/index.js":"1pnxx","../toDate/index.js":"fsrFV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3AWAR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
parcelHelpers.export(exports, "formatters", ()=>(0, _formattersJs.formatters));
parcelHelpers.export(exports, "longFormatters", ()=>(0, _longFormattersJs.longFormatters));
parcelHelpers.export(exports, "formatDate", ()=>format);
/**
 * The {@link format} function options.
 */ /**
 * @name format
 * @alias formatDate
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear](https://date-fns.org/docs/getISOWeekYear)
 *    and [getWeekYear](https://date-fns.org/docs/getWeekYear)).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param date - The original date
 * @param format - The string of tokens
 * @param options - An object with options
 *
 * @returns The formatted date string
 *
 * @throws `date` must not be Invalid Date
 * @throws `options.locale` must contain `localize` property
 * @throws `options.locale` must contain `formatLong` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */ parcelHelpers.export(exports, "format", ()=>format);
var _defaultLocaleJs = require("./_lib/defaultLocale.js");
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _formattersJs = require("./_lib/format/formatters.js");
var _longFormattersJs = require("./_lib/format/longFormatters.js");
var _protectedTokensJs = require("./_lib/protectedTokens.js");
var _isValidJs = require("./isValid.js");
var _toDateJs = require("./toDate.js");
// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function format(date, formatStr, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, _defaultLocaleJs.defaultLocale);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const originalDate = (0, _toDateJs.toDate)(date, options?.in);
    if (!(0, _isValidJs.isValid)(originalDate)) throw new RangeError("Invalid time value");
    let parts = formatStr.match(longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter === "p" || firstCharacter === "P") {
            const longFormatter = (0, _longFormattersJs.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp).map((substring)=>{
        // Replace two single quote characters with one single quote character
        if (substring === "''") return {
            isToken: false,
            value: "'"
        };
        const firstCharacter = substring[0];
        if (firstCharacter === "'") return {
            isToken: false,
            value: cleanEscapedString(substring)
        };
        if ((0, _formattersJs.formatters)[firstCharacter]) return {
            isToken: true,
            value: substring
        };
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
        return {
            isToken: false,
            value: substring
        };
    });
    // invoke localize preprocessor (only for french locales at the moment)
    if (locale.localize.preprocessor) parts = locale.localize.preprocessor(originalDate, parts);
    const formatterOptions = {
        firstWeekContainsDate,
        weekStartsOn,
        locale
    };
    return parts.map((part)=>{
        if (!part.isToken) return part.value;
        const token = part.value;
        if (!options?.useAdditionalWeekYearTokens && (0, _protectedTokensJs.isProtectedWeekYearToken)(token) || !options?.useAdditionalDayOfYearTokens && (0, _protectedTokensJs.isProtectedDayOfYearToken)(token)) (0, _protectedTokensJs.warnOrThrowProtectedError)(token, formatStr, String(date));
        const formatter = (0, _formattersJs.formatters)[token[0]];
        return formatter(originalDate, token, locale.localize, formatterOptions);
    }).join("");
}
function cleanEscapedString(input) {
    const matched = input.match(escapedStringRegExp);
    if (!matched) return input;
    return matched[1].replace(doubleQuoteRegExp, "'");
}
// Fallback for modularized imports:
exports.default = format;

},{"./_lib/defaultLocale.js":[["defaultLocale","hbuPO","enUS"]],"./_lib/defaultOptions.js":"gg1YU","./_lib/format/formatters.js":"fpJwT","./_lib/format/longFormatters.js":"lMm4k","./_lib/protectedTokens.js":"9HGYz","./isValid.js":"7VkAB","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hbuPO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "enUS", ()=>enUS);
var _formatDistanceJs = require("./en-US/_lib/formatDistance.js");
var _formatLongJs = require("./en-US/_lib/formatLong.js");
var _formatRelativeJs = require("./en-US/_lib/formatRelative.js");
var _localizeJs = require("./en-US/_lib/localize.js");
var _matchJs = require("./en-US/_lib/match.js");
const enUS = {
    code: "en-US",
    formatDistance: (0, _formatDistanceJs.formatDistance),
    formatLong: (0, _formatLongJs.formatLong),
    formatRelative: (0, _formatRelativeJs.formatRelative),
    localize: (0, _localizeJs.localize),
    match: (0, _matchJs.match),
    options: {
        weekStartsOn: 0 /* Sunday */ ,
        firstWeekContainsDate: 1
    }
};
// Fallback for modularized imports:
exports.default = enUS;

},{"./en-US/_lib/formatDistance.js":"5RYM8","./en-US/_lib/formatLong.js":"51g13","./en-US/_lib/formatRelative.js":"auJhG","./en-US/_lib/localize.js":"cQlQD","./en-US/_lib/match.js":"1ET98","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5RYM8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatDistance", ()=>formatDistance);
const formatDistanceLocale = {
    lessThanXSeconds: {
        one: "less than a second",
        other: "less than {{count}} seconds"
    },
    xSeconds: {
        one: "1 second",
        other: "{{count}} seconds"
    },
    halfAMinute: "half a minute",
    lessThanXMinutes: {
        one: "less than a minute",
        other: "less than {{count}} minutes"
    },
    xMinutes: {
        one: "1 minute",
        other: "{{count}} minutes"
    },
    aboutXHours: {
        one: "about 1 hour",
        other: "about {{count}} hours"
    },
    xHours: {
        one: "1 hour",
        other: "{{count}} hours"
    },
    xDays: {
        one: "1 day",
        other: "{{count}} days"
    },
    aboutXWeeks: {
        one: "about 1 week",
        other: "about {{count}} weeks"
    },
    xWeeks: {
        one: "1 week",
        other: "{{count}} weeks"
    },
    aboutXMonths: {
        one: "about 1 month",
        other: "about {{count}} months"
    },
    xMonths: {
        one: "1 month",
        other: "{{count}} months"
    },
    aboutXYears: {
        one: "about 1 year",
        other: "about {{count}} years"
    },
    xYears: {
        one: "1 year",
        other: "{{count}} years"
    },
    overXYears: {
        one: "over 1 year",
        other: "over {{count}} years"
    },
    almostXYears: {
        one: "almost 1 year",
        other: "almost {{count}} years"
    }
};
const formatDistance = (token, count, options)=>{
    let result;
    const tokenValue = formatDistanceLocale[token];
    if (typeof tokenValue === "string") result = tokenValue;
    else if (count === 1) result = tokenValue.one;
    else result = tokenValue.other.replace("{{count}}", count.toString());
    if (options?.addSuffix) {
        if (options.comparison && options.comparison > 0) return "in " + result;
        else return result + " ago";
    }
    return result;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"51g13":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatLong", ()=>formatLong);
var _buildFormatLongFnJs = require("../../_lib/buildFormatLongFn.js");
const dateFormats = {
    full: "EEEE, MMMM do, y",
    long: "MMMM do, y",
    medium: "MMM d, y",
    short: "MM/dd/yyyy"
};
const timeFormats = {
    full: "h:mm:ss a zzzz",
    long: "h:mm:ss a z",
    medium: "h:mm:ss a",
    short: "h:mm a"
};
const dateTimeFormats = {
    full: "{{date}} 'at' {{time}}",
    long: "{{date}} 'at' {{time}}",
    medium: "{{date}}, {{time}}",
    short: "{{date}}, {{time}}"
};
const formatLong = {
    date: (0, _buildFormatLongFnJs.buildFormatLongFn)({
        formats: dateFormats,
        defaultWidth: "full"
    }),
    time: (0, _buildFormatLongFnJs.buildFormatLongFn)({
        formats: timeFormats,
        defaultWidth: "full"
    }),
    dateTime: (0, _buildFormatLongFnJs.buildFormatLongFn)({
        formats: dateTimeFormats,
        defaultWidth: "full"
    })
};

},{"../../_lib/buildFormatLongFn.js":"ce8PJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ce8PJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildFormatLongFn", ()=>buildFormatLongFn);
function buildFormatLongFn(args) {
    return (options = {})=>{
        // TODO: Remove String()
        const width = options.width ? String(options.width) : args.defaultWidth;
        const format = args.formats[width] || args.formats[args.defaultWidth];
        return format;
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"auJhG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatRelative", ()=>formatRelative);
const formatRelativeLocale = {
    lastWeek: "'last' eeee 'at' p",
    yesterday: "'yesterday at' p",
    today: "'today at' p",
    tomorrow: "'tomorrow at' p",
    nextWeek: "eeee 'at' p",
    other: "P"
};
const formatRelative = (token, _date, _baseDate, _options)=>formatRelativeLocale[token];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cQlQD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "localize", ()=>localize);
var _buildLocalizeFnJs = require("../../_lib/buildLocalizeFn.js");
const eraValues = {
    narrow: [
        "B",
        "A"
    ],
    abbreviated: [
        "BC",
        "AD"
    ],
    wide: [
        "Before Christ",
        "Anno Domini"
    ]
};
const quarterValues = {
    narrow: [
        "1",
        "2",
        "3",
        "4"
    ],
    abbreviated: [
        "Q1",
        "Q2",
        "Q3",
        "Q4"
    ],
    wide: [
        "1st quarter",
        "2nd quarter",
        "3rd quarter",
        "4th quarter"
    ]
};
// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
const monthValues = {
    narrow: [
        "J",
        "F",
        "M",
        "A",
        "M",
        "J",
        "J",
        "A",
        "S",
        "O",
        "N",
        "D"
    ],
    abbreviated: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ],
    wide: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ]
};
const dayValues = {
    narrow: [
        "S",
        "M",
        "T",
        "W",
        "T",
        "F",
        "S"
    ],
    short: [
        "Su",
        "Mo",
        "Tu",
        "We",
        "Th",
        "Fr",
        "Sa"
    ],
    abbreviated: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    wide: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ]
};
const dayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "morning",
        afternoon: "afternoon",
        evening: "evening",
        night: "night"
    }
};
const formattingDayPeriodValues = {
    narrow: {
        am: "a",
        pm: "p",
        midnight: "mi",
        noon: "n",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    abbreviated: {
        am: "AM",
        pm: "PM",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    },
    wide: {
        am: "a.m.",
        pm: "p.m.",
        midnight: "midnight",
        noon: "noon",
        morning: "in the morning",
        afternoon: "in the afternoon",
        evening: "in the evening",
        night: "at night"
    }
};
const ordinalNumber = (dirtyNumber, _options)=>{
    const number = Number(dirtyNumber);
    // If ordinal numbers depend on context, for example,
    // if they are different for different grammatical genders,
    // use `options.unit`.
    //
    // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
    // 'day', 'hour', 'minute', 'second'.
    const rem100 = number % 100;
    if (rem100 > 20 || rem100 < 10) switch(rem100 % 10){
        case 1:
            return number + "st";
        case 2:
            return number + "nd";
        case 3:
            return number + "rd";
    }
    return number + "th";
};
const localize = {
    ordinalNumber,
    era: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: eraValues,
        defaultWidth: "wide"
    }),
    quarter: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: quarterValues,
        defaultWidth: "wide",
        argumentCallback: (quarter)=>quarter - 1
    }),
    month: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: monthValues,
        defaultWidth: "wide"
    }),
    day: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: dayValues,
        defaultWidth: "wide"
    }),
    dayPeriod: (0, _buildLocalizeFnJs.buildLocalizeFn)({
        values: dayPeriodValues,
        defaultWidth: "wide",
        formattingValues: formattingDayPeriodValues,
        defaultFormattingWidth: "wide"
    })
};

},{"../../_lib/buildLocalizeFn.js":"gGaIW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gGaIW":[function(require,module,exports,__globalThis) {
/**
 * The localize function argument callback which allows to convert raw value to
 * the actual type.
 *
 * @param value - The value to convert
 *
 * @returns The converted value
 */ /**
 * The map of localized values for each width.
 */ /**
 * The index type of the locale unit value. It types conversion of units of
 * values that don't start at 0 (i.e. quarters).
 */ /**
 * Converts the unit value to the tuple of values.
 */ /**
 * The tuple of localized era values. The first element represents BC,
 * the second element represents AD.
 */ /**
 * The tuple of localized quarter values. The first element represents Q1.
 */ /**
 * The tuple of localized day values. The first element represents Sunday.
 */ /**
 * The tuple of localized month values. The first element represents January.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildLocalizeFn", ()=>buildLocalizeFn);
function buildLocalizeFn(args) {
    return (value, options)=>{
        const context = options?.context ? String(options.context) : "standalone";
        let valuesArray;
        if (context === "formatting" && args.formattingValues) {
            const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
            const width = options?.width ? String(options.width) : defaultWidth;
            valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
        } else {
            const defaultWidth = args.defaultWidth;
            const width = options?.width ? String(options.width) : args.defaultWidth;
            valuesArray = args.values[width] || args.values[defaultWidth];
        }
        const index = args.argumentCallback ? args.argumentCallback(value) : value;
        // @ts-expect-error - For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
        return valuesArray[index];
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1ET98":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "match", ()=>match);
var _buildMatchFnJs = require("../../_lib/buildMatchFn.js");
var _buildMatchPatternFnJs = require("../../_lib/buildMatchPatternFn.js");
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
    narrow: /^(b|a)/i,
    abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
    wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
    any: [
        /^b/i,
        /^(a|c)/i
    ]
};
const matchQuarterPatterns = {
    narrow: /^[1234]/i,
    abbreviated: /^q[1234]/i,
    wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
    any: [
        /1/i,
        /2/i,
        /3/i,
        /4/i
    ]
};
const matchMonthPatterns = {
    narrow: /^[jfmasond]/i,
    abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
    wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
    narrow: [
        /^j/i,
        /^f/i,
        /^m/i,
        /^a/i,
        /^m/i,
        /^j/i,
        /^j/i,
        /^a/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ],
    any: [
        /^ja/i,
        /^f/i,
        /^mar/i,
        /^ap/i,
        /^may/i,
        /^jun/i,
        /^jul/i,
        /^au/i,
        /^s/i,
        /^o/i,
        /^n/i,
        /^d/i
    ]
};
const matchDayPatterns = {
    narrow: /^[smtwf]/i,
    short: /^(su|mo|tu|we|th|fr|sa)/i,
    abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
    wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
    narrow: [
        /^s/i,
        /^m/i,
        /^t/i,
        /^w/i,
        /^t/i,
        /^f/i,
        /^s/i
    ],
    any: [
        /^su/i,
        /^m/i,
        /^tu/i,
        /^w/i,
        /^th/i,
        /^f/i,
        /^sa/i
    ]
};
const matchDayPeriodPatterns = {
    narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
    any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
    any: {
        am: /^a/i,
        pm: /^p/i,
        midnight: /^mi/i,
        noon: /^no/i,
        morning: /morning/i,
        afternoon: /afternoon/i,
        evening: /evening/i,
        night: /night/i
    }
};
const match = {
    ordinalNumber: (0, _buildMatchPatternFnJs.buildMatchPatternFn)({
        matchPattern: matchOrdinalNumberPattern,
        parsePattern: parseOrdinalNumberPattern,
        valueCallback: (value)=>parseInt(value, 10)
    }),
    era: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchEraPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseEraPatterns,
        defaultParseWidth: "any"
    }),
    quarter: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchQuarterPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseQuarterPatterns,
        defaultParseWidth: "any",
        valueCallback: (index)=>index + 1
    }),
    month: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchMonthPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseMonthPatterns,
        defaultParseWidth: "any"
    }),
    day: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchDayPatterns,
        defaultMatchWidth: "wide",
        parsePatterns: parseDayPatterns,
        defaultParseWidth: "any"
    }),
    dayPeriod: (0, _buildMatchFnJs.buildMatchFn)({
        matchPatterns: matchDayPeriodPatterns,
        defaultMatchWidth: "any",
        parsePatterns: parseDayPeriodPatterns,
        defaultParseWidth: "any"
    })
};

},{"../../_lib/buildMatchFn.js":"hK5XO","../../_lib/buildMatchPatternFn.js":"3RJOq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hK5XO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchFn", ()=>buildMatchFn);
function buildMatchFn(args) {
    return (string, options = {})=>{
        const width = options.width;
        const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
        const matchResult = string.match(matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
        const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern)=>pattern.test(matchedString)) : findKey(parsePatterns, (pattern)=>pattern.test(matchedString));
        let value;
        value = args.valueCallback ? args.valueCallback(key) : key;
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}
function findKey(object, predicate) {
    for(const key in object){
        if (Object.prototype.hasOwnProperty.call(object, key) && predicate(object[key])) return key;
    }
    return undefined;
}
function findIndex(array, predicate) {
    for(let key = 0; key < array.length; key++){
        if (predicate(array[key])) return key;
    }
    return undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3RJOq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildMatchPatternFn", ()=>buildMatchPatternFn);
function buildMatchPatternFn(args) {
    return (string, options = {})=>{
        const matchResult = string.match(args.matchPattern);
        if (!matchResult) return null;
        const matchedString = matchResult[0];
        const parseResult = string.match(args.parsePattern);
        if (!parseResult) return null;
        let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
        // [TODO] I challenge you to fix the type
        value = options.valueCallback ? options.valueCallback(value) : value;
        const rest = string.slice(matchedString.length);
        return {
            value,
            rest
        };
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gg1YU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
parcelHelpers.export(exports, "setDefaultOptions", ()=>setDefaultOptions);
let defaultOptions = {};
function getDefaultOptions() {
    return defaultOptions;
}
function setDefaultOptions(newOptions) {
    defaultOptions = newOptions;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fpJwT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatters", ()=>formatters);
var _getDayOfYearJs = require("../../getDayOfYear.js");
var _getISOWeekJs = require("../../getISOWeek.js");
var _getISOWeekYearJs = require("../../getISOWeekYear.js");
var _getWeekJs = require("../../getWeek.js");
var _getWeekYearJs = require("../../getWeekYear.js");
var _addLeadingZerosJs = require("../addLeadingZeros.js");
var _lightFormattersJs = require("./lightFormatters.js");
const dayPeriodEnum = {
    am: "am",
    pm: "pm",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
};
const formatters = {
    // Era
    G: function(date, token, localize) {
        const era = date.getFullYear() > 0 ? 1 : 0;
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return localize.era(era, {
                    width: "abbreviated"
                });
            // A, B
            case "GGGGG":
                return localize.era(era, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return localize.era(era, {
                    width: "wide"
                });
        }
    },
    // Year
    y: function(date, token, localize) {
        // Ordinal number
        if (token === "yo") {
            const signedYear = date.getFullYear();
            // Returns 1 for 1 BC (which is year 0 in JavaScript)
            const year = signedYear > 0 ? signedYear : 1 - signedYear;
            return localize.ordinalNumber(year, {
                unit: "year"
            });
        }
        return (0, _lightFormattersJs.lightFormatters).y(date, token);
    },
    // Local week-numbering year
    Y: function(date, token, localize, options) {
        const signedWeekYear = (0, _getWeekYearJs.getWeekYear)(date, options);
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
        // Two digit year
        if (token === "YY") {
            const twoDigitYear = weekYear % 100;
            return (0, _addLeadingZerosJs.addLeadingZeros)(twoDigitYear, 2);
        }
        // Ordinal number
        if (token === "Yo") return localize.ordinalNumber(weekYear, {
            unit: "year"
        });
        // Padding
        return (0, _addLeadingZerosJs.addLeadingZeros)(weekYear, token.length);
    },
    // ISO week-numbering year
    R: function(date, token) {
        const isoWeekYear = (0, _getISOWeekYearJs.getISOWeekYear)(date);
        // Padding
        return (0, _addLeadingZerosJs.addLeadingZeros)(isoWeekYear, token.length);
    },
    // Extended year. This is a single number designating the year of this calendar system.
    // The main difference between `y` and `u` localizers are B.C. years:
    // | Year | `y` | `u` |
    // |------|-----|-----|
    // | AC 1 |   1 |   1 |
    // | BC 1 |   1 |   0 |
    // | BC 2 |   2 |  -1 |
    // Also `yy` always returns the last two digits of a year,
    // while `uu` pads single digit years to 2 characters and returns other years unchanged.
    u: function(date, token) {
        const year = date.getFullYear();
        return (0, _addLeadingZerosJs.addLeadingZeros)(year, token.length);
    },
    // Quarter
    Q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "Q":
                return String(quarter);
            // 01, 02, 03, 04
            case "QQ":
                return (0, _addLeadingZerosJs.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone quarter
    q: function(date, token, localize) {
        const quarter = Math.ceil((date.getMonth() + 1) / 3);
        switch(token){
            // 1, 2, 3, 4
            case "q":
                return String(quarter);
            // 01, 02, 03, 04
            case "qq":
                return (0, _addLeadingZerosJs.addLeadingZeros)(quarter, 2);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return localize.ordinalNumber(quarter, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return localize.quarter(quarter, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return localize.quarter(quarter, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return localize.quarter(quarter, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Month
    M: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            case "M":
            case "MM":
                return (0, _lightFormattersJs.lightFormatters).M(date, token);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "MMM":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return localize.month(month, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone month
    L: function(date, token, localize) {
        const month = date.getMonth();
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return String(month + 1);
            // 01, 02, ..., 12
            case "LL":
                return (0, _addLeadingZerosJs.addLeadingZeros)(month + 1, 2);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return localize.ordinalNumber(month + 1, {
                    unit: "month"
                });
            // Jan, Feb, ..., Dec
            case "LLL":
                return localize.month(month, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return localize.month(month, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return localize.month(month, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // Local week of year
    w: function(date, token, localize, options) {
        const week = (0, _getWeekJs.getWeek)(date, options);
        if (token === "wo") return localize.ordinalNumber(week, {
            unit: "week"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(week, token.length);
    },
    // ISO week of year
    I: function(date, token, localize) {
        const isoWeek = (0, _getISOWeekJs.getISOWeek)(date);
        if (token === "Io") return localize.ordinalNumber(isoWeek, {
            unit: "week"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(isoWeek, token.length);
    },
    // Day of the month
    d: function(date, token, localize) {
        if (token === "do") return localize.ordinalNumber(date.getDate(), {
            unit: "date"
        });
        return (0, _lightFormattersJs.lightFormatters).d(date, token);
    },
    // Day of year
    D: function(date, token, localize) {
        const dayOfYear = (0, _getDayOfYearJs.getDayOfYear)(date);
        if (token === "Do") return localize.ordinalNumber(dayOfYear, {
            unit: "dayOfYear"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(dayOfYear, token.length);
    },
    // Day of week
    E: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Local day of week
    e: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (Nth day of week with current locale or weekStartsOn)
            case "e":
                return String(localDayOfWeek);
            // Padded numerical value
            case "ee":
                return (0, _addLeadingZerosJs.addLeadingZeros)(localDayOfWeek, 2);
            // 1st, 2nd, ..., 7th
            case "eo":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "eee":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Stand-alone local day of week
    c: function(date, token, localize, options) {
        const dayOfWeek = date.getDay();
        const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
        switch(token){
            // Numerical value (same as in `e`)
            case "c":
                return String(localDayOfWeek);
            // Padded numerical value
            case "cc":
                return (0, _addLeadingZerosJs.addLeadingZeros)(localDayOfWeek, token.length);
            // 1st, 2nd, ..., 7th
            case "co":
                return localize.ordinalNumber(localDayOfWeek, {
                    unit: "day"
                });
            case "ccc":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "standalone"
                });
        }
    },
    // ISO day of week
    i: function(date, token, localize) {
        const dayOfWeek = date.getDay();
        const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
        switch(token){
            // 2
            case "i":
                return String(isoDayOfWeek);
            // 02
            case "ii":
                return (0, _addLeadingZerosJs.addLeadingZeros)(isoDayOfWeek, token.length);
            // 2nd
            case "io":
                return localize.ordinalNumber(isoDayOfWeek, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return localize.day(dayOfWeek, {
                    width: "abbreviated",
                    context: "formatting"
                });
            // T
            case "iiiii":
                return localize.day(dayOfWeek, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "iiiiii":
                return localize.day(dayOfWeek, {
                    width: "short",
                    context: "formatting"
                });
            // Tuesday
            case "iiii":
            default:
                return localize.day(dayOfWeek, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM or PM
    a: function(date, token, localize) {
        const hours = date.getHours();
        const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "aaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "aaaaa":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // AM, PM, midnight, noon
    b: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours === 12) dayPeriodEnumValue = dayPeriodEnum.noon;
        else if (hours === 0) dayPeriodEnumValue = dayPeriodEnum.midnight;
        else dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "b":
            case "bb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "bbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                }).toLowerCase();
            case "bbbbb":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // in the morning, in the afternoon, in the evening, at night
    B: function(date, token, localize) {
        const hours = date.getHours();
        let dayPeriodEnumValue;
        if (hours >= 17) dayPeriodEnumValue = dayPeriodEnum.evening;
        else if (hours >= 12) dayPeriodEnumValue = dayPeriodEnum.afternoon;
        else if (hours >= 4) dayPeriodEnumValue = dayPeriodEnum.morning;
        else dayPeriodEnumValue = dayPeriodEnum.night;
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "abbreviated",
                    context: "formatting"
                });
            case "BBBBB":
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return localize.dayPeriod(dayPeriodEnumValue, {
                    width: "wide",
                    context: "formatting"
                });
        }
    },
    // Hour [1-12]
    h: function(date, token, localize) {
        if (token === "ho") {
            let hours = date.getHours() % 12;
            if (hours === 0) hours = 12;
            return localize.ordinalNumber(hours, {
                unit: "hour"
            });
        }
        return (0, _lightFormattersJs.lightFormatters).h(date, token);
    },
    // Hour [0-23]
    H: function(date, token, localize) {
        if (token === "Ho") return localize.ordinalNumber(date.getHours(), {
            unit: "hour"
        });
        return (0, _lightFormattersJs.lightFormatters).H(date, token);
    },
    // Hour [0-11]
    K: function(date, token, localize) {
        const hours = date.getHours() % 12;
        if (token === "Ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(hours, token.length);
    },
    // Hour [1-24]
    k: function(date, token, localize) {
        let hours = date.getHours();
        if (hours === 0) hours = 24;
        if (token === "ko") return localize.ordinalNumber(hours, {
            unit: "hour"
        });
        return (0, _addLeadingZerosJs.addLeadingZeros)(hours, token.length);
    },
    // Minute
    m: function(date, token, localize) {
        if (token === "mo") return localize.ordinalNumber(date.getMinutes(), {
            unit: "minute"
        });
        return (0, _lightFormattersJs.lightFormatters).m(date, token);
    },
    // Second
    s: function(date, token, localize) {
        if (token === "so") return localize.ordinalNumber(date.getSeconds(), {
            unit: "second"
        });
        return (0, _lightFormattersJs.lightFormatters).s(date, token);
    },
    // Fraction of second
    S: function(date, token) {
        return (0, _lightFormattersJs.lightFormatters).S(date, token);
    },
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        if (timezoneOffset === 0) return "Z";
        switch(token){
            // Hours and optional minutes
            case "X":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case "XXXX":
            case "XX":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case "XXXXX":
            case "XXX":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Hours and optional minutes
            case "x":
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case "xxxx":
            case "xx":
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimiter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case "xxxxx":
            case "xxx":
            default:
                return formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (GMT)
    O: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "O":
            case "OO":
            case "OOO":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "OOOO":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, _localize) {
        const timezoneOffset = date.getTimezoneOffset();
        switch(token){
            // Short
            case "z":
            case "zz":
            case "zzz":
                return "GMT" + formatTimezoneShort(timezoneOffset, ":");
            // Long
            case "zzzz":
            default:
                return "GMT" + formatTimezone(timezoneOffset, ":");
        }
    },
    // Seconds timestamp
    t: function(date, token, _localize) {
        const timestamp = Math.trunc(+date / 1000);
        return (0, _addLeadingZerosJs.addLeadingZeros)(timestamp, token.length);
    },
    // Milliseconds timestamp
    T: function(date, token, _localize) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(+date, token.length);
    }
};
function formatTimezoneShort(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = Math.trunc(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + (0, _addLeadingZerosJs.addLeadingZeros)(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? "-" : "+";
        return sign + (0, _addLeadingZerosJs.addLeadingZeros)(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, delimiter);
}
function formatTimezone(offset, delimiter = "") {
    const sign = offset > 0 ? "-" : "+";
    const absOffset = Math.abs(offset);
    const hours = (0, _addLeadingZerosJs.addLeadingZeros)(Math.trunc(absOffset / 60), 2);
    const minutes = (0, _addLeadingZerosJs.addLeadingZeros)(absOffset % 60, 2);
    return sign + hours + delimiter + minutes;
}

},{"../../getDayOfYear.js":"b5z8T","../../getISOWeek.js":"946sx","../../getISOWeekYear.js":"eBsTu","../../getWeek.js":"bqzpI","../../getWeekYear.js":"jGQkU","../addLeadingZeros.js":"9KeJB","./lightFormatters.js":"fdXN9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b5z8T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getDayOfYear} function options.
 */ /**
 * @name getDayOfYear
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * const result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */ parcelHelpers.export(exports, "getDayOfYear", ()=>getDayOfYear);
var _differenceInCalendarDaysJs = require("./differenceInCalendarDays.js");
var _startOfYearJs = require("./startOfYear.js");
var _toDateJs = require("./toDate.js");
function getDayOfYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = (0, _differenceInCalendarDaysJs.differenceInCalendarDays)(_date, (0, _startOfYearJs.startOfYear)(_date));
    const dayOfYear = diff + 1;
    return dayOfYear;
}
// Fallback for modularized imports:
exports.default = getDayOfYear;

},{"./differenceInCalendarDays.js":"eWFID","./startOfYear.js":"atjwS","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eWFID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link differenceInCalendarDays} function options.
 */ /**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param laterDate - The later date
 * @param earlierDate - The earlier date
 * @param options - The options object
 *
 * @returns The number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */ parcelHelpers.export(exports, "differenceInCalendarDays", ()=>differenceInCalendarDays);
var _getTimezoneOffsetInMillisecondsJs = require("./_lib/getTimezoneOffsetInMilliseconds.js");
var _normalizeDatesJs = require("./_lib/normalizeDates.js");
var _constantsJs = require("./constants.js");
var _startOfDayJs = require("./startOfDay.js");
function differenceInCalendarDays(laterDate, earlierDate, options) {
    const [laterDate_, earlierDate_] = (0, _normalizeDatesJs.normalizeDates)(options?.in, laterDate, earlierDate);
    const laterStartOfDay = (0, _startOfDayJs.startOfDay)(laterDate_);
    const earlierStartOfDay = (0, _startOfDayJs.startOfDay)(earlierDate_);
    const laterTimestamp = +laterStartOfDay - (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(laterStartOfDay);
    const earlierTimestamp = +earlierStartOfDay - (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(earlierStartOfDay);
    // Round the number of days to the nearest integer because the number of
    // milliseconds in a day is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round((laterTimestamp - earlierTimestamp) / (0, _constantsJs.millisecondsInDay));
}
// Fallback for modularized imports:
exports.default = differenceInCalendarDays;

},{"./_lib/getTimezoneOffsetInMilliseconds.js":"kExSW","./_lib/normalizeDates.js":"dMQb8","./constants.js":"2c8QU","./startOfDay.js":"c2B4c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kExSW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ parcelHelpers.export(exports, "getTimezoneOffsetInMilliseconds", ()=>getTimezoneOffsetInMilliseconds);
var _toDateJs = require("../toDate.js");
function getTimezoneOffsetInMilliseconds(date) {
    const _date = (0, _toDateJs.toDate)(date);
    const utcDate = new Date(Date.UTC(_date.getFullYear(), _date.getMonth(), _date.getDate(), _date.getHours(), _date.getMinutes(), _date.getSeconds(), _date.getMilliseconds()));
    utcDate.setUTCFullYear(_date.getFullYear());
    return +date - +utcDate;
}

},{"../toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3EhaA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * Starting from v3.7.0, it clones a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param argument - The value to convert
 *
 * @returns The parsed date in the local time zone
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */ parcelHelpers.export(exports, "toDate", ()=>toDate);
var _constructFromJs = require("./constructFrom.js");
function toDate(argument, context) {
    // [TODO] Get rid of `toDate` or `constructFrom`?
    return (0, _constructFromJs.constructFrom)(context || argument, argument);
}
// Fallback for modularized imports:
exports.default = toDate;

},{"./constructFrom.js":"56Q4T","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"56Q4T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name constructFrom
 * @category Generic Helpers
 * @summary Constructs a date using the reference date and the value
 *
 * @description
 * The function constructs a new date using the constructor from the reference
 * date and the given value. It helps to build generic functions that accept
 * date extensions.
 *
 * It defaults to `Date` if the passed reference date is a number or a string.
 *
 * Starting from v3.7.0, it allows to construct a date using `[Symbol.for("constructDateFrom")]`
 * enabling to transfer extra properties from the reference date to the new date.
 * It's useful for extensions like [`TZDate`](https://github.com/date-fns/tz)
 * that accept a time zone as a constructor argument.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 *
 * @param date - The reference date to take constructor from
 * @param value - The value to create the date
 *
 * @returns Date initialized using the given date and value
 *
 * @example
 * import { constructFrom } from "./constructFrom/date-fns";
 *
 * // A function that clones a date preserving the original type
 * function cloneDate<DateType extends Date>(date: DateType): DateType {
 *   return constructFrom(
 *     date, // Use constructor from the given date
 *     date.getTime() // Use the date value to create a new date
 *   );
 * }
 */ parcelHelpers.export(exports, "constructFrom", ()=>constructFrom);
var _constantsJs = require("./constants.js");
function constructFrom(date, value) {
    if (typeof date === "function") return date(value);
    if (date && typeof date === "object" && (0, _constantsJs.constructFromSymbol) in date) return date[0, _constantsJs.constructFromSymbol](value);
    if (date instanceof Date) return new date.constructor(value);
    return new Date(value);
}
// Fallback for modularized imports:
exports.default = constructFrom;

},{"./constants.js":"2c8QU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2c8QU":[function(require,module,exports,__globalThis) {
/**
 * @module constants
 * @summary Useful constants
 * @description
 * Collection of useful date constants.
 *
 * The constants could be imported from `date-fns/constants`:
 *
 * ```ts
 * import { maxTime, minTime } from "./constants/date-fns/constants";
 *
 * function isAllowedTime(time) {
 *   return time <= maxTime && time >= minTime;
 * }
 * ```
 */ /**
 * @constant
 * @name daysInWeek
 * @summary Days in 1 week.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "daysInWeek", ()=>daysInWeek);
parcelHelpers.export(exports, "daysInYear", ()=>daysInYear);
parcelHelpers.export(exports, "maxTime", ()=>maxTime);
parcelHelpers.export(exports, "minTime", ()=>minTime);
parcelHelpers.export(exports, "millisecondsInWeek", ()=>millisecondsInWeek);
parcelHelpers.export(exports, "millisecondsInDay", ()=>millisecondsInDay);
parcelHelpers.export(exports, "millisecondsInMinute", ()=>millisecondsInMinute);
parcelHelpers.export(exports, "millisecondsInHour", ()=>millisecondsInHour);
parcelHelpers.export(exports, "millisecondsInSecond", ()=>millisecondsInSecond);
parcelHelpers.export(exports, "minutesInYear", ()=>minutesInYear);
parcelHelpers.export(exports, "minutesInMonth", ()=>minutesInMonth);
parcelHelpers.export(exports, "minutesInDay", ()=>minutesInDay);
parcelHelpers.export(exports, "minutesInHour", ()=>minutesInHour);
parcelHelpers.export(exports, "monthsInQuarter", ()=>monthsInQuarter);
parcelHelpers.export(exports, "monthsInYear", ()=>monthsInYear);
parcelHelpers.export(exports, "quartersInYear", ()=>quartersInYear);
parcelHelpers.export(exports, "secondsInHour", ()=>secondsInHour);
parcelHelpers.export(exports, "secondsInMinute", ()=>secondsInMinute);
parcelHelpers.export(exports, "secondsInDay", ()=>secondsInDay);
parcelHelpers.export(exports, "secondsInWeek", ()=>secondsInWeek);
parcelHelpers.export(exports, "secondsInYear", ()=>secondsInYear);
parcelHelpers.export(exports, "secondsInMonth", ()=>secondsInMonth);
parcelHelpers.export(exports, "secondsInQuarter", ()=>secondsInQuarter);
parcelHelpers.export(exports, "constructFromSymbol", ()=>constructFromSymbol);
const daysInWeek = 7;
const daysInYear = 365.2425;
const maxTime = Math.pow(10, 8) * 86400000;
const minTime = -maxTime;
const millisecondsInWeek = 604800000;
const millisecondsInDay = 86400000;
const millisecondsInMinute = 60000;
const millisecondsInHour = 3600000;
const millisecondsInSecond = 1000;
const minutesInYear = 525600;
const minutesInMonth = 43200;
const minutesInDay = 1440;
const minutesInHour = 60;
const monthsInQuarter = 3;
const monthsInYear = 12;
const quartersInYear = 4;
const secondsInHour = 3600;
const secondsInMinute = 60;
const secondsInDay = secondsInHour * 24;
const secondsInWeek = secondsInDay * 7;
const secondsInYear = secondsInDay * daysInYear;
const secondsInMonth = secondsInYear / 12;
const secondsInQuarter = secondsInMonth * 3;
const constructFromSymbol = Symbol.for("constructDateFrom");

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dMQb8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeDates", ()=>normalizeDates);
var _constructFromJs = require("../constructFrom.js");
function normalizeDates(context, ...dates) {
    const normalize = (0, _constructFromJs.constructFrom).bind(null, context || dates.find((date)=>typeof date === "object"));
    return dates.map(normalize);
}

},{"../constructFrom.js":"56Q4T","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c2B4c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfDay} function options.
 */ /**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfDay", ()=>startOfDay);
var _toDateJs = require("./toDate.js");
function startOfDay(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfDay;

},{"./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"atjwS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfYear} function options.
 */ /**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - The options
 *
 * @returns The start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfYear", ()=>startOfYear);
var _toDateJs = require("./toDate.js");
function startOfYear(date, options) {
    const date_ = (0, _toDateJs.toDate)(date, options?.in);
    date_.setFullYear(date_.getFullYear(), 0, 1);
    date_.setHours(0, 0, 0, 0);
    return date_;
}
// Fallback for modularized imports:
exports.default = startOfYear;

},{"./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"946sx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getISOWeek} function options.
 */ /**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 * @param options - The options
 *
 * @returns The ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */ parcelHelpers.export(exports, "getISOWeek", ()=>getISOWeek);
var _constantsJs = require("./constants.js");
var _startOfISOWeekJs = require("./startOfISOWeek.js");
var _startOfISOWeekYearJs = require("./startOfISOWeekYear.js");
var _toDateJs = require("./toDate.js");
function getISOWeek(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = +(0, _startOfISOWeekJs.startOfISOWeek)(_date) - +(0, _startOfISOWeekYearJs.startOfISOWeekYear)(_date);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, _constantsJs.millisecondsInWeek)) + 1;
}
// Fallback for modularized imports:
exports.default = getISOWeek;

},{"./constants.js":"2c8QU","./startOfISOWeek.js":"gaVGB","./startOfISOWeekYear.js":"fdVZQ","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gaVGB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfISOWeek} function options.
 */ /**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfISOWeek", ()=>startOfISOWeek);
var _startOfWeekJs = require("./startOfWeek.js");
function startOfISOWeek(date, options) {
    return (0, _startOfWeekJs.startOfWeek)(date, {
        ...options,
        weekStartsOn: 1
    });
}
// Fallback for modularized imports:
exports.default = startOfISOWeek;

},{"./startOfWeek.js":"i3N4r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i3N4r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeek} function options.
 */ /**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */ parcelHelpers.export(exports, "startOfWeek", ()=>startOfWeek);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _toDateJs = require("./toDate.js");
function startOfWeek(date, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const day = _date.getDay();
    const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
    _date.setDate(_date.getDate() - diff);
    _date.setHours(0, 0, 0, 0);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfWeek;

},{"./_lib/defaultOptions.js":"gg1YU","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fdVZQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfISOWeekYear} function options.
 */ /**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of an ISO week-numbering year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */ parcelHelpers.export(exports, "startOfISOWeekYear", ()=>startOfISOWeekYear);
var _constructFromJs = require("./constructFrom.js");
var _getISOWeekYearJs = require("./getISOWeekYear.js");
var _startOfISOWeekJs = require("./startOfISOWeek.js");
function startOfISOWeekYear(date, options) {
    const year = (0, _getISOWeekYearJs.getISOWeekYear)(date, options);
    const fourthOfJanuary = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    fourthOfJanuary.setFullYear(year, 0, 4);
    fourthOfJanuary.setHours(0, 0, 0, 0);
    return (0, _startOfISOWeekJs.startOfISOWeek)(fourthOfJanuary);
}
// Fallback for modularized imports:
exports.default = startOfISOWeekYear;

},{"./constructFrom.js":"56Q4T","./getISOWeekYear.js":"eBsTu","./startOfISOWeek.js":"gaVGB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eBsTu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getISOWeekYear} function options.
 */ /**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 *
 * @returns The ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */ parcelHelpers.export(exports, "getISOWeekYear", ()=>getISOWeekYear);
var _constructFromJs = require("./constructFrom.js");
var _startOfISOWeekJs = require("./startOfISOWeek.js");
var _toDateJs = require("./toDate.js");
function getISOWeekYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const fourthOfJanuaryOfNextYear = (0, _constructFromJs.constructFrom)(_date, 0);
    fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
    fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, _startOfISOWeekJs.startOfISOWeek)(fourthOfJanuaryOfNextYear);
    const fourthOfJanuaryOfThisYear = (0, _constructFromJs.constructFrom)(_date, 0);
    fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
    fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, _startOfISOWeekJs.startOfISOWeek)(fourthOfJanuaryOfThisYear);
    if (_date.getTime() >= startOfNextYear.getTime()) return year + 1;
    else if (_date.getTime() >= startOfThisYear.getTime()) return year;
    else return year - 1;
}
// Fallback for modularized imports:
exports.default = getISOWeekYear;

},{"./constructFrom.js":"56Q4T","./startOfISOWeek.js":"gaVGB","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bqzpI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeek} function options.
 */ /**
 * @name getWeek
 * @category Week Helpers
 * @summary Get the local week index of the given date.
 *
 * @description
 * Get the local week index of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The week
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005 with default options?
 * const result = getWeek(new Date(2005, 0, 2))
 * //=> 2
 *
 * @example
 * // Which week of the local week numbering year is 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January?
 * const result = getWeek(new Date(2005, 0, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> 53
 */ parcelHelpers.export(exports, "getWeek", ()=>getWeek);
var _constantsJs = require("./constants.js");
var _startOfWeekJs = require("./startOfWeek.js");
var _startOfWeekYearJs = require("./startOfWeekYear.js");
var _toDateJs = require("./toDate.js");
function getWeek(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = +(0, _startOfWeekJs.startOfWeek)(_date, options) - +(0, _startOfWeekYearJs.startOfWeekYear)(_date, options);
    // Round the number of weeks to the nearest integer because the number of
    // milliseconds in a week is not constant (e.g. it's different in the week of
    // the daylight saving time clock shift).
    return Math.round(diff / (0, _constantsJs.millisecondsInWeek)) + 1;
}
// Fallback for modularized imports:
exports.default = getWeek;

},{"./constants.js":"2c8QU","./startOfWeek.js":"i3N4r","./startOfWeekYear.js":"l2yMV","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l2yMV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link startOfWeekYear} function options.
 */ /**
 * @name startOfWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Return the start of a local week-numbering year for the given date.
 *
 * @description
 * Return the start of a local week-numbering year.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type.
 *
 * @param date - The original date
 * @param options - An object with options
 *
 * @returns The start of a week-numbering year
 *
 * @example
 * // The start of an a week-numbering year for 2 July 2005 with default settings:
 * const result = startOfWeekYear(new Date(2005, 6, 2))
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // The start of a week-numbering year for 2 July 2005
 * // if Monday is the first day of week
 * // and 4 January is always in the first week of the year:
 * const result = startOfWeekYear(new Date(2005, 6, 2), {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Mon Jan 03 2005 00:00:00
 */ parcelHelpers.export(exports, "startOfWeekYear", ()=>startOfWeekYear);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _constructFromJs = require("./constructFrom.js");
var _getWeekYearJs = require("./getWeekYear.js");
var _startOfWeekJs = require("./startOfWeek.js");
function startOfWeekYear(date, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const year = (0, _getWeekYearJs.getWeekYear)(date, options);
    const firstWeek = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    firstWeek.setFullYear(year, 0, firstWeekContainsDate);
    firstWeek.setHours(0, 0, 0, 0);
    const _date = (0, _startOfWeekJs.startOfWeek)(firstWeek, options);
    return _date;
}
// Fallback for modularized imports:
exports.default = startOfWeekYear;

},{"./_lib/defaultOptions.js":"gg1YU","./constructFrom.js":"56Q4T","./getWeekYear.js":"jGQkU","./startOfWeek.js":"i3N4r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jGQkU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getWeekYear} function options.
 */ /**
 * @name getWeekYear
 * @category Week-Numbering Year Helpers
 * @summary Get the local week-numbering year of the given date.
 *
 * @description
 * Get the local week-numbering year of the given date.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @param date - The given date
 * @param options - An object with options.
 *
 * @returns The local week-numbering year
 *
 * @example
 * // Which week numbering year is 26 December 2004 with the default settings?
 * const result = getWeekYear(new Date(2004, 11, 26))
 * //=> 2005
 *
 * @example
 * // Which week numbering year is 26 December 2004 if week starts on Saturday?
 * const result = getWeekYear(new Date(2004, 11, 26), { weekStartsOn: 6 })
 * //=> 2004
 *
 * @example
 * // Which week numbering year is 26 December 2004 if the first week contains 4 January?
 * const result = getWeekYear(new Date(2004, 11, 26), { firstWeekContainsDate: 4 })
 * //=> 2004
 */ parcelHelpers.export(exports, "getWeekYear", ()=>getWeekYear);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _constructFromJs = require("./constructFrom.js");
var _startOfWeekJs = require("./startOfWeek.js");
var _toDateJs = require("./toDate.js");
function getWeekYear(date, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const year = _date.getFullYear();
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const firstWeekOfNextYear = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
    firstWeekOfNextYear.setHours(0, 0, 0, 0);
    const startOfNextYear = (0, _startOfWeekJs.startOfWeek)(firstWeekOfNextYear, options);
    const firstWeekOfThisYear = (0, _constructFromJs.constructFrom)(options?.in || date, 0);
    firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
    firstWeekOfThisYear.setHours(0, 0, 0, 0);
    const startOfThisYear = (0, _startOfWeekJs.startOfWeek)(firstWeekOfThisYear, options);
    if (+_date >= +startOfNextYear) return year + 1;
    else if (+_date >= +startOfThisYear) return year;
    else return year - 1;
}
// Fallback for modularized imports:
exports.default = getWeekYear;

},{"./_lib/defaultOptions.js":"gg1YU","./constructFrom.js":"56Q4T","./startOfWeek.js":"i3N4r","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9KeJB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addLeadingZeros", ()=>addLeadingZeros);
function addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? "-" : "";
    const output = Math.abs(number).toString().padStart(targetLength, "0");
    return sign + output;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fdXN9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "lightFormatters", ()=>lightFormatters);
var _addLeadingZerosJs = require("../addLeadingZeros.js");
const lightFormatters = {
    // Year
    y (date, token) {
        // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
        // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
        // |----------|-------|----|-------|-------|-------|
        // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
        // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
        // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
        // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
        // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
        const signedYear = date.getFullYear();
        // Returns 1 for 1 BC (which is year 0 in JavaScript)
        const year = signedYear > 0 ? signedYear : 1 - signedYear;
        return (0, _addLeadingZerosJs.addLeadingZeros)(token === "yy" ? year % 100 : year, token.length);
    },
    // Month
    M (date, token) {
        const month = date.getMonth();
        return token === "M" ? String(month + 1) : (0, _addLeadingZerosJs.addLeadingZeros)(month + 1, 2);
    },
    // Day of the month
    d (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getDate(), token.length);
    },
    // AM or PM
    a (date, token) {
        const dayPeriodEnumValue = date.getHours() / 12 >= 1 ? "pm" : "am";
        switch(token){
            case "a":
            case "aa":
                return dayPeriodEnumValue.toUpperCase();
            case "aaa":
                return dayPeriodEnumValue;
            case "aaaaa":
                return dayPeriodEnumValue[0];
            case "aaaa":
            default:
                return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
        }
    },
    // Hour [1-12]
    h (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getHours() % 12 || 12, token.length);
    },
    // Hour [0-23]
    H (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getHours(), token.length);
    },
    // Minute
    m (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getMinutes(), token.length);
    },
    // Second
    s (date, token) {
        return (0, _addLeadingZerosJs.addLeadingZeros)(date.getSeconds(), token.length);
    },
    // Fraction of second
    S (date, token) {
        const numberOfDigits = token.length;
        const milliseconds = date.getMilliseconds();
        const fractionalSeconds = Math.trunc(milliseconds * Math.pow(10, numberOfDigits - 3));
        return (0, _addLeadingZerosJs.addLeadingZeros)(fractionalSeconds, token.length);
    }
};

},{"../addLeadingZeros.js":"9KeJB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lMm4k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "longFormatters", ()=>longFormatters);
const dateLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "P":
            return formatLong.date({
                width: "short"
            });
        case "PP":
            return formatLong.date({
                width: "medium"
            });
        case "PPP":
            return formatLong.date({
                width: "long"
            });
        case "PPPP":
        default:
            return formatLong.date({
                width: "full"
            });
    }
};
const timeLongFormatter = (pattern, formatLong)=>{
    switch(pattern){
        case "p":
            return formatLong.time({
                width: "short"
            });
        case "pp":
            return formatLong.time({
                width: "medium"
            });
        case "ppp":
            return formatLong.time({
                width: "long"
            });
        case "pppp":
        default:
            return formatLong.time({
                width: "full"
            });
    }
};
const dateTimeLongFormatter = (pattern, formatLong)=>{
    const matchResult = pattern.match(/(P+)(p+)?/) || [];
    const datePattern = matchResult[1];
    const timePattern = matchResult[2];
    if (!timePattern) return dateLongFormatter(pattern, formatLong);
    let dateTimeFormat;
    switch(datePattern){
        case "P":
            dateTimeFormat = formatLong.dateTime({
                width: "short"
            });
            break;
        case "PP":
            dateTimeFormat = formatLong.dateTime({
                width: "medium"
            });
            break;
        case "PPP":
            dateTimeFormat = formatLong.dateTime({
                width: "long"
            });
            break;
        case "PPPP":
        default:
            dateTimeFormat = formatLong.dateTime({
                width: "full"
            });
            break;
    }
    return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong)).replace("{{time}}", timeLongFormatter(timePattern, formatLong));
};
const longFormatters = {
    p: timeLongFormatter,
    P: dateTimeLongFormatter
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9HGYz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isProtectedDayOfYearToken", ()=>isProtectedDayOfYearToken);
parcelHelpers.export(exports, "isProtectedWeekYearToken", ()=>isProtectedWeekYearToken);
parcelHelpers.export(exports, "warnOrThrowProtectedError", ()=>warnOrThrowProtectedError);
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = [
    "D",
    "DD",
    "YY",
    "YYYY"
];
function isProtectedDayOfYearToken(token) {
    return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
    return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format, input) {
    const _message = message(token, format, input);
    console.warn(_message);
    if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format, input) {
    const subject = token[0] === "Y" ? "years" : "days of the month";
    return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7VkAB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate](https://date-fns.org/docs/toDate)
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param date - The date to check
 *
 * @returns The date is valid
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertible into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */ parcelHelpers.export(exports, "isValid", ()=>isValid);
var _isDateJs = require("./isDate.js");
var _toDateJs = require("./toDate.js");
function isValid(date) {
    return !(!(0, _isDateJs.isDate)(date) && typeof date !== "number" || isNaN(+(0, _toDateJs.toDate)(date)));
}
// Fallback for modularized imports:
exports.default = isValid;

},{"./isDate.js":"6zvFm","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6zvFm":[function(require,module,exports,__globalThis) {
/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param value - The value to check
 *
 * @returns True if the given value is a date
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isDate", ()=>isDate);
function isDate(value) {
    return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
// Fallback for modularized imports:
exports.default = isDate;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1pnxx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatters", ()=>formatters);
var _indexJs = require("../../_lib/tzIntlTimeZoneName/index.js");
var _indexJs1 = require("../../_lib/tzParseTimezone/index.js");
const MILLISECONDS_IN_MINUTE = 60000;
const formatters = {
    // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
    X: function(date, token, options) {
        const timezoneOffset = getTimeZoneOffset(options.timeZone, date);
        if (timezoneOffset === 0) return 'Z';
        switch(token){
            // Hours and optional minutes
            case 'X':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XX`
            case 'XXXX':
            case 'XX':
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `XXX`
            case 'XXXXX':
            case 'XXX':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
    x: function(date, token, options) {
        const timezoneOffset = getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Hours and optional minutes
            case 'x':
                return formatTimezoneWithOptionalMinutes(timezoneOffset);
            // Hours, minutes and optional seconds without `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xx`
            case 'xxxx':
            case 'xx':
                return formatTimezone(timezoneOffset);
            // Hours, minutes and optional seconds with `:` delimeter
            // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
            // so this token always has the same output as `xxx`
            case 'xxxxx':
            case 'xxx':
            default:
                return formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (GMT)
    O: function(date, token, options) {
        const timezoneOffset = getTimeZoneOffset(options.timeZone, date);
        switch(token){
            // Short
            case 'O':
            case 'OO':
            case 'OOO':
                return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
            // Long
            case 'OOOO':
            default:
                return 'GMT' + formatTimezone(timezoneOffset, ':');
        }
    },
    // Timezone (specific non-location)
    z: function(date, token, options) {
        switch(token){
            // Short
            case 'z':
            case 'zz':
            case 'zzz':
                return (0, _indexJs.tzIntlTimeZoneName)('short', date, options);
            // Long
            case 'zzzz':
            default:
                return (0, _indexJs.tzIntlTimeZoneName)('long', date, options);
        }
    }
};
function getTimeZoneOffset(timeZone, originalDate) {
    const timeZoneOffset = timeZone ? (0, _indexJs1.tzParseTimezone)(timeZone, originalDate, true) / MILLISECONDS_IN_MINUTE : originalDate?.getTimezoneOffset() ?? 0;
    if (Number.isNaN(timeZoneOffset)) throw new RangeError('Invalid time zone specified: ' + timeZone);
    return timeZoneOffset;
}
function addLeadingZeros(number, targetLength) {
    const sign = number < 0 ? '-' : '';
    let output = Math.abs(number).toString();
    while(output.length < targetLength)output = '0' + output;
    return sign + output;
}
function formatTimezone(offset, delimiter = '') {
    const sign = offset > 0 ? '-' : '+';
    const absOffset = Math.abs(offset);
    const hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
    const minutes = addLeadingZeros(Math.floor(absOffset % 60), 2);
    return sign + hours + delimiter + minutes;
}
function formatTimezoneWithOptionalMinutes(offset, delimiter) {
    if (offset % 60 === 0) {
        const sign = offset > 0 ? '-' : '+';
        return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
    }
    return formatTimezone(offset, delimiter);
}
function formatTimezoneShort(offset, delimiter = '') {
    const sign = offset > 0 ? '-' : '+';
    const absOffset = Math.abs(offset);
    const hours = Math.floor(absOffset / 60);
    const minutes = absOffset % 60;
    if (minutes === 0) return sign + String(hours);
    return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

},{"../../_lib/tzIntlTimeZoneName/index.js":"joZZo","../../_lib/tzParseTimezone/index.js":"86Mkh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"joZZo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Returns the formatted time zone name of the provided `timeZone` or the current
 * system time zone if omitted, accounting for DST according to the UTC value of
 * the date.
 */ parcelHelpers.export(exports, "tzIntlTimeZoneName", ()=>tzIntlTimeZoneName);
var _dateFns = require("date-fns");
function tzIntlTimeZoneName(length, date, options) {
    const defaultOptions = (0, _dateFns.getDefaultOptions)();
    const dtf = getDTF(length, options.timeZone, options.locale ?? defaultOptions.locale);
    return 'formatToParts' in dtf ? partsTimeZone(dtf, date) : hackyTimeZone(dtf, date);
}
function partsTimeZone(dtf, date) {
    const formatted = dtf.formatToParts(date);
    for(let i = formatted.length - 1; i >= 0; --i){
        if (formatted[i].type === 'timeZoneName') return formatted[i].value;
    }
    return undefined;
}
function hackyTimeZone(dtf, date) {
    const formatted = dtf.format(date).replace(/\u200E/g, '');
    const tzNameMatch = / [\w-+ ]+$/.exec(formatted);
    return tzNameMatch ? tzNameMatch[0].substr(1) : '';
}
// If a locale has been provided `en-US` is used as a fallback in case it is an
// invalid locale, otherwise the locale is left undefined to use the system locale.
function getDTF(length, timeZone, locale) {
    return new Intl.DateTimeFormat(locale ? [
        locale.code,
        'en-US'
    ] : undefined, {
        timeZone: timeZone,
        timeZoneName: length
    });
}

},{"date-fns":"4aY5h","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4aY5h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getDefaultOptions
 * @category Common Helpers
 * @summary Get default options.
 * @pure false
 *
 * @description
 * Returns an object that contains defaults for
 * `options.locale`, `options.weekStartsOn` and `options.firstWeekContainsDate`
 * arguments for all functions.
 *
 * You can change these with [setDefaultOptions](https://date-fns.org/docs/setDefaultOptions).
 *
 * @returns The default options
 *
 * @example
 * const result = getDefaultOptions()
 * //=> {}
 *
 * @example
 * setDefaultOptions({ weekStarsOn: 1, firstWeekContainsDate: 4 })
 * const result = getDefaultOptions()
 * //=> { weekStarsOn: 1, firstWeekContainsDate: 4 }
 */ parcelHelpers.export(exports, "getDefaultOptions", ()=>getDefaultOptions);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
function getDefaultOptions() {
    return Object.assign({}, (0, _defaultOptionsJs.getDefaultOptions)());
}
// Fallback for modularized imports:
exports.default = getDefaultOptions;

},{"./_lib/defaultOptions.js":"gg1YU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"86Mkh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Parse constious time zone offset formats to an offset in milliseconds
parcelHelpers.export(exports, "tzParseTimezone", ()=>tzParseTimezone);
var _indexJs = require("../tzTokenizeDate/index.js");
var _indexJs1 = require("../newDateUTC/index.js");
const MILLISECONDS_IN_HOUR = 3600000;
const MILLISECONDS_IN_MINUTE = 60000;
const patterns = {
    timezone: /([Z+-].*)$/,
    timezoneZ: /^(Z)$/,
    timezoneHH: /^([+-]\d{2})$/,
    timezoneHHMM: /^([+-])(\d{2}):?(\d{2})$/
};
function tzParseTimezone(timezoneString, date, isUtcDate) {
    // Empty string
    if (!timezoneString) return 0;
    // Z
    let token = patterns.timezoneZ.exec(timezoneString);
    if (token) return 0;
    let hours;
    let absoluteOffset;
    // ±hh
    token = patterns.timezoneHH.exec(timezoneString);
    if (token) {
        hours = parseInt(token[1], 10);
        if (!validateTimezone(hours)) return NaN;
        return -(hours * MILLISECONDS_IN_HOUR);
    }
    // ±hh:mm or ±hhmm
    token = patterns.timezoneHHMM.exec(timezoneString);
    if (token) {
        hours = parseInt(token[2], 10);
        const minutes = parseInt(token[3], 10);
        if (!validateTimezone(hours, minutes)) return NaN;
        absoluteOffset = Math.abs(hours) * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
        return token[1] === '+' ? -absoluteOffset : absoluteOffset;
    }
    // IANA time zone
    if (isValidTimezoneIANAString(timezoneString)) {
        date = new Date(date || Date.now());
        const utcDate = isUtcDate ? date : toUtcDate(date);
        const offset = calcOffset(utcDate, timezoneString);
        const fixedOffset = isUtcDate ? offset : fixOffset(date, offset, timezoneString);
        return -fixedOffset;
    }
    return NaN;
}
function toUtcDate(date) {
    return (0, _indexJs1.newDateUTC)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
}
function calcOffset(date, timezoneString) {
    const tokens = (0, _indexJs.tzTokenizeDate)(date, timezoneString);
    // ms dropped because it's not provided by tzTokenizeDate
    const asUTC = (0, _indexJs1.newDateUTC)(tokens[0], tokens[1] - 1, tokens[2], tokens[3] % 24, tokens[4], tokens[5], 0).getTime();
    let asTS = date.getTime();
    const over = asTS % 1000;
    asTS -= over >= 0 ? over : 1000 + over;
    return asUTC - asTS;
}
function fixOffset(date, offset, timezoneString) {
    const localTS = date.getTime();
    // Our UTC time is just a guess because our offset is just a guess
    let utcGuess = localTS - offset;
    // Test whether the zone matches the offset for this ts
    const o2 = calcOffset(new Date(utcGuess), timezoneString);
    // If so, offset didn't change, and we're done
    if (offset === o2) return offset;
    // If not, change the ts by the difference in the offset
    utcGuess -= o2 - offset;
    // If that gives us the local time we want, we're done
    const o3 = calcOffset(new Date(utcGuess), timezoneString);
    if (o2 === o3) return o2;
    // If it's different, we're in a hole time. The offset has changed, but we don't adjust the time
    return Math.max(o2, o3);
}
function validateTimezone(hours, minutes) {
    return -23 <= hours && hours <= 23 && (minutes == null || 0 <= minutes && minutes <= 59);
}
const validIANATimezoneCache = {};
function isValidTimezoneIANAString(timeZoneString) {
    if (validIANATimezoneCache[timeZoneString]) return true;
    try {
        new Intl.DateTimeFormat(undefined, {
            timeZone: timeZoneString
        });
        validIANATimezoneCache[timeZoneString] = true;
        return true;
    } catch (error) {
        return false;
    }
}

},{"../tzTokenizeDate/index.js":"7h5bK","../newDateUTC/index.js":"cZ2zr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7h5bK":[function(require,module,exports,__globalThis) {
/**
 * Returns the [year, month, day, hour, minute, seconds] tokens of the provided
 * `date` as it will be rendered in the `timeZone`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tzTokenizeDate", ()=>tzTokenizeDate);
function tzTokenizeDate(date, timeZone) {
    const dtf = getDateTimeFormat(timeZone);
    return 'formatToParts' in dtf ? partsOffset(dtf, date) : hackyOffset(dtf, date);
}
const typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    hour: 3,
    minute: 4,
    second: 5
};
function partsOffset(dtf, date) {
    try {
        const formatted = dtf.formatToParts(date);
        const filled = [];
        for(let i = 0; i < formatted.length; i++){
            const pos = typeToPos[formatted[i].type];
            if (pos !== undefined) filled[pos] = parseInt(formatted[i].value, 10);
        }
        return filled;
    } catch (error) {
        if (error instanceof RangeError) return [
            NaN
        ];
        throw error;
    }
}
function hackyOffset(dtf, date) {
    const formatted = dtf.format(date);
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const parsed = /(\d+)\/(\d+)\/(\d+),? (\d+):(\d+):(\d+)/.exec(formatted);
    // const [, fMonth, fDay, fYear, fHour, fMinute, fSecond] = parsed
    // return [fYear, fMonth, fDay, fHour, fMinute, fSecond]
    return [
        parseInt(parsed[3], 10),
        parseInt(parsed[1], 10),
        parseInt(parsed[2], 10),
        parseInt(parsed[4], 10),
        parseInt(parsed[5], 10),
        parseInt(parsed[6], 10)
    ];
}
// Get a cached Intl.DateTimeFormat instance for the IANA `timeZone`. This can be used
// to get deterministic local date/time output according to the `en-US` locale which
// can be used to extract local time parts as necessary.
const dtfCache = {};
// New browsers use `hourCycle`, IE and Chrome <73 does not support it and uses `hour12`
const testDateFormatted = new Intl.DateTimeFormat('en-US', {
    hourCycle: 'h23',
    timeZone: 'America/New_York',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
}).format(new Date('2014-06-25T04:00:00.123Z'));
const hourCycleSupported = testDateFormatted === '06/25/2014, 00:00:00' || testDateFormatted === "\u200E06\u200E/\u200E25\u200E/\u200E2014\u200E \u200E00\u200E:\u200E00\u200E:\u200E00";
function getDateTimeFormat(timeZone) {
    if (!dtfCache[timeZone]) dtfCache[timeZone] = hourCycleSupported ? new Intl.DateTimeFormat('en-US', {
        hourCycle: 'h23',
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    }) : new Intl.DateTimeFormat('en-US', {
        hour12: false,
        timeZone: timeZone,
        year: 'numeric',
        month: 'numeric',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
    });
    return dtfCache[timeZone];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cZ2zr":[function(require,module,exports,__globalThis) {
/**
 * Use instead of `new Date(Date.UTC(...))` to support years below 100 which doesn't work
 * otherwise due to the nature of the
 * [`Date` constructor](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date#interpretation_of_two-digit_years.
 *
 * For `Date.UTC(...)`, use `newDateUTC(...).getTime()`.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "newDateUTC", ()=>newDateUTC);
function newDateUTC(fullYear, month, day, hour, minute, second, millisecond) {
    const utcDate = new Date(0);
    utcDate.setUTCFullYear(fullYear, month, day);
    utcDate.setUTCHours(hour, minute, second, millisecond);
    return utcDate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fsrFV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 * If the function cannot parse the string or the values are invalid, it returns Invalid Date.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 * All *date-fns* functions will throw `RangeError` if `options.additionalDigits` is not 0, 1, 2 or undefined.
 *
 * @param argument the value to convert
 * @param options the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @param {string} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 *
 * @returns the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = toDate('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = toDate('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */ parcelHelpers.export(exports, "toDate", ()=>toDate);
var _indexJs = require("../_lib/getTimezoneOffsetInMilliseconds/index.js");
var _indexJs1 = require("../_lib/tzParseTimezone/index.js");
var _indexJs2 = require("../_lib/tzPattern/index.js");
const MILLISECONDS_IN_HOUR = 3600000;
const MILLISECONDS_IN_MINUTE = 60000;
const DEFAULT_ADDITIONAL_DIGITS = 2;
const patterns = {
    dateTimePattern: /^([0-9W+-]+)(T| )(.*)/,
    datePattern: /^([0-9W+-]+)(.*)/,
    plainTime: /:/,
    // year tokens
    YY: /^(\d{2})$/,
    YYY: [
        /^([+-]\d{2})$/,
        /^([+-]\d{3})$/,
        /^([+-]\d{4})$/
    ],
    YYYY: /^(\d{4})/,
    YYYYY: [
        /^([+-]\d{4})/,
        /^([+-]\d{5})/,
        /^([+-]\d{6})/
    ],
    // date tokens
    MM: /^-(\d{2})$/,
    DDD: /^-?(\d{3})$/,
    MMDD: /^-?(\d{2})-?(\d{2})$/,
    Www: /^-?W(\d{2})$/,
    WwwD: /^-?W(\d{2})-?(\d{1})$/,
    HH: /^(\d{2}([.,]\d*)?)$/,
    HHMM: /^(\d{2}):?(\d{2}([.,]\d*)?)$/,
    HHMMSS: /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/,
    // time zone tokens (to identify the presence of a tz)
    timeZone: (0, _indexJs2.tzPattern)
};
function toDate(argument, options = {}) {
    if (arguments.length < 1) throw new TypeError('1 argument required, but only ' + arguments.length + ' present');
    if (argument === null) return new Date(NaN);
    const additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : Number(options.additionalDigits);
    if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) throw new RangeError('additionalDigits must be 0, 1 or 2');
    // Clone the date
    if (argument instanceof Date || typeof argument === 'object' && Object.prototype.toString.call(argument) === '[object Date]') // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
    else if (typeof argument === 'number' || Object.prototype.toString.call(argument) === '[object Number]') return new Date(argument);
    else if (!(Object.prototype.toString.call(argument) === '[object String]')) return new Date(NaN);
    const dateStrings = splitDateString(argument);
    const { year, restDateString } = parseYear(dateStrings.date, additionalDigits);
    const date = parseDate(restDateString, year);
    if (date === null || isNaN(date.getTime())) return new Date(NaN);
    if (date) {
        const timestamp = date.getTime();
        let time = 0;
        let offset;
        if (dateStrings.time) {
            time = parseTime(dateStrings.time);
            if (time === null || isNaN(time)) return new Date(NaN);
        }
        if (dateStrings.timeZone || options.timeZone) {
            offset = (0, _indexJs1.tzParseTimezone)(dateStrings.timeZone || options.timeZone, new Date(timestamp + time));
            if (isNaN(offset)) return new Date(NaN);
        } else {
            // get offset accurate to hour in time zones that change offset
            offset = (0, _indexJs.getTimezoneOffsetInMilliseconds)(new Date(timestamp + time));
            offset = (0, _indexJs.getTimezoneOffsetInMilliseconds)(new Date(timestamp + time + offset));
        }
        return new Date(timestamp + time + offset);
    } else return new Date(NaN);
}
function splitDateString(dateString) {
    const dateStrings = {};
    let parts = patterns.dateTimePattern.exec(dateString);
    let timeString;
    if (!parts) {
        parts = patterns.datePattern.exec(dateString);
        if (parts) {
            dateStrings.date = parts[1];
            timeString = parts[2];
        } else {
            dateStrings.date = null;
            timeString = dateString;
        }
    } else {
        dateStrings.date = parts[1];
        timeString = parts[3];
    }
    if (timeString) {
        const token = patterns.timeZone.exec(timeString);
        if (token) {
            dateStrings.time = timeString.replace(token[1], '');
            dateStrings.timeZone = token[1].trim();
        } else dateStrings.time = timeString;
    }
    return dateStrings;
}
function parseYear(dateString, additionalDigits) {
    if (dateString) {
        const patternYYY = patterns.YYY[additionalDigits];
        const patternYYYYY = patterns.YYYYY[additionalDigits];
        // YYYY or ±YYYYY
        let token = patterns.YYYY.exec(dateString) || patternYYYYY.exec(dateString);
        if (token) {
            const yearString = token[1];
            return {
                year: parseInt(yearString, 10),
                restDateString: dateString.slice(yearString.length)
            };
        }
        // YY or ±YYY
        token = patterns.YY.exec(dateString) || patternYYY.exec(dateString);
        if (token) {
            const centuryString = token[1];
            return {
                year: parseInt(centuryString, 10) * 100,
                restDateString: dateString.slice(centuryString.length)
            };
        }
    }
    // Invalid ISO-formatted year
    return {
        year: null
    };
}
function parseDate(dateString, year) {
    // Invalid ISO-formatted year
    if (year === null) return null;
    let date;
    let month;
    let week;
    // YYYY
    if (!dateString || !dateString.length) {
        date = new Date(0);
        date.setUTCFullYear(year);
        return date;
    }
    // YYYY-MM
    let token = patterns.MM.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        if (!validateDate(year, month)) return new Date(NaN);
        date.setUTCFullYear(year, month);
        return date;
    }
    // YYYY-DDD or YYYYDDD
    token = patterns.DDD.exec(dateString);
    if (token) {
        date = new Date(0);
        const dayOfYear = parseInt(token[1], 10);
        if (!validateDayOfYearDate(year, dayOfYear)) return new Date(NaN);
        date.setUTCFullYear(year, 0, dayOfYear);
        return date;
    }
    // yyyy-MM-dd or YYYYMMDD
    token = patterns.MMDD.exec(dateString);
    if (token) {
        date = new Date(0);
        month = parseInt(token[1], 10) - 1;
        const day = parseInt(token[2], 10);
        if (!validateDate(year, month, day)) return new Date(NaN);
        date.setUTCFullYear(year, month, day);
        return date;
    }
    // YYYY-Www or YYYYWww
    token = patterns.Www.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        if (!validateWeekDate(week)) return new Date(NaN);
        return dayOfISOWeekYear(year, week);
    }
    // YYYY-Www-D or YYYYWwwD
    token = patterns.WwwD.exec(dateString);
    if (token) {
        week = parseInt(token[1], 10) - 1;
        const dayOfWeek = parseInt(token[2], 10) - 1;
        if (!validateWeekDate(week, dayOfWeek)) return new Date(NaN);
        return dayOfISOWeekYear(year, week, dayOfWeek);
    }
    // Invalid ISO-formatted date
    return null;
}
function parseTime(timeString) {
    let hours;
    let minutes;
    // hh
    let token = patterns.HH.exec(timeString);
    if (token) {
        hours = parseFloat(token[1].replace(',', '.'));
        if (!validateTime(hours)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR;
    }
    // hh:mm or hhmm
    token = patterns.HHMM.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseFloat(token[2].replace(',', '.'));
        if (!validateTime(hours, minutes)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE;
    }
    // hh:mm:ss or hhmmss
    token = patterns.HHMMSS.exec(timeString);
    if (token) {
        hours = parseInt(token[1], 10);
        minutes = parseInt(token[2], 10);
        const seconds = parseFloat(token[3].replace(',', '.'));
        if (!validateTime(hours, minutes, seconds)) return NaN;
        return hours % 24 * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
    }
    // Invalid ISO-formatted time
    return null;
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
    week = week || 0;
    day = day || 0;
    const date = new Date(0);
    date.setUTCFullYear(isoWeekYear, 0, 4);
    const fourthOfJanuaryDay = date.getUTCDay() || 7;
    const diff = week * 7 + day + 1 - fourthOfJanuaryDay;
    date.setUTCDate(date.getUTCDate() + diff);
    return date;
}
// Validation functions
const DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
    if (month < 0 || month > 11) return false;
    if (date != null) {
        if (date < 1) return false;
        const isLeapYear = isLeapYearIndex(year);
        if (isLeapYear && date > DAYS_IN_MONTH_LEAP_YEAR[month]) return false;
        if (!isLeapYear && date > DAYS_IN_MONTH[month]) return false;
    }
    return true;
}
function validateDayOfYearDate(year, dayOfYear) {
    if (dayOfYear < 1) return false;
    const isLeapYear = isLeapYearIndex(year);
    if (isLeapYear && dayOfYear > 366) return false;
    if (!isLeapYear && dayOfYear > 365) return false;
    return true;
}
function validateWeekDate(week, day) {
    if (week < 0 || week > 52) return false;
    if (day != null && (day < 0 || day > 6)) return false;
    return true;
}
function validateTime(hours, minutes, seconds) {
    if (hours < 0 || hours >= 25) return false;
    if (minutes != null && (minutes < 0 || minutes >= 60)) return false;
    if (seconds != null && (seconds < 0 || seconds >= 60)) return false;
    return true;
}

},{"../_lib/getTimezoneOffsetInMilliseconds/index.js":"4bwM4","../_lib/tzParseTimezone/index.js":"86Mkh","../_lib/tzPattern/index.js":"44fK4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4bwM4":[function(require,module,exports,__globalThis) {
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTimezoneOffsetInMilliseconds", ()=>getTimezoneOffsetInMilliseconds);
function getTimezoneOffsetInMilliseconds(date) {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    utcDate.setUTCFullYear(date.getFullYear());
    return +date - +utcDate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"44fK4":[function(require,module,exports,__globalThis) {
/** Regex to identify the presence of a time zone specifier in a date string */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "tzPattern", ()=>tzPattern);
const tzPattern = /(Z|[+-]\d{2}(?::?\d{2})?| UTC| [a-zA-Z]+\/[a-zA-Z_]+(?:\/[a-zA-Z_]+)?)$/;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cIzOr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name formatInTimeZone
 * @category Time Zone Helpers
 * @summary Gets the offset in milliseconds between the time zone and Universal Coordinated Time (UTC)
 *
 * @param date the date representing the local time / real UTC time
 * @param timeZone the time zone this date should be formatted for; can be an offset or IANA time zone
 * @param formatStr the string of tokens
 * @param options the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link
 *   https://date-fns.org/docs/toDate}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See
 *   [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {Boolean} [options.awareOfUnicodeTokens=false] - if true, allows usage of Unicode tokens causes confusion:
 *   - Some of the day of year tokens (`D`, `DD`) that are confused with the day of month tokens (`d`, `dd`).
 *   - Some of the local week-numbering year tokens (`YY`, `YYYY`) that are confused with the calendar year tokens
 *   (`yy`, `yyyy`). See: https://git.io/fxCyr
 * @param {String} [options.timeZone=''] - used to specify the IANA time zone offset of a date String.
 */ parcelHelpers.export(exports, "formatInTimeZone", ()=>formatInTimeZone);
var _indexJs = require("../format/index.js");
var _indexJs1 = require("../toZonedTime/index.js");
function formatInTimeZone(date, timeZone, formatStr, options) {
    options = {
        ...options,
        timeZone,
        originalDate: date
    };
    return (0, _indexJs.format)((0, _indexJs1.toZonedTime)(date, timeZone, {
        timeZone: options.timeZone
    }), formatStr, options);
}

},{"../format/index.js":"7fSGh","../toZonedTime/index.js":"f2gxJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f2gxJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name toZonedTime
 * @category Time Zone Helpers
 * @summary Get a date/time representing local time in a given time zone from the UTC date
 *
 * @description
 * Returns a date instance with values representing the local time in the time zone
 * specified of the UTC time from the date provided. In other words, when the new date
 * is formatted it will show the equivalent hours in the target time zone regardless
 * of the current system time zone.
 *
 * @param date the date with the relevant UTC time
 * @param timeZone the time zone to get local time for, can be an offset or IANA time zone
 * @param options the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 *
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // In June 10am UTC is 6am in New York (-04:00)
 * const result = toZonedTime('2014-06-25T10:00:00.000Z', 'America/New_York')
 * //=> Jun 25 2014 06:00:00
 */ parcelHelpers.export(exports, "toZonedTime", ()=>toZonedTime);
var _indexJs = require("../_lib/tzParseTimezone/index.js");
var _indexJs1 = require("../toDate/index.js");
function toZonedTime(date, timeZone, options) {
    date = (0, _indexJs1.toDate)(date, options);
    const offsetMilliseconds = (0, _indexJs.tzParseTimezone)(timeZone, date, true);
    const d = new Date(date.getTime() - offsetMilliseconds);
    const resultDate = new Date(0);
    resultDate.setFullYear(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    resultDate.setHours(d.getUTCHours(), d.getUTCMinutes(), d.getUTCSeconds(), d.getUTCMilliseconds());
    return resultDate;
}

},{"../_lib/tzParseTimezone/index.js":"86Mkh","../toDate/index.js":"fsrFV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7uc4c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name fromZonedTime
 * @category Time Zone Helpers
 * @summary Get the UTC date/time from a date representing local time in a given time zone
 *
 * @description
 * Returns a date instance with the UTC time of the provided date of which the values
 * represented the local time in the time zone specified. In other words, if the input
 * date represented local time in time zone, the timestamp of the output date will
 * give the equivalent UTC of that local time regardless of the current system time zone.
 *
 * @param date the date with values representing the local time
 * @param timeZone the time zone of this local time, can be an offset or IANA time zone
 * @param options the object with options. See [Options]{@link https://date-fns.org/docs/Options}
 * @param {0|1|2} [options.additionalDigits=2] - passed to `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // In June 10am in Los Angeles is 5pm UTC
 * const result = fromZonedTime(new Date(2014, 5, 25, 10, 0, 0), 'America/Los_Angeles')
 * //=> 2014-06-25T17:00:00.000Z
 */ parcelHelpers.export(exports, "fromZonedTime", ()=>fromZonedTime);
var _indexJs = require("../toDate/index.js");
var _indexJs1 = require("../_lib/tzPattern/index.js");
var _indexJs2 = require("../_lib/tzParseTimezone/index.js");
var _indexJs3 = require("../_lib/newDateUTC/index.js");
function fromZonedTime(date, timeZone, options) {
    if (typeof date === 'string' && !date.match((0, _indexJs1.tzPattern))) return (0, _indexJs.toDate)(date, {
        ...options,
        timeZone
    });
    date = (0, _indexJs.toDate)(date, options);
    const utc = (0, _indexJs3.newDateUTC)(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()).getTime();
    const offsetMilliseconds = (0, _indexJs2.tzParseTimezone)(timeZone, new Date(utc));
    return new Date(utc + offsetMilliseconds);
}

},{"../toDate/index.js":"fsrFV","../_lib/tzPattern/index.js":"44fK4","../_lib/tzParseTimezone/index.js":"86Mkh","../_lib/newDateUTC/index.js":"cZ2zr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3AC4d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name getTimezoneOffset
 * @category Time Zone Helpers
 * @summary Gets the offset in milliseconds between the time zone and Universal Coordinated Time (UTC)
 *
 * @description
 * Returns the time zone offset from UTC time in milliseconds for IANA time zones as well
 * as other time zone offset string formats.
 *
 * For time zones where daylight savings time is applicable a `Date` should be passed on
 * the second parameter to ensure the offset correctly accounts for DST at that time of
 * year. When omitted, the current date is used.
 *
 * @param timeZone the time zone of this local time, can be an offset or IANA time zone
 * @param date the date with values representing the local time
 *
 * @example
 * const result = getTimezoneOffset('-07:00')
 *   //=> -18000000 (-7 * 60 * 60 * 1000)
 * const result = getTimezoneOffset('Africa/Johannesburg')
 *   //=> 7200000 (2 * 60 * 60 * 1000)
 * const result = getTimezoneOffset('America/New_York', new Date(2016, 0, 1))
 *   //=> -18000000 (-5 * 60 * 60 * 1000)
 * const result = getTimezoneOffset('America/New_York', new Date(2016, 6, 1))
 *   //=> -14400000 (-4 * 60 * 60 * 1000)
 */ parcelHelpers.export(exports, "getTimezoneOffset", ()=>getTimezoneOffset);
var _indexJs = require("../_lib/tzParseTimezone/index.js");
function getTimezoneOffset(timeZone, date) {
    return -(0, _indexJs.tzParseTimezone)(timeZone, date);
}

},{"../_lib/tzParseTimezone/index.js":"86Mkh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2P7h2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addMinutes} function options.
 */ /**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of minutes to be added.
 * @param options - An object with options
 *
 * @returns The new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */ parcelHelpers.export(exports, "addMinutes", ()=>addMinutes);
var _constantsJs = require("./constants.js");
var _toDateJs = require("./toDate.js");
function addMinutes(date, amount, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    _date.setTime(_date.getTime() + amount * (0, _constantsJs.millisecondsInMinute));
    return _date;
}
// Fallback for modularized imports:
exports.default = addMinutes;

},{"./constants.js":"2c8QU","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6d3x3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Rexports of internal for libraries to use.
// See: https://github.com/date-fns/date-fns/issues/3638#issuecomment-1877082874
parcelHelpers.export(exports, "longFormatters", ()=>(0, _longFormattersJs.longFormatters));
parcelHelpers.export(exports, "parsers", ()=>(0, _parsersJs.parsers));
/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangeably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear](https://date-fns.org/docs/setISOWeekYear)
 *    and [setWeekYear](https://date-fns.org/docs/setWeekYear)).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param dateStr - The string to parse
 * @param formatStr - The string of tokens
 * @param referenceDate - defines values missing from the parsed dateString
 * @param options - An object with options.
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @returns The parsed date
 *
 * @throws `options.locale` must contain `match` property
 * @throws use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */ parcelHelpers.export(exports, "parse", ()=>parse);
var _defaultLocaleJs = require("./_lib/defaultLocale.js");
var _longFormattersJs = require("./_lib/format/longFormatters.js");
var _protectedTokensJs = require("./_lib/protectedTokens.js");
var _constructFromJs = require("./constructFrom.js");
var _getDefaultOptionsJs = require("./getDefaultOptions.js");
var _toDateJs = require("./toDate.js");
var _setterJs = require("./parse/_lib/Setter.js");
var _parsersJs = require("./parse/_lib/parsers.js");
/**
 * The {@link parse} function options.
 */ // This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const notWhitespaceRegExp = /\S/;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse(dateStr, formatStr, referenceDate, options) {
    const invalidDate = ()=>(0, _constructFromJs.constructFrom)(options?.in || referenceDate, NaN);
    const defaultOptions = (0, _getDefaultOptionsJs.getDefaultOptions)();
    const locale = options?.locale ?? defaultOptions.locale ?? (0, _defaultLocaleJs.defaultLocale);
    const firstWeekContainsDate = options?.firstWeekContainsDate ?? options?.locale?.options?.firstWeekContainsDate ?? defaultOptions.firstWeekContainsDate ?? defaultOptions.locale?.options?.firstWeekContainsDate ?? 1;
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    if (!formatStr) return dateStr ? invalidDate() : (0, _toDateJs.toDate)(referenceDate, options?.in);
    const subFnOptions = {
        firstWeekContainsDate,
        weekStartsOn,
        locale
    };
    // If timezone isn't specified, it will try to use the context or
    // the reference date and fallback to the system time zone.
    const setters = [
        new (0, _setterJs.DateTimezoneSetter)(options?.in, referenceDate)
    ];
    const tokens = formatStr.match(longFormattingTokensRegExp).map((substring)=>{
        const firstCharacter = substring[0];
        if (firstCharacter in (0, _longFormattersJs.longFormatters)) {
            const longFormatter = (0, _longFormattersJs.longFormatters)[firstCharacter];
            return longFormatter(substring, locale.formatLong);
        }
        return substring;
    }).join("").match(formattingTokensRegExp);
    const usedTokens = [];
    for (let token of tokens){
        if (!options?.useAdditionalWeekYearTokens && (0, _protectedTokensJs.isProtectedWeekYearToken)(token)) (0, _protectedTokensJs.warnOrThrowProtectedError)(token, formatStr, dateStr);
        if (!options?.useAdditionalDayOfYearTokens && (0, _protectedTokensJs.isProtectedDayOfYearToken)(token)) (0, _protectedTokensJs.warnOrThrowProtectedError)(token, formatStr, dateStr);
        const firstCharacter = token[0];
        const parser = (0, _parsersJs.parsers)[firstCharacter];
        if (parser) {
            const { incompatibleTokens } = parser;
            if (Array.isArray(incompatibleTokens)) {
                const incompatibleToken = usedTokens.find((usedToken)=>incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter);
                if (incompatibleToken) throw new RangeError(`The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`);
            } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) throw new RangeError(`The format string mustn't contain \`${token}\` and any other token at the same time`);
            usedTokens.push({
                token: firstCharacter,
                fullToken: token
            });
            const parseResult = parser.run(dateStr, token, locale.match, subFnOptions);
            if (!parseResult) return invalidDate();
            setters.push(parseResult.setter);
            dateStr = parseResult.rest;
        } else {
            if (firstCharacter.match(unescapedLatinCharacterRegExp)) throw new RangeError("Format string contains an unescaped latin alphabet character `" + firstCharacter + "`");
            // Replace two single quote characters with one single quote character
            if (token === "''") token = "'";
            else if (firstCharacter === "'") token = cleanEscapedString(token);
            // Cut token from string, or, if string doesn't match the token, return Invalid Date
            if (dateStr.indexOf(token) === 0) dateStr = dateStr.slice(token.length);
            else return invalidDate();
        }
    }
    // Check if the remaining input contains something other than whitespace
    if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) return invalidDate();
    const uniquePrioritySetters = setters.map((setter)=>setter.priority).sort((a, b)=>b - a).filter((priority, index, array)=>array.indexOf(priority) === index).map((priority)=>setters.filter((setter)=>setter.priority === priority).sort((a, b)=>b.subPriority - a.subPriority)).map((setterArray)=>setterArray[0]);
    let date = (0, _toDateJs.toDate)(referenceDate, options?.in);
    if (isNaN(+date)) return invalidDate();
    const flags = {};
    for (const setter of uniquePrioritySetters){
        if (!setter.validate(date, subFnOptions)) return invalidDate();
        const result = setter.set(date, flags, subFnOptions);
        // Result is tuple (date, flags)
        if (Array.isArray(result)) {
            date = result[0];
            Object.assign(flags, result[1]);
        // Result is date
        } else date = result;
    }
    return date;
}
function cleanEscapedString(input) {
    return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
// Fallback for modularized imports:
exports.default = parse;

},{"./_lib/defaultLocale.js":[["defaultLocale","hbuPO","enUS"]],"./_lib/format/longFormatters.js":"lMm4k","./_lib/protectedTokens.js":"9HGYz","./constructFrom.js":"56Q4T","./getDefaultOptions.js":"4aY5h","./toDate.js":"3EhaA","./parse/_lib/Setter.js":"lJmWS","./parse/_lib/parsers.js":"bV2G0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lJmWS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Setter", ()=>Setter);
parcelHelpers.export(exports, "ValueSetter", ()=>ValueSetter);
parcelHelpers.export(exports, "DateTimezoneSetter", ()=>DateTimezoneSetter);
var _constructFromJs = require("../../constructFrom.js");
var _transposeJs = require("../../transpose.js");
const TIMEZONE_UNIT_PRIORITY = 10;
class Setter {
    subPriority = 0;
    validate(_utcDate, _options) {
        return true;
    }
}
class ValueSetter extends Setter {
    constructor(value, validateValue, setValue, priority, subPriority){
        super();
        this.value = value;
        this.validateValue = validateValue;
        this.setValue = setValue;
        this.priority = priority;
        if (subPriority) this.subPriority = subPriority;
    }
    validate(date, options) {
        return this.validateValue(date, this.value, options);
    }
    set(date, flags, options) {
        return this.setValue(date, flags, this.value, options);
    }
}
class DateTimezoneSetter extends Setter {
    priority = TIMEZONE_UNIT_PRIORITY;
    subPriority = -1;
    constructor(context, reference){
        super();
        this.context = context || ((date)=>(0, _constructFromJs.constructFrom)(reference, date));
    }
    set(date, flags) {
        if (flags.timestampIsSet) return date;
        return (0, _constructFromJs.constructFrom)(date, (0, _transposeJs.transpose)(date, this.context));
    }
}

},{"../../constructFrom.js":"56Q4T","../../transpose.js":"8vzTq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8vzTq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @name transpose
 * @category Generic Helpers
 * @summary Transpose the date to the given constructor.
 *
 * @description
 * The function transposes the date to the given constructor. It helps you
 * to transpose the date in the system time zone to say `UTCDate` or any other
 * date extension.
 *
 * @typeParam InputDate - The input `Date` type derived from the passed argument.
 * @typeParam ResultDate - The result `Date` type derived from the passed constructor.
 *
 * @param date - The date to use values from
 * @param constructor - The date constructor to use
 *
 * @returns Date transposed to the given constructor
 *
 * @example
 * // Create July 10, 2022 00:00 in locale time zone
 * const date = new Date(2022, 6, 10)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0800 (Singapore Standard Time)'
 *
 * @example
 * // Transpose the date to July 10, 2022 00:00 in UTC
 * transpose(date, UTCDate)
 * //=> 'Sun Jul 10 2022 00:00:00 GMT+0000 (Coordinated Universal Time)'
 */ parcelHelpers.export(exports, "transpose", ()=>transpose);
var _constructFromJs = require("./constructFrom.js");
function transpose(date, constructor) {
    const date_ = isConstructor(constructor) ? new constructor(0) : (0, _constructFromJs.constructFrom)(constructor, 0);
    date_.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
    date_.setHours(date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds());
    return date_;
}
function isConstructor(constructor) {
    return typeof constructor === "function" && constructor.prototype?.constructor === constructor;
}
// Fallback for modularized imports:
exports.default = transpose;

},{"./constructFrom.js":"56Q4T","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bV2G0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "parsers", ()=>parsers);
var _eraParserJs = require("./parsers/EraParser.js");
var _yearParserJs = require("./parsers/YearParser.js");
var _localWeekYearParserJs = require("./parsers/LocalWeekYearParser.js");
var _isoweekYearParserJs = require("./parsers/ISOWeekYearParser.js");
var _extendedYearParserJs = require("./parsers/ExtendedYearParser.js");
var _quarterParserJs = require("./parsers/QuarterParser.js");
var _standAloneQuarterParserJs = require("./parsers/StandAloneQuarterParser.js");
var _monthParserJs = require("./parsers/MonthParser.js");
var _standAloneMonthParserJs = require("./parsers/StandAloneMonthParser.js");
var _localWeekParserJs = require("./parsers/LocalWeekParser.js");
var _isoweekParserJs = require("./parsers/ISOWeekParser.js");
var _dateParserJs = require("./parsers/DateParser.js");
var _dayOfYearParserJs = require("./parsers/DayOfYearParser.js");
var _dayParserJs = require("./parsers/DayParser.js");
var _localDayParserJs = require("./parsers/LocalDayParser.js");
var _standAloneLocalDayParserJs = require("./parsers/StandAloneLocalDayParser.js");
var _isodayParserJs = require("./parsers/ISODayParser.js");
var _ampmparserJs = require("./parsers/AMPMParser.js");
var _ampmmidnightParserJs = require("./parsers/AMPMMidnightParser.js");
var _dayPeriodParserJs = require("./parsers/DayPeriodParser.js");
var _hour1To12ParserJs = require("./parsers/Hour1to12Parser.js");
var _hour0To23ParserJs = require("./parsers/Hour0to23Parser.js");
var _hour0To11ParserJs = require("./parsers/Hour0To11Parser.js");
var _hour1To24ParserJs = require("./parsers/Hour1To24Parser.js");
var _minuteParserJs = require("./parsers/MinuteParser.js");
var _secondParserJs = require("./parsers/SecondParser.js");
var _fractionOfSecondParserJs = require("./parsers/FractionOfSecondParser.js");
var _isotimezoneWithZParserJs = require("./parsers/ISOTimezoneWithZParser.js");
var _isotimezoneParserJs = require("./parsers/ISOTimezoneParser.js");
var _timestampSecondsParserJs = require("./parsers/TimestampSecondsParser.js");
var _timestampMillisecondsParserJs = require("./parsers/TimestampMillisecondsParser.js");
const parsers = {
    G: new (0, _eraParserJs.EraParser)(),
    y: new (0, _yearParserJs.YearParser)(),
    Y: new (0, _localWeekYearParserJs.LocalWeekYearParser)(),
    R: new (0, _isoweekYearParserJs.ISOWeekYearParser)(),
    u: new (0, _extendedYearParserJs.ExtendedYearParser)(),
    Q: new (0, _quarterParserJs.QuarterParser)(),
    q: new (0, _standAloneQuarterParserJs.StandAloneQuarterParser)(),
    M: new (0, _monthParserJs.MonthParser)(),
    L: new (0, _standAloneMonthParserJs.StandAloneMonthParser)(),
    w: new (0, _localWeekParserJs.LocalWeekParser)(),
    I: new (0, _isoweekParserJs.ISOWeekParser)(),
    d: new (0, _dateParserJs.DateParser)(),
    D: new (0, _dayOfYearParserJs.DayOfYearParser)(),
    E: new (0, _dayParserJs.DayParser)(),
    e: new (0, _localDayParserJs.LocalDayParser)(),
    c: new (0, _standAloneLocalDayParserJs.StandAloneLocalDayParser)(),
    i: new (0, _isodayParserJs.ISODayParser)(),
    a: new (0, _ampmparserJs.AMPMParser)(),
    b: new (0, _ampmmidnightParserJs.AMPMMidnightParser)(),
    B: new (0, _dayPeriodParserJs.DayPeriodParser)(),
    h: new (0, _hour1To12ParserJs.Hour1to12Parser)(),
    H: new (0, _hour0To23ParserJs.Hour0to23Parser)(),
    K: new (0, _hour0To11ParserJs.Hour0To11Parser)(),
    k: new (0, _hour1To24ParserJs.Hour1To24Parser)(),
    m: new (0, _minuteParserJs.MinuteParser)(),
    s: new (0, _secondParserJs.SecondParser)(),
    S: new (0, _fractionOfSecondParserJs.FractionOfSecondParser)(),
    X: new (0, _isotimezoneWithZParserJs.ISOTimezoneWithZParser)(),
    x: new (0, _isotimezoneParserJs.ISOTimezoneParser)(),
    t: new (0, _timestampSecondsParserJs.TimestampSecondsParser)(),
    T: new (0, _timestampMillisecondsParserJs.TimestampMillisecondsParser)()
};

},{"./parsers/EraParser.js":"J6rYH","./parsers/YearParser.js":"jIXNL","./parsers/LocalWeekYearParser.js":"2X3C9","./parsers/ISOWeekYearParser.js":"7xsGG","./parsers/ExtendedYearParser.js":"cNFP8","./parsers/QuarterParser.js":"l7G6y","./parsers/StandAloneQuarterParser.js":"4gkBP","./parsers/MonthParser.js":"1ASit","./parsers/StandAloneMonthParser.js":"aqwKp","./parsers/LocalWeekParser.js":"3vrfp","./parsers/ISOWeekParser.js":"UX0tK","./parsers/DateParser.js":"fG35C","./parsers/DayOfYearParser.js":"g0N3C","./parsers/DayParser.js":"d3tpG","./parsers/LocalDayParser.js":"8Kx2m","./parsers/StandAloneLocalDayParser.js":"f80cj","./parsers/ISODayParser.js":"4Fga8","./parsers/AMPMParser.js":"cgad6","./parsers/AMPMMidnightParser.js":"dNFEz","./parsers/DayPeriodParser.js":"fHbt0","./parsers/Hour1to12Parser.js":"eaFb3","./parsers/Hour0to23Parser.js":"jFJrc","./parsers/Hour0To11Parser.js":"2ZQDe","./parsers/Hour1To24Parser.js":"eXZUC","./parsers/MinuteParser.js":"a5SBN","./parsers/SecondParser.js":"kEUE1","./parsers/FractionOfSecondParser.js":"bgyUX","./parsers/ISOTimezoneWithZParser.js":"9SV93","./parsers/ISOTimezoneParser.js":"kDJTH","./parsers/TimestampSecondsParser.js":"ldQiO","./parsers/TimestampMillisecondsParser.js":"5KjwH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"J6rYH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EraParser", ()=>EraParser);
var _parserJs = require("../Parser.js");
class EraParser extends (0, _parserJs.Parser) {
    priority = 140;
    parse(dateString, token, match) {
        switch(token){
            // AD, BC
            case "G":
            case "GG":
            case "GGG":
                return match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
            // A, B
            case "GGGGG":
                return match.era(dateString, {
                    width: "narrow"
                });
            // Anno Domini, Before Christ
            case "GGGG":
            default:
                return match.era(dateString, {
                    width: "wide"
                }) || match.era(dateString, {
                    width: "abbreviated"
                }) || match.era(dateString, {
                    width: "narrow"
                });
        }
    }
    set(date, flags, value) {
        flags.era = value;
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "R",
        "u",
        "t",
        "T"
    ];
}

},{"../Parser.js":"5V2kM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5V2kM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Parser", ()=>Parser);
var _setterJs = require("./Setter.js");
class Parser {
    run(dateString, token, match, options) {
        const result = this.parse(dateString, token, match, options);
        if (!result) return null;
        return {
            setter: new (0, _setterJs.ValueSetter)(result.value, this.validate, this.set, this.priority, this.subPriority),
            rest: result.rest
        };
    }
    validate(_utcDate, _value, _options) {
        return true;
    }
}

},{"./Setter.js":"lJmWS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jIXNL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
parcelHelpers.export(exports, "YearParser", ()=>YearParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class YearParser extends (0, _parserJs.Parser) {
    priority = 130;
    incompatibleTokens = [
        "Y",
        "R",
        "u",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year,
                isTwoDigitYear: token === "yy"
            });
        switch(token){
            case "y":
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
            case "yo":
                return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value) {
        const currentYear = date.getFullYear();
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, 1);
            date.setHours(0, 0, 0, 0);
            return date;
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}

},{"../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lNy5I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mapValue", ()=>mapValue);
parcelHelpers.export(exports, "parseNumericPattern", ()=>parseNumericPattern);
parcelHelpers.export(exports, "parseTimezonePattern", ()=>parseTimezonePattern);
parcelHelpers.export(exports, "parseAnyDigitsSigned", ()=>parseAnyDigitsSigned);
parcelHelpers.export(exports, "parseNDigits", ()=>parseNDigits);
parcelHelpers.export(exports, "parseNDigitsSigned", ()=>parseNDigitsSigned);
parcelHelpers.export(exports, "dayPeriodEnumToHours", ()=>dayPeriodEnumToHours);
parcelHelpers.export(exports, "normalizeTwoDigitYear", ()=>normalizeTwoDigitYear);
parcelHelpers.export(exports, "isLeapYearIndex", ()=>isLeapYearIndex);
var _constantsJs = require("../../constants.js");
var _constantsJs1 = require("./constants.js");
function mapValue(parseFnResult, mapFn) {
    if (!parseFnResult) return parseFnResult;
    return {
        value: mapFn(parseFnResult.value),
        rest: parseFnResult.rest
    };
}
function parseNumericPattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    return {
        value: parseInt(matchResult[0], 10),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseTimezonePattern(pattern, dateString) {
    const matchResult = dateString.match(pattern);
    if (!matchResult) return null;
    // Input is 'Z'
    if (matchResult[0] === "Z") return {
        value: 0,
        rest: dateString.slice(1)
    };
    const sign = matchResult[1] === "+" ? 1 : -1;
    const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
    const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
    const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
    return {
        value: sign * (hours * (0, _constantsJs.millisecondsInHour) + minutes * (0, _constantsJs.millisecondsInMinute) + seconds * (0, _constantsJs.millisecondsInSecond)),
        rest: dateString.slice(matchResult[0].length)
    };
}
function parseAnyDigitsSigned(dateString) {
    return parseNumericPattern((0, _constantsJs1.numericPatterns).anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs1.numericPatterns).singleDigit, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs1.numericPatterns).twoDigits, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs1.numericPatterns).threeDigits, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs1.numericPatterns).fourDigits, dateString);
        default:
            return parseNumericPattern(new RegExp("^\\d{1," + n + "}"), dateString);
    }
}
function parseNDigitsSigned(n, dateString) {
    switch(n){
        case 1:
            return parseNumericPattern((0, _constantsJs1.numericPatterns).singleDigitSigned, dateString);
        case 2:
            return parseNumericPattern((0, _constantsJs1.numericPatterns).twoDigitsSigned, dateString);
        case 3:
            return parseNumericPattern((0, _constantsJs1.numericPatterns).threeDigitsSigned, dateString);
        case 4:
            return parseNumericPattern((0, _constantsJs1.numericPatterns).fourDigitsSigned, dateString);
        default:
            return parseNumericPattern(new RegExp("^-?\\d{1," + n + "}"), dateString);
    }
}
function dayPeriodEnumToHours(dayPeriod) {
    switch(dayPeriod){
        case "morning":
            return 4;
        case "evening":
            return 17;
        case "pm":
        case "noon":
        case "afternoon":
            return 12;
        case "am":
        case "midnight":
        case "night":
        default:
            return 0;
    }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
    const isCommonEra = currentYear > 0;
    // Absolute number of the current year:
    // 1 -> 1 AC
    // 0 -> 1 BC
    // -1 -> 2 BC
    const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
    let result;
    if (absCurrentYear <= 50) result = twoDigitYear || 100;
    else {
        const rangeEnd = absCurrentYear + 50;
        const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
        const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
        result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
    }
    return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex(year) {
    return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

},{"../../constants.js":"2c8QU","./constants.js":"gvUWU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gvUWU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numericPatterns", ()=>numericPatterns);
parcelHelpers.export(exports, "timezonePatterns", ()=>timezonePatterns);
const numericPatterns = {
    month: /^(1[0-2]|0?\d)/,
    date: /^(3[0-1]|[0-2]?\d)/,
    dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
    week: /^(5[0-3]|[0-4]?\d)/,
    hour23h: /^(2[0-3]|[0-1]?\d)/,
    hour24h: /^(2[0-4]|[0-1]?\d)/,
    hour11h: /^(1[0-1]|0?\d)/,
    hour12h: /^(1[0-2]|0?\d)/,
    minute: /^[0-5]?\d/,
    second: /^[0-5]?\d/,
    singleDigit: /^\d/,
    twoDigits: /^\d{1,2}/,
    threeDigits: /^\d{1,3}/,
    fourDigits: /^\d{1,4}/,
    anyDigitsSigned: /^-?\d+/,
    singleDigitSigned: /^-?\d/,
    twoDigitsSigned: /^-?\d{1,2}/,
    threeDigitsSigned: /^-?\d{1,3}/,
    fourDigitsSigned: /^-?\d{1,4}/
};
const timezonePatterns = {
    basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
    basic: /^([+-])(\d{2})(\d{2})|Z/,
    basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
    extended: /^([+-])(\d{2}):(\d{2})|Z/,
    extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2X3C9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Local week-numbering year
parcelHelpers.export(exports, "LocalWeekYearParser", ()=>LocalWeekYearParser);
var _getWeekYearJs = require("../../../getWeekYear.js");
var _startOfWeekJs = require("../../../startOfWeek.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class LocalWeekYearParser extends (0, _parserJs.Parser) {
    priority = 130;
    parse(dateString, token, match) {
        const valueCallback = (year)=>({
                year,
                isTwoDigitYear: token === "YY"
            });
        switch(token){
            case "Y":
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(4, dateString), valueCallback);
            case "Yo":
                return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                    unit: "year"
                }), valueCallback);
            default:
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
        }
    }
    validate(_date, value) {
        return value.isTwoDigitYear || value.year > 0;
    }
    set(date, flags, value, options) {
        const currentYear = (0, _getWeekYearJs.getWeekYear)(date, options);
        if (value.isTwoDigitYear) {
            const normalizedTwoDigitYear = (0, _utilsJs.normalizeTwoDigitYear)(value.year, currentYear);
            date.setFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
            date.setHours(0, 0, 0, 0);
            return (0, _startOfWeekJs.startOfWeek)(date, options);
        }
        const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
        date.setFullYear(year, 0, options.firstWeekContainsDate);
        date.setHours(0, 0, 0, 0);
        return (0, _startOfWeekJs.startOfWeek)(date, options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}

},{"../../../getWeekYear.js":"jGQkU","../../../startOfWeek.js":"i3N4r","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7xsGG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// ISO week-numbering year
parcelHelpers.export(exports, "ISOWeekYearParser", ()=>ISOWeekYearParser);
var _startOfISOWeekJs = require("../../../startOfISOWeek.js");
var _constructFromJs = require("../../../constructFrom.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class ISOWeekYearParser extends (0, _parserJs.Parser) {
    priority = 130;
    parse(dateString, token) {
        if (token === "R") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
        return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        const firstWeekOfYear = (0, _constructFromJs.constructFrom)(date, 0);
        firstWeekOfYear.setFullYear(value, 0, 4);
        firstWeekOfYear.setHours(0, 0, 0, 0);
        return (0, _startOfISOWeekJs.startOfISOWeek)(firstWeekOfYear);
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "u",
        "Q",
        "q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}

},{"../../../startOfISOWeek.js":"gaVGB","../../../constructFrom.js":"56Q4T","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cNFP8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExtendedYearParser", ()=>ExtendedYearParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class ExtendedYearParser extends (0, _parserJs.Parser) {
    priority = 130;
    parse(dateString, token) {
        if (token === "u") return (0, _utilsJs.parseNDigitsSigned)(4, dateString);
        return (0, _utilsJs.parseNDigitsSigned)(token.length, dateString);
    }
    set(date, _flags, value) {
        date.setFullYear(value, 0, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "G",
        "y",
        "Y",
        "R",
        "w",
        "I",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

},{"../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l7G6y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QuarterParser", ()=>QuarterParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class QuarterParser extends (0, _parserJs.Parser) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "Q":
            case "QQ":
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "Qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "QQQ":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "QQQQQ":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // 1st quarter, 2nd quarter, ...
            case "QQQQ":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

},{"../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4gkBP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneQuarterParser", ()=>StandAloneQuarterParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class StandAloneQuarterParser extends (0, _parserJs.Parser) {
    priority = 120;
    parse(dateString, token, match) {
        switch(token){
            // 1, 2, 3, 4
            case "q":
            case "qq":
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
            // 1st, 2nd, 3rd, 4th
            case "qo":
                return match.ordinalNumber(dateString, {
                    unit: "quarter"
                });
            // Q1, Q2, Q3, Q4
            case "qqq":
                return match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1, 2, 3, 4 (narrow quarter; could be not numerical)
            case "qqqqq":
                return match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // 1st quarter, 2nd quarter, ...
            case "qqqq":
            default:
                return match.quarter(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.quarter(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 4;
    }
    set(date, _flags, value) {
        date.setMonth((value - 1) * 3, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

},{"../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1ASit":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MonthParser", ()=>MonthParser);
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class MonthParser extends (0, _parserJs.Parser) {
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "L",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "M":
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "MM":
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Mo":
                return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "MMM":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // J, F, ..., D
            case "MMMMM":
                return match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // January, February, ..., December
            case "MMMM":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
}

},{"../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aqwKp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "StandAloneMonthParser", ()=>StandAloneMonthParser);
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class StandAloneMonthParser extends (0, _parserJs.Parser) {
    priority = 110;
    parse(dateString, token, match) {
        const valueCallback = (value)=>value - 1;
        switch(token){
            // 1, 2, ..., 12
            case "L":
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).month, dateString), valueCallback);
            // 01, 02, ..., 12
            case "LL":
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(2, dateString), valueCallback);
            // 1st, 2nd, ..., 12th
            case "Lo":
                return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                    unit: "month"
                }), valueCallback);
            // Jan, Feb, ..., Dec
            case "LLL":
                return match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // J, F, ..., D
            case "LLLLL":
                return match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // January, February, ..., December
            case "LLLL":
            default:
                return match.month(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.month(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        date.setMonth(value, 1);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

},{"../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3vrfp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Local week of year
parcelHelpers.export(exports, "LocalWeekParser", ()=>LocalWeekParser);
var _setWeekJs = require("../../../setWeek.js");
var _startOfWeekJs = require("../../../startOfWeek.js");
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class LocalWeekParser extends (0, _parserJs.Parser) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "w":
                return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
            case "wo":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value, options) {
        return (0, _startOfWeekJs.startOfWeek)((0, _setWeekJs.setWeek)(date, value, options), options);
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "i",
        "t",
        "T"
    ];
}

},{"../../../setWeek.js":"qG4iW","../../../startOfWeek.js":"i3N4r","../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"qG4iW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link setWeek} function options.
 */ /**
 * @name setWeek
 * @category Week Helpers
 * @summary Set the local week to the given date.
 *
 * @description
 * Set the local week to the given date, saving the weekday number.
 * The exact calculation depends on the values of
 * `options.weekStartsOn` (which is the index of the first day of the week)
 * and `options.firstWeekContainsDate` (which is the day of January, which is always in
 * the first week of the week-numbering year)
 *
 * Week numbering: https://en.wikipedia.org/wiki/Week#The_ISO_week_date_system
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param week - The week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the local week set
 *
 * @example
 * // Set the 1st week to 2 January 2005 with default options:
 * const result = setWeek(new Date(2005, 0, 2), 1)
 * //=> Sun Dec 26 2004 00:00:00
 *
 * @example
 * // Set the 1st week to 2 January 2005,
 * // if Monday is the first day of the week,
 * // and the first week of the year always contains 4 January:
 * const result = setWeek(new Date(2005, 0, 2), 1, {
 *   weekStartsOn: 1,
 *   firstWeekContainsDate: 4
 * })
 * //=> Sun Jan 4 2004 00:00:00
 */ parcelHelpers.export(exports, "setWeek", ()=>setWeek);
var _getWeekJs = require("./getWeek.js");
var _toDateJs = require("./toDate.js");
function setWeek(date, week, options) {
    const date_ = (0, _toDateJs.toDate)(date, options?.in);
    const diff = (0, _getWeekJs.getWeek)(date_, options) - week;
    date_.setDate(date_.getDate() - diff * 7);
    return (0, _toDateJs.toDate)(date_, options?.in);
}
// Fallback for modularized imports:
exports.default = setWeek;

},{"./getWeek.js":"bqzpI","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"UX0tK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// ISO week of year
parcelHelpers.export(exports, "ISOWeekParser", ()=>ISOWeekParser);
var _setISOWeekJs = require("../../../setISOWeek.js");
var _startOfISOWeekJs = require("../../../startOfISOWeek.js");
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class ISOWeekParser extends (0, _parserJs.Parser) {
    priority = 100;
    parse(dateString, token, match) {
        switch(token){
            case "I":
                return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).week, dateString);
            case "Io":
                return match.ordinalNumber(dateString, {
                    unit: "week"
                });
            default:
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 53;
    }
    set(date, _flags, value) {
        return (0, _startOfISOWeekJs.startOfISOWeek)((0, _setISOWeekJs.setISOWeek)(date, value));
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "e",
        "c",
        "t",
        "T"
    ];
}

},{"../../../setISOWeek.js":"jPtts","../../../startOfISOWeek.js":"gaVGB","../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jPtts":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link setISOWeek} function options.
 */ /**
 * @name setISOWeek
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The `Date` type of the context function.
 *
 * @param date - The date to be changed
 * @param week - The ISO week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the ISO week set
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * const result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */ parcelHelpers.export(exports, "setISOWeek", ()=>setISOWeek);
var _getISOWeekJs = require("./getISOWeek.js");
var _toDateJs = require("./toDate.js");
function setISOWeek(date, week, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    const diff = (0, _getISOWeekJs.getISOWeek)(_date, options) - week;
    _date.setDate(_date.getDate() - diff * 7);
    return _date;
}
// Fallback for modularized imports:
exports.default = setISOWeek;

},{"./getISOWeek.js":"946sx","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fG35C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Day of the month
parcelHelpers.export(exports, "DateParser", ()=>DateParser);
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
const DAYS_IN_MONTH = [
    31,
    28,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
const DAYS_IN_MONTH_LEAP_YEAR = [
    31,
    29,
    31,
    30,
    31,
    30,
    31,
    31,
    30,
    31,
    30,
    31
];
class DateParser extends (0, _parserJs.Parser) {
    priority = 90;
    subPriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "d":
                return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).date, dateString);
            case "do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
        const month = date.getMonth();
        if (isLeapYear) return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
        else return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
    set(date, _flags, value) {
        date.setDate(value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "w",
        "I",
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

},{"../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g0N3C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DayOfYearParser", ()=>DayOfYearParser);
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class DayOfYearParser extends (0, _parserJs.Parser) {
    priority = 90;
    subpriority = 1;
    parse(dateString, token, match) {
        switch(token){
            case "D":
            case "DD":
                return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).dayOfYear, dateString);
            case "Do":
                return match.ordinalNumber(dateString, {
                    unit: "date"
                });
            default:
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
        }
    }
    validate(date, value) {
        const year = date.getFullYear();
        const isLeapYear = (0, _utilsJs.isLeapYearIndex)(year);
        if (isLeapYear) return value >= 1 && value <= 366;
        else return value >= 1 && value <= 365;
    }
    set(date, _flags, value) {
        date.setMonth(0, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "Y",
        "R",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "I",
        "d",
        "E",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

},{"../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d3tpG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Day of week
parcelHelpers.export(exports, "DayParser", ()=>DayParser);
var _setDayJs = require("../../../setDay.js");
var _parserJs = require("../Parser.js");
class DayParser extends (0, _parserJs.Parser) {
    priority = 90;
    parse(dateString, token, match) {
        switch(token){
            // Tue
            case "E":
            case "EE":
            case "EEE":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "EEEEE":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "EEEEEE":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "EEEE":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, _setDayJs.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "D",
        "i",
        "e",
        "c",
        "t",
        "T"
    ];
}

},{"../../../setDay.js":"7TrKB","../Parser.js":"5V2kM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7TrKB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link setDay} function options.
 */ /**
 * @name setDay
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param day - The day of the week of the new date
 * @param options - An object with options.
 *
 * @returns The new date with the day of the week set
 *
 * @example
 * // Set week day to Sunday, with the default weekStartsOn of Sunday:
 * const result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // Set week day to Sunday, with a weekStartsOn of Monday:
 * const result = setDay(new Date(2014, 8, 1), 0, { weekStartsOn: 1 })
 * //=> Sun Sep 07 2014 00:00:00
 */ parcelHelpers.export(exports, "setDay", ()=>setDay);
var _defaultOptionsJs = require("./_lib/defaultOptions.js");
var _addDaysJs = require("./addDays.js");
var _toDateJs = require("./toDate.js");
function setDay(date, day, options) {
    const defaultOptions = (0, _defaultOptionsJs.getDefaultOptions)();
    const weekStartsOn = options?.weekStartsOn ?? options?.locale?.options?.weekStartsOn ?? defaultOptions.weekStartsOn ?? defaultOptions.locale?.options?.weekStartsOn ?? 0;
    const date_ = (0, _toDateJs.toDate)(date, options?.in);
    const currentDay = date_.getDay();
    const remainder = day % 7;
    const dayIndex = (remainder + 7) % 7;
    const delta = 7 - weekStartsOn;
    const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
    return (0, _addDaysJs.addDays)(date_, diff, options);
}
// Fallback for modularized imports:
exports.default = setDay;

},{"./_lib/defaultOptions.js":"gg1YU","./addDays.js":"egQdw","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"egQdw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link addDays} function options.
 */ /**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * **You don't need date-fns\***:
 *
 * Temporal has a built-in `add` method on all its classes:
 *
 * - [`Temporal.Instant.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/Instant/add)
 * - [`Temporal.PlainDate.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainDate/add)
 * - [`Temporal.PlainDateTime.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainDateTime/add)
 * - [`Temporal.PlainTime.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainTime/add)
 * - [`Temporal.PlainYearMonth.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/PlainYearMonth/add)
 * - [`Temporal.ZonedDateTime.prototype.add()`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Temporal/ZonedDateTime/add)
 *
 * \* **Not really**, see: https://date-fns.org/you-dont-need-date-fns
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param amount - The amount of days to be added.
 * @param options - An object with options
 *
 * @returns The new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 *
 * @example
 * // Using Temporal:
 * // Add 10 days to 1 September 2014:
 * Temporal.PlainDate.from("2014-09-01").add({ days: 10 }).toString();
 * //=> "2014-09-11"
 */ parcelHelpers.export(exports, "addDays", ()=>addDays);
var _constructFromJs = require("./constructFrom.js");
var _toDateJs = require("./toDate.js");
function addDays(date, amount, options) {
    const _date = (0, _toDateJs.toDate)(date, options?.in);
    if (isNaN(amount)) return (0, _constructFromJs.constructFrom)(options?.in || date, NaN);
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    if (!amount) return _date;
    _date.setDate(_date.getDate() + amount);
    return _date;
}
// Fallback for modularized imports:
exports.default = addDays;

},{"./constructFrom.js":"56Q4T","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Kx2m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Local day of week
parcelHelpers.export(exports, "LocalDayParser", ()=>LocalDayParser);
var _setDayJs = require("../../../setDay.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class LocalDayParser extends (0, _parserJs.Parser) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "e":
            case "ee":
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "eo":
                return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "eee":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // T
            case "eeeee":
                return match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tu
            case "eeeeee":
                return match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            // Tuesday
            case "eeee":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, _setDayJs.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "c",
        "t",
        "T"
    ];
}

},{"../../../setDay.js":"7TrKB","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f80cj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Stand-alone local day of week
parcelHelpers.export(exports, "StandAloneLocalDayParser", ()=>StandAloneLocalDayParser);
var _setDayJs = require("../../../setDay.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class StandAloneLocalDayParser extends (0, _parserJs.Parser) {
    priority = 90;
    parse(dateString, token, match, options) {
        const valueCallback = (value)=>{
            // We want here floor instead of trunc, so we get -7 for value 0 instead of 0
            const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
            return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
        };
        switch(token){
            // 3
            case "c":
            case "cc":
                return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
            // 3rd
            case "co":
                return (0, _utilsJs.mapValue)(match.ordinalNumber(dateString, {
                    unit: "day"
                }), valueCallback);
            // Tue
            case "ccc":
                return match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // T
            case "ccccc":
                return match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tu
            case "cccccc":
                return match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
            // Tuesday
            case "cccc":
            default:
                return match.day(dateString, {
                    width: "wide",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "short",
                    context: "standalone"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "standalone"
                });
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 6;
    }
    set(date, _flags, value, options) {
        date = (0, _setDayJs.setDay)(date, value, options);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "R",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "I",
        "d",
        "D",
        "E",
        "i",
        "e",
        "t",
        "T"
    ];
}

},{"../../../setDay.js":"7TrKB","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Fga8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// ISO day of week
parcelHelpers.export(exports, "ISODayParser", ()=>ISODayParser);
var _setISODayJs = require("../../../setISODay.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class ISODayParser extends (0, _parserJs.Parser) {
    priority = 90;
    parse(dateString, token, match) {
        const valueCallback = (value)=>{
            if (value === 0) return 7;
            return value;
        };
        switch(token){
            // 2
            case "i":
            case "ii":
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
            // 2nd
            case "io":
                return match.ordinalNumber(dateString, {
                    unit: "day"
                });
            // Tue
            case "iii":
                return (0, _utilsJs.mapValue)(match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // T
            case "iiiii":
                return (0, _utilsJs.mapValue)(match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tu
            case "iiiiii":
                return (0, _utilsJs.mapValue)(match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
            // Tuesday
            case "iiii":
            default:
                return (0, _utilsJs.mapValue)(match.day(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "short",
                    context: "formatting"
                }) || match.day(dateString, {
                    width: "narrow",
                    context: "formatting"
                }), valueCallback);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 7;
    }
    set(date, _flags, value) {
        date = (0, _setISODayJs.setISODay)(date, value);
        date.setHours(0, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "y",
        "Y",
        "u",
        "q",
        "Q",
        "M",
        "L",
        "w",
        "d",
        "D",
        "E",
        "e",
        "c",
        "t",
        "T"
    ];
}

},{"../../../setISODay.js":"8HEvp","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8HEvp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link setISODay} function options.
 */ /**
 * @name setISODay
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday, etc.
 *
 * @typeParam DateType - The `Date` type, the function operates on. Gets inferred from passed arguments. Allows to use extensions like [`UTCDate`](https://github.com/date-fns/utc).
 * @typeParam ResultDate - The result `Date` type, it is the type returned from the context function if it is passed, or inferred from the arguments.
 *
 * @param date - The date to be changed
 * @param day - The day of the ISO week of the new date
 * @param options - An object with options
 *
 * @returns The new date with the day of the ISO week set
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * const result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */ parcelHelpers.export(exports, "setISODay", ()=>setISODay);
var _addDaysJs = require("./addDays.js");
var _getISODayJs = require("./getISODay.js");
var _toDateJs = require("./toDate.js");
function setISODay(date, day, options) {
    const date_ = (0, _toDateJs.toDate)(date, options?.in);
    const currentDay = (0, _getISODayJs.getISODay)(date_, options);
    const diff = day - currentDay;
    return (0, _addDaysJs.addDays)(date_, diff, options);
}
// Fallback for modularized imports:
exports.default = setISODay;

},{"./addDays.js":"egQdw","./getISODay.js":"lUBmu","./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lUBmu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * The {@link getISODay} function options.
 */ /**
 * @name getISODay
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param date - The given date
 * @param options - An object with options
 *
 * @returns The day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * const result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */ parcelHelpers.export(exports, "getISODay", ()=>getISODay);
var _toDateJs = require("./toDate.js");
function getISODay(date, options) {
    const day = (0, _toDateJs.toDate)(date, options?.in).getDay();
    return day === 0 ? 7 : day;
}
// Fallback for modularized imports:
exports.default = getISODay;

},{"./toDate.js":"3EhaA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cgad6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMParser", ()=>AMPMParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class AMPMParser extends (0, _parserJs.Parser) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "a":
            case "aa":
            case "aaa":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaaa":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "aaaa":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "b",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}

},{"../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dNFEz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AMPMMidnightParser", ()=>AMPMMidnightParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class AMPMMidnightParser extends (0, _parserJs.Parser) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "b":
            case "bb":
            case "bbb":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbbb":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "bbbb":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "B",
        "H",
        "k",
        "t",
        "T"
    ];
}

},{"../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fHbt0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// in the morning, in the afternoon, in the evening, at night
parcelHelpers.export(exports, "DayPeriodParser", ()=>DayPeriodParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class DayPeriodParser extends (0, _parserJs.Parser) {
    priority = 80;
    parse(dateString, token, match) {
        switch(token){
            case "B":
            case "BB":
            case "BBB":
                return match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBBB":
                return match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
            case "BBBB":
            default:
                return match.dayPeriod(dateString, {
                    width: "wide",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "abbreviated",
                    context: "formatting"
                }) || match.dayPeriod(dateString, {
                    width: "narrow",
                    context: "formatting"
                });
        }
    }
    set(date, _flags, value) {
        date.setHours((0, _utilsJs.dayPeriodEnumToHours)(value), 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "t",
        "T"
    ];
}

},{"../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eaFb3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1to12Parser", ()=>Hour1to12Parser);
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class Hour1to12Parser extends (0, _parserJs.Parser) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "h":
                return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour12h, dateString);
            case "ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 12;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else if (!isPM && value === 12) date.setHours(0, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "H",
        "K",
        "k",
        "t",
        "T"
    ];
}

},{"../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jFJrc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0to23Parser", ()=>Hour0to23Parser);
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class Hour0to23Parser extends (0, _parserJs.Parser) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "H":
                return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour23h, dateString);
            case "Ho":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 23;
    }
    set(date, _flags, value) {
        date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "K",
        "k",
        "t",
        "T"
    ];
}

},{"../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2ZQDe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour0To11Parser", ()=>Hour0To11Parser);
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class Hour0To11Parser extends (0, _parserJs.Parser) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "K":
                return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour11h, dateString);
            case "Ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 11;
    }
    set(date, _flags, value) {
        const isPM = date.getHours() >= 12;
        if (isPM && value < 12) date.setHours(value + 12, 0, 0, 0);
        else date.setHours(value, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "h",
        "H",
        "k",
        "t",
        "T"
    ];
}

},{"../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eXZUC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Hour1To24Parser", ()=>Hour1To24Parser);
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class Hour1To24Parser extends (0, _parserJs.Parser) {
    priority = 70;
    parse(dateString, token, match) {
        switch(token){
            case "k":
                return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).hour24h, dateString);
            case "ko":
                return match.ordinalNumber(dateString, {
                    unit: "hour"
                });
            default:
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 1 && value <= 24;
    }
    set(date, _flags, value) {
        const hours = value <= 24 ? value % 24 : value;
        date.setHours(hours, 0, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "a",
        "b",
        "h",
        "H",
        "K",
        "t",
        "T"
    ];
}

},{"../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a5SBN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MinuteParser", ()=>MinuteParser);
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class MinuteParser extends (0, _parserJs.Parser) {
    priority = 60;
    parse(dateString, token, match) {
        switch(token){
            case "m":
                return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).minute, dateString);
            case "mo":
                return match.ordinalNumber(dateString, {
                    unit: "minute"
                });
            default:
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setMinutes(value, 0, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}

},{"../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kEUE1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondParser", ()=>SecondParser);
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class SecondParser extends (0, _parserJs.Parser) {
    priority = 50;
    parse(dateString, token, match) {
        switch(token){
            case "s":
                return (0, _utilsJs.parseNumericPattern)((0, _constantsJs.numericPatterns).second, dateString);
            case "so":
                return match.ordinalNumber(dateString, {
                    unit: "second"
                });
            default:
                return (0, _utilsJs.parseNDigits)(token.length, dateString);
        }
    }
    validate(_date, value) {
        return value >= 0 && value <= 59;
    }
    set(date, _flags, value) {
        date.setSeconds(value, 0);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}

},{"../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bgyUX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FractionOfSecondParser", ()=>FractionOfSecondParser);
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class FractionOfSecondParser extends (0, _parserJs.Parser) {
    priority = 30;
    parse(dateString, token) {
        const valueCallback = (value)=>Math.trunc(value * Math.pow(10, -token.length + 3));
        return (0, _utilsJs.mapValue)((0, _utilsJs.parseNDigits)(token.length, dateString), valueCallback);
    }
    set(date, _flags, value) {
        date.setMilliseconds(value);
        return date;
    }
    incompatibleTokens = [
        "t",
        "T"
    ];
}

},{"../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9SV93":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Timezone (ISO-8601. +00:00 is `'Z'`)
parcelHelpers.export(exports, "ISOTimezoneWithZParser", ()=>ISOTimezoneWithZParser);
var _constructFromJs = require("../../../constructFrom.js");
var _getTimezoneOffsetInMillisecondsJs = require("../../../_lib/getTimezoneOffsetInMilliseconds.js");
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class ISOTimezoneWithZParser extends (0, _parserJs.Parser) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "X":
                return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
            case "XX":
                return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
            case "XXXX":
                return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
            case "XXXXX":
                return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
            case "XXX":
            default:
                return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, _constructFromJs.constructFrom)(date, date.getTime() - (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "x"
    ];
}

},{"../../../constructFrom.js":"56Q4T","../../../_lib/getTimezoneOffsetInMilliseconds.js":"kExSW","../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kDJTH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// Timezone (ISO-8601)
parcelHelpers.export(exports, "ISOTimezoneParser", ()=>ISOTimezoneParser);
var _constructFromJs = require("../../../constructFrom.js");
var _getTimezoneOffsetInMillisecondsJs = require("../../../_lib/getTimezoneOffsetInMilliseconds.js");
var _constantsJs = require("../constants.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class ISOTimezoneParser extends (0, _parserJs.Parser) {
    priority = 10;
    parse(dateString, token) {
        switch(token){
            case "x":
                return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalMinutes, dateString);
            case "xx":
                return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basic, dateString);
            case "xxxx":
                return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).basicOptionalSeconds, dateString);
            case "xxxxx":
                return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extendedOptionalSeconds, dateString);
            case "xxx":
            default:
                return (0, _utilsJs.parseTimezonePattern)((0, _constantsJs.timezonePatterns).extended, dateString);
        }
    }
    set(date, flags, value) {
        if (flags.timestampIsSet) return date;
        return (0, _constructFromJs.constructFrom)(date, date.getTime() - (0, _getTimezoneOffsetInMillisecondsJs.getTimezoneOffsetInMilliseconds)(date) - value);
    }
    incompatibleTokens = [
        "t",
        "T",
        "X"
    ];
}

},{"../../../constructFrom.js":"56Q4T","../../../_lib/getTimezoneOffsetInMilliseconds.js":"kExSW","../constants.js":"gvUWU","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ldQiO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampSecondsParser", ()=>TimestampSecondsParser);
var _constructFromJs = require("../../../constructFrom.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class TimestampSecondsParser extends (0, _parserJs.Parser) {
    priority = 40;
    parse(dateString) {
        return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, _constructFromJs.constructFrom)(date, value * 1000),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}

},{"../../../constructFrom.js":"56Q4T","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5KjwH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimestampMillisecondsParser", ()=>TimestampMillisecondsParser);
var _constructFromJs = require("../../../constructFrom.js");
var _parserJs = require("../Parser.js");
var _utilsJs = require("../utils.js");
class TimestampMillisecondsParser extends (0, _parserJs.Parser) {
    priority = 20;
    parse(dateString) {
        return (0, _utilsJs.parseAnyDigitsSigned)(dateString);
    }
    set(date, _flags, value) {
        return [
            (0, _constructFromJs.constructFrom)(date, value),
            {
                timestampIsSet: true
            }
        ];
    }
    incompatibleTokens = "*";
}

},{"../../../constructFrom.js":"56Q4T","../Parser.js":"5V2kM","../utils.js":"lNy5I","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8ZJ4j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimeSlotPicker", ()=>TimeSlotPicker);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _timezoneUtils = require("../utils/timezoneUtils");
var _timeSlotPickerScss = require("./TimeSlotPicker.scss");
const TimeSlotPicker = ({ value, onChange, type, minTime, maxTime, disabled = false })=>{
    const [isOpen, setIsOpen] = (0, _react.useState)(false);
    const containerRef = (0, _react.useRef)(null);
    const listRef = (0, _react.useRef)(null);
    const rawOptions = type === 'start' ? (0, _timezoneUtils.TIME_SLOTS_30_MIN) : (0, _timezoneUtils.END_TIME_SLOTS_30_MIN);
    const minMinutes = minTime ? (0, _timezoneUtils.timeToMinutes)(minTime) : undefined;
    const maxMinutes = maxTime ? (0, _timezoneUtils.timeToMinutes)(maxTime) : undefined;
    // Close when clicking outside
    (0, _react.useEffect)(()=>{
        if (!isOpen) return;
        const handleClickOutside = (e)=>{
            if (containerRef.current && !containerRef.current.contains(e.target)) setIsOpen(false);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Escape') setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        isOpen
    ]);
    // Scroll to active option when opening
    (0, _react.useEffect)(()=>{
        if (isOpen && listRef.current) {
            const activeEl = listRef.current.querySelector('.time-option.active');
            if (activeEl) activeEl.scrollIntoView({
                block: 'nearest'
            });
        }
    }, [
        isOpen
    ]);
    const handleSelect = (timeStr)=>{
        onChange(timeStr);
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `time-slot-picker-container ${disabled ? 'disabled' : ''}`,
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: `time-display-btn ${isOpen ? 'open' : ''}`,
                onClick: ()=>!disabled && setIsOpen(!isOpen),
                disabled: disabled,
                "aria-haspopup": "listbox",
                "aria-expanded": isOpen,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: value || (type === 'start' ? '09:00' : '17:00')
                })
            }),
            isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "time-dropdown-menu",
                ref: listRef,
                role: "listbox",
                children: rawOptions.map((opt)=>{
                    const optMins = (0, _timezoneUtils.timeToMinutes)(opt);
                    const isTooEarly = minMinutes !== undefined && optMins < minMinutes;
                    const isTooLate = maxMinutes !== undefined && optMins > maxMinutes;
                    const isOptionDisabled = isTooEarly || isTooLate;
                    const isSelected = opt === value;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: `time-option ${isSelected ? 'active' : ''} ${isOptionDisabled ? 'disabled' : ''}`,
                        onClick: ()=>!isOptionDisabled && handleSelect(opt),
                        disabled: isOptionDisabled,
                        role: "option",
                        "aria-selected": isSelected,
                        children: opt
                    }, opt);
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../utils/timezoneUtils":"3cRmo","./TimeSlotPicker.scss":"8L0ZJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8L0ZJ":[function() {},{}],"13NLc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TimezoneSelector", ()=>TimezoneSelector);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _timezoneUtils = require("../utils/timezoneUtils");
var _timezoneSelectorScss = require("./TimezoneSelector.scss");
const TimezoneSelector = ({ value, onChange, error })=>{
    const [isOpen, setIsOpen] = (0, _react.useState)(false);
    const [searchQuery, setSearchQuery] = (0, _react.useState)('');
    const [debouncedQuery, setDebouncedQuery] = (0, _react.useState)('');
    const containerRef = (0, _react.useRef)(null);
    const searchInputRef = (0, _react.useRef)(null);
    const allTimezones = (0, _react.useMemo)(()=>(0, _timezoneUtils.getAllSupportedTimezones)(), []);
    // 100ms debounce for search query
    (0, _react.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebouncedQuery(searchQuery);
        }, 100);
        return ()=>clearTimeout(timer);
    }, [
        searchQuery
    ]);
    // Filtered timezone list
    const filteredTimezones = (0, _react.useMemo)(()=>{
        return (0, _timezoneUtils.searchTimezones)(debouncedQuery, allTimezones);
    }, [
        debouncedQuery,
        allTimezones
    ]);
    // Selected option details (matches exact, alias e.g. Asia/Calcutta -> Asia/Kolkata, or formats dynamically)
    const selectedOption = (0, _react.useMemo)(()=>{
        return (0, _timezoneUtils.findTimezoneOption)(value, allTimezones);
    }, [
        allTimezones,
        value
    ]);
    // Close on outside click
    (0, _react.useEffect)(()=>{
        if (!isOpen) return;
        const handleClickOutside = (e)=>{
            if (containerRef.current && !containerRef.current.contains(e.target)) setIsOpen(false);
        };
        const handleKeyDown = (e)=>{
            if (e.key === 'Escape') setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, [
        isOpen
    ]);
    // Focus input when opened
    (0, _react.useEffect)(()=>{
        if (isOpen) setTimeout(()=>{
            searchInputRef.current?.focus();
        }, 50);
        else {
            setSearchQuery('');
            setDebouncedQuery('');
        }
    }, [
        isOpen
    ]);
    const handleSelect = (tzId)=>{
        onChange(tzId);
        setIsOpen(false);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "timezone-selector-container",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                className: `timezone-trigger-btn ${isOpen ? 'active' : ''} ${error ? 'has-error' : ''}`,
                onClick: ()=>setIsOpen(!isOpen),
                "aria-haspopup": "listbox",
                "aria-expanded": isOpen,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "tz-label",
                        children: selectedOption ? selectedOption.label : value || 'Select timezone'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                        className: `chevron-icon ${isOpen ? 'rotated' : ''}`,
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        stroke: "currentColor",
                        strokeWidth: "2",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                            points: "6 9 12 15 18 9"
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "tz-inline-error",
                children: error
            }),
            isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "timezone-dropdown",
                role: "listbox",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "tz-search-box",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                className: "search-icon",
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: "11",
                                        cy: "11",
                                        r: "8"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "21",
                                        y1: "21",
                                        x2: "16.65",
                                        y2: "16.65"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                ref: searchInputRef,
                                type: "text",
                                className: "tz-search-input",
                                placeholder: "Search city or timezone...",
                                value: searchQuery,
                                onChange: (e)=>setSearchQuery(e.target.value)
                            }),
                            searchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn-clear-search",
                                onClick: ()=>setSearchQuery(''),
                                "aria-label": "Clear search",
                                children: "\xd7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "tz-options-list",
                        children: filteredTimezones.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "no-tz-found",
                            children: "No timezones found"
                        }) : filteredTimezones.map((tz)=>{
                            const isSelected = tz.id === value;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: `tz-option-item ${isSelected ? 'selected' : ''}`,
                                onClick: ()=>handleSelect(tz.id),
                                role: "option",
                                "aria-selected": isSelected,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "tz-option-label",
                                        children: tz.label
                                    }),
                                    isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        className: "check-icon",
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                            points: "20 6 9 17 4 12"
                                        })
                                    })
                                ]
                            }, tz.id);
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../utils/timezoneUtils":"3cRmo","./TimezoneSelector.scss":"2CdWL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2CdWL":[function() {},{}],"lzWT7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProfileRemove2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProfileRemove2 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 64,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M32 .25C49.535.25 63.75 14.465 63.75 32S49.535 63.75 32 63.75.25 49.535.25 32 14.465.25 32 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M32 .25C49.535.25 63.75 14.465 63.75 32S49.535 63.75 32 63.75.25 49.535.25 32 14.465.25 32 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2.4,
                d: "m39.625 25.497-.975 15.785A2.78 2.78 0 0 1 37.939 43c-.417.448-.965.697-1.534.697h-9.31c-.57 0-1.117-.25-1.534-.698a2.78 2.78 0 0 1-.71-1.718l-.976-15.784m5.625 5.2v7.8m4.5-7.8v7.8m1.125-13v-3.9a1.4 1.4 0 0 0-.33-.92 1.05 1.05 0 0 0-.795-.38h-4.5a1.06 1.06 0 0 0-.796.38 1.4 1.4 0 0 0-.329.92v3.9m-5.625 0h18"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 66.9,
                        x2: 17.188,
                        y1: 64.016,
                        y2: -16.416,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 32,
                        x2: 32,
                        y1: 0,
                        y2: 64,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5jf2V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUpdateTrainerSchedule", ()=>useUpdateTrainerSchedule);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
function useUpdateTrainerSchedule() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const { uid, timezone, weekly_schedule, days = 60, force = false, ai_responses_enabled, ai_responses_only, unavailable_dates, unavailable_dates_only, connected_calendar, calendar_connection_only } = payload;
            if (!uid) throw new Error('User UID is required to update schedule');
            const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_UPDATE_SCHEDULE}`;
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    uid,
                    timezone,
                    weekly_schedule,
                    days,
                    force,
                    ai_responses_enabled,
                    ai_responses_only,
                    unavailable_dates,
                    unavailable_dates_only,
                    connected_calendar,
                    calendar_connection_only
                })
            });
            if (!response.ok) {
                const errJson = await response.json().catch(()=>({}));
                throw new Error(errJson.error || 'Failed to update schedule');
            }
            return response.json();
        },
        onSuccess: (res, variables)=>{
            if (res?.hasConflicts) return; // Don't hydrate cache if there were unresolved conflicts
            const scheduleQueryKey = [
                'trainer-schedule',
                variables.uid
            ];
            const onboardingQueryKey = [
                'onboarding-state',
                variables.uid
            ];
            // Update schedule query cache immediately
            queryClient.setQueryData(scheduleQueryKey, (oldData)=>{
                const prevData = oldData?.data || {};
                return {
                    status: 'ok',
                    data: {
                        timezone: variables.timezone ?? prevData.timezone ?? '',
                        weekly_schedule: variables.weekly_schedule ?? prevData.weekly_schedule ?? {},
                        ai_responses_enabled: variables.ai_responses_enabled !== undefined ? variables.ai_responses_enabled : prevData.ai_responses_enabled ?? true,
                        unavailable_dates: variables.unavailable_dates !== undefined ? variables.unavailable_dates : prevData.unavailable_dates ?? [],
                        connected_calendar: variables.connected_calendar !== undefined ? variables.connected_calendar : prevData.connected_calendar ?? null
                    }
                };
            });
            // Update onboarding query cache
            queryClient.setQueryData(onboardingQueryKey, (oldData)=>{
                if (!oldData) return oldData;
                return {
                    ...oldData,
                    onboarding: {
                        ...oldData.onboarding,
                        step4_schedule: {
                            timezone: variables.timezone ?? oldData.onboarding?.step4_schedule?.timezone,
                            weekly_schedule: variables.weekly_schedule ?? oldData.onboarding?.step4_schedule?.weekly_schedule
                        }
                    },
                    profile: {
                        ...oldData.profile,
                        timezone: variables.timezone ?? oldData.profile?.timezone,
                        weekly_schedule: variables.weekly_schedule ?? oldData.profile?.weekly_schedule
                    }
                };
            });
            queryClient.invalidateQueries({
                queryKey: scheduleQueryKey
            });
            queryClient.invalidateQueries({
                queryKey: onboardingQueryKey
            });
        }
    });
}

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2n68F":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchTrainerSchedule", ()=>fetchTrainerSchedule);
parcelHelpers.export(exports, "useGetTrainerSchedule", ()=>useGetTrainerSchedule);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
const fetchTrainerSchedule = async (uid)=>{
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_SCHEDULE}?uid=${uid}`;
    const response = await fetch(apiUrl);
    if (!response.ok) {
        if (response.status === 404) return {
            status: 'ok',
            data: {
                timezone: '',
                weekly_schedule: {}
            }
        };
        throw new Error('Failed to fetch trainer schedule');
    }
    return response.json();
};
function useGetTrainerSchedule(uid) {
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'trainer-schedule',
            uid
        ],
        queryFn: async ()=>{
            if (!uid) return null;
            return fetchTrainerSchedule(uid);
        },
        enabled: !!uid,
        staleTime: 300000
    });
}

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hHqzR":[function() {},{}],"lVvhl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _throttleDebounce = require("throttle-debounce");
var _hooks = require("../_util/hooks");
var _warning = require("../_util/warning");
var _context = require("../config-provider/context");
var _indicator = require("./Indicator");
var _indicatorDefault = parcelHelpers.interopDefault(_indicator);
var _index = require("./style/index");
var _indexDefault = parcelHelpers.interopDefault(_index);
var _usePercent = require("./usePercent");
var _usePercentDefault = parcelHelpers.interopDefault(_usePercent);
"use client";
const _SpinSizes = [
    'small',
    'default',
    'large'
];
// Render indicator
let defaultIndicator;
function shouldDelay(spinning, delay) {
    return !!spinning && !!delay && !Number.isNaN(Number(delay));
}
const Spin = (props)=>{
    const { prefixCls: customizePrefixCls, spinning: customSpinning = true, delay = 0, className, rootClassName, size = 'default', tip, wrapperClassName, style, children, fullscreen = false, indicator, percent, classNames, styles, ...restProps } = props;
    const { getPrefixCls, direction, indicator: contextIndicator, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('spin');
    const prefixCls = getPrefixCls('spin', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _indexDefault.default)(prefixCls);
    const [spinning, setSpinning] = _react.useState(()=>customSpinning && !shouldDelay(customSpinning, delay));
    const mergedPercent = (0, _usePercentDefault.default)(spinning, percent);
    _react.useEffect(()=>{
        if (customSpinning) {
            const showSpinning = (0, _throttleDebounce.debounce)(delay, ()=>{
                setSpinning(true);
            });
            showSpinning();
            return ()=>{
                showSpinning?.cancel?.();
            };
        }
        setSpinning(false);
    }, [
        delay,
        customSpinning
    ]);
    const isNestedPattern = _react.useMemo(()=>typeof children !== 'undefined' && !fullscreen, [
        children,
        fullscreen
    ]);
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        size,
        spinning,
        tip,
        fullscreen,
        children,
        percent: mergedPercent
    };
    // ========================= Style ==========================
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const spinClassName = (0, _clsx.clsx)(prefixCls, contextClassName, {
        [`${prefixCls}-sm`]: size === 'small',
        [`${prefixCls}-lg`]: size === 'large',
        [`${prefixCls}-spinning`]: spinning,
        [`${prefixCls}-show-text`]: !!tip,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, !fullscreen && rootClassName, !fullscreen && mergedClassNames.root, hashId, cssVarCls);
    const containerClassName = (0, _clsx.clsx)(`${prefixCls}-container`, {
        [`${prefixCls}-blur`]: spinning
    });
    const mergedIndicator = indicator ?? contextIndicator ?? defaultIndicator;
    const mergedStyle = {
        ...contextStyle,
        ...style
    };
    const spinElement = /*#__PURE__*/ _react.createElement("div", {
        ...restProps,
        style: fullscreen ? mergedStyle : {
            ...mergedStyles.root,
            ...mergedStyle
        },
        className: spinClassName,
        "aria-live": "polite",
        "aria-busy": spinning
    }, /*#__PURE__*/ _react.createElement((0, _indicatorDefault.default), {
        className: mergedClassNames.indicator,
        style: mergedStyles.indicator,
        prefixCls: prefixCls,
        indicator: mergedIndicator,
        percent: mergedPercent
    }), tip && (isNestedPattern || fullscreen) ? /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-text`, mergedClassNames.tip),
        style: mergedStyles.tip
    }, tip) : null);
    if (isNestedPattern) return /*#__PURE__*/ _react.createElement("div", {
        ...restProps,
        className: (0, _clsx.clsx)(`${prefixCls}-nested-loading`, wrapperClassName, mergedClassNames.wrapper, hashId, cssVarCls),
        style: mergedStyles.wrapper
    }, spinning && /*#__PURE__*/ _react.createElement("div", {
        key: "loading"
    }, spinElement), /*#__PURE__*/ _react.createElement("div", {
        className: containerClassName,
        key: "container"
    }, children));
    if (fullscreen) return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-fullscreen`, {
            [`${prefixCls}-fullscreen-show`]: spinning
        }, rootClassName, hashId, cssVarCls, mergedClassNames.mask),
        style: mergedStyles.mask
    }, spinElement);
    return spinElement;
};
Spin.setDefaultIndicator = (indicator)=>{
    defaultIndicator = indicator;
};
exports.default = Spin;

},{"react":"bmhQu","clsx":"431Ou","throttle-debounce":"cwlfm","../_util/hooks":"kdnMA","../_util/warning":"95o3w","../config-provider/context":"75zwC","./Indicator":"dhWP7","./style/index":"9HWb3","./usePercent":"7iQct","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cwlfm":[function(require,module,exports,__globalThis) {
/* eslint-disable no-undefined,no-param-reassign,no-shadow */ /**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param {number} delay -                  A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher)
 *                                            are most useful.
 * @param {Function} callback -               A function to be executed after delay milliseconds. The `this` context and all arguments are passed through,
 *                                            as-is, to `callback` when the throttled-function is executed.
 * @param {object} [options] -              An object to configure options.
 * @param {boolean} [options.noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds
 *                                            while the throttled-function is being called. If noTrailing is false or unspecified, callback will be executed
 *                                            one final time after the last throttled-function call. (After the throttled-function has not been called for
 *                                            `delay` milliseconds, the internal counter is reset).
 * @param {boolean} [options.noLeading] -   Optional, defaults to false. If noLeading is false, the first throttled-function call will execute callback
 *                                            immediately. If noLeading is true, the first the callback execution will be skipped. It should be noted that
 *                                            callback will never executed if both noLeading = true and noTrailing = true.
 * @param {boolean} [options.debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is
 *                                            false (at end), schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function} A new, throttled, function.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "debounce", ()=>debounce);
parcelHelpers.export(exports, "throttle", ()=>throttle);
function throttle(delay, callback, options) {
    var _ref = options || {}, _ref$noTrailing = _ref.noTrailing, noTrailing = _ref$noTrailing === void 0 ? false : _ref$noTrailing, _ref$noLeading = _ref.noLeading, noLeading = _ref$noLeading === void 0 ? false : _ref$noLeading, _ref$debounceMode = _ref.debounceMode, debounceMode = _ref$debounceMode === void 0 ? undefined : _ref$debounceMode;
    /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */ var timeoutID;
    var cancelled = false;
    // Keep track of the last time `callback` was executed.
    var lastExec = 0;
    // Function to clear existing timeout
    function clearExistingTimeout() {
        if (timeoutID) clearTimeout(timeoutID);
    }
    // Function to cancel next exec
    function cancel(options) {
        var _ref2 = options || {}, _ref2$upcomingOnly = _ref2.upcomingOnly, upcomingOnly = _ref2$upcomingOnly === void 0 ? false : _ref2$upcomingOnly;
        clearExistingTimeout();
        cancelled = !upcomingOnly;
    }
    /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */ function wrapper() {
        for(var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++)arguments_[_key] = arguments[_key];
        var self = this;
        var elapsed = Date.now() - lastExec;
        if (cancelled) return;
        // Execute `callback` and update the `lastExec` timestamp.
        function exec() {
            lastExec = Date.now();
            callback.apply(self, arguments_);
        }
        /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */ function clear() {
            timeoutID = undefined;
        }
        if (!noLeading && debounceMode && !timeoutID) /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`
       * and noLeading != true.
       */ exec();
        clearExistingTimeout();
        if (debounceMode === undefined && elapsed > delay) {
            if (noLeading) {
                /*
         * In throttle mode with noLeading, if `delay` time has
         * been exceeded, update `lastExec` and schedule `callback`
         * to execute after `delay` ms.
         */ lastExec = Date.now();
                if (!noTrailing) timeoutID = setTimeout(debounceMode ? clear : exec, delay);
            } else /*
         * In throttle mode without noLeading, if `delay` time has been exceeded, execute
         * `callback`.
         */ exec();
        } else if (noTrailing !== true) /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */ timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
    wrapper.cancel = cancel;
    // Return the wrapper function.
    return wrapper;
}
/* eslint-disable no-undefined */ /**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param {number} delay -               A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param {Function} callback -          A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                        to `callback` when the debounced-function is executed.
 * @param {object} [options] -           An object to configure options.
 * @param {boolean} [options.atBegin] -  Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                        after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                        (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 *
 * @returns {Function} A new, debounced function.
 */ function debounce(delay, callback, options) {
    var _ref = options || {}, _ref$atBegin = _ref.atBegin, atBegin = _ref$atBegin === void 0 ? false : _ref$atBegin;
    return throttle(delay, callback, {
        debounceMode: atBegin !== false
    });
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dhWP7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Indicator);
var _react = require("react");
var _clsx = require("clsx");
var _reactNode = require("../../_util/reactNode");
var _looper = require("./Looper");
var _looperDefault = parcelHelpers.interopDefault(_looper);
"use client";
function Indicator(props) {
    const { prefixCls, indicator, percent, className, style } = props;
    const dotClassName = `${prefixCls}-dot`;
    if (indicator && /*#__PURE__*/ _react.isValidElement(indicator)) return (0, _reactNode.cloneElement)(indicator, (currentProps)=>({
            className: (0, _clsx.clsx)(currentProps.className, dotClassName, className),
            style: {
                ...currentProps.style,
                ...style
            },
            percent
        }));
    return /*#__PURE__*/ _react.createElement((0, _looperDefault.default), {
        prefixCls: prefixCls,
        percent: percent,
        className: className,
        style: style
    });
}

},{"react":"bmhQu","clsx":"431Ou","../../_util/reactNode":"78pFx","./Looper":"2rrUE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2rrUE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Looper);
var _react = require("react");
var _clsx = require("clsx");
var _progress = require("./Progress");
var _progressDefault = parcelHelpers.interopDefault(_progress);
"use client";
function Looper(props) {
    const { prefixCls, percent = 0, className, style } = props;
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    // ===================== Render =====================
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(holderClassName, className, percent > 0 && hideClassName),
        style: style
    }, /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(dotClassName, `${prefixCls}-dot-spin`)
    }, [
        1,
        2,
        3,
        4
    ].map((i)=>/*#__PURE__*/ _react.createElement("i", {
            className: `${prefixCls}-dot-item`,
            key: i
        })))), /*#__PURE__*/ _react.createElement((0, _progressDefault.default), {
        prefixCls: prefixCls,
        percent: percent
    }));
}

},{"react":"bmhQu","clsx":"431Ou","./Progress":"bmDrd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bmDrd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _clsx = require("clsx");
"use client";
const viewSize = 100;
const borderWidth = viewSize / 5;
const radius = viewSize / 2 - borderWidth / 2;
const circumference = radius * 2 * Math.PI;
const position = 50;
const CustomCircle = (props)=>{
    const { dotClassName, style, hasCircleCls } = props;
    return /*#__PURE__*/ _react.createElement("circle", {
        className: (0, _clsx.clsx)(`${dotClassName}-circle`, {
            [`${dotClassName}-circle-bg`]: hasCircleCls
        }),
        r: radius,
        cx: position,
        cy: position,
        strokeWidth: borderWidth,
        style: style
    });
};
const Progress = ({ percent, prefixCls })=>{
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    const [render, setRender] = _react.useState(false);
    // ==================== Visible =====================
    (0, _useLayoutEffectDefault.default)(()=>{
        if (percent !== 0) setRender(true);
    }, [
        percent !== 0
    ]);
    // ==================== Progress ====================
    const safePtg = Math.max(Math.min(percent, 100), 0);
    // ===================== Render =====================
    if (!render) return null;
    const circleStyle = {
        strokeDashoffset: `${circumference / 4}`,
        strokeDasharray: `${circumference * safePtg / 100} ${circumference * (100 - safePtg) / 100}`
    };
    return /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(holderClassName, `${dotClassName}-progress`, safePtg <= 0 && hideClassName)
    }, /*#__PURE__*/ _react.createElement("svg", {
        viewBox: `0 0 ${viewSize} ${viewSize}`,
        role: "progressbar",
        "aria-valuemin": 0,
        "aria-valuemax": 100,
        "aria-valuenow": safePtg
    }, /*#__PURE__*/ _react.createElement(CustomCircle, {
        dotClassName: dotClassName,
        hasCircleCls: true
    }), /*#__PURE__*/ _react.createElement(CustomCircle, {
        dotClassName: dotClassName,
        style: circleStyle
    })));
};
exports.default = Progress;

},{"react":"bmhQu","@rc-component/util/es/hooks/useLayoutEffect":"azwns","clsx":"431Ou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9HWb3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../style");
var _internal = require("../../theme/internal");
const antSpinMove = new (0, _cssinjs.Keyframes)('antSpinMove', {
    to: {
        opacity: 1
    }
});
const antRotate = new (0, _cssinjs.Keyframes)('antRotate', {
    to: {
        transform: 'rotate(405deg)'
    }
});
const genSpinStyle = (token)=>{
    const { componentCls, calc } = token;
    return {
        [componentCls]: {
            ...(0, _style.resetComponent)(token),
            position: 'absolute',
            display: 'none',
            color: token.colorPrimary,
            fontSize: 0,
            textAlign: 'center',
            verticalAlign: 'middle',
            opacity: 0,
            transition: `transform ${token.motionDurationSlow} ${token.motionEaseInOutCirc}`,
            '&-spinning': {
                position: 'relative',
                display: 'inline-block',
                opacity: 1
            },
            [`${componentCls}-text`]: {
                fontSize: token.fontSize,
                paddingTop: calc(calc(token.dotSize).sub(token.fontSize)).div(2).add(2).equal()
            },
            '&-fullscreen': {
                position: 'fixed',
                width: '100vw',
                height: '100vh',
                backgroundColor: token.colorBgMask,
                zIndex: token.zIndexPopupBase,
                inset: 0,
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
                opacity: 0,
                visibility: 'hidden',
                transition: `all ${token.motionDurationMid}`,
                '&-show': {
                    opacity: 1,
                    visibility: 'visible'
                },
                [componentCls]: {
                    [`${componentCls}-dot-holder`]: {
                        color: token.colorWhite
                    },
                    [`${componentCls}-text`]: {
                        color: token.colorTextLightSolid
                    }
                }
            },
            '&-nested-loading': {
                position: 'relative',
                [`> div > ${componentCls}`]: {
                    position: 'absolute',
                    top: 0,
                    insetInlineStart: 0,
                    zIndex: 4,
                    display: 'block',
                    width: '100%',
                    height: '100%',
                    maxHeight: token.contentHeight,
                    [`${componentCls}-dot`]: {
                        position: 'absolute',
                        top: '50%',
                        insetInlineStart: '50%',
                        margin: calc(token.dotSize).mul(-1).div(2).equal()
                    },
                    [`${componentCls}-text`]: {
                        position: 'absolute',
                        top: '50%',
                        width: '100%',
                        textShadow: `0 1px 2px ${token.colorBgContainer}` // FIXME: shadow
                    },
                    [`&${componentCls}-show-text ${componentCls}-dot`]: {
                        marginTop: calc(token.dotSize).div(2).mul(-1).sub(10).equal()
                    },
                    '&-sm': {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeSM).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeSM).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeSM).div(2).mul(-1).sub(10).equal()
                        }
                    },
                    '&-lg': {
                        [`${componentCls}-dot`]: {
                            margin: calc(token.dotSizeLG).mul(-1).div(2).equal()
                        },
                        [`${componentCls}-text`]: {
                            paddingTop: calc(calc(token.dotSizeLG).sub(token.fontSize)).div(2).add(2).equal()
                        },
                        [`&${componentCls}-show-text ${componentCls}-dot`]: {
                            marginTop: calc(token.dotSizeLG).div(2).mul(-1).sub(10).equal()
                        }
                    }
                },
                [`${componentCls}-container`]: {
                    position: 'relative',
                    transition: `opacity ${token.motionDurationSlow}`,
                    '&::after': {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: 0,
                        bottom: 0,
                        insetInlineStart: 0,
                        zIndex: 10,
                        width: '100%',
                        height: '100%',
                        background: token.colorBgContainer,
                        opacity: 0,
                        transition: `all ${token.motionDurationSlow}`,
                        content: '""',
                        pointerEvents: 'none'
                    }
                },
                [`${componentCls}-blur`]: {
                    clear: 'both',
                    opacity: 0.5,
                    userSelect: 'none',
                    pointerEvents: 'none',
                    '&::after': {
                        opacity: 0.4,
                        pointerEvents: 'auto'
                    }
                }
            },
            // tip
            // ------------------------------
            '&-tip': {
                color: token.spinDotDefault
            },
            // holder
            // ------------------------------
            [`${componentCls}-dot-holder`]: {
                width: '1em',
                height: '1em',
                fontSize: token.dotSize,
                display: 'inline-block',
                transition: `transform ${token.motionDurationSlow} ease, opacity ${token.motionDurationSlow} ease`,
                transformOrigin: '50% 50%',
                lineHeight: 1,
                color: token.colorPrimary,
                '&-hidden': {
                    transform: 'scale(0.3)',
                    opacity: 0
                }
            },
            // progress
            // ------------------------------
            [`${componentCls}-dot-progress`]: {
                position: 'absolute',
                inset: 0
            },
            // dots
            // ------------------------------
            [`${componentCls}-dot`]: {
                position: 'relative',
                display: 'inline-block',
                fontSize: token.dotSize,
                width: '1em',
                height: '1em',
                '&-item': {
                    position: 'absolute',
                    display: 'block',
                    width: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    height: calc(token.dotSize).sub(calc(token.marginXXS).div(2)).div(2).equal(),
                    background: 'currentColor',
                    borderRadius: '100%',
                    transform: 'scale(0.75)',
                    transformOrigin: '50% 50%',
                    opacity: 0.3,
                    animationName: antSpinMove,
                    animationDuration: '1s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear',
                    animationDirection: 'alternate',
                    '&:nth-child(1)': {
                        top: 0,
                        insetInlineStart: 0,
                        animationDelay: '0s'
                    },
                    '&:nth-child(2)': {
                        top: 0,
                        insetInlineEnd: 0,
                        animationDelay: '0.4s'
                    },
                    '&:nth-child(3)': {
                        insetInlineEnd: 0,
                        bottom: 0,
                        animationDelay: '0.8s'
                    },
                    '&:nth-child(4)': {
                        bottom: 0,
                        insetInlineStart: 0,
                        animationDelay: '1.2s'
                    }
                },
                '&-spin': {
                    transform: 'rotate(45deg)',
                    animationName: antRotate,
                    animationDuration: '1.2s',
                    animationIterationCount: 'infinite',
                    animationTimingFunction: 'linear'
                },
                '&-circle': {
                    strokeLinecap: 'round',
                    transition: [
                        'stroke-dashoffset',
                        'stroke-dasharray',
                        'stroke',
                        'stroke-width',
                        'opacity'
                    ].map((item)=>`${item} ${token.motionDurationSlow} ease`).join(','),
                    fillOpacity: 0,
                    stroke: 'currentcolor'
                },
                '&-circle-bg': {
                    stroke: token.colorFillSecondary
                }
            },
            // small
            [`&-sm ${componentCls}-dot`]: {
                '&, &-holder': {
                    fontSize: token.dotSizeSM
                }
            },
            [`&-sm ${componentCls}-dot-holder`]: {
                i: {
                    width: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal(),
                    height: calc(calc(token.dotSizeSM).sub(calc(token.marginXXS).div(2))).div(2).equal()
                }
            },
            // large
            [`&-lg ${componentCls}-dot`]: {
                '&, &-holder': {
                    fontSize: token.dotSizeLG
                }
            },
            [`&-lg ${componentCls}-dot-holder`]: {
                i: {
                    width: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal(),
                    height: calc(calc(token.dotSizeLG).sub(token.marginXXS)).div(2).equal()
                }
            },
            [`&${componentCls}-show-text ${componentCls}-text`]: {
                display: 'block'
            }
        }
    };
};
const prepareComponentToken = (token)=>{
    const { controlHeightLG, controlHeight } = token;
    return {
        contentHeight: 400,
        dotSize: controlHeightLG / 2,
        dotSizeSM: controlHeightLG * 0.35,
        dotSizeLG: controlHeight
    };
};
// ============================== Export ==============================
exports.default = (0, _internal.genStyleHooks)('Spin', (token)=>{
    const spinToken = (0, _internal.mergeToken)(token, {
        spinDotDefault: token.colorTextDescription
    });
    return genSpinStyle(spinToken);
}, prepareComponentToken);

},{"@ant-design/cssinjs":"2VNL8","../../style":"4Ezp0","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7iQct":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePercent);
var _react = require("react");
const AUTO_INTERVAL = 200;
const STEP_BUCKETS = [
    [
        30,
        0.05
    ],
    [
        70,
        0.03
    ],
    [
        96,
        0.01
    ]
];
function usePercent(spinning, percent) {
    const [mockPercent, setMockPercent] = _react.useState(0);
    const mockIntervalRef = _react.useRef(null);
    const isAuto = percent === 'auto';
    _react.useEffect(()=>{
        if (isAuto && spinning) {
            setMockPercent(0);
            mockIntervalRef.current = setInterval(()=>{
                setMockPercent((prev)=>{
                    const restPTG = 100 - prev;
                    for(let i = 0; i < STEP_BUCKETS.length; i += 1){
                        const [limit, stepPtg] = STEP_BUCKETS[i];
                        if (prev <= limit) return prev + restPTG * stepPtg;
                    }
                    return prev;
                });
            }, AUTO_INTERVAL);
        }
        return ()=>{
            if (mockIntervalRef.current) {
                clearInterval(mockIntervalRef.current);
                mockIntervalRef.current = null;
            }
        };
    }, [
        isAuto,
        spinning
    ]);
    return isAuto ? mockPercent : percent;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gnh1N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasStep1Experience", ()=>hasStep1Experience);
parcelHelpers.export(exports, "hasStep2ClientTypes", ()=>hasStep2ClientTypes);
parcelHelpers.export(exports, "hasStep3Offers", ()=>hasStep3Offers);
parcelHelpers.export(exports, "hasStep4Schedule", ()=>hasStep4Schedule);
/**
 * Computes the real step completion progress and next step to resume based on the actual
 * presence of data in the user's onboarding document.
 */ parcelHelpers.export(exports, "computeOnboardingProgress", ()=>computeOnboardingProgress);
function hasStep1Experience(onboarding) {
    if (!onboarding?.step1_experience) return false;
    if (Array.isArray(onboarding.step1_experience)) return onboarding.step1_experience.length > 0;
    if (typeof onboarding.step1_experience === 'string') return onboarding.step1_experience.trim().length > 0;
    return false;
}
function hasStep2ClientTypes(onboarding) {
    if (!onboarding?.step2_client_types) return false;
    if (Array.isArray(onboarding.step2_client_types)) return onboarding.step2_client_types.length > 0;
    return false;
}
function hasStep3Offers(onboarding) {
    if (!onboarding?.step3_offers) return false;
    if (Array.isArray(onboarding.step3_offers)) return onboarding.step3_offers.length > 0;
    return false;
}
function hasStep4Schedule(onboarding) {
    if (!onboarding) return false;
    const isSkipped = Boolean(onboarding.onboardingSkipped ?? onboarding.skipped);
    if (isSkipped) return false;
    if (onboarding.step4_schedule && typeof onboarding.step4_schedule === 'object') {
        const schedule = onboarding.step4_schedule;
        if (schedule.timezone && typeof schedule.timezone === 'string' && schedule.timezone.trim()) return true;
    }
    return (onboarding.lastCompletedStep ?? 0) >= 4;
}
function computeOnboardingProgress(onboarding) {
    if (!onboarding) return {
        hasStep1: false,
        hasStep2: false,
        hasStep3: false,
        hasStep4: false,
        completedStepsCount: 0,
        nextStepNumber: 1,
        nextHeroWizardStep: 3,
        isFullyCompleted: false,
        isSkipped: false
    };
    const isSkipped = Boolean(onboarding.onboardingSkipped ?? onboarding.skipped);
    const hasStep1 = hasStep1Experience(onboarding);
    const hasStep2 = hasStep2ClientTypes(onboarding);
    const hasStep3 = hasStep3Offers(onboarding);
    const hasStep4 = hasStep4Schedule(onboarding);
    let completedStepsCount = 0;
    if (hasStep1) completedStepsCount++;
    if (hasStep2) completedStepsCount++;
    if (hasStep3) completedStepsCount++;
    if (hasStep4) completedStepsCount++;
    let nextStepNumber = 1;
    let nextHeroWizardStep = 3;
    if (!hasStep1) {
        nextStepNumber = 1;
        nextHeroWizardStep = 3; // Experience
    } else if (!hasStep2) {
        nextStepNumber = 2;
        nextHeroWizardStep = 4; // ClientType: "What type of clients are you looking for?"
    } else if (!hasStep3) {
        nextStepNumber = 3;
        nextHeroWizardStep = 5; // Offer: "What do you offer to your clients?"
    } else if (!hasStep4) {
        nextStepNumber = 4;
        nextHeroWizardStep = 6; // Schedule: "Let's set your schedule"
    } else {
        nextStepNumber = 4;
        nextHeroWizardStep = 6;
    }
    const isFullyCompleted = !isSkipped && completedStepsCount === 4;
    return {
        hasStep1,
        hasStep2,
        hasStep3,
        hasStep4,
        completedStepsCount,
        nextStepNumber,
        nextHeroWizardStep,
        isFullyCompleted,
        isSkipped
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jEMFR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgRightArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRightArrow = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#04051B",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M4 12h16m-6 6 6-6-6-6"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jjnLA":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6NYcv");

},{}],"gKYwy":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("c7Tus");

},{}],"4gq5W":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2eC8u");

},{}],"ptH8e":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("bxOsJ");

},{}],"5LncY":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("bEGqx");

},{}],"abHBB":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("jRaN6");

},{}],"dLvQ4":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("i5pmE");

},{}],"6OsjK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFeatureSyncPerformance);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFeatureSyncPerformance = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 205,
        height: 139,
        fill: "none",
        viewBox: "0 0 205 139",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                filter: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 173.111,
                        height: 120.917,
                        x: 15.711,
                        fill: "url(#b)",
                        rx: 8.268
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 172.594,
                        height: 120.4,
                        x: 15.969,
                        y: 0.258,
                        stroke: "#fff",
                        strokeOpacity: 0.07,
                        strokeWidth: 0.517,
                        rx: 8.01
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "url(#c)",
                        d: "M34.83 10.916a8.203 8.203 0 1 1 0 16.406 8.203 8.203 0 0 1 0-16.406"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#22D543",
                        fillOpacity: 0.02,
                        d: "M34.83 10.916a8.203 8.203 0 1 1 0 16.406 8.203 8.203 0 0 1 0-16.406"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "#22D543",
                        strokeWidth: 0.129,
                        d: "M34.83 10.916a8.203 8.203 0 1 1 0 16.406 8.203 8.203 0 0 1 0-16.406Z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "#22D543",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 1.033,
                        d: "m38.704 17.182-3.05 3.05c-.153.153-.23.23-.318.258a.4.4 0 0 1-.24 0c-.088-.029-.165-.105-.318-.259l-1.061-1.06c-.154-.154-.23-.23-.319-.26a.4.4 0 0 0-.24 0c-.088.03-.165.106-.318.26l-1.887 1.886m7.751-1.162v-2.713h-2.713"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        xmlSpace: "preserve",
                        fill: "#fff",
                        fontFamily: "Poppins",
                        fontSize: 8.268,
                        fontWeight: 500,
                        letterSpacing: "0em",
                        style: {
                            whiteSpace: "pre"
                        },
                        transform: "translate(47.234 12.62)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                            x: 0,
                            y: 9.095,
                            children: "Performance Overview"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        "data-progress-art": "true",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("foreignObject", {
                                width: 70.039,
                                height: 70.037,
                                x: 28.738,
                                y: 35.526,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    xmlns: "http://www.w3.org/1999/xhtml",
                                    style: {
                                        backdropFilter: "blur(1.49px)",
                                        clipPath: "url(#d)",
                                        height: "100%",
                                        width: "100%"
                                    }
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                "data-figma-bg-blur-radius": 2.98,
                                filter: "url(#e)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    fill: "#000",
                                    fillOpacity: 0.2,
                                    d: "M95.794 70.544c0 17.693-14.344 32.037-32.038 32.037S31.72 88.237 31.72 70.543s14.343-32.037 32.037-32.037S95.794 52.85 95.794 70.543m-59.2 0c0 15 12.161 27.162 27.162 27.162s27.162-12.161 27.162-27.163c0-15-12.16-27.162-27.162-27.162-15 0-27.162 12.161-27.162 27.162"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                                filter: "url(#f)",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    fill: "#71BE41",
                                    fillOpacity: 0.6,
                                    d: "M95.794 70.544a32.038 32.038 0 1 0-25.954 31.454l-.925-4.787a27.163 27.163 0 1 1 22.003-26.668z"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "#71BE41",
                                d: "M93.356 70.544c1.347 0 2.448-1.094 2.345-2.436a32.038 32.038 0 1 0-28.27 34.262c1.338-.155 2.202-1.443 1.946-2.765-.255-1.322-1.534-2.175-2.873-2.039A27.162 27.162 0 1 1 90.809 68.11c.12 1.34 1.2 2.435 2.547 2.435"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "#7BC14F",
                        "data-progress-label": "true",
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        letterSpacing: "0em",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                xmlSpace: "preserve",
                                fontSize: 12.809,
                                style: {
                                    whiteSpace: "pre"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 51.109,
                                    y: 70.067,
                                    children: "86%"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                xmlSpace: "preserve",
                                fontSize: 6.028,
                                style: {
                                    whiteSpace: "pre"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 43.654,
                                    y: 81.115,
                                    children: "Overall Score"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        filter: "url(#g)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#71BE41",
                            d: "M106.141 42.154a1.55 1.55 0 1 1 3.1 0 1.55 1.55 0 0 1-3.1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "#fff",
                        fontFamily: "Poppins",
                        fontSize: 7.234,
                        fontWeight: 500,
                        letterSpacing: "0em",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                xmlSpace: "preserve",
                                fillOpacity: 0.7,
                                style: {
                                    whiteSpace: "pre"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 113.375,
                                    y: 44.387,
                                    children: "Great Form"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                xmlSpace: "preserve",
                                style: {
                                    whiteSpace: "pre"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 158.477,
                                    y: 44.387,
                                    children: "5"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        filter: "url(#h)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#71BE41",
                            d: "M106.141 59.289a1.55 1.55 0 1 1 3.1 0 1.55 1.55 0 0 1-3.1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "#fff",
                        fontFamily: "Poppins",
                        fontSize: 7.234,
                        fontWeight: 500,
                        letterSpacing: "0em",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                xmlSpace: "preserve",
                                fillOpacity: 0.7,
                                style: {
                                    whiteSpace: "pre"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 113.375,
                                    y: 61.522,
                                    children: "Good Form"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                xmlSpace: "preserve",
                                style: {
                                    whiteSpace: "pre"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 157.477,
                                    y: 61.522,
                                    children: "1"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        filter: "url(#i)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#FFA100",
                            d: "M106.141 76.421a1.55 1.55 0 1 1 3.1 0 1.55 1.55 0 0 1-3.1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "#fff",
                        fontFamily: "Poppins",
                        fontSize: 7.234,
                        fontWeight: 500,
                        letterSpacing: "0em",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                xmlSpace: "preserve",
                                fillOpacity: 0.7,
                                style: {
                                    whiteSpace: "pre"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 113.375,
                                    y: 78.655,
                                    children: "Needs Focus"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                xmlSpace: "preserve",
                                style: {
                                    whiteSpace: "pre"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 162.477,
                                    y: 78.655,
                                    children: "1"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        filter: "url(#j)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#EB4444",
                            d: "M106.141 93.556a1.55 1.55 0 1 1 3.1 0 1.55 1.55 0 0 1-3.1 0"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                        fill: "#fff",
                        fontFamily: "Poppins",
                        fontSize: 7.234,
                        fontWeight: 500,
                        letterSpacing: "0em",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                xmlSpace: "preserve",
                                fillOpacity: 0.7,
                                style: {
                                    whiteSpace: "pre"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 113.375,
                                    y: 95.79,
                                    children: "Skipped"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                                xmlSpace: "preserve",
                                style: {
                                    whiteSpace: "pre"
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                                    x: 145.477,
                                    y: 95.79,
                                    children: "0"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "a",
                        width: 204.528,
                        height: 152.334,
                        x: 0.002,
                        y: -13.642,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                dy: 2.067
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                stdDeviation: 7.855
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_14686_61551"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_14686_61551",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "e",
                        width: 70.039,
                        height: 70.037,
                        x: 28.738,
                        y: 35.526,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                dy: 1.49
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                stdDeviation: 2.123
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                k2: -1,
                                k3: 1,
                                operator: "arithmetic"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.6 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in2: "shape",
                                result: "effect1_innerShadow_14686_61551"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "f",
                        width: 84.046,
                        height: 84.044,
                        x: 21.735,
                        y: 28.522,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                result: "effect1_foregroundBlur_14686_61551",
                                stdDeviation: 4.992
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "g",
                        width: 9.303,
                        height: 9.301,
                        x: 103.04,
                        y: 37.503,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                stdDeviation: 1.55
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0.443137 0 0 0 0 0.745098 0 0 0 0 0.254902 0 0 0 0.6 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_14686_61551"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_14686_61551",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "h",
                        width: 9.303,
                        height: 9.301,
                        x: 103.04,
                        y: 54.638,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                stdDeviation: 1.55
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0.443137 0 0 0 0 0.745098 0 0 0 0 0.254902 0 0 0 0.6 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_14686_61551"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_14686_61551",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "i",
                        width: 9.303,
                        height: 9.301,
                        x: 103.04,
                        y: 71.771,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                stdDeviation: 1.55
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                values: "0 0 0 0 1 0 0 0 0 0.631373 0 0 0 0 0 0 0 0 0.6 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_14686_61551"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_14686_61551",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "j",
                        width: 9.303,
                        height: 9.301,
                        x: 103.04,
                        y: 88.905,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                stdDeviation: 1.55
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0.921569 0 0 0 0 0.266667 0 0 0 0 0.266667 0 0 0 0.6 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_14686_61551"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_14686_61551",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 196.666,
                        x2: 120.244,
                        y1: 120.948,
                        y2: -56.072,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#111229"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c",
                        x1: 43.847,
                        x2: 31.003,
                        y1: 27.391,
                        y2: 6.61,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "d",
                        transform: "translate(-28.738 -35.526)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M95.794 70.544c0 17.693-14.344 32.037-32.038 32.037S31.72 88.237 31.72 70.543s14.343-32.037 32.037-32.037S95.794 52.85 95.794 70.543m-59.2 0c0 15 12.161 27.162 27.162 27.162s27.162-12.161 27.162-27.163c0-15-12.16-27.162-27.162-27.162-15 0-27.162 12.161-27.162 27.162"
                        })
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5TBqO":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fG0Qk");

},{}],"bCo1h":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProgramBuilder);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgramBuilder = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 29.879,
        height: 29.879,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 29.879 29.879",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#111229",
            d: "m19.966 16.394-2.677 4.295q-.342.53-.948.436-.607-.093-.764-.716l-.871-3.486-8.497 8.497a1.22 1.22 0 0 1-.855.359 1.16 1.16 0 0 1-.888-.359q-.342-.342-.342-.871 0-.53.342-.872l8.497-8.528-3.486-.871q-.622-.156-.716-.762t.436-.95l4.295-2.646-.373-5.073q-.063-.623.498-.902.56-.28 1.027.124l3.89 3.268 4.7-1.898q.59-.249 1.027.186.436.436.187 1.027l-1.899 4.7 3.268 3.86q.405.466.125 1.027t-.903.498zM4.03 8.053a.6.6 0 0 1-.186-.436q0-.249.186-.435L5.65 5.563a.6.6 0 0 1 .436-.187q.248 0 .435.187L8.14 7.182q.187.187.187.435a.6.6 0 0 1-.187.436L6.52 9.671a.6.6 0 0 1-.435.187.6.6 0 0 1-.436-.187zm17.803 17.803-1.618-1.619a.6.6 0 0 1-.187-.435q0-.249.187-.436l1.618-1.619a.6.6 0 0 1 .436-.186q.249 0 .436.186l1.618 1.619q.187.187.187.436a.6.6 0 0 1-.187.435l-1.618 1.619a.6.6 0 0 1-.436.187.6.6 0 0 1-.436-.187"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ic88o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAssignClients);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAssignClients = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 29.879,
        height: 29.879,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 29.879 29.879",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#04051B",
                    d: "M19.64 14.936c-1.204 0-2.369-.538-3.28-1.514-.887-.953-1.429-2.222-1.524-3.575-.102-1.442.338-2.769 1.239-3.736.9-.966 2.16-1.488 3.566-1.488 1.396 0 2.659.53 3.556 1.495.907.974 1.348 2.298 1.246 3.729-.098 1.354-.639 2.623-1.524 3.574-.909.977-2.073 1.515-3.278 1.515m7.725 10.312H11.917a1.62 1.62 0 0 1-1.29-.625 1.77 1.77 0 0 1-.308-1.511c.494-1.981 1.716-3.624 3.535-4.751 1.614-1 3.669-1.55 5.787-1.55 2.159 0 4.16.527 5.783 1.526 1.823 1.12 3.047 2.773 3.538 4.778a1.77 1.77 0 0 1-.311 1.51 1.62 1.62 0 0 1-1.286.623M8.566 15.17c-2.062 0-3.874-1.917-4.043-4.273-.083-1.207.293-2.324 1.055-3.142.754-.81 1.816-1.257 2.988-1.257s2.227.449 2.984 1.264c.768.825 1.143 1.939 1.055 3.136-.168 2.355-1.98 4.272-4.039 4.272m3.848 1.843c-1.031-.504-2.369-.756-3.847-.756-1.726 0-3.403.45-4.721 1.267-1.495.927-2.5 2.278-2.906 3.908a1.6 1.6 0 0 0 .28 1.37 1.48 1.48 0 0 0 1.178.571h6.504a.47.47 0 0 0 .46-.385q.01-.056.025-.11c.497-1.996 1.66-3.682 3.381-4.911a.47.47 0 0 0-.037-.785 5 5 0 0 0-.317-.17"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h29.879v29.879H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"38t6B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgClientsWork);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgClientsWork = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 29.879,
        height: 29.879,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 29.879 29.879",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#04051B",
                    d: "M19.64 14.936c-1.204 0-2.369-.538-3.28-1.514-.887-.953-1.429-2.222-1.524-3.575-.102-1.442.338-2.769 1.239-3.736.9-.966 2.16-1.488 3.566-1.488 1.396 0 2.659.53 3.556 1.495.907.974 1.348 2.298 1.246 3.729-.098 1.354-.639 2.623-1.524 3.574-.909.977-2.073 1.515-3.278 1.515m7.725 10.312H11.917a1.62 1.62 0 0 1-1.29-.625 1.77 1.77 0 0 1-.308-1.511c.494-1.981 1.716-3.624 3.535-4.751 1.614-1 3.669-1.55 5.787-1.55 2.159 0 4.16.527 5.783 1.526 1.823 1.12 3.047 2.773 3.538 4.778a1.77 1.77 0 0 1-.311 1.51 1.62 1.62 0 0 1-1.286.623M8.566 15.17c-2.062 0-3.874-1.917-4.043-4.273-.083-1.207.293-2.324 1.055-3.142.754-.81 1.816-1.257 2.988-1.257s2.227.449 2.984 1.264c.768.825 1.143 1.939 1.055 3.136-.168 2.355-1.98 4.272-4.039 4.272m3.848 1.843c-1.031-.504-2.369-.756-3.847-.756-1.726 0-3.403.45-4.721 1.267-1.495.927-2.5 2.278-2.906 3.908a1.6 1.6 0 0 0 .28 1.37 1.48 1.48 0 0 0 1.178.571h6.504a.47.47 0 0 0 .46-.385q.01-.056.025-.11c.497-1.996 1.66-3.682 3.381-4.911a.47.47 0 0 0-.037-.785 5 5 0 0 0-.317-.17"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h29.879v29.879H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jXFCf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProgressSync);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgressSync = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 29.879,
        height: 29.879,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 29.879 29.879",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#04051B",
                    d: "M19.64 14.936c-1.204 0-2.369-.538-3.28-1.514-.887-.953-1.429-2.222-1.524-3.575-.102-1.442.338-2.769 1.239-3.736.9-.966 2.16-1.488 3.566-1.488 1.396 0 2.659.53 3.556 1.495.907.974 1.348 2.298 1.246 3.729-.098 1.354-.639 2.623-1.524 3.574-.909.977-2.073 1.515-3.278 1.515m7.725 10.312H11.917a1.62 1.62 0 0 1-1.29-.625 1.77 1.77 0 0 1-.308-1.511c.494-1.981 1.716-3.624 3.535-4.751 1.614-1 3.669-1.55 5.787-1.55 2.159 0 4.16.527 5.783 1.526 1.823 1.12 3.047 2.773 3.538 4.778a1.77 1.77 0 0 1-.311 1.51 1.62 1.62 0 0 1-1.286.623M8.566 15.17c-2.062 0-3.874-1.917-4.043-4.273-.083-1.207.293-2.324 1.055-3.142.754-.81 1.816-1.257 2.988-1.257s2.227.449 2.984 1.264c.768.825 1.143 1.939 1.055 3.136-.168 2.355-1.98 4.272-4.039 4.272m3.848 1.843c-1.031-.504-2.369-.756-3.847-.756-1.726 0-3.403.45-4.721 1.267-1.495.927-2.5 2.278-2.906 3.908a1.6 1.6 0 0 0 .28 1.37 1.48 1.48 0 0 0 1.178.571h6.504a.47.47 0 0 0 .46-.385q.01-.056.025-.11c.497-1.996 1.66-3.682 3.381-4.911a.47.47 0 0 0-.037-.785 5 5 0 0 0-.317-.17"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h29.879v29.879H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5rI6d":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6Jwas");

},{}],"qX3D7":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6lTFP");

},{}],"bnu3s":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("k3Ukq");

},{}],"jkz9i":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9lcKO");

},{}],"l62KF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgQuoteIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgQuoteIcon = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26.253,
        height: 18.52,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 26.253 18.52",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#000",
                d: "M4.9 12.097c-.578 1.453-1.487 2.888-2.704 4.27a1.29 1.29 0 0 0-.122 1.558c.245.385.647.595 1.085.595.122 0 .245-.009.367-.053 2.573-.752 8.584-3.42 8.75-11.978.062-3.3-2.353-6.134-5.495-6.458a6.2 6.2 0 0 0-4.76 1.549A6.16 6.16 0 0 0 0 6.139c0 2.887 2.048 5.416 4.9 5.958"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                d: "M4.9 12.097c-.578 1.453-1.487 2.888-2.704 4.27a1.29 1.29 0 0 0-.122 1.558c.245.385.647.595 1.085.595.122 0 .245-.009.367-.053 2.573-.752 8.584-3.42 8.75-11.978.062-3.3-2.353-6.134-5.495-6.458a6.2 6.2 0 0 0-4.76 1.549A6.16 6.16 0 0 0 0 6.139c0 2.887 2.048 5.416 4.9 5.958"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#000",
                d: "M20.75.031a6.2 6.2 0 0 0-4.752 1.549 6.16 6.16 0 0 0-2.021 4.559c0 2.887 2.047 5.416 4.9 5.958-.578 1.453-1.488 2.888-2.704 4.27a1.29 1.29 0 0 0-.123 1.558c.245.385.648.595 1.085.595.123 0 .245-.009.368-.053 2.572-.752 8.584-3.42 8.75-11.978v-.123c0-3.246-2.389-6.011-5.504-6.335"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                d: "M20.75.031a6.2 6.2 0 0 0-4.752 1.549 6.16 6.16 0 0 0-2.021 4.559c0 2.887 2.047 5.416 4.9 5.958-.578 1.453-1.488 2.888-2.704 4.27a1.29 1.29 0 0 0-.123 1.558c.245.385.648.595 1.085.595.123 0 .245-.009.368-.053 2.572-.752 8.584-3.42 8.75-11.978v-.123c0-3.246-2.389-6.011-5.504-6.335"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4D1Kw":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2DTsp");

},{}],"4Kv4R":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("b79eu");

},{}],"jD0hd":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("f0iwA");

},{}],"g27c7":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7PExM");

},{}],"bdmCA":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lOeRy");

},{}],"aex14":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3fMc5");

},{}],"6wj7T":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("jARiZ");

},{}],"5e2IG":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1aMq4");

},{}],"lP9tD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgTrendUp);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTrendUp = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14.667,
        height: 8,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 14.667 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#FFA100",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "M14 .667 8.754 5.912c-.264.264-.396.396-.548.446a.67.67 0 0 1-.412 0c-.152-.05-.284-.182-.548-.446L5.42 4.088c-.264-.264-.396-.396-.548-.446a.67.67 0 0 0-.412 0c-.153.05-.285.182-.549.446L.667 7.333m13.333-2V.667H9.333"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dL149":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgQuote);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgQuote = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 18 18",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M3.437 12.99c-.772-.82-1.187-1.74-1.187-3.232 0-2.625 1.843-4.978 4.523-6.14l.67 1.033C4.94 6.004 4.451 7.759 4.256 8.866c.403-.208.93-.28 1.447-.233 1.353.125 2.42 1.236 2.42 2.617a2.625 2.625 0 0 1-2.626 2.625 2.9 2.9 0 0 1-2.06-.884m7.5 0c-.772-.82-1.187-1.74-1.187-3.232 0-2.625 1.843-4.978 4.523-6.14l.67 1.033c-2.502 1.353-2.991 3.108-3.186 4.215.403-.208.93-.28 1.447-.233 1.353.125 2.42 1.236 2.42 2.617a2.625 2.625 0 0 1-2.626 2.625 2.9 2.9 0 0 1-2.06-.884"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1oJN4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgStar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgStar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 18 18",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            stroke: "#FFA100",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M8.645 1.721a.398.398 0 0 1 .713 0l1.732 3.51a1.59 1.59 0 0 0 1.196.87l3.875.566a.398.398 0 0 1 .22.678l-2.802 2.729a1.59 1.59 0 0 0-.458 1.408l.662 3.855a.397.397 0 0 1-.579.42l-3.463-1.82a1.59 1.59 0 0 0-1.48 0l-3.463 1.82a.397.397 0 0 1-.577-.42l.66-3.854a1.59 1.59 0 0 0-.458-1.41L1.621 7.347a.398.398 0 0 1 .22-.68L5.717 6.1a1.59 1.59 0 0 0 1.197-.87z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dQZFv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLaptop);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLaptop = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14.998,
        height: 14.861,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 14.998 14.861",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#A36700",
            d: "M14.25 11.25a.75.75 0 0 1 .087 1.495l-.088.005H.75a.75.75 0 0 1-.088-1.495l.088-.005zM12.75 0a1.5 1.5 0 0 1 1.495 1.388l.004.112V9a1.5 1.5 0 0 1-1.387 1.496l-.113.004H2.25A1.5 1.5 0 0 1 .753 9.113L.749 9V1.5A1.5 1.5 0 0 1 2.137.004L2.249 0z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iy2eE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGroup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGroup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 33,
        height: 33,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 33 33",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M16.413 5.183c-2.842 0-5.145 2.69-5.145 6.008 0 2.301 1.108 4.3 2.735 5.309l-1.887.875-5.022 2.328q-.727.364-.727 1.236v5.53c.04.692.455 1.337 1.128 1.348h17.864c.768-.067 1.156-.686 1.164-1.347v-5.53q0-.873-.727-1.237l-4.84-2.328-2.011-.953c1.56-1.032 2.614-2.988 2.614-5.23 0-3.319-2.304-6.009-5.146-6.009m-8.3 2.113c-1.223.047-2.192.576-2.929 1.419a5.5 5.5 0 0 0-1.219 3.42c.05 1.773.844 3.451 2.256 4.33l-5.639 2.62Q0 19.303 0 20.104v4.438c.03.589.336 1.083.909 1.092h3.748v-4.695c.062-1.255.651-2.27 1.71-2.764l3.747-1.783q.437-.255.837-.691a8.43 8.43 0 0 1-.764-7.75c-.647-.396-1.375-.65-2.074-.655m16.736 0c-.8.017-1.539.311-2.146.727.969 2.534.701 5.39-.728 7.605q.473.545.983.837l3.602 1.71c1.097.602 1.663 1.625 1.674 2.764v4.695h3.856c.634-.055.904-.56.91-1.092v-4.438q0-.728-.582-1.02l-5.567-2.656c1.444-1.065 2.169-2.66 2.183-4.293-.039-1.293-.433-2.494-1.22-3.42-.82-.891-1.84-1.41-2.965-1.419"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"89Tk4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPound);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPound = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 40 40",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "url(#b)",
                    d: "M19.997 2.222a17.778 17.778 0 1 0 0 35.556 17.778 17.778 0 0 0 0-35.556m7.222 28.8H13.04a1.39 1.39 0 0 1-.245-2.756c.167 0 1.912-.544 1.912-3.933V21.11H11.93a1.111 1.111 0 0 1 0-2.223h2.778V13.2a6.5 6.5 0 0 1 6.355-6.666 6.26 6.26 0 0 1 4.678 2.155 1.4 1.4 0 1 1-2.078 1.878 3.42 3.42 0 0 0-2.555-1.211A3.72 3.72 0 0 0 17.53 13.2v5.688h3.333a1.111 1.111 0 0 1 0 2.223H17.53v3.222a8.5 8.5 0 0 1-.867 3.91H27.22a1.389 1.389 0 0 1 0 2.779"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 2.667,
                        x2: 60.667,
                        y1: 30,
                        y2: 2.667,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFEB14"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M0 0h40v40H0z"
                        })
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jWvIy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgImpactArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgImpactArrow = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 60.668,
        height: 31.334,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 60.668 31.334",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#FFA100",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M59.668 1 36.586 24.082c-1.161 1.162-1.742 1.742-2.412 1.96a2.93 2.93 0 0 1-1.813 0c-.67-.218-1.25-.799-2.412-1.96l-8.03-8.03c-1.162-1.161-1.742-1.742-2.412-1.96a2.93 2.93 0 0 0-1.813 0c-.67.218-1.25.799-2.412 1.96L1 30.334m58.668-8.8V1H39.134"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"84nYt":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("a5EOc");

},{}],"bgooQ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("bNbcy");

},{}],"8yt52":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("c5Yeh");

},{}],"ksK5R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPlatformUnion);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPlatformUnion = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 1522,
        height: 1059.89,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 1522 1059.89",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("foreignObject", {
                width: 1522,
                height: 1059.89,
                x: 0,
                y: 0,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    xmlns: "http://www.w3.org/1999/xhtml",
                    style: {
                        backdropFilter: "blur(2.65px)",
                        clipPath: "url(#a)",
                        height: "100%",
                        width: "100%"
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                "data-figma-bg-blur-radius": 5.3,
                filter: "url(#b)",
                shapeRendering: "crispEdges",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        fillOpacity: 0.12,
                        fillRule: "evenodd",
                        d: "M1361 97c33.14 0 60 26.863 60 60v737.89c0 33.137-26.86 60-60 60H161c-33.137 0-60-26.863-60-60V157c0-33.137 26.863-60 60-60z",
                        clipRule: "evenodd"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "url(#c)",
                        strokeOpacity: 0.23,
                        d: "M1361 96.5c33.41 0 60.5 27.087 60.5 60.5v737.89c0 33.413-27.09 60.5-60.5 60.5H161c-33.413 0-60.5-27.087-60.5-60.5V157c0-33.413 27.087-60.5 60.5-60.5z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c",
                        x1: 761,
                        x2: 818.5,
                        y1: 97,
                        y2: 1096.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.635,
                                stopColor: "#fff"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#04051B",
                                stopOpacity: 0
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fillRule: "evenodd",
                            d: "M1361 97c33.14 0 60 26.863 60 60v737.89c0 33.137-26.86 60-60 60H161c-33.137 0-60-26.863-60-60V157c0-33.137 26.863-60 60-60z",
                            clipRule: "evenodd"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "b",
                        width: 1522,
                        height: 1059.89,
                        x: 0,
                        y: 0,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                dy: 4
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                stdDeviation: 50
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                values: "0 0 0 0 1 0 0 0 0 0.631373 0 0 0 0 0 0 0 0 0.17 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_0_359"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_0_359",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gdwh4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgButtonSpark);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgButtonSpark = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14.222,
        height: 14.222,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 14.222 14.222",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#04051B",
            d: "M9.499 7.805 8.225 9.85a.42.42 0 0 1-.452.207q-.288-.045-.363-.34l-.415-1.66L2.951 12.1a.58.58 0 0 1-.408.171.55.55 0 0 1-.422-.17.56.56 0 0 1-.163-.415q0-.253.163-.415l4.044-4.06-1.659-.414q-.296-.074-.34-.363a.425.425 0 0 1 .207-.452l2.044-1.26L6.24 2.31a.4.4 0 0 1 .237-.43.41.41 0 0 1 .49.06l1.851 1.555 2.237-.904q.281-.12.49.09.206.206.088.488l-.904 2.237 1.556 1.837a.41.41 0 0 1 .06.489.4.4 0 0 1-.43.237zm-7.586-3.97a.284.284 0 0 1 0-.415l.77-.77a.284.284 0 0 1 .416 0l.77.77a.284.284 0 0 1 0 .415l-.77.77a.284.284 0 0 1-.415 0zm8.474 8.474-.77-.77a.284.284 0 0 1 0-.415l.77-.77a.284.284 0 0 1 .415 0l.77.77q.09.088.09.207t-.09.207l-.77.77a.284.284 0 0 1-.415 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Rti9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNavLogo1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNavLogo1 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21.849,
        height: 11.979,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 21.849 11.979",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M2.931 10.315a4 4 0 0 1 .327-.078l18.59-4.79L12.752.247A1.8 1.8 0 0 0 11.838 0c-.327 0-.643.09-.914.246L.496 6.218A.97.97 0 0 0 0 7.067v4.912a8.2 8.2 0 0 1 2.931-1.664m8.895-7.826c1.263 0 2.255 1.016 2.154 2.256-.09 1.116-1.06 1.998-2.187 1.987-1.195 0-2.109-.95-2.097-2.177.01-1.172.935-2.066 2.13-2.066"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fERD6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNavLogo2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNavLogo2 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 9.03,
        height: 11.119,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 9.03 11.119",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M.823 2.11S.463 2.98 0 4.052c.676.28 5.75 2.423 5.761 2.434a6.03 6.03 0 0 1 3.18 4.097c.033.179.067.357.09.536V0z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aXbjQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNavLogo3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNavLogo3 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 13.944,
        height: 12.202,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 13.944 12.202",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M13.405 7.122a3.3 3.3 0 0 0 .462-2.511 3.37 3.37 0 0 0-1.759-2.267L6.528 0l-2.47 5.783A7.26 7.26 0 0 1 0 9.746l3.867 2.21c.27.157.586.246.913.246a1.8 1.8 0 0 0 .913-.246l6.663-3.807c.44-.256.778-.602 1.049-1.027"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g2fNl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNavLogo4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNavLogo4 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12.165,
        height: 11.13,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 12.165 11.13",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M12.165 0 3.687 2.177l-.327.078A4.525 4.525 0 0 0 0 6.631c0 2.49 2.007 4.5 4.464 4.5a4.47 4.47 0 0 0 4.104-2.725l.226-.525C9.493 6.274 11.33 1.965 12.164 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h3Sly":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNavIconPlus);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNavIconPlus = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M3.333 8h9.334M8 3.333v9.334"
            })
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"CJrht":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNavIconClients);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNavIconClients = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.7,
            strokeWidth: 1.333,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M10.667 14v-1.333A2.667 2.667 0 0 0 8 10H4a2.667 2.667 0 0 0-2.667 2.667V14M6 7.333A2.667 2.667 0 1 0 6 2a2.667 2.667 0 0 0 0 5.333M14.667 14v-1.333a2.67 2.67 0 0 0-2-2.58M10.667 2.087a2.667 2.667 0 0 1 0 5.166"
            })
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"biX9g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNavIconFolder);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNavIconFolder = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.7,
            strokeWidth: 1.333,
            d: "M4 9.333 5 7.4a1.33 1.33 0 0 1 1.16-.733h7.173m0 0a1.333 1.333 0 0 1 1.294 1.666l-1.027 4a1.33 1.33 0 0 1-1.3 1H2.667A1.333 1.333 0 0 1 1.333 12V3.333A1.333 1.333 0 0 1 2.667 2h2.6a1.33 1.33 0 0 1 1.126.6l.54.8a1.33 1.33 0 0 0 1.114.6H12a1.333 1.333 0 0 1 1.333 1.333z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gARNz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNavIconMessage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNavIconMessage = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15.111,
        height: 15.111,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 15.111 15.111",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.7,
            strokeWidth: 1.333,
            d: "M4.407 5.668h5.667M4.407 8.186h5.667m-5.667 2.519h3.149m6.296-3.148a6.296 6.296 0 0 1-6.296 6.296H1.259V7.557a6.296 6.296 0 1 1 12.593 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lc40Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMiniRing);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMiniRing = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 123.621,
        height: 123.621,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 123.621 123.621",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                filter: "url(#a)",
                style: {
                    mixBlendMode: "multiply"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                        id: "b",
                        width: 97,
                        height: 97,
                        x: 13.366,
                        y: 13.366,
                        fill: "#000",
                        maskUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "#fff",
                                d: "M13.366 13.366h97v97h-97z"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M106.255 61.81c0 24.546-19.899 44.445-44.445 44.445S17.366 86.356 17.366 61.81 37.264 17.366 61.81 17.366s44.445 19.898 44.445 44.444m-67.122 0c0 12.525 10.153 22.678 22.677 22.678 12.525 0 22.678-10.153 22.678-22.678 0-12.524-10.153-22.677-22.678-22.677-12.524 0-22.677 10.153-22.677 22.677"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#FFA100",
                        d: "M106.255 61.81c0 24.546-19.899 44.445-44.445 44.445S17.366 86.356 17.366 61.81 37.264 17.366 61.81 17.366s44.445 19.898 44.445 44.444m-67.122 0c0 12.525 10.153 22.678 22.677 22.678 12.525 0 22.678-10.153 22.678-22.678 0-12.524-10.153-22.677-22.678-22.677-12.524 0-22.677 10.153-22.677 22.677"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "#585FCF",
                        strokeWidth: 6.531,
                        d: "M106.255 61.81c0 24.546-19.899 44.445-44.445 44.445S17.366 86.356 17.366 61.81 37.264 17.366 61.81 17.366s44.445 19.898 44.445 44.444Zm-67.122 0c0 12.525 10.153 22.678 22.677 22.678 12.525 0 22.678-10.153 22.678-22.678 0-12.524-10.153-22.677-22.678-22.677-12.524 0-22.677 10.153-22.677 22.677Z",
                        mask: "url(#b)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "a",
                    width: 123.621,
                    height: 123.621,
                    x: 0,
                    y: 0,
                    colorInterpolationFilters: "sRGB",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "effect1_foregroundBlur_0_308",
                            stdDeviation: 7.05
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4wtpD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgClientProfile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgClientProfile = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#755ADF",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#755ADF",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#755ADF",
                d: "M15.925 15.9a3.55 3.55 0 0 0 2.575-.787 3.47 3.47 0 0 0 1.255-2.36 3.47 3.47 0 0 0-.8-2.549 3.55 3.55 0 0 0-2.388-1.246 3.54 3.54 0 0 0-2.576.788 3.47 3.47 0 0 0-1.255 2.359c-.085.92.203 1.838.801 2.55a3.54 3.54 0 0 0 2.388 1.245m-4.353.598a1.77 1.77 0 0 0-1.288.394c-.36.295-.585.719-.627 1.18l-.023.247c-.11 1.187.56 2.26 1.582 3.043 1.026.787 2.464 1.332 4.067 1.48s3.116-.124 4.27-.71c1.147-.581 2.003-1.514 2.113-2.7l.023-.249a1.73 1.73 0 0 0-.4-1.274 1.77 1.77 0 0 0-1.194-.623z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9MrjD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMovementInsights);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMovementInsights = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#42CDFF",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#42CDFF",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#42CDFF",
                d: "M18.022 14.13a5.6 5.6 0 0 1-1.86-2.501c-.424-1.15-.558-2.309-.6-2.961-.013-.384-.318-.682-.682-.667-.364.014-.647.336-.633.72.014 2.884 1.294 5.108 1.294 5.108l-5.405 7.948a.797.797 0 0 0 .166 1.07c.314.238.75.176.991-.143l3.41-4.459 1.92 1.568.744 2.625a.75.75 0 0 0 .716.562c.414 0 .747-.354.747-.79a1 1 0 0 0-.016-.161c-.639-3.242-1.963-4.278-1.963-4.278l.994-1.188c.452 1.34.591 2.595.63 3.274a.62.62 0 0 0 .53.591c.33.041.63-.207.67-.556q.002-.027.002-.058c.097-3.798-1.008-5.206-1.655-5.703"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#42CDFF",
                d: "M19.5 13.14c.575-.519.668-1.4.206-1.97-.461-.568-1.302-.608-1.877-.09-.576.52-.668 1.401-.207 1.97s1.302.609 1.878.09"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3aLZ1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProgramGoals);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgramGoals = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                d: "M16.375 17.74c-.327.079-.668.066-.98-.037a1.6 1.6 0 0 1-.775-.543 1.47 1.47 0 0 1-.306-.864 1.55 1.55 0 0 1 .265-.895.514.514 0 0 1 .664-.157.45.45 0 0 1 .21.276.42.42 0 0 1-.065.34.7.7 0 0 0-.105.253.6.6 0 0 0 .007.267c.024.14.095.267.203.364a.7.7 0 0 0 .395.177.8.8 0 0 0 .44-.074.74.74 0 0 0 .32-.299.5.5 0 0 1 .302-.207.5.5 0 0 1 .364.046.44.44 0 0 1 .21.277.44.44 0 0 1-.06.342 1.7 1.7 0 0 1-.47.467 1.8 1.8 0 0 1-.619.267"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                d: "M22.387 14.668c.38 1.572.07 3.242-.858 4.642-.929 1.4-2.402 2.416-4.094 2.824s-3.467.175-4.931-.648c-1.465-.823-2.501-2.168-2.88-3.74-.38-1.571-.07-3.24.858-4.64.929-1.4 2.402-2.417 4.094-2.825a.5.5 0 0 1 .361.048.43.43 0 0 1 .21.273l.53 2.197a.44.44 0 0 1-.064.339.5.5 0 0 1-.298.207 3.3 3.3 0 0 0-1.596.893 3 3 0 0 0-.83 1.558c-.108.58-.03 1.17.225 1.696a3 3 0 0 0 1.633 1.319c.7.24 1.477.236 2.192-.01a3.3 3.3 0 0 0 1.716-1.333 2.88 2.88 0 0 0 .427-2.027.4.4 0 0 1-.006-.175.4.4 0 0 1 .066-.166.48.48 0 0 1 .302-.205l2.366-.57a.5.5 0 0 1 .372.052q.082.05.135.125.055.076.07.166"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                d: "M21.345 11.329a.6.6 0 0 1-.07.34l-1.048 1.581a1.7 1.7 0 0 1-.6.548q-.214.12-.457.178a2 2 0 0 1-.33.08l-.864.049-1.1 1.666a.53.53 0 0 1-.3.207.5.5 0 0 1-.36-.047.414.414 0 0 1-.148-.613l1.105-1.674-.352-.723a1.5 1.5 0 0 1-.142-.749c.019-.26.107-.516.257-.74l1.038-1.567a.66.66 0 0 1 .296-.224.625.625 0 0 1 .65.125.56.56 0 0 1 .155.318l.115 1.354 1.358-.517a.64.64 0 0 1 .354-.017.6.6 0 0 1 .296.172c.07.071.121.158.147.252"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2sXTH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProgramSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgramSummary = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .25C24.699.25 31.75 7.302 31.75 16S24.698 31.75 16 31.75.25 24.698.25 16 7.302.25 16 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M16 .25C24.699.25 31.75 7.302 31.75 16S24.698 31.75 16 31.75.25 24.698.25 16 7.302.25 16 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#FFA100",
                opacity: 0.8,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M19.222 11.01h-6.596l.45.591.654-2.013-.45.342h1.28a.47.47 0 0 0 .467-.466 2 2 0 0 1 .006-.143c.009-.098-.018.117-.003.02q.022-.126.067-.246l-.019.042.032-.068q.029-.056.062-.11c.018-.03.108-.151.012-.027a1.4 1.4 0 0 1 .208-.212c.072-.06-.092.068-.016.013q.102-.072.216-.125l-.042.018a1.4 1.4 0 0 1 .194-.06c.036-.01.191-.03.028-.01a1.4 1.4 0 0 1 .29-.003l-.046-.007.077.014q.061.013.123.032c.035.01.177.069.03.006a1.4 1.4 0 0 1 .259.15c-.115-.084-.042-.033-.017-.012a1.4 1.4 0 0 1 .146.141q.022.03.042.062.034.051.064.107c.017.033.075.172.015.026a1.4 1.4 0 0 1 .08.295c-.024-.148-.008-.054-.005-.02q.005.058.004.117a.47.47 0 0 0 .467.466h1.268l-.45-.342.653 2.013c.079.242.32.396.574.326.237-.065.405-.332.326-.574L19.02 9.34a.47.47 0 0 0-.45-.343H17.3l.466.467c0-.481-.185-.934-.511-1.285a1.85 1.85 0 0 0-1.325-.566c-1.01-.01-1.837.854-1.837 1.85l.466-.466h-1.28a.47.47 0 0 0-.45.343l-.654 2.013c-.094.291.157.59.45.59h6.596a.47.47 0 0 0 .467-.466.47.47 0 0 0-.467-.466"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M21.854 12.232v9.995q-.002.078-.01.157c-.01.098.018-.117.003-.02a1.8 1.8 0 0 1-.11.39c.06-.15-.01.013-.027.048a2 2 0 0 1-.132.21c-.054.077.071-.088.013-.015a2 2 0 0 1-.262.262c-.063.051.097-.07-.005.002a2 2 0 0 1-.257.15c-.029.014-.116.05.02-.006a2 2 0 0 1-.37.107 2 2 0 0 1-.19.01H11.32q-.088 0-.177-.007c-.033-.003-.13-.017.02.004q-.037-.005-.076-.013a2 2 0 0 1-.293-.082c-.03-.011-.116-.05.018.008a1.8 1.8 0 0 1-.343-.2c.129.094-.01-.012-.04-.038a2 2 0 0 1-.122-.122c-.026-.028-.133-.167-.037-.04a2 2 0 0 1-.157-.252q-.018-.033-.033-.068c-.035-.074.044.114-.002-.004a1.8 1.8 0 0 1-.096-.37c.023.149.008.054.005.02a2 2 0 0 1-.007-.158V12.178q.004-.079.012-.157c-.018.167.01-.036.02-.079a2 2 0 0 1 .041-.147c.012-.037.081-.202.016-.053q.066-.148.158-.283l.043-.06c-.085.116-.032.041-.011.017a2 2 0 0 1 .265-.259c-.118.095-.022.019.006 0q.124-.085.26-.148c.085-.04-.108.043-.02.008l.071-.026a2 2 0 0 1 .323-.079c-.15.023-.054.008-.02.005q.08-.007.16-.007h1.662l-.45-.59-.336 1.035c-.095.291.157.59.45.59h6.596c.293 0 .544-.299.45-.59l-.336-1.036-.45.59h1.635q.096 0 .191.01c.098.01-.117-.018-.02-.003a2 2 0 0 1 .248.059q.072.023.143.051c-.15-.06.012.01.047.028a2 2 0 0 1 .19.117c.103.07-.058-.049.005.002a2 2 0 0 1 .262.262c.06.072-.068-.091-.013-.016a2 2 0 0 1 .186.323c-.063-.14-.012-.027 0 .005a2 2 0 0 1 .087.347c-.024-.158-.005-.03-.002.005q.004.066.005.133a.47.47 0 0 0 .466.466.47.47 0 0 0 .467-.466c-.008-1.025-.717-1.946-1.718-2.19-.265-.065-.531-.065-.801-.065H18.89c-.293 0-.545.3-.45.59l.336 1.036.45-.59H12.63l.45.59.336-1.036c.094-.29-.157-.59-.45-.59h-1.418c-.273 0-.54.005-.809.07a2.2 2.2 0 0 0-1.187.767 2.3 2.3 0 0 0-.505 1.418v9.91c0 .67.262 1.323.779 1.76a2.3 2.3 0 0 0 1.422.552h8.974c.312 0 .615 0 .921-.083.96-.264 1.644-1.18 1.644-2.171v-9.97a.47.47 0 0 0-.467-.466.47.47 0 0 0-.466.466"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M11.705 15.126h8.439a.47.47 0 0 0 .466-.467.47.47 0 0 0-.466-.467h-8.439a.47.47 0 0 0-.467.467.47.47 0 0 0 .467.466m0 3.093h8.439a.47.47 0 0 0 .466-.466.47.47 0 0 0-.466-.467h-8.439a.47.47 0 0 0-.467.467c0 .254.213.466.467.466m0 3.093h5.775a.47.47 0 0 0 .466-.466.47.47 0 0 0-.466-.467h-5.775a.47.47 0 0 0-.467.466.47.47 0 0 0 .467.467m4.23-11.437a.47.47 0 0 0 .467-.467.47.47 0 0 0-.467-.467.47.47 0 0 0-.466.467.47.47 0 0 0 .466.467"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 33.45,
                        x2: 8.594,
                        y1: 32.008,
                        y2: -8.208,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 16,
                        x2: 16,
                        y1: 0,
                        y2: 32,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hkeyK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGoalApproach);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGoalApproach = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#8163F3",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#8163F3",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#8163F3",
                d: "M12.73 16.761v5.083c0 .301-.124.59-.343.802s-.517.332-.827.332h-1.39c-.31 0-.608-.12-.828-.332A1.12 1.12 0 0 1 9 21.844v-5.083c0-.302.123-.59.342-.805.219-.213.516-.335.827-.336h1.391c.311.001.608.123.827.336.22.214.342.503.342.805m5.135-3.295v8.4c-.002.301-.127.59-.348.802S17 23 16.688 23h-1.384c-.31 0-.609-.12-.829-.332a1.13 1.13 0 0 1-.347-.802v-8.4c0-.303.124-.593.345-.807s.52-.335.831-.335h1.384c.312 0 .611.12.832.335.22.213.345.504.345.807M23 10.142v11.724c-.002.301-.127.59-.347.802s-.519.332-.83.332H20.44c-.311 0-.61-.12-.83-.332a1.13 1.13 0 0 1-.347-.802V10.142c0-.303.124-.594.345-.808S20.128 9 20.44 9h1.383c.313 0 .612.12.832.334.221.214.345.505.345.808"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"tA9Si":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgInjuriesNotes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInjuriesNotes = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#EB4545",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#EB4444",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#EB4545",
                d: "M15.497 8.878a1.6 1.6 0 0 1 .534.053l4.642 1.303q.446.131.745.473.3.341.33.792l.241 3.409q.179 2.524-1.175 4.822t-3.843 3.29q-.111.043-.222.07a1.6 1.6 0 0 1-.245.035 1.6 1.6 0 0 1-.246 0 2 2 0 0 1-.23-.04q-2.604-.63-4.268-2.716-1.664-2.084-1.842-4.608l-.241-3.408q-.032-.45.216-.831.25-.38.67-.573l4.412-1.943a1.6 1.6 0 0 1 .522-.128m.324 4.6a.53.53 0 0 0-.49.563l.104 1.47-1.47.104a.53.53 0 0 0 .074 1.056l1.471-.104.104 1.471a.528.528 0 0 0 1.054-.075l-.104-1.47 1.47-.104a.528.528 0 0 0-.075-1.056l-1.47.104-.104-1.47a.53.53 0 0 0-.564-.49"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fb3Cp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPlanStructure);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPlanStructure = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#71BE41",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#71BE41",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#71BE41",
                d: "M9 20.9c0 1.19.91 2.1 2.1 2.1h9.8c1.19 0 2.1-.91 2.1-2.1v-5.6H9zm11.9-10.5h-1.4v-.7c0-.42-.28-.7-.7-.7s-.7.28-.7.7v.7h-4.2v-.7c0-.42-.28-.7-.7-.7s-.7.28-.7.7v.7h-1.4c-1.19 0-2.1.91-2.1 2.1v1.4h14v-1.4c0-1.19-.91-2.1-2.1-2.1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eHDnc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgIntensitySetup);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgIntensitySetup = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#42CDFF",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#42CDFF",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#42CDFF",
                fillRule: "evenodd",
                d: "M11.837 11.082c.177-.092.446-.175.806-.152.359.023.615.14.779.253a.73.73 0 0 1 .306.641 210 210 0 0 1-.23 4.015 210 210 0 0 1-.286 4.011.73.73 0 0 1-.386.597 1.53 1.53 0 0 1-.805.151 1.53 1.53 0 0 1-.78-.253.73.73 0 0 1-.305-.64c.017-.384.077-1.648.229-4.016s.255-3.629.287-4.01a.73.73 0 0 1 .385-.598m8.92.573a1.53 1.53 0 0 0-.78-.253c-.36-.023-.628.06-.805.151a.73.73 0 0 0-.386.597c-.032.381-.134 1.643-.287 4.01a210 210 0 0 0-.229 4.016.73.73 0 0 0 .306.64c.164.114.42.23.78.254.359.023.628-.06.805-.151a.73.73 0 0 0 .385-.597 210 210 0 0 0 .287-4.011c.152-2.368.212-3.632.23-4.015a.73.73 0 0 0-.307-.641m-11.055.76a1.5 1.5 0 0 0-.538.058c-.347.11-.472.424-.491.638-.026.299-.089 1.064-.175 2.407s-.122 2.11-.135 2.41c-.009.214.076.542.406.695.132.06.305.112.525.126s.4-.014.538-.058c.347-.11.472-.424.491-.638.026-.299.089-1.064.175-2.407s.122-2.11.135-2.409c.009-.215-.076-.543-.406-.696a1.5 1.5 0 0 0-.525-.126m13.527.962a1.5 1.5 0 0 0-.525-.126 1.5 1.5 0 0 0-.538.058c-.346.11-.472.424-.49.638a112 112 0 0 0-.176 2.407c-.086 1.342-.122 2.11-.135 2.41-.009.214.076.542.406.695.132.06.306.112.526.126s.398-.014.537-.058c.347-.11.472-.424.491-.638.026-.299.089-1.064.175-2.407.087-1.342.123-2.11.135-2.41.009-.214-.075-.542-.406-.695m-9.125 3.458.123-1.905c.02-.316.29-.466.567-.472q.085-.002.256 0c.227.001.57.011 1.046.042a19 19 0 0 1 1.296.125c.274.041.522.224.502.54l-.122 1.905c-.02.317-.29.466-.567.472a7 7 0 0 1-.257 0c-.227-.001-.57-.011-1.045-.042-.476-.03-.817-.064-1.043-.091a7 7 0 0 1-.254-.034c-.274-.041-.522-.224-.502-.54",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"59Zgc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgWeight);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgWeight = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#8e8e93",
            fillRule: "evenodd",
            d: "M4.307 3.68c.151-.086.382-.17.697-.164.315.005.543.097.69.189a.64.64 0 0 1 .294.547c0 .335 0 1.441-.036 3.515a184 184 0 0 1-.087 3.514.64.64 0 0 1-.312.537c-.15.087-.382.17-.697.165a1.33 1.33 0 0 1-.69-.19.64.64 0 0 1-.294-.547c0-.335 0-1.44.036-3.515.036-2.073.074-3.179.087-3.514a.64.64 0 0 1 .312-.536m7.811.137a1.33 1.33 0 0 0-.69-.19 1.33 1.33 0 0 0-.697.166.64.64 0 0 0-.313.536c-.012.335-.05 1.44-.086 3.514-.037 2.074-.037 3.18-.036 3.515 0 .168.065.406.293.547.148.093.376.184.69.19.315.005.547-.078.697-.165a.64.64 0 0 0 .313-.537c.012-.335.05-1.44.086-3.514.037-2.074.037-3.18.036-3.515a.64.64 0 0 0-.293-.547M2.497 4.932a1.3 1.3 0 0 0-.467.073c-.299.11-.395.39-.403.577-.01.262-.034.933-.054 2.109a99 99 0 0 0-.02 2.109c.001.188.088.47.383.59.117.048.271.086.464.09a1.3 1.3 0 0 0 .467-.073c.298-.11.395-.39.403-.577.01-.262.034-.933.054-2.109s.02-1.847.02-2.109c-.001-.188-.089-.47-.383-.59a1.3 1.3 0 0 0-.464-.09m11.85.288a1.3 1.3 0 0 0-.463-.09 1.3 1.3 0 0 0-.467.074c-.299.11-.395.389-.403.577-.01.262-.034.933-.055 2.108A99 99 0 0 0 12.94 10c.001.188.088.47.383.59.117.048.271.086.464.09a1.3 1.3 0 0 0 .467-.073c.298-.11.395-.39.402-.578.01-.261.035-.933.055-2.108s.02-1.847.02-2.11c-.002-.187-.089-.47-.383-.59M6.522 8.61l.03-1.668c.004-.277.234-.418.475-.435l.224-.011c.199-.008.499-.013.915-.006a17 17 0 0 1 1.137.057c.241.025.465.174.46.451l-.029 1.668c-.005.278-.234.419-.476.435l-.223.011a17 17 0 0 1-.915.006 17 17 0 0 1-1.137-.057c-.241-.024-.465-.174-.46-.45",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aRHII":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBarAndBench);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBarAndBench = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M1.7 8.374c.033-1.039.038-2.077.06-3.118.005-.313.17-.474.477-.47l.477.01c.014-.075.028-.136.04-.198.12-.672.645-1.204 1.314-1.246.41-.027 1.666.008 2.463.03l.03-1.834c.002-.15.027-.302.166-.376a.74.74 0 0 1 .346-.081c.833.006 1.666.023 2.496.04a1 1 0 0 1 .172.019c.21.04.328.17.332.385.004.183-.002.365-.005.547l-.024 1.359c.615.008 1.884.022 2.313.045q.294.017.564.138c.562.264.833.735.883 1.365l.492.008c.29.005.46.173.455.46a500 500 0 0 1-.062 3.374c-.005.293-.178.449-.467.446q-.907-.011-1.813-.032c-.35-.006-.513-.175-.506-.53l.028-1.622q.013-.828.029-1.654c.008-.305.186-.477.48-.474l.488.009c-.042-.386-.284-.616-.637-.625l-.668-.011-1.591-.028-.102 5.81 1.389.025a.59.59 0 0 1 .579.605.593.593 0 0 1-.6.585l-1.38-.025-.03 1.636 2.222.04a.59.59 0 0 1 .579.604.59.59 0 0 1-.6.585l-7.994-.14a.593.593 0 0 1-.579-.605.59.59 0 0 1 .6-.584l2.239.039.028-1.636-1.396-.025a.593.593 0 0 1-.579-.605.59.59 0 0 1 .6-.585l1.406.025.101-5.81-2.282-.04s-.598.236-.635.602l.49.008c.282.008.464.18.46.462a374 374 0 0 1-.06 3.375c-.005.282-.198.445-.477.44-.546-.01-1.092-.037-1.638-.023-.635.014-.687-.238-.673-.7"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Cuql":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOther);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOther = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M4.27 10.415A.28.28 0 0 0 4 10.16l-1.305-.023a.276.276 0 0 0-.28.246l-.361 2.947a1.26 1.26 0 0 0 .713 1.275 1.24 1.24 0 0 0 1.428-.277 1.25 1.25 0 0 0 .335-.954zm9.103 3.113-.258-2.958a.28.28 0 0 0-.272-.255l-1.304-.023a.275.275 0 0 0-.281.245l-.361 2.948a1.26 1.26 0 0 0 .301.965 1.24 1.24 0 0 0 1.418.328 1.25 1.25 0 0 0 .69-.737c.057-.165.08-.34.067-.513M10.021 2.811a2.76 2.76 0 0 1 1.251 1.045c.304.466.46 1.014.451 1.571l-.044 2.503a.28.28 0 0 1-.28.273.3.3 0 0 0-.218.097.3.3 0 0 0-.06.232l.126.698a.28.28 0 0 0 .267.227l1.327.023a.275.275 0 0 0 .269-.195c.03-.1.088-.283.211-.714a.3.3 0 0 0-.05-.235.3.3 0 0 0-.215-.104.276.276 0 0 1-.271-.283l.043-2.502a3.9 3.9 0 0 0-1.085-2.773 3.86 3.86 0 0 0-3.685-1.082.6.6 0 0 1-.277-.005 3.86 3.86 0 0 0-3.721.953 3.9 3.9 0 0 0-1.18 2.733l-.044 2.503a.28.28 0 0 1-.281.273.3.3 0 0 0-.217.096.3.3 0 0 0-.06.233c.109.436.16.62.187.72a.28.28 0 0 0 .262.206l1.326.023a.275.275 0 0 0 .275-.218l.156-.693a.3.3 0 0 0-.051-.234.3.3 0 0 0-.22-.104.276.276 0 0 1-.271-.283l.043-2.503a2.77 2.77 0 0 1 1.792-2.555.13.13 0 0 1 .16.047.134.134 0 0 1-.003.167 3.9 3.9 0 0 0-.843 2.36 2.8 2.8 0 0 0 .775 1.981 2.756 2.756 0 0 0 3.909.068 2.8 2.8 0 0 0 .844-1.952 3.9 3.9 0 0 0-.76-2.388.134.134 0 0 1 .002-.167.13.13 0 0 1 .161-.042M7.825 7.028A1.65 1.65 0 0 1 6.66 6.52a1.67 1.67 0 0 1-.465-1.188c.009-.488.145-.965.395-1.384s.605-.763 1.03-1a.55.55 0 0 1 .552.01c.416.251.759.608.994 1.035s.354.909.346 1.397c-.008.442-.19.864-.506 1.171a1.65 1.65 0 0 1-1.181.468"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Xg1S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPainPoint0);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPainPoint0 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 29.551,
        height: 29.551,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 29.551 29.551",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                    cx: 14.775,
                    cy: 14.775,
                    r: 6.895,
                    fill: "#CA1A1A",
                    fillOpacity: 0.72
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.779,
                cy: 14.776,
                r: 4.925,
                fill: "#D52222",
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.779,
                cy: 14.776,
                r: 4.821,
                stroke: "#FFB4B4",
                strokeOpacity: 0.52,
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.776,
                cy: 14.774,
                r: 2.783,
                fill: "#D52222",
                fillOpacity: 0.36,
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.778,
                cy: 14.776,
                r: 0.604,
                fill: "#D52222",
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "a",
                    width: 29.551,
                    height: 29.551,
                    x: 0,
                    y: 0,
                    colorInterpolationFilters: "sRGB",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "effect1_foregroundBlur_0_165",
                            stdDeviation: 3.94
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"60zbG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPainPoint1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPainPoint1 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 29.551,
        height: 29.551,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 29.551 29.551",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                    cx: 14.775,
                    cy: 14.775,
                    r: 6.895,
                    fill: "#CA1A1A",
                    fillOpacity: 0.72
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.771,
                cy: 14.774,
                r: 4.925,
                fill: "#D52222",
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.771,
                cy: 14.774,
                r: 4.821,
                stroke: "#FFB4B4",
                strokeOpacity: 0.52,
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.768,
                cy: 14.777,
                r: 2.783,
                fill: "#D52222",
                fillOpacity: 0.36,
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.771,
                cy: 14.774,
                r: 0.604,
                fill: "#D52222",
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "a",
                    width: 29.551,
                    height: 29.551,
                    x: 0,
                    y: 0,
                    colorInterpolationFilters: "sRGB",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "effect1_foregroundBlur_0_202",
                            stdDeviation: 3.94
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aduug":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPainPoint2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPainPoint2 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 29.551,
        height: 29.551,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 29.551 29.551",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                    cx: 14.775,
                    cy: 14.775,
                    r: 6.895,
                    fill: "#CA1A1A",
                    fillOpacity: 0.72
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.779,
                cy: 14.774,
                r: 4.925,
                fill: "#D52222",
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.779,
                cy: 14.774,
                r: 4.821,
                stroke: "#FFB4B4",
                strokeOpacity: 0.52,
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.769,
                cy: 14.774,
                r: 2.783,
                fill: "#D52222",
                fillOpacity: 0.36,
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.771,
                cy: 14.776,
                r: 0.604,
                fill: "#D52222",
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "a",
                    width: 29.551,
                    height: 29.551,
                    x: 0,
                    y: 0,
                    colorInterpolationFilters: "sRGB",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "effect1_foregroundBlur_0_160",
                            stdDeviation: 3.94
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4trl7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPainPoint3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPainPoint3 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 29.551,
        height: 29.551,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 29.551 29.551",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                    cx: 14.775,
                    cy: 14.775,
                    r: 6.895,
                    fill: "#CA1A1A",
                    fillOpacity: 0.72
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.779,
                cy: 14.774,
                r: 4.925,
                fill: "#D52222",
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.779,
                cy: 14.774,
                r: 4.821,
                stroke: "#FFB4B4",
                strokeOpacity: 0.52,
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.776,
                cy: 14.776,
                r: 2.783,
                fill: "#D52222",
                fillOpacity: 0.36,
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.771,
                cy: 14.774,
                r: 0.604,
                fill: "#D52222",
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "a",
                    width: 29.551,
                    height: 29.551,
                    x: 0,
                    y: 0,
                    colorInterpolationFilters: "sRGB",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "effect1_foregroundBlur_0_297",
                            stdDeviation: 3.94
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"koAYG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPainPoint4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPainPoint4 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 29.551,
        height: 29.551,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 29.551 29.551",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                    cx: 14.775,
                    cy: 14.775,
                    r: 6.895,
                    fill: "#CA1A1A",
                    fillOpacity: 0.72
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.771,
                cy: 14.775,
                r: 4.925,
                fill: "#D52222",
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.771,
                cy: 14.775,
                r: 4.821,
                stroke: "#FFB4B4",
                strokeOpacity: 0.52,
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.776,
                cy: 14.776,
                r: 2.783,
                fill: "#D52222",
                fillOpacity: 0.36,
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.778,
                cy: 14.776,
                r: 0.604,
                fill: "#D52222",
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "a",
                    width: 29.551,
                    height: 29.551,
                    x: 0,
                    y: 0,
                    colorInterpolationFilters: "sRGB",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "effect1_foregroundBlur_0_155",
                            stdDeviation: 3.94
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8btDH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPainPoint5);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPainPoint5 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 29.551,
        height: 29.551,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 29.551 29.551",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                    cx: 14.775,
                    cy: 14.775,
                    r: 6.895,
                    fill: "#CA1A1A",
                    fillOpacity: 0.72
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.771,
                cy: 14.774,
                r: 4.925,
                fill: "#D52222",
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.771,
                cy: 14.774,
                r: 4.821,
                stroke: "#FFB4B4",
                strokeOpacity: 0.52,
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.776,
                cy: 14.776,
                r: 2.783,
                fill: "#D52222",
                fillOpacity: 0.36,
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.771,
                cy: 14.774,
                r: 0.604,
                fill: "#D52222",
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "a",
                    width: 29.551,
                    height: 29.551,
                    x: 0,
                    y: 0,
                    colorInterpolationFilters: "sRGB",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "effect1_foregroundBlur_0_315",
                            stdDeviation: 3.94
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9mJvw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPainPoint6);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPainPoint6 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 29.551,
        height: 29.551,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 29.551 29.551",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                filter: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                    cx: 14.775,
                    cy: 14.775,
                    r: 6.895,
                    fill: "#CA1A1A",
                    fillOpacity: 0.72
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.779,
                cy: 14.776,
                r: 4.925,
                fill: "#D52222",
                fillOpacity: 0.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.779,
                cy: 14.776,
                r: 4.821,
                stroke: "#FFB4B4",
                strokeOpacity: 0.52,
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.776,
                cy: 14.778,
                r: 2.783,
                fill: "#D52222",
                fillOpacity: 0.36,
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.778,
                cy: 14.776,
                r: 0.604,
                fill: "#D52222",
                stroke: "#FF7A7A",
                strokeWidth: 0.208
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "a",
                    width: 29.551,
                    height: 29.551,
                    x: 0,
                    y: 0,
                    colorInterpolationFilters: "sRGB",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "BackgroundImageFix",
                            result: "shape"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            result: "effect1_foregroundBlur_0_150",
                            stdDeviation: 3.94
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2dyFJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDonutArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDonutArrow = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 28.889,
        height: 9.778,
        fill: "none",
        overflow: "visible",
        preserveAspectRatio: "none",
        style: {
            display: "block"
        },
        viewBox: "0 0 28.889 9.778",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeWidth: 0.889,
            d: "M28.444.444H9.334l-8.89 8.89"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4zTfT":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Login", ()=>Login);
var _jsxRuntime = require("react/jsx-runtime");
var _loginScss = require("./Login.scss");
// 🔹 React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 Routing
var _reactRouterDom = require("react-router-dom");
// 🔹 Components
var _button = require("../../components/Button/Button");
// 🔹 Store
var _sessionStore = require("src/store/sessionStore");
var _appAlert = require("src/utils/appAlert");
var _validation = require("src/utils/validation");
// 🔹 Assets
var _useAuthLogin = require("src/api/mutations/useAuthLogin");
var _useAuthSocialLogin = require("src/api/mutations/useAuthSocialLogin");
var _useGetOnboardingMasterData = require("src/api/mutations/useGetOnboardingMasterData");
var _useGetOnboardingState = require("src/api/mutations/useGetOnboardingState");
var _onboardingUtils = require("src/utils/onboardingUtils");
var _queryClient = require("src/api/queryClient");
var _rightArrowSvg = require("../../../../assets/images/onboarding-trainer/right-arrow.svg");
var _infoSvg = require("../../../../assets/images/onboarding-trainer/info.svg");
var _eyeClosedSvg = require("../../../../assets/images/onboarding-trainer/eye-closed.svg");
var _eyeOpenSvg = require("../../../../assets/images/onboarding-trainer/eye-open.svg");
var _googleSvg = require("../../../../assets/images/onboarding-trainer/google.svg");
var _appleSvg = require("../../../../assets/images/onboarding-trainer/apple.svg");
var _logoSvg = require("../../../../assets/images/onboarding-trainer/logo.svg");
const Login = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [email, setEmail] = (0, _react.useState)('');
    const [password, setPassword] = (0, _react.useState)('');
    const [showPassword, setShowPassword] = (0, _react.useState)(false);
    const [rememberMe, setRememberMe] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)({});
    const [isNavigating, setIsNavigating] = (0, _react.useState)(false);
    const setToken = (0, _sessionStore.sessionStore)((s)=>s.setToken);
    const { mutateAsync: login, isPending: isLoginPending } = (0, _useAuthLogin.useAuthLogin)();
    const { mutateAsync: socialLogin, isPending: isSocialLoginPending } = (0, _useAuthSocialLogin.useAuthSocialLogin)();
    // 🔹 Preload Master Data while user is typing so the onboarding screens load instantly
    (0, _useGetOnboardingMasterData.useGetOnboardingMasterData)();
    const handleLogin = async (e)=>{
        e.preventDefault();
        const newErrors = {};
        if (!email.trim()) newErrors.email = 'Please fill this before continuing';
        else if (!(0, _validation.isValidEmail)(email)) newErrors.email = 'Please enter a valid email address.';
        if (!password) newErrors.password = 'Please fill this before continuing';
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        try {
            setIsNavigating(true);
            const user = await login({
                email,
                password,
                rememberMe
            });
            // Fetch required data before navigating so it's instantly available
            const [, onboardingStateResult] = await Promise.all([
                (0, _queryClient.queryClient).fetchQuery({
                    queryKey: [
                        'onboarding-master-data'
                    ],
                    queryFn: (0, _useGetOnboardingMasterData.fetchOnboardingMasterData)
                }),
                (0, _queryClient.queryClient).fetchQuery({
                    queryKey: [
                        'onboarding-state',
                        user.uid
                    ],
                    queryFn: ()=>(0, _useGetOnboardingState.fetchOnboardingState)(user.uid)
                })
            ]);
            setErrors({});
            // Set the session token and the user's profile fetched from backend
            setToken(await user.getIdToken(), {
                ...onboardingStateResult?.profile,
                uid: user.uid
            });
            // toast.success('Login successful!', {
            //   position: 'top-right',
            //   style: {
            //     borderRadius: '8px',
            //     background: '#0a0b24',
            //     color: '#fff',
            //     border: '1px solid rgba(255, 255, 255, 0.1)',
            //     minWidth: 'max-content',
            //   },
            //   iconTheme: {
            //     primary: '#ffb703',
            //     secondary: '#000',
            //   },
            const activeOnboarding = onboardingStateResult?.onboarding ?? onboardingStateResult?.profile?.onboarding;
            const progress = (0, _onboardingUtils.computeOnboardingProgress)(activeOnboarding);
            if (progress.isFullyCompleted || progress.isSkipped) navigate('/onboarding-trainer/dashboard');
            else navigate('/onboarding-trainer');
        } catch (error) {
            setIsNavigating(false);
            const newErrors = {};
            if (error.code === 'auth/wrong-password') newErrors.password = 'Incorrect password. Please try again.';
            else if (error.code === 'auth/invalid-credential') newErrors.password = 'Invalid email or password. Please try again.';
            else if (error.code === 'auth/user-not-found') newErrors.email = 'No account found with this email address.';
            else if (error.code === 'auth/invalid-email') newErrors.email = 'Please enter a valid email address.';
            else if (error.code === 'auth/too-many-requests') newErrors.email = 'Too many failed login attempts. Please try again later.';
            else if (error.message) {
                // Fallback for custom errors like the email verification one
                const cleanedMessage = error.message.replace('Firebase: Error ', '').replace(/\(auth.*\)\./, '').trim();
                if (cleanedMessage.includes('verify your email before logging in')) {
                    navigate('/onboarding-trainer/signup/verify-email', {
                        state: {
                            email,
                            fromLogin: true
                        }
                    });
                    return;
                }
                newErrors.email = cleanedMessage;
            }
            setErrors(newErrors);
        }
    };
    const handleSocialLogin = async (providerName)=>{
        try {
            setIsNavigating(true);
            const socialResult = await socialLogin({
                providerName,
                rememberMe
            });
            const user = socialResult.user;
            // Fetch required data before navigating so it's instantly available
            const [, onboardingStateResult] = await Promise.all([
                (0, _queryClient.queryClient).fetchQuery({
                    queryKey: [
                        'onboarding-master-data'
                    ],
                    queryFn: (0, _useGetOnboardingMasterData.fetchOnboardingMasterData)
                }),
                (0, _queryClient.queryClient).fetchQuery({
                    queryKey: [
                        'onboarding-state',
                        user.uid
                    ],
                    queryFn: ()=>(0, _useGetOnboardingState.fetchOnboardingState)(user.uid)
                })
            ]);
            const backendProfile = onboardingStateResult?.profile || {};
            let name = backendProfile.name || socialResult.firstName;
            let surname = backendProfile.surname;
            if ((!surname || surname === 'Trainer') && socialResult.lastName && socialResult.lastName !== 'Trainer') surname = socialResult.lastName;
            else if (!surname) surname = socialResult.lastName || '';
            if (name && name.includes(' ') && (!surname || surname === 'Trainer')) {
                const parts = name.trim().split(/\s+/);
                name = parts[0];
                surname = parts.slice(1).join(' ');
            }
            setToken(await user.getIdToken(), {
                ...backendProfile,
                uid: user.uid,
                name,
                surname,
                avatarUrl: backendProfile.avatarUrl || backendProfile.avatar_url || socialResult.avatarUrl || user.photoURL || undefined
            });
            const activeOnboarding = onboardingStateResult?.onboarding ?? onboardingStateResult?.profile?.onboarding;
            const progress = (0, _onboardingUtils.computeOnboardingProgress)(activeOnboarding);
            if (progress.isFullyCompleted || progress.isSkipped) navigate('/onboarding-trainer/dashboard');
            else navigate('/onboarding-trainer');
        } catch (error) {
            setIsNavigating(false);
            (0, _appAlert.toast).error(error.message || 'Social login failed');
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "onboarding-login-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "login-box",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "login-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "logo-placeholder",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                className: "login-title",
                                children: "Log in your"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "login-subtitle",
                                children: "Welcome back! Please enter your details."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                        onSubmit: handleLogin,
                        className: "login-form auth-form-common",
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "input-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: "EMAIL"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "email",
                                        name: "email",
                                        autoComplete: "email",
                                        placeholder: "john.doe@example.com",
                                        value: email,
                                        onChange: (e)=>{
                                            setEmail(e.target.value);
                                            if (errors.email) setErrors({
                                                ...errors,
                                                email: ''
                                            });
                                        },
                                        className: errors.email ? 'error-input' : ''
                                    }),
                                    errors.email && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "error-message",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSvg.ReactComponent), {}),
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: errors.email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "input-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: "PASSWORD"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "password-input-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: showPassword ? 'text' : 'password',
                                                name: "password",
                                                autoComplete: "current-password",
                                                placeholder: "Enter your password",
                                                value: password,
                                                onChange: (e)=>{
                                                    setPassword(e.target.value);
                                                    if (errors.password) setErrors({
                                                        ...errors,
                                                        password: ''
                                                    });
                                                },
                                                className: errors.password ? 'error-input' : ''
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "eye-btn",
                                                onClick: ()=>setShowPassword(!showPassword),
                                                children: showPassword ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyeOpenSvg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyeClosedSvg.ReactComponent), {})
                                            })
                                        ]
                                    }),
                                    errors.password && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "error-message",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSvg.ReactComponent), {}),
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: errors.password
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-actions",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        className: "checkbox-label",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "checkbox",
                                                checked: rememberMe,
                                                onChange: (e)=>setRememberMe(e.target.checked)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "checkmark"
                                            }),
                                            "Remember me"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: "/onboarding-trainer/forgot-password",
                                        className: "forgot-password",
                                        children: "Forgot password?"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                type: "submit",
                                variant: "primary",
                                svg: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rightArrowSvg.ReactComponent), {}),
                                className: "submit-btn right-arrow",
                                isLoading: isLoginPending || isNavigating,
                                disabled: isSocialLoginPending || isNavigating,
                                children: "Log in"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "privacy-text",
                                children: [
                                    "By continuing you agree with our",
                                    ' ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        onClick: ()=>navigate('/privacy-policy'),
                                        children: "Privacy Policy"
                                    }),
                                    " and",
                                    ' ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                        onClick: ()=>navigate('/terms-of-service'),
                                        children: "Terms & Conditions"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "auth-divider",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "OR LOG IN WITH"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "auth-social-login",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: "social-btn google-btn",
                                onClick: ()=>handleSocialLogin('google'),
                                disabled: isLoginPending || isSocialLoginPending || isNavigating,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleSvg.ReactComponent), {}),
                                    "Google"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: "social-btn apple-btn",
                                onClick: ()=>handleSocialLogin('apple'),
                                disabled: isLoginPending || isSocialLoginPending || isNavigating,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appleSvg.ReactComponent), {}),
                                    "Apple"
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        className: "auth-bottom-link",
                        children: [
                            "Don't have an account? ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                to: "/onboarding-trainer/signup",
                                children: "Sign up"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "login-bg-glow"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","./Login.scss":"7ZCO1","react":"bmhQu","react-router-dom":"f3cgC","../../components/Button/Button":"jLE7r","src/store/sessionStore":"kPSO3","src/utils/appAlert":"de4Mq","src/utils/validation":"1NJZx","src/api/mutations/useAuthLogin":"abWlC","src/api/mutations/useAuthSocialLogin":"7DD6P","src/api/mutations/useGetOnboardingMasterData":"dhU6k","src/api/mutations/useGetOnboardingState":"3gbTg","src/utils/onboardingUtils":"gnh1N","src/api/queryClient":"406Ct","../../../../assets/images/onboarding-trainer/right-arrow.svg":"jEMFR","../../../../assets/images/onboarding-trainer/info.svg":"9S52k","../../../../assets/images/onboarding-trainer/eye-closed.svg":"i5yb0","../../../../assets/images/onboarding-trainer/eye-open.svg":"13Rvh","../../../../assets/images/onboarding-trainer/google.svg":"KnXaD","../../../../assets/images/onboarding-trainer/apple.svg":"gOuz3","../../../../assets/images/onboarding-trainer/logo.svg":"iy8G7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7ZCO1":[function() {},{}],"1NJZx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isValidEmail", ()=>isValidEmail);
const isValidEmail = (email)=>{
    if (!email) return false;
    return /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/.test(email.trim());
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"abWlC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthLogin", ()=>useAuthLogin);
var _reactQuery = require("@tanstack/react-query");
var _auth = require("firebase/auth");
var _firebase = require("src/config/firebase");
function useAuthLogin() {
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const { email, password, rememberMe } = payload;
            // Set persistence based on "remember me"
            await (0, _auth.setPersistence)((0, _firebase.auth), rememberMe ? (0, _auth.browserLocalPersistence) : (0, _auth.browserSessionPersistence));
            const userCredential = await (0, _auth.signInWithEmailAndPassword)((0, _firebase.auth), email, password);
            if (!userCredential.user.emailVerified) // await signOut(auth); // Keep Firebase auth alive so the user can resend the verification email
            throw new Error('Please verify your email before logging in. Check your inbox/spam folder.');
            return userCredential.user;
        }
    });
}

},{"@tanstack/react-query":"ehKs4","firebase/auth":"dZ6yw","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7DD6P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthSocialLogin", ()=>useAuthSocialLogin);
var _reactQuery = require("@tanstack/react-query");
var _auth = require("firebase/auth");
var _firebase = require("src/config/firebase");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
function useAuthSocialLogin() {
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const { providerName, rememberMe } = payload;
            // Set persistence if requested (optional for signup, but good for login)
            if (rememberMe !== undefined) await (0, _auth.setPersistence)((0, _firebase.auth), rememberMe ? (0, _auth.browserLocalPersistence) : (0, _auth.browserSessionPersistence));
            const provider = providerName === 'google' ? new (0, _auth.GoogleAuthProvider)() : new (0, _auth.OAuthProvider)('apple.com');
            const result = await (0, _auth.signInWithPopup)((0, _firebase.auth), provider);
            const user = result.user;
            const additionalInfo = (0, _auth.getAdditionalUserInfo)(result);
            const oauthProfile = additionalInfo?.profile || {};
            // 1. Try to extract first & last name from OAuth Profile (Google / Apple)
            let firstName = (oauthProfile.given_name || oauthProfile.givenName || oauthProfile.first_name || '').trim();
            let lastName = (oauthProfile.family_name || oauthProfile.familyName || oauthProfile.last_name || '').trim();
            // Apple may pass name as an object: { firstName: '...', lastName: '...' }
            if (!firstName && typeof oauthProfile.name === 'object' && oauthProfile.name) {
                firstName = (oauthProfile.name.firstName || oauthProfile.name.givenName || '').trim();
                lastName = (oauthProfile.name.lastName || oauthProfile.name.familyName || '').trim();
            }
            // 2. If name is still not completely split, try displayName or oauthProfile.name (as string)
            const rawFullName = (user.displayName || (typeof oauthProfile.name === 'string' ? oauthProfile.name : '') || '').trim();
            if ((!firstName || !lastName) && rawFullName) {
                const parts = rawFullName.split(/\s+/);
                if (!firstName && parts[0]) firstName = parts[0];
                if (!lastName && parts.length > 1) lastName = parts.slice(1).join(' ');
            }
            // If firstName has spaces and lastName is empty, split them
            if (firstName && !lastName && /\s+/.test(firstName)) {
                const parts = firstName.split(/\s+/);
                firstName = parts[0] || '';
                lastName = parts.slice(1).join(' ') || '';
            }
            // 3. Fallback from email if firstName or lastName is still empty
            const hasLetterRegex = /[\p{L}]/u;
            if (!firstName || !hasLetterRegex.test(firstName)) {
                const emailPrefix = (user.email || '').split('@')[0] || '';
                const cleanPrefix = emailPrefix.split(/[._-]/)[0] || '';
                const lettersOnly = cleanPrefix.replace(/[^\p{L}]/gu, '');
                firstName = lettersOnly.length > 0 ? lettersOnly.charAt(0).toUpperCase() + lettersOnly.slice(1) : 'Trainer';
            }
            if (!lastName || !hasLetterRegex.test(lastName)) {
                const emailPrefix = (user.email || '').split('@')[0] || '';
                const emailParts = emailPrefix.split(/[._-]/);
                if (emailParts.length > 1) {
                    const secondPartLetters = emailParts[1].replace(/[^\p{L}]/gu, '');
                    if (secondPartLetters.length > 0) lastName = secondPartLetters.charAt(0).toUpperCase() + secondPartLetters.slice(1);
                }
            }
            if (!lastName || !hasLetterRegex.test(lastName)) lastName = 'Trainer';
            const email = (user.email || user.providerData?.[0]?.email || (0, _firebase.auth).currentUser?.email || '').trim().toLowerCase();
            const avatarUrl = user.photoURL || oauthProfile.picture || '';
            // Create or update user profile in Backend
            const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).CREATE_USER_PROFILE_API_HOST}`;
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    uid: user.uid,
                    email: email,
                    name: firstName.trim().slice(0, 50),
                    surname: lastName.trim().slice(0, 50),
                    avatar_url: avatarUrl || undefined,
                    avatarUrl: avatarUrl || undefined
                })
            });
            // 409 means the user already exists, which is fine for login
            if (!response.ok && response.status !== 409) console.error('Failed to create user profile in backend:', await response.text());
            return {
                user,
                firstName: firstName.trim(),
                lastName: lastName.trim(),
                avatarUrl
            };
        }
    });
}

},{"@tanstack/react-query":"ehKs4","firebase/auth":"dZ6yw","src/config/firebase":"cmjIE","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"406Ct":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "queryClient", ()=>queryClient);
var _reactQuery = require("@tanstack/react-query");
const queryClient = new (0, _reactQuery.QueryClient)();

},{"@tanstack/react-query":"b8keQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b8keQ":[function(require,module,exports,__globalThis) {
// src/index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HydrationBoundary", ()=>(0, _hydrationBoundaryJs.HydrationBoundary));
parcelHelpers.export(exports, "IsRestoringProvider", ()=>(0, _isRestoringProviderJs.IsRestoringProvider));
parcelHelpers.export(exports, "QueryClientContext", ()=>(0, _queryClientProviderJs.QueryClientContext));
parcelHelpers.export(exports, "QueryClientProvider", ()=>(0, _queryClientProviderJs.QueryClientProvider));
parcelHelpers.export(exports, "QueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryJs.QueryErrorResetBoundary));
parcelHelpers.export(exports, "infiniteQueryOptions", ()=>(0, _infiniteQueryOptionsJs.infiniteQueryOptions));
parcelHelpers.export(exports, "mutationOptions", ()=>(0, _mutationOptionsJs.mutationOptions));
parcelHelpers.export(exports, "queryOptions", ()=>(0, _queryOptionsJs.queryOptions));
parcelHelpers.export(exports, "useInfiniteQuery", ()=>(0, _useInfiniteQueryJs.useInfiniteQuery));
parcelHelpers.export(exports, "useIsFetching", ()=>(0, _useIsFetchingJs.useIsFetching));
parcelHelpers.export(exports, "useIsMutating", ()=>(0, _useMutationStateJs.useIsMutating));
parcelHelpers.export(exports, "useIsRestoring", ()=>(0, _isRestoringProviderJs.useIsRestoring));
parcelHelpers.export(exports, "useMutation", ()=>(0, _useMutationJs.useMutation));
parcelHelpers.export(exports, "useMutationState", ()=>(0, _useMutationStateJs.useMutationState));
parcelHelpers.export(exports, "usePrefetchInfiniteQuery", ()=>(0, _usePrefetchInfiniteQueryJs.usePrefetchInfiniteQuery));
parcelHelpers.export(exports, "usePrefetchQuery", ()=>(0, _usePrefetchQueryJs.usePrefetchQuery));
parcelHelpers.export(exports, "useQueries", ()=>(0, _useQueriesJs.useQueries));
parcelHelpers.export(exports, "useQuery", ()=>(0, _useQueryJs.useQuery));
parcelHelpers.export(exports, "useQueryClient", ()=>(0, _queryClientProviderJs.useQueryClient));
parcelHelpers.export(exports, "useQueryErrorResetBoundary", ()=>(0, _queryErrorResetBoundaryJs.useQueryErrorResetBoundary));
parcelHelpers.export(exports, "useSuspenseInfiniteQuery", ()=>(0, _useSuspenseInfiniteQueryJs.useSuspenseInfiniteQuery));
parcelHelpers.export(exports, "useSuspenseQueries", ()=>(0, _useSuspenseQueriesJs.useSuspenseQueries));
parcelHelpers.export(exports, "useSuspenseQuery", ()=>(0, _useSuspenseQueryJs.useSuspenseQuery));
var _queryCore = require("@tanstack/query-core");
parcelHelpers.exportAll(_queryCore, exports);
var _typesJs = require("./types.js");
parcelHelpers.exportAll(_typesJs, exports);
var _useQueriesJs = require("./useQueries.js");
var _useQueryJs = require("./useQuery.js");
var _useSuspenseQueryJs = require("./useSuspenseQuery.js");
var _useSuspenseInfiniteQueryJs = require("./useSuspenseInfiniteQuery.js");
var _useSuspenseQueriesJs = require("./useSuspenseQueries.js");
var _usePrefetchQueryJs = require("./usePrefetchQuery.js");
var _usePrefetchInfiniteQueryJs = require("./usePrefetchInfiniteQuery.js");
var _queryOptionsJs = require("./queryOptions.js");
var _infiniteQueryOptionsJs = require("./infiniteQueryOptions.js");
var _queryClientProviderJs = require("./QueryClientProvider.js");
var _hydrationBoundaryJs = require("./HydrationBoundary.js");
var _queryErrorResetBoundaryJs = require("./QueryErrorResetBoundary.js");
var _useIsFetchingJs = require("./useIsFetching.js");
var _useMutationStateJs = require("./useMutationState.js");
var _useMutationJs = require("./useMutation.js");
var _mutationOptionsJs = require("./mutationOptions.js");
var _useInfiniteQueryJs = require("./useInfiniteQuery.js");
var _isRestoringProviderJs = require("./IsRestoringProvider.js");

},{"@tanstack/query-core":"jKUpW","./types.js":"kGIw6","./useQueries.js":false,"./useQuery.js":"lWWNx","./useSuspenseQuery.js":false,"./useSuspenseInfiniteQuery.js":false,"./useSuspenseQueries.js":false,"./usePrefetchQuery.js":false,"./usePrefetchInfiniteQuery.js":false,"./queryOptions.js":false,"./infiniteQueryOptions.js":false,"./QueryClientProvider.js":"97Oud","./HydrationBoundary.js":false,"./QueryErrorResetBoundary.js":false,"./useIsFetching.js":false,"./useMutationState.js":false,"./useMutation.js":"ehKs4","./mutationOptions.js":false,"./useInfiniteQuery.js":false,"./IsRestoringProvider.js":false,"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jKUpW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryClient", ()=>QueryClient);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/queryClient.ts
var _utilsJs = require("./utils.js");
var _queryCacheJs = require("./queryCache.js");
var _mutationCacheJs = require("./mutationCache.js");
var _focusManagerJs = require("./focusManager.js");
var _onlineManagerJs = require("./onlineManager.js");
var _notifyManagerJs = require("./notifyManager.js");
var _infiniteQueryBehaviorJs = require("./infiniteQueryBehavior.js");
var _queryCache, _mutationCache, _defaultOptions, _queryDefaults, _mutationDefaults, _mountCount, _unsubscribeFocus, _unsubscribeOnline;
var QueryClient = class {
    constructor(config = {}){
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _queryCache);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _mutationCache);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _defaultOptions);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _queryDefaults);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _mutationDefaults);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _mountCount);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _unsubscribeFocus);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _unsubscribeOnline);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _queryCache, config.queryCache || new (0, _queryCacheJs.QueryCache)());
        (0, _chunkPXG64RU4Js.__privateSet)(this, _mutationCache, config.mutationCache || new (0, _mutationCacheJs.MutationCache)());
        (0, _chunkPXG64RU4Js.__privateSet)(this, _defaultOptions, config.defaultOptions || {});
        (0, _chunkPXG64RU4Js.__privateSet)(this, _queryDefaults, /* @__PURE__ */ new Map());
        (0, _chunkPXG64RU4Js.__privateSet)(this, _mutationDefaults, /* @__PURE__ */ new Map());
        (0, _chunkPXG64RU4Js.__privateSet)(this, _mountCount, 0);
    }
    mount() {
        (0, _chunkPXG64RU4Js.__privateWrapper)(this, _mountCount)._++;
        if ((0, _chunkPXG64RU4Js.__privateGet)(this, _mountCount) !== 1) return;
        (0, _chunkPXG64RU4Js.__privateSet)(this, _unsubscribeFocus, (0, _focusManagerJs.focusManager).subscribe(async (focused)=>{
            if (focused) {
                await this.resumePausedMutations();
                (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).onFocus();
            }
        }));
        (0, _chunkPXG64RU4Js.__privateSet)(this, _unsubscribeOnline, (0, _onlineManagerJs.onlineManager).subscribe(async (online)=>{
            if (online) {
                await this.resumePausedMutations();
                (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).onOnline();
            }
        }));
    }
    unmount() {
        var _a, _b;
        (0, _chunkPXG64RU4Js.__privateWrapper)(this, _mountCount)._--;
        if ((0, _chunkPXG64RU4Js.__privateGet)(this, _mountCount) !== 0) return;
        (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _unsubscribeFocus)) == null || _a.call(this);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _unsubscribeFocus, void 0);
        (_b = (0, _chunkPXG64RU4Js.__privateGet)(this, _unsubscribeOnline)) == null || _b.call(this);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _unsubscribeOnline, void 0);
    }
    isFetching(filters) {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).findAll({
            ...filters,
            fetchStatus: "fetching"
        }).length;
    }
    isMutating(filters) {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).findAll({
            ...filters,
            status: "pending"
        }).length;
    }
    /**
   * Imperative (non-reactive) way to retrieve data for a QueryKey.
   * Should only be used in callbacks or functions where reading the latest data is necessary, e.g. for optimistic updates.
   *
   * Hint: Do not use this function inside a component, because it won't receive updates.
   * Use `useQuery` to create a `QueryObserver` that subscribes to changes.
   */ getQueryData(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey
        });
        return (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).get(options.queryHash)) == null ? void 0 : _a.state.data;
    }
    ensureQueryData(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        const query = (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).build(this, defaultedOptions);
        const cachedData = query.state.data;
        if (cachedData === void 0) return this.fetchQuery(options);
        if (options.revalidateIfStale && query.isStaleByTime((0, _utilsJs.resolveStaleTime)(defaultedOptions.staleTime, query))) this.prefetchQuery(defaultedOptions);
        return Promise.resolve(cachedData);
    }
    getQueriesData(filters) {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).findAll(filters).map(({ queryKey, state })=>{
            const data = state.data;
            return [
                queryKey,
                data
            ];
        });
    }
    setQueryData(queryKey, updater, options) {
        const defaultedOptions = this.defaultQueryOptions({
            queryKey
        });
        const query = (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).get(defaultedOptions.queryHash);
        const prevData = query == null ? void 0 : query.state.data;
        const data = (0, _utilsJs.functionalUpdate)(updater, prevData);
        if (data === void 0) return void 0;
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).build(this, defaultedOptions).setData(data, {
            ...options,
            manual: true
        });
    }
    setQueriesData(filters, updater, options) {
        return (0, _notifyManagerJs.notifyManager).batch(()=>(0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).findAll(filters).map(({ queryKey })=>[
                    queryKey,
                    this.setQueryData(queryKey, updater, options)
                ]));
    }
    getQueryState(queryKey) {
        var _a;
        const options = this.defaultQueryOptions({
            queryKey
        });
        return (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).get(options.queryHash)) == null ? void 0 : _a.state;
    }
    removeQueries(filters) {
        const queryCache = (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache);
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                queryCache.remove(query);
            });
        });
    }
    resetQueries(filters, options) {
        const queryCache = (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache);
        return (0, _notifyManagerJs.notifyManager).batch(()=>{
            queryCache.findAll(filters).forEach((query)=>{
                query.reset();
            });
            return this.refetchQueries({
                type: "active",
                ...filters
            }, options);
        });
    }
    cancelQueries(filters, cancelOptions = {}) {
        const defaultedCancelOptions = {
            revert: true,
            ...cancelOptions
        };
        const promises = (0, _notifyManagerJs.notifyManager).batch(()=>(0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).findAll(filters).map((query)=>query.cancel(defaultedCancelOptions)));
        return Promise.all(promises).then((0, _utilsJs.noop)).catch((0, _utilsJs.noop));
    }
    invalidateQueries(filters, options = {}) {
        return (0, _notifyManagerJs.notifyManager).batch(()=>{
            (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).findAll(filters).forEach((query)=>{
                query.invalidate();
            });
            if ((filters == null ? void 0 : filters.refetchType) === "none") return Promise.resolve();
            return this.refetchQueries({
                ...filters,
                type: (filters == null ? void 0 : filters.refetchType) ?? (filters == null ? void 0 : filters.type) ?? "active"
            }, options);
        });
    }
    refetchQueries(filters, options = {}) {
        const fetchOptions = {
            ...options,
            cancelRefetch: options.cancelRefetch ?? true
        };
        const promises = (0, _notifyManagerJs.notifyManager).batch(()=>(0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).findAll(filters).filter((query)=>!query.isDisabled() && !query.isStatic()).map((query)=>{
                let promise = query.fetch(void 0, fetchOptions);
                if (!fetchOptions.throwOnError) promise = promise.catch((0, _utilsJs.noop));
                return query.state.fetchStatus === "paused" ? Promise.resolve() : promise;
            }));
        return Promise.all(promises).then((0, _utilsJs.noop));
    }
    fetchQuery(options) {
        const defaultedOptions = this.defaultQueryOptions(options);
        if (defaultedOptions.retry === void 0) defaultedOptions.retry = false;
        const query = (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).build(this, defaultedOptions);
        return query.isStaleByTime((0, _utilsJs.resolveStaleTime)(defaultedOptions.staleTime, query)) ? query.fetch(defaultedOptions) : Promise.resolve(query.state.data);
    }
    prefetchQuery(options) {
        return this.fetchQuery(options).then((0, _utilsJs.noop)).catch((0, _utilsJs.noop));
    }
    fetchInfiniteQuery(options) {
        options.behavior = (0, _infiniteQueryBehaviorJs.infiniteQueryBehavior)(options.pages);
        return this.fetchQuery(options);
    }
    prefetchInfiniteQuery(options) {
        return this.fetchInfiniteQuery(options).then((0, _utilsJs.noop)).catch((0, _utilsJs.noop));
    }
    ensureInfiniteQueryData(options) {
        options.behavior = (0, _infiniteQueryBehaviorJs.infiniteQueryBehavior)(options.pages);
        return this.ensureQueryData(options);
    }
    resumePausedMutations() {
        if ((0, _onlineManagerJs.onlineManager).isOnline()) return (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).resumePausedMutations();
        return Promise.resolve();
    }
    getQueryCache() {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache);
    }
    getMutationCache() {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache);
    }
    getDefaultOptions() {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _defaultOptions);
    }
    setDefaultOptions(options) {
        (0, _chunkPXG64RU4Js.__privateSet)(this, _defaultOptions, options);
    }
    setQueryDefaults(queryKey, options) {
        (0, _chunkPXG64RU4Js.__privateGet)(this, _queryDefaults).set((0, _utilsJs.hashKey)(queryKey), {
            queryKey,
            defaultOptions: options
        });
    }
    getQueryDefaults(queryKey) {
        const defaults = [
            ...(0, _chunkPXG64RU4Js.__privateGet)(this, _queryDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, _utilsJs.partialMatchKey)(queryKey, queryDefault.queryKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    setMutationDefaults(mutationKey, options) {
        (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationDefaults).set((0, _utilsJs.hashKey)(mutationKey), {
            mutationKey,
            defaultOptions: options
        });
    }
    getMutationDefaults(mutationKey) {
        const defaults = [
            ...(0, _chunkPXG64RU4Js.__privateGet)(this, _mutationDefaults).values()
        ];
        const result = {};
        defaults.forEach((queryDefault)=>{
            if ((0, _utilsJs.partialMatchKey)(mutationKey, queryDefault.mutationKey)) Object.assign(result, queryDefault.defaultOptions);
        });
        return result;
    }
    defaultQueryOptions(options) {
        if (options._defaulted) return options;
        const defaultedOptions = {
            ...(0, _chunkPXG64RU4Js.__privateGet)(this, _defaultOptions).queries,
            ...this.getQueryDefaults(options.queryKey),
            ...options,
            _defaulted: true
        };
        if (!defaultedOptions.queryHash) defaultedOptions.queryHash = (0, _utilsJs.hashQueryKeyByOptions)(defaultedOptions.queryKey, defaultedOptions);
        if (defaultedOptions.refetchOnReconnect === void 0) defaultedOptions.refetchOnReconnect = defaultedOptions.networkMode !== "always";
        if (defaultedOptions.throwOnError === void 0) defaultedOptions.throwOnError = !!defaultedOptions.suspense;
        if (!defaultedOptions.networkMode && defaultedOptions.persister) defaultedOptions.networkMode = "offlineFirst";
        if (defaultedOptions.queryFn === (0, _utilsJs.skipToken)) defaultedOptions.enabled = false;
        return defaultedOptions;
    }
    defaultMutationOptions(options) {
        if (options == null ? void 0 : options._defaulted) return options;
        return {
            ...(0, _chunkPXG64RU4Js.__privateGet)(this, _defaultOptions).mutations,
            ...(options == null ? void 0 : options.mutationKey) && this.getMutationDefaults(options.mutationKey),
            ...options,
            _defaulted: true
        };
    }
    clear() {
        (0, _chunkPXG64RU4Js.__privateGet)(this, _queryCache).clear();
        (0, _chunkPXG64RU4Js.__privateGet)(this, _mutationCache).clear();
    }
};
_queryCache = new WeakMap();
_mutationCache = new WeakMap();
_defaultOptions = new WeakMap();
_queryDefaults = new WeakMap();
_mutationDefaults = new WeakMap();
_mountCount = new WeakMap();
_unsubscribeFocus = new WeakMap();
_unsubscribeOnline = new WeakMap();

},{"./chunk-PXG64RU4.js":"eR9la","./utils.js":"ku1P9","./queryCache.js":"9XmOT","./mutationCache.js":"37XHp","./focusManager.js":"5x0my","./onlineManager.js":"iNMaz","./notifyManager.js":"egZGk","./infiniteQueryBehavior.js":"koVKm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9XmOT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "QueryCache", ()=>QueryCache);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/queryCache.ts
var _utilsJs = require("./utils.js");
var _queryJs = require("./query.js");
var _notifyManagerJs = require("./notifyManager.js");
var _subscribableJs = require("./subscribable.js");
var _queries;
var QueryCache = class extends (0, _subscribableJs.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _queries);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _queries, /* @__PURE__ */ new Map());
    }
    build(client, options, state) {
        const queryKey = options.queryKey;
        const queryHash = options.queryHash ?? (0, _utilsJs.hashQueryKeyByOptions)(queryKey, options);
        let query = this.get(queryHash);
        if (!query) {
            query = new (0, _queryJs.Query)({
                client,
                queryKey,
                queryHash,
                options: client.defaultQueryOptions(options),
                state,
                defaultOptions: client.getQueryDefaults(queryKey)
            });
            this.add(query);
        }
        return query;
    }
    add(query) {
        if (!(0, _chunkPXG64RU4Js.__privateGet)(this, _queries).has(query.queryHash)) {
            (0, _chunkPXG64RU4Js.__privateGet)(this, _queries).set(query.queryHash, query);
            this.notify({
                type: "added",
                query
            });
        }
    }
    remove(query) {
        const queryInMap = (0, _chunkPXG64RU4Js.__privateGet)(this, _queries).get(query.queryHash);
        if (queryInMap) {
            query.destroy();
            if (queryInMap === query) (0, _chunkPXG64RU4Js.__privateGet)(this, _queries).delete(query.queryHash);
            this.notify({
                type: "removed",
                query
            });
        }
    }
    clear() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                this.remove(query);
            });
        });
    }
    get(queryHash) {
        return (0, _chunkPXG64RU4Js.__privateGet)(this, _queries).get(queryHash);
    }
    getAll() {
        return [
            ...(0, _chunkPXG64RU4Js.__privateGet)(this, _queries).values()
        ];
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((query)=>(0, _utilsJs.matchQuery)(defaultedFilters, query));
    }
    findAll(filters = {}) {
        const queries = this.getAll();
        return Object.keys(filters).length > 0 ? queries.filter((query)=>(0, _utilsJs.matchQuery)(filters, query)) : queries;
    }
    notify(event) {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    onFocus() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onFocus();
            });
        });
    }
    onOnline() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.getAll().forEach((query)=>{
                query.onOnline();
            });
        });
    }
};
_queries = new WeakMap();

},{"./chunk-PXG64RU4.js":"eR9la","./utils.js":"ku1P9","./query.js":"31nNK","./notifyManager.js":"egZGk","./subscribable.js":"ifEuT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"37XHp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MutationCache", ()=>MutationCache);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/mutationCache.ts
var _notifyManagerJs = require("./notifyManager.js");
var _mutationJs = require("./mutation.js");
var _utilsJs = require("./utils.js");
var _subscribableJs = require("./subscribable.js");
var _mutations, _scopes, _mutationId;
var MutationCache = class extends (0, _subscribableJs.Subscribable) {
    constructor(config = {}){
        super();
        this.config = config;
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _mutations);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _scopes);
        (0, _chunkPXG64RU4Js.__privateAdd)(this, _mutationId);
        (0, _chunkPXG64RU4Js.__privateSet)(this, _mutations, /* @__PURE__ */ new Set());
        (0, _chunkPXG64RU4Js.__privateSet)(this, _scopes, /* @__PURE__ */ new Map());
        (0, _chunkPXG64RU4Js.__privateSet)(this, _mutationId, 0);
    }
    build(client, options, state) {
        const mutation = new (0, _mutationJs.Mutation)({
            client,
            mutationCache: this,
            mutationId: ++(0, _chunkPXG64RU4Js.__privateWrapper)(this, _mutationId)._,
            options: client.defaultMutationOptions(options),
            state
        });
        this.add(mutation);
        return mutation;
    }
    add(mutation) {
        (0, _chunkPXG64RU4Js.__privateGet)(this, _mutations).add(mutation);
        const scope = scopeFor(mutation);
        if (typeof scope === "string") {
            const scopedMutations = (0, _chunkPXG64RU4Js.__privateGet)(this, _scopes).get(scope);
            if (scopedMutations) scopedMutations.push(mutation);
            else (0, _chunkPXG64RU4Js.__privateGet)(this, _scopes).set(scope, [
                mutation
            ]);
        }
        this.notify({
            type: "added",
            mutation
        });
    }
    remove(mutation) {
        if ((0, _chunkPXG64RU4Js.__privateGet)(this, _mutations).delete(mutation)) {
            const scope = scopeFor(mutation);
            if (typeof scope === "string") {
                const scopedMutations = (0, _chunkPXG64RU4Js.__privateGet)(this, _scopes).get(scope);
                if (scopedMutations) {
                    if (scopedMutations.length > 1) {
                        const index = scopedMutations.indexOf(mutation);
                        if (index !== -1) scopedMutations.splice(index, 1);
                    } else if (scopedMutations[0] === mutation) (0, _chunkPXG64RU4Js.__privateGet)(this, _scopes).delete(scope);
                }
            }
        }
        this.notify({
            type: "removed",
            mutation
        });
    }
    canRun(mutation) {
        const scope = scopeFor(mutation);
        if (typeof scope === "string") {
            const mutationsWithSameScope = (0, _chunkPXG64RU4Js.__privateGet)(this, _scopes).get(scope);
            const firstPendingMutation = mutationsWithSameScope == null ? void 0 : mutationsWithSameScope.find((m)=>m.state.status === "pending");
            return !firstPendingMutation || firstPendingMutation === mutation;
        } else return true;
    }
    runNext(mutation) {
        var _a;
        const scope = scopeFor(mutation);
        if (typeof scope === "string") {
            const foundMutation = (_a = (0, _chunkPXG64RU4Js.__privateGet)(this, _scopes).get(scope)) == null ? void 0 : _a.find((m)=>m !== mutation && m.state.isPaused);
            return (foundMutation == null ? void 0 : foundMutation.continue()) ?? Promise.resolve();
        } else return Promise.resolve();
    }
    clear() {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            (0, _chunkPXG64RU4Js.__privateGet)(this, _mutations).forEach((mutation)=>{
                this.notify({
                    type: "removed",
                    mutation
                });
            });
            (0, _chunkPXG64RU4Js.__privateGet)(this, _mutations).clear();
            (0, _chunkPXG64RU4Js.__privateGet)(this, _scopes).clear();
        });
    }
    getAll() {
        return Array.from((0, _chunkPXG64RU4Js.__privateGet)(this, _mutations));
    }
    find(filters) {
        const defaultedFilters = {
            exact: true,
            ...filters
        };
        return this.getAll().find((mutation)=>(0, _utilsJs.matchMutation)(defaultedFilters, mutation));
    }
    findAll(filters = {}) {
        return this.getAll().filter((mutation)=>(0, _utilsJs.matchMutation)(filters, mutation));
    }
    notify(event) {
        (0, _notifyManagerJs.notifyManager).batch(()=>{
            this.listeners.forEach((listener)=>{
                listener(event);
            });
        });
    }
    resumePausedMutations() {
        const pausedMutations = this.getAll().filter((x)=>x.state.isPaused);
        return (0, _notifyManagerJs.notifyManager).batch(()=>Promise.all(pausedMutations.map((mutation)=>mutation.continue().catch((0, _utilsJs.noop)))));
    }
};
_mutations = new WeakMap();
_scopes = new WeakMap();
_mutationId = new WeakMap();
function scopeFor(mutation) {
    var _a;
    return (_a = mutation.options.scope) == null ? void 0 : _a.id;
}

},{"./chunk-PXG64RU4.js":"eR9la","./notifyManager.js":"egZGk","./mutation.js":"6HxMS","./utils.js":"ku1P9","./subscribable.js":"ifEuT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"koVKm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasNextPage", ()=>hasNextPage);
parcelHelpers.export(exports, "hasPreviousPage", ()=>hasPreviousPage);
parcelHelpers.export(exports, "infiniteQueryBehavior", ()=>infiniteQueryBehavior);
var _chunkPXG64RU4Js = require("./chunk-PXG64RU4.js");
// src/infiniteQueryBehavior.ts
var _utilsJs = require("./utils.js");
function infiniteQueryBehavior(pages) {
    return {
        onFetch: (context, query)=>{
            var _a, _b, _c, _d, _e;
            const options = context.options;
            const direction = (_c = (_b = (_a = context.fetchOptions) == null ? void 0 : _a.meta) == null ? void 0 : _b.fetchMore) == null ? void 0 : _c.direction;
            const oldPages = ((_d = context.state.data) == null ? void 0 : _d.pages) || [];
            const oldPageParams = ((_e = context.state.data) == null ? void 0 : _e.pageParams) || [];
            let result = {
                pages: [],
                pageParams: []
            };
            let currentPage = 0;
            const fetchFn = async ()=>{
                let cancelled = false;
                const addSignalProperty = (object)=>{
                    Object.defineProperty(object, "signal", {
                        enumerable: true,
                        get: ()=>{
                            if (context.signal.aborted) cancelled = true;
                            else context.signal.addEventListener("abort", ()=>{
                                cancelled = true;
                            });
                            return context.signal;
                        }
                    });
                };
                const queryFn = (0, _utilsJs.ensureQueryFn)(context.options, context.fetchOptions);
                const fetchPage = async (data, param, previous)=>{
                    if (cancelled) return Promise.reject();
                    if (param == null && data.pages.length) return Promise.resolve(data);
                    const createQueryFnContext = ()=>{
                        const queryFnContext2 = {
                            client: context.client,
                            queryKey: context.queryKey,
                            pageParam: param,
                            direction: previous ? "backward" : "forward",
                            meta: context.options.meta
                        };
                        addSignalProperty(queryFnContext2);
                        return queryFnContext2;
                    };
                    const queryFnContext = createQueryFnContext();
                    const page = await queryFn(queryFnContext);
                    const { maxPages } = context.options;
                    const addTo = previous ? (0, _utilsJs.addToStart) : (0, _utilsJs.addToEnd);
                    return {
                        pages: addTo(data.pages, page, maxPages),
                        pageParams: addTo(data.pageParams, param, maxPages)
                    };
                };
                if (direction && oldPages.length) {
                    const previous = direction === "backward";
                    const pageParamFn = previous ? getPreviousPageParam : getNextPageParam;
                    const oldData = {
                        pages: oldPages,
                        pageParams: oldPageParams
                    };
                    const param = pageParamFn(options, oldData);
                    result = await fetchPage(oldData, param, previous);
                } else {
                    const remainingPages = pages ?? oldPages.length;
                    do {
                        const param = currentPage === 0 ? oldPageParams[0] ?? options.initialPageParam : getNextPageParam(options, result);
                        if (currentPage > 0 && param == null) break;
                        result = await fetchPage(result, param);
                        currentPage++;
                    }while (currentPage < remainingPages);
                }
                return result;
            };
            if (context.options.persister) context.fetchFn = ()=>{
                var _a2, _b2;
                return (_b2 = (_a2 = context.options).persister) == null ? void 0 : _b2.call(_a2, fetchFn, {
                    client: context.client,
                    queryKey: context.queryKey,
                    meta: context.options.meta,
                    signal: context.signal
                }, query);
            };
            else context.fetchFn = fetchFn;
        }
    };
}
function getNextPageParam(options, { pages, pageParams }) {
    const lastIndex = pages.length - 1;
    return pages.length > 0 ? options.getNextPageParam(pages[lastIndex], pages, pageParams[lastIndex], pageParams) : void 0;
}
function getPreviousPageParam(options, { pages, pageParams }) {
    var _a;
    return pages.length > 0 ? (_a = options.getPreviousPageParam) == null ? void 0 : _a.call(options, pages[0], pages, pageParams[0], pageParams) : void 0;
}
function hasNextPage(options, data) {
    if (!data) return false;
    return getNextPageParam(options, data) != null;
}
function hasPreviousPage(options, data) {
    if (!data || !options.getPreviousPageParam) return false;
    return getPreviousPageParam(options, data) != null;
}

},{"./chunk-PXG64RU4.js":"eR9la","./utils.js":"ku1P9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kGIw6":[function(require,module,exports,__globalThis) {

},{}],"9S52k":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInfo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#F82222",
            d: "M6.611 10.5h.778V6.222H6.61zm.727-5.522a.46.46 0 0 0 .141-.342.47.47 0 0 0-.48-.478.46.46 0 0 0-.34.138.46.46 0 0 0-.137.341q0 .203.14.34A.46.46 0 0 0 7 5.116a.46.46 0 0 0 .338-.137M7.003 14a6.8 6.8 0 0 1-2.73-.55 7.1 7.1 0 0 1-2.224-1.497A7.1 7.1 0 0 1 .55 9.732 6.8 6.8 0 0 1 0 7.002q0-1.452.551-2.73A7.1 7.1 0 0 1 2.046 2.05 7 7 0 0 1 4.268.55 6.8 6.8 0 0 1 6.998 0a6.8 6.8 0 0 1 2.73.551 7.1 7.1 0 0 1 2.223 1.495q.945.944 1.498 2.222.55 1.278.551 2.73 0 1.45-.55 2.73a7 7 0 0 1-1.497 2.223 7.1 7.1 0 0 1-2.221 1.498Q8.457 14 7.003 14M7 13.222q2.605 0 4.414-1.808T13.222 7t-1.808-4.414Q9.605.778 7 .778T2.586 2.586.778 7t1.808 4.414Q4.395 13.222 7 13.222"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i5yb0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEyeClosed);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEyeClosed = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: 20,
        height: 20,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9 9 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24M1 1l22 22"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"13Rvh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEyeOpen);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEyeOpen = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 20,
        height: 20,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 12,
                cy: 12,
                r: 3
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"KnXaD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGoogle);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGoogle = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#4285F4",
                d: "M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#34A853",
                d: "M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FBBC05",
                d: "M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#EA4335",
                d: "M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gOuz3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgApple);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgApple = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#000",
            d: "M16.63 11.392c-.023-2.613 2.133-3.87 2.232-3.928-1.218-1.782-3.111-2.022-3.782-2.046-1.603-.162-3.127.944-3.945.944-.817 0-2.073-.923-3.398-.897a4.93 4.93 0 0 0-4.211 2.5c-1.798 3.12-.46 7.747 1.288 10.27.857 1.235 1.874 2.623 3.195 2.573 1.272-.05 1.761-.822 3.298-.822s1.996.822 3.321.796c1.35-.025 2.234-1.261 3.088-2.522a11.2 11.2 0 0 0 1.446-2.969c-.033-.016-2.775-1.066-2.532-3.899m-1.21-6.295c.706-.855 1.181-2.042 1.052-3.23-.996.04-2.231.663-2.961 1.545-.656.786-1.226 2.001-1.072 3.161 1.114.086 2.274-.622 2.981-1.476"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iy8G7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLogo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 105,
        height: 30,
        fill: "none",
        viewBox: "0 0 105 30",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#FFA100",
                        d: "M3.298 11.605c.038-.013.33-.088.367-.088L24.58 6.129 14.345.276A2 2 0 0 0 13.317 0c-.367 0-.723.1-1.027.276L.558 6.996c-.33.188-.558.54-.558.954v5.526a9.2 9.2 0 0 1 3.298-1.872M13.305 2.8c1.42 0 2.536 1.143 2.422 2.537-.101 1.255-1.192 2.248-2.46 2.235-1.345 0-2.372-1.067-2.36-2.449C10.92 3.804 11.96 2.8 13.305 2.8m4.084 8.315s-.406.98-.926 2.185c.76.314 6.468 2.725 6.481 2.738a6.79 6.79 0 0 1 3.577 4.61c.038.2.076.401.101.602V8.741zm5.605 13.011a3.7 3.7 0 0 0 .52-2.826 3.79 3.79 0 0 0-1.978-2.55l-6.278-2.637-2.778 6.506a8.16 8.16 0 0 1-4.566 4.458l4.35 2.487c.305.176.66.276 1.028.276.38 0 .723-.1 1.027-.276l7.496-4.283a3.45 3.45 0 0 0 1.18-1.155m-9.31-12.056-9.538 2.448-.367.088A5.09 5.09 0 0 0 0 19.53c0 2.801 2.258 5.062 5.023 5.062a5.03 5.03 0 0 0 4.616-3.065l.254-.59c.786-1.808 2.854-6.656 3.792-8.867"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M51.173 12.56a5 5 0 0 0-1.56-1.043 4.6 4.6 0 0 0-1.902-.39c-.8 0-1.573.177-2.283.541a6.7 6.7 0 0 0-1.979 1.495 4.64 4.64 0 0 0-1.674-1.482 4.7 4.7 0 0 0-2.232-.54 4.66 4.66 0 0 0-3.349 1.381v-1.03h-3.12v11.379h3.12v-6.318c0-.364.064-.703.203-1.017a2.9 2.9 0 0 1 .546-.841c.228-.239.494-.427.811-.566s.66-.2 1.015-.2c.71 0 1.306.25 1.788.74s.723 1.13.723 1.897v6.317h3.12v-6.317c0-.364.064-.703.203-1.017.14-.314.317-.603.546-.842a2.47 2.47 0 0 1 1.826-.766c.71 0 1.306.251 1.788.741s.723 1.13.723 1.896v6.318h3.12v-6.782c0-.703-.127-1.344-.393-1.96a4.16 4.16 0 0 0-1.04-1.594m5.073-5.615c-.52 0-.964.176-1.332.54a1.7 1.7 0 0 0-.558 1.281c0 .503.19.93.558 1.281.368.352.812.54 1.332.54s.964-.175 1.332-.54c.368-.351.558-.778.558-1.28 0-.503-.19-.93-.558-1.282-.355-.364-.812-.54-1.332-.54m1.561 4.546h-3.12V22.87h3.12zm12.252 1.069a5 5 0 0 0-1.611-1.043 4.9 4.9 0 0 0-1.966-.39 5 5 0 0 0-1.903.365 4.8 4.8 0 0 0-1.572 1.017v-1.017h-3.12v11.379h3.12v-6.318c0-.364.076-.703.215-1.017.14-.314.33-.603.584-.841a2.6 2.6 0 0 1 .875-.566c.342-.138.698-.2 1.078-.2.761 0 1.395.25 1.903.74.507.49.773 1.13.773 1.897v6.317h3.12v-6.782c0-.703-.14-1.343-.406-1.959a4.9 4.9 0 0 0-1.09-1.582m6.671-1.069h-3.12V22.87h3.12zm-1.56-4.546c-.52 0-.964.176-1.332.54a1.7 1.7 0 0 0-.558 1.281c0 .503.19.93.558 1.281.368.352.812.54 1.332.54s.964-.175 1.332-.54c.368-.351.558-.778.558-1.28 0-.503-.19-.93-.558-1.282a1.82 1.82 0 0 0-1.332-.54m15.169 1.608c-.457-.49-1.04-.88-1.725-1.168-.698-.302-1.51-.44-2.436-.44h-7.381V22.87h3.247v-5.69h4.147c.926 0 1.75-.137 2.435-.426.698-.276 1.269-.653 1.725-1.13.457-.465.8-1.018 1.028-1.633a5.6 5.6 0 0 0 .342-1.934c0-.64-.114-1.256-.342-1.872a5.2 5.2 0 0 0-1.04-1.632m-2.08 4.345a2.3 2.3 0 0 1-.47.741 2.35 2.35 0 0 1-.786.54c-.305.139-.672.201-1.078.201h-3.907V9.746h3.907c.406 0 .773.063 1.078.2.304.14.57.315.786.528s.368.465.47.741c.101.277.152.566.152.854a1.9 1.9 0 0 1-.153.83m4.592-5.954v2.801h4.45V22.87h3.247V9.746H105v-2.8z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h105v29.84H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dozlf":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SignUp", ()=>SignUp);
var _jsxRuntime = require("react/jsx-runtime");
var _signUpScss = require("./SignUp.scss");
// 🔹 React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 Routing
var _reactRouterDom = require("react-router-dom");
// 🔹 Components
var _button = require("../../components/Button/Button");
// 🔹 Store
var _sessionStore = require("src/store/sessionStore");
var _uiStore = require("src/store/uiStore");
var _appAlert = require("src/utils/appAlert");
var _validation = require("src/utils/validation");
// 🔹 Assets
var _authBannerWebp = require("url:../../../../assets/images/onboarding-trainer/auth-banner.webp");
var _authBannerWebpDefault = parcelHelpers.interopDefault(_authBannerWebp);
var _useAuthSignUp = require("src/api/mutations/useAuthSignUp");
var _useAuthSocialLogin = require("src/api/mutations/useAuthSocialLogin");
var _useGetOnboardingMasterData = require("src/api/mutations/useGetOnboardingMasterData");
var _useGetOnboardingState = require("src/api/mutations/useGetOnboardingState");
var _onboardingUtils = require("src/utils/onboardingUtils");
var _queryClient = require("src/api/queryClient");
var _infoSvg = require("../../../../assets/images/onboarding-trainer/info.svg");
var _eyeClosedSvg = require("../../../../assets/images/onboarding-trainer/eye-closed.svg");
var _backSvg = require("../../../../assets/images/onboarding-trainer/back.svg");
var _eyeOpenSvg = require("../../../../assets/images/onboarding-trainer/eye-open.svg");
var _googleSvg = require("../../../../assets/images/onboarding-trainer/google.svg");
var _appleSvg = require("../../../../assets/images/onboarding-trainer/apple.svg");
var _logoSvg = require("../../../../assets/images/onboarding-trainer/logo.svg");
const SignUp = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const setToken = (0, _sessionStore.sessionStore)((s)=>s.setToken);
    const setHasSignedUp = (0, _uiStore.uiStore)((s)=>s.setHasSignedUp);
    const [name, setName] = (0, _react.useState)('');
    const [surname, setSurname] = (0, _react.useState)('');
    const [email, setEmail] = (0, _react.useState)('');
    const [password, setPassword] = (0, _react.useState)('');
    const [showPassword, setShowPassword] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)({});
    const [isSuccess, setIsSuccess] = (0, _react.useState)(false);
    const [isNavigating, setIsNavigating] = (0, _react.useState)(false);
    const { mutateAsync: signUp, isPending: isSignUpPending } = (0, _useAuthSignUp.useAuthSignUp)();
    const { mutateAsync: socialLogin, isPending: isSocialLoginPending } = (0, _useAuthSocialLogin.useAuthSocialLogin)();
    // 🔹 Preload Master Data while user is typing so the onboarding screens load instantly
    (0, _useGetOnboardingMasterData.useGetOnboardingMasterData)();
    const handleSignUp = async (e)=>{
        e.preventDefault();
        if (isSignUpPending || isNavigating) return;
        const newErrors = {};
        if (!name.trim()) newErrors.name = 'Please fill this before continuing';
        else if (!/\p{L}/u.test(name.trim())) newErrors.name = 'Name must contain at least one letter';
        if (!surname.trim()) newErrors.surname = 'Please fill this before continuing';
        else if (!/\p{L}/u.test(surname.trim())) newErrors.surname = 'Surname must contain at least one letter';
        if (!email.trim()) newErrors.email = 'Please fill this before continuing';
        else if (!(0, _validation.isValidEmail)(email)) newErrors.email = 'Please enter a valid email address.';
        if (!password) newErrors.password = 'Please fill this before continuing';
        else {
            const hasUppercase = /[A-Z]/.test(password);
            const hasLowercase = /[a-z]/.test(password);
            const hasNumber = /\d/.test(password);
            const hasSymbol = /[-!@#$%^&*(),.?":{}|<>_+=/[\\\]~`]/.test(password);
            const pwdErrs = [];
            if (password.length < 8) pwdErrs.push('be at least 8 characters');
            if (!hasUppercase) pwdErrs.push('contain an uppercase letter');
            if (!hasLowercase) pwdErrs.push('contain a lowercase letter');
            if (!hasNumber) pwdErrs.push('contain a number');
            if (!hasSymbol) pwdErrs.push('contain a symbol');
            if (pwdErrs.length > 0) {
                if (pwdErrs.length === 1) newErrors.password = `Password must ${pwdErrs[0]}.`;
                else if (pwdErrs.length === 2) newErrors.password = `Password must ${pwdErrs[0]} and ${pwdErrs[1]}.`;
                else {
                    const last = pwdErrs.pop();
                    newErrors.password = `Password must ${pwdErrs.join(', ')}, and ${last}.`;
                }
            }
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        try {
            setIsNavigating(true);
            await signUp({
                name,
                surname,
                email,
                password
            });
            setErrors({});
            setHasSignedUp(true);
            // toast.success('Registration successful! Please check your email to verify.', {
            //   position: 'top-right',
            //   style: {
            //     borderRadius: '8px',
            //     background: '#0a0b24',
            //     color: '#fff',
            //     border: '1px solid rgba(255, 255, 255, 0.1)',
            //     minWidth: 'max-content',
            //   },
            //   iconTheme: {
            //     primary: '#ffb703',
            //     secondary: '#000',
            //   },
            // });
            setIsNavigating(false);
            navigate('/onboarding-trainer/signup/verify-email', {
                state: {
                    email
                }
            });
        } catch (error) {
            setIsNavigating(false);
            const newErrors = {};
            if (error.code === 'auth/email-already-in-use') newErrors.email = 'This email is already registered. Try logging in instead.';
            else if (error.code === 'auth/invalid-email') newErrors.email = 'Please enter a valid email address.';
            else if (error.code === 'auth/weak-password') newErrors.password = 'Password is too weak. Please choose a stronger password.';
            else if (error.code === 'auth/operation-not-allowed') newErrors.email = 'Registration is currently disabled. Please contact support.';
            else if (error.message) newErrors.email = error.message.replace('Firebase: Error ', '').replace(/\(auth.*\)\./, '').trim();
            else newErrors.email = 'Registration failed. Please try again.';
            setErrors(newErrors);
        }
    };
    const handleSocialLogin = async (providerName)=>{
        try {
            setIsNavigating(true);
            const socialResult = await socialLogin({
                providerName
            });
            const user = socialResult.user;
            // Fetch required data before navigating so it's instantly available
            const [, onboardingStateResult] = await Promise.all([
                (0, _queryClient.queryClient).fetchQuery({
                    queryKey: [
                        'onboarding-master-data'
                    ],
                    queryFn: (0, _useGetOnboardingMasterData.fetchOnboardingMasterData)
                }),
                (0, _queryClient.queryClient).fetchQuery({
                    queryKey: [
                        'onboarding-state',
                        user.uid
                    ],
                    queryFn: ()=>(0, _useGetOnboardingState.fetchOnboardingState)(user.uid)
                })
            ]);
            const backendProfile = onboardingStateResult?.profile || {};
            let name = backendProfile.name || socialResult.firstName;
            let surname = backendProfile.surname;
            if ((!surname || surname === 'Trainer') && socialResult.lastName && socialResult.lastName !== 'Trainer') surname = socialResult.lastName;
            else if (!surname) surname = socialResult.lastName || '';
            if (name && name.includes(' ') && (!surname || surname === 'Trainer')) {
                const parts = name.trim().split(/\s+/);
                name = parts[0];
                surname = parts.slice(1).join(' ');
            }
            setToken(await user.getIdToken(), {
                ...backendProfile,
                uid: user.uid,
                name,
                surname,
                avatarUrl: backendProfile.avatarUrl || backendProfile.avatar_url || socialResult.avatarUrl || user.photoURL || undefined
            });
            const activeOnboarding = onboardingStateResult?.onboarding ?? onboardingStateResult?.profile?.onboarding;
            const progress = (0, _onboardingUtils.computeOnboardingProgress)(activeOnboarding);
            if (progress.isFullyCompleted || progress.isSkipped) navigate('/onboarding-trainer/dashboard');
            else navigate('/onboarding-trainer');
        } catch (error) {
            setIsNavigating(false);
            (0, _appAlert.toast).error(error.message || 'Social login failed');
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "onboarding-signup-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "signup-image-side",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                        src: (0, _authBannerWebpDefault.default),
                        alt: "Signup Banner",
                        className: "signup-image-bg"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "signup-image-overlay"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "signup-form-side",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "signup-box",
                    children: isSuccess ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "signup-success-message",
                        style: {
                            textAlign: 'center',
                            marginTop: '40px',
                            padding: '0 20px'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    marginBottom: '24px',
                                    display: 'flex',
                                    justifyContent: 'center'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    width: "64",
                                    height: "64",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "#ffb703",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M22 11.08V12a10 10 0 1 1-5.93-9.14"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                            points: "22 4 12 14.01 9 11.01"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                style: {
                                    color: '#fff',
                                    fontSize: '24px',
                                    fontWeight: 600,
                                    marginBottom: '16px'
                                },
                                children: "Please verify your email"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                style: {
                                    color: 'var(--auth-text-muted)',
                                    fontSize: '16px',
                                    lineHeight: '1.5',
                                    maxWidth: '400px',
                                    margin: '0 auto 24px auto'
                                },
                                children: "Registration successful! Before logging in, please check your inbox and spam folder for a verification link."
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                variant: "outline",
                                onClick: ()=>{
                                    setIsSuccess(false);
                                    navigate('/onboarding-trainer/login');
                                },
                                className: "back-to-login-in",
                                style: {
                                    margin: '0 auto'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backSvg.ReactComponent), {}),
                                    " Back to Log in"
                                ]
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "signup-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "logo-placeholder desktop-only",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                                        className: "signup-title",
                                        children: [
                                            "Sign up ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "highlight",
                                                children: "for free"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "signup-subtitle",
                                        children: "Join miniPT and start building your programs today."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                autoComplete: "on",
                                onSubmit: handleSignUp,
                                className: "signup-form auth-form-common",
                                noValidate: true,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "email",
                                        style: {
                                            display: 'none'
                                        },
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "password",
                                        style: {
                                            display: 'none'
                                        },
                                        "aria-hidden": "true"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "input-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "input-group",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        children: "NAME"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "text",
                                                        name: "firstName",
                                                        placeholder: "John",
                                                        value: name,
                                                        onChange: (e)=>{
                                                            setName(e.target.value);
                                                            if (errors.name) setErrors({
                                                                ...errors,
                                                                name: ''
                                                            });
                                                        },
                                                        className: errors.name ? 'error-input' : ''
                                                    }),
                                                    errors.name && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "error-message",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSvg.ReactComponent), {}),
                                                            " ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: errors.name
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "input-group",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        children: "SURNAME"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "text",
                                                        name: "lastName",
                                                        placeholder: "Doe",
                                                        autoComplete: "off",
                                                        value: surname,
                                                        onChange: (e)=>{
                                                            setSurname(e.target.value);
                                                            if (errors.surname) setErrors({
                                                                ...errors,
                                                                surname: ''
                                                            });
                                                        },
                                                        className: errors.surname ? 'error-input' : ''
                                                    }),
                                                    errors.surname && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "error-message",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSvg.ReactComponent), {}),
                                                            " ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: errors.surname
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "input-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: "EMAIL"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "email",
                                                name: "email",
                                                autoComplete: "email",
                                                placeholder: "john.doe@example.com",
                                                value: email,
                                                onChange: (e)=>{
                                                    setEmail(e.target.value);
                                                    if (errors.email) setErrors({
                                                        ...errors,
                                                        email: ''
                                                    });
                                                },
                                                className: errors.email ? 'error-input' : ''
                                            }),
                                            errors.email && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "error-message",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSvg.ReactComponent), {}),
                                                    " ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: errors.email
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "input-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                children: 'PASSWORD'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "password-input-wrapper",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: showPassword ? 'text' : 'password',
                                                        name: "password",
                                                        autoComplete: "new-password",
                                                        placeholder: "Create a strong password",
                                                        value: password,
                                                        onChange: (e)=>{
                                                            setPassword(e.target.value);
                                                            if (errors.password) setErrors({
                                                                ...errors,
                                                                password: ''
                                                            });
                                                        },
                                                        className: errors.password ? 'error-input' : ''
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        className: "eye-btn",
                                                        onClick: ()=>setShowPassword(!showPassword),
                                                        children: showPassword ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyeOpenSvg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyeClosedSvg.ReactComponent), {})
                                                    })
                                                ]
                                            }),
                                            errors.password && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "error-message",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSvg.ReactComponent), {}),
                                                    " ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: errors.password
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        type: "submit",
                                        variant: "primary",
                                        className: "submit-btn",
                                        isLoading: isSignUpPending || isNavigating,
                                        disabled: isSignUpPending || isSocialLoginPending || isNavigating,
                                        children: 'Sign Up'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "privacy-text",
                                        children: [
                                            'By continuing you agree with our ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                onClick: ()=>navigate('/privacy-policy'),
                                                children: 'Privacy Policy'
                                            }),
                                            ' ',
                                            "and",
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                onClick: ()=>navigate('/terms-of-service'),
                                                children: 'Terms & Conditions'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "auth-divider",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: 'OR SIGN UP WITH'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "auth-social-login",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        type: "button",
                                        className: "social-btn google-btn",
                                        onClick: ()=>handleSocialLogin('google'),
                                        disabled: isSignUpPending || isSocialLoginPending || isNavigating,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleSvg.ReactComponent), {}),
                                            "Google"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        type: "button",
                                        className: "social-btn apple-btn",
                                        onClick: ()=>handleSocialLogin('apple'),
                                        disabled: isSignUpPending || isSocialLoginPending || isNavigating,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appleSvg.ReactComponent), {}),
                                            "Apple"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                className: "auth-bottom-link",
                                children: [
                                    "Already have an account? ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                                        to: "/onboarding-trainer/login",
                                        children: "Log in"
                                    })
                                ]
                            })
                        ]
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","./SignUp.scss":"49cmm","react":"bmhQu","react-router-dom":"f3cgC","../../components/Button/Button":"jLE7r","src/store/sessionStore":"kPSO3","src/store/uiStore":"hxErL","src/utils/appAlert":"de4Mq","src/utils/validation":"1NJZx","url:../../../../assets/images/onboarding-trainer/auth-banner.webp":"cerRX","src/api/mutations/useAuthSignUp":"lIBTO","src/api/mutations/useAuthSocialLogin":"7DD6P","src/api/mutations/useGetOnboardingMasterData":"dhU6k","src/api/mutations/useGetOnboardingState":"3gbTg","src/utils/onboardingUtils":"gnh1N","src/api/queryClient":"406Ct","../../../../assets/images/onboarding-trainer/info.svg":"9S52k","../../../../assets/images/onboarding-trainer/eye-closed.svg":"i5yb0","../../../../assets/images/onboarding-trainer/back.svg":"bVuDS","../../../../assets/images/onboarding-trainer/eye-open.svg":"13Rvh","../../../../assets/images/onboarding-trainer/google.svg":"KnXaD","../../../../assets/images/onboarding-trainer/apple.svg":"gOuz3","../../../../assets/images/onboarding-trainer/logo.svg":"iy8G7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"49cmm":[function() {},{}],"cerRX":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7KsP6");

},{}],"lIBTO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthSignUp", ()=>useAuthSignUp);
var _reactQuery = require("@tanstack/react-query");
var _auth = require("firebase/auth");
var _firebase = require("src/config/firebase");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
function useAuthSignUp() {
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const { name, surname, email, password } = payload;
            // 1. Create a user in Firebase Auth
            const userCredential = await (0, _auth.createUserWithEmailAndPassword)((0, _firebase.auth), email, password);
            const user = userCredential.user;
            // 2. Update Firebase Auth profile
            await (0, _auth.updateProfile)(user, {
                displayName: `${name.trim()} ${surname.trim()}`.trim()
            });
            // 3. Create a user profile in Backend first
            const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).CREATE_USER_PROFILE_API_HOST}`;
            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    uid: user.uid,
                    email: user.email,
                    name: name.trim(),
                    surname: surname.trim()
                })
            });
            if (!response.ok) {
                // Parse the error message
                let errorMsg = 'Unknown error';
                try {
                    const errData = await response.json();
                    errorMsg = errData.error || errorMsg;
                } catch  {
                    errorMsg = await response.text();
                }
                // Backend validation failed, so we delete the Firebase Auth user
                // to prevent ghost accounts that cannot log in properly
                await user.delete().catch(console.error);
                throw new Error(errorMsg);
            }
            // 4. Send email verification ONLY AFTER backend profile is successfully created
            const basePath = "/";
            await (0, _auth.sendEmailVerification)(user, {
                url: `${window.location.origin}${basePath}/onboarding-trainer/login?type=trainer`
            });
            return user;
        }
    });
}

},{"@tanstack/react-query":"ehKs4","firebase/auth":"dZ6yw","src/config/firebase":"cmjIE","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bVuDS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBack);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBack = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M20 12H4m6-6-6 6 6 6"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Qt0q":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ForgotPassword", ()=>ForgotPassword);
var _jsxRuntime = require("react/jsx-runtime");
var _forgotPasswordScss = require("./ForgotPassword.scss");
// 🔹 React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 Routing
var _reactRouterDom = require("react-router-dom");
// 🔹 Components
var _button = require("../../components/Button/Button");
// 🔹 Assets
var _useAuthResetPassword = require("src/api/mutations/useAuthResetPassword");
var _appAlert = require("src/utils/appAlert");
var _infoSvg = require("../../../../assets/images/onboarding-trainer/info.svg");
var _emailSvg = require("../../../../assets/images/onboarding-trainer/email.svg");
var _backSvg = require("../../../../assets/images/onboarding-trainer/back.svg");
var _logoSvg = require("../../../../assets/images/onboarding-trainer/logo.svg");
const ForgotPassword = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [email, setEmail] = (0, _react.useState)('');
    const [errors, setErrors] = (0, _react.useState)({});
    const [submitted, setSubmitted] = (0, _react.useState)(false);
    const [cooldown, setCooldown] = (0, _react.useState)(0);
    const { mutateAsync: resetPassword, isPending } = (0, _useAuthResetPassword.useAuthResetPassword)();
    (0, _react.useEffect)(()=>{
        let timer;
        if (cooldown > 0) timer = setTimeout(()=>setCooldown((prev)=>prev - 1), 1000);
        return ()=>clearTimeout(timer);
    }, [
        cooldown
    ]);
    const handleResetPassword = async (e)=>{
        e.preventDefault();
        if (!email.trim()) {
            setErrors({
                email: 'Please enter your email address'
            });
            return;
        }
        try {
            await resetPassword({
                email
            });
            setErrors({});
            if (submitted) (0, _appAlert.toast).success('Reset link resent successfully!');
            setSubmitted(true);
            setCooldown(60); // Start 60-second cooldown
        } catch (error) {
            let errorMessage = 'Failed to send reset link.';
            if (error.code === 'auth/user-not-found' || error.message === 'auth/user-not-found') errorMessage = 'No account found with this email address.';
            else if (error.code === 'auth/invalid-email') errorMessage = 'Please enter a valid email address.';
            else if (error.message) errorMessage = error.message.replace('Firebase: Error ', '').replace(/\(auth.*\)\./, '').trim();
            setErrors({
                email: errorMessage
            });
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "onboarding-forgot-password-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "forgot-password-box",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "forgot-password-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "logo-placeholder",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                className: "forgot-password-title",
                                children: submitted ? 'Check your email' : 'Forgot password?'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "forgot-password-subtitle",
                                children: submitted ? "If an account exists for this email, you'll receive a password reset link shortly." : "Enter your email and we\u2019ll send you reset instructions."
                            })
                        ]
                    }),
                    !submitted ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                        onSubmit: handleResetPassword,
                        className: "forgot-password-form auth-form-common",
                        noValidate: true,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "input-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: "EMAIL"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "email",
                                        placeholder: "john.doe@example.com",
                                        value: email,
                                        onChange: (e)=>{
                                            setEmail(e.target.value);
                                            if (errors.email) setErrors({
                                                ...errors,
                                                email: ''
                                            });
                                        },
                                        className: errors.email ? 'error-input' : ''
                                    }),
                                    errors.email && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "error-message",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSvg.ReactComponent), {}),
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: errors.email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                type: "submit",
                                variant: "primary",
                                className: "submit-btn bg-white",
                                disabled: isPending,
                                children: isPending ? 'Sending...' : 'Send reset link'
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "email-sent-card-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "email-sent-info-box",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "email-icon-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emailSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "email-details",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "email-sent-label",
                                                children: "EMAIL SENT TO:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "email-address",
                                                children: email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: "primary",
                                className: "submit-btn bg-white w-100",
                                onClick: ()=>{
                                    window.location.href = `mailto:${email}`;
                                },
                                children: "Open email app"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "resend-link-text",
                                children: [
                                    "Didn't receive the email?",
                                    ' ',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: `resend-link-btn ${cooldown > 0 ? 'disabled-link' : ''}`,
                                        onClick: handleResetPassword,
                                        disabled: isPending || cooldown > 0,
                                        style: {
                                            opacity: cooldown > 0 ? 0.6 : 1,
                                            cursor: cooldown > 0 ? 'not-allowed' : 'pointer'
                                        },
                                        children: isPending ? 'Sending...' : cooldown > 0 ? `Resend link in ${cooldown}s` : 'Resend link'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                        variant: "outline",
                        className: "submit-btn m-auto back-to-login",
                        onClick: ()=>navigate('/onboarding-trainer/login'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backSvg.ReactComponent), {}),
                            " Back to Log in"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "forgot-password-bg-glow"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","./ForgotPassword.scss":"9zEyr","react":"bmhQu","react-router-dom":"f3cgC","../../components/Button/Button":"jLE7r","src/api/mutations/useAuthResetPassword":"l4cVK","src/utils/appAlert":"de4Mq","../../../../assets/images/onboarding-trainer/info.svg":"9S52k","../../../../assets/images/onboarding-trainer/email.svg":"97YKv","../../../../assets/images/onboarding-trainer/back.svg":"bVuDS","../../../../assets/images/onboarding-trainer/logo.svg":"iy8G7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9zEyr":[function() {},{}],"l4cVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthResetPassword", ()=>useAuthResetPassword);
var _reactQuery = require("@tanstack/react-query");
var _auth = require("firebase/auth");
var _firebase = require("src/config/firebase");
function useAuthResetPassword() {
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const { email } = payload;
            // Check if the user exists first
            const methods = await (0, _auth.fetchSignInMethodsForEmail)((0, _firebase.auth), email);
            if (methods.length === 0) throw new Error('auth/user-not-found');
            const basePath = "/";
            await (0, _auth.sendPasswordResetEmail)((0, _firebase.auth), email, {
                url: `${window.location.origin}${basePath}/onboarding-trainer/login?type=trainer`
            });
        }
    });
}

},{"@tanstack/react-query":"ehKs4","firebase/auth":"dZ6yw","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"97YKv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEmail);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEmail = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 44,
        height: 44,
        fill: "none",
        viewBox: "0 0 44 44",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 22C0 9.85 9.85 0 22 0s22 9.85 22 22-9.85 22-22 22S0 34.15 0 22"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 22C0 9.85 9.85 0 22 0s22 9.85 22 22-9.85 22-22 22S0 34.15 0 22"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.353,
                d: "M22 .176C34.053.176 43.824 9.947 43.824 22S34.053 43.824 22 43.824.176 34.053.176 22 9.947.176 22 .176Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#07092C",
                d: "M13.58 30.422a2.03 2.03 0 0 1-1.486-.618 2.03 2.03 0 0 1-.62-1.488v-12.63q0-.87.62-1.487a2.03 2.03 0 0 1 1.486-.619H30.42q.87 0 1.488.619.618.62.617 1.486v12.631a2.03 2.03 0 0 1-.617 1.488 2.02 2.02 0 0 1-1.488.618zM22 22.869q.132 0 .277-.04t.276-.118L30 18.054a.9.9 0 0 0 .316-.329.9.9 0 0 0 .105-.434q0-.526-.447-.79-.447-.263-.921.026l-7.052 4.421-7.053-4.42q-.474-.29-.92-.013-.449.276-.448.776 0 .263.105.46.105.198.316.303l7.447 4.657a1.1 1.1 0 0 0 .553.158"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M13.58 30.422a2.03 2.03 0 0 1-1.486-.618 2.03 2.03 0 0 1-.62-1.488v-12.63q0-.87.62-1.487a2.03 2.03 0 0 1 1.486-.619H30.42q.87 0 1.488.619.618.62.617 1.486v12.631a2.03 2.03 0 0 1-.617 1.488 2.02 2.02 0 0 1-1.488.618zM22 22.869q.132 0 .277-.04t.276-.118L30 18.054a.9.9 0 0 0 .316-.329.9.9 0 0 0 .105-.434q0-.526-.447-.79-.447-.263-.921.026l-7.052 4.421-7.053-4.42q-.474-.29-.92-.013-.449.276-.448.776 0 .263.105.46.105.198.316.303l7.447 4.657a1.1 1.1 0 0 0 .553.158"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 45.994,
                    x2: 11.817,
                    y1: 44.011,
                    y2: -11.286,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2xpwe":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResetPassword", ()=>ResetPassword);
var _jsxRuntime = require("react/jsx-runtime");
var _resetPasswordScss = require("./ResetPassword.scss");
// 🔹 React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 Routing
var _reactRouterDom = require("react-router-dom");
// 🔹 Components
var _button = require("../../components/Button/Button");
// 🔹 Assets
var _useAuthConfirmPasswordReset = require("src/api/mutations/useAuthConfirmPasswordReset");
var _appAlert = require("src/utils/appAlert");
var _passwordVerifySvg = require("../../../../assets/images/onboarding-trainer/password-verify.svg");
var _infoSvg = require("../../../../assets/images/onboarding-trainer/info.svg");
var _eyeClosedSvg = require("../../../../assets/images/onboarding-trainer/eye-closed.svg");
var _backSvg = require("../../../../assets/images/onboarding-trainer/back.svg");
var _eyeOpenSvg = require("../../../../assets/images/onboarding-trainer/eye-open.svg");
var _logoSvg = require("../../../../assets/images/onboarding-trainer/logo.svg");
const CheckIcon = ({ color })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: "14",
        height: "14",
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M11.6667 3.5L5.25004 9.91667L2.33337 7",
            stroke: color,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
        })
    });
const ResetPassword = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const oobCode = searchParams.get('oobCode');
    const [password, setPassword] = (0, _react.useState)('');
    const [confirmPassword, setConfirmPassword] = (0, _react.useState)('');
    const [showPassword, setShowPassword] = (0, _react.useState)(false);
    const [showConfirmPassword, setShowConfirmPassword] = (0, _react.useState)(false);
    const [isSuccess, setIsSuccess] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)({});
    const { mutateAsync: confirmReset, isPending } = (0, _useAuthConfirmPasswordReset.useAuthConfirmPasswordReset)();
    const requirements = [
        {
            label: 'At least 8 characters',
            met: password.length >= 8
        },
        {
            label: 'One uppercase letter',
            met: /[A-Z]/.test(password)
        },
        {
            label: 'One number',
            met: /[0-9]/.test(password)
        },
        {
            label: 'One special character',
            met: /[^A-Za-z0-9]/.test(password)
        }
    ];
    const handleResetPassword = async (e)=>{
        e.preventDefault();
        const newErrors = {};
        if (!oobCode) {
            (0, _appAlert.toast).error('Invalid or missing password reset code.');
            return;
        }
        if (!requirements.every((req)=>req.met)) newErrors.password = 'Please meet all password requirements';
        if (password !== confirmPassword) newErrors.confirmPassword = 'Passwords do not match';
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        try {
            await confirmReset({
                oobCode,
                newPassword: password
            });
            (0, _appAlert.toast).success('Password successfully reset. You can now log in.');
            setIsSuccess(true);
        } catch (error) {
            let errorMessage = 'Failed to reset password.';
            if (error.code === 'auth/invalid-action-code') errorMessage = 'The reset link has expired or is invalid.';
            else if (error.message) errorMessage = error.message.replace('Firebase: Error ', '').trim();
            setErrors({
                form: errorMessage
            });
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "onboarding-reset-password-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "reset-password-box",
                children: isSuccess ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "reset-password-success",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logo-placeholder",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoSvg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "success-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordVerifySvg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                            className: "reset-password-title",
                            children: 'Password updated'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "reset-password-subtitle",
                            children: [
                                "Your password has been changed successfully.",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "You can now log in with your new password."
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                            variant: "outline",
                            className: "submit-btn m-auto back-to-login",
                            onClick: ()=>navigate('/onboarding-trainer/login'),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backSvg.ReactComponent), {}),
                                " Back to Log in"
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "reset-password-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "logo-placeholder",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoSvg.ReactComponent), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    className: "reset-password-title",
                                    children: "Create new password"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "reset-password-subtitle",
                                    children: 'Choose a strong password for your miniPT account'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                            onSubmit: handleResetPassword,
                            className: "reset-password-form auth-form-common",
                            noValidate: true,
                            children: [
                                errors.form && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "error-message mb-2",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSvg.ReactComponent), {}),
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: errors.form
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "input-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            children: "NEW PASSWORD"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "password-input-wrapper",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: showPassword ? 'text' : 'password',
                                                    name: "newPassword",
                                                    autoComplete: "new-password",
                                                    placeholder: "Create a strong password",
                                                    value: password,
                                                    onChange: (e)=>{
                                                        setPassword(e.target.value);
                                                        if (errors.password) setErrors({
                                                            ...errors,
                                                            password: ''
                                                        });
                                                    },
                                                    className: errors.password ? 'error-input' : ''
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    className: "eye-btn",
                                                    onClick: ()=>setShowPassword(!showPassword),
                                                    tabIndex: -1,
                                                    children: showPassword ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyeOpenSvg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyeClosedSvg.ReactComponent), {})
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "input-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            children: "CONFIRM PASSWORD"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "password-input-wrapper",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: showConfirmPassword ? 'text' : 'password',
                                                    name: "confirmPassword",
                                                    autoComplete: "new-password",
                                                    placeholder: "Re-enter your password",
                                                    value: confirmPassword,
                                                    onChange: (e)=>{
                                                        setConfirmPassword(e.target.value);
                                                        if (errors.confirmPassword) setErrors({
                                                            ...errors,
                                                            confirmPassword: ''
                                                        });
                                                    },
                                                    className: errors.confirmPassword ? 'error-input' : ''
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    className: "eye-btn",
                                                    onClick: ()=>setShowConfirmPassword(!showConfirmPassword),
                                                    tabIndex: -1,
                                                    children: showConfirmPassword ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyeOpenSvg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eyeClosedSvg.ReactComponent), {})
                                                })
                                            ]
                                        }),
                                        errors.confirmPassword && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "error-message",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _infoSvg.ReactComponent), {}),
                                                " ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: errors.confirmPassword
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "password-requirements",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "requirements-title",
                                            children: "PASSWORD MUST INCLUDE"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                            children: requirements.map((req, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("li", {
                                                    className: req.met ? 'met' : '',
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)(CheckIcon, {
                                                            color: req.met ? 'var(--primary-color, #ffa100)' : 'var(--auth-text-muted)'
                                                        }),
                                                        req.label
                                                    ]
                                                }, index))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    type: "submit",
                                    variant: "primary",
                                    className: "submit-btn bg-white",
                                    disabled: isPending || !password || !confirmPassword,
                                    children: isPending ? 'Resetting...' : 'Reset password'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                            variant: "outline",
                            className: "submit-btn m-auto back-to-login",
                            onClick: ()=>navigate('/onboarding-trainer/login'),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backSvg.ReactComponent), {}),
                                " Back to Log in"
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "reset-password-bg-glow"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","./ResetPassword.scss":"3J5bm","react":"bmhQu","react-router-dom":"f3cgC","../../components/Button/Button":"jLE7r","src/api/mutations/useAuthConfirmPasswordReset":"kGvqV","src/utils/appAlert":"de4Mq","../../../../assets/images/onboarding-trainer/password-verify.svg":"kygI5","../../../../assets/images/onboarding-trainer/info.svg":"9S52k","../../../../assets/images/onboarding-trainer/eye-closed.svg":"i5yb0","../../../../assets/images/onboarding-trainer/back.svg":"bVuDS","../../../../assets/images/onboarding-trainer/eye-open.svg":"13Rvh","../../../../assets/images/onboarding-trainer/logo.svg":"iy8G7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3J5bm":[function() {},{}],"kGvqV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAuthConfirmPasswordReset", ()=>useAuthConfirmPasswordReset);
var _reactQuery = require("@tanstack/react-query");
var _auth = require("firebase/auth");
var _firebase = require("src/config/firebase");
function useAuthConfirmPasswordReset() {
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const { oobCode, newPassword } = payload;
            await (0, _auth.confirmPasswordReset)((0, _firebase.auth), oobCode, newPassword);
        }
    });
}

},{"@tanstack/react-query":"ehKs4","firebase/auth":"dZ6yw","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kygI5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPasswordVerify);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPasswordVerify = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 60,
        height: 60,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#04051B",
                d: "m26.108 36.3 16.95-16.95q.6-.6 1.4-.6t1.4.6.6 1.426-.6 1.424l-18.35 18.4q-.6.6-1.4.6t-1.4-.6l-8.6-8.6q-.6-.6-.576-1.424.024-.825.626-1.426a1.94 1.94 0 0 1 1.426-.6q.825.002 1.424.6z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "m26.108 36.3 16.95-16.95q.6-.6 1.4-.6t1.4.6.6 1.426-.6 1.424l-18.35 18.4q-.6.6-1.4.6t-1.4-.6l-8.6-8.6q-.6-.6-.576-1.424.024-.825.626-1.426a1.94 1.94 0 0 1 1.426-.6q.825.002 1.424.6z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 58.29,
                height: 58.29,
                x: 0.855,
                y: 0.855,
                stroke: "url(#b)",
                strokeWidth: 1.71,
                rx: 29.145
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "a",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(27.8991 -12.6281 2.78295 50.0018 17.294 37.392)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFEB14"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFA100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 30,
                        x2: 30,
                        y1: 0,
                        y2: 60,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 0.5,
                                stopColor: "#FFC109"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFA100"
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gIa7W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AuthAction", ()=>AuthAction);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
const AuthAction = ()=>{
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    (0, _react.useEffect)(()=>{
        const mode = searchParams.get('mode');
        const oobCode = searchParams.get('oobCode');
        const continueUrl = searchParams.get('continueUrl');
        // Check if this action originated from the Trainer App
        const isTrainerContext = continueUrl && continueUrl.includes('onboarding-trainer');
        if (isTrainerContext && mode === 'resetPassword' && oobCode) {
            // Redirect to the custom Trainer Reset Password screen
            navigate(`/onboarding-trainer/reset-password?oobCode=${oobCode}`, {
                replace: true
            });
            return;
        }
        // Fallback: Redirect all other actions (or non-trainer actions)
        // to the default Firebase Auth Action handler
        const firebaseDefaultUrl = `https://minipt-1.firebaseapp.com/__/auth/action${window.location.search}`;
        window.location.replace(firebaseDefaultUrl);
    }, [
        navigate,
        searchParams
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#060723',
            color: 'white'
        },
        children: "Loading..."
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"52uKi":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmailVerified", ()=>EmailVerified);
var _jsxRuntime = require("react/jsx-runtime");
var _emailVerifiedScss = require("./EmailVerified.scss");
// 🔹 React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 Routing
var _reactRouterDom = require("react-router-dom");
// 🔹 Components
var _button = require("../../components/Button/Button");
var _passwordVerifySvg = require("../../../../assets/images/onboarding-trainer/password-verify.svg");
var _backSvg = require("../../../../assets/images/onboarding-trainer/back.svg");
var _logoSvg = require("../../../../assets/images/onboarding-trainer/logo.svg");
const EmailVerified = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "onboarding-email-verified-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "email-verified-box",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "logo-placeholder",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "success-icon-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _passwordVerifySvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        className: "email-verified-title",
                        children: 'Your email has been verified'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "email-verified-subtitle",
                        children: 'You can now sign in with your new account'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                        variant: "outline",
                        className: "submit-btn m-auto back-to-login",
                        onClick: ()=>navigate('/onboarding-trainer/login'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backSvg.ReactComponent), {}),
                            " Back to Log in"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "email-verified-bg-glow"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","./EmailVerified.scss":"eKG0y","react":"bmhQu","react-router-dom":"f3cgC","../../components/Button/Button":"jLE7r","../../../../assets/images/onboarding-trainer/password-verify.svg":"kygI5","../../../../assets/images/onboarding-trainer/back.svg":"bVuDS","../../../../assets/images/onboarding-trainer/logo.svg":"iy8G7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eKG0y":[function() {},{}],"g1QQu":[function(require,module,exports,__globalThis) {
// 🔹 Stylesheets
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VerifyEmail", ()=>VerifyEmail);
var _jsxRuntime = require("react/jsx-runtime");
var _verifyEmailScss = require("./VerifyEmail.scss");
// 🔹 React Core
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
// 🔹 Routing
var _reactRouterDom = require("react-router-dom");
// 🔹 Firebase
var _auth = require("firebase/auth");
var _firebase = require("src/config/firebase");
// 🔹 Libraries
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
// 🔹 Components
var _button = require("../../components/Button/Button");
var _emailSvg = require("../../../../assets/images/onboarding-trainer/email.svg");
var _backSvg = require("../../../../assets/images/onboarding-trainer/back.svg");
var _logoSvg = require("../../../../assets/images/onboarding-trainer/logo.svg");
const VerifyEmail = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const { email = 'your email', fromLogin = false } = location.state || {};
    const [countdown, setCountdown] = (0, _react.useState)(fromLogin ? 0 : 60);
    const [isResending, setIsResending] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        let timer;
        if (countdown > 0) timer = setInterval(()=>setCountdown((c)=>c - 1), 1000);
        return ()=>clearInterval(timer);
    }, [
        countdown
    ]);
    const handleResend = async ()=>{
        if (!(0, _firebase.auth).currentUser) {
            (0, _reactHotToastDefault.default).error('Session expired. Please sign in again to resend.');
            return;
        }
        try {
            setIsResending(true);
            const basePath = "/";
            await (0, _auth.sendEmailVerification)((0, _firebase.auth).currentUser, {
                url: `${window.location.origin}${basePath}/onboarding-trainer/login?type=trainer`
            });
            (0, _reactHotToastDefault.default).success('Verification email sent!');
            setCountdown(60);
        } catch (error) {
            (0, _reactHotToastDefault.default).error(error?.message || 'Failed to resend email');
        } finally{
            setIsResending(false);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "onboarding-verify-email-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "verify-email-box",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "verify-email-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "logo-placeholder",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                className: "verify-email-title",
                                children: 'Verify your email'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "verify-email-subtitle",
                                children: 'Before logging in, please check your inbox and spam folder for a verification link.'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "email-sent-card-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "email-sent-info-box",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "email-icon-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emailSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "email-details",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "email-sent-label",
                                                children: 'EMAIL SENT TO:'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "email-address",
                                                children: email
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: "primary",
                                className: "submit-btn bg-white w-100",
                                onClick: ()=>{
                                    window.location.href = `mailto:${email}`;
                                },
                                children: 'Open email app'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "resend-email-link",
                                disabled: countdown > 0 || isResending,
                                onClick: handleResend,
                                children: countdown > 0 ? `Resend email in ${countdown}s` : 'Resend email'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                        variant: "outline",
                        className: "submit-btn back-to-login",
                        onClick: ()=>navigate('/onboarding-trainer/login'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backSvg.ReactComponent), {}),
                            " Back to Log in"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "verify-email-bg-glow"
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","./VerifyEmail.scss":"fQWWw","react":"bmhQu","react-router-dom":"f3cgC","firebase/auth":"dZ6yw","src/config/firebase":"cmjIE","react-hot-toast":"3T0Wh","../../components/Button/Button":"jLE7r","../../../../assets/images/onboarding-trainer/email.svg":"97YKv","../../../../assets/images/onboarding-trainer/back.svg":"bVuDS","../../../../assets/images/onboarding-trainer/logo.svg":"iy8G7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fQWWw":[function() {},{}],"kXA0H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dashboard", ()=>Dashboard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _sidebar = require("../../components/Sidebar/Sidebar");
var _reactRouterDom = require("react-router-dom");
var _sessionStore = require("src/store/sessionStore");
var _useGetOnboardingState = require("src/api/mutations/useGetOnboardingState");
var _firebase = require("src/config/firebase");
var _useUpdateTrainerProfile = require("src/api/mutations/useUpdateTrainerProfile");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _useIsDesktop = require("src/hooks/useIsDesktop");
var _dashboardScss = require("./Dashboard.scss");
var _hamburgerSvg = require("../../../../assets/images/onboarding-trainer/dashboard/hamburger.svg");
var _logoSvg = require("../../../../assets/images/onboarding-trainer/logo.svg");
const Dashboard = ()=>{
    const [isSidebarOpen, setIsSidebarOpen] = (0, _react.useState)(false);
    const [isSidebarCollapsed, setIsSidebarCollapsed] = (0, _react.useState)(false);
    const isLoggedIn = (0, _sessionStore.sessionStore)((state)=>state.isLoggedIn);
    const currentUser = (0, _sessionStore.sessionStore)((state)=>state.currentUser);
    // Fetch latest profile data in background if logged in
    (0, _useGetOnboardingState.useGetOnboardingState)(isLoggedIn ? currentUser?.uid : undefined);
    // Fetch program generator master data in the background and sync to UI store automatically
    (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const location = (0, _reactRouterDom.useLocation)();
    (0, _react.useEffect)(()=>{
        // Auto-collapse sidebar on program generator and generated routes
        if (location.pathname.includes('/dashboard/program-generator') || location.pathname.includes('/dashboard/program-generated') || location.pathname.match(/\/dashboard\/clients\/[^/]+/)) setIsSidebarCollapsed(true);
        else setIsSidebarCollapsed(false);
        // Scroll dashboard content to top on route changes
        const scrollableMain = document.getElementById('scrollableDashboardMain');
        if (scrollableMain) scrollableMain.scrollTop = 0;
        window.scrollTo(0, 0);
        if (document.documentElement) document.documentElement.scrollTop = 0;
        if (document.body) document.body.scrollTop = 0;
    }, [
        location.pathname
    ]);
    (0, _react.useEffect)(()=>{
        // Automatically reload Firebase Auth user to catch external email verifications
        if ((0, _firebase.auth).currentUser && currentUser) (0, _firebase.auth).currentUser.reload().then(()=>{
            const authEmail = (0, _firebase.auth).currentUser?.email;
            if (authEmail && authEmail !== currentUser.email) {
                // If the email was verified and updated in Firebase Auth, sync it to our backend & store
                (0, _sessionStore.sessionStore).getState().updateProfile({
                    email: authEmail
                });
                (0, _useUpdateTrainerProfile.updateTrainerProfile)({
                    uid: (0, _firebase.auth).currentUser.uid,
                    data: {
                        email: authEmail
                    }
                }).catch(console.error);
            }
        }).catch(console.error);
    }, [
        currentUser
    ]);
    const isDesktop = (0, _useIsDesktop.useIsDesktop)(768);
    const isDesktopMessages = isDesktop && location.pathname.includes('/dashboard/messages');
    const isMobileChatActive = !isDesktop && Boolean(location.pathname.match(/\/dashboard\/messages\/[^/]+/));
    const isChatActive = isDesktopMessages || isMobileChatActive;
    (0, _react.useEffect)(()=>{
        if (isChatActive) {
            document.documentElement.classList.add('chat-active-page');
            document.body.classList.add('chat-active-page');
        } else {
            document.documentElement.classList.remove('chat-active-page');
            document.body.classList.remove('chat-active-page');
        }
        return ()=>{
            document.documentElement.classList.remove('chat-active-page');
            document.body.classList.remove('chat-active-page');
        };
    }, [
        isChatActive
    ]);
    if (!isLoggedIn) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: "/onboarding-trainer/signup",
        replace: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `onboarding-dashboard-layout ${isSidebarCollapsed ? 'sidebar-collapsed' : ''} ${isChatActive ? 'chat-view-active-layout' : ''}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebar.Sidebar), {
                isOpen: isSidebarOpen,
                onClose: ()=>setIsSidebarOpen(false),
                isCollapsed: isSidebarCollapsed,
                onToggleCollapse: ()=>setIsSidebarCollapsed(!isSidebarCollapsed)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `dashboard-main ${isChatActive ? 'chat-view-active' : ''}`,
                id: "scrollableDashboardMain",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mobile-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "hamburger-btn",
                                onClick: ()=>setIsSidebarOpen(true),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hamburgerSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "mobile-logo",
                                onClick: ()=>setIsSidebarOpen(true),
                                style: {
                                    cursor: 'pointer'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoSvg.ReactComponent), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `dashboard-content-wrapper ${isChatActive ? 'chat-content-wrapper' : ''}`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {})
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../components/Sidebar/Sidebar":"jorGz","react-router-dom":[["Navigate","9oT3O"],["Outlet","9oT3O"],["useLocation","f3cgC"]],"src/store/sessionStore":"kPSO3","src/api/mutations/useGetOnboardingState":"3gbTg","src/config/firebase":"cmjIE","src/api/mutations/useUpdateTrainerProfile":"4z0zZ","src/api/mutations/useGetProgramMasterData":"bOtFg","src/hooks/useIsDesktop":"dYh53","./Dashboard.scss":"jat7a","../../../../assets/images/onboarding-trainer/dashboard/hamburger.svg":"lvqzy","../../../../assets/images/onboarding-trainer/logo.svg":"iy8G7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jorGz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Sidebar", ()=>Sidebar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _sessionStore = require("src/store/sessionStore");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _appAlert = require("src/utils/appAlert");
var _firebase = require("src/config/firebase");
var _auth = require("firebase/auth");
var _reactQuery = require("@tanstack/react-query");
var _sidebarScss = require("./Sidebar.scss");
var _sidebarNavSvg = require("../../../../assets/images/onboarding-trainer/components/sidebar/sidebar-nav.svg");
var _newProgramSvg = require("../../../../assets/images/onboarding-trainer/components/sidebar/new-program.svg");
var _programsSvg = require("../../../../assets/images/onboarding-trainer/components/sidebar/programs.svg");
var _messagesSvg = require("../../../../assets/images/onboarding-trainer/components/sidebar/messages.svg");
var _closeSvg = require("../../../../assets/images/onboarding-trainer/components/sidebar/close.svg");
var _clientsSvg = require("../../../../assets/images/onboarding-trainer/components/sidebar/clients.svg");
var _largeSvg = require("../../../../assets/images/onboarding-trainer/components/sidebar/large.svg");
var _smallSvg = require("../../../../assets/images/onboarding-trainer/components/sidebar/small.svg");
var _onlyLogoSvg = require("../../../../assets/images/onboarding-trainer/components/sidebar/only-logo.svg");
var _logoSvg = require("../../../../assets/images/onboarding-trainer/logo.svg");
var _subscriptionPlanMenuSvg = require("src/assets/images/onboarding-trainer/subscription-icons/profile-menu/subscription-plan-menu.svg");
var _profileMenuSvg = require("src/assets/images/onboarding-trainer/subscription-icons/profile-menu/profile-menu.svg");
var _logoutMenuSvg = require("src/assets/images/onboarding-trainer/subscription-icons/profile-menu/logout-menu.svg");
var _userChevronLeftSvg = require("src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg");
var _managePaymentMethodNextSvg = require("src/assets/images/onboarding-trainer/subscription-icons/billing-history/manage-payment-method-next.svg");
var _notificationSvg = require("src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/notification.svg");
var _useGetTrainerUnreadMessages = require("src/api/mutations/useGetTrainerUnreadMessages");
var _useChatRealtime = require("src/hooks/useChatRealtime");
var _useInquiriesRealtime = require("src/hooks/useInquiriesRealtime");
var _useCheckinsRealtime = require("src/hooks/useCheckinsRealtime");
var _useTrainerNotifications = require("src/hooks/useTrainerNotifications");
var _trainerPresence = require("src/services/presence/trainerPresence");
var _registerPush = require("src/services/push/registerPush");
const Sidebar = ({ isOpen, onClose, isCollapsed, onToggleCollapse })=>{
    const { currentUser, logout } = (0, _sessionStore.sessionStore)();
    const [isLogoutModalVisible, setIsLogoutModalVisible] = (0, _react.useState)(false);
    const [isLoggingOut, setIsLoggingOut] = (0, _react.useState)(false);
    const [isProfileMenuOpen, setIsProfileMenuOpen] = (0, _react.useState)(false);
    const [isNotificationsOpen, setIsNotificationsOpen] = (0, _react.useState)(false);
    const profileMenuRef = (0, _react.useRef)(null);
    const notificationsRef = (0, _react.useRef)(null);
    const navigate = (0, _reactRouterDom.useNavigate)();
    const location = (0, _reactRouterDom.useLocation)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    (0, _react.useEffect)(()=>{
        const handleClickOutside = (e)=>{
            const target = e.target;
            if (profileMenuRef.current && !profileMenuRef.current.contains(target)) setIsProfileMenuOpen(false);
            if (notificationsRef.current && !notificationsRef.current.contains(target)) setIsNotificationsOpen(false);
        };
        if (isProfileMenuOpen || isNotificationsOpen) document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        isProfileMenuOpen,
        isNotificationsOpen
    ]);
    (0, _react.useEffect)(()=>{
        setIsProfileMenuOpen(false);
        setIsNotificationsOpen(false);
    }, [
        location.pathname
    ]);
    const isDashboardScreens = location.pathname.includes('/dashboard/clients') || location.pathname.includes('/dashboard/programs') || location.pathname.includes('/dashboard/messages');
    const trainerUid = currentUser?.uid || '';
    const { data: unreadData } = (0, _useGetTrainerUnreadMessages.useGetTrainerUnreadMessages)();
    const { totalUnread: chatUnread } = (0, _useChatRealtime.useChatRealtime)();
    const { inquiries } = (0, _useInquiriesRealtime.useInquiriesRealtime)(trainerUid);
    const { checkins } = (0, _useCheckinsRealtime.useCheckinsRealtime)(trainerUid);
    const { notifications, unreadCount: unreadNotificationsCount, markAsRead: markNotificationRead } = (0, _useTrainerNotifications.useTrainerNotifications)(trainerUid);
    const unreadInquiries = inquiries.filter((inq)=>{
        const isSentByTrainer = inq.message?.sender_role === 'trainer' || inq.message?.sender_uid === trainerUid || inq.message?.send_uid === trainerUid;
        return !isSentByTrainer && !inq.message?.is_read;
    }).length;
    const unreadCheckins = checkins.filter((c)=>!c.is_read && (c.isAppoint || Boolean(c.appointUId))).length;
    // Realtime total unread overrides the initial fetch if available.
    const totalRealtimeUnread = (chatUnread || 0) + unreadInquiries + unreadCheckins;
    const displayUnread = totalRealtimeUnread > 0 ? totalRealtimeUnread : unreadData?.totalUnread || 0;
    const handleNotificationClick = async (notif)=>{
        await markNotificationRead(notif.id);
        setIsNotificationsOpen(false);
        closeSidebarOnMobile();
        if (notif.chat_id) navigate(`/onboarding-trainer/dashboard/messages/${notif.chat_id}`);
    };
    const closeSidebarOnMobile = ()=>{
        if (window.innerWidth < 992) onClose();
    };
    const handleNewProgram = ()=>{
        closeSidebarOnMobile();
        if (isDashboardScreens) navigate('/onboarding-trainer/dashboard');
        else navigate('/onboarding-trainer/dashboard/program-generator/ai?action=new_program');
    };
    const calculateProgress = ()=>{
        if (!currentUser) return 0;
        let score = 0;
        const totalFields = 11;
        if (currentUser.name && currentUser.surname) score += 1;
        if (currentUser.bio) score += 1;
        if (currentUser.experience) score += 1;
        if (currentUser.onboarding?.step3_offers && currentUser.onboarding.step3_offers.length > 0) score += 1;
        if (currentUser.certificates && currentUser.certificates.length > 0) score += 1;
        if (currentUser.expertise) score += 1;
        if (currentUser.trainingStyle) score += 1;
        if (currentUser.pricing && currentUser.pricing.length > 0) score += 1;
        if (currentUser.location) score += 1;
        if (currentUser.facility) score += 1;
        if (currentUser.introductionVideoUrl) score += 1;
        const rawPercentage = score / totalFields * 100;
        return Math.round(rawPercentage / 5) * 5;
    };
    const progress = calculateProgress();
    const getInitials = ()=>{
        if (!currentUser) return 'U';
        const first = currentUser.name?.[0] || '';
        const last = currentUser.surname?.[0] || (currentUser.name && currentUser.name.includes(' ') ? currentUser.name.trim().split(/\s+/)[1]?.[0] || '' : '');
        return `${first}${last}`.toUpperCase() || 'U';
    };
    const handleLogout = async ()=>{
        if (isLoggingOut) return;
        setIsLoggingOut(true);
        try {
            if (currentUser?.uid) await Promise.allSettled([
                (0, _trainerPresence.setTrainerOnlineStatus)(currentUser.uid, false),
                (0, _registerPush.unsubscribeBrowserPush)(currentUser.uid, 'trainer')
            ]);
            await (0, _auth.signOut)((0, _firebase.auth));
            queryClient.clear();
            logout();
            setIsLogoutModalVisible(false);
            (0, _appAlert.toast).success('Logged out successfully!', {
                position: 'top-right',
                style: {
                    borderRadius: '8px',
                    background: '#0a0b24',
                    color: '#fff',
                    border: '1px solid rgba(255, 255, 255, 0.1)',
                    minWidth: 'max-content'
                }
            });
            navigate('/onboarding-trainer/login');
        } catch (error) {
            console.error('Logout Error:', error);
            (0, _appAlert.toast).error('Failed to log out. Please try again.');
        } finally{
            setIsLoggingOut(false);
        }
    };
    (0, _react.useEffect)(()=>{
        if (isOpen) document.body.style.overflow = 'hidden';
        else document.body.style.overflow = '';
        return ()=>{
            document.body.style.overflow = '';
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "sidebar-overlay",
                onClick: onClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("aside", {
                className: `trainer-sidebar ${isOpen ? 'open' : ''} ${isCollapsed ? 'collapsed' : ''}`,
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "sidebar-top",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "sidebar-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "logo-container",
                                        onClick: ()=>{
                                            if (onToggleCollapse) onToggleCollapse();
                                            closeSidebarOnMobile();
                                        },
                                        style: {
                                            cursor: 'pointer'
                                        },
                                        children: isCollapsed ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onlyLogoSvg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoSvg.ReactComponent), {})
                                    }),
                                    !isCollapsed && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "desktop-toggle-btn",
                                        onClick: onToggleCollapse,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sidebarNavSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "mobile-close-btn",
                                        onClick: onClose,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "sidebar-action",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "new-program-btn",
                                    onClick: handleNewProgram,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _newProgramSvg.ReactComponent), {}),
                                        !isCollapsed && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: 'Create'
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("nav", {
                                className: "sidebar-nav",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.NavLink), {
                                        to: "/onboarding-trainer/dashboard/clients",
                                        className: ({ isActive })=>`nav-item ${isActive ? 'active' : ''}`,
                                        onClick: closeSidebarOnMobile,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientsSvg.ReactComponent), {}),
                                            !isCollapsed && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Clients"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.NavLink), {
                                        to: "/onboarding-trainer/dashboard/programs",
                                        className: ({ isActive })=>`nav-item ${isActive ? 'active' : ''}`,
                                        onClick: closeSidebarOnMobile,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programsSvg.ReactComponent), {}),
                                            !isCollapsed && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Programs"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactRouterDom.NavLink), {
                                        to: "/onboarding-trainer/dashboard/messages",
                                        className: ({ isActive })=>`nav-item ${isActive ? 'active' : ''}`,
                                        onClick: closeSidebarOnMobile,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "nav-icon-wrapper",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesSvg.ReactComponent), {}),
                                                    isCollapsed && displayUnread > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "unread-dot-badge"
                                                    })
                                                ]
                                            }),
                                            !isCollapsed && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Messages"
                                            }),
                                            !isCollapsed && displayUnread > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "unread-badge",
                                                children: displayUnread > 99 ? '99+' : displayUnread
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "notifications-nav-wrapper",
                                        ref: notificationsRef,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: `nav-item notifications-toggle-btn ${isNotificationsOpen ? 'active' : ''}`,
                                                onClick: ()=>setIsNotificationsOpen(!isNotificationsOpen),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "nav-icon-wrapper",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notificationSvg.ReactComponent), {}),
                                                            isCollapsed && unreadNotificationsCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "unread-dot-badge"
                                                            })
                                                        ]
                                                    }),
                                                    !isCollapsed && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: 'Notifications'
                                                    }),
                                                    !isCollapsed && unreadNotificationsCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "unread-badge",
                                                        children: unreadNotificationsCount > 99 ? '99+' : unreadNotificationsCount
                                                    })
                                                ]
                                            }),
                                            isNotificationsOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "notifications-popover",
                                                children: notifications.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "empty-notifications",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        children: 'No notifications yet'
                                                    })
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "notifications-list-scroll",
                                                    children: notifications.map((notif)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: `notification-item ${!notif.is_read ? 'unread' : ''}`,
                                                            onClick: ()=>handleNotificationClick(notif),
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "notif-icon-circle",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notificationSvg.ReactComponent), {
                                                                        className: "notif-bell-icon"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "notif-content-col",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "notif-title-row",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "notif-title",
                                                                                    children: notif.title
                                                                                }),
                                                                                !notif.is_read && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "notif-unread-dot"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                            className: "notif-body",
                                                                            children: notif.body
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }, notif.id))
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "sidebar-bottom",
                        ref: profileMenuRef,
                        children: [
                            isProfileMenuOpen && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "profile-popup-menu",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        type: "button",
                                        className: "profile-menu-item",
                                        onClick: ()=>{
                                            setIsProfileMenuOpen(false);
                                            closeSidebarOnMobile();
                                            navigate('/onboarding-trainer/dashboard/subscription');
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "menu-icon-wrap",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _subscriptionPlanMenuSvg.ReactComponent), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Subscription Plan'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        type: "button",
                                        className: "profile-menu-item",
                                        onClick: ()=>{
                                            setIsProfileMenuOpen(false);
                                            closeSidebarOnMobile();
                                            navigate('/onboarding-trainer/dashboard/profile');
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "menu-icon-wrap",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileMenuSvg.ReactComponent), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Profile'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        type: "button",
                                        className: "profile-menu-item logout-item",
                                        onClick: ()=>{
                                            setIsProfileMenuOpen(false);
                                            setIsLogoutModalVisible(true);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "menu-icon-wrap",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoutMenuSvg.ReactComponent), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Logout'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: `user-profile ${isProfileMenuOpen ? 'menu-active' : ''}`,
                                onClick: ()=>setIsProfileMenuOpen((prev)=>!prev),
                                role: "button",
                                tabIndex: 0,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "avatar",
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            backgroundColor: '#fff',
                                            fontWeight: 'bold',
                                            backgroundImage: currentUser?.avatarUrl ? `url(${currentUser.avatarUrl})` : 'none',
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            color: currentUser?.avatarUrl ? 'transparent' : '#060723'
                                        },
                                        children: !currentUser?.avatarUrl && getInitials()
                                    }),
                                    !isCollapsed && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "user-info",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "user-name",
                                                        children: currentUser ? `${currentUser.name || ''} ${currentUser.surname || ''}`.trim() || 'Guest User' : 'Guest User'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "user-progress",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                children: [
                                                                    progress,
                                                                    "%"
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "progress-bar-container",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "progress-bar",
                                                                    style: {
                                                                        width: `${progress}%`
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: `user-arrow ${isProfileMenuOpen ? 'menu-open' : 'menu-closed'}`,
                                                children: isProfileMenuOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userChevronLeftSvg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _managePaymentMethodNextSvg.ReactComponent), {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: isLogoutModalVisible,
                footer: null,
                onCancel: ()=>{
                    if (!isLoggingOut) setIsLogoutModalVisible(false);
                },
                centered: true,
                width: 420,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _largeSvg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Log out?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Are you sure you want to log out of your account?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-logout",
                                    onClick: handleLogout,
                                    disabled: isLoggingOut,
                                    style: {
                                        opacity: isLoggingOut ? 0.8 : 1,
                                        cursor: isLoggingOut ? 'not-allowed' : 'pointer'
                                    },
                                    children: isLoggingOut ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                    style: {
                                                        fontSize: 16,
                                                        color: '#060723'
                                                    },
                                                    spin: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Logging out..."
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smallSvg.ReactComponent), {}),
                                            " Log out"
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setIsLogoutModalVisible(false),
                                    disabled: isLoggingOut,
                                    style: {
                                        opacity: isLoggingOut ? 0.5 : 1,
                                        cursor: isLoggingOut ? 'not-allowed' : 'pointer'
                                    },
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","src/store/sessionStore":"kPSO3","antd":[["Modal","kY4DD","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"src/utils/appAlert":"de4Mq","src/config/firebase":"cmjIE","firebase/auth":"dZ6yw","@tanstack/react-query":"97Oud","./Sidebar.scss":"2zW5p","../../../../assets/images/onboarding-trainer/components/sidebar/sidebar-nav.svg":"7kj30","../../../../assets/images/onboarding-trainer/components/sidebar/new-program.svg":"6DMuL","../../../../assets/images/onboarding-trainer/components/sidebar/programs.svg":"ke67c","../../../../assets/images/onboarding-trainer/components/sidebar/messages.svg":"5Mkl3","../../../../assets/images/onboarding-trainer/components/sidebar/close.svg":"4rVUz","../../../../assets/images/onboarding-trainer/components/sidebar/clients.svg":"2oZzI","../../../../assets/images/onboarding-trainer/components/sidebar/large.svg":"3hTE1","../../../../assets/images/onboarding-trainer/components/sidebar/small.svg":"2jDJP","../../../../assets/images/onboarding-trainer/components/sidebar/only-logo.svg":"5717Y","../../../../assets/images/onboarding-trainer/logo.svg":"iy8G7","src/assets/images/onboarding-trainer/subscription-icons/profile-menu/subscription-plan-menu.svg":"kP0fu","src/assets/images/onboarding-trainer/subscription-icons/profile-menu/profile-menu.svg":"cfRnV","src/assets/images/onboarding-trainer/subscription-icons/profile-menu/logout-menu.svg":"jDBoj","src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg":"bF2mm","src/assets/images/onboarding-trainer/subscription-icons/billing-history/manage-payment-method-next.svg":"kgObN","src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/notification.svg":"9EZ1c","src/api/mutations/useGetTrainerUnreadMessages":"4vC0Z","src/hooks/useChatRealtime":"dvay5","src/hooks/useInquiriesRealtime":"kno3J","src/hooks/useCheckinsRealtime":"dnr1Y","src/hooks/useTrainerNotifications":"8Rd8u","src/services/presence/trainerPresence":"8wUar","src/services/push/registerPush":"xSUJJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2zW5p":[function() {},{}],"7kj30":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSidebarNav);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSidebarNav = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M9 3.5v17M3 9.4c0-2.24 0-3.36.436-4.216a4 4 0 0 1 1.748-1.748C6.04 3 7.16 3 9.4 3h5.2c2.24 0 3.36 0 4.216.436a4 4 0 0 1 1.748 1.748C21 6.04 21 7.16 21 9.4v5.2c0 2.24 0 3.36-.436 4.216a4 4 0 0 1-1.748 1.748C17.96 21 16.84 21 14.6 21H9.4c-2.24 0-3.36 0-4.216-.436a4 4 0 0 1-1.748-1.748C3 17.96 3 16.84 3 14.6z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6DMuL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNewProgram);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNewProgram = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: 20,
        height: 20,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12 5v14m-7-7h14"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ke67c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPrograms);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPrograms = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        width: 20,
        height: 20,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5Mkl3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessages);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessages = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 17 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M4.5 5.708h6.75M4.5 8.542h6.75M4.5 11.375h3.75m7.5-3.542c0 3.912-3.358 7.084-7.5 7.084H.75V7.833C.75 3.921 4.108.75 8.25.75s7.5 3.171 7.5 7.083"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4rVUz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgClose);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgClose = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.667,
            d: "m11 21 10-10m-10 0 10 10"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2oZzI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgClients);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgClients = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 20,
        height: 20,
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 2,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 9,
                cy: 7,
                r: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M23 21v-2a4 4 0 0 0-3-3.87m-4-12a4 4 0 0 1 0 7.75"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3hTE1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLarge);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLarge = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 64,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M32 .25C49.535.25 63.75 14.465 63.75 32S49.535 63.75 32 63.75.25 49.535.25 32 14.465.25 32 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M32 .25C49.535.25 63.75 14.465 63.75 32S49.535 63.75 32 63.75.25 49.535.25 32 14.465.25 32 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2.333,
                d: "M28.5 42.5h-4.667a2.333 2.333 0 0 1-2.333-2.333V23.833a2.333 2.333 0 0 1 2.333-2.333H28.5m8.164 16.33 5.833-5.833-5.833-5.833M42.5 32h-14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 66.9,
                        x2: 17.188,
                        y1: 64.016,
                        y2: -16.416,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 32,
                        x2: 32,
                        y1: 0,
                        y2: 64,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2jDJP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSmall);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSmall = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#07092C",
            fillRule: "evenodd",
            d: "M6 2a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm10.293 5.293a1 1 0 0 1 1.414 0l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L18.586 13H10a1 1 0 0 1 0-2h8.586l-2.293-2.293a1 1 0 0 1 0-1.414",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5717Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOnlyLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOnlyLogo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 27,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M3.298 11.605c.038-.013.33-.088.367-.088L24.58 6.129 14.345.276A2 2 0 0 0 13.317 0c-.367 0-.723.1-1.027.276L.558 6.996c-.33.188-.558.54-.558.954v5.526a9.2 9.2 0 0 1 3.298-1.872M13.305 2.8c1.42 0 2.536 1.143 2.422 2.537-.101 1.255-1.192 2.248-2.46 2.235-1.345 0-2.372-1.067-2.36-2.449C10.92 3.804 11.96 2.8 13.305 2.8m4.084 8.315s-.406.98-.926 2.185c.76.314 6.468 2.725 6.48 2.738a6.79 6.79 0 0 1 3.577 4.61c.038.2.076.401.102.602V8.741zm5.606 13.011a3.7 3.7 0 0 0 .52-2.826 3.79 3.79 0 0 0-1.979-2.55l-6.278-2.637-2.778 6.506a8.16 8.16 0 0 1-4.566 4.458l4.35 2.487c.305.176.66.276 1.028.276.38 0 .723-.1 1.027-.276l7.496-4.283a3.45 3.45 0 0 0 1.18-1.155m-9.31-12.056-9.538 2.448-.367.088A5.09 5.09 0 0 0 0 19.53c0 2.801 2.258 5.062 5.023 5.062a5.03 5.03 0 0 0 4.616-3.065l.254-.59c.786-1.808 2.854-6.656 3.792-8.867"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kP0fu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSubscriptionPlanMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSubscriptionPlanMenu = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 19,
        fill: "none",
        viewBox: "0 0 17 19",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M5.844 2.873c.498-1.458 2.513-1.502 3.104-.132l.05.133.672 1.967a3.33 3.33 0 0 0 1.897 2.009l.18.068 1.967.671c1.459.498 1.503 2.513.134 3.104l-.134.05-1.966.673a3.34 3.34 0 0 0-2.01 1.896l-.068.18L9 15.46c-.499 1.458-2.514 1.502-3.104.133l-.051-.133-.672-1.967a3.33 3.33 0 0 0-1.897-2.01l-.18-.067-1.966-.672c-1.46-.498-1.504-2.513-.134-3.103l.134-.052 1.966-.671a3.33 3.33 0 0 0 2.01-1.897l.067-.18zM14.088 0a.83.83 0 0 1 .748.467l.04.097.292.855.856.292a.834.834 0 0 1 .098 1.537l-.098.04-.855.292-.292.856a.833.833 0 0 1-1.538.097l-.04-.097-.291-.855-.856-.292a.833.833 0 0 1-.098-1.537l.098-.04.855-.292.292-.856A.83.83 0 0 1 14.088 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cfRnV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProfileMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProfileMenu = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 18,
        fill: "none",
        viewBox: "0 0 15 18",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M7.5 8.75A4.375 4.375 0 1 0 7.5 0a4.375 4.375 0 0 0 0 8.75M2.188 10A2.19 2.19 0 0 0 0 12.188v.312c0 1.496.952 2.76 2.303 3.62 1.359.866 3.198 1.38 5.197 1.38s3.838-.514 5.197-1.38C14.048 15.26 15 13.997 15 12.5v-.312A2.19 2.19 0 0 0 12.813 10z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jDBoj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLogoutMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLogoutMenu = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 14,
        fill: "none",
        viewBox: "0 0 15 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.6,
            d: "m11.17 3.716 2.963 2.917L11.17 9.55m2.963-2.917H3.763M8.207 9.55v.729a2.17 2.17 0 0 1-.65 1.547 2.24 2.24 0 0 1-1.572.64H3.022a2.24 2.24 0 0 1-1.571-.64A2.17 2.17 0 0 1 .8 10.279V2.987c0-.58.234-1.136.65-1.546A2.24 2.24 0 0 1 3.023.8h2.963c.59 0 1.155.23 1.571.64.417.41.651.967.651 1.547v.73"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bF2mm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgUserChevronLeft);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUserChevronLeft = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 18,
        fill: "none",
        viewBox: "0 0 10 18",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M8.5 1.5 1.5 9l7 7.5"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kgObN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgManagePaymentMethodNext);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgManagePaymentMethodNext = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 6,
        height: 10,
        fill: "none",
        viewBox: "0 0 6 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "m.667 8.667 4-4-4-4"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9EZ1c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNotification);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNotification = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "m13.748 10.666-.153-.185c-.687-.832-1.103-1.334-1.103-3.688 0-1.219-.29-2.219-.865-2.969-.423-.554-.996-.974-1.75-1.285a.1.1 0 0 1-.026-.02C9.58 1.608 8.837 1 8.001 1c-.838 0-1.58.61-1.852 1.518a.1.1 0 0 1-.025.02c-1.76.725-2.616 2.117-2.616 4.254 0 2.355-.415 2.857-1.103 3.688l-.152.185a1.1 1.1 0 0 0-.145 1.176c.192.406.603.658 1.071.658h9.645c.467 0 .874-.252 1.068-.656a1.1 1.1 0 0 0-.144-1.177M8 15a2.5 2.5 0 0 0 2.2-1.317.126.126 0 0 0-.05-.167.13.13 0 0 0-.061-.016H5.912a.124.124 0 0 0-.125.121q-.001.033.014.062A2.5 2.5 0 0 0 8.001 15"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4vC0Z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchTrainerUnreadMessages", ()=>fetchTrainerUnreadMessages);
parcelHelpers.export(exports, "useGetTrainerUnreadMessages", ()=>useGetTrainerUnreadMessages);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _deepCamelCaseKeys = require("src/utils/deepCamelCaseKeys");
var _sessionStore = require("src/store/sessionStore");
var _firebase = require("src/config/firebase");
const fetchTrainerUnreadMessages = async ()=>{
    const token = await (0, _firebase.auth).currentUser?.getIdToken();
    if (!token) throw new Error('Not authenticated');
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_UNREAD_MESSAGES}`;
    const response = await fetch(apiUrl, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!response.ok) {
        const err = await response.json().catch(()=>({}));
        throw new Error(err.error?.message || `Failed to fetch unread messages: ${response.status}`);
    }
    const res = await response.json();
    const parsedData = (0, _deepCamelCaseKeys.deepCamelCaseKeys)(res);
    return parsedData;
};
function useGetTrainerUnreadMessages() {
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const trainerId = currentUser?.uid;
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'trainer-unread-messages',
            trainerId
        ],
        queryFn: ()=>fetchTrainerUnreadMessages(),
        enabled: !!trainerId,
        staleTime: 300000
    });
}

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","src/utils/deepCamelCaseKeys":"9w8Oj","src/store/sessionStore":"kPSO3","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9w8Oj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deepCamelCaseKeys", ()=>deepCamelCaseKeys);
const toCamelCase = (str)=>{
    return str.replace(/_([a-z0-9])/g, (g)=>g[1].toUpperCase());
};
const deepCamelCaseKeys = (obj)=>{
    if (Array.isArray(obj)) return obj.map((v)=>deepCamelCaseKeys(v));
    else if (obj !== null && obj !== undefined && obj.constructor === Object) return Object.keys(obj).reduce((result, key)=>{
        result[toCamelCase(key)] = deepCamelCaseKeys(obj[key]);
        return result;
    }, {});
    return obj;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dvay5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useChatRealtime", ()=>useChatRealtime);
var _react = require("react");
var _firestore = require("firebase/firestore");
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
/**
 * Normalizes raw Firestore chat document to the standard ChatConversationItem shape
 * so that realtime data matches the API data exactly.
 */ function normalizeFirestoreChat(docData, chatId, trainerUid) {
    if (!docData) return null;
    const participants = docData.participants || [];
    if (!participants.includes(trainerUid)) return null;
    // client is the other participant
    const clientUid = participants.find((p)=>p !== trainerUid);
    if (!clientUid) return null;
    const rawLastMsg = docData.last_message;
    let bodyStr = '';
    let msgType = 'text';
    let senderUid = '';
    let fullName = 'Client';
    let profilePicture = null;
    if (typeof rawLastMsg === 'string') {
        const trimmed = rawLastMsg.trim();
        const bracketMatch = trimmed.match(/^\[([A-Z0-9_-]+)\]$/i);
        if (bracketMatch) {
            msgType = bracketMatch[1].toLowerCase();
            bodyStr = '';
        } else bodyStr = trimmed;
    } else if (rawLastMsg && typeof rawLastMsg === 'object') {
        bodyStr = (rawLastMsg.body || '').trim();
        msgType = (rawLastMsg.message_type || 'text').toLowerCase();
        const bracketMatch = bodyStr.match(/^\[([A-Z0-9_-]+)\]$/i);
        if (bracketMatch) {
            if (!rawLastMsg.message_type || rawLastMsg.message_type === 'text') msgType = bracketMatch[1].toLowerCase();
            bodyStr = '';
        }
        senderUid = rawLastMsg.sender_uid || '';
        if (rawLastMsg.sender_uid === clientUid) {
            fullName = rawLastMsg.sender_name || fullName;
            profilePicture = rawLastMsg.sender_avatar || profilePicture;
        } else if (rawLastMsg.receive_uid === clientUid) {
            fullName = rawLastMsg.receive_name || fullName;
            profilePicture = rawLastMsg.receive_avatar || profilePicture;
        }
    }
    const unreadCount = docData[`unread_count_${trainerUid}`] || 0;
    const lastMessageTime = docData.last_message_time || docData.update_time;
    let sendTimeIso = new Date().toISOString();
    if (lastMessageTime) {
        if (typeof lastMessageTime.toDate === 'function') sendTimeIso = lastMessageTime.toDate().toISOString();
        else if (typeof lastMessageTime === 'string') sendTimeIso = new Date(lastMessageTime).toISOString();
        else if (typeof lastMessageTime === 'number') sendTimeIso = new Date(lastMessageTime).toISOString();
    }
    const isActive = docData.is_active !== undefined ? Boolean(docData.is_active) : true;
    const isUnbound = Boolean(docData.is_unbound);
    return {
        chatId,
        client: {
            uid: clientUid,
            fullName,
            profilePicture
        },
        lastMessage: {
            body: bodyStr,
            messageType: msgType,
            senderUid,
            sendTime: sendTimeIso
        },
        unreadCount,
        isUnread: unreadCount > 0,
        isActive,
        isUnbound
    };
}
function useChatRealtime() {
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const trainerId = currentUser?.uid;
    // We store the current realtime updates in a map to easily merge
    const [realtimeUpdates, setRealtimeUpdates] = (0, _react.useState)({});
    // To avoid unneeded re-renders when setting state, track unread total manually if needed
    const [totalUnread, setTotalUnread] = (0, _react.useState)(0);
    (0, _react.useEffect)(()=>{
        if (!trainerId) return;
        const chatsRef = (0, _firestore.collection)((0, _firebase.db), 'flutter_chat_messages');
        const q = (0, _firestore.query)(chatsRef, (0, _firestore.where)('participants', 'array-contains', trainerId), (0, _firestore.orderBy)('last_message_time', 'desc'), (0, _firestore.limit)(100));
        const unsubscribe = (0, _firestore.onSnapshot)(q, (snapshot)=>{
            const updates = {};
            let currentUnread = 0;
            snapshot.docs.forEach((doc)=>{
                const data = doc.data();
                const normalized = normalizeFirestoreChat(data, doc.id, trainerId);
                if (normalized) {
                    updates[doc.id] = normalized;
                    currentUnread += normalized.unreadCount;
                }
            });
            setRealtimeUpdates(updates);
            setTotalUnread(currentUnread);
        }, (err)=>{
            console.error('Error in realtime chat listener:', err);
        });
        return ()=>unsubscribe();
    }, [
        trainerId
    ]);
    return {
        realtimeUpdates,
        totalUnread
    };
}

},{"react":"bmhQu","firebase/firestore":"5IgBQ","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kno3J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useInquiriesRealtime", ()=>useInquiriesRealtime);
var _react = require("react");
var _firestore = require("firebase/firestore");
var _auth = require("firebase/auth");
var _firebase = require("src/config/firebase");
const useInquiriesRealtime = (trainerUid)=>{
    const [inquiries, setInquiries] = (0, _react.useState)([]);
    const [isLoading, setIsLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    const [activeUid, setActiveUid] = (0, _react.useState)(()=>(0, _firebase.auth).currentUser?.uid || (trainerUid && !trainerUid.includes('@') ? trainerUid : ''));
    (0, _react.useEffect)(()=>{
        const unsubscribeAuth = (0, _auth.onAuthStateChanged)((0, _firebase.auth), (user)=>{
            if (user?.uid) setActiveUid(user.uid);
            else setIsLoading(false);
        });
        return ()=>unsubscribeAuth();
    }, []);
    (0, _react.useEffect)(()=>{
        const uidToUse = activeUid || (0, _firebase.auth).currentUser?.uid || (trainerUid && !trainerUid.includes('@') ? trainerUid : '');
        if (!uidToUse) return;
        setIsLoading(true);
        // Ensure we have a composite index for this:
        // collectionGroup: messages
        // fields: receive_uid (ASC), message_type (ASC), send_time (DESC)
        const clientQuery = (0, _firestore.query)((0, _firestore.collectionGroup)((0, _firebase.db), 'messages'), (0, _firestore.where)('receive_uid', '==', uidToUse), (0, _firestore.where)('message_type', '==', 'inquiry'), (0, _firestore.orderBy)('send_time', 'desc'), (0, _firestore.limit)(100));
        let clientItems = [];
        let supportItems = [];
        const updateCombined = ()=>{
            const combined = [
                ...clientItems,
                ...supportItems
            ];
            combined.sort((a, b)=>{
                const timeA = a.message.send_time ? new Date(typeof a.message.send_time.toDate === 'function' ? a.message.send_time.toDate() : a.message.send_time).getTime() : 0;
                const timeB = b.message.send_time ? new Date(typeof b.message.send_time.toDate === 'function' ? b.message.send_time.toDate() : b.message.send_time).getTime() : 0;
                return timeB - timeA;
            });
            setInquiries(combined);
            setIsLoading(false);
            setError(null);
        };
        const unsubscribeClient = (0, _firestore.onSnapshot)(clientQuery, (snapshot)=>{
            const items = [];
            snapshot.docs.forEach((docSnap)=>{
                const chatId = docSnap.ref.parent.parent?.id;
                const data = docSnap.data();
                if (chatId) items.push({
                    chatId,
                    message: {
                        ...data,
                        id: docSnap.id
                    }
                });
            });
            clientItems = items;
            updateCombined();
        }, (err)=>{
            console.error('Error fetching client inquiries:', err);
            setError(err);
            setIsLoading(false);
        });
        // Support chat inquiries listener
        const supportChatId = `support_${uidToUse}`;
        const supportQuery = (0, _firestore.query)((0, _firestore.collection)((0, _firebase.db), 'flutter_chat_messages', supportChatId, 'messages'), (0, _firestore.orderBy)('send_time', 'desc'), (0, _firestore.limit)(50));
        const unsubscribeSupport = (0, _firestore.onSnapshot)(supportQuery, (snapshot)=>{
            const items = [];
            snapshot.docs.forEach((docSnap)=>{
                const data = docSnap.data();
                if (data.is_support || data.message_type === 'support' || data.subject) items.push({
                    chatId: supportChatId,
                    message: {
                        ...data,
                        id: docSnap.id,
                        inquiryType: data.topic || data.inquiryType || 'Billing & Subscription',
                        inquirySubject: data.subject || data.inquirySubject || 'Support Request',
                        inquiryDetail: data.message || data.body || '',
                        sender_name: data.sender_role === 'trainer' || data.sender_uid === uidToUse || data.send_uid === uidToUse ? data.sender_name || 'You' : 'miniPT Support',
                        is_support: true
                    }
                });
            });
            supportItems = items;
            updateCombined();
        }, ()=>{
            supportItems = [];
            updateCombined();
        });
        return ()=>{
            unsubscribeClient();
            unsubscribeSupport();
        };
    }, [
        trainerUid,
        activeUid
    ]);
    return {
        inquiries,
        isLoading,
        error
    };
};

},{"react":"bmhQu","firebase/firestore":"5IgBQ","firebase/auth":"dZ6yw","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dnr1Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCheckinsRealtime", ()=>useCheckinsRealtime);
var _react = require("react");
var _firestore = require("firebase/firestore");
var _auth = require("firebase/auth");
var _firebase = require("src/config/firebase");
var _checkins = require("src/api/checkins");
const useCheckinsRealtime = (trainerUid, bookedOnly = true)=>{
    const [checkins, setCheckins] = (0, _react.useState)([]);
    const [checkinDaysMap, setCheckinDaysMap] = (0, _react.useState)({});
    const [isLoading, setIsLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    const [activeUid, setActiveUid] = (0, _react.useState)(()=>(0, _firebase.auth).currentUser?.uid || (trainerUid && !trainerUid.includes('@') ? trainerUid : ''));
    (0, _react.useEffect)(()=>{
        const unsubscribeAuth = (0, _auth.onAuthStateChanged)((0, _firebase.auth), (user)=>{
            if (user?.uid) setActiveUid(user.uid);
            else setActiveUid(trainerUid && !trainerUid.includes('@') ? trainerUid : '');
        });
        return ()=>unsubscribeAuth();
    }, [
        trainerUid
    ]);
    (0, _react.useEffect)(()=>{
        const uidToUse = activeUid || (0, _firebase.auth).currentUser?.uid || (trainerUid && !trainerUid.includes('@') ? trainerUid : '');
        if (!uidToUse) return;
        setIsLoading(true);
        // Query checkinList subcollection under trainer_app_users/{uidToUse}
        const checkinListCol = (0, _firestore.collection)((0, _firebase.db), 'trainer_app_users', uidToUse, 'checkinList');
        const unsubscribe = (0, _firestore.onSnapshot)(checkinListCol, (snapshot)=>{
            const items = [];
            const daysMap = {};
            snapshot.docs.forEach((doc)=>{
                const docData = doc.data();
                const dateStr = docData.date || doc.id;
                const morning = docData.morningList || [];
                const daytime = docData.daytimeList || [];
                const evening = docData.eveningList || [];
                daysMap[dateStr] = {
                    date: dateStr,
                    morningList: morning,
                    daytimeList: daytime,
                    eveningList: evening
                };
                [
                    'morningList',
                    'daytimeList',
                    'eveningList'
                ].forEach((listKey)=>{
                    const slotList = docData[listKey] || [];
                    slotList.forEach((slot)=>{
                        if (!slot || typeof slot !== 'object') return;
                        const isAppointed = Boolean(slot.isAppoint || slot.appointUId);
                        // Option A: Only include booked student appointments, ignore empty availability slots
                        if (bookedOnly && !isAppointed) return;
                        items.push((0, _checkins.enrichClientCheckin)(slot, dateStr, uidToUse));
                    });
                });
            });
            // Sort in memory by date + time descending
            items.sort((a, b)=>{
                const dateA = `${a.date || ''}T${a.time || '00:00'}`;
                const dateB = `${b.date || ''}T${b.time || '00:00'}`;
                return dateB.localeCompare(dateA);
            });
            setCheckins(items);
            setCheckinDaysMap(daysMap);
            setIsLoading(false);
            setError(null);
        }, (err)=>{
            console.error('Error fetching check-ins realtime from checkinList:', err);
            setError(err);
            setIsLoading(false);
        });
        return ()=>unsubscribe();
    }, [
        trainerUid,
        activeUid,
        bookedOnly
    ]);
    return {
        checkins,
        checkinDaysMap,
        isLoading,
        error
    };
};

},{"react":"bmhQu","firebase/firestore":"5IgBQ","firebase/auth":"dZ6yw","src/config/firebase":"cmjIE","src/api/checkins":"NC6YO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"NC6YO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHECKIN_PROGRESS", ()=>CHECKIN_PROGRESS);
parcelHelpers.export(exports, "fetchTrainerCheckins", ()=>fetchTrainerCheckins);
parcelHelpers.export(exports, "fetchTrainerCheckinDetails", ()=>fetchTrainerCheckinDetails);
parcelHelpers.export(exports, "markTrainerCheckinRead", ()=>markTrainerCheckinRead);
parcelHelpers.export(exports, "confirmTrainerCheckin", ()=>confirmTrainerCheckin);
parcelHelpers.export(exports, "completeTrainerCheckin", ()=>completeTrainerCheckin);
parcelHelpers.export(exports, "fetchZoomMeetingStatus", ()=>fetchZoomMeetingStatus);
parcelHelpers.export(exports, "suggestTrainerCheckin", ()=>suggestTrainerCheckin);
parcelHelpers.export(exports, "declineTrainerCheckin", ()=>declineTrainerCheckin);
parcelHelpers.export(exports, "sendTrainerCheckinReminder", ()=>sendTrainerCheckinReminder);
parcelHelpers.export(exports, "updateTrainerCheckinActionItems", ()=>updateTrainerCheckinActionItems);
parcelHelpers.export(exports, "useGetTrainerCheckins", ()=>useGetTrainerCheckins);
parcelHelpers.export(exports, "useConfirmCheckinMutation", ()=>useConfirmCheckinMutation);
parcelHelpers.export(exports, "useCompleteCheckinMutation", ()=>useCompleteCheckinMutation);
parcelHelpers.export(exports, "useZoomMeetingStatusQuery", ()=>useZoomMeetingStatusQuery);
parcelHelpers.export(exports, "useSuggestCheckinMutation", ()=>useSuggestCheckinMutation);
parcelHelpers.export(exports, "useDeclineCheckinMutation", ()=>useDeclineCheckinMutation);
parcelHelpers.export(exports, "useSendCheckinReminderMutation", ()=>useSendCheckinReminderMutation);
parcelHelpers.export(exports, "useUpdateCheckinActionItemsMutation", ()=>useUpdateCheckinActionItemsMutation);
parcelHelpers.export(exports, "useGetTrainerCheckinDetails", ()=>useGetTrainerCheckinDetails);
parcelHelpers.export(exports, "useMarkCheckinReadMutation", ()=>useMarkCheckinReadMutation);
parcelHelpers.export(exports, "enrichClientCheckin", ()=>enrichClientCheckin);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
const CHECKIN_PROGRESS = {
    PENDING: '1',
    PROPOSED_NEW_TIME: '2',
    CONFIRMED: '3',
    ATTENDED: '4',
    DECLINED: '5',
    CANCELLED: '6'
};
const getAuthToken = async ()=>{
    const token = await (0, _firebase.auth).currentUser?.getIdToken();
    if (!token) throw new Error('ERR_UNAUTHORIZED');
    return token;
};
const fetchTrainerCheckins = async (params)=>{
    const token = await getAuthToken();
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.clientId && params.clientId !== 'all') queryParams.append('clientId', params.clientId);
    if (params.status && params.status !== 'all') queryParams.append('status', params.status);
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.limit !== undefined) queryParams.append('limit', params.limit.toString());
    if (params.cursor) queryParams.append('cursor', params.cursor);
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_CHECKINS}?${queryParams.toString()}`;
    const response = await fetch(apiUrl, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new Error(`Failed to fetch check-ins: ${response.status}`);
    return response.json();
};
const fetchTrainerCheckinDetails = async (checkinId, targetDate, chatId)=>{
    const token = await getAuthToken();
    const queryParams = new URLSearchParams();
    queryParams.append('checkin_id', checkinId);
    if (targetDate) queryParams.append('date', targetDate);
    if (chatId) queryParams.append('chat_id', chatId);
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_CHECKIN_DETAILS}?${queryParams.toString()}`;
    const response = await fetch(apiUrl, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        const errData = await response.json().catch(()=>null);
        throw new Error(errData?.error?.message || `Failed to fetch check-in details: ${response.status}`);
    }
    return response.json();
};
const markTrainerCheckinRead = async (payload)=>{
    const token = await getAuthToken();
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_MARK_CHECKIN_READ}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            checkin_id: payload.checkinId,
            date: payload.targetDate,
            chat_id: payload.chatId
        })
    });
    if (!response.ok) {
        const errData = await response.json().catch(()=>null);
        throw new Error(errData?.error?.message || `Failed to mark check-in read: ${response.status}`);
    }
    return response.json();
};
const confirmTrainerCheckin = async (payload)=>{
    const token = await getAuthToken();
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_CONFIRM_CHECKIN}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            checkin_id: payload.checkinId,
            chat_id: payload.chatId,
            send_zoom_link_on_confirm: payload.sendZoomLinkOnConfirm
        })
    });
    if (!response.ok) {
        const errData = await response.json().catch(()=>null);
        throw new Error(errData?.error?.message || `Failed to confirm check-in: ${response.status}`);
    }
    return response.json();
};
const completeTrainerCheckin = async (payload)=>{
    const token = await getAuthToken();
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_COMPLETE_CHECKIN}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            checkin_id: payload.checkinId,
            chat_id: payload.chatId,
            attendance: payload.attendance || 'attended',
            duration_mins: payload.durationMins || 30,
            notes: payload.notes || '',
            action_items: payload.actionItems || []
        })
    });
    if (!response.ok) {
        const errData = await response.json().catch(()=>null);
        throw new Error(errData?.error?.message || `Failed to complete check-in: ${response.status}`);
    }
    return response.json();
};
const fetchZoomMeetingStatus = async (checkinId, chatId)=>{
    try {
        const token = await getAuthToken();
        const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_ZOOM_MEETING_STATUS}`;
        const response = await fetch(apiUrl, {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                checkin_id: checkinId,
                chat_id: chatId
            })
        });
        if (!response.ok) return {
            success: false,
            has_zoom_meeting: false
        };
        return await response.json();
    } catch  {
        return {
            success: false,
            has_zoom_meeting: false
        };
    }
};
const suggestTrainerCheckin = async (payload)=>{
    const token = await getAuthToken();
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_SUGGEST_CHECKIN}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            checkin_id: payload.checkinId,
            chat_id: payload.chatId,
            suggested_date: payload.suggestedDate,
            suggested_time: payload.suggestedTime,
            suggested_select_time_type: payload.suggestedSelectTimeType,
            suggested_type: payload.suggestedType,
            timezone: payload.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
            notes: payload.notes || ''
        })
    });
    if (!response.ok) {
        const errData = await response.json().catch(()=>null);
        throw new Error(errData?.error?.message || `Failed to suggest new time: ${response.status}`);
    }
    return response.json();
};
const declineTrainerCheckin = async (payload)=>{
    const token = await getAuthToken();
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_DECLINE_CHECKIN}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            checkin_id: payload.checkinId,
            chat_id: payload.chatId,
            reason: payload.reason || ''
        })
    });
    if (!response.ok) {
        const errData = await response.json().catch(()=>null);
        throw new Error(errData?.error?.message || `Failed to decline check-in: ${response.status}`);
    }
    return response.json();
};
const sendTrainerCheckinReminder = async (payload)=>{
    const token = await getAuthToken();
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_SEND_CHECKIN_REMINDER}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            checkin_id: payload.checkinId,
            chat_id: payload.chatId
        })
    });
    if (!response.ok) {
        const errData = await response.json().catch(()=>null);
        throw new Error(errData?.error?.message || `Failed to send reminder: ${response.status}`);
    }
    return response.json();
};
const updateTrainerCheckinActionItems = async (payload)=>{
    const token = await getAuthToken();
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_UPDATE_CHECKIN_ACTION_ITEMS}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            checkin_id: payload.checkinId,
            chat_id: payload.chatId,
            action_items: payload.actionItems
        })
    });
    if (!response.ok) {
        const errData = await response.json().catch(()=>null);
        throw new Error(errData?.error?.message || `Failed to update action items: ${response.status}`);
    }
    return response.json();
};
const useGetTrainerCheckins = (params, enabled = true)=>{
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const trainerUid = (0, _firebase.auth).currentUser?.uid || currentUser?.uid || '';
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'trainer-checkins',
            trainerUid,
            params
        ],
        queryFn: ()=>fetchTrainerCheckins(params),
        enabled: enabled && !!trainerUid,
        staleTime: 60000
    });
};
const useConfirmCheckinMutation = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: confirmTrainerCheckin,
        onSuccess: (data)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-checkins'
                ]
            });
            queryClient.setQueryData([
                'checkin-detail',
                data.checkin.id
            ], data.checkin);
        }
    });
};
const useCompleteCheckinMutation = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: completeTrainerCheckin,
        onSuccess: (data)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-checkins'
                ]
            });
            queryClient.setQueryData([
                'checkin-detail',
                data.checkin.id
            ], data.checkin);
        }
    });
};
const useZoomMeetingStatusQuery = (checkinId, chatId, enabled = false)=>{
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'zoom-meeting-status',
            checkinId
        ],
        queryFn: ()=>fetchZoomMeetingStatus(checkinId, chatId),
        enabled: enabled && !!checkinId,
        staleTime: 30000,
        retry: 1
    });
};
const useSuggestCheckinMutation = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: suggestTrainerCheckin,
        onSuccess: (data)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-checkins'
                ]
            });
            queryClient.setQueryData([
                'checkin-detail',
                data.checkin.id
            ], data.checkin);
        }
    });
};
const useDeclineCheckinMutation = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: declineTrainerCheckin,
        onSuccess: (data)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-checkins'
                ]
            });
            queryClient.setQueryData([
                'checkin-detail',
                data.checkin.id
            ], data.checkin);
        }
    });
};
const useSendCheckinReminderMutation = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: sendTrainerCheckinReminder,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-checkins'
                ]
            });
        }
    });
};
const useUpdateCheckinActionItemsMutation = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: updateTrainerCheckinActionItems,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-checkins'
                ]
            });
        }
    });
};
const useGetTrainerCheckinDetails = (checkinId, options)=>{
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'checkin-detail',
            checkinId
        ],
        queryFn: ()=>fetchTrainerCheckinDetails(checkinId, options?.targetDate, options?.chatId),
        enabled: Boolean(checkinId) && options?.enabled !== false,
        staleTime: 30000
    });
};
const useMarkCheckinReadMutation = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: markTrainerCheckinRead,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-checkins'
                ]
            });
        }
    });
};
function enrichClientCheckin(slot, docDate, trainerUid) {
    const checkinProgress = slot.checkinProgress ? String(slot.checkinProgress) : undefined;
    const slotTime = slot.checkinTime || slot.time || '';
    const effectiveDate = slot.checkinDate || slot.date || docDate || '';
    // Canonical message doc ID determination:
    // 1. Explicit slot.message_id
    // 2. slot.id if from a chat message (message_type === 'checkin') or if it's a doc ID (not a slot time '15:00')
    const isDocId = (val)=>Boolean(val && typeof val === 'string' && !val.includes(':') && !val.includes('/'));
    const rawId = slot.id || slot.checkin_id;
    const messageId = slot.message_id || (slot.message_type === 'checkin' ? slot.id : undefined) || (isDocId(rawId) ? rawId : undefined);
    const canonicalId = messageId || (isDocId(slot.checkin_id) ? slot.checkin_id : undefined) || (isDocId(slot.id) ? slot.id : undefined) || `${effectiveDate}_${slotTime || '00:00'}`;
    const clientUid = slot.appointUId || slot.client_uid || slot.userUID || '';
    const rawStatus = slot.status || 'open';
    let appStatus = slot.app_status;
    if (!appStatus) {
        if (checkinProgress === '3') appStatus = 'confirmed';
        else if (checkinProgress === '4') appStatus = 'completed';
        else if (checkinProgress === '5' || checkinProgress === '6') appStatus = 'declined';
        else if (checkinProgress === '1' || checkinProgress === '2') appStatus = 'pending_confirmation';
        else if (rawStatus === 'close') appStatus = 'completed';
        else if (slot.isAppoint || clientUid) appStatus = slot.zoom_link || slot.zoomMeetingUrl ? 'confirmed' : 'pending_confirmation';
        else appStatus = 'pending_confirmation';
    }
    let statusBadge = slot.status_badge;
    let headerTitle = slot.header_title;
    if (!statusBadge || !headerTitle) {
        if (checkinProgress === '2') {
            statusBadge = {
                label: slot.checkinNewSuggest ? 'Client Counter-Proposal' : 'New Time Proposed',
                className: 'new_time_proposed',
                hasDot: true
            };
            headerTitle = slot.checkinNewSuggest ? 'Client suggested another time' : 'New check-in time proposed';
        } else if (checkinProgress === '6') {
            statusBadge = {
                label: 'Cancelled',
                className: 'declined',
                hasDot: false
            };
            headerTitle = 'Check-in cancelled';
        } else if (appStatus === 'confirmed') {
            statusBadge = {
                label: 'Confirmed',
                className: 'confirmed',
                hasDot: false
            };
            headerTitle = 'Check-in confirmed';
        } else if (appStatus === 'completed') {
            statusBadge = {
                label: 'Completed',
                className: 'completed',
                hasDot: false
            };
            headerTitle = 'Check-in completed';
        } else if (appStatus === 'declined') {
            statusBadge = {
                label: 'Declined',
                className: 'declined',
                hasDot: false
            };
            headerTitle = 'Check-in declined';
        } else {
            statusBadge = {
                label: 'Pending confirmation',
                className: 'pending_confirmation',
                hasDot: true
            };
            headerTitle = 'Check-in request';
        }
    }
    const checkinType = slot.checkinType || (slot.preference === 'in_person' ? 'inPerson' : 'online');
    const preference = slot.preference || (checkinType === 'inPerson' ? 'in_person' : 'online_zoom');
    let preferenceLabel = slot.preference_label;
    if (!preferenceLabel) {
        if (preference === 'online_zoom' || checkinType === 'online') preferenceLabel = 'Online via Zoom';
        else if (preference === 'in_person' || checkinType === 'inPerson') preferenceLabel = 'In-person';
        else if (preference === 'phone') preferenceLabel = 'Phone call';
        else preferenceLabel = preference;
    }
    let formattedDate = slot.formatted_date;
    let formattedTime = slot.formatted_time;
    if (!formattedDate || !formattedTime) try {
        if (slotTime && slotTime.includes(':')) {
            const parts = slotTime.split(':');
            const hr = parseInt(parts[0], 10);
            const mn = parts[1].replace(/[^\d]/g, '');
            const isAlreadyAmPm = /AM|PM/i.test(slotTime);
            if (isAlreadyAmPm) formattedTime = slotTime;
            else {
                const ampm = hr >= 12 ? 'PM' : 'AM';
                const hr12 = hr % 12 || 12;
                formattedTime = `${hr12}:${mn.padStart(2, '0')} ${ampm}`;
            }
        } else formattedTime = slotTime || '12:00 PM';
        if (effectiveDate && /^\d{4}-\d{2}-\d{2}/.test(effectiveDate)) {
            const dObj = new Date(effectiveDate.slice(0, 10) + 'T00:00:00');
            formattedDate = dObj.toLocaleDateString('en-US', {
                month: 'short',
                day: '2-digit',
                year: 'numeric'
            });
        } else formattedDate = effectiveDate || 'Jul 23, 2026';
    } catch  {
        formattedDate = effectiveDate || 'Jul 23, 2026';
        formattedTime = slotTime || '12:00 PM';
    }
    const formattedSubtitle = slot.formatted_subtitle || `${formattedDate} \xb7 ${formattedTime} \xb7 ${preferenceLabel}`;
    const clientName = slot.client_name && slot.client_name !== 'Client' ? slot.client_name : clientUid ? 'Guest' : 'Available slot';
    let clientInitials = slot.client_initials;
    if (!clientInitials || clientInitials === 'CL') {
        if (clientName && clientName !== 'Available slot' && clientName !== 'Guest') {
            const parts = clientName.trim().split(' ');
            if (parts.length >= 2) clientInitials = (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
            else if (parts.length === 1) clientInitials = parts[0].slice(0, 2).toUpperCase();
        } else if (clientName === 'Guest') clientInitials = 'GU';
        if (!clientInitials) clientInitials = 'GU';
    }
    const zoomUrl = slot.zoomMeetingUrl || slot.zoom_link || '';
    let meetingId = slot.zoomMeetingId || slot.meeting_id || '';
    let passcode = slot.zoomMeetingPwd || slot.passcode || '';
    if (zoomUrl && (!meetingId || !passcode)) {
        const idMatch = zoomUrl.match(/\/j\/(\d+)/);
        const pwdMatch = zoomUrl.match(/[?&]pwd=([^&#]+)/);
        if (idMatch && !meetingId) {
            const rawId = idMatch[1];
            meetingId = rawId.length >= 10 ? `${rawId.slice(0, 3)} ${rawId.slice(3, 7)} ${rawId.slice(7)}` : rawId;
        }
        if (pwdMatch && !passcode) {
            const rawPwd = pwdMatch[1];
            passcode = rawPwd.length > 8 ? rawPwd.slice(0, 6) : rawPwd;
        }
    }
    const isAppointed = Boolean(slot.isAppoint || clientUid);
    const isRead = slot.is_read !== undefined ? Boolean(slot.is_read) : appStatus === 'completed' || appStatus === 'declined' || !isAppointed;
    return {
        ...slot,
        id: canonicalId,
        checkin_id: canonicalId,
        message_id: messageId || (isDocId(canonicalId) ? canonicalId : undefined),
        date: effectiveDate,
        time: slotTime,
        status: appStatus,
        legacy_status: rawStatus,
        header_title: headerTitle,
        status_badge: statusBadge,
        preference,
        preference_label: preferenceLabel,
        checkinType,
        // Mobile Checkin lifecycle fields
        checkinProgress,
        checkinDate: slot.checkinDate || effectiveDate,
        checkinTime: slot.checkinTime || slotTime,
        checkinSelectTimeType: slot.checkinSelectTimeType,
        checkinNewDate: slot.checkinNewDate || slot.suggested_date,
        checkinNewTime: slot.checkinNewTime || slot.suggested_time,
        checkinNewSelectTimeType: slot.checkinNewSelectTimeType,
        checkinNewType: slot.checkinNewType,
        checkinNewSuggest: Boolean(slot.checkinNewSuggest),
        checkinDeclinedReason: slot.checkinDeclinedReason || slot.decline_reason,
        zoomMeetingUrl: zoomUrl,
        zoomMeetingId: meetingId,
        zoomMeetingPwd: passcode,
        formatted_date: formattedDate,
        formatted_time: formattedTime,
        formatted_subtitle: formattedSubtitle,
        formatted_sent_time: slot.formatted_sent_time || '',
        isAppoint: isAppointed,
        appointUId: clientUid,
        client_uid: clientUid,
        trainer_uid: trainerUid,
        client_name: clientName,
        client_avatar: slot.client_avatar || slot.avatar || slot.avatarUrl || slot.profile_picture || null,
        client_email: slot.client_email || slot.email || slot.clientEmail || '',
        client_initials: clientInitials,
        zoom_link: zoomUrl,
        meeting_id: meetingId,
        passcode,
        notes: slot.notes || '',
        attachments: slot.attachments || [],
        action_items: slot.action_items || [],
        ai_progress_summary: slot.ai_progress_summary || null,
        ai_summary: slot.ai_summary || [],
        transcript_highlights: slot.transcript_highlights || [],
        full_transcript: slot.full_transcript || [],
        attendance: slot.attendance || 'attended',
        duration_mins: slot.duration_mins || 30,
        is_read: isRead,
        read_time: slot.read_time || null,
        read_by: slot.read_by || '',
        suggested_date: slot.checkinNewDate || slot.suggested_date,
        suggested_time: slot.checkinNewTime || slot.suggested_time,
        suggested_datetime_utc: slot.suggested_datetime_utc,
        suggestion_notes: slot.suggestion_notes,
        decline_reason: slot.checkinDeclinedReason || slot.decline_reason,
        created_at: slot.created_at,
        updated_at: slot.updated_at,
        status_updated_at: slot.status_updated_at,
        status_updated_by: slot.status_updated_by,
        chat_id: slot.chat_id || (clientUid ? `${trainerUid}_${clientUid}` : '')
    };
}

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQuery","lWWNx"],["useQueryClient","97Oud"]],"src/config/api-config":"9oD3c","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Rd8u":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTrainerNotifications", ()=>useTrainerNotifications);
var _react = require("react");
var _firestore = require("firebase/firestore");
var _auth = require("firebase/auth");
var _firebase = require("src/config/firebase");
const useTrainerNotifications = (trainerUid)=>{
    const [notifications, setNotifications] = (0, _react.useState)([]);
    const [isLoading, setIsLoading] = (0, _react.useState)(true);
    const [activeUid, setActiveUid] = (0, _react.useState)(()=>(0, _firebase.auth).currentUser?.uid || (trainerUid && !trainerUid.includes('@') ? trainerUid : ''));
    (0, _react.useEffect)(()=>{
        const unsubscribeAuth = (0, _auth.onAuthStateChanged)((0, _firebase.auth), (user)=>{
            if (user?.uid) setActiveUid(user.uid);
            else setIsLoading(false);
        });
        return ()=>unsubscribeAuth();
    }, []);
    const uidToUse = activeUid || (0, _firebase.auth).currentUser?.uid || (trainerUid && !trainerUid.includes('@') ? trainerUid : '');
    (0, _react.useEffect)(()=>{
        if (!uidToUse) {
            setIsLoading(false);
            return;
        }
        setIsLoading(true);
        const notifQuery = (0, _firestore.query)((0, _firestore.collection)((0, _firebase.db), 'trainer_app_users', uidToUse, 'notifications'), (0, _firestore.orderBy)('created_at', 'desc'), (0, _firestore.limit)(30));
        const unsubscribe = (0, _firestore.onSnapshot)(notifQuery, (snapshot)=>{
            const items = [];
            snapshot.forEach((d)=>{
                const data = d.data();
                items.push({
                    id: d.id,
                    title: data.title || 'Notification',
                    body: data.body || '',
                    type: data.type || 'system',
                    chat_id: data.chat_id,
                    message_id: data.message_id,
                    sender_uid: data.sender_uid,
                    sender_name: data.sender_name,
                    sender_avatar: data.sender_avatar,
                    is_read: Boolean(data.is_read),
                    created_at: data.created_at
                });
            });
            setNotifications(items);
            setIsLoading(false);
        }, (error)=>{
            console.error('Error fetching trainer notifications:', error);
            setIsLoading(false);
        });
        return ()=>unsubscribe();
    }, [
        uidToUse
    ]);
    const markAsRead = (0, _react.useCallback)(async (notificationId)=>{
        if (!uidToUse || !notificationId) return;
        try {
            const notifDocRef = (0, _firestore.doc)((0, _firebase.db), 'trainer_app_users', uidToUse, 'notifications', notificationId);
            await (0, _firestore.updateDoc)(notifDocRef, {
                is_read: true
            });
        } catch (err) {
            console.error('Failed to mark notification as read:', err);
        }
    }, [
        uidToUse
    ]);
    const unreadCount = notifications.filter((n)=>!n.is_read).length;
    return {
        notifications,
        unreadCount,
        isLoading,
        markAsRead
    };
};

},{"react":"bmhQu","firebase/firestore":"5IgBQ","firebase/auth":"dZ6yw","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8wUar":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setTrainerOnlineStatus", ()=>setTrainerOnlineStatus);
parcelHelpers.export(exports, "initializeTrainerPresence", ()=>initializeTrainerPresence);
var _firestore = require("firebase/firestore");
var _firebase = require("src/config/firebase");
const setTrainerOnlineStatus = async (uid, isOnline)=>{
    if (!uid || uid.includes('@')) return;
    try {
        const trainerDocRef = (0, _firestore.doc)((0, _firebase.db), 'trainer_app_users', uid);
        await (0, _firestore.setDoc)(trainerDocRef, {
            is_online: isOnline,
            last_seen: (0, _firestore.serverTimestamp)()
        }, {
            merge: true
        });
    } catch (error) {
        if (error?.code === 'permission-denied') // Ignore permission denied errors on logout where the token is already cleared
        return;
        console.error(`[Trainer Presence] Failed to update status (isOnline=${isOnline}):`, error);
    }
};
const initializeTrainerPresence = (uid)=>{
    if (!uid || uid.includes('@')) return ()=>{};
    // 1. Immediately mark trainer as online
    setTrainerOnlineStatus(uid, true);
    // 2. Periodic heartbeat every 60 seconds while active
    const HEARTBEAT_INTERVAL_MS = 60000;
    const heartbeatTimer = setInterval(()=>{
        if (document.visibilityState === 'visible') setTrainerOnlineStatus(uid, true);
    }, HEARTBEAT_INTERVAL_MS);
    // 3. Tab visibility change handler
    const handleVisibilityChange = ()=>{
        if (document.visibilityState === 'visible') setTrainerOnlineStatus(uid, true);
        else // Refresh last_seen when backgrounded
        setTrainerOnlineStatus(uid, true);
    };
    // 4. Page hide / unload handlers
    const handlePageHide = ()=>{
        setTrainerOnlineStatus(uid, false);
    };
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('pagehide', handlePageHide);
    window.addEventListener('beforeunload', handlePageHide);
    // Cleanup function
    return ()=>{
        clearInterval(heartbeatTimer);
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        window.removeEventListener('pagehide', handlePageHide);
        window.removeEventListener('beforeunload', handlePageHide);
        // Mark offline on unmount/cleanup
        setTrainerOnlineStatus(uid, false);
    };
};

},{"firebase/firestore":"5IgBQ","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"xSUJJ":[function(require,module,exports,__globalThis) {
// Firebase Cloud Messaging (FCM) push notification registration service
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Checks whether Firebase Cloud Messaging is supported in the current browser environment.
 */ parcelHelpers.export(exports, "isFCMSupported", ()=>isFCMSupported);
/**
 * Safely retrieves the Firebase Messaging instance only when supported by the browser,
 * preventing `messaging/unsupported-browser` unhandled rejections in Safari and unsupported environments.
 */ parcelHelpers.export(exports, "getMessagingSafely", ()=>getMessagingSafely);
/**
 * Generates a stable unique document ID from an FCM token
 */ parcelHelpers.export(exports, "getSubscriptionId", ()=>getSubscriptionId);
/**
 * Registers browser service worker, requests FCM notification permissions,
 * and saves the FCM token to Firestore.
 */ parcelHelpers.export(exports, "registerBrowserPush", ()=>registerBrowserPush);
/**
 * Removes a specific device's push subscription from Firestore and local state.
 */ parcelHelpers.export(exports, "removePushSubscription", ()=>removePushSubscription);
/**
 * Unsubscribes FCM push notifications and clears the token in Firestore.
 */ parcelHelpers.export(exports, "unsubscribeBrowserPush", ()=>unsubscribeBrowserPush);
/**
 * Retrieves list of active registered push devices for the user.
 */ parcelHelpers.export(exports, "getUserPushSubscriptions", ()=>getUserPushSubscriptions);
/**
 * Retrieves the current FCM token for this browser session.
 */ parcelHelpers.export(exports, "getCurrentFCMToken", ()=>getCurrentFCMToken);
/**
 * Retrieves and logs the current FCM token for this browser session.
 */ parcelHelpers.export(exports, "printCurrentFCMToken", ()=>printCurrentFCMToken);
/**
 * Foreground message listener when the app tab is active
 */ parcelHelpers.export(exports, "onForegroundFCMMessage", ()=>onForegroundFCMMessage);
var _messaging = require("firebase/messaging");
var _firestore = require("firebase/firestore");
var _firebase = require("src/config/firebase");
const getMessaging = _messaging.getMessaging;
const onMessage = _messaging.onMessage;
const isSupported = _messaging.isSupported;
let isSupportedPromise = null;
async function isFCMSupported() {
    if (typeof window === 'undefined') return false;
    if (!('serviceWorker' in navigator) || !('Notification' in window)) return false;
    if (typeof isSupported !== 'function') return false;
    if (!isSupportedPromise) isSupportedPromise = isSupported().catch(()=>false);
    return isSupportedPromise;
}
async function getMessagingSafely() {
    try {
        const supported = await isFCMSupported();
        if (!supported) return null;
        return getMessaging((0, _firebase.app));
    } catch (err) {
        console.warn('[FCM Push] Browser does not support Firebase Messaging:', err);
        return null;
    }
}
const getFcmToken = _messaging.getToken;
const deleteFcmToken = _messaging.deleteToken;
function getSubscriptionId(token) {
    return token.slice(-32).replace(/[^a-zA-Z0-9]/g, '') || 'fcm_device';
}
async function registerBrowserPush(userId, userRole = 'trainer') {
    if (!userId || userId.includes('@')) return {
        success: false,
        status: 'FAILED',
        error: 'Invalid user ID'
    };
    if (typeof window === 'undefined' || !('serviceWorker' in navigator) || !('Notification' in window)) return {
        success: false,
        status: 'UNSUPPORTED',
        error: 'Web Push Notifications are not supported in this browser.'
    };
    try {
        // 1. Request Notification permission
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return {
            success: false,
            status: 'DENIED',
            error: 'Notification permission was denied.'
        };
        // 2. Register Firebase Messaging Service Worker
        const swUrl = `${window.location.origin}/firebase-messaging-sw.js`;
        const registration = await navigator.serviceWorker.register(swUrl, {
            scope: '/'
        });
        await navigator.serviceWorker.ready;
        // 3. Obtain FCM Token
        const messaging = await getMessagingSafely();
        if (!messaging) return {
            success: false,
            status: 'UNSUPPORTED',
            error: 'Web Push Notifications are not supported in this browser.'
        };
        const token = await getFcmToken(messaging, {
            serviceWorkerRegistration: registration
        });
        if (!token) return {
            success: false,
            status: 'FAILED',
            error: 'Failed to retrieve FCM token from Firebase.'
        };
        // eslint-disable-next-line no-console
        console.log('%c[FCM Push] FCM Registration Token:%c ' + token, 'background: #F59E0B; color: #000; font-weight: bold; padding: 2px 6px; border-radius: 4px;', 'color: #00E676; font-weight: bold;');
        const subId = getSubscriptionId(token);
        const nowIso = new Date().toISOString();
        const userCollection = userRole === 'trainer' ? 'trainer_app_users' : 'flutter_user';
        // Store current device token & sub ID in localStorage for matching
        if (typeof window !== 'undefined') try {
            localStorage.setItem('minipt_current_fcm_token', token);
            localStorage.setItem('minipt_current_fcm_sub_id', subId);
        } catch  {
        // Ignored
        }
        // 4. Save to User document (main FCMToken field + fcm_tokens array)
        const userDocRef = (0, _firestore.doc)((0, _firebase.db), userCollection, userId);
        try {
            await (0, _firestore.updateDoc)(userDocRef, {
                FCMToken: token,
                fcm_tokens: (0, _firestore.arrayUnion)(token),
                fcm_updated_at: nowIso
            });
        } catch  {
            await (0, _firestore.setDoc)(userDocRef, {
                FCMToken: token,
                fcm_tokens: [
                    token
                ],
                fcm_updated_at: nowIso
            }, {
                merge: true
            });
        }
        // 5. Save device info in subcollection for device management
        const subDocRef = (0, _firestore.doc)((0, _firebase.db), userCollection, userId, 'push_subscriptions', subId);
        await (0, _firestore.setDoc)(subDocRef, {
            fcm_token: token,
            endpoint: token,
            ua: navigator.userAgent,
            created_at: nowIso,
            last_active_at: nowIso
        }, {
            merge: true
        });
        return {
            success: true,
            status: 'GRANTED',
            token,
            subId
        };
    } catch (error) {
        const errMessage = error instanceof Error ? error.message : 'Unknown registration error';
        return {
            success: false,
            status: 'FAILED',
            error: errMessage
        };
    }
}
async function removePushSubscription(userId, subId, fcmToken, userRole = 'trainer') {
    if (!userId) return false;
    try {
        const userCollection = userRole === 'trainer' ? 'trainer_app_users' : 'flutter_user';
        const subDocRef = (0, _firestore.doc)((0, _firebase.db), userCollection, userId, 'push_subscriptions', subId);
        await (0, _firestore.deleteDoc)(subDocRef).catch(()=>{});
        if (fcmToken) {
            const userDocRef = (0, _firestore.doc)((0, _firebase.db), userCollection, userId);
            await (0, _firestore.updateDoc)(userDocRef, {
                fcm_tokens: (0, _firestore.arrayRemove)(fcmToken)
            }).catch(()=>{});
        }
        // If removing the subscription of this current browser session, unregister locally too
        if (typeof window !== 'undefined') {
            const currentSubId = localStorage.getItem('minipt_current_fcm_sub_id');
            const currentToken = localStorage.getItem('minipt_current_fcm_token');
            if (currentSubId === subId || fcmToken && currentToken === fcmToken) {
                localStorage.removeItem('minipt_current_fcm_sub_id');
                localStorage.removeItem('minipt_current_fcm_token');
                try {
                    const messaging = await getMessagingSafely();
                    if (messaging) await deleteFcmToken(messaging);
                } catch (e) {
                    console.warn('Error deleting local FCM token:', e);
                }
            }
        }
        return true;
    } catch (error) {
        console.error('Failed to remove push subscription:', error);
        return false;
    }
}
async function unsubscribeBrowserPush(userId, userRole = 'trainer') {
    try {
        if (typeof window !== 'undefined') {
            localStorage.removeItem('minipt_current_fcm_sub_id');
            localStorage.removeItem('minipt_current_fcm_token');
        }
        if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return false;
        const messaging = await getMessagingSafely();
        if (!messaging) return false;
        const swUrl = `${window.location.origin}/firebase-messaging-sw.js`;
        const registration = await navigator.serviceWorker.getRegistration(swUrl);
        if (registration) try {
            const token = await getFcmToken(messaging, {
                serviceWorkerRegistration: registration
            });
            if (token) {
                await deleteFcmToken(messaging);
                const subId = getSubscriptionId(token);
                const userCollection = userRole === 'trainer' ? 'trainer_app_users' : 'flutter_user';
                // Clean up Firestore
                const userDocRef = (0, _firestore.doc)((0, _firebase.db), userCollection, userId);
                await (0, _firestore.updateDoc)(userDocRef, {
                    FCMToken: '',
                    fcm_tokens: (0, _firestore.arrayRemove)(token)
                }).catch(()=>{});
                const subDocRef = (0, _firestore.doc)((0, _firebase.db), userCollection, userId, 'push_subscriptions', subId);
                await (0, _firestore.deleteDoc)(subDocRef).catch(()=>{});
            }
        } catch (e) {
            console.warn('Error deleting FCM token:', e);
        }
        return true;
    } catch (error) {
        console.error('Failed to unsubscribe push notifications:', error);
        return false;
    }
}
async function getUserPushSubscriptions(userId, userRole = 'trainer') {
    if (!userId || userId.includes('@')) return [];
    if (!(0, _firebase.auth).currentUser || (0, _firebase.auth).currentUser.uid !== userId) return [];
    try {
        const userCollection = userRole === 'trainer' ? 'trainer_app_users' : 'flutter_user';
        const subsRef = (0, _firestore.collection)((0, _firebase.db), userCollection, userId, 'push_subscriptions');
        const snap = await (0, _firestore.getDocs)(subsRef);
        const items = [];
        snap.forEach((d)=>{
            const data = d.data();
            items.push({
                id: d.id,
                fcm_token: data.fcm_token || data.endpoint || '',
                ua: data.ua || 'Web Browser',
                created_at: data.created_at || '',
                last_active_at: data.last_active_at || ''
            });
        });
        return items;
    } catch (error) {
        console.warn('Unable to fetch push subscriptions:', error);
        return [];
    }
}
async function getCurrentFCMToken() {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return null;
    const stored = localStorage.getItem('minipt_current_fcm_token');
    if (stored) return stored;
    try {
        const messaging = await getMessagingSafely();
        if (!messaging) return null;
        const swUrl = `${window.location.origin}/firebase-messaging-sw.js`;
        const registration = await navigator.serviceWorker.getRegistration(swUrl);
        if (registration) {
            const token = await getFcmToken(messaging, {
                serviceWorkerRegistration: registration
            });
            if (token) {
                localStorage.setItem('minipt_current_fcm_token', token);
                localStorage.setItem('minipt_current_fcm_sub_id', getSubscriptionId(token));
                return token;
            }
        }
    } catch  {
    // Ignored
    }
    return null;
}
async function printCurrentFCMToken() {
    if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return null;
    try {
        const token = await getCurrentFCMToken();
        if (token) {
            // eslint-disable-next-line no-console
            console.log('%c[FCM Push] Current Browser FCM Token:%c\n' + token, 'background: #F59E0B; color: #000; font-weight: bold; padding: 2px 6px; border-radius: 4px;', 'color: #00E676; font-family: monospace; font-weight: bold;');
            return token;
        }
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn('[FCM Push] Could not retrieve active FCM token:', e);
    }
    return null;
}
function onForegroundFCMMessage(callback) {
    if (typeof window === 'undefined' || !('Notification' in window)) return ()=>{};
    let unsubscribe = null;
    let isCancelled = false;
    getMessagingSafely().then((messaging)=>{
        if (!messaging || isCancelled) return;
        try {
            unsubscribe = onMessage(messaging, callback);
        } catch (e) {
            console.warn('FCM foreground listener initialization failed:', e);
        }
    }).catch(()=>{});
    return ()=>{
        isCancelled = true;
        if (unsubscribe) unsubscribe();
    };
}
// Expose helper to browser console for easy testing: window.printFCMToken()
if (typeof window !== 'undefined') window.printFCMToken = printCurrentFCMToken;

},{"firebase/messaging":"3hb4x","firebase/firestore":"5IgBQ","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3hb4x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _messaging = require("@firebase/messaging");
parcelHelpers.exportAll(_messaging, exports);

},{"@firebase/messaging":"fEh8m","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fEh8m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteToken", ()=>deleteToken);
parcelHelpers.export(exports, "getMessaging", ()=>getMessagingInWindow);
parcelHelpers.export(exports, "getToken", ()=>getToken);
parcelHelpers.export(exports, "isSupported", ()=>isWindowSupported);
parcelHelpers.export(exports, "onMessage", ()=>onMessage);
parcelHelpers.export(exports, "onRegistered", ()=>onRegistered);
parcelHelpers.export(exports, "onUnregistered", ()=>onUnregistered);
parcelHelpers.export(exports, "register", ()=>register);
parcelHelpers.export(exports, "unregister", ()=>unregister);
var _installations = require("@firebase/installations");
var _component = require("@firebase/component");
var _idb = require("idb");
var _util = require("@firebase/util");
var _app = require("@firebase/app");
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DEFAULT_SW_PATH = '/firebase-messaging-sw.js';
const DEFAULT_SW_SCOPE = '/firebase-cloud-messaging-push-scope';
const DEFAULT_VAPID_KEY = 'BDOU99-h67HcA6JeFXHbSNMu7e2yNNu3RzoMj8TM4W88jITfq7ZmPvIM1Iv-4_l2LxQcYwhqby2xGpWwzjfAnG4';
const ENDPOINT = 'https://fcmregistrations.googleapis.com/v1';
const CONSOLE_CAMPAIGN_ID = 'google.c.a.c_id';
const CONSOLE_CAMPAIGN_NAME = 'google.c.a.c_l';
const CONSOLE_CAMPAIGN_TIME = 'google.c.a.ts';
/** Set to '1' if Analytics is enabled for the campaign */ const CONSOLE_CAMPAIGN_ANALYTICS_ENABLED = 'google.c.a.e';
const DEFAULT_REGISTRATION_TIMEOUT = 10000;
var MessageType$1;
(function(MessageType) {
    MessageType[MessageType["DATA_MESSAGE"] = 1] = "DATA_MESSAGE";
    MessageType[MessageType["DISPLAY_NOTIFICATION"] = 3] = "DISPLAY_NOTIFICATION";
})(MessageType$1 || (MessageType$1 = {}));
/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License"); you may not use this file except
 * in compliance with the License. You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under the License
 * is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express
 * or implied. See the License for the specific language governing permissions and limitations under
 * the License.
 */ var MessageType;
(function(MessageType) {
    MessageType["PUSH_RECEIVED"] = "push-received";
    MessageType["NOTIFICATION_CLICKED"] = "notification-clicked";
    MessageType["FID_REGISTERED"] = "fid-registered";
})(MessageType || (MessageType = {}));
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function arrayToBase64(array) {
    const uint8Array = new Uint8Array(array);
    const base64String = btoa(String.fromCharCode(...uint8Array));
    return base64String.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
}
function base64ToArray(base64String) {
    const padding = '='.repeat((4 - base64String.length % 4) % 4);
    const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
    const rawData = atob(base64);
    const outputArray = new Uint8Array(rawData.length);
    for(let i = 0; i < rawData.length; ++i)outputArray[i] = rawData.charCodeAt(i);
    return outputArray;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const OLD_DB_NAME = 'fcm_token_details_db';
/**
 * The last DB version of 'fcm_token_details_db' was 4. This is one higher, so that the upgrade
 * callback is called for all versions of the old DB.
 */ const OLD_DB_VERSION = 5;
const OLD_OBJECT_STORE_NAME = 'fcm_token_object_Store';
async function migrateOldDatabase(senderId) {
    if ('databases' in indexedDB) {
        // indexedDb.databases() is an IndexedDB v3 API and does not exist in all browsers. TODO: Remove
        // typecast when it lands in TS types.
        const databases = await indexedDB.databases();
        const dbNames = databases.map((db)=>db.name);
        if (!dbNames.includes(OLD_DB_NAME)) // old DB didn't exist, no need to open.
        return null;
    }
    let tokenDetails = null;
    const db = await (0, _idb.openDB)(OLD_DB_NAME, OLD_DB_VERSION, {
        upgrade: async (db, oldVersion, newVersion, upgradeTransaction)=>{
            if (oldVersion < 2) // Database too old, skip migration.
            return;
            if (!db.objectStoreNames.contains(OLD_OBJECT_STORE_NAME)) // Database did not exist. Nothing to do.
            return;
            const objectStore = upgradeTransaction.objectStore(OLD_OBJECT_STORE_NAME);
            const value = await objectStore.index('fcmSenderId').get(senderId);
            await objectStore.clear();
            if (!value) // No entry in the database, nothing to migrate.
            return;
            if (oldVersion === 2) {
                const oldDetails = value;
                if (!oldDetails.auth || !oldDetails.p256dh || !oldDetails.endpoint) return;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime ?? Date.now(),
                    subscriptionOptions: {
                        auth: oldDetails.auth,
                        p256dh: oldDetails.p256dh,
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: typeof oldDetails.vapidKey === 'string' ? oldDetails.vapidKey : arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 3) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: arrayToBase64(oldDetails.auth),
                        p256dh: arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: arrayToBase64(oldDetails.vapidKey)
                    }
                };
            } else if (oldVersion === 4) {
                const oldDetails = value;
                tokenDetails = {
                    token: oldDetails.fcmToken,
                    createTime: oldDetails.createTime,
                    subscriptionOptions: {
                        auth: arrayToBase64(oldDetails.auth),
                        p256dh: arrayToBase64(oldDetails.p256dh),
                        endpoint: oldDetails.endpoint,
                        swScope: oldDetails.swScope,
                        vapidKey: arrayToBase64(oldDetails.vapidKey)
                    }
                };
            }
        }
    });
    db.close();
    // Delete all old databases.
    await (0, _idb.deleteDB)(OLD_DB_NAME);
    await (0, _idb.deleteDB)('fcm_vapid_details_db');
    await (0, _idb.deleteDB)('undefined');
    return checkTokenDetails(tokenDetails) ? tokenDetails : null;
}
function checkTokenDetails(tokenDetails) {
    if (!tokenDetails || !tokenDetails.subscriptionOptions) return false;
    const { subscriptionOptions } = tokenDetails;
    return typeof tokenDetails.createTime === 'number' && tokenDetails.createTime > 0 && typeof tokenDetails.token === 'string' && tokenDetails.token.length > 0 && typeof subscriptionOptions.auth === 'string' && subscriptionOptions.auth.length > 0 && typeof subscriptionOptions.p256dh === 'string' && subscriptionOptions.p256dh.length > 0 && typeof subscriptionOptions.endpoint === 'string' && subscriptionOptions.endpoint.length > 0 && typeof subscriptionOptions.swScope === 'string' && subscriptionOptions.swScope.length > 0 && typeof subscriptionOptions.vapidKey === 'string' && subscriptionOptions.vapidKey.length > 0;
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ERROR_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ ]: 'This method is available in a Window context.',
    ["only-available-in-sw" /* ErrorCode.AVAILABLE_IN_SW */ ]: 'This method is available in a service worker context.',
    ["permission-default" /* ErrorCode.PERMISSION_DEFAULT */ ]: 'The notification permission was not granted and dismissed instead.',
    ["permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ ]: 'The notification permission was not granted and blocked instead.',
    ["unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ ]: "This browser doesn't support the API's required to use the Firebase SDK.",
    ["indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ ]: "This browser doesn't support indexedDb.open() (ex. Safari iFrame, Firefox Private Browsing, etc)",
    ["failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ ]: 'We are unable to register the default service worker. {$browserErrorMessage}',
    ["token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ ]: 'A problem occurred while subscribing the user to FCM: {$errorInfo}',
    ["token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ ]: 'FCM returned no token when subscribing the user to push.',
    ["fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ ]: 'A problem occurred while creating an FCM registration via FID: {$errorInfo}',
    ["fid-unregister-failed" /* ErrorCode.FID_UNREGISTER_FAILED */ ]: 'A problem occurred while unregistering the FCM registration via FID: {$errorInfo}',
    ["fid-registration-idb-schema-unavailable" /* ErrorCode.FID_REGISTRATION_IDB_SCHEMA_UNAVAILABLE */ ]: "Unable to read or persist FID registration metadata because the messaging IndexedDB schema is unavailable (for example, the database could not be upgraded to the latest version).",
    ["token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ ]: "A problem occurred while unsubscribing the user from FCM: {$errorInfo}",
    ["token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ ]: 'A problem occurred while updating the user from FCM: {$errorInfo}',
    ["token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ ]: 'FCM returned no token when updating the user to push.',
    ["use-sw-after-get-token" /* ErrorCode.USE_SW_AFTER_GET_TOKEN */ ]: "The useServiceWorker() method may only be called once and must be called before calling getToken() to ensure your service worker is used.",
    ["invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ ]: 'The input to useServiceWorker() must be a ServiceWorkerRegistration.',
    ["invalid-bg-handler" /* ErrorCode.INVALID_BG_HANDLER */ ]: 'The input to setBackgroundMessageHandler() must be a function.',
    ["invalid-vapid-key" /* ErrorCode.INVALID_VAPID_KEY */ ]: 'The public VAPID key must be a string.',
    ["use-vapid-key-after-get-token" /* ErrorCode.USE_VAPID_KEY_AFTER_GET_TOKEN */ ]: "The usePublicVapidKey() method may only be called once and must be called before calling getToken() to ensure your VAPID key is used.",
    ["invalid-on-registered-handler" /* ErrorCode.INVALID_ON_REGISTERED_HANDLER */ ]: 'No onRegistered callback handler was provided or registered. Implement onRegistered() before register().'
};
const ERROR_FACTORY = new (0, _util.ErrorFactory)('messaging', 'Messaging', ERROR_MAP);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DATABASE_NAME = 'firebase-messaging-database';
const DATABASE_VERSION = 2;
const TOKEN_OBJECT_STORE_NAME = 'firebase-messaging-store';
const FID_REGISTRATION_OBJECT_STORE_NAME = 'firebase-messaging-fid-registration-store';
const defaultIdb = {
    openDB: (0, _idb.openDB),
    deleteDB: (0, _idb.deleteDB)
};
let idbImpl = defaultIdb;
// Open v2, but fall back to v1 if upgrade/open fails. Cache as `unknown` and guard store access.
let dbPromise = null;
function migrateMessagingDb(upgradeDb, oldVersion, targetSchemaVersion) {
    // Intentional fall-through for v2: run all intermediate migrations.
    // eslint-disable-next-line default-case
    switch(oldVersion){
        case 0:
            upgradeDb.createObjectStore(TOKEN_OBJECT_STORE_NAME);
            if (targetSchemaVersion === 1) break;
        // fall through
        case 1:
            if (targetSchemaVersion === 2) upgradeDb.createObjectStore(FID_REGISTRATION_OBJECT_STORE_NAME);
    }
}
function createOpenDbOptions(targetSchemaVersion) {
    return {
        upgrade: (upgradeDb, oldVersion)=>{
            migrateMessagingDb(upgradeDb, oldVersion, targetSchemaVersion);
        },
        blocked: ()=>{
        /* no-op */ },
        blocking: (_currentVersion, _blockedVersion, event)=>{
            dbPromise = null;
            event.target?.close();
        },
        terminated: ()=>{
            dbPromise = null;
        }
    };
}
function getDbPromise() {
    if (!dbPromise) {
        const openLatest = idbImpl.openDB(DATABASE_NAME, DATABASE_VERSION, createOpenDbOptions(2));
        // Assign synchronously to avoid concurrent openDB() calls.
        dbPromise = openLatest.catch(()=>idbImpl.openDB(DATABASE_NAME, DATABASE_VERSION - 1, createOpenDbOptions(1)));
    }
    return dbPromise;
}
function hasObjectStore(db, storeName) {
    return db.objectStoreNames.contains(storeName);
}
function assertFidRegistrationObjectStore(db) {
    if (!hasObjectStore(db, FID_REGISTRATION_OBJECT_STORE_NAME)) throw ERROR_FACTORY.create("fid-registration-idb-schema-unavailable" /* ErrorCode.FID_REGISTRATION_IDB_SCHEMA_UNAVAILABLE */ );
}
async function dbGet(firebaseDependencies) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    const tokenDetails = await db.transaction(TOKEN_OBJECT_STORE_NAME).objectStore(TOKEN_OBJECT_STORE_NAME).get(key);
    if (tokenDetails) return tokenDetails;
    else {
        const oldTokenDetails = await migrateOldDatabase(firebaseDependencies.appConfig.senderId);
        if (oldTokenDetails) {
            await dbSet(firebaseDependencies, oldTokenDetails);
            return oldTokenDetails;
        }
    }
}
async function dbSet(firebaseDependencies, tokenDetails) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    const stores = [
        TOKEN_OBJECT_STORE_NAME
    ];
    const hasFidStore = hasObjectStore(db, FID_REGISTRATION_OBJECT_STORE_NAME);
    if (hasFidStore) stores.push(FID_REGISTRATION_OBJECT_STORE_NAME);
    const tx = db.transaction(stores, 'readwrite');
    await tx.objectStore(TOKEN_OBJECT_STORE_NAME).put(tokenDetails, key);
    if (hasFidStore) await tx.objectStore(FID_REGISTRATION_OBJECT_STORE_NAME).delete(key);
    await tx.done;
    return tokenDetails;
}
async function dbRemove(firebaseDependencies) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    const tx = db.transaction(TOKEN_OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore(TOKEN_OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
async function dbGetFidRegistration(firebaseDependencies) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    assertFidRegistrationObjectStore(db);
    return await db.transaction(FID_REGISTRATION_OBJECT_STORE_NAME).objectStore(FID_REGISTRATION_OBJECT_STORE_NAME).get(key);
}
async function dbSetFidRegistration(firebaseDependencies, details) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    assertFidRegistrationObjectStore(db);
    const tx = db.transaction([
        TOKEN_OBJECT_STORE_NAME,
        FID_REGISTRATION_OBJECT_STORE_NAME
    ], 'readwrite');
    await tx.objectStore(FID_REGISTRATION_OBJECT_STORE_NAME).put(details, key);
    await tx.objectStore(TOKEN_OBJECT_STORE_NAME).delete(key);
    await tx.done;
    return details;
}
async function dbRemoveFidRegistration(firebaseDependencies) {
    const key = getKey(firebaseDependencies);
    const db = await getDbPromise();
    assertFidRegistrationObjectStore(db);
    const tx = db.transaction(FID_REGISTRATION_OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore(FID_REGISTRATION_OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
function getKey({ appConfig }) {
    return appConfig.appId;
}
const name = "@firebase/messaging";
const version = "0.13.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Max attempts (initial fetch + retries) when CreateRegistration `fetch()` throws. */ const FID_REGISTRATION_FETCH_MAX_ATTEMPTS = 3;
/** Base delay in ms; backoff is `BASE * 2^attempt` after each failed attempt. */ const FID_REGISTRATION_FETCH_BASE_BACKOFF_MS = 1000;
async function requestGetToken(firebaseDependencies, subscriptionOptions) {
    const headers = await getHeaders(firebaseDependencies);
    const body = getBody(subscriptionOptions, firebaseDependencies.appConfig.appName, /* includeSdkVersion= */ false);
    const subscribeOptions = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch(getEndpoint(firebaseDependencies.appConfig), subscribeOptions);
        responseData = await response.json();
    } catch (err) {
        throw ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: err?.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw ERROR_FACTORY.create("token-subscribe-failed" /* ErrorCode.TOKEN_SUBSCRIBE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw ERROR_FACTORY.create("token-subscribe-no-token" /* ErrorCode.TOKEN_SUBSCRIBE_NO_TOKEN */ );
    return responseData.token;
}
async function requestCreateRegistration(firebaseDependencies, subscriptionOptions) {
    const headers = await getHeaders(firebaseDependencies);
    const body = getBody(subscriptionOptions, firebaseDependencies.appConfig.appName, /* includeSdkVersion= */ true);
    const subscribeOptions = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    let response;
    try {
        response = await fetchWithExponentialRetry(()=>fetch(getEndpoint(firebaseDependencies.appConfig), subscribeOptions), FID_REGISTRATION_FETCH_MAX_ATTEMPTS, FID_REGISTRATION_FETCH_BASE_BACKOFF_MS);
    } catch (err) {
        throw ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
            errorInfo: err?.toString()
        });
    }
    if (response.ok) {
        const responseFid = await parseCreateRegistrationSuccessFid(response);
        return {
            responseFid
        };
    }
    // `fetch()` succeeded, but the backend returned a non-2xx response.
    // Best-effort parse the body to extract `error.message`, but always fail with
    // `FID_REGISTRATION_FAILED` to keep the error surface uniform.
    // Best-effort extraction of error details; the main signal is response.ok / status.
    let responseData;
    try {
        responseData = await response.json();
    } catch (err) {
        throw ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
            errorInfo: response.statusText
        });
    }
    const message = responseData.error?.message ?? response.statusText;
    throw ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
        errorInfo: message
    });
}
/**
 * Deletes an FCM Web registration via DeleteRegistration using the Firebase Installation ID (FID).
 */ async function requestDeleteRegistration(firebaseDependencies, fid) {
    const headers = await getHeaders(firebaseDependencies);
    const options = {
        method: 'DELETE',
        headers
    };
    let response;
    try {
        response = await fetch(`${getEndpoint(firebaseDependencies.appConfig)}/${fid}`, options);
    } catch (err) {
        throw ERROR_FACTORY.create("fid-unregister-failed" /* ErrorCode.FID_UNREGISTER_FAILED */ , {
            errorInfo: err?.toString()
        });
    }
    if (response.ok) return;
    // Best-effort parse error details; surface uniform error code.
    try {
        const responseData = await response.json();
        const message = responseData.error?.message ?? response.statusText;
        throw message;
    } catch (err) {
        // If parsing failed, fall back to status text.
        throw ERROR_FACTORY.create("fid-unregister-failed" /* ErrorCode.FID_UNREGISTER_FAILED */ , {
            errorInfo: typeof err === 'string' && err || response.statusText || err?.toString()
        });
    }
}
/**
 * Parses a successful CreateRegistration body. The backend must return JSON with a non-empty
 * string `name`: a resource name `projects/{projectId}/registrations/{fid}`
 */ async function parseCreateRegistrationSuccessFid(response) {
    const text = await response.text();
    if (!text.trim()) throw ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
        errorInfo: 'CreateRegistration succeeded but response body is empty'
    });
    let data;
    try {
        data = JSON.parse(text);
    } catch  {
        throw ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
            errorInfo: 'CreateRegistration succeeded but response body is not valid JSON'
        });
    }
    const name = data.name;
    if (typeof name !== 'string' || name.length === 0) throw ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
        errorInfo: 'CreateRegistration succeeded but response did not include a non-empty name'
    });
    return parseFidFromRegistrationResourceName(name);
}
const REGISTRATIONS_NAME_SEGMENT = '/registrations/';
/** Extracts the Firebase Installation ID from CreateRegistration `name` (resource path). */ function parseFidFromRegistrationResourceName(name) {
    const segmentIndex = name.indexOf(REGISTRATIONS_NAME_SEGMENT);
    if (segmentIndex !== -1) {
        const fid = name.slice(segmentIndex + REGISTRATIONS_NAME_SEGMENT.length);
        if (fid.length > 0) return fid;
    }
    throw ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
        errorInfo: 'CreateRegistration succeeded but response name is not a valid registration resource name'
    });
}
async function requestUpdateToken(firebaseDependencies, tokenDetails) {
    const headers = await getHeaders(firebaseDependencies);
    const body = getBody(tokenDetails.subscriptionOptions, firebaseDependencies.appConfig.appName, /* includeSdkVersion= */ false);
    const updateOptions = {
        method: 'PATCH',
        headers,
        body: JSON.stringify(body)
    };
    let responseData;
    try {
        const response = await fetch(`${getEndpoint(firebaseDependencies.appConfig)}/${tokenDetails.token}`, updateOptions);
        responseData = await response.json();
    } catch (err) {
        throw ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: err?.toString()
        });
    }
    if (responseData.error) {
        const message = responseData.error.message;
        throw ERROR_FACTORY.create("token-update-failed" /* ErrorCode.TOKEN_UPDATE_FAILED */ , {
            errorInfo: message
        });
    }
    if (!responseData.token) throw ERROR_FACTORY.create("token-update-no-token" /* ErrorCode.TOKEN_UPDATE_NO_TOKEN */ );
    return responseData.token;
}
async function requestDeleteToken(firebaseDependencies, token) {
    const headers = await getHeaders(firebaseDependencies);
    const unsubscribeOptions = {
        method: 'DELETE',
        headers
    };
    try {
        const response = await fetch(`${getEndpoint(firebaseDependencies.appConfig)}/${token}`, unsubscribeOptions);
        const responseData = await response.json();
        if (responseData.error) {
            const message = responseData.error.message;
            throw ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
                errorInfo: message
            });
        }
    } catch (err) {
        throw ERROR_FACTORY.create("token-unsubscribe-failed" /* ErrorCode.TOKEN_UNSUBSCRIBE_FAILED */ , {
            errorInfo: err?.toString()
        });
    }
}
/**
 * Re-runs `operation` when it throws, with exponential backoff between attempts.
 * Rethrows the last error if all attempts fail.
 */ async function fetchWithExponentialRetry(operation, maxAttempts, baseBackoffMs) {
    let lastError;
    for(let attempt = 0; attempt < maxAttempts; attempt++)try {
        return await operation();
    } catch (err) {
        lastError = err;
        if (attempt < maxAttempts - 1) {
            const delayMs = baseBackoffMs * Math.pow(2, attempt);
            await new Promise((resolve)=>setTimeout(resolve, delayMs));
        }
    }
    throw lastError;
}
function getEndpoint({ projectId }) {
    return `${ENDPOINT}/projects/${projectId}/registrations`;
}
async function getHeaders({ appConfig, installations }) {
    const authToken = await installations.getToken();
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': appConfig.apiKey,
        'x-goog-firebase-installations-auth': `FIS ${authToken}`
    });
}
/**
 * Hostname for the registering web client (e.g. `www.example.com`), or the app name
 * (`appNameFallback`) when the scope cannot be resolved (e.g. some test environments).
 */ function getRegistrationOrigin(swScope, appNameFallback) {
    try {
        if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(swScope)) return new URL(swScope).host;
    } catch  {
    // Fall through to relative-scope handling.
    }
    try {
        if (typeof self !== 'undefined' && self.location?.href) return new URL(swScope, self.location.origin).host;
    } catch  {
    // Fall through.
    }
    if (typeof self !== 'undefined' && self.location?.host) return self.location.host;
    return appNameFallback;
}
function getBody({ p256dh, auth, endpoint, vapidKey, swScope }, appNameFallback, includeSdkVersion) {
    const body = {
        web: {
            origin: getRegistrationOrigin(swScope, appNameFallback),
            endpoint,
            auth,
            p256dh
        }
    };
    if (includeSdkVersion) // eslint-disable-next-line camelcase
    body.fcm_sdk_version = version;
    if (vapidKey !== DEFAULT_VAPID_KEY) body.web.applicationPubKey = vapidKey;
    return body;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ // UpdateRegistration will be called once every week.
const TOKEN_EXPIRATION_MS = 604800000; // 7 days
async function getTokenInternal(messaging) {
    const pushSubscription = await getPushSubscription$1(messaging.swRegistration, messaging.vapidKey);
    const subscriptionOptions = {
        vapidKey: messaging.vapidKey,
        swScope: messaging.swRegistration.scope,
        endpoint: pushSubscription.endpoint,
        auth: arrayToBase64(pushSubscription.getKey('auth')),
        p256dh: arrayToBase64(pushSubscription.getKey('p256dh'))
    };
    const tokenDetails = await dbGet(messaging.firebaseDependencies);
    if (!tokenDetails) // No token, get a new one.
    return getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    else if (!isTokenValid(tokenDetails.subscriptionOptions, subscriptionOptions)) {
        // Invalid token, get a new one.
        try {
            await requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
        } catch (e) {
            // Suppress errors because of #2364
            console.warn(e);
        }
        return getNewToken(messaging.firebaseDependencies, subscriptionOptions);
    } else if (Date.now() >= tokenDetails.createTime + TOKEN_EXPIRATION_MS) // Weekly token refresh
    return updateToken(messaging, {
        token: tokenDetails.token,
        createTime: Date.now(),
        subscriptionOptions
    });
    else // Valid token, nothing to do.
    return tokenDetails.token;
}
/**
 * Legacy getToken() path: there is a token row in IndexedDB. Revoke it with FCM, drop the row, and
 * clear any leftover FID registration metadata (apps may mix APIs).
 */ async function revokeLegacyFcmTokenAndClearCaches(messaging, tokenDetails) {
    await requestDeleteToken(messaging.firebaseDependencies, tokenDetails.token);
    await dbRemove(messaging.firebaseDependencies);
    await removeFidRegistrationBestEffort(messaging.firebaseDependencies);
}
/**
 * No legacy token row: the client may only have FID-based registration (register() flow). If so,
 * delete that registration on the server, always scrub local FID metadata, then surface
 * onUnregistered when we actually had an FID.
 */ async function revokeFidRegistrationIfStored(messaging) {
    const stored = await dbGetFidRegistration(messaging.firebaseDependencies).catch(()=>undefined);
    const fid = stored?.fid;
    if (fid) await requestDeleteRegistration(messaging.firebaseDependencies, fid);
    await removeFidRegistrationBestEffort(messaging.firebaseDependencies);
    if (fid) notifyOnUnregistered(messaging, fid);
}
/**
 * Revokes the app's FCM registration: legacy token (getToken/deleteToken) and/or FID-based
 * registration (register/unregister), clears local caches, notifies onUnregistered when a stored
 * FID existed, then unsubscribes the push subscription when present.
 */ async function revokeRegistrationInternal(messaging) {
    const tokenDetails = await dbGet(messaging.firebaseDependencies);
    if (tokenDetails) await revokeLegacyFcmTokenAndClearCaches(messaging, tokenDetails);
    else await revokeFidRegistrationIfStored(messaging);
    // Unsubscribe from the push subscription.
    const pushSubscription = await messaging.swRegistration.pushManager.getSubscription();
    if (pushSubscription) return pushSubscription.unsubscribe();
    // If there's no SW, consider it a success.
    return true;
}
async function updateToken(messaging, tokenDetails) {
    try {
        const updatedToken = await requestUpdateToken(messaging.firebaseDependencies, tokenDetails);
        const updatedTokenDetails = {
            ...tokenDetails,
            token: updatedToken,
            createTime: Date.now()
        };
        await dbSet(messaging.firebaseDependencies, updatedTokenDetails);
        return updatedToken;
    } catch (e) {
        throw e;
    }
}
async function getNewToken(firebaseDependencies, subscriptionOptions) {
    const token = await requestGetToken(firebaseDependencies, subscriptionOptions);
    const tokenDetails = {
        token,
        createTime: Date.now(),
        subscriptionOptions
    };
    await dbSet(firebaseDependencies, tokenDetails);
    return tokenDetails.token;
}
/**
 * Gets a PushSubscription for the current user.
 */ async function getPushSubscription$1(swRegistration, vapidKey) {
    const subscription = await swRegistration.pushManager.getSubscription();
    if (subscription) return subscription;
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        // Chrome <= 75 doesn't support base64-encoded VAPID key. For backward compatibility, VAPID key
        // submitted to pushManager#subscribe must be of type Uint8Array.
        applicationServerKey: base64ToArray(vapidKey)
    });
}
/**
 * Checks if the saved tokenDetails object matches the configuration provided.
 */ function isTokenValid(dbOptions, currentOptions) {
    const isVapidKeyEqual = currentOptions.vapidKey === dbOptions.vapidKey;
    const isEndpointEqual = currentOptions.endpoint === dbOptions.endpoint;
    const isAuthEqual = currentOptions.auth === dbOptions.auth;
    const isP256dhEqual = currentOptions.p256dh === dbOptions.p256dh;
    return isVapidKeyEqual && isEndpointEqual && isAuthEqual && isP256dhEqual;
}
/** Clears FID registration metadata; apps may mix legacy getToken() with FID register/unregister. */ async function removeFidRegistrationBestEffort(firebaseDependencies) {
    try {
        await dbRemoveFidRegistration(firebaseDependencies);
    } catch  {
    // Ignore.
    }
}
function notifyOnRegistered(messaging, fid) {
    const handler = messaging.onRegisteredHandler;
    if (!handler) return;
    if (typeof handler === 'function') handler(fid);
    else handler.next(fid);
}
function notifyOnUnregistered(messaging, fid) {
    const handler = messaging.onUnregisteredHandler;
    if (!handler) return;
    if (typeof handler === 'function') handler(fid);
    else handler.next(fid);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function registerDefaultSw(messaging) {
    try {
        messaging.swRegistration = await navigator.serviceWorker.register(DEFAULT_SW_PATH, {
            scope: DEFAULT_SW_SCOPE
        });
        // The timing when browser updates sw when sw has an update is unreliable from experiment. It
        // leads to version conflict when the SDK upgrades to a newer version in the main page, but sw
        // is stuck with the old version. For example,
        // https://github.com/firebase/firebase-js-sdk/issues/2590 The following line reliably updates
        // sw if there was an update.
        messaging.swRegistration.update().catch(()=>{
        /* it is non blocking and we don't care if it failed */ });
        await waitForRegistrationActive(messaging.swRegistration);
    } catch (e) {
        throw ERROR_FACTORY.create("failed-service-worker-registration" /* ErrorCode.FAILED_DEFAULT_REGISTRATION */ , {
            browserErrorMessage: e?.message
        });
    }
}
/**
 * Waits for registration to become active. MDN documentation claims that
 * a service worker registration should be ready to use after awaiting
 * navigator.serviceWorker.register() but that doesn't seem to be the case in
 * practice, causing the SDK to throw errors when calling
 * swRegistration.pushManager.subscribe() too soon after register(). The only
 * solution seems to be waiting for the service worker registration `state`
 * to become "active".
 */ async function waitForRegistrationActive(registration) {
    return new Promise((resolve, reject)=>{
        const rejectTimeout = setTimeout(()=>reject(new Error(`Service worker not registered after ${DEFAULT_REGISTRATION_TIMEOUT} ms`)), DEFAULT_REGISTRATION_TIMEOUT);
        const incomingSw = registration.installing || registration.waiting;
        if (registration.active) {
            clearTimeout(rejectTimeout);
            resolve();
        } else if (incomingSw) incomingSw.onstatechange = (ev)=>{
            if (ev.target?.state === 'activated') {
                incomingSw.onstatechange = null;
                clearTimeout(rejectTimeout);
                resolve();
            }
        };
        else {
            clearTimeout(rejectTimeout);
            reject(new Error('No incoming service worker found.'));
        }
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function updateSwReg(messaging, swRegistration) {
    if (!swRegistration && !messaging.swRegistration) await registerDefaultSw(messaging);
    if (!swRegistration && !!messaging.swRegistration) return;
    if (!(swRegistration instanceof ServiceWorkerRegistration)) throw ERROR_FACTORY.create("invalid-sw-registration" /* ErrorCode.INVALID_SW_REGISTRATION */ );
    messaging.swRegistration = swRegistration;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function updateVapidKey(messaging, vapidKey) {
    if (!!vapidKey) messaging.vapidKey = vapidKey;
    else if (!messaging.vapidKey) messaging.vapidKey = DEFAULT_VAPID_KEY;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Retries when CreateRegistration echoes an FID that does not match Installations.getId(). */ const FID_REGISTRATION_FID_MATCH_MAX_ATTEMPTS = 3;
/**
 * For the new FID-based register path:
 * - Create (or refresh) an FCM Web registration in the backend via CreateRegistration.
 * - Use the FIS auth token produced by the installations instance (implicitly associated with FID).
 * - CreateRegistration must echo the installation in `name` (e.g.
 *   `projects/{projectId}/registrations/{fid}`); it must match `expectedFid` from
 *   Installations.getId(). On mismatch we refresh the auth token and retry, then fail with
 *   `fid-registration-failed`.
 */ async function registerFcmRegistrationWithFid(messaging, expectedFid) {
    const pushSubscription = await getPushSubscription(messaging.swRegistration, messaging.vapidKey);
    const subscriptionOptions = {
        vapidKey: messaging.vapidKey,
        swScope: messaging.swRegistration.scope,
        endpoint: pushSubscription.endpoint,
        auth: arrayToBase64(pushSubscription.getKey('auth')),
        p256dh: arrayToBase64(pushSubscription.getKey('p256dh'))
    };
    const installations = messaging.firebaseDependencies.installations;
    for(let attempt = 0; attempt < FID_REGISTRATION_FID_MATCH_MAX_ATTEMPTS; attempt++){
        const { responseFid } = await requestCreateRegistration(messaging.firebaseDependencies, subscriptionOptions);
        if (responseFid === expectedFid) return;
        // If CreateRegistration echoes an unexpected FID, the FIS auth token used for the request may
        // be stale relative to the installation the backend associates with the call. Force-refresh
        // the token before retrying so the next attempt uses credentials aligned with Installations.
        if (attempt < FID_REGISTRATION_FID_MATCH_MAX_ATTEMPTS - 1) await installations.getToken(true);
    }
    throw ERROR_FACTORY.create("fid-registration-failed" /* ErrorCode.FID_REGISTRATION_FAILED */ , {
        errorInfo: 'CreateRegistration response FID does not match Firebase Installation ID'
    });
}
async function getPushSubscription(swRegistration, vapidKey) {
    const subscription = await swRegistration.pushManager.getSubscription();
    if (subscription) return subscription;
    // Chrome/Firefox require applicationServerKey to be of type Uint8Array.
    return swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        // `PushManager.subscribe` expects a `BufferSource`; `base64ToArray` produces a typed array.
        // Cast to satisfy the lib typing differences across TS DOM versions.
        applicationServerKey: base64ToArray(vapidKey)
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const FID_REGISTRATION_REFRESH_MS = 604800000; // 7 days
/**
 * Registers the app instance with FCM using its Firebase Installation ID (FID). The FID is
 * delivered via the `onRegistered` callback. Call this to establish an FID-based identity.
 * Once `onRegistered` provides an FID, instruct your backend to remove any legacy token
 * previously associated with this instance. The backend send API supports FID as a target.
 *
 * When called multiple times, `onRegistered` is invoked on each call with the current FID.
 * Backend registration sync runs on first register, when the FID changes, or on weekly refresh.
 *
 * @param messaging - The MessagingService instance.
 * @param options - Optional. Same options as getToken (vapidKey, serviceWorkerRegistration).
 */ async function register$1(messaging, options) {
    if (!navigator) throw ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (Notification.permission === 'default') await Notification.requestPermission();
    if (Notification.permission !== 'granted') throw ERROR_FACTORY.create("permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ );
    if (!messaging.onRegisteredHandler) throw ERROR_FACTORY.create("invalid-on-registered-handler" /* ErrorCode.INVALID_ON_REGISTERED_HANDLER */ );
    await updateVapidKey(messaging, options?.vapidKey);
    await updateSwReg(messaging, options?.serviceWorkerRegistration);
    // Keep the queue alive after a failed register() so future calls can retry.
    const prev = messaging._registerNotifyChain.catch(()=>{});
    messaging._registerNotifyChain = prev.then(async ()=>{
        const fid = await messaging.firebaseDependencies.installations.getId();
        const stored = await dbGetFidRegistration(messaging.firebaseDependencies);
        const now = Date.now();
        const shouldRefresh = !stored || stored.fid !== fid || now >= stored.lastRegisterTime + FID_REGISTRATION_REFRESH_MS;
        if (shouldRefresh) {
            await registerFcmRegistrationWithFid(messaging, fid);
            await dbSetFidRegistration(messaging.firebaseDependencies, {
                fid,
                lastRegisterTime: now,
                vapidKey: messaging.vapidKey
            });
        }
        const handler = messaging.onRegisteredHandler;
        if (!handler) throw ERROR_FACTORY.create("invalid-on-registered-handler" /* ErrorCode.INVALID_ON_REGISTERED_HANDLER */ );
        notifyOnRegistered(messaging, fid);
    });
    return messaging._registerNotifyChain;
}
/**
 * @license
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * When the Firebase Installation ID changes, re-run `register()` so FCM registration and
 * onRegistered run for the new FID. No-op if no onRegistered handler is set or the app
 * instance was never registered with FCM.
 */ function subscribeFidChangeRegistration(messaging, installations) {
    return (0, _installations.onIdChange)(installations, ()=>{
        (async ()=>{
            if (!messaging.onRegisteredHandler) return;
            const stored = await dbGetFidRegistration(messaging.firebaseDependencies);
            if (!stored) return;
            await register$1(messaging).catch(()=>{
            // Best-effort: permission may be revoked or SW unavailable after FID rotation.
            });
        })();
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function externalizePayload(internalPayload) {
    const payload = {
        from: internalPayload.from,
        // eslint-disable-next-line camelcase
        collapseKey: internalPayload.collapse_key,
        // eslint-disable-next-line camelcase
        messageId: internalPayload.fcmMessageId
    };
    propagateNotificationPayload(payload, internalPayload);
    propagateDataPayload(payload, internalPayload);
    propagateFcmOptions(payload, internalPayload);
    return payload;
}
function propagateNotificationPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.notification) return;
    payload.notification = {};
    const title = messagePayloadInternal.notification.title;
    if (!!title) payload.notification.title = title;
    const body = messagePayloadInternal.notification.body;
    if (!!body) payload.notification.body = body;
    const image = messagePayloadInternal.notification.image;
    if (!!image) payload.notification.image = image;
    const icon = messagePayloadInternal.notification.icon;
    if (!!icon) payload.notification.icon = icon;
}
function propagateDataPayload(payload, messagePayloadInternal) {
    if (!messagePayloadInternal.data) return;
    payload.data = messagePayloadInternal.data;
}
function propagateFcmOptions(payload, messagePayloadInternal) {
    // fcmOptions.link value is written into notification.click_action. see more in b/232072111
    if (!messagePayloadInternal.fcmOptions && !messagePayloadInternal.notification?.click_action) return;
    payload.fcmOptions = {};
    const link = messagePayloadInternal.fcmOptions?.link ?? messagePayloadInternal.notification?.click_action;
    if (!!link) payload.fcmOptions.link = link;
    // eslint-disable-next-line camelcase
    const analyticsLabel = messagePayloadInternal.fcmOptions?.analytics_label;
    if (!!analyticsLabel) payload.fcmOptions.analyticsLabel = analyticsLabel;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function isConsoleMessage(data) {
    // This message has a campaign ID, meaning it was sent using the Firebase Console.
    return typeof data === 'object' && !!data && CONSOLE_CAMPAIGN_ID in data;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ _mergeStrings('AzSCbw63g1R0nCw85jG8', 'Iaya3yLKwmgvh7cF0q4');
function _mergeStrings(s1, s2) {
    const resultArray = [];
    for(let i = 0; i < s1.length; i++){
        resultArray.push(s1.charAt(i));
        if (i < s2.length) resultArray.push(s2.charAt(i));
    }
    return resultArray.join('');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function extractAppConfig(app) {
    if (!app || !app.options) throw getMissingValueError('App Configuration Object');
    if (!app.name) throw getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId',
        'messagingSenderId'
    ];
    const { options } = app;
    for (const keyName of configKeys){
        if (!options[keyName]) throw getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: options.projectId,
        apiKey: options.apiKey,
        appId: options.appId,
        senderId: options.messagingSenderId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ class MessagingService {
    constructor(app, installations, analyticsProvider){
        // logging is only done with end user consent. Default to false.
        this.deliveryMetricsExportedToBigQueryEnabled = false;
        this.onBackgroundMessageHandler = null;
        this.onMessageHandler = null;
        /** Observer for the event that the app instance is registered with FCM via Firebase Installation ID (FID). */ this.onRegisteredHandler = null;
        /** Observer for the event that the app instance is unregistered from FCM (FID no longer active). */ this.onUnregisteredHandler = null;
        /**
         * Serializes the FID get + compare + notify step so concurrent register() calls
         * do not race each other.
         */ this._registerNotifyChain = Promise.resolve();
        /** Unsubscribe from Installations `onIdChange` when messaging is deleted. */ this._fidChangeUnsubscribe = null;
        this.logEvents = [];
        /**
         * Single source of truth for the logging loop lifecycle.
         *
         * `scheduled` holds the active timer id; `flushing` indicates an async dispatch
         * is in progress (prevents duplicate starts); `stopped` means idle.
         */ this.logQueue = {
            state: 'stopped'
        };
        const appConfig = extractAppConfig(app);
        this.firebaseDependencies = {
            app,
            appConfig,
            installations,
            analyticsProvider
        };
    }
    _delete() {
        if (this._fidChangeUnsubscribe) {
            this._fidChangeUnsubscribe();
            this._fidChangeUnsubscribe = null;
        }
        if (this.logQueue.state === 'scheduled') clearTimeout(this.logQueue.timerId);
        this.logQueue = {
            state: 'stopped'
        };
        return Promise.resolve();
    }
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function getToken$1(messaging, options) {
    if (!navigator) throw ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (Notification.permission === 'default') await Notification.requestPermission();
    if (Notification.permission !== 'granted') throw ERROR_FACTORY.create("permission-blocked" /* ErrorCode.PERMISSION_BLOCKED */ );
    await updateVapidKey(messaging, options?.vapidKey);
    await updateSwReg(messaging, options?.serviceWorkerRegistration);
    return getTokenInternal(messaging);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function logToScion(messaging, messageType, data) {
    const eventType = getEventType(messageType);
    const analytics = await messaging.firebaseDependencies.analyticsProvider.get();
    analytics.logEvent(eventType, {
        /* eslint-disable camelcase */ message_id: data[CONSOLE_CAMPAIGN_ID],
        message_name: data[CONSOLE_CAMPAIGN_NAME],
        message_time: data[CONSOLE_CAMPAIGN_TIME],
        message_device_time: Math.floor(Date.now() / 1000)
    });
}
function getEventType(messageType) {
    switch(messageType){
        case MessageType.NOTIFICATION_CLICKED:
            return 'notification_open';
        case MessageType.PUSH_RECEIVED:
            return 'notification_foreground';
        default:
            throw new Error();
    }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function messageEventListener(messaging, event) {
    const internalPayload = event.data;
    if (!internalPayload.isFirebaseMessaging) return;
    if (messaging.onMessageHandler && internalPayload.messageType === MessageType.PUSH_RECEIVED) {
        if (typeof messaging.onMessageHandler === 'function') messaging.onMessageHandler(externalizePayload(internalPayload));
        else messaging.onMessageHandler.next(externalizePayload(internalPayload));
    }
    if (messaging.onRegisteredHandler && internalPayload.messageType === MessageType.FID_REGISTERED) {
        const fid = internalPayload.fid;
        if (typeof messaging.onRegisteredHandler === 'function') messaging.onRegisteredHandler(fid);
        else messaging.onRegisteredHandler.next(fid);
    }
    // Log to Scion if applicable
    const dataPayload = internalPayload.data;
    if (isConsoleMessage(dataPayload) && dataPayload[CONSOLE_CAMPAIGN_ANALYTICS_ENABLED] === '1') await logToScion(messaging, internalPayload.messageType, dataPayload);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const WindowMessagingFactory = (container)=>{
    const messaging = new MessagingService(container.getProvider('app').getImmediate(), container.getProvider('installations-internal').getImmediate(), container.getProvider('analytics-internal'));
    navigator.serviceWorker.addEventListener('message', (e)=>messageEventListener(messaging, e));
    messaging._fidChangeUnsubscribe = subscribeFidChangeRegistration(messaging, container.getProvider('installations').getImmediate());
    return messaging;
};
const WindowMessagingInternalFactory = (container)=>{
    const messaging = container.getProvider('messaging').getImmediate();
    const messagingInternal = {
        getToken: (options)=>getToken$1(messaging, options),
        register: (options)=>register$1(messaging, options)
    };
    return messagingInternal;
};
function registerMessagingInWindow() {
    (0, _app._registerComponent)(new (0, _component.Component)('messaging', WindowMessagingFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, _app._registerComponent)(new (0, _component.Component)('messaging-internal', WindowMessagingInternalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
    (0, _app.registerVersion)(name, version);
    // BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
    (0, _app.registerVersion)(name, version, 'esm2020');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Checks if all required APIs exist in the browser.
 * @returns a Promise that resolves to a boolean.
 *
 * @public
 */ async function isWindowSupported() {
    try {
        // This throws if open() is unsupported, so adding it to the conditional
        // statement below can cause an uncaught error.
        await (0, _util.validateIndexedDBOpenable)();
    } catch (e) {
        return false;
    }
    // firebase-js-sdk/issues/2393 reveals that idb#open in Safari iframe and Firefox private browsing
    // might be prohibited to run. In these contexts, an error would be thrown during the messaging
    // instantiating phase, informing the developers to import/call isSupported for special handling.
    return typeof window !== 'undefined' && (0, _util.isIndexedDBAvailable)() && (0, _util.areCookiesEnabled)() && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window && 'fetch' in window && ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') && PushSubscription.prototype.hasOwnProperty('getKey');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function deleteToken$1(messaging) {
    if (!navigator) throw ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    if (!messaging.swRegistration) await registerDefaultSw(messaging);
    return revokeRegistrationInternal(messaging);
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function onMessage$1(messaging, nextOrObserver) {
    if (!navigator) throw ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    messaging.onMessageHandler = nextOrObserver;
    return ()=>{
        messaging.onMessageHandler = null;
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Subscribes to an event that the app instance is registered with FCM via Firebase Installation ID (FID).
 * Use the FID passed to the callback to upload it to your application server.
 *
 * @param messaging - The {@link MessagingService} instance.
 * @param nextOrObserver - A function or observer object called when an FID is registered.
 * @returns Unsubscribe function to stop listening.
 */ function onRegistered$1(messaging, nextOrObserver) {
    messaging.onRegisteredHandler = nextOrObserver;
    return ()=>{
        if (messaging.onRegisteredHandler === nextOrObserver) messaging.onRegisteredHandler = null;
    };
}
/**
 * @license
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Subscribes to an event that the app instance is unregistered from FCM so the FID is no longer active.
 * Use this to notify your backend to remove this FID to prevent 404 errors on send.
 *
 * @param messaging - The {@link MessagingService} instance.
 * @param nextOrObserver - A function or observer object called with the unregistered FID.
 * @returns Unsubscribe function to stop listening.
 */ function onUnregistered$1(messaging, nextOrObserver) {
    messaging.onUnregisteredHandler = nextOrObserver;
    return ()=>{
        if (messaging.onUnregisteredHandler === nextOrObserver) messaging.onUnregisteredHandler = null;
    };
}
/**
 * @license
 * Copyright 2026 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Unregisters the app instance from FCM by deleting its FID-based registration.
 *
 * On success, triggers the `onUnregistered` callback (if set) with the unregistered FID.
 *
 * @param messaging - The MessagingService instance.
 */ async function unregister$1(messaging) {
    if (!navigator) throw ERROR_FACTORY.create("only-available-in-window" /* ErrorCode.AVAILABLE_IN_WINDOW */ );
    // Prefer the last successfully registered FID from local metadata when available.
    const stored = await dbGetFidRegistration(messaging.firebaseDependencies).catch(()=>undefined);
    const fid = stored?.fid ?? await messaging.firebaseDependencies.installations.getId();
    await requestDeleteRegistration(messaging.firebaseDependencies, fid);
    // Best-effort local cleanup; still resolve even if schema is unavailable.
    try {
        await dbRemoveFidRegistration(messaging.firebaseDependencies);
    } catch  {
    // Ignore.
    }
    // Best-effort cleanup of legacy token details created via getToken().
    try {
        await dbRemove(messaging.firebaseDependencies);
    } catch  {
    // Ignore.
    }
    const handler = messaging.onUnregisteredHandler;
    if (!handler) return;
    if (typeof handler === 'function') handler(fid);
    else handler.next(fid);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Retrieves a Firebase Cloud Messaging instance.
 *
 * @returns The Firebase Cloud Messaging instance associated with the provided firebase app.
 *
 * @public
 */ function getMessagingInWindow(app = (0, _app.getApp)()) {
    // Conscious decision to make this async check non-blocking during the messaging instance
    // initialization phase for performance consideration. An error would be thrown latter for
    // developer's information. Developers can then choose to import and call `isSupported` for
    // special handling.
    isWindowSupported().then((isSupported)=>{
        // If `isWindowSupported()` resolved, but returned false.
        if (!isSupported) throw ERROR_FACTORY.create("unsupported-browser" /* ErrorCode.UNSUPPORTED_BROWSER */ );
    }, (_)=>{
        // If `isWindowSupported()` rejected.
        throw ERROR_FACTORY.create("indexed-db-unsupported" /* ErrorCode.INDEXED_DB_UNSUPPORTED */ );
    });
    return (0, _app._getProvider)((0, _util.getModularInstance)(app), 'messaging').getImmediate();
}
/**
 * Subscribes the {@link Messaging} instance to push notifications. Returns a Firebase Cloud
 * Messaging registration token that can be used to send push messages to that {@link Messaging}
 * instance.
 *
 * If notification permission isn't already granted, this method asks the user for permission. The
 * returned promise rejects if the user does not allow the app to show notifications.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param options - Provides an optional vapid key and an optional service worker registration.
 *
 * @returns The promise resolves with an FCM registration token.
 *
 * @deprecated Use {@link register} together with {@link onRegistered} for Firebase
 * Installation ID-based messaging instead of retrieving an FCM registration token with this API.
 *
 * @public
 */ async function getToken(messaging, options) {
    messaging = (0, _util.getModularInstance)(messaging);
    return getToken$1(messaging, options);
}
/**
 * Deletes the registration token associated with this {@link Messaging} instance and unsubscribes
 * the {@link Messaging} instance from the push subscription.
 *
 * If there is no legacy registration token but the client has FID-based registration metadata
 * (from {@link register}), this deletes that registration on the server, clears local metadata, and
 * invokes {@link onUnregistered} with the removed FID when successful.
 *
 * @param messaging - The {@link Messaging} instance.
 *
 * @returns The promise resolves when the token has been successfully deleted.
 *
 * @deprecated Use {@link onUnregistered} to observe when the client is no longer
 * registered and update your backend accordingly, instead of explicitly deleting the
 * registration token with this API.
 *
 * @public
 */ function deleteToken(messaging) {
    messaging = (0, _util.getModularInstance)(messaging);
    return deleteToken$1(messaging);
}
/**
 * When a push message is received and the user is currently on a page for your origin, the
 * message is passed to the page and an `onMessage()` event is dispatched with the payload of
 * the push message.
 *
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - This function, or observer object with `next` defined,
 *     is called when a message is received and the user is currently viewing your page.
 * @returns To stop listening for messages execute this returned function.
 *
 * @public
 */ function onMessage(messaging, nextOrObserver) {
    messaging = (0, _util.getModularInstance)(messaging);
    return onMessage$1(messaging, nextOrObserver);
}
/**
 * Registers the app instance with FCM using its Firebase Installation ID (FID). The FID is
 * delivered via the {@link onRegistered} callback, not as a return value. Call this to establish
 * an FID-based identity; once {@link onRegistered} provides an FID, instruct your backend to
 * remove any legacy token previously associated with this instance. The backend send API
 * supports FID as a target.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param options - Optional. VAPID key and/or service worker registration (same as getToken).
 * @returns Promise that resolves when registration has been initiated; FID is delivered via onRegistered.
 *
 * @public
 */ async function register(messaging, options) {
    messaging = (0, _util.getModularInstance)(messaging);
    return register$1(messaging, options);
}
/**
 * Unregisters the app instance from FCM by deleting its FID-based registration.
 * On success, triggers {@link onUnregistered} (if registered) with the unregistered FID.
 *
 * @param messaging - The {@link Messaging} instance.
 *
 * @public
 */ async function unregister(messaging) {
    messaging = (0, _util.getModularInstance)(messaging);
    return unregister$1(messaging);
}
/**
 * Subscribes to an event that the app instance is registered with FCM via Firebase Installation ID (FID).
 * Use the FID passed to the callback to upload it to your application server. When you receive an FID
 * after calling {@link register}, instruct your backend to remove any legacy token for this instance.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - A function or observer object called when an FID is registered.
 * @returns Unsubscribe function to stop listening.
 *
 * @public
 */ function onRegistered(messaging, nextOrObserver) {
    messaging = (0, _util.getModularInstance)(messaging);
    return onRegistered$1(messaging, nextOrObserver);
}
/**
 * Subscribes to an event that the app instance is unregistered from FCM (FID no longer active).
 * Use this to notify your backend to remove this FID to prevent 404 errors on send.
 *
 * @param messaging - The {@link Messaging} instance.
 * @param nextOrObserver - A function or observer object called with the unregistered FID.
 * @returns Unsubscribe function to stop listening.
 *
 * @public
 */ function onUnregistered(messaging, nextOrObserver) {
    messaging = (0, _util.getModularInstance)(messaging);
    return onUnregistered$1(messaging, nextOrObserver);
}
/**
 * The Firebase Cloud Messaging Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ registerMessagingInWindow();

},{"@firebase/installations":"eYtyG","@firebase/component":"6VF6E","idb":"d2rZl","@firebase/util":"fHqXn","@firebase/app":"iO7sa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eYtyG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteInstallations", ()=>deleteInstallations);
parcelHelpers.export(exports, "getId", ()=>getId);
parcelHelpers.export(exports, "getInstallations", ()=>getInstallations);
parcelHelpers.export(exports, "getToken", ()=>getToken);
parcelHelpers.export(exports, "onIdChange", ()=>onIdChange);
var _app = require("@firebase/app");
var _component = require("@firebase/component");
var _util = require("@firebase/util");
var _idb = require("idb");
const name = "@firebase/installations";
const version = "0.6.22";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const PENDING_TIMEOUT_MS = 10000;
const PACKAGE_VERSION = `w:${version}`;
const INTERNAL_AUTH_VERSION = 'FIS_v2';
const INSTALLATIONS_API_URL = 'https://firebaseinstallations.googleapis.com/v1';
const TOKEN_EXPIRATION_BUFFER = 3600000; // One hour
const SERVICE = 'installations';
const SERVICE_NAME = 'Installations';
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const ERROR_DESCRIPTION_MAP = {
    ["missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ ]: 'Missing App configuration value: "{$valueName}"',
    ["not-registered" /* ErrorCode.NOT_REGISTERED */ ]: 'Firebase Installation is not registered.',
    ["installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ ]: 'Firebase Installation not found.',
    ["request-failed" /* ErrorCode.REQUEST_FAILED */ ]: '{$requestName} request failed with error "{$serverCode} {$serverStatus}: {$serverMessage}"',
    ["app-offline" /* ErrorCode.APP_OFFLINE */ ]: 'Could not process request. Application offline.',
    ["delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ ]: "Can't delete installation while there is a pending registration request."
};
const ERROR_FACTORY = new (0, _util.ErrorFactory)(SERVICE, SERVICE_NAME, ERROR_DESCRIPTION_MAP);
/** Returns true if error is a FirebaseError that is based on an error from the server. */ function isServerError(error) {
    return error instanceof (0, _util.FirebaseError) && error.code.includes("request-failed" /* ErrorCode.REQUEST_FAILED */ );
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function getInstallationsEndpoint({ projectId }) {
    return `${INSTALLATIONS_API_URL}/projects/${projectId}/installations`;
}
function extractAuthTokenInfoFromResponse(response) {
    return {
        token: response.token,
        requestStatus: 2 /* RequestStatus.COMPLETED */ ,
        expiresIn: getExpiresInFromResponseExpiresIn(response.expiresIn),
        creationTime: Date.now()
    };
}
async function getErrorFromResponse(requestName, response) {
    const responseJson = await response.json();
    const errorData = responseJson.error;
    return ERROR_FACTORY.create("request-failed" /* ErrorCode.REQUEST_FAILED */ , {
        requestName,
        serverCode: errorData.code,
        serverMessage: errorData.message,
        serverStatus: errorData.status
    });
}
function getHeaders({ apiKey }) {
    return new Headers({
        'Content-Type': 'application/json',
        Accept: 'application/json',
        'x-goog-api-key': apiKey
    });
}
function getHeadersWithAuth(appConfig, { refreshToken }) {
    const headers = getHeaders(appConfig);
    headers.append('Authorization', getAuthorizationHeader(refreshToken));
    return headers;
}
/**
 * Calls the passed in fetch wrapper and returns the response.
 * If the returned response has a status of 5xx, re-runs the function once and
 * returns the response.
 */ async function retryIfServerError(fn) {
    const result = await fn();
    if (result.status >= 500 && result.status < 600) // Internal Server Error. Retry request.
    return fn();
    return result;
}
function getExpiresInFromResponseExpiresIn(responseExpiresIn) {
    // This works because the server will never respond with fractions of a second.
    return Number(responseExpiresIn.replace('s', '000'));
}
function getAuthorizationHeader(refreshToken) {
    return `${INTERNAL_AUTH_VERSION} ${refreshToken}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function createInstallationRequest({ appConfig, heartbeatServiceProvider }, { fid }) {
    const endpoint = getInstallationsEndpoint(appConfig);
    const headers = getHeaders(appConfig);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        fid,
        authVersion: INTERNAL_AUTH_VERSION,
        appId: appConfig.appId,
        sdkVersion: PACKAGE_VERSION
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const registeredInstallationEntry = {
            fid: responseValue.fid || fid,
            registrationStatus: 2 /* RequestStatus.COMPLETED */ ,
            refreshToken: responseValue.refreshToken,
            authToken: extractAuthTokenInfoFromResponse(responseValue.authToken)
        };
        return registeredInstallationEntry;
    } else throw await getErrorFromResponse('Create Installation', response);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a promise that resolves after given time passes. */ function sleep(ms) {
    return new Promise((resolve)=>{
        setTimeout(resolve, ms);
    });
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function bufferToBase64UrlSafe(array) {
    const b64 = btoa(String.fromCharCode(...array));
    return b64.replace(/\+/g, '-').replace(/\//g, '_');
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const VALID_FID_PATTERN = /^[cdef][\w-]{21}$/;
const INVALID_FID = '';
/**
 * Generates a new FID using random values from Web Crypto API.
 * Returns an empty string if FID generation fails for any reason.
 */ function generateFid() {
    try {
        // A valid FID has exactly 22 base64 characters, which is 132 bits, or 16.5
        // bytes. our implementation generates a 17 byte array instead.
        const fidByteArray = new Uint8Array(17);
        const crypto = self.crypto || self.msCrypto;
        crypto.getRandomValues(fidByteArray);
        // Replace the first 4 random bits with the constant FID header of 0b0111.
        fidByteArray[0] = 112 + fidByteArray[0] % 16;
        const fid = encode(fidByteArray);
        return VALID_FID_PATTERN.test(fid) ? fid : INVALID_FID;
    } catch  {
        // FID generation errored
        return INVALID_FID;
    }
}
/** Converts a FID Uint8Array to a base64 string representation. */ function encode(fidByteArray) {
    const b64String = bufferToBase64UrlSafe(fidByteArray);
    // Remove the 23rd character that was added because of the extra 4 bits at the
    // end of our 17 byte array, and the '=' padding.
    return b64String.substr(0, 22);
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /** Returns a string key that can be used to identify the app. */ function getKey(appConfig) {
    return `${appConfig.appName}!${appConfig.appId}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const fidChangeCallbacks = new Map();
/**
 * Calls the onIdChange callbacks with the new FID value, and broadcasts the
 * change to other tabs.
 */ function fidChanged(appConfig, fid) {
    const key = getKey(appConfig);
    callFidChangeCallbacks(key, fid);
    broadcastFidChange(key, fid);
}
function addCallback(appConfig, callback) {
    // Open the broadcast channel if it's not already open,
    // to be able to listen to change events from other tabs.
    getBroadcastChannel();
    const key = getKey(appConfig);
    let callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) {
        callbackSet = new Set();
        fidChangeCallbacks.set(key, callbackSet);
    }
    callbackSet.add(callback);
}
function removeCallback(appConfig, callback) {
    const key = getKey(appConfig);
    const callbackSet = fidChangeCallbacks.get(key);
    if (!callbackSet) return;
    callbackSet.delete(callback);
    if (callbackSet.size === 0) fidChangeCallbacks.delete(key);
    // Close broadcast channel if there are no more callbacks.
    closeBroadcastChannel();
}
function callFidChangeCallbacks(key, fid) {
    const callbacks = fidChangeCallbacks.get(key);
    if (!callbacks) return;
    for (const callback of callbacks)callback(fid);
}
function broadcastFidChange(key, fid) {
    const channel = getBroadcastChannel();
    if (channel) channel.postMessage({
        key,
        fid
    });
    closeBroadcastChannel();
}
let broadcastChannel = null;
/** Opens and returns a BroadcastChannel if it is supported by the browser. */ function getBroadcastChannel() {
    if (!broadcastChannel && 'BroadcastChannel' in self) {
        broadcastChannel = new BroadcastChannel('[Firebase] FID Change');
        broadcastChannel.onmessage = (e)=>{
            callFidChangeCallbacks(e.data.key, e.data.fid);
        };
    }
    return broadcastChannel;
}
function closeBroadcastChannel() {
    if (fidChangeCallbacks.size === 0 && broadcastChannel) {
        broadcastChannel.close();
        broadcastChannel = null;
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const DATABASE_NAME = 'firebase-installations-database';
const DATABASE_VERSION = 1;
const OBJECT_STORE_NAME = 'firebase-installations-store';
let dbPromise = null;
function getDbPromise() {
    if (!dbPromise) dbPromise = (0, _idb.openDB)(DATABASE_NAME, DATABASE_VERSION, {
        upgrade: (db, oldVersion)=>{
            // We don't use 'break' in this switch statement, the fall-through
            // behavior is what we want, because if there are multiple versions between
            // the old version and the current version, we want ALL the migrations
            // that correspond to those versions to run, not only the last one.
            // eslint-disable-next-line default-case
            switch(oldVersion){
                case 0:
                    db.createObjectStore(OBJECT_STORE_NAME);
            }
        }
    });
    return dbPromise;
}
/** Assigns or overwrites the record for the given key with the given value. */ async function set(appConfig, value) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const objectStore = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = await objectStore.get(key);
    await objectStore.put(value, key);
    await tx.done;
    if (!oldValue || oldValue.fid !== value.fid) fidChanged(appConfig, value.fid);
    return value;
}
/** Removes record(s) from the objectStore that match the given key. */ async function remove(appConfig) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    await tx.objectStore(OBJECT_STORE_NAME).delete(key);
    await tx.done;
}
/**
 * Atomically updates a record with the result of updateFn, which gets
 * called with the current value. If newValue is undefined, the record is
 * deleted instead.
 * @return Updated value
 */ async function update(appConfig, updateFn) {
    const key = getKey(appConfig);
    const db = await getDbPromise();
    const tx = db.transaction(OBJECT_STORE_NAME, 'readwrite');
    const store = tx.objectStore(OBJECT_STORE_NAME);
    const oldValue = await store.get(key);
    const newValue = updateFn(oldValue);
    if (newValue === undefined) await store.delete(key);
    else await store.put(newValue, key);
    await tx.done;
    if (newValue && (!oldValue || oldValue.fid !== newValue.fid)) fidChanged(appConfig, newValue.fid);
    return newValue;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Updates and returns the InstallationEntry from the database.
 * Also triggers a registration request if it is necessary and possible.
 */ async function getInstallationEntry(installations) {
    let registrationPromise;
    const installationEntry = await update(installations.appConfig, (oldEntry)=>{
        const installationEntry = updateOrCreateInstallationEntry(oldEntry);
        const entryWithPromise = triggerRegistrationIfNecessary(installations, installationEntry);
        registrationPromise = entryWithPromise.registrationPromise;
        return entryWithPromise.installationEntry;
    });
    if (installationEntry.fid === INVALID_FID) // FID generation failed. Waiting for the FID from the server.
    return {
        installationEntry: await registrationPromise
    };
    return {
        installationEntry,
        registrationPromise
    };
}
/**
 * Creates a new Installation Entry if one does not exist.
 * Also clears timed out pending requests.
 */ function updateOrCreateInstallationEntry(oldEntry) {
    const entry = oldEntry || {
        fid: generateFid(),
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return clearTimedOutRequest(entry);
}
/**
 * If the Firebase Installation is not registered yet, this will trigger the
 * registration and return an InProgressInstallationEntry.
 *
 * If registrationPromise does not exist, the installationEntry is guaranteed
 * to be registered.
 */ function triggerRegistrationIfNecessary(installations, installationEntry) {
    if (installationEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        if (!navigator.onLine) {
            // Registration required but app is offline.
            const registrationPromiseWithError = Promise.reject(ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ ));
            return {
                installationEntry,
                registrationPromise: registrationPromiseWithError
            };
        }
        // Try registering. Change status to IN_PROGRESS.
        const inProgressEntry = {
            fid: installationEntry.fid,
            registrationStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
            registrationTime: Date.now()
        };
        const registrationPromise = registerInstallation(installations, inProgressEntry);
        return {
            installationEntry: inProgressEntry,
            registrationPromise
        };
    } else if (installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) return {
        installationEntry,
        registrationPromise: waitUntilFidRegistration(installations)
    };
    else return {
        installationEntry
    };
}
/** This will be executed only once for each new Firebase Installation. */ async function registerInstallation(installations, installationEntry) {
    try {
        const registeredInstallationEntry = await createInstallationRequest(installations, installationEntry);
        return set(installations.appConfig, registeredInstallationEntry);
    } catch (e) {
        if (isServerError(e) && e.customData.serverCode === 409) // Server returned a "FID cannot be used" error.
        // Generate a new ID next time.
        await remove(installations.appConfig);
        else // Registration failed. Set FID as not registered.
        await set(installations.appConfig, {
            fid: installationEntry.fid,
            registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
        });
        throw e;
    }
}
/** Call if FID registration is pending in another request. */ async function waitUntilFidRegistration(installations) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateInstallationRequest(installations.appConfig);
    while(entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // createInstallation request still in progress.
        await sleep(100);
        entry = await updateInstallationRequest(installations.appConfig);
    }
    if (entry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) {
        // The request timed out or failed in a different call. Try again.
        const { installationEntry, registrationPromise } = await getInstallationEntry(installations);
        if (registrationPromise) return registrationPromise;
        else // if there is no registrationPromise, entry is registered.
        return installationEntry;
    }
    return entry;
}
/**
 * Called only if there is a CreateInstallation request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * CreateInstallation request.
 *
 * Returns the updated InstallationEntry.
 */ function updateInstallationRequest(appConfig) {
    return update(appConfig, (oldEntry)=>{
        if (!oldEntry) throw ERROR_FACTORY.create("installation-not-found" /* ErrorCode.INSTALLATION_NOT_FOUND */ );
        return clearTimedOutRequest(oldEntry);
    });
}
function clearTimedOutRequest(entry) {
    if (hasInstallationRequestTimedOut(entry)) return {
        fid: entry.fid,
        registrationStatus: 0 /* RequestStatus.NOT_STARTED */ 
    };
    return entry;
}
function hasInstallationRequestTimedOut(installationEntry) {
    return installationEntry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */  && installationEntry.registrationTime + PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function generateAuthTokenRequest({ appConfig, heartbeatServiceProvider }, installationEntry) {
    const endpoint = getGenerateAuthTokenEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    // If heartbeat service exists, add the heartbeat string to the header.
    const heartbeatService = heartbeatServiceProvider.getImmediate({
        optional: true
    });
    if (heartbeatService) {
        const heartbeatsHeader = await heartbeatService.getHeartbeatsHeader();
        if (heartbeatsHeader) headers.append('x-firebase-client', heartbeatsHeader);
    }
    const body = {
        installation: {
            sdkVersion: PACKAGE_VERSION,
            appId: appConfig.appId
        }
    };
    const request = {
        method: 'POST',
        headers,
        body: JSON.stringify(body)
    };
    const response = await retryIfServerError(()=>fetch(endpoint, request));
    if (response.ok) {
        const responseValue = await response.json();
        const completedAuthToken = extractAuthTokenInfoFromResponse(responseValue);
        return completedAuthToken;
    } else throw await getErrorFromResponse('Generate Auth Token', response);
}
function getGenerateAuthTokenEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}/authTokens:generate`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a valid authentication token for the installation. Generates a new
 * token if one doesn't exist, is expired or about to expire.
 *
 * Should only be called if the Firebase Installation is registered.
 */ async function refreshAuthToken(installations, forceRefresh = false) {
    let tokenPromise;
    const entry = await update(installations.appConfig, (oldEntry)=>{
        if (!isEntryRegistered(oldEntry)) throw ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (!forceRefresh && isAuthTokenValid(oldAuthToken)) // There is a valid token in the DB.
        return oldEntry;
        else if (oldAuthToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ) {
            // There already is a token request in progress.
            tokenPromise = waitUntilAuthTokenRequest(installations, forceRefresh);
            return oldEntry;
        } else {
            // No token or token expired.
            if (!navigator.onLine) throw ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            const inProgressEntry = makeAuthTokenRequestInProgressEntry(oldEntry);
            tokenPromise = fetchAuthTokenFromServer(installations, inProgressEntry);
            return inProgressEntry;
        }
    });
    const authToken = tokenPromise ? await tokenPromise : entry.authToken;
    return authToken;
}
/**
 * Call only if FID is registered and Auth Token request is in progress.
 *
 * Waits until the current pending request finishes. If the request times out,
 * tries once in this thread as well.
 */ async function waitUntilAuthTokenRequest(installations, forceRefresh) {
    // Unfortunately, there is no way of reliably observing when a value in
    // IndexedDB changes (yet, see https://github.com/WICG/indexed-db-observers),
    // so we need to poll.
    let entry = await updateAuthTokenRequest(installations.appConfig);
    while(entry.authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */ ){
        // generateAuthToken still in progress.
        await sleep(100);
        entry = await updateAuthTokenRequest(installations.appConfig);
    }
    const authToken = entry.authToken;
    if (authToken.requestStatus === 0 /* RequestStatus.NOT_STARTED */ ) // The request timed out or failed in a different call. Try again.
    return refreshAuthToken(installations, forceRefresh);
    else return authToken;
}
/**
 * Called only if there is a GenerateAuthToken request in progress.
 *
 * Updates the InstallationEntry in the DB based on the status of the
 * GenerateAuthToken request.
 *
 * Returns the updated InstallationEntry.
 */ function updateAuthTokenRequest(appConfig) {
    return update(appConfig, (oldEntry)=>{
        if (!isEntryRegistered(oldEntry)) throw ERROR_FACTORY.create("not-registered" /* ErrorCode.NOT_REGISTERED */ );
        const oldAuthToken = oldEntry.authToken;
        if (hasAuthTokenRequestTimedOut(oldAuthToken)) return {
            ...oldEntry,
            authToken: {
                requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
            }
        };
        return oldEntry;
    });
}
async function fetchAuthTokenFromServer(installations, installationEntry) {
    try {
        const authToken = await generateAuthTokenRequest(installations, installationEntry);
        const updatedInstallationEntry = {
            ...installationEntry,
            authToken
        };
        await set(installations.appConfig, updatedInstallationEntry);
        return authToken;
    } catch (e) {
        if (isServerError(e) && (e.customData.serverCode === 401 || e.customData.serverCode === 404)) // Server returned a "FID not found" or a "Invalid authentication" error.
        // Generate a new ID next time.
        await remove(installations.appConfig);
        else {
            const updatedInstallationEntry = {
                ...installationEntry,
                authToken: {
                    requestStatus: 0 /* RequestStatus.NOT_STARTED */ 
                }
            };
            await set(installations.appConfig, updatedInstallationEntry);
        }
        throw e;
    }
}
function isEntryRegistered(installationEntry) {
    return installationEntry !== undefined && installationEntry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ;
}
function isAuthTokenValid(authToken) {
    return authToken.requestStatus === 2 /* RequestStatus.COMPLETED */  && !isAuthTokenExpired(authToken);
}
function isAuthTokenExpired(authToken) {
    const now = Date.now();
    return now < authToken.creationTime || authToken.creationTime + authToken.expiresIn < now + TOKEN_EXPIRATION_BUFFER;
}
/** Returns an updated InstallationEntry with an InProgressAuthToken. */ function makeAuthTokenRequestInProgressEntry(oldEntry) {
    const inProgressAuthToken = {
        requestStatus: 1 /* RequestStatus.IN_PROGRESS */ ,
        requestTime: Date.now()
    };
    return {
        ...oldEntry,
        authToken: inProgressAuthToken
    };
}
function hasAuthTokenRequestTimedOut(authToken) {
    return authToken.requestStatus === 1 /* RequestStatus.IN_PROGRESS */  && authToken.requestTime + PENDING_TIMEOUT_MS < Date.now();
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Creates a Firebase Installation if there isn't one for the app and
 * returns the Installation ID.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function getId(installations) {
    const installationsImpl = installations;
    const { installationEntry, registrationPromise } = await getInstallationEntry(installationsImpl);
    if (registrationPromise) registrationPromise.catch(console.error);
    else // If the installation is already registered, update the authentication
    // token if needed.
    refreshAuthToken(installationsImpl).catch(console.error);
    return installationEntry.fid;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns a Firebase Installations auth token, identifying the current
 * Firebase Installation.
 * @param installations - The `Installations` instance.
 * @param forceRefresh - Force refresh regardless of token expiration.
 *
 * @public
 */ async function getToken(installations, forceRefresh = false) {
    const installationsImpl = installations;
    await completeInstallationRegistration(installationsImpl);
    // At this point we either have a Registered Installation in the DB, or we've
    // already thrown an error.
    const authToken = await refreshAuthToken(installationsImpl, forceRefresh);
    return authToken.token;
}
async function completeInstallationRegistration(installations) {
    const { registrationPromise } = await getInstallationEntry(installations);
    if (registrationPromise) // A createInstallation request is in progress. Wait until it finishes.
    await registrationPromise;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ async function deleteInstallationRequest(appConfig, installationEntry) {
    const endpoint = getDeleteEndpoint(appConfig, installationEntry);
    const headers = getHeadersWithAuth(appConfig, installationEntry);
    const request = {
        method: 'DELETE',
        headers
    };
    const response = await retryIfServerError(()=>fetch(endpoint, request));
    if (!response.ok) throw await getErrorFromResponse('Delete Installation', response);
}
function getDeleteEndpoint(appConfig, { fid }) {
    return `${getInstallationsEndpoint(appConfig)}/${fid}`;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Deletes the Firebase Installation and all associated data.
 * @param installations - The `Installations` instance.
 *
 * @public
 */ async function deleteInstallations(installations) {
    const { appConfig } = installations;
    const entry = await update(appConfig, (oldEntry)=>{
        if (oldEntry && oldEntry.registrationStatus === 0 /* RequestStatus.NOT_STARTED */ ) // Delete the unregistered entry without sending a deleteInstallation request.
        return undefined;
        return oldEntry;
    });
    if (entry) {
        if (entry.registrationStatus === 1 /* RequestStatus.IN_PROGRESS */ ) // Can't delete while trying to register.
        throw ERROR_FACTORY.create("delete-pending-registration" /* ErrorCode.DELETE_PENDING_REGISTRATION */ );
        else if (entry.registrationStatus === 2 /* RequestStatus.COMPLETED */ ) {
            if (!navigator.onLine) throw ERROR_FACTORY.create("app-offline" /* ErrorCode.APP_OFFLINE */ );
            else {
                await deleteInstallationRequest(appConfig, entry);
                await remove(appConfig);
            }
        }
    }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Sets a new callback that will get called when Installation ID changes.
 * Returns an unsubscribe function that will remove the callback when called.
 * @param installations - The `Installations` instance.
 * @param callback - The callback function that is invoked when FID changes.
 * @returns A function that can be called to unsubscribe.
 *
 * @public
 */ function onIdChange(installations, callback) {
    const { appConfig } = installations;
    addCallback(appConfig, callback);
    return ()=>{
        removeCallback(appConfig, callback);
    };
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Returns an instance of {@link Installations} associated with the given
 * {@link @firebase/app#FirebaseApp} instance.
 * @param app - The {@link @firebase/app#FirebaseApp} instance.
 *
 * @public
 */ function getInstallations(app = (0, _app.getApp)()) {
    const installationsImpl = (0, _app._getProvider)(app, 'installations').getImmediate();
    return installationsImpl;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ function extractAppConfig(app) {
    if (!app || !app.options) throw getMissingValueError('App Configuration');
    if (!app.name) throw getMissingValueError('App Name');
    // Required app config keys
    const configKeys = [
        'projectId',
        'apiKey',
        'appId'
    ];
    for (const keyName of configKeys){
        if (!app.options[keyName]) throw getMissingValueError(keyName);
    }
    return {
        appName: app.name,
        projectId: app.options.projectId,
        apiKey: app.options.apiKey,
        appId: app.options.appId
    };
}
function getMissingValueError(valueName) {
    return ERROR_FACTORY.create("missing-app-config-values" /* ErrorCode.MISSING_APP_CONFIG_VALUES */ , {
        valueName
    });
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const INSTALLATIONS_NAME = 'installations';
const INSTALLATIONS_NAME_INTERNAL = 'installations-internal';
const publicFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Throws if app isn't configured properly.
    const appConfig = extractAppConfig(app);
    const heartbeatServiceProvider = (0, _app._getProvider)(app, 'heartbeat');
    const installationsImpl = {
        app,
        appConfig,
        heartbeatServiceProvider,
        _delete: ()=>Promise.resolve()
    };
    return installationsImpl;
};
const internalFactory = (container)=>{
    const app = container.getProvider('app').getImmediate();
    // Internal FIS instance relies on public FIS instance.
    const installations = (0, _app._getProvider)(app, INSTALLATIONS_NAME).getImmediate();
    const installationsInternal = {
        getId: ()=>getId(installations),
        getToken: (forceRefresh)=>getToken(installations, forceRefresh)
    };
    return installationsInternal;
};
function registerInstallations() {
    (0, _app._registerComponent)(new (0, _component.Component)(INSTALLATIONS_NAME, publicFactory, "PUBLIC" /* ComponentType.PUBLIC */ ));
    (0, _app._registerComponent)(new (0, _component.Component)(INSTALLATIONS_NAME_INTERNAL, internalFactory, "PRIVATE" /* ComponentType.PRIVATE */ ));
}
/**
 * The Firebase Installations Web SDK.
 * This SDK does not work in a Node.js environment.
 *
 * @packageDocumentation
 */ registerInstallations();
(0, _app.registerVersion)(name, version);
// BUILD_TARGET will be replaced by values like esm, cjs, etc during the compilation
(0, _app.registerVersion)(name, version, 'esm2020');

},{"@firebase/app":"iO7sa","@firebase/component":"6VF6E","@firebase/util":"fHqXn","idb":"d2rZl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4z0zZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateTrainerProfile", ()=>updateTrainerProfile);
parcelHelpers.export(exports, "useUpdateTrainerProfile", ()=>useUpdateTrainerProfile);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _sessionStore = require("../../store/sessionStore");
var _appAlert = require("src/utils/appAlert");
var _appAlertDefault = parcelHelpers.interopDefault(_appAlert);
const updateTrainerProfile = async (payload)=>{
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_UPDATE_PROFILE}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
    });
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.error || 'Failed to update profile');
    }
    return response.json();
};
function useUpdateTrainerProfile() {
    const updateStoreProfile = (0, _sessionStore.sessionStore)((state)=>state.updateProfile);
    return (0, _reactQuery.useMutation)({
        mutationFn: updateTrainerProfile,
        onSuccess: (response, variables)=>{
            // Update local Zustand store with the successfully saved data
            updateStoreProfile(variables.data);
            (0, _appAlertDefault.default).success('Profile updated successfully', {
                position: 'top-right',
                style: {
                    borderRadius: '8px',
                    background: '#0a0b24',
                    color: '#fff',
                    border: '1px solid rgba(255, 255, 255, 0.1)'
                }
            });
        },
        onError: (error)=>{
            (0, _appAlertDefault.default).error(error.message, {
                position: 'top-right',
                style: {
                    borderRadius: '8px',
                    background: '#0a0b24',
                    color: '#fff',
                    border: '1px solid rgba(255, 255, 255, 0.1)'
                }
            });
        }
    });
}

},{"@tanstack/react-query":"ehKs4","src/config/api-config":"9oD3c","../../store/sessionStore":"kPSO3","src/utils/appAlert":"de4Mq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bOtFg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchProgramMasterData", ()=>fetchProgramMasterData);
parcelHelpers.export(exports, "useGetProgramMasterData", ()=>useGetProgramMasterData);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _keyBy = require("lodash/keyBy");
var _keyByDefault = parcelHelpers.interopDefault(_keyBy);
var _deepCamelCaseKeys = require("src/utils/deepCamelCaseKeys");
const ONE_WEEK_MS = 604800000; // 7 days (1 week)
const fetchProgramMasterData = async ()=>{
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_PROGRAM_MASTER_DATA}`;
    const response = await fetch(apiUrl);
    if (!response.ok) throw new Error(`Failed to fetch program master data: ${response.status}`);
    const res = await response.json();
    // Standard industry approach: use lodash keyBy to normalize array to a dictionary using 'id'
    const dataObj = Array.isArray(res.data) ? (0, _keyByDefault.default)(res.data, 'id') : res.data;
    const parsedData = (0, _deepCamelCaseKeys.deepCamelCaseKeys)(dataObj);
    return parsedData;
};
function useGetProgramMasterData() {
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'program-master-data'
        ],
        queryFn: fetchProgramMasterData,
        staleTime: ONE_WEEK_MS,
        gcTime: ONE_WEEK_MS
    });
}

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","lodash/keyBy":"dnkT0","src/utils/deepCamelCaseKeys":"9w8Oj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dnkT0":[function(require,module,exports,__globalThis) {
var baseAssignValue = require("c46c3767ff672674"), createAggregator = require("6b8d7408337ccc56");
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the last element responsible for generating the key. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * var array = [
 *   { 'dir': 'left', 'code': 97 },
 *   { 'dir': 'right', 'code': 100 }
 * ];
 *
 * _.keyBy(array, function(o) {
 *   return String.fromCharCode(o.code);
 * });
 * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
 *
 * _.keyBy(array, 'dir');
 * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
 */ var keyBy = createAggregator(function(result, value, key) {
    baseAssignValue(result, key, value);
});
module.exports = keyBy;

},{"c46c3767ff672674":"kIeTG","6b8d7408337ccc56":"g9n00"}],"kIeTG":[function(require,module,exports,__globalThis) {
var defineProperty = require("57c6267f904aee0a");
/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) defineProperty(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
module.exports = baseAssignValue;

},{"57c6267f904aee0a":"avMUX"}],"avMUX":[function(require,module,exports,__globalThis) {
var getNative = require("7565accd8c33cb8b");
var defineProperty = function() {
    try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
module.exports = defineProperty;

},{"7565accd8c33cb8b":"aNiUF"}],"aNiUF":[function(require,module,exports,__globalThis) {
var baseIsNative = require("63e3f1300cdc459f"), getValue = require("16db51a0e009bd8c");
/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function getNative(object, key) {
    var value = getValue(object, key);
    return baseIsNative(value) ? value : undefined;
}
module.exports = getNative;

},{"63e3f1300cdc459f":"59yCg","16db51a0e009bd8c":"kRRoe"}],"59yCg":[function(require,module,exports,__globalThis) {
var isFunction = require("2f9b4543c84c6692"), isMasked = require("cabbc2adfaeb27d9"), isObject = require("cbb5703fe1562e7f"), toSource = require("388b819f47a43aa5");
/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var funcProto = Function.prototype, objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function baseIsNative(value) {
    if (!isObject(value) || isMasked(value)) return false;
    var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
    return pattern.test(toSource(value));
}
module.exports = baseIsNative;

},{"2f9b4543c84c6692":"bHqi4","cabbc2adfaeb27d9":"kafWX","cbb5703fe1562e7f":"b5XR2","388b819f47a43aa5":"6S6xj"}],"bHqi4":[function(require,module,exports,__globalThis) {
var baseGetTag = require("5419308bd9194e11"), isObject = require("3cba3c966459d528");
/** `Object#toString` result references. */ var asyncTag = '[object AsyncFunction]', funcTag = '[object Function]', genTag = '[object GeneratorFunction]', proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function isFunction(value) {
    if (!isObject(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = baseGetTag(value);
    return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}
module.exports = isFunction;

},{"5419308bd9194e11":"7W5wu","3cba3c966459d528":"b5XR2"}],"7W5wu":[function(require,module,exports,__globalThis) {
var Symbol = require("68a84eb98c5d3fa2"), getRawTag = require("9b2aaf31b7bdd837"), objectToString = require("46d5beb3375f8a28");
/** `Object#toString` result references. */ var nullTag = '[object Null]', undefinedTag = '[object Undefined]';
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function baseGetTag(value) {
    if (value == null) return value === undefined ? undefinedTag : nullTag;
    return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
}
module.exports = baseGetTag;

},{"68a84eb98c5d3fa2":"dpC1Y","9b2aaf31b7bdd837":"lpH2j","46d5beb3375f8a28":"7jwXs"}],"dpC1Y":[function(require,module,exports,__globalThis) {
var root = require("9ff1abd51ad45ac0");
/** Built-in value references. */ var Symbol = root.Symbol;
module.exports = Symbol;

},{"9ff1abd51ad45ac0":"63oqc"}],"63oqc":[function(require,module,exports,__globalThis) {
var freeGlobal = require("cd92e8811deaabf5");
/** Detect free variable `self`. */ var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var root = freeGlobal || freeSelf || Function('return this')();
module.exports = root;

},{"cd92e8811deaabf5":"k9HNM"}],"k9HNM":[function(require,module,exports,__globalThis) {
/** Detect free variable `global` from Node.js. */ var global = arguments[3];
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
module.exports = freeGlobal;

},{}],"lpH2j":[function(require,module,exports,__globalThis) {
var Symbol = require("e9b4533b2a68f814");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/** Built-in value references. */ var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function getRawTag(value) {
    var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
    try {
        value[symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[symToStringTag] = tag;
        else delete value[symToStringTag];
    }
    return result;
}
module.exports = getRawTag;

},{"e9b4533b2a68f814":"dpC1Y"}],"7jwXs":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var nativeObjectToString = objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function objectToString(value) {
    return nativeObjectToString.call(value);
}
module.exports = objectToString;

},{}],"b5XR2":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
module.exports = isObject;

},{}],"kafWX":[function(require,module,exports,__globalThis) {
var coreJsData = require("2fa6c734b0792bcf");
/** Used to detect methods masquerading as native. */ var maskSrcKey = function() {
    var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function isMasked(func) {
    return !!maskSrcKey && maskSrcKey in func;
}
module.exports = isMasked;

},{"2fa6c734b0792bcf":"jcsqv"}],"jcsqv":[function(require,module,exports,__globalThis) {
var root = require("2f0959b2c20d7fb0");
/** Used to detect overreaching core-js shims. */ var coreJsData = root['__core-js_shared__'];
module.exports = coreJsData;

},{"2f0959b2c20d7fb0":"63oqc"}],"6S6xj":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var funcToString = funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function toSource(func) {
    if (func != null) {
        try {
            return funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
module.exports = toSource;

},{}],"kRRoe":[function(require,module,exports,__globalThis) {
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function getValue(object, key) {
    return object == null ? undefined : object[key];
}
module.exports = getValue;

},{}],"g9n00":[function(require,module,exports,__globalThis) {
var arrayAggregator = require("64738ab87169df22"), baseAggregator = require("d5eaf98cd48e9d0f"), baseIteratee = require("161d63ee0d95ee81"), isArray = require("3ebefba2225c8b9e");
/**
 * Creates a function like `_.groupBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} [initializer] The accumulator object initializer.
 * @returns {Function} Returns the new aggregator function.
 */ function createAggregator(setter, initializer) {
    return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
        return func(collection, setter, baseIteratee(iteratee, 2), accumulator);
    };
}
module.exports = createAggregator;

},{"64738ab87169df22":"bNRLL","d5eaf98cd48e9d0f":"3Vyr6","161d63ee0d95ee81":"e8N0c","3ebefba2225c8b9e":"bCmB4"}],"bNRLL":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `baseAggregator` for arrays.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
}
module.exports = arrayAggregator;

},{}],"3Vyr6":[function(require,module,exports,__globalThis) {
var baseEach = require("b2d4f581dd6625d8");
/**
 * Aggregates elements of `collection` on `accumulator` with keys transformed
 * by `iteratee` and values set by `setter`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform keys.
 * @param {Object} accumulator The initial aggregated object.
 * @returns {Function} Returns `accumulator`.
 */ function baseAggregator(collection, setter, iteratee, accumulator) {
    baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
    });
    return accumulator;
}
module.exports = baseAggregator;

},{"b2d4f581dd6625d8":"8f5we"}],"8f5we":[function(require,module,exports,__globalThis) {
var baseForOwn = require("ee57d32bcdc873cb"), createBaseEach = require("f1e3fc84161ef3ec");
/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */ var baseEach = createBaseEach(baseForOwn);
module.exports = baseEach;

},{"ee57d32bcdc873cb":"3ymA5","f1e3fc84161ef3ec":"3SKDS"}],"3ymA5":[function(require,module,exports,__globalThis) {
var baseFor = require("c7da20818a5fe3d6"), keys = require("1fb77c53defe5720");
/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */ function baseForOwn(object, iteratee) {
    return object && baseFor(object, iteratee, keys);
}
module.exports = baseForOwn;

},{"c7da20818a5fe3d6":"6uMGX","1fb77c53defe5720":"kYKDj"}],"6uMGX":[function(require,module,exports,__globalThis) {
var createBaseFor = require("178c767a7be60d59");
/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */ var baseFor = createBaseFor();
module.exports = baseFor;

},{"178c767a7be60d59":"bqMdu"}],"bqMdu":[function(require,module,exports,__globalThis) {
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseFor(fromRight) {
    return function(object, iteratee, keysFunc) {
        var index = -1, iterable = Object(object), props = keysFunc(object), length = props.length;
        while(length--){
            var key = props[fromRight ? length : ++index];
            if (iteratee(iterable[key], key, iterable) === false) break;
        }
        return object;
    };
}
module.exports = createBaseFor;

},{}],"kYKDj":[function(require,module,exports,__globalThis) {
var arrayLikeKeys = require("4c73ca42c789e5ab"), baseKeys = require("e8453365fdacc8da"), isArrayLike = require("7760b47b02971dfa");
/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */ function keys(object) {
    return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}
module.exports = keys;

},{"4c73ca42c789e5ab":"fcdyL","e8453365fdacc8da":"beZEn","7760b47b02971dfa":"f6382"}],"fcdyL":[function(require,module,exports,__globalThis) {
var baseTimes = require("7ed875a0e67be76f"), isArguments = require("9cdb51ffa56f149b"), isArray = require("38cd49f1e493b3d7"), isBuffer = require("b379831fe1873fed"), isIndex = require("f362a34cd8321bb7"), isTypedArray = require("c019db5297494469");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */ function arrayLikeKeys(value, inherited) {
    var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result = skipIndexes ? baseTimes(value.length, String) : [], length = result.length;
    for(var key in value)if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
    (key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
    isIndex(key, length)))) result.push(key);
    return result;
}
module.exports = arrayLikeKeys;

},{"7ed875a0e67be76f":"5PiEx","9cdb51ffa56f149b":"lGymi","38cd49f1e493b3d7":"bCmB4","b379831fe1873fed":"bs8mk","f362a34cd8321bb7":"f4t28","c019db5297494469":"geCZt"}],"5PiEx":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */ function baseTimes(n, iteratee) {
    var index = -1, result = Array(n);
    while(++index < n)result[index] = iteratee(index);
    return result;
}
module.exports = baseTimes;

},{}],"lGymi":[function(require,module,exports,__globalThis) {
var baseIsArguments = require("b56e5b7d86069686"), isObjectLike = require("bead821d6af018b5");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var isArguments = baseIsArguments(function() {
    return arguments;
}()) ? baseIsArguments : function(value) {
    return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
};
module.exports = isArguments;

},{"b56e5b7d86069686":"dmb35","bead821d6af018b5":"anjMx"}],"dmb35":[function(require,module,exports,__globalThis) {
var baseGetTag = require("7e8612a4a451f2cc"), isObjectLike = require("b6cdbe52dcf709f8");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function baseIsArguments(value) {
    return isObjectLike(value) && baseGetTag(value) == argsTag;
}
module.exports = baseIsArguments;

},{"7e8612a4a451f2cc":"7W5wu","b6cdbe52dcf709f8":"anjMx"}],"anjMx":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function isObjectLike(value) {
    return value != null && typeof value == 'object';
}
module.exports = isObjectLike;

},{}],"bCmB4":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var isArray = Array.isArray;
module.exports = isArray;

},{}],"bs8mk":[function(require,module,exports,__globalThis) {
var root = require("cef5ec6f0da1ab00"), stubFalse = require("a1e87b138cf75d1d");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Built-in value references. */ var Buffer = moduleExports ? root.Buffer : undefined;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */ var isBuffer = nativeIsBuffer || stubFalse;
module.exports = isBuffer;

},{"cef5ec6f0da1ab00":"63oqc","a1e87b138cf75d1d":"1n2Pf"}],"1n2Pf":[function(require,module,exports,__globalThis) {
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */ function stubFalse() {
    return false;
}
module.exports = stubFalse;

},{}],"f4t28":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function isIndex(value, length) {
    var type = typeof value;
    length = length == null ? MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
module.exports = isIndex;

},{}],"geCZt":[function(require,module,exports,__globalThis) {
var baseIsTypedArray = require("75a26f037e65be61"), baseUnary = require("903f50eb1c16d257"), nodeUtil = require("fa49853a82034c30");
/* Node.js helper references. */ var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */ var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
module.exports = isTypedArray;

},{"75a26f037e65be61":"aTorW","903f50eb1c16d257":"infZD","fa49853a82034c30":"42cL5"}],"aTorW":[function(require,module,exports,__globalThis) {
var baseGetTag = require("67544c3df364a802"), isLength = require("f661b3a120d7a4cb"), isObjectLike = require("cdd86c83797c0618");
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', funcTag = '[object Function]', mapTag = '[object Map]', numberTag = '[object Number]', objectTag = '[object Object]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', weakMapTag = '[object WeakMap]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]', float32Tag = '[object Float32Array]', float64Tag = '[object Float64Array]', int8Tag = '[object Int8Array]', int16Tag = '[object Int16Array]', int32Tag = '[object Int32Array]', uint8Tag = '[object Uint8Array]', uint8ClampedTag = '[object Uint8ClampedArray]', uint16Tag = '[object Uint16Array]', uint32Tag = '[object Uint32Array]';
/** Used to identify `toStringTag` values of typed arrays. */ var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */ function baseIsTypedArray(value) {
    return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}
module.exports = baseIsTypedArray;

},{"67544c3df364a802":"7W5wu","f661b3a120d7a4cb":"hnKdL","cdd86c83797c0618":"anjMx"}],"hnKdL":[function(require,module,exports,__globalThis) {
/** Used as references for various `Number` constants. */ var MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}
module.exports = isLength;

},{}],"infZD":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */ function baseUnary(func) {
    return function(value) {
        return func(value);
    };
}
module.exports = baseUnary;

},{}],"42cL5":[function(require,module,exports,__globalThis) {
var freeGlobal = require("94e753dfbe54816e");
/** Detect free variable `exports`. */ var freeExports = exports && !exports.nodeType && exports;
/** Detect free variable `module`. */ var freeModule = freeExports && true && module && !module.nodeType && module;
/** Detect the popular CommonJS extension `module.exports`. */ var moduleExports = freeModule && freeModule.exports === freeExports;
/** Detect free variable `process` from Node.js. */ var freeProcess = moduleExports && freeGlobal.process;
/** Used to access faster Node.js helpers. */ var nodeUtil = function() {
    try {
        // Use `util.types` for Node.js 10+.
        var types = freeModule && freeModule.require && freeModule.require('util').types;
        if (types) return types;
        // Legacy `process.binding('util')` for Node.js < 10.
        return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
}();
module.exports = nodeUtil;

},{"94e753dfbe54816e":"k9HNM"}],"beZEn":[function(require,module,exports,__globalThis) {
var isPrototype = require("7da6298814f9bd95"), nativeKeys = require("3ec652610d8dd5d3");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */ function baseKeys(object) {
    if (!isPrototype(object)) return nativeKeys(object);
    var result = [];
    for(var key in Object(object))if (hasOwnProperty.call(object, key) && key != 'constructor') result.push(key);
    return result;
}
module.exports = baseKeys;

},{"7da6298814f9bd95":"9hPlj","3ec652610d8dd5d3":"VyX7D"}],"9hPlj":[function(require,module,exports,__globalThis) {
/** Used for built-in method references. */ var objectProto = Object.prototype;
/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */ function isPrototype(value) {
    var Ctor = value && value.constructor, proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
    return value === proto;
}
module.exports = isPrototype;

},{}],"VyX7D":[function(require,module,exports,__globalThis) {
var overArg = require("aa3357c7a3889df");
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeKeys = overArg(Object.keys, Object);
module.exports = nativeKeys;

},{"aa3357c7a3889df":"acc6S"}],"acc6S":[function(require,module,exports,__globalThis) {
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */ function overArg(func, transform) {
    return function(arg) {
        return func(transform(arg));
    };
}
module.exports = overArg;

},{}],"f6382":[function(require,module,exports,__globalThis) {
var isFunction = require("bb060d4356645330"), isLength = require("f3db08d4d1110aaf");
/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */ function isArrayLike(value) {
    return value != null && isLength(value.length) && !isFunction(value);
}
module.exports = isArrayLike;

},{"bb060d4356645330":"bHqi4","f3db08d4d1110aaf":"hnKdL"}],"3SKDS":[function(require,module,exports,__globalThis) {
var isArrayLike = require("49bbd11cbf093bb1");
/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */ function createBaseEach(eachFunc, fromRight) {
    return function(collection, iteratee) {
        if (collection == null) return collection;
        if (!isArrayLike(collection)) return eachFunc(collection, iteratee);
        var length = collection.length, index = fromRight ? length : -1, iterable = Object(collection);
        while(fromRight ? index-- : ++index < length){
            if (iteratee(iterable[index], index, iterable) === false) break;
        }
        return collection;
    };
}
module.exports = createBaseEach;

},{"49bbd11cbf093bb1":"f6382"}],"e8N0c":[function(require,module,exports,__globalThis) {
var baseMatches = require("30aeab910fab669"), baseMatchesProperty = require("4f010869f7b63154"), identity = require("28f06147d1eb9502"), isArray = require("3c56f88c4debf449"), property = require("aee920e0ef5bf111");
/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */ function baseIteratee(value) {
    // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
    // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
    if (typeof value == 'function') return value;
    if (value == null) return identity;
    if (typeof value == 'object') return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
    return property(value);
}
module.exports = baseIteratee;

},{"30aeab910fab669":"iDV2P","4f010869f7b63154":"hK8v8","28f06147d1eb9502":"f1xGx","3c56f88c4debf449":"bCmB4","aee920e0ef5bf111":"5OhK3"}],"iDV2P":[function(require,module,exports,__globalThis) {
var baseIsMatch = require("e45515c903dc8f87"), getMatchData = require("89e9034a8071e297"), matchesStrictComparable = require("782598b150762386");
/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatches(source) {
    var matchData = getMatchData(source);
    if (matchData.length == 1 && matchData[0][2]) return matchesStrictComparable(matchData[0][0], matchData[0][1]);
    return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
    };
}
module.exports = baseMatches;

},{"e45515c903dc8f87":"3atKA","89e9034a8071e297":"fYqFL","782598b150762386":"g1Vc7"}],"3atKA":[function(require,module,exports,__globalThis) {
var Stack = require("ae43062900bf7e4d"), baseIsEqual = require("9003c0cc8ac007b6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */ function baseIsMatch(object, source, matchData, customizer) {
    var index = matchData.length, length = index, noCustomizer = !customizer;
    if (object == null) return !length;
    object = Object(object);
    while(index--){
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) return false;
    }
    while(++index < length){
        data = matchData[index];
        var key = data[0], objValue = object[key], srcValue = data[1];
        if (noCustomizer && data[2]) {
            if (objValue === undefined && !(key in object)) return false;
        } else {
            var stack = new Stack;
            if (customizer) var result = customizer(objValue, srcValue, key, object, source, stack);
            if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) return false;
        }
    }
    return true;
}
module.exports = baseIsMatch;

},{"ae43062900bf7e4d":"igtgH","9003c0cc8ac007b6":"KbWXx"}],"igtgH":[function(require,module,exports,__globalThis) {
var ListCache = require("cfb30a39eead9e7e"), stackClear = require("ceda2a63c77c915"), stackDelete = require("91ee1b348d9d7172"), stackGet = require("3fe28318f65b9332"), stackHas = require("724ca4def8b84e06"), stackSet = require("e9ceacb40d9582bd");
/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Stack(entries) {
    var data = this.__data__ = new ListCache(entries);
    this.size = data.size;
}
// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;
module.exports = Stack;

},{"cfb30a39eead9e7e":"fqUvy","ceda2a63c77c915":"dvReD","91ee1b348d9d7172":"fYqUe","3fe28318f65b9332":"aWAsX","724ca4def8b84e06":"cbYvU","e9ceacb40d9582bd":"7Zr3m"}],"fqUvy":[function(require,module,exports,__globalThis) {
var listCacheClear = require("4b1a0d54aed80a7b"), listCacheDelete = require("b700cb849df2c166"), listCacheGet = require("d76dd90eead6cced"), listCacheHas = require("3d210628ba60ec8"), listCacheSet = require("76026bf2d4cfff93");
/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;
module.exports = ListCache;

},{"4b1a0d54aed80a7b":"hxcMS","b700cb849df2c166":"lEMcE","d76dd90eead6cced":"jQQdO","3d210628ba60ec8":"7MlYo","76026bf2d4cfff93":"7f5T8"}],"hxcMS":[function(require,module,exports,__globalThis) {
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
module.exports = listCacheClear;

},{}],"lEMcE":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("173cad7d48c35f4f");
/** Used for built-in method references. */ var arrayProto = Array.prototype;
/** Built-in value references. */ var splice = arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function listCacheDelete(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else splice.call(data, index, 1);
    --this.size;
    return true;
}
module.exports = listCacheDelete;

},{"173cad7d48c35f4f":"haKw5"}],"haKw5":[function(require,module,exports,__globalThis) {
var eq = require("b38bfe408564f7a5");
/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if (eq(array[length][0], key)) return length;
    }
    return -1;
}
module.exports = assocIndexOf;

},{"b38bfe408564f7a5":"jOpKa"}],"jOpKa":[function(require,module,exports,__globalThis) {
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function eq(value, other) {
    return value === other || value !== value && other !== other;
}
module.exports = eq;

},{}],"jQQdO":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("c0bae780ed176e2c");
/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function listCacheGet(key) {
    var data = this.__data__, index = assocIndexOf(data, key);
    return index < 0 ? undefined : data[index][1];
}
module.exports = listCacheGet;

},{"c0bae780ed176e2c":"haKw5"}],"7MlYo":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("7ed3d4e3adbd64a4");
/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function listCacheHas(key) {
    return assocIndexOf(this.__data__, key) > -1;
}
module.exports = listCacheHas;

},{"7ed3d4e3adbd64a4":"haKw5"}],"7f5T8":[function(require,module,exports,__globalThis) {
var assocIndexOf = require("5be4035c2d7ca432");
/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function listCacheSet(key, value) {
    var data = this.__data__, index = assocIndexOf(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
module.exports = listCacheSet;

},{"5be4035c2d7ca432":"haKw5"}],"dvReD":[function(require,module,exports,__globalThis) {
var ListCache = require("8a0350213da984ae");
/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */ function stackClear() {
    this.__data__ = new ListCache;
    this.size = 0;
}
module.exports = stackClear;

},{"8a0350213da984ae":"fqUvy"}],"fYqUe":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function stackDelete(key) {
    var data = this.__data__, result = data['delete'](key);
    this.size = data.size;
    return result;
}
module.exports = stackDelete;

},{}],"aWAsX":[function(require,module,exports,__globalThis) {
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function stackGet(key) {
    return this.__data__.get(key);
}
module.exports = stackGet;

},{}],"cbYvU":[function(require,module,exports,__globalThis) {
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function stackHas(key) {
    return this.__data__.has(key);
}
module.exports = stackHas;

},{}],"7Zr3m":[function(require,module,exports,__globalThis) {
var ListCache = require("4737651e99b917d2"), Map = require("1494efbafafa9552"), MapCache = require("6049e8027fe9407f");
/** Used as the size to enable large array optimizations. */ var LARGE_ARRAY_SIZE = 200;
/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */ function stackSet(key, value) {
    var data = this.__data__;
    if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([
                key,
                value
            ]);
            this.size = ++data.size;
            return this;
        }
        data = this.__data__ = new MapCache(pairs);
    }
    data.set(key, value);
    this.size = data.size;
    return this;
}
module.exports = stackSet;

},{"4737651e99b917d2":"fqUvy","1494efbafafa9552":"koCkS","6049e8027fe9407f":"kzsm2"}],"koCkS":[function(require,module,exports,__globalThis) {
var getNative = require("ed0752fe9f482107"), root = require("29224713b8d411e6");
/* Built-in method references that are verified to be native. */ var Map = getNative(root, 'Map');
module.exports = Map;

},{"ed0752fe9f482107":"aNiUF","29224713b8d411e6":"63oqc"}],"kzsm2":[function(require,module,exports,__globalThis) {
var mapCacheClear = require("a5ffecfb6a8bdac1"), mapCacheDelete = require("d2967b0e32ccfa56"), mapCacheGet = require("ca21409ea89624c0"), mapCacheHas = require("f88fd07f8dd1f67d"), mapCacheSet = require("dbf3eae765642a3b");
/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;
module.exports = MapCache;

},{"a5ffecfb6a8bdac1":"khR1f","d2967b0e32ccfa56":"grz0B","ca21409ea89624c0":"gQckk","f88fd07f8dd1f67d":"3qapz","dbf3eae765642a3b":"7mwaN"}],"khR1f":[function(require,module,exports,__globalThis) {
var Hash = require("4ae82d88051cc92b"), ListCache = require("a07dcf3fd3097a0c"), Map = require("92c01c953ef00ded");
/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
    };
}
module.exports = mapCacheClear;

},{"4ae82d88051cc92b":"bzS4y","a07dcf3fd3097a0c":"fqUvy","92c01c953ef00ded":"koCkS"}],"bzS4y":[function(require,module,exports,__globalThis) {
var hashClear = require("f47a1723b6e2d79b"), hashDelete = require("bc25d439ccd1fb47"), hashGet = require("f096b37295a92ab0"), hashHas = require("d88173cbc6a133c8"), hashSet = require("afb9b3bae0461cbf");
/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;
module.exports = Hash;

},{"f47a1723b6e2d79b":"f3UHe","bc25d439ccd1fb47":"50EWR","f096b37295a92ab0":"jaqJo","d88173cbc6a133c8":"7KDxC","afb9b3bae0461cbf":"4boiL"}],"f3UHe":[function(require,module,exports,__globalThis) {
var nativeCreate = require("dc294230a47ca365");
/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function hashClear() {
    this.__data__ = nativeCreate ? nativeCreate(null) : {};
    this.size = 0;
}
module.exports = hashClear;

},{"dc294230a47ca365":"4Kf0F"}],"4Kf0F":[function(require,module,exports,__globalThis) {
var getNative = require("12f496acdffb7cf7");
/* Built-in method references that are verified to be native. */ var nativeCreate = getNative(Object, 'create');
module.exports = nativeCreate;

},{"12f496acdffb7cf7":"aNiUF"}],"50EWR":[function(require,module,exports,__globalThis) {
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = hashDelete;

},{}],"jaqJo":[function(require,module,exports,__globalThis) {
var nativeCreate = require("627211fa3e1596e1");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function hashGet(key) {
    var data = this.__data__;
    if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
    }
    return hasOwnProperty.call(data, key) ? data[key] : undefined;
}
module.exports = hashGet;

},{"627211fa3e1596e1":"4Kf0F"}],"7KDxC":[function(require,module,exports,__globalThis) {
var nativeCreate = require("52b3f0bfeddceb45");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function hashHas(key) {
    var data = this.__data__;
    return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}
module.exports = hashHas;

},{"52b3f0bfeddceb45":"4Kf0F"}],"4boiL":[function(require,module,exports,__globalThis) {
var nativeCreate = require("67b7d10f53ccd515");
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
    return this;
}
module.exports = hashSet;

},{"67b7d10f53ccd515":"4Kf0F"}],"grz0B":[function(require,module,exports,__globalThis) {
var getMapData = require("656d8c5510e0af84");
/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function mapCacheDelete(key) {
    var result = getMapData(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
module.exports = mapCacheDelete;

},{"656d8c5510e0af84":"1pboz"}],"1pboz":[function(require,module,exports,__globalThis) {
var isKeyable = require("adfdd2b4101370ed");
/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function getMapData(map, key) {
    var data = map.__data__;
    return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
module.exports = getMapData;

},{"adfdd2b4101370ed":"l0fiB"}],"l0fiB":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ function isKeyable(value) {
    var type = typeof value;
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
module.exports = isKeyable;

},{}],"gQckk":[function(require,module,exports,__globalThis) {
var getMapData = require("d345cdfee2b4007d");
/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function mapCacheGet(key) {
    return getMapData(this, key).get(key);
}
module.exports = mapCacheGet;

},{"d345cdfee2b4007d":"1pboz"}],"3qapz":[function(require,module,exports,__globalThis) {
var getMapData = require("29ebabd55e2d6074");
/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function mapCacheHas(key) {
    return getMapData(this, key).has(key);
}
module.exports = mapCacheHas;

},{"29ebabd55e2d6074":"1pboz"}],"7mwaN":[function(require,module,exports,__globalThis) {
var getMapData = require("21c5ffca56eeb737");
/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function mapCacheSet(key, value) {
    var data = getMapData(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
module.exports = mapCacheSet;

},{"21c5ffca56eeb737":"1pboz"}],"KbWXx":[function(require,module,exports,__globalThis) {
var baseIsEqualDeep = require("bd1d38ebd4028e5a"), isObjectLike = require("809bbb0c20650dbc");
/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */ function baseIsEqual(value, other, bitmask, customizer, stack) {
    if (value === other) return true;
    if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) return value !== value && other !== other;
    return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}
module.exports = baseIsEqual;

},{"bd1d38ebd4028e5a":"43ilA","809bbb0c20650dbc":"anjMx"}],"43ilA":[function(require,module,exports,__globalThis) {
var Stack = require("60c73bca87468e58"), equalArrays = require("96bc8a1825db53a5"), equalByTag = require("8bdece495e87fb69"), equalObjects = require("bb94920432a68eca"), getTag = require("45495edff98e5837"), isArray = require("18256411ae9e2858"), isBuffer = require("e5ba7abf54247fc5"), isTypedArray = require("50d786bb5c7366af");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** `Object#toString` result references. */ var argsTag = '[object Arguments]', arrayTag = '[object Array]', objectTag = '[object Object]';
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
    var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
    objTag = objTag == argsTag ? objectTag : objTag;
    othTag = othTag == argsTag ? objectTag : othTag;
    var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
    if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) return false;
        objIsArr = true;
        objIsObj = false;
    }
    if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
    }
    if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'), othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack);
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
    }
    if (!isSameTag) return false;
    stack || (stack = new Stack);
    return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}
module.exports = baseIsEqualDeep;

},{"60c73bca87468e58":"igtgH","96bc8a1825db53a5":"52sMm","8bdece495e87fb69":"f6wak","bb94920432a68eca":"6ZS6r","45495edff98e5837":"iqJCK","18256411ae9e2858":"bCmB4","e5ba7abf54247fc5":"bs8mk","50d786bb5c7366af":"geCZt"}],"52sMm":[function(require,module,exports,__globalThis) {
var SetCache = require("9b110ce138e67ce5"), arraySome = require("1ee20de911db0cb0"), cacheHas = require("defff3d81be91b23");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */ function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
    if (arrLength != othLength && !(isPartial && othLength > arrLength)) return false;
    // Check that cyclic values are equal.
    var arrStacked = stack.get(array);
    var othStacked = stack.get(other);
    if (arrStacked && othStacked) return arrStacked == other && othStacked == array;
    var index = -1, result = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache : undefined;
    stack.set(array, other);
    stack.set(other, array);
    // Ignore non-index properties.
    while(++index < arrLength){
        var arrValue = array[index], othValue = other[index];
        if (customizer) var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        if (compared !== undefined) {
            if (compared) continue;
            result = false;
            break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
            if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) return seen.push(othIndex);
            })) {
                result = false;
                break;
            }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
        }
    }
    stack['delete'](array);
    stack['delete'](other);
    return result;
}
module.exports = equalArrays;

},{"9b110ce138e67ce5":"eYiqn","1ee20de911db0cb0":"4Dzv0","defff3d81be91b23":"9fAC8"}],"eYiqn":[function(require,module,exports,__globalThis) {
var MapCache = require("10fe37252553d0bd"), setCacheAdd = require("9a831e81e9a1f98c"), setCacheHas = require("1a2b6c8a7399c39f");
/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */ function SetCache(values) {
    var index = -1, length = values == null ? 0 : values.length;
    this.__data__ = new MapCache;
    while(++index < length)this.add(values[index]);
}
// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;
module.exports = SetCache;

},{"10fe37252553d0bd":"kzsm2","9a831e81e9a1f98c":"7G1qP","1a2b6c8a7399c39f":"ihf1p"}],"7G1qP":[function(require,module,exports,__globalThis) {
/** Used to stand-in for `undefined` hash values. */ var HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */ function setCacheAdd(value) {
    this.__data__.set(value, HASH_UNDEFINED);
    return this;
}
module.exports = setCacheAdd;

},{}],"ihf1p":[function(require,module,exports,__globalThis) {
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 */ function setCacheHas(value) {
    return this.__data__.has(value);
}
module.exports = setCacheHas;

},{}],"4Dzv0":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function arraySome(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length;
    while(++index < length){
        if (predicate(array[index], index, array)) return true;
    }
    return false;
}
module.exports = arraySome;

},{}],"9fAC8":[function(require,module,exports,__globalThis) {
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function cacheHas(cache, key) {
    return cache.has(key);
}
module.exports = cacheHas;

},{}],"f6wak":[function(require,module,exports,__globalThis) {
var Symbol = require("474c1df4fc722b40"), Uint8Array = require("dbf6aa5033a0f48"), eq = require("539966708f906e61"), equalArrays = require("8142d4017f0a425f"), mapToArray = require("48cddf732eff33ba"), setToArray = require("9dc78b26c5daba20");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/** `Object#toString` result references. */ var boolTag = '[object Boolean]', dateTag = '[object Date]', errorTag = '[object Error]', mapTag = '[object Map]', numberTag = '[object Number]', regexpTag = '[object RegExp]', setTag = '[object Set]', stringTag = '[object String]', symbolTag = '[object Symbol]';
var arrayBufferTag = '[object ArrayBuffer]', dataViewTag = '[object DataView]';
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
    switch(tag){
        case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) return false;
            object = object.buffer;
            other = other.buffer;
        case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) return false;
            return true;
        case boolTag:
        case dateTag:
        case numberTag:
            // Coerce booleans to `1` or `0` and dates to milliseconds.
            // Invalid dates are coerced to `NaN`.
            return eq(+object, +other);
        case errorTag:
            return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
            // Coerce regexes to strings and treat strings, primitives and objects,
            // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
            // for more details.
            return object == other + '';
        case mapTag:
            var convert = mapToArray;
        case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);
            if (object.size != other.size && !isPartial) return false;
            // Assume cyclic values are equal.
            var stacked = stack.get(object);
            if (stacked) return stacked == other;
            bitmask |= COMPARE_UNORDERED_FLAG;
            // Recursively compare objects (susceptible to call stack limits).
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;
        case symbolTag:
            if (symbolValueOf) return symbolValueOf.call(object) == symbolValueOf.call(other);
    }
    return false;
}
module.exports = equalByTag;

},{"474c1df4fc722b40":"dpC1Y","dbf6aa5033a0f48":"kuXZd","539966708f906e61":"jOpKa","8142d4017f0a425f":"52sMm","48cddf732eff33ba":"fWrEH","9dc78b26c5daba20":"1fGvU"}],"kuXZd":[function(require,module,exports,__globalThis) {
var root = require("f755339301d6568f");
/** Built-in value references. */ var Uint8Array = root.Uint8Array;
module.exports = Uint8Array;

},{"f755339301d6568f":"63oqc"}],"fWrEH":[function(require,module,exports,__globalThis) {
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */ function mapToArray(map) {
    var index = -1, result = Array(map.size);
    map.forEach(function(value, key) {
        result[++index] = [
            key,
            value
        ];
    });
    return result;
}
module.exports = mapToArray;

},{}],"1fGvU":[function(require,module,exports,__globalThis) {
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */ function setToArray(set) {
    var index = -1, result = Array(set.size);
    set.forEach(function(value) {
        result[++index] = value;
    });
    return result;
}
module.exports = setToArray;

},{}],"6ZS6r":[function(require,module,exports,__globalThis) {
var getAllKeys = require("b911593d305cf4a2");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1;
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Used to check objects for own properties. */ var hasOwnProperty = objectProto.hasOwnProperty;
/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */ function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
    var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
    if (objLength != othLength && !isPartial) return false;
    var index = objLength;
    while(index--){
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) return false;
    }
    // Check that cyclic values are equal.
    var objStacked = stack.get(object);
    var othStacked = stack.get(other);
    if (objStacked && othStacked) return objStacked == other && othStacked == object;
    var result = true;
    stack.set(object, other);
    stack.set(other, object);
    var skipCtor = isPartial;
    while(++index < objLength){
        key = objProps[index];
        var objValue = object[key], othValue = other[key];
        if (customizer) var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
        }
        skipCtor || (skipCtor = key == 'constructor');
    }
    if (result && !skipCtor) {
        var objCtor = object.constructor, othCtor = other.constructor;
        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) result = false;
    }
    stack['delete'](object);
    stack['delete'](other);
    return result;
}
module.exports = equalObjects;

},{"b911593d305cf4a2":"e2oxc"}],"e2oxc":[function(require,module,exports,__globalThis) {
var baseGetAllKeys = require("c3dbe402f6996a21"), getSymbols = require("aa79b69a13f924db"), keys = require("e3ad83e53433bc8a");
/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */ function getAllKeys(object) {
    return baseGetAllKeys(object, keys, getSymbols);
}
module.exports = getAllKeys;

},{"c3dbe402f6996a21":"1cDSE","aa79b69a13f924db":"a0y7B","e3ad83e53433bc8a":"kYKDj"}],"1cDSE":[function(require,module,exports,__globalThis) {
var arrayPush = require("abfc70b400ed76c2"), isArray = require("148b85918856c33a");
/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */ function baseGetAllKeys(object, keysFunc, symbolsFunc) {
    var result = keysFunc(object);
    return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}
module.exports = baseGetAllKeys;

},{"abfc70b400ed76c2":"h6Wmb","148b85918856c33a":"bCmB4"}],"h6Wmb":[function(require,module,exports,__globalThis) {
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
module.exports = arrayPush;

},{}],"a0y7B":[function(require,module,exports,__globalThis) {
var arrayFilter = require("7fe025254f0b7e4a"), stubArray = require("6b1c62cea92cdb9");
/** Used for built-in method references. */ var objectProto = Object.prototype;
/** Built-in value references. */ var propertyIsEnumerable = objectProto.propertyIsEnumerable;
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeGetSymbols = Object.getOwnPropertySymbols;
/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */ var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
    if (object == null) return [];
    object = Object(object);
    return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
    });
};
module.exports = getSymbols;

},{"7fe025254f0b7e4a":"2hRJc","6b1c62cea92cdb9":"dvCCe"}],"2hRJc":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */ function arrayFilter(array, predicate) {
    var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (predicate(value, index, array)) result[resIndex++] = value;
    }
    return result;
}
module.exports = arrayFilter;

},{}],"dvCCe":[function(require,module,exports,__globalThis) {
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */ function stubArray() {
    return [];
}
module.exports = stubArray;

},{}],"iqJCK":[function(require,module,exports,__globalThis) {
var DataView = require("7f038695b2fdb86e"), Map = require("28e3344aae951f13"), Promise = require("b286298be5b1d9a4"), Set = require("3ae50c158f89813"), WeakMap = require("9f458755f627d456"), baseGetTag = require("8e9160b373d7fe66"), toSource = require("b210627dd951641f");
/** `Object#toString` result references. */ var mapTag = '[object Map]', objectTag = '[object Object]', promiseTag = '[object Promise]', setTag = '[object Set]', weakMapTag = '[object WeakMap]';
var dataViewTag = '[object DataView]';
/** Used to detect maps, sets, and weakmaps. */ var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map), promiseCtorString = toSource(Promise), setCtorString = toSource(Set), weakMapCtorString = toSource(WeakMap);
/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ var getTag = baseGetTag;
// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set) != setTag || WeakMap && getTag(new WeakMap) != weakMapTag) getTag = function(value) {
    var result = baseGetTag(value), Ctor = result == objectTag ? value.constructor : undefined, ctorString = Ctor ? toSource(Ctor) : '';
    if (ctorString) switch(ctorString){
        case dataViewCtorString:
            return dataViewTag;
        case mapCtorString:
            return mapTag;
        case promiseCtorString:
            return promiseTag;
        case setCtorString:
            return setTag;
        case weakMapCtorString:
            return weakMapTag;
    }
    return result;
};
module.exports = getTag;

},{"7f038695b2fdb86e":"jTHlh","28e3344aae951f13":"koCkS","b286298be5b1d9a4":"3G5PG","3ae50c158f89813":"oaIQr","9f458755f627d456":"4rBqe","8e9160b373d7fe66":"7W5wu","b210627dd951641f":"6S6xj"}],"jTHlh":[function(require,module,exports,__globalThis) {
var getNative = require("a6517d0448dad786"), root = require("f83c375075418382");
/* Built-in method references that are verified to be native. */ var DataView = getNative(root, 'DataView');
module.exports = DataView;

},{"a6517d0448dad786":"aNiUF","f83c375075418382":"63oqc"}],"3G5PG":[function(require,module,exports,__globalThis) {
var getNative = require("6940648d854355b5"), root = require("a5c6637bac681a0");
/* Built-in method references that are verified to be native. */ var Promise = getNative(root, 'Promise');
module.exports = Promise;

},{"6940648d854355b5":"aNiUF","a5c6637bac681a0":"63oqc"}],"oaIQr":[function(require,module,exports,__globalThis) {
var getNative = require("56b792d64741a4ff"), root = require("ca486d41cdf819d4");
/* Built-in method references that are verified to be native. */ var Set = getNative(root, 'Set');
module.exports = Set;

},{"56b792d64741a4ff":"aNiUF","ca486d41cdf819d4":"63oqc"}],"4rBqe":[function(require,module,exports,__globalThis) {
var getNative = require("4507415bd8810d3c"), root = require("7a9a6581834a8452");
/* Built-in method references that are verified to be native. */ var WeakMap = getNative(root, 'WeakMap');
module.exports = WeakMap;

},{"4507415bd8810d3c":"aNiUF","7a9a6581834a8452":"63oqc"}],"fYqFL":[function(require,module,exports,__globalThis) {
var isStrictComparable = require("8ba18052e16e94fb"), keys = require("94ffded3a85af2f6");
/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */ function getMatchData(object) {
    var result = keys(object), length = result.length;
    while(length--){
        var key = result[length], value = object[key];
        result[length] = [
            key,
            value,
            isStrictComparable(value)
        ];
    }
    return result;
}
module.exports = getMatchData;

},{"8ba18052e16e94fb":"ls1Vb","94ffded3a85af2f6":"kYKDj"}],"ls1Vb":[function(require,module,exports,__globalThis) {
var isObject = require("be1941f960bbf057");
/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */ function isStrictComparable(value) {
    return value === value && !isObject(value);
}
module.exports = isStrictComparable;

},{"be1941f960bbf057":"b5XR2"}],"g1Vc7":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function matchesStrictComparable(key, srcValue) {
    return function(object) {
        if (object == null) return false;
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
    };
}
module.exports = matchesStrictComparable;

},{}],"hK8v8":[function(require,module,exports,__globalThis) {
var baseIsEqual = require("cebe22f5ca0827a7"), get = require("d5ca180f7d6f956a"), hasIn = require("3462bb3f546fa1f7"), isKey = require("f5fef07966a1c4ee"), isStrictComparable = require("2a1cd212d48516"), matchesStrictComparable = require("885e72ee7fc6d296"), toKey = require("cd65eaf4a3af29f6");
/** Used to compose bitmasks for value comparisons. */ var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */ function baseMatchesProperty(path, srcValue) {
    if (isKey(path) && isStrictComparable(srcValue)) return matchesStrictComparable(toKey(path), srcValue);
    return function(object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
    };
}
module.exports = baseMatchesProperty;

},{"cebe22f5ca0827a7":"KbWXx","d5ca180f7d6f956a":"joon0","3462bb3f546fa1f7":"4QIVe","f5fef07966a1c4ee":"jwsgR","2a1cd212d48516":"ls1Vb","885e72ee7fc6d296":"g1Vc7","cd65eaf4a3af29f6":"RBtZh"}],"joon0":[function(require,module,exports,__globalThis) {
var baseGet = require("446ba3c1be7939a3");
/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */ function get(object, path, defaultValue) {
    var result = object == null ? undefined : baseGet(object, path);
    return result === undefined ? defaultValue : result;
}
module.exports = get;

},{"446ba3c1be7939a3":"421JF"}],"421JF":[function(require,module,exports,__globalThis) {
var castPath = require("434ba191fc1dcf09"), toKey = require("c3296f04fad32769");
/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function baseGet(object, path) {
    path = castPath(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[toKey(path[index++])];
    return index && index == length ? object : undefined;
}
module.exports = baseGet;

},{"434ba191fc1dcf09":"f3wws","c3296f04fad32769":"RBtZh"}],"f3wws":[function(require,module,exports,__globalThis) {
var isArray = require("26a856890198f45b"), isKey = require("e823e604d75f975b"), stringToPath = require("f5fff1c342107fbd"), toString = require("b04e8cc634273c23");
/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function castPath(value, object) {
    if (isArray(value)) return value;
    return isKey(value, object) ? [
        value
    ] : stringToPath(toString(value));
}
module.exports = castPath;

},{"26a856890198f45b":"bCmB4","e823e604d75f975b":"jwsgR","f5fff1c342107fbd":"fyi4X","b04e8cc634273c23":"hiC1E"}],"jwsgR":[function(require,module,exports,__globalThis) {
var isArray = require("1efcc081e9a448a8"), isSymbol = require("4cdff6c9e9ff5d38");
/** Used to match property names within property paths. */ var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function isKey(value, object) {
    if (isArray(value)) return false;
    var type = typeof value;
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) return true;
    return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
}
module.exports = isKey;

},{"1efcc081e9a448a8":"bCmB4","4cdff6c9e9ff5d38":"b0ZB5"}],"b0ZB5":[function(require,module,exports,__globalThis) {
var baseGetTag = require("6118c0d5630f51ce"), isObjectLike = require("74644060ad1a1d3c");
/** `Object#toString` result references. */ var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function isSymbol(value) {
    return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}
module.exports = isSymbol;

},{"6118c0d5630f51ce":"7W5wu","74644060ad1a1d3c":"anjMx"}],"fyi4X":[function(require,module,exports,__globalThis) {
var memoizeCapped = require("55f565a895f455e5");
/** Used to match property names within property paths. */ var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var stringToPath = memoizeCapped(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
    });
    return result;
});
module.exports = stringToPath;

},{"55f565a895f455e5":"971Q6"}],"971Q6":[function(require,module,exports,__globalThis) {
var memoize = require("cb456550b1f5dd0a");
/** Used as the maximum memoize cache size. */ var MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function memoizeCapped(func) {
    var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
module.exports = memoizeCapped;

},{"cb456550b1f5dd0a":"6LVZz"}],"6LVZz":[function(require,module,exports,__globalThis) {
var MapCache = require("b34b26bf235f1cdd");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    var memoized = function() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new (memoize.Cache || MapCache);
    return memoized;
}
// Expose `MapCache`.
memoize.Cache = MapCache;
module.exports = memoize;

},{"b34b26bf235f1cdd":"kzsm2"}],"hiC1E":[function(require,module,exports,__globalThis) {
var baseToString = require("81fca33832a744d9");
/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function toString(value) {
    return value == null ? '' : baseToString(value);
}
module.exports = toString;

},{"81fca33832a744d9":"iarts"}],"iarts":[function(require,module,exports,__globalThis) {
var Symbol = require("16af83505444e42a"), arrayMap = require("8439a3a1551d0706"), isArray = require("4b12c9f502d3288a"), isSymbol = require("a0ebd327d618908a");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var symbolProto = Symbol ? Symbol.prototype : undefined, symbolToString = symbolProto ? symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if (isArray(value)) // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
    if (isSymbol(value)) return symbolToString ? symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = baseToString;

},{"16af83505444e42a":"dpC1Y","8439a3a1551d0706":"eDg3z","4b12c9f502d3288a":"bCmB4","a0ebd327d618908a":"b0ZB5"}],"eDg3z":[function(require,module,exports,__globalThis) {
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
module.exports = arrayMap;

},{}],"RBtZh":[function(require,module,exports,__globalThis) {
var isSymbol = require("2aed9f6fd4b7386");
/** Used as references for various `Number` constants. */ var INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function toKey(value) {
    if (typeof value == 'string' || isSymbol(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -INFINITY ? '-0' : result;
}
module.exports = toKey;

},{"2aed9f6fd4b7386":"b0ZB5"}],"4QIVe":[function(require,module,exports,__globalThis) {
var baseHasIn = require("9fbd4bb192f3f572"), hasPath = require("b0aefd36de99e579");
/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function hasIn(object, path) {
    return object != null && hasPath(object, path, baseHasIn);
}
module.exports = hasIn;

},{"9fbd4bb192f3f572":"6bFxV","b0aefd36de99e579":"1l5ST"}],"6bFxV":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function baseHasIn(object, key) {
    return object != null && key in Object(object);
}
module.exports = baseHasIn;

},{}],"1l5ST":[function(require,module,exports,__globalThis) {
var castPath = require("bdbd2cfd212d36f7"), isArguments = require("47ffafdab3ba0d6f"), isArray = require("93ebd263ff0131c1"), isIndex = require("252ef74480e01958"), isLength = require("23c2f64e75e90a2"), toKey = require("af5ade297cb685ee");
/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function hasPath(object, path, hasFunc) {
    path = castPath(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
}
module.exports = hasPath;

},{"bdbd2cfd212d36f7":"f3wws","47ffafdab3ba0d6f":"lGymi","93ebd263ff0131c1":"bCmB4","252ef74480e01958":"f4t28","23c2f64e75e90a2":"hnKdL","af5ade297cb685ee":"RBtZh"}],"f1xGx":[function(require,module,exports,__globalThis) {
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function identity(value) {
    return value;
}
module.exports = identity;

},{}],"5OhK3":[function(require,module,exports,__globalThis) {
var baseProperty = require("c7f2d79ee4b1c16a"), basePropertyDeep = require("abf31da39349df22"), isKey = require("a387ef4a4373de2c"), toKey = require("9315973458389ae7");
/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */ function property(path) {
    return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}
module.exports = property;

},{"c7f2d79ee4b1c16a":"dAR2V","abf31da39349df22":"4gSJp","a387ef4a4373de2c":"jwsgR","9315973458389ae7":"RBtZh"}],"dAR2V":[function(require,module,exports,__globalThis) {
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function baseProperty(key) {
    return function(object) {
        return object == null ? undefined : object[key];
    };
}
module.exports = baseProperty;

},{}],"4gSJp":[function(require,module,exports,__globalThis) {
var baseGet = require("f0f9f03bc3030d02");
/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */ function basePropertyDeep(path) {
    return function(object) {
        return baseGet(object, path);
    };
}
module.exports = basePropertyDeep;

},{"f0f9f03bc3030d02":"421JF"}],"dYh53":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsDesktop", ()=>useIsDesktop);
var _react = require("react");
const useIsDesktop = (breakpoint = 768)=>{
    const [isDesktop, setIsDesktop] = (0, _react.useState)(()=>{
        if (typeof window === 'undefined') return true;
        return window.innerWidth >= breakpoint;
    });
    (0, _react.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const mediaQuery = window.matchMedia(`(min-width: ${breakpoint}px)`);
        const handleChange = (e)=>{
            setIsDesktop(e.matches);
        };
        // Set initial matching state
        setIsDesktop(mediaQuery.matches);
        try {
            mediaQuery.addEventListener('change', handleChange);
            return ()=>mediaQuery.removeEventListener('change', handleChange);
        } catch  {
            // Fallback for older browsers
            mediaQuery.addListener(handleChange);
            return ()=>mediaQuery.removeListener(handleChange);
        }
    }, [
        breakpoint
    ]);
    return isDesktop;
};

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jat7a":[function() {},{}],"lvqzy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgHamburger);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgHamburger = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 14,
        fill: "none",
        viewBox: "0 0 18 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#DADADA",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.8,
            d: "M1 13h8M1 7h16M9 1h8"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fUXFQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Overview", ()=>Overview);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _programGeneratorProgressStore = require("src/store/programGeneratorProgressStore");
var _overviewScss = require("./Overview.scss");
var _createWithManualSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/overview/create-with-manual.svg");
var _createWithAiSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/overview/create-with-ai.svg");
var _createArrowSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/overview/create-arrow.svg");
var _logoSvg = require("../../../../../../assets/images/onboarding-trainer/logo.svg");
const Overview = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const resetProgress = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore)((state)=>state.resetProgress);
    const handleCreate = (type)=>{
        resetProgress();
        navigate(`/onboarding-trainer/dashboard/program-generator/${type}`);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "overview-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "dashboard-header-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "logo-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: 'Create personalized workout programs for your clients'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "dashboard-action-cards",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "action-card ai-card",
                        onClick: ()=>handleCreate('ai'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon-circle",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createWithAiSvg.ReactComponent), {
                                    viewBox: "0 0 64 64"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-title",
                                children: [
                                    'Create with AI',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createArrowSvg.ReactComponent), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "card-description",
                                children: 'Let AI generate a customized workout program'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "action-card manual-card",
                        onClick: ()=>handleCreate('manual'),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon-circle",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createWithManualSvg.ReactComponent), {
                                    viewBox: "0 0 64 64"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-title",
                                children: [
                                    'Create Manually',
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createArrowSvg.ReactComponent), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "card-description",
                                children: 'Build your workout program from scratch'
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","src/store/programGeneratorProgressStore":"2iAYB","./Overview.scss":"lRfyY","../../../../../../assets/images/onboarding-trainer/dashboard/overview/create-with-manual.svg":"iUQ2I","../../../../../../assets/images/onboarding-trainer/dashboard/overview/create-with-ai.svg":"gzhlc","../../../../../../assets/images/onboarding-trainer/dashboard/overview/create-arrow.svg":"6TMMd","../../../../../../assets/images/onboarding-trainer/logo.svg":"iy8G7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lRfyY":[function() {},{}],"iUQ2I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCreateWithManual);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCreateWithManual = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 64,
        fill: "none",
        viewBox: "0 0 64 64",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 32,
                cy: 32,
                r: 31.5,
                fill: "#0E1026",
                stroke: "#FFA100",
                strokeOpacity: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2.667,
                d: "M32 42.667h12m-6.167-21.838a2.83 2.83 0 0 1 4.003 4.003L25.823 40.846c-.317.318-.71.55-1.14.675l-3.83 1.117a.666.666 0 0 1-.826-.826l1.117-3.83c.126-.43.358-.822.675-1.138z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gzhlc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCreateWithAi);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCreateWithAi = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 64,
        fill: "none",
        viewBox: "0 0 64 64",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 32,
                cy: 32,
                r: 31.5,
                fill: "#0E1026",
                stroke: "#FFA100",
                strokeOpacity: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2.667,
                d: "M29.249 36.666a2.67 2.67 0 0 0-1.916-1.916l-8.18-2.109a.666.666 0 0 1 0-1.283l8.18-2.11a2.67 2.67 0 0 0 1.916-1.915l2.109-8.18a.667.667 0 0 1 1.284 0l2.108 8.18a2.67 2.67 0 0 0 1.916 1.916l8.18 2.108a.667.667 0 0 1 0 1.285l-8.18 2.108a2.67 2.67 0 0 0-1.916 1.916l-2.11 8.18a.666.666 0 0 1-1.283 0zM42.664 20v5.333m2.669-2.666H40m-18.664 16v2.667M22.667 40H20"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6TMMd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCreateArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCreateArrow = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M4 12h16m-6 6 6-6-6-6"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lhjye":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Clients", ()=>Clients);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _button = require("../../../../components/Button/Button");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _reactRouterDom = require("react-router-dom");
var _useGetTrainerClients = require("src/api/mutations/useGetTrainerClients");
var _useAddTrainerClient = require("src/api/mutations/useAddTrainerClient");
var _useUpdateClientStatus = require("src/api/mutations/useUpdateClientStatus");
var _useUnblockClient = require("src/api/mutations/useUnblockClient");
var _dashboardScreensScss = require("../../DashboardScreens.scss");
var _clientsScss = require("./Clients.scss");
var _reactInfiniteScrollComponent = require("react-infinite-scroll-component");
var _reactInfiniteScrollComponentDefault = parcelHelpers.interopDefault(_reactInfiniteScrollComponent);
var _clientSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/clients/client.svg");
var _filterSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/clients/filter.svg");
var _searchSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/clients/search.svg");
var _listSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/list.svg");
var _menuSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/menu.svg");
var _dashboardModalArchiveSvg = require("src/assets/images/trainer/clients/dashboard-modal-archive.svg");
var _dashboardModalDeleteSvg = require("src/assets/images/trainer/clients/dashboard-modal-delete.svg");
var _dashboardArchiveSvg = require("src/assets/images/trainer/clients/dashboard-archive.svg");
var _dashboardOnboardSvg = require("src/assets/images/trainer/clients/dashboard-onboard.svg");
var _dashboardOnboardArrowSvg = require("src/assets/images/trainer/clients/dashboard-onboard-arrow.svg");
var _dashboardDeleteSvg = require("src/assets/images/trainer/clients/dashboard-delete.svg");
var _dashboardEmailSvg = require("src/assets/images/trainer/clients/dashboard-email.svg");
var _dashboardViewArrowSvg = require("src/assets/images/trainer/clients/dashboard-view-arrow.svg");
var _onboardModalInfoSvg = require("src/assets/images/trainer/clients/onboard-modal-info.svg");
var _onboardModalPointSvg = require("src/assets/images/trainer/clients/onboard-modal-point.svg");
var _validation = require("src/utils/validation");
var _sessionStore = require("src/store/sessionStore");
const Clients = ()=>{
    const [viewMode, setViewMode] = (0, _react.useState)('grid');
    const [showFilter, setShowFilter] = (0, _react.useState)('active');
    const [sortFilter, setSortFilter] = (0, _react.useState)('newest');
    const [searchQuery, setSearchQuery] = (0, _react.useState)('');
    const [debouncedSearch, setDebouncedSearch] = (0, _react.useState)('');
    const [currentPage, setCurrentPage] = (0, _react.useState)(1);
    const [isAddClientModalVisible, setIsAddClientModalVisible] = (0, _react.useState)(false);
    const [newClientName, setNewClientName] = (0, _react.useState)('');
    const [newClientSurname, setNewClientSurname] = (0, _react.useState)('');
    const [newClientEmail, setNewClientEmail] = (0, _react.useState)('');
    const [newClientBodyProfile, setNewClientBodyProfile] = (0, _react.useState)('');
    const [errorMsg, setErrorMsg] = (0, _react.useState)('');
    const [fieldErrors, setFieldErrors] = (0, _react.useState)({});
    const [touchedFields, setTouchedFields] = (0, _react.useState)({});
    const validateName = (name)=>{
        if (!name.trim()) return 'First Name is required';
        if (name.length > 50) return 'First Name must be 50 characters or less';
        if (!/\p{L}/u.test(name)) return 'First Name must contain at least one valid letter';
        return '';
    };
    const validateSurname = (surname)=>{
        if (!surname.trim()) return 'Surname is required';
        if (surname.length > 50) return 'Surname must be 50 characters or less';
        if (!/\p{L}/u.test(surname)) return 'Surname must contain at least one valid letter';
        return '';
    };
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const validateEmail = (email)=>{
        const trimmed = email.trim();
        if (trimmed && trimmed.length > 255) return 'Email must be 255 characters or less';
        if (trimmed && !(0, _validation.isValidEmail)(trimmed)) return 'Please enter a valid email address.';
        if (currentUser?.email && trimmed.toLowerCase() === currentUser.email.trim().toLowerCase()) return 'You cannot add yourself as a client.';
        return '';
    };
    const [isOnboardingModalVisible, setIsOnboardingModalVisible] = (0, _react.useState)(false);
    const [onboardingClient, setOnboardingClient] = (0, _react.useState)(null);
    const [clientToDelete, setClientToDelete] = (0, _react.useState)(null);
    const [clientToArchive, setClientToArchive] = (0, _react.useState)(null);
    const [clientToActivate, setClientToActivate] = (0, _react.useState)(null);
    const [clientToUnblock, setClientToUnblock] = (0, _react.useState)(null);
    const { mutateAsync: unblockClient, isPending: isUnblocking } = (0, _useUnblockClient.useUnblockClientMutation)();
    const { data: clientsData, isLoading } = (0, _useGetTrainerClients.useGetTrainerClients)(showFilter, debouncedSearch, sortFilter, currentPage);
    const totalCount = clientsData?.totalCount || 0;
    const [allClients, setAllClients] = (0, _react.useState)([]);
    const prevFiltersRef = (0, _react.useRef)({
        showFilter,
        sortFilter,
        debouncedSearch
    });
    (0, _react.useEffect)(()=>{
        const prev = prevFiltersRef.current;
        const filterChanged = prev.showFilter !== showFilter || prev.sortFilter !== sortFilter || prev.debouncedSearch !== debouncedSearch;
        if (filterChanged) {
            setCurrentPage(1);
            prevFiltersRef.current = {
                showFilter,
                sortFilter,
                debouncedSearch
            };
        }
        const fetchedClients = clientsData?.clients;
        if (fetchedClients && fetchedClients.length > 0) {
            if (currentPage === 1 || filterChanged) setAllClients(fetchedClients);
            else setAllClients((prevList)=>{
                const existingIds = new Set(prevList.map((c)=>c.uid));
                const newClients = fetchedClients.filter((c)=>!existingIds.has(c.uid));
                return [
                    ...prevList,
                    ...newClients
                ];
            });
        } else if (fetchedClients && fetchedClients.length === 0 && (currentPage === 1 || filterChanged)) setAllClients([]);
        else if (!fetchedClients && filterChanged) setAllClients([]);
    }, [
        showFilter,
        sortFilter,
        debouncedSearch,
        clientsData?.clients,
        currentPage
    ]);
    const { mutate: addClient, isPending: isAdding } = (0, _useAddTrainerClient.useAddTrainerClient)();
    const { mutate: updateClientStatus, isPending: isUpdatingStatus } = (0, _useUpdateClientStatus.useUpdateClientStatus)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    (0, _react.useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedSearch(searchQuery);
        }, 500);
        return ()=>clearTimeout(handler);
    }, [
        searchQuery
    ]);
    const handleCloseAddClientModal = ()=>{
        setIsAddClientModalVisible(false);
        setNewClientName('');
        setNewClientSurname('');
        setNewClientEmail('');
        setNewClientBodyProfile('');
        setFieldErrors({});
        setTouchedFields({});
        setErrorMsg('');
    };
    // Filtered and sorted clients are now handled by the backend API.
    const getInitials = (name, surname)=>{
        const first = name ? name.charAt(0).toUpperCase() : '';
        const second = surname ? surname.charAt(0).toUpperCase() : '';
        return `${first}${second}`;
    };
    const handleSaveClient = ()=>{
        const nameErr = validateName(newClientName);
        const surnameErr = validateSurname(newClientSurname);
        const emailErr = validateEmail(newClientEmail);
        const bodyProfileErr = newClientBodyProfile === '' ? 'Please select a body profile.' : '';
        setTouchedFields({
            name: true,
            surname: true,
            email: true,
            bodyProfile: true
        });
        setFieldErrors({
            name: nameErr,
            surname: surnameErr,
            email: emailErr,
            bodyProfile: bodyProfileErr
        });
        if (nameErr || surnameErr || emailErr || bodyProfileErr) return;
        setErrorMsg('');
        addClient({
            name: newClientName.trim(),
            surname: newClientSurname.trim(),
            email: newClientEmail.trim(),
            bodyProfile: newClientBodyProfile
        }, {
            onSuccess: ()=>{
                const fullName = `${newClientName.trim()} ${newClientSurname.trim()}`;
                (0, _reactHotToastDefault.default).success(`${fullName} added successfully`, {
                    id: 'add-client-success'
                });
                handleCloseAddClientModal();
                setSearchQuery('');
                setDebouncedSearch('');
                setSortFilter('newest');
                setShowFilter('active');
                setCurrentPage(1);
            },
            onError: (err)=>{
                const ERROR_MAPPING = {
                    ERR_CLIENT_EXISTS: 'This client is already in your list.',
                    ERR_CANNOT_INVITE_SELF: 'You cannot add yourself as a client.',
                    ERR_FIRST_NAME_REQUIRED: 'First Name is required',
                    ERR_SURNAME_REQUIRED: 'Surname is required',
                    ERR_FIRST_NAME_TOO_LONG: 'First Name must be 50 characters or less',
                    ERR_SURNAME_TOO_LONG: 'Surname must be 50 characters or less',
                    ERR_EMAIL_TOO_LONG: 'Email must be 255 characters or less',
                    ERR_INVALID_FIRST_NAME: 'First Name must contain at least one valid letter',
                    ERR_INVALID_SURNAME: 'Surname must contain at least one valid letter',
                    ERR_INVALID_EMAIL_FORMAT: 'Please enter a valid email address.',
                    ERR_AUTH_CREATION_FAILED: 'Failed to create user account'
                };
                if (err.errorCode && ERROR_MAPPING[err.errorCode]) setErrorMsg(ERROR_MAPPING[err.errorCode]);
                else if (err.message === 'CLIENT_EXISTS' || err?.message?.toLowerCase().includes('already exists')) setErrorMsg('This client is already in your list.');
                else setErrorMsg(err.message || 'Failed to add client. Please try again.');
            }
        });
    };
    const showItems = [
        {
            key: 'active',
            label: 'Active'
        },
        {
            key: 'inactive',
            label: 'Inactive'
        },
        {
            key: 'blocked',
            label: 'Blocked'
        },
        {
            key: 'all',
            label: 'All'
        }
    ];
    const sortItems = [
        {
            key: 'newest',
            label: 'Date (Newest)'
        },
        {
            key: 'oldest',
            label: 'Date (Oldest)'
        },
        {
            key: 'name',
            label: 'Name (A-Z)'
        }
    ];
    const getShowLabel = ()=>showItems.find((i)=>i.key === showFilter)?.label || 'Active';
    const getSortLabel = ()=>sortItems.find((i)=>i.key === sortFilter)?.label || 'Date (Newest)';
    const handleArchiveClient = ()=>{
        if (!clientToArchive) return;
        updateClientStatus({
            clientId: clientToArchive.uid,
            isActive: false,
            isDeleted: false
        }, {
            onSuccess: (res)=>{
                if (res?.code === 'SUCCESS_CLIENT_ARCHIVED') (0, _reactHotToastDefault.default).success(`${clientToArchive.name} ${clientToArchive.surname} successfully archived`, {
                    id: 'archive-client-success'
                });
                else (0, _reactHotToastDefault.default).success('Status updated successfully', {
                    id: 'archive-client-success'
                });
                if (showFilter === 'active') setAllClients((prev)=>prev.filter((c)=>c.uid !== clientToArchive.uid));
                else setAllClients((prev)=>prev.map((c)=>c.uid === clientToArchive.uid ? {
                            ...c,
                            isActive: false
                        } : c));
                setClientToArchive(null);
            }
        });
    };
    const handleActivateClient = ()=>{
        if (!clientToActivate) return;
        updateClientStatus({
            clientId: clientToActivate.uid,
            isActive: true,
            isDeleted: false
        }, {
            onSuccess: (res)=>{
                if (res?.code === 'SUCCESS_CLIENT_UPDATED') (0, _reactHotToastDefault.default).success(`${clientToActivate.name} ${clientToActivate.surname} successfully activated`, {
                    id: 'activate-client-success'
                });
                else (0, _reactHotToastDefault.default).success('Status updated successfully', {
                    id: 'activate-client-success'
                });
                if (showFilter === 'inactive') setAllClients((prev)=>prev.filter((c)=>c.uid !== clientToActivate.uid));
                else setAllClients((prev)=>prev.map((c)=>c.uid === clientToActivate.uid ? {
                            ...c,
                            isActive: true
                        } : c));
                setClientToActivate(null);
            }
        });
    };
    const handleUnblockClient = async ()=>{
        if (!clientToUnblock) return;
        try {
            await unblockClient({
                clientUid: clientToUnblock.uid
            });
            (0, _reactHotToastDefault.default).success(`${clientToUnblock.name} ${clientToUnblock.surname} successfully unblocked`, {
                id: 'unblock-client-success'
            });
            if (showFilter === 'blocked') setAllClients((prev)=>prev.filter((c)=>c.uid !== clientToUnblock.uid));
            else setAllClients((prev)=>prev.map((c)=>c.uid === clientToUnblock.uid ? {
                        ...c,
                        isBlocked: false,
                        is_blocked: false,
                        isActive: true,
                        is_active: true
                    } : c));
            setClientToUnblock(null);
        } catch (err) {
            console.error('Failed to unblock client:', err);
            (0, _reactHotToastDefault.default).error(err.message || 'Failed to unblock client. Please try again.');
        }
    };
    const handleDeleteClient = ()=>{
        if (!clientToDelete) return;
        updateClientStatus({
            clientId: clientToDelete.uid,
            isDeleted: true
        }, {
            onSuccess: (res)=>{
                if (res?.code === 'SUCCESS_CLIENT_DELETED') (0, _reactHotToastDefault.default).success(`${clientToDelete.name} ${clientToDelete.surname} successfully deleted`, {
                    id: 'delete-client-success'
                });
                else (0, _reactHotToastDefault.default).success('Status updated successfully', {
                    id: 'delete-client-success'
                });
                setAllClients((prev)=>prev.filter((c)=>c.uid !== clientToDelete.uid));
                setClientToDelete(null);
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "dashboard-screen client-screen",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "dashboard-top-section desktop-only",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "dashboard-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                children: "Clients"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "header-actions",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    variant: "light",
                                    onClick: ()=>setIsAddClientModalVisible(true),
                                    children: '+ Add Client'
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "dashboard-filter-bar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "filters-left",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                        menu: {
                                            items: showItems,
                                            onClick: (e)=>setShowFilter(e.key)
                                        },
                                        trigger: [
                                            'click'
                                        ],
                                        rootClassName: "dark-theme-dropdown",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "filter-item filter-show",
                                            style: {
                                                cursor: 'pointer'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    children: [
                                                        "Show: ",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: getShowLabel()
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                    width: "12",
                                                    height: "12",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                        points: "6 9 12 15 18 9"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "divider"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "search-input",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "text",
                                                placeholder: "Find client..",
                                                value: searchQuery,
                                                onChange: (e)=>setSearchQuery(e.target.value)
                                            }),
                                            searchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setSearchQuery(''),
                                                className: "clear-search-btn",
                                                "aria-label": "Clear search",
                                                style: {
                                                    background: 'transparent',
                                                    backgroundColor: 'transparent',
                                                    backgroundImage: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    margin: 0,
                                                    outline: 'none',
                                                    appearance: 'none',
                                                    WebkitAppearance: 'none',
                                                    borderRadius: 0,
                                                    boxShadow: 'none',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer',
                                                    color: '#838e9e',
                                                    width: 20,
                                                    height: 20,
                                                    minWidth: 'unset',
                                                    minHeight: 'unset',
                                                    flexShrink: 0
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                    width: "14",
                                                    height: "14",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    style: {
                                                        display: 'block',
                                                        margin: 0,
                                                        pointerEvents: 'none'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                            x1: "18",
                                                            y1: "6",
                                                            x2: "6",
                                                            y2: "18"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                            x1: "6",
                                                            y1: "6",
                                                            x2: "18",
                                                            y2: "18"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "filters-right",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "filter-label",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Filters:'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                        menu: {
                                            items: sortItems,
                                            onClick: (e)=>setSortFilter(e.key)
                                        },
                                        trigger: [
                                            'click'
                                        ],
                                        rootClassName: "dark-theme-dropdown",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "filter-item filter-sort",
                                            style: {
                                                cursor: 'pointer'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    children: [
                                                        "Sort: ",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: getSortLabel()
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                    width: "12",
                                                    height: "12",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                        points: "6 9 12 15 18 9"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "view-toggles",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: `toggle-btn ${viewMode === 'grid' ? 'active' : ''}`,
                                                onClick: ()=>setViewMode('grid'),
                                                "aria-label": "Grid view",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuSvg.ReactComponent), {
                                                    viewBox: "0 0 24 24"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: `toggle-btn ${viewMode === 'list' ? 'active' : ''}`,
                                                onClick: ()=>setViewMode('list'),
                                                "aria-label": "List view",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listSvg.ReactComponent), {
                                                    viewBox: "0 0 24 24"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mobile-only",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "dashboard-top-section",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "dashboard-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        children: "Clients"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "header-actions",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            variant: "light",
                                            onClick: ()=>setIsAddClientModalVisible(true),
                                            children: '+ Add'
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "dashboard-filter-bar",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "filter-label",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Filters:'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "filter-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                                menu: {
                                                    items: showItems,
                                                    onClick: (e)=>setShowFilter(e.key)
                                                },
                                                trigger: [
                                                    'click'
                                                ],
                                                rootClassName: "dark-theme-dropdown",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "filter-item filter-show",
                                                    style: {
                                                        cursor: 'pointer'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            children: [
                                                                "Show: ",
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "value",
                                                                    children: getShowLabel()
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            width: "12",
                                                            height: "12",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                                points: "6 9 12 15 18 9"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                                menu: {
                                                    items: sortItems,
                                                    onClick: (e)=>setSortFilter(e.key)
                                                },
                                                trigger: [
                                                    'click'
                                                ],
                                                rootClassName: "dark-theme-dropdown",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "filter-item filter-sort",
                                                    style: {
                                                        cursor: 'pointer'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            children: [
                                                                "Sort: ",
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "value",
                                                                    children: getSortLabel()
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            width: "12",
                                                            height: "12",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                                points: "6 9 12 15 18 9"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "dashboard-search-section",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "filter-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "search-input",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchSvg.ReactComponent), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            placeholder: "Find client..",
                                            value: searchQuery,
                                            onChange: (e)=>setSearchQuery(e.target.value)
                                        }),
                                        searchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setSearchQuery(''),
                                            className: "clear-search-btn",
                                            "aria-label": "Clear search",
                                            style: {
                                                background: 'transparent',
                                                backgroundColor: 'transparent',
                                                backgroundImage: 'none',
                                                border: 'none',
                                                padding: 0,
                                                margin: 0,
                                                outline: 'none',
                                                appearance: 'none',
                                                WebkitAppearance: 'none',
                                                borderRadius: 0,
                                                boxShadow: 'none',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                color: '#838e9e',
                                                width: 20,
                                                height: 20,
                                                minWidth: 'unset',
                                                minHeight: 'unset',
                                                flexShrink: 0
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                style: {
                                                    display: 'block',
                                                    margin: 0,
                                                    pointerEvents: 'none'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                        x1: "18",
                                                        y1: "6",
                                                        x2: "6",
                                                        y2: "18"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                        x1: "6",
                                                        y1: "6",
                                                        x2: "18",
                                                        y2: "18"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "view-toggles",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `toggle-btn ${viewMode === 'grid' ? 'active' : ''}`,
                                            onClick: ()=>setViewMode('grid'),
                                            "aria-label": "Grid view",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuSvg.ReactComponent), {
                                                viewBox: "0 0 24 24"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `toggle-btn ${viewMode === 'list' ? 'active' : ''}`,
                                            onClick: ()=>setViewMode('list'),
                                            "aria-label": "List view",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listSvg.ReactComponent), {
                                                viewBox: "0 0 24 24"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            isLoading && allClients.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "loading-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                        indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                            className: "loading-icon",
                            spin: true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "loading-text",
                        children: "Loading clients"
                    })
                ]
            }) : allClients.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `client-cards-container ${viewMode === 'grid' ? 'grid-view' : 'list-view'}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactInfiniteScrollComponentDefault.default), {
                    dataLength: allClients.length,
                    next: ()=>setCurrentPage((prev)=>prev + 1),
                    hasMore: allClients.length < totalCount,
                    loader: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "loading-container",
                        style: {
                            padding: '20px 0',
                            minHeight: 'auto',
                            flex: 'none'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                    className: "loading-icon",
                                    spin: true
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "loading-text",
                                children: "Loading more clients"
                            })
                        ]
                    }),
                    scrollableTarget: "scrollableDashboardMain",
                    className: "infinite-scroll-content",
                    children: allClients.map((client)=>{
                        const isBlocked = Boolean(client.isBlocked || client.is_blocked);
                        const isActive = !isBlocked && client.isActive !== false && client.is_active !== false;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "client-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "client-info-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "client-avatar",
                                            children: getInitials(client.name, client.surname)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "client-details",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "client-name-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                                            children: [
                                                                client.name,
                                                                " ",
                                                                client.surname
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: `status-badge ${isBlocked ? 'blocked' : isActive ? 'active' : 'inactive'}`,
                                                            children: isBlocked ? 'BLOCKED' : isActive ? 'ACTIVE' : 'INACTIVE'
                                                        })
                                                    ]
                                                }),
                                                client.email && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "client-email-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardEmailSvg.ReactComponent), {}),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: client.email
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "client-action-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "action-icons",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "icon-btn delete-btn",
                                                    onClick: ()=>setClientToDelete(client),
                                                    title: "Delete Client",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardDeleteSvg.ReactComponent), {})
                                                }),
                                                isBlocked ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "icon-btn unblock-btn",
                                                    onClick: ()=>setClientToUnblock(client),
                                                    title: "Unblock Client",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                                x: "3",
                                                                y: "11",
                                                                width: "18",
                                                                height: "11",
                                                                rx: "2",
                                                                ry: "2"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M7 11V7a5 5 0 0 1 9.9-1"
                                                            })
                                                        ]
                                                    })
                                                }) : isActive ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "icon-btn archive-btn",
                                                    onClick: ()=>setClientToArchive(client),
                                                    title: "Archive Client",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardArchiveSvg.ReactComponent), {})
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "icon-btn archive-btn",
                                                    onClick: ()=>setClientToActivate(client),
                                                    title: "Activate Client",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardArchiveSvg.ReactComponent), {
                                                        style: {
                                                            transform: 'rotate(180deg)'
                                                        }
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "button-group",
                                            children: [
                                                isBlocked ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "primary-action-btn unblock-primary-btn",
                                                    onClick: ()=>setClientToUnblock(client),
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "onboard-text-wrapper",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: "Unblock Client"
                                                        })
                                                    })
                                                }) : isActive && !client.isFitnessComplete && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                    className: "primary-action-btn",
                                                    onClick: ()=>{
                                                        setOnboardingClient(client);
                                                        setIsOnboardingModalVisible(true);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "onboard",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardOnboardSvg.ReactComponent), {})
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "onboard-text-wrapper",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: "Start Onboarding"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                !isBlocked && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                    className: "secondary-action-btn",
                                                    onClick: ()=>navigate(`/onboarding-trainer/dashboard/clients/${client?.uid}/overview`),
                                                    children: [
                                                        "View ",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardViewArrowSvg.ReactComponent), {})
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }, client.uid);
                    })
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "dashboard-empty-state",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "empty-icon",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: debouncedSearch ? `No results found for "${debouncedSearch}"` : showFilter === 'blocked' ? 'No blocked clients.' : showFilter === 'inactive' ? 'No inactive clients yet.' : 'No clients yet'
                    }),
                    showFilter !== 'inactive' && showFilter !== 'blocked' && !debouncedSearch && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Add your first client to get started"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: "light",
                                style: {
                                    color: '#000',
                                    padding: '14px 24px',
                                    borderRadius: '8px',
                                    minHeight: 'auto'
                                },
                                onClick: ()=>setIsAddClientModalVisible(true),
                                children: '+ Add Your First Client'
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: isAddClientModalVisible,
                footer: null,
                onCancel: handleCloseAddClientModal,
                centered: true,
                width: 480,
                closeIcon: null,
                rootClassName: "add-client-modal",
                className: "add-client-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "add-client-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Add New Client"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Enter your client's information"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group body-profile-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    children: 'BODY PROFILE'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "gender-selection",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: "gender-option",
                                            onClick: ()=>{
                                                setNewClientBodyProfile('female');
                                                if (touchedFields.bodyProfile) setFieldErrors((prev)=>({
                                                        ...prev,
                                                        bodyProfile: ''
                                                    }));
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `checkbox-custom ${newClientBodyProfile === 'female' ? 'checked' : ''}`,
                                                    children: newClientBodyProfile === 'female' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        width: "12",
                                                        height: "12",
                                                        viewBox: "0 0 12 12",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M10 3L4.5 8.5L2 6",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Female"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                            className: "gender-option",
                                            onClick: ()=>{
                                                setNewClientBodyProfile('male');
                                                if (touchedFields.bodyProfile) setFieldErrors((prev)=>({
                                                        ...prev,
                                                        bodyProfile: ''
                                                    }));
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `checkbox-custom ${newClientBodyProfile === 'male' ? 'checked' : ''}`,
                                                    children: newClientBodyProfile === 'male' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        width: "12",
                                                        height: "12",
                                                        viewBox: "0 0 12 12",
                                                        fill: "none",
                                                        xmlns: "http://www.w3.org/2000/svg",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                            d: "M10 3L4.5 8.5L2 6",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Male"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                fieldErrors.bodyProfile && touchedFields.bodyProfile && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    style: {
                                        color: '#ff4d4f',
                                        fontSize: '12px',
                                        marginTop: '4px'
                                    },
                                    children: fieldErrors.bodyProfile
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "input-wrapper",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    children: "First Name"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "text",
                                                    placeholder: "First Name",
                                                    maxLength: 50,
                                                    value: newClientName,
                                                    onChange: (e)=>{
                                                        setNewClientName(e.target.value);
                                                        if (touchedFields.name) setFieldErrors((prev)=>({
                                                                ...prev,
                                                                name: validateName(e.target.value)
                                                            }));
                                                    },
                                                    onBlur: (e)=>{
                                                        setNewClientName(e.target.value.trim());
                                                        setTouchedFields((prev)=>({
                                                                ...prev,
                                                                name: true
                                                            }));
                                                        setFieldErrors((prev)=>({
                                                                ...prev,
                                                                name: validateName(e.target.value.trim())
                                                            }));
                                                    },
                                                    style: fieldErrors.name && touchedFields.name ? {
                                                        border: '1px solid #ff4d4f'
                                                    } : {}
                                                }),
                                                fieldErrors.name && touchedFields.name && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    style: {
                                                        color: '#ff4d4f',
                                                        fontSize: '12px',
                                                        marginTop: '4px'
                                                    },
                                                    children: fieldErrors.name
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "input-wrapper",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    children: "Surname"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "text",
                                                    placeholder: "Surname",
                                                    maxLength: 50,
                                                    value: newClientSurname,
                                                    onChange: (e)=>{
                                                        setNewClientSurname(e.target.value);
                                                        if (touchedFields.surname) setFieldErrors((prev)=>({
                                                                ...prev,
                                                                surname: validateSurname(e.target.value)
                                                            }));
                                                    },
                                                    onBlur: (e)=>{
                                                        setNewClientSurname(e.target.value.trim());
                                                        setTouchedFields((prev)=>({
                                                                ...prev,
                                                                surname: true
                                                            }));
                                                        setFieldErrors((prev)=>({
                                                                ...prev,
                                                                surname: validateSurname(e.target.value.trim())
                                                            }));
                                                    },
                                                    style: fieldErrors.surname && touchedFields.surname ? {
                                                        border: '1px solid #ff4d4f'
                                                    } : {}
                                                }),
                                                fieldErrors.surname && touchedFields.surname && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    style: {
                                                        color: '#ff4d4f',
                                                        fontSize: '12px',
                                                        marginTop: '4px'
                                                    },
                                                    children: fieldErrors.surname
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "input-wrapper",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            children: "Email (Optional)"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "email",
                                            placeholder: "john.doe@example.com",
                                            maxLength: 255,
                                            value: newClientEmail,
                                            onChange: (e)=>{
                                                setNewClientEmail(e.target.value);
                                                if (touchedFields.email) setFieldErrors((prev)=>({
                                                        ...prev,
                                                        email: validateEmail(e.target.value)
                                                    }));
                                            },
                                            onBlur: (e)=>{
                                                setNewClientEmail(e.target.value.trim());
                                                setTouchedFields((prev)=>({
                                                        ...prev,
                                                        email: true
                                                    }));
                                                setFieldErrors((prev)=>({
                                                        ...prev,
                                                        email: validateEmail(e.target.value.trim())
                                                    }));
                                            },
                                            style: fieldErrors.email && touchedFields.email ? {
                                                border: '1px solid #ff4d4f'
                                            } : {}
                                        }),
                                        fieldErrors.email && touchedFields.email && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                color: '#ff4d4f',
                                                fontSize: '12px',
                                                marginTop: '4px'
                                            },
                                            children: fieldErrors.email
                                        })
                                    ]
                                })
                            ]
                        }),
                        errorMsg && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "error-message",
                            style: {
                                color: '#ff4d4f',
                                margin: '-16px 0 16px'
                            },
                            children: errorMsg
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-cancel",
                                    onClick: handleCloseAddClientModal,
                                    disabled: isAdding,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-save",
                                    onClick: handleSaveClient,
                                    disabled: isAdding,
                                    isLoading: isAdding,
                                    children: "Save"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: isOnboardingModalVisible,
                footer: null,
                onCancel: ()=>setIsOnboardingModalVisible(false),
                centered: true,
                width: 682,
                closeIcon: null,
                rootClassName: "onboarding-modal",
                className: "onboarding-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "onboarding-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    children: "Client Onboarding"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        "for",
                                        ' ',
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            children: [
                                                onboardingClient?.name,
                                                " ",
                                                onboardingClient?.surname
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "info-box",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "info-icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardModalInfoSvg.ReactComponent), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "info-text",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Before You Begin"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: "Onboarding a client can take a few minutes. You'll need some information about the client to complete this process. Make sure you've had the first consultation with the client so you can answer the onboarding questions accurately."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "requirements-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    children: "What You'll Need:"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "requirements-grid",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "requirement-item",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardModalPointSvg.ReactComponent), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Basic client information"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "requirement-item",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardModalPointSvg.ReactComponent), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Health and fitness goals"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "requirement-item",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardModalPointSvg.ReactComponent), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Medical history and injuries"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "requirement-item",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardModalPointSvg.ReactComponent), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Current fitness level"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "requirement-item",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardModalPointSvg.ReactComponent), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Available equipment"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "requirement-item",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardModalPointSvg.ReactComponent), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Schedule and preferences"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setIsOnboardingModalVisible(false),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-continue",
                                    onClick: ()=>{
                                        if (onboardingClient?.uid) {
                                            navigate(`/onboarding-trainer/dashboard/program-generator/ai?clientId=${onboardingClient.uid}&step=energy-level&onboardingOnly=true`);
                                            setIsOnboardingModalVisible(false);
                                        }
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            "Continue with Onboarding ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardOnboardArrowSvg.ReactComponent), {})
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "footer-text",
                            children: "You can save your progress and return to complete the onboarding later"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: !!clientToDelete,
                footer: null,
                onCancel: ()=>setClientToDelete(null),
                centered: true,
                width: 400,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardModalDeleteSvg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Delete Client?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                "Are you sure you want to delete ",
                                clientToDelete?.name,
                                " ",
                                clientToDelete?.surname,
                                "?"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-logout",
                                    disabled: isUpdatingStatus,
                                    onClick: handleDeleteClient,
                                    isLoading: isUpdatingStatus,
                                    children: "Delete"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-cancel",
                                    onClick: ()=>setClientToDelete(null),
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: !!clientToArchive,
                footer: null,
                onCancel: ()=>setClientToArchive(null),
                centered: true,
                width: 400,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardModalArchiveSvg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Archive Client?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                "Are you sure you want to archive",
                                ' ',
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                    children: [
                                        clientToArchive?.name,
                                        " ",
                                        clientToArchive?.surname
                                    ]
                                }),
                                "?"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-logout",
                                    disabled: isUpdatingStatus,
                                    onClick: handleArchiveClient,
                                    isLoading: isUpdatingStatus,
                                    children: "Archive"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    variant: "light",
                                    className: "btn-cancel",
                                    onClick: ()=>setClientToArchive(null),
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: !!clientToActivate,
                footer: null,
                onCancel: ()=>setClientToActivate(null),
                centered: true,
                width: 400,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardModalArchiveSvg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Activate Client?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                "Are you sure you want to activate",
                                ' ',
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                    children: [
                                        clientToActivate?.name,
                                        " ",
                                        clientToActivate?.surname
                                    ]
                                }),
                                "?"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-logout",
                                    disabled: isUpdatingStatus,
                                    onClick: handleActivateClient,
                                    isLoading: isUpdatingStatus,
                                    children: "Activate"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    variant: "light",
                                    className: "btn-cancel",
                                    onClick: ()=>setClientToActivate(null),
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: !!clientToUnblock,
                footer: null,
                onCancel: ()=>!isUnblocking && setClientToUnblock(null),
                centered: true,
                width: 400,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper unblock-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: "28",
                                height: "28",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "#ffa100",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                        x: "3",
                                        y: "11",
                                        width: "18",
                                        height: "11",
                                        rx: "2",
                                        ry: "2"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M7 11V7a5 5 0 0 1 9.9-1"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Unblock Client?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                "Are you sure you want to unblock",
                                ' ',
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                    children: [
                                        clientToUnblock?.name,
                                        " ",
                                        clientToUnblock?.surname
                                    ]
                                }),
                                "? This will restore their messages, chat, and program access."
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-logout unblock-confirm-btn",
                                    disabled: isUnblocking,
                                    onClick: handleUnblockClient,
                                    isLoading: isUnblocking,
                                    children: "Unblock"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    variant: "light",
                                    className: "btn-cancel",
                                    onClick: ()=>setClientToUnblock(null),
                                    disabled: isUnblocking,
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-hot-toast":"3T0Wh","../../../../components/Button/Button":"jLE7r","antd":[["Dropdown","cMU6A","default"],["Modal","kY4DD","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"react-router-dom":"f3cgC","src/api/mutations/useGetTrainerClients":"18nHc","src/api/mutations/useAddTrainerClient":"7Y55Y","src/api/mutations/useUpdateClientStatus":"1sZJL","src/api/mutations/useUnblockClient":"bm367","../../DashboardScreens.scss":"lYzMQ","./Clients.scss":"EGCI2","react-infinite-scroll-component":"jrRfZ","../../../../../../assets/images/onboarding-trainer/dashboard/clients/client.svg":"btqky","../../../../../../assets/images/onboarding-trainer/dashboard/clients/filter.svg":"3x6cI","../../../../../../assets/images/onboarding-trainer/dashboard/clients/search.svg":"1z49p","../../../../../../assets/images/onboarding-trainer/dashboard/list.svg":"9VO1i","../../../../../../assets/images/onboarding-trainer/dashboard/menu.svg":"3WSyH","src/assets/images/trainer/clients/dashboard-modal-archive.svg":"iJaEv","src/assets/images/trainer/clients/dashboard-modal-delete.svg":"4NTEi","src/assets/images/trainer/clients/dashboard-archive.svg":"aTlfZ","src/assets/images/trainer/clients/dashboard-onboard.svg":"8P2xD","src/assets/images/trainer/clients/dashboard-onboard-arrow.svg":"deNJx","src/assets/images/trainer/clients/dashboard-delete.svg":"gvFKh","src/assets/images/trainer/clients/dashboard-email.svg":"fJoDx","src/assets/images/trainer/clients/dashboard-view-arrow.svg":"c6iRs","src/assets/images/trainer/clients/onboard-modal-info.svg":"8c7At","src/assets/images/trainer/clients/onboard-modal-point.svg":"hYbGA","src/utils/validation":"1NJZx","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"18nHc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchTrainerClients", ()=>fetchTrainerClients);
parcelHelpers.export(exports, "useGetTrainerClients", ()=>useGetTrainerClients);
/**
 * Fetches a single client by their UID using the backend's clientId filter.
 * Only enabled when clientId is provided.
 */ parcelHelpers.export(exports, "useGetTrainerClientById", ()=>useGetTrainerClientById);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _deepCamelCaseKeys = require("src/utils/deepCamelCaseKeys");
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
const fetchTrainerClients = async ({ trainerId, status, search, sortBy, page, limit, clientId })=>{
    if (!trainerId) throw new Error('Trainer ID is missing');
    const queryParams = new URLSearchParams({
        trainerId,
        status,
        search,
        sort: sortBy,
        page: page.toString()
    });
    if (limit) queryParams.append('limit', limit.toString());
    if (clientId) queryParams.append('clientId', clientId);
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_CLIENTS}?${queryParams.toString()}`;
    const response = await fetch(apiUrl);
    if (!response.ok) throw new Error(`Failed to fetch trainer clients: ${response.status}`);
    const res = await response.json();
    const parsedData = (0, _deepCamelCaseKeys.deepCamelCaseKeys)(res.data);
    return {
        clients: parsedData,
        totalCount: res.totalCount || 0,
        page: res.page || 1,
        limit: res.limit || 20
    };
};
function useGetTrainerClients(status = 'active', search = '', sortBy = 'newest', page = 1, limit = 10) {
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const trainerId = currentUser?.uid || (0, _firebase.auth).currentUser?.uid;
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'trainer-clients',
            trainerId,
            status,
            search,
            sortBy,
            page,
            limit
        ],
        queryFn: ()=>fetchTrainerClients({
                trainerId: trainerId,
                status,
                search,
                sortBy,
                page,
                limit
            }),
        enabled: !!trainerId
    });
}
function useGetTrainerClientById(clientId) {
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const trainerId = currentUser?.uid || (0, _firebase.auth).currentUser?.uid;
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'trainer-client-by-id',
            trainerId,
            clientId
        ],
        queryFn: ()=>fetchTrainerClients({
                trainerId: trainerId,
                status: 'all',
                search: '',
                sortBy: 'newest',
                page: 1,
                limit: 1,
                clientId
            }),
        enabled: !!trainerId && !!clientId,
        staleTime: 300000
    });
}

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","src/utils/deepCamelCaseKeys":"9w8Oj","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7Y55Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addTrainerClient", ()=>addTrainerClient);
parcelHelpers.export(exports, "useAddTrainerClient", ()=>useAddTrainerClient);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
const addTrainerClient = async (payload)=>{
    const currentUser = (0, _sessionStore.sessionStore).getState().currentUser;
    const trainerId = currentUser?.uid || (0, _firebase.auth).currentUser?.uid;
    if (!trainerId) throw new Error('Trainer ID is missing');
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_ADD_CLIENT}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...payload,
            trainerId
        })
    });
    if (!response.ok) {
        let errorMessage = `Failed to add trainer client: ${response.status}`;
        let errorCode = 'ERR_UNKNOWN';
        try {
            const errorData = await response.json();
            if (errorData.errorCode) errorCode = errorData.errorCode;
            if (errorData.error) errorMessage = errorData.error;
        } catch (e) {
            // Ignore json parse error
            console.error('Error adding trainer client', e);
        }
        const error = new Error(errorMessage);
        error.errorCode = errorCode;
        throw error;
    }
    return response.json();
};
function useAddTrainerClient() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: addTrainerClient,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-clients'
                ]
            });
        }
    });
}

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"src/config/api-config":"9oD3c","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1sZJL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updateClientStatus", ()=>updateClientStatus);
parcelHelpers.export(exports, "useUpdateClientStatus", ()=>useUpdateClientStatus);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
const updateClientStatus = async (payload)=>{
    const currentUser = (0, _sessionStore.sessionStore).getState().currentUser;
    const trainerId = currentUser?.uid || (0, _firebase.auth).currentUser?.uid;
    if (!trainerId) throw new Error('Trainer ID is missing');
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_UPDATE_CLIENT_STATUS}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...payload,
            trainerId
        })
    });
    if (!response.ok) {
        let errorMessage = `Failed to update client status: ${response.status}`;
        let errorCode = 'ERR_UNKNOWN';
        try {
            const errorData = await response.json();
            if (errorData.errorCode) errorCode = errorData.errorCode;
            if (errorData.error) errorMessage = errorData.error;
        } catch (e) {
            // Ignore json parse error
            console.error('Error updating client status', e);
        }
        const error = new Error(errorMessage);
        error.errorCode = errorCode;
        throw error;
    }
    return response.json();
};
function useUpdateClientStatus() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: updateClientStatus,
        onSuccess: ()=>{
            const currentUser = (0, _sessionStore.sessionStore).getState().currentUser;
            const trainerId = currentUser?.uid;
            if (trainerId) // Invalidate trainer clients list so the UI refreshes
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-clients',
                    trainerId
                ]
            });
        }
    });
}

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"src/config/api-config":"9oD3c","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bm367":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUnblockClientMutation", ()=>(0, _supportReports.useUnblockClientMutation));
parcelHelpers.export(exports, "unblockClientApi", ()=>(0, _supportReports.unblockClientApi));
var _supportReports = require("src/api/supportReports");

},{"src/api/supportReports":"3GxXz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3GxXz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "submitSupportReportApi", ()=>submitSupportReportApi);
parcelHelpers.export(exports, "useSubmitSupportReportMutation", ()=>useSubmitSupportReportMutation);
parcelHelpers.export(exports, "blockClientApi", ()=>blockClientApi);
parcelHelpers.export(exports, "useBlockClientMutation", ()=>useBlockClientMutation);
parcelHelpers.export(exports, "unblockClientApi", ()=>unblockClientApi);
parcelHelpers.export(exports, "useUnblockClientMutation", ()=>useUnblockClientMutation);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _firebase = require("src/config/firebase");
const getAuthToken = async ()=>{
    const currentUser = (0, _firebase.auth).currentUser;
    if (!currentUser) throw new Error('User is not authenticated');
    return await currentUser.getIdToken(true);
};
const submitSupportReportApi = async (payload)=>{
    const token = await getAuthToken();
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_SUBMIT_SUPPORT_REPORT}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            chat_id: payload.chatId,
            reported_uid: payload.reportedUid,
            category: payload.category,
            details: payload.details,
            screenshots: payload.screenshots
        })
    });
    if (!response.ok) {
        const errData = await response.json().catch(()=>null);
        throw new Error(errData?.error?.message || `Failed to submit report: ${response.status}`);
    }
    return response.json();
};
const useSubmitSupportReportMutation = ()=>{
    return (0, _reactQuery.useMutation)({
        mutationFn: submitSupportReportApi
    });
};
const blockClientApi = async (payload)=>{
    const token = await getAuthToken();
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_BLOCK_CLIENT}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            client_uid: payload.clientUid,
            chat_id: payload.chatId,
            reason: payload.reason
        })
    });
    if (!response.ok) {
        const errData = await response.json().catch(()=>null);
        throw new Error(errData?.error?.message || `Failed to block client: ${response.status}`);
    }
    return response.json();
};
const useBlockClientMutation = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: blockClientApi,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-clients'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'inquiries'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'chats'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'checkins'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-messages-page'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-program-plan-list'
                ]
            });
        }
    });
};
const unblockClientApi = async (payload)=>{
    const token = await getAuthToken();
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_UNBLOCK_CLIENT}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            client_uid: payload.clientUid
        })
    });
    if (!response.ok) {
        const errData = await response.json().catch(()=>null);
        throw new Error(errData?.error?.message || `Failed to unblock client: ${response.status}`);
    }
    return response.json();
};
const useUnblockClientMutation = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: unblockClientApi,
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-clients'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'inquiries'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'chats'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'checkins'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-messages-page'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-program-plan-list'
                ]
            });
        }
    });
};

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"src/config/api-config":"9oD3c","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lYzMQ":[function() {},{}],"EGCI2":[function() {},{}],"jrRfZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>InfiniteScroll);
parcelHelpers.export(exports, "useInfiniteScroll", ()=>useInfiniteScroll);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const ThresholdUnits = {
    Pixel: 'Pixel',
    Percent: 'Percent'
};
const defaultThreshold = {
    unit: ThresholdUnits.Percent,
    value: 80
};
function parseThreshold(scrollThreshold) {
    if (typeof scrollThreshold === 'number') return {
        unit: ThresholdUnits.Percent,
        value: scrollThreshold * 100
    };
    if (typeof scrollThreshold === 'string') {
        if (/^(\d*(\.\d+)?)px$/.exec(scrollThreshold)) return {
            unit: ThresholdUnits.Pixel,
            value: parseFloat(scrollThreshold)
        };
        if (/^(\d*(\.\d+)?)%$/.exec(scrollThreshold)) return {
            unit: ThresholdUnits.Percent,
            value: parseFloat(scrollThreshold)
        };
        console.warn('scrollThreshold format is invalid. Valid formats: "120px", "50%"...');
        return defaultThreshold;
    }
    console.warn('scrollThreshold should be string or number');
    return defaultThreshold;
}
/**
 * Converts a scrollThreshold value into a CSS rootMargin string for IntersectionObserver.
 *
 * scrollThreshold represents "how far down the page before triggering" (e.g. 0.8 = 80%).
 * IntersectionObserver's rootMargin extends the root's bounding box so the sentinel is
 * detected before it actually enters the visible area.
 *
 * For a percentage threshold (e.g. 0.8 → 80%):
 *   remaining = 100% - 80% = 20% → rootMargin bottom = "20%"
 *
 * For a pixel threshold (e.g. "120px"):
 *   rootMargin bottom = "120px"
 *
 * Note: rootMargin percentages are relative to the root element's own dimensions, not
 * scrollHeight. This is a close approximation of the original scroll-event behavior and
 * is an intentional tradeoff for the performance benefit.
 *
 * For inverse mode the margin is applied to the top instead of the bottom.
 */ function buildRootMargin(scrollThreshold, inverse) {
    const threshold = parseThreshold(scrollThreshold);
    let margin;
    if (threshold.unit === ThresholdUnits.Pixel) margin = `${threshold.value}px`;
    else {
        // threshold.value is already in percent (e.g. 80 for 0.8 input)
        const remaining = 100 - threshold.value;
        margin = `${remaining}%`;
    }
    return inverse ? `${margin} 0px 0px 0px` : `0px 0px ${margin} 0px`;
}
/**
 * Low-level hook for building custom infinite scroll UIs.
 *
 * Manages an IntersectionObserver that watches a sentinel element you place
 * at the end of your list. When the sentinel enters the viewport, next() is
 * called. The hook handles deduplication and resets automatically when
 * dataLength changes.
 *
 * Use the InfiniteScroll component instead if you want a ready-made wrapper
 * with built-in loader, endMessage, pull-to-refresh, and inverse scroll UI.
 *
 * @example Basic usage
 * ```tsx
 * function Feed() {
 *   const [items, setItems] = useState(initialItems);
 *   const [hasMore, setHasMore] = useState(true);
 *
 *   const { sentinelRef, isLoading } = useInfiniteScroll({
 *     next: async () => {
 *       const more = await fetchItems(items.length);
 *       if (more.length === 0) { setHasMore(false); return; }
 *       setItems(prev => [...prev, ...more]);
 *     },
 *     hasMore,
 *     dataLength: items.length,
 *   });
 *
 *   return (
 *     <ul>
 *       {items.map(item => <li key={item.id}>{item.name}</li>)}
 *       <li ref={sentinelRef} aria-hidden />
 *       {isLoading && <li>Loading...</li>}
 *     </ul>
 *   );
 * }
 * ```
 */ function useInfiniteScroll({ next, hasMore, dataLength, scrollThreshold = 0.8, scrollableTarget, inverse = false }) {
    const [isLoading, setIsLoading] = (0, _react.useState)(false);
    const sentinelRef = (0, _react.useRef)(null);
    const actionTriggeredRef = (0, _react.useRef)(false);
    // Stable ref so the observer callback always calls the latest next()
    // without triggering observer reconnection when an inline function is passed.
    const nextRef = (0, _react.useRef)(next);
    nextRef.current = next;
    const getScrollableNode = (0, _react.useCallback)(()=>{
        if (scrollableTarget instanceof HTMLElement) return scrollableTarget;
        if (typeof scrollableTarget === 'string') return document.getElementById(scrollableTarget);
        return null;
    }, [
        scrollableTarget
    ]);
    // Reset the load guard when new data arrives.
    (0, _react.useEffect)(()=>{
        actionTriggeredRef.current = false;
        setIsLoading(false);
    }, [
        dataLength
    ]);
    // IntersectionObserver lifecycle.
    (0, _react.useEffect)(()=>{
        if (!hasMore) return;
        if (typeof IntersectionObserver === 'undefined') return;
        const sentinel = sentinelRef.current;
        if (!sentinel) return;
        const root = getScrollableNode();
        const observer = new IntersectionObserver(([entry])=>{
            if (!entry.isIntersecting || actionTriggeredRef.current) return;
            actionTriggeredRef.current = true;
            setIsLoading(true);
            nextRef.current();
        }, {
            root,
            rootMargin: buildRootMargin(scrollThreshold, inverse),
            threshold: 0
        });
        observer.observe(sentinel);
        return ()=>observer.disconnect();
    }, [
        hasMore,
        scrollThreshold,
        inverse,
        getScrollableNode
    ]);
    return {
        sentinelRef,
        isLoading
    };
}
function InfiniteScroll({ next, hasMore, children, loader, scrollThreshold = 0.8, endMessage, style, height, scrollableTarget, hasChildren, inverse = false, pullDownToRefresh = false, pullDownToRefreshContent, releaseToRefreshContent, pullDownToRefreshThreshold = 100, refreshFunction, onScroll, dataLength, initialScrollY, className = '', role, tabIndex, id, ...ariaProps }) {
    const [showLoader, setShowLoader] = (0, _react.useState)(false);
    const [pullToRefreshThresholdBreached, setPullToRefreshThresholdBreached] = (0, _react.useState)(false);
    // State drives the JSX re-render when height is measured; ref is read by handlers
    const [maxPullDownDistance, setMaxPullDownDistance] = (0, _react.useState)(0);
    const infScrollRef = (0, _react.useRef)(null);
    const sentinelRef = (0, _react.useRef)(null);
    const pullDownRef = (0, _react.useRef)(null);
    // --- Stable callback refs ---
    // Assigned synchronously every render so effects and event handlers always call
    // the latest version without adding the functions to any effect dependency array.
    // This prevents the IO observer and PTR listeners from being recreated every time
    // consumers pass inline functions (the most common real-world usage).
    const nextRef = (0, _react.useRef)(next);
    nextRef.current = next;
    const refreshFunctionRef = (0, _react.useRef)(refreshFunction);
    refreshFunctionRef.current = refreshFunction;
    // Ref for pullDownToRefreshThreshold so onMove always reads the current value
    // without needing it in the PTR effect deps
    const pullThresholdRef = (0, _react.useRef)(pullDownToRefreshThreshold);
    pullThresholdRef.current = pullDownToRefreshThreshold;
    // --- Mutable refs — never trigger re-renders ---
    const actionTriggeredRef = (0, _react.useRef)(false);
    const draggingRef = (0, _react.useRef)(false);
    const startYRef = (0, _react.useRef)(0);
    const currentYRef = (0, _react.useRef)(0);
    const maxPullDownDistanceRef = (0, _react.useRef)(0); // kept in sync with maxPullDownDistance state
    // Resolve the custom scrollable element; stable as long as scrollableTarget doesn't change
    const getScrollableNode = (0, _react.useCallback)(()=>{
        if (scrollableTarget instanceof HTMLElement) return scrollableTarget;
        if (typeof scrollableTarget === 'string') return document.getElementById(scrollableTarget);
        if (scrollableTarget === null) console.warn(`You are trying to pass scrollableTarget but it is null. This might
        happen because the element may not have been added to DOM yet.
        See https://github.com/ankeetmaini/react-infinite-scroll-component/issues/59 for more info.
      `);
        return null;
    }, [
        scrollableTarget
    ]);
    // Effect 1 — one-time validation and initialScrollY
    (0, _react.useEffect)(()=>{
        if (typeof dataLength === 'undefined') throw new Error(`mandatory prop "dataLength" is missing. The prop is needed` + ` when loading more content. Check README.md for usage`);
        if (pullDownToRefresh && typeof refreshFunction !== 'function') throw new Error(`Mandatory prop "refreshFunction" missing.
          Pull Down To Refresh functionality will not work
          as expected. Check README.md for usage'`);
        if (typeof initialScrollY === 'number') {
            const el = height ? infScrollRef.current : getScrollableNode();
            if (el && el.scrollHeight > initialScrollY) el.scrollTo(0, initialScrollY);
        }
    }, []);
    // Effect 2a — reset the load guard when new data arrives.
    // Deliberately decoupled from the IO observer (Effect 2b) so the observer
    // is NOT recreated on every data load — it lives for the component's full
    // mount lifetime and only reconnects when structural config changes.
    (0, _react.useEffect)(()=>{
        actionTriggeredRef.current = false;
        setShowLoader(false);
    }, [
        dataLength
    ]);
    // Effect 2b — IntersectionObserver lifecycle.
    // dataLength is intentionally absent from deps: the guard reset above handles
    // the per-load reset. The observer only reconnects when the root, margin, or
    // direction changes — typically never after initial mount.
    (0, _react.useEffect)(()=>{
        if (!hasMore) return;
        if (typeof IntersectionObserver === 'undefined') return;
        const sentinel = sentinelRef.current;
        if (!sentinel) return;
        const root = height ? infScrollRef.current : getScrollableNode();
        const observer = new IntersectionObserver(([entry])=>{
            if (!entry.isIntersecting || actionTriggeredRef.current) return;
            actionTriggeredRef.current = true;
            setShowLoader(true);
            nextRef.current(); // stable ref — safe to call without listing next in deps
        }, {
            root,
            rootMargin: buildRootMargin(scrollThreshold, inverse),
            threshold: 0
        });
        observer.observe(sentinel);
        return ()=>observer.disconnect();
    }, [
        hasMore,
        scrollThreshold,
        inverse,
        height,
        getScrollableNode
    ]);
    // Effect 3 — onScroll passthrough (only when prop is provided)
    (0, _react.useEffect)(()=>{
        var _a;
        if (!onScroll) return;
        const scrollEl = (_a = height ? infScrollRef.current : getScrollableNode()) !== null && _a !== void 0 ? _a : typeof window !== 'undefined' ? window : null;
        if (!scrollEl) return;
        const handler = (e)=>{
            setTimeout(()=>onScroll(e), 0);
        };
        scrollEl.addEventListener('scroll', handler);
        return ()=>scrollEl.removeEventListener('scroll', handler);
    }, [
        onScroll,
        height,
        getScrollableNode
    ]);
    // Effect 4 — Pull-to-refresh event listeners.
    // refreshFunction and pullDownToRefreshThreshold are intentionally absent from
    // deps — they are read via refs so listener re-registration is not needed when
    // consumers pass new function references or change the threshold at runtime.
    (0, _react.useEffect)(()=>{
        var _a, _b;
        if (!pullDownToRefresh) return;
        const scrollEl = (_a = height ? infScrollRef.current : getScrollableNode()) !== null && _a !== void 0 ? _a : typeof window !== 'undefined' ? window : null;
        if (!scrollEl) return;
        // Measure pull-down indicator height after mount
        if ((_b = pullDownRef.current) === null || _b === void 0 ? void 0 : _b.firstChild) {
            const dist = pullDownRef.current.firstChild.getBoundingClientRect().height;
            maxPullDownDistanceRef.current = dist;
            setMaxPullDownDistance(dist);
        }
        const onStart = (evt)=>{
            // Only allow pull-to-refresh when the scroll container is at the very top.
            // Replaces the old lastScrollTop ref which was never updated after removing
            // the scroll event listener, making the original guard permanently a no-op.
            const scrollTop = scrollEl instanceof HTMLElement ? scrollEl.scrollTop : document.documentElement.scrollTop;
            if (scrollTop > 0) return;
            draggingRef.current = true;
            if (evt instanceof MouseEvent) startYRef.current = evt.pageY;
            else if (evt instanceof TouchEvent) startYRef.current = evt.touches[0].pageY;
            currentYRef.current = startYRef.current;
            if (infScrollRef.current) {
                infScrollRef.current.style.willChange = 'transform';
                infScrollRef.current.style.transition = 'transform 0.2s cubic-bezier(0,0,0.31,1)';
            }
        };
        const onMove = (evt)=>{
            if (!draggingRef.current) return;
            if (evt instanceof MouseEvent) currentYRef.current = evt.pageY;
            else if (evt instanceof TouchEvent) currentYRef.current = evt.touches[0].pageY;
            // user is scrolling up — ignore
            if (currentYRef.current < startYRef.current) return;
            const delta = currentYRef.current - startYRef.current;
            // Read via ref — no stale closure risk, no effect re-registration needed
            if (delta >= pullThresholdRef.current) setPullToRefreshThresholdBreached(true);
            // limit drag to 1.5x maxPullDownDistance
            if (delta > maxPullDownDistanceRef.current * 1.5) return;
            if (infScrollRef.current) {
                infScrollRef.current.style.overflow = 'visible';
                infScrollRef.current.style.transform = `translate3d(0px, ${delta}px, 0px)`;
            }
        };
        const onEnd = ()=>{
            startYRef.current = 0;
            currentYRef.current = 0;
            draggingRef.current = false;
            setPullToRefreshThresholdBreached((breached)=>{
                var _a;
                if (breached) // Read via ref — refreshFunction identity changes don't re-register listeners
                (_a = refreshFunctionRef.current) === null || _a === void 0 || _a.call(refreshFunctionRef);
                return false;
            });
            requestAnimationFrame(()=>{
                if (infScrollRef.current) {
                    infScrollRef.current.style.overflow = 'auto';
                    infScrollRef.current.style.transform = 'none';
                    infScrollRef.current.style.willChange = 'unset';
                }
            });
        };
        scrollEl.addEventListener('touchstart', onStart);
        scrollEl.addEventListener('touchmove', onMove);
        scrollEl.addEventListener('touchend', onEnd);
        scrollEl.addEventListener('mousedown', onStart);
        scrollEl.addEventListener('mousemove', onMove);
        scrollEl.addEventListener('mouseup', onEnd);
        return ()=>{
            scrollEl.removeEventListener('touchstart', onStart);
            scrollEl.removeEventListener('touchmove', onMove);
            scrollEl.removeEventListener('touchend', onEnd);
            scrollEl.removeEventListener('mousedown', onStart);
            scrollEl.removeEventListener('mousemove', onMove);
            scrollEl.removeEventListener('mouseup', onEnd);
        };
    }, [
        pullDownToRefresh,
        height,
        getScrollableNode
    ]);
    const containerStyle = {
        height: height !== null && height !== void 0 ? height : 'auto',
        overflow: 'auto',
        WebkitOverflowScrolling: 'touch',
        ...style
    };
    const hasChildrenResolved = hasChildren || !!(children && children instanceof Array && children.length);
    const outerDivStyle = pullDownToRefresh && height ? {
        overflow: 'auto'
    } : {};
    const sentinel = hasMore ? (0, _jsxRuntime.jsx)("div", {
        ref: sentinelRef,
        style: {
            height: 1
        }
    }) : null;
    return (0, _jsxRuntime.jsx)("div", {
        style: outerDivStyle,
        className: "infinite-scroll-component__outerdiv",
        children: (0, _jsxRuntime.jsxs)("div", {
            ...ariaProps,
            role: role,
            tabIndex: tabIndex,
            id: id,
            className: [
                'infinite-scroll-component',
                className
            ].filter(Boolean).join(' '),
            ref: infScrollRef,
            style: containerStyle,
            children: [
                pullDownToRefresh && (0, _jsxRuntime.jsx)("div", {
                    style: {
                        position: 'relative'
                    },
                    ref: pullDownRef,
                    children: (0, _jsxRuntime.jsx)("div", {
                        style: {
                            position: 'absolute',
                            left: 0,
                            right: 0,
                            top: -1 * maxPullDownDistance
                        },
                        children: pullToRefreshThresholdBreached ? releaseToRefreshContent : pullDownToRefreshContent
                    })
                }),
                children,
                !showLoader && !hasChildrenResolved && hasMore && loader,
                showLoader && hasMore && loader,
                sentinel,
                !hasMore && endMessage
            ]
        })
    });
}

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"btqky":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgClient);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgClient = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 80,
        height: 80,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 3.333,
                d: "M51.665 55v-3.333A6.667 6.667 0 0 0 45 45H35a6.667 6.667 0 0 0-6.667 6.667V55m11.666-16.667a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 83.625,
                        x2: 21.485,
                        y1: 80.021,
                        y2: -20.52,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 40,
                        x2: 40,
                        y1: 0,
                        y2: 80,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3x6cI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFilter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFilter = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#B3B3B3",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "M14.003 2.666H9.336m-2.669 0H2M14 8H8M5.333 8H2m11.997 5.334h-3.333m-2.664 0H2m7.336-12v2.667m-4 2.665v2.667M10.664 12v2.667"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1z49p":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSearch);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSearch = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#99A1AF",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "M7.333 12.667A5.333 5.333 0 1 0 7.333 2a5.333 5.333 0 0 0 0 10.667M14 14l-2.867-2.867"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9VO1i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgList = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.8,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M9 6h10.5M9 12h10.5M9 18h10.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4.75,
                cy: 6,
                r: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4.75,
                cy: 12,
                r: 1,
                fill: "currentColor"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 4.75,
                cy: 18,
                r: 1,
                fill: "currentColor"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3WSyH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMenu = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        strokeWidth: 1.8,
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 6,
                height: 6,
                x: 4.5,
                y: 4.5,
                rx: 1.2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 6,
                height: 6,
                x: 13.5,
                y: 4.5,
                rx: 1.2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 6,
                height: 6,
                x: 13.5,
                y: 13.5,
                rx: 1.2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 6,
                height: 6,
                x: 4.5,
                y: 13.5,
                rx: 1.2
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iJaEv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDashboardModalArchive);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDashboardModalArchive = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 64,
        fill: "none",
        viewBox: "0 0 64 64",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M32 .25C49.535.25 63.75 14.465 63.75 32S49.535 63.75 32 63.75.25 49.535.25 32 14.465.25 32 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M32 .25C49.535.25 63.75 14.465 63.75 32S49.535 63.75 32 63.75.25 49.535.25 32 14.465.25 32 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.55,
                d: "M29 32c0-.466 0-.699.076-.883a1 1 0 0 1 .541-.54c.184-.077.417-.077.883-.077h3c.466 0 .699 0 .883.076a1 1 0 0 1 .54.541c.077.184.077.417.077.883s0 .699-.076.883a1 1 0 0 1-.541.54c-.184.077-.417.077-.883.077h-3c-.466 0-.699 0-.883-.076a1 1 0 0 1-.54-.541C29 32.699 29 32.466 29 32"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.55,
                d: "M40.5 27v6c0 3.771 0 5.657-1.172 6.828S36.271 41 32.5 41h-1c-3.771 0-5.657 0-6.828-1.172S23.5 36.771 23.5 33v-6M22 25c0-.943 0-1.414.293-1.707S23.057 23 24 23h16c.943 0 1.414 0 1.707.293S42 24.057 42 25s0 1.414-.293 1.707S40.943 27 40 27H24c-.943 0-1.414 0-1.707-.293S22 25.943 22 25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 66.9,
                        x2: 17.188,
                        y1: 64.016,
                        y2: -16.416,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 32,
                        x2: 32,
                        y1: 0,
                        y2: 64,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4NTEi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDashboardModalDelete);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDashboardModalDelete = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 64,
        fill: "none",
        viewBox: "0 0 64 64",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M32 .25C49.535.25 63.75 14.465 63.75 32S49.535 63.75 32 63.75.25 49.535.25 32 14.465.25 32 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M32 .25C49.535.25 63.75 14.465 63.75 32S49.535 63.75 32 63.75.25 49.535.25 32 14.465.25 32 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2.4,
                d: "m39.625 25.497-.975 15.785A2.78 2.78 0 0 1 37.939 43c-.417.448-.965.697-1.534.697h-9.31c-.57 0-1.117-.25-1.534-.698a2.78 2.78 0 0 1-.71-1.718l-.976-15.784m5.625 5.2v7.8m4.5-7.8v7.8m1.125-13v-3.9a1.4 1.4 0 0 0-.33-.92 1.05 1.05 0 0 0-.795-.38h-4.5c-.298 0-.584.137-.796.38a1.4 1.4 0 0 0-.329.92v3.9m-5.625 0h18"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 66.9,
                        x2: 17.188,
                        y1: 64.016,
                        y2: -16.416,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 32,
                        x2: 32,
                        y1: 0,
                        y2: 64,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aTlfZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDashboardArchive);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDashboardArchive = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#D6D6D6",
                strokeWidth: 1.5,
                d: "M9 12c0-.466 0-.699.076-.883a1 1 0 0 1 .541-.54c.184-.077.417-.077.883-.077h3c.466 0 .699 0 .883.076a1 1 0 0 1 .54.541c.077.184.077.417.077.883s0 .699-.076.883a1 1 0 0 1-.541.54c-.184.077-.417.077-.883.077h-3c-.466 0-.699 0-.883-.076a1 1 0 0 1-.54-.541C9 12.699 9 12.466 9 12Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#D6D6D6",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "M20.5 7v6c0 3.771 0 5.657-1.172 6.828S16.271 21 12.5 21h-1c-3.771 0-5.657 0-6.828-1.172S3.5 16.771 3.5 13V7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#D6D6D6",
                strokeWidth: 1.5,
                d: "M2 5c0-.943 0-1.414.293-1.707S3.057 3 4 3h16c.943 0 1.414 0 1.707.293S22 4.057 22 5s0 1.414-.293 1.707S20.943 7 20 7H4c-.943 0-1.414 0-1.707-.293S2 5.943 2 5Z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8P2xD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDashboardOnboard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDashboardOnboard = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                stroke: "#04051B",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.333,
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M10.67 13.666v-1.333a2.667 2.667 0 0 0-2.667-2.667h-4a2.667 2.667 0 0 0-2.667 2.667v1.333M6.003 7a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.333M12.664 5v4M14.664 7h-4"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"deNJx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDashboardOnboardArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDashboardOnboardArrow = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#04051B",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "M2.667 8h10.666m-4 4 4-4-4-4"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gvFKh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDashboardDelete);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDashboardDelete = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#07092C",
                strokeWidth: 1.5,
                d: "M9 12c0-.466 0-.699.076-.883a1 1 0 0 1 .541-.54c.184-.077.417-.077.883-.077h3c.466 0 .699 0 .883.076a1 1 0 0 1 .54.541c.077.184.077.417.077.883s0 .699-.076.883a1 1 0 0 1-.541.54c-.184.077-.417.077-.883.077h-3c-.466 0-.699 0-.883-.076a1 1 0 0 1-.54-.541C9 12.699 9 12.466 9 12Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#07092C",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "M20.5 7v6c0 3.771 0 5.657-1.172 6.828S16.271 21 12.5 21h-1c-3.771 0-5.657 0-6.828-1.172S3.5 16.771 3.5 13V7"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#07092C",
                strokeWidth: 1.5,
                d: "M2 5c0-.943 0-1.414.293-1.707S3.057 3 4 3h16c.943 0 1.414 0 1.707.293S22 4.057 22 5s0 1.414-.293 1.707S20.943 7 20 7H4c-.943 0-1.414 0-1.707-.293S2 5.943 2 5Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#D6D6D6",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.6,
                d: "m19.042 6.99-.83 12.168c-.035.505-.252.979-.606 1.324a1.87 1.87 0 0 1-1.307.538H8.37c-.486 0-.952-.192-1.307-.538a2.04 2.04 0 0 1-.606-1.324l-.83-12.169m4.791 4.009v6.013m3.833-6.013v6.013m.959-10.022V3.983c0-.266-.101-.521-.281-.709a.94.94 0 0 0-.678-.294h-3.833a.94.94 0 0 0-.678.294c-.18.188-.28.443-.28.709v3.006m-4.792 0H20"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fJoDx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDashboardEmail);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDashboardEmail = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeOpacity: 0.7,
                strokeWidth: 1.167,
                d: "M11.668 2.334H2.335c-.645 0-1.167.522-1.167 1.167v7c0 .644.522 1.166 1.167 1.166h9.333c.644 0 1.167-.522 1.167-1.166v-7c0-.645-.523-1.167-1.167-1.167"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeOpacity: 0.7,
                strokeWidth: 1.167,
                d: "M12.835 4.084 7.602 7.409a1.13 1.13 0 0 1-1.202 0L1.168 4.084"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c6iRs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDashboardViewArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDashboardViewArrow = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.7,
            strokeWidth: 1.333,
            d: "m6 12 4-4-4-4"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8c7At":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOnboardModalInfo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOnboardModalInfo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#FFA100",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M12 16v-4M12 8h.01"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hYbGA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOnboardModalPoint);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOnboardModalPoint = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#FFA100",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "m13.33 4-7.333 7.333L2.664 8"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hZ3OV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientOverview", ()=>ClientOverview);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _useGetTrainerClients = require("src/api/mutations/useGetTrainerClients");
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
var _overviewHeaderCalendarSvg = require("src/assets/images/trainer/clients/overview-header-calendar.svg");
var _overviewHeaderEmailSvg = require("src/assets/images/trainer/clients/overview-header-email.svg");
var _overviewHeaderSendMessageSvg = require("src/assets/images/trainer/clients/overview-header-send-message.svg");
var _emptyState = require("./components/EmptyState");
var _clientOverviewScss = require("./ClientOverview.scss");
const formatMemberSince = (createdAt)=>{
    if (!createdAt) return '-';
    if (typeof createdAt === 'number' || typeof createdAt === 'string' && /^\d+$/.test(createdAt.trim())) {
        const num = Number(createdAt);
        const d = (0, _dayjsDefault.default)(num < 1e11 ? num * 1000 : num);
        if (d.isValid()) return d.format('MMMM DD, YYYY');
    }
    if (typeof createdAt === 'object') {
        const secs = createdAt.seconds ?? createdAt._seconds;
        if (typeof secs === 'number') {
            const d = (0, _dayjsDefault.default)(secs * 1000);
            if (d.isValid()) return d.format('MMMM DD, YYYY');
        }
    }
    const d = (0, _dayjsDefault.default)(createdAt);
    if (d.isValid()) return d.format('MMMM DD, YYYY');
    return '-';
};
const ClientOverview = ()=>{
    const { uid } = (0, _reactRouterDom.useParams)();
    const location = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const currentUser = (0, _sessionStore.sessionStore)((state)=>state.currentUser);
    const trainerUid = (0, _firebase.auth).currentUser?.uid || currentUser?.uid || '';
    const { data, isLoading } = (0, _useGetTrainerClients.useGetTrainerClientById)(uid);
    const client = (0, _react.useMemo)(()=>{
        return data?.clients?.[0] || null;
    }, [
        data?.clients
    ]);
    const handleSendMessage = ()=>{
        const clientUid = client?.uid || client?.id || uid;
        if (!clientUid || !trainerUid) return;
        const chatId = [
            trainerUid,
            clientUid
        ].sort().join('_');
        navigate(`/onboarding-trainer/dashboard/messages/${chatId}`);
    };
    (0, _react.useEffect)(()=>{
        const mainContainer = document.querySelector('.dashboard-main');
        if (mainContainer) mainContainer.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        else window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    }, [
        uid
    ]);
    const tabs = [
        'Overview',
        'Program',
        'Workouts',
        'Client Profile'
    ];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "client-overview-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "loading-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                    indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                        className: "loading-icon",
                        spin: true
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "loading-text",
                    children: "Loading client details"
                })
            ]
        })
    });
    if (!client) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "client-overview-container",
        style: {
            padding: '40px 24px'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyState.EmptyState), {
            message: "The requested client details could not be found or have been removed.",
            marginTop: "0"
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "client-overview-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "client-overview-container-wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "overview-header-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "client-profile-info",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "avatar",
                                        children: client?.avatar_url || client?.avatarUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: client.avatar_url || client.avatarUrl,
                                            alt: "Profile"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "avatar-placeholder",
                                            children: [
                                                client?.name?.[0],
                                                client?.surname?.[0]
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "details",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                                children: [
                                                    client?.name,
                                                    " ",
                                                    client?.surname
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "meta",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "email",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewHeaderEmailSvg.ReactComponent), {}),
                                                            " ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "email-text",
                                                                children: client?.email
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "member-since",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewHeaderCalendarSvg.ReactComponent), {}),
                                                            " Member since:",
                                                            ' ',
                                                            formatMemberSince(client?.createdAt || client?.created_at)
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                className: "send-message-btn",
                                onClick: handleSendMessage,
                                children: [
                                    "Send Message ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewHeaderSendMessageSvg.ReactComponent), {})
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "overview-tabs",
                        children: tabs.map((tab, index)=>{
                            const tabPath = tab.toLowerCase().replace(' ', '-');
                            const isActive = location.pathname.includes(`/${tabPath}`);
                            // Special handling for workouts to keep the tab active on WorkoutDetails
                            const isWorkoutsActive = tab === 'Workouts' && location.pathname.includes('/workouts');
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: `tab-btn ${isActive || isWorkoutsActive ? 'active' : ''}`,
                                        onClick: ()=>navigate(tabPath),
                                        children: tab
                                    }),
                                    index < tabs.length - 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "tab-separator"
                                    })
                                ]
                            }, tab);
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "tab-outlet-area",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {
                    context: {
                        client
                    }
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Outlet","9oT3O"],["useParams","9oT3O"],["useLocation","f3cgC"],["useNavigate","f3cgC"]],"dayjs":"adpMK","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"src/api/mutations/useGetTrainerClients":"18nHc","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","src/assets/images/trainer/clients/overview-header-calendar.svg":"2CVtH","src/assets/images/trainer/clients/overview-header-email.svg":"2Aoed","src/assets/images/trainer/clients/overview-header-send-message.svg":"hK5EN","./components/EmptyState":"a8ne2","./ClientOverview.scss":"h32CG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"adpMK":[function(require,module,exports,__globalThis) {
!function(t, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    var t = 1e3, e = 6e4, n = 36e5, r = "millisecond", i = "second", s = "minute", u = "hour", a = "day", o = "week", c = "month", f = "quarter", h = "year", d = "date", l = "Invalid Date", $ = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, y = /\[([^\]]+)]|YYYY|YY|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, M = {
        name: "en",
        weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),
        months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"),
        ordinal: function(t) {
            var e = [
                "th",
                "st",
                "nd",
                "rd"
            ], n = t % 100;
            return "[" + t + (e[(n - 20) % 10] || e[n] || e[0]) + "]";
        }
    }, m = function(t, e, n) {
        var r = String(t);
        return !r || r.length >= e ? t : "" + Array(e + 1 - r.length).join(n) + t;
    }, v = {
        s: m,
        z: function(t) {
            var e = -t.utcOffset(), n = Math.abs(e), r = Math.floor(n / 60), i = n % 60;
            return (e <= 0 ? "+" : "-") + m(r, 2, "0") + ":" + m(i, 2, "0");
        },
        m: function t(e, n) {
            if (e.date() < n.date()) return -t(n, e);
            var r = 12 * (n.year() - e.year()) + (n.month() - e.month()), i = e.clone().add(r, c), s = n - i < 0, u = e.clone().add(r + (s ? -1 : 1), c);
            return +(-(r + (n - i) / (s ? i - u : u - i)) || 0);
        },
        a: function(t) {
            return t < 0 ? Math.ceil(t) || 0 : Math.floor(t);
        },
        p: function(t) {
            return ({
                M: c,
                y: h,
                w: o,
                d: a,
                D: d,
                h: u,
                m: s,
                s: i,
                ms: r,
                Q: f
            })[t] || String(t || "").toLowerCase().replace(/s$/, "");
        },
        u: function(t) {
            return void 0 === t;
        }
    }, g = "en", D = {};
    D[g] = M;
    var p = "$isDayjsObject", S = function(t) {
        return t instanceof _ || !(!t || !t[p]);
    }, w = function t(e, n, r) {
        var i;
        if (!e) return g;
        if ("string" == typeof e) {
            var s = e.toLowerCase();
            D[s] && (i = s), n && (D[s] = n, i = s);
            var u = e.split("-");
            if (!i && u.length > 1) return t(u[0]);
        } else {
            var a = e.name;
            D[a] = e, i = a;
        }
        return !r && i && (g = i), i || !r && g;
    }, O = function(t, e) {
        if (S(t)) return t.clone();
        var n = "object" == typeof e ? e : {};
        return n.date = t, n.args = arguments, new _(n);
    }, b = v;
    b.l = w, b.i = S, b.w = function(t, e) {
        return O(t, {
            locale: e.$L,
            utc: e.$u,
            x: e.$x,
            $offset: e.$offset
        });
    };
    var _ = function() {
        function M(t) {
            this.$L = w(t.locale, null, !0), this.parse(t), this.$x = this.$x || t.x || {}, this[p] = !0;
        }
        var m = M.prototype;
        return m.parse = function(t) {
            this.$d = function(t) {
                var e = t.date, n = t.utc;
                if (null === e) return new Date(NaN);
                if (b.u(e)) return new Date;
                if (e instanceof Date) return new Date(e);
                if ("string" == typeof e && !/Z$/i.test(e)) {
                    var r = e.match($);
                    if (r) {
                        var i = r[2] - 1 || 0, s = (r[7] || "0").substring(0, 3);
                        return n ? new Date(Date.UTC(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s)) : new Date(r[1], i, r[3] || 1, r[4] || 0, r[5] || 0, r[6] || 0, s);
                    }
                }
                return new Date(e);
            }(t), this.init();
        }, m.init = function() {
            var t = this.$d;
            this.$y = t.getFullYear(), this.$M = t.getMonth(), this.$D = t.getDate(), this.$W = t.getDay(), this.$H = t.getHours(), this.$m = t.getMinutes(), this.$s = t.getSeconds(), this.$ms = t.getMilliseconds();
        }, m.$utils = function() {
            return b;
        }, m.isValid = function() {
            return !(this.$d.toString() === l);
        }, m.isSame = function(t, e) {
            var n = O(t);
            return this.startOf(e) <= n && n <= this.endOf(e);
        }, m.isAfter = function(t, e) {
            return O(t) < this.startOf(e);
        }, m.isBefore = function(t, e) {
            return this.endOf(e) < O(t);
        }, m.$g = function(t, e, n) {
            return b.u(t) ? this[e] : this.set(n, t);
        }, m.unix = function() {
            return Math.floor(this.valueOf() / 1e3);
        }, m.valueOf = function() {
            return this.$d.getTime();
        }, m.startOf = function(t, e) {
            var n = this, r = !!b.u(e) || e, f = b.p(t), l = function(t, e) {
                var i = b.w(n.$u ? Date.UTC(n.$y, e, t) : new Date(n.$y, e, t), n);
                return r ? i : i.endOf(a);
            }, $ = function(t, e) {
                return b.w(n.toDate()[t].apply(n.toDate("s"), (r ? [
                    0,
                    0,
                    0,
                    0
                ] : [
                    23,
                    59,
                    59,
                    999
                ]).slice(e)), n);
            }, y = this.$W, M = this.$M, m = this.$D, v = "set" + (this.$u ? "UTC" : "");
            switch(f){
                case h:
                    return r ? l(1, 0) : l(31, 11);
                case c:
                    return r ? l(1, M) : l(0, M + 1);
                case o:
                    var g = this.$locale().weekStart || 0, D = (y < g ? y + 7 : y) - g;
                    return l(r ? m - D : m + (6 - D), M);
                case a:
                case d:
                    return $(v + "Hours", 0);
                case u:
                    return $(v + "Minutes", 1);
                case s:
                    return $(v + "Seconds", 2);
                case i:
                    return $(v + "Milliseconds", 3);
                default:
                    return this.clone();
            }
        }, m.endOf = function(t) {
            return this.startOf(t, !1);
        }, m.$set = function(t, e) {
            var n, o = b.p(t), f = "set" + (this.$u ? "UTC" : ""), l = (n = {}, n[a] = f + "Date", n[d] = f + "Date", n[c] = f + "Month", n[h] = f + "FullYear", n[u] = f + "Hours", n[s] = f + "Minutes", n[i] = f + "Seconds", n[r] = f + "Milliseconds", n)[o], $ = o === a ? this.$D + (e - this.$W) : e;
            if (o === c || o === h) {
                var y = this.clone().set(d, 1);
                y.$d[l]($), y.init(), this.$d = y.set(d, Math.min(this.$D, y.daysInMonth())).$d;
            } else l && this.$d[l]($);
            return this.init(), this;
        }, m.set = function(t, e) {
            return this.clone().$set(t, e);
        }, m.get = function(t) {
            return this[b.p(t)]();
        }, m.add = function(r, f) {
            var d, l = this;
            r = Number(r);
            var $ = b.p(f), y = function(t) {
                var e = O(l);
                return b.w(e.date(e.date() + Math.round(t * r)), l);
            };
            if ($ === c) return this.set(c, this.$M + r);
            if ($ === h) return this.set(h, this.$y + r);
            if ($ === a) return y(1);
            if ($ === o) return y(7);
            var M = (d = {}, d[s] = e, d[u] = n, d[i] = t, d)[$] || 1, m = this.$d.getTime() + r * M;
            return b.w(m, this);
        }, m.subtract = function(t, e) {
            return this.add(-1 * t, e);
        }, m.format = function(t) {
            var e = this, n = this.$locale();
            if (!this.isValid()) return n.invalidDate || l;
            var r = t || "YYYY-MM-DDTHH:mm:ssZ", i = b.z(this), s = this.$H, u = this.$m, a = this.$M, o = n.weekdays, c = n.months, f = n.meridiem, h = function(t, n, i, s) {
                return t && (t[n] || t(e, r)) || i[n].slice(0, s);
            }, d = function(t) {
                return b.s(s % 12 || 12, t, "0");
            }, $ = f || function(t, e, n) {
                var r = t < 12 ? "AM" : "PM";
                return n ? r.toLowerCase() : r;
            };
            return r.replace(y, function(t, r) {
                return r || function(t) {
                    switch(t){
                        case "YY":
                            return String(e.$y).slice(-2);
                        case "YYYY":
                            return b.s(e.$y, 4, "0");
                        case "M":
                            return a + 1;
                        case "MM":
                            return b.s(a + 1, 2, "0");
                        case "MMM":
                            return h(n.monthsShort, a, c, 3);
                        case "MMMM":
                            return h(c, a);
                        case "D":
                            return e.$D;
                        case "DD":
                            return b.s(e.$D, 2, "0");
                        case "d":
                            return String(e.$W);
                        case "dd":
                            return h(n.weekdaysMin, e.$W, o, 2);
                        case "ddd":
                            return h(n.weekdaysShort, e.$W, o, 3);
                        case "dddd":
                            return o[e.$W];
                        case "H":
                            return String(s);
                        case "HH":
                            return b.s(s, 2, "0");
                        case "h":
                            return d(1);
                        case "hh":
                            return d(2);
                        case "a":
                            return $(s, u, !0);
                        case "A":
                            return $(s, u, !1);
                        case "m":
                            return String(u);
                        case "mm":
                            return b.s(u, 2, "0");
                        case "s":
                            return String(e.$s);
                        case "ss":
                            return b.s(e.$s, 2, "0");
                        case "SSS":
                            return b.s(e.$ms, 3, "0");
                        case "Z":
                            return i;
                    }
                    return null;
                }(t) || i.replace(":", "");
            });
        }, m.utcOffset = function() {
            return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
        }, m.diff = function(r, d, l) {
            var $, y = this, M = b.p(d), m = O(r), v = (m.utcOffset() - this.utcOffset()) * e, g = this - m, D = function() {
                return b.m(y, m);
            };
            switch(M){
                case h:
                    $ = D() / 12;
                    break;
                case c:
                    $ = D();
                    break;
                case f:
                    $ = D() / 3;
                    break;
                case o:
                    $ = (g - v) / 6048e5;
                    break;
                case a:
                    $ = (g - v) / 864e5;
                    break;
                case u:
                    $ = g / n;
                    break;
                case s:
                    $ = g / e;
                    break;
                case i:
                    $ = g / t;
                    break;
                default:
                    $ = g;
            }
            return l ? $ : b.a($);
        }, m.daysInMonth = function() {
            return this.endOf(c).$D;
        }, m.$locale = function() {
            return D[this.$L];
        }, m.locale = function(t, e) {
            if (!t) return this.$L;
            var n = this.clone(), r = w(t, e, !0);
            return r && (n.$L = r), n;
        }, m.clone = function() {
            return b.w(this.$d, this);
        }, m.toDate = function() {
            return new Date(this.valueOf());
        }, m.toJSON = function() {
            return this.isValid() ? this.toISOString() : null;
        }, m.toISOString = function() {
            return this.$d.toISOString();
        }, m.toString = function() {
            return this.$d.toUTCString();
        }, M;
    }(), Y = _.prototype;
    return O.prototype = Y, [
        [
            "$ms",
            r
        ],
        [
            "$s",
            i
        ],
        [
            "$m",
            s
        ],
        [
            "$H",
            u
        ],
        [
            "$W",
            a
        ],
        [
            "$M",
            c
        ],
        [
            "$y",
            h
        ],
        [
            "$D",
            d
        ]
    ].forEach(function(t) {
        Y[t[1]] = function(e) {
            return this.$g(e, t[0], t[1]);
        };
    }), O.extend = function(t, e) {
        return t.$i || (t(e, _, O), t.$i = !0), O;
    }, O.locale = w, O.isDayjs = S, O.unix = function(t) {
        return O(1e3 * t);
    }, O.en = D[g], O.Ls = D, O.p = {}, O;
});

},{}],"2CVtH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewHeaderCalendar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewHeaderCalendar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.7,
            strokeWidth: 1.333,
            d: "M5.332 1.332v2.667M10.668 1.332v2.667M12.667 2.668H3.333C2.597 2.668 2 3.265 2 4.001v9.334c0 .736.597 1.333 1.333 1.333h9.334c.736 0 1.333-.597 1.333-1.333V4c0-.736-.597-1.333-1.333-1.333M2 6.668h12"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Aoed":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewHeaderEmail);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewHeaderEmail = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeOpacity: 0.7,
                strokeWidth: 1.167,
                d: "M11.668 2.334H2.335c-.645 0-1.167.522-1.167 1.167v7c0 .644.522 1.166 1.167 1.166h9.333c.644 0 1.167-.522 1.167-1.166v-7c0-.645-.523-1.167-1.167-1.167"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeOpacity: 0.7,
                strokeWidth: 1.167,
                d: "M12.835 4.084 7.602 7.409a1.13 1.13 0 0 1-1.202 0L1.168 4.084"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hK5EN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewHeaderSendMessage);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewHeaderSendMessage = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#07092C",
            d: "M20.04 2.322c1.016-.355 1.992.621 1.637 1.637l-5.925 16.93c-.385 1.099-1.915 1.16-2.387.098l-2.86-6.432 4.025-4.025a.75.75 0 0 0-1.06-1.06l-4.025 4.023-6.432-2.859c-1.063-.473-1-2.002.097-2.387z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a8ne2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyState", ()=>EmptyState);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("src/screens/OnboardingTrainer/components/Button/Button");
const EmptyState = ({ message = 'No Data Found', marginTop = '40px', buttonText, onButtonClick, hideIcon = false, hideMessage = false })=>{
    if (buttonText && onButtonClick && hideIcon && hideMessage) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "dashboard-empty-state",
        style: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '300px',
            width: '100%',
            marginTop: 0
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
            variant: "light",
            onClick: onButtonClick,
            children: buttonText
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "dashboard-empty-state",
        style: {
            marginTop,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
        },
        children: [
            !hideIcon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                width: "65",
                height: "64",
                viewBox: "0 0 65 64",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M32.5 32C37.6547 32 41.8333 27.8213 41.8333 22.6667C41.8333 17.512 37.6547 13.3333 32.5 13.3333C27.3453 13.3333 23.1667 17.512 23.1667 22.6667C23.1667 27.8213 27.3453 32 32.5 32ZM25.0333 34.6667C18.1093 34.6667 12.5 40.276 12.5 47.2V50.6667H52.5V47.2C52.5 40.276 46.8907 34.6667 39.9667 34.6667H25.0333Z",
                    fill: "#FFFFFF",
                    fillOpacity: "0.5"
                })
            }),
            !hideMessage && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                style: {
                    marginBottom: buttonText ? '16px' : '0'
                },
                children: message
            }),
            buttonText && onButtonClick && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                variant: "light",
                onClick: onButtonClick,
                style: {
                    marginTop: 8
                },
                children: buttonText
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/screens/OnboardingTrainer/components/Button/Button":"jLE7r","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h32CG":[function() {},{}],"cW78d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OverviewTab", ()=>OverviewTab);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _buildingProgramFemalePng = require("url:../../ProgramGeneratorAI/assets/client/building-program-female.png");
var _buildingProgramFemalePngDefault = parcelHelpers.interopDefault(_buildingProgramFemalePng);
var _buildingProgramMalePng = require("url:../../ProgramGeneratorAI/assets/client/building-program-male.png");
var _buildingProgramMalePngDefault = parcelHelpers.interopDefault(_buildingProgramMalePng);
var _overviewOverviewEquipmentSvg = require("src/assets/images/trainer/clients/overview-overview-equipment.svg");
var _overviewOverviewFrequencySvg = require("src/assets/images/trainer/clients/overview-overview-frequency.svg");
var _overviewOverviewApproachSvg = require("src/assets/images/trainer/clients/overview-overview-approach.svg");
var _overviewOverviewDurationSvg = require("src/assets/images/trainer/clients/overview-overview-duration.svg");
var _overviewOverviewWeekSvg = require("src/assets/images/trainer/clients/overview-overview-week.svg");
var _overviewOverviewThisWeekSvg = require("src/assets/images/trainer/clients/overview-overview-this_week.svg");
var _overviewOverviewWorkoutsCompletedSvg = require("src/assets/images/trainer/clients/overview-overview-workouts_completed.svg");
var _overviewOverviewTrainingVolumeSvg = require("src/assets/images/trainer/clients/overview-overview-training_volume.svg");
var _overviewOverviewCompletionRateSvg = require("src/assets/images/trainer/clients/overview-overview-completion_rate.svg");
var _overviewOverviewRecentActivitySvg = require("src/assets/images/trainer/clients/overview-overview-recent_activity.svg");
var _overviewOverviewMyNotesSvg = require("src/assets/images/trainer/clients/overview-overview-my_notes.svg");
var _overviewOverviewViewAllArrowSvg = require("src/assets/images/trainer/clients/overview-overview-view_all_arrow.svg");
var _overviewOverviewAddNoteSvg = require("src/assets/images/trainer/clients/overview-overview-add_note.svg");
var _overviewOverviewAiObservationsSvg = require("src/assets/images/trainer/clients/overview-overview-ai_observations.svg");
var _overviewOverviewProgramOverviewSvg = require("src/assets/images/trainer/clients/overview-overview-program-overview.svg");
var _overviewOverviewSessionTimeSvg = require("src/assets/images/trainer/clients/overview-overview-session-time.svg");
var _overviewOverviewViewProgramSvg = require("src/assets/images/trainer/clients/overview-overview-view-program.svg");
var _addNoteModal = require("./AddNoteModal/AddNoteModal");
var _useGetClientOverview = require("src/api/queries/useGetClientOverview");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _genderUtils = require("src/utils/genderUtils");
var _emptyState = require("./EmptyState");
const OverviewTab = ()=>{
    const { uid } = (0, _reactRouterDom.useParams)();
    const { client } = (0, _reactRouterDom.useOutletContext)();
    const clientName = client ? `${client.name || ''} ${client.surname || ''}`.trim() : undefined;
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [isAddNoteModalOpen, setIsAddNoteModalOpen] = (0, _react.useState)(false);
    const { data: overviewData, isLoading } = (0, _useGetClientOverview.useGetClientOverview)(uid || '');
    const { data: masterData } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const getSlugTitle = (slug)=>{
        if (!slug) return '';
        let result = null;
        if (masterData) {
            const search = (obj)=>{
                if (result) return;
                if (!obj || typeof obj !== 'object') return;
                if ((obj.slug === slug || obj.id === slug) && obj.title) {
                    result = obj.title;
                    return;
                }
                if (Array.isArray(obj)) obj.forEach(search);
                else Object.values(obj).forEach(search);
            };
            search(masterData);
        }
        if (result) return result;
        return String(slug).replace(/_/g, '-').split('-').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };
    const formatEquipment = (equip)=>{
        if (!equip || equip.length === 0) return 'None';
        const formatted = equip.map((e)=>e.split('-').map((w)=>w.charAt(0).toUpperCase() + w.slice(1)).join(' '));
        if (formatted.length === 1) return formatted[0];
        return `${formatted[0]}, +${formatted.length - 1} other`;
    };
    const formatDate = (isoStr)=>{
        if (!isoStr) return '--';
        if (isoStr.includes("\u2022")) return isoStr;
        try {
            const parsed = (0, _dayjsDefault.default)(isoStr);
            if (parsed.isValid()) {
                const currentYear = (0, _dayjsDefault.default)().year();
                const finalDate = parsed.year() === 2001 && !isoStr.includes('2001') ? parsed.year(currentYear) : parsed;
                return finalDate.format("MMM DD, YYYY \u2022 h:mm A");
            }
            return isoStr;
        } catch  {
            return isoStr;
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "overview-content loading",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                    className: "loading-icon",
                    spin: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                className: "loading-text",
                children: "Loading overview"
            })
        ]
    });
    const overview = overviewData?.overview;
    const thisWeek = overviewData?.thisWeek;
    const recentActivity = overviewData?.recentActivity;
    const aiObservations = overviewData?.aiObservations || [];
    const myNotes = overviewData?.myNotes || [];
    const isDraftProgram = overview?.isDraft === true || overview?.status === 'draft';
    const generatorType = overview?.generatorType === 'manual' || overview?.type === 'manual' ? 'manual' : 'ai';
    const isInactive = client?.is_active === false || client?.isActive === false;
    if (!overview?.programId || isDraftProgram) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "overview-content",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "dashboard-empty-state-wrapper",
            style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '400px',
                width: '100%'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyState.EmptyState), {
                message: isInactive ? 'This client is currently inactive. Activate this client to create and assign programs.' : isDraftProgram ? 'You have an unfinished program draft for this client.' : 'No program yet.',
                buttonText: isInactive ? undefined : isDraftProgram ? 'Continue to Finish Program' : 'Create Your First Program',
                onButtonClick: isInactive ? undefined : isDraftProgram ? ()=>navigate(`/onboarding-trainer/dashboard/program-generator/${generatorType}?programId=${overview.programId}`) : ()=>navigate('/onboarding-trainer/dashboard'),
                hideIcon: true,
                hideMessage: false,
                marginTop: "0"
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "overview-content",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "overview-grid",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "program-overview-card",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "card-content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "title-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewProgramOverviewSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: "Program Overview"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "active-badge",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "dot"
                                            }),
                                            " ACTIVE"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "program-body-split",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "program-info",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "program-details",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "program-summary",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                children: overview?.programName || 'Workout Program'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                                className: "goal",
                                                                children: [
                                                                    "Goal:",
                                                                    ' ',
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        children: getSlugTitle(overview?.primaryGoal || '') || 'Not specified'
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "stats-grid grid-1",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "stat-item",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewApproachSvg.ReactComponent), {}),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "label",
                                                                                children: "Approach"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "value",
                                                                                children: getSlugTitle(overview?.goalApproach || overview?.approach || '') || '--'
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "stat-item",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewFrequencySvg.ReactComponent), {}),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "label",
                                                                                children: "Frequency"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                className: "value",
                                                                                children: [
                                                                                    overview?.frequency || 0,
                                                                                    " days / week"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "stats-grid grid-2",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "stat-item",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewWeekSvg.ReactComponent), {}),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "label",
                                                                                children: "Week"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "value",
                                                                                children: overview?.week ? String(overview.week).toLowerCase().includes('not started') ? overview.week : `Week ${overview.week}` : 'Week 1'
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "stat-item",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewSessionTimeSvg.ReactComponent), {}),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "label",
                                                                                children: "Session Time"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                className: "value",
                                                                                children: [
                                                                                    overview?.sessionTime || 0,
                                                                                    " min"
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "stat-item",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewEquipmentSvg.ReactComponent), {}),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "label",
                                                                                children: "Equipment"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "value",
                                                                                style: {
                                                                                    textTransform: 'capitalize'
                                                                                },
                                                                                children: formatEquipment(overview?.equipment || [])
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "card-bg",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: (0, _genderUtils.isFemaleProfile)(client) ? (0, _buildingProgramFemalePngDefault.default) : (0, _buildingProgramMalePngDefault.default),
                                                    alt: "Building Program"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        className: `view-program-btn ${isDraftProgram ? 'continue-program-btn' : ''}`,
                                        onClick: ()=>{
                                            if (isDraftProgram) navigate(`/onboarding-trainer/dashboard/program-generator/ai?programId=${overview.programId}`);
                                            else navigate(`/onboarding-trainer/dashboard/program-generated/${overview.programId}`, {
                                                state: {
                                                    clientId: uid,
                                                    clientName,
                                                    isManually: generatorType === 'manual',
                                                    generatorType
                                                }
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewViewProgramSvg.ReactComponent), {}),
                                            ' ',
                                            isDraftProgram ? 'Continue Program' : 'View Program'
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "this-week-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "card-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewThisWeekSvg.ReactComponent), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    children: "This Week"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "progress-stats",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "progress-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "icon-container",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewWorkoutsCompletedSvg.ReactComponent), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "progress-content",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "progress-labels",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "label",
                                                            children: "Workouts completed"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "value",
                                                            children: [
                                                                thisWeek?.workoutsCompleted || 0,
                                                                " / ",
                                                                thisWeek?.totalWorkouts || 0
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "progress-bar-container",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "progress-fill",
                                                        style: {
                                                            width: `${thisWeek?.totalWorkouts ? (thisWeek?.workoutsCompleted || 0) / thisWeek?.totalWorkouts * 100 : 0}%`
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "progress-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "icon-container",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewDurationSvg.ReactComponent), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "progress-content",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "progress-labels",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "label",
                                                            children: "Duration"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "value",
                                                            children: [
                                                                thisWeek?.duration || 0,
                                                                " min"
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "progress-bar-container",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "progress-fill",
                                                        style: {
                                                            width: `${Math.min(100, (thisWeek?.duration || 0) / Math.max(1, (overview?.sessionTime || 45) * (thisWeek?.totalWorkouts || 3)) * 100)}%`
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "progress-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "icon-container",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewTrainingVolumeSvg.ReactComponent), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "progress-content",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "progress-labels",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "label",
                                                            children: "Training volume"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: thisWeek?.trainingVolume || '--'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "progress-bar-container",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "progress-fill",
                                                        style: {
                                                            width: `${(()=>{
                                                                const parts = (thisWeek?.trainingVolume || '').split('/');
                                                                const completed = parseFloat((parts[0] || '').replace(/[^0-9.]/g, '')) || 0;
                                                                const planned = parseFloat((parts[1] || '').replace(/[^0-9.]/g, '')) || 0;
                                                                return planned > 0 ? Math.min(100, Math.max(0, completed / planned * 100)) : completed > 0 ? 100 : 0;
                                                            })()}%`
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "progress-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "icon-container",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewCompletionRateSvg.ReactComponent), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "progress-content",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "progress-labels",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "label",
                                                            children: "Completion rate"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: thisWeek?.completionRate || '--'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "progress-bar-container",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "progress-fill",
                                                        style: {
                                                            width: `${Math.min(100, Math.max(0, parseInt(thisWeek?.completionRate || '0', 10) || 0))}%`
                                                        }
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "recent-activity-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "card-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewRecentActivitySvg.ReactComponent), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    children: "Recent Activity"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "activity-list",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "activity-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "title",
                                            children: "Last workout completed"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "date",
                                            children: formatDate(recentActivity?.lastCompleted)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "activity-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "title",
                                            children: "Last check-in"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "date",
                                            children: formatDate(recentActivity?.lastCheckin)
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "activity-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "title",
                                            children: "Next scheduled workout"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "date",
                                            children: recentActivity?.nextScheduled ? formatDate(recentActivity.nextScheduled) : '--'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "notes-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "card-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "title-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewMyNotesSvg.ReactComponent), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "My Notes"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "view-all-btn",
                                    onClick: ()=>navigate(`/onboarding-trainer/dashboard/clients/${uid}/overview/notes`),
                                    children: [
                                        "View All ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewViewAllArrowSvg.ReactComponent), {})
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "notes-list",
                            children: myNotes.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "empty-state",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "empty-icon-container",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewMyNotesSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: "No notes yet."
                                    })
                                ]
                            }) : myNotes.map((note)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "note-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "note-content",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "dot"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    children: note.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "date",
                                            children: formatDate(note.date)
                                        })
                                    ]
                                }, note.id))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: "add-note-btn",
                            onClick: ()=>setIsAddNoteModalOpen(true),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewAddNoteSvg.ReactComponent), {}),
                                " Add Note"
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "ai-observations-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "card-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewAiObservationsSvg.ReactComponent), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    children: "AI Observations"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "observations-list",
                            children: aiObservations.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "empty-state",
                                children: "No observations."
                            }) : aiObservations.map((obs)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "observation-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "dot"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: obs.text
                                        })
                                    ]
                                }, obs.id))
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addNoteModal.AddNoteModal), {
                    open: isAddNoteModalOpen,
                    onClose: ()=>setIsAddNoteModalOpen(false)
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["useNavigate","f3cgC"],["useOutletContext","9oT3O"],["useParams","9oT3O"]],"dayjs":"adpMK","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"url:../../ProgramGeneratorAI/assets/client/building-program-female.png":"bn6Ha","url:../../ProgramGeneratorAI/assets/client/building-program-male.png":"fqV09","src/assets/images/trainer/clients/overview-overview-equipment.svg":"jlS6s","src/assets/images/trainer/clients/overview-overview-frequency.svg":"6KcyE","src/assets/images/trainer/clients/overview-overview-approach.svg":"4yrDl","src/assets/images/trainer/clients/overview-overview-duration.svg":"6IWgi","src/assets/images/trainer/clients/overview-overview-week.svg":"22Oti","src/assets/images/trainer/clients/overview-overview-this_week.svg":"gHOaN","src/assets/images/trainer/clients/overview-overview-workouts_completed.svg":"1ClGD","src/assets/images/trainer/clients/overview-overview-training_volume.svg":"azXTR","src/assets/images/trainer/clients/overview-overview-completion_rate.svg":"8oTli","src/assets/images/trainer/clients/overview-overview-recent_activity.svg":"67Zbc","src/assets/images/trainer/clients/overview-overview-my_notes.svg":"dcY56","src/assets/images/trainer/clients/overview-overview-view_all_arrow.svg":"6Yqg0","src/assets/images/trainer/clients/overview-overview-add_note.svg":"dMSpB","src/assets/images/trainer/clients/overview-overview-ai_observations.svg":"bzIGE","src/assets/images/trainer/clients/overview-overview-program-overview.svg":"JeUzf","src/assets/images/trainer/clients/overview-overview-session-time.svg":"hRJ8o","src/assets/images/trainer/clients/overview-overview-view-program.svg":"9Ufbb","./AddNoteModal/AddNoteModal":"kuHpn","src/api/queries/useGetClientOverview":"29QSs","src/api/mutations/useGetProgramMasterData":"bOtFg","src/utils/genderUtils":"aiA54","./EmptyState":"a8ne2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bn6Ha":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ZwQZX");

},{}],"fqV09":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6m6nZ");

},{}],"jlS6s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewEquipment);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewEquipment = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M24 17.017c-.02-1.199-.003-2.397-.007-3.599 0-.36-.2-.55-.578-.55h-.587l-.044-.228a1.756 1.756 0 0 0-1.59-1.465c-.504-.038-2.05-.024-3.032-.015q0-1.057.003-2.116c0-.174-.028-.349-.197-.437a1 1 0 0 0-.425-.101c-1.025-.009-2.05-.006-3.072-.003a1.3 1.3 0 0 0-.212.018c-.26.041-.407.19-.416.438-.01.21-.006.42-.006.63v1.568c-.757-.003-2.32-.011-2.847.006q-.362.015-.697.148c-.697.293-1.04.832-1.116 1.557h-.606c-.356 0-.569.19-.569.52q-.005 1.948.003 3.895c0 .337.21.52.566.524q1.115.004 2.231 0c.431 0 .635-.193.635-.601v-1.873c0-.636.003-1.273 0-1.909-.003-.352-.22-.553-.582-.556h-.6c.06-.444.363-.705.797-.707h2.782v6.705h-1.71c-.4 0-.725.308-.725.686 0 .38.325.687.725.687h1.7v1.888H11.09c-.4 0-.725.308-.725.687 0 .378.325.686.725.686h9.84c.4 0 .726-.308.726-.686 0-.38-.325-.687-.725-.687h-2.757v-1.888h1.72c.4 0 .724-.308.724-.687 0-.378-.325-.686-.725-.686h-1.731V12.16h2.81s.73.284.768.707h-.603c-.347.003-.575.198-.575.524q-.009 1.947 0 3.894c0 .325.234.518.578.518.672 0 1.344-.021 2.016.006.781.03.85-.26.844-.793"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6KcyE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewFrequency);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewFrequency = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M9 21.4c0 1.19.91 2.1 2.1 2.1h9.8c1.19 0 2.1-.91 2.1-2.1v-5.6H9zm11.9-10.5h-1.4v-.7c0-.42-.28-.7-.7-.7s-.7.28-.7.7v.7h-4.2v-.7c0-.42-.28-.7-.7-.7s-.7.28-.7.7v.7h-1.4c-1.19 0-2.1.91-2.1 2.1v1.4h14V13c0-1.19-.91-2.1-2.1-2.1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4yrDl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewApproach);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewApproach = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                fillRule: "evenodd",
                d: "M10.65 10.73c.204-.116.519-.23.95-.23s.746.114.95.23c.316.18.41.486.415.704.01.436.035 1.872.035 4.566s-.026 4.13-.035 4.566a.82.82 0 0 1-.415.704c-.204.116-.519.23-.95.23s-.746-.114-.95-.23a.82.82 0 0 1-.415-.704A227 227 0 0 1 10.2 16c0-2.694.026-4.13.035-4.566a.82.82 0 0 1 .415-.704m10.7 0a1.9 1.9 0 0 0-.95-.23c-.431 0-.746.114-.95.23a.82.82 0 0 0-.415.704C19.025 11.87 19 13.306 19 16s.026 4.13.035 4.566a.82.82 0 0 0 .415.704c.204.116.519.23.95.23s.746-.114.95-.23a.82.82 0 0 0 .415-.704c.01-.436.035-1.872.035-4.566s-.026-4.13-.035-4.566a.82.82 0 0 0-.415-.704M8.2 12.397c-.264 0-.476.045-.638.105a.82.82 0 0 0-.538.758C7.016 13.6 7 14.473 7 16s.016 2.4.024 2.74c.006.244.132.61.538.758.162.06.374.105.638.105s.476-.045.638-.105a.82.82 0 0 0 .538-.758c.008-.34.024-1.213.024-2.74s-.016-2.4-.024-2.74a.82.82 0 0 0-.538-.758 1.9 1.9 0 0 0-.638-.105m16.238.105a1.9 1.9 0 0 0-.638-.105c-.264 0-.476.045-.638.105a.82.82 0 0 0-.538.758c-.008.34-.024 1.213-.024 2.74s.016 2.4.024 2.74c.006.244.132.61.538.758.162.06.374.105.638.105s.476-.045.638-.105a.82.82 0 0 0 .538-.758c.008-.34.024-1.213.024-2.74s-.016-2.4-.024-2.74a.82.82 0 0 0-.538-.758M13.8 17.084v-2.168c0-.36.31-.548.641-.575q.102-.01.306-.02c.272-.014.683-.028 1.253-.028s.981.014 1.253.028q.204.01.306.02c.33.026.641.216.641.575v2.168c0 .36-.31.548-.641.575q-.103.01-.306.02c-.272.014-.683.028-1.253.028s-.981-.014-1.253-.028a9 9 0 0 1-.306-.02c-.33-.026-.641-.216-.641-.575",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6IWgi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewDuration);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewDuration = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 34,
        height: 34,
        fill: "none",
        viewBox: "0 0 34 34",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 34,
                height: 34,
                fill: "#0A0B29",
                rx: 17
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M15.359 10.43a.76.76 0 0 1-.778-.762q0-.323.224-.542a.76.76 0 0 1 .553-.22h3.112q.33 0 .554.22t.223.542a.74.74 0 0 1-.224.543.75.75 0 0 1-.553.22zm1.555 8.381q.33 0 .555-.22a.73.73 0 0 0 .223-.542v-3.047a.73.73 0 0 0-.224-.543.76.76 0 0 0-.554-.22.76.76 0 0 0-.554.22.73.73 0 0 0-.224.543v3.047a.758.758 0 0 0 .778.762m0 6.095q-1.44 0-2.713-.542a7.02 7.02 0 0 1-3.733-3.658 6.5 6.5 0 0 1-.554-2.657q0-1.41.555-2.657a7 7 0 0 1 1.506-2.181 7.2 7.2 0 0 1 2.227-1.476 6.8 6.8 0 0 1 2.712-.543q1.206 0 2.314.38a7.6 7.6 0 0 1 2.08 1.106l.545-.534a.75.75 0 0 1 .544-.21q.33 0 .545.21.213.21.214.534a.72.72 0 0 1-.214.533l-.545.533a7.4 7.4 0 0 1 1.128 2.038q.39 1.086.39 2.267a6.5 6.5 0 0 1-.555 2.658 7 7 0 0 1-1.507 2.18 7.2 7.2 0 0 1-2.227 1.477 6.8 6.8 0 0 1-2.712.542"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"22Oti":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewWeek);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewWeek = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M14.444 9.024a.76.76 0 0 1-.777-.762q0-.322.224-.543a.76.76 0 0 1 .553-.219h3.112q.33 0 .554.22t.223.542a.74.74 0 0 1-.224.543.75.75 0 0 1-.553.219zM16 17.404q.33 0 .555-.219a.73.73 0 0 0 .223-.542v-3.048a.73.73 0 0 0-.224-.542.77.77 0 0 0-.554-.22.76.76 0 0 0-.554.22.73.73 0 0 0-.224.542v3.048a.758.758 0 0 0 .778.762m0 6.096q-1.44 0-2.713-.543A7.02 7.02 0 0 1 9.554 19.3 6.5 6.5 0 0 1 9 16.644q0-1.41.555-2.658a7 7 0 0 1 1.506-2.18 7.2 7.2 0 0 1 2.227-1.476A6.8 6.8 0 0 1 16 9.786q1.206 0 2.314.38a7.6 7.6 0 0 1 2.08 1.105l.545-.533a.75.75 0 0 1 .544-.21q.33 0 .545.21.213.21.214.533a.72.72 0 0 1-.214.534l-.545.533a7.4 7.4 0 0 1 1.128 2.038q.39 1.086.389 2.267a6.5 6.5 0 0 1-.555 2.657 7 7 0 0 1-1.506 2.18 7.2 7.2 0 0 1-2.227 1.477A6.8 6.8 0 0 1 16 23.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gHOaN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewThisWeek);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewThisWeek = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#42CDFF",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#42CDFF",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#42CDFF",
                d: "M12.262 16.924v6.172a1.4 1.4 0 0 1-.391.974c-.25.259-.59.404-.945.404h-1.59c-.354 0-.694-.145-.945-.404A1.4 1.4 0 0 1 8 23.096v-6.172c0-.366.14-.717.39-.977.251-.26.591-.407.946-.41h1.59c.355.003.695.15.945.41s.391.611.391.977m5.87-4.001v10.2a1.4 1.4 0 0 1-.398.974 1.32 1.32 0 0 1-.948.403h-1.58c-.356 0-.697-.145-.949-.403a1.4 1.4 0 0 1-.396-.974v-10.2c0-.368.141-.72.393-.98.253-.26.595-.407.951-.407h1.582c.356 0 .698.146.95.406s.394.613.394.98M24 8.886v14.237a1.4 1.4 0 0 1-.397.974 1.32 1.32 0 0 1-.948.403h-1.581c-.355 0-.696-.145-.948-.403a1.4 1.4 0 0 1-.397-.974V8.886c0-.367.142-.72.394-.98s.594-.406.951-.406h1.581c.357 0 .699.146.951.406s.394.613.394.98"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1ClGD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewWorkoutsCompleted);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewWorkoutsCompleted = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 34,
        height: 34,
        fill: "none",
        viewBox: "0 0 34 34",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 34,
                height: 34,
                fill: "#0A0B29",
                rx: 17
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M24.75 18.914a.2.2 0 0 1-.023-.047c-.016-.052-1.723-5.238-6.006-7.3a2.1 2.1 0 0 1-.756-.744c-.012-.023-.196-.35-.835-.449a3 3 0 0 1 .108.338q.019.072.035.144.022.11.036.222c.006.043.015.086.018.13q.018.176.015.359a3.2 3.2 0 0 1-.172.978c.376.055.713.253.927.56.442.634.723 1.591.835 2.845 0 .024.003.86.42 1.611.261.283.517.613.76 1.007a.177.177 0 0 1-.065.247.19.19 0 0 1-.256-.063c-1.606-2.612-3.77-2.41-4.917-2.057a1.86 1.86 0 0 1-1.446-.134c-2.253-1.248-4.296-.031-4.876.377 0 0-.098 4.127-.327 6.85l2.557 1.313c.26-.122 1.12-.587 1.438-1.525.074-.216.13-.412.18-.585.131-.464.227-.8.517-.932.214-.096.479-.062.886.115q.169.076.343.138l.736.25c.145.05.269.084.388.11 1.771.37 3.697.177 5.15-.519 1.365-.651 2.124-.938 2.52-1.065a3.64 3.64 0 0 0 1.391-.79c.559-.514.7-.98.42-1.384m-1.625.102c-.137.563-.608 1.034-1.4 1.4a.19.19 0 0 1-.248-.085.177.177 0 0 1 .087-.24c.684-.316 1.087-.705 1.198-1.154.142-.575-.249-1.077-.252-1.082a.176.176 0 0 1 .033-.253.19.19 0 0 1 .26.032c.02.026.503.638.322 1.382"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M11.25 12.894q.015.03.03.059c.055.096.12.184.185.272.024.032.044.067.069.098.053.066.114.125.172.186.045.046.085.096.132.14.043.039.091.071.136.108.07.057.137.115.21.166.03.02.061.034.09.052.096.06.192.12.294.169l.057.022q.173.081.356.142.043.01.087.02c.115.033.23.064.35.084a3.2 3.2 0 0 0 .92.016c.12-.015.236-.042.352-.071.029-.007.06-.01.089-.018q.187-.054.364-.13.027-.01.054-.02c.108-.047.21-.105.311-.164q.04-.021.079-.042c.08-.051.155-.111.23-.169.041-.032.086-.06.126-.093.053-.045.099-.098.148-.147.056-.055.116-.107.167-.167.03-.034.053-.072.08-.107.065-.082.131-.164.187-.255q.018-.03.033-.06.1-.166.18-.345a2.8 2.8 0 0 0 .22-1.4q-.007-.06-.017-.117a3 3 0 0 0-.032-.195q-.014-.066-.032-.13a3 3 0 0 0-.172-.482q-.025-.054-.051-.106a3 3 0 0 0-.182-.31q-.027-.038-.057-.076a3 3 0 0 0-.265-.318q-.074-.075-.153-.146a3 3 0 0 0-.2-.165q-.077-.06-.16-.114a3 3 0 0 0-.326-.186q-.069-.036-.14-.068a3 3 0 0 0-.316-.117q-.058-.017-.116-.031a3 3 0 0 0-.264-.059l-.114-.02a3 3 0 0 0-.38-.032 3 3 0 0 0-.382.02q-.059.006-.116.015-.135.018-.265.05-.06.011-.117.026-.164.045-.32.106-.072.03-.143.063a3 3 0 0 0-.702.442 3 3 0 0 0-.267.252 3 3 0 0 0-.165.194q-.031.038-.062.077a3 3 0 0 0-.378.708q-.03.086-.056.171-.02.066-.038.133a3 3 0 0 0-.038.192q-.012.058-.02.118a2.795 2.795 0 0 0 .34 1.76m2.374-2.855.033-.006q.144-.025.294-.024.15.004.292.034l.034.008c.695.159 1.21.767 1.197 1.483a1.51 1.51 0 0 1-.97 1.37l-.008.002a1.6 1.6 0 0 1-.265.075l-.038.008a1.6 1.6 0 0 1-.295.023 1.6 1.6 0 0 1-.293-.034q-.019-.004-.038-.009a1.6 1.6 0 0 1-.263-.084l-.006-.002a1.51 1.51 0 0 1-.924-1.403c.013-.716.548-1.306 1.25-1.44"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"azXTR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewTrainingVolume);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewTrainingVolume = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 34,
        height: 34,
        fill: "none",
        viewBox: "0 0 34 34",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 34,
                height: 34,
                fill: "#0A0B29",
                rx: 17
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M16.64 7.906a4 4 0 0 1 4 4c0 .73-.19 1.41-.54 2h2.54c.95 0 1.75.67 1.95 1.56 2.01 8.01 2.05 8.22 2.05 8.44a2 2 0 0 1-2 2h-16a2 2 0 0 1-2-2c0-.22.04-.43 2.05-8.44.2-.89 1-1.56 1.95-1.56h2.54a3.9 3.9 0 0 1-.54-2 4 4 0 0 1 4-4m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-6 6v8h2v-2.5l1 1v1.5h2v-2l-2-2 2-2v-2h-2v1.5l-1 1v-2.5zm9 0c-1.11 0-2 .89-2 2v4c0 1.11.89 2 2 2h3v-5h-2v3h-1v-4h3v-2z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8oTli":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewCompletionRate);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewCompletionRate = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 34,
        height: 34,
        fill: "none",
        viewBox: "0 0 34 34",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 34,
                height: 34,
                fill: "#0A0B29",
                rx: 17
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M16.834 18.95a2.098 2.098 0 0 1-1.48-3.586.597.597 0 0 1 .839.847.9.9 0 0 0-.27.641.903.903 0 0 0 1.584.642.6.6 0 0 1 .847 0 .61.61 0 0 1 0 .847 2.12 2.12 0 0 1-1.52.61"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M24.956 16.853a8.114 8.114 0 1 1-8.115-8.115.594.594 0 0 1 .594.594v3.008a.6.6 0 0 1-.594.594 3.85 3.85 0 0 0-2.177.657 3.9 3.9 0 0 0-1.67 4.022 3.959 3.959 0 0 0 7.766-.792.586.586 0 0 1 .594-.594h3.008a.594.594 0 0 1 .594.626"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M24.666 12.205a.84.84 0 0 1-.182.42l-1.718 1.717a2.06 2.06 0 0 1-.878.523q-.294.09-.602.087a2.4 2.4 0 0 1-.42 0l-1.053-.206-1.805 1.813a.63.63 0 0 1-.42.174.6.6 0 0 1-.419-.174.585.585 0 0 1 0-.839l1.813-1.82-.214-1.046a2.2 2.2 0 0 1 .048-1.013 2.06 2.06 0 0 1 .522-.879L21.04 9.26a.8.8 0 0 1 .42-.198.7.7 0 0 1 .427.071c.131.067.24.168.317.293.078.14.11.3.095.46l-.253 1.789 1.781-.246a.745.745 0 0 1 .736.404c.065.114.1.241.103.372"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"67Zbc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewRecentActivity);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewRecentActivity = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#42CDFF",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#42CDFF",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                id: "b",
                width: 18,
                height: 18,
                x: 7,
                y: 7,
                maskUnits: "userSpaceOnUse",
                style: {
                    maskType: "luminance"
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        stroke: "#fff",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M23.083 15.997A7.083 7.083 0 0 1 16 23.081H8.916v-7.084a7.083 7.083 0 1 1 14.167 0"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "#000",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M12.458 13.875h6.375m-6.375 2.833h6.375m-6.375 2.834H16"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                mask: "url(#b)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#42CDFF",
                    d: "M7.5 7.5h17v17h-17z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dcY56":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewMyNotes);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewMyNotes = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#8163F3",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#8163F3",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#8163F3",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M13 17.405h6m-6-3.048h1.5M13 20.452h3M14.5 9.024h-3c-.398 0-.78.16-1.06.446-.282.286-.44.673-.44 1.078v11.428c0 .404.158.792.44 1.078.28.286.662.446 1.06.446h9c.398 0 .78-.16 1.06-.446.282-.286.44-.674.44-1.078V10.548c0-.405-.158-.792-.44-1.078a1.49 1.49 0 0 0-1.06-.446h-2.625m-3.375 0V7.5m0 1.524v1.524"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Yqg0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewViewAllArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewViewAllArrow = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "m6 12 4-4-4-4"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dMSpB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewAddNote);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewAddNote = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 18 18",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M3.75 9h10.5M9 3.75v10.5"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bzIGE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewAiObservations);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewAiObservations = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#755ADF",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                d: "M13.962 11.564c.399-1.166 2.01-1.202 2.483-.106l.04.107.538 1.573a2.67 2.67 0 0 0 1.518 1.608l.144.054 1.574.537c1.166.399 1.202 2.01.106 2.483l-.106.04-1.574.538a2.67 2.67 0 0 0-1.608 1.518l-.054.144-.537 1.574c-.399 1.166-2.01 1.202-2.483.106l-.041-.106-.537-1.574a2.67 2.67 0 0 0-1.518-1.608l-.144-.054-1.573-.537c-1.167-.399-1.203-2.01-.107-2.483l.107-.041 1.573-.537a2.67 2.67 0 0 0 1.608-1.518l.054-.144zm6.595-2.298a.67.67 0 0 1 .599.373l.032.078.233.684.685.233a.667.667 0 0 1 .079 1.23l-.079.032-.684.234-.233.684a.666.666 0 0 1-1.23.078l-.032-.078-.234-.684-.684-.233a.667.667 0 0 1-.079-1.23l.079-.032.684-.233.233-.685a.67.67 0 0 1 .631-.451"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"JeUzf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewProgramOverview);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewProgramOverview = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#71BE41",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#71BE41",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#71BE41",
                d: "M9 20.9c0 1.19.91 2.1 2.1 2.1h9.8c1.19 0 2.1-.91 2.1-2.1v-5.6H9zm11.9-10.5h-1.4v-.7c0-.42-.28-.7-.7-.7s-.7.28-.7.7v.7h-4.2v-.7c0-.42-.28-.7-.7-.7s-.7.28-.7.7v.7h-1.4c-1.19 0-2.1.91-2.1 2.1v1.4h14v-1.4c0-1.19-.91-2.1-2.1-2.1"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hRJ8o":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewSessionTime);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewSessionTime = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M22 23.99a.52.52 0 0 1-.144.36.48.48 0 0 1-.347.15H10.491a.48.48 0 0 1-.347-.15.52.52 0 0 1 0-.722.48.48 0 0 1 .347-.15h.642v-2.127c0-.367.076-.73.223-1.064a2.5 2.5 0 0 1 .63-.87l3.261-2.917-3.26-2.917a2.5 2.5 0 0 1-.63-.87 2.6 2.6 0 0 1-.224-1.064V9.52h-.642a.48.48 0 0 1-.347-.15.52.52 0 0 1 0-.721.48.48 0 0 1 .347-.15h11.018c.13 0 .255.054.347.15a.52.52 0 0 1 0 .722.48.48 0 0 1-.347.15h-.642v2.127c0 .367-.076.73-.223 1.064a2.5 2.5 0 0 1-.63.87L16.752 16.5l3.26 2.917c.268.24.483.536.63.87s.225.697.224 1.064v2.128h.642c.13 0 .255.053.347.15a.52.52 0 0 1 .144.36"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Ufbb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOverviewOverviewViewProgram);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOverviewOverviewViewProgram = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.7,
                fillRule: "evenodd",
                d: "M12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5M9.75 12a2.25 2.25 0 1 1 4.5 0 2.25 2.25 0 0 1-4.5 0",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.7,
                fillRule: "evenodd",
                d: "M12 3.25c-4.514 0-7.555 2.704-9.32 4.997l-.031.041c-.4.519-.767.996-1.016 1.56-.267.605-.383 1.264-.383 2.152s.116 1.547.383 2.152c.25.564.617 1.042 1.016 1.56l.032.041C4.445 18.046 7.486 20.75 12 20.75s7.555-2.704 9.32-4.997l.031-.041c.4-.518.767-.996 1.016-1.56.267-.605.383-1.264.383-2.152s-.116-1.547-.383-2.152c-.25-.564-.617-1.041-1.016-1.56l-.032-.041C19.555 5.954 16.514 3.25 12 3.25M3.87 9.162C5.498 7.045 8.15 4.75 12 4.75s6.501 2.295 8.13 4.412c.44.57.696.91.865 1.292.158.358.255.795.255 1.546s-.097 1.188-.255 1.546c-.169.382-.426.722-.864 1.292C18.5 16.955 15.85 19.25 12 19.25s-6.501-2.295-8.13-4.412c-.44-.57-.696-.91-.865-1.292-.158-.358-.255-.795-.255-1.546s.097-1.188.255-1.546c.169-.382.427-.722.865-1.292",
                clipRule: "evenodd"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kuHpn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AddNoteModal", ()=>AddNoteModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _reactRouterDom = require("react-router-dom");
var _button = require("src/components/Button/Button");
var _closeIconSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/close-icon.svg");
var _useClientNotesMutations = require("src/api/mutations/useClientNotesMutations");
var _addNoteModalScss = require("./AddNoteModal.scss");
const AddNoteModal = ({ open, onClose })=>{
    const { uid } = (0, _reactRouterDom.useParams)();
    const { mutate: addNote, isPending } = (0, _useClientNotesMutations.useAddClientNote)();
    const [title, setTitle] = (0, _react.useState)('');
    const [content, setContent] = (0, _react.useState)('');
    const [titleError, setTitleError] = (0, _react.useState)('');
    const [contentError, setContentError] = (0, _react.useState)('');
    const [serverError, setServerError] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        if (open) {
            setTitle('');
            setContent('');
            setTitleError('');
            setContentError('');
            setServerError('');
        }
    }, [
        open
    ]);
    const validate = ()=>{
        let isValid = true;
        setTitleError('');
        setContentError('');
        if (!title.trim()) {
            setTitleError('Title is required');
            isValid = false;
        } else if (!/[a-zA-Z]/.test(title)) {
            setTitleError('Title must contain at least one valid letter');
            isValid = false;
        } else if (title.length > 100) {
            setTitleError('Title cannot exceed 100 characters');
            isValid = false;
        }
        if (!content.trim()) {
            setContentError('Note content is required');
            isValid = false;
        } else if (!/[a-zA-Z]/.test(content)) {
            setContentError('Note content must contain at least one valid letter');
            isValid = false;
        }
        return isValid;
    };
    const handleSave = ()=>{
        if (!uid) return;
        if (validate()) {
            setServerError('');
            addNote({
                clientId: uid,
                title: title.trim(),
                description: content.trim()
            }, {
                onSuccess: ()=>{
                    onClose();
                },
                onError: (error)=>{
                    // Standardized API error code mapping
                    if (error.message.includes('ERR_INVALID_TITLE')) setTitleError('Title must contain valid characters');
                    else if (error.message.includes('ERR_INVALID_DESCRIPTION')) setContentError('Description must contain valid characters');
                    else setServerError(error.message || 'Failed to save note. Please try again.');
                }
            });
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: open,
        onCancel: onClose,
        footer: null,
        centered: true,
        width: 540,
        closeIcon: null,
        rootClassName: "add-note-modal assign-client-modal",
        className: "logout-modal",
        styles: {
            mask: {
                backdropFilter: 'blur(4px)',
                backgroundColor: 'rgba(6, 7, 35, 0.8)'
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "assign-client-content add-note-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "modal-title",
                            children: "Add Note"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "close-btn",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeIconSvg.ReactComponent), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-group title-group",
                    style: {
                        position: 'relative'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            children: "NOTE TITLE"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "input-wrapper",
                            style: {
                                position: 'relative'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                placeholder: "Enter a short title",
                                maxLength: 100,
                                value: title,
                                onChange: (e)=>{
                                    setTitle(e.target.value);
                                    if (titleError) setTitleError('');
                                },
                                onBlur: (e)=>setTitle(e.target.value.trim()),
                                style: {
                                    width: '100%',
                                    paddingRight: '50px',
                                    borderColor: titleError ? 'red' : undefined
                                }
                            })
                        }),
                        titleError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "error-message",
                            style: {
                                color: 'red',
                                fontSize: '12px',
                                marginTop: '4px',
                                display: 'block'
                            },
                            children: titleError
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-group note-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            children: [
                                "NOTE ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "char-count",
                                    children: [
                                        content.length,
                                        "/500"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "textarea-wrapper",
                            style: contentError ? {
                                borderColor: 'red'
                            } : {},
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                placeholder: "Write your note here...",
                                maxLength: 500,
                                value: content,
                                onChange: (e)=>{
                                    setContent(e.target.value);
                                    if (contentError) setContentError('');
                                },
                                onBlur: (e)=>setContent(e.target.value.trim())
                            })
                        }),
                        contentError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "error-message",
                            style: {
                                color: 'red',
                                fontSize: '12px',
                                marginTop: '4px',
                                display: 'block'
                            },
                            children: contentError
                        })
                    ]
                }),
                serverError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "server-error",
                    style: {
                        color: 'red',
                        fontSize: '12px',
                        marginBottom: '16px'
                    },
                    children: serverError
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            className: "btn-cancel",
                            onClick: onClose,
                            disabled: isPending,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            className: "btn-assign-primary btn-save",
                            onClick: handleSave,
                            disabled: isPending || !title.trim() && !content.trim(),
                            isLoading: isPending,
                            children: "Save"
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"react-router-dom":"9oT3O","src/components/Button/Button":"g0894","src/assets/images/onboarding-trainer/dashboard/programs/close-icon.svg":"ifISx","src/api/mutations/useClientNotesMutations":"10jH4","./AddNoteModal.scss":"8dtpa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ifISx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCloseIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCloseIcon = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#99A1AF",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M6 18 18 6M6 6l12 12"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"10jH4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAddClientNote", ()=>useAddClientNote);
parcelHelpers.export(exports, "useDeleteClientNote", ()=>useDeleteClientNote);
parcelHelpers.export(exports, "usePinClientNote", ()=>usePinClientNote);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
const addNote = async (params)=>{
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_ADD_CLIENT_NOTE}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    });
    if (!response.ok) {
        const errorData = await response.json().catch(()=>({}));
        throw new Error(errorData.error || 'Failed to add note');
    }
    return response.json();
};
const deleteNote = async (params)=>{
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_DELETE_CLIENT_NOTE}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    });
    if (!response.ok) {
        const errorData = await response.json().catch(()=>({}));
        throw new Error(errorData.error || 'Failed to delete note');
    }
    return response.json();
};
const pinNote = async (params)=>{
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_PIN_CLIENT_NOTE}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(params)
    });
    if (!response.ok) {
        const errorData = await response.json().catch(()=>({}));
        throw new Error(errorData.error || 'Failed to pin note');
    }
    return response.json();
};
const useAddClientNote = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: addNote,
        onSuccess: (_, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'clientNotes',
                    variables.clientId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientOverview',
                    variables.clientId
                ]
            });
        }
    });
};
const useDeleteClientNote = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: deleteNote,
        onSuccess: (_, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'clientNotes',
                    variables.clientId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientOverview',
                    variables.clientId
                ]
            });
        }
    });
};
const usePinClientNote = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: pinNote,
        onSuccess: (_, variables)=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'clientNotes',
                    variables.clientId
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientOverview',
                    variables.clientId
                ]
            });
        }
    });
};

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8dtpa":[function() {},{}],"29QSs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetClientOverview", ()=>useGetClientOverview);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _sessionStore = require("src/store/sessionStore");
const getClientOverview = async (clientId, trainerId)=>{
    if (!clientId) throw new Error('clientId is required');
    let apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_CLIENT_OVERVIEW}?clientId=${clientId}`;
    if (trainerId) apiUrl += `&trainerId=${trainerId}`;
    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        const errorData = await response.json().catch(()=>({}));
        throw new Error(errorData.error || 'Failed to fetch client overview');
    }
    const res = await response.json();
    return res.data;
};
const useGetClientOverview = (clientId)=>{
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const trainerId = currentUser?.uid;
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'clientOverview',
            clientId,
            trainerId
        ],
        queryFn: ()=>getClientOverview(clientId, trainerId),
        enabled: !!clientId
    });
};

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aiA54":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resolveBodyProfile", ()=>resolveBodyProfile);
parcelHelpers.export(exports, "isFemaleProfile", ()=>isFemaleProfile);
parcelHelpers.export(exports, "isMaleProfile", ()=>isMaleProfile);
const resolveBodyProfile = (source, fallback = 'male')=>{
    if (!source) return fallback;
    if (typeof source === 'string') {
        const s = source.trim().toLowerCase();
        if (s === 'female' || s === '2') return 'female';
        if (s === 'male' || s === '1') return 'male';
        return fallback;
    }
    const bp = (source.bodyProfile || source.body_profile || source.clientBodyProfile || source.backgroundImageGender || '').toString().trim().toLowerCase();
    if (bp === 'female') return 'female';
    if (bp === 'male') return 'male';
    const g = (source.gender ?? '').toString().trim().toLowerCase();
    if (g === 'female' || g === '2') return 'female';
    if (g === 'male' || g === '1') return 'male';
    return fallback;
};
const isFemaleProfile = (source)=>{
    return resolveBodyProfile(source) === 'female';
};
const isMaleProfile = (source)=>{
    return resolveBodyProfile(source) === 'male';
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eP8Ed":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientNotesTab", ()=>ClientNotesTab);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _clientNotesTabScss = require("./ClientNotesTab.scss");
var _navArrowIconSvg = require("src/assets/images/trainer/clients/nav-arrow-icon.svg");
var _dashboardViewArrowSvg = require("src/assets/images/trainer/clients/dashboard-view-arrow.svg");
var _overviewOverviewAddNoteSvg = require("src/assets/images/trainer/clients/overview-overview-add_note.svg");
var _overviewOverviewMyNotesSvg = require("src/assets/images/trainer/clients/overview-overview-my_notes.svg");
var _searchSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/search.svg");
var _pinSvg = require("src/assets/images/trainer/clients/pin.svg");
var _dashboardDeleteSvg = require("src/assets/images/trainer/clients/dashboard-delete.svg");
var _dashboardModalDeleteSvg = require("src/assets/images/trainer/clients/dashboard-modal-delete.svg");
var _button = require("src/components/Button/Button");
var _useDebounce = require("src/hooks/useDebounce");
var _useGetClientNotes = require("src/api/queries/useGetClientNotes");
var _useClientNotesMutations = require("src/api/mutations/useClientNotesMutations");
var _addNoteModal = require("./AddNoteModal/AddNoteModal");
const ClientNotesTab = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { uid } = (0, _reactRouterDom.useParams)();
    const [isAddNoteModalOpen, setIsAddNoteModalOpen] = (0, _react.useState)(false);
    const [noteToDelete, setNoteToDelete] = (0, _react.useState)(null);
    const [searchQuery, setSearchQuery] = (0, _react.useState)('');
    const [sortFilter, setSortFilter] = (0, _react.useState)('newest');
    const debouncedSearchQuery = (0, _useDebounce.useDebounce)(searchQuery, 500);
    const { data: notes = [], isLoading } = (0, _useGetClientNotes.useGetClientNotes)(uid || '', sortFilter, debouncedSearchQuery);
    const { mutate: deleteNoteMutate, isPending: isDeleting } = (0, _useClientNotesMutations.useDeleteClientNote)();
    const { mutate: pinNoteMutate, isPending: isPinning, variables: pinningVariables } = (0, _useClientNotesMutations.usePinClientNote)();
    const togglePin = (id, currentlyPinned)=>{
        if (!uid) return;
        pinNoteMutate({
            clientId: uid,
            noteId: id,
            pinned: !currentlyPinned
        });
    };
    const deleteNote = ()=>{
        if (!noteToDelete || !uid) return;
        deleteNoteMutate({
            clientId: uid,
            noteId: noteToDelete
        }, {
            onSuccess: ()=>{
                setNoteToDelete(null);
            }
        });
    };
    const formatDate = (isoStr)=>{
        try {
            const d = new Date(isoStr);
            if (isNaN(d.getTime())) return isoStr;
            const months = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ];
            const month = months[d.getMonth()];
            const day = d.getDate();
            const year = d.getFullYear();
            return `${month} ${day}, ${year}`;
        } catch  {
            return isoStr;
        }
    };
    const formatTime = (isoStr)=>{
        try {
            const d = new Date(isoStr);
            if (isNaN(d.getTime())) return isoStr;
            let hours = d.getHours();
            const minutes = d.getMinutes().toString().padStart(2, '0');
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12;
            hours = hours ? hours : 12; // the hour '0' should be '12'
            return `${hours}:${minutes} ${ampm}`;
        } catch  {
            return isoStr;
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "client-notes-tab",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "notes-header-bar",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "left-actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                className: "back-btn",
                                onClick: ()=>navigate(`/onboarding-trainer/dashboard/clients/${uid}/overview`),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navArrowIconSvg.ReactComponent), {
                                        className: "back-arrow"
                                    }),
                                    "My Notes"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "search-filter-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "search-input-wrapper",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchSvg.ReactComponent), {
                                                className: "search-icon"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "text",
                                                placeholder: "Search note",
                                                value: searchQuery,
                                                onChange: (e)=>setSearchQuery(e.target.value)
                                            }),
                                            searchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                onClick: ()=>setSearchQuery(''),
                                                className: "clear-search-btn",
                                                "aria-label": "Clear search",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                    width: "14",
                                                    height: "14",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                            x1: "18",
                                                            y1: "6",
                                                            x2: "6",
                                                            y2: "18"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                            x1: "6",
                                                            y1: "6",
                                                            x2: "18",
                                                            y2: "18"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                        menu: {
                                            items: [
                                                {
                                                    key: 'newest',
                                                    label: 'Newest first'
                                                },
                                                {
                                                    key: 'oldest',
                                                    label: 'Oldest first'
                                                },
                                                {
                                                    key: 'a-z',
                                                    label: 'Name (A-Z)'
                                                }
                                            ],
                                            onClick: (e)=>setSortFilter(e.key)
                                        },
                                        trigger: [
                                            'click'
                                        ],
                                        rootClassName: "dark-theme-dropdown",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "filter-dropdown",
                                            style: {
                                                cursor: 'pointer'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: sortFilter === 'newest' ? 'Newest first' : sortFilter === 'oldest' || sortFilter === 'older' ? 'Oldest first' : 'Name (A-Z)'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardViewArrowSvg.ReactComponent), {
                                                    className: "dropdown-arrow"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: "add-note-btn",
                        onClick: ()=>setIsAddNoteModalOpen(true),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewAddNoteSvg.ReactComponent), {}),
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: "Add Note"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "notes-list-container",
                children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "empty-state",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                        indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                            style: {
                                fontSize: 24,
                                color: '#fff'
                            },
                            spin: true
                        })
                    })
                }) : notes.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "empty-state",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "empty-icon-container",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewMyNotesSvg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: searchQuery ? `No results found for "${searchQuery}"` : 'No notes yet.'
                        })
                    ]
                }) : notes.map((note)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "note-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "note-info-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "note-date-box",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "date-part",
                                                children: [
                                                    formatDate(note.date).split(',')[0],
                                                    ","
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "year-part",
                                                children: formatDate(note.date).split(',')[1]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "note-body",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                className: "note-title",
                                                children: note.title
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "note-content",
                                                children: note.description
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "note-actions",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "top-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: `action-btn pin-btn ${note.pinned ? 'active' : ''}`,
                                                onClick: ()=>togglePin(note.id, !!note.pinned),
                                                disabled: isPinning && pinningVariables?.noteId === note.id,
                                                children: isPinning && pinningVariables?.noteId === note.id ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                    indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                        style: {
                                                            fontSize: 16,
                                                            color: '#fff'
                                                        },
                                                        spin: true
                                                    })
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pinSvg.ReactComponent), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "action-btn delete-btn",
                                                onClick: ()=>setNoteToDelete(note.id),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardDeleteSvg.ReactComponent), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "note-time",
                                        children: formatTime(note.date)
                                    })
                                ]
                            })
                        ]
                    }, note.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addNoteModal.AddNoteModal), {
                open: isAddNoteModalOpen,
                onClose: ()=>setIsAddNoteModalOpen(false)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: !!noteToDelete,
                footer: null,
                onCancel: ()=>setNoteToDelete(null),
                centered: true,
                width: 400,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "icon-wrapper delete",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardModalDeleteSvg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Delete Note?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Are you sure you want to delete this note?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-logout",
                                    onClick: deleteNote,
                                    disabled: isDeleting,
                                    isLoading: isDeleting,
                                    children: "Delete"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-cancel",
                                    onClick: ()=>setNoteToDelete(null),
                                    disabled: isDeleting,
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["useNavigate","f3cgC"],["useParams","9oT3O"]],"antd":[["Dropdown","cMU6A","default"],["Modal","kY4DD","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"./ClientNotesTab.scss":"d8Onr","src/assets/images/trainer/clients/nav-arrow-icon.svg":"3jSUC","src/assets/images/trainer/clients/dashboard-view-arrow.svg":"c6iRs","src/assets/images/trainer/clients/overview-overview-add_note.svg":"dMSpB","src/assets/images/trainer/clients/overview-overview-my_notes.svg":"dcY56","src/assets/images/onboarding-trainer/dashboard/clients/search.svg":"1z49p","src/assets/images/trainer/clients/pin.svg":"6xTbr","src/assets/images/trainer/clients/dashboard-delete.svg":"gvFKh","src/assets/images/trainer/clients/dashboard-modal-delete.svg":"4NTEi","src/components/Button/Button":"g0894","src/hooks/useDebounce":"fxOsA","src/api/queries/useGetClientNotes":"ak6RG","src/api/mutations/useClientNotesMutations":"10jH4","./AddNoteModal/AddNoteModal":"kuHpn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d8Onr":[function() {},{}],"3jSUC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNavArrowIcon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNavArrowIcon = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.7,
            strokeWidth: 2,
            d: "m9 18 6-6-6-6"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6xTbr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPin);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPin = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 18 18",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                fillOpacity: 0.5,
                d: "m7.5 5.5 4-4L16 6l-4 4-1.5 4L9 15.5 5.5 12 2 8.5 3.5 7z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M5.5 12 1 16.5M11 1l5.5 5.5m-5-5-4 4-4 1.5L2 8.5l7 7 1.5-1.5 1.5-4 4-4z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fxOsA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDebounce", ()=>useDebounce);
var _react = require("react");
function useDebounce(value, delay) {
    const [debouncedValue, setDebouncedValue] = (0, _react.useState)(value);
    (0, _react.useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedValue(value);
        }, delay);
        return ()=>{
            clearTimeout(handler);
        };
    }, [
        value,
        delay
    ]);
    return debouncedValue;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ak6RG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetClientNotes", ()=>useGetClientNotes);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
const getClientNotes = async (clientId, sortBy, search)=>{
    if (!clientId) throw new Error('clientId is required');
    const queryParams = new URLSearchParams({
        clientId,
        sort_by: sortBy,
        search: search
    });
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_CLIENT_NOTES}?${queryParams.toString()}`;
    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        const errorData = await response.json().catch(()=>({}));
        throw new Error(errorData.error || 'Failed to fetch notes');
    }
    const res = await response.json();
    return res.data;
};
const useGetClientNotes = (clientId, sortBy = 'newest', search = '')=>{
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'clientNotes',
            clientId,
            sortBy,
            search
        ],
        queryFn: ()=>getClientNotes(clientId, sortBy, search),
        enabled: !!clientId,
        staleTime: 0,
        gcTime: 0
    });
};

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9USUx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgramTab", ()=>ProgramTab);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _firebase = require("src/config/firebase");
var _programGeneratorProgressStore = require("src/store/programGeneratorProgressStore");
var _sessionStore = require("src/store/sessionStore");
var _reactRouterDom = require("react-router-dom");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _useGetClientProgramTab = require("src/api/queries/useGetClientProgramTab");
var _emptyState = require("./EmptyState");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _useUpdateProgramSchedule = require("src/api/mutations/useUpdateProgramSchedule");
var _reactQuery = require("@tanstack/react-query");
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _intensitySetupSvg = require("../../ProgramGeneratorAI/../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg");
var _programGoalsSvg = require("../../ProgramGeneratorAI/../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/program_goals.svg");
var _goalApproachSvg = require("../../ProgramGeneratorAI/../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/goal_approach.svg");
var _planStructureSvg = require("../../ProgramGeneratorAI/../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/plan_structure.svg");
var _editSvg = require("../../ProgramGeneratorAI/../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/edit.svg");
var _weightSvg = require("../../ProgramGeneratorAI/../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/weight.svg");
var _equipmentIcons = require("src/utils/equipmentIcons");
var _genderUtils = require("src/utils/genderUtils");
var _intensityCard = require("./ProgramTab/IntensityCard");
var _equipmentsModal = require("./ProgramTab/EquipmentsModal");
var _programFemalePng = require("url:../../ProgramGeneratorAI/assets/client/program-female.png");
var _programFemalePngDefault = parcelHelpers.interopDefault(_programFemalePng);
var _programMalePng = require("url:../../ProgramGeneratorAI/assets/client/program-male.png");
var _programMalePngDefault = parcelHelpers.interopDefault(_programMalePng);
var _programWorkoutPerformanceAdherenceSvg = require("src/assets/images/trainer/clients/program_workout_performance_adherence.svg");
var _programWorkoutSvg = require("src/assets/images/trainer/clients/program_workout.svg");
var _overviewOverviewProgramOverviewSvg = require("src/assets/images/trainer/clients/overview-overview-program-overview.svg");
var _overviewHeaderCalendarSvg = require("src/assets/images/trainer/clients/overview-header-calendar.svg");
var _moreProgramWorkoutSvg = require("src/assets/images/trainer/clients/more_program_workout.svg");
var _navArrowIconSvg = require("src/assets/images/trainer/clients/nav-arrow-icon.svg");
var _notificationSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/notification.svg");
var _onboardModalInfoSvg = require("src/assets/images/trainer/clients/onboard-modal-info.svg");
const getLocalYMD = (d)=>{
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const dayNum = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${dayNum}`;
};
const ProgramTab = ()=>{
    const { client } = (0, _reactRouterDom.useOutletContext)();
    const clientId = client?.uid;
    const clientName = client ? `${client.name || ''} ${client.surname || ''}`.trim() : undefined;
    const currentUser = (0, _sessionStore.sessionStore)((state)=>state.currentUser);
    const trainerUid = (0, _firebase.auth).currentUser?.uid || currentUser?.uid || '';
    const { data: programData, isLoading } = (0, _useGetClientProgramTab.useGetClientProgramTab)(clientId, trainerUid);
    const { data: masterData } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const updateProgramSchedule = (0, _useUpdateProgramSchedule.useUpdateProgramSchedule)();
    const getSlugTitle = (slug)=>{
        if (!slug) return '';
        let result = null;
        if (masterData) {
            const search = (obj)=>{
                if (result) return;
                if (!obj || typeof obj !== 'object') return;
                if ((obj.slug === slug || obj.id === slug) && obj.title) {
                    result = obj.title;
                    return;
                }
                if (Array.isArray(obj)) obj.forEach(search);
                else Object.values(obj).forEach(search);
            };
            search(masterData);
        }
        if (result) return result;
        return String(slug).replace(/_/g, '-').split('-').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };
    const weeksData = programData?.weeksData || [];
    const [activeWeek, setActiveWeek] = (0, _react.useState)(weeksData.length > 0 ? weeksData[0].week : 1);
    const [activeDayIndex, setActiveDayIndex] = (0, _react.useState)(0);
    const [isEquipmentsModalOpen, setIsEquipmentsModalOpen] = (0, _react.useState)(false);
    const minWeek = weeksData.length > 0 ? weeksData[0].week : 1;
    const maxWeek = weeksData.length > 0 ? weeksData[weeksData.length - 1].week : 1;
    const isFirstWeek = activeWeek <= minWeek;
    const isLastWeek = activeWeek >= maxWeek;
    const handlePrevWeekTab = ()=>{
        if (!isFirstWeek) setActiveWeek((prev)=>Math.max(minWeek, prev - 1));
    };
    const handleNextWeekTab = ()=>{
        if (!isLastWeek) setActiveWeek((prev)=>Math.min(maxWeek, prev + 1));
    };
    (0, _react.useEffect)(()=>{
        setActiveDayIndex(0);
        if (weeksListRef.current) {
            const activeEl = weeksListRef.current.querySelector('.active');
            if (activeEl) {
                const container = weeksListRef.current;
                const scrollLeft = activeEl.offsetLeft - container.clientWidth / 2 + activeEl.clientWidth / 2;
                container.scrollTo({
                    left: Math.max(0, scrollLeft),
                    behavior: 'smooth'
                });
            }
        }
    }, [
        activeWeek
    ]);
    const activeWeekData = weeksData.find((w)=>w.week === activeWeek) || {
        days: []
    };
    const exercisesToRender = activeWeekData.days[activeDayIndex]?.exercises || [];
    const getSelectedWorkoutId = ()=>{
        const activeDay = activeWeekData?.days?.[activeDayIndex];
        if (activeDay?.dateYmd && programData?.datetimeList) {
            const rawDt = [
                ...programData.datetimeList || []
            ].filter((dt)=>dt?.ymd).sort((a, b)=>(a.ymd || '').localeCompare(b.ymd || ''));
            const foundIdx = rawDt.findIndex((dt)=>dt.ymd === activeDay.dateYmd);
            if (foundIdx !== -1) return foundIdx + 1;
        }
        let globalWorkoutIndex = 0;
        for (const w of weeksData){
            if (w.week === activeWeek) {
                globalWorkoutIndex += activeDayIndex + 1;
                return globalWorkoutIndex;
            }
            globalWorkoutIndex += w.days?.length || 0;
        }
        return 1;
    };
    const [visibleThumbnails, setVisibleThumbnails] = (0, _react.useState)(7);
    const weeksListRef = (0, _react.useRef)(null);
    const thumbnailsContainerRef = (0, _react.useRef)(null);
    const [isPlanCalendarModalOpen, setIsPlanCalendarModalOpen] = (0, _react.useState)(false);
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [modalTab, setModalTab] = (0, _react.useState)('permanent');
    const [modalDate, setModalDate] = (0, _react.useState)(new Date());
    const [currentDate, setCurrentDate] = (0, _react.useState)(new Date());
    const [draftDatetimeList, setDraftDatetimeList] = (0, _react.useState)([]);
    const [selectedSource, setSelectedSource] = (0, _react.useState)(null);
    const [inlineError, setInlineError] = (0, _react.useState)(null);
    const chartContentRef = (0, _react.useRef)(null);
    const isDraggingChartRef = (0, _react.useRef)(false);
    const chartStartXRef = (0, _react.useRef)(0);
    const chartScrollLeftRef = (0, _react.useRef)(0);
    const [chartScrollInfo, setChartScrollInfo] = (0, _react.useState)({
        scrollProgress: 0,
        thumbWidth: 30,
        isScrollable: false,
        canScrollLeft: false,
        canScrollRight: false
    });
    const updateChartScroll = ()=>{
        if (chartContentRef.current) {
            const { scrollLeft, scrollWidth, clientWidth } = chartContentRef.current;
            const maxScroll = scrollWidth - clientWidth;
            const isScrollable = maxScroll > 2;
            const thumbRatio = Math.max(0.15, Math.min(1, clientWidth / scrollWidth));
            const thumbWidthPercent = thumbRatio * 100;
            const scrollPercent = maxScroll > 0 ? scrollLeft / maxScroll : 0;
            setChartScrollInfo({
                scrollProgress: scrollPercent,
                thumbWidth: thumbWidthPercent,
                isScrollable,
                canScrollLeft: scrollLeft > 5,
                canScrollRight: scrollLeft < maxScroll - 5
            });
        }
    };
    const handleScrollChart = (direction)=>{
        if (chartContentRef.current) {
            const scrollAmount = Math.max(260, chartContentRef.current.clientWidth * 0.6);
            chartContentRef.current.scrollBy({
                left: direction === 'left' ? -scrollAmount : scrollAmount,
                behavior: 'smooth'
            });
        }
    };
    const handleChartMouseDown = (e)=>{
        if (!chartContentRef.current) return;
        isDraggingChartRef.current = true;
        chartStartXRef.current = e.pageX - chartContentRef.current.offsetLeft;
        chartScrollLeftRef.current = chartContentRef.current.scrollLeft;
    };
    const handleChartMouseMove = (e)=>{
        if (!isDraggingChartRef.current || !chartContentRef.current) return;
        e.preventDefault();
        const x = e.pageX - chartContentRef.current.offsetLeft;
        const walk = (x - chartStartXRef.current) * 1.5;
        chartContentRef.current.scrollLeft = chartScrollLeftRef.current - walk;
    };
    const handleChartMouseUpOrLeave = ()=>{
        isDraggingChartRef.current = false;
    };
    (0, _react.useEffect)(()=>{
        updateChartScroll();
        const handleResize = ()=>updateChartScroll();
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, [
        programData
    ]);
    (0, _react.useEffect)(()=>{
        if (isPlanCalendarModalOpen && programData?.datetimeList) {
            const dtList = JSON.parse(JSON.stringify(programData.datetimeList));
            setDraftDatetimeList(dtList);
            setModalDate(new Date());
            setSelectedSource(null);
            setInlineError(null);
            setModalTab('permanent');
        }
    }, [
        isPlanCalendarModalOpen,
        programData
    ]);
    const handleEditProgram = (stepSlug, subStepSlug)=>{
        if (!programData) return;
        const store = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState();
        const pid = programData.programId || programData.id || '';
        store.resetProgress();
        store.setClientId(clientId);
        if (pid) store.setProgramId(pid);
        if (programData.progress) store.setProgress(programData.progress);
        const queryParams = new URLSearchParams({
            clientId
        });
        if (pid) queryParams.set('programId', pid);
        if (stepSlug) queryParams.set('step', stepSlug);
        if (subStepSlug) queryParams.set('subStep', subStepSlug);
        const goal = programData.progress?.training_goal?.[0]?.value || (programData.primaryGoal ? String(programData.primaryGoal).toLowerCase().replace(/[\s_]+/g, '-') : '');
        if (goal) queryParams.set('goal', goal);
        queryParams.set('editMode', 'true');
        navigate(`/onboarding-trainer/dashboard/program-generator/ai?${queryParams.toString()}`);
    };
    const updateItemDateFields = (item, newYmd)=>{
        const [y, m, d] = newYmd.split('-');
        const dObj = new Date(Number(y), Number(m) - 1, Number(d));
        const weekdayNames = [
            'Sunday',
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday'
        ];
        const weekday2Names = [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ];
        const jsDay = dObj.getDay();
        return {
            ...item,
            ymd: newYmd,
            year: Number(y),
            month: Number(m),
            day: String(Number(d)),
            weekday: weekdayNames[jsDay],
            weekday2: weekday2Names[jsDay],
            weekdayNum: jsDay === 0 ? 7 : jsDay
        };
    };
    const handleDayClick = (day)=>{
        if (day.isPast || updateProgramSchedule.isPending) return;
        setInlineError(null);
        if (modalTab === 'temporary') {
            if (!selectedSource) {
                if (day.isWorkout) setSelectedSource(day.ymd);
            } else {
                if (day.ymd === selectedSource) setSelectedSource(null);
                else if (!day.isWorkout) {
                    // Move workout
                    const newList = [
                        ...draftDatetimeList
                    ];
                    const itemIndex = newList.findIndex((item)=>item.ymd === selectedSource);
                    if (itemIndex !== -1) {
                        newList[itemIndex] = updateItemDateFields(newList[itemIndex], day.ymd);
                        setDraftDatetimeList(newList);
                        setSelectedSource(null);
                    }
                } else setInlineError('Destination date already contains a workout');
            }
        } else if (modalTab === 'permanent') {
            if (selectedSource === null) {
                if (day.isWorkout) setSelectedSource(day.jsWeekday);
            } else if (day.jsWeekday === selectedSource) setSelectedSource(null);
            else {
                // Check if destination weekday already has workouts in the future
                const destHasWorkout = draftDatetimeList.some((item)=>{
                    if (item.ymd < getLocalYMD(new Date())) return false;
                    const [y, m, d] = item.ymd.split('-');
                    const dateObj = new Date(Number(y), Number(m) - 1, Number(d));
                    return dateObj.getDay() === day.jsWeekday;
                });
                if (destHasWorkout) {
                    setInlineError('Destination weekday already has a workout scheduled');
                    return;
                }
                const sourceWeekday = selectedSource;
                const destWeekday = day.jsWeekday;
                const sourceIso = sourceWeekday === 0 ? 7 : sourceWeekday;
                const destIso = destWeekday === 0 ? 7 : destWeekday;
                const diff = destIso - sourceIso;
                const todayYmd = getLocalYMD(new Date());
                const newList = draftDatetimeList.map((item)=>{
                    if (item.ymd <= todayYmd) return item;
                    const [y, m, d] = item.ymd.split('-');
                    const dateObj = new Date(Number(y), Number(m) - 1, Number(d));
                    if (dateObj.getDay() === sourceWeekday) {
                        const targetDate = new Date(dateObj);
                        targetDate.setDate(targetDate.getDate() + diff);
                        if (getLocalYMD(targetDate) <= todayYmd) targetDate.setDate(targetDate.getDate() + 7);
                        const newYmd = getLocalYMD(targetDate);
                        // Only move if new date is strictly in the future and no collision
                        if (newYmd > todayYmd && !draftDatetimeList.some((w)=>w.ymd === newYmd)) return updateItemDateFields(item, newYmd);
                    }
                    return item;
                });
                setDraftDatetimeList(newList);
                setSelectedSource(null);
            }
        }
    };
    const generateModalCalendarDays = (date)=>{
        const year = date.getFullYear();
        const month = date.getMonth();
        const firstDayOfMonth = new Date(year, month, 1);
        const lastDayOfMonth = new Date(year, month + 1, 0);
        const daysInMonth = lastDayOfMonth.getDate();
        let startDayOfWeek = firstDayOfMonth.getDay() - 1;
        if (startDayOfWeek === -1) startDayOfWeek = 6;
        const days = [];
        const today = new Date();
        const todayY = today.getFullYear();
        const todayM = today.getMonth();
        const todayD = today.getDate();
        const todayYmd = getLocalYMD(today);
        const prevMonthLastDay = new Date(year, month, 0).getDate();
        const prevMonth = month === 0 ? 11 : month - 1;
        const prevYear = month === 0 ? year - 1 : year;
        for(let i = startDayOfWeek - 1; i >= 0; i--){
            const d = prevMonthLastDay - i;
            days.push({
                date: d,
                isCurrentMonth: false,
                isToday: d === todayD && prevMonth === todayM && prevYear === todayY,
                month: prevMonth,
                year: prevYear
            });
        }
        for(let i = 1; i <= daysInMonth; i++)days.push({
            date: i,
            isCurrentMonth: true,
            isToday: i === todayD && month === todayM && year === todayY,
            month: month,
            year: year
        });
        const totalDays = days.length;
        const remainingDays = 42 - totalDays;
        const nextMonth = month === 11 ? 0 : month + 1;
        const nextYear = month === 11 ? year + 1 : year;
        for(let i = 1; i <= remainingDays; i++)days.push({
            date: i,
            isCurrentMonth: false,
            isToday: i === todayD && nextMonth === todayM && nextYear === todayY,
            month: nextMonth,
            year: nextYear
        });
        return days.map((day, index)=>{
            const colIndex = index % 7;
            const jsWeekday = (colIndex + 1) % 7;
            const mStr = String(day.month + 1).padStart(2, '0');
            const dStr = String(day.date).padStart(2, '0');
            const ymd = `${day.year}-${mStr}-${dStr}`;
            const isPast = ymd <= todayYmd;
            const isWorkout = draftDatetimeList.some((item)=>item.ymd === ymd);
            let isSelectedSource = false;
            if (modalTab === 'temporary') isSelectedSource = selectedSource === ymd;
            else if (modalTab === 'permanent') isSelectedSource = selectedSource === jsWeekday && isWorkout;
            return {
                ...day,
                isWorkout,
                ymd,
                jsWeekday,
                isPast,
                isSelectedSource
            };
        });
    };
    // Fixed frequency and days from original program plan
    const originalPlanDaysInfo = (0, _react.useMemo)(()=>{
        const dayNames = [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ];
        const howOften = programData?.progress?.how_often_train || programData?.progress?.howOftenTrain;
        if (Array.isArray(howOften) && howOften.length > 0) {
            const WEEKDAY_MAP = {
                sunday: {
                    name: 'Sun',
                    order: 7
                },
                monday: {
                    name: 'Mon',
                    order: 1
                },
                tuesday: {
                    name: 'Tue',
                    order: 2
                },
                wednesday: {
                    name: 'Wed',
                    order: 3
                },
                thursday: {
                    name: 'Thu',
                    order: 4
                },
                friday: {
                    name: 'Fri',
                    order: 5
                },
                saturday: {
                    name: 'Sat',
                    order: 6
                }
            };
            const days = howOften.map((item)=>{
                const key = String(item?.slug || item?.value || item || '').trim().toLowerCase();
                return WEEKDAY_MAP[key];
            }).filter(Boolean);
            if (days.length > 0) {
                days.sort((a, b)=>a.order - b.order);
                return {
                    daysString: days.map((d)=>d.name).join(' / '),
                    frequency: days.length
                };
            }
        }
        if (programData?.planCalendar?.workoutDays && Array.isArray(programData.planCalendar.workoutDays) && programData.planCalendar.workoutDays.length > 0) {
            const sorted = [
                ...programData.planCalendar.workoutDays
            ].sort((a, b)=>{
                const aVal = a === 0 ? 7 : a;
                const bVal = b === 0 ? 7 : b;
                return aVal - bVal;
            });
            return {
                daysString: sorted.map((d)=>dayNames[d]).join(' / '),
                frequency: sorted.length
            };
        }
        if (programData?.datetimeList && Array.isArray(programData.datetimeList) && programData.datetimeList.length > 0) {
            const daysSet = new Set();
            programData.datetimeList.forEach((item)=>{
                if (!item?.ymd) return;
                const [y, m, d] = item.ymd.split('-');
                daysSet.add(new Date(Number(y), Number(m) - 1, Number(d)).getDay());
            });
            const sorted = Array.from(daysSet).sort((a, b)=>{
                const aVal = a === 0 ? 7 : a;
                const bVal = b === 0 ? 7 : b;
                return aVal - bVal;
            });
            return {
                daysString: sorted.map((d)=>dayNames[d]).join(' / '),
                frequency: sorted.length
            };
        }
        return {
            daysString: 'Mon / Wed / Thu / Fri',
            frequency: 4
        };
    }, [
        programData
    ]);
    const modalPlanDaysInfo = (0, _react.useMemo)(()=>{
        const dayNames = [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ];
        const todayYmd = getLocalYMD(new Date());
        if (modalTab === 'permanent' && draftDatetimeList && draftDatetimeList.length > 0) {
            const futureWorkouts = draftDatetimeList.filter((item)=>item?.ymd && item.ymd >= todayYmd);
            const targetList = futureWorkouts.length > 0 ? futureWorkouts : draftDatetimeList;
            const daysSet = new Set();
            targetList.forEach((item)=>{
                if (!item?.ymd) return;
                const [y, m, d] = item.ymd.split('-');
                daysSet.add(new Date(Number(y), Number(m) - 1, Number(d)).getDay());
            });
            const sorted = Array.from(daysSet).sort((a, b)=>{
                const aVal = a === 0 ? 7 : a;
                const bVal = b === 0 ? 7 : b;
                return aVal - bVal;
            });
            if (sorted.length > 0) return {
                daysString: sorted.map((d)=>dayNames[d]).join(' / '),
                frequency: sorted.length
            };
        }
        return originalPlanDaysInfo;
    }, [
        modalTab,
        draftDatetimeList,
        originalPlanDaysInfo
    ]);
    const handleSaveCalendarChanges = async ()=>{
        try {
            const trainerId = programData?.trainerId || (0, _sessionStore.sessionStore).getState().currentUser?.uid || '';
            const programId = programData?.programId || programData?.id || '';
            const WEEKDAY_ORDER = {
                monday: 1,
                tuesday: 2,
                wednesday: 3,
                thursday: 4,
                friday: 5,
                saturday: 6,
                sunday: 7
            };
            let howOftenTrain = undefined;
            if (modalTab === 'permanent') {
                const uniqueDaySlugs = new Set();
                draftDatetimeList.forEach((item)=>{
                    const w = String(item.weekday || '').trim().toLowerCase();
                    if (w && WEEKDAY_ORDER[w]) uniqueDaySlugs.add(w);
                });
                const sortedDays = Array.from(uniqueDaySlugs).sort((a, b)=>(WEEKDAY_ORDER[a] || 99) - (WEEKDAY_ORDER[b] || 99));
                howOftenTrain = sortedDays.map((d)=>({
                        slug: d,
                        value: d
                    }));
            }
            await updateProgramSchedule.mutateAsync({
                clientId: clientId,
                trainerId: trainerId,
                programId: programId,
                datetimeList: draftDatetimeList,
                changeType: modalTab,
                howOftenTrain: howOftenTrain
            });
            // Refresh the dashboard data
            await Promise.all([
                queryClient.invalidateQueries({
                    queryKey: [
                        'clientProgramTab'
                    ]
                }),
                queryClient.invalidateQueries({
                    queryKey: [
                        'clientWorkoutsTab'
                    ]
                }),
                queryClient.invalidateQueries({
                    queryKey: [
                        'clientOverview'
                    ]
                })
            ]);
            (0, _reactHotToastDefault.default).success('Program schedule updated successfully');
            setModalTab('permanent');
            setIsPlanCalendarModalOpen(false);
            // Reset Plan Calendar tab to index 0 (Week 1)
            setActiveWeek(1);
        } catch  {
            setInlineError('Failed to update program schedule');
        }
    };
    const currentModalCalendarDays = generateModalCalendarDays(modalDate);
    const handleModalPrevMonth = ()=>{
        setModalDate(new Date(modalDate.getFullYear(), modalDate.getMonth() - 1, 1));
    };
    const handleModalNextMonth = ()=>{
        setModalDate(new Date(modalDate.getFullYear(), modalDate.getMonth() + 1, 1));
    };
    const getWeekDays = (date)=>{
        const start = new Date(date);
        const day = start.getDay();
        const diff = start.getDate() - day + (day === 0 ? -6 : 1);
        start.setDate(diff);
        const days = [];
        for(let i = 0; i < 7; i++){
            const d = new Date(start);
            d.setDate(start.getDate() + i);
            days.push(d);
        }
        return days;
    };
    const currentWeekDays = getWeekDays(currentDate);
    const formatWeekRange = (days)=>{
        const start = days[0];
        const end = days[6];
        const startMonth = start.toLocaleString('en-US', {
            month: 'short'
        });
        const endMonth = end.toLocaleString('en-US', {
            month: 'short'
        });
        if (startMonth === endMonth) return `${start.getDate()} - ${end.getDate()} ${startMonth}`;
        return `${start.getDate()} ${startMonth} - ${end.getDate()} ${endMonth}`;
    };
    const handlePrevWeek = ()=>{
        const newDate = new Date(currentDate);
        newDate.setDate(newDate.getDate() - 7);
        setCurrentDate(newDate);
    };
    const handleNextWeek = ()=>{
        const newDate = new Date(currentDate);
        newDate.setDate(newDate.getDate() + 7);
        setCurrentDate(newDate);
    };
    // Sync week calendar view to program date range
    (0, _react.useEffect)(()=>{
        if (programData?.datetimeList && programData.datetimeList.length > 0) {
            setCurrentDate(new Date());
            setModalDate(new Date());
        }
    }, [
        programData
    ]);
    (0, _react.useEffect)(()=>{
        const updateVisibleCount = ()=>{
            if (thumbnailsContainerRef.current) {
                // Get container width and calculate how many 76px thumbnails + 6px gaps (82px) can fit.
                // We subtract 1 to reserve space for the .more-btn which is always displayed.
                const containerWidth = thumbnailsContainerRef.current.clientWidth;
                const maxItems = Math.max(1, Math.floor(containerWidth / 82) - 1);
                setVisibleThumbnails(maxItems);
            }
        };
        updateVisibleCount();
        window.addEventListener('resize', updateVisibleCount);
        return ()=>window.removeEventListener('resize', updateVisibleCount);
    }, []);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "program-tab-content loading",
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 400,
            gap: 16
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                    style: {
                        fontSize: 32,
                        color: '#ffa100'
                    },
                    spin: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                style: {
                    fontSize: 16,
                    fontWeight: 500,
                    color: '#ffffffb3'
                },
                children: "Loading Program"
            })
        ]
    });
    const isDraftProgram = programData?.isDraft === true || programData?.status === 'draft';
    const generatorType = programData?.generatorType === 'manual' || programData?.isManually === true || programData?.type === 'manual' ? 'manual' : 'ai';
    if (!programData || programData.status === 'no_program' || !programData.programId || isDraftProgram) {
        const isInactive = client?.is_active === false || client?.isActive === false;
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "program-tab-content",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "dashboard-empty-state-wrapper",
                style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    minHeight: '400px',
                    width: '100%'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyState.EmptyState), {
                    message: isInactive ? 'This client is currently inactive. Activate this client to create and assign programs.' : isDraftProgram ? 'You have an unfinished program draft for this client.' : 'No program yet.',
                    buttonText: isInactive ? undefined : isDraftProgram ? 'Continue to Finish Program' : 'Create Your First Program',
                    onButtonClick: isInactive ? undefined : isDraftProgram ? ()=>navigate(`/onboarding-trainer/dashboard/program-generator/${generatorType}?programId=${programData?.programId}`) : ()=>navigate('/onboarding-trainer/dashboard'),
                    hideIcon: true,
                    hideMessage: false,
                    marginTop: "0"
                })
            })
        });
    }
    const isManuallyGenerated = programData?.isManually === true || programData?.isAIGenerate === false || !programData?.progress?.training_goal;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "program-tab-content",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "program-cards-grid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "program-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _intensitySetupSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Intensity & Setup"
                                    }),
                                    !isManuallyGenerated && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {
                                            onClick: ()=>handleEditProgram('program-intensity'),
                                            style: {
                                                cursor: 'pointer'
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row align-center space-between",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "label",
                                                children: [
                                                    "Intensity: ",
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: getSlugTitle(programData.intensity)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "value-dots",
                                                children: Array.from({
                                                    length: 6
                                                }).map((_, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: `dot ${idx < (0, _intensityCard.getIntensityActiveDots)(programData?.intensity) ? 'active' : ''}`
                                                    }, idx))
                                            })
                                        ]
                                    }),
                                    (()=>{
                                        const equipments = programData.equipments || [];
                                        const visibleEquipments = equipments.slice(0, 3);
                                        const remainingCount = equipments.length - 3;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                visibleEquipments.map((eq, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "info-row align-center space-between",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "value",
                                                                children: getSlugTitle(eq)
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "icon-img",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _equipmentIcons.EquipmentIcon), {
                                                                    slug: eq
                                                                })
                                                            })
                                                        ]
                                                    }, i)),
                                                equipments.length > 3 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "show-more-toggle",
                                                    onClick: ()=>setIsEquipmentsModalOpen(true),
                                                    children: [
                                                        "Show +",
                                                        remainingCount
                                                    ]
                                                })
                                            ]
                                        });
                                    })()
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "program-card has-bg-image",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programGoalsSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Program Goals"
                                    }),
                                    !isManuallyGenerated && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {
                                            onClick: ()=>handleEditProgram('training-goal'),
                                            style: {
                                                cursor: 'pointer'
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: "Primary Goal"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value highlight",
                                                children: getSlugTitle(programData.primaryGoal)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-group",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: "Priority Focus"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: programData.priorityFocus.map(getSlugTitle).join(', ') || 'Not specified'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _genderUtils.isFemaleProfile)(client) ? (0, _programFemalePngDefault.default) : (0, _programMalePngDefault.default),
                                className: "bg-image",
                                alt: "Program Goal"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "program-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _goalApproachSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Goal Approach"
                                    }),
                                    !isManuallyGenerated && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {
                                            onClick: ()=>handleEditProgram('training-goal-details', 'training-goal-approaches'),
                                            style: {
                                                cursor: 'pointer'
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body approach-body",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "left-col",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "info-group",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Approach"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: getSlugTitle(programData.goalApproach) || 'Not specified'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "info-group",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Method"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: programData.goalMethod.map(getSlugTitle).join(' / ') || 'Not specified'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "right-col chart-bars",
                                        children: [
                                            60,
                                            40,
                                            60,
                                            30,
                                            80,
                                            50,
                                            70,
                                            90,
                                            60,
                                            40
                                        ].map((h, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: `bar bar-h${h}`
                                            }, i))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "program-card program-status",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planStructureSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Program Status"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {
                                            onClick: ()=>handleEditProgram('program-duration'),
                                            style: {
                                                cursor: 'pointer'
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body ",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row align-center status-grid",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: "Time"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "value",
                                                children: [
                                                    programData.timeMin,
                                                    " min"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row align-center status-grid",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: "Week"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: String(programData.currentWeek).toLowerCase().includes('not started') ? `Not started (${programData.totalWeeks || ''})`.replace('()', '').trim() : `${programData.currentWeek} of ${programData.totalWeeks}`
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row align-center status-grid",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: "Frequency"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: programData.frequency
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row align-center status-grid",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: "Status"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `status-badge ${(programData.status || 'active').toLowerCase()}`,
                                                children: (programData.status || 'active').toUpperCase()
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "middle-cards-grid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "program-card today-workout-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programWorkoutSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "main-title",
                                                children: [
                                                    client?.name || 'Client',
                                                    "'s today workout "
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "subtitle",
                                                children: [
                                                    "\u2022 ",
                                                    programData.todayWorkout.day,
                                                    ", ",
                                                    programData.todayWorkout.date
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {
                                            onClick: ()=>navigate(`/onboarding-trainer/dashboard/program-generated/${programData.programId}`, {
                                                    state: {
                                                        clientId,
                                                        clientName,
                                                        isManually: isManuallyGenerated,
                                                        generatorType: isManuallyGenerated ? 'manual' : 'ai'
                                                    }
                                                }),
                                            style: {
                                                cursor: 'pointer'
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "week-selector",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `nav-arrow left ${isFirstWeek ? 'disabled' : ''}`,
                                                onClick: handlePrevWeekTab,
                                                style: isFirstWeek ? {
                                                    opacity: 0.25,
                                                    cursor: 'not-allowed',
                                                    pointerEvents: 'none'
                                                } : {
                                                    cursor: 'pointer'
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navArrowIconSvg.ReactComponent), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "weeks-list",
                                                ref: weeksListRef,
                                                children: weeksData.map((weekObj)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: activeWeek === weekObj.week ? 'active' : '',
                                                        onClick: ()=>setActiveWeek(weekObj.week),
                                                        children: [
                                                            "Week ",
                                                            weekObj.week
                                                        ]
                                                    }, weekObj.week))
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `nav-arrow right ${isLastWeek ? 'disabled' : ''}`,
                                                onClick: handleNextWeekTab,
                                                style: isLastWeek ? {
                                                    opacity: 0.25,
                                                    cursor: 'not-allowed',
                                                    pointerEvents: 'none'
                                                } : {
                                                    cursor: 'pointer'
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navArrowIconSvg.ReactComponent), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "day-selector",
                                        children: activeWeekData.days.map((dayObj, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: `day-circle ${activeDayIndex === idx ? 'active' : ''}`,
                                                onClick: ()=>setActiveDayIndex(idx),
                                                children: dayObj.dayLabel
                                            }, idx))
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "thumbnails-row",
                                        ref: thumbnailsContainerRef,
                                        children: [
                                            exercisesToRender.slice(0, visibleThumbnails).map((item, idx)=>{
                                                const isMale = (0, _genderUtils.isMaleProfile)(client);
                                                const imgUrl = isMale ? item.image_male_url || item.image_female_url : item.image_female_url || item.image_male_url;
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "thumbnail",
                                                    children: imgUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: imgUrl,
                                                        alt: item.en_display_name || item.name
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        style: {
                                                            width: '100%',
                                                            height: '100%',
                                                            backgroundColor: '#2a2d3d',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            borderRadius: '8px',
                                                            color: '#8a8d9d',
                                                            fontSize: '12px',
                                                            fontWeight: 'bold',
                                                            textTransform: 'uppercase'
                                                        },
                                                        children: (item.en_display_name || item.name || 'EX').substring(0, 2)
                                                    })
                                                }, idx);
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "thumbnail more-btn cursor-pointer",
                                                onClick: ()=>{
                                                    const targetUid = clientId || client?.uid || client?.id;
                                                    if (targetUid) navigate(`/onboarding-trainer/dashboard/clients/${targetUid}/workouts/${getSelectedWorkoutId()}`);
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreProgramWorkoutSvg.ReactComponent), {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "program-card plan-calendar-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewOverviewProgramOverviewSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Plan Calendar"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        onClick: ()=>setIsPlanCalendarModalOpen(true),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "schedule-info",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "schedule-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewHeaderCalendarSvg.ReactComponent), {
                                                        className: "small-icon"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: originalPlanDaysInfo.daysString
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "schedule-item evening-reminder",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notificationSvg.ReactComponent), {
                                                        className: "small-icon"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: programData?.planCalendar?.reminderTime || 'Evening reminder'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "calendar-box",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "week-range",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "This week"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "range-selector",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "nav-arrow left",
                                                                onClick: handlePrevWeek,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navArrowIconSvg.ReactComponent), {})
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: formatWeekRange(currentWeekDays)
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "nav-arrow right",
                                                                onClick: handleNextWeek,
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navArrowIconSvg.ReactComponent), {})
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "calendar-days",
                                                children: currentWeekDays.map((date, index)=>{
                                                    const dayName = date.toLocaleString('en-US', {
                                                        weekday: 'short'
                                                    }).substring(0, 2);
                                                    const year = date.getFullYear();
                                                    const month = String(date.getMonth() + 1).padStart(2, '0');
                                                    const day = String(date.getDate()).padStart(2, '0');
                                                    const ymd = `${year}-${month}-${day}`;
                                                    const today = new Date();
                                                    const todayYear = today.getFullYear();
                                                    const todayMonth = String(today.getMonth() + 1).padStart(2, '0');
                                                    const todayDay = String(today.getDate()).padStart(2, '0');
                                                    const todayYmd = `${todayYear}-${todayMonth}-${todayDay}`;
                                                    const isToday = ymd === todayYmd;
                                                    const isPast = ymd < todayYmd;
                                                    const isFuture = ymd > todayYmd;
                                                    const datetimeList = programData?.datetimeList || [];
                                                    const isWorkoutScheduled = datetimeList.some((item)=>item.ymd === ymd);
                                                    const completedWorkouts = programData?.completedWorkoutsYmds || [];
                                                    const isWorkoutDone = completedWorkouts.includes(ymd);
                                                    let stateClass = '';
                                                    let showDumbbell = false;
                                                    if (isPast) {
                                                        if (isWorkoutDone) {
                                                            stateClass = 'past-done';
                                                            showDumbbell = true;
                                                        } else if (isWorkoutScheduled) {
                                                            stateClass = 'past-workout';
                                                            showDumbbell = true;
                                                        } else {
                                                            stateClass = 'past-no-workout';
                                                            showDumbbell = false;
                                                        }
                                                    } else if (isToday) {
                                                        if (isWorkoutScheduled || isWorkoutDone) {
                                                            stateClass = 'today-workout';
                                                            showDumbbell = true;
                                                        } else {
                                                            stateClass = 'today-no-workout';
                                                            showDumbbell = false;
                                                        }
                                                    } else if (isFuture) {
                                                        if (isWorkoutScheduled) {
                                                            stateClass = 'future-workout';
                                                            showDumbbell = true;
                                                        } else {
                                                            stateClass = 'future-no-workout';
                                                            showDumbbell = false;
                                                        }
                                                    }
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "cal-day",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "day-name",
                                                                children: dayName
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: `day-num ${stateClass}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        children: date.getDate()
                                                                    }),
                                                                    showDumbbell && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _weightSvg.ReactComponent), {
                                                                        className: "cal-icon"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }, index);
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "performance-adherence-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "performance-chart-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header space-between",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "title-left",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "icon",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programWorkoutPerformanceAdherenceSvg.ReactComponent), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: "Workout Performance & Adherence"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "chart-nav-arrows",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `nav-arrow left ${!chartScrollInfo.canScrollLeft ? 'disabled' : ''}`,
                                                onClick: ()=>handleScrollChart('left'),
                                                title: "Scroll Left",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navArrowIconSvg.ReactComponent), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `nav-arrow right ${!chartScrollInfo.canScrollRight ? 'disabled' : ''}`,
                                                onClick: ()=>handleScrollChart('right'),
                                                title: "Scroll Right",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navArrowIconSvg.ReactComponent), {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "chart-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "y-axis",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "y-label",
                                                children: "Time (min)"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "60"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "45"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "30"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "15"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "0"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "chart-content",
                                        ref: chartContentRef,
                                        onScroll: updateChartScroll,
                                        onMouseDown: handleChartMouseDown,
                                        onMouseMove: handleChartMouseMove,
                                        onMouseUp: handleChartMouseUpOrLeave,
                                        onMouseLeave: handleChartMouseUpOrLeave,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "bars-wrapper",
                                            children: (programData?.datetimeList || []).map((item, index)=>{
                                                const ymd = item.ymd;
                                                if (!ymd) return null;
                                                const [y, m, d] = ymd.split('-');
                                                const dateObj = new Date(Number(y), Number(m) - 1, Number(d));
                                                const dayName = dateObj.toLocaleDateString('en-US', {
                                                    weekday: 'short'
                                                });
                                                const completedWorkouts = programData?.completedWorkoutsYmds || [];
                                                const isWorkoutDone = completedWorkouts.includes(ymd);
                                                const todayYmd = getLocalYMD(new Date());
                                                const isPast = ymd < todayYmd;
                                                const planned = programData?.timeMin || 45;
                                                let actual = 0;
                                                if (isWorkoutDone) actual = planned - index % 6; // Mock completed duration
                                                else if (isPast) actual = 0; // Missed workout
                                                const plannedHeight = planned / 60 * 100;
                                                const actualHeight = actual / 60 * 100;
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "day-group",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "bar-pair",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "bar planned",
                                                                    style: {
                                                                        height: `${Math.min(100, plannedHeight)}%`
                                                                    },
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "bar-value",
                                                                        children: planned
                                                                    })
                                                                }),
                                                                (actual > 0 || isPast) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "bar actual",
                                                                    style: {
                                                                        height: `${Math.min(100, actualHeight)}%`
                                                                    },
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "bar-value",
                                                                        children: actual
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "day-label",
                                                            children: dayName
                                                        })
                                                    ]
                                                }, index);
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "chart-legend",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "legend-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "dot planned"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Planned Time (min)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "legend-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "dot actual"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Actual Time (min)"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "performance-metrics-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "metric-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "metric-label",
                                        children: "WORKOUT COMPLETION"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "metric-value",
                                        children: programData?.adherence?.workoutCompletion || '0%'
                                    }),
                                    (()=>{
                                        const val = programData?.adherence?.workoutCompletionNum || 0;
                                        let badgeColor = 'red';
                                        let badgeText = 'Low';
                                        if (val >= 75) {
                                            badgeColor = 'green';
                                            badgeText = 'Good';
                                        } else if (val >= 40) {
                                            badgeColor = 'yellow';
                                            badgeText = 'Average';
                                        }
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: `status-badge ${badgeColor}`,
                                            children: badgeText
                                        });
                                    })()
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "metric-divider"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "metric-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "metric-label",
                                        children: "AVG. TIME ADHERENCE"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "metric-value",
                                        children: programData?.adherence?.avgTimeAdherence || '0/0 min'
                                    }),
                                    (()=>{
                                        const val = programData?.adherence?.avgTimeAdherenceNum || 0;
                                        const target = programData?.timeMin || 45;
                                        const pct = target > 0 ? val / target * 100 : 0;
                                        let badgeColor = 'red';
                                        let badgeText = 'Off Track';
                                        if (pct >= 75) {
                                            badgeColor = 'green';
                                            badgeText = 'On Track';
                                        } else if (pct >= 40) {
                                            badgeColor = 'yellow';
                                            badgeText = 'Average';
                                        }
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: `status-badge ${badgeColor}`,
                                            children: badgeText
                                        });
                                    })()
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "metric-divider"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "metric-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "metric-label",
                                        children: "PLAN RESPECT / CONSISTENCY"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "metric-value",
                                        children: programData?.adherence?.planRespect || '0 of 0 workouts'
                                    }),
                                    (()=>{
                                        const val = programData?.adherence?.planRespectNum || 0;
                                        const total = programData?.adherence?.planRespectTotal || 0;
                                        const pct = total > 0 ? val / total * 100 : 0;
                                        let badgeColor = 'red';
                                        let badgeText = 'Off Track';
                                        if (pct >= 75) {
                                            badgeColor = 'green';
                                            badgeText = 'On Track';
                                        } else if (pct >= 40) {
                                            badgeColor = 'yellow';
                                            badgeText = 'Average';
                                        }
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: `status-badge ${badgeColor}`,
                                            children: badgeText
                                        });
                                    })()
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: isPlanCalendarModalOpen,
                footer: null,
                onCancel: ()=>setIsPlanCalendarModalOpen(false),
                centered: true,
                width: 520,
                closeIcon: null,
                rootClassName: "plan-calendar-modal",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "plan-calendar-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "modal-header",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "Plan Calendar"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-subtitle",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "subtitle-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewHeaderCalendarSvg.ReactComponent), {}),
                                        " ",
                                        modalPlanDaysInfo.daysString
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "subtitle-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _overviewHeaderCalendarSvg.ReactComponent), {}),
                                        " ",
                                        modalPlanDaysInfo.frequency,
                                        " days a week"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-tabs",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `tab ${modalTab === 'permanent' ? 'active' : ''}`,
                                    onClick: ()=>setModalTab('permanent'),
                                    children: "Permanent Change"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `tab ${modalTab === 'temporary' ? 'active' : ''}`,
                                    onClick: ()=>setModalTab('temporary'),
                                    children: "Temporary Change"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "info-banner",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardModalInfoSvg.ReactComponent), {
                                    className: "info-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: modalTab === 'permanent' ? 'Tapping a day updates the recurring weekly schedule for all future weeks' : 'Tapping a day overrides only that specific date without changing the weekly pattern'
                                })
                            ]
                        }),
                        inlineError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "inline-error",
                            style: {
                                color: '#ff4d4f',
                                marginTop: '12px',
                                textAlign: 'center',
                                fontSize: '14px',
                                fontWeight: 500
                            },
                            children: inlineError
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "calendar-widget",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "calendar-header",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: modalDate.toLocaleString('en-US', {
                                                month: 'long',
                                                year: 'numeric'
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-arrows",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "nav-arrow left",
                                                    onClick: handleModalPrevMonth,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navArrowIconSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "nav-arrow right",
                                                    onClick: handleModalNextMonth,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navArrowIconSvg.ReactComponent), {})
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "calendar-grid",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "weekdays",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Mo"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Tu"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "We"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Th"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Fr"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Sa"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Su"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "days",
                                            children: currentModalCalendarDays.map((day, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `day ${day.isCurrentMonth ? '' : 'inactive'} ${day.isPast ? 'past-day' : ''}`,
                                                    onClick: ()=>handleDayClick(day),
                                                    style: {
                                                        cursor: day.isPast ? 'not-allowed' : 'pointer',
                                                        opacity: day.isPast ? 0.5 : 1
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: `date-circle ${day.isWorkout ? 'workout' : ''} ${day.isToday ? 'green-glow' : ''} ${day.isSelectedSource ? 'selected-source' : ''}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "date-num",
                                                                children: day.date
                                                            }),
                                                            day.isWorkout && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _weightSvg.ReactComponent), {
                                                                className: "dumbbell-icon"
                                                            })
                                                        ]
                                                    })
                                                }, idx))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "calendar-legend",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "legend-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "dot active"
                                        }),
                                        " Active workout"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "legend-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "dot filled"
                                        }),
                                        "Skipped / changed"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "legend-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "dot outline"
                                        }),
                                        " Regular day"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setIsPlanCalendarModalOpen(false),
                                    disabled: updateProgramSchedule.isPending,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-save",
                                    onClick: handleSaveCalendarChanges,
                                    disabled: updateProgramSchedule.isPending,
                                    children: updateProgramSchedule.isPending ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        style: {
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            gap: '8px',
                                            color: '#050621'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                    style: {
                                                        fontSize: 16,
                                                        color: '#050621'
                                                    },
                                                    spin: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Saving..."
                                            })
                                        ]
                                    }) : 'Save Changes'
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _equipmentsModal.EquipmentsModal), {
                isOpen: isEquipmentsModalOpen,
                onClose: ()=>setIsEquipmentsModalOpen(false),
                equipments: programData?.equipments || [],
                getSlugTitle: getSlugTitle
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/config/firebase":"cmjIE","src/store/programGeneratorProgressStore":"2iAYB","src/store/sessionStore":"kPSO3","react-router-dom":[["useNavigate","f3cgC"],["useOutletContext","9oT3O"]],"antd":[["Modal","kY4DD","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"src/api/queries/useGetClientProgramTab":"dfeJO","./EmptyState":"a8ne2","src/api/mutations/useGetProgramMasterData":"bOtFg","src/api/mutations/useUpdateProgramSchedule":"6jQIf","@tanstack/react-query":"97Oud","react-hot-toast":"3T0Wh","../../ProgramGeneratorAI/../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg":"eHDnc","../../ProgramGeneratorAI/../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/program_goals.svg":"3aLZ1","../../ProgramGeneratorAI/../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/goal_approach.svg":"hkeyK","../../ProgramGeneratorAI/../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/plan_structure.svg":"fb3Cp","../../ProgramGeneratorAI/../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/edit.svg":"jR7RI","../../ProgramGeneratorAI/../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/weight.svg":"59Zgc","src/utils/equipmentIcons":"80Hvz","src/utils/genderUtils":"aiA54","./ProgramTab/IntensityCard":"kMOpw","./ProgramTab/EquipmentsModal":"6IaFd","url:../../ProgramGeneratorAI/assets/client/program-female.png":"afyDG","url:../../ProgramGeneratorAI/assets/client/program-male.png":"6LOXB","src/assets/images/trainer/clients/program_workout_performance_adherence.svg":"logsm","src/assets/images/trainer/clients/program_workout.svg":"EI0fZ","src/assets/images/trainer/clients/overview-overview-program-overview.svg":"JeUzf","src/assets/images/trainer/clients/overview-header-calendar.svg":"2CVtH","src/assets/images/trainer/clients/more_program_workout.svg":"21mCv","src/assets/images/trainer/clients/nav-arrow-icon.svg":"3jSUC","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/notification.svg":"9EZ1c","src/assets/images/trainer/clients/onboard-modal-info.svg":"8c7At","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dfeJO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetClientProgramTab", ()=>useGetClientProgramTab);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
const getClientProgramTab = async (clientId, trainerId)=>{
    const queryParams = new URLSearchParams({
        clientId
    });
    if (trainerId) queryParams.append('trainerId', trainerId);
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_CLIENT_PROGRAM_TAB}?${queryParams.toString()}`;
    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) {
        const errorData = await response.json().catch(()=>({}));
        throw new Error(errorData.error || 'Failed to fetch program tab data');
    }
    const data = await response.json();
    if (data.status === 'error') throw new Error(data.error || 'Failed to fetch program tab data');
    return data.data;
};
const useGetClientProgramTab = (clientId, trainerId)=>{
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'clientProgramTab',
            clientId,
            trainerId
        ],
        queryFn: ()=>getClientProgramTab(clientId, trainerId),
        enabled: !!clientId
    });
};

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6jQIf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUpdateProgramSchedule", ()=>useUpdateProgramSchedule);
var _reactQuery = require("@tanstack/react-query");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
const useUpdateProgramSchedule = ()=>{
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const response = await (0, _axiosDefault.default).post(`${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_UPDATE_PROGRAMME_CALENDAR}`, {
                data: payload
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        }
    });
};

},{"@tanstack/react-query":"ehKs4","axios":"kL5AO","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jR7RI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEdit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEdit = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 33,
        height: 33,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#D6D6D6",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.333,
                d: "m18.51 11.803 2.316 2.398m-1.298-3.38a1.667 1.667 0 1 1 2.315 2.398l-9.337 9.017-2.333-.04.041-2.382z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#D6D6D6",
                strokeLinecap: "round",
                strokeWidth: 1.2,
                d: "m9.716 25.564 12.798.223"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"80Hvz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EQUIPMENT_ICON_MAP", ()=>EQUIPMENT_ICON_MAP);
parcelHelpers.export(exports, "getEquipmentIcon", ()=>getEquipmentIcon);
parcelHelpers.export(exports, "EquipmentIcon", ()=>EquipmentIcon);
var _react = require("react");
var _dumbbellSvg = require("src/assets/images/onboarding-trainer/equipment/svg/dumbbell.svg");
var _kettlebellSvg = require("src/assets/images/onboarding-trainer/equipment/svg/kettlebell.svg");
var _barbellSvg = require("src/assets/images/onboarding-trainer/equipment/svg/barbell.svg");
var _benchSvg = require("src/assets/images/onboarding-trainer/equipment/svg/bench.svg");
var _crunchBenchSvg = require("src/assets/images/onboarding-trainer/equipment/svg/crunch_bench.svg");
var _absCrunchMachineSvg = require("src/assets/images/onboarding-trainer/equipment/svg/abs_crunch_machine.svg");
var _chestPressSvg = require("src/assets/images/onboarding-trainer/equipment/svg/chest_press.svg");
var _fitnessBallSvg = require("src/assets/images/onboarding-trainer/equipment/svg/fitness_ball.svg");
var _foamRollerSvg = require("src/assets/images/onboarding-trainer/equipment/svg/foam_roller.svg");
var _hipAbductionSvg = require("src/assets/images/onboarding-trainer/equipment/svg/hip_abduction.svg");
var _hipAdbuction2Svg = require("src/assets/images/onboarding-trainer/equipment/svg/hip_adbuction_2.svg");
var _jumpRopeSvg = require("src/assets/images/onboarding-trainer/equipment/svg/jump_rope.svg");
var _latPullDownSvg = require("src/assets/images/onboarding-trainer/equipment/svg/lat_pull_down.svg");
var _legCurlSvg = require("src/assets/images/onboarding-trainer/equipment/svg/leg_curl.svg");
var _legExtensionSvg = require("src/assets/images/onboarding-trainer/equipment/svg/leg_extension.svg");
var _legPressSvg = require("src/assets/images/onboarding-trainer/equipment/svg/leg_press.svg");
var _cableCrossoverSvg = require("src/assets/images/onboarding-trainer/equipment/svg/cable_crossover.svg");
var _pulleyMachineSvg = require("src/assets/images/onboarding-trainer/equipment/svg/pulley_machine.svg");
var _seatedRowMachineSvg = require("src/assets/images/onboarding-trainer/equipment/svg/seated_row_machine.svg");
var _shoulderPressSvg = require("src/assets/images/onboarding-trainer/equipment/svg/shoulder_press.svg");
var _tricepsDipMachineSvg = require("src/assets/images/onboarding-trainer/equipment/svg/triceps_dip_machine.svg");
var _yogaMatSvg = require("src/assets/images/onboarding-trainer/equipment/svg/yoga_mat.svg");
var _bodyweightSvg = require("src/assets/images/onboarding-trainer/equipment/svg/bodyweight.svg");
var _pullUpBarSvg = require("src/assets/images/onboarding-trainer/equipment/svg/pull_up_bar.svg");
var _resistanceBandSvg = require("src/assets/images/onboarding-trainer/equipment/svg/resistance_band.svg");
var _otherSvg = require("src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/other.svg");
const EQUIPMENT_ICON_MAP = {
    // Dumbbell
    dumbell: (0, _dumbbellSvg.ReactComponent),
    dumbbell: (0, _dumbbellSvg.ReactComponent),
    // Kettlebell
    kettlebell: (0, _kettlebellSvg.ReactComponent),
    // Barbell
    barbell: (0, _barbellSvg.ReactComponent),
    // Bench
    bench: (0, _benchSvg.ReactComponent),
    // Crunch bench
    crunch_bench: (0, _crunchBenchSvg.ReactComponent),
    'crunch-bench': (0, _crunchBenchSvg.ReactComponent),
    // Abs crunch machine
    abs_crunch_machine: (0, _absCrunchMachineSvg.ReactComponent),
    'abs-crunch-machine': (0, _absCrunchMachineSvg.ReactComponent),
    // Chest press
    chest_press: (0, _chestPressSvg.ReactComponent),
    'chest-press': (0, _chestPressSvg.ReactComponent),
    // Fitness ball
    fitness_ball: (0, _fitnessBallSvg.ReactComponent),
    'fitness-ball': (0, _fitnessBallSvg.ReactComponent),
    swiss_ball: (0, _fitnessBallSvg.ReactComponent),
    'swiss-ball': (0, _fitnessBallSvg.ReactComponent),
    // Foam roller
    foam_roller: (0, _foamRollerSvg.ReactComponent),
    'foam-roller': (0, _foamRollerSvg.ReactComponent),
    // Hip abduction
    hip_abduction: (0, _hipAbductionSvg.ReactComponent),
    'hip-abduction': (0, _hipAbductionSvg.ReactComponent),
    hip_adbuction: (0, _hipAbductionSvg.ReactComponent),
    'hip-adbuction': (0, _hipAbductionSvg.ReactComponent),
    // Hip adduction
    hip_adbuction_2: (0, _hipAdbuction2Svg.ReactComponent),
    'hip-adbuction-2': (0, _hipAdbuction2Svg.ReactComponent),
    hip_adduction: (0, _hipAdbuction2Svg.ReactComponent),
    'hip-adduction': (0, _hipAdbuction2Svg.ReactComponent),
    // Jump rope
    jump_rope: (0, _jumpRopeSvg.ReactComponent),
    'jump-rope': (0, _jumpRopeSvg.ReactComponent),
    // Lat pull down
    lat_pull_down: (0, _latPullDownSvg.ReactComponent),
    'lat-pull-down': (0, _latPullDownSvg.ReactComponent),
    // Leg curl
    leg_curl: (0, _legCurlSvg.ReactComponent),
    'leg-curl': (0, _legCurlSvg.ReactComponent),
    // Leg extension
    leg_extension: (0, _legExtensionSvg.ReactComponent),
    'leg-extension': (0, _legExtensionSvg.ReactComponent),
    // Leg press
    leg_press: (0, _legPressSvg.ReactComponent),
    'leg-press': (0, _legPressSvg.ReactComponent),
    // Cable crossover
    new_crossover: (0, _cableCrossoverSvg.ReactComponent),
    'new-crossover': (0, _cableCrossoverSvg.ReactComponent),
    cable_crossover: (0, _cableCrossoverSvg.ReactComponent),
    'cable-crossover': (0, _cableCrossoverSvg.ReactComponent),
    // Pulley machine
    pulley_machine: (0, _pulleyMachineSvg.ReactComponent),
    'pulley-machine': (0, _pulleyMachineSvg.ReactComponent),
    // Seated row machine
    seated_row_machine: (0, _seatedRowMachineSvg.ReactComponent),
    'seated-row-machine': (0, _seatedRowMachineSvg.ReactComponent),
    // Shoulder press
    shoulder_press: (0, _shoulderPressSvg.ReactComponent),
    'shoulder-press': (0, _shoulderPressSvg.ReactComponent),
    // Triceps dip machine
    triceps_dip_machine: (0, _tricepsDipMachineSvg.ReactComponent),
    'triceps-dip-machine': (0, _tricepsDipMachineSvg.ReactComponent),
    // Yoga mat
    yoga_mat: (0, _yogaMatSvg.ReactComponent),
    'yoga-mat': (0, _yogaMatSvg.ReactComponent),
    // Bodyweight
    bodyweight: (0, _bodyweightSvg.ReactComponent),
    'body-weight': (0, _bodyweightSvg.ReactComponent),
    body_weight: (0, _bodyweightSvg.ReactComponent),
    none: (0, _bodyweightSvg.ReactComponent),
    // Pull up bar
    pull_up_bar: (0, _pullUpBarSvg.ReactComponent),
    'pull-up-bar': (0, _pullUpBarSvg.ReactComponent),
    // Resistance bands
    resistance_bands: (0, _resistanceBandSvg.ReactComponent),
    'resistance-bands': (0, _resistanceBandSvg.ReactComponent),
    resistance_band: (0, _resistanceBandSvg.ReactComponent),
    'resistance-band': (0, _resistanceBandSvg.ReactComponent)
};
const getEquipmentIcon = (slugOrName)=>{
    if (!slugOrName) return 0, _otherSvg.ReactComponent;
    const normalized = slugOrName.toLowerCase().trim().replace(/\s+/g, '_');
    const normalizedHyphen = slugOrName.toLowerCase().trim().replace(/\s+/g, '-');
    return EQUIPMENT_ICON_MAP[normalized] || EQUIPMENT_ICON_MAP[normalizedHyphen] || (0, _otherSvg.ReactComponent);
};
const EquipmentIcon = ({ slug, className })=>{
    const SvgComponent = getEquipmentIcon(slug);
    return /*#__PURE__*/ (0, _react.createElement)(SvgComponent, {
        className
    });
};

},{"react":"bmhQu","src/assets/images/onboarding-trainer/equipment/svg/dumbbell.svg":"lzlOe","src/assets/images/onboarding-trainer/equipment/svg/kettlebell.svg":"cyWQo","src/assets/images/onboarding-trainer/equipment/svg/barbell.svg":"931RS","src/assets/images/onboarding-trainer/equipment/svg/bench.svg":"gX5aZ","src/assets/images/onboarding-trainer/equipment/svg/crunch_bench.svg":"8Rwa7","src/assets/images/onboarding-trainer/equipment/svg/abs_crunch_machine.svg":"kLIHh","src/assets/images/onboarding-trainer/equipment/svg/chest_press.svg":"6kdSQ","src/assets/images/onboarding-trainer/equipment/svg/fitness_ball.svg":"6U5N3","src/assets/images/onboarding-trainer/equipment/svg/foam_roller.svg":"dwMhY","src/assets/images/onboarding-trainer/equipment/svg/hip_abduction.svg":"4ZiCy","src/assets/images/onboarding-trainer/equipment/svg/hip_adbuction_2.svg":"eX99D","src/assets/images/onboarding-trainer/equipment/svg/jump_rope.svg":"2ao7G","src/assets/images/onboarding-trainer/equipment/svg/lat_pull_down.svg":"4UFbL","src/assets/images/onboarding-trainer/equipment/svg/leg_curl.svg":"4bt5K","src/assets/images/onboarding-trainer/equipment/svg/leg_extension.svg":"bv4KM","src/assets/images/onboarding-trainer/equipment/svg/leg_press.svg":"lKeYI","src/assets/images/onboarding-trainer/equipment/svg/cable_crossover.svg":"dMIIB","src/assets/images/onboarding-trainer/equipment/svg/pulley_machine.svg":"awVYh","src/assets/images/onboarding-trainer/equipment/svg/seated_row_machine.svg":"aW9tM","src/assets/images/onboarding-trainer/equipment/svg/shoulder_press.svg":"cZ73Q","src/assets/images/onboarding-trainer/equipment/svg/triceps_dip_machine.svg":"4tWgb","src/assets/images/onboarding-trainer/equipment/svg/yoga_mat.svg":"aX5bq","src/assets/images/onboarding-trainer/equipment/svg/bodyweight.svg":"HHL8X","src/assets/images/onboarding-trainer/equipment/svg/pull_up_bar.svg":"57NP3","src/assets/images/onboarding-trainer/equipment/svg/resistance_band.svg":"2coge","src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/other.svg":"3Cuql","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lzlOe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDumbbell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDumbbell = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 6,
                x: 1.5,
                y: 5.5,
                fill: "#E5E5E5",
                rx: 0.75
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.2,
                height: 4,
                x: 3.5,
                y: 6.5,
                fill: "#E5E5E5",
                rx: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 7.6,
                height: 1.6,
                x: 4.7,
                y: 7.7,
                fill: "#E5E5E5",
                rx: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.2,
                height: 4,
                x: 12.3,
                y: 6.5,
                fill: "#E5E5E5",
                rx: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2,
                height: 6,
                x: 13.5,
                y: 5.5,
                fill: "#E5E5E5",
                rx: 0.75
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cyWQo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgKettlebell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgKettlebell = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M6 2.5C4.6 2.5 3.5 3.6 3.5 5v1.5c-1.2 1.1-2 2.7-2 4.5 0 3 2.2 4.5 7 4.5s7-1.5 7-4.5c0-1.8-.8-3.4-2-4.5V5c0-1.4-1.1-2.5-2.5-2.5zM5 5c0-.6.4-1 1-1h5c.6 0 1 .4 1 1v1.1C10.9 5.4 9.7 5 8.5 5S6.1 5.4 5 6.1zm-2 6c0-2 1.8-3.5 5.5-3.5S14 9 14 11c0 2.3-1.7 3-5.5 3S3 13.3 3 11",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"931RS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBarbell);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBarbell = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 16,
                height: 1.6,
                x: 0.5,
                y: 7.7,
                fill: "#E5E5E5",
                rx: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.5,
                height: 10,
                x: 2,
                y: 3.5,
                fill: "#E5E5E5",
                rx: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.2,
                height: 8,
                x: 3.8,
                y: 4.5,
                fill: "#E5E5E5",
                rx: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 0.8,
                height: 3,
                x: 5.2,
                y: 7,
                fill: "#E5E5E5",
                rx: 0.3
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 0.8,
                height: 3,
                x: 11,
                y: 7,
                fill: "#E5E5E5",
                rx: 0.3
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.2,
                height: 8,
                x: 12,
                y: 4.5,
                fill: "#E5E5E5",
                rx: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.5,
                height: 10,
                x: 13.5,
                y: 3.5,
                fill: "#E5E5E5",
                rx: 0.5
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gX5aZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBench);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBench = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 15,
                height: 2.2,
                x: 1,
                y: 6,
                fill: "#E5E5E5",
                rx: 1.1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.5,
                height: 5.8,
                x: 2.5,
                y: 8.2,
                fill: "#E5E5E5",
                rx: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.5,
                height: 5.8,
                x: 13,
                y: 8.2,
                fill: "#E5E5E5",
                rx: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 3.5,
                height: 1.5,
                x: 1.5,
                y: 13.5,
                fill: "#E5E5E5",
                rx: 0.6
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 3.5,
                height: 1.5,
                x: 12,
                y: 13.5,
                fill: "#E5E5E5",
                rx: 0.6
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 9,
                height: 1.2,
                x: 4,
                y: 9.5,
                fill: "#E5E5E5",
                rx: 0.4
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Rwa7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCrunchBench);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCrunchBench = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 2.2,
                d: "m2.5 13.5 11-8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "M12.5 5.5v9M10.5 14.5h4M1.5 14h3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 13,
                cy: 3.5,
                r: 1.3,
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.5,
                cy: 5.5,
                r: 1.3,
                fill: "#E5E5E5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kLIHh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAbsCrunchMachine);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAbsCrunchMachine = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M2 14.5h13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.3,
                d: "M3.5 14.5v-11h4v11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2.4,
                height: 7,
                x: 4.3,
                y: 5,
                fill: "#E5E5E5",
                rx: 0.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.4,
                d: "M7.5 11h5V8.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 12,
                cy: 5.5,
                r: 1.5,
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.3,
                d: "m10 5.5-2.5 2"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6kdSQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgChestPress);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgChestPress = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M2 14.5h13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.2,
                d: "M3 14.5V3h3v11.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.8,
                height: 7.5,
                x: 3.6,
                y: 4.5,
                fill: "#E5E5E5",
                rx: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.3,
                d: "M8 14.5v-4h4v4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "M9 10.5v-5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.3,
                d: "M11 6.5h3.5V10"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6U5N3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFitnessBall);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFitnessBall = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8.5,
                cy: 8.5,
                r: 6.5,
                stroke: "#E5E5E5",
                strokeWidth: 1.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.1,
                d: "M3 6.5c1.8-1.3 9.2-1.3 11 0M2 8.5c2.2-1.3 10.8-1.3 13 0M3 10.5c1.8 1.3 9.2 1.3 11 0"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dwMhY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFoamRoller);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFoamRoller = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 12,
                height: 8,
                x: 2.5,
                y: 4.5,
                stroke: "#E5E5E5",
                strokeWidth: 1.4,
                rx: 2.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                cx: 4.5,
                cy: 8.5,
                fill: "#E5E5E5",
                rx: 1.2,
                ry: 3
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.1,
                d: "M7.5 5.5v6M10 5.5v6M12.5 5.5v6"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4ZiCy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgHipAbduction);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgHipAbduction = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M2 14.5h13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.2,
                d: "M3.5 14.5V4h3v10.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.8,
                height: 6.5,
                x: 4.1,
                y: 5.5,
                fill: "#E5E5E5",
                rx: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.3,
                d: "M8.5 14.5v-5h3v5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 7,
                r: 1.3,
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.3,
                d: "M7 11.5C7.8 10 9 10 10 10s2.2 0 3 1.5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eX99D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgHipAdbuction2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgHipAdbuction2 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M2 14.5h13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.2,
                d: "M3.5 14.5V4h3v10.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.8,
                height: 6.5,
                x: 4.1,
                y: 5.5,
                fill: "#E5E5E5",
                rx: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.3,
                d: "M8.5 14.5v-5h3v5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 10,
                cy: 7,
                r: 1.3,
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.3,
                d: "M8 10.5 9.5 12l1.5-1.5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2ao7G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgJumpRope);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgJumpRope = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M4.27 10.415A.28.28 0 0 0 4 10.16l-1.305-.023a.276.276 0 0 0-.28.246l-.361 2.947a1.26 1.26 0 0 0 .713 1.275 1.24 1.24 0 0 0 1.428-.277 1.25 1.25 0 0 0 .335-.954zm9.103 3.113-.258-2.958a.28.28 0 0 0-.272-.255l-1.304-.023a.275.275 0 0 0-.281.245l-.361 2.948a1.26 1.26 0 0 0 .301.965 1.24 1.24 0 0 0 1.418.328 1.25 1.25 0 0 0 .69-.737c.057-.165.08-.34.067-.513M10.021 2.811a2.76 2.76 0 0 1 1.251 1.045c.304.466.46 1.014.451 1.571l-.044 2.503a.28.28 0 0 1-.28.273.3.3 0 0 0-.218.097.3.3 0 0 0-.06.232l.126.698a.28.28 0 0 0 .267.227l1.327.023a.275.275 0 0 0 .269-.195c.03-.1.088-.283.211-.714a.3.3 0 0 0-.05-.235.3.3 0 0 0-.215-.104.276.276 0 0 1-.271-.283l.043-2.502a3.9 3.9 0 0 0-1.085-2.773 3.86 3.86 0 0 0-3.685-1.082.6.6 0 0 1-.277-.005 3.86 3.86 0 0 0-3.721.953 3.9 3.9 0 0 0-1.18 2.733l-.044 2.503a.28.28 0 0 1-.281.273.3.3 0 0 0-.217.096.3.3 0 0 0-.06.233c.109.436.16.62.187.72a.28.28 0 0 0 .262.206l1.326.023a.275.275 0 0 0 .275-.218l.156-.693a.3.3 0 0 0-.051-.234.3.3 0 0 0-.22-.104.276.276 0 0 1-.271-.283l.043-2.503a2.77 2.77 0 0 1 1.792-2.555.13.13 0 0 1 .16.047.134.134 0 0 1-.003.167 3.9 3.9 0 0 0-.843 2.36 2.8 2.8 0 0 0 .775 1.981 2.756 2.756 0 0 0 3.909.068 2.8 2.8 0 0 0 .844-1.952 3.9 3.9 0 0 0-.76-2.388.134.134 0 0 1 .002-.167.13.13 0 0 1 .161-.042M7.825 7.028A1.65 1.65 0 0 1 6.66 6.52a1.67 1.67 0 0 1-.465-1.188c.009-.488.145-.965.395-1.384s.605-.763 1.03-1a.55.55 0 0 1 .552.01c.416.251.759.608.994 1.035s.354.909.346 1.397c-.008.442-.19.864-.506 1.171a1.65 1.65 0 0 1-1.181.468"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4UFbL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLatPullDown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLatPullDown = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M2 14.5h13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.3,
                d: "M4 14.5v-12h4.5v12M8.5 2.5h5v3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.6,
                d: "M10.5 5.5h6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.3,
                d: "M11 14.5v-4h3.5v4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2.4,
                height: 7.5,
                x: 4.8,
                y: 4.5,
                fill: "#E5E5E5",
                rx: 0.4
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4bt5K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLegCurl);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLegCurl = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M2 14.5h13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.2,
                d: "M3.5 14.5V4h3v10.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.8,
                height: 6.5,
                x: 4.1,
                y: 5.5,
                fill: "#E5E5E5",
                rx: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.8,
                d: "m7 10 5-2"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "m12 8 2 3.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14,
                cy: 12,
                r: 1.3,
                fill: "#E5E5E5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bv4KM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLegExtension);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLegExtension = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M2 14.5h13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.2,
                d: "M3.5 14.5V4h3v10.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.8,
                height: 6.5,
                x: 4.1,
                y: 5.5,
                fill: "#E5E5E5",
                rx: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.3,
                d: "M8 14.5V9h3.5v5.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M8.5 9V5M11.5 9l2.5 1.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.5,
                cy: 11,
                r: 1.3,
                fill: "#E5E5E5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lKeYI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLegPress);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLegPress = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M2 14.5h13M3 14 13 4"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 2.2,
                d: "M4 14.5 5.5 11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 2.5,
                d: "m9 8 2.5-2.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "m12 4.5 2 2"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dMIIB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCableCrossover);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCableCrossover = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.3,
                d: "M1.5 14.5h14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.3,
                d: "M2.5 14.5v-12h12v12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.2,
                d: "M2.5 4h12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 2.5,
                cy: 6,
                r: 1.2,
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 14.5,
                cy: 6,
                r: 1.2,
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.1,
                d: "m2.5 6 4 3.5M14.5 6l-4 3.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.5,
                height: 5,
                x: 1,
                y: 7,
                fill: "#E5E5E5",
                rx: 0.3
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.5,
                height: 5,
                x: 14.5,
                y: 7,
                fill: "#E5E5E5",
                rx: 0.3
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"awVYh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPulleyMachine);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPulleyMachine = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M3 14.5h11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.3,
                d: "M5.5 14.5v-12h4v12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 2.4,
                height: 7.5,
                x: 6.3,
                y: 5,
                fill: "#E5E5E5",
                rx: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.3,
                d: "M9.5 3h3v3"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 12.5,
                cy: 7.5,
                r: 1.3,
                fill: "#E5E5E5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aW9tM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSeatedRowMachine);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSeatedRowMachine = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M2 14.5h13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.2,
                d: "M3.5 14.5V4h3v10.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.8,
                height: 6.5,
                x: 4.1,
                y: 5.5,
                fill: "#E5E5E5",
                rx: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.3,
                d: "M9 14.5V11h4.5v3.5M8 8v6.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M6.5 8.5H10"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cZ73Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgShoulderPress);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgShoulderPress = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M2 14.5h13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.2,
                d: "M3.5 14.5V3h3v11.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.8,
                height: 7.5,
                x: 4.1,
                y: 4.5,
                fill: "#E5E5E5",
                rx: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.3,
                d: "M9 14.5V10h3.5v4.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "M9.5 10V4.5M8 3.5h5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4tWgb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgTricepsDipMachine);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTricepsDipMachine = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M2 14.5h13"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.2,
                d: "M3.5 14.5v-11h3v11"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 1.8,
                height: 7,
                x: 4.1,
                y: 5,
                fill: "#E5E5E5",
                rx: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.3,
                d: "M8.5 14.5v-5h4v5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.3,
                d: "M8.5 7.5h5v3"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aX5bq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgYogaMat);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgYogaMat = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "M3 13.5h11.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                cx: 4.5,
                cy: 8.5,
                stroke: "#E5E5E5",
                strokeWidth: 1.3,
                rx: 2.5,
                ry: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("ellipse", {
                cx: 4.5,
                cy: 8.5,
                stroke: "#E5E5E5",
                strokeWidth: 1.1,
                rx: 1.2,
                ry: 2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeWidth: 1.3,
                d: "M4.5 4.5h9c1.1 0 2 1.8 2 4s-.9 4-2 4h-9"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"HHL8X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBodyweight);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBodyweight = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8.5,
                cy: 4,
                r: 2,
                fill: "#E5E5E5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M4 15v-4.5C4 9.1 5.1 8 6.5 8h4c1.4 0 2.5 1.1 2.5 2.5V15"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"57NP3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPullUpBar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPullUpBar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.8,
                d: "M1 4h15"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeWidth: 1.4,
                d: "M4 4v9M13 4v9M2.5 13h3M11.5 13h3"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2coge":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgResistanceBand);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgResistanceBand = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8.5,
                cy: 8.5,
                r: 5.5,
                stroke: "#E5E5E5",
                strokeWidth: 1.8
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8.5,
                cy: 8.5,
                r: 3.2,
                stroke: "#E5E5E5",
                strokeDasharray: "2 1.5",
                strokeWidth: 1.1
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kMOpw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getIntensityActiveDots", ()=>getIntensityActiveDots);
parcelHelpers.export(exports, "IntensityCard", ()=>IntensityCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _intensitySetupSvg = require("../../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg");
var _editSvg = require("../../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/edit.svg");
var _equipmentIcons = require("src/utils/equipmentIcons");
var _equipmentsModal = require("./EquipmentsModal");
const getIntensityActiveDots = (intensity)=>{
    if (typeof intensity === 'number') {
        if (intensity >= 1 && intensity <= 3) return intensity * 2;
        if (intensity >= 1 && intensity <= 6) return intensity;
        return 4;
    }
    if (!intensity) return 4;
    const normalized = String(intensity).toLowerCase().trim().replace(/[-_]/g, '');
    if (normalized.includes('low')) return 2;
    if (normalized.includes('high')) return 6;
    if (normalized.includes('balance') || normalized.includes('medium') || normalized.includes('moderate')) return 4;
    return 4;
};
const IntensityCard = ({ programData, getSlugTitle, onEdit })=>{
    const [isEquipmentsModalOpen, setIsEquipmentsModalOpen] = (0, _react.useState)(false);
    const equipments = programData?.equipments || [];
    const visibleEquipments = equipments.slice(0, 3);
    const remainingCount = equipments.length - 3;
    const isManuallyGenerated = programData?.isManually === true || programData?.isAIGenerate === false || !programData?.progress?.training_goal;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "program-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _intensitySetupSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "Intensity & Setup"
                            }),
                            !isManuallyGenerated && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "edit-btn",
                                onClick: onEdit,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {
                                    style: {
                                        cursor: 'pointer'
                                    }
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "card-body",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "info-row align-center space-between",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "label",
                                        children: [
                                            "Intensity: ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: getSlugTitle(programData.intensity)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "value-dots",
                                        children: Array.from({
                                            length: 6
                                        }).map((_, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: `dot ${idx < getIntensityActiveDots(programData?.intensity) ? 'active' : ''}`
                                            }, idx))
                                    })
                                ]
                            }),
                            visibleEquipments.map((eq, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "info-row align-center space-between",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "value",
                                            children: getSlugTitle(eq)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "icon-img",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _equipmentIcons.EquipmentIcon), {
                                                slug: eq
                                            })
                                        })
                                    ]
                                }, i)),
                            equipments.length > 3 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "show-more-toggle",
                                onClick: ()=>setIsEquipmentsModalOpen(true),
                                children: [
                                    "Show +",
                                    remainingCount
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _equipmentsModal.EquipmentsModal), {
                isOpen: isEquipmentsModalOpen,
                onClose: ()=>setIsEquipmentsModalOpen(false),
                equipments: equipments,
                getSlugTitle: getSlugTitle
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg":"eHDnc","../../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/edit.svg":"jR7RI","src/utils/equipmentIcons":"80Hvz","./EquipmentsModal":"6IaFd","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6IaFd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EquipmentsModal", ()=>EquipmentsModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _intensitySetupSvg = require("../../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg");
var _closeSvg = require("src/assets/images/trainer/clients/close.svg");
var _equipmentIcons = require("src/utils/equipmentIcons");
var _equipmentsModalScss = require("./EquipmentsModal.scss");
const EquipmentsModal = ({ isOpen, onClose, equipments, getSlugTitle })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        onCancel: onClose,
        footer: null,
        centered: true,
        width: 540,
        rootClassName: "equipments-list-modal",
        closeIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeSvg.ReactComponent), {
            className: "modal-close-icon"
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "equipments-modal-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "modal-header",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-left",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "header-icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _intensitySetupSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "header-text",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Equipments"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "subtitle",
                                        children: [
                                            equipments.length,
                                            " equipments configured"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "equipments-grid",
                    children: equipments.map((eq, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "equipment-item-card",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "eq-name",
                                    children: getSlugTitle(eq)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "eq-icon-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _equipmentIcons.EquipmentIcon), {
                                        slug: eq
                                    })
                                })
                            ]
                        }, idx))
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "modal-footer",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn-close",
                        onClick: onClose,
                        children: "Done"
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"../../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg":"eHDnc","src/assets/images/trainer/clients/close.svg":"5zasw","src/utils/equipmentIcons":"80Hvz","./EquipmentsModal.scss":"bWl9p","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5zasw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgClose);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgClose = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#07092C",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M18 6 6 18M6 6l12 12"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bWl9p":[function() {},{}],"afyDG":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("ezJ4B");

},{}],"6LOXB":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5ibj9");

},{}],"logsm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProgramWorkoutPerformanceAdherence);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgramWorkoutPerformanceAdherence = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E0CE00",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E0CE00",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E0CE00",
                clipPath: "url(#b)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m20.066 22.952-2.435-5.563v-3.237s3.628-2.463.482-5.938a.654.654 0 0 0-.929-.04l-.021.022-.004.003a.655.655 0 0 0-.009.912c.638.681 1.513 2.085-.187 3.581a1.5 1.5 0 0 1-.588.316l-.09.022c-.191.047-.388.047-.576 0l-.09-.022a1.5 1.5 0 0 1-.588-.316c-1.7-1.493-.825-2.9-.187-3.58a.655.655 0 0 0-.013-.913l-.003-.003a.65.65 0 0 0-.944.018c-3.146 3.472.482 5.938.482 5.938v3.234L11.93 22.95a.75.75 0 0 0 .385.987q.013.006.028.013a.75.75 0 0 0 .95-.372L16 18.052l2.703 5.528a.75.75 0 0 0 1.363-.628"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M16 12.478c.763 0 1.381-.663 1.381-1.481S16.763 9.516 16 9.516s-1.381.663-1.381 1.48c0 .819.618 1.482 1.38 1.482"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 33.45,
                        x2: 8.594,
                        y1: 32.008,
                        y2: -8.208,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M8 8h16v16H8z"
                        })
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"EI0fZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProgramWorkout);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgramWorkout = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#755ADF",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                fillRule: "evenodd",
                d: "M11 7.998a2.5 2.5 0 0 0-2.5 2.5v10a2.5 2.5 0 0 0 2.5 2.5h10a2.5 2.5 0 0 0 2.5-2.5v-10a2.5 2.5 0 0 0-2.5-2.5zm3.333 4.167a.833.833 0 0 1 .834-.834h5a.833.833 0 0 1 0 1.667h-5a.834.834 0 0 1-.834-.833m0 3.333a.833.833 0 0 1 .834-.833h5a.833.833 0 0 1 0 1.666h-5a.833.833 0 0 1-.834-.833m0 3.333a.833.833 0 0 1 .834-.833h5a.833.833 0 0 1 0 1.667h-5a.833.833 0 0 1-.834-.834m-2.5-7.5a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667M11 15.498a.833.833 0 1 1 1.666 0 .833.833 0 0 1-1.666 0m.833 2.5a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"21mCv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMoreProgramWorkout);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMoreProgramWorkout = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 76,
        height: 76,
        fill: "none",
        viewBox: "0 0 76 76",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.05,
                d: "M0 12C0 5.373 5.373 0 12 0h52c6.627 0 12 5.373 12 12v52c0 6.627-5.373 12-12 12H12C5.373 76 0 70.627 0 64z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 29,
                cy: 38,
                r: 3,
                fill: "#fff",
                fillOpacity: 0.7
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 38,
                cy: 38,
                r: 3,
                fill: "#fff",
                fillOpacity: 0.7
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 47,
                cy: 38,
                r: 3,
                fill: "#fff",
                fillOpacity: 0.7
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iMQYC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WorkoutsTab", ()=>WorkoutsTab);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _programWorkoutSvg = require("src/assets/images/trainer/clients/program_workout.svg");
var _navArrowIconSvg = require("src/assets/images/trainer/clients/nav-arrow-icon.svg");
var _moreProgramWorkoutSvg = require("src/assets/images/trainer/clients/more_program_workout.svg");
var _upNextSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/up_next.svg");
var _workoutHistorySvg = require("src/assets/images/onboarding-trainer/dashboard/programs/workout-history.svg");
var _useGetClientWorkoutsTab = require("src/api/queries/useGetClientWorkoutsTab");
var _genderUtils = require("src/utils/genderUtils");
var _sessionStore = require("src/store/sessionStore");
var _emptyState = require("./EmptyState");
var _workoutsTabScss = require("./WorkoutsTab.scss");
const WorkoutsTab = ()=>{
    const { client } = (0, _reactRouterDom.useOutletContext)();
    const [visibleThumbnails, setVisibleThumbnails] = (0, _react.useState)(7);
    const thumbnailsContainerRef = (0, _react.useRef)(null);
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { uid } = (0, _reactRouterDom.useParams)();
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const trainerId = currentUser?.uid;
    const { data, isLoading } = (0, _useGetClientWorkoutsTab.useGetClientWorkoutsTab)(uid || '', trainerId);
    (0, _react.useEffect)(()=>{
        const updateVisibleCount = ()=>{
            if (thumbnailsContainerRef.current) {
                // Get container width and calculate how many 80px thumbnails + 12px gaps (92px) can fit.
                // We subtract 1 to reserve space for the .more-btn which is always displayed.
                const containerWidth = thumbnailsContainerRef.current.clientWidth;
                const maxItems = Math.max(1, Math.floor(containerWidth / 92) - 1);
                setVisibleThumbnails(maxItems);
            }
        };
        updateVisibleCount();
        window.addEventListener('resize', updateVisibleCount);
        return ()=>window.removeEventListener('resize', updateVisibleCount);
    }, []);
    const formatDate = (isoStr)=>{
        if (!isoStr) return '-';
        if (isoStr.includes("\u2022") && !isoStr.includes('T')) return isoStr;
        try {
            const parsed = (0, _dayjsDefault.default)(isoStr);
            if (parsed.isValid()) {
                const currentYear = (0, _dayjsDefault.default)().year();
                const finalDate = parsed.year() === 2001 && !isoStr.includes('2001') ? parsed.year(currentYear) : parsed;
                return finalDate.format("MMM DD, YYYY \u2022 h:mm A");
            }
            return isoStr;
        } catch  {
            return isoStr;
        }
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "workouts-tab-container loading",
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 400,
            gap: 16
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                    style: {
                        fontSize: 32,
                        color: '#ffa100'
                    },
                    spin: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                style: {
                    fontSize: 16,
                    fontWeight: 500,
                    color: '#ffffffb3'
                },
                children: "Loading Workouts"
            })
        ]
    });
    const workouts = data?.workouts || [];
    const isDraftProgram = data?.isDraft === true || data?.status === 'draft';
    const generatorType = data?.generatorType === 'manual' || data?.type === 'manual' ? 'manual' : 'ai';
    if (workouts.length === 0 || isDraftProgram) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "workouts-tab-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "dashboard-empty-state-wrapper",
            style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '400px',
                width: '100%'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyState.EmptyState), {
                message: isDraftProgram ? 'You have an unfinished program draft for this client.' : 'No Workouts Recorded Yet',
                buttonText: isDraftProgram ? 'Continue to Finish Program' : undefined,
                onButtonClick: isDraftProgram ? ()=>navigate(`/onboarding-trainer/dashboard/program-generator/${generatorType}?programId=${data?.programId}`) : undefined,
                hideIcon: true,
                hideMessage: false,
                marginTop: "0"
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "workouts-tab-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "workouts-tab-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "left-column",
                    children: [
                        workouts.map((workout, idx)=>{
                            const isFirst = idx === 0;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                children: [
                                    workout.isUpNext && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "up-next-section",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "up-next-label",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _upNextSvg.ReactComponent), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Up next"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "program-workout-card",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "card-header",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "title-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programWorkoutSvg.ReactComponent), {
                                                                className: "workout-icon"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                        className: "main-title",
                                                                        children: [
                                                                            workout.title,
                                                                            " "
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                        className: "subtitle",
                                                                        children: [
                                                                            "\u2022 ",
                                                                            workout.dateLabel
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navArrowIconSvg.ReactComponent), {
                                                        className: "nav-arrow cursor-pointer",
                                                        onClick: ()=>navigate(`/onboarding-trainer/dashboard/clients/${uid}/workouts/${idx + 1}`)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "thumbnails-row",
                                                ref: isFirst ? thumbnailsContainerRef : null,
                                                children: [
                                                    workout.exercises.slice(0, visibleThumbnails).map((item, eIdx)=>{
                                                        const isMale = (0, _genderUtils.isMaleProfile)(data || client);
                                                        const imgUrl = isMale ? item.image_male_url || item.image_female_url : item.image_female_url || item.image_male_url;
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "thumbnail",
                                                            children: imgUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: imgUrl,
                                                                alt: item.en_display_name || item.name || 'Exercise'
                                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                style: {
                                                                    width: '100%',
                                                                    height: '100%',
                                                                    backgroundColor: '#2a2d3d',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'center',
                                                                    borderRadius: '8px',
                                                                    color: '#8a8d9d',
                                                                    fontSize: '12px',
                                                                    fontWeight: 'bold',
                                                                    textTransform: 'uppercase'
                                                                },
                                                                children: (item.en_display_name || item.name || 'EX').substring(0, 2)
                                                            })
                                                        }, eIdx);
                                                    }),
                                                    workout.exercises.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "thumbnail more-btn cursor-pointer",
                                                        onClick: ()=>navigate(`/onboarding-trainer/dashboard/clients/${uid}/workouts/${idx + 1}`),
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreProgramWorkoutSvg.ReactComponent), {})
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, idx);
                        }),
                        workouts.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                color: '#fff',
                                opacity: 0.7,
                                padding: '24px'
                            },
                            children: "No workouts scheduled."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "right-column",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "workout-history-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "card-header",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "title-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _workoutHistorySvg.ReactComponent), {
                                            className: "history-icon"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Workout History"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "history-list",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "history-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: "Last workout completed"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: formatDate(data?.lastWorkoutCompleted)
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "history-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: "Next scheduled workout"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: formatDate(data?.nextScheduledWorkout)
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["useNavigate","f3cgC"],["useOutletContext","9oT3O"],["useParams","9oT3O"]],"antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"dayjs":"adpMK","src/assets/images/trainer/clients/program_workout.svg":"EI0fZ","src/assets/images/trainer/clients/nav-arrow-icon.svg":"3jSUC","src/assets/images/trainer/clients/more_program_workout.svg":"21mCv","src/assets/images/onboarding-trainer/dashboard/programs/up_next.svg":"4xxKb","src/assets/images/onboarding-trainer/dashboard/programs/workout-history.svg":"eiMHv","src/api/queries/useGetClientWorkoutsTab":"h8u6i","src/utils/genderUtils":"aiA54","src/store/sessionStore":"kPSO3","./EmptyState":"a8ne2","./WorkoutsTab.scss":"3aulW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4xxKb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgUpNext);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUpNext = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 53,
        fill: "none",
        viewBox: "0 0 16 53",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M6.657 52.207a1 1 0 0 0 1.414 0l6.364-6.364a1 1 0 1 0-1.414-1.414l-5.657 5.657-5.657-5.657a1 1 0 0 0-1.414 1.414zM8.364 1.5a1 1 0 0 0-2 0h2m0 45.833a1 1 0 1 0-2 0h2m-2-8.333a1 1 0 1 0 2 0h-2m2-8.333a1 1 0 1 0-2 0h2m-2-8.334a1 1 0 1 0 2 0h-2m2-8.333a1 1 0 1 0-2 0h2m-2-8.333a1 1 0 1 0 2 0h-2m1 45.833h1v-4.167h-2V51.5zm0-12.5h1v-8.333h-2V39zm0-16.667h1V14h-2v8.333zm0-16.666h1V1.5h-2v4.167z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eiMHv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgWorkoutHistory);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgWorkoutHistory = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#42CDFF",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#42CDFF",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#42CDFF",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M8.5 14.5s1.504-2.049 2.725-3.271a6.75 6.75 0 1 1-1.712 6.646M13 14.5H8.5V10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h8u6i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetClientWorkoutsTab", ()=>useGetClientWorkoutsTab);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _reactHotToast = require("react-hot-toast");
const fetchWorkoutsTab = async (clientId, trainerId)=>{
    const queryParams = new URLSearchParams({
        clientId
    });
    if (trainerId) queryParams.append('trainerId', trainerId);
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_CLIENT_WORKOUTS_TAB}?${queryParams.toString()}`;
    try {
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error('Network response was not ok');
        const json = await response.json();
        if (json.status === 'ok') return json.data;
        else throw new Error(json.error || 'Failed to fetch workouts tab data');
    } catch (error) {
        (0, _reactHotToast.toast).error(error.message || 'Error fetching workouts tab data');
        throw error;
    }
};
const useGetClientWorkoutsTab = (clientId, trainerId)=>{
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'clientWorkoutsTab',
            clientId,
            trainerId
        ],
        queryFn: ()=>fetchWorkoutsTab(clientId, trainerId),
        enabled: !!clientId
    });
};

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","react-hot-toast":"3T0Wh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3aulW":[function() {},{}],"jStZT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientProfileTab", ()=>ClientProfileTab);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _reactRouterDom = require("react-router-dom");
var _useGetClientProfileTab = require("../../../../../../../api/queries/useGetClientProfileTab");
var _genderUtils = require("src/utils/genderUtils");
var _injuriesNotesModal = require("./ClientProfileTab/InjuriesNotesModal");
var _injurieslimitationsMaleNeckWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-neck.webp");
var _injurieslimitationsMaleNeckWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleNeckWebp);
var _injurieslimitationsMaleShouldersWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-shoulders.webp");
var _injurieslimitationsMaleShouldersWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleShouldersWebp);
var _injurieslimitationsMaleChestWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-chest.webp");
var _injurieslimitationsMaleChestWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleChestWebp);
var _injurieslimitationsMaleCoreWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-core.webp");
var _injurieslimitationsMaleCoreWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleCoreWebp);
var _injurieslimitationsMaleBackWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-back.webp");
var _injurieslimitationsMaleBackWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleBackWebp);
var _injurieslimitationsMaleWristsWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-wrists.webp");
var _injurieslimitationsMaleWristsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleWristsWebp);
var _injurieslimitationsMaleElbowWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-elbow.webp");
var _injurieslimitationsMaleElbowWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleElbowWebp);
var _injurieslimitationsMaleArmsWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-arms.webp");
var _injurieslimitationsMaleArmsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleArmsWebp);
var _injurieslimitationsMaleHipsWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-hips.webp");
var _injurieslimitationsMaleHipsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleHipsWebp);
var _injurieslimitationsMaleKneesWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-knees.webp");
var _injurieslimitationsMaleKneesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleKneesWebp);
var _injurieslimitationsMaleAnklesWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-ankles.webp");
var _injurieslimitationsMaleAnklesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleAnklesWebp);
var _injurieslimitationsMaleGlutesWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-glutes.webp");
var _injurieslimitationsMaleGlutesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleGlutesWebp);
var _injurieslimitationsFemaleNeckWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-neck.webp");
var _injurieslimitationsFemaleNeckWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleNeckWebp);
var _injurieslimitationsFemaleShouldersWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-shoulders.webp");
var _injurieslimitationsFemaleShouldersWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleShouldersWebp);
var _injurieslimitationsFemaleChestWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-chest.webp");
var _injurieslimitationsFemaleChestWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleChestWebp);
var _injurieslimitationsFemaleCoreWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-core.webp");
var _injurieslimitationsFemaleCoreWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleCoreWebp);
var _injurieslimitationsFemaleBackWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-back.webp");
var _injurieslimitationsFemaleBackWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleBackWebp);
var _injurieslimitationsFemaleWristsWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-wrists.webp");
var _injurieslimitationsFemaleWristsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleWristsWebp);
var _injurieslimitationsFemaleElbowWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-elbow.webp");
var _injurieslimitationsFemaleElbowWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleElbowWebp);
var _injurieslimitationsFemaleArmsWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-arms.webp");
var _injurieslimitationsFemaleArmsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleArmsWebp);
var _injurieslimitationsFemaleHipsWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-hips.webp");
var _injurieslimitationsFemaleHipsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleHipsWebp);
var _injurieslimitationsFemaleKneesWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-knees.webp");
var _injurieslimitationsFemaleKneesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleKneesWebp);
var _injurieslimitationsFemaleAnklesWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-ankles.webp");
var _injurieslimitationsFemaleAnklesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleAnklesWebp);
var _injurieslimitationsFemaleGlutesWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-glutes.webp");
var _injurieslimitationsFemaleGlutesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleGlutesWebp);
var _injurieslimitationsFemalePregnancyWebp = require("url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-pregnancy.webp");
var _injurieslimitationsFemalePregnancyWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemalePregnancyWebp);
var _clientProfileSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/client_profile.svg");
var _injuriesNotesSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injuries_notes.svg");
var _editSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/edit.svg");
var _bodyMetricsCompositionFemalePng = require("url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/body-metrics-composition-female.png");
var _bodyMetricsCompositionFemalePngDefault = parcelHelpers.interopDefault(_bodyMetricsCompositionFemalePng);
var _bodyMetricsCompositionMalePng = require("url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/body-metrics-composition-male.png");
var _bodyMetricsCompositionMalePngDefault = parcelHelpers.interopDefault(_bodyMetricsCompositionMalePng);
var _bodyMetricsCompositionSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/programs/body-metrics-composition.svg");
var _progressPhotosSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/programs/progress-photos.svg");
var _addProgressPhotosSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/programs/add-progress-photos.svg");
var _frontJpg = require("url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/front.jpg");
var _frontJpgDefault = parcelHelpers.interopDefault(_frontJpg);
var _sideJpg = require("url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/side.jpg");
var _sideJpgDefault = parcelHelpers.interopDefault(_sideJpg);
var _backJpg = require("url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/back.jpg");
var _backJpgDefault = parcelHelpers.interopDefault(_backJpg);
var _movementProgressionChart = require("./MovementProgressionChart");
const SHOW_PROGRESS_SECTION = false;
const mapActivityLevel = (level)=>{
    if (level === null || level === undefined || level === '' || level === 'No data') return 'No data';
    const num = Number(level);
    if (isNaN(num)) return 'No data';
    if (num < 30) return 'Lightly Active';
    if (num < 70) return 'Moderately Active';
    return 'Very Active';
};
const mapEnergyLevel = (level)=>{
    if (!level || level === 'No data') return 'No data';
    const norm = level.toLowerCase().replace(/_/g, '-');
    if (norm === 'often-low') return 'Often Low';
    if (norm === 'often-high') return 'Often High';
    if (norm === 'fluctuates') return 'Fluctuates';
    return toTitleCase(level);
};
const mapFitnessLevel = (level)=>{
    if (!level || level === 'No data') return 'No data';
    switch(level.toLowerCase().replace(/_/g, '-')){
        case 'beginner':
            return 'Beginner';
        case 'early-intermediate':
            return 'Early Intermediate';
        case 'intermediate':
            return 'Intermediate';
        case 'advanced':
            return 'Advanced';
        case 'athlete':
            return 'Athlete';
        default:
            return level ? toTitleCase(level) : 'No data';
    }
};
const toTitleCase = (str)=>str.split('-').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
const renderDots = (value, max = 6)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "value-dots",
        children: Array.from({
            length: max
        }).map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `dot ${i < value ? 'purple-100' : 'white-15'}`
            }, i))
    });
};
const ClientProfileTab = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { client } = (0, _reactRouterDom.useOutletContext)();
    const [isInjuriesModalOpen, setIsInjuriesModalOpen] = (0, _react.useState)(false);
    const { data, isLoading } = (0, _useGetClientProfileTab.useGetClientProfileTab)(client?.uid || client?.id);
    const isFemale = (0, _genderUtils.isFemaleProfile)(data?.clientProfile || client);
    const injuryIconMapping = {
        neck: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: isFemale ? (0, _injurieslimitationsFemaleNeckWebpDefault.default) : (0, _injurieslimitationsMaleNeckWebpDefault.default),
            alt: "neck",
            className: "program-svg-icon"
        }),
        shoulders: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: isFemale ? (0, _injurieslimitationsFemaleShouldersWebpDefault.default) : (0, _injurieslimitationsMaleShouldersWebpDefault.default),
            alt: "shoulders",
            className: "program-svg-icon"
        }),
        chest: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: isFemale ? (0, _injurieslimitationsFemaleChestWebpDefault.default) : (0, _injurieslimitationsMaleChestWebpDefault.default),
            alt: "chest",
            className: "program-svg-icon"
        }),
        core: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: isFemale ? (0, _injurieslimitationsFemaleCoreWebpDefault.default) : (0, _injurieslimitationsMaleCoreWebpDefault.default),
            alt: "core",
            className: "program-svg-icon"
        }),
        back: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: isFemale ? (0, _injurieslimitationsFemaleBackWebpDefault.default) : (0, _injurieslimitationsMaleBackWebpDefault.default),
            alt: "back",
            className: "program-svg-icon"
        }),
        wrists: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: isFemale ? (0, _injurieslimitationsFemaleWristsWebpDefault.default) : (0, _injurieslimitationsMaleWristsWebpDefault.default),
            alt: "wrists",
            className: "program-svg-icon"
        }),
        elbow: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: isFemale ? (0, _injurieslimitationsFemaleElbowWebpDefault.default) : (0, _injurieslimitationsMaleElbowWebpDefault.default),
            alt: "elbow",
            className: "program-svg-icon"
        }),
        arms: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: isFemale ? (0, _injurieslimitationsFemaleArmsWebpDefault.default) : (0, _injurieslimitationsMaleArmsWebpDefault.default),
            alt: "arms",
            className: "program-svg-icon"
        }),
        hips: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: isFemale ? (0, _injurieslimitationsFemaleHipsWebpDefault.default) : (0, _injurieslimitationsMaleHipsWebpDefault.default),
            alt: "hips",
            className: "program-svg-icon"
        }),
        knees: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: isFemale ? (0, _injurieslimitationsFemaleKneesWebpDefault.default) : (0, _injurieslimitationsMaleKneesWebpDefault.default),
            alt: "knees",
            className: "program-svg-icon"
        }),
        ankles: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: isFemale ? (0, _injurieslimitationsFemaleAnklesWebpDefault.default) : (0, _injurieslimitationsMaleAnklesWebpDefault.default),
            alt: "ankles",
            className: "program-svg-icon"
        }),
        glutes: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: isFemale ? (0, _injurieslimitationsFemaleGlutesWebpDefault.default) : (0, _injurieslimitationsMaleGlutesWebpDefault.default),
            alt: "glutes",
            className: "program-svg-icon"
        }),
        pregnancy: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemalePregnancyWebpDefault.default),
            alt: "pregnancy",
            className: "program-svg-icon"
        }) : null
    };
    if (isLoading || !data) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "program-tab-content client-profile-content",
        style: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 400,
            gap: 16
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                    style: {
                        fontSize: 32,
                        color: '#ffa100'
                    },
                    spin: true
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                style: {
                    fontSize: 16,
                    fontWeight: 500,
                    color: '#ffffffb3'
                },
                children: "Loading Profile"
            })
        ]
    });
    const { clientProfile, bodyMetrics, progressPhotos } = data;
    const { fitnessLevel, energyLevel, activityLevel } = clientProfile;
    const injuriesPartsRaw = data?.injuriesAndNotes?.parts || [];
    const injuriesParts = injuriesPartsRaw.map((p)=>typeof p === 'object' && p !== null ? p.slug : p);
    const injuriesNotes = data?.injuriesAndNotes?.notes || '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "program-tab-content client-profile-content",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "program-cards-grid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "program-card review-card client-profile-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientProfileSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Client Profile"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        onClick: ()=>navigate(`/onboarding-trainer/dashboard/program-generator/ai?clientId=${client?.uid || client?.id}&step=energy-level&from=client-profile`),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {
                                            style: {
                                                cursor: 'pointer'
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "card-body",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "info-row client-profile-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "client-profile-details",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value fitness-level-value",
                                                    children: mapFitnessLevel(fitnessLevel)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "inline-info",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "label",
                                                            children: "Energy:"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: mapEnergyLevel(energyLevel)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "inline-info",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "label",
                                                            children: "Activity:"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: mapActivityLevel(activityLevel)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "client-profile-graphs",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "client-profile-chart",
                                                    children: [
                                                        40,
                                                        60,
                                                        30,
                                                        80,
                                                        50,
                                                        70,
                                                        90
                                                    ].map((h, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: `bar bar-h${h}`
                                                        }, i))
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "client-profile-dots",
                                                    children: renderDots(activityLevel != null && activityLevel !== '' && !isNaN(Number(activityLevel)) ? Math.min(6, Math.max(1, Math.ceil(Number(activityLevel) / 100 * 6))) : 0, 6)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "program-card review-card injuries-notes-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _injuriesNotesSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Injuries & Notes"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        onClick: ()=>navigate(`/onboarding-trainer/dashboard/program-generator/ai?clientId=${client?.uid || client?.id}&step=injuries-limitations&from=client-profile`),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {
                                            style: {
                                                cursor: 'pointer'
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body injuries-notes-body",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "injuries-notes",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "inline-info",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value injuries-value",
                                                    children: injuriesParts.length > 0 ? injuriesParts.slice(0, 3).map(toTitleCase).join(', ') + (injuriesParts.length > 3 ? '...' : '') : 'None'
                                                })
                                            }),
                                            injuriesNotes ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "inline-info",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value notes-value",
                                                    children: injuriesNotes
                                                })
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "inline-info",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value",
                                                    children: "No special notes"
                                                })
                                            }),
                                            (injuriesParts.length > 3 || injuriesNotes && injuriesNotes.trim().length > 0) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "show-more-toggle",
                                                onClick: ()=>setIsInjuriesModalOpen(true),
                                                children: "Show More"
                                            })
                                        ]
                                    }),
                                    injuriesParts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "injuries-notes-image",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "stacked-images",
                                            children: injuriesParts.slice(0, 3).reverse().map((part, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `stacked-img stack-${injuriesParts.slice(0, 3).length - 1 - i}`,
                                                    children: injuryIconMapping[part]
                                                }, part))
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "program-card review-card body-metrics-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bodyMetricsCompositionSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Body Metrics & Composition"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body body-metrics-body",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "body-model-container",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                            src: isFemale ? (0, _bodyMetricsCompositionFemalePngDefault.default) : (0, _bodyMetricsCompositionMalePngDefault.default),
                                            alt: "Body Metrics Model"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "metrics-grid",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "metric-badge",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Waist:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: bodyMetrics.waist || 'No Data'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "metric-badge",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Weight:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: bodyMetrics.weight || 'No Data'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "metric-badge",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Chest:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: bodyMetrics.chest || 'No Data'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "metric-badge",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Height:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: bodyMetrics.height || 'No Data'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "metric-badge",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Hip:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: bodyMetrics.hip || 'No Data'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "metric-badge",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Body Fat:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: bodyMetrics.bodyFat || 'No Data'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "metric-badge",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Arms:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: bodyMetrics.arms || 'No Data'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "metric-badge",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Lean Mass:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: bodyMetrics.leanMass || 'No Data'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "metric-badge",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Thighs:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: bodyMetrics.thighs || 'No Data'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "metric-badge",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Age:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: bodyMetrics.age || 'No Data'
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    SHOW_PROGRESS_SECTION && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "program-card review-card progress-photos-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _progressPhotosSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Progress Photos"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn add-btn",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addProgressPhotosSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body progress-photos-body",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "photos-row",
                                        children: progressPhotos.photos.map((photo, i)=>{
                                            const getLocalImage = (type)=>{
                                                if (type === 'front') return 0, _frontJpgDefault.default;
                                                if (type === 'side') return 0, _sideJpgDefault.default;
                                                return 0, _backJpgDefault.default;
                                            };
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "photo-container",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "photo-frame",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: photo.url || getLocalImage(photo.type),
                                                            alt: photo.label
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "photo-label",
                                                            children: photo.label
                                                        })
                                                    ]
                                                })
                                            }, i);
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "last-updated",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: "Last updated:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "value",
                                                children: [
                                                    " ",
                                                    progressPhotos.lastUpdated
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "view-all-btn",
                                        children: "View All Photos"
                                    })
                                ]
                            })
                        ]
                    }),
                    data?.movementProgression?.baseValues && data.movementProgression.baseValues.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movementProgressionChart.MovementProgressionChart), {
                        baseValues: data.movementProgression.baseValues,
                        legendData: data.movementProgression.legendData || []
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _injuriesNotesModal.InjuriesNotesModal), {
                isOpen: isInjuriesModalOpen,
                onClose: ()=>setIsInjuriesModalOpen(false),
                injuriesParts: injuriesParts,
                injuriesNotes: injuriesNotes,
                injuryIconMapping: injuryIconMapping,
                toTitleCase: toTitleCase
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"react-router-dom":[["useNavigate","f3cgC"],["useOutletContext","9oT3O"]],"../../../../../../../api/queries/useGetClientProfileTab":"9YkSm","src/utils/genderUtils":"aiA54","./ClientProfileTab/InjuriesNotesModal":"isil5","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-neck.webp":"bMNGc","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-shoulders.webp":"9f150","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-chest.webp":"1WA6S","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-core.webp":"6ykDS","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-back.webp":"552LM","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-wrists.webp":"2vVR2","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-elbow.webp":"5rwm2","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-arms.webp":"gywcQ","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-hips.webp":"IL2gD","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-knees.webp":"chOpQ","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-ankles.webp":"9LTxX","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-male-glutes.webp":"axt4z","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-neck.webp":"7ieJ8","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-shoulders.webp":"c4vn4","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-chest.webp":"18x57","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-core.webp":"fAYwU","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-back.webp":"b7YNj","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-wrists.webp":"jqY0l","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-elbow.webp":"cUOkG","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-arms.webp":"ejSWy","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-hips.webp":"4XVjh","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-knees.webp":"bahGv","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-ankles.webp":"aEszt","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-glutes.webp":"1xfcS","url:../../../../../../../assets/images/trainer/program-generator/injurieslimitations-female-pregnancy.webp":"zojTP","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/client_profile.svg":"4wtpD","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injuries_notes.svg":"tA9Si","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/edit.svg":"jR7RI","url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/body-metrics-composition-female.png":"dZsI6","url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/body-metrics-composition-male.png":"4b8qa","../../../../../../../assets/images/onboarding-trainer/dashboard/programs/body-metrics-composition.svg":"fS2v8","../../../../../../../assets/images/onboarding-trainer/dashboard/programs/progress-photos.svg":"f6pgd","../../../../../../../assets/images/onboarding-trainer/dashboard/programs/add-progress-photos.svg":"76yRL","url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/front.jpg":"3V3GB","url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/side.jpg":"dcl8n","url:../../../../../../../assets/images/onboarding-trainer/dashboard/programs/back.jpg":"9LCEs","./MovementProgressionChart":"6LFQg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9YkSm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetClientProfileTab", ()=>useGetClientProfileTab);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _sessionStore = require("src/store/sessionStore");
const getClientProfileTab = async (clientId, trainerId)=>{
    if (!clientId) throw new Error('clientId is required');
    let apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_CLIENT_PROFILE_TAB}?clientId=${clientId}`;
    if (trainerId) apiUrl += `&trainerId=${trainerId}`;
    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new Error('Failed to fetch client profile tab');
    const data = await response.json();
    return data.data;
};
const useGetClientProfileTab = (clientId)=>{
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const trainerId = currentUser?.uid;
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'clientProfileTab',
            clientId
        ],
        queryFn: ()=>getClientProfileTab(clientId, trainerId),
        enabled: !!clientId
    });
};

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"isil5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InjuriesNotesModal", ()=>InjuriesNotesModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _injuriesNotesSvg = require("../../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injuries_notes.svg");
var _closeSvg = require("src/assets/images/trainer/clients/close.svg");
var _injuriesNotesModalScss = require("./InjuriesNotesModal.scss");
const InjuriesNotesModal = ({ isOpen, onClose, injuriesParts, injuriesNotes, injuryIconMapping, toTitleCase })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        onCancel: onClose,
        footer: null,
        centered: true,
        width: 540,
        rootClassName: "injuries-notes-list-modal",
        closeIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeSvg.ReactComponent), {
            className: "modal-close-icon"
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "injuries-notes-modal-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "modal-header",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-left",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "header-icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _injuriesNotesSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "header-text",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: "Injuries & Notes"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "subtitle",
                                        children: injuriesParts.length > 0 ? `${injuriesParts.length} injuries & limitations recorded` : 'Client injury profile & special notes'
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                            className: "section-title",
                            children: "Injuries & Limitations"
                        }),
                        injuriesParts.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "injuries-grid",
                            children: injuriesParts.map((part, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "injury-item-card",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "injury-name",
                                            children: toTitleCase(part)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "injury-icon-wrapper",
                                            children: injuryIconMapping[part]
                                        })
                                    ]
                                }, idx))
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "empty-section-text",
                            children: "None recorded"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-section notes-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                            className: "section-title",
                            children: "Special Notes"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "notes-box",
                            children: injuriesNotes && injuriesNotes.trim() ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "notes-text",
                                children: injuriesNotes
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "notes-empty",
                                children: "No special notes provided"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "modal-footer",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "btn-close",
                        onClick: onClose,
                        children: "Done"
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"../../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injuries_notes.svg":"tA9Si","src/assets/images/trainer/clients/close.svg":"5zasw","./InjuriesNotesModal.scss":"e8rHr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e8rHr":[function() {},{}],"bMNGc":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fQBVY");

},{}],"9f150":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8iuNf");

},{}],"1WA6S":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gCy98");

},{}],"6ykDS":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gXoGf");

},{}],"552LM":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cXVu4");

},{}],"2vVR2":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("k07q9");

},{}],"5rwm2":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("Uo081");

},{}],"gywcQ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fgT7C");

},{}],"IL2gD":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fJ5iT");

},{}],"chOpQ":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gMf2g");

},{}],"9LTxX":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kSzbO");

},{}],"axt4z":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8SSAy");

},{}],"7ieJ8":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gpXNH");

},{}],"c4vn4":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3uv1C");

},{}],"18x57":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("hD7oi");

},{}],"fAYwU":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("17o0c");

},{}],"b7YNj":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4SPCV");

},{}],"jqY0l":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cfFci");

},{}],"cUOkG":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("17SPs");

},{}],"ejSWy":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7wK01");

},{}],"4XVjh":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3op2n");

},{}],"bahGv":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7ru8O");

},{}],"aEszt":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6ZDtY");

},{}],"1xfcS":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8oRU4");

},{}],"zojTP":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("iwlhh");

},{}],"dZsI6":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fuF5X");

},{}],"4b8qa":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("58pze");

},{}],"fS2v8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBodyMetricsComposition);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBodyMetricsComposition = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                d: "M12.063 10.094a1.97 1.97 0 0 1 1.968-1.969h3.938a1.97 1.97 0 0 1 1.968 1.969v11.812a1.97 1.97 0 0 1-1.968 1.969H14.03q-.204 0-.396-.04a1.97 1.97 0 0 1-1.572-1.929zm1.124.281V11.5h1.688a.562.562 0 1 0 0-1.125zm0 2.531v1.125H16a.562.562 0 1 0 0-1.125zm0 2.531v1.126h1.688a.562.562 0 1 0 0-1.125zm0 2.532v1.125H16a.562.562 0 1 0 0-1.125zm0 2.531v1.125h1.688a.562.562 0 1 0 0-1.125z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f6pgd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProgressPhotos);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgressPhotos = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#42CDFF",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#42CDFF",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#42CDFF",
                d: "M21.25 11.5h-1.19l-.75-.75c-.434-.434-1.196-.75-1.81-.75h-3c-.614 0-1.376.316-1.81.75l-.75.75h-1.19c-1.24 0-2.25 1.01-2.25 2.25v6c0 1.24 1.01 2.25 2.25 2.25h10.5c1.24 0 2.25-1.01 2.25-2.25v-6c0-1.24-1.01-2.25-2.25-2.25M16 19a2.625 2.625 0 1 1 0-5.25A2.625 2.625 0 0 1 16 19m4.5-3.526a.975.975 0 1 1 0-1.95.975.975 0 0 1 0 1.95"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"76yRL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAddProgressPhotos);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAddProgressPhotos = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 32,
                height: 32,
                fill: "#fff",
                fillOpacity: 0.05,
                rx: 16
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 31.5,
                height: 31.5,
                x: 0.25,
                y: 0.25,
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.5,
                rx: 15.75
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M10.75 16.012h10.5M16 10.762v10.5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3V3GB":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("l48yo");

},{}],"dcl8n":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("hAPUJ");

},{}],"9LCEs":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8BEE7");

},{}],"6LFQg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MovementProgressionChart", ()=>MovementProgressionChart);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _recharts = require("recharts");
var _movementInsightsSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/movement_insights.svg");
var _upSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/programs/up.svg");
var _downSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/programs/down.svg");
const CustomTooltip = ({ active, payload, label })=>{
    if (active && payload && payload.length) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "custom-tooltip",
        style: {
            background: '#0b0c25',
            padding: '8px 12px',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '8px',
            color: '#fff'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "label",
                style: {
                    margin: '0 0 4px',
                    fontSize: '12px',
                    color: 'rgba(255,255,255,0.7)'
                },
                children: label
            }),
            payload.map((entry, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    style: {
                        color: entry.color,
                        margin: 0,
                        fontSize: '14px',
                        fontWeight: 600
                    },
                    children: [
                        entry.name,
                        ": ",
                        entry.value,
                        "%"
                    ]
                }, index))
        ]
    });
    return null;
};
const MovementProgressionChart = ({ baseValues, legendData })=>{
    const generateDynamicData = ()=>{
        const generatedData = [];
        const today = new Date();
        const formatMonthDay = (date)=>{
            const months = [
                'Jan',
                'Feb',
                'Mar',
                'Apr',
                'May',
                'Jun',
                'Jul',
                'Aug',
                'Sep',
                'Oct',
                'Nov',
                'Dec'
            ];
            const day = date.getDate().toString().padStart(2, '0');
            return `${months[date.getMonth()]} ${day}`;
        };
        // Map each data point to formatted historical dates spaced ~monthly
        const count = baseValues.length;
        for(let i = 0; i < count; i++){
            const daysAgo = (count - 1 - i) * 28;
            const d = new Date(today.getTime() - daysAgo * 86400000);
            generatedData.push({
                name: formatMonthDay(d),
                ...baseValues[i]
            });
        }
        return generatedData;
    };
    const data = generateDynamicData();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "program-card movement-progression-card",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "card-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "icon",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movementInsightsSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Movement Progression"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "card-body",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "chart-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.ResponsiveContainer), {
                            width: "100%",
                            height: "100%",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _recharts.LineChart), {
                                data: data,
                                margin: {
                                    top: 15,
                                    right: 12,
                                    left: -25,
                                    bottom: 0
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.CartesianGrid), {
                                        stroke: "rgba(255, 255, 255, 0.05)",
                                        vertical: true,
                                        horizontal: true
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.XAxis), {
                                        dataKey: "name",
                                        axisLine: {
                                            stroke: 'rgba(255, 255, 255, 0.05)'
                                        },
                                        tickLine: false,
                                        // @ts-expect-error lineHeight
                                        tick: {
                                            fill: '#FFFFFFB2',
                                            fontSize: 11,
                                            lineHeight: 14
                                        },
                                        dy: 8
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.YAxis), {
                                        axisLine: {
                                            stroke: 'rgba(255, 255, 255, 0.05)'
                                        },
                                        tickLine: false,
                                        // @ts-expect-error lineHeight
                                        tick: {
                                            fill: '#FFFFFFB2',
                                            fontSize: 11,
                                            lineHeight: 14
                                        },
                                        tickFormatter: (value)=>`${value}%`,
                                        domain: [
                                            0,
                                            100
                                        ],
                                        ticks: [
                                            0,
                                            25,
                                            50,
                                            75,
                                            100
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Tooltip), {
                                        content: /*#__PURE__*/ (0, _jsxRuntime.jsx)(CustomTooltip, {}),
                                        cursor: {
                                            stroke: 'rgba(255, 255, 255, 0.2)'
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Line), {
                                        type: "monotone",
                                        dataKey: "mobility",
                                        name: "Mobility",
                                        stroke: "#755BDF",
                                        strokeWidth: 1.5,
                                        dot: {
                                            r: 2.5,
                                            fill: '#755BDF',
                                            strokeWidth: 0
                                        },
                                        activeDot: {
                                            r: 4.5
                                        },
                                        connectNulls: false
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Line), {
                                        type: "monotone",
                                        dataKey: "stability",
                                        name: "Stability",
                                        stroke: "#42CDFF",
                                        strokeWidth: 1.5,
                                        dot: {
                                            r: 2.5,
                                            fill: '#42CDFF',
                                            strokeWidth: 0
                                        },
                                        activeDot: {
                                            r: 4.5
                                        },
                                        connectNulls: false
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Line), {
                                        type: "monotone",
                                        dataKey: "balance",
                                        name: "Balance",
                                        stroke: "#22D543",
                                        strokeWidth: 1.5,
                                        dot: {
                                            r: 2.5,
                                            fill: '#22D543',
                                            strokeWidth: 0
                                        },
                                        activeDot: {
                                            r: 4.5
                                        },
                                        connectNulls: false
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recharts.Line), {
                                        type: "monotone",
                                        dataKey: "quality",
                                        name: "Quality",
                                        stroke: "#FFA100",
                                        strokeWidth: 1.5,
                                        dot: {
                                            r: 2.5,
                                            fill: '#FFA100',
                                            strokeWidth: 0
                                        },
                                        activeDot: {
                                            r: 4.5
                                        },
                                        connectNulls: false
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "custom-legend",
                        children: legendData.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legend-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "legend-title",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "dot",
                                                style: {
                                                    backgroundColor: item.color
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "label",
                                                children: [
                                                    item.label,
                                                    ":"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "legend-status",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "status-text",
                                                children: item.status
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: `trend-pill ${item.trend}`,
                                                children: [
                                                    item.trend === 'up' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _upSvg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: item.percentage
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, item.key))
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","recharts":[["CartesianGrid","74v6C"],["Line","ai7ym"],["LineChart","7PM4x"],["ResponsiveContainer","7epZf"],["Tooltip","jq3he"],["XAxis","lpbvS"],["YAxis","iccw2"]],"../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/movement_insights.svg":"9MrjD","../../../../../../../assets/images/onboarding-trainer/dashboard/programs/up.svg":"fwzp4","../../../../../../../assets/images/onboarding-trainer/dashboard/programs/down.svg":"5HSNL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"74v6C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultCartesianGridProps", ()=>defaultCartesianGridProps);
parcelHelpers.export(exports, "CartesianGrid", ()=>CartesianGrid);
/**
 * @fileOverview Cartesian Grid
 */ var _react = require("react");
var _logUtils = require("../util/LogUtils");
var _dataUtils = require("../util/DataUtils");
var _chartUtils = require("../util/ChartUtils");
var _getTicks = require("./getTicks");
var _cartesianAxis = require("./CartesianAxis");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _axisSelectors = require("../state/selectors/axisSelectors");
var _hooks = require("../state/hooks");
var _panoramaContext = require("../context/PanoramaContext");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
var _svgPropertiesNoEvents = require("../util/svgPropertiesNoEvents");
var _isWellBehavedNumber = require("../util/isWellBehavedNumber");
var _zindexLayer = require("../zIndex/ZIndexLayer");
var _defaultZIndexes = require("../zIndex/DefaultZIndexes");
var _excluded = [
    "x1",
    "y1",
    "x2",
    "y2",
    "key"
], _excluded2 = [
    "offset"
], _excluded3 = [
    "xAxisId",
    "yAxisId"
], _excluded4 = [
    "xAxisId",
    "yAxisId"
];
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * The <CartesianGrid horizontal
 */ var Background = (props)=>{
    var { fill } = props;
    if (!fill || fill === 'none') return null;
    var { fillOpacity, x, y, width, height, ry } = props;
    return /*#__PURE__*/ _react.createElement("rect", {
        x: x,
        y: y,
        ry: ry,
        width: width,
        height: height,
        stroke: "none",
        fill: fill,
        fillOpacity: fillOpacity,
        className: "recharts-cartesian-grid-bg"
    });
};
function LineItem(_ref) {
    var { option, lineItemProps } = _ref;
    var lineItem;
    if (/*#__PURE__*/ _react.isValidElement(option)) // @ts-expect-error typescript does not see the props type when cloning an element
    lineItem = /*#__PURE__*/ _react.cloneElement(option, lineItemProps);
    else if (typeof option === 'function') lineItem = option(lineItemProps);
    else {
        var _svgPropertiesNoEvent;
        var { x1, y1, x2, y2, key } = lineItemProps, others = _objectWithoutProperties(lineItemProps, _excluded);
        var _ref2 = (_svgPropertiesNoEvent = (0, _svgPropertiesNoEvents.svgPropertiesNoEvents)(others)) !== null && _svgPropertiesNoEvent !== void 0 ? _svgPropertiesNoEvent : {}, { offset: __ } = _ref2, restOfFilteredProps = _objectWithoutProperties(_ref2, _excluded2);
        lineItem = /*#__PURE__*/ _react.createElement("line", _extends({}, restOfFilteredProps, {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2,
            fill: "none",
            key: key
        }));
    }
    return lineItem;
}
function HorizontalGridLines(props) {
    var { x, width, horizontal = true, horizontalPoints } = props;
    if (!horizontal || !horizontalPoints || !horizontalPoints.length) return null;
    var { xAxisId, yAxisId } = props, otherLineItemProps = _objectWithoutProperties(props, _excluded3);
    var items = horizontalPoints.map((entry, i)=>{
        var lineItemProps = _objectSpread(_objectSpread({}, otherLineItemProps), {}, {
            x1: x,
            y1: entry,
            x2: x + width,
            y2: entry,
            key: "line-".concat(i),
            index: i
        });
        return /*#__PURE__*/ _react.createElement(LineItem, {
            key: "line-".concat(i),
            option: horizontal,
            lineItemProps: lineItemProps
        });
    });
    return /*#__PURE__*/ _react.createElement("g", {
        className: "recharts-cartesian-grid-horizontal"
    }, items);
}
function VerticalGridLines(props) {
    var { y, height, vertical = true, verticalPoints } = props;
    if (!vertical || !verticalPoints || !verticalPoints.length) return null;
    var { xAxisId, yAxisId } = props, otherLineItemProps = _objectWithoutProperties(props, _excluded4);
    var items = verticalPoints.map((entry, i)=>{
        var lineItemProps = _objectSpread(_objectSpread({}, otherLineItemProps), {}, {
            x1: entry,
            y1: y,
            x2: entry,
            y2: y + height,
            key: "line-".concat(i),
            index: i
        });
        return /*#__PURE__*/ _react.createElement(LineItem, {
            option: vertical,
            lineItemProps: lineItemProps,
            key: "line-".concat(i)
        });
    });
    return /*#__PURE__*/ _react.createElement("g", {
        className: "recharts-cartesian-grid-vertical"
    }, items);
}
function HorizontalStripes(props) {
    var { horizontalFill, fillOpacity, x, y, width, height, horizontalPoints, horizontal = true } = props;
    if (!horizontal || !horizontalFill || !horizontalFill.length || horizontalPoints == null) return null;
    var roundedSortedHorizontalPoints = horizontalPoints.map((e)=>Math.round(e + y - y)).sort((a, b)=>a - b);
    // Why is this condition `!==` instead of `<=` ?
    if (y !== roundedSortedHorizontalPoints[0]) roundedSortedHorizontalPoints.unshift(0);
    var items = roundedSortedHorizontalPoints.map((entry, i)=>{
        // Why do we strip only the last stripe if it is invisible, and not all invisible stripes?
        var lastStripe = !roundedSortedHorizontalPoints[i + 1];
        var lineHeight = lastStripe ? y + height - entry : roundedSortedHorizontalPoints[i + 1] - entry;
        if (lineHeight <= 0) return null;
        var colorIndex = i % horizontalFill.length;
        return /*#__PURE__*/ _react.createElement("rect", {
            key: "react-".concat(i),
            y: entry,
            x: x,
            height: lineHeight,
            width: width,
            stroke: "none",
            fill: horizontalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ _react.createElement("g", {
        className: "recharts-cartesian-gridstripes-horizontal"
    }, items);
}
function VerticalStripes(props) {
    var { vertical = true, verticalFill, fillOpacity, x, y, width, height, verticalPoints } = props;
    if (!vertical || !verticalFill || !verticalFill.length) return null;
    var roundedSortedVerticalPoints = verticalPoints.map((e)=>Math.round(e + x - x)).sort((a, b)=>a - b);
    if (x !== roundedSortedVerticalPoints[0]) roundedSortedVerticalPoints.unshift(0);
    var items = roundedSortedVerticalPoints.map((entry, i)=>{
        var lastStripe = !roundedSortedVerticalPoints[i + 1];
        var lineWidth = lastStripe ? x + width - entry : roundedSortedVerticalPoints[i + 1] - entry;
        if (lineWidth <= 0) return null;
        var colorIndex = i % verticalFill.length;
        return /*#__PURE__*/ _react.createElement("rect", {
            key: "react-".concat(i),
            x: entry,
            y: y,
            width: lineWidth,
            height: height,
            stroke: "none",
            fill: verticalFill[colorIndex],
            fillOpacity: fillOpacity,
            className: "recharts-cartesian-grid-bg"
        });
    });
    return /*#__PURE__*/ _react.createElement("g", {
        className: "recharts-cartesian-gridstripes-vertical"
    }, items);
}
var defaultVerticalCoordinatesGenerator = (_ref3, syncWithTicks)=>{
    var { xAxis, width, height, offset } = _ref3;
    return (0, _chartUtils.getCoordinatesOfGrid)((0, _getTicks.getTicks)(_objectSpread(_objectSpread(_objectSpread({}, (0, _cartesianAxis.defaultCartesianAxisProps)), xAxis), {}, {
        ticks: (0, _chartUtils.getTicksOfAxis)(xAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width,
            height
        }
    })), offset.left, offset.left + offset.width, syncWithTicks);
};
var defaultHorizontalCoordinatesGenerator = (_ref4, syncWithTicks)=>{
    var { yAxis, width, height, offset } = _ref4;
    return (0, _chartUtils.getCoordinatesOfGrid)((0, _getTicks.getTicks)(_objectSpread(_objectSpread(_objectSpread({}, (0, _cartesianAxis.defaultCartesianAxisProps)), yAxis), {}, {
        ticks: (0, _chartUtils.getTicksOfAxis)(yAxis, true),
        viewBox: {
            x: 0,
            y: 0,
            width,
            height
        }
    })), offset.top, offset.top + offset.height, syncWithTicks);
};
var defaultCartesianGridProps = {
    horizontal: true,
    vertical: true,
    // The ordinates of horizontal grid lines
    horizontalPoints: [],
    // The abscissas of vertical grid lines
    verticalPoints: [],
    stroke: '#ccc',
    fill: 'none',
    // The fill of colors of grid lines
    verticalFill: [],
    horizontalFill: [],
    xAxisId: 0,
    yAxisId: 0,
    syncWithTicks: false,
    zIndex: (0, _defaultZIndexes.DefaultZIndexes).grid
};
function CartesianGrid(props) {
    var chartWidth = (0, _chartLayoutContext.useChartWidth)();
    var chartHeight = (0, _chartLayoutContext.useChartHeight)();
    var offset = (0, _chartLayoutContext.useOffsetInternal)();
    var propsIncludingDefaults = _objectSpread(_objectSpread({}, (0, _resolveDefaultProps.resolveDefaultProps)(props, defaultCartesianGridProps)), {}, {
        x: (0, _dataUtils.isNumber)(props.x) ? props.x : offset.left,
        y: (0, _dataUtils.isNumber)(props.y) ? props.y : offset.top,
        width: (0, _dataUtils.isNumber)(props.width) ? props.width : offset.width,
        height: (0, _dataUtils.isNumber)(props.height) ? props.height : offset.height
    });
    var { xAxisId, yAxisId, x, y, width, height, syncWithTicks, horizontalValues, verticalValues } = propsIncludingDefaults;
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    var xAxis = (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectAxisPropsNeededForCartesianGridTicksGenerator)(state, 'xAxis', xAxisId, isPanorama));
    var yAxis = (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectAxisPropsNeededForCartesianGridTicksGenerator)(state, 'yAxis', yAxisId, isPanorama));
    if (!(0, _isWellBehavedNumber.isPositiveNumber)(width) || !(0, _isWellBehavedNumber.isPositiveNumber)(height) || !(0, _dataUtils.isNumber)(x) || !(0, _dataUtils.isNumber)(y)) return null;
    /*
   * verticalCoordinatesGenerator and horizontalCoordinatesGenerator are defined
   * outside the propsIncludingDefaults because they were never part of the original props
   * and they were never passed as a prop down to horizontal/vertical custom elements.
   * If we add these two to propsIncludingDefaults then we are changing public API.
   * Not a bad thing per se but also not necessary.
   */ var verticalCoordinatesGenerator = propsIncludingDefaults.verticalCoordinatesGenerator || defaultVerticalCoordinatesGenerator;
    var horizontalCoordinatesGenerator = propsIncludingDefaults.horizontalCoordinatesGenerator || defaultHorizontalCoordinatesGenerator;
    var { horizontalPoints, verticalPoints } = propsIncludingDefaults;
    // No horizontal points are specified
    if ((!horizontalPoints || !horizontalPoints.length) && typeof horizontalCoordinatesGenerator === 'function') {
        var isHorizontalValues = horizontalValues && horizontalValues.length;
        var generatorResult = horizontalCoordinatesGenerator({
            yAxis: yAxis ? _objectSpread(_objectSpread({}, yAxis), {}, {
                ticks: isHorizontalValues ? horizontalValues : yAxis.ticks
            }) : undefined,
            width: chartWidth !== null && chartWidth !== void 0 ? chartWidth : width,
            height: chartHeight !== null && chartHeight !== void 0 ? chartHeight : height,
            offset
        }, isHorizontalValues ? true : syncWithTicks);
        (0, _logUtils.warn)(Array.isArray(generatorResult), "horizontalCoordinatesGenerator should return Array but instead it returned [".concat(typeof generatorResult, "]"));
        if (Array.isArray(generatorResult)) horizontalPoints = generatorResult;
    }
    // No vertical points are specified
    if ((!verticalPoints || !verticalPoints.length) && typeof verticalCoordinatesGenerator === 'function') {
        var isVerticalValues = verticalValues && verticalValues.length;
        var _generatorResult = verticalCoordinatesGenerator({
            xAxis: xAxis ? _objectSpread(_objectSpread({}, xAxis), {}, {
                ticks: isVerticalValues ? verticalValues : xAxis.ticks
            }) : undefined,
            width: chartWidth !== null && chartWidth !== void 0 ? chartWidth : width,
            height: chartHeight !== null && chartHeight !== void 0 ? chartHeight : height,
            offset
        }, isVerticalValues ? true : syncWithTicks);
        (0, _logUtils.warn)(Array.isArray(_generatorResult), "verticalCoordinatesGenerator should return Array but instead it returned [".concat(typeof _generatorResult, "]"));
        if (Array.isArray(_generatorResult)) verticalPoints = _generatorResult;
    }
    return /*#__PURE__*/ _react.createElement((0, _zindexLayer.ZIndexLayer), {
        zIndex: propsIncludingDefaults.zIndex
    }, /*#__PURE__*/ _react.createElement("g", {
        className: "recharts-cartesian-grid"
    }, /*#__PURE__*/ _react.createElement(Background, {
        fill: propsIncludingDefaults.fill,
        fillOpacity: propsIncludingDefaults.fillOpacity,
        x: propsIncludingDefaults.x,
        y: propsIncludingDefaults.y,
        width: propsIncludingDefaults.width,
        height: propsIncludingDefaults.height,
        ry: propsIncludingDefaults.ry
    }), /*#__PURE__*/ _react.createElement(HorizontalStripes, _extends({}, propsIncludingDefaults, {
        horizontalPoints: horizontalPoints
    })), /*#__PURE__*/ _react.createElement(VerticalStripes, _extends({}, propsIncludingDefaults, {
        verticalPoints: verticalPoints
    })), /*#__PURE__*/ _react.createElement(HorizontalGridLines, _extends({}, propsIncludingDefaults, {
        offset: offset,
        horizontalPoints: horizontalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    })), /*#__PURE__*/ _react.createElement(VerticalGridLines, _extends({}, propsIncludingDefaults, {
        offset: offset,
        verticalPoints: verticalPoints,
        xAxis: xAxis,
        yAxis: yAxis
    }))));
}
CartesianGrid.displayName = 'CartesianGrid';

},{"react":"bmhQu","../util/LogUtils":"dDrLn","../util/DataUtils":"lNZEj","../util/ChartUtils":"enJyE","./getTicks":"lESsH","./CartesianAxis":"d3UBS","../context/chartLayoutContext":"jIUyy","../state/selectors/axisSelectors":"bvR8m","../state/hooks":"aEuxu","../context/PanoramaContext":"10hMm","../util/resolveDefaultProps":"cWUqx","../util/svgPropertiesNoEvents":"2NZlZ","../util/isWellBehavedNumber":"aIsFR","../zIndex/ZIndexLayer":"6RR5t","../zIndex/DefaultZIndexes":"h8nlV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dDrLn":[function(require,module,exports,__globalThis) {
/* eslint no-console: 0 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "warn", ()=>warn);
var isDev = true;
var warn = function warn(condition, format) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    if (isDev && typeof console !== 'undefined' && console.warn) {
        if (format === undefined) console.warn('LogUtils requires an error message argument');
        if (!condition) {
            if (format === undefined) console.warn("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
            else {
                var argIndex = 0;
                console.warn(format.replace(/%s/g, ()=>args[argIndex++]));
            }
        }
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lNZEj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mathSign", ()=>mathSign);
parcelHelpers.export(exports, "isNan", ()=>isNan);
parcelHelpers.export(exports, "isPercent", ()=>isPercent);
parcelHelpers.export(exports, "isNumber", ()=>isNumber);
parcelHelpers.export(exports, "isNumOrStr", ()=>isNumOrStr);
parcelHelpers.export(exports, "uniqueId", ()=>uniqueId);
parcelHelpers.export(exports, "getPercentValue", ()=>getPercentValue);
parcelHelpers.export(exports, "hasDuplicate", ()=>hasDuplicate);
parcelHelpers.export(exports, "interpolate", ()=>interpolate);
parcelHelpers.export(exports, "findEntryInArray", ()=>findEntryInArray);
parcelHelpers.export(exports, "getLinearRegression", ()=>getLinearRegression);
parcelHelpers.export(exports, "isNullish", ()=>isNullish);
parcelHelpers.export(exports, "upperFirst", ()=>upperFirst);
/**
 * Checks if the value is not null nor undefined.
 * @param value The value to check
 * @returns true if the value is not null nor undefined
 */ parcelHelpers.export(exports, "isNotNil", ()=>isNotNil);
/**
 * No-operation function that does nothing.
 * Useful as a placeholder or default callback function.
 */ parcelHelpers.export(exports, "noop", ()=>noop);
var _get = require("es-toolkit/compat/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _round = require("./round");
var mathSign = (value)=>{
    if (value === 0) return 0;
    if (value > 0) return 1;
    return -1;
};
var isNan = (value)=>{
    // eslint-disable-next-line eqeqeq
    return typeof value == 'number' && value != +value;
};
var isPercent = (value)=>typeof value === 'string' && value.indexOf('%') === value.length - 1;
var isNumber = (value)=>(typeof value === 'number' || value instanceof Number) && !isNan(value);
var isNumOrStr = (value)=>isNumber(value) || typeof value === 'string';
var idCounter = 0;
var uniqueId = (prefix)=>{
    var id = ++idCounter;
    return "".concat(prefix || '').concat(id);
};
var getPercentValue = function getPercentValue(percent, totalValue) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var validate = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    if (!isNumber(percent) && typeof percent !== 'string') return defaultValue;
    var value;
    if (isPercent(percent)) {
        if (totalValue == null) return defaultValue;
        var index = percent.indexOf('%');
        value = totalValue * parseFloat(percent.slice(0, index)) / 100;
    } else value = +percent;
    if (isNan(value)) value = defaultValue;
    if (validate && totalValue != null && value > totalValue) value = totalValue;
    return value;
};
var hasDuplicate = (ary)=>{
    if (!Array.isArray(ary)) return false;
    var len = ary.length;
    var cache = {};
    for(var i = 0; i < len; i++){
        if (!cache[String(ary[i])]) cache[String(ary[i])] = true;
        else return true;
    }
    return false;
};
function interpolate(start, end, t) {
    if (isNumber(start) && isNumber(end)) return (0, _round.round)(start + t * (end - start));
    return end;
}
function findEntryInArray(ary, specifiedKey, specifiedValue) {
    if (!ary || !ary.length) return undefined;
    return ary.find((entry)=>entry && (typeof specifiedKey === 'function' ? specifiedKey(entry) : (0, _getDefault.default)(entry, specifiedKey)) === specifiedValue);
}
var getLinearRegression = (data)=>{
    var len = data.length;
    var xsum = 0;
    var ysum = 0;
    var xysum = 0;
    var xxsum = 0;
    var xmin = Infinity;
    var xmax = -Infinity;
    var xcurrent = 0;
    var ycurrent = 0;
    for(var i = 0; i < len; i++){
        var _data$i, _data$i2;
        xcurrent = ((_data$i = data[i]) === null || _data$i === void 0 ? void 0 : _data$i.cx) || 0;
        ycurrent = ((_data$i2 = data[i]) === null || _data$i2 === void 0 ? void 0 : _data$i2.cy) || 0;
        xsum += xcurrent;
        ysum += ycurrent;
        xysum += xcurrent * ycurrent;
        xxsum += xcurrent * xcurrent;
        xmin = Math.min(xmin, xcurrent);
        xmax = Math.max(xmax, xcurrent);
    }
    var a = len * xxsum !== xsum * xsum ? (len * xysum - xsum * ysum) / (len * xxsum - xsum * xsum) : 0;
    return {
        xmin,
        xmax,
        a,
        b: (ysum - a * xsum) / len
    };
};
var isNullish = (value)=>{
    return value === null || typeof value === 'undefined';
};
var upperFirst = (value)=>{
    if (isNullish(value)) return value;
    return "".concat(value.charAt(0).toUpperCase()).concat(value.slice(1));
};
function isNotNil(value) {
    return value != null;
}
function noop() {}

},{"es-toolkit/compat/get":"7LxLv","./round":"aY5HH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7LxLv":[function(require,module,exports,__globalThis) {
module.exports = require("17b7b0b833de5127").get;

},{"17b7b0b833de5127":"gFg89"}],"gFg89":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const isUnsafeProperty = require("ad304f8ea1d5ac37");
const isDeepKey = require("9eb5edfea8bee8fd");
const toKey = require("ea1f0559baa354b7");
const toPath = require("88667a5c3ba99c86");
function get(object, path, defaultValue) {
    if (object == null) return defaultValue;
    switch(typeof path){
        case 'string':
            {
                if (isUnsafeProperty.isUnsafeProperty(path)) return defaultValue;
                const result = object[path];
                if (result === undefined) {
                    if (isDeepKey.isDeepKey(path)) return get(object, toPath.toPath(path), defaultValue);
                    else return defaultValue;
                }
                return result;
            }
        case 'number':
        case 'symbol':
            {
                if (typeof path === 'number') path = toKey.toKey(path);
                const result = object[path];
                if (result === undefined) return defaultValue;
                return result;
            }
        default:
            {
                if (Array.isArray(path)) return getWithPath(object, path, defaultValue);
                if (Object.is(path?.valueOf(), -0)) path = '-0';
                else path = String(path);
                if (isUnsafeProperty.isUnsafeProperty(path)) return defaultValue;
                const result = object[path];
                if (result === undefined) return defaultValue;
                return result;
            }
    }
}
function getWithPath(object, path, defaultValue) {
    if (path.length === 0) return defaultValue;
    let current = object;
    for(let index = 0; index < path.length; index++){
        if (current == null) return defaultValue;
        if (isUnsafeProperty.isUnsafeProperty(path[index])) return defaultValue;
        current = current[path[index]];
    }
    if (current === undefined) return defaultValue;
    return current;
}
exports.get = get;

},{"ad304f8ea1d5ac37":"ejWeH","9eb5edfea8bee8fd":"ggdFX","ea1f0559baa354b7":"bryRk","88667a5c3ba99c86":"f9GmR"}],"ejWeH":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isUnsafeProperty(key) {
    return key === '__proto__';
}
exports.isUnsafeProperty = isUnsafeProperty;

},{}],"ggdFX":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isDeepKey(key) {
    switch(typeof key){
        case 'number':
        case 'symbol':
            return false;
        case 'string':
            return key.includes('.') || key.includes('[') || key.includes(']');
    }
}
exports.isDeepKey = isDeepKey;

},{}],"bryRk":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function toKey(value) {
    if (typeof value === 'string' || typeof value === 'symbol') return value;
    if (Object.is(value?.valueOf?.(), -0)) return '-0';
    return String(value);
}
exports.toKey = toKey;

},{}],"f9GmR":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const toString = require("8d5eaa8a6714e142");
const toKey = require("e9287aff2d710df");
function toPath(deepKey) {
    if (Array.isArray(deepKey)) return deepKey.map(toKey.toKey);
    if (typeof deepKey === 'symbol') return [
        deepKey
    ];
    deepKey = toString.toString(deepKey);
    const result = [];
    const length = deepKey.length;
    if (length === 0) return result;
    let index = 0;
    let key = '';
    let quoteChar = '';
    let bracket = false;
    if (deepKey.charCodeAt(0) === 46) {
        result.push('');
        index++;
    }
    while(index < length){
        const char = deepKey[index];
        if (quoteChar) {
            if (char === '\\' && index + 1 < length) {
                index++;
                key += deepKey[index];
            } else if (char === quoteChar) quoteChar = '';
            else key += char;
        } else if (bracket) {
            if (char === '"' || char === "'") quoteChar = char;
            else if (char === ']') {
                bracket = false;
                result.push(key);
                key = '';
            } else key += char;
        } else {
            if (char === '[') {
                bracket = true;
                if (key) {
                    result.push(key);
                    key = '';
                }
            } else if (char === '.') {
                if (key) {
                    result.push(key);
                    key = '';
                }
            } else key += char;
        }
        index++;
    }
    if (key) result.push(key);
    return result;
}
exports.toPath = toPath;

},{"8d5eaa8a6714e142":"9zGwg","e9287aff2d710df":"bryRk"}],"9zGwg":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function toString(value) {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) return value.map(toString).join(',');
    const result = String(value);
    if (result === '0' && Object.is(Number(value), -0)) return '-0';
    return result;
}
exports.toString = toString;

},{}],"aY5HH":[function(require,module,exports,__globalThis) {
// if you go lower than 3, wild wild things happen during rendering
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "round", ()=>round);
/**
 * This function will accept a string template literal and for each
 * variable placeholder, it will round the value to avoid long float numbers in
 * the SVG path which might cause rendering issues in some browsers.
 */ parcelHelpers.export(exports, "roundTemplateLiteral", ()=>roundTemplateLiteral);
var defaultRoundPrecision = 4;
function round(num) {
    var roundPrecision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultRoundPrecision;
    var factor = 10 ** roundPrecision;
    var rounded = Math.round(num * factor) / factor;
    if (Object.is(rounded, -0)) return 0;
    return rounded;
}
function roundTemplateLiteral(strings) {
    for(var _len = arguments.length, values = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)values[_key - 1] = arguments[_key];
    return strings.reduce((result, string, i)=>{
        var value = values[i - 1];
        if (typeof value === 'string') return result + value + string;
        if (value !== undefined) return result + round(value) + string;
        return result + string;
    }, '');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"enJyE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValueByDataKey", ()=>getValueByDataKey);
parcelHelpers.export(exports, "appendOffsetOfLegend", ()=>appendOffsetOfLegend);
parcelHelpers.export(exports, "isCategoricalAxis", ()=>isCategoricalAxis);
parcelHelpers.export(exports, "getCoordinatesOfGrid", ()=>getCoordinatesOfGrid);
parcelHelpers.export(exports, "getTicksOfAxis", ()=>getTicksOfAxis);
parcelHelpers.export(exports, "checkDomainOfScale", ()=>checkDomainOfScale);
parcelHelpers.export(exports, "truncateByDomain", ()=>truncateByDomain);
parcelHelpers.export(exports, "offsetSign", ()=>offsetSign);
parcelHelpers.export(exports, "offsetPositive", ()=>offsetPositive);
parcelHelpers.export(exports, "getStackedData", ()=>getStackedData);
/**
 * Externally, we accept both strings and numbers as stack IDs
 * @inline
 */ /**
 * Stack IDs in the external props allow numbers; but internally we use it as an object key
 * and object keys are always strings. Also, it would be kinda confusing if stackId=8 and stackId='8' were different stacks
 * so let's just force a string.
 */ parcelHelpers.export(exports, "getNormalizedStackId", ()=>getNormalizedStackId);
parcelHelpers.export(exports, "getCateCoordinateOfLine", ()=>getCateCoordinateOfLine);
parcelHelpers.export(exports, "getCateCoordinateOfBar", ()=>getCateCoordinateOfBar);
parcelHelpers.export(exports, "getBaseValueOfBar", ()=>getBaseValueOfBar);
parcelHelpers.export(exports, "getDomainOfStackGroups", ()=>getDomainOfStackGroups);
parcelHelpers.export(exports, "MIN_VALUE_REG", ()=>MIN_VALUE_REG);
parcelHelpers.export(exports, "MAX_VALUE_REG", ()=>MAX_VALUE_REG);
parcelHelpers.export(exports, "getBandSizeOfAxis", ()=>getBandSizeOfAxis);
parcelHelpers.export(exports, "getTooltipEntry", ()=>getTooltipEntry);
parcelHelpers.export(exports, "getTooltipNameProp", ()=>getTooltipNameProp);
parcelHelpers.export(exports, "calculateCartesianTooltipPos", ()=>calculateCartesianTooltipPos);
parcelHelpers.export(exports, "calculatePolarTooltipPos", ()=>calculatePolarTooltipPos);
var _sortBy = require("es-toolkit/compat/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _get = require("es-toolkit/compat/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _d3Shape = require("victory-vendor/d3-shape");
var _dataUtils = require("./DataUtils");
var _getSliced = require("./getSliced");
var _isWellBehavedNumber = require("./isWellBehavedNumber");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function getValueByDataKey(obj, dataKey, defaultValue) {
    if ((0, _dataUtils.isNullish)(obj) || (0, _dataUtils.isNullish)(dataKey)) return defaultValue;
    if ((0, _dataUtils.isNumOrStr)(dataKey)) return (0, _getDefault.default)(obj, dataKey, defaultValue);
    if (typeof dataKey === 'function') return dataKey(obj);
    return defaultValue;
}
var appendOffsetOfLegend = (offset, legendSettings, legendSize)=>{
    if (legendSettings && legendSize) {
        var { width: boxWidth, height: boxHeight } = legendSize;
        var { align, verticalAlign, layout } = legendSettings;
        if ((layout === 'vertical' || layout === 'horizontal' && verticalAlign === 'middle') && align !== 'center' && (0, _dataUtils.isNumber)(offset[align])) return _objectSpread(_objectSpread({}, offset), {}, {
            [align]: offset[align] + (boxWidth || 0)
        });
        if ((layout === 'horizontal' || layout === 'vertical' && align === 'center') && verticalAlign !== 'middle' && (0, _dataUtils.isNumber)(offset[verticalAlign])) return _objectSpread(_objectSpread({}, offset), {}, {
            [verticalAlign]: offset[verticalAlign] + (boxHeight || 0)
        });
    }
    return offset;
};
var isCategoricalAxis = (layout, axisType)=>layout === 'horizontal' && axisType === 'xAxis' || layout === 'vertical' && axisType === 'yAxis' || layout === 'centric' && axisType === 'angleAxis' || layout === 'radial' && axisType === 'radiusAxis';
var getCoordinatesOfGrid = (ticks, minValue, maxValue, syncWithTicks)=>{
    if (syncWithTicks) return ticks.map((entry)=>entry.coordinate);
    var hasMin, hasMax;
    var values = ticks.map((entry)=>{
        if (entry.coordinate === minValue) hasMin = true;
        if (entry.coordinate === maxValue) hasMax = true;
        return entry.coordinate;
    });
    if (!hasMin) values.push(minValue);
    if (!hasMax) values.push(maxValue);
    return values;
};
var getTicksOfAxis = (axis, isGrid, isAll)=>{
    if (!axis) return null;
    var { duplicateDomain, type, range, scale, realScaleType, isCategorical, categoricalDomain, tickCount, ticks, niceTicks, axisType } = axis;
    if (!scale) return null;
    var offsetForBand = realScaleType === 'scaleBand' && scale.bandwidth ? scale.bandwidth() / 2 : 2;
    var offset = (isGrid || isAll) && type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && range && range.length >= 2 ? (0, _dataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    if (isGrid && (ticks || niceTicks)) {
        var result = (ticks || niceTicks || []).map((entry, index)=>{
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset,
                index
            };
        });
        return result.filter((row)=>!(0, _dataUtils.isNan)(row.coordinate));
    }
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            index,
            offset
        }));
    if (scale.ticks && !isAll && tickCount != null) return scale.ticks(tickCount).map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            offset,
            index
        }));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index,
            offset
        }));
};
var EPS = 1e-4;
var checkDomainOfScale = (scale)=>{
    var domain = scale.domain();
    if (!domain || domain.length <= 2) return;
    var len = domain.length;
    var range = scale.range();
    var minValue = Math.min(range[0], range[1]) - EPS;
    var maxValue = Math.max(range[0], range[1]) + EPS;
    var first = scale(domain[0]);
    var last = scale(domain[len - 1]);
    if (first < minValue || first > maxValue || last < minValue || last > maxValue) scale.domain([
        domain[0],
        domain[len - 1]
    ]);
};
var truncateByDomain = (value, domain)=>{
    if (!domain || domain.length !== 2 || !(0, _dataUtils.isNumber)(domain[0]) || !(0, _dataUtils.isNumber)(domain[1])) return value;
    var minValue = Math.min(domain[0], domain[1]);
    var maxValue = Math.max(domain[0], domain[1]);
    var result = [
        value[0],
        value[1]
    ];
    if (!(0, _dataUtils.isNumber)(value[0]) || value[0] < minValue) result[0] = minValue;
    if (!(0, _dataUtils.isNumber)(value[1]) || value[1] > maxValue) result[1] = maxValue;
    if (result[0] > maxValue) result[0] = maxValue;
    if (result[1] < minValue) result[1] = minValue;
    return result;
};
var offsetSign = (series)=>{
    var _series$;
    var n = series.length;
    if (n <= 0) return;
    var m = (_series$ = series[0]) === null || _series$ === void 0 ? void 0 : _series$.length;
    if (m == null || m <= 0) return;
    for(var j = 0; j < m; ++j){
        var positive = 0;
        var negative = 0;
        for(var i = 0; i < n; ++i){
            var row = series[i];
            var col = row === null || row === void 0 ? void 0 : row[j];
            if (col == null) continue;
            var series1 = col[1];
            var series0 = col[0];
            var value = (0, _dataUtils.isNan)(series1) ? series0 : series1;
            if (value >= 0) {
                col[0] = positive;
                col[1] = positive + value;
                positive = series1;
            } else {
                col[0] = negative;
                col[1] = negative + value;
                negative = series1;
            }
        }
    }
};
var offsetPositive = (series)=>{
    var _series$2;
    var n = series.length;
    if (n <= 0) return;
    var m = (_series$2 = series[0]) === null || _series$2 === void 0 ? void 0 : _series$2.length;
    if (m == null || m <= 0) return;
    for(var j = 0; j < m; ++j){
        var positive = 0;
        for(var i = 0; i < n; ++i){
            var row = series[i];
            var col = row === null || row === void 0 ? void 0 : row[j];
            if (col == null) continue;
            var value = (0, _dataUtils.isNan)(col[1]) ? col[0] : col[1];
            if (value >= 0) {
                col[0] = positive;
                col[1] = positive + value;
                // eslint-disable-next-line prefer-destructuring
                positive = col[1];
            } else {
                col[0] = 0;
                col[1] = 0;
            }
        }
    }
};
/**
 * Function type to compute offset for stacked data.
 *
 * d3-shape has something fishy going on with its types.
 * In @definitelytyped/d3-shape, this function (the offset accessor) is typed as Series<> => void.
 * However! When I actually open the storybook I can see that the offset accessor actually receives Array<Series<>>.
 * The same I can see in the source code itself:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 * That one unfortunately has no types but we can tell it passes three-dimensional array.
 *
 * Which leads me to believe that definitelytyped is wrong on this one.
 * There's open discussion on this topic without much attention:
 * https://github.com/DefinitelyTyped/DefinitelyTyped/discussions/66042
 */ var STACK_OFFSET_MAP = {
    sign: offsetSign,
    // @ts-expect-error definitelytyped types are incorrect
    expand: (0, _d3Shape.stackOffsetExpand),
    // @ts-expect-error definitelytyped types are incorrect
    none: (0, _d3Shape.stackOffsetNone),
    // @ts-expect-error definitelytyped types are incorrect
    silhouette: (0, _d3Shape.stackOffsetSilhouette),
    // @ts-expect-error definitelytyped types are incorrect
    wiggle: (0, _d3Shape.stackOffsetWiggle),
    positive: offsetPositive
};
var getStackedData = (data, dataKeys, offsetType)=>{
    var _STACK_OFFSET_MAP$off;
    var offsetAccessor = (_STACK_OFFSET_MAP$off = STACK_OFFSET_MAP[offsetType]) !== null && _STACK_OFFSET_MAP$off !== void 0 ? _STACK_OFFSET_MAP$off : (0, _d3Shape.stackOffsetNone);
    var stack = (0, _d3Shape.stack)().keys(dataKeys).value((d, key)=>Number(getValueByDataKey(d, key, 0))).order((0, _d3Shape.stackOrderNone))// @ts-expect-error definitelytyped types are incorrect
    .offset(offsetAccessor);
    var result = stack(data);
    // Post-process ranged data: if value is an array of two numbers, use them directly without stacking
    result.forEach((series, seriesIndex)=>{
        series.forEach((point, pointIndex)=>{
            var value = getValueByDataKey(data[pointIndex], dataKeys[seriesIndex], 0);
            if (Array.isArray(value) && value.length === 2 && (0, _dataUtils.isNumber)(value[0]) && (0, _dataUtils.isNumber)(value[1])) {
                // eslint-disable-next-line prefer-destructuring,no-param-reassign
                point[0] = value[0];
                // eslint-disable-next-line prefer-destructuring,no-param-reassign
                point[1] = value[1];
            }
        });
    });
    return result;
};
function getNormalizedStackId(publicStackId) {
    return publicStackId == null ? undefined : String(publicStackId);
}
function getCateCoordinateOfLine(_ref) {
    var { axis, ticks, bandSize, entry, index, dataKey } = _ref;
    if (axis.type === 'category') {
        // find coordinate of category axis by the value of category
        // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
        if (!axis.allowDuplicatedCategory && axis.dataKey && !(0, _dataUtils.isNullish)(entry[axis.dataKey])) {
            // @ts-expect-error why does this use direct object access instead of getValueByDataKey?
            var matchedTick = (0, _dataUtils.findEntryInArray)(ticks, 'value', entry[axis.dataKey]);
            if (matchedTick) return matchedTick.coordinate + bandSize / 2;
        }
        return ticks[index] ? ticks[index].coordinate + bandSize / 2 : null;
    }
    var value = getValueByDataKey(entry, !(0, _dataUtils.isNullish)(dataKey) ? dataKey : axis.dataKey);
    // @ts-expect-error getValueByDataKey does not validate the output type
    return !(0, _dataUtils.isNullish)(value) ? axis.scale(value) : null;
}
var getCateCoordinateOfBar = (_ref2)=>{
    var { axis, ticks, offset, bandSize, entry, index } = _ref2;
    if (axis.type === 'category') return ticks[index] ? ticks[index].coordinate + offset : null;
    var value = getValueByDataKey(entry, axis.dataKey, axis.scale.domain()[index]);
    return !(0, _dataUtils.isNullish)(value) ? axis.scale(value) - bandSize / 2 + offset : null;
};
var getBaseValueOfBar = (_ref3)=>{
    var { numericAxis } = _ref3;
    var domain = numericAxis.scale.domain();
    if (numericAxis.type === 'number') {
        // @ts-expect-error type number means the domain has numbers in it but this relationship is not known to typescript
        var minValue = Math.min(domain[0], domain[1]);
        // @ts-expect-error type number means the domain has numbers in it but this relationship is not known to typescript
        var maxValue = Math.max(domain[0], domain[1]);
        if (minValue <= 0 && maxValue >= 0) return 0;
        if (maxValue < 0) return maxValue;
        return minValue;
    }
    return domain[0];
};
var getDomainOfSingle = (data)=>{
    var flat = data.flat(2).filter((0, _dataUtils.isNumber));
    return [
        Math.min(...flat),
        Math.max(...flat)
    ];
};
var makeDomainFinite = (domain)=>{
    return [
        domain[0] === Infinity ? 0 : domain[0],
        domain[1] === -Infinity ? 0 : domain[1]
    ];
};
var getDomainOfStackGroups = (stackGroups, startIndex, endIndex)=>{
    if (stackGroups == null) return undefined;
    return makeDomainFinite(Object.keys(stackGroups).reduce((result, stackId)=>{
        var group = stackGroups[stackId];
        if (!group) return result;
        var { stackedData } = group;
        var domain = stackedData.reduce((res, entry)=>{
            var sliced = (0, _getSliced.getSliced)(entry, startIndex, endIndex);
            var s = getDomainOfSingle(sliced);
            if (!(0, _isWellBehavedNumber.isWellBehavedNumber)(s[0]) || !(0, _isWellBehavedNumber.isWellBehavedNumber)(s[1])) return res;
            return [
                Math.min(res[0], s[0]),
                Math.max(res[1], s[1])
            ];
        }, [
            Infinity,
            -Infinity
        ]);
        return [
            Math.min(domain[0], result[0]),
            Math.max(domain[1], result[1])
        ];
    }, [
        Infinity,
        -Infinity
    ]));
};
var MIN_VALUE_REG = /^dataMin[\s]*-[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var MAX_VALUE_REG = /^dataMax[\s]*\+[\s]*([0-9]+([.]{1}[0-9]+){0,1})$/;
var getBandSizeOfAxis = (axis, ticks, isBar)=>{
    if (axis && axis.scale && axis.scale.bandwidth) {
        var bandWidth = axis.scale.bandwidth();
        if (!isBar || bandWidth > 0) return bandWidth;
    }
    if (axis && ticks && ticks.length >= 2) {
        var orderedTicks = (0, _sortByDefault.default)(ticks, (o)=>o.coordinate);
        var bandSize = Infinity;
        for(var i = 1, len = orderedTicks.length; i < len; i++){
            var cur = orderedTicks[i];
            var prev = orderedTicks[i - 1];
            bandSize = Math.min(((cur === null || cur === void 0 ? void 0 : cur.coordinate) || 0) - ((prev === null || prev === void 0 ? void 0 : prev.coordinate) || 0), bandSize);
        }
        return bandSize === Infinity ? 0 : bandSize;
    }
    return isBar ? undefined : 0;
};
function getTooltipEntry(_ref4) {
    var { tooltipEntrySettings, dataKey, payload, value, name } = _ref4;
    return _objectSpread(_objectSpread({}, tooltipEntrySettings), {}, {
        dataKey,
        payload,
        value,
        name
    });
}
function getTooltipNameProp(nameFromItem, dataKey) {
    if (nameFromItem) return String(nameFromItem);
    if (typeof dataKey === 'string') return dataKey;
    return undefined;
}
var calculateCartesianTooltipPos = (coordinate, layout)=>{
    if (layout === 'horizontal') return coordinate.chartX;
    if (layout === 'vertical') return coordinate.chartY;
    return undefined;
};
var calculatePolarTooltipPos = (rangeObj, layout)=>{
    if (layout === 'centric') return rangeObj.angle;
    return rangeObj.radius;
};

},{"es-toolkit/compat/sortBy":"jVc75","es-toolkit/compat/get":"7LxLv","victory-vendor/d3-shape":"54uEf","./DataUtils":"lNZEj","./getSliced":"85Zws","./isWellBehavedNumber":"aIsFR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jVc75":[function(require,module,exports,__globalThis) {
module.exports = require("678d19d75649a4dc").sortBy;

},{"678d19d75649a4dc":"6bRwy"}],"6bRwy":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const orderBy = require("eb5d95df4950b6a4");
const flatten = require("6771523f9b58116");
const isIterateeCall = require("9d41b3601553cd7f");
function sortBy(collection, ...criteria) {
    const length = criteria.length;
    if (length > 1 && isIterateeCall.isIterateeCall(collection, criteria[0], criteria[1])) criteria = [];
    else if (length > 2 && isIterateeCall.isIterateeCall(criteria[0], criteria[1], criteria[2])) criteria = [
        criteria[0]
    ];
    return orderBy.orderBy(collection, flatten.flatten(criteria), [
        'asc'
    ]);
}
exports.sortBy = sortBy;

},{"eb5d95df4950b6a4":"7SxT2","6771523f9b58116":"lxVzQ","9d41b3601553cd7f":"adz7R"}],"7SxT2":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const compareValues = require("dba08ea049f774ad");
const isKey = require("cc47c38a8bc669e1");
const toPath = require("c18a5a8387787884");
function orderBy(collection, criteria, orders, guard) {
    if (collection == null) return [];
    orders = guard ? undefined : orders;
    if (!Array.isArray(collection)) collection = Object.values(collection);
    if (!Array.isArray(criteria)) criteria = criteria == null ? [
        null
    ] : [
        criteria
    ];
    if (criteria.length === 0) criteria = [
        null
    ];
    if (!Array.isArray(orders)) orders = orders == null ? [] : [
        orders
    ];
    orders = orders.map((order)=>String(order));
    const getValueByNestedPath = (object, path)=>{
        let target = object;
        for(let i = 0; i < path.length && target != null; ++i)target = target[path[i]];
        return target;
    };
    const getValueByCriterion = (criterion, object)=>{
        if (object == null || criterion == null) return object;
        if (typeof criterion === 'object' && 'key' in criterion) {
            if (Object.hasOwn(object, criterion.key)) return object[criterion.key];
            return getValueByNestedPath(object, criterion.path);
        }
        if (typeof criterion === 'function') return criterion(object);
        if (Array.isArray(criterion)) return getValueByNestedPath(object, criterion);
        if (typeof object === 'object') return object[criterion];
        return object;
    };
    const preparedCriteria = criteria.map((criterion)=>{
        if (Array.isArray(criterion) && criterion.length === 1) criterion = criterion[0];
        if (criterion == null || typeof criterion === 'function' || Array.isArray(criterion) || isKey.isKey(criterion)) return criterion;
        return {
            key: criterion,
            path: toPath.toPath(criterion)
        };
    });
    const preparedCollection = collection.map((item)=>({
            original: item,
            criteria: preparedCriteria.map((criterion)=>getValueByCriterion(criterion, item))
        }));
    return preparedCollection.slice().sort((a, b)=>{
        for(let i = 0; i < preparedCriteria.length; i++){
            const comparedResult = compareValues.compareValues(a.criteria[i], b.criteria[i], orders[i]);
            if (comparedResult !== 0) return comparedResult;
        }
        return 0;
    }).map((item)=>item.original);
}
exports.orderBy = orderBy;

},{"dba08ea049f774ad":"ju0k5","cc47c38a8bc669e1":"6QYsj","c18a5a8387787884":"f9GmR"}],"ju0k5":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function getPriority(a) {
    if (typeof a === 'symbol') return 1;
    if (a === null) return 2;
    if (a === undefined) return 3;
    if (a !== a) return 4;
    return 0;
}
const compareValues = (a, b, order)=>{
    if (a !== b) {
        const aPriority = getPriority(a);
        const bPriority = getPriority(b);
        if (aPriority === bPriority && aPriority === 0) {
            if (a < b) return order === 'desc' ? 1 : -1;
            if (a > b) return order === 'desc' ? -1 : 1;
        }
        return order === 'desc' ? bPriority - aPriority : aPriority - bPriority;
    }
    return 0;
};
exports.compareValues = compareValues;

},{}],"6QYsj":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const isSymbol = require("7043b0ab9d10f7f0");
const regexIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/;
const regexIsPlainProp = /^\w*$/;
function isKey(value, object) {
    if (Array.isArray(value)) return false;
    if (typeof value === 'number' || typeof value === 'boolean' || value == null || isSymbol.isSymbol(value)) return true;
    return typeof value === 'string' && (regexIsPlainProp.test(value) || !regexIsDeepProp.test(value)) || object != null && Object.hasOwn(object, value);
}
exports.isKey = isKey;

},{"7043b0ab9d10f7f0":"9YY2A"}],"9YY2A":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isSymbol(value) {
    return typeof value === 'symbol' || value instanceof Symbol;
}
exports.isSymbol = isSymbol;

},{}],"lxVzQ":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function flatten(arr, depth = 1) {
    const result = [];
    const flooredDepth = Math.floor(depth);
    const recursive = (arr, currentDepth)=>{
        for(let i = 0; i < arr.length; i++){
            const item = arr[i];
            if (Array.isArray(item) && currentDepth < flooredDepth) recursive(item, currentDepth + 1);
            else result.push(item);
        }
    };
    recursive(arr, 0);
    return result;
}
exports.flatten = flatten;

},{}],"adz7R":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const isIndex = require("f35e283ba3ce080f");
const isArrayLike = require("d2138db427eab27f");
const isObject = require("4cedf7bc6e18aeff");
const eq = require("d9094a8c661e4584");
function isIterateeCall(value, index, object) {
    if (!isObject.isObject(object)) return false;
    if (typeof index === 'number' && isArrayLike.isArrayLike(object) && isIndex.isIndex(index) && index < object.length || typeof index === 'string' && index in object) return eq.eq(object[index], value);
    return false;
}
exports.isIterateeCall = isIterateeCall;

},{"f35e283ba3ce080f":"gvFyj","d2138db427eab27f":"8WsUw","4cedf7bc6e18aeff":"z9lTG","d9094a8c661e4584":"kUpbN"}],"gvFyj":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const IS_UNSIGNED_INTEGER = /^(?:0|[1-9]\d*)$/;
function isIndex(value, length = Number.MAX_SAFE_INTEGER) {
    switch(typeof value){
        case 'number':
            return Number.isInteger(value) && value >= 0 && value < length;
        case 'symbol':
            return false;
        case 'string':
            return IS_UNSIGNED_INTEGER.test(value);
    }
}
exports.isIndex = isIndex;

},{}],"8WsUw":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const isLength = require("57ae9017e1d12b22");
function isArrayLike(value) {
    return value != null && typeof value !== 'function' && isLength.isLength(value.length);
}
exports.isArrayLike = isArrayLike;

},{"57ae9017e1d12b22":"bLdme"}],"bLdme":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isLength(value) {
    return Number.isSafeInteger(value) && value >= 0;
}
exports.isLength = isLength;

},{}],"z9lTG":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isObject(value) {
    return value !== null && (typeof value === 'object' || typeof value === 'function');
}
exports.isObject = isObject;

},{}],"kUpbN":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function eq(value, other) {
    return value === other || Number.isNaN(value) && Number.isNaN(other);
}
exports.eq = eq;

},{}],"54uEf":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("19271802296fa753");

},{"19271802296fa753":"igYcw"}],"igYcw":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-shape` (CommonJS)
// See upstream license: https://github.com/d3/d3-shape/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-shape`
module.exports = require("176bd3ee52fdecae");

},{"176bd3ee52fdecae":"4SqkE"}],"4SqkE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "arc", {
    enumerable: true,
    get: function() {
        return _arc.default;
    }
});
Object.defineProperty(exports, "area", {
    enumerable: true,
    get: function() {
        return _area.default;
    }
});
Object.defineProperty(exports, "areaRadial", {
    enumerable: true,
    get: function() {
        return _areaRadial.default;
    }
});
Object.defineProperty(exports, "curveBasis", {
    enumerable: true,
    get: function() {
        return _basis.default;
    }
});
Object.defineProperty(exports, "curveBasisClosed", {
    enumerable: true,
    get: function() {
        return _basisClosed.default;
    }
});
Object.defineProperty(exports, "curveBasisOpen", {
    enumerable: true,
    get: function() {
        return _basisOpen.default;
    }
});
Object.defineProperty(exports, "curveBumpX", {
    enumerable: true,
    get: function() {
        return _bump.bumpX;
    }
});
Object.defineProperty(exports, "curveBumpY", {
    enumerable: true,
    get: function() {
        return _bump.bumpY;
    }
});
Object.defineProperty(exports, "curveBundle", {
    enumerable: true,
    get: function() {
        return _bundle.default;
    }
});
Object.defineProperty(exports, "curveCardinal", {
    enumerable: true,
    get: function() {
        return _cardinal.default;
    }
});
Object.defineProperty(exports, "curveCardinalClosed", {
    enumerable: true,
    get: function() {
        return _cardinalClosed.default;
    }
});
Object.defineProperty(exports, "curveCardinalOpen", {
    enumerable: true,
    get: function() {
        return _cardinalOpen.default;
    }
});
Object.defineProperty(exports, "curveCatmullRom", {
    enumerable: true,
    get: function() {
        return _catmullRom.default;
    }
});
Object.defineProperty(exports, "curveCatmullRomClosed", {
    enumerable: true,
    get: function() {
        return _catmullRomClosed.default;
    }
});
Object.defineProperty(exports, "curveCatmullRomOpen", {
    enumerable: true,
    get: function() {
        return _catmullRomOpen.default;
    }
});
Object.defineProperty(exports, "curveLinear", {
    enumerable: true,
    get: function() {
        return _linear.default;
    }
});
Object.defineProperty(exports, "curveLinearClosed", {
    enumerable: true,
    get: function() {
        return _linearClosed.default;
    }
});
Object.defineProperty(exports, "curveMonotoneX", {
    enumerable: true,
    get: function() {
        return _monotone.monotoneX;
    }
});
Object.defineProperty(exports, "curveMonotoneY", {
    enumerable: true,
    get: function() {
        return _monotone.monotoneY;
    }
});
Object.defineProperty(exports, "curveNatural", {
    enumerable: true,
    get: function() {
        return _natural.default;
    }
});
Object.defineProperty(exports, "curveStep", {
    enumerable: true,
    get: function() {
        return _step.default;
    }
});
Object.defineProperty(exports, "curveStepAfter", {
    enumerable: true,
    get: function() {
        return _step.stepAfter;
    }
});
Object.defineProperty(exports, "curveStepBefore", {
    enumerable: true,
    get: function() {
        return _step.stepBefore;
    }
});
Object.defineProperty(exports, "line", {
    enumerable: true,
    get: function() {
        return _line.default;
    }
});
Object.defineProperty(exports, "lineRadial", {
    enumerable: true,
    get: function() {
        return _lineRadial.default;
    }
});
Object.defineProperty(exports, "link", {
    enumerable: true,
    get: function() {
        return _link.link;
    }
});
Object.defineProperty(exports, "linkHorizontal", {
    enumerable: true,
    get: function() {
        return _link.linkHorizontal;
    }
});
Object.defineProperty(exports, "linkRadial", {
    enumerable: true,
    get: function() {
        return _link.linkRadial;
    }
});
Object.defineProperty(exports, "linkVertical", {
    enumerable: true,
    get: function() {
        return _link.linkVertical;
    }
});
Object.defineProperty(exports, "pie", {
    enumerable: true,
    get: function() {
        return _pie.default;
    }
});
Object.defineProperty(exports, "pointRadial", {
    enumerable: true,
    get: function() {
        return _pointRadial.default;
    }
});
Object.defineProperty(exports, "radialArea", {
    enumerable: true,
    get: function() {
        return _areaRadial.default;
    }
});
Object.defineProperty(exports, "radialLine", {
    enumerable: true,
    get: function() {
        return _lineRadial.default;
    }
});
Object.defineProperty(exports, "stack", {
    enumerable: true,
    get: function() {
        return _stack.default;
    }
});
Object.defineProperty(exports, "stackOffsetDiverging", {
    enumerable: true,
    get: function() {
        return _diverging.default;
    }
});
Object.defineProperty(exports, "stackOffsetExpand", {
    enumerable: true,
    get: function() {
        return _expand.default;
    }
});
Object.defineProperty(exports, "stackOffsetNone", {
    enumerable: true,
    get: function() {
        return _none.default;
    }
});
Object.defineProperty(exports, "stackOffsetSilhouette", {
    enumerable: true,
    get: function() {
        return _silhouette.default;
    }
});
Object.defineProperty(exports, "stackOffsetWiggle", {
    enumerable: true,
    get: function() {
        return _wiggle.default;
    }
});
Object.defineProperty(exports, "stackOrderAppearance", {
    enumerable: true,
    get: function() {
        return _appearance.default;
    }
});
Object.defineProperty(exports, "stackOrderAscending", {
    enumerable: true,
    get: function() {
        return _ascending.default;
    }
});
Object.defineProperty(exports, "stackOrderDescending", {
    enumerable: true,
    get: function() {
        return _descending.default;
    }
});
Object.defineProperty(exports, "stackOrderInsideOut", {
    enumerable: true,
    get: function() {
        return _insideOut.default;
    }
});
Object.defineProperty(exports, "stackOrderNone", {
    enumerable: true,
    get: function() {
        return _none2.default;
    }
});
Object.defineProperty(exports, "stackOrderReverse", {
    enumerable: true,
    get: function() {
        return _reverse.default;
    }
});
Object.defineProperty(exports, "symbol", {
    enumerable: true,
    get: function() {
        return _symbol.default;
    }
});
Object.defineProperty(exports, "symbolAsterisk", {
    enumerable: true,
    get: function() {
        return _asterisk.default;
    }
});
Object.defineProperty(exports, "symbolCircle", {
    enumerable: true,
    get: function() {
        return _circle.default;
    }
});
Object.defineProperty(exports, "symbolCross", {
    enumerable: true,
    get: function() {
        return _cross.default;
    }
});
Object.defineProperty(exports, "symbolDiamond", {
    enumerable: true,
    get: function() {
        return _diamond.default;
    }
});
Object.defineProperty(exports, "symbolDiamond2", {
    enumerable: true,
    get: function() {
        return _diamond2.default;
    }
});
Object.defineProperty(exports, "symbolPlus", {
    enumerable: true,
    get: function() {
        return _plus.default;
    }
});
Object.defineProperty(exports, "symbolSquare", {
    enumerable: true,
    get: function() {
        return _square.default;
    }
});
Object.defineProperty(exports, "symbolSquare2", {
    enumerable: true,
    get: function() {
        return _square2.default;
    }
});
Object.defineProperty(exports, "symbolStar", {
    enumerable: true,
    get: function() {
        return _star.default;
    }
});
Object.defineProperty(exports, "symbolTriangle", {
    enumerable: true,
    get: function() {
        return _triangle.default;
    }
});
Object.defineProperty(exports, "symbolTriangle2", {
    enumerable: true,
    get: function() {
        return _triangle2.default;
    }
});
Object.defineProperty(exports, "symbolWye", {
    enumerable: true,
    get: function() {
        return _wye.default;
    }
});
Object.defineProperty(exports, "symbolX", {
    enumerable: true,
    get: function() {
        return _x.default;
    }
});
Object.defineProperty(exports, "symbols", {
    enumerable: true,
    get: function() {
        return _symbol.symbolsFill;
    }
});
Object.defineProperty(exports, "symbolsFill", {
    enumerable: true,
    get: function() {
        return _symbol.symbolsFill;
    }
});
Object.defineProperty(exports, "symbolsStroke", {
    enumerable: true,
    get: function() {
        return _symbol.symbolsStroke;
    }
});
var _arc = _interopRequireDefault(require("2d3f5974235d4d97"));
var _area = _interopRequireDefault(require("e7d6d9d0e4901d2e"));
var _line = _interopRequireDefault(require("bce35bc16739dbe5"));
var _pie = _interopRequireDefault(require("74b9b0848a30f56d"));
var _areaRadial = _interopRequireDefault(require("795a4987e33fc84"));
var _lineRadial = _interopRequireDefault(require("b1ce66d1195c070b"));
var _pointRadial = _interopRequireDefault(require("18b93f5355310e1c"));
var _link = require("661c14c96c31c97d");
var _symbol = _interopRequireWildcard(require("974cd54b219b5407"));
var _asterisk = _interopRequireDefault(require("3237a04f4f14fca5"));
var _circle = _interopRequireDefault(require("d06ad8106b0de21c"));
var _cross = _interopRequireDefault(require("871a2983fe1eb51f"));
var _diamond = _interopRequireDefault(require("d1ef85359a4dd212"));
var _diamond2 = _interopRequireDefault(require("3dea65984f117ec1"));
var _plus = _interopRequireDefault(require("1565ec3cf1a7613a"));
var _square = _interopRequireDefault(require("9285c34ad7b613e4"));
var _square2 = _interopRequireDefault(require("c6e9c9d35fa5b5cb"));
var _star = _interopRequireDefault(require("815abfb8fc8798e0"));
var _triangle = _interopRequireDefault(require("431e53334965b545"));
var _triangle2 = _interopRequireDefault(require("64d0ff16b783fd6c"));
var _wye = _interopRequireDefault(require("6bcb4260ac11e7b8"));
var _x = _interopRequireDefault(require("f8ed4fd677a8b4d9"));
var _basisClosed = _interopRequireDefault(require("91e47160fd76a75d"));
var _basisOpen = _interopRequireDefault(require("3cfac39a85530a37"));
var _basis = _interopRequireDefault(require("f697ba81082957cf"));
var _bump = require("2bea78dcacfdca47");
var _bundle = _interopRequireDefault(require("e82aff58f59c7695"));
var _cardinalClosed = _interopRequireDefault(require("c72e75e517eac392"));
var _cardinalOpen = _interopRequireDefault(require("9217e81617e05b4"));
var _cardinal = _interopRequireDefault(require("1dd79a3764c6f2bf"));
var _catmullRomClosed = _interopRequireDefault(require("aee7da70ecf7456b"));
var _catmullRomOpen = _interopRequireDefault(require("6d5f31fa960dcbe2"));
var _catmullRom = _interopRequireDefault(require("3a4d3052f18b3d40"));
var _linearClosed = _interopRequireDefault(require("46142d6a54d00966"));
var _linear = _interopRequireDefault(require("e55fce1282a99ed7"));
var _monotone = require("fad9762fa89b7933");
var _natural = _interopRequireDefault(require("188623ab79fe5f6b"));
var _step = _interopRequireWildcard(require("48bb2877ede27508"));
var _stack = _interopRequireDefault(require("39fd6af83767c8b0"));
var _expand = _interopRequireDefault(require("17e05ad95922030d"));
var _diverging = _interopRequireDefault(require("a216beddff4c3a08"));
var _none = _interopRequireDefault(require("b09a2130bd13b1e0"));
var _silhouette = _interopRequireDefault(require("70400e7acef40477"));
var _wiggle = _interopRequireDefault(require("b9b44fd8f75e0415"));
var _appearance = _interopRequireDefault(require("fd3023466e7ac9e7"));
var _ascending = _interopRequireDefault(require("46c02ef8fc93b026"));
var _descending = _interopRequireDefault(require("a5a0ae33dd14b3b0"));
var _insideOut = _interopRequireDefault(require("43469f5cea84b12e"));
var _none2 = _interopRequireDefault(require("68f36eef1efe200b"));
var _reverse = _interopRequireDefault(require("a5f086840207a549"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"2d3f5974235d4d97":"7mqPt","e7d6d9d0e4901d2e":"k2zfj","bce35bc16739dbe5":"grc7V","74b9b0848a30f56d":"kZ7cJ","795a4987e33fc84":"2nDeM","b1ce66d1195c070b":"4vVgk","18b93f5355310e1c":"gslqy","661c14c96c31c97d":"dLpNs","974cd54b219b5407":"bJpQ8","3237a04f4f14fca5":"2QTzP","d06ad8106b0de21c":"gjU1C","871a2983fe1eb51f":"kCrcc","d1ef85359a4dd212":"lax6Y","3dea65984f117ec1":"kpjvt","1565ec3cf1a7613a":"aYa9i","9285c34ad7b613e4":"4srPs","c6e9c9d35fa5b5cb":"4CPqd","815abfb8fc8798e0":"bbdpu","431e53334965b545":"bohKH","64d0ff16b783fd6c":"eG2Be","6bcb4260ac11e7b8":"hgYEx","f8ed4fd677a8b4d9":"4qr51","91e47160fd76a75d":"eLnZH","3cfac39a85530a37":"5FhA9","f697ba81082957cf":"bTxSV","2bea78dcacfdca47":"5nt2K","e82aff58f59c7695":"y8zgg","c72e75e517eac392":"ibTlH","9217e81617e05b4":"l2NZd","1dd79a3764c6f2bf":"4qEFz","aee7da70ecf7456b":"fX22y","6d5f31fa960dcbe2":"aW0Tn","3a4d3052f18b3d40":"kAFBh","46142d6a54d00966":"kZEre","e55fce1282a99ed7":"fWPnB","fad9762fa89b7933":"hQOhx","188623ab79fe5f6b":"hJlvH","48bb2877ede27508":"AEhKq","39fd6af83767c8b0":"gpRwX","17e05ad95922030d":"2pw9l","a216beddff4c3a08":"8qoTI","b09a2130bd13b1e0":"aEqzB","70400e7acef40477":"66Qa4","b9b44fd8f75e0415":"gOpUa","fd3023466e7ac9e7":"i34NF","46c02ef8fc93b026":"kJWkm","a5a0ae33dd14b3b0":"bXNtY","43469f5cea84b12e":"cPTLO","68f36eef1efe200b":"dyxZK","a5f086840207a549":"7jhD4"}],"7mqPt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("9b71135f97bb0843");
var _constant = _interopRequireDefault(require("b66d56b93af4da33"));
var _math = require("53b6f54f25927f26");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function arcInnerRadius(d) {
    return d.innerRadius;
}
function arcOuterRadius(d) {
    return d.outerRadius;
}
function arcStartAngle(d) {
    return d.startAngle;
}
function arcEndAngle(d) {
    return d.endAngle;
}
function arcPadAngle(d) {
    return d && d.padAngle; // Note: optional!
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
    var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
    if (t * t < _math.epsilon) return;
    t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
    return [
        x0 + t * x10,
        y0 + t * y10
    ];
}
// Compute perpendicular offset line of length rc.
// http://mathworld.wolfram.com/Circle-LineIntersection.html
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
    var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / (0, _math.sqrt)(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * (0, _math.sqrt)((0, _math.max)(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
    // Pick the closer of the two intersection points.
    // TODO Is there a faster way to determine which intersection to use?
    if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
    return {
        cx: cx0,
        cy: cy0,
        x01: -ox,
        y01: -oy,
        x11: cx0 * (r1 / r - 1),
        y11: cy0 * (r1 / r - 1)
    };
}
function _default() {
    var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = (0, _constant.default)(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null;
    function arc() {
        var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - _math.halfPi, a1 = endAngle.apply(this, arguments) - _math.halfPi, da = (0, _math.abs)(a1 - a0), cw = a1 > a0;
        if (!context) context = buffer = (0, _index.path)();
        // Ensure that the outer radius is always larger than the inner radius.
        if (r1 < r0) r = r1, r1 = r0, r0 = r;
        // Is it a point?
        if (!(r1 > _math.epsilon)) context.moveTo(0, 0);
        else if (da > _math.tau - _math.epsilon) {
            context.moveTo(r1 * (0, _math.cos)(a0), r1 * (0, _math.sin)(a0));
            context.arc(0, 0, r1, a0, a1, !cw);
            if (r0 > _math.epsilon) {
                context.moveTo(r0 * (0, _math.cos)(a1), r0 * (0, _math.sin)(a1));
                context.arc(0, 0, r0, a1, a0, cw);
            }
        } else {
            var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > _math.epsilon && (padRadius ? +padRadius.apply(this, arguments) : (0, _math.sqrt)(r0 * r0 + r1 * r1)), rc = (0, _math.min)((0, _math.abs)(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
            // Apply padding? Note that since r1 ≥ r0, da1 ≥ da0.
            if (rp > _math.epsilon) {
                var p0 = (0, _math.asin)(rp / r0 * (0, _math.sin)(ap)), p1 = (0, _math.asin)(rp / r1 * (0, _math.sin)(ap));
                if ((da0 -= p0 * 2) > _math.epsilon) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
                else da0 = 0, a00 = a10 = (a0 + a1) / 2;
                if ((da1 -= p1 * 2) > _math.epsilon) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
                else da1 = 0, a01 = a11 = (a0 + a1) / 2;
            }
            var x01 = r1 * (0, _math.cos)(a01), y01 = r1 * (0, _math.sin)(a01), x10 = r0 * (0, _math.cos)(a10), y10 = r0 * (0, _math.sin)(a10);
            // Apply rounded corners?
            if (rc > _math.epsilon) {
                var x11 = r1 * (0, _math.cos)(a11), y11 = r1 * (0, _math.sin)(a11), x00 = r0 * (0, _math.cos)(a00), y00 = r0 * (0, _math.sin)(a00), oc;
                // Restrict the corner radius according to the sector angle.
                if (da < _math.pi && (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10))) {
                    var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / (0, _math.sin)((0, _math.acos)((ax * bx + ay * by) / ((0, _math.sqrt)(ax * ax + ay * ay) * (0, _math.sqrt)(bx * bx + by * by))) / 2), lc = (0, _math.sqrt)(oc[0] * oc[0] + oc[1] * oc[1]);
                    rc0 = (0, _math.min)(rc, (r0 - lc) / (kc - 1));
                    rc1 = (0, _math.min)(rc, (r1 - lc) / (kc + 1));
                }
            }
            // Is the sector collapsed to a line?
            if (!(da1 > _math.epsilon)) context.moveTo(x01, y01);
            else if (rc1 > _math.epsilon) {
                t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
                t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
                context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc1 < rc) context.arc(t0.cx, t0.cy, rc1, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc1, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r1, (0, _math.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
                    context.arc(t1.cx, t1.cy, rc1, (0, _math.atan2)(t1.y11, t1.x11), (0, _math.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
            // Is there no inner ring, and it’s a circular sector?
            // Or perhaps it’s an annular sector collapsed due to padding?
            if (!(r0 > _math.epsilon) || !(da0 > _math.epsilon)) context.lineTo(x10, y10);
            else if (rc0 > _math.epsilon) {
                t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
                t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
                context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
                // Have the corners merged?
                if (rc0 < rc) context.arc(t0.cx, t0.cy, rc0, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t1.y01, t1.x01), !cw);
                else {
                    context.arc(t0.cx, t0.cy, rc0, (0, _math.atan2)(t0.y01, t0.x01), (0, _math.atan2)(t0.y11, t0.x11), !cw);
                    context.arc(0, 0, r0, (0, _math.atan2)(t0.cy + t0.y11, t0.cx + t0.x11), (0, _math.atan2)(t1.cy + t1.y11, t1.cx + t1.x11), cw);
                    context.arc(t1.cx, t1.cy, rc0, (0, _math.atan2)(t1.y11, t1.x11), (0, _math.atan2)(t1.y01, t1.x01), !cw);
                }
            } else context.arc(0, 0, r0, a10, a00, cw);
        }
        context.closePath();
        if (buffer) return context = null, buffer + "" || null;
    }
    arc.centroid = function() {
        var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - _math.pi / 2;
        return [
            (0, _math.cos)(a) * r,
            (0, _math.sin)(a) * r
        ];
    };
    arc.innerRadius = function(_) {
        return arguments.length ? (innerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : innerRadius;
    };
    arc.outerRadius = function(_) {
        return arguments.length ? (outerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : outerRadius;
    };
    arc.cornerRadius = function(_) {
        return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : cornerRadius;
    };
    arc.padRadius = function(_) {
        return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : padRadius;
    };
    arc.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : startAngle;
    };
    arc.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : endAngle;
    };
    arc.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), arc) : padAngle;
    };
    arc.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, arc) : context;
    };
    return arc;
}

},{"9b71135f97bb0843":"5o72z","b66d56b93af4da33":"iNw3T","53b6f54f25927f26":"l2Koo"}],"5o72z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "path", {
    enumerable: true,
    get: function() {
        return _path.default;
    }
});
var _path = _interopRequireDefault(require("3b0cf72f61f38e1e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"3b0cf72f61f38e1e":"9s49y"}],"9s49y":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
const pi = Math.PI, tau = 2 * pi, epsilon = 1e-6, tauEpsilon = tau - epsilon;
function Path() {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null; // end of current subpath
    this._ = "";
}
function path() {
    return new Path();
}
Path.prototype = path.prototype = {
    constructor: Path,
    moveTo: function(x, y) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y);
    },
    closePath: function() {
        if (this._x1 !== null) {
            this._x1 = this._x0, this._y1 = this._y0;
            this._ += "Z";
        }
    },
    lineTo: function(x, y) {
        this._ += "L" + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    quadraticCurveTo: function(x1, y1, x, y) {
        this._ += "Q" + +x1 + "," + +y1 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._ += "C" + +x1 + "," + +y1 + "," + +x2 + "," + +y2 + "," + (this._x1 = +x) + "," + (this._y1 = +y);
    },
    arcTo: function(x1, y1, x2, y2, r) {
        x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
        var x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x1,y1).
        if (this._x1 === null) this._ += "M" + (this._x1 = x1) + "," + (this._y1 = y1);
        else if (!(l01_2 > epsilon)) ;
        else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon) || !r) this._ += "L" + (this._x1 = x1) + "," + (this._y1 = y1);
        else {
            var x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
            // If the start tangent is not coincident with (x0,y0), line to.
            if (Math.abs(t01 - 1) > epsilon) this._ += "L" + (x1 + t01 * x01) + "," + (y1 + t01 * y01);
            this._ += "A" + r + "," + r + ",0,0," + +(y01 * x20 > x01 * y20) + "," + (this._x1 = x1 + t21 * x21) + "," + (this._y1 = y1 + t21 * y21);
        }
    },
    arc: function(x, y, r, a0, a1, ccw) {
        x = +x, y = +y, r = +r, ccw = !!ccw;
        var dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x + dx, y0 = y + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
        // Is the radius negative? Error.
        if (r < 0) throw new Error("negative radius: " + r);
        // Is this path empty? Move to (x0,y0).
        if (this._x1 === null) this._ += "M" + x0 + "," + y0;
        else if (Math.abs(this._x1 - x0) > epsilon || Math.abs(this._y1 - y0) > epsilon) this._ += "L" + x0 + "," + y0;
        // Is this arc empty? We’re done.
        if (!r) return;
        // Does the angle go the wrong way? Flip the direction.
        if (da < 0) da = da % tau + tau;
        // Is this a complete circle? Draw two arcs to complete the circle.
        if (da > tauEpsilon) this._ += "A" + r + "," + r + ",0,1," + cw + "," + (x - dx) + "," + (y - dy) + "A" + r + "," + r + ",0,1," + cw + "," + (this._x1 = x0) + "," + (this._y1 = y0);
        else if (da > epsilon) this._ += "A" + r + "," + r + ",0," + +(da >= pi) + "," + cw + "," + (this._x1 = x + r * Math.cos(a1)) + "," + (this._y1 = y + r * Math.sin(a1));
    },
    rect: function(x, y, w, h) {
        this._ += "M" + (this._x0 = this._x1 = +x) + "," + (this._y0 = this._y1 = +y) + "h" + +w + "v" + +h + "h" + -w + "Z";
    },
    toString: function() {
        return this._;
    }
};
var _default = exports.default = path;

},{}],"iNw3T":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x) {
    return function constant() {
        return x;
    };
}

},{}],"l2Koo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.abs = void 0;
exports.acos = acos;
exports.asin = asin;
exports.tau = exports.sqrt = exports.sin = exports.pi = exports.min = exports.max = exports.halfPi = exports.epsilon = exports.cos = exports.atan2 = void 0;
const abs = exports.abs = Math.abs;
const atan2 = exports.atan2 = Math.atan2;
const cos = exports.cos = Math.cos;
const max = exports.max = Math.max;
const min = exports.min = Math.min;
const sin = exports.sin = Math.sin;
const sqrt = exports.sqrt = Math.sqrt;
const epsilon = exports.epsilon = 1e-12;
const pi = exports.pi = Math.PI;
const halfPi = exports.halfPi = pi / 2;
const tau = exports.tau = 2 * pi;
function acos(x) {
    return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
}
function asin(x) {
    return x >= 1 ? halfPi : x <= -1 ? -halfPi : Math.asin(x);
}

},{}],"k2zfj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("500493761fddc3b8");
var _array = _interopRequireDefault(require("bbf8fdbd92f1ebcd"));
var _constant = _interopRequireDefault(require("a5b783eee5be8fa0"));
var _linear = _interopRequireDefault(require("f4129b2496ff7a8b"));
var _line = _interopRequireDefault(require("b3caf3b68a2e9f58"));
var _point = require("ea923553657b0095");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(x0, y0, y1) {
    var x1 = null, defined = (0, _constant.default)(true), context = null, curve = _linear.default, output = null;
    x0 = typeof x0 === "function" ? x0 : x0 === undefined ? _point.x : (0, _constant.default)(+x0);
    y0 = typeof y0 === "function" ? y0 : y0 === undefined ? (0, _constant.default)(0) : (0, _constant.default)(+y0);
    y1 = typeof y1 === "function" ? y1 : y1 === undefined ? _point.y : (0, _constant.default)(+y1);
    function area(data) {
        var i, j, k, n = (data = (0, _array.default)(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
        if (context == null) output = curve(buffer = (0, _index.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) {
                    j = i;
                    output.areaStart();
                    output.lineStart();
                } else {
                    output.lineEnd();
                    output.lineStart();
                    for(k = i - 1; k >= j; --k)output.point(x0z[k], y0z[k]);
                    output.lineEnd();
                    output.areaEnd();
                }
            }
            if (defined0) {
                x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
                output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
            }
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    function arealine() {
        return (0, _line.default)().defined(defined).curve(curve).context(context);
    }
    area.x = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), x1 = null, area) : x0;
    };
    area.x0 = function(_) {
        return arguments.length ? (x0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : x0;
    };
    area.x1 = function(_) {
        return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : x1;
    };
    area.y = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), y1 = null, area) : y0;
    };
    area.y0 = function(_) {
        return arguments.length ? (y0 = typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : y0;
    };
    area.y1 = function(_) {
        return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : (0, _constant.default)(+_), area) : y1;
    };
    area.lineX0 = area.lineY0 = function() {
        return arealine().x(x0).y(y0);
    };
    area.lineY1 = function() {
        return arealine().x(x0).y(y1);
    };
    area.lineX1 = function() {
        return arealine().x(x1).y(y0);
    };
    area.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant.default)(!!_), area) : defined;
    };
    area.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
    };
    area.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
    };
    return area;
}

},{"500493761fddc3b8":"5o72z","bbf8fdbd92f1ebcd":"b5jT0","a5b783eee5be8fa0":"iNw3T","f4129b2496ff7a8b":"fWPnB","b3caf3b68a2e9f58":"grc7V","ea923553657b0095":"hE6Qt"}],"b5jT0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.slice = void 0;
var slice = exports.slice = Array.prototype.slice;
function _default(x) {
    return typeof x === "object" && "length" in x ? x // Array, TypedArray, NodeList, array-like
     : Array.from(x); // Map, Set, iterable, string, or anything else
}

},{}],"fWPnB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function Linear(context) {
    this._context = context;
}
Linear.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                this._context.lineTo(x, y);
                break;
        }
    }
};
function _default(context) {
    return new Linear(context);
}

},{}],"grc7V":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("98710a8cd2690312");
var _array = _interopRequireDefault(require("71eeea1751dcd149"));
var _constant = _interopRequireDefault(require("9083cb1503140862"));
var _linear = _interopRequireDefault(require("c81bc5ab811126a3"));
var _point = require("552145ba71b64707");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(x, y) {
    var defined = (0, _constant.default)(true), context = null, curve = _linear.default, output = null;
    x = typeof x === "function" ? x : x === undefined ? _point.x : (0, _constant.default)(x);
    y = typeof y === "function" ? y : y === undefined ? _point.y : (0, _constant.default)(y);
    function line(data) {
        var i, n = (data = (0, _array.default)(data)).length, d, defined0 = false, buffer;
        if (context == null) output = curve(buffer = (0, _index.path)());
        for(i = 0; i <= n; ++i){
            if (!(i < n && defined(d = data[i], i, data)) === defined0) {
                if (defined0 = !defined0) output.lineStart();
                else output.lineEnd();
            }
            if (defined0) output.point(+x(d, i, data), +y(d, i, data));
        }
        if (buffer) return output = null, buffer + "" || null;
    }
    line.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant.default)(+_), line) : x;
    };
    line.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant.default)(+_), line) : y;
    };
    line.defined = function(_) {
        return arguments.length ? (defined = typeof _ === "function" ? _ : (0, _constant.default)(!!_), line) : defined;
    };
    line.curve = function(_) {
        return arguments.length ? (curve = _, context != null && (output = curve(context)), line) : curve;
    };
    line.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line) : context;
    };
    return line;
}

},{"98710a8cd2690312":"5o72z","71eeea1751dcd149":"b5jT0","9083cb1503140862":"iNw3T","c81bc5ab811126a3":"fWPnB","552145ba71b64707":"hE6Qt"}],"hE6Qt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.x = x;
exports.y = y;
function x(p) {
    return p[0];
}
function y(p) {
    return p[1];
}

},{}],"kZ7cJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _array = _interopRequireDefault(require("b67e0ae37b57d123"));
var _constant = _interopRequireDefault(require("37710d2df9ce0c7a"));
var _descending = _interopRequireDefault(require("a28172d9eab0febf"));
var _identity = _interopRequireDefault(require("e5c1f58030d4bf4f"));
var _math = require("496c2d9cd8d2f75c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default() {
    var value = _identity.default, sortValues = _descending.default, sort = null, startAngle = (0, _constant.default)(0), endAngle = (0, _constant.default)(_math.tau), padAngle = (0, _constant.default)(0);
    function pie(data) {
        var i, n = (data = (0, _array.default)(data)).length, j, k, sum = 0, index = new Array(n), arcs = new Array(n), a0 = +startAngle.apply(this, arguments), da = Math.min(_math.tau, Math.max(-_math.tau, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da) / n, padAngle.apply(this, arguments)), pa = p * (da < 0 ? -1 : 1), v;
        for(i = 0; i < n; ++i)if ((v = arcs[index[i] = i] = +value(data[i], i, data)) > 0) sum += v;
        // Optionally sort the arcs by previously-computed values or by data.
        if (sortValues != null) index.sort(function(i, j) {
            return sortValues(arcs[i], arcs[j]);
        });
        else if (sort != null) index.sort(function(i, j) {
            return sort(data[i], data[j]);
        });
        // Compute the arcs! They are stored in the original data's order.
        for(i = 0, k = sum ? (da - n * pa) / sum : 0; i < n; ++i, a0 = a1)j = index[i], v = arcs[j], a1 = a0 + (v > 0 ? v * k : 0) + pa, arcs[j] = {
            data: data[j],
            index: i,
            value: v,
            startAngle: a0,
            endAngle: a1,
            padAngle: p
        };
        return arcs;
    }
    pie.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : value;
    };
    pie.sortValues = function(_) {
        return arguments.length ? (sortValues = _, sort = null, pie) : sortValues;
    };
    pie.sort = function(_) {
        return arguments.length ? (sort = _, sortValues = null, pie) : sort;
    };
    pie.startAngle = function(_) {
        return arguments.length ? (startAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : startAngle;
    };
    pie.endAngle = function(_) {
        return arguments.length ? (endAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : endAngle;
    };
    pie.padAngle = function(_) {
        return arguments.length ? (padAngle = typeof _ === "function" ? _ : (0, _constant.default)(+_), pie) : padAngle;
    };
    return pie;
}

},{"b67e0ae37b57d123":"b5jT0","37710d2df9ce0c7a":"iNw3T","a28172d9eab0febf":"libzo","e5c1f58030d4bf4f":"5bxYk","496c2d9cd8d2f75c":"l2Koo"}],"libzo":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{}],"5bxYk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(d) {
    return d;
}

},{}],"2nDeM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _radial = _interopRequireWildcard(require("d5f2199be7e4428"));
var _area = _interopRequireDefault(require("9fd6b69a882b62b9"));
var _lineRadial = require("4727a97bf0f56e5e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function _default() {
    var a = (0, _area.default)().curve(_radial.curveRadialLinear), c = a.curve, x0 = a.lineX0, x1 = a.lineX1, y0 = a.lineY0, y1 = a.lineY1;
    a.angle = a.x, delete a.x;
    a.startAngle = a.x0, delete a.x0;
    a.endAngle = a.x1, delete a.x1;
    a.radius = a.y, delete a.y;
    a.innerRadius = a.y0, delete a.y0;
    a.outerRadius = a.y1, delete a.y1;
    a.lineStartAngle = function() {
        return (0, _lineRadial.lineRadial)(x0());
    }, delete a.lineX0;
    a.lineEndAngle = function() {
        return (0, _lineRadial.lineRadial)(x1());
    }, delete a.lineX1;
    a.lineInnerRadius = function() {
        return (0, _lineRadial.lineRadial)(y0());
    }, delete a.lineY0;
    a.lineOuterRadius = function() {
        return (0, _lineRadial.lineRadial)(y1());
    }, delete a.lineY1;
    a.curve = function(_) {
        return arguments.length ? c((0, _radial.default)(_)) : c()._curve;
    };
    return a;
}

},{"d5f2199be7e4428":"haFli","9fd6b69a882b62b9":"k2zfj","4727a97bf0f56e5e":"4vVgk"}],"haFli":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.curveRadialLinear = void 0;
exports.default = curveRadial;
var _linear = _interopRequireDefault(require("fcbc4ed98c33ce63"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var curveRadialLinear = exports.curveRadialLinear = curveRadial(_linear.default);
function Radial(curve) {
    this._curve = curve;
}
Radial.prototype = {
    areaStart: function() {
        this._curve.areaStart();
    },
    areaEnd: function() {
        this._curve.areaEnd();
    },
    lineStart: function() {
        this._curve.lineStart();
    },
    lineEnd: function() {
        this._curve.lineEnd();
    },
    point: function(a, r) {
        this._curve.point(r * Math.sin(a), r * -Math.cos(a));
    }
};
function curveRadial(curve) {
    function radial(context) {
        return new Radial(curve(context));
    }
    radial._curve = curve;
    return radial;
}

},{"fcbc4ed98c33ce63":"fWPnB"}],"4vVgk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.lineRadial = lineRadial;
var _radial = _interopRequireWildcard(require("467073d1fc4d6144"));
var _line = _interopRequireDefault(require("b165a0178810938"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function lineRadial(l) {
    var c = l.curve;
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    l.curve = function(_) {
        return arguments.length ? c((0, _radial.default)(_)) : c()._curve;
    };
    return l;
}
function _default() {
    return lineRadial((0, _line.default)().curve(_radial.curveRadialLinear));
}

},{"467073d1fc4d6144":"haFli","b165a0178810938":"grc7V"}],"gslqy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x, y) {
    return [
        (y = +y) * Math.cos(x -= Math.PI / 2),
        y * Math.sin(x)
    ];
}

},{}],"dLpNs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.link = link;
exports.linkHorizontal = linkHorizontal;
exports.linkRadial = linkRadial;
exports.linkVertical = linkVertical;
var _index = require("ae6bae8009c48266");
var _array = require("3bac10be5f465a96");
var _constant = _interopRequireDefault(require("35364e9c346d01b7"));
var _bump = require("ce2d1a2cbddf3802");
var _point = require("be0eb0a3ebd67c05");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function linkSource(d) {
    return d.source;
}
function linkTarget(d) {
    return d.target;
}
function link(curve) {
    let source = linkSource;
    let target = linkTarget;
    let x = _point.x;
    let y = _point.y;
    let context = null;
    let output = null;
    function link() {
        let buffer;
        const argv = _array.slice.call(arguments);
        const s = source.apply(this, argv);
        const t = target.apply(this, argv);
        if (context == null) output = curve(buffer = (0, _index.path)());
        output.lineStart();
        argv[0] = s, output.point(+x.apply(this, argv), +y.apply(this, argv));
        argv[0] = t, output.point(+x.apply(this, argv), +y.apply(this, argv));
        output.lineEnd();
        if (buffer) return output = null, buffer + "" || null;
    }
    link.source = function(_) {
        return arguments.length ? (source = _, link) : source;
    };
    link.target = function(_) {
        return arguments.length ? (target = _, link) : target;
    };
    link.x = function(_) {
        return arguments.length ? (x = typeof _ === "function" ? _ : (0, _constant.default)(+_), link) : x;
    };
    link.y = function(_) {
        return arguments.length ? (y = typeof _ === "function" ? _ : (0, _constant.default)(+_), link) : y;
    };
    link.context = function(_) {
        return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), link) : context;
    };
    return link;
}
function linkHorizontal() {
    return link(_bump.bumpX);
}
function linkVertical() {
    return link(_bump.bumpY);
}
function linkRadial() {
    const l = link(_bump.bumpRadial);
    l.angle = l.x, delete l.x;
    l.radius = l.y, delete l.y;
    return l;
}

},{"ae6bae8009c48266":"5o72z","3bac10be5f465a96":"b5jT0","35364e9c346d01b7":"iNw3T","ce2d1a2cbddf3802":"5nt2K","be0eb0a3ebd67c05":"hE6Qt"}],"5nt2K":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bumpRadial = bumpRadial;
exports.bumpX = bumpX;
exports.bumpY = bumpY;
var _pointRadial = _interopRequireDefault(require("b619d14f2ed97e73"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class Bump {
    constructor(context, x){
        this._context = context;
        this._x = x;
    }
    areaStart() {
        this._line = 0;
    }
    areaEnd() {
        this._line = NaN;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    }
    point(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                if (this._line) this._context.lineTo(x, y);
                else this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._x) this._context.bezierCurveTo(this._x0 = (this._x0 + x) / 2, this._y0, this._x0, y, x, y);
                else this._context.bezierCurveTo(this._x0, this._y0 = (this._y0 + y) / 2, x, this._y0, x, y);
                break;
        }
        this._x0 = x, this._y0 = y;
    }
}
class BumpRadial {
    constructor(context){
        this._context = context;
    }
    lineStart() {
        this._point = 0;
    }
    lineEnd() {}
    point(x, y) {
        x = +x, y = +y;
        if (this._point++ === 0) this._x0 = x, this._y0 = y;
        else {
            const p0 = (0, _pointRadial.default)(this._x0, this._y0);
            const p1 = (0, _pointRadial.default)(this._x0, this._y0 = (this._y0 + y) / 2);
            const p2 = (0, _pointRadial.default)(x, this._y0);
            const p3 = (0, _pointRadial.default)(x, y);
            this._context.moveTo(...p0);
            this._context.bezierCurveTo(...p1, ...p2, ...p3);
        }
    }
}
function bumpX(context) {
    return new Bump(context, true);
}
function bumpY(context) {
    return new Bump(context, false);
}
function bumpRadial(context) {
    return new BumpRadial(context);
}

},{"b619d14f2ed97e73":"gslqy"}],"bJpQ8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Symbol;
exports.symbolsStroke = exports.symbolsFill = void 0;
var _index = require("ed221954c3cadd8c");
var _constant = _interopRequireDefault(require("a318f579ae289bb4"));
var _asterisk = _interopRequireDefault(require("4f836b828c4aee2"));
var _circle = _interopRequireDefault(require("a3d59dddf62412f7"));
var _cross = _interopRequireDefault(require("b51ad47cf070e0d4"));
var _diamond = _interopRequireDefault(require("a8375ed091b8d08a"));
var _diamond2 = _interopRequireDefault(require("7c0f9eaf6c7614f0"));
var _plus = _interopRequireDefault(require("459ff396a52f1e2d"));
var _square = _interopRequireDefault(require("174dac6271fe5f76"));
var _square2 = _interopRequireDefault(require("444710f2180a0669"));
var _star = _interopRequireDefault(require("1f31f8ec57f98fa6"));
var _triangle = _interopRequireDefault(require("f4d77aaf9ffb5dbd"));
var _triangle2 = _interopRequireDefault(require("80c17c4ac5160020"));
var _wye = _interopRequireDefault(require("2da15e99e0fdb804"));
var _x = _interopRequireDefault(require("67fc72d8d3ef7cbf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
// These symbols are designed to be filled.
const symbolsFill = exports.symbolsFill = [
    _circle.default,
    _cross.default,
    _diamond.default,
    _square.default,
    _star.default,
    _triangle.default,
    _wye.default
];
// These symbols are designed to be stroked (with a width of 1.5px and round caps).
const symbolsStroke = exports.symbolsStroke = [
    _circle.default,
    _plus.default,
    _x.default,
    _triangle2.default,
    _asterisk.default,
    _square2.default,
    _diamond2.default
];
function Symbol(type, size) {
    let context = null;
    type = typeof type === "function" ? type : (0, _constant.default)(type || _circle.default);
    size = typeof size === "function" ? size : (0, _constant.default)(size === undefined ? 64 : +size);
    function symbol() {
        let buffer;
        if (!context) context = buffer = (0, _index.path)();
        type.apply(this, arguments).draw(context, +size.apply(this, arguments));
        if (buffer) return context = null, buffer + "" || null;
    }
    symbol.type = function(_) {
        return arguments.length ? (type = typeof _ === "function" ? _ : (0, _constant.default)(_), symbol) : type;
    };
    symbol.size = function(_) {
        return arguments.length ? (size = typeof _ === "function" ? _ : (0, _constant.default)(+_), symbol) : size;
    };
    symbol.context = function(_) {
        return arguments.length ? (context = _ == null ? null : _, symbol) : context;
    };
    return symbol;
}

},{"ed221954c3cadd8c":"5o72z","a318f579ae289bb4":"iNw3T","4f836b828c4aee2":"2QTzP","a3d59dddf62412f7":"gjU1C","b51ad47cf070e0d4":"kCrcc","a8375ed091b8d08a":"lax6Y","7c0f9eaf6c7614f0":"kpjvt","459ff396a52f1e2d":"aYa9i","174dac6271fe5f76":"4srPs","444710f2180a0669":"4CPqd","1f31f8ec57f98fa6":"bbdpu","f4d77aaf9ffb5dbd":"bohKH","80c17c4ac5160020":"eG2Be","2da15e99e0fdb804":"hgYEx","67fc72d8d3ef7cbf":"4qr51"}],"2QTzP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("48d3e9f7df1a172c");
const sqrt3 = (0, _math.sqrt)(3);
var _default = exports.default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size + (0, _math.min)(size / 28, 0.75)) * 0.59436;
        const t = r / 2;
        const u = t * sqrt3;
        context.moveTo(0, r);
        context.lineTo(0, -r);
        context.moveTo(-u, -t);
        context.lineTo(u, t);
        context.moveTo(-u, t);
        context.lineTo(u, -t);
    }
};

},{"48d3e9f7df1a172c":"l2Koo"}],"gjU1C":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("8ed2e3009b93c9bf");
var _default = exports.default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size / _math.pi);
        context.moveTo(r, 0);
        context.arc(0, 0, r, 0, _math.tau);
    }
};

},{"8ed2e3009b93c9bf":"l2Koo"}],"kCrcc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("69815bae4b0787ae");
var _default = exports.default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size / 5) / 2;
        context.moveTo(-3 * r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, -3 * r);
        context.lineTo(r, -3 * r);
        context.lineTo(r, -r);
        context.lineTo(3 * r, -r);
        context.lineTo(3 * r, r);
        context.lineTo(r, r);
        context.lineTo(r, 3 * r);
        context.lineTo(-r, 3 * r);
        context.lineTo(-r, r);
        context.lineTo(-3 * r, r);
        context.closePath();
    }
};

},{"69815bae4b0787ae":"l2Koo"}],"lax6Y":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("856b74e87be6d6a0");
const tan30 = (0, _math.sqrt)(1 / 3);
const tan30_2 = tan30 * 2;
var _default = exports.default = {
    draw (context, size) {
        const y = (0, _math.sqrt)(size / tan30_2);
        const x = y * tan30;
        context.moveTo(0, -y);
        context.lineTo(x, 0);
        context.lineTo(0, y);
        context.lineTo(-x, 0);
        context.closePath();
    }
};

},{"856b74e87be6d6a0":"l2Koo"}],"kpjvt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("c8441956b7ca25b0");
var _default = exports.default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size) * 0.62625;
        context.moveTo(0, -r);
        context.lineTo(r, 0);
        context.lineTo(0, r);
        context.lineTo(-r, 0);
        context.closePath();
    }
};

},{"c8441956b7ca25b0":"l2Koo"}],"aYa9i":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("a4abcfa52e8b0f37");
var _default = exports.default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size - (0, _math.min)(size / 7, 2)) * 0.87559;
        context.moveTo(-r, 0);
        context.lineTo(r, 0);
        context.moveTo(0, r);
        context.lineTo(0, -r);
    }
};

},{"a4abcfa52e8b0f37":"l2Koo"}],"4srPs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("e72da19a42674d7c");
var _default = exports.default = {
    draw (context, size) {
        const w = (0, _math.sqrt)(size);
        const x = -w / 2;
        context.rect(x, x, w, w);
    }
};

},{"e72da19a42674d7c":"l2Koo"}],"4CPqd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("1c9d5bda227640bf");
var _default = exports.default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size) * 0.4431;
        context.moveTo(r, r);
        context.lineTo(r, -r);
        context.lineTo(-r, -r);
        context.lineTo(-r, r);
        context.closePath();
    }
};

},{"1c9d5bda227640bf":"l2Koo"}],"bbdpu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("751667ddf3bfbdc1");
const ka = 0.89081309152928522810;
const kr = (0, _math.sin)(_math.pi / 10) / (0, _math.sin)(7 * _math.pi / 10);
const kx = (0, _math.sin)(_math.tau / 10) * kr;
const ky = -(0, _math.cos)(_math.tau / 10) * kr;
var _default = exports.default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size * ka);
        const x = kx * r;
        const y = ky * r;
        context.moveTo(0, -r);
        context.lineTo(x, y);
        for(let i = 1; i < 5; ++i){
            const a = _math.tau * i / 5;
            const c = (0, _math.cos)(a);
            const s = (0, _math.sin)(a);
            context.lineTo(s * r, -c * r);
            context.lineTo(c * x - s * y, s * x + c * y);
        }
        context.closePath();
    }
};

},{"751667ddf3bfbdc1":"l2Koo"}],"bohKH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("7bc957b4c8d38817");
const sqrt3 = (0, _math.sqrt)(3);
var _default = exports.default = {
    draw (context, size) {
        const y = -(0, _math.sqrt)(size / (sqrt3 * 3));
        context.moveTo(0, y * 2);
        context.lineTo(-sqrt3 * y, -y);
        context.lineTo(sqrt3 * y, -y);
        context.closePath();
    }
};

},{"7bc957b4c8d38817":"l2Koo"}],"eG2Be":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("7e4bb208ad9cf3ec");
const sqrt3 = (0, _math.sqrt)(3);
var _default = exports.default = {
    draw (context, size) {
        const s = (0, _math.sqrt)(size) * 0.6824;
        const t = s / 2;
        const u = s * sqrt3 / 2; // cos(Math.PI / 6)
        context.moveTo(0, -s);
        context.lineTo(u, t);
        context.lineTo(-u, t);
        context.closePath();
    }
};

},{"7e4bb208ad9cf3ec":"l2Koo"}],"hgYEx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("812e1ff9b9a68f0d");
const c = -0.5;
const s = (0, _math.sqrt)(3) / 2;
const k = 1 / (0, _math.sqrt)(12);
const a = (k / 2 + 1) * 3;
var _default = exports.default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size / a);
        const x0 = r / 2, y0 = r * k;
        const x1 = x0, y1 = r * k + r;
        const x2 = -x1, y2 = y1;
        context.moveTo(x0, y0);
        context.lineTo(x1, y1);
        context.lineTo(x2, y2);
        context.lineTo(c * x0 - s * y0, s * x0 + c * y0);
        context.lineTo(c * x1 - s * y1, s * x1 + c * y1);
        context.lineTo(c * x2 - s * y2, s * x2 + c * y2);
        context.lineTo(c * x0 + s * y0, c * y0 - s * x0);
        context.lineTo(c * x1 + s * y1, c * y1 - s * x1);
        context.lineTo(c * x2 + s * y2, c * y2 - s * x2);
        context.closePath();
    }
};

},{"812e1ff9b9a68f0d":"l2Koo"}],"4qr51":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _math = require("6e8e98e197afefc3");
var _default = exports.default = {
    draw (context, size) {
        const r = (0, _math.sqrt)(size - (0, _math.min)(size / 6, 1.7)) * 0.6189;
        context.moveTo(-r, -r);
        context.lineTo(r, r);
        context.moveTo(-r, r);
        context.lineTo(r, -r);
    }
};

},{"6e8e98e197afefc3":"l2Koo"}],"eLnZH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _noop = _interopRequireDefault(require("8620520ba80e006a"));
var _basis = require("87413069402f4f60");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function BasisClosed(context) {
    this._context = context;
}
BasisClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x2, this._y2);
                this._context.closePath();
                break;
            case 2:
                this._context.moveTo((this._x2 + 2 * this._x3) / 3, (this._y2 + 2 * this._y3) / 3);
                this._context.lineTo((this._x3 + 2 * this._x2) / 3, (this._y3 + 2 * this._y2) / 3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x2, this._y2);
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x2 = x, this._y2 = y;
                break;
            case 1:
                this._point = 2;
                this._x3 = x, this._y3 = y;
                break;
            case 2:
                this._point = 3;
                this._x4 = x, this._y4 = y;
                this._context.moveTo((this._x0 + 4 * this._x1 + x) / 6, (this._y0 + 4 * this._y1 + y) / 6);
                break;
            default:
                (0, _basis.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new BasisClosed(context);
}

},{"8620520ba80e006a":"7mSdV","87413069402f4f60":"bTxSV"}],"7mSdV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default() {}

},{}],"bTxSV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Basis = Basis;
exports.default = _default;
exports.point = point;
function point(that, x, y) {
    that._context.bezierCurveTo((2 * that._x0 + that._x1) / 3, (2 * that._y0 + that._y1) / 3, (that._x0 + 2 * that._x1) / 3, (that._y0 + 2 * that._y1) / 3, (that._x0 + 4 * that._x1 + x) / 6, (that._y0 + 4 * that._y1 + y) / 6);
}
function Basis(context) {
    this._context = context;
}
Basis.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 3:
                point(this, this._x1, this._y1);
            // falls through
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._context.lineTo((5 * this._x0 + this._x1) / 6, (5 * this._y0 + this._y1) / 6);
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new Basis(context);
}

},{}],"5FhA9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _basis = require("580a0e4914be358e");
function BasisOpen(context) {
    this._context = context;
}
BasisOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                var x0 = (this._x0 + 4 * this._x1 + x) / 6, y0 = (this._y0 + 4 * this._y1 + y) / 6;
                this._line ? this._context.lineTo(x0, y0) : this._context.moveTo(x0, y0);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _basis.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
    }
};
function _default(context) {
    return new BasisOpen(context);
}

},{"580a0e4914be358e":"bTxSV"}],"y8zgg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _basis = require("202e66c93596d8c0");
function Bundle(context, beta) {
    this._basis = new _basis.Basis(context);
    this._beta = beta;
}
Bundle.prototype = {
    lineStart: function() {
        this._x = [];
        this._y = [];
        this._basis.lineStart();
    },
    lineEnd: function() {
        var x = this._x, y = this._y, j = x.length - 1;
        if (j > 0) {
            var x0 = x[0], y0 = y[0], dx = x[j] - x0, dy = y[j] - y0, i = -1, t;
            while(++i <= j){
                t = i / j;
                this._basis.point(this._beta * x[i] + (1 - this._beta) * (x0 + t * dx), this._beta * y[i] + (1 - this._beta) * (y0 + t * dy));
            }
        }
        this._x = this._y = null;
        this._basis.lineEnd();
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
var _default = exports.default = function custom(beta) {
    function bundle(context) {
        return beta === 1 ? new _basis.Basis(context) : new Bundle(context, beta);
    }
    bundle.beta = function(beta) {
        return custom(+beta);
    };
    return bundle;
}(0.85);

},{"202e66c93596d8c0":"bTxSV"}],"ibTlH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardinalClosed = CardinalClosed;
exports.default = void 0;
var _noop = _interopRequireDefault(require("3ac7c5e1248dc9ae"));
var _cardinal = require("cfbcda1bc3207e7e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function CardinalClosed(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _cardinal.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalClosed(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"3ac7c5e1248dc9ae":"7mSdV","cfbcda1bc3207e7e":"4qEFz"}],"4qEFz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Cardinal = Cardinal;
exports.default = void 0;
exports.point = point;
function point(that, x, y) {
    that._context.bezierCurveTo(that._x1 + that._k * (that._x2 - that._x0), that._y1 + that._k * (that._y2 - that._y0), that._x2 + that._k * (that._x1 - x), that._y2 + that._k * (that._y1 - y), that._x2, that._y2);
}
function Cardinal(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
Cardinal.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                point(this, this._x1, this._y1);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                this._x1 = x, this._y1 = y;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = exports.default = function custom(tension) {
    function cardinal(context) {
        return new Cardinal(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{}],"l2NZd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CardinalOpen = CardinalOpen;
exports.default = void 0;
var _cardinal = require("cf4363a3b836d23a");
function CardinalOpen(context, tension) {
    this._context = context;
    this._k = (1 - tension) / 6;
}
CardinalOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _cardinal.point)(this, x, y);
                break;
        }
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = exports.default = function custom(tension) {
    function cardinal(context) {
        return new CardinalOpen(context, tension);
    }
    cardinal.tension = function(tension) {
        return custom(+tension);
    };
    return cardinal;
}(0);

},{"cf4363a3b836d23a":"4qEFz"}],"fX22y":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _cardinalClosed = require("f5ae01d2345d4943");
var _noop = _interopRequireDefault(require("82484b434a1d31db"));
var _catmullRom = require("3bd3d5af820e50ff");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function CatmullRomClosed(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._x3 = this._x4 = this._x5 = this._y0 = this._y1 = this._y2 = this._y3 = this._y4 = this._y5 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 1:
                this._context.moveTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 2:
                this._context.lineTo(this._x3, this._y3);
                this._context.closePath();
                break;
            case 3:
                this.point(this._x3, this._y3);
                this.point(this._x4, this._y4);
                this.point(this._x5, this._y5);
                break;
        }
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._x3 = x, this._y3 = y;
                break;
            case 1:
                this._point = 2;
                this._context.moveTo(this._x4 = x, this._y4 = y);
                break;
            case 2:
                this._point = 3;
                this._x5 = x, this._y5 = y;
                break;
            default:
                (0, _catmullRom.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomClosed(context, alpha) : new _cardinalClosed.CardinalClosed(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"f5ae01d2345d4943":"ibTlH","82484b434a1d31db":"7mSdV","3bd3d5af820e50ff":"kAFBh"}],"kAFBh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.point = point;
var _math = require("d464c344292067de");
var _cardinal = require("2f2af409b067cecd");
function point(that, x, y) {
    var x1 = that._x1, y1 = that._y1, x2 = that._x2, y2 = that._y2;
    if (that._l01_a > _math.epsilon) {
        var a = 2 * that._l01_2a + 3 * that._l01_a * that._l12_a + that._l12_2a, n = 3 * that._l01_a * (that._l01_a + that._l12_a);
        x1 = (x1 * a - that._x0 * that._l12_2a + that._x2 * that._l01_2a) / n;
        y1 = (y1 * a - that._y0 * that._l12_2a + that._y2 * that._l01_2a) / n;
    }
    if (that._l23_a > _math.epsilon) {
        var b = 2 * that._l23_2a + 3 * that._l23_a * that._l12_a + that._l12_2a, m = 3 * that._l23_a * (that._l23_a + that._l12_a);
        x2 = (x2 * b + that._x1 * that._l23_2a - x * that._l12_2a) / m;
        y2 = (y2 * b + that._y1 * that._l23_2a - y * that._l12_2a) / m;
    }
    that._context.bezierCurveTo(x1, y1, x2, y2, that._x2, that._y2);
}
function CatmullRom(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRom.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x2, this._y2);
                break;
            case 3:
                this.point(this._x2, this._y2);
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
            // falls through
            default:
                point(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRom(context, alpha) : new _cardinal.Cardinal(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"d464c344292067de":"l2Koo","2f2af409b067cecd":"4qEFz"}],"aW0Tn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _cardinalOpen = require("97b1c5692429330d");
var _catmullRom = require("9847de9b9e7ea36b");
function CatmullRomOpen(context, alpha) {
    this._context = context;
    this._alpha = alpha;
}
CatmullRomOpen.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._x2 = this._y0 = this._y1 = this._y2 = NaN;
        this._l01_a = this._l12_a = this._l23_a = this._l01_2a = this._l12_2a = this._l23_2a = this._point = 0;
    },
    lineEnd: function() {
        if (this._line || this._line !== 0 && this._point === 3) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) {
            var x23 = this._x2 - x, y23 = this._y2 - y;
            this._l23_a = Math.sqrt(this._l23_2a = Math.pow(x23 * x23 + y23 * y23, this._alpha));
        }
        switch(this._point){
            case 0:
                this._point = 1;
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                this._line ? this._context.lineTo(this._x2, this._y2) : this._context.moveTo(this._x2, this._y2);
                break;
            case 3:
                this._point = 4;
            // falls through
            default:
                (0, _catmullRom.point)(this, x, y);
                break;
        }
        this._l01_a = this._l12_a, this._l12_a = this._l23_a;
        this._l01_2a = this._l12_2a, this._l12_2a = this._l23_2a;
        this._x0 = this._x1, this._x1 = this._x2, this._x2 = x;
        this._y0 = this._y1, this._y1 = this._y2, this._y2 = y;
    }
};
var _default = exports.default = function custom(alpha) {
    function catmullRom(context) {
        return alpha ? new CatmullRomOpen(context, alpha) : new _cardinalOpen.CardinalOpen(context, 0);
    }
    catmullRom.alpha = function(alpha) {
        return custom(+alpha);
    };
    return catmullRom;
}(0.5);

},{"97b1c5692429330d":"l2NZd","9847de9b9e7ea36b":"kAFBh"}],"kZEre":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _noop = _interopRequireDefault(require("bb3255f3276eba36"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function LinearClosed(context) {
    this._context = context;
}
LinearClosed.prototype = {
    areaStart: _noop.default,
    areaEnd: _noop.default,
    lineStart: function() {
        this._point = 0;
    },
    lineEnd: function() {
        if (this._point) this._context.closePath();
    },
    point: function(x, y) {
        x = +x, y = +y;
        if (this._point) this._context.lineTo(x, y);
        else this._point = 1, this._context.moveTo(x, y);
    }
};
function _default(context) {
    return new LinearClosed(context);
}

},{"bb3255f3276eba36":"7mSdV"}],"hQOhx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.monotoneX = monotoneX;
exports.monotoneY = monotoneY;
function sign(x) {
    return x < 0 ? -1 : 1;
}
// Calculate the slopes of the tangents (Hermite-type interpolation) based on
// the following paper: Steffen, M. 1990. A Simple Method for Monotonic
// Interpolation in One Dimension. Astronomy and Astrophysics, Vol. 239, NO.
// NOV(II), P. 443, 1990.
function slope3(that, x2, y2) {
    var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
    return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
// Calculate a one-sided slope.
function slope2(that, t) {
    var h = that._x1 - that._x0;
    return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
// According to https://en.wikipedia.org/wiki/Cubic_Hermite_spline#Representations
// "you can express cubic Hermite interpolation in terms of cubic Bézier curves
// with respect to the four values p0, p0 + m0 / 3, p1 - m1 / 3, p1".
function point(that, t0, t1) {
    var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
    that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}
function MonotoneX(context) {
    this._context = context;
}
MonotoneX.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        switch(this._point){
            case 2:
                this._context.lineTo(this._x1, this._y1);
                break;
            case 3:
                point(this, this._t0, slope2(this, this._t0));
                break;
        }
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        this._line = 1 - this._line;
    },
    point: function(x, y) {
        var t1 = NaN;
        x = +x, y = +y;
        if (x === this._x1 && y === this._y1) return; // Ignore coincident points.
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
                break;
            case 2:
                this._point = 3;
                point(this, slope2(this, t1 = slope3(this, x, y)), t1);
                break;
            default:
                point(this, this._t0, t1 = slope3(this, x, y));
                break;
        }
        this._x0 = this._x1, this._x1 = x;
        this._y0 = this._y1, this._y1 = y;
        this._t0 = t1;
    }
};
function MonotoneY(context) {
    this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x, y) {
    MonotoneX.prototype.point.call(this, y, x);
};
function ReflectContext(context) {
    this._context = context;
}
ReflectContext.prototype = {
    moveTo: function(x, y) {
        this._context.moveTo(y, x);
    },
    closePath: function() {
        this._context.closePath();
    },
    lineTo: function(x, y) {
        this._context.lineTo(y, x);
    },
    bezierCurveTo: function(x1, y1, x2, y2, x, y) {
        this._context.bezierCurveTo(y1, x1, y2, x2, y, x);
    }
};
function monotoneX(context) {
    return new MonotoneX(context);
}
function monotoneY(context) {
    return new MonotoneY(context);
}

},{}],"hJlvH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function Natural(context) {
    this._context = context;
}
Natural.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = [];
        this._y = [];
    },
    lineEnd: function() {
        var x = this._x, y = this._y, n = x.length;
        if (n) {
            this._line ? this._context.lineTo(x[0], y[0]) : this._context.moveTo(x[0], y[0]);
            if (n === 2) this._context.lineTo(x[1], y[1]);
            else {
                var px = controlPoints(x), py = controlPoints(y);
                for(var i0 = 0, i1 = 1; i1 < n; ++i0, ++i1)this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x[i1], y[i1]);
            }
        }
        if (this._line || this._line !== 0 && n === 1) this._context.closePath();
        this._line = 1 - this._line;
        this._x = this._y = null;
    },
    point: function(x, y) {
        this._x.push(+x);
        this._y.push(+y);
    }
};
// See https://www.particleincell.com/2012/bezier-splines/ for derivation.
function controlPoints(x) {
    var i, n = x.length - 1, m, a = new Array(n), b = new Array(n), r = new Array(n);
    a[0] = 0, b[0] = 2, r[0] = x[0] + 2 * x[1];
    for(i = 1; i < n - 1; ++i)a[i] = 1, b[i] = 4, r[i] = 4 * x[i] + 2 * x[i + 1];
    a[n - 1] = 2, b[n - 1] = 7, r[n - 1] = 8 * x[n - 1] + x[n];
    for(i = 1; i < n; ++i)m = a[i] / b[i - 1], b[i] -= m, r[i] -= m * r[i - 1];
    a[n - 1] = r[n - 1] / b[n - 1];
    for(i = n - 2; i >= 0; --i)a[i] = (r[i] - a[i + 1]) / b[i];
    b[n - 1] = (x[n] + a[n - 1]) / 2;
    for(i = 0; i < n - 1; ++i)b[i] = 2 * x[i + 1] - a[i + 1];
    return [
        a,
        b
    ];
}
function _default(context) {
    return new Natural(context);
}

},{}],"AEhKq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.stepAfter = stepAfter;
exports.stepBefore = stepBefore;
function Step(context, t) {
    this._context = context;
    this._t = t;
}
Step.prototype = {
    areaStart: function() {
        this._line = 0;
    },
    areaEnd: function() {
        this._line = NaN;
    },
    lineStart: function() {
        this._x = this._y = NaN;
        this._point = 0;
    },
    lineEnd: function() {
        if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
        if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
        if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
    },
    point: function(x, y) {
        x = +x, y = +y;
        switch(this._point){
            case 0:
                this._point = 1;
                this._line ? this._context.lineTo(x, y) : this._context.moveTo(x, y);
                break;
            case 1:
                this._point = 2;
            // falls through
            default:
                if (this._t <= 0) {
                    this._context.lineTo(this._x, y);
                    this._context.lineTo(x, y);
                } else {
                    var x1 = this._x * (1 - this._t) + x * this._t;
                    this._context.lineTo(x1, this._y);
                    this._context.lineTo(x1, y);
                }
                break;
        }
        this._x = x, this._y = y;
    }
};
function _default(context) {
    return new Step(context, 0.5);
}
function stepBefore(context) {
    return new Step(context, 0);
}
function stepAfter(context) {
    return new Step(context, 1);
}

},{}],"gpRwX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _array = _interopRequireDefault(require("8b3b605fa9e4fac5"));
var _constant = _interopRequireDefault(require("e744701481d85f49"));
var _none = _interopRequireDefault(require("e54b6b0ae39944a2"));
var _none2 = _interopRequireDefault(require("e9814568a9c80598"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function stackValue(d, key) {
    return d[key];
}
function stackSeries(key) {
    const series = [];
    series.key = key;
    return series;
}
function _default() {
    var keys = (0, _constant.default)([]), order = _none2.default, offset = _none.default, value = stackValue;
    function stack(data) {
        var sz = Array.from(keys.apply(this, arguments), stackSeries), i, n = sz.length, j = -1, oz;
        for (const d of data)for(i = 0, ++j; i < n; ++i)(sz[i][j] = [
            0,
            +value(d, sz[i].key, j, data)
        ]).data = d;
        for(i = 0, oz = (0, _array.default)(order(sz)); i < n; ++i)sz[oz[i]].index = i;
        offset(sz, oz);
        return sz;
    }
    stack.keys = function(_) {
        return arguments.length ? (keys = typeof _ === "function" ? _ : (0, _constant.default)(Array.from(_)), stack) : keys;
    };
    stack.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(+_), stack) : value;
    };
    stack.order = function(_) {
        return arguments.length ? (order = _ == null ? _none2.default : typeof _ === "function" ? _ : (0, _constant.default)(Array.from(_)), stack) : order;
    };
    stack.offset = function(_) {
        return arguments.length ? (offset = _ == null ? _none.default : _, stack) : offset;
    };
    return stack;
}

},{"8b3b605fa9e4fac5":"b5jT0","e744701481d85f49":"iNw3T","e54b6b0ae39944a2":"aEqzB","e9814568a9c80598":"dyxZK"}],"aEqzB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series, order) {
    if (!((n = series.length) > 1)) return;
    for(var i = 1, j, s0, s1 = series[order[0]], n, m = s1.length; i < n; ++i){
        s0 = s1, s1 = series[order[i]];
        for(j = 0; j < m; ++j)s1[j][1] += s1[j][0] = isNaN(s0[j][1]) ? s0[j][0] : s0[j][1];
    }
}

},{}],"dyxZK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series) {
    var n = series.length, o = new Array(n);
    while(--n >= 0)o[n] = n;
    return o;
}

},{}],"2pw9l":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("d8cdcff221711407"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, n, j = 0, m = series[0].length, y; j < m; ++j){
        for(y = i = 0; i < n; ++i)y += series[i][j][1] || 0;
        if (y) for(i = 0; i < n; ++i)series[i][j][1] /= y;
    }
    (0, _none.default)(series, order);
}

},{"d8cdcff221711407":"aEqzB"}],"8qoTI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var i, j = 0, d, dy, yp, yn, n, m = series[order[0]].length; j < m; ++j)for(yp = yn = 0, i = 0; i < n; ++i){
        if ((dy = (d = series[order[i]][j])[1] - d[0]) > 0) d[0] = yp, d[1] = yp += dy;
        else if (dy < 0) d[1] = yn, d[0] = yn += dy;
        else d[0] = 0, d[1] = dy;
    }
}

},{}],"66Qa4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("af9c5fa37c1b1d9e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0)) return;
    for(var j = 0, s0 = series[order[0]], n, m = s0.length; j < m; ++j){
        for(var i = 0, y = 0; i < n; ++i)y += series[i][j][1] || 0;
        s0[j][1] += s0[j][0] = -y / 2;
    }
    (0, _none.default)(series, order);
}

},{"af9c5fa37c1b1d9e":"aEqzB"}],"gOpUa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("56eb12e1b2174aaf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series, order) {
    if (!((n = series.length) > 0) || !((m = (s0 = series[order[0]]).length) > 0)) return;
    for(var y = 0, j = 1, s0, m, n; j < m; ++j){
        for(var i = 0, s1 = 0, s2 = 0; i < n; ++i){
            var si = series[order[i]], sij0 = si[j][1] || 0, sij1 = si[j - 1][1] || 0, s3 = (sij0 - sij1) / 2;
            for(var k = 0; k < i; ++k){
                var sk = series[order[k]], skj0 = sk[j][1] || 0, skj1 = sk[j - 1][1] || 0;
                s3 += skj0 - skj1;
            }
            s1 += sij0, s2 += s3 * sij0;
        }
        s0[j - 1][1] += s0[j - 1][0] = y;
        if (s1) y -= s2 / s1;
    }
    s0[j - 1][1] += s0[j - 1][0] = y;
    (0, _none.default)(series, order);
}

},{"56eb12e1b2174aaf":"aEqzB"}],"i34NF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("4494c675f3e20319"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var peaks = series.map(peak);
    return (0, _none.default)(series).sort(function(a, b) {
        return peaks[a] - peaks[b];
    });
}
function peak(series) {
    var i = -1, j = 0, n = series.length, vi, vj = -Infinity;
    while(++i < n)if ((vi = +series[i][1]) > vj) vj = vi, j = i;
    return j;
}

},{"4494c675f3e20319":"dyxZK"}],"kJWkm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.sum = sum;
var _none = _interopRequireDefault(require("4a7d728f9a184a25"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var sums = series.map(sum);
    return (0, _none.default)(series).sort(function(a, b) {
        return sums[a] - sums[b];
    });
}
function sum(series) {
    var s = 0, i = -1, n = series.length, v;
    while(++i < n)if (v = +series[i][1]) s += v;
    return s;
}

},{"4a7d728f9a184a25":"dyxZK"}],"bXNtY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _ascending = _interopRequireDefault(require("d39a3ba1232418c4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    return (0, _ascending.default)(series).reverse();
}

},{"d39a3ba1232418c4":"kJWkm"}],"cPTLO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _appearance = _interopRequireDefault(require("7e770dfcdf2ff59a"));
var _ascending = require("12f0fe8581e206");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    var n = series.length, i, j, sums = series.map(_ascending.sum), order = (0, _appearance.default)(series), top = 0, bottom = 0, tops = [], bottoms = [];
    for(i = 0; i < n; ++i){
        j = order[i];
        if (top < bottom) {
            top += sums[j];
            tops.push(j);
        } else {
            bottom += sums[j];
            bottoms.push(j);
        }
    }
    return bottoms.reverse().concat(tops);
}

},{"7e770dfcdf2ff59a":"i34NF","12f0fe8581e206":"kJWkm"}],"7jhD4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _none = _interopRequireDefault(require("175f4f386d8ceefb"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(series) {
    return (0, _none.default)(series).reverse();
}

},{"175f4f386d8ceefb":"dyxZK"}],"85Zws":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getSliced", ()=>getSliced);
function getSliced(arr, startIndex, endIndex) {
    if (!Array.isArray(arr)) return arr;
    if (arr && startIndex + endIndex !== 0) return arr.slice(startIndex, endIndex + 1);
    return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aIsFR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWellBehavedNumber", ()=>isWellBehavedNumber);
parcelHelpers.export(exports, "isPositiveNumber", ()=>isPositiveNumber);
function isWellBehavedNumber(n) {
    return Number.isFinite(n);
}
function isPositiveNumber(n) {
    return typeof n === 'number' && n > 0 && Number.isFinite(n);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lESsH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTicks", ()=>getTicks);
var _dataUtils = require("../util/DataUtils");
var _domutils = require("../util/DOMUtils");
var _global = require("../util/Global");
var _tickUtils = require("../util/TickUtils");
var _getEquidistantTicks = require("./getEquidistantTicks");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap) {
    var result = (ticks || []).slice();
    var len = result.length;
    var { start } = boundaries;
    var { end } = boundaries;
    var _loop = function _loop(i) {
        var entry = result[i];
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === len - 1) {
            var gap = sign * (entry.coordinate + sign * getSize() / 2 - end);
            result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
                tickCoord: gap > 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        if (entry.tickCoord != null) {
            var isShow = (0, _tickUtils.isVisible)(sign, entry.tickCoord, getSize, start, end);
            if (isShow) {
                end = entry.tickCoord - sign * (getSize() / 2 + minTickGap);
                result[i] = _objectSpread(_objectSpread({}, entry), {}, {
                    isShow: true
                });
            }
        }
    };
    for(var i = len - 1; i >= 0; i--)_loop(i);
    return result;
}
function getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, preserveEnd) {
    // This method is mutating the array so clone is indeed necessary here
    var result = (ticks || []).slice();
    var len = result.length;
    var { start, end } = boundaries;
    if (preserveEnd) {
        // Try to guarantee the tail to be displayed
        var tail = ticks[len - 1];
        var tailSize = getTickSize(tail, len - 1);
        var tailGap = sign * (tail.coordinate + sign * tailSize / 2 - end);
        result[len - 1] = tail = _objectSpread(_objectSpread({}, tail), {}, {
            tickCoord: tailGap > 0 ? tail.coordinate - tailGap * sign : tail.coordinate
        });
        if (tail.tickCoord != null) {
            var isTailShow = (0, _tickUtils.isVisible)(sign, tail.tickCoord, ()=>tailSize, start, end);
            if (isTailShow) {
                end = tail.tickCoord - sign * (tailSize / 2 + minTickGap);
                result[len - 1] = _objectSpread(_objectSpread({}, tail), {}, {
                    isShow: true
                });
            }
        }
    }
    var count = preserveEnd ? len - 1 : len;
    var _loop2 = function _loop2(i) {
        var entry = result[i];
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        if (i === 0) {
            var gap = sign * (entry.coordinate - sign * getSize() / 2 - start);
            result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
                tickCoord: gap < 0 ? entry.coordinate - gap * sign : entry.coordinate
            });
        } else result[i] = entry = _objectSpread(_objectSpread({}, entry), {}, {
            tickCoord: entry.coordinate
        });
        if (entry.tickCoord != null) {
            var isShow = (0, _tickUtils.isVisible)(sign, entry.tickCoord, getSize, start, end);
            if (isShow) {
                start = entry.tickCoord + sign * (getSize() / 2 + minTickGap);
                result[i] = _objectSpread(_objectSpread({}, entry), {}, {
                    isShow: true
                });
            }
        }
    };
    for(var i = 0; i < count; i++)_loop2(i);
    return result;
}
function getTicks(props, fontSize, letterSpacing) {
    var { tick, ticks, viewBox, minTickGap, orientation, interval, tickFormatter, unit, angle } = props;
    if (!ticks || !ticks.length || !tick) return [];
    if ((0, _dataUtils.isNumber)(interval) || (0, _global.Global).isSsr) {
        var _getNumberIntervalTic;
        return (_getNumberIntervalTic = (0, _tickUtils.getNumberIntervalTicks)(ticks, (0, _dataUtils.isNumber)(interval) ? interval : 0)) !== null && _getNumberIntervalTic !== void 0 ? _getNumberIntervalTic : [];
    }
    var candidates = [];
    var sizeKey = orientation === 'top' || orientation === 'bottom' ? 'width' : 'height';
    var unitSize = unit && sizeKey === 'width' ? (0, _domutils.getStringSize)(unit, {
        fontSize,
        letterSpacing
    }) : {
        width: 0,
        height: 0
    };
    var getTickSize = (content, index)=>{
        var value = typeof tickFormatter === 'function' ? tickFormatter(content.value, index) : content.value;
        // Recharts only supports angles when sizeKey === 'width'
        return sizeKey === 'width' ? (0, _tickUtils.getAngledTickWidth)((0, _domutils.getStringSize)(value, {
            fontSize,
            letterSpacing
        }), unitSize, angle) : (0, _domutils.getStringSize)(value, {
            fontSize,
            letterSpacing
        })[sizeKey];
    };
    var sign = ticks.length >= 2 ? (0, _dataUtils.mathSign)(ticks[1].coordinate - ticks[0].coordinate) : 1;
    var boundaries = (0, _tickUtils.getTickBoundaries)(viewBox, sign, sizeKey);
    if (interval === 'equidistantPreserveStart') return (0, _getEquidistantTicks.getEquidistantTicks)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'equidistantPreserveEnd') return (0, _getEquidistantTicks.getEquidistantPreserveEndTicks)(sign, boundaries, getTickSize, ticks, minTickGap);
    if (interval === 'preserveStart' || interval === 'preserveStartEnd') candidates = getTicksStart(sign, boundaries, getTickSize, ticks, minTickGap, interval === 'preserveStartEnd');
    else candidates = getTicksEnd(sign, boundaries, getTickSize, ticks, minTickGap);
    return candidates.filter((entry)=>entry.isShow);
}

},{"../util/DataUtils":"lNZEj","../util/DOMUtils":"7zgY9","../util/Global":"7wpBp","../util/TickUtils":"cPfUd","./getEquidistantTicks":"kvALh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7zgY9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStringSize", ()=>getStringSize);
parcelHelpers.export(exports, "configureTextMeasurement", ()=>configureTextMeasurement);
parcelHelpers.export(exports, "getTextMeasurementConfig", ()=>getTextMeasurementConfig);
parcelHelpers.export(exports, "clearStringCache", ()=>clearStringCache);
parcelHelpers.export(exports, "getStringCacheStats", ()=>getStringCacheStats);
var _global = require("./Global");
var _lrucache = require("./LRUCache");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var defaultConfig = {
    cacheSize: 2000,
    enableCache: true
};
var currentConfig = _objectSpread({}, defaultConfig);
var stringCache = new (0, _lrucache.LRUCache)(currentConfig.cacheSize);
var SPAN_STYLE = {
    position: 'absolute',
    top: '-20000px',
    left: 0,
    padding: 0,
    margin: 0,
    border: 'none',
    whiteSpace: 'pre'
};
var MEASUREMENT_SPAN_ID = 'recharts_measurement_span';
function createCacheKey(text, style) {
    // Simple string concatenation for better performance than JSON.stringify
    var fontSize = style.fontSize || '';
    var fontFamily = style.fontFamily || '';
    var fontWeight = style.fontWeight || '';
    var fontStyle = style.fontStyle || '';
    var letterSpacing = style.letterSpacing || '';
    var textTransform = style.textTransform || '';
    return "".concat(text, "|").concat(fontSize, "|").concat(fontFamily, "|").concat(fontWeight, "|").concat(fontStyle, "|").concat(letterSpacing, "|").concat(textTransform);
}
/**
 * Measure text using DOM (accurate but slower)
 * @param text - The text to measure
 * @param style - CSS style properties to apply
 * @returns The size of the text
 */ var measureTextWithDOM = (text, style)=>{
    try {
        var measurementSpan = document.getElementById(MEASUREMENT_SPAN_ID);
        if (!measurementSpan) {
            measurementSpan = document.createElement('span');
            measurementSpan.setAttribute('id', MEASUREMENT_SPAN_ID);
            measurementSpan.setAttribute('aria-hidden', 'true');
            document.body.appendChild(measurementSpan);
        }
        // Apply styles directly without unnecessary object creation
        Object.assign(measurementSpan.style, SPAN_STYLE, style);
        measurementSpan.textContent = "".concat(text);
        var rect = measurementSpan.getBoundingClientRect();
        return {
            width: rect.width,
            height: rect.height
        };
    } catch (_unused) {
        return {
            width: 0,
            height: 0
        };
    }
};
var getStringSize = function getStringSize(text) {
    var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (text === undefined || text === null || (0, _global.Global).isSsr) return {
        width: 0,
        height: 0
    };
    // If caching is disabled, measure directly
    if (!currentConfig.enableCache) return measureTextWithDOM(text, style);
    var cacheKey = createCacheKey(text, style);
    var cachedResult = stringCache.get(cacheKey);
    if (cachedResult) return cachedResult;
    // Measure using DOM
    var result = measureTextWithDOM(text, style);
    // Store in LRU cache
    stringCache.set(cacheKey, result);
    return result;
};
var configureTextMeasurement = (config)=>{
    var newConfig = _objectSpread(_objectSpread({}, currentConfig), config);
    if (newConfig.cacheSize !== currentConfig.cacheSize) stringCache = new (0, _lrucache.LRUCache)(newConfig.cacheSize);
    currentConfig = newConfig;
};
var getTextMeasurementConfig = ()=>_objectSpread({}, currentConfig);
var clearStringCache = ()=>{
    stringCache.clear();
};
var getStringCacheStats = ()=>({
        size: stringCache.size(),
        maxSize: currentConfig.cacheSize
    });

},{"./Global":"7wpBp","./LRUCache":"83ljn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7wpBp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Global", ()=>Global);
var parseIsSsrByDefault = ()=>!(typeof window !== 'undefined' && window.document && Boolean(window.document.createElement) && window.setTimeout);
var Global = {
    devToolsEnabled: true,
    isSsr: parseIsSsrByDefault()
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"83ljn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Simple LRU (Least Recently Used) cache implementation
 */ parcelHelpers.export(exports, "LRUCache", ()=>LRUCache);
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class LRUCache {
    constructor(maxSize){
        _defineProperty(this, "cache", new Map());
        this.maxSize = maxSize;
    }
    get(key) {
        var value = this.cache.get(key);
        if (value !== undefined) {
            this.cache.delete(key);
            this.cache.set(key, value);
        }
        return value;
    }
    set(key, value) {
        if (this.cache.has(key)) this.cache.delete(key);
        else if (this.cache.size >= this.maxSize) {
            var firstKey = this.cache.keys().next().value;
            if (firstKey != null) this.cache.delete(firstKey);
        }
        this.cache.set(key, value);
    }
    clear() {
        this.cache.clear();
    }
    size() {
        return this.cache.size;
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cPfUd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getAngledTickWidth", ()=>getAngledTickWidth);
parcelHelpers.export(exports, "getTickBoundaries", ()=>getTickBoundaries);
parcelHelpers.export(exports, "isVisible", ()=>isVisible);
parcelHelpers.export(exports, "getNumberIntervalTicks", ()=>getNumberIntervalTicks);
var _cartesianUtils = require("./CartesianUtils");
var _getEveryNth = require("./getEveryNth");
function getAngledTickWidth(contentSize, unitSize, angle) {
    var size = {
        width: contentSize.width + unitSize.width,
        height: contentSize.height + unitSize.height
    };
    return (0, _cartesianUtils.getAngledRectangleWidth)(size, angle);
}
function getTickBoundaries(viewBox, sign, sizeKey) {
    var isWidth = sizeKey === 'width';
    var { x, y, width, height } = viewBox;
    if (sign === 1) return {
        start: isWidth ? x : y,
        end: isWidth ? x + width : y + height
    };
    return {
        start: isWidth ? x + width : y + height,
        end: isWidth ? x : y
    };
}
function isVisible(sign, tickPosition, getSize, start, end) {
    /* Since getSize() is expensive (it reads the ticks' size from the DOM), we do this check first to avoid calculating
   * the tick's size. */ if (sign * tickPosition < sign * start || sign * tickPosition > sign * end) return false;
    var size = getSize();
    return sign * (tickPosition - sign * size / 2 - start) >= 0 && sign * (tickPosition + sign * size / 2 - end) <= 0;
}
function getNumberIntervalTicks(ticks, interval) {
    return (0, _getEveryNth.getEveryNth)(ticks, interval + 1);
}

},{"./CartesianUtils":"6piZB","./getEveryNth":"9n28S","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6piZB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rectWithPoints", ()=>rectWithPoints);
parcelHelpers.export(exports, "rectWithCoords", ()=>rectWithCoords);
parcelHelpers.export(exports, "ScaleHelper", ()=>ScaleHelper);
parcelHelpers.export(exports, "createLabeledScales", ()=>createLabeledScales);
/** Normalizes the angle so that 0 <= angle < 180.
 * @param {number} angle Angle in degrees.
 * @return {number} the normalized angle with a value of at least 0 and never greater or equal to 180. */ parcelHelpers.export(exports, "normalizeAngle", ()=>normalizeAngle);
parcelHelpers.export(exports, "getAngledRectangleWidth", ()=>getAngledRectangleWidth);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var rectWithPoints = (_ref, _ref2)=>{
    var { x: x1, y: y1 } = _ref;
    var { x: x2, y: y2 } = _ref2;
    return {
        x: Math.min(x1, x2),
        y: Math.min(y1, y2),
        width: Math.abs(x2 - x1),
        height: Math.abs(y2 - y1)
    };
};
var rectWithCoords = (_ref3)=>{
    var { x1, y1, x2, y2 } = _ref3;
    return rectWithPoints({
        x: x1,
        y: y1
    }, {
        x: x2,
        y: y2
    });
};
class ScaleHelper {
    static create(obj) {
        return new ScaleHelper(obj);
    }
    constructor(scale){
        this.scale = scale;
    }
    get domain() {
        return this.scale.domain;
    }
    get range() {
        return this.scale.range;
    }
    get rangeMin() {
        return this.range()[0];
    }
    get rangeMax() {
        return this.range()[1];
    }
    get bandwidth() {
        return this.scale.bandwidth;
    }
    apply(value) {
        var { bandAware, position } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (value === undefined) return undefined;
        if (position) switch(position){
            case 'start':
                return this.scale(value);
            case 'middle':
                var offset = this.bandwidth ? this.bandwidth() / 2 : 0;
                return this.scale(value) + offset;
            case 'end':
                var _offset = this.bandwidth ? this.bandwidth() : 0;
                return this.scale(value) + _offset;
            default:
                return this.scale(value);
        }
        if (bandAware) {
            var _offset2 = this.bandwidth ? this.bandwidth() / 2 : 0;
            return this.scale(value) + _offset2;
        }
        return this.scale(value);
    }
    isInRange(value) {
        var range = this.range();
        var first = range[0];
        var last = range[range.length - 1];
        return first <= last ? value >= first && value <= last : value >= last && value <= first;
    }
}
_defineProperty(ScaleHelper, "EPS", 1e-4);
var createLabeledScales = (options)=>{
    var scales = Object.keys(options).reduce((res, key)=>_objectSpread(_objectSpread({}, res), {}, {
            [key]: ScaleHelper.create(options[key])
        }), {});
    return _objectSpread(_objectSpread({}, scales), {}, {
        apply (coord) {
            var { bandAware, position } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            return Object.fromEntries(Object.entries(coord).map((_ref4)=>{
                var [label, value] = _ref4;
                return [
                    label,
                    scales[label].apply(value, {
                        bandAware,
                        position
                    })
                ];
            }));
        },
        isInRange (coord) {
            return Object.keys(coord).every((label)=>scales[label].isInRange(coord[label]));
        }
    });
};
function normalizeAngle(angle) {
    return (angle % 180 + 180) % 180;
}
var getAngledRectangleWidth = function getAngledRectangleWidth(_ref5) {
    var { width, height } = _ref5;
    var angle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    // Ensure angle is >= 0 && < 180
    var normalizedAngle = normalizeAngle(angle);
    var angleRadians = normalizedAngle * Math.PI / 180;
    /* Depending on the height and width of the rectangle, we may need to use different formulas to calculate the angled
   * width. This threshold defines when each formula should kick in. */ var angleThreshold = Math.atan(height / width);
    var angledWidth = angleRadians > angleThreshold && angleRadians < Math.PI - angleThreshold ? height / Math.sin(angleRadians) : width / Math.cos(angleRadians);
    return Math.abs(angledWidth);
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9n28S":[function(require,module,exports,__globalThis) {
/**
 * Given an array and a number N, return a new array which contains every nTh
 * element of the input array. For n below 1, an empty array is returned.
 * For n equal to 1, the input array is returned as is.
 * For n greater than the length of the array, an array containing the first element
 * and every nTh element after that (if any) is returned.
 *
 * @param array An input array.
 * @param n A number specifying which elements to take.
 * @returns The result array of the same type as the input array.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEveryNth", ()=>getEveryNth);
function getEveryNth(array, n) {
    if (n < 1) return [];
    if (n === 1) return array;
    var result = [];
    for(var i = 0; i < array.length; i += n){
        var item = array[i];
        if (item !== undefined) result.push(item);
    }
    return result;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kvALh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getEquidistantTicks", ()=>getEquidistantTicks);
parcelHelpers.export(exports, "getEquidistantPreserveEndTicks", ()=>getEquidistantPreserveEndTicks);
var _tickUtils = require("../util/TickUtils");
var _getEveryNth = require("../util/getEveryNth");
function getEquidistantTicks(sign, boundaries, getTickSize, ticks, minTickGap) {
    // If the ticks are readonly, then the slice might not be necessary
    var result = (ticks || []).slice();
    var { start: initialStart, end } = boundaries;
    var index = 0;
    // Premature optimisation idea 1: Estimate a lower bound, and start from there.
    // For now, start from every tick
    var stepsize = 1;
    var start = initialStart;
    var _loop = function _loop() {
        // Given stepsize, evaluate whether every stepsize-th tick can be shown.
        // If it can not, then increase the stepsize by 1, and try again.
        var entry = ticks === null || ticks === void 0 ? void 0 : ticks[index];
        // Break condition - If we have evaluated all the ticks, then we are done.
        if (entry === undefined) return {
            v: (0, _getEveryNth.getEveryNth)(ticks, stepsize)
        };
        // Check if the element collides with the next element
        var i = index;
        var size;
        var getSize = ()=>{
            if (size === undefined) size = getTickSize(entry, i);
            return size;
        };
        var tickCoord = entry.coordinate;
        // We will always show the first tick.
        var isShow = index === 0 || (0, _tickUtils.isVisible)(sign, tickCoord, getSize, start, end);
        if (!isShow) {
            // Start all over with a larger stepsize
            index = 0;
            start = initialStart;
            stepsize += 1;
        }
        if (isShow) {
            // If it can be shown, update the start
            start = tickCoord + sign * (getSize() / 2 + minTickGap);
            index += stepsize;
        }
    }, _ret;
    while(stepsize <= result.length){
        _ret = _loop();
        if (_ret) return _ret.v;
    }
    return [];
}
function getEquidistantPreserveEndTicks(sign, boundaries, getTickSize, ticks, minTickGap) {
    // If the ticks are readonly, then the slice might not be necessary
    // Reworked logic for getEquidistantPreserveEndTicks
    var result = (ticks || []).slice();
    var len = result.length;
    if (len === 0) return [];
    var { start: initialStart, end } = boundaries;
    // Start with stepsize = 1 (every tick) up to the maximum possible stepsize (len)
    for(var stepsize = 1; stepsize <= len; stepsize++){
        // 1. Calculate the offset so the last tick (index len - 1) is always included in the sequence.
        var offset = (len - 1) % stepsize;
        var start = initialStart; // `start` tracks the coordinate of the last successfully drawn tick + gap
        var ok = true;
        // 2. Iterate through the end-anchored sequence: offset, offset + stepsize, ..., len - 1
        var _loop2 = function _loop2() {
            var entry = ticks[index];
            var i = index;
            var size;
            // Use a function to get size, as in the original code
            var getSize = ()=>{
                if (size === undefined) size = getTickSize(entry, i);
                return size;
            };
            var tickCoord = entry.coordinate;
            // 3. Apply visibility logic (including the first tick special case)
            // The reviewer says *not* to unconditionally bypass checks for the last tick.
            var isShow = index === offset || (0, _tickUtils.isVisible)(sign, tickCoord, getSize, start, end);
            if (!isShow) {
                // If any tick in this end-anchored sequence fails visibility/collision,
                // reject this stepsize and move to the next iteration (larger stepsize).
                ok = false;
                return 1; // break
            }
            // 4. If showable, update the 'start' coordinate for the next collision check
            if (isShow) start = tickCoord + sign * (getSize() / 2 + minTickGap);
        };
        for(var index = offset; index < len; index += stepsize){
            if (_loop2()) break;
        }
        // 5. If the entire sequence for this stepsize passed the visibility check, return the result
        if (ok) {
            // Build the final result array explicitly using the validated stepsize and offset.
            var finalTicks = [];
            for(var _index = offset; _index < len; _index += stepsize)finalTicks.push(ticks[_index]);
            return finalTicks;
        }
    }
    // If no stepsize works (this shouldn't happen unless minTickGap is huge), return an empty array.
    return [];
}

},{"../util/TickUtils":"cPfUd","../util/getEveryNth":"9n28S","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d3UBS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultCartesianAxisProps", ()=>defaultCartesianAxisProps);
parcelHelpers.export(exports, "CartesianAxis", ()=>CartesianAxis);
/**
 * @fileOverview Cartesian Axis
 */ var _react = require("react");
var _get = require("es-toolkit/compat/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _clsx = require("clsx");
var _layer = require("../container/Layer");
var _text = require("../component/Text");
var _label = require("../component/Label");
var _dataUtils = require("../util/DataUtils");
var _types = require("../util/types");
var _getTicks = require("./getTicks");
var _svgPropertiesNoEvents = require("../util/svgPropertiesNoEvents");
var _yaxisUtils = require("../util/YAxisUtils");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
var _zindexLayer = require("../zIndex/ZIndexLayer");
var _defaultZIndexes = require("../zIndex/DefaultZIndexes");
var _excluded = [
    "axisLine",
    "width",
    "height",
    "className",
    "hide",
    "ticks",
    "axisType"
];
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var defaultCartesianAxisProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    viewBox: {
        x: 0,
        y: 0,
        width: 0,
        height: 0
    },
    // The orientation of axis
    orientation: 'bottom',
    // The ticks
    ticks: [],
    stroke: '#666',
    tickLine: true,
    axisLine: true,
    tick: true,
    mirror: false,
    minTickGap: 5,
    // The width or height of tick
    tickSize: 6,
    tickMargin: 2,
    interval: 'preserveEnd',
    zIndex: (0, _defaultZIndexes.DefaultZIndexes).axis
};
/*
 * `viewBox` and `scale` are SVG attributes.
 * Recharts however - unfortunately - has its own attributes named `viewBox` and `scale`
 * that are completely different data shape and different purpose.
 */ function AxisLine(axisLineProps) {
    var { x, y, width, height, orientation, mirror, axisLine, otherSvgProps } = axisLineProps;
    if (!axisLine) return null;
    var props = _objectSpread(_objectSpread(_objectSpread({}, otherSvgProps), (0, _svgPropertiesNoEvents.svgPropertiesNoEvents)(axisLine)), {}, {
        fill: 'none'
    });
    if (orientation === 'top' || orientation === 'bottom') {
        var needHeight = +(orientation === 'top' && !mirror || orientation === 'bottom' && mirror);
        props = _objectSpread(_objectSpread({}, props), {}, {
            x1: x,
            y1: y + needHeight * height,
            x2: x + width,
            y2: y + needHeight * height
        });
    } else {
        var needWidth = +(orientation === 'left' && !mirror || orientation === 'right' && mirror);
        props = _objectSpread(_objectSpread({}, props), {}, {
            x1: x + needWidth * width,
            y1: y,
            x2: x + needWidth * width,
            y2: y + height
        });
    }
    return /*#__PURE__*/ _react.createElement("line", _extends({}, props, {
        className: (0, _clsx.clsx)('recharts-cartesian-axis-line', (0, _getDefault.default)(axisLine, 'className'))
    }));
}
/**
 * Calculate the coordinates of endpoints in ticks.
 * @param data The data of a simple tick.
 * @param x The x-coordinate of the axis.
 * @param y The y-coordinate of the axis.
 * @param width The width of the axis.
 * @param height The height of the axis.
 * @param orientation The orientation of the axis.
 * @param tickSize The length of the tick line.
 * @param mirror If true, the ticks are mirrored.
 * @param tickMargin The margin between the tick line and the tick text.
 * @returns An object with `line` and `tick` coordinates.
 * `line` is the coordinates for the tick line, and `tick` is the coordinate for the tick text.
 */ function getTickLineCoord(data, x, y, width, height, orientation, tickSize, mirror, tickMargin) {
    var x1, x2, y1, y2, tx, ty;
    var sign = mirror ? -1 : 1;
    var finalTickSize = data.tickSize || tickSize;
    var tickCoord = (0, _dataUtils.isNumber)(data.tickCoord) ? data.tickCoord : data.coordinate;
    switch(orientation){
        case 'top':
            x1 = x2 = data.coordinate;
            y2 = y + +!mirror * height;
            y1 = y2 - sign * finalTickSize;
            ty = y1 - sign * tickMargin;
            tx = tickCoord;
            break;
        case 'left':
            y1 = y2 = data.coordinate;
            x2 = x + +!mirror * width;
            x1 = x2 - sign * finalTickSize;
            tx = x1 - sign * tickMargin;
            ty = tickCoord;
            break;
        case 'right':
            y1 = y2 = data.coordinate;
            x2 = x + +mirror * width;
            x1 = x2 + sign * finalTickSize;
            tx = x1 + sign * tickMargin;
            ty = tickCoord;
            break;
        default:
            x1 = x2 = data.coordinate;
            y2 = y + +mirror * height;
            y1 = y2 + sign * finalTickSize;
            ty = y1 + sign * tickMargin;
            tx = tickCoord;
            break;
    }
    return {
        line: {
            x1,
            y1,
            x2,
            y2
        },
        tick: {
            x: tx,
            y: ty
        }
    };
}
/**
 * @param orientation The orientation of the axis.
 * @param mirror If true, the ticks are mirrored.
 * @returns The text anchor of the tick.
 */ function getTickTextAnchor(orientation, mirror) {
    switch(orientation){
        case 'left':
            return mirror ? 'start' : 'end';
        case 'right':
            return mirror ? 'end' : 'start';
        default:
            return 'middle';
    }
}
/**
 * @param orientation The orientation of the axis.
 * @param mirror If true, the ticks are mirrored.
 * @returns The vertical text anchor of the tick.
 */ function getTickVerticalAnchor(orientation, mirror) {
    switch(orientation){
        case 'left':
        case 'right':
            return 'middle';
        case 'top':
            return mirror ? 'start' : 'end';
        default:
            return mirror ? 'end' : 'start';
    }
}
function TickItem(props) {
    var { option, tickProps, value } = props;
    var tickItem;
    var combinedClassName = (0, _clsx.clsx)(tickProps.className, 'recharts-cartesian-axis-tick-value');
    if (/*#__PURE__*/ _react.isValidElement(option)) // @ts-expect-error element cloning is not typed
    tickItem = /*#__PURE__*/ _react.cloneElement(option, _objectSpread(_objectSpread({}, tickProps), {}, {
        className: combinedClassName
    }));
    else if (typeof option === 'function') tickItem = option(_objectSpread(_objectSpread({}, tickProps), {}, {
        className: combinedClassName
    }));
    else {
        var className = 'recharts-cartesian-axis-tick-value';
        if (typeof option !== 'boolean') className = (0, _clsx.clsx)(className, option === null || option === void 0 ? void 0 : option.className);
        tickItem = /*#__PURE__*/ _react.createElement((0, _text.Text), _extends({}, tickProps, {
            className: className
        }), value);
    }
    return tickItem;
}
var Ticks = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    var { ticks = [], tick, tickLine, stroke, tickFormatter, unit, padding, tickTextProps, orientation, mirror, x, y, width, height, tickSize, tickMargin, fontSize, letterSpacing, getTicksConfig, events, axisType } = props;
    // @ts-expect-error some properties are optional in props but required in getTicks
    var finalTicks = (0, _getTicks.getTicks)(_objectSpread(_objectSpread({}, getTicksConfig), {}, {
        ticks
    }), fontSize, letterSpacing);
    var textAnchor = getTickTextAnchor(orientation, mirror);
    var verticalAnchor = getTickVerticalAnchor(orientation, mirror);
    var axisProps = (0, _svgPropertiesNoEvents.svgPropertiesNoEvents)(getTicksConfig);
    var customTickProps = (0, _svgPropertiesNoEvents.svgPropertiesNoEventsFromUnknown)(tick);
    var tickLinePropsObject = {};
    if (typeof tickLine === 'object') tickLinePropsObject = tickLine;
    var tickLineProps = _objectSpread(_objectSpread({}, axisProps), {}, {
        fill: 'none'
    }, tickLinePropsObject);
    var tickLineCoords = finalTicks.map((entry)=>_objectSpread({
            entry
        }, getTickLineCoord(entry, x, y, width, height, orientation, tickSize, mirror, tickMargin)));
    var tickLines = tickLineCoords.map((_ref)=>{
        var { entry, line: lineCoord } = _ref;
        return /*#__PURE__*/ _react.createElement((0, _layer.Layer), {
            className: "recharts-cartesian-axis-tick",
            key: "tick-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, tickLine && /*#__PURE__*/ _react.createElement("line", _extends({}, tickLineProps, lineCoord, {
            className: (0, _clsx.clsx)('recharts-cartesian-axis-tick-line', (0, _getDefault.default)(tickLine, 'className'))
        })));
    });
    var tickLabels = tickLineCoords.map((_ref2, i)=>{
        var { entry, tick: tickCoord } = _ref2;
        var tickProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
            // @ts-expect-error textAnchor from axisProps is typed as `string` but Text wants type `TextAnchor`
            textAnchor,
            verticalAnchor
        }, axisProps), {}, {
            // @ts-expect-error customTickProps is contributing unknown props
            stroke: 'none',
            // @ts-expect-error customTickProps is contributing unknown props
            fill: stroke
        }, customTickProps), tickCoord), {}, {
            index: i,
            payload: entry,
            visibleTicksCount: finalTicks.length,
            tickFormatter,
            padding
        }, tickTextProps);
        return /*#__PURE__*/ _react.createElement((0, _layer.Layer), _extends({
            className: "recharts-cartesian-axis-tick-label",
            key: "tick-label-".concat(entry.value, "-").concat(entry.coordinate, "-").concat(entry.tickCoord)
        }, (0, _types.adaptEventsOfChild)(events, entry, i)), tick && /*#__PURE__*/ _react.createElement(TickItem, {
            option: tick,
            tickProps: tickProps,
            value: "".concat(typeof tickFormatter === 'function' ? tickFormatter(entry.value, i) : entry.value).concat(unit || '')
        }));
    });
    return /*#__PURE__*/ _react.createElement("g", {
        className: "recharts-cartesian-axis-ticks recharts-".concat(axisType, "-ticks")
    }, tickLabels.length > 0 && /*#__PURE__*/ _react.createElement((0, _zindexLayer.ZIndexLayer), {
        zIndex: (0, _defaultZIndexes.DefaultZIndexes).label
    }, /*#__PURE__*/ _react.createElement("g", {
        className: "recharts-cartesian-axis-tick-labels recharts-".concat(axisType, "-tick-labels"),
        ref: ref
    }, tickLabels)), tickLines.length > 0 && /*#__PURE__*/ _react.createElement("g", {
        className: "recharts-cartesian-axis-tick-lines recharts-".concat(axisType, "-tick-lines")
    }, tickLines));
});
var CartesianAxisComponent = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    var { axisLine, width, height, className, hide, ticks, axisType } = props, rest = _objectWithoutProperties(props, _excluded);
    var [fontSize, setFontSize] = (0, _react.useState)('');
    var [letterSpacing, setLetterSpacing] = (0, _react.useState)('');
    var tickRefs = (0, _react.useRef)(null);
    (0, _react.useImperativeHandle)(ref, ()=>({
            getCalculatedWidth: ()=>{
                var _props$labelRef;
                return (0, _yaxisUtils.getCalculatedYAxisWidth)({
                    ticks: tickRefs.current,
                    label: (_props$labelRef = props.labelRef) === null || _props$labelRef === void 0 ? void 0 : _props$labelRef.current,
                    labelGapWithTick: 5,
                    tickSize: props.tickSize,
                    tickMargin: props.tickMargin
                });
            }
        }));
    var layerRef = (0, _react.useCallback)((el)=>{
        if (el) {
            var tickNodes = el.getElementsByClassName('recharts-cartesian-axis-tick-value');
            tickRefs.current = tickNodes;
            var tick = tickNodes[0];
            if (tick) {
                var computedStyle = window.getComputedStyle(tick);
                var calculatedFontSize = computedStyle.fontSize;
                var calculatedLetterSpacing = computedStyle.letterSpacing;
                if (calculatedFontSize !== fontSize || calculatedLetterSpacing !== letterSpacing) {
                    setFontSize(calculatedFontSize);
                    setLetterSpacing(calculatedLetterSpacing);
                }
            }
        }
    }, [
        fontSize,
        letterSpacing
    ]);
    if (hide) return null;
    /*
   * This is different condition from what validateWidthHeight is doing;
   * the CartesianAxis does allow width or height to be undefined.
   */ if (width != null && width <= 0 || height != null && height <= 0) return null;
    return /*#__PURE__*/ _react.createElement((0, _zindexLayer.ZIndexLayer), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ _react.createElement((0, _layer.Layer), {
        className: (0, _clsx.clsx)('recharts-cartesian-axis', className)
    }, /*#__PURE__*/ _react.createElement(AxisLine, {
        x: props.x,
        y: props.y,
        width: width,
        height: height,
        orientation: props.orientation,
        mirror: props.mirror,
        axisLine: axisLine,
        otherSvgProps: (0, _svgPropertiesNoEvents.svgPropertiesNoEvents)(props)
    }), /*#__PURE__*/ _react.createElement(Ticks, {
        ref: layerRef,
        axisType: axisType,
        events: rest,
        fontSize: fontSize,
        getTicksConfig: props,
        height: props.height,
        letterSpacing: letterSpacing,
        mirror: props.mirror,
        orientation: props.orientation,
        padding: props.padding,
        stroke: props.stroke,
        tick: props.tick,
        tickFormatter: props.tickFormatter,
        tickLine: props.tickLine,
        tickMargin: props.tickMargin,
        tickSize: props.tickSize,
        tickTextProps: props.tickTextProps,
        ticks: ticks,
        unit: props.unit,
        width: props.width,
        x: props.x,
        y: props.y
    }), /*#__PURE__*/ _react.createElement((0, _label.CartesianLabelContextProvider), {
        x: props.x,
        y: props.y,
        width: props.width,
        height: props.height,
        lowerWidth: props.width,
        upperWidth: props.width
    }, /*#__PURE__*/ _react.createElement((0, _label.CartesianLabelFromLabelProp), {
        label: props.label,
        labelRef: props.labelRef
    }), props.children)));
});
var CartesianAxis = /*#__PURE__*/ _react.forwardRef((outsideProps, ref)=>{
    var props = (0, _resolveDefaultProps.resolveDefaultProps)(outsideProps, defaultCartesianAxisProps);
    return /*#__PURE__*/ _react.createElement(CartesianAxisComponent, _extends({}, props, {
        ref: ref
    }));
});
CartesianAxis.displayName = 'CartesianAxis';

},{"react":"bmhQu","es-toolkit/compat/get":"7LxLv","clsx":"431Ou","../container/Layer":"ctc59","../component/Text":"a7uB1","../component/Label":"feVPQ","../util/DataUtils":"lNZEj","../util/types":"9qdl2","./getTicks":"lESsH","../util/svgPropertiesNoEvents":"2NZlZ","../util/YAxisUtils":"kxZIM","../util/resolveDefaultProps":"cWUqx","../zIndex/ZIndexLayer":"6RR5t","../zIndex/DefaultZIndexes":"h8nlV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ctc59":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Layer", ()=>Layer);
var _react = require("react");
var _clsx = require("clsx");
var _svgPropertiesAndEvents = require("../util/svgPropertiesAndEvents");
var _excluded = [
    "children",
    "className"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Layer = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    var { children, className } = props, others = _objectWithoutProperties(props, _excluded);
    var layerClass = (0, _clsx.clsx)('recharts-layer', className);
    return /*#__PURE__*/ _react.createElement("g", _extends({
        className: layerClass
    }, (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(others), {
        ref: ref
    }), children);
});

},{"react":"bmhQu","clsx":"431Ou","../util/svgPropertiesAndEvents":"6bogn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6bogn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Filters an object to only include SVG properties, data attributes, and event handlers.
 * @param obj - The object to filter.
 * @returns A new object containing only valid SVG properties, data attributes, and event handlers.
 */ parcelHelpers.export(exports, "svgPropertiesAndEvents", ()=>svgPropertiesAndEvents);
/**
 * Function to filter SVG properties from various input types.
 * The input types can be:
 * - A record of string keys to any values, in which case it returns a record of only SVG properties
 * - A React element, in which case it returns the props of the element filtered to only SVG properties
 * - Anything else, in which case it returns null
 *
 * This function has a wide-open return type, because it will read and filter the props of an arbitrary React element.
 * This can be SVG, HTML, whatnot, with arbitrary values, so we can't type it more specifically.
 *
 * If you wish to have a type-safe version, use svgPropertiesNoEvents directly with a typed object.
 *
 * @param input - The input to filter, which can be a record, a React element, or other types.
 * @returns A record of SVG properties if the input is a record or React element, otherwise null.
 */ parcelHelpers.export(exports, "svgPropertiesAndEventsFromUnknown", ()=>svgPropertiesAndEventsFromUnknown);
var _react = require("react");
var _excludeEventProps = require("./excludeEventProps");
var _svgPropertiesNoEvents = require("./svgPropertiesNoEvents");
function svgPropertiesAndEvents(obj) {
    var result = {};
    // for ... in loop is 10x faster than Object.entries + filter + Object.fromEntries in Chrome
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if ((0, _svgPropertiesNoEvents.isSvgElementPropKey)(key) || (0, _svgPropertiesNoEvents.isDataAttribute)(key) || (0, _excludeEventProps.isEventKey)(key)) result[key] = obj[key];
        }
    }
    return result;
}
function svgPropertiesAndEventsFromUnknown(input) {
    if (input == null) return null;
    if (/*#__PURE__*/ (0, _react.isValidElement)(input)) // @ts-expect-error we can't type this better because input can be any React element
    return svgPropertiesAndEvents(input.props);
    if (typeof input === 'object' && !Array.isArray(input)) return svgPropertiesAndEvents(input);
    return null;
}

},{"react":"bmhQu","./excludeEventProps":"4mRNj","./svgPropertiesNoEvents":"2NZlZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4mRNj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isEventKey", ()=>isEventKey);
var EventKeys = [
    'dangerouslySetInnerHTML',
    'onCopy',
    'onCopyCapture',
    'onCut',
    'onCutCapture',
    'onPaste',
    'onPasteCapture',
    'onCompositionEnd',
    'onCompositionEndCapture',
    'onCompositionStart',
    'onCompositionStartCapture',
    'onCompositionUpdate',
    'onCompositionUpdateCapture',
    'onFocus',
    'onFocusCapture',
    'onBlur',
    'onBlurCapture',
    'onChange',
    'onChangeCapture',
    'onBeforeInput',
    'onBeforeInputCapture',
    'onInput',
    'onInputCapture',
    'onReset',
    'onResetCapture',
    'onSubmit',
    'onSubmitCapture',
    'onInvalid',
    'onInvalidCapture',
    'onLoad',
    'onLoadCapture',
    'onError',
    'onErrorCapture',
    'onKeyDown',
    'onKeyDownCapture',
    'onKeyPress',
    'onKeyPressCapture',
    'onKeyUp',
    'onKeyUpCapture',
    'onAbort',
    'onAbortCapture',
    'onCanPlay',
    'onCanPlayCapture',
    'onCanPlayThrough',
    'onCanPlayThroughCapture',
    'onDurationChange',
    'onDurationChangeCapture',
    'onEmptied',
    'onEmptiedCapture',
    'onEncrypted',
    'onEncryptedCapture',
    'onEnded',
    'onEndedCapture',
    'onLoadedData',
    'onLoadedDataCapture',
    'onLoadedMetadata',
    'onLoadedMetadataCapture',
    'onLoadStart',
    'onLoadStartCapture',
    'onPause',
    'onPauseCapture',
    'onPlay',
    'onPlayCapture',
    'onPlaying',
    'onPlayingCapture',
    'onProgress',
    'onProgressCapture',
    'onRateChange',
    'onRateChangeCapture',
    'onSeeked',
    'onSeekedCapture',
    'onSeeking',
    'onSeekingCapture',
    'onStalled',
    'onStalledCapture',
    'onSuspend',
    'onSuspendCapture',
    'onTimeUpdate',
    'onTimeUpdateCapture',
    'onVolumeChange',
    'onVolumeChangeCapture',
    'onWaiting',
    'onWaitingCapture',
    'onAuxClick',
    'onAuxClickCapture',
    'onClick',
    'onClickCapture',
    'onContextMenu',
    'onContextMenuCapture',
    'onDoubleClick',
    'onDoubleClickCapture',
    'onDrag',
    'onDragCapture',
    'onDragEnd',
    'onDragEndCapture',
    'onDragEnter',
    'onDragEnterCapture',
    'onDragExit',
    'onDragExitCapture',
    'onDragLeave',
    'onDragLeaveCapture',
    'onDragOver',
    'onDragOverCapture',
    'onDragStart',
    'onDragStartCapture',
    'onDrop',
    'onDropCapture',
    'onMouseDown',
    'onMouseDownCapture',
    'onMouseEnter',
    'onMouseLeave',
    'onMouseMove',
    'onMouseMoveCapture',
    'onMouseOut',
    'onMouseOutCapture',
    'onMouseOver',
    'onMouseOverCapture',
    'onMouseUp',
    'onMouseUpCapture',
    'onSelect',
    'onSelectCapture',
    'onTouchCancel',
    'onTouchCancelCapture',
    'onTouchEnd',
    'onTouchEndCapture',
    'onTouchMove',
    'onTouchMoveCapture',
    'onTouchStart',
    'onTouchStartCapture',
    'onPointerDown',
    'onPointerDownCapture',
    'onPointerMove',
    'onPointerMoveCapture',
    'onPointerUp',
    'onPointerUpCapture',
    'onPointerCancel',
    'onPointerCancelCapture',
    'onPointerEnter',
    'onPointerEnterCapture',
    'onPointerLeave',
    'onPointerLeaveCapture',
    'onPointerOver',
    'onPointerOverCapture',
    'onPointerOut',
    'onPointerOutCapture',
    'onGotPointerCapture',
    'onGotPointerCaptureCapture',
    'onLostPointerCapture',
    'onLostPointerCaptureCapture',
    'onScroll',
    'onScrollCapture',
    'onWheel',
    'onWheelCapture',
    'onAnimationStart',
    'onAnimationStartCapture',
    'onAnimationEnd',
    'onAnimationEndCapture',
    'onAnimationIteration',
    'onAnimationIterationCapture',
    'onTransitionEnd',
    'onTransitionEndCapture'
];
function isEventKey(key) {
    if (typeof key !== 'string') return false;
    var allowedEventKeys = EventKeys;
    return allowedEventKeys.includes(key);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2NZlZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isSvgElementPropKey", ()=>isSvgElementPropKey);
/**
 * Checks if the property is a data attribute.
 * @param key The property key.
 * @returns True if the key starts with 'data-', false otherwise.
 */ parcelHelpers.export(exports, "isDataAttribute", ()=>isDataAttribute);
/**
 * Filters an object to only include SVG properties. Removes all event handlers too.
 * @param obj - The object to filter
 * @returns A new object containing only valid SVG properties, excluding event handlers.
 */ parcelHelpers.export(exports, "svgPropertiesNoEvents", ()=>svgPropertiesNoEvents);
/**
 * Function to filter SVG properties from various input types.
 * The input types can be:
 * - A record of string keys to any values, in which case it returns a record of only SVG properties
 * - A React element, in which case it returns the props of the element filtered to only SVG properties
 * - Anything else, in which case it returns null
 *
 * This function has a wide-open return type, because it will read and filter the props of an arbitrary React element.
 * This can be SVG, HTML, whatnot, with arbitrary values, so we can't type it more specifically.
 *
 * If you wish to have a type-safe version, use svgPropertiesNoEvents directly with a typed object.
 *
 * @param input - The input to filter, which can be a record, a React element, or other types.
 * @returns A record of SVG properties if the input is a record or React element, otherwise null.
 */ parcelHelpers.export(exports, "svgPropertiesNoEventsFromUnknown", ()=>svgPropertiesNoEventsFromUnknown);
var _react = require("react");
var SVGElementPropKeys = [
    'aria-activedescendant',
    'aria-atomic',
    'aria-autocomplete',
    'aria-busy',
    'aria-checked',
    'aria-colcount',
    'aria-colindex',
    'aria-colspan',
    'aria-controls',
    'aria-current',
    'aria-describedby',
    'aria-details',
    'aria-disabled',
    'aria-errormessage',
    'aria-expanded',
    'aria-flowto',
    'aria-haspopup',
    'aria-hidden',
    'aria-invalid',
    'aria-keyshortcuts',
    'aria-label',
    'aria-labelledby',
    'aria-level',
    'aria-live',
    'aria-modal',
    'aria-multiline',
    'aria-multiselectable',
    'aria-orientation',
    'aria-owns',
    'aria-placeholder',
    'aria-posinset',
    'aria-pressed',
    'aria-readonly',
    'aria-relevant',
    'aria-required',
    'aria-roledescription',
    'aria-rowcount',
    'aria-rowindex',
    'aria-rowspan',
    'aria-selected',
    'aria-setsize',
    'aria-sort',
    'aria-valuemax',
    'aria-valuemin',
    'aria-valuenow',
    'aria-valuetext',
    'className',
    'color',
    'height',
    'id',
    'lang',
    'max',
    'media',
    'method',
    'min',
    'name',
    'style',
    /*
 * removed 'type' SVGElementPropKey because we do not currently use any SVG elements
 * that can use it, and it conflicts with the recharts prop 'type'
 * https://github.com/recharts/recharts/pull/3327
 * https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/type
 */ // 'type',
    'target',
    'width',
    'role',
    'tabIndex',
    'accentHeight',
    'accumulate',
    'additive',
    'alignmentBaseline',
    'allowReorder',
    'alphabetic',
    'amplitude',
    'arabicForm',
    'ascent',
    'attributeName',
    'attributeType',
    'autoReverse',
    'azimuth',
    'baseFrequency',
    'baselineShift',
    'baseProfile',
    'bbox',
    'begin',
    'bias',
    'by',
    'calcMode',
    'capHeight',
    'clip',
    'clipPath',
    'clipPathUnits',
    'clipRule',
    'colorInterpolation',
    'colorInterpolationFilters',
    'colorProfile',
    'colorRendering',
    'contentScriptType',
    'contentStyleType',
    'cursor',
    'cx',
    'cy',
    'd',
    'decelerate',
    'descent',
    'diffuseConstant',
    'direction',
    'display',
    'divisor',
    'dominantBaseline',
    'dur',
    'dx',
    'dy',
    'edgeMode',
    'elevation',
    'enableBackground',
    'end',
    'exponent',
    'externalResourcesRequired',
    'fill',
    'fillOpacity',
    'fillRule',
    'filter',
    'filterRes',
    'filterUnits',
    'floodColor',
    'floodOpacity',
    'focusable',
    'fontFamily',
    'fontSize',
    'fontSizeAdjust',
    'fontStretch',
    'fontStyle',
    'fontVariant',
    'fontWeight',
    'format',
    'from',
    'fx',
    'fy',
    'g1',
    'g2',
    'glyphName',
    'glyphOrientationHorizontal',
    'glyphOrientationVertical',
    'glyphRef',
    'gradientTransform',
    'gradientUnits',
    'hanging',
    'horizAdvX',
    'horizOriginX',
    'href',
    'ideographic',
    'imageRendering',
    'in2',
    'in',
    'intercept',
    'k1',
    'k2',
    'k3',
    'k4',
    'k',
    'kernelMatrix',
    'kernelUnitLength',
    'kerning',
    'keyPoints',
    'keySplines',
    'keyTimes',
    'lengthAdjust',
    'letterSpacing',
    'lightingColor',
    'limitingConeAngle',
    'local',
    'markerEnd',
    'markerHeight',
    'markerMid',
    'markerStart',
    'markerUnits',
    'markerWidth',
    'mask',
    'maskContentUnits',
    'maskUnits',
    'mathematical',
    'mode',
    'numOctaves',
    'offset',
    'opacity',
    'operator',
    'order',
    'orient',
    'orientation',
    'origin',
    'overflow',
    'overlinePosition',
    'overlineThickness',
    'paintOrder',
    'panose1',
    'pathLength',
    'patternContentUnits',
    'patternTransform',
    'patternUnits',
    'pointerEvents',
    'pointsAtX',
    'pointsAtY',
    'pointsAtZ',
    'preserveAlpha',
    'preserveAspectRatio',
    'primitiveUnits',
    'r',
    'radius',
    'refX',
    'refY',
    'renderingIntent',
    'repeatCount',
    'repeatDur',
    'requiredExtensions',
    'requiredFeatures',
    'restart',
    'result',
    'rotate',
    'rx',
    'ry',
    'seed',
    'shapeRendering',
    'slope',
    'spacing',
    'specularConstant',
    'specularExponent',
    'speed',
    'spreadMethod',
    'startOffset',
    'stdDeviation',
    'stemh',
    'stemv',
    'stitchTiles',
    'stopColor',
    'stopOpacity',
    'strikethroughPosition',
    'strikethroughThickness',
    'string',
    'stroke',
    'strokeDasharray',
    'strokeDashoffset',
    'strokeLinecap',
    'strokeLinejoin',
    'strokeMiterlimit',
    'strokeOpacity',
    'strokeWidth',
    'surfaceScale',
    'systemLanguage',
    'tableValues',
    'targetX',
    'targetY',
    'textAnchor',
    'textDecoration',
    'textLength',
    'textRendering',
    'to',
    'transform',
    'u1',
    'u2',
    'underlinePosition',
    'underlineThickness',
    'unicode',
    'unicodeBidi',
    'unicodeRange',
    'unitsPerEm',
    'vAlphabetic',
    'values',
    'vectorEffect',
    'version',
    'vertAdvY',
    'vertOriginX',
    'vertOriginY',
    'vHanging',
    'vIdeographic',
    'viewTarget',
    'visibility',
    'vMathematical',
    'widths',
    'wordSpacing',
    'writingMode',
    'x1',
    'x2',
    'x',
    'xChannelSelector',
    'xHeight',
    'xlinkActuate',
    'xlinkArcrole',
    'xlinkHref',
    'xlinkRole',
    'xlinkShow',
    'xlinkTitle',
    'xlinkType',
    'xmlBase',
    'xmlLang',
    'xmlns',
    'xmlnsXlink',
    'xmlSpace',
    'y1',
    'y2',
    'y',
    'yChannelSelector',
    'z',
    'zoomAndPan',
    'ref',
    'key',
    'angle'
];
var SVGElementPropKeySet = new Set(SVGElementPropKeys);
function isSvgElementPropKey(key) {
    if (typeof key !== 'string') return false;
    return SVGElementPropKeySet.has(key);
}
function isDataAttribute(key) {
    return typeof key === 'string' && key.startsWith('data-');
}
function svgPropertiesNoEvents(obj) {
    if (typeof obj !== 'object' || obj === null) return {};
    var result = {};
    for(var key in obj){
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (isSvgElementPropKey(key) || isDataAttribute(key)) result[key] = obj[key];
        }
    }
    return result;
}
function svgPropertiesNoEventsFromUnknown(input) {
    if (input == null) return null;
    if (/*#__PURE__*/ (0, _react.isValidElement)(input) && typeof input.props === 'object' && input.props !== null) {
        var p = input.props;
        return svgPropertiesNoEvents(p);
    }
    if (typeof input === 'object' && !Array.isArray(input)) return svgPropertiesNoEvents(input);
    return null;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a7uB1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @inline
 */ parcelHelpers.export(exports, "isValidTextAnchor", ()=>isValidTextAnchor);
parcelHelpers.export(exports, "getWordsByLines", ()=>getWordsByLines);
parcelHelpers.export(exports, "textDefaultProps", ()=>textDefaultProps);
parcelHelpers.export(exports, "Text", ()=>Text);
var _react = require("react");
var _clsx = require("clsx");
var _dataUtils = require("../util/DataUtils");
var _global = require("../util/Global");
var _domutils = require("../util/DOMUtils");
var _reduceCSSCalc = require("../util/ReduceCSSCalc");
var _svgPropertiesAndEvents = require("../util/svgPropertiesAndEvents");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
var _isWellBehavedNumber = require("../util/isWellBehavedNumber");
var _excluded = [
    "x",
    "y",
    "lineHeight",
    "capHeight",
    "fill",
    "scaleToFit",
    "textAnchor",
    "verticalAnchor"
], _excluded2 = [
    "dx",
    "dy",
    "angle",
    "className",
    "breakAll"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var BREAKING_SPACES = /[ \f\n\r\t\v\u2028\u2029]+/;
var calculateWordWidths = (_ref)=>{
    var { children, breakAll, style } = _ref;
    try {
        var words = [];
        if (!(0, _dataUtils.isNullish)(children)) {
            if (breakAll) words = children.toString().split('');
            else words = children.toString().split(BREAKING_SPACES);
        }
        var wordsWithComputedWidth = words.map((word)=>({
                word,
                width: (0, _domutils.getStringSize)(word, style).width
            }));
        var spaceWidth = breakAll ? 0 : (0, _domutils.getStringSize)('\u00A0', style).width;
        return {
            wordsWithComputedWidth,
            spaceWidth
        };
    } catch (_unused) {
        return null;
    }
};
function isValidTextAnchor(value) {
    return value === 'start' || value === 'middle' || value === 'end' || value === 'inherit';
}
/**
 * @inline
 */ /**
 * @inline
 */ var calculate = (words, lineWidth, spaceWidth, scaleToFit)=>words.reduce((result, _ref2)=>{
        var { word, width } = _ref2;
        var currentLine = result[result.length - 1];
        if (currentLine && width != null && (lineWidth == null || scaleToFit || currentLine.width + width + spaceWidth < Number(lineWidth))) {
            // Word can be added to an existing line
            currentLine.words.push(word);
            currentLine.width += width + spaceWidth;
        } else {
            // Add first word to line or word is too long to scaleToFit on existing line
            var newLine = {
                words: [
                    word
                ],
                width
            };
            result.push(newLine);
        }
        return result;
    }, []);
var findLongestLine = (words)=>words.reduce((a, b)=>a.width > b.width ? a : b);
var suffix = "\u2026";
var checkOverflow = (text, index, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit)=>{
    var tempText = text.slice(0, index);
    var words = calculateWordWidths({
        breakAll,
        style,
        children: tempText + suffix
    });
    if (!words) return [
        false,
        []
    ];
    var result = calculate(words.wordsWithComputedWidth, lineWidth, spaceWidth, scaleToFit);
    var doesOverflow = result.length > maxLines || findLongestLine(result).width > Number(lineWidth);
    return [
        doesOverflow,
        result
    ];
};
var calculateWordsByLines = (_ref3, initialWordsWithComputedWith, spaceWidth, lineWidth, scaleToFit)=>{
    var { maxLines, children, style, breakAll } = _ref3;
    var shouldLimitLines = (0, _dataUtils.isNumber)(maxLines);
    var text = String(children);
    var originalResult = calculate(initialWordsWithComputedWith, lineWidth, spaceWidth, scaleToFit);
    if (!shouldLimitLines || scaleToFit) return originalResult;
    var overflows = originalResult.length > maxLines || findLongestLine(originalResult).width > Number(lineWidth);
    if (!overflows) return originalResult;
    var start = 0;
    var end = text.length - 1;
    var iterations = 0;
    var trimmedResult;
    while(start <= end && iterations <= text.length - 1){
        var middle = Math.floor((start + end) / 2);
        var prev = middle - 1;
        var [doesPrevOverflow, result] = checkOverflow(text, prev, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit);
        var [doesMiddleOverflow] = checkOverflow(text, middle, breakAll, style, maxLines, lineWidth, spaceWidth, scaleToFit);
        if (!doesPrevOverflow && !doesMiddleOverflow) start = middle + 1;
        if (doesPrevOverflow && doesMiddleOverflow) end = middle - 1;
        if (!doesPrevOverflow && doesMiddleOverflow) {
            trimmedResult = result;
            break;
        }
        iterations++;
    }
    // Fallback to originalResult (result without trimming) if we cannot find the
    // where to trim.  This should not happen :tm:
    return trimmedResult || originalResult;
};
var getWordsWithoutCalculate = (children)=>{
    var words = !(0, _dataUtils.isNullish)(children) ? children.toString().split(BREAKING_SPACES) : [];
    return [
        {
            words,
            width: undefined
        }
    ];
};
var getWordsByLines = (_ref4)=>{
    var { width, scaleToFit, children, style, breakAll, maxLines } = _ref4;
    // Only perform calculations if using features that require them (multiline, scaleToFit)
    if ((width || scaleToFit) && !(0, _global.Global).isSsr) {
        var wordsWithComputedWidth, spaceWidth;
        var wordWidths = calculateWordWidths({
            breakAll,
            children,
            style
        });
        if (wordWidths) {
            var { wordsWithComputedWidth: wcw, spaceWidth: sw } = wordWidths;
            wordsWithComputedWidth = wcw;
            spaceWidth = sw;
        } else return getWordsWithoutCalculate(children);
        return calculateWordsByLines({
            breakAll,
            children,
            maxLines,
            style
        }, wordsWithComputedWidth, spaceWidth, width, Boolean(scaleToFit));
    }
    return getWordsWithoutCalculate(children);
};
var DEFAULT_FILL = '#808080';
var textDefaultProps = {
    angle: 0,
    breakAll: false,
    // Magic number from d3
    capHeight: '0.71em',
    fill: DEFAULT_FILL,
    lineHeight: '1em',
    scaleToFit: false,
    textAnchor: 'start',
    // Maintain compat with existing charts / default SVG behavior
    verticalAnchor: 'end',
    x: 0,
    y: 0
};
var Text = /*#__PURE__*/ (0, _react.forwardRef)((outsideProps, ref)=>{
    var _resolveDefaultProps1 = (0, _resolveDefaultProps.resolveDefaultProps)(outsideProps, textDefaultProps), { x: propsX, y: propsY, lineHeight, capHeight, fill, scaleToFit, textAnchor, verticalAnchor } = _resolveDefaultProps1, props = _objectWithoutProperties(_resolveDefaultProps1, _excluded);
    var wordsByLines = (0, _react.useMemo)(()=>{
        return getWordsByLines({
            breakAll: props.breakAll,
            children: props.children,
            maxLines: props.maxLines,
            scaleToFit,
            style: props.style,
            width: props.width
        });
    }, [
        props.breakAll,
        props.children,
        props.maxLines,
        scaleToFit,
        props.style,
        props.width
    ]);
    var { dx, dy, angle, className, breakAll } = props, textProps = _objectWithoutProperties(props, _excluded2);
    if (!(0, _dataUtils.isNumOrStr)(propsX) || !(0, _dataUtils.isNumOrStr)(propsY) || wordsByLines.length === 0) return null;
    var x = Number(propsX) + ((0, _dataUtils.isNumber)(dx) ? dx : 0);
    var y = Number(propsY) + ((0, _dataUtils.isNumber)(dy) ? dy : 0);
    if (!(0, _isWellBehavedNumber.isWellBehavedNumber)(x) || !(0, _isWellBehavedNumber.isWellBehavedNumber)(y)) return null;
    var startDy;
    switch(verticalAnchor){
        case 'start':
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat(capHeight, ")"));
            break;
        case 'middle':
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat((wordsByLines.length - 1) / 2, " * -").concat(lineHeight, " + (").concat(capHeight, " / 2))"));
            break;
        default:
            startDy = (0, _reduceCSSCalc.reduceCSSCalc)("calc(".concat(wordsByLines.length - 1, " * -").concat(lineHeight, ")"));
            break;
    }
    var transforms = [];
    if (scaleToFit) {
        var lineWidth = wordsByLines[0].width;
        var { width } = props;
        transforms.push("scale(".concat((0, _dataUtils.isNumber)(width) && (0, _dataUtils.isNumber)(lineWidth) ? width / lineWidth : 1, ")"));
    }
    if (angle) transforms.push("rotate(".concat(angle, ", ").concat(x, ", ").concat(y, ")"));
    if (transforms.length) textProps.transform = transforms.join(' ');
    return /*#__PURE__*/ _react.createElement("text", _extends({}, (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(textProps), {
        ref: ref,
        x: x,
        y: y,
        className: (0, _clsx.clsx)('recharts-text', className),
        textAnchor: textAnchor,
        fill: fill.includes('url') ? DEFAULT_FILL : fill
    }), wordsByLines.map((line, index)=>{
        var words = line.words.join(breakAll ? '' : ' ');
        return(/*#__PURE__*/ // duplicate words will cause duplicate keys which is why we add the array index here
        _react.createElement("tspan", {
            x: x,
            dy: index === 0 ? startDy : lineHeight,
            key: "".concat(words, "-").concat(index)
        }, words));
    }));
});
Text.displayName = 'Text';

},{"react":"bmhQu","clsx":"431Ou","../util/DataUtils":"lNZEj","../util/Global":"7wpBp","../util/DOMUtils":"7zgY9","../util/ReduceCSSCalc":"jBF7r","../util/svgPropertiesAndEvents":"6bogn","../util/resolveDefaultProps":"cWUqx","../util/isWellBehavedNumber":"aIsFR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jBF7r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "safeEvaluateExpression", ()=>safeEvaluateExpression);
parcelHelpers.export(exports, "reduceCSSCalc", ()=>reduceCSSCalc);
var _dataUtils = require("./DataUtils");
var _DecimalCSS;
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var MULTIPLY_OR_DIVIDE_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([*/])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var ADD_OR_SUBTRACT_REGEX = /(-?\d+(?:\.\d+)?[a-zA-Z%]*)([+-])(-?\d+(?:\.\d+)?[a-zA-Z%]*)/;
var CSS_LENGTH_UNIT_REGEX = /^px|cm|vh|vw|em|rem|%|mm|in|pt|pc|ex|ch|vmin|vmax|Q$/;
var NUM_SPLIT_REGEX = /(-?\d+(?:\.\d+)?)([a-zA-Z%]+)?/;
var CONVERSION_RATES = {
    cm: 96 / 2.54,
    mm: 96 / 25.4,
    pt: 96 / 72,
    pc: 16,
    in: 96,
    Q: 96 / 101.6,
    px: 1
};
var FIXED_CSS_LENGTH_UNITS = [
    'cm',
    'mm',
    'pt',
    'pc',
    'in',
    'Q',
    'px'
];
function isSupportedUnit(unit) {
    return FIXED_CSS_LENGTH_UNITS.includes(unit);
}
var STR_NAN = 'NaN';
function convertToPx(value, unit) {
    return value * CONVERSION_RATES[unit];
}
class DecimalCSS {
    static parse(str) {
        var _NUM_SPLIT_REGEX$exec;
        var [, numStr, unit] = (_NUM_SPLIT_REGEX$exec = NUM_SPLIT_REGEX.exec(str)) !== null && _NUM_SPLIT_REGEX$exec !== void 0 ? _NUM_SPLIT_REGEX$exec : [];
        if (numStr == null) return DecimalCSS.NaN;
        return new DecimalCSS(parseFloat(numStr), unit !== null && unit !== void 0 ? unit : '');
    }
    constructor(num, unit){
        this.num = num;
        this.unit = unit;
        this.num = num;
        this.unit = unit;
        if ((0, _dataUtils.isNan)(num)) this.unit = '';
        if (unit !== '' && !CSS_LENGTH_UNIT_REGEX.test(unit)) {
            this.num = NaN;
            this.unit = '';
        }
        if (isSupportedUnit(unit)) {
            this.num = convertToPx(num, unit);
            this.unit = 'px';
        }
    }
    add(other) {
        if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
        return new DecimalCSS(this.num + other.num, this.unit);
    }
    subtract(other) {
        if (this.unit !== other.unit) return new DecimalCSS(NaN, '');
        return new DecimalCSS(this.num - other.num, this.unit);
    }
    multiply(other) {
        if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
        return new DecimalCSS(this.num * other.num, this.unit || other.unit);
    }
    divide(other) {
        if (this.unit !== '' && other.unit !== '' && this.unit !== other.unit) return new DecimalCSS(NaN, '');
        return new DecimalCSS(this.num / other.num, this.unit || other.unit);
    }
    toString() {
        return "".concat(this.num).concat(this.unit);
    }
    isNaN() {
        return (0, _dataUtils.isNan)(this.num);
    }
}
_DecimalCSS = DecimalCSS;
_defineProperty(DecimalCSS, "NaN", new _DecimalCSS(NaN, ''));
function calculateArithmetic(expr) {
    if (expr == null || expr.includes(STR_NAN)) return STR_NAN;
    var newExpr = expr;
    while(newExpr.includes('*') || newExpr.includes('/')){
        var _MULTIPLY_OR_DIVIDE_R;
        var [, leftOperand, operator, rightOperand] = (_MULTIPLY_OR_DIVIDE_R = MULTIPLY_OR_DIVIDE_REGEX.exec(newExpr)) !== null && _MULTIPLY_OR_DIVIDE_R !== void 0 ? _MULTIPLY_OR_DIVIDE_R : [];
        var lTs = DecimalCSS.parse(leftOperand !== null && leftOperand !== void 0 ? leftOperand : '');
        var rTs = DecimalCSS.parse(rightOperand !== null && rightOperand !== void 0 ? rightOperand : '');
        var result = operator === '*' ? lTs.multiply(rTs) : lTs.divide(rTs);
        if (result.isNaN()) return STR_NAN;
        newExpr = newExpr.replace(MULTIPLY_OR_DIVIDE_REGEX, result.toString());
    }
    while(newExpr.includes('+') || /.-\d+(?:\.\d+)?/.test(newExpr)){
        var _ADD_OR_SUBTRACT_REGE;
        var [, _leftOperand, _operator, _rightOperand] = (_ADD_OR_SUBTRACT_REGE = ADD_OR_SUBTRACT_REGEX.exec(newExpr)) !== null && _ADD_OR_SUBTRACT_REGE !== void 0 ? _ADD_OR_SUBTRACT_REGE : [];
        var _lTs = DecimalCSS.parse(_leftOperand !== null && _leftOperand !== void 0 ? _leftOperand : '');
        var _rTs = DecimalCSS.parse(_rightOperand !== null && _rightOperand !== void 0 ? _rightOperand : '');
        var _result = _operator === '+' ? _lTs.add(_rTs) : _lTs.subtract(_rTs);
        if (_result.isNaN()) return STR_NAN;
        newExpr = newExpr.replace(ADD_OR_SUBTRACT_REGEX, _result.toString());
    }
    return newExpr;
}
var PARENTHESES_REGEX = /\(([^()]*)\)/;
function calculateParentheses(expr) {
    var newExpr = expr;
    var match;
    // eslint-disable-next-line no-cond-assign
    while((match = PARENTHESES_REGEX.exec(newExpr)) != null){
        var [, parentheticalExpression] = match;
        newExpr = newExpr.replace(PARENTHESES_REGEX, calculateArithmetic(parentheticalExpression));
    }
    return newExpr;
}
function evaluateExpression(expression) {
    var newExpr = expression.replace(/\s+/g, '');
    newExpr = calculateParentheses(newExpr);
    newExpr = calculateArithmetic(newExpr);
    return newExpr;
}
function safeEvaluateExpression(expression) {
    try {
        return evaluateExpression(expression);
    } catch (_unused) {
        return STR_NAN;
    }
}
function reduceCSSCalc(expression) {
    var result = safeEvaluateExpression(expression.slice(5, -1));
    if (result === STR_NAN) return '';
    return result;
}

},{"./DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cWUqx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This function mimics the behavior of the `defaultProps` static property in React.
 * Functional components do not have a defaultProps property, so this function is useful to resolve default props.
 *
 * The common recommendation is to use ES6 destructuring with default values in the function signature,
 * but you need to be careful there and make sure you destructure all the individual properties
 * and not the whole object. See the test file for example.
 *
 * And because destructuring all properties one by one is a faff, and it's easy to miss one property,
 * this function exists.
 *
 * @param realProps - the props object passed to the component by the user
 * @param defaultProps - the default props object defined in the component by Recharts
 * @returns - the props object with all the default props resolved. All `undefined` values are replaced with the default value.
 */ parcelHelpers.export(exports, "resolveDefaultProps", ()=>resolveDefaultProps) /**
 * Helper type to extract the keys of T that are required.
 * It iterates through each key K in T. If Pick<T, K> cannot be assigned an empty object {},
 * it means K is required, so we keep K; otherwise, we discard it (never).
 * [keyof T] at the end creates a union of the kept keys.
 */  /**
 * Helper type to extract the keys of T that are optional.
 * It iterates through each key K in T. If Pick<T, K> can be assigned an empty object {},
 * it means K is optional (or potentially missing), so we keep K; otherwise, we discard it (never).
 * [keyof T] at the end creates a union of the kept keys.
 */  /**
 * Helper type to ensure keys of D exist in T.
 * For each key K in D, if K is also a key of T, keep the type D[K].
 * If K is NOT a key of T, map it to type `never`.
 * An object cannot have a property of type `never`, effectively disallowing extra keys.
 */  /**
 * This type will take a source type `Props` and a default type `Defaults` and will return a new type
 * where all properties that are optional in `Props` but required in `Defaults` are made required in the result.
 * Properties that are required in `Props` and optional in `Defaults` will remain required.
 * Properties that are optional in both `Props` and `Defaults` will remain optional.
 *
 * This is useful for creating a type that represents the resolved props of a component with default props.
 */ ;
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function resolveDefaultProps(realProps, defaultProps) {
    /*
   * To avoid mutating the original `realProps` object passed to the function, create a shallow copy of it.
   * `resolvedProps` will be modified directly with the defaults.
   */ var resolvedProps = _objectSpread({}, realProps);
    /*
   * Since the function guarantees `D extends Partial<T>`, this assignment is safe.
   * It allows TypeScript to work with the well-defined `Partial<T>` type inside the loop,
   * making subsequent type inference (especially for `dp[key]`) much more straightforward for the compiler.
   * This is a key step to improve type safety *without* value assertions later.
   */ var dp = defaultProps;
    /*
   * `Object.keys` doesn't preserve strong key types - it always returns Array<string>.
   * However, due to the `D extends Partial<T>` constraint,
   * we know these keys *must* also be valid keys of `T`.
   * This assertion informs TypeScript of this relationship, avoiding type errors when using `key` to index `acc` (type T).
   *
   * Type assertions are not sound but in this case it's necessary
   * as `Object.keys` does not do what we want it to do.
   */ var keys = Object.keys(defaultProps);
    var withDefaults = keys.reduce((acc, key)=>{
        if (acc[key] === undefined && dp[key] !== undefined) acc[key] = dp[key];
        return acc;
    }, resolvedProps);
    /*
   * And again type assertions are not safe but here we have done the runtime work
   * so let's bypass the lack of static type safety and tell the compiler what happened.
   */ return withDefaults;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"feVPQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartesianLabelContextProvider", ()=>CartesianLabelContextProvider);
parcelHelpers.export(exports, "PolarLabelContextProvider", ()=>PolarLabelContextProvider);
parcelHelpers.export(exports, "usePolarLabelContext", ()=>usePolarLabelContext);
parcelHelpers.export(exports, "isLabelContentAFunction", ()=>isLabelContentAFunction);
parcelHelpers.export(exports, "getAttrsOfCartesianLabel", ()=>getAttrsOfCartesianLabel);
parcelHelpers.export(exports, "defaultLabelProps", ()=>defaultLabelProps);
/**
 * @consumes CartesianViewBoxContext
 * @consumes PolarViewBoxContext
 * @consumes CartesianLabelContext
 * @consumes PolarLabelContext
 */ parcelHelpers.export(exports, "Label", ()=>Label);
parcelHelpers.export(exports, "CartesianLabelFromLabelProp", ()=>CartesianLabelFromLabelProp);
parcelHelpers.export(exports, "PolarLabelFromLabelProp", ()=>PolarLabelFromLabelProp);
var _react = require("react");
var _clsx = require("clsx");
var _text = require("./Text");
var _dataUtils = require("../util/DataUtils");
var _polarUtils = require("../util/PolarUtils");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _hooks = require("../state/hooks");
var _polarAxisSelectors = require("../state/selectors/polarAxisSelectors");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
var _svgPropertiesAndEvents = require("../util/svgPropertiesAndEvents");
var _zindexLayer = require("../zIndex/ZIndexLayer");
var _defaultZIndexes = require("../zIndex/DefaultZIndexes");
var _excluded = [
    "labelRef"
], _excluded2 = [
    "content"
];
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
/**
 * @inline
 */ /**
 * @inline
 */ /**
 * @inline
 */ var CartesianLabelContext = /*#__PURE__*/ (0, _react.createContext)(null);
var CartesianLabelContextProvider = (_ref)=>{
    var { x, y, upperWidth, lowerWidth, width, height, children } = _ref;
    var viewBox = (0, _react.useMemo)(()=>({
            x,
            y,
            upperWidth,
            lowerWidth,
            width,
            height
        }), [
        x,
        y,
        upperWidth,
        lowerWidth,
        width,
        height
    ]);
    return /*#__PURE__*/ _react.createElement(CartesianLabelContext.Provider, {
        value: viewBox
    }, children);
};
var useCartesianLabelContext = ()=>{
    var labelChildContext = (0, _react.useContext)(CartesianLabelContext);
    var chartContext = (0, _chartLayoutContext.useViewBox)();
    return labelChildContext || (0, _chartLayoutContext.cartesianViewBoxToTrapezoid)(chartContext);
};
var PolarLabelContext = /*#__PURE__*/ (0, _react.createContext)(null);
var PolarLabelContextProvider = (_ref2)=>{
    var { cx, cy, innerRadius, outerRadius, startAngle, endAngle, clockWise, children } = _ref2;
    var viewBox = (0, _react.useMemo)(()=>({
            cx,
            cy,
            innerRadius,
            outerRadius,
            startAngle,
            endAngle,
            clockWise
        }), [
        cx,
        cy,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        clockWise
    ]);
    return /*#__PURE__*/ _react.createElement(PolarLabelContext.Provider, {
        value: viewBox
    }, children);
};
var usePolarLabelContext = ()=>{
    var labelChildContext = (0, _react.useContext)(PolarLabelContext);
    var chartContext = (0, _hooks.useAppSelector)((0, _polarAxisSelectors.selectPolarViewBox));
    return labelChildContext || chartContext;
};
var getLabel = (props)=>{
    var { value, formatter } = props;
    var label = (0, _dataUtils.isNullish)(props.children) ? value : props.children;
    if (typeof formatter === 'function') return formatter(label);
    return label;
};
var isLabelContentAFunction = (content)=>{
    return content != null && typeof content === 'function';
};
var getDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 360);
    return sign * deltaAngle;
};
var renderRadialLabel = (labelProps, position, label, attrs, viewBox)=>{
    var { offset, className } = labelProps;
    var { cx, cy, innerRadius, outerRadius, startAngle, endAngle, clockWise } = viewBox;
    var radius = (innerRadius + outerRadius) / 2;
    var deltaAngle = getDeltaAngle(startAngle, endAngle);
    var sign = deltaAngle >= 0 ? 1 : -1;
    var labelAngle, direction;
    switch(position){
        case 'insideStart':
            labelAngle = startAngle + sign * offset;
            direction = clockWise;
            break;
        case 'insideEnd':
            labelAngle = endAngle - sign * offset;
            direction = !clockWise;
            break;
        case 'end':
            labelAngle = endAngle + sign * offset;
            direction = clockWise;
            break;
        default:
            throw new Error("Unsupported position ".concat(position));
    }
    direction = deltaAngle <= 0 ? direction : !direction;
    var startPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, labelAngle);
    var endPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, labelAngle + (direction ? 1 : -1) * 359);
    var path = "M".concat(startPoint.x, ",").concat(startPoint.y, "\n    A").concat(radius, ",").concat(radius, ",0,1,").concat(direction ? 0 : 1, ",\n    ").concat(endPoint.x, ",").concat(endPoint.y);
    var id = (0, _dataUtils.isNullish)(labelProps.id) ? (0, _dataUtils.uniqueId)('recharts-radial-line-') : labelProps.id;
    return /*#__PURE__*/ _react.createElement("text", _extends({}, attrs, {
        dominantBaseline: "central",
        className: (0, _clsx.clsx)('recharts-radial-bar-label', className)
    }), /*#__PURE__*/ _react.createElement("defs", null, /*#__PURE__*/ _react.createElement("path", {
        id: id,
        d: path
    })), /*#__PURE__*/ _react.createElement("textPath", {
        xlinkHref: "#".concat(id)
    }, label));
};
var getAttrsOfPolarLabel = (viewBox, offset, position)=>{
    var { cx, cy, innerRadius, outerRadius, startAngle, endAngle } = viewBox;
    var midAngle = (startAngle + endAngle) / 2;
    if (position === 'outside') {
        var { x: _x, y: _y } = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius + offset, midAngle);
        return {
            x: _x,
            y: _y,
            textAnchor: _x >= cx ? 'start' : 'end',
            verticalAnchor: 'middle'
        };
    }
    if (position === 'center') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
    if (position === 'centerTop') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'start'
    };
    if (position === 'centerBottom') return {
        x: cx,
        y: cy,
        textAnchor: 'middle',
        verticalAnchor: 'end'
    };
    var r = (innerRadius + outerRadius) / 2;
    var { x, y } = (0, _polarUtils.polarToCartesian)(cx, cy, r, midAngle);
    return {
        x,
        y,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    };
};
var isPolar = (viewBox)=>'cx' in viewBox && (0, _dataUtils.isNumber)(viewBox.cx);
var getAttrsOfCartesianLabel = (props, viewBox)=>{
    var { parentViewBox: parentViewBoxFromProps, offset, position } = props;
    var parentViewBox;
    if (parentViewBoxFromProps != null && !isPolar(parentViewBoxFromProps)) // Check that nobody is trying to pass a polar viewBox to a cartesian label
    parentViewBox = parentViewBoxFromProps;
    var { x, y, upperWidth, lowerWidth, height } = viewBox;
    // Funnel.tsx provides a viewBox where `x` is the top-left of the trapezoid shape.
    var upperX = x;
    // The trapezoid is centered, so we can calculate the other corners from the top-left.
    var lowerX = x + (upperWidth - lowerWidth) / 2;
    // middleX is the x-coordinate of the left edge at the vertical midpoint of the trapezoid.
    var middleX = (upperX + lowerX) / 2;
    // The width of the trapezoid at its vertical midpoint.
    var midHeightWidth = (upperWidth + lowerWidth) / 2;
    // The center x-coordinate is constant for the entire height of the trapezoid.
    var centerX = upperX + upperWidth / 2;
    // Define vertical offsets and position inverts based on the value being positive or negative.
    // This allows labels to be positioned correctly for bars with negative height.
    var verticalSign = height >= 0 ? 1 : -1;
    var verticalOffset = verticalSign * offset;
    var verticalEnd = verticalSign > 0 ? 'end' : 'start';
    var verticalStart = verticalSign > 0 ? 'start' : 'end';
    // Define horizontal offsets and position inverts based on the value being positive or negative.
    // This allows labels to be positioned correctly for bars with negative width.
    var horizontalSign = upperWidth >= 0 ? 1 : -1;
    var horizontalOffset = horizontalSign * offset;
    var horizontalEnd = horizontalSign > 0 ? 'end' : 'start';
    var horizontalStart = horizontalSign > 0 ? 'start' : 'end';
    if (position === 'top') {
        var attrs = {
            x: upperX + upperWidth / 2,
            y: y - verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalEnd
        };
        return _objectSpread(_objectSpread({}, attrs), parentViewBox ? {
            height: Math.max(y - parentViewBox.y, 0),
            width: upperWidth
        } : {});
    }
    if (position === 'bottom') {
        var _attrs = {
            x: lowerX + lowerWidth / 2,
            y: y + height + verticalOffset,
            textAnchor: 'middle',
            verticalAnchor: verticalStart
        };
        return _objectSpread(_objectSpread({}, _attrs), parentViewBox ? {
            height: Math.max(parentViewBox.y + parentViewBox.height - (y + height), 0),
            width: lowerWidth
        } : {});
    }
    if (position === 'left') {
        var _attrs2 = {
            x: middleX - horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalEnd,
            verticalAnchor: 'middle'
        };
        return _objectSpread(_objectSpread({}, _attrs2), parentViewBox ? {
            width: Math.max(_attrs2.x - parentViewBox.x, 0),
            height
        } : {});
    }
    if (position === 'right') {
        var _attrs3 = {
            x: middleX + midHeightWidth + horizontalOffset,
            y: y + height / 2,
            textAnchor: horizontalStart,
            verticalAnchor: 'middle'
        };
        return _objectSpread(_objectSpread({}, _attrs3), parentViewBox ? {
            width: Math.max(parentViewBox.x + parentViewBox.width - _attrs3.x, 0),
            height
        } : {});
    }
    var sizeAttrs = parentViewBox ? {
        width: midHeightWidth,
        height
    } : {};
    if (position === 'insideLeft') return _objectSpread({
        x: middleX + horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalStart,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideRight') return _objectSpread({
        x: middleX + midHeightWidth - horizontalOffset,
        y: y + height / 2,
        textAnchor: horizontalEnd,
        verticalAnchor: 'middle'
    }, sizeAttrs);
    if (position === 'insideTop') return _objectSpread({
        x: upperX + upperWidth / 2,
        y: y + verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottom') return _objectSpread({
        x: lowerX + lowerWidth / 2,
        y: y + height - verticalOffset,
        textAnchor: 'middle',
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideTopLeft') return _objectSpread({
        x: upperX + horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideTopRight') return _objectSpread({
        x: upperX + upperWidth - horizontalOffset,
        y: y + verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalStart
    }, sizeAttrs);
    if (position === 'insideBottomLeft') return _objectSpread({
        x: lowerX + horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalStart,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (position === 'insideBottomRight') return _objectSpread({
        x: lowerX + lowerWidth - horizontalOffset,
        y: y + height - verticalOffset,
        textAnchor: horizontalEnd,
        verticalAnchor: verticalEnd
    }, sizeAttrs);
    if (!!position && typeof position === 'object' && ((0, _dataUtils.isNumber)(position.x) || (0, _dataUtils.isPercent)(position.x)) && ((0, _dataUtils.isNumber)(position.y) || (0, _dataUtils.isPercent)(position.y))) // TODO: This is not quite right. The width of the trapezoid changes with y.
    // A percentage-based x should be relative to the width at that y.
    // For now, we use the mid-height width as a reasonable approximation.
    return _objectSpread({
        x: x + (0, _dataUtils.getPercentValue)(position.x, midHeightWidth),
        y: y + (0, _dataUtils.getPercentValue)(position.y, height),
        textAnchor: 'end',
        verticalAnchor: 'end'
    }, sizeAttrs);
    return _objectSpread({
        x: centerX,
        y: y + height / 2,
        textAnchor: 'middle',
        verticalAnchor: 'middle'
    }, sizeAttrs);
};
var defaultLabelProps = {
    angle: 0,
    offset: 5,
    zIndex: (0, _defaultZIndexes.DefaultZIndexes).label,
    position: 'middle',
    textBreakAll: false
};
function Label(outerProps) {
    var props = (0, _resolveDefaultProps.resolveDefaultProps)(outerProps, defaultLabelProps);
    var { viewBox: viewBoxFromProps, position, value, children, content, className = '', textBreakAll, labelRef } = props;
    var polarViewBox = usePolarLabelContext();
    var cartesianViewBox = useCartesianLabelContext();
    /*
   * I am not proud about this solution, but it's a quick fix for https://github.com/recharts/recharts/issues/6030#issuecomment-3155352460.
   * What we should really do is split Label into two components: CartesianLabel and PolarLabel and then handle their respective viewBoxes separately.
   * Also other components should set its own viewBox in a context so that we can fix https://github.com/recharts/recharts/issues/6156
   */ var resolvedViewBox = position === 'center' ? cartesianViewBox : polarViewBox !== null && polarViewBox !== void 0 ? polarViewBox : cartesianViewBox;
    var viewBox, label, positionAttrs;
    if (viewBoxFromProps == null) viewBox = resolvedViewBox;
    else if (isPolar(viewBoxFromProps)) viewBox = viewBoxFromProps;
    else viewBox = (0, _chartLayoutContext.cartesianViewBoxToTrapezoid)(viewBoxFromProps);
    if (!viewBox || (0, _dataUtils.isNullish)(value) && (0, _dataUtils.isNullish)(children) && !/*#__PURE__*/ (0, _react.isValidElement)(content) && typeof content !== 'function') return null;
    var propsWithViewBox = _objectSpread(_objectSpread({}, props), {}, {
        viewBox
    });
    if (/*#__PURE__*/ (0, _react.isValidElement)(content)) {
        var { labelRef: _ } = propsWithViewBox, propsWithoutLabelRef = _objectWithoutProperties(propsWithViewBox, _excluded);
        return /*#__PURE__*/ (0, _react.cloneElement)(content, propsWithoutLabelRef);
    }
    if (typeof content === 'function') {
        var { content: _2 } = propsWithViewBox, propsForContent = _objectWithoutProperties(propsWithViewBox, _excluded2);
        // @ts-expect-error we're not checking if the content component returns something that Text is able to render
        label = /*#__PURE__*/ (0, _react.createElement)(content, propsForContent);
        if (/*#__PURE__*/ (0, _react.isValidElement)(label)) return label;
    } else label = getLabel(props);
    var attrs = (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(props);
    if (isPolar(viewBox)) {
        if (position === 'insideStart' || position === 'insideEnd' || position === 'end') return renderRadialLabel(props, position, label, attrs, viewBox);
        positionAttrs = getAttrsOfPolarLabel(viewBox, props.offset, props.position);
    } else positionAttrs = getAttrsOfCartesianLabel(props, viewBox);
    return /*#__PURE__*/ _react.createElement((0, _zindexLayer.ZIndexLayer), {
        zIndex: props.zIndex
    }, /*#__PURE__*/ _react.createElement((0, _text.Text), _extends({
        ref: labelRef,
        className: (0, _clsx.clsx)('recharts-label', className)
    }, attrs, positionAttrs, {
        /*
     * textAnchor is decided by default based on the `position`
     * but we allow overriding via props for precise control.
     */ textAnchor: (0, _text.isValidTextAnchor)(attrs.textAnchor) ? attrs.textAnchor : positionAttrs.textAnchor,
        breakAll: textBreakAll
    }), label));
}
Label.displayName = 'Label';
var parseLabel = (label, viewBox, labelRef)=>{
    if (!label) return null;
    var commonProps = {
        viewBox,
        labelRef
    };
    if (label === true) return /*#__PURE__*/ _react.createElement(Label, _extends({
        key: "label-implicit"
    }, commonProps));
    if ((0, _dataUtils.isNumOrStr)(label)) return /*#__PURE__*/ _react.createElement(Label, _extends({
        key: "label-implicit",
        value: label
    }, commonProps));
    if (/*#__PURE__*/ (0, _react.isValidElement)(label)) {
        if (label.type === Label) return /*#__PURE__*/ (0, _react.cloneElement)(label, _objectSpread({
            key: 'label-implicit'
        }, commonProps));
        return /*#__PURE__*/ _react.createElement(Label, _extends({
            key: "label-implicit",
            content: label
        }, commonProps));
    }
    if (isLabelContentAFunction(label)) return /*#__PURE__*/ _react.createElement(Label, _extends({
        key: "label-implicit",
        content: label
    }, commonProps));
    if (label && typeof label === 'object') return /*#__PURE__*/ _react.createElement(Label, _extends({}, label, {
        key: "label-implicit"
    }, commonProps));
    return null;
};
function CartesianLabelFromLabelProp(_ref3) {
    var { label, labelRef } = _ref3;
    var viewBox = useCartesianLabelContext();
    return parseLabel(label, viewBox, labelRef) || null;
}
function PolarLabelFromLabelProp(_ref4) {
    var { label } = _ref4;
    var viewBox = usePolarLabelContext();
    return parseLabel(label, viewBox) || null;
}

},{"react":"bmhQu","clsx":"431Ou","./Text":"a7uB1","../util/DataUtils":"lNZEj","../util/PolarUtils":"ezeVo","../context/chartLayoutContext":"jIUyy","../state/hooks":"aEuxu","../state/selectors/polarAxisSelectors":"jJj4n","../util/resolveDefaultProps":"cWUqx","../util/svgPropertiesAndEvents":"6bogn","../zIndex/ZIndexLayer":"6RR5t","../zIndex/DefaultZIndexes":"h8nlV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ezeVo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RADIAN", ()=>RADIAN);
parcelHelpers.export(exports, "degreeToRadian", ()=>degreeToRadian);
parcelHelpers.export(exports, "radianToDegree", ()=>radianToDegree);
parcelHelpers.export(exports, "polarToCartesian", ()=>polarToCartesian);
parcelHelpers.export(exports, "getMaxRadius", ()=>getMaxRadius);
parcelHelpers.export(exports, "inRangeOfSector", ()=>inRangeOfSector);
parcelHelpers.export(exports, "getTickClassName", ()=>getTickClassName);
var _react = require("react");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var RADIAN = Math.PI / 180;
var degreeToRadian = (angle)=>angle * Math.PI / 180;
var radianToDegree = (angleInRadian)=>angleInRadian * 180 / Math.PI;
var polarToCartesian = (cx, cy, radius, angle)=>({
        x: cx + Math.cos(-RADIAN * angle) * radius,
        y: cy + Math.sin(-RADIAN * angle) * radius
    });
var getMaxRadius = function getMaxRadius(width, height) {
    var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        width: 0,
        height: 0,
        brushBottom: 0
    };
    return Math.min(Math.abs(width - (offset.left || 0) - (offset.right || 0)), Math.abs(height - (offset.top || 0) - (offset.bottom || 0))) / 2;
};
var distanceBetweenPoints = (point, anotherPoint)=>{
    var { x: x1, y: y1 } = point;
    var { x: x2, y: y2 } = anotherPoint;
    return Math.sqrt((x1 - x2) ** 2 + (y1 - y2) ** 2);
};
var getAngleOfPoint = (_ref, _ref2)=>{
    var { x, y } = _ref;
    var { cx, cy } = _ref2;
    var radius = distanceBetweenPoints({
        x,
        y
    }, {
        x: cx,
        y: cy
    });
    if (radius <= 0) return {
        radius,
        angle: 0
    };
    var cos = (x - cx) / radius;
    var angleInRadian = Math.acos(cos);
    if (y > cy) angleInRadian = 2 * Math.PI - angleInRadian;
    return {
        radius,
        angle: radianToDegree(angleInRadian),
        angleInRadian
    };
};
var formatAngleOfSector = (_ref3)=>{
    var { startAngle, endAngle } = _ref3;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return {
        startAngle: startAngle - min * 360,
        endAngle: endAngle - min * 360
    };
};
var reverseFormatAngleOfSector = (angle, _ref4)=>{
    var { startAngle, endAngle } = _ref4;
    var startCnt = Math.floor(startAngle / 360);
    var endCnt = Math.floor(endAngle / 360);
    var min = Math.min(startCnt, endCnt);
    return angle + min * 360;
};
var inRangeOfSector = (_ref5, viewBox)=>{
    var { chartX: x, chartY: y } = _ref5;
    var { radius, angle } = getAngleOfPoint({
        x,
        y
    }, viewBox);
    var { innerRadius, outerRadius } = viewBox;
    if (radius < innerRadius || radius > outerRadius) return null;
    if (radius === 0) return null;
    var { startAngle, endAngle } = formatAngleOfSector(viewBox);
    var formatAngle = angle;
    var inRange;
    if (startAngle <= endAngle) {
        while(formatAngle > endAngle)formatAngle -= 360;
        while(formatAngle < startAngle)formatAngle += 360;
        inRange = formatAngle >= startAngle && formatAngle <= endAngle;
    } else {
        while(formatAngle > startAngle)formatAngle -= 360;
        while(formatAngle < endAngle)formatAngle += 360;
        inRange = formatAngle >= endAngle && formatAngle <= startAngle;
    }
    if (inRange) return _objectSpread(_objectSpread({}, viewBox), {}, {
        radius,
        angle: reverseFormatAngleOfSector(formatAngle, viewBox)
    });
    return null;
};
var getTickClassName = (tick)=>!/*#__PURE__*/ (0, _react.isValidElement)(tick) && typeof tick !== 'function' && typeof tick !== 'boolean' && tick != null ? tick.className : '';

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jIUyy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "cartesianViewBoxToTrapezoid", ()=>cartesianViewBoxToTrapezoid);
parcelHelpers.export(exports, "useViewBox", ()=>useViewBox);
parcelHelpers.export(exports, "useOffsetInternal", ()=>useOffsetInternal);
parcelHelpers.export(exports, "useChartWidth", ()=>useChartWidth);
parcelHelpers.export(exports, "useChartHeight", ()=>useChartHeight);
parcelHelpers.export(exports, "useMargin", ()=>useMargin);
parcelHelpers.export(exports, "selectChartLayout", ()=>selectChartLayout);
parcelHelpers.export(exports, "useChartLayout", ()=>useChartLayout);
parcelHelpers.export(exports, "useCartesianChartLayout", ()=>useCartesianChartLayout);
parcelHelpers.export(exports, "useIsInChartContext", ()=>useIsInChartContext);
parcelHelpers.export(exports, "ReportChartSize", ()=>ReportChartSize);
parcelHelpers.export(exports, "ReportChartMargin", ()=>ReportChartMargin);
var _react = require("react");
var _hooks = require("../state/hooks");
var _layoutSlice = require("../state/layoutSlice");
var _selectChartOffsetInternal = require("../state/selectors/selectChartOffsetInternal");
var _containerSelectors = require("../state/selectors/containerSelectors");
var _panoramaContext = require("./PanoramaContext");
var _brushSelectors = require("../state/selectors/brushSelectors");
var _responsiveContainer = require("../component/ResponsiveContainer");
var _isWellBehavedNumber = require("../util/isWellBehavedNumber");
function cartesianViewBoxToTrapezoid(box) {
    if (!box) return undefined;
    return {
        x: box.x,
        y: box.y,
        upperWidth: 'upperWidth' in box ? box.upperWidth : box.width,
        lowerWidth: 'lowerWidth' in box ? box.lowerWidth : box.width,
        width: box.width,
        height: box.height
    };
}
var useViewBox = ()=>{
    var _useAppSelector;
    var panorama = (0, _panoramaContext.useIsPanorama)();
    var rootViewBox = (0, _hooks.useAppSelector)((0, _selectChartOffsetInternal.selectChartViewBox));
    var brushDimensions = (0, _hooks.useAppSelector)((0, _brushSelectors.selectBrushDimensions));
    var brushPadding = (_useAppSelector = (0, _hooks.useAppSelector)((0, _brushSelectors.selectBrushSettings))) === null || _useAppSelector === void 0 ? void 0 : _useAppSelector.padding;
    if (!panorama || !brushDimensions || !brushPadding) return rootViewBox;
    return {
        width: brushDimensions.width - brushPadding.left - brushPadding.right,
        height: brushDimensions.height - brushPadding.top - brushPadding.bottom,
        x: brushPadding.left,
        y: brushPadding.top
    };
};
var manyComponentsThrowErrorsIfOffsetIsUndefined = {
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    width: 0,
    height: 0,
    brushBottom: 0
};
var useOffsetInternal = ()=>{
    var _useAppSelector2;
    return (_useAppSelector2 = (0, _hooks.useAppSelector)((0, _selectChartOffsetInternal.selectChartOffsetInternal))) !== null && _useAppSelector2 !== void 0 ? _useAppSelector2 : manyComponentsThrowErrorsIfOffsetIsUndefined;
};
var useChartWidth = ()=>{
    return (0, _hooks.useAppSelector)((0, _containerSelectors.selectChartWidth));
};
var useChartHeight = ()=>{
    return (0, _hooks.useAppSelector)((0, _containerSelectors.selectChartHeight));
};
var useMargin = ()=>{
    return (0, _hooks.useAppSelector)((state)=>state.layout.margin);
};
var selectChartLayout = (state)=>state.layout.layoutType;
var useChartLayout = ()=>(0, _hooks.useAppSelector)(selectChartLayout);
var useCartesianChartLayout = ()=>{
    var layout = useChartLayout();
    if (layout === 'horizontal' || layout === 'vertical') return layout;
    return undefined;
};
var useIsInChartContext = ()=>{
    /*
   * All charts provide a layout type in the chart context.
   * If we have a layout type, we are in a chart context.
   */ var layout = useChartLayout();
    return layout !== undefined;
};
var ReportChartSize = (props)=>{
    var dispatch = (0, _hooks.useAppDispatch)();
    /*
   * Skip dispatching properties in panorama chart for two reasons:
   * 1. The root chart should be deciding on these properties, and
   * 2. Brush reads these properties from redux store, and so they must remain stable
   *      to avoid circular dependency and infinite re-rendering.
   */ var isPanorama = (0, _panoramaContext.useIsPanorama)();
    var { width: widthFromProps, height: heightFromProps } = props;
    var responsiveContainerCalculations = (0, _responsiveContainer.useResponsiveContainerContext)();
    var width = widthFromProps;
    var height = heightFromProps;
    if (responsiveContainerCalculations) {
        /*
     * In case we receive width and height from ResponsiveContainer,
     * we will always prefer those.
     * Only in case ResponsiveContainer does not provide width or height,
     * we will fall back to the explicitly provided width and height.
     *
     * This to me feels backwards - we should allow override by the more specific props on individual charts, right?
     * But this is 3.x behaviour, so let's keep it for backwards compatibility.
     *
     * We can change this in 4.x if we want to.
     */ width = responsiveContainerCalculations.width > 0 ? responsiveContainerCalculations.width : widthFromProps;
        height = responsiveContainerCalculations.height > 0 ? responsiveContainerCalculations.height : heightFromProps;
    }
    (0, _react.useEffect)(()=>{
        if (!isPanorama && (0, _isWellBehavedNumber.isPositiveNumber)(width) && (0, _isWellBehavedNumber.isPositiveNumber)(height)) dispatch((0, _layoutSlice.setChartSize)({
            width,
            height
        }));
    }, [
        dispatch,
        isPanorama,
        width,
        height
    ]);
    return null;
};
var ReportChartMargin = (_ref)=>{
    var { margin } = _ref;
    var dispatch = (0, _hooks.useAppDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _layoutSlice.setMargin)(margin));
    }, [
        dispatch,
        margin
    ]);
    return null;
};

},{"react":"bmhQu","../state/hooks":"aEuxu","../state/layoutSlice":"gG6kT","../state/selectors/selectChartOffsetInternal":"caUjq","../state/selectors/containerSelectors":"lnBke","./PanoramaContext":"10hMm","../state/selectors/brushSelectors":"3YEO3","../component/ResponsiveContainer":"7epZf","../util/isWellBehavedNumber":"aIsFR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aEuxu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAppDispatch", ()=>useAppDispatch);
/**
 * This is a recharts variant of `useSelector` from 'react-redux' package.
 *
 * The difference is that react-redux version will throw an Error when used outside of Redux context.
 *
 * This, recharts version, will return undefined instead.
 *
 * This is because we want to allow using our components outside the Chart wrapper,
 * and have people provide all props explicitly.
 *
 * If however they use the component inside a chart wrapper then those props become optional,
 * and we read them from Redux state instead.
 *
 * @param selector for pulling things out of Redux store; will not be called if the store is not accessible
 * @return whatever the selector returned; or undefined when outside of Redux store
 */ parcelHelpers.export(exports, "useAppSelector", ()=>useAppSelector);
var _withSelector = require("use-sync-external-store/shim/with-selector");
var _react = require("react");
var _rechartsReduxContext = require("./RechartsReduxContext");
var noopDispatch = (a)=>a;
var useAppDispatch = ()=>{
    var context = (0, _react.useContext)((0, _rechartsReduxContext.RechartsReduxContext));
    if (context) return context.store.dispatch;
    return noopDispatch;
};
var noop = ()=>{};
var addNestedSubNoop = ()=>noop;
var refEquality = (a, b)=>a === b;
function useAppSelector(selector) {
    var context = (0, _react.useContext)((0, _rechartsReduxContext.RechartsReduxContext));
    return (0, _withSelector.useSyncExternalStoreWithSelector)(context ? context.subscription.addNestedSub : addNestedSubNoop, context ? context.store.getState : noop, context ? context.store.getState : noop, context ? selector : noop, refEquality);
}

},{"use-sync-external-store/shim/with-selector":"j1vWm","react":"bmhQu","./RechartsReduxContext":"fkmiH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fkmiH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RechartsReduxContext", ()=>RechartsReduxContext);
var _react = require("react");
var RechartsReduxContext = /*#__PURE__*/ (0, _react.createContext)(null);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gG6kT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setMargin", ()=>setMargin);
parcelHelpers.export(exports, "setLayout", ()=>setLayout);
parcelHelpers.export(exports, "setChartSize", ()=>setChartSize);
parcelHelpers.export(exports, "setScale", ()=>setScale);
parcelHelpers.export(exports, "chartLayoutReducer", ()=>chartLayoutReducer);
var _toolkit = require("@reduxjs/toolkit");
var initialState = {
    layoutType: 'horizontal',
    width: 0,
    height: 0,
    margin: {
        top: 5,
        right: 5,
        bottom: 5,
        left: 5
    },
    scale: 1
};
var chartLayoutSlice = (0, _toolkit.createSlice)({
    name: 'chartLayout',
    initialState,
    reducers: {
        setLayout (state, action) {
            state.layoutType = action.payload;
        },
        setChartSize (state, action) {
            state.width = action.payload.width;
            state.height = action.payload.height;
        },
        setMargin (state, action) {
            var _action$payload$top, _action$payload$right, _action$payload$botto, _action$payload$left;
            state.margin.top = (_action$payload$top = action.payload.top) !== null && _action$payload$top !== void 0 ? _action$payload$top : 0;
            state.margin.right = (_action$payload$right = action.payload.right) !== null && _action$payload$right !== void 0 ? _action$payload$right : 0;
            state.margin.bottom = (_action$payload$botto = action.payload.bottom) !== null && _action$payload$botto !== void 0 ? _action$payload$botto : 0;
            state.margin.left = (_action$payload$left = action.payload.left) !== null && _action$payload$left !== void 0 ? _action$payload$left : 0;
        },
        setScale (state, action) {
            state.scale = action.payload;
        }
    }
});
var { setMargin, setLayout, setChartSize, setScale } = chartLayoutSlice.actions;
var chartLayoutReducer = chartLayoutSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7hE98":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReducerType", ()=>ReducerType);
parcelHelpers.export(exports, "SHOULD_AUTOBATCH", ()=>SHOULD_AUTOBATCH);
parcelHelpers.export(exports, "TaskAbortError", ()=>TaskAbortError);
parcelHelpers.export(exports, "Tuple", ()=>Tuple);
parcelHelpers.export(exports, "addListener", ()=>addListener);
parcelHelpers.export(exports, "asyncThunkCreator", ()=>asyncThunkCreator);
parcelHelpers.export(exports, "autoBatchEnhancer", ()=>autoBatchEnhancer);
parcelHelpers.export(exports, "buildCreateSlice", ()=>buildCreateSlice);
parcelHelpers.export(exports, "clearAllListeners", ()=>clearAllListeners);
parcelHelpers.export(exports, "combineSlices", ()=>combineSlices);
parcelHelpers.export(exports, "configureStore", ()=>configureStore);
parcelHelpers.export(exports, "createAction", ()=>createAction);
parcelHelpers.export(exports, "createActionCreatorInvariantMiddleware", ()=>createActionCreatorInvariantMiddleware);
parcelHelpers.export(exports, "createAsyncThunk", ()=>createAsyncThunk);
parcelHelpers.export(exports, "createDraftSafeSelector", ()=>createDraftSafeSelector);
parcelHelpers.export(exports, "createDraftSafeSelectorCreator", ()=>createDraftSafeSelectorCreator);
parcelHelpers.export(exports, "createDynamicMiddleware", ()=>createDynamicMiddleware);
parcelHelpers.export(exports, "createEntityAdapter", ()=>createEntityAdapter);
parcelHelpers.export(exports, "createImmutableStateInvariantMiddleware", ()=>createImmutableStateInvariantMiddleware);
parcelHelpers.export(exports, "createListenerMiddleware", ()=>createListenerMiddleware);
parcelHelpers.export(exports, "createNextState", ()=>(0, _immer.produce));
parcelHelpers.export(exports, "createReducer", ()=>createReducer);
parcelHelpers.export(exports, "createSelector", ()=>(0, _reselect.createSelector));
parcelHelpers.export(exports, "createSelectorCreator", ()=>(0, _reselect.createSelectorCreator));
parcelHelpers.export(exports, "createSerializableStateInvariantMiddleware", ()=>createSerializableStateInvariantMiddleware);
parcelHelpers.export(exports, "createSlice", ()=>createSlice);
parcelHelpers.export(exports, "current", ()=>(0, _immer.current));
parcelHelpers.export(exports, "findNonSerializableValue", ()=>findNonSerializableValue);
parcelHelpers.export(exports, "formatProdErrorMessage", ()=>formatProdErrorMessage);
parcelHelpers.export(exports, "freeze", ()=>(0, _immer.freeze));
parcelHelpers.export(exports, "isActionCreator", ()=>isActionCreator);
parcelHelpers.export(exports, "isAllOf", ()=>isAllOf);
parcelHelpers.export(exports, "isAnyOf", ()=>isAnyOf);
parcelHelpers.export(exports, "isAsyncThunkAction", ()=>isAsyncThunkAction);
parcelHelpers.export(exports, "isDraft", ()=>(0, _immer.isDraft));
parcelHelpers.export(exports, "isFluxStandardAction", ()=>isFSA);
parcelHelpers.export(exports, "isFulfilled", ()=>isFulfilled);
parcelHelpers.export(exports, "isImmutableDefault", ()=>isImmutableDefault);
parcelHelpers.export(exports, "isPending", ()=>isPending);
parcelHelpers.export(exports, "isPlain", ()=>isPlain);
parcelHelpers.export(exports, "isRejected", ()=>isRejected);
parcelHelpers.export(exports, "isRejectedWithValue", ()=>isRejectedWithValue);
parcelHelpers.export(exports, "lruMemoize", ()=>(0, _reselect.lruMemoize));
parcelHelpers.export(exports, "miniSerializeError", ()=>miniSerializeError);
parcelHelpers.export(exports, "nanoid", ()=>nanoid);
parcelHelpers.export(exports, "original", ()=>(0, _immer.original));
parcelHelpers.export(exports, "prepareAutoBatched", ()=>prepareAutoBatched);
parcelHelpers.export(exports, "removeListener", ()=>removeListener);
parcelHelpers.export(exports, "unwrapResult", ()=>unwrapResult);
parcelHelpers.export(exports, "weakMapMemoize", ()=>(0, _reselect.weakMapMemoize));
// src/index.ts
var _redux = require("redux");
parcelHelpers.exportAll(_redux, exports);
var _immer = require("immer");
// src/index.ts
var _reselect = require("reselect");
// src/getDefaultMiddleware.ts
var _reduxThunk = require("redux-thunk");
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var __publicField = (obj, key, value)=>__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
// src/createDraftSafeSelector.ts
var createDraftSafeSelectorCreator = (...args)=>{
    const createSelector2 = (0, _reselect.createSelectorCreator)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var createDraftSafeSelector = /* @__PURE__ */ createDraftSafeSelectorCreator((0, _reselect.weakMapMemoize));
// src/devtoolsExtension.ts
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, _redux.compose;
    return (0, _redux.compose).apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error(formatProdErrorMessage(0));
            return __spreadValues(__spreadValues({
                type,
                payload: prepared.payload
            }, "meta" in prepared && {
                meta: prepared.meta
            }), "error" in prepared && {
                error: prepared.error
            });
        }
        return {
            type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, _redux.isAction)(action) && action.type === type;
    return actionCreator;
}
function isActionCreator(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    hasMatchFunction(action);
}
function isFSA(action) {
    return (0, _redux.isAction)(action) && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function createActionCreatorInvariantMiddleware(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/utils.ts
function getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
var Tuple = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function freezeDraftable(val) {
    return (0, _immer.isDraftable)(val) ? (0, _immer.produce)(val, ()=>{}) : val;
}
function getOrInsertComputed(map, key, compute) {
    if (map.has(key)) return map.get(key);
    return map.set(key, compute(key)).get(key);
}
// src/immutableStateInvariantMiddleware.ts
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignoredPaths, obj) {
    const trackedProperties = trackProperties(isImmutable, ignoredPaths, obj);
    return {
        detectMutations () {
            return detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        const hasIgnoredPaths = ignoredPaths.length > 0;
        for(const key in obj){
            const nestedPath = path ? path + "." + key : key;
            if (hasIgnoredPaths) {
                const hasMatches = ignoredPaths.some((ignored)=>{
                    if (ignored instanceof RegExp) return ignored.test(nestedPath);
                    return nestedPath === ignored;
                });
                if (hasMatches) continue;
            }
            tracked.children[key] = trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function createImmutableStateInvariantMiddleware(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, _redux.isPlainObject)(val);
}
function findNonSerializableValue(value, path = "", isSerializable = isPlain, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache == null ? void 0 : cache.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && isNestedFrozen(value)) cache.add(value);
    return false;
}
function isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function createSerializableStateInvariantMiddleware(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
var buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk = true, immutableCheck = true, serializableCheck = true, actionCreatorCheck = true } = options != null ? options : {};
        let middlewareArray = new Tuple();
        if (thunk) {
            if (isBoolean(thunk)) middlewareArray.push((0, _reduxThunk.thunk));
            else middlewareArray.push((0, _reduxThunk.withExtraArgument)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = ()=>(payload)=>({
            payload,
            meta: {
                [SHOULD_AUTOBATCH]: true
            }
        });
var createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var autoBatchEnhancer = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
            typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10) : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    var _a;
                    try {
                        notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch = true } = options != null ? options : {};
        let enhancerArray = new Tuple(middlewareEnhancer);
        if (autoBatch) enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
function configureStore(options) {
    const getDefaultMiddleware = buildGetDefaultMiddleware();
    const { reducer, middleware, devTools = true, duplicateMiddlewareCheck = true, preloadedState, enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, _redux.isPlainObject)(reducer)) rootReducer = (0, _redux.combineReducers)(reducer);
    else throw new Error(formatProdErrorMessage(1));
    let finalMiddleware;
    if (typeof middleware === "function") finalMiddleware = middleware(getDefaultMiddleware);
    else finalMiddleware = getDefaultMiddleware();
    var middleware2;
    let finalCompose = (0, _redux.compose);
    if (devTools) finalCompose = composeWithDevTools(__spreadValues({
        // Enable capture of stack traces for dispatched Redux actions
        trace: false
    }, typeof devTools === "object" && devTools));
    const middlewareEnhancer = (0, _redux.applyMiddleware)(...finalMiddleware);
    const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, _redux.createStore)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error(formatProdErrorMessage(28));
            if (type in actionsMap) throw new Error(formatProdErrorMessage(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addAsyncThunk (asyncThunk, reducers) {
            if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
            if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
            if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
            if (reducers.settled) actionMatchers.push({
                matcher: asyncThunk.settled,
                reducer: reducers.settled
            });
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher,
                reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
function createReducer(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if (isStateFunction(initialState)) getInitialState = ()=>freezeDraftable(initialState());
    else {
        const frozenInitialState = freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, _immer.isDraft)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, _immer.isDraftable)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                } else return (0, _immer.produce)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/matchers.ts
var matches = (matcher, action)=>{
    if (hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function isAnyOf(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>matches(matcher, action));
    };
}
function isAllOf(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>matches(matcher, action));
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isPending()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.pending));
}
function isRejected(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isRejected()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.rejected));
}
function isRejectedWithValue(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return isAllOf(isRejected(...asyncThunks), hasFlag);
    if (!isAsyncThunkArray(asyncThunks)) return isRejectedWithValue()(asyncThunks[0]);
    return isAllOf(isRejected(...asyncThunks), hasFlag);
}
function isFulfilled(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isFulfilled()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled));
}
function isAsyncThunkAction(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!isAsyncThunkArray(asyncThunks)) return isAsyncThunkAction()(asyncThunks[0]);
    return isAnyOf(...asyncThunks.flatMap((asyncThunk)=>[
            asyncThunk.pending,
            asyncThunk.rejected,
            asyncThunk.fulfilled
        ]));
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ __publicField(this, "_type");
    }
};
var FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
        /*
    type-only property to distinguish between RejectWithValue and FulfillWithMeta
    does not exist at runtime
    */ __publicField(this, "_type");
    }
};
var miniSerializeError = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var externalAbortMessage = "External signal was aborted";
var createAsyncThunk = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    requestStatus: "fulfilled"
                })
            }));
        const pending = createAction(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    requestStatus: "pending"
                })
            }));
        const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload,
                error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
                meta: __spreadProps(__spreadValues({}, meta || {}), {
                    arg,
                    requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: (error == null ? void 0 : error.name) === "AbortError",
                    condition: (error == null ? void 0 : error.name) === "ConditionError"
                })
            }));
        function actionCreator(arg, { signal } = {}) {
            return (dispatch, getState, extra)=>{
                const requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                if (signal) {
                    if (signal.aborted) abort(externalAbortMessage);
                    else signal.addEventListener("abort", ()=>abort(externalAbortMessage), {
                        once: true
                    });
                }
                const promise = async function() {
                    var _a, _b;
                    let finalAction;
                    try {
                        let conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, {
                            getState,
                            extra
                        });
                        if (isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler, {
                                once: true
                            });
                        });
                        dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, {
                            requestId,
                            arg
                        }, {
                            getState,
                            extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch,
                                getState,
                                extra,
                                requestId,
                                signal: abortController.signal,
                                abort,
                                rejectWithValue: (value, meta)=>{
                                    return new RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof RejectWithValue) throw result;
                                if (result instanceof FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort,
                    requestId,
                    arg,
                    unwrap () {
                        return promise.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending,
            rejected,
            fulfilled,
            settled: isAnyOf(rejected, fulfilled),
            typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
var asyncThunkCreator = {
    [asyncThunkSymbol]: createAsyncThunk
};
var ReducerType = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})(ReducerType || {});
function getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function buildCreateSlice({ creators } = {}) {
    var _a;
    const cAT = (_a = creators == null ? void 0 : creators.asyncThunk) == null ? void 0 : _a[asyncThunkSymbol];
    return function createSlice2(options) {
        const { name, reducerPath = name } = options;
        if (!name) throw new Error(formatProdErrorMessage(11));
        const reducers = (typeof options.reducers === "function" ? options.reducers(buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error(formatProdErrorMessage(12));
                if (type in context.sliceCaseReducersByType) throw new Error(formatProdErrorMessage(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName,
                type: getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), context.sliceCaseReducersByType);
            return createReducer(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        const injectedStateCache = /* @__PURE__ */ new WeakMap();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getOrInsertComputed(injectedStateCache, selectSlice, getInitialState);
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = getOrInsertComputed(injectedSelectorCache, injected, ()=>/* @__PURE__ */ new WeakMap());
                return getOrInsertComputed(selectorCache, selectState, ()=>{
                    var _a2;
                    const map = {};
                    for (const [name2, selector] of Object.entries((_a2 = options.selectors) != null ? _a2 : {}))map[name2] = wrapSelector(selector, selectState, ()=>getOrInsertComputed(injectedStateCache, selectState, getInitialState), injected);
                    return map;
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice
            };
        }
        const slice = __spreadProps(__spreadValues({
            name,
            reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState
        }, makeSelectorProps(reducerPath)), {
            injectInto (injectable, _a2 = {}) {
                var _b = _a2, { reducerPath: pathOpt } = _b, config = __objRest(_b, [
                    "reducerPath"
                ]);
                const newReducerPath = pathOpt != null ? pathOpt : reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer
                }, config);
                return __spreadValues(__spreadValues({}, slice), makeSelectorProps(newReducerPath, true));
            }
        });
        return slice;
    };
}
function wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return __spreadValues({
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator
        }, config);
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare,
                reducer
            };
        },
        asyncThunk
    };
}
function handleNormalReducerDefinition({ type, reducerName, createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error(formatProdErrorMessage(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function handleThunkCaseReducerDefinition({ type, reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error(formatProdErrorMessage(18));
    const { payloadCreator, fulfilled, pending, rejected, settled, options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || noop,
        pending: pending || noop,
        rejected: rejected || noop,
        settled: settled || noop
    });
}
function noop() {}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory(stateAdapter) {
    function getInitialState(additionalState = {}, entities) {
        const state = Object.assign(getInitialEntityState(), additionalState);
        return entities ? stateAdapter.setAll(state, entities) : state;
    }
    return {
        getInitialState
    };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = createDraftSafeSelector } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds,
            selectEntities,
            selectAll,
            selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors
    };
}
// src/entities/state_adapter.ts
var isDraftTyped = (0, _immer.isDraft);
function createSingleArgumentStateOperator(mutator) {
    const operator = createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if (isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, _immer.produce)(state, runMutator);
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function getCurrent(value) {
    return (0, _immer.isDraft)(value) ? (0, _immer.current)(value) : value;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    const existingIdsArray = getCurrent(state.ids);
    const existingIds = new Set(existingIdsArray);
    const added = [];
    const addedIds = /* @__PURE__ */ new Set([]);
    const updated = [];
    for (const entity of newEntities){
        const id = selectIdValue(entity, selectId);
        if (existingIds.has(id) || addedIds.has(id)) updated.push({
            id,
            changes: entity
        });
        else {
            addedIds.add(id);
            added.push(entity);
        }
    }
    return [
        added,
        updated,
        existingIdsArray
    ];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            var _a;
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: __spreadValues(__spreadValues({}, (_a = updatesPerEntity[update.id]) == null ? void 0 : _a.changes), update.changes)
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = splitAddedUpdatedEntities(newEntities, selectId, state);
        addManyMutably(added, state);
        updateManyMutably(updated, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function findInsertIndex(sortedItems, item, comparisonFunction) {
    let lowIndex = 0;
    let highIndex = sortedItems.length;
    while(lowIndex < highIndex){
        let middleIndex = lowIndex + highIndex >>> 1;
        const currentItem = sortedItems[middleIndex];
        const res = comparisonFunction(item, currentItem);
        if (res >= 0) lowIndex = middleIndex + 1;
        else highIndex = middleIndex;
    }
    return lowIndex;
}
function insert(sortedItems, item, comparisonFunction) {
    const insertAtIndex = findInsertIndex(sortedItems, item, comparisonFunction);
    sortedItems.splice(insertAtIndex, 0, item);
    return sortedItems;
}
function createSortedStateAdapter(selectId, comparer) {
    const { removeOne, removeMany, removeAll } = createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state, existingIds) {
        newEntities = ensureEntitiesArray(newEntities);
        const existingKeys = new Set(existingIds != null ? existingIds : getCurrent(state.ids));
        const addedKeys = /* @__PURE__ */ new Set();
        const models = newEntities.filter((model)=>{
            const modelId = selectIdValue(model, selectId);
            const notAdded = !addedKeys.has(modelId);
            if (notAdded) addedKeys.add(modelId);
            return !existingKeys.has(modelId) && notAdded;
        });
        if (models.length !== 0) mergeFunction(state, models);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        let deduplicatedEntities = {};
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            for (const item of newEntities){
                const entityId = selectId(item);
                deduplicatedEntities[entityId] = item;
                delete state.entities[entityId];
            }
            newEntities = ensureEntitiesArray(deduplicatedEntities);
            mergeFunction(state, newEntities);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state, []);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        let replacedIds = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                replacedIds = true;
                delete state.entities[update.id];
                const oldIndex = state.ids.indexOf(update.id);
                state.ids[oldIndex] = newId;
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) mergeFunction(state, [], appliedUpdates, replacedIds);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated, existingIdsArray] = splitAddedUpdatedEntities(newEntities, selectId, state);
        if (added.length) addManyMutably(added, state, existingIdsArray);
        if (updated.length) updateManyMutably(updated, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    const mergeFunction = (state, addedItems, appliedUpdates, replacedIds)=>{
        const currentEntities = getCurrent(state.entities);
        const currentIds = getCurrent(state.ids);
        const stateEntities = state.entities;
        let ids = currentIds;
        if (replacedIds) ids = new Set(currentIds);
        let sortedEntities = [];
        for (const id of ids){
            const entity = currentEntities[id];
            if (entity) sortedEntities.push(entity);
        }
        const wasPreviouslyEmpty = sortedEntities.length === 0;
        for (const item of addedItems){
            stateEntities[selectId(item)] = item;
            if (!wasPreviouslyEmpty) insert(sortedEntities, item, comparer);
        }
        if (wasPreviouslyEmpty) sortedEntities = addedItems.slice().sort(comparer);
        else if (appliedUpdates) sortedEntities.sort(comparer);
        const newSortedIds = sortedEntities.map(selectId);
        if (!areArraysEqual(currentIds, newSortedIds)) state.ids = newSortedIds;
    };
    return {
        removeOne,
        removeMany,
        removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options = {}) {
    const { selectId, sortComparer } = __spreadValues({
        sortComparer: false,
        selectId: (instance)=>instance.id
    }, options);
    const stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    const stateFactory = createInitialStateFactory(stateAdapter);
    const selectorsFactory = createSelectorsFactory();
    return __spreadValues(__spreadValues(__spreadValues({
        selectId,
        sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = `task-${cancelled}`;
var taskCompleted = `task-${completed}`;
var listenerCancelled = `${listener}-${cancelled}`;
var listenerCompleted = `${listener}-${completed}`;
var TaskAbortError = class {
    constructor(code){
        this.code = code;
        __publicField(this, "name", "TaskAbortError");
        __publicField(this, "message");
        this.message = `${task} ${cancelled} (reason: ${code})`;
    }
};
// src/listenerMiddleware/utils.ts
var assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new TypeError(formatProdErrorMessage(32));
};
var noop2 = ()=>{};
var catchRejection = (promise, onError = noop2)=>{
    promise.catch(onError);
    return promise;
};
var addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
// src/listenerMiddleware/task.ts
var validateActive = (signal)=>{
    if (signal.aborted) throw new TaskAbortError(signal.reason);
};
function raceWithSignal(signal, promise) {
    let cleanup = noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new TaskAbortError(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = noop2;
    });
}
var runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value
        };
    } catch (error) {
        return {
            status: error instanceof TaskAbortError ? "cancelled" : "rejected",
            error
        };
    } finally{
        cleanUp == null || cleanUp();
    }
};
var createPause = (signal)=>{
    return (promise)=>{
        return catchRejection(raceWithSignal(signal, promise).then((output)=>{
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = (signal)=>{
    const pause = createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign } = Object;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>addAbortSignalListener(parentAbortSignal, ()=>controller.abort(parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = runTask(async ()=>{
            validateActive(parentAbortSignal);
            validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: createPause(childAbortController.signal),
                delay: createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            validateActive(childAbortController.signal);
            return result2;
        }, ()=>childAbortController.abort(taskCompleted));
        if (opts == null ? void 0 : opts.autoJoin) parentBlockingPromises.push(result.catch(noop2));
        return {
            result: createPause(parentAbortSignal)(result),
            cancel () {
                childAbortController.abort(taskCancelled);
            }
        };
    };
};
var createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await raceWithSignal(signal, Promise.race(promises));
            validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>catchRejection(take(predicate, timeout));
};
var getListenerEntryPropsFrom = (options)=>{
    let { type, actionCreator, matcher, predicate, effect } = options;
    if (type) predicate = createAction(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error(formatProdErrorMessage(21));
    assertFunction(effect, "options.listener");
    return {
        predicate,
        type,
        effect
    };
};
var createListenerEntry = /* @__PURE__ */ assign((options)=>{
    const { type, predicate, effect } = getListenerEntryPropsFrom(options);
    const entry = {
        id: nanoid(),
        effect,
        type,
        predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error(formatProdErrorMessage(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>createListenerEntry
});
var findListenerEntry = (listenerMap, options)=>{
    const { type, effect, predicate } = getListenerEntryPropsFrom(options);
    return Array.from(listenerMap.values()).find((entry)=>{
        const matchPredicateOrType = typeof type === "string" ? entry.type === type : entry.predicate === predicate;
        return matchPredicateOrType && entry.effect === effect;
    });
};
var cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        controller.abort(listenerCancelled);
    });
};
var createClearListenerMiddleware = (listenerMap, executingListeners)=>{
    return ()=>{
        for (const listener2 of executingListeners.keys())cancelActiveListeners(listener2);
        listenerMap.clear();
    };
};
var safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = /* @__PURE__ */ assign(/* @__PURE__ */ createAction(`${alm}/add`), {
    withTypes: ()=>addListener
});
var clearAllListeners = /* @__PURE__ */ createAction(`${alm}/removeAll`);
var removeListener = /* @__PURE__ */ assign(/* @__PURE__ */ createAction(`${alm}/remove`), {
    withTypes: ()=>removeListener
});
var defaultErrorHandler = (...args)=>{
    console.error(`${alm}/error`, ...args);
};
var createListenerMiddleware = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const executingListeners = /* @__PURE__ */ new Map();
    const trackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 0;
        executingListeners.set(entry, count + 1);
    };
    const untrackExecutingListener = (entry)=>{
        var _a;
        const count = (_a = executingListeners.get(entry)) != null ? _a : 1;
        if (count === 1) executingListeners.delete(entry);
        else executingListeners.set(entry, count - 1);
    };
    const { extra, onError = defaultErrorHandler } = middlewareOptions;
    assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        var _a;
        const entry = (_a = findListenerEntry(listenerMap, options)) != null ? _a : createListenerEntry(options);
        return insertEntry(entry);
    };
    assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const entry = findListenerEntry(listenerMap, options);
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) cancelActiveListeners(entry);
        }
        return !!entry;
    };
    assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            trackExecutingListener(entry);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            assign({}, api, {
                getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take,
                delay: createDelay(internalTaskController.signal),
                pause: createPause(internalTaskController.signal),
                extra,
                signal: internalTaskController.signal,
                fork: createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            controller.abort(listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    internalTaskController.abort(listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof TaskAbortError)) safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            internalTaskController.abort(listenerCompleted);
            untrackExecutingListener(entry);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = createClearListenerMiddleware(listenerMap, executingListeners);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, _redux.isAction)(action)) return next(action);
                if (addListener.match(action)) return startListening(action.payload);
                if (clearAllListeners.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if (removeListener.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === INTERNAL_NIL_TOKEN) throw new Error(formatProdErrorMessage(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware,
        startListening,
        stopListening,
        clearListeners: clearListenerMiddleware
    };
};
// src/dynamicMiddleware/index.ts
var createMiddlewareEntry = (middleware)=>({
        middleware,
        applied: /* @__PURE__ */ new Map()
    });
var matchInstance = (instanceId)=>(action)=>{
        var _a;
        return ((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a.instanceId) === instanceId;
    };
var createDynamicMiddleware = ()=>{
    const instanceId = nanoid();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign(createAction("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            getOrInsertComputed(middlewareMap, middleware2, createMiddlewareEntry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>getOrInsertComputed(entry.applied, api, entry.middleware));
        return (0, _redux.compose)(...appliedMiddleware);
    };
    const isWithMiddleware = isAllOf(withMiddleware, matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware,
        addMiddleware,
        withMiddleware,
        instanceId
    };
};
var isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var getReducers = (slices)=>slices.flatMap((sliceOrMap)=>isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var isStateProxy = (value)=>!!value && !!value[ORIGINAL_STATE];
var stateProxyMap = /* @__PURE__ */ new WeakMap();
var createStateProxy = (state, reducerMap, initialStateCache)=>getOrInsertComputed(stateProxyMap, state, ()=>new Proxy(state, {
            get: (target, prop, receiver)=>{
                if (prop === ORIGINAL_STATE) return target;
                const result = Reflect.get(target, prop, receiver);
                if (typeof result === "undefined") {
                    const cached = initialStateCache[prop];
                    if (typeof cached !== "undefined") return cached;
                    const reducer = reducerMap[prop];
                    if (reducer) {
                        const reducerResult = reducer(void 0, {
                            type: nanoid()
                        });
                        if (typeof reducerResult === "undefined") throw new Error(formatProdErrorMessage(24));
                        initialStateCache[prop] = reducerResult;
                        return reducerResult;
                    }
                }
                return result;
            }
        }));
var original = (state)=>{
    if (!isStateProxy(state)) throw new Error(formatProdErrorMessage(25));
    return state[ORIGINAL_STATE];
};
var emptyObject = {};
var noopReducer = (state = emptyObject)=>state;
function combineSlices(...slices) {
    const reducerMap = Object.fromEntries(getReducers(slices));
    const getReducer = ()=>Object.keys(reducerMap).length ? (0, _redux.combineReducers)(reducerMap) : noopReducer;
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const initialStateCache = {};
    const inject = (slice, config = {})=>{
        const { reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) return combinedReducer;
        if (config.overrideExisting && currentReducer !== reducerToInject) delete initialStateCache[reducerPath];
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn(createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap, initialStateCache), ...args);
        };
    }, {
        original
    });
    return Object.assign(combinedReducer, {
        inject,
        selector
    });
}
// src/formatProdErrorMessage.ts
function formatProdErrorMessage(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}

},{"redux":"fptxw","immer":"5taT5","reselect":"ds2su","redux-thunk":"cC21f","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fptxw":[function(require,module,exports,__globalThis) {
// src/utils/formatProdErrorMessage.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__DO_NOT_USE__ActionTypes", ()=>actionTypes_default);
parcelHelpers.export(exports, "applyMiddleware", ()=>applyMiddleware);
parcelHelpers.export(exports, "bindActionCreators", ()=>bindActionCreators);
parcelHelpers.export(exports, "combineReducers", ()=>combineReducers);
parcelHelpers.export(exports, "compose", ()=>compose);
parcelHelpers.export(exports, "createStore", ()=>createStore);
parcelHelpers.export(exports, "isAction", ()=>isAction);
parcelHelpers.export(exports, "isPlainObject", ()=>isPlainObject);
parcelHelpers.export(exports, "legacy_createStore", ()=>legacy_createStore);
function formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;
// src/utils/actionTypes.ts
var randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
    INIT: `@@redux/INIT${randomString()}`,
    REPLACE: `@@redux/REPLACE${randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;
// src/utils/isPlainObject.ts
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if (isDate(val)) return "date";
    if (isError(val)) return "error";
    const constructorName = ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function createStore(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error(formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error(formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error(formatProdErrorMessage(1));
        return enhancer(createStore)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error(formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error(formatProdErrorMessage(4));
        if (isDispatching) throw new Error(formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error(formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!isPlainObject(action)) throw new Error(formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error(formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error(formatProdErrorMessage(17));
        if (isDispatching) throw new Error(formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error(formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: actionTypes_default.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error(formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe
                };
            },
            [symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: actionTypes_default.INIT
    });
    const store = {
        dispatch,
        subscribe,
        getState,
        replaceReducer,
        [symbol_observable_default]: observable
    };
    return store;
}
function legacy_createStore(reducer, preloadedState, enhancer) {
    return createStore(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!isPlainObject(inputState)) return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === actionTypes_default.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: actionTypes_default.INIT
        });
        if (typeof initialState === "undefined") throw new Error(formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: actionTypes_default.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error(formatProdErrorMessage(13));
    });
}
function combineReducers(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error(formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function bindActionCreators(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error(formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function compose(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function applyMiddleware(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error(formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = compose(...chain)(store.dispatch);
            return {
                ...store,
                dispatch
            };
        };
}
// src/utils/isAction.ts
function isAction(action) {
    return isPlainObject(action) && "type" in action && typeof action.type === "string";
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5taT5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", ()=>Immer2);
parcelHelpers.export(exports, "applyPatches", ()=>applyPatches);
parcelHelpers.export(exports, "castDraft", ()=>castDraft);
parcelHelpers.export(exports, "castImmutable", ()=>castImmutable);
parcelHelpers.export(exports, "createDraft", ()=>createDraft);
parcelHelpers.export(exports, "current", ()=>current);
parcelHelpers.export(exports, "enableArrayMethods", ()=>enableArrayMethods);
parcelHelpers.export(exports, "enableMapSet", ()=>enableMapSet);
parcelHelpers.export(exports, "enablePatches", ()=>enablePatches);
parcelHelpers.export(exports, "finishDraft", ()=>finishDraft);
parcelHelpers.export(exports, "freeze", ()=>freeze);
parcelHelpers.export(exports, "immerable", ()=>DRAFTABLE);
parcelHelpers.export(exports, "isDraft", ()=>isDraft);
parcelHelpers.export(exports, "isDraftable", ()=>isDraftable);
parcelHelpers.export(exports, "nothing", ()=>NOTHING);
parcelHelpers.export(exports, "original", ()=>original);
parcelHelpers.export(exports, "produce", ()=>produce);
parcelHelpers.export(exports, "produceWithPatches", ()=>produceWithPatches);
parcelHelpers.export(exports, "setAutoFreeze", ()=>setAutoFreeze);
parcelHelpers.export(exports, "setUseStrictIteration", ()=>setUseStrictIteration);
parcelHelpers.export(exports, "setUseStrictShallowCopy", ()=>setUseStrictShallowCopy);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var O = Object;
var getPrototypeOf = O.getPrototypeOf;
var CONSTRUCTOR = "constructor";
var PROTOTYPE = "prototype";
var CONFIGURABLE = "configurable";
var ENUMERABLE = "enumerable";
var WRITABLE = "writable";
var VALUE = "value";
var isDraft = (value)=>!!value && !!value[DRAFT_STATE];
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || isArray(value) || !!value[DRAFTABLE] || !!((_a = value[CONSTRUCTOR]) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = O[PROTOTYPE][CONSTRUCTOR].toString();
var cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject(value) {
    if (!value || !isObjectish(value)) return false;
    const proto = getPrototypeOf(value);
    if (proto === null || proto === O[PROTOTYPE]) return true;
    const Ctor = O.hasOwnProperty.call(proto, CONSTRUCTOR) && proto[CONSTRUCTOR];
    if (Ctor === Object) return true;
    if (!isFunction(Ctor)) return false;
    let ctorString = cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter, strict = true) {
    if (getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : O.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function getArchtype(thing) {
    const state = thing[DRAFT_STATE];
    return state ? state.type_ : isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
var has = (thing, prop, type = getArchtype(thing))=>type === 2 /* Map */  ? thing.has(prop) : O[PROTOTYPE].hasOwnProperty.call(thing, prop);
var get = (thing, prop, type = getArchtype(thing))=>// @ts-ignore
    type === 2 /* Map */  ? thing.get(prop) : thing[prop];
var set = (thing, propOrOldValue, value, type = getArchtype(thing))=>{
    if (type === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (type === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
};
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
var isArray = Array.isArray;
var isMap = (target)=>target instanceof Map;
var isSet = (target)=>target instanceof Set;
var isObjectish = (target)=>typeof target === "object";
var isFunction = (target)=>typeof target === "function";
var isBoolean = (target)=>typeof target === "boolean";
function isArrayIndex(value) {
    const n = +value;
    return Number.isInteger(n) && String(n) === value;
}
var getProxyDraft = (value)=>{
    if (!isObjectish(value)) return null;
    return value == null ? void 0 : value[DRAFT_STATE];
};
var latest = (state)=>state.copy_ || state.base_;
var getValue = (value)=>{
    var _a;
    const proxyDraft = getProxyDraft(value);
    return proxyDraft ? (_a = proxyDraft.copy_) != null ? _a : proxyDraft.base_ : value;
};
var getFinalValue = (state)=>state.modified_ ? state.copy_ : state.base_;
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (isArray(base)) return Array[PROTOTYPE].slice.call(base);
    const isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = O.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc[WRITABLE] === false) {
                desc[WRITABLE] = true;
                desc[CONFIGURABLE] = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                [CONFIGURABLE]: true,
                [WRITABLE]: true,
                // could live with !!desc.set as well here...
                [ENUMERABLE]: desc[ENUMERABLE],
                [VALUE]: base[key]
            };
        }
        return O.create(getPrototypeOf(base), descriptors);
    } else {
        const proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        const obj = O.create(proto);
        return O.assign(obj, base);
    }
}
function freeze(obj, deep = false) {
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) O.defineProperties(obj, {
        set: dontMutateMethodOverride,
        add: dontMutateMethodOverride,
        clear: dontMutateMethodOverride,
        delete: dontMutateMethodOverride
    });
    O.freeze(obj);
    if (deep) each(obj, (_key, value)=>{
        freeze(value, true);
    }, false);
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
var dontMutateMethodOverride = {
    [VALUE]: dontMutateFrozenCollections
};
function isFrozen(obj) {
    if (obj === null || !isObjectish(obj)) return true;
    return O.isFrozen(obj);
}
// src/utils/plugins.ts
var PluginMapSet = "MapSet";
var PluginPatches = "Patches";
var PluginArrayMethods = "ArrayMethods";
var plugins = {};
function getPlugin(pluginKey) {
    const plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
var isPluginLoaded = (pluginKey)=>!!plugins[pluginKey];
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
var getCurrentScope = ()=>currentScope;
var createScope = (parent_, immer_)=>({
        drafts_: [],
        parent_,
        immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0,
        handledSet_: /* @__PURE__ */ new Set(),
        processedForPatches_: /* @__PURE__ */ new Set(),
        mapSetPlugin_: isPluginLoaded(PluginMapSet) ? getPlugin(PluginMapSet) : void 0,
        arrayMethodsPlugin_: isPluginLoaded(PluginArrayMethods) ? getPlugin(PluginArrayMethods) : void 0
    });
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        scope.patchPlugin_ = getPlugin(PluginPatches);
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
var enterScope = (immer2)=>currentScope = createScope(currentScope, immer2);
function revokeDraft(draft) {
    const state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) result = finalize(scope, result);
        const { patchPlugin_ } = scope;
        if (patchPlugin_) patchPlugin_.generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope);
    } else result = finalize(scope, baseDraft);
    maybeFreeze(scope, result, true);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value) {
    if (isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    if (!state) {
        const finalValue = handleValue(value, rootScope.handledSet_, rootScope);
        return finalValue;
    }
    if (!isSameScope(state, rootScope)) return value;
    if (!state.modified_) return state.base_;
    if (!state.finalized_) {
        const { callbacks_ } = state;
        if (callbacks_) while(callbacks_.length > 0){
            const callback = callbacks_.pop();
            callback(rootScope);
        }
        generatePatchesAndFinalize(state, rootScope);
    }
    return state.copy_;
}
function maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
function markStateFinalized(state) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
}
var isSameScope = (state, rootScope)=>state.scope_ === rootScope;
var EMPTY_LOCATIONS_RESULT = [];
function updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
    var _a;
    const parentCopy = latest(parent);
    const parentType = parent.type_;
    if (originalKey !== void 0) {
        const currentValue = get(parentCopy, originalKey, parentType);
        if (currentValue === draftValue) {
            set(parentCopy, originalKey, finalizedValue, parentType);
            return;
        }
    }
    if (!parent.draftLocations_) {
        const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
        each(parentCopy, (key, value)=>{
            if (isDraft(value)) {
                const keys = draftLocations.get(value) || [];
                keys.push(key);
                draftLocations.set(value, keys);
            }
        });
    }
    const locations = (_a = parent.draftLocations_.get(draftValue)) != null ? _a : EMPTY_LOCATIONS_RESULT;
    for (const location of locations)set(parentCopy, location, finalizedValue, parentType);
}
function registerChildFinalizationCallback(parent, child, key) {
    parent.callbacks_.push(function childCleanup(rootScope) {
        var _a, _b;
        const state = child;
        if (!state || !isSameScope(state, rootScope)) return;
        (_a = rootScope.mapSetPlugin_) == null || _a.fixSetContents(state);
        const finalizedValue = getFinalValue(state);
        updateDraftInParent(parent, (_b = state.draft_) != null ? _b : state, finalizedValue, key);
        generatePatchesAndFinalize(state, rootScope);
    });
}
function generatePatchesAndFinalize(state, rootScope) {
    var _a, _b;
    const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 /* Set */  || state.type_ === 1 /* Array */  && state.allIndicesReassigned_ || ((_b = (_a = state.assigned_) == null ? void 0 : _a.size) != null ? _b : 0) > 0);
    if (shouldFinalize) {
        const { patchPlugin_ } = rootScope;
        if (patchPlugin_) {
            const basePath = patchPlugin_.getPath(state);
            if (basePath) patchPlugin_.generatePatches_(state, basePath, rootScope);
        }
        markStateFinalized(state);
    }
}
function handleCrossReference(target, key, value) {
    const { scope_ } = target;
    if (isDraft(value)) {
        const state = value[DRAFT_STATE];
        if (isSameScope(state, scope_)) state.callbacks_.push(function crossReferenceCleanup() {
            prepareCopy(target);
            const finalizedValue = getFinalValue(state);
            updateDraftInParent(target, value, finalizedValue, key);
        });
    } else if (isDraftable(value)) target.callbacks_.push(function nestedDraftCleanup() {
        var _a;
        const targetCopy = latest(target);
        if (get(targetCopy, key, target.type_) === value) {
            if (scope_.drafts_.length > 1 && ((_a = target.assigned_.get(key)) != null ? _a : false) === true && target.copy_) handleValue(get(target.copy_, key, target.type_), scope_.handledSet_, scope_);
        }
    });
}
function handleValue(target, handledSet, rootScope) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return target;
    if (isDraft(target) || handledSet.has(target) || !isDraftable(target) || isFrozen(target)) return target;
    handledSet.add(target);
    each(target, (key, value)=>{
        if (isDraft(value)) {
            const state = value[DRAFT_STATE];
            if (isSameScope(state, rootScope)) {
                const updatedValue = getFinalValue(state);
                set(target, key, updatedValue, target.type_);
                markStateFinalized(state);
            }
        } else if (isDraftable(value)) handleValue(value, handledSet, rootScope);
    });
    return target;
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    const baseIsArray = isArray(base);
    const state = {
        type_: baseIsArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        // actually instantiated in `prepareCopy()`
        assigned_: void 0,
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false,
        // `callbacks` actually gets assigned in `createProxy`
        callbacks_: void 0
    };
    let target = state;
    let traps = objectTraps;
    if (baseIsArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    const { revoke, proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return [
        proxy,
        state
    ];
}
var objectTraps = {
    get (state, prop) {
        if (prop === DRAFT_STATE) return state;
        let arrayPlugin = state.scope_.arrayMethodsPlugin_;
        const isArrayWithStringProp = state.type_ === 1 /* Array */  && typeof prop === "string";
        if (isArrayWithStringProp) {
            if (arrayPlugin == null ? void 0 : arrayPlugin.isArrayOperationMethod(prop)) return arrayPlugin.createMethodInterceptor(state, prop);
        }
        const source = latest(state);
        if (!has(source, prop, state.type_)) return readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (isArrayWithStringProp && state.operationMethod && (arrayPlugin == null ? void 0 : arrayPlugin.isMutatingArrayMethod(state.operationMethod)) && isArrayIndex(prop)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            const childKey = state.type_ === 1 /* Array */  ? +prop : prop;
            const childDraft = createProxy(state.scope_, value, state, childKey);
            return state.copy_[childKey] = childDraft;
        }
        return value;
    },
    has (state, prop) {
        return prop in latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys(latest(state));
    },
    set (state, prop, value) {
        const desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = peek(latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_.set(prop, false);
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop, state.type_))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_.set(prop, true);
        handleCrossReference(state, prop, value);
        return true;
    },
    deleteProperty (state, prop) {
        prepareCopy(state);
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_.set(prop, false);
            markChanged(state);
        } else state.assigned_.delete(prop);
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            [WRITABLE]: true,
            [CONFIGURABLE]: state.type_ !== 1 /* Array */  || prop !== "length",
            [ENUMERABLE]: desc[ENUMERABLE],
            [VALUE]: owner[prop]
        };
    },
    defineProperty () {
        die(11);
    },
    getPrototypeOf (state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, (key, fn)=>{
    arrayTraps[key] = function() {
        const args = arguments;
        args[0] = args[0][0];
        return fn.apply(this, args);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    const state = draft[DRAFT_STATE];
    const source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    const desc = getDescriptorFromProto(source, prop);
    return desc ? VALUE in desc ? desc[VALUE] : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) {
        state.assigned_ = /* @__PURE__ */ new Map();
        state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
    }
}
// src/core/immerClass.ts
var Immer2 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (isFunction(base) && !isFunction(recipe)) {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (!isFunction(recipe)) die(6);
            if (patchListener !== void 0 && !isFunction(patchListener)) die(7);
            let result;
            if (isDraftable(base)) {
                const scope = enterScope(this);
                const proxy = createProxy(scope, base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || !isObjectish(base)) {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    getPlugin(PluginPatches).generateReplacementPatches_(base, result, {
                        patches_: p,
                        inversePatches_: ip
                    });
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (isFunction(base)) return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (isBoolean(config == null ? void 0 : config.autoFreeze)) this.setAutoFreeze(config.autoFreeze);
        if (isBoolean(config == null ? void 0 : config.useStrictShallowCopy)) this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if (isBoolean(config == null ? void 0 : config.useStrictIteration)) this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!isDraftable(base)) die(8);
        if (isDraft(base)) base = current(base);
        const scope = enterScope(this);
        const proxy = createProxy(scope, base, void 0);
        proxy[DRAFT_STATE].isManual_ = true;
        leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[DRAFT_STATE];
        if (!state || !state.isManual_) die(9);
        const { scope_: scope } = state;
        usePatchesInScope(scope, patchListener);
        return processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = getPlugin(PluginPatches).applyPatches_;
        if (isDraft(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function createProxy(rootScope, value, parent, key) {
    var _a, _b;
    const [draft, state] = isMap(value) ? getPlugin(PluginMapSet).proxyMap_(value, parent) : isSet(value) ? getPlugin(PluginMapSet).proxySet_(value, parent) : createProxyProxy(value, parent);
    const scope = (_a = parent == null ? void 0 : parent.scope_) != null ? _a : getCurrentScope();
    scope.drafts_.push(draft);
    state.callbacks_ = (_b = parent == null ? void 0 : parent.callbacks_) != null ? _b : [];
    state.key_ = key;
    if (parent && key !== void 0) registerChildFinalizationCallback(parent, state, key);
    else state.callbacks_.push(function rootDraftCleanup(rootScope2) {
        var _a2;
        (_a2 = rootScope2.mapSetPlugin_) == null || _a2.fixSetContents(state);
        const { patchPlugin_ } = rootScope2;
        if (state.modified_ && patchPlugin_) patchPlugin_.generatePatches_(state, [], rootScope2);
    });
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = shallowCopy(value, true);
    each(copy, (key, childValue)=>{
        set(copy, key, currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    const errorOffset = 16;
    function getPath(state, path = []) {
        var _a;
        if ("key_" in state && state.key_ !== void 0) {
            const parentCopy = (_a = state.parent_.copy_) != null ? _a : state.parent_.base_;
            const proxyDraft = getProxyDraft(get(parentCopy, state.key_));
            const valueAtKey = get(parentCopy, state.key_);
            if (valueAtKey === void 0) return null;
            if (valueAtKey !== state.draft_ && valueAtKey !== state.base_ && valueAtKey !== state.copy_) return null;
            if (proxyDraft != null && proxyDraft.base_ !== state.base_) return null;
            const isSet2 = state.parent_.type_ === 3 /* Set */ ;
            let key;
            if (isSet2) {
                const setParent = state.parent_;
                key = Array.from(setParent.drafts_.keys()).indexOf(state.key_);
            } else key = state.key_;
            if (!(isSet2 && parentCopy.size > key || has(parentCopy, key))) return null;
            path.push(key);
        }
        if (state.parent_) return getPath(state.parent_, path);
        path.reverse();
        try {
            resolvePath(state.copy_, path);
        } catch (e) {
            return null;
        }
        return path;
    }
    function resolvePath(base, path) {
        let current2 = base;
        for(let i = 0; i < path.length - 1; i++){
            const key = path[i];
            current2 = get(current2, key);
            if (!isObjectish(current2) || current2 === null) throw new Error(`Cannot resolve path at '${path.join("/")}'`);
        }
        return current2;
    }
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, scope) {
        if (state.scope_.processedForPatches_.has(state)) return;
        state.scope_.processedForPatches_.add(state);
        const { patches_, inversePatches_ } = scope;
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches_, inversePatches_);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches_, inversePatches_);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches_, inversePatches_);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_, assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        const allReassigned = state.allIndicesReassigned_ === true;
        for(let i = 0; i < base_.length; i++){
            const copiedItem = copy_[i];
            const baseItem = base_[i];
            const isAssigned = allReassigned || (assigned_ == null ? void 0 : assigned_.get(i.toString()));
            if (isAssigned && copiedItem !== baseItem) {
                const childState = copiedItem == null ? void 0 : copiedItem[DRAFT_STATE];
                if (childState && childState.modified_) continue;
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REPLACE,
                    path,
                    // Need to maybe clone it, as it can in fact be the original value
                    // due to the base/copy inversion at the start of this function
                    value: clonePatchValueIfNeeded(copiedItem)
                });
                inversePatches.push({
                    op: REPLACE,
                    path,
                    value: clonePatchValueIfNeeded(baseItem)
                });
            }
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_, copy_, type_ } = state;
        each(state.assigned_, (key, assignedValue)=>{
            const origValue = get(base_, key, type_);
            const value = get(copy_, key, type_);
            const op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op,
                path
            } : {
                op,
                path,
                value: clonePatchValueIfNeeded(value)
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path
            } : op === REMOVE ? {
                op: ADD,
                path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_, copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: ADD,
                    path,
                    value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path,
                    value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, scope) {
        const { patches_, inversePatches_ } = scope;
        patches_.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches_.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path, op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === CONSTRUCTOR)) die(errorOffset + 3);
                if (isFunction(base) && p === PROTOTYPE) die(errorOffset + 3);
                base = get(base, p);
                if (!isObjectish(base)) die(errorOffset + 2, path.join("/"));
            }
            const type = getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create(getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin(PluginPatches, {
        applyPatches_,
        generatePatches_,
        generateReplacementPatches_,
        getPath
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false,
                callbacks_: []
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(key) {
            return latest(this[DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!latest(state).has(key) || latest(state).get(key) !== value) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[DRAFT_STATE];
            latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            const value = latest(state).get(key);
            if (state.finalized_ || !isDraftable(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = createProxy(state.scope_, value, state, key);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return latest(this[DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        const map = new DraftMap(target, parent);
        return [
            map,
            map[DRAFT_STATE]
        ];
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false,
                assigned_: void 0,
                callbacks_: []
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        const set2 = new DraftSet(target, parent);
        return [
            set2,
            set2[DRAFT_STATE]
        ];
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if (isDraftable(value)) {
                    const draft = createProxy(state.scope_, value, state, value);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    function fixSetContents(target) {
        if (target.type_ === 3 /* Set */  && target.copy_) {
            const copy = new Set(target.copy_);
            target.copy_.clear();
            copy.forEach((value)=>{
                target.copy_.add(getValue(value));
            });
        }
    }
    loadPlugin(PluginMapSet, {
        proxyMap_,
        proxySet_,
        fixSetContents
    });
}
// src/plugins/arrayMethods.ts
function enableArrayMethods() {
    const SHIFTING_METHODS = /* @__PURE__ */ new Set([
        "shift",
        "unshift"
    ]);
    const QUEUE_METHODS = /* @__PURE__ */ new Set([
        "push",
        "pop"
    ]);
    const RESULT_RETURNING_METHODS = /* @__PURE__ */ new Set([
        ...QUEUE_METHODS,
        ...SHIFTING_METHODS
    ]);
    const REORDERING_METHODS = /* @__PURE__ */ new Set([
        "reverse",
        "sort"
    ]);
    const MUTATING_METHODS = /* @__PURE__ */ new Set([
        ...RESULT_RETURNING_METHODS,
        ...REORDERING_METHODS,
        "splice"
    ]);
    const FIND_METHODS = /* @__PURE__ */ new Set([
        "find",
        "findLast"
    ]);
    const NON_MUTATING_METHODS = /* @__PURE__ */ new Set([
        "filter",
        "slice",
        "concat",
        "flat",
        ...FIND_METHODS,
        "findIndex",
        "findLastIndex",
        "some",
        "every",
        "indexOf",
        "lastIndexOf",
        "includes",
        "join",
        "toString",
        "toLocaleString"
    ]);
    function isMutatingArrayMethod(method) {
        return MUTATING_METHODS.has(method);
    }
    function isNonMutatingArrayMethod(method) {
        return NON_MUTATING_METHODS.has(method);
    }
    function isArrayOperationMethod(method) {
        return isMutatingArrayMethod(method) || isNonMutatingArrayMethod(method);
    }
    function enterOperation(state, method) {
        state.operationMethod = method;
    }
    function exitOperation(state) {
        state.operationMethod = void 0;
    }
    function executeArrayMethod(state, operation, markLength = true) {
        prepareCopy(state);
        const result = operation();
        markChanged(state);
        if (markLength) state.assigned_.set("length", true);
        return result;
    }
    function markAllIndicesReassigned(state) {
        state.allIndicesReassigned_ = true;
    }
    function normalizeSliceIndex(index, length) {
        if (index < 0) return Math.max(length + index, 0);
        return Math.min(index, length);
    }
    function handleSimpleOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            const result = state.copy_[method](...args);
            if (SHIFTING_METHODS.has(method)) markAllIndicesReassigned(state);
            return RESULT_RETURNING_METHODS.has(method) ? result : state.draft_;
        });
    }
    function handleReorderingOperation(state, method, args) {
        return executeArrayMethod(state, ()=>{
            state.copy_[method](...args);
            markAllIndicesReassigned(state);
            return state.draft_;
        }, false);
    }
    function createMethodInterceptor(state, originalMethod) {
        return function interceptedMethod(...args) {
            const method = originalMethod;
            enterOperation(state, method);
            try {
                if (isMutatingArrayMethod(method)) {
                    if (RESULT_RETURNING_METHODS.has(method)) return handleSimpleOperation(state, method, args);
                    if (REORDERING_METHODS.has(method)) return handleReorderingOperation(state, method, args);
                    if (method === "splice") {
                        const res = executeArrayMethod(state, ()=>state.copy_.splice(...args));
                        markAllIndicesReassigned(state);
                        return res;
                    }
                } else return handleNonMutatingOperation(state, method, args);
            } finally{
                exitOperation(state);
            }
        };
    }
    function handleNonMutatingOperation(state, method, args) {
        var _a, _b;
        const source = latest(state);
        if (method === "filter") {
            const predicate = args[0];
            const result = [];
            for(let i = 0; i < source.length; i++)if (predicate(source[i], i, source)) result.push(state.draft_[i]);
            return result;
        }
        if (FIND_METHODS.has(method)) {
            const predicate = args[0];
            const isForward = method === "find";
            const step = isForward ? 1 : -1;
            const start = isForward ? 0 : source.length - 1;
            for(let i = start; i >= 0 && i < source.length; i += step){
                if (predicate(source[i], i, source)) return state.draft_[i];
            }
            return void 0;
        }
        if (method === "slice") {
            const rawStart = (_a = args[0]) != null ? _a : 0;
            const rawEnd = (_b = args[1]) != null ? _b : source.length;
            const start = normalizeSliceIndex(rawStart, source.length);
            const end = normalizeSliceIndex(rawEnd, source.length);
            const result = [];
            for(let i = start; i < end; i++)result.push(state.draft_[i]);
            return result;
        }
        return source[method](...args);
    }
    loadPlugin(PluginArrayMethods, {
        createMethodInterceptor,
        isArrayOperationMethod,
        isMutatingArrayMethod
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = /* @__PURE__ */ immer.produceWithPatches.bind(immer);
var setAutoFreeze = /* @__PURE__ */ immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = /* @__PURE__ */ immer.setUseStrictShallowCopy.bind(immer);
var setUseStrictIteration = /* @__PURE__ */ immer.setUseStrictIteration.bind(immer);
var applyPatches = /* @__PURE__ */ immer.applyPatches.bind(immer);
var createDraft = /* @__PURE__ */ immer.createDraft.bind(immer);
var finishDraft = /* @__PURE__ */ immer.finishDraft.bind(immer);
var castDraft = (value)=>value;
var castImmutable = (value)=>value;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ds2su":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createSelector", ()=>createSelector);
parcelHelpers.export(exports, "createSelectorCreator", ()=>createSelectorCreator);
parcelHelpers.export(exports, "createStructuredSelector", ()=>createStructuredSelector);
parcelHelpers.export(exports, "lruMemoize", ()=>lruMemoize);
parcelHelpers.export(exports, "referenceEqualityCheck", ()=>referenceEqualityCheck);
parcelHelpers.export(exports, "setGlobalDevModeChecks", ()=>setGlobalDevModeChecks);
parcelHelpers.export(exports, "unstable_autotrackMemoize", ()=>autotrackMemoize);
parcelHelpers.export(exports, "weakMapMemoize", ()=>weakMapMemoize);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __publicField = (obj, key, value)=>{
    __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize, memoizeOptions } = options;
    const { inputSelectorResults, inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var setGlobalDevModeChecks = (devModeChecks)=>{
    Object.assign(globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var NOT_FOUND = /* @__PURE__ */ Symbol("NOT_FOUND");
function assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck, inputStabilityCheck } = __spreadValues(__spreadValues({}, globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $REVISION = 0;
var CURRENT_TRACKER = null;
var Cell = class {
    constructor(initialValue, isEqual = tripleEq){
        __publicField(this, "revision", $REVISION);
        __publicField(this, "_value");
        __publicField(this, "_lastValue");
        __publicField(this, "_isEqual", tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        CURRENT_TRACKER == null || CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$REVISION;
    }
};
function tripleEq(a, b) {
    return a === b;
}
var TrackingCache = class {
    constructor(fn){
        __publicField(this, "_cachedValue");
        __publicField(this, "_cachedRevision", -1);
        __publicField(this, "_deps", []);
        __publicField(this, "hits", 0);
        __publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = CURRENT_TRACKER;
            CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        CURRENT_TRACKER == null || CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function getValue(cell) {
    if (!(cell instanceof Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function setValue(storage, value) {
    if (!(storage instanceof Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function createCell(initialValue, isEqual = tripleEq) {
    return new Cell(initialValue, isEqual);
}
function createCache(fn) {
    assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var neverEq = (a, b)=>false;
function createTag() {
    return createCell(null, neverEq);
}
function dirtyTag(tag, value) {
    setValue(tag, value);
}
var consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = createTag();
    getValue(tag);
};
var dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var REDUX_PROXY_LABEL = Symbol();
var nextId = 0;
var proto = Object.getPrototypeOf({});
var ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        __publicField(this, "proxy", new Proxy(this, objectProxyHandler));
        __publicField(this, "tag", createTag());
        __publicField(this, "tags", {});
        __publicField(this, "children", {});
        __publicField(this, "collectionTag", null);
        __publicField(this, "id", nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = createNode(childValue);
                if (childNode.tag) getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = createTag();
                    tag.value = childValue;
                }
                getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        __publicField(this, "proxy", new Proxy([
            this
        ], arrayProxyHandler));
        __publicField(this, "tag", createTag());
        __publicField(this, "tags", {});
        __publicField(this, "children", {});
        __publicField(this, "collectionTag", null);
        __publicField(this, "id", nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") consumeCollection(node);
        return objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return objectProxyHandler.has(node, prop);
    }
};
function createNode(value) {
    if (Array.isArray(value)) return new ArrayTreeNode(value);
    return new ObjectTreeNode(value);
}
function updateNode(node, newValue) {
    const { value, tags, children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            dirtyCollection(node);
            dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) updateNode(childNode, newChildValue);
        else {
            deleteNode(childNode);
            delete children[key];
        }
    }
}
function deleteNode(node) {
    if (node.tag) dirtyTag(node.tag, null);
    dirtyCollection(node);
    for(const key in node.tags)dirtyTag(node.tags[key], null);
    for(const key in node.children)deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key,
                value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === NOT_FOUND) {
            entries.unshift({
                key,
                value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get,
        put,
        getEntries,
        clear
    };
}
var referenceEqualityCheck = (a, b)=>a === b;
function createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function lruMemoize(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck = referenceEqualityCheck, maxSize = 1, resultEqualityCheck } = providedOptions;
    const comparator = createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize <= 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function autotrackMemoize(func) {
    const node = createNode([]);
    let lastArgs = null;
    const shallowEqual = createCacheKeyComparator(referenceEqualityCheck);
    const cache = createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var Ref = typeof WeakRef !== "undefined" ? WeakRef : StrongRef;
var UNTERMINATED = 0;
var TERMINATED = 1;
function createCacheNode() {
    return {
        s: UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function weakMapMemoize(func, options = {}) {
    let fnNode = createCacheNode();
    const { resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
                if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                    result = lastResultValue;
                    resultsCount !== 0 && resultsCount--;
                }
                const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
                lastResult = needsWeakRef ? new Ref(result) : result;
            }
        }
        terminatedNode.s = TERMINATED;
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function createSelectorCreator(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = __spreadValues(__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize, memoizeOptions = [], argsMemoize = weakMapMemoize, argsMemoizeOptions = [], devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = ensureIsArray(argsMemoizeOptions);
        const dependencies = getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc,
            memoizedResultFunc,
            dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize,
            argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var createSelector = /* @__PURE__ */ createSelectorCreator(weakMapMemoize);
// src/createStructuredSelector.ts
var createStructuredSelector = Object.assign((inputSelectorsObject, selectorCreator = createSelector)=>{
    assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>createStructuredSelector
});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cC21f":[function(require,module,exports,__globalThis) {
// src/index.ts
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "thunk", ()=>thunk);
parcelHelpers.export(exports, "withExtraArgument", ()=>withExtraArgument);
function createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch, getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"caUjq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectBrushHeight", ()=>selectBrushHeight);
parcelHelpers.export(exports, "selectChartOffsetInternal", ()=>selectChartOffsetInternal);
parcelHelpers.export(exports, "selectChartViewBox", ()=>selectChartViewBox);
parcelHelpers.export(exports, "selectAxisViewBox", ()=>selectAxisViewBox);
var _reselect = require("reselect");
var _legendSelectors = require("./legendSelectors");
var _chartUtils = require("../../util/ChartUtils");
var _containerSelectors = require("./containerSelectors");
var _selectAllAxes = require("./selectAllAxes");
var _constants = require("../../util/Constants");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var selectBrushHeight = (state)=>state.brush.height;
function selectLeftAxesOffset(state) {
    var yAxes = (0, _selectAllAxes.selectAllYAxes)(state);
    return yAxes.reduce((result, entry)=>{
        if (entry.orientation === 'left' && !entry.mirror && !entry.hide) {
            var width = typeof entry.width === 'number' ? entry.width : (0, _constants.DEFAULT_Y_AXIS_WIDTH);
            return result + width;
        }
        return result;
    }, 0);
}
function selectRightAxesOffset(state) {
    var yAxes = (0, _selectAllAxes.selectAllYAxes)(state);
    return yAxes.reduce((result, entry)=>{
        if (entry.orientation === 'right' && !entry.mirror && !entry.hide) {
            var width = typeof entry.width === 'number' ? entry.width : (0, _constants.DEFAULT_Y_AXIS_WIDTH);
            return result + width;
        }
        return result;
    }, 0);
}
function selectTopAxesOffset(state) {
    var xAxes = (0, _selectAllAxes.selectAllXAxes)(state);
    return xAxes.reduce((result, entry)=>{
        if (entry.orientation === 'top' && !entry.mirror && !entry.hide) return result + entry.height;
        return result;
    }, 0);
}
function selectBottomAxesOffset(state) {
    var xAxes = (0, _selectAllAxes.selectAllXAxes)(state);
    return xAxes.reduce((result, entry)=>{
        if (entry.orientation === 'bottom' && !entry.mirror && !entry.hide) return result + entry.height;
        return result;
    }, 0);
}
var selectChartOffsetInternal = (0, _reselect.createSelector)([
    (0, _containerSelectors.selectChartWidth),
    (0, _containerSelectors.selectChartHeight),
    (0, _containerSelectors.selectMargin),
    selectBrushHeight,
    selectLeftAxesOffset,
    selectRightAxesOffset,
    selectTopAxesOffset,
    selectBottomAxesOffset,
    (0, _legendSelectors.selectLegendSettings),
    (0, _legendSelectors.selectLegendSize)
], (chartWidth, chartHeight, margin, brushHeight, leftAxesOffset, rightAxesOffset, topAxesOffset, bottomAxesOffset, legendSettings, legendSize)=>{
    var offsetH = {
        left: (margin.left || 0) + leftAxesOffset,
        right: (margin.right || 0) + rightAxesOffset
    };
    var offsetV = {
        top: (margin.top || 0) + topAxesOffset,
        bottom: (margin.bottom || 0) + bottomAxesOffset
    };
    var offset = _objectSpread(_objectSpread({}, offsetV), offsetH);
    var brushBottom = offset.bottom;
    offset.bottom += brushHeight;
    offset = (0, _chartUtils.appendOffsetOfLegend)(offset, legendSettings, legendSize);
    var offsetWidth = chartWidth - offset.left - offset.right;
    var offsetHeight = chartHeight - offset.top - offset.bottom;
    return _objectSpread(_objectSpread({
        brushBottom
    }, offset), {}, {
        // never return negative values for height and width
        width: Math.max(offsetWidth, 0),
        height: Math.max(offsetHeight, 0)
    });
});
var selectChartViewBox = (0, _reselect.createSelector)(selectChartOffsetInternal, (offset)=>({
        x: offset.left,
        y: offset.top,
        width: offset.width,
        height: offset.height
    }));
var selectAxisViewBox = (0, _reselect.createSelector)((0, _containerSelectors.selectChartWidth), (0, _containerSelectors.selectChartHeight), (width, height)=>({
        x: 0,
        y: 0,
        width,
        height
    }));

},{"reselect":"ds2su","./legendSelectors":"9IH6M","../../util/ChartUtils":"enJyE","./containerSelectors":"lnBke","./selectAllAxes":"3qrY7","../../util/Constants":"5DKvC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9IH6M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectLegendSettings", ()=>selectLegendSettings);
parcelHelpers.export(exports, "selectLegendSize", ()=>selectLegendSize);
parcelHelpers.export(exports, "selectLegendPayload", ()=>selectLegendPayload);
var _reselect = require("reselect");
var _sortBy = require("es-toolkit/compat/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var selectLegendSettings = (state)=>state.legend.settings;
var selectLegendSize = (state)=>state.legend.size;
var selectAllLegendPayload2DArray = (state)=>state.legend.payload;
var selectLegendPayload = (0, _reselect.createSelector)([
    selectAllLegendPayload2DArray,
    selectLegendSettings
], (payloads, _ref)=>{
    var { itemSorter } = _ref;
    var flat = payloads.flat(1);
    return itemSorter ? (0, _sortByDefault.default)(flat, itemSorter) : flat;
});

},{"reselect":"ds2su","es-toolkit/compat/sortBy":"jVc75","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lnBke":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectChartWidth", ()=>selectChartWidth);
parcelHelpers.export(exports, "selectChartHeight", ()=>selectChartHeight);
parcelHelpers.export(exports, "selectContainerScale", ()=>selectContainerScale);
parcelHelpers.export(exports, "selectMargin", ()=>selectMargin);
var selectChartWidth = (state)=>state.layout.width;
var selectChartHeight = (state)=>state.layout.height;
var selectContainerScale = (state)=>state.layout.scale;
var selectMargin = (state)=>state.layout.margin;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3qrY7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectAllXAxes", ()=>selectAllXAxes);
parcelHelpers.export(exports, "selectAllYAxes", ()=>selectAllYAxes);
var _reselect = require("reselect");
var selectAllXAxes = (0, _reselect.createSelector)((state)=>state.cartesianAxis.xAxis, (xAxisMap)=>{
    return Object.values(xAxisMap);
});
var selectAllYAxes = (0, _reselect.createSelector)((state)=>state.cartesianAxis.yAxis, (yAxisMap)=>{
    return Object.values(yAxisMap);
});

},{"reselect":"ds2su","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5DKvC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "COLOR_PANEL", ()=>COLOR_PANEL);
parcelHelpers.export(exports, "DATA_ITEM_INDEX_ATTRIBUTE_NAME", ()=>DATA_ITEM_INDEX_ATTRIBUTE_NAME);
parcelHelpers.export(exports, "DATA_ITEM_GRAPHICAL_ITEM_ID_ATTRIBUTE_NAME", ()=>DATA_ITEM_GRAPHICAL_ITEM_ID_ATTRIBUTE_NAME);
parcelHelpers.export(exports, "DEFAULT_Y_AXIS_WIDTH", ()=>DEFAULT_Y_AXIS_WIDTH);
var COLOR_PANEL = [
    '#1890FF',
    '#66B5FF',
    '#41D9C7',
    '#2FC25B',
    '#6EDB8F',
    '#9AE65C',
    '#FACC14',
    '#E6965C',
    '#57AD71',
    '#223273',
    '#738AE6',
    '#7564CC',
    '#8543E0',
    '#A877ED',
    '#5C8EE6',
    '#13C2C2',
    '#70E0E0',
    '#5CA3E6',
    '#3436C7',
    '#8082FF',
    '#DD81E6',
    '#F04864',
    '#FA7D92',
    '#D598D9'
];
var DATA_ITEM_INDEX_ATTRIBUTE_NAME = 'data-recharts-item-index';
var DATA_ITEM_GRAPHICAL_ITEM_ID_ATTRIBUTE_NAME = 'data-recharts-item-id';
var DEFAULT_Y_AXIS_WIDTH = 60;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"10hMm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIsPanorama", ()=>useIsPanorama);
parcelHelpers.export(exports, "PanoramaContextProvider", ()=>PanoramaContextProvider);
var _react = require("react");
var PanoramaContext = /*#__PURE__*/ (0, _react.createContext)(null);
var useIsPanorama = ()=>(0, _react.useContext)(PanoramaContext) != null;
var PanoramaContextProvider = (_ref)=>{
    var { children } = _ref;
    return /*#__PURE__*/ _react.createElement(PanoramaContext.Provider, {
        value: true
    }, children);
};

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3YEO3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectBrushSettings", ()=>selectBrushSettings);
parcelHelpers.export(exports, "selectBrushDimensions", ()=>selectBrushDimensions);
var _reselect = require("reselect");
var _selectChartOffsetInternal = require("./selectChartOffsetInternal");
var _containerSelectors = require("./containerSelectors");
var _dataUtils = require("../../util/DataUtils");
var selectBrushSettings = (state)=>state.brush;
var selectBrushDimensions = (0, _reselect.createSelector)([
    selectBrushSettings,
    (0, _selectChartOffsetInternal.selectChartOffsetInternal),
    (0, _containerSelectors.selectMargin)
], (brushSettings, offset, margin)=>({
        height: brushSettings.height,
        x: (0, _dataUtils.isNumber)(brushSettings.x) ? brushSettings.x : offset.left,
        y: (0, _dataUtils.isNumber)(brushSettings.y) ? brushSettings.y : offset.top + offset.height + offset.brushBottom - ((margin === null || margin === void 0 ? void 0 : margin.bottom) || 0),
        width: (0, _dataUtils.isNumber)(brushSettings.width) ? brushSettings.width : offset.width
    }));

},{"reselect":"ds2su","./selectChartOffsetInternal":"caUjq","./containerSelectors":"lnBke","../../util/DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7epZf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useResponsiveContainerContext", ()=>useResponsiveContainerContext);
parcelHelpers.export(exports, "ResponsiveContainer", ()=>ResponsiveContainer);
var _clsx = require("clsx");
var _react = require("react");
var _throttle = require("es-toolkit/compat/throttle");
var _throttleDefault = parcelHelpers.interopDefault(_throttle);
var _dataUtils = require("../util/DataUtils");
var _logUtils = require("../util/LogUtils");
var _responsiveContainerUtils = require("./responsiveContainerUtils");
var _isWellBehavedNumber = require("../util/isWellBehavedNumber");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var ResponsiveContainerContext = /*#__PURE__*/ (0, _react.createContext)({
    width: -1,
    height: -1
});
function isAcceptableSize(size) {
    return (0, _isWellBehavedNumber.isPositiveNumber)(size.width) && (0, _isWellBehavedNumber.isPositiveNumber)(size.height);
}
function ResponsiveContainerContextProvider(_ref) {
    var { children, width, height } = _ref;
    var size = (0, _react.useMemo)(()=>({
            width,
            height
        }), [
        width,
        height
    ]);
    if (!isAcceptableSize(size)) /*
     * Don't render the container if width or height is non-positive because
     * in that case the chart will not be rendered properly anyway.
     * We will instead wait for the next resize event to provide the correct dimensions.
     */ return null;
    return /*#__PURE__*/ _react.createElement(ResponsiveContainerContext.Provider, {
        value: size
    }, children);
}
var useResponsiveContainerContext = ()=>(0, _react.useContext)(ResponsiveContainerContext);
var SizeDetectorContainer = /*#__PURE__*/ (0, _react.forwardRef)((_ref2, ref)=>{
    var { aspect, initialDimension = {
        width: -1,
        height: -1
    }, width, height, /*
     * default min-width to 0 if not specified - 'auto' causes issues with flexbox
     * https://github.com/recharts/recharts/issues/172
     */ minWidth = 0, minHeight, maxHeight, children, debounce = 0, id, className, onResize, style = {} } = _ref2;
    var containerRef = (0, _react.useRef)(null);
    /*
   * We are using a ref to avoid re-creating the ResizeObserver when the onResize function changes.
   * The ref is updated on every render, so the latest onResize function is always available in the effect.
   */ var onResizeRef = (0, _react.useRef)();
    onResizeRef.current = onResize;
    (0, _react.useImperativeHandle)(ref, ()=>containerRef.current);
    var [sizes, setSizes] = (0, _react.useState)({
        containerWidth: initialDimension.width,
        containerHeight: initialDimension.height
    });
    var setContainerSize = (0, _react.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    (0, _react.useEffect)(()=>{
        if (containerRef.current == null || typeof ResizeObserver === 'undefined') return 0, _dataUtils.noop;
        var callback = (entries)=>{
            var _onResizeRef$current;
            var { width: containerWidth, height: containerHeight } = entries[0].contentRect;
            setContainerSize(containerWidth, containerHeight);
            (_onResizeRef$current = onResizeRef.current) === null || _onResizeRef$current === void 0 || _onResizeRef$current.call(onResizeRef, containerWidth, containerHeight);
        };
        if (debounce > 0) callback = (0, _throttleDefault.default)(callback, debounce, {
            trailing: true,
            leading: false
        });
        var observer = new ResizeObserver(callback);
        var { width: containerWidth, height: containerHeight } = containerRef.current.getBoundingClientRect();
        setContainerSize(containerWidth, containerHeight);
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    }, [
        setContainerSize,
        debounce
    ]);
    var { containerWidth, containerHeight } = sizes;
    (0, _logUtils.warn)(!aspect || aspect > 0, 'The aspect(%s) must be greater than zero.', aspect);
    var { calculatedWidth, calculatedHeight } = (0, _responsiveContainerUtils.calculateChartDimensions)(containerWidth, containerHeight, {
        width,
        height,
        aspect,
        maxHeight
    });
    (0, _logUtils.warn)(calculatedWidth != null && calculatedWidth > 0 || calculatedHeight != null && calculatedHeight > 0, "The width(%s) and height(%s) of chart should be greater than 0,\n       please check the style of container, or the props width(%s) and height(%s),\n       or add a minWidth(%s) or minHeight(%s) or use aspect(%s) to control the\n       height and width.", calculatedWidth, calculatedHeight, width, height, minWidth, minHeight, aspect);
    return /*#__PURE__*/ _react.createElement("div", {
        id: id ? "".concat(id) : undefined,
        className: (0, _clsx.clsx)('recharts-responsive-container', className),
        style: _objectSpread(_objectSpread({}, style), {}, {
            width,
            height,
            minWidth,
            minHeight,
            maxHeight
        }),
        ref: containerRef
    }, /*#__PURE__*/ _react.createElement("div", {
        style: (0, _responsiveContainerUtils.getInnerDivStyle)({
            width,
            height
        })
    }, /*#__PURE__*/ _react.createElement(ResponsiveContainerContextProvider, {
        width: calculatedWidth,
        height: calculatedHeight
    }, children)));
});
var ResponsiveContainer = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    var responsiveContainerContext = useResponsiveContainerContext();
    if ((0, _isWellBehavedNumber.isPositiveNumber)(responsiveContainerContext.width) && (0, _isWellBehavedNumber.isPositiveNumber)(responsiveContainerContext.height)) /*
     * If we detect that we are already inside another ResponsiveContainer,
     * we do not attempt to add another layer of responsiveness.
     */ return props.children;
    var { width, height } = (0, _responsiveContainerUtils.getDefaultWidthAndHeight)({
        width: props.width,
        height: props.height,
        aspect: props.aspect
    });
    /*
   * Let's try to get the calculated dimensions without having the div container set up.
   * Sometimes this does produce fixed, positive dimensions. If so, we can skip rendering the div and monitoring its size.
   */ var { calculatedWidth, calculatedHeight } = (0, _responsiveContainerUtils.calculateChartDimensions)(undefined, undefined, {
        width,
        height,
        aspect: props.aspect,
        maxHeight: props.maxHeight
    });
    if ((0, _dataUtils.isNumber)(calculatedWidth) && (0, _dataUtils.isNumber)(calculatedHeight)) /*
     * If it just so happens that the combination of width, height, and aspect ratio
     * results in fixed dimensions, then we don't need to monitor the container's size.
     * We can just provide these fixed dimensions to the context.
     *
     * Note that here we are not checking for positive numbers;
     * if the user provides a zero or negative width/height, we will just pass that along
     * as whatever size we detect won't be helping anyway.
     */ return /*#__PURE__*/ _react.createElement(ResponsiveContainerContextProvider, {
        width: calculatedWidth,
        height: calculatedHeight
    }, props.children);
    /*
   * Static analysis did not produce fixed dimensions,
   * so we need to render a special div and monitor its size.
   */ return /*#__PURE__*/ _react.createElement(SizeDetectorContainer, _extends({}, props, {
        width: width,
        height: height,
        ref: ref
    }));
});

},{"clsx":"431Ou","react":"bmhQu","es-toolkit/compat/throttle":"bYCuM","../util/DataUtils":"lNZEj","../util/LogUtils":"dDrLn","./responsiveContainerUtils":"1wuyR","../util/isWellBehavedNumber":"aIsFR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bYCuM":[function(require,module,exports,__globalThis) {
module.exports = require("fd64c61ead6ed3b4").throttle;

},{"fd64c61ead6ed3b4":"6HVxA"}],"6HVxA":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const debounce = require("5a0d7a5ba257b53a");
function throttle(func, throttleMs = 0, options = {}) {
    const { leading = true, trailing = true } = options;
    return debounce.debounce(func, throttleMs, {
        leading,
        maxWait: throttleMs,
        trailing
    });
}
exports.throttle = throttle;

},{"5a0d7a5ba257b53a":"gR1L7"}],"gR1L7":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const debounce$1 = require("10283d435c9d6840");
function debounce(func, debounceMs = 0, options = {}) {
    if (typeof options !== 'object') options = {};
    const { leading = false, trailing = true, maxWait } = options;
    const edges = Array(2);
    if (leading) edges[0] = 'leading';
    if (trailing) edges[1] = 'trailing';
    let result = undefined;
    let pendingAt = null;
    const _debounced = debounce$1.debounce(function(...args) {
        result = func.apply(this, args);
        pendingAt = null;
    }, debounceMs, {
        edges
    });
    const debounced = function(...args) {
        if (maxWait != null) {
            if (pendingAt === null) pendingAt = Date.now();
            if (Date.now() - pendingAt >= maxWait) {
                result = func.apply(this, args);
                pendingAt = Date.now();
                _debounced.cancel();
                _debounced.schedule();
                return result;
            }
        }
        _debounced.apply(this, args);
        return result;
    };
    const flush = ()=>{
        _debounced.flush();
        return result;
    };
    debounced.cancel = _debounced.cancel;
    debounced.flush = flush;
    return debounced;
}
exports.debounce = debounce;

},{"10283d435c9d6840":"aYyTO"}],"aYyTO":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function debounce(func, debounceMs, { signal, edges } = {}) {
    let pendingThis = undefined;
    let pendingArgs = null;
    const leading = edges != null && edges.includes('leading');
    const trailing = edges == null || edges.includes('trailing');
    const invoke = ()=>{
        if (pendingArgs !== null) {
            func.apply(pendingThis, pendingArgs);
            pendingThis = undefined;
            pendingArgs = null;
        }
    };
    const onTimerEnd = ()=>{
        if (trailing) invoke();
        cancel();
    };
    let timeoutId = null;
    const schedule = ()=>{
        if (timeoutId != null) clearTimeout(timeoutId);
        timeoutId = setTimeout(()=>{
            timeoutId = null;
            onTimerEnd();
        }, debounceMs);
    };
    const cancelTimer = ()=>{
        if (timeoutId !== null) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };
    const cancel = ()=>{
        cancelTimer();
        pendingThis = undefined;
        pendingArgs = null;
    };
    const flush = ()=>{
        invoke();
    };
    const debounced = function(...args) {
        if (signal?.aborted) return;
        pendingThis = this;
        pendingArgs = args;
        const isFirstCall = timeoutId == null;
        schedule();
        if (leading && isFirstCall) invoke();
    };
    debounced.schedule = schedule;
    debounced.cancel = cancel;
    debounced.flush = flush;
    signal?.addEventListener('abort', cancel, {
        once: true
    });
    return debounced;
}
exports.debounce = debounce;

},{}],"1wuyR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateChartDimensions", ()=>calculateChartDimensions);
parcelHelpers.export(exports, "getInnerDivStyle", ()=>getInnerDivStyle);
parcelHelpers.export(exports, "getDefaultWidthAndHeight", ()=>getDefaultWidthAndHeight);
var _dataUtils = require("../util/DataUtils");
var calculateChartDimensions = (containerWidth, containerHeight, props)=>{
    var { width = '100%', height = '100%', aspect, maxHeight } = props;
    /*
   * The containerWidth and containerHeight are already percentage based because it's set as that percentage in CSS.
   * Means we don't have to calculate percentages here.
   */ var calculatedWidth = (0, _dataUtils.isPercent)(width) ? containerWidth : Number(width);
    var calculatedHeight = (0, _dataUtils.isPercent)(height) ? containerHeight : Number(height);
    if (aspect && aspect > 0) {
        // Preserve the desired aspect ratio
        if (calculatedWidth) // Will default to using width for aspect ratio
        calculatedHeight = calculatedWidth / aspect;
        else if (calculatedHeight) // But we should also take height into consideration
        calculatedWidth = calculatedHeight * aspect;
        // if maxHeight is set, overwrite if calculatedHeight is greater than maxHeight
        if (maxHeight && calculatedHeight != null && calculatedHeight > maxHeight) calculatedHeight = maxHeight;
    }
    return {
        calculatedWidth,
        calculatedHeight
    };
};
var bothOverflow = {
    width: 0,
    height: 0,
    overflow: 'visible'
};
var overflowX = {
    width: 0,
    overflowX: 'visible'
};
var overflowY = {
    height: 0,
    overflowY: 'visible'
};
var noStyle = {};
var getInnerDivStyle = (props)=>{
    var { width, height } = props;
    var isWidthPercent = (0, _dataUtils.isPercent)(width);
    var isHeightPercent = (0, _dataUtils.isPercent)(height);
    if (isWidthPercent && isHeightPercent) return bothOverflow;
    if (isWidthPercent) return overflowX;
    if (isHeightPercent) return overflowY;
    return noStyle;
};
function getDefaultWidthAndHeight(_ref) {
    var { width, height, aspect } = _ref;
    var calculatedWidth = width;
    var calculatedHeight = height;
    if (calculatedWidth === undefined && calculatedHeight === undefined) {
        calculatedWidth = '100%';
        calculatedHeight = '100%';
    } else if (calculatedWidth === undefined) calculatedWidth = aspect && aspect > 0 ? undefined : '100%';
    else if (calculatedHeight === undefined) calculatedHeight = aspect && aspect > 0 ? undefined : '100%';
    return {
        width: calculatedWidth,
        height: calculatedHeight
    };
}

},{"../util/DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jJj4n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "implicitAngleAxis", ()=>implicitAngleAxis);
parcelHelpers.export(exports, "implicitRadiusAxis", ()=>implicitRadiusAxis);
parcelHelpers.export(exports, "implicitRadialBarAngleAxis", ()=>implicitRadialBarAngleAxis);
parcelHelpers.export(exports, "implicitRadialBarRadiusAxis", ()=>implicitRadialBarRadiusAxis);
parcelHelpers.export(exports, "selectAngleAxis", ()=>selectAngleAxis);
parcelHelpers.export(exports, "selectRadiusAxis", ()=>selectRadiusAxis);
parcelHelpers.export(exports, "selectPolarOptions", ()=>selectPolarOptions);
parcelHelpers.export(exports, "selectMaxRadius", ()=>selectMaxRadius);
parcelHelpers.export(exports, "selectOuterRadius", ()=>selectOuterRadius);
parcelHelpers.export(exports, "selectAngleAxisRange", ()=>selectAngleAxisRange);
parcelHelpers.export(exports, "selectAngleAxisRangeWithReversed", ()=>selectAngleAxisRangeWithReversed);
parcelHelpers.export(exports, "selectRadiusAxisRange", ()=>selectRadiusAxisRange);
parcelHelpers.export(exports, "selectRadiusAxisRangeWithReversed", ()=>selectRadiusAxisRangeWithReversed);
parcelHelpers.export(exports, "selectPolarViewBox", ()=>selectPolarViewBox);
var _reselect = require("reselect");
var _containerSelectors = require("./containerSelectors");
var _selectChartOffsetInternal = require("./selectChartOffsetInternal");
var _polarUtils = require("../../util/PolarUtils");
var _dataUtils = require("../../util/DataUtils");
var _defaultPolarAngleAxisProps = require("../../polar/defaultPolarAngleAxisProps");
var _defaultPolarRadiusAxisProps = require("../../polar/defaultPolarRadiusAxisProps");
var _combineAxisRangeWithReverse = require("./combiners/combineAxisRangeWithReverse");
var _chartLayoutContext = require("../../context/chartLayoutContext");
var implicitAngleAxis = {
    allowDataOverflow: false,
    allowDecimals: false,
    allowDuplicatedCategory: false,
    // defaultPolarAngleAxisProps.allowDuplicatedCategory has it set to true but the actual axis rendering ignores the prop because reasons,
    dataKey: undefined,
    domain: undefined,
    id: (0, _defaultPolarAngleAxisProps.defaultPolarAngleAxisProps).angleAxisId,
    includeHidden: false,
    name: undefined,
    reversed: (0, _defaultPolarAngleAxisProps.defaultPolarAngleAxisProps).reversed,
    scale: (0, _defaultPolarAngleAxisProps.defaultPolarAngleAxisProps).scale,
    tick: (0, _defaultPolarAngleAxisProps.defaultPolarAngleAxisProps).tick,
    tickCount: undefined,
    ticks: undefined,
    type: (0, _defaultPolarAngleAxisProps.defaultPolarAngleAxisProps).type,
    unit: undefined
};
var implicitRadiusAxis = {
    allowDataOverflow: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).allowDataOverflow,
    allowDecimals: false,
    allowDuplicatedCategory: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).allowDuplicatedCategory,
    dataKey: undefined,
    domain: undefined,
    id: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).radiusAxisId,
    includeHidden: false,
    name: undefined,
    reversed: false,
    scale: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).scale,
    tick: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).tick,
    tickCount: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).tickCount,
    ticks: undefined,
    type: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).type,
    unit: undefined
};
var implicitRadialBarAngleAxis = {
    allowDataOverflow: false,
    allowDecimals: false,
    allowDuplicatedCategory: (0, _defaultPolarAngleAxisProps.defaultPolarAngleAxisProps).allowDuplicatedCategory,
    dataKey: undefined,
    domain: undefined,
    id: (0, _defaultPolarAngleAxisProps.defaultPolarAngleAxisProps).angleAxisId,
    includeHidden: false,
    name: undefined,
    reversed: false,
    scale: (0, _defaultPolarAngleAxisProps.defaultPolarAngleAxisProps).scale,
    tick: (0, _defaultPolarAngleAxisProps.defaultPolarAngleAxisProps).tick,
    tickCount: undefined,
    ticks: undefined,
    type: 'number',
    unit: undefined
};
var implicitRadialBarRadiusAxis = {
    allowDataOverflow: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).allowDataOverflow,
    allowDecimals: false,
    allowDuplicatedCategory: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).allowDuplicatedCategory,
    dataKey: undefined,
    domain: undefined,
    id: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).radiusAxisId,
    includeHidden: false,
    name: undefined,
    reversed: false,
    scale: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).scale,
    tick: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).tick,
    tickCount: (0, _defaultPolarRadiusAxisProps.defaultPolarRadiusAxisProps).tickCount,
    ticks: undefined,
    type: 'category',
    unit: undefined
};
var selectAngleAxis = (state, angleAxisId)=>{
    if (state.polarAxis.angleAxis[angleAxisId] != null) return state.polarAxis.angleAxis[angleAxisId];
    if (state.layout.layoutType === 'radial') return implicitRadialBarAngleAxis;
    return implicitAngleAxis;
};
var selectRadiusAxis = (state, radiusAxisId)=>{
    if (state.polarAxis.radiusAxis[radiusAxisId] != null) return state.polarAxis.radiusAxis[radiusAxisId];
    if (state.layout.layoutType === 'radial') return implicitRadialBarRadiusAxis;
    return implicitRadiusAxis;
};
var selectPolarOptions = (state)=>state.polarOptions;
var selectMaxRadius = (0, _reselect.createSelector)([
    (0, _containerSelectors.selectChartWidth),
    (0, _containerSelectors.selectChartHeight),
    (0, _selectChartOffsetInternal.selectChartOffsetInternal)
], (0, _polarUtils.getMaxRadius));
var selectInnerRadius = (0, _reselect.createSelector)([
    selectPolarOptions,
    selectMaxRadius
], (polarChartOptions, maxRadius)=>{
    if (polarChartOptions == null) return undefined;
    return (0, _dataUtils.getPercentValue)(polarChartOptions.innerRadius, maxRadius, 0);
});
var selectOuterRadius = (0, _reselect.createSelector)([
    selectPolarOptions,
    selectMaxRadius
], (polarChartOptions, maxRadius)=>{
    if (polarChartOptions == null) return undefined;
    return (0, _dataUtils.getPercentValue)(polarChartOptions.outerRadius, maxRadius, maxRadius * 0.8);
});
var combineAngleAxisRange = (polarOptions)=>{
    if (polarOptions == null) return [
        0,
        0
    ];
    var { startAngle, endAngle } = polarOptions;
    return [
        startAngle,
        endAngle
    ];
};
var selectAngleAxisRange = (0, _reselect.createSelector)([
    selectPolarOptions
], combineAngleAxisRange);
var selectAngleAxisRangeWithReversed = (0, _reselect.createSelector)([
    selectAngleAxis,
    selectAngleAxisRange
], (0, _combineAxisRangeWithReverse.combineAxisRangeWithReverse));
var selectRadiusAxisRange = (0, _reselect.createSelector)([
    selectMaxRadius,
    selectInnerRadius,
    selectOuterRadius
], (maxRadius, innerRadius, outerRadius)=>{
    if (maxRadius == null || innerRadius == null || outerRadius == null) return undefined;
    return [
        innerRadius,
        outerRadius
    ];
});
var selectRadiusAxisRangeWithReversed = (0, _reselect.createSelector)([
    selectRadiusAxis,
    selectRadiusAxisRange
], (0, _combineAxisRangeWithReverse.combineAxisRangeWithReverse));
var selectPolarViewBox = (0, _reselect.createSelector)([
    (0, _chartLayoutContext.selectChartLayout),
    selectPolarOptions,
    selectInnerRadius,
    selectOuterRadius,
    (0, _containerSelectors.selectChartWidth),
    (0, _containerSelectors.selectChartHeight)
], (layout, polarOptions, innerRadius, outerRadius, width, height)=>{
    if (layout !== 'centric' && layout !== 'radial' || polarOptions == null || innerRadius == null || outerRadius == null) return undefined;
    var { cx, cy, startAngle, endAngle } = polarOptions;
    return {
        cx: (0, _dataUtils.getPercentValue)(cx, width, width / 2),
        cy: (0, _dataUtils.getPercentValue)(cy, height, height / 2),
        innerRadius,
        outerRadius,
        startAngle,
        endAngle,
        clockWise: false // this property look useful, why not use it?
    };
});

},{"reselect":"ds2su","./containerSelectors":"lnBke","./selectChartOffsetInternal":"caUjq","../../util/PolarUtils":"ezeVo","../../util/DataUtils":"lNZEj","../../polar/defaultPolarAngleAxisProps":"fgzi8","../../polar/defaultPolarRadiusAxisProps":"58k7x","./combiners/combineAxisRangeWithReverse":"c3amE","../../context/chartLayoutContext":"jIUyy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fgzi8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultPolarAngleAxisProps", ()=>defaultPolarAngleAxisProps);
var _defaultZIndexes = require("../zIndex/DefaultZIndexes");
var defaultPolarAngleAxisProps = {
    allowDecimals: false,
    allowDuplicatedCategory: true,
    // if I set this to false then Tooltip synchronisation stops working in Radar, wtf
    angleAxisId: 0,
    axisLine: true,
    axisLineType: 'polygon',
    cx: 0,
    cy: 0,
    orientation: 'outer',
    reversed: false,
    scale: 'auto',
    tick: true,
    tickLine: true,
    tickSize: 8,
    type: 'category',
    zIndex: (0, _defaultZIndexes.DefaultZIndexes).axis
};

},{"../zIndex/DefaultZIndexes":"h8nlV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h8nlV":[function(require,module,exports,__globalThis) {
/**
 * A collection of all default zIndex values used throughout the library.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultZIndexes", ()=>DefaultZIndexes);
var DefaultZIndexes = {
    /**
   * CartesianGrid and PolarGrid
   */ grid: -100,
    /**
   * Background of Bar and RadialBar.
   * This is not visible by default but can be enabled by setting background={true} on Bar or RadialBar.
   */ barBackground: -50,
    /*
   * other chart elements or custom elements without specific zIndex
   * render in here, at zIndex 0
   */ /**
   * Area, Pie, Radar, and ReferenceArea
   */ area: 100,
    /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area. CursorRectangle is a rectangle box.
   * It renders below bar so that in a stacked bar chart the cursor rectangle does not hide the other bars.
   */ cursorRectangle: 200,
    /**
   * Bar and RadialBar
   */ bar: 300,
    /**
   * Line and ReferenceLine, and ErrorBor
   */ line: 400,
    /**
   * XAxis and YAxis and PolarAngleAxis and PolarRadiusAxis ticks and lines and children
   */ axis: 500,
    /**
   * Scatter and ReferenceDot,
   * and Dots of Line and Area and Radar if they have dot=true
   */ scatter: 600,
    /**
   * Hovering over a Bar or RadialBar renders a highlight rectangle
   */ activeBar: 1000,
    /**
   * Cursor is embedded inside Tooltip and controlled by it.
   * The Tooltip itself has a separate portal and is not included in the zIndex system;
   * Cursor is the decoration inside the chart area, usually a cross or a box.
   * CursorLine is a line cursor rendered in Line, Area, Scatter, Radar charts.
   * It renders above the Line and Scatter so that it is always visible.
   * It renders below active dot so that the dot is always visible and shows the current point.
   * We're also assuming that the active dot is small enough that it does not fully cover the cursor line.
   *
   * This also applies to the radial cursor in RadialBarChart.
   */ cursorLine: 1100,
    /**
   * Hovering over a Point in Line, Area, Scatter, Radar renders a highlight dot
   */ activeDot: 1200,
    /**
   * LabelList and Label, including Axis labels
   */ label: 2000
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"58k7x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultPolarRadiusAxisProps", ()=>defaultPolarRadiusAxisProps);
var _defaultZIndexes = require("../zIndex/DefaultZIndexes");
var defaultPolarRadiusAxisProps = {
    allowDataOverflow: false,
    allowDecimals: false,
    allowDuplicatedCategory: true,
    angle: 0,
    axisLine: true,
    includeHidden: false,
    hide: false,
    label: false,
    orientation: 'right',
    radiusAxisId: 0,
    reversed: false,
    scale: 'auto',
    stroke: '#ccc',
    tick: true,
    tickCount: 5,
    type: 'number',
    zIndex: (0, _defaultZIndexes.DefaultZIndexes).axis
};

},{"../zIndex/DefaultZIndexes":"h8nlV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c3amE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineAxisRangeWithReverse", ()=>combineAxisRangeWithReverse);
var combineAxisRangeWithReverse = (axisSettings, axisRange)=>{
    if (!axisSettings || !axisRange) return undefined;
    if (axisSettings !== null && axisSettings !== void 0 && axisSettings.reversed) return [
        axisRange[1],
        axisRange[0]
    ];
    return axisRange;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6RR5t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * @since 3.4
 */ /**
 * A layer that renders its children into a portal corresponding to the given zIndex.
 * We can't use regular CSS `z-index` because SVG does not support it.
 * So instead, we create separate DOM nodes for each zIndex layer
 * and render the children into the corresponding DOM node using React portals.
 *
 * This component must be used inside a Chart component.
 *
 * @param zIndex numeric zIndex value, higher values are rendered on top of lower values
 * @param children the content to render inside this zIndex layer
 *
 * @since 3.4
 */ parcelHelpers.export(exports, "ZIndexLayer", ()=>ZIndexLayer);
var _react = require("react");
var _reactDom = require("react-dom");
var _dataUtils = require("../util/DataUtils");
var _hooks = require("../state/hooks");
var _zIndexSelectors = require("./zIndexSelectors");
var _zIndexSlice = require("../state/zIndexSlice");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _panoramaContext = require("../context/PanoramaContext");
function ZIndexLayer(_ref) {
    var { zIndex, children } = _ref;
    /*
   * If we are outside of chart, then we can't rely on the zIndex portal state,
   * so we just render normally.
   */ var isInChartContext = (0, _chartLayoutContext.useIsInChartContext)();
    /*
   * If zIndex is undefined then we render normally without portals.
   * Also, if zIndex is 0, we render normally without portals,
   * because 0 is the default layer that does not need a portal.
   */ var shouldRenderInPortal = isInChartContext && zIndex !== undefined && zIndex !== 0;
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    var dispatch = (0, _hooks.useAppDispatch)();
    (0, _react.useLayoutEffect)(()=>{
        if (!shouldRenderInPortal) // Nothing to do. We have to call the hook because of the rules of hooks.
        return 0, _dataUtils.noop;
        /*
     * Because zIndexes are dynamic (meaning, we're not working with a predefined set of layers,
     * but we allow users to define any zIndex at any time), we need to register
     * the requested zIndex in the global store. This way, the ZIndexPortals component
     * can render the corresponding portals and only the requested ones.
     */ dispatch((0, _zIndexSlice.registerZIndexPortal)({
            zIndex
        }));
        return ()=>{
            dispatch((0, _zIndexSlice.unregisterZIndexPortal)({
                zIndex
            }));
        };
    }, [
        dispatch,
        zIndex,
        shouldRenderInPortal
    ]);
    var portalElement = (0, _hooks.useAppSelector)((state)=>(0, _zIndexSelectors.selectZIndexPortalElement)(state, zIndex, isPanorama));
    if (!shouldRenderInPortal) // If no zIndex is provided or zIndex is 0, render normally without portals
    return children;
    if (!portalElement) /*
     * If we don't have a portal element yet, this means that the registration
     * has not been processed yet by the ZIndexPortals component.
     * So here we render null and wait for the next render cycle.
     */ return null;
    return /*#__PURE__*/ (0, _reactDom.createPortal)(children, portalElement);
}

},{"react":"bmhQu","react-dom":"82aNB","../util/DataUtils":"lNZEj","../state/hooks":"aEuxu","./zIndexSelectors":"bBgaU","../state/zIndexSlice":"haK2y","../context/chartLayoutContext":"jIUyy","../context/PanoramaContext":"10hMm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bBgaU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectZIndexPortalElement", ()=>selectZIndexPortalElement);
parcelHelpers.export(exports, "selectAllRegisteredZIndexes", ()=>selectAllRegisteredZIndexes);
var _reselect = require("reselect");
var _arrayEqualityCheck = require("../state/selectors/arrayEqualityCheck");
var _defaultZIndexes = require("./DefaultZIndexes");
var selectZIndexPortalElement = (0, _reselect.createSelector)((state)=>state.zIndex.zIndexMap, (_, zIndex)=>zIndex, (_, _zIndex, isPanorama)=>isPanorama, (zIndexMap, zIndex, isPanorama)=>{
    if (zIndex == null) return undefined;
    var entry = zIndexMap[zIndex];
    if (entry == null) return undefined;
    if (isPanorama) return entry.panoramaElement;
    return entry.element;
});
var selectAllRegisteredZIndexes = (0, _reselect.createSelector)((state)=>state.zIndex.zIndexMap, (zIndexMap)=>{
    var allNumbers = Object.keys(zIndexMap).map((zIndexStr)=>parseInt(zIndexStr, 10)).concat(Object.values((0, _defaultZIndexes.DefaultZIndexes)));
    var uniqueNumbers = Array.from(new Set(allNumbers));
    return uniqueNumbers.sort((a, b)=>a - b);
}, {
    memoizeOptions: {
        resultEqualityCheck: (0, _arrayEqualityCheck.arrayContentsAreEqualCheck)
    }
});

},{"reselect":"ds2su","../state/selectors/arrayEqualityCheck":"R4lui","./DefaultZIndexes":"h8nlV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"R4lui":[function(require,module,exports,__globalThis) {
/**
 * Checks if two arrays are equal, treating empty arrays as equal regardless of reference.
 * If both arrays are non-empty, it checks for reference equality.
 * @param a
 * @param b
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "emptyArraysAreEqualCheck", ()=>emptyArraysAreEqualCheck);
/**
 * Checks if two arrays have the same contents in the same order.
 * @param a
 * @param b
 */ parcelHelpers.export(exports, "arrayContentsAreEqualCheck", ()=>arrayContentsAreEqualCheck);
function emptyArraysAreEqualCheck(a, b) {
    if (Array.isArray(a) && Array.isArray(b) && a.length === 0 && b.length === 0) // empty arrays are always equal, regardless of reference
    return true;
    return a === b;
}
function arrayContentsAreEqualCheck(a, b) {
    if (a.length === b.length) {
        for(var i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    return false;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"haK2y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "registerZIndexPortal", ()=>registerZIndexPortal);
parcelHelpers.export(exports, "unregisterZIndexPortal", ()=>unregisterZIndexPortal);
parcelHelpers.export(exports, "registerZIndexPortalElement", ()=>registerZIndexPortalElement);
parcelHelpers.export(exports, "unregisterZIndexPortalElement", ()=>unregisterZIndexPortalElement);
parcelHelpers.export(exports, "zIndexReducer", ()=>zIndexReducer);
/**
 * This slice contains a registry of z-index values for various components.
 * The state is a map from z-index numbers to element references.
 */ var _toolkit = require("@reduxjs/toolkit");
var _immer = require("immer");
var _defaultZIndexes = require("../zIndex/DefaultZIndexes");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var seed = {};
var initialState = {
    zIndexMap: Object.values((0, _defaultZIndexes.DefaultZIndexes)).reduce((acc, current)=>_objectSpread(_objectSpread({}, acc), {}, {
            [current]: {
                element: undefined,
                panoramaElement: undefined,
                consumers: 0
            }
        }), seed)
};
var defaultZIndexSet = new Set(Object.values((0, _defaultZIndexes.DefaultZIndexes)));
function isDefaultZIndex(zIndex) {
    return defaultZIndexSet.has(zIndex);
}
var zIndexSlice = (0, _toolkit.createSlice)({
    name: 'zIndex',
    initialState,
    reducers: {
        registerZIndexPortal: {
            reducer: (state, action)=>{
                var { zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) state.zIndexMap[zIndex].consumers += 1;
                else state.zIndexMap[zIndex] = {
                    consumers: 1,
                    element: undefined,
                    panoramaElement: undefined
                };
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        unregisterZIndexPortal: {
            reducer: (state, action)=>{
                var { zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    state.zIndexMap[zIndex].consumers -= 1;
                    /*
           * Garbage collect unused z-index entries, except for default z-indexes.
           * Default z-indexes are always rendered, regardless of whether there are consumers or not.
           * And because of that, even if we delete this entry, the ZIndexPortal provider will still be rendered
           * and React is not going to re-create it, and it won't re-register the element ID.
           * So let's not delete default z-index entries.
           */ if (state.zIndexMap[zIndex].consumers <= 0 && !isDefaultZIndex(zIndex)) delete state.zIndexMap[zIndex];
                }
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        registerZIndexPortalElement: {
            reducer: (state, action)=>{
                var { zIndex, element, isPanorama } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    if (isPanorama) state.zIndexMap[zIndex].panoramaElement = (0, _immer.castDraft)(element);
                    else state.zIndexMap[zIndex].element = (0, _immer.castDraft)(element);
                } else state.zIndexMap[zIndex] = {
                    consumers: 0,
                    element: isPanorama ? undefined : (0, _immer.castDraft)(element),
                    panoramaElement: isPanorama ? (0, _immer.castDraft)(element) : undefined
                };
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        unregisterZIndexPortalElement: {
            reducer: (state, action)=>{
                var { zIndex } = action.payload;
                if (state.zIndexMap[zIndex]) {
                    if (action.payload.isPanorama) state.zIndexMap[zIndex].panoramaElement = undefined;
                    else state.zIndexMap[zIndex].element = undefined;
                }
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        }
    }
});
var { registerZIndexPortal, unregisterZIndexPortal, registerZIndexPortalElement, unregisterZIndexPortalElement } = zIndexSlice.actions;
var zIndexReducer = zIndexSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","immer":"ggZ4C","../zIndex/DefaultZIndexes":"h8nlV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ggZ4C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Immer", ()=>Immer2);
parcelHelpers.export(exports, "applyPatches", ()=>applyPatches);
parcelHelpers.export(exports, "castDraft", ()=>castDraft);
parcelHelpers.export(exports, "castImmutable", ()=>castImmutable);
parcelHelpers.export(exports, "createDraft", ()=>createDraft);
parcelHelpers.export(exports, "current", ()=>current);
parcelHelpers.export(exports, "enableMapSet", ()=>enableMapSet);
parcelHelpers.export(exports, "enablePatches", ()=>enablePatches);
parcelHelpers.export(exports, "finishDraft", ()=>finishDraft);
parcelHelpers.export(exports, "freeze", ()=>freeze);
parcelHelpers.export(exports, "immerable", ()=>DRAFTABLE);
parcelHelpers.export(exports, "isDraft", ()=>isDraft);
parcelHelpers.export(exports, "isDraftable", ()=>isDraftable);
parcelHelpers.export(exports, "nothing", ()=>NOTHING);
parcelHelpers.export(exports, "original", ()=>original);
parcelHelpers.export(exports, "produce", ()=>produce);
parcelHelpers.export(exports, "produceWithPatches", ()=>produceWithPatches);
parcelHelpers.export(exports, "setAutoFreeze", ()=>setAutoFreeze);
parcelHelpers.export(exports, "setUseStrictIteration", ()=>setUseStrictIteration);
parcelHelpers.export(exports, "setUseStrictShallowCopy", ()=>setUseStrictShallowCopy);
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var errors = [];
function die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
    return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
    var _a;
    if (!value) return false;
    return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!((_a = value.constructor) == null ? void 0 : _a[DRAFTABLE]) || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
var cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = Object.getPrototypeOf(value);
    if (proto === null || proto === Object.prototype) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    if (typeof Ctor !== "function") return false;
    let ctorString = cachedCtorStrings.get(Ctor);
    if (ctorString === void 0) {
        ctorString = Function.toString.call(Ctor);
        cachedCtorStrings.set(Ctor, ctorString);
    }
    return ctorString === objectCtorString;
}
function original(value) {
    if (!isDraft(value)) die(15, value);
    return value[DRAFT_STATE].base_;
}
function each(obj, iter, strict = true) {
    if (getArchtype(obj) === 0 /* Object */ ) {
        const keys = strict ? Reflect.ownKeys(obj) : Object.keys(obj);
        keys.forEach((key)=>{
            iter(key, obj[key], obj);
        });
    } else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function getArchtype(thing) {
    const state = thing[DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : isMap(thing) ? 2 /* Map */  : isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function has(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function get(thing, prop) {
    return getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function set(thing, propOrOldValue, value) {
    const t = getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function isMap(target) {
    return target instanceof Map;
}
function isSet(target) {
    return target instanceof Set;
}
function latest(state) {
    return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
    if (isMap(base)) return new Map(base);
    if (isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    const isPlain = isPlainObject(base);
    if (strict === true || strict === "class_only" && !isPlain) {
        const descriptors = Object.getOwnPropertyDescriptors(base);
        delete descriptors[DRAFT_STATE];
        let keys = Reflect.ownKeys(descriptors);
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            const desc = descriptors[key];
            if (desc.writable === false) {
                desc.writable = true;
                desc.configurable = true;
            }
            if (desc.get || desc.set) descriptors[key] = {
                configurable: true,
                writable: true,
                // could live with !!desc.set as well here...
                enumerable: desc.enumerable,
                value: base[key]
            };
        }
        return Object.create(getPrototypeOf(base), descriptors);
    } else {
        const proto = getPrototypeOf(base);
        if (proto !== null && isPlain) return __spreadValues({}, base);
        const obj = Object.create(proto);
        return Object.assign(obj, base);
    }
}
function freeze(obj, deep = false) {
    if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj)) return obj;
    if (getArchtype(obj) > 1) Object.defineProperties(obj, {
        set: dontMutateMethodOverride,
        add: dontMutateMethodOverride,
        clear: dontMutateMethodOverride,
        delete: dontMutateMethodOverride
    });
    Object.freeze(obj);
    if (deep) Object.values(obj).forEach((value)=>freeze(value, true));
    return obj;
}
function dontMutateFrozenCollections() {
    die(2);
}
var dontMutateMethodOverride = {
    value: dontMutateFrozenCollections
};
function isFrozen(obj) {
    if (obj === null || typeof obj !== "object") return true;
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var plugins = {};
function getPlugin(pluginKey) {
    const plugin = plugins[pluginKey];
    if (!plugin) die(0, pluginKey);
    return plugin;
}
function loadPlugin(pluginKey, implementation) {
    if (!plugins[pluginKey]) plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var currentScope;
function getCurrentScope() {
    return currentScope;
}
function createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_,
        immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function revokeScope(scope) {
    leaveScope(scope);
    scope.drafts_.forEach(revokeDraft);
    scope.drafts_ = null;
}
function leaveScope(scope) {
    if (scope === currentScope) currentScope = scope.parent_;
}
function enterScope(immer2) {
    return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
    const state = draft[DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[DRAFT_STATE].modified_) {
            revokeScope(scope);
            die(4);
        }
        if (isDraftable(result)) {
            result = finalize(scope, result);
            if (!scope.parent_) maybeFreeze(scope, result);
        }
        if (scope.patches_) getPlugin("Patches").generateReplacementPatches_(baseDraft[DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = finalize(scope, baseDraft, []);
    revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
    if (isFrozen(value)) return value;
    const useStrictIteration = rootScope.immer_.shouldUseStrictIteration();
    const state = value[DRAFT_STATE];
    if (!state) {
        each(value, (key, childValue)=>finalizeProperty(rootScope, state, value, key, childValue, path), useStrictIteration);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        each(resultEach, (key, childValue)=>finalizeProperty(rootScope, state, result, key, childValue, path, isSet2), useStrictIteration);
        maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if (childValue == null) return;
    if (typeof childValue !== "object" && !targetIsSet) return;
    const childIsFrozen = isFrozen(childValue);
    if (childIsFrozen && !targetIsSet) return;
    if (isDraft(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = finalize(rootScope, childValue, path);
        set(targetObject, prop, res);
        if (isDraft(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if (isDraftable(childValue) && !childIsFrozen) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        if (parentState && parentState.base_ && parentState.base_[prop] === childValue && childIsFrozen) return;
        finalize(rootScope, childValue);
        if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && (isMap(targetObject) ? targetObject.has(prop) : Object.prototype.propertyIsEnumerable.call(targetObject, prop))) maybeFreeze(rootScope, childValue);
    }
}
function maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) freeze(value, deep);
}
// src/core/proxy.ts
function createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = arrayTraps;
    }
    const { revoke, proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var objectTraps = {
    get (state, prop) {
        if (prop === DRAFT_STATE) return state;
        const source = latest(state);
        if (!has(source, prop)) return readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !isDraftable(value)) return value;
        if (value === peek(state.base_, prop)) {
            prepareCopy(state);
            return state.copy_[prop] = createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys(latest(state));
    },
    set (state, prop, value) {
        const desc = getDescriptorFromProto(latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = peek(latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if (is(value, current2) && (value !== void 0 || has(state.base_, prop))) return true;
            prepareCopy(state);
            markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            prepareCopy(state);
            markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        die(11);
    },
    getPrototypeOf (state) {
        return getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        die(12);
    }
};
var arrayTraps = {};
each(objectTraps, (key, fn)=>{
    arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
arrayTraps.deleteProperty = function(state, prop) {
    return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
    return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
    const state = draft[DRAFT_STATE];
    const source = state ? latest(state) : draft;
    return source[prop];
}
function readPropFromProto(state, source, prop) {
    var _a;
    const desc = getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = getPrototypeOf(proto);
    }
    return void 0;
}
function markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) markChanged(state.parent_);
    }
}
function prepareCopy(state) {
    if (!state.copy_) state.copy_ = shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var Immer2 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        this.useStrictIteration_ = true;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") die(7);
            let result;
            if (isDraftable(base)) {
                const scope = enterScope(this);
                const proxy = createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) revokeScope(scope);
                    else leaveScope(scope);
                }
                usePatchesInScope(scope, patchListener);
                return processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === NOTHING) result = void 0;
                if (this.autoFreeze_) freeze(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
        if (typeof (config == null ? void 0 : config.useStrictIteration) === "boolean") this.setUseStrictIteration(config.useStrictIteration);
    }
    createDraft(base) {
        if (!isDraftable(base)) die(8);
        if (isDraft(base)) base = current(base);
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        proxy[DRAFT_STATE].isManual_ = true;
        leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[DRAFT_STATE];
        if (!state || !state.isManual_) die(9);
        const { scope_: scope } = state;
        usePatchesInScope(scope, patchListener);
        return processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */ setUseStrictIteration(value) {
        this.useStrictIteration_ = value;
    }
    shouldUseStrictIteration() {
        return this.useStrictIteration_;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = getPlugin("Patches").applyPatches_;
        if (isDraft(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function createProxy(value, parent) {
    const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function current(value) {
    if (!isDraft(value)) die(10, value);
    return currentImpl(value);
}
function currentImpl(value) {
    if (!isDraftable(value) || isFrozen(value)) return value;
    const state = value[DRAFT_STATE];
    let copy;
    let strict = true;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
        strict = state.scope_.immer_.shouldUseStrictIteration();
    } else copy = shallowCopy(value, true);
    each(copy, (key, childValue)=>{
        set(copy, key, currentImpl(childValue));
    }, strict);
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function enablePatches() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_, assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_, copy_ } = state;
        each(state.assigned_, (key, assignedValue)=>{
            const origValue = get(base_, key);
            const value = get(copy_, key);
            const op = !assignedValue ? REMOVE : has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op,
                path
            } : {
                op,
                path,
                value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path
            } : op === REMOVE ? {
                op: ADD,
                path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_, copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: ADD,
                    path,
                    value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path,
                    value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path,
                    value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === NOTHING ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path, op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") die(errorOffset + 3);
                base = get(base, p);
                if (typeof base !== "object") die(errorOffset + 2, path.join("/"));
            }
            const type = getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!isDraftable(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if (isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if (isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create(getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if (has(obj, DRAFTABLE)) cloned[DRAFTABLE] = obj[DRAFTABLE];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if (isDraft(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    loadPlugin("Patches", {
        applyPatches_,
        generatePatches_,
        generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function enableMapSet() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(key) {
            return latest(this[DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!latest(state).has(key) || latest(state).get(key) !== value) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareMapCopy(state);
                markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[DRAFT_STATE];
            latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            const value = latest(state).get(key);
            if (state.finalized_ || !isDraftable(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return latest(this[DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return latest(this[DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            if (latest(state).size) {
                prepareSetCopy(state);
                markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [(DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if (isDraftable(value)) {
                    const draft = createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) die(3, JSON.stringify(latest(state)));
    }
    loadPlugin("MapSet", {
        proxyMap_,
        proxySet_
    });
}
// src/immer.ts
var immer = new Immer2();
var produce = immer.produce;
var produceWithPatches = /* @__PURE__ */ immer.produceWithPatches.bind(immer);
var setAutoFreeze = /* @__PURE__ */ immer.setAutoFreeze.bind(immer);
var setUseStrictShallowCopy = /* @__PURE__ */ immer.setUseStrictShallowCopy.bind(immer);
var setUseStrictIteration = /* @__PURE__ */ immer.setUseStrictIteration.bind(immer);
var applyPatches = /* @__PURE__ */ immer.applyPatches.bind(immer);
var createDraft = /* @__PURE__ */ immer.createDraft.bind(immer);
var finishDraft = /* @__PURE__ */ immer.finishDraft.bind(immer);
function castDraft(value) {
    return value;
}
function castImmutable(value) {
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9qdl2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isPolarCoordinate", ()=>isPolarCoordinate);
parcelHelpers.export(exports, "adaptEventHandlers", ()=>adaptEventHandlers);
parcelHelpers.export(exports, "adaptEventsOfChild", ()=>adaptEventsOfChild);
parcelHelpers.export(exports, "isNonEmptyArray", ()=>isNonEmptyArray);
var _react = require("react");
var _excludeEventProps = require("./excludeEventProps");
var isPolarCoordinate = (c)=>{
    return 'radius' in c && 'startAngle' in c && 'endAngle' in c;
};
var adaptEventHandlers = (props, newHandler)=>{
    if (!props || typeof props === 'function' || typeof props === 'boolean') return null;
    var inputProps = props;
    if (/*#__PURE__*/ (0, _react.isValidElement)(props)) inputProps = props.props;
    if (typeof inputProps !== 'object' && typeof inputProps !== 'function') return null;
    var out = {};
    Object.keys(inputProps).forEach((key)=>{
        if ((0, _excludeEventProps.isEventKey)(key)) out[key] = newHandler || ((e)=>inputProps[key](inputProps, e));
    });
    return out;
};
var getEventHandlerOfChild = (originalHandler, data, index)=>(e)=>{
        originalHandler(data, index, e);
        return null;
    };
var adaptEventsOfChild = (props, data, index)=>{
    if (props === null || typeof props !== 'object' && typeof props !== 'function') return null;
    var out = null;
    Object.keys(props).forEach((key)=>{
        var item = props[key];
        if ((0, _excludeEventProps.isEventKey)(key) && typeof item === 'function') {
            if (!out) out = {};
            out[key] = getEventHandlerOfChild(item, data, index);
        }
    });
    return out;
};
var isNonEmptyArray = (arr)=>{
    return Array.isArray(arr) && arr.length > 0;
};

},{"react":"bmhQu","./excludeEventProps":"4mRNj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kxZIM":[function(require,module,exports,__globalThis) {
/**
 * Calculates the width of the Y-axis based on the tick labels and the axis label.
 * @param params - The parameters object.
 * @param [params.ticks] - An array-like object of tick elements, each with a `getBoundingClientRect` method.
 * @param [params.label] - The axis label element, with a `getBoundingClientRect` method.
 * @param [params.labelGapWithTick=5] - The gap between the label and the tick.
 * @param [params.tickSize=0] - The length of the tick line.
 * @param [params.tickMargin=0] - The margin between the tick line and the tick text.
 * @returns The calculated width of the Y-axis.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCalculatedYAxisWidth", ()=>getCalculatedYAxisWidth);
var getCalculatedYAxisWidth = (_ref)=>{
    var { ticks, label, labelGapWithTick = 5, // Default gap between label and tick
    tickSize = 0, tickMargin = 0 } = _ref;
    // find the max width of the tick labels
    var maxTickWidth = 0;
    if (ticks) {
        Array.from(ticks).forEach((tickNode)=>{
            if (tickNode) {
                var bbox = tickNode.getBoundingClientRect();
                if (bbox.width > maxTickWidth) maxTickWidth = bbox.width;
            }
        });
        // calculate width of the axis label
        var labelWidth = label ? label.getBoundingClientRect().width : 0;
        var tickWidth = tickSize + tickMargin;
        // calculate the updated width of the y-axis
        var updatedYAxisWidth = maxTickWidth + tickWidth + labelWidth + (label ? labelGapWithTick : 0);
        return Math.round(updatedYAxisWidth);
    }
    return 0;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bvR8m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultNumericDomain", ()=>defaultNumericDomain);
parcelHelpers.export(exports, "implicitXAxis", ()=>implicitXAxis);
parcelHelpers.export(exports, "selectXAxisSettingsNoDefaults", ()=>selectXAxisSettingsNoDefaults);
parcelHelpers.export(exports, "selectXAxisSettings", ()=>selectXAxisSettings);
parcelHelpers.export(exports, "implicitYAxis", ()=>implicitYAxis);
parcelHelpers.export(exports, "selectYAxisSettingsNoDefaults", ()=>selectYAxisSettingsNoDefaults);
parcelHelpers.export(exports, "selectYAxisSettings", ()=>selectYAxisSettings);
parcelHelpers.export(exports, "implicitZAxis", ()=>implicitZAxis);
parcelHelpers.export(exports, "selectZAxisSettings", ()=>selectZAxisSettings);
parcelHelpers.export(exports, "selectBaseAxis", ()=>selectBaseAxis);
parcelHelpers.export(exports, "selectAxisSettings", ()=>selectAxisSettings);
parcelHelpers.export(exports, "selectHasBar", ()=>selectHasBar);
/**
 * Filters CartesianGraphicalItemSettings by the relevant axis ID
 * @param axisType 'xAxis' | 'yAxis' | 'zAxis' | 'radiusAxis' | 'angleAxis'
 * @param axisId from props, defaults to 0
 *
 * @returns Predicate function that return true for CartesianGraphicalItemSettings that are relevant to the specified axis
 */ parcelHelpers.export(exports, "itemAxisPredicate", ()=>itemAxisPredicate);
parcelHelpers.export(exports, "selectUnfilteredCartesianItems", ()=>selectUnfilteredCartesianItems);
parcelHelpers.export(exports, "combineGraphicalItemsSettings", ()=>combineGraphicalItemsSettings);
parcelHelpers.export(exports, "selectCartesianItemsSettings", ()=>selectCartesianItemsSettings);
parcelHelpers.export(exports, "selectStackedCartesianItemsSettings", ()=>selectStackedCartesianItemsSettings);
parcelHelpers.export(exports, "filterGraphicalNotStackedItems", ()=>filterGraphicalNotStackedItems);
parcelHelpers.export(exports, "combineGraphicalItemsData", ()=>combineGraphicalItemsData);
parcelHelpers.export(exports, "selectCartesianGraphicalItemsData", ()=>selectCartesianGraphicalItemsData);
parcelHelpers.export(exports, "combineDisplayedData", ()=>combineDisplayedData);
parcelHelpers.export(exports, "selectDisplayedData", ()=>selectDisplayedData);
parcelHelpers.export(exports, "combineAppliedValues", ()=>combineAppliedValues);
parcelHelpers.export(exports, "selectAllAppliedValues", ()=>selectAllAppliedValues);
parcelHelpers.export(exports, "isErrorBarRelevantForAxisType", ()=>isErrorBarRelevantForAxisType);
/**
 * @param entry One item in the 'data' array. Could be anything really - this is defined externally. This is the raw, before dataKey application
 * @param appliedValue This is the result of applying the 'main' dataKey on the `entry`.
 * @param relevantErrorBars Error bars that are relevant for the current axis and layout and all that.
 * @return either undefined or an array of ErrorValue
 */ parcelHelpers.export(exports, "getErrorDomainByDataKey", ()=>getErrorDomainByDataKey);
parcelHelpers.export(exports, "selectTooltipAxis", ()=>selectTooltipAxis);
parcelHelpers.export(exports, "selectTooltipAxisDataKey", ()=>selectTooltipAxisDataKey);
parcelHelpers.export(exports, "selectDisplayedStackedData", ()=>selectDisplayedStackedData);
parcelHelpers.export(exports, "combineStackGroups", ()=>combineStackGroups);
parcelHelpers.export(exports, "selectStackGroups", ()=>selectStackGroups);
parcelHelpers.export(exports, "combineDomainOfStackGroups", ()=>combineDomainOfStackGroups);
parcelHelpers.export(exports, "getDomainDefinition", ()=>getDomainDefinition);
parcelHelpers.export(exports, "selectDomainDefinition", ()=>selectDomainDefinition);
parcelHelpers.export(exports, "selectDomainFromUserPreference", ()=>selectDomainFromUserPreference);
parcelHelpers.export(exports, "selectDomainOfStackGroups", ()=>selectDomainOfStackGroups);
parcelHelpers.export(exports, "selectAllErrorBarSettings", ()=>selectAllErrorBarSettings);
parcelHelpers.export(exports, "mergeDomains", ()=>mergeDomains);
parcelHelpers.export(exports, "combineDomainOfAllAppliedNumericalValuesIncludingErrorValues", ()=>combineDomainOfAllAppliedNumericalValuesIncludingErrorValues);
parcelHelpers.export(exports, "selectReferenceDots", ()=>selectReferenceDots);
parcelHelpers.export(exports, "filterReferenceElements", ()=>filterReferenceElements);
parcelHelpers.export(exports, "selectReferenceDotsByAxis", ()=>selectReferenceDotsByAxis);
parcelHelpers.export(exports, "selectReferenceAreas", ()=>selectReferenceAreas);
parcelHelpers.export(exports, "selectReferenceAreasByAxis", ()=>selectReferenceAreasByAxis);
parcelHelpers.export(exports, "selectReferenceLines", ()=>selectReferenceLines);
parcelHelpers.export(exports, "selectReferenceLinesByAxis", ()=>selectReferenceLinesByAxis);
parcelHelpers.export(exports, "combineDotsDomain", ()=>combineDotsDomain);
parcelHelpers.export(exports, "combineAreasDomain", ()=>combineAreasDomain);
parcelHelpers.export(exports, "combineLinesDomain", ()=>combineLinesDomain);
parcelHelpers.export(exports, "combineNumericalDomain", ()=>combineNumericalDomain);
parcelHelpers.export(exports, "selectNumericalDomain", ()=>selectNumericalDomain);
parcelHelpers.export(exports, "combineAxisDomain", ()=>combineAxisDomain);
parcelHelpers.export(exports, "selectAxisDomain", ()=>selectAxisDomain);
parcelHelpers.export(exports, "combineRealScaleType", ()=>combineRealScaleType);
parcelHelpers.export(exports, "selectRealScaleType", ()=>selectRealScaleType);
parcelHelpers.export(exports, "combineScaleFunction", ()=>combineScaleFunction);
parcelHelpers.export(exports, "combineNiceTicks", ()=>combineNiceTicks);
parcelHelpers.export(exports, "selectNiceTicks", ()=>selectNiceTicks);
parcelHelpers.export(exports, "combineAxisDomainWithNiceTicks", ()=>combineAxisDomainWithNiceTicks);
parcelHelpers.export(exports, "selectAxisDomainIncludingNiceTicks", ()=>selectAxisDomainIncludingNiceTicks);
parcelHelpers.export(exports, "selectSmallestDistanceBetweenValues", ()=>selectSmallestDistanceBetweenValues);
parcelHelpers.export(exports, "selectCalculatedXAxisPadding", ()=>selectCalculatedXAxisPadding);
parcelHelpers.export(exports, "selectCalculatedYAxisPadding", ()=>selectCalculatedYAxisPadding);
parcelHelpers.export(exports, "combineXAxisRange", ()=>combineXAxisRange);
parcelHelpers.export(exports, "combineYAxisRange", ()=>combineYAxisRange);
parcelHelpers.export(exports, "selectAxisRange", ()=>selectAxisRange);
parcelHelpers.export(exports, "selectAxisRangeWithReverse", ()=>selectAxisRangeWithReverse);
parcelHelpers.export(exports, "selectAxisScale", ()=>selectAxisScale);
parcelHelpers.export(exports, "selectErrorBarsSettings", ()=>selectErrorBarsSettings);
parcelHelpers.export(exports, "selectXAxisSize", ()=>selectXAxisSize);
parcelHelpers.export(exports, "selectAllXAxesOffsetSteps", ()=>selectAllXAxesOffsetSteps);
parcelHelpers.export(exports, "selectAllYAxesOffsetSteps", ()=>selectAllYAxesOffsetSteps);
parcelHelpers.export(exports, "selectXAxisPosition", ()=>selectXAxisPosition);
parcelHelpers.export(exports, "selectYAxisPosition", ()=>selectYAxisPosition);
parcelHelpers.export(exports, "selectYAxisSize", ()=>selectYAxisSize);
parcelHelpers.export(exports, "selectCartesianAxisSize", ()=>selectCartesianAxisSize);
parcelHelpers.export(exports, "combineDuplicateDomain", ()=>combineDuplicateDomain);
parcelHelpers.export(exports, "selectDuplicateDomain", ()=>selectDuplicateDomain);
parcelHelpers.export(exports, "combineCategoricalDomain", ()=>combineCategoricalDomain);
parcelHelpers.export(exports, "selectCategoricalDomain", ()=>selectCategoricalDomain);
parcelHelpers.export(exports, "selectAxisPropsNeededForCartesianGridTicksGenerator", ()=>selectAxisPropsNeededForCartesianGridTicksGenerator);
parcelHelpers.export(exports, "combineAxisTicks", ()=>combineAxisTicks);
parcelHelpers.export(exports, "selectTicksOfAxis", ()=>selectTicksOfAxis);
parcelHelpers.export(exports, "combineGraphicalItemTicks", ()=>combineGraphicalItemTicks);
parcelHelpers.export(exports, "selectTicksOfGraphicalItem", ()=>selectTicksOfGraphicalItem);
parcelHelpers.export(exports, "selectAxisWithScale", ()=>selectAxisWithScale);
parcelHelpers.export(exports, "selectZAxisWithScale", ()=>selectZAxisWithScale);
parcelHelpers.export(exports, "selectChartDirection", ()=>selectChartDirection);
var _reselect = require("reselect");
var _range = require("es-toolkit/compat/range");
var _rangeDefault = parcelHelpers.interopDefault(_range);
var _d3Scale = require("victory-vendor/d3-scale");
var _chartLayoutContext = require("../../context/chartLayoutContext");
var _chartUtils = require("../../util/ChartUtils");
var _dataSelectors = require("./dataSelectors");
var _isDomainSpecifiedByUser = require("../../util/isDomainSpecifiedByUser");
var _dataUtils = require("../../util/DataUtils");
var _isWellBehavedNumber = require("../../util/isWellBehavedNumber");
var _scale = require("../../util/scale");
var _containerSelectors = require("./containerSelectors");
var _selectAllAxes = require("./selectAllAxes");
var _selectChartOffsetInternal = require("./selectChartOffsetInternal");
var _brushSelectors = require("./brushSelectors");
var _rootPropsSelectors = require("./rootPropsSelectors");
var _polarAxisSelectors = require("./polarAxisSelectors");
var _pickAxisType = require("./pickAxisType");
var _pickAxisId = require("./pickAxisId");
var _combineAxisRangeWithReverse = require("./combiners/combineAxisRangeWithReverse");
var _constants = require("../../util/Constants");
var _getStackSeriesIdentifier = require("../../util/stacks/getStackSeriesIdentifier");
var _combineDisplayedStackedData = require("./combiners/combineDisplayedStackedData");
var _stackedGraphicalItem = require("../types/StackedGraphicalItem");
var _numberDomainEqualityCheck = require("./numberDomainEqualityCheck");
var _arrayEqualityCheck = require("./arrayEqualityCheck");
var _selectTooltipAxisType = require("./selectTooltipAxisType");
var _selectTooltipAxisId = require("./selectTooltipAxisId");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var defaultNumericDomain = [
    0,
    'auto'
];
var implicitXAxis = {
    allowDataOverflow: false,
    allowDecimals: true,
    allowDuplicatedCategory: true,
    angle: 0,
    dataKey: undefined,
    domain: undefined,
    height: 30,
    hide: true,
    id: 0,
    includeHidden: false,
    interval: 'preserveEnd',
    minTickGap: 5,
    mirror: false,
    name: undefined,
    orientation: 'bottom',
    padding: {
        left: 0,
        right: 0
    },
    reversed: false,
    scale: 'auto',
    tick: true,
    tickCount: 5,
    tickFormatter: undefined,
    ticks: undefined,
    type: 'category',
    unit: undefined
};
var selectXAxisSettingsNoDefaults = (state, axisId)=>{
    return state.cartesianAxis.xAxis[axisId];
};
var selectXAxisSettings = (state, axisId)=>{
    var axis = selectXAxisSettingsNoDefaults(state, axisId);
    if (axis == null) return implicitXAxis;
    return axis;
};
var implicitYAxis = {
    allowDataOverflow: false,
    allowDecimals: true,
    allowDuplicatedCategory: true,
    angle: 0,
    dataKey: undefined,
    domain: defaultNumericDomain,
    hide: true,
    id: 0,
    includeHidden: false,
    interval: 'preserveEnd',
    minTickGap: 5,
    mirror: false,
    name: undefined,
    orientation: 'left',
    padding: {
        top: 0,
        bottom: 0
    },
    reversed: false,
    scale: 'auto',
    tick: true,
    tickCount: 5,
    tickFormatter: undefined,
    ticks: undefined,
    type: 'number',
    unit: undefined,
    width: (0, _constants.DEFAULT_Y_AXIS_WIDTH)
};
var selectYAxisSettingsNoDefaults = (state, axisId)=>{
    return state.cartesianAxis.yAxis[axisId];
};
var selectYAxisSettings = (state, axisId)=>{
    var axis = selectYAxisSettingsNoDefaults(state, axisId);
    if (axis == null) return implicitYAxis;
    return axis;
};
var implicitZAxis = {
    domain: [
        0,
        'auto'
    ],
    includeHidden: false,
    reversed: false,
    allowDataOverflow: false,
    allowDuplicatedCategory: false,
    dataKey: undefined,
    id: 0,
    name: '',
    range: [
        64,
        64
    ],
    scale: 'auto',
    type: 'number',
    unit: ''
};
var selectZAxisSettings = (state, axisId)=>{
    var axis = state.cartesianAxis.zAxis[axisId];
    if (axis == null) return implicitZAxis;
    return axis;
};
var selectBaseAxis = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return selectXAxisSettings(state, axisId);
        case 'yAxis':
            return selectYAxisSettings(state, axisId);
        case 'zAxis':
            return selectZAxisSettings(state, axisId);
        case 'angleAxis':
            return (0, _polarAxisSelectors.selectAngleAxis)(state, axisId);
        case 'radiusAxis':
            return (0, _polarAxisSelectors.selectRadiusAxis)(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var selectCartesianAxisSettings = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return selectXAxisSettings(state, axisId);
        case 'yAxis':
            return selectYAxisSettings(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var selectAxisSettings = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return selectXAxisSettings(state, axisId);
        case 'yAxis':
            return selectYAxisSettings(state, axisId);
        case 'angleAxis':
            return (0, _polarAxisSelectors.selectAngleAxis)(state, axisId);
        case 'radiusAxis':
            return (0, _polarAxisSelectors.selectRadiusAxis)(state, axisId);
        default:
            throw new Error("Unexpected axis type: ".concat(axisType));
    }
};
var selectHasBar = (state)=>state.graphicalItems.cartesianItems.some((item)=>item.type === 'bar') || state.graphicalItems.polarItems.some((item)=>item.type === 'radialBar');
function itemAxisPredicate(axisType, axisId) {
    return (item)=>{
        switch(axisType){
            case 'xAxis':
                // This is sensitive to the data type, as 0 !== '0'. I wonder if we should be more flexible. How does 2.x branch behave? TODO write test for that
                return 'xAxisId' in item && item.xAxisId === axisId;
            case 'yAxis':
                return 'yAxisId' in item && item.yAxisId === axisId;
            case 'zAxis':
                return 'zAxisId' in item && item.zAxisId === axisId;
            case 'angleAxis':
                return 'angleAxisId' in item && item.angleAxisId === axisId;
            case 'radiusAxis':
                return 'radiusAxisId' in item && item.radiusAxisId === axisId;
            default:
                return false;
        }
    };
}
var selectUnfilteredCartesianItems = (state)=>state.graphicalItems.cartesianItems;
var selectAxisPredicate = (0, _reselect.createSelector)([
    (0, _pickAxisType.pickAxisType),
    (0, _pickAxisId.pickAxisId)
], itemAxisPredicate);
var combineGraphicalItemsSettings = (graphicalItems, axisSettings, axisPredicate)=>graphicalItems.filter(axisPredicate).filter((item)=>{
        if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.includeHidden) === true) return true;
        return !item.hide;
    });
var selectCartesianItemsSettings = (0, _reselect.createSelector)([
    selectUnfilteredCartesianItems,
    selectBaseAxis,
    selectAxisPredicate
], combineGraphicalItemsSettings, {
    memoizeOptions: {
        resultEqualityCheck: (0, _arrayEqualityCheck.emptyArraysAreEqualCheck)
    }
});
var selectStackedCartesianItemsSettings = (0, _reselect.createSelector)([
    selectCartesianItemsSettings
], (cartesianItems)=>{
    return cartesianItems.filter((item)=>item.type === 'area' || item.type === 'bar').filter((0, _stackedGraphicalItem.isStacked));
});
var filterGraphicalNotStackedItems = (cartesianItems)=>cartesianItems.filter((item)=>!('stackId' in item) || item.stackId === undefined);
var selectCartesianItemsSettingsExceptStacked = (0, _reselect.createSelector)([
    selectCartesianItemsSettings
], filterGraphicalNotStackedItems);
var combineGraphicalItemsData = (cartesianItems)=>cartesianItems.map((item)=>item.data).filter(Boolean).flat(1);
var selectCartesianGraphicalItemsData = (0, _reselect.createSelector)([
    selectCartesianItemsSettings
], combineGraphicalItemsData, {
    memoizeOptions: {
        resultEqualityCheck: (0, _arrayEqualityCheck.emptyArraysAreEqualCheck)
    }
});
var combineDisplayedData = (graphicalItemsData, _ref)=>{
    var { chartData = [], dataStartIndex, dataEndIndex } = _ref;
    if (graphicalItemsData.length > 0) /*
     * There is no slicing when data is defined on graphical items. Why?
     * Because Brush ignores data defined on graphical items,
     * and does not render.
     * So Brush will never show up in a Scatter chart for example.
     * This is something we will need to fix.
     *
     * Now, when the root chart data is not defined, the dataEndIndex is 0,
     * which means the itemsData will be sliced to an empty array anyway.
     * But that's an implementation detail, and we can fix that too.
     *
     * Also, in absence of Axis dataKey, we use the dataKey from each item, respectively.
     * This is the usual pattern for numerical axis, that is the one where bars go up:
     * users don't specify any dataKey by default and expect the axis to "just match the data".
     */ return graphicalItemsData;
    return chartData.slice(dataStartIndex, dataEndIndex + 1);
};
var selectDisplayedData = (0, _reselect.createSelector)([
    selectCartesianGraphicalItemsData,
    (0, _dataSelectors.selectChartDataWithIndexesIfNotInPanoramaPosition4)
], combineDisplayedData);
var combineAppliedValues = (data, axisSettings, items)=>{
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) return data.map((item)=>({
            value: (0, _chartUtils.getValueByDataKey)(item, axisSettings.dataKey)
        }));
    if (items.length > 0) return items.map((item)=>item.dataKey).flatMap((dataKey)=>data.map((entry)=>({
                value: (0, _chartUtils.getValueByDataKey)(entry, dataKey)
            })));
    return data.map((entry)=>({
            value: entry
        }));
};
var selectAllAppliedValues = (0, _reselect.createSelector)([
    selectDisplayedData,
    selectBaseAxis,
    selectCartesianItemsSettings
], combineAppliedValues);
function isErrorBarRelevantForAxisType(axisType, errorBar) {
    switch(axisType){
        case 'xAxis':
            return errorBar.direction === 'x';
        case 'yAxis':
            return errorBar.direction === 'y';
        default:
            return false;
    }
}
/**
 * This is type of "error" in chart. It is set by using ErrorBar, and it can represent confidence interval,
 * or gap in the data, or standard deviation, or quartiles in boxplot, or whiskers or whatever.
 *
 * We will internally represent it as a tuple of two numbers, where the first number is the lower bound and the second number is the upper bound.
 *
 * It is also true that the first number should be lower than or equal to the associated "main value",
 * and the second number should be higher than or equal to the associated "main value".
 */ function makeNumber(val) {
    if ((0, _dataUtils.isNumOrStr)(val) || val instanceof Date) {
        var n = Number(val);
        if ((0, _isWellBehavedNumber.isWellBehavedNumber)(n)) return n;
    }
    return undefined;
}
function makeDomain(val) {
    if (Array.isArray(val)) {
        var attempt = [
            makeNumber(val[0]),
            makeNumber(val[1])
        ];
        if ((0, _isDomainSpecifiedByUser.isWellFormedNumberDomain)(attempt)) return attempt;
        return undefined;
    }
    var n = makeNumber(val);
    if (n == null) return undefined;
    return [
        n,
        n
    ];
}
function onlyAllowNumbers(data) {
    return data.map(makeNumber).filter((0, _dataUtils.isNotNil));
}
function getErrorDomainByDataKey(entry, appliedValue, relevantErrorBars) {
    if (!relevantErrorBars || typeof appliedValue !== 'number' || (0, _dataUtils.isNan)(appliedValue)) return [];
    if (!relevantErrorBars.length) return [];
    return onlyAllowNumbers(relevantErrorBars.flatMap((eb)=>{
        var errorValue = (0, _chartUtils.getValueByDataKey)(entry, eb.dataKey);
        var lowBound, highBound;
        if (Array.isArray(errorValue)) [lowBound, highBound] = errorValue;
        else lowBound = highBound = errorValue;
        if (!(0, _isWellBehavedNumber.isWellBehavedNumber)(lowBound) || !(0, _isWellBehavedNumber.isWellBehavedNumber)(highBound)) return undefined;
        return [
            appliedValue - lowBound,
            appliedValue + highBound
        ];
    }));
}
var selectTooltipAxis = (state)=>{
    var axisType = (0, _selectTooltipAxisType.selectTooltipAxisType)(state);
    var axisId = (0, _selectTooltipAxisId.selectTooltipAxisId)(state);
    return selectAxisSettings(state, axisType, axisId);
};
var selectTooltipAxisDataKey = (0, _reselect.createSelector)([
    selectTooltipAxis
], (axis)=>axis === null || axis === void 0 ? void 0 : axis.dataKey);
var selectDisplayedStackedData = (0, _reselect.createSelector)([
    selectStackedCartesianItemsSettings,
    (0, _dataSelectors.selectChartDataWithIndexesIfNotInPanoramaPosition4),
    selectTooltipAxis
], (0, _combineDisplayedStackedData.combineDisplayedStackedData));
var combineStackGroups = (displayedData, items, stackOffsetType, reverseStackOrder)=>{
    var initialItemsGroups = {};
    var itemsGroup = items.reduce((acc, item)=>{
        if (item.stackId == null) return acc;
        var stack = acc[item.stackId];
        if (stack == null) stack = [];
        stack.push(item);
        acc[item.stackId] = stack;
        return acc;
    }, initialItemsGroups);
    return Object.fromEntries(Object.entries(itemsGroup).map((_ref2)=>{
        var [stackId, graphicalItems] = _ref2;
        var orderedGraphicalItems = reverseStackOrder ? [
            ...graphicalItems
        ].reverse() : graphicalItems;
        var dataKeys = orderedGraphicalItems.map((0, _getStackSeriesIdentifier.getStackSeriesIdentifier));
        return [
            stackId,
            {
                // @ts-expect-error getStackedData requires that the input is array of objects, Recharts does not test for that
                stackedData: (0, _chartUtils.getStackedData)(displayedData, dataKeys, stackOffsetType),
                graphicalItems: orderedGraphicalItems
            }
        ];
    }));
};
var selectStackGroups = (0, _reselect.createSelector)([
    selectDisplayedStackedData,
    selectStackedCartesianItemsSettings,
    (0, _rootPropsSelectors.selectStackOffsetType),
    (0, _rootPropsSelectors.selectReverseStackOrder)
], combineStackGroups);
var combineDomainOfStackGroups = (stackGroups, _ref3, axisType, domainFromUserPreference)=>{
    var { dataStartIndex, dataEndIndex } = _ref3;
    if (domainFromUserPreference != null) // User has specified a domain, so we respect that and we can skip computing anything else
    return undefined;
    if (axisType === 'zAxis') // ZAxis ignores stacks
    return undefined;
    var domainOfStackGroups = (0, _chartUtils.getDomainOfStackGroups)(stackGroups, dataStartIndex, dataEndIndex);
    if (domainOfStackGroups != null && domainOfStackGroups[0] === 0 && domainOfStackGroups[1] === 0) return undefined;
    return domainOfStackGroups;
};
var selectAllowsDataOverflow = (0, _reselect.createSelector)([
    selectBaseAxis
], (axisSettings)=>axisSettings.allowDataOverflow);
var getDomainDefinition = (axisSettings)=>{
    var _axisSettings$domain;
    if (axisSettings == null || !('domain' in axisSettings)) return defaultNumericDomain;
    if (axisSettings.domain != null) return axisSettings.domain;
    if ('ticks' in axisSettings && axisSettings.ticks != null) {
        if (axisSettings.type === 'number') {
            var allValues = onlyAllowNumbers(axisSettings.ticks);
            return [
                Math.min(...allValues),
                Math.max(...allValues)
            ];
        }
        if (axisSettings.type === 'category') return axisSettings.ticks.map(String);
    }
    return (_axisSettings$domain = axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.domain) !== null && _axisSettings$domain !== void 0 ? _axisSettings$domain : defaultNumericDomain;
};
var selectDomainDefinition = (0, _reselect.createSelector)([
    selectBaseAxis
], getDomainDefinition);
var selectDomainFromUserPreference = (0, _reselect.createSelector)([
    selectDomainDefinition,
    selectAllowsDataOverflow
], (0, _isDomainSpecifiedByUser.numericalDomainSpecifiedWithoutRequiringData));
var selectDomainOfStackGroups = (0, _reselect.createSelector)([
    selectStackGroups,
    (0, _dataSelectors.selectChartDataWithIndexes),
    (0, _pickAxisType.pickAxisType),
    selectDomainFromUserPreference
], combineDomainOfStackGroups, {
    memoizeOptions: {
        resultEqualityCheck: (0, _numberDomainEqualityCheck.numberDomainEqualityCheck)
    }
});
var selectAllErrorBarSettings = (state)=>state.errorBars;
var combineRelevantErrorBarSettings = (cartesianItemsSettings, allErrorBarSettings, axisType)=>{
    return cartesianItemsSettings.flatMap((item)=>{
        return allErrorBarSettings[item.id];
    }).filter(Boolean).filter((e)=>{
        return isErrorBarRelevantForAxisType(axisType, e);
    });
};
var mergeDomains = function mergeDomains() {
    for(var _len = arguments.length, domains = new Array(_len), _key = 0; _key < _len; _key++)domains[_key] = arguments[_key];
    var allDomains = domains.filter(Boolean);
    if (allDomains.length === 0) return undefined;
    var allValues = allDomains.flat();
    var min = Math.min(...allValues);
    var max = Math.max(...allValues);
    return [
        min,
        max
    ];
};
var combineDomainOfAllAppliedNumericalValuesIncludingErrorValues = (data, axisSettings, items, errorBars, axisType)=>{
    var lowerEnd, upperEnd;
    if (items.length > 0) data.forEach((entry)=>{
        items.forEach((item)=>{
            var _errorBars$item$id, _axisSettings$dataKey;
            var relevantErrorBars = (_errorBars$item$id = errorBars[item.id]) === null || _errorBars$item$id === void 0 ? void 0 : _errorBars$item$id.filter((errorBar)=>isErrorBarRelevantForAxisType(axisType, errorBar));
            var valueByDataKey = (0, _chartUtils.getValueByDataKey)(entry, (_axisSettings$dataKey = axisSettings.dataKey) !== null && _axisSettings$dataKey !== void 0 ? _axisSettings$dataKey : item.dataKey);
            var errorDomain = getErrorDomainByDataKey(entry, valueByDataKey, relevantErrorBars);
            if (errorDomain.length >= 2) {
                var localLower = Math.min(...errorDomain);
                var localUpper = Math.max(...errorDomain);
                if (lowerEnd == null || localLower < lowerEnd) lowerEnd = localLower;
                if (upperEnd == null || localUpper > upperEnd) upperEnd = localUpper;
            }
            var dataValueDomain = makeDomain(valueByDataKey);
            if (dataValueDomain != null) {
                lowerEnd = lowerEnd == null ? dataValueDomain[0] : Math.min(lowerEnd, dataValueDomain[0]);
                upperEnd = upperEnd == null ? dataValueDomain[1] : Math.max(upperEnd, dataValueDomain[1]);
            }
        });
    });
    if ((axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.dataKey) != null) data.forEach((item)=>{
        var dataValueDomain = makeDomain((0, _chartUtils.getValueByDataKey)(item, axisSettings.dataKey));
        if (dataValueDomain != null) {
            lowerEnd = lowerEnd == null ? dataValueDomain[0] : Math.min(lowerEnd, dataValueDomain[0]);
            upperEnd = upperEnd == null ? dataValueDomain[1] : Math.max(upperEnd, dataValueDomain[1]);
        }
    });
    if ((0, _isWellBehavedNumber.isWellBehavedNumber)(lowerEnd) && (0, _isWellBehavedNumber.isWellBehavedNumber)(upperEnd)) return [
        lowerEnd,
        upperEnd
    ];
    return undefined;
};
var selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = (0, _reselect.createSelector)([
    selectDisplayedData,
    selectBaseAxis,
    selectCartesianItemsSettingsExceptStacked,
    selectAllErrorBarSettings,
    (0, _pickAxisType.pickAxisType)
], combineDomainOfAllAppliedNumericalValuesIncludingErrorValues, {
    memoizeOptions: {
        resultEqualityCheck: (0, _numberDomainEqualityCheck.numberDomainEqualityCheck)
    }
});
function onlyAllowNumbersAndStringsAndDates(item) {
    var { value } = item;
    if ((0, _dataUtils.isNumOrStr)(value) || value instanceof Date) return value;
    return undefined;
}
var computeDomainOfTypeCategory = (allDataSquished, axisSettings, isCategorical)=>{
    var categoricalDomain = allDataSquished.map(onlyAllowNumbersAndStringsAndDates).filter((v)=>v != null);
    if (isCategorical && (axisSettings.dataKey == null || axisSettings.allowDuplicatedCategory && (0, _dataUtils.hasDuplicate)(categoricalDomain))) /*
     * 1. In an absence of dataKey, Recharts will use array indexes as its categorical domain
     * 2. When category axis has duplicated text, serial numbers are used to generate scale
     */ return (0, _rangeDefault.default)(0, allDataSquished.length);
    if (axisSettings.allowDuplicatedCategory) return categoricalDomain;
    return Array.from(new Set(categoricalDomain));
};
var selectReferenceDots = (state)=>state.referenceElements.dots;
var filterReferenceElements = (elements, axisType, axisId)=>{
    return elements.filter((el)=>el.ifOverflow === 'extendDomain').filter((el)=>{
        if (axisType === 'xAxis') return el.xAxisId === axisId;
        return el.yAxisId === axisId;
    });
};
var selectReferenceDotsByAxis = (0, _reselect.createSelector)([
    selectReferenceDots,
    (0, _pickAxisType.pickAxisType),
    (0, _pickAxisId.pickAxisId)
], filterReferenceElements);
var selectReferenceAreas = (state)=>state.referenceElements.areas;
var selectReferenceAreasByAxis = (0, _reselect.createSelector)([
    selectReferenceAreas,
    (0, _pickAxisType.pickAxisType),
    (0, _pickAxisId.pickAxisId)
], filterReferenceElements);
var selectReferenceLines = (state)=>state.referenceElements.lines;
var selectReferenceLinesByAxis = (0, _reselect.createSelector)([
    selectReferenceLines,
    (0, _pickAxisType.pickAxisType),
    (0, _pickAxisId.pickAxisId)
], filterReferenceElements);
var combineDotsDomain = (dots, axisType)=>{
    if (dots == null) return undefined;
    var allCoords = onlyAllowNumbers(dots.map((dot)=>axisType === 'xAxis' ? dot.x : dot.y));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var selectReferenceDotsDomain = (0, _reselect.createSelector)(selectReferenceDotsByAxis, (0, _pickAxisType.pickAxisType), combineDotsDomain);
var combineAreasDomain = (areas, axisType)=>{
    if (areas == null) return undefined;
    var allCoords = onlyAllowNumbers(areas.flatMap((area)=>[
            axisType === 'xAxis' ? area.x1 : area.y1,
            axisType === 'xAxis' ? area.x2 : area.y2
        ]));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var selectReferenceAreasDomain = (0, _reselect.createSelector)([
    selectReferenceAreasByAxis,
    (0, _pickAxisType.pickAxisType)
], combineAreasDomain);
function extractXCoordinates(line) {
    var _line$segment;
    if (line.x != null) return onlyAllowNumbers([
        line.x
    ]);
    var segmentCoordinates = (_line$segment = line.segment) === null || _line$segment === void 0 ? void 0 : _line$segment.map((s)=>s.x);
    if (segmentCoordinates == null || segmentCoordinates.length === 0) return [];
    return onlyAllowNumbers(segmentCoordinates);
}
function extractYCoordinates(line) {
    var _line$segment2;
    if (line.y != null) return onlyAllowNumbers([
        line.y
    ]);
    var segmentCoordinates = (_line$segment2 = line.segment) === null || _line$segment2 === void 0 ? void 0 : _line$segment2.map((s)=>s.y);
    if (segmentCoordinates == null || segmentCoordinates.length === 0) return [];
    return onlyAllowNumbers(segmentCoordinates);
}
var combineLinesDomain = (lines, axisType)=>{
    if (lines == null) return undefined;
    var allCoords = lines.flatMap((line)=>axisType === 'xAxis' ? extractXCoordinates(line) : extractYCoordinates(line));
    if (allCoords.length === 0) return undefined;
    return [
        Math.min(...allCoords),
        Math.max(...allCoords)
    ];
};
var selectReferenceLinesDomain = (0, _reselect.createSelector)([
    selectReferenceLinesByAxis,
    (0, _pickAxisType.pickAxisType)
], combineLinesDomain);
var selectReferenceElementsDomain = (0, _reselect.createSelector)(selectReferenceDotsDomain, selectReferenceLinesDomain, selectReferenceAreasDomain, (dotsDomain, linesDomain, areasDomain)=>{
    return mergeDomains(dotsDomain, areasDomain, linesDomain);
});
var combineNumericalDomain = (axisSettings, domainDefinition, domainFromUserPreference, domainOfStackGroups, dataAndErrorBarsDomain, referenceElementsDomain, layout, axisType)=>{
    if (domainFromUserPreference != null) // We're done! No need to compute anything else.
    return domainFromUserPreference;
    var shouldIncludeDomainOfStackGroups = layout === 'vertical' && axisType === 'xAxis' || layout === 'horizontal' && axisType === 'yAxis';
    var mergedDomains = shouldIncludeDomainOfStackGroups ? mergeDomains(domainOfStackGroups, referenceElementsDomain, dataAndErrorBarsDomain) : mergeDomains(referenceElementsDomain, dataAndErrorBarsDomain);
    return (0, _isDomainSpecifiedByUser.parseNumericalUserDomain)(domainDefinition, mergedDomains, axisSettings.allowDataOverflow);
};
var selectNumericalDomain = (0, _reselect.createSelector)([
    selectBaseAxis,
    selectDomainDefinition,
    selectDomainFromUserPreference,
    selectDomainOfStackGroups,
    selectDomainOfAllAppliedNumericalValuesIncludingErrorValues,
    selectReferenceElementsDomain,
    (0, _chartLayoutContext.selectChartLayout),
    (0, _pickAxisType.pickAxisType)
], combineNumericalDomain, {
    memoizeOptions: {
        resultEqualityCheck: (0, _numberDomainEqualityCheck.numberDomainEqualityCheck)
    }
});
/**
 * Expand by design maps everything between 0 and 1,
 * there is nothing to compute.
 * See https://d3js.org/d3-shape/stack#stack-offsets
 */ var expandDomain = [
    0,
    1
];
var combineAxisDomain = (axisSettings, layout, displayedData, allAppliedValues, stackOffsetType, axisType, numericalDomain)=>{
    if ((axisSettings == null || displayedData == null || displayedData.length === 0) && numericalDomain === undefined) return undefined;
    var { dataKey, type } = axisSettings;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    if (isCategorical && dataKey == null) {
        var _displayedData$length;
        return (0, _rangeDefault.default)(0, (_displayedData$length = displayedData === null || displayedData === void 0 ? void 0 : displayedData.length) !== null && _displayedData$length !== void 0 ? _displayedData$length : 0);
    }
    if (type === 'category') return computeDomainOfTypeCategory(allAppliedValues, axisSettings, isCategorical);
    if (stackOffsetType === 'expand') return expandDomain;
    return numericalDomain;
};
var selectAxisDomain = (0, _reselect.createSelector)([
    selectBaseAxis,
    (0, _chartLayoutContext.selectChartLayout),
    selectDisplayedData,
    selectAllAppliedValues,
    (0, _rootPropsSelectors.selectStackOffsetType),
    (0, _pickAxisType.pickAxisType),
    selectNumericalDomain
], combineAxisDomain);
var combineRealScaleType = (axisConfig, layout, hasBar, chartType, axisType)=>{
    if (axisConfig == null) return undefined;
    var { scale, type } = axisConfig;
    if (scale === 'auto') {
        if (layout === 'radial' && axisType === 'radiusAxis') return 'band';
        if (layout === 'radial' && axisType === 'angleAxis') return 'linear';
        if (type === 'category' && chartType && (chartType.indexOf('LineChart') >= 0 || chartType.indexOf('AreaChart') >= 0 || chartType.indexOf('ComposedChart') >= 0 && !hasBar)) return 'point';
        if (type === 'category') return 'band';
        return 'linear';
    }
    if (typeof scale === 'string') {
        var name = "scale".concat((0, _dataUtils.upperFirst)(scale));
        return name in _d3Scale ? name : 'point';
    }
    return undefined;
};
var selectRealScaleType = (0, _reselect.createSelector)([
    selectBaseAxis,
    (0, _chartLayoutContext.selectChartLayout),
    selectHasBar,
    (0, _rootPropsSelectors.selectChartName),
    (0, _pickAxisType.pickAxisType)
], combineRealScaleType);
function getD3ScaleFromType(realScaleType) {
    if (realScaleType == null) return undefined;
    if (realScaleType in _d3Scale) // @ts-expect-error we should do better type verification here
    return _d3Scale[realScaleType]();
    var name = "scale".concat((0, _dataUtils.upperFirst)(realScaleType));
    if (name in _d3Scale) // @ts-expect-error we should do better type verification here
    return _d3Scale[name]();
    return undefined;
}
function combineScaleFunction(axis, realScaleType, axisDomain, axisRange) {
    if (axisDomain == null || axisRange == null) return undefined;
    if (typeof axis.scale === 'function') // @ts-expect-error we're going to assume here that if axis.scale is a function then it is a d3Scale function
    return axis.scale.copy().domain(axisDomain).range(axisRange);
    var d3ScaleFunction = getD3ScaleFromType(realScaleType);
    if (d3ScaleFunction == null) return undefined;
    var scale = d3ScaleFunction.domain(axisDomain).range(axisRange);
    // I don't like this function because it mutates the scale. We should come up with a way to compute the domain up front.
    (0, _chartUtils.checkDomainOfScale)(scale);
    return scale;
}
var combineNiceTicks = (axisDomain, axisSettings, realScaleType)=>{
    var domainDefinition = getDomainDefinition(axisSettings);
    if (realScaleType !== 'auto' && realScaleType !== 'linear') return undefined;
    if (axisSettings != null && axisSettings.tickCount && Array.isArray(domainDefinition) && (domainDefinition[0] === 'auto' || domainDefinition[1] === 'auto') && (0, _isDomainSpecifiedByUser.isWellFormedNumberDomain)(axisDomain)) return (0, _scale.getNiceTickValues)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals);
    if (axisSettings != null && axisSettings.tickCount && axisSettings.type === 'number' && (0, _isDomainSpecifiedByUser.isWellFormedNumberDomain)(axisDomain)) return (0, _scale.getTickValuesFixedDomain)(axisDomain, axisSettings.tickCount, axisSettings.allowDecimals);
    return undefined;
};
var selectNiceTicks = (0, _reselect.createSelector)([
    selectAxisDomain,
    selectAxisSettings,
    selectRealScaleType
], combineNiceTicks);
var combineAxisDomainWithNiceTicks = (axisSettings, domain, niceTicks, axisType)=>{
    if (/*
   * Angle axis for some reason uses nice ticks when rendering axis tick labels,
   * but doesn't use nice ticks for extending domain like all the other axes do.
   * Not really sure why? Is there a good reason,
   * or is it just because someone added support for nice ticks to the other axes and forgot this one?
   */ axisType !== 'angleAxis' && (axisSettings === null || axisSettings === void 0 ? void 0 : axisSettings.type) === 'number' && (0, _isDomainSpecifiedByUser.isWellFormedNumberDomain)(domain) && Array.isArray(niceTicks) && niceTicks.length > 0) {
        var minFromDomain = domain[0];
        var minFromTicks = niceTicks[0];
        var maxFromDomain = domain[1];
        var maxFromTicks = niceTicks[niceTicks.length - 1];
        return [
            Math.min(minFromDomain, minFromTicks),
            Math.max(maxFromDomain, maxFromTicks)
        ];
    }
    return domain;
};
var selectAxisDomainIncludingNiceTicks = (0, _reselect.createSelector)([
    selectBaseAxis,
    selectAxisDomain,
    selectNiceTicks,
    (0, _pickAxisType.pickAxisType)
], combineAxisDomainWithNiceTicks);
var selectSmallestDistanceBetweenValues = (0, _reselect.createSelector)(selectAllAppliedValues, selectBaseAxis, (allDataSquished, axisSettings)=>{
    if (!axisSettings || axisSettings.type !== 'number') return undefined;
    var smallestDistanceBetweenValues = Infinity;
    var sortedValues = Array.from(onlyAllowNumbers(allDataSquished.map((d)=>d.value))).sort((a, b)=>a - b);
    var first = sortedValues[0];
    var last = sortedValues[sortedValues.length - 1];
    if (first == null || last == null) return Infinity;
    var diff = last - first;
    if (diff === 0) return Infinity;
    // Only do n - 1 distance calculations because there's only n - 1 distances between n values.
    for(var i = 0; i < sortedValues.length - 1; i++){
        var curr = sortedValues[i];
        var next = sortedValues[i + 1];
        if (curr == null || next == null) continue;
        var distance = next - curr;
        smallestDistanceBetweenValues = Math.min(smallestDistanceBetweenValues, distance);
    }
    return smallestDistanceBetweenValues / diff;
});
var selectCalculatedPadding = (0, _reselect.createSelector)(selectSmallestDistanceBetweenValues, (0, _chartLayoutContext.selectChartLayout), (0, _rootPropsSelectors.selectBarCategoryGap), (0, _selectChartOffsetInternal.selectChartOffsetInternal), (_1, _2, _3, _4, padding)=>padding, (smallestDistanceInPercent, layout, barCategoryGap, offset, padding)=>{
    if (!(0, _isWellBehavedNumber.isWellBehavedNumber)(smallestDistanceInPercent)) return 0;
    var rangeWidth = layout === 'vertical' ? offset.height : offset.width;
    if (padding === 'gap') return smallestDistanceInPercent * rangeWidth / 2;
    if (padding === 'no-gap') {
        var gap = (0, _dataUtils.getPercentValue)(barCategoryGap, smallestDistanceInPercent * rangeWidth);
        var halfBand = smallestDistanceInPercent * rangeWidth / 2;
        return halfBand - gap - (halfBand - gap) / rangeWidth * gap;
    }
    return 0;
});
var selectCalculatedXAxisPadding = (state, axisId, isPanorama)=>{
    var xAxisSettings = selectXAxisSettings(state, axisId);
    if (xAxisSettings == null || typeof xAxisSettings.padding !== 'string') return 0;
    return selectCalculatedPadding(state, 'xAxis', axisId, isPanorama, xAxisSettings.padding);
};
var selectCalculatedYAxisPadding = (state, axisId, isPanorama)=>{
    var yAxisSettings = selectYAxisSettings(state, axisId);
    if (yAxisSettings == null || typeof yAxisSettings.padding !== 'string') return 0;
    return selectCalculatedPadding(state, 'yAxis', axisId, isPanorama, yAxisSettings.padding);
};
var selectXAxisPadding = (0, _reselect.createSelector)(selectXAxisSettings, selectCalculatedXAxisPadding, (xAxisSettings, calculated)=>{
    var _padding$left, _padding$right;
    if (xAxisSettings == null) return {
        left: 0,
        right: 0
    };
    var { padding } = xAxisSettings;
    if (typeof padding === 'string') return {
        left: calculated,
        right: calculated
    };
    return {
        left: ((_padding$left = padding.left) !== null && _padding$left !== void 0 ? _padding$left : 0) + calculated,
        right: ((_padding$right = padding.right) !== null && _padding$right !== void 0 ? _padding$right : 0) + calculated
    };
});
var selectYAxisPadding = (0, _reselect.createSelector)(selectYAxisSettings, selectCalculatedYAxisPadding, (yAxisSettings, calculated)=>{
    var _padding$top, _padding$bottom;
    if (yAxisSettings == null) return {
        top: 0,
        bottom: 0
    };
    var { padding } = yAxisSettings;
    if (typeof padding === 'string') return {
        top: calculated,
        bottom: calculated
    };
    return {
        top: ((_padding$top = padding.top) !== null && _padding$top !== void 0 ? _padding$top : 0) + calculated,
        bottom: ((_padding$bottom = padding.bottom) !== null && _padding$bottom !== void 0 ? _padding$bottom : 0) + calculated
    };
});
var combineXAxisRange = (0, _reselect.createSelector)([
    (0, _selectChartOffsetInternal.selectChartOffsetInternal),
    selectXAxisPadding,
    (0, _brushSelectors.selectBrushDimensions),
    (0, _brushSelectors.selectBrushSettings),
    (_state, _axisId, isPanorama)=>isPanorama
], (offset, padding, brushDimensions, _ref4, isPanorama)=>{
    var { padding: brushPadding } = _ref4;
    if (isPanorama) return [
        brushPadding.left,
        brushDimensions.width - brushPadding.right
    ];
    return [
        offset.left + padding.left,
        offset.left + offset.width - padding.right
    ];
});
var combineYAxisRange = (0, _reselect.createSelector)([
    (0, _selectChartOffsetInternal.selectChartOffsetInternal),
    (0, _chartLayoutContext.selectChartLayout),
    selectYAxisPadding,
    (0, _brushSelectors.selectBrushDimensions),
    (0, _brushSelectors.selectBrushSettings),
    (_state, _axisId, isPanorama)=>isPanorama
], (offset, layout, padding, brushDimensions, _ref5, isPanorama)=>{
    var { padding: brushPadding } = _ref5;
    if (isPanorama) return [
        brushDimensions.height - brushPadding.bottom,
        brushPadding.top
    ];
    if (layout === 'horizontal') return [
        offset.top + offset.height - padding.bottom,
        offset.top + padding.top
    ];
    return [
        offset.top + padding.top,
        offset.top + offset.height - padding.bottom
    ];
});
var selectAxisRange = (state, axisType, axisId, isPanorama)=>{
    var _selectZAxisSettings;
    switch(axisType){
        case 'xAxis':
            return combineXAxisRange(state, axisId, isPanorama);
        case 'yAxis':
            return combineYAxisRange(state, axisId, isPanorama);
        case 'zAxis':
            return (_selectZAxisSettings = selectZAxisSettings(state, axisId)) === null || _selectZAxisSettings === void 0 ? void 0 : _selectZAxisSettings.range;
        case 'angleAxis':
            return (0, _polarAxisSelectors.selectAngleAxisRange)(state);
        case 'radiusAxis':
            return (0, _polarAxisSelectors.selectRadiusAxisRange)(state, axisId);
        default:
            return undefined;
    }
};
var selectAxisRangeWithReverse = (0, _reselect.createSelector)([
    selectBaseAxis,
    selectAxisRange
], (0, _combineAxisRangeWithReverse.combineAxisRangeWithReverse));
var selectAxisScale = (0, _reselect.createSelector)([
    selectBaseAxis,
    selectRealScaleType,
    selectAxisDomainIncludingNiceTicks,
    selectAxisRangeWithReverse
], combineScaleFunction);
var selectErrorBarsSettings = (0, _reselect.createSelector)([
    selectCartesianItemsSettings,
    selectAllErrorBarSettings,
    (0, _pickAxisType.pickAxisType)
], combineRelevantErrorBarSettings);
function compareIds(a, b) {
    if (a.id < b.id) return -1;
    if (a.id > b.id) return 1;
    return 0;
}
var pickAxisOrientation = (_state, orientation)=>orientation;
var pickMirror = (_state, _orientation, mirror)=>mirror;
var selectAllXAxesWithOffsetType = (0, _reselect.createSelector)((0, _selectAllAxes.selectAllXAxes), pickAxisOrientation, pickMirror, (allAxes, orientation, mirror)=>allAxes.filter((axis)=>axis.orientation === orientation).filter((axis)=>axis.mirror === mirror).sort(compareIds));
var selectAllYAxesWithOffsetType = (0, _reselect.createSelector)((0, _selectAllAxes.selectAllYAxes), pickAxisOrientation, pickMirror, (allAxes, orientation, mirror)=>allAxes.filter((axis)=>axis.orientation === orientation).filter((axis)=>axis.mirror === mirror).sort(compareIds));
var getXAxisSize = (offset, axisSettings)=>{
    return {
        width: offset.width,
        height: axisSettings.height
    };
};
var getYAxisSize = (offset, axisSettings)=>{
    var width = typeof axisSettings.width === 'number' ? axisSettings.width : (0, _constants.DEFAULT_Y_AXIS_WIDTH);
    return {
        width,
        height: offset.height
    };
};
var selectXAxisSize = (0, _reselect.createSelector)((0, _selectChartOffsetInternal.selectChartOffsetInternal), selectXAxisSettings, getXAxisSize);
var combineXAxisPositionStartingPoint = (offset, orientation, chartHeight)=>{
    switch(orientation){
        case 'top':
            return offset.top;
        case 'bottom':
            return chartHeight - offset.bottom;
        default:
            return 0;
    }
};
var combineYAxisPositionStartingPoint = (offset, orientation, chartWidth)=>{
    switch(orientation){
        case 'left':
            return offset.left;
        case 'right':
            return chartWidth - offset.right;
        default:
            return 0;
    }
};
var selectAllXAxesOffsetSteps = (0, _reselect.createSelector)((0, _containerSelectors.selectChartHeight), (0, _selectChartOffsetInternal.selectChartOffsetInternal), selectAllXAxesWithOffsetType, pickAxisOrientation, pickMirror, (chartHeight, offset, allAxesWithSameOffsetType, orientation, mirror)=>{
    var steps = {};
    var position;
    allAxesWithSameOffsetType.forEach((axis)=>{
        var axisSize = getXAxisSize(offset, axis);
        if (position == null) position = combineXAxisPositionStartingPoint(offset, orientation, chartHeight);
        var needSpace = orientation === 'top' && !mirror || orientation === 'bottom' && mirror;
        steps[axis.id] = position - Number(needSpace) * axisSize.height;
        position += (needSpace ? -1 : 1) * axisSize.height;
    });
    return steps;
});
var selectAllYAxesOffsetSteps = (0, _reselect.createSelector)((0, _containerSelectors.selectChartWidth), (0, _selectChartOffsetInternal.selectChartOffsetInternal), selectAllYAxesWithOffsetType, pickAxisOrientation, pickMirror, (chartWidth, offset, allAxesWithSameOffsetType, orientation, mirror)=>{
    var steps = {};
    var position;
    allAxesWithSameOffsetType.forEach((axis)=>{
        var axisSize = getYAxisSize(offset, axis);
        if (position == null) position = combineYAxisPositionStartingPoint(offset, orientation, chartWidth);
        var needSpace = orientation === 'left' && !mirror || orientation === 'right' && mirror;
        steps[axis.id] = position - Number(needSpace) * axisSize.width;
        position += (needSpace ? -1 : 1) * axisSize.width;
    });
    return steps;
});
var selectXAxisOffsetSteps = (state, axisId)=>{
    var axisSettings = selectXAxisSettings(state, axisId);
    if (axisSettings == null) return undefined;
    return selectAllXAxesOffsetSteps(state, axisSettings.orientation, axisSettings.mirror);
};
var selectXAxisPosition = (0, _reselect.createSelector)([
    (0, _selectChartOffsetInternal.selectChartOffsetInternal),
    selectXAxisSettings,
    selectXAxisOffsetSteps,
    (_, axisId)=>axisId
], (offset, axisSettings, allSteps, axisId)=>{
    if (axisSettings == null) return undefined;
    var stepOfThisAxis = allSteps === null || allSteps === void 0 ? void 0 : allSteps[axisId];
    if (stepOfThisAxis == null) return {
        x: offset.left,
        y: 0
    };
    return {
        x: offset.left,
        y: stepOfThisAxis
    };
});
var selectYAxisOffsetSteps = (state, axisId)=>{
    var axisSettings = selectYAxisSettings(state, axisId);
    if (axisSettings == null) return undefined;
    return selectAllYAxesOffsetSteps(state, axisSettings.orientation, axisSettings.mirror);
};
var selectYAxisPosition = (0, _reselect.createSelector)([
    (0, _selectChartOffsetInternal.selectChartOffsetInternal),
    selectYAxisSettings,
    selectYAxisOffsetSteps,
    (_, axisId)=>axisId
], (offset, axisSettings, allSteps, axisId)=>{
    if (axisSettings == null) return undefined;
    var stepOfThisAxis = allSteps === null || allSteps === void 0 ? void 0 : allSteps[axisId];
    if (stepOfThisAxis == null) return {
        x: 0,
        y: offset.top
    };
    return {
        x: stepOfThisAxis,
        y: offset.top
    };
});
var selectYAxisSize = (0, _reselect.createSelector)((0, _selectChartOffsetInternal.selectChartOffsetInternal), selectYAxisSettings, (offset, axisSettings)=>{
    var width = typeof axisSettings.width === 'number' ? axisSettings.width : (0, _constants.DEFAULT_Y_AXIS_WIDTH);
    return {
        width,
        height: offset.height
    };
});
var selectCartesianAxisSize = (state, axisType, axisId)=>{
    switch(axisType){
        case 'xAxis':
            return selectXAxisSize(state, axisId).width;
        case 'yAxis':
            return selectYAxisSize(state, axisId).height;
        default:
            return undefined;
    }
};
var combineDuplicateDomain = (chartLayout, appliedValues, axis, axisType)=>{
    if (axis == null) return undefined;
    var { allowDuplicatedCategory, type, dataKey } = axis;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(chartLayout, axisType);
    var allData = appliedValues.map((av)=>av.value);
    if (dataKey && isCategorical && type === 'category' && allowDuplicatedCategory && (0, _dataUtils.hasDuplicate)(allData)) return allData;
    return undefined;
};
var selectDuplicateDomain = (0, _reselect.createSelector)([
    (0, _chartLayoutContext.selectChartLayout),
    selectAllAppliedValues,
    selectBaseAxis,
    (0, _pickAxisType.pickAxisType)
], combineDuplicateDomain);
var combineCategoricalDomain = (layout, appliedValues, axis, axisType)=>{
    if (axis == null || axis.dataKey == null) return undefined;
    var { type, scale } = axis;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    if (isCategorical && (type === 'number' || scale !== 'auto')) return appliedValues.map((d)=>d.value);
    return undefined;
};
var selectCategoricalDomain = (0, _reselect.createSelector)([
    (0, _chartLayoutContext.selectChartLayout),
    selectAllAppliedValues,
    selectAxisSettings,
    (0, _pickAxisType.pickAxisType)
], combineCategoricalDomain);
var selectAxisPropsNeededForCartesianGridTicksGenerator = (0, _reselect.createSelector)([
    (0, _chartLayoutContext.selectChartLayout),
    selectCartesianAxisSettings,
    selectRealScaleType,
    selectAxisScale,
    selectDuplicateDomain,
    selectCategoricalDomain,
    selectAxisRange,
    selectNiceTicks,
    (0, _pickAxisType.pickAxisType)
], (layout, axis, realScaleType, scale, duplicateDomain, categoricalDomain, axisRange, niceTicks, axisType)=>{
    if (axis == null) return undefined;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    return {
        angle: axis.angle,
        interval: axis.interval,
        minTickGap: axis.minTickGap,
        orientation: axis.orientation,
        tick: axis.tick,
        tickCount: axis.tickCount,
        tickFormatter: axis.tickFormatter,
        ticks: axis.ticks,
        type: axis.type,
        unit: axis.unit,
        axisType,
        categoricalDomain,
        duplicateDomain,
        isCategorical,
        niceTicks,
        range: axisRange,
        realScaleType,
        scale
    };
});
var combineAxisTicks = (layout, axis, realScaleType, scale, niceTicks, axisRange, duplicateDomain, categoricalDomain, axisType)=>{
    if (axis == null || scale == null) return undefined;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    var { type, ticks, tickCount } = axis;
    // This is testing for `scaleBand` but for band axis the type is reported as `band` so this looks like a dead code with a workaround elsewhere?
    var offsetForBand = realScaleType === 'scaleBand' && typeof scale.bandwidth === 'function' ? scale.bandwidth() / 2 : 2;
    var offset = type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && axisRange != null && axisRange.length >= 2 ? (0, _dataUtils.mathSign)(axisRange[0] - axisRange[1]) * 2 * offset : offset;
    // The ticks set by user should only affect the ticks adjacent to axis line
    var ticksOrNiceTicks = ticks || niceTicks;
    if (ticksOrNiceTicks) {
        var result = ticksOrNiceTicks.map((entry, index)=>{
            var scaleContent = duplicateDomain ? duplicateDomain.indexOf(entry) : entry;
            return {
                index,
                // If the scaleContent is not a number, the coordinate will be NaN.
                // That could be the case for example with a PointScale and a string as domain.
                coordinate: scale(scaleContent) + offset,
                value: entry,
                offset
            };
        });
        return result.filter((row)=>(0, _isWellBehavedNumber.isWellBehavedNumber)(row.coordinate));
    }
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            index,
            offset
        })).filter((row)=>(0, _isWellBehavedNumber.isWellBehavedNumber)(row.coordinate));
    if (scale.ticks) return scale.ticks(tickCount)// @ts-expect-error why does the offset go here? The type does not require it
    .map((entry)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            offset
        }));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index,
            offset
        }));
};
var selectTicksOfAxis = (0, _reselect.createSelector)([
    (0, _chartLayoutContext.selectChartLayout),
    selectAxisSettings,
    selectRealScaleType,
    selectAxisScale,
    selectNiceTicks,
    selectAxisRange,
    selectDuplicateDomain,
    selectCategoricalDomain,
    (0, _pickAxisType.pickAxisType)
], combineAxisTicks);
var combineGraphicalItemTicks = (layout, axis, scale, axisRange, duplicateDomain, categoricalDomain, axisType)=>{
    if (axis == null || scale == null || axisRange == null || axisRange[0] === axisRange[1]) return undefined;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    var { tickCount } = axis;
    var offset = 0;
    offset = axisType === 'angleAxis' && (axisRange === null || axisRange === void 0 ? void 0 : axisRange.length) >= 2 ? (0, _dataUtils.mathSign)(axisRange[0] - axisRange[1]) * 2 * offset : offset;
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            index,
            offset
        }));
    if (scale.ticks) return scale.ticks(tickCount)// @ts-expect-error why does the offset go here? The type does not require it
    .map((entry)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            offset
        }));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index,
            offset
        }));
};
var selectTicksOfGraphicalItem = (0, _reselect.createSelector)([
    (0, _chartLayoutContext.selectChartLayout),
    selectAxisSettings,
    selectAxisScale,
    selectAxisRange,
    selectDuplicateDomain,
    selectCategoricalDomain,
    (0, _pickAxisType.pickAxisType)
], combineGraphicalItemTicks);
var selectAxisWithScale = (0, _reselect.createSelector)(selectBaseAxis, selectAxisScale, (axis, scale)=>{
    if (axis == null || scale == null) return undefined;
    return _objectSpread(_objectSpread({}, axis), {}, {
        scale
    });
});
var selectZAxisScale = (0, _reselect.createSelector)([
    selectBaseAxis,
    selectRealScaleType,
    selectAxisDomain,
    selectAxisRangeWithReverse
], combineScaleFunction);
var selectZAxisWithScale = (0, _reselect.createSelector)((state, _axisType, axisId)=>selectZAxisSettings(state, axisId), selectZAxisScale, (axis, scale)=>{
    if (axis == null || scale == null) return undefined;
    return _objectSpread(_objectSpread({}, axis), {}, {
        scale
    });
});
var selectChartDirection = (0, _reselect.createSelector)([
    (0, _chartLayoutContext.selectChartLayout),
    (0, _selectAllAxes.selectAllXAxes),
    (0, _selectAllAxes.selectAllYAxes)
], (layout, allXAxes, allYAxes)=>{
    switch(layout){
        case 'horizontal':
            return allXAxes.some((axis)=>axis.reversed) ? 'right-to-left' : 'left-to-right';
        case 'vertical':
            return allYAxes.some((axis)=>axis.reversed) ? 'bottom-to-top' : 'top-to-bottom';
        // TODO: make this better. For now, right arrow triggers "forward", left arrow "back"
        // however, the tooltip moves an unintuitive direction because of how the indices are rendered
        case 'centric':
        case 'radial':
            return 'left-to-right';
        default:
            return undefined;
    }
});

},{"reselect":"ds2su","es-toolkit/compat/range":"dEtyy","victory-vendor/d3-scale":"bQQDC","../../context/chartLayoutContext":"jIUyy","../../util/ChartUtils":"enJyE","./dataSelectors":"j0cmw","../../util/isDomainSpecifiedByUser":"5AAMy","../../util/DataUtils":"lNZEj","../../util/isWellBehavedNumber":"aIsFR","../../util/scale":"65ekg","./containerSelectors":"lnBke","./selectAllAxes":"3qrY7","./selectChartOffsetInternal":"caUjq","./brushSelectors":"3YEO3","./rootPropsSelectors":"eYPte","./polarAxisSelectors":"jJj4n","./pickAxisType":"2M8G8","./pickAxisId":"87acx","./combiners/combineAxisRangeWithReverse":"c3amE","../../util/Constants":"5DKvC","../../util/stacks/getStackSeriesIdentifier":"4X5RP","./combiners/combineDisplayedStackedData":"c7vK5","../types/StackedGraphicalItem":"ivpBz","./numberDomainEqualityCheck":"8LF4r","./arrayEqualityCheck":"R4lui","./selectTooltipAxisType":"hUECt","./selectTooltipAxisId":"laxEp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dEtyy":[function(require,module,exports,__globalThis) {
module.exports = require("f8fde43919d6876e").range;

},{"f8fde43919d6876e":"aaDvg"}],"aaDvg":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const isIterateeCall = require("c79a4b1139182b4d");
const toFinite = require("d8b2bf43b4c9ad45");
function range(start, end, step) {
    if (step && typeof step !== 'number' && isIterateeCall.isIterateeCall(start, end, step)) end = step = undefined;
    start = toFinite.toFinite(start);
    if (end === undefined) {
        end = start;
        start = 0;
    } else end = toFinite.toFinite(end);
    step = step === undefined ? start < end ? 1 : -1 : toFinite.toFinite(step);
    const length = Math.max(Math.ceil((end - start) / (step || 1)), 0);
    const result = new Array(length);
    for(let index = 0; index < length; index++){
        result[index] = start;
        start += step;
    }
    return result;
}
exports.range = range;

},{"c79a4b1139182b4d":"adz7R","d8b2bf43b4c9ad45":"1Q68D"}],"1Q68D":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const toNumber = require("3e24cb7f6a56e42c");
function toFinite(value) {
    if (!value) return value === 0 ? value : 0;
    value = toNumber.toNumber(value);
    if (value === Infinity || value === -Infinity) {
        const sign = value < 0 ? -1 : 1;
        return sign * Number.MAX_VALUE;
    }
    return value === value ? value : 0;
}
exports.toFinite = toFinite;

},{"3e24cb7f6a56e42c":"9ybzq"}],"9ybzq":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const isSymbol = require("770b9c63b7cb0879");
function toNumber(value) {
    if (isSymbol.isSymbol(value)) return NaN;
    return Number(value);
}
exports.toNumber = toNumber;

},{"770b9c63b7cb0879":"9YY2A"}],"bQQDC":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// This file only exists for tooling that doesn't work yet with package.json:exports
// by proxying through the CommonJS version.
module.exports = require("ea85efe7e401a98a");

},{"ea85efe7e401a98a":"3HEkZ"}],"3HEkZ":[function(require,module,exports,__globalThis) {
// `victory-vendor/d3-scale` (CommonJS)
// See upstream license: https://github.com/d3/d3-scale/blob/main/LICENSE
//
// Our CommonJS package relies on transpiled vendor files in `lib-vendor/d3-scale`
module.exports = require("9f3e91243b64b1b0");

},{"9f3e91243b64b1b0":"klWbN"}],"klWbN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "scaleBand", {
    enumerable: true,
    get: function() {
        return _band.default;
    }
});
Object.defineProperty(exports, "scaleDiverging", {
    enumerable: true,
    get: function() {
        return _diverging.default;
    }
});
Object.defineProperty(exports, "scaleDivergingLog", {
    enumerable: true,
    get: function() {
        return _diverging.divergingLog;
    }
});
Object.defineProperty(exports, "scaleDivergingPow", {
    enumerable: true,
    get: function() {
        return _diverging.divergingPow;
    }
});
Object.defineProperty(exports, "scaleDivergingSqrt", {
    enumerable: true,
    get: function() {
        return _diverging.divergingSqrt;
    }
});
Object.defineProperty(exports, "scaleDivergingSymlog", {
    enumerable: true,
    get: function() {
        return _diverging.divergingSymlog;
    }
});
Object.defineProperty(exports, "scaleIdentity", {
    enumerable: true,
    get: function() {
        return _identity.default;
    }
});
Object.defineProperty(exports, "scaleImplicit", {
    enumerable: true,
    get: function() {
        return _ordinal.implicit;
    }
});
Object.defineProperty(exports, "scaleLinear", {
    enumerable: true,
    get: function() {
        return _linear.default;
    }
});
Object.defineProperty(exports, "scaleLog", {
    enumerable: true,
    get: function() {
        return _log.default;
    }
});
Object.defineProperty(exports, "scaleOrdinal", {
    enumerable: true,
    get: function() {
        return _ordinal.default;
    }
});
Object.defineProperty(exports, "scalePoint", {
    enumerable: true,
    get: function() {
        return _band.point;
    }
});
Object.defineProperty(exports, "scalePow", {
    enumerable: true,
    get: function() {
        return _pow.default;
    }
});
Object.defineProperty(exports, "scaleQuantile", {
    enumerable: true,
    get: function() {
        return _quantile.default;
    }
});
Object.defineProperty(exports, "scaleQuantize", {
    enumerable: true,
    get: function() {
        return _quantize.default;
    }
});
Object.defineProperty(exports, "scaleRadial", {
    enumerable: true,
    get: function() {
        return _radial.default;
    }
});
Object.defineProperty(exports, "scaleSequential", {
    enumerable: true,
    get: function() {
        return _sequential.default;
    }
});
Object.defineProperty(exports, "scaleSequentialLog", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialLog;
    }
});
Object.defineProperty(exports, "scaleSequentialPow", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialPow;
    }
});
Object.defineProperty(exports, "scaleSequentialQuantile", {
    enumerable: true,
    get: function() {
        return _sequentialQuantile.default;
    }
});
Object.defineProperty(exports, "scaleSequentialSqrt", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialSqrt;
    }
});
Object.defineProperty(exports, "scaleSequentialSymlog", {
    enumerable: true,
    get: function() {
        return _sequential.sequentialSymlog;
    }
});
Object.defineProperty(exports, "scaleSqrt", {
    enumerable: true,
    get: function() {
        return _pow.sqrt;
    }
});
Object.defineProperty(exports, "scaleSymlog", {
    enumerable: true,
    get: function() {
        return _symlog.default;
    }
});
Object.defineProperty(exports, "scaleThreshold", {
    enumerable: true,
    get: function() {
        return _threshold.default;
    }
});
Object.defineProperty(exports, "scaleTime", {
    enumerable: true,
    get: function() {
        return _time.default;
    }
});
Object.defineProperty(exports, "scaleUtc", {
    enumerable: true,
    get: function() {
        return _utcTime.default;
    }
});
Object.defineProperty(exports, "tickFormat", {
    enumerable: true,
    get: function() {
        return _tickFormat.default;
    }
});
var _band = _interopRequireWildcard(require("b63efb80eb4f3997"));
var _identity = _interopRequireDefault(require("599666f8569781e"));
var _linear = _interopRequireDefault(require("81a646a660f644b0"));
var _log = _interopRequireDefault(require("86d5f4344a349716"));
var _symlog = _interopRequireDefault(require("b710ccde4c0e48a2"));
var _ordinal = _interopRequireWildcard(require("64b86754e86644bb"));
var _pow = _interopRequireWildcard(require("b1b95f640cc918be"));
var _radial = _interopRequireDefault(require("a92c7cfb56bc5881"));
var _quantile = _interopRequireDefault(require("592c2efd5d96bbdb"));
var _quantize = _interopRequireDefault(require("e52ffbce45f03bde"));
var _threshold = _interopRequireDefault(require("d72c59b81e30fbb0"));
var _time = _interopRequireDefault(require("8a3bda0d92036416"));
var _utcTime = _interopRequireDefault(require("889651fd1a77d2be"));
var _sequential = _interopRequireWildcard(require("fd5b5906f4fcb1c8"));
var _sequentialQuantile = _interopRequireDefault(require("4430958b59fb539b"));
var _diverging = _interopRequireWildcard(require("f8014e5ceaa878fb"));
var _tickFormat = _interopRequireDefault(require("1391cb83b35daafe"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

},{"b63efb80eb4f3997":"khbZS","599666f8569781e":"9tkMn","81a646a660f644b0":"7wwWf","86d5f4344a349716":"b2mDf","b710ccde4c0e48a2":"hnxTj","64b86754e86644bb":"80XAa","b1b95f640cc918be":"7qYxn","a92c7cfb56bc5881":"8wQBJ","592c2efd5d96bbdb":"4zGak","e52ffbce45f03bde":"ev1uM","d72c59b81e30fbb0":"bJUxs","8a3bda0d92036416":"iry3Y","889651fd1a77d2be":"lQRCm","fd5b5906f4fcb1c8":"kJaHH","4430958b59fb539b":"9ZDCv","f8014e5ceaa878fb":"526zm","1391cb83b35daafe":"kZcrG"}],"khbZS":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = band;
exports.point = point;
var _index = require("c83c4aaf4d4f3e6c");
var _init = require("691f3ba4feec551a");
var _ordinal = _interopRequireDefault(require("933dd1d51fe58981"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function band() {
    var scale = (0, _ordinal.default)().unknown(undefined), domain = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
    delete scale.unknown;
    function rescale() {
        var n = domain().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
        step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
        if (round) step = Math.floor(step);
        start += (stop - start - step * (n - paddingInner)) * align;
        bandwidth = step * (1 - paddingInner);
        if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
        var values = (0, _index.range)(n).map(function(i) {
            return start + step * i;
        });
        return ordinalRange(reverse ? values.reverse() : values);
    }
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.range = function(_) {
        return arguments.length ? ([r0, r1] = _, r0 = +r0, r1 = +r1, rescale()) : [
            r0,
            r1
        ];
    };
    scale.rangeRound = function(_) {
        return [r0, r1] = _, r0 = +r0, r1 = +r1, round = true, rescale();
    };
    scale.bandwidth = function() {
        return bandwidth;
    };
    scale.step = function() {
        return step;
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, rescale()) : round;
    };
    scale.padding = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_), rescale()) : paddingInner;
    };
    scale.paddingInner = function(_) {
        return arguments.length ? (paddingInner = Math.min(1, _), rescale()) : paddingInner;
    };
    scale.paddingOuter = function(_) {
        return arguments.length ? (paddingOuter = +_, rescale()) : paddingOuter;
    };
    scale.align = function(_) {
        return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
    };
    scale.copy = function() {
        return band(domain(), [
            r0,
            r1
        ]).round(round).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
    };
    return _init.initRange.apply(rescale(), arguments);
}
function pointish(scale) {
    var copy = scale.copy;
    scale.padding = scale.paddingOuter;
    delete scale.paddingInner;
    delete scale.paddingOuter;
    scale.copy = function() {
        return pointish(copy());
    };
    return scale;
}
function point() {
    return pointish(band.apply(null, arguments).paddingInner(1));
}

},{"c83c4aaf4d4f3e6c":"3WmRx","691f3ba4feec551a":"9c0mi","933dd1d51fe58981":"80XAa"}],"3WmRx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Adder", {
    enumerable: true,
    get: function() {
        return _fsum.Adder;
    }
});
Object.defineProperty(exports, "InternMap", {
    enumerable: true,
    get: function() {
        return _index.InternMap;
    }
});
Object.defineProperty(exports, "InternSet", {
    enumerable: true,
    get: function() {
        return _index.InternSet;
    }
});
Object.defineProperty(exports, "ascending", {
    enumerable: true,
    get: function() {
        return _ascending.default;
    }
});
Object.defineProperty(exports, "bin", {
    enumerable: true,
    get: function() {
        return _bin.default;
    }
});
Object.defineProperty(exports, "bisect", {
    enumerable: true,
    get: function() {
        return _bisect.default;
    }
});
Object.defineProperty(exports, "bisectCenter", {
    enumerable: true,
    get: function() {
        return _bisect.bisectCenter;
    }
});
Object.defineProperty(exports, "bisectLeft", {
    enumerable: true,
    get: function() {
        return _bisect.bisectLeft;
    }
});
Object.defineProperty(exports, "bisectRight", {
    enumerable: true,
    get: function() {
        return _bisect.bisectRight;
    }
});
Object.defineProperty(exports, "bisector", {
    enumerable: true,
    get: function() {
        return _bisector.default;
    }
});
Object.defineProperty(exports, "count", {
    enumerable: true,
    get: function() {
        return _count.default;
    }
});
Object.defineProperty(exports, "cross", {
    enumerable: true,
    get: function() {
        return _cross.default;
    }
});
Object.defineProperty(exports, "cumsum", {
    enumerable: true,
    get: function() {
        return _cumsum.default;
    }
});
Object.defineProperty(exports, "descending", {
    enumerable: true,
    get: function() {
        return _descending.default;
    }
});
Object.defineProperty(exports, "deviation", {
    enumerable: true,
    get: function() {
        return _deviation.default;
    }
});
Object.defineProperty(exports, "difference", {
    enumerable: true,
    get: function() {
        return _difference.default;
    }
});
Object.defineProperty(exports, "disjoint", {
    enumerable: true,
    get: function() {
        return _disjoint.default;
    }
});
Object.defineProperty(exports, "every", {
    enumerable: true,
    get: function() {
        return _every.default;
    }
});
Object.defineProperty(exports, "extent", {
    enumerable: true,
    get: function() {
        return _extent.default;
    }
});
Object.defineProperty(exports, "fcumsum", {
    enumerable: true,
    get: function() {
        return _fsum.fcumsum;
    }
});
Object.defineProperty(exports, "filter", {
    enumerable: true,
    get: function() {
        return _filter.default;
    }
});
Object.defineProperty(exports, "flatGroup", {
    enumerable: true,
    get: function() {
        return _group.flatGroup;
    }
});
Object.defineProperty(exports, "flatRollup", {
    enumerable: true,
    get: function() {
        return _group.flatRollup;
    }
});
Object.defineProperty(exports, "fsum", {
    enumerable: true,
    get: function() {
        return _fsum.fsum;
    }
});
Object.defineProperty(exports, "greatest", {
    enumerable: true,
    get: function() {
        return _greatest.default;
    }
});
Object.defineProperty(exports, "greatestIndex", {
    enumerable: true,
    get: function() {
        return _greatestIndex.default;
    }
});
Object.defineProperty(exports, "group", {
    enumerable: true,
    get: function() {
        return _group.default;
    }
});
Object.defineProperty(exports, "groupSort", {
    enumerable: true,
    get: function() {
        return _groupSort.default;
    }
});
Object.defineProperty(exports, "groups", {
    enumerable: true,
    get: function() {
        return _group.groups;
    }
});
Object.defineProperty(exports, "histogram", {
    enumerable: true,
    get: function() {
        return _bin.default;
    }
});
Object.defineProperty(exports, "index", {
    enumerable: true,
    get: function() {
        return _group.index;
    }
});
Object.defineProperty(exports, "indexes", {
    enumerable: true,
    get: function() {
        return _group.indexes;
    }
});
Object.defineProperty(exports, "intersection", {
    enumerable: true,
    get: function() {
        return _intersection.default;
    }
});
Object.defineProperty(exports, "least", {
    enumerable: true,
    get: function() {
        return _least.default;
    }
});
Object.defineProperty(exports, "leastIndex", {
    enumerable: true,
    get: function() {
        return _leastIndex.default;
    }
});
Object.defineProperty(exports, "map", {
    enumerable: true,
    get: function() {
        return _map.default;
    }
});
Object.defineProperty(exports, "max", {
    enumerable: true,
    get: function() {
        return _max.default;
    }
});
Object.defineProperty(exports, "maxIndex", {
    enumerable: true,
    get: function() {
        return _maxIndex.default;
    }
});
Object.defineProperty(exports, "mean", {
    enumerable: true,
    get: function() {
        return _mean.default;
    }
});
Object.defineProperty(exports, "median", {
    enumerable: true,
    get: function() {
        return _median.default;
    }
});
Object.defineProperty(exports, "merge", {
    enumerable: true,
    get: function() {
        return _merge.default;
    }
});
Object.defineProperty(exports, "min", {
    enumerable: true,
    get: function() {
        return _min.default;
    }
});
Object.defineProperty(exports, "minIndex", {
    enumerable: true,
    get: function() {
        return _minIndex.default;
    }
});
Object.defineProperty(exports, "mode", {
    enumerable: true,
    get: function() {
        return _mode.default;
    }
});
Object.defineProperty(exports, "nice", {
    enumerable: true,
    get: function() {
        return _nice.default;
    }
});
Object.defineProperty(exports, "pairs", {
    enumerable: true,
    get: function() {
        return _pairs.default;
    }
});
Object.defineProperty(exports, "permute", {
    enumerable: true,
    get: function() {
        return _permute.default;
    }
});
Object.defineProperty(exports, "quantile", {
    enumerable: true,
    get: function() {
        return _quantile.default;
    }
});
Object.defineProperty(exports, "quantileSorted", {
    enumerable: true,
    get: function() {
        return _quantile.quantileSorted;
    }
});
Object.defineProperty(exports, "quickselect", {
    enumerable: true,
    get: function() {
        return _quickselect.default;
    }
});
Object.defineProperty(exports, "range", {
    enumerable: true,
    get: function() {
        return _range.default;
    }
});
Object.defineProperty(exports, "rank", {
    enumerable: true,
    get: function() {
        return _rank.default;
    }
});
Object.defineProperty(exports, "reduce", {
    enumerable: true,
    get: function() {
        return _reduce.default;
    }
});
Object.defineProperty(exports, "reverse", {
    enumerable: true,
    get: function() {
        return _reverse.default;
    }
});
Object.defineProperty(exports, "rollup", {
    enumerable: true,
    get: function() {
        return _group.rollup;
    }
});
Object.defineProperty(exports, "rollups", {
    enumerable: true,
    get: function() {
        return _group.rollups;
    }
});
Object.defineProperty(exports, "scan", {
    enumerable: true,
    get: function() {
        return _scan.default;
    }
});
Object.defineProperty(exports, "shuffle", {
    enumerable: true,
    get: function() {
        return _shuffle.default;
    }
});
Object.defineProperty(exports, "shuffler", {
    enumerable: true,
    get: function() {
        return _shuffle.shuffler;
    }
});
Object.defineProperty(exports, "some", {
    enumerable: true,
    get: function() {
        return _some.default;
    }
});
Object.defineProperty(exports, "sort", {
    enumerable: true,
    get: function() {
        return _sort.default;
    }
});
Object.defineProperty(exports, "subset", {
    enumerable: true,
    get: function() {
        return _subset.default;
    }
});
Object.defineProperty(exports, "sum", {
    enumerable: true,
    get: function() {
        return _sum.default;
    }
});
Object.defineProperty(exports, "superset", {
    enumerable: true,
    get: function() {
        return _superset.default;
    }
});
Object.defineProperty(exports, "thresholdFreedmanDiaconis", {
    enumerable: true,
    get: function() {
        return _freedmanDiaconis.default;
    }
});
Object.defineProperty(exports, "thresholdScott", {
    enumerable: true,
    get: function() {
        return _scott.default;
    }
});
Object.defineProperty(exports, "thresholdSturges", {
    enumerable: true,
    get: function() {
        return _sturges.default;
    }
});
Object.defineProperty(exports, "tickIncrement", {
    enumerable: true,
    get: function() {
        return _ticks.tickIncrement;
    }
});
Object.defineProperty(exports, "tickStep", {
    enumerable: true,
    get: function() {
        return _ticks.tickStep;
    }
});
Object.defineProperty(exports, "ticks", {
    enumerable: true,
    get: function() {
        return _ticks.default;
    }
});
Object.defineProperty(exports, "transpose", {
    enumerable: true,
    get: function() {
        return _transpose.default;
    }
});
Object.defineProperty(exports, "union", {
    enumerable: true,
    get: function() {
        return _union.default;
    }
});
Object.defineProperty(exports, "variance", {
    enumerable: true,
    get: function() {
        return _variance.default;
    }
});
Object.defineProperty(exports, "zip", {
    enumerable: true,
    get: function() {
        return _zip.default;
    }
});
var _bisect = _interopRequireWildcard(require("30e30fd80e01d017"));
var _ascending = _interopRequireDefault(require("ba6e167afdeaab0b"));
var _bisector = _interopRequireDefault(require("a8afbc207886cfe5"));
var _count = _interopRequireDefault(require("1ec4d87c2d530b17"));
var _cross = _interopRequireDefault(require("e60cb580083b63b4"));
var _cumsum = _interopRequireDefault(require("2ed7a3899076eb06"));
var _descending = _interopRequireDefault(require("b44226224b8ee28a"));
var _deviation = _interopRequireDefault(require("3bfdfde74e5e3893"));
var _extent = _interopRequireDefault(require("e0c64cb1665c42fc"));
var _fsum = require("8239d81e924c7f9b");
var _group = _interopRequireWildcard(require("e133ef73b59e280f"));
var _groupSort = _interopRequireDefault(require("3c1ee14e652a9a74"));
var _bin = _interopRequireDefault(require("1c3fea00392fd51a"));
var _freedmanDiaconis = _interopRequireDefault(require("39d93dd913508747"));
var _scott = _interopRequireDefault(require("876933b3acb155ad"));
var _sturges = _interopRequireDefault(require("d1e08dd0d72014d7"));
var _max = _interopRequireDefault(require("5653c1d333b623cc"));
var _maxIndex = _interopRequireDefault(require("e384106528492a4"));
var _mean = _interopRequireDefault(require("e8829bf9149c3ef0"));
var _median = _interopRequireDefault(require("d00dfb19fe2fa3dd"));
var _merge = _interopRequireDefault(require("f8db612b317ca902"));
var _min = _interopRequireDefault(require("23890540251f6e67"));
var _minIndex = _interopRequireDefault(require("b9d42ff8895c4de8"));
var _mode = _interopRequireDefault(require("85fe3d40f6f5138d"));
var _nice = _interopRequireDefault(require("e8d14d9a3dedafe6"));
var _pairs = _interopRequireDefault(require("177b2ef4b4963970"));
var _permute = _interopRequireDefault(require("365c2a51c1482713"));
var _quantile = _interopRequireWildcard(require("1d56df0071525856"));
var _quickselect = _interopRequireDefault(require("1d2b63add15610db"));
var _range = _interopRequireDefault(require("879f1890a7517024"));
var _rank = _interopRequireDefault(require("912567809e44cbf8"));
var _least = _interopRequireDefault(require("c6b4300bede89d14"));
var _leastIndex = _interopRequireDefault(require("38f5be9e3fad1ac0"));
var _greatest = _interopRequireDefault(require("7fdad0a7cfab2520"));
var _greatestIndex = _interopRequireDefault(require("acba90bb290c79e9"));
var _scan = _interopRequireDefault(require("4a0a3c353076d5f7"));
var _shuffle = _interopRequireWildcard(require("ca2fb5eb530363f6"));
var _sum = _interopRequireDefault(require("fcc170790ec9f19b"));
var _ticks = _interopRequireWildcard(require("cd372a8370da3735"));
var _transpose = _interopRequireDefault(require("fece81f7cb114699"));
var _variance = _interopRequireDefault(require("68a6cbe5f6ed9d0b"));
var _zip = _interopRequireDefault(require("a43b4c003dde8ae5"));
var _every = _interopRequireDefault(require("aa419cb489a22141"));
var _some = _interopRequireDefault(require("2d20a8f791fd5767"));
var _filter = _interopRequireDefault(require("32260c06b0e9256d"));
var _map = _interopRequireDefault(require("6071cde151b05eb9"));
var _reduce = _interopRequireDefault(require("12d8fb254953b9bd"));
var _reverse = _interopRequireDefault(require("a0b2aacd1379b178"));
var _sort = _interopRequireDefault(require("68390ceda5e75df5"));
var _difference = _interopRequireDefault(require("e3b896de066f5364"));
var _disjoint = _interopRequireDefault(require("a4315b63bcb13bca"));
var _intersection = _interopRequireDefault(require("9f70d47eae5d7300"));
var _subset = _interopRequireDefault(require("56df3047d82ddba3"));
var _superset = _interopRequireDefault(require("f70ec3fe7b14f6c5"));
var _union = _interopRequireDefault(require("7c20e02710d1b117"));
var _index = require("5307d8bb084e9ec1");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

},{"30e30fd80e01d017":"20Pjg","ba6e167afdeaab0b":"5yu5V","a8afbc207886cfe5":"8Xes2","1ec4d87c2d530b17":"hO2Re","e60cb580083b63b4":"8QPcA","2ed7a3899076eb06":"kSfoe","b44226224b8ee28a":"8oxOH","3bfdfde74e5e3893":"du57m","e0c64cb1665c42fc":"eZosg","8239d81e924c7f9b":"7s4j9","e133ef73b59e280f":"3Cx3x","3c1ee14e652a9a74":"9qUHa","1c3fea00392fd51a":"jNxfZ","39d93dd913508747":"3gCe4","876933b3acb155ad":"cMat0","d1e08dd0d72014d7":"9DBCa","5653c1d333b623cc":"kX5sr","e384106528492a4":"fvWGd","e8829bf9149c3ef0":"iMH5W","d00dfb19fe2fa3dd":"4Z2Em","f8db612b317ca902":"8Sm5p","23890540251f6e67":"jZKFk","b9d42ff8895c4de8":"aoqnq","85fe3d40f6f5138d":"cVrie","e8d14d9a3dedafe6":"1zrO7","177b2ef4b4963970":"htyag","365c2a51c1482713":"2ebaM","1d56df0071525856":"ePrqa","1d2b63add15610db":"7hJ18","879f1890a7517024":"8ccAc","912567809e44cbf8":"2UczV","c6b4300bede89d14":"8eP27","38f5be9e3fad1ac0":"c2Alz","7fdad0a7cfab2520":"86fOj","acba90bb290c79e9":"7HagX","4a0a3c353076d5f7":"igA6j","ca2fb5eb530363f6":"2XZuB","fcc170790ec9f19b":"7F0zR","cd372a8370da3735":"kfc0d","fece81f7cb114699":"4XM4C","68a6cbe5f6ed9d0b":"3d3NY","a43b4c003dde8ae5":"kdWpH","aa419cb489a22141":"7PRel","2d20a8f791fd5767":"6TGSF","32260c06b0e9256d":"aHlRB","6071cde151b05eb9":"2uu8t","12d8fb254953b9bd":"8mPlU","a0b2aacd1379b178":"enfn7","68390ceda5e75df5":"bVX97","e3b896de066f5364":"lBNlZ","a4315b63bcb13bca":"fJwn8","9f70d47eae5d7300":"7ZjoH","56df3047d82ddba3":"hgdYE","f70ec3fe7b14f6c5":"h0Rqs","7c20e02710d1b117":"ifI2v","5307d8bb084e9ec1":"3TELG"}],"20Pjg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.bisectRight = exports.bisectLeft = exports.bisectCenter = void 0;
var _ascending = _interopRequireDefault(require("c1f158b330aaa13c"));
var _bisector = _interopRequireDefault(require("ae9e5922ca82e11d"));
var _number = _interopRequireDefault(require("7b6cc53664acedc3"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const ascendingBisect = (0, _bisector.default)(_ascending.default);
const bisectRight = exports.bisectRight = ascendingBisect.right;
const bisectLeft = exports.bisectLeft = ascendingBisect.left;
const bisectCenter = exports.bisectCenter = (0, _bisector.default)(_number.default).center;
var _default = exports.default = bisectRight;

},{"c1f158b330aaa13c":"5yu5V","ae9e5922ca82e11d":"8Xes2","7b6cc53664acedc3":"hgqCQ"}],"5yu5V":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ascending;
function ascending(a, b) {
    return a == null || b == null ? NaN : a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
}

},{}],"8Xes2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = bisector;
var _ascending = _interopRequireDefault(require("7cbc9edd390ae8bb"));
var _descending = _interopRequireDefault(require("bbf176e93324968c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function bisector(f) {
    let compare1, compare2, delta;
    // If an accessor is specified, promote it to a comparator. In this case we
    // can test whether the search value is (self-) comparable. We can’t do this
    // for a comparator (except for specific, known comparators) because we can’t
    // tell if the comparator is symmetric, and an asymmetric comparator can’t be
    // used to test whether a single value is comparable.
    if (f.length !== 2) {
        compare1 = _ascending.default;
        compare2 = (d, x)=>(0, _ascending.default)(f(d), x);
        delta = (d, x)=>f(d) - x;
    } else {
        compare1 = f === _ascending.default || f === _descending.default ? f : zero;
        compare2 = f;
        delta = f;
    }
    function left(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) < 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function right(a, x, lo = 0, hi = a.length) {
        if (lo < hi) {
            if (compare1(x, x) !== 0) return hi;
            do {
                const mid = lo + hi >>> 1;
                if (compare2(a[mid], x) <= 0) lo = mid + 1;
                else hi = mid;
            }while (lo < hi);
        }
        return lo;
    }
    function center(a, x, lo = 0, hi = a.length) {
        const i = left(a, x, lo, hi - 1);
        return i > lo && delta(a[i - 1], x) > -delta(a[i], x) ? i - 1 : i;
    }
    return {
        left,
        center,
        right
    };
}
function zero() {
    return 0;
}

},{"7cbc9edd390ae8bb":"5yu5V","bbf176e93324968c":"8oxOH"}],"8oxOH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = descending;
function descending(a, b) {
    return a == null || b == null ? NaN : b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
}

},{}],"hgqCQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = number;
exports.numbers = numbers;
function number(x) {
    return x === null ? NaN : +x;
}
function* numbers(values, valueof) {
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) yield value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) yield value;
    }
}

},{}],"hO2Re":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = count;
function count(values, valueof) {
    let count = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count;
    }
    return count;
}

},{}],"8QPcA":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cross;
function length(array) {
    return array.length | 0;
}
function empty(length) {
    return !(length > 0);
}
function arrayify(values) {
    return typeof values !== "object" || "length" in values ? values : Array.from(values);
}
function reducer(reduce) {
    return (values)=>reduce(...values);
}
function cross(...values) {
    const reduce = typeof values[values.length - 1] === "function" && reducer(values.pop());
    values = values.map(arrayify);
    const lengths = values.map(length);
    const j = values.length - 1;
    const index = new Array(j + 1).fill(0);
    const product = [];
    if (j < 0 || lengths.some(empty)) return product;
    while(true){
        product.push(index.map((j, i)=>values[i][j]));
        let i = j;
        while(++index[i] === lengths[i]){
            if (i === 0) return reduce ? product.map(reduce) : product;
            index[i--] = 0;
        }
    }
}

},{}],"kSfoe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cumsum;
function cumsum(values, valueof) {
    var sum = 0, index = 0;
    return Float64Array.from(values, valueof === undefined ? (v)=>sum += +v || 0 : (v)=>sum += +valueof(v, index++, values) || 0);
}

},{}],"du57m":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = deviation;
var _variance = _interopRequireDefault(require("51ae5f4f20d14175"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function deviation(values, valueof) {
    const v = (0, _variance.default)(values, valueof);
    return v ? Math.sqrt(v) : v;
}

},{"51ae5f4f20d14175":"3d3NY"}],"3d3NY":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = variance;
function variance(values, valueof) {
    let count = 0;
    let delta;
    let mean = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) {
            delta = value - mean;
            mean += delta / ++count;
            sum += delta * (value - mean);
        }
    }
    if (count > 1) return sum / (count - 1);
}

},{}],"eZosg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = extent;
function extent(values, valueof) {
    let min;
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null) {
            if (min === undefined) {
                if (value >= value) min = max = value;
            } else {
                if (min > value) min = value;
                if (max < value) max = value;
            }
        }
    }
    return [
        min,
        max
    ];
}

},{}],"7s4j9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Adder = void 0;
exports.fcumsum = fcumsum;
exports.fsum = fsum;
// https://github.com/python/cpython/blob/a74eea238f5baba15797e2e8b570d153bc8690a7/Modules/mathmodule.c#L1423
class Adder {
    constructor(){
        this._partials = new Float64Array(32);
        this._n = 0;
    }
    add(x) {
        const p = this._partials;
        let i = 0;
        for(let j = 0; j < this._n && j < 32; j++){
            const y = p[j], hi = x + y, lo = Math.abs(x) < Math.abs(y) ? x - (hi - y) : y - (hi - x);
            if (lo) p[i++] = lo;
            x = hi;
        }
        p[i] = x;
        this._n = i + 1;
        return this;
    }
    valueOf() {
        const p = this._partials;
        let n = this._n, x, y, lo, hi = 0;
        if (n > 0) {
            hi = p[--n];
            while(n > 0){
                x = hi;
                y = p[--n];
                hi = x + y;
                lo = y - (hi - x);
                if (lo) break;
            }
            if (n > 0 && (lo < 0 && p[n - 1] < 0 || lo > 0 && p[n - 1] > 0)) {
                y = lo * 2;
                x = hi + y;
                if (y == x - hi) hi = x;
            }
        }
        return hi;
    }
}
exports.Adder = Adder;
function fsum(values, valueof) {
    const adder = new Adder();
    if (valueof === undefined) {
        for (let value of values)if (value = +value) adder.add(value);
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) adder.add(value);
    }
    return +adder;
}
function fcumsum(values, valueof) {
    const adder = new Adder();
    let index = -1;
    return Float64Array.from(values, valueof === undefined ? (v)=>adder.add(+v || 0) : (v)=>adder.add(+valueof(v, ++index, values) || 0));
}

},{}],"3Cx3x":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = group;
exports.flatGroup = flatGroup;
exports.flatRollup = flatRollup;
exports.groups = groups;
exports.index = index;
exports.indexes = indexes;
exports.rollup = rollup;
exports.rollups = rollups;
var _index = require("48004d0dfe52b7a6");
var _identity = _interopRequireDefault(require("3cf6030d781ef6b2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function group(values, ...keys) {
    return nest(values, _identity.default, _identity.default, keys);
}
function groups(values, ...keys) {
    return nest(values, Array.from, _identity.default, keys);
}
function flatten(groups, keys) {
    for(let i = 1, n = keys.length; i < n; ++i)groups = groups.flatMap((g)=>g.pop().map(([key, value])=>[
                ...g,
                key,
                value
            ]));
    return groups;
}
function flatGroup(values, ...keys) {
    return flatten(groups(values, ...keys), keys);
}
function flatRollup(values, reduce, ...keys) {
    return flatten(rollups(values, reduce, ...keys), keys);
}
function rollup(values, reduce, ...keys) {
    return nest(values, _identity.default, reduce, keys);
}
function rollups(values, reduce, ...keys) {
    return nest(values, Array.from, reduce, keys);
}
function index(values, ...keys) {
    return nest(values, _identity.default, unique, keys);
}
function indexes(values, ...keys) {
    return nest(values, Array.from, unique, keys);
}
function unique(values) {
    if (values.length !== 1) throw new Error("duplicate key");
    return values[0];
}
function nest(values, map, reduce, keys) {
    return function regroup(values, i) {
        if (i >= keys.length) return reduce(values);
        const groups = new _index.InternMap();
        const keyof = keys[i++];
        let index = -1;
        for (const value of values){
            const key = keyof(value, ++index, values);
            const group = groups.get(key);
            if (group) group.push(value);
            else groups.set(key, [
                value
            ]);
        }
        for (const [key, values] of groups)groups.set(key, regroup(values, i));
        return map(groups);
    }(values, 0);
}

},{"48004d0dfe52b7a6":"3TELG","3cf6030d781ef6b2":"7zKxF"}],"3TELG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.InternSet = exports.InternMap = void 0;
class InternMap extends Map {
    constructor(entries, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (entries != null) for (const [key, value] of entries)this.set(key, value);
    }
    get(key) {
        return super.get(intern_get(this, key));
    }
    has(key) {
        return super.has(intern_get(this, key));
    }
    set(key, value) {
        return super.set(intern_set(this, key), value);
    }
    delete(key) {
        return super.delete(intern_delete(this, key));
    }
}
exports.InternMap = InternMap;
class InternSet extends Set {
    constructor(values, key = keyof){
        super();
        Object.defineProperties(this, {
            _intern: {
                value: new Map()
            },
            _key: {
                value: key
            }
        });
        if (values != null) for (const value of values)this.add(value);
    }
    has(value) {
        return super.has(intern_get(this, value));
    }
    add(value) {
        return super.add(intern_set(this, value));
    }
    delete(value) {
        return super.delete(intern_delete(this, value));
    }
}
exports.InternSet = InternSet;
function intern_get({ _intern, _key }, value) {
    const key = _key(value);
    return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) return _intern.get(key);
    _intern.set(key, value);
    return value;
}
function intern_delete({ _intern, _key }, value) {
    const key = _key(value);
    if (_intern.has(key)) {
        value = _intern.get(key);
        _intern.delete(key);
    }
    return value;
}
function keyof(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{}],"7zKxF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = identity;
function identity(x) {
    return x;
}

},{}],"9qUHa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = groupSort;
var _ascending = _interopRequireDefault(require("325640508c2e43b"));
var _group = _interopRequireWildcard(require("57a8d19e7d7a16cf"));
var _sort = _interopRequireDefault(require("a759bcb922f07eb1"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function groupSort(values, reduce, key) {
    return (reduce.length !== 2 ? (0, _sort.default)((0, _group.rollup)(values, reduce, key), ([ak, av], [bk, bv])=>(0, _ascending.default)(av, bv) || (0, _ascending.default)(ak, bk)) : (0, _sort.default)((0, _group.default)(values, key), ([ak, av], [bk, bv])=>reduce(av, bv) || (0, _ascending.default)(ak, bk))).map(([key])=>key);
}

},{"325640508c2e43b":"5yu5V","57a8d19e7d7a16cf":"3Cx3x","a759bcb922f07eb1":"bVX97"}],"bVX97":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ascendingDefined = ascendingDefined;
exports.compareDefined = compareDefined;
exports.default = sort;
var _ascending = _interopRequireDefault(require("17dda5769044e4af"));
var _permute = _interopRequireDefault(require("45ed8435c3fc2fdf"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function sort(values, ...F) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    values = Array.from(values);
    let [f] = F;
    if (f && f.length !== 2 || F.length > 1) {
        const index = Uint32Array.from(values, (d, i)=>i);
        if (F.length > 1) {
            F = F.map((f)=>values.map(f));
            index.sort((i, j)=>{
                for (const f of F){
                    const c = ascendingDefined(f[i], f[j]);
                    if (c) return c;
                }
            });
        } else {
            f = values.map(f);
            index.sort((i, j)=>ascendingDefined(f[i], f[j]));
        }
        return (0, _permute.default)(values, index);
    }
    return values.sort(compareDefined(f));
}
function compareDefined(compare = _ascending.default) {
    if (compare === _ascending.default) return ascendingDefined;
    if (typeof compare !== "function") throw new TypeError("compare is not a function");
    return (a, b)=>{
        const x = compare(a, b);
        if (x || x === 0) return x;
        return (compare(b, b) === 0) - (compare(a, a) === 0);
    };
}
function ascendingDefined(a, b) {
    return (a == null || !(a >= a)) - (b == null || !(b >= b)) || (a < b ? -1 : a > b ? 1 : 0);
}

},{"17dda5769044e4af":"5yu5V","45ed8435c3fc2fdf":"2ebaM"}],"2ebaM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = permute;
function permute(source, keys) {
    return Array.from(keys, (key)=>source[key]);
}

},{}],"jNxfZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = bin;
var _array = require("2e045be59e43c77");
var _bisect = _interopRequireDefault(require("319eb924a032034c"));
var _constant = _interopRequireDefault(require("2d6358dd303eb77c"));
var _extent = _interopRequireDefault(require("b715ed473e0ab15b"));
var _identity = _interopRequireDefault(require("f9340ffc2d80b8ca"));
var _nice = _interopRequireDefault(require("c13788fe41624795"));
var _ticks = _interopRequireWildcard(require("b122967555bb47b9"));
var _sturges = _interopRequireDefault(require("3587d7f4446a1fc2"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function bin() {
    var value = _identity.default, domain = _extent.default, threshold = _sturges.default;
    function histogram(data) {
        if (!Array.isArray(data)) data = Array.from(data);
        var i, n = data.length, x, step, values = new Array(n);
        for(i = 0; i < n; ++i)values[i] = value(data[i], i, data);
        var xz = domain(values), x0 = xz[0], x1 = xz[1], tz = threshold(values, x0, x1);
        // Convert number of thresholds into uniform thresholds, and nice the
        // default domain accordingly.
        if (!Array.isArray(tz)) {
            const max = x1, tn = +tz;
            if (domain === _extent.default) [x0, x1] = (0, _nice.default)(x0, x1, tn);
            tz = (0, _ticks.default)(x0, x1, tn);
            // If the domain is aligned with the first tick (which it will by
            // default), then we can use quantization rather than bisection to bin
            // values, which is substantially faster.
            if (tz[0] <= x0) step = (0, _ticks.tickIncrement)(x0, x1, tn);
            // If the last threshold is coincident with the domain’s upper bound, the
            // last bin will be zero-width. If the default domain is used, and this
            // last threshold is coincident with the maximum input value, we can
            // extend the niced upper bound by one tick to ensure uniform bin widths;
            // otherwise, we simply remove the last threshold. Note that we don’t
            // coerce values or the domain to numbers, and thus must be careful to
            // compare order (>=) rather than strict equality (===)!
            if (tz[tz.length - 1] >= x1) {
                if (max >= x1 && domain === _extent.default) {
                    const step = (0, _ticks.tickIncrement)(x0, x1, tn);
                    if (isFinite(step)) {
                        if (step > 0) x1 = (Math.floor(x1 / step) + 1) * step;
                        else if (step < 0) x1 = (Math.ceil(x1 * -step) + 1) / -step;
                    }
                } else tz.pop();
            }
        }
        // Remove any thresholds outside the domain.
        var m = tz.length;
        while(tz[0] <= x0)tz.shift(), --m;
        while(tz[m - 1] > x1)tz.pop(), --m;
        var bins = new Array(m + 1), bin;
        // Initialize bins.
        for(i = 0; i <= m; ++i){
            bin = bins[i] = [];
            bin.x0 = i > 0 ? tz[i - 1] : x0;
            bin.x1 = i < m ? tz[i] : x1;
        }
        // Assign data to bins by value, ignoring any outside the domain.
        if (isFinite(step)) {
            if (step > 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[Math.min(m, Math.floor((x - x0) / step))].push(data[i]);
            } else if (step < 0) {
                for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) {
                    const j = Math.floor((x0 - x) * step);
                    bins[Math.min(m, j + (tz[j] <= x))].push(data[i]); // handle off-by-one due to rounding
                }
            }
        } else {
            for(i = 0; i < n; ++i)if ((x = values[i]) != null && x0 <= x && x <= x1) bins[(0, _bisect.default)(tz, x, 0, m)].push(data[i]);
        }
        return bins;
    }
    histogram.value = function(_) {
        return arguments.length ? (value = typeof _ === "function" ? _ : (0, _constant.default)(_), histogram) : value;
    };
    histogram.domain = function(_) {
        return arguments.length ? (domain = typeof _ === "function" ? _ : (0, _constant.default)([
            _[0],
            _[1]
        ]), histogram) : domain;
    };
    histogram.thresholds = function(_) {
        return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? (0, _constant.default)(_array.slice.call(_)) : (0, _constant.default)(_), histogram) : threshold;
    };
    return histogram;
}

},{"2e045be59e43c77":"fifxg","319eb924a032034c":"20Pjg","2d6358dd303eb77c":"1hxAI","b715ed473e0ab15b":"eZosg","f9340ffc2d80b8ca":"7zKxF","c13788fe41624795":"1zrO7","b122967555bb47b9":"kfc0d","3587d7f4446a1fc2":"9DBCa"}],"fifxg":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.slice = exports.map = void 0;
var array = Array.prototype;
var slice = exports.slice = array.slice;
var map = exports.map = array.map;

},{}],"1hxAI":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = constant;
function constant(x) {
    return ()=>x;
}

},{}],"1zrO7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nice;
var _ticks = require("82883d5f91d2ba9");
function nice(start, stop, count) {
    let prestep;
    while(true){
        const step = (0, _ticks.tickIncrement)(start, stop, count);
        if (step === prestep || step === 0 || !isFinite(step)) return [
            start,
            stop
        ];
        else if (step > 0) {
            start = Math.floor(start / step) * step;
            stop = Math.ceil(stop / step) * step;
        } else if (step < 0) {
            start = Math.ceil(start * step) / step;
            stop = Math.floor(stop * step) / step;
        }
        prestep = step;
    }
}

},{"82883d5f91d2ba9":"kfc0d"}],"kfc0d":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ticks;
exports.tickIncrement = tickIncrement;
exports.tickStep = tickStep;
var e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function ticks(start, stop, count) {
    var reverse, i = -1, n, ticks, step;
    stop = +stop, start = +start, count = +count;
    if (start === stop && count > 0) return [
        start
    ];
    if (reverse = stop < start) n = start, start = stop, stop = n;
    if ((step = tickIncrement(start, stop, count)) === 0 || !isFinite(step)) return [];
    if (step > 0) {
        let r0 = Math.round(start / step), r1 = Math.round(stop / step);
        if (r0 * step < start) ++r0;
        if (r1 * step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) * step;
    } else {
        step = -step;
        let r0 = Math.round(start * step), r1 = Math.round(stop * step);
        if (r0 / step < start) ++r0;
        if (r1 / step > stop) --r1;
        ticks = new Array(n = r1 - r0 + 1);
        while(++i < n)ticks[i] = (r0 + i) / step;
    }
    if (reverse) ticks.reverse();
    return ticks;
}
function tickIncrement(start, stop, count) {
    var step = (stop - start) / Math.max(0, count), power = Math.floor(Math.log(step) / Math.LN10), error = step / Math.pow(10, power);
    return power >= 0 ? (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1) * Math.pow(10, power) : -Math.pow(10, -power) / (error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1);
}
function tickStep(start, stop, count) {
    var step0 = Math.abs(stop - start) / Math.max(0, count), step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)), error = step0 / step1;
    if (error >= e10) step1 *= 10;
    else if (error >= e5) step1 *= 5;
    else if (error >= e2) step1 *= 2;
    return stop < start ? -step1 : step1;
}

},{}],"9DBCa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdSturges;
var _count = _interopRequireDefault(require("d856b0d375bb9b61"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdSturges(values) {
    return Math.ceil(Math.log((0, _count.default)(values)) / Math.LN2) + 1;
}

},{"d856b0d375bb9b61":"hO2Re"}],"3gCe4":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdFreedmanDiaconis;
var _count = _interopRequireDefault(require("84a2a08734413081"));
var _quantile = _interopRequireDefault(require("b453688def319e0"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdFreedmanDiaconis(values, min, max) {
    return Math.ceil((max - min) / (2 * ((0, _quantile.default)(values, 0.75) - (0, _quantile.default)(values, 0.25)) * Math.pow((0, _count.default)(values), -1 / 3)));
}

},{"84a2a08734413081":"hO2Re","b453688def319e0":"ePrqa"}],"ePrqa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantile;
exports.quantileSorted = quantileSorted;
var _max = _interopRequireDefault(require("6377896bac51b475"));
var _min = _interopRequireDefault(require("7403c617ea3dc723"));
var _quickselect = _interopRequireDefault(require("fa6451b912e13124"));
var _number = _interopRequireWildcard(require("de13410c4756be71"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function quantile(values, p, valueof) {
    values = Float64Array.from((0, _number.numbers)(values, valueof));
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return (0, _min.default)(values);
    if (p >= 1) return (0, _max.default)(values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = (0, _max.default)((0, _quickselect.default)(values, i0).subarray(0, i0 + 1)), value1 = (0, _min.default)(values.subarray(i0 + 1));
    return value0 + (value1 - value0) * (i - i0);
}
function quantileSorted(values, p, valueof = _number.default) {
    if (!(n = values.length)) return;
    if ((p = +p) <= 0 || n < 2) return +valueof(values[0], 0, values);
    if (p >= 1) return +valueof(values[n - 1], n - 1, values);
    var n, i = (n - 1) * p, i0 = Math.floor(i), value0 = +valueof(values[i0], i0, values), value1 = +valueof(values[i0 + 1], i0 + 1, values);
    return value0 + (value1 - value0) * (i - i0);
}

},{"6377896bac51b475":"kX5sr","7403c617ea3dc723":"jZKFk","fa6451b912e13124":"7hJ18","de13410c4756be71":"hgqCQ"}],"kX5sr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = max;
function max(values, valueof) {
    let max;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (max < value || max === undefined && value >= value)) max = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value;
    }
    return max;
}

},{}],"jZKFk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = min;
function min(values, valueof) {
    let min;
    if (valueof === undefined) {
        for (const value of values)if (value != null && (min > value || min === undefined && value >= value)) min = value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value;
    }
    return min;
}

},{}],"7hJ18":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quickselect;
var _sort = require("c4d7054457278972");
// Based on https://github.com/mourner/quickselect
// ISC license, Copyright 2018 Vladimir Agafonkin.
function quickselect(array, k, left = 0, right = array.length - 1, compare) {
    compare = compare === undefined ? _sort.ascendingDefined : (0, _sort.compareDefined)(compare);
    while(right > left){
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            quickselect(array, k, newLeft, newRight, compare);
        }
        const t = array[k];
        let i = left;
        let j = right;
        swap(array, left, k);
        if (compare(array[right], t) > 0) swap(array, left, right);
        while(i < j){
            swap(array, i, j), ++i, --j;
            while(compare(array[i], t) < 0)++i;
            while(compare(array[j], t) > 0)--j;
        }
        if (compare(array[left], t) === 0) swap(array, left, j);
        else ++j, swap(array, j, right);
        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
    return array;
}
function swap(array, i, j) {
    const t = array[i];
    array[i] = array[j];
    array[j] = t;
}

},{"c4d7054457278972":"bVX97"}],"cMat0":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = thresholdScott;
var _count = _interopRequireDefault(require("544301f03b7cfef6"));
var _deviation = _interopRequireDefault(require("9c084667c87040d5"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function thresholdScott(values, min, max) {
    return Math.ceil((max - min) * Math.cbrt((0, _count.default)(values)) / (3.49 * (0, _deviation.default)(values)));
}

},{"544301f03b7cfef6":"hO2Re","9c084667c87040d5":"du57m"}],"fvWGd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = maxIndex;
function maxIndex(values, valueof) {
    let max;
    let maxIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (max < value || max === undefined && value >= value)) max = value, maxIndex = index;
    }
    return maxIndex;
}

},{}],"iMH5W":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mean;
function mean(values, valueof) {
    let count = 0;
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value != null && (value = +value) >= value) ++count, sum += value;
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (value = +value) >= value) ++count, sum += value;
    }
    if (count) return sum / count;
}

},{}],"4Z2Em":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = median;
var _quantile = _interopRequireDefault(require("73b253d4e179eac9"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function median(values, valueof) {
    return (0, _quantile.default)(values, 0.5, valueof);
}

},{"73b253d4e179eac9":"ePrqa"}],"8Sm5p":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = merge;
function* flatten(arrays) {
    for (const array of arrays)yield* array;
}
function merge(arrays) {
    return Array.from(flatten(arrays));
}

},{}],"aoqnq":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = minIndex;
function minIndex(values, valueof) {
    let min;
    let minIndex = -1;
    let index = -1;
    if (valueof === undefined) for (const value of values){
        ++index;
        if (value != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    else {
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && (min > value || min === undefined && value >= value)) min = value, minIndex = index;
    }
    return minIndex;
}

},{}],"cVrie":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = mode;
var _index = require("cc79d9604cb49161");
function mode(values, valueof) {
    const counts = new _index.InternMap();
    if (valueof === undefined) {
        for (let value of values)if (value != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    } else {
        let index = -1;
        for (let value of values)if ((value = valueof(value, ++index, values)) != null && value >= value) counts.set(value, (counts.get(value) || 0) + 1);
    }
    let modeValue;
    let modeCount = 0;
    for (const [value, count] of counts)if (count > modeCount) {
        modeCount = count;
        modeValue = value;
    }
    return modeValue;
}

},{"cc79d9604cb49161":"3TELG"}],"htyag":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pairs;
exports.pair = pair;
function pairs(values, pairof = pair) {
    const pairs1 = [];
    let previous;
    let first = false;
    for (const value of values){
        if (first) pairs1.push(pairof(previous, value));
        previous = value;
        first = true;
    }
    return pairs1;
}
function pair(a, b) {
    return [
        a,
        b
    ];
}

},{}],"8ccAc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = range;
function range(start, stop, step) {
    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
    var i = -1, n = Math.max(0, Math.ceil((stop - start) / step)) | 0, range = new Array(n);
    while(++i < n)range[i] = start + i * step;
    return range;
}

},{}],"2UczV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = rank;
var _ascending = _interopRequireDefault(require("3d6b2e0137da2f5f"));
var _sort = require("baf9f3a118e8a4c3");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function rank(values, valueof = _ascending.default) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    let V = Array.from(values);
    const R = new Float64Array(V.length);
    if (valueof.length !== 2) V = V.map(valueof), valueof = _ascending.default;
    const compareIndex = (i, j)=>valueof(V[i], V[j]);
    let k, r;
    Uint32Array.from(V, (_, i)=>i).sort(valueof === _ascending.default ? (i, j)=>(0, _sort.ascendingDefined)(V[i], V[j]) : (0, _sort.compareDefined)(compareIndex)).forEach((j, i)=>{
        const c = compareIndex(j, k === undefined ? j : k);
        if (c >= 0) {
            if (k === undefined || c > 0) k = j, r = i;
            R[j] = r;
        } else R[j] = NaN;
    });
    return R;
}

},{"3d6b2e0137da2f5f":"5yu5V","baf9f3a118e8a4c3":"bVX97"}],"8eP27":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = least;
var _ascending = _interopRequireDefault(require("86cd41303b4be24c"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function least(values, compare = _ascending.default) {
    let min;
    let defined = false;
    if (compare.length === 1) {
        let minValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascending.default)(value, minValue) < 0 : (0, _ascending.default)(value, value) === 0) {
                min = element;
                minValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, min) < 0 : compare(value, value) === 0) {
            min = value;
            defined = true;
        }
    }
    return min;
}

},{"86cd41303b4be24c":"5yu5V"}],"c2Alz":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = leastIndex;
var _ascending = _interopRequireDefault(require("3a70505afbae26e3"));
var _minIndex = _interopRequireDefault(require("7863dae356808098"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function leastIndex(values, compare = _ascending.default) {
    if (compare.length === 1) return (0, _minIndex.default)(values, compare);
    let minValue;
    let min = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (min < 0 ? compare(value, value) === 0 : compare(value, minValue) < 0) {
            minValue = value;
            min = index;
        }
    }
    return min;
}

},{"3a70505afbae26e3":"5yu5V","7863dae356808098":"aoqnq"}],"86fOj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = greatest;
var _ascending = _interopRequireDefault(require("7e4721a4d28ff20a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function greatest(values, compare = _ascending.default) {
    let max;
    let defined = false;
    if (compare.length === 1) {
        let maxValue;
        for (const element of values){
            const value = compare(element);
            if (defined ? (0, _ascending.default)(value, maxValue) > 0 : (0, _ascending.default)(value, value) === 0) {
                max = element;
                maxValue = value;
                defined = true;
            }
        }
    } else {
        for (const value of values)if (defined ? compare(value, max) > 0 : compare(value, value) === 0) {
            max = value;
            defined = true;
        }
    }
    return max;
}

},{"7e4721a4d28ff20a":"5yu5V"}],"7HagX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = greatestIndex;
var _ascending = _interopRequireDefault(require("a08614b50d783d7f"));
var _maxIndex = _interopRequireDefault(require("c1f809321f205561"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function greatestIndex(values, compare = _ascending.default) {
    if (compare.length === 1) return (0, _maxIndex.default)(values, compare);
    let maxValue;
    let max = -1;
    let index = -1;
    for (const value of values){
        ++index;
        if (max < 0 ? compare(value, value) === 0 : compare(value, maxValue) > 0) {
            maxValue = value;
            max = index;
        }
    }
    return max;
}

},{"a08614b50d783d7f":"5yu5V","c1f809321f205561":"fvWGd"}],"igA6j":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = scan;
var _leastIndex = _interopRequireDefault(require("620579109956e518"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function scan(values, compare) {
    const index = (0, _leastIndex.default)(values, compare);
    return index < 0 ? undefined : index;
}

},{"620579109956e518":"c2Alz"}],"2XZuB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
exports.shuffler = shuffler;
var _default = exports.default = shuffler(Math.random);
function shuffler(random) {
    return function shuffle(array, i0 = 0, i1 = array.length) {
        let m = i1 - (i0 = +i0);
        while(m){
            const i = random() * m-- | 0, t = array[m + i0];
            array[m + i0] = array[i + i0];
            array[i + i0] = t;
        }
        return array;
    };
}

},{}],"7F0zR":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sum;
function sum(values, valueof) {
    let sum = 0;
    if (valueof === undefined) {
        for (let value of values)if (value = +value) sum += value;
    } else {
        let index = -1;
        for (let value of values)if (value = +valueof(value, ++index, values)) sum += value;
    }
    return sum;
}

},{}],"4XM4C":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = transpose;
var _min = _interopRequireDefault(require("e91a8bba11a65cd"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function transpose(matrix) {
    if (!(n = matrix.length)) return [];
    for(var i = -1, m = (0, _min.default)(matrix, length), transpose = new Array(m); ++i < m;)for(var j = -1, n, row = transpose[i] = new Array(n); ++j < n;)row[j] = matrix[j][i];
    return transpose;
}
function length(d) {
    return d.length;
}

},{"e91a8bba11a65cd":"jZKFk"}],"kdWpH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = zip;
var _transpose = _interopRequireDefault(require("f5cee9197fcba405"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function zip() {
    return (0, _transpose.default)(arguments);
}

},{"f5cee9197fcba405":"4XM4C"}],"7PRel":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = every;
function every(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (!test(value, ++index, values)) return false;
    }
    return true;
}

},{}],"6TGSF":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = some;
function some(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    let index = -1;
    for (const value of values){
        if (test(value, ++index, values)) return true;
    }
    return false;
}

},{}],"aHlRB":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = filter;
function filter(values, test) {
    if (typeof test !== "function") throw new TypeError("test is not a function");
    const array = [];
    let index = -1;
    for (const value of values)if (test(value, ++index, values)) array.push(value);
    return array;
}

},{}],"2uu8t":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = map;
function map(values, mapper) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    if (typeof mapper !== "function") throw new TypeError("mapper is not a function");
    return Array.from(values, (value, index)=>mapper(value, index, values));
}

},{}],"8mPlU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reduce;
function reduce(values, reducer, value) {
    if (typeof reducer !== "function") throw new TypeError("reducer is not a function");
    const iterator = values[Symbol.iterator]();
    let done, next, index = -1;
    if (arguments.length < 3) {
        ({ done, value } = iterator.next());
        if (done) return;
        ++index;
    }
    while({ done, value: next } = iterator.next(), !done)value = reducer(value, next, ++index, values);
    return value;
}

},{}],"enfn7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = reverse;
function reverse(values) {
    if (typeof values[Symbol.iterator] !== "function") throw new TypeError("values is not iterable");
    return Array.from(values).reverse();
}

},{}],"lBNlZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = difference;
var _index = require("53f785431e2265c8");
function difference(values, ...others) {
    values = new _index.InternSet(values);
    for (const other of others)for (const value of other)values.delete(value);
    return values;
}

},{"53f785431e2265c8":"3TELG"}],"fJwn8":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = disjoint;
var _index = require("fd3ab907acc87368");
function disjoint(values, other) {
    const iterator = other[Symbol.iterator](), set = new _index.InternSet();
    for (const v of values){
        if (set.has(v)) return false;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) break;
            if (Object.is(v, value)) return false;
            set.add(value);
        }
    }
    return true;
}

},{"fd3ab907acc87368":"3TELG"}],"7ZjoH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = intersection;
var _index = require("57400e6933e84289");
function intersection(values, ...others) {
    values = new _index.InternSet(values);
    others = others.map(set);
    out: for (const value of values){
        for (const other of others)if (!other.has(value)) {
            values.delete(value);
            continue out;
        }
    }
    return values;
}
function set(values) {
    return values instanceof _index.InternSet ? values : new _index.InternSet(values);
}

},{"57400e6933e84289":"3TELG"}],"hgdYE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = subset;
var _superset = _interopRequireDefault(require("642286ff2d84a077"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function subset(values, other) {
    return (0, _superset.default)(other, values);
}

},{"642286ff2d84a077":"h0Rqs"}],"h0Rqs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = superset;
function superset(values, other) {
    const iterator = values[Symbol.iterator](), set = new Set();
    for (const o of other){
        const io = intern(o);
        if (set.has(io)) continue;
        let value, done;
        while({ value, done } = iterator.next()){
            if (done) return false;
            const ivalue = intern(value);
            set.add(ivalue);
            if (Object.is(io, ivalue)) break;
        }
    }
    return true;
}
function intern(value) {
    return value !== null && typeof value === "object" ? value.valueOf() : value;
}

},{}],"ifI2v":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = union;
var _index = require("c01638dea2a1bd81");
function union(...others) {
    const set = new _index.InternSet();
    for (const other of others)for (const o of other)set.add(o);
    return set;
}

},{"c01638dea2a1bd81":"3TELG"}],"9c0mi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.initInterpolator = initInterpolator;
exports.initRange = initRange;
function initRange(domain, range) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            this.range(domain);
            break;
        default:
            this.range(range).domain(domain);
            break;
    }
    return this;
}
function initInterpolator(domain, interpolator) {
    switch(arguments.length){
        case 0:
            break;
        case 1:
            if (typeof domain === "function") this.interpolator(domain);
            else this.range(domain);
            break;
        default:
            this.domain(domain);
            if (typeof interpolator === "function") this.interpolator(interpolator);
            else this.range(interpolator);
            break;
    }
    return this;
}

},{}],"80XAa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = ordinal;
exports.implicit = void 0;
var _index = require("fcba4401bac5bf73");
var _init = require("cc7553c4008fe238");
const implicit = exports.implicit = Symbol("implicit");
function ordinal() {
    var index = new _index.InternMap(), domain = [], range = [], unknown = implicit;
    function scale(d) {
        let i = index.get(d);
        if (i === undefined) {
            if (unknown !== implicit) return unknown;
            index.set(d, i = domain.push(d) - 1);
        }
        return range[i % range.length];
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [], index = new _index.InternMap();
        for (const value of _){
            if (index.has(value)) continue;
            index.set(value, domain.push(value) - 1);
        }
        return scale;
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), scale) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return ordinal(domain, range).unknown(unknown);
    };
    _init.initRange.apply(scale, arguments);
    return scale;
}

},{"fcba4401bac5bf73":"3WmRx","cc7553c4008fe238":"9c0mi"}],"9tkMn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = identity;
var _linear = require("f84b1fa17c06395b");
var _number = _interopRequireDefault(require("b36082d6f802f397"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function identity(domain) {
    var unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : x;
    }
    scale.invert = scale;
    scale.domain = scale.range = function(_) {
        return arguments.length ? (domain = Array.from(_, _number.default), scale) : domain.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return identity(domain).unknown(unknown);
    };
    domain = arguments.length ? Array.from(domain, _number.default) : [
        0,
        1
    ];
    return (0, _linear.linearish)(scale);
}

},{"f84b1fa17c06395b":"7wwWf","b36082d6f802f397":"fbqLJ"}],"7wwWf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = linear;
exports.linearish = linearish;
var _index = require("1483cc73fade9a0f");
var _continuous = _interopRequireWildcard(require("b89b32e6dad66d07"));
var _init = require("a628a2e1a79e7cdb");
var _tickFormat = _interopRequireDefault(require("a55604f9dbd11e62"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function linearish(scale) {
    var domain = scale.domain;
    scale.ticks = function(count) {
        var d = domain();
        return (0, _index.ticks)(d[0], d[d.length - 1], count == null ? 10 : count);
    };
    scale.tickFormat = function(count, specifier) {
        var d = domain();
        return (0, _tickFormat.default)(d[0], d[d.length - 1], count == null ? 10 : count, specifier);
    };
    scale.nice = function(count) {
        if (count == null) count = 10;
        var d = domain();
        var i0 = 0;
        var i1 = d.length - 1;
        var start = d[i0];
        var stop = d[i1];
        var prestep;
        var step;
        var maxIter = 10;
        if (stop < start) {
            step = start, start = stop, stop = step;
            step = i0, i0 = i1, i1 = step;
        }
        while(maxIter-- > 0){
            step = (0, _index.tickIncrement)(start, stop, count);
            if (step === prestep) {
                d[i0] = start;
                d[i1] = stop;
                return domain(d);
            } else if (step > 0) {
                start = Math.floor(start / step) * step;
                stop = Math.ceil(stop / step) * step;
            } else if (step < 0) {
                start = Math.ceil(start * step) / step;
                stop = Math.floor(stop * step) / step;
            } else break;
            prestep = step;
        }
        return scale;
    };
    return scale;
}
function linear() {
    var scale = (0, _continuous.default)();
    scale.copy = function() {
        return (0, _continuous.copy)(scale, linear());
    };
    _init.initRange.apply(scale, arguments);
    return linearish(scale);
}

},{"1483cc73fade9a0f":"3WmRx","b89b32e6dad66d07":"9w8kD","a628a2e1a79e7cdb":"9c0mi","a55604f9dbd11e62":"kZcrG"}],"9w8kD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copy = copy;
exports.default = continuous;
exports.identity = identity;
exports.transformer = transformer;
var _index = require("b27e55bf39279c79");
var _index2 = require("ba6b5a0092937a29");
var _constant = _interopRequireDefault(require("e75211b791b964e7"));
var _number = _interopRequireDefault(require("d695e4a3f96a954d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var unit = [
    0,
    1
];
function identity(x) {
    return x;
}
function normalize(a, b) {
    return (b -= a = +a) ? function(x) {
        return (x - a) / b;
    } : (0, _constant.default)(isNaN(b) ? NaN : 0.5);
}
function clamper(a, b) {
    var t;
    if (a > b) t = a, a = b, b = t;
    return function(x) {
        return Math.max(a, Math.min(b, x));
    };
}
// normalize(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
// interpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding range value x in [a,b].
function bimap(domain, range, interpolate) {
    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
    if (d1 < d0) d0 = normalize(d1, d0), r0 = interpolate(r1, r0);
    else d0 = normalize(d0, d1), r0 = interpolate(r0, r1);
    return function(x) {
        return r0(d0(x));
    };
}
function polymap(domain, range, interpolate) {
    var j = Math.min(domain.length, range.length) - 1, d = new Array(j), r = new Array(j), i = -1;
    // Reverse descending domains.
    if (domain[j] < domain[0]) {
        domain = domain.slice().reverse();
        range = range.slice().reverse();
    }
    while(++i < j){
        d[i] = normalize(domain[i], domain[i + 1]);
        r[i] = interpolate(range[i], range[i + 1]);
    }
    return function(x) {
        var i = (0, _index.bisect)(domain, x, 1, j) - 1;
        return r[i](d[i](x));
    };
}
function copy(source, target) {
    return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer() {
    var domain = unit, range = unit, interpolate = _index2.interpolate, transform, untransform, unknown, clamp = identity, piecewise, output, input;
    function rescale() {
        var n = Math.min(domain.length, range.length);
        if (clamp !== identity) clamp = clamper(domain[0], domain[n - 1]);
        piecewise = n > 2 ? polymap : bimap;
        output = input = null;
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : (output || (output = piecewise(domain.map(transform), range, interpolate)))(transform(clamp(x)));
    }
    scale.invert = function(y) {
        return clamp(untransform((input || (input = piecewise(range, domain.map(transform), _index2.interpolateNumber)))(y)));
    };
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_, _number.default), rescale()) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.rangeRound = function(_) {
        return range = Array.from(_), interpolate = _index2.interpolateRound, rescale();
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = _ ? true : identity, rescale()) : clamp !== identity;
    };
    scale.interpolate = function(_) {
        return arguments.length ? (interpolate = _, rescale()) : interpolate;
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t, u) {
        transform = t, untransform = u;
        return rescale();
    };
}
function continuous() {
    return transformer()(identity, identity);
}

},{"b27e55bf39279c79":"3WmRx","ba6b5a0092937a29":"8saGV","e75211b791b964e7":"aDM3c","d695e4a3f96a954d":"fbqLJ"}],"8saGV":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "interpolate", {
    enumerable: true,
    get: function() {
        return _value.default;
    }
});
Object.defineProperty(exports, "interpolateArray", {
    enumerable: true,
    get: function() {
        return _array.default;
    }
});
Object.defineProperty(exports, "interpolateBasis", {
    enumerable: true,
    get: function() {
        return _basis.default;
    }
});
Object.defineProperty(exports, "interpolateBasisClosed", {
    enumerable: true,
    get: function() {
        return _basisClosed.default;
    }
});
Object.defineProperty(exports, "interpolateCubehelix", {
    enumerable: true,
    get: function() {
        return _cubehelix.default;
    }
});
Object.defineProperty(exports, "interpolateCubehelixLong", {
    enumerable: true,
    get: function() {
        return _cubehelix.cubehelixLong;
    }
});
Object.defineProperty(exports, "interpolateDate", {
    enumerable: true,
    get: function() {
        return _date.default;
    }
});
Object.defineProperty(exports, "interpolateDiscrete", {
    enumerable: true,
    get: function() {
        return _discrete.default;
    }
});
Object.defineProperty(exports, "interpolateHcl", {
    enumerable: true,
    get: function() {
        return _hcl.default;
    }
});
Object.defineProperty(exports, "interpolateHclLong", {
    enumerable: true,
    get: function() {
        return _hcl.hclLong;
    }
});
Object.defineProperty(exports, "interpolateHsl", {
    enumerable: true,
    get: function() {
        return _hsl.default;
    }
});
Object.defineProperty(exports, "interpolateHslLong", {
    enumerable: true,
    get: function() {
        return _hsl.hslLong;
    }
});
Object.defineProperty(exports, "interpolateHue", {
    enumerable: true,
    get: function() {
        return _hue.default;
    }
});
Object.defineProperty(exports, "interpolateLab", {
    enumerable: true,
    get: function() {
        return _lab.default;
    }
});
Object.defineProperty(exports, "interpolateNumber", {
    enumerable: true,
    get: function() {
        return _number.default;
    }
});
Object.defineProperty(exports, "interpolateNumberArray", {
    enumerable: true,
    get: function() {
        return _numberArray.default;
    }
});
Object.defineProperty(exports, "interpolateObject", {
    enumerable: true,
    get: function() {
        return _object.default;
    }
});
Object.defineProperty(exports, "interpolateRgb", {
    enumerable: true,
    get: function() {
        return _rgb.default;
    }
});
Object.defineProperty(exports, "interpolateRgbBasis", {
    enumerable: true,
    get: function() {
        return _rgb.rgbBasis;
    }
});
Object.defineProperty(exports, "interpolateRgbBasisClosed", {
    enumerable: true,
    get: function() {
        return _rgb.rgbBasisClosed;
    }
});
Object.defineProperty(exports, "interpolateRound", {
    enumerable: true,
    get: function() {
        return _round.default;
    }
});
Object.defineProperty(exports, "interpolateString", {
    enumerable: true,
    get: function() {
        return _string.default;
    }
});
Object.defineProperty(exports, "interpolateTransformCss", {
    enumerable: true,
    get: function() {
        return _index.interpolateTransformCss;
    }
});
Object.defineProperty(exports, "interpolateTransformSvg", {
    enumerable: true,
    get: function() {
        return _index.interpolateTransformSvg;
    }
});
Object.defineProperty(exports, "interpolateZoom", {
    enumerable: true,
    get: function() {
        return _zoom.default;
    }
});
Object.defineProperty(exports, "piecewise", {
    enumerable: true,
    get: function() {
        return _piecewise.default;
    }
});
Object.defineProperty(exports, "quantize", {
    enumerable: true,
    get: function() {
        return _quantize.default;
    }
});
var _value = _interopRequireDefault(require("18a1769b74308b38"));
var _array = _interopRequireDefault(require("f99323a27aa06a8c"));
var _basis = _interopRequireDefault(require("66bb1ae08d550d2f"));
var _basisClosed = _interopRequireDefault(require("e0f8689cd9a4ed85"));
var _date = _interopRequireDefault(require("938cc47dd24b27f"));
var _discrete = _interopRequireDefault(require("6ee3a660784662db"));
var _hue = _interopRequireDefault(require("c97b3402df3264f1"));
var _number = _interopRequireDefault(require("c4605d70387a9f89"));
var _numberArray = _interopRequireDefault(require("f5b9681bf316d3c8"));
var _object = _interopRequireDefault(require("2a8363d30def3d49"));
var _round = _interopRequireDefault(require("132735e62b44017c"));
var _string = _interopRequireDefault(require("5f79c0b417d7ffb1"));
var _index = require("9cd31cac42489c2d");
var _zoom = _interopRequireDefault(require("829022ddb9572f68"));
var _rgb = _interopRequireWildcard(require("a08467c6d9046172"));
var _hsl = _interopRequireWildcard(require("1b2f37b38b1c2632"));
var _lab = _interopRequireDefault(require("76284b3c5d04b53e"));
var _hcl = _interopRequireWildcard(require("361bffab7c7a6e6a"));
var _cubehelix = _interopRequireWildcard(require("c6d6249c783d060a"));
var _piecewise = _interopRequireDefault(require("cb02924b4c722e0d"));
var _quantize = _interopRequireDefault(require("d55fda9f4fcff7dd"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"18a1769b74308b38":"dLkyW","f99323a27aa06a8c":"i5klt","66bb1ae08d550d2f":"juiSN","e0f8689cd9a4ed85":"2O9oe","938cc47dd24b27f":"hIFzD","6ee3a660784662db":"iX52l","c97b3402df3264f1":"b9eWE","c4605d70387a9f89":"kgyAE","f5b9681bf316d3c8":"dKKK9","2a8363d30def3d49":"fbKMX","132735e62b44017c":"96E7N","5f79c0b417d7ffb1":"iETQQ","9cd31cac42489c2d":"g6gbx","829022ddb9572f68":"8lKxi","a08467c6d9046172":"1Iwtu","1b2f37b38b1c2632":"189BK","76284b3c5d04b53e":"5Rc4l","361bffab7c7a6e6a":"fNLV7","c6d6249c783d060a":"5S5ro","cb02924b4c722e0d":"6eoZ5","d55fda9f4fcff7dd":"bn5P3"}],"dLkyW":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _index = require("6b00cb8a35cd7eca");
var _rgb = _interopRequireDefault(require("2f5b9308d0021b3f"));
var _array = require("858d92aa5fbe2d16");
var _date = _interopRequireDefault(require("3b5f3eaf3c70c4df"));
var _number = _interopRequireDefault(require("7aa3212a6360303f"));
var _object = _interopRequireDefault(require("4512622efcc3e244"));
var _string = _interopRequireDefault(require("4f6ec7c7e2d116a"));
var _constant = _interopRequireDefault(require("49fed36e04134ce7"));
var _numberArray = _interopRequireWildcard(require("7635b225e783f2fb"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    var t = typeof b, c;
    return b == null || t === "boolean" ? (0, _constant.default)(b) : (t === "number" ? _number.default : t === "string" ? (c = (0, _index.color)(b)) ? (b = c, _rgb.default) : _string.default : b instanceof _index.color ? _rgb.default : b instanceof Date ? _date.default : (0, _numberArray.isNumberArray)(b) ? _numberArray.default : Array.isArray(b) ? _array.genericArray : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? _object.default : _number.default)(a, b);
}

},{"6b00cb8a35cd7eca":"j7NEC","2f5b9308d0021b3f":"1Iwtu","858d92aa5fbe2d16":"i5klt","3b5f3eaf3c70c4df":"hIFzD","7aa3212a6360303f":"kgyAE","4512622efcc3e244":"fbKMX","4f6ec7c7e2d116a":"iETQQ","49fed36e04134ce7":"29DPw","7635b225e783f2fb":"dKKK9"}],"j7NEC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "color", {
    enumerable: true,
    get: function() {
        return _color.default;
    }
});
Object.defineProperty(exports, "cubehelix", {
    enumerable: true,
    get: function() {
        return _cubehelix.default;
    }
});
Object.defineProperty(exports, "gray", {
    enumerable: true,
    get: function() {
        return _lab.gray;
    }
});
Object.defineProperty(exports, "hcl", {
    enumerable: true,
    get: function() {
        return _lab.hcl;
    }
});
Object.defineProperty(exports, "hsl", {
    enumerable: true,
    get: function() {
        return _color.hsl;
    }
});
Object.defineProperty(exports, "lab", {
    enumerable: true,
    get: function() {
        return _lab.default;
    }
});
Object.defineProperty(exports, "lch", {
    enumerable: true,
    get: function() {
        return _lab.lch;
    }
});
Object.defineProperty(exports, "rgb", {
    enumerable: true,
    get: function() {
        return _color.rgb;
    }
});
var _color = _interopRequireWildcard(require("60878dcd6741cbf6"));
var _lab = _interopRequireWildcard(require("19fbdf90fb32e3fb"));
var _cubehelix = _interopRequireDefault(require("84a7e361b17f11ef"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

},{"60878dcd6741cbf6":"giINC","19fbdf90fb32e3fb":"blOoi","84a7e361b17f11ef":"7aPTc"}],"giINC":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Color = Color;
exports.Rgb = Rgb;
exports.darker = exports.brighter = void 0;
exports.default = color;
exports.hsl = hsl;
exports.hslConvert = hslConvert;
exports.rgb = rgb;
exports.rgbConvert = rgbConvert;
var _define = _interopRequireWildcard(require("1d30727e3b2969dd"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function Color() {}
var darker = exports.darker = 0.7;
var brighter = exports.brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
    aliceblue: 0xf0f8ff,
    antiquewhite: 0xfaebd7,
    aqua: 0x00ffff,
    aquamarine: 0x7fffd4,
    azure: 0xf0ffff,
    beige: 0xf5f5dc,
    bisque: 0xffe4c4,
    black: 0x000000,
    blanchedalmond: 0xffebcd,
    blue: 0x0000ff,
    blueviolet: 0x8a2be2,
    brown: 0xa52a2a,
    burlywood: 0xdeb887,
    cadetblue: 0x5f9ea0,
    chartreuse: 0x7fff00,
    chocolate: 0xd2691e,
    coral: 0xff7f50,
    cornflowerblue: 0x6495ed,
    cornsilk: 0xfff8dc,
    crimson: 0xdc143c,
    cyan: 0x00ffff,
    darkblue: 0x00008b,
    darkcyan: 0x008b8b,
    darkgoldenrod: 0xb8860b,
    darkgray: 0xa9a9a9,
    darkgreen: 0x006400,
    darkgrey: 0xa9a9a9,
    darkkhaki: 0xbdb76b,
    darkmagenta: 0x8b008b,
    darkolivegreen: 0x556b2f,
    darkorange: 0xff8c00,
    darkorchid: 0x9932cc,
    darkred: 0x8b0000,
    darksalmon: 0xe9967a,
    darkseagreen: 0x8fbc8f,
    darkslateblue: 0x483d8b,
    darkslategray: 0x2f4f4f,
    darkslategrey: 0x2f4f4f,
    darkturquoise: 0x00ced1,
    darkviolet: 0x9400d3,
    deeppink: 0xff1493,
    deepskyblue: 0x00bfff,
    dimgray: 0x696969,
    dimgrey: 0x696969,
    dodgerblue: 0x1e90ff,
    firebrick: 0xb22222,
    floralwhite: 0xfffaf0,
    forestgreen: 0x228b22,
    fuchsia: 0xff00ff,
    gainsboro: 0xdcdcdc,
    ghostwhite: 0xf8f8ff,
    gold: 0xffd700,
    goldenrod: 0xdaa520,
    gray: 0x808080,
    green: 0x008000,
    greenyellow: 0xadff2f,
    grey: 0x808080,
    honeydew: 0xf0fff0,
    hotpink: 0xff69b4,
    indianred: 0xcd5c5c,
    indigo: 0x4b0082,
    ivory: 0xfffff0,
    khaki: 0xf0e68c,
    lavender: 0xe6e6fa,
    lavenderblush: 0xfff0f5,
    lawngreen: 0x7cfc00,
    lemonchiffon: 0xfffacd,
    lightblue: 0xadd8e6,
    lightcoral: 0xf08080,
    lightcyan: 0xe0ffff,
    lightgoldenrodyellow: 0xfafad2,
    lightgray: 0xd3d3d3,
    lightgreen: 0x90ee90,
    lightgrey: 0xd3d3d3,
    lightpink: 0xffb6c1,
    lightsalmon: 0xffa07a,
    lightseagreen: 0x20b2aa,
    lightskyblue: 0x87cefa,
    lightslategray: 0x778899,
    lightslategrey: 0x778899,
    lightsteelblue: 0xb0c4de,
    lightyellow: 0xffffe0,
    lime: 0x00ff00,
    limegreen: 0x32cd32,
    linen: 0xfaf0e6,
    magenta: 0xff00ff,
    maroon: 0x800000,
    mediumaquamarine: 0x66cdaa,
    mediumblue: 0x0000cd,
    mediumorchid: 0xba55d3,
    mediumpurple: 0x9370db,
    mediumseagreen: 0x3cb371,
    mediumslateblue: 0x7b68ee,
    mediumspringgreen: 0x00fa9a,
    mediumturquoise: 0x48d1cc,
    mediumvioletred: 0xc71585,
    midnightblue: 0x191970,
    mintcream: 0xf5fffa,
    mistyrose: 0xffe4e1,
    moccasin: 0xffe4b5,
    navajowhite: 0xffdead,
    navy: 0x000080,
    oldlace: 0xfdf5e6,
    olive: 0x808000,
    olivedrab: 0x6b8e23,
    orange: 0xffa500,
    orangered: 0xff4500,
    orchid: 0xda70d6,
    palegoldenrod: 0xeee8aa,
    palegreen: 0x98fb98,
    paleturquoise: 0xafeeee,
    palevioletred: 0xdb7093,
    papayawhip: 0xffefd5,
    peachpuff: 0xffdab9,
    peru: 0xcd853f,
    pink: 0xffc0cb,
    plum: 0xdda0dd,
    powderblue: 0xb0e0e6,
    purple: 0x800080,
    rebeccapurple: 0x663399,
    red: 0xff0000,
    rosybrown: 0xbc8f8f,
    royalblue: 0x4169e1,
    saddlebrown: 0x8b4513,
    salmon: 0xfa8072,
    sandybrown: 0xf4a460,
    seagreen: 0x2e8b57,
    seashell: 0xfff5ee,
    sienna: 0xa0522d,
    silver: 0xc0c0c0,
    skyblue: 0x87ceeb,
    slateblue: 0x6a5acd,
    slategray: 0x708090,
    slategrey: 0x708090,
    snow: 0xfffafa,
    springgreen: 0x00ff7f,
    steelblue: 0x4682b4,
    tan: 0xd2b48c,
    teal: 0x008080,
    thistle: 0xd8bfd8,
    tomato: 0xff6347,
    turquoise: 0x40e0d0,
    violet: 0xee82ee,
    wheat: 0xf5deb3,
    white: 0xffffff,
    whitesmoke: 0xf5f5f5,
    yellow: 0xffff00,
    yellowgreen: 0x9acd32
};
(0, _define.default)(Color, color, {
    copy (channels) {
        return Object.assign(new this.constructor(), this, channels);
    },
    displayable () {
        return this.rgb().displayable();
    },
    hex: color_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: color_formatHex,
    formatHex8: color_formatHex8,
    formatHsl: color_formatHsl,
    formatRgb: color_formatRgb,
    toString: color_formatRgb
});
function color_formatHex() {
    return this.rgb().formatHex();
}
function color_formatHex8() {
    return this.rgb().formatHex8();
}
function color_formatHsl() {
    return hslConvert(this).formatHsl();
}
function color_formatRgb() {
    return this.rgb().formatRgb();
}
function color(format) {
    var m, l;
    format = (format + "").trim().toLowerCase();
    return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
     : l === 3 ? new Rgb(m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, (m & 0xf) << 4 | m & 0xf, 1) // #f00
     : l === 8 ? rgba(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
     : l === 4 ? rgba(m >> 12 & 0xf | m >> 8 & 0xf0, m >> 8 & 0xf | m >> 4 & 0xf0, m >> 4 & 0xf | m & 0xf0, ((m & 0xf) << 4 | m & 0xf) / 0xff) // #f000
     : null // invalid hex
    ) : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
     : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
     : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
     : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
     : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
     : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
     : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
     : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n) {
    return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
}
function rgba(r, g, b, a) {
    if (a <= 0) r = g = b = NaN;
    return new Rgb(r, g, b, a);
}
function rgbConvert(o) {
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Rgb();
    o = o.rgb();
    return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb(r, g, b, opacity) {
    return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
}
function Rgb(r, g, b, opacity) {
    this.r = +r;
    this.g = +g;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Rgb, rgb, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
    },
    rgb () {
        return this;
    },
    clamp () {
        return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
    },
    displayable () {
        return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
    },
    hex: rgb_formatHex,
    // Deprecated! Use color.formatHex.
    formatHex: rgb_formatHex,
    formatHex8: rgb_formatHex8,
    formatRgb: rgb_formatRgb,
    toString: rgb_formatRgb
}));
function rgb_formatHex() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
    return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
    return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
    return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
    value = clampi(value);
    return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h, s, l, a) {
    if (a <= 0) h = s = l = NaN;
    else if (l <= 0 || l >= 1) h = s = NaN;
    else if (s <= 0) h = NaN;
    return new Hsl(h, s, l, a);
}
function hslConvert(o) {
    if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof Color)) o = color(o);
    if (!o) return new Hsl();
    if (o instanceof Hsl) return o;
    o = o.rgb();
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, min = Math.min(r, g, b), max = Math.max(r, g, b), h = NaN, s = max - min, l = (max + min) / 2;
    if (s) {
        if (r === max) h = (g - b) / s + (g < b) * 6;
        else if (g === max) h = (b - r) / s + 2;
        else h = (r - g) / s + 4;
        s /= l < 0.5 ? max + min : 2 - max - min;
        h *= 60;
    } else s = l > 0 && l < 1 ? 0 : h;
    return new Hsl(h, s, l, o.opacity);
}
function hsl(h, s, l, opacity) {
    return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Hsl, hsl, (0, _define.extend)(Color, {
    brighter (k) {
        k = k == null ? brighter : Math.pow(brighter, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? darker : Math.pow(darker, k);
        return new Hsl(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = this.h % 360 + (this.h < 0) * 360, s = isNaN(h) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
        return new Rgb(hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2), hsl2rgb(h, m1, m2), hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2), this.opacity);
    },
    clamp () {
        return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
    },
    displayable () {
        return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
    },
    formatHsl () {
        const a = clampa(this.opacity);
        return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
    }
}));
function clamph(value) {
    value = (value || 0) % 360;
    return value < 0 ? value + 360 : value;
}
function clampt(value) {
    return Math.max(0, Math.min(1, value || 0));
}
/* From FvD 13.37, CSS Color Module Level 3 */ function hsl2rgb(h, m1, m2) {
    return (h < 60 ? m1 + (m2 - m1) * h / 60 : h < 180 ? m2 : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60 : m1) * 255;
}

},{"1d30727e3b2969dd":"5UwhP"}],"5UwhP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.extend = extend;
function _default(constructor, factory, prototype) {
    constructor.prototype = factory.prototype = prototype;
    prototype.constructor = constructor;
}
function extend(parent, definition) {
    var prototype = Object.create(parent.prototype);
    for(var key in definition)prototype[key] = definition[key];
    return prototype;
}

},{}],"blOoi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Hcl = Hcl;
exports.Lab = Lab;
exports.default = lab;
exports.gray = gray;
exports.hcl = hcl;
exports.lch = lch;
var _define = _interopRequireWildcard(require("9a3353011f08cad1"));
var _color = require("3650f0b1e5700098");
var _math = require("ef21497f13ac1079");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
// https://observablehq.com/@mbostock/lab-and-rgb
const K = 18, Xn = 0.96422, Yn = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
    if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
    if (o instanceof Hcl) return hcl2lab(o);
    if (!(o instanceof _color.Rgb)) o = (0, _color.rgbConvert)(o);
    var r = rgb2lrgb(o.r), g = rgb2lrgb(o.g), b = rgb2lrgb(o.b), y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
    if (r === g && g === b) x = z = y;
    else {
        x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
        z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
    }
    return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
}
function gray(l, opacity) {
    return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
}
function lab(l, a, b, opacity) {
    return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
}
function Lab(l, a, b, opacity) {
    this.l = +l;
    this.a = +a;
    this.b = +b;
    this.opacity = +opacity;
}
(0, _define.default)(Lab, lab, (0, _define.extend)(_color.Color, {
    brighter (k) {
        return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    darker (k) {
        return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
    },
    rgb () {
        var y = (this.l + 16) / 116, x = isNaN(this.a) ? y : y + this.a / 500, z = isNaN(this.b) ? y : y - this.b / 200;
        x = Xn * lab2xyz(x);
        y = Yn * lab2xyz(y);
        z = Zn * lab2xyz(z);
        return new _color.Rgb(lrgb2rgb(3.1338561 * x - 1.6168667 * y - 0.4906146 * z), lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z), lrgb2rgb(0.0719453 * x - 0.2289914 * y + 1.4052427 * z), this.opacity);
    }
}));
function xyz2lab(t) {
    return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
    return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x) {
    return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x) {
    return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
    if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
    if (!(o instanceof Lab)) o = labConvert(o);
    if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
    var h = Math.atan2(o.b, o.a) * _math.degrees;
    return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function lch(l, c, h, opacity) {
    return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function hcl(h, c, l, opacity) {
    return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
}
function Hcl(h, c, l, opacity) {
    this.h = +h;
    this.c = +c;
    this.l = +l;
    this.opacity = +opacity;
}
function hcl2lab(o) {
    if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
    var h = o.h * _math.radians;
    return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
}
(0, _define.default)(Hcl, hcl, (0, _define.extend)(_color.Color, {
    brighter (k) {
        return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
    },
    darker (k) {
        return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
    },
    rgb () {
        return hcl2lab(this).rgb();
    }
}));

},{"9a3353011f08cad1":"5UwhP","3650f0b1e5700098":"giINC","ef21497f13ac1079":"fLXFb"}],"fLXFb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.radians = exports.degrees = void 0;
const radians = exports.radians = Math.PI / 180;
const degrees = exports.degrees = 180 / Math.PI;

},{}],"7aPTc":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Cubehelix = Cubehelix;
exports.default = cubehelix;
var _define = _interopRequireWildcard(require("4abcf1c064e6684a"));
var _color = require("88aa652eacec148e");
var _math = require("7e69901a6e423f00");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var A = -0.14861, B = 1.78277, C = -0.29227, D = -0.90649, E = 1.97294, ED = E * D, EB = E * B, BC_DA = B * C - D * A;
function cubehelixConvert(o) {
    if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
    if (!(o instanceof _color.Rgb)) o = (0, _color.rgbConvert)(o);
    var r = o.r / 255, g = o.g / 255, b = o.b / 255, l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB), bl = b - l, k = (E * (g - l) - C * bl) / D, s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
    h = s ? Math.atan2(k, bl) * _math.degrees - 120 : NaN;
    return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
}
function cubehelix(h, s, l, opacity) {
    return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
}
function Cubehelix(h, s, l, opacity) {
    this.h = +h;
    this.s = +s;
    this.l = +l;
    this.opacity = +opacity;
}
(0, _define.default)(Cubehelix, cubehelix, (0, _define.extend)(_color.Color, {
    brighter (k) {
        k = k == null ? _color.brighter : Math.pow(_color.brighter, k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    darker (k) {
        k = k == null ? _color.darker : Math.pow(_color.darker, k);
        return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
    },
    rgb () {
        var h = isNaN(this.h) ? 0 : (this.h + 120) * _math.radians, l = +this.l, a = isNaN(this.s) ? 0 : this.s * l * (1 - l), cosh = Math.cos(h), sinh = Math.sin(h);
        return new _color.Rgb(255 * (l + a * (A * cosh + B * sinh)), 255 * (l + a * (C * cosh + D * sinh)), 255 * (l + a * (E * cosh)), this.opacity);
    }
}));

},{"4abcf1c064e6684a":"5UwhP","88aa652eacec148e":"giINC","7e69901a6e423f00":"fLXFb"}],"1Iwtu":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.rgbBasisClosed = exports.rgbBasis = exports.default = void 0;
var _index = require("a71c13c6f95adbd4");
var _basis = _interopRequireDefault(require("6a332a97102860d7"));
var _basisClosed = _interopRequireDefault(require("9304424e5c9a17cf"));
var _color = _interopRequireWildcard(require("7dffa81f3b4437d6"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = exports.default = function rgbGamma(y) {
    var color = (0, _color.gamma)(y);
    function rgb(start, end) {
        var r = color((start = (0, _index.rgb)(start)).r, (end = (0, _index.rgb)(end)).r), g = color(start.g, end.g), b = color(start.b, end.b), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.r = r(t);
            start.g = g(t);
            start.b = b(t);
            start.opacity = opacity(t);
            return start + "";
        };
    }
    rgb.gamma = rgbGamma;
    return rgb;
}(1);
function rgbSpline(spline) {
    return function(colors) {
        var n = colors.length, r = new Array(n), g = new Array(n), b = new Array(n), i, color;
        for(i = 0; i < n; ++i){
            color = (0, _index.rgb)(colors[i]);
            r[i] = color.r || 0;
            g[i] = color.g || 0;
            b[i] = color.b || 0;
        }
        r = spline(r);
        g = spline(g);
        b = spline(b);
        color.opacity = 1;
        return function(t) {
            color.r = r(t);
            color.g = g(t);
            color.b = b(t);
            return color + "";
        };
    };
}
var rgbBasis = exports.rgbBasis = rgbSpline(_basis.default);
var rgbBasisClosed = exports.rgbBasisClosed = rgbSpline(_basisClosed.default);

},{"a71c13c6f95adbd4":"j7NEC","6a332a97102860d7":"juiSN","9304424e5c9a17cf":"2O9oe","7dffa81f3b4437d6":"bwUhJ"}],"juiSN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.basis = basis;
exports.default = _default;
function basis(t1, v0, v1, v2, v3) {
    var t2 = t1 * t1, t3 = t2 * t1;
    return ((1 - 3 * t1 + 3 * t2 - t3) * v0 + (4 - 6 * t2 + 3 * t3) * v1 + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2 + t3 * v3) / 6;
}
function _default(values) {
    var n = values.length - 1;
    return function(t) {
        var i = t <= 0 ? t = 0 : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n), v1 = values[i], v2 = values[i + 1], v0 = i > 0 ? values[i - 1] : 2 * v1 - v2, v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
        return basis((t - i / n) * n, v0, v1, v2, v3);
    };
}

},{}],"2O9oe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _basis = require("fa54a771ab54df01");
function _default(values) {
    var n = values.length;
    return function(t) {
        var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n), v0 = values[(i + n - 1) % n], v1 = values[i % n], v2 = values[(i + 1) % n], v3 = values[(i + 2) % n];
        return (0, _basis.basis)((t - i / n) * n, v0, v1, v2, v3);
    };
}

},{"fa54a771ab54df01":"juiSN"}],"bwUhJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nogamma;
exports.gamma = gamma;
exports.hue = hue;
var _constant = _interopRequireDefault(require("c45f0b08e65bfe9d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function linear(a, d) {
    return function(t) {
        return a + t * d;
    };
}
function exponential(a, b, y) {
    return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
        return Math.pow(a + t * b, y);
    };
}
function hue(a, b) {
    var d = b - a;
    return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : (0, _constant.default)(isNaN(a) ? b : a);
}
function gamma(y) {
    return (y = +y) === 1 ? nogamma : function(a, b) {
        return b - a ? exponential(a, b, y) : (0, _constant.default)(isNaN(a) ? b : a);
    };
}
function nogamma(a, b) {
    var d = b - a;
    return d ? linear(a, d) : (0, _constant.default)(isNaN(a) ? b : a);
}

},{"c45f0b08e65bfe9d":"29DPw"}],"29DPw":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _default = (x)=>()=>x;
exports.default = _default;

},{}],"i5klt":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.genericArray = genericArray;
var _value = _interopRequireDefault(require("b86da8c7688bb1d9"));
var _numberArray = _interopRequireWildcard(require("505aa46a393cd613"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    return ((0, _numberArray.isNumberArray)(b) ? _numberArray.default : genericArray)(a, b);
}
function genericArray(a, b) {
    var nb = b ? b.length : 0, na = a ? Math.min(nb, a.length) : 0, x = new Array(na), c = new Array(nb), i;
    for(i = 0; i < na; ++i)x[i] = (0, _value.default)(a[i], b[i]);
    for(; i < nb; ++i)c[i] = b[i];
    return function(t) {
        for(i = 0; i < na; ++i)c[i] = x[i](t);
        return c;
    };
}

},{"b86da8c7688bb1d9":"dLkyW","505aa46a393cd613":"dKKK9"}],"dKKK9":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.isNumberArray = isNumberArray;
function _default(a, b) {
    if (!b) b = [];
    var n = a ? Math.min(b.length, a.length) : 0, c = b.slice(), i;
    return function(t) {
        for(i = 0; i < n; ++i)c[i] = a[i] * (1 - t) + b[i] * t;
        return c;
    };
}
function isNumberArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}

},{}],"hIFzD":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    var d = new Date();
    return a = +a, b = +b, function(t) {
        return d.setTime(a * (1 - t) + b * t), d;
    };
}

},{}],"kgyAE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return a = +a, b = +b, function(t) {
        return a * (1 - t) + b * t;
    };
}

},{}],"fbKMX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _value = _interopRequireDefault(require("ff3c10c6ba896e53"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(a, b) {
    var i = {}, c = {}, k;
    if (a === null || typeof a !== "object") a = {};
    if (b === null || typeof b !== "object") b = {};
    for(k in b)if (k in a) i[k] = (0, _value.default)(a[k], b[k]);
    else c[k] = b[k];
    return function(t) {
        for(k in i)c[k] = i[k](t);
        return c;
    };
}

},{"ff3c10c6ba896e53":"dLkyW"}],"iETQQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _number = _interopRequireDefault(require("1ec1f242696e82fa"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b) {
    return function() {
        return b;
    };
}
function one(b) {
    return function(t) {
        return b(t) + "";
    };
}
function _default(a, b) {
    var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
    am, // current match in a
    bm, // current match in b
    bs, // string preceding current number in b, if any
    i = -1, // index in s
    s = [], // string constants and placeholders
    q = []; // number interpolators
    // Coerce inputs to strings.
    a = a + "", b = b + "";
    // Interpolate pairs of numbers in a & b.
    while((am = reA.exec(a)) && (bm = reB.exec(b))){
        if ((bs = bm.index) > bi) {
            // a string precedes the next number in b
            bs = b.slice(bi, bs);
            if (s[i]) s[i] += bs; // coalesce with previous string
            else s[++i] = bs;
        }
        if ((am = am[0]) === (bm = bm[0])) {
            // numbers in a & b match
            if (s[i]) s[i] += bm; // coalesce with previous string
            else s[++i] = bm;
        } else {
            // interpolate non-matching numbers
            s[++i] = null;
            q.push({
                i: i,
                x: (0, _number.default)(am, bm)
            });
        }
        bi = reB.lastIndex;
    }
    // Add remains of b.
    if (bi < b.length) {
        bs = b.slice(bi);
        if (s[i]) s[i] += bs; // coalesce with previous string
        else s[++i] = bs;
    }
    // Special optimization for only a single match.
    // Otherwise, interpolate each of the numbers and rejoin the string.
    return s.length < 2 ? q[0] ? one(q[0].x) : zero(b) : (b = q.length, function(t) {
        for(var i = 0, o; i < b; ++i)s[(o = q[i]).i] = o.x(t);
        return s.join("");
    });
}

},{"1ec1f242696e82fa":"kgyAE"}],"iX52l":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(range) {
    var n = range.length;
    return function(t) {
        return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
    };
}

},{}],"b9eWE":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _color = require("f9552f2567e33cad");
function _default(a, b) {
    var i = (0, _color.hue)(+a, +b);
    return function(t) {
        var x = i(t);
        return x - 360 * Math.floor(x / 360);
    };
}

},{"f9552f2567e33cad":"bwUhJ"}],"96E7N":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(a, b) {
    return a = +a, b = +b, function(t) {
        return Math.round(a * (1 - t) + b * t);
    };
}

},{}],"g6gbx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.interpolateTransformSvg = exports.interpolateTransformCss = void 0;
var _number = _interopRequireDefault(require("3e2d37e598810190"));
var _parse = require("4b3d6acbd4a3c21a");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function interpolateTransform(parse, pxComma, pxParen, degParen) {
    function pop(s) {
        return s.length ? s.pop() + " " : "";
    }
    function translate(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push("translate(", null, pxComma, null, pxParen);
            q.push({
                i: i - 4,
                x: (0, _number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _number.default)(ya, yb)
            });
        } else if (xb || yb) s.push("translate(" + xb + pxComma + yb + pxParen);
    }
    function rotate(a, b, s, q) {
        if (a !== b) {
            if (a - b > 180) b += 360;
            else if (b - a > 180) a += 360; // shortest path
            q.push({
                i: s.push(pop(s) + "rotate(", null, degParen) - 2,
                x: (0, _number.default)(a, b)
            });
        } else if (b) s.push(pop(s) + "rotate(" + b + degParen);
    }
    function skewX(a, b, s, q) {
        if (a !== b) q.push({
            i: s.push(pop(s) + "skewX(", null, degParen) - 2,
            x: (0, _number.default)(a, b)
        });
        else if (b) s.push(pop(s) + "skewX(" + b + degParen);
    }
    function scale(xa, ya, xb, yb, s, q) {
        if (xa !== xb || ya !== yb) {
            var i = s.push(pop(s) + "scale(", null, ",", null, ")");
            q.push({
                i: i - 4,
                x: (0, _number.default)(xa, xb)
            }, {
                i: i - 2,
                x: (0, _number.default)(ya, yb)
            });
        } else if (xb !== 1 || yb !== 1) s.push(pop(s) + "scale(" + xb + "," + yb + ")");
    }
    return function(a, b) {
        var s = [], // string constants and placeholders
        q = []; // number interpolators
        a = parse(a), b = parse(b);
        translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
        rotate(a.rotate, b.rotate, s, q);
        skewX(a.skewX, b.skewX, s, q);
        scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
        a = b = null; // gc
        return function(t) {
            var i = -1, n = q.length, o;
            while(++i < n)s[(o = q[i]).i] = o.x(t);
            return s.join("");
        };
    };
}
var interpolateTransformCss = exports.interpolateTransformCss = interpolateTransform(_parse.parseCss, "px, ", "px)", "deg)");
var interpolateTransformSvg = exports.interpolateTransformSvg = interpolateTransform(_parse.parseSvg, ", ", ")", ")");

},{"3e2d37e598810190":"kgyAE","4b3d6acbd4a3c21a":"bMbmU"}],"bMbmU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseCss = parseCss;
exports.parseSvg = parseSvg;
var _decompose = _interopRequireWildcard(require("6801e9b7b9a8c06f"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var svgNode;
/* eslint-disable no-undef */ function parseCss(value) {
    const m = new (typeof DOMMatrix === "function" ? DOMMatrix : WebKitCSSMatrix)(value + "");
    return m.isIdentity ? _decompose.identity : (0, _decompose.default)(m.a, m.b, m.c, m.d, m.e, m.f);
}
function parseSvg(value) {
    if (value == null) return _decompose.identity;
    if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
    svgNode.setAttribute("transform", value);
    if (!(value = svgNode.transform.baseVal.consolidate())) return _decompose.identity;
    value = value.matrix;
    return (0, _decompose.default)(value.a, value.b, value.c, value.d, value.e, value.f);
}

},{"6801e9b7b9a8c06f":"wMGNr"}],"wMGNr":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.identity = void 0;
var degrees = 180 / Math.PI;
var identity = exports.identity = {
    translateX: 0,
    translateY: 0,
    rotate: 0,
    skewX: 0,
    scaleX: 1,
    scaleY: 1
};
function _default(a, b, c, d, e, f) {
    var scaleX, scaleY, skewX;
    if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
    if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
    if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
    if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
    return {
        translateX: e,
        translateY: f,
        rotate: Math.atan2(b, a) * degrees,
        skewX: Math.atan(skewX) * degrees,
        scaleX: scaleX,
        scaleY: scaleY
    };
}

},{}],"8lKxi":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var epsilon2 = 1e-12;
function cosh(x) {
    return ((x = Math.exp(x)) + 1 / x) / 2;
}
function sinh(x) {
    return ((x = Math.exp(x)) - 1 / x) / 2;
}
function tanh(x) {
    return ((x = Math.exp(2 * x)) - 1) / (x + 1);
}
var _default = exports.default = function zoomRho(rho, rho2, rho4) {
    // p0 = [ux0, uy0, w0]
    // p1 = [ux1, uy1, w1]
    function zoom(p0, p1) {
        var ux0 = p0[0], uy0 = p0[1], w0 = p0[2], ux1 = p1[0], uy1 = p1[1], w1 = p1[2], dx = ux1 - ux0, dy = uy1 - uy0, d2 = dx * dx + dy * dy, i, S;
        // Special case for u0 ≅ u1.
        if (d2 < epsilon2) {
            S = Math.log(w1 / w0) / rho;
            i = function(t) {
                return [
                    ux0 + t * dx,
                    uy0 + t * dy,
                    w0 * Math.exp(rho * t * S)
                ];
            };
        } else {
            var d1 = Math.sqrt(d2), b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1), b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1), r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0), r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
            S = (r1 - r0) / rho;
            i = function(t) {
                var s = t * S, coshr0 = cosh(r0), u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
                return [
                    ux0 + u * dx,
                    uy0 + u * dy,
                    w0 * coshr0 / cosh(rho * s + r0)
                ];
            };
        }
        i.duration = S * 1000 * rho / Math.SQRT2;
        return i;
    }
    zoom.rho = function(_) {
        var _1 = Math.max(1e-3, +_), _2 = _1 * _1, _4 = _2 * _2;
        return zoomRho(_1, _2, _4);
    };
    return zoom;
}(Math.SQRT2, 2, 4);

},{}],"189BK":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hslLong = exports.default = void 0;
var _index = require("8527dae26181d5cf");
var _color = _interopRequireWildcard(require("45faacac073e112a"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function hsl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _index.hsl)(start)).h, (end = (0, _index.hsl)(end)).h), s = (0, _color.default)(start.s, end.s), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.s = s(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var _default = exports.default = hsl(_color.hue);
var hslLong = exports.hslLong = hsl(_color.default);

},{"8527dae26181d5cf":"j7NEC","45faacac073e112a":"bwUhJ"}],"5Rc4l":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = lab;
var _index = require("bb962b0e100409c3");
var _color = _interopRequireDefault(require("39c4c5a5fff46e6a"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function lab(start, end) {
    var l = (0, _color.default)((start = (0, _index.lab)(start)).l, (end = (0, _index.lab)(end)).l), a = (0, _color.default)(start.a, end.a), b = (0, _color.default)(start.b, end.b), opacity = (0, _color.default)(start.opacity, end.opacity);
    return function(t) {
        start.l = l(t);
        start.a = a(t);
        start.b = b(t);
        start.opacity = opacity(t);
        return start + "";
    };
}

},{"bb962b0e100409c3":"j7NEC","39c4c5a5fff46e6a":"bwUhJ"}],"fNLV7":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hclLong = exports.default = void 0;
var _index = require("5dab9e1ee5c5ab5d");
var _color = _interopRequireWildcard(require("4a63660e3a72d4d2"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function hcl(hue) {
    return function(start, end) {
        var h = hue((start = (0, _index.hcl)(start)).h, (end = (0, _index.hcl)(end)).h), c = (0, _color.default)(start.c, end.c), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
        return function(t) {
            start.h = h(t);
            start.c = c(t);
            start.l = l(t);
            start.opacity = opacity(t);
            return start + "";
        };
    };
}
var _default = exports.default = hcl(_color.hue);
var hclLong = exports.hclLong = hcl(_color.default);

},{"5dab9e1ee5c5ab5d":"j7NEC","4a63660e3a72d4d2":"bwUhJ"}],"5S5ro":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.cubehelixLong = void 0;
var _index = require("981aef0afb354b0c");
var _color = _interopRequireWildcard(require("f9336ad633bd893d"));
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function cubehelix(hue) {
    return function cubehelixGamma(y) {
        y = +y;
        function cubehelix(start, end) {
            var h = hue((start = (0, _index.cubehelix)(start)).h, (end = (0, _index.cubehelix)(end)).h), s = (0, _color.default)(start.s, end.s), l = (0, _color.default)(start.l, end.l), opacity = (0, _color.default)(start.opacity, end.opacity);
            return function(t) {
                start.h = h(t);
                start.s = s(t);
                start.l = l(Math.pow(t, y));
                start.opacity = opacity(t);
                return start + "";
            };
        }
        cubehelix.gamma = cubehelixGamma;
        return cubehelix;
    }(1);
}
var _default = exports.default = cubehelix(_color.hue);
var cubehelixLong = exports.cubehelixLong = cubehelix(_color.default);

},{"981aef0afb354b0c":"j7NEC","f9336ad633bd893d":"bwUhJ"}],"6eoZ5":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = piecewise;
var _value = _interopRequireDefault(require("5c06b65a4f09269b"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function piecewise(interpolate, values) {
    if (values === undefined) values = interpolate, interpolate = _value.default;
    var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
    while(i < n)I[i] = interpolate(v, v = values[++i]);
    return function(t) {
        var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
        return I[i](t - i);
    };
}

},{"5c06b65a4f09269b":"dLkyW"}],"bn5P3":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(interpolator, n) {
    var samples = new Array(n);
    for(var i = 0; i < n; ++i)samples[i] = interpolator(i / (n - 1));
    return samples;
}

},{}],"aDM3c":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = constants;
function constants(x) {
    return function() {
        return x;
    };
}

},{}],"fbqLJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = number;
function number(x) {
    return +x;
}

},{}],"kZcrG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = tickFormat;
var _index = require("a4043605242eb496");
var _index2 = require("8da1e3e06f47624b");
function tickFormat(start, stop, count, specifier) {
    var step = (0, _index.tickStep)(start, stop, count), precision;
    specifier = (0, _index2.formatSpecifier)(specifier == null ? ",f" : specifier);
    switch(specifier.type){
        case "s":
            var value = Math.max(Math.abs(start), Math.abs(stop));
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionPrefix)(step, value))) specifier.precision = precision;
            return (0, _index2.formatPrefix)(specifier, value);
        case "":
        case "e":
        case "g":
        case "p":
        case "r":
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionRound)(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
            break;
        case "f":
        case "%":
            if (specifier.precision == null && !isNaN(precision = (0, _index2.precisionFixed)(step))) specifier.precision = precision - (specifier.type === "%") * 2;
            break;
    }
    return (0, _index2.format)(specifier);
}

},{"a4043605242eb496":"3WmRx","8da1e3e06f47624b":"lmET6"}],"lmET6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormatSpecifier", {
    enumerable: true,
    get: function() {
        return _formatSpecifier.FormatSpecifier;
    }
});
Object.defineProperty(exports, "format", {
    enumerable: true,
    get: function() {
        return _defaultLocale.format;
    }
});
Object.defineProperty(exports, "formatDefaultLocale", {
    enumerable: true,
    get: function() {
        return _defaultLocale.default;
    }
});
Object.defineProperty(exports, "formatLocale", {
    enumerable: true,
    get: function() {
        return _locale.default;
    }
});
Object.defineProperty(exports, "formatPrefix", {
    enumerable: true,
    get: function() {
        return _defaultLocale.formatPrefix;
    }
});
Object.defineProperty(exports, "formatSpecifier", {
    enumerable: true,
    get: function() {
        return _formatSpecifier.default;
    }
});
Object.defineProperty(exports, "precisionFixed", {
    enumerable: true,
    get: function() {
        return _precisionFixed.default;
    }
});
Object.defineProperty(exports, "precisionPrefix", {
    enumerable: true,
    get: function() {
        return _precisionPrefix.default;
    }
});
Object.defineProperty(exports, "precisionRound", {
    enumerable: true,
    get: function() {
        return _precisionRound.default;
    }
});
var _defaultLocale = _interopRequireWildcard(require("2ee0c7b1a22e44e6"));
var _locale = _interopRequireDefault(require("ff358412e51164cd"));
var _formatSpecifier = _interopRequireWildcard(require("60d6396182b4fde8"));
var _precisionFixed = _interopRequireDefault(require("792b165b9b0bcf2d"));
var _precisionPrefix = _interopRequireDefault(require("f2702d774fe2085c"));
var _precisionRound = _interopRequireDefault(require("492f493218059efd"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

},{"2ee0c7b1a22e44e6":"7sRrh","ff358412e51164cd":"dCQ3d","60d6396182b4fde8":"lzvJZ","792b165b9b0bcf2d":"5Gs9u","f2702d774fe2085c":"14dfX","492f493218059efd":"1R2bO"}],"7sRrh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defaultLocale;
exports.formatPrefix = exports.format = void 0;
var _locale = _interopRequireDefault(require("317c67875ded3d99"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var locale;
var format;
var formatPrefix;
defaultLocale({
    thousands: ",",
    grouping: [
        3
    ],
    currency: [
        "$",
        ""
    ]
});
function defaultLocale(definition) {
    locale = (0, _locale.default)(definition);
    exports.format = format = locale.format;
    exports.formatPrefix = formatPrefix = locale.formatPrefix;
    return locale;
}

},{"317c67875ded3d99":"dCQ3d"}],"dCQ3d":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("f55671e2db2b86ef"));
var _formatGroup = _interopRequireDefault(require("e366a511ee4b4f2f"));
var _formatNumerals = _interopRequireDefault(require("86155372ae3c6f7e"));
var _formatSpecifier = _interopRequireDefault(require("1b6c7d0076b09661"));
var _formatTrim = _interopRequireDefault(require("8fea1479564cd384"));
var _formatTypes = _interopRequireDefault(require("8cc741dcfb99dfd9"));
var _formatPrefixAuto = require("10cbdd8f7ac88548");
var _identity = _interopRequireDefault(require("efeab53251079183"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var map = Array.prototype.map, prefixes = [
    "y",
    "z",
    "a",
    "f",
    "p",
    "n",
    "\xb5",
    "m",
    "",
    "k",
    "M",
    "G",
    "T",
    "P",
    "E",
    "Z",
    "Y"
];
function _default(locale) {
    var group = locale.grouping === undefined || locale.thousands === undefined ? _identity.default : (0, _formatGroup.default)(map.call(locale.grouping, Number), locale.thousands + ""), currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "", currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "", decimal = locale.decimal === undefined ? "." : locale.decimal + "", numerals = locale.numerals === undefined ? _identity.default : (0, _formatNumerals.default)(map.call(locale.numerals, String)), percent = locale.percent === undefined ? "%" : locale.percent + "", minus = locale.minus === undefined ? "\u2212" : locale.minus + "", nan = locale.nan === undefined ? "NaN" : locale.nan + "";
    function newFormat(specifier) {
        specifier = (0, _formatSpecifier.default)(specifier);
        var fill = specifier.fill, align = specifier.align, sign = specifier.sign, symbol = specifier.symbol, zero = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim = specifier.trim, type = specifier.type;
        // The "n" type is an alias for ",g".
        if (type === "n") comma = true, type = "g";
        else if (!_formatTypes.default[type]) precision === undefined && (precision = 12), trim = true, type = "g";
        // If zero fill is specified, padding goes after sign and before digits.
        if (zero || fill === "0" && align === "=") zero = true, fill = "0", align = "=";
        // Compute the prefix and suffix.
        // For SI-prefix, the suffix is lazily computed.
        var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
        // What format function should we use?
        // Is this an integer type?
        // Can this type generate exponential notation?
        var formatType = _formatTypes.default[type], maybeSuffix = /[defgprs%]/.test(type);
        // Set the default precision if not specified,
        // or clamp the specified precision to the supported range.
        // For significant precision, it must be in [1, 21].
        // For fixed precision, it must be in [0, 20].
        precision = precision === undefined ? 6 : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
        function format(value) {
            var valuePrefix = prefix, valueSuffix = suffix, i, n, c;
            if (type === "c") {
                valueSuffix = formatType(value) + valueSuffix;
                value = "";
            } else {
                value = +value;
                // Determine the sign. -0 is not less than 0, but 1 / -0 is!
                var valueNegative = value < 0 || 1 / value < 0;
                // Perform the initial formatting.
                value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
                // Trim insignificant zeros.
                if (trim) value = (0, _formatTrim.default)(value);
                // If a negative value rounds to zero after formatting, and no explicit positive sign is requested, hide the sign.
                if (valueNegative && +value === 0 && sign !== "+") valueNegative = false;
                // Compute the prefix and suffix.
                valuePrefix = (valueNegative ? sign === "(" ? sign : minus : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
                valueSuffix = (type === "s" ? prefixes[8 + _formatPrefixAuto.prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
                // Break the formatted value into the integer “value” part that can be
                // grouped, and fractional or exponential “suffix” part that is not.
                if (maybeSuffix) {
                    i = -1, n = value.length;
                    while(++i < n)if (c = value.charCodeAt(i), 48 > c || c > 57) {
                        valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
                        value = value.slice(0, i);
                        break;
                    }
                }
            }
            // If the fill character is not "0", grouping is applied before padding.
            if (comma && !zero) value = group(value, Infinity);
            // Compute the padding.
            var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
            // If the fill character is "0", grouping is applied after padding.
            if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
            // Reconstruct the final output based on the desired alignment.
            switch(align){
                case "<":
                    value = valuePrefix + value + valueSuffix + padding;
                    break;
                case "=":
                    value = valuePrefix + padding + value + valueSuffix;
                    break;
                case "^":
                    value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
                    break;
                default:
                    value = padding + valuePrefix + value + valueSuffix;
                    break;
            }
            return numerals(value);
        }
        format.toString = function() {
            return specifier + "";
        };
        return format;
    }
    function formatPrefix(specifier, value) {
        var f = newFormat((specifier = (0, _formatSpecifier.default)(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor((0, _exponent.default)(value) / 3))) * 3, k = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
        return function(value) {
            return f(k * value) + prefix;
        };
    }
    return {
        format: newFormat,
        formatPrefix: formatPrefix
    };
}

},{"f55671e2db2b86ef":"ewpsP","e366a511ee4b4f2f":"g7uxL","86155372ae3c6f7e":"aT22S","1b6c7d0076b09661":"lzvJZ","8fea1479564cd384":"6HXQQ","8cc741dcfb99dfd9":"hxUqM","10cbdd8f7ac88548":"aABIy","efeab53251079183":"kUzbj"}],"ewpsP":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _formatDecimal = require("bc7d6f0e0b7ad989");
function _default(x) {
    return x = (0, _formatDecimal.formatDecimalParts)(Math.abs(x)), x ? x[1] : NaN;
}

},{"bc7d6f0e0b7ad989":"6KL4o"}],"6KL4o":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.formatDecimalParts = formatDecimalParts;
function _default(x) {
    return Math.abs(x = Math.round(x)) >= 1e21 ? x.toLocaleString("en").replace(/,/g, "") : x.toString(10);
}
// Computes the decimal coefficient and exponent of the specified number x with
// significant digits p, where x is positive and p is in [1, 21] or undefined.
// For example, formatDecimalParts(1.23) returns ["123", 0].
function formatDecimalParts(x, p) {
    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
    var i, coefficient = x.slice(0, i);
    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
    return [
        coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
        +x.slice(i + 1)
    ];
}

},{}],"g7uxL":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(grouping, thousands) {
    return function(value, width) {
        var i = value.length, t = [], j = 0, g = grouping[0], length = 0;
        while(i > 0 && g > 0){
            if (length + g + 1 > width) g = Math.max(1, width - length);
            t.push(value.substring(i -= g, i + g));
            if ((length += g + 1) > width) break;
            g = grouping[j = (j + 1) % grouping.length];
        }
        return t.reverse().join(thousands);
    };
}

},{}],"aT22S":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(numerals) {
    return function(value) {
        return value.replace(/[0-9]/g, function(i) {
            return numerals[+i];
        });
    };
}

},{}],"lzvJZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormatSpecifier = FormatSpecifier;
exports.default = formatSpecifier;
// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
    var match;
    return new FormatSpecifier({
        fill: match[1],
        align: match[2],
        sign: match[3],
        symbol: match[4],
        zero: match[5],
        width: match[6],
        comma: match[7],
        precision: match[8] && match[8].slice(1),
        trim: match[9],
        type: match[10]
    });
}
formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
function FormatSpecifier(specifier) {
    this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
    this.align = specifier.align === undefined ? ">" : specifier.align + "";
    this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
    this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
    this.zero = !!specifier.zero;
    this.width = specifier.width === undefined ? undefined : +specifier.width;
    this.comma = !!specifier.comma;
    this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
    this.trim = !!specifier.trim;
    this.type = specifier.type === undefined ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
    return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === undefined ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};

},{}],"6HXQQ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
function _default(s) {
    out: for(var n = s.length, i = 1, i0 = -1, i1; i < n; ++i)switch(s[i]){
        case ".":
            i0 = i1 = i;
            break;
        case "0":
            if (i0 === 0) i0 = i;
            i1 = i;
            break;
        default:
            if (!+s[i]) break out;
            if (i0 > 0) i0 = 0;
            break;
    }
    return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}

},{}],"hxUqM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _formatDecimal = _interopRequireDefault(require("feafbe2a554fb639"));
var _formatPrefixAuto = _interopRequireDefault(require("8d1082b790377352"));
var _formatRounded = _interopRequireDefault(require("35a9fc35835a2a14"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var _default = exports.default = {
    "%": (x, p)=>(x * 100).toFixed(p),
    "b": (x)=>Math.round(x).toString(2),
    "c": (x)=>x + "",
    "d": _formatDecimal.default,
    "e": (x, p)=>x.toExponential(p),
    "f": (x, p)=>x.toFixed(p),
    "g": (x, p)=>x.toPrecision(p),
    "o": (x)=>Math.round(x).toString(8),
    "p": (x, p)=>(0, _formatRounded.default)(x * 100, p),
    "r": _formatRounded.default,
    "s": _formatPrefixAuto.default,
    "X": (x)=>Math.round(x).toString(16).toUpperCase(),
    "x": (x)=>Math.round(x).toString(16)
};

},{"feafbe2a554fb639":"6KL4o","8d1082b790377352":"aABIy","35a9fc35835a2a14":"lSKCk"}],"aABIy":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
exports.prefixExponent = void 0;
var _formatDecimal = require("c968343e236e1eff");
var prefixExponent;
function _default(x, p) {
    var d = (0, _formatDecimal.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1], i = exponent - (exports.prefixExponent = prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1, n = coefficient.length;
    return i === n ? coefficient : i > n ? coefficient + new Array(i - n + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + (0, _formatDecimal.formatDecimalParts)(x, Math.max(0, p + i - 1))[0]; // less than 1y!
}

},{"c968343e236e1eff":"6KL4o"}],"lSKCk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _formatDecimal = require("8a356ace3ecb0657");
function _default(x, p) {
    var d = (0, _formatDecimal.formatDecimalParts)(x, p);
    if (!d) return x + "";
    var coefficient = d[0], exponent = d[1];
    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1) : coefficient + new Array(exponent - coefficient.length + 2).join("0");
}

},{"8a356ace3ecb0657":"6KL4o"}],"kUzbj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
function _default(x) {
    return x;
}

},{}],"5Gs9u":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("10ac7ec4cef9eac2"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step) {
    return Math.max(0, -(0, _exponent.default)(Math.abs(step)));
}

},{"10ac7ec4cef9eac2":"ewpsP"}],"14dfX":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("a74b6430297cf90d"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step, value) {
    return Math.max(0, Math.max(-8, Math.min(8, Math.floor((0, _exponent.default)(value) / 3))) * 3 - (0, _exponent.default)(Math.abs(step)));
}

},{"a74b6430297cf90d":"ewpsP"}],"1R2bO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = _default;
var _exponent = _interopRequireDefault(require("152cf0fffe5db4dc"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _default(step, max) {
    step = Math.abs(step), max = Math.abs(max) - step;
    return Math.max(0, (0, _exponent.default)(max) - (0, _exponent.default)(step)) + 1;
}

},{"152cf0fffe5db4dc":"ewpsP"}],"b2mDf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = log;
exports.loggish = loggish;
var _index = require("c2225ae6830156cb");
var _index2 = require("9fe16242a20f801");
var _nice = _interopRequireDefault(require("e1f7cd4bad5fecf5"));
var _continuous = require("cdd2320c22aee987");
var _init = require("54c81c620622cc22");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function transformLog(x) {
    return Math.log(x);
}
function transformExp(x) {
    return Math.exp(x);
}
function transformLogn(x) {
    return -Math.log(-x);
}
function transformExpn(x) {
    return -Math.exp(-x);
}
function pow10(x) {
    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
}
function powp(base) {
    return base === 10 ? pow10 : base === Math.E ? Math.exp : (x)=>Math.pow(base, x);
}
function logp(base) {
    return base === Math.E ? Math.log : base === 10 && Math.log10 || base === 2 && Math.log2 || (base = Math.log(base), (x)=>Math.log(x) / base);
}
function reflect(f) {
    return (x, k)=>-f(-x, k);
}
function loggish(transform) {
    const scale = transform(transformLog, transformExp);
    const domain = scale.domain;
    let base = 10;
    let logs;
    let pows;
    function rescale() {
        logs = logp(base), pows = powp(base);
        if (domain()[0] < 0) {
            logs = reflect(logs), pows = reflect(pows);
            transform(transformLogn, transformExpn);
        } else transform(transformLog, transformExp);
        return scale;
    }
    scale.base = function(_) {
        return arguments.length ? (base = +_, rescale()) : base;
    };
    scale.domain = function(_) {
        return arguments.length ? (domain(_), rescale()) : domain();
    };
    scale.ticks = (count)=>{
        const d = domain();
        let u = d[0];
        let v = d[d.length - 1];
        const r = v < u;
        if (r) [u, v] = [
            v,
            u
        ];
        let i = logs(u);
        let j = logs(v);
        let k;
        let t;
        const n = count == null ? 10 : +count;
        let z = [];
        if (!(base % 1) && j - i < n) {
            i = Math.floor(i), j = Math.ceil(j);
            if (u > 0) for(; i <= j; ++i)for(k = 1; k < base; ++k){
                t = i < 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            else for(; i <= j; ++i)for(k = base - 1; k >= 1; --k){
                t = i > 0 ? k / pows(-i) : k * pows(i);
                if (t < u) continue;
                if (t > v) break;
                z.push(t);
            }
            if (z.length * 2 < n) z = (0, _index.ticks)(u, v, n);
        } else z = (0, _index.ticks)(i, j, Math.min(j - i, n)).map(pows);
        return r ? z.reverse() : z;
    };
    scale.tickFormat = (count, specifier)=>{
        if (count == null) count = 10;
        if (specifier == null) specifier = base === 10 ? "s" : ",";
        if (typeof specifier !== "function") {
            if (!(base % 1) && (specifier = (0, _index2.formatSpecifier)(specifier)).precision == null) specifier.trim = true;
            specifier = (0, _index2.format)(specifier);
        }
        if (count === Infinity) return specifier;
        const k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
        return (d)=>{
            let i = d / pows(Math.round(logs(d)));
            if (i * base < base - 0.5) i *= base;
            return i <= k ? specifier(d) : "";
        };
    };
    scale.nice = ()=>{
        return domain((0, _nice.default)(domain(), {
            floor: (x)=>pows(Math.floor(logs(x))),
            ceil: (x)=>pows(Math.ceil(logs(x)))
        }));
    };
    return scale;
}
function log() {
    const scale = loggish((0, _continuous.transformer)()).domain([
        1,
        10
    ]);
    scale.copy = ()=>(0, _continuous.copy)(scale, log()).base(scale.base());
    _init.initRange.apply(scale, arguments);
    return scale;
}

},{"c2225ae6830156cb":"3WmRx","9fe16242a20f801":"lmET6","e1f7cd4bad5fecf5":"9q94Z","cdd2320c22aee987":"9w8kD","54c81c620622cc22":"9c0mi"}],"9q94Z":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = nice;
function nice(domain, interval) {
    domain = domain.slice();
    var i0 = 0, i1 = domain.length - 1, x0 = domain[i0], x1 = domain[i1], t;
    if (x1 < x0) {
        t = i0, i0 = i1, i1 = t;
        t = x0, x0 = x1, x1 = t;
    }
    domain[i0] = interval.floor(x0);
    domain[i1] = interval.ceil(x1);
    return domain;
}

},{}],"hnxTj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = symlog;
exports.symlogish = symlogish;
var _linear = require("6b7bc111d415c072");
var _continuous = require("f781e5664611d9c0");
var _init = require("499d293100f0413a");
function transformSymlog(c) {
    return function(x) {
        return Math.sign(x) * Math.log1p(Math.abs(x / c));
    };
}
function transformSymexp(c) {
    return function(x) {
        return Math.sign(x) * Math.expm1(Math.abs(x)) * c;
    };
}
function symlogish(transform) {
    var c = 1, scale = transform(transformSymlog(c), transformSymexp(c));
    scale.constant = function(_) {
        return arguments.length ? transform(transformSymlog(c = +_), transformSymexp(c)) : c;
    };
    return (0, _linear.linearish)(scale);
}
function symlog() {
    var scale = symlogish((0, _continuous.transformer)());
    scale.copy = function() {
        return (0, _continuous.copy)(scale, symlog()).constant(scale.constant());
    };
    return _init.initRange.apply(scale, arguments);
}

},{"6b7bc111d415c072":"7wwWf","f781e5664611d9c0":"9w8kD","499d293100f0413a":"9c0mi"}],"7qYxn":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = pow;
exports.powish = powish;
exports.sqrt = sqrt;
var _linear = require("94b90569504e034e");
var _continuous = require("6297cca891d63c37");
var _init = require("1b7874ad495edb4c");
function transformPow(exponent) {
    return function(x) {
        return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
    };
}
function transformSqrt(x) {
    return x < 0 ? -Math.sqrt(-x) : Math.sqrt(x);
}
function transformSquare(x) {
    return x < 0 ? -x * x : x * x;
}
function powish(transform) {
    var scale = transform(_continuous.identity, _continuous.identity), exponent = 1;
    function rescale() {
        return exponent === 1 ? transform(_continuous.identity, _continuous.identity) : exponent === 0.5 ? transform(transformSqrt, transformSquare) : transform(transformPow(exponent), transformPow(1 / exponent));
    }
    scale.exponent = function(_) {
        return arguments.length ? (exponent = +_, rescale()) : exponent;
    };
    return (0, _linear.linearish)(scale);
}
function pow() {
    var scale = powish((0, _continuous.transformer)());
    scale.copy = function() {
        return (0, _continuous.copy)(scale, pow()).exponent(scale.exponent());
    };
    _init.initRange.apply(scale, arguments);
    return scale;
}
function sqrt() {
    return pow.apply(null, arguments).exponent(0.5);
}

},{"94b90569504e034e":"7wwWf","6297cca891d63c37":"9w8kD","1b7874ad495edb4c":"9c0mi"}],"8wQBJ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = radial;
var _continuous = _interopRequireDefault(require("9cc3a5098e156c85"));
var _init = require("116f55aac82ec8e9");
var _linear = require("b2719a0a78ca2805");
var _number = _interopRequireDefault(require("aa73717e632c4a05"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function square(x) {
    return Math.sign(x) * x * x;
}
function unsquare(x) {
    return Math.sign(x) * Math.sqrt(Math.abs(x));
}
function radial() {
    var squared = (0, _continuous.default)(), range = [
        0,
        1
    ], round = false, unknown;
    function scale(x) {
        var y = unsquare(squared(x));
        return isNaN(y) ? unknown : round ? Math.round(y) : y;
    }
    scale.invert = function(y) {
        return squared.invert(square(y));
    };
    scale.domain = function(_) {
        return arguments.length ? (squared.domain(_), scale) : squared.domain();
    };
    scale.range = function(_) {
        return arguments.length ? (squared.range((range = Array.from(_, _number.default)).map(square)), scale) : range.slice();
    };
    scale.rangeRound = function(_) {
        return scale.range(_).round(true);
    };
    scale.round = function(_) {
        return arguments.length ? (round = !!_, scale) : round;
    };
    scale.clamp = function(_) {
        return arguments.length ? (squared.clamp(_), scale) : squared.clamp();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return radial(squared.domain(), range).round(round).clamp(squared.clamp()).unknown(unknown);
    };
    _init.initRange.apply(scale, arguments);
    return (0, _linear.linearish)(scale);
}

},{"9cc3a5098e156c85":"9w8kD","116f55aac82ec8e9":"9c0mi","b2719a0a78ca2805":"7wwWf","aa73717e632c4a05":"fbqLJ"}],"4zGak":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantile;
var _index = require("1587656407247c17");
var _init = require("e93efb9761f1f003");
function quantile() {
    var domain = [], range = [], thresholds = [], unknown;
    function rescale() {
        var i = 0, n = Math.max(1, range.length);
        thresholds = new Array(n - 1);
        while(++i < n)thresholds[i - 1] = (0, _index.quantileSorted)(domain, i / n);
        return scale;
    }
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : range[(0, _index.bisect)(thresholds, x)];
    }
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : [
            i > 0 ? thresholds[i - 1] : domain[0],
            i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
        ];
    };
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort(_index.ascending);
        return rescale();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), rescale()) : range.slice();
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.quantiles = function() {
        return thresholds.slice();
    };
    scale.copy = function() {
        return quantile().domain(domain).range(range).unknown(unknown);
    };
    return _init.initRange.apply(scale, arguments);
}

},{"1587656407247c17":"3WmRx","e93efb9761f1f003":"9c0mi"}],"ev1uM":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = quantize;
var _index = require("61f3ae9aeeace72a");
var _linear = require("19f450ffb9fe0ee8");
var _init = require("97a4ee1bb0f33f6b");
function quantize() {
    var x0 = 0, x1 = 1, n = 1, domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown;
    function scale(x) {
        return x != null && x <= x ? range[(0, _index.bisect)(domain, x, 0, n)] : unknown;
    }
    function rescale() {
        var i = -1;
        domain = new Array(n);
        while(++i < n)domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
        return scale;
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, x0 = +x0, x1 = +x1, rescale()) : [
            x0,
            x1
        ];
    };
    scale.range = function(_) {
        return arguments.length ? (n = (range = Array.from(_)).length - 1, rescale()) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return i < 0 ? [
            NaN,
            NaN
        ] : i < 1 ? [
            x0,
            domain[0]
        ] : i >= n ? [
            domain[n - 1],
            x1
        ] : [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : scale;
    };
    scale.thresholds = function() {
        return domain.slice();
    };
    scale.copy = function() {
        return quantize().domain([
            x0,
            x1
        ]).range(range).unknown(unknown);
    };
    return _init.initRange.apply((0, _linear.linearish)(scale), arguments);
}

},{"61f3ae9aeeace72a":"3WmRx","19f450ffb9fe0ee8":"7wwWf","97a4ee1bb0f33f6b":"9c0mi"}],"bJUxs":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = threshold;
var _index = require("4b6954aba910b52b");
var _init = require("5769040792c8fbdc");
function threshold() {
    var domain = [
        0.5
    ], range = [
        0,
        1
    ], unknown, n = 1;
    function scale(x) {
        return x != null && x <= x ? range[(0, _index.bisect)(domain, x, 0, n)] : unknown;
    }
    scale.domain = function(_) {
        return arguments.length ? (domain = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
    };
    scale.range = function(_) {
        return arguments.length ? (range = Array.from(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
    };
    scale.invertExtent = function(y) {
        var i = range.indexOf(y);
        return [
            domain[i - 1],
            domain[i]
        ];
    };
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    scale.copy = function() {
        return threshold().domain(domain).range(range).unknown(unknown);
    };
    return _init.initRange.apply(scale, arguments);
}

},{"4b6954aba910b52b":"3WmRx","5769040792c8fbdc":"9c0mi"}],"iry3Y":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.calendar = calendar;
exports.default = time;
var _index = require("d6f26b6733e27d9f");
var _index2 = require("2c6c21fb5fc82ed8");
var _continuous = _interopRequireWildcard(require("33f8922a5dd4a530"));
var _init = require("2234a07f2ca64e26");
var _nice = _interopRequireDefault(require("c7d75e934f92c19f"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function date(t) {
    return new Date(t);
}
function number(t) {
    return t instanceof Date ? +t : +new Date(+t);
}
function calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format) {
    var scale = (0, _continuous.default)(), invert = scale.invert, domain = scale.domain;
    var formatMillisecond = format(".%L"), formatSecond = format(":%S"), formatMinute = format("%I:%M"), formatHour = format("%I %p"), formatDay = format("%a %d"), formatWeek = format("%b %d"), formatMonth = format("%B"), formatYear = format("%Y");
    function tickFormat(date) {
        return (second(date) < date ? formatMillisecond : minute(date) < date ? formatSecond : hour(date) < date ? formatMinute : day(date) < date ? formatHour : month(date) < date ? week(date) < date ? formatDay : formatWeek : year(date) < date ? formatMonth : formatYear)(date);
    }
    scale.invert = function(y) {
        return new Date(invert(y));
    };
    scale.domain = function(_) {
        return arguments.length ? domain(Array.from(_, number)) : domain().map(date);
    };
    scale.ticks = function(interval) {
        var d = domain();
        return ticks(d[0], d[d.length - 1], interval == null ? 10 : interval);
    };
    scale.tickFormat = function(count, specifier) {
        return specifier == null ? tickFormat : format(specifier);
    };
    scale.nice = function(interval) {
        var d = domain();
        if (!interval || typeof interval.range !== "function") interval = tickInterval(d[0], d[d.length - 1], interval == null ? 10 : interval);
        return interval ? domain((0, _nice.default)(d, interval)) : scale;
    };
    scale.copy = function() {
        return (0, _continuous.copy)(scale, calendar(ticks, tickInterval, year, month, week, day, hour, minute, second, format));
    };
    return scale;
}
function time() {
    return _init.initRange.apply(calendar(_index.timeTicks, _index.timeTickInterval, _index.timeYear, _index.timeMonth, _index.timeWeek, _index.timeDay, _index.timeHour, _index.timeMinute, _index.timeSecond, _index2.timeFormat).domain([
        new Date(2000, 0, 1),
        new Date(2000, 0, 2)
    ]), arguments);
}

},{"d6f26b6733e27d9f":"47yDh","2c6c21fb5fc82ed8":"6bc60","33f8922a5dd4a530":"9w8kD","2234a07f2ca64e26":"9c0mi","c7d75e934f92c19f":"9q94Z"}],"47yDh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "timeDay", {
    enumerable: true,
    get: function() {
        return _day.default;
    }
});
Object.defineProperty(exports, "timeDays", {
    enumerable: true,
    get: function() {
        return _day.days;
    }
});
Object.defineProperty(exports, "timeFriday", {
    enumerable: true,
    get: function() {
        return _week.friday;
    }
});
Object.defineProperty(exports, "timeFridays", {
    enumerable: true,
    get: function() {
        return _week.fridays;
    }
});
Object.defineProperty(exports, "timeHour", {
    enumerable: true,
    get: function() {
        return _hour.default;
    }
});
Object.defineProperty(exports, "timeHours", {
    enumerable: true,
    get: function() {
        return _hour.hours;
    }
});
Object.defineProperty(exports, "timeInterval", {
    enumerable: true,
    get: function() {
        return _interval.default;
    }
});
Object.defineProperty(exports, "timeMillisecond", {
    enumerable: true,
    get: function() {
        return _millisecond.default;
    }
});
Object.defineProperty(exports, "timeMilliseconds", {
    enumerable: true,
    get: function() {
        return _millisecond.milliseconds;
    }
});
Object.defineProperty(exports, "timeMinute", {
    enumerable: true,
    get: function() {
        return _minute.default;
    }
});
Object.defineProperty(exports, "timeMinutes", {
    enumerable: true,
    get: function() {
        return _minute.minutes;
    }
});
Object.defineProperty(exports, "timeMonday", {
    enumerable: true,
    get: function() {
        return _week.monday;
    }
});
Object.defineProperty(exports, "timeMondays", {
    enumerable: true,
    get: function() {
        return _week.mondays;
    }
});
Object.defineProperty(exports, "timeMonth", {
    enumerable: true,
    get: function() {
        return _month.default;
    }
});
Object.defineProperty(exports, "timeMonths", {
    enumerable: true,
    get: function() {
        return _month.months;
    }
});
Object.defineProperty(exports, "timeSaturday", {
    enumerable: true,
    get: function() {
        return _week.saturday;
    }
});
Object.defineProperty(exports, "timeSaturdays", {
    enumerable: true,
    get: function() {
        return _week.saturdays;
    }
});
Object.defineProperty(exports, "timeSecond", {
    enumerable: true,
    get: function() {
        return _second.default;
    }
});
Object.defineProperty(exports, "timeSeconds", {
    enumerable: true,
    get: function() {
        return _second.seconds;
    }
});
Object.defineProperty(exports, "timeSunday", {
    enumerable: true,
    get: function() {
        return _week.sunday;
    }
});
Object.defineProperty(exports, "timeSundays", {
    enumerable: true,
    get: function() {
        return _week.sundays;
    }
});
Object.defineProperty(exports, "timeThursday", {
    enumerable: true,
    get: function() {
        return _week.thursday;
    }
});
Object.defineProperty(exports, "timeThursdays", {
    enumerable: true,
    get: function() {
        return _week.thursdays;
    }
});
Object.defineProperty(exports, "timeTickInterval", {
    enumerable: true,
    get: function() {
        return _ticks.timeTickInterval;
    }
});
Object.defineProperty(exports, "timeTicks", {
    enumerable: true,
    get: function() {
        return _ticks.timeTicks;
    }
});
Object.defineProperty(exports, "timeTuesday", {
    enumerable: true,
    get: function() {
        return _week.tuesday;
    }
});
Object.defineProperty(exports, "timeTuesdays", {
    enumerable: true,
    get: function() {
        return _week.tuesdays;
    }
});
Object.defineProperty(exports, "timeWednesday", {
    enumerable: true,
    get: function() {
        return _week.wednesday;
    }
});
Object.defineProperty(exports, "timeWednesdays", {
    enumerable: true,
    get: function() {
        return _week.wednesdays;
    }
});
Object.defineProperty(exports, "timeWeek", {
    enumerable: true,
    get: function() {
        return _week.sunday;
    }
});
Object.defineProperty(exports, "timeWeeks", {
    enumerable: true,
    get: function() {
        return _week.sundays;
    }
});
Object.defineProperty(exports, "timeYear", {
    enumerable: true,
    get: function() {
        return _year.default;
    }
});
Object.defineProperty(exports, "timeYears", {
    enumerable: true,
    get: function() {
        return _year.years;
    }
});
Object.defineProperty(exports, "utcDay", {
    enumerable: true,
    get: function() {
        return _utcDay.default;
    }
});
Object.defineProperty(exports, "utcDays", {
    enumerable: true,
    get: function() {
        return _utcDay.utcDays;
    }
});
Object.defineProperty(exports, "utcFriday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcFriday;
    }
});
Object.defineProperty(exports, "utcFridays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcFridays;
    }
});
Object.defineProperty(exports, "utcHour", {
    enumerable: true,
    get: function() {
        return _utcHour.default;
    }
});
Object.defineProperty(exports, "utcHours", {
    enumerable: true,
    get: function() {
        return _utcHour.utcHours;
    }
});
Object.defineProperty(exports, "utcMillisecond", {
    enumerable: true,
    get: function() {
        return _millisecond.default;
    }
});
Object.defineProperty(exports, "utcMilliseconds", {
    enumerable: true,
    get: function() {
        return _millisecond.milliseconds;
    }
});
Object.defineProperty(exports, "utcMinute", {
    enumerable: true,
    get: function() {
        return _utcMinute.default;
    }
});
Object.defineProperty(exports, "utcMinutes", {
    enumerable: true,
    get: function() {
        return _utcMinute.utcMinutes;
    }
});
Object.defineProperty(exports, "utcMonday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcMonday;
    }
});
Object.defineProperty(exports, "utcMondays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcMondays;
    }
});
Object.defineProperty(exports, "utcMonth", {
    enumerable: true,
    get: function() {
        return _utcMonth.default;
    }
});
Object.defineProperty(exports, "utcMonths", {
    enumerable: true,
    get: function() {
        return _utcMonth.utcMonths;
    }
});
Object.defineProperty(exports, "utcSaturday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSaturday;
    }
});
Object.defineProperty(exports, "utcSaturdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSaturdays;
    }
});
Object.defineProperty(exports, "utcSecond", {
    enumerable: true,
    get: function() {
        return _second.default;
    }
});
Object.defineProperty(exports, "utcSeconds", {
    enumerable: true,
    get: function() {
        return _second.seconds;
    }
});
Object.defineProperty(exports, "utcSunday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSunday;
    }
});
Object.defineProperty(exports, "utcSundays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSundays;
    }
});
Object.defineProperty(exports, "utcThursday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcThursday;
    }
});
Object.defineProperty(exports, "utcThursdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcThursdays;
    }
});
Object.defineProperty(exports, "utcTickInterval", {
    enumerable: true,
    get: function() {
        return _ticks.utcTickInterval;
    }
});
Object.defineProperty(exports, "utcTicks", {
    enumerable: true,
    get: function() {
        return _ticks.utcTicks;
    }
});
Object.defineProperty(exports, "utcTuesday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcTuesday;
    }
});
Object.defineProperty(exports, "utcTuesdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcTuesdays;
    }
});
Object.defineProperty(exports, "utcWednesday", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcWednesday;
    }
});
Object.defineProperty(exports, "utcWednesdays", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcWednesdays;
    }
});
Object.defineProperty(exports, "utcWeek", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSunday;
    }
});
Object.defineProperty(exports, "utcWeeks", {
    enumerable: true,
    get: function() {
        return _utcWeek.utcSundays;
    }
});
Object.defineProperty(exports, "utcYear", {
    enumerable: true,
    get: function() {
        return _utcYear.default;
    }
});
Object.defineProperty(exports, "utcYears", {
    enumerable: true,
    get: function() {
        return _utcYear.utcYears;
    }
});
var _interval = _interopRequireDefault(require("792c68a3f8a1926"));
var _millisecond = _interopRequireWildcard(require("2357def356bae18"));
var _second = _interopRequireWildcard(require("1c57489bc0aa2095"));
var _minute = _interopRequireWildcard(require("29ed17b274422d68"));
var _hour = _interopRequireWildcard(require("24ed79de6f4f26d"));
var _day = _interopRequireWildcard(require("82753f475a698669"));
var _week = require("a7e60f089113fd37");
var _month = _interopRequireWildcard(require("340ea3bf33812c65"));
var _year = _interopRequireWildcard(require("e014d3654a0b00fb"));
var _utcMinute = _interopRequireWildcard(require("5ff1ef18d2410f37"));
var _utcHour = _interopRequireWildcard(require("2822e085c5125d78"));
var _utcDay = _interopRequireWildcard(require("ff909be541c31c33"));
var _utcWeek = require("70b57967fcafbaa5");
var _utcMonth = _interopRequireWildcard(require("e41feff472794f13"));
var _utcYear = _interopRequireWildcard(require("9b0775a896f4b4dc"));
var _ticks = require("af413f597619bd05");
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

},{"792c68a3f8a1926":"7wdQk","2357def356bae18":"7KbA2","1c57489bc0aa2095":"9Wy8t","29ed17b274422d68":"8k41t","24ed79de6f4f26d":"f1kus","82753f475a698669":"311tO","a7e60f089113fd37":"jHsGk","340ea3bf33812c65":"jNWOH","e014d3654a0b00fb":"efPyv","5ff1ef18d2410f37":"i8oeh","2822e085c5125d78":"aQDn2","ff909be541c31c33":"4cqkb","70b57967fcafbaa5":"hSvJ6","e41feff472794f13":"lWT7H","9b0775a896f4b4dc":"jAVqN","af413f597619bd05":"QojIU"}],"7wdQk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = newInterval;
var t0 = new Date(), t1 = new Date();
function newInterval(floori, offseti, count, field) {
    function interval(date) {
        return floori(date = arguments.length === 0 ? new Date() : new Date(+date)), date;
    }
    interval.floor = function(date) {
        return floori(date = new Date(+date)), date;
    };
    interval.ceil = function(date) {
        return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
    };
    interval.round = function(date) {
        var d0 = interval(date), d1 = interval.ceil(date);
        return date - d0 < d1 - date ? d0 : d1;
    };
    interval.offset = function(date, step) {
        return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
    };
    interval.range = function(start, stop, step) {
        var range = [], previous;
        start = interval.ceil(start);
        step = step == null ? 1 : Math.floor(step);
        if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
        do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
        while (previous < start && start < stop);
        return range;
    };
    interval.filter = function(test) {
        return newInterval(function(date) {
            if (date >= date) while(floori(date), !test(date))date.setTime(date - 1);
        }, function(date, step) {
            if (date >= date) {
                if (step < 0) while(++step <= 0){
                    while(offseti(date, -1), !test(date)); // eslint-disable-line no-empty
                }
                else while(--step >= 0){
                    while(offseti(date, 1), !test(date)); // eslint-disable-line no-empty
                }
            }
        });
    };
    if (count) {
        interval.count = function(start, end) {
            t0.setTime(+start), t1.setTime(+end);
            floori(t0), floori(t1);
            return Math.floor(count(t0, t1));
        };
        interval.every = function(step) {
            step = Math.floor(step);
            return !isFinite(step) || !(step > 0) ? null : !(step > 1) ? interval : interval.filter(field ? function(d) {
                return field(d) % step === 0;
            } : function(d) {
                return interval.count(0, d) % step === 0;
            });
        };
    }
    return interval;
}

},{}],"7KbA2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.milliseconds = exports.default = void 0;
var _interval = _interopRequireDefault(require("47fef281020880de"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var millisecond = (0, _interval.default)(function() {
// noop
}, function(date, step) {
    date.setTime(+date + step);
}, function(start, end) {
    return end - start;
});
// An optimized implementation for this simple case.
millisecond.every = function(k) {
    k = Math.floor(k);
    if (!isFinite(k) || !(k > 0)) return null;
    if (!(k > 1)) return millisecond;
    return (0, _interval.default)(function(date) {
        date.setTime(Math.floor(date / k) * k);
    }, function(date, step) {
        date.setTime(+date + step * k);
    }, function(start, end) {
        return (end - start) / k;
    });
};
var _default = exports.default = millisecond;
var milliseconds = exports.milliseconds = millisecond.range;

},{"47fef281020880de":"7wdQk"}],"9Wy8t":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.seconds = exports.default = void 0;
var _interval = _interopRequireDefault(require("b059f221ba83fd2b"));
var _duration = require("4b017018381ce3ad");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var second = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds());
}, function(date, step) {
    date.setTime(+date + step * _duration.durationSecond);
}, function(start, end) {
    return (end - start) / _duration.durationSecond;
}, function(date) {
    return date.getUTCSeconds();
});
var _default = exports.default = second;
var seconds = exports.seconds = second.range;

},{"b059f221ba83fd2b":"7wdQk","4b017018381ce3ad":"alYyG"}],"alYyG":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.durationYear = exports.durationWeek = exports.durationSecond = exports.durationMonth = exports.durationMinute = exports.durationHour = exports.durationDay = void 0;
const durationSecond = exports.durationSecond = 1000;
const durationMinute = exports.durationMinute = durationSecond * 60;
const durationHour = exports.durationHour = durationMinute * 60;
const durationDay = exports.durationDay = durationHour * 24;
const durationWeek = exports.durationWeek = durationDay * 7;
const durationMonth = exports.durationMonth = durationDay * 30;
const durationYear = exports.durationYear = durationDay * 365;

},{}],"8k41t":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.minutes = exports.default = void 0;
var _interval = _interopRequireDefault(require("5b81b309635f37c2"));
var _duration = require("52c486da961f0d2c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var minute = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration.durationSecond);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationMinute);
}, function(start, end) {
    return (end - start) / _duration.durationMinute;
}, function(date) {
    return date.getMinutes();
});
var _default = exports.default = minute;
var minutes = exports.minutes = minute.range;

},{"5b81b309635f37c2":"7wdQk","52c486da961f0d2c":"alYyG"}],"f1kus":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hours = exports.default = void 0;
var _interval = _interopRequireDefault(require("d36c991e94b8c5d6"));
var _duration = require("b17b3dbdbc5c799e");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var hour = (0, _interval.default)(function(date) {
    date.setTime(date - date.getMilliseconds() - date.getSeconds() * _duration.durationSecond - date.getMinutes() * _duration.durationMinute);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationHour);
}, function(start, end) {
    return (end - start) / _duration.durationHour;
}, function(date) {
    return date.getHours();
});
var _default = exports.default = hour;
var hours = exports.hours = hour.range;

},{"d36c991e94b8c5d6":"7wdQk","b17b3dbdbc5c799e":"alYyG"}],"311tO":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = exports.days = void 0;
var _interval = _interopRequireDefault(require("c559f97c050225d3"));
var _duration = require("93d679bd1def1b3c");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var day = (0, _interval.default)((date)=>date.setHours(0, 0, 0, 0), (date, step)=>date.setDate(date.getDate() + step), (start, end)=>(end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration.durationMinute) / _duration.durationDay, (date)=>date.getDate() - 1);
var _default = exports.default = day;
var days = exports.days = day.range;

},{"c559f97c050225d3":"7wdQk","93d679bd1def1b3c":"alYyG"}],"jHsGk":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wednesdays = exports.wednesday = exports.tuesdays = exports.tuesday = exports.thursdays = exports.thursday = exports.sundays = exports.sunday = exports.saturdays = exports.saturday = exports.mondays = exports.monday = exports.fridays = exports.friday = void 0;
var _interval = _interopRequireDefault(require("fb608840fab065f0"));
var _duration = require("136ded3f760de188");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function weekday(i) {
    return (0, _interval.default)(function(date) {
        date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setDate(date.getDate() + step * 7);
    }, function(start, end) {
        return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * _duration.durationMinute) / _duration.durationWeek;
    });
}
var sunday = exports.sunday = weekday(0);
var monday = exports.monday = weekday(1);
var tuesday = exports.tuesday = weekday(2);
var wednesday = exports.wednesday = weekday(3);
var thursday = exports.thursday = weekday(4);
var friday = exports.friday = weekday(5);
var saturday = exports.saturday = weekday(6);
var sundays = exports.sundays = sunday.range;
var mondays = exports.mondays = monday.range;
var tuesdays = exports.tuesdays = tuesday.range;
var wednesdays = exports.wednesdays = wednesday.range;
var thursdays = exports.thursdays = thursday.range;
var fridays = exports.fridays = friday.range;
var saturdays = exports.saturdays = saturday.range;

},{"fb608840fab065f0":"7wdQk","136ded3f760de188":"alYyG"}],"jNWOH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.months = exports.default = void 0;
var _interval = _interopRequireDefault(require("7e198ba28f0e25de"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var month = (0, _interval.default)(function(date) {
    date.setDate(1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setMonth(date.getMonth() + step);
}, function(start, end) {
    return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
}, function(date) {
    return date.getMonth();
});
var _default = exports.default = month;
var months = exports.months = month.range;

},{"7e198ba28f0e25de":"7wdQk"}],"efPyv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.years = exports.default = void 0;
var _interval = _interopRequireDefault(require("699a5bdfd0c77e2e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var year = (0, _interval.default)(function(date) {
    date.setMonth(0, 1);
    date.setHours(0, 0, 0, 0);
}, function(date, step) {
    date.setFullYear(date.getFullYear() + step);
}, function(start, end) {
    return end.getFullYear() - start.getFullYear();
}, function(date) {
    return date.getFullYear();
});
// An optimized implementation for this simple case.
year.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval.default)(function(date) {
        date.setFullYear(Math.floor(date.getFullYear() / k) * k);
        date.setMonth(0, 1);
        date.setHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setFullYear(date.getFullYear() + step * k);
    });
};
var _default = exports.default = year;
var years = exports.years = year.range;

},{"699a5bdfd0c77e2e":"7wdQk"}],"i8oeh":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcMinutes = exports.default = void 0;
var _interval = _interopRequireDefault(require("64b6a8f5c9bd1c96"));
var _duration = require("32c01369d4e699fb");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcMinute = (0, _interval.default)(function(date) {
    date.setUTCSeconds(0, 0);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationMinute);
}, function(start, end) {
    return (end - start) / _duration.durationMinute;
}, function(date) {
    return date.getUTCMinutes();
});
var _default = exports.default = utcMinute;
var utcMinutes = exports.utcMinutes = utcMinute.range;

},{"64b6a8f5c9bd1c96":"7wdQk","32c01369d4e699fb":"alYyG"}],"aQDn2":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcHours = exports.default = void 0;
var _interval = _interopRequireDefault(require("8c74396d670977a"));
var _duration = require("6c82203e6970a1bc");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcHour = (0, _interval.default)(function(date) {
    date.setUTCMinutes(0, 0, 0);
}, function(date, step) {
    date.setTime(+date + step * _duration.durationHour);
}, function(start, end) {
    return (end - start) / _duration.durationHour;
}, function(date) {
    return date.getUTCHours();
});
var _default = exports.default = utcHour;
var utcHours = exports.utcHours = utcHour.range;

},{"8c74396d670977a":"7wdQk","6c82203e6970a1bc":"alYyG"}],"4cqkb":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcDays = exports.default = void 0;
var _interval = _interopRequireDefault(require("1f97a562b3e12493"));
var _duration = require("4c0ac820095fab8f");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcDay = (0, _interval.default)(function(date) {
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCDate(date.getUTCDate() + step);
}, function(start, end) {
    return (end - start) / _duration.durationDay;
}, function(date) {
    return date.getUTCDate() - 1;
});
var _default = exports.default = utcDay;
var utcDays = exports.utcDays = utcDay.range;

},{"1f97a562b3e12493":"7wdQk","4c0ac820095fab8f":"alYyG"}],"hSvJ6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcWednesdays = exports.utcWednesday = exports.utcTuesdays = exports.utcTuesday = exports.utcThursdays = exports.utcThursday = exports.utcSundays = exports.utcSunday = exports.utcSaturdays = exports.utcSaturday = exports.utcMondays = exports.utcMonday = exports.utcFridays = exports.utcFriday = void 0;
var _interval = _interopRequireDefault(require("e95c6c72a9a72603"));
var _duration = require("b3779dea703b5e01");
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function utcWeekday(i) {
    return (0, _interval.default)(function(date) {
        date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCDate(date.getUTCDate() + step * 7);
    }, function(start, end) {
        return (end - start) / _duration.durationWeek;
    });
}
var utcSunday = exports.utcSunday = utcWeekday(0);
var utcMonday = exports.utcMonday = utcWeekday(1);
var utcTuesday = exports.utcTuesday = utcWeekday(2);
var utcWednesday = exports.utcWednesday = utcWeekday(3);
var utcThursday = exports.utcThursday = utcWeekday(4);
var utcFriday = exports.utcFriday = utcWeekday(5);
var utcSaturday = exports.utcSaturday = utcWeekday(6);
var utcSundays = exports.utcSundays = utcSunday.range;
var utcMondays = exports.utcMondays = utcMonday.range;
var utcTuesdays = exports.utcTuesdays = utcTuesday.range;
var utcWednesdays = exports.utcWednesdays = utcWednesday.range;
var utcThursdays = exports.utcThursdays = utcThursday.range;
var utcFridays = exports.utcFridays = utcFriday.range;
var utcSaturdays = exports.utcSaturdays = utcSaturday.range;

},{"e95c6c72a9a72603":"7wdQk","b3779dea703b5e01":"alYyG"}],"lWT7H":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcMonths = exports.default = void 0;
var _interval = _interopRequireDefault(require("9fc54a6c7da64a87"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcMonth = (0, _interval.default)(function(date) {
    date.setUTCDate(1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCMonth(date.getUTCMonth() + step);
}, function(start, end) {
    return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
}, function(date) {
    return date.getUTCMonth();
});
var _default = exports.default = utcMonth;
var utcMonths = exports.utcMonths = utcMonth.range;

},{"9fc54a6c7da64a87":"7wdQk"}],"jAVqN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcYears = exports.default = void 0;
var _interval = _interopRequireDefault(require("8be30e72f54134d4"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var utcYear = (0, _interval.default)(function(date) {
    date.setUTCMonth(0, 1);
    date.setUTCHours(0, 0, 0, 0);
}, function(date, step) {
    date.setUTCFullYear(date.getUTCFullYear() + step);
}, function(start, end) {
    return end.getUTCFullYear() - start.getUTCFullYear();
}, function(date) {
    return date.getUTCFullYear();
});
// An optimized implementation for this simple case.
utcYear.every = function(k) {
    return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : (0, _interval.default)(function(date) {
        date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
        date.setUTCMonth(0, 1);
        date.setUTCHours(0, 0, 0, 0);
    }, function(date, step) {
        date.setUTCFullYear(date.getUTCFullYear() + step * k);
    });
};
var _default = exports.default = utcYear;
var utcYears = exports.utcYears = utcYear.range;

},{"8be30e72f54134d4":"7wdQk"}],"QojIU":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utcTicks = exports.utcTickInterval = exports.timeTicks = exports.timeTickInterval = void 0;
var _index = require("d7f21fd662cddf99");
var _duration = require("aa18ef34c0be11bc");
var _millisecond = _interopRequireDefault(require("dac51414a1e8276b"));
var _second = _interopRequireDefault(require("d68afea8416c3f1a"));
var _minute = _interopRequireDefault(require("404a139d621a9db2"));
var _hour = _interopRequireDefault(require("9a0bf4314f401b0c"));
var _day = _interopRequireDefault(require("3f04924c68533af9"));
var _week = require("b2b29cfa1ce6c7da");
var _month = _interopRequireDefault(require("5ceb61e7c9c807ec"));
var _year = _interopRequireDefault(require("dd0ef245ed62fdbf"));
var _utcMinute = _interopRequireDefault(require("1e46f3d232f79e5e"));
var _utcHour = _interopRequireDefault(require("3d1ae5dfacd220b4"));
var _utcDay = _interopRequireDefault(require("5fb1b56afb7033e1"));
var _utcWeek = require("536323b8c7eb14e3");
var _utcMonth = _interopRequireDefault(require("856c2c54a9da13b6"));
var _utcYear = _interopRequireDefault(require("f5ebb8abb03b9dec"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function ticker(year, month, week, day, hour, minute) {
    const tickIntervals = [
        [
            _second.default,
            1,
            _duration.durationSecond
        ],
        [
            _second.default,
            5,
            5 * _duration.durationSecond
        ],
        [
            _second.default,
            15,
            15 * _duration.durationSecond
        ],
        [
            _second.default,
            30,
            30 * _duration.durationSecond
        ],
        [
            minute,
            1,
            _duration.durationMinute
        ],
        [
            minute,
            5,
            5 * _duration.durationMinute
        ],
        [
            minute,
            15,
            15 * _duration.durationMinute
        ],
        [
            minute,
            30,
            30 * _duration.durationMinute
        ],
        [
            hour,
            1,
            _duration.durationHour
        ],
        [
            hour,
            3,
            3 * _duration.durationHour
        ],
        [
            hour,
            6,
            6 * _duration.durationHour
        ],
        [
            hour,
            12,
            12 * _duration.durationHour
        ],
        [
            day,
            1,
            _duration.durationDay
        ],
        [
            day,
            2,
            2 * _duration.durationDay
        ],
        [
            week,
            1,
            _duration.durationWeek
        ],
        [
            month,
            1,
            _duration.durationMonth
        ],
        [
            month,
            3,
            3 * _duration.durationMonth
        ],
        [
            year,
            1,
            _duration.durationYear
        ]
    ];
    function ticks(start, stop, count) {
        const reverse = stop < start;
        if (reverse) [start, stop] = [
            stop,
            start
        ];
        const interval = count && typeof count.range === "function" ? count : tickInterval(start, stop, count);
        const ticks = interval ? interval.range(start, +stop + 1) : []; // inclusive stop
        return reverse ? ticks.reverse() : ticks;
    }
    function tickInterval(start, stop, count) {
        const target = Math.abs(stop - start) / count;
        const i = (0, _index.bisector)(([, , step])=>step).right(tickIntervals, target);
        if (i === tickIntervals.length) return year.every((0, _index.tickStep)(start / _duration.durationYear, stop / _duration.durationYear, count));
        if (i === 0) return _millisecond.default.every(Math.max((0, _index.tickStep)(start, stop, count), 1));
        const [t, step] = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
        return t.every(step);
    }
    return [
        ticks,
        tickInterval
    ];
}
const [utcTicks, utcTickInterval] = ticker(_utcYear.default, _utcMonth.default, _utcWeek.utcSunday, _utcDay.default, _utcHour.default, _utcMinute.default);
exports.utcTickInterval = utcTickInterval;
exports.utcTicks = utcTicks;
const [timeTicks, timeTickInterval] = ticker(_year.default, _month.default, _week.sunday, _day.default, _hour.default, _minute.default);
exports.timeTickInterval = timeTickInterval;
exports.timeTicks = timeTicks;

},{"d7f21fd662cddf99":"3WmRx","aa18ef34c0be11bc":"alYyG","dac51414a1e8276b":"7KbA2","d68afea8416c3f1a":"9Wy8t","404a139d621a9db2":"8k41t","9a0bf4314f401b0c":"f1kus","3f04924c68533af9":"311tO","b2b29cfa1ce6c7da":"jHsGk","5ceb61e7c9c807ec":"jNWOH","dd0ef245ed62fdbf":"efPyv","1e46f3d232f79e5e":"i8oeh","3d1ae5dfacd220b4":"aQDn2","5fb1b56afb7033e1":"4cqkb","536323b8c7eb14e3":"hSvJ6","856c2c54a9da13b6":"lWT7H","f5ebb8abb03b9dec":"jAVqN"}],"6bc60":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "isoFormat", {
    enumerable: true,
    get: function() {
        return _isoFormat.default;
    }
});
Object.defineProperty(exports, "isoParse", {
    enumerable: true,
    get: function() {
        return _isoParse.default;
    }
});
Object.defineProperty(exports, "timeFormat", {
    enumerable: true,
    get: function() {
        return _defaultLocale.timeFormat;
    }
});
Object.defineProperty(exports, "timeFormatDefaultLocale", {
    enumerable: true,
    get: function() {
        return _defaultLocale.default;
    }
});
Object.defineProperty(exports, "timeFormatLocale", {
    enumerable: true,
    get: function() {
        return _locale.default;
    }
});
Object.defineProperty(exports, "timeParse", {
    enumerable: true,
    get: function() {
        return _defaultLocale.timeParse;
    }
});
Object.defineProperty(exports, "utcFormat", {
    enumerable: true,
    get: function() {
        return _defaultLocale.utcFormat;
    }
});
Object.defineProperty(exports, "utcParse", {
    enumerable: true,
    get: function() {
        return _defaultLocale.utcParse;
    }
});
var _defaultLocale = _interopRequireWildcard(require("e254c805352cbe79"));
var _locale = _interopRequireDefault(require("a2049a4646cad099"));
var _isoFormat = _interopRequireDefault(require("8485f996f4dff29b"));
var _isoParse = _interopRequireDefault(require("e2c3ab8c9c293ff5"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}

},{"e254c805352cbe79":"rVIfp","a2049a4646cad099":"gx8CH","8485f996f4dff29b":"eSPqd","e2c3ab8c9c293ff5":"7TPWj"}],"rVIfp":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = defaultLocale;
exports.utcParse = exports.utcFormat = exports.timeParse = exports.timeFormat = void 0;
var _locale = _interopRequireDefault(require("8c8d5f4601afc09e"));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var locale;
var timeFormat;
var timeParse;
var utcFormat;
var utcParse;
defaultLocale({
    dateTime: "%x, %X",
    date: "%-m/%-d/%Y",
    time: "%-I:%M:%S %p",
    periods: [
        "AM",
        "PM"
    ],
    days: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday"
    ],
    shortDays: [
        "Sun",
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat"
    ],
    months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
    ],
    shortMonths: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec"
    ]
});
function defaultLocale(definition) {
    locale = (0, _locale.default)(definition);
    exports.timeFormat = timeFormat = locale.format;
    exports.timeParse = timeParse = locale.parse;
    exports.utcFormat = utcFormat = locale.utcFormat;
    exports.utcParse = utcParse = locale.utcParse;
    return locale;
}

},{"8c8d5f4601afc09e":"gx8CH"}],"gx8CH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = formatLocale;
var _index = require("da76bc1e0eef4658");
function localDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
        date.setFullYear(d.y);
        return date;
    }
    return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
}
function utcDate(d) {
    if (0 <= d.y && d.y < 100) {
        var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
        date.setUTCFullYear(d.y);
        return date;
    }
    return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
}
function newDate(y, m, d) {
    return {
        y: y,
        m: m,
        d: d,
        H: 0,
        M: 0,
        S: 0,
        L: 0
    };
}
function formatLocale(locale) {
    var locale_dateTime = locale.dateTime, locale_date = locale.date, locale_time = locale.time, locale_periods = locale.periods, locale_weekdays = locale.days, locale_shortWeekdays = locale.shortDays, locale_months = locale.months, locale_shortMonths = locale.shortMonths;
    var periodRe = formatRe(locale_periods), periodLookup = formatLookup(locale_periods), weekdayRe = formatRe(locale_weekdays), weekdayLookup = formatLookup(locale_weekdays), shortWeekdayRe = formatRe(locale_shortWeekdays), shortWeekdayLookup = formatLookup(locale_shortWeekdays), monthRe = formatRe(locale_months), monthLookup = formatLookup(locale_months), shortMonthRe = formatRe(locale_shortMonths), shortMonthLookup = formatLookup(locale_shortMonths);
    var formats = {
        "a": formatShortWeekday,
        "A": formatWeekday,
        "b": formatShortMonth,
        "B": formatMonth,
        "c": null,
        "d": formatDayOfMonth,
        "e": formatDayOfMonth,
        "f": formatMicroseconds,
        "g": formatYearISO,
        "G": formatFullYearISO,
        "H": formatHour24,
        "I": formatHour12,
        "j": formatDayOfYear,
        "L": formatMilliseconds,
        "m": formatMonthNumber,
        "M": formatMinutes,
        "p": formatPeriod,
        "q": formatQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatSeconds,
        "u": formatWeekdayNumberMonday,
        "U": formatWeekNumberSunday,
        "V": formatWeekNumberISO,
        "w": formatWeekdayNumberSunday,
        "W": formatWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatYear,
        "Y": formatFullYear,
        "Z": formatZone,
        "%": formatLiteralPercent
    };
    var utcFormats = {
        "a": formatUTCShortWeekday,
        "A": formatUTCWeekday,
        "b": formatUTCShortMonth,
        "B": formatUTCMonth,
        "c": null,
        "d": formatUTCDayOfMonth,
        "e": formatUTCDayOfMonth,
        "f": formatUTCMicroseconds,
        "g": formatUTCYearISO,
        "G": formatUTCFullYearISO,
        "H": formatUTCHour24,
        "I": formatUTCHour12,
        "j": formatUTCDayOfYear,
        "L": formatUTCMilliseconds,
        "m": formatUTCMonthNumber,
        "M": formatUTCMinutes,
        "p": formatUTCPeriod,
        "q": formatUTCQuarter,
        "Q": formatUnixTimestamp,
        "s": formatUnixTimestampSeconds,
        "S": formatUTCSeconds,
        "u": formatUTCWeekdayNumberMonday,
        "U": formatUTCWeekNumberSunday,
        "V": formatUTCWeekNumberISO,
        "w": formatUTCWeekdayNumberSunday,
        "W": formatUTCWeekNumberMonday,
        "x": null,
        "X": null,
        "y": formatUTCYear,
        "Y": formatUTCFullYear,
        "Z": formatUTCZone,
        "%": formatLiteralPercent
    };
    var parses = {
        "a": parseShortWeekday,
        "A": parseWeekday,
        "b": parseShortMonth,
        "B": parseMonth,
        "c": parseLocaleDateTime,
        "d": parseDayOfMonth,
        "e": parseDayOfMonth,
        "f": parseMicroseconds,
        "g": parseYear,
        "G": parseFullYear,
        "H": parseHour24,
        "I": parseHour24,
        "j": parseDayOfYear,
        "L": parseMilliseconds,
        "m": parseMonthNumber,
        "M": parseMinutes,
        "p": parsePeriod,
        "q": parseQuarter,
        "Q": parseUnixTimestamp,
        "s": parseUnixTimestampSeconds,
        "S": parseSeconds,
        "u": parseWeekdayNumberMonday,
        "U": parseWeekNumberSunday,
        "V": parseWeekNumberISO,
        "w": parseWeekdayNumberSunday,
        "W": parseWeekNumberMonday,
        "x": parseLocaleDate,
        "X": parseLocaleTime,
        "y": parseYear,
        "Y": parseFullYear,
        "Z": parseZone,
        "%": parseLiteralPercent
    };
    // These recursive directive definitions must be deferred.
    formats.x = newFormat(locale_date, formats);
    formats.X = newFormat(locale_time, formats);
    formats.c = newFormat(locale_dateTime, formats);
    utcFormats.x = newFormat(locale_date, utcFormats);
    utcFormats.X = newFormat(locale_time, utcFormats);
    utcFormats.c = newFormat(locale_dateTime, utcFormats);
    function newFormat(specifier, formats) {
        return function(date) {
            var string = [], i = -1, j = 0, n = specifier.length, c, pad, format;
            if (!(date instanceof Date)) date = new Date(+date);
            while(++i < n)if (specifier.charCodeAt(i) === 37) {
                string.push(specifier.slice(j, i));
                if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
                else pad = c === "e" ? " " : "0";
                if (format = formats[c]) c = format(date, pad);
                string.push(c);
                j = i + 1;
            }
            string.push(specifier.slice(j, i));
            return string.join("");
        };
    }
    function newParse(specifier, Z) {
        return function(string) {
            var d = newDate(1900, undefined, 1), i = parseSpecifier(d, specifier, string += "", 0), week, day;
            if (i != string.length) return null;
            // If a UNIX timestamp is specified, return it.
            if ("Q" in d) return new Date(d.Q);
            if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
            // If this is utcParse, never use the local timezone.
            if (Z && !("Z" in d)) d.Z = 0;
            // The am-pm flag is 0 for AM, and 1 for PM.
            if ("p" in d) d.H = d.H % 12 + d.p * 12;
            // If the month was not specified, inherit from the quarter.
            if (d.m === undefined) d.m = "q" in d ? d.q : 0;
            // Convert day-of-week and week-of-year to day-of-year.
            if ("V" in d) {
                if (d.V < 1 || d.V > 53) return null;
                if (!("w" in d)) d.w = 1;
                if ("Z" in d) {
                    week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
                    week = day > 4 || day === 0 ? _index.utcMonday.ceil(week) : (0, _index.utcMonday)(week);
                    week = _index.utcDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getUTCFullYear();
                    d.m = week.getUTCMonth();
                    d.d = week.getUTCDate() + (d.w + 6) % 7;
                } else {
                    week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
                    week = day > 4 || day === 0 ? _index.timeMonday.ceil(week) : (0, _index.timeMonday)(week);
                    week = _index.timeDay.offset(week, (d.V - 1) * 7);
                    d.y = week.getFullYear();
                    d.m = week.getMonth();
                    d.d = week.getDate() + (d.w + 6) % 7;
                }
            } else if ("W" in d || "U" in d) {
                if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
                day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
                d.m = 0;
                d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
            }
            // If a time zone is specified, all fields are interpreted as UTC and then
            // offset according to the specified time zone.
            if ("Z" in d) {
                d.H += d.Z / 100 | 0;
                d.M += d.Z % 100;
                return utcDate(d);
            }
            // Otherwise, all fields are in local time.
            return localDate(d);
        };
    }
    function parseSpecifier(d, specifier, string, j) {
        var i = 0, n = specifier.length, m = string.length, c, parse;
        while(i < n){
            if (j >= m) return -1;
            c = specifier.charCodeAt(i++);
            if (c === 37) {
                c = specifier.charAt(i++);
                parse = parses[c in pads ? specifier.charAt(i++) : c];
                if (!parse || (j = parse(d, string, j)) < 0) return -1;
            } else if (c != string.charCodeAt(j++)) return -1;
        }
        return j;
    }
    function parsePeriod(d, string, i) {
        var n = periodRe.exec(string.slice(i));
        return n ? (d.p = periodLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortWeekday(d, string, i) {
        var n = shortWeekdayRe.exec(string.slice(i));
        return n ? (d.w = shortWeekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseWeekday(d, string, i) {
        var n = weekdayRe.exec(string.slice(i));
        return n ? (d.w = weekdayLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseShortMonth(d, string, i) {
        var n = shortMonthRe.exec(string.slice(i));
        return n ? (d.m = shortMonthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseMonth(d, string, i) {
        var n = monthRe.exec(string.slice(i));
        return n ? (d.m = monthLookup.get(n[0].toLowerCase()), i + n[0].length) : -1;
    }
    function parseLocaleDateTime(d, string, i) {
        return parseSpecifier(d, locale_dateTime, string, i);
    }
    function parseLocaleDate(d, string, i) {
        return parseSpecifier(d, locale_date, string, i);
    }
    function parseLocaleTime(d, string, i) {
        return parseSpecifier(d, locale_time, string, i);
    }
    function formatShortWeekday(d) {
        return locale_shortWeekdays[d.getDay()];
    }
    function formatWeekday(d) {
        return locale_weekdays[d.getDay()];
    }
    function formatShortMonth(d) {
        return locale_shortMonths[d.getMonth()];
    }
    function formatMonth(d) {
        return locale_months[d.getMonth()];
    }
    function formatPeriod(d) {
        return locale_periods[+(d.getHours() >= 12)];
    }
    function formatQuarter(d) {
        return 1 + ~~(d.getMonth() / 3);
    }
    function formatUTCShortWeekday(d) {
        return locale_shortWeekdays[d.getUTCDay()];
    }
    function formatUTCWeekday(d) {
        return locale_weekdays[d.getUTCDay()];
    }
    function formatUTCShortMonth(d) {
        return locale_shortMonths[d.getUTCMonth()];
    }
    function formatUTCMonth(d) {
        return locale_months[d.getUTCMonth()];
    }
    function formatUTCPeriod(d) {
        return locale_periods[+(d.getUTCHours() >= 12)];
    }
    function formatUTCQuarter(d) {
        return 1 + ~~(d.getUTCMonth() / 3);
    }
    return {
        format: function(specifier) {
            var f = newFormat(specifier += "", formats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        parse: function(specifier) {
            var p = newParse(specifier += "", false);
            p.toString = function() {
                return specifier;
            };
            return p;
        },
        utcFormat: function(specifier) {
            var f = newFormat(specifier += "", utcFormats);
            f.toString = function() {
                return specifier;
            };
            return f;
        },
        utcParse: function(specifier) {
            var p = newParse(specifier += "", true);
            p.toString = function() {
                return specifier;
            };
            return p;
        }
    };
}
var pads = {
    "-": "",
    "_": " ",
    "0": "0"
}, numberRe = /^\s*\d+/, // note: ignores next directive
percentRe = /^%/, requoteRe = /[\\^$*+?|[\]().{}]/g;
function pad(value, fill, width) {
    var sign = value < 0 ? "-" : "", string = (sign ? -value : value) + "", length = string.length;
    return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
}
function requote(s) {
    return s.replace(requoteRe, "\\$&");
}
function formatRe(names) {
    return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
}
function formatLookup(names) {
    return new Map(names.map((name, i)=>[
            name.toLowerCase(),
            i
        ]));
}
function parseWeekdayNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.w = +n[0], i + n[0].length) : -1;
}
function parseWeekdayNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.u = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberSunday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.U = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberISO(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.V = +n[0], i + n[0].length) : -1;
}
function parseWeekNumberMonday(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.W = +n[0], i + n[0].length) : -1;
}
function parseFullYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 4));
    return n ? (d.y = +n[0], i + n[0].length) : -1;
}
function parseYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
}
function parseZone(d, string, i) {
    var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
    return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
}
function parseQuarter(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 1));
    return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
}
function parseMonthNumber(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
}
function parseDayOfMonth(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.d = +n[0], i + n[0].length) : -1;
}
function parseDayOfYear(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
}
function parseHour24(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.H = +n[0], i + n[0].length) : -1;
}
function parseMinutes(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.M = +n[0], i + n[0].length) : -1;
}
function parseSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 2));
    return n ? (d.S = +n[0], i + n[0].length) : -1;
}
function parseMilliseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 3));
    return n ? (d.L = +n[0], i + n[0].length) : -1;
}
function parseMicroseconds(d, string, i) {
    var n = numberRe.exec(string.slice(i, i + 6));
    return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
}
function parseLiteralPercent(d, string, i) {
    var n = percentRe.exec(string.slice(i, i + 1));
    return n ? i + n[0].length : -1;
}
function parseUnixTimestamp(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.Q = +n[0], i + n[0].length) : -1;
}
function parseUnixTimestampSeconds(d, string, i) {
    var n = numberRe.exec(string.slice(i));
    return n ? (d.s = +n[0], i + n[0].length) : -1;
}
function formatDayOfMonth(d, p) {
    return pad(d.getDate(), p, 2);
}
function formatHour24(d, p) {
    return pad(d.getHours(), p, 2);
}
function formatHour12(d, p) {
    return pad(d.getHours() % 12 || 12, p, 2);
}
function formatDayOfYear(d, p) {
    return pad(1 + _index.timeDay.count((0, _index.timeYear)(d), d), p, 3);
}
function formatMilliseconds(d, p) {
    return pad(d.getMilliseconds(), p, 3);
}
function formatMicroseconds(d, p) {
    return formatMilliseconds(d, p) + "000";
}
function formatMonthNumber(d, p) {
    return pad(d.getMonth() + 1, p, 2);
}
function formatMinutes(d, p) {
    return pad(d.getMinutes(), p, 2);
}
function formatSeconds(d, p) {
    return pad(d.getSeconds(), p, 2);
}
function formatWeekdayNumberMonday(d) {
    var day = d.getDay();
    return day === 0 ? 7 : day;
}
function formatWeekNumberSunday(d, p) {
    return pad(_index.timeSunday.count((0, _index.timeYear)(d) - 1, d), p, 2);
}
function dISO(d) {
    var day = d.getDay();
    return day >= 4 || day === 0 ? (0, _index.timeThursday)(d) : _index.timeThursday.ceil(d);
}
function formatWeekNumberISO(d, p) {
    d = dISO(d);
    return pad(_index.timeThursday.count((0, _index.timeYear)(d), d) + ((0, _index.timeYear)(d).getDay() === 4), p, 2);
}
function formatWeekdayNumberSunday(d) {
    return d.getDay();
}
function formatWeekNumberMonday(d, p) {
    return pad(_index.timeMonday.count((0, _index.timeYear)(d) - 1, d), p, 2);
}
function formatYear(d, p) {
    return pad(d.getFullYear() % 100, p, 2);
}
function formatYearISO(d, p) {
    d = dISO(d);
    return pad(d.getFullYear() % 100, p, 2);
}
function formatFullYear(d, p) {
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatFullYearISO(d, p) {
    var day = d.getDay();
    d = day >= 4 || day === 0 ? (0, _index.timeThursday)(d) : _index.timeThursday.ceil(d);
    return pad(d.getFullYear() % 10000, p, 4);
}
function formatZone(d) {
    var z = d.getTimezoneOffset();
    return (z > 0 ? "-" : (z *= -1, "+")) + pad(z / 60 | 0, "0", 2) + pad(z % 60, "0", 2);
}
function formatUTCDayOfMonth(d, p) {
    return pad(d.getUTCDate(), p, 2);
}
function formatUTCHour24(d, p) {
    return pad(d.getUTCHours(), p, 2);
}
function formatUTCHour12(d, p) {
    return pad(d.getUTCHours() % 12 || 12, p, 2);
}
function formatUTCDayOfYear(d, p) {
    return pad(1 + _index.utcDay.count((0, _index.utcYear)(d), d), p, 3);
}
function formatUTCMilliseconds(d, p) {
    return pad(d.getUTCMilliseconds(), p, 3);
}
function formatUTCMicroseconds(d, p) {
    return formatUTCMilliseconds(d, p) + "000";
}
function formatUTCMonthNumber(d, p) {
    return pad(d.getUTCMonth() + 1, p, 2);
}
function formatUTCMinutes(d, p) {
    return pad(d.getUTCMinutes(), p, 2);
}
function formatUTCSeconds(d, p) {
    return pad(d.getUTCSeconds(), p, 2);
}
function formatUTCWeekdayNumberMonday(d) {
    var dow = d.getUTCDay();
    return dow === 0 ? 7 : dow;
}
function formatUTCWeekNumberSunday(d, p) {
    return pad(_index.utcSunday.count((0, _index.utcYear)(d) - 1, d), p, 2);
}
function UTCdISO(d) {
    var day = d.getUTCDay();
    return day >= 4 || day === 0 ? (0, _index.utcThursday)(d) : _index.utcThursday.ceil(d);
}
function formatUTCWeekNumberISO(d, p) {
    d = UTCdISO(d);
    return pad(_index.utcThursday.count((0, _index.utcYear)(d), d) + ((0, _index.utcYear)(d).getUTCDay() === 4), p, 2);
}
function formatUTCWeekdayNumberSunday(d) {
    return d.getUTCDay();
}
function formatUTCWeekNumberMonday(d, p) {
    return pad(_index.utcMonday.count((0, _index.utcYear)(d) - 1, d), p, 2);
}
function formatUTCYear(d, p) {
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCYearISO(d, p) {
    d = UTCdISO(d);
    return pad(d.getUTCFullYear() % 100, p, 2);
}
function formatUTCFullYear(d, p) {
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCFullYearISO(d, p) {
    var day = d.getUTCDay();
    d = day >= 4 || day === 0 ? (0, _index.utcThursday)(d) : _index.utcThursday.ceil(d);
    return pad(d.getUTCFullYear() % 10000, p, 4);
}
function formatUTCZone() {
    return "+0000";
}
function formatLiteralPercent() {
    return "%";
}
function formatUnixTimestamp(d) {
    return +d;
}
function formatUnixTimestampSeconds(d) {
    return Math.floor(+d / 1000);
}

},{"da76bc1e0eef4658":"47yDh"}],"eSPqd":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isoSpecifier = exports.default = void 0;
var _defaultLocale = require("2f8f6a7c55a265a7");
var isoSpecifier = exports.isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
function formatIsoNative(date) {
    return date.toISOString();
}
var formatIso = Date.prototype.toISOString ? formatIsoNative : (0, _defaultLocale.utcFormat)(isoSpecifier);
var _default = exports.default = formatIso;

},{"2f8f6a7c55a265a7":"rVIfp"}],"7TPWj":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = void 0;
var _isoFormat = require("c9c0e033b3f4cd7a");
var _defaultLocale = require("717272dfdfdf9f58");
function parseIsoNative(string) {
    var date = new Date(string);
    return isNaN(date) ? null : date;
}
var parseIso = +new Date("2000-01-01T00:00:00.000Z") ? parseIsoNative : (0, _defaultLocale.utcParse)(_isoFormat.isoSpecifier);
var _default = exports.default = parseIso;

},{"c9c0e033b3f4cd7a":"eSPqd","717272dfdfdf9f58":"rVIfp"}],"lQRCm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = utcTime;
var _index = require("ea22621463423769");
var _index2 = require("df08fa54879bdddf");
var _time = require("3d474b4ac409608e");
var _init = require("f5277d460a04562a");
function utcTime() {
    return _init.initRange.apply((0, _time.calendar)(_index.utcTicks, _index.utcTickInterval, _index.utcYear, _index.utcMonth, _index.utcWeek, _index.utcDay, _index.utcHour, _index.utcMinute, _index.utcSecond, _index2.utcFormat).domain([
        Date.UTC(2000, 0, 1),
        Date.UTC(2000, 0, 2)
    ]), arguments);
}

},{"ea22621463423769":"47yDh","df08fa54879bdddf":"6bc60","3d474b4ac409608e":"iry3Y","f5277d460a04562a":"9c0mi"}],"kJaHH":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.copy = copy;
exports.default = sequential;
exports.sequentialLog = sequentialLog;
exports.sequentialPow = sequentialPow;
exports.sequentialSqrt = sequentialSqrt;
exports.sequentialSymlog = sequentialSymlog;
var _index = require("576a63ed61017ad0");
var _continuous = require("367c19cf7640115e");
var _init = require("4d9ecd8e312987f2");
var _linear = require("7aa8dc079711aa38");
var _log = require("9675a35c284dba6f");
var _symlog = require("e5e6e98809c25bc3");
var _pow = require("814ae7ed84550652");
function transformer() {
    var x0 = 0, x1 = 1, t0, t1, k10, transform, interpolator = _continuous.identity, clamp = false, unknown;
    function scale(x) {
        return x == null || isNaN(x = +x) ? unknown : interpolator(k10 === 0 ? 0.5 : (x = (transform(x) - t0) * k10, clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0), scale) : [
            x0,
            x1
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1;
            return arguments.length ? ([r0, r1] = _, interpolator = interpolate(r0, r1), scale) : [
                interpolator(0),
                interpolator(1)
            ];
        };
    }
    scale.range = range(_index.interpolate);
    scale.rangeRound = range(_index.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), k10 = t0 === t1 ? 0 : 1 / (t1 - t0);
        return scale;
    };
}
function copy(source, target) {
    return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
    var scale = (0, _linear.linearish)(transformer()(_continuous.identity));
    scale.copy = function() {
        return copy(scale, sequential());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialLog() {
    var scale = (0, _log.loggish)(transformer()).domain([
        1,
        10
    ]);
    scale.copy = function() {
        return copy(scale, sequentialLog()).base(scale.base());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialSymlog() {
    var scale = (0, _symlog.symlogish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialSymlog()).constant(scale.constant());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialPow() {
    var scale = (0, _pow.powish)(transformer());
    scale.copy = function() {
        return copy(scale, sequentialPow()).exponent(scale.exponent());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function sequentialSqrt() {
    return sequentialPow.apply(null, arguments).exponent(0.5);
}

},{"576a63ed61017ad0":"8saGV","367c19cf7640115e":"9w8kD","4d9ecd8e312987f2":"9c0mi","7aa8dc079711aa38":"7wwWf","9675a35c284dba6f":"b2mDf","e5e6e98809c25bc3":"hnxTj","814ae7ed84550652":"7qYxn"}],"9ZDCv":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = sequentialQuantile;
var _index = require("eed0055976263d50");
var _continuous = require("21618a239c62366b");
var _init = require("92ad1cf8524c146");
function sequentialQuantile() {
    var domain = [], interpolator = _continuous.identity;
    function scale(x) {
        if (x != null && !isNaN(x = +x)) return interpolator(((0, _index.bisect)(domain, x, 1) - 1) / (domain.length - 1));
    }
    scale.domain = function(_) {
        if (!arguments.length) return domain.slice();
        domain = [];
        for (let d of _)if (d != null && !isNaN(d = +d)) domain.push(d);
        domain.sort(_index.ascending);
        return scale;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    scale.range = function() {
        return domain.map((d, i)=>interpolator(i / (domain.length - 1)));
    };
    scale.quantiles = function(n) {
        return Array.from({
            length: n + 1
        }, (_, i)=>(0, _index.quantile)(domain, i / n));
    };
    scale.copy = function() {
        return sequentialQuantile(interpolator).domain(domain);
    };
    return _init.initInterpolator.apply(scale, arguments);
}

},{"eed0055976263d50":"3WmRx","21618a239c62366b":"9w8kD","92ad1cf8524c146":"9c0mi"}],"526zm":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = diverging;
exports.divergingLog = divergingLog;
exports.divergingPow = divergingPow;
exports.divergingSqrt = divergingSqrt;
exports.divergingSymlog = divergingSymlog;
var _index = require("915e51d9b913a910");
var _continuous = require("bf6a55aee26f6305");
var _init = require("dafbeaec64c427e8");
var _linear = require("367c88af554f4c81");
var _log = require("f1b41897387bed31");
var _sequential = require("478631d13f9292c0");
var _symlog = require("f1514783e2b3953d");
var _pow = require("2cbbbabc7f04bb29");
function transformer() {
    var x0 = 0, x1 = 0.5, x2 = 1, s = 1, t0, t1, t2, k10, k21, interpolator = _continuous.identity, transform, clamp = false, unknown;
    function scale(x) {
        return isNaN(x = +x) ? unknown : (x = 0.5 + ((x = +transform(x)) - t1) * (s * x < s * t1 ? k10 : k21), interpolator(clamp ? Math.max(0, Math.min(1, x)) : x));
    }
    scale.domain = function(_) {
        return arguments.length ? ([x0, x1, x2] = _, t0 = transform(x0 = +x0), t1 = transform(x1 = +x1), t2 = transform(x2 = +x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1, scale) : [
            x0,
            x1,
            x2
        ];
    };
    scale.clamp = function(_) {
        return arguments.length ? (clamp = !!_, scale) : clamp;
    };
    scale.interpolator = function(_) {
        return arguments.length ? (interpolator = _, scale) : interpolator;
    };
    function range(interpolate) {
        return function(_) {
            var r0, r1, r2;
            return arguments.length ? ([r0, r1, r2] = _, interpolator = (0, _index.piecewise)(interpolate, [
                r0,
                r1,
                r2
            ]), scale) : [
                interpolator(0),
                interpolator(0.5),
                interpolator(1)
            ];
        };
    }
    scale.range = range(_index.interpolate);
    scale.rangeRound = range(_index.interpolateRound);
    scale.unknown = function(_) {
        return arguments.length ? (unknown = _, scale) : unknown;
    };
    return function(t) {
        transform = t, t0 = t(x0), t1 = t(x1), t2 = t(x2), k10 = t0 === t1 ? 0 : 0.5 / (t1 - t0), k21 = t1 === t2 ? 0 : 0.5 / (t2 - t1), s = t1 < t0 ? -1 : 1;
        return scale;
    };
}
function diverging() {
    var scale = (0, _linear.linearish)(transformer()(_continuous.identity));
    scale.copy = function() {
        return (0, _sequential.copy)(scale, diverging());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingLog() {
    var scale = (0, _log.loggish)(transformer()).domain([
        0.1,
        1,
        10
    ]);
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingLog()).base(scale.base());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingSymlog() {
    var scale = (0, _symlog.symlogish)(transformer());
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingSymlog()).constant(scale.constant());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingPow() {
    var scale = (0, _pow.powish)(transformer());
    scale.copy = function() {
        return (0, _sequential.copy)(scale, divergingPow()).exponent(scale.exponent());
    };
    return _init.initInterpolator.apply(scale, arguments);
}
function divergingSqrt() {
    return divergingPow.apply(null, arguments).exponent(0.5);
}

},{"915e51d9b913a910":"8saGV","bf6a55aee26f6305":"9w8kD","dafbeaec64c427e8":"9c0mi","367c88af554f4c81":"7wwWf","f1b41897387bed31":"b2mDf","478631d13f9292c0":"kJaHH","f1514783e2b3953d":"hnxTj","2cbbbabc7f04bb29":"7qYxn"}],"j0cmw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectChartDataWithIndexes", ()=>selectChartDataWithIndexes);
parcelHelpers.export(exports, "selectChartDataAndAlwaysIgnoreIndexes", ()=>selectChartDataAndAlwaysIgnoreIndexes);
parcelHelpers.export(exports, "selectChartDataWithIndexesIfNotInPanoramaPosition4", ()=>selectChartDataWithIndexesIfNotInPanoramaPosition4);
parcelHelpers.export(exports, "selectChartDataWithIndexesIfNotInPanoramaPosition3", ()=>selectChartDataWithIndexesIfNotInPanoramaPosition3);
var _reselect = require("reselect");
var selectChartDataWithIndexes = (state)=>state.chartData;
var selectChartDataAndAlwaysIgnoreIndexes = (0, _reselect.createSelector)([
    selectChartDataWithIndexes
], (dataState)=>{
    var dataEndIndex = dataState.chartData != null ? dataState.chartData.length - 1 : 0;
    return {
        chartData: dataState.chartData,
        computedData: dataState.computedData,
        dataEndIndex,
        dataStartIndex: 0
    };
});
var selectChartDataWithIndexesIfNotInPanoramaPosition4 = (state, _unused1, _unused2, isPanorama)=>{
    if (isPanorama) return selectChartDataAndAlwaysIgnoreIndexes(state);
    return selectChartDataWithIndexes(state);
};
var selectChartDataWithIndexesIfNotInPanoramaPosition3 = (state, _unused1, isPanorama)=>{
    if (isPanorama) return selectChartDataAndAlwaysIgnoreIndexes(state);
    return selectChartDataWithIndexes(state);
};

},{"reselect":"ds2su","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5AAMy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isWellFormedNumberDomain", ()=>isWellFormedNumberDomain);
parcelHelpers.export(exports, "extendDomain", ()=>extendDomain);
/**
 * So Recharts allows users to provide their own domains,
 * but it also places some expectations on what the domain is.
 * We can improve on the typescript typing, but we also need a runtime test
 to observe that the user-provided domain is well-formed,
 * that is: an array with exactly two numbers.
 *
 * This function does not accept data as an argument.
 * This is to enable a performance optimization - if the domain is there,
 * and we know what it is without traversing all the data,
 * then we don't have to traverse all the data!
 *
 * If the user-provided domain is not well-formed,
 * this function will return undefined - in which case we should traverse the data to calculate the real domain.
 *
 * This function is for parsing the numerical domain only.
 *
 * @param userDomain external prop, user provided, before validation. Can have various shapes: array, function, special magical strings inside too.
 * @param allowDataOverflow boolean, provided by users. If true then the data domain wins
 *
 * @return [min, max] domain if it's well-formed; undefined if the domain is invalid
 */ parcelHelpers.export(exports, "numericalDomainSpecifiedWithoutRequiringData", ()=>numericalDomainSpecifiedWithoutRequiringData);
/**
 * So Recharts allows users to provide their own domains,
 * but it also places some expectations on what the domain is.
 * We can improve on the typescript typing, but we also need a runtime test
 * to observe that the user-provided domain is well-formed,
 * that is: an array with exactly two numbers.
 * If the user-provided domain is not well-formed,
 * this function will return undefined - in which case we should traverse the data to calculate the real domain.
 *
 * This function is for parsing the numerical domain only.
 *
 * You are probably thinking, why does domain need tick count?
 * Well it adjusts the domain based on where the "nice ticks" land, and nice ticks depend on the tick count.
 *
 * @param userDomain external prop, user provided, before validation. Can have various shapes: array, function, special magical strings inside too.
 * @param dataDomain calculated from data. Can be undefined, as an option for performance optimization
 * @param allowDataOverflow provided by users. If true then the data domain wins
 *
 * @return [min, max] domain if it's well-formed; undefined if the domain is invalid
 */ parcelHelpers.export(exports, "parseNumericalUserDomain", ()=>parseNumericalUserDomain);
var _chartUtils = require("./ChartUtils");
var _dataUtils = require("./DataUtils");
var _isWellBehavedNumber = require("./isWellBehavedNumber");
function isWellFormedNumberDomain(v) {
    if (Array.isArray(v) && v.length === 2) {
        var [min, max] = v;
        if ((0, _isWellBehavedNumber.isWellBehavedNumber)(min) && (0, _isWellBehavedNumber.isWellBehavedNumber)(max)) return true;
    }
    return false;
}
function extendDomain(providedDomain, boundaryDomain, allowDataOverflow) {
    if (allowDataOverflow) // If the data are allowed to overflow - we're fine with whatever user provided
    return providedDomain;
    /*
   * If the data are not allowed to overflow - we need to extend the domain.
   * Means that effectively the user is allowed to make the domain larger
   * but not smaller.
   */ return [
        Math.min(providedDomain[0], boundaryDomain[0]),
        Math.max(providedDomain[1], boundaryDomain[1])
    ];
}
function numericalDomainSpecifiedWithoutRequiringData(userDomain, allowDataOverflow) {
    if (!allowDataOverflow) // Cannot compute data overflow if the data is not provided
    return undefined;
    if (typeof userDomain === 'function') // The user function expects the data to be provided as an argument
    return undefined;
    if (Array.isArray(userDomain) && userDomain.length === 2) {
        var [providedMin, providedMax] = userDomain;
        var finalMin, finalMax;
        if ((0, _isWellBehavedNumber.isWellBehavedNumber)(providedMin)) finalMin = providedMin;
        else if (typeof providedMin === 'function') // The user function expects the data to be provided as an argument
        return undefined;
        if ((0, _isWellBehavedNumber.isWellBehavedNumber)(providedMax)) finalMax = providedMax;
        else if (typeof providedMax === 'function') // The user function expects the data to be provided as an argument
        return undefined;
        var candidate = [
            finalMin,
            finalMax
        ];
        if (isWellFormedNumberDomain(candidate)) return candidate;
    }
    return undefined;
}
function parseNumericalUserDomain(userDomain, dataDomain, allowDataOverflow) {
    if (!allowDataOverflow && dataDomain == null) // Cannot compute data overflow if the data is not provided
    return undefined;
    if (typeof userDomain === 'function' && dataDomain != null) try {
        var result = userDomain(dataDomain, allowDataOverflow);
        if (isWellFormedNumberDomain(result)) return extendDomain(result, dataDomain, allowDataOverflow);
    } catch (_unused) {
    /* ignore the exception and compute domain from data later */ }
    if (Array.isArray(userDomain) && userDomain.length === 2) {
        var [providedMin, providedMax] = userDomain;
        var finalMin, finalMax;
        if (providedMin === 'auto') {
            if (dataDomain != null) finalMin = Math.min(...dataDomain);
        } else if ((0, _dataUtils.isNumber)(providedMin)) finalMin = providedMin;
        else if (typeof providedMin === 'function') try {
            if (dataDomain != null) finalMin = providedMin(dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[0]);
        } catch (_unused2) {
        /* ignore the exception and compute domain from data later */ }
        else if (typeof providedMin === 'string' && (0, _chartUtils.MIN_VALUE_REG).test(providedMin)) {
            var match = (0, _chartUtils.MIN_VALUE_REG).exec(providedMin);
            if (match == null || match[1] == null || dataDomain == null) finalMin = undefined;
            else {
                var value = +match[1];
                finalMin = dataDomain[0] - value;
            }
        } else finalMin = dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[0];
        if (providedMax === 'auto') {
            if (dataDomain != null) finalMax = Math.max(...dataDomain);
        } else if ((0, _dataUtils.isNumber)(providedMax)) finalMax = providedMax;
        else if (typeof providedMax === 'function') try {
            if (dataDomain != null) finalMax = providedMax(dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[1]);
        } catch (_unused3) {
        /* ignore the exception and compute domain from data later */ }
        else if (typeof providedMax === 'string' && (0, _chartUtils.MAX_VALUE_REG).test(providedMax)) {
            var _match = (0, _chartUtils.MAX_VALUE_REG).exec(providedMax);
            if (_match == null || _match[1] == null || dataDomain == null) finalMax = undefined;
            else {
                var _value = +_match[1];
                finalMax = dataDomain[1] + _value;
            }
        } else finalMax = dataDomain === null || dataDomain === void 0 ? void 0 : dataDomain[1];
        var candidate = [
            finalMin,
            finalMax
        ];
        if (isWellFormedNumberDomain(candidate)) {
            if (dataDomain == null) return candidate;
            return extendDomain(candidate, dataDomain, allowDataOverflow);
        }
    }
    return undefined;
}

},{"./ChartUtils":"enJyE","./DataUtils":"lNZEj","./isWellBehavedNumber":"aIsFR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"65ekg":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview calculate tick values of scale
 * @author xile611, arcthur
 * @date 2015-09-17
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getValidInterval", ()=>getValidInterval);
parcelHelpers.export(exports, "getFormatStep", ()=>getFormatStep);
parcelHelpers.export(exports, "getTickOfSingleValue", ()=>getTickOfSingleValue);
/**
 * Calculate the ticks of an interval. Ticks can appear outside the interval
 * if it makes them more rounded and nice.
 *
 * @param tuple of [min,max] min: The minimum value, max: The maximum value
 * @param tickCount     The count of ticks
 * @param allowDecimals Allow the ticks to be decimals or not
 * @return array of ticks
 */ parcelHelpers.export(exports, "calculateStep", ()=>_calculateStep);
parcelHelpers.export(exports, "getNiceTickValues", ()=>getNiceTickValues);
parcelHelpers.export(exports, "getTickValuesFixedDomain", ()=>getTickValuesFixedDomain);
var _decimalJsLight = require("decimal.js-light");
var _decimalJsLightDefault = parcelHelpers.interopDefault(_decimalJsLight);
var _utils = require("./util/utils");
var _arithmetic = require("./util/arithmetic");
var getValidInterval = (_ref)=>{
    var [min, max] = _ref;
    var [validMin, validMax] = [
        min,
        max
    ];
    // exchange
    if (min > max) [validMin, validMax] = [
        max,
        min
    ];
    return [
        validMin,
        validMax
    ];
};
var getFormatStep = (roughStep, allowDecimals, correctionFactor)=>{
    if (roughStep.lte(0)) return new (0, _decimalJsLightDefault.default)(0);
    var digitCount = (0, _arithmetic.getDigitCount)(roughStep.toNumber());
    // The ratio between the rough step and the smallest number which has a bigger
    // order of magnitudes than the rough step
    var digitCountValue = new (0, _decimalJsLightDefault.default)(10).pow(digitCount);
    var stepRatio = roughStep.div(digitCountValue);
    // When an integer and a float multiplied, the accuracy of result may be wrong
    var stepRatioScale = digitCount !== 1 ? 0.05 : 0.1;
    var amendStepRatio = new (0, _decimalJsLightDefault.default)(Math.ceil(stepRatio.div(stepRatioScale).toNumber())).add(correctionFactor).mul(stepRatioScale);
    var formatStep = amendStepRatio.mul(digitCountValue);
    return allowDecimals ? new (0, _decimalJsLightDefault.default)(formatStep.toNumber()) : new (0, _decimalJsLightDefault.default)(Math.ceil(formatStep.toNumber()));
};
var getTickOfSingleValue = (value, tickCount, allowDecimals)=>{
    var step = new (0, _decimalJsLightDefault.default)(1);
    // calculate the middle value of ticks
    var middle = new (0, _decimalJsLightDefault.default)(value);
    if (!middle.isint() && allowDecimals) {
        var absVal = Math.abs(value);
        if (absVal < 1) {
            // The step should be a float number when the difference is smaller than 1
            step = new (0, _decimalJsLightDefault.default)(10).pow((0, _arithmetic.getDigitCount)(value) - 1);
            middle = new (0, _decimalJsLightDefault.default)(Math.floor(middle.div(step).toNumber())).mul(step);
        } else if (absVal > 1) // Return the maximum integer which is smaller than 'value' when 'value' is greater than 1
        middle = new (0, _decimalJsLightDefault.default)(Math.floor(value));
    } else if (value === 0) middle = new (0, _decimalJsLightDefault.default)(Math.floor((tickCount - 1) / 2));
    else if (!allowDecimals) middle = new (0, _decimalJsLightDefault.default)(Math.floor(value));
    var middleIndex = Math.floor((tickCount - 1) / 2);
    var fn = (0, _utils.compose)((0, _utils.map)((n)=>middle.add(new (0, _decimalJsLightDefault.default)(n - middleIndex).mul(step)).toNumber()), (0, _utils.range));
    return fn(0, tickCount);
};
/**
 * Calculate the step
 *
 * @param  min              The minimum value of an interval
 * @param  max              The maximum value of an interval
 * @param  tickCount        The count of ticks
 * @param  allowDecimals    Allow the ticks to be decimals or not
 * @param  correctionFactor A correction factor
 * @return The step, minimum value of ticks, maximum value of ticks
 */ var _calculateStep = function calculateStep(min, max, tickCount, allowDecimals) {
    var correctionFactor = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    // dirty hack (for recharts' test)
    if (!Number.isFinite((max - min) / (tickCount - 1))) return {
        step: new (0, _decimalJsLightDefault.default)(0),
        tickMin: new (0, _decimalJsLightDefault.default)(0),
        tickMax: new (0, _decimalJsLightDefault.default)(0)
    };
    // The step which is easy to understand between two ticks
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(max).sub(min).div(tickCount - 1), allowDecimals, correctionFactor);
    // A medial value of ticks
    var middle;
    // When 0 is inside the interval, 0 should be a tick
    if (min <= 0 && max >= 0) middle = new (0, _decimalJsLightDefault.default)(0);
    else {
        // calculate the middle value
        middle = new (0, _decimalJsLightDefault.default)(min).add(max).div(2);
        // minus modulo value
        middle = middle.sub(new (0, _decimalJsLightDefault.default)(middle).mod(step));
    }
    var belowCount = Math.ceil(middle.sub(min).div(step).toNumber());
    var upCount = Math.ceil(new (0, _decimalJsLightDefault.default)(max).sub(middle).div(step).toNumber());
    var scaleCount = belowCount + upCount + 1;
    if (scaleCount > tickCount) // When more ticks need to cover the interval, step should be bigger.
    return _calculateStep(min, max, tickCount, allowDecimals, correctionFactor + 1);
    if (scaleCount < tickCount) {
        // When less ticks can cover the interval, we should add some additional ticks
        upCount = max > 0 ? upCount + (tickCount - scaleCount) : upCount;
        belowCount = max > 0 ? belowCount : belowCount + (tickCount - scaleCount);
    }
    return {
        step,
        tickMin: middle.sub(new (0, _decimalJsLightDefault.default)(belowCount).mul(step)),
        tickMax: middle.add(new (0, _decimalJsLightDefault.default)(upCount).mul(step))
    };
};
var getNiceTickValues = function getNiceTickValues(_ref2) {
    var [min, max] = _ref2;
    var tickCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 6;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var count = Math.max(tickCount, 2);
    var [cormin, cormax] = getValidInterval([
        min,
        max
    ]);
    if (cormin === -Infinity || cormax === Infinity) {
        var _values = cormax === Infinity ? [
            cormin,
            ...(0, _utils.range)(0, tickCount - 1).map(()=>Infinity)
        ] : [
            ...(0, _utils.range)(0, tickCount - 1).map(()=>-Infinity),
            cormax
        ];
        return min > max ? _values.reverse() : _values;
    }
    if (cormin === cormax) return getTickOfSingleValue(cormin, tickCount, allowDecimals);
    // Get the step between two ticks
    var { step, tickMin, tickMax } = _calculateStep(cormin, cormax, count, allowDecimals, 0);
    var values = (0, _arithmetic.rangeStep)(tickMin, tickMax.add(new (0, _decimalJsLightDefault.default)(0.1).mul(step)), step);
    return min > max ? values.reverse() : values;
};
var getTickValuesFixedDomain = function getTickValuesFixedDomain(_ref3, tickCount) {
    var [min, max] = _ref3;
    var allowDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    // More than two ticks should be return
    var [cormin, cormax] = getValidInterval([
        min,
        max
    ]);
    if (cormin === -Infinity || cormax === Infinity) return [
        min,
        max
    ];
    if (cormin === cormax) return [
        cormin
    ];
    var count = Math.max(tickCount, 2);
    var step = getFormatStep(new (0, _decimalJsLightDefault.default)(cormax).sub(cormin).div(count - 1), allowDecimals, 0);
    var values = [
        ...(0, _arithmetic.rangeStep)(new (0, _decimalJsLightDefault.default)(cormin), new (0, _decimalJsLightDefault.default)(cormax), step),
        cormax
    ];
    if (allowDecimals === false) /*
     * allowDecimals is false means that we want to have integer ticks.
     * The step is guaranteed to be an integer in the code above which is great start
     * but when the first step is not an integer, it will start stepping from a decimal value anyway.
     * So we need to round all the values to integers after the fact.
     */ values = values.map((value)=>Math.round(value));
    return min > max ? values.reverse() : values;
};

},{"decimal.js-light":"eFP63","./util/utils":"gx5Ju","./util/arithmetic":"f2trb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eFP63":[function(require,module,exports,__globalThis) {
/*! decimal.js-light v2.5.1 https://github.com/MikeMcl/decimal.js-light/LICENCE */ (function(globalScope) {
    'use strict';
    /*
   *  decimal.js-light v2.5.1
   *  An arbitrary-precision Decimal type for JavaScript.
   *  https://github.com/MikeMcl/decimal.js-light
   *  Copyright (c) 2020 Michael Mclaughlin <M8ch88l@gmail.com>
   *  MIT Expat Licence
   */ // -----------------------------------  EDITABLE DEFAULTS  ------------------------------------ //
    // The limit on the value of `precision`, and on the value of the first argument to
    // `toDecimalPlaces`, `toExponential`, `toFixed`, `toPrecision` and `toSignificantDigits`.
    var MAX_DIGITS = 1e9, // The initial configuration properties of the Decimal constructor.
    Decimal = {
        // These values must be integers within the stated ranges (inclusive).
        // Most of these values can be changed during run-time using `Decimal.config`.
        // The maximum number of significant digits of the result of a calculation or base conversion.
        // E.g. `Decimal.config({ precision: 20 });`
        precision: 20,
        // The rounding mode used by default by `toInteger`, `toDecimalPlaces`, `toExponential`,
        // `toFixed`, `toPrecision` and `toSignificantDigits`.
        //
        // ROUND_UP         0 Away from zero.
        // ROUND_DOWN       1 Towards zero.
        // ROUND_CEIL       2 Towards +Infinity.
        // ROUND_FLOOR      3 Towards -Infinity.
        // ROUND_HALF_UP    4 Towards nearest neighbour. If equidistant, up.
        // ROUND_HALF_DOWN  5 Towards nearest neighbour. If equidistant, down.
        // ROUND_HALF_EVEN  6 Towards nearest neighbour. If equidistant, towards even neighbour.
        // ROUND_HALF_CEIL  7 Towards nearest neighbour. If equidistant, towards +Infinity.
        // ROUND_HALF_FLOOR 8 Towards nearest neighbour. If equidistant, towards -Infinity.
        //
        // E.g.
        // `Decimal.rounding = 4;`
        // `Decimal.rounding = Decimal.ROUND_HALF_UP;`
        rounding: 4,
        // The exponent value at and beneath which `toString` returns exponential notation.
        // JavaScript numbers: -7
        toExpNeg: -7,
        // The exponent value at and above which `toString` returns exponential notation.
        // JavaScript numbers: 21
        toExpPos: 21,
        // The natural logarithm of 10.
        // 115 digits
        LN10: '2.302585092994045684017991454684364207601101488628772976033327900967572609677352480235997205089598298341967784042286'
    }, // ----------------------------------- END OF EDITABLE DEFAULTS ------------------------------- //
    external = true, decimalError = '[DecimalError] ', invalidArgument = decimalError + 'Invalid argument: ', exponentOutOfRange = decimalError + 'Exponent out of range: ', mathfloor = Math.floor, mathpow = Math.pow, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, ONE, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, MAX_E = mathfloor(MAX_SAFE_INTEGER / LOG_BASE), // Decimal.prototype object
    P = {};
    // Decimal prototype methods
    /*
   *  absoluteValue                       abs
   *  comparedTo                          cmp
   *  decimalPlaces                       dp
   *  dividedBy                           div
   *  dividedToIntegerBy                  idiv
   *  equals                              eq
   *  exponent
   *  greaterThan                         gt
   *  greaterThanOrEqualTo                gte
   *  isInteger                           isint
   *  isNegative                          isneg
   *  isPositive                          ispos
   *  isZero
   *  lessThan                            lt
   *  lessThanOrEqualTo                   lte
   *  logarithm                           log
   *  minus                               sub
   *  modulo                              mod
   *  naturalExponential                  exp
   *  naturalLogarithm                    ln
   *  negated                             neg
   *  plus                                add
   *  precision                           sd
   *  squareRoot                          sqrt
   *  times                               mul
   *  toDecimalPlaces                     todp
   *  toExponential
   *  toFixed
   *  toInteger                           toint
   *  toNumber
   *  toPower                             pow
   *  toPrecision
   *  toSignificantDigits                 tosd
   *  toString
   *  valueOf                             val
   */ /*
   * Return a new Decimal whose value is the absolute value of this Decimal.
   *
   */ P.absoluteValue = P.abs = function() {
        var x = new this.constructor(this);
        if (x.s) x.s = 1;
        return x;
    };
    /*
   * Return
   *   1    if the value of this Decimal is greater than the value of `y`,
   *  -1    if the value of this Decimal is less than the value of `y`,
   *   0    if they have the same value
   *
   */ P.comparedTo = P.cmp = function(y) {
        var i, j, xdL, ydL, x = this;
        y = new x.constructor(y);
        // Signs differ?
        if (x.s !== y.s) return x.s || -y.s;
        // Compare exponents.
        if (x.e !== y.e) return x.e > y.e ^ x.s < 0 ? 1 : -1;
        xdL = x.d.length;
        ydL = y.d.length;
        // Compare digit by digit.
        for(i = 0, j = xdL < ydL ? xdL : ydL; i < j; ++i){
            if (x.d[i] !== y.d[i]) return x.d[i] > y.d[i] ^ x.s < 0 ? 1 : -1;
        }
        // Compare lengths.
        return xdL === ydL ? 0 : xdL > ydL ^ x.s < 0 ? 1 : -1;
    };
    /*
   * Return the number of decimal places of the value of this Decimal.
   *
   */ P.decimalPlaces = P.dp = function() {
        var x = this, w = x.d.length - 1, dp = (w - x.e) * LOG_BASE;
        // Subtract the number of trailing zeros of the last word.
        w = x.d[w];
        if (w) for(; w % 10 == 0; w /= 10)dp--;
        return dp < 0 ? 0 : dp;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal divided by `y`, truncated to
   * `precision` significant digits.
   *
   */ P.dividedBy = P.div = function(y) {
        return divide(this, new this.constructor(y));
    };
    /*
   * Return a new Decimal whose value is the integer part of dividing the value of this Decimal
   * by the value of `y`, truncated to `precision` significant digits.
   *
   */ P.dividedToIntegerBy = P.idiv = function(y) {
        var x = this, Ctor = x.constructor;
        return round(divide(x, new Ctor(y), 0, 1), Ctor.precision);
    };
    /*
   * Return true if the value of this Decimal is equal to the value of `y`, otherwise return false.
   *
   */ P.equals = P.eq = function(y) {
        return !this.cmp(y);
    };
    /*
   * Return the (base 10) exponent value of this Decimal (this.e is the base 10000000 exponent).
   *
   */ P.exponent = function() {
        return getBase10Exponent(this);
    };
    /*
   * Return true if the value of this Decimal is greater than the value of `y`, otherwise return
   * false.
   *
   */ P.greaterThan = P.gt = function(y) {
        return this.cmp(y) > 0;
    };
    /*
   * Return true if the value of this Decimal is greater than or equal to the value of `y`,
   * otherwise return false.
   *
   */ P.greaterThanOrEqualTo = P.gte = function(y) {
        return this.cmp(y) >= 0;
    };
    /*
   * Return true if the value of this Decimal is an integer, otherwise return false.
   *
   */ P.isInteger = P.isint = function() {
        return this.e > this.d.length - 2;
    };
    /*
   * Return true if the value of this Decimal is negative, otherwise return false.
   *
   */ P.isNegative = P.isneg = function() {
        return this.s < 0;
    };
    /*
   * Return true if the value of this Decimal is positive, otherwise return false.
   *
   */ P.isPositive = P.ispos = function() {
        return this.s > 0;
    };
    /*
   * Return true if the value of this Decimal is 0, otherwise return false.
   *
   */ P.isZero = function() {
        return this.s === 0;
    };
    /*
   * Return true if the value of this Decimal is less than `y`, otherwise return false.
   *
   */ P.lessThan = P.lt = function(y) {
        return this.cmp(y) < 0;
    };
    /*
   * Return true if the value of this Decimal is less than or equal to `y`, otherwise return false.
   *
   */ P.lessThanOrEqualTo = P.lte = function(y) {
        return this.cmp(y) < 1;
    };
    /*
   * Return the logarithm of the value of this Decimal to the specified base, truncated to
   * `precision` significant digits.
   *
   * If no base is specified, return log[10](x).
   *
   * log[base](x) = ln(x) / ln(base)
   *
   * The maximum error of the result is 1 ulp (unit in the last place).
   *
   * [base] {number|string|Decimal} The base of the logarithm.
   *
   */ P.logarithm = P.log = function(base) {
        var r, x = this, Ctor = x.constructor, pr = Ctor.precision, wpr = pr + 5;
        // Default base is 10.
        if (base === void 0) base = new Ctor(10);
        else {
            base = new Ctor(base);
            // log[-b](x) = NaN
            // log[0](x)  = NaN
            // log[1](x)  = NaN
            if (base.s < 1 || base.eq(ONE)) throw Error(decimalError + 'NaN');
        }
        // log[b](-x) = NaN
        // log[b](0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // log[b](1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        external = false;
        r = divide(ln(x, wpr), ln(base, wpr), wpr);
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal minus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.minus = P.sub = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? subtract(x, y) : add(x, (y.s = -y.s, y));
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal modulo `y`, truncated to
   * `precision` significant digits.
   *
   */ P.modulo = P.mod = function(y) {
        var q, x = this, Ctor = x.constructor, pr = Ctor.precision;
        y = new Ctor(y);
        // x % 0 = NaN
        if (!y.s) throw Error(decimalError + 'NaN');
        // Return x if x is 0.
        if (!x.s) return round(new Ctor(x), pr);
        // Prevent rounding of intermediate calculations.
        external = false;
        q = divide(x, y, 0, 1).times(y);
        external = true;
        return x.minus(q);
    };
    /*
   * Return a new Decimal whose value is the natural exponential of the value of this Decimal,
   * i.e. the base e raised to the power the value of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.naturalExponential = P.exp = function() {
        return exp(this);
    };
    /*
   * Return a new Decimal whose value is the natural logarithm of the value of this Decimal,
   * truncated to `precision` significant digits.
   *
   */ P.naturalLogarithm = P.ln = function() {
        return ln(this);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal negated, i.e. as if multiplied by
   * -1.
   *
   */ P.negated = P.neg = function() {
        var x = new this.constructor(this);
        x.s = -x.s || 0;
        return x;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal plus `y`, truncated to
   * `precision` significant digits.
   *
   */ P.plus = P.add = function(y) {
        var x = this;
        y = new x.constructor(y);
        return x.s == y.s ? add(x, y) : subtract(x, (y.s = -y.s, y));
    };
    /*
   * Return the number of significant digits of the value of this Decimal.
   *
   * [z] {boolean|number} Whether to count integer-part trailing zeros: true, false, 1 or 0.
   *
   */ P.precision = P.sd = function(z) {
        var e, sd, w, x = this;
        if (z !== void 0 && z !== !!z && z !== 1 && z !== 0) throw Error(invalidArgument + z);
        e = getBase10Exponent(x) + 1;
        w = x.d.length - 1;
        sd = w * LOG_BASE + 1;
        w = x.d[w];
        // If non-zero...
        if (w) {
            // Subtract the number of trailing zeros of the last word.
            for(; w % 10 == 0; w /= 10)sd--;
            // Add the number of digits of the first word.
            for(w = x.d[0]; w >= 10; w /= 10)sd++;
        }
        return z && e > sd ? e : sd;
    };
    /*
   * Return a new Decimal whose value is the square root of this Decimal, truncated to `precision`
   * significant digits.
   *
   */ P.squareRoot = P.sqrt = function() {
        var e, n, pr, r, s, t, wpr, x = this, Ctor = x.constructor;
        // Negative or zero?
        if (x.s < 1) {
            if (!x.s) return new Ctor(0);
            // sqrt(-x) = NaN
            throw Error(decimalError + 'NaN');
        }
        e = getBase10Exponent(x);
        external = false;
        // Initial estimate.
        s = Math.sqrt(+x);
        // Math.sqrt underflow/overflow?
        // Pass x to Math.sqrt as integer, then adjust the exponent of the result.
        if (s == 0 || s == 1 / 0) {
            n = digitsToString(x.d);
            if ((n.length + e) % 2 == 0) n += '0';
            s = Math.sqrt(n);
            e = mathfloor((e + 1) / 2) - (e < 0 || e % 2);
            if (s == 1 / 0) n = '5e' + e;
            else {
                n = s.toExponential();
                n = n.slice(0, n.indexOf('e') + 1) + e;
            }
            r = new Ctor(n);
        } else r = new Ctor(s.toString());
        pr = Ctor.precision;
        s = wpr = pr + 3;
        // Newton-Raphson iteration.
        for(;;){
            t = r;
            r = t.plus(divide(x, t, wpr + 2)).times(0.5);
            if (digitsToString(t.d).slice(0, wpr) === (n = digitsToString(r.d)).slice(0, wpr)) {
                n = n.slice(wpr - 3, wpr + 1);
                // The 4th rounding digit may be in error by -1 so if the 4 rounding digits are 9999 or
                // 4999, i.e. approaching a rounding boundary, continue the iteration.
                if (s == wpr && n == '4999') {
                    // On the first iteration only, check to see if rounding up gives the exact result as the
                    // nines may infinitely repeat.
                    round(t, pr + 1, 0);
                    if (t.times(t).eq(x)) {
                        r = t;
                        break;
                    }
                } else if (n != '9999') break;
                wpr += 4;
            }
        }
        external = true;
        return round(r, pr);
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal times `y`, truncated to
   * `precision` significant digits.
   *
   */ P.times = P.mul = function(y) {
        var carry, e, i, k, r, rL, t, xdL, ydL, x = this, Ctor = x.constructor, xd = x.d, yd = (y = new Ctor(y)).d;
        // Return 0 if either is 0.
        if (!x.s || !y.s) return new Ctor(0);
        y.s *= x.s;
        e = x.e + y.e;
        xdL = xd.length;
        ydL = yd.length;
        // Ensure xd points to the longer array.
        if (xdL < ydL) {
            r = xd;
            xd = yd;
            yd = r;
            rL = xdL;
            xdL = ydL;
            ydL = rL;
        }
        // Initialise the result array with zeros.
        r = [];
        rL = xdL + ydL;
        for(i = rL; i--;)r.push(0);
        // Multiply!
        for(i = ydL; --i >= 0;){
            carry = 0;
            for(k = xdL + i; k > i;){
                t = r[k] + yd[i] * xd[k - i - 1] + carry;
                r[k--] = t % BASE | 0;
                carry = t / BASE | 0;
            }
            r[k] = (r[k] + carry) % BASE | 0;
        }
        // Remove trailing zeros.
        for(; !r[--rL];)r.pop();
        if (carry) ++e;
        else r.shift();
        y.d = r;
        y.e = e;
        return external ? round(y, Ctor.precision) : y;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `dp`
   * decimal places using rounding mode `rm` or `rounding` if `rm` is omitted.
   *
   * If `dp` is omitted, return a new Decimal whose value is the value of this Decimal.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toDecimalPlaces = P.todp = function(dp, rm) {
        var x = this, Ctor = x.constructor;
        x = new Ctor(x);
        if (dp === void 0) return x;
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        return round(x, dp + getBase10Exponent(x) + 1, rm);
    };
    /*
   * Return a string representing the value of this Decimal in exponential notation rounded to
   * `dp` fixed decimal places using rounding mode `rounding`.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toExponential = function(dp, rm) {
        var str, x = this, Ctor = x.constructor;
        if (dp === void 0) str = toString(x, true);
        else {
            checkInt32(dp, 0, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), dp + 1, rm);
            str = toString(x, true, dp + 1);
        }
        return str;
    };
    /*
   * Return a string representing the value of this Decimal in normal (fixed-point) notation to
   * `dp` fixed decimal places and rounded using rounding mode `rm` or `rounding` if `rm` is
   * omitted.
   *
   * As with JavaScript numbers, (-0).toFixed(0) is '0', but e.g. (-0.00001).toFixed(0) is '-0'.
   *
   * [dp] {number} Decimal places. Integer, 0 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
   * (-0).toFixed(3) is '0.000'.
   * (-0.5).toFixed(0) is '-0'.
   *
   */ P.toFixed = function(dp, rm) {
        var str, y, x = this, Ctor = x.constructor;
        if (dp === void 0) return toString(x);
        checkInt32(dp, 0, MAX_DIGITS);
        if (rm === void 0) rm = Ctor.rounding;
        else checkInt32(rm, 0, 8);
        y = round(new Ctor(x), dp + getBase10Exponent(x) + 1, rm);
        str = toString(y.abs(), false, dp + getBase10Exponent(y) + 1);
        // To determine whether to add the minus sign look at the value before it was rounded,
        // i.e. look at `x` rather than `y`.
        return x.isneg() && !x.isZero() ? '-' + str : str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a whole number using
   * rounding mode `rounding`.
   *
   */ P.toInteger = P.toint = function() {
        var x = this, Ctor = x.constructor;
        return round(new Ctor(x), getBase10Exponent(x) + 1, Ctor.rounding);
    };
    /*
   * Return the value of this Decimal converted to a number primitive.
   *
   */ P.toNumber = function() {
        return +this;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal raised to the power `y`,
   * truncated to `precision` significant digits.
   *
   * For non-integer or very large exponents pow(x, y) is calculated using
   *
   *   x^y = exp(y*ln(x))
   *
   * The maximum error is 1 ulp (unit in last place).
   *
   * y {number|string|Decimal} The power to which to raise this Decimal.
   *
   */ P.toPower = P.pow = function(y) {
        var e, k, pr, r, sign, yIsInt, x = this, Ctor = x.constructor, guard = 12, yn = +(y = new Ctor(y));
        // pow(x, 0) = 1
        if (!y.s) return new Ctor(ONE);
        x = new Ctor(x);
        // pow(0, y > 0) = 0
        // pow(0, y < 0) = Infinity
        if (!x.s) {
            if (y.s < 1) throw Error(decimalError + 'Infinity');
            return x;
        }
        // pow(1, y) = 1
        if (x.eq(ONE)) return x;
        pr = Ctor.precision;
        // pow(x, 1) = x
        if (y.eq(ONE)) return round(x, pr);
        e = y.e;
        k = y.d.length - 1;
        yIsInt = e >= k;
        sign = x.s;
        if (!yIsInt) {
            // pow(x < 0, y non-integer) = NaN
            if (sign < 0) throw Error(decimalError + 'NaN');
        // If y is a small integer use the 'exponentiation by squaring' algorithm.
        } else if ((k = yn < 0 ? -yn : yn) <= MAX_SAFE_INTEGER) {
            r = new Ctor(ONE);
            // Max k of 9007199254740991 takes 53 loop iterations.
            // Maximum digits array length; leaves [28, 34] guard digits.
            e = Math.ceil(pr / LOG_BASE + 4);
            external = false;
            for(;;){
                if (k % 2) {
                    r = r.times(x);
                    truncate(r.d, e);
                }
                k = mathfloor(k / 2);
                if (k === 0) break;
                x = x.times(x);
                truncate(x.d, e);
            }
            external = true;
            return y.s < 0 ? new Ctor(ONE).div(r) : round(r, pr);
        }
        // Result is negative if x is negative and the last digit of integer y is odd.
        sign = sign < 0 && y.d[Math.max(e, k)] & 1 ? -1 : 1;
        x.s = 1;
        external = false;
        r = y.times(ln(x, pr + guard));
        external = true;
        r = exp(r);
        r.s = sign;
        return r;
    };
    /*
   * Return a string representing the value of this Decimal rounded to `sd` significant digits
   * using rounding mode `rounding`.
   *
   * Return exponential notation if `sd` is less than the number of digits necessary to represent
   * the integer part of the value in normal notation.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toPrecision = function(sd, rm) {
        var e, str, x = this, Ctor = x.constructor;
        if (sd === void 0) {
            e = getBase10Exponent(x);
            str = toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
            x = round(new Ctor(x), sd, rm);
            e = getBase10Exponent(x);
            str = toString(x, sd <= e || e <= Ctor.toExpNeg, sd);
        }
        return str;
    };
    /*
   * Return a new Decimal whose value is the value of this Decimal rounded to a maximum of `sd`
   * significant digits using rounding mode `rm`, or to `precision` and `rounding` respectively if
   * omitted.
   *
   * [sd] {number} Significant digits. Integer, 1 to MAX_DIGITS inclusive.
   * [rm] {number} Rounding mode. Integer, 0 to 8 inclusive.
   *
   */ P.toSignificantDigits = P.tosd = function(sd, rm) {
        var x = this, Ctor = x.constructor;
        if (sd === void 0) {
            sd = Ctor.precision;
            rm = Ctor.rounding;
        } else {
            checkInt32(sd, 1, MAX_DIGITS);
            if (rm === void 0) rm = Ctor.rounding;
            else checkInt32(rm, 0, 8);
        }
        return round(new Ctor(x), sd, rm);
    };
    /*
   * Return a string representing the value of this Decimal.
   *
   * Return exponential notation if this Decimal has a positive exponent equal to or greater than
   * `toExpPos`, or a negative exponent equal to or less than `toExpNeg`.
   *
   */ P.toString = P.valueOf = P.val = P.toJSON = function() {
        var x = this, e = getBase10Exponent(x), Ctor = x.constructor;
        return toString(x, e <= Ctor.toExpNeg || e >= Ctor.toExpPos);
    };
    // Helper functions for Decimal.prototype (P) and/or Decimal methods, and their callers.
    /*
   *  add                 P.minus, P.plus
   *  checkInt32          P.todp, P.toExponential, P.toFixed, P.toPrecision, P.tosd
   *  digitsToString      P.log, P.sqrt, P.pow, toString, exp, ln
   *  divide              P.div, P.idiv, P.log, P.mod, P.sqrt, exp, ln
   *  exp                 P.exp, P.pow
   *  getBase10Exponent   P.exponent, P.sd, P.toint, P.sqrt, P.todp, P.toFixed, P.toPrecision,
   *                      P.toString, divide, round, toString, exp, ln
   *  getLn10             P.log, ln
   *  getZeroString       digitsToString, toString
   *  ln                  P.log, P.ln, P.pow, exp
   *  parseDecimal        Decimal
   *  round               P.abs, P.idiv, P.log, P.minus, P.mod, P.neg, P.plus, P.toint, P.sqrt,
   *                      P.times, P.todp, P.toExponential, P.toFixed, P.pow, P.toPrecision, P.tosd,
   *                      divide, getLn10, exp, ln
   *  subtract            P.minus, P.plus
   *  toString            P.toExponential, P.toFixed, P.toPrecision, P.toString, P.valueOf
   *  truncate            P.pow
   *
   *  Throws:             P.log, P.mod, P.sd, P.sqrt, P.pow,  checkInt32, divide, round,
   *                      getLn10, exp, ln, parseDecimal, Decimal, config
   */ function add(x, y) {
        var carry, d, e, i, k, len, xd, yd, Ctor = x.constructor, pr = Ctor.precision;
        // If either is zero...
        if (!x.s || !y.s) {
            // Return x if y is zero.
            // Return y if y is non-zero.
            if (!y.s) y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are finite, non-zero numbers with the same sign.
        k = x.e;
        e = y.e;
        xd = xd.slice();
        i = k - e;
        // If base 1e7 exponents differ...
        if (i) {
            if (i < 0) {
                d = xd;
                i = -i;
                len = yd.length;
            } else {
                d = yd;
                e = k;
                len = xd.length;
            }
            // Limit number of zeros prepended to max(ceil(pr / LOG_BASE), len) + 1.
            k = Math.ceil(pr / LOG_BASE);
            len = k > len ? k + 1 : len + 1;
            if (i > len) {
                i = len;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents. Note: Faster to use reverse then do unshifts.
            d.reverse();
            for(; i--;)d.push(0);
            d.reverse();
        }
        len = xd.length;
        i = yd.length;
        // If yd is longer than xd, swap xd and yd so xd points to the longer array.
        if (len - i < 0) {
            i = len;
            d = yd;
            yd = xd;
            xd = d;
        }
        // Only start adding at yd.length - 1 as the further digits of xd can be left as they are.
        for(carry = 0; i;){
            carry = (xd[--i] = xd[i] + yd[i] + carry) / BASE | 0;
            xd[i] %= BASE;
        }
        if (carry) {
            xd.unshift(carry);
            ++e;
        }
        // Remove trailing zeros.
        // No need to check for zero, as +x + +y != 0 && -x + -y != 0
        for(len = xd.length; xd[--len] == 0;)xd.pop();
        y.d = xd;
        y.e = e;
        return external ? round(y, pr) : y;
    }
    function checkInt32(i, min, max) {
        if (i !== ~~i || i < min || i > max) throw Error(invalidArgument + i);
    }
    function digitsToString(d) {
        var i, k, ws, indexOfLastWord = d.length - 1, str = '', w = d[0];
        if (indexOfLastWord > 0) {
            str += w;
            for(i = 1; i < indexOfLastWord; i++){
                ws = d[i] + '';
                k = LOG_BASE - ws.length;
                if (k) str += getZeroString(k);
                str += ws;
            }
            w = d[i];
            ws = w + '';
            k = LOG_BASE - ws.length;
            if (k) str += getZeroString(k);
        } else if (w === 0) return '0';
        // Remove trailing zeros of last w.
        for(; w % 10 === 0;)w /= 10;
        return str + w;
    }
    var divide = function() {
        // Assumes non-zero x and k, and hence non-zero result.
        function multiplyInteger(x, k) {
            var temp, carry = 0, i = x.length;
            for(x = x.slice(); i--;){
                temp = x[i] * k + carry;
                x[i] = temp % BASE | 0;
                carry = temp / BASE | 0;
            }
            if (carry) x.unshift(carry);
            return x;
        }
        function compare(a, b, aL, bL) {
            var i, r;
            if (aL != bL) r = aL > bL ? 1 : -1;
            else {
                for(i = r = 0; i < aL; i++)if (a[i] != b[i]) {
                    r = a[i] > b[i] ? 1 : -1;
                    break;
                }
            }
            return r;
        }
        function subtract(a, b, aL) {
            var i = 0;
            // Subtract b from a.
            for(; aL--;){
                a[aL] -= i;
                i = a[aL] < b[aL] ? 1 : 0;
                a[aL] = i * BASE + a[aL] - b[aL];
            }
            // Remove leading zeros.
            for(; !a[0] && a.length > 1;)a.shift();
        }
        return function(x, y, pr, dp) {
            var cmp, e, i, k, prod, prodL, q, qd, rem, remL, rem0, sd, t, xi, xL, yd0, yL, yz, Ctor = x.constructor, sign = x.s == y.s ? 1 : -1, xd = x.d, yd = y.d;
            // Either 0?
            if (!x.s) return new Ctor(x);
            if (!y.s) throw Error(decimalError + 'Division by zero');
            e = x.e - y.e;
            yL = yd.length;
            xL = xd.length;
            q = new Ctor(sign);
            qd = q.d = [];
            // Result exponent may be one less than e.
            for(i = 0; yd[i] == (xd[i] || 0);)++i;
            if (yd[i] > (xd[i] || 0)) --e;
            if (pr == null) sd = pr = Ctor.precision;
            else if (dp) sd = pr + (getBase10Exponent(x) - getBase10Exponent(y)) + 1;
            else sd = pr;
            if (sd < 0) return new Ctor(0);
            // Convert precision in number of base 10 digits to base 1e7 digits.
            sd = sd / LOG_BASE + 2 | 0;
            i = 0;
            // divisor < 1e7
            if (yL == 1) {
                k = 0;
                yd = yd[0];
                sd++;
                // k is the carry.
                for(; (i < xL || k) && sd--; i++){
                    t = k * BASE + (xd[i] || 0);
                    qd[i] = t / yd | 0;
                    k = t % yd | 0;
                }
            // divisor >= 1e7
            } else {
                // Normalise xd and yd so highest order digit of yd is >= BASE/2
                k = BASE / (yd[0] + 1) | 0;
                if (k > 1) {
                    yd = multiplyInteger(yd, k);
                    xd = multiplyInteger(xd, k);
                    yL = yd.length;
                    xL = xd.length;
                }
                xi = yL;
                rem = xd.slice(0, yL);
                remL = rem.length;
                // Add zeros to make remainder as long as divisor.
                for(; remL < yL;)rem[remL++] = 0;
                yz = yd.slice();
                yz.unshift(0);
                yd0 = yd[0];
                if (yd[1] >= BASE / 2) ++yd0;
                do {
                    k = 0;
                    // Compare divisor and remainder.
                    cmp = compare(yd, rem, yL, remL);
                    // If divisor < remainder.
                    if (cmp < 0) {
                        // Calculate trial digit, k.
                        rem0 = rem[0];
                        if (yL != remL) rem0 = rem0 * BASE + (rem[1] || 0);
                        // k will be how many times the divisor goes into the current remainder.
                        k = rem0 / yd0 | 0;
                        //  Algorithm:
                        //  1. product = divisor * trial digit (k)
                        //  2. if product > remainder: product -= divisor, k--
                        //  3. remainder -= product
                        //  4. if product was < remainder at 2:
                        //    5. compare new remainder and divisor
                        //    6. If remainder > divisor: remainder -= divisor, k++
                        if (k > 1) {
                            if (k >= BASE) k = BASE - 1;
                            // product = divisor * trial digit.
                            prod = multiplyInteger(yd, k);
                            prodL = prod.length;
                            remL = rem.length;
                            // Compare product and remainder.
                            cmp = compare(prod, rem, prodL, remL);
                            // product > remainder.
                            if (cmp == 1) {
                                k--;
                                // Subtract divisor from product.
                                subtract(prod, yL < prodL ? yz : yd, prodL);
                            }
                        } else {
                            // cmp is -1.
                            // If k is 0, there is no need to compare yd and rem again below, so change cmp to 1
                            // to avoid it. If k is 1 there is a need to compare yd and rem again below.
                            if (k == 0) cmp = k = 1;
                            prod = yd.slice();
                        }
                        prodL = prod.length;
                        if (prodL < remL) prod.unshift(0);
                        // Subtract product from remainder.
                        subtract(rem, prod, remL);
                        // If product was < previous remainder.
                        if (cmp == -1) {
                            remL = rem.length;
                            // Compare divisor and new remainder.
                            cmp = compare(yd, rem, yL, remL);
                            // If divisor < new remainder, subtract divisor from remainder.
                            if (cmp < 1) {
                                k++;
                                // Subtract divisor from remainder.
                                subtract(rem, yL < remL ? yz : yd, remL);
                            }
                        }
                        remL = rem.length;
                    } else if (cmp === 0) {
                        k++;
                        rem = [
                            0
                        ];
                    } // if cmp === 1, k will be 0
                    // Add the next digit, k, to the result array.
                    qd[i++] = k;
                    // Update the remainder.
                    if (cmp && rem[0]) rem[remL++] = xd[xi] || 0;
                    else {
                        rem = [
                            xd[xi]
                        ];
                        remL = 1;
                    }
                }while ((xi++ < xL || rem[0] !== void 0) && sd--);
            }
            // Leading zero?
            if (!qd[0]) qd.shift();
            q.e = e;
            return round(q, dp ? pr + getBase10Exponent(q) + 1 : pr);
        };
    }();
    /*
   * Return a new Decimal whose value is the natural exponential of `x` truncated to `sd`
   * significant digits.
   *
   * Taylor/Maclaurin series.
   *
   * exp(x) = x^0/0! + x^1/1! + x^2/2! + x^3/3! + ...
   *
   * Argument reduction:
   *   Repeat x = x / 32, k += 5, until |x| < 0.1
   *   exp(x) = exp(x / 2^k)^(2^k)
   *
   * Previously, the argument was initially reduced by
   * exp(x) = exp(r) * 10^k  where r = x - k * ln10, k = floor(x / ln10)
   * to first put r in the range [0, ln10], before dividing by 32 until |x| < 0.1, but this was
   * found to be slower than just dividing repeatedly by 32 as above.
   *
   * (Math object integer min/max: Math.exp(709) = 8.2e+307, Math.exp(-745) = 5e-324)
   *
   *  exp(x) is non-terminating for any finite, non-zero x.
   *
   */ function exp(x, sd) {
        var denominator, guard, pow, sum, t, wpr, i = 0, k = 0, Ctor = x.constructor, pr = Ctor.precision;
        if (getBase10Exponent(x) > 16) throw Error(exponentOutOfRange + getBase10Exponent(x));
        // exp(0) = 1
        if (!x.s) return new Ctor(ONE);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        t = new Ctor(0.03125);
        while(x.abs().gte(0.1)){
            x = x.times(t); // x = x / 2^5
            k += 5;
        }
        // Estimate the precision increase necessary to ensure the first 4 rounding digits are correct.
        guard = Math.log(mathpow(2, k)) / Math.LN10 * 2 + 5 | 0;
        wpr += guard;
        denominator = pow = sum = new Ctor(ONE);
        Ctor.precision = wpr;
        for(;;){
            pow = round(pow.times(x), wpr);
            denominator = denominator.times(++i);
            t = sum.plus(divide(pow, denominator, wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                while(k--)sum = round(sum.times(sum), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
        }
    }
    // Calculate the base 10 exponent from the base 1e7 exponent.
    function getBase10Exponent(x) {
        var e = x.e * LOG_BASE, w = x.d[0];
        // Add the number of digits of the first word of the digits array.
        for(; w >= 10; w /= 10)e++;
        return e;
    }
    function getLn10(Ctor, sd, pr) {
        if (sd > Ctor.LN10.sd()) {
            // Reset global state in case the exception is caught.
            external = true;
            if (pr) Ctor.precision = pr;
            throw Error(decimalError + 'LN10 precision limit exceeded');
        }
        return round(new Ctor(Ctor.LN10), sd);
    }
    function getZeroString(k) {
        var zs = '';
        for(; k--;)zs += '0';
        return zs;
    }
    /*
   * Return a new Decimal whose value is the natural logarithm of `x` truncated to `sd` significant
   * digits.
   *
   *  ln(n) is non-terminating (n != 1)
   *
   */ function ln(y, sd) {
        var c, c0, denominator, e, numerator, sum, t, wpr, x2, n = 1, guard = 10, x = y, xd = x.d, Ctor = x.constructor, pr = Ctor.precision;
        // ln(-x) = NaN
        // ln(0) = -Infinity
        if (x.s < 1) throw Error(decimalError + (x.s ? 'NaN' : '-Infinity'));
        // ln(1) = 0
        if (x.eq(ONE)) return new Ctor(0);
        if (sd == null) {
            external = false;
            wpr = pr;
        } else wpr = sd;
        if (x.eq(10)) {
            if (sd == null) external = true;
            return getLn10(Ctor, wpr);
        }
        wpr += guard;
        Ctor.precision = wpr;
        c = digitsToString(xd);
        c0 = c.charAt(0);
        e = getBase10Exponent(x);
        if (Math.abs(e) < 1.5e15) {
            // Argument reduction.
            // The series converges faster the closer the argument is to 1, so using
            // ln(a^b) = b * ln(a),   ln(a) = ln(a^b) / b
            // multiply the argument by itself until the leading digits of the significand are 7, 8, 9,
            // 10, 11, 12 or 13, recording the number of multiplications so the sum of the series can
            // later be divided by this number, then separate out the power of 10 using
            // ln(a*10^b) = ln(a) + b*ln(10).
            // max n is 21 (gives 0.9, 1.0 or 1.1) (9e15 / 21 = 4.2e14).
            //while (c0 < 9 && c0 != 1 || c0 == 1 && c.charAt(1) > 1) {
            // max n is 6 (gives 0.7 - 1.3)
            while(c0 < 7 && c0 != 1 || c0 == 1 && c.charAt(1) > 3){
                x = x.times(y);
                c = digitsToString(x.d);
                c0 = c.charAt(0);
                n++;
            }
            e = getBase10Exponent(x);
            if (c0 > 1) {
                x = new Ctor('0.' + c);
                e++;
            } else x = new Ctor(c0 + '.' + c.slice(1));
        } else {
            // The argument reduction method above may result in overflow if the argument y is a massive
            // number with exponent >= 1500000000000000 (9e15 / 6 = 1.5e15), so instead recall this
            // function using ln(x*10^e) = ln(x) + e*ln(10).
            t = getLn10(Ctor, wpr + 2, pr).times(e + '');
            x = ln(new Ctor(c0 + '.' + c.slice(1)), wpr - guard).plus(t);
            Ctor.precision = pr;
            return sd == null ? (external = true, round(x, pr)) : x;
        }
        // x is reduced to a value near 1.
        // Taylor series.
        // ln(y) = ln((1 + x)/(1 - x)) = 2(x + x^3/3 + x^5/5 + x^7/7 + ...)
        // where x = (y - 1)/(y + 1)    (|x| < 1)
        sum = numerator = x = divide(x.minus(ONE), x.plus(ONE), wpr);
        x2 = round(x.times(x), wpr);
        denominator = 3;
        for(;;){
            numerator = round(numerator.times(x2), wpr);
            t = sum.plus(divide(numerator, new Ctor(denominator), wpr));
            if (digitsToString(t.d).slice(0, wpr) === digitsToString(sum.d).slice(0, wpr)) {
                sum = sum.times(2);
                // Reverse the argument reduction.
                if (e !== 0) sum = sum.plus(getLn10(Ctor, wpr + 2, pr).times(e + ''));
                sum = divide(sum, new Ctor(n), wpr);
                Ctor.precision = pr;
                return sd == null ? (external = true, round(sum, pr)) : sum;
            }
            sum = t;
            denominator += 2;
        }
    }
    /*
   * Parse the value of a new Decimal `x` from string `str`.
   */ function parseDecimal(x, str) {
        var e, i, len;
        // Decimal point?
        if ((e = str.indexOf('.')) > -1) str = str.replace('.', '');
        // Exponential form?
        if ((i = str.search(/e/i)) > 0) {
            // Determine exponent.
            if (e < 0) e = i;
            e += +str.slice(i + 1);
            str = str.substring(0, i);
        } else if (e < 0) // Integer.
        e = str.length;
        // Determine leading zeros.
        for(i = 0; str.charCodeAt(i) === 48;)++i;
        // Determine trailing zeros.
        for(len = str.length; str.charCodeAt(len - 1) === 48;)--len;
        str = str.slice(i, len);
        if (str) {
            len -= i;
            e = e - i - 1;
            x.e = mathfloor(e / LOG_BASE);
            x.d = [];
            // Transform base
            // e is the base 10 exponent.
            // i is where to slice str to get the first word of the digits array.
            i = (e + 1) % LOG_BASE;
            if (e < 0) i += LOG_BASE;
            if (i < len) {
                if (i) x.d.push(+str.slice(0, i));
                for(len -= LOG_BASE; i < len;)x.d.push(+str.slice(i, i += LOG_BASE));
                str = str.slice(i);
                i = LOG_BASE - str.length;
            } else i -= len;
            for(; i--;)str += '0';
            x.d.push(+str);
            if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + e);
        } else {
            // Zero.
            x.s = 0;
            x.e = 0;
            x.d = [
                0
            ];
        }
        return x;
    }
    /*
   * Round `x` to `sd` significant digits, using rounding mode `rm` if present (truncate otherwise).
   */ function round(x, sd, rm) {
        var i, j, k, n, rd, doRound, w, xdi, xd = x.d;
        // rd: the rounding digit, i.e. the digit after the digit that may be rounded up.
        // w: the word of xd which contains the rounding digit, a base 1e7 number.
        // xdi: the index of w within xd.
        // n: the number of digits of w.
        // i: what would be the index of rd within w if all the numbers were 7 digits long (i.e. if
        // they had leading zeros)
        // j: if > 0, the actual index of rd within w (if < 0, rd is a leading zero).
        // Get the length of the first word of the digits array xd.
        for(n = 1, k = xd[0]; k >= 10; k /= 10)n++;
        i = sd - n;
        // Is the rounding digit in the first word of xd?
        if (i < 0) {
            i += LOG_BASE;
            j = sd;
            w = xd[xdi = 0];
        } else {
            xdi = Math.ceil((i + 1) / LOG_BASE);
            k = xd.length;
            if (xdi >= k) return x;
            w = k = xd[xdi];
            // Get the number of digits of w.
            for(n = 1; k >= 10; k /= 10)n++;
            // Get the index of rd within w.
            i %= LOG_BASE;
            // Get the index of rd within w, adjusted for leading zeros.
            // The number of leading zeros of w is given by LOG_BASE - n.
            j = i - LOG_BASE + n;
        }
        if (rm !== void 0) {
            k = mathpow(10, n - j - 1);
            // Get the rounding digit at index j of w.
            rd = w / k % 10 | 0;
            // Are there any non-zero digits after the rounding digit?
            doRound = sd < 0 || xd[xdi + 1] !== void 0 || w % k;
            // The expression `w % mathpow(10, n - j - 1)` returns all the digits of w to the right of the
            // digit at (left-to-right) index j, e.g. if w is 908714 and j is 2, the expression will give
            // 714.
            doRound = rm < 4 ? (rd || doRound) && (rm == 0 || rm == (x.s < 0 ? 3 : 2)) : rd > 5 || rd == 5 && (rm == 4 || doRound || rm == 6 && (i > 0 ? j > 0 ? w / mathpow(10, n - j) : 0 : xd[xdi - 1]) % 10 & 1 || rm == (x.s < 0 ? 8 : 7));
        }
        if (sd < 1 || !xd[0]) {
            if (doRound) {
                k = getBase10Exponent(x);
                xd.length = 1;
                // Convert sd to decimal places.
                sd = sd - k - 1;
                // 1, 0.1, 0.01, 0.001, 0.0001 etc.
                xd[0] = mathpow(10, (LOG_BASE - sd % LOG_BASE) % LOG_BASE);
                x.e = mathfloor(-sd / LOG_BASE) || 0;
            } else {
                xd.length = 1;
                // Zero.
                xd[0] = x.e = x.s = 0;
            }
            return x;
        }
        // Remove excess digits.
        if (i == 0) {
            xd.length = xdi;
            k = 1;
            xdi--;
        } else {
            xd.length = xdi + 1;
            k = mathpow(10, LOG_BASE - i);
            // E.g. 56700 becomes 56000 if 7 is the rounding digit.
            // j > 0 means i > number of leading zeros of w.
            xd[xdi] = j > 0 ? (w / mathpow(10, n - j) % mathpow(10, j) | 0) * k : 0;
        }
        if (doRound) {
            for(;;)// Is the digit to be rounded up in the first word of xd?
            if (xdi == 0) {
                if ((xd[0] += k) == BASE) {
                    xd[0] = 1;
                    ++x.e;
                }
                break;
            } else {
                xd[xdi] += k;
                if (xd[xdi] != BASE) break;
                xd[xdi--] = 0;
                k = 1;
            }
        }
        // Remove trailing zeros.
        for(i = xd.length; xd[--i] === 0;)xd.pop();
        if (external && (x.e > MAX_E || x.e < -MAX_E)) throw Error(exponentOutOfRange + getBase10Exponent(x));
        return x;
    }
    function subtract(x, y) {
        var d, e, i, j, k, len, xd, xe, xLTy, yd, Ctor = x.constructor, pr = Ctor.precision;
        // Return y negated if x is zero.
        // Return x if y is zero and x is non-zero.
        if (!x.s || !y.s) {
            if (y.s) y.s = -y.s;
            else y = new Ctor(x);
            return external ? round(y, pr) : y;
        }
        xd = x.d;
        yd = y.d;
        // x and y are non-zero numbers with the same sign.
        e = y.e;
        xe = x.e;
        xd = xd.slice();
        k = xe - e;
        // If exponents differ...
        if (k) {
            xLTy = k < 0;
            if (xLTy) {
                d = xd;
                k = -k;
                len = yd.length;
            } else {
                d = yd;
                e = xe;
                len = xd.length;
            }
            // Numbers with massively different exponents would result in a very high number of zeros
            // needing to be prepended, but this can be avoided while still ensuring correct rounding by
            // limiting the number of zeros to `Math.ceil(pr / LOG_BASE) + 2`.
            i = Math.max(Math.ceil(pr / LOG_BASE), len) + 2;
            if (k > i) {
                k = i;
                d.length = 1;
            }
            // Prepend zeros to equalise exponents.
            d.reverse();
            for(i = k; i--;)d.push(0);
            d.reverse();
        // Base 1e7 exponents equal.
        } else {
            // Check digits to determine which is the bigger number.
            i = xd.length;
            len = yd.length;
            xLTy = i < len;
            if (xLTy) len = i;
            for(i = 0; i < len; i++)if (xd[i] != yd[i]) {
                xLTy = xd[i] < yd[i];
                break;
            }
            k = 0;
        }
        if (xLTy) {
            d = xd;
            xd = yd;
            yd = d;
            y.s = -y.s;
        }
        len = xd.length;
        // Append zeros to xd if shorter.
        // Don't add zeros to yd if shorter as subtraction only needs to start at yd length.
        for(i = yd.length - len; i > 0; --i)xd[len++] = 0;
        // Subtract yd from xd.
        for(i = yd.length; i > k;){
            if (xd[--i] < yd[i]) {
                for(j = i; j && xd[--j] === 0;)xd[j] = BASE - 1;
                --xd[j];
                xd[i] += BASE;
            }
            xd[i] -= yd[i];
        }
        // Remove trailing zeros.
        for(; xd[--len] === 0;)xd.pop();
        // Remove leading zeros and adjust exponent accordingly.
        for(; xd[0] === 0; xd.shift())--e;
        // Zero?
        if (!xd[0]) return new Ctor(0);
        y.d = xd;
        y.e = e;
        //return external && xd.length >= pr / LOG_BASE ? round(y, pr) : y;
        return external ? round(y, pr) : y;
    }
    function toString(x, isExp, sd) {
        var k, e = getBase10Exponent(x), str = digitsToString(x.d), len = str.length;
        if (isExp) {
            if (sd && (k = sd - len) > 0) str = str.charAt(0) + '.' + str.slice(1) + getZeroString(k);
            else if (len > 1) str = str.charAt(0) + '.' + str.slice(1);
            str = str + (e < 0 ? 'e' : 'e+') + e;
        } else if (e < 0) {
            str = '0.' + getZeroString(-e - 1) + str;
            if (sd && (k = sd - len) > 0) str += getZeroString(k);
        } else if (e >= len) {
            str += getZeroString(e + 1 - len);
            if (sd && (k = sd - e - 1) > 0) str = str + '.' + getZeroString(k);
        } else {
            if ((k = e + 1) < len) str = str.slice(0, k) + '.' + str.slice(k);
            if (sd && (k = sd - len) > 0) {
                if (e + 1 === len) str += '.';
                str += getZeroString(k);
            }
        }
        return x.s < 0 ? '-' + str : str;
    }
    // Does not strip trailing zeros.
    function truncate(arr, len) {
        if (arr.length > len) {
            arr.length = len;
            return true;
        }
    }
    // Decimal methods
    /*
   *  clone
   *  config/set
   */ /*
   * Create and return a Decimal constructor with the same configuration properties as this Decimal
   * constructor.
   *
   */ function clone(obj) {
        var i, p, ps;
        /*
     * The Decimal constructor and exported function.
     * Return a new Decimal instance.
     *
     * value {number|string|Decimal} A numeric value.
     *
     */ function Decimal(value) {
            var x = this;
            // Decimal called without new.
            if (!(x instanceof Decimal)) return new Decimal(value);
            // Retain a reference to this Decimal constructor, and shadow Decimal.prototype.constructor
            // which points to Object.
            x.constructor = Decimal;
            // Duplicate.
            if (value instanceof Decimal) {
                x.s = value.s;
                x.e = value.e;
                x.d = (value = value.d) ? value.slice() : value;
                return;
            }
            if (typeof value === 'number') {
                // Reject Infinity/NaN.
                if (value * 0 !== 0) throw Error(invalidArgument + value);
                if (value > 0) x.s = 1;
                else if (value < 0) {
                    value = -value;
                    x.s = -1;
                } else {
                    x.s = 0;
                    x.e = 0;
                    x.d = [
                        0
                    ];
                    return;
                }
                // Fast path for small integers.
                if (value === ~~value && value < 1e7) {
                    x.e = 0;
                    x.d = [
                        value
                    ];
                    return;
                }
                return parseDecimal(x, value.toString());
            } else if (typeof value !== 'string') throw Error(invalidArgument + value);
            // Minus sign?
            if (value.charCodeAt(0) === 45) {
                value = value.slice(1);
                x.s = -1;
            } else x.s = 1;
            if (isDecimal.test(value)) parseDecimal(x, value);
            else throw Error(invalidArgument + value);
        }
        Decimal.prototype = P;
        Decimal.ROUND_UP = 0;
        Decimal.ROUND_DOWN = 1;
        Decimal.ROUND_CEIL = 2;
        Decimal.ROUND_FLOOR = 3;
        Decimal.ROUND_HALF_UP = 4;
        Decimal.ROUND_HALF_DOWN = 5;
        Decimal.ROUND_HALF_EVEN = 6;
        Decimal.ROUND_HALF_CEIL = 7;
        Decimal.ROUND_HALF_FLOOR = 8;
        Decimal.clone = clone;
        Decimal.config = Decimal.set = config;
        if (obj === void 0) obj = {};
        if (obj) {
            ps = [
                'precision',
                'rounding',
                'toExpNeg',
                'toExpPos',
                'LN10'
            ];
            for(i = 0; i < ps.length;)if (!obj.hasOwnProperty(p = ps[i++])) obj[p] = this[p];
        }
        Decimal.config(obj);
        return Decimal;
    }
    /*
   * Configure global settings for a Decimal constructor.
   *
   * `obj` is an object with one or more of the following properties,
   *
   *   precision  {number}
   *   rounding   {number}
   *   toExpNeg   {number}
   *   toExpPos   {number}
   *
   * E.g. Decimal.config({ precision: 20, rounding: 4 })
   *
   */ function config(obj) {
        if (!obj || typeof obj !== 'object') throw Error(decimalError + 'Object expected');
        var i, p, v, ps = [
            'precision',
            1,
            MAX_DIGITS,
            'rounding',
            0,
            8,
            'toExpNeg',
            -1 / 0,
            0,
            'toExpPos',
            0,
            1 / 0
        ];
        for(i = 0; i < ps.length; i += 3)if ((v = obj[p = ps[i]]) !== void 0) {
            if (mathfloor(v) === v && v >= ps[i + 1] && v <= ps[i + 2]) this[p] = v;
            else throw Error(invalidArgument + p + ': ' + v);
        }
        if ((v = obj[p = 'LN10']) !== void 0) {
            if (v == Math.LN10) this[p] = new this(v);
            else throw Error(invalidArgument + p + ': ' + v);
        }
        return this;
    }
    // Create and configure initial Decimal constructor.
    Decimal = clone(Decimal);
    Decimal['default'] = Decimal.Decimal = Decimal;
    // Internal constant.
    ONE = new Decimal(1);
    // Export.
    // AMD.
    if (typeof define == 'function' && define.amd) define(function() {
        return Decimal;
    });
    else if (module.exports) module.exports = Decimal;
    else {
        if (!globalScope) globalScope = typeof self != 'undefined' && self && self.self == self ? self : Function('return this')();
        globalScope.Decimal = Decimal;
    }
})(this);

},{}],"gx5Ju":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PLACE_HOLDER", ()=>PLACE_HOLDER);
parcelHelpers.export(exports, "curry", ()=>curry);
parcelHelpers.export(exports, "range", ()=>range);
parcelHelpers.export(exports, "map", ()=>map);
parcelHelpers.export(exports, "compose", ()=>compose);
var identity = (i)=>i;
var PLACE_HOLDER = {
    '@@functional/placeholder': true
};
var isPlaceHolder = (val)=>val === PLACE_HOLDER;
var curry0 = (fn)=>function _curried() {
        if (arguments.length === 0 || arguments.length === 1 && isPlaceHolder(arguments.length <= 0 ? undefined : arguments[0])) return _curried;
        return fn(...arguments);
    };
var curryN = (n, fn)=>{
    if (n === 1) return fn;
    return curry0(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        var argsLength = args.filter((arg)=>arg !== PLACE_HOLDER).length;
        if (argsLength >= n) return fn(...args);
        return curryN(n - argsLength, curry0(function() {
            for(var _len2 = arguments.length, restArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)restArgs[_key2] = arguments[_key2];
            var newArgs = args.map((arg)=>isPlaceHolder(arg) ? restArgs.shift() : arg);
            return fn(...newArgs, ...restArgs);
        }));
    });
};
var curry = (fn)=>curryN(fn.length, fn);
var range = (begin, end)=>{
    var arr = [];
    for(var i = begin; i < end; ++i)arr[i - begin] = i;
    return arr;
};
var map = curry((fn, arr)=>{
    if (Array.isArray(arr)) return arr.map(fn);
    return Object.keys(arr).map((key)=>arr[key]).map(fn);
});
var compose = function compose() {
    for(var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)args[_key3] = arguments[_key3];
    if (!args.length) return identity;
    var fns = args.reverse();
    // first function can receive multiply arguments
    var firstFn = fns[0];
    var tailsFn = fns.slice(1);
    return function() {
        return tailsFn.reduce((res, fn)=>fn(res), firstFn(...arguments));
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f2trb":[function(require,module,exports,__globalThis) {
/**
 * @fileOverview Some common arithmetic methods
 * @author xile611
 * @date 2015-09-17
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "rangeStep", ()=>rangeStep);
parcelHelpers.export(exports, "getDigitCount", ()=>getDigitCount);
var _decimalJsLight = require("decimal.js-light");
var _decimalJsLightDefault = parcelHelpers.interopDefault(_decimalJsLight);
/**
 * Get the digit count of a number.
 * If the absolute value is in the interval [0.1, 1), the result is 0.
 * If the absolute value is in the interval [0.01, 0.1), the digit count is -1.
 * If the absolute value is in the interval [0.001, 0.01), the digit count is -2.
 *
 * @param  {Number} value The number
 * @return {Integer}      Digit count
 */ function getDigitCount(value) {
    var result;
    if (value === 0) result = 1;
    else result = Math.floor(new (0, _decimalJsLightDefault.default)(value).abs().log(10).toNumber()) + 1;
    return result;
}
/**
 * Get the data in the interval [start, end) with a fixed step.
 * Also handles JS calculation precision issues.
 *
 * @param  {Decimal} start Start point
 * @param  {Decimal} end   End point, not included
 * @param  {Decimal} step  Step size
 * @return {Array}         Array of numbers
 */ function rangeStep(start, end, step) {
    var num = new (0, _decimalJsLightDefault.default)(start);
    var i = 0;
    var result = [];
    // magic number to prevent infinite loop
    while(num.lt(end) && i < 100000){
        result.push(num.toNumber());
        num = num.add(step);
        i++;
    }
    return result;
}

},{"decimal.js-light":"eFP63","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eYPte":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectRootMaxBarSize", ()=>selectRootMaxBarSize);
parcelHelpers.export(exports, "selectBarGap", ()=>selectBarGap);
parcelHelpers.export(exports, "selectBarCategoryGap", ()=>selectBarCategoryGap);
parcelHelpers.export(exports, "selectRootBarSize", ()=>selectRootBarSize);
parcelHelpers.export(exports, "selectStackOffsetType", ()=>selectStackOffsetType);
parcelHelpers.export(exports, "selectReverseStackOrder", ()=>selectReverseStackOrder);
parcelHelpers.export(exports, "selectChartName", ()=>selectChartName);
parcelHelpers.export(exports, "selectSyncId", ()=>selectSyncId);
parcelHelpers.export(exports, "selectSyncMethod", ()=>selectSyncMethod);
parcelHelpers.export(exports, "selectEventEmitter", ()=>selectEventEmitter);
parcelHelpers.export(exports, "selectChartBaseValue", ()=>selectChartBaseValue);
var selectRootMaxBarSize = (state)=>state.rootProps.maxBarSize;
var selectBarGap = (state)=>state.rootProps.barGap;
var selectBarCategoryGap = (state)=>state.rootProps.barCategoryGap;
var selectRootBarSize = (state)=>state.rootProps.barSize;
var selectStackOffsetType = (state)=>state.rootProps.stackOffset;
var selectReverseStackOrder = (state)=>state.rootProps.reverseStackOrder;
var selectChartName = (state)=>state.options.chartName;
var selectSyncId = (state)=>state.rootProps.syncId;
var selectSyncMethod = (state)=>state.rootProps.syncMethod;
var selectEventEmitter = (state)=>state.options.eventEmitter;
var selectChartBaseValue = (state)=>state.rootProps.baseValue;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2M8G8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pickAxisType", ()=>pickAxisType);
var pickAxisType = (_state, axisType)=>axisType;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"87acx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pickAxisId", ()=>pickAxisId);
var pickAxisId = (_state, _axisType, axisId)=>axisId;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4X5RP":[function(require,module,exports,__globalThis) {
/**
 * Returns identifier for stack series which is one individual graphical item in the stack.
 * @param graphicalItem - The graphical item representing the series in the stack.
 * @return The identifier for the series in the stack
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getStackSeriesIdentifier", ()=>getStackSeriesIdentifier);
function getStackSeriesIdentifier(graphicalItem) {
    return graphicalItem === null || graphicalItem === void 0 ? void 0 : graphicalItem.id;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c7vK5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * In a stacked chart, each graphical item has its own data. That data could be either:
 * - defined on the chart root, in which case the item gets a unique dataKey
 * - or defined on the item itself, in which case multiple items can share the same dataKey
 *
 * That means we cannot use the dataKey as a unique identifier for the item.
 *
 * This type represents a single data point in a stacked chart, where each key is a series identifier
 * and the value is the numeric value for that series using the numerical axis dataKey.
 */ parcelHelpers.export(exports, "combineDisplayedStackedData", ()=>combineDisplayedStackedData);
var _getStackSeriesIdentifier = require("../../../util/stacks/getStackSeriesIdentifier");
var _chartUtils = require("../../../util/ChartUtils");
function combineDisplayedStackedData(stackedGraphicalItems, _ref, tooltipAxisSettings) {
    var { chartData = [] } = _ref;
    var { allowDuplicatedCategory, dataKey: tooltipDataKey } = tooltipAxisSettings;
    // A map of tooltip data keys to the stacked data points
    var knownItemsByDataKey = new Map();
    stackedGraphicalItems.forEach((item)=>{
        var _item$data;
        // If there is no data on the individual item then we use the root chart data
        var resolvedData = (_item$data = item.data) !== null && _item$data !== void 0 ? _item$data : chartData;
        if (resolvedData == null || resolvedData.length === 0) // if that doesn't work then we skip this item
        return;
        var stackIdentifier = (0, _getStackSeriesIdentifier.getStackSeriesIdentifier)(item);
        resolvedData.forEach((entry, index)=>{
            var tooltipValue = tooltipDataKey == null || allowDuplicatedCategory ? index : String((0, _chartUtils.getValueByDataKey)(entry, tooltipDataKey, null));
            var numericValue = (0, _chartUtils.getValueByDataKey)(entry, item.dataKey, 0);
            var curr;
            if (knownItemsByDataKey.has(tooltipValue)) curr = knownItemsByDataKey.get(tooltipValue);
            else curr = {};
            Object.assign(curr, {
                [stackIdentifier]: numericValue
            });
            knownItemsByDataKey.set(tooltipValue, curr);
        });
    });
    return Array.from(knownItemsByDataKey.values());
}

},{"../../../util/stacks/getStackSeriesIdentifier":"4X5RP","../../../util/ChartUtils":"enJyE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ivpBz":[function(require,module,exports,__globalThis) {
/**
 * Some graphical items allow data stacking. The stacks are optional,
 * so all props here are optional too.
 */ /**
 * Some graphical items allow data stacking.
 * This interface is used to represent the items that are stacked
 * because the user has provided the stackId and dataKey properties.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "isStacked", ()=>isStacked);
function isStacked(graphicalItem) {
    return 'stackId' in graphicalItem && graphicalItem.stackId != null && graphicalItem.dataKey != null;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8LF4r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "numberDomainEqualityCheck", ()=>numberDomainEqualityCheck);
var numberDomainEqualityCheck = (a, b)=>{
    if (a === b) return true;
    if (a == null || b == null) return false;
    return a[0] === b[0] && a[1] === b[1];
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hUECt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectTooltipAxisType", ()=>selectTooltipAxisType);
var _chartLayoutContext = require("../../context/chartLayoutContext");
var selectTooltipAxisType = (state)=>{
    var layout = (0, _chartLayoutContext.selectChartLayout)(state);
    if (layout === 'horizontal') return 'xAxis';
    if (layout === 'vertical') return 'yAxis';
    if (layout === 'centric') return 'angleAxis';
    return 'radiusAxis';
};

},{"../../context/chartLayoutContext":"jIUyy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"laxEp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectTooltipAxisId", ()=>selectTooltipAxisId);
var selectTooltipAxisId = (state)=>state.tooltip.settings.axisId;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ai7ym":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultLineProps", ()=>defaultLineProps);
parcelHelpers.export(exports, "computeLinePoints", ()=>computeLinePoints);
parcelHelpers.export(exports, "Line", ()=>Line);
var _react = require("react");
var _clsx = require("clsx");
var _layer = require("../container/Layer");
var _labelList = require("../component/LabelList");
var _dots = require("../component/Dots");
var _dataUtils = require("../util/DataUtils");
var _reactUtils = require("../util/ReactUtils");
var _chartUtils = require("../util/ChartUtils");
var _activePoints = require("../component/ActivePoints");
var _setTooltipEntrySettings = require("../state/SetTooltipEntrySettings");
var _errorBarContext = require("../context/ErrorBarContext");
var _graphicalItemClipPath = require("./GraphicalItemClipPath");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _panoramaContext = require("../context/PanoramaContext");
var _lineSelectors = require("../state/selectors/lineSelectors");
var _hooks = require("../state/hooks");
var _setLegendPayload = require("../state/SetLegendPayload");
var _useAnimationId = require("../util/useAnimationId");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
var _hooks1 = require("../hooks");
var _registerGraphicalItemId = require("../context/RegisterGraphicalItemId");
var _setGraphicalItem = require("../state/SetGraphicalItem");
var _svgPropertiesNoEvents = require("../util/svgPropertiesNoEvents");
var _javascriptAnimate = require("../animation/JavascriptAnimate");
var _svgPropertiesAndEvents = require("../util/svgPropertiesAndEvents");
var _getRadiusAndStrokeWidthFromDot = require("../util/getRadiusAndStrokeWidthFromDot");
var _activeShapeUtils = require("../util/ActiveShapeUtils");
var _zindexLayer = require("../zIndex/ZIndexLayer");
var _defaultZIndexes = require("../zIndex/DefaultZIndexes");
var _propsAreEqual = require("../util/propsAreEqual");
var _excluded = [
    "id"
], _excluded2 = [
    "type",
    "layout",
    "connectNulls",
    "needClip",
    "shape"
], _excluded3 = [
    "activeDot",
    "animateNewValues",
    "animationBegin",
    "animationDuration",
    "animationEasing",
    "connectNulls",
    "dot",
    "hide",
    "isAnimationActive",
    "label",
    "legendType",
    "xAxisId",
    "yAxisId",
    "id"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * Internal props, combination of external props + defaultProps + private Recharts state
 */ /**
 * External props, intended for end users to fill in
 */ /**
 * Because of naming conflict, we are forced to ignore certain (valid) SVG attributes.
 */ var computeLegendPayloadFromAreaData = (props)=>{
    var { dataKey, name, stroke, legendType, hide } = props;
    return [
        {
            inactive: hide,
            dataKey,
            type: legendType,
            color: stroke,
            value: (0, _chartUtils.getTooltipNameProp)(name, dataKey),
            payload: props
        }
    ];
};
var SetLineTooltipEntrySettings = /*#__PURE__*/ _react.memo((_ref)=>{
    var { dataKey, data, stroke, strokeWidth, fill, name, hide, unit, tooltipType, id } = _ref;
    var tooltipEntrySettings = {
        dataDefinedOnItem: data,
        positions: undefined,
        settings: {
            stroke,
            strokeWidth,
            fill,
            dataKey,
            nameKey: undefined,
            name: (0, _chartUtils.getTooltipNameProp)(name, dataKey),
            hide,
            type: tooltipType,
            color: stroke,
            unit,
            graphicalItemId: id
        }
    };
    return /*#__PURE__*/ _react.createElement((0, _setTooltipEntrySettings.SetTooltipEntrySettings), {
        tooltipEntrySettings: tooltipEntrySettings
    });
});
var generateSimpleStrokeDasharray = (totalLength, length)=>{
    return "".concat(length, "px ").concat(totalLength - length, "px");
};
function repeat(lines, count) {
    var linesUnit = lines.length % 2 !== 0 ? [
        ...lines,
        0
    ] : lines;
    var result = [];
    for(var i = 0; i < count; ++i)result = [
        ...result,
        ...linesUnit
    ];
    return result;
}
var getStrokeDasharray = (length, totalLength, lines)=>{
    var lineLength = lines.reduce((pre, next)=>pre + next);
    // if lineLength is 0 return the default when no strokeDasharray is provided
    if (!lineLength) return generateSimpleStrokeDasharray(totalLength, length);
    var count = Math.floor(length / lineLength);
    var remainLength = length % lineLength;
    var restLength = totalLength - length;
    var remainLines = [];
    for(var i = 0, sum = 0; i < lines.length; sum += lines[i], ++i)if (sum + lines[i] > remainLength) {
        remainLines = [
            ...lines.slice(0, i),
            remainLength - sum
        ];
        break;
    }
    var emptyLines = remainLines.length % 2 === 0 ? [
        0,
        restLength
    ] : [
        restLength
    ];
    return [
        ...repeat(lines, count),
        ...remainLines,
        ...emptyLines
    ].map((line)=>"".concat(line, "px")).join(', ');
};
function LineDotsWrapper(_ref2) {
    var { clipPathId, points, props } = _ref2;
    var { dot, dataKey, needClip } = props;
    /*
   * Exclude ID from the props passed to the Dots component
   * because then the ID would be applied to multiple dots, and it would no longer be unique.
   */ var { id } = props, propsWithoutId = _objectWithoutProperties(props, _excluded);
    var lineProps = (0, _svgPropertiesNoEvents.svgPropertiesNoEvents)(propsWithoutId);
    return /*#__PURE__*/ _react.createElement((0, _dots.Dots), {
        points: points,
        dot: dot,
        className: "recharts-line-dots",
        dotClassName: "recharts-line-dot",
        dataKey: dataKey,
        baseProps: lineProps,
        needClip: needClip,
        clipPathId: clipPathId
    });
}
function LineLabelListProvider(_ref3) {
    var { showLabels, children, points } = _ref3;
    var labelListEntries = (0, _react.useMemo)(()=>{
        return points === null || points === void 0 ? void 0 : points.map((point)=>{
            var _point$x, _point$y;
            var viewBox = {
                x: (_point$x = point.x) !== null && _point$x !== void 0 ? _point$x : 0,
                y: (_point$y = point.y) !== null && _point$y !== void 0 ? _point$y : 0,
                width: 0,
                lowerWidth: 0,
                upperWidth: 0,
                height: 0
            };
            return _objectSpread(_objectSpread({}, viewBox), {}, {
                value: point.value,
                payload: point.payload,
                viewBox,
                /*
         * Line is not passing parentViewBox to the LabelList so the labels can escape - looks like a bug, should we pass parentViewBox?
         * Or should this just be the root chart viewBox?
         */ parentViewBox: undefined,
                fill: undefined
            });
        });
    }, [
        points
    ]);
    return /*#__PURE__*/ _react.createElement((0, _labelList.CartesianLabelListContextProvider), {
        value: showLabels ? labelListEntries : undefined
    }, children);
}
function StaticCurve(_ref4) {
    var { clipPathId, pathRef, points, strokeDasharray, props } = _ref4;
    var { type, layout, connectNulls, needClip, shape } = props, others = _objectWithoutProperties(props, _excluded2);
    var curveProps = _objectSpread(_objectSpread({}, (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(others)), {}, {
        fill: 'none',
        className: 'recharts-line-curve',
        clipPath: needClip ? "url(#clipPath-".concat(clipPathId, ")") : undefined,
        points,
        type,
        layout,
        connectNulls,
        strokeDasharray: strokeDasharray !== null && strokeDasharray !== void 0 ? strokeDasharray : props.strokeDasharray
    });
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, (points === null || points === void 0 ? void 0 : points.length) > 1 && /*#__PURE__*/ _react.createElement((0, _activeShapeUtils.Shape), _extends({
        shapeType: "curve",
        option: shape
    }, curveProps, {
        pathRef: pathRef
    })), /*#__PURE__*/ _react.createElement(LineDotsWrapper, {
        points: points,
        clipPathId: clipPathId,
        props: props
    }));
}
function getTotalLength(mainCurve) {
    try {
        return mainCurve && mainCurve.getTotalLength && mainCurve.getTotalLength() || 0;
    } catch (_unused) {
        return 0;
    }
}
function CurveWithAnimation(_ref5) {
    var { clipPathId, props, pathRef, previousPointsRef, longestAnimatedLengthRef } = _ref5;
    var { points, strokeDasharray, isAnimationActive, animationBegin, animationDuration, animationEasing, animateNewValues, width, height, onAnimationEnd, onAnimationStart } = props;
    var prevPoints = previousPointsRef.current;
    var animationId = (0, _useAnimationId.useAnimationId)(points, 'recharts-line-');
    var animationIdRef = (0, _react.useRef)(animationId);
    var [isAnimating, setIsAnimating] = (0, _react.useState)(false);
    var showLabels = !isAnimating;
    var handleAnimationEnd = (0, _react.useCallback)(()=>{
        if (typeof onAnimationEnd === 'function') onAnimationEnd();
        setIsAnimating(false);
    }, [
        onAnimationEnd
    ]);
    var handleAnimationStart = (0, _react.useCallback)(()=>{
        if (typeof onAnimationStart === 'function') onAnimationStart();
        setIsAnimating(true);
    }, [
        onAnimationStart
    ]);
    var totalLength = getTotalLength(pathRef.current);
    /*
   * Here we want to detect if the length animation has been interrupted.
   * For that we keep a reference to the furthest length that has been animated.
   *
   * And then, to keep things smooth, we add to it the current length that is being animated right now.
   *
   * If we did Math.max then it makes the length animation "pause" but we want to keep it smooth
   * so in case we have some "leftover" length from the previous animation we add it to the current length.
   *
   * This is not perfect because the animation changes speed due to easing. The default easing is 'ease' which is not linear
   * and makes it stand out. But it's good enough I suppose.
   * If we want to fix it then we need to keep track of multiple animations and their easing and timings.
   *
   * If you want to see this in action, try to change the dataKey of the line chart while the initial animation is running.
   * The Line begins with zero length and slowly grows to the full length. While this growth is in progress,
   * change the dataKey and the Line will continue growing from where it has grown so far.
   *
   * This is for the case when new animation triggers. When that happens we get new points, everything re-renders,
   * and we get fresh new state in this component and use the ref stored above.
   *
   * In case when we get render without new animation - for example when opacity changes, or color changes,
   * then the animationId remains the same, and we do not update the starting point.
   * See https://github.com/recharts/recharts/issues/6044
   */ var startingPointRef = (0, _react.useRef)(0);
    if (animationIdRef.current !== animationId) {
        startingPointRef.current = longestAnimatedLengthRef.current;
        animationIdRef.current = animationId;
    }
    var startingPoint = startingPointRef.current;
    return /*#__PURE__*/ _react.createElement(LineLabelListProvider, {
        points: points,
        showLabels: showLabels
    }, props.children, /*#__PURE__*/ _react.createElement((0, _javascriptAnimate.JavascriptAnimate), {
        animationId: animationId,
        begin: animationBegin,
        duration: animationDuration,
        isActive: isAnimationActive,
        easing: animationEasing,
        onAnimationEnd: handleAnimationEnd,
        onAnimationStart: handleAnimationStart,
        key: animationId
    }, (t)=>{
        var lengthInterpolated = (0, _dataUtils.interpolate)(startingPoint, totalLength + startingPoint, t);
        var curLength = Math.min(lengthInterpolated, totalLength);
        var currentStrokeDasharray;
        if (isAnimationActive) {
            if (strokeDasharray) {
                var lines = "".concat(strokeDasharray).split(/[,\s]+/gim).map((num)=>parseFloat(num));
                currentStrokeDasharray = getStrokeDasharray(curLength, totalLength, lines);
            } else currentStrokeDasharray = generateSimpleStrokeDasharray(totalLength, curLength);
        } else currentStrokeDasharray = strokeDasharray == null ? undefined : String(strokeDasharray);
        /*
     * Here it is important to wait a little bit with updating the previousPointsRef
     * before the animation has a time to initialize.
     * If we set the previous pointsRef immediately, we set it before the Legend height it calculated
     * and before pathRef is set.
     * If that happens, the Line will re-render again after Legend had reported its height
     * which will start a new animation with the previous points as the starting point
     * which gives the effect of the Line animating slightly upwards (where the animation distance equals the Legend height).
     * Waiting for t > 0 is indirect but good enough to ensure that the Legend height is calculated and animation works properly.
     *
     * Total length similarly is calculated from the pathRef. We should not update the previousPointsRef
     * before the pathRef is set, otherwise we will have a wrong total length.
     */ if (t > 0 && totalLength > 0) {
            // eslint-disable-next-line no-param-reassign
            previousPointsRef.current = points;
            /*
       * totalLength is set from a ref and is not updated in the first tick of the animation.
       * It defaults to zero which is exactly what we want here because we want to grow from zero,
       * however the same happens when the data change.
       *
       * In that case we want to remember the previous length and continue from there, and only animate the shape.
       *
       * Therefore the totalLength > 0 check.
       *
       * The Animate is about to fire handleAnimationStart which will update the state
       * and cause a re-render and read a new proper totalLength which will be used in the next tick
       * and update the longestAnimatedLengthRef.
       *
       * Why Math.max? Sometimes the curve goes through a smaller length than previously recorded.
       * If we just set it to curLength, then the next animation would start from a smaller length
       * which looks weird. So we keep the longest length ever reached and then animate from there.
       */ // eslint-disable-next-line no-param-reassign
            longestAnimatedLengthRef.current = Math.max(longestAnimatedLengthRef.current, curLength);
        }
        if (prevPoints) {
            var prevPointsDiffFactor = prevPoints.length / points.length;
            var stepData = t === 1 ? points : points.map((entry, index)=>{
                var prevPointIndex = Math.floor(index * prevPointsDiffFactor);
                if (prevPoints[prevPointIndex]) {
                    var prev = prevPoints[prevPointIndex];
                    return _objectSpread(_objectSpread({}, entry), {}, {
                        x: (0, _dataUtils.interpolate)(prev.x, entry.x, t),
                        y: (0, _dataUtils.interpolate)(prev.y, entry.y, t)
                    });
                }
                // magic number of faking previous x and y location
                if (animateNewValues) return _objectSpread(_objectSpread({}, entry), {}, {
                    x: (0, _dataUtils.interpolate)(width * 2, entry.x, t),
                    y: (0, _dataUtils.interpolate)(height / 2, entry.y, t)
                });
                return _objectSpread(_objectSpread({}, entry), {}, {
                    x: entry.x,
                    y: entry.y
                });
            });
            // eslint-disable-next-line no-param-reassign
            previousPointsRef.current = stepData;
            return /*#__PURE__*/ _react.createElement(StaticCurve, {
                props: props,
                points: stepData,
                clipPathId: clipPathId,
                pathRef: pathRef,
                strokeDasharray: currentStrokeDasharray
            });
        }
        return /*#__PURE__*/ _react.createElement(StaticCurve, {
            props: props,
            points: points,
            clipPathId: clipPathId,
            pathRef: pathRef,
            strokeDasharray: currentStrokeDasharray
        });
    }), /*#__PURE__*/ _react.createElement((0, _labelList.LabelListFromLabelProp), {
        label: props.label
    }));
}
function RenderCurve(_ref6) {
    var { clipPathId, props } = _ref6;
    var previousPointsRef = (0, _react.useRef)(null);
    var longestAnimatedLengthRef = (0, _react.useRef)(0);
    var pathRef = (0, _react.useRef)(null);
    return /*#__PURE__*/ _react.createElement(CurveWithAnimation, {
        props: props,
        clipPathId: clipPathId,
        previousPointsRef: previousPointsRef,
        longestAnimatedLengthRef: longestAnimatedLengthRef,
        pathRef: pathRef
    });
}
var errorBarDataPointFormatter = (dataPoint, dataKey)=>{
    var _dataPoint$x, _dataPoint$y;
    return {
        x: (_dataPoint$x = dataPoint.x) !== null && _dataPoint$x !== void 0 ? _dataPoint$x : undefined,
        y: (_dataPoint$y = dataPoint.y) !== null && _dataPoint$y !== void 0 ? _dataPoint$y : undefined,
        value: dataPoint.value,
        // @ts-expect-error getValueByDataKey does not validate the output type
        errorVal: (0, _chartUtils.getValueByDataKey)(dataPoint.payload, dataKey)
    };
};
// eslint-disable-next-line react/prefer-stateless-function
class LineWithState extends (0, _react.Component) {
    render() {
        var { hide, dot, points, className, xAxisId, yAxisId, top, left, width, height, id, needClip, zIndex } = this.props;
        if (hide) return null;
        var layerClass = (0, _clsx.clsx)('recharts-line', className);
        var clipPathId = id;
        var { r, strokeWidth } = (0, _getRadiusAndStrokeWidthFromDot.getRadiusAndStrokeWidthFromDot)(dot);
        var clipDot = (0, _reactUtils.isClipDot)(dot);
        var dotSize = r * 2 + strokeWidth;
        var activePointsClipPath = needClip ? "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")") : undefined;
        return /*#__PURE__*/ _react.createElement((0, _zindexLayer.ZIndexLayer), {
            zIndex: zIndex
        }, /*#__PURE__*/ _react.createElement((0, _layer.Layer), {
            className: layerClass
        }, needClip && /*#__PURE__*/ _react.createElement("defs", null, /*#__PURE__*/ _react.createElement((0, _graphicalItemClipPath.GraphicalItemClipPath), {
            clipPathId: clipPathId,
            xAxisId: xAxisId,
            yAxisId: yAxisId
        }), !clipDot && /*#__PURE__*/ _react.createElement("clipPath", {
            id: "clipPath-dots-".concat(clipPathId)
        }, /*#__PURE__*/ _react.createElement("rect", {
            x: left - dotSize / 2,
            y: top - dotSize / 2,
            width: width + dotSize,
            height: height + dotSize
        }))), /*#__PURE__*/ _react.createElement((0, _errorBarContext.SetErrorBarContext), {
            xAxisId: xAxisId,
            yAxisId: yAxisId,
            data: points,
            dataPointFormatter: errorBarDataPointFormatter,
            errorBarOffset: 0
        }, /*#__PURE__*/ _react.createElement(RenderCurve, {
            props: this.props,
            clipPathId: clipPathId
        }))), /*#__PURE__*/ _react.createElement((0, _activePoints.ActivePoints), {
            activeDot: this.props.activeDot,
            points: points,
            mainColor: this.props.stroke,
            itemDataKey: this.props.dataKey,
            clipPath: activePointsClipPath
        }));
    }
}
var defaultLineProps = {
    activeDot: true,
    animateNewValues: true,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease',
    connectNulls: false,
    dot: true,
    fill: '#fff',
    hide: false,
    isAnimationActive: 'auto',
    label: false,
    legendType: 'line',
    stroke: '#3182bd',
    strokeWidth: 1,
    xAxisId: 0,
    yAxisId: 0,
    zIndex: (0, _defaultZIndexes.DefaultZIndexes).line,
    type: 'linear'
};
function LineImpl(props) {
    var _resolveDefaultProps1 = (0, _resolveDefaultProps.resolveDefaultProps)(props, defaultLineProps), { activeDot, animateNewValues, animationBegin, animationDuration, animationEasing, connectNulls, dot, hide, isAnimationActive, label, legendType, xAxisId, yAxisId, id } = _resolveDefaultProps1, everythingElse = _objectWithoutProperties(_resolveDefaultProps1, _excluded3);
    var { needClip } = (0, _graphicalItemClipPath.useNeedsClip)(xAxisId, yAxisId);
    var plotArea = (0, _hooks1.usePlotArea)();
    var layout = (0, _chartLayoutContext.useChartLayout)();
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    var points = (0, _hooks.useAppSelector)((state)=>(0, _lineSelectors.selectLinePoints)(state, xAxisId, yAxisId, isPanorama, id));
    if (layout !== 'horizontal' && layout !== 'vertical' || points == null || plotArea == null) // Cannot render Line in an unsupported layout
    return null;
    var { height, width, x: left, y: top } = plotArea;
    return /*#__PURE__*/ _react.createElement(LineWithState, _extends({}, everythingElse, {
        id: id,
        connectNulls: connectNulls,
        dot: dot,
        activeDot: activeDot,
        animateNewValues: animateNewValues,
        animationBegin: animationBegin,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        hide: hide,
        label: label,
        legendType: legendType,
        xAxisId: xAxisId,
        yAxisId: yAxisId,
        points: points,
        layout: layout,
        height: height,
        width: width,
        left: left,
        top: top,
        needClip: needClip
    }));
}
function computeLinePoints(_ref7) {
    var { layout, xAxis, yAxis, xAxisTicks, yAxisTicks, dataKey, bandSize, displayedData } = _ref7;
    return displayedData.map((entry, index)=>{
        // @ts-expect-error getValueByDataKey does not validate the output type
        var value = (0, _chartUtils.getValueByDataKey)(entry, dataKey);
        if (layout === 'horizontal') {
            var _x = (0, _chartUtils.getCateCoordinateOfLine)({
                axis: xAxis,
                ticks: xAxisTicks,
                bandSize,
                entry,
                index
            });
            var _y = (0, _dataUtils.isNullish)(value) ? null : yAxis.scale(value);
            return {
                x: _x,
                y: _y,
                value,
                payload: entry
            };
        }
        var x = (0, _dataUtils.isNullish)(value) ? null : xAxis.scale(value);
        var y = (0, _chartUtils.getCateCoordinateOfLine)({
            axis: yAxis,
            ticks: yAxisTicks,
            bandSize,
            entry,
            index
        });
        if (x == null || y == null) return null;
        return {
            x,
            y,
            value,
            payload: entry
        };
    }).filter(Boolean);
}
function LineFn(outsideProps) {
    var props = (0, _resolveDefaultProps.resolveDefaultProps)(outsideProps, defaultLineProps);
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    return /*#__PURE__*/ _react.createElement((0, _registerGraphicalItemId.RegisterGraphicalItemId), {
        id: props.id,
        type: "line"
    }, (id)=>/*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _setLegendPayload.SetLegendPayload), {
            legendPayload: computeLegendPayloadFromAreaData(props)
        }), /*#__PURE__*/ _react.createElement(SetLineTooltipEntrySettings, {
            dataKey: props.dataKey,
            data: props.data,
            stroke: props.stroke,
            strokeWidth: props.strokeWidth,
            fill: props.fill,
            name: props.name,
            hide: props.hide,
            unit: props.unit,
            tooltipType: props.tooltipType,
            id: id
        }), /*#__PURE__*/ _react.createElement((0, _setGraphicalItem.SetCartesianGraphicalItem), {
            type: "line",
            id: id,
            data: props.data,
            xAxisId: props.xAxisId,
            yAxisId: props.yAxisId,
            zAxisId: 0,
            dataKey: props.dataKey,
            hide: props.hide,
            isPanorama: isPanorama
        }), /*#__PURE__*/ _react.createElement(LineImpl, _extends({}, props, {
            id: id
        }))));
}
var Line = /*#__PURE__*/ _react.memo(LineFn, (0, _propsAreEqual.propsAreEqual));
Line.displayName = 'Line';

},{"react":"bmhQu","clsx":"431Ou","../container/Layer":"ctc59","../component/LabelList":"aiJvW","../component/Dots":"aC00x","../util/DataUtils":"lNZEj","../util/ReactUtils":"0yfuc","../util/ChartUtils":"enJyE","../component/ActivePoints":"lEBvx","../state/SetTooltipEntrySettings":"kJI8J","../context/ErrorBarContext":"er7iN","./GraphicalItemClipPath":"b8pcP","../context/chartLayoutContext":"jIUyy","../context/PanoramaContext":"10hMm","../state/selectors/lineSelectors":"2Dpao","../state/hooks":"aEuxu","../state/SetLegendPayload":"iwmF3","../util/useAnimationId":"feTEg","../util/resolveDefaultProps":"cWUqx","../hooks":"gL5ve","../context/RegisterGraphicalItemId":"aCd5f","../state/SetGraphicalItem":"c4ajk","../util/svgPropertiesNoEvents":"2NZlZ","../animation/JavascriptAnimate":"as3wV","../util/svgPropertiesAndEvents":"6bogn","../util/getRadiusAndStrokeWidthFromDot":"4bXjy","../util/ActiveShapeUtils":"2zGHp","../zIndex/ZIndexLayer":"6RR5t","../zIndex/DefaultZIndexes":"h8nlV","../util/propsAreEqual":"eGfhC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aiJvW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CartesianLabelListContextProvider", ()=>CartesianLabelListContextProvider);
parcelHelpers.export(exports, "PolarLabelListContextProvider", ()=>PolarLabelListContextProvider);
/**
 * @consumes LabelListContext
 */ parcelHelpers.export(exports, "LabelList", ()=>LabelList);
parcelHelpers.export(exports, "LabelListFromLabelProp", ()=>LabelListFromLabelProp);
var _react = require("react");
var _last = require("es-toolkit/compat/last");
var _lastDefault = parcelHelpers.interopDefault(_last);
var _label = require("./Label");
var _layer = require("../container/Layer");
var _chartUtils = require("../util/ChartUtils");
var _dataUtils = require("../util/DataUtils");
var _svgPropertiesAndEvents = require("../util/svgPropertiesAndEvents");
var _zindexLayer = require("../zIndex/ZIndexLayer");
var _defaultZIndexes = require("../zIndex/DefaultZIndexes");
var _excluded = [
    "valueAccessor"
], _excluded2 = [
    "dataKey",
    "clockWise",
    "id",
    "textBreakAll",
    "zIndex"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
/**
 * This is public API because we expose it as the valueAccessor parameter.
 *
 * The properties of "viewBox" are repeated as the root props of the entry object.
 * So it doesn't matter if you read entry.x or entry.viewBox.x, they are the same.
 *
 * It's not necessary to pass redundant data, but we keep it for backward compatibility.
 */ /**
 * LabelList props do not allow refs because the same props are reused in multiple elements so we don't have a good single place to ref to.
 */ /**
 * This is the type accepted for the `label` prop on various graphical items.
 * It accepts:
 *
 * boolean:
 *    true = labels show,
 *    false = labels don't show
 * React element:
 *    will be cloned with extra props
 * function:
 *    is used as <Label content={function} />, so this will be called once for each individual label (so typically once for each data point)
 * object:
 *    the props to be passed to a LabelList component
 *
 * @inline
 */ var defaultAccessor = (entry)=>Array.isArray(entry.value) ? (0, _lastDefault.default)(entry.value) : entry.value;
var CartesianLabelListContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var CartesianLabelListContextProvider = CartesianLabelListContext.Provider;
var PolarLabelListContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var PolarLabelListContextProvider = PolarLabelListContext.Provider;
function useCartesianLabelListContext() {
    return (0, _react.useContext)(CartesianLabelListContext);
}
function usePolarLabelListContext() {
    return (0, _react.useContext)(PolarLabelListContext);
}
function LabelList(_ref) {
    var { valueAccessor = defaultAccessor } = _ref, restProps = _objectWithoutProperties(_ref, _excluded);
    var { dataKey, clockWise, id, textBreakAll, zIndex } = restProps, others = _objectWithoutProperties(restProps, _excluded2);
    var cartesianData = useCartesianLabelListContext();
    var polarData = usePolarLabelListContext();
    var data = cartesianData || polarData;
    if (!data || !data.length) return null;
    return /*#__PURE__*/ _react.createElement((0, _zindexLayer.ZIndexLayer), {
        zIndex: zIndex !== null && zIndex !== void 0 ? zIndex : (0, _defaultZIndexes.DefaultZIndexes).label
    }, /*#__PURE__*/ _react.createElement((0, _layer.Layer), {
        className: "recharts-label-list"
    }, data.map((entry, index)=>{
        var _restProps$fill;
        var value = (0, _dataUtils.isNullish)(dataKey) ? valueAccessor(entry, index) : (0, _chartUtils.getValueByDataKey)(entry && entry.payload, dataKey);
        var idProps = (0, _dataUtils.isNullish)(id) ? {} : {
            id: "".concat(id, "-").concat(index)
        };
        return /*#__PURE__*/ _react.createElement((0, _label.Label), _extends({
            key: "label-".concat(index)
        }, (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(entry), others, idProps, {
            /*
       * Prefer to use the explicit fill from LabelList props.
       * Only in an absence of that, fall back to the fill of the entry.
       * The entry fill can be quite difficult to see especially in Bar, Pie, RadialBar in inside positions.
       * On the other hand it's quite convenient in Scatter, Line, or when the position is outside the Bar, Pie filled shapes.
       */ fill: (_restProps$fill = restProps.fill) !== null && _restProps$fill !== void 0 ? _restProps$fill : entry.fill,
            parentViewBox: entry.parentViewBox,
            value: value,
            textBreakAll: textBreakAll,
            viewBox: entry.viewBox,
            index: index,
            zIndex: 0
        }));
    })));
}
LabelList.displayName = 'LabelList';
function LabelListFromLabelProp(_ref2) {
    var { label } = _ref2;
    if (!label) return null;
    if (label === true) return /*#__PURE__*/ _react.createElement(LabelList, {
        key: "labelList-implicit"
    });
    if (/*#__PURE__*/ _react.isValidElement(label) || (0, _label.isLabelContentAFunction)(label)) return /*#__PURE__*/ _react.createElement(LabelList, {
        key: "labelList-implicit",
        content: label
    });
    if (typeof label === 'object') return /*#__PURE__*/ _react.createElement(LabelList, _extends({
        key: "labelList-implicit"
    }, label, {
        type: String(label.type)
    }));
    return null;
}

},{"react":"bmhQu","es-toolkit/compat/last":"hNXkK","./Label":"feVPQ","../container/Layer":"ctc59","../util/ChartUtils":"enJyE","../util/DataUtils":"lNZEj","../util/svgPropertiesAndEvents":"6bogn","../zIndex/ZIndexLayer":"6RR5t","../zIndex/DefaultZIndexes":"h8nlV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hNXkK":[function(require,module,exports,__globalThis) {
module.exports = require("d152f3f8292d7ccc").last;

},{"d152f3f8292d7ccc":"kaqQD"}],"kaqQD":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const last$1 = require("244a8d869dcb2ffe");
const toArray = require("b4f257dea47ce49");
const isArrayLike = require("7d7418b7901f48c9");
function last(array) {
    if (!isArrayLike.isArrayLike(array)) return undefined;
    return last$1.last(toArray.toArray(array));
}
exports.last = last;

},{"244a8d869dcb2ffe":"gHbOM","b4f257dea47ce49":"2KZkp","7d7418b7901f48c9":"8WsUw"}],"gHbOM":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function last(arr) {
    return arr[arr.length - 1];
}
exports.last = last;

},{}],"2KZkp":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function toArray(value) {
    return Array.isArray(value) ? value : Array.from(value);
}
exports.toArray = toArray;

},{}],"aC00x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dots", ()=>Dots);
var _react = require("react");
var _clsx = require("clsx");
var _dot = require("../shape/Dot");
var _layer = require("../container/Layer");
var _reactUtils = require("../util/ReactUtils");
var _svgPropertiesAndEvents = require("../util/svgPropertiesAndEvents");
var _zindexLayer = require("../zIndex/ZIndexLayer");
var _defaultZIndexes = require("../zIndex/DefaultZIndexes");
var _excluded = [
    "points"
];
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function DotItem(_ref) {
    var { option, dotProps, className } = _ref;
    if (/*#__PURE__*/ (0, _react.isValidElement)(option)) // @ts-expect-error we can't type check element cloning properly
    return /*#__PURE__*/ (0, _react.cloneElement)(option, dotProps);
    if (typeof option === 'function') return option(dotProps);
    var finalClassName = (0, _clsx.clsx)(className, typeof option !== 'boolean' ? option.className : '');
    var _ref2 = dotProps !== null && dotProps !== void 0 ? dotProps : {}, { points } = _ref2, props = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/ _react.createElement((0, _dot.Dot), _extends({}, props, {
        className: finalClassName
    }));
}
function shouldRenderDots(points, dot) {
    if (points == null) return false;
    if (dot) return true;
    return points.length === 1;
}
function Dots(_ref3) {
    var { points, dot, className, dotClassName, dataKey, baseProps, needClip, clipPathId, zIndex = (0, _defaultZIndexes.DefaultZIndexes).scatter } = _ref3;
    if (!shouldRenderDots(points, dot)) return null;
    var clipDot = (0, _reactUtils.isClipDot)(dot);
    var customDotProps = (0, _svgPropertiesAndEvents.svgPropertiesAndEventsFromUnknown)(dot);
    var dots = points.map((entry, i)=>{
        var _entry$x, _entry$y;
        var dotProps = _objectSpread(_objectSpread(_objectSpread({
            r: 3
        }, baseProps), customDotProps), {}, {
            index: i,
            cx: (_entry$x = entry.x) !== null && _entry$x !== void 0 ? _entry$x : undefined,
            cy: (_entry$y = entry.y) !== null && _entry$y !== void 0 ? _entry$y : undefined,
            dataKey,
            value: entry.value,
            payload: entry.payload,
            points
        });
        return /*#__PURE__*/ _react.createElement(DotItem, {
            key: "dot-".concat(i),
            option: dot,
            dotProps: dotProps,
            className: dotClassName
        });
    });
    var layerProps = {};
    if (needClip && clipPathId != null) layerProps.clipPath = "url(#clipPath-".concat(clipDot ? '' : 'dots-').concat(clipPathId, ")");
    return /*#__PURE__*/ _react.createElement((0, _zindexLayer.ZIndexLayer), {
        zIndex: zIndex
    }, /*#__PURE__*/ _react.createElement((0, _layer.Layer), _extends({
        className: className
    }, layerProps), dots));
}

},{"react":"bmhQu","clsx":"431Ou","../shape/Dot":"8aTES","../container/Layer":"ctc59","../util/ReactUtils":"0yfuc","../util/svgPropertiesAndEvents":"6bogn","../zIndex/ZIndexLayer":"6RR5t","../zIndex/DefaultZIndexes":"h8nlV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8aTES":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Dot", ()=>Dot);
/**
 * @fileOverview Dot
 */ var _react = require("react");
var _clsx = require("clsx");
var _types = require("../util/types");
var _svgPropertiesNoEvents = require("../util/svgPropertiesNoEvents");
var _dataUtils = require("../util/DataUtils");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var Dot = (props)=>{
    var { cx, cy, r, className } = props;
    var layerClass = (0, _clsx.clsx)('recharts-dot', className);
    if ((0, _dataUtils.isNumber)(cx) && (0, _dataUtils.isNumber)(cy) && (0, _dataUtils.isNumber)(r)) return /*#__PURE__*/ _react.createElement("circle", _extends({}, (0, _svgPropertiesNoEvents.svgPropertiesNoEvents)(props), (0, _types.adaptEventHandlers)(props), {
        className: layerClass,
        cx: cx,
        cy: cy,
        r: r
    }));
    return null;
};

},{"react":"bmhQu","clsx":"431Ou","../util/types":"9qdl2","../util/svgPropertiesNoEvents":"2NZlZ","../util/DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"0yfuc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SCALE_TYPES", ()=>SCALE_TYPES);
parcelHelpers.export(exports, "getDisplayName", ()=>getDisplayName);
parcelHelpers.export(exports, "toArray", ()=>toArray);
/**
 * @deprecated instead find another approach that does not require reading React Elements from DOM.
 *
 * Find and return all matched children by type.
 * `type` must be a React.ComponentType
 *
 * @param children do not use
 * @param type do not use
 * @return deprecated do not use
 */ parcelHelpers.export(exports, "findAllByType", ()=>findAllByType);
parcelHelpers.export(exports, "isClipDot", ()=>isClipDot);
var _get = require("es-toolkit/compat/get");
var _getDefault = parcelHelpers.interopDefault(_get);
var _react = require("react");
var _reactIs = require("react-is");
var _dataUtils = require("./DataUtils");
var SCALE_TYPES = [
    'auto',
    'linear',
    'pow',
    'sqrt',
    'log',
    'identity',
    'time',
    'band',
    'point',
    'ordinal',
    'quantile',
    'quantize',
    'utc',
    'sequential',
    'threshold'
];
var getDisplayName = (Comp)=>{
    if (typeof Comp === 'string') return Comp;
    if (!Comp) return '';
    return Comp.displayName || Comp.name || 'Component';
};
// `toArray` gets called multiple times during the render
// so we can memoize last invocation (since reference to `children` is the same)
var lastChildren = null;
var lastResult = null;
var toArray = (children)=>{
    if (children === lastChildren && Array.isArray(lastResult)) return lastResult;
    var result = [];
    (0, _react.Children).forEach(children, (child)=>{
        if ((0, _dataUtils.isNullish)(child)) return;
        if ((0, _reactIs.isFragment)(child)) result = result.concat(toArray(child.props.children));
        else // @ts-expect-error this could still be Iterable<ReactNode> and TS does not like that
        result.push(child);
    });
    lastResult = result;
    lastChildren = children;
    return result;
};
function findAllByType(children, type) {
    var result = [];
    var types = [];
    if (Array.isArray(type)) types = type.map((t)=>getDisplayName(t));
    else types = [
        getDisplayName(type)
    ];
    toArray(children).forEach((child)=>{
        // @ts-expect-error toArray and lodash.get are not compatible. Let's get rid of the whole findAllByType function
        var childType = (0, _getDefault.default)(child, 'type.displayName') || (0, _getDefault.default)(child, 'type.name');
        if (childType && types.indexOf(childType) !== -1) result.push(child);
    });
    return result;
}
var isClipDot = (dot)=>{
    if (dot && typeof dot === 'object' && 'clipDot' in dot) return Boolean(dot.clipDot);
    return true;
};

},{"es-toolkit/compat/get":"7LxLv","react":"bmhQu","react-is":"m2UGx","./DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"m2UGx":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("69b8dc74edea6c6c");

},{"69b8dc74edea6c6c":"58XvN"}],"58XvN":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * react-is.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = Symbol.for("react.memo"), REACT_LAZY_TYPE = Symbol.for("react.lazy"), REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function typeOf(object) {
    if ("object" === typeof object && null !== object) {
        var $$typeof = object.$$typeof;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                    case REACT_VIEW_TRANSITION_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
exports.ContextConsumer = REACT_CONSUMER_TYPE;
exports.ContextProvider = REACT_CONTEXT_TYPE;
exports.Element = REACT_ELEMENT_TYPE;
exports.ForwardRef = REACT_FORWARD_REF_TYPE;
exports.Fragment = REACT_FRAGMENT_TYPE;
exports.Lazy = REACT_LAZY_TYPE;
exports.Memo = REACT_MEMO_TYPE;
exports.Portal = REACT_PORTAL_TYPE;
exports.Profiler = REACT_PROFILER_TYPE;
exports.StrictMode = REACT_STRICT_MODE_TYPE;
exports.Suspense = REACT_SUSPENSE_TYPE;
exports.SuspenseList = REACT_SUSPENSE_LIST_TYPE;
exports.isContextConsumer = function(object) {
    return typeOf(object) === REACT_CONSUMER_TYPE;
};
exports.isContextProvider = function(object) {
    return typeOf(object) === REACT_CONTEXT_TYPE;
};
exports.isElement = function(object) {
    return "object" === typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
};
exports.isForwardRef = function(object) {
    return typeOf(object) === REACT_FORWARD_REF_TYPE;
};
exports.isFragment = function(object) {
    return typeOf(object) === REACT_FRAGMENT_TYPE;
};
exports.isLazy = function(object) {
    return typeOf(object) === REACT_LAZY_TYPE;
};
exports.isMemo = function(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
};
exports.isPortal = function(object) {
    return typeOf(object) === REACT_PORTAL_TYPE;
};
exports.isProfiler = function(object) {
    return typeOf(object) === REACT_PROFILER_TYPE;
};
exports.isStrictMode = function(object) {
    return typeOf(object) === REACT_STRICT_MODE_TYPE;
};
exports.isSuspense = function(object) {
    return typeOf(object) === REACT_SUSPENSE_TYPE;
};
exports.isSuspenseList = function(object) {
    return typeOf(object) === REACT_SUSPENSE_LIST_TYPE;
};
exports.isValidElementType = function(type) {
    return "string" === typeof type || "function" === typeof type || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || "object" === typeof type && null !== type && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || void 0 !== type.getModuleId) ? !0 : !1;
};
exports.typeOf = typeOf;

},{}],"lEBvx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActivePoints", ()=>ActivePoints);
var _react = require("react");
var _types = require("../util/types");
var _dot = require("../shape/Dot");
var _layer = require("../container/Layer");
var _hooks = require("../state/hooks");
var _tooltipSelectors = require("../state/selectors/tooltipSelectors");
var _hooks1 = require("../hooks");
var _dataUtils = require("../util/DataUtils");
var _svgPropertiesNoEvents = require("../util/svgPropertiesNoEvents");
var _zindexLayer = require("../zIndex/ZIndexLayer");
var _defaultZIndexes = require("../zIndex/DefaultZIndexes");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var ActivePoint = (_ref)=>{
    var { point, childIndex, mainColor, activeDot, dataKey, clipPath } = _ref;
    if (activeDot === false || point.x == null || point.y == null) return null;
    var dotPropsTyped = {
        index: childIndex,
        dataKey,
        cx: point.x,
        cy: point.y,
        r: 4,
        fill: mainColor !== null && mainColor !== void 0 ? mainColor : 'none',
        strokeWidth: 2,
        stroke: '#fff',
        payload: point.payload,
        value: point.value
    };
    // @ts-expect-error svgPropertiesNoEventsFromUnknown(activeDot) is contributing unknown props
    var dotProps = _objectSpread(_objectSpread(_objectSpread({}, dotPropsTyped), (0, _svgPropertiesNoEvents.svgPropertiesNoEventsFromUnknown)(activeDot)), (0, _types.adaptEventHandlers)(activeDot));
    var dot;
    if (/*#__PURE__*/ (0, _react.isValidElement)(activeDot)) // @ts-expect-error we're improperly typing events
    dot = /*#__PURE__*/ (0, _react.cloneElement)(activeDot, dotProps);
    else if (typeof activeDot === 'function') dot = activeDot(dotProps);
    else dot = /*#__PURE__*/ _react.createElement((0, _dot.Dot), dotProps);
    return /*#__PURE__*/ _react.createElement((0, _layer.Layer), {
        className: "recharts-active-dot",
        clipPath: clipPath
    }, dot);
};
function ActivePoints(_ref2) {
    var { points, mainColor, activeDot, itemDataKey, clipPath, zIndex = (0, _defaultZIndexes.DefaultZIndexes).activeDot } = _ref2;
    var activeTooltipIndex = (0, _hooks.useAppSelector)((0, _tooltipSelectors.selectActiveTooltipIndex));
    var activeDataPoints = (0, _hooks1.useActiveTooltipDataPoints)();
    if (points == null || activeDataPoints == null) return null;
    var activePoint = points.find((p)=>activeDataPoints.includes(p.payload));
    if ((0, _dataUtils.isNullish)(activePoint)) return null;
    return /*#__PURE__*/ _react.createElement((0, _zindexLayer.ZIndexLayer), {
        zIndex: zIndex
    }, /*#__PURE__*/ _react.createElement(ActivePoint, {
        point: activePoint,
        childIndex: Number(activeTooltipIndex),
        mainColor: mainColor,
        dataKey: itemDataKey,
        activeDot: activeDot,
        clipPath: clipPath
    }));
}

},{"react":"bmhQu","../util/types":"9qdl2","../shape/Dot":"8aTES","../container/Layer":"ctc59","../state/hooks":"aEuxu","../state/selectors/tooltipSelectors":"hydW6","../hooks":"gL5ve","../util/DataUtils":"lNZEj","../util/svgPropertiesNoEvents":"2NZlZ","../zIndex/ZIndexLayer":"6RR5t","../zIndex/DefaultZIndexes":"h8nlV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hydW6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectTooltipAxisRealScaleType", ()=>selectTooltipAxisRealScaleType);
parcelHelpers.export(exports, "selectAllUnfilteredGraphicalItems", ()=>selectAllUnfilteredGraphicalItems);
parcelHelpers.export(exports, "selectAllGraphicalItemsSettings", ()=>selectAllGraphicalItemsSettings);
parcelHelpers.export(exports, "selectTooltipGraphicalItemsData", ()=>selectTooltipGraphicalItemsData);
parcelHelpers.export(exports, "selectTooltipDisplayedData", ()=>selectTooltipDisplayedData);
parcelHelpers.export(exports, "selectTooltipAxisDomain", ()=>selectTooltipAxisDomain);
parcelHelpers.export(exports, "selectTooltipAxisDomainIncludingNiceTicks", ()=>selectTooltipAxisDomainIncludingNiceTicks);
parcelHelpers.export(exports, "selectTooltipAxisRangeWithReverse", ()=>selectTooltipAxisRangeWithReverse);
parcelHelpers.export(exports, "selectTooltipAxisScale", ()=>selectTooltipAxisScale);
parcelHelpers.export(exports, "selectTooltipCategoricalDomain", ()=>selectTooltipCategoricalDomain);
parcelHelpers.export(exports, "selectTooltipAxisTicks", ()=>selectTooltipAxisTicks);
parcelHelpers.export(exports, "selectActiveTooltipIndex", ()=>selectActiveTooltipIndex);
parcelHelpers.export(exports, "selectActiveLabel", ()=>selectActiveLabel);
parcelHelpers.export(exports, "selectActiveTooltipDataKey", ()=>selectActiveTooltipDataKey);
parcelHelpers.export(exports, "selectActiveTooltipGraphicalItemId", ()=>selectActiveTooltipGraphicalItemId);
parcelHelpers.export(exports, "selectActiveTooltipCoordinate", ()=>selectActiveTooltipCoordinate);
parcelHelpers.export(exports, "selectIsTooltipActive", ()=>selectIsTooltipActive);
parcelHelpers.export(exports, "selectActiveTooltipPayload", ()=>selectActiveTooltipPayload);
parcelHelpers.export(exports, "selectActiveTooltipDataPoints", ()=>selectActiveTooltipDataPoints);
var _reselect = require("reselect");
var _axisSelectors = require("./axisSelectors");
var _chartLayoutContext = require("../../context/chartLayoutContext");
var _chartUtils = require("../../util/ChartUtils");
var _dataSelectors = require("./dataSelectors");
var _rootPropsSelectors = require("./rootPropsSelectors");
var _dataUtils = require("../../util/DataUtils");
var _combineAxisRangeWithReverse = require("./combiners/combineAxisRangeWithReverse");
var _selectTooltipEventType = require("./selectTooltipEventType");
var _combineActiveLabel = require("./combiners/combineActiveLabel");
var _selectTooltipSettings = require("./selectTooltipSettings");
var _combineTooltipInteractionState = require("./combiners/combineTooltipInteractionState");
var _combineActiveTooltipIndex = require("./combiners/combineActiveTooltipIndex");
var _combineCoordinateForDefaultIndex = require("./combiners/combineCoordinateForDefaultIndex");
var _containerSelectors = require("./containerSelectors");
var _selectChartOffsetInternal = require("./selectChartOffsetInternal");
var _combineTooltipPayloadConfigurations = require("./combiners/combineTooltipPayloadConfigurations");
var _selectTooltipPayloadSearcher = require("./selectTooltipPayloadSearcher");
var _selectTooltipState = require("./selectTooltipState");
var _combineTooltipPayload = require("./combiners/combineTooltipPayload");
var _selectTooltipAxisId = require("./selectTooltipAxisId");
var _selectTooltipAxisType = require("./selectTooltipAxisType");
var _combineDisplayedStackedData = require("./combiners/combineDisplayedStackedData");
var _stackedGraphicalItem = require("../types/StackedGraphicalItem");
var _isDomainSpecifiedByUser = require("../../util/isDomainSpecifiedByUser");
var _numberDomainEqualityCheck = require("./numberDomainEqualityCheck");
var _arrayEqualityCheck = require("./arrayEqualityCheck");
var selectTooltipAxisRealScaleType = (0, _reselect.createSelector)([
    (0, _axisSelectors.selectTooltipAxis),
    (0, _chartLayoutContext.selectChartLayout),
    (0, _axisSelectors.selectHasBar),
    (0, _rootPropsSelectors.selectChartName),
    (0, _selectTooltipAxisType.selectTooltipAxisType)
], (0, _axisSelectors.combineRealScaleType));
var selectAllUnfilteredGraphicalItems = (0, _reselect.createSelector)([
    (state)=>state.graphicalItems.cartesianItems,
    (state)=>state.graphicalItems.polarItems
], (cartesianItems, polarItems)=>[
        ...cartesianItems,
        ...polarItems
    ]);
var selectTooltipAxisPredicate = (0, _reselect.createSelector)([
    (0, _selectTooltipAxisType.selectTooltipAxisType),
    (0, _selectTooltipAxisId.selectTooltipAxisId)
], (0, _axisSelectors.itemAxisPredicate));
var selectAllGraphicalItemsSettings = (0, _reselect.createSelector)([
    selectAllUnfilteredGraphicalItems,
    (0, _axisSelectors.selectTooltipAxis),
    selectTooltipAxisPredicate
], (0, _axisSelectors.combineGraphicalItemsSettings), {
    memoizeOptions: {
        resultEqualityCheck: (0, _arrayEqualityCheck.emptyArraysAreEqualCheck)
    }
});
var selectAllStackedGraphicalItemsSettings = (0, _reselect.createSelector)([
    selectAllGraphicalItemsSettings
], (graphicalItems)=>graphicalItems.filter((0, _stackedGraphicalItem.isStacked)));
var selectTooltipGraphicalItemsData = (0, _reselect.createSelector)([
    selectAllGraphicalItemsSettings
], (0, _axisSelectors.combineGraphicalItemsData), {
    memoizeOptions: {
        resultEqualityCheck: (0, _arrayEqualityCheck.emptyArraysAreEqualCheck)
    }
});
var selectTooltipDisplayedData = (0, _reselect.createSelector)([
    selectTooltipGraphicalItemsData,
    (0, _dataSelectors.selectChartDataWithIndexes)
], (0, _axisSelectors.combineDisplayedData));
var selectTooltipStackedData = (0, _reselect.createSelector)([
    selectAllStackedGraphicalItemsSettings,
    (0, _dataSelectors.selectChartDataWithIndexes),
    (0, _axisSelectors.selectTooltipAxis)
], (0, _combineDisplayedStackedData.combineDisplayedStackedData));
var selectAllTooltipAppliedValues = (0, _reselect.createSelector)([
    selectTooltipDisplayedData,
    (0, _axisSelectors.selectTooltipAxis),
    selectAllGraphicalItemsSettings
], (0, _axisSelectors.combineAppliedValues));
var selectTooltipAxisDomainDefinition = (0, _reselect.createSelector)([
    (0, _axisSelectors.selectTooltipAxis)
], (0, _axisSelectors.getDomainDefinition));
var selectTooltipDataOverflow = (0, _reselect.createSelector)([
    (0, _axisSelectors.selectTooltipAxis)
], (axisSettings)=>axisSettings.allowDataOverflow);
var selectTooltipDomainFromUserPreferences = (0, _reselect.createSelector)([
    selectTooltipAxisDomainDefinition,
    selectTooltipDataOverflow
], (0, _isDomainSpecifiedByUser.numericalDomainSpecifiedWithoutRequiringData));
var selectAllStackedGraphicalItems = (0, _reselect.createSelector)([
    selectAllGraphicalItemsSettings
], (graphicalItems)=>graphicalItems.filter((0, _stackedGraphicalItem.isStacked)));
var selectTooltipStackGroups = (0, _reselect.createSelector)([
    selectTooltipStackedData,
    selectAllStackedGraphicalItems,
    (0, _rootPropsSelectors.selectStackOffsetType),
    (0, _rootPropsSelectors.selectReverseStackOrder)
], (0, _axisSelectors.combineStackGroups));
var selectTooltipDomainOfStackGroups = (0, _reselect.createSelector)([
    selectTooltipStackGroups,
    (0, _dataSelectors.selectChartDataWithIndexes),
    (0, _selectTooltipAxisType.selectTooltipAxisType),
    selectTooltipDomainFromUserPreferences
], (0, _axisSelectors.combineDomainOfStackGroups));
var selectTooltipItemsSettingsExceptStacked = (0, _reselect.createSelector)([
    selectAllGraphicalItemsSettings
], (0, _axisSelectors.filterGraphicalNotStackedItems));
var selectDomainOfAllAppliedNumericalValuesIncludingErrorValues = (0, _reselect.createSelector)([
    selectTooltipDisplayedData,
    (0, _axisSelectors.selectTooltipAxis),
    selectTooltipItemsSettingsExceptStacked,
    (0, _axisSelectors.selectAllErrorBarSettings),
    (0, _selectTooltipAxisType.selectTooltipAxisType)
], (0, _axisSelectors.combineDomainOfAllAppliedNumericalValuesIncludingErrorValues), {
    memoizeOptions: {
        resultEqualityCheck: (0, _numberDomainEqualityCheck.numberDomainEqualityCheck)
    }
});
var selectReferenceDotsByTooltipAxis = (0, _reselect.createSelector)([
    (0, _axisSelectors.selectReferenceDots),
    (0, _selectTooltipAxisType.selectTooltipAxisType),
    (0, _selectTooltipAxisId.selectTooltipAxisId)
], (0, _axisSelectors.filterReferenceElements));
var selectTooltipReferenceDotsDomain = (0, _reselect.createSelector)([
    selectReferenceDotsByTooltipAxis,
    (0, _selectTooltipAxisType.selectTooltipAxisType)
], (0, _axisSelectors.combineDotsDomain));
var selectReferenceAreasByTooltipAxis = (0, _reselect.createSelector)([
    (0, _axisSelectors.selectReferenceAreas),
    (0, _selectTooltipAxisType.selectTooltipAxisType),
    (0, _selectTooltipAxisId.selectTooltipAxisId)
], (0, _axisSelectors.filterReferenceElements));
var selectTooltipReferenceAreasDomain = (0, _reselect.createSelector)([
    selectReferenceAreasByTooltipAxis,
    (0, _selectTooltipAxisType.selectTooltipAxisType)
], (0, _axisSelectors.combineAreasDomain));
var selectReferenceLinesByTooltipAxis = (0, _reselect.createSelector)([
    (0, _axisSelectors.selectReferenceLines),
    (0, _selectTooltipAxisType.selectTooltipAxisType),
    (0, _selectTooltipAxisId.selectTooltipAxisId)
], (0, _axisSelectors.filterReferenceElements));
var selectTooltipReferenceLinesDomain = (0, _reselect.createSelector)([
    selectReferenceLinesByTooltipAxis,
    (0, _selectTooltipAxisType.selectTooltipAxisType)
], (0, _axisSelectors.combineLinesDomain));
var selectTooltipReferenceElementsDomain = (0, _reselect.createSelector)([
    selectTooltipReferenceDotsDomain,
    selectTooltipReferenceLinesDomain,
    selectTooltipReferenceAreasDomain
], (0, _axisSelectors.mergeDomains));
var selectTooltipNumericalDomain = (0, _reselect.createSelector)([
    (0, _axisSelectors.selectTooltipAxis),
    selectTooltipAxisDomainDefinition,
    selectTooltipDomainFromUserPreferences,
    selectTooltipDomainOfStackGroups,
    selectDomainOfAllAppliedNumericalValuesIncludingErrorValues,
    selectTooltipReferenceElementsDomain,
    (0, _chartLayoutContext.selectChartLayout),
    (0, _selectTooltipAxisType.selectTooltipAxisType)
], (0, _axisSelectors.combineNumericalDomain));
var selectTooltipAxisDomain = (0, _reselect.createSelector)([
    (0, _axisSelectors.selectTooltipAxis),
    (0, _chartLayoutContext.selectChartLayout),
    selectTooltipDisplayedData,
    selectAllTooltipAppliedValues,
    (0, _rootPropsSelectors.selectStackOffsetType),
    (0, _selectTooltipAxisType.selectTooltipAxisType),
    selectTooltipNumericalDomain
], (0, _axisSelectors.combineAxisDomain));
var selectTooltipNiceTicks = (0, _reselect.createSelector)([
    selectTooltipAxisDomain,
    (0, _axisSelectors.selectTooltipAxis),
    selectTooltipAxisRealScaleType
], (0, _axisSelectors.combineNiceTicks));
var selectTooltipAxisDomainIncludingNiceTicks = (0, _reselect.createSelector)([
    (0, _axisSelectors.selectTooltipAxis),
    selectTooltipAxisDomain,
    selectTooltipNiceTicks,
    (0, _selectTooltipAxisType.selectTooltipAxisType)
], (0, _axisSelectors.combineAxisDomainWithNiceTicks));
var selectTooltipAxisRange = (state)=>{
    var axisType = (0, _selectTooltipAxisType.selectTooltipAxisType)(state);
    var axisId = (0, _selectTooltipAxisId.selectTooltipAxisId)(state);
    var isPanorama = false; // Tooltip never displays in panorama so this is safe to assume
    return (0, _axisSelectors.selectAxisRange)(state, axisType, axisId, isPanorama);
};
var selectTooltipAxisRangeWithReverse = (0, _reselect.createSelector)([
    (0, _axisSelectors.selectTooltipAxis),
    selectTooltipAxisRange
], (0, _combineAxisRangeWithReverse.combineAxisRangeWithReverse));
var selectTooltipAxisScale = (0, _reselect.createSelector)([
    (0, _axisSelectors.selectTooltipAxis),
    selectTooltipAxisRealScaleType,
    selectTooltipAxisDomainIncludingNiceTicks,
    selectTooltipAxisRangeWithReverse
], (0, _axisSelectors.combineScaleFunction));
var selectTooltipDuplicateDomain = (0, _reselect.createSelector)([
    (0, _chartLayoutContext.selectChartLayout),
    selectAllTooltipAppliedValues,
    (0, _axisSelectors.selectTooltipAxis),
    (0, _selectTooltipAxisType.selectTooltipAxisType)
], (0, _axisSelectors.combineDuplicateDomain));
var selectTooltipCategoricalDomain = (0, _reselect.createSelector)([
    (0, _chartLayoutContext.selectChartLayout),
    selectAllTooltipAppliedValues,
    (0, _axisSelectors.selectTooltipAxis),
    (0, _selectTooltipAxisType.selectTooltipAxisType)
], (0, _axisSelectors.combineCategoricalDomain));
var combineTicksOfTooltipAxis = (layout, axis, realScaleType, scale, range, duplicateDomain, categoricalDomain, axisType)=>{
    if (!axis) return undefined;
    var { type } = axis;
    var isCategorical = (0, _chartUtils.isCategoricalAxis)(layout, axisType);
    if (!scale) return undefined;
    var offsetForBand = realScaleType === 'scaleBand' && scale.bandwidth ? scale.bandwidth() / 2 : 2;
    var offset = type === 'category' && scale.bandwidth ? scale.bandwidth() / offsetForBand : 0;
    offset = axisType === 'angleAxis' && range != null && (range === null || range === void 0 ? void 0 : range.length) >= 2 ? (0, _dataUtils.mathSign)(range[0] - range[1]) * 2 * offset : offset;
    // When axis is a categorical axis, but the type of axis is number or the scale of axis is not "auto"
    if (isCategorical && categoricalDomain) return categoricalDomain.map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: entry,
            index,
            offset
        }));
    // When axis has duplicated text, serial numbers are used to generate scale
    return scale.domain().map((entry, index)=>({
            coordinate: scale(entry) + offset,
            value: duplicateDomain ? duplicateDomain[entry] : entry,
            index,
            offset
        }));
};
var selectTooltipAxisTicks = (0, _reselect.createSelector)([
    (0, _chartLayoutContext.selectChartLayout),
    (0, _axisSelectors.selectTooltipAxis),
    selectTooltipAxisRealScaleType,
    selectTooltipAxisScale,
    selectTooltipAxisRange,
    selectTooltipDuplicateDomain,
    selectTooltipCategoricalDomain,
    (0, _selectTooltipAxisType.selectTooltipAxisType)
], combineTicksOfTooltipAxis);
var selectTooltipEventType = (0, _reselect.createSelector)([
    (0, _selectTooltipEventType.selectDefaultTooltipEventType),
    (0, _selectTooltipEventType.selectValidateTooltipEventTypes),
    (0, _selectTooltipSettings.selectTooltipSettings)
], (defaultTooltipEventType, validateTooltipEventType, settings)=>(0, _selectTooltipEventType.combineTooltipEventType)(settings.shared, defaultTooltipEventType, validateTooltipEventType));
var selectTooltipTrigger = (state)=>state.tooltip.settings.trigger;
var selectDefaultIndex = (state)=>state.tooltip.settings.defaultIndex;
var selectTooltipInteractionState = (0, _reselect.createSelector)([
    (0, _selectTooltipState.selectTooltipState),
    selectTooltipEventType,
    selectTooltipTrigger,
    selectDefaultIndex
], (0, _combineTooltipInteractionState.combineTooltipInteractionState));
var selectActiveTooltipIndex = (0, _reselect.createSelector)([
    selectTooltipInteractionState,
    selectTooltipDisplayedData,
    (0, _axisSelectors.selectTooltipAxisDataKey),
    selectTooltipAxisDomain
], (0, _combineActiveTooltipIndex.combineActiveTooltipIndex));
var selectActiveLabel = (0, _reselect.createSelector)([
    selectTooltipAxisTicks,
    selectActiveTooltipIndex
], (0, _combineActiveLabel.combineActiveLabel));
var selectActiveTooltipDataKey = (0, _reselect.createSelector)([
    selectTooltipInteractionState
], (tooltipInteraction)=>{
    if (!tooltipInteraction) return undefined;
    return tooltipInteraction.dataKey;
});
var selectActiveTooltipGraphicalItemId = (0, _reselect.createSelector)([
    selectTooltipInteractionState
], (tooltipInteraction)=>{
    if (!tooltipInteraction) return undefined;
    return tooltipInteraction.graphicalItemId;
});
var selectTooltipPayloadConfigurations = (0, _reselect.createSelector)([
    (0, _selectTooltipState.selectTooltipState),
    selectTooltipEventType,
    selectTooltipTrigger,
    selectDefaultIndex
], (0, _combineTooltipPayloadConfigurations.combineTooltipPayloadConfigurations));
var selectTooltipCoordinateForDefaultIndex = (0, _reselect.createSelector)([
    (0, _containerSelectors.selectChartWidth),
    (0, _containerSelectors.selectChartHeight),
    (0, _chartLayoutContext.selectChartLayout),
    (0, _selectChartOffsetInternal.selectChartOffsetInternal),
    selectTooltipAxisTicks,
    selectDefaultIndex,
    selectTooltipPayloadConfigurations,
    (0, _selectTooltipPayloadSearcher.selectTooltipPayloadSearcher)
], (0, _combineCoordinateForDefaultIndex.combineCoordinateForDefaultIndex));
var selectActiveTooltipCoordinate = (0, _reselect.createSelector)([
    selectTooltipInteractionState,
    selectTooltipCoordinateForDefaultIndex
], (tooltipInteractionState, defaultIndexCoordinate)=>{
    if (tooltipInteractionState !== null && tooltipInteractionState !== void 0 && tooltipInteractionState.coordinate) return tooltipInteractionState.coordinate;
    return defaultIndexCoordinate;
});
var selectIsTooltipActive = (0, _reselect.createSelector)([
    selectTooltipInteractionState
], (tooltipInteractionState)=>{
    var _tooltipInteractionSt;
    return (_tooltipInteractionSt = tooltipInteractionState === null || tooltipInteractionState === void 0 ? void 0 : tooltipInteractionState.active) !== null && _tooltipInteractionSt !== void 0 ? _tooltipInteractionSt : false;
});
var selectActiveTooltipPayload = (0, _reselect.createSelector)([
    selectTooltipPayloadConfigurations,
    selectActiveTooltipIndex,
    (0, _dataSelectors.selectChartDataWithIndexes),
    (0, _axisSelectors.selectTooltipAxisDataKey),
    selectActiveLabel,
    (0, _selectTooltipPayloadSearcher.selectTooltipPayloadSearcher),
    selectTooltipEventType
], (0, _combineTooltipPayload.combineTooltipPayload));
var selectActiveTooltipDataPoints = (0, _reselect.createSelector)([
    selectActiveTooltipPayload
], (payload)=>{
    if (payload == null) return undefined;
    var dataPoints = payload.map((p)=>p.payload).filter((p)=>p != null);
    return Array.from(new Set(dataPoints));
});

},{"reselect":"ds2su","./axisSelectors":"bvR8m","../../context/chartLayoutContext":"jIUyy","../../util/ChartUtils":"enJyE","./dataSelectors":"j0cmw","./rootPropsSelectors":"eYPte","../../util/DataUtils":"lNZEj","./combiners/combineAxisRangeWithReverse":"c3amE","./selectTooltipEventType":"4RpEb","./combiners/combineActiveLabel":"2d1rr","./selectTooltipSettings":"iUsgm","./combiners/combineTooltipInteractionState":"41NKO","./combiners/combineActiveTooltipIndex":"f5Q8L","./combiners/combineCoordinateForDefaultIndex":"17rFP","./containerSelectors":"lnBke","./selectChartOffsetInternal":"caUjq","./combiners/combineTooltipPayloadConfigurations":"iA3O6","./selectTooltipPayloadSearcher":"i7xdk","./selectTooltipState":"XQ7NK","./combiners/combineTooltipPayload":"lgUnN","./selectTooltipAxisId":"laxEp","./selectTooltipAxisType":"hUECt","./combiners/combineDisplayedStackedData":"c7vK5","../types/StackedGraphicalItem":"ivpBz","../../util/isDomainSpecifiedByUser":"5AAMy","./numberDomainEqualityCheck":"8LF4r","./arrayEqualityCheck":"R4lui","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4RpEb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectDefaultTooltipEventType", ()=>selectDefaultTooltipEventType);
parcelHelpers.export(exports, "selectValidateTooltipEventTypes", ()=>selectValidateTooltipEventTypes);
parcelHelpers.export(exports, "combineTooltipEventType", ()=>combineTooltipEventType);
parcelHelpers.export(exports, "selectTooltipEventType", ()=>selectTooltipEventType);
parcelHelpers.export(exports, "useTooltipEventType", ()=>useTooltipEventType);
var _hooks = require("../hooks");
var selectDefaultTooltipEventType = (state)=>state.options.defaultTooltipEventType;
var selectValidateTooltipEventTypes = (state)=>state.options.validateTooltipEventTypes;
function combineTooltipEventType(shared, defaultTooltipEventType, validateTooltipEventTypes) {
    if (shared == null) return defaultTooltipEventType;
    var eventType = shared ? 'axis' : 'item';
    if (validateTooltipEventTypes == null) return defaultTooltipEventType;
    return validateTooltipEventTypes.includes(eventType) ? eventType : defaultTooltipEventType;
}
function selectTooltipEventType(state, shared) {
    var defaultTooltipEventType = selectDefaultTooltipEventType(state);
    var validateTooltipEventTypes = selectValidateTooltipEventTypes(state);
    return combineTooltipEventType(shared, defaultTooltipEventType, validateTooltipEventTypes);
}
function useTooltipEventType(shared) {
    return (0, _hooks.useAppSelector)((state)=>selectTooltipEventType(state, shared));
}

},{"../hooks":"aEuxu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2d1rr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineActiveLabel", ()=>combineActiveLabel);
var _dataUtils = require("../../../util/DataUtils");
var combineActiveLabel = (tooltipTicks, activeIndex)=>{
    var _tooltipTicks$n;
    var n = Number(activeIndex);
    if ((0, _dataUtils.isNan)(n) || activeIndex == null) return undefined;
    return n >= 0 ? tooltipTicks === null || tooltipTicks === void 0 || (_tooltipTicks$n = tooltipTicks[n]) === null || _tooltipTicks$n === void 0 ? void 0 : _tooltipTicks$n.value : undefined;
};

},{"../../../util/DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iUsgm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectTooltipSettings", ()=>selectTooltipSettings);
var selectTooltipSettings = (state)=>state.tooltip.settings;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"41NKO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineTooltipInteractionState", ()=>combineTooltipInteractionState);
var _tooltipSlice = require("../../tooltipSlice");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function chooseAppropriateMouseInteraction(tooltipState, tooltipEventType, trigger) {
    if (tooltipEventType === 'axis') {
        if (trigger === 'click') return tooltipState.axisInteraction.click;
        return tooltipState.axisInteraction.hover;
    }
    if (trigger === 'click') return tooltipState.itemInteraction.click;
    return tooltipState.itemInteraction.hover;
}
function hasBeenActivePreviously(tooltipInteractionState) {
    return tooltipInteractionState.index != null;
}
var combineTooltipInteractionState = (tooltipState, tooltipEventType, trigger, defaultIndex)=>{
    if (tooltipEventType == null) return 0, _tooltipSlice.noInteraction;
    var appropriateMouseInteraction = chooseAppropriateMouseInteraction(tooltipState, tooltipEventType, trigger);
    if (appropriateMouseInteraction == null) return 0, _tooltipSlice.noInteraction;
    if (appropriateMouseInteraction.active) return appropriateMouseInteraction;
    if (tooltipState.keyboardInteraction.active) return tooltipState.keyboardInteraction;
    if (tooltipState.syncInteraction.active && tooltipState.syncInteraction.index != null) return tooltipState.syncInteraction;
    var activeFromProps = tooltipState.settings.active === true;
    if (hasBeenActivePreviously(appropriateMouseInteraction)) {
        if (activeFromProps) return _objectSpread(_objectSpread({}, appropriateMouseInteraction), {}, {
            active: true
        });
    } else if (defaultIndex != null) return {
        active: true,
        coordinate: undefined,
        dataKey: undefined,
        index: defaultIndex,
        graphicalItemId: undefined
    };
    return _objectSpread(_objectSpread({}, (0, _tooltipSlice.noInteraction)), {}, {
        coordinate: appropriateMouseInteraction.coordinate
    });
};

},{"../../tooltipSlice":"8Jqu4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Jqu4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "noInteraction", ()=>noInteraction);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "addTooltipEntrySettings", ()=>addTooltipEntrySettings);
parcelHelpers.export(exports, "replaceTooltipEntrySettings", ()=>replaceTooltipEntrySettings);
parcelHelpers.export(exports, "removeTooltipEntrySettings", ()=>removeTooltipEntrySettings);
parcelHelpers.export(exports, "setTooltipSettingsState", ()=>setTooltipSettingsState);
parcelHelpers.export(exports, "setActiveMouseOverItemIndex", ()=>setActiveMouseOverItemIndex);
parcelHelpers.export(exports, "mouseLeaveItem", ()=>mouseLeaveItem);
parcelHelpers.export(exports, "mouseLeaveChart", ()=>mouseLeaveChart);
parcelHelpers.export(exports, "setActiveClickItemIndex", ()=>setActiveClickItemIndex);
parcelHelpers.export(exports, "setMouseOverAxisIndex", ()=>setMouseOverAxisIndex);
parcelHelpers.export(exports, "setMouseClickAxisIndex", ()=>setMouseClickAxisIndex);
parcelHelpers.export(exports, "setSyncInteraction", ()=>setSyncInteraction);
parcelHelpers.export(exports, "setKeyboardInteraction", ()=>setKeyboardInteraction);
parcelHelpers.export(exports, "tooltipReducer", ()=>tooltipReducer);
var _toolkit = require("@reduxjs/toolkit");
var _immer = require("immer");
var noInteraction = {
    active: false,
    index: null,
    dataKey: undefined,
    graphicalItemId: undefined,
    coordinate: undefined
};
var initialState = {
    itemInteraction: {
        click: noInteraction,
        hover: noInteraction
    },
    axisInteraction: {
        click: noInteraction,
        hover: noInteraction
    },
    keyboardInteraction: noInteraction,
    syncInteraction: {
        active: false,
        index: null,
        dataKey: undefined,
        label: undefined,
        coordinate: undefined,
        sourceViewBox: undefined,
        graphicalItemId: undefined
    },
    tooltipItemPayloads: [],
    settings: {
        shared: undefined,
        trigger: 'hover',
        axisId: 0,
        active: false,
        defaultIndex: undefined
    }
};
/**
 * This is the event we get when user is interacting with a specific graphical item.
 */ /**
 * Keyboard interaction payload has no graphical item ID,
 * and no dataKey, because keyboard interaction is always
 * with the whole chart, not with a specific graphical item.
 */ var tooltipSlice = (0, _toolkit.createSlice)({
    name: 'tooltip',
    initialState,
    reducers: {
        addTooltipEntrySettings: {
            reducer (state, action) {
                state.tooltipItemPayloads.push((0, _immer.castDraft)(action.payload));
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        replaceTooltipEntrySettings: {
            reducer (state, action) {
                var { prev, next } = action.payload;
                var index = (0, _toolkit.current)(state).tooltipItemPayloads.indexOf((0, _immer.castDraft)(prev));
                if (index > -1) state.tooltipItemPayloads[index] = (0, _immer.castDraft)(next);
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        removeTooltipEntrySettings: {
            reducer (state, action) {
                var index = (0, _toolkit.current)(state).tooltipItemPayloads.indexOf((0, _immer.castDraft)(action.payload));
                if (index > -1) state.tooltipItemPayloads.splice(index, 1);
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        setTooltipSettingsState (state, action) {
            state.settings = action.payload;
        },
        setActiveMouseOverItemIndex (state, action) {
            state.syncInteraction.active = false;
            state.keyboardInteraction.active = false;
            state.itemInteraction.hover.active = true;
            state.itemInteraction.hover.index = action.payload.activeIndex;
            state.itemInteraction.hover.dataKey = action.payload.activeDataKey;
            state.itemInteraction.hover.graphicalItemId = action.payload.activeGraphicalItemId;
            state.itemInteraction.hover.coordinate = action.payload.activeCoordinate;
        },
        mouseLeaveChart (state) {
            /*
       * Clear only the active flags. Why?
       * 1. Keep Coordinate to preserve animation - next time the Tooltip appears, we want to render it from
       * the last place where it was when it disappeared.
       * 2. We want to keep all the properties anyway just in case the tooltip has `active=true` prop
       * and continues being visible even after the mouse has left the chart.
       */ state.itemInteraction.hover.active = false;
            state.axisInteraction.hover.active = false;
        },
        mouseLeaveItem (state) {
            state.itemInteraction.hover.active = false;
        },
        setActiveClickItemIndex (state, action) {
            state.syncInteraction.active = false;
            state.itemInteraction.click.active = true;
            state.keyboardInteraction.active = false;
            state.itemInteraction.click.index = action.payload.activeIndex;
            state.itemInteraction.click.dataKey = action.payload.activeDataKey;
            state.itemInteraction.click.graphicalItemId = action.payload.activeGraphicalItemId;
            state.itemInteraction.click.coordinate = action.payload.activeCoordinate;
        },
        setMouseOverAxisIndex (state, action) {
            state.syncInteraction.active = false;
            state.axisInteraction.hover.active = true;
            state.keyboardInteraction.active = false;
            state.axisInteraction.hover.index = action.payload.activeIndex;
            state.axisInteraction.hover.dataKey = action.payload.activeDataKey;
            state.axisInteraction.hover.coordinate = action.payload.activeCoordinate;
        },
        setMouseClickAxisIndex (state, action) {
            state.syncInteraction.active = false;
            state.keyboardInteraction.active = false;
            state.axisInteraction.click.active = true;
            state.axisInteraction.click.index = action.payload.activeIndex;
            state.axisInteraction.click.dataKey = action.payload.activeDataKey;
            state.axisInteraction.click.coordinate = action.payload.activeCoordinate;
        },
        setSyncInteraction (state, action) {
            state.syncInteraction = action.payload;
        },
        setKeyboardInteraction (state, action) {
            state.keyboardInteraction.active = action.payload.active;
            state.keyboardInteraction.index = action.payload.activeIndex;
            state.keyboardInteraction.coordinate = action.payload.activeCoordinate;
        }
    }
});
var { addTooltipEntrySettings, replaceTooltipEntrySettings, removeTooltipEntrySettings, setTooltipSettingsState, setActiveMouseOverItemIndex, mouseLeaveItem, mouseLeaveChart, setActiveClickItemIndex, setMouseOverAxisIndex, setMouseClickAxisIndex, setSyncInteraction, setKeyboardInteraction } = tooltipSlice.actions;
var tooltipReducer = tooltipSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","immer":"ggZ4C","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f5Q8L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineActiveTooltipIndex", ()=>combineActiveTooltipIndex);
var _isWellBehavedNumber = require("../../../util/isWellBehavedNumber");
var _chartUtils = require("../../../util/ChartUtils");
var _isDomainSpecifiedByUser = require("../../../util/isDomainSpecifiedByUser");
function toFiniteNumber(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : undefined;
    if (value instanceof Date) {
        var numericValue = value.valueOf();
        return Number.isFinite(numericValue) ? numericValue : undefined;
    }
    var parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
}
function isValueWithinNumberDomain(value, domain) {
    var numericValue = toFiniteNumber(value);
    var lowerBound = domain[0];
    var upperBound = domain[1];
    if (numericValue === undefined) return false;
    var min = Math.min(lowerBound, upperBound);
    var max = Math.max(lowerBound, upperBound);
    return numericValue >= min && numericValue <= max;
}
function isValueWithinDomain(entry, axisDataKey, domain) {
    if (domain == null || axisDataKey == null) return true;
    var value = (0, _chartUtils.getValueByDataKey)(entry, axisDataKey);
    if (value == null) return true;
    if (!(0, _isDomainSpecifiedByUser.isWellFormedNumberDomain)(domain)) return true;
    return isValueWithinNumberDomain(value, domain);
}
var combineActiveTooltipIndex = (tooltipInteraction, chartData, axisDataKey, domain)=>{
    var desiredIndex = tooltipInteraction === null || tooltipInteraction === void 0 ? void 0 : tooltipInteraction.index;
    if (desiredIndex == null) return null;
    var indexAsNumber = Number(desiredIndex);
    if (!(0, _isWellBehavedNumber.isWellBehavedNumber)(indexAsNumber)) // this is for charts like Sankey and Treemap that do not support numerical indexes. We need a proper solution for this before we can start supporting keyboard events on these charts.
    return desiredIndex;
    /*
   * Zero is a trivial limit for single-dimensional charts like Line and Area,
   * but this also needs a support for multidimensional charts like Sankey and Treemap! TODO
   */ var lowerLimit = 0;
    var upperLimit = Infinity;
    if (chartData.length > 0) upperLimit = chartData.length - 1;
    // now let's clamp the desiredIndex between the limits
    var clampedIndex = Math.max(lowerLimit, Math.min(indexAsNumber, upperLimit));
    var entry = chartData[clampedIndex];
    if (entry == null) return String(clampedIndex);
    if (!isValueWithinDomain(entry, axisDataKey, domain)) return null;
    return String(clampedIndex);
};

},{"../../../util/isWellBehavedNumber":"aIsFR","../../../util/ChartUtils":"enJyE","../../../util/isDomainSpecifiedByUser":"5AAMy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"17rFP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineCoordinateForDefaultIndex", ()=>combineCoordinateForDefaultIndex);
var combineCoordinateForDefaultIndex = (width, height, layout, offset, tooltipTicks, defaultIndex, tooltipConfigurations, tooltipPayloadSearcher)=>{
    if (defaultIndex == null || tooltipPayloadSearcher == null) return undefined;
    // With defaultIndex alone, we don't have enough information to decide _which_ of the multiple tooltips to display. So we choose the first one.
    var firstConfiguration = tooltipConfigurations[0];
    // @ts-expect-error we need to rethink the tooltipPayloadSearcher type
    var maybePosition = firstConfiguration == null ? undefined : tooltipPayloadSearcher(firstConfiguration.positions, defaultIndex);
    if (maybePosition != null) return maybePosition;
    var tick = tooltipTicks === null || tooltipTicks === void 0 ? void 0 : tooltipTicks[Number(defaultIndex)];
    if (!tick) return undefined;
    switch(layout){
        case 'horizontal':
            return {
                x: tick.coordinate,
                y: (offset.top + height) / 2
            };
        default:
            // This logic is not super sound - it conflates vertical, radial, centric layouts into just one. TODO improve!
            return {
                x: (offset.left + width) / 2,
                y: tick.coordinate
            };
    }
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iA3O6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineTooltipPayloadConfigurations", ()=>combineTooltipPayloadConfigurations);
var combineTooltipPayloadConfigurations = (tooltipState, tooltipEventType, trigger, defaultIndex)=>{
    // if tooltip reacts to axis interaction, then we display all items at the same time.
    if (tooltipEventType === 'axis') return tooltipState.tooltipItemPayloads;
    /*
   * By now we already know that tooltipEventType is 'item', so we can only search in itemInteractions.
   * item means that only the hovered or clicked item will be present in the tooltip.
   */ if (tooltipState.tooltipItemPayloads.length === 0) // No point filtering if the payload is empty
    return [];
    var filterByGraphicalItemId;
    if (trigger === 'hover') filterByGraphicalItemId = tooltipState.itemInteraction.hover.graphicalItemId;
    else filterByGraphicalItemId = tooltipState.itemInteraction.click.graphicalItemId;
    if (filterByGraphicalItemId == null && defaultIndex != null) {
        /*
     * So when we use `defaultIndex` - we don't have a dataKey to filter by because user did not hover over anything yet.
     * In that case let's display the first item in the tooltip; after all, this is `item` interaction case,
     * so we should display only one item at a time instead of all.
     */ var firstItemPayload = tooltipState.tooltipItemPayloads[0];
        if (firstItemPayload != null) return [
            firstItemPayload
        ];
        return [];
    }
    return tooltipState.tooltipItemPayloads.filter((tpc)=>{
        var _tpc$settings;
        return ((_tpc$settings = tpc.settings) === null || _tpc$settings === void 0 ? void 0 : _tpc$settings.graphicalItemId) === filterByGraphicalItemId;
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i7xdk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectTooltipPayloadSearcher", ()=>selectTooltipPayloadSearcher);
var selectTooltipPayloadSearcher = (state)=>state.options.tooltipPayloadSearcher;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"XQ7NK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectTooltipState", ()=>selectTooltipState);
var selectTooltipState = (state)=>state.tooltip;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lgUnN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "combineTooltipPayload", ()=>combineTooltipPayload);
var _dataUtils = require("../../../util/DataUtils");
var _chartUtils = require("../../../util/ChartUtils");
var _getSliced = require("../../../util/getSliced");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function selectFinalData(dataDefinedOnItem, dataDefinedOnChart) {
    /*
   * If a payload has data specified directly from the graphical item, prefer that.
   * Otherwise, fill in data from the chart level, using the same index.
   */ if (dataDefinedOnItem != null) return dataDefinedOnItem;
    return dataDefinedOnChart;
}
var combineTooltipPayload = (tooltipPayloadConfigurations, activeIndex, chartDataState, tooltipAxisDataKey, activeLabel, tooltipPayloadSearcher, tooltipEventType)=>{
    if (activeIndex == null || tooltipPayloadSearcher == null) return undefined;
    var { chartData, computedData, dataStartIndex, dataEndIndex } = chartDataState;
    var init = [];
    return tooltipPayloadConfigurations.reduce((agg, _ref)=>{
        var _settings$dataKey;
        var { dataDefinedOnItem, settings } = _ref;
        var finalData = selectFinalData(dataDefinedOnItem, chartData);
        var sliced = Array.isArray(finalData) ? (0, _getSliced.getSliced)(finalData, dataStartIndex, dataEndIndex) : finalData;
        var finalDataKey = (_settings$dataKey = settings === null || settings === void 0 ? void 0 : settings.dataKey) !== null && _settings$dataKey !== void 0 ? _settings$dataKey : tooltipAxisDataKey;
        // BaseAxisProps does not support nameKey but it could!
        var finalNameKey = settings === null || settings === void 0 ? void 0 : settings.nameKey; // ?? tooltipAxis?.nameKey;
        var tooltipPayload;
        if (tooltipAxisDataKey && Array.isArray(sliced) && /*
     * findEntryInArray won't work for Scatter because Scatter provides an array of arrays
     * as tooltip payloads and findEntryInArray is not prepared to handle that.
     * Sad but also ScatterChart only allows 'item' tooltipEventType
     * and also this is only a problem if there are multiple Scatters and each has its own data array
     * so let's fix that some other time.
     */ !Array.isArray(sliced[0]) && /*
     * If the tooltipEventType is 'axis', we should search for the dataKey in the sliced data
     * because thanks to allowDuplicatedCategory=false, the order of elements in the array
     * no longer matches the order of elements in the original data
     * and so we need to search by the active dataKey + label rather than by index.
     *
     * The same happens if multiple graphical items are present in the chart
     * and each of them has its own data array. Those arrays get concatenated
     * and again the tooltip index no longer matches the original data.
     *
     * On the other hand the tooltipEventType 'item' should always search by index
     * because we get the index from interacting over the individual elements
     * which is always accurate, irrespective of the allowDuplicatedCategory setting.
     */ tooltipEventType === 'axis') tooltipPayload = (0, _dataUtils.findEntryInArray)(sliced, tooltipAxisDataKey, activeLabel);
        else /*
       * This is a problem because it assumes that the index is pointing to the displayed data
       * which it isn't because the index is pointing to the tooltip ticks array.
       * The above approach (with findEntryInArray) is the correct one, but it only works
       * if the axis dataKey is defined explicitly, and if the data is an array of objects.
       */ tooltipPayload = tooltipPayloadSearcher(sliced, activeIndex, computedData, finalNameKey);
        if (Array.isArray(tooltipPayload)) tooltipPayload.forEach((item)=>{
            var newSettings = _objectSpread(_objectSpread({}, settings), {}, {
                // @ts-expect-error we're assuming that item has name and unit properties
                name: item.name,
                // @ts-expect-error we're assuming that item has name and unit properties
                unit: item.unit,
                // color and fill are erased to keep 100% the identical behaviour to recharts 2.x - but there's nothing stopping us from returning them here. It's technically a breaking change.
                color: undefined,
                // color and fill are erased to keep 100% the identical behaviour to recharts 2.x - but there's nothing stopping us from returning them here. It's technically a breaking change.
                fill: undefined
            });
            agg.push((0, _chartUtils.getTooltipEntry)({
                tooltipEntrySettings: newSettings,
                // @ts-expect-error we're assuming that item has name and unit properties
                dataKey: item.dataKey,
                // @ts-expect-error we're assuming that item has name and unit properties
                payload: item.payload,
                // @ts-expect-error getValueByDataKey does not validate the output type
                value: (0, _chartUtils.getValueByDataKey)(item.payload, item.dataKey),
                // @ts-expect-error we're assuming that item has name and unit properties
                name: item.name
            }));
        });
        else {
            var _getValueByDataKey;
            // I am not quite sure why these two branches (Array vs Array of Arrays) have to behave differently - I imagine we should unify these. 3.x breaking change?
            agg.push((0, _chartUtils.getTooltipEntry)({
                tooltipEntrySettings: settings,
                dataKey: finalDataKey,
                payload: tooltipPayload,
                // @ts-expect-error getValueByDataKey does not validate the output type
                value: (0, _chartUtils.getValueByDataKey)(tooltipPayload, finalDataKey),
                // @ts-expect-error getValueByDataKey does not validate the output type
                name: (_getValueByDataKey = (0, _chartUtils.getValueByDataKey)(tooltipPayload, finalNameKey)) !== null && _getValueByDataKey !== void 0 ? _getValueByDataKey : settings === null || settings === void 0 ? void 0 : settings.name
            }));
        }
        return agg;
    }, init);
};

},{"../../../util/DataUtils":"lNZEj","../../../util/ChartUtils":"enJyE","../../../util/getSliced":"85Zws","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gL5ve":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useXAxis", ()=>useXAxis);
parcelHelpers.export(exports, "useYAxis", ()=>useYAxis);
parcelHelpers.export(exports, "useActiveTooltipLabel", ()=>useActiveTooltipLabel);
parcelHelpers.export(exports, "useOffset", ()=>useOffset);
parcelHelpers.export(exports, "usePlotArea", ()=>usePlotArea);
parcelHelpers.export(exports, "useActiveTooltipDataPoints", ()=>useActiveTooltipDataPoints);
parcelHelpers.export(exports, "useXAxisDomain", ()=>useXAxisDomain);
parcelHelpers.export(exports, "useYAxisDomain", ()=>useYAxisDomain);
var _cartesianAxisSlice = require("./state/cartesianAxisSlice");
var _axisSelectors = require("./state/selectors/axisSelectors");
var _hooks = require("./state/hooks");
var _panoramaContext = require("./context/PanoramaContext");
var _tooltipSelectors = require("./state/selectors/tooltipSelectors");
var _selectChartOffset = require("./state/selectors/selectChartOffset");
var _selectPlotArea = require("./state/selectors/selectPlotArea");
var useXAxis = (xAxisId)=>{
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    return (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectAxisWithScale)(state, 'xAxis', xAxisId, isPanorama));
};
var useYAxis = (yAxisId)=>{
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    return (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectAxisWithScale)(state, 'yAxis', yAxisId, isPanorama));
};
var useActiveTooltipLabel = ()=>{
    return (0, _hooks.useAppSelector)((0, _tooltipSelectors.selectActiveLabel));
};
var useOffset = ()=>{
    return (0, _hooks.useAppSelector)((0, _selectChartOffset.selectChartOffset));
};
var usePlotArea = ()=>{
    return (0, _hooks.useAppSelector)((0, _selectPlotArea.selectPlotArea));
};
var useActiveTooltipDataPoints = ()=>{
    return (0, _hooks.useAppSelector)((0, _tooltipSelectors.selectActiveTooltipDataPoints));
};
var useXAxisDomain = function useXAxisDomain() {
    var xAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _cartesianAxisSlice.defaultAxisId);
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    return (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectAxisDomain)(state, 'xAxis', xAxisId, isPanorama));
};
var useYAxisDomain = function useYAxisDomain() {
    var yAxisId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _cartesianAxisSlice.defaultAxisId);
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    return (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectAxisDomain)(state, 'yAxis', yAxisId, isPanorama));
};

},{"./state/cartesianAxisSlice":"284SY","./state/selectors/axisSelectors":"bvR8m","./state/hooks":"aEuxu","./context/PanoramaContext":"10hMm","./state/selectors/tooltipSelectors":"hydW6","./state/selectors/selectChartOffset":"gmF7x","./state/selectors/selectPlotArea":"ev8GB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"284SY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultAxisId", ()=>defaultAxisId);
parcelHelpers.export(exports, "addXAxis", ()=>addXAxis);
parcelHelpers.export(exports, "replaceXAxis", ()=>replaceXAxis);
parcelHelpers.export(exports, "removeXAxis", ()=>removeXAxis);
parcelHelpers.export(exports, "addYAxis", ()=>addYAxis);
parcelHelpers.export(exports, "replaceYAxis", ()=>replaceYAxis);
parcelHelpers.export(exports, "removeYAxis", ()=>removeYAxis);
parcelHelpers.export(exports, "addZAxis", ()=>addZAxis);
parcelHelpers.export(exports, "replaceZAxis", ()=>replaceZAxis);
parcelHelpers.export(exports, "removeZAxis", ()=>removeZAxis);
parcelHelpers.export(exports, "updateYAxisWidth", ()=>updateYAxisWidth);
parcelHelpers.export(exports, "cartesianAxisReducer", ()=>cartesianAxisReducer);
var _toolkit = require("@reduxjs/toolkit");
var _immer = require("immer");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var defaultAxisId = 0;
/**
 * Properties shared in X, Y, and Z axes
 */ /**
 * These are the external props, visible for users as they set them using our public API.
 * There is all sorts of internal computed things based on these, but they will come through selectors.
 *
 * Properties shared between X and Y axes
 */ /**
 * Z axis is special because it's never displayed. It controls the size of Scatter dots,
 * but it never displays ticks anywhere.
 */ var initialState = {
    xAxis: {},
    yAxis: {},
    zAxis: {}
};
/**
 * This is the slice where each individual Axis element pushes its own configuration.
 * Prefer to use this one instead of axisSlice.
 */ var cartesianAxisSlice = (0, _toolkit.createSlice)({
    name: 'cartesianAxis',
    initialState,
    reducers: {
        addXAxis: {
            reducer (state, action) {
                state.xAxis[action.payload.id] = (0, _immer.castDraft)(action.payload);
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        replaceXAxis: {
            reducer (state, action) {
                var { prev, next } = action.payload;
                if (state.xAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.xAxis[prev.id];
                    state.xAxis[next.id] = (0, _immer.castDraft)(next);
                }
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        removeXAxis: {
            reducer (state, action) {
                delete state.xAxis[action.payload.id];
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        addYAxis: {
            reducer (state, action) {
                state.yAxis[action.payload.id] = (0, _immer.castDraft)(action.payload);
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        replaceYAxis: {
            reducer (state, action) {
                var { prev, next } = action.payload;
                if (state.yAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.yAxis[prev.id];
                    state.yAxis[next.id] = (0, _immer.castDraft)(next);
                }
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        removeYAxis: {
            reducer (state, action) {
                delete state.yAxis[action.payload.id];
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        addZAxis: {
            reducer (state, action) {
                state.zAxis[action.payload.id] = (0, _immer.castDraft)(action.payload);
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        replaceZAxis: {
            reducer (state, action) {
                var { prev, next } = action.payload;
                if (state.zAxis[prev.id] !== undefined) {
                    if (prev.id !== next.id) delete state.zAxis[prev.id];
                    state.zAxis[next.id] = (0, _immer.castDraft)(next);
                }
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        removeZAxis: {
            reducer (state, action) {
                delete state.zAxis[action.payload.id];
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        updateYAxisWidth (state, action) {
            var { id, width } = action.payload;
            var axis = state.yAxis[id];
            if (axis) {
                var history = axis.widthHistory || [];
                // An oscillation is detected when the new width is the same as the width before the last one.
                // This is a simple A -> B -> A pattern. If the next width is B, and the difference is less than 1 pixel, we ignore it.
                if (history.length === 3 && history[0] === history[2] && width === history[1] && width !== axis.width && Math.abs(width - history[0]) <= 1) return;
                var newHistory = [
                    ...history,
                    width
                ].slice(-3);
                state.yAxis[id] = _objectSpread(_objectSpread({}, state.yAxis[id]), {}, {
                    width,
                    widthHistory: newHistory
                });
            }
        }
    }
});
var { addXAxis, replaceXAxis, removeXAxis, addYAxis, replaceYAxis, removeYAxis, addZAxis, replaceZAxis, removeZAxis, updateYAxisWidth } = cartesianAxisSlice.actions;
var cartesianAxisReducer = cartesianAxisSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","immer":"ggZ4C","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gmF7x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectChartOffset", ()=>selectChartOffset);
var _reselect = require("reselect");
var _selectChartOffsetInternal = require("./selectChartOffsetInternal");
var selectChartOffset = (0, _reselect.createSelector)([
    (0, _selectChartOffsetInternal.selectChartOffsetInternal)
], (offsetInternal)=>{
    return {
        top: offsetInternal.top,
        bottom: offsetInternal.bottom,
        left: offsetInternal.left,
        right: offsetInternal.right
    };
});

},{"reselect":"ds2su","./selectChartOffsetInternal":"caUjq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ev8GB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectPlotArea", ()=>selectPlotArea);
var _reselect = require("reselect");
var _selectChartOffset = require("./selectChartOffset");
var _containerSelectors = require("./containerSelectors");
var selectPlotArea = (0, _reselect.createSelector)([
    (0, _selectChartOffset.selectChartOffset),
    (0, _containerSelectors.selectChartWidth),
    (0, _containerSelectors.selectChartHeight)
], (offset, chartWidth, chartHeight)=>{
    if (!offset || chartWidth == null || chartHeight == null) return undefined;
    return {
        x: offset.left,
        y: offset.top,
        width: Math.max(0, chartWidth - offset.left - offset.right),
        height: Math.max(0, chartHeight - offset.top - offset.bottom)
    };
});

},{"reselect":"ds2su","./selectChartOffset":"gmF7x","./containerSelectors":"lnBke","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kJI8J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SetTooltipEntrySettings", ()=>SetTooltipEntrySettings);
var _react = require("react");
var _hooks = require("./hooks");
var _tooltipSlice = require("./tooltipSlice");
var _panoramaContext = require("../context/PanoramaContext");
function SetTooltipEntrySettings(_ref) {
    var { tooltipEntrySettings } = _ref;
    var dispatch = (0, _hooks.useAppDispatch)();
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    var prevSettingsRef = (0, _react.useRef)(null);
    (0, _react.useLayoutEffect)(()=>{
        if (isPanorama) // Panorama graphical items should never contribute to Tooltip payload.
        return;
        if (prevSettingsRef.current === null) dispatch((0, _tooltipSlice.addTooltipEntrySettings)(tooltipEntrySettings));
        else if (prevSettingsRef.current !== tooltipEntrySettings) dispatch((0, _tooltipSlice.replaceTooltipEntrySettings)({
            prev: prevSettingsRef.current,
            next: tooltipEntrySettings
        }));
        prevSettingsRef.current = tooltipEntrySettings;
    }, [
        tooltipEntrySettings,
        dispatch,
        isPanorama
    ]);
    (0, _react.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, _tooltipSlice.removeTooltipEntrySettings)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}

},{"react":"bmhQu","./hooks":"aEuxu","./tooltipSlice":"8Jqu4","../context/PanoramaContext":"10hMm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"er7iN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SetErrorBarContext", ()=>SetErrorBarContext);
parcelHelpers.export(exports, "useErrorBarContext", ()=>useErrorBarContext);
parcelHelpers.export(exports, "ReportErrorBarSettings", ()=>ReportErrorBarSettings);
var _react = require("react");
var _errorBarSlice = require("../state/errorBarSlice");
var _hooks = require("../state/hooks");
var _registerGraphicalItemId = require("./RegisterGraphicalItemId");
var _excluded = [
    "children"
];
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var initialContextState = {
    data: [],
    xAxisId: 'xAxis-0',
    yAxisId: 'yAxis-0',
    dataPointFormatter: ()=>({
            x: 0,
            y: 0,
            value: 0
        }),
    errorBarOffset: 0
};
var ErrorBarContext = /*#__PURE__*/ (0, _react.createContext)(initialContextState);
function SetErrorBarContext(props) {
    var { children } = props, rest = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ _react.createElement(ErrorBarContext.Provider, {
        value: rest
    }, children);
}
var useErrorBarContext = ()=>(0, _react.useContext)(ErrorBarContext);
function ReportErrorBarSettings(props) {
    var dispatch = (0, _hooks.useAppDispatch)();
    var graphicalItemId = (0, _registerGraphicalItemId.useGraphicalItemId)();
    var prevPropsRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (graphicalItemId == null) // ErrorBar outside a graphical item context does not do anything.
        return;
        if (prevPropsRef.current === null) dispatch((0, _errorBarSlice.addErrorBar)({
            itemId: graphicalItemId,
            errorBar: props
        }));
        else if (prevPropsRef.current !== props) dispatch((0, _errorBarSlice.replaceErrorBar)({
            itemId: graphicalItemId,
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        graphicalItemId,
        props
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current != null && graphicalItemId != null) {
                dispatch((0, _errorBarSlice.removeErrorBar)({
                    itemId: graphicalItemId,
                    errorBar: prevPropsRef.current
                }));
                prevPropsRef.current = null;
            }
        };
    }, [
        dispatch,
        graphicalItemId
    ]);
    return null;
}

},{"react":"bmhQu","../state/errorBarSlice":"jPkx5","../state/hooks":"aEuxu","./RegisterGraphicalItemId":"aCd5f","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jPkx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addErrorBar", ()=>addErrorBar);
parcelHelpers.export(exports, "replaceErrorBar", ()=>replaceErrorBar);
parcelHelpers.export(exports, "removeErrorBar", ()=>removeErrorBar);
parcelHelpers.export(exports, "errorBarReducer", ()=>errorBarReducer);
var _toolkit = require("@reduxjs/toolkit");
/**
 * ErrorBars have lot more settings but all the others are scoped to the component itself.
 * Only some of them required to be reported to the global store because XAxis and YAxis need to know
 * if the error bar is contributing to extending the axis domain.
 */ var initialState = {};
var errorBarSlice = (0, _toolkit.createSlice)({
    name: 'errorBars',
    initialState,
    reducers: {
        addErrorBar: (state, action)=>{
            var { itemId, errorBar } = action.payload;
            if (!state[itemId]) state[itemId] = [];
            state[itemId].push(errorBar);
        },
        replaceErrorBar: (state, action)=>{
            var { itemId, prev, next } = action.payload;
            if (state[itemId]) state[itemId] = state[itemId].map((e)=>e.dataKey === prev.dataKey && e.direction === prev.direction ? next : e);
        },
        removeErrorBar: (state, action)=>{
            var { itemId, errorBar } = action.payload;
            if (state[itemId]) state[itemId] = state[itemId].filter((e)=>e.dataKey !== errorBar.dataKey || e.direction !== errorBar.direction);
        }
    }
});
var { addErrorBar, replaceErrorBar, removeErrorBar } = errorBarSlice.actions;
var errorBarReducer = errorBarSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aCd5f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RegisterGraphicalItemId", ()=>RegisterGraphicalItemId);
parcelHelpers.export(exports, "useGraphicalItemId", ()=>useGraphicalItemId);
var _react = require("react");
var _useUniqueId = require("../util/useUniqueId");
var GraphicalItemIdContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var RegisterGraphicalItemId = (_ref)=>{
    var { id, type, children } = _ref;
    var resolvedId = (0, _useUniqueId.useUniqueId)("recharts-".concat(type), id);
    return /*#__PURE__*/ _react.createElement(GraphicalItemIdContext.Provider, {
        value: resolvedId
    }, children(resolvedId));
};
function useGraphicalItemId() {
    return (0, _react.useContext)(GraphicalItemIdContext);
}

},{"react":"bmhQu","../util/useUniqueId":"kGj8C","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kGj8C":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * A hook that generates a unique ID. It uses React.useId() in React 18+ for SSR safety
 * and falls back to a client-side-only unique ID generator for older versions.
 *
 * The ID will stay the same across renders, and you can optionally provide a prefix.
 *
 * @param [prefix] - An optional prefix for the generated ID.
 * @param [customId] - An optional custom ID to override the generated one.
 * @returns The unique ID.
 */ parcelHelpers.export(exports, "useUniqueId", ()=>useUniqueId) /**
 * The useUniqueId hook returns a unique ID that is either reused from external props or generated internally.
 * Either way the ID is now guaranteed to be present so no more nulls or undefined.
 */ ;
var _useId = require("./useId");
function useUniqueId(prefix, customId) {
    /*
   * We have to call this hook here even if we don't use the result because
   * rules of hooks demand that hooks are never called conditionally.
   */ var generatedId = (0, _useId.useId)();
    // If a custom ID is provided, it always takes precedence.
    if (customId) return customId;
    // Apply the prefix if one was provided.
    return prefix ? "".concat(prefix, "-").concat(generatedId) : generatedId;
}

},{"./useId":"6nnkS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6nnkS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useIdFallback", ()=>useIdFallback);
parcelHelpers.export(exports, "useId", ()=>useId);
var _react = require("react");
var _dataUtils = require("./DataUtils");
var _ref;
var useIdFallback = ()=>{
    var [id] = _react.useState(()=>(0, _dataUtils.uniqueId)('uid-'));
    return id;
};
var useId = (_ref = _react['useId'.toString()]) !== null && _ref !== void 0 ? _ref : useIdFallback;

},{"react":"bmhQu","./DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b8pcP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useNeedsClip", ()=>useNeedsClip);
parcelHelpers.export(exports, "GraphicalItemClipPath", ()=>GraphicalItemClipPath);
var _react = require("react");
var _hooks = require("../state/hooks");
var _axisSelectors = require("../state/selectors/axisSelectors");
var _hooks1 = require("../hooks");
function useNeedsClip(xAxisId, yAxisId) {
    var _xAxis$allowDataOverf, _yAxis$allowDataOverf;
    var xAxis = (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectXAxisSettings)(state, xAxisId));
    var yAxis = (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectYAxisSettings)(state, yAxisId));
    var needClipX = (_xAxis$allowDataOverf = xAxis === null || xAxis === void 0 ? void 0 : xAxis.allowDataOverflow) !== null && _xAxis$allowDataOverf !== void 0 ? _xAxis$allowDataOverf : (0, _axisSelectors.implicitXAxis).allowDataOverflow;
    var needClipY = (_yAxis$allowDataOverf = yAxis === null || yAxis === void 0 ? void 0 : yAxis.allowDataOverflow) !== null && _yAxis$allowDataOverf !== void 0 ? _yAxis$allowDataOverf : (0, _axisSelectors.implicitYAxis).allowDataOverflow;
    var needClip = needClipX || needClipY;
    return {
        needClip,
        needClipX,
        needClipY
    };
}
function GraphicalItemClipPath(_ref) {
    var { xAxisId, yAxisId, clipPathId } = _ref;
    var plotArea = (0, _hooks1.usePlotArea)();
    var { needClipX, needClipY, needClip } = useNeedsClip(xAxisId, yAxisId);
    if (!needClip || !plotArea) return null;
    var { x, y, width, height } = plotArea;
    return /*#__PURE__*/ _react.createElement("clipPath", {
        id: "clipPath-".concat(clipPathId)
    }, /*#__PURE__*/ _react.createElement("rect", {
        x: needClipX ? x : x - width / 2,
        y: needClipY ? y : y - height / 2,
        width: needClipX ? width : width * 2,
        height: needClipY ? height : height * 2
    }));
}

},{"react":"bmhQu","../state/hooks":"aEuxu","../state/selectors/axisSelectors":"bvR8m","../hooks":"gL5ve","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Dpao":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectLinePoints", ()=>selectLinePoints);
var _reselect = require("reselect");
var _line = require("../../cartesian/Line");
var _dataSelectors = require("./dataSelectors");
var _chartLayoutContext = require("../../context/chartLayoutContext");
var _axisSelectors = require("./axisSelectors");
var _chartUtils = require("../../util/ChartUtils");
var selectXAxisWithScale = (state, xAxisId, _yAxisId, isPanorama)=>(0, _axisSelectors.selectAxisWithScale)(state, 'xAxis', xAxisId, isPanorama);
var selectXAxisTicks = (state, xAxisId, _yAxisId, isPanorama)=>(0, _axisSelectors.selectTicksOfGraphicalItem)(state, 'xAxis', xAxisId, isPanorama);
var selectYAxisWithScale = (state, _xAxisId, yAxisId, isPanorama)=>(0, _axisSelectors.selectAxisWithScale)(state, 'yAxis', yAxisId, isPanorama);
var selectYAxisTicks = (state, _xAxisId, yAxisId, isPanorama)=>(0, _axisSelectors.selectTicksOfGraphicalItem)(state, 'yAxis', yAxisId, isPanorama);
var selectBandSize = (0, _reselect.createSelector)([
    (0, _chartLayoutContext.selectChartLayout),
    selectXAxisWithScale,
    selectYAxisWithScale,
    selectXAxisTicks,
    selectYAxisTicks
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks)=>{
    if ((0, _chartUtils.isCategoricalAxis)(layout, 'xAxis')) return (0, _chartUtils.getBandSizeOfAxis)(xAxis, xAxisTicks, false);
    return (0, _chartUtils.getBandSizeOfAxis)(yAxis, yAxisTicks, false);
});
var pickLineId = (_state, _xAxisId, _yAxisId, _isPanorama, id)=>id;
function isLineSettings(item) {
    return item.type === 'line';
}
/*
 * There is a race condition problem because we read some data from props and some from the state.
 * The state is updated through a dispatch and is one render behind,
 * and so we have this weird one tick render where the displayedData in one selector have the old dataKey
 * but the new dataKey in another selector.
 *
 * So here instead of reading the dataKey from the props, we always read it from the state.
 */ var selectSynchronisedLineSettings = (0, _reselect.createSelector)([
    (0, _axisSelectors.selectUnfilteredCartesianItems),
    pickLineId
], (graphicalItems, id)=>graphicalItems.filter(isLineSettings).find((x)=>x.id === id));
var selectLinePoints = (0, _reselect.createSelector)([
    (0, _chartLayoutContext.selectChartLayout),
    selectXAxisWithScale,
    selectYAxisWithScale,
    selectXAxisTicks,
    selectYAxisTicks,
    selectSynchronisedLineSettings,
    selectBandSize,
    (0, _dataSelectors.selectChartDataWithIndexesIfNotInPanoramaPosition4)
], (layout, xAxis, yAxis, xAxisTicks, yAxisTicks, lineSettings, bandSize, _ref)=>{
    var { chartData, dataStartIndex, dataEndIndex } = _ref;
    if (lineSettings == null || xAxis == null || yAxis == null || xAxisTicks == null || yAxisTicks == null || xAxisTicks.length === 0 || yAxisTicks.length === 0 || bandSize == null || layout !== 'horizontal' && layout !== 'vertical') return undefined;
    var { dataKey, data } = lineSettings;
    var displayedData;
    if (data != null && data.length > 0) displayedData = data;
    else displayedData = chartData === null || chartData === void 0 ? void 0 : chartData.slice(dataStartIndex, dataEndIndex + 1);
    if (displayedData == null) return undefined;
    return (0, _line.computeLinePoints)({
        layout,
        xAxis,
        yAxis,
        xAxisTicks,
        yAxisTicks,
        dataKey,
        bandSize,
        displayedData
    });
});

},{"reselect":"ds2su","../../cartesian/Line":"ai7ym","./dataSelectors":"j0cmw","../../context/chartLayoutContext":"jIUyy","./axisSelectors":"bvR8m","../../util/ChartUtils":"enJyE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iwmF3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SetLegendPayload", ()=>SetLegendPayload);
parcelHelpers.export(exports, "SetPolarLegendPayload", ()=>SetPolarLegendPayload);
var _react = require("react");
var _panoramaContext = require("../context/PanoramaContext");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _hooks = require("./hooks");
var _legendSlice = require("./legendSlice");
function SetLegendPayload(_ref) {
    var { legendPayload } = _ref;
    var dispatch = (0, _hooks.useAppDispatch)();
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    var prevPayloadRef = (0, _react.useRef)(null);
    (0, _react.useLayoutEffect)(()=>{
        if (isPanorama) return;
        if (prevPayloadRef.current === null) dispatch((0, _legendSlice.addLegendPayload)(legendPayload));
        else if (prevPayloadRef.current !== legendPayload) dispatch((0, _legendSlice.replaceLegendPayload)({
            prev: prevPayloadRef.current,
            next: legendPayload
        }));
        prevPayloadRef.current = legendPayload;
    }, [
        dispatch,
        isPanorama,
        legendPayload
    ]);
    (0, _react.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPayloadRef.current) {
                dispatch((0, _legendSlice.removeLegendPayload)(prevPayloadRef.current));
                prevPayloadRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
function SetPolarLegendPayload(_ref2) {
    var { legendPayload } = _ref2;
    var dispatch = (0, _hooks.useAppDispatch)();
    var layout = (0, _hooks.useAppSelector)((0, _chartLayoutContext.selectChartLayout));
    var prevPayloadRef = (0, _react.useRef)(null);
    (0, _react.useLayoutEffect)(()=>{
        if (layout !== 'centric' && layout !== 'radial') return;
        if (prevPayloadRef.current === null) dispatch((0, _legendSlice.addLegendPayload)(legendPayload));
        else if (prevPayloadRef.current !== legendPayload) dispatch((0, _legendSlice.replaceLegendPayload)({
            prev: prevPayloadRef.current,
            next: legendPayload
        }));
        prevPayloadRef.current = legendPayload;
    }, [
        dispatch,
        layout,
        legendPayload
    ]);
    (0, _react.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPayloadRef.current) {
                dispatch((0, _legendSlice.removeLegendPayload)(prevPayloadRef.current));
                prevPayloadRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}

},{"react":"bmhQu","../context/PanoramaContext":"10hMm","../context/chartLayoutContext":"jIUyy","./hooks":"aEuxu","./legendSlice":"fLI5a","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fLI5a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "setLegendSize", ()=>setLegendSize);
parcelHelpers.export(exports, "setLegendSettings", ()=>setLegendSettings);
parcelHelpers.export(exports, "addLegendPayload", ()=>addLegendPayload);
parcelHelpers.export(exports, "replaceLegendPayload", ()=>replaceLegendPayload);
parcelHelpers.export(exports, "removeLegendPayload", ()=>removeLegendPayload);
parcelHelpers.export(exports, "legendReducer", ()=>legendReducer);
var _toolkit = require("@reduxjs/toolkit");
var _immer = require("immer");
/**
 * The properties inside this state update independently of each other and quite often.
 * When selecting, never select the whole state because you are going to get
 * unnecessary re-renders. Select only the properties you need.
 *
 * This is why this state type is not exported - don't use it directly.
 */ var initialState = {
    settings: {
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'middle',
        itemSorter: 'value'
    },
    size: {
        width: 0,
        height: 0
    },
    payload: []
};
var legendSlice = (0, _toolkit.createSlice)({
    name: 'legend',
    initialState,
    reducers: {
        setLegendSize (state, action) {
            state.size.width = action.payload.width;
            state.size.height = action.payload.height;
        },
        setLegendSettings (state, action) {
            state.settings.align = action.payload.align;
            state.settings.layout = action.payload.layout;
            state.settings.verticalAlign = action.payload.verticalAlign;
            state.settings.itemSorter = action.payload.itemSorter;
        },
        addLegendPayload: {
            reducer (state, action) {
                state.payload.push((0, _immer.castDraft)(action.payload));
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        replaceLegendPayload: {
            reducer (state, action) {
                var { prev, next } = action.payload;
                var index = (0, _toolkit.current)(state).payload.indexOf((0, _immer.castDraft)(prev));
                if (index > -1) state.payload[index] = (0, _immer.castDraft)(next);
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        removeLegendPayload: {
            reducer (state, action) {
                var index = (0, _toolkit.current)(state).payload.indexOf((0, _immer.castDraft)(action.payload));
                if (index > -1) state.payload.splice(index, 1);
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        }
    }
});
var { setLegendSize, setLegendSettings, addLegendPayload, replaceLegendPayload, removeLegendPayload } = legendSlice.actions;
var legendReducer = legendSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","immer":"ggZ4C","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"feTEg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This hook returns a unique animation id for the object input.
 * If input changes (as in, reference equality is different), the animation id will change.
 * If input does not change, the animation id will not change.
 *
 * This is useful for animations. The Animate component
 * does have a `shouldReAnimate` prop but that doesn't seem to be doing what the name implies.
 * Also, we don't always want to re-animate on every render;
 * we only want to re-animate when the input changes. Not the internal state (e.g. `isAnimating`).
 *
 * @param input The object to check for changes. Uses reference equality (=== operator)
 * @param prefix Optional prefix to use for the animation id
 * @returns A unique animation id
 */ parcelHelpers.export(exports, "useAnimationId", ()=>useAnimationId);
var _react = require("react");
var _dataUtils = require("./DataUtils");
function useAnimationId(input) {
    var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'animation-';
    var animationId = (0, _react.useRef)((0, _dataUtils.uniqueId)(prefix));
    var prevProps = (0, _react.useRef)(input);
    if (prevProps.current !== input) {
        animationId.current = (0, _dataUtils.uniqueId)(prefix);
        prevProps.current = input;
    }
    return animationId.current;
}

},{"react":"bmhQu","./DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c4ajk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SetCartesianGraphicalItem", ()=>SetCartesianGraphicalItem);
parcelHelpers.export(exports, "SetPolarGraphicalItem", ()=>SetPolarGraphicalItem);
var _react = require("react");
var _hooks = require("./hooks");
var _graphicalItemsSlice = require("./graphicalItemsSlice");
var SetCartesianGraphicalItemImpl = (props)=>{
    var dispatch = (0, _hooks.useAppDispatch)();
    var prevPropsRef = (0, _react.useRef)(null);
    (0, _react.useLayoutEffect)(()=>{
        if (prevPropsRef.current === null) dispatch((0, _graphicalItemsSlice.addCartesianGraphicalItem)(props));
        else if (prevPropsRef.current !== props) dispatch((0, _graphicalItemsSlice.replaceCartesianGraphicalItem)({
            prev: prevPropsRef.current,
            next: props
        }));
        prevPropsRef.current = props;
    }, [
        dispatch,
        props
    ]);
    (0, _react.useLayoutEffect)(()=>{
        return ()=>{
            if (prevPropsRef.current) {
                dispatch((0, _graphicalItemsSlice.removeCartesianGraphicalItem)(prevPropsRef.current));
                /*
         * Here we have to reset the ref to null because in StrictMode, the effect will run twice,
         * but it will keep the same ref value from the first render.
         *
         * In browser, React will clear the ref after the first effect cleanup,
         * so that wouldn't be an issue.
         *
         * In StrictMode, however, the ref is kept,
         * and in the hook above the code checks for `prevPropsRef.current === null`
         * which would be false so it would not dispatch the `addCartesianGraphicalItem` action again.
         *
         * https://github.com/recharts/recharts/issues/6022
         */ prevPropsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
};
var SetCartesianGraphicalItem = /*#__PURE__*/ (0, _react.memo)(SetCartesianGraphicalItemImpl);
function SetPolarGraphicalItem(props) {
    var dispatch = (0, _hooks.useAppDispatch)();
    (0, _react.useLayoutEffect)(()=>{
        dispatch((0, _graphicalItemsSlice.addPolarGraphicalItem)(props));
        return ()=>{
            dispatch((0, _graphicalItemsSlice.removePolarGraphicalItem)(props));
        };
    }, [
        dispatch,
        props
    ]);
    return null;
}

},{"react":"bmhQu","./hooks":"aEuxu","./graphicalItemsSlice":"c5gq8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c5gq8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addCartesianGraphicalItem", ()=>addCartesianGraphicalItem);
parcelHelpers.export(exports, "replaceCartesianGraphicalItem", ()=>replaceCartesianGraphicalItem);
parcelHelpers.export(exports, "removeCartesianGraphicalItem", ()=>removeCartesianGraphicalItem);
parcelHelpers.export(exports, "addPolarGraphicalItem", ()=>addPolarGraphicalItem);
parcelHelpers.export(exports, "removePolarGraphicalItem", ()=>removePolarGraphicalItem);
parcelHelpers.export(exports, "graphicalItemsReducer", ()=>graphicalItemsReducer);
var _toolkit = require("@reduxjs/toolkit");
var _immer = require("immer");
/**
 * Unique ID of the graphical item.
 * This is used to identify the graphical item in the state and in the React tree.
 * This is required for every graphical item - it's either provided by the user or generated automatically.
 */ var initialState = {
    cartesianItems: [],
    polarItems: []
};
var graphicalItemsSlice = (0, _toolkit.createSlice)({
    name: 'graphicalItems',
    initialState,
    reducers: {
        addCartesianGraphicalItem: {
            reducer (state, action) {
                state.cartesianItems.push((0, _immer.castDraft)(action.payload));
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        replaceCartesianGraphicalItem: {
            reducer (state, action) {
                var { prev, next } = action.payload;
                var index = (0, _toolkit.current)(state).cartesianItems.indexOf((0, _immer.castDraft)(prev));
                if (index > -1) state.cartesianItems[index] = (0, _immer.castDraft)(next);
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        removeCartesianGraphicalItem: {
            reducer (state, action) {
                var index = (0, _toolkit.current)(state).cartesianItems.indexOf((0, _immer.castDraft)(action.payload));
                if (index > -1) state.cartesianItems.splice(index, 1);
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        addPolarGraphicalItem: {
            reducer (state, action) {
                state.polarItems.push((0, _immer.castDraft)(action.payload));
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        },
        removePolarGraphicalItem: {
            reducer (state, action) {
                var index = (0, _toolkit.current)(state).polarItems.indexOf((0, _immer.castDraft)(action.payload));
                if (index > -1) state.polarItems.splice(index, 1);
            },
            prepare: (0, _toolkit.prepareAutoBatched)()
        }
    }
});
var { addCartesianGraphicalItem, replaceCartesianGraphicalItem, removeCartesianGraphicalItem, addPolarGraphicalItem, removePolarGraphicalItem } = graphicalItemsSlice.actions;
var graphicalItemsReducer = graphicalItemsSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","immer":"ggZ4C","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"as3wV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "JavascriptAnimate", ()=>JavascriptAnimate);
var _react = require("react");
var _dataUtils = require("../util/DataUtils");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
var _configUpdate = require("./configUpdate");
var _configUpdateDefault = parcelHelpers.interopDefault(_configUpdate);
var _easing = require("./easing");
var _useAnimationManager = require("./useAnimationManager");
var _global = require("../util/Global");
var defaultJavascriptAnimateProps = {
    begin: 0,
    duration: 1000,
    easing: 'ease',
    isActive: true,
    canBegin: true,
    onAnimationEnd: ()=>{},
    onAnimationStart: ()=>{}
};
var from = {
    t: 0
};
var to = {
    t: 1
};
function JavascriptAnimate(outsideProps) {
    var props = (0, _resolveDefaultProps.resolveDefaultProps)(outsideProps, defaultJavascriptAnimateProps);
    var { isActive: isActiveProp, canBegin, duration, easing, begin, onAnimationEnd, onAnimationStart, children } = props;
    var isActive = isActiveProp === 'auto' ? !(0, _global.Global).isSsr : isActiveProp;
    var animationManager = (0, _useAnimationManager.useAnimationManager)(props.animationId, props.animationManager);
    var [style, setStyle] = (0, _react.useState)(isActive ? from : to);
    var stopJSAnimation = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (!isActive) setStyle(to);
    }, [
        isActive
    ]);
    (0, _react.useEffect)(()=>{
        if (!isActive || !canBegin) return 0, _dataUtils.noop;
        var startAnimation = (0, _configUpdateDefault.default)(from, to, (0, _easing.configEasing)(easing), duration, setStyle, animationManager.getTimeoutController());
        var onAnimationActive = ()=>{
            stopJSAnimation.current = startAnimation();
        };
        animationManager.start([
            onAnimationStart,
            begin,
            onAnimationActive,
            duration,
            onAnimationEnd
        ]);
        return ()=>{
            animationManager.stop();
            if (stopJSAnimation.current) stopJSAnimation.current();
            onAnimationEnd();
        };
    }, [
        isActive,
        canBegin,
        duration,
        easing,
        begin,
        onAnimationStart,
        onAnimationEnd,
        animationManager
    ]);
    return children(style.t);
}

},{"react":"bmhQu","../util/DataUtils":"lNZEj","../util/resolveDefaultProps":"cWUqx","./configUpdate":"4y3cl","./easing":"gUuz8","./useAnimationManager":"kIaDp","../util/Global":"7wpBp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4y3cl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "alpha", ()=>alpha);
var _util = require("./util");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var alpha = (begin, end, k)=>begin + (end - begin) * k;
var needContinue = (_ref)=>{
    var { from, to } = _ref;
    return from !== to;
};
/*
 * @description: cal new from value and velocity in each stepper
 * @return: { [styleProperty]: { from, to, velocity } }
 */ var calStepperVals = (easing, preVals, steps)=>{
    var nextStepVals = (0, _util.mapObject)((key, val)=>{
        if (needContinue(val)) {
            var [newX, newV] = easing(val.from, val.to, val.velocity);
            return _objectSpread(_objectSpread({}, val), {}, {
                from: newX,
                velocity: newV
            });
        }
        return val;
    }, preVals);
    if (steps < 1) return (0, _util.mapObject)((key, val)=>{
        if (needContinue(val) && nextStepVals[key] != null) return _objectSpread(_objectSpread({}, val), {}, {
            velocity: alpha(val.velocity, nextStepVals[key].velocity, steps),
            from: alpha(val.from, nextStepVals[key].from, steps)
        });
        return val;
    }, preVals);
    return calStepperVals(easing, nextStepVals, steps - 1);
};
function createStepperUpdate(from, to, easing, interKeys, render, timeoutController) {
    var preTime;
    var stepperStyle = interKeys.reduce((res, key)=>_objectSpread(_objectSpread({}, res), {}, {
            [key]: {
                from: from[key],
                velocity: 0,
                to: to[key]
            }
        }), {});
    var getCurrStyle = ()=>(0, _util.mapObject)((key, val)=>val.from, stepperStyle);
    var shouldStopAnimation = ()=>!Object.values(stepperStyle).filter(needContinue).length;
    var stopAnimation = null;
    var stepperUpdate = (now)=>{
        if (!preTime) preTime = now;
        var deltaTime = now - preTime;
        var steps = deltaTime / easing.dt;
        stepperStyle = calStepperVals(easing, stepperStyle, steps);
        // get union set and add compatible prefix
        render(_objectSpread(_objectSpread(_objectSpread({}, from), to), getCurrStyle()));
        preTime = now;
        if (!shouldStopAnimation()) stopAnimation = timeoutController.setTimeout(stepperUpdate);
    };
    // return start animation method
    return ()=>{
        stopAnimation = timeoutController.setTimeout(stepperUpdate);
        // return stop animation method
        return ()=>{
            var _stopAnimation;
            (_stopAnimation = stopAnimation) === null || _stopAnimation === void 0 || _stopAnimation();
        };
    };
}
function createTimingUpdate(from, to, easing, duration, interKeys, render, timeoutController) {
    var stopAnimation = null;
    var timingStyle = interKeys.reduce((res, key)=>{
        var fromElement = from[key];
        var toElement = to[key];
        if (fromElement == null || toElement == null) return res;
        return _objectSpread(_objectSpread({}, res), {}, {
            [key]: [
                fromElement,
                toElement
            ]
        });
    }, {});
    var beginTime;
    var timingUpdate = (now)=>{
        if (!beginTime) beginTime = now;
        var t = (now - beginTime) / duration;
        var currStyle = (0, _util.mapObject)((key, val)=>alpha(...val, easing(t)), timingStyle);
        // get union set and add compatible prefix
        render(_objectSpread(_objectSpread(_objectSpread({}, from), to), currStyle));
        if (t < 1) stopAnimation = timeoutController.setTimeout(timingUpdate);
        else {
            var finalStyle = (0, _util.mapObject)((key, val)=>alpha(...val, easing(1)), timingStyle);
            render(_objectSpread(_objectSpread(_objectSpread({}, from), to), finalStyle));
        }
    };
    // return start animation method
    return ()=>{
        stopAnimation = timeoutController.setTimeout(timingUpdate);
        // return stop animation method
        return ()=>{
            var _stopAnimation2;
            (_stopAnimation2 = stopAnimation) === null || _stopAnimation2 === void 0 || _stopAnimation2();
        };
    };
}
// configure update function
// eslint-disable-next-line import/no-default-export
exports.default = (from, to, easing, duration, render, timeoutController)=>{
    var interKeys = (0, _util.getIntersectionKeys)(from, to);
    if (easing == null) // no animation, just set to final state
    return ()=>{
        render(_objectSpread(_objectSpread({}, from), to));
        return ()=>{};
    };
    return easing.isStepper === true ? createStepperUpdate(from, to, easing, interKeys, render, timeoutController) : createTimingUpdate(from, to, easing, duration, interKeys, render, timeoutController);
};

},{"./util":"lDasc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lDasc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getDashCase", ()=>getDashCase);
parcelHelpers.export(exports, "getTransitionVal", ()=>getTransitionVal);
parcelHelpers.export(exports, "getIntersectionKeys", ()=>getIntersectionKeys);
parcelHelpers.export(exports, "mapObject", ()=>mapObject);
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getDashCase = (name)=>name.replace(/([A-Z])/g, (v)=>"-".concat(v.toLowerCase()));
var getTransitionVal = (props, duration, easing)=>props.map((prop)=>"".concat(getDashCase(prop), " ").concat(duration, "ms ").concat(easing)).join(',');
var getIntersectionKeys = (preObj, nextObj)=>[
        Object.keys(preObj),
        Object.keys(nextObj)
    ].reduce((a, b)=>a.filter((c)=>b.includes(c)));
var mapObject = (fn, obj)=>Object.keys(obj).reduce((res, key)=>_objectSpread(_objectSpread({}, res), {}, {
            [key]: fn(key, obj[key])
        }), {});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gUuz8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ACCURACY", ()=>ACCURACY);
parcelHelpers.export(exports, "configBezier", ()=>configBezier);
parcelHelpers.export(exports, "configSpring", ()=>configSpring);
parcelHelpers.export(exports, "configEasing", ()=>configEasing);
var ACCURACY = 1e-4;
var cubicBezierFactor = (c1, c2)=>[
        0,
        3 * c1,
        3 * c2 - 6 * c1,
        3 * c1 - 3 * c2 + 1
    ];
var evaluatePolynomial = (params, t)=>params.map((param, i)=>param * t ** i).reduce((pre, curr)=>pre + curr);
var cubicBezier = (c1, c2)=>(t)=>{
        var params = cubicBezierFactor(c1, c2);
        return evaluatePolynomial(params, t);
    };
var derivativeCubicBezier = (c1, c2)=>(t)=>{
        var params = cubicBezierFactor(c1, c2);
        var newParams = [
            ...params.map((param, i)=>param * i).slice(1),
            0
        ];
        return evaluatePolynomial(newParams, t);
    };
var parseCubicBezier = (easing)=>{
    var _easingParts$;
    var easingParts = easing.split('(');
    if (easingParts.length !== 2 || easingParts[0] !== 'cubic-bezier') return null;
    var numbers = (_easingParts$ = easingParts[1]) === null || _easingParts$ === void 0 || (_easingParts$ = _easingParts$.split(')')[0]) === null || _easingParts$ === void 0 ? void 0 : _easingParts$.split(',');
    if (numbers == null || numbers.length !== 4) return null;
    var coords = numbers.map((x)=>parseFloat(x));
    return [
        coords[0],
        coords[1],
        coords[2],
        coords[3]
    ];
};
var getBezierCoordinates = function getBezierCoordinates() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if (args.length === 1) switch(args[0]){
        case 'linear':
            return [
                0.0,
                0.0,
                1.0,
                1.0
            ];
        case 'ease':
            return [
                0.25,
                0.1,
                0.25,
                1.0
            ];
        case 'ease-in':
            return [
                0.42,
                0.0,
                1.0,
                1.0
            ];
        case 'ease-out':
            return [
                0.42,
                0.0,
                0.58,
                1.0
            ];
        case 'ease-in-out':
            return [
                0.0,
                0.0,
                0.58,
                1.0
            ];
        default:
            var easing = parseCubicBezier(args[0]);
            if (easing) return easing;
    }
    if (args.length === 4) return args;
    // Fallback for invalid inputs. The previous implementation was buggy and would lead to NaN.
    // Returning linear easing is a safe default.
    return [
        0.0,
        0.0,
        1.0,
        1.0
    ];
};
var createBezierEasing = (x1, y1, x2, y2)=>{
    var curveX = cubicBezier(x1, x2);
    var curveY = cubicBezier(y1, y2);
    var derCurveX = derivativeCubicBezier(x1, x2);
    var rangeValue = (value)=>{
        if (value > 1) return 1;
        if (value < 0) return 0;
        return value;
    };
    var bezier = (_t)=>{
        var t = _t > 1 ? 1 : _t;
        var x = t;
        for(var i = 0; i < 8; ++i){
            var evalT = curveX(x) - t;
            var derVal = derCurveX(x);
            if (Math.abs(evalT - t) < ACCURACY || derVal < ACCURACY) return curveY(x);
            x = rangeValue(x - evalT / derVal);
        }
        return curveY(x);
    };
    bezier.isStepper = false;
    return bezier;
};
var configBezier = function configBezier() {
    return createBezierEasing(...getBezierCoordinates(...arguments));
};
var configSpring = function configSpring() {
    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var { stiff = 100, damping = 8, dt = 17 } = config;
    var stepper = (currX, destX, currV)=>{
        var FSpring = -(currX - destX) * stiff;
        var FDamping = currV * damping;
        var newV = currV + (FSpring - FDamping) * dt / 1000;
        var newX = currV * dt / 1000 + currX;
        if (Math.abs(newX - destX) < ACCURACY && Math.abs(newV) < ACCURACY) return [
            destX,
            0
        ];
        return [
            newX,
            newV
        ];
    };
    stepper.isStepper = true;
    stepper.dt = dt;
    return stepper;
};
var configEasing = (easing)=>{
    if (typeof easing === 'string') switch(easing){
        case 'ease':
        case 'ease-in-out':
        case 'ease-out':
        case 'ease-in':
        case 'linear':
            return configBezier(easing);
        case 'spring':
            return configSpring();
        default:
            if (easing.split('(')[0] === 'cubic-bezier') return configBezier(easing);
    }
    if (typeof easing === 'function') return easing;
    return null;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kIaDp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AnimationManagerContext", ()=>AnimationManagerContext);
parcelHelpers.export(exports, "useAnimationManager", ()=>useAnimationManager);
var _react = require("react");
var _createDefaultAnimationManager = require("./createDefaultAnimationManager");
var AnimationManagerContext = /*#__PURE__*/ (0, _react.createContext)((0, _createDefaultAnimationManager.createDefaultAnimationManager));
function useAnimationManager(animationId, animationManagerFromProps) {
    var contextAnimationManager = (0, _react.useContext)(AnimationManagerContext);
    return (0, _react.useMemo)(()=>animationManagerFromProps !== null && animationManagerFromProps !== void 0 ? animationManagerFromProps : contextAnimationManager(animationId), [
        animationId,
        animationManagerFromProps,
        contextAnimationManager
    ]);
}

},{"react":"bmhQu","./createDefaultAnimationManager":"7KTSK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7KTSK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createDefaultAnimationManager", ()=>createDefaultAnimationManager);
var _animationManager = require("./AnimationManager");
var _timeoutController = require("./timeoutController");
function createDefaultAnimationManager() {
    return (0, _animationManager.createAnimateManager)(new (0, _timeoutController.RequestAnimationFrameTimeoutController)());
}

},{"./AnimationManager":"iB53i","./timeoutController":"e8fQC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iB53i":[function(require,module,exports,__globalThis) {
/**
 * Represents a single item in the ReactSmoothQueue.
 * The item can be:
 * - A number representing a delay in milliseconds.
 * - An object representing a style change
 * - A StartAnimationFunction that starts eased transition and calls different render
 *      because of course in Recharts we have to have three ways to do everything
 * - An arbitrary function to be executed
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createAnimateManager", ()=>createAnimateManager);
function createAnimateManager(timeoutController) {
    var currStyle;
    var handleChange = ()=>null;
    var shouldStop = false;
    var cancelTimeout = null;
    var setStyle = (_style)=>{
        if (shouldStop) return;
        if (Array.isArray(_style)) {
            if (!_style.length) return;
            var styles = _style;
            var [curr, ...restStyles] = styles;
            if (typeof curr === 'number') {
                cancelTimeout = timeoutController.setTimeout(setStyle.bind(null, restStyles), curr);
                return;
            }
            setStyle(curr);
            cancelTimeout = timeoutController.setTimeout(setStyle.bind(null, restStyles));
            return;
        }
        if (typeof _style === 'string') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'object') {
            currStyle = _style;
            handleChange(currStyle);
        }
        if (typeof _style === 'function') _style();
    };
    return {
        stop: ()=>{
            shouldStop = true;
        },
        start: (style)=>{
            shouldStop = false;
            if (cancelTimeout) {
                cancelTimeout();
                cancelTimeout = null;
            }
            setStyle(style);
        },
        subscribe: (_handleChange)=>{
            handleChange = _handleChange;
            return ()=>{
                handleChange = ()=>null;
            };
        },
        getTimeoutController: ()=>timeoutController
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e8fQC":[function(require,module,exports,__globalThis) {
/**
 * Callback type for the timeout function.
 * Receives current time in milliseconds as an argument.
 */ /**
 * A function that, when called, cancels the timeout.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RequestAnimationFrameTimeoutController", ()=>RequestAnimationFrameTimeoutController);
class RequestAnimationFrameTimeoutController {
    setTimeout(callback) {
        var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
        var startTime = performance.now();
        var requestId = null;
        var executeCallback = (now)=>{
            if (now - startTime >= delay) callback(now);
            else if (typeof requestAnimationFrame === 'function') requestId = requestAnimationFrame(executeCallback);
        };
        requestId = requestAnimationFrame(executeCallback);
        return ()=>{
            if (requestId != null) cancelAnimationFrame(requestId);
        };
    }
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4bXjy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRadiusAndStrokeWidthFromDot", ()=>getRadiusAndStrokeWidthFromDot);
var _svgPropertiesNoEvents = require("./svgPropertiesNoEvents");
function getRadiusAndStrokeWidthFromDot(dot) {
    var props = (0, _svgPropertiesNoEvents.svgPropertiesNoEventsFromUnknown)(dot);
    var defaultR = 3;
    var defaultStrokeWidth = 2;
    if (props != null) {
        var { r, strokeWidth } = props;
        var realR = Number(r);
        var realStrokeWidth = Number(strokeWidth);
        if (Number.isNaN(realR) || realR < 0) realR = defaultR;
        if (Number.isNaN(realStrokeWidth) || realStrokeWidth < 0) realStrokeWidth = defaultStrokeWidth;
        return {
            r: realR,
            strokeWidth: realStrokeWidth
        };
    }
    return {
        r: defaultR,
        strokeWidth: defaultStrokeWidth
    };
}

},{"./svgPropertiesNoEvents":"2NZlZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2zGHp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPropsFromShapeOption", ()=>getPropsFromShapeOption);
parcelHelpers.export(exports, "Shape", ()=>Shape);
var _react = require("react");
var _isPlainObject = require("es-toolkit/compat/isPlainObject");
var _isPlainObjectDefault = parcelHelpers.interopDefault(_isPlainObject);
var _rectangle = require("../shape/Rectangle");
var _trapezoid = require("../shape/Trapezoid");
var _sector = require("../shape/Sector");
var _layer = require("../container/Layer");
var _symbols = require("../shape/Symbols");
var _curve = require("../shape/Curve");
var _excluded = [
    "option",
    "shapeType",
    "activeClassName"
];
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * This is an abstraction for rendering a user defined prop for a customized shape in several forms.
 *
 * <Shape /> is the root and will handle taking in:
 *  - an object of svg properties
 *  - a boolean
 *  - a render prop(inline function that returns jsx)
 *  - a React element
 *
 * <ShapeSelector /> is a subcomponent of <Shape /> and used to match a component
 * to the value of props.shapeType that is passed to the root.
 *
 */ function defaultPropTransformer(option, props) {
    return _objectSpread(_objectSpread({}, props), option);
}
function isSymbolsProps(shapeType, _elementProps) {
    return shapeType === 'symbols';
}
function ShapeSelector(_ref) {
    var { shapeType, elementProps } = _ref;
    switch(shapeType){
        case 'rectangle':
            return /*#__PURE__*/ _react.createElement((0, _rectangle.Rectangle), elementProps);
        case 'trapezoid':
            return /*#__PURE__*/ _react.createElement((0, _trapezoid.Trapezoid), elementProps);
        case 'sector':
            return /*#__PURE__*/ _react.createElement((0, _sector.Sector), elementProps);
        case 'symbols':
            if (isSymbolsProps(shapeType, elementProps)) return /*#__PURE__*/ _react.createElement((0, _symbols.Symbols), elementProps);
            break;
        case 'curve':
            return /*#__PURE__*/ _react.createElement((0, _curve.Curve), elementProps);
        default:
            return null;
    }
}
function getPropsFromShapeOption(option) {
    if (/*#__PURE__*/ (0, _react.isValidElement)(option)) return option.props;
    return option;
}
function Shape(_ref2) {
    var { option, shapeType, activeClassName = 'recharts-active-shape' } = _ref2, props = _objectWithoutProperties(_ref2, _excluded);
    var shape;
    if (/*#__PURE__*/ (0, _react.isValidElement)(option)) // @ts-expect-error we can't know the type of cloned element props
    shape = /*#__PURE__*/ (0, _react.cloneElement)(option, _objectSpread(_objectSpread({}, props), getPropsFromShapeOption(option)));
    else if (typeof option === 'function') shape = option(props, props.index);
    else if ((0, _isPlainObjectDefault.default)(option) && typeof option !== 'boolean') {
        var nextProps = defaultPropTransformer(option, props);
        shape = /*#__PURE__*/ _react.createElement(ShapeSelector, {
            shapeType: shapeType,
            elementProps: nextProps
        });
    } else {
        var elementProps = props;
        shape = /*#__PURE__*/ _react.createElement(ShapeSelector, {
            shapeType: shapeType,
            elementProps: elementProps
        });
    }
    if (props.isActive) return /*#__PURE__*/ _react.createElement((0, _layer.Layer), {
        className: activeClassName
    }, shape);
    return shape;
}

},{"react":"bmhQu","es-toolkit/compat/isPlainObject":"78gKD","../shape/Rectangle":"juFRO","../shape/Trapezoid":"kIZHv","../shape/Sector":"kLwSx","../container/Layer":"ctc59","../shape/Symbols":"8Ihmm","../shape/Curve":"edkNn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"78gKD":[function(require,module,exports,__globalThis) {
module.exports = require("be40e5b7c3196dc7").isPlainObject;

},{"be40e5b7c3196dc7":"kj4YR"}],"kj4YR":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isPlainObject(object) {
    if (typeof object !== 'object') return false;
    if (object == null) return false;
    if (Object.getPrototypeOf(object) === null) return true;
    if (Object.prototype.toString.call(object) !== '[object Object]') {
        const tag = object[Symbol.toStringTag];
        if (tag == null) return false;
        const isTagReadonly = !Object.getOwnPropertyDescriptor(object, Symbol.toStringTag)?.writable;
        if (isTagReadonly) return false;
        return object.toString() === `[object ${tag}]`;
    }
    let proto = object;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(object) === proto;
}
exports.isPlainObject = isPlainObject;

},{}],"juFRO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultRectangleProps", ()=>defaultRectangleProps);
parcelHelpers.export(exports, "Rectangle", ()=>Rectangle);
/**
 * @fileOverview Rectangle
 */ var _react = require("react");
var _clsx = require("clsx");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
var _javascriptAnimate = require("../animation/JavascriptAnimate");
var _dataUtils = require("../util/DataUtils");
var _useAnimationId = require("../util/useAnimationId");
var _util = require("../animation/util");
var _svgPropertiesAndEvents = require("../util/svgPropertiesAndEvents");
var _round = require("../util/round");
var _excluded = [
    "radius"
], _excluded2 = [
    "radius"
];
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0;
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
/**
 * @inline
 */ var getRectanglePath = (x, y, width, height, radius)=>{
    var roundedWidth = (0, _round.round)(width);
    var roundedHeight = (0, _round.round)(height);
    var maxRadius = Math.min(Math.abs(roundedWidth) / 2, Math.abs(roundedHeight) / 2);
    var ySign = roundedHeight >= 0 ? 1 : -1;
    var xSign = roundedWidth >= 0 ? 1 : -1;
    var clockWise = roundedHeight >= 0 && roundedWidth >= 0 || roundedHeight < 0 && roundedWidth < 0 ? 1 : 0;
    var path;
    if (maxRadius > 0 && radius instanceof Array) {
        var newRadius = [
            0,
            0,
            0,
            0
        ];
        for(var i = 0, len = 4; i < len; i++)newRadius[i] = radius[i] > maxRadius ? maxRadius : radius[i];
        path = (0, _round.roundTemplateLiteral)(_templateObject || (_templateObject = _taggedTemplateLiteral([
            "M",
            ",",
            ""
        ])), x, y + ySign * newRadius[0]);
        if (newRadius[0] > 0) path += (0, _round.roundTemplateLiteral)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",",
            ",",
            ""
        ])), newRadius[0], newRadius[0], clockWise, x + xSign * newRadius[0], y);
        path += (0, _round.roundTemplateLiteral)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + width - xSign * newRadius[1], y);
        if (newRadius[1] > 0) path += (0, _round.roundTemplateLiteral)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[1], newRadius[1], clockWise, x + width, y + ySign * newRadius[1]);
        path += (0, _round.roundTemplateLiteral)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + width, y + height - ySign * newRadius[2]);
        if (newRadius[2] > 0) path += (0, _round.roundTemplateLiteral)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[2], newRadius[2], clockWise, x + width - xSign * newRadius[2], y + height);
        path += (0, _round.roundTemplateLiteral)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral([
            "L ",
            ",",
            ""
        ])), x + xSign * newRadius[3], y + height);
        if (newRadius[3] > 0) path += (0, _round.roundTemplateLiteral)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral([
            "A ",
            ",",
            ",0,0,",
            ",\n        ",
            ",",
            ""
        ])), newRadius[3], newRadius[3], clockWise, x, y + height - ySign * newRadius[3]);
        path += 'Z';
    } else if (maxRadius > 0 && radius === +radius && radius > 0) {
        var _newRadius = Math.min(maxRadius, radius);
        path = (0, _round.roundTemplateLiteral)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral([
            "M ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n            L ",
            ",",
            "\n            A ",
            ",",
            ",0,0,",
            ",",
            ",",
            " Z"
        ])), x, y + ySign * _newRadius, _newRadius, _newRadius, clockWise, x + xSign * _newRadius, y, x + width - xSign * _newRadius, y, _newRadius, _newRadius, clockWise, x + width, y + ySign * _newRadius, x + width, y + height - ySign * _newRadius, _newRadius, _newRadius, clockWise, x + width - xSign * _newRadius, y + height, x + xSign * _newRadius, y + height, _newRadius, _newRadius, clockWise, x, y + height - ySign * _newRadius);
    } else path = (0, _round.roundTemplateLiteral)(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral([
        "M ",
        ",",
        " h ",
        " v ",
        " h ",
        " Z"
    ])), x, y, width, height, -width);
    return path;
};
var defaultRectangleProps = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    // The radius of border
    // The radius of four corners when radius is a number
    // The radius of left-top, right-top, right-bottom, left-bottom when radius is an array
    radius: 0,
    isAnimationActive: false,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var Rectangle = (rectangleProps)=>{
    var props = (0, _resolveDefaultProps.resolveDefaultProps)(rectangleProps, defaultRectangleProps);
    var pathRef = (0, _react.useRef)(null);
    var [totalLength, setTotalLength] = (0, _react.useState)(-1);
    (0, _react.useEffect)(()=>{
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (_unused) {
        // calculate total length error
        }
    }, []);
    var { x, y, width, height, radius, className } = props;
    var { animationEasing, animationDuration, animationBegin, isAnimationActive, isUpdateAnimationActive } = props;
    var prevWidthRef = (0, _react.useRef)(width);
    var prevHeightRef = (0, _react.useRef)(height);
    var prevXRef = (0, _react.useRef)(x);
    var prevYRef = (0, _react.useRef)(y);
    var animationIdInput = (0, _react.useMemo)(()=>({
            x,
            y,
            width,
            height,
            radius
        }), [
        x,
        y,
        width,
        height,
        radius
    ]);
    var animationId = (0, _useAnimationId.useAnimationId)(animationIdInput, 'rectangle-');
    if (x !== +x || y !== +y || width !== +width || height !== +height || width === 0 || height === 0) return null;
    var layerClass = (0, _clsx.clsx)('recharts-rectangle', className);
    if (!isUpdateAnimationActive) {
        var _svgPropertiesAndEven = (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(props), { radius: _ } = _svgPropertiesAndEven, otherPathProps = _objectWithoutProperties(_svgPropertiesAndEven, _excluded);
        return /*#__PURE__*/ _react.createElement("path", _extends({}, otherPathProps, {
            x: (0, _round.round)(x),
            y: (0, _round.round)(y),
            width: (0, _round.round)(width),
            height: (0, _round.round)(height),
            radius: typeof radius === 'number' ? radius : undefined,
            className: layerClass,
            d: getRectanglePath(x, y, width, height, radius)
        }));
    }
    var prevWidth = prevWidthRef.current;
    var prevHeight = prevHeightRef.current;
    var prevX = prevXRef.current;
    var prevY = prevYRef.current;
    var from = "0px ".concat(totalLength === -1 ? 1 : totalLength, "px");
    var to = "".concat(totalLength, "px 0px");
    var transition = (0, _util.getTransitionVal)([
        'strokeDasharray'
    ], animationDuration, typeof animationEasing === 'string' ? animationEasing : defaultRectangleProps.animationEasing);
    return /*#__PURE__*/ _react.createElement((0, _javascriptAnimate.JavascriptAnimate), {
        animationId: animationId,
        key: animationId,
        canBegin: totalLength > 0,
        duration: animationDuration,
        easing: animationEasing,
        isActive: isUpdateAnimationActive,
        begin: animationBegin
    }, (t)=>{
        var currWidth = (0, _dataUtils.interpolate)(prevWidth, width, t);
        var currHeight = (0, _dataUtils.interpolate)(prevHeight, height, t);
        var currX = (0, _dataUtils.interpolate)(prevX, x, t);
        var currY = (0, _dataUtils.interpolate)(prevY, y, t);
        if (pathRef.current) {
            prevWidthRef.current = currWidth;
            prevHeightRef.current = currHeight;
            prevXRef.current = currX;
            prevYRef.current = currY;
        }
        var animationStyle;
        if (!isAnimationActive) animationStyle = {
            strokeDasharray: to
        };
        else if (t > 0) animationStyle = {
            transition,
            strokeDasharray: to
        };
        else animationStyle = {
            strokeDasharray: from
        };
        var _svgPropertiesAndEven2 = (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(props), { radius: _ } = _svgPropertiesAndEven2, otherPathProps = _objectWithoutProperties(_svgPropertiesAndEven2, _excluded2);
        return /*#__PURE__*/ _react.createElement("path", _extends({}, otherPathProps, {
            radius: typeof radius === 'number' ? radius : undefined,
            className: layerClass,
            d: getRectanglePath(currX, currY, currWidth, currHeight, radius),
            ref: pathRef,
            style: _objectSpread(_objectSpread({}, animationStyle), props.style)
        }));
    });
};

},{"react":"bmhQu","clsx":"431Ou","../util/resolveDefaultProps":"cWUqx","../animation/JavascriptAnimate":"as3wV","../util/DataUtils":"lNZEj","../util/useAnimationId":"feTEg","../animation/util":"lDasc","../util/svgPropertiesAndEvents":"6bogn","../util/round":"aY5HH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kIZHv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTrapezoidProps", ()=>defaultTrapezoidProps);
parcelHelpers.export(exports, "Trapezoid", ()=>Trapezoid);
/**
 * @fileOverview Rectangle
 */ var _react = require("react");
var _clsx = require("clsx");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
var _javascriptAnimate = require("../animation/JavascriptAnimate");
var _useAnimationId = require("../util/useAnimationId");
var _dataUtils = require("../util/DataUtils");
var _util = require("../animation/util");
var _svgPropertiesAndEvents = require("../util/svgPropertiesAndEvents");
var _round = require("../util/round");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var getTrapezoidPath = (x, y, upperWidth, lowerWidth, height)=>{
    var widthGap = upperWidth - lowerWidth;
    var path;
    path = (0, _round.roundTemplateLiteral)(_templateObject || (_templateObject = _taggedTemplateLiteral([
        "M ",
        ",",
        ""
    ])), x, y);
    path += (0, _round.roundTemplateLiteral)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
        "L ",
        ",",
        ""
    ])), x + upperWidth, y);
    path += (0, _round.roundTemplateLiteral)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([
        "L ",
        ",",
        ""
    ])), x + upperWidth - widthGap / 2, y + height);
    path += (0, _round.roundTemplateLiteral)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([
        "L ",
        ",",
        ""
    ])), x + upperWidth - widthGap / 2 - lowerWidth, y + height);
    path += (0, _round.roundTemplateLiteral)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([
        "L ",
        ",",
        " Z"
    ])), x, y);
    return path;
};
var defaultTrapezoidProps = {
    x: 0,
    y: 0,
    upperWidth: 0,
    lowerWidth: 0,
    height: 0,
    isUpdateAnimationActive: false,
    animationBegin: 0,
    animationDuration: 1500,
    animationEasing: 'ease'
};
var Trapezoid = (outsideProps)=>{
    var trapezoidProps = (0, _resolveDefaultProps.resolveDefaultProps)(outsideProps, defaultTrapezoidProps);
    var { x, y, upperWidth, lowerWidth, height, className } = trapezoidProps;
    var { animationEasing, animationDuration, animationBegin, isUpdateAnimationActive } = trapezoidProps;
    var pathRef = (0, _react.useRef)(null);
    var [totalLength, setTotalLength] = (0, _react.useState)(-1);
    var prevUpperWidthRef = (0, _react.useRef)(upperWidth);
    var prevLowerWidthRef = (0, _react.useRef)(lowerWidth);
    var prevHeightRef = (0, _react.useRef)(height);
    var prevXRef = (0, _react.useRef)(x);
    var prevYRef = (0, _react.useRef)(y);
    var animationId = (0, _useAnimationId.useAnimationId)(outsideProps, 'trapezoid-');
    (0, _react.useEffect)(()=>{
        if (pathRef.current && pathRef.current.getTotalLength) try {
            var pathTotalLength = pathRef.current.getTotalLength();
            if (pathTotalLength) setTotalLength(pathTotalLength);
        } catch (_unused) {
        // calculate total length error
        }
    }, []);
    if (x !== +x || y !== +y || upperWidth !== +upperWidth || lowerWidth !== +lowerWidth || height !== +height || upperWidth === 0 && lowerWidth === 0 || height === 0) return null;
    var layerClass = (0, _clsx.clsx)('recharts-trapezoid', className);
    if (!isUpdateAnimationActive) return /*#__PURE__*/ _react.createElement("g", null, /*#__PURE__*/ _react.createElement("path", _extends({}, (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(trapezoidProps), {
        className: layerClass,
        d: getTrapezoidPath(x, y, upperWidth, lowerWidth, height)
    })));
    var prevUpperWidth = prevUpperWidthRef.current;
    var prevLowerWidth = prevLowerWidthRef.current;
    var prevHeight = prevHeightRef.current;
    var prevX = prevXRef.current;
    var prevY = prevYRef.current;
    var from = "0px ".concat(totalLength === -1 ? 1 : totalLength, "px");
    var to = "".concat(totalLength, "px 0px");
    var transition = (0, _util.getTransitionVal)([
        'strokeDasharray'
    ], animationDuration, animationEasing);
    return /*#__PURE__*/ _react.createElement((0, _javascriptAnimate.JavascriptAnimate), {
        animationId: animationId,
        key: animationId,
        canBegin: totalLength > 0,
        duration: animationDuration,
        easing: animationEasing,
        isActive: isUpdateAnimationActive,
        begin: animationBegin
    }, (t)=>{
        var currUpperWidth = (0, _dataUtils.interpolate)(prevUpperWidth, upperWidth, t);
        var currLowerWidth = (0, _dataUtils.interpolate)(prevLowerWidth, lowerWidth, t);
        var currHeight = (0, _dataUtils.interpolate)(prevHeight, height, t);
        var currX = (0, _dataUtils.interpolate)(prevX, x, t);
        var currY = (0, _dataUtils.interpolate)(prevY, y, t);
        if (pathRef.current) {
            prevUpperWidthRef.current = currUpperWidth;
            prevLowerWidthRef.current = currLowerWidth;
            prevHeightRef.current = currHeight;
            prevXRef.current = currX;
            prevYRef.current = currY;
        }
        var animationStyle = t > 0 ? {
            transition,
            strokeDasharray: to
        } : {
            strokeDasharray: from
        };
        return /*#__PURE__*/ _react.createElement("path", _extends({}, (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(trapezoidProps), {
            className: layerClass,
            d: getTrapezoidPath(currX, currY, currUpperWidth, currLowerWidth, currHeight),
            ref: pathRef,
            style: _objectSpread(_objectSpread({}, animationStyle), trapezoidProps.style)
        }));
    });
};

},{"react":"bmhQu","clsx":"431Ou","../util/resolveDefaultProps":"cWUqx","../animation/JavascriptAnimate":"as3wV","../util/useAnimationId":"feTEg","../util/DataUtils":"lNZEj","../animation/util":"lDasc","../util/svgPropertiesAndEvents":"6bogn","../util/round":"aY5HH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kLwSx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultSectorProps", ()=>defaultSectorProps);
parcelHelpers.export(exports, "Sector", ()=>Sector);
var _react = require("react");
var _clsx = require("clsx");
var _polarUtils = require("../util/PolarUtils");
var _dataUtils = require("../util/DataUtils");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
var _svgPropertiesAndEvents = require("../util/svgPropertiesAndEvents");
var _round = require("../util/round");
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var getDeltaAngle = (startAngle, endAngle)=>{
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var deltaAngle = Math.min(Math.abs(endAngle - startAngle), 359.999);
    return sign * deltaAngle;
};
var getTangentCircle = (_ref)=>{
    var { cx, cy, radius, angle, sign, isExternal, cornerRadius, cornerIsExternal } = _ref;
    var centerRadius = cornerRadius * (isExternal ? 1 : -1) + radius;
    var theta = Math.asin(cornerRadius / centerRadius) / (0, _polarUtils.RADIAN);
    var centerAngle = cornerIsExternal ? angle : angle + sign * theta;
    var center = (0, _polarUtils.polarToCartesian)(cx, cy, centerRadius, centerAngle);
    // The coordinate of point which is tangent to the circle
    var circleTangency = (0, _polarUtils.polarToCartesian)(cx, cy, radius, centerAngle);
    // The coordinate of point which is tangent to the radius line
    var lineTangencyAngle = cornerIsExternal ? angle - sign * theta : angle;
    var lineTangency = (0, _polarUtils.polarToCartesian)(cx, cy, centerRadius * Math.cos(theta * (0, _polarUtils.RADIAN)), lineTangencyAngle);
    return {
        center,
        circleTangency,
        lineTangency,
        theta
    };
};
var getSectorPath = (_ref2)=>{
    var { cx, cy, innerRadius, outerRadius, startAngle, endAngle } = _ref2;
    var angle = getDeltaAngle(startAngle, endAngle);
    // When the angle of sector equals to 360, star point and end point coincide
    var tempEndAngle = startAngle + angle;
    var outerStartPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, startAngle);
    var outerEndPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, tempEndAngle);
    var path = (0, _round.roundTemplateLiteral)(_templateObject || (_templateObject = _taggedTemplateLiteral([
        "M ",
        ",",
        "\n    A ",
        ",",
        ",0,\n    ",
        ",",
        ",\n    ",
        ",",
        "\n  "
    ])), outerStartPoint.x, outerStartPoint.y, outerRadius, outerRadius, +(Math.abs(angle) > 180), +(startAngle > tempEndAngle), outerEndPoint.x, outerEndPoint.y);
    if (innerRadius > 0) {
        var innerStartPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, startAngle);
        var innerEndPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, tempEndAngle);
        path += (0, _round.roundTemplateLiteral)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([
            "L ",
            ",",
            "\n            A ",
            ",",
            ",0,\n            ",
            ",",
            ",\n            ",
            ",",
            " Z"
        ])), innerEndPoint.x, innerEndPoint.y, innerRadius, innerRadius, +(Math.abs(angle) > 180), +(startAngle <= tempEndAngle), innerStartPoint.x, innerStartPoint.y);
    } else path += (0, _round.roundTemplateLiteral)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral([
        "L ",
        ",",
        " Z"
    ])), cx, cy);
    return path;
};
var getSectorWithCorner = (_ref3)=>{
    var { cx, cy, innerRadius, outerRadius, cornerRadius, forceCornerRadius, cornerIsExternal, startAngle, endAngle } = _ref3;
    var sign = (0, _dataUtils.mathSign)(endAngle - startAngle);
    var { circleTangency: soct, lineTangency: solt, theta: sot } = getTangentCircle({
        cx,
        cy,
        radius: outerRadius,
        angle: startAngle,
        sign,
        cornerRadius,
        cornerIsExternal
    });
    var { circleTangency: eoct, lineTangency: eolt, theta: eot } = getTangentCircle({
        cx,
        cy,
        radius: outerRadius,
        angle: endAngle,
        sign: -sign,
        cornerRadius,
        cornerIsExternal
    });
    var outerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sot - eot;
    if (outerArcAngle < 0) {
        if (forceCornerRadius) return (0, _round.roundTemplateLiteral)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([
            "M ",
            ",",
            "\n        a",
            ",",
            ",0,0,1,",
            ",0\n        a",
            ",",
            ",0,0,1,",
            ",0\n      "
        ])), solt.x, solt.y, cornerRadius, cornerRadius, cornerRadius * 2, cornerRadius, cornerRadius, -cornerRadius * 2);
        return getSectorPath({
            cx,
            cy,
            innerRadius,
            outerRadius,
            startAngle,
            endAngle
        });
    }
    var path = (0, _round.roundTemplateLiteral)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral([
        "M ",
        ",",
        "\n    A",
        ",",
        ",0,0,",
        ",",
        ",",
        "\n    A",
        ",",
        ",0,",
        ",",
        ",",
        ",",
        "\n    A",
        ",",
        ",0,0,",
        ",",
        ",",
        "\n  "
    ])), solt.x, solt.y, cornerRadius, cornerRadius, +(sign < 0), soct.x, soct.y, outerRadius, outerRadius, +(outerArcAngle > 180), +(sign < 0), eoct.x, eoct.y, cornerRadius, cornerRadius, +(sign < 0), eolt.x, eolt.y);
    if (innerRadius > 0) {
        var { circleTangency: sict, lineTangency: silt, theta: sit } = getTangentCircle({
            cx,
            cy,
            radius: innerRadius,
            angle: startAngle,
            sign,
            isExternal: true,
            cornerRadius,
            cornerIsExternal
        });
        var { circleTangency: eict, lineTangency: eilt, theta: eit } = getTangentCircle({
            cx,
            cy,
            radius: innerRadius,
            angle: endAngle,
            sign: -sign,
            isExternal: true,
            cornerRadius,
            cornerIsExternal
        });
        var innerArcAngle = cornerIsExternal ? Math.abs(startAngle - endAngle) : Math.abs(startAngle - endAngle) - sit - eit;
        if (innerArcAngle < 0 && cornerRadius === 0) return "".concat(path, "L").concat(cx, ",").concat(cy, "Z");
        path += (0, _round.roundTemplateLiteral)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral([
            "L",
            ",",
            "\n      A",
            ",",
            ",0,0,",
            ",",
            ",",
            "\n      A",
            ",",
            ",0,",
            ",",
            ",",
            ",",
            "\n      A",
            ",",
            ",0,0,",
            ",",
            ",",
            "Z"
        ])), eilt.x, eilt.y, cornerRadius, cornerRadius, +(sign < 0), eict.x, eict.y, innerRadius, innerRadius, +(innerArcAngle > 180), +(sign > 0), sict.x, sict.y, cornerRadius, cornerRadius, +(sign < 0), silt.x, silt.y);
    } else path += (0, _round.roundTemplateLiteral)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral([
        "L",
        ",",
        "Z"
    ])), cx, cy);
    return path;
};
var defaultSectorProps = {
    cx: 0,
    cy: 0,
    innerRadius: 0,
    outerRadius: 0,
    startAngle: 0,
    endAngle: 0,
    cornerRadius: 0,
    forceCornerRadius: false,
    cornerIsExternal: false
};
var Sector = (sectorProps)=>{
    var props = (0, _resolveDefaultProps.resolveDefaultProps)(sectorProps, defaultSectorProps);
    var { cx, cy, innerRadius, outerRadius, cornerRadius, forceCornerRadius, cornerIsExternal, startAngle, endAngle, className } = props;
    if (outerRadius < innerRadius || startAngle === endAngle) return null;
    var layerClass = (0, _clsx.clsx)('recharts-sector', className);
    var deltaRadius = outerRadius - innerRadius;
    var cr = (0, _dataUtils.getPercentValue)(cornerRadius, deltaRadius, 0, true);
    var path;
    if (cr > 0 && Math.abs(startAngle - endAngle) < 360) path = getSectorWithCorner({
        cx,
        cy,
        innerRadius,
        outerRadius,
        cornerRadius: Math.min(cr, deltaRadius / 2),
        forceCornerRadius,
        cornerIsExternal,
        startAngle,
        endAngle
    });
    else path = getSectorPath({
        cx,
        cy,
        innerRadius,
        outerRadius,
        startAngle,
        endAngle
    });
    return /*#__PURE__*/ _react.createElement("path", _extends({}, (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(props), {
        className: layerClass,
        d: path
    }));
};

},{"react":"bmhQu","clsx":"431Ou","../util/PolarUtils":"ezeVo","../util/DataUtils":"lNZEj","../util/resolveDefaultProps":"cWUqx","../util/svgPropertiesAndEvents":"6bogn","../util/round":"aY5HH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Ihmm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Symbols", ()=>Symbols);
var _react = require("react");
var _d3Shape = require("victory-vendor/d3-shape");
var _clsx = require("clsx");
var _dataUtils = require("../util/DataUtils");
var _svgPropertiesAndEvents = require("../util/svgPropertiesAndEvents");
var _excluded = [
    "type",
    "size",
    "sizeType"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var symbolFactories = {
    symbolCircle: (0, _d3Shape.symbolCircle),
    symbolCross: (0, _d3Shape.symbolCross),
    symbolDiamond: (0, _d3Shape.symbolDiamond),
    symbolSquare: (0, _d3Shape.symbolSquare),
    symbolStar: (0, _d3Shape.symbolStar),
    symbolTriangle: (0, _d3Shape.symbolTriangle),
    symbolWye: (0, _d3Shape.symbolWye)
};
var RADIAN = Math.PI / 180;
var getSymbolFactory = (type)=>{
    var name = "symbol".concat((0, _dataUtils.upperFirst)(type));
    return symbolFactories[name] || (0, _d3Shape.symbolCircle);
};
var calculateAreaSize = (size, sizeType, type)=>{
    if (sizeType === 'area') return size;
    switch(type){
        case 'cross':
            return 5 * size * size / 9;
        case 'diamond':
            return 0.5 * size * size / Math.sqrt(3);
        case 'square':
            return size * size;
        case 'star':
            var angle = 18 * RADIAN;
            return 1.25 * size * size * (Math.tan(angle) - Math.tan(angle * 2) * Math.tan(angle) ** 2);
        case 'triangle':
            return Math.sqrt(3) * size * size / 4;
        case 'wye':
            return (21 - 10 * Math.sqrt(3)) * size * size / 8;
        default:
            return Math.PI * size * size / 4;
    }
};
var registerSymbol = (key, factory)=>{
    symbolFactories["symbol".concat((0, _dataUtils.upperFirst)(key))] = factory;
};
var Symbols = (_ref)=>{
    var { type = 'circle', size = 64, sizeType = 'area' } = _ref, rest = _objectWithoutProperties(_ref, _excluded);
    var props = _objectSpread(_objectSpread({}, rest), {}, {
        type,
        size,
        sizeType
    });
    var realType = 'circle';
    if (typeof type === 'string') /*
     * Our type guard is not as strong as it could be (i.e. non-existent),
     * and so despite the typescript type saying that `type` is a `SymbolType`,
     * we can get numbers or really anything, so let's have a runtime check here to fix the exception.
     *
     * https://github.com/recharts/recharts/issues/6197
     */ realType = type;
    /**
   * Calculate the path of curve
   * @return {String} path
   */ var getPath = ()=>{
        var symbolFactory = getSymbolFactory(realType);
        var symbol = (0, _d3Shape.symbol)().type(symbolFactory).size(calculateAreaSize(size, sizeType, realType));
        var s = symbol();
        if (s === null) return undefined;
        return s;
    };
    var { className, cx, cy } = props;
    var filteredProps = (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(props);
    if ((0, _dataUtils.isNumber)(cx) && (0, _dataUtils.isNumber)(cy) && (0, _dataUtils.isNumber)(size)) return /*#__PURE__*/ _react.createElement("path", _extends({}, filteredProps, {
        className: (0, _clsx.clsx)('recharts-symbols', className),
        transform: "translate(".concat(cx, ", ").concat(cy, ")"),
        d: getPath()
    }));
    return null;
};
Symbols.registerSymbol = registerSymbol;

},{"react":"bmhQu","victory-vendor/d3-shape":"54uEf","clsx":"431Ou","../util/DataUtils":"lNZEj","../util/svgPropertiesAndEvents":"6bogn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"edkNn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPath", ()=>getPath);
parcelHelpers.export(exports, "Curve", ()=>Curve);
/**
 * @fileOverview Curve
 */ var _react = require("react");
var _d3Shape = require("victory-vendor/d3-shape");
var _clsx = require("clsx");
var _types = require("../util/types");
var _dataUtils = require("../util/DataUtils");
var _isWellBehavedNumber = require("../util/isWellBehavedNumber");
var _svgPropertiesNoEvents = require("../util/svgPropertiesNoEvents");
var _chartLayoutContext = require("../context/chartLayoutContext");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var CURVE_FACTORIES = {
    curveBasisClosed: (0, _d3Shape.curveBasisClosed),
    curveBasisOpen: (0, _d3Shape.curveBasisOpen),
    curveBasis: (0, _d3Shape.curveBasis),
    curveBumpX: (0, _d3Shape.curveBumpX),
    curveBumpY: (0, _d3Shape.curveBumpY),
    curveLinearClosed: (0, _d3Shape.curveLinearClosed),
    curveLinear: (0, _d3Shape.curveLinear),
    curveMonotoneX: (0, _d3Shape.curveMonotoneX),
    curveMonotoneY: (0, _d3Shape.curveMonotoneY),
    curveNatural: (0, _d3Shape.curveNatural),
    curveStep: (0, _d3Shape.curveStep),
    curveStepAfter: (0, _d3Shape.curveStepAfter),
    curveStepBefore: (0, _d3Shape.curveStepBefore)
};
/**
 * @inline
 */ var defined = (p)=>(0, _isWellBehavedNumber.isWellBehavedNumber)(p.x) && (0, _isWellBehavedNumber.isWellBehavedNumber)(p.y);
var areaDefined = (d)=>d.base != null && defined(d.base) && defined(d);
var getX = (p)=>p.x;
var getY = (p)=>p.y;
var getCurveFactory = (type, layout)=>{
    if (typeof type === 'function') return type;
    var name = "curve".concat((0, _dataUtils.upperFirst)(type));
    if ((name === 'curveMonotone' || name === 'curveBump') && layout) return CURVE_FACTORIES["".concat(name).concat(layout === 'vertical' ? 'Y' : 'X')];
    return CURVE_FACTORIES[name] || (0, _d3Shape.curveLinear);
};
var getPath = (_ref)=>{
    var { type = 'linear', points = [], baseLine, layout, connectNulls = false } = _ref;
    var curveFactory = getCurveFactory(type, layout);
    var formatPoints = connectNulls ? points.filter(defined) : points;
    var lineFunction;
    // When dealing with an area chart (where `baseLine` is an array),
    // we need to pair points with their corresponding `baseLine` points first.
    // This is to ensure that we filter points and their baseline counterparts together,
    // preventing errors from mismatched array lengths and ensuring `defined` checks both.
    if (Array.isArray(baseLine)) {
        var areaPoints = points.map((entry, index)=>_objectSpread(_objectSpread({}, entry), {}, {
                base: baseLine[index]
            }));
        if (layout === 'vertical') lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0((d)=>d.base.x);
        else lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0((d)=>d.base.y);
        /*
     * What happens here is that the `.defined()` call will make it so that this function can accept
     * nullable points, and internally it will filter them out and skip when generating the path.
     * So on the input it accepts NullableCoordinate, but it never calls getX/getY on null points because of the defined() filter.
     *
     * The d3 type definition has only one generic so it doesn't allow to describe this properly.
     * However. d3 types are mutable, but we can pretend that they are not, and we can pretend
     * that calling defined() returns a new function with a different generic type.
     */ var _nullableLineFunction = lineFunction.defined(areaDefined).curve(curveFactory);
        var finalPoints = connectNulls ? areaPoints.filter(areaDefined) : areaPoints;
        return _nullableLineFunction(finalPoints);
    }
    if (layout === 'vertical' && (0, _dataUtils.isNumber)(baseLine)) lineFunction = (0, _d3Shape.area)().y(getY).x1(getX).x0(baseLine);
    else if ((0, _dataUtils.isNumber)(baseLine)) lineFunction = (0, _d3Shape.area)().x(getX).y1(getY).y0(baseLine);
    else lineFunction = (0, _d3Shape.line)().x(getX).y(getY);
    var nullableLineFunction = lineFunction.defined(defined).curve(curveFactory);
    return nullableLineFunction(formatPoints);
};
var Curve = (props)=>{
    var { className, points, path, pathRef } = props;
    var layout = (0, _chartLayoutContext.useChartLayout)();
    if ((!points || !points.length) && !path) return null;
    var getPathInput = {
        type: props.type,
        points: props.points,
        baseLine: props.baseLine,
        layout: props.layout || layout,
        connectNulls: props.connectNulls
    };
    var realPath = points && points.length ? getPath(getPathInput) : path;
    return /*#__PURE__*/ _react.createElement("path", _extends({}, (0, _svgPropertiesNoEvents.svgPropertiesNoEvents)(props), (0, _types.adaptEventHandlers)(props), {
        className: (0, _clsx.clsx)('recharts-curve', className),
        d: realPath === null ? undefined : realPath,
        ref: pathRef
    }));
};

},{"react":"bmhQu","victory-vendor/d3-shape":"54uEf","clsx":"431Ou","../util/types":"9qdl2","../util/DataUtils":"lNZEj","../util/isWellBehavedNumber":"aIsFR","../util/svgPropertiesNoEvents":"2NZlZ","../context/chartLayoutContext":"jIUyy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eGfhC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * So usually React would compare only the first level of props using Object.is.
 * However, in our case many props are objects or arrays, and our own docs recommend to do that!
 * Therefore, we need a custom comparison function that does a shallow comparison of each prop value.
 *
 * Because charts can and do receive large props (typically the data array),
 * we only limit this to a subset of known props that are likely to be objects/arrays.
 *
 * @param prevProps
 * @param nextProps
 */ parcelHelpers.export(exports, "propsAreEqual", ()=>propsAreEqual);
var _reactRedux = require("react-redux");
var propsToShallowCompare = new Set([
    'axisLine',
    'tickLine',
    'activeBar',
    'activeDot',
    'activeLabel',
    'activeShape',
    'allowEscapeViewBox',
    'background',
    'cursor',
    'dot',
    'label',
    'line',
    'margin',
    'padding',
    'position',
    'shape',
    'style',
    'tick',
    'wrapperStyle',
    // radius can be an array of 4 numbers, easy to compare shallowly
    'radius'
]);
/**
 * When comparing two values, returns true if they are the same value or
 * are both NaN.
 *
 * If we used just a simple triple equals, we would get false negatives for two NaNs
 * which could cause extra re-renders so let's have this instead.
 *
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Guide/Equality_comparisons_and_sameness#same-value-zero_equality
 *
 * @param x first value to compare
 * @param y second value to compare
 * return true if the same, false if different
 */ function sameValueZero(x, y) {
    if (x == null && y == null) /*
     * treat null and undefined as equal. Internally in Recharts we make no difference between these two
     * so there is no need to re-render.
     */ return true;
    if (typeof x === 'number' && typeof y === 'number') // x and y are equal (this is true for -0 and 0) or they are both NaN
    // eslint-disable-next-line no-self-compare
    return x === y || x !== x && y !== y;
    return x === y;
}
function propsAreEqual(prevProps, nextProps) {
    var allKeys = new Set([
        ...Object.keys(prevProps),
        ...Object.keys(nextProps)
    ]);
    for (var key of allKeys){
        /*
     * If a key is on a special allowlist, go one level deeper
     * and do a shallow comparison of the values.
     */ if (propsToShallowCompare.has(key)) {
            if (prevProps[key] == null && nextProps[key] == null) continue;
            if (!(0, _reactRedux.shallowEqual)(prevProps[key], nextProps[key])) return false;
        /*
       * Otherwise do a simple same-value comparison (with NaN support).
       */ } else if (!sameValueZero(prevProps[key], nextProps[key])) return false;
    }
    return true;
}

},{"react-redux":"aRDHF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aRDHF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Provider", ()=>Provider_default);
parcelHelpers.export(exports, "ReactReduxContext", ()=>ReactReduxContext);
parcelHelpers.export(exports, "batch", ()=>batch);
parcelHelpers.export(exports, "connect", ()=>connect_default);
parcelHelpers.export(exports, "createDispatchHook", ()=>createDispatchHook);
parcelHelpers.export(exports, "createSelectorHook", ()=>createSelectorHook);
parcelHelpers.export(exports, "createStoreHook", ()=>createStoreHook);
parcelHelpers.export(exports, "shallowEqual", ()=>shallowEqual);
parcelHelpers.export(exports, "useDispatch", ()=>useDispatch);
parcelHelpers.export(exports, "useSelector", ()=>useSelector);
parcelHelpers.export(exports, "useStore", ()=>useStore);
// src/utils/react.ts
var _react = require("react");
// src/hooks/useSelector.ts
var _withSelectorJs = require("use-sync-external-store/with-selector.js");
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value)=>key in obj ? __defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value
    }) : obj[key] = value;
var __spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(b))if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var __spreadProps = (a, b)=>__defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && __getOwnPropSymbols) {
        for (var prop of __getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
// src/utils/react-is.ts
var IS_REACT_19 = /* @__PURE__ */ _react.version.startsWith("19");
var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for(IS_REACT_19 ? "react.transitional.element" : "react.element");
var REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal");
var REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
var REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode");
var REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler");
var REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer");
var REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context");
var REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref");
var REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense");
var REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list");
var REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo");
var REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
var REACT_OFFSCREEN_TYPE = /* @__PURE__ */ Symbol.for("react.offscreen");
var REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Memo = REACT_MEMO_TYPE;
function isValidElementType(type) {
    return typeof type === "string" || typeof type === "function" || type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_OFFSCREEN_TYPE || typeof type === "object" && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_CONSUMER_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) ? true : false;
}
function typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const { $$typeof } = object;
        switch($$typeof){
            case REACT_ELEMENT_TYPE:
                switch(object = object.type, object){
                    case REACT_FRAGMENT_TYPE:
                    case REACT_PROFILER_TYPE:
                    case REACT_STRICT_MODE_TYPE:
                    case REACT_SUSPENSE_TYPE:
                    case REACT_SUSPENSE_LIST_TYPE:
                        return object;
                    default:
                        switch(object = object && object.$$typeof, object){
                            case REACT_CONTEXT_TYPE:
                            case REACT_FORWARD_REF_TYPE:
                            case REACT_LAZY_TYPE:
                            case REACT_MEMO_TYPE:
                                return object;
                            case REACT_CONSUMER_TYPE:
                                return object;
                            default:
                                return $$typeof;
                        }
                }
            case REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
}
function isContextConsumer(object) {
    return IS_REACT_19 ? typeOf(object) === REACT_CONSUMER_TYPE : typeOf(object) === REACT_CONTEXT_TYPE;
}
function isMemo(object) {
    return typeOf(object) === REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    verify(mapStateToProps, "mapStateToProps");
    verify(mapDispatchToProps, "mapDispatchToProps");
    verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual, areOwnPropsEqual, areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps, initMapDispatchToProps, initMergeProps } = _b, options = __objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function verifyPlainObject(value, displayName, methodName) {
    if (!isPlainObject(value)) warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? wrapMapToPropsConstant((dispatch)=>({
            dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return __spreadValues(__spreadValues(__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName, areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>defaultMergeProps : typeof mergeProps === "function" ? wrapMergePropsFunc(mergeProps) : createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var nullListeners = {
    notify () {},
    get: ()=>[]
};
function createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub,
        notifyNestedSubs,
        handleChangeWrapper,
        isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var canUseDOM = ()=>!!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var isDOM = /* @__PURE__ */ canUseDOM();
var isRunningInReactNative = ()=>typeof navigator !== "undefined" && navigator.product === "ReactNative";
var isReactNative = /* @__PURE__ */ isRunningInReactNative();
var getUseIsomorphicLayoutEffect = ()=>isDOM || isReactNative ? _react.useLayoutEffect : _react.useEffect;
var useIsomorphicLayoutEffect = /* @__PURE__ */ getUseIsomorphicLayoutEffect();
// src/utils/shallowEqual.ts
function is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function shallowEqual(objA, objB) {
    if (is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var TYPE_STATICS = {
    [ForwardRef]: FORWARD_REF_STATICS,
    [Memo]: MEMO_STATICS
};
function getStatics(component) {
    if (isMemo(component)) return MEMO_STATICS;
    return TYPE_STATICS[component["$$typeof"]] || REACT_STATICS;
}
var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if (objectPrototype) {
            const inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = getOwnPropertyNames(sourceComponent);
        if (getOwnPropertySymbols) keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        const targetStatics = getStatics(targetComponent);
        const sourceStatics = getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/Context.ts
var ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function getContext() {
    var _a;
    if (!_react.createContext) return {};
    const contextMap = (_a = gT[ContextKey]) != null ? _a : gT[ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get(_react.createContext);
    if (!realContext) {
        realContext = _react.createContext(null);
        contextMap.set(_react.createContext, realContext);
    }
    return realContext;
}
var ReactReduxContext = /* @__PURE__ */ getContext();
// src/components/connect.tsx
var NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function strictEqual(a, b) {
    return a === b;
}
var hasWarnedAboutDeprecatedPureOption = false;
function connect(mapStateToProps, mapDispatchToProps, mergeProps, { // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual = strictEqual, areOwnPropsEqual = shallowEqual, areStatePropsEqual = shallowEqual, areMergedPropsEqual = shallowEqual, // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, // the context consumer to use
context = ReactReduxContext } = {}) {
    const Context = context;
    const initMapStateToProps = mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges,
            displayName,
            wrappedComponentName,
            WrappedComponent,
            // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps,
            initMergeProps,
            areStatesEqual,
            areStatePropsEqual,
            areOwnPropsEqual,
            areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = _react.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = __objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = _react.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = _react.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = _react.useMemo(()=>{
                return finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = _react.useMemo(()=>{
                if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY;
                const subscription2 = createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = _react.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return __spreadProps(__spreadValues({}, contextValue), {
                    subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = _react.useRef(void 0);
            const lastWrapperProps = _react.useRef(wrapperProps);
            const childPropsFromStoreUpdate = _react.useRef(void 0);
            const renderIsScheduled = _react.useRef(false);
            const isMounted = _react.useRef(false);
            const latestSubscriptionCallbackError = _react.useRef(void 0);
            useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = _react.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = _react.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = _react.useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = _react.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ _react.createElement(WrappedComponent, __spreadProps(__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = _react.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ _react.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = _react.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = _react.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ _react.createElement(Connect, __spreadProps(__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var connect_default = connect;
// src/components/Provider.tsx
function Provider(providerProps) {
    const { children, context, serverState, store } = providerProps;
    const contextValue = _react.useMemo(()=>{
        const subscription = createSubscription(store);
        const baseContextValue = {
            store,
            subscription,
            getServerState: serverState ? ()=>serverState : void 0
        };
        return baseContextValue;
    }, [
        store,
        serverState
    ]);
    const previousState = _react.useMemo(()=>store.getState(), [
        store
    ]);
    useIsomorphicLayoutEffect(()=>{
        const { subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || ReactReduxContext;
    return /* @__PURE__ */ _react.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var Provider_default = Provider;
// src/hooks/useReduxContext.ts
function createReduxContextHook(context = ReactReduxContext) {
    return function useReduxContext2() {
        const contextValue = _react.useContext(context);
        return contextValue;
    };
}
var useReduxContext = /* @__PURE__ */ createReduxContextHook();
// src/hooks/useStore.ts
function createStoreHook(context = ReactReduxContext) {
    const useReduxContext2 = context === ReactReduxContext ? useReduxContext : // @ts-ignore
    createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var useStore = /* @__PURE__ */ createStoreHook();
// src/hooks/useDispatch.ts
function createDispatchHook(context = ReactReduxContext) {
    const useStore2 = context === ReactReduxContext ? useStore : createStoreHook(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var useDispatch = /* @__PURE__ */ createDispatchHook();
var refEquality = (a, b)=>a === b;
function createSelectorHook(context = ReactReduxContext) {
    const useReduxContext2 = context === ReactReduxContext ? useReduxContext : createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn = refEquality } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const reduxContext = useReduxContext2();
        const { store, subscription, getServerState } = reduxContext;
        const firstRun = _react.useRef(true);
        const wrappedSelector = _react.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector
        ]);
        const selectedState = (0, _withSelectorJs.useSyncExternalStoreWithSelector)(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        _react.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var useSelector = /* @__PURE__ */ createSelectorHook();
// src/exports.ts
var batch = defaultNoopBatch;

},{"react":"bmhQu","use-sync-external-store/with-selector.js":"aRxn3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aRxn3":[function(require,module,exports,__globalThis) {
'use strict';
module.exports = require("626c9c74fab84747");

},{"626c9c74fab84747":"5ft1K"}],"5ft1K":[function(require,module,exports,__globalThis) {
/**
 * @license React
 * use-sync-external-store-with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
var React = require("309335e472185eb6");
function is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var objectIs = "function" === typeof Object.is ? Object.is : is, useSyncExternalStore = React.useSyncExternalStore, useRef = React.useRef, useEffect = React.useEffect, useMemo = React.useMemo, useDebugValue = React.useDebugValue;
exports.useSyncExternalStoreWithSelector = function(subscribe, getSnapshot, getServerSnapshot, selector, isEqual) {
    var instRef = useRef(null);
    if (null === instRef.current) {
        var inst = {
            hasValue: !1,
            value: null
        };
        instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo(function() {
        function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
                hasMemo = !0;
                memoizedSnapshot = nextSnapshot;
                nextSnapshot = selector(nextSnapshot);
                if (void 0 !== isEqual && inst.hasValue) {
                    var currentSelection = inst.value;
                    if (isEqual(currentSelection, nextSnapshot)) return memoizedSelection = currentSelection;
                }
                return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
            var nextSelection = selector(nextSnapshot);
            if (void 0 !== isEqual && isEqual(currentSelection, nextSelection)) return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
        }
        var hasMemo = !1, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
            function() {
                return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
                return memoizedSelector(maybeGetServerSnapshot());
            }
        ];
    }, [
        getSnapshot,
        getServerSnapshot,
        selector,
        isEqual
    ]);
    var value = useSyncExternalStore(subscribe, instRef[0], instRef[1]);
    useEffect(function() {
        inst.hasValue = !0;
        inst.value = value;
    }, [
        value
    ]);
    useDebugValue(value);
    return value;
};

},{"309335e472185eb6":"bmhQu"}],"7PM4x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LineChart", ()=>LineChart);
var _react = require("react");
var _optionsSlice = require("../state/optionsSlice");
var _cartesianChart = require("./CartesianChart");
var allowedTooltipTypes = [
    'axis'
];
var LineChart = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ _react.createElement((0, _cartesianChart.CartesianChart), {
        chartName: "LineChart",
        defaultTooltipEventType: "axis",
        validateTooltipEventTypes: allowedTooltipTypes,
        tooltipPayloadSearcher: (0, _optionsSlice.arrayTooltipSearcher),
        categoricalChartProps: props,
        ref: ref
    });
});

},{"react":"bmhQu","../state/optionsSlice":"2vgjK","./CartesianChart":"20tGW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2vgjK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * These chart options are decided internally, by Recharts,
 * and will not change during the lifetime of the chart.
 *
 * Changing these options can be done by swapping the root element
 * which will make a brand-new Redux store.
 *
 * If you want to store options that can be changed by the user,
 * use UpdatableChartOptions in rootPropsSlice.ts.
 */ parcelHelpers.export(exports, "arrayTooltipSearcher", ()=>arrayTooltipSearcher);
parcelHelpers.export(exports, "optionsReducer", ()=>optionsReducer);
parcelHelpers.export(exports, "createEventEmitter", ()=>createEventEmitter);
var _toolkit = require("@reduxjs/toolkit");
var _dataUtils = require("../util/DataUtils");
function arrayTooltipSearcher(data, strIndex) {
    if (!strIndex) return undefined;
    var numIndex = Number.parseInt(strIndex, 10);
    if ((0, _dataUtils.isNan)(numIndex)) return undefined;
    return data === null || data === void 0 ? void 0 : data[numIndex];
}
var initialState = {
    chartName: '',
    tooltipPayloadSearcher: undefined,
    eventEmitter: undefined,
    defaultTooltipEventType: 'axis'
};
var optionsSlice = (0, _toolkit.createSlice)({
    name: 'options',
    initialState,
    reducers: {
        createEventEmitter: (state)=>{
            if (state.eventEmitter == null) state.eventEmitter = Symbol('rechartsEventEmitter');
        }
    }
});
var optionsReducer = optionsSlice.reducer;
var { createEventEmitter } = optionsSlice.actions;

},{"@reduxjs/toolkit":"7hE98","../util/DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"20tGW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultCartesianChartProps", ()=>defaultCartesianChartProps);
parcelHelpers.export(exports, "CartesianChart", ()=>CartesianChart);
var _react = require("react");
var _rechartsStoreProvider = require("../state/RechartsStoreProvider");
var _chartDataContext = require("../context/chartDataContext");
var _reportMainChartProps = require("../state/ReportMainChartProps");
var _reportChartProps = require("../state/ReportChartProps");
var _categoricalChart = require("./CategoricalChart");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var defaultMargin = {
    top: 5,
    right: 5,
    bottom: 5,
    left: 5
};
var defaultCartesianChartProps = {
    accessibilityLayer: true,
    barCategoryGap: '10%',
    barGap: 4,
    layout: 'horizontal',
    margin: defaultMargin,
    responsive: false,
    reverseStackOrder: false,
    stackOffset: 'none',
    syncMethod: 'index'
};
var CartesianChart = /*#__PURE__*/ (0, _react.forwardRef)(function CartesianChart(props, ref) {
    var _categoricalChartProp;
    var rootChartProps = (0, _resolveDefaultProps.resolveDefaultProps)(props.categoricalChartProps, defaultCartesianChartProps);
    var { chartName, defaultTooltipEventType, validateTooltipEventTypes, tooltipPayloadSearcher, categoricalChartProps } = props;
    var options = {
        chartName,
        defaultTooltipEventType,
        validateTooltipEventTypes,
        tooltipPayloadSearcher,
        eventEmitter: undefined
    };
    return /*#__PURE__*/ _react.createElement((0, _rechartsStoreProvider.RechartsStoreProvider), {
        preloadedState: {
            options
        },
        reduxStoreName: (_categoricalChartProp = categoricalChartProps.id) !== null && _categoricalChartProp !== void 0 ? _categoricalChartProp : chartName
    }, /*#__PURE__*/ _react.createElement((0, _chartDataContext.ChartDataContextProvider), {
        chartData: categoricalChartProps.data
    }), /*#__PURE__*/ _react.createElement((0, _reportMainChartProps.ReportMainChartProps), {
        layout: rootChartProps.layout,
        margin: rootChartProps.margin
    }), /*#__PURE__*/ _react.createElement((0, _reportChartProps.ReportChartProps), {
        baseValue: rootChartProps.baseValue,
        accessibilityLayer: rootChartProps.accessibilityLayer,
        barCategoryGap: rootChartProps.barCategoryGap,
        maxBarSize: rootChartProps.maxBarSize,
        stackOffset: rootChartProps.stackOffset,
        barGap: rootChartProps.barGap,
        barSize: rootChartProps.barSize,
        syncId: rootChartProps.syncId,
        syncMethod: rootChartProps.syncMethod,
        className: rootChartProps.className,
        reverseStackOrder: rootChartProps.reverseStackOrder
    }), /*#__PURE__*/ _react.createElement((0, _categoricalChart.CategoricalChart), _extends({}, rootChartProps, {
        ref: ref
    })));
});

},{"react":"bmhQu","../state/RechartsStoreProvider":"aNngJ","../context/chartDataContext":"eFUkf","../state/ReportMainChartProps":"kt6OZ","../state/ReportChartProps":"jQD2P","./CategoricalChart":"9Ugve","../util/resolveDefaultProps":"cWUqx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aNngJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RechartsStoreProvider", ()=>RechartsStoreProvider);
var _react = require("react");
var _reactRedux = require("react-redux");
var _store = require("./store");
var _panoramaContext = require("../context/PanoramaContext");
var _rechartsReduxContext = require("./RechartsReduxContext");
function RechartsStoreProvider(_ref) {
    var { preloadedState, children, reduxStoreName } = _ref;
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    /*
   * Why the ref? Redux official documentation recommends to use store as a singleton,
   * and reuse that everywhere: https://redux-toolkit.js.org/api/configureStore#basic-example
   *
   * Which is correct! Except that is considering deploying Redux in an app.
   * Recharts as a library supports multiple charts on the same page.
   * And each of these charts needs its own store independent of others!
   *
   * The alternative is to have everything in the store keyed by the chart id.
   * Which would make working with everything a little bit more painful because we need the chart id everywhere.
   */ var storeRef = (0, _react.useRef)(null);
    /*
   * Panorama means that this chart is not its own chart, it's only a "preview"
   * being rendered as a child of Brush.
   * In such case, it should not have a store on its own - it should implicitly inherit
   * whatever data is in the "parent" or "root" chart.
   * Which here is represented by not having a Provider at all. All selectors will use the root store by default.
   */ if (isPanorama) return children;
    if (storeRef.current == null) storeRef.current = (0, _store.createRechartsStore)(preloadedState, reduxStoreName);
    // @ts-expect-error React-Redux types demand that the context internal value is not null, but we have that as default.
    var nonNullContext = (0, _rechartsReduxContext.RechartsReduxContext);
    return /*#__PURE__*/ _react.createElement((0, _reactRedux.Provider), {
        context: nonNullContext,
        store: storeRef.current
    }, children);
}

},{"react":"bmhQu","react-redux":"aRDHF","./store":"1l8JH","../context/PanoramaContext":"10hMm","./RechartsReduxContext":"fkmiH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1l8JH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "createRechartsStore", ()=>createRechartsStore);
var _toolkit = require("@reduxjs/toolkit");
var _optionsSlice = require("./optionsSlice");
var _tooltipSlice = require("./tooltipSlice");
var _chartDataSlice = require("./chartDataSlice");
var _layoutSlice = require("./layoutSlice");
var _mouseEventsMiddleware = require("./mouseEventsMiddleware");
var _reduxDevtoolsJsonStringifyReplacer = require("./reduxDevtoolsJsonStringifyReplacer");
var _cartesianAxisSlice = require("./cartesianAxisSlice");
var _graphicalItemsSlice = require("./graphicalItemsSlice");
var _referenceElementsSlice = require("./referenceElementsSlice");
var _brushSlice = require("./brushSlice");
var _legendSlice = require("./legendSlice");
var _rootPropsSlice = require("./rootPropsSlice");
var _polarAxisSlice = require("./polarAxisSlice");
var _polarOptionsSlice = require("./polarOptionsSlice");
var _keyboardEventsMiddleware = require("./keyboardEventsMiddleware");
var _externalEventsMiddleware = require("./externalEventsMiddleware");
var _touchEventsMiddleware = require("./touchEventsMiddleware");
var _errorBarSlice = require("./errorBarSlice");
var _global = require("../util/Global");
var _zIndexSlice = require("./zIndexSlice");
var rootReducer = (0, _toolkit.combineReducers)({
    brush: (0, _brushSlice.brushReducer),
    cartesianAxis: (0, _cartesianAxisSlice.cartesianAxisReducer),
    chartData: (0, _chartDataSlice.chartDataReducer),
    errorBars: (0, _errorBarSlice.errorBarReducer),
    graphicalItems: (0, _graphicalItemsSlice.graphicalItemsReducer),
    layout: (0, _layoutSlice.chartLayoutReducer),
    legend: (0, _legendSlice.legendReducer),
    options: (0, _optionsSlice.optionsReducer),
    polarAxis: (0, _polarAxisSlice.polarAxisReducer),
    polarOptions: (0, _polarOptionsSlice.polarOptionsReducer),
    referenceElements: (0, _referenceElementsSlice.referenceElementsReducer),
    rootProps: (0, _rootPropsSlice.rootPropsReducer),
    tooltip: (0, _tooltipSlice.tooltipReducer),
    zIndex: (0, _zIndexSlice.zIndexReducer)
});
var createRechartsStore = function createRechartsStore(preloadedState) {
    var chartName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Chart';
    return (0, _toolkit.configureStore)({
        reducer: rootReducer,
        // redux-toolkit v1 types are unhappy with the preloadedState type. Remove the `as any` when bumping to v2
        preloadedState: preloadedState,
        // @ts-expect-error redux-toolkit v1 types are unhappy with the middleware array. Remove this comment when bumping to v2
        middleware: (getDefaultMiddleware)=>{
            var _process$env$NODE_ENV;
            return getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: ![
                    'commonjs',
                    'es6',
                    'production'
                ].includes((_process$env$NODE_ENV = "es6", _process$env$NODE_ENV !== void 0) ? _process$env$NODE_ENV : '')
            }).concat([
                (0, _mouseEventsMiddleware.mouseClickMiddleware).middleware,
                (0, _mouseEventsMiddleware.mouseMoveMiddleware).middleware,
                (0, _keyboardEventsMiddleware.keyboardEventsMiddleware).middleware,
                (0, _externalEventsMiddleware.externalEventsMiddleware).middleware,
                (0, _touchEventsMiddleware.touchEventMiddleware).middleware
            ]);
        },
        /*
     * I can't find out how to satisfy typescript here.
     * We return `EnhancerArray<[StoreEnhancer<{}, {}>, StoreEnhancer]>` from this function,
     * but the types say we should return `EnhancerArray<StoreEnhancer<{}, {}>`.
     * Looks like it's badly inferred generics, but it won't allow me to provide the correct type manually either.
     * So let's just ignore the error for now.
     */ // @ts-expect-error mismatched generics
        enhancers: (getDefaultEnhancers)=>{
            var enhancers = getDefaultEnhancers;
            if (typeof getDefaultEnhancers === 'function') /*
         * In RTK v2 this is always a function, but in v1 it is an array.
         * Because we have @types/redux-toolkit v1 as a dependency, typescript is going to flag this as an error.
         * We support both RTK v1 and v2, so we need to do this check.
         * https://redux-toolkit.js.org/usage/migrating-rtk-2#configurestoreenhancers-must-be-a-callback
         */ // @ts-expect-error RTK v2 behaviour on RTK v1 types
            enhancers = getDefaultEnhancers();
            return enhancers.concat((0, _toolkit.autoBatchEnhancer)({
                type: 'raf'
            }));
        },
        devTools: (0, _global.Global).devToolsEnabled && {
            serialize: {
                replacer: (0, _reduxDevtoolsJsonStringifyReplacer.reduxDevtoolsJsonStringifyReplacer)
            },
            name: "recharts-".concat(chartName)
        }
    });
};

},{"@reduxjs/toolkit":[["autoBatchEnhancer","7hE98"],["configureStore","7hE98"],["combineReducers","fptxw"]],"./optionsSlice":"2vgjK","./tooltipSlice":"8Jqu4","./chartDataSlice":"8sqTx","./layoutSlice":"gG6kT","./mouseEventsMiddleware":"cI47t","./reduxDevtoolsJsonStringifyReplacer":"7B0sD","./cartesianAxisSlice":"284SY","./graphicalItemsSlice":"c5gq8","./referenceElementsSlice":"fAFVp","./brushSlice":"cDmMg","./legendSlice":"fLI5a","./rootPropsSlice":"Gj7Dt","./polarAxisSlice":"e71Z3","./polarOptionsSlice":"kwLXV","./keyboardEventsMiddleware":"bcdow","./externalEventsMiddleware":"2Rhvy","./touchEventsMiddleware":"1Gqol","./errorBarSlice":"jPkx5","../util/Global":"7wpBp","./zIndexSlice":"haK2y","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8sqTx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialChartDataState", ()=>initialChartDataState);
parcelHelpers.export(exports, "setChartData", ()=>setChartData);
parcelHelpers.export(exports, "setDataStartEndIndexes", ()=>setDataStartEndIndexes);
parcelHelpers.export(exports, "setComputedData", ()=>setComputedData);
parcelHelpers.export(exports, "chartDataReducer", ()=>chartDataReducer);
var _toolkit = require("@reduxjs/toolkit");
var initialChartDataState = {
    chartData: undefined,
    computedData: undefined,
    dataStartIndex: 0,
    dataEndIndex: 0
};
var chartDataSlice = (0, _toolkit.createSlice)({
    name: 'chartData',
    initialState: initialChartDataState,
    reducers: {
        setChartData (state, action) {
            state.chartData = action.payload;
            if (action.payload == null) {
                state.dataStartIndex = 0;
                state.dataEndIndex = 0;
                return;
            }
            if (action.payload.length > 0 && state.dataEndIndex !== action.payload.length - 1) state.dataEndIndex = action.payload.length - 1;
        },
        setComputedData (state, action) {
            state.computedData = action.payload;
        },
        setDataStartEndIndexes (state, action) {
            var { startIndex, endIndex } = action.payload;
            if (startIndex != null) state.dataStartIndex = startIndex;
            if (endIndex != null) state.dataEndIndex = endIndex;
        }
    }
});
var { setChartData, setDataStartEndIndexes, setComputedData } = chartDataSlice.actions;
var chartDataReducer = chartDataSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cI47t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "mouseClickAction", ()=>mouseClickAction);
parcelHelpers.export(exports, "mouseClickMiddleware", ()=>mouseClickMiddleware);
parcelHelpers.export(exports, "mouseMoveAction", ()=>mouseMoveAction);
parcelHelpers.export(exports, "mouseMoveMiddleware", ()=>mouseMoveMiddleware);
var _toolkit = require("@reduxjs/toolkit");
var _tooltipSlice = require("./tooltipSlice");
var _selectActivePropsFromChartPointer = require("./selectors/selectActivePropsFromChartPointer");
var _selectTooltipEventType = require("./selectors/selectTooltipEventType");
var _getChartPointer = require("../util/getChartPointer");
var mouseClickAction = (0, _toolkit.createAction)('mouseClick');
var mouseClickMiddleware = (0, _toolkit.createListenerMiddleware)();
// TODO: there's a bug here when you click the chart the activeIndex resets to zero
mouseClickMiddleware.startListening({
    actionCreator: mouseClickAction,
    effect: (action, listenerApi)=>{
        var mousePointer = action.payload;
        var activeProps = (0, _selectActivePropsFromChartPointer.selectActivePropsFromChartPointer)(listenerApi.getState(), (0, _getChartPointer.getChartPointer)(mousePointer));
        if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, _tooltipSlice.setMouseClickAxisIndex)({
            activeIndex: activeProps.activeIndex,
            activeDataKey: undefined,
            activeCoordinate: activeProps.activeCoordinate
        }));
    }
});
var mouseMoveAction = (0, _toolkit.createAction)('mouseMove');
var mouseMoveMiddleware = (0, _toolkit.createListenerMiddleware)();
/*
 * This single rafId is safe because:
 * 1. Each chart has its own Redux store instance with its own middleware
 * 2. mouseMoveAction only fires from one DOM element (the chart wrapper)
 * 3. Rapid mousemove events from the same element SHOULD debounce - we only care about the latest position
 * This is different from externalEventsMiddleware which handles multiple event types
 * (click, mouseenter, mouseleave, etc.) that should NOT cancel each other.
 */ var rafId = null;
mouseMoveMiddleware.startListening({
    actionCreator: mouseMoveAction,
    effect: (action, listenerApi)=>{
        var mousePointer = action.payload;
        // Cancel any pending animation frame
        if (rafId !== null) cancelAnimationFrame(rafId);
        var chartPointer = (0, _getChartPointer.getChartPointer)(mousePointer);
        // Schedule the dispatch for the next animation frame
        rafId = requestAnimationFrame(()=>{
            var state = listenerApi.getState();
            var tooltipEventType = (0, _selectTooltipEventType.selectTooltipEventType)(state, state.tooltip.settings.shared);
            // this functionality only applies to charts that have axes
            if (tooltipEventType === 'axis') {
                var activeProps = (0, _selectActivePropsFromChartPointer.selectActivePropsFromChartPointer)(state, chartPointer);
                if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, _tooltipSlice.setMouseOverAxisIndex)({
                    activeIndex: activeProps.activeIndex,
                    activeDataKey: undefined,
                    activeCoordinate: activeProps.activeCoordinate
                }));
                else // this is needed to clear tooltip state when the mouse moves out of the inRange (svg - offset) function, but not yet out of the svg
                listenerApi.dispatch((0, _tooltipSlice.mouseLeaveChart)());
            }
            rafId = null;
        });
    }
});

},{"@reduxjs/toolkit":"7hE98","./tooltipSlice":"8Jqu4","./selectors/selectActivePropsFromChartPointer":"hjsgY","./selectors/selectTooltipEventType":"4RpEb","../util/getChartPointer":"b9Vry","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hjsgY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectActivePropsFromChartPointer", ()=>selectActivePropsFromChartPointer);
var _reselect = require("reselect");
var _chartLayoutContext = require("../../context/chartLayoutContext");
var _tooltipSelectors = require("./tooltipSelectors");
var _selectChartOffsetInternal = require("./selectChartOffsetInternal");
var _selectors = require("./selectors");
var _polarAxisSelectors = require("./polarAxisSelectors");
var _selectTooltipAxisType = require("./selectTooltipAxisType");
var pickChartPointer = (_state, chartPointer)=>chartPointer;
var selectActivePropsFromChartPointer = (0, _reselect.createSelector)([
    pickChartPointer,
    (0, _chartLayoutContext.selectChartLayout),
    (0, _polarAxisSelectors.selectPolarViewBox),
    (0, _selectTooltipAxisType.selectTooltipAxisType),
    (0, _tooltipSelectors.selectTooltipAxisRangeWithReverse),
    (0, _tooltipSelectors.selectTooltipAxisTicks),
    (0, _selectors.selectOrderedTooltipTicks),
    (0, _selectChartOffsetInternal.selectChartOffsetInternal)
], (0, _selectors.combineActiveProps));

},{"reselect":"ds2su","../../context/chartLayoutContext":"jIUyy","./tooltipSelectors":"hydW6","./selectChartOffsetInternal":"caUjq","./selectors":"2uuUJ","./polarAxisSelectors":"jJj4n","./selectTooltipAxisType":"hUECt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2uuUJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useChartName", ()=>useChartName);
parcelHelpers.export(exports, "selectOrderedTooltipTicks", ()=>selectOrderedTooltipTicks);
parcelHelpers.export(exports, "selectTooltipInteractionState", ()=>selectTooltipInteractionState);
parcelHelpers.export(exports, "selectActiveIndex", ()=>selectActiveIndex);
parcelHelpers.export(exports, "selectTooltipDataKey", ()=>selectTooltipDataKey);
parcelHelpers.export(exports, "selectTooltipPayloadConfigurations", ()=>selectTooltipPayloadConfigurations);
parcelHelpers.export(exports, "selectCoordinateForDefaultIndex", ()=>selectCoordinateForDefaultIndex);
parcelHelpers.export(exports, "selectActiveCoordinate", ()=>selectActiveCoordinate);
parcelHelpers.export(exports, "selectActiveLabel", ()=>selectActiveLabel);
parcelHelpers.export(exports, "selectTooltipPayload", ()=>selectTooltipPayload);
parcelHelpers.export(exports, "selectIsTooltipActive", ()=>selectIsTooltipActive);
parcelHelpers.export(exports, "combineActiveProps", ()=>combineActiveProps);
var _reselect = require("reselect");
var _sortBy = require("es-toolkit/compat/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _hooks = require("../hooks");
var _chartUtils = require("../../util/ChartUtils");
var _dataSelectors = require("./dataSelectors");
var _tooltipSelectors = require("./tooltipSelectors");
var _axisSelectors = require("./axisSelectors");
var _rootPropsSelectors = require("./rootPropsSelectors");
var _chartLayoutContext = require("../../context/chartLayoutContext");
var _selectChartOffsetInternal = require("./selectChartOffsetInternal");
var _containerSelectors = require("./containerSelectors");
var _combineActiveLabel = require("./combiners/combineActiveLabel");
var _combineTooltipInteractionState = require("./combiners/combineTooltipInteractionState");
var _combineActiveTooltipIndex = require("./combiners/combineActiveTooltipIndex");
var _combineCoordinateForDefaultIndex = require("./combiners/combineCoordinateForDefaultIndex");
var _combineTooltipPayloadConfigurations = require("./combiners/combineTooltipPayloadConfigurations");
var _selectTooltipPayloadSearcher = require("./selectTooltipPayloadSearcher");
var _selectTooltipState = require("./selectTooltipState");
var _combineTooltipPayload = require("./combiners/combineTooltipPayload");
var _getActiveCoordinate = require("../../util/getActiveCoordinate");
var _polarUtils = require("../../util/PolarUtils");
var useChartName = ()=>{
    return (0, _hooks.useAppSelector)((0, _rootPropsSelectors.selectChartName));
};
var pickTooltipEventType = (_state, tooltipEventType)=>tooltipEventType;
var pickTrigger = (_state, _tooltipEventType, trigger)=>trigger;
var pickDefaultIndex = (_state, _tooltipEventType, _trigger, defaultIndex)=>defaultIndex;
var selectOrderedTooltipTicks = (0, _reselect.createSelector)((0, _tooltipSelectors.selectTooltipAxisTicks), (ticks)=>(0, _sortByDefault.default)(ticks, (o)=>o.coordinate));
var selectTooltipInteractionState = (0, _reselect.createSelector)([
    (0, _selectTooltipState.selectTooltipState),
    pickTooltipEventType,
    pickTrigger,
    pickDefaultIndex
], (0, _combineTooltipInteractionState.combineTooltipInteractionState));
var selectActiveIndex = (0, _reselect.createSelector)([
    selectTooltipInteractionState,
    (0, _tooltipSelectors.selectTooltipDisplayedData),
    (0, _axisSelectors.selectTooltipAxisDataKey),
    (0, _tooltipSelectors.selectTooltipAxisDomain)
], (0, _combineActiveTooltipIndex.combineActiveTooltipIndex));
var selectTooltipDataKey = (state, tooltipEventType, trigger)=>{
    if (tooltipEventType == null) return undefined;
    var tooltipState = (0, _selectTooltipState.selectTooltipState)(state);
    if (tooltipEventType === 'axis') {
        if (trigger === 'hover') return tooltipState.axisInteraction.hover.dataKey;
        return tooltipState.axisInteraction.click.dataKey;
    }
    if (trigger === 'hover') return tooltipState.itemInteraction.hover.dataKey;
    return tooltipState.itemInteraction.click.dataKey;
};
var selectTooltipPayloadConfigurations = (0, _reselect.createSelector)([
    (0, _selectTooltipState.selectTooltipState),
    pickTooltipEventType,
    pickTrigger,
    pickDefaultIndex
], (0, _combineTooltipPayloadConfigurations.combineTooltipPayloadConfigurations));
var selectCoordinateForDefaultIndex = (0, _reselect.createSelector)([
    (0, _containerSelectors.selectChartWidth),
    (0, _containerSelectors.selectChartHeight),
    (0, _chartLayoutContext.selectChartLayout),
    (0, _selectChartOffsetInternal.selectChartOffsetInternal),
    (0, _tooltipSelectors.selectTooltipAxisTicks),
    pickDefaultIndex,
    selectTooltipPayloadConfigurations,
    (0, _selectTooltipPayloadSearcher.selectTooltipPayloadSearcher)
], (0, _combineCoordinateForDefaultIndex.combineCoordinateForDefaultIndex));
var selectActiveCoordinate = (0, _reselect.createSelector)([
    selectTooltipInteractionState,
    selectCoordinateForDefaultIndex
], (tooltipInteractionState, defaultIndexCoordinate)=>{
    var _tooltipInteractionSt;
    return (_tooltipInteractionSt = tooltipInteractionState.coordinate) !== null && _tooltipInteractionSt !== void 0 ? _tooltipInteractionSt : defaultIndexCoordinate;
});
var selectActiveLabel = (0, _reselect.createSelector)([
    (0, _tooltipSelectors.selectTooltipAxisTicks),
    selectActiveIndex
], (0, _combineActiveLabel.combineActiveLabel));
var selectTooltipPayload = (0, _reselect.createSelector)([
    selectTooltipPayloadConfigurations,
    selectActiveIndex,
    (0, _dataSelectors.selectChartDataWithIndexes),
    (0, _axisSelectors.selectTooltipAxisDataKey),
    selectActiveLabel,
    (0, _selectTooltipPayloadSearcher.selectTooltipPayloadSearcher),
    pickTooltipEventType
], (0, _combineTooltipPayload.combineTooltipPayload));
var selectIsTooltipActive = (0, _reselect.createSelector)([
    selectTooltipInteractionState,
    selectActiveIndex
], (tooltipInteractionState, activeIndex)=>{
    return {
        isActive: tooltipInteractionState.active && activeIndex != null,
        activeIndex
    };
});
var combineActiveCartesianProps = (chartEvent, layout, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset)=>{
    if (!chartEvent || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks) return undefined;
    if (!(0, _getActiveCoordinate.isInCartesianRange)(chartEvent, offset)) return undefined;
    var pos = (0, _chartUtils.calculateCartesianTooltipPos)(chartEvent, layout);
    var activeIndex = (0, _getActiveCoordinate.calculateActiveTickIndex)(pos, orderedTooltipTicks, tooltipTicks, tooltipAxisType, tooltipAxisRange);
    var activeCoordinate = (0, _getActiveCoordinate.getActiveCartesianCoordinate)(layout, tooltipTicks, activeIndex, chartEvent);
    return {
        activeIndex: String(activeIndex),
        activeCoordinate
    };
};
var combineActivePolarProps = (chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks)=>{
    if (!chartEvent || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks || !polarViewBox) return undefined;
    var rangeObj = (0, _polarUtils.inRangeOfSector)(chartEvent, polarViewBox);
    if (!rangeObj) return undefined;
    var pos = (0, _chartUtils.calculatePolarTooltipPos)(rangeObj, layout);
    var activeIndex = (0, _getActiveCoordinate.calculateActiveTickIndex)(pos, orderedTooltipTicks, tooltipTicks, tooltipAxisType, tooltipAxisRange);
    var activeCoordinate = (0, _getActiveCoordinate.getActivePolarCoordinate)(layout, tooltipTicks, activeIndex, rangeObj);
    return {
        activeIndex: String(activeIndex),
        activeCoordinate
    };
};
var combineActiveProps = (chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset)=>{
    if (!chartEvent || !layout || !tooltipAxisType || !tooltipAxisRange || !tooltipTicks) return undefined;
    if (layout === 'horizontal' || layout === 'vertical') return combineActiveCartesianProps(chartEvent, layout, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks, offset);
    return combineActivePolarProps(chartEvent, layout, polarViewBox, tooltipAxisType, tooltipAxisRange, tooltipTicks, orderedTooltipTicks);
};

},{"reselect":"ds2su","es-toolkit/compat/sortBy":"jVc75","../hooks":"aEuxu","../../util/ChartUtils":"enJyE","./dataSelectors":"j0cmw","./tooltipSelectors":"hydW6","./axisSelectors":"bvR8m","./rootPropsSelectors":"eYPte","../../context/chartLayoutContext":"jIUyy","./selectChartOffsetInternal":"caUjq","./containerSelectors":"lnBke","./combiners/combineActiveLabel":"2d1rr","./combiners/combineTooltipInteractionState":"41NKO","./combiners/combineActiveTooltipIndex":"f5Q8L","./combiners/combineCoordinateForDefaultIndex":"17rFP","./combiners/combineTooltipPayloadConfigurations":"iA3O6","./selectTooltipPayloadSearcher":"i7xdk","./selectTooltipState":"XQ7NK","./combiners/combineTooltipPayload":"lgUnN","../../util/getActiveCoordinate":"cePd9","../../util/PolarUtils":"ezeVo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cePd9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getActiveCartesianCoordinate", ()=>getActiveCartesianCoordinate);
parcelHelpers.export(exports, "getActivePolarCoordinate", ()=>getActivePolarCoordinate);
parcelHelpers.export(exports, "isInCartesianRange", ()=>isInCartesianRange);
parcelHelpers.export(exports, "calculateActiveTickIndex", ()=>calculateActiveTickIndex);
var _polarUtils = require("./PolarUtils");
var _dataUtils = require("./DataUtils");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var getActiveCartesianCoordinate = (layout, tooltipTicks, activeIndex, pointer)=>{
    var entry = tooltipTicks.find((tick)=>tick && tick.index === activeIndex);
    if (entry) {
        if (layout === 'horizontal') return {
            x: entry.coordinate,
            y: pointer.chartY
        };
        if (layout === 'vertical') return {
            x: pointer.chartX,
            y: entry.coordinate
        };
    }
    return {
        x: 0,
        y: 0
    };
};
var getActivePolarCoordinate = (layout, tooltipTicks, activeIndex, rangeObj)=>{
    var entry = tooltipTicks.find((tick)=>tick && tick.index === activeIndex);
    if (entry) {
        if (layout === 'centric') {
            var _angle = entry.coordinate;
            var { radius: _radius } = rangeObj;
            return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), (0, _polarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, _radius, _angle)), {}, {
                angle: _angle,
                radius: _radius
            });
        }
        var radius = entry.coordinate;
        var { angle } = rangeObj;
        return _objectSpread(_objectSpread(_objectSpread({}, rangeObj), (0, _polarUtils.polarToCartesian)(rangeObj.cx, rangeObj.cy, radius, angle)), {}, {
            angle,
            radius
        });
    }
    return {
        angle: 0,
        clockWise: false,
        cx: 0,
        cy: 0,
        endAngle: 0,
        innerRadius: 0,
        outerRadius: 0,
        radius: 0,
        startAngle: 0,
        x: 0,
        y: 0
    };
};
function isInCartesianRange(pointer, offset) {
    var { chartX: x, chartY: y } = pointer;
    return x >= offset.left && x <= offset.left + offset.width && y >= offset.top && y <= offset.top + offset.height;
}
var calculateActiveTickIndex = (coordinate, ticks, unsortedTicks, axisType, range)=>{
    var _ticks$length;
    var len = (_ticks$length = ticks === null || ticks === void 0 ? void 0 : ticks.length) !== null && _ticks$length !== void 0 ? _ticks$length : 0;
    // if there are 1 or fewer ticks or if there is no coordinate then the active tick is at index 0
    if (len <= 1 || coordinate == null) return 0;
    if (axisType === 'angleAxis' && range != null && Math.abs(Math.abs(range[1] - range[0]) - 360) <= 1e-6) // ticks are distributed in a circle
    for(var i = 0; i < len; i++){
        var _unsortedTicks, _unsortedTicks2, _unsortedTicks$i, _unsortedTicks$, _unsortedTicks3;
        var before = i > 0 ? (_unsortedTicks = unsortedTicks[i - 1]) === null || _unsortedTicks === void 0 ? void 0 : _unsortedTicks.coordinate : (_unsortedTicks2 = unsortedTicks[len - 1]) === null || _unsortedTicks2 === void 0 ? void 0 : _unsortedTicks2.coordinate;
        var cur = (_unsortedTicks$i = unsortedTicks[i]) === null || _unsortedTicks$i === void 0 ? void 0 : _unsortedTicks$i.coordinate;
        var after = i >= len - 1 ? (_unsortedTicks$ = unsortedTicks[0]) === null || _unsortedTicks$ === void 0 ? void 0 : _unsortedTicks$.coordinate : (_unsortedTicks3 = unsortedTicks[i + 1]) === null || _unsortedTicks3 === void 0 ? void 0 : _unsortedTicks3.coordinate;
        var sameDirectionCoord = void 0;
        if (before == null || cur == null || after == null) continue;
        if ((0, _dataUtils.mathSign)(cur - before) !== (0, _dataUtils.mathSign)(after - cur)) {
            var diffInterval = [];
            if ((0, _dataUtils.mathSign)(after - cur) === (0, _dataUtils.mathSign)(range[1] - range[0])) {
                sameDirectionCoord = after;
                var curInRange = cur + range[1] - range[0];
                diffInterval[0] = Math.min(curInRange, (curInRange + before) / 2);
                diffInterval[1] = Math.max(curInRange, (curInRange + before) / 2);
            } else {
                sameDirectionCoord = before;
                var afterInRange = after + range[1] - range[0];
                diffInterval[0] = Math.min(cur, (afterInRange + cur) / 2);
                diffInterval[1] = Math.max(cur, (afterInRange + cur) / 2);
            }
            var sameInterval = [
                Math.min(cur, (sameDirectionCoord + cur) / 2),
                Math.max(cur, (sameDirectionCoord + cur) / 2)
            ];
            if (coordinate > sameInterval[0] && coordinate <= sameInterval[1] || coordinate >= diffInterval[0] && coordinate <= diffInterval[1]) {
                var _unsortedTicks$i2;
                return (_unsortedTicks$i2 = unsortedTicks[i]) === null || _unsortedTicks$i2 === void 0 ? void 0 : _unsortedTicks$i2.index;
            }
        } else {
            var minValue = Math.min(before, after);
            var maxValue = Math.max(before, after);
            if (coordinate > (minValue + cur) / 2 && coordinate <= (maxValue + cur) / 2) {
                var _unsortedTicks$i3;
                return (_unsortedTicks$i3 = unsortedTicks[i]) === null || _unsortedTicks$i3 === void 0 ? void 0 : _unsortedTicks$i3.index;
            }
        }
    }
    else if (ticks) // ticks are distributed in a single direction
    for(var _i = 0; _i < len; _i++){
        var curr = ticks[_i];
        if (curr == null) continue;
        var next = ticks[_i + 1];
        var prev = ticks[_i - 1];
        if (_i === 0 && next != null && coordinate <= (curr.coordinate + next.coordinate) / 2) return curr.index;
        if (_i === len - 1 && prev != null && coordinate > (curr.coordinate + prev.coordinate) / 2) return curr.index;
        if (_i > 0 && _i < len - 1 && prev != null && next != null && coordinate > (curr.coordinate + prev.coordinate) / 2 && coordinate <= (curr.coordinate + next.coordinate) / 2) return curr.index;
    }
    return -1;
};

},{"./PolarUtils":"ezeVo","./DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b9Vry":[function(require,module,exports,__globalThis) {
/**
 * Computes the chart coordinates from the mouse event.
 *
 * The coordinates are relative to the top-left corner of the chart,
 * where the top-left corner of the chart is (0, 0).
 * Moving right, the x-coordinate increases, and moving down, the y-coordinate increases.
 *
 * The coordinates are rounded to the nearest integer and are including a CSS transform scale.
 * So a chart that's scaled will return the same coordinates as a chart that's not scaled.
 *
 * @param event The mouse event from React event handlers
 * @return chartPointer The chart coordinates relative to the top-left corner of the chart
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getChartPointer", ()=>getChartPointer);
var getChartPointer = (event)=>{
    var rect = event.currentTarget.getBoundingClientRect();
    var scaleX = rect.width / event.currentTarget.offsetWidth;
    var scaleY = rect.height / event.currentTarget.offsetHeight;
    return {
        /*
     * Here it's important to use:
     * - event.clientX and event.clientY to get the mouse position relative to the viewport, including scroll.
     * - pageX and pageY are not used because they are relative to the whole document, and ignore scroll.
     * - rect.left and rect.top are used to get the position of the chart relative to the viewport.
     * - offsetX and offsetY are not used because they are relative to the offset parent
     *  which may or may not be the same as the clientX and clientY, depending on the position of the chart in the DOM
     *  and surrounding element styles. CSS position: relative, absolute, fixed, will change the offset parent.
     * - scaleX and scaleY are necessary for when the chart element is scaled using CSS `transform: scale(N)`.
     */ chartX: Math.round((event.clientX - rect.left) / scaleX),
        chartY: Math.round((event.clientY - rect.top) / scaleY)
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7B0sD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "reduxDevtoolsJsonStringifyReplacer", ()=>reduxDevtoolsJsonStringifyReplacer);
function reduxDevtoolsJsonStringifyReplacer(key, value) {
    if (value instanceof HTMLElement) return "HTMLElement <".concat(value.tagName, " class=\"").concat(value.className, "\">");
    if (value === window) return 'global.window';
    if (key === 'children' && typeof value === 'object' && value !== null) return '<<CHILDREN>>';
    return value;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fAFVp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "referenceElementsSlice", ()=>referenceElementsSlice);
parcelHelpers.export(exports, "addDot", ()=>addDot);
parcelHelpers.export(exports, "removeDot", ()=>removeDot);
parcelHelpers.export(exports, "addArea", ()=>addArea);
parcelHelpers.export(exports, "removeArea", ()=>removeArea);
parcelHelpers.export(exports, "addLine", ()=>addLine);
parcelHelpers.export(exports, "removeLine", ()=>removeLine);
parcelHelpers.export(exports, "referenceElementsReducer", ()=>referenceElementsReducer);
var _toolkit = require("@reduxjs/toolkit");
var _immer = require("immer");
var initialState = {
    dots: [],
    areas: [],
    lines: []
};
var referenceElementsSlice = (0, _toolkit.createSlice)({
    name: 'referenceElements',
    initialState,
    reducers: {
        addDot: (state, action)=>{
            state.dots.push(action.payload);
        },
        removeDot: (state, action)=>{
            var index = (0, _toolkit.current)(state).dots.findIndex((dot)=>dot === action.payload);
            if (index !== -1) state.dots.splice(index, 1);
        },
        addArea: (state, action)=>{
            state.areas.push(action.payload);
        },
        removeArea: (state, action)=>{
            var index = (0, _toolkit.current)(state).areas.findIndex((area)=>area === action.payload);
            if (index !== -1) state.areas.splice(index, 1);
        },
        addLine: (state, action)=>{
            state.lines.push((0, _immer.castDraft)(action.payload));
        },
        removeLine: (state, action)=>{
            var index = (0, _toolkit.current)(state).lines.findIndex((line)=>line === action.payload);
            if (index !== -1) state.lines.splice(index, 1);
        }
    }
});
var { addDot, removeDot, addArea, removeArea, addLine, removeLine } = referenceElementsSlice.actions;
var referenceElementsReducer = referenceElementsSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","immer":"ggZ4C","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cDmMg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "brushSlice", ()=>brushSlice);
parcelHelpers.export(exports, "setBrushSettings", ()=>setBrushSettings);
parcelHelpers.export(exports, "brushReducer", ()=>brushReducer);
var _toolkit = require("@reduxjs/toolkit");
/**
 * From all Brush properties, only height has a default value and will always be defined.
 * Other properties are nullable and will be computed from offsets and margins if they are not set.
 */ var initialState = {
    x: 0,
    y: 0,
    width: 0,
    height: 0,
    padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    }
};
var brushSlice = (0, _toolkit.createSlice)({
    name: 'brush',
    initialState,
    reducers: {
        setBrushSettings (_state, action) {
            if (action.payload == null) return initialState;
            return action.payload;
        }
    }
});
var { setBrushSettings } = brushSlice.actions;
var brushReducer = brushSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Gj7Dt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initialState", ()=>initialState);
parcelHelpers.export(exports, "rootPropsReducer", ()=>rootPropsReducer);
parcelHelpers.export(exports, "updateOptions", ()=>updateOptions);
var _toolkit = require("@reduxjs/toolkit");
var initialState = {
    accessibilityLayer: true,
    barCategoryGap: '10%',
    barGap: 4,
    barSize: undefined,
    className: undefined,
    maxBarSize: undefined,
    stackOffset: 'none',
    syncId: undefined,
    syncMethod: 'index',
    baseValue: undefined,
    reverseStackOrder: false
};
var rootPropsSlice = (0, _toolkit.createSlice)({
    name: 'rootProps',
    initialState,
    reducers: {
        updateOptions: (state, action)=>{
            var _action$payload$barGa;
            state.accessibilityLayer = action.payload.accessibilityLayer;
            state.barCategoryGap = action.payload.barCategoryGap;
            state.barGap = (_action$payload$barGa = action.payload.barGap) !== null && _action$payload$barGa !== void 0 ? _action$payload$barGa : initialState.barGap;
            state.barSize = action.payload.barSize;
            state.maxBarSize = action.payload.maxBarSize;
            state.stackOffset = action.payload.stackOffset;
            state.syncId = action.payload.syncId;
            state.syncMethod = action.payload.syncMethod;
            state.className = action.payload.className;
            state.baseValue = action.payload.baseValue;
            state.reverseStackOrder = action.payload.reverseStackOrder;
        }
    }
});
var rootPropsReducer = rootPropsSlice.reducer;
var { updateOptions } = rootPropsSlice.actions;

},{"@reduxjs/toolkit":"7hE98","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e71Z3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "addRadiusAxis", ()=>addRadiusAxis);
parcelHelpers.export(exports, "removeRadiusAxis", ()=>removeRadiusAxis);
parcelHelpers.export(exports, "addAngleAxis", ()=>addAngleAxis);
parcelHelpers.export(exports, "removeAngleAxis", ()=>removeAngleAxis);
parcelHelpers.export(exports, "polarAxisReducer", ()=>polarAxisReducer);
var _toolkit = require("@reduxjs/toolkit");
var _immer = require("immer");
var initialState = {
    radiusAxis: {},
    angleAxis: {}
};
var polarAxisSlice = (0, _toolkit.createSlice)({
    name: 'polarAxis',
    initialState,
    reducers: {
        addRadiusAxis (state, action) {
            state.radiusAxis[action.payload.id] = (0, _immer.castDraft)(action.payload);
        },
        removeRadiusAxis (state, action) {
            delete state.radiusAxis[action.payload.id];
        },
        addAngleAxis (state, action) {
            state.angleAxis[action.payload.id] = (0, _immer.castDraft)(action.payload);
        },
        removeAngleAxis (state, action) {
            delete state.angleAxis[action.payload.id];
        }
    }
});
var { addRadiusAxis, removeRadiusAxis, addAngleAxis, removeAngleAxis } = polarAxisSlice.actions;
var polarAxisReducer = polarAxisSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","immer":"ggZ4C","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kwLXV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "updatePolarOptions", ()=>updatePolarOptions);
parcelHelpers.export(exports, "polarOptionsReducer", ()=>polarOptionsReducer);
var _toolkit = require("@reduxjs/toolkit");
var polarOptionsSlice = (0, _toolkit.createSlice)({
    name: 'polarOptions',
    initialState: null,
    reducers: {
        updatePolarOptions: (_state, action)=>{
            return action.payload;
        }
    }
});
var { updatePolarOptions } = polarOptionsSlice.actions;
var polarOptionsReducer = polarOptionsSlice.reducer;

},{"@reduxjs/toolkit":"7hE98","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bcdow":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "keyDownAction", ()=>keyDownAction);
parcelHelpers.export(exports, "focusAction", ()=>focusAction);
parcelHelpers.export(exports, "keyboardEventsMiddleware", ()=>keyboardEventsMiddleware);
var _toolkit = require("@reduxjs/toolkit");
var _tooltipSlice = require("./tooltipSlice");
var _tooltipSelectors = require("./selectors/tooltipSelectors");
var _selectors = require("./selectors/selectors");
var _axisSelectors = require("./selectors/axisSelectors");
var _combineActiveTooltipIndex = require("./selectors/combiners/combineActiveTooltipIndex");
var keyDownAction = (0, _toolkit.createAction)('keyDown');
var focusAction = (0, _toolkit.createAction)('focus');
var keyboardEventsMiddleware = (0, _toolkit.createListenerMiddleware)();
keyboardEventsMiddleware.startListening({
    actionCreator: keyDownAction,
    effect: (action, listenerApi)=>{
        var state = listenerApi.getState();
        var accessibilityLayerIsActive = state.rootProps.accessibilityLayer !== false;
        if (!accessibilityLayerIsActive) return;
        var { keyboardInteraction } = state.tooltip;
        var key = action.payload;
        if (key !== 'ArrowRight' && key !== 'ArrowLeft' && key !== 'Enter') return;
        // TODO this is lacking index for charts that do not support numeric indexes
        var resolvedIndex = (0, _combineActiveTooltipIndex.combineActiveTooltipIndex)(keyboardInteraction, (0, _tooltipSelectors.selectTooltipDisplayedData)(state), (0, _axisSelectors.selectTooltipAxisDataKey)(state), (0, _tooltipSelectors.selectTooltipAxisDomain)(state));
        var currentIndex = resolvedIndex == null ? -1 : Number(resolvedIndex);
        if (!Number.isFinite(currentIndex) || currentIndex < 0) return;
        var tooltipTicks = (0, _tooltipSelectors.selectTooltipAxisTicks)(state);
        if (key === 'Enter') {
            var _coordinate = (0, _selectors.selectCoordinateForDefaultIndex)(state, 'axis', 'hover', String(keyboardInteraction.index));
            listenerApi.dispatch((0, _tooltipSlice.setKeyboardInteraction)({
                active: !keyboardInteraction.active,
                activeIndex: keyboardInteraction.index,
                activeCoordinate: _coordinate
            }));
            return;
        }
        var direction = (0, _axisSelectors.selectChartDirection)(state);
        var directionMultiplier = direction === 'left-to-right' ? 1 : -1;
        var movement = key === 'ArrowRight' ? 1 : -1;
        var nextIndex = currentIndex + movement * directionMultiplier;
        if (tooltipTicks == null || nextIndex >= tooltipTicks.length || nextIndex < 0) return;
        var coordinate = (0, _selectors.selectCoordinateForDefaultIndex)(state, 'axis', 'hover', String(nextIndex));
        listenerApi.dispatch((0, _tooltipSlice.setKeyboardInteraction)({
            active: true,
            activeIndex: nextIndex.toString(),
            activeCoordinate: coordinate
        }));
    }
});
keyboardEventsMiddleware.startListening({
    actionCreator: focusAction,
    effect: (_action, listenerApi)=>{
        var state = listenerApi.getState();
        var accessibilityLayerIsActive = state.rootProps.accessibilityLayer !== false;
        if (!accessibilityLayerIsActive) return;
        var { keyboardInteraction } = state.tooltip;
        if (keyboardInteraction.active) return;
        if (keyboardInteraction.index == null) {
            var nextIndex = '0';
            var coordinate = (0, _selectors.selectCoordinateForDefaultIndex)(state, 'axis', 'hover', String(nextIndex));
            listenerApi.dispatch((0, _tooltipSlice.setKeyboardInteraction)({
                active: true,
                activeIndex: nextIndex,
                activeCoordinate: coordinate
            }));
        }
    }
});

},{"@reduxjs/toolkit":"7hE98","./tooltipSlice":"8Jqu4","./selectors/tooltipSelectors":"hydW6","./selectors/selectors":"2uuUJ","./selectors/axisSelectors":"bvR8m","./selectors/combiners/combineActiveTooltipIndex":"f5Q8L","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Rhvy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "externalEventAction", ()=>externalEventAction);
parcelHelpers.export(exports, "externalEventsMiddleware", ()=>externalEventsMiddleware);
var _toolkit = require("@reduxjs/toolkit");
var _tooltipSelectors = require("./selectors/tooltipSelectors");
var externalEventAction = (0, _toolkit.createAction)('externalEvent');
var externalEventsMiddleware = (0, _toolkit.createListenerMiddleware)();
/*
 * We need a Map keyed by event type because this middleware handles MULTIPLE different event types
 * (click, mouseenter, mouseleave, mousedown, mouseup, contextmenu, dblclick, touchstart, touchmove, touchend)
 * from the same DOM element. Different event types should NOT cancel each other's animation frames.
 * For example, a click event and a mousemove event can happen in quick succession and both should be processed.
 * This is different from mouseMoveMiddleware which only handles one event type and uses a single rafId.
 */ var rafIdMap = new Map();
externalEventsMiddleware.startListening({
    actionCreator: externalEventAction,
    effect: (action, listenerApi)=>{
        var { handler, reactEvent } = action.payload;
        if (handler == null) return;
        reactEvent.persist();
        var eventType = reactEvent.type;
        // Cancel any pending animation frame for this event type
        var existingRafId = rafIdMap.get(eventType);
        if (existingRafId !== undefined) cancelAnimationFrame(existingRafId);
        var rafId = requestAnimationFrame(()=>{
            try {
                /*
         * Here it is important that we get the latest state inside the animation frame callback,
         * not from the outer scope, because there may have been other actions dispatched
         * between the time the event was fired and the animation frame callback is executed.
         * One of those actions is the one that actually sets the active tooltip state!
         */ var state = listenerApi.getState();
                var nextState = {
                    activeCoordinate: (0, _tooltipSelectors.selectActiveTooltipCoordinate)(state),
                    activeDataKey: (0, _tooltipSelectors.selectActiveTooltipDataKey)(state),
                    activeIndex: (0, _tooltipSelectors.selectActiveTooltipIndex)(state),
                    activeLabel: (0, _tooltipSelectors.selectActiveLabel)(state),
                    activeTooltipIndex: (0, _tooltipSelectors.selectActiveTooltipIndex)(state),
                    isTooltipActive: (0, _tooltipSelectors.selectIsTooltipActive)(state)
                };
                handler(nextState, reactEvent);
            } finally{
                rafIdMap.delete(eventType);
            }
        });
        rafIdMap.set(eventType, rafId);
    }
});

},{"@reduxjs/toolkit":"7hE98","./selectors/tooltipSelectors":"hydW6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Gqol":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "touchEventAction", ()=>touchEventAction);
parcelHelpers.export(exports, "touchEventMiddleware", ()=>touchEventMiddleware);
var _toolkit = require("@reduxjs/toolkit");
var _tooltipSlice = require("./tooltipSlice");
var _selectActivePropsFromChartPointer = require("./selectors/selectActivePropsFromChartPointer");
var _getChartPointer = require("../util/getChartPointer");
var _selectTooltipEventType = require("./selectors/selectTooltipEventType");
var _constants = require("../util/Constants");
var _touchSelectors = require("./selectors/touchSelectors");
var _tooltipSelectors = require("./selectors/tooltipSelectors");
var touchEventAction = (0, _toolkit.createAction)('touchMove');
var touchEventMiddleware = (0, _toolkit.createListenerMiddleware)();
touchEventMiddleware.startListening({
    actionCreator: touchEventAction,
    effect: (action, listenerApi)=>{
        var touchEvent = action.payload;
        if (touchEvent.touches == null || touchEvent.touches.length === 0) return;
        var state = listenerApi.getState();
        var tooltipEventType = (0, _selectTooltipEventType.selectTooltipEventType)(state, state.tooltip.settings.shared);
        if (tooltipEventType === 'axis') {
            var touch = touchEvent.touches[0];
            if (touch == null) return;
            var activeProps = (0, _selectActivePropsFromChartPointer.selectActivePropsFromChartPointer)(state, (0, _getChartPointer.getChartPointer)({
                clientX: touch.clientX,
                clientY: touch.clientY,
                currentTarget: touchEvent.currentTarget
            }));
            if ((activeProps === null || activeProps === void 0 ? void 0 : activeProps.activeIndex) != null) listenerApi.dispatch((0, _tooltipSlice.setMouseOverAxisIndex)({
                activeIndex: activeProps.activeIndex,
                activeDataKey: undefined,
                activeCoordinate: activeProps.activeCoordinate
            }));
        } else if (tooltipEventType === 'item') {
            var _target$getAttribute;
            var _touch = touchEvent.touches[0];
            if (document.elementFromPoint == null || _touch == null) return;
            var target = document.elementFromPoint(_touch.clientX, _touch.clientY);
            if (!target || !target.getAttribute) return;
            var itemIndex = target.getAttribute((0, _constants.DATA_ITEM_INDEX_ATTRIBUTE_NAME));
            var graphicalItemId = (_target$getAttribute = target.getAttribute((0, _constants.DATA_ITEM_GRAPHICAL_ITEM_ID_ATTRIBUTE_NAME))) !== null && _target$getAttribute !== void 0 ? _target$getAttribute : undefined;
            var settings = (0, _tooltipSelectors.selectAllGraphicalItemsSettings)(state).find((item)=>item.id === graphicalItemId);
            if (itemIndex == null || settings == null || graphicalItemId == null) return;
            var { dataKey } = settings;
            var coordinate = (0, _touchSelectors.selectTooltipCoordinate)(state, itemIndex, graphicalItemId);
            listenerApi.dispatch((0, _tooltipSlice.setActiveMouseOverItemIndex)({
                activeDataKey: dataKey,
                activeIndex: itemIndex,
                activeCoordinate: coordinate,
                activeGraphicalItemId: graphicalItemId
            }));
        }
    }
});

},{"@reduxjs/toolkit":"7hE98","./tooltipSlice":"8Jqu4","./selectors/selectActivePropsFromChartPointer":"hjsgY","../util/getChartPointer":"b9Vry","./selectors/selectTooltipEventType":"4RpEb","../util/Constants":"5DKvC","./selectors/touchSelectors":"5zRQA","./selectors/tooltipSelectors":"hydW6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5zRQA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectTooltipCoordinate", ()=>selectTooltipCoordinate);
var _reselect = require("reselect");
var _selectTooltipPayloadSearcher = require("./selectTooltipPayloadSearcher");
var _selectTooltipState = require("./selectTooltipState");
var selectAllTooltipPayloadConfiguration = (0, _reselect.createSelector)([
    (0, _selectTooltipState.selectTooltipState)
], (tooltipState)=>tooltipState.tooltipItemPayloads);
var selectTooltipCoordinate = (0, _reselect.createSelector)([
    selectAllTooltipPayloadConfiguration,
    (0, _selectTooltipPayloadSearcher.selectTooltipPayloadSearcher),
    (_state, tooltipIndex)=>tooltipIndex,
    (_state, _tooltipIndex, graphicalItemId)=>graphicalItemId
], (allTooltipConfigurations, tooltipPayloadSearcher, tooltipIndex, graphicalItemId)=>{
    var mostRelevantTooltipConfiguration = allTooltipConfigurations.find((tooltipConfiguration)=>{
        return tooltipConfiguration.settings.graphicalItemId === graphicalItemId;
    });
    if (mostRelevantTooltipConfiguration == null) return undefined;
    var { positions } = mostRelevantTooltipConfiguration;
    if (positions == null) return undefined;
    // @ts-expect-error tooltipPayloadSearcher is not typed well
    var maybePosition = tooltipPayloadSearcher(positions, tooltipIndex);
    return maybePosition;
});

},{"reselect":"ds2su","./selectTooltipPayloadSearcher":"i7xdk","./selectTooltipState":"XQ7NK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eFUkf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChartDataContextProvider", ()=>ChartDataContextProvider);
parcelHelpers.export(exports, "SetComputedData", ()=>SetComputedData);
parcelHelpers.export(exports, "useChartData", ()=>useChartData);
parcelHelpers.export(exports, "useDataIndex", ()=>useDataIndex);
var _react = require("react");
var _chartDataSlice = require("../state/chartDataSlice");
var _hooks = require("../state/hooks");
var _panoramaContext = require("./PanoramaContext");
var ChartDataContextProvider = (props)=>{
    var { chartData } = props;
    var dispatch = (0, _hooks.useAppDispatch)();
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    (0, _react.useEffect)(()=>{
        if (isPanorama) // Panorama mode reuses data from the main chart, so we must not overwrite it here.
        return ()=>{
        // there is nothing to clean up
        };
        dispatch((0, _chartDataSlice.setChartData)(chartData));
        return ()=>{
            dispatch((0, _chartDataSlice.setChartData)(undefined));
        };
    }, [
        chartData,
        dispatch,
        isPanorama
    ]);
    return null;
};
var SetComputedData = (props)=>{
    var { computedData } = props;
    var dispatch = (0, _hooks.useAppDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _chartDataSlice.setComputedData)(computedData));
        return ()=>{
            dispatch((0, _chartDataSlice.setChartData)(undefined));
        };
    }, [
        computedData,
        dispatch
    ]);
    return null;
};
var selectChartData = (state)=>state.chartData.chartData;
var useChartData = ()=>(0, _hooks.useAppSelector)(selectChartData);
var selectDataIndex = (state)=>{
    var { dataStartIndex, dataEndIndex } = state.chartData;
    return {
        startIndex: dataStartIndex,
        endIndex: dataEndIndex
    };
};
var useDataIndex = ()=>{
    return (0, _hooks.useAppSelector)(selectDataIndex);
};

},{"react":"bmhQu","../state/chartDataSlice":"8sqTx","../state/hooks":"aEuxu","./PanoramaContext":"10hMm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kt6OZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportMainChartProps", ()=>ReportMainChartProps);
var _react = require("react");
var _panoramaContext = require("../context/PanoramaContext");
var _layoutSlice = require("./layoutSlice");
var _hooks = require("./hooks");
var _propsAreEqual = require("../util/propsAreEqual");
/**
 * "Main" props are props that are only accepted on the main chart,
 * as opposed to the small panorama chart inside a Brush.
 */ function ReportMainChartPropsImpl(_ref) {
    var { layout, margin } = _ref;
    var dispatch = (0, _hooks.useAppDispatch)();
    /*
   * Skip dispatching properties in panorama chart for two reasons:
   * 1. The root chart should be deciding on these properties, and
   * 2. Brush reads these properties from redux store, and so they must remain stable
   *      to avoid circular dependency and infinite re-rendering.
   */ var isPanorama = (0, _panoramaContext.useIsPanorama)();
    /*
   * useEffect here is required to avoid the "Cannot update a component while rendering a different component" error.
   * https://github.com/facebook/react/issues/18178
   *
   * Reported in https://github.com/recharts/recharts/issues/5514
   */ (0, _react.useEffect)(()=>{
        if (!isPanorama) {
            dispatch((0, _layoutSlice.setLayout)(layout));
            dispatch((0, _layoutSlice.setMargin)(margin));
        }
    }, [
        dispatch,
        isPanorama,
        layout,
        margin
    ]);
    return null;
}
var ReportMainChartProps = /*#__PURE__*/ (0, _react.memo)(ReportMainChartPropsImpl, (0, _propsAreEqual.propsAreEqual));

},{"react":"bmhQu","../context/PanoramaContext":"10hMm","./layoutSlice":"gG6kT","./hooks":"aEuxu","../util/propsAreEqual":"eGfhC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jQD2P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportChartProps", ()=>ReportChartProps);
var _react = require("react");
var _rootPropsSlice = require("./rootPropsSlice");
var _hooks = require("./hooks");
function ReportChartProps(props) {
    var dispatch = (0, _hooks.useAppDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _rootPropsSlice.updateOptions)(props));
    }, [
        dispatch,
        props
    ]);
    return null;
}

},{"react":"bmhQu","./rootPropsSlice":"Gj7Dt","./hooks":"aEuxu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Ugve":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CategoricalChart", ()=>CategoricalChart);
var _react = require("react");
var _rootSurface = require("../container/RootSurface");
var _rechartsWrapper = require("./RechartsWrapper");
var _clipPathProvider = require("../container/ClipPathProvider");
var _svgPropertiesNoEvents = require("../util/svgPropertiesNoEvents");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _excluded = [
    "width",
    "height",
    "responsive",
    "children",
    "className",
    "style",
    "compact",
    "title",
    "desc"
];
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var CategoricalChart = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    var { width, height, responsive, children, className, style, compact, title, desc } = props, others = _objectWithoutProperties(props, _excluded);
    var attrs = (0, _svgPropertiesNoEvents.svgPropertiesNoEvents)(others);
    /*
   * The "compact" mode is used as the panorama within Brush.
   * However because `compact` is a public prop, let's assume that it can render outside of Brush too.
   */ if (compact) return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _chartLayoutContext.ReportChartSize), {
        width: width,
        height: height
    }), /*#__PURE__*/ _react.createElement((0, _rootSurface.RootSurface), {
        otherAttributes: attrs,
        title: title,
        desc: desc
    }, children));
    return /*#__PURE__*/ _react.createElement((0, _rechartsWrapper.RechartsWrapper), {
        className: className,
        style: style,
        width: width,
        height: height,
        responsive: responsive !== null && responsive !== void 0 ? responsive : false,
        onClick: props.onClick,
        onMouseLeave: props.onMouseLeave,
        onMouseEnter: props.onMouseEnter,
        onMouseMove: props.onMouseMove,
        onMouseDown: props.onMouseDown,
        onMouseUp: props.onMouseUp,
        onContextMenu: props.onContextMenu,
        onDoubleClick: props.onDoubleClick,
        onTouchStart: props.onTouchStart,
        onTouchMove: props.onTouchMove,
        onTouchEnd: props.onTouchEnd
    }, /*#__PURE__*/ _react.createElement((0, _rootSurface.RootSurface), {
        otherAttributes: attrs,
        title: title,
        desc: desc,
        ref: ref
    }, /*#__PURE__*/ _react.createElement((0, _clipPathProvider.ClipPathProvider), null, children)));
});

},{"react":"bmhQu","../container/RootSurface":"8g7Xe","./RechartsWrapper":"jM7qK","../container/ClipPathProvider":"cnICI","../util/svgPropertiesNoEvents":"2NZlZ","../context/chartLayoutContext":"jIUyy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8g7Xe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RootSurface", ()=>RootSurface);
var _react = require("react");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _accessibilityContext = require("../context/accessibilityContext");
var _panoramaContext = require("../context/PanoramaContext");
var _surface = require("./Surface");
var _hooks = require("../state/hooks");
var _brushSelectors = require("../state/selectors/brushSelectors");
var _isWellBehavedNumber = require("../util/isWellBehavedNumber");
var _zindexPortal = require("../zIndex/ZIndexPortal");
var _excluded = [
    "children"
];
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var FULL_WIDTH_AND_HEIGHT = {
    width: '100%',
    height: '100%',
    /*
   * display: block is necessary here because the default for an SVG is display: inline,
   * which in some browsers (Chrome) adds a little bit of extra space above and below the SVG
   * to make space for the descender of letters like "g" and "y". This throws off the height calculation
   * and causes the container to grow indefinitely on each render with responsive=true.
   * Display: block removes that extra space.
   *
   * Interestingly, Firefox does not have this problem, but it doesn't hurt to add the style anyway.
   */ display: 'block'
};
var MainChartSurface = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    var width = (0, _chartLayoutContext.useChartWidth)();
    var height = (0, _chartLayoutContext.useChartHeight)();
    var hasAccessibilityLayer = (0, _accessibilityContext.useAccessibilityLayer)();
    if (!(0, _isWellBehavedNumber.isPositiveNumber)(width) || !(0, _isWellBehavedNumber.isPositiveNumber)(height)) return null;
    var { children, otherAttributes, title, desc } = props;
    var tabIndex, role;
    if (otherAttributes != null) {
        if (typeof otherAttributes.tabIndex === 'number') tabIndex = otherAttributes.tabIndex;
        else tabIndex = hasAccessibilityLayer ? 0 : undefined;
        if (typeof otherAttributes.role === 'string') role = otherAttributes.role;
        else role = hasAccessibilityLayer ? 'application' : undefined;
    }
    return /*#__PURE__*/ _react.createElement((0, _surface.Surface), _extends({}, otherAttributes, {
        title: title,
        desc: desc,
        role: role,
        tabIndex: tabIndex,
        width: width,
        height: height,
        style: FULL_WIDTH_AND_HEIGHT,
        ref: ref
    }), children);
});
var BrushPanoramaSurface = (_ref)=>{
    var { children } = _ref;
    var brushDimensions = (0, _hooks.useAppSelector)((0, _brushSelectors.selectBrushDimensions));
    if (!brushDimensions) return null;
    var { width, height, y, x } = brushDimensions;
    return /*#__PURE__*/ _react.createElement((0, _surface.Surface), {
        width: width,
        height: height,
        x: x,
        y: y
    }, children);
};
var RootSurface = /*#__PURE__*/ (0, _react.forwardRef)((_ref2, ref)=>{
    var { children } = _ref2, rest = _objectWithoutProperties(_ref2, _excluded);
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    if (isPanorama) return /*#__PURE__*/ _react.createElement(BrushPanoramaSurface, null, /*#__PURE__*/ _react.createElement((0, _zindexPortal.AllZIndexPortals), {
        isPanorama: true
    }, children));
    return /*#__PURE__*/ _react.createElement(MainChartSurface, _extends({
        ref: ref
    }, rest), /*#__PURE__*/ _react.createElement((0, _zindexPortal.AllZIndexPortals), {
        isPanorama: false
    }, children));
});

},{"react":"bmhQu","../context/chartLayoutContext":"jIUyy","../context/accessibilityContext":"18E6N","../context/PanoramaContext":"10hMm","./Surface":"9NZXr","../state/hooks":"aEuxu","../state/selectors/brushSelectors":"3YEO3","../util/isWellBehavedNumber":"aIsFR","../zIndex/ZIndexPortal":"j0LhQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"18E6N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useAccessibilityLayer", ()=>useAccessibilityLayer);
var _hooks = require("../state/hooks");
var useAccessibilityLayer = ()=>{
    var _useAppSelector;
    return (_useAppSelector = (0, _hooks.useAppSelector)((state)=>state.rootProps.accessibilityLayer)) !== null && _useAppSelector !== void 0 ? _useAppSelector : true;
};

},{"../state/hooks":"aEuxu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9NZXr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Surface", ()=>Surface);
/**
 * @fileOverview Surface
 */ var _react = require("react");
var _clsx = require("clsx");
var _svgPropertiesAndEvents = require("../util/svgPropertiesAndEvents");
var _excluded = [
    "children",
    "width",
    "height",
    "viewBox",
    "className",
    "style",
    "title",
    "desc"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var Surface = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    var { children, width, height, viewBox, className, style, title, desc } = props, others = _objectWithoutProperties(props, _excluded);
    var svgView = viewBox || {
        width,
        height,
        x: 0,
        y: 0
    };
    var layerClass = (0, _clsx.clsx)('recharts-surface', className);
    return /*#__PURE__*/ _react.createElement("svg", _extends({}, (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(others), {
        className: layerClass,
        width: width,
        height: height,
        style: style,
        viewBox: "".concat(svgView.x, " ").concat(svgView.y, " ").concat(svgView.width, " ").concat(svgView.height),
        ref: ref
    }), /*#__PURE__*/ _react.createElement("title", null, title), /*#__PURE__*/ _react.createElement("desc", null, desc), children);
});

},{"react":"bmhQu","clsx":"431Ou","../util/svgPropertiesAndEvents":"6bogn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j0LhQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AllZIndexPortals", ()=>AllZIndexPortals);
var _react = require("react");
var _hooks = require("../state/hooks");
var _zIndexSlice = require("../state/zIndexSlice");
var _zIndexSelectors = require("./zIndexSelectors");
function ZIndexSvgPortal(_ref) {
    var { zIndex, isPanorama } = _ref;
    var ref = (0, _react.useRef)(null);
    var dispatch = (0, _hooks.useAppDispatch)();
    (0, _react.useLayoutEffect)(()=>{
        if (ref.current) dispatch((0, _zIndexSlice.registerZIndexPortalElement)({
            zIndex,
            element: ref.current,
            isPanorama
        }));
        return ()=>{
            dispatch((0, _zIndexSlice.unregisterZIndexPortalElement)({
                zIndex,
                isPanorama
            }));
        };
    }, [
        dispatch,
        zIndex,
        isPanorama
    ]);
    // these g elements should not be tabbable
    return /*#__PURE__*/ _react.createElement("g", {
        tabIndex: -1,
        ref: ref
    });
}
function AllZIndexPortals(_ref2) {
    var { children, isPanorama } = _ref2;
    var allRegisteredZIndexes = (0, _hooks.useAppSelector)((0, _zIndexSelectors.selectAllRegisteredZIndexes));
    if (!allRegisteredZIndexes || allRegisteredZIndexes.length === 0) return children;
    var allNegativeZIndexes = allRegisteredZIndexes.filter((zIndex)=>zIndex < 0);
    // We exclude zero on purpose - that is the default layer, and it doesn't need a portal.
    var allPositiveZIndexes = allRegisteredZIndexes.filter((zIndex)=>zIndex > 0);
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, allNegativeZIndexes.map((zIndex)=>/*#__PURE__*/ _react.createElement(ZIndexSvgPortal, {
            key: zIndex,
            zIndex: zIndex,
            isPanorama: isPanorama
        })), children, allPositiveZIndexes.map((zIndex)=>/*#__PURE__*/ _react.createElement(ZIndexSvgPortal, {
            key: zIndex,
            zIndex: zIndex,
            isPanorama: isPanorama
        })));
}

},{"react":"bmhQu","../state/hooks":"aEuxu","../state/zIndexSlice":"haK2y","./zIndexSelectors":"bBgaU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jM7qK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RechartsWrapper", ()=>RechartsWrapper);
var _react = require("react");
var _clsx = require("clsx");
var _tooltipSlice = require("../state/tooltipSlice");
var _hooks = require("../state/hooks");
var _mouseEventsMiddleware = require("../state/mouseEventsMiddleware");
var _useChartSynchronisation = require("../synchronisation/useChartSynchronisation");
var _keyboardEventsMiddleware = require("../state/keyboardEventsMiddleware");
var _useReportScale = require("../util/useReportScale");
var _externalEventsMiddleware = require("../state/externalEventsMiddleware");
var _touchEventsMiddleware = require("../state/touchEventsMiddleware");
var _tooltipPortalContext = require("../context/tooltipPortalContext");
var _legendPortalContext = require("../context/legendPortalContext");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _responsiveContainer = require("../component/ResponsiveContainer");
var _dataUtils = require("../util/DataUtils");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var EventSynchronizer = ()=>{
    (0, _useChartSynchronisation.useSynchronisedEventsFromOtherCharts)();
    return null;
};
function getNumberOrZero(value) {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
        var parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) return parsed;
    }
    return 0;
}
var ResponsiveDiv = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    var _props$style, _props$style2;
    var observerRef = (0, _react.useRef)(null);
    var [sizes, setSizes] = (0, _react.useState)({
        containerWidth: getNumberOrZero((_props$style = props.style) === null || _props$style === void 0 ? void 0 : _props$style.width),
        containerHeight: getNumberOrZero((_props$style2 = props.style) === null || _props$style2 === void 0 ? void 0 : _props$style2.height)
    });
    var setContainerSize = (0, _react.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    var innerRef = (0, _react.useCallback)((node)=>{
        if (typeof ref === 'function') ref(node);
        if (node != null && typeof ResizeObserver !== 'undefined') {
            var { width: containerWidth, height: containerHeight } = node.getBoundingClientRect();
            setContainerSize(containerWidth, containerHeight);
            var callback = (entries)=>{
                var { width, height } = entries[0].contentRect;
                setContainerSize(width, height);
            };
            var observer = new ResizeObserver(callback);
            observer.observe(node);
            observerRef.current = observer;
        }
    }, [
        ref,
        setContainerSize
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            var observer = observerRef.current;
            if (observer != null) observer.disconnect();
        };
    }, [
        setContainerSize
    ]);
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _chartLayoutContext.ReportChartSize), {
        width: sizes.containerWidth,
        height: sizes.containerHeight
    }), /*#__PURE__*/ _react.createElement("div", _extends({
        ref: innerRef
    }, props)));
});
var ReadSizeOnceDiv = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    var { width, height } = props;
    var [sizes, setSizes] = (0, _react.useState)({
        containerWidth: getNumberOrZero(width),
        containerHeight: getNumberOrZero(height)
    });
    var setContainerSize = (0, _react.useCallback)((newWidth, newHeight)=>{
        setSizes((prevState)=>{
            var roundedWidth = Math.round(newWidth);
            var roundedHeight = Math.round(newHeight);
            if (prevState.containerWidth === roundedWidth && prevState.containerHeight === roundedHeight) return prevState;
            return {
                containerWidth: roundedWidth,
                containerHeight: roundedHeight
            };
        });
    }, []);
    var innerRef = (0, _react.useCallback)((node)=>{
        if (typeof ref === 'function') ref(node);
        if (node != null) {
            var { width: containerWidth, height: containerHeight } = node.getBoundingClientRect();
            setContainerSize(containerWidth, containerHeight);
        }
    }, [
        ref,
        setContainerSize
    ]);
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _chartLayoutContext.ReportChartSize), {
        width: sizes.containerWidth,
        height: sizes.containerHeight
    }), /*#__PURE__*/ _react.createElement("div", _extends({
        ref: innerRef
    }, props)));
});
var StaticDiv = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    var { width, height } = props;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _chartLayoutContext.ReportChartSize), {
        width: width,
        height: height
    }), /*#__PURE__*/ _react.createElement("div", _extends({
        ref: ref
    }, props)));
});
var NonResponsiveDiv = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    var { width, height } = props;
    if ((0, _dataUtils.isPercent)(width) || (0, _dataUtils.isPercent)(height)) return /*#__PURE__*/ _react.createElement(ReadSizeOnceDiv, _extends({}, props, {
        ref: ref
    }));
    return /*#__PURE__*/ _react.createElement(StaticDiv, _extends({}, props, {
        ref: ref
    }));
});
function getWrapperDivComponent(responsive) {
    return responsive === true ? ResponsiveDiv : NonResponsiveDiv;
}
var RechartsWrapper = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    var { children, className, height: heightFromProps, onClick, onContextMenu, onDoubleClick, onMouseDown, onMouseEnter, onMouseLeave, onMouseMove, onMouseUp, onTouchEnd, onTouchMove, onTouchStart, style, width: widthFromProps, responsive, dispatchTouchEvents = true } = props;
    var containerRef = (0, _react.useRef)(null);
    var dispatch = (0, _hooks.useAppDispatch)();
    var [tooltipPortal, setTooltipPortal] = (0, _react.useState)(null);
    var [legendPortal, setLegendPortal] = (0, _react.useState)(null);
    var setScaleRef = (0, _useReportScale.useReportScale)();
    var responsiveContainerCalculations = (0, _responsiveContainer.useResponsiveContainerContext)();
    var width = (responsiveContainerCalculations === null || responsiveContainerCalculations === void 0 ? void 0 : responsiveContainerCalculations.width) > 0 ? responsiveContainerCalculations.width : widthFromProps;
    var height = (responsiveContainerCalculations === null || responsiveContainerCalculations === void 0 ? void 0 : responsiveContainerCalculations.height) > 0 ? responsiveContainerCalculations.height : heightFromProps;
    var innerRef = (0, _react.useCallback)((node)=>{
        setScaleRef(node);
        if (typeof ref === 'function') ref(node);
        setTooltipPortal(node);
        setLegendPortal(node);
        if (node != null) containerRef.current = node;
    }, [
        setScaleRef,
        ref,
        setTooltipPortal,
        setLegendPortal
    ]);
    var myOnClick = (0, _react.useCallback)((e)=>{
        dispatch((0, _mouseEventsMiddleware.mouseClickAction)(e));
        dispatch((0, _externalEventsMiddleware.externalEventAction)({
            handler: onClick,
            reactEvent: e
        }));
    }, [
        dispatch,
        onClick
    ]);
    var myOnMouseEnter = (0, _react.useCallback)((e)=>{
        dispatch((0, _mouseEventsMiddleware.mouseMoveAction)(e));
        dispatch((0, _externalEventsMiddleware.externalEventAction)({
            handler: onMouseEnter,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseEnter
    ]);
    var myOnMouseLeave = (0, _react.useCallback)((e)=>{
        dispatch((0, _tooltipSlice.mouseLeaveChart)());
        dispatch((0, _externalEventsMiddleware.externalEventAction)({
            handler: onMouseLeave,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseLeave
    ]);
    var myOnMouseMove = (0, _react.useCallback)((e)=>{
        dispatch((0, _mouseEventsMiddleware.mouseMoveAction)(e));
        dispatch((0, _externalEventsMiddleware.externalEventAction)({
            handler: onMouseMove,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseMove
    ]);
    var onFocus = (0, _react.useCallback)(()=>{
        dispatch((0, _keyboardEventsMiddleware.focusAction)());
    }, [
        dispatch
    ]);
    var onKeyDown = (0, _react.useCallback)((e)=>{
        dispatch((0, _keyboardEventsMiddleware.keyDownAction)(e.key));
    }, [
        dispatch
    ]);
    var myOnContextMenu = (0, _react.useCallback)((e)=>{
        dispatch((0, _externalEventsMiddleware.externalEventAction)({
            handler: onContextMenu,
            reactEvent: e
        }));
    }, [
        dispatch,
        onContextMenu
    ]);
    var myOnDoubleClick = (0, _react.useCallback)((e)=>{
        dispatch((0, _externalEventsMiddleware.externalEventAction)({
            handler: onDoubleClick,
            reactEvent: e
        }));
    }, [
        dispatch,
        onDoubleClick
    ]);
    var myOnMouseDown = (0, _react.useCallback)((e)=>{
        dispatch((0, _externalEventsMiddleware.externalEventAction)({
            handler: onMouseDown,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseDown
    ]);
    var myOnMouseUp = (0, _react.useCallback)((e)=>{
        dispatch((0, _externalEventsMiddleware.externalEventAction)({
            handler: onMouseUp,
            reactEvent: e
        }));
    }, [
        dispatch,
        onMouseUp
    ]);
    var myOnTouchStart = (0, _react.useCallback)((e)=>{
        dispatch((0, _externalEventsMiddleware.externalEventAction)({
            handler: onTouchStart,
            reactEvent: e
        }));
    }, [
        dispatch,
        onTouchStart
    ]);
    /*
   * onTouchMove is special because it behaves different from mouse events.
   * Mouse events have 'enter' + 'leave' combo that notify us when the mouse is over
   * a certain element. Touch events don't have that; touch only gives us
   * start (finger down), end (finger up) and move (finger moving).
   * So we need to figure out which element the user is touching
   * ourselves. Fortunately, there's a convenient method for that:
   * https://developer.mozilla.org/en-US/docs/Web/API/Document/elementFromPoint
   */ var myOnTouchMove = (0, _react.useCallback)((e)=>{
        if (dispatchTouchEvents) dispatch((0, _touchEventsMiddleware.touchEventAction)(e));
        dispatch((0, _externalEventsMiddleware.externalEventAction)({
            handler: onTouchMove,
            reactEvent: e
        }));
    }, [
        dispatch,
        dispatchTouchEvents,
        onTouchMove
    ]);
    var myOnTouchEnd = (0, _react.useCallback)((e)=>{
        dispatch((0, _externalEventsMiddleware.externalEventAction)({
            handler: onTouchEnd,
            reactEvent: e
        }));
    }, [
        dispatch,
        onTouchEnd
    ]);
    var WrapperDiv = getWrapperDivComponent(responsive);
    return /*#__PURE__*/ _react.createElement((0, _tooltipPortalContext.TooltipPortalContext).Provider, {
        value: tooltipPortal
    }, /*#__PURE__*/ _react.createElement((0, _legendPortalContext.LegendPortalContext).Provider, {
        value: legendPortal
    }, /*#__PURE__*/ _react.createElement(WrapperDiv, {
        width: width !== null && width !== void 0 ? width : style === null || style === void 0 ? void 0 : style.width,
        height: height !== null && height !== void 0 ? height : style === null || style === void 0 ? void 0 : style.height,
        className: (0, _clsx.clsx)('recharts-wrapper', className),
        style: _objectSpread({
            position: 'relative',
            cursor: 'default',
            width,
            height
        }, style),
        onClick: myOnClick,
        onContextMenu: myOnContextMenu,
        onDoubleClick: myOnDoubleClick,
        onFocus: onFocus,
        onKeyDown: onKeyDown,
        onMouseDown: myOnMouseDown,
        onMouseEnter: myOnMouseEnter,
        onMouseLeave: myOnMouseLeave,
        onMouseMove: myOnMouseMove,
        onMouseUp: myOnMouseUp,
        onTouchEnd: myOnTouchEnd,
        onTouchMove: myOnTouchMove,
        onTouchStart: myOnTouchStart,
        ref: innerRef
    }, /*#__PURE__*/ _react.createElement(EventSynchronizer, null), children)));
});

},{"react":"bmhQu","clsx":"431Ou","../state/tooltipSlice":"8Jqu4","../state/hooks":"aEuxu","../state/mouseEventsMiddleware":"cI47t","../synchronisation/useChartSynchronisation":"hqM1z","../state/keyboardEventsMiddleware":"bcdow","../util/useReportScale":"zqVb2","../state/externalEventsMiddleware":"2Rhvy","../state/touchEventsMiddleware":"1Gqol","../context/tooltipPortalContext":"IPMrJ","../context/legendPortalContext":"4cmHF","../context/chartLayoutContext":"jIUyy","../component/ResponsiveContainer":"7epZf","../util/DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hqM1z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Will receive synchronisation events from other charts.
 *
 * Reads syncMethod from state and decides how to synchronise the tooltip based on that.
 *
 * @returns void
 */ parcelHelpers.export(exports, "useSynchronisedEventsFromOtherCharts", ()=>useSynchronisedEventsFromOtherCharts);
/**
 * Will send events to other charts.
 * If syncId is undefined, no events will be sent.
 *
 * This ignores the syncMethod, because that is set and computed on the receiving end.
 *
 * @param tooltipEventType from Tooltip
 * @param trigger from Tooltip
 * @param activeCoordinate from state
 * @param activeLabel from state
 * @param activeIndex from state
 * @param isTooltipActive from state
 * @returns void
 */ parcelHelpers.export(exports, "useTooltipChartSynchronisation", ()=>useTooltipChartSynchronisation);
parcelHelpers.export(exports, "useBrushChartSynchronisation", ()=>useBrushChartSynchronisation);
var _react = require("react");
var _hooks = require("../state/hooks");
var _rootPropsSelectors = require("../state/selectors/rootPropsSelectors");
var _events = require("../util/Events");
var _optionsSlice = require("../state/optionsSlice");
var _tooltipSlice = require("../state/tooltipSlice");
var _selectors = require("../state/selectors/selectors");
var _tooltipSelectors = require("../state/selectors/tooltipSelectors");
var _syncSelectors = require("./syncSelectors");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _chartDataSlice = require("../state/chartDataSlice");
var _dataUtils = require("../util/DataUtils");
var _excluded = [
    "x",
    "y"
];
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function useTooltipSyncEventsListener() {
    var mySyncId = (0, _hooks.useAppSelector)((0, _rootPropsSelectors.selectSyncId));
    var myEventEmitter = (0, _hooks.useAppSelector)((0, _rootPropsSelectors.selectEventEmitter));
    var dispatch = (0, _hooks.useAppDispatch)();
    var syncMethod = (0, _hooks.useAppSelector)((0, _rootPropsSelectors.selectSyncMethod));
    var tooltipTicks = (0, _hooks.useAppSelector)((0, _tooltipSelectors.selectTooltipAxisTicks));
    var layout = (0, _chartLayoutContext.useChartLayout)();
    var viewBox = (0, _chartLayoutContext.useViewBox)();
    var className = (0, _hooks.useAppSelector)((state)=>state.rootProps.className);
    (0, _react.useEffect)(()=>{
        if (mySyncId == null) // This chart is not synchronised with any other chart so we don't need to listen for any events.
        return 0, _dataUtils.noop;
        var listener = (incomingSyncId, action, emitter)=>{
            if (myEventEmitter === emitter) // We don't want to dispatch actions that we sent ourselves.
            return;
            if (mySyncId !== incomingSyncId) // This event is not for this chart
            return;
            if (syncMethod === 'index') {
                var _action$payload;
                if (viewBox && action !== null && action !== void 0 && (_action$payload = action.payload) !== null && _action$payload !== void 0 && _action$payload.coordinate && action.payload.sourceViewBox) {
                    var _action$payload$coord = action.payload.coordinate, { x: _x, y: _y } = _action$payload$coord, otherCoordinateProps = _objectWithoutProperties(_action$payload$coord, _excluded);
                    var { x: sourceX, y: sourceY, width: sourceWidth, height: sourceHeight } = action.payload.sourceViewBox;
                    var scaledCoordinate = _objectSpread(_objectSpread({}, otherCoordinateProps), {}, {
                        x: viewBox.x + (sourceWidth ? (_x - sourceX) / sourceWidth : 0) * viewBox.width,
                        y: viewBox.y + (sourceHeight ? (_y - sourceY) / sourceHeight : 0) * viewBox.height
                    });
                    dispatch(_objectSpread(_objectSpread({}, action), {}, {
                        payload: _objectSpread(_objectSpread({}, action.payload), {}, {
                            coordinate: scaledCoordinate
                        })
                    }));
                } else dispatch(action);
                return;
            }
            if (tooltipTicks == null) // for the other two sync methods, we need the ticks to be available
            return;
            var activeTick;
            if (typeof syncMethod === 'function') {
                /*
         * This is what the data shape in 2.x CategoricalChartState used to look like.
         * In 3.x we store things differently but let's try to keep the old shape for compatibility.
         */ var syncMethodParam = {
                    activeTooltipIndex: action.payload.index == null ? undefined : Number(action.payload.index),
                    isTooltipActive: action.payload.active,
                    activeIndex: action.payload.index == null ? undefined : Number(action.payload.index),
                    activeLabel: action.payload.label,
                    activeDataKey: action.payload.dataKey,
                    activeCoordinate: action.payload.coordinate
                };
                // Call a callback function. If there is an application specific algorithm
                var activeTooltipIndex = syncMethod(tooltipTicks, syncMethodParam);
                activeTick = tooltipTicks[activeTooltipIndex];
            } else if (syncMethod === 'value') // labels are always strings, tick.value might be a string or a number, depending on axis type
            activeTick = tooltipTicks.find((tick)=>String(tick.value) === action.payload.label);
            var { coordinate } = action.payload;
            if (activeTick == null || action.payload.active === false || coordinate == null || viewBox == null) {
                dispatch((0, _tooltipSlice.setSyncInteraction)({
                    active: false,
                    coordinate: undefined,
                    dataKey: undefined,
                    index: null,
                    label: undefined,
                    sourceViewBox: undefined,
                    graphicalItemId: undefined
                }));
                return;
            }
            var { x, y } = coordinate;
            var validateChartX = Math.min(x, viewBox.x + viewBox.width);
            var validateChartY = Math.min(y, viewBox.y + viewBox.height);
            var activeCoordinate = {
                x: layout === 'horizontal' ? activeTick.coordinate : validateChartX,
                y: layout === 'horizontal' ? validateChartY : activeTick.coordinate
            };
            var syncAction = (0, _tooltipSlice.setSyncInteraction)({
                active: action.payload.active,
                coordinate: activeCoordinate,
                dataKey: action.payload.dataKey,
                index: String(activeTick.index),
                label: action.payload.label,
                sourceViewBox: action.payload.sourceViewBox,
                graphicalItemId: action.payload.graphicalItemId
            });
            dispatch(syncAction);
        };
        (0, _events.eventCenter).on((0, _events.TOOLTIP_SYNC_EVENT), listener);
        return ()=>{
            (0, _events.eventCenter).off((0, _events.TOOLTIP_SYNC_EVENT), listener);
        };
    }, [
        className,
        dispatch,
        myEventEmitter,
        mySyncId,
        syncMethod,
        tooltipTicks,
        layout,
        viewBox
    ]);
}
function useBrushSyncEventsListener() {
    var mySyncId = (0, _hooks.useAppSelector)((0, _rootPropsSelectors.selectSyncId));
    var myEventEmitter = (0, _hooks.useAppSelector)((0, _rootPropsSelectors.selectEventEmitter));
    var dispatch = (0, _hooks.useAppDispatch)();
    (0, _react.useEffect)(()=>{
        if (mySyncId == null) // This chart is not synchronised with any other chart so we don't need to listen for any events.
        return 0, _dataUtils.noop;
        var listener = (incomingSyncId, action, emitter)=>{
            if (myEventEmitter === emitter) // We don't want to dispatch actions that we sent ourselves.
            return;
            if (mySyncId === incomingSyncId) dispatch((0, _chartDataSlice.setDataStartEndIndexes)(action));
        };
        (0, _events.eventCenter).on((0, _events.BRUSH_SYNC_EVENT), listener);
        return ()=>{
            (0, _events.eventCenter).off((0, _events.BRUSH_SYNC_EVENT), listener);
        };
    }, [
        dispatch,
        myEventEmitter,
        mySyncId
    ]);
}
function useSynchronisedEventsFromOtherCharts() {
    var dispatch = (0, _hooks.useAppDispatch)();
    (0, _react.useEffect)(()=>{
        dispatch((0, _optionsSlice.createEventEmitter)());
    }, [
        dispatch
    ]);
    useTooltipSyncEventsListener();
    useBrushSyncEventsListener();
}
function useTooltipChartSynchronisation(tooltipEventType, trigger, activeCoordinate, activeLabel, activeIndex, isTooltipActive) {
    var activeDataKey = (0, _hooks.useAppSelector)((state)=>(0, _selectors.selectTooltipDataKey)(state, tooltipEventType, trigger));
    var eventEmitterSymbol = (0, _hooks.useAppSelector)((0, _rootPropsSelectors.selectEventEmitter));
    var syncId = (0, _hooks.useAppSelector)((0, _rootPropsSelectors.selectSyncId));
    var syncMethod = (0, _hooks.useAppSelector)((0, _rootPropsSelectors.selectSyncMethod));
    var tooltipState = (0, _hooks.useAppSelector)((0, _syncSelectors.selectSynchronisedTooltipState));
    var isReceivingSynchronisation = tooltipState === null || tooltipState === void 0 ? void 0 : tooltipState.active;
    var viewBox = (0, _chartLayoutContext.useViewBox)();
    (0, _react.useEffect)(()=>{
        if (isReceivingSynchronisation) /*
       * This chart currently has active tooltip, synchronised from another chart.
       * Let's not send any outgoing synchronisation events while that's happening
       * to avoid infinite loops.
       */ return;
        if (syncId == null) /*
       * syncId is not set, means that this chart is not synchronised with any other chart,
       * means we don't need to send synchronisation events
       */ return;
        if (eventEmitterSymbol == null) /*
       * When using Recharts internal hooks and selectors outside charts context,
       * these properties will be undefined. Let's return silently instead of throwing an error.
       */ return;
        var syncAction = (0, _tooltipSlice.setSyncInteraction)({
            active: isTooltipActive,
            coordinate: activeCoordinate,
            dataKey: activeDataKey,
            index: activeIndex,
            label: typeof activeLabel === 'number' ? String(activeLabel) : activeLabel,
            sourceViewBox: viewBox,
            graphicalItemId: undefined
        });
        (0, _events.eventCenter).emit((0, _events.TOOLTIP_SYNC_EVENT), syncId, syncAction, eventEmitterSymbol);
    }, [
        isReceivingSynchronisation,
        activeCoordinate,
        activeDataKey,
        activeIndex,
        activeLabel,
        eventEmitterSymbol,
        syncId,
        syncMethod,
        isTooltipActive,
        viewBox
    ]);
}
function useBrushChartSynchronisation() {
    var syncId = (0, _hooks.useAppSelector)((0, _rootPropsSelectors.selectSyncId));
    var eventEmitterSymbol = (0, _hooks.useAppSelector)((0, _rootPropsSelectors.selectEventEmitter));
    var brushStartIndex = (0, _hooks.useAppSelector)((state)=>state.chartData.dataStartIndex);
    var brushEndIndex = (0, _hooks.useAppSelector)((state)=>state.chartData.dataEndIndex);
    (0, _react.useEffect)(()=>{
        if (syncId == null || brushStartIndex == null || brushEndIndex == null || eventEmitterSymbol == null) return;
        var syncAction = {
            startIndex: brushStartIndex,
            endIndex: brushEndIndex
        };
        (0, _events.eventCenter).emit((0, _events.BRUSH_SYNC_EVENT), syncId, syncAction, eventEmitterSymbol);
    }, [
        brushEndIndex,
        brushStartIndex,
        eventEmitterSymbol,
        syncId
    ]);
}

},{"react":"bmhQu","../state/hooks":"aEuxu","../state/selectors/rootPropsSelectors":"eYPte","../util/Events":"9loZl","../state/optionsSlice":"2vgjK","../state/tooltipSlice":"8Jqu4","../state/selectors/selectors":"2uuUJ","../state/selectors/tooltipSelectors":"hydW6","./syncSelectors":"hitnG","../context/chartLayoutContext":"jIUyy","../state/chartDataSlice":"8sqTx","../util/DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9loZl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "eventCenter", ()=>eventCenter);
parcelHelpers.export(exports, "TOOLTIP_SYNC_EVENT", ()=>TOOLTIP_SYNC_EVENT);
parcelHelpers.export(exports, "BRUSH_SYNC_EVENT", ()=>BRUSH_SYNC_EVENT);
var _eventemitter3 = require("eventemitter3");
var _eventemitter3Default = parcelHelpers.interopDefault(_eventemitter3);
var eventCenter = new (0, _eventemitter3Default.default)();
var TOOLTIP_SYNC_EVENT = 'recharts.syncEvent.tooltip';
var BRUSH_SYNC_EVENT = 'recharts.syncEvent.brush';

},{"eventemitter3":"g0kuJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g0kuJ":[function(require,module,exports,__globalThis) {
'use strict';
var has = Object.prototype.hasOwnProperty, prefix = '~';
/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */ function Events() {}
//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
    Events.prototype = Object.create(null);
    //
    // This hack is needed because the `__proto__` property is still inherited in
    // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
    //
    if (!new Events().__proto__) prefix = false;
}
/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */ function EE(fn, context, once) {
    this.fn = fn;
    this.context = context;
    this.once = once || false;
}
/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */ function addListener(emitter, event, fn, context, once) {
    if (typeof fn !== 'function') throw new TypeError('The listener must be a function');
    var listener = new EE(fn, context || emitter, once), evt = prefix ? prefix + event : event;
    if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
    else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
    else emitter._events[evt] = [
        emitter._events[evt],
        listener
    ];
    return emitter;
}
/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */ function clearEvent(emitter, evt) {
    if (--emitter._eventsCount === 0) emitter._events = new Events();
    else delete emitter._events[evt];
}
/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */ function EventEmitter() {
    this._events = new Events();
    this._eventsCount = 0;
}
/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */ EventEmitter.prototype.eventNames = function eventNames() {
    var names = [], events, name;
    if (this._eventsCount === 0) return names;
    for(name in events = this._events)if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
    if (Object.getOwnPropertySymbols) return names.concat(Object.getOwnPropertySymbols(events));
    return names;
};
/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */ EventEmitter.prototype.listeners = function listeners(event) {
    var evt = prefix ? prefix + event : event, handlers = this._events[evt];
    if (!handlers) return [];
    if (handlers.fn) return [
        handlers.fn
    ];
    for(var i = 0, l = handlers.length, ee = new Array(l); i < l; i++)ee[i] = handlers[i].fn;
    return ee;
};
/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */ EventEmitter.prototype.listenerCount = function listenerCount(event) {
    var evt = prefix ? prefix + event : event, listeners = this._events[evt];
    if (!listeners) return 0;
    if (listeners.fn) return 1;
    return listeners.length;
};
/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */ EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return false;
    var listeners = this._events[evt], len = arguments.length, args, i;
    if (listeners.fn) {
        if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
        switch(len){
            case 1:
                return listeners.fn.call(listeners.context), true;
            case 2:
                return listeners.fn.call(listeners.context, a1), true;
            case 3:
                return listeners.fn.call(listeners.context, a1, a2), true;
            case 4:
                return listeners.fn.call(listeners.context, a1, a2, a3), true;
            case 5:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
            case 6:
                return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
        }
        for(i = 1, args = new Array(len - 1); i < len; i++)args[i - 1] = arguments[i];
        listeners.fn.apply(listeners.context, args);
    } else {
        var length = listeners.length, j;
        for(i = 0; i < length; i++){
            if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
            switch(len){
                case 1:
                    listeners[i].fn.call(listeners[i].context);
                    break;
                case 2:
                    listeners[i].fn.call(listeners[i].context, a1);
                    break;
                case 3:
                    listeners[i].fn.call(listeners[i].context, a1, a2);
                    break;
                case 4:
                    listeners[i].fn.call(listeners[i].context, a1, a2, a3);
                    break;
                default:
                    if (!args) for(j = 1, args = new Array(len - 1); j < len; j++)args[j - 1] = arguments[j];
                    listeners[i].fn.apply(listeners[i].context, args);
            }
        }
    }
    return true;
};
/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.on = function on(event, fn, context) {
    return addListener(this, event, fn, context, false);
};
/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.once = function once(event, fn, context) {
    return addListener(this, event, fn, context, true);
};
/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
    var evt = prefix ? prefix + event : event;
    if (!this._events[evt]) return this;
    if (!fn) {
        clearEvent(this, evt);
        return this;
    }
    var listeners = this._events[evt];
    if (listeners.fn) {
        if (listeners.fn === fn && (!once || listeners.once) && (!context || listeners.context === context)) clearEvent(this, evt);
    } else {
        for(var i = 0, events = [], length = listeners.length; i < length; i++)if (listeners[i].fn !== fn || once && !listeners[i].once || context && listeners[i].context !== context) events.push(listeners[i]);
        //
        // Reset the array, or remove it completely if we have no more listeners.
        //
        if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
        else clearEvent(this, evt);
    }
    return this;
};
/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */ EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
    var evt;
    if (event) {
        evt = prefix ? prefix + event : event;
        if (this._events[evt]) clearEvent(this, evt);
    } else {
        this._events = new Events();
        this._eventsCount = 0;
    }
    return this;
};
//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;
//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;
//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;
module.exports = EventEmitter;

},{}],"hitnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "selectSynchronisedTooltipState", ()=>selectSynchronisedTooltipState);
function selectSynchronisedTooltipState(state) {
    return state.tooltip.syncInteraction;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"zqVb2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useReportScale", ()=>useReportScale);
var _react = require("react");
var _hooks = require("../state/hooks");
var _containerSelectors = require("../state/selectors/containerSelectors");
var _layoutSlice = require("../state/layoutSlice");
var _isWellBehavedNumber = require("./isWellBehavedNumber");
function useReportScale() {
    var dispatch = (0, _hooks.useAppDispatch)();
    var [ref, setRef] = (0, _react.useState)(null);
    var scale = (0, _hooks.useAppSelector)((0, _containerSelectors.selectContainerScale));
    (0, _react.useEffect)(()=>{
        if (ref == null) return;
        var rect = ref.getBoundingClientRect();
        var newScale = rect.width / ref.offsetWidth;
        if ((0, _isWellBehavedNumber.isWellBehavedNumber)(newScale) && newScale !== scale) dispatch((0, _layoutSlice.setScale)(newScale));
    }, [
        ref,
        dispatch,
        scale
    ]);
    return setRef;
}

},{"react":"bmhQu","../state/hooks":"aEuxu","../state/selectors/containerSelectors":"lnBke","../state/layoutSlice":"gG6kT","./isWellBehavedNumber":"aIsFR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"IPMrJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipPortalContext", ()=>TooltipPortalContext);
parcelHelpers.export(exports, "useTooltipPortal", ()=>useTooltipPortal);
var _react = require("react");
var TooltipPortalContext = /*#__PURE__*/ (0, _react.createContext)(null);
var useTooltipPortal = ()=>(0, _react.useContext)(TooltipPortalContext);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4cmHF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LegendPortalContext", ()=>LegendPortalContext);
parcelHelpers.export(exports, "useLegendPortal", ()=>useLegendPortal);
var _react = require("react");
var LegendPortalContext = /*#__PURE__*/ (0, _react.createContext)(null);
var useLegendPortal = ()=>(0, _react.useContext)(LegendPortalContext);

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cnICI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClipPathProvider", ()=>ClipPathProvider);
parcelHelpers.export(exports, "useClipPathId", ()=>useClipPathId);
var _react = require("react");
var _dataUtils = require("../util/DataUtils");
var _hooks = require("../hooks");
var ClipPathIdContext = /*#__PURE__*/ (0, _react.createContext)(undefined);
var ClipPathProvider = (_ref)=>{
    var { children } = _ref;
    var [clipPathId] = (0, _react.useState)("".concat((0, _dataUtils.uniqueId)('recharts'), "-clip"));
    var plotArea = (0, _hooks.usePlotArea)();
    if (plotArea == null) return null;
    var { x, y, width, height } = plotArea;
    return /*#__PURE__*/ _react.createElement(ClipPathIdContext.Provider, {
        value: clipPathId
    }, /*#__PURE__*/ _react.createElement("defs", null, /*#__PURE__*/ _react.createElement("clipPath", {
        id: clipPathId
    }, /*#__PURE__*/ _react.createElement("rect", {
        x: x,
        y: y,
        height: height,
        width: width
    }))), children);
};
var useClipPathId = ()=>{
    return (0, _react.useContext)(ClipPathIdContext);
};

},{"react":"bmhQu","../util/DataUtils":"lNZEj","../hooks":"gL5ve","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jq3he":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "defaultTooltipProps", ()=>defaultTooltipProps);
parcelHelpers.export(exports, "Tooltip", ()=>Tooltip);
var _react = require("react");
var _reactDom = require("react-dom");
var _defaultTooltipContent = require("./DefaultTooltipContent");
var _tooltipBoundingBox = require("./TooltipBoundingBox");
var _getUniqPayload = require("../util/payload/getUniqPayload");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _accessibilityContext = require("../context/accessibilityContext");
var _useElementOffset = require("../util/useElementOffset");
var _cursor = require("./Cursor");
var _selectors = require("../state/selectors/selectors");
var _tooltipPortalContext = require("../context/tooltipPortalContext");
var _hooks = require("../state/hooks");
var _tooltipSlice = require("../state/tooltipSlice");
var _useChartSynchronisation = require("../synchronisation/useChartSynchronisation");
var _selectTooltipEventType = require("../state/selectors/selectTooltipEventType");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function defaultUniqBy(entry) {
    return entry.dataKey;
}
function renderContent(content, props) {
    if (/*#__PURE__*/ _react.isValidElement(content)) return /*#__PURE__*/ _react.cloneElement(content, props);
    if (typeof content === 'function') return /*#__PURE__*/ _react.createElement(content, props);
    return /*#__PURE__*/ _react.createElement((0, _defaultTooltipContent.DefaultTooltipContent), props);
}
var emptyPayload = [];
var defaultTooltipProps = {
    allowEscapeViewBox: {
        x: false,
        y: false
    },
    animationDuration: 400,
    animationEasing: 'ease',
    axisId: 0,
    contentStyle: {},
    cursor: true,
    filterNull: true,
    includeHidden: false,
    isAnimationActive: 'auto',
    itemSorter: 'name',
    itemStyle: {},
    labelStyle: {},
    offset: 10,
    reverseDirection: {
        x: false,
        y: false
    },
    separator: ' : ',
    trigger: 'hover',
    useTranslate3d: false,
    wrapperStyle: {}
};
function Tooltip(outsideProps) {
    var _useAppSelector, _ref;
    var props = (0, _resolveDefaultProps.resolveDefaultProps)(outsideProps, defaultTooltipProps);
    var { active: activeFromProps, allowEscapeViewBox, animationDuration, animationEasing, content, filterNull, isAnimationActive, offset, payloadUniqBy, position, reverseDirection, useTranslate3d, wrapperStyle, cursor, shared, trigger, defaultIndex, portal: portalFromProps, axisId } = props;
    var dispatch = (0, _hooks.useAppDispatch)();
    var defaultIndexAsString = typeof defaultIndex === 'number' ? String(defaultIndex) : defaultIndex;
    (0, _react.useEffect)(()=>{
        dispatch((0, _tooltipSlice.setTooltipSettingsState)({
            shared,
            trigger,
            axisId,
            active: activeFromProps,
            defaultIndex: defaultIndexAsString
        }));
    }, [
        dispatch,
        shared,
        trigger,
        axisId,
        activeFromProps,
        defaultIndexAsString
    ]);
    var viewBox = (0, _chartLayoutContext.useViewBox)();
    var accessibilityLayer = (0, _accessibilityContext.useAccessibilityLayer)();
    var tooltipEventType = (0, _selectTooltipEventType.useTooltipEventType)(shared);
    var { activeIndex, isActive } = (_useAppSelector = (0, _hooks.useAppSelector)((state)=>(0, _selectors.selectIsTooltipActive)(state, tooltipEventType, trigger, defaultIndexAsString))) !== null && _useAppSelector !== void 0 ? _useAppSelector : {};
    var payloadFromRedux = (0, _hooks.useAppSelector)((state)=>(0, _selectors.selectTooltipPayload)(state, tooltipEventType, trigger, defaultIndexAsString));
    var labelFromRedux = (0, _hooks.useAppSelector)((state)=>(0, _selectors.selectActiveLabel)(state, tooltipEventType, trigger, defaultIndexAsString));
    var coordinate = (0, _hooks.useAppSelector)((state)=>(0, _selectors.selectActiveCoordinate)(state, tooltipEventType, trigger, defaultIndexAsString));
    var payload = payloadFromRedux;
    var tooltipPortalFromContext = (0, _tooltipPortalContext.useTooltipPortal)();
    /*
   * The user can set `active=true` on the Tooltip in which case the Tooltip will stay always active,
   * or `active=false` in which case the Tooltip never shows.
   *
   * If the `active` prop is not defined then it will show and hide based on mouse or keyboard activity.
   */ var finalIsActive = (_ref = activeFromProps !== null && activeFromProps !== void 0 ? activeFromProps : isActive) !== null && _ref !== void 0 ? _ref : false;
    var [lastBoundingBox, updateBoundingBox] = (0, _useElementOffset.useElementOffset)([
        payload,
        finalIsActive
    ]);
    var finalLabel = tooltipEventType === 'axis' ? labelFromRedux : undefined;
    (0, _useChartSynchronisation.useTooltipChartSynchronisation)(tooltipEventType, trigger, coordinate, finalLabel, activeIndex, finalIsActive);
    var tooltipPortal = portalFromProps !== null && portalFromProps !== void 0 ? portalFromProps : tooltipPortalFromContext;
    if (tooltipPortal == null || viewBox == null || tooltipEventType == null) return null;
    var finalPayload = payload !== null && payload !== void 0 ? payload : emptyPayload;
    if (!finalIsActive) finalPayload = emptyPayload;
    if (filterNull && finalPayload.length) finalPayload = (0, _getUniqPayload.getUniqPayload)(finalPayload.filter((entry)=>entry.value != null && (entry.hide !== true || props.includeHidden)), payloadUniqBy, defaultUniqBy);
    var hasPayload = finalPayload.length > 0;
    var tooltipElement = /*#__PURE__*/ _react.createElement((0, _tooltipBoundingBox.TooltipBoundingBox), {
        allowEscapeViewBox: allowEscapeViewBox,
        animationDuration: animationDuration,
        animationEasing: animationEasing,
        isAnimationActive: isAnimationActive,
        active: finalIsActive,
        coordinate: coordinate,
        hasPayload: hasPayload,
        offset: offset,
        position: position,
        reverseDirection: reverseDirection,
        useTranslate3d: useTranslate3d,
        viewBox: viewBox,
        wrapperStyle: wrapperStyle,
        lastBoundingBox: lastBoundingBox,
        innerRef: updateBoundingBox,
        hasPortalFromProps: Boolean(portalFromProps)
    }, renderContent(content, _objectSpread(_objectSpread({}, props), {}, {
        payload: finalPayload,
        label: finalLabel,
        active: finalIsActive,
        activeIndex,
        coordinate,
        accessibilityLayer
    })));
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ (0, _reactDom.createPortal)(tooltipElement, tooltipPortal), finalIsActive && /*#__PURE__*/ _react.createElement((0, _cursor.Cursor), {
        cursor: cursor,
        tooltipEventType: tooltipEventType,
        coordinate: coordinate,
        payload: finalPayload,
        index: activeIndex
    }));
}

},{"react":"bmhQu","react-dom":"82aNB","./DefaultTooltipContent":"0Tes8","./TooltipBoundingBox":"bFoLs","../util/payload/getUniqPayload":"dNGQ3","../context/chartLayoutContext":"jIUyy","../context/accessibilityContext":"18E6N","../util/useElementOffset":"gHc91","./Cursor":"s6j6w","../state/selectors/selectors":"2uuUJ","../context/tooltipPortalContext":"IPMrJ","../state/hooks":"aEuxu","../state/tooltipSlice":"8Jqu4","../synchronisation/useChartSynchronisation":"hqM1z","../state/selectors/selectTooltipEventType":"4RpEb","../util/resolveDefaultProps":"cWUqx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"0Tes8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DefaultTooltipContent", ()=>DefaultTooltipContent);
/**
 * @fileOverview Default Tooltip Content
 */ var _react = require("react");
var _sortBy = require("es-toolkit/compat/sortBy");
var _sortByDefault = parcelHelpers.interopDefault(_sortBy);
var _clsx = require("clsx");
var _dataUtils = require("../util/DataUtils");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function defaultFormatter(value) {
    return Array.isArray(value) && (0, _dataUtils.isNumOrStr)(value[0]) && (0, _dataUtils.isNumOrStr)(value[1]) ? value.join(' ~ ') : value;
}
var DefaultTooltipContent = (props)=>{
    var { separator = ' : ', contentStyle = {}, itemStyle = {}, labelStyle = {}, payload, formatter, itemSorter, wrapperClassName, labelClassName, label, labelFormatter, accessibilityLayer = false } = props;
    var renderContent = ()=>{
        if (payload && payload.length) {
            var listStyle = {
                padding: 0,
                margin: 0
            };
            var items = (itemSorter ? (0, _sortByDefault.default)(payload, itemSorter) : payload).map((entry, i)=>{
                if (entry.type === 'none') return null;
                var finalFormatter = entry.formatter || formatter || defaultFormatter;
                var { value, name } = entry;
                var finalValue = value;
                var finalName = name;
                if (finalFormatter) {
                    var formatted = finalFormatter(value, name, entry, i, payload);
                    if (Array.isArray(formatted)) [finalValue, finalName] = formatted;
                    else if (formatted != null) finalValue = formatted;
                    else return null;
                }
                var finalItemStyle = _objectSpread({
                    display: 'block',
                    paddingTop: 4,
                    paddingBottom: 4,
                    color: entry.color || '#000'
                }, itemStyle);
                return /*#__PURE__*/ _react.createElement("li", {
                    className: "recharts-tooltip-item",
                    key: "tooltip-item-".concat(i),
                    style: finalItemStyle
                }, (0, _dataUtils.isNumOrStr)(finalName) ? /*#__PURE__*/ _react.createElement("span", {
                    className: "recharts-tooltip-item-name"
                }, finalName) : null, (0, _dataUtils.isNumOrStr)(finalName) ? /*#__PURE__*/ _react.createElement("span", {
                    className: "recharts-tooltip-item-separator"
                }, separator) : null, /*#__PURE__*/ _react.createElement("span", {
                    className: "recharts-tooltip-item-value"
                }, finalValue), /*#__PURE__*/ _react.createElement("span", {
                    className: "recharts-tooltip-item-unit"
                }, entry.unit || ''));
            });
            return /*#__PURE__*/ _react.createElement("ul", {
                className: "recharts-tooltip-item-list",
                style: listStyle
            }, items);
        }
        return null;
    };
    var finalStyle = _objectSpread({
        margin: 0,
        padding: 10,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        whiteSpace: 'nowrap'
    }, contentStyle);
    var finalLabelStyle = _objectSpread({
        margin: 0
    }, labelStyle);
    var hasLabel = !(0, _dataUtils.isNullish)(label);
    var finalLabel = hasLabel ? label : '';
    var wrapperCN = (0, _clsx.clsx)('recharts-default-tooltip', wrapperClassName);
    var labelCN = (0, _clsx.clsx)('recharts-tooltip-label', labelClassName);
    if (hasLabel && labelFormatter && payload !== undefined && payload !== null) finalLabel = labelFormatter(label, payload);
    var accessibilityAttributes = accessibilityLayer ? {
        role: 'status',
        'aria-live': 'assertive'
    } : {};
    return /*#__PURE__*/ _react.createElement("div", _extends({
        className: wrapperCN,
        style: finalStyle
    }, accessibilityAttributes), /*#__PURE__*/ _react.createElement("p", {
        className: labelCN,
        style: finalLabelStyle
    }, /*#__PURE__*/ _react.isValidElement(finalLabel) ? finalLabel : "".concat(finalLabel)), renderContent());
};

},{"react":"bmhQu","es-toolkit/compat/sortBy":"jVc75","clsx":"431Ou","../util/DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bFoLs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TooltipBoundingBox", ()=>TooltipBoundingBox);
var _react = require("react");
var _translate = require("../util/tooltip/translate");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
class TooltipBoundingBox extends (0, _react.PureComponent) {
    constructor(){
        super(...arguments);
        _defineProperty(this, "state", {
            dismissed: false,
            dismissedAtCoordinate: {
                x: 0,
                y: 0
            }
        });
        _defineProperty(this, "handleKeyDown", (event)=>{
            if (event.key === 'Escape') {
                var _this$props$coordinat, _this$props$coordinat2, _this$props$coordinat3, _this$props$coordinat4;
                this.setState({
                    dismissed: true,
                    dismissedAtCoordinate: {
                        x: (_this$props$coordinat = (_this$props$coordinat2 = this.props.coordinate) === null || _this$props$coordinat2 === void 0 ? void 0 : _this$props$coordinat2.x) !== null && _this$props$coordinat !== void 0 ? _this$props$coordinat : 0,
                        y: (_this$props$coordinat3 = (_this$props$coordinat4 = this.props.coordinate) === null || _this$props$coordinat4 === void 0 ? void 0 : _this$props$coordinat4.y) !== null && _this$props$coordinat3 !== void 0 ? _this$props$coordinat3 : 0
                    }
                });
            }
        });
    }
    componentDidMount() {
        document.addEventListener('keydown', this.handleKeyDown);
    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.handleKeyDown);
    }
    componentDidUpdate() {
        var _this$props$coordinat5, _this$props$coordinat6;
        if (!this.state.dismissed) return;
        if (((_this$props$coordinat5 = this.props.coordinate) === null || _this$props$coordinat5 === void 0 ? void 0 : _this$props$coordinat5.x) !== this.state.dismissedAtCoordinate.x || ((_this$props$coordinat6 = this.props.coordinate) === null || _this$props$coordinat6 === void 0 ? void 0 : _this$props$coordinat6.y) !== this.state.dismissedAtCoordinate.y) this.state.dismissed = false;
    }
    render() {
        var { active, allowEscapeViewBox, animationDuration, animationEasing, children, coordinate, hasPayload, isAnimationActive, offset, position, reverseDirection, useTranslate3d, viewBox, wrapperStyle, lastBoundingBox, innerRef, hasPortalFromProps } = this.props;
        var { cssClasses, cssProperties } = (0, _translate.getTooltipTranslate)({
            allowEscapeViewBox,
            coordinate,
            offsetTopLeft: offset,
            position,
            reverseDirection,
            tooltipBox: {
                height: lastBoundingBox.height,
                width: lastBoundingBox.width
            },
            useTranslate3d,
            viewBox
        });
        // do not use absolute styles if the user has passed a custom portal prop
        var positionStyles = hasPortalFromProps ? {} : _objectSpread(_objectSpread({
            transition: isAnimationActive && active ? "transform ".concat(animationDuration, "ms ").concat(animationEasing) : undefined
        }, cssProperties), {}, {
            pointerEvents: 'none',
            visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden',
            position: 'absolute',
            top: 0,
            left: 0
        });
        var outerStyle = _objectSpread(_objectSpread({}, positionStyles), {}, {
            visibility: !this.state.dismissed && active && hasPayload ? 'visible' : 'hidden'
        }, wrapperStyle);
        return(/*#__PURE__*/ // This element allow listening to the `Escape` key. See https://github.com/recharts/recharts/pull/2925
        _react.createElement("div", {
            // @ts-expect-error typescript library does not recognize xmlns attribute, but it's required for an HTML chunk inside SVG.
            xmlns: "http://www.w3.org/1999/xhtml",
            tabIndex: -1,
            className: cssClasses,
            style: outerStyle,
            ref: innerRef
        }, children));
    }
}

},{"react":"bmhQu","../util/tooltip/translate":"kbgvu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kbgvu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getTooltipCSSClassName", ()=>getTooltipCSSClassName);
parcelHelpers.export(exports, "getTooltipTranslateXY", ()=>getTooltipTranslateXY);
parcelHelpers.export(exports, "getTransformStyle", ()=>getTransformStyle);
parcelHelpers.export(exports, "getTooltipTranslate", ()=>getTooltipTranslate);
var _clsx = require("clsx");
var _dataUtils = require("../DataUtils");
var CSS_CLASS_PREFIX = 'recharts-tooltip-wrapper';
var TOOLTIP_HIDDEN = {
    visibility: 'hidden'
};
function getTooltipCSSClassName(_ref) {
    var { coordinate, translateX, translateY } = _ref;
    return (0, _clsx.clsx)(CSS_CLASS_PREFIX, {
        ["".concat(CSS_CLASS_PREFIX, "-right")]: (0, _dataUtils.isNumber)(translateX) && coordinate && (0, _dataUtils.isNumber)(coordinate.x) && translateX >= coordinate.x,
        ["".concat(CSS_CLASS_PREFIX, "-left")]: (0, _dataUtils.isNumber)(translateX) && coordinate && (0, _dataUtils.isNumber)(coordinate.x) && translateX < coordinate.x,
        ["".concat(CSS_CLASS_PREFIX, "-bottom")]: (0, _dataUtils.isNumber)(translateY) && coordinate && (0, _dataUtils.isNumber)(coordinate.y) && translateY >= coordinate.y,
        ["".concat(CSS_CLASS_PREFIX, "-top")]: (0, _dataUtils.isNumber)(translateY) && coordinate && (0, _dataUtils.isNumber)(coordinate.y) && translateY < coordinate.y
    });
}
function getTooltipTranslateXY(_ref2) {
    var { allowEscapeViewBox, coordinate, key, offsetTopLeft, position, reverseDirection, tooltipDimension, viewBox, viewBoxDimension } = _ref2;
    if (position && (0, _dataUtils.isNumber)(position[key])) return position[key];
    var negative = coordinate[key] - tooltipDimension - (offsetTopLeft > 0 ? offsetTopLeft : 0);
    var positive = coordinate[key] + offsetTopLeft;
    if (allowEscapeViewBox[key]) return reverseDirection[key] ? negative : positive;
    var viewBoxKey = viewBox[key];
    if (viewBoxKey == null) return 0;
    if (reverseDirection[key]) {
        var _tooltipBoundary = negative;
        var _viewBoxBoundary = viewBoxKey;
        if (_tooltipBoundary < _viewBoxBoundary) return Math.max(positive, viewBoxKey);
        return Math.max(negative, viewBoxKey);
    }
    if (viewBoxDimension == null) return 0;
    var tooltipBoundary = positive + tooltipDimension;
    var viewBoxBoundary = viewBoxKey + viewBoxDimension;
    if (tooltipBoundary > viewBoxBoundary) return Math.max(negative, viewBoxKey);
    return Math.max(positive, viewBoxKey);
}
function getTransformStyle(_ref3) {
    var { translateX, translateY, useTranslate3d } = _ref3;
    return {
        transform: useTranslate3d ? "translate3d(".concat(translateX, "px, ").concat(translateY, "px, 0)") : "translate(".concat(translateX, "px, ").concat(translateY, "px)")
    };
}
function getTooltipTranslate(_ref4) {
    var { allowEscapeViewBox, coordinate, offsetTopLeft, position, reverseDirection, tooltipBox, useTranslate3d, viewBox } = _ref4;
    var cssProperties, translateX, translateY;
    if (tooltipBox.height > 0 && tooltipBox.width > 0 && coordinate) {
        translateX = getTooltipTranslateXY({
            allowEscapeViewBox,
            coordinate,
            key: 'x',
            offsetTopLeft,
            position,
            reverseDirection,
            tooltipDimension: tooltipBox.width,
            viewBox,
            viewBoxDimension: viewBox.width
        });
        translateY = getTooltipTranslateXY({
            allowEscapeViewBox,
            coordinate,
            key: 'y',
            offsetTopLeft,
            position,
            reverseDirection,
            tooltipDimension: tooltipBox.height,
            viewBox,
            viewBoxDimension: viewBox.height
        });
        cssProperties = getTransformStyle({
            translateX,
            translateY,
            useTranslate3d
        });
    } else cssProperties = TOOLTIP_HIDDEN;
    return {
        cssProperties,
        cssClasses: getTooltipCSSClassName({
            translateX,
            translateY,
            coordinate
        })
    };
}

},{"clsx":"431Ou","../DataUtils":"lNZEj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dNGQ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * This is configuration option that decides how to filter for unique values only:
 *
 * - `false` means "no filter"
 * - `true` means "use recharts default filter"
 * - function means "use return of this function as the default key"
 */ parcelHelpers.export(exports, "getUniqPayload", ()=>getUniqPayload);
var _uniqBy = require("es-toolkit/compat/uniqBy");
var _uniqByDefault = parcelHelpers.interopDefault(_uniqBy);
function getUniqPayload(payload, option, defaultUniqBy) {
    if (option === true) return (0, _uniqByDefault.default)(payload, defaultUniqBy);
    if (typeof option === 'function') return (0, _uniqByDefault.default)(payload, option);
    return payload;
}

},{"es-toolkit/compat/uniqBy":"7RKPI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7RKPI":[function(require,module,exports,__globalThis) {
module.exports = require("c68862132b68c61d").uniqBy;

},{"c68862132b68c61d":"JVhfy"}],"JVhfy":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const uniqBy$1 = require("194be566ab8457f5");
const identity = require("8b6c48d1a7cdfd86");
const isArrayLikeObject = require("c6d20e6dea80feb8");
const iteratee = require("1d4303ee2e83ddc0");
function uniqBy(array, iteratee$1 = identity.identity) {
    if (!isArrayLikeObject.isArrayLikeObject(array)) return [];
    return uniqBy$1.uniqBy(Array.from(array), iteratee.iteratee(iteratee$1));
}
exports.uniqBy = uniqBy;

},{"194be566ab8457f5":"eOUmz","8b6c48d1a7cdfd86":"22NVj","c6d20e6dea80feb8":"gnrcV","1d4303ee2e83ddc0":"Dgzev"}],"eOUmz":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function uniqBy(arr, mapper) {
    const map = new Map();
    for(let i = 0; i < arr.length; i++){
        const item = arr[i];
        const key = mapper(item);
        if (!map.has(key)) map.set(key, item);
    }
    return Array.from(map.values());
}
exports.uniqBy = uniqBy;

},{}],"22NVj":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function identity(x) {
    return x;
}
exports.identity = identity;

},{}],"gnrcV":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const isArrayLike = require("3a821169bc681432");
const isObjectLike = require("ca99534676728fa5");
function isArrayLikeObject(value) {
    return isObjectLike.isObjectLike(value) && isArrayLike.isArrayLike(value);
}
exports.isArrayLikeObject = isArrayLikeObject;

},{"3a821169bc681432":"8WsUw","ca99534676728fa5":"5gm2N"}],"5gm2N":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isObjectLike(value) {
    return typeof value === 'object' && value !== null;
}
exports.isObjectLike = isObjectLike;

},{}],"Dgzev":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const identity = require("34a09933bbad62a9");
const property = require("ce4209d3a3e67e11");
const matches = require("6665a5f74a3308cd");
const matchesProperty = require("222896d885bef5c6");
function iteratee(value) {
    if (value == null) return identity.identity;
    switch(typeof value){
        case 'function':
            return value;
        case 'object':
            if (Array.isArray(value) && value.length === 2) return matchesProperty.matchesProperty(value[0], value[1]);
            return matches.matches(value);
        case 'string':
        case 'symbol':
        case 'number':
            return property.property(value);
    }
}
exports.iteratee = iteratee;

},{"34a09933bbad62a9":"22NVj","ce4209d3a3e67e11":"cjT8a","6665a5f74a3308cd":"dxQ8D","222896d885bef5c6":"kfmxy"}],"cjT8a":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const get = require("2364e8d124a370df");
function property(path) {
    return function(object) {
        return get.get(object, path);
    };
}
exports.property = property;

},{"2364e8d124a370df":"gFg89"}],"dxQ8D":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const isMatch = require("deeed137064cace1");
const cloneDeep = require("30c0a90dbfc65b71");
function matches(source) {
    source = cloneDeep.cloneDeep(source);
    return (target)=>{
        return isMatch.isMatch(target, source);
    };
}
exports.matches = matches;

},{"deeed137064cace1":"hBOSx","30c0a90dbfc65b71":"5FvK8"}],"hBOSx":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const isMatchWith = require("ba0796f703a5faf6");
function isMatch(target, source) {
    return isMatchWith.isMatchWith(target, source, ()=>undefined);
}
exports.isMatch = isMatch;

},{"ba0796f703a5faf6":"dFaEP"}],"dFaEP":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const isObject = require("b49f4ddfc298c1af");
const isPrimitive = require("f87e2e4defd9ead2");
const eq = require("2fb61e722bac67a");
function isMatchWith(target, source, compare) {
    if (typeof compare !== 'function') return isMatchWith(target, source, ()=>undefined);
    return isMatchWithInternal(target, source, function doesMatch(objValue, srcValue, key, object, source, stack) {
        const isEqual = compare(objValue, srcValue, key, object, source, stack);
        if (isEqual !== undefined) return Boolean(isEqual);
        return isMatchWithInternal(objValue, srcValue, doesMatch, stack);
    }, new Map());
}
function isMatchWithInternal(target, source, compare, stack) {
    if (source === target) return true;
    switch(typeof source){
        case 'object':
            return isObjectMatch(target, source, compare, stack);
        case 'function':
            {
                const sourceKeys = Object.keys(source);
                if (sourceKeys.length > 0) return isMatchWithInternal(target, {
                    ...source
                }, compare, stack);
                return eq.eq(target, source);
            }
        default:
            if (!isObject.isObject(target)) return eq.eq(target, source);
            if (typeof source === 'string') return source === '';
            return true;
    }
}
function isObjectMatch(target, source, compare, stack) {
    if (source == null) return true;
    if (Array.isArray(source)) return isArrayMatch(target, source, compare, stack);
    if (source instanceof Map) return isMapMatch(target, source, compare, stack);
    if (source instanceof Set) return isSetMatch(target, source, compare, stack);
    const keys = Object.keys(source);
    if (target == null || isPrimitive.isPrimitive(target)) return keys.length === 0;
    if (keys.length === 0) return true;
    if (stack?.has(source)) return stack.get(source) === target;
    stack?.set(source, target);
    try {
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (!isPrimitive.isPrimitive(target) && !(key in target)) return false;
            if (source[key] === undefined && target[key] !== undefined) return false;
            if (source[key] === null && target[key] !== null) return false;
            const isEqual = compare(target[key], source[key], key, target, source, stack);
            if (!isEqual) return false;
        }
        return true;
    } finally{
        stack?.delete(source);
    }
}
function isMapMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Map)) return false;
    for (const [key, sourceValue] of source.entries()){
        const targetValue = target.get(key);
        const isEqual = compare(targetValue, sourceValue, key, target, source, stack);
        if (isEqual === false) return false;
    }
    return true;
}
function isArrayMatch(target, source, compare, stack) {
    if (source.length === 0) return true;
    if (!Array.isArray(target)) return false;
    const countedIndex = new Set();
    for(let i = 0; i < source.length; i++){
        const sourceItem = source[i];
        let found = false;
        for(let j = 0; j < target.length; j++){
            if (countedIndex.has(j)) continue;
            const targetItem = target[j];
            let matches = false;
            const isEqual = compare(targetItem, sourceItem, i, target, source, stack);
            if (isEqual) matches = true;
            if (matches) {
                countedIndex.add(j);
                found = true;
                break;
            }
        }
        if (!found) return false;
    }
    return true;
}
function isSetMatch(target, source, compare, stack) {
    if (source.size === 0) return true;
    if (!(target instanceof Set)) return false;
    return isArrayMatch([
        ...target
    ], [
        ...source
    ], compare, stack);
}
exports.isMatchWith = isMatchWith;
exports.isSetMatch = isSetMatch;

},{"b49f4ddfc298c1af":"z9lTG","f87e2e4defd9ead2":"39dcp","2fb61e722bac67a":"kUpbN"}],"39dcp":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isPrimitive(value) {
    return value == null || typeof value !== 'object' && typeof value !== 'function';
}
exports.isPrimitive = isPrimitive;

},{}],"5FvK8":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const cloneDeepWith = require("db05d91db5f76de");
function cloneDeep(obj) {
    return cloneDeepWith.cloneDeepWithImpl(obj, undefined, obj, new Map(), undefined);
}
exports.cloneDeep = cloneDeep;

},{"db05d91db5f76de":"5kKQ3"}],"5kKQ3":[function(require,module,exports,__globalThis) {
var Buffer = require("bf3102a397a5a417").Buffer;
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const getSymbols = require("a577f65185a16262");
const getTag = require("4070c476d215f393");
const tags = require("1fdcce9ab9f2baab");
const isPrimitive = require("603918cbef97cfa1");
const isTypedArray = require("7f504f3c464865c2");
function cloneDeepWith(obj, cloneValue) {
    return cloneDeepWithImpl(obj, undefined, obj, new Map(), cloneValue);
}
function cloneDeepWithImpl(valueToClone, keyToClone, objectToClone, stack = new Map(), cloneValue) {
    const cloned = cloneValue?.(valueToClone, keyToClone, objectToClone, stack);
    if (cloned !== undefined) return cloned;
    if (isPrimitive.isPrimitive(valueToClone)) return valueToClone;
    if (stack.has(valueToClone)) return stack.get(valueToClone);
    if (Array.isArray(valueToClone)) {
        const result = new Array(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = cloneDeepWithImpl(valueToClone[i], i, objectToClone, stack, cloneValue);
        if (Object.hasOwn(valueToClone, 'index')) result.index = valueToClone.index;
        if (Object.hasOwn(valueToClone, 'input')) result.input = valueToClone.input;
        return result;
    }
    if (valueToClone instanceof Date) return new Date(valueToClone.getTime());
    if (valueToClone instanceof RegExp) {
        const result = new RegExp(valueToClone.source, valueToClone.flags);
        result.lastIndex = valueToClone.lastIndex;
        return result;
    }
    if (valueToClone instanceof Map) {
        const result = new Map();
        stack.set(valueToClone, result);
        for (const [key, value] of valueToClone)result.set(key, cloneDeepWithImpl(value, key, objectToClone, stack, cloneValue));
        return result;
    }
    if (valueToClone instanceof Set) {
        const result = new Set();
        stack.set(valueToClone, result);
        for (const value of valueToClone)result.add(cloneDeepWithImpl(value, undefined, objectToClone, stack, cloneValue));
        return result;
    }
    if (typeof Buffer !== 'undefined' && Buffer.isBuffer(valueToClone)) return valueToClone.subarray();
    if (isTypedArray.isTypedArray(valueToClone)) {
        const result = new (Object.getPrototypeOf(valueToClone)).constructor(valueToClone.length);
        stack.set(valueToClone, result);
        for(let i = 0; i < valueToClone.length; i++)result[i] = cloneDeepWithImpl(valueToClone[i], i, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof ArrayBuffer || typeof SharedArrayBuffer !== 'undefined' && valueToClone instanceof SharedArrayBuffer) return valueToClone.slice(0);
    if (valueToClone instanceof DataView) {
        const result = new DataView(valueToClone.buffer.slice(0), valueToClone.byteOffset, valueToClone.byteLength);
        stack.set(valueToClone, result);
        copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof File !== 'undefined' && valueToClone instanceof File) {
        const result = new File([
            valueToClone
        ], valueToClone.name, {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof Blob !== 'undefined' && valueToClone instanceof Blob) {
        const result = new Blob([
            valueToClone
        ], {
            type: valueToClone.type
        });
        stack.set(valueToClone, result);
        copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Error) {
        const result = new valueToClone.constructor();
        stack.set(valueToClone, result);
        result.message = valueToClone.message;
        result.name = valueToClone.name;
        result.stack = valueToClone.stack;
        result.cause = valueToClone.cause;
        copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Boolean) {
        const result = new Boolean(valueToClone.valueOf());
        stack.set(valueToClone, result);
        copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof Number) {
        const result = new Number(valueToClone.valueOf());
        stack.set(valueToClone, result);
        copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (valueToClone instanceof String) {
        const result = new String(valueToClone.valueOf());
        stack.set(valueToClone, result);
        copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    if (typeof valueToClone === 'object' && isCloneableObject(valueToClone)) {
        const result = Object.create(Object.getPrototypeOf(valueToClone));
        stack.set(valueToClone, result);
        copyProperties(result, valueToClone, objectToClone, stack, cloneValue);
        return result;
    }
    return valueToClone;
}
function copyProperties(target, source, objectToClone = target, stack, cloneValue) {
    const keys = [
        ...Object.keys(source),
        ...getSymbols.getSymbols(source)
    ];
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const descriptor = Object.getOwnPropertyDescriptor(target, key);
        if (descriptor == null || descriptor.writable) target[key] = cloneDeepWithImpl(source[key], key, objectToClone, stack, cloneValue);
    }
}
function isCloneableObject(object) {
    switch(getTag.getTag(object)){
        case tags.argumentsTag:
        case tags.arrayTag:
        case tags.arrayBufferTag:
        case tags.dataViewTag:
        case tags.booleanTag:
        case tags.dateTag:
        case tags.float32ArrayTag:
        case tags.float64ArrayTag:
        case tags.int8ArrayTag:
        case tags.int16ArrayTag:
        case tags.int32ArrayTag:
        case tags.mapTag:
        case tags.numberTag:
        case tags.objectTag:
        case tags.regexpTag:
        case tags.setTag:
        case tags.stringTag:
        case tags.symbolTag:
        case tags.uint8ArrayTag:
        case tags.uint8ClampedArrayTag:
        case tags.uint16ArrayTag:
        case tags.uint32ArrayTag:
            return true;
        default:
            return false;
    }
}
exports.cloneDeepWith = cloneDeepWith;
exports.cloneDeepWithImpl = cloneDeepWithImpl;
exports.copyProperties = copyProperties;

},{"bf3102a397a5a417":"cjdyz","a577f65185a16262":"96bTR","4070c476d215f393":"dHd7b","1fdcce9ab9f2baab":"fy0f7","603918cbef97cfa1":"39dcp","7f504f3c464865c2":"i0oXi"}],"96bTR":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function getSymbols(object) {
    return Object.getOwnPropertySymbols(object).filter((symbol)=>Object.prototype.propertyIsEnumerable.call(object, symbol));
}
exports.getSymbols = getSymbols;

},{}],"dHd7b":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function getTag(value) {
    if (value == null) return value === undefined ? '[object Undefined]' : '[object Null]';
    return Object.prototype.toString.call(value);
}
exports.getTag = getTag;

},{}],"fy0f7":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const regexpTag = '[object RegExp]';
const stringTag = '[object String]';
const numberTag = '[object Number]';
const booleanTag = '[object Boolean]';
const argumentsTag = '[object Arguments]';
const symbolTag = '[object Symbol]';
const dateTag = '[object Date]';
const mapTag = '[object Map]';
const setTag = '[object Set]';
const arrayTag = '[object Array]';
const functionTag = '[object Function]';
const arrayBufferTag = '[object ArrayBuffer]';
const objectTag = '[object Object]';
const errorTag = '[object Error]';
const dataViewTag = '[object DataView]';
const uint8ArrayTag = '[object Uint8Array]';
const uint8ClampedArrayTag = '[object Uint8ClampedArray]';
const uint16ArrayTag = '[object Uint16Array]';
const uint32ArrayTag = '[object Uint32Array]';
const bigUint64ArrayTag = '[object BigUint64Array]';
const int8ArrayTag = '[object Int8Array]';
const int16ArrayTag = '[object Int16Array]';
const int32ArrayTag = '[object Int32Array]';
const bigInt64ArrayTag = '[object BigInt64Array]';
const float32ArrayTag = '[object Float32Array]';
const float64ArrayTag = '[object Float64Array]';
exports.argumentsTag = argumentsTag;
exports.arrayBufferTag = arrayBufferTag;
exports.arrayTag = arrayTag;
exports.bigInt64ArrayTag = bigInt64ArrayTag;
exports.bigUint64ArrayTag = bigUint64ArrayTag;
exports.booleanTag = booleanTag;
exports.dataViewTag = dataViewTag;
exports.dateTag = dateTag;
exports.errorTag = errorTag;
exports.float32ArrayTag = float32ArrayTag;
exports.float64ArrayTag = float64ArrayTag;
exports.functionTag = functionTag;
exports.int16ArrayTag = int16ArrayTag;
exports.int32ArrayTag = int32ArrayTag;
exports.int8ArrayTag = int8ArrayTag;
exports.mapTag = mapTag;
exports.numberTag = numberTag;
exports.objectTag = objectTag;
exports.regexpTag = regexpTag;
exports.setTag = setTag;
exports.stringTag = stringTag;
exports.symbolTag = symbolTag;
exports.uint16ArrayTag = uint16ArrayTag;
exports.uint32ArrayTag = uint32ArrayTag;
exports.uint8ArrayTag = uint8ArrayTag;
exports.uint8ClampedArrayTag = uint8ClampedArrayTag;

},{}],"i0oXi":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isTypedArray(x) {
    return ArrayBuffer.isView(x) && !(x instanceof DataView);
}
exports.isTypedArray = isTypedArray;

},{}],"kfmxy":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const isMatch = require("97fbdff9ce60b6fe");
const toKey = require("69ad15d5350a97fa");
const cloneDeep = require("1680d4f510641bc8");
const get = require("258126be23b1fe14");
const has = require("c6544619359f3365");
function matchesProperty(property, source) {
    switch(typeof property){
        case 'object':
            if (Object.is(property?.valueOf(), -0)) property = '-0';
            break;
        case 'number':
            property = toKey.toKey(property);
            break;
    }
    source = cloneDeep.cloneDeep(source);
    return function(target) {
        const result = get.get(target, property);
        if (result === undefined) return has.has(target, property);
        if (source === undefined) return result === undefined;
        return isMatch.isMatch(result, source);
    };
}
exports.matchesProperty = matchesProperty;

},{"97fbdff9ce60b6fe":"hBOSx","69ad15d5350a97fa":"bryRk","1680d4f510641bc8":"2LOoA","258126be23b1fe14":"gFg89","c6544619359f3365":"beyj7"}],"2LOoA":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const cloneDeepWith = require("8c842c78edb24c2");
function cloneDeep(obj) {
    return cloneDeepWith.cloneDeepWith(obj);
}
exports.cloneDeep = cloneDeep;

},{"8c842c78edb24c2":"40q15"}],"40q15":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const cloneDeepWith$1 = require("2081e2d78b70246f");
const tags = require("e4aa5222c7305241");
function cloneDeepWith(obj, customizer) {
    return cloneDeepWith$1.cloneDeepWith(obj, (value, key, object, stack)=>{
        const cloned = customizer?.(value, key, object, stack);
        if (cloned !== undefined) return cloned;
        if (typeof obj !== 'object') return undefined;
        switch(Object.prototype.toString.call(obj)){
            case tags.numberTag:
            case tags.stringTag:
            case tags.booleanTag:
                {
                    const result = new obj.constructor(obj?.valueOf());
                    cloneDeepWith$1.copyProperties(result, obj);
                    return result;
                }
            case tags.argumentsTag:
                {
                    const result = {};
                    cloneDeepWith$1.copyProperties(result, obj);
                    result.length = obj.length;
                    result[Symbol.iterator] = obj[Symbol.iterator];
                    return result;
                }
            default:
                return undefined;
        }
    });
}
exports.cloneDeepWith = cloneDeepWith;

},{"2081e2d78b70246f":"5kKQ3","e4aa5222c7305241":"fy0f7"}],"beyj7":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const isDeepKey = require("c81898b1e5b78fc6");
const isIndex = require("4e3a1165cc00e2e0");
const isArguments = require("604d588a220456ee");
const toPath = require("40deff72a611b034");
function has(object, path) {
    let resolvedPath;
    if (Array.isArray(path)) resolvedPath = path;
    else if (typeof path === 'string' && isDeepKey.isDeepKey(path) && object?.[path] == null) resolvedPath = toPath.toPath(path);
    else resolvedPath = [
        path
    ];
    if (resolvedPath.length === 0) return false;
    let current = object;
    for(let i = 0; i < resolvedPath.length; i++){
        const key = resolvedPath[i];
        if (current == null || !Object.hasOwn(current, key)) {
            const isSparseIndex = (Array.isArray(current) || isArguments.isArguments(current)) && isIndex.isIndex(key) && key < current.length;
            if (!isSparseIndex) return false;
        }
        current = current[key];
    }
    return true;
}
exports.has = has;

},{"c81898b1e5b78fc6":"ggdFX","4e3a1165cc00e2e0":"gvFyj","604d588a220456ee":"f2Uze","40deff72a611b034":"f9GmR"}],"f2Uze":[function(require,module,exports,__globalThis) {
'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
const getTag = require("1a92579570045351");
function isArguments(value) {
    return value !== null && typeof value === 'object' && getTag.getTag(value) === '[object Arguments]';
}
exports.isArguments = isArguments;

},{"1a92579570045351":"dHd7b"}],"gHc91":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * TODO this documentation does not reflect what this hook is doing, update it.
 * Stores the `offsetHeight`, `offsetLeft`, `offsetTop`, and `offsetWidth` of a DOM element.
 */ /**
 * Use this to listen to element layout changes.
 *
 * Very useful for reading actual sizes of DOM elements relative to the viewport.
 *
 * @param extraDependencies use this to trigger new DOM dimensions read when any of these change. Good for things like payload and label, that will re-render something down in the children array, but you want to read the layout box of a parent.
 * @returns [lastElementOffset, updateElementOffset] most recent value, and setter. Pass the setter to a DOM element ref like this: `<div ref={updateElementOffset}>`
 */ parcelHelpers.export(exports, "useElementOffset", ()=>useElementOffset);
var _react = require("react");
var EPS = 1;
function useElementOffset() {
    var extraDependencies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var [lastBoundingBox, setLastBoundingBox] = (0, _react.useState)({
        height: 0,
        left: 0,
        top: 0,
        width: 0
    });
    var updateBoundingBox = (0, _react.useCallback)((node)=>{
        if (node != null) {
            var rect = node.getBoundingClientRect();
            var box = {
                height: rect.height,
                left: rect.left,
                top: rect.top,
                width: rect.width
            };
            if (Math.abs(box.height - lastBoundingBox.height) > EPS || Math.abs(box.left - lastBoundingBox.left) > EPS || Math.abs(box.top - lastBoundingBox.top) > EPS || Math.abs(box.width - lastBoundingBox.width) > EPS) setLastBoundingBox({
                height: box.height,
                left: box.left,
                top: box.top,
                width: box.width
            });
        }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        lastBoundingBox.width,
        lastBoundingBox.height,
        lastBoundingBox.top,
        lastBoundingBox.left,
        ...extraDependencies
    ]);
    return [
        lastBoundingBox,
        updateBoundingBox
    ];
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"s6j6w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CursorInternal", ()=>CursorInternal);
/*
 * Cursor is the background, or a highlight,
 * that shows when user mouses over or activates
 * an area.
 *
 * It usually shows together with a tooltip
 * to emphasise which part of the chart does the tooltip refer to.
 */ parcelHelpers.export(exports, "Cursor", ()=>Cursor);
var _react = require("react");
var _clsx = require("clsx");
var _types = require("../util/types");
var _curve = require("../shape/Curve");
var _cross = require("../shape/Cross");
var _getCursorRectangle = require("../util/cursor/getCursorRectangle");
var _rectangle = require("../shape/Rectangle");
var _getRadialCursorPoints = require("../util/cursor/getRadialCursorPoints");
var _sector = require("../shape/Sector");
var _getCursorPoints = require("../util/cursor/getCursorPoints");
var _chartLayoutContext = require("../context/chartLayoutContext");
var _useTooltipAxis = require("../context/useTooltipAxis");
var _selectors = require("../state/selectors/selectors");
var _svgPropertiesNoEvents = require("../util/svgPropertiesNoEvents");
var _zindexLayer = require("../zIndex/ZIndexLayer");
var _defaultZIndexes = require("../zIndex/DefaultZIndexes");
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
/**
 * If set false, no cursor will be drawn when tooltip is active.
 * If set an object, the option is the configuration of cursor.
 * If set a React element, the option is the custom react element of drawing cursor
 */ function RenderCursor(_ref) {
    var { cursor, cursorComp, cursorProps } = _ref;
    if (/*#__PURE__*/ (0, _react.isValidElement)(cursor)) return /*#__PURE__*/ (0, _react.cloneElement)(cursor, cursorProps);
    return /*#__PURE__*/ (0, _react.createElement)(cursorComp, cursorProps);
}
function CursorInternal(props) {
    var _props$zIndex;
    var { coordinate, payload, index, offset, tooltipAxisBandSize, layout, cursor, tooltipEventType, chartName } = props;
    // The cursor is a part of the Tooltip, and it should be shown (by default) when the Tooltip is active.
    var activeCoordinate = coordinate;
    var activePayload = payload;
    var activeTooltipIndex = index;
    if (!cursor || !activeCoordinate || chartName !== 'ScatterChart' && tooltipEventType !== 'axis') return null;
    var restProps, cursorComp, preferredZIndex;
    if (chartName === 'ScatterChart') {
        restProps = activeCoordinate;
        cursorComp = (0, _cross.Cross);
        preferredZIndex = (0, _defaultZIndexes.DefaultZIndexes).cursorLine;
    } else if (chartName === 'BarChart') {
        restProps = (0, _getCursorRectangle.getCursorRectangle)(layout, activeCoordinate, offset, tooltipAxisBandSize);
        cursorComp = (0, _rectangle.Rectangle);
        preferredZIndex = (0, _defaultZIndexes.DefaultZIndexes).cursorRectangle;
    } else if (layout === 'radial' && (0, _types.isPolarCoordinate)(activeCoordinate)) {
        var { cx, cy, radius, startAngle, endAngle } = (0, _getRadialCursorPoints.getRadialCursorPoints)(activeCoordinate);
        restProps = {
            cx,
            cy,
            startAngle,
            endAngle,
            innerRadius: radius,
            outerRadius: radius
        };
        cursorComp = (0, _sector.Sector);
        preferredZIndex = (0, _defaultZIndexes.DefaultZIndexes).cursorLine;
    } else {
        restProps = {
            points: (0, _getCursorPoints.getCursorPoints)(layout, activeCoordinate, offset)
        };
        cursorComp = (0, _curve.Curve);
        preferredZIndex = (0, _defaultZIndexes.DefaultZIndexes).cursorLine;
    }
    var extraClassName = typeof cursor === 'object' && 'className' in cursor ? cursor.className : undefined;
    var cursorProps = _objectSpread(_objectSpread(_objectSpread(_objectSpread({
        stroke: '#ccc',
        pointerEvents: 'none'
    }, offset), restProps), (0, _svgPropertiesNoEvents.svgPropertiesNoEventsFromUnknown)(cursor)), {}, {
        payload: activePayload,
        payloadIndex: activeTooltipIndex,
        className: (0, _clsx.clsx)('recharts-tooltip-cursor', extraClassName)
    });
    return /*#__PURE__*/ _react.createElement((0, _zindexLayer.ZIndexLayer), {
        zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : preferredZIndex
    }, /*#__PURE__*/ _react.createElement(RenderCursor, {
        cursor: cursor,
        cursorComp: cursorComp,
        cursorProps: cursorProps
    }));
}
function Cursor(props) {
    var tooltipAxisBandSize = (0, _useTooltipAxis.useTooltipAxisBandSize)();
    var offset = (0, _chartLayoutContext.useOffsetInternal)();
    var layout = (0, _chartLayoutContext.useChartLayout)();
    var chartName = (0, _selectors.useChartName)();
    if (tooltipAxisBandSize == null || offset == null || layout == null || chartName == null) return null;
    return /*#__PURE__*/ _react.createElement(CursorInternal, _extends({}, props, {
        offset: offset,
        layout: layout,
        tooltipAxisBandSize: tooltipAxisBandSize,
        chartName: chartName
    }));
}

},{"react":"bmhQu","clsx":"431Ou","../util/types":"9qdl2","../shape/Curve":"edkNn","../shape/Cross":"2TNIW","../util/cursor/getCursorRectangle":"f9fDJ","../shape/Rectangle":"juFRO","../util/cursor/getRadialCursorPoints":"4I2Ha","../shape/Sector":"kLwSx","../util/cursor/getCursorPoints":"dqzry","../context/chartLayoutContext":"jIUyy","../context/useTooltipAxis":"3E309","../state/selectors/selectors":"2uuUJ","../util/svgPropertiesNoEvents":"2NZlZ","../zIndex/ZIndexLayer":"6RR5t","../zIndex/DefaultZIndexes":"h8nlV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2TNIW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Cross", ()=>Cross);
/**
 * @fileOverview Cross
 */ var _react = require("react");
var _clsx = require("clsx");
var _dataUtils = require("../util/DataUtils");
var _svgPropertiesAndEvents = require("../util/svgPropertiesAndEvents");
var _excluded = [
    "x",
    "y",
    "top",
    "left",
    "width",
    "height",
    "className"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
var getPath = (x, y, width, height, top, left)=>{
    return "M".concat(x, ",").concat(top, "v").concat(height, "M").concat(left, ",").concat(y, "h").concat(width);
};
var Cross = (_ref)=>{
    var { x = 0, y = 0, top = 0, left = 0, width = 0, height = 0, className } = _ref, rest = _objectWithoutProperties(_ref, _excluded);
    var props = _objectSpread({
        x,
        y,
        top,
        left,
        width,
        height
    }, rest);
    if (!(0, _dataUtils.isNumber)(x) || !(0, _dataUtils.isNumber)(y) || !(0, _dataUtils.isNumber)(width) || !(0, _dataUtils.isNumber)(height) || !(0, _dataUtils.isNumber)(top) || !(0, _dataUtils.isNumber)(left)) return null;
    return /*#__PURE__*/ _react.createElement("path", _extends({}, (0, _svgPropertiesAndEvents.svgPropertiesAndEvents)(props), {
        className: (0, _clsx.clsx)('recharts-cross', className),
        d: getPath(x, y, width, height, top, left)
    }));
};

},{"react":"bmhQu","clsx":"431Ou","../util/DataUtils":"lNZEj","../util/svgPropertiesAndEvents":"6bogn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f9fDJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCursorRectangle", ()=>getCursorRectangle);
function getCursorRectangle(layout, activeCoordinate, offset, tooltipAxisBandSize) {
    var halfSize = tooltipAxisBandSize / 2;
    return {
        stroke: 'none',
        fill: '#ccc',
        x: layout === 'horizontal' ? activeCoordinate.x - halfSize : offset.left + 0.5,
        y: layout === 'horizontal' ? offset.top + 0.5 : activeCoordinate.y - halfSize,
        width: layout === 'horizontal' ? tooltipAxisBandSize : offset.width - 1,
        height: layout === 'horizontal' ? offset.height - 1 : tooltipAxisBandSize
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4I2Ha":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Only applicable for radial layouts
 * @param {Object} activeCoordinate ChartCoordinate
 * @returns {Object} RadialCursorPoints
 */ parcelHelpers.export(exports, "getRadialCursorPoints", ()=>getRadialCursorPoints);
var _polarUtils = require("../PolarUtils");
function getRadialCursorPoints(activeCoordinate) {
    var { cx, cy, radius, startAngle, endAngle } = activeCoordinate;
    var startPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, startAngle);
    var endPoint = (0, _polarUtils.polarToCartesian)(cx, cy, radius, endAngle);
    return {
        points: [
            startPoint,
            endPoint
        ],
        cx,
        cy,
        radius,
        startAngle,
        endAngle
    };
}

},{"../PolarUtils":"ezeVo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dqzry":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getCursorPoints", ()=>getCursorPoints);
var _polarUtils = require("../PolarUtils");
var _types = require("../types");
var _getRadialCursorPoints = require("./getRadialCursorPoints");
function getCursorPoints(layout, activeCoordinate, offset) {
    if (layout === 'horizontal') return [
        {
            x: activeCoordinate.x,
            y: offset.top
        },
        {
            x: activeCoordinate.x,
            y: offset.top + offset.height
        }
    ];
    if (layout === 'vertical') return [
        {
            x: offset.left,
            y: activeCoordinate.y
        },
        {
            x: offset.left + offset.width,
            y: activeCoordinate.y
        }
    ];
    if ((0, _types.isPolarCoordinate)(activeCoordinate)) {
        if (layout === 'centric') {
            var { cx, cy, innerRadius, outerRadius, angle } = activeCoordinate;
            var innerPoint = (0, _polarUtils.polarToCartesian)(cx, cy, innerRadius, angle);
            var outerPoint = (0, _polarUtils.polarToCartesian)(cx, cy, outerRadius, angle);
            return [
                {
                    x: innerPoint.x,
                    y: innerPoint.y
                },
                {
                    x: outerPoint.x,
                    y: outerPoint.y
                }
            ];
        }
        return (0, _getRadialCursorPoints.getRadialCursorPoints)(activeCoordinate);
    }
    return undefined;
}

},{"../PolarUtils":"ezeVo","../types":"9qdl2","./getRadialCursorPoints":"4I2Ha","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3E309":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useTooltipAxis", ()=>useTooltipAxis);
parcelHelpers.export(exports, "useTooltipAxisBandSize", ()=>useTooltipAxisBandSize);
var _hooks = require("../state/hooks");
var _chartUtils = require("../util/ChartUtils");
var _axisSelectors = require("../state/selectors/axisSelectors");
var _tooltipSelectors = require("../state/selectors/tooltipSelectors");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var useTooltipAxis = ()=>(0, _hooks.useAppSelector)((0, _axisSelectors.selectTooltipAxis));
var useTooltipAxisBandSize = ()=>{
    var tooltipAxis = useTooltipAxis();
    var tooltipTicks = (0, _hooks.useAppSelector)((0, _tooltipSelectors.selectTooltipAxisTicks));
    var tooltipAxisScale = (0, _hooks.useAppSelector)((0, _tooltipSelectors.selectTooltipAxisScale));
    if (!tooltipAxis || !tooltipAxisScale) return (0, _chartUtils.getBandSizeOfAxis)(undefined, tooltipTicks);
    return (0, _chartUtils.getBandSizeOfAxis)(_objectSpread(_objectSpread({}, tooltipAxis), {}, {
        scale: tooltipAxisScale
    }), tooltipTicks);
};

},{"../state/hooks":"aEuxu","../util/ChartUtils":"enJyE","../state/selectors/axisSelectors":"bvR8m","../state/selectors/tooltipSelectors":"hydW6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lpbvS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "xAxisDefaultProps", ()=>xAxisDefaultProps);
parcelHelpers.export(exports, "XAxis", ()=>XAxis);
/**
 * @fileOverview X Axis
 */ var _react = require("react");
var _clsx = require("clsx");
var _cartesianAxis = require("./CartesianAxis");
var _hooks = require("../state/hooks");
var _cartesianAxisSlice = require("../state/cartesianAxisSlice");
var _axisSelectors = require("../state/selectors/axisSelectors");
var _selectChartOffsetInternal = require("../state/selectors/selectChartOffsetInternal");
var _panoramaContext = require("../context/PanoramaContext");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
var _axisPropsAreEqual = require("../util/axisPropsAreEqual");
var _excluded = [
    "dangerouslySetInnerHTML",
    "ticks",
    "scale"
], _excluded2 = [
    "id",
    "scale"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function SetXAxisSettings(settings) {
    var dispatch = (0, _hooks.useAppDispatch)();
    var prevSettingsRef = (0, _react.useRef)(null);
    (0, _react.useLayoutEffect)(()=>{
        if (prevSettingsRef.current === null) dispatch((0, _cartesianAxisSlice.addXAxis)(settings));
        else if (prevSettingsRef.current !== settings) dispatch((0, _cartesianAxisSlice.replaceXAxis)({
            prev: prevSettingsRef.current,
            next: settings
        }));
        prevSettingsRef.current = settings;
    }, [
        settings,
        dispatch
    ]);
    (0, _react.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, _cartesianAxisSlice.removeXAxis)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
var XAxisImpl = (props)=>{
    var { xAxisId, className } = props;
    var viewBox = (0, _hooks.useAppSelector)((0, _selectChartOffsetInternal.selectAxisViewBox));
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    var axisType = 'xAxis';
    var cartesianTickItems = (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectTicksOfAxis)(state, axisType, xAxisId, isPanorama));
    var axisSize = (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectXAxisSize)(state, xAxisId));
    var position = (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectXAxisPosition)(state, xAxisId));
    /*
   * Here we select settings from the store and prefer to use them instead of the actual props
   * so that the chart is consistent. If we used the props directly, some components will use axis settings
   * from state and some from props and because there is a render step between these two, they might be showing different things.
   * https://github.com/recharts/recharts/issues/6257
   */ var synchronizedSettings = (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectXAxisSettingsNoDefaults)(state, xAxisId));
    if (axisSize == null || position == null || synchronizedSettings == null) return null;
    var { dangerouslySetInnerHTML, ticks, scale: del } = props, allOtherProps = _objectWithoutProperties(props, _excluded);
    var { id, scale: del2 } = synchronizedSettings, restSynchronizedSettings = _objectWithoutProperties(synchronizedSettings, _excluded2);
    return /*#__PURE__*/ _react.createElement((0, _cartesianAxis.CartesianAxis), _extends({}, allOtherProps, restSynchronizedSettings, {
        x: position.x,
        y: position.y,
        width: axisSize.width,
        height: axisSize.height,
        className: (0, _clsx.clsx)("recharts-".concat(axisType, " ").concat(axisType), className),
        viewBox: viewBox,
        ticks: cartesianTickItems,
        axisType: axisType
    }));
};
var xAxisDefaultProps = {
    allowDataOverflow: (0, _axisSelectors.implicitXAxis).allowDataOverflow,
    allowDecimals: (0, _axisSelectors.implicitXAxis).allowDecimals,
    allowDuplicatedCategory: (0, _axisSelectors.implicitXAxis).allowDuplicatedCategory,
    angle: (0, _axisSelectors.implicitXAxis).angle,
    axisLine: (0, _cartesianAxis.defaultCartesianAxisProps).axisLine,
    height: (0, _axisSelectors.implicitXAxis).height,
    hide: false,
    includeHidden: (0, _axisSelectors.implicitXAxis).includeHidden,
    interval: (0, _axisSelectors.implicitXAxis).interval,
    minTickGap: (0, _axisSelectors.implicitXAxis).minTickGap,
    mirror: (0, _axisSelectors.implicitXAxis).mirror,
    orientation: (0, _axisSelectors.implicitXAxis).orientation,
    padding: (0, _axisSelectors.implicitXAxis).padding,
    reversed: (0, _axisSelectors.implicitXAxis).reversed,
    scale: (0, _axisSelectors.implicitXAxis).scale,
    tick: (0, _axisSelectors.implicitXAxis).tick,
    tickCount: (0, _axisSelectors.implicitXAxis).tickCount,
    tickLine: (0, _cartesianAxis.defaultCartesianAxisProps).tickLine,
    tickSize: (0, _cartesianAxis.defaultCartesianAxisProps).tickSize,
    type: (0, _axisSelectors.implicitXAxis).type,
    xAxisId: 0
};
var XAxisSettingsDispatcher = (outsideProps)=>{
    var props = (0, _resolveDefaultProps.resolveDefaultProps)(outsideProps, xAxisDefaultProps);
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(SetXAxisSettings, {
        allowDataOverflow: props.allowDataOverflow,
        allowDecimals: props.allowDecimals,
        allowDuplicatedCategory: props.allowDuplicatedCategory,
        angle: props.angle,
        dataKey: props.dataKey,
        domain: props.domain,
        height: props.height,
        hide: props.hide,
        id: props.xAxisId,
        includeHidden: props.includeHidden,
        interval: props.interval,
        minTickGap: props.minTickGap,
        mirror: props.mirror,
        name: props.name,
        orientation: props.orientation,
        padding: props.padding,
        reversed: props.reversed,
        scale: props.scale,
        tick: props.tick,
        tickCount: props.tickCount,
        tickFormatter: props.tickFormatter,
        ticks: props.ticks,
        type: props.type,
        unit: props.unit
    }), /*#__PURE__*/ _react.createElement(XAxisImpl, props));
};
var XAxis = /*#__PURE__*/ _react.memo(XAxisSettingsDispatcher, (0, _axisPropsAreEqual.axisPropsAreEqual));
XAxis.displayName = 'XAxis';

},{"react":"bmhQu","clsx":"431Ou","./CartesianAxis":"d3UBS","../state/hooks":"aEuxu","../state/cartesianAxisSlice":"284SY","../state/selectors/axisSelectors":"bvR8m","../state/selectors/selectChartOffsetInternal":"caUjq","../context/PanoramaContext":"10hMm","../util/resolveDefaultProps":"cWUqx","../util/axisPropsAreEqual":"aPjHF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aPjHF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Usually we would not compare array props deeply for performance consideration.
 * However, for axis props, domain is sometimes defined as a two-elements array, and range is always
 * a two-elements array. So we can do a shallow comparison for the rest props and a shallow
 * comparison for these two array props.
 * @param prevProps
 * @param nextProps
 */ parcelHelpers.export(exports, "axisPropsAreEqual", ()=>axisPropsAreEqual);
var _propsAreEqual = require("./propsAreEqual");
var _excluded = [
    "domain",
    "range"
], _excluded2 = [
    "domain",
    "range"
];
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function shortArraysAreEqual(arr1, arr2) {
    if (arr1 === arr2) return true;
    if (Array.isArray(arr1) && arr1.length === 2 && Array.isArray(arr2) && arr2.length === 2) return arr1[0] === arr2[0] && arr1[1] === arr2[1];
    return false;
}
function axisPropsAreEqual(prevProps, nextProps) {
    if (prevProps === nextProps) return true;
    var { domain: prevDomain, range: prevRange } = prevProps, prevRest = _objectWithoutProperties(prevProps, _excluded);
    var { domain: nextDomain, range: nextRange } = nextProps, nextRest = _objectWithoutProperties(nextProps, _excluded2);
    if (!shortArraysAreEqual(prevDomain, nextDomain)) return false;
    if (!shortArraysAreEqual(prevRange, nextRange)) return false;
    return (0, _propsAreEqual.propsAreEqual)(prevRest, nextRest);
}

},{"./propsAreEqual":"eGfhC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iccw2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "yAxisDefaultProps", ()=>yAxisDefaultProps);
parcelHelpers.export(exports, "YAxis", ()=>YAxis);
var _react = require("react");
var _clsx = require("clsx");
var _cartesianAxis = require("./CartesianAxis");
var _cartesianAxisSlice = require("../state/cartesianAxisSlice");
var _hooks = require("../state/hooks");
var _axisSelectors = require("../state/selectors/axisSelectors");
var _selectChartOffsetInternal = require("../state/selectors/selectChartOffsetInternal");
var _panoramaContext = require("../context/PanoramaContext");
var _label = require("../component/Label");
var _resolveDefaultProps = require("../util/resolveDefaultProps");
var _axisPropsAreEqual = require("../util/axisPropsAreEqual");
var _excluded = [
    "dangerouslySetInnerHTML",
    "ticks",
    "scale"
], _excluded2 = [
    "id",
    "scale"
];
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _objectWithoutProperties(e, t) {
    if (null == e) return {};
    var o, r, i = _objectWithoutPropertiesLoose(e, t);
    if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function SetYAxisSettings(settings) {
    var dispatch = (0, _hooks.useAppDispatch)();
    var prevSettingsRef = (0, _react.useRef)(null);
    (0, _react.useLayoutEffect)(()=>{
        if (prevSettingsRef.current === null) dispatch((0, _cartesianAxisSlice.addYAxis)(settings));
        else if (prevSettingsRef.current !== settings) dispatch((0, _cartesianAxisSlice.replaceYAxis)({
            prev: prevSettingsRef.current,
            next: settings
        }));
        prevSettingsRef.current = settings;
    }, [
        settings,
        dispatch
    ]);
    (0, _react.useLayoutEffect)(()=>{
        return ()=>{
            if (prevSettingsRef.current) {
                dispatch((0, _cartesianAxisSlice.removeYAxis)(prevSettingsRef.current));
                prevSettingsRef.current = null;
            }
        };
    }, [
        dispatch
    ]);
    return null;
}
var YAxisImpl = (props)=>{
    var { yAxisId, className, width, label } = props;
    var cartesianAxisRef = (0, _react.useRef)(null);
    var labelRef = (0, _react.useRef)(null);
    var viewBox = (0, _hooks.useAppSelector)((0, _selectChartOffsetInternal.selectAxisViewBox));
    var isPanorama = (0, _panoramaContext.useIsPanorama)();
    var dispatch = (0, _hooks.useAppDispatch)();
    var axisType = 'yAxis';
    var axisSize = (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectYAxisSize)(state, yAxisId));
    var position = (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectYAxisPosition)(state, yAxisId));
    var cartesianTickItems = (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectTicksOfAxis)(state, axisType, yAxisId, isPanorama));
    /*
   * Here we select settings from the store and prefer to use them instead of the actual props
   * so that the chart is consistent. If we used the props directly, some components will use axis settings
   * from state and some from props and because there is a render step between these two, they might be showing different things.
   * https://github.com/recharts/recharts/issues/6257
   */ var synchronizedSettings = (0, _hooks.useAppSelector)((state)=>(0, _axisSelectors.selectYAxisSettingsNoDefaults)(state, yAxisId));
    (0, _react.useLayoutEffect)(()=>{
        // No dynamic width calculation is done when width !== 'auto'
        // or when a function/react element is used for label
        if (width !== 'auto' || !axisSize || (0, _label.isLabelContentAFunction)(label) || /*#__PURE__*/ (0, _react.isValidElement)(label) || synchronizedSettings == null) return;
        var axisComponent = cartesianAxisRef.current;
        if (!axisComponent) return;
        var updatedYAxisWidth = axisComponent.getCalculatedWidth();
        // if the width has changed, dispatch an action to update the width
        if (Math.round(axisSize.width) !== Math.round(updatedYAxisWidth)) dispatch((0, _cartesianAxisSlice.updateYAxisWidth)({
            id: yAxisId,
            width: updatedYAxisWidth
        }));
    }, [
        // The dependency on cartesianAxisRef.current is not needed because useLayoutEffect will run after every render.
        // The ref will be populated by then.
        // To re-run this effect when ticks change, we can depend on the ticks array from the store.
        cartesianTickItems,
        axisSize,
        dispatch,
        label,
        yAxisId,
        width,
        synchronizedSettings
    ]);
    if (axisSize == null || position == null || synchronizedSettings == null) return null;
    var { dangerouslySetInnerHTML, ticks, scale: del } = props, allOtherProps = _objectWithoutProperties(props, _excluded);
    var { id, scale: del2 } = synchronizedSettings, restSynchronizedSettings = _objectWithoutProperties(synchronizedSettings, _excluded2);
    return /*#__PURE__*/ _react.createElement((0, _cartesianAxis.CartesianAxis), _extends({}, allOtherProps, restSynchronizedSettings, {
        ref: cartesianAxisRef,
        labelRef: labelRef,
        x: position.x,
        y: position.y,
        tickTextProps: width === 'auto' ? {
            width: undefined
        } : {
            width
        },
        width: axisSize.width,
        height: axisSize.height,
        className: (0, _clsx.clsx)("recharts-".concat(axisType, " ").concat(axisType), className),
        viewBox: viewBox,
        ticks: cartesianTickItems,
        axisType: axisType
    }));
};
var yAxisDefaultProps = {
    allowDataOverflow: (0, _axisSelectors.implicitYAxis).allowDataOverflow,
    allowDecimals: (0, _axisSelectors.implicitYAxis).allowDecimals,
    allowDuplicatedCategory: (0, _axisSelectors.implicitYAxis).allowDuplicatedCategory,
    angle: (0, _axisSelectors.implicitYAxis).angle,
    axisLine: (0, _cartesianAxis.defaultCartesianAxisProps).axisLine,
    hide: false,
    includeHidden: (0, _axisSelectors.implicitYAxis).includeHidden,
    interval: (0, _axisSelectors.implicitYAxis).interval,
    minTickGap: (0, _axisSelectors.implicitYAxis).minTickGap,
    mirror: (0, _axisSelectors.implicitYAxis).mirror,
    orientation: (0, _axisSelectors.implicitYAxis).orientation,
    padding: (0, _axisSelectors.implicitYAxis).padding,
    reversed: (0, _axisSelectors.implicitYAxis).reversed,
    scale: (0, _axisSelectors.implicitYAxis).scale,
    tick: (0, _axisSelectors.implicitYAxis).tick,
    tickCount: (0, _axisSelectors.implicitYAxis).tickCount,
    tickLine: (0, _cartesianAxis.defaultCartesianAxisProps).tickLine,
    tickSize: (0, _cartesianAxis.defaultCartesianAxisProps).tickSize,
    type: (0, _axisSelectors.implicitYAxis).type,
    width: (0, _axisSelectors.implicitYAxis).width,
    yAxisId: 0
};
var YAxisSettingsDispatcher = (outsideProps)=>{
    var props = (0, _resolveDefaultProps.resolveDefaultProps)(outsideProps, yAxisDefaultProps);
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(SetYAxisSettings, {
        interval: props.interval,
        id: props.yAxisId,
        scale: props.scale,
        type: props.type,
        domain: props.domain,
        allowDataOverflow: props.allowDataOverflow,
        dataKey: props.dataKey,
        allowDuplicatedCategory: props.allowDuplicatedCategory,
        allowDecimals: props.allowDecimals,
        tickCount: props.tickCount,
        padding: props.padding,
        includeHidden: props.includeHidden,
        reversed: props.reversed,
        ticks: props.ticks,
        width: props.width,
        orientation: props.orientation,
        mirror: props.mirror,
        hide: props.hide,
        unit: props.unit,
        name: props.name,
        angle: props.angle,
        minTickGap: props.minTickGap,
        tick: props.tick,
        tickFormatter: props.tickFormatter
    }), /*#__PURE__*/ _react.createElement(YAxisImpl, props));
};
var YAxis = /*#__PURE__*/ _react.memo(YAxisSettingsDispatcher, (0, _axisPropsAreEqual.axisPropsAreEqual));
YAxis.displayName = 'YAxis';

},{"react":"bmhQu","clsx":"431Ou","./CartesianAxis":"d3UBS","../state/cartesianAxisSlice":"284SY","../state/hooks":"aEuxu","../state/selectors/axisSelectors":"bvR8m","../state/selectors/selectChartOffsetInternal":"caUjq","../context/PanoramaContext":"10hMm","../component/Label":"feVPQ","../util/resolveDefaultProps":"cWUqx","../util/axisPropsAreEqual":"aPjHF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fwzp4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgUp);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUp = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 7,
        height: 8,
        fill: "none",
        viewBox: "0 0 7 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#71BE41",
            d: "M4.333 7.463c0 .2-.163.363-.364.363H2.377a.364.364 0 0 1-.363-.363V4.149c0-.2-.163-.363-.364-.363H.365a.364.364 0 0 1-.268-.61L2.906.118a.364.364 0 0 1 .535 0L6.25 3.176a.364.364 0 0 1-.268.61H4.697c-.201 0-.364.163-.364.363z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5HSNL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDown = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 7,
        height: 8,
        fill: "none",
        viewBox: "0 0 7 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#ED4040",
            d: "M2.014.364c0-.201.163-.364.363-.364H3.97c.201 0 .364.163.364.364v3.313c0 .2.163.363.363.363h1.286c.316 0 .482.377.268.61L3.44 7.708a.364.364 0 0 1-.536 0L.097 4.65a.364.364 0 0 1 .268-.61H1.65c.2 0 .364-.162.364-.363z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bt8O1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WorkoutDetails", ()=>WorkoutDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _navArrowIconSvg = require("src/assets/images/trainer/clients/nav-arrow-icon.svg");
var _workoutsSummarySvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/workouts-summary.svg");
var _workoutDurationSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/workout-duration.svg");
var _exercisesSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/exercises.svg");
var _caloriesEstSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/calories-est.svg");
var _performanceOverviewSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/performance-overview.svg");
var _aiObservationsSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/ai-observations.svg");
var _muscleFocusSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/muscle-focus.svg");
var _workoutMetricsSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/workout-metrics.svg");
var _avgHeartRateSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/avg-heart-rate.svg");
var _totalRepsSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/total-reps.svg");
var _volumeSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/volume.svg");
var _restTimeSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/rest-time.svg");
var _postureSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/posture.svg");
var _depthSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/depth.svg");
var _kneeAlignmentSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/knee-alignment.svg");
var _coreStabilitySvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/core-stability.svg");
var _muscleGroupImages = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/ProgramGeneratorAI/assets/MuscleGroupImages");
var _useGetAllMovements = require("src/api/queries/useGetAllMovements");
var _useGetClientWorkoutDetails = require("src/api/queries/useGetClientWorkoutDetails");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _genderUtils = require("src/utils/genderUtils");
var _workoutDetailsScss = require("./WorkoutDetails.scss");
const WorkoutDetails = ()=>{
    const { uid, workoutId } = (0, _reactRouterDom.useParams)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { client } = (0, _reactRouterDom.useOutletContext)();
    const { data: workoutDetails, isLoading: isDetailsLoading } = (0, _useGetClientWorkoutDetails.useGetClientWorkoutDetails)({
        clientId: uid || '',
        workoutId: workoutId || ''
    });
    const { data: programMasterData } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const [expandedExercise, setExpandedExercise] = (0, _react.useState)(2);
    const toggleExercise = (index)=>{
        setExpandedExercise(expandedExercise === index ? null : index);
    };
    const { data: allMovements = [] } = (0, _useGetAllMovements.useGetAllMovements)();
    const normalize = (str)=>(str || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    const isFemale = (0, _genderUtils.isFemaleProfile)(workoutDetails || client);
    const getExerciseImageUrl = (apiEx)=>{
        if (isFemale && apiEx.image_female_url) return apiEx.image_female_url;
        if (!isFemale && apiEx.image_male_url) return apiEx.image_male_url;
        if (apiEx.image_male_url || apiEx.image_female_url) return isFemale ? apiEx.image_female_url || apiEx.image_male_url : apiEx.image_male_url || apiEx.image_female_url;
        const normTitle = normalize(apiEx.title || apiEx.name || '');
        const matched = allMovements.find((m)=>normalize(m.id || m._id) === normTitle || normalize(m.en_display_name) === normTitle);
        if (matched) return isFemale ? matched.image_female_url || matched.image_male_url : matched.image_male_url || matched.image_female_url;
        return '';
    };
    const apiExercises = workoutDetails?.workoutExercises || [];
    const getSlugTitle = (slug)=>{
        if (!slug) return '';
        if (!programMasterData) return slug.split(/[-_]/).map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
        let result = null;
        const search = (obj)=>{
            if (result) return;
            if (!obj || typeof obj !== 'object') return;
            const itemSlug = obj.slug || obj.id;
            if (itemSlug && typeof itemSlug === 'string') {
                const normalizedObjSlug = itemSlug.replace(/[-_]/g, '_').toLowerCase();
                const normalizedTargetSlug = slug.replace(/[-_]/g, '_').toLowerCase();
                if (normalizedObjSlug === normalizedTargetSlug && obj.title) {
                    result = obj.title;
                    return;
                }
            }
            if (Array.isArray(obj)) obj.forEach(search);
            else Object.values(obj).forEach(search);
        };
        search(programMasterData);
        if (result) return result;
        return slug.split(/[-_]/).map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };
    const primaryGoalTitle = workoutDetails?.primaryGoal ? workoutDetails.primaryGoal.split(',').map((s)=>getSlugTitle(s.trim())).filter(Boolean).join(', ') : 'Not specified';
    const secondaryGoalTitles = workoutDetails?.secondaryGoals?.length ? workoutDetails.secondaryGoals.map((slug)=>getSlugTitle(slug)).filter(Boolean).join(', ') : 'Not specified';
    let formattedRestTime = '0s';
    if (workoutDetails?.workoutMetrics) {
        const totalSecs = workoutDetails.workoutMetrics.restTimeSecs || 0;
        if (totalSecs >= 60) {
            const mins = Math.floor(totalSecs / 60);
            const secs = totalSecs % 60;
            formattedRestTime = secs > 0 ? `${mins}m ${secs}s` : `${mins} min`;
        } else formattedRestTime = `${totalSecs}s`;
    }
    const getMuscleKey = (group)=>{
        const normalized = group.toLowerCase().replace(/-/g, '_');
        if (normalized.includes('full_body') || normalized.includes('total_body')) return 'full_body';
        if (normalized.includes('upper_body') || normalized.includes('shoulder') || normalized.includes('chest') || normalized.includes('arm') || normalized.includes('bicep') || normalized.includes('tricep') || normalized.includes('wrist') || normalized.includes('neck') || normalized.includes('elbow')) return 'upper_body';
        if (normalized.includes('lower_body') || normalized.includes('leg') || normalized.includes('quad') || normalized.includes('hamstring') || normalized.includes('knee') || normalized.includes('ankle') || normalized.includes('calf') || normalized.includes('calves') || normalized.includes('feet') || normalized.includes('foot')) return 'lower_body';
        if (normalized.includes('back') || normalized.includes('spine') || normalized.includes('lat')) return 'back';
        if (normalized.includes('core') || normalized.includes('abs') || normalized.includes('abdominal')) return 'core';
        if (normalized.includes('glute') || normalized.includes('hip')) return 'glutes';
        return normalized;
    };
    const bodyProfile = workoutDetails?.clientBodyProfile?.toLowerCase() === 'male' ? 'male' : 'female';
    const muscleGroups = workoutDetails?.muscleGroups || [];
    const exercises = apiExercises.map((apiEx)=>{
        let statusClass = 'upcoming';
        if (apiEx.status === 'Completed') {
            if (apiEx.formLabel === 'Great') statusClass = 'great';
            else if (apiEx.formLabel === 'Good') statusClass = 'good';
            else statusClass = 'needs-focus';
        }
        const sets = apiEx.setsCount || 0;
        const reps = apiEx.repsOrDurationLabel || '-';
        let formText = 'Upcoming...';
        if (apiEx.status === 'Completed') {
            if (apiEx.formLabel === 'Needs Focus' || apiEx.formLabel === 'Bad') formText = 'Needs Focus';
            else if (apiEx.formLabel) formText = `${apiEx.formLabel} Form`;
            else formText = 'Completed';
        }
        return {
            name: apiEx.title,
            duration: `${sets} \xd7 ${reps}`,
            score: apiEx.formScore,
            form: formText,
            status: statusClass,
            image: getExerciseImageUrl(apiEx),
            details: apiEx.details
        };
    });
    let isCompleted = false;
    if (workoutDetails?.ymd) {
        const ymd = workoutDetails.ymd;
        const selectTime = workoutDetails.selectTime || '00:00';
        const workoutDateTime = (0, _dayjsDefault.default)(`${ymd}T${selectTime}:00`);
        if (workoutDateTime.isBefore((0, _dayjsDefault.default)())) isCompleted = true;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "workout-details-page",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "wd-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-left",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "back-btn",
                                onClick: ()=>navigate(`/onboarding-trainer/dashboard/clients/${uid}/overview`),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navArrowIconSvg.ReactComponent), {
                                    className: "back-icon"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h1", {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "title-main",
                                        children: [
                                            workoutId,
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("sup", {
                                                children: workoutId === '1' ? 'st' : workoutId === '2' ? 'nd' : workoutId === '3' ? 'rd' : 'th'
                                            }),
                                            ' ',
                                            "program's workout"
                                        ]
                                    }),
                                    workoutDetails?.dateLabel && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "subtitle",
                                        children: [
                                            "\u2022 ",
                                            workoutDetails.dateLabel
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `status-badge ${isCompleted ? 'completed' : 'in-progress'}`,
                        children: isCompleted ? 'COMPLETED' : 'IN PROGRESS...'
                    })
                ]
            }),
            isDetailsLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '300px'
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                    indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                        style: {
                            fontSize: 24,
                            color: '#fff'
                        },
                        spin: true
                    })
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "wd-content-grid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "wd-card workouts-summary-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "wd-card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _workoutsSummarySvg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        children: "Workouts summary"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "wd-card-content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "summary-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _workoutDurationSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Workout duration"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: isDetailsLoading ? '...' : workoutDetails?.durationMin ? `${workoutDetails.durationMin} min` : '-'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "summary-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exercisesSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Exercises"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: isDetailsLoading ? '...' : workoutDetails?.exercisesCount || 0
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "summary-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _caloriesEstSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Calories (est.)"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: isDetailsLoading ? '...' : workoutDetails?.caloriesEst ? `${workoutDetails.caloriesEst} kcal` : '-'
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "wd-card mobile-only ai-observations-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "wd-card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _aiObservationsSvg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        children: "AI Observations"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "wd-card-content overarching-ai",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    style: {
                                        color: 'var(--auth-text-muted)',
                                        margin: 0,
                                        fontSize: '14px',
                                        lineHeight: '22px'
                                    },
                                    children: workoutDetails?.aiObservations || 'No Data'
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "wd-card performance-overview-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "wd-card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _performanceOverviewSvg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        children: "Performance Overview"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "wd-card-content performance-content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "donut-chart-container",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "donut-ring",
                                            style: {
                                                background: `conic-gradient(from 140deg, ${workoutDetails?.performanceOverview?.colorHex || '#7bc14f'} ${(workoutDetails?.performanceOverview?.overallScore || 0) / 100 * 360}deg, #00000033 ${(workoutDetails?.performanceOverview?.overallScore || 0) / 100 * 360}deg)`
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "donut-inner",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "donut-score",
                                                        style: {
                                                            color: workoutDetails?.performanceOverview?.colorHex || '#7bc14f'
                                                        },
                                                        children: [
                                                            workoutDetails?.performanceOverview?.overallScore || 0,
                                                            "%"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "donut-label",
                                                        style: {
                                                            color: workoutDetails?.performanceOverview?.colorHex || '#7bc14f'
                                                        },
                                                        children: "Overall Score"
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "performance-legend",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "legend-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "dot dot-great"
                                                    }),
                                                    " Great Form",
                                                    ' ',
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                                        children: workoutDetails?.performanceOverview?.greatCount || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "legend-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "dot dot-good"
                                                    }),
                                                    " Good Form",
                                                    ' ',
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                                        children: workoutDetails?.performanceOverview?.goodCount || 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "legend-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "dot dot-needs-focus"
                                                    }),
                                                    " Needs Focus",
                                                    ' ',
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                                        children: workoutDetails?.performanceOverview?.needsFocusCount ?? workoutDetails?.performanceOverview?.badCount ?? 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "legend-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "dot dot-skipped"
                                                    }),
                                                    " Skipped",
                                                    ' ',
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                                        children: workoutDetails?.performanceOverview?.skippedCount || 0
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "wd-card workout-exercises-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "wd-card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exercisesSvg.ReactComponent), {
                                        className: "workout-exercises-icon"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        children: "Workout Exercises"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "wd-card-content",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "exercise-list",
                                    children: exercises.map((ex, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: `exercise-item ${expandedExercise === index ? 'expanded' : ''}`,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "exercise-header",
                                                    onClick: ()=>toggleExercise(index),
                                                    children: [
                                                        ex.image ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: ex.image,
                                                            alt: ex.name,
                                                            className: "ex-img"
                                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "ex-img",
                                                            children: (ex.name || 'EX').substring(0, 2)
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "ex-header-right",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "ex-text",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "ex-name",
                                                                            children: ex.name
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "ex-dur",
                                                                            children: ex.duration
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "ex-score-box",
                                                                    children: [
                                                                        ex.score !== undefined && ex.score !== null ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: `score-value ${ex.status}`,
                                                                            children: [
                                                                                ex.score,
                                                                                "%"
                                                                            ]
                                                                        }) : null,
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: `form-label ${ex.status}`,
                                                                            children: ex.form
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "ex-chevron",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _navArrowIconSvg.ReactComponent), {
                                                                        style: {
                                                                            transform: expandedExercise === index ? 'rotate(-90deg)' : 'rotate(90deg)'
                                                                        }
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                expandedExercise === index && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "exercise-details",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "details-grid",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "details-box",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                        className: "box-title",
                                                                        children: "Body Tracking"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "tracking-list",
                                                                        children: (ex.details?.bodyTracking || [
                                                                            {
                                                                                label: 'Posture',
                                                                                value: 'No Data',
                                                                                status: 'no-data'
                                                                            },
                                                                            {
                                                                                label: 'Depth',
                                                                                value: 'No Data',
                                                                                status: 'no-data'
                                                                            },
                                                                            {
                                                                                label: 'Knee Alignment',
                                                                                value: 'No Data',
                                                                                status: 'no-data'
                                                                            },
                                                                            {
                                                                                label: 'Core Stability',
                                                                                value: 'No Data',
                                                                                status: 'no-data'
                                                                            }
                                                                        ]).map((tr, i)=>{
                                                                            const renderIcon = ()=>{
                                                                                if (tr.icon) return tr.icon;
                                                                                switch(tr.label){
                                                                                    case 'Posture':
                                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _postureSvg.ReactComponent), {});
                                                                                    case 'Depth':
                                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _depthSvg.ReactComponent), {});
                                                                                    case 'Knee Alignment':
                                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _kneeAlignmentSvg.ReactComponent), {});
                                                                                    case 'Core Stability':
                                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _coreStabilitySvg.ReactComponent), {});
                                                                                    default:
                                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _postureSvg.ReactComponent), {});
                                                                                }
                                                                            };
                                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "tracking-item",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                        className: "tr-left",
                                                                                        children: [
                                                                                            renderIcon(),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                                children: tr.label
                                                                                            })
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: `tr-right ${tr.status || 'no-data'}`,
                                                                                        children: tr.value || 'No Data'
                                                                                    })
                                                                                ]
                                                                            }, i);
                                                                        })
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "details-box ai-observations-nested",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "ai-title",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _aiObservationsSvg.ReactComponent), {}),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                                className: "box-title",
                                                                                children: "AI Observations"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                        children: ex.details?.aiObservations || 'No Data'
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        }, index))
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "muscle-metrics-wrapper",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "wd-card muscle-focus-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "wd-card-header",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _muscleFocusSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                children: "Muscle Focus"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "wd-card-content muscle-focus-content",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "trainer-program-focus-image-wrapper static-view",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: (0, _muscleGroupImages.MuscleGroupImages)[bodyProfile].base,
                                                        className: "muscle-group",
                                                        alt: 'muscleGroup'
                                                    }),
                                                    muscleGroups.map((group)=>{
                                                        const muscleKey = getMuscleKey(group);
                                                        const imageSrc = (0, _muscleGroupImages.MuscleGroupImages)[bodyProfile][muscleKey];
                                                        if (!imageSrc) return null;
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: imageSrc,
                                                            className: "muscle-group-item active",
                                                            alt: group
                                                        }, group);
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "muscle-focus-labels",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "mf-label",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "mf-title",
                                                                children: "Primary"
                                                            }),
                                                            " ",
                                                            primaryGoalTitle
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "mf-label",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "mf-title",
                                                                children: "Secondary"
                                                            }),
                                                            " ",
                                                            secondaryGoalTitles
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "wd-card workout-metrics-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "wd-card-header",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _workoutMetricsSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                children: "Workout Metrics"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "wd-card-content",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "summary-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _avgHeartRateSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "Avg. Heart Rate"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: "--"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "summary-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _totalRepsSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "Total Reps"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: workoutDetails?.workoutMetrics?.totalReps ?? 0
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "summary-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _volumeSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "Volume"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "value",
                                                        children: [
                                                            workoutDetails?.workoutMetrics?.volume ?? 0,
                                                            ' ',
                                                            workoutDetails?.workoutMetrics?.weightUnit ?? 'kg'
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "summary-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _restTimeSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "Rest Time"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value",
                                                        children: formattedRestTime
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["useNavigate","f3cgC"],["useOutletContext","9oT3O"],["useParams","9oT3O"]],"dayjs":"adpMK","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"src/assets/images/trainer/clients/nav-arrow-icon.svg":"3jSUC","src/assets/images/onboarding-trainer/dashboard/clients/workouts/workouts-summary.svg":"isS6W","src/assets/images/onboarding-trainer/dashboard/clients/workouts/workout-duration.svg":"hvOvz","src/assets/images/onboarding-trainer/dashboard/clients/workouts/exercises.svg":"jCcPb","src/assets/images/onboarding-trainer/dashboard/clients/workouts/calories-est.svg":"iC6us","src/assets/images/onboarding-trainer/dashboard/clients/workouts/performance-overview.svg":"fP7ko","src/assets/images/onboarding-trainer/dashboard/clients/workouts/ai-observations.svg":"jPIL3","src/assets/images/onboarding-trainer/dashboard/clients/workouts/muscle-focus.svg":"dCoA7","src/assets/images/onboarding-trainer/dashboard/clients/workouts/workout-metrics.svg":"3pzsf","src/assets/images/onboarding-trainer/dashboard/clients/workouts/avg-heart-rate.svg":"6Bp1m","src/assets/images/onboarding-trainer/dashboard/clients/workouts/total-reps.svg":"3sIYB","src/assets/images/onboarding-trainer/dashboard/clients/workouts/volume.svg":"hvtmi","src/assets/images/onboarding-trainer/dashboard/clients/workouts/rest-time.svg":"8y4GQ","src/assets/images/onboarding-trainer/dashboard/clients/workouts/posture.svg":"8jLhU","src/assets/images/onboarding-trainer/dashboard/clients/workouts/depth.svg":"9aj9W","src/assets/images/onboarding-trainer/dashboard/clients/workouts/knee-alignment.svg":"ee2Sl","src/assets/images/onboarding-trainer/dashboard/clients/workouts/core-stability.svg":"2EQob","src/screens/OnboardingTrainer/screens/Dashboard/screens/ProgramGeneratorAI/assets/MuscleGroupImages":"9D5GI","src/api/queries/useGetAllMovements":"lveJ0","src/api/queries/useGetClientWorkoutDetails":"cPrSq","src/api/mutations/useGetProgramMasterData":"bOtFg","src/utils/genderUtils":"aiA54","./WorkoutDetails.scss":"ixY24","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"isS6W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgWorkoutsSummary);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgWorkoutsSummary = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#755ADF",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#755ADF",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#755ADF",
                fillRule: "evenodd",
                d: "M11 8.5A2.5 2.5 0 0 0 8.5 11v10a2.5 2.5 0 0 0 2.5 2.5h10a2.5 2.5 0 0 0 2.5-2.5V11A2.5 2.5 0 0 0 21 8.5zm3.333 4.167a.833.833 0 0 1 .834-.834h5a.833.833 0 0 1 0 1.667h-5a.833.833 0 0 1-.834-.833m0 3.333a.833.833 0 0 1 .834-.833h5a.834.834 0 0 1 0 1.666h-5a.834.834 0 0 1-.834-.833m0 3.333a.833.833 0 0 1 .834-.833h5a.833.833 0 0 1 0 1.667h-5a.833.833 0 0 1-.834-.834m-2.5-7.5a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667M11 16a.833.833 0 1 1 1.667 0A.833.833 0 0 1 11 16m.833 2.5a.833.833 0 1 0 0 1.666.833.833 0 0 0 0-1.666",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hvOvz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgWorkoutDuration);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgWorkoutDuration = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M14.444 9.024a.76.76 0 0 1-.777-.762q0-.322.224-.543a.76.76 0 0 1 .553-.219h3.112q.33 0 .554.22t.223.542a.74.74 0 0 1-.224.543.75.75 0 0 1-.553.219zM16 17.404q.33 0 .555-.219a.73.73 0 0 0 .223-.542v-3.048a.73.73 0 0 0-.224-.542.77.77 0 0 0-.554-.22.76.76 0 0 0-.554.22.73.73 0 0 0-.224.542v3.048a.758.758 0 0 0 .778.762m0 6.096q-1.44 0-2.713-.543A7.02 7.02 0 0 1 9.554 19.3 6.5 6.5 0 0 1 9 16.644q0-1.41.555-2.658a7 7 0 0 1 1.506-2.18 7.2 7.2 0 0 1 2.227-1.476A6.8 6.8 0 0 1 16 9.786q1.206 0 2.314.38a7.6 7.6 0 0 1 2.08 1.105l.545-.533a.75.75 0 0 1 .544-.21q.33 0 .545.21.213.21.214.533a.72.72 0 0 1-.214.534l-.545.533a7.4 7.4 0 0 1 1.128 2.038q.39 1.086.389 2.267a6.5 6.5 0 0 1-.555 2.657 7 7 0 0 1-1.506 2.18 7.2 7.2 0 0 1-2.227 1.477A6.8 6.8 0 0 1 16 23.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jCcPb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgExercises);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgExercises = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                fillRule: "evenodd",
                d: "M10.65 10.73c.204-.116.519-.23.95-.23s.746.114.95.23c.316.18.41.486.415.704.01.436.035 1.872.035 4.566s-.026 4.13-.035 4.566a.82.82 0 0 1-.415.704c-.204.116-.519.23-.95.23s-.746-.114-.95-.23a.82.82 0 0 1-.415-.704A227 227 0 0 1 10.2 16c0-2.694.026-4.13.035-4.566a.82.82 0 0 1 .415-.704m10.7 0a1.9 1.9 0 0 0-.95-.23c-.431 0-.746.114-.95.23a.82.82 0 0 0-.415.704C19.025 11.87 19 13.306 19 16s.026 4.13.035 4.566a.82.82 0 0 0 .415.704c.204.116.519.23.95.23s.746-.114.95-.23a.82.82 0 0 0 .415-.704c.01-.436.035-1.872.035-4.566s-.026-4.13-.035-4.566a.82.82 0 0 0-.415-.704M8.2 12.397c-.264 0-.476.045-.638.105a.82.82 0 0 0-.538.758C7.016 13.6 7 14.473 7 16s.016 2.4.024 2.74c.006.244.132.61.538.758.162.06.374.105.638.105s.476-.045.638-.105a.82.82 0 0 0 .538-.758c.008-.34.024-1.213.024-2.74s-.016-2.4-.024-2.74a.82.82 0 0 0-.538-.758 1.9 1.9 0 0 0-.638-.105m16.238.105a1.9 1.9 0 0 0-.638-.105c-.264 0-.476.045-.638.105a.82.82 0 0 0-.538.758c-.008.34-.024 1.213-.024 2.74s.016 2.4.024 2.74c.006.244.132.61.538.758.162.06.374.105.638.105s.476-.045.638-.105a.82.82 0 0 0 .538-.758c.008-.34.024-1.213.024-2.74s-.016-2.4-.024-2.74a.82.82 0 0 0-.538-.758M13.8 17.084v-2.168c0-.36.31-.548.641-.575q.102-.01.306-.02c.272-.014.683-.028 1.253-.028s.981.014 1.253.028q.204.01.306.02c.33.026.641.216.641.575v2.168c0 .36-.31.548-.641.575q-.103.01-.306.02c-.272.014-.683.028-1.253.028s-.981-.014-1.253-.028a9 9 0 0 1-.306-.02c-.33-.026-.641-.216-.641-.575",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iC6us":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCaloriesEst);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCaloriesEst = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M21.67 15.245c-.23-.284-.51-.53-.77-.775-.67-.567-1.43-.973-2.07-1.568-1.49-1.379-1.82-3.655-.87-5.402-.95.217-1.78.708-2.489 1.247-2.59 1.964-3.61 5.43-2.39 8.406.04.094.08.188.08.311 0 .208-.15.397-.35.472-.23.095-.47.038-.66-.113a.6.6 0 0 1-.14-.16c-1.13-1.351-1.31-3.287-.55-4.836-1.669 1.284-2.579 3.457-2.449 5.506.06.472.12.945.29 1.417.14.567.41 1.133.71 1.634 1.08 1.634 2.95 2.805 4.96 3.04 2.139.256 4.428-.112 6.068-1.51 1.83-1.568 2.47-4.08 1.53-6.234l-.13-.245c-.21-.435-.77-1.19-.77-1.19m-3.16 5.95c-.28.227-.74.472-1.1.567-1.12.377-2.239-.152-2.899-.775 1.19-.264 1.9-1.095 2.11-1.936.17-.756-.15-1.379-.28-2.106-.12-.7-.1-1.294.17-1.946.19.359.39.718.63 1.001.77.945 1.98 1.36 2.24 2.645.04.132.06.264.06.406.03.774-.33 1.624-.93 2.144"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fP7ko":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPerformanceOverview);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPerformanceOverview = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#22D543",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#22D543",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#22D543",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "m23.5 12.25-5.901 5.901c-.297.297-.446.446-.617.502a.75.75 0 0 1-.464 0c-.171-.056-.32-.204-.617-.502L13.85 16.1c-.297-.297-.446-.446-.617-.502a.75.75 0 0 0-.464 0c-.171.056-.32.205-.617.502L8.5 19.75m15-2.25v-5.25h-5.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jPIL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAiObservations);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAiObservations = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M5.962 3.564c.399-1.166 2.01-1.202 2.483-.106l.04.107.538 1.573a2.67 2.67 0 0 0 1.518 1.608l.144.054 1.574.537c1.166.399 1.202 2.01.106 2.483l-.106.04-1.574.538a2.67 2.67 0 0 0-1.608 1.518l-.054.144-.537 1.574c-.399 1.166-2.01 1.202-2.483.106l-.041-.106-.537-1.574a2.67 2.67 0 0 0-1.518-1.608l-.144-.054-1.573-.537c-1.167-.399-1.203-2.01-.107-2.483l.107-.041L3.763 6.8a2.67 2.67 0 0 0 1.608-1.518l.054-.144zm6.595-2.298a.67.67 0 0 1 .599.373l.032.078.233.684.685.233a.666.666 0 0 1 .079 1.23l-.079.032-.684.234-.233.684a.666.666 0 0 1-1.23.078l-.032-.078-.234-.684-.684-.233a.666.666 0 0 1-.079-1.23l.079-.032.684-.233.233-.685a.67.67 0 0 1 .631-.451"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dCoA7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMuscleFocus);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMuscleFocus = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#42CDFF",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#42CDFF",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#b)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#42CDFF",
                    d: "M23.008 13.59a.45.45 0 0 0-.066-.235c-.046-.089-1.275-2.151-5.119-2.639a2.04 2.04 0 0 1-.989-.408c-.712-.548-2.123-1.458-3.595-1.326-1.238.103-2.466.478-3.277.778a1.48 1.48 0 0 0-.97 1.387v6.076H10.8a2.746 2.746 0 0 0 2.742-2.742c0-.258.207-.47.469-.47a.47.47 0 0 1 .469.47c0 2.03-1.65 3.68-3.68 3.68H8.99v1.58h2.34c.262 0 .468.206.468.468a.467.467 0 0 1-.468.469H8.99v.872c0 .816.666 1.481 1.482 1.481h2.93a.47.47 0 0 0 .454-.356c.146-.581.507-1.646.863-2.025.506-.544 1.388-2.1 1.753-3.844a.534.534 0 0 1 .722-.38c1.73.698 4.088 1.42 5.504.895a.47.47 0 0 0 .31-.44z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 33.45,
                        x2: 8.594,
                        y1: 32.008,
                        y2: -8.208,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M8.5 8.5h15v15h-15z"
                        })
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3pzsf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgWorkoutMetrics);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgWorkoutMetrics = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFEB14",
                fillOpacity: 0.02,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFEB14",
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFEB14",
                d: "M12.063 10.094a1.97 1.97 0 0 1 1.968-1.969h3.938a1.97 1.97 0 0 1 1.968 1.969v11.812a1.97 1.97 0 0 1-1.968 1.969H14.03q-.204 0-.396-.04a1.97 1.97 0 0 1-1.572-1.929zm1.124.281V11.5h1.688a.562.562 0 1 0 0-1.125zm0 2.531v1.125H16a.562.562 0 1 0 0-1.125zm0 2.531v1.126h1.688a.562.562 0 1 0 0-1.125zm0 2.532v1.125H16a.562.562 0 1 0 0-1.125zm0 2.531v1.125h1.688a.562.562 0 1 0 0-1.125z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Bp1m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAvgHeartRate);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAvgHeartRate = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                fillRule: "evenodd",
                d: "M15.706 9.236a4.943 4.943 0 0 0-7.258-.287 4.95 4.95 0 0 0-1.114 5.288h3.656l2.335-4.41L16 14.88l1.337-2.525.997 1.883h6.332a4.95 4.95 0 0 0-1.114-5.288 4.943 4.943 0 0 0-7.258.287L16 9.58zm7.87 6.685h-6.133L16 18.646l-2.675-5.052-1.232 2.327H8.425l.023.024 7.548 7.551.004.004 7.552-7.555z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3sIYB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgTotalReps);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTotalReps = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M8 14.333s1.688-2.276 3.06-3.635A7.6 7.6 0 0 1 16.421 8.5C20.607 8.5 24 11.858 24 16s-3.393 7.5-7.579 7.5c-3.455 0-6.37-2.288-7.283-5.417m3.915-3.75H8v-5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hvtmi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgVolume);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgVolume = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M16 8.5c.849 0 1.663.328 2.263.911.6.584.937 1.375.937 2.2 0 .568-.152 1.097-.432 1.556H20.8c.76 0 1.4.52 1.56 1.213 1.608 6.23 1.64 6.393 1.64 6.564 0 .413-.169.809-.469 1.1s-.707.456-1.131.456H9.6c-.424 0-.831-.164-1.131-.456a1.53 1.53 0 0 1-.469-1.1c0-.17.032-.334 1.64-6.564.16-.692.8-1.213 1.56-1.213h2.032a2.97 2.97 0 0 1-.432-1.556c0-.825.337-1.616.937-2.2A3.25 3.25 0 0 1 16 8.5m0 1.556c-.424 0-.831.163-1.131.455s-.469.688-.469 1.1.169.808.469 1.1.707.456 1.131.456.831-.164 1.131-.456.469-.687.469-1.1c0-.412-.169-.808-.469-1.1A1.62 1.62 0 0 0 16 10.056m-4.8 4.666v6.222h1.6V19l.8.778v1.166h1.6V19.39l-1.6-1.556 1.6-1.555v-1.556h-1.6v1.167l-.8.778v-1.945zm7.2 0c-.888 0-1.6.692-1.6 1.556v3.11c0 .864.712 1.556 1.6 1.556h2.4v-3.888h-1.6v2.333h-.8v-3.111h2.4v-1.556z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8y4GQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgRestTime);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRestTime = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.03,
                d: "M0 16C0 7.163 7.163 0 16 0s16 7.163 16 16-7.163 16-16 16S0 24.837 0 16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeOpacity: 0.15,
                strokeWidth: 0.25,
                d: "M16 .125C24.767.125 31.875 7.232 31.875 16c0 8.767-7.108 15.875-15.875 15.875C7.232 31.875.125 24.767.125 16 .125 7.232 7.232.125 16 .125Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M22 23.021a.47.47 0 0 1-.144.339.5.5 0 0 1-.347.14H10.491a.5.5 0 0 1-.347-.14.473.473 0 0 1 0-.677.5.5 0 0 1 .347-.14h.642v-1.995c0-.344.076-.685.223-.998s.363-.59.63-.815L15.248 16l-3.26-2.735a2.4 2.4 0 0 1-.63-.815 2.3 2.3 0 0 1-.224-.998V9.457h-.642a.5.5 0 0 1-.347-.14.473.473 0 0 1 0-.677.5.5 0 0 1 .347-.14h11.018c.13 0 .255.05.347.14a.473.473 0 0 1 0 .677.5.5 0 0 1-.347.14h-.642v1.995c0 .345-.076.685-.223.998a2.4 2.4 0 0 1-.63.815L16.752 16l3.26 2.735c.268.224.483.502.63.815s.225.653.224.998v1.995h.642c.13 0 .255.05.347.14s.144.211.144.338"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                    id: "a",
                    x1: 33.45,
                    x2: 8.594,
                    y1: 32.008,
                    y2: -8.208,
                    gradientUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            stopColor: "#13142B"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                            offset: 1,
                            stopColor: "#050621"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8jLhU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPosture);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPosture = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 21,
        fill: "none",
        viewBox: "0 0 20 21",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                d: "M6.658 4.863h-.009a.37.37 0 0 1-.284-.13c-.405-.431-.373-1.757-.326-2.23v-.015l.008-.821C6.055.747 6.834 0 7.783 0 8.741 0 9.52.754 9.52 1.68v.807c0 .277-.087.743-.331 1.147-.446.735-1.462 1.228-2.531 1.229M5.056 20.358l.113-.197c.117-.202.228-.394.315-.588.217-.481.291-.95.385-1.543.087-.552.186-1.179.43-2 .243-.82.598-1.366.91-1.848.35-.54.653-1.005.653-1.651-.11-3.788.163-4.414.591-4.938a.155.155 0 0 0-.026-.222.167.167 0 0 0-.23.026c-.473.578-.775 1.247-.662 5.138 0 .55-.266.96-.602 1.479-.178.274-.354.55-.505.838q-.134.255-.243.52c-.046.113-.095.448-.266.436-.159-.011-.141-.231-.15-.338l-.047-.517c-.068-.76-.133-1.479-.17-1.934-.15-1.844-.125-2.278.056-3.028.216-.895.586-1.564 1.334-2.727.531-.825.552-.858.552-1.51 0-.13-.029-.293-.062-.44a.21.21 0 0 1 .159-.248c.311-.077.604-.19.868-.336a.22.22 0 0 1 .319.143q.02.09.046.183c.11.386.403.698.743 1.058.658.699 1.477 1.568 1.383 3.47q-.012.24-.037.456c-.119 1.015-.443 1.687-.757 2.34-.325.676-.633 1.315-.658 2.241-.01.368.076.733.256 1.057.484.868 1.34 1.587 1.34 3.506 0 .51-.076 1.044-.215 1.506a.45.45 0 0 1-.429.31H6.495a.213.213 0 0 1-.213-.257c.062-.266.149-.586.239-.764.152-.3.439-.746.77-1.264.623-.97 1.398-2.178 1.879-3.317a.158.158 0 0 0-.116-.214.17.17 0 0 0-.19.102c-.47 1.112-1.235 2.304-1.85 3.262-.337.525-.627.978-.787 1.292-.123.244-.234.694-.3.993a.216.216 0 0 1-.213.167h-.247a.47.47 0 0 1-.384-.181.42.42 0 0 1-.027-.461M12.01 12.476c-.09.186-.176.362-.255.542a.33.33 0 0 1-.301.194.3.3 0 0 1-.127-.025.313.313 0 0 1-.174-.415c.084-.193.173-.375.267-.569q.095-.193.19-.395a.33.33 0 0 1 .432-.16.32.32 0 0 1 .172.177.3.3 0 0 1-.008.242c-.064.138-.129.271-.196.409M10.83 5.43a.33.33 0 0 1-.454-.082 1.9 1.9 0 0 1-.298-.59 3.5 3.5 0 0 1-.103-.54.3.3 0 0 1 .07-.232.33.33 0 0 1 .255-.12c.167 0 .306.122.325.283q.027.237.084.443c.034.122.1.248.206.398.05.07.068.154.052.237a.31.31 0 0 1-.136.203M11.465 15.608a.333.333 0 0 1 .45.098l.128.192c.174.263.34.512.438.72.037.077.04.163.01.242a.32.32 0 0 1-.17.178.333.333 0 0 1-.433-.154c-.08-.169-.234-.4-.396-.644l-.129-.195a.3.3 0 0 1-.042-.24.32.32 0 0 1 .144-.197M11.126 5.742a.335.335 0 0 1 .46.043c.19.225.438.531.656.911a.31.31 0 0 1-.127.43.33.33 0 0 1-.445-.123 5.5 5.5 0 0 0-.589-.815.31.31 0 0 1 .045-.446M12.526 9.18a.32.32 0 0 1-.326-.3 4.5 4.5 0 0 0-.152-.974.316.316 0 0 1 .231-.387.326.326 0 0 1 .4.224c.096.345.154.718.174 1.106a.3.3 0 0 1-.085.228.33.33 0 0 1-.226.103zM12.601 11.036a.327.327 0 0 1-.403.219.32.32 0 0 1-.197-.15.3.3 0 0 1-.029-.24c.092-.316.155-.637.194-.982a.32.32 0 0 1 .36-.28.32.32 0 0 1 .29.348 6.3 6.3 0 0 1-.215 1.085"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                d: "M10.821 15.043a1.2 1.2 0 0 1-.076-.404c0-.277.023-.536.07-.793a.323.323 0 0 1 .378-.258c.085.015.16.061.21.13.05.07.07.153.055.237-.04.22-.06.444-.06.684q.001.08.043.205a.3.3 0 0 1-.018.241.335.335 0 0 1-.292.175.33.33 0 0 1-.31-.217M12.33 4.08l.244.183a.31.31 0 0 1 .058.444.33.33 0 0 1-.259.123.33.33 0 0 1-.2-.066l-1.007-.754-.006-.006a.32.32 0 0 1-.101-.153l-.004-.013-.002-.006a.3.3 0 0 1 .102-.303l.01-.01 1.009-.755a.33.33 0 0 1 .2-.066c.102 0 .196.045.258.123a.31.31 0 0 1-.058.444l-.245.183h2.344c.18 0 .327.142.327.316a.32.32 0 0 1-.327.317zM11.944 14.693a.3.3 0 0 1-.101-.153l-.005-.013v-.006a.3.3 0 0 1 .101-.303l.01-.01 1.009-.755a.33.33 0 0 1 .2-.066.33.33 0 0 1 .258.122.31.31 0 0 1-.058.444l-.245.183h1.343c.18 0 .326.142.326.317a.32.32 0 0 1-.326.316h-1.343l.245.183a.31.31 0 0 1 .058.444.33.33 0 0 1-.259.123.33.33 0 0 1-.2-.066l-1.007-.754z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9aj9W":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDepth);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDepth = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            fillRule: "evenodd",
            d: "m9.146 5.995 5.538 1.882c.421.143.421.75 0 .893l-5.538 1.882a.45.45 0 0 1-.292 0L3.316 8.77c-.421-.143-.421-.75 0-.893l5.538-1.882a.45.45 0 0 1 .292 0m-1.062-2.8.454.463V1.735c0-.13.105-.235.233-.235h.458c.13 0 .233.105.233.235v1.923l.433-.442a.23.23 0 0 1 .328.002l.323.33a.24.24 0 0 1 0 .335l-1.22 1.244a.455.455 0 0 1-.652 0l-1.24-1.264a.24.24 0 0 1 0-.335l.324-.33a.227.227 0 0 1 .326-.003m1.378 12.147v1.923a.233.233 0 0 1-.233.235H8.77a.233.233 0 0 1-.233-.235v-1.923l-.454.463a.23.23 0 0 1-.326-.003l-.323-.33a.24.24 0 0 1-.001-.335l1.24-1.264a.455.455 0 0 1 .652 0l1.22 1.244c.09.092.091.243 0 .336l-.323.33a.227.227 0 0 1-.328.001zm4.17-5.47 1.052.358c.421.143.421.75 0 .893l-5.538 1.882a.45.45 0 0 1-.292 0l-5.538-1.882c-.421-.143-.421-.75 0-.893l1.053-.358 4.266 1.45c.237.08.493.08.73 0z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ee2Sl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgKneeAlignment);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgKneeAlignment = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M13.463 7.151 10.779 4.5H3c1.188 1.746 4.39 4.56 5.274 5.318.236.202.443.434.582.704.254.485.29.952.284 1.216-.005.232-.012.467-.005.701A63 63 0 0 0 9.47 17.5h4.096l.363-4.631c.058-.743.18-1.486.426-2.196.73-2.094-.891-3.522-.891-3.522m-1.086 2.906a.26.26 0 0 1-.197.089.26.26 0 0 1-.154-.049c-.737-.54-.712-2.08-.707-2.254.002-.128.124-.223.256-.225.137.002.247.109.242.239-.013.408.06 1.539.518 1.878a.22.22 0 0 1 .042.325zM15.277 7.404a.25.25 0 0 1-.209-.107.223.223 0 0 1 .072-.32l.76-.46a.26.26 0 0 1 .343.068.223.223 0 0 1-.072.32l-.76.46a.26.26 0 0 1-.134.037zM15.778 8.5a.24.24 0 0 1-.244-.193c-.025-.125.068-.246.202-.27l.971-.157a.25.25 0 0 1 .289.188c.025.125-.067.246-.202.27l-.97.157q-.024.004-.043.005zM16.657 9.937a.3.3 0 0 1-.08-.012l-.856-.27c-.13-.04-.2-.17-.157-.294a.254.254 0 0 1 .316-.146l.857.27c.13.04.199.17.157.294a.25.25 0 0 1-.237.158"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2EQob":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCoreStability);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCoreStability = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M18.745 9.152h-.329l-1.542-4.123a.903.903 0 0 0 .078-.892.86.86 0 0 0-1.122-.423L11.036 5.73H8.63l-4.55-2.107a.84.84 0 0 0-1.13.42.9.9 0 0 0 .17.998l-1.537 4.11h-.329A.26.26 0 0 0 1 9.416c0 1.379 1.085 2.5 2.42 2.5 1.333 0 2.418-1.121 2.418-2.5a.26.26 0 0 0-.255-.263h-.329l-1.368-3.66 4.237 2.219v4.068q0 .015.002.032l.56 4.802c.03.267.161.505.368.672a.96.96 0 0 0 .729.207c.52-.069.885-.55.85-1.117l-.281-4.601.73-.296-.333 1.57c-.129.61.295 1.094.779 1.21.444.105.963-.093 1.122-.774l.78-3.343c.076-.22.074-.462-.004-.68-.18-.504-.715-.764-1.243-.606l-.614.184V7.703l4.534-2.179-1.357 3.628h-.328a.26.26 0 0 0-.255.263c0 1.379 1.085 2.5 2.419 2.5S19 10.794 19 9.415a.26.26 0 0 0-.255-.263m-14.037 0H2.13l1.288-3.445zM16.58 5.707l1.288 3.445h-2.577zm-8.227-1.68c0-.842.663-1.527 1.477-1.527s1.477.685 1.477 1.526c0 .842-.662 1.527-1.477 1.527-.814 0-1.477-.685-1.477-1.527"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lveJ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetAllMovements", ()=>useGetAllMovements);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
const getAllMovements = async ()=>{
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_ALL_MOVEMENTS}`;
    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json'
        }
    });
    if (!response.ok) throw new Error('Failed to fetch movements');
    const res = await response.json();
    const rawMovements = (res.data || []).filter((item)=>item.is_show_move === true);
    return rawMovements.map((item)=>{
        // 1. Pre-compute the generic mapped muscle group for the UI based primarily on tags
        const tags = (item.tags || []).map((t)=>t.toLowerCase().trim());
        const mStr = (item.muscles || []).map((m)=>m.toLowerCase()).join(' ');
        const tStr = tags.join(' ');
        if (tags.includes('full body') || tStr.includes('full body')) item.mapped_muscle_group = 'Full Body';
        else if (tags.includes('core') || tStr.includes('core')) item.mapped_muscle_group = 'Core';
        else if (tags.includes('upper body') || tStr.includes('upper body')) item.mapped_muscle_group = 'Upper Body';
        else if (tags.includes('lower body') || tStr.includes('lower body')) item.mapped_muscle_group = 'Lower Body';
        else if (mStr.match(/quad|hamstring|calv|calf|glute|leg|adductor|abductor/) || tStr.match(/leg|hip/)) item.mapped_muscle_group = 'Lower Body';
        else if (mStr.match(/chest|back|lat|trap|shoulder|deltoid|arm|bicep|tricep|forearm/) || tStr.match(/push|pull|press/)) item.mapped_muscle_group = 'Upper Body';
        else if (mStr.match(/abdomin|core|oblique/)) item.mapped_muscle_group = 'Core';
        else item.mapped_muscle_group = 'Full Body'; // fallback
        return item;
    });
};
const useGetAllMovements = ()=>{
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'allMovements'
        ],
        queryFn: getAllMovements,
        staleTime: 28800000,
        gcTime: 28800000
    });
};

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cPrSq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetClientWorkoutDetails", ()=>useGetClientWorkoutDetails);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _reactHotToast = require("react-hot-toast");
const fetchWorkoutDetails = async (clientId, workoutId)=>{
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_CLIENT_WORKOUT_DETAILS}?clientId=${clientId}&workoutId=${workoutId}`;
    try {
        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        });
        if (!response.ok) throw new Error('Network response was not ok');
        const json = await response.json();
        if (json.status === 'ok') return json.data;
        else throw new Error(json.error || 'Failed to fetch workout details');
    } catch (error) {
        (0, _reactHotToast.toast).error(error.message || 'Error fetching workout details');
        throw error;
    }
};
const useGetClientWorkoutDetails = ({ clientId, workoutId })=>{
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'clientWorkoutDetails',
            clientId,
            workoutId
        ],
        queryFn: ()=>fetchWorkoutDetails(clientId, workoutId),
        enabled: !!clientId && !!workoutId,
        staleTime: 300000
    });
};

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","react-hot-toast":"3T0Wh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ixY24":[function() {},{}],"iu3BE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Programs", ()=>Programs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("../../../../components/Button/Button");
var _useDebounce = require("src/hooks/useDebounce");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _dashboardScreensScss = require("../../DashboardScreens.scss");
var _programSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/programs/program.svg");
var _uploadSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/programs/upload.svg");
var _listSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/list.svg");
var _menuSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/menu.svg");
var _aiSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/programs/ai.svg");
var _addPhotoFilesSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/programs/add_photo_files.svg");
var _takeAPhotoSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/programs/take_a_photo.svg");
var _filterSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/clients/filter.svg");
var _searchSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/clients/search.svg");
var _programCard = require("./components/ProgramCard/ProgramCard");
var _useGetTrainerProgramPlanList = require("src/api/mutations/useGetTrainerProgramPlanList");
var _useGetTrainerClients = require("src/api/mutations/useGetTrainerClients");
var _useGetAllMovements = require("src/api/queries/useGetAllMovements");
var _genderUtils = require("src/utils/genderUtils");
var _sessionStore = require("src/store/sessionStore");
var _reactRouterDom = require("react-router-dom");
const Programs = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const trainerId = currentUser?.uid;
    const [viewMode, setViewMode] = (0, _react.useState)('grid');
    const fileInputRef = (0, _react.useRef)(null);
    const [searchQuery, setSearchQuery] = (0, _react.useState)('');
    const [showFilter, setShowFilter] = (0, _react.useState)('1'); // "1" is Active, "0" is Inactive
    const [clientFilter, setClientFilter] = (0, _react.useState)('all');
    const [sortFilter, setSortFilter] = (0, _react.useState)('newest');
    const [clientPage, setClientPage] = (0, _react.useState)(1);
    const [allClients, setAllClients] = (0, _react.useState)([]);
    const [totalClientCount, setTotalClientCount] = (0, _react.useState)(0);
    const debouncedSearchQuery = (0, _useDebounce.useDebounce)(searchQuery, 500);
    const { data: programsData = [], isLoading: isProgramsLoading } = (0, _useGetTrainerProgramPlanList.useGetTrainerProgramPlanList)({
        isActive: showFilter === 'all' ? '' : showFilter,
        clientId: clientFilter === 'all' ? '' : clientFilter,
        sortFilter,
        searchQuery: debouncedSearchQuery
    });
    const { data: activeProgramsData = [], isLoading: isActiveProgramsLoading } = (0, _useGetTrainerProgramPlanList.useGetTrainerProgramPlanList)({
        isActive: '1'
    });
    const { data: allMovements } = (0, _useGetAllMovements.useGetAllMovements)();
    const { data: clientsData, isFetching: isFetchingClients } = (0, _useGetTrainerClients.useGetTrainerClients)('all', '', 'newest', clientPage, 1000);
    (0, _react.useEffect)(()=>{
        if (clientsData?.clients) {
            if (clientPage === 1) setAllClients(clientsData.clients);
            else setAllClients((prev)=>{
                const existingIds = new Set(prev.map((c)=>c.uid));
                const newClients = clientsData.clients.filter((c)=>!existingIds.has(c.uid));
                return [
                    ...prev,
                    ...newClients
                ];
            });
            setTotalClientCount(clientsData.totalCount || 0);
        }
    }, [
        clientsData,
        clientPage
    ]);
    const showItems = [
        {
            key: '1',
            label: 'Active'
        },
        {
            key: '0',
            label: 'Archive'
        },
        {
            key: 'all',
            label: 'All'
        }
    ];
    // Build client dropdown options dynamically from the fetched clients
    const clientItems = [
        {
            key: 'all',
            label: 'All Clients'
        },
        ...allClients.map((c)=>({
                key: c.uid,
                label: `${c.name} ${c.surname}`
            }))
    ];
    if (isFetchingClients && clientPage > 1) clientItems.push({
        key: 'loading',
        label: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                textAlign: 'center',
                padding: '4px 0'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                size: "small"
            })
        })
    });
    const sortItems = [
        {
            key: 'newest',
            label: 'Date (Newest)'
        },
        {
            key: 'oldest',
            label: 'Date (Oldest)'
        },
        {
            key: 'name',
            label: 'Name (A-Z)'
        }
    ];
    const uploadItems = [
        {
            key: 'add_photo',
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addPhotoFilesSvg.ReactComponent), {
                style: {
                    fontSize: '16px'
                }
            }),
            label: 'Add photo & files'
        },
        {
            key: 'take_photo',
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _takeAPhotoSvg.ReactComponent), {
                style: {
                    fontSize: '16px'
                }
            }),
            label: 'Take a photo'
        }
    ];
    const getShowLabel = ()=>showItems.find((i)=>i.key === showFilter)?.label || 'Active';
    const getClientLabel = ()=>clientItems.find((i)=>i.key === clientFilter)?.label || 'All Clients';
    const getSortLabel = ()=>sortItems.find((i)=>i.key === sortFilter)?.label || 'Date (Newest)';
    const handleUploadMenuClick = (e)=>{
        if (e.key === 'add_photo' || e.key === 'take_photo') fileInputRef.current?.click();
    };
    const allPrograms = (0, _react.useMemo)(()=>{
        if (!programsData || allClients.length === 0) return [];
        return programsData.filter((p)=>{
            // Do not show programs belonging to deleted clients
            if (p.clientId && !allClients.some((c)=>c.uid === p.clientId)) return false;
            return true;
        }).map((p)=>{
            const client = allClients.find((c)=>c.uid === p.clientId);
            const cName = client?.name || '';
            const cSurname = client?.surname || '';
            const clientName = client ? `${cName} ${cSurname}`.trim() : '';
            const initials = client ? `${cName.charAt(0)}${cSurname.charAt(0)}`.toUpperCase() : '';
            let durationNum = parseInt(p.duration || '1', 10);
            let daysPerWeek = p.datetimeList?.length ? Math.ceil(p.datetimeList.length / durationNum) : 0;
            const normalize = (str)=>(str || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
            const extractedImages = [];
            if (p.datetimeList) for (const day of p.datetimeList){
                const allDayMoves = [
                    ...day.warmUpMoves || [],
                    ...day.moves || [],
                    ...day.coolDownMoves || []
                ];
                for (const move of allDayMoves){
                    const matchedExercise = allMovements?.find((m)=>normalize(m.id) === normalize(move.title) || normalize(m.en_display_name) === normalize(move.title));
                    const isFemale = (0, _genderUtils.isFemaleProfile)(client || p);
                    const imgUrl = isFemale ? matchedExercise?.image_female_url || matchedExercise?.image_male_url : matchedExercise?.image_male_url || matchedExercise?.image_female_url;
                    if (matchedExercise) extractedImages.push(imgUrl || '');
                    if (extractedImages.length >= 3) break;
                }
                if (extractedImages.length >= 3) break;
            }
            const defaultImages = [
                '',
                '',
                ''
            ];
            const draftProgress = p.draft?.progress || {};
            let nextStepSlug = 'energy-level';
            if (!draftProgress['energy_level'] || draftProgress['energy_level'].length === 0) nextStepSlug = 'energy-level';
            else if (!draftProgress['activity_level'] || draftProgress['activity_level'].length === 0) nextStepSlug = 'non-gym-activity';
            else if (!draftProgress['fitness_level'] || draftProgress['fitness_level'].length === 0) nextStepSlug = 'fitness-level';
            else if (!draftProgress['movement_insights'] || draftProgress['movement_insights'].length < 5) nextStepSlug = 'movement-insights';
            else if (!draftProgress['injuries_parts'] || draftProgress['injuries_parts'].length === 0) nextStepSlug = 'injuries-limitations';
            else if (!draftProgress['program_duration'] || draftProgress['program_duration'].length === 0) nextStepSlug = 'program-duration';
            else if (!draftProgress['how_often_train'] || draftProgress['how_often_train'].length === 0) nextStepSlug = 'training-schedule';
            else if (!draftProgress['workout_duration'] || draftProgress['workout_duration'].length === 0) nextStepSlug = 'workout-duration';
            else if (!draftProgress['training_goal'] || draftProgress['training_goal'].length === 0) nextStepSlug = 'training-goal';
            if (p.status === 'draft') {
                if (draftProgress['program_duration'] && draftProgress['program_duration'].length > 0) durationNum = parseInt(draftProgress['program_duration'][0].value, 10);
                if (draftProgress['how_often_train']) daysPerWeek = draftProgress['how_often_train'].length;
            }
            const isArchived = p.isActive === '0' || String(p.isActive) === '0';
            return {
                id: p.id,
                docPath: p.docPath || (p.id && trainerId ? `trainer_app_users/${trainerId}/programme_plan/${p.id}` : ''),
                isSent: !!p.isSentToClient,
                clientId: p.clientId,
                generatorType: p.generatorType || p?.type || (p.isManually ? 'manual' : 'ai'),
                isManually: p.isManually,
                programmeName: p.status === 'draft' ? p.programmeName || 'Draft' : p.programmeName || 'Program',
                weeks: durationNum,
                daysPerWeek,
                tags: p.focus_area || 'General',
                thumbnails: [
                    extractedImages[0] || defaultImages[0],
                    extractedImages[1] || defaultImages[1],
                    extractedImages[2] || defaultImages[2]
                ],
                nextStepSlug,
                assignedTo: {
                    name: clientName,
                    initials
                },
                status: p.status === 'draft' ? 'draft' : p.clientId ? 'assigned' : 'unassigned',
                isActive: isArchived ? '0' : '1',
                createTime: p.createTime || new Date().toISOString(),
                date: (()=>{
                    const d = new Date(p.createTime || new Date().toISOString());
                    const day = d.getDate();
                    const month = d.toLocaleDateString('en-GB', {
                        month: 'short'
                    });
                    const year = d.getFullYear();
                    return `${day} ${month}, ${year}`;
                })()
            };
        });
    }, [
        programsData,
        allClients,
        allMovements,
        trainerId
    ]);
    const validActivePrograms = (0, _react.useMemo)(()=>{
        if (!activeProgramsData) return [];
        return activeProgramsData.filter((p)=>{
            if (p.docPath && (p.docPath.startsWith('mover_app_users/') || p.docPath.startsWith('flutter_user/'))) return false;
            if (p.clientId && allClients.length > 0 && !allClients.some((c)=>c.uid === p.clientId)) return false;
            return p.isActive === '1' || p.isActive !== '0';
        });
    }, [
        activeProgramsData,
        allClients
    ]);
    const displayedPrograms = (0, _react.useMemo)(()=>{
        const filtered = allPrograms.filter((p)=>{
            // Exclude programs fetched from client user collections (if they somehow appear in the payload)
            if (p.docPath && (p.docPath.startsWith('mover_app_users/') || p.docPath.startsWith('flutter_user/'))) return false;
            if (showFilter === '1') {
                if (p.isActive === '0') return false;
            } else if (showFilter === '0') {
                if (p.isActive !== '0') return false;
            }
            if (clientFilter !== 'all' && p.clientId !== clientFilter) return false;
            if (searchQuery) {
                const query = searchQuery.toLowerCase();
                if (!p.programmeName.toLowerCase().includes(query) && !p.assignedTo.name.toLowerCase().includes(query)) return false;
            }
            return true;
        });
        return filtered.sort((a, b)=>{
            if (sortFilter === 'newest') return new Date(b.createTime).getTime() - new Date(a.createTime).getTime();
            else if (sortFilter === 'oldest') return new Date(a.createTime).getTime() - new Date(b.createTime).getTime();
            else if (sortFilter === 'name') return a.programmeName.localeCompare(b.programmeName);
            return 0;
        });
    }, [
        allPrograms,
        showFilter,
        clientFilter,
        sortFilter,
        searchQuery
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "dashboard-screen program-screen",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                type: "file",
                ref: fileInputRef,
                style: {
                    display: 'none'
                },
                accept: "image/*, .pdf, .doc, .docx"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "dashboard-top-section desktop-only",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "dashboard-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                children: "Programs"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "header-actions",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                        variant: "light",
                                        onClick: ()=>{
                                            // if (allPrograms.length >= 1) {
                                            //   navigate('/onboarding-trainer/dashboard');
                                            // } else {
                                            //   navigate('/onboarding-trainer/dashboard/program-generator/ai?action=new_program');
                                            // }
                                            navigate('/onboarding-trainer/dashboard');
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    marginRight: '8px',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _aiSvg.ReactComponent), {})
                                            }),
                                            validActivePrograms.length === 0 && !isActiveProgramsLoading ? 'Create Your First Program' : 'Create Program'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                        menu: {
                                            items: uploadItems,
                                            onClick: handleUploadMenuClick
                                        },
                                        trigger: [
                                            'click'
                                        ],
                                        rootClassName: "dark-theme-dropdown",
                                        placement: "bottomRight",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            style: {
                                                display: 'inline-block',
                                                cursor: 'pointer'
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                variant: "outline",
                                                style: {
                                                    color: '#fff',
                                                    pointerEvents: 'none'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        style: {
                                                            marginRight: '8px',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        },
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadSvg.ReactComponent), {})
                                                    }),
                                                    'Upload a Program'
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "dashboard-filter-bar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "filters-left",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                        menu: {
                                            items: showItems,
                                            onClick: (e)=>setShowFilter(e.key)
                                        },
                                        trigger: [
                                            'click'
                                        ],
                                        rootClassName: "dark-theme-dropdown",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "filter-item filter-show",
                                            style: {
                                                cursor: 'pointer'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    children: [
                                                        "Show: ",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: getShowLabel()
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                    width: "12",
                                                    height: "12",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                        points: "6 9 12 15 18 9"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "divider"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "search-input",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "text",
                                                placeholder: "Find program..",
                                                value: searchQuery,
                                                onChange: (e)=>setSearchQuery(e.target.value)
                                            }),
                                            searchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                onClick: ()=>setSearchQuery(''),
                                                className: "clear-search-btn",
                                                "aria-label": "Clear search",
                                                style: {
                                                    background: 'transparent',
                                                    backgroundColor: 'transparent',
                                                    backgroundImage: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    margin: 0,
                                                    outline: 'none',
                                                    appearance: 'none',
                                                    WebkitAppearance: 'none',
                                                    borderRadius: 0,
                                                    boxShadow: 'none',
                                                    display: 'inline-flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer',
                                                    color: '#838e9e',
                                                    width: 20,
                                                    height: 20,
                                                    minWidth: 'unset',
                                                    minHeight: 'unset',
                                                    flexShrink: 0
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                    width: "14",
                                                    height: "14",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    style: {
                                                        display: 'block',
                                                        margin: 0,
                                                        pointerEvents: 'none'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                            x1: "18",
                                                            y1: "6",
                                                            x2: "6",
                                                            y2: "18"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                            x1: "6",
                                                            y1: "6",
                                                            x2: "18",
                                                            y2: "18"
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "filters-right",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "filter-label",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Filters:'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                        menu: {
                                            items: clientItems,
                                            onClick: (e)=>setClientFilter(e.key)
                                        },
                                        trigger: [
                                            'click'
                                        ],
                                        rootClassName: "dark-theme-dropdown",
                                        popupRender: (menu)=>/*#__PURE__*/ (0, _react.cloneElement)(menu, {
                                                onScroll: (e)=>{
                                                    const target = e.currentTarget;
                                                    if (Math.abs(target.scrollHeight - target.clientHeight - target.scrollTop) <= 1) {
                                                        if (allClients.length < totalClientCount && !isFetchingClients) setClientPage((prev)=>prev + 1);
                                                    }
                                                }
                                            }),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "filter-item filter-sort",
                                            style: {
                                                cursor: 'pointer'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    children: [
                                                        "Client: ",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: getClientLabel()
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                    width: "12",
                                                    height: "12",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                        points: "6 9 12 15 18 9"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                        menu: {
                                            items: sortItems,
                                            onClick: (e)=>setSortFilter(e.key)
                                        },
                                        trigger: [
                                            'click'
                                        ],
                                        rootClassName: "dark-theme-dropdown",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "filter-item filter-sort",
                                            style: {
                                                cursor: 'pointer'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    children: [
                                                        "Sort: ",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: getSortLabel()
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                    width: "12",
                                                    height: "12",
                                                    viewBox: "0 0 24 24",
                                                    fill: "none",
                                                    stroke: "currentColor",
                                                    strokeWidth: "2",
                                                    strokeLinecap: "round",
                                                    strokeLinejoin: "round",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                        points: "6 9 12 15 18 9"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "view-toggles",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: `toggle-btn ${viewMode === 'grid' ? 'active' : ''}`,
                                                onClick: ()=>setViewMode('grid'),
                                                "aria-label": "Grid view",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuSvg.ReactComponent), {
                                                    viewBox: "0 0 24 24"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: `toggle-btn ${viewMode === 'list' ? 'active' : ''}`,
                                                onClick: ()=>setViewMode('list'),
                                                "aria-label": "List view",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listSvg.ReactComponent), {
                                                    viewBox: "0 0 24 24"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mobile-only",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "dashboard-top-section",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "dashboard-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        children: "Programs"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "header-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                                variant: "light",
                                                onClick: ()=>navigate('/onboarding-trainer/dashboard'),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        style: {
                                                            marginRight: '8px',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        },
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _aiSvg.ReactComponent), {})
                                                    }),
                                                    'Create'
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                                menu: {
                                                    items: uploadItems,
                                                    onClick: handleUploadMenuClick
                                                },
                                                trigger: [
                                                    'click'
                                                ],
                                                rootClassName: "dark-theme-dropdown",
                                                placement: "bottomRight",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    style: {
                                                        display: 'inline-block',
                                                        cursor: 'pointer'
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                        variant: "outline",
                                                        style: {
                                                            color: '#fff',
                                                            pointerEvents: 'none'
                                                        },
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            style: {
                                                                display: 'flex',
                                                                alignItems: 'center'
                                                            },
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadSvg.ReactComponent), {})
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "dashboard-filter-bar",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "filter-label",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Filters:'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "filter-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                                menu: {
                                                    items: showItems,
                                                    onClick: (e)=>setShowFilter(e.key)
                                                },
                                                trigger: [
                                                    'click'
                                                ],
                                                rootClassName: "dark-theme-dropdown",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "filter-item filter-show",
                                                    style: {
                                                        cursor: 'pointer'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            children: [
                                                                "Show: ",
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "value",
                                                                    children: getShowLabel()
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            width: "12",
                                                            height: "12",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                                points: "6 9 12 15 18 9"
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                                menu: {
                                                    items: sortItems,
                                                    onClick: (e)=>setSortFilter(e.key)
                                                },
                                                trigger: [
                                                    'click'
                                                ],
                                                rootClassName: "dark-theme-dropdown",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "filter-item filter-sort",
                                                    style: {
                                                        cursor: 'pointer'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            children: [
                                                                "Sort: ",
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "value",
                                                                    children: getSortLabel()
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            width: "12",
                                                            height: "12",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "currentColor",
                                                            strokeWidth: "2",
                                                            strokeLinecap: "round",
                                                            strokeLinejoin: "round",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                                points: "6 9 12 15 18 9"
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "filter-row",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                            menu: {
                                                items: clientItems,
                                                onClick: (e)=>setClientFilter(e.key)
                                            },
                                            trigger: [
                                                'click'
                                            ],
                                            rootClassName: "dark-theme-dropdown",
                                            popupRender: (menu)=>/*#__PURE__*/ (0, _react.cloneElement)(menu, {
                                                    onScroll: (e)=>{
                                                        const target = e.currentTarget;
                                                        if (Math.abs(target.scrollHeight - target.clientHeight - target.scrollTop) <= 1) {
                                                            if (allClients.length < totalClientCount && !isFetchingClients) setClientPage((prev)=>prev + 1);
                                                        }
                                                    }
                                                }),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "filter-item filter-sort",
                                                style: {
                                                    cursor: 'pointer'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            "Client: ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "value",
                                                                children: getClientLabel()
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        width: "12",
                                                        height: "12",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                            points: "6 9 12 15 18 9"
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "dashboard-search-section",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "filter-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "search-input",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                    cx: "11",
                                                    cy: "11",
                                                    r: "8"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                    x1: "21",
                                                    y1: "21",
                                                    x2: "16.65",
                                                    y2: "16.65"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            placeholder: "Find program..",
                                            value: searchQuery,
                                            onChange: (e)=>setSearchQuery(e.target.value)
                                        }),
                                        searchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            onClick: ()=>setSearchQuery(''),
                                            className: "clear-search-btn",
                                            "aria-label": "Clear search",
                                            style: {
                                                background: 'transparent',
                                                backgroundColor: 'transparent',
                                                backgroundImage: 'none',
                                                border: 'none',
                                                padding: 0,
                                                margin: 0,
                                                outline: 'none',
                                                appearance: 'none',
                                                WebkitAppearance: 'none',
                                                borderRadius: 0,
                                                boxShadow: 'none',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                cursor: 'pointer',
                                                color: '#838e9e',
                                                width: 20,
                                                height: 20,
                                                minWidth: 'unset',
                                                minHeight: 'unset',
                                                flexShrink: 0
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                strokeLinecap: "round",
                                                strokeLinejoin: "round",
                                                style: {
                                                    display: 'block',
                                                    margin: 0,
                                                    pointerEvents: 'none'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                        x1: "18",
                                                        y1: "6",
                                                        x2: "6",
                                                        y2: "18"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                        x1: "6",
                                                        y1: "6",
                                                        x2: "18",
                                                        y2: "18"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "view-toggles",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `toggle-btn ${viewMode === 'grid' ? 'active' : ''}`,
                                            onClick: ()=>setViewMode('grid'),
                                            "aria-label": "Grid view",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _menuSvg.ReactComponent), {
                                                viewBox: "0 0 24 24"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `toggle-btn ${viewMode === 'list' ? 'active' : ''}`,
                                            onClick: ()=>setViewMode('list'),
                                            "aria-label": "List view",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _listSvg.ReactComponent), {
                                                viewBox: "0 0 24 24"
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            }),
            isProgramsLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "loading-container",
                style: {
                    flex: 1
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                        indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                            className: "loading-icon",
                            spin: true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "loading-text",
                        children: "Loading programs"
                    })
                ]
            }) : displayedPrograms.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "dashboard-empty-state",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "empty-icon",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: searchQuery ? `No results found for "${searchQuery}"` : showFilter === '0' ? 'No archived programs yet' : 'No programs yet'
                    }),
                    !searchQuery && showFilter !== '0' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Create your first workout program"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _button.Button), {
                                variant: "light",
                                onClick: ()=>navigate('/onboarding-trainer/dashboard'),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        style: {
                                            marginRight: '8px',
                                            display: 'flex',
                                            alignItems: 'center'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _aiSvg.ReactComponent), {})
                                    }),
                                    validActivePrograms.length === 0 ? 'Create Your First Program' : 'Create Program'
                                ]
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `programs-content ${viewMode}-layout`,
                children: displayedPrograms.map((program)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programCard.ProgramCard), {
                        data: program,
                        viewMode: viewMode
                    }, program.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../../../components/Button/Button":"jLE7r","src/hooks/useDebounce":"fxOsA","antd":[["Dropdown","cMU6A","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"../../DashboardScreens.scss":"lYzMQ","../../../../../../assets/images/onboarding-trainer/dashboard/programs/program.svg":"7sfp0","../../../../../../assets/images/onboarding-trainer/dashboard/programs/upload.svg":"cwoPB","../../../../../../assets/images/onboarding-trainer/dashboard/list.svg":"9VO1i","../../../../../../assets/images/onboarding-trainer/dashboard/menu.svg":"3WSyH","../../../../../../assets/images/onboarding-trainer/dashboard/programs/ai.svg":"iP6NF","../../../../../../assets/images/onboarding-trainer/dashboard/programs/add_photo_files.svg":"h5kDO","../../../../../../assets/images/onboarding-trainer/dashboard/programs/take_a_photo.svg":"0Spin","../../../../../../assets/images/onboarding-trainer/dashboard/clients/filter.svg":"3x6cI","../../../../../../assets/images/onboarding-trainer/dashboard/clients/search.svg":"1z49p","./components/ProgramCard/ProgramCard":"jsAJt","src/api/mutations/useGetTrainerProgramPlanList":"eJMbb","src/api/mutations/useGetTrainerClients":"18nHc","src/api/queries/useGetAllMovements":"lveJ0","src/utils/genderUtils":"aiA54","src/store/sessionStore":"kPSO3","react-router-dom":"f3cgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lYzMQ":[function() {},{}],"7sfp0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProgram);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgram = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 80,
        height: 80,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "m29.996 44.168 2.5-4.834a3.33 3.33 0 0 1 2.9-1.833h17.933m0 0a3.333 3.333 0 0 1 3.233 4.166l-2.566 10a3.334 3.334 0 0 1-3.25 2.5H26.662a3.333 3.333 0 0 1-3.333-3.333V29.167a3.333 3.333 0 0 1 3.333-3.333h6.5a3.33 3.33 0 0 1 2.817 1.5l1.35 2a3.33 3.33 0 0 0 2.783 1.5h9.884a3.333 3.333 0 0 1 3.333 3.333z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 83.625,
                        x2: 21.485,
                        y1: 80.021,
                        y2: -20.52,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 40,
                        x2: 40,
                        y1: 0,
                        y2: 80,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cwoPB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgUpload);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUpload = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 15,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#E5E5E5",
                    d: "M2.41 13.853q-.676 0-1.158-.482a1.58 1.58 0 0 1-.482-1.158v-1.641q0-.348.236-.584a.8.8 0 0 1 .584-.236q.348 0 .585.236a.8.8 0 0 1 .235.584v1.64h9.843v-1.64q0-.348.236-.584a.8.8 0 0 1 .584-.236q.348 0 .585.236a.8.8 0 0 1 .235.584v1.64q0 .677-.481 1.16a1.58 1.58 0 0 1-1.16.48zm4.101-9.966L4.974 5.425a.76.76 0 0 1-.584.236.84.84 0 0 1-.585-.256.87.87 0 0 1-.236-.574.75.75 0 0 1 .236-.575l2.953-2.952a.7.7 0 0 1 .266-.174.93.93 0 0 1 .615 0 .74.74 0 0 1 .267.174l2.953 2.952a.75.75 0 0 1 .236.575.84.84 0 0 1-.82.83.76.76 0 0 1-.585-.236L8.152 3.887v5.865a.8.8 0 0 1-.236.585.8.8 0 0 1-.584.235.8.8 0 0 1-.584-.236.8.8 0 0 1-.237-.584z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h14.667v14.667H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iP6NF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAi);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAi = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#07092C",
            d: "M6.071 3.633c.4-1.167 2.011-1.202 2.484-.106l.04.106.538 1.574a2.67 2.67 0 0 0 1.517 1.607l.145.054 1.573.537c1.167.399 1.202 2.011.107 2.484l-.107.04-1.573.538a2.67 2.67 0 0 0-1.608 1.517l-.054.144-.538 1.574c-.398 1.167-2.01 1.202-2.482.107l-.042-.107-.537-1.573a2.67 2.67 0 0 0-1.517-1.608l-.144-.054-1.574-.538c-1.167-.398-1.202-2.01-.106-2.482l.106-.042 1.574-.537A2.67 2.67 0 0 0 5.48 5.351l.054-.144zm6.596-2.299a.67.67 0 0 1 .598.373l.032.078.234.684.684.234a.666.666 0 0 1 .08 1.23l-.08.032-.684.233-.233.685a.667.667 0 0 1-1.23.078l-.032-.078-.233-.684-.685-.234a.666.666 0 0 1-.079-1.23l.08-.032.683-.233.233-.685a.67.67 0 0 1 .632-.451"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h5kDO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAddPhotoFiles);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAddPhotoFiles = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 18 18",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    stroke: "#E5E5E5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.5,
                    d: "m16.079 8.747-6.893 6.892A4.502 4.502 0 0 1 2.82 9.272L9.71 2.379a3.002 3.002 0 0 1 4.245 4.245l-6.9 6.893a1.501 1.501 0 0 1-2.122-2.123l6.367-6.36"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h18v18H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"0Spin":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgTakeAPhoto);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTakeAPhoto = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 18 18",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#E5E5E5",
                    d: "M9 13.778q1.5 0 2.55-1.02t1.05-2.48a3.33 3.33 0 0 0-1.05-2.479Q10.502 6.779 9 6.778q-1.5-.001-2.55 1.021-1.047 1.023-1.05 2.479-.002 1.455 1.05 2.48Q7.503 13.78 9 13.777m0-1.556a1.96 1.96 0 0 1-1.42-.564 1.85 1.85 0 0 1-.58-1.38q0-.817.58-1.38A1.96 1.96 0 0 1 9 8.332q.84 0 1.42.564t.58 1.38-.58 1.381a1.96 1.96 0 0 1-1.42.564M2.6 16.5q-.66 0-1.13-.457A1.48 1.48 0 0 1 1 14.944V5.611q0-.642.47-1.098t1.13-.457h2.52L6.6 2.5h4.8l1.48 1.556h2.52q.66 0 1.13.457T17 5.61v9.333q0 .642-.47 1.1a1.56 1.56 0 0 1-1.13.456zm0-1.556h12.8V5.611h-3.24L10.7 4.056H7.3L5.84 5.61H2.6z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h18v18H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jsAJt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgramCard", ()=>ProgramCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _antd = require("antd");
var _appLinksConfig = require("src/config/app-links.config");
var _useArchiveProgramPlan = require("src/api/mutations/useArchiveProgramPlan");
var _useDeleteProgramPlan = require("src/api/mutations/useDeleteProgramPlan");
var _useSendProgramPlanToClient = require("src/api/mutations/useSendProgramPlanToClient");
var _useDuplicateProgramPlan = require("src/api/mutations/useDuplicateProgramPlan");
var _assignToClientModal = require("../../../ProgramGenerated/components/AssignToClientModal/AssignToClientModal");
var _button = require("src/components/Button/Button");
var _sessionStore = require("src/store/sessionStore");
var _programCardScss = require("./ProgramCard.scss");
var _programAiSvg = require("../../../../../../../../assets/images/onboarding-trainer/dashboard/programs/program-ai.svg");
var _programAiLargeSvg = require("../../../../../../../../assets/images/onboarding-trainer/dashboard/programs/program-ai-large.svg");
var _shareSvg = require("../../../../../../../../assets/images/onboarding-trainer/dashboard/programs/share.svg");
var _archiveSvg = require("../../../../../../../../assets/images/onboarding-trainer/dashboard/programs/archive.svg");
var _archiveConfirmationSvg = require("../../../../../../../../assets/images/onboarding-trainer/dashboard/programs/archive-confirmation.svg");
var _moreProgramWorkoutSvg = require("src/assets/images/trainer/clients/more_program_workout.svg");
var _calendarSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/calendar.svg");
var _clockSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/clock.svg");
var _deleteSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/delete.svg");
var _assignToClientSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/assign-to-client.svg");
var _copySvg = require("src/assets/images/onboarding-trainer/dashboard/programs/copy.svg");
var _dashboardModalDeleteSvg = require("src/assets/images/trainer/clients/dashboard-modal-delete.svg");
var _dashboardModalDuplicateSvg = require("src/assets/images/trainer/clients/dashboard-modal-duplicate.svg");
// Modal Images
var _copyLinkSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/copy_link.svg");
var _miniptAppSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/minipt-app.svg");
var _messengerSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/messenger.svg");
var _smsSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/sms.svg");
var _closeIconSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/close-icon.svg");
const ProgramCard = ({ data, viewMode })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const trainerId = currentUser?.uid;
    const isAssigned = !!data.clientId;
    const [isShareModalOpen, setIsShareModalOpen] = (0, _react.useState)(false);
    const [isArchiveModalOpen, setIsArchiveModalOpen] = (0, _react.useState)(false);
    const [isDeleteModalOpen, setIsDeleteModalOpen] = (0, _react.useState)(false);
    const [isAssignModalOpen, setIsAssignModalOpen] = (0, _react.useState)(false);
    const [isDuplicateModalOpen, setIsDuplicateModalOpen] = (0, _react.useState)(false);
    const toggleShareModal = (e)=>{
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        setIsShareModalOpen(!isShareModalOpen);
    };
    const { mutate: archiveProgram, isPending: isArchiving } = (0, _useArchiveProgramPlan.useArchiveProgramPlan)();
    const { mutate: sendProgram, isPending: isSending } = (0, _useSendProgramPlanToClient.useSendProgramPlanToClient)();
    const isArchived = data.isActive === '0' || String(data.isActive) === '0' || data.isActive === 'false';
    const handleArchive = ()=>{
        const docPath = data.docPath || (data.id && trainerId ? `trainer_app_users/${trainerId}/programme_plan/${data.id}` : '');
        archiveProgram({
            docPath,
            programId: data.id,
            trainerId,
            isActive: isArchived ? '1' : '0'
        }, {
            onSuccess: ()=>{
                setIsArchiveModalOpen(false);
            }
        });
    };
    const { mutate: deleteProgram, isPending: isDeleting } = (0, _useDeleteProgramPlan.useDeleteProgramPlan)();
    const { mutate: duplicateProgram, isPending: isDuplicating } = (0, _useDuplicateProgramPlan.useDuplicateProgramPlan)();
    const handleDuplicate = (e)=>{
        e.stopPropagation();
        setIsDuplicateModalOpen(true);
    };
    const confirmDuplicate = ()=>{
        const docPath = data.docPath || (data.id && trainerId ? `trainer_app_users/${trainerId}/programme_plan/${data.id}` : '');
        duplicateProgram({
            docPath,
            programId: data.id
        }, {
            onSuccess: ()=>{
                setIsDuplicateModalOpen(false);
            }
        });
    };
    const handleDelete = ()=>{
        const docPath = data.docPath || (data.id && trainerId ? `trainer_app_users/${trainerId}/programme_plan/${data.id}` : '');
        deleteProgram({
            docPath,
            programId: data.id,
            trainerId
        }, {
            onSuccess: ()=>{
                setIsDeleteModalOpen(false);
            }
        });
    };
    const appStoreLink = (0, _appLinksConfig.APP_LINKS).ios;
    const shareLink = `${window.location.origin}/program/${data.id}`;
    const shareText = `Your PT has sent you \u{201C}${data.programmeName}\u{201D}.
View it in the miniPT app. If you don\u{2019}t have miniPT yet, install the app first, then open this link:
${shareLink}\n\nDownload on the App Store:\n${appStoreLink}`;
    const encodedShareText = encodeURIComponent(shareText);
    const [isCopied, setIsCopied] = (0, _react.useState)(false);
    const handleCopyLink = ()=>{
        navigator.clipboard.writeText(shareText);
        setIsCopied(true);
        setTimeout(()=>{
            setIsCopied(false);
        }, 2000);
    };
    const handleWhatsApp = ()=>{
        window.open(`https://wa.me/?text=${encodedShareText}`, '_blank');
    };
    const handleMessenger = ()=>{
        window.open(`fb-messenger://share/?link=${encodeURIComponent(shareLink)}`, '_blank');
    };
    const handleSMS = ()=>{
        window.open(`sms:?body=${encodedShareText}`, '_self');
    };
    const handleMiniPTApp = ()=>{
        // If no client is assigned yet, open the assign modal first
        if (!data.clientId) {
            setIsShareModalOpen(false);
            setIsAssignModalOpen(true);
            return;
        }
        sendProgram({
            docPath: data.docPath,
            clientId: data.clientId,
            programId: data.id,
            notify: true,
            startDate: new Date().toISOString().split('T')[0],
            message: ''
        }, {
            onSuccess: ()=>{
                setIsShareModalOpen(false);
            }
        });
    };
    const isDraft = data.status === 'draft';
    const [isMobile, setIsMobile] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        const handleResize = ()=>setIsMobile(window.innerWidth < 992);
        handleResize();
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    const forceGridOnMobile = true;
    const activeViewMode = forceGridOnMobile && isMobile ? 'grid' : viewMode;
    const hideThumbnails = viewMode === 'list';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `program-card-wrapper ${activeViewMode}-view ${hideThumbnails ? 'hide-thumbnails' : ''}`,
        onClick: ()=>{
            if (isDraft) {
                const genType = data.generatorType === 'manual' || data?.type === 'manual' || data.isManually ? 'manual' : 'ai';
                navigate(`/onboarding-trainer/dashboard/program-generator/${genType}?programId=${data.id}`);
            } else {
                const isManualProg = data.generatorType === 'manual' || data?.type === 'manual' || Boolean(data.isManually);
                navigate(`/onboarding-trainer/dashboard/program-generated/${data.id}`, {
                    state: {
                        clientId: data.clientId,
                        clientName: data.assignedTo?.name,
                        isManually: isManualProg,
                        generatorType: isManualProg ? 'manual' : 'ai'
                    }
                });
            }
        },
        style: {
            cursor: 'pointer'
        },
        children: [
            activeViewMode === 'grid' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "title-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programAiSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "title-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                title: data.programmeName,
                                                children: data.programmeName
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "date",
                                                children: data.date
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isDraft ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "draft-header-actions",
                                onClick: (e)=>e.stopPropagation(),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "icon-action-btn",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            setIsDeleteModalOpen(true);
                                        },
                                        disabled: isArchiving,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "icon-action-btn archive-btn",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            setIsArchiveModalOpen(true);
                                        },
                                        disabled: isArchiving,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _archiveSvg.ReactComponent), {})
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "share-btn",
                                onClick: toggleShareModal,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shareSvg.ReactComponent), {})
                            })
                        ]
                    }),
                    !isDraft && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "meta-info",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "meta-item-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                children: [
                                                    data.weeks,
                                                    " weeks"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clockSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                children: [
                                                    data.daysPerWeek,
                                                    " days/week"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "action-buttons-group",
                                onClick: (e)=>e.stopPropagation(),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "icon-action-btn",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            setIsDeleteModalOpen(true);
                                        },
                                        disabled: isArchiving,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "icon-action-btn archive-btn",
                                        onClick: (e)=>{
                                            e.stopPropagation();
                                            setIsArchiveModalOpen(true);
                                        },
                                        disabled: isArchiving,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _archiveSvg.ReactComponent), {})
                                    })
                                ]
                            })
                        ]
                    }),
                    isDraft ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "draft-state",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: "Don't worry. We saved your answers. Continue from where you left"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "full-width-btn",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    navigate(`/onboarding-trainer/dashboard/program-generator/ai?programId=${data.id}&step=${data.nextStepSlug || 'energy-level'}`);
                                },
                                children: "Finish program creation"
                            })
                        ]
                    }) : viewMode !== 'list' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "thumbnails",
                        children: [
                            data.thumbnails.map((thumb, index)=>thumb ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: thumb,
                                    alt: `thumb ${index}`,
                                    className: "thumbnail-item"
                                }, index) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "thumbnail-item placeholder"
                                }, index)),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "more-thumbnails",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moreProgramWorkoutSvg.ReactComponent), {})
                            })
                        ]
                    }),
                    isAssigned ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "assignment",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "assignment-info",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "label",
                                        children: "Assigned to:"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "assignment-details",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "avatar",
                                                children: data.assignedTo.initials
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "name",
                                                title: data.assignedTo.name,
                                                children: data.assignedTo.name
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "copy-btn",
                                disabled: isDuplicating,
                                onClick: handleDuplicate,
                                title: "Duplicate program",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copySvg.ReactComponent), {})
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "assignment unassigned",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "label",
                                children: "Assigned to:"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                className: "full-width-btn assign-btn",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    setIsAssignModalOpen(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignToClientSvg.ReactComponent), {}),
                                    " Assign to client"
                                ]
                            })
                        ]
                    })
                ]
            }),
            activeViewMode === 'list' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "list-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mobile-only mobile-top",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "title-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon-wrapper mobile-only",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programAiSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "title-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: data.programmeName
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "date",
                                                children: data.date
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "list-row desktop-only",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "left-content-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "info-column",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "title-section",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "icon-wrapper large-icon",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programAiLargeSvg.ReactComponent), {})
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "title-text",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                    title: data.programmeName,
                                                                    children: data.programmeName
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "date",
                                                                    children: data.date
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                isDraft ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "draft-text-list",
                                                    children: "Don't worry. We saved your answers. Continue from where you left"
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "meta-info",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "meta-item",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarSvg.ReactComponent), {
                                                                    className: "small-icon"
                                                                }),
                                                                " ",
                                                                data.weeks,
                                                                " weeks"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "meta-item",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clockSvg.ReactComponent), {
                                                                    className: "small-icon"
                                                                }),
                                                                " ",
                                                                data.daysPerWeek,
                                                                " days/week"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "assignment-column",
                                            children: isAssigned ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "assignment",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "assignment-info",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "label",
                                                            children: "Assigned to:"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "assignment-details",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "avatar",
                                                                    children: data.assignedTo.initials
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "name",
                                                                    title: data.assignedTo.name,
                                                                    children: data.assignedTo.name
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    className: "copy-btn",
                                                                    disabled: isDuplicating,
                                                                    onClick: handleDuplicate,
                                                                    title: "Duplicate program",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copySvg.ReactComponent), {})
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "assignment unassigned",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: "Assigned to:"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                        className: "full-width-btn assign-btn",
                                                        onClick: (e)=>{
                                                            e.stopPropagation();
                                                            setIsAssignModalOpen(true);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignToClientSvg.ReactComponent), {}),
                                                            " Assign to client"
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "right-actions-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "icon-actions",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "icon-action-btn",
                                                    onClick: (e)=>{
                                                        e.stopPropagation();
                                                        setIsDeleteModalOpen(true);
                                                    },
                                                    disabled: isArchiving,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    className: "icon-action-btn archive-btn",
                                                    onClick: (e)=>{
                                                        e.stopPropagation();
                                                        setIsArchiveModalOpen(true);
                                                    },
                                                    disabled: isArchiving,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _archiveSvg.ReactComponent), {})
                                                })
                                            ]
                                        }),
                                        isDraft ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "full-width-btn finish-btn",
                                            onClick: (e)=>{
                                                e.stopPropagation();
                                                navigate(`/onboarding-trainer/dashboard/program-generator/ai?programId=${data.id}`);
                                            },
                                            children: "Finish program creation"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            className: "share-btn with-text",
                                            onClick: toggleShareModal,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shareSvg.ReactComponent), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Share"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mobile-only mobile-bottom",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "mobile-meta-info",
                                    children: isDraft ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "draft-text-list",
                                        children: "Don't worry. We saved your answers. Continue from where you left"
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "meta-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarSvg.ReactComponent), {
                                                        className: "small-icon"
                                                    }),
                                                    data.weeks,
                                                    " weeks"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "meta-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clockSvg.ReactComponent), {
                                                        className: "small-icon"
                                                    }),
                                                    data.daysPerWeek,
                                                    " days/week"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "assignment-column",
                                    children: isAssigned ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "assignment",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "assignment-info",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "label",
                                                    children: "Assigned to:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "assignment-details",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "avatar",
                                                            children: data.assignedTo.initials
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "name",
                                                            title: data.assignedTo.name,
                                                            children: data.assignedTo.name
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            className: "copy-btn",
                                                            disabled: isDuplicating,
                                                            onClick: handleDuplicate,
                                                            title: "Duplicate program",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copySvg.ReactComponent), {})
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "assignment unassigned",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: "Assigned to:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                className: "full-width-btn assign-btn",
                                                onClick: (e)=>{
                                                    e.stopPropagation();
                                                    setIsAssignModalOpen(true);
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignToClientSvg.ReactComponent), {}),
                                                    " Assign to client"
                                                ]
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "divider"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "action-buttons-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "icon-action-btn",
                                            onClick: (e)=>{
                                                e.stopPropagation();
                                                setIsDeleteModalOpen(true);
                                            },
                                            disabled: isArchiving,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteSvg.ReactComponent), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "icon-action-btn archive-btn",
                                            onClick: (e)=>{
                                                e.stopPropagation();
                                                setIsArchiveModalOpen(true);
                                            },
                                            disabled: isArchiving,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _archiveSvg.ReactComponent), {})
                                        }),
                                        isDraft ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "full-width-btn finish-btn",
                                            onClick: (e)=>{
                                                e.stopPropagation();
                                                navigate(`/onboarding-trainer/dashboard/program-generator/ai?programId=${data.id}`);
                                            },
                                            children: "Finish program creation"
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "icon-action-btn with-text",
                                            onClick: toggleShareModal,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shareSvg.ReactComponent), {})
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                onClick: (e)=>e.stopPropagation(),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                        open: isShareModalOpen,
                        footer: null,
                        onCancel: ()=>setIsShareModalOpen(false),
                        centered: true,
                        width: 500,
                        closeIcon: null,
                        rootClassName: "share-program-modal",
                        className: "share-program-modal",
                        styles: {
                            mask: {
                                backdropFilter: 'blur(4px)',
                                backgroundColor: 'rgba(6, 7, 35, 0.8)'
                            }
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "share-modal-content",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "modal-header",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                            children: "Share Program"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "close-btn",
                                            onClick: toggleShareModal,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeIconSvg.ReactComponent), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    className: "modal-subtitle",
                                    children: [
                                        'Share "',
                                        data.programmeName,
                                        '" with your client'
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "main-options",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            className: `share-option-btn primary-option ${isCopied ? 'copied-btn' : ''}`,
                                            onClick: handleCopyLink,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "icon-box copy-link",
                                                    children: isCopied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "#ffffff",
                                                        strokeWidth: "2.5",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        className: "check-icon",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                            points: "20 6 9 17 4 12"
                                                        })
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyLinkSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "option-text",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "option-title",
                                                            children: isCopied ? 'Link Copied!' : 'Copy Link'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "option-desc",
                                                            children: isCopied ? 'Copied to clipboard!' : 'Copy shareable link to clipboard'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            className: "share-option-btn primary-option",
                                            onClick: handleMiniPTApp,
                                            disabled: isSending,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "icon-box minipt-app",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miniptAppSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "option-text",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "option-title",
                                                            children: isSending ? 'Sending...' : data.isSent ? 'Send Again' : 'Send via miniPT App'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "option-desc",
                                                            children: data.isSent ? "Resend and update programme in client's miniPT app" : !data.clientId ? 'Assign a client first to send via miniPT app' : "Send directly to client's miniPT app"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "modal-divider",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Or share via"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "secondary-options",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            className: "share-option-btn secondary-option",
                                            onClick: handleWhatsApp,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "icon-box social-icon",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messengerSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "WhatsApp"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            className: "share-option-btn secondary-option",
                                            onClick: handleMessenger,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "icon-box social-icon",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messengerSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "Messenger"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            className: "share-option-btn secondary-option",
                                            onClick: handleSMS,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "icon-box social-icon",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smsSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "SMS"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                        open: isArchiveModalOpen,
                        footer: null,
                        onCancel: ()=>setIsArchiveModalOpen(false),
                        centered: true,
                        width: 400,
                        closeIcon: null,
                        rootClassName: "logout-modal",
                        className: "logout-modal",
                        styles: {
                            mask: {
                                backdropFilter: 'blur(4px)',
                                backgroundColor: 'rgba(6, 7, 35, 0.8)'
                            }
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-modal-content",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "logout-icon-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _archiveConfirmationSvg.ReactComponent), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                    children: [
                                        isArchived ? 'Unarchive' : 'Archive',
                                        " Program?"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        "Are you sure you want to ",
                                        isArchived ? 'unarchive' : 'archive',
                                        ' "',
                                        data.programmeName,
                                        '"?'
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "logout-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            className: "btn-logout",
                                            disabled: isArchiving,
                                            isLoading: isArchiving,
                                            onClick: handleArchive,
                                            children: isArchived ? 'Unarchive' : 'Archive'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "btn-cancel",
                                            onClick: ()=>setIsArchiveModalOpen(false),
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                        open: isDeleteModalOpen,
                        footer: null,
                        onCancel: ()=>setIsDeleteModalOpen(false),
                        centered: true,
                        width: 400,
                        closeIcon: null,
                        rootClassName: "logout-modal",
                        className: "logout-modal",
                        styles: {
                            mask: {
                                backdropFilter: 'blur(4px)',
                                backgroundColor: 'rgba(6, 7, 35, 0.8)'
                            }
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-modal-content",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "logout-icon-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardModalDeleteSvg.ReactComponent), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    children: "Delete Program?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        'Are you sure you want to delete "',
                                        data.programmeName,
                                        '"?'
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "logout-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            className: "btn-logout",
                                            disabled: isDeleting,
                                            onClick: handleDelete,
                                            isLoading: isDeleting,
                                            children: "Delete"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            className: "btn-cancel",
                                            onClick: ()=>setIsDeleteModalOpen(false),
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                        open: isDuplicateModalOpen,
                        footer: null,
                        onCancel: ()=>setIsDuplicateModalOpen(false),
                        centered: true,
                        width: 400,
                        closeIcon: null,
                        rootClassName: "logout-modal",
                        className: "logout-modal",
                        styles: {
                            mask: {
                                backdropFilter: 'blur(4px)',
                                backgroundColor: 'rgba(6, 7, 35, 0.8)'
                            }
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-modal-content",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "logout-icon-wrapper",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardModalDuplicateSvg.ReactComponent), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    children: "Duplicate Program?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                    children: [
                                        'Are you sure you want to duplicate "',
                                        data.programmeName,
                                        '"?'
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "logout-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            className: "btn-logout",
                                            disabled: isDuplicating,
                                            onClick: confirmDuplicate,
                                            isLoading: isDuplicating,
                                            children: "Duplicate"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            className: "btn-cancel",
                                            onClick: ()=>setIsDuplicateModalOpen(false),
                                            children: "Cancel"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignToClientModal.AssignToClientModal), {
                        isOpen: isAssignModalOpen,
                        onClose: ()=>setIsAssignModalOpen(false),
                        onAssign: (assignData)=>{
                            return new Promise((resolve, reject)=>{
                                sendProgram({
                                    docPath: data.docPath,
                                    programId: data.id,
                                    clientId: assignData.clientId,
                                    startDate: assignData.startDate,
                                    notify: assignData.notify,
                                    message: assignData.message
                                }, {
                                    onSuccess: ()=>{
                                        setIsAssignModalOpen(false);
                                        resolve();
                                    },
                                    onError: (error)=>{
                                        reject(error);
                                    }
                                });
                            });
                        }
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","antd":[["Modal","kY4DD","default"]],"src/config/app-links.config":"lGiup","src/api/mutations/useArchiveProgramPlan":"1PYAP","src/api/mutations/useDeleteProgramPlan":"gXAUl","src/api/mutations/useSendProgramPlanToClient":"4puCf","src/api/mutations/useDuplicateProgramPlan":"fTLHP","../../../ProgramGenerated/components/AssignToClientModal/AssignToClientModal":"erZXW","src/components/Button/Button":"g0894","src/store/sessionStore":"kPSO3","./ProgramCard.scss":"3xKUM","../../../../../../../../assets/images/onboarding-trainer/dashboard/programs/program-ai.svg":"2HhJP","../../../../../../../../assets/images/onboarding-trainer/dashboard/programs/program-ai-large.svg":"8UBX0","../../../../../../../../assets/images/onboarding-trainer/dashboard/programs/share.svg":"f2Jtq","../../../../../../../../assets/images/onboarding-trainer/dashboard/programs/archive.svg":"h8VBW","../../../../../../../../assets/images/onboarding-trainer/dashboard/programs/archive-confirmation.svg":"eyEXI","src/assets/images/trainer/clients/more_program_workout.svg":"21mCv","src/assets/images/onboarding-trainer/dashboard/programs/calendar.svg":"lqn5K","src/assets/images/onboarding-trainer/dashboard/programs/clock.svg":"8UFg1","src/assets/images/onboarding-trainer/dashboard/programs/delete.svg":"aPIYI","src/assets/images/onboarding-trainer/dashboard/programs/assign-to-client.svg":"315jk","src/assets/images/onboarding-trainer/dashboard/programs/copy.svg":"cXT4E","src/assets/images/trainer/clients/dashboard-modal-delete.svg":"4NTEi","src/assets/images/trainer/clients/dashboard-modal-duplicate.svg":"1qXpt","src/assets/images/onboarding-trainer/dashboard/programs/copy_link.svg":"jBuuB","src/assets/images/onboarding-trainer/dashboard/programs/minipt-app.svg":"bUWqY","src/assets/images/onboarding-trainer/dashboard/programs/messenger.svg":"fG1PB","src/assets/images/onboarding-trainer/dashboard/programs/sms.svg":"1OQrU","src/assets/images/onboarding-trainer/dashboard/programs/close-icon.svg":"ifISx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1PYAP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useArchiveProgramPlan", ()=>useArchiveProgramPlan);
var _reactQuery = require("@tanstack/react-query");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
const useArchiveProgramPlan = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const response = await (0, _axiosDefault.default).post(`${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_ARCHIVE_PROGRAM_PLAN}`, {
                data: payload
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        },
        onSuccess: (_, variables)=>{
            // Invalidate the query to fetch fresh data
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-program-plan-list'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientWorkoutsTab'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientProgramTab'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientOverview'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'overview'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer_get_client_overview'
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    'clientWorkoutsTab'
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    'clientProgramTab'
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    'clientOverview'
                ]
            });
            const isUnarchiving = variables.isActive === '1';
            (0, _reactHotToastDefault.default).success(`Program ${isUnarchiving ? 'restored' : 'archived'} successfully`);
        },
        onError: (error, variables)=>{
            const isUnarchiving = variables.isActive === '1';
            const action = isUnarchiving ? 'unarchive' : 'archive';
            console.error(`Failed to ${action} program`, error);
            (0, _reactHotToastDefault.default).error(`Failed to ${action} program`);
        }
    });
};

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"axios":"kL5AO","src/config/api-config":"9oD3c","react-hot-toast":"3T0Wh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gXAUl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDeleteProgramPlan", ()=>useDeleteProgramPlan);
var _reactQuery = require("@tanstack/react-query");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
const useDeleteProgramPlan = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const response = await (0, _axiosDefault.default).post(`${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_DELETE_PROGRAM_PLAN}`, {
                data: payload
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        },
        onSuccess: (data, variables)=>{
            // Invalidate the query to fetch fresh data
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-program-plan-list'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientWorkoutsTab'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientProgramTab'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientOverview'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'overview'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer_get_client_overview'
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    'clientWorkoutsTab'
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    'clientProgramTab'
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    'clientOverview'
                ]
            });
            if (!variables.hideToast) (0, _reactHotToastDefault.default).success('Program deleted successfully');
        },
        onError: (error)=>{
            console.error('Failed to delete program', error);
            (0, _reactHotToastDefault.default).error('Failed to delete program');
        }
    });
};

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"axios":"kL5AO","src/config/api-config":"9oD3c","react-hot-toast":"3T0Wh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4puCf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSendProgramPlanToClient", ()=>useSendProgramPlanToClient);
var _reactQuery = require("@tanstack/react-query");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
const useSendProgramPlanToClient = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const response = await (0, _axiosDefault.default).post(`${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_SEND_PROGRAMME_PLAN_TO_CLIENT}`, {
                data: payload
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        },
        onSuccess: ()=>{
            // Invalidate the query to fetch fresh data so the program moves to 'sent' state
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-program-plan-list'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientWorkoutsTab'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientProgramTab'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientOverview'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'overview'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer_get_client_overview'
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    'clientWorkoutsTab'
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    'clientProgramTab'
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    'clientOverview'
                ]
            });
            (0, _reactHotToastDefault.default).success('Program sent successfully');
        },
        onError: (error)=>{
            console.error('Failed to send program', error);
            (0, _reactHotToastDefault.default).error('Failed to send program');
        }
    });
};

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"axios":"kL5AO","src/config/api-config":"9oD3c","react-hot-toast":"3T0Wh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fTLHP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useDuplicateProgramPlan", ()=>useDuplicateProgramPlan);
var _reactQuery = require("@tanstack/react-query");
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _sessionStore = require("src/store/sessionStore");
const useDuplicateProgramPlan = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const trainerId = currentUser?.uid;
            if (!trainerId) throw new Error('Trainer ID not found');
            const response = await fetch(`${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_DUPLICATE_PROGRAM_PLAN}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    data: {
                        ...payload,
                        trainerId
                    }
                })
            });
            if (!response.ok) throw new Error('Failed to duplicate program');
            return response.json();
        },
        onSuccess: ()=>{
            (0, _reactHotToastDefault.default).success('Program duplicated successfully.');
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-program-plan-list'
                ]
            });
        },
        onError: (error)=>{
            console.error(error);
            (0, _reactHotToastDefault.default).error('Failed to duplicate the program. Please try again.');
        }
    });
};

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"react-hot-toast":"3T0Wh","src/config/api-config":"9oD3c","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"erZXW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AssignToClientModal", ()=>AssignToClientModal);
var _jsxRuntime = require("react/jsx-runtime");
var _assignToClientModalScss = require("./AssignToClientModal.scss");
var _antd = require("antd");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactInfiniteScrollComponent = require("react-infinite-scroll-component");
var _reactInfiniteScrollComponentDefault = parcelHelpers.interopDefault(_reactInfiniteScrollComponent);
var _useGetTrainerClients = require("src/api/mutations/useGetTrainerClients");
var _searchSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/search.svg");
var _downArrowSvg = require("src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/down-arrow.svg");
var _monthSvg = require("src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/month.svg");
var _radioTick2Svg = require("src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/radio-tick-2.svg");
var _closeIconSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/close-icon.svg");
var _solarDangerTriangleLinearSvg = require("src/assets/images/onboarding-trainer/solar_danger-triangle-linear.svg");
var _useGetTrainerProgramPlanList = require("src/api/mutations/useGetTrainerProgramPlanList");
var _sessionStore = require("src/store/sessionStore");
var _useDeleteProgramPlan = require("src/api/mutations/useDeleteProgramPlan");
const AssignToClientModal = ({ isOpen, onClose, onAssign })=>{
    const [searchQuery, setSearchQuery] = (0, _react.useState)('');
    const [debouncedSearch, setDebouncedSearch] = (0, _react.useState)('');
    const [selectedClient, setSelectedClient] = (0, _react.useState)(null);
    const [startDate, setStartDate] = (0, _react.useState)(new Date().toISOString().split('T')[0]);
    const [notify, setNotify] = (0, _react.useState)(true);
    const [message, setMessage] = (0, _react.useState)('');
    const [currentPage, setCurrentPage] = (0, _react.useState)(1);
    const [allClients, setAllClients] = (0, _react.useState)([]);
    const [isAssigning, setIsAssigning] = (0, _react.useState)(false);
    const [clientPrograms, setClientPrograms] = (0, _react.useState)([]);
    const [isCheckingPrograms, setIsCheckingPrograms] = (0, _react.useState)(false);
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const trainerId = currentUser?.uid;
    const { mutateAsync: deleteProgram } = (0, _useDeleteProgramPlan.useDeleteProgramPlan)();
    const { data, isLoading } = (0, _useGetTrainerClients.useGetTrainerClients)('active', debouncedSearch, 'newest', currentPage, 10);
    const totalCount = data?.totalCount || 0;
    const prevSearchRef = (0, _react.useRef)(debouncedSearch);
    (0, _react.useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedSearch(searchQuery);
        }, 500);
        return ()=>clearTimeout(handler);
    }, [
        searchQuery
    ]);
    (0, _react.useEffect)(()=>{
        const filterChanged = prevSearchRef.current !== debouncedSearch;
        if (filterChanged) {
            setCurrentPage(1);
            prevSearchRef.current = debouncedSearch;
        }
        const fetchedClients = data?.clients;
        if (fetchedClients && fetchedClients.length > 0) {
            if (currentPage === 1 || filterChanged) setAllClients(fetchedClients);
            else setAllClients((prev)=>{
                const existingIds = new Set(prev.map((c)=>c.uid));
                const newClients = fetchedClients.filter((c)=>!existingIds.has(c.uid));
                return [
                    ...prev,
                    ...newClients
                ];
            });
        } else if (fetchedClients && fetchedClients.length === 0 && (currentPage === 1 || filterChanged)) setAllClients([]);
        else if (!fetchedClients && filterChanged) setAllClients([]);
    }, [
        data?.clients,
        currentPage,
        debouncedSearch
    ]);
    (0, _react.useEffect)(()=>{
        if (selectedClient && trainerId) {
            setIsCheckingPrograms(true);
            (0, _useGetTrainerProgramPlanList.fetchTrainerProgramPlanList)(trainerId, {
                clientId: selectedClient.uid,
                isActive: '1'
            }).then((programs)=>{
                const activeClientPrograms = (programs || []).filter((p)=>p.clientId === selectedClient.uid && String(p.isActive) === '1');
                setClientPrograms(activeClientPrograms);
            }).catch(console.error).finally(()=>setIsCheckingPrograms(false));
        } else setClientPrograms([]);
    }, [
        selectedClient,
        trainerId
    ]);
    const getInitials = (name, surname)=>{
        const first = name ? name.charAt(0).toUpperCase() : '';
        const second = surname ? surname.charAt(0).toUpperCase() : '';
        return `${first}${second}`;
    };
    const handleAssign = async ()=>{
        if (!selectedClient) return;
        setIsAssigning(true);
        try {
            if (clientPrograms.length > 0) await Promise.all(clientPrograms.map((p)=>deleteProgram({
                    docPath: p.docPath,
                    hideToast: true
                }).catch(console.error)));
            await onAssign({
                clientId: selectedClient.uid,
                startDate: startDate,
                notify,
                message: message.trim()
            });
            onClose();
        } catch (error) {
            console.error(error);
        } finally{
            setIsAssigning(false);
        }
    };
    // reset state when modal opens/closes
    (0, _react.useEffect)(()=>{
        if (isOpen) {
            setSearchQuery('');
            setDebouncedSearch('');
            setSelectedClient(null);
            setStartDate(new Date().toISOString().split('T')[0]);
            setNotify(true);
            setMessage('');
            setCurrentPage(1);
        }
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        onCancel: onClose,
        footer: null,
        centered: true,
        width: 540,
        closeIcon: null,
        rootClassName: "assign-client-modal",
        className: "logout-modal",
        styles: {
            mask: {
                backdropFilter: 'blur(4px)',
                backgroundColor: 'rgba(6, 7, 35, 0.8)'
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "assign-client-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "modal-title",
                            children: "Assign to a client"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "close-btn",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeIconSvg.ReactComponent), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "modal-subtitle",
                    children: "Choose a client and assign this workout"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "search-box",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchSvg.ReactComponent), {
                            className: "search-icon"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "text",
                            placeholder: "Search client",
                            value: searchQuery,
                            onChange: (e)=>setSearchQuery(e.target.value),
                            disabled: isAssigning
                        }),
                        searchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "clear-search-btn",
                            "aria-label": "Clear search",
                            onClick: ()=>setSearchQuery(''),
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "18",
                                        y1: "6",
                                        x2: "6",
                                        y2: "18"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "6",
                                        y1: "6",
                                        x2: "18",
                                        y2: "18"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "client-list-wrapper",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: `client-list-container ${allClients.length > 2 ? 'has-scroll' : ''}`,
                            id: "assignClientList",
                            children: [
                                isLoading && allClients.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "loading-state",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                            size: "small"
                                        }),
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                marginLeft: 8
                                            },
                                            children: "Loading clients..."
                                        })
                                    ]
                                }),
                                !isLoading && allClients.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "empty-state",
                                    children: "No clients found."
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactInfiniteScrollComponentDefault.default), {
                                    dataLength: allClients.length,
                                    next: ()=>setCurrentPage((prev)=>prev + 1),
                                    hasMore: allClients.length < totalCount,
                                    loader: allClients.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "loading-state",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                size: "small"
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    marginLeft: 8
                                                },
                                                children: "Loading more clients..."
                                            })
                                        ]
                                    }) : null,
                                    scrollableTarget: "assignClientList",
                                    children: allClients.map((client)=>{
                                        const isSelected = selectedClient?.uid === client.uid;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: `client-item ${isSelected ? 'selected' : ''} ${isAssigning ? 'disabled' : ''}`,
                                            onClick: ()=>{
                                                if (!isAssigning) setSelectedClient(client);
                                            },
                                            style: {
                                                opacity: isAssigning ? 0.5 : 1,
                                                pointerEvents: isAssigning ? 'none' : 'auto'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "client-info",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "client-avatar",
                                                            children: client.avatarUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: client.avatarUrl,
                                                                alt: client.name
                                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "avatar-placeholder",
                                                                children: getInitials(client.name, client.surname)
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "client-name",
                                                            children: [
                                                                client.name,
                                                                " ",
                                                                client.surname
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "client-radio",
                                                    children: isSelected ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioTick2Svg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "radio-circle"
                                                    })
                                                })
                                            ]
                                        }, client.uid);
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "list-fade-overlay"
                        })
                    ]
                }),
                selectedClient && clientPrograms.length > 0 && !isCheckingPrograms && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "inline-warning",
                    style: {
                        backgroundColor: '#2B2B2B',
                        padding: 12,
                        borderRadius: 8,
                        marginTop: 16,
                        display: 'flex',
                        gap: 12,
                        alignItems: 'flex-start'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _solarDangerTriangleLinearSvg.ReactComponent), {
                            style: {
                                width: 24,
                                height: 24,
                                minWidth: 24,
                                minHeight: 24,
                                flexShrink: 0,
                                marginTop: 2
                            }
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    style: {
                                        margin: 0,
                                        fontSize: 14,
                                        fontWeight: 500,
                                        color: '#FFFFFF'
                                    },
                                    children: "Replace current program?"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    style: {
                                        margin: '4px 0 0 0',
                                        fontSize: 12,
                                        color: '#A0A0A0'
                                    },
                                    children: "This client already has an active program. Assigning a new one will replace it, and any progress in the current program will be lost."
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "config-row",
                    style: {
                        marginTop: 16
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "config-group start-date-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    children: "Start date"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.DatePicker), {
                                    format: (value)=>{
                                        if (!value) return '';
                                        if (value.isSame((0, _dayjsDefault.default)(), 'day')) return 'Today';
                                        return value.format('D MMM, YYYY');
                                    },
                                    value: startDate ? (0, _dayjsDefault.default)(startDate, 'YYYY-MM-DD') : null,
                                    onChange: (date)=>setStartDate(date ? date.format('YYYY-MM-DD') : ''),
                                    disabledDate: (current)=>{
                                        const today = (0, _dayjsDefault.default)().startOf('day');
                                        const maxDate = today.add(1, 'year');
                                        return current && (current < today || current > maxDate);
                                    },
                                    allowClear: false,
                                    suffixIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downArrowSvg.ReactComponent), {}),
                                    prefix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _monthSvg.ReactComponent), {}),
                                    className: "dark-datepicker-custom",
                                    classNames: {
                                        popup: 'dark-datepicker-popup'
                                    },
                                    size: "small",
                                    disabled: isAssigning
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "config-group notify-group",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: `notify-card ${notify ? 'active' : ''} ${isAssigning ? 'disabled' : ''}`,
                                onClick: ()=>{
                                    if (!isAssigning) setNotify(!notify);
                                },
                                style: {
                                    opacity: isAssigning ? 0.5 : 1,
                                    pointerEvents: isAssigning ? 'none' : 'auto'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "notify-header",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Checkbox), {
                                                checked: notify,
                                                className: "notify-checkbox"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "notify-title",
                                                children: "Notify client now"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "notify-subtitle",
                                        title: `Send a notification to ${selectedClient ? `${selectedClient.name || ''} ${selectedClient.surname || ''}`.trim() : 'client name'}`,
                                        children: [
                                            "Send a notification to",
                                            ' ',
                                            selectedClient ? `${selectedClient.name || ''} ${selectedClient.surname || ''}`.trim() : 'client name'
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "message-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Add message (optional)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "char-count",
                                    children: [
                                        message.length,
                                        "/1000"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "textarea-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                placeholder: "Type here...",
                                maxLength: 1000,
                                value: message,
                                onChange: (e)=>setMessage(e.target.value),
                                onBlur: (e)=>setMessage(e.target.value.trim()),
                                disabled: isAssigning
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "btn-cancel",
                            onClick: onClose,
                            disabled: isAssigning,
                            children: "Cancel"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: "btn-assign-primary",
                            onClick: handleAssign,
                            disabled: !selectedClient || isAssigning,
                            children: [
                                isAssigning && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    width: "20",
                                    height: "20",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "3",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    style: {
                                        marginRight: 8,
                                        animation: 'custom-spin 1s linear infinite'
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M21 12a9 9 0 1 1-6.219-8.56"
                                    })
                                }),
                                clientPrograms.length > 0 ? 'Replace Program' : 'Assign to client'
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","./AssignToClientModal.scss":"3T0cZ","antd":[["Checkbox","cz5r0","default"],["DatePicker","3z8aE","default"],["Modal","kY4DD","default"],["Spin","lVvhl","default"]],"dayjs":"adpMK","react":"bmhQu","react-infinite-scroll-component":"jrRfZ","src/api/mutations/useGetTrainerClients":"18nHc","src/assets/images/onboarding-trainer/dashboard/clients/search.svg":"1z49p","src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/down-arrow.svg":"dZZ3x","src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/month.svg":"3C1kF","src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/radio-tick-2.svg":"hejBm","src/assets/images/onboarding-trainer/dashboard/programs/close-icon.svg":"ifISx","src/assets/images/onboarding-trainer/solar_danger-triangle-linear.svg":"9eQb4","src/api/mutations/useGetTrainerProgramPlanList":"eJMbb","src/store/sessionStore":"kPSO3","src/api/mutations/useDeleteProgramPlan":"gXAUl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3T0cZ":[function() {},{}],"3z8aE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dayjs = require("@rc-component/picker/generate/dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _purePanel = require("../_util/PurePanel");
var _purePanelDefault = parcelHelpers.interopDefault(_purePanel);
var _generatePicker = require("./generatePicker");
var _generatePickerDefault = parcelHelpers.interopDefault(_generatePicker);
"use client";
const DatePicker = (0, _generatePickerDefault.default)((0, _dayjsDefault.default));
// We don't care debug panel
/* istanbul ignore next */ const PurePanel = (0, _purePanelDefault.default)(DatePicker, 'popupAlign', undefined, 'picker');
DatePicker._InternalPanelDoNotUseOrYouWillBeFired = PurePanel;
const PureRangePanel = (0, _purePanelDefault.default)(DatePicker.RangePicker, 'popupAlign', undefined, 'picker');
DatePicker._InternalRangePanelDoNotUseOrYouWillBeFired = PureRangePanel;
DatePicker.generatePicker = (0, _generatePickerDefault.default);
exports.default = DatePicker;

},{"@rc-component/picker/generate/dayjs":"5ZPpF","../_util/PurePanel":"31Oxh","./generatePicker":"ioUNU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5ZPpF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
var _weekday = require("dayjs/plugin/weekday");
var _weekdayDefault = parcelHelpers.interopDefault(_weekday);
var _localeData = require("dayjs/plugin/localeData");
var _localeDataDefault = parcelHelpers.interopDefault(_localeData);
var _weekOfYear = require("dayjs/plugin/weekOfYear");
var _weekOfYearDefault = parcelHelpers.interopDefault(_weekOfYear);
var _weekYear = require("dayjs/plugin/weekYear");
var _weekYearDefault = parcelHelpers.interopDefault(_weekYear);
var _advancedFormat = require("dayjs/plugin/advancedFormat");
var _advancedFormatDefault = parcelHelpers.interopDefault(_advancedFormat);
var _customParseFormat = require("dayjs/plugin/customParseFormat");
var _customParseFormatDefault = parcelHelpers.interopDefault(_customParseFormat);
(0, _dayjsDefault.default).extend((0, _customParseFormatDefault.default));
(0, _dayjsDefault.default).extend((0, _advancedFormatDefault.default));
(0, _dayjsDefault.default).extend((0, _weekdayDefault.default));
(0, _dayjsDefault.default).extend((0, _localeDataDefault.default));
(0, _dayjsDefault.default).extend((0, _weekOfYearDefault.default));
(0, _dayjsDefault.default).extend((0, _weekYearDefault.default));
(0, _dayjsDefault.default).extend(function(o, c) {
    // todo support Wo (ISO week)
    var proto = c.prototype;
    var oldFormat = proto.format;
    proto.format = function f(formatStr) {
        var str = (formatStr || '').replace('Wo', 'wo');
        return oldFormat.bind(this)(str);
    };
});
var localeMap = {
    // ar_EG:
    // az_AZ:
    // bg_BG:
    bn_BD: 'bn-bd',
    by_BY: 'be',
    // ca_ES:
    // cs_CZ:
    // da_DK:
    // de_DE:
    // el_GR:
    en_GB: 'en-gb',
    en_US: 'en',
    // es_ES:
    // et_EE:
    // fa_IR:
    // fi_FI:
    fr_BE: 'fr',
    // todo: dayjs has no fr_BE locale, use fr at present
    fr_CA: 'fr-ca',
    // fr_FR:
    // ga_IE:
    // gl_ES:
    // he_IL:
    // hi_IN:
    // hr_HR:
    // hu_HU:
    hy_AM: 'hy-am',
    // id_ID:
    // is_IS:
    // it_IT:
    // ja_JP:
    // ka_GE:
    // kk_KZ:
    // km_KH:
    kmr_IQ: 'ku',
    // kn_IN:
    // ko_KR:
    // ku_IQ: // previous ku in antd
    // lt_LT:
    // lv_LV:
    // mk_MK:
    // ml_IN:
    // mn_MN:
    // ms_MY:
    // nb_NO:
    // ne_NP:
    nl_BE: 'nl-be',
    // nl_NL:
    // pl_PL:
    pt_BR: 'pt-br',
    // pt_PT:
    // ro_RO:
    // ru_RU:
    // sk_SK:
    // sl_SI:
    // sr_RS:
    // sv_SE:
    // ta_IN:
    // th_TH:
    // tr_TR:
    // uk_UA:
    // ur_PK:
    // vi_VN:
    zh_CN: 'zh-cn',
    zh_HK: 'zh-hk',
    zh_TW: 'zh-tw'
};
var parseLocale = function parseLocale(locale) {
    var mapLocale = localeMap[locale];
    return mapLocale || locale.split('_')[0];
};
/* istanbul ignore next */ var parseNoMatchNotice = function parseNoMatchNotice() {
// zombieJ:
// When user typing, its always miss match format.
// This check is meaningless.
// https://github.com/ant-design/ant-design/issues/51839
// noteOnce(false, 'Not match any format. Please help to fire a issue about this.');
};
var generateConfig = {
    // get
    getNow: function getNow() {
        var now = (0, _dayjsDefault.default)();
        // https://github.com/ant-design/ant-design/discussions/50934
        if (typeof now.tz === 'function') return now.tz(); // use default timezone
        return now;
    },
    getFixedDate: function getFixedDate(string) {
        return (0, _dayjsDefault.default)(string, [
            'YYYY-M-DD',
            'YYYY-MM-DD'
        ]);
    },
    getEndDate: function getEndDate(date) {
        return date.endOf('month');
    },
    getWeekDay: function getWeekDay(date) {
        var clone = date.locale('en');
        return clone.weekday() + clone.localeData().firstDayOfWeek();
    },
    getYear: function getYear(date) {
        return date.year();
    },
    getMonth: function getMonth(date) {
        return date.month();
    },
    getDate: function getDate(date) {
        return date.date();
    },
    getHour: function getHour(date) {
        return date.hour();
    },
    getMinute: function getMinute(date) {
        return date.minute();
    },
    getSecond: function getSecond(date) {
        return date.second();
    },
    getMillisecond: function getMillisecond(date) {
        return date.millisecond();
    },
    // set
    addYear: function addYear(date, diff) {
        return date.add(diff, 'year');
    },
    addMonth: function addMonth(date, diff) {
        return date.add(diff, 'month');
    },
    addDate: function addDate(date, diff) {
        return date.add(diff, 'day');
    },
    setYear: function setYear(date, year) {
        return date.year(year);
    },
    setMonth: function setMonth(date, month) {
        return date.month(month);
    },
    setDate: function setDate(date, num) {
        return date.date(num);
    },
    setHour: function setHour(date, hour) {
        return date.hour(hour);
    },
    setMinute: function setMinute(date, minute) {
        return date.minute(minute);
    },
    setSecond: function setSecond(date, second) {
        return date.second(second);
    },
    setMillisecond: function setMillisecond(date, milliseconds) {
        return date.millisecond(milliseconds);
    },
    // Compare
    isAfter: function isAfter(date1, date2) {
        return date1.isAfter(date2);
    },
    isValidate: function isValidate(date) {
        return date.isValid();
    },
    locale: {
        getWeekFirstDay: function getWeekFirstDay(locale) {
            return (0, _dayjsDefault.default)().locale(parseLocale(locale)).localeData().firstDayOfWeek();
        },
        getWeekFirstDate: function getWeekFirstDate(locale, date) {
            return date.locale(parseLocale(locale)).weekday(0);
        },
        getWeek: function getWeek(locale, date) {
            return date.locale(parseLocale(locale)).week();
        },
        getShortWeekDays: function getShortWeekDays(locale) {
            return (0, _dayjsDefault.default)().locale(parseLocale(locale)).localeData().weekdaysMin();
        },
        getShortMonths: function getShortMonths(locale) {
            return (0, _dayjsDefault.default)().locale(parseLocale(locale)).localeData().monthsShort();
        },
        format: function format(locale, date, _format) {
            return date.locale(parseLocale(locale)).format(_format);
        },
        parse: function parse(locale, text, formats) {
            var localeStr = parseLocale(locale);
            for(var i = 0; i < formats.length; i += 1){
                var format = formats[i];
                var formatText = text;
                if (format.includes('wo') || format.includes('Wo')) {
                    // parse Wo
                    var year = formatText.split('-')[0];
                    var weekStr = formatText.split('-')[1];
                    var firstWeek = (0, _dayjsDefault.default)(year, 'YYYY').startOf('year').locale(localeStr);
                    for(var j = 0; j <= 52; j += 1){
                        var nextWeek = firstWeek.add(j, 'week');
                        if (nextWeek.format('Wo') === weekStr) return nextWeek;
                    }
                    parseNoMatchNotice();
                    return null;
                }
                var date = (0, _dayjsDefault.default)(formatText, format, true).locale(localeStr);
                if (date.isValid()) return date;
            }
            if (text) parseNoMatchNotice();
            return null;
        }
    }
};
exports.default = generateConfig;

},{"dayjs":"adpMK","dayjs/plugin/weekday":"2Sbrk","dayjs/plugin/localeData":"2u6K6","dayjs/plugin/weekOfYear":"ilF8W","dayjs/plugin/weekYear":"fYpM4","dayjs/plugin/advancedFormat":"3kdR4","dayjs/plugin/customParseFormat":"5mTjf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Sbrk":[function(require,module,exports,__globalThis) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    return function(e, t) {
        t.prototype.weekday = function(e) {
            var t = this.$locale().weekStart || 0, i = this.$W, n = (i < t ? i + 7 : i) - t;
            return this.$utils().u(e) ? n : this.subtract(n, "day").add(e, "day");
        };
    };
});

},{}],"2u6K6":[function(require,module,exports,__globalThis) {
!function(n, e) {
    module.exports = e();
}(this, function() {
    "use strict";
    return function(n, e, t) {
        var r = e.prototype, o = function(n) {
            return n && (n.indexOf ? n : n.s);
        }, u = function(n, e, t, r, u) {
            var i = n.name ? n : n.$locale(), a = o(i[e]), s = o(i[t]), f = a || s.map(function(n) {
                return n.slice(0, r);
            });
            if (!u) return f;
            var d = i.weekStart;
            return f.map(function(n, e) {
                return f[(e + (d || 0)) % 7];
            });
        }, i = function() {
            return t.Ls[t.locale()];
        }, a = function(n, e) {
            return n.formats[e] || function(n) {
                return n.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(n, e, t) {
                    return e || t.slice(1);
                });
            }(n.formats[e.toUpperCase()]);
        }, s = function() {
            var n = this;
            return {
                months: function(e) {
                    return e ? e.format("MMMM") : u(n, "months");
                },
                monthsShort: function(e) {
                    return e ? e.format("MMM") : u(n, "monthsShort", "months", 3);
                },
                firstDayOfWeek: function() {
                    return n.$locale().weekStart || 0;
                },
                weekdays: function(e) {
                    return e ? e.format("dddd") : u(n, "weekdays");
                },
                weekdaysMin: function(e) {
                    return e ? e.format("dd") : u(n, "weekdaysMin", "weekdays", 2);
                },
                weekdaysShort: function(e) {
                    return e ? e.format("ddd") : u(n, "weekdaysShort", "weekdays", 3);
                },
                longDateFormat: function(e) {
                    return a(n.$locale(), e);
                },
                meridiem: this.$locale().meridiem,
                ordinal: this.$locale().ordinal
            };
        };
        r.localeData = function() {
            return s.bind(this)();
        }, t.localeData = function() {
            var n = i();
            return {
                firstDayOfWeek: function() {
                    return n.weekStart || 0;
                },
                weekdays: function() {
                    return t.weekdays();
                },
                weekdaysShort: function() {
                    return t.weekdaysShort();
                },
                weekdaysMin: function() {
                    return t.weekdaysMin();
                },
                months: function() {
                    return t.months();
                },
                monthsShort: function() {
                    return t.monthsShort();
                },
                longDateFormat: function(e) {
                    return a(n, e);
                },
                meridiem: n.meridiem,
                ordinal: n.ordinal
            };
        }, t.months = function() {
            return u(i(), "months");
        }, t.monthsShort = function() {
            return u(i(), "monthsShort", "months", 3);
        }, t.weekdays = function(n) {
            return u(i(), "weekdays", null, null, n);
        }, t.weekdaysShort = function(n) {
            return u(i(), "weekdaysShort", "weekdays", 3, n);
        }, t.weekdaysMin = function(n) {
            return u(i(), "weekdaysMin", "weekdays", 2, n);
        };
    };
});

},{}],"ilF8W":[function(require,module,exports,__globalThis) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    var e = "week", t = "year";
    return function(i, n, r) {
        var f = n.prototype;
        f.week = function(i) {
            if (void 0 === i && (i = null), null !== i) return this.add(7 * (i - this.week()), "day");
            var n = this.$locale().yearStart || 1;
            if (11 === this.month() && this.date() > 25) {
                var f = r(this).startOf(t).add(1, t).date(n), s = r(this).endOf(e);
                if (f.isBefore(s)) return 1;
            }
            var a = r(this).startOf(t).date(n).startOf(e).subtract(1, "millisecond"), o = this.diff(a, e, !0);
            return o < 0 ? r(this).startOf("week").week() : Math.ceil(o);
        }, f.weeks = function(e) {
            return void 0 === e && (e = null), this.week(e);
        };
    };
});

},{}],"fYpM4":[function(require,module,exports,__globalThis) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    return function(e, t) {
        t.prototype.weekYear = function() {
            var e = this.month(), t = this.week(), n = this.year();
            return 1 === t && 11 === e ? n + 1 : 0 === e && t >= 52 ? n - 1 : n;
        };
    };
});

},{}],"3kdR4":[function(require,module,exports,__globalThis) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    return function(e, t) {
        var r = t.prototype, n = r.format;
        r.format = function(e) {
            var t = this, r = this.$locale();
            if (!this.isValid()) return n.bind(this)(e);
            var s = this.$utils(), a = (e || "YYYY-MM-DDTHH:mm:ssZ").replace(/\[([^\]]+)]|Q|wo|ww|w|WW|W|zzz|z|gggg|GGGG|Do|X|x|k{1,2}|S/g, function(e) {
                switch(e){
                    case "Q":
                        return Math.ceil((t.$M + 1) / 3);
                    case "Do":
                        return r.ordinal(t.$D);
                    case "gggg":
                        return t.weekYear();
                    case "GGGG":
                        return t.isoWeekYear();
                    case "wo":
                        return r.ordinal(t.week(), "W");
                    case "w":
                    case "ww":
                        return s.s(t.week(), "w" === e ? 1 : 2, "0");
                    case "W":
                    case "WW":
                        return s.s(t.isoWeek(), "W" === e ? 1 : 2, "0");
                    case "k":
                    case "kk":
                        return s.s(String(0 === t.$H ? 24 : t.$H), "k" === e ? 1 : 2, "0");
                    case "X":
                        return Math.floor(t.$d.getTime() / 1e3);
                    case "x":
                        return t.$d.getTime();
                    case "z":
                        return "[" + t.offsetName() + "]";
                    case "zzz":
                        return "[" + t.offsetName("long") + "]";
                    default:
                        return e;
                }
            });
            return n.bind(this)(a);
        };
    };
});

},{}],"5mTjf":[function(require,module,exports,__globalThis) {
!function(e, t) {
    module.exports = t();
}(this, function() {
    "use strict";
    var e = {
        LTS: "h:mm:ss A",
        LT: "h:mm A",
        L: "MM/DD/YYYY",
        LL: "MMMM D, YYYY",
        LLL: "MMMM D, YYYY h:mm A",
        LLLL: "dddd, MMMM D, YYYY h:mm A"
    }, t = /(\[[^[]*\])|([-_:/.,()\s]+)|(A|a|Q|YYYY|YY?|ww?|MM?M?M?|Do|DD?|hh?|HH?|mm?|ss?|S{1,3}|z|ZZ?)/g, n = /\d/, r = /\d\d/, i = /\d\d?/, o = /\d*[^-_:/,()\s\d]+/, s = {}, a = function(e) {
        return (e = +e) + (e > 68 ? 1900 : 2e3);
    };
    var f = function(e) {
        return function(t) {
            this[e] = +t;
        };
    }, h = [
        /[+-]\d\d:?(\d\d)?|Z/,
        function(e) {
            (this.zone || (this.zone = {})).offset = function(e) {
                if (!e) return 0;
                if ("Z" === e) return 0;
                var t = e.match(/([+-]|\d\d)/g), n = 60 * t[1] + (+t[2] || 0);
                return 0 === n ? 0 : "+" === t[0] ? -n : n;
            }(e);
        }
    ], u = function(e) {
        var t = s[e];
        return t && (t.indexOf ? t : t.s.concat(t.f));
    }, d = function(e, t) {
        var n, r = s.meridiem;
        if (r) {
            for(var i = 1; i <= 24; i += 1)if (e.indexOf(r(i, 0, t)) > -1) {
                n = i > 12;
                break;
            }
        } else n = e === (t ? "pm" : "PM");
        return n;
    }, c = {
        A: [
            o,
            function(e) {
                this.afternoon = d(e, !1);
            }
        ],
        a: [
            o,
            function(e) {
                this.afternoon = d(e, !0);
            }
        ],
        Q: [
            n,
            function(e) {
                this.month = 3 * (e - 1) + 1;
            }
        ],
        S: [
            n,
            function(e) {
                this.milliseconds = 100 * +e;
            }
        ],
        SS: [
            r,
            function(e) {
                this.milliseconds = 10 * +e;
            }
        ],
        SSS: [
            /\d{3}/,
            function(e) {
                this.milliseconds = +e;
            }
        ],
        s: [
            i,
            f("seconds")
        ],
        ss: [
            i,
            f("seconds")
        ],
        m: [
            i,
            f("minutes")
        ],
        mm: [
            i,
            f("minutes")
        ],
        H: [
            i,
            f("hours")
        ],
        h: [
            i,
            f("hours")
        ],
        HH: [
            i,
            f("hours")
        ],
        hh: [
            i,
            f("hours")
        ],
        D: [
            i,
            f("day")
        ],
        DD: [
            r,
            f("day")
        ],
        Do: [
            o,
            function(e) {
                var t = s.ordinal, n = e.match(/\d+/);
                if (this.day = n[0], t) for(var r = 1; r <= 31; r += 1)t(r).replace(/\[|\]/g, "") === e && (this.day = r);
            }
        ],
        w: [
            i,
            f("week")
        ],
        ww: [
            r,
            f("week")
        ],
        M: [
            i,
            f("month")
        ],
        MM: [
            r,
            f("month")
        ],
        MMM: [
            o,
            function(e) {
                var t = u("months"), n = (u("monthsShort") || t.map(function(e) {
                    return e.slice(0, 3);
                })).indexOf(e) + 1;
                if (n < 1) throw new Error;
                this.month = n % 12 || n;
            }
        ],
        MMMM: [
            o,
            function(e) {
                var t = u("months").indexOf(e) + 1;
                if (t < 1) throw new Error;
                this.month = t % 12 || t;
            }
        ],
        Y: [
            /[+-]?\d+/,
            f("year")
        ],
        YY: [
            r,
            function(e) {
                this.year = a(e);
            }
        ],
        YYYY: [
            /\d{4}/,
            f("year")
        ],
        Z: h,
        ZZ: h
    };
    function l(n) {
        var r, i;
        r = n, i = s && s.formats;
        for(var o = (n = r.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(t, n, r) {
            var o = r && r.toUpperCase();
            return n || i[r] || e[r] || i[o].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(e, t, n) {
                return t || n.slice(1);
            });
        })).match(t), a = o.length, f = 0; f < a; f += 1){
            var h = o[f], u = c[h], d = u && u[0], l = u && u[1];
            o[f] = l ? {
                regex: d,
                parser: l
            } : h.replace(/^\[|\]$/g, "");
        }
        return function(e) {
            for(var t = {}, n = 0, r = 0; n < a; n += 1){
                var i = o[n];
                if ("string" == typeof i) r += i.length;
                else {
                    var s = i.regex, f = i.parser, h = e.slice(r), u = s.exec(h)[0];
                    f.call(t, u), e = e.replace(u, "");
                }
            }
            return function(e) {
                var t = e.afternoon;
                if (void 0 !== t) {
                    var n = e.hours;
                    t ? n < 12 && (e.hours += 12) : 12 === n && (e.hours = 0), delete e.afternoon;
                }
            }(t), t;
        };
    }
    return function(e, t, n) {
        n.p.customParseFormat = !0, e && e.parseTwoDigitYear && (a = e.parseTwoDigitYear);
        var r = t.prototype, i = r.parse;
        r.parse = function(e) {
            var t = e.date, r = e.utc, o = e.args;
            this.$u = r;
            var a = o[1];
            if ("string" == typeof a) {
                var f = !0 === o[2], h = !0 === o[3], u = f || h, d = o[2];
                h && (d = o[2]), s = this.$locale(), !f && d && (s = n.Ls[d]), this.$d = function(e, t, n, r) {
                    try {
                        if ([
                            "x",
                            "X"
                        ].indexOf(t) > -1) return new Date(("X" === t ? 1e3 : 1) * e);
                        var i = l(t)(e), o = i.year, s = i.month, a = i.day, f = i.hours, h = i.minutes, u = i.seconds, d = i.milliseconds, c = i.zone, m = i.week, M = new Date, Y = a || (o || s ? 1 : M.getDate()), p = o || M.getFullYear(), v = 0;
                        o && !s || (v = s > 0 ? s - 1 : M.getMonth());
                        var D, w = f || 0, g = h || 0, y = u || 0, L = d || 0;
                        return c ? new Date(Date.UTC(p, v, Y, w, g, y, L + 60 * c.offset * 1e3)) : n ? new Date(Date.UTC(p, v, Y, w, g, y, L)) : (D = new Date(p, v, Y, w, g, y, L), m && (D = r(D).week(m).toDate()), D);
                    } catch (e) {
                        return new Date("");
                    }
                }(t, a, r, n), this.init(), d && !0 !== d && (this.$L = this.locale(d).$L), u && t != this.format(a) && (this.$d = new Date("")), s = {};
            } else if (a instanceof Array) for(var c = a.length, m = 1; m <= c; m += 1){
                o[1] = a[m - 1];
                var M = n.apply(this, o);
                if (M.isValid()) {
                    this.$d = M.$d, this.$L = M.$L, this.init();
                    break;
                }
                m === c && (this.$d = new Date(""));
            }
            else i.call(this, e);
        };
    };
});

},{}],"ioUNU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _generateRangePicker = require("./generateRangePicker");
var _generateRangePickerDefault = parcelHelpers.interopDefault(_generateRangePicker);
var _generateSinglePicker = require("./generateSinglePicker");
var _generateSinglePickerDefault = parcelHelpers.interopDefault(_generateSinglePicker);
"use client";
const generatePicker = (generateConfig)=>{
    // =========================== Picker ===========================
    const { DatePicker, WeekPicker, MonthPicker, YearPicker, TimePicker, QuarterPicker } = (0, _generateSinglePickerDefault.default)(generateConfig);
    // ======================== Range Picker ========================
    const RangePicker = (0, _generateRangePickerDefault.default)(generateConfig);
    const MergedDatePicker = DatePicker;
    MergedDatePicker.WeekPicker = WeekPicker;
    MergedDatePicker.MonthPicker = MonthPicker;
    MergedDatePicker.YearPicker = YearPicker;
    MergedDatePicker.RangePicker = RangePicker;
    MergedDatePicker.TimePicker = TimePicker;
    MergedDatePicker.QuarterPicker = QuarterPicker;
    return MergedDatePicker;
};
exports.default = generatePicker;

},{"./generateRangePicker":"faSt8","./generateSinglePicker":"ekvit","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"faSt8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _swapRightOutlined = require("@ant-design/icons/es/icons/SwapRightOutlined");
var _swapRightOutlinedDefault = parcelHelpers.interopDefault(_swapRightOutlined);
var _picker = require("@rc-component/picker");
var _clsx = require("clsx");
var _contextIsolator = require("../../_util/ContextIsolator");
var _contextIsolatorDefault = parcelHelpers.interopDefault(_contextIsolator);
var _hooks = require("../../_util/hooks");
var _statusUtils = require("../../_util/statusUtils");
var _warning = require("../../_util/warning");
var _configProvider = require("../../config-provider");
var _disabledContext = require("../../config-provider/DisabledContext");
var _disabledContextDefault = parcelHelpers.interopDefault(_disabledContext);
var _useCSSVarCls = require("../../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _useSize = require("../../config-provider/hooks/useSize");
var _useSizeDefault = parcelHelpers.interopDefault(_useSize);
var _context = require("../../form/context");
var _useVariants = require("../../form/hooks/useVariants");
var _useVariantsDefault = parcelHelpers.interopDefault(_useVariants);
var _locale = require("../../locale");
var _compact = require("../../space/Compact");
var _useMergedPickerSemantic = require("../hooks/useMergedPickerSemantic");
var _useMergedPickerSemanticDefault = parcelHelpers.interopDefault(_useMergedPickerSemantic);
var _enUS = require("../locale/en_US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
var _style = require("../style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _util = require("../util");
var _constant = require("./constant");
var _suffixIcon = require("./SuffixIcon");
var _suffixIconDefault = parcelHelpers.interopDefault(_suffixIcon);
var _useComponents = require("./useComponents");
var _useComponentsDefault = parcelHelpers.interopDefault(_useComponents);
"use client";
const generateRangePicker = (generateConfig)=>{
    const RangePicker = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
        const { prefixCls: customizePrefixCls, getPopupContainer: customGetPopupContainer, components, className, style, classNames, styles, placement, size: customizeSize, disabled: customDisabled, bordered = true, placeholder, status: customStatus, variant: customVariant, picker, dropdownClassName, popupClassName, popupStyle, rootClassName, suffixIcon, ...restProps } = props;
        const pickerType = picker === (0, _constant.TIME) ? 'timePicker' : 'datePicker';
        var oldProp, newProp;
        const [mergedClassNames, mergedStyles] = (0, _useMergedPickerSemanticDefault.default)(pickerType, classNames, styles, popupClassName || dropdownClassName, popupStyle);
        const innerRef = _react.useRef(null);
        const { getPrefixCls, direction, getPopupContainer, rangePicker } = (0, _react.useContext)((0, _configProvider.ConfigContext));
        const prefixCls = getPrefixCls('picker', customizePrefixCls);
        const { compactSize, compactItemClassnames } = (0, _compact.useCompactItemContext)(prefixCls, direction);
        const rootPrefixCls = getPrefixCls();
        const [variant, enableVariantCls] = (0, _useVariantsDefault.default)('rangePicker', customVariant, bordered);
        const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
        const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
        const mergedRootClassName = (0, _clsx.clsx)(hashId, cssVarCls, rootCls, rootClassName);
        // ===================== Icon =====================
        const [mergedAllowClear] = (0, _util.useIcons)(props, prefixCls);
        // ================== components ==================
        const mergedComponents = (0, _useComponentsDefault.default)(components);
        // ===================== Size =====================
        const mergedSize = (0, _useSizeDefault.default)((ctx)=>customizeSize ?? compactSize ?? ctx);
        // ===================== Disabled =====================
        const disabled = _react.useContext((0, _disabledContextDefault.default));
        const mergedDisabled = customDisabled ?? disabled;
        // ===================== FormItemInput =====================
        const formItemContext = (0, _react.useContext)((0, _context.FormItemInputContext));
        const { hasFeedback, status: contextStatus, feedbackIcon } = formItemContext;
        const mergedSuffixIcon = /*#__PURE__*/ _react.createElement((0, _suffixIconDefault.default), {
            picker,
            hasFeedback,
            feedbackIcon,
            suffixIcon
        });
        (0, _react.useImperativeHandle)(ref, ()=>innerRef.current);
        const [contextLocale] = (0, _locale.useLocale)('Calendar', (0, _enUSDefault.default));
        const locale = {
            ...contextLocale,
            ...props.locale
        };
        // ============================ zIndex ============================
        const [zIndex] = (0, _hooks.useZIndex)('DatePicker', mergedStyles?.popup?.root?.zIndex);
        return /*#__PURE__*/ _react.createElement((0, _contextIsolatorDefault.default), {
            space: true
        }, /*#__PURE__*/ _react.createElement((0, _picker.RangePicker), {
            separator: /*#__PURE__*/ _react.createElement("span", {
                "aria-label": "to",
                className: `${prefixCls}-separator`
            }, /*#__PURE__*/ _react.createElement((0, _swapRightOutlinedDefault.default), null)),
            disabled: mergedDisabled,
            ref: innerRef,
            placement: placement,
            placeholder: (0, _util.getRangePlaceholder)(locale, picker, placeholder),
            suffixIcon: mergedSuffixIcon,
            prevIcon: /*#__PURE__*/ _react.createElement("span", {
                className: `${prefixCls}-prev-icon`
            }),
            nextIcon: /*#__PURE__*/ _react.createElement("span", {
                className: `${prefixCls}-next-icon`
            }),
            superPrevIcon: /*#__PURE__*/ _react.createElement("span", {
                className: `${prefixCls}-super-prev-icon`
            }),
            superNextIcon: /*#__PURE__*/ _react.createElement("span", {
                className: `${prefixCls}-super-next-icon`
            }),
            transitionName: `${rootPrefixCls}-slide-up`,
            picker: picker,
            ...restProps,
            locale: locale.lang,
            getPopupContainer: customGetPopupContainer || getPopupContainer,
            generateConfig: generateConfig,
            components: mergedComponents,
            direction: direction,
            // Style
            prefixCls: prefixCls,
            rootClassName: mergedRootClassName,
            className: (0, _clsx.clsx)({
                [`${prefixCls}-${mergedSize}`]: mergedSize,
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, _statusUtils.getStatusClassNames)(prefixCls, (0, _statusUtils.getMergedStatus)(contextStatus, customStatus), hasFeedback), compactItemClassnames, className, rangePicker?.className),
            style: {
                ...rangePicker?.style,
                ...style
            },
            // Semantic Style
            classNames: mergedClassNames,
            styles: {
                ...mergedStyles,
                popup: {
                    ...mergedStyles.popup,
                    root: {
                        ...mergedStyles.popup.root,
                        zIndex
                    }
                }
            },
            allowClear: mergedAllowClear
        }));
    });
    return RangePicker;
};
exports.default = generateRangePicker;

},{"react":"bmhQu","@ant-design/icons/es/icons/SwapRightOutlined":"iCmgZ","@rc-component/picker":"k7KfK","clsx":"431Ou","../../_util/ContextIsolator":"5aVQ9","../../_util/hooks":"6noQ6","../../_util/statusUtils":"gbJk4","../../_util/warning":"95o3w","../../config-provider":"dVeAX","../../config-provider/DisabledContext":"h4TcW","../../config-provider/hooks/useCSSVarCls":"gcu2s","../../config-provider/hooks/useSize":"gXe6G","../../form/context":"krZYn","../../form/hooks/useVariants":"larUs","../../locale":[["useLocale","l6QvX","default"]],"../../space/Compact":"cOSpV","../hooks/useMergedPickerSemantic":"bGTPJ","../locale/en_US":"bGutz","../style":"faEoi","../util":"aFH16","./constant":"3Y6Wn","./SuffixIcon":"cX8QY","./useComponents":"04mg8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iCmgZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _swapRightOutlined = require("@ant-design/icons-svg/es/asn/SwapRightOutlined");
var _swapRightOutlinedDefault = parcelHelpers.interopDefault(_swapRightOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const SwapRightOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _swapRightOutlinedDefault.default)
    }));
/**![swap-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg3My4xIDU5Ni4ybC0xNjQtMjA4QTMyIDMyIDAgMDA2ODQgMzc2aC02NC44Yy02LjcgMC0xMC40IDcuNy02LjMgMTNsMTQ0LjMgMTgzSDE1MmMtNC40IDAtOCAzLjYtOCA4djYwYzAgNC40IDMuNiA4IDggOGg2OTUuOWMyNi44IDAgNDEuNy0zMC44IDI1LjItNTEuOHoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(SwapRightOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/SwapRightOutlined":"a4dWD","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a4dWD":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var SwapRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M873.1 596.2l-164-208A32 32 0 00684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z"
                }
            }
        ]
    },
    "name": "swap-right",
    "theme": "outlined"
};
exports.default = SwapRightOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k7KfK":[function(require,module,exports,__globalThis) {
/**
 * What's new?
 * - Common
 *  - [Break] Support special year format, all the year will follow the locale config.
 *  - Blur all of field will trigger `onChange` if validate
 *  - Support `preserveInvalidOnBlur` to not to clean input if invalid and remove `changeOnBlur`
 *  - `pickerValue` is now full controlled
 *    - `defaultPickerValue` will take effect on every field active with popup opening.
 *  - [Break] clear button return the event with `onClick`
 *
 * - Locale
 *  - Remove `dateFormat` since it's never used
 *  - Remove `dateTimeFormat` since it's never used
 *
 * - Picker
 *  - TimePicker support `changeOnScroll`
 *  - TimePicker support `millisecond`
 *  - Support cellMeridiemFormat for AM/PM
 *  - Get correct `disabledHours` when set `use12Hours`
 *  - Support `showWeek`
 *
 * - RangePicker
 *  - [Break] RangePicker is now not limit the range of clicked field.
 *  - Trigger `onCalendarChange` when type correct
 *  - [Break] Not order `value` if given `value` is wrong order.
 *  - Hover `presets` will show date in input field.
 *  - [Break] RangePicker go to end field, `pickerValue` will follow the start field if not controlled.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Picker", ()=>(0, _singlePickerDefault.default));
parcelHelpers.export(exports, "RangePicker", ()=>(0, _rangePickerDefault.default));
parcelHelpers.export(exports, "PickerPanel", ()=>(0, _pickerPanelDefault.default));
var _rangePicker = require("./PickerInput/RangePicker");
var _rangePickerDefault = parcelHelpers.interopDefault(_rangePicker);
var _singlePicker = require("./PickerInput/SinglePicker");
var _singlePickerDefault = parcelHelpers.interopDefault(_singlePicker);
var _pickerPanel = require("./PickerPanel");
var _pickerPanelDefault = parcelHelpers.interopDefault(_pickerPanel);
exports.default = (0, _singlePickerDefault.default);

},{"./PickerInput/RangePicker":"dYjhy","./PickerInput/SinglePicker":"kjTx4","./PickerPanel":"3ZGhg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dYjhy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _omit = require("@rc-component/util/es/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _react = require("react");
var _pickerTrigger = require("../PickerTrigger");
var _pickerTriggerDefault = parcelHelpers.interopDefault(_pickerTrigger);
var _util1 = require("../PickerTrigger/util");
var _miscUtil = require("../utils/miscUtil");
var _context = require("./context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _useCellRender = require("./hooks/useCellRender");
var _useCellRenderDefault = parcelHelpers.interopDefault(_useCellRender);
var _useFieldsInvalidate = require("./hooks/useFieldsInvalidate");
var _useFieldsInvalidateDefault = parcelHelpers.interopDefault(_useFieldsInvalidate);
var _useFilledProps = require("./hooks/useFilledProps");
var _useFilledPropsDefault = parcelHelpers.interopDefault(_useFilledProps);
var _useOpen = require("./hooks/useOpen");
var _useOpenDefault = parcelHelpers.interopDefault(_useOpen);
var _usePickerRef = require("./hooks/usePickerRef");
var _usePickerRefDefault = parcelHelpers.interopDefault(_usePickerRef);
var _usePresets = require("./hooks/usePresets");
var _usePresetsDefault = parcelHelpers.interopDefault(_usePresets);
var _useRangeActive = require("./hooks/useRangeActive");
var _useRangeActiveDefault = parcelHelpers.interopDefault(_useRangeActive);
var _useRangeDisabledDate = require("./hooks/useRangeDisabledDate");
var _useRangeDisabledDateDefault = parcelHelpers.interopDefault(_useRangeDisabledDate);
var _useRangePickerValue = require("./hooks/useRangePickerValue");
var _useRangePickerValueDefault = parcelHelpers.interopDefault(_useRangePickerValue);
var _useRangeValue = require("./hooks/useRangeValue");
var _useRangeValueDefault = parcelHelpers.interopDefault(_useRangeValue);
var _useShowNow = require("./hooks/useShowNow");
var _useShowNowDefault = parcelHelpers.interopDefault(_useShowNow);
var _popup = require("./Popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
var _rangeSelector = require("./Selector/RangeSelector");
var _rangeSelectorDefault = parcelHelpers.interopDefault(_rangeSelector);
var _useSemantic = require("../hooks/useSemantic");
var _useSemanticDefault = parcelHelpers.interopDefault(_useSemantic);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function separateConfig(config, defaultConfig) {
    var singleConfig = config !== null && config !== void 0 ? config : defaultConfig;
    if (Array.isArray(singleConfig)) return singleConfig;
    return [
        singleConfig,
        singleConfig
    ];
}
/** Used for change event, it should always be not undefined */ function getActiveRange(activeIndex) {
    return activeIndex === 1 ? 'end' : 'start';
}
function RangePicker(props, ref) {
    // ========================= Prop =========================
    var _useFilledProps = (0, _useFilledPropsDefault.default)(props, function() {
        var disabled = props.disabled, allowEmpty = props.allowEmpty;
        var mergedDisabled = separateConfig(disabled, false);
        var mergedAllowEmpty = separateConfig(allowEmpty, false);
        return {
            disabled: mergedDisabled,
            allowEmpty: mergedAllowEmpty
        };
    }), _useFilledProps2 = _slicedToArray(_useFilledProps, 6), filledProps = _useFilledProps2[0], internalPicker = _useFilledProps2[1], complexPicker = _useFilledProps2[2], formatList = _useFilledProps2[3], maskFormat = _useFilledProps2[4], isInvalidateDate = _useFilledProps2[5];
    var prefixCls = filledProps.prefixCls, rootClassName = filledProps.rootClassName, propStyles = filledProps.styles, propClassNames = filledProps.classNames, previewValue = filledProps.previewValue, defaultValue = filledProps.defaultValue, value = filledProps.value, needConfirm = filledProps.needConfirm, onKeyDown = filledProps.onKeyDown, disabled = filledProps.disabled, allowEmpty = filledProps.allowEmpty, disabledDate = filledProps.disabledDate, minDate = filledProps.minDate, maxDate = filledProps.maxDate, defaultOpen = filledProps.defaultOpen, open = filledProps.open, onOpenChange = filledProps.onOpenChange, locale = filledProps.locale, generateConfig = filledProps.generateConfig, picker = filledProps.picker, showNow = filledProps.showNow, showToday = filledProps.showToday, showTime = filledProps.showTime, mode = filledProps.mode, onPanelChange = filledProps.onPanelChange, onCalendarChange = filledProps.onCalendarChange, onOk = filledProps.onOk, defaultPickerValue = filledProps.defaultPickerValue, pickerValue = filledProps.pickerValue, onPickerValueChange = filledProps.onPickerValueChange, inputReadOnly = filledProps.inputReadOnly, suffixIcon = filledProps.suffixIcon, onFocus = filledProps.onFocus, onBlur = filledProps.onBlur, presets = filledProps.presets, ranges = filledProps.ranges, components = filledProps.components, cellRender = filledProps.cellRender, dateRender = filledProps.dateRender, monthCellRender = filledProps.monthCellRender, onClick = filledProps.onClick;
    // ========================= Refs =========================
    var selectorRef = (0, _usePickerRefDefault.default)(ref);
    // ======================= Semantic =======================
    var _useSemantic = (0, _useSemanticDefault.default)(propClassNames, propStyles), _useSemantic2 = _slicedToArray(_useSemantic, 2), mergedClassNames = _useSemantic2[0], mergedStyles = _useSemantic2[1];
    // ========================= Open =========================
    var _useOpen = (0, _useOpenDefault.default)(open, defaultOpen, disabled, onOpenChange), _useOpen2 = _slicedToArray(_useOpen, 2), mergedOpen = _useOpen2[0], setMergeOpen = _useOpen2[1];
    var triggerOpen = function triggerOpen(nextOpen, config) {
        // No need to open if all disabled
        if (disabled.some(function(fieldDisabled) {
            return !fieldDisabled;
        }) || !nextOpen) setMergeOpen(nextOpen, config);
    };
    // ======================== Values ========================
    var _useInnerValue = (0, _useRangeValue.useInnerValue)(generateConfig, locale, formatList, true, false, defaultValue, value, onCalendarChange, onOk), _useInnerValue2 = _slicedToArray(_useInnerValue, 5), mergedValue = _useInnerValue2[0], setInnerValue = _useInnerValue2[1], getCalendarValue = _useInnerValue2[2], triggerCalendarChange = _useInnerValue2[3], triggerOk = _useInnerValue2[4];
    var calendarValue = getCalendarValue();
    // ======================== Active ========================
    var _useRangeActive = (0, _useRangeActiveDefault.default)(disabled, allowEmpty, mergedOpen), _useRangeActive2 = _slicedToArray(_useRangeActive, 9), focused = _useRangeActive2[0], triggerFocus = _useRangeActive2[1], lastOperation = _useRangeActive2[2], activeIndex = _useRangeActive2[3], setActiveIndex = _useRangeActive2[4], nextActiveIndex = _useRangeActive2[5], activeIndexList = _useRangeActive2[6], updateSubmitIndex = _useRangeActive2[7], hasActiveSubmitValue = _useRangeActive2[8];
    var onSharedFocus = function onSharedFocus(event, index) {
        triggerFocus(true);
        onFocus === null || onFocus === void 0 || onFocus(event, {
            range: getActiveRange(index !== null && index !== void 0 ? index : activeIndex)
        });
    };
    var onSharedBlur = function onSharedBlur(event, index) {
        triggerFocus(false);
        onBlur === null || onBlur === void 0 || onBlur(event, {
            range: getActiveRange(index !== null && index !== void 0 ? index : activeIndex)
        });
    };
    // ======================= ShowTime =======================
    /** Used for Popup panel */ var mergedShowTime = _react.useMemo(function() {
        if (!showTime) return null;
        var disabledTime = showTime.disabledTime;
        var proxyDisabledTime = disabledTime ? function(date) {
            var range = getActiveRange(activeIndex);
            var fromDate = (0, _miscUtil.getFromDate)(calendarValue, activeIndexList, activeIndex);
            return disabledTime(date, range, {
                from: fromDate
            });
        } : undefined;
        return _objectSpread(_objectSpread({}, showTime), {}, {
            disabledTime: proxyDisabledTime
        });
    }, [
        showTime,
        activeIndex,
        calendarValue,
        activeIndexList
    ]);
    // ========================= Mode =========================
    var _useControlledState = (0, _util.useControlledState)([
        picker,
        picker
    ], mode), _useControlledState2 = _slicedToArray(_useControlledState, 2), modes = _useControlledState2[0], setModes = _useControlledState2[1];
    var mergedMode = modes[activeIndex] || picker;
    /** Extends from `mergedMode` to patch `datetime` mode */ var internalMode = mergedMode === 'date' && mergedShowTime ? 'datetime' : mergedMode;
    // ====================== PanelCount ======================
    var multiplePanel = internalMode === picker && internalMode !== 'time';
    // ======================= Show Now =======================
    var mergedShowNow = (0, _useShowNowDefault.default)(picker, mergedMode, showNow, showToday, true);
    // ======================== Value =========================
    var _useRangeValue1 = (0, _useRangeValueDefault.default)(filledProps, mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, disabled, formatList, focused, mergedOpen, isInvalidateDate), _useRangeValue2 = _slicedToArray(_useRangeValue1, 2), /** Trigger `onChange` by check `disabledDate` */ flushSubmit = _useRangeValue2[0], /** Trigger `onChange` directly without check `disabledDate` */ triggerSubmitChange = _useRangeValue2[1];
    // ===================== DisabledDate =====================
    var mergedDisabledDate = (0, _useRangeDisabledDateDefault.default)(calendarValue, disabled, activeIndexList, generateConfig, locale, disabledDate);
    // ======================= Validate =======================
    var _useFieldsInvalidate = (0, _useFieldsInvalidateDefault.default)(calendarValue, isInvalidateDate, allowEmpty), _useFieldsInvalidate2 = _slicedToArray(_useFieldsInvalidate, 2), submitInvalidates = _useFieldsInvalidate2[0], onSelectorInvalid = _useFieldsInvalidate2[1];
    // ===================== Picker Value =====================
    var _useRangePickerValue = (0, _useRangePickerValueDefault.default)(generateConfig, locale, calendarValue, modes, mergedOpen, activeIndex, internalPicker, multiplePanel, defaultPickerValue, pickerValue, mergedShowTime === null || mergedShowTime === void 0 ? void 0 : mergedShowTime.defaultOpenValue, onPickerValueChange, minDate, maxDate), _useRangePickerValue2 = _slicedToArray(_useRangePickerValue, 2), currentPickerValue = _useRangePickerValue2[0], setCurrentPickerValue = _useRangePickerValue2[1];
    // >>> Mode need wait for `pickerValue`
    var triggerModeChange = (0, _util.useEvent)(function(nextPickerValue, nextMode, triggerEvent) {
        var clone = (0, _miscUtil.fillIndex)(modes, activeIndex, nextMode);
        if (clone[0] !== modes[0] || clone[1] !== modes[1]) setModes(clone);
        // Compatible with `onPanelChange`
        if (onPanelChange && triggerEvent !== false) {
            var clonePickerValue = _toConsumableArray(calendarValue);
            if (nextPickerValue) clonePickerValue[activeIndex] = nextPickerValue;
            onPanelChange(clonePickerValue, clone);
        }
    });
    // ======================== Change ========================
    var fillCalendarValue = function fillCalendarValue(date, index) {
        return(// Trigger change only when date changed
        (0, _miscUtil.fillIndex)(calendarValue, index, date));
    };
    // ======================== Submit ========================
    /**
   * Trigger by confirm operation.
   * This function has already handle the `needConfirm` check logic.
   * - Selector: enter key
   * - Panel: OK button
   */ var triggerPartConfirm = function triggerPartConfirm(date, skipFocus) {
        var nextValue = calendarValue;
        if (date) nextValue = fillCalendarValue(date, activeIndex);
        updateSubmitIndex(activeIndex);
        // Get next focus index
        var nextIndex = nextActiveIndex(nextValue);
        // Change calendar value and tell flush it
        triggerCalendarChange(nextValue);
        flushSubmit(activeIndex, nextIndex === null);
        if (nextIndex === null) triggerOpen(false, {
            force: true
        });
        else if (!skipFocus) selectorRef.current.focus({
            index: nextIndex
        });
    };
    // ======================== Click =========================
    var onSelectorClick = function onSelectorClick(event) {
        var _activeElement;
        var rootNode = event.target.getRootNode();
        if (!selectorRef.current.nativeElement.contains((_activeElement = rootNode.activeElement) !== null && _activeElement !== void 0 ? _activeElement : document.activeElement)) {
            // Click to focus the enabled input
            var enabledIndex = disabled.findIndex(function(d) {
                return !d;
            });
            if (enabledIndex >= 0) selectorRef.current.focus({
                index: enabledIndex
            });
        }
        triggerOpen(true);
        onClick === null || onClick === void 0 || onClick(event);
    };
    var onSelectorClear = function onSelectorClear() {
        triggerSubmitChange(null);
        triggerOpen(false, {
            force: true
        });
    };
    // ======================== Hover =========================
    var _React$useState = _react.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), hoverSource = _React$useState2[0], setHoverSource = _React$useState2[1];
    var _React$useState3 = _react.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), internalHoverValues = _React$useState4[0], setInternalHoverValues = _React$useState4[1];
    var hoverValues = _react.useMemo(function() {
        return internalHoverValues || calendarValue;
    }, [
        calendarValue,
        internalHoverValues
    ]);
    // Clean up `internalHoverValues` when closed
    _react.useEffect(function() {
        if (!mergedOpen) setInternalHoverValues(null);
    }, [
        mergedOpen
    ]);
    // ========================================================
    // ==                       Panels                       ==
    // ========================================================
    // Save the offset with active bar position
    // const [activeOffset, setActiveOffset] = React.useState(0);
    var _React$useState5 = _react.useState([
        0,
        0,
        0
    ]), _React$useState6 = _slicedToArray(_React$useState5, 2), activeInfo = _React$useState6[0], setActiveInfo = _React$useState6[1];
    var onSetHover = function onSetHover(date, source) {
        if (previewValue !== 'hover') return;
        setInternalHoverValues(date);
        setHoverSource(source);
    };
    // ======================= Presets ========================
    var presetList = (0, _usePresetsDefault.default)(presets, ranges);
    var onPresetHover = function onPresetHover(nextValues) {
        onSetHover(nextValues, 'preset');
    };
    var onPresetSubmit = function onPresetSubmit(nextValues) {
        var passed = triggerSubmitChange(nextValues);
        if (passed) triggerOpen(false, {
            force: true
        });
    };
    var onNow = function onNow(now) {
        triggerPartConfirm(now);
    };
    // ======================== Panel =========================
    var onPanelHover = function onPanelHover(date) {
        onSetHover(date ? fillCalendarValue(date, activeIndex) : null, 'cell');
    };
    // >>> Focus
    var onPanelFocus = function onPanelFocus(event) {
        triggerOpen(true);
        onSharedFocus(event);
    };
    // >>> MouseDown
    var onPanelMouseDown = function onPanelMouseDown() {
        lastOperation('panel');
    };
    // >>> Calendar
    var onPanelSelect = function onPanelSelect(date) {
        var clone = (0, _miscUtil.fillIndex)(calendarValue, activeIndex, date);
        // Only trigger calendar event but not update internal `calendarValue` state
        triggerCalendarChange(clone);
        // >>> Trigger next active if !needConfirm
        // Fully logic check `useRangeValue` hook
        if (!needConfirm && !complexPicker && internalPicker === internalMode) triggerPartConfirm(date);
    };
    // >>> Close
    var onPopupClose = function onPopupClose() {
        // Close popup
        triggerOpen(false);
    };
    // >>> cellRender
    var onInternalCellRender = (0, _useCellRenderDefault.default)(cellRender, dateRender, monthCellRender, getActiveRange(activeIndex));
    // >>> Value
    var panelValue = calendarValue[activeIndex] || null;
    // >>> invalid
    var isPopupInvalidateDate = (0, _util.useEvent)(function(date) {
        return isInvalidateDate(date, {
            activeIndex: activeIndex
        });
    });
    var panelProps = _react.useMemo(function() {
        var domProps = (0, _pickAttrsDefault.default)(filledProps, false);
        var restProps = (0, _omitDefault.default)(filledProps, [].concat(_toConsumableArray(Object.keys(domProps)), [
            'onChange',
            'onCalendarChange',
            'style',
            'className',
            'onPanelChange',
            'disabledTime',
            'classNames',
            'styles'
        ]));
        return restProps;
    }, [
        filledProps
    ]);
    // >>> Render
    var panel = /*#__PURE__*/ _react.createElement((0, _popupDefault.default), _extends({}, panelProps, {
        showNow: mergedShowNow,
        showTime: mergedShowTime,
        range: true,
        multiplePanel: multiplePanel,
        activeInfo: activeInfo,
        disabledDate: mergedDisabledDate,
        onFocus: onPanelFocus,
        onBlur: onSharedBlur,
        onPanelMouseDown: onPanelMouseDown,
        picker: picker,
        mode: mergedMode,
        internalMode: internalMode,
        onPanelChange: triggerModeChange,
        format: maskFormat,
        value: panelValue,
        isInvalid: isPopupInvalidateDate,
        onChange: null,
        onSelect: onPanelSelect,
        pickerValue: currentPickerValue,
        defaultOpenValue: (0, _miscUtil.toArray)(showTime === null || showTime === void 0 ? void 0 : showTime.defaultOpenValue)[activeIndex],
        onPickerValueChange: setCurrentPickerValue,
        hoverValue: hoverValues,
        onHover: onPanelHover,
        needConfirm: needConfirm,
        onSubmit: triggerPartConfirm,
        onOk: triggerOk,
        presets: presetList,
        onPresetHover: onPresetHover,
        onPresetSubmit: onPresetSubmit,
        onNow: onNow,
        cellRender: onInternalCellRender,
        classNames: mergedClassNames,
        styles: mergedStyles
    }));
    // ========================================================
    // ==                      Selector                      ==
    // ========================================================
    // ======================== Change ========================
    var onSelectorChange = function onSelectorChange(date, index) {
        var clone = fillCalendarValue(date, index);
        triggerCalendarChange(clone);
    };
    var onSelectorInputChange = function onSelectorInputChange() {
        lastOperation('input');
    };
    // ======================= Selector =======================
    var onSelectorFocus = function onSelectorFocus(event, index) {
        // Check if `needConfirm` but user not submit yet
        var activeListLen = activeIndexList.length;
        var lastActiveIndex = activeIndexList[activeListLen - 1];
        if (activeListLen && lastActiveIndex !== index && needConfirm && // Not change index if is not filled
        !allowEmpty[lastActiveIndex] && !hasActiveSubmitValue(lastActiveIndex) && calendarValue[lastActiveIndex]) {
            selectorRef.current.focus({
                index: lastActiveIndex
            });
            return;
        }
        lastOperation('input');
        triggerOpen(true, {
            inherit: true
        });
        // When click input to switch the field, it will not trigger close.
        // Which means it will lose the part confirm and we need fill back.
        // ref: https://github.com/ant-design/ant-design/issues/49512
        if (activeIndex !== index && mergedOpen && !needConfirm && complexPicker) triggerPartConfirm(null, true);
        setActiveIndex(index);
        onSharedFocus(event, index);
    };
    var onSelectorBlur = function onSelectorBlur(event, index) {
        triggerOpen(false);
        if (!needConfirm && lastOperation() === 'input') {
            var nextIndex = nextActiveIndex(calendarValue);
            flushSubmit(activeIndex, nextIndex === null);
        }
        onSharedBlur(event, index);
    };
    var onSelectorKeyDown = function onSelectorKeyDown(event, preventDefault) {
        if (event.key === 'Tab') triggerPartConfirm(null, true);
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(event, preventDefault);
    };
    // ======================= Context ========================
    var context = _react.useMemo(function() {
        return {
            prefixCls: prefixCls,
            locale: locale,
            generateConfig: generateConfig,
            button: components.button,
            input: components.input,
            classNames: mergedClassNames,
            styles: mergedStyles
        };
    }, [
        prefixCls,
        locale,
        generateConfig,
        components.button,
        components.input,
        mergedClassNames,
        mergedStyles
    ]);
    // ======================== Effect ========================
    // >>> Mode
    // Reset for every active
    (0, _useLayoutEffectDefault.default)(function() {
        if (mergedOpen && activeIndex !== undefined) // Legacy compatible. This effect update should not trigger `onPanelChange`
        triggerModeChange(null, picker, false);
    }, [
        mergedOpen,
        activeIndex,
        picker
    ]);
    // >>> For complex picker, we need check if need to focus next one
    (0, _useLayoutEffectDefault.default)(function() {
        var lastOp = lastOperation();
        // Trade as confirm on field leave
        if (!mergedOpen && lastOp === 'input') {
            triggerOpen(false);
            triggerPartConfirm(null, true);
        }
        // Submit with complex picker
        if (!mergedOpen && complexPicker && !needConfirm && lastOp === 'panel') {
            triggerOpen(true);
            triggerPartConfirm();
        }
    }, [
        mergedOpen
    ]);
    var isIndexEmpty;
    // ======================== Render ========================
    return /*#__PURE__*/ _react.createElement((0, _contextDefault.default).Provider, {
        value: context
    }, /*#__PURE__*/ _react.createElement((0, _pickerTriggerDefault.default), _extends({}, (0, _util1.pickTriggerProps)(filledProps), {
        popupElement: panel,
        popupStyle: mergedStyles.popup.root,
        popupClassName: (0, _clsx.clsx)(rootClassName, mergedClassNames.popup.root),
        visible: mergedOpen,
        onClose: onPopupClose,
        range: true
    }), /*#__PURE__*/ _react.createElement((0, _rangeSelectorDefault.default), _extends({}, filledProps, {
        // Ref
        ref: selectorRef,
        className: (0, _clsx.clsx)(filledProps.className, rootClassName, mergedClassNames.root),
        style: _objectSpread(_objectSpread({}, mergedStyles.root), filledProps.style),
        suffixIcon: suffixIcon,
        activeIndex: focused || mergedOpen ? activeIndex : null,
        activeHelp: !!internalHoverValues,
        allHelp: !!internalHoverValues && hoverSource === 'preset',
        focused: focused,
        onFocus: onSelectorFocus,
        onBlur: onSelectorBlur,
        onKeyDown: onSelectorKeyDown,
        onSubmit: triggerPartConfirm,
        value: hoverValues,
        maskFormat: maskFormat,
        onChange: onSelectorChange,
        onInputChange: onSelectorInputChange,
        format: formatList,
        inputReadOnly: inputReadOnly,
        disabled: disabled,
        open: mergedOpen,
        onOpenChange: triggerOpen,
        onClick: onSelectorClick,
        onClear: onSelectorClear,
        invalid: submitInvalidates,
        onInvalid: onSelectorInvalid,
        onActiveInfo: setActiveInfo
    }))));
}
var RefRangePicker = /*#__PURE__*/ _react.forwardRef(RangePicker);
exports.default = RefRangePicker;

},{"@rc-component/util":"6ZBDN","clsx":"431Ou","@rc-component/util/es/hooks/useLayoutEffect":"azwns","@rc-component/util/es/omit":"1VS01","@rc-component/util/es/pickAttrs":"jGMGD","@rc-component/util/es/warning":"hJXDS","react":"bmhQu","../PickerTrigger":"49zW0","../PickerTrigger/util":"e2ZZe","../utils/miscUtil":"2yPUL","./context":"afG3N","./hooks/useCellRender":"9dNsP","./hooks/useFieldsInvalidate":"jAemW","./hooks/useFilledProps":"dcybt","./hooks/useOpen":"e19rh","./hooks/usePickerRef":"cXEvs","./hooks/usePresets":"bhkRw","./hooks/useRangeActive":"1MKqj","./hooks/useRangeDisabledDate":"5Znt2","./hooks/useRangePickerValue":"75Bgy","./hooks/useRangeValue":"ddux0","./hooks/useShowNow":"3o1XX","./Popup":"h3ENZ","./Selector/RangeSelector":"4I3HW","../hooks/useSemantic":"1JfFg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"49zW0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _trigger = require("@rc-component/trigger");
var _triggerDefault = parcelHelpers.interopDefault(_trigger);
var _clsx = require("clsx");
var _react = require("react");
var _uiUtil = require("../utils/uiUtil");
var _context = require("../PickerInput/context");
var _contextDefault = parcelHelpers.interopDefault(_context);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var BUILT_IN_PLACEMENTS = {
    bottomLeft: {
        points: [
            'tl',
            'bl'
        ],
        offset: [
            0,
            4
        ],
        overflow: {
            adjustX: 1,
            adjustY: 1
        }
    },
    bottomRight: {
        points: [
            'tr',
            'br'
        ],
        offset: [
            0,
            4
        ],
        overflow: {
            adjustX: 1,
            adjustY: 1
        }
    },
    topLeft: {
        points: [
            'bl',
            'tl'
        ],
        offset: [
            0,
            -4
        ],
        overflow: {
            adjustX: 0,
            adjustY: 1
        }
    },
    topRight: {
        points: [
            'br',
            'tr'
        ],
        offset: [
            0,
            -4
        ],
        overflow: {
            adjustX: 0,
            adjustY: 1
        }
    }
};
function PickerTrigger(_ref) {
    var popupElement = _ref.popupElement, popupStyle = _ref.popupStyle, popupClassName = _ref.popupClassName, popupAlign = _ref.popupAlign, transitionName = _ref.transitionName, getPopupContainer = _ref.getPopupContainer, children = _ref.children, range = _ref.range, placement = _ref.placement, _ref$builtinPlacement = _ref.builtinPlacements, builtinPlacements = _ref$builtinPlacement === void 0 ? BUILT_IN_PLACEMENTS : _ref$builtinPlacement, direction = _ref.direction, visible = _ref.visible, onClose = _ref.onClose;
    var _React$useContext = _react.useContext((0, _contextDefault.default)), prefixCls = _React$useContext.prefixCls;
    var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
    var realPlacement = (0, _uiUtil.getRealPlacement)(placement, direction === 'rtl');
    return /*#__PURE__*/ _react.createElement((0, _triggerDefault.default), {
        showAction: [],
        hideAction: [
            'click'
        ],
        popupPlacement: realPlacement,
        builtinPlacements: builtinPlacements,
        prefixCls: dropdownPrefixCls,
        popupMotion: {
            motionName: transitionName
        },
        popup: popupElement,
        popupAlign: popupAlign,
        popupVisible: visible,
        popupClassName: (0, _clsx.clsx)(popupClassName, _defineProperty(_defineProperty({}, "".concat(dropdownPrefixCls, "-range"), range), "".concat(dropdownPrefixCls, "-rtl"), direction === 'rtl')),
        popupStyle: popupStyle,
        stretch: "minWidth",
        getPopupContainer: getPopupContainer,
        onPopupVisibleChange: function onPopupVisibleChange(nextVisible) {
            if (!nextVisible) onClose();
        }
    }, children);
}
exports.default = PickerTrigger;

},{"@rc-component/trigger":"8gqi4","clsx":"431Ou","react":"bmhQu","../utils/uiUtil":"9S3dK","../PickerInput/context":"afG3N","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9S3dK":[function(require,module,exports,__globalThis) {
// ====================== Mode ======================
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getRealPlacement", ()=>getRealPlacement);
function getRealPlacement(placement, rtl) {
    if (placement !== undefined) return placement;
    return rtl ? 'bottomRight' : 'bottomLeft';
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"afG3N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var PickerContext = /*#__PURE__*/ _react.createContext(null);
exports.default = PickerContext;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e2ZZe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "pickTriggerProps", ()=>pickTriggerProps);
var _miscUtil = require("../utils/miscUtil");
function pickTriggerProps(props) {
    return (0, _miscUtil.pickProps)(props, [
        'placement',
        'builtinPlacements',
        'popupAlign',
        'getPopupContainer',
        'transitionName',
        'direction'
    ]);
}

},{"../utils/miscUtil":"2yPUL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2yPUL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "leftPad", ()=>leftPad);
/**
 * Convert `value` to array. Will provide `[]` if is null or undefined.
 */ parcelHelpers.export(exports, "toArray", ()=>toArray);
parcelHelpers.export(exports, "fillIndex", ()=>fillIndex);
/** Pick props from the key list. Will filter empty value */ parcelHelpers.export(exports, "pickProps", ()=>pickProps);
parcelHelpers.export(exports, "getRowFormat", ()=>getRowFormat);
parcelHelpers.export(exports, "getFromDate", ()=>getFromDate);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function leftPad(str, length) {
    var fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
    var current = String(str);
    while(current.length < length)current = "".concat(fill).concat(current);
    return current;
}
function toArray(val) {
    if (val === null || val === undefined) return [];
    return Array.isArray(val) ? val : [
        val
    ];
}
function fillIndex(ori, index, value) {
    var clone = _toConsumableArray(ori);
    clone[index] = value;
    return clone;
}
function pickProps(props, keys) {
    var clone = {};
    var mergedKeys = keys || Object.keys(props);
    mergedKeys.forEach(function(key) {
        if (props[key] !== undefined) clone[key] = props[key];
    });
    return clone;
}
function getRowFormat(picker, locale, format) {
    if (format) return format;
    switch(picker){
        // All from the `locale.fieldXXXFormat` first
        case 'time':
            return locale.fieldTimeFormat;
        case 'datetime':
            return locale.fieldDateTimeFormat;
        case 'month':
            return locale.fieldMonthFormat;
        case 'year':
            return locale.fieldYearFormat;
        case 'quarter':
            return locale.fieldQuarterFormat;
        case 'week':
            return locale.fieldWeekFormat;
        default:
            return locale.fieldDateFormat;
    }
}
function getFromDate(calendarValues, activeIndexList, activeIndex) {
    var mergedActiveIndex = activeIndex !== undefined ? activeIndex : activeIndexList[activeIndexList.length - 1];
    var firstValuedIndex = activeIndexList.find(function(index) {
        return calendarValues[index];
    });
    return mergedActiveIndex !== firstValuedIndex ? calendarValues[firstValuedIndex] : undefined;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9dNsP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useCellRender);
var _util = require("@rc-component/util");
var _react = require("react");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function useCellRender(cellRender, dateRender, monthCellRender, range) {
    // ======================== Render ========================
    // Merged render
    var mergedCellRender = _react.useMemo(function() {
        if (cellRender) return cellRender;
        return function(current, info) {
            var date = current;
            if (dateRender && info.type === 'date') return dateRender(date, info.today);
            if (monthCellRender && info.type === 'month') return monthCellRender(date, info.locale);
            return info.originNode;
        };
    }, [
        cellRender,
        monthCellRender,
        dateRender
    ]);
    // Cell render
    var onInternalCellRender = _react.useCallback(function(date, info) {
        return mergedCellRender(date, _objectSpread(_objectSpread({}, info), {}, {
            range: range
        }));
    }, [
        mergedCellRender,
        range
    ]);
    return onInternalCellRender;
}

},{"@rc-component/util":"6ZBDN","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jAemW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFieldsInvalidate);
var _miscUtil = require("../../utils/miscUtil");
var _react = require("react");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useFieldsInvalidate(calendarValue, isInvalidateDate) {
    var allowEmpty = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var _React$useState = _react.useState([
        false,
        false
    ]), _React$useState2 = _slicedToArray(_React$useState, 2), fieldsInvalidates = _React$useState2[0], setFieldsInvalidates = _React$useState2[1];
    var onSelectorInvalid = function onSelectorInvalid(invalid, index) {
        setFieldsInvalidates(function(ori) {
            return (0, _miscUtil.fillIndex)(ori, index, invalid);
        });
    };
    /**
   * For the Selector Input to mark as `aria-disabled`
   */ var submitInvalidates = _react.useMemo(function() {
        return fieldsInvalidates.map(function(invalid, index) {
            // If typing invalidate
            if (invalid) return true;
            var current = calendarValue[index];
            // Not check if all empty
            if (!current) return false;
            // Not allow empty
            if (!allowEmpty[index] && !current) return true;
            // Invalidate
            if (current && isInvalidateDate(current, {
                activeIndex: index
            })) return true;
            return false;
        });
    }, [
        calendarValue,
        fieldsInvalidates,
        isInvalidateDate,
        allowEmpty
    ]);
    return [
        submitInvalidates,
        onSelectorInvalid
    ];
}

},{"../../utils/miscUtil":"2yPUL","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dcybt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useFilledProps);
var _util = require("@rc-component/util");
var _react = require("react");
var _useLocale = require("../../hooks/useLocale");
var _useLocaleDefault = parcelHelpers.interopDefault(_useLocale);
var _useTimeConfig = require("../../hooks/useTimeConfig");
var _miscUtil = require("../../utils/miscUtil");
var _useClearIcon = require("../Selector/hooks/useClearIcon");
var _useDisabledBoundary = require("./useDisabledBoundary");
var _useDisabledBoundaryDefault = parcelHelpers.interopDefault(_useDisabledBoundary);
var _useFieldFormat = require("./useFieldFormat");
var _useInputReadOnly = require("./useInputReadOnly");
var _useInputReadOnlyDefault = parcelHelpers.interopDefault(_useInputReadOnly);
var _useInvalidate = require("./useInvalidate");
var _useInvalidateDefault = parcelHelpers.interopDefault(_useInvalidate);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useList(value) {
    var fillMode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var values = _react.useMemo(function() {
        var list = value ? (0, _miscUtil.toArray)(value) : value;
        if (fillMode && list) list[1] = list[1] || list[0];
        return list;
    }, [
        value,
        fillMode
    ]);
    return values;
}
function useFilledProps(props, updater) {
    var generateConfig = props.generateConfig, locale = props.locale, _props$picker = props.picker, picker = _props$picker === void 0 ? 'date' : _props$picker, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? 'rc-picker' : _props$prefixCls, _props$previewValue = props.previewValue, previewValue = _props$previewValue === void 0 ? 'hover' : _props$previewValue, _props$styles = props.styles, styles = _props$styles === void 0 ? {} : _props$styles, _props$classNames = props.classNames, classNames = _props$classNames === void 0 ? {} : _props$classNames, _props$order = props.order, order = _props$order === void 0 ? true : _props$order, _props$components = props.components, components = _props$components === void 0 ? {} : _props$components, inputRender = props.inputRender, allowClear = props.allowClear, clearIcon = props.clearIcon, needConfirm = props.needConfirm, multiple = props.multiple, format = props.format, inputReadOnly = props.inputReadOnly, disabledDate = props.disabledDate, minDate = props.minDate, maxDate = props.maxDate, showTime = props.showTime, value = props.value, defaultValue = props.defaultValue, pickerValue = props.pickerValue, defaultPickerValue = props.defaultPickerValue;
    var values = useList(value);
    var defaultValues = useList(defaultValue);
    var pickerValues = useList(pickerValue);
    var defaultPickerValues = useList(defaultPickerValue);
    // ======================== Picker ========================
    /** Almost same as `picker`, but add `datetime` for `date` with `showTime` */ var internalPicker = picker === 'date' && showTime ? 'datetime' : picker;
    /** The picker is `datetime` or `time` */ var multipleInteractivePicker = internalPicker === 'time' || internalPicker === 'datetime';
    var complexPicker = multipleInteractivePicker || multiple;
    var mergedNeedConfirm = needConfirm !== null && needConfirm !== void 0 ? needConfirm : multipleInteractivePicker;
    // ========================== Time ==========================
    // Auto `format` need to check `showTime.showXXX` first.
    // And then merge the `locale` into `mergedShowTime`.
    var _getTimeProps = (0, _useTimeConfig.getTimeProps)(props), _getTimeProps2 = _slicedToArray(_getTimeProps, 4), timeProps = _getTimeProps2[0], localeTimeProps = _getTimeProps2[1], showTimeFormat = _getTimeProps2[2], propFormat = _getTimeProps2[3];
    // ======================= Locales ========================
    var mergedLocale = (0, _useLocaleDefault.default)(locale, localeTimeProps);
    var mergedShowTime = _react.useMemo(function() {
        return (0, _useTimeConfig.fillShowTimeConfig)(internalPicker, showTimeFormat, propFormat, timeProps, mergedLocale);
    }, [
        internalPicker,
        showTimeFormat,
        propFormat,
        timeProps,
        mergedLocale
    ]);
    // ======================== Props =========================
    var filledProps = _react.useMemo(function() {
        return _objectSpread(_objectSpread({}, props), {}, {
            previewValue: previewValue,
            prefixCls: prefixCls,
            locale: mergedLocale,
            picker: picker,
            styles: styles,
            classNames: classNames,
            order: order,
            components: _objectSpread({
                input: inputRender
            }, components),
            clearIcon: (0, _useClearIcon.fillClearIcon)(prefixCls, allowClear, clearIcon),
            showTime: mergedShowTime,
            value: values,
            defaultValue: defaultValues,
            pickerValue: pickerValues,
            defaultPickerValue: defaultPickerValues
        }, updater === null || updater === void 0 ? void 0 : updater());
    }, [
        props
    ]);
    // ======================== Format ========================
    var _useFieldFormat1 = (0, _useFieldFormat.useFieldFormat)(internalPicker, mergedLocale, format), _useFieldFormat2 = _slicedToArray(_useFieldFormat1, 2), formatList = _useFieldFormat2[0], maskFormat = _useFieldFormat2[1];
    // ======================= ReadOnly =======================
    var mergedInputReadOnly = (0, _useInputReadOnlyDefault.default)(formatList, inputReadOnly, multiple);
    // ======================= Boundary =======================
    var disabledBoundaryDate = (0, _useDisabledBoundaryDefault.default)(generateConfig, locale, disabledDate, minDate, maxDate);
    // ====================== Invalidate ======================
    var isInvalidateDate = (0, _useInvalidateDefault.default)(generateConfig, picker, disabledBoundaryDate, mergedShowTime);
    // ======================== Merged ========================
    var mergedProps = _react.useMemo(function() {
        return _objectSpread(_objectSpread({}, filledProps), {}, {
            needConfirm: mergedNeedConfirm,
            inputReadOnly: mergedInputReadOnly,
            disabledDate: disabledBoundaryDate
        });
    }, [
        filledProps,
        mergedNeedConfirm,
        mergedInputReadOnly,
        disabledBoundaryDate
    ]);
    return [
        mergedProps,
        internalPicker,
        complexPicker,
        formatList,
        maskFormat,
        isInvalidateDate
    ];
}

},{"@rc-component/util":"6ZBDN","react":"bmhQu","../../hooks/useLocale":"14hhv","../../hooks/useTimeConfig":"8Q56P","../../utils/miscUtil":"2yPUL","../Selector/hooks/useClearIcon":"lIvsa","./useDisabledBoundary":"kFs8a","./useFieldFormat":"jhsmm","./useInputReadOnly":"9ghTC","./useInvalidate":"z5Q4E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"14hhv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fillTimeFormat", ()=>fillTimeFormat);
parcelHelpers.export(exports, "default", ()=>useLocale);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function fillTimeFormat(showHour, showMinute, showSecond, showMillisecond, showMeridiem) {
    var timeFormat = '';
    // Base HH:mm:ss
    var cells = [];
    if (showHour) cells.push(showMeridiem ? 'hh' : 'HH');
    if (showMinute) cells.push('mm');
    if (showSecond) cells.push('ss');
    timeFormat = cells.join(':');
    // Millisecond
    if (showMillisecond) timeFormat += '.SSS';
    // Meridiem
    if (showMeridiem) timeFormat += ' A';
    return timeFormat;
}
/**
 * Used for `useFilledProps` since it already in the React.useMemo
 */ function fillLocale(locale, showHour, showMinute, showSecond, showMillisecond, use12Hours) {
    // Not fill `monthFormat` since `locale.shortMonths` handle this
    // Not fill `cellMeridiemFormat` since AM & PM by default
    var fieldDateTimeFormat = locale.fieldDateTimeFormat, fieldDateFormat = locale.fieldDateFormat, fieldTimeFormat = locale.fieldTimeFormat, fieldMonthFormat = locale.fieldMonthFormat, fieldYearFormat = locale.fieldYearFormat, fieldWeekFormat = locale.fieldWeekFormat, fieldQuarterFormat = locale.fieldQuarterFormat, yearFormat = locale.yearFormat, cellYearFormat = locale.cellYearFormat, cellQuarterFormat = locale.cellQuarterFormat, dayFormat = locale.dayFormat, cellDateFormat = locale.cellDateFormat;
    var timeFormat = fillTimeFormat(showHour, showMinute, showSecond, showMillisecond, use12Hours);
    return _objectSpread(_objectSpread({}, locale), {}, {
        fieldDateTimeFormat: fieldDateTimeFormat || "YYYY-MM-DD ".concat(timeFormat),
        fieldDateFormat: fieldDateFormat || 'YYYY-MM-DD',
        fieldTimeFormat: fieldTimeFormat || timeFormat,
        fieldMonthFormat: fieldMonthFormat || 'YYYY-MM',
        fieldYearFormat: fieldYearFormat || 'YYYY',
        fieldWeekFormat: fieldWeekFormat || 'gggg-wo',
        fieldQuarterFormat: fieldQuarterFormat || 'YYYY-[Q]Q',
        yearFormat: yearFormat || 'YYYY',
        cellYearFormat: cellYearFormat || 'YYYY',
        cellQuarterFormat: cellQuarterFormat || '[Q]Q',
        cellDateFormat: cellDateFormat || dayFormat || 'D'
    });
}
function useLocale(locale, showProps) {
    var showHour = showProps.showHour, showMinute = showProps.showMinute, showSecond = showProps.showSecond, showMillisecond = showProps.showMillisecond, use12Hours = showProps.use12Hours;
    return (0, _reactDefault.default).useMemo(function() {
        return fillLocale(locale, showHour, showMinute, showSecond, showMillisecond, use12Hours);
    }, [
        locale,
        showHour,
        showMinute,
        showSecond,
        showMillisecond,
        use12Hours
    ]);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Q56P":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Get `showHour`, `showMinute`, `showSecond` or other from the props.
 * This is pure function, will not get `showXXX` from the `format` prop.
 */ parcelHelpers.export(exports, "getTimeProps", ()=>getTimeProps);
parcelHelpers.export(exports, "fillShowTimeConfig", ()=>fillShowTimeConfig);
var _miscUtil = require("../utils/miscUtil");
var _useLocale = require("./useLocale");
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function checkShow(format, keywords, show) {
    return show !== null && show !== void 0 ? show : keywords.some(function(keyword) {
        return format.includes(keyword);
    });
}
var showTimeKeys = [
    // 'format',
    'showNow',
    'showHour',
    'showMinute',
    'showSecond',
    'showMillisecond',
    'use12Hours',
    'hourStep',
    'minuteStep',
    'secondStep',
    'millisecondStep',
    'hideDisabledOptions',
    'defaultValue',
    'disabledHours',
    'disabledMinutes',
    'disabledSeconds',
    'disabledMilliseconds',
    'disabledTime',
    'changeOnScroll',
    'defaultOpenValue'
];
/**
 * Get SharedTimeProps from props.
 */ function pickTimeProps(props) {
    var timeProps = (0, _miscUtil.pickProps)(props, showTimeKeys);
    var format = props.format, picker = props.picker;
    var propFormat = null;
    if (format) {
        propFormat = format;
        if (Array.isArray(propFormat)) propFormat = propFormat[0];
        propFormat = _typeof(propFormat) === 'object' ? propFormat.format : propFormat;
    }
    if (picker === 'time') timeProps.format = propFormat;
    return [
        timeProps,
        propFormat
    ];
}
function isStringFormat(format) {
    return format && typeof format === 'string';
}
/** Check if all the showXXX is `undefined` */ function existShowConfig(showHour, showMinute, showSecond, showMillisecond) {
    return [
        showHour,
        showMinute,
        showSecond,
        showMillisecond
    ].some(function(show) {
        return show !== undefined;
    });
}
/** Fill the showXXX if needed */ function fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond) {
    var parsedShowHour = showHour;
    var parsedShowMinute = showMinute;
    var parsedShowSecond = showSecond;
    if (!hasShowConfig && !parsedShowHour && !parsedShowMinute && !parsedShowSecond && !showMillisecond) {
        parsedShowHour = true;
        parsedShowMinute = true;
        parsedShowSecond = true;
    } else if (hasShowConfig) {
        var _parsedShowHour, _parsedShowMinute, _parsedShowSecond;
        var existFalse = [
            parsedShowHour,
            parsedShowMinute,
            parsedShowSecond
        ].some(function(show) {
            return show === false;
        });
        var existTrue = [
            parsedShowHour,
            parsedShowMinute,
            parsedShowSecond
        ].some(function(show) {
            return show === true;
        });
        var defaultShow = existFalse ? true : !existTrue;
        parsedShowHour = (_parsedShowHour = parsedShowHour) !== null && _parsedShowHour !== void 0 ? _parsedShowHour : defaultShow;
        parsedShowMinute = (_parsedShowMinute = parsedShowMinute) !== null && _parsedShowMinute !== void 0 ? _parsedShowMinute : defaultShow;
        parsedShowSecond = (_parsedShowSecond = parsedShowSecond) !== null && _parsedShowSecond !== void 0 ? _parsedShowSecond : defaultShow;
    }
    return [
        parsedShowHour,
        parsedShowMinute,
        parsedShowSecond,
        showMillisecond
    ];
}
function getTimeProps(componentProps) {
    var showTime = componentProps.showTime;
    var _pickTimeProps = pickTimeProps(componentProps), _pickTimeProps2 = _slicedToArray(_pickTimeProps, 2), pickedProps = _pickTimeProps2[0], propFormat = _pickTimeProps2[1];
    var showTimeConfig = showTime && _typeof(showTime) === 'object' ? showTime : {};
    var timeConfig = _objectSpread(_objectSpread({
        defaultOpenValue: showTimeConfig.defaultOpenValue || showTimeConfig.defaultValue
    }, pickedProps), showTimeConfig);
    var showMillisecond = timeConfig.showMillisecond;
    var showHour = timeConfig.showHour, showMinute = timeConfig.showMinute, showSecond = timeConfig.showSecond;
    var hasShowConfig = existShowConfig(showHour, showMinute, showSecond, showMillisecond);
    var _fillShowConfig = fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond);
    var _fillShowConfig2 = _slicedToArray(_fillShowConfig, 3);
    showHour = _fillShowConfig2[0];
    showMinute = _fillShowConfig2[1];
    showSecond = _fillShowConfig2[2];
    return [
        timeConfig,
        _objectSpread(_objectSpread({}, timeConfig), {}, {
            showHour: showHour,
            showMinute: showMinute,
            showSecond: showSecond,
            showMillisecond: showMillisecond
        }),
        timeConfig.format,
        propFormat
    ];
}
function fillShowTimeConfig(picker, showTimeFormat, propFormat, timeConfig, locale) {
    var isTimePicker = picker === 'time';
    if (picker === 'datetime' || isTimePicker) {
        var pickedProps = timeConfig;
        // ====================== BaseFormat ======================
        var defaultLocaleFormat = (0, _miscUtil.getRowFormat)(picker, locale, null);
        var baselineFormat = defaultLocaleFormat;
        var formatList = [
            showTimeFormat,
            propFormat
        ];
        for(var i = 0; i < formatList.length; i += 1){
            var format = (0, _miscUtil.toArray)(formatList[i])[0];
            if (isStringFormat(format)) {
                baselineFormat = format;
                break;
            }
        }
        // ========================= Show =========================
        var showHour = pickedProps.showHour, showMinute = pickedProps.showMinute, showSecond = pickedProps.showSecond, showMillisecond = pickedProps.showMillisecond;
        var use12Hours = pickedProps.use12Hours;
        var showMeridiem = checkShow(baselineFormat, [
            'a',
            'A',
            'LT',
            'LLL',
            'LTS'
        ], use12Hours);
        var hasShowConfig = existShowConfig(showHour, showMinute, showSecond, showMillisecond);
        // Fill with format, if needed
        if (!hasShowConfig) {
            showHour = checkShow(baselineFormat, [
                'H',
                'h',
                'k',
                'LT',
                'LLL'
            ]);
            showMinute = checkShow(baselineFormat, [
                'm',
                'LT',
                'LLL'
            ]);
            showSecond = checkShow(baselineFormat, [
                's',
                'LTS'
            ]);
            showMillisecond = checkShow(baselineFormat, [
                'SSS'
            ]);
        }
        // Fallback if all can not see
        // ======================== Format ========================
        var _fillShowConfig3 = fillShowConfig(hasShowConfig, showHour, showMinute, showSecond, showMillisecond);
        var _fillShowConfig4 = _slicedToArray(_fillShowConfig3, 3);
        showHour = _fillShowConfig4[0];
        showMinute = _fillShowConfig4[1];
        showSecond = _fillShowConfig4[2];
        var timeFormat = showTimeFormat || (0, _useLocale.fillTimeFormat)(showHour, showMinute, showSecond, showMillisecond, showMeridiem);
        // ======================== Props =========================
        return _objectSpread(_objectSpread({}, pickedProps), {}, {
            // Format
            format: timeFormat,
            // Show Config
            showHour: showHour,
            showMinute: showMinute,
            showSecond: showSecond,
            showMillisecond: showMillisecond,
            use12Hours: showMeridiem
        });
    }
    return null;
}

},{"../utils/miscUtil":"2yPUL","./useLocale":"14hhv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lIvsa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Used for `useFilledProps` since it already in the React.useMemo
 */ parcelHelpers.export(exports, "fillClearIcon", ()=>fillClearIcon);
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
var _react = require("react");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function fillClearIcon(prefixCls, allowClear, clearIcon) {
    if (allowClear === false) return null;
    var config = allowClear && _typeof(allowClear) === 'object' ? allowClear : {};
    return config.clearIcon || clearIcon || /*#__PURE__*/ _react.createElement("span", {
        className: "".concat(prefixCls, "-clear-btn")
    });
}

},{"@rc-component/util/es/warning":"hJXDS","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kFs8a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDisabledBoundary);
var _util = require("@rc-component/util");
var _dateUtil = require("../../utils/dateUtil");
function useDisabledBoundary(generateConfig, locale, disabledDate, minDate, maxDate) {
    var mergedDisabledDate = (0, _util.useEvent)(function(date, info) {
        if (disabledDate && disabledDate(date, info)) return true;
        if (minDate && generateConfig.isAfter(minDate, date) && !(0, _dateUtil.isSame)(generateConfig, locale, minDate, date, info.type)) return true;
        if (maxDate && generateConfig.isAfter(date, maxDate) && !(0, _dateUtil.isSame)(generateConfig, locale, maxDate, date, info.type)) return true;
        return false;
    });
    return mergedDisabledDate;
}

},{"@rc-component/util":"6ZBDN","../../utils/dateUtil":"gSKz6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gSKz6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WEEK_DAY_COUNT", ()=>WEEK_DAY_COUNT);
parcelHelpers.export(exports, "isSameDecade", ()=>isSameDecade);
parcelHelpers.export(exports, "isSameYear", ()=>isSameYear);
parcelHelpers.export(exports, "getQuarter", ()=>getQuarter);
parcelHelpers.export(exports, "isSameQuarter", ()=>isSameQuarter);
parcelHelpers.export(exports, "isSameMonth", ()=>isSameMonth);
parcelHelpers.export(exports, "isSameDate", ()=>isSameDate);
parcelHelpers.export(exports, "isSameTime", ()=>isSameTime);
/**
 * Check if the Date is all the same of timestamp
 */ parcelHelpers.export(exports, "isSameTimestamp", ()=>isSameTimestamp);
parcelHelpers.export(exports, "isSameWeek", ()=>isSameWeek);
parcelHelpers.export(exports, "isSame", ()=>isSame);
/** Between in date but not equal of date */ parcelHelpers.export(exports, "isInRange", ()=>isInRange);
parcelHelpers.export(exports, "isSameOrAfter", ()=>isSameOrAfter);
parcelHelpers.export(exports, "getWeekStartDate", ()=>getWeekStartDate);
parcelHelpers.export(exports, "formatValue", ()=>formatValue);
/**
 * Fill the time info into Date if provided.
 */ parcelHelpers.export(exports, "fillTime", ()=>fillTime);
var WEEK_DAY_COUNT = 7;
/**
 * Wrap the compare logic.
 * This will compare the each of value is empty first.
 * 1. All is empty, return true.
 * 2. One is empty, return false.
 * 3. return customize compare logic.
 */ function nullableCompare(value1, value2, oriCompareFn) {
    if (!value1 && !value2 || value1 === value2) return true;
    if (!value1 || !value2) return false;
    return oriCompareFn();
}
function isSameDecade(generateConfig, decade1, decade2) {
    return nullableCompare(decade1, decade2, function() {
        var num1 = Math.floor(generateConfig.getYear(decade1) / 10);
        var num2 = Math.floor(generateConfig.getYear(decade2) / 10);
        return num1 === num2;
    });
}
function isSameYear(generateConfig, year1, year2) {
    return nullableCompare(year1, year2, function() {
        return generateConfig.getYear(year1) === generateConfig.getYear(year2);
    });
}
function getQuarter(generateConfig, date) {
    var quota = Math.floor(generateConfig.getMonth(date) / 3);
    return quota + 1;
}
function isSameQuarter(generateConfig, quarter1, quarter2) {
    return nullableCompare(quarter1, quarter2, function() {
        return isSameYear(generateConfig, quarter1, quarter2) && getQuarter(generateConfig, quarter1) === getQuarter(generateConfig, quarter2);
    });
}
function isSameMonth(generateConfig, month1, month2) {
    return nullableCompare(month1, month2, function() {
        return isSameYear(generateConfig, month1, month2) && generateConfig.getMonth(month1) === generateConfig.getMonth(month2);
    });
}
function isSameDate(generateConfig, date1, date2) {
    return nullableCompare(date1, date2, function() {
        return isSameYear(generateConfig, date1, date2) && isSameMonth(generateConfig, date1, date2) && generateConfig.getDate(date1) === generateConfig.getDate(date2);
    });
}
function isSameTime(generateConfig, time1, time2) {
    return nullableCompare(time1, time2, function() {
        return generateConfig.getHour(time1) === generateConfig.getHour(time2) && generateConfig.getMinute(time1) === generateConfig.getMinute(time2) && generateConfig.getSecond(time1) === generateConfig.getSecond(time2);
    });
}
function isSameTimestamp(generateConfig, time1, time2) {
    return nullableCompare(time1, time2, function() {
        return isSameDate(generateConfig, time1, time2) && isSameTime(generateConfig, time1, time2) && generateConfig.getMillisecond(time1) === generateConfig.getMillisecond(time2);
    });
}
function isSameWeek(generateConfig, locale, date1, date2) {
    return nullableCompare(date1, date2, function() {
        var weekStartDate1 = generateConfig.locale.getWeekFirstDate(locale, date1);
        var weekStartDate2 = generateConfig.locale.getWeekFirstDate(locale, date2);
        return isSameYear(generateConfig, weekStartDate1, weekStartDate2) && generateConfig.locale.getWeek(locale, date1) === generateConfig.locale.getWeek(locale, date2);
    });
}
function isSame(generateConfig, locale, source, target, type) {
    switch(type){
        case 'date':
            return isSameDate(generateConfig, source, target);
        case 'week':
            return isSameWeek(generateConfig, locale.locale, source, target);
        case 'month':
            return isSameMonth(generateConfig, source, target);
        case 'quarter':
            return isSameQuarter(generateConfig, source, target);
        case 'year':
            return isSameYear(generateConfig, source, target);
        case 'decade':
            return isSameDecade(generateConfig, source, target);
        case 'time':
            return isSameTime(generateConfig, source, target);
        default:
            return isSameTimestamp(generateConfig, source, target);
    }
}
function isInRange(generateConfig, startDate, endDate, current) {
    if (!startDate || !endDate || !current) return false;
    return generateConfig.isAfter(current, startDate) && generateConfig.isAfter(endDate, current);
}
function isSameOrAfter(generateConfig, locale, date1, date2, type) {
    if (isSame(generateConfig, locale, date1, date2, type)) return true;
    return generateConfig.isAfter(date1, date2);
}
function getWeekStartDate(locale, generateConfig, value) {
    var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale);
    var monthStartDate = generateConfig.setDate(value, 1);
    var startDateWeekDay = generateConfig.getWeekDay(monthStartDate);
    var alignStartDate = generateConfig.addDate(monthStartDate, weekFirstDay - startDateWeekDay);
    if (generateConfig.getMonth(alignStartDate) === generateConfig.getMonth(value) && generateConfig.getDate(alignStartDate) > 1) alignStartDate = generateConfig.addDate(alignStartDate, -7);
    return alignStartDate;
}
function formatValue(value, _ref) {
    var generateConfig = _ref.generateConfig, locale = _ref.locale, format = _ref.format;
    if (!value) return '';
    return typeof format === 'function' ? format(value) : generateConfig.locale.format(locale.locale, value, format);
}
function fillTime(generateConfig, date, time) {
    var tmpDate = date;
    var getFn = [
        'getHour',
        'getMinute',
        'getSecond',
        'getMillisecond'
    ];
    var setFn = [
        'setHour',
        'setMinute',
        'setSecond',
        'setMillisecond'
    ];
    setFn.forEach(function(fn, index) {
        if (time) tmpDate = generateConfig[fn](tmpDate, generateConfig[getFn[index]](time));
        else tmpDate = generateConfig[fn](tmpDate, 0);
    });
    return tmpDate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jhsmm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useFieldFormat", ()=>useFieldFormat);
var _react = require("react");
var _miscUtil = require("../../utils/miscUtil");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function useFieldFormat(picker, locale, format) {
    return _react.useMemo(function() {
        var rawFormat = (0, _miscUtil.getRowFormat)(picker, locale, format);
        var formatList = (0, _miscUtil.toArray)(rawFormat);
        var firstFormat = formatList[0];
        var maskFormat = _typeof(firstFormat) === 'object' && firstFormat.type === 'mask' ? firstFormat.format : null;
        return [
            // Format list
            formatList.map(function(config) {
                return typeof config === 'string' || typeof config === 'function' ? config : config.format;
            }),
            // Mask Format
            maskFormat
        ];
    }, [
        picker,
        locale,
        format
    ]);
}

},{"react":"bmhQu","../../utils/miscUtil":"2yPUL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9ghTC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useInputReadOnly);
function useInputReadOnly(formatList, inputReadOnly, multiple) {
    if (typeof formatList[0] === 'function' || multiple) return true;
    return inputReadOnly;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"z5Q4E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useInvalidate);
var _util = require("@rc-component/util");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function useInvalidate(generateConfig, picker, disabledDate, showTime) {
    // Check disabled date
    var isInvalidate = (0, _util.useEvent)(function(date, info) {
        var outsideInfo = _objectSpread({
            type: picker
        }, info);
        delete outsideInfo.activeIndex;
        if (// Date object is invalid
        !generateConfig.isValidate(date) || // Date is disabled by `disabledDate`
        disabledDate && disabledDate(date, outsideInfo)) return true;
        if ((picker === 'date' || picker === 'time') && showTime) {
            var _showTime$disabledTim;
            var range = info && info.activeIndex === 1 ? 'end' : 'start';
            var _ref = ((_showTime$disabledTim = showTime.disabledTime) === null || _showTime$disabledTim === void 0 ? void 0 : _showTime$disabledTim.call(showTime, date, range, {
                from: outsideInfo.from
            })) || {}, disabledHours = _ref.disabledHours, disabledMinutes = _ref.disabledMinutes, disabledSeconds = _ref.disabledSeconds, disabledMilliseconds = _ref.disabledMilliseconds;
            var legacyDisabledHours = showTime.disabledHours, legacyDisabledMinutes = showTime.disabledMinutes, legacyDisabledSeconds = showTime.disabledSeconds;
            var mergedDisabledHours = disabledHours || legacyDisabledHours;
            var mergedDisabledMinutes = disabledMinutes || legacyDisabledMinutes;
            var mergedDisabledSeconds = disabledSeconds || legacyDisabledSeconds;
            var hour = generateConfig.getHour(date);
            var minute = generateConfig.getMinute(date);
            var second = generateConfig.getSecond(date);
            var millisecond = generateConfig.getMillisecond(date);
            if (mergedDisabledHours && mergedDisabledHours().includes(hour)) return true;
            if (mergedDisabledMinutes && mergedDisabledMinutes(hour).includes(minute)) return true;
            if (mergedDisabledSeconds && mergedDisabledSeconds(hour, minute).includes(second)) return true;
            if (disabledMilliseconds && disabledMilliseconds(hour, minute, second).includes(millisecond)) return true;
        }
        return false;
    });
    return isInvalidate;
}

},{"@rc-component/util":"6ZBDN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e19rh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useOpen);
var _useDelayState = require("./useDelayState");
var _useDelayStateDefault = parcelHelpers.interopDefault(_useDelayState);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useOpen(open, defaultOpen) {
    var disabledList = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var onOpenChange = arguments.length > 3 ? arguments[3] : undefined;
    var mergedOpen = disabledList.every(function(disabled) {
        return disabled;
    }) ? false : open;
    // Delay for handle the open state, in case fast shift from `open` -> `close` -> `open`
    // const [rafOpen, setRafOpen] = useLockState(open, defaultOpen || false, onOpenChange);
    var _useDelayState = (0, _useDelayStateDefault.default)(mergedOpen, defaultOpen || false, onOpenChange), _useDelayState2 = _slicedToArray(_useDelayState, 2), rafOpen = _useDelayState2[0], setRafOpen = _useDelayState2[1];
    function setOpen(next) {
        var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if (!config.inherit || rafOpen) setRafOpen(next, config.force);
    }
    return [
        rafOpen,
        setOpen
    ];
}

},{"./useDelayState":"971Lr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"971Lr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useDelayState);
var _util = require("@rc-component/util");
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useDelayState(value, defaultValue, onChange) {
    var _useControlledState = (0, _util.useControlledState)(defaultValue, value), _useControlledState2 = _slicedToArray(_useControlledState, 2), state = _useControlledState2[0], setState = _useControlledState2[1];
    // Need force update to ensure React re-render
    var _React$useState = (0, _reactDefault.default).useState({}), _React$useState2 = _slicedToArray(_React$useState, 2), forceUpdate = _React$useState2[1];
    var triggerUpdate = (0, _util.useEvent)(function(nextState) {
        setState(nextState);
        forceUpdate({});
    });
    var nextValueRef = (0, _reactDefault.default).useRef(value);
    // ============================= Update =============================
    var rafRef = (0, _reactDefault.default).useRef();
    var cancelRaf = function cancelRaf() {
        (0, _rafDefault.default).cancel(rafRef.current);
    };
    var doUpdate = (0, _util.useEvent)(function() {
        triggerUpdate(nextValueRef.current);
        if (onChange && state !== nextValueRef.current) onChange(nextValueRef.current);
    });
    var updateValue = (0, _util.useEvent)(function(next, immediately) {
        cancelRaf();
        nextValueRef.current = next;
        if (next || immediately) doUpdate();
        else rafRef.current = (0, _rafDefault.default)(doUpdate);
    });
    (0, _reactDefault.default).useEffect(function() {
        return cancelRaf;
    }, []);
    return [
        state,
        updateValue
    ];
}

},{"@rc-component/util":"6ZBDN","@rc-component/util/es/raf":"ajbAx","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cXEvs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePickerRef);
var _react = require("react");
function usePickerRef(ref) {
    var selectorRef = _react.useRef();
    _react.useImperativeHandle(ref, function() {
        var _selectorRef$current;
        return {
            nativeElement: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.nativeElement,
            focus: function focus(options) {
                var _selectorRef$current2;
                (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 || _selectorRef$current2.focus(options);
            },
            blur: function blur() {
                var _selectorRef$current3;
                (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.blur();
            }
        };
    });
    return selectorRef;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bhkRw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>usePresets);
var _react = require("react");
var _warning = require("@rc-component/util/es/warning");
var _warningDefault = parcelHelpers.interopDefault(_warning);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function usePresets(presets, legacyRanges) {
    return _react.useMemo(function() {
        if (presets) return presets;
        if (legacyRanges) {
            (0, _warningDefault.default)(false, '`ranges` is deprecated. Please use `presets` instead.');
            return Object.entries(legacyRanges).map(function(_ref) {
                var _ref2 = _slicedToArray(_ref, 2), label = _ref2[0], value = _ref2[1];
                return {
                    label: label,
                    value: value
                };
            });
        }
        return [];
    }, [
        presets,
        legacyRanges
    ]);
}

},{"react":"bmhQu","@rc-component/util/es/warning":"hJXDS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1MKqj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRangeActive);
var _react = require("react");
var _useLockEffect = require("./useLockEffect");
var _useLockEffectDefault = parcelHelpers.interopDefault(_useLockEffect);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useRangeActive(disabled) {
    var empty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var mergedOpen = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    var _React$useState = _react.useState(0), _React$useState2 = _slicedToArray(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
    var _React$useState3 = _react.useState(false), _React$useState4 = _slicedToArray(_React$useState3, 2), focused = _React$useState4[0], setFocused = _React$useState4[1];
    var activeListRef = _react.useRef([]);
    var submitIndexRef = _react.useRef(null);
    var lastOperationRef = _react.useRef(null);
    var updateSubmitIndex = function updateSubmitIndex(index) {
        submitIndexRef.current = index;
    };
    var hasActiveSubmitValue = function hasActiveSubmitValue(index) {
        return submitIndexRef.current === index;
    };
    var triggerFocus = function triggerFocus(nextFocus) {
        setFocused(nextFocus);
    };
    // ============================= Record =============================
    var lastOperation = function lastOperation(type) {
        if (type) lastOperationRef.current = type;
        return lastOperationRef.current;
    };
    // ============================ Strategy ============================
    // Trigger when input enter or input blur or panel close
    var nextActiveIndex = function nextActiveIndex(nextValue) {
        var list = activeListRef.current;
        var filledActiveSet = new Set(list.filter(function(index) {
            return nextValue[index] || empty[index];
        }));
        var nextIndex = list[list.length - 1] === 0 ? 1 : 0;
        if (filledActiveSet.size >= 2 || disabled[nextIndex]) return null;
        return nextIndex;
    };
    // ============================= Effect =============================
    // Wait in case it's from the click outside to blur
    (0, _useLockEffectDefault.default)(focused || mergedOpen, function() {
        if (!focused) {
            activeListRef.current = [];
            updateSubmitIndex(null);
        }
    });
    _react.useEffect(function() {
        if (focused) activeListRef.current.push(activeIndex);
    }, [
        focused,
        activeIndex
    ]);
    return [
        focused,
        triggerFocus,
        lastOperation,
        activeIndex,
        setActiveIndex,
        nextActiveIndex,
        activeListRef.current,
        updateSubmitIndex,
        hasActiveSubmitValue
    ];
}

},{"react":"bmhQu","./useLockEffect":"6NbwG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6NbwG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useLockEffect);
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _react = require("react");
function useLockEffect(condition, callback) {
    var delayFrames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var callbackRef = _react.useRef(callback);
    callbackRef.current = callback;
    (0, _useLayoutEffect.useLayoutUpdateEffect)(function() {
        if (condition) callbackRef.current(condition);
        else {
            var id = (0, _rafDefault.default)(function() {
                callbackRef.current(condition);
            }, delayFrames);
            return function() {
                (0, _rafDefault.default).cancel(id);
            };
        }
    }, [
        condition
    ]);
}

},{"@rc-component/util/es/hooks/useLayoutEffect":"azwns","@rc-component/util/es/raf":"ajbAx","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5Znt2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRangeDisabledDate);
var _dateUtil = require("../../utils/dateUtil");
var _miscUtil = require("../../utils/miscUtil");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useRangeDisabledDate(values, disabled, activeIndexList, generateConfig, locale, disabledDate) {
    var activeIndex = activeIndexList[activeIndexList.length - 1];
    var rangeDisabledDate = function rangeDisabledDate(date, info) {
        var _values = _slicedToArray(values, 2), start = _values[0], end = _values[1];
        var mergedInfo = _objectSpread(_objectSpread({}, info), {}, {
            from: (0, _miscUtil.getFromDate)(values, activeIndexList)
        });
        // ============================ Disabled ============================
        // Should not select days before the start date
        if (activeIndex === 1 && disabled[0] && start && // Same date isOK
        !(0, _dateUtil.isSame)(generateConfig, locale, start, date, mergedInfo.type) && // Before start date
        generateConfig.isAfter(start, date)) return true;
        // Should not select days after the end date
        if (activeIndex === 0 && disabled[1] && end && // Same date isOK
        !(0, _dateUtil.isSame)(generateConfig, locale, end, date, mergedInfo.type) && // After end date
        generateConfig.isAfter(date, end)) return true;
        // ============================= Origin =============================
        return disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date, mergedInfo);
    };
    return rangeDisabledDate;
}

},{"../../utils/dateUtil":"gSKz6","../../utils/miscUtil":"2yPUL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"75Bgy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "offsetPanelDate", ()=>offsetPanelDate);
parcelHelpers.export(exports, "default", ()=>useRangePickerValue);
var _util = require("@rc-component/util");
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _react = require("react");
var _dateUtil = require("../../utils/dateUtil");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function offsetPanelDate(generateConfig, picker, date, offset) {
    switch(picker){
        case 'date':
        case 'week':
            return generateConfig.addMonth(date, offset);
        case 'month':
        case 'quarter':
            return generateConfig.addYear(date, offset);
        case 'year':
            return generateConfig.addYear(date, offset * 10);
        case 'decade':
            return generateConfig.addYear(date, offset * 100);
        default:
            return date;
    }
}
var EMPTY_LIST = [];
function useRangePickerValue(generateConfig, locale, calendarValue, modes, open, activeIndex, pickerMode, multiplePanel) {
    var defaultPickerValue = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : EMPTY_LIST;
    var pickerValue = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : EMPTY_LIST;
    var timeDefaultValue = arguments.length > 10 && arguments[10] !== undefined ? arguments[10] : EMPTY_LIST;
    var onPickerValueChange = arguments.length > 11 ? arguments[11] : undefined;
    var minDate = arguments.length > 12 ? arguments[12] : undefined;
    var maxDate = arguments.length > 13 ? arguments[13] : undefined;
    var isTimePicker = pickerMode === 'time';
    // ======================== Active ========================
    // `activeIndex` must be valid to avoid getting empty `pickerValue`
    var mergedActiveIndex = activeIndex || 0;
    // ===================== Picker Value =====================
    var getDefaultPickerValue = function getDefaultPickerValue(index) {
        var now = generateConfig.getNow();
        if (isTimePicker) now = (0, _dateUtil.fillTime)(generateConfig, now);
        return defaultPickerValue[index] || calendarValue[index] || now;
    };
    // Align `pickerValue` with `showTime.defaultValue`
    var _pickerValue = _slicedToArray(pickerValue, 2), startPickerValue = _pickerValue[0], endPickerValue = _pickerValue[1];
    // PickerValue state
    var _useControlledState = (0, _util.useControlledState)(function() {
        return getDefaultPickerValue(0);
    }, startPickerValue), _useControlledState2 = _slicedToArray(_useControlledState, 2), mergedStartPickerValue = _useControlledState2[0], setStartPickerValue = _useControlledState2[1];
    var _useControlledState3 = (0, _util.useControlledState)(function() {
        return getDefaultPickerValue(1);
    }, endPickerValue), _useControlledState4 = _slicedToArray(_useControlledState3, 2), mergedEndPickerValue = _useControlledState4[0], setEndPickerValue = _useControlledState4[1];
    // Current PickerValue
    var currentPickerValue = _react.useMemo(function() {
        var current = [
            mergedStartPickerValue,
            mergedEndPickerValue
        ][mergedActiveIndex];
        // Merge the `showTime.defaultValue` into `pickerValue`
        return isTimePicker ? current : (0, _dateUtil.fillTime)(generateConfig, current, timeDefaultValue[mergedActiveIndex]);
    }, [
        isTimePicker,
        mergedStartPickerValue,
        mergedEndPickerValue,
        mergedActiveIndex,
        generateConfig,
        timeDefaultValue
    ]);
    var setCurrentPickerValue = function setCurrentPickerValue(nextPickerValue) {
        var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'panel';
        var updater = [
            setStartPickerValue,
            setEndPickerValue
        ][mergedActiveIndex];
        updater(nextPickerValue);
        var clone = [
            mergedStartPickerValue,
            mergedEndPickerValue
        ];
        clone[mergedActiveIndex] = nextPickerValue;
        if (onPickerValueChange && (!(0, _dateUtil.isSame)(generateConfig, locale, mergedStartPickerValue, clone[0], pickerMode) || !(0, _dateUtil.isSame)(generateConfig, locale, mergedEndPickerValue, clone[1], pickerMode))) onPickerValueChange(clone, {
            source: source,
            range: mergedActiveIndex === 1 ? 'end' : 'start',
            mode: modes
        });
    };
    // ======================== Effect ========================
    /**
   * EndDate pickerValue is little different. It should be:
   * - If date picker (without time), endDate is not same year & month as startDate
   *   - pickerValue minus one month
   * - Else pass directly
   */ var getEndDatePickerValue = function getEndDatePickerValue(startDate, endDate) {
        if (multiplePanel) {
            // Basic offset
            var SAME_CHECKER = {
                date: 'month',
                week: 'month',
                month: 'year',
                quarter: 'year'
            };
            var mode = SAME_CHECKER[pickerMode];
            if (mode && !(0, _dateUtil.isSame)(generateConfig, locale, startDate, endDate, mode)) return offsetPanelDate(generateConfig, pickerMode, endDate, -1);
            // Year offset
            if (pickerMode === 'year' && startDate) {
                var srcYear = Math.floor(generateConfig.getYear(startDate) / 10);
                var tgtYear = Math.floor(generateConfig.getYear(endDate) / 10);
                if (srcYear !== tgtYear) return offsetPanelDate(generateConfig, pickerMode, endDate, -1);
            }
        }
        return endDate;
    };
    // >>> When switch field, reset the picker value as prev field picker value
    var prevActiveIndexRef = _react.useRef(null);
    (0, _useLayoutEffectDefault.default)(function() {
        if (open) {
            if (!defaultPickerValue[mergedActiveIndex]) {
                var nextPickerValue = isTimePicker ? null : generateConfig.getNow();
                /**
         * 1. If has prevActiveIndex, use it to avoid panel jump
         * 2. If current field has value
         *    - If `activeIndex` is 1 and `calendarValue[0]` is not same panel as `calendarValue[1]`,
         *      offset `calendarValue[1]` and set it
         *    - Else use `calendarValue[activeIndex]`
         * 3. If current field has no value but another field has value, use another field value
         * 4. Else use now (not any `calendarValue` can ref)
         */ if (prevActiveIndexRef.current !== null && prevActiveIndexRef.current !== mergedActiveIndex) // If from another field, not jump picker value
                nextPickerValue = [
                    mergedStartPickerValue,
                    mergedEndPickerValue
                ][mergedActiveIndex ^ 1];
                else if (calendarValue[mergedActiveIndex]) // Current field has value
                nextPickerValue = mergedActiveIndex === 0 ? calendarValue[0] : getEndDatePickerValue(calendarValue[0], calendarValue[1]);
                else if (calendarValue[mergedActiveIndex ^ 1]) // Current field has no value but another field has value
                nextPickerValue = calendarValue[mergedActiveIndex ^ 1];
                // Only sync when has value, this will sync in the `min-max` logic
                if (nextPickerValue) {
                    // nextPickerValue < minDate
                    if (minDate && generateConfig.isAfter(minDate, nextPickerValue)) nextPickerValue = minDate;
                    // maxDate < nextPickerValue
                    var offsetPickerValue = multiplePanel ? offsetPanelDate(generateConfig, pickerMode, nextPickerValue, 1) : nextPickerValue;
                    if (maxDate && generateConfig.isAfter(offsetPickerValue, maxDate)) nextPickerValue = multiplePanel ? offsetPanelDate(generateConfig, pickerMode, maxDate, -1) : maxDate;
                    setCurrentPickerValue(nextPickerValue, 'reset');
                }
            }
        }
    }, [
        open,
        mergedActiveIndex,
        calendarValue[mergedActiveIndex]
    ]);
    // >>> Reset prevActiveIndex when panel closed
    _react.useEffect(function() {
        if (open) prevActiveIndexRef.current = mergedActiveIndex;
        else prevActiveIndexRef.current = null;
    }, [
        open,
        mergedActiveIndex
    ]);
    // >>> defaultPickerValue: Resync to `defaultPickerValue` for each panel focused
    (0, _useLayoutEffectDefault.default)(function() {
        if (open && defaultPickerValue) {
            if (defaultPickerValue[mergedActiveIndex]) setCurrentPickerValue(defaultPickerValue[mergedActiveIndex], 'reset');
        }
    }, [
        open,
        mergedActiveIndex
    ]);
    return [
        currentPickerValue,
        setCurrentPickerValue
    ];
}

},{"@rc-component/util":"6ZBDN","@rc-component/util/es/hooks/useLayoutEffect":"azwns","react":"bmhQu","../../utils/dateUtil":"gSKz6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ddux0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Control the internal `value` align with prop `value` and provide a temp `calendarValue` for ui.
 * `calendarValue` will be reset when blur & focus & open.
 */ parcelHelpers.export(exports, "useInnerValue", ()=>useInnerValue);
parcelHelpers.export(exports, "default", ()=>useRangeValue);
var _util = require("@rc-component/util");
var _react = require("react");
var _useSyncState = require("../../hooks/useSyncState");
var _useSyncStateDefault = parcelHelpers.interopDefault(_useSyncState);
var _dateUtil = require("../../utils/dateUtil");
var _miscUtil = require("../../utils/miscUtil");
var _useLockEffect = require("./useLockEffect");
var _useLockEffectDefault = parcelHelpers.interopDefault(_useLockEffect);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var EMPTY_VALUE = [];
// Submit Logic:
// * ✅ Value:
//    * merged value using controlled value, if not, use stateValue
//    * When merged value change, [1] resync calendar value and submit value
// * ✅ Calender Value:
//    * 💻 When user typing is validate, change the calendar value
//    * 🌅 When user click on the panel, change the calendar value
// * Submit Value:
//    * 💻 When user blur the input, flush calendar value to submit value
//    * 🌅 When user click on the panel is no needConfirm, flush calendar value to submit value
//    * 🌅 When user click on the panel is needConfirm and click OK, flush calendar value to submit value
// * Blur logic & close logic:
//    * ✅ For value, always try flush submit
//    * ✅ If `needConfirm`, reset as [1]
//    * Else (`!needConfirm`)
//      * If has another index field, active another index
// * ✅ Flush submit:
//    * If all the start & end field is confirmed or all blur or panel closed
//    * Update `needSubmit` mark to true
//    * trigger onChange by `needSubmit` and update stateValue
function useUtil(generateConfig, locale, formatList) {
    var getDateTexts = function getDateTexts(dates) {
        return dates.map(function(date) {
            return (0, _dateUtil.formatValue)(date, {
                generateConfig: generateConfig,
                locale: locale,
                format: formatList[0]
            });
        });
    };
    var isSameDates = function isSameDates(source, target) {
        var maxLen = Math.max(source.length, target.length);
        var diffIndex = -1;
        for(var i = 0; i < maxLen; i += 1){
            var prev = source[i] || null;
            var next = target[i] || null;
            if (prev !== next && !(0, _dateUtil.isSameTimestamp)(generateConfig, prev, next)) {
                diffIndex = i;
                break;
            }
        }
        return [
            diffIndex < 0,
            diffIndex !== 0
        ];
    };
    return [
        getDateTexts,
        isSameDates
    ];
}
function orderDates(dates, generateConfig) {
    return _toConsumableArray(dates).sort(function(a, b) {
        return generateConfig.isAfter(a, b) ? 1 : -1;
    });
}
/**
 * Used for internal value management.
 * It should always use `mergedValue` in render logic
 */ function useCalendarValue(mergedValue) {
    var _useSyncState = (0, _useSyncStateDefault.default)(mergedValue), _useSyncState2 = _slicedToArray(_useSyncState, 2), calendarValue = _useSyncState2[0], setCalendarValue = _useSyncState2[1];
    /** Sync calendarValue & submitValue back with value */ var syncWithValue = (0, _util.useEvent)(function() {
        setCalendarValue(mergedValue);
    });
    _react.useEffect(function() {
        syncWithValue();
    }, [
        mergedValue
    ]);
    return [
        calendarValue,
        setCalendarValue
    ];
}
function useInnerValue(generateConfig, locale, formatList, /** Used for RangePicker. `true` means [DateType, DateType] or will be DateType[] */ rangeValue, /**
 * Trigger order when trigger calendar value change.
 * This should only used in SinglePicker with `multiple` mode.
 * So when `rangeValue` is `true`, order will be ignored.
 */ order, defaultValue, value, onCalendarChange, onOk) {
    // This is the root value which will sync with controlled or uncontrolled value
    var _useControlledState = (0, _util.useControlledState)(defaultValue, value), _useControlledState2 = _slicedToArray(_useControlledState, 2), innerValue = _useControlledState2[0], setInnerValue = _useControlledState2[1];
    var mergedValue = innerValue || EMPTY_VALUE;
    // ========================= Inner Values =========================
    var _useCalendarValue = useCalendarValue(mergedValue), _useCalendarValue2 = _slicedToArray(_useCalendarValue, 2), calendarValue = _useCalendarValue2[0], setCalendarValue = _useCalendarValue2[1];
    // ============================ Change ============================
    var _useUtil = useUtil(generateConfig, locale, formatList), _useUtil2 = _slicedToArray(_useUtil, 2), getDateTexts = _useUtil2[0], isSameDates = _useUtil2[1];
    var triggerCalendarChange = (0, _util.useEvent)(function(nextCalendarValues) {
        var clone = _toConsumableArray(nextCalendarValues);
        if (rangeValue) for(var i = 0; i < 2; i += 1)clone[i] = clone[i] || null;
        else if (order) clone = orderDates(clone.filter(function(date) {
            return date;
        }), generateConfig);
        // Update merged value
        var _isSameDates = isSameDates(calendarValue(), clone), _isSameDates2 = _slicedToArray(_isSameDates, 2), isSameMergedDates = _isSameDates2[0], isSameStart = _isSameDates2[1];
        if (!isSameMergedDates) {
            setCalendarValue(clone);
            // Trigger calendar change event
            if (onCalendarChange) {
                var cellTexts = getDateTexts(clone);
                onCalendarChange(clone, cellTexts, {
                    range: isSameStart ? 'end' : 'start'
                });
            }
        }
    });
    var triggerOk = function triggerOk() {
        if (onOk) onOk(calendarValue());
    };
    return [
        mergedValue,
        setInnerValue,
        calendarValue,
        triggerCalendarChange,
        triggerOk
    ];
}
function useRangeValue(info, mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, disabled, formatList, focused, open, isInvalidateDate) {
    var generateConfig = info.generateConfig, locale = info.locale, picker = info.picker, onChange = info.onChange, allowEmpty = info.allowEmpty, order = info.order;
    var orderOnChange = disabled.some(function(d) {
        return d;
    }) ? false : order;
    // ============================= Util =============================
    var _useUtil3 = useUtil(generateConfig, locale, formatList), _useUtil4 = _slicedToArray(_useUtil3, 2), getDateTexts = _useUtil4[0], isSameDates = _useUtil4[1];
    // ============================ Values ============================
    // Used for trigger `onChange` event.
    // Record current value which is wait for submit.
    var _useSyncState3 = (0, _useSyncStateDefault.default)(mergedValue), _useSyncState4 = _slicedToArray(_useSyncState3, 2), submitValue = _useSyncState4[0], setSubmitValue = _useSyncState4[1];
    /** Sync calendarValue & submitValue back with value */ var syncWithValue = (0, _util.useEvent)(function() {
        setSubmitValue(mergedValue);
    });
    _react.useEffect(function() {
        syncWithValue();
    }, [
        mergedValue
    ]);
    // ============================ Submit ============================
    var triggerSubmit = (0, _util.useEvent)(function(nextValue) {
        var isNullValue = nextValue === null;
        var clone = _toConsumableArray(nextValue || submitValue());
        // Fill null value
        if (isNullValue) {
            var maxLen = Math.max(disabled.length, clone.length);
            for(var i = 0; i < maxLen; i += 1)if (!disabled[i]) clone[i] = null;
        }
        // Only when exist value to sort
        if (orderOnChange && clone[0] && clone[1]) clone = orderDates(clone, generateConfig);
        // Sync `calendarValue`
        triggerCalendarChange(clone);
        // ========= Validate check =========
        var _clone = clone, _clone2 = _slicedToArray(_clone, 2), start = _clone2[0], end = _clone2[1];
        // >>> Empty
        var startEmpty = !start;
        var endEmpty = !end;
        var validateEmptyDateRange = allowEmpty ? // Validate empty start
        (!startEmpty || allowEmpty[0]) && // Validate empty end
        (!endEmpty || allowEmpty[1]) : true;
        // >>> Order
        var validateOrder = !order || startEmpty || endEmpty || (0, _dateUtil.isSame)(generateConfig, locale, start, end, picker) || generateConfig.isAfter(end, start);
        // >>> Invalid
        var validateDates = // Validate start
        (disabled[0] || !start || !isInvalidateDate(start, {
            activeIndex: 0
        })) && // Validate end
        (disabled[1] || !end || !isInvalidateDate(end, {
            from: start,
            activeIndex: 1
        }));
        // >>> Result
        var allPassed = // Null value is from clear button
        isNullValue || // Normal check
        validateEmptyDateRange && validateOrder && validateDates;
        if (allPassed) {
            // Sync value with submit value
            setInnerValue(clone);
            var _isSameDates3 = isSameDates(clone, mergedValue), _isSameDates4 = _slicedToArray(_isSameDates3, 1), isSameMergedDates = _isSameDates4[0];
            // Trigger `onChange` if needed
            if (onChange && !isSameMergedDates) {
                var everyEmpty = clone.every(function(val) {
                    return !val;
                });
                onChange(// Return null directly if all date are empty
                isNullValue && everyEmpty ? null : clone, everyEmpty ? null : getDateTexts(clone));
            }
        }
        return allPassed;
    });
    // ========================= Flush Submit =========================
    var flushSubmit = (0, _util.useEvent)(function(index, needTriggerChange) {
        var nextSubmitValue = (0, _miscUtil.fillIndex)(submitValue(), index, getCalendarValue()[index]);
        setSubmitValue(nextSubmitValue);
        if (needTriggerChange) triggerSubmit();
    });
    // ============================ Effect ============================
    // All finished action trigger after 2 frames
    var interactiveFinished = !focused && !open;
    (0, _useLockEffectDefault.default)(!interactiveFinished, function() {
        if (interactiveFinished) {
            // Always try to trigger submit first
            triggerSubmit();
            // Trigger calendar change since this is a effect reset
            // https://github.com/ant-design/ant-design/issues/22351
            triggerCalendarChange(mergedValue);
            // Sync with value anyway
            syncWithValue();
        }
    }, 2);
    // ============================ Return ============================
    return [
        flushSubmit,
        triggerSubmit
    ];
}

},{"@rc-component/util":"6ZBDN","react":"bmhQu","../../hooks/useSyncState":"2Sxb8","../../utils/dateUtil":"gSKz6","../../utils/miscUtil":"2yPUL","./useLockEffect":"6NbwG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Sxb8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSyncState);
var _react = require("react");
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function useSyncState(defaultValue, controlledValue) {
    var valueRef = _react.useRef(defaultValue);
    var _React$useState = _react.useState({}), _React$useState2 = _slicedToArray(_React$useState, 2), forceUpdate = _React$useState2[1];
    var getter = function getter(useControlledValueFirst) {
        return useControlledValueFirst && controlledValue !== undefined ? controlledValue : valueRef.current;
    };
    var setter = function setter(nextValue) {
        valueRef.current = nextValue;
        forceUpdate({});
    };
    return [
        getter,
        setter,
        getter(true)
    ];
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3o1XX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useShowNow);
function useShowNow(picker, mode, showNow, showToday, rangePicker) {
    if (mode !== 'date' && mode !== 'time') return false;
    if (showNow !== undefined) return showNow;
    // Compatible with old version `showToday`
    if (showToday !== undefined) return showToday;
    return !rangePicker && (picker === 'date' || picker === 'time');
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h3ENZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Popup);
var _clsx = require("clsx");
var _resizeObserver = require("@rc-component/resize-observer");
var _resizeObserverDefault = parcelHelpers.interopDefault(_resizeObserver);
var _react = require("react");
var _miscUtil = require("../../utils/miscUtil");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _footer = require("./Footer");
var _footerDefault = parcelHelpers.interopDefault(_footer);
var _popupPanel = require("./PopupPanel");
var _popupPanelDefault = parcelHelpers.interopDefault(_popupPanel);
var _presetPanel = require("./PresetPanel");
var _presetPanelDefault = parcelHelpers.interopDefault(_presetPanel);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Popup(props) {
    var _classNames$popup, _styles$popup;
    var panelRender = props.panelRender, internalMode = props.internalMode, picker = props.picker, showNow = props.showNow, range = props.range, multiple = props.multiple, _props$activeInfo = props.activeInfo, activeInfo = _props$activeInfo === void 0 ? [
        0,
        0,
        0
    ] : _props$activeInfo, presets = props.presets, onPresetHover = props.onPresetHover, onPresetSubmit = props.onPresetSubmit, onFocus = props.onFocus, onBlur = props.onBlur, onPanelMouseDown = props.onPanelMouseDown, direction = props.direction, value = props.value, onSelect = props.onSelect, isInvalid = props.isInvalid, defaultOpenValue = props.defaultOpenValue, onOk = props.onOk, onSubmit = props.onSubmit, classNames = props.classNames, styles = props.styles;
    var _React$useContext = _react.useContext((0, _contextDefault.default)), prefixCls = _React$useContext.prefixCls;
    var panelPrefixCls = "".concat(prefixCls, "-panel");
    var rtl = direction === 'rtl';
    // ========================= Refs =========================
    var arrowRef = _react.useRef(null);
    var wrapperRef = _react.useRef(null);
    // ======================== Offset ========================
    var _React$useState = _react.useState(0), _React$useState2 = _slicedToArray(_React$useState, 2), containerWidth = _React$useState2[0], setContainerWidth = _React$useState2[1];
    var _React$useState3 = _react.useState(0), _React$useState4 = _slicedToArray(_React$useState3, 2), containerOffset = _React$useState4[0], setContainerOffset = _React$useState4[1];
    var _React$useState5 = _react.useState(0), _React$useState6 = _slicedToArray(_React$useState5, 2), arrowOffset = _React$useState6[0], setArrowOffset = _React$useState6[1];
    var onResize = function onResize(info) {
        if (info.width) setContainerWidth(info.width);
    };
    var _activeInfo = _slicedToArray(activeInfo, 3), activeInputLeft = _activeInfo[0], activeInputRight = _activeInfo[1], selectorWidth = _activeInfo[2];
    var _React$useState7 = _react.useState(0), _React$useState8 = _slicedToArray(_React$useState7, 2), retryTimes = _React$useState8[0], setRetryTimes = _React$useState8[1];
    _react.useEffect(function() {
        setRetryTimes(10);
    }, [
        activeInputLeft
    ]);
    _react.useEffect(function() {
        // `activeOffset` is always align with the active input element
        // So we need only check container contains the `activeOffset`
        if (range && wrapperRef.current) {
            var _arrowRef$current;
            // Offset in case container has border radius
            var arrowWidth = ((_arrowRef$current = arrowRef.current) === null || _arrowRef$current === void 0 ? void 0 : _arrowRef$current.offsetWidth) || 0;
            // Arrow Offset
            var wrapperRect = wrapperRef.current.getBoundingClientRect();
            if (!wrapperRect.height || wrapperRect.right < 0) {
                setRetryTimes(function(times) {
                    return Math.max(0, times - 1);
                });
                return;
            }
            var nextArrowOffset = (rtl ? activeInputRight - arrowWidth : activeInputLeft) - wrapperRect.left;
            setArrowOffset(nextArrowOffset);
            // Container Offset
            if (containerWidth && containerWidth < selectorWidth) {
                var offset = rtl ? wrapperRect.right - (activeInputRight - arrowWidth + containerWidth) : activeInputLeft + arrowWidth - wrapperRect.left - containerWidth;
                var safeOffset = Math.max(0, offset);
                setContainerOffset(safeOffset);
            } else setContainerOffset(0);
        }
    }, [
        retryTimes,
        rtl,
        containerWidth,
        activeInputLeft,
        activeInputRight,
        selectorWidth,
        range
    ]);
    // ======================== Custom ========================
    function filterEmpty(list) {
        return list.filter(function(item) {
            return item;
        });
    }
    var valueList = _react.useMemo(function() {
        return filterEmpty((0, _miscUtil.toArray)(value));
    }, [
        value
    ]);
    var isTimePickerEmptyValue = picker === 'time' && !valueList.length;
    var footerSubmitValue = _react.useMemo(function() {
        if (isTimePickerEmptyValue) return filterEmpty([
            defaultOpenValue
        ]);
        return valueList;
    }, [
        isTimePickerEmptyValue,
        valueList,
        defaultOpenValue
    ]);
    var popupPanelValue = isTimePickerEmptyValue ? defaultOpenValue : valueList;
    var disableSubmit = _react.useMemo(function() {
        // Empty is invalid
        if (!footerSubmitValue.length) return true;
        return footerSubmitValue.some(function(val) {
            return isInvalid(val);
        });
    }, [
        footerSubmitValue,
        isInvalid
    ]);
    var onFooterSubmit = function onFooterSubmit() {
        // For TimePicker, we will additional trigger the value update
        if (isTimePickerEmptyValue) onSelect(defaultOpenValue);
        onOk();
        onSubmit();
    };
    var mergedNodes = /*#__PURE__*/ _react.createElement("div", {
        className: "".concat(prefixCls, "-panel-layout")
    }, /*#__PURE__*/ _react.createElement((0, _presetPanelDefault.default), {
        prefixCls: prefixCls,
        presets: presets,
        onClick: onPresetSubmit,
        onHover: onPresetHover
    }), /*#__PURE__*/ _react.createElement("div", null, /*#__PURE__*/ _react.createElement((0, _popupPanelDefault.default), _extends({}, props, {
        value: popupPanelValue
    })), /*#__PURE__*/ _react.createElement((0, _footerDefault.default), _extends({}, props, {
        showNow: multiple ? false : showNow,
        invalid: disableSubmit,
        onSubmit: onFooterSubmit
    }))));
    if (panelRender) mergedNodes = panelRender(mergedNodes);
    // ======================== Render ========================
    var containerPrefixCls = "".concat(panelPrefixCls, "-container");
    var marginLeft = 'marginLeft';
    var marginRight = 'marginRight';
    // Container
    var renderNode = /*#__PURE__*/ _react.createElement("div", {
        onMouseDown: onPanelMouseDown,
        tabIndex: -1,
        className: (0, _clsx.clsx)(containerPrefixCls, "".concat(prefixCls, "-").concat(internalMode, "-panel-container"), classNames === null || classNames === void 0 || (_classNames$popup = classNames.popup) === null || _classNames$popup === void 0 ? void 0 : _classNames$popup.container),
        style: _objectSpread(_defineProperty(_defineProperty({}, rtl ? marginRight : marginLeft, containerOffset), rtl ? marginLeft : marginRight, 'auto'), styles === null || styles === void 0 || (_styles$popup = styles.popup) === null || _styles$popup === void 0 ? void 0 : _styles$popup.container),
        onFocus: onFocus,
        onBlur: onBlur
    }, mergedNodes);
    if (range) renderNode = /*#__PURE__*/ _react.createElement("div", {
        onMouseDown: onPanelMouseDown,
        ref: wrapperRef,
        className: (0, _clsx.clsx)("".concat(prefixCls, "-range-wrapper"), "".concat(prefixCls, "-").concat(picker, "-range-wrapper"))
    }, /*#__PURE__*/ _react.createElement("div", {
        ref: arrowRef,
        className: "".concat(prefixCls, "-range-arrow"),
        style: {
            left: arrowOffset
        }
    }), /*#__PURE__*/ _react.createElement((0, _resizeObserverDefault.default), {
        onResize: onResize
    }, renderNode));
    return renderNode;
}

},{"clsx":"431Ou","@rc-component/resize-observer":"4dgtN","react":"bmhQu","../../utils/miscUtil":"2yPUL","../context":"afG3N","./Footer":"ed0IX","./PopupPanel":"UBvta","./PresetPanel":"3XqCZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ed0IX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Footer);
var _clsx = require("clsx");
var _react = require("react");
var _useTimeInfo = require("../../hooks/useTimeInfo");
var _useTimeInfoDefault = parcelHelpers.interopDefault(_useTimeInfo);
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function Footer(props) {
    var mode = props.mode, internalMode = props.internalMode, renderExtraFooter = props.renderExtraFooter, showNow = props.showNow, showTime = props.showTime, onSubmit = props.onSubmit, onNow = props.onNow, invalid = props.invalid, needConfirm = props.needConfirm, generateConfig = props.generateConfig, disabledDate = props.disabledDate;
    var _React$useContext = _react.useContext((0, _contextDefault.default)), prefixCls = _React$useContext.prefixCls, locale = _React$useContext.locale, _React$useContext$but = _React$useContext.button, Button = _React$useContext$but === void 0 ? 'button' : _React$useContext$but, classNames = _React$useContext.classNames, styles = _React$useContext.styles;
    // >>> Now
    var now = generateConfig.getNow();
    var _useTimeInfo = (0, _useTimeInfoDefault.default)(generateConfig, showTime, now), _useTimeInfo2 = _slicedToArray(_useTimeInfo, 1), getValidTime = _useTimeInfo2[0];
    // ======================== Extra =========================
    var extraNode = renderExtraFooter === null || renderExtraFooter === void 0 ? void 0 : renderExtraFooter(mode);
    // ======================== Ranges ========================
    var nowDisabled = disabledDate(now, {
        type: mode
    });
    var onInternalNow = function onInternalNow() {
        if (!nowDisabled) {
            var validateNow = getValidTime(now);
            onNow(validateNow);
        }
    };
    var nowPrefixCls = "".concat(prefixCls, "-now");
    var nowBtnPrefixCls = "".concat(nowPrefixCls, "-btn");
    var presetNode = showNow && /*#__PURE__*/ _react.createElement("li", {
        className: nowPrefixCls
    }, /*#__PURE__*/ _react.createElement("a", {
        className: (0, _clsx.clsx)(nowBtnPrefixCls, nowDisabled && "".concat(nowBtnPrefixCls, "-disabled")),
        "aria-disabled": nowDisabled,
        onClick: onInternalNow
    }, internalMode === 'date' ? locale.today : locale.now));
    // >>> OK
    var okNode = needConfirm && /*#__PURE__*/ _react.createElement("li", {
        className: "".concat(prefixCls, "-ok")
    }, /*#__PURE__*/ _react.createElement(Button, {
        disabled: invalid,
        onClick: onSubmit
    }, locale.ok));
    var rangeNode = (presetNode || okNode) && /*#__PURE__*/ _react.createElement("ul", {
        className: "".concat(prefixCls, "-ranges")
    }, presetNode, okNode);
    // ======================== Render ========================
    if (!extraNode && !rangeNode) return null;
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)("".concat(prefixCls, "-footer"), classNames.popup.footer),
        style: styles.popup.footer
    }, extraNode && /*#__PURE__*/ _react.createElement("div", {
        className: "".concat(prefixCls, "-footer-extra")
    }, extraNode), rangeNode);
}

},{"clsx":"431Ou","react":"bmhQu","../../hooks/useTimeInfo":"jcxgQ","../context":"afG3N","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jcxgQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useTimeInfo);
var _util = require("@rc-component/util");
var _react = require("react");
var _util1 = require("../PickerPanel/TimePanel/TimePanelBody/util");
var _miscUtil = require("../utils/miscUtil");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function emptyDisabled() {
    return [];
}
function generateUnits(start, end) {
    var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
    var hideDisabledOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var disabledUnits = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
    var pad = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 2;
    var units = [];
    var integerStep = step >= 1 ? step | 0 : 1;
    for(var i = start; i <= end; i += integerStep){
        var disabled = disabledUnits.includes(i);
        if (!disabled || !hideDisabledOptions) units.push({
            label: (0, _miscUtil.leftPad)(i, pad),
            value: i,
            disabled: disabled
        });
    }
    return units;
}
function useTimeInfo(generateConfig) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var date = arguments.length > 2 ? arguments[2] : undefined;
    var _ref = props || {}, use12Hours = _ref.use12Hours, _ref$hourStep = _ref.hourStep, hourStep = _ref$hourStep === void 0 ? 1 : _ref$hourStep, _ref$minuteStep = _ref.minuteStep, minuteStep = _ref$minuteStep === void 0 ? 1 : _ref$minuteStep, _ref$secondStep = _ref.secondStep, secondStep = _ref$secondStep === void 0 ? 1 : _ref$secondStep, _ref$millisecondStep = _ref.millisecondStep, millisecondStep = _ref$millisecondStep === void 0 ? 100 : _ref$millisecondStep, hideDisabledOptions = _ref.hideDisabledOptions, disabledTime = _ref.disabledTime, disabledHours = _ref.disabledHours, disabledMinutes = _ref.disabledMinutes, disabledSeconds = _ref.disabledSeconds;
    var mergedDate = _react.useMemo(function() {
        return date || generateConfig.getNow();
    }, [
        date,
        generateConfig
    ]);
    var isHourStepValid, isMinuteStepValid, isSecondStepValid;
    // ======================== Disabled ========================
    var getDisabledTimes = _react.useCallback(function(targetDate) {
        var disabledConfig = (disabledTime === null || disabledTime === void 0 ? void 0 : disabledTime(targetDate)) || {};
        return [
            disabledConfig.disabledHours || disabledHours || emptyDisabled,
            disabledConfig.disabledMinutes || disabledMinutes || emptyDisabled,
            disabledConfig.disabledSeconds || disabledSeconds || emptyDisabled,
            disabledConfig.disabledMilliseconds || emptyDisabled
        ];
    }, [
        disabledTime,
        disabledHours,
        disabledMinutes,
        disabledSeconds
    ]);
    var _React$useMemo = _react.useMemo(function() {
        return getDisabledTimes(mergedDate);
    }, [
        mergedDate,
        getDisabledTimes
    ]), _React$useMemo2 = _slicedToArray(_React$useMemo, 4), mergedDisabledHours = _React$useMemo2[0], mergedDisabledMinutes = _React$useMemo2[1], mergedDisabledSeconds = _React$useMemo2[2], mergedDisabledMilliseconds = _React$useMemo2[3];
    // ========================= Column =========================
    var getAllUnits = _react.useCallback(function(getDisabledHours, getDisabledMinutes, getDisabledSeconds, getDisabledMilliseconds) {
        var hours = generateUnits(0, 23, hourStep, hideDisabledOptions, getDisabledHours());
        // Hours
        var rowHourUnits = use12Hours ? hours.map(function(unit) {
            return _objectSpread(_objectSpread({}, unit), {}, {
                label: (0, _miscUtil.leftPad)(unit.value % 12 || 12, 2)
            });
        }) : hours;
        // Minutes
        var getMinuteUnits = function getMinuteUnits(nextHour) {
            return generateUnits(0, 59, minuteStep, hideDisabledOptions, getDisabledMinutes(nextHour));
        };
        // Seconds
        var getSecondUnits = function getSecondUnits(nextHour, nextMinute) {
            return generateUnits(0, 59, secondStep, hideDisabledOptions, getDisabledSeconds(nextHour, nextMinute));
        };
        // Milliseconds
        var getMillisecondUnits = function getMillisecondUnits(nextHour, nextMinute, nextSecond) {
            return generateUnits(0, 999, millisecondStep, hideDisabledOptions, getDisabledMilliseconds(nextHour, nextMinute, nextSecond), 3);
        };
        return [
            rowHourUnits,
            getMinuteUnits,
            getSecondUnits,
            getMillisecondUnits
        ];
    }, [
        hideDisabledOptions,
        hourStep,
        use12Hours,
        millisecondStep,
        minuteStep,
        secondStep
    ]);
    var _React$useMemo3 = _react.useMemo(function() {
        return getAllUnits(mergedDisabledHours, mergedDisabledMinutes, mergedDisabledSeconds, mergedDisabledMilliseconds);
    }, [
        getAllUnits,
        mergedDisabledHours,
        mergedDisabledMinutes,
        mergedDisabledSeconds,
        mergedDisabledMilliseconds
    ]), _React$useMemo4 = _slicedToArray(_React$useMemo3, 4), rowHourUnits = _React$useMemo4[0], getMinuteUnits = _React$useMemo4[1], getSecondUnits = _React$useMemo4[2], getMillisecondUnits = _React$useMemo4[3];
    // ======================== Validate ========================
    /**
   * Get validate time with `disabledTime`, `certainDate` to specific the date need to check
   */ var getValidTime = function getValidTime(nextTime, certainDate) {
        var getCheckHourUnits = function getCheckHourUnits() {
            return rowHourUnits;
        };
        var getCheckMinuteUnits = getMinuteUnits;
        var getCheckSecondUnits = getSecondUnits;
        var getCheckMillisecondUnits = getMillisecondUnits;
        if (certainDate) {
            var _getDisabledTimes = getDisabledTimes(certainDate), _getDisabledTimes2 = _slicedToArray(_getDisabledTimes, 4), targetDisabledHours = _getDisabledTimes2[0], targetDisabledMinutes = _getDisabledTimes2[1], targetDisabledSeconds = _getDisabledTimes2[2], targetDisabledMilliseconds = _getDisabledTimes2[3];
            var _getAllUnits = getAllUnits(targetDisabledHours, targetDisabledMinutes, targetDisabledSeconds, targetDisabledMilliseconds), _getAllUnits2 = _slicedToArray(_getAllUnits, 4), targetRowHourUnits = _getAllUnits2[0], targetGetMinuteUnits = _getAllUnits2[1], targetGetSecondUnits = _getAllUnits2[2], targetGetMillisecondUnits = _getAllUnits2[3];
            getCheckHourUnits = function getCheckHourUnits() {
                return targetRowHourUnits;
            };
            getCheckMinuteUnits = targetGetMinuteUnits;
            getCheckSecondUnits = targetGetSecondUnits;
            getCheckMillisecondUnits = targetGetMillisecondUnits;
        }
        var validateDate = (0, _util1.findValidateTime)(nextTime, getCheckHourUnits, getCheckMinuteUnits, getCheckSecondUnits, getCheckMillisecondUnits, generateConfig);
        return validateDate;
    };
    return [
        // getValidTime
        getValidTime,
        // Units
        rowHourUnits,
        getMinuteUnits,
        getSecondUnits,
        getMillisecondUnits
    ];
}

},{"@rc-component/util":"6ZBDN","react":"bmhQu","../PickerPanel/TimePanel/TimePanelBody/util":"a2kJ9","../utils/miscUtil":"2yPUL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a2kJ9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "findValidateTime", ()=>findValidateTime);
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function findValidateTime(date, getHourUnits, getMinuteUnits, getSecondUnits, getMillisecondUnits, generateConfig) {
    var nextDate = date;
    function alignValidate(getUnitValue, setUnitValue, units) {
        var nextValue = generateConfig[getUnitValue](nextDate);
        var nextUnit = units.find(function(unit) {
            return unit.value === nextValue;
        });
        if (!nextUnit || nextUnit.disabled) {
            // Find most closest unit
            var validateUnits = units.filter(function(unit) {
                return !unit.disabled;
            });
            var reverseEnabledUnits = _toConsumableArray(validateUnits).reverse();
            var validateUnit = reverseEnabledUnits.find(function(unit) {
                return unit.value <= nextValue;
            }) || validateUnits[0];
            if (validateUnit) {
                nextValue = validateUnit.value;
                nextDate = generateConfig[setUnitValue](nextDate, nextValue);
            }
        }
        return nextValue;
    }
    // Find validate hour
    var nextHour = alignValidate('getHour', 'setHour', getHourUnits());
    // Find validate minute
    var nextMinute = alignValidate('getMinute', 'setMinute', getMinuteUnits(nextHour));
    // Find validate second
    var nextSecond = alignValidate('getSecond', 'setSecond', getSecondUnits(nextHour, nextMinute));
    // Find validate millisecond
    alignValidate('getMillisecond', 'setMillisecond', getMillisecondUnits(nextHour, nextMinute, nextSecond));
    return nextDate;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"UBvta":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PopupPanel);
var _react = require("react");
var _pickerPanel = require("../../PickerPanel");
var _pickerPanelDefault = parcelHelpers.interopDefault(_pickerPanel);
var _context = require("../../PickerPanel/context");
var _context1 = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context1);
var _useRangePickerValue = require("../hooks/useRangePickerValue");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function PopupPanel(props) {
    var picker = props.picker, multiplePanel = props.multiplePanel, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, needConfirm = props.needConfirm, onSubmit = props.onSubmit, range = props.range, hoverValue = props.hoverValue;
    var _React$useContext = _react.useContext((0, _contextDefault.default)), prefixCls = _React$useContext.prefixCls, generateConfig = _React$useContext.generateConfig;
    // ======================== Offset ========================
    var internalOffsetDate = _react.useCallback(function(date, offset) {
        return (0, _useRangePickerValue.offsetPanelDate)(generateConfig, picker, date, offset);
    }, [
        generateConfig,
        picker
    ]);
    var nextPickerValue = _react.useMemo(function() {
        return internalOffsetDate(pickerValue, 1);
    }, [
        pickerValue,
        internalOffsetDate
    ]);
    // Outside
    var onSecondPickerValueChange = function onSecondPickerValueChange(nextDate) {
        onPickerValueChange(internalOffsetDate(nextDate, -1));
    };
    // ======================= Context ========================
    var sharedContext = {
        onCellDblClick: function onCellDblClick() {
            if (needConfirm) onSubmit();
        }
    };
    var hideHeader = picker === 'time';
    // ======================== Props =========================
    var pickerProps = _objectSpread(_objectSpread({}, props), {}, {
        hoverValue: null,
        hoverRangeValue: null,
        hideHeader: hideHeader
    });
    if (range) pickerProps.hoverRangeValue = hoverValue;
    else pickerProps.hoverValue = hoverValue;
    // ======================== Render ========================
    // Multiple
    if (multiplePanel) return /*#__PURE__*/ _react.createElement("div", {
        className: "".concat(prefixCls, "-panels")
    }, /*#__PURE__*/ _react.createElement((0, _context.PickerHackContext).Provider, {
        value: _objectSpread(_objectSpread({}, sharedContext), {}, {
            hideNext: true
        })
    }, /*#__PURE__*/ _react.createElement((0, _pickerPanelDefault.default), pickerProps)), /*#__PURE__*/ _react.createElement((0, _context.PickerHackContext).Provider, {
        value: _objectSpread(_objectSpread({}, sharedContext), {}, {
            hidePrev: true
        })
    }, /*#__PURE__*/ _react.createElement((0, _pickerPanelDefault.default), _extends({}, pickerProps, {
        pickerValue: nextPickerValue,
        onPickerValueChange: onSecondPickerValueChange
    }))));
    // Single
    return /*#__PURE__*/ _react.createElement((0, _context.PickerHackContext).Provider, {
        value: _objectSpread({}, sharedContext)
    }, /*#__PURE__*/ _react.createElement((0, _pickerPanelDefault.default), pickerProps));
}

},{"react":"bmhQu","../../PickerPanel":"3ZGhg","../../PickerPanel/context":"eEXYs","../context":"afG3N","../hooks/useRangePickerValue":"75Bgy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3ZGhg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _util = require("@rc-component/util");
var _react = require("react");
var _useLocale = require("../hooks/useLocale");
var _useLocaleDefault = parcelHelpers.interopDefault(_useLocale);
var _useTimeConfig = require("../hooks/useTimeConfig");
var _useToggleDates = require("../hooks/useToggleDates");
var _useToggleDatesDefault = parcelHelpers.interopDefault(_useToggleDates);
var _context = require("../PickerInput/context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _useCellRender = require("../PickerInput/hooks/useCellRender");
var _useCellRenderDefault = parcelHelpers.interopDefault(_useCellRender);
var _dateUtil = require("../utils/dateUtil");
var _miscUtil = require("../utils/miscUtil");
var _context1 = require("./context");
var _datePanel = require("./DatePanel");
var _datePanelDefault = parcelHelpers.interopDefault(_datePanel);
var _dateTimePanel = require("./DateTimePanel");
var _dateTimePanelDefault = parcelHelpers.interopDefault(_dateTimePanel);
var _decadePanel = require("./DecadePanel");
var _decadePanelDefault = parcelHelpers.interopDefault(_decadePanel);
var _monthPanel = require("./MonthPanel");
var _monthPanelDefault = parcelHelpers.interopDefault(_monthPanel);
var _quarterPanel = require("./QuarterPanel");
var _quarterPanelDefault = parcelHelpers.interopDefault(_quarterPanel);
var _timePanel = require("./TimePanel");
var _timePanelDefault = parcelHelpers.interopDefault(_timePanel);
var _weekPanel = require("./WeekPanel");
var _weekPanelDefault = parcelHelpers.interopDefault(_weekPanel);
var _yearPanel = require("./YearPanel");
var _yearPanelDefault = parcelHelpers.interopDefault(_yearPanel);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var DefaultComponents = {
    date: (0, _datePanelDefault.default),
    datetime: (0, _dateTimePanelDefault.default),
    week: (0, _weekPanelDefault.default),
    month: (0, _monthPanelDefault.default),
    quarter: (0, _quarterPanelDefault.default),
    year: (0, _yearPanelDefault.default),
    decade: (0, _decadePanelDefault.default),
    time: (0, _timePanelDefault.default)
};
function PickerPanel(props, ref) {
    var panelClassNames = props.classNames, panelStyles = props.styles, locale = props.locale, generateConfig = props.generateConfig, direction = props.direction, prefixCls = props.prefixCls, _props$tabIndex = props.tabIndex, tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex, multiple = props.multiple, defaultValue = props.defaultValue, value = props.value, onChange = props.onChange, onSelect = props.onSelect, defaultPickerValue = props.defaultPickerValue, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, mode = props.mode, onPanelChange = props.onPanelChange, _props$picker = props.picker, picker = _props$picker === void 0 ? 'date' : _props$picker, showTime = props.showTime, hoverValue = props.hoverValue, hoverRangeValue = props.hoverRangeValue, cellRender = props.cellRender, dateRender = props.dateRender, monthCellRender = props.monthCellRender, _props$components = props.components, components = _props$components === void 0 ? {} : _props$components, hideHeader = props.hideHeader;
    // ======================== Context ========================
    var _ref = _react.useContext((0, _contextDefault.default)) || {}, contextPrefixCls = _ref.prefixCls, pickerClassNames = _ref.classNames, pickerStyles = _ref.styles;
    // ======================== prefixCls ========================
    var mergedPrefixCls = contextPrefixCls || prefixCls || 'rc-picker';
    // ========================== Refs ==========================
    var rootRef = _react.useRef();
    _react.useImperativeHandle(ref, function() {
        return {
            nativeElement: rootRef.current
        };
    });
    // ========================== Time ==========================
    // Auto `format` need to check `showTime.showXXX` first.
    // And then merge the `locale` into `mergedShowTime`.
    var _getTimeProps = (0, _useTimeConfig.getTimeProps)(props), _getTimeProps2 = _slicedToArray(_getTimeProps, 4), timeProps = _getTimeProps2[0], localeTimeProps = _getTimeProps2[1], showTimeFormat = _getTimeProps2[2], propFormat = _getTimeProps2[3];
    // ========================= Locale =========================
    var filledLocale = (0, _useLocaleDefault.default)(locale, localeTimeProps);
    // ========================= Picker =========================
    var internalPicker = picker === 'date' && showTime ? 'datetime' : picker;
    // ======================== ShowTime ========================
    var mergedShowTime = _react.useMemo(function() {
        return (0, _useTimeConfig.fillShowTimeConfig)(internalPicker, showTimeFormat, propFormat, timeProps, filledLocale);
    }, [
        internalPicker,
        showTimeFormat,
        propFormat,
        timeProps,
        filledLocale
    ]);
    // ========================== Now ===========================
    var now = generateConfig.getNow();
    // ========================== Mode ==========================
    var _useControlledState = (0, _util.useControlledState)(picker || 'date', mode), _useControlledState2 = _slicedToArray(_useControlledState, 2), mergedMode = _useControlledState2[0], setMergedMode = _useControlledState2[1];
    var internalMode = mergedMode === 'date' && mergedShowTime ? 'datetime' : mergedMode;
    // ========================= Toggle =========================
    var toggleDates = (0, _useToggleDatesDefault.default)(generateConfig, locale, internalPicker);
    // ========================= Value ==========================
    // >>> Real value
    // Interactive with `onChange` event which only trigger when the `mode` is `picker`
    var _useControlledState3 = (0, _util.useControlledState)(defaultValue, value), _useControlledState4 = _slicedToArray(_useControlledState3, 2), innerValue = _useControlledState4[0], setMergedValue = _useControlledState4[1];
    var mergedValue = _react.useMemo(function() {
        // Clean up `[null]`
        var values = (0, _miscUtil.toArray)(innerValue).filter(function(val) {
            return val;
        });
        return multiple ? values : values.slice(0, 1);
    }, [
        innerValue,
        multiple
    ]);
    // Sync value and only trigger onChange event when changed
    var triggerChange = (0, _util.useEvent)(function(nextValue) {
        setMergedValue(nextValue);
        if (onChange && (nextValue === null || mergedValue.length !== nextValue.length || mergedValue.some(function(ori, index) {
            return !(0, _dateUtil.isSame)(generateConfig, locale, ori, nextValue[index], internalPicker);
        }))) onChange === null || onChange === void 0 || onChange(multiple ? nextValue : nextValue[0]);
    });
    // >>> CalendarValue
    // CalendarValue is a temp value for user operation
    // which will only trigger `onCalendarChange` but not `onChange`
    var onInternalSelect = (0, _util.useEvent)(function(newDate) {
        onSelect === null || onSelect === void 0 || onSelect(newDate);
        if (mergedMode === picker) {
            var nextValues = multiple ? toggleDates(mergedValue, newDate) : [
                newDate
            ];
            triggerChange(nextValues);
        }
    });
    // >>> PickerValue
    // PickerValue is used to control the current displaying panel
    var _useControlledState5 = (0, _util.useControlledState)(defaultPickerValue || mergedValue[0] || now, pickerValue), _useControlledState6 = _slicedToArray(_useControlledState5, 2), mergedPickerValue = _useControlledState6[0], setInternalPickerValue = _useControlledState6[1];
    _react.useEffect(function() {
        if (mergedValue[0] && !pickerValue) setInternalPickerValue(mergedValue[0]);
    }, [
        mergedValue[0]
    ]);
    // Both trigger when manually pickerValue or mode change
    var triggerPanelChange = function triggerPanelChange(viewDate, nextMode) {
        onPanelChange === null || onPanelChange === void 0 || onPanelChange(viewDate || pickerValue, nextMode || mergedMode);
    };
    var setPickerValue = function setPickerValue(nextPickerValue) {
        var triggerPanelEvent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        setInternalPickerValue(nextPickerValue);
        onPickerValueChange === null || onPickerValueChange === void 0 || onPickerValueChange(nextPickerValue);
        if (triggerPanelEvent) triggerPanelChange(nextPickerValue);
    };
    var triggerModeChange = function triggerModeChange(nextMode, viewDate) {
        setMergedMode(nextMode);
        if (viewDate) setPickerValue(viewDate);
        triggerPanelChange(viewDate, nextMode);
    };
    var onPanelValueSelect = function onPanelValueSelect(nextValue) {
        onInternalSelect(nextValue);
        setPickerValue(nextValue);
        // Update mode if needed
        if (mergedMode !== picker) {
            var decadeYearQueue = [
                'decade',
                'year'
            ];
            var decadeYearMonthQueue = [].concat(decadeYearQueue, [
                'month'
            ]);
            var pickerQueue = {
                quarter: [].concat(decadeYearQueue, [
                    'quarter'
                ]),
                week: [].concat(_toConsumableArray(decadeYearMonthQueue), [
                    'week'
                ]),
                date: [].concat(_toConsumableArray(decadeYearMonthQueue), [
                    'date'
                ])
            };
            var queue = pickerQueue[picker] || decadeYearMonthQueue;
            var index = queue.indexOf(mergedMode);
            var nextMode = queue[index + 1];
            if (nextMode) triggerModeChange(nextMode, nextValue);
        }
    };
    // ======================= Hover Date =======================
    var hoverRangeDate = _react.useMemo(function() {
        var start;
        var end;
        if (Array.isArray(hoverRangeValue)) {
            var _hoverRangeValue = _slicedToArray(hoverRangeValue, 2);
            start = _hoverRangeValue[0];
            end = _hoverRangeValue[1];
        } else start = hoverRangeValue;
        // Return for not exist
        if (!start && !end) return null;
        // Fill if has empty
        start = start || end;
        end = end || start;
        return generateConfig.isAfter(start, end) ? [
            end,
            start
        ] : [
            start,
            end
        ];
    }, [
        hoverRangeValue,
        generateConfig
    ]);
    // ======================= Components =======================
    // >>> cellRender
    var onInternalCellRender = (0, _useCellRenderDefault.default)(cellRender, dateRender, monthCellRender);
    // ======================= Components =======================
    var PanelComponent = components[internalMode] || DefaultComponents[internalMode] || (0, _datePanelDefault.default);
    // ======================== Context =========================
    var sharedPanelContext = _react.useMemo(function() {
        var _ref2, _pickerClassNames$pop, _ref3, _pickerStyles$popup;
        return {
            classNames: (_ref2 = (_pickerClassNames$pop = pickerClassNames === null || pickerClassNames === void 0 ? void 0 : pickerClassNames.popup) !== null && _pickerClassNames$pop !== void 0 ? _pickerClassNames$pop : panelClassNames) !== null && _ref2 !== void 0 ? _ref2 : {},
            styles: (_ref3 = (_pickerStyles$popup = pickerStyles === null || pickerStyles === void 0 ? void 0 : pickerStyles.popup) !== null && _pickerStyles$popup !== void 0 ? _pickerStyles$popup : panelStyles) !== null && _ref3 !== void 0 ? _ref3 : {}
        };
    }, [
        pickerClassNames,
        panelClassNames,
        pickerStyles,
        panelStyles
    ]);
    var parentHackContext = _react.useContext((0, _context1.PickerHackContext));
    var pickerPanelContext = _react.useMemo(function() {
        return _objectSpread(_objectSpread({}, parentHackContext), {}, {
            hideHeader: hideHeader
        });
    }, [
        parentHackContext,
        hideHeader
    ]);
    // ========================= Render =========================
    var panelCls = "".concat(mergedPrefixCls, "-panel");
    var panelProps = (0, _miscUtil.pickProps)(props, [
        // Week
        'showWeek',
        // Icons
        'prevIcon',
        'nextIcon',
        'superPrevIcon',
        'superNextIcon',
        // Disabled
        'disabledDate',
        'minDate',
        'maxDate',
        // Hover
        'onHover'
    ]);
    return /*#__PURE__*/ _react.createElement((0, _context1.SharedPanelContext).Provider, {
        value: sharedPanelContext
    }, /*#__PURE__*/ _react.createElement((0, _context1.PickerHackContext).Provider, {
        value: pickerPanelContext
    }, /*#__PURE__*/ _react.createElement("div", {
        ref: rootRef,
        tabIndex: tabIndex,
        className: (0, _clsx.clsx)(panelCls, _defineProperty({}, "".concat(panelCls, "-rtl"), direction === 'rtl'))
    }, /*#__PURE__*/ _react.createElement(PanelComponent, _extends({}, panelProps, {
        // Time
        showTime: mergedShowTime,
        prefixCls: mergedPrefixCls,
        locale: filledLocale,
        generateConfig: generateConfig,
        onModeChange: triggerModeChange,
        pickerValue: mergedPickerValue,
        onPickerValueChange: function onPickerValueChange(nextPickerValue) {
            setPickerValue(nextPickerValue, true);
        },
        value: mergedValue[0],
        onSelect: onPanelValueSelect,
        values: mergedValue,
        cellRender: onInternalCellRender,
        hoverRangeValue: hoverRangeDate,
        hoverValue: hoverValue
    })))));
}
var RefPanelPicker = /*#__PURE__*/ _react.memo(/*#__PURE__*/ _react.forwardRef(PickerPanel));
// Make support generic
exports.default = RefPanelPicker;

},{"clsx":"431Ou","@rc-component/util":"6ZBDN","react":"bmhQu","../hooks/useLocale":"14hhv","../hooks/useTimeConfig":"8Q56P","../hooks/useToggleDates":"3oZQL","../PickerInput/context":"afG3N","../PickerInput/hooks/useCellRender":"9dNsP","../utils/dateUtil":"gSKz6","../utils/miscUtil":"2yPUL","./context":"eEXYs","./DatePanel":"annzN","./DateTimePanel":"5TDnt","./DecadePanel":"hCetW","./MonthPanel":"mAiyA","./QuarterPanel":"49p1Q","./TimePanel":"dpogL","./WeekPanel":"311z1","./YearPanel":"jPlv7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3oZQL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useToggleDates);
var _dateUtil = require("../utils/dateUtil");
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function useToggleDates(generateConfig, locale, panelMode) {
    function toggleDates(list, target) {
        var index = list.findIndex(function(date) {
            return (0, _dateUtil.isSame)(generateConfig, locale, date, target, panelMode);
        });
        if (index === -1) return [].concat(_toConsumableArray(list), [
            target
        ]);
        var sliceList = _toConsumableArray(list);
        sliceList.splice(index, 1);
        return sliceList;
    }
    return toggleDates;
}

},{"../utils/dateUtil":"gSKz6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eEXYs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SharedPanelContext", ()=>SharedPanelContext);
parcelHelpers.export(exports, "PanelContext", ()=>PanelContext);
parcelHelpers.export(exports, "usePanelContext", ()=>usePanelContext);
/**
 * Get shared props for the SharedPanelProps interface.
 */ parcelHelpers.export(exports, "useInfo", ()=>useInfo);
parcelHelpers.export(exports, "PickerHackContext", ()=>PickerHackContext);
var _react = require("react");
var SharedPanelContext = /*#__PURE__*/ _react.createContext(null);
var PanelContext = /*#__PURE__*/ _react.createContext(null);
function usePanelContext() {
    return _react.useContext(PanelContext);
}
function useInfo(props, panelType) {
    // TODO: this is not good to get from each props.
    // Should move to `SharedPanelContext` instead.
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, disabledDate = props.disabledDate, minDate = props.minDate, maxDate = props.maxDate, cellRender = props.cellRender, hoverValue = props.hoverValue, hoverRangeValue = props.hoverRangeValue, onHover = props.onHover, values = props.values, pickerValue = props.pickerValue, onSelect = props.onSelect, prevIcon = props.prevIcon, nextIcon = props.nextIcon, superPrevIcon = props.superPrevIcon, superNextIcon = props.superNextIcon;
    // ======================= Context ========================
    var _React$useContext = _react.useContext(SharedPanelContext), classNames = _React$useContext.classNames, styles = _React$useContext.styles;
    // ========================= MISC =========================
    var now = generateConfig.getNow();
    // ========================= Info =========================
    var info = {
        now: now,
        values: values,
        pickerValue: pickerValue,
        prefixCls: prefixCls,
        classNames: classNames,
        styles: styles,
        disabledDate: disabledDate,
        minDate: minDate,
        maxDate: maxDate,
        cellRender: cellRender,
        hoverValue: hoverValue,
        hoverRangeValue: hoverRangeValue,
        onHover: onHover,
        locale: locale,
        generateConfig: generateConfig,
        onSelect: onSelect,
        panelType: panelType,
        // Icons
        prevIcon: prevIcon,
        nextIcon: nextIcon,
        superPrevIcon: superPrevIcon,
        superNextIcon: superNextIcon
    };
    return [
        info,
        now
    ];
}
var PickerHackContext = /*#__PURE__*/ _react.createContext({});

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"annzN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DatePanel);
var _clsx = require("clsx");
var _react = require("react");
var _dateUtil = require("../../utils/dateUtil");
var _context = require("../context");
var _panelBody = require("../PanelBody");
var _panelBodyDefault = parcelHelpers.interopDefault(_panelBody);
var _panelHeader = require("../PanelHeader");
var _panelHeaderDefault = parcelHelpers.interopDefault(_panelHeader);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function DatePanel(props) {
    var prefixCls = props.prefixCls, _props$panelName = props.panelName, panelName = _props$panelName === void 0 ? 'date' : _props$panelName, locale = props.locale, generateConfig = props.generateConfig, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, onModeChange = props.onModeChange, _props$mode = props.mode, mode = _props$mode === void 0 ? 'date' : _props$mode, disabledDate = props.disabledDate, onSelect = props.onSelect, onHover = props.onHover, showWeek = props.showWeek;
    var panelPrefixCls = "".concat(prefixCls, "-").concat(panelName, "-panel");
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    var isWeek = mode === 'week';
    // ========================== Base ==========================
    var _useInfo = (0, _context.useInfo)(props, mode), _useInfo2 = _slicedToArray(_useInfo, 2), info = _useInfo2[0], now = _useInfo2[1];
    var weekFirstDay = generateConfig.locale.getWeekFirstDay(locale.locale);
    var monthStartDate = generateConfig.setDate(pickerValue, 1);
    var baseDate = (0, _dateUtil.getWeekStartDate)(locale.locale, generateConfig, monthStartDate);
    var month = generateConfig.getMonth(pickerValue);
    // =========================== PrefixColumn ===========================
    var showPrefixColumn = showWeek === undefined ? isWeek : showWeek;
    var prefixColumn = showPrefixColumn ? function(date) {
        // >>> Additional check for disabled
        var disabled = disabledDate === null || disabledDate === void 0 ? void 0 : disabledDate(date, {
            type: 'week'
        });
        return /*#__PURE__*/ _react.createElement("td", {
            key: "week",
            className: (0, _clsx.clsx)(cellPrefixCls, "".concat(cellPrefixCls, "-week"), _defineProperty({}, "".concat(cellPrefixCls, "-disabled"), disabled)),
            onClick: function onClick() {
                if (!disabled) onSelect(date);
            },
            onMouseEnter: function onMouseEnter() {
                if (!disabled) onHover === null || onHover === void 0 || onHover(date);
            },
            onMouseLeave: function onMouseLeave() {
                if (!disabled) onHover === null || onHover === void 0 || onHover(null);
            }
        }, /*#__PURE__*/ _react.createElement("div", {
            className: "".concat(cellPrefixCls, "-inner")
        }, generateConfig.locale.getWeek(locale.locale, date)));
    } : null;
    // ========================= Cells ==========================
    // >>> Header Cells
    var headerCells = [];
    var weekDaysLocale = locale.shortWeekDays || (generateConfig.locale.getShortWeekDays ? generateConfig.locale.getShortWeekDays(locale.locale) : []);
    if (prefixColumn) headerCells.push(/*#__PURE__*/ _react.createElement("th", {
        key: "empty"
    }, /*#__PURE__*/ _react.createElement("span", {
        style: {
            width: 0,
            height: 0,
            position: 'absolute',
            overflow: 'hidden',
            opacity: 0
        }
    }, locale.week)));
    for(var i = 0; i < (0, _dateUtil.WEEK_DAY_COUNT); i += 1)headerCells.push(/*#__PURE__*/ _react.createElement("th", {
        key: i
    }, weekDaysLocale[(i + weekFirstDay) % (0, _dateUtil.WEEK_DAY_COUNT)]));
    // >>> Body Cells
    var getCellDate = function getCellDate(date, offset) {
        return generateConfig.addDate(date, offset);
    };
    var getCellText = function getCellText(date) {
        return (0, _dateUtil.formatValue)(date, {
            locale: locale,
            format: locale.cellDateFormat,
            generateConfig: generateConfig
        });
    };
    var getCellClassName = function getCellClassName(date) {
        var classObj = _defineProperty(_defineProperty({}, "".concat(prefixCls, "-cell-in-view"), (0, _dateUtil.isSameMonth)(generateConfig, date, pickerValue)), "".concat(prefixCls, "-cell-today"), (0, _dateUtil.isSameDate)(generateConfig, date, now));
        return classObj;
    };
    // ========================= Header =========================
    var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
    var yearNode = /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        "aria-label": locale.yearSelect,
        key: "year",
        onClick: function onClick() {
            onModeChange('year', pickerValue);
        },
        tabIndex: -1,
        className: "".concat(prefixCls, "-year-btn")
    }, (0, _dateUtil.formatValue)(pickerValue, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    var monthNode = /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        "aria-label": locale.monthSelect,
        key: "month",
        onClick: function onClick() {
            onModeChange('month', pickerValue);
        },
        tabIndex: -1,
        className: "".concat(prefixCls, "-month-btn")
    }, locale.monthFormat ? (0, _dateUtil.formatValue)(pickerValue, {
        locale: locale,
        format: locale.monthFormat,
        generateConfig: generateConfig
    }) : monthsLocale[month]);
    var monthYearNodes = locale.monthBeforeYear ? [
        monthNode,
        yearNode
    ] : [
        yearNode,
        monthNode
    ];
    // ========================= Render =========================
    return /*#__PURE__*/ _react.createElement((0, _context.PanelContext).Provider, {
        value: info
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(panelPrefixCls, showWeek && "".concat(panelPrefixCls, "-show-week"))
    }, /*#__PURE__*/ _react.createElement((0, _panelHeaderDefault.default), {
        offset: function offset(distance) {
            return generateConfig.addMonth(pickerValue, distance);
        },
        superOffset: function superOffset(distance) {
            return generateConfig.addYear(pickerValue, distance);
        },
        onChange: onPickerValueChange,
        getStart: function getStart(date) {
            return generateConfig.setDate(date, 1);
        },
        getEnd: function getEnd(date) {
            var clone = generateConfig.setDate(date, 1);
            clone = generateConfig.addMonth(clone, 1);
            return generateConfig.addDate(clone, -1);
        }
    }, monthYearNodes), /*#__PURE__*/ _react.createElement((0, _panelBodyDefault.default), _extends({
        titleFormat: locale.fieldDateFormat
    }, props, {
        colNum: (0, _dateUtil.WEEK_DAY_COUNT),
        rowNum: 6,
        baseDate: baseDate,
        headerCells: headerCells,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName,
        prefixColumn: prefixColumn,
        cellSelection: !isWeek
    }))));
}

},{"clsx":"431Ou","react":"bmhQu","../../utils/dateUtil":"gSKz6","../context":"eEXYs","../PanelBody":"8aeMR","../PanelHeader":"hqaaU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8aeMR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PanelBody);
var _clsx = require("clsx");
var _react = require("react");
var _dateUtil = require("../utils/dateUtil");
var _context = require("./context");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function PanelBody(props) {
    var rowNum = props.rowNum, colNum = props.colNum, baseDate = props.baseDate, getCellDate = props.getCellDate, prefixColumn = props.prefixColumn, rowClassName = props.rowClassName, titleFormat = props.titleFormat, getCellText = props.getCellText, getCellClassName = props.getCellClassName, headerCells = props.headerCells, _props$cellSelection = props.cellSelection, cellSelection = _props$cellSelection === void 0 ? true : _props$cellSelection, disabledDate = props.disabledDate;
    var _usePanelContext = (0, _context.usePanelContext)(), prefixCls = _usePanelContext.prefixCls, classNames = _usePanelContext.classNames, styles = _usePanelContext.styles, type = _usePanelContext.panelType, now = _usePanelContext.now, contextDisabledDate = _usePanelContext.disabledDate, cellRender = _usePanelContext.cellRender, onHover = _usePanelContext.onHover, hoverValue = _usePanelContext.hoverValue, hoverRangeValue = _usePanelContext.hoverRangeValue, generateConfig = _usePanelContext.generateConfig, values = _usePanelContext.values, locale = _usePanelContext.locale, onSelect = _usePanelContext.onSelect;
    var mergedDisabledDate = disabledDate || contextDisabledDate;
    var cellPrefixCls = "".concat(prefixCls, "-cell");
    // ============================= Context ==============================
    var _React$useContext = _react.useContext((0, _context.PickerHackContext)), onCellDblClick = _React$useContext.onCellDblClick;
    // ============================== Value ===============================
    var matchValues = function matchValues(date) {
        return values.some(function(singleValue) {
            return singleValue && (0, _dateUtil.isSame)(generateConfig, locale, date, singleValue, type);
        });
    };
    // =============================== Body ===============================
    var rows = [];
    for(var row = 0; row < rowNum; row += 1){
        var rowNode = [];
        var rowStartDate = void 0;
        var _loop = function _loop() {
            var offset = row * colNum + col;
            var currentDate = getCellDate(baseDate, offset);
            var disabled = mergedDisabledDate === null || mergedDisabledDate === void 0 ? void 0 : mergedDisabledDate(currentDate, {
                type: type
            });
            // Row Start Cell
            if (col === 0) {
                rowStartDate = currentDate;
                if (prefixColumn) rowNode.push(prefixColumn(rowStartDate));
            }
            // Range
            var inRange = false;
            var rangeStart = false;
            var rangeEnd = false;
            if (cellSelection && hoverRangeValue) {
                var _hoverRangeValue = _slicedToArray(hoverRangeValue, 2), hoverStart = _hoverRangeValue[0], hoverEnd = _hoverRangeValue[1];
                inRange = (0, _dateUtil.isInRange)(generateConfig, hoverStart, hoverEnd, currentDate);
                rangeStart = (0, _dateUtil.isSame)(generateConfig, locale, currentDate, hoverStart, type);
                rangeEnd = (0, _dateUtil.isSame)(generateConfig, locale, currentDate, hoverEnd, type);
            }
            // Title
            var title = titleFormat ? (0, _dateUtil.formatValue)(currentDate, {
                locale: locale,
                format: titleFormat,
                generateConfig: generateConfig
            }) : undefined;
            // Render
            var inner = /*#__PURE__*/ _react.createElement("div", {
                className: "".concat(cellPrefixCls, "-inner")
            }, getCellText(currentDate));
            rowNode.push(/*#__PURE__*/ _react.createElement("td", {
                key: col,
                title: title,
                className: (0, _clsx.clsx)(cellPrefixCls, classNames.item, _objectSpread(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(cellPrefixCls, "-disabled"), disabled), "".concat(cellPrefixCls, "-hover"), (hoverValue || []).some(function(date) {
                    return (0, _dateUtil.isSame)(generateConfig, locale, currentDate, date, type);
                })), "".concat(cellPrefixCls, "-in-range"), inRange && !rangeStart && !rangeEnd), "".concat(cellPrefixCls, "-range-start"), rangeStart), "".concat(cellPrefixCls, "-range-end"), rangeEnd), "".concat(prefixCls, "-cell-selected"), !hoverRangeValue && // WeekPicker use row instead
                type !== 'week' && matchValues(currentDate)), getCellClassName(currentDate))),
                style: styles.item,
                onClick: function onClick() {
                    if (!disabled) onSelect(currentDate);
                },
                onDoubleClick: function onDoubleClick() {
                    if (!disabled && onCellDblClick) onCellDblClick();
                },
                onMouseEnter: function onMouseEnter() {
                    if (!disabled) onHover === null || onHover === void 0 || onHover(currentDate);
                },
                onMouseLeave: function onMouseLeave() {
                    if (!disabled) onHover === null || onHover === void 0 || onHover(null);
                }
            }, cellRender ? cellRender(currentDate, {
                prefixCls: prefixCls,
                originNode: inner,
                today: now,
                type: type,
                locale: locale
            }) : inner));
        };
        for(var col = 0; col < colNum; col += 1)_loop();
        rows.push(/*#__PURE__*/ _react.createElement("tr", {
            key: row,
            className: rowClassName === null || rowClassName === void 0 ? void 0 : rowClassName(rowStartDate)
        }, rowNode));
    }
    // ============================== Render ==============================
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)("".concat(prefixCls, "-body"), classNames.body),
        style: styles.body
    }, /*#__PURE__*/ _react.createElement("table", {
        className: (0, _clsx.clsx)("".concat(prefixCls, "-content"), classNames.content),
        style: styles.content
    }, headerCells && /*#__PURE__*/ _react.createElement("thead", null, /*#__PURE__*/ _react.createElement("tr", null, headerCells)), /*#__PURE__*/ _react.createElement("tbody", null, rows)));
}

},{"clsx":"431Ou","react":"bmhQu","../utils/dateUtil":"gSKz6","./context":"eEXYs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hqaaU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _react = require("react");
var _dateUtil = require("../utils/dateUtil");
var _context = require("./context");
var HIDDEN_STYLE = {
    visibility: 'hidden'
};
function PanelHeader(props) {
    var offset = props.offset, superOffset = props.superOffset, onChange = props.onChange, getStart = props.getStart, getEnd = props.getEnd, children = props.children;
    var _usePanelContext = (0, _context.usePanelContext)(), prefixCls = _usePanelContext.prefixCls, classNames = _usePanelContext.classNames, styles = _usePanelContext.styles, _usePanelContext$prev = _usePanelContext.prevIcon, prevIcon = _usePanelContext$prev === void 0 ? "\u2039" : _usePanelContext$prev, _usePanelContext$next = _usePanelContext.nextIcon, nextIcon = _usePanelContext$next === void 0 ? "\u203A" : _usePanelContext$next, _usePanelContext$supe = _usePanelContext.superPrevIcon, superPrevIcon = _usePanelContext$supe === void 0 ? "\xAB" : _usePanelContext$supe, _usePanelContext$supe2 = _usePanelContext.superNextIcon, superNextIcon = _usePanelContext$supe2 === void 0 ? "\xBB" : _usePanelContext$supe2, minDate = _usePanelContext.minDate, maxDate = _usePanelContext.maxDate, generateConfig = _usePanelContext.generateConfig, locale = _usePanelContext.locale, pickerValue = _usePanelContext.pickerValue, type = _usePanelContext.panelType;
    var headerPrefixCls = "".concat(prefixCls, "-header");
    var _React$useContext = _react.useContext((0, _context.PickerHackContext)), hidePrev = _React$useContext.hidePrev, hideNext = _React$useContext.hideNext, hideHeader = _React$useContext.hideHeader;
    // ======================= Limitation =======================
    var disabledOffsetPrev = _react.useMemo(function() {
        if (!minDate || !offset || !getEnd) return false;
        var prevPanelLimitDate = getEnd(offset(-1, pickerValue));
        return !(0, _dateUtil.isSameOrAfter)(generateConfig, locale, prevPanelLimitDate, minDate, type);
    }, [
        minDate,
        offset,
        pickerValue,
        getEnd,
        generateConfig,
        locale,
        type
    ]);
    var disabledSuperOffsetPrev = _react.useMemo(function() {
        if (!minDate || !superOffset || !getEnd) return false;
        var prevPanelLimitDate = getEnd(superOffset(-1, pickerValue));
        return !(0, _dateUtil.isSameOrAfter)(generateConfig, locale, prevPanelLimitDate, minDate, type);
    }, [
        minDate,
        superOffset,
        pickerValue,
        getEnd,
        generateConfig,
        locale,
        type
    ]);
    var disabledOffsetNext = _react.useMemo(function() {
        if (!maxDate || !offset || !getStart) return false;
        var nextPanelLimitDate = getStart(offset(1, pickerValue));
        return !(0, _dateUtil.isSameOrAfter)(generateConfig, locale, maxDate, nextPanelLimitDate, type);
    }, [
        maxDate,
        offset,
        pickerValue,
        getStart,
        generateConfig,
        locale,
        type
    ]);
    var disabledSuperOffsetNext = _react.useMemo(function() {
        if (!maxDate || !superOffset || !getStart) return false;
        var nextPanelLimitDate = getStart(superOffset(1, pickerValue));
        return !(0, _dateUtil.isSameOrAfter)(generateConfig, locale, maxDate, nextPanelLimitDate, type);
    }, [
        maxDate,
        superOffset,
        pickerValue,
        getStart,
        generateConfig,
        locale,
        type
    ]);
    // ========================= Offset =========================
    var onOffset = function onOffset(distance) {
        if (offset) onChange(offset(distance, pickerValue));
    };
    var onSuperOffset = function onSuperOffset(distance) {
        if (superOffset) onChange(superOffset(distance, pickerValue));
    };
    // ========================= Render =========================
    if (hideHeader) return null;
    var prevBtnCls = "".concat(headerPrefixCls, "-prev-btn");
    var nextBtnCls = "".concat(headerPrefixCls, "-next-btn");
    var superPrevBtnCls = "".concat(headerPrefixCls, "-super-prev-btn");
    var superNextBtnCls = "".concat(headerPrefixCls, "-super-next-btn");
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(headerPrefixCls, classNames.header),
        style: styles.header
    }, superOffset && /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        "aria-label": locale.previousYear,
        onClick: function onClick() {
            return onSuperOffset(-1);
        },
        tabIndex: -1,
        className: (0, _clsx.clsx)(superPrevBtnCls, disabledSuperOffsetPrev && "".concat(superPrevBtnCls, "-disabled")),
        disabled: disabledSuperOffsetPrev,
        style: hidePrev ? HIDDEN_STYLE : {}
    }, superPrevIcon), offset && /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        "aria-label": locale.previousMonth,
        onClick: function onClick() {
            return onOffset(-1);
        },
        tabIndex: -1,
        className: (0, _clsx.clsx)(prevBtnCls, disabledOffsetPrev && "".concat(prevBtnCls, "-disabled")),
        disabled: disabledOffsetPrev,
        style: hidePrev ? HIDDEN_STYLE : {}
    }, prevIcon), /*#__PURE__*/ _react.createElement("div", {
        className: "".concat(headerPrefixCls, "-view")
    }, children), offset && /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        "aria-label": locale.nextMonth,
        onClick: function onClick() {
            return onOffset(1);
        },
        tabIndex: -1,
        className: (0, _clsx.clsx)(nextBtnCls, disabledOffsetNext && "".concat(nextBtnCls, "-disabled")),
        disabled: disabledOffsetNext,
        style: hideNext ? HIDDEN_STYLE : {}
    }, nextIcon), superOffset && /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        "aria-label": locale.nextYear,
        onClick: function onClick() {
            return onSuperOffset(1);
        },
        tabIndex: -1,
        className: (0, _clsx.clsx)(superNextBtnCls, disabledSuperOffsetNext && "".concat(superNextBtnCls, "-disabled")),
        disabled: disabledSuperOffsetNext,
        style: hideNext ? HIDDEN_STYLE : {}
    }, superNextIcon));
}
exports.default = PanelHeader;

},{"clsx":"431Ou","react":"bmhQu","../utils/dateUtil":"gSKz6","./context":"eEXYs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5TDnt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DateTimePanel);
var _react = require("react");
var _useTimeInfo = require("../../hooks/useTimeInfo");
var _useTimeInfoDefault = parcelHelpers.interopDefault(_useTimeInfo);
var _dateUtil = require("../../utils/dateUtil");
var _datePanel = require("../DatePanel");
var _datePanelDefault = parcelHelpers.interopDefault(_datePanel);
var _timePanel = require("../TimePanel");
var _timePanelDefault = parcelHelpers.interopDefault(_timePanel);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function DateTimePanel(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, showTime = props.showTime, onSelect = props.onSelect, value = props.value, pickerValue = props.pickerValue, onHover = props.onHover;
    var panelPrefixCls = "".concat(prefixCls, "-datetime-panel");
    // =============================== Time ===============================
    var _useTimeInfo = (0, _useTimeInfoDefault.default)(generateConfig, showTime), _useTimeInfo2 = _slicedToArray(_useTimeInfo, 1), getValidTime = _useTimeInfo2[0];
    // Merge the time info from `value` or `pickerValue`
    var mergeTime = function mergeTime(date) {
        if (value) return (0, _dateUtil.fillTime)(generateConfig, date, value);
        return (0, _dateUtil.fillTime)(generateConfig, date, pickerValue);
    };
    // ============================== Hover ===============================
    var onDateHover = function onDateHover(date) {
        onHover === null || onHover === void 0 || onHover(date ? mergeTime(date) : date);
    };
    // ============================== Select ==============================
    var onDateSelect = function onDateSelect(date) {
        // Merge with current time
        var cloneDate = mergeTime(date);
        onSelect(getValidTime(cloneDate, cloneDate));
    };
    // ============================== Render ==============================
    return /*#__PURE__*/ _react.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ _react.createElement((0, _datePanelDefault.default), _extends({}, props, {
        onSelect: onDateSelect,
        onHover: onDateHover
    })), /*#__PURE__*/ _react.createElement((0, _timePanelDefault.default), props));
}

},{"react":"bmhQu","../../hooks/useTimeInfo":"jcxgQ","../../utils/dateUtil":"gSKz6","../DatePanel":"annzN","../TimePanel":"dpogL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dpogL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TimePanel);
var _clsx = require("clsx");
var _react = require("react");
var _dateUtil = require("../../utils/dateUtil");
var _context = require("../context");
var _panelHeader = require("../PanelHeader");
var _panelHeaderDefault = parcelHelpers.interopDefault(_panelHeader);
var _timePanelBody = require("./TimePanelBody");
var _timePanelBodyDefault = parcelHelpers.interopDefault(_timePanelBody);
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function TimePanel(props) {
    var prefixCls = props.prefixCls, value = props.value, locale = props.locale, generateConfig = props.generateConfig, showTime = props.showTime;
    var _ref = showTime || {}, format = _ref.format;
    var panelPrefixCls = "".concat(prefixCls, "-time-panel");
    // ========================== Base ==========================
    var _useInfo = (0, _context.useInfo)(props, 'time'), _useInfo2 = _slicedToArray(_useInfo, 1), info = _useInfo2[0];
    // ========================= Render =========================
    return /*#__PURE__*/ _react.createElement((0, _context.PanelContext).Provider, {
        value: info
    }, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(panelPrefixCls)
    }, /*#__PURE__*/ _react.createElement((0, _panelHeaderDefault.default), null, value ? (0, _dateUtil.formatValue)(value, {
        locale: locale,
        format: format,
        generateConfig: generateConfig
    }) : "\xA0"), /*#__PURE__*/ _react.createElement((0, _timePanelBodyDefault.default), showTime)));
}

},{"clsx":"431Ou","react":"bmhQu","../../utils/dateUtil":"gSKz6","../context":"eEXYs","../PanelHeader":"hqaaU","./TimePanelBody":"2DnRt","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2DnRt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TimePanelBody);
var _react = require("react");
var _useTimeInfo = require("../../../hooks/useTimeInfo");
var _useTimeInfoDefault = parcelHelpers.interopDefault(_useTimeInfo);
var _dateUtil = require("../../../utils/dateUtil");
var _context = require("../../context");
var _timeColumn = require("./TimeColumn");
var _timeColumnDefault = parcelHelpers.interopDefault(_timeColumn);
var _clsx = require("clsx");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function isAM(hour) {
    return hour < 12;
}
function TimePanelBody(props) {
    var showHour = props.showHour, showMinute = props.showMinute, showSecond = props.showSecond, showMillisecond = props.showMillisecond, showMeridiem = props.use12Hours, changeOnScroll = props.changeOnScroll;
    var _usePanelContext = (0, _context.usePanelContext)(), prefixCls = _usePanelContext.prefixCls, classNames = _usePanelContext.classNames, styles = _usePanelContext.styles, values = _usePanelContext.values, generateConfig = _usePanelContext.generateConfig, locale = _usePanelContext.locale, onSelect = _usePanelContext.onSelect, _usePanelContext$onHo = _usePanelContext.onHover, onHover = _usePanelContext$onHo === void 0 ? function() {} : _usePanelContext$onHo, pickerValue = _usePanelContext.pickerValue;
    var value = (values === null || values === void 0 ? void 0 : values[0]) || null;
    var _React$useContext = _react.useContext((0, _context.PickerHackContext)), onCellDblClick = _React$useContext.onCellDblClick;
    // ========================== Info ==========================
    var _useTimeInfo = (0, _useTimeInfoDefault.default)(generateConfig, props, value), _useTimeInfo2 = _slicedToArray(_useTimeInfo, 5), getValidTime = _useTimeInfo2[0], rowHourUnits = _useTimeInfo2[1], getMinuteUnits = _useTimeInfo2[2], getSecondUnits = _useTimeInfo2[3], getMillisecondUnits = _useTimeInfo2[4];
    // ========================= Value ==========================
    // PickerValue will tell which one to align on the top
    var getUnitValue = function getUnitValue(func) {
        var valueUnitVal = value && generateConfig[func](value);
        var pickerUnitValue = pickerValue && generateConfig[func](pickerValue);
        return [
            valueUnitVal,
            pickerUnitValue
        ];
    };
    var _getUnitValue = getUnitValue('getHour'), _getUnitValue2 = _slicedToArray(_getUnitValue, 2), hour = _getUnitValue2[0], pickerHour = _getUnitValue2[1];
    var _getUnitValue3 = getUnitValue('getMinute'), _getUnitValue4 = _slicedToArray(_getUnitValue3, 2), minute = _getUnitValue4[0], pickerMinute = _getUnitValue4[1];
    var _getUnitValue5 = getUnitValue('getSecond'), _getUnitValue6 = _slicedToArray(_getUnitValue5, 2), second = _getUnitValue6[0], pickerSecond = _getUnitValue6[1];
    var _getUnitValue7 = getUnitValue('getMillisecond'), _getUnitValue8 = _slicedToArray(_getUnitValue7, 2), millisecond = _getUnitValue8[0], pickerMillisecond = _getUnitValue8[1];
    var meridiem = hour === null ? null : isAM(hour) ? 'am' : 'pm';
    // ========================= Column =========================
    // Hours
    var hourUnits = _react.useMemo(function() {
        if (!showMeridiem) return rowHourUnits;
        return isAM(hour) ? rowHourUnits.filter(function(h) {
            return isAM(h.value);
        }) : rowHourUnits.filter(function(h) {
            return !isAM(h.value);
        });
    }, [
        hour,
        rowHourUnits,
        showMeridiem
    ]);
    // >>> Pick Fallback
    var getEnabled = function getEnabled(units, val) {
        var _enabledUnits$;
        var enabledUnits = units.filter(function(unit) {
            return !unit.disabled;
        });
        return val !== null && val !== void 0 ? val : enabledUnits === null || enabledUnits === void 0 || (_enabledUnits$ = enabledUnits[0]) === null || _enabledUnits$ === void 0 ? void 0 : _enabledUnits$.value;
    };
    // >>> Minutes
    var validHour = getEnabled(rowHourUnits, hour);
    var minuteUnits = _react.useMemo(function() {
        return getMinuteUnits(validHour);
    }, [
        getMinuteUnits,
        validHour
    ]);
    // >>> Seconds
    var validMinute = getEnabled(minuteUnits, minute);
    var secondUnits = _react.useMemo(function() {
        return getSecondUnits(validHour, validMinute);
    }, [
        getSecondUnits,
        validHour,
        validMinute
    ]);
    // >>> Milliseconds
    var validSecond = getEnabled(secondUnits, second);
    var millisecondUnits = _react.useMemo(function() {
        return getMillisecondUnits(validHour, validMinute, validSecond);
    }, [
        getMillisecondUnits,
        validHour,
        validMinute,
        validSecond
    ]);
    var validMillisecond = getEnabled(millisecondUnits, millisecond);
    // Meridiem
    var meridiemUnits = _react.useMemo(function() {
        if (!showMeridiem) return [];
        var base = generateConfig.getNow();
        var amDate = generateConfig.setHour(base, 6);
        var pmDate = generateConfig.setHour(base, 18);
        var formatMeridiem = function formatMeridiem(date, defaultLabel) {
            var cellMeridiemFormat = locale.cellMeridiemFormat;
            return cellMeridiemFormat ? (0, _dateUtil.formatValue)(date, {
                generateConfig: generateConfig,
                locale: locale,
                format: cellMeridiemFormat
            }) : defaultLabel;
        };
        return [
            {
                label: formatMeridiem(amDate, 'AM'),
                value: 'am',
                disabled: rowHourUnits.every(function(h) {
                    return h.disabled || !isAM(h.value);
                })
            },
            {
                label: formatMeridiem(pmDate, 'PM'),
                value: 'pm',
                disabled: rowHourUnits.every(function(h) {
                    return h.disabled || isAM(h.value);
                })
            }
        ];
    }, [
        rowHourUnits,
        showMeridiem,
        generateConfig,
        locale
    ]);
    // ========================= Change =========================
    /**
   * Check if time is validate or will match to validate one
   */ var triggerChange = function triggerChange(nextDate) {
        var validateDate = getValidTime(nextDate);
        onSelect(validateDate);
    };
    // ========================= Column =========================
    // Create a template date for the trigger change event
    var triggerDateTmpl = _react.useMemo(function() {
        var tmpl = value || pickerValue || generateConfig.getNow();
        var isNotNull = function isNotNull(num) {
            return num !== null && num !== undefined;
        };
        if (isNotNull(hour)) {
            tmpl = generateConfig.setHour(tmpl, hour);
            tmpl = generateConfig.setMinute(tmpl, minute);
            tmpl = generateConfig.setSecond(tmpl, second);
            tmpl = generateConfig.setMillisecond(tmpl, millisecond);
        } else if (isNotNull(pickerHour)) {
            tmpl = generateConfig.setHour(tmpl, pickerHour);
            tmpl = generateConfig.setMinute(tmpl, pickerMinute);
            tmpl = generateConfig.setSecond(tmpl, pickerSecond);
            tmpl = generateConfig.setMillisecond(tmpl, pickerMillisecond);
        } else if (isNotNull(validHour)) {
            tmpl = generateConfig.setHour(tmpl, validHour);
            tmpl = generateConfig.setMinute(tmpl, validMinute);
            tmpl = generateConfig.setSecond(tmpl, validSecond);
            tmpl = generateConfig.setMillisecond(tmpl, validMillisecond);
        }
        return tmpl;
    }, [
        value,
        pickerValue,
        hour,
        minute,
        second,
        millisecond,
        validHour,
        validMinute,
        validSecond,
        validMillisecond,
        pickerHour,
        pickerMinute,
        pickerSecond,
        pickerMillisecond,
        generateConfig
    ]);
    // ===================== Columns Change =====================
    var fillColumnValue = function fillColumnValue(val, func) {
        if (val === null) return null;
        return generateConfig[func](triggerDateTmpl, val);
    };
    var getNextHourTime = function getNextHourTime(val) {
        return fillColumnValue(val, 'setHour');
    };
    var getNextMinuteTime = function getNextMinuteTime(val) {
        return fillColumnValue(val, 'setMinute');
    };
    var getNextSecondTime = function getNextSecondTime(val) {
        return fillColumnValue(val, 'setSecond');
    };
    var getNextMillisecondTime = function getNextMillisecondTime(val) {
        return fillColumnValue(val, 'setMillisecond');
    };
    var getMeridiemTime = function getMeridiemTime(val) {
        if (val === null) return null;
        if (val === 'am' && !isAM(hour)) return generateConfig.setHour(triggerDateTmpl, hour - 12);
        else if (val === 'pm' && isAM(hour)) return generateConfig.setHour(triggerDateTmpl, hour + 12);
        return triggerDateTmpl;
    };
    var onHourChange = function onHourChange(val) {
        triggerChange(getNextHourTime(val));
    };
    var onMinuteChange = function onMinuteChange(val) {
        triggerChange(getNextMinuteTime(val));
    };
    var onSecondChange = function onSecondChange(val) {
        triggerChange(getNextSecondTime(val));
    };
    var onMillisecondChange = function onMillisecondChange(val) {
        triggerChange(getNextMillisecondTime(val));
    };
    var onMeridiemChange = function onMeridiemChange(val) {
        triggerChange(getMeridiemTime(val));
    };
    // ====================== Column Hover ======================
    var onHourHover = function onHourHover(val) {
        onHover(getNextHourTime(val));
    };
    var onMinuteHover = function onMinuteHover(val) {
        onHover(getNextMinuteTime(val));
    };
    var onSecondHover = function onSecondHover(val) {
        onHover(getNextSecondTime(val));
    };
    var onMillisecondHover = function onMillisecondHover(val) {
        onHover(getNextMillisecondTime(val));
    };
    var onMeridiemHover = function onMeridiemHover(val) {
        onHover(getMeridiemTime(val));
    };
    // ========================= Render =========================
    var sharedColumnProps = {
        onDblClick: onCellDblClick,
        changeOnScroll: changeOnScroll
    };
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)("".concat(prefixCls, "-content"), classNames.content),
        style: styles.content
    }, showHour && /*#__PURE__*/ _react.createElement((0, _timeColumnDefault.default), _extends({
        units: hourUnits,
        value: hour,
        optionalValue: pickerHour,
        type: "hour",
        onChange: onHourChange,
        onHover: onHourHover
    }, sharedColumnProps)), showMinute && /*#__PURE__*/ _react.createElement((0, _timeColumnDefault.default), _extends({
        units: minuteUnits,
        value: minute,
        optionalValue: pickerMinute,
        type: "minute",
        onChange: onMinuteChange,
        onHover: onMinuteHover
    }, sharedColumnProps)), showSecond && /*#__PURE__*/ _react.createElement((0, _timeColumnDefault.default), _extends({
        units: secondUnits,
        value: second,
        optionalValue: pickerSecond,
        type: "second",
        onChange: onSecondChange,
        onHover: onSecondHover
    }, sharedColumnProps)), showMillisecond && /*#__PURE__*/ _react.createElement((0, _timeColumnDefault.default), _extends({
        units: millisecondUnits,
        value: millisecond,
        optionalValue: pickerMillisecond,
        type: "millisecond",
        onChange: onMillisecondChange,
        onHover: onMillisecondHover
    }, sharedColumnProps)), showMeridiem && /*#__PURE__*/ _react.createElement((0, _timeColumnDefault.default), _extends({
        units: meridiemUnits,
        value: meridiem,
        type: "meridiem",
        onChange: onMeridiemChange,
        onHover: onMeridiemHover
    }, sharedColumnProps)));
}

},{"react":"bmhQu","../../../hooks/useTimeInfo":"jcxgQ","../../../utils/dateUtil":"gSKz6","../../context":"eEXYs","./TimeColumn":"7oAdz","clsx":"431Ou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7oAdz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>TimeColumn);
var _clsx = require("clsx");
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _react = require("react");
var _context = require("../../context");
var _useScrollTo = require("./useScrollTo");
var _useScrollToDefault = parcelHelpers.interopDefault(_useScrollTo);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var SCROLL_DELAY = 300;
// Not use JSON.stringify to avoid dead loop
function flattenUnits(units) {
    return units.map(function(_ref) {
        var value = _ref.value, label = _ref.label, disabled = _ref.disabled;
        return [
            value,
            label,
            disabled
        ].join(',');
    }).join(';');
}
function TimeColumn(props) {
    var units = props.units, value = props.value, optionalValue = props.optionalValue, type = props.type, onChange = props.onChange, onHover = props.onHover, onDblClick = props.onDblClick, changeOnScroll = props.changeOnScroll;
    var _usePanelContext = (0, _context.usePanelContext)(), prefixCls = _usePanelContext.prefixCls, cellRender = _usePanelContext.cellRender, now = _usePanelContext.now, locale = _usePanelContext.locale, classNames = _usePanelContext.classNames, styles = _usePanelContext.styles;
    var panelPrefixCls = "".concat(prefixCls, "-time-panel");
    var cellPrefixCls = "".concat(prefixCls, "-time-panel-cell");
    // ========================== Refs ==========================
    var ulRef = _react.useRef(null);
    // ========================= Scroll =========================
    var checkDelayRef = _react.useRef();
    var clearDelayCheck = function clearDelayCheck() {
        clearTimeout(checkDelayRef.current);
    };
    // ========================== Sync ==========================
    var _useScrollTo = (0, _useScrollToDefault.default)(ulRef, value !== null && value !== void 0 ? value : optionalValue), _useScrollTo2 = _slicedToArray(_useScrollTo, 3), syncScroll = _useScrollTo2[0], stopScroll = _useScrollTo2[1], isScrolling = _useScrollTo2[2];
    // Effect sync value scroll
    (0, _useLayoutEffectDefault.default)(function() {
        syncScroll();
        clearDelayCheck();
        return function() {
            stopScroll();
            clearDelayCheck();
        };
    }, [
        value,
        optionalValue,
        flattenUnits(units)
    ]);
    // ========================= Change =========================
    // Scroll event if sync onScroll
    var onInternalScroll = function onInternalScroll(event) {
        clearDelayCheck();
        var target = event.target;
        if (!isScrolling() && changeOnScroll) checkDelayRef.current = setTimeout(function() {
            var ul = ulRef.current;
            var firstLiTop = ul.querySelector("li").offsetTop;
            var liList = Array.from(ul.querySelectorAll("li"));
            var liTopList = liList.map(function(li) {
                return li.offsetTop - firstLiTop;
            });
            var liDistList = liTopList.map(function(top, index) {
                if (units[index].disabled) return Number.MAX_SAFE_INTEGER;
                return Math.abs(top - target.scrollTop);
            });
            // Find min distance index
            var minDist = Math.min.apply(Math, _toConsumableArray(liDistList));
            var minDistIndex = liDistList.findIndex(function(dist) {
                return dist === minDist;
            });
            var targetUnit = units[minDistIndex];
            if (targetUnit && !targetUnit.disabled) onChange(targetUnit.value);
        }, SCROLL_DELAY);
    };
    // ========================= Render =========================
    var columnPrefixCls = "".concat(panelPrefixCls, "-column");
    return /*#__PURE__*/ _react.createElement("ul", {
        className: columnPrefixCls,
        ref: ulRef,
        "data-type": type,
        onScroll: onInternalScroll
    }, units.map(function(_ref2) {
        var label = _ref2.label, unitValue = _ref2.value, disabled = _ref2.disabled;
        var inner = /*#__PURE__*/ _react.createElement("div", {
            className: "".concat(cellPrefixCls, "-inner")
        }, label);
        return /*#__PURE__*/ _react.createElement("li", {
            key: unitValue,
            style: styles.item,
            className: (0, _clsx.clsx)(cellPrefixCls, classNames.item, _defineProperty(_defineProperty({}, "".concat(cellPrefixCls, "-selected"), value === unitValue), "".concat(cellPrefixCls, "-disabled"), disabled)),
            onClick: function onClick() {
                if (!disabled) onChange(unitValue);
            },
            onDoubleClick: function onDoubleClick() {
                if (!disabled && onDblClick) onDblClick();
            },
            onMouseEnter: function onMouseEnter() {
                onHover(unitValue);
            },
            onMouseLeave: function onMouseLeave() {
                onHover(null);
            },
            "data-value": unitValue
        }, cellRender ? cellRender(unitValue, {
            prefixCls: prefixCls,
            originNode: inner,
            today: now,
            type: 'time',
            subType: type,
            locale: locale
        }) : inner);
    }));
}

},{"clsx":"431Ou","@rc-component/util/es/hooks/useLayoutEffect":"azwns","react":"bmhQu","../../context":"eEXYs","./useScrollTo":"dSjSK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dSjSK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useScrollTo);
var _util = require("@rc-component/util");
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _isVisible = require("@rc-component/util/es/Dom/isVisible");
var _isVisibleDefault = parcelHelpers.interopDefault(_isVisible);
var _react = require("react");
var SPEED_PTG = 1 / 3;
function useScrollTo(ulRef, value) {
    // ========================= Scroll =========================
    var scrollingRef = _react.useRef(false);
    var scrollRafRef = _react.useRef(null);
    var scrollDistRef = _react.useRef(null);
    var isScrolling = function isScrolling() {
        return scrollingRef.current;
    };
    var stopScroll = function stopScroll() {
        (0, _rafDefault.default).cancel(scrollRafRef.current);
        scrollingRef.current = false;
    };
    var scrollRafTimesRef = _react.useRef();
    var startScroll = function startScroll() {
        var ul = ulRef.current;
        scrollDistRef.current = null;
        scrollRafTimesRef.current = 0;
        if (ul) {
            var targetLi = ul.querySelector("[data-value=\"".concat(value, "\"]"));
            var firstLi = ul.querySelector("li");
            var doScroll = function doScroll() {
                stopScroll();
                scrollingRef.current = true;
                scrollRafTimesRef.current += 1;
                var currentTop = ul.scrollTop;
                var firstLiTop = firstLi.offsetTop;
                var targetLiTop = targetLi.offsetTop;
                var targetTop = targetLiTop - firstLiTop;
                // Wait for element exist. 5 frames is enough
                if (targetLiTop === 0 && targetLi !== firstLi || !(0, _isVisibleDefault.default)(ul)) {
                    if (scrollRafTimesRef.current <= 5) scrollRafRef.current = (0, _rafDefault.default)(doScroll);
                    return;
                }
                var nextTop = currentTop + (targetTop - currentTop) * SPEED_PTG;
                var dist = Math.abs(targetTop - nextTop);
                // Break if dist get larger, which means user is scrolling
                if (scrollDistRef.current !== null && scrollDistRef.current < dist) {
                    stopScroll();
                    return;
                }
                scrollDistRef.current = dist;
                // Stop when dist is less than 1
                if (dist <= 1) {
                    ul.scrollTop = targetTop;
                    stopScroll();
                    return;
                }
                // IE not support `scrollTo`
                ul.scrollTop = nextTop;
                scrollRafRef.current = (0, _rafDefault.default)(doScroll);
            };
            if (targetLi && firstLi) doScroll();
        }
    };
    // ======================== Trigger =========================
    var syncScroll = (0, _util.useEvent)(startScroll);
    return [
        syncScroll,
        stopScroll,
        isScrolling
    ];
}

},{"@rc-component/util":"6ZBDN","@rc-component/util/es/raf":"ajbAx","@rc-component/util/es/Dom/isVisible":"frSWl","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hCetW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>DecadePanel);
var _react = require("react");
var _dateUtil = require("../../utils/dateUtil");
var _context = require("../context");
var _panelBody = require("../PanelBody");
var _panelBodyDefault = parcelHelpers.interopDefault(_panelBody);
var _panelHeader = require("../PanelHeader");
var _panelHeaderDefault = parcelHelpers.interopDefault(_panelHeader);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function DecadePanel(props) {
    var prefixCls = props.prefixCls, locale = props.locale, generateConfig = props.generateConfig, pickerValue = props.pickerValue, disabledDate = props.disabledDate, onPickerValueChange = props.onPickerValueChange;
    var panelPrefixCls = "".concat(prefixCls, "-decade-panel");
    // ========================== Base ==========================
    var _useInfo = (0, _context.useInfo)(props, 'decade'), _useInfo2 = _slicedToArray(_useInfo, 1), info = _useInfo2[0];
    var getStartYear = function getStartYear(date) {
        var startYear = Math.floor(generateConfig.getYear(date) / 100) * 100;
        return generateConfig.setYear(date, startYear);
    };
    var getEndYear = function getEndYear(date) {
        var startYear = getStartYear(date);
        return generateConfig.addYear(startYear, 99);
    };
    var startYearDate = getStartYear(pickerValue);
    var endYearDate = getEndYear(pickerValue);
    var baseDate = generateConfig.addYear(startYearDate, -10);
    // ========================= Cells ==========================
    var getCellDate = function getCellDate(date, offset) {
        return generateConfig.addYear(date, offset * 10);
    };
    var getCellText = function getCellText(date) {
        var cellYearFormat = locale.cellYearFormat;
        var startYearStr = (0, _dateUtil.formatValue)(date, {
            locale: locale,
            format: cellYearFormat,
            generateConfig: generateConfig
        });
        var endYearStr = (0, _dateUtil.formatValue)(generateConfig.addYear(date, 9), {
            locale: locale,
            format: cellYearFormat,
            generateConfig: generateConfig
        });
        return "".concat(startYearStr, "-").concat(endYearStr);
    };
    var getCellClassName = function getCellClassName(date) {
        return _defineProperty({}, "".concat(prefixCls, "-cell-in-view"), (0, _dateUtil.isSameDecade)(generateConfig, date, startYearDate) || (0, _dateUtil.isSameDecade)(generateConfig, date, endYearDate) || (0, _dateUtil.isInRange)(generateConfig, startYearDate, endYearDate, date));
    };
    // ======================== Disabled ========================
    var mergedDisabledDate = disabledDate ? function(currentDate, disabledInfo) {
        // Start
        var baseStartDate = generateConfig.setDate(currentDate, 1);
        var baseStartMonth = generateConfig.setMonth(baseStartDate, 0);
        var baseStartYear = generateConfig.setYear(baseStartMonth, Math.floor(generateConfig.getYear(baseStartMonth) / 10) * 10);
        // End
        var baseEndYear = generateConfig.addYear(baseStartYear, 10);
        var baseEndDate = generateConfig.addDate(baseEndYear, -1);
        return disabledDate(baseStartYear, disabledInfo) && disabledDate(baseEndDate, disabledInfo);
    } : null;
    // ========================= Header =========================
    var yearNode = "".concat((0, _dateUtil.formatValue)(startYearDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }), "-").concat((0, _dateUtil.formatValue)(endYearDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    // ========================= Render =========================
    return /*#__PURE__*/ _react.createElement((0, _context.PanelContext).Provider, {
        value: info
    }, /*#__PURE__*/ _react.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ _react.createElement((0, _panelHeaderDefault.default), {
        superOffset: function superOffset(distance) {
            return generateConfig.addYear(pickerValue, distance * 100);
        },
        onChange: onPickerValueChange,
        getStart: getStartYear,
        getEnd: getEndYear
    }, yearNode), /*#__PURE__*/ _react.createElement((0, _panelBodyDefault.default), _extends({}, props, {
        disabledDate: mergedDisabledDate,
        colNum: 3,
        rowNum: 4,
        baseDate: baseDate,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName
    }))));
}

},{"react":"bmhQu","../../utils/dateUtil":"gSKz6","../context":"eEXYs","../PanelBody":"8aeMR","../PanelHeader":"hqaaU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"mAiyA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MonthPanel);
var _react = require("react");
var _dateUtil = require("../../utils/dateUtil");
var _context = require("../context");
var _panelBody = require("../PanelBody");
var _panelBodyDefault = parcelHelpers.interopDefault(_panelBody);
var _panelHeader = require("../PanelHeader");
var _panelHeaderDefault = parcelHelpers.interopDefault(_panelHeader);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function MonthPanel(props) {
    var prefixCls = props.prefixCls, locale = props.locale, generateConfig = props.generateConfig, pickerValue = props.pickerValue, disabledDate = props.disabledDate, onPickerValueChange = props.onPickerValueChange, onModeChange = props.onModeChange;
    var panelPrefixCls = "".concat(prefixCls, "-month-panel");
    // ========================== Base ==========================
    var _useInfo = (0, _context.useInfo)(props, 'month'), _useInfo2 = _slicedToArray(_useInfo, 1), info = _useInfo2[0];
    var baseDate = generateConfig.setMonth(pickerValue, 0);
    // ========================= Month ==========================
    var monthsLocale = locale.shortMonths || (generateConfig.locale.getShortMonths ? generateConfig.locale.getShortMonths(locale.locale) : []);
    // ========================= Cells ==========================
    var getCellDate = function getCellDate(date, offset) {
        return generateConfig.addMonth(date, offset);
    };
    var getCellText = function getCellText(date) {
        var month = generateConfig.getMonth(date);
        return locale.monthFormat ? (0, _dateUtil.formatValue)(date, {
            locale: locale,
            format: locale.monthFormat,
            generateConfig: generateConfig
        }) : monthsLocale[month];
    };
    var getCellClassName = function getCellClassName() {
        return _defineProperty({}, "".concat(prefixCls, "-cell-in-view"), true);
    };
    // ======================== Disabled ========================
    var mergedDisabledDate = disabledDate ? function(currentDate, disabledInfo) {
        var startDate = generateConfig.setDate(currentDate, 1);
        var nextMonthStartDate = generateConfig.setMonth(startDate, generateConfig.getMonth(startDate) + 1);
        var endDate = generateConfig.addDate(nextMonthStartDate, -1);
        return disabledDate(startDate, disabledInfo) && disabledDate(endDate, disabledInfo);
    } : null;
    // ========================= Header =========================
    var yearNode = /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        key: "year",
        "aria-label": locale.yearSelect,
        onClick: function onClick() {
            onModeChange('year');
        },
        tabIndex: -1,
        className: "".concat(prefixCls, "-year-btn")
    }, (0, _dateUtil.formatValue)(pickerValue, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    // ========================= Render =========================
    return /*#__PURE__*/ _react.createElement((0, _context.PanelContext).Provider, {
        value: info
    }, /*#__PURE__*/ _react.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ _react.createElement((0, _panelHeaderDefault.default), {
        superOffset: function superOffset(distance) {
            return generateConfig.addYear(pickerValue, distance);
        },
        onChange: onPickerValueChange,
        getStart: function getStart(date) {
            return generateConfig.setMonth(date, 0);
        },
        getEnd: function getEnd(date) {
            return generateConfig.setMonth(date, 11);
        }
    }, yearNode), /*#__PURE__*/ _react.createElement((0, _panelBodyDefault.default), _extends({}, props, {
        disabledDate: mergedDisabledDate,
        titleFormat: locale.fieldMonthFormat,
        colNum: 3,
        rowNum: 4,
        baseDate: baseDate,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName
    }))));
}

},{"react":"bmhQu","../../utils/dateUtil":"gSKz6","../context":"eEXYs","../PanelBody":"8aeMR","../PanelHeader":"hqaaU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"49p1Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>QuarterPanel);
var _react = require("react");
var _dateUtil = require("../../utils/dateUtil");
var _context = require("../context");
var _panelBody = require("../PanelBody");
var _panelBodyDefault = parcelHelpers.interopDefault(_panelBody);
var _panelHeader = require("../PanelHeader");
var _panelHeaderDefault = parcelHelpers.interopDefault(_panelHeader);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function QuarterPanel(props) {
    var prefixCls = props.prefixCls, locale = props.locale, generateConfig = props.generateConfig, pickerValue = props.pickerValue, onPickerValueChange = props.onPickerValueChange, onModeChange = props.onModeChange;
    var panelPrefixCls = "".concat(prefixCls, "-quarter-panel");
    // ========================== Base ==========================
    var _useInfo = (0, _context.useInfo)(props, 'quarter'), _useInfo2 = _slicedToArray(_useInfo, 1), info = _useInfo2[0];
    var baseDate = generateConfig.setMonth(pickerValue, 0);
    // ========================= Cells ==========================
    var getCellDate = function getCellDate(date, offset) {
        return generateConfig.addMonth(date, offset * 3);
    };
    var getCellText = function getCellText(date) {
        return (0, _dateUtil.formatValue)(date, {
            locale: locale,
            format: locale.cellQuarterFormat,
            generateConfig: generateConfig
        });
    };
    var getCellClassName = function getCellClassName() {
        return _defineProperty({}, "".concat(prefixCls, "-cell-in-view"), true);
    };
    // ========================= Header =========================
    var yearNode = /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        key: "year",
        "aria-label": locale.yearSelect,
        onClick: function onClick() {
            onModeChange('year');
        },
        tabIndex: -1,
        className: "".concat(prefixCls, "-year-btn")
    }, (0, _dateUtil.formatValue)(pickerValue, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    // ========================= Render =========================
    return /*#__PURE__*/ _react.createElement((0, _context.PanelContext).Provider, {
        value: info
    }, /*#__PURE__*/ _react.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ _react.createElement((0, _panelHeaderDefault.default), {
        superOffset: function superOffset(distance) {
            return generateConfig.addYear(pickerValue, distance);
        },
        onChange: onPickerValueChange,
        getStart: function getStart(date) {
            return generateConfig.setMonth(date, 0);
        },
        getEnd: function getEnd(date) {
            return generateConfig.setMonth(date, 11);
        }
    }, yearNode), /*#__PURE__*/ _react.createElement((0, _panelBodyDefault.default), _extends({}, props, {
        titleFormat: locale.fieldQuarterFormat,
        colNum: 4,
        rowNum: 1,
        baseDate: baseDate,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName
    }))));
}

},{"react":"bmhQu","../../utils/dateUtil":"gSKz6","../context":"eEXYs","../PanelBody":"8aeMR","../PanelHeader":"hqaaU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"311z1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>WeekPanel);
var _clsx = require("clsx");
var _react = require("react");
var _dateUtil = require("../../utils/dateUtil");
var _datePanel = require("../DatePanel");
var _datePanelDefault = parcelHelpers.interopDefault(_datePanel);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function WeekPanel(props) {
    var prefixCls = props.prefixCls, generateConfig = props.generateConfig, locale = props.locale, value = props.value, hoverValue = props.hoverValue, hoverRangeValue = props.hoverRangeValue;
    // =============================== Row ================================
    var localeName = locale.locale;
    var rowPrefixCls = "".concat(prefixCls, "-week-panel-row");
    var rowClassName = function rowClassName(currentDate) {
        var rangeCls = {};
        if (hoverRangeValue) {
            var _hoverRangeValue = _slicedToArray(hoverRangeValue, 2), rangeStart = _hoverRangeValue[0], rangeEnd = _hoverRangeValue[1];
            var isRangeStart = (0, _dateUtil.isSameWeek)(generateConfig, localeName, rangeStart, currentDate);
            var isRangeEnd = (0, _dateUtil.isSameWeek)(generateConfig, localeName, rangeEnd, currentDate);
            rangeCls["".concat(rowPrefixCls, "-range-start")] = isRangeStart;
            rangeCls["".concat(rowPrefixCls, "-range-end")] = isRangeEnd;
            rangeCls["".concat(rowPrefixCls, "-range-hover")] = !isRangeStart && !isRangeEnd && (0, _dateUtil.isInRange)(generateConfig, rangeStart, rangeEnd, currentDate);
        }
        if (hoverValue) rangeCls["".concat(rowPrefixCls, "-hover")] = hoverValue.some(function(date) {
            return (0, _dateUtil.isSameWeek)(generateConfig, localeName, currentDate, date);
        });
        return (0, _clsx.clsx)(rowPrefixCls, _defineProperty({}, "".concat(rowPrefixCls, "-selected"), !hoverRangeValue && (0, _dateUtil.isSameWeek)(generateConfig, localeName, value, currentDate)), // Patch for hover range
        rangeCls);
    };
    // ============================== Render ==============================
    return /*#__PURE__*/ _react.createElement((0, _datePanelDefault.default), _extends({}, props, {
        mode: "week",
        panelName: "week",
        rowClassName: rowClassName
    }));
}

},{"clsx":"431Ou","react":"bmhQu","../../utils/dateUtil":"gSKz6","../DatePanel":"annzN","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jPlv7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>YearPanel);
var _react = require("react");
var _dateUtil = require("../../utils/dateUtil");
var _context = require("../context");
var _panelBody = require("../PanelBody");
var _panelBodyDefault = parcelHelpers.interopDefault(_panelBody);
var _panelHeader = require("../PanelHeader");
var _panelHeaderDefault = parcelHelpers.interopDefault(_panelHeader);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function YearPanel(props) {
    var prefixCls = props.prefixCls, locale = props.locale, generateConfig = props.generateConfig, pickerValue = props.pickerValue, disabledDate = props.disabledDate, onPickerValueChange = props.onPickerValueChange, onModeChange = props.onModeChange;
    var panelPrefixCls = "".concat(prefixCls, "-year-panel");
    // ========================== Base ==========================
    var _useInfo = (0, _context.useInfo)(props, 'year'), _useInfo2 = _slicedToArray(_useInfo, 1), info = _useInfo2[0];
    var getStartYear = function getStartYear(date) {
        var startYear = Math.floor(generateConfig.getYear(date) / 10) * 10;
        return generateConfig.setYear(date, startYear);
    };
    var getEndYear = function getEndYear(date) {
        var startYear = getStartYear(date);
        return generateConfig.addYear(startYear, 9);
    };
    var startYearDate = getStartYear(pickerValue);
    var endYearDate = getEndYear(pickerValue);
    var baseDate = generateConfig.addYear(startYearDate, -1);
    // ========================= Cells ==========================
    var getCellDate = function getCellDate(date, offset) {
        return generateConfig.addYear(date, offset);
    };
    var getCellText = function getCellText(date) {
        return (0, _dateUtil.formatValue)(date, {
            locale: locale,
            format: locale.cellYearFormat,
            generateConfig: generateConfig
        });
    };
    var getCellClassName = function getCellClassName(date) {
        return _defineProperty({}, "".concat(prefixCls, "-cell-in-view"), (0, _dateUtil.isSameYear)(generateConfig, date, startYearDate) || (0, _dateUtil.isSameYear)(generateConfig, date, endYearDate) || (0, _dateUtil.isInRange)(generateConfig, startYearDate, endYearDate, date));
    };
    // ======================== Disabled ========================
    var mergedDisabledDate = disabledDate ? function(currentDate, disabledInfo) {
        // Start
        var startMonth = generateConfig.setMonth(currentDate, 0);
        var startDate = generateConfig.setDate(startMonth, 1);
        // End
        var endMonth = generateConfig.addYear(startDate, 1);
        var endDate = generateConfig.addDate(endMonth, -1);
        return disabledDate(startDate, disabledInfo) && disabledDate(endDate, disabledInfo);
    } : null;
    // ========================= Header =========================
    var yearNode = /*#__PURE__*/ _react.createElement("button", {
        type: "button",
        key: "decade",
        "aria-label": locale.decadeSelect,
        onClick: function onClick() {
            onModeChange('decade');
        },
        tabIndex: -1,
        className: "".concat(prefixCls, "-decade-btn")
    }, (0, _dateUtil.formatValue)(startYearDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }), "-", (0, _dateUtil.formatValue)(endYearDate, {
        locale: locale,
        format: locale.yearFormat,
        generateConfig: generateConfig
    }));
    // ========================= Render =========================
    return /*#__PURE__*/ _react.createElement((0, _context.PanelContext).Provider, {
        value: info
    }, /*#__PURE__*/ _react.createElement("div", {
        className: panelPrefixCls
    }, /*#__PURE__*/ _react.createElement((0, _panelHeaderDefault.default), {
        superOffset: function superOffset(distance) {
            return generateConfig.addYear(pickerValue, distance * 10);
        },
        onChange: onPickerValueChange,
        getStart: getStartYear,
        getEnd: getEndYear
    }, yearNode), /*#__PURE__*/ _react.createElement((0, _panelBodyDefault.default), _extends({}, props, {
        disabledDate: mergedDisabledDate,
        titleFormat: locale.fieldYearFormat,
        colNum: 3,
        rowNum: 4,
        baseDate: baseDate,
        getCellDate: getCellDate,
        getCellText: getCellText,
        getCellClassName: getCellClassName
    }))));
}

},{"react":"bmhQu","../../utils/dateUtil":"gSKz6","../context":"eEXYs","../PanelBody":"8aeMR","../PanelHeader":"hqaaU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3XqCZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>PresetPanel);
var _react = require("react");
function executeValue(value) {
    return typeof value === 'function' ? value() : value;
}
function PresetPanel(props) {
    var prefixCls = props.prefixCls, presets = props.presets, _onClick = props.onClick, onHover = props.onHover;
    if (!presets.length) return null;
    return /*#__PURE__*/ _react.createElement("div", {
        className: "".concat(prefixCls, "-presets")
    }, /*#__PURE__*/ _react.createElement("ul", null, presets.map(function(_ref, index) {
        var label = _ref.label, value = _ref.value;
        return /*#__PURE__*/ _react.createElement("li", {
            key: index,
            onClick: function onClick() {
                _onClick(executeValue(value));
            },
            onMouseEnter: function onMouseEnter() {
                onHover(executeValue(value));
            },
            onMouseLeave: function onMouseLeave() {
                onHover(null);
            }
        }, label);
    })));
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4I3HW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _resizeObserver = require("@rc-component/resize-observer");
var _resizeObserverDefault = parcelHelpers.interopDefault(_resizeObserver);
var _util = require("@rc-component/util");
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _useInputProps = require("./hooks/useInputProps");
var _useInputPropsDefault = parcelHelpers.interopDefault(_useInputProps);
var _useRootProps = require("./hooks/useRootProps");
var _useRootPropsDefault = parcelHelpers.interopDefault(_useRootProps);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _excluded = [
    "id",
    "prefix",
    "clearIcon",
    "suffixIcon",
    "separator",
    "activeIndex",
    "activeHelp",
    "allHelp",
    "focused",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "locale",
    "generateConfig",
    "placeholder",
    "className",
    "style",
    "onClick",
    "onClear",
    "value",
    "onChange",
    "onSubmit",
    "onInputChange",
    "format",
    "maskFormat",
    "preserveInvalidOnBlur",
    "onInvalid",
    "disabled",
    "invalid",
    "inputReadOnly",
    "direction",
    "onOpenChange",
    "onActiveInfo",
    "placement",
    "onMouseDown",
    "required",
    "aria-required",
    "autoFocus",
    "tabIndex"
], _excluded2 = [
    "index"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function RangeSelector(props, ref) {
    var id = props.id, prefix = props.prefix, clearIcon = props.clearIcon, suffixIcon = props.suffixIcon, _props$separator = props.separator, separator = _props$separator === void 0 ? '~' : _props$separator, activeIndex = props.activeIndex, activeHelp = props.activeHelp, allHelp = props.allHelp, focused = props.focused, onFocus = props.onFocus, onBlur = props.onBlur, onKeyDown = props.onKeyDown, locale = props.locale, generateConfig = props.generateConfig, placeholder = props.placeholder, className = props.className, style = props.style, onClick = props.onClick, onClear = props.onClear, value = props.value, onChange = props.onChange, onSubmit = props.onSubmit, onInputChange = props.onInputChange, format = props.format, maskFormat = props.maskFormat, preserveInvalidOnBlur = props.preserveInvalidOnBlur, onInvalid = props.onInvalid, disabled = props.disabled, invalid = props.invalid, inputReadOnly = props.inputReadOnly, direction = props.direction, onOpenChange = props.onOpenChange, onActiveInfo = props.onActiveInfo, placement = props.placement, _onMouseDown = props.onMouseDown, required = props.required, ariaRequired = props['aria-required'], autoFocus = props.autoFocus, tabIndex = props.tabIndex, restProps = _objectWithoutProperties(props, _excluded);
    var rtl = direction === 'rtl';
    // ======================== Prefix ========================
    var _React$useContext = _react.useContext((0, _contextDefault.default)), prefixCls = _React$useContext.prefixCls, classNames = _React$useContext.classNames, styles = _React$useContext.styles;
    // ========================== Id ==========================
    var ids = _react.useMemo(function() {
        if (typeof id === 'string') return [
            id
        ];
        var mergedId = id || {};
        return [
            mergedId.start,
            mergedId.end
        ];
    }, [
        id
    ]);
    // ========================= Refs =========================
    var rootRef = _react.useRef();
    var inputStartRef = _react.useRef();
    var inputEndRef = _react.useRef();
    var getInput = function getInput(index) {
        var _index;
        return (_index = [
            inputStartRef,
            inputEndRef
        ][index]) === null || _index === void 0 ? void 0 : _index.current;
    };
    _react.useImperativeHandle(ref, function() {
        return {
            nativeElement: rootRef.current,
            focus: function focus(options) {
                if (_typeof(options) === 'object') {
                    var _getInput;
                    var _ref = options || {}, _ref$index = _ref.index, _index2 = _ref$index === void 0 ? 0 : _ref$index, rest = _objectWithoutProperties(_ref, _excluded2);
                    (_getInput = getInput(_index2)) === null || _getInput === void 0 || _getInput.focus(rest);
                } else {
                    var _getInput2;
                    (_getInput2 = getInput(options !== null && options !== void 0 ? options : 0)) === null || _getInput2 === void 0 || _getInput2.focus();
                }
            },
            blur: function blur() {
                var _getInput3, _getInput4;
                (_getInput3 = getInput(0)) === null || _getInput3 === void 0 || _getInput3.blur();
                (_getInput4 = getInput(1)) === null || _getInput4 === void 0 || _getInput4.blur();
            }
        };
    });
    // ======================== Props =========================
    var rootProps = (0, _useRootPropsDefault.default)(restProps);
    // ===================== Placeholder ======================
    var mergedPlaceholder = _react.useMemo(function() {
        return Array.isArray(placeholder) ? placeholder : [
            placeholder,
            placeholder
        ];
    }, [
        placeholder
    ]);
    // ======================== Inputs ========================
    var _useInputProps = (0, _useInputPropsDefault.default)(_objectSpread(_objectSpread({}, props), {}, {
        id: ids,
        placeholder: mergedPlaceholder
    })), _useInputProps2 = _slicedToArray(_useInputProps, 1), getInputProps = _useInputProps2[0];
    // ====================== ActiveBar =======================
    var _React$useState = _react.useState({
        position: 'absolute',
        width: 0
    }), _React$useState2 = _slicedToArray(_React$useState, 2), activeBarStyle = _React$useState2[0], setActiveBarStyle = _React$useState2[1];
    var syncActiveOffset = (0, _util.useEvent)(function() {
        var input = getInput(activeIndex);
        if (input) {
            var inputRect = input.nativeElement.getBoundingClientRect();
            var parentRect = rootRef.current.getBoundingClientRect();
            var rectOffset = inputRect.left - parentRect.left;
            setActiveBarStyle(function(ori) {
                return _objectSpread(_objectSpread({}, ori), {}, {
                    width: inputRect.width,
                    left: rectOffset
                });
            });
            onActiveInfo([
                inputRect.left,
                inputRect.right,
                parentRect.width
            ]);
        }
    });
    _react.useEffect(function() {
        syncActiveOffset();
    }, [
        activeIndex
    ]);
    // ======================== Clear =========================
    var showClear = clearIcon && (value[0] && !disabled[0] || value[1] && !disabled[1]);
    // ======================= Disabled =======================
    var startAutoFocus = autoFocus && !disabled[0];
    var endAutoFocus = autoFocus && !startAutoFocus && !disabled[1];
    // ======================== Render ========================
    return /*#__PURE__*/ _react.createElement((0, _resizeObserverDefault.default), {
        onResize: syncActiveOffset
    }, /*#__PURE__*/ _react.createElement("div", _extends({}, rootProps, {
        className: (0, _clsx.clsx)(prefixCls, "".concat(prefixCls, "-range"), _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-focused"), focused), "".concat(prefixCls, "-disabled"), disabled.every(function(i) {
            return i;
        })), "".concat(prefixCls, "-invalid"), invalid.some(function(i) {
            return i;
        })), "".concat(prefixCls, "-rtl"), rtl), className),
        style: style,
        ref: rootRef,
        onClick: onClick,
        onMouseDown: function onMouseDown(e) {
            var target = e.target;
            if (target !== inputStartRef.current.inputElement && target !== inputEndRef.current.inputElement) e.preventDefault();
            _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(e);
        }
    }), prefix && /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)("".concat(prefixCls, "-prefix"), classNames.prefix),
        style: styles.prefix
    }, prefix), /*#__PURE__*/ _react.createElement((0, _inputDefault.default), _extends({
        ref: inputStartRef
    }, getInputProps(0), {
        className: "".concat(prefixCls, "-input-start"),
        autoFocus: startAutoFocus,
        tabIndex: tabIndex,
        "date-range": "start"
    })), /*#__PURE__*/ _react.createElement("div", {
        className: "".concat(prefixCls, "-range-separator")
    }, separator), /*#__PURE__*/ _react.createElement((0, _inputDefault.default), _extends({
        ref: inputEndRef
    }, getInputProps(1), {
        className: "".concat(prefixCls, "-input-end"),
        autoFocus: endAutoFocus,
        tabIndex: tabIndex,
        "date-range": "end"
    })), /*#__PURE__*/ _react.createElement("div", {
        className: "".concat(prefixCls, "-active-bar"),
        style: activeBarStyle
    }), /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
        type: "suffix",
        icon: suffixIcon
    }), showClear && /*#__PURE__*/ _react.createElement((0, _icon.ClearIcon), {
        icon: clearIcon,
        onClear: onClear
    })));
}
var RefRangeSelector = /*#__PURE__*/ _react.forwardRef(RangeSelector);
exports.default = RefRangeSelector;

},{"clsx":"431Ou","@rc-component/resize-observer":"4dgtN","@rc-component/util":"6ZBDN","react":"bmhQu","../context":"afG3N","./hooks/useInputProps":"hVYVK","./hooks/useRootProps":"1oByy","./Icon":"8fnok","./Input":"ktoov","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hVYVK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useInputProps);
var _util = require("@rc-component/util");
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
var _react = require("react");
var _dateUtil = require("../../../utils/dateUtil");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function useInputProps(props, /** Used for SinglePicker */ postProps) {
    var format = props.format, maskFormat = props.maskFormat, generateConfig = props.generateConfig, locale = props.locale, preserveInvalidOnBlur = props.preserveInvalidOnBlur, inputReadOnly = props.inputReadOnly, required = props.required, ariaRequired = props['aria-required'], onSubmit = props.onSubmit, _onFocus = props.onFocus, _onBlur = props.onBlur, onInputChange = props.onInputChange, onInvalid = props.onInvalid, open = props.open, onOpenChange = props.onOpenChange, _onKeyDown = props.onKeyDown, _onChange = props.onChange, activeHelp = props.activeHelp, name = props.name, autoComplete = props.autoComplete, id = props.id, value = props.value, invalid = props.invalid, placeholder = props.placeholder, disabled = props.disabled, activeIndex = props.activeIndex, allHelp = props.allHelp, picker = props.picker;
    // ======================== Parser ========================
    var parseDate = function parseDate(str, formatStr) {
        var parsed = generateConfig.locale.parse(locale.locale, str, [
            formatStr
        ]);
        return parsed && generateConfig.isValidate(parsed) ? parsed : null;
    };
    // ========================= Text =========================
    var firstFormat = format[0];
    var getText = _react.useCallback(function(date) {
        return (0, _dateUtil.formatValue)(date, {
            locale: locale,
            format: firstFormat,
            generateConfig: generateConfig
        });
    }, [
        locale,
        generateConfig,
        firstFormat
    ]);
    var valueTexts = _react.useMemo(function() {
        return value.map(getText);
    }, [
        value,
        getText
    ]);
    // ========================= Size =========================
    var size = _react.useMemo(function() {
        var defaultSize = picker === 'time' ? 8 : 10;
        var length = typeof firstFormat === 'function' ? firstFormat(generateConfig.getNow()).length : firstFormat.length;
        return Math.max(defaultSize, length) + 2;
    }, [
        firstFormat,
        picker,
        generateConfig
    ]);
    // ======================= Validate =======================
    var _validateFormat = function validateFormat(text) {
        for(var i = 0; i < format.length; i += 1){
            var singleFormat = format[i];
            // Only support string type
            if (typeof singleFormat === 'string') {
                var parsed = parseDate(text, singleFormat);
                if (parsed) return parsed;
            }
        }
        return false;
    };
    // ======================== Input =========================
    var getInputProps = function getInputProps(index) {
        function getProp(propValue) {
            return index !== undefined ? propValue[index] : propValue;
        }
        var pickedAttrs = (0, _pickAttrsDefault.default)(props, {
            aria: true,
            data: true
        });
        var inputProps = _objectSpread(_objectSpread({}, pickedAttrs), {}, {
            // ============== Shared ==============
            format: maskFormat,
            validateFormat: function validateFormat(text) {
                return !!_validateFormat(text);
            },
            preserveInvalidOnBlur: preserveInvalidOnBlur,
            readOnly: inputReadOnly,
            required: required,
            'aria-required': ariaRequired,
            name: name,
            autoComplete: autoComplete,
            size: size,
            // ============= By Index =============
            id: getProp(id),
            value: getProp(valueTexts) || '',
            invalid: getProp(invalid),
            placeholder: getProp(placeholder),
            active: activeIndex === index,
            helped: allHelp || activeHelp && activeIndex === index,
            disabled: getProp(disabled),
            onFocus: function onFocus(event) {
                _onFocus(event, index);
            },
            onBlur: function onBlur(event) {
                // Blur do not trigger close
                // Since it may focus to the popup panel
                _onBlur(event, index);
            },
            onSubmit: onSubmit,
            // Get validate text value
            onChange: function onChange(text) {
                onInputChange();
                var parsed = _validateFormat(text);
                if (parsed) {
                    onInvalid(false, index);
                    _onChange(parsed, index);
                    return;
                }
                // Tell outer that the value typed is invalid.
                // If text is empty, it means valid.
                onInvalid(!!text, index);
            },
            onHelp: function onHelp() {
                onOpenChange(true, {
                    index: index
                });
            },
            onKeyDown: function onKeyDown(event) {
                var prevented = false;
                _onKeyDown === null || _onKeyDown === void 0 || _onKeyDown(event, function() {
                    prevented = true;
                });
                if (!event.defaultPrevented && !prevented) switch(event.key){
                    case 'Escape':
                        onOpenChange(false, {
                            index: index
                        });
                        break;
                    case 'Enter':
                        if (!open) onOpenChange(true);
                        break;
                }
            }
        }, postProps === null || postProps === void 0 ? void 0 : postProps({
            valueTexts: valueTexts
        }));
        // ============== Clean Up ==============
        Object.keys(inputProps).forEach(function(key) {
            if (inputProps[key] === undefined) delete inputProps[key];
        });
        return inputProps;
    };
    return [
        getInputProps,
        getText
    ];
}

},{"@rc-component/util":"6ZBDN","@rc-component/util/es/pickAttrs":"jGMGD","react":"bmhQu","../../../utils/dateUtil":"gSKz6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1oByy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRootProps);
var _react = require("react");
var _miscUtil = require("../../../utils/miscUtil");
var propNames = [
    'onMouseEnter',
    'onMouseLeave'
];
function useRootProps(props) {
    return _react.useMemo(function() {
        return (0, _miscUtil.pickProps)(props, propNames);
    }, [
        props
    ]);
}

},{"react":"bmhQu","../../../utils/miscUtil":"2yPUL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8fnok":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>Icon);
parcelHelpers.export(exports, "ClearIcon", ()=>ClearIcon);
var _react = require("react");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _clsx = require("clsx");
var _excluded = [
    "icon",
    "type"
], _excluded2 = [
    "onClear"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function Icon(props) {
    var icon = props.icon, type = props.type, restProps = _objectWithoutProperties(props, _excluded);
    var _React$useContext = _react.useContext((0, _contextDefault.default)), prefixCls = _React$useContext.prefixCls, classNames = _React$useContext.classNames, styles = _React$useContext.styles;
    return icon ? /*#__PURE__*/ _react.createElement("span", _extends({
        className: (0, _clsx.clsx)("".concat(prefixCls, "-").concat(type), classNames.suffix),
        style: styles.suffix
    }, restProps), icon) : null;
}
function ClearIcon(_ref) {
    var onClear = _ref.onClear, restProps = _objectWithoutProperties(_ref, _excluded2);
    return /*#__PURE__*/ _react.createElement(Icon, _extends({}, restProps, {
        type: "clear",
        role: "button",
        onMouseDown: function onMouseDown(e) {
            e.preventDefault();
        },
        onClick: function onClick(e) {
            e.stopPropagation();
            onClear();
        }
    }));
}

},{"react":"bmhQu","../context":"afG3N","clsx":"431Ou","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ktoov":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _util = require("@rc-component/util");
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _react = require("react");
var _miscUtil = require("../../utils/miscUtil");
var _context = require("../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _useLockEffect = require("../hooks/useLockEffect");
var _useLockEffectDefault = parcelHelpers.interopDefault(_useLockEffect);
var _icon = require("./Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _maskFormat = require("./MaskFormat");
var _maskFormatDefault = parcelHelpers.interopDefault(_maskFormat);
var _util1 = require("./util");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "className",
    "active",
    "showActiveCls",
    "suffixIcon",
    "format",
    "validateFormat",
    "onChange",
    "onInput",
    "helped",
    "onHelp",
    "onSubmit",
    "onKeyDown",
    "preserveInvalidOnBlur",
    "invalid",
    "clearIcon"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
// Format logic
//
// First time on focus:
//  1. check if the text is valid, if not fill with format
//  2. set highlight cell to the first cell
// Cells
//  1. Selection the index cell, set inner `cacheValue` to ''
//  2. Key input filter non-number char, patch after the `cacheValue`
//    1. Replace the `cacheValue` with input align the cell length
//    2. Re-selection the mask cell
//  3. If `cacheValue` match the limit length or cell format (like 1 ~ 12 month), go to next cell
var Input = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    var className = props.className, active = props.active, _props$showActiveCls = props.showActiveCls, showActiveCls = _props$showActiveCls === void 0 ? true : _props$showActiveCls, suffixIcon = props.suffixIcon, format = props.format, validateFormat = props.validateFormat, onChange = props.onChange, onInput = props.onInput, helped = props.helped, onHelp = props.onHelp, onSubmit = props.onSubmit, onKeyDown = props.onKeyDown, _props$preserveInvali = props.preserveInvalidOnBlur, preserveInvalidOnBlur = _props$preserveInvali === void 0 ? false : _props$preserveInvali, invalid = props.invalid, clearIcon = props.clearIcon, restProps = _objectWithoutProperties(props, _excluded);
    var value = props.value, onFocus = props.onFocus, onBlur = props.onBlur, onMouseUp = props.onMouseUp;
    var _React$useContext = _react.useContext((0, _contextDefault.default)), prefixCls = _React$useContext.prefixCls, _React$useContext$inp = _React$useContext.input, Component = _React$useContext$inp === void 0 ? 'input' : _React$useContext$inp, classNames = _React$useContext.classNames, styles = _React$useContext.styles;
    var inputPrefixCls = "".concat(prefixCls, "-input");
    // ======================== Value =========================
    var _React$useState = _react.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
    var _React$useState3 = _react.useState(value), _React$useState4 = _slicedToArray(_React$useState3, 2), internalInputValue = _React$useState4[0], setInputValue = _React$useState4[1];
    var _React$useState5 = _react.useState(''), _React$useState6 = _slicedToArray(_React$useState5, 2), focusCellText = _React$useState6[0], setFocusCellText = _React$useState6[1];
    var _React$useState7 = _react.useState(null), _React$useState8 = _slicedToArray(_React$useState7, 2), focusCellIndex = _React$useState8[0], setFocusCellIndex = _React$useState8[1];
    var _React$useState9 = _react.useState(null), _React$useState10 = _slicedToArray(_React$useState9, 2), forceSelectionSyncMark = _React$useState10[0], forceSelectionSync = _React$useState10[1];
    var inputValue = internalInputValue || '';
    // Sync value if needed
    _react.useEffect(function() {
        setInputValue(value);
    }, [
        value
    ]);
    // ========================= Refs =========================
    var holderRef = _react.useRef(null);
    var inputRef = _react.useRef(null);
    _react.useImperativeHandle(ref, function() {
        return {
            nativeElement: holderRef.current,
            inputElement: inputRef.current,
            focus: function focus(options) {
                inputRef.current.focus(options);
            },
            blur: function blur() {
                inputRef.current.blur();
            }
        };
    });
    // ======================== Format ========================
    var maskFormat = _react.useMemo(function() {
        return new (0, _maskFormatDefault.default)(format || '');
    }, [
        format
    ]);
    var _React$useMemo = _react.useMemo(function() {
        if (helped) return [
            0,
            0
        ];
        return maskFormat.getSelection(focusCellIndex);
    }, [
        maskFormat,
        focusCellIndex,
        helped
    ]), _React$useMemo2 = _slicedToArray(_React$useMemo, 2), selectionStart = _React$useMemo2[0], selectionEnd = _React$useMemo2[1];
    // ======================== Modify ========================
    // When input modify content, trigger `onHelp` if is not the format
    var onModify = function onModify(text) {
        if (text && text !== format && text !== value) onHelp();
    };
    // ======================== Change ========================
    /**
   * Triggered by paste, keyDown and focus to show format
   */ var triggerInputChange = (0, _util.useEvent)(function(text) {
        if (validateFormat(text)) onChange(text);
        setInputValue(text);
        onModify(text);
    });
    // Directly trigger `onChange` if `format` is empty
    var onInternalChange = function onInternalChange(event) {
        // Hack `onChange` with format to do nothing
        if (!format) {
            var text = event.target.value;
            onModify(text);
            setInputValue(text);
            onChange(text);
        }
    };
    var onFormatPaste = function onFormatPaste(event) {
        // Get paste text
        var pasteText = event.clipboardData.getData('text');
        if (validateFormat(pasteText)) triggerInputChange(pasteText);
    };
    // ======================== Mouse =========================
    // When `mouseDown` get focus, it's better to not to change the selection
    // Since the up position maybe not is the first cell
    var mouseDownRef = _react.useRef(false);
    var onFormatMouseDown = function onFormatMouseDown() {
        mouseDownRef.current = true;
    };
    var onFormatMouseUp = function onFormatMouseUp(event) {
        var _ref = event.target, start = _ref.selectionStart;
        var closeMaskIndex = maskFormat.getMaskCellIndex(start);
        setFocusCellIndex(closeMaskIndex);
        // Force update the selection
        forceSelectionSync({});
        onMouseUp === null || onMouseUp === void 0 || onMouseUp(event);
        mouseDownRef.current = false;
    };
    // ====================== Focus Blur ======================
    var onFormatFocus = function onFormatFocus(event) {
        setFocused(true);
        setFocusCellIndex(0);
        setFocusCellText('');
        onFocus(event);
    };
    var onSharedBlur = function onSharedBlur(event) {
        onBlur(event);
    };
    var onFormatBlur = function onFormatBlur(event) {
        setFocused(false);
        onSharedBlur(event);
    };
    // ======================== Active ========================
    // Check if blur need reset input value
    (0, _useLockEffectDefault.default)(active, function() {
        if (!active && !preserveInvalidOnBlur) setInputValue(value);
    });
    // ======================= Keyboard =======================
    var onSharedKeyDown = function onSharedKeyDown(event) {
        if (event.key === 'Enter' && validateFormat(inputValue)) onSubmit();
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(event);
    };
    var onFormatKeyDown = function onFormatKeyDown(event) {
        onSharedKeyDown(event);
        var key = event.key;
        // Save the cache with cell text
        var nextCellText = null;
        // Fill in the input
        var nextFillText = null;
        var maskCellLen = selectionEnd - selectionStart;
        var cellFormat = format.slice(selectionStart, selectionEnd);
        // Cell Index
        var offsetCellIndex = function offsetCellIndex(offset) {
            setFocusCellIndex(function(idx) {
                var nextIndex = idx + offset;
                nextIndex = Math.max(nextIndex, 0);
                nextIndex = Math.min(nextIndex, maskFormat.size() - 1);
                return nextIndex;
            });
        };
        // Range
        var offsetCellValue = function offsetCellValue(offset) {
            var _getMaskRange = (0, _util1.getMaskRange)(cellFormat), _getMaskRange2 = _slicedToArray(_getMaskRange, 3), rangeStart = _getMaskRange2[0], rangeEnd = _getMaskRange2[1], rangeDefault = _getMaskRange2[2];
            var currentText = inputValue.slice(selectionStart, selectionEnd);
            var currentTextNum = Number(currentText);
            if (isNaN(currentTextNum)) return String(rangeDefault ? rangeDefault : offset > 0 ? rangeStart : rangeEnd);
            var num = currentTextNum + offset;
            var range = rangeEnd - rangeStart + 1;
            return String(rangeStart + (range + num - rangeStart) % range);
        };
        switch(key){
            // =============== Remove ===============
            case 'Backspace':
            case 'Delete':
                nextCellText = '';
                nextFillText = cellFormat;
                break;
            // =============== Arrows ===============
            // Left key
            case 'ArrowLeft':
                nextCellText = '';
                offsetCellIndex(-1);
                break;
            // Right key
            case 'ArrowRight':
                nextCellText = '';
                offsetCellIndex(1);
                break;
            // Up key
            case 'ArrowUp':
                nextCellText = '';
                nextFillText = offsetCellValue(1);
                break;
            // Down key
            case 'ArrowDown':
                nextCellText = '';
                nextFillText = offsetCellValue(-1);
                break;
            // =============== Number ===============
            default:
                if (!isNaN(Number(key))) {
                    nextCellText = focusCellText + key;
                    nextFillText = nextCellText;
                }
                break;
        }
        // Update cell text
        if (nextCellText !== null) {
            setFocusCellText(nextCellText);
            if (nextCellText.length >= maskCellLen) {
                // Go to next cell
                offsetCellIndex(1);
                setFocusCellText('');
            }
        }
        // Update the input text
        if (nextFillText !== null) {
            // Replace selection range with `nextCellText`
            var nextFocusValue = // before
            inputValue.slice(0, selectionStart) + // replace
            (0, _miscUtil.leftPad)(nextFillText, maskCellLen) + // after
            inputValue.slice(selectionEnd);
            triggerInputChange(nextFocusValue.slice(0, format.length));
        }
        // Always trigger selection sync after key down
        forceSelectionSync({});
    };
    // ======================== Format ========================
    var rafRef = _react.useRef();
    (0, _useLayoutEffectDefault.default)(function() {
        if (!focused || !format || mouseDownRef.current) return;
        // Reset with format if not match
        if (!maskFormat.match(inputValue)) {
            triggerInputChange(format);
            return;
        }
        // Match the selection range
        inputRef.current.setSelectionRange(selectionStart, selectionEnd);
        // Chrome has the bug anchor position looks not correct but actually correct
        rafRef.current = (0, _rafDefault.default)(function() {
            inputRef.current.setSelectionRange(selectionStart, selectionEnd);
        });
        return function() {
            (0, _rafDefault.default).cancel(rafRef.current);
        };
    }, [
        maskFormat,
        format,
        focused,
        inputValue,
        focusCellIndex,
        selectionStart,
        selectionEnd,
        forceSelectionSyncMark,
        triggerInputChange
    ]);
    // ======================== Render ========================
    // Input props for format
    var inputProps = format ? {
        onFocus: onFormatFocus,
        onBlur: onFormatBlur,
        onKeyDown: onFormatKeyDown,
        onMouseDown: onFormatMouseDown,
        onMouseUp: onFormatMouseUp,
        onPaste: onFormatPaste
    } : {};
    return /*#__PURE__*/ _react.createElement("div", {
        ref: holderRef,
        className: (0, _clsx.clsx)(inputPrefixCls, _defineProperty(_defineProperty({}, "".concat(inputPrefixCls, "-active"), active && showActiveCls), "".concat(inputPrefixCls, "-placeholder"), helped), className)
    }, /*#__PURE__*/ _react.createElement(Component, _extends({
        ref: inputRef,
        "aria-invalid": invalid,
        autoComplete: "off"
    }, restProps, {
        onKeyDown: onSharedKeyDown,
        onBlur: onSharedBlur
    }, inputProps, {
        // Value
        value: inputValue,
        onChange: onInternalChange,
        className: classNames.input,
        style: styles.input
    })), /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
        type: "suffix",
        icon: suffixIcon
    }), clearIcon);
});
exports.default = Input;

},{"clsx":"431Ou","@rc-component/util":"6ZBDN","@rc-component/util/es/hooks/useLayoutEffect":"azwns","@rc-component/util/es/raf":"ajbAx","react":"bmhQu","../../utils/miscUtil":"2yPUL","../context":"afG3N","../hooks/useLockEffect":"6NbwG","./Icon":"8fnok","./MaskFormat":"757Eb","./util":"ghMig","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"757Eb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MaskFormat);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var FORMAT_KEYS = [
    'YYYY',
    'MM',
    'DD',
    'HH',
    'mm',
    'ss',
    'SSS'
];
// Use Chinese character to avoid conflict with the mask format
var REPLACE_KEY = "\u9867";
var MaskFormat = /*#__PURE__*/ function() {
    function MaskFormat(format) {
        _classCallCheck(this, MaskFormat);
        _defineProperty(this, "format", void 0);
        _defineProperty(this, "maskFormat", void 0);
        _defineProperty(this, "cells", void 0);
        _defineProperty(this, "maskCells", void 0);
        this.format = format;
        // Generate mask format
        var replaceKeys = FORMAT_KEYS.map(function(key) {
            return "(".concat(key, ")");
        }).join('|');
        var replaceReg = new RegExp(replaceKeys, 'g');
        this.maskFormat = format.replace(replaceReg, // Use Chinese character to avoid user use it in format
        function(key) {
            return REPLACE_KEY.repeat(key.length);
        });
        // Generate cells
        var cellReg = new RegExp("(".concat(FORMAT_KEYS.join('|'), ")"));
        var strCells = (format.split(cellReg) || []).filter(function(str) {
            return str;
        });
        var offset = 0;
        this.cells = strCells.map(function(text) {
            var mask = FORMAT_KEYS.includes(text);
            var start = offset;
            var end = offset + text.length;
            offset = end;
            return {
                text: text,
                mask: mask,
                start: start,
                end: end
            };
        });
        // Mask cells
        this.maskCells = this.cells.filter(function(cell) {
            return cell.mask;
        });
    }
    _createClass(MaskFormat, [
        {
            key: "getSelection",
            value: function getSelection(maskCellIndex) {
                var _ref = this.maskCells[maskCellIndex] || {}, start = _ref.start, end = _ref.end;
                return [
                    start || 0,
                    end || 0
                ];
            }
        },
        {
            key: "match",
            value: function match(text) {
                for(var i = 0; i < this.maskFormat.length; i += 1){
                    var maskChar = this.maskFormat[i];
                    var textChar = text[i];
                    if (!textChar || maskChar !== REPLACE_KEY && maskChar !== textChar) return false;
                }
                return true;
            }
        },
        {
            key: "size",
            value: function size() {
                return this.maskCells.length;
            }
        },
        {
            key: "getMaskCellIndex",
            value: function getMaskCellIndex(anchorIndex) {
                var closetDist = Number.MAX_SAFE_INTEGER;
                var closetIndex = 0;
                for(var i = 0; i < this.maskCells.length; i += 1){
                    var _this$maskCells$i = this.maskCells[i], start = _this$maskCells$i.start, end = _this$maskCells$i.end;
                    if (anchorIndex >= start && anchorIndex <= end) return i;
                    var dist = Math.min(Math.abs(anchorIndex - start), Math.abs(anchorIndex - end));
                    if (dist < closetDist) {
                        closetDist = dist;
                        closetIndex = i;
                    }
                }
                return closetIndex;
            }
        }
    ]);
    return MaskFormat;
}();

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ghMig":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMaskRange", ()=>getMaskRange);
function getMaskRange(key) {
    var PresetRange = {
        YYYY: [
            0,
            9999,
            new Date().getFullYear()
        ],
        MM: [
            1,
            12
        ],
        DD: [
            1,
            31
        ],
        HH: [
            0,
            23
        ],
        mm: [
            0,
            59
        ],
        ss: [
            0,
            59
        ],
        SSS: [
            0,
            999
        ]
    };
    return PresetRange[key];
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1JfFg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useSemantic);
var _react = require("react");
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function useSemantic(classNames, styles) {
    return (0, _react.useMemo)(function() {
        var mergedClassNames = _objectSpread(_objectSpread({}, classNames), {}, {
            popup: (classNames === null || classNames === void 0 ? void 0 : classNames.popup) || {}
        });
        var mergedStyles = _objectSpread(_objectSpread({}, styles), {}, {
            popup: (styles === null || styles === void 0 ? void 0 : styles.popup) || {}
        });
        return [
            mergedClassNames,
            mergedStyles
        ];
    }, [
        classNames,
        styles
    ]);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kjTx4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _omit = require("@rc-component/util/es/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
var _react = require("react");
var _useToggleDates = require("../hooks/useToggleDates");
var _useToggleDatesDefault = parcelHelpers.interopDefault(_useToggleDates);
var _pickerTrigger = require("../PickerTrigger");
var _pickerTriggerDefault = parcelHelpers.interopDefault(_pickerTrigger);
var _util1 = require("../PickerTrigger/util");
var _miscUtil = require("../utils/miscUtil");
var _context = require("./context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _useCellRender = require("./hooks/useCellRender");
var _useCellRenderDefault = parcelHelpers.interopDefault(_useCellRender);
var _useFieldsInvalidate = require("./hooks/useFieldsInvalidate");
var _useFieldsInvalidateDefault = parcelHelpers.interopDefault(_useFieldsInvalidate);
var _useFilledProps = require("./hooks/useFilledProps");
var _useFilledPropsDefault = parcelHelpers.interopDefault(_useFilledProps);
var _useOpen = require("./hooks/useOpen");
var _useOpenDefault = parcelHelpers.interopDefault(_useOpen);
var _usePickerRef = require("./hooks/usePickerRef");
var _usePickerRefDefault = parcelHelpers.interopDefault(_usePickerRef);
var _usePresets = require("./hooks/usePresets");
var _usePresetsDefault = parcelHelpers.interopDefault(_usePresets);
var _useRangeActive = require("./hooks/useRangeActive");
var _useRangeActiveDefault = parcelHelpers.interopDefault(_useRangeActive);
var _useRangePickerValue = require("./hooks/useRangePickerValue");
var _useRangePickerValueDefault = parcelHelpers.interopDefault(_useRangePickerValue);
var _useRangeValue = require("./hooks/useRangeValue");
var _useRangeValueDefault = parcelHelpers.interopDefault(_useRangeValue);
var _useShowNow = require("./hooks/useShowNow");
var _useShowNowDefault = parcelHelpers.interopDefault(_useShowNow);
var _popup = require("./Popup");
var _popupDefault = parcelHelpers.interopDefault(_popup);
var _singleSelector = require("./Selector/SingleSelector");
var _singleSelectorDefault = parcelHelpers.interopDefault(_singleSelector);
var _useSemantic = require("../hooks/useSemantic");
var _useSemanticDefault = parcelHelpers.interopDefault(_useSemantic);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
// TODO: isInvalidateDate with showTime.disabledTime should not provide `range` prop
/** Internal usage. For cross function get same aligned props */ function Picker(props, ref) {
    // ========================= Prop =========================
    var _useFilledProps = (0, _useFilledPropsDefault.default)(props), _useFilledProps2 = _slicedToArray(_useFilledProps, 6), filledProps = _useFilledProps2[0], internalPicker = _useFilledProps2[1], complexPicker = _useFilledProps2[2], formatList = _useFilledProps2[3], maskFormat = _useFilledProps2[4], isInvalidateDate = _useFilledProps2[5];
    var _ref = filledProps, prefixCls = _ref.prefixCls, rootClassName = _ref.rootClassName, propStyles = _ref.styles, propClassNames = _ref.classNames, previewValue = _ref.previewValue, order = _ref.order, defaultValue = _ref.defaultValue, value = _ref.value, needConfirm = _ref.needConfirm, onChange = _ref.onChange, onKeyDown = _ref.onKeyDown, disabled = _ref.disabled, disabledDate = _ref.disabledDate, minDate = _ref.minDate, maxDate = _ref.maxDate, defaultOpen = _ref.defaultOpen, open = _ref.open, onOpenChange = _ref.onOpenChange, locale = _ref.locale, generateConfig = _ref.generateConfig, picker = _ref.picker, showNow = _ref.showNow, showToday = _ref.showToday, showTime = _ref.showTime, mode = _ref.mode, onPanelChange = _ref.onPanelChange, onCalendarChange = _ref.onCalendarChange, onOk = _ref.onOk, multiple = _ref.multiple, defaultPickerValue = _ref.defaultPickerValue, pickerValue = _ref.pickerValue, onPickerValueChange = _ref.onPickerValueChange, inputReadOnly = _ref.inputReadOnly, suffixIcon = _ref.suffixIcon, removeIcon = _ref.removeIcon, onFocus = _ref.onFocus, onBlur = _ref.onBlur, presets = _ref.presets, components = _ref.components, cellRender = _ref.cellRender, dateRender = _ref.dateRender, monthCellRender = _ref.monthCellRender, onClick = _ref.onClick;
    // ========================= Refs =========================
    var selectorRef = (0, _usePickerRefDefault.default)(ref);
    // ========================= Util =========================
    function pickerParam(values) {
        if (values === null) return null;
        return multiple ? values : values[0];
    }
    var toggleDates = (0, _useToggleDatesDefault.default)(generateConfig, locale, internalPicker);
    // ======================= Semantic =======================
    var _useSemantic = (0, _useSemanticDefault.default)(propClassNames, propStyles), _useSemantic2 = _slicedToArray(_useSemantic, 2), mergedClassNames = _useSemantic2[0], mergedStyles = _useSemantic2[1];
    // ========================= Open =========================
    var _useOpen = (0, _useOpenDefault.default)(open, defaultOpen, [
        disabled
    ], onOpenChange), _useOpen2 = _slicedToArray(_useOpen, 2), mergedOpen = _useOpen2[0], triggerOpen = _useOpen2[1];
    // ======================= Calendar =======================
    var onInternalCalendarChange = function onInternalCalendarChange(dates, dateStrings, info) {
        if (onCalendarChange) {
            var filteredInfo = _objectSpread({}, info);
            delete filteredInfo.range;
            onCalendarChange(pickerParam(dates), pickerParam(dateStrings), filteredInfo);
        }
    };
    var onInternalOk = function onInternalOk(dates) {
        onOk === null || onOk === void 0 || onOk(pickerParam(dates));
    };
    // ======================== Values ========================
    var _useInnerValue = (0, _useRangeValue.useInnerValue)(generateConfig, locale, formatList, false, order, defaultValue, value, onInternalCalendarChange, onInternalOk), _useInnerValue2 = _slicedToArray(_useInnerValue, 5), mergedValue = _useInnerValue2[0], setInnerValue = _useInnerValue2[1], getCalendarValue = _useInnerValue2[2], triggerCalendarChange = _useInnerValue2[3], triggerOk = _useInnerValue2[4];
    var calendarValue = getCalendarValue();
    // ======================== Active ========================
    // In SinglePicker, we will always get `activeIndex` is 0.
    var _useRangeActive = (0, _useRangeActiveDefault.default)([
        disabled
    ]), _useRangeActive2 = _slicedToArray(_useRangeActive, 4), focused = _useRangeActive2[0], triggerFocus = _useRangeActive2[1], lastOperation = _useRangeActive2[2], activeIndex = _useRangeActive2[3];
    var onSharedFocus = function onSharedFocus(event) {
        triggerFocus(true);
        onFocus === null || onFocus === void 0 || onFocus(event, {});
    };
    var onSharedBlur = function onSharedBlur(event) {
        triggerFocus(false);
        onBlur === null || onBlur === void 0 || onBlur(event, {});
    };
    // ========================= Mode =========================
    var _useControlledState = (0, _util.useControlledState)(picker, mode), _useControlledState2 = _slicedToArray(_useControlledState, 2), mergedMode = _useControlledState2[0], setMode = _useControlledState2[1];
    /** Extends from `mergedMode` to patch `datetime` mode */ var internalMode = mergedMode === 'date' && showTime ? 'datetime' : mergedMode;
    // ======================= Show Now =======================
    var mergedShowNow = (0, _useShowNowDefault.default)(picker, mergedMode, showNow, showToday);
    // ======================== Value =========================
    var onInternalChange = onChange && function(dates, dateStrings) {
        onChange(pickerParam(dates), pickerParam(dateStrings));
    };
    var _useRangeValue1 = (0, _useRangeValueDefault.default)(_objectSpread(_objectSpread({}, filledProps), {}, {
        onChange: onInternalChange
    }), mergedValue, setInnerValue, getCalendarValue, triggerCalendarChange, [], //disabled,
    formatList, focused, mergedOpen, isInvalidateDate), _useRangeValue2 = _slicedToArray(_useRangeValue1, 2), /** Trigger `onChange` directly without check `disabledDate` */ triggerSubmitChange = _useRangeValue2[1];
    // ======================= Validate =======================
    var _useFieldsInvalidate = (0, _useFieldsInvalidateDefault.default)(calendarValue, isInvalidateDate), _useFieldsInvalidate2 = _slicedToArray(_useFieldsInvalidate, 2), submitInvalidates = _useFieldsInvalidate2[0], onSelectorInvalid = _useFieldsInvalidate2[1];
    var submitInvalidate = _react.useMemo(function() {
        return submitInvalidates.some(function(invalidated) {
            return invalidated;
        });
    }, [
        submitInvalidates
    ]);
    // ===================== Picker Value =====================
    // Proxy to single pickerValue
    var onInternalPickerValueChange = function onInternalPickerValueChange(dates, info) {
        if (onPickerValueChange) {
            var cleanInfo = _objectSpread(_objectSpread({}, info), {}, {
                mode: info.mode[0]
            });
            delete cleanInfo.range;
            onPickerValueChange(dates[0], cleanInfo);
        }
    };
    var _useRangePickerValue = (0, _useRangePickerValueDefault.default)(generateConfig, locale, calendarValue, [
        mergedMode
    ], mergedOpen, activeIndex, internalPicker, false, // multiplePanel,
    defaultPickerValue, pickerValue, (0, _miscUtil.toArray)(showTime === null || showTime === void 0 ? void 0 : showTime.defaultOpenValue), onInternalPickerValueChange, minDate, maxDate), _useRangePickerValue2 = _slicedToArray(_useRangePickerValue, 2), currentPickerValue = _useRangePickerValue2[0], setCurrentPickerValue = _useRangePickerValue2[1];
    // >>> Mode need wait for `pickerValue`
    var triggerModeChange = (0, _util.useEvent)(function(nextPickerValue, nextMode, triggerEvent) {
        setMode(nextMode);
        // Compatible with `onPanelChange`
        if (onPanelChange && triggerEvent !== false) {
            var lastPickerValue = nextPickerValue || calendarValue[calendarValue.length - 1];
            onPanelChange(lastPickerValue, nextMode);
        }
    });
    // ======================== Submit ========================
    /**
   * Different with RangePicker, confirm should check `multiple` logic.
   * This will never provide `date` instead.
   */ var triggerConfirm = function triggerConfirm() {
        triggerSubmitChange(getCalendarValue());
        triggerOpen(false, {
            force: true
        });
    };
    // ======================== Click =========================
    var onSelectorClick = function onSelectorClick(event) {
        if (!disabled && !selectorRef.current.nativeElement.contains(document.activeElement)) // Click to focus the enabled input
        selectorRef.current.focus();
        triggerOpen(true);
        onClick === null || onClick === void 0 || onClick(event);
    };
    var onSelectorClear = function onSelectorClear() {
        triggerSubmitChange(null);
        triggerOpen(false, {
            force: true
        });
    };
    // ======================== Hover =========================
    var _React$useState = _react.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), hoverSource = _React$useState2[0], setHoverSource = _React$useState2[1];
    var _React$useState3 = _react.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), internalHoverValue = _React$useState4[0], setInternalHoverValue = _React$useState4[1];
    var hoverValues = _react.useMemo(function() {
        var values = [
            internalHoverValue
        ].concat(_toConsumableArray(calendarValue)).filter(function(date) {
            return date;
        });
        return multiple ? values : values.slice(0, 1);
    }, [
        calendarValue,
        internalHoverValue,
        multiple
    ]);
    // Selector values is different with RangePicker
    // which can not use `hoverValue` directly
    var selectorValues = _react.useMemo(function() {
        if (!multiple && internalHoverValue) return [
            internalHoverValue
        ];
        return calendarValue.filter(function(date) {
            return date;
        });
    }, [
        calendarValue,
        internalHoverValue,
        multiple
    ]);
    // Clean up `internalHoverValues` when closed
    _react.useEffect(function() {
        if (!mergedOpen) setInternalHoverValue(null);
    }, [
        mergedOpen
    ]);
    var onSetHover = function onSetHover(date, source) {
        if (previewValue !== 'hover') return;
        setInternalHoverValue(date);
        setHoverSource(source);
    };
    // ========================================================
    // ==                       Panels                       ==
    // ========================================================
    // ======================= Presets ========================
    var presetList = (0, _usePresetsDefault.default)(presets);
    var onPresetHover = function onPresetHover(nextValue) {
        onSetHover(nextValue, 'preset');
    };
    // TODO: handle this
    var onPresetSubmit = function onPresetSubmit(nextValue) {
        var nextCalendarValues = multiple ? toggleDates(getCalendarValue(), nextValue) : [
            nextValue
        ];
        var passed = triggerSubmitChange(nextCalendarValues);
        if (passed && !multiple) triggerOpen(false, {
            force: true
        });
    };
    var onNow = function onNow(now) {
        onPresetSubmit(now);
    };
    // ======================== Panel =========================
    var onPanelHover = function onPanelHover(date) {
        onSetHover(date, 'cell');
    };
    // >>> Focus
    var onPanelFocus = function onPanelFocus(event) {
        triggerOpen(true);
        onSharedFocus(event);
    };
    // >>> Calendar
    var onPanelSelect = function onPanelSelect(date) {
        lastOperation('panel');
        // Not change values if multiple and current panel is to match with picker
        if (multiple && internalMode !== picker) return;
        var nextValues = multiple ? toggleDates(getCalendarValue(), date) : [
            date
        ];
        // Only trigger calendar event but not update internal `calendarValue` state
        triggerCalendarChange(nextValues);
        // >>> Trigger next active if !needConfirm
        // Fully logic check `useRangeValue` hook
        if (!needConfirm && !complexPicker && internalPicker === internalMode) triggerConfirm();
    };
    // >>> Close
    var onPopupClose = function onPopupClose() {
        // Close popup
        triggerOpen(false);
    };
    // >>> cellRender
    var onInternalCellRender = (0, _useCellRenderDefault.default)(cellRender, dateRender, monthCellRender);
    // >>> invalid
    var panelProps = _react.useMemo(function() {
        var domProps = (0, _pickAttrsDefault.default)(filledProps, false);
        var restProps = (0, _omitDefault.default)(filledProps, [].concat(_toConsumableArray(Object.keys(domProps)), [
            'onChange',
            'onCalendarChange',
            'style',
            'className',
            'onPanelChange',
            'classNames',
            'styles'
        ]));
        return _objectSpread(_objectSpread({}, restProps), {}, {
            multiple: filledProps.multiple
        });
    }, [
        filledProps
    ]);
    // >>> Render
    var panel = /*#__PURE__*/ _react.createElement((0, _popupDefault.default), _extends({}, panelProps, {
        showNow: mergedShowNow,
        showTime: showTime,
        disabledDate: disabledDate,
        onFocus: onPanelFocus,
        onBlur: onSharedBlur,
        picker: picker,
        mode: mergedMode,
        internalMode: internalMode,
        onPanelChange: triggerModeChange,
        format: maskFormat,
        value: calendarValue,
        isInvalid: isInvalidateDate,
        onChange: null,
        onSelect: onPanelSelect,
        pickerValue: currentPickerValue,
        defaultOpenValue: showTime === null || showTime === void 0 ? void 0 : showTime.defaultOpenValue,
        onPickerValueChange: setCurrentPickerValue,
        hoverValue: hoverValues,
        onHover: onPanelHover,
        needConfirm: needConfirm,
        onSubmit: triggerConfirm,
        onOk: triggerOk,
        presets: presetList,
        onPresetHover: onPresetHover,
        onPresetSubmit: onPresetSubmit,
        onNow: onNow,
        cellRender: onInternalCellRender,
        classNames: mergedClassNames,
        styles: mergedStyles
    }));
    // ========================================================
    // ==                      Selector                      ==
    // ========================================================
    // ======================== Change ========================
    var onSelectorChange = function onSelectorChange(date) {
        triggerCalendarChange(date);
    };
    var onSelectorInputChange = function onSelectorInputChange() {
        lastOperation('input');
    };
    // ======================= Selector =======================
    var onSelectorFocus = function onSelectorFocus(event) {
        lastOperation('input');
        triggerOpen(true, {
            inherit: true
        });
        // setActiveIndex(index);
        onSharedFocus(event);
    };
    var onSelectorBlur = function onSelectorBlur(event) {
        triggerOpen(false);
        onSharedBlur(event);
    };
    var onSelectorKeyDown = function onSelectorKeyDown(event, preventDefault) {
        if (event.key === 'Tab') triggerConfirm();
        onKeyDown === null || onKeyDown === void 0 || onKeyDown(event, preventDefault);
    };
    // ======================= Context ========================
    var context = _react.useMemo(function() {
        return {
            prefixCls: prefixCls,
            locale: locale,
            generateConfig: generateConfig,
            button: components.button,
            input: components.input,
            classNames: mergedClassNames,
            styles: mergedStyles
        };
    }, [
        prefixCls,
        locale,
        generateConfig,
        components.button,
        components.input,
        mergedClassNames,
        mergedStyles
    ]);
    // ======================== Effect ========================
    // >>> Mode
    // Reset for every active
    (0, _useLayoutEffectDefault.default)(function() {
        if (mergedOpen && activeIndex !== undefined) // Legacy compatible. This effect update should not trigger `onPanelChange`
        triggerModeChange(null, picker, false);
    }, [
        mergedOpen,
        activeIndex,
        picker
    ]);
    // >>> For complex picker, we need check if need to focus next one
    (0, _useLayoutEffectDefault.default)(function() {
        var lastOp = lastOperation();
        // Trade as confirm on field leave
        if (!mergedOpen && lastOp === 'input') {
            triggerOpen(false);
            triggerConfirm();
        }
        // Submit with complex picker
        if (!mergedOpen && complexPicker && !needConfirm && lastOp === 'panel') triggerConfirm();
    }, [
        mergedOpen
    ]);
    // ======================== Render ========================
    return /*#__PURE__*/ _react.createElement((0, _contextDefault.default).Provider, {
        value: context
    }, /*#__PURE__*/ _react.createElement((0, _pickerTriggerDefault.default), _extends({}, (0, _util1.pickTriggerProps)(filledProps), {
        popupElement: panel,
        popupStyle: mergedStyles.popup.root,
        popupClassName: (0, _clsx.clsx)(rootClassName, mergedClassNames.popup.root),
        visible: mergedOpen,
        onClose: onPopupClose
    }), /*#__PURE__*/ _react.createElement((0, _singleSelectorDefault.default), _extends({}, filledProps, {
        // Ref
        ref: selectorRef,
        className: (0, _clsx.clsx)(filledProps.className, rootClassName, mergedClassNames.root),
        style: _objectSpread(_objectSpread({}, mergedStyles.root), filledProps.style),
        suffixIcon: suffixIcon,
        removeIcon: removeIcon,
        activeHelp: !!internalHoverValue,
        allHelp: !!internalHoverValue && hoverSource === 'preset',
        focused: focused,
        onFocus: onSelectorFocus,
        onBlur: onSelectorBlur,
        onKeyDown: onSelectorKeyDown,
        onSubmit: triggerConfirm,
        value: selectorValues,
        maskFormat: maskFormat,
        onChange: onSelectorChange,
        onInputChange: onSelectorInputChange,
        internalPicker: internalPicker,
        format: formatList,
        inputReadOnly: inputReadOnly,
        disabled: disabled,
        open: mergedOpen,
        onOpenChange: triggerOpen,
        onClick: onSelectorClick,
        onClear: onSelectorClear,
        invalid: submitInvalidate,
        onInvalid: function onInvalid(invalid) {
            // Only `single` mode support type date.
            // `multiple` mode can not typing.
            onSelectorInvalid(invalid, 0);
        }
    }))));
}
var RefPicker = /*#__PURE__*/ _react.forwardRef(Picker);
exports.default = RefPicker;

},{"@rc-component/util":"6ZBDN","clsx":"431Ou","@rc-component/util/es/hooks/useLayoutEffect":"azwns","@rc-component/util/es/omit":"1VS01","@rc-component/util/es/pickAttrs":"jGMGD","react":"bmhQu","../hooks/useToggleDates":"3oZQL","../PickerTrigger":"49zW0","../PickerTrigger/util":"e2ZZe","../utils/miscUtil":"2yPUL","./context":"afG3N","./hooks/useCellRender":"9dNsP","./hooks/useFieldsInvalidate":"jAemW","./hooks/useFilledProps":"dcybt","./hooks/useOpen":"e19rh","./hooks/usePickerRef":"cXEvs","./hooks/usePresets":"bhkRw","./hooks/useRangeActive":"1MKqj","./hooks/useRangePickerValue":"75Bgy","./hooks/useRangeValue":"ddux0","./hooks/useShowNow":"3o1XX","./Popup":"h3ENZ","./Selector/SingleSelector":"gIyza","../hooks/useSemantic":"1JfFg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gIyza":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _react = require("react");
var _dateUtil = require("../../../utils/dateUtil");
var _context = require("../../context");
var _contextDefault = parcelHelpers.interopDefault(_context);
var _icon = require("../Icon");
var _iconDefault = parcelHelpers.interopDefault(_icon);
var _input = require("../Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _useInputProps = require("../hooks/useInputProps");
var _useInputPropsDefault = parcelHelpers.interopDefault(_useInputProps);
var _useRootProps = require("../hooks/useRootProps");
var _useRootPropsDefault = parcelHelpers.interopDefault(_useRootProps);
var _multipleDates = require("./MultipleDates");
var _multipleDatesDefault = parcelHelpers.interopDefault(_multipleDates);
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
var _excluded = [
    "id",
    "open",
    "prefix",
    "clearIcon",
    "suffixIcon",
    "activeHelp",
    "allHelp",
    "focused",
    "onFocus",
    "onBlur",
    "onKeyDown",
    "locale",
    "generateConfig",
    "placeholder",
    "className",
    "style",
    "onClick",
    "onClear",
    "internalPicker",
    "value",
    "onChange",
    "onSubmit",
    "onInputChange",
    "multiple",
    "maxTagCount",
    "format",
    "maskFormat",
    "preserveInvalidOnBlur",
    "onInvalid",
    "disabled",
    "invalid",
    "inputReadOnly",
    "direction",
    "onOpenChange",
    "onMouseDown",
    "required",
    "aria-required",
    "autoFocus",
    "tabIndex",
    "removeIcon"
];
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function SingleSelector(props, ref) {
    var id = props.id, open = props.open, prefix = props.prefix, clearIcon = props.clearIcon, suffixIcon = props.suffixIcon, activeHelp = props.activeHelp, allHelp = props.allHelp, focused = props.focused, onFocus = props.onFocus, onBlur = props.onBlur, onKeyDown = props.onKeyDown, locale = props.locale, generateConfig = props.generateConfig, placeholder = props.placeholder, className = props.className, style = props.style, onClick = props.onClick, onClear = props.onClear, internalPicker = props.internalPicker, value = props.value, onChange = props.onChange, onSubmit = props.onSubmit, onInputChange = props.onInputChange, multiple = props.multiple, maxTagCount = props.maxTagCount, format = props.format, maskFormat = props.maskFormat, preserveInvalidOnBlur = props.preserveInvalidOnBlur, onInvalid = props.onInvalid, disabled = props.disabled, invalid = props.invalid, inputReadOnly = props.inputReadOnly, direction = props.direction, onOpenChange = props.onOpenChange, _onMouseDown = props.onMouseDown, required = props.required, ariaRequired = props['aria-required'], autoFocus = props.autoFocus, tabIndex = props.tabIndex, removeIcon = props.removeIcon, restProps = _objectWithoutProperties(props, _excluded);
    var rtl = direction === 'rtl';
    // ======================== Prefix ========================
    var _React$useContext = _react.useContext((0, _contextDefault.default)), prefixCls = _React$useContext.prefixCls, classNames = _React$useContext.classNames, styles = _React$useContext.styles;
    // ========================= Refs =========================
    var rootRef = _react.useRef();
    var inputRef = _react.useRef();
    _react.useImperativeHandle(ref, function() {
        return {
            nativeElement: rootRef.current,
            focus: function focus(options) {
                var _inputRef$current;
                (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus(options);
            },
            blur: function blur() {
                var _inputRef$current2;
                (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
            }
        };
    });
    // ======================== Props =========================
    var rootProps = (0, _useRootPropsDefault.default)(restProps);
    // ======================== Change ========================
    var onSingleChange = function onSingleChange(date) {
        onChange([
            date
        ]);
    };
    var onMultipleRemove = function onMultipleRemove(date) {
        var nextValues = value.filter(function(oriDate) {
            return oriDate && !(0, _dateUtil.isSame)(generateConfig, locale, oriDate, date, internalPicker);
        });
        onChange(nextValues);
        // When `open`, it means user is operating the
        if (!open) onSubmit();
    };
    // ======================== Inputs ========================
    var _useInputProps = (0, _useInputPropsDefault.default)(_objectSpread(_objectSpread({}, props), {}, {
        onChange: onSingleChange
    }), function(_ref) {
        var valueTexts = _ref.valueTexts;
        return {
            value: valueTexts[0] || '',
            active: focused
        };
    }), _useInputProps2 = _slicedToArray(_useInputProps, 2), getInputProps = _useInputProps2[0], getText = _useInputProps2[1];
    // ======================== Clear =========================
    var showClear = !!(clearIcon && value.length && !disabled);
    // ======================= Multiple =======================
    var selectorNode = multiple ? /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement((0, _multipleDatesDefault.default), {
        prefixCls: prefixCls,
        value: value,
        onRemove: onMultipleRemove,
        formatDate: getText,
        maxTagCount: maxTagCount,
        disabled: disabled,
        removeIcon: removeIcon,
        placeholder: placeholder
    }), /*#__PURE__*/ _react.createElement("input", {
        className: "".concat(prefixCls, "-multiple-input"),
        value: value.map(getText).join(','),
        ref: inputRef,
        readOnly: true,
        autoFocus: autoFocus,
        tabIndex: tabIndex
    }), /*#__PURE__*/ _react.createElement((0, _iconDefault.default), {
        type: "suffix",
        icon: suffixIcon
    }), showClear && /*#__PURE__*/ _react.createElement((0, _icon.ClearIcon), {
        icon: clearIcon,
        onClear: onClear
    })) : /*#__PURE__*/ _react.createElement((0, _inputDefault.default), _extends({
        ref: inputRef
    }, getInputProps(), {
        autoFocus: autoFocus,
        tabIndex: tabIndex,
        suffixIcon: suffixIcon,
        clearIcon: showClear && /*#__PURE__*/ _react.createElement((0, _icon.ClearIcon), {
            icon: clearIcon,
            onClear: onClear
        }),
        showActiveCls: false
    }));
    // ======================== Render ========================
    return /*#__PURE__*/ _react.createElement("div", _extends({}, rootProps, {
        className: (0, _clsx.clsx)(prefixCls, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(prefixCls, "-multiple"), multiple), "".concat(prefixCls, "-focused"), focused), "".concat(prefixCls, "-disabled"), disabled), "".concat(prefixCls, "-invalid"), invalid), "".concat(prefixCls, "-rtl"), rtl), className),
        style: style,
        ref: rootRef,
        onClick: onClick,
        onMouseDown: function onMouseDown(e) {
            var _inputRef$current3;
            var target = e.target;
            if (target !== ((_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 ? void 0 : _inputRef$current3.inputElement)) e.preventDefault();
            _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(e);
        }
    }), prefix && /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)("".concat(prefixCls, "-prefix"), classNames.prefix),
        style: styles.prefix
    }, prefix), selectorNode);
}
var RefSingleSelector = /*#__PURE__*/ _react.forwardRef(SingleSelector);
exports.default = RefSingleSelector;

},{"clsx":"431Ou","react":"bmhQu","../../../utils/dateUtil":"gSKz6","../../context":"afG3N","../Icon":"8fnok","../Input":"ktoov","../hooks/useInputProps":"hVYVK","../hooks/useRootProps":"1oByy","./MultipleDates":"42yox","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"42yox":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>MultipleDates);
var _clsx = require("clsx");
var _overflow = require("@rc-component/overflow");
var _overflowDefault = parcelHelpers.interopDefault(_overflow);
var _react = require("react");
function MultipleDates(props) {
    var prefixCls = props.prefixCls, value = props.value, onRemove = props.onRemove, _props$removeIcon = props.removeIcon, removeIcon = _props$removeIcon === void 0 ? "\xd7" : _props$removeIcon, formatDate = props.formatDate, disabled = props.disabled, maxTagCount = props.maxTagCount, placeholder = props.placeholder;
    var selectorCls = "".concat(prefixCls, "-selector");
    var selectionCls = "".concat(prefixCls, "-selection");
    var overflowCls = "".concat(selectionCls, "-overflow");
    // ========================= Item =========================
    function renderSelector(content, onClose) {
        return /*#__PURE__*/ _react.createElement("span", {
            className: (0, _clsx.clsx)("".concat(selectionCls, "-item")),
            title: typeof content === 'string' ? content : null
        }, /*#__PURE__*/ _react.createElement("span", {
            className: "".concat(selectionCls, "-item-content")
        }, content), !disabled && onClose && /*#__PURE__*/ _react.createElement("span", {
            onMouseDown: function onMouseDown(e) {
                e.preventDefault();
            },
            onClick: onClose,
            className: "".concat(selectionCls, "-item-remove")
        }, removeIcon));
    }
    function renderItem(date) {
        var displayLabel = formatDate(date);
        var onClose = function onClose(event) {
            if (event) event.stopPropagation();
            onRemove(date);
        };
        return renderSelector(displayLabel, onClose);
    }
    // ========================= Rest =========================
    function renderRest(omittedValues) {
        var content = "+ ".concat(omittedValues.length, " ...");
        return renderSelector(content);
    }
    // ======================== Render ========================
    return /*#__PURE__*/ _react.createElement("div", {
        className: selectorCls
    }, /*#__PURE__*/ _react.createElement((0, _overflowDefault.default), {
        prefixCls: overflowCls,
        data: value,
        renderItem: renderItem,
        renderRest: renderRest,
        itemKey: function itemKey(date) {
            return formatDate(date);
        },
        maxCount: maxTagCount
    }), !value.length && /*#__PURE__*/ _react.createElement("span", {
        className: "".concat(prefixCls, "-selection-placeholder")
    }, placeholder));
}

},{"clsx":"431Ou","@rc-component/overflow":"eGFPB","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"larUs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _configProvider = require("../../config-provider");
var _context = require("../context");
/**
 * Compatible for legacy `bordered` prop.
 */ const useVariant = (component, variant, legacyBordered)=>{
    const { variant: configVariant, [component]: componentConfig } = _react.useContext((0, _configProvider.ConfigContext));
    const ctxVariant = _react.useContext((0, _context.VariantContext));
    const configComponentVariant = componentConfig?.variant;
    let mergedVariant;
    if (typeof variant !== 'undefined') mergedVariant = variant;
    else if (legacyBordered === false) mergedVariant = 'borderless';
    else // form variant > component global variant > global variant
    mergedVariant = ctxVariant ?? configComponentVariant ?? configVariant ?? 'outlined';
    const enableVariantCls = (0, _configProvider.Variants).includes(mergedVariant);
    return [
        mergedVariant,
        enableVariantCls
    ];
};
exports.default = useVariant;

},{"react":"bmhQu","../../config-provider":[["ConfigContext","dVeAX"],["Variants","75zwC"]],"../context":"krZYn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bGTPJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _hooks = require("../../_util/hooks");
var _context = require("../../config-provider/context");
const useMergedPickerSemantic = (pickerType, classNames, styles, popupClassName, popupStyle, mergedProps)=>{
    const { classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)(pickerType);
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        popup: {
            _default: 'root'
        }
    });
    return _react.useMemo(()=>{
        // ClassNames
        const filledClassNames = {
            ...mergedClassNames,
            popup: {
                ...mergedClassNames.popup,
                root: (0, _clsx.clsx)(mergedClassNames.popup?.root, popupClassName)
            }
        };
        // Styles
        const filledStyles = {
            ...mergedStyles,
            popup: {
                ...mergedStyles.popup,
                root: {
                    ...mergedStyles.popup?.root,
                    ...popupStyle
                }
            }
        };
        // Return
        return [
            filledClassNames,
            filledStyles
        ];
    }, [
        mergedClassNames,
        mergedStyles,
        popupClassName,
        popupStyle
    ]);
};
exports.default = useMergedPickerSemantic;

},{"react":"bmhQu","clsx":"431Ou","../../_util/hooks":"kdnMA","../../config-provider/context":"75zwC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"faEoi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genPanelStyle", ()=>(0, _panel.genPanelStyle));
parcelHelpers.export(exports, "initPanelComponentToken", ()=>(0, _token.initPanelComponentToken));
parcelHelpers.export(exports, "initPickerPanelToken", ()=>(0, _token.initPickerPanelToken));
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../input/style");
var _style1 = require("../../style");
var _compactItem = require("../../style/compact-item");
var _motion = require("../../style/motion");
var _roundedArrow = require("../../style/roundedArrow");
var _internal = require("../../theme/internal");
var _multiple = require("./multiple");
var _multipleDefault = parcelHelpers.interopDefault(_multiple);
var _panel = require("./panel");
var _panelDefault = parcelHelpers.interopDefault(_panel);
var _token = require("./token");
var _variants = require("./variants");
var _variantsDefault = parcelHelpers.interopDefault(_variants);
const genPickerPadding = (paddingBlock, paddingInline)=>{
    return {
        padding: `${(0, _cssinjs.unit)(paddingBlock)} ${(0, _cssinjs.unit)(paddingInline)}`
    };
};
const genPickerStatusStyle = (token)=>{
    const { componentCls, colorError, colorWarning } = token;
    return {
        [`${componentCls}:not(${componentCls}-disabled):not([disabled])`]: {
            [`&${componentCls}-status-error`]: {
                [`${componentCls}-active-bar`]: {
                    background: colorError
                }
            },
            [`&${componentCls}-status-warning`]: {
                [`${componentCls}-active-bar`]: {
                    background: colorWarning
                }
            }
        }
    };
};
const genPickerStyle = (token)=>{
    const { componentCls, antCls, paddingInline, lineWidth, lineType, colorBorder, borderRadius, motionDurationMid, colorTextDisabled, colorTextPlaceholder, colorTextQuaternary, fontSizeLG, inputFontSizeLG, fontSizeSM, inputFontSizeSM, controlHeightSM, paddingInlineSM, paddingXS, marginXS, colorIcon, lineWidthBold, colorPrimary, motionDurationSlow, zIndexPopup, paddingXXS, sizePopupArrow, colorBgElevated, borderRadiusLG, boxShadowSecondary, borderRadiusSM, colorSplit, cellHoverBg, presetsWidth, presetsMaxWidth, boxShadowPopoverArrow, fontHeight, lineHeightLG } = token;
    return [
        {
            [componentCls]: {
                ...(0, _style1.resetComponent)(token),
                ...genPickerPadding(token.paddingBlock, token.paddingInline),
                position: 'relative',
                display: 'inline-flex',
                alignItems: 'center',
                lineHeight: 1,
                borderRadius,
                transition: `border ${motionDurationMid}, box-shadow ${motionDurationMid}, background ${motionDurationMid}`,
                [`${componentCls}-prefix`]: {
                    flex: '0 0 auto',
                    marginInlineEnd: token.inputAffixPadding
                },
                // ======================== Input =========================
                [`${componentCls}-input`]: {
                    position: 'relative',
                    display: 'inline-flex',
                    alignItems: 'center',
                    width: '100%',
                    '> input': {
                        position: 'relative',
                        display: 'inline-block',
                        width: '100%',
                        color: 'inherit',
                        fontSize: token.inputFontSize ?? token.fontSize,
                        lineHeight: token.lineHeight,
                        transition: `all ${motionDurationMid}`,
                        ...(0, _style.genPlaceholderStyle)(colorTextPlaceholder),
                        flex: 'auto',
                        // Fix Firefox flex not correct:
                        // https://github.com/ant-design/ant-design/pull/20023#issuecomment-564389553
                        minWidth: 1,
                        height: 'auto',
                        padding: 0,
                        background: 'transparent',
                        border: 0,
                        fontFamily: 'inherit',
                        '&:focus': {
                            boxShadow: 'none',
                            outline: 0
                        },
                        '&[disabled]': {
                            background: 'transparent',
                            color: colorTextDisabled,
                            cursor: 'not-allowed'
                        }
                    },
                    '&-placeholder': {
                        '> input': {
                            color: colorTextPlaceholder
                        }
                    }
                },
                // Size
                '&-large': {
                    ...genPickerPadding(token.paddingBlockLG, token.paddingInlineLG),
                    borderRadius: token.borderRadiusLG,
                    [`${componentCls}-input > input`]: {
                        fontSize: inputFontSizeLG ?? fontSizeLG,
                        lineHeight: lineHeightLG
                    }
                },
                '&-small': {
                    ...genPickerPadding(token.paddingBlockSM, token.paddingInlineSM),
                    borderRadius: token.borderRadiusSM,
                    [`${componentCls}-input > input`]: {
                        fontSize: inputFontSizeSM ?? fontSizeSM
                    }
                },
                [`${componentCls}-suffix`]: {
                    display: 'flex',
                    flex: 'none',
                    alignSelf: 'center',
                    marginInlineStart: token.calc(paddingXS).div(2).equal(),
                    color: colorTextQuaternary,
                    lineHeight: 1,
                    pointerEvents: 'none',
                    transition: `opacity ${motionDurationMid}, color ${motionDurationMid}`,
                    '> *': {
                        verticalAlign: 'top',
                        '&:not(:last-child)': {
                            marginInlineEnd: marginXS
                        }
                    }
                },
                [`${componentCls}-clear`]: {
                    position: 'absolute',
                    top: '50%',
                    insetInlineEnd: 0,
                    color: colorTextQuaternary,
                    lineHeight: 1,
                    transform: 'translateY(-50%)',
                    cursor: 'pointer',
                    opacity: 0,
                    transition: `opacity ${motionDurationMid}, color ${motionDurationMid}`,
                    '> *': {
                        verticalAlign: 'top'
                    },
                    '&:hover': {
                        color: colorIcon
                    }
                },
                '&:hover': {
                    [`${componentCls}-clear`]: {
                        opacity: 1
                    },
                    // Should use the following selector, but since `:has` has poor compatibility,
                    // we use `:not(:last-child)` instead, which may cause some problems in some cases.
                    // [`${componentCls}-suffix:has(+ ${componentCls}-clear)`]: {
                    [`${componentCls}-suffix:not(:last-child)`]: {
                        opacity: 0
                    }
                },
                [`${componentCls}-separator`]: {
                    position: 'relative',
                    display: 'inline-block',
                    width: '1em',
                    height: fontSizeLG,
                    color: colorTextQuaternary,
                    fontSize: fontSizeLG,
                    verticalAlign: 'top',
                    cursor: 'default',
                    [`${componentCls}-focused &`]: {
                        color: colorIcon
                    },
                    [`${componentCls}-range-separator &`]: {
                        [`${componentCls}-disabled &`]: {
                            cursor: 'not-allowed'
                        }
                    }
                },
                // ======================== Range =========================
                '&-range': {
                    position: 'relative',
                    display: 'inline-flex',
                    // Active bar
                    [`${componentCls}-active-bar`]: {
                        bottom: token.calc(lineWidth).mul(-1).equal(),
                        height: lineWidthBold,
                        background: colorPrimary,
                        opacity: 0,
                        transition: `all ${motionDurationSlow} ease-out`,
                        pointerEvents: 'none'
                    },
                    [`&${componentCls}-focused`]: {
                        [`${componentCls}-active-bar`]: {
                            opacity: 1
                        }
                    },
                    [`${componentCls}-range-separator`]: {
                        alignItems: 'center',
                        padding: `0 ${(0, _cssinjs.unit)(paddingXS)}`,
                        lineHeight: 1
                    }
                },
                // ======================== Clear =========================
                '&-range, &-multiple': {
                    // Clear
                    [`${componentCls}-clear`]: {
                        insetInlineEnd: paddingInline
                    },
                    [`&${componentCls}-small`]: {
                        [`${componentCls}-clear`]: {
                            insetInlineEnd: paddingInlineSM
                        }
                    }
                },
                // ======================= Dropdown =======================
                '&-dropdown': {
                    ...(0, _style1.resetComponent)(token),
                    ...(0, _panel.genPanelStyle)(token),
                    pointerEvents: 'none',
                    position: 'absolute',
                    // Fix incorrect position of picker popup
                    // https://github.com/ant-design/ant-design/issues/35590
                    top: -9999,
                    left: {
                        _skip_check_: true,
                        value: -9999
                    },
                    zIndex: zIndexPopup,
                    [`&${componentCls}-dropdown-hidden`]: {
                        display: 'none'
                    },
                    '&-rtl': {
                        direction: 'rtl'
                    },
                    [`&${componentCls}-dropdown-placement-bottomLeft,
            &${componentCls}-dropdown-placement-bottomRight`]: {
                        [`${componentCls}-range-arrow`]: {
                            top: 0,
                            display: 'block',
                            transform: 'translateY(-100%)'
                        }
                    },
                    [`&${componentCls}-dropdown-placement-topLeft,
            &${componentCls}-dropdown-placement-topRight`]: {
                        [`${componentCls}-range-arrow`]: {
                            bottom: 0,
                            display: 'block',
                            transform: 'translateY(100%) rotate(180deg)'
                        }
                    },
                    [`&${antCls}-slide-up-appear, &${antCls}-slide-up-enter`]: {
                        [`${componentCls}-range-arrow${componentCls}-range-arrow`]: {
                            transition: 'none'
                        }
                    },
                    [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-topRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-topRight`]: {
                        animationName: (0, _motion.slideDownIn)
                    },
                    [`&${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-enter${antCls}-slide-up-enter-active${componentCls}-dropdown-placement-bottomRight,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-appear${antCls}-slide-up-appear-active${componentCls}-dropdown-placement-bottomRight`]: {
                        animationName: (0, _motion.slideUpIn)
                    },
                    // https://github.com/ant-design/ant-design/issues/48727
                    [`&${antCls}-slide-up-leave ${componentCls}-panel-container`]: {
                        pointerEvents: 'none'
                    },
                    [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-topRight`]: {
                        animationName: (0, _motion.slideDownOut)
                    },
                    [`&${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-bottomLeft,
          &${antCls}-slide-up-leave${antCls}-slide-up-leave-active${componentCls}-dropdown-placement-bottomRight`]: {
                        animationName: (0, _motion.slideUpOut)
                    },
                    // Time picker with additional style
                    [`${componentCls}-panel > ${componentCls}-time-panel`]: {
                        paddingTop: paddingXXS
                    },
                    // ======================== Ranges ========================
                    [`${componentCls}-range-wrapper`]: {
                        display: 'flex',
                        position: 'relative'
                    },
                    [`${componentCls}-range-arrow`]: {
                        position: 'absolute',
                        zIndex: 1,
                        display: 'none',
                        paddingInline: token.calc(paddingInline).mul(1.5).equal(),
                        boxSizing: 'content-box',
                        transition: `all ${motionDurationSlow} ease-out`,
                        ...(0, _roundedArrow.genRoundedArrow)(token, colorBgElevated, boxShadowPopoverArrow),
                        '&:before': {
                            insetInlineStart: token.calc(paddingInline).mul(1.5).equal()
                        }
                    },
                    [`${componentCls}-panel-container`]: {
                        overflow: 'hidden',
                        verticalAlign: 'top',
                        background: colorBgElevated,
                        borderRadius: borderRadiusLG,
                        boxShadow: boxShadowSecondary,
                        transition: `margin ${motionDurationSlow}`,
                        display: 'inline-block',
                        pointerEvents: 'auto',
                        // ======================== Layout ========================
                        [`${componentCls}-panel-layout`]: {
                            display: 'flex',
                            flexWrap: 'nowrap',
                            alignItems: 'stretch'
                        },
                        // ======================== Preset ========================
                        [`${componentCls}-presets`]: {
                            display: 'flex',
                            flexDirection: 'column',
                            minWidth: presetsWidth,
                            maxWidth: presetsMaxWidth,
                            ul: {
                                height: 0,
                                flex: 'auto',
                                listStyle: 'none',
                                overflow: 'auto',
                                margin: 0,
                                padding: paddingXS,
                                borderInlineEnd: `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorSplit}`,
                                li: {
                                    ...(0, _style1.textEllipsis),
                                    borderRadius: borderRadiusSM,
                                    paddingInline: paddingXS,
                                    paddingBlock: token.calc(controlHeightSM).sub(fontHeight).div(2).equal(),
                                    cursor: 'pointer',
                                    transition: `all ${motionDurationSlow}`,
                                    '+ li': {
                                        marginTop: marginXS
                                    },
                                    '&:hover': {
                                        background: cellHoverBg
                                    }
                                }
                            }
                        },
                        // ======================== Panels ========================
                        [`${componentCls}-panels`]: {
                            display: 'inline-flex',
                            flexWrap: 'nowrap',
                            // [`${componentCls}-panel`]: {
                            //   borderWidth: `0 0 ${unit(lineWidth)}`,
                            // },
                            '&:last-child': {
                                [`${componentCls}-panel`]: {
                                    borderWidth: 0
                                }
                            }
                        },
                        [`${componentCls}-panel`]: {
                            verticalAlign: 'top',
                            background: 'transparent',
                            borderRadius: 0,
                            borderWidth: 0,
                            [`${componentCls}-content, table`]: {
                                textAlign: 'center'
                            },
                            '&-focused': {
                                borderColor: colorBorder
                            }
                        }
                    }
                },
                '&-dropdown-range': {
                    padding: `${(0, _cssinjs.unit)(token.calc(sizePopupArrow).mul(2).div(3).equal())} 0`,
                    '&-hidden': {
                        display: 'none'
                    }
                },
                '&-rtl': {
                    direction: 'rtl',
                    [`${componentCls}-separator`]: {
                        transform: 'scale(-1, 1)'
                    },
                    [`${componentCls}-footer`]: {
                        '&-extra': {
                            direction: 'rtl'
                        }
                    }
                }
            }
        },
        // Follow code may reuse in other components
        (0, _motion.initSlideMotion)(token, 'slide-up'),
        (0, _motion.initSlideMotion)(token, 'slide-down'),
        (0, _motion.initMoveMotion)(token, 'move-up'),
        (0, _motion.initMoveMotion)(token, 'move-down')
    ];
};
// ============================== Export ==============================
exports.default = (0, _internal.genStyleHooks)('DatePicker', (token)=>{
    const pickerToken = (0, _internal.mergeToken)((0, _style.initInputToken)(token), (0, _token.initPickerPanelToken)(token), {
        inputPaddingHorizontalBase: token.calc(token.paddingSM).sub(1).equal(),
        multipleSelectItemHeight: token.multipleItemHeight,
        selectHeight: token.controlHeight
    });
    return [
        (0, _panelDefault.default)(pickerToken),
        genPickerStyle(pickerToken),
        (0, _variantsDefault.default)(pickerToken),
        genPickerStatusStyle(pickerToken),
        (0, _multipleDefault.default)(pickerToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, _compactItem.genCompactItemStyle)(token, {
            focusElCls: `${token.componentCls}-focused`
        })
    ];
}, (0, _token.prepareComponentToken));

},{"@ant-design/cssinjs":"2VNL8","../../input/style":"8tbVx","../../style":"4Ezp0","../../style/compact-item":"7EW6Y","../../style/motion":[["initMoveMotion","1R9U2"],["initSlideMotion","9hH4M"],["slideDownIn","9hH4M"],["slideDownOut","9hH4M"],["slideUpIn","9hH4M"],["slideUpOut","9hH4M"]],"../../style/roundedArrow":"dmj3M","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"./multiple":"s0FCf","./panel":"9Rmv9","./token":"2ZPrv","./variants":"7f8O1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8tbVx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initComponentToken", ()=>(0, _token.initComponentToken));
parcelHelpers.export(exports, "initInputToken", ()=>(0, _token.initInputToken));
parcelHelpers.export(exports, "genPlaceholderStyle", ()=>genPlaceholderStyle);
parcelHelpers.export(exports, "genActiveStyle", ()=>genActiveStyle);
parcelHelpers.export(exports, "genInputSmallStyle", ()=>genInputSmallStyle);
parcelHelpers.export(exports, "genBasicInputStyle", ()=>genBasicInputStyle);
parcelHelpers.export(exports, "genInputGroupStyle", ()=>genInputGroupStyle);
parcelHelpers.export(exports, "genInputStyle", ()=>genInputStyle);
parcelHelpers.export(exports, "genAffixStyle", ()=>genAffixStyle);
parcelHelpers.export(exports, "useSharedStyle", ()=>useSharedStyle);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../style");
var _compactItem = require("../../style/compact-item");
var _internal = require("../../theme/internal");
var _token = require("./token");
var _variants = require("./variants");
const genPlaceholderStyle = (color)=>({
        // Firefox
        '&::-moz-placeholder': {
            opacity: 1
        },
        '&::placeholder': {
            color,
            userSelect: 'none' // https://github.com/ant-design/ant-design/pull/32639
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        }
    });
const genActiveStyle = (token)=>({
        borderColor: token.activeBorderColor,
        boxShadow: token.activeShadow,
        outline: 0,
        backgroundColor: token.activeBg
    });
const genInputLargeStyle = (token)=>{
    const { paddingBlockLG, lineHeightLG, borderRadiusLG, paddingInlineLG } = token;
    return {
        padding: `${(0, _cssinjs.unit)(paddingBlockLG)} ${(0, _cssinjs.unit)(paddingInlineLG)}`,
        fontSize: token.inputFontSizeLG,
        lineHeight: lineHeightLG,
        borderRadius: borderRadiusLG
    };
};
const genInputSmallStyle = (token)=>({
        padding: `${(0, _cssinjs.unit)(token.paddingBlockSM)} ${(0, _cssinjs.unit)(token.paddingInlineSM)}`,
        fontSize: token.inputFontSizeSM,
        borderRadius: token.borderRadiusSM
    });
const genBasicInputStyle = (token, option = {})=>({
        position: 'relative',
        display: 'inline-block',
        width: '100%',
        minWidth: 0,
        padding: `${(0, _cssinjs.unit)(token.paddingBlock)} ${(0, _cssinjs.unit)(token.paddingInline)}`,
        color: token.colorText,
        fontSize: token.inputFontSize,
        lineHeight: token.lineHeight,
        borderRadius: token.borderRadius,
        transition: `all ${token.motionDurationMid}`,
        ...genPlaceholderStyle(token.colorTextPlaceholder),
        // Size
        '&-lg': {
            ...genInputLargeStyle(token),
            ...option.largeStyle
        },
        '&-sm': {
            ...genInputSmallStyle(token),
            ...option.smallStyle
        },
        // RTL
        '&-rtl, &-textarea-rtl': {
            direction: 'rtl'
        }
    });
const genInputGroupStyle = (token)=>{
    const { componentCls, antCls } = token;
    return {
        position: 'relative',
        display: 'table',
        width: '100%',
        borderCollapse: 'separate',
        borderSpacing: 0,
        // Undo padding and float of grid classes
        "&[class*='col-']": {
            paddingInlineEnd: token.paddingXS,
            '&:last-child': {
                paddingInlineEnd: 0
            }
        },
        // Sizing options
        [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: {
            ...genInputLargeStyle(token)
        },
        [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: {
            ...genInputSmallStyle(token)
        },
        // Fix https://github.com/ant-design/ant-design/issues/5754
        [`&-lg ${antCls}-select-single`]: {
            height: token.controlHeightLG
        },
        [`&-sm ${antCls}-select-single`]: {
            height: token.controlHeightSM
        },
        [`> ${componentCls}`]: {
            display: 'table-cell',
            '&:not(:first-child):not(:last-child)': {
                borderRadius: 0
            }
        },
        [`${componentCls}-group`]: {
            '&-addon, &-wrap': {
                display: 'table-cell',
                width: 1,
                whiteSpace: 'nowrap',
                verticalAlign: 'middle',
                '&:not(:first-child):not(:last-child)': {
                    borderRadius: 0
                }
            },
            '&-wrap > *': {
                display: 'block !important'
            },
            '&-addon': {
                position: 'relative',
                padding: `0 ${(0, _cssinjs.unit)(token.paddingInline)}`,
                color: token.colorText,
                fontWeight: 'normal',
                fontSize: token.inputFontSize,
                textAlign: 'center',
                borderRadius: token.borderRadius,
                transition: `all ${token.motionDurationSlow}`,
                lineHeight: 1,
                // Reset Select's style in addon
                [`${antCls}-select`]: {
                    margin: `${(0, _cssinjs.unit)(token.calc(token.paddingBlock).add(1).mul(-1).equal())} ${(0, _cssinjs.unit)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
                        backgroundColor: 'inherit',
                        border: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} transparent`,
                        boxShadow: 'none'
                    }
                },
                // https://github.com/ant-design/ant-design/issues/31333
                [`${antCls}-cascader-picker`]: {
                    margin: `-9px ${(0, _cssinjs.unit)(token.calc(token.paddingInline).mul(-1).equal())}`,
                    backgroundColor: 'transparent',
                    [`${antCls}-cascader-input`]: {
                        textAlign: 'start',
                        border: 0,
                        boxShadow: 'none'
                    }
                }
            }
        },
        [componentCls]: {
            width: '100%',
            marginBottom: 0,
            textAlign: 'inherit',
            '&:focus': {
                zIndex: 1,
                // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
                borderInlineEndWidth: 1
            },
            '&:hover': {
                zIndex: 1,
                borderInlineEndWidth: 1
            }
        },
        // Reset rounded corners
        [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}-affix-wrapper`]: {
            [`&:not(:first-child) ${componentCls}`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            },
            [`&:not(:last-child) ${componentCls}`]: {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            }
        },
        [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            // Reset Select's style in addon
            [`${antCls}-select`]: {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`${componentCls}-affix-wrapper`]: {
            '&:not(:last-child)': {
                borderStartEndRadius: 0,
                borderEndEndRadius: 0
            },
            '&:not(:first-child)': {
                borderStartStartRadius: 0,
                borderEndStartRadius: 0
            }
        },
        [`&${componentCls}-group-compact`]: {
            display: 'block',
            ...(0, _style.clearFix)(),
            [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
                '&:not(:first-child):not(:last-child)': {
                    borderInlineEndWidth: token.lineWidth,
                    '&:hover, &:focus': {
                        zIndex: 1
                    }
                }
            },
            '& > *': {
                display: 'inline-flex',
                float: 'none',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design-pro/issues/139
                borderRadius: 0
            },
            [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
                display: 'inline-flex'
            },
            '& > *:not(:last-child)': {
                marginInlineEnd: token.calc(token.lineWidth).mul(-1).equal(),
                borderInlineEndWidth: token.lineWidth
            },
            // Undo float for .ant-input-group .ant-input
            [componentCls]: {
                float: 'none'
            },
            // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
            [`& > ${antCls}-select,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderRadius: 0,
                '&:hover, &:focus': {
                    zIndex: 1
                }
            },
            [`& > ${antCls}-select-focused`]: {
                zIndex: 1
            },
            // update z-index for arrow icon
            [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
                zIndex: 1 // https://github.com/ant-design/ant-design/issues/20371
            },
            [`& > *:first-child,
      & > ${antCls}-select:first-child,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
                borderStartStartRadius: token.borderRadius,
                borderEndStartRadius: token.borderRadius
            },
            [`& > *:last-child,
      & > ${antCls}-select:last-child,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
                borderInlineEndWidth: token.lineWidth,
                borderStartEndRadius: token.borderRadius,
                borderEndEndRadius: token.borderRadius
            },
            // https://github.com/ant-design/ant-design/issues/12493
            [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
                verticalAlign: 'top'
            },
            [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
                marginInlineStart: token.calc(token.lineWidth).mul(-1).equal(),
                [`${componentCls}-affix-wrapper`]: {
                }
            }
        }
    };
};
const genInputStyle = (token)=>{
    const { componentCls, controlHeightSM, lineWidth, calc } = token;
    const FIXED_CHROME_COLOR_HEIGHT = 16;
    const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
    return {
        [componentCls]: {
            ...(0, _style.resetComponent)(token),
            ...genBasicInputStyle(token),
            // Variants
            ...(0, _variants.genOutlinedStyle)(token),
            ...(0, _variants.genFilledStyle)(token),
            ...(0, _variants.genBorderlessStyle)(token),
            ...(0, _variants.genUnderlinedStyle)(token),
            '&[type="color"]': {
                height: token.controlHeight,
                [`&${componentCls}-lg`]: {
                    height: token.controlHeightLG
                },
                [`&${componentCls}-sm`]: {
                    height: controlHeightSM,
                    paddingTop: colorSmallPadding,
                    paddingBottom: colorSmallPadding
                }
            },
            '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
                appearance: 'none'
            }
        }
    };
};
const genAllowClearStyle = (token)=>{
    const { componentCls } = token;
    return {
        // ========================= Input =========================
        [`${componentCls}-clear-icon`]: {
            margin: 0,
            padding: 0,
            lineHeight: 0,
            color: token.colorTextQuaternary,
            fontSize: token.fontSizeIcon,
            verticalAlign: -1,
            // https://github.com/ant-design/ant-design/pull/18151
            // https://codesandbox.io/s/wizardly-sun-u10br
            cursor: 'pointer',
            transition: `color ${token.motionDurationSlow}`,
            border: 'none',
            outline: 'none',
            backgroundColor: 'transparent',
            '&:hover': {
                color: token.colorIcon
            },
            '&:active': {
                color: token.colorText
            },
            '&-hidden': {
                visibility: 'hidden'
            },
            '&-has-suffix': {
                margin: `0 ${(0, _cssinjs.unit)(token.inputAffixPadding)}`
            }
        }
    };
};
const genAffixStyle = (token)=>{
    const { componentCls, inputAffixPadding, colorTextDescription, motionDurationSlow, colorIcon, colorIconHover, iconCls } = token;
    const affixCls = `${componentCls}-affix-wrapper`;
    const affixClsDisabled = `${componentCls}-affix-wrapper-disabled`;
    return {
        [affixCls]: {
            ...genBasicInputStyle(token),
            display: 'inline-flex',
            '&-focused, &:focus': {
                zIndex: 1
            },
            [`> input${componentCls}`]: {
                padding: 0
            },
            [`> input${componentCls}, > textarea${componentCls}`]: {
                fontSize: 'inherit',
                border: 'none',
                borderRadius: 0,
                outline: 'none',
                background: 'transparent',
                color: 'inherit',
                '&::-ms-reveal': {
                    display: 'none'
                },
                '&:focus': {
                    boxShadow: 'none !important'
                }
            },
            '&::before': {
                display: 'inline-block',
                width: 0,
                visibility: 'hidden',
                content: '"\\a0"'
            },
            [componentCls]: {
                '&-prefix, &-suffix': {
                    display: 'flex',
                    flex: 'none',
                    alignItems: 'center',
                    '> *:not(:last-child)': {
                        marginInlineEnd: token.paddingXS
                    }
                },
                '&-show-count-suffix': {
                    color: colorTextDescription,
                    direction: 'ltr'
                },
                '&-show-count-has-suffix': {
                    marginInlineEnd: token.paddingXXS
                },
                '&-prefix': {
                    marginInlineEnd: inputAffixPadding
                },
                '&-suffix': {
                    marginInlineStart: inputAffixPadding
                }
            },
            ...genAllowClearStyle(token),
            // password
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'pointer',
                transition: `all ${motionDurationSlow}`,
                '&:hover': {
                    color: colorIconHover
                }
            }
        },
        // 覆盖 affix-wrapper borderRadius！
        [`${componentCls}-underlined`]: {
            borderRadius: 0
        },
        [affixClsDisabled]: {
            // password disabled
            [`${iconCls}${componentCls}-password-icon`]: {
                color: colorIcon,
                cursor: 'not-allowed',
                '&:hover': {
                    color: colorIcon
                }
            }
        }
    };
};
const genGroupStyle = (token)=>{
    const { componentCls, borderRadiusLG, borderRadiusSM } = token;
    return {
        [`${componentCls}-group`]: {
            // Style for input-group: input with label, with button or dropdown...
            ...(0, _style.resetComponent)(token),
            ...genInputGroupStyle(token),
            '&-rtl': {
                direction: 'rtl'
            },
            '&-wrapper': {
                display: 'inline-block',
                width: '100%',
                textAlign: 'start',
                verticalAlign: 'top',
                // https://github.com/ant-design/ant-design/issues/6403
                '&-rtl': {
                    direction: 'rtl'
                },
                // Size
                '&-lg': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusLG,
                        fontSize: token.inputFontSizeLG
                    }
                },
                '&-sm': {
                    [`${componentCls}-group-addon`]: {
                        borderRadius: borderRadiusSM
                    }
                },
                // Variants
                ...(0, _variants.genOutlinedGroupStyle)(token),
                ...(0, _variants.genFilledGroupStyle)(token),
                // '&-disabled': {
                //   [`${componentCls}-group-addon`]: {
                //     ...genDisabledStyle(token),
                //   },
                // },
                // Fix the issue of using icons in Space Compact mode
                // https://github.com/ant-design/ant-design/issues/42122
                [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
                    [`${componentCls}, ${componentCls}-group-addon`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                },
                // Fix the issue of input use show-count param in space compact mode
                // https://github.com/ant-design/ant-design/issues/46872
                [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartEndRadius: 0,
                        borderEndEndRadius: 0
                    }
                },
                // Fix the issue of input use `addonAfter` param in space compact mode
                // https://github.com/ant-design/ant-design/issues/52483
                [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-item`]: {
                    [`${componentCls}-affix-wrapper`]: {
                        borderStartStartRadius: 0,
                        borderEndStartRadius: 0
                    }
                }
            }
        }
    };
};
// ============================== Range ===============================
const genRangeStyle = (token)=>{
    const { componentCls } = token;
    return {
        [`${componentCls}-out-of-range`]: {
            [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
                color: token.colorError
            }
        }
    };
};
const useSharedStyle = (0, _internal.genStyleHooks)([
    'Input',
    'Shared'
], (token)=>{
    const inputToken = (0, _internal.mergeToken)(token, (0, _token.initInputToken)(token));
    return [
        genInputStyle(inputToken),
        genAffixStyle(inputToken)
    ];
}, (0, _token.initComponentToken), {
    resetFont: false
});
exports.default = (0, _internal.genStyleHooks)([
    'Input',
    'Component'
], (token)=>{
    const inputToken = (0, _internal.mergeToken)(token, (0, _token.initInputToken)(token));
    return [
        genGroupStyle(inputToken),
        genRangeStyle(inputToken),
        // =====================================================
        // ==             Space Compact                       ==
        // =====================================================
        (0, _compactItem.genCompactItemStyle)(inputToken, {
            focus: true,
            focusElCls: `${inputToken.componentCls}-affix-wrapper-focused`
        })
    ];
}, (0, _token.initComponentToken), {
    resetFont: false
});

},{"@ant-design/cssinjs":"2VNL8","../../style":"4Ezp0","../../style/compact-item":"7EW6Y","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"./token":"aJMj7","./variants":"2E8zu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aJMj7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initInputToken", ()=>initInputToken);
parcelHelpers.export(exports, "initComponentToken", ()=>initComponentToken);
var _internal = require("../../theme/internal");
function initInputToken(token) {
    return (0, _internal.mergeToken)(token, {
        inputAffixPadding: token.paddingXXS
    });
}
const initComponentToken = (token)=>{
    const { controlHeight, fontSize, lineHeight, lineWidth, controlHeightSM, controlHeightLG, fontSizeLG, lineHeightLG, paddingSM, controlPaddingHorizontalSM, controlPaddingHorizontal, colorFillAlter, colorPrimaryHover, colorPrimary, controlOutlineWidth, controlOutline, colorErrorOutline, colorWarningOutline, colorBgContainer, inputFontSize, inputFontSizeLG, inputFontSizeSM } = token;
    const mergedFontSize = inputFontSize || fontSize;
    const mergedFontSizeSM = inputFontSizeSM || mergedFontSize;
    const mergedFontSizeLG = inputFontSizeLG || fontSizeLG;
    const paddingBlock = Math.round((controlHeight - mergedFontSize * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockSM = Math.round((controlHeightSM - mergedFontSizeSM * lineHeight) / 2 * 10) / 10 - lineWidth;
    const paddingBlockLG = Math.ceil((controlHeightLG - mergedFontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth;
    return {
        paddingBlock: Math.max(paddingBlock, 0),
        paddingBlockSM: Math.max(paddingBlockSM, 0),
        paddingBlockLG: Math.max(paddingBlockLG, 0),
        paddingInline: paddingSM - lineWidth,
        paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
        paddingInlineLG: controlPaddingHorizontal - lineWidth,
        addonBg: colorFillAlter,
        activeBorderColor: colorPrimary,
        hoverBorderColor: colorPrimaryHover,
        activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
        errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
        warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
        hoverBg: colorBgContainer,
        activeBg: colorBgContainer,
        inputFontSize: mergedFontSize,
        inputFontSizeLG: mergedFontSizeLG,
        inputFontSizeSM: mergedFontSizeSM
    };
};

},{"../../theme/internal":"g8twD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2E8zu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genHoverStyle", ()=>genHoverStyle);
parcelHelpers.export(exports, "genDisabledStyle", ()=>genDisabledStyle);
parcelHelpers.export(exports, "genBaseOutlinedStyle", ()=>genBaseOutlinedStyle);
parcelHelpers.export(exports, "genOutlinedStyle", ()=>genOutlinedStyle);
parcelHelpers.export(exports, "genOutlinedGroupStyle", ()=>genOutlinedGroupStyle);
parcelHelpers.export(exports, "genBorderlessStyle", ()=>genBorderlessStyle);
parcelHelpers.export(exports, "genFilledStyle", ()=>genFilledStyle);
parcelHelpers.export(exports, "genFilledGroupStyle", ()=>genFilledGroupStyle);
parcelHelpers.export(exports, "genBaseUnderlinedStyle", ()=>genBaseUnderlinedStyle);
parcelHelpers.export(exports, "genUnderlinedStyle", ()=>genUnderlinedStyle);
var _cssinjs = require("@ant-design/cssinjs");
var _internal = require("../../theme/internal");
const genHoverStyle = (token)=>({
        borderColor: token.hoverBorderColor,
        backgroundColor: token.hoverBg
    });
const genDisabledStyle = (token)=>({
        color: token.colorTextDisabled,
        backgroundColor: token.colorBgContainerDisabled,
        borderColor: token.colorBorder,
        boxShadow: 'none',
        cursor: 'not-allowed',
        opacity: 1,
        'input[disabled], textarea[disabled]': {
            cursor: 'not-allowed'
        },
        '&:hover:not([disabled])': {
            ...genHoverStyle((0, _internal.mergeToken)(token, {
                hoverBorderColor: token.colorBorder,
                hoverBg: token.colorBgContainerDisabled
            }))
        }
    });
const genBaseOutlinedStyle = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: options.borderColor,
        '&:hover': {
            borderColor: options.hoverBorderColor,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: options.activeBorderColor,
            boxShadow: options.activeShadow,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const genOutlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...genBaseOutlinedStyle(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        },
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: options.borderColor
        }
    });
const genOutlinedStyle = (token, extraStyles)=>({
        '&-outlined': {
            ...genBaseOutlinedStyle(token, {
                borderColor: token.colorBorder,
                hoverBorderColor: token.hoverBorderColor,
                activeBorderColor: token.activeBorderColor,
                activeShadow: token.activeShadow
            }),
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                ...genDisabledStyle(token)
            },
            ...genOutlinedStatusStyle(token, {
                status: 'error',
                borderColor: token.colorError,
                hoverBorderColor: token.colorErrorBorderHover,
                activeBorderColor: token.colorError,
                activeShadow: token.errorActiveShadow,
                affixColor: token.colorError
            }),
            ...genOutlinedStatusStyle(token, {
                status: 'warning',
                borderColor: token.colorWarning,
                hoverBorderColor: token.colorWarningBorderHover,
                activeBorderColor: token.colorWarning,
                activeShadow: token.warningActiveShadow,
                affixColor: token.colorWarning
            }),
            ...extraStyles
        }
    });
const genOutlinedGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                borderColor: options.addonBorderColor,
                color: options.addonColor
            }
        }
    });
const genOutlinedGroupStyle = (token)=>({
        '&-outlined': {
            [`${token.componentCls}-group`]: {
                '&-addon': {
                    background: token.addonBg,
                    border: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                },
                '&-addon:first-child': {
                    borderInlineEnd: 0
                },
                '&-addon:last-child': {
                    borderInlineStart: 0
                }
            },
            ...genOutlinedGroupStatusStyle(token, {
                status: 'error',
                addonBorderColor: token.colorError,
                addonColor: token.colorErrorText
            }),
            ...genOutlinedGroupStatusStyle(token, {
                status: 'warning',
                addonBorderColor: token.colorWarning,
                addonColor: token.colorWarningText
            }),
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group-addon`]: {
                    ...genDisabledStyle(token)
                }
            }
        }
    });
const genBorderlessStyle = (token, extraStyles)=>{
    const { componentCls } = token;
    return {
        '&-borderless': {
            background: 'transparent',
            border: 'none',
            '&:focus, &:focus-within': {
                outline: 'none'
            },
            // >>>>> Disabled
            [`&${componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                cursor: 'not-allowed'
            },
            // >>>>> Status
            [`&${componentCls}-status-error`]: {
                '&, & input, & textarea': {
                    color: token.colorError
                }
            },
            [`&${componentCls}-status-warning`]: {
                '&, & input, & textarea': {
                    color: token.colorWarning
                }
            },
            ...extraStyles
        }
    };
};
/* ============== Filled ============== */ const genBaseFilledStyle = (token, options)=>({
        background: options.bg,
        borderWidth: token.lineWidth,
        borderStyle: token.lineType,
        borderColor: 'transparent',
        'input&, & input, textarea&, & textarea': {
            color: options?.inputColor ?? 'unset'
        },
        '&:hover': {
            background: options.hoverBg
        },
        '&:focus, &:focus-within': {
            outline: 0,
            borderColor: options.activeBorderColor,
            backgroundColor: token.activeBg
        }
    });
const genFilledStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...genBaseFilledStyle(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        }
    });
const genFilledStyle = (token, extraStyles)=>({
        '&-filled': {
            ...genBaseFilledStyle(token, {
                bg: token.colorFillTertiary,
                hoverBg: token.colorFillSecondary,
                activeBorderColor: token.activeBorderColor,
                inputColor: token.colorText
            }),
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                ...genDisabledStyle(token)
            },
            ...genFilledStatusStyle(token, {
                status: 'error',
                bg: token.colorErrorBg,
                hoverBg: token.colorErrorBgHover,
                activeBorderColor: token.colorError,
                inputColor: token.colorErrorText,
                affixColor: token.colorError
            }),
            ...genFilledStatusStyle(token, {
                status: 'warning',
                bg: token.colorWarningBg,
                hoverBg: token.colorWarningBgHover,
                activeBorderColor: token.colorWarning,
                inputColor: token.colorWarningText,
                affixColor: token.colorWarning
            }),
            ...extraStyles
        }
    });
const genFilledGroupStatusStyle = (token, options)=>({
        [`&${token.componentCls}-group-wrapper-status-${options.status}`]: {
            [`${token.componentCls}-group-addon`]: {
                background: options.addonBg,
                color: options.addonColor
            }
        }
    });
const genFilledGroupStyle = (token)=>({
        '&-filled': {
            [`${token.componentCls}-group-addon`]: {
                background: token.colorFillTertiary,
                '&:last-child': {
                    position: 'static'
                }
            },
            ...genFilledGroupStatusStyle(token, {
                status: 'error',
                addonBg: token.colorErrorBg,
                addonColor: token.colorErrorText
            }),
            ...genFilledGroupStatusStyle(token, {
                status: 'warning',
                addonBg: token.colorWarningBg,
                addonColor: token.colorWarningText
            }),
            [`&${token.componentCls}-group-wrapper-disabled`]: {
                [`${token.componentCls}-group`]: {
                    '&-addon': {
                        background: token.colorFillTertiary,
                        color: token.colorTextDisabled
                    },
                    '&-addon:first-child': {
                        borderInlineStart: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    },
                    '&-addon:last-child': {
                        borderInlineEnd: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderTop: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`,
                        borderBottom: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.colorBorder}`
                    }
                }
            }
        }
    });
const genBaseUnderlinedStyle = (token, options)=>({
        background: token.colorBgContainer,
        borderWidth: `${(0, _cssinjs.unit)(token.lineWidth)} 0`,
        borderStyle: `${token.lineType} none`,
        borderColor: `transparent transparent ${options.borderColor} transparent`,
        borderRadius: 0,
        '&:hover': {
            borderColor: `transparent transparent ${options.hoverBorderColor} transparent`,
            backgroundColor: token.hoverBg
        },
        '&:focus, &:focus-within': {
            borderColor: `transparent transparent ${options.activeBorderColor} transparent`,
            outline: 0,
            backgroundColor: token.activeBg
        }
    });
const genUnderlinedStatusStyle = (token, options)=>({
        [`&${token.componentCls}-status-${options.status}:not(${token.componentCls}-disabled)`]: {
            ...genBaseUnderlinedStyle(token, options),
            [`${token.componentCls}-prefix, ${token.componentCls}-suffix`]: {
                color: options.affixColor
            }
        },
        [`&${token.componentCls}-status-${options.status}${token.componentCls}-disabled`]: {
            borderColor: `transparent transparent ${options.borderColor} transparent`
        }
    });
const genUnderlinedStyle = (token, extraStyles)=>({
        '&-underlined': {
            ...genBaseUnderlinedStyle(token, {
                borderColor: token.colorBorder,
                hoverBorderColor: token.hoverBorderColor,
                activeBorderColor: token.activeBorderColor,
                activeShadow: token.activeShadow
            }),
            // >>>>> Disabled
            [`&${token.componentCls}-disabled, &[disabled]`]: {
                color: token.colorTextDisabled,
                boxShadow: 'none',
                cursor: 'not-allowed',
                '&:hover': {
                    borderColor: `transparent transparent ${token.colorBorder} transparent`
                }
            },
            'input[disabled], textarea[disabled]': {
                cursor: 'not-allowed'
            },
            ...genUnderlinedStatusStyle(token, {
                status: 'error',
                borderColor: token.colorError,
                hoverBorderColor: token.colorErrorBorderHover,
                activeBorderColor: token.colorError,
                activeShadow: token.errorActiveShadow,
                affixColor: token.colorError
            }),
            ...genUnderlinedStatusStyle(token, {
                status: 'warning',
                borderColor: token.colorWarning,
                hoverBorderColor: token.colorWarningBorderHover,
                activeBorderColor: token.colorWarning,
                activeShadow: token.warningActiveShadow,
                affixColor: token.colorWarning
            }),
            ...extraStyles
        }
    });

},{"@ant-design/cssinjs":"2VNL8","../../theme/internal":"g8twD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"s0FCf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
var _internal = require("../../theme/internal");
var _util = require("./util");
const genSize = (token, suffix)=>{
    const { componentCls, controlHeight } = token;
    const suffixCls = suffix ? `${componentCls}-${suffix}` : '';
    const multipleSelectorUnit = (0, _util.getMultipleSelectorUnit)(token);
    return [
        // genSelectionStyle(token, suffix),
        {
            [`${componentCls}-multiple${suffixCls}`]: {
                paddingBlock: multipleSelectorUnit.containerPadding,
                paddingInlineStart: multipleSelectorUnit.basePadding,
                minHeight: controlHeight,
                // ======================== Selections ========================
                [`${componentCls}-selection-item`]: {
                    height: multipleSelectorUnit.itemHeight,
                    lineHeight: (0, _cssinjs.unit)(multipleSelectorUnit.itemLineHeight)
                }
            }
        }
    ];
};
const genPickerMultipleStyle = (token)=>{
    const { componentCls, calc, lineWidth } = token;
    const smallToken = (0, _internal.mergeToken)(token, {
        fontHeight: token.fontSize,
        selectHeight: token.controlHeightSM,
        multipleSelectItemHeight: token.multipleItemHeightSM,
        borderRadius: token.borderRadiusSM,
        borderRadiusSM: token.borderRadiusXS,
        controlHeight: token.controlHeightSM
    });
    const largeToken = (0, _internal.mergeToken)(token, {
        fontHeight: calc(token.multipleItemHeightLG).sub(calc(lineWidth).mul(2).equal()).equal(),
        fontSize: token.fontSizeLG,
        selectHeight: token.controlHeightLG,
        multipleSelectItemHeight: token.multipleItemHeightLG,
        borderRadius: token.borderRadiusLG,
        borderRadiusSM: token.borderRadius,
        controlHeight: token.controlHeightLG
    });
    return [
        // ======================== Size ========================
        genSize(smallToken, 'small'),
        genSize(token),
        genSize(largeToken, 'large'),
        // ====================== Selection ======================
        {
            [`${componentCls}${componentCls}-multiple`]: {
                width: '100%',
                cursor: 'text',
                // ==================== Selector =====================
                [`${componentCls}-selector`]: {
                    flex: 'auto',
                    padding: 0,
                    position: 'relative',
                    '&:after': {
                        margin: 0
                    },
                    // ================== placeholder ==================
                    [`${componentCls}-selection-placeholder`]: {
                        position: 'absolute',
                        top: '50%',
                        insetInlineStart: token.inputPaddingHorizontalBase,
                        insetInlineEnd: 0,
                        transform: 'translateY(-50%)',
                        transition: `all ${token.motionDurationSlow}`,
                        overflow: 'hidden',
                        whiteSpace: 'nowrap',
                        textOverflow: 'ellipsis',
                        flex: 1,
                        color: token.colorTextPlaceholder,
                        pointerEvents: 'none'
                    }
                },
                // ===================== Overflow ====================
                ...(0, _util.genOverflowStyle)(token),
                // ====================== Input ======================
                // Input is `readonly`, which is used for a11y only
                [`${componentCls}-multiple-input`]: {
                    width: 0,
                    height: 0,
                    border: 0,
                    visibility: 'hidden',
                    position: 'absolute',
                    zIndex: -1
                }
            }
        }
    ];
};
exports.default = genPickerMultipleStyle;

},{"@ant-design/cssinjs":"2VNL8","../../theme/internal":"g8twD","./util":"ezCT1","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ezCT1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getMultipleSelectorUnit", ()=>getMultipleSelectorUnit);
parcelHelpers.export(exports, "genOverflowStyle", ()=>genOverflowStyle);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../style");
const getMultipleSelectorUnit = (token)=>{
    const { multipleSelectItemHeight, paddingXXS, lineWidth, INTERNAL_FIXED_ITEM_MARGIN } = token;
    const basePadding = token.max(token.calc(paddingXXS).sub(lineWidth).equal(), 0);
    const containerPadding = token.max(token.calc(basePadding).sub(INTERNAL_FIXED_ITEM_MARGIN).equal(), 0);
    return {
        basePadding,
        containerPadding,
        itemHeight: (0, _cssinjs.unit)(multipleSelectItemHeight),
        itemLineHeight: (0, _cssinjs.unit)(token.calc(multipleSelectItemHeight).sub(token.calc(token.lineWidth).mul(2)).equal())
    };
};
const genOverflowStyle = (token)=>{
    const { componentCls, iconCls, borderRadiusSM, motionDurationSlow, paddingXS, multipleItemColorDisabled, multipleItemBorderColorDisabled, colorIcon, colorIconHover, INTERNAL_FIXED_ITEM_MARGIN } = token;
    const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
    return {
        /**
     * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
     * may update to redesign with its align logic.
     */ // =========================== Overflow ===========================
        [selectOverflowPrefixCls]: {
            position: 'relative',
            display: 'flex',
            flex: 'auto',
            flexWrap: 'wrap',
            maxWidth: '100%',
            '&-item': {
                flex: 'none',
                alignSelf: 'center',
                // https://github.com/ant-design/ant-design/issues/54179
                maxWidth: 'calc(100% - 4px)',
                display: 'inline-flex'
            },
            // ======================== Selections ==========================
            [`${componentCls}-selection-item`]: {
                display: 'flex',
                alignSelf: 'center',
                flex: 'none',
                boxSizing: 'border-box',
                maxWidth: '100%',
                marginBlock: INTERNAL_FIXED_ITEM_MARGIN,
                borderRadius: borderRadiusSM,
                cursor: 'default',
                transition: `font-size ${motionDurationSlow}, line-height ${motionDurationSlow}, height ${motionDurationSlow}`,
                marginInlineEnd: token.calc(INTERNAL_FIXED_ITEM_MARGIN).mul(2).equal(),
                paddingInlineStart: paddingXS,
                paddingInlineEnd: token.calc(paddingXS).div(2).equal(),
                [`${componentCls}-disabled&`]: {
                    color: multipleItemColorDisabled,
                    borderColor: multipleItemBorderColorDisabled,
                    cursor: 'not-allowed'
                },
                // It's ok not to do this, but 24px makes bottom narrow in view should adjust
                '&-content': {
                    display: 'inline-block',
                    marginInlineEnd: token.calc(paddingXS).div(2).equal(),
                    overflow: 'hidden',
                    whiteSpace: 'pre',
                    // fix whitespace wrapping. custom tags display all whitespace within.
                    textOverflow: 'ellipsis'
                },
                '&-remove': {
                    ...(0, _style.resetIcon)(),
                    display: 'inline-flex',
                    alignItems: 'center',
                    color: colorIcon,
                    fontWeight: 'bold',
                    fontSize: 10,
                    lineHeight: 'inherit',
                    cursor: 'pointer',
                    [`> ${iconCls}`]: {
                        verticalAlign: '-0.2em'
                    },
                    '&:hover': {
                        color: colorIconHover
                    }
                }
            }
        }
    };
};

},{"@ant-design/cssinjs":"2VNL8","../../style":"4Ezp0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Rmv9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genPanelStyle", ()=>genPanelStyle);
var _cssinjs = require("@ant-design/cssinjs");
var _fastColor = require("@ant-design/fast-color");
const genPickerCellInnerStyle = (token)=>{
    const { pickerCellCls, pickerCellInnerCls, cellHeight, borderRadiusSM, motionDurationMid, cellHoverBg, lineWidth, lineType, colorPrimary, cellActiveWithRangeBg, colorTextLightSolid, colorTextDisabled, cellBgDisabled, colorFillSecondary } = token;
    return {
        '&::before': {
            position: 'absolute',
            top: '50%',
            insetInlineStart: 0,
            insetInlineEnd: 0,
            zIndex: 1,
            height: cellHeight,
            transform: 'translateY(-50%)',
            content: '""',
            pointerEvents: 'none'
        },
        // >>> Default
        [pickerCellInnerCls]: {
            position: 'relative',
            zIndex: 2,
            display: 'inline-block',
            minWidth: cellHeight,
            height: cellHeight,
            lineHeight: (0, _cssinjs.unit)(cellHeight),
            borderRadius: borderRadiusSM,
            transition: `background ${motionDurationMid}`
        },
        // >>> Hover
        [`&:hover:not(${pickerCellCls}-in-view):not(${pickerCellCls}-disabled),
    &:hover:not(${pickerCellCls}-selected):not(${pickerCellCls}-range-start):not(${pickerCellCls}-range-end):not(${pickerCellCls}-disabled)`]: {
            [pickerCellInnerCls]: {
                background: cellHoverBg
            }
        },
        // >>> Today
        [`&-in-view${pickerCellCls}-today ${pickerCellInnerCls}`]: {
            '&::before': {
                position: 'absolute',
                top: 0,
                insetInlineEnd: 0,
                bottom: 0,
                insetInlineStart: 0,
                zIndex: 1,
                border: `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorPrimary}`,
                borderRadius: borderRadiusSM,
                content: '""'
            }
        },
        // >>> In Range
        [`&-in-view${pickerCellCls}-in-range,
      &-in-view${pickerCellCls}-range-start,
      &-in-view${pickerCellCls}-range-end`]: {
            position: 'relative',
            [`&:not(${pickerCellCls}-disabled):before`]: {
                background: cellActiveWithRangeBg
            }
        },
        // >>> Selected
        [`&-in-view${pickerCellCls}-selected,
      &-in-view${pickerCellCls}-range-start,
      &-in-view${pickerCellCls}-range-end`]: {
            [`&:not(${pickerCellCls}-disabled) ${pickerCellInnerCls}`]: {
                color: colorTextLightSolid,
                background: colorPrimary
            },
            [`&${pickerCellCls}-disabled ${pickerCellInnerCls}`]: {
                background: colorFillSecondary
            }
        },
        [`&-in-view${pickerCellCls}-range-start:not(${pickerCellCls}-disabled):before`]: {
            insetInlineStart: '50%'
        },
        [`&-in-view${pickerCellCls}-range-end:not(${pickerCellCls}-disabled):before`]: {
            insetInlineEnd: '50%'
        },
        // range start border-radius
        [`&-in-view${pickerCellCls}-range-start:not(${pickerCellCls}-range-end) ${pickerCellInnerCls}`]: {
            borderStartStartRadius: borderRadiusSM,
            borderEndStartRadius: borderRadiusSM,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
        },
        // range end border-radius
        [`&-in-view${pickerCellCls}-range-end:not(${pickerCellCls}-range-start) ${pickerCellInnerCls}`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0,
            borderStartEndRadius: borderRadiusSM,
            borderEndEndRadius: borderRadiusSM
        },
        // >>> Disabled
        '&-disabled': {
            color: colorTextDisabled,
            cursor: 'not-allowed',
            [pickerCellInnerCls]: {
                background: 'transparent'
            },
            '&::before': {
                background: cellBgDisabled
            }
        },
        [`&-disabled${pickerCellCls}-today ${pickerCellInnerCls}::before`]: {
            borderColor: colorTextDisabled
        }
    };
};
const genPanelStyle = (token)=>{
    const { componentCls, pickerCellCls, pickerCellInnerCls, pickerYearMonthCellWidth, pickerControlIconSize, cellWidth, paddingSM, paddingXS, paddingXXS, colorBgContainer, lineWidth, lineType, borderRadiusLG, colorPrimary, colorTextHeading, colorSplit, pickerControlIconBorderWidth, colorIcon, textHeight, motionDurationMid, colorIconHover, fontWeightStrong, cellHeight, pickerCellPaddingVertical, colorTextDisabled, colorText, fontSize, motionDurationSlow, withoutTimeCellHeight, pickerQuarterPanelContentHeight, borderRadiusSM, colorTextLightSolid, cellHoverBg, timeColumnHeight, timeColumnWidth, timeCellHeight, controlItemBgActive, marginXXS, pickerDatePanelPaddingHorizontal, pickerControlIconMargin } = token;
    const pickerPanelWidth = token.calc(cellWidth).mul(7).add(token.calc(pickerDatePanelPaddingHorizontal).mul(2)).equal();
    return {
        [componentCls]: {
            '&-panel': {
                display: 'inline-flex',
                flexDirection: 'column',
                textAlign: 'center',
                background: colorBgContainer,
                borderRadius: borderRadiusLG,
                outline: 'none',
                '&-focused': {
                    borderColor: colorPrimary
                },
                '&-rtl': {
                    [`${componentCls}-prev-icon,
              ${componentCls}-super-prev-icon`]: {
                        transform: 'rotate(45deg)'
                    },
                    [`${componentCls}-next-icon,
              ${componentCls}-super-next-icon`]: {
                        transform: 'rotate(-135deg)'
                    },
                    [`${componentCls}-time-panel`]: {
                        [`${componentCls}-content`]: {
                            direction: 'ltr',
                            '> *': {
                                direction: 'rtl'
                            }
                        }
                    }
                }
            },
            // ========================================================
            // =                     Shared Panel                     =
            // ========================================================
            [`&-decade-panel,
        &-year-panel,
        &-quarter-panel,
        &-month-panel,
        &-week-panel,
        &-date-panel,
        &-time-panel`]: {
                display: 'flex',
                flexDirection: 'column',
                width: pickerPanelWidth
            },
            // ======================= Header =======================
            '&-header': {
                display: 'flex',
                padding: `0 ${(0, _cssinjs.unit)(paddingXS)}`,
                color: colorTextHeading,
                borderBottom: `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorSplit}`,
                '> *': {
                    flex: 'none'
                },
                button: {
                    padding: 0,
                    color: colorIcon,
                    lineHeight: (0, _cssinjs.unit)(textHeight),
                    background: 'transparent',
                    border: 0,
                    cursor: 'pointer',
                    transition: `color ${motionDurationMid}`,
                    fontSize: 'inherit',
                    display: 'inline-flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    '&:empty': {
                        display: 'none'
                    }
                },
                '> button': {
                    minWidth: '1.6em',
                    fontSize,
                    '&:hover': {
                        color: colorIconHover
                    },
                    '&:disabled': {
                        opacity: 0.25,
                        pointerEvents: 'none'
                    }
                },
                '&-view': {
                    flex: 'auto',
                    fontWeight: fontWeightStrong,
                    lineHeight: (0, _cssinjs.unit)(textHeight),
                    '> button': {
                        color: 'inherit',
                        fontWeight: 'inherit',
                        verticalAlign: 'top',
                        '&:not(:first-child)': {
                            marginInlineStart: paddingXS
                        },
                        '&:hover': {
                            color: colorPrimary
                        }
                    }
                }
            },
            // Arrow button
            [`&-prev-icon,
        &-next-icon,
        &-super-prev-icon,
        &-super-next-icon`]: {
                position: 'relative',
                width: pickerControlIconSize,
                height: pickerControlIconSize,
                '&::before': {
                    position: 'absolute',
                    top: 0,
                    insetInlineStart: 0,
                    width: pickerControlIconSize,
                    height: pickerControlIconSize,
                    border: `0 solid currentcolor`,
                    borderBlockStartWidth: pickerControlIconBorderWidth,
                    borderInlineStartWidth: pickerControlIconBorderWidth,
                    content: '""'
                }
            },
            [`&-super-prev-icon,
        &-super-next-icon`]: {
                '&::after': {
                    position: 'absolute',
                    top: pickerControlIconMargin,
                    insetInlineStart: pickerControlIconMargin,
                    display: 'inline-block',
                    width: pickerControlIconSize,
                    height: pickerControlIconSize,
                    border: '0 solid currentcolor',
                    borderBlockStartWidth: pickerControlIconBorderWidth,
                    borderInlineStartWidth: pickerControlIconBorderWidth,
                    content: '""'
                }
            },
            '&-prev-icon, &-super-prev-icon': {
                transform: 'rotate(-45deg)'
            },
            '&-next-icon, &-super-next-icon': {
                transform: 'rotate(135deg)'
            },
            // ======================== Body ========================
            '&-content': {
                width: '100%',
                tableLayout: 'fixed',
                borderCollapse: 'collapse',
                'th, td': {
                    position: 'relative',
                    minWidth: cellHeight,
                    fontWeight: 'normal'
                },
                th: {
                    height: token.calc(cellHeight).add(token.calc(pickerCellPaddingVertical).mul(2)).equal(),
                    color: colorText,
                    verticalAlign: 'middle'
                }
            },
            '&-cell': {
                padding: `${(0, _cssinjs.unit)(pickerCellPaddingVertical)} 0`,
                color: colorTextDisabled,
                cursor: 'pointer',
                // In view
                '&-in-view': {
                    color: colorText
                },
                ...genPickerCellInnerStyle(token)
            },
            [`&-decade-panel,
        &-year-panel,
        &-quarter-panel,
        &-month-panel`]: {
                [`${componentCls}-content`]: {
                    height: token.calc(withoutTimeCellHeight).mul(4).equal()
                },
                [pickerCellInnerCls]: {
                    padding: `0 ${(0, _cssinjs.unit)(paddingXS)}`
                }
            },
            '&-quarter-panel': {
                [`${componentCls}-content`]: {
                    height: pickerQuarterPanelContentHeight
                }
            },
            // ========================================================
            // =                       Special                        =
            // ========================================================
            // ===================== Decade Panel =====================
            '&-decade-panel': {
                [pickerCellInnerCls]: {
                    padding: `0 ${(0, _cssinjs.unit)(token.calc(paddingXS).div(2).equal())}`
                },
                [`${componentCls}-cell::before`]: {
                    display: 'none'
                }
            },
            // ============= Year & Quarter & Month Panel =============
            [`&-year-panel,
        &-quarter-panel,
        &-month-panel`]: {
                [`${componentCls}-body`]: {
                    padding: `0 ${(0, _cssinjs.unit)(paddingXS)}`
                },
                [pickerCellInnerCls]: {
                    width: pickerYearMonthCellWidth
                }
            },
            // ====================== Date Panel ======================
            '&-date-panel': {
                [`${componentCls}-body`]: {
                    padding: `${(0, _cssinjs.unit)(paddingXS)} ${(0, _cssinjs.unit)(pickerDatePanelPaddingHorizontal)}`
                },
                [`${componentCls}-content th`]: {
                    boxSizing: 'border-box',
                    padding: 0
                }
            },
            // ====================== Week Panel ======================
            '&-week-panel-row': {
                td: {
                    '&:before': {
                        transition: `background ${motionDurationMid}`
                    },
                    '&:first-child:before': {
                        borderStartStartRadius: borderRadiusSM,
                        borderEndStartRadius: borderRadiusSM
                    },
                    '&:last-child:before': {
                        borderStartEndRadius: borderRadiusSM,
                        borderEndEndRadius: borderRadiusSM
                    }
                },
                '&:hover td:before': {
                    background: cellHoverBg
                },
                '&-range-start td, &-range-end td, &-selected td, &-hover td': {
                    // Rise priority to override hover style
                    [`&${pickerCellCls}`]: {
                        '&:before': {
                            background: colorPrimary
                        },
                        [`&${componentCls}-cell-week`]: {
                            color: new (0, _fastColor.FastColor)(colorTextLightSolid).setA(0.5).toHexString()
                        },
                        [pickerCellInnerCls]: {
                            color: colorTextLightSolid
                        }
                    }
                },
                '&-range-hover td:before': {
                    background: controlItemBgActive
                }
            },
            // >>> ShowWeek
            '&-week-panel, &-date-panel-show-week': {
                [`${componentCls}-body`]: {
                    padding: `${(0, _cssinjs.unit)(paddingXS)} ${(0, _cssinjs.unit)(paddingSM)}`
                },
                [`${componentCls}-content th`]: {
                    width: 'auto'
                }
            },
            // ==================== Datetime Panel ====================
            '&-datetime-panel': {
                display: 'flex',
                [`${componentCls}-time-panel`]: {
                    borderInlineStart: `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorSplit}`
                },
                [`${componentCls}-date-panel,
          ${componentCls}-time-panel`]: {
                    transition: `opacity ${motionDurationSlow}`
                },
                // Keyboard
                '&-active': {
                    [`${componentCls}-date-panel,
            ${componentCls}-time-panel`]: {
                        opacity: 0.3,
                        '&-active': {
                            opacity: 1
                        }
                    }
                }
            },
            // ====================== Time Panel ======================
            '&-time-panel': {
                width: 'auto',
                minWidth: 'auto',
                [`${componentCls}-content`]: {
                    display: 'flex',
                    flex: 'auto',
                    height: timeColumnHeight
                },
                '&-column': {
                    flex: '1 0 auto',
                    width: timeColumnWidth,
                    margin: `${(0, _cssinjs.unit)(paddingXXS)} 0`,
                    padding: 0,
                    overflowY: 'hidden',
                    textAlign: 'start',
                    listStyle: 'none',
                    transition: `background ${motionDurationMid}`,
                    overflowX: 'hidden',
                    '&::-webkit-scrollbar': {
                        width: 8,
                        backgroundColor: 'transparent'
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: token.colorTextTertiary,
                        borderRadius: token.borderRadiusSM
                    },
                    // For Firefox
                    '&': {
                        scrollbarWidth: 'thin',
                        scrollbarColor: `${token.colorTextTertiary} transparent`
                    },
                    '&::after': {
                        display: 'block',
                        height: `calc(100% - ${(0, _cssinjs.unit)(timeCellHeight)})`,
                        content: '""'
                    },
                    '&:not(:first-child)': {
                        borderInlineStart: `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorSplit}`
                    },
                    '&-active': {
                        background: new (0, _fastColor.FastColor)(controlItemBgActive).setA(0.2).toHexString()
                    },
                    '&:hover': {
                        overflowY: 'auto'
                    },
                    '> li': {
                        margin: 0,
                        padding: 0,
                        [`&${componentCls}-time-panel-cell`]: {
                            marginInline: marginXXS,
                            [`${componentCls}-time-panel-cell-inner`]: {
                                display: 'block',
                                width: token.calc(timeColumnWidth).sub(token.calc(marginXXS).mul(2)).equal(),
                                height: timeCellHeight,
                                margin: 0,
                                paddingBlock: 0,
                                paddingInlineEnd: 0,
                                paddingInlineStart: token.calc(timeColumnWidth).sub(timeCellHeight).div(2).equal(),
                                color: colorText,
                                lineHeight: (0, _cssinjs.unit)(timeCellHeight),
                                borderRadius: borderRadiusSM,
                                cursor: 'pointer',
                                transition: `background ${motionDurationMid}`,
                                '&:hover': {
                                    background: cellHoverBg
                                }
                            },
                            '&-selected': {
                                [`${componentCls}-time-panel-cell-inner`]: {
                                    background: controlItemBgActive
                                }
                            },
                            '&-disabled': {
                                [`${componentCls}-time-panel-cell-inner`]: {
                                    color: colorTextDisabled,
                                    background: 'transparent',
                                    cursor: 'not-allowed'
                                }
                            }
                        }
                    }
                }
            }
        }
    };
};
const genPickerPanelStyle = (token)=>{
    const { componentCls, textHeight, lineWidth, paddingSM, antCls, colorPrimary, cellActiveWithRangeBg, colorPrimaryBorder, lineType, colorSplit } = token;
    return {
        [`${componentCls}-dropdown`]: {
            // ======================== Footer ========================
            [`${componentCls}-footer`]: {
                borderTop: `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorSplit}`,
                '&-extra': {
                    padding: `0 ${(0, _cssinjs.unit)(paddingSM)}`,
                    lineHeight: (0, _cssinjs.unit)(token.calc(textHeight).sub(token.calc(lineWidth).mul(2)).equal()),
                    textAlign: 'start',
                    '&:not(:last-child)': {
                        borderBottom: `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorSplit}`
                    }
                }
            },
            // ==================== Footer > Ranges ===================
            [`${componentCls}-panels + ${componentCls}-footer ${componentCls}-ranges`]: {
                justifyContent: 'space-between'
            },
            [`${componentCls}-ranges`]: {
                marginBlock: 0,
                paddingInline: (0, _cssinjs.unit)(paddingSM),
                overflow: 'hidden',
                textAlign: 'start',
                listStyle: 'none',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                '> li': {
                    lineHeight: (0, _cssinjs.unit)(token.calc(textHeight).sub(token.calc(lineWidth).mul(2)).equal()),
                    display: 'inline-block'
                },
                [`${componentCls}-now-btn-disabled`]: {
                    pointerEvents: 'none',
                    color: token.colorTextDisabled
                },
                // https://github.com/ant-design/ant-design/issues/23687
                [`${componentCls}-preset > ${antCls}-tag-blue`]: {
                    color: colorPrimary,
                    background: cellActiveWithRangeBg,
                    borderColor: colorPrimaryBorder,
                    cursor: 'pointer'
                },
                [`${componentCls}-ok`]: {
                    paddingBlock: token.calc(lineWidth).mul(2).equal(),
                    marginInlineStart: 'auto'
                }
            }
        }
    };
};
exports.default = genPickerPanelStyle;

},{"@ant-design/cssinjs":"2VNL8","@ant-design/fast-color":"50VUA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2ZPrv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initPickerPanelToken", ()=>initPickerPanelToken);
parcelHelpers.export(exports, "initPanelComponentToken", ()=>initPanelComponentToken);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _fastColor = require("@ant-design/fast-color");
var _token = require("../../input/style/token");
var _roundedArrow = require("../../style/roundedArrow");
const initPickerPanelToken = (token)=>{
    const { componentCls, controlHeightLG, paddingXXS, padding } = token;
    return {
        pickerCellCls: `${componentCls}-cell`,
        pickerCellInnerCls: `${componentCls}-cell-inner`,
        pickerYearMonthCellWidth: token.calc(controlHeightLG).mul(1.5).equal(),
        pickerQuarterPanelContentHeight: token.calc(controlHeightLG).mul(1.4).equal(),
        pickerCellPaddingVertical: token.calc(paddingXXS).add(token.calc(paddingXXS).div(2)).equal(),
        pickerCellBorderGap: 2,
        // Magic for gap between cells
        pickerControlIconSize: 7,
        pickerControlIconMargin: 4,
        pickerControlIconBorderWidth: 1.5,
        pickerDatePanelPaddingHorizontal: token.calc(padding).add(token.calc(paddingXXS).div(2)).equal() // 18 in normal
    };
};
const initPanelComponentToken = (token)=>{
    const { colorBgContainerDisabled, controlHeight, controlHeightSM, controlHeightLG, paddingXXS, lineWidth } = token;
    // Item height default use `controlHeight - 2 * paddingXXS`,
    // but some case `paddingXXS=0`.
    // Let's fallback it.
    const dblPaddingXXS = paddingXXS * 2;
    const dblLineWidth = lineWidth * 2;
    const multipleItemHeight = Math.min(controlHeight - dblPaddingXXS, controlHeight - dblLineWidth);
    const multipleItemHeightSM = Math.min(controlHeightSM - dblPaddingXXS, controlHeightSM - dblLineWidth);
    const multipleItemHeightLG = Math.min(controlHeightLG - dblPaddingXXS, controlHeightLG - dblLineWidth);
    // FIXED_ITEM_MARGIN is a hardcode calculation since calc not support rounding
    const INTERNAL_FIXED_ITEM_MARGIN = Math.floor(paddingXXS / 2);
    const filledToken = {
        INTERNAL_FIXED_ITEM_MARGIN,
        cellHoverBg: token.controlItemBgHover,
        cellActiveWithRangeBg: token.controlItemBgActive,
        cellHoverWithRangeBg: new (0, _fastColor.FastColor)(token.colorPrimary).lighten(35).toHexString(),
        cellRangeBorderColor: new (0, _fastColor.FastColor)(token.colorPrimary).lighten(20).toHexString(),
        cellBgDisabled: colorBgContainerDisabled,
        timeColumnWidth: controlHeightLG * 1.4,
        timeColumnHeight: 224,
        timeCellHeight: 28,
        cellWidth: controlHeightSM * 1.5,
        cellHeight: controlHeightSM,
        textHeight: controlHeightLG,
        withoutTimeCellHeight: controlHeightLG * 1.65,
        multipleItemBg: token.colorFillSecondary,
        multipleItemBorderColor: 'transparent',
        multipleItemHeight,
        multipleItemHeightSM,
        multipleItemHeightLG,
        multipleSelectorBgDisabled: colorBgContainerDisabled,
        multipleItemColorDisabled: token.colorTextDisabled,
        multipleItemBorderColorDisabled: 'transparent'
    };
    return filledToken;
};
const prepareComponentToken = (token)=>({
        ...(0, _token.initComponentToken)(token),
        ...initPanelComponentToken(token),
        ...(0, _roundedArrow.getArrowToken)(token),
        presetsWidth: 120,
        presetsMaxWidth: 200,
        zIndexPopup: token.zIndexPopupBase + 50
    });

},{"@ant-design/fast-color":"50VUA","../../input/style/token":"aJMj7","../../style/roundedArrow":"dmj3M","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7f8O1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
var _variants = require("../../input/style/variants");
const genVariantsStyle = (token)=>{
    const { componentCls } = token;
    return {
        [componentCls]: [
            {
                ...(0, _variants.genOutlinedStyle)(token),
                ...(0, _variants.genUnderlinedStyle)(token),
                ...(0, _variants.genFilledStyle)(token),
                ...(0, _variants.genBorderlessStyle)(token)
            },
            // ========================= Multiple =========================
            {
                '&-outlined': {
                    [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
                        background: token.multipleItemBg,
                        border: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
                    }
                },
                '&-filled': {
                    [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
                        background: token.colorBgContainer,
                        border: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.colorSplit}`
                    }
                },
                '&-borderless': {
                    [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
                        background: token.multipleItemBg,
                        border: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
                    }
                },
                '&-underlined': {
                    [`&${componentCls}-multiple ${componentCls}-selection-item`]: {
                        background: token.multipleItemBg,
                        border: `${(0, _cssinjs.unit)(token.lineWidth)} ${token.lineType} ${token.multipleItemBorderColor}`
                    }
                }
            }
        ]
    };
};
exports.default = genVariantsStyle;

},{"@ant-design/cssinjs":"2VNL8","../../input/style/variants":"2E8zu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aFH16":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPlaceholder", ()=>getPlaceholder);
parcelHelpers.export(exports, "getRangePlaceholder", ()=>getRangePlaceholder);
parcelHelpers.export(exports, "useIcons", ()=>useIcons);
var _react = require("react");
var _useIcons = require("../select/useIcons");
var _useIconsDefault = parcelHelpers.interopDefault(_useIcons);
function getPlaceholder(locale, picker, customizePlaceholder) {
    if (customizePlaceholder !== undefined) return customizePlaceholder;
    if (picker === 'year' && locale.lang.yearPlaceholder) return locale.lang.yearPlaceholder;
    if (picker === 'quarter' && locale.lang.quarterPlaceholder) return locale.lang.quarterPlaceholder;
    if (picker === 'month' && locale.lang.monthPlaceholder) return locale.lang.monthPlaceholder;
    if (picker === 'week' && locale.lang.weekPlaceholder) return locale.lang.weekPlaceholder;
    if (picker === 'time' && locale.timePickerLocale.placeholder) return locale.timePickerLocale.placeholder;
    return locale.lang.placeholder;
}
function getRangePlaceholder(locale, picker, customizePlaceholder) {
    if (customizePlaceholder !== undefined) return customizePlaceholder;
    if (picker === 'year' && locale.lang.yearPlaceholder) return locale.lang.rangeYearPlaceholder;
    if (picker === 'quarter' && locale.lang.quarterPlaceholder) return locale.lang.rangeQuarterPlaceholder;
    if (picker === 'month' && locale.lang.monthPlaceholder) return locale.lang.rangeMonthPlaceholder;
    if (picker === 'week' && locale.lang.weekPlaceholder) return locale.lang.rangeWeekPlaceholder;
    if (picker === 'time' && locale.timePickerLocale.placeholder) return locale.timePickerLocale.rangePlaceholder;
    return locale.lang.rangePlaceholder;
}
function useIcons(props, prefixCls) {
    const { allowClear = true } = props;
    const { clearIcon, removeIcon } = (0, _useIconsDefault.default)({
        ...props,
        prefixCls,
        componentName: 'DatePicker'
    });
    const mergedAllowClear = _react.useMemo(()=>{
        if (allowClear === false) return false;
        const allowClearConfig = allowClear === true ? {} : allowClear;
        return {
            clearIcon: clearIcon,
            ...allowClearConfig
        };
    }, [
        allowClear,
        clearIcon
    ]);
    return [
        mergedAllowClear,
        removeIcon
    ];
}

},{"react":"bmhQu","../select/useIcons":"krHDK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"krHDK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useIcons);
var _react = require("react");
var _checkOutlined = require("@ant-design/icons/es/icons/CheckOutlined");
var _checkOutlinedDefault = parcelHelpers.interopDefault(_checkOutlined);
var _closeCircleFilled = require("@ant-design/icons/es/icons/CloseCircleFilled");
var _closeCircleFilledDefault = parcelHelpers.interopDefault(_closeCircleFilled);
var _closeOutlined = require("@ant-design/icons/es/icons/CloseOutlined");
var _closeOutlinedDefault = parcelHelpers.interopDefault(_closeOutlined);
var _downOutlined = require("@ant-design/icons/es/icons/DownOutlined");
var _downOutlinedDefault = parcelHelpers.interopDefault(_downOutlined);
var _loadingOutlined = require("@ant-design/icons/es/icons/LoadingOutlined");
var _loadingOutlinedDefault = parcelHelpers.interopDefault(_loadingOutlined);
var _searchOutlined = require("@ant-design/icons/es/icons/SearchOutlined");
var _searchOutlinedDefault = parcelHelpers.interopDefault(_searchOutlined);
var _warning = require("../_util/warning");
"use client";
function useIcons({ suffixIcon, clearIcon, menuItemSelectedIcon, removeIcon, loading, multiple, hasFeedback, showSuffixIcon, feedbackIcon, showArrow, componentName }) {
    // Clear Icon
    const mergedClearIcon = clearIcon ?? /*#__PURE__*/ _react.createElement((0, _closeCircleFilledDefault.default), null);
    // Validation Feedback Icon
    const getSuffixIconNode = (arrowIcon)=>{
        if (suffixIcon === null && !hasFeedback && !showArrow) return null;
        return /*#__PURE__*/ _react.createElement(_react.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
    };
    // Arrow item icon
    let mergedSuffixIcon = null;
    if (suffixIcon !== undefined) mergedSuffixIcon = getSuffixIconNode(suffixIcon);
    else if (loading) mergedSuffixIcon = getSuffixIconNode(/*#__PURE__*/ _react.createElement((0, _loadingOutlinedDefault.default), {
        spin: true
    }));
    else mergedSuffixIcon = ({ open, showSearch })=>{
        if (open && showSearch) return getSuffixIconNode(/*#__PURE__*/ _react.createElement((0, _searchOutlinedDefault.default), null));
        return getSuffixIconNode(/*#__PURE__*/ _react.createElement((0, _downOutlinedDefault.default), null));
    };
    // Checked item icon
    let mergedItemIcon = null;
    if (menuItemSelectedIcon !== undefined) mergedItemIcon = menuItemSelectedIcon;
    else if (multiple) mergedItemIcon = /*#__PURE__*/ _react.createElement((0, _checkOutlinedDefault.default), null);
    else mergedItemIcon = null;
    let mergedRemoveIcon = null;
    if (removeIcon !== undefined) mergedRemoveIcon = removeIcon;
    else mergedRemoveIcon = /*#__PURE__*/ _react.createElement((0, _closeOutlinedDefault.default), null);
    return {
        // TODO: remove as when all the deps bumped
        clearIcon: mergedClearIcon,
        suffixIcon: mergedSuffixIcon,
        itemIcon: mergedItemIcon,
        removeIcon: mergedRemoveIcon
    };
}

},{"react":"bmhQu","@ant-design/icons/es/icons/CheckOutlined":"jMPci","@ant-design/icons/es/icons/CloseCircleFilled":"d3fPr","@ant-design/icons/es/icons/CloseOutlined":"dinn5","@ant-design/icons/es/icons/DownOutlined":"dGiFt","@ant-design/icons/es/icons/LoadingOutlined":"8Mvdh","@ant-design/icons/es/icons/SearchOutlined":"iN0sG","../_util/warning":"95o3w","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jMPci":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _checkOutlined = require("@ant-design/icons-svg/es/asn/CheckOutlined");
var _checkOutlinedDefault = parcelHelpers.interopDefault(_checkOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const CheckOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _checkOutlinedDefault.default)
    }));
/**![check](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkxMiAxOTBoLTY5LjljLTkuOCAwLTE5LjEgNC41LTI1LjEgMTIuMkw0MDQuNyA3MjQuNSAyMDcgNDc0YTMyIDMyIDAgMDAtMjUuMS0xMi4ySDExMmMtNi43IDAtMTAuNCA3LjctNi4zIDEyLjlsMjczLjkgMzQ3YzEyLjggMTYuMiAzNy40IDE2LjIgNTAuMyAwbDQ4OC40LTYxOC45YzQuMS01LjEuNC0xMi44LTYuMy0xMi44eiIgLz48L3N2Zz4=) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(CheckOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/CheckOutlined":"hwHkd","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hwHkd":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var CheckOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z"
                }
            }
        ]
    },
    "name": "check",
    "theme": "outlined"
};
exports.default = CheckOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dGiFt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _downOutlined = require("@ant-design/icons-svg/es/asn/DownOutlined");
var _downOutlinedDefault = parcelHelpers.interopDefault(_downOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const DownOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _downOutlinedDefault.default)
    }));
/**![down](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4NCAyNTZoLTc1Yy01LjEgMC05LjkgMi41LTEyLjkgNi42TDUxMiA2NTQuMiAyMjcuOSAyNjIuNmMtMy00LjEtNy44LTYuNi0xMi45LTYuNmgtNzVjLTYuNSAwLTEwLjMgNy40LTYuNSAxMi43bDM1Mi42IDQ4Ni4xYzEyLjggMTcuNiAzOSAxNy42IDUxLjcgMGwzNTIuNi00ODYuMWMzLjktNS4zLjEtMTIuNy02LjQtMTIuN3oiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(DownOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/DownOutlined":"7JnW1","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7JnW1":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var DownOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z"
                }
            }
        ]
    },
    "name": "down",
    "theme": "outlined"
};
exports.default = DownOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iN0sG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _searchOutlined = require("@ant-design/icons-svg/es/asn/SearchOutlined");
var _searchOutlinedDefault = parcelHelpers.interopDefault(_searchOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const SearchOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _searchOutlinedDefault.default)
    }));
/**![search](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTkwOS42IDg1NC41TDY0OS45IDU5NC44QzY5MC4yIDU0Mi43IDcxMiA0NzkgNzEyIDQxMmMwLTgwLjItMzEuMy0xNTUuNC04Ny45LTIxMi4xLTU2LjYtNTYuNy0xMzItODcuOS0yMTIuMS04Ny45cy0xNTUuNSAzMS4zLTIxMi4xIDg3LjlDMTQzLjIgMjU2LjUgMTEyIDMzMS44IDExMiA0MTJjMCA4MC4xIDMxLjMgMTU1LjUgODcuOSAyMTIuMUMyNTYuNSA2ODAuOCAzMzEuOCA3MTIgNDEyIDcxMmM2NyAwIDEzMC42LTIxLjggMTgyLjctNjJsMjU5LjcgMjU5LjZhOC4yIDguMiAwIDAwMTEuNiAwbDQzLjYtNDMuNWE4LjIgOC4yIDAgMDAwLTExLjZ6TTU3MC40IDU3MC40QzUyOCA2MTIuNyA0NzEuOCA2MzYgNDEyIDYzNnMtMTE2LTIzLjMtMTU4LjQtNjUuNkMyMTEuMyA1MjggMTg4IDQ3MS44IDE4OCA0MTJzMjMuMy0xMTYuMSA2NS42LTE1OC40QzI5NiAyMTEuMyAzNTIuMiAxODggNDEyIDE4OHMxMTYuMSAyMy4yIDE1OC40IDY1LjZTNjM2IDM1Mi4yIDYzNiA0MTJzLTIzLjMgMTE2LjEtNjUuNiAxNTguNHoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(SearchOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/SearchOutlined":"kRP0t","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kRP0t":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var SearchOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z"
                }
            }
        ]
    },
    "name": "search",
    "theme": "outlined"
};
exports.default = SearchOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Y6Wn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WEEK", ()=>WEEK);
parcelHelpers.export(exports, "WEEKPICKER", ()=>WEEKPICKER);
parcelHelpers.export(exports, "MONTH", ()=>MONTH);
parcelHelpers.export(exports, "MONTHPICKER", ()=>MONTHPICKER);
parcelHelpers.export(exports, "YEAR", ()=>YEAR);
parcelHelpers.export(exports, "YEARPICKER", ()=>YEARPICKER);
parcelHelpers.export(exports, "QUARTER", ()=>QUARTER);
parcelHelpers.export(exports, "QUARTERPICKER", ()=>QUARTERPICKER);
parcelHelpers.export(exports, "TIME", ()=>TIME);
parcelHelpers.export(exports, "TIMEPICKER", ()=>TIMEPICKER);
const [WEEK, WEEKPICKER] = [
    'week',
    'WeekPicker'
];
const [MONTH, MONTHPICKER] = [
    'month',
    'MonthPicker'
];
const [YEAR, YEARPICKER] = [
    'year',
    'YearPicker'
];
const [QUARTER, QUARTERPICKER] = [
    'quarter',
    'QuarterPicker'
];
const [TIME, TIMEPICKER] = [
    'time',
    'TimePicker'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cX8QY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _calendarOutlined = require("@ant-design/icons/es/icons/CalendarOutlined");
var _calendarOutlinedDefault = parcelHelpers.interopDefault(_calendarOutlined);
var _clockCircleOutlined = require("@ant-design/icons/es/icons/ClockCircleOutlined");
var _clockCircleOutlinedDefault = parcelHelpers.interopDefault(_clockCircleOutlined);
var _constant = require("../generatePicker/constant");
"use client";
const SuffixIcon = ({ picker, hasFeedback, feedbackIcon, suffixIcon })=>{
    if (suffixIcon === null || suffixIcon === false) return null;
    if (suffixIcon === true || suffixIcon === undefined) return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, picker === (0, _constant.TIME) ? /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _clockCircleOutlinedDefault.default), null) : /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _calendarOutlinedDefault.default), null), hasFeedback && feedbackIcon);
    return suffixIcon;
};
exports.default = SuffixIcon;

},{"react":"bmhQu","@ant-design/icons/es/icons/CalendarOutlined":"2q2RO","@ant-design/icons/es/icons/ClockCircleOutlined":"kNCW2","../generatePicker/constant":"3Y6Wn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2q2RO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _calendarOutlined = require("@ant-design/icons-svg/es/asn/CalendarOutlined");
var _calendarOutlinedDefault = parcelHelpers.interopDefault(_calendarOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const CalendarOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _calendarOutlinedDefault.default)
    }));
/**![calendar](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MCAxODRINzEydi02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMzg0di02NGMwLTQuNC0zLjYtOC04LThoLTU2Yy00LjQgMC04IDMuNi04IDh2NjRIMTQ0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnY2NjRjMCAxNy43IDE0LjMgMzIgMzIgMzJoNzM2YzE3LjcgMCAzMi0xNC4zIDMyLTMyVjIxNmMwLTE3LjctMTQuMy0zMi0zMi0zMnptLTQwIDY1NkgxODRWNDYwaDY1NnYzODB6TTE4NCAzOTJWMjU2aDEyOHY0OGMwIDQuNCAzLjYgOCA4IDhoNTZjNC40IDAgOC0zLjYgOC04di00OGgyNTZ2NDhjMCA0LjQgMy42IDggOCA4aDU2YzQuNCAwIDgtMy42IDgtOHYtNDhoMTI4djEzNkgxODR6IiAvPjwvc3ZnPg==) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(CalendarOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/CalendarOutlined":"9Z7XE","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9Z7XE":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var CalendarOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z"
                }
            }
        ]
    },
    "name": "calendar",
    "theme": "outlined"
};
exports.default = CalendarOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kNCW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _clockCircleOutlined = require("@ant-design/icons-svg/es/asn/ClockCircleOutlined");
var _clockCircleOutlinedDefault = parcelHelpers.interopDefault(_clockCircleOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const ClockCircleOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _clockCircleOutlinedDefault.default)
    }));
/**![clock-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTY4Ni43IDYzOC42TDU0NC4xIDUzNS41VjI4OGMwLTQuNC0zLjYtOC04LThINDg4Yy00LjQgMC04IDMuNi04IDh2Mjc1LjRjMCAyLjYgMS4yIDUgMy4zIDYuNWwxNjUuNCAxMjAuNmMzLjYgMi42IDguNiAxLjggMTEuMi0xLjdsMjguNi0zOWMyLjYtMy43IDEuOC04LjctMS44LTExLjJ6IiAvPjwvc3ZnPg==) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(ClockCircleOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/ClockCircleOutlined":"jSLkH","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jSLkH":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var ClockCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z"
                }
            }
        ]
    },
    "name": "clock-circle",
    "theme": "outlined"
};
exports.default = ClockCircleOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"04mg8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useComponents);
var _react = require("react");
var _pickerButton = require("../PickerButton");
var _pickerButtonDefault = parcelHelpers.interopDefault(_pickerButton);
function useComponents(components) {
    return (0, _react.useMemo)(()=>({
            button: (0, _pickerButtonDefault.default),
            ...components
        }), [
        components
    ]);
}

},{"react":"bmhQu","../PickerButton":"k6N5y","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k6N5y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _button = require("../button/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
"use client";
const PickerButton = (props)=>/*#__PURE__*/ _react.createElement((0, _buttonDefault.default), {
        size: "small",
        type: "primary",
        ...props
    });
exports.default = PickerButton;

},{"react":"bmhQu","../button/Button":"gfWzz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ekvit":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _picker = require("@rc-component/picker");
var _pickerDefault = parcelHelpers.interopDefault(_picker);
var _clsx = require("clsx");
var _contextIsolator = require("../../_util/ContextIsolator");
var _contextIsolatorDefault = parcelHelpers.interopDefault(_contextIsolator);
var _hooks = require("../../_util/hooks");
var _statusUtils = require("../../_util/statusUtils");
var _warning = require("../../_util/warning");
var _configProvider = require("../../config-provider");
var _disabledContext = require("../../config-provider/DisabledContext");
var _disabledContextDefault = parcelHelpers.interopDefault(_disabledContext);
var _useCSSVarCls = require("../../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _useSize = require("../../config-provider/hooks/useSize");
var _useSizeDefault = parcelHelpers.interopDefault(_useSize);
var _context = require("../../form/context");
var _useVariants = require("../../form/hooks/useVariants");
var _useVariantsDefault = parcelHelpers.interopDefault(_useVariants);
var _locale = require("../../locale");
var _compact = require("../../space/Compact");
var _useMergedPickerSemantic = require("../hooks/useMergedPickerSemantic");
var _useMergedPickerSemanticDefault = parcelHelpers.interopDefault(_useMergedPickerSemantic);
var _enUS = require("../locale/en_US");
var _enUSDefault = parcelHelpers.interopDefault(_enUS);
var _style = require("../style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _util = require("../util");
var _constant = require("./constant");
var _suffixIcon = require("./SuffixIcon");
var _suffixIconDefault = parcelHelpers.interopDefault(_suffixIcon);
var _useComponents = require("./useComponents");
var _useComponentsDefault = parcelHelpers.interopDefault(_useComponents);
"use client";
const generatePicker = (generateConfig)=>{
    const getPicker = (picker, displayName)=>{
        const pickerType = displayName === (0, _constant.TIMEPICKER) ? 'timePicker' : 'datePicker';
        const Picker = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
            const { prefixCls: customizePrefixCls, getPopupContainer: customizeGetPopupContainer, components, style, className, size: customizeSize, bordered, placement, placeholder, disabled: customDisabled, status: customStatus, variant: customVariant, onCalendarChange, classNames, styles, dropdownClassName, popupClassName, popupStyle, rootClassName, suffixIcon, ...restProps } = props;
            var oldProp, newProp;
            const { getPrefixCls, direction, getPopupContainer, // Consume different styles according to different names
            [pickerType]: contextPickerConfig } = (0, _react.useContext)((0, _configProvider.ConfigContext));
            const prefixCls = getPrefixCls('picker', customizePrefixCls);
            // ===================== Size =====================
            const { compactSize, compactItemClassnames } = (0, _compact.useCompactItemContext)(prefixCls, direction);
            const mergedSize = (0, _useSizeDefault.default)((ctx)=>customizeSize ?? compactSize ?? ctx);
            // ===================== Disabled =====================
            const disabled = _react.useContext((0, _disabledContextDefault.default));
            const mergedDisabled = customDisabled ?? disabled;
            // =========== Merged Props for Semantic ===========
            const mergedProps = {
                ...props,
                size: mergedSize,
                disabled: mergedDisabled,
                status: customStatus,
                variant: customVariant
            };
            // ========================= Style ==========================
            // Use original useMergedPickerSemantic for proper popup handling
            const [mergedClassNames, mergedStyles] = (0, _useMergedPickerSemanticDefault.default)(pickerType, classNames, styles, popupClassName || dropdownClassName, popupStyle, mergedProps);
            const innerRef = _react.useRef(null);
            const [variant, enableVariantCls] = (0, _useVariantsDefault.default)('datePicker', customVariant, bordered);
            const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
            const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
            const mergedRootClassName = (0, _clsx.clsx)(hashId, cssVarCls, rootCls, rootClassName);
            (0, _react.useImperativeHandle)(ref, ()=>innerRef.current);
            const additionalProps = {
                showToday: true
            };
            const mergedPicker = picker || props.picker;
            const rootPrefixCls = getPrefixCls();
            // ==================== Legacy =====================
            const { onSelect, multiple } = restProps;
            const hasLegacyOnSelect = onSelect && picker === 'time' && !multiple;
            const onInternalCalendarChange = (date, dateStr, info)=>{
                onCalendarChange?.(date, dateStr, info);
                if (hasLegacyOnSelect) onSelect(date);
            };
            // ===================== Icon =====================
            const [mergedAllowClear, removeIcon] = (0, _util.useIcons)(props, prefixCls);
            // ================== components ==================
            const mergedComponents = (0, _useComponentsDefault.default)(components);
            // ===================== FormItemInput =====================
            const formItemContext = (0, _react.useContext)((0, _context.FormItemInputContext));
            const { hasFeedback, status: contextStatus, feedbackIcon } = formItemContext;
            const mergedSuffixIcon = /*#__PURE__*/ _react.createElement((0, _suffixIconDefault.default), {
                picker: mergedPicker,
                hasFeedback,
                feedbackIcon,
                suffixIcon
            });
            const [contextLocale] = (0, _locale.useLocale)('DatePicker', (0, _enUSDefault.default));
            const locale = {
                ...contextLocale,
                ...props.locale
            };
            // ============================ zIndex ============================
            const [zIndex] = (0, _hooks.useZIndex)('DatePicker', mergedStyles?.popup?.root?.zIndex);
            return /*#__PURE__*/ _react.createElement((0, _contextIsolatorDefault.default), {
                space: true
            }, /*#__PURE__*/ _react.createElement((0, _pickerDefault.default), {
                ref: innerRef,
                placeholder: (0, _util.getPlaceholder)(locale, mergedPicker, placeholder),
                suffixIcon: mergedSuffixIcon,
                placement: placement,
                prevIcon: /*#__PURE__*/ _react.createElement("span", {
                    className: `${prefixCls}-prev-icon`
                }),
                nextIcon: /*#__PURE__*/ _react.createElement("span", {
                    className: `${prefixCls}-next-icon`
                }),
                superPrevIcon: /*#__PURE__*/ _react.createElement("span", {
                    className: `${prefixCls}-super-prev-icon`
                }),
                superNextIcon: /*#__PURE__*/ _react.createElement("span", {
                    className: `${prefixCls}-super-next-icon`
                }),
                transitionName: `${rootPrefixCls}-slide-up`,
                picker: picker,
                onCalendarChange: onInternalCalendarChange,
                ...additionalProps,
                ...restProps,
                locale: locale.lang,
                getPopupContainer: customizeGetPopupContainer || getPopupContainer,
                generateConfig: generateConfig,
                components: mergedComponents,
                direction: direction,
                disabled: mergedDisabled,
                // Style
                prefixCls: prefixCls,
                rootClassName: mergedRootClassName,
                className: (0, _clsx.clsx)({
                    [`${prefixCls}-${mergedSize}`]: mergedSize,
                    [`${prefixCls}-${variant}`]: enableVariantCls
                }, (0, _statusUtils.getStatusClassNames)(prefixCls, (0, _statusUtils.getMergedStatus)(contextStatus, customStatus), hasFeedback), compactItemClassnames, contextPickerConfig?.className, className),
                style: {
                    ...contextPickerConfig?.style,
                    ...style
                },
                // Semantic Style
                classNames: mergedClassNames,
                styles: {
                    ...mergedStyles,
                    popup: {
                        ...mergedStyles.popup,
                        root: {
                            ...mergedStyles.popup.root,
                            zIndex
                        }
                    }
                },
                allowClear: mergedAllowClear,
                removeIcon: removeIcon
            }));
        });
        return Picker;
    };
    const DatePicker = getPicker();
    const WeekPicker = getPicker((0, _constant.WEEK), (0, _constant.WEEKPICKER));
    const MonthPicker = getPicker((0, _constant.MONTH), (0, _constant.MONTHPICKER));
    const YearPicker = getPicker((0, _constant.YEAR), (0, _constant.YEARPICKER));
    const QuarterPicker = getPicker((0, _constant.QUARTER), (0, _constant.QUARTERPICKER));
    const TimePicker = getPicker((0, _constant.TIME), (0, _constant.TIMEPICKER));
    return {
        DatePicker,
        WeekPicker,
        MonthPicker,
        YearPicker,
        TimePicker,
        QuarterPicker
    };
};
exports.default = generatePicker;

},{"react":"bmhQu","@rc-component/picker":"k7KfK","clsx":"431Ou","../../_util/ContextIsolator":"5aVQ9","../../_util/hooks":"6noQ6","../../_util/statusUtils":"gbJk4","../../_util/warning":"95o3w","../../config-provider":"dVeAX","../../config-provider/DisabledContext":"h4TcW","../../config-provider/hooks/useCSSVarCls":"gcu2s","../../config-provider/hooks/useSize":"gXe6G","../../form/context":"krZYn","../../form/hooks/useVariants":"larUs","../../locale":[["useLocale","l6QvX","default"]],"../../space/Compact":"cOSpV","../hooks/useMergedPickerSemantic":"bGTPJ","../locale/en_US":"bGutz","../style":"faEoi","../util":"aFH16","./constant":"3Y6Wn","./SuffixIcon":"cX8QY","./useComponents":"04mg8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dZZ3x":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDownArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDownArrow = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.5,
            strokeWidth: 2,
            d: "m6 9 6 6 6-6"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3C1kF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMonth);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMonth = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M2 12.2c0 1.02.78 1.8 1.8 1.8h8.4c1.02 0 1.8-.78 1.8-1.8V7.4H2zm10.2-9H11v-.6c0-.36-.24-.6-.6-.6s-.6.24-.6.6v.6H6.2v-.6c0-.36-.24-.6-.6-.6s-.6.24-.6.6v.6H3.8C2.78 3.2 2 3.98 2 5v1.2h12V5c0-1.02-.78-1.8-1.8-1.8"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hejBm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgRadioTick2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRadioTick2 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#FFA100",
                        fillOpacity: 0.2,
                        d: "M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10s4.477 10 10 10 10-4.477 10-10"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "#FFA100",
                        strokeLinecap: "round",
                        strokeLinejoin: "round",
                        strokeWidth: 2,
                        d: "M14.665 6.5 8.25 12.917 5.332 10"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9eQb4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSolarDangerTriangleLinear);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSolarDangerTriangleLinear = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 11.92,
                        x2: 11.92,
                        y1: 2.5,
                        y2: 21.5,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: "0%",
                                stopColor: "#FFE111"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: "100%",
                                stopColor: "#FFA100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("filter", {
                        id: "a",
                        width: "140%",
                        height: "140%",
                        x: "-20%",
                        y: "-20%",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("feDropShadow", {
                            dx: 0,
                            dy: 0,
                            floodColor: "#FFA000",
                            floodOpacity: 0.5,
                            stdDeviation: 0.8
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                filter: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "url(#b)",
                        strokeLinejoin: "round",
                        strokeWidth: 2.2,
                        d: "M5.277 10.688c2.898-5.14 4.347-7.71 6.643-7.71s3.745 2.57 6.643 7.71l.361.64c2.41 4.27 3.615 6.406 2.526 7.967-1.089 1.562-3.783 1.562-9.17 1.562h-.723c-5.387 0-8.081 0-9.17-1.562-1.087-1.561.12-3.697 2.529-7.967z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "url(#b)",
                        strokeLinecap: "round",
                        strokeWidth: 2.2,
                        d: "M11.92 7.6v5"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 11.92,
                        cy: 16,
                        r: 1.2,
                        fill: "url(#b)"
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eJMbb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchTrainerProgramPlanList", ()=>fetchTrainerProgramPlanList);
parcelHelpers.export(exports, "useGetTrainerProgramPlanList", ()=>useGetTrainerProgramPlanList);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _deepCamelCaseKeys = require("src/utils/deepCamelCaseKeys");
var _sessionStore = require("src/store/sessionStore");
var _firebase = require("src/config/firebase");
const fetchTrainerProgramPlanList = async (trainerId, filters)=>{
    if (!trainerId) throw new Error('Trainer ID is missing');
    const queryParams = new URLSearchParams({
        trainerId
    });
    if (filters.isActive) queryParams.append('isActive', filters.isActive);
    if (filters.clientId) queryParams.append('clientId', filters.clientId);
    if (filters.sortFilter) queryParams.append('sortBy', filters.sortFilter);
    if (filters.searchQuery) queryParams.append('searchQuery', filters.searchQuery);
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_PROGRAM_PLAN_LIST}?${queryParams.toString()}`;
    const response = await fetch(apiUrl);
    if (!response.ok) throw new Error(`Failed to fetch trainer programs: ${response.status}`);
    const res = await response.json();
    const parsedData = (0, _deepCamelCaseKeys.deepCamelCaseKeys)(res.data);
    return parsedData;
};
function useGetTrainerProgramPlanList(filters = {}) {
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const trainerId = currentUser?.uid || (0, _firebase.auth).currentUser?.uid;
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'trainer-program-plan-list',
            trainerId,
            filters.isActive,
            filters.clientId,
            filters.sortFilter,
            filters.searchQuery
        ],
        queryFn: ()=>fetchTrainerProgramPlanList(trainerId, filters),
        enabled: !!trainerId
    });
}

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","src/utils/deepCamelCaseKeys":"9w8Oj","src/store/sessionStore":"kPSO3","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3xKUM":[function() {},{}],"2HhJP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProgramAi);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgramAi = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        viewBox: "0 0 40 40",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                fillOpacity: 0.05,
                d: "M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                d: "M18.28 22.916a1.67 1.67 0 0 0-1.197-1.197L11.971 20.4a.417.417 0 0 1 0-.801l5.112-1.32a1.67 1.67 0 0 0 1.198-1.196l1.318-5.113a.417.417 0 0 1 .803 0l1.317 5.113a1.67 1.67 0 0 0 1.198 1.197l5.112 1.318a.417.417 0 0 1 0 .803l-5.112 1.318a1.67 1.67 0 0 0-1.198 1.197l-1.318 5.113a.417.417 0 0 1-.803 0zM26.664 12.5v3.333M28.333 14.166H25M13.336 24.166v1.667M14.167 25H12.5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8UBX0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProgramAiLarge);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProgramAiLarge = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        viewBox: "0 0 40 40",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                fillOpacity: 0.05,
                d: "M0 8a8 8 0 0 1 8-8h24a8 8 0 0 1 8 8v24a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                d: "M18.28 22.916a1.67 1.67 0 0 0-1.197-1.197L11.971 20.4a.417.417 0 0 1 0-.801l5.112-1.32a1.67 1.67 0 0 0 1.198-1.196l1.318-5.113a.417.417 0 0 1 .803 0l1.317 5.113a1.67 1.67 0 0 0 1.198 1.197l5.112 1.318a.417.417 0 0 1 0 .803l-5.112 1.318a1.67 1.67 0 0 0-1.198 1.197l-1.318 5.113a.417.417 0 0 1-.803 0zM26.664 12.5v3.333M28.333 14.166H25M13.336 24.166v1.667M14.167 25H12.5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f2Jtq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgShare);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgShare = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 17,
        fill: "none",
        viewBox: "0 0 16 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.467,
            d: "M12.4 5.132a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4M3.6 10.265a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4M12.4 15.4a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4M5.501 9.174l5.008 2.918M10.502 4.04 5.5 6.956"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h8VBW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgArchive);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgArchive = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#D6D6D6",
                strokeWidth: 1.5,
                d: "M9 12c0-.466 0-.699.076-.883a1 1 0 0 1 .541-.54c.184-.077.417-.077.883-.077h3c.466 0 .699 0 .883.076a1 1 0 0 1 .54.541c.077.184.077.417.077.883s0 .699-.076.883a1 1 0 0 1-.541.54c-.184.077-.417.077-.883.077h-3c-.466 0-.699 0-.883-.076a1 1 0 0 1-.54-.541C9 12.699 9 12.466 9 12Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#D6D6D6",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "M20.492 7.008v6c0 3.77 0 5.657-1.172 6.828-1.172 1.17-3.057 1.172-6.828 1.172h-1c-3.77 0-5.657 0-6.828-1.172-1.17-1.172-1.172-3.057-1.172-6.828v-6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#D6D6D6",
                strokeWidth: 1.5,
                d: "M1.992 5c0-.943 0-1.414.293-1.707S3.05 3 3.992 3h16c.943 0 1.414 0 1.707.293s.293.764.293 1.707 0 1.414-.293 1.707S20.935 7 19.992 7h-16c-.943 0-1.414 0-1.707-.293S1.992 5.943 1.992 5Z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eyEXI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgArchiveConfirmation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgArchiveConfirmation = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 64,
        fill: "none",
        viewBox: "0 0 64 64",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M32 .25C49.535.25 63.75 14.465 63.75 32S49.535 63.75 32 63.75.25 49.535.25 32 14.465.25 32 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M32 .25C49.535.25 63.75 14.465 63.75 32S49.535 63.75 32 63.75.25 49.535.25 32 14.465.25 32 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.55,
                d: "M29 32c0-.466 0-.699.076-.883a1 1 0 0 1 .541-.54c.184-.077.417-.077.883-.077h3c.466 0 .699 0 .883.076a1 1 0 0 1 .54.541c.077.184.077.417.077.883s0 .699-.076.883a1 1 0 0 1-.541.54c-.184.077-.417.077-.883.077h-3c-.466 0-.699 0-.883-.076a1 1 0 0 1-.54-.541C29 32.699 29 32.466 29 32"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.55,
                d: "M40.5 27v6c0 3.771 0 5.657-1.172 6.828S36.271 41 32.5 41h-1c-3.771 0-5.657 0-6.828-1.172S23.5 36.771 23.5 33v-6M22 25c0-.943 0-1.414.293-1.707S23.057 23 24 23h16c.943 0 1.414 0 1.707.293S42 24.057 42 25s0 1.414-.293 1.707S40.943 27 40 27H24c-.943 0-1.414 0-1.707-.293S22 25.943 22 25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 66.9,
                        x2: 17.188,
                        y1: 64.016,
                        y2: -16.416,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 32,
                        x2: 32,
                        y1: 0,
                        y2: 64,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lqn5K":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCalendar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCalendar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.5,
            strokeWidth: 1.167,
            d: "M4.664 1.164v2.333M9.336 1.164v2.333M11.083 2.336H2.917c-.645 0-1.167.522-1.167 1.167v8.166c0 .645.522 1.167 1.167 1.167h8.166c.645 0 1.167-.522 1.167-1.167V3.503c0-.645-.522-1.167-1.167-1.167M1.75 5.836h10.5"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8UFg1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgClock);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgClock = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.5,
            strokeWidth: 1.167,
            d: "M7 4.667V7l1.75 1.75M12.25 7A5.25 5.25 0 1 1 1.749 7 5.25 5.25 0 0 1 12.25 7"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aPIYI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDelete);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDelete = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#D6D6D6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.6,
            d: "m19.042 6.99-.831 12.168c-.035.505-.251.979-.606 1.324a1.87 1.87 0 0 1-1.306.538H8.368c-.485 0-.952-.192-1.307-.538a2.04 2.04 0 0 1-.605-1.324L5.625 6.989m4.791 4.009v6.013m3.834-6.013v6.013m.958-10.022V3.983c0-.266-.1-.521-.28-.709a.94.94 0 0 0-.678-.294h-3.834a.94.94 0 0 0-.677.294c-.18.188-.28.443-.28.709v3.006m-4.792 0H20"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"315jk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAssignToClient);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAssignToClient = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#07092C",
            d: "M8 8a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M3.75 9A1.75 1.75 0 0 0 2 10.75V11c0 1.197.761 2.209 1.842 2.896C4.93 14.589 6.402 15 8 15s3.07-.412 4.158-1.104C13.238 13.21 14 12.197 14 11v-.25A1.75 1.75 0 0 0 12.25 9z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cXT4E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCopy);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCopy = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 13,
                height: 13,
                x: 8,
                y: 8,
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.8,
                rx: 2.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.8,
                d: "M4 16a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1qXpt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDashboardModalDuplicate);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDashboardModalDuplicate = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 64,
        fill: "none",
        viewBox: "0 0 64 64",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("mask", {
                id: "a",
                width: 64,
                height: 64,
                x: 0,
                y: 0,
                maskUnits: "userSpaceOnUse",
                style: {
                    maskType: "luminance"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#fff",
                    d: "M64 0H0v64h64z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                mask: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "url(#b)",
                        d: "M32 .25C49.535.25 63.75 14.465 63.75 32S49.535 63.75 32 63.75.25 49.535.25 32 14.465.25 32 .25"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "url(#c)",
                        strokeWidth: 0.5,
                        d: "M32 .25C49.535.25 63.75 14.465 63.75 32S49.535 63.75 32 63.75.25 49.535.25 32 14.465.25 32 .25Z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M25.75 29.084a3.334 3.334 0 0 1 3.334-3.334h10.832a3.33 3.33 0 0 1 3.334 3.334v10.832a3.33 3.33 0 0 1-3.334 3.334H29.084a3.33 3.33 0 0 1-3.334-3.334z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M22.015 37.921a2.5 2.5 0 0 1-1.265-2.171v-12.5c0-1.375 1.125-2.5 2.5-2.5h12.5c.938 0 1.447.481 1.875 1.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 66.9,
                        x2: 17.188,
                        y1: 64.016,
                        y2: -16.416,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "c",
                        x1: 32,
                        x2: 32,
                        y1: 0,
                        y2: 64,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jBuuB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCopyLink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCopyLink = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        viewBox: "0 0 40 40",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                d: "M0 10C0 4.477 4.477 0 10 0h20c5.523 0 10 4.477 10 10v20c0 5.523-4.477 10-10 10H10C4.477 40 0 35.523 0 30z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#04051B",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                d: "M26.664 16.666h-8.333c-.92 0-1.667.746-1.667 1.667v8.333c0 .92.746 1.667 1.667 1.667h8.333c.92 0 1.667-.746 1.667-1.667v-8.333c0-.92-.747-1.667-1.667-1.667"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#04051B",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                d: "M13.33 23.333c-.916 0-1.666-.75-1.666-1.667v-8.333c0-.917.75-1.667 1.667-1.667h8.333c.917 0 1.667.75 1.667 1.667"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bUWqY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMiniptApp);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMiniptApp = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        viewBox: "0 0 40 40",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M8.902 16.73c.045-.014.39-.103.435-.103l24.747-6.375-12.11-6.925A2.4 2.4 0 0 0 20.757 3c-.436 0-.856.119-1.216.327L5.66 11.277c-.39.223-.66.64-.66 1.13v6.538a10.9 10.9 0 0 1 3.902-2.214m11.84-10.416c1.681 0 3.002 1.352 2.867 3.002-.12 1.486-1.41 2.66-2.911 2.645-1.591 0-2.807-1.263-2.792-2.898.015-1.56 1.246-2.75 2.837-2.75M25.572 16.152s-.48 1.16-1.095 2.586c.9.372 7.653 3.225 7.668 3.24 2.161 1.1 3.722 3.09 4.232 5.453.045.238.09.476.12.714V13.344zM32.21 31.547c.646-.995.871-2.184.616-3.343a4.48 4.48 0 0 0-2.341-3.017l-7.429-3.12-3.286 7.697a9.66 9.66 0 0 1-5.403 5.275l5.148 2.943c.36.208.78.327 1.215.327.45 0 .856-.12 1.216-.327l8.869-5.068a4.1 4.1 0 0 0 1.396-1.367M21.193 17.281 9.907 20.18l-.435.104C6.906 20.952 5 23.314 5 26.108c0 3.314 2.671 5.989 5.943 5.989 2.446 0 4.562-1.5 5.462-3.626l.3-.698c.931-2.14 3.377-7.876 4.488-10.492"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fG1PB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessenger);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessenger = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        viewBox: "0 0 40 40",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                fillOpacity: 0.05,
                d: "M0 10C0 4.477 4.477 0 10 0h20c5.523 0 10 4.477 10 10v20c0 5.523-4.477 10-10 10H10C4.477 40 0 35.523 0 30z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                d: "M16.58 26.665a7.5 7.5 0 1 0-3.25-3.25l-1.666 4.917z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1OQrU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSms);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSms = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        viewBox: "0 0 40 40",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                fillOpacity: 0.05,
                d: "M0 10C0 4.477 4.477 0 10 0h20c5.523 0 10 4.477 10 10v20c0 5.523-4.477 10-10 10H10C4.477 40 0 35.523 0 30z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFA100",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                d: "M28.331 24.098v2.5a1.666 1.666 0 0 1-1.816 1.666 16.5 16.5 0 0 1-7.192-2.558 16.25 16.25 0 0 1-5-5 16.5 16.5 0 0 1-2.558-7.225 1.667 1.667 0 0 1 1.658-1.817h2.5a1.67 1.67 0 0 1 1.667 1.434c.105.8.3 1.585.583 2.341a1.67 1.67 0 0 1-.375 1.759l-1.058 1.058a13.33 13.33 0 0 0 5 5l1.058-1.058a1.67 1.67 0 0 1 1.758-.375c.756.282 1.542.477 2.342.583a1.667 1.667 0 0 1 1.433 1.692"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jvVL7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Profile", ()=>Profile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _professionalInfoSection = require("./components/ProfessionalInfoSection");
var _introductionVideoSection = require("./components/IntroductionVideoSection");
var _careerHighlightsSection = require("./components/CareerHighlightsSection");
var _expertiseSection = require("./components/ExpertiseSection");
var _trainingStyleSection = require("./components/TrainingStyleSection");
var _sessionPricingSection = require("./components/SessionPricingSection");
var _locationFacilitySection = require("./components/LocationFacilitySection");
var _socialLinksSection = require("./components/SocialLinksSection");
var _packages = require("./components/Packages/Packages");
var _trainerSettings = require("./components/TrainerSettings/TrainerSettings");
var _completeOnboardingBanner = require("./components/CompleteOnboardingBanner/CompleteOnboardingBanner");
var _profileEditContext = require("./ProfileEditContext");
var _profileScss = require("./Profile.scss");
var _pencil2Svg = require("../../../../../../assets/images/onboarding-trainer/dashboard/profile/pencil2.svg");
const ProfileContent = ()=>{
    const { isBulkEditing, toggleAllEdits } = (0, _react.useContext)((0, _profileEditContext.ProfileEditContext));
    const [searchParams, setSearchParams] = (0, _reactRouterDom.useSearchParams)();
    const currentTabParam = searchParams.get('tab');
    const sectionParam = searchParams.get('section') || searchParams.get('subtab') || searchParams.get('subTab');
    const isSettingsOption = Boolean(sectionParam) || Boolean(currentTabParam && (0, _trainerSettings.SETTINGS_OPTIONS).some((opt)=>opt.id === currentTabParam.toLowerCase().replace(/[\s_]+/g, '-') || opt.label.toLowerCase() === currentTabParam.toLowerCase()));
    const activeTab = currentTabParam === 'packages' ? 'packages' : currentTabParam === 'settings' || isSettingsOption ? 'settings' : 'profile';
    const isPackagesSubflow = activeTab === 'packages' && (searchParams.get('view') === 'create' || searchParams.get('view') === 'edit' || searchParams.get('view') === 'template');
    const handleTabChange = (tab)=>{
        setSearchParams((prev)=>{
            const next = new URLSearchParams(prev);
            if (tab === 'profile') {
                next.delete('tab');
                next.delete('section');
                next.delete('subtab');
                next.delete('subTab');
            } else if (tab === 'packages') {
                next.set('tab', 'packages');
                next.delete('section');
                next.delete('subtab');
                next.delete('subTab');
            } else {
                next.set('tab', 'settings');
                const currentSection = next.get('section') || next.get('subtab');
                if (!currentSection) next.set('section', 'schedule');
            }
            next.delete('view');
            next.delete('id');
            next.delete('type');
            return next;
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "profile-container",
        children: [
            !isPackagesSubflow && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "profile-top-tabs-bar",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _completeOnboardingBanner.CompleteOnboardingBanner), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "profile-top-header-row",
                        children: [
                            activeTab === 'profile' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "header-text",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                                children: 'Profile'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                children: 'Manage your account information'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        className: "edit-profile-btn",
                                        onClick: toggleAllEdits,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pencil2Svg.ReactComponent), {}),
                                            isBulkEditing ? 'Cancel Editing' : 'Edit Profile'
                                        ]
                                    })
                                ]
                            }),
                            activeTab === 'packages' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "header-text",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        children: 'Packages'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'Your can create a maximum of 3 packages'
                                    })
                                ]
                            }),
                            activeTab === 'settings' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "header-text",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                        children: 'Settings'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'Manage your account preferences, notification preferences, and platform configurations in one place.'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "profile-tabs-nav",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: `profile-tab-btn ${activeTab === 'profile' ? 'active' : ''}`,
                                onClick: ()=>handleTabChange('profile'),
                                children: 'My Profile'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "tab-separator"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: `profile-tab-btn ${activeTab === 'packages' ? 'active' : ''}`,
                                onClick: ()=>handleTabChange('packages'),
                                children: 'Packages'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "tab-separator"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: `profile-tab-btn ${activeTab === 'settings' ? 'active' : ''}`,
                                onClick: ()=>handleTabChange('settings'),
                                children: 'Settings'
                            })
                        ]
                    })
                ]
            }),
            activeTab === 'profile' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "profile-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _professionalInfoSection.ProfessionalInfoSection), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _introductionVideoSection.IntroductionVideoSection), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _careerHighlightsSection.CareerHighlightsSection), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expertiseSection.ExpertiseSection), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trainingStyleSection.TrainingStyleSection), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sessionPricingSection.SessionPricingSection), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _locationFacilitySection.LocationFacilitySection), {}),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _socialLinksSection.SocialLinksSection), {})
                ]
            }),
            activeTab === 'packages' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _packages.Packages), {}),
            activeTab === 'settings' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trainerSettings.TrainerSettings), {})
        ]
    });
};
const Profile = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileEditContext.ProfileEditProvider), {
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfileContent, {})
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./components/ProfessionalInfoSection":"bJr2y","./components/IntroductionVideoSection":"kqhTx","./components/CareerHighlightsSection":"b4Wqk","./components/ExpertiseSection":"iLwPD","./components/TrainingStyleSection":"5g7rB","./components/SessionPricingSection":"i8pkN","./components/LocationFacilitySection":"d7Btc","./components/SocialLinksSection":"lJIEb","./components/Packages/Packages":"1RtZ6","./components/TrainerSettings/TrainerSettings":"5s4Rm","./components/CompleteOnboardingBanner/CompleteOnboardingBanner":"c1CtJ","./ProfileEditContext":"iw7ag","./Profile.scss":"3rTMt","../../../../../../assets/images/onboarding-trainer/dashboard/profile/pencil2.svg":"7qRBh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bJr2y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProfessionalInfoSection", ()=>ProfessionalInfoSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _firebase = require("src/config/firebase");
var _auth = require("firebase/auth");
var _profileSection = require("./ProfileSection");
var _sessionStore = require("src/store/sessionStore");
var _useGetOnboardingMasterData = require("src/api/mutations/useGetOnboardingMasterData");
var _useUpdateTrainerProfile = require("src/api/mutations/useUpdateTrainerProfile");
var _imageResizer = require("src/utils/imageResizer");
var _firebaseStorage = require("src/api/services/firebaseStorage");
var _antd = require("antd");
var _fullScreenImageModal = require("src/components/Modals/FullScreenImageModal/FullScreenImageModal");
var _profileEditContext = require("../ProfileEditContext");
var _appAlert = require("src/utils/appAlert");
var _appAlertDefault = parcelHelpers.interopDefault(_appAlert);
var _validation = require("src/utils/validation");
var _professionalInfoSectionScss = require("./ProfessionalInfoSection.scss");
var _selectedServiceSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/selected-service.svg");
var _experienceLevelSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/experience-level.svg");
var _profileRemove2Svg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove2.svg");
var _profileRemoveSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove.svg");
var _experienceSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/experience.svg");
var _uploadSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/upload.svg");
var _emailSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/email.svg");
var _starSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/star.svg");
const ProfessionalInfoSection = ()=>{
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)({});
    const [isUploading, setIsUploading] = (0, _react.useState)(false);
    const [isFullScreenAvatar, setIsFullScreenAvatar] = (0, _react.useState)(false);
    const [isDeleteAvatarModalVisible, setIsDeleteAvatarModalVisible] = (0, _react.useState)(false);
    const { globalEditAction, registerEditState } = (0, _react.useContext)((0, _profileEditContext.ProfileEditContext));
    (0, _react.useEffect)(()=>{
        if (globalEditAction.count > 0) {
            if (globalEditAction.type === 'OPEN') setIsEditing(true);
            else if (globalEditAction.type === 'CLOSE') setIsEditing(false);
        }
    }, [
        globalEditAction
    ]);
    (0, _react.useEffect)(()=>{
        registerEditState('professionalInfo', isEditing);
    }, [
        isEditing,
        registerEditState
    ]);
    const { data: masterData } = (0, _useGetOnboardingMasterData.useGetOnboardingMasterData)();
    const { mutateAsync: updateProfileBackend, isPending } = (0, _useUpdateTrainerProfile.useUpdateTrainerProfile)();
    const offerOptions = (0, _react.useMemo)(()=>{
        return masterData?.['onboarding_offer']?.options || [];
    }, [
        masterData
    ]);
    const getOfferTitle = (spec)=>{
        const opt = offerOptions.find((o)=>o.slug === spec);
        return opt ? opt.title : spec;
    };
    // Local state for editing
    const [name, setName] = (0, _react.useState)(currentUser?.name || '');
    const [surname, setSurname] = (0, _react.useState)(currentUser?.surname || '');
    const [email, setEmail] = (0, _react.useState)(currentUser?.email || '');
    const [avatarUrl, setAvatarUrl] = (0, _react.useState)(currentUser?.avatarUrl || '');
    const [oldAvatarUrl, setOldAvatarUrl] = (0, _react.useState)(''); // To track for deletion
    const [bio, setBio] = (0, _react.useState)(currentUser?.bio || '');
    const [experience, setExperience] = (0, _react.useState)(currentUser?.experience || '');
    const [experienceLevel, setExperienceLevel] = (0, _react.useState)(currentUser?.experienceLevel || '');
    const [step3Offers, setStep3Offers] = (0, _react.useState)(currentUser?.onboarding?.step3_offers || []);
    // Sync state when currentUser changes (e.g. initial load)
    (0, _react.useEffect)(()=>{
        if (currentUser && !isEditing) {
            let initialName = (currentUser.name || '').trim();
            let initialSurname = (currentUser.surname || '').trim();
            if (initialName.includes(' ') && (!initialSurname || initialSurname === 'Trainer')) {
                const parts = initialName.split(/\s+/);
                initialName = parts[0];
                initialSurname = parts.slice(1).join(' ');
            }
            setName(initialName);
            setSurname(initialSurname);
            setEmail(currentUser.email || '');
            setAvatarUrl(currentUser.avatarUrl || '');
            setBio(currentUser.bio || '');
            setExperience(currentUser.experience || '');
            setExperienceLevel(currentUser.experienceLevel || '');
            // Normalize any legacy title-cased strings in the DB to slugs
            setStep3Offers((currentUser.onboarding?.step3_offers || []).map((s)=>s.toLowerCase().replace(/\s+/g, '-')));
        }
    }, [
        currentUser,
        isEditing
    ]);
    const [isSocialLogin, setIsSocialLogin] = (0, _react.useState)(()=>{
        return Boolean((0, _firebase.auth).currentUser?.providerData.some((provider)=>provider.providerId === 'google.com' || provider.providerId === 'apple.com') && !(0, _firebase.auth).currentUser?.providerData.some((provider)=>provider.providerId === 'password'));
    });
    (0, _react.useEffect)(()=>{
        const checkSocial = (user)=>{
            if (user) {
                const isSocial = user.providerData.some((provider)=>provider.providerId === 'google.com' || provider.providerId === 'apple.com') && !user.providerData.some((provider)=>provider.providerId === 'password');
                setIsSocialLogin(Boolean(isSocial));
            }
        };
        checkSocial((0, _firebase.auth).currentUser);
        const unsubscribe = (0, _firebase.auth).onAuthStateChanged((user)=>{
            checkSocial(user);
        });
        return ()=>unsubscribe();
    }, []);
    const handleSave = async ()=>{
        if (!currentUser) return;
        const trimmedName = name.trim();
        const trimmedSurname = surname.trim();
        const trimmedEmail = isSocialLogin ? (currentUser.email || '').trim() : email.trim();
        const trimmedBio = bio.trim();
        const trimmedExperienceLevel = experienceLevel.trim();
        const newErrors = {};
        if (!trimmedName) newErrors.name = 'Name is required';
        else if (!/\p{L}/u.test(trimmedName)) newErrors.name = 'Name must contain at least one letter';
        if (!trimmedSurname) newErrors.surname = 'Surname is required';
        else if (!/\p{L}/u.test(trimmedSurname)) newErrors.surname = 'Surname must contain at least one letter';
        if (!trimmedEmail) newErrors.email = 'Email is required';
        else if (!(0, _validation.isValidEmail)(trimmedEmail)) newErrors.email = 'Please enter a valid email address';
        if (!trimmedBio) newErrors.bio = 'Professional bio is required';
        else if (trimmedBio.length > 1000) newErrors.bio = 'Professional bio must be less than 1000 characters';
        if (!trimmedExperienceLevel) newErrors.experienceLevel = 'Experience level is required';
        let parsedExperience;
        if (experience === '' || experience === null || experience === undefined) newErrors.experience = 'Years of Experience is required';
        else {
            parsedExperience = typeof experience === 'string' ? parseFloat(experience) : experience;
            if (isNaN(parsedExperience) || parsedExperience < 0 || parsedExperience > 99) newErrors.experience = 'Years of Experience must be a valid number between 0 and 99';
        }
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setErrors({});
        setName(trimmedName);
        setSurname(trimmedSurname);
        setEmail(trimmedEmail);
        setBio(trimmedBio);
        setExperienceLevel(trimmedExperienceLevel);
        // Experience validation
        const payloadData = {
            name: trimmedName,
            surname: trimmedSurname,
            avatarUrl,
            bio: trimmedBio,
            experience: parsedExperience,
            experienceLevel: trimmedExperienceLevel,
            onboarding: {
                ...currentUser.onboarding || {},
                step3_offers: step3Offers.map((spec)=>{
                    const opt = offerOptions.find((o)=>o.slug === spec);
                    return opt ? opt.slug : spec;
                })
            }
        };
        let emailChanged = false;
        if (!isSocialLogin && trimmedEmail !== currentUser.email) emailChanged = true;
        if (!emailChanged) payloadData.email = trimmedEmail;
        try {
            if (emailChanged && (0, _firebase.auth).currentUser) {
                const actionCodeSettings = {
                    url: `${window.location.origin}${"/"}/onboarding-trainer/login?type=change-email`,
                    handleCodeInApp: false
                };
                try {
                    await (0, _auth.verifyBeforeUpdateEmail)((0, _firebase.auth).currentUser, trimmedEmail, actionCodeSettings);
                    (0, _appAlertDefault.default).success('Verification email sent! Please check your new email inbox to confirm the change.', {
                        duration: 6000
                    });
                } catch (authError) {
                    if (authError.code === 'auth/email-already-in-use') {
                        (0, _appAlertDefault.default).error('This email is already in use by another account.');
                        return;
                    }
                    if (authError.code === 'auth/requires-recent-login') {
                        (0, _appAlertDefault.default).error('Please log out and log back in to change your email.');
                        return;
                    }
                    throw authError;
                }
            }
            await updateProfileBackend({
                uid: currentUser?.uid || '',
                data: payloadData,
                oldAvatarUrl: oldAvatarUrl ? oldAvatarUrl : undefined
            });
            setIsEditing(false);
            setOldAvatarUrl(''); // reset tracking after save
        } catch (error) {
            console.error(error);
        }
    };
    const handleAvatarUpload = async (e)=>{
        const file = e.target.files?.[0];
        if (!file || !currentUser) return;
        const allowedTypes = [
            'image/png',
            'image/jpeg',
            'image/jpg'
        ];
        if (!allowedTypes.includes(file.type)) {
            (0, _appAlertDefault.default).error('Unsupported file format. Please upload a PNG or JPEG image.');
            return;
        }
        if (file.size > 2097152) {
            (0, _appAlertDefault.default).error('File size exceeds 2MB limit');
            return;
        }
        try {
            setIsUploading(true);
            const resizedFile = await (0, _imageResizer.resizeImage)(file, 2048, 2048);
            const uid = currentUser?.uid || '';
            const downloadUrl = await (0, _firebaseStorage.uploadTrainerFile)(resizedFile, 'avatars', uid);
            // If there's an existing avatar url in local state, mark it for delametion on save
            if (avatarUrl && !oldAvatarUrl && avatarUrl.includes('firebasestorage')) setOldAvatarUrl(avatarUrl);
            setAvatarUrl(downloadUrl);
        } catch (error) {
            console.error(error);
            (0, _appAlertDefault.default).error('Failed to upload image');
        } finally{
            setIsUploading(false);
        }
    };
    const toggleOffer = (opt)=>{
        const isSelected = step3Offers.includes(opt.slug);
        if (isSelected) setStep3Offers((prev)=>prev.filter((s)=>s !== opt.slug));
        else setStep3Offers((prev)=>[
                ...prev,
                opt.slug
            ]);
    };
    const getInitials = ()=>{
        const first = currentUser?.name?.[0] || '';
        const last = currentUser?.surname?.[0] || (currentUser?.name && currentUser.name.includes(' ') ? currentUser.name.trim().split(/\s+/)[1]?.[0] || '' : '');
        return `${first}${last}`.toUpperCase() || 'U';
    };
    const displayOffers = (currentUser?.onboarding?.step3_offers || []).map((s)=>s.toLowerCase().replace(/\s+/g, '-'));
    const viewContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "professional-info-view",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "profile-header-main",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `avatar-large ${currentUser?.avatarUrl ? 'clickable' : ''}`,
                        onClick: ()=>currentUser?.avatarUrl && setIsFullScreenAvatar(true),
                        style: currentUser?.avatarUrl ? {
                            backgroundImage: `url(${currentUser.avatarUrl})`,
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            color: 'transparent',
                            cursor: 'pointer'
                        } : {},
                        children: !currentUser?.avatarUrl && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: getInitials()
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "profile-details",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                children: currentUser ? `${currentUser.name || ''} ${currentUser.surname || ''}`.trim() || 'Guest User' : 'Guest User'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "service-offered",
                                children: displayOffers.length > 0 ? displayOffers.map(getOfferTitle).join(" \u2022 ") : 'No services listed'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rating",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "star",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _starSvg.ReactComponent), {})
                                    }),
                                    ' ',
                                    currentUser?.review ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "star",
                                                children: "5.0"
                                            }),
                                            " ",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "reviews",
                                                children: "(0 reviews)"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "reviews",
                                            children: "No rating yet"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "info-meta-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "meta-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emailSvg.ReactComponent), {}),
                            " ",
                            currentUser?.email || 'No email provided'
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "meta-item",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _experienceSvg.ReactComponent), {}),
                            ' ',
                            currentUser?.experience ? `${currentUser.experience} years experience` : 'No experience listed'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "info-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectedServiceSvg.ReactComponent), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: "SERVICES OFFERED"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "chips-container",
                        children: displayOffers.length > 0 ? displayOffers.map((spec)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "chip",
                                children: getOfferTitle(spec)
                            }, spec)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "no-data",
                            children: 'No Services Offered selected.'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "info-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _experienceLevelSvg.ReactComponent), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: "EXPERIENCE LEVEL"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "card-value",
                        children: currentUser?.experienceLevel || 'No experience level provided.'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "info-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "card-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _experienceLevelSvg.ReactComponent), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: "PROFESSIONAL BIO"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "card-value",
                        children: currentUser?.bio || 'No professional bio provided.'
                    })
                ]
            })
        ]
    });
    const editContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "professional-info-edit",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "avatar-and-names-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "avatar-upload",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                position: 'relative',
                                display: 'inline-block'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "avatar-large",
                                style: avatarUrl ? {
                                    position: 'relative',
                                    overflow: 'hidden',
                                    backgroundImage: `url(${avatarUrl})`,
                                    backgroundSize: 'cover',
                                    backgroundPosition: 'center',
                                    color: 'transparent',
                                    cursor: isUploading ? 'not-allowed' : 'pointer',
                                    opacity: isUploading ? 0.5 : 1
                                } : {
                                    position: 'relative',
                                    overflow: 'hidden',
                                    cursor: isUploading ? 'not-allowed' : 'pointer',
                                    opacity: isUploading ? 0.5 : 1
                                },
                                children: [
                                    !avatarUrl && !isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: getInitials()
                                    }),
                                    isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "hover-overlay",
                                        style: {
                                            opacity: 1,
                                            cursor: 'not-allowed'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "loader"
                                        })
                                    }),
                                    !isUploading && !avatarUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "hover-overlay",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                type: "file",
                                                accept: "image/png, image/jpeg, image/jpg",
                                                onChange: handleAvatarUpload,
                                                disabled: isUploading,
                                                style: {
                                                    position: 'absolute',
                                                    top: 0,
                                                    left: 0,
                                                    width: '100%',
                                                    height: '100%',
                                                    opacity: 0,
                                                    cursor: 'pointer',
                                                    borderRadius: '16px',
                                                    zIndex: 2
                                                },
                                                title: "Upload Profile Picture"
                                            })
                                        ]
                                    }),
                                    !isUploading && avatarUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "hover-overlay with-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                className: "action-icon",
                                                title: "Change Profile Picture",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        type: "file",
                                                        accept: "image/png, image/jpeg, image/jpg",
                                                        onChange: handleAvatarUpload,
                                                        disabled: isUploading,
                                                        style: {
                                                            display: 'none'
                                                        }
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "action-icon",
                                                title: "Remove Profile Picture",
                                                onClick: (e)=>{
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    setIsDeleteAvatarModalVisible(true);
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileRemoveSvg.ReactComponent), {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-row names-form-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: "FIRST NAME"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        value: name,
                                        maxLength: 50,
                                        onChange: (e)=>{
                                            const val = e.target.value;
                                            setName(val);
                                            if (!/\p{L}/u.test(val.trim()) && val.trim() !== '') setErrors((prev)=>({
                                                    ...prev,
                                                    name: 'Name must contain at least one letter'
                                                }));
                                            else if (errors.name) setErrors((prev)=>({
                                                    ...prev,
                                                    name: ''
                                                }));
                                        },
                                        onBlur: (e)=>{
                                            const val = e.target.value.trim();
                                            setName(val);
                                            if (!/\p{L}/u.test(val) && val !== '') setErrors((prev)=>({
                                                    ...prev,
                                                    name: 'Name must contain at least one letter'
                                                }));
                                        },
                                        placeholder: "John",
                                        className: errors.name ? 'error-border' : ''
                                    }),
                                    errors.name && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "error-message",
                                        children: errors.name
                                    }),
                                    name.length >= 50 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                                        style: {
                                            color: '#E44E4E',
                                            alignSelf: 'flex-end',
                                            marginTop: 4
                                        },
                                        children: [
                                            name.length,
                                            "/50"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: "SURNAME"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        value: surname,
                                        maxLength: 50,
                                        onChange: (e)=>{
                                            const val = e.target.value;
                                            setSurname(val);
                                            if (!/\p{L}/u.test(val.trim()) && val.trim() !== '') setErrors((prev)=>({
                                                    ...prev,
                                                    surname: 'Surname must contain at least one letter'
                                                }));
                                            else if (errors.surname) setErrors((prev)=>({
                                                    ...prev,
                                                    surname: ''
                                                }));
                                        },
                                        onBlur: (e)=>{
                                            const val = e.target.value.trim();
                                            setSurname(val);
                                            if (!/\p{L}/u.test(val) && val !== '') setErrors((prev)=>({
                                                    ...prev,
                                                    surname: 'Surname must contain at least one letter'
                                                }));
                                        },
                                        placeholder: "Trainer",
                                        className: errors.surname ? 'error-border' : ''
                                    }),
                                    errors.surname && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "error-message",
                                        children: errors.surname
                                    }),
                                    surname.length >= 50 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                                        style: {
                                            color: '#E44E4E',
                                            alignSelf: 'flex-end',
                                            marginTop: 4
                                        },
                                        children: [
                                            surname.length,
                                            "/50"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        children: "EMAIL"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "email",
                        value: email,
                        disabled: isSocialLogin,
                        onChange: (e)=>{
                            if (isSocialLogin) return;
                            setEmail(e.target.value);
                            if (errors.email) setErrors((prev)=>({
                                    ...prev,
                                    email: ''
                                }));
                        },
                        onBlur: (e)=>setEmail(e.target.value.trim()),
                        placeholder: "e.g. john.doe@example.com",
                        className: `${errors.email ? 'error-border' : ''} ${isSocialLogin ? 'disabled-input' : ''}`
                    }),
                    errors.email && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "error-message",
                        children: errors.email
                    }),
                    isSocialLogin && /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                        className: "field-hint",
                        children: "Email cannot be changed for accounts signed up via social login."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        children: 'Professional Bio'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        placeholder: "Tell clients about yourself, your experience, and your approach...",
                        value: bio,
                        maxLength: 1000,
                        onChange: (e)=>{
                            setBio(e.target.value);
                            if (errors.bio) setErrors((prev)=>({
                                    ...prev,
                                    bio: ''
                                }));
                        },
                        onBlur: (e)=>setBio(e.target.value.trim()),
                        className: errors.bio ? 'error-border' : ''
                    }),
                    errors.bio && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "error-message",
                        children: errors.bio
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                        style: {
                            color: bio.length > 1000 ? 'red' : 'rgba(255,255,255,0.4)',
                            alignSelf: 'flex-end',
                            marginTop: 4
                        },
                        children: [
                            bio.length,
                            "/1000"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        children: 'Years of Experience'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        inputMode: "decimal",
                        value: experience,
                        onChange: (e)=>{
                            const val = e.target.value;
                            if (val === '' || /^\d{0,2}(\.\d{0,1})?$/.test(val)) {
                                setExperience(val);
                                if (errors.experience) setErrors((prev)=>({
                                        ...prev,
                                        experience: ''
                                    }));
                            }
                        },
                        placeholder: "e.g. 5.5",
                        className: errors.experience ? 'error-border' : ''
                    }),
                    errors.experience && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "error-message",
                        children: errors.experience
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        children: 'Experience Level'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        value: experienceLevel,
                        maxLength: 200,
                        onChange: (e)=>{
                            setExperienceLevel(e.target.value);
                            if (errors.experienceLevel) setErrors((prev)=>({
                                    ...prev,
                                    experienceLevel: ''
                                }));
                        },
                        onBlur: (e)=>setExperienceLevel(e.target.value.trim()),
                        placeholder: "e.g. Intermediate Personal Trainer",
                        className: errors.experienceLevel ? 'error-border' : ''
                    }),
                    errors.experienceLevel && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "error-message",
                        children: errors.experienceLevel
                    }),
                    experienceLevel.length >= 200 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                        style: {
                            color: '#E44E4E',
                            alignSelf: 'flex-end',
                            marginTop: 4
                        },
                        children: [
                            experienceLevel.length,
                            "/200"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        children: 'Services offered (select all that apply)'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "chips-selector",
                        children: offerOptions.length > 0 ? offerOptions.map((opt)=>{
                            const isSelected = step3Offers.includes(opt.slug);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: `chip-btn ${isSelected ? 'selected' : ''}`,
                                onClick: ()=>toggleOffer(opt),
                                children: opt.title
                            }, opt.slug);
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            style: {
                                color: 'rgba(255,255,255,0.4)',
                                fontSize: 14
                            },
                            children: 'Loading services...'
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileSection.ProfileSection), {
                title: "Professional Information",
                isEditing: isEditing,
                isSaving: isPending,
                isActionDisabled: isUploading,
                onEditToggle: setIsEditing,
                onSave: handleSave,
                onCancel: ()=>{
                    if (currentUser) {
                        setName(currentUser.name || '');
                        setSurname(currentUser.surname || '');
                        setEmail(currentUser.email || '');
                        setAvatarUrl(currentUser.avatarUrl || '');
                        setBio(currentUser.bio || '');
                        setExperience(currentUser.experience ?? '');
                        setExperienceLevel(currentUser.experienceLevel || '');
                        setStep3Offers(currentUser.onboarding?.step3_offers || []);
                        setOldAvatarUrl('');
                        setErrors({});
                    }
                },
                editContent: editContent,
                children: viewContent
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullScreenImageModal.FullScreenImageModal), {
                isOpen: isFullScreenAvatar && !!currentUser?.avatarUrl,
                onClose: ()=>setIsFullScreenAvatar(false),
                imageUrl: currentUser?.avatarUrl || ''
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: isDeleteAvatarModalVisible,
                footer: null,
                onCancel: ()=>setIsDeleteAvatarModalVisible(false),
                centered: true,
                width: 400,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileRemove2Svg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Delete Profile Photo?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Are you sure you want to delete your profile photo?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "btn-logout",
                                    onClick: ()=>{
                                        if (avatarUrl.includes('firebasestorage')) setOldAvatarUrl(avatarUrl);
                                        setAvatarUrl('');
                                        setIsDeleteAvatarModalVisible(false);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileRemoveSvg.ReactComponent), {}),
                                        " Delete"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setIsDeleteAvatarModalVisible(false),
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/config/firebase":"cmjIE","firebase/auth":"dZ6yw","./ProfileSection":"eigPk","src/store/sessionStore":"kPSO3","src/api/mutations/useGetOnboardingMasterData":"dhU6k","src/api/mutations/useUpdateTrainerProfile":"4z0zZ","src/utils/imageResizer":"4DLAC","src/api/services/firebaseStorage":"cCllM","antd":[["Modal","kY4DD","default"]],"src/components/Modals/FullScreenImageModal/FullScreenImageModal":"7dgg4","../ProfileEditContext":"iw7ag","src/utils/appAlert":"de4Mq","src/utils/validation":"1NJZx","./ProfessionalInfoSection.scss":"jDkE0","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/selected-service.svg":"hrPb3","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/experience-level.svg":"9iaYU","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove2.svg":"lzWT7","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove.svg":"sZ5YA","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/experience.svg":"6tNiD","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/upload.svg":"cnXFn","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/email.svg":"cOVps","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/star.svg":"cu9h8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eigPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProfileSection", ()=>ProfileSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _profileSectionScss = require("./ProfileSection.scss");
var _button = require("../../../../../components/Button/Button");
var _closeEditSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/close-edit.svg");
var _editSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/edit.svg");
const ProfileSection = ({ title, children, editContent, isEditing: externalIsEditing, isSaving = false, onEditToggle, onSave, onCancel, headerAction, isActionDisabled = false, className = '' })=>{
    const [internalIsEditing, setInternalIsEditing] = (0, _react.useState)(false);
    const isEditing = externalIsEditing !== undefined ? externalIsEditing : internalIsEditing;
    const handleEditClick = ()=>{
        const newState = true;
        setInternalIsEditing(newState);
        if (onEditToggle) onEditToggle(newState);
    };
    const handleCancelClick = ()=>{
        const newState = false;
        setInternalIsEditing(newState);
        if (onCancel) onCancel();
        if (onEditToggle) onEditToggle(newState);
    };
    const handleSaveClick = ()=>{
        if (onSave) onSave();
        else {
            const newState = false;
            setInternalIsEditing(newState);
            if (onEditToggle) onEditToggle(newState);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `profile-section ${isEditing ? 'editing' : ''}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `section-header ${className}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-actions",
                        children: [
                            isEditing && headerAction && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "custom-action",
                                children: headerAction
                            }),
                            !isEditing && editContent && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "edit-btn",
                                onClick: handleEditClick,
                                "aria-label": "Edit",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {})
                            }),
                            isEditing && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "edit-btn active",
                                "aria-label": "Edit",
                                onClick: handleCancelClick,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeEditSvg.ReactComponent), {})
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "section-content",
                children: isEditing && editContent ? editContent : children
            }),
            isEditing && editContent && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "section-footer",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "cancel-btn",
                        onClick: handleCancelClick,
                        disabled: isSaving,
                        children: 'Cancel'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        className: "save-btn",
                        onClick: handleSaveClick,
                        isLoading: isSaving,
                        disabled: isSaving || isActionDisabled,
                        children: 'Save Changes'
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ProfileSection.scss":"juxKe","../../../../../components/Button/Button":"jLE7r","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/close-edit.svg":"fwWUo","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/edit.svg":"fqBTM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"juxKe":[function() {},{}],"fwWUo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCloseEdit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCloseEdit = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 34,
        height: 34,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M0 8a8 8 0 0 1 8-8h18a8 8 0 0 1 8 8v18a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                d: "M22 12 12 22m0-10 10 10"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fqBTM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEdit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEdit = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 34,
        height: 34,
        fill: "none",
        viewBox: "0 0 34 34",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                fillOpacity: 0.05,
                d: "M0 8a8 8 0 0 1 8-8h18a8 8 0 0 1 8 8v18a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M23.88 13.11a2.114 2.114 0 0 0-2.989-2.991l-10.01 10.012a1.5 1.5 0 0 0-.374.622l-.991 3.264a.375.375 0 0 0 .467.467l3.265-.99c.235-.072.448-.2.622-.373z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4DLAC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "resizeImage", ()=>resizeImage);
const resizeImage = (file, maxWidth, maxHeight)=>{
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = (event)=>{
            const img = new Image();
            img.src = event.target?.result;
            img.onload = ()=>{
                let { width, height } = img;
                if (width > maxWidth || height > maxHeight) {
                    const ratio = Math.min(maxWidth / width, maxHeight / height);
                    width = width * ratio;
                    height = height * ratio;
                }
                const canvas = document.createElement('canvas');
                canvas.width = width;
                canvas.height = height;
                const ctx = canvas.getContext('2d');
                if (!ctx) {
                    reject(new Error('Failed to get canvas context'));
                    return;
                }
                ctx.drawImage(img, 0, 0, width, height);
                canvas.toBlob((blob)=>{
                    if (blob) resolve(new File([
                        blob
                    ], file.name, {
                        type: file.type
                    }));
                    else reject(new Error('Canvas to Blob failed'));
                }, file.type, 0.9);
            };
            img.onerror = (error)=>reject(error);
        };
        reader.onerror = (error)=>reject(error);
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cCllM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "deleteChatMedia", ()=>deleteChatMedia);
parcelHelpers.export(exports, "uploadTrainerFile", ()=>uploadTrainerFile);
parcelHelpers.export(exports, "uploadSupportScreenshot", ()=>uploadSupportScreenshot);
parcelHelpers.export(exports, "deleteSupportScreenshot", ()=>deleteSupportScreenshot);
parcelHelpers.export(exports, "uploadChatAudio", ()=>uploadChatAudio);
parcelHelpers.export(exports, "uploadChatImage", ()=>uploadChatImage);
parcelHelpers.export(exports, "uploadChatVideo", ()=>uploadChatVideo);
parcelHelpers.export(exports, "uploadChatFile", ()=>uploadChatFile);
var _storage = require("firebase/storage");
var _firebase = require("src/config/firebase");
const deleteChatMedia = async (urlOrPath)=>{
    try {
        if (!urlOrPath) return;
        const storageRef = (0, _storage.ref)((0, _firebase.storage), urlOrPath);
        await (0, _storage.deleteObject)(storageRef);
    } catch (error) {
        console.error('Error deleting chat media from storage:', error);
    }
};
const uploadTrainerFile = async (file, folder, userId)=>{
    const fileExtension = file.name.split('.').pop();
    const fileName = `${crypto.randomUUID()}.${fileExtension}`;
    // The user requested to use the "trainer_profile_images" bucket or folder.
    // We'll store it under trainer_profile_images/{folder}/{userId}/{fileName}
    // For certificates, store under trainer_profile_certificate/{userId}/{fileName}
    // For videos, store under trainer_profile_video/{userId}/{fileName}
    let filePath = '';
    if (folder === 'certificates') filePath = `trainer_profile_certificate/${userId}/${fileName}`;
    else if (folder === 'videos') filePath = `trainer_profile_video/${userId}/${fileName}`;
    else filePath = `trainer_profile_images/${folder}/${userId}/${fileName}`;
    const storageRef = (0, _storage.ref)((0, _firebase.storage), filePath);
    await (0, _storage.uploadBytes)(storageRef, file);
    return await (0, _storage.getDownloadURL)(storageRef);
};
const uploadSupportScreenshot = async (file, userId)=>{
    const fileExtension = file.name.split('.').pop();
    const timestamp = new Date().getTime();
    const fileName = `${timestamp}_${crypto.randomUUID()}.${fileExtension}`;
    const filePath = `trainer_support_reports/${userId}/${fileName}`;
    const storageRef = (0, _storage.ref)((0, _firebase.storage), filePath);
    await (0, _storage.uploadBytes)(storageRef, file);
    return await (0, _storage.getDownloadURL)(storageRef);
};
const deleteSupportScreenshot = async (urlOrPath)=>{
    try {
        if (!urlOrPath) return;
        const storageRef = (0, _storage.ref)((0, _firebase.storage), urlOrPath);
        await (0, _storage.deleteObject)(storageRef);
    } catch (error) {
        console.error('Error deleting support screenshot from storage:', error);
    }
};
const uploadChatAudio = async (blob, chatId, _userId)=>{
    const isMp3 = blob.type.includes('mp3') || blob.type.includes('mpeg');
    const isM4a = blob.type.includes('mp4') || blob.type.includes('m4a');
    const fileExtension = isMp3 ? 'mp3' : isM4a ? 'm4a' : 'webm';
    const timestamp = new Date().getTime();
    const fileName = `${timestamp}_${crypto.randomUUID()}.${fileExtension}`;
    const filePath = `chat_media/audio/${chatId}/${fileName}`;
    const storageRef = (0, _storage.ref)((0, _firebase.storage), filePath);
    await (0, _storage.uploadBytes)(storageRef, blob, {
        contentType: blob.type || (isMp3 ? 'audio/mp3' : isM4a ? 'audio/mp4' : 'audio/webm;codecs=opus')
    });
    return await (0, _storage.getDownloadURL)(storageRef);
};
const uploadChatImage = async (file, chatId, _userId)=>{
    const fileExtension = file.name.split('.').pop() || 'jpg';
    const timestamp = new Date().getTime();
    const fileName = `${timestamp}_${crypto.randomUUID()}.${fileExtension}`;
    const filePath = `chat_media/images/${chatId}/${fileName}`;
    const storageRef = (0, _storage.ref)((0, _firebase.storage), filePath);
    await (0, _storage.uploadBytes)(storageRef, file, {
        contentType: file.type || 'image/jpeg'
    });
    const url = await (0, _storage.getDownloadURL)(storageRef);
    return {
        url,
        filePath,
        fileName: file.name,
        sizeBytes: file.size
    };
};
const uploadChatVideo = async (file, chatId, _userId)=>{
    const fileExtension = file.name.split('.').pop() || 'mp4';
    const timestamp = new Date().getTime();
    const fileName = `${timestamp}_${crypto.randomUUID()}.${fileExtension}`;
    const filePath = `chat_media/videos/${chatId}/${fileName}`;
    const storageRef = (0, _storage.ref)((0, _firebase.storage), filePath);
    await (0, _storage.uploadBytes)(storageRef, file, {
        contentType: file.type || 'video/mp4'
    });
    const url = await (0, _storage.getDownloadURL)(storageRef);
    return {
        url,
        filePath,
        fileName: file.name,
        sizeBytes: file.size
    };
};
const uploadChatFile = async (file, chatId, _userId)=>{
    const timestamp = new Date().getTime();
    const sanitizedName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
    const storageFileName = `${timestamp}_${crypto.randomUUID()}_${sanitizedName}`;
    const filePath = `chat_media/files/${chatId}/${storageFileName}`;
    const storageRef = (0, _storage.ref)((0, _firebase.storage), filePath);
    await (0, _storage.uploadBytes)(storageRef, file, {
        contentType: file.type || 'application/octet-stream'
    });
    const downloadUrl = await (0, _storage.getDownloadURL)(storageRef);
    return {
        url: downloadUrl,
        filePath,
        fileName: file.name,
        sizeBytes: file.size,
        mimeType: file.type
    };
};

},{"firebase/storage":"9JHfQ","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7dgg4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FullScreenImageModal", ()=>FullScreenImageModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _mediaPreviewModalScss = require("../mediaPreviewModal.scss");
const FullScreenImageModal = ({ isOpen, onClose, imageUrl, altText = 'Full screen view' })=>{
    const [isLoading, setIsLoading] = (0, _react.useState)(true);
    const [loadedUrl, setLoadedUrl] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        if (isOpen && imageUrl !== loadedUrl) setIsLoading(true);
    }, [
        isOpen,
        imageUrl,
        loadedUrl
    ]);
    const antIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
        style: {
            fontSize: 48,
            color: '#ffa100'
        },
        spin: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        className: "media-preview-modal",
        rootClassName: "media-preview-modal-root",
        open: isOpen,
        onCancel: onClose,
        footer: null,
        centered: true,
        width: "auto",
        style: {
            maxWidth: '90vw',
            padding: 0
        },
        closable: true,
        closeIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            style: {
                color: '#fff',
                fontSize: '15px',
                backgroundColor: 'rgba(15, 23, 42, 0.9)',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
        }),
        styles: {
            mask: {
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(20, 22, 28, 0.72)'
            },
            body: {
                padding: 0,
                background: 'transparent',
                borderRadius: '10px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
            }
        },
        children: imageUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: {
                minHeight: isLoading ? '300px' : 'auto',
                minWidth: isLoading ? '300px' : 'auto',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                borderRadius: '16px',
                overflow: 'hidden',
                background: 'rgba(14, 16, 32, 0.82)',
                backdropFilter: 'blur(16px)',
                WebkitBackdropFilter: 'blur(16px)',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                boxShadow: '0 16px 48px rgba(0, 0, 0, 0.6)'
            },
            children: [
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 2
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                        indicator: antIcon
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: imageUrl,
                    alt: altText,
                    onLoad: ()=>{
                        setIsLoading(false);
                        setLoadedUrl(imageUrl);
                    },
                    style: {
                        maxWidth: '100%',
                        maxHeight: '80vh',
                        objectFit: 'contain',
                        display: isLoading ? 'none' : 'block',
                        margin: '0 auto',
                        borderRadius: '16px'
                    }
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["CloseOutlined","dinn5","default"],["LoadingOutlined","8Mvdh","default"]],"../mediaPreviewModal.scss":"b16LQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b16LQ":[function() {},{}],"iw7ag":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProfileEditContext", ()=>ProfileEditContext);
parcelHelpers.export(exports, "ProfileEditProvider", ()=>ProfileEditProvider);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
const ProfileEditContext = /*#__PURE__*/ (0, _react.createContext)({
    globalEditAction: {
        type: 'IDLE',
        count: 0
    },
    toggleAllEdits: ()=>{},
    registerEditState: ()=>{},
    isAnyEditing: false,
    isBulkEditing: false
});
const ProfileEditProvider = ({ children })=>{
    const [globalEditAction, setGlobalEditAction] = (0, _react.useState)({
        type: 'IDLE',
        count: 0
    });
    const [editingSections, setEditingSections] = (0, _react.useState)(new Set());
    const registerEditState = (0, _react.useCallback)((sectionId, isEditing)=>{
        setEditingSections((prev)=>{
            const next = new Set(prev);
            if (isEditing) next.add(sectionId);
            else next.delete(sectionId);
            return next;
        });
    }, []);
    const isAnyEditing = editingSections.size > 0;
    const isBulkEditing = isAnyEditing;
    const toggleAllEdits = ()=>{
        const willOpen = !isAnyEditing;
        setGlobalEditAction((prev)=>({
                type: willOpen ? 'OPEN' : 'CLOSE',
                count: prev.count + 1
            }));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProfileEditContext.Provider, {
        value: {
            globalEditAction,
            toggleAllEdits,
            registerEditState,
            isAnyEditing,
            isBulkEditing
        },
        children: children
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jDkE0":[function() {},{}],"hrPb3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSelectedService);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSelectedService = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.667,
            d: "M7.497 4.167H5.831a1.667 1.667 0 0 0-1.667 1.666v10A1.666 1.666 0 0 0 5.831 17.5h8.333a1.667 1.667 0 0 0 1.667-1.667v-10a1.667 1.667 0 0 0-1.667-1.666h-1.667m-5 0a1.667 1.667 0 0 0 1.667 1.666h1.667a1.666 1.666 0 0 0 1.666-1.666m-5 0A1.667 1.667 0 0 1 9.164 2.5h1.667a1.666 1.666 0 0 1 1.666 1.667m-5 7.5 1.667 1.666L12.497 10"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9iaYU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgExperienceLevel);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgExperienceLevel = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.667,
            d: "M15.83 17.5v-1.667a3.333 3.333 0 0 0-3.333-3.333h-5a3.333 3.333 0 0 0-3.333 3.333V17.5m5.833-8.333a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"sZ5YA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgProfileRemove);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgProfileRemove = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 30 30",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2.4,
            d: "m23.625 8.497-.975 15.785A2.78 2.78 0 0 1 21.939 26c-.417.448-.965.697-1.534.697h-9.31c-.57 0-1.117-.25-1.534-.697a2.78 2.78 0 0 1-.71-1.718L7.874 8.497m5.625 5.2v7.8m4.5-7.8v7.8m1.125-13v-3.9a1.4 1.4 0 0 0-.33-.92 1.05 1.05 0 0 0-.795-.38h-4.5c-.298 0-.585.137-.796.38a1.4 1.4 0 0 0-.329.92v3.9m-5.625 0h18"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6tNiD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgExperience);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgExperience = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.333,
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M10.67 13.336V2.669a1.333 1.333 0 0 0-1.334-1.333H6.669a1.333 1.333 0 0 0-1.333 1.333v10.667"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M13.336 4H2.669c-.736 0-1.333.597-1.333 1.333V12c0 .736.597 1.333 1.333 1.333h10.667c.736 0 1.333-.597 1.333-1.333V5.333c0-.736-.597-1.333-1.333-1.333"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h16v16H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cnXFn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgUpload);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUpload = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M15.75 11.25v3a1.5 1.5 0 0 1-1.5 1.5H3.75a1.5 1.5 0 0 1-1.5-1.5v-3M12.75 6 9 2.25 5.25 6M9 2.25v9"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cOVps":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEmail);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEmail = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.333,
                d: "M13.336 2.664H2.669c-.736 0-1.333.597-1.333 1.333v8c0 .737.597 1.334 1.333 1.334h10.667c.736 0 1.333-.597 1.333-1.334v-8c0-.736-.597-1.333-1.333-1.333"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.333,
                d: "m14.67 4.664-5.98 3.8a1.29 1.29 0 0 1-1.374 0l-5.98-3.8"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cu9h8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgStar);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgStar = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            stroke: "#FFA100",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M8.645 1.721a.398.398 0 0 1 .713 0l1.732 3.51a1.59 1.59 0 0 0 1.196.87l3.875.566a.398.398 0 0 1 .22.678l-2.802 2.729a1.59 1.59 0 0 0-.458 1.408l.662 3.855a.397.397 0 0 1-.579.42l-3.463-1.82a1.59 1.59 0 0 0-1.48 0l-3.463 1.82a.397.397 0 0 1-.577-.42l.66-3.854a1.59 1.59 0 0 0-.458-1.41L1.621 7.347a.398.398 0 0 1 .22-.68L5.717 6.1a1.59 1.59 0 0 0 1.197-.87z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kqhTx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntroductionVideoSection", ()=>IntroductionVideoSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _profileSection = require("./ProfileSection");
var _sessionStore = require("src/store/sessionStore");
var _useUpdateTrainerProfile = require("src/api/mutations/useUpdateTrainerProfile");
var _firebaseStorage = require("src/api/services/firebaseStorage");
var _antd = require("antd");
var _fullScreenVideoModal = require("src/components/Modals/FullScreenVideoModal/FullScreenVideoModal");
var _appAlert = require("src/utils/appAlert");
var _profileEditContext = require("../ProfileEditContext");
var _introductionVideoSectionScss = require("./IntroductionVideoSection.scss");
var _profileRemove2Svg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove2.svg");
var _profileRemoveSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove.svg");
var _uploadSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/upload.svg");
var _uploadFailedSvg = require("../../../../../../../assets/images/onboarding-trainer/profile/upload-failed.svg");
var _fileSvg = require("../../../../../../../assets/images/onboarding-trainer/profile/file.svg");
var _sizeSvg = require("../../../../../../../assets/images/onboarding-trainer/profile/size.svg");
var _timeSvg = require("../../../../../../../assets/images/onboarding-trainer/profile/time.svg");
var _playButtonSvg = require("../../../../../../../assets/images/onboarding-trainer/profile/play-button.svg");
var _deleteSvg = require("../../../../../../../assets/images/onboarding-trainer/profile/delete.svg");
var _replaceSvg = require("../../../../../../../assets/images/onboarding-trainer/profile/replace.svg");
const formatSize = (bytes)=>{
    if (!bytes) return '';
    const mb = bytes / 1048576;
    return `${mb.toFixed(1)} MB`;
};
const formatDuration = (seconds)=>{
    if (!seconds) return '';
    const m = Math.floor(seconds / 60);
    const s = Math.floor(seconds % 60);
    return `${m}:${s < 10 ? '0' : ''}${s}`;
};
const formatFileName = (name, maxLength = 14)=>{
    if (!name) return '';
    if (name.length <= maxLength) return name;
    const extIndex = name.lastIndexOf('.');
    if (extIndex === -1) return name.substring(0, maxLength - 3) + '...';
    const ext = name.substring(extIndex);
    const baseName = name.substring(0, extIndex);
    const charsToKeep = maxLength - ext.length - 3;
    if (charsToKeep <= 0) return name.substring(0, Math.max(3, maxLength - 3)) + '...';
    const front = Math.ceil(charsToKeep / 2);
    const back = Math.floor(charsToKeep / 2);
    return `${baseName.substring(0, front)}...${baseName.substring(baseName.length - back)}${ext}`;
};
const IntroductionVideoSection = ()=>{
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [isUploading, setIsUploading] = (0, _react.useState)(false);
    const [uploadProgress, setUploadProgress] = (0, _react.useState)(0); // Mock progress for UI
    const { mutateAsync: updateProfileBackend, isPending } = (0, _useUpdateTrainerProfile.useUpdateTrainerProfile)();
    const { globalEditAction, registerEditState } = (0, _react.useContext)((0, _profileEditContext.ProfileEditContext));
    (0, _react.useEffect)(()=>{
        if (globalEditAction.count > 0) {
            if (globalEditAction.type === 'OPEN') setIsEditing(true);
            else if (globalEditAction.type === 'CLOSE') setIsEditing(false);
        }
    }, [
        globalEditAction
    ]);
    (0, _react.useEffect)(()=>{
        registerEditState('introductionVideo', isEditing);
    }, [
        isEditing,
        registerEditState
    ]);
    const [video, setVideo] = (0, _react.useState)({
        url: currentUser?.introductionVideoUrl,
        name: currentUser?.introductionVideoName,
        size: currentUser?.introductionVideoSize,
        duration: currentUser?.introductionVideoDuration
    });
    const [previewState, setPreviewState] = (0, _react.useState)(null);
    const [videoToRemove, setVideoToRemove] = (0, _react.useState)(false);
    const fileInputRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (currentUser && !isEditing) setVideo({
            url: currentUser.introductionVideoUrl,
            name: currentUser.introductionVideoName,
            size: currentUser.introductionVideoSize,
            duration: currentUser.introductionVideoDuration
        });
    }, [
        currentUser,
        isEditing
    ]);
    const handleSave = async ()=>{
        if (!currentUser) return;
        if (!video.url && !currentUser.introductionVideoUrl) return;
        if (video.error) {
            (0, _appAlert.toast).error('Please resolve validation errors before saving.');
            return;
        }
        try {
            const uid = currentUser?.uid || '';
            await updateProfileBackend({
                uid,
                data: {
                    introductionVideoUrl: video.url || '',
                    introductionVideoName: video.name || '',
                    introductionVideoSize: video.size || null,
                    introductionVideoDuration: video.duration || null
                },
                oldVideoUrl: currentUser.introductionVideoUrl !== video.url ? currentUser.introductionVideoUrl : undefined
            });
            setIsEditing(false);
        } catch (error) {
            console.error(error);
            (0, _appAlert.toast).error('Failed to save profile');
        }
    };
    const handleRemoveVideo = (e)=>{
        if (e) e.stopPropagation();
        setVideoToRemove(true);
    };
    const confirmRemoveVideo = ()=>{
        setVideo({
            url: undefined,
            name: undefined,
            size: undefined,
            duration: undefined,
            error: undefined
        });
        setVideoToRemove(false);
    };
    const triggerReplace = (e)=>{
        e.stopPropagation();
        if (fileInputRef.current) fileInputRef.current.click();
    };
    const handleFileUpload = async (e)=>{
        const file = e.target.files?.[0];
        if (!file || !currentUser) return;
        const allowedTypes = [
            'video/mp4',
            'video/quicktime',
            'video/webm'
        ];
        if (!allowedTypes.includes(file.type)) {
            setVideo({
                ...video,
                error: 'Upload failed. Unsupported file format.'
            });
            return;
        }
        if (file.size > 104857600) {
            setVideo({
                ...video,
                error: 'Upload failed. File exceeds the 100 MB limit.'
            });
            return;
        }
        // Create a video element to check duration
        const videoElement = document.createElement('video');
        videoElement.preload = 'metadata';
        videoElement.onloadedmetadata = async ()=>{
            window.URL.revokeObjectURL(videoElement.src);
            if (videoElement.duration > 180) {
                // 3 minutes
                setVideo({
                    ...video,
                    error: 'Upload failed. Video exceeds 3 minutes limit.'
                });
                return;
            }
            // Proceed to upload
            setVideo({
                ...video,
                name: file.name,
                error: undefined
            });
            try {
                setIsUploading(true);
                setUploadProgress(0);
                // Mock progress updates for UI while actual upload happens
                const progressInterval = setInterval(()=>{
                    setUploadProgress((prev)=>{
                        if (prev >= 95) {
                            clearInterval(progressInterval);
                            return 95;
                        }
                        return prev + 5;
                    });
                }, 100);
                const uid = currentUser?.uid || '';
                const downloadUrl = await (0, _firebaseStorage.uploadTrainerFile)(file, 'videos', uid);
                clearInterval(progressInterval);
                setUploadProgress(100);
                setVideo({
                    url: downloadUrl,
                    name: file.name,
                    size: file.size,
                    duration: videoElement.duration,
                    error: undefined
                });
            } catch  {
                (0, _appAlert.toast).error('Failed to process file');
                setVideo({
                    ...video,
                    error: 'Upload failed. Please try again.'
                });
            } finally{
                setIsUploading(false);
            }
        };
        videoElement.onerror = ()=>{
            setVideo({
                ...video,
                error: 'Upload failed. Invalid video file.'
            });
        };
        videoElement.src = window.URL.createObjectURL(file);
    };
    const viewContent = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "introduction-video-view",
        children: currentUser?.introductionVideoUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "uploaded-video-preview",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "preview-box",
                children: [
                    currentUser.introductionVideoUrl && /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                        src: currentUser.introductionVideoUrl,
                        className: "thumbnail-video",
                        preload: "metadata"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "play-btn",
                        onClick: ()=>setPreviewState(currentUser.introductionVideoUrl),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _playButtonSvg.ReactComponent), {})
                    })
                ]
            })
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "text-section-view",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "icon-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                        width: "24",
                        height: "24",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                x: "2",
                                y: "4",
                                width: "20",
                                height: "16",
                                rx: "2",
                                stroke: "white",
                                strokeWidth: "2"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M10 8L16 12L10 16V8Z",
                                fill: "white"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "No video added yet."
                })
            ]
        })
    });
    const renderUploadArea = ()=>{
        if (isUploading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "uploaded-video-preview",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "preview-box",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "play-btn",
                        disabled: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _playButtonSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "video-info-overlay",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "name",
                            children: formatFileName(video.name || 'Uploading...')
                        })
                    })
                ]
            })
        });
        if (video.name && !video.error) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "uploaded-video-preview",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "preview-box",
                children: [
                    video.url && /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                        src: video.url,
                        className: "thumbnail-video",
                        preload: "metadata"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "play-btn",
                        onClick: ()=>video.url && setPreviewState(video.url),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _playButtonSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "video-info-overlay",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "name",
                                children: formatFileName(video.name)
                            }),
                            video.size && video.duration && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "meta",
                                children: [
                                    formatSize(video.size),
                                    " \u2022 ",
                                    formatDuration(video.duration)
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "file",
                        ref: fileInputRef,
                        accept: "video/mp4,video/quicktime,video/webm",
                        onChange: handleFileUpload,
                        style: {
                            display: 'none'
                        }
                    })
                ]
            })
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: `upload-area ${video.error ? 'error-border' : ''}`,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadSvg.ReactComponent), {}),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: "Upload video"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                    type: "file",
                    accept: "video/mp4,video/quicktime,video/webm",
                    onChange: handleFileUpload
                })
            ]
        });
    };
    const editContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "introduction-video-edit",
        children: [
            renderUploadArea(),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "upload-info-container",
                children: [
                    isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "uploading-progress-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "uploading-text",
                                children: [
                                    "Uploading... ",
                                    uploadProgress,
                                    "%"
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-bar-bg",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "progress-bar-fill",
                                    style: {
                                        width: `${uploadProgress}%`
                                    }
                                })
                            })
                        ]
                    }),
                    video.name && !video.error && !isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "actions-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: handleRemoveVideo,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deleteSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: triggerReplace,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _replaceSvg.ReactComponent), {})
                            })
                        ]
                    }),
                    video.error && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "error-message",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadFailedSvg.ReactComponent), {}),
                            " ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: video.error
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "upload-rules",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rule-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fileSvg.ReactComponent), {}),
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "MP4, MOV, or WebM"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rule-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sizeSvg.ReactComponent), {}),
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Max 100 MB"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "rule-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeSvg.ReactComponent), {}),
                                    " ",
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Up to 3 minutes"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
    const isInitialEmpty = !currentUser?.introductionVideoUrl;
    const isActionDisabled = isUploading || !!video.error || !video.url && isInitialEmpty;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileSection.ProfileSection), {
                className: "align-items-center introduction-video-header",
                title: "Introduction Video",
                isEditing: isEditing,
                isSaving: isPending,
                isActionDisabled: isActionDisabled,
                onEditToggle: setIsEditing,
                onSave: handleSave,
                onCancel: ()=>{
                    if (currentUser) setVideo({
                        url: currentUser.introductionVideoUrl,
                        name: currentUser.introductionVideoName,
                        size: currentUser.introductionVideoSize,
                        duration: currentUser.introductionVideoDuration
                    });
                },
                editContent: editContent,
                children: viewContent
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullScreenVideoModal.FullScreenVideoModal), {
                isOpen: Boolean(previewState),
                onClose: ()=>setPreviewState(null),
                videoUrl: previewState || ''
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: videoToRemove,
                footer: null,
                onCancel: ()=>setVideoToRemove(false),
                centered: true,
                width: 400,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileRemove2Svg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Delete Video?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: "Are you sure you want to delete your introduction video?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "btn-logout",
                                    onClick: confirmRemoveVideo,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileRemoveSvg.ReactComponent), {}),
                                        " Delete"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setVideoToRemove(false),
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ProfileSection":"eigPk","src/store/sessionStore":"kPSO3","src/api/mutations/useUpdateTrainerProfile":"4z0zZ","src/api/services/firebaseStorage":"cCllM","antd":[["Modal","kY4DD","default"]],"src/components/Modals/FullScreenVideoModal/FullScreenVideoModal":"gcrID","src/utils/appAlert":"de4Mq","../ProfileEditContext":"iw7ag","./IntroductionVideoSection.scss":"aU6EK","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove2.svg":"lzWT7","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove.svg":"sZ5YA","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/upload.svg":"cnXFn","../../../../../../../assets/images/onboarding-trainer/profile/upload-failed.svg":"douiX","../../../../../../../assets/images/onboarding-trainer/profile/file.svg":"1VwO4","../../../../../../../assets/images/onboarding-trainer/profile/size.svg":"8g1Tw","../../../../../../../assets/images/onboarding-trainer/profile/time.svg":"ajNbU","../../../../../../../assets/images/onboarding-trainer/profile/play-button.svg":"413oN","../../../../../../../assets/images/onboarding-trainer/profile/delete.svg":"2lYkA","../../../../../../../assets/images/onboarding-trainer/profile/replace.svg":"dw2SU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gcrID":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FullScreenVideoModal", ()=>FullScreenVideoModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _mediaPreviewModalScss = require("../mediaPreviewModal.scss");
const FullScreenVideoModal = ({ isOpen, onClose, videoUrl })=>{
    const [isLoading, setIsLoading] = (0, _react.useState)(true);
    const [loadedUrl, setLoadedUrl] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        if (isOpen && videoUrl !== loadedUrl) setIsLoading(true);
    }, [
        isOpen,
        videoUrl,
        loadedUrl
    ]);
    const antIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
        style: {
            fontSize: 48,
            color: '#ffa100'
        },
        spin: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        className: "media-preview-modal",
        rootClassName: "media-preview-modal-root",
        open: isOpen,
        onCancel: onClose,
        footer: null,
        centered: true,
        width: 760,
        style: {
            maxWidth: '90vw',
            padding: 0
        },
        destroyOnHidden: true,
        closable: true,
        closeIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            style: {
                color: '#fff',
                fontSize: '15px',
                backgroundColor: 'rgba(15, 23, 42, 0.9)',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
        }),
        styles: {
            mask: {
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(20, 22, 28, 0.72)'
            },
            body: {
                padding: 0,
                background: '#000',
                borderRadius: '10px',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '300px'
            }
        },
        children: videoUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: {
                width: '100%',
                minHeight: isLoading ? '300px' : 'auto',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                borderRadius: '10px',
                overflow: 'hidden',
                background: '#000'
            },
            children: [
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 2,
                        background: '#1a1f2e'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                        indicator: antIcon
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                    src: videoUrl,
                    controls: true,
                    autoPlay: true,
                    playsInline: true,
                    onLoadedData: ()=>{
                        setIsLoading(false);
                        setLoadedUrl(videoUrl);
                    },
                    onCanPlay: ()=>{
                        setIsLoading(false);
                        setLoadedUrl(videoUrl);
                    },
                    style: {
                        width: '100%',
                        maxHeight: '75vh',
                        display: 'block',
                        objectFit: 'contain',
                        borderRadius: '10px',
                        opacity: isLoading ? 0 : 1,
                        transition: 'opacity 0.2s ease'
                    }
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["CloseOutlined","dinn5","default"],["LoadingOutlined","8Mvdh","default"]],"../mediaPreviewModal.scss":"b16LQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b16LQ":[function() {},{}],"aU6EK":[function() {},{}],"douiX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgUploadFailed);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUploadFailed = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 19,
                height: 19,
                x: 0.5,
                y: 0.5,
                stroke: "#F16A6A",
                rx: 9.5
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#F16A6A",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                d: "m13 7-6 6M7 7l6 6"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1VwO4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFile = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            fillOpacity: 0.7,
            d: "M11.667 9.167a2.5 2.5 0 0 1-2.5-2.5V3.333H5.834A1.667 1.667 0 0 0 4.167 5v10.833A1.666 1.666 0 0 0 5.834 17.5h7.5A1.667 1.667 0 0 0 15 15.833V9.167zM10 6.667a1.667 1.667 0 0 0 1.667 1.666h2.992L10 3.675zM5.834 2.5H10l5.834 5.833v7.5a2.5 2.5 0 0 1-2.5 2.5h-7.5a2.5 2.5 0 0 1-2.5-2.5V5a2.5 2.5 0 0 1 2.5-2.5"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8g1Tw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSize);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSize = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#B5B5BC",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            d: "M17.002 5.5c0 .33-.182.654-.534.958-.351.303-.867.579-1.517.811s-1.422.416-2.272.542-1.76.19-2.68.19c-1.857 0-3.637-.263-4.95-.732S2.997 6.164 2.997 5.501c0-.329.18-.654.533-.957.351-.304.867-.58 1.517-.812S6.47 3.316 7.32 3.19C8.17 3.065 9.08 3 10 3c.919 0 1.83.065 2.68.19.849.126 1.62.31 2.27.542s1.167.508 1.518.812c.352.303.534.628.534.957M17.002 14.5c0 .439-.324.87-.939 1.25-.614.38-1.498.696-2.562.916-1.065.22-2.272.335-3.501.335s-2.437-.116-3.501-.335-1.949-.535-2.563-.916c-.615-.38-.938-.811-.938-1.25M17.002 11.5c0 .439-.324.87-.939 1.25-.614.38-1.498.696-2.562.916-1.065.22-2.272.335-3.501.335s-2.437-.116-3.501-.335-1.949-.536-2.563-.916-.938-.811-.938-1.25M17.002 8.5c0 .439-.324.87-.939 1.25-.614.38-1.498.696-2.562.916-1.065.22-2.272.335-3.501.335s-2.437-.116-3.501-.335-1.949-.536-2.563-.916-.938-.811-.938-1.25M2.998 5.496V14.5M17.002 5.496V14.5"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ajNbU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgTime);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTime = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeOpacity: 0.7,
                strokeWidth: 1.1,
                d: "M10 17a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeOpacity: 0.7,
                strokeWidth: 1.1,
                d: "M9.222 6.89v3.89h3.889"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"413oN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPlayButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPlayButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 51 51",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M33.51 22.134a3.4 3.4 0 0 1 1.32 1.26 3.44 3.44 0 0 1 0 3.53 3.4 3.4 0 0 1-1.32 1.26l-14.557 7.962c-2.344 1.283-5.223-.385-5.223-3.024V17.197c0-2.64 2.88-4.307 5.223-3.026z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2lYkA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDelete);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDelete = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.6,
            d: "m19.042 6.99-.831 12.168c-.035.505-.251.979-.606 1.324a1.87 1.87 0 0 1-1.306.538H8.368c-.485 0-.952-.192-1.307-.538a2.04 2.04 0 0 1-.605-1.324L5.625 6.989m4.791 4.009v6.013m3.834-6.013v6.013m.958-10.022V3.983c0-.266-.1-.521-.28-.709a.94.94 0 0 0-.678-.294h-3.834a.94.94 0 0 0-.677.294c-.18.188-.28.443-.28.709v3.006m-4.792 0H20"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dw2SU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReplace);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReplace = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m13 16-3 3 3 3m-3-3h5a7 7 0 0 0 3-13.326M6 18.326A7 7 0 0 1 9 5h5m-3 3 3-3-3-3"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b4Wqk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CareerHighlightsSection", ()=>CareerHighlightsSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _profileSection = require("./ProfileSection");
var _sessionStore = require("src/store/sessionStore");
var _useUpdateTrainerProfile = require("src/api/mutations/useUpdateTrainerProfile");
var _firebaseStorage = require("src/api/services/firebaseStorage");
var _antd = require("antd");
var _fullScreenDocumentModal = require("src/components/Modals/FullScreenDocumentModal/FullScreenDocumentModal");
var _appAlert = require("src/utils/appAlert");
var _profileEditContext = require("../ProfileEditContext");
var _careerHighlightsSectionScss = require("./CareerHighlightsSection.scss");
var _profileRemove2Svg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove2.svg");
var _profileRemoveSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove.svg");
var _certificateSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/certificate.svg");
var _uploadSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/upload.svg");
var _closeSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/close.svg");
const CareerHighlightsSection = ()=>{
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [uploadingIndex, setUploadingIndex] = (0, _react.useState)(null);
    const [hasSubmitted, setHasSubmitted] = (0, _react.useState)(false);
    const { mutateAsync: updateProfileBackend, isPending } = (0, _useUpdateTrainerProfile.useUpdateTrainerProfile)();
    const { globalEditAction, registerEditState } = (0, _react.useContext)((0, _profileEditContext.ProfileEditContext));
    (0, _react.useEffect)(()=>{
        if (globalEditAction.count > 0) {
            if (globalEditAction.type === 'OPEN') {
                setIsEditing(true);
                setHasSubmitted(false);
            } else if (globalEditAction.type === 'CLOSE') setIsEditing(false);
        }
    }, [
        globalEditAction
    ]);
    (0, _react.useEffect)(()=>{
        registerEditState('careerHighlights', isEditing);
    }, [
        isEditing,
        registerEditState
    ]);
    const [certificates, setCertificates] = (0, _react.useState)(currentUser?.certificates?.length ? currentUser.certificates : [
        {
            name: ''
        }
    ]);
    const [previewState, setPreviewState] = (0, _react.useState)(null);
    const [certToRemove, setCertToRemove] = (0, _react.useState)(null);
    (0, _react.useEffect)(()=>{
        if (currentUser && !isEditing) setCertificates(currentUser.certificates?.length ? currentUser.certificates : [
            {
                name: ''
            }
        ]);
    }, [
        currentUser,
        isEditing
    ]);
    const handleSave = async ()=>{
        if (!currentUser) return;
        if (certificates.length === 0 && (!currentUser?.certificates || currentUser.certificates.length === 0)) return;
        setHasSubmitted(true);
        const hasErrors = certificates.some((c)=>c.name.trim() === '' || !c.fileUrl);
        const hasUploadErrors = certificates.some((c)=>c.error);
        if (hasErrors || hasUploadErrors) {
            (0, _appAlert.toast).error('Please resolve certificate validation errors or remove invalid entries before saving.');
            return;
        }
        const validCerts = certificates.filter((c)=>c.name.trim() !== '' && c.fileUrl);
        // Check lengths
        const invalidName = validCerts.find((c)=>c.name.length > 100);
        if (invalidName) {
            (0, _appAlert.toast).error('Certificate name must be less than 100 characters');
            return;
        }
        try {
            const uid = currentUser?.uid || '';
            await updateProfileBackend({
                uid,
                data: {
                    certificates: validCerts
                }
            });
            setIsEditing(false);
        } catch (error) {
            console.error(error);
        }
    };
    const handleAddCert = ()=>{
        setCertificates([
            ...certificates,
            {
                name: ''
            }
        ]);
        setHasSubmitted(false);
    };
    const handleRemoveCert = (index)=>{
        const cert = certificates[index];
        if (!cert.name.trim() && !cert.fileUrl && !cert.fileName) setCertificates(certificates.filter((_, i)=>i !== index));
        else setCertToRemove(index);
    };
    const confirmRemoveCert = ()=>{
        if (certToRemove !== null) {
            setCertificates(certificates.filter((_, i)=>i !== certToRemove));
            setCertToRemove(null);
        }
    };
    const handleUpdateCertName = (index, name)=>{
        setCertificates(certificates.map((c, i)=>i === index ? {
                ...c,
                name
            } : c));
    };
    const handleFileUpload = async (index, e)=>{
        const file = e.target.files?.[0];
        if (!file || !currentUser) return;
        const allowedTypes = [
            'application/pdf',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'image/png',
            'image/jpeg',
            'image/jpg',
            'image/gif',
            'image/webp'
        ];
        if (!allowedTypes.includes(file.type)) {
            setCertificates(certificates.map((c, i)=>{
                if (i === index) {
                    const fileNameWithoutExt = file.name.replace(/\.[^/.]+$/, '');
                    return {
                        ...c,
                        fileName: file.name,
                        name: c.name.trim() === '' ? fileNameWithoutExt : c.name,
                        error: 'Unsupported file format'
                    };
                }
                return c;
            }));
            return;
        }
        if (file.size > 2097152) {
            setCertificates(certificates.map((c, i)=>{
                if (i === index) {
                    const fileNameWithoutExt = file.name.replace(/\.[^/.]+$/, '');
                    return {
                        ...c,
                        fileName: file.name,
                        name: c.name.trim() === '' ? fileNameWithoutExt : c.name,
                        error: 'File size exceeds 2MB limit'
                    };
                }
                return c;
            }));
            return;
        }
        // Clear any previous error before starting upload
        setCertificates(certificates.map((c, i)=>i === index ? {
                ...c,
                error: undefined
            } : c));
        try {
            setUploadingIndex(index);
            const uid = currentUser?.uid || '';
            const downloadUrl = await (0, _firebaseStorage.uploadTrainerFile)(file, 'certificates', uid);
            setCertificates(certificates.map((c, i)=>{
                if (i === index) {
                    const fileNameWithoutExt = file.name.replace(/\.[^/.]+$/, '');
                    return {
                        ...c,
                        fileUrl: downloadUrl,
                        fileName: file.name,
                        name: c.name.trim() === '' ? fileNameWithoutExt : c.name,
                        error: undefined
                    };
                }
                return c;
            }));
        } catch  {
            (0, _appAlert.toast).error('Failed to process file');
            setCertificates(certificates.map((c, i)=>{
                if (i === index) return {
                    ...c,
                    error: 'Upload failed'
                };
                return c;
            }));
        } finally{
            setUploadingIndex(null);
        }
    };
    const isAddDisabled = uploadingIndex !== null || certificates.length >= 5;
    const hasUploadError = certificates.some((c)=>c.error);
    const handleView = (cert)=>{
        if (!cert.fileUrl) return;
        // Detect if the stored URL is an image or pdf based on extension from firebase storage or token
        const isPdf = cert.fileUrl.toLowerCase().includes('.pdf');
        const isImage = cert.fileUrl.match(/\.(jpeg|jpg|gif|png)/i) != null || !isPdf && cert.fileUrl.includes('firebasestorage');
        if (isPdf || isImage) setPreviewState({
            url: cert.fileUrl,
            type: isPdf ? 'pdf' : 'image'
        });
        else window.open(cert.fileUrl, '_blank');
    };
    const viewContent = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "career-highlights-view",
        children: currentUser?.certificates && currentUser.certificates.length > 0 ? currentUser.certificates.map((cert, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "certificate-item",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "cert-info",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _certificateSvg.ReactComponent), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: cert.name
                            })
                        ]
                    }),
                    cert.fileUrl && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "view-btn",
                        onClick: ()=>handleView(cert),
                        children: 'View'
                    })
                ]
            }, index)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "text-section-view",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "icon-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _certificateSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: 'No certificates added yet.'
                    })
                ]
            })
        })
    });
    const editContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "career-highlights-edit",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "edit-description-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "description",
                        children: "Upload your certifications and achievements"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "add-action-btn",
                        onClick: handleAddCert,
                        disabled: isAddDisabled,
                        children: '+ Add Certificate'
                    })
                ]
            }),
            certificates.map((cert, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "cert-input-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                width: '100%'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group cert-name-group",
                                    style: {
                                        marginBottom: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            placeholder: "Certificate name",
                                            value: cert.name,
                                            maxLength: 100,
                                            onChange: (e)=>handleUpdateCertName(index, e.target.value),
                                            onBlur: (e)=>handleUpdateCertName(index, e.target.value.trim()),
                                            className: hasSubmitted && cert.name.trim() === '' ? 'error-border' : ''
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "remove-cert-btn",
                                            onClick: ()=>handleRemoveCert(index),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeSvg.ReactComponent), {})
                                        })
                                    ]
                                }),
                                hasSubmitted && cert.name.trim() === '' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                    className: "error-message",
                                    style: {
                                        color: '#E44E4E',
                                        marginTop: '4px',
                                        display: 'block',
                                        fontSize: '12px'
                                    },
                                    children: "Certificate name is required"
                                })
                            ]
                        }),
                        cert.fileUrl || cert.error ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '4px'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: `uploaded-file ${cert.error ? 'error-border' : ''}`,
                                    onClick: ()=>!cert.error && handleView(cert),
                                    style: {
                                        cursor: cert.error ? 'default' : 'pointer',
                                        color: cert.error ? '#E44E4E' : 'inherit'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _certificateSvg.ReactComponent), {}),
                                        " ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: cert.fileName || 'Uploaded Document'
                                        })
                                    ]
                                }),
                                cert.error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                    style: {
                                        color: '#E44E4E'
                                    },
                                    children: cert.error
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: `upload-cert-btn ${hasSubmitted && !cert.fileUrl ? 'error-border' : ''}`,
                                    style: {
                                        position: 'relative',
                                        overflow: 'hidden',
                                        opacity: uploadingIndex === index ? 0.5 : 1
                                    },
                                    children: [
                                        uploadingIndex === index ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            className: "loading-spinner",
                                            width: "16",
                                            height: "16",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M21 12a9 9 0 1 1-6.219-8.56"
                                            })
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _uploadSvg.ReactComponent), {}),
                                                " Upload certificate"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "file",
                                            accept: ".pdf,.doc,.docx,image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                            onChange: (e)=>handleFileUpload(index, e),
                                            disabled: uploadingIndex !== null,
                                            style: {
                                                position: 'absolute',
                                                top: 0,
                                                left: 0,
                                                width: '100%',
                                                height: '100%',
                                                opacity: 0,
                                                cursor: uploadingIndex !== null ? 'not-allowed' : 'pointer'
                                            }
                                        })
                                    ]
                                }),
                                hasSubmitted && !cert.fileUrl && /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                    className: "error-message",
                                    style: {
                                        color: '#E44E4E',
                                        marginTop: '4px',
                                        display: 'block',
                                        fontSize: '12px'
                                    },
                                    children: "Certificate file is required"
                                })
                            ]
                        })
                    ]
                }, index))
        ]
    });
    const isInitialEmpty = !currentUser?.certificates || currentUser.certificates.length === 0;
    const isActionDisabled = uploadingIndex !== null || hasUploadError || certificates.some((c)=>c.name.trim() === '' || !c.fileUrl) || certificates.length === 0 && isInitialEmpty;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileSection.ProfileSection), {
                className: "align-items-center career-highlights-centificate-header",
                title: "Career Highlights & Certificates",
                isEditing: isEditing,
                isSaving: isPending,
                isActionDisabled: isActionDisabled,
                onEditToggle: setIsEditing,
                onSave: handleSave,
                onCancel: ()=>{
                    if (currentUser) setCertificates(currentUser.certificates?.length ? currentUser.certificates : [
                        {
                            name: ''
                        }
                    ]);
                },
                editContent: editContent,
                children: viewContent
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullScreenDocumentModal.FullScreenDocumentModal), {
                isOpen: Boolean(previewState),
                onClose: ()=>setPreviewState(null),
                documentUrl: previewState?.url || '',
                type: previewState?.type,
                title: "Certificate Preview"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: certToRemove !== null,
                footer: null,
                onCancel: ()=>setCertToRemove(null),
                centered: true,
                width: 400,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileRemove2Svg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Delete Certification?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                "Are you sure you want to delete your",
                                ' ',
                                certToRemove !== null && certificates[certToRemove]?.name ? certificates[certToRemove].name : 'certification',
                                "?"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "btn-logout",
                                    onClick: confirmRemoveCert,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileRemoveSvg.ReactComponent), {}),
                                        " Delete"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setCertToRemove(null),
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ProfileSection":"eigPk","src/store/sessionStore":"kPSO3","src/api/mutations/useUpdateTrainerProfile":"4z0zZ","src/api/services/firebaseStorage":"cCllM","antd":[["Modal","kY4DD","default"]],"src/components/Modals/FullScreenDocumentModal/FullScreenDocumentModal":"1sOL3","src/utils/appAlert":"de4Mq","../ProfileEditContext":"iw7ag","./CareerHighlightsSection.scss":"i1UB8","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove2.svg":"lzWT7","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove.svg":"sZ5YA","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/certificate.svg":"7F80B","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/upload.svg":"cnXFn","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/close.svg":"lSBhS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1sOL3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FullScreenDocumentModal", ()=>FullScreenDocumentModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _mediaPreviewModalScss = require("../mediaPreviewModal.scss");
const FullScreenDocumentModal = ({ isOpen, onClose, documentUrl, type = 'auto', title = 'Document Preview' })=>{
    const [isLoading, setIsLoading] = (0, _react.useState)(true);
    const [loadedUrl, setLoadedUrl] = (0, _react.useState)('');
    const isDocument = type === 'pdf' || type === 'doc' || type === 'docx' || type === 'auto' && (documentUrl.toLowerCase().includes('.pdf') || documentUrl.toLowerCase().includes('.doc') || documentUrl.toLowerCase().includes('application/pdf'));
    (0, _react.useEffect)(()=>{
        if (isOpen && documentUrl !== loadedUrl) setIsLoading(true);
    }, [
        isOpen,
        documentUrl,
        loadedUrl
    ]);
    const antIcon = /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
        style: {
            fontSize: 48,
            color: '#ffa100'
        },
        spin: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        className: "media-preview-modal",
        open: isOpen,
        onCancel: onClose,
        footer: null,
        centered: true,
        width: "80vw",
        style: {
            maxWidth: '90vw'
        },
        destroyOnHidden: true,
        closable: true,
        closeIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
            style: {
                color: '#fff',
                fontSize: '15px',
                backgroundColor: 'rgba(15, 23, 42, 0.9)',
                border: '1px solid rgba(255, 255, 255, 0.25)',
                borderRadius: '50%',
                width: '32px',
                height: '32px',
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.5)'
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
        }),
        styles: {
            mask: {
                backdropFilter: 'blur(8px)',
                WebkitBackdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(20, 22, 28, 0.72)'
            },
            body: {
                padding: 0,
                background: '#1a1f2e',
                borderRadius: '10px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '400px'
            }
        },
        children: documentUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            style: {
                width: '100%',
                minHeight: '75vh',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative',
                borderRadius: '10px',
                overflow: 'hidden',
                background: '#1a1f2e'
            },
            children: [
                isLoading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 2,
                        background: '#1a1f2e'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                        indicator: antIcon
                    })
                }),
                isDocument ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("iframe", {
                    title: title,
                    src: documentUrl,
                    onLoad: ()=>{
                        setIsLoading(false);
                        setLoadedUrl(documentUrl);
                    },
                    style: {
                        width: '100%',
                        height: '75vh',
                        border: 'none',
                        borderRadius: '10px',
                        display: 'block',
                        background: '#fff',
                        opacity: isLoading ? 0 : 1,
                        transition: 'opacity 0.2s ease'
                    }
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: documentUrl,
                    alt: title,
                    onLoad: ()=>{
                        setIsLoading(false);
                        setLoadedUrl(documentUrl);
                    },
                    style: {
                        width: '100%',
                        maxHeight: '75vh',
                        objectFit: 'contain',
                        borderRadius: '10px',
                        display: isLoading ? 'none' : 'block',
                        margin: '0 auto'
                    }
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["CloseOutlined","dinn5","default"],["LoadingOutlined","8Mvdh","default"]],"../mediaPreviewModal.scss":"b16LQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b16LQ":[function() {},{}],"i1UB8":[function() {},{}],"7F80B":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCertificate);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCertificate = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                d: "m12.898 10.742 1.263 7.105a.416.416 0 0 1-.675.392l-2.984-2.24a.83.83 0 0 0-.997 0l-2.988 2.239a.417.417 0 0 1-.675-.39l1.261-7.106"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                d: "M10 11.664a5 5 0 1 0 0-10 5 5 0 0 0 0 10"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lSBhS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgClose);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgClose = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.667,
            d: "M15 5 5 15M5 5l10 10"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iLwPD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExpertiseSection", ()=>ExpertiseSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _profileSection = require("./ProfileSection");
var _sessionStore = require("src/store/sessionStore");
var _useUpdateTrainerProfile = require("src/api/mutations/useUpdateTrainerProfile");
var _profileEditContext = require("../ProfileEditContext");
var _textSectionScss = require("./TextSection.scss");
var _expertiseSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/expertise.svg");
const ExpertiseSection = ()=>{
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)('');
    const [expertise, setExpertise] = (0, _react.useState)(currentUser?.expertise || '');
    const { mutateAsync: updateProfileBackend, isPending } = (0, _useUpdateTrainerProfile.useUpdateTrainerProfile)();
    const { globalEditAction, registerEditState } = (0, _react.useContext)((0, _profileEditContext.ProfileEditContext));
    (0, _react.useEffect)(()=>{
        if (globalEditAction.count > 0) {
            if (globalEditAction.type === 'OPEN') setIsEditing(true);
            else if (globalEditAction.type === 'CLOSE') setIsEditing(false);
        }
    }, [
        globalEditAction
    ]);
    (0, _react.useEffect)(()=>{
        registerEditState('expertise', isEditing);
    }, [
        isEditing,
        registerEditState
    ]);
    (0, _react.useEffect)(()=>{
        if (currentUser && !isEditing) setExpertise(currentUser.expertise || '');
    }, [
        currentUser,
        isEditing
    ]);
    const handleSave = async ()=>{
        if (!currentUser) return;
        if (expertise.length > 1000) {
            setError('Expertise must be less than 1000 characters');
            return;
        }
        const trimmedExpertise = expertise.trim();
        if (!trimmedExpertise) {
            setError('Expertise is required');
            return;
        }
        setError('');
        setExpertise(trimmedExpertise);
        try {
            const uid = currentUser?.uid || '';
            await updateProfileBackend({
                uid,
                data: {
                    expertise: trimmedExpertise
                }
            });
            setIsEditing(false);
        } catch (error) {
            console.error(error);
        }
    };
    const viewContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "text-section-view",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "icon-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expertiseSvg.ReactComponent), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: currentUser?.expertise || 'No expertise description provided.'
            })
        ]
    });
    const editContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "text-section-edit",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "description",
                children: 'Describe your areas of expertise and what makes you unique'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        value: expertise,
                        maxLength: 1000,
                        onChange: (e)=>{
                            setExpertise(e.target.value);
                            if (error) setError('');
                        },
                        onBlur: (e)=>setExpertise(e.target.value.trim()),
                        placeholder: "Specialized in strength training and functional fitness...",
                        className: error ? 'error-border' : ''
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "error-message",
                        children: error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                        style: {
                            color: expertise.length > 1000 ? 'red' : 'rgba(255,255,255,0.4)',
                            alignSelf: 'flex-end',
                            marginTop: 4
                        },
                        children: [
                            expertise.length,
                            "/1000"
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileSection.ProfileSection), {
        title: "Expertise",
        className: "align-items-center career-highlights-centificate-header",
        isEditing: isEditing,
        isSaving: isPending,
        onEditToggle: setIsEditing,
        onSave: handleSave,
        onCancel: ()=>{
            if (currentUser) {
                setExpertise(currentUser.expertise || '');
                setError('');
            }
        },
        editContent: editContent,
        children: viewContent
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ProfileSection":"eigPk","src/store/sessionStore":"kPSO3","src/api/mutations/useUpdateTrainerProfile":"4z0zZ","../ProfileEditContext":"iw7ag","./TextSection.scss":"be7ts","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/expertise.svg":"8gPul","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"be7ts":[function() {},{}],"8gPul":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgExpertise);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgExpertise = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                d: "M12.503 1.664h-7.5a1.667 1.667 0 0 0-1.667 1.667v13.333a1.667 1.667 0 0 0 1.667 1.667h10a1.667 1.667 0 0 0 1.666-1.667V5.831z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                d: "M11.664 1.664v3.333a1.667 1.667 0 0 0 1.667 1.667h3.333M8.33 7.5H6.665m6.665 3.336H6.665m6.665 3.328H6.665"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5g7rB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrainingStyleSection", ()=>TrainingStyleSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _profileSection = require("./ProfileSection");
var _sessionStore = require("src/store/sessionStore");
var _useUpdateTrainerProfile = require("src/api/mutations/useUpdateTrainerProfile");
var _profileEditContext = require("../ProfileEditContext");
var _textSectionScss = require("./TextSection.scss");
var _experienceLevelSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/experience-level.svg");
const TrainingStyleSection = ()=>{
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [error, setError] = (0, _react.useState)('');
    const [trainingStyle, setTrainingStyle] = (0, _react.useState)(currentUser?.trainingStyle || '');
    const { mutateAsync: updateProfileBackend, isPending } = (0, _useUpdateTrainerProfile.useUpdateTrainerProfile)();
    const { globalEditAction, registerEditState } = (0, _react.useContext)((0, _profileEditContext.ProfileEditContext));
    (0, _react.useEffect)(()=>{
        if (globalEditAction.count > 0) {
            if (globalEditAction.type === 'OPEN') setIsEditing(true);
            else if (globalEditAction.type === 'CLOSE') setIsEditing(false);
        }
    }, [
        globalEditAction
    ]);
    (0, _react.useEffect)(()=>{
        registerEditState('trainingStyle', isEditing);
    }, [
        isEditing,
        registerEditState
    ]);
    (0, _react.useEffect)(()=>{
        if (currentUser && !isEditing) setTrainingStyle(currentUser.trainingStyle || '');
    }, [
        currentUser,
        isEditing
    ]);
    const handleSave = async ()=>{
        if (!currentUser) return;
        if (trainingStyle.length > 1000) {
            setError('Training Style must be less than 1000 characters');
            return;
        }
        const trimmedStyle = trainingStyle.trim();
        if (!trimmedStyle) {
            setError('Training Style is required');
            return;
        }
        setError('');
        setTrainingStyle(trimmedStyle);
        try {
            const uid = currentUser?.uid || '';
            await updateProfileBackend({
                uid,
                data: {
                    trainingStyle: trimmedStyle
                }
            });
            setIsEditing(false);
        } catch (error) {
            console.error(error);
        }
    };
    const viewContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "text-section-view",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "icon-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _experienceLevelSvg.ReactComponent), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: currentUser?.trainingStyle || 'No training style description provided.'
            })
        ]
    });
    const editContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "text-section-edit",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "description",
                children: 'Explain your training approach and philosophy'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        value: trainingStyle,
                        maxLength: 1000,
                        onChange: (e)=>{
                            setTrainingStyle(e.target.value);
                            if (error) setError('');
                        },
                        onBlur: (e)=>setTrainingStyle(e.target.value.trim()),
                        placeholder: "I believe in progressive overload and periodization...",
                        className: error ? 'error-border' : ''
                    }),
                    error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "error-message",
                        children: error
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                        style: {
                            color: trainingStyle.length > 1000 ? 'red' : 'rgba(255,255,255,0.4)',
                            alignSelf: 'flex-end',
                            marginTop: 4
                        },
                        children: [
                            trainingStyle.length,
                            "/1000"
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileSection.ProfileSection), {
        title: "Training Style",
        className: "align-items-center career-highlights-centificate-header",
        isEditing: isEditing,
        isSaving: isPending,
        onEditToggle: setIsEditing,
        onSave: handleSave,
        onCancel: ()=>{
            if (currentUser) {
                setTrainingStyle(currentUser.trainingStyle || '');
                setError('');
            }
        },
        editContent: editContent,
        children: viewContent
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ProfileSection":"eigPk","src/store/sessionStore":"kPSO3","src/api/mutations/useUpdateTrainerProfile":"4z0zZ","../ProfileEditContext":"iw7ag","./TextSection.scss":"be7ts","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/experience-level.svg":"9iaYU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"be7ts":[function() {},{}],"i8pkN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SessionPricingSection", ()=>SessionPricingSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _profileSection = require("./ProfileSection");
var _sessionStore = require("src/store/sessionStore");
var _useUpdateTrainerProfile = require("src/api/mutations/useUpdateTrainerProfile");
var _profileEditContext = require("../ProfileEditContext");
var _sessionPricingSectionScss = require("./SessionPricingSection.scss");
var _closeSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/close.svg");
const SessionPricingSection = ()=>{
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const { mutateAsync: updateProfileBackend, isPending } = (0, _useUpdateTrainerProfile.useUpdateTrainerProfile)();
    const { globalEditAction, registerEditState } = (0, _react.useContext)((0, _profileEditContext.ProfileEditContext));
    (0, _react.useEffect)(()=>{
        if (globalEditAction.count > 0) {
            if (globalEditAction.type === 'OPEN') setIsEditing(true);
            else if (globalEditAction.type === 'CLOSE') setIsEditing(false);
        }
    }, [
        globalEditAction
    ]);
    (0, _react.useEffect)(()=>{
        registerEditState('sessionPricing', isEditing);
    }, [
        isEditing,
        registerEditState
    ]);
    const [pricing, setPricing] = (0, _react.useState)(currentUser?.pricing?.length ? currentUser.pricing : [
        {
            duration: '',
            price: ''
        }
    ]);
    (0, _react.useEffect)(()=>{
        if (currentUser && !isEditing) setPricing(currentUser.pricing?.length ? currentUser.pricing : [
            {
                duration: '',
                price: ''
            }
        ]);
    }, [
        currentUser,
        isEditing
    ]);
    const handleSave = async ()=>{
        if (!currentUser) return;
        const hasInvalidEntries = pricing.some((p)=>p.duration === '' || isNaN(Number(p.duration)) || Number(p.duration) <= 0 || Number(p.duration) > 240 || p.price === '' || isNaN(Number(p.price)) || Number(p.price) <= 0 || Number(p.price) > 10000);
        if (hasInvalidEntries) return;
        try {
            const uid = currentUser?.uid || '';
            // Convert to numbers before saving to backend
            const cleanedPricing = pricing.map((p)=>({
                    duration: Number(p.duration),
                    price: Number(p.price)
                }));
            await updateProfileBackend({
                uid,
                data: {
                    pricing: cleanedPricing
                }
            });
            setIsEditing(false);
        } catch (error) {
            console.error(error);
        }
    };
    const handleAddPricing = ()=>{
        setPricing([
            ...pricing,
            {
                duration: '',
                price: ''
            }
        ]);
    };
    const handleRemovePricing = (index)=>{
        setPricing(pricing.filter((_, i)=>i !== index));
    };
    const handleUpdatePricing = (index, field, value)=>{
        setPricing(pricing.map((p, i)=>i === index ? {
                ...p,
                [field]: value
            } : p));
    };
    const viewContent = /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "session-pricing-view",
        children: currentUser?.pricing && currentUser.pricing.length > 0 ? currentUser.pricing.map((p, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "pricing-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                        children: [
                            "$",
                            p.price
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: `${p.duration} minute session`
                    })
                ]
            }, i)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "text-section-view",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: 'No session pricing added yet.'
            })
        })
    });
    const editContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "session-pricing-edit",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "description",
                children: 'Set your pricing for different session durations'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "pricing-input-group",
                children: [
                    pricing.map((p, i)=>{
                        const isDurationError = p.duration === '' || isNaN(Number(p.duration)) || Number(p.duration) <= 0 || Number(p.duration) > 240;
                        const isPriceError = p.price === '' || isNaN(Number(p.price)) || Number(p.price) <= 0 || Number(p.price) > 10000;
                        const hasError = isDurationError || isPriceError;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '4px',
                                marginBottom: '16px'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group row-group",
                                    style: {
                                        marginBottom: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            value: p.duration !== undefined ? p.duration : '',
                                            onChange: (e)=>handleUpdatePricing(i, 'duration', e.target.value),
                                            onBlur: (e)=>handleUpdatePricing(i, 'duration', e.target.value.trim()),
                                            className: `duration-input ${isDurationError && p.duration !== '' ? 'error-border' : ''}`,
                                            placeholder: "Min"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "unit",
                                            children: "minutes - $"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            value: p.price !== undefined ? p.price : '',
                                            onChange: (e)=>handleUpdatePricing(i, 'price', e.target.value),
                                            onBlur: (e)=>handleUpdatePricing(i, 'price', e.target.value.trim()),
                                            className: `price-input ${isPriceError && p.price !== '' ? 'error-border' : ''}`,
                                            placeholder: "Price"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "remove-btn",
                                            onClick: ()=>handleRemovePricing(i),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeSvg.ReactComponent), {})
                                        })
                                    ]
                                }),
                                hasError && (p.duration !== '' || p.price !== '') && /*#__PURE__*/ (0, _jsxRuntime.jsx)("small", {
                                    style: {
                                        color: '#E44E4E',
                                        marginTop: '4px'
                                    },
                                    children: isDurationError && isPriceError ? 'Please enter a valid duration (1-240 mins) and price ($1-$10,000).' : isDurationError ? 'Please enter a valid duration between 1 and 240 minutes.' : 'Please enter a valid price between $1 and $10,000.'
                                })
                            ]
                        }, i);
                    }),
                    pricing.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "no-data",
                        style: {
                            marginLeft: 0
                        },
                        children: `Click "+ Add Option" to add pricing.`
                    })
                ]
            })
        ]
    });
    const hasPricingError = pricing.some((p)=>p.duration === '' || isNaN(Number(p.duration)) || Number(p.duration) <= 0 || Number(p.duration) > 240 || p.price === '' || isNaN(Number(p.price)) || Number(p.price) <= 0 || Number(p.price) > 10000);
    const isInitialEmpty = !currentUser?.pricing || currentUser.pricing.length === 0;
    const isActionDisabled = hasPricingError || pricing.length === 0 && isInitialEmpty;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileSection.ProfileSection), {
        title: "Session Pricing",
        className: "align-items-center career-highlights-centificate-header",
        isEditing: isEditing,
        isSaving: isPending,
        isActionDisabled: isActionDisabled,
        onEditToggle: setIsEditing,
        onSave: handleSave,
        onCancel: ()=>{
            if (currentUser) setPricing(currentUser.pricing?.length ? currentUser.pricing : [
                {
                    duration: '',
                    price: ''
                }
            ]);
        },
        editContent: editContent,
        headerAction: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
            className: "add-action-btn",
            onClick: handleAddPricing,
            disabled: pricing.length >= 5,
            style: {
                background: 'none',
                border: 'none',
                color: pricing.length >= 5 ? 'rgba(255, 255, 255, 0.4)' : '#ffb703',
                cursor: pricing.length >= 5 ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500'
            },
            children: '+ Add Option'
        }),
        children: viewContent
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ProfileSection":"eigPk","src/store/sessionStore":"kPSO3","src/api/mutations/useUpdateTrainerProfile":"4z0zZ","../ProfileEditContext":"iw7ag","./SessionPricingSection.scss":"5e9nM","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/close.svg":"lSBhS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5e9nM":[function() {},{}],"d7Btc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "LocationFacilitySection", ()=>LocationFacilitySection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _profileSection = require("./ProfileSection");
var _sessionStore = require("src/store/sessionStore");
var _useUpdateTrainerProfile = require("src/api/mutations/useUpdateTrainerProfile");
var _profileEditContext = require("../ProfileEditContext");
var _locationFacilitySectionScss = require("./LocationFacilitySection.scss");
var _locationSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/location.svg");
var _facilitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/facility.svg");
const LocationFacilitySection = ()=>{
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [errors, setErrors] = (0, _react.useState)({});
    const [location, setLocation] = (0, _react.useState)(currentUser?.location || '');
    const [facility, setFacility] = (0, _react.useState)(currentUser?.facility || '');
    const { mutateAsync: updateProfileBackend, isPending } = (0, _useUpdateTrainerProfile.useUpdateTrainerProfile)();
    const { globalEditAction, registerEditState } = (0, _react.useContext)((0, _profileEditContext.ProfileEditContext));
    (0, _react.useEffect)(()=>{
        if (globalEditAction.count > 0) {
            if (globalEditAction.type === 'OPEN') setIsEditing(true);
            else if (globalEditAction.type === 'CLOSE') setIsEditing(false);
        }
    }, [
        globalEditAction
    ]);
    (0, _react.useEffect)(()=>{
        registerEditState('locationFacility', isEditing);
    }, [
        isEditing,
        registerEditState
    ]);
    (0, _react.useEffect)(()=>{
        if (currentUser && !isEditing) {
            setLocation(currentUser.location || '');
            setFacility(currentUser.facility || '');
        }
    }, [
        currentUser,
        isEditing
    ]);
    const handleSave = async ()=>{
        if (!currentUser) return;
        const newErrors = {};
        if (location.length > 200) newErrors.location = 'Location must be under 200 characters';
        if (facility.length > 200) newErrors.facility = 'Facility must be under 200 characters';
        const trimmedLocation = location.trim();
        const trimmedFacility = facility.trim();
        if (!trimmedLocation) newErrors.location = 'Location is required';
        if (!trimmedFacility) newErrors.facility = 'Primary facility is required';
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;
        }
        setErrors({});
        setLocation(trimmedLocation);
        setFacility(trimmedFacility);
        try {
            const uid = currentUser?.uid || '';
            await updateProfileBackend({
                uid,
                data: {
                    location: trimmedLocation,
                    facility: trimmedFacility
                }
            });
            setIsEditing(false);
        } catch (error) {
            console.error(error);
        }
    };
    const viewContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "location-facility-view",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "location-item",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "icon-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _locationSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "location-details",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "label",
                                children: "LOCATION"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "value",
                                children: currentUser?.location || 'No location provided.'
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "location-item",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "icon-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _facilitySvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "location-details",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "label",
                                children: "PRIMARY FACILITY"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "value",
                                children: currentUser?.facility || 'No primary facility provided.'
                            })
                        ]
                    })
                ]
            })
        ]
    });
    const editContent = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "location-facility-edit",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        children: "Location"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        value: location,
                        maxLength: 200,
                        onChange: (e)=>{
                            setLocation(e.target.value);
                            if (errors.location) setErrors((prev)=>({
                                    ...prev,
                                    location: ''
                                }));
                        },
                        onBlur: (e)=>setLocation(e.target.value.trim()),
                        placeholder: "Los Angeles, CA",
                        className: errors.location ? 'error-border' : ''
                    }),
                    errors.location && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "error-message",
                        children: errors.location
                    }),
                    location.length >= 200 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                        style: {
                            color: '#E44E4E',
                            alignSelf: 'flex-end',
                            marginTop: 4
                        },
                        children: [
                            location.length,
                            "/200"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        children: "Primary Facility"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "text",
                        value: facility,
                        maxLength: 200,
                        onChange: (e)=>{
                            setFacility(e.target.value);
                            if (errors.facility) setErrors((prev)=>({
                                    ...prev,
                                    facility: ''
                                }));
                        },
                        onBlur: (e)=>setFacility(e.target.value.trim()),
                        placeholder: "Gold's Gym Venice",
                        className: errors.facility ? 'error-border' : ''
                    }),
                    errors.facility && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "error-message",
                        children: errors.facility
                    }),
                    facility.length >= 200 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                        style: {
                            color: '#E44E4E',
                            alignSelf: 'flex-end',
                            marginTop: 4
                        },
                        children: [
                            facility.length,
                            "/200"
                        ]
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileSection.ProfileSection), {
        title: "Location & Facility",
        className: "align-items-center career-highlights-centificate-header",
        isEditing: isEditing,
        isSaving: isPending,
        onEditToggle: setIsEditing,
        onSave: handleSave,
        onCancel: ()=>{
            if (currentUser) {
                setLocation(currentUser.location || '');
                setFacility(currentUser.facility || '');
                setErrors({});
            }
        },
        editContent: editContent,
        children: viewContent
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ProfileSection":"eigPk","src/store/sessionStore":"kPSO3","src/api/mutations/useUpdateTrainerProfile":"4z0zZ","../ProfileEditContext":"iw7ag","./LocationFacilitySection.scss":"7TEn6","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/location.svg":"19nuk","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/facility.svg":"dTc1y","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7TEn6":[function() {},{}],"19nuk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLocation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLocation = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M16.67 8.33c0 4.162-4.617 8.495-6.167 9.833a.83.83 0 0 1-1.001 0c-1.55-1.338-6.166-5.671-6.166-9.832a6.667 6.667 0 0 1 13.333 0"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M10 10.836a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dTc1y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFacility);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFacility = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.667,
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M5 18.33v-15a1.667 1.667 0 0 1 1.667-1.666h6.666A1.666 1.666 0 0 1 15 3.331v15zM4.997 10H3.331a1.667 1.667 0 0 0-1.667 1.667v5a1.667 1.667 0 0 0 1.667 1.666h1.666"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M15 7.5h1.667a1.667 1.667 0 0 1 1.666 1.667v7.5a1.667 1.667 0 0 1-1.666 1.666H15M8.336 5h3.333M8.336 8.336h3.333m-3.333 3.328h3.333M8.336 15h3.333"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lJIEb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPlatformDomainError", ()=>getPlatformDomainError);
parcelHelpers.export(exports, "getSocialIcon", ()=>getSocialIcon);
parcelHelpers.export(exports, "SocialLinksSection", ()=>SocialLinksSection);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _profileSection = require("./ProfileSection");
var _sessionStore = require("src/store/sessionStore");
var _useUpdateTrainerProfile = require("src/api/mutations/useUpdateTrainerProfile");
var _profileEditContext = require("../ProfileEditContext");
var _antd = require("antd");
var _appAlert = require("src/utils/appAlert");
var _socialLinksSectionScss = require("./SocialLinksSection.scss");
var _profileRemove2Svg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove2.svg");
var _profileRemoveSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove.svg");
var _closeSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/close.svg");
const PRESET_PLATFORMS = [
    {
        name: 'Facebook'
    },
    {
        name: 'Instagram'
    },
    {
        name: 'Twitter'
    },
    {
        name: 'YouTube'
    },
    {
        name: 'LinkedIn'
    },
    {
        name: 'TikTok'
    },
    {
        name: 'Website'
    }
];
const getPlatformDomainError = (platform, url)=>{
    const normPlatform = platform.trim().toLowerCase();
    const normUrl = url.trim().toLowerCase();
    if (normPlatform.includes('facebook') || normPlatform === 'fb') {
        if (!normUrl.includes('facebook') && !normUrl.includes('fb.com') && !normUrl.includes('fb.watch')) return 'URL must contain facebook (e.g. https://facebook.com/...)';
    } else if (normPlatform.includes('instagram') || normPlatform.includes('insta')) {
        if (!normUrl.includes('instagram') && !normUrl.includes('instagr.am')) return 'URL must contain instagram (e.g. https://instagram.com/...)';
    } else if (normPlatform.includes('twitter') || normPlatform === 'x' || normPlatform.includes('twitter / x')) {
        if (!normUrl.includes('twitter') && !normUrl.includes('x.com') && !normUrl.includes('t.co')) return 'URL must contain twitter or x.com (e.g. https://twitter.com/...)';
    } else if (normPlatform.includes('youtube') || normPlatform === 'yt') {
        if (!normUrl.includes('youtube') && !normUrl.includes('youtu.be')) return 'URL must contain youtube (e.g. https://youtube.com/...)';
    } else if (normPlatform.includes('linkedin')) {
        if (!normUrl.includes('linkedin')) return 'URL must contain linkedin (e.g. https://linkedin.com/...)';
    } else if (normPlatform.includes('tiktok')) {
        if (!normUrl.includes('tiktok')) return 'URL must contain tiktok (e.g. https://tiktok.com/...)';
    }
    return null;
};
const getSocialIcon = (platform)=>{
    const normalized = platform.trim().toLowerCase();
    if (normalized.includes('facebook') || normalized.includes('fb')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: "social-platform-svg facebook",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"
        })
    });
    if (normalized.includes('instagram') || normalized.includes('insta')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: "social-platform-svg instagram",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
        })
    });
    if (normalized.includes('twitter') || normalized.includes(' x') || normalized === 'x') return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: "social-platform-svg twitter",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
        })
    });
    if (normalized.includes('youtube') || normalized.includes('yt')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: "social-platform-svg youtube",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"
        })
    });
    if (normalized.includes('linkedin')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: "social-platform-svg linkedin",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
        })
    });
    if (normalized.includes('tiktok')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        className: "social-platform-svg tiktok",
        viewBox: "0 0 24 24",
        fill: "currentColor",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-1.01-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.24 1.07-.14 1.61.24 1.64 1.82 2.84 3.48 2.72 1.02-.04 1.98-.59 2.51-1.46.43-.64.6-1.41.6-2.18V.02z"
        })
    });
    // Fallback: Globe / Link icon
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        className: "social-platform-svg website",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        strokeWidth: "2",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: "12",
                cy: "12",
                r: "10"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                x1: "2",
                y1: "12",
                x2: "22",
                y2: "12"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
            })
        ]
    });
};
const SocialLinksSection = ()=>{
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const [isEditing, setIsEditing] = (0, _react.useState)(false);
    const [hasSubmitted, setHasSubmitted] = (0, _react.useState)(false);
    const { mutateAsync: updateProfileBackend, isPending } = (0, _useUpdateTrainerProfile.useUpdateTrainerProfile)();
    const { globalEditAction, registerEditState } = (0, _react.useContext)((0, _profileEditContext.ProfileEditContext));
    const [links, setLinks] = (0, _react.useState)(currentUser?.socialLinks?.length ? currentUser.socialLinks : []);
    const [activeAutocompleteIndex, setActiveAutocompleteIndex] = (0, _react.useState)(null);
    const [linkToRemove, setLinkToRemove] = (0, _react.useState)(null);
    const dropdownRef = (0, _react.useRef)(null);
    // Sync with global bulk edit
    (0, _react.useEffect)(()=>{
        if (globalEditAction.count > 0) {
            if (globalEditAction.type === 'OPEN') {
                setIsEditing(true);
                setHasSubmitted(false);
            } else if (globalEditAction.type === 'CLOSE') setIsEditing(false);
        }
    }, [
        globalEditAction
    ]);
    // Register section with edit context
    (0, _react.useEffect)(()=>{
        registerEditState('socialLinks', isEditing);
    }, [
        isEditing,
        registerEditState
    ]);
    // Sync state when currentUser changes and not editing
    (0, _react.useEffect)(()=>{
        if (currentUser && !isEditing) setLinks(currentUser.socialLinks?.length ? currentUser.socialLinks : []);
    }, [
        currentUser,
        isEditing
    ]);
    // Close autocomplete on click outside
    (0, _react.useEffect)(()=>{
        const handleClickOutside = (e)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setActiveAutocompleteIndex(null);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>document.removeEventListener('mousedown', handleClickOutside);
    }, []);
    const handleAddLink = ()=>{
        if (links.length >= 10) {
            (0, _appAlert.toast).error('You can add up to 10 social media links.');
            return;
        }
        setLinks([
            ...links,
            {
                platform: '',
                url: ''
            }
        ]);
        setHasSubmitted(false);
    };
    const handleRemoveLinkClick = (index)=>{
        const item = links[index];
        if (!item.platform.trim() && !item.url.trim()) setLinks(links.filter((_, i)=>i !== index));
        else setLinkToRemove(index);
    };
    const confirmRemoveLink = ()=>{
        if (linkToRemove !== null) {
            setLinks(links.filter((_, i)=>i !== linkToRemove));
            setLinkToRemove(null);
        }
    };
    const handleUpdateField = (index, field, value)=>{
        setLinks(links.map((link, i)=>{
            if (i === index) return {
                ...link,
                [field]: value
            };
            return link;
        }));
    };
    const handlePlatformBlur = (index, rawVal)=>{
        const trimmed = rawVal.trim();
        handleUpdateField(index, 'platform', trimmed);
    };
    const handleUrlBlur = (index, rawVal)=>{
        let trimmed = rawVal.trim();
        if (trimmed && !/^https?:\/\//i.test(trimmed)) trimmed = `https://${trimmed}`;
        handleUpdateField(index, 'url', trimmed);
    };
    const handleSelectAutocomplete = (index, platform)=>{
        setLinks(links.map((link, i)=>{
            if (i === index) return {
                ...link,
                platform: platform.name
            };
            return link;
        }));
        setActiveAutocompleteIndex(null);
    };
    // Validation function
    const validateLinks = ()=>{
        const rowErrors = [];
        let hasError = false;
        links.forEach((link)=>{
            const err = {};
            const platformTrimmed = link.platform.trim();
            const urlTrimmed = link.url.trim();
            // If either platform or url is provided, both are required and must be valid
            if (platformTrimmed || urlTrimmed) {
                if (!platformTrimmed) {
                    err.platform = 'Platform name is required';
                    hasError = true;
                } else if (!/\p{L}/u.test(platformTrimmed)) {
                    err.platform = 'Platform must contain at least one letter';
                    hasError = true;
                } else if (platformTrimmed.length > 50) {
                    err.platform = 'Platform must be 50 characters or less';
                    hasError = true;
                }
                if (!urlTrimmed) {
                    err.url = 'URL is required';
                    hasError = true;
                } else if (urlTrimmed.length > 255) {
                    err.url = 'URL must be 255 characters or less';
                    hasError = true;
                } else if (!/^https?:\/\/[^\s/$.?#].[^\s]*$/i.test(urlTrimmed)) {
                    err.url = 'Please enter a valid URL (e.g. https://instagram.com/user)';
                    hasError = true;
                } else {
                    const domainError = getPlatformDomainError(platformTrimmed, urlTrimmed);
                    if (domainError) {
                        err.url = domainError;
                        hasError = true;
                    }
                }
            }
            rowErrors.push(err);
        });
        return {
            hasError,
            rowErrors
        };
    };
    const handleSave = async ()=>{
        if (!currentUser) return;
        setHasSubmitted(true);
        const { hasError } = validateLinks();
        if (hasError) {
            (0, _appAlert.toast).error('Please resolve validation errors before saving.');
            return;
        }
        // Filter out completely blank rows
        const validLinks = links.map((l)=>({
                platform: l.platform.trim(),
                url: l.url.trim()
            })).filter((l)=>l.platform !== '' && l.url !== '');
        if (validLinks.length > 10) {
            (0, _appAlert.toast).error('Maximum 10 social links allowed.');
            return;
        }
        try {
            const uid = currentUser.uid || '';
            await updateProfileBackend({
                uid,
                data: {
                    socialLinks: validLinks
                }
            });
            setIsEditing(false);
            setActiveAutocompleteIndex(null);
        } catch (error) {
            console.error(error);
        }
    };
    const handleCancel = ()=>{
        setIsEditing(false);
        setActiveAutocompleteIndex(null);
        setHasSubmitted(false);
        setLinks(currentUser?.socialLinks?.length ? currentUser.socialLinks : []);
    };
    const { rowErrors } = validateLinks();
    // View mode content
    const renderViewContent = ()=>{
        if (!links || links.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "social-links-empty",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "empty-text",
                children: 'No social media links added yet.'
            })
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "social-links-grid",
            children: links.map((link, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                    href: link.url,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    className: "social-link-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "platform-icon-box",
                            children: getSocialIcon(link.platform)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "link-details",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "platform-label",
                                    children: link.platform
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "link-url-text",
                                    children: link.url.replace(/^https?:\/\/(www\.)?/, '')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "external-arrow",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                        points: "15 3 21 3 21 9"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "10",
                                        y1: "14",
                                        x2: "21",
                                        y2: "3"
                                    })
                                ]
                            })
                        })
                    ]
                }, `${link.platform}-${idx}`))
        });
    };
    // Edit mode content
    const renderEditContent = ()=>{
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "social-links-edit-container",
            ref: dropdownRef,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "links-edit-list",
                    children: links.map((link, index)=>{
                        const platformErr = hasSubmitted ? rowErrors[index]?.platform : undefined;
                        const urlErr = hasSubmitted ? rowErrors[index]?.url : undefined;
                        // Filter preset platforms based on typed input
                        const filteredPresets = PRESET_PLATFORMS.filter((p)=>p.name.toLowerCase().includes(link.platform.trim().toLowerCase()));
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "social-link-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "field-group link-title-field",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "field-label",
                                            children: 'LINK TITLE'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "input-with-icon",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "prefix-icon",
                                                    children: getSocialIcon(link.platform)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "text",
                                                    className: `field-input ${platformErr ? 'error-border' : ''}`,
                                                    placeholder: "e.g. My website, Instagram...",
                                                    value: link.platform,
                                                    maxLength: 50,
                                                    onChange: (e)=>{
                                                        handleUpdateField(index, 'platform', e.target.value);
                                                        setActiveAutocompleteIndex(index);
                                                    },
                                                    onFocus: ()=>setActiveAutocompleteIndex(index),
                                                    onBlur: (e)=>handlePlatformBlur(index, e.target.value)
                                                })
                                            ]
                                        }),
                                        platformErr && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "inline-error-msg",
                                            children: platformErr
                                        }),
                                        activeAutocompleteIndex === index && filteredPresets.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "autocomplete-dropdown",
                                            children: filteredPresets.map((preset)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                    type: "button",
                                                    className: "autocomplete-item",
                                                    onMouseDown: (e)=>{
                                                        e.preventDefault(); // prevent blur before click registers
                                                        handleSelectAutocomplete(index, preset);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "item-icon",
                                                            children: getSocialIcon(preset.name)
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "item-name",
                                                            children: preset.name
                                                        })
                                                    ]
                                                }, preset.name))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "field-group url-field",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            className: "field-label",
                                            children: 'URL'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "url-input-container",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "text",
                                                    className: `field-input ${urlErr ? 'error-border' : ''}`,
                                                    placeholder: "https://",
                                                    value: link.url,
                                                    maxLength: 255,
                                                    onChange: (e)=>handleUpdateField(index, 'url', e.target.value),
                                                    onBlur: (e)=>handleUrlBlur(index, e.target.value)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    className: "remove-link-row-btn",
                                                    onClick: ()=>handleRemoveLinkClick(index),
                                                    "aria-label": "Remove link",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeSvg.ReactComponent), {})
                                                })
                                            ]
                                        }),
                                        urlErr && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "inline-error-msg",
                                            children: urlErr
                                        })
                                    ]
                                })
                            ]
                        }, index);
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    type: "button",
                    className: "add-new-link-btn",
                    onClick: handleAddLink,
                    disabled: links.length >= 10 || isPending,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "plus-icon",
                            children: '+'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: 'Add new link'
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileSection.ProfileSection), {
                title: "Social Media & Links",
                isEditing: isEditing,
                isSaving: isPending,
                onEditToggle: setIsEditing,
                onSave: handleSave,
                onCancel: handleCancel,
                editContent: renderEditContent(),
                children: renderViewContent()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: linkToRemove !== null,
                footer: null,
                onCancel: ()=>setLinkToRemove(null),
                centered: true,
                width: 400,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileRemove2Svg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: 'Delete Social Link?'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                'Are you sure you want to remove ',
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: linkToRemove !== null && links[linkToRemove]?.platform ? links[linkToRemove].platform : 'this social link'
                                }),
                                '?'
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "btn-logout",
                                    onClick: confirmRemoveLink,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _profileRemoveSvg.ReactComponent), {}),
                                        " ",
                                        'Delete'
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setLinkToRemove(null),
                                    children: 'Cancel'
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ProfileSection":"eigPk","src/store/sessionStore":"kPSO3","src/api/mutations/useUpdateTrainerProfile":"4z0zZ","../ProfileEditContext":"iw7ag","antd":[["Modal","kY4DD","default"]],"src/utils/appAlert":"de4Mq","./SocialLinksSection.scss":"l270M","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove2.svg":"lzWT7","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/profile-remove.svg":"sZ5YA","../../../../../../../assets/images/onboarding-trainer/dashboard/profile/components/close.svg":"lSBhS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l270M":[function() {},{}],"1RtZ6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Packages", ()=>Packages);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("@tanstack/react-query");
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
var _packagesService = require("src/api/services/packagesService");
var _useGetTrainerPackages = require("src/api/queries/useGetTrainerPackages");
var _useSaveTrainerPackage = require("src/api/mutations/useSaveTrainerPackage");
var _useUnpublishTrainerPackage = require("src/api/mutations/useUnpublishTrainerPackage");
var _emptyPackagesView = require("./EmptyPackagesView");
var _packagesListView = require("./PackagesListView");
var _packageForm = require("./PackageForm");
var _unpublishPackageModal = require("./UnpublishPackageModal");
var _documentTemplateView = require("./DocumentTemplateView");
var _appAlert = require("src/utils/appAlert");
var _appAlertDefault = parcelHelpers.interopDefault(_appAlert);
var _packagesScss = require("./Packages.scss");
const Packages = ()=>{
    const [searchParams, setSearchParams] = (0, _reactRouterDom.useSearchParams)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const trainerId = currentUser?.uid || (0, _firebase.auth).currentUser?.uid || '';
    // React Query Hooks
    const { data: packages = [], isLoading } = (0, _useGetTrainerPackages.useGetTrainerPackages)(trainerId);
    const saveMutation = (0, _useSaveTrainerPackage.useSaveTrainerPackage)();
    const unpublishMutation = (0, _useUnpublishTrainerPackage.useUnpublishTrainerPackage)();
    const [isManualSaving, setIsManualSaving] = (0, _react.useState)(false);
    // Navigation Sub-views: 'list' | 'create' | 'edit' | 'template'
    const currentView = searchParams.get('view') || 'list';
    const selectedPackageId = searchParams.get('id');
    const templateTypeParam = searchParams.get('type') || 'contractual_terms';
    // Modal State
    const [isUnpublishModalOpen, setIsUnpublishModalOpen] = (0, _react.useState)(false);
    // Find currently editing package
    const editingPackage = (0, _react.useMemo)(()=>{
        if (!selectedPackageId) return packages[0] || null;
        return packages.find((p)=>{
            if (p.id === selectedPackageId) return true;
            const lowerSelected = selectedPackageId.toLowerCase();
            if (p.presetTier.toLowerCase() === lowerSelected) return true;
            if (p.presetTier.toLowerCase() === `package ${lowerSelected}`) return true;
            const templateMatch = (0, _packagesService.PACKAGE_PRESET_TEMPLATES).find((t)=>t.tier.toLowerCase() === lowerSelected || t.id.toLowerCase() === lowerSelected || t.templateId.toLowerCase() === lowerSelected || lowerSelected === t.tier.replace('Package ', '').toLowerCase());
            return Boolean(templateMatch && p.presetTier === templateMatch.tier);
        }) || null;
    }, [
        packages,
        selectedPackageId
    ]);
    // Determine current tier from editingPackage or selectedPackageId
    const currentEditingTier = (0, _react.useMemo)(()=>{
        if (editingPackage?.presetTier) return editingPackage.presetTier;
        if (selectedPackageId) {
            const lower = selectedPackageId.toLowerCase();
            const matchedTemplate = (0, _packagesService.PACKAGE_PRESET_TEMPLATES).find((t)=>t.tier.toLowerCase() === lower || t.id.toLowerCase() === lower || t.templateId.toLowerCase() === lower || lower === t.tier.replace('Package ', '').toLowerCase());
            if (matchedTemplate) return matchedTemplate.tier;
        }
        return (0, _packagesService.DEFAULT_PACKAGE_TEMPLATE).tier;
    }, [
        editingPackage,
        selectedPackageId
    ]);
    const handleTierChange = (newTier, targetPackageId)=>{
        setSearchParams((prev)=>{
            const next = new URLSearchParams(prev);
            next.set('tab', 'packages');
            next.set('view', 'edit');
            if (targetPackageId) next.set('id', targetPackageId);
            else next.set('id', newTier);
            return next;
        });
    };
    // Track draft state when temporarily navigating to template view
    const [createDraft, setCreateDraft] = (0, _react.useState)(null);
    const fromView = searchParams.get('from');
    const fromId = searchParams.get('fromId');
    // View Navigation Handlers
    const navigateTo = (view, extraParams)=>{
        setSearchParams((prev)=>{
            const next = new URLSearchParams(prev);
            next.set('tab', 'packages');
            if (view === 'list') {
                next.delete('view');
                next.delete('id');
                next.delete('type');
                next.delete('from');
                next.delete('fromId');
            } else {
                next.set('view', view);
                if (view !== 'template') {
                    next.delete('type');
                    next.delete('from');
                    next.delete('fromId');
                }
                if (extraParams) Object.entries(extraParams).forEach(([k, v])=>next.set(k, v));
            }
            return next;
        });
    };
    const handleCreatePackage = ()=>{
        if (packages.length >= 3) {
            (0, _appAlertDefault.default).error('You can create a maximum of 3 packages.');
            return;
        }
        try {
            localStorage.removeItem(`mini_pt_package_create_draft_${trainerId}`);
        } catch  {
        // ignore
        }
        setCreateDraft(null);
        navigateTo('create');
    };
    const handleEditPackage = (pkg)=>{
        navigateTo('edit', {
            id: pkg.id
        });
    };
    const handleBackToList = ()=>{
        setCreateDraft(null);
        navigateTo('list');
    };
    const handleOpenTemplate = (type, currentDraft)=>{
        if (currentView === 'create' && currentDraft) setCreateDraft(currentDraft);
        const extraParams = {
            type,
            from: currentView
        };
        if (selectedPackageId) extraParams.fromId = selectedPackageId;
        navigateTo('template', extraParams);
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
        const dashboardMain = document.querySelector('.dashboard-main');
        if (dashboardMain) dashboardMain.scrollTop = 0;
    };
    const handleBackFromTemplate = ()=>{
        if (fromView === 'create') navigateTo('create');
        else if (fromView === 'edit') navigateTo('edit', fromId ? {
            id: fromId
        } : undefined);
        else navigateTo('list');
    };
    // Save Handler
    const handleSavePackage = async (packageData)=>{
        if (!trainerId) {
            (0, _appAlertDefault.default).error('Trainer session not found. Please log in again.');
            return;
        }
        setIsManualSaving(true);
        try {
            await saveMutation.mutateAsync({
                trainerId,
                packageData: {
                    ...packageData,
                    status: 'published'
                }
            });
            try {
                localStorage.removeItem(`mini_pt_package_create_draft_${trainerId}`);
            } catch  {
            // ignore
            }
            setCreateDraft(null);
            (0, _appAlertDefault.default).success(currentView === 'create' ? 'Package created and published successfully!' : 'Package changes published successfully!');
            handleBackToList();
        } catch (err) {
            console.error('Failed to save package:', err);
            const msg = err instanceof Error ? err.message : 'Failed to save package. Please try again.';
            (0, _appAlertDefault.default).error(msg);
        } finally{
            setIsManualSaving(false);
        }
    };
    // Direct API Auto-save for package drafts
    const handleAutoSavePackage = async (packageData, signal)=>{
        if (!trainerId) return;
        if (signal?.aborted) return;
        const isDraft = (packageData.status ?? 'draft') === 'draft';
        if (isDraft) {
            const draftValidation = (0, _packagesService.validatePackageDraftClient)(packageData);
            if (!draftValidation.isValid) return;
        } else {
            const clientValidation = (0, _packagesService.validatePackageClient)(packageData);
            if (!clientValidation.isValid) return;
        }
        try {
            const saved = await (0, _packagesService.packagesService).saveTrainerPackage(trainerId, {
                ...packageData,
                status: packageData.status || (currentView === 'edit' ? editingPackage?.status || 'published' : 'draft')
            }, signal);
            if (signal?.aborted) return;
            // Hydrate query cache silently so navigating back shows fresh data immediately
            const qKey = (0, _useGetTrainerPackages.trainerPackagesQueryKey)(trainerId);
            queryClient.setQueryData(qKey, (oldList = [])=>{
                const exists = oldList.some((p)=>p.id === saved.id || p.presetTier === saved.presetTier);
                return exists ? oldList.map((p)=>p.id === saved.id || p.presetTier === saved.presetTier ? saved : p) : [
                    ...oldList,
                    saved
                ];
            });
            return saved;
        } catch (err) {
            if (err instanceof Error && (err.name === 'AbortError' || err.message.includes('aborted'))) return;
            console.warn('Auto-save error:', err);
        }
    };
    // Unpublish Handler
    const handleConfirmUnpublish = async ()=>{
        if (!trainerId || !selectedPackageId) {
            (0, _appAlertDefault.default).error('Package information missing.');
            return;
        }
        try {
            await unpublishMutation.mutateAsync({
                trainerId,
                packageId: selectedPackageId
            });
            (0, _appAlertDefault.default).success('Package has been unpublished and saved as draft.');
            setIsUnpublishModalOpen(false);
            handleBackToList();
        } catch (err) {
            console.error('Failed to unpublish package:', err);
            const msg = err instanceof Error ? err.message : 'Failed to unpublish package. Please try again.';
            (0, _appAlertDefault.default).error(msg);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "packages-container",
        children: [
            currentView === 'template' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentTemplateView.DocumentTemplateView), {
                type: templateTypeParam,
                onBack: handleBackFromTemplate
            }),
            currentView === 'create' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _packageForm.PackageForm), {
                mode: "create",
                initialData: createDraft,
                allPackages: packages,
                onTierChange: handleTierChange,
                onBack: handleBackToList,
                onSave: handleSavePackage,
                onAutoSave: handleAutoSavePackage,
                onOpenTemplate: handleOpenTemplate,
                isSaving: isManualSaving
            }, "create-package"),
            currentView === 'edit' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                children: [
                    isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "packages-loading-state",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "packages-spinner"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: 'Loading package...'
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _packageForm.PackageForm), {
                        mode: "edit",
                        initialData: editingPackage,
                        initialTier: currentEditingTier,
                        allPackages: packages,
                        onTierChange: handleTierChange,
                        onBack: handleBackToList,
                        onSave: handleSavePackage,
                        onAutoSave: handleAutoSavePackage,
                        onUnpublishClick: ()=>setIsUnpublishModalOpen(true),
                        onOpenTemplate: handleOpenTemplate,
                        isSaving: isManualSaving
                    }, editingPackage?.id || currentEditingTier),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unpublishPackageModal.UnpublishPackageModal), {
                        isOpen: isUnpublishModalOpen,
                        onCancel: ()=>setIsUnpublishModalOpen(false),
                        onConfirm: handleConfirmUnpublish,
                        isPending: unpublishMutation.isPending
                    })
                ]
            }),
            currentView === 'list' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "packages-main-list-wrapper",
                children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "packages-loading-state",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "packages-spinner"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: 'Loading your packages...'
                        })
                    ]
                }) : packages.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyPackagesView.EmptyPackagesView), {
                    onCreateClick: handleCreatePackage
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _packagesListView.PackagesListView), {
                    packages: packages,
                    onEditPackage: handleEditPackage
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","@tanstack/react-query":"97Oud","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","src/api/services/packagesService":"8L80X","src/api/queries/useGetTrainerPackages":"1t4gF","src/api/mutations/useSaveTrainerPackage":"hG8bS","src/api/mutations/useUnpublishTrainerPackage":"50tSr","./EmptyPackagesView":"bI2zz","./PackagesListView":"b1hyJ","./PackageForm":"f7J4Q","./UnpublishPackageModal":"1s1dd","./DocumentTemplateView":"bN8Ok","src/utils/appAlert":"de4Mq","./Packages.scss":"camCS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8L80X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "VALID_PRESET_TIERS", ()=>VALID_PRESET_TIERS);
parcelHelpers.export(exports, "VALID_READY_WITHIN_OPTIONS", ()=>VALID_READY_WITHIN_OPTIONS);
parcelHelpers.export(exports, "VALID_NUTRITIONAL_DELIVERY_OPTIONS", ()=>VALID_NUTRITIONAL_DELIVERY_OPTIONS);
parcelHelpers.export(exports, "VALID_CURRENCIES", ()=>VALID_CURRENCIES);
parcelHelpers.export(exports, "CURRENCY_SYMBOLS", ()=>CURRENCY_SYMBOLS);
parcelHelpers.export(exports, "VALID_DURATIONS", ()=>VALID_DURATIONS);
parcelHelpers.export(exports, "PACKAGE_PRESET_TEMPLATES", ()=>PACKAGE_PRESET_TEMPLATES);
parcelHelpers.export(exports, "DEFAULT_PACKAGE_TEMPLATE", ()=>DEFAULT_PACKAGE_TEMPLATE);
parcelHelpers.export(exports, "getPackageTemplateConfig", ()=>getPackageTemplateConfig);
parcelHelpers.export(exports, "DEFAULT_PACKAGE_PRESETS", ()=>DEFAULT_PACKAGE_PRESETS);
parcelHelpers.export(exports, "PACKAGE_ERROR_CODES", ()=>PACKAGE_ERROR_CODES);
parcelHelpers.export(exports, "DEFAULT_DOCUMENT_TEMPLATES", ()=>DEFAULT_DOCUMENT_TEMPLATES);
parcelHelpers.export(exports, "validateReadyWithinTimeline", ()=>validateReadyWithinTimeline);
parcelHelpers.export(exports, "validatePackageDraftClient", ()=>validatePackageDraftClient);
parcelHelpers.export(exports, "validatePackageClient", ()=>validatePackageClient);
parcelHelpers.export(exports, "packagesService", ()=>packagesService);
var _firestore = require("firebase/firestore");
var _firebase = require("src/config/firebase");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
const VALID_PRESET_TIERS = [
    'Package 1',
    'Package 2',
    'Package 3'
];
const VALID_READY_WITHIN_OPTIONS = [
    'Within 24 hours',
    'Within 48 hours',
    'Within 3 days',
    'Within 5 days',
    'Within 7 days'
];
const VALID_NUTRITIONAL_DELIVERY_OPTIONS = [
    'Within 24 hours',
    'Within 48 hours',
    'Within 3 days',
    'Within 5 days'
];
const VALID_CURRENCIES = [
    'GBP',
    'USD',
    'EUR'
];
const CURRENCY_SYMBOLS = {
    GBP: "\xa3",
    USD: '$',
    EUR: "\u20AC"
};
const VALID_DURATIONS = [
    '1 week',
    '2 weeks',
    '3 weeks',
    '4 weeks/ 1 month',
    '6 weeks',
    '8 weeks/ 2 months',
    '12 weeks/ 3 months'
];
const PACKAGE_PRESET_TEMPLATES = [
    {
        id: 'pkg_1',
        tier: 'Package 1',
        templateId: 'pkg_template_1',
        label: 'Package 1'
    },
    {
        id: 'pkg_2',
        tier: 'Package 2',
        templateId: 'pkg_template_2',
        label: 'Package 2'
    },
    {
        id: 'pkg_3',
        tier: 'Package 3',
        templateId: 'pkg_template_3',
        label: 'Package 3'
    }
];
const DEFAULT_PACKAGE_TEMPLATE = PACKAGE_PRESET_TEMPLATES[0];
const getPackageTemplateConfig = (tier)=>{
    return PACKAGE_PRESET_TEMPLATES.find((t)=>t.tier.toLowerCase() === (tier || '').toLowerCase()) || DEFAULT_PACKAGE_TEMPLATE;
};
const DEFAULT_PACKAGE_PRESETS = {
    'Package 1': {
        templateId: PACKAGE_PRESET_TEMPLATES[0].templateId,
        name: '',
        presetTier: PACKAGE_PRESET_TEMPLATES[0].tier,
        shortDescription: '',
        whoIsThisFor: '',
        price: 0,
        currency: 'GBP',
        currencySymbol: "\xa3",
        duration: '4 weeks/ 1 month',
        coaching: {
            inquiriesPerWeek: 1,
            checkInsPerWeek: 1
        },
        optionalExtras: {
            nutritionalPlan: false,
            nutritionalGuidance: false
        },
        delivery: {
            initialProgramReadyWithin: 'Within 3 days',
            nutritionalPlanDelivery: 'Within 3 days'
        },
        terms: {
            coachingPeriod: '4-week coaching period',
            renewal: 'No automatic renewal'
        }
    },
    'Package 2': {
        templateId: PACKAGE_PRESET_TEMPLATES[1].templateId,
        name: '',
        presetTier: PACKAGE_PRESET_TEMPLATES[1].tier,
        shortDescription: '',
        whoIsThisFor: '',
        price: 0,
        currency: 'GBP',
        currencySymbol: "\xa3",
        duration: '4 weeks/ 1 month',
        coaching: {
            inquiriesPerWeek: 1,
            checkInsPerWeek: 1
        },
        optionalExtras: {
            nutritionalPlan: false,
            nutritionalGuidance: false
        },
        delivery: {
            initialProgramReadyWithin: 'Within 3 days',
            nutritionalPlanDelivery: 'Within 3 days'
        },
        terms: {
            coachingPeriod: '4-week coaching period',
            renewal: 'No automatic renewal'
        }
    },
    'Package 3': {
        templateId: PACKAGE_PRESET_TEMPLATES[2].templateId,
        name: '',
        presetTier: PACKAGE_PRESET_TEMPLATES[2].tier,
        shortDescription: '',
        whoIsThisFor: '',
        price: 0,
        currency: 'GBP',
        currencySymbol: "\xa3",
        duration: '4 weeks/ 1 month',
        coaching: {
            inquiriesPerWeek: 1,
            checkInsPerWeek: 1
        },
        optionalExtras: {
            nutritionalPlan: false,
            nutritionalGuidance: false
        },
        delivery: {
            initialProgramReadyWithin: 'Within 3 days',
            nutritionalPlanDelivery: 'Within 3 days'
        },
        terms: {
            coachingPeriod: '4-week coaching period',
            renewal: 'No automatic renewal'
        }
    }
};
const PACKAGE_ERROR_CODES = {
    ERR_PACKAGE_NAME_REQUIRED: 'Package Name is required.',
    ERR_PACKAGE_NAME_TOO_SHORT: 'Package Name must be at least 2 characters.',
    ERR_PACKAGE_NAME_TOO_LONG: 'Package Name cannot exceed 50 characters.',
    ERR_PACKAGE_NAME_INVALID: 'Package Name must contain at least one alphabetical letter.',
    ERR_SHORT_DESC_REQUIRED: 'Short Description is required.',
    ERR_SHORT_DESC_TOO_SHORT: 'Short Description must be at least 5 characters.',
    ERR_SHORT_DESC_TOO_LONG: 'Short Description cannot exceed 200 characters.',
    ERR_SHORT_DESC_INVALID: 'Short Description must contain at least one alphabetical letter.',
    ERR_WHO_IS_THIS_FOR_REQUIRED: 'Please specify who this package is for.',
    ERR_WHO_IS_THIS_FOR_TOO_SHORT: 'Who this is for must be at least 5 characters.',
    ERR_WHO_IS_THIS_FOR_TOO_LONG: 'Who this is for cannot exceed 200 characters.',
    ERR_WHO_IS_THIS_FOR_INVALID: 'Who this is for must contain at least one alphabetical letter.',
    ERR_PRICE_REQUIRED: 'Price is required.',
    ERR_INVALID_PRICE: 'Please enter a valid price.',
    ERR_INVALID_PRICE_DECIMALS: 'Price cannot have more than 2 decimal places.',
    ERR_PRICE_OUT_OF_RANGE: "Price must be between \xa31 and \xa399,999.",
    ERR_INVALID_PRESET_TIER: 'Invalid package preset tier selected.',
    ERR_INVALID_INQUIRIES_COUNT: 'Inquiries per week must be between 0 and 10.',
    ERR_INVALID_CHECKINS_COUNT: 'Check-ins per week must be between 0 and 10.',
    ERR_INVALID_DELIVERY_TIME: 'Please select a valid delivery timeline.',
    ERR_NUTRITIONAL_DELIVERY_REQUIRED: 'Nutritional plan delivery timeline is required.',
    ERR_MAX_PACKAGES_REACHED: 'You can create a maximum of 3 packages.',
    ERR_PACKAGE_NOT_FOUND: 'The specified package was not found.',
    ERR_MISSING_UID: 'Trainer session expired. Please log in again.',
    ERR_INVALID_UID: 'Invalid user identifier.',
    ERR_INTERNAL_SERVER_ERROR: 'An error occurred while communicating with the server.'
};
const DEFAULT_DOCUMENT_TEMPLATES = {
    contractual_terms: {
        title: 'Contractual terms',
        subtitle: 'Please review the terms that apply to your use of the platform and paid subscription',
        lastUpdated: 'May 1, 2026',
        version: '2.1',
        clauses: [
            {
                number: 1,
                title: 'Acceptance of Terms',
                content: 'By accessing or using miniPT ("the Platform"), you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree, you may not use the Platform.'
            },
            {
                number: 2,
                title: 'Account Eligibility',
                content: 'By accessing or using miniPT ("the Platform"), you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree, you may not use the Platform.'
            },
            {
                number: 3,
                title: 'Subscription & Billing',
                content: 'miniPT offers recurring subscription plans billed in advance. By subscribing, you authorise us to charge your selected payment method on a recurring basis until cancelled.'
            },
            {
                number: 4,
                title: 'Free Trial Terms',
                content: 'New eligible users may receive a 14-day free trial. At the end of the trial, your subscription will automatically begin and your payment method will be charged unless you cancel before the trial ends. One free trial per user.'
            },
            {
                number: 5,
                title: 'Cancellations & Refunds',
                content: 'You can cancel your subscription at any time from your account settings. Cancellations take effect at the end of the current billing period. We do not offer refunds for partial billing periods or unused subscription time, except as required by law.'
            },
            {
                number: 6,
                title: 'Trainer Responsibilities',
                content: 'You agree to use the Platform only for lawful purposes and in a professional manner. You are responsible for the accuracy of the information you provide and for obtaining any necessary consents from your clients.'
            },
            {
                number: 7,
                title: 'Content & Intellectual Property',
                content: 'All content, features, and materials on miniPT are owned by miniPT or its licensors and are protected by copyright, trademark, and other intellectual property laws. You retain ownership of the content you create, while granting miniPT a limited license to host and display it as needed to provide the service.'
            },
            {
                number: 8,
                title: 'Limitation of Liability',
                content: 'miniPT is provided "as is" and "as available." To the fullest extent permitted by law, miniPT shall not be liable for any indirect, incidental, or consequential damages arising out of your use of the Platform.'
            },
            {
                number: 9,
                title: 'Contact Information',
                content: 'If you have any questions about these Terms, please contact us at legal@minipt.com or 12 Fitness Street, London, SW1A 1AA, United Kingdom.'
            }
        ]
    },
    checkin_policy: {
        title: 'Check-in policy',
        subtitle: 'Standards and schedules for client check-ins and video evaluations',
        lastUpdated: 'May 1, 2026',
        version: '1.4',
        clauses: [
            {
                number: 1,
                title: 'Scheduled Check-in Windows',
                content: 'All check-ins must be booked at least 12 hours in advance within the trainer availability schedule. Video check-ins last 15 minutes unless an extended session is agreed upon.'
            },
            {
                number: 2,
                title: 'Client Preparation',
                content: 'Clients should complete their weekly workout log and log any questions or injuries before the check-in call to ensure maximum coaching value.'
            },
            {
                number: 3,
                title: 'Rescheduling Guidelines',
                content: 'Check-ins can be rescheduled up to 4 hours before the booked slot without penalty. Missed check-ins without notice will be forfeited.'
            },
            {
                number: 4,
                title: 'Video Connection & Technical Support',
                content: 'Video check-ins are conducted via integrated secure video links. Trainers and clients must ensure stable internet access during their booked window.'
            }
        ]
    },
    cancellation_policy: {
        title: 'Cancellation and unused policy',
        subtitle: 'Policy regarding package cancellations, pauses, and unused coaching credits',
        lastUpdated: 'May 1, 2026',
        version: '1.2',
        clauses: [
            {
                number: 1,
                title: '4-Week Package Cycle',
                content: 'Packages run for a fixed 4-week period starting on the designated program ready date. Services do not roll over past the 4-week cycle.'
            },
            {
                number: 2,
                title: 'Cancellation Notice',
                content: 'Clients may request cancellation of ongoing coaching with 7 days notice prior to the end of their current 4-week cycle.'
            },
            {
                number: 3,
                title: 'Unused Inquiries and Check-ins',
                content: 'Unused inquiries and check-ins expire at the conclusion of each 4-week coaching period and cannot be redeemed for cash or refunded.'
            },
            {
                number: 4,
                title: 'Trainer Cancellation & Replacement',
                content: 'If a trainer is unable to deliver a scheduled program or check-ins due to unforeseen circumstances, an extension or prorated credit will be issued.'
            }
        ]
    }
};
const validateReadyWithinTimeline = (readyWithin)=>{
    const trimmed = readyWithin?.trim();
    if (!trimmed) return {
        isValid: false,
        error: 'Please select or enter when the initial program will be ready.'
    };
    if (trimmed.includes('-')) return {
        isValid: false,
        error: 'Initial program ready within cannot be negative.'
    };
    const match = trimmed.match(/^(?:within\s+)?(\d+)\s*(days?|hours?|d|h)?$/i);
    if (!match) return {
        isValid: false,
        error: 'Please enter a valid timeframe between 1 and 60 days (e.g. Within 3 days).'
    };
    const num = parseInt(match[1], 10);
    const unit = match[2]?.toLowerCase();
    if (unit && (unit.startsWith('h') || unit === 'hours' || unit === 'hour')) {
        if (num <= 0) return {
            isValid: false,
            error: 'Initial program ready within must be at least 1 hour.'
        };
        if (num > 1440) return {
            isValid: false,
            error: 'Initial program ready within cannot exceed 60 days (1,440 hours).'
        };
        return {
            isValid: true,
            days: Math.max(1, Math.round(num / 24))
        };
    }
    // Days
    if (num <= 0) return {
        isValid: false,
        error: 'Initial program ready within must be at least 1 day.'
    };
    if (num > 60) return {
        isValid: false,
        error: 'Initial program ready within cannot exceed 60 days.'
    };
    return {
        isValid: true,
        days: num
    };
};
const validatePackageDraftClient = (pkg)=>{
    const hasContent = Boolean(pkg.name && pkg.name.trim().length > 0 || pkg.shortDescription && pkg.shortDescription.trim().length > 0 || pkg.whoIsThisFor && pkg.whoIsThisFor.trim().length > 0 || pkg.price !== undefined && !isNaN(Number(pkg.price)) && Number(pkg.price) > 0);
    if (!hasContent) return {
        isValid: false,
        error: 'Draft has no content yet.'
    };
    if (pkg.name && pkg.name.trim().length > 50) return {
        isValid: false,
        error: 'Package Name cannot exceed 50 characters.'
    };
    if (pkg.shortDescription && pkg.shortDescription.trim().length > 200) return {
        isValid: false,
        error: 'Short Description cannot exceed 200 characters.'
    };
    if (pkg.whoIsThisFor && pkg.whoIsThisFor.trim().length > 200) return {
        isValid: false,
        error: 'Who this is for cannot exceed 200 characters.'
    };
    if (pkg.price !== undefined && !isNaN(Number(pkg.price)) && Number(pkg.price) > 99999) return {
        isValid: false,
        error: 'Price cannot exceed 99,999.'
    };
    return {
        isValid: true
    };
};
const validatePackageClient = (pkg)=>{
    const errors = {};
    const letterRegex = /[\p{L}]/u;
    // 1. Package Name
    const trimmedName = (pkg.name || '').trim();
    if (!trimmedName) errors.name = 'Package Name is required.';
    else if (trimmedName.length < 2) errors.name = 'Package Name must be at least 2 characters.';
    else if (trimmedName.length > 50) errors.name = 'Package Name cannot exceed 50 characters.';
    else if (!letterRegex.test(trimmedName)) errors.name = 'Package Name must contain at least one alphabetical letter.';
    // 2. Short Description
    const trimmedDesc = (pkg.shortDescription || '').trim();
    if (!trimmedDesc) errors.shortDescription = 'Short Description is required.';
    else if (trimmedDesc.length < 5) errors.shortDescription = 'Short Description must be at least 5 characters.';
    else if (trimmedDesc.length > 200) errors.shortDescription = 'Short Description cannot exceed 200 characters.';
    else if (!letterRegex.test(trimmedDesc)) errors.shortDescription = 'Short Description must contain at least one alphabetical letter.';
    // 3. Who is this for?
    const trimmedWhoFor = (pkg.whoIsThisFor || '').trim();
    if (!trimmedWhoFor) errors.whoIsThisFor = 'Please specify who this package is for.';
    else if (trimmedWhoFor.length < 5) errors.whoIsThisFor = 'Who this is for must be at least 5 characters.';
    else if (trimmedWhoFor.length > 200) errors.whoIsThisFor = 'Who this is for cannot exceed 200 characters.';
    else if (!letterRegex.test(trimmedWhoFor)) errors.whoIsThisFor = 'Who this is for must contain at least one alphabetical letter.';
    // 4. Price
    const rawPrice = pkg.price;
    const sym = pkg.currency && CURRENCY_SYMBOLS[pkg.currency] || "\xa3";
    if (rawPrice === undefined || rawPrice === null || rawPrice === '') errors.price = 'Price is required.';
    else {
        const priceVal = Number(rawPrice);
        if (isNaN(priceVal) || !Number.isFinite(priceVal) || priceVal <= 0) errors.price = 'Please enter a valid price.';
        else {
            const strVal = String(rawPrice).trim();
            const decPart = strVal.includes('.') ? strVal.split('.')[1] : '';
            if (decPart.length > 2) errors.price = 'Price cannot have more than 2 decimal places.';
            else if (priceVal < 1 || priceVal > 99999) errors.price = `Price must be between ${sym}1 and ${sym}99,999.`;
        }
    }
    // 5. Delivery SLA
    const readyResult = validateReadyWithinTimeline(pkg.delivery?.initialProgramReadyWithin);
    if (!readyResult.isValid && readyResult.error) errors.initialProgramReadyWithin = readyResult.error;
    // 6. Nutritional Plan Delivery SLA
    if (pkg.optionalExtras?.nutritionalPlan) {
        const nutDelivery = pkg.delivery?.nutritionalPlanDelivery;
        if (!nutDelivery || !VALID_NUTRITIONAL_DELIVERY_OPTIONS.includes(nutDelivery)) errors.nutritionalPlanDelivery = 'Please select nutritional plan delivery timeline.';
    }
    return {
        isValid: Object.keys(errors).length === 0,
        errors
    };
};
const packagesService = {
    /**
   * Fetch all trainer packages via Cloud Functions with Firestore fallback
   */ async getTrainerPackages (trainerId) {
        if (!trainerId) return [];
        try {
            const url = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_PACKAGES}?uid=${encodeURIComponent(trainerId)}`;
            const res = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            if (res.ok) {
                const json = await res.json();
                if (Array.isArray(json.data)) {
                    const tierOrder = {
                        'Package 1': 1,
                        'Package 2': 2,
                        'Package 3': 3
                    };
                    return json.data.sort((a, b)=>(tierOrder[a.presetTier] || 99) - (tierOrder[b.presetTier] || 99));
                }
            }
        } catch (apiErr) {
            console.warn('[packagesService.getTrainerPackages] API call failed, falling back to Firestore SDK:', apiErr);
        }
        // Direct Firestore fallback
        try {
            const packagesRef = (0, _firestore.collection)((0, _firebase.db), 'trainer_app_users', trainerId, 'packages');
            const snapshot = await (0, _firestore.getDocs)(packagesRef);
            const tierOrder = {
                'Package 1': 1,
                'Package 2': 2,
                'Package 3': 3
            };
            if (!snapshot.empty) {
                const pkgs = snapshot.docs.map((docSnap)=>({
                        ...docSnap.data(),
                        id: docSnap.id
                    }));
                return pkgs.sort((a, b)=>(tierOrder[a.presetTier] || 99) - (tierOrder[b.presetTier] || 99));
            }
            // Check parent doc summary
            const userRef = (0, _firestore.doc)((0, _firebase.db), 'trainer_app_users', trainerId);
            const userSnap = await (0, _firestore.getDoc)(userRef);
            if (userSnap.exists()) {
                const userData = userSnap.data();
                if (Array.isArray(userData?.packages) && userData.packages.length > 0) return userData.packages.sort((a, b)=>(tierOrder[a.presetTier] || 99) - (tierOrder[b.presetTier] || 99));
            }
            return [];
        } catch (firestoreErr) {
            console.error('[packagesService.getTrainerPackages] Firestore SDK error:', firestoreErr);
            return [];
        }
    },
    /**
   * Fetch package templates from Master Data
   */ async getPackageTemplates () {
        try {
            const url = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}trainer_get_package_templates`;
            const res = await fetch(url);
            if (res.ok) {
                const json = await res.json();
                if (Array.isArray(json?.data) && json.data.length > 0) return json.data;
            }
        } catch (apiErr) {
            console.warn('[packagesService.getPackageTemplates] API failed, falling back:', apiErr);
        }
        try {
            const docRef = (0, _firestore.doc)((0, _firebase.db), 'trainer_app_master_data', 'package_templates');
            const snap = await (0, _firestore.getDoc)(docRef);
            if (snap.exists()) {
                const data = snap.data();
                if (Array.isArray(data?.templates) && data.templates.length > 0) return data.templates;
            }
        } catch (fsErr) {
            console.warn('[packagesService.getPackageTemplates] Firestore read notice:', fsErr);
        }
        // Default static fallback
        return [
            'Package 1',
            'Package 2',
            'Package 3'
        ].map((tier, idx)=>({
                ...DEFAULT_PACKAGE_PRESETS[tier],
                id: `pkg_template_${idx + 1}`,
                templateId: `pkg_template_${idx + 1}`
            }));
    },
    /**
   * Fetch document / terms templates from Master Data
   */ async getDocumentTemplates () {
        try {
            const url = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_DOCUMENT_TEMPLATES}`;
            const res = await fetch(url);
            if (res.ok) {
                const json = await res.json();
                if (json?.data && typeof json.data === 'object' && Object.keys(json.data).length > 0) return json.data;
            }
        } catch (apiErr) {
            console.warn('[packagesService.getDocumentTemplates] API failed, falling back:', apiErr);
        }
        try {
            const docRef = (0, _firestore.doc)((0, _firebase.db), 'trainer_app_master_data', 'document_templates');
            const snap = await (0, _firestore.getDoc)(docRef);
            if (snap.exists()) {
                const data = snap.data();
                if (data && Object.keys(data).length > 0) return data;
            }
        } catch (fsErr) {
            console.warn('[packagesService.getDocumentTemplates] Firestore read notice:', fsErr);
        }
        return DEFAULT_DOCUMENT_TEMPLATES;
    },
    /**
   * Save (create or update) a trainer package via Cloud Functions with Firestore fallback
   */ async saveTrainerPackage (trainerId, packageData, signal) {
        if (!trainerId) throw new Error(PACKAGE_ERROR_CODES.ERR_MISSING_UID);
        // Client-side pre-validation
        const isDraft = (packageData.status ?? 'draft') === 'draft';
        if (isDraft) {
            const draftValidation = validatePackageDraftClient(packageData);
            if (!draftValidation.isValid) throw new Error(draftValidation.error || 'Draft is incomplete');
        } else {
            const clientValidation = validatePackageClient(packageData);
            if (!clientValidation.isValid) {
                const firstError = Object.values(clientValidation.errors)[0];
                throw new Error(firstError);
            }
        }
        // 1. Try Cloud Functions API
        try {
            const url = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_SAVE_PACKAGE}`;
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    uid: trainerId,
                    package: packageData
                }),
                signal
            });
            const json = await res.json().catch(()=>null);
            if (!res.ok) {
                const errorCode = json?.code;
                const mappedMsg = errorCode ? PACKAGE_ERROR_CODES[errorCode] : null;
                throw new Error(mappedMsg || json?.message || json?.error || 'Failed to save package on server.');
            }
            if (json?.data) return json.data;
        } catch (apiErr) {
            if (signal?.aborted || apiErr instanceof Error && (apiErr.name === 'AbortError' || apiErr.message.includes('aborted'))) throw new DOMException('The user aborted a request.', 'AbortError');
            // If server returned a business validation error (status 400), do NOT fall back
            const errMsg = apiErr instanceof Error ? apiErr.message : String(apiErr);
            if (Object.values(PACKAGE_ERROR_CODES).includes(errMsg)) throw apiErr;
            console.warn('[packagesService.saveTrainerPackage] Cloud Function unavailable, using Firestore client:', apiErr);
        }
        if (signal?.aborted) throw new DOMException('The user aborted a request.', 'AbortError');
        // 2. Direct Firestore fallback
        const packageId = packageData.id || `pkg_${Date.now()}`;
        const now = new Date().toISOString();
        const fullPackage = {
            id: packageId,
            trainerId,
            name: (packageData.name || '').trim(),
            presetTier: packageData.presetTier || DEFAULT_PACKAGE_TEMPLATE.tier,
            templateId: packageData.templateId || getPackageTemplateConfig(packageData.presetTier).templateId,
            shortDescription: (packageData.shortDescription || '').trim(),
            whoIsThisFor: (packageData.whoIsThisFor || '').trim(),
            price: packageData.price !== undefined && !isNaN(Number(packageData.price)) ? Number(packageData.price) : 0,
            currency: packageData.currency || 'GBP',
            currencySymbol: packageData.currencySymbol || CURRENCY_SYMBOLS[packageData.currency || 'GBP'] || "\xa3",
            duration: packageData.duration || '4 weeks/ 1 month',
            coaching: {
                inquiriesPerWeek: packageData.coaching?.inquiriesPerWeek ?? 1,
                checkInsPerWeek: packageData.coaching?.checkInsPerWeek ?? 2
            },
            optionalExtras: {
                nutritionalPlan: Boolean(packageData.optionalExtras?.nutritionalPlan),
                nutritionalGuidance: Boolean(packageData.optionalExtras?.nutritionalGuidance)
            },
            delivery: {
                initialProgramReadyWithin: packageData.delivery?.initialProgramReadyWithin || 'Within 3 days',
                nutritionalPlanDelivery: packageData.delivery?.nutritionalPlanDelivery || 'Within 3 days'
            },
            terms: {
                coachingPeriod: packageData.terms?.coachingPeriod || '4-week coaching period',
                renewal: packageData.terms?.renewal || 'No automatic renewal'
            },
            status: packageData.status || 'published',
            createdAt: packageData.createdAt || now,
            updatedAt: now
        };
        const docRef = (0, _firestore.doc)((0, _firebase.db), 'trainer_app_users', trainerId, 'packages', packageId);
        await (0, _firestore.setDoc)(docRef, fullPackage, {
            merge: true
        });
        try {
            const existing = await this.getTrainerPackages(trainerId);
            const updatedList = existing.some((p)=>p.id === packageId) ? existing.map((p)=>p.id === packageId ? fullPackage : p) : [
                ...existing,
                fullPackage
            ];
            const userRef = (0, _firestore.doc)((0, _firebase.db), 'trainer_app_users', trainerId);
            await (0, _firestore.updateDoc)(userRef, {
                packages: updatedList
            });
        } catch (syncErr) {
            console.warn('[packagesService.saveTrainerPackage] Parent sync notice:', syncErr);
        }
        return fullPackage;
    },
    /**
   * Unpublish package via Cloud Functions with Firestore fallback
   */ async unpublishTrainerPackage (trainerId, packageId) {
        if (!trainerId || !packageId) return;
        try {
            const url = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_UNPUBLISH_PACKAGE}`;
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    uid: trainerId,
                    packageId
                })
            });
            if (res.ok) return;
        } catch (apiErr) {
            console.warn('[packagesService.unpublishTrainerPackage] API call failed, using Firestore fallback:', apiErr);
        }
        // Direct Firestore fallback
        const docRef = (0, _firestore.doc)((0, _firebase.db), 'trainer_app_users', trainerId, 'packages', packageId);
        await (0, _firestore.setDoc)(docRef, {
            status: 'draft',
            updatedAt: new Date().toISOString()
        }, {
            merge: true
        });
        try {
            const existing = await this.getTrainerPackages(trainerId);
            const updatedList = existing.map((p)=>p.id === packageId ? {
                    ...p,
                    status: 'draft'
                } : p);
            const userRef = (0, _firestore.doc)((0, _firebase.db), 'trainer_app_users', trainerId);
            await (0, _firestore.updateDoc)(userRef, {
                packages: updatedList
            });
        } catch (err) {
            console.warn('[packagesService.unpublishTrainerPackage] Parent sync notice:', err);
        }
    },
    /**
   * Delete package via Cloud Functions with Firestore fallback
   */ async deleteTrainerPackage (trainerId, packageId) {
        if (!trainerId || !packageId) return;
        try {
            const url = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_DELETE_PACKAGE}`;
            const res = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    uid: trainerId,
                    packageId
                })
            });
            if (res.ok) return;
        } catch (apiErr) {
            console.warn('[packagesService.deleteTrainerPackage] API call failed, using Firestore fallback:', apiErr);
        }
        // Direct Firestore fallback
        const docRef = (0, _firestore.doc)((0, _firebase.db), 'trainer_app_users', trainerId, 'packages', packageId);
        await (0, _firestore.deleteDoc)(docRef);
        try {
            const existing = await this.getTrainerPackages(trainerId);
            const updatedList = existing.filter((p)=>p.id !== packageId);
            const userRef = (0, _firestore.doc)((0, _firebase.db), 'trainer_app_users', trainerId);
            await (0, _firestore.updateDoc)(userRef, {
                packages: updatedList
            });
        } catch (err) {
            console.warn('[packagesService.deleteTrainerPackage] Parent sync notice:', err);
        }
    }
};

},{"firebase/firestore":"5IgBQ","src/config/firebase":"cmjIE","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1t4gF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "trainerPackagesQueryKey", ()=>trainerPackagesQueryKey);
parcelHelpers.export(exports, "useGetTrainerPackages", ()=>useGetTrainerPackages);
var _reactQuery = require("@tanstack/react-query");
var _packagesService = require("../services/packagesService");
const trainerPackagesQueryKey = (trainerId)=>[
        'trainer-packages',
        trainerId
    ];
function useGetTrainerPackages(trainerId) {
    return (0, _reactQuery.useQuery)({
        queryKey: trainerPackagesQueryKey(trainerId),
        queryFn: async ()=>{
            if (!trainerId) return [];
            return (0, _packagesService.packagesService).getTrainerPackages(trainerId);
        },
        enabled: Boolean(trainerId),
        staleTime: 300000
    });
}

},{"@tanstack/react-query":"lWWNx","../services/packagesService":"8L80X","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hG8bS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSaveTrainerPackage", ()=>useSaveTrainerPackage);
var _reactQuery = require("@tanstack/react-query");
var _packagesService = require("../services/packagesService");
var _useGetTrainerPackages = require("../queries/useGetTrainerPackages");
function useSaveTrainerPackage() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: async ({ trainerId, packageData, signal })=>{
            return (0, _packagesService.packagesService).saveTrainerPackage(trainerId, packageData, signal);
        },
        onSuccess: (savedPackage, variables)=>{
            const qKey = (0, _useGetTrainerPackages.trainerPackagesQueryKey)(variables.trainerId);
            // Hydrate query cache immediately
            queryClient.setQueryData(qKey, (oldList = [])=>{
                const index = oldList.findIndex((p)=>p.id === savedPackage.id);
                if (index >= 0) {
                    const next = [
                        ...oldList
                    ];
                    next[index] = savedPackage;
                    return next;
                }
                return [
                    ...oldList,
                    savedPackage
                ];
            });
            queryClient.invalidateQueries({
                queryKey: qKey
            });
        }
    });
}

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"../services/packagesService":"8L80X","../queries/useGetTrainerPackages":"1t4gF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"50tSr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useUnpublishTrainerPackage", ()=>useUnpublishTrainerPackage);
var _reactQuery = require("@tanstack/react-query");
var _packagesService = require("../services/packagesService");
var _useGetTrainerPackages = require("../queries/useGetTrainerPackages");
function useUnpublishTrainerPackage() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: async ({ trainerId, packageId })=>{
            return (0, _packagesService.packagesService).unpublishTrainerPackage(trainerId, packageId);
        },
        onSuccess: (_, variables)=>{
            const qKey = (0, _useGetTrainerPackages.trainerPackagesQueryKey)(variables.trainerId);
            // Hydrate query cache immediately
            queryClient.setQueryData(qKey, (oldList = [])=>{
                return oldList.map((p)=>p.id === variables.packageId ? {
                        ...p,
                        status: 'draft'
                    } : p);
            });
            queryClient.invalidateQueries({
                queryKey: qKey
            });
        }
    });
}

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"../services/packagesService":"8L80X","../queries/useGetTrainerPackages":"1t4gF","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bI2zz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EmptyPackagesView", ()=>EmptyPackagesView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _emptyPackageBoxSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/empty-package/empty-package-box.svg");
var _addPlusSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/empty-package/add-plus.svg");
var _emptyPackagesViewScss = require("./EmptyPackagesView.scss");
const EmptyPackagesView = ({ onCreateClick })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "empty-packages-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "empty-packages-card",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "empty-icon-wrap",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyPackageBoxSvg.ReactComponent), {
                        className: "empty-box-svg"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    className: "empty-title",
                    children: 'No package yet'
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "empty-subtitle",
                    children: 'Create a package and start earning'
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    type: "button",
                    className: "btn-create-package-white",
                    onClick: onCreateClick,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addPlusSvg.ReactComponent), {
                            className: "btn-plus-icon"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: 'Create a Package'
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/assets/images/onboarding-trainer/dashboard/profile/packages/empty-package/empty-package-box.svg":"3brDd","src/assets/images/onboarding-trainer/dashboard/profile/packages/empty-package/add-plus.svg":"33Uwc","./EmptyPackagesView.scss":"dDQEL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3brDd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEmptyPackageBox);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEmptyPackageBox = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 80,
        height: 80,
        fill: "none",
        viewBox: "0 0 80 80",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                fillRule: "evenodd",
                d: "M35.147 33.499h9.706c4.92 0 7.382 0 8.765 1.44 1.382 1.438 1.056 3.661.405 8.108l-.615 4.217c-.51 3.487-.766 5.231-2.074 6.275s-3.237 1.044-7.098 1.044h-8.472c-3.86 0-5.79 0-7.098-1.044s-1.564-2.788-2.074-6.275l-.615-4.218c-.652-4.446-.977-6.669.405-8.108s3.844-1.44 8.765-1.44m-.98 15.251c0-.604.544-1.094 1.215-1.094h9.237c.67 0 1.214.49 1.214 1.094s-.544 1.094-1.214 1.094h-9.237c-.671 0-1.215-.49-1.215-1.094",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                d: "M34.91 25.417h10.18c.34 0 .597 0 .826.021 1.616.16 2.938 1.13 3.499 2.439h-18.83c.561-1.308 1.884-2.28 3.5-2.438.226-.022.487-.022.825-.022",
                opacity: 0.4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#FFA100",
                d: "M31.702 29.388c-2.027 0-3.69 1.225-4.244 2.848l-.035.102q.885-.255 1.797-.369c1.575-.201 3.567-.201 5.88-.201h10.05c2.314 0 4.306 0 5.88.201.613.079 1.217.194 1.797.369l-.033-.102c-.554-1.625-2.217-2.848-4.245-2.848z",
                opacity: 0.7
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 83.625,
                        x2: 21.485,
                        y1: 80.021,
                        y2: -20.52,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 40,
                        x2: 40,
                        y1: 0,
                        y2: 80,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"33Uwc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAddPlus);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAddPlus = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#07092C",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M8 1v7m0 0v7m0-7H1m7 0h7"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dDQEL":[function() {},{}],"b1hyJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PackagesListView", ()=>PackagesListView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dumbbellProgramSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/packages-list/dumbbell-program.svg");
var _inquiryChatSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/packages-list/inquiry-chat.svg");
var _videoCheckinSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/packages-list/video-checkin.svg");
var _packagesListViewScss = require("./PackagesListView.scss");
const PackagesListView = ({ packages, onEditPackage })=>{
    const tierOrder = {
        'Package 1': 1,
        'Package 2': 2,
        'Package 3': 3
    };
    const sortedPackages = [
        ...packages
    ].sort((a, b)=>(tierOrder[a.presetTier] || 99) - (tierOrder[b.presetTier] || 99));
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "packages-list-view",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "packages-cards-stack",
            children: sortedPackages.map((pkg)=>{
                const isPublished = pkg.status === 'published';
                const inquiriesCount = pkg.coaching?.inquiriesPerWeek ?? 1;
                const checkinsCount = pkg.coaching?.checkInsPerWeek ?? 2;
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "package-item-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "package-card-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "package-title-col",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "package-name-row",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                    className: "package-name",
                                                    children: pkg.name
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: `package-status-badge ${isPublished ? 'published' : 'draft'}`,
                                                    children: isPublished ? 'PUBLISHED' : 'SAVED AS DRAFT'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "package-short-desc",
                                            children: pkg.shortDescription || 'Build strength with personal support'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "package-price-col",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "price-amount-row",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "price-val",
                                                    children: [
                                                        pkg.currencySymbol || "\xa3",
                                                        pkg.price
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "price-period",
                                                    children: ' / month'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "renewal-note",
                                            children: pkg.terms?.renewal || 'No automatic renewal'
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "package-features-grid",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "feature-tile-box",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "feature-icon-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dumbbellProgramSvg.ReactComponent), {
                                                className: "tile-svg"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "feature-tile-text",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    className: "feature-tile-title",
                                                    children: 'Personalized training program'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "feature-tile-subtitle",
                                                    children: 'A structured plan tailored to your goals.'
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "feature-tile-box",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "feature-icon-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inquiryChatSvg.ReactComponent), {
                                                className: "tile-svg"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "feature-tile-text",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    className: "feature-tile-title",
                                                    children: inquiriesCount === 1 ? '1 inquirie / week' : `${inquiriesCount} inquiries / week`
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "feature-tile-subtitle",
                                                    children: 'Detailed feedback on your progress'
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "feature-tile-box",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "feature-icon-wrapper",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoCheckinSvg.ReactComponent), {
                                                className: "tile-svg"
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "feature-tile-text",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    className: "feature-tile-title",
                                                    children: `${checkinsCount} x 15-min video check-ins`
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "feature-tile-subtitle",
                                                    children: 'Stay on track with regular support.'
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "package-card-action",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn-edit-package-white",
                                onClick: ()=>onEditPackage(pkg),
                                children: 'Edit Package'
                            })
                        })
                    ]
                }, pkg.id);
            })
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/assets/images/onboarding-trainer/dashboard/profile/packages/packages-list/dumbbell-program.svg":"7JWVP","src/assets/images/onboarding-trainer/dashboard/profile/packages/packages-list/inquiry-chat.svg":"fyjpK","src/assets/images/onboarding-trainer/dashboard/profile/packages/packages-list/video-checkin.svg":"ep1le","./PackagesListView.scss":"6aD9e","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7JWVP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDumbbellProgram);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDumbbellProgram = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 11,
        fill: "none",
        viewBox: "0 0 18 11",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M3.65.23C3.854.114 4.169 0 4.6 0s.746.114.95.23c.316.18.41.486.415.704C5.975 1.37 6 2.806 6 5.5s-.026 4.13-.035 4.566a.82.82 0 0 1-.415.704c-.204.116-.519.23-.95.23s-.746-.114-.95-.23a.82.82 0 0 1-.415-.704C3.225 9.63 3.2 8.194 3.2 5.5s.026-4.13.035-4.566A.82.82 0 0 1 3.65.23m10.7 0A1.9 1.9 0 0 0 13.4 0c-.431 0-.746.114-.95.23a.82.82 0 0 0-.415.704C12.025 1.37 12 2.806 12 5.5s.026 4.13.035 4.566a.82.82 0 0 0 .415.704c.204.116.519.23.95.23s.746-.114.95-.23a.82.82 0 0 0 .415-.704c.01-.436.035-1.872.035-4.566s-.026-4.13-.035-4.566A.82.82 0 0 0 14.35.23M1.2 1.897c-.264 0-.476.045-.638.105a.82.82 0 0 0-.538.758C.016 3.1 0 3.973 0 5.5s.016 2.4.024 2.74c.006.244.132.61.538.758.162.06.374.105.638.105s.476-.045.638-.105a.82.82 0 0 0 .538-.758c.008-.34.024-1.213.024-2.74s-.016-2.4-.024-2.74a.82.82 0 0 0-.538-.758 1.9 1.9 0 0 0-.638-.105m16.238.105a1.9 1.9 0 0 0-.638-.105c-.264 0-.476.045-.638.105a.82.82 0 0 0-.538.758c-.008.34-.024 1.213-.024 2.74s.016 2.4.024 2.74c.006.244.132.61.538.758.162.06.374.105.638.105s.476-.045.638-.105a.82.82 0 0 0 .538-.758C17.984 7.9 18 7.027 18 5.5s-.016-2.4-.024-2.74a.82.82 0 0 0-.538-.758M6.8 6.584V4.416c0-.36.31-.548.641-.575a9 9 0 0 1 .306-.02c.272-.014.683-.028 1.253-.028s.981.014 1.253.028q.204.01.306.02c.33.026.641.216.641.575v2.168c0 .36-.31.548-.641.575a9 9 0 0 1-.306.02c-.272.014-.683.028-1.253.028s-.981-.014-1.253-.028a9 9 0 0 1-.306-.02c-.33-.026-.641-.216-.641-.575",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fyjpK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgInquiryChat);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInquiryChat = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M14.333 7.667a6.666 6.666 0 0 1-6.666 6.666H1V7.667a6.667 6.667 0 1 1 13.333 0"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#0c1020",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.8,
                d: "M4.333 5.667h6m-6 2.666h6m-6 2.667h3.334"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ep1le":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgVideoCheckin);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgVideoCheckin = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 12,
        fill: "none",
        viewBox: "0 0 17 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M2.46 0A2.46 2.46 0 0 0 0 2.46v6.56a2.46 2.46 0 0 0 2.46 2.46h8.2a2.46 2.46 0 0 0 2.46-2.46v-1.3L15 9.6a.82.82 0 0 0 1.4-.58V2.46a.819.819 0 0 0-1.4-.58l-1.88 1.88v-1.3A2.46 2.46 0 0 0 10.66 0z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6aD9e":[function() {},{}],"f7J4Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PackageForm", ()=>PackageForm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _packagesService = require("src/api/services/packagesService");
var _customSelect = require("./CustomSelect");
var _dumbbellProgramSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/packages-list/dumbbell-program.svg");
var _inquiryChatSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/packages-list/inquiry-chat.svg");
var _videoCheckinSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/packages-list/video-checkin.svg");
var _calendarPeriodSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/calendar-period.svg");
var _documentPolicySvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/document-policy.svg");
var _noAutomaticRenewalSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/no-automatic-renewal.svg");
var _nutritionalAppleSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/nutritional-apple.svg");
var _lockSecuritySvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/lock-security.svg");
var _packageDetailsSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/package-details.svg");
var _inquiryOrangeSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/inquiry-orange.svg");
var _optionalExtrasSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/optional-extras.svg");
var _deliveryExpectationsSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/delivery-expectations.svg");
var _packageTermsSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/package-terms.svg");
var _checkmarkGreenSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/checkmark-green.svg");
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
var _appAlert = require("src/utils/appAlert");
var _appAlertDefault = parcelHelpers.interopDefault(_appAlert);
var _packageFormScss = require("./PackageForm.scss");
const PRESET_OPTIONS = (0, _packagesService.PACKAGE_PRESET_TEMPLATES).map((opt)=>opt.tier);
const READY_WITHIN_OPTIONS = [
    'Within 24 hours',
    'Within 48 hours',
    'Within 3 days',
    'Within 5 days',
    'Within 7 days'
];
const NUTRITIONAL_DELIVERY_OPTIONS = [
    'Within 24 hours',
    'Within 48 hours',
    'Within 3 days',
    'Within 5 days'
];
const getSavedDraft = (key)=>{
    try {
        const raw = localStorage.getItem(key);
        return raw ? JSON.parse(raw) : null;
    } catch  {
        return null;
    }
};
const PackageForm = ({ mode, initialData, initialTier, allPackages = [], onTierChange, onBack, onSave, onAutoSave, onUnpublishClick, onOpenTemplate, isSaving = false })=>{
    const { currentUser } = (0, _sessionStore.sessionStore)();
    const trainerId = currentUser?.uid || (0, _firebase.auth).currentUser?.uid || '';
    const draftStorageKey = `mini_pt_package_create_draft_${trainerId}`;
    // Read saved draft once during initial state computation for create mode
    const initialOrDraft = (0, _react.useMemo)(()=>{
        if (mode === 'create' && !initialData) {
            const saved = getSavedDraft(draftStorageKey);
            if (saved && (saved.name === 'Basic' || saved.price === 95)) {
                try {
                    localStorage.removeItem(draftStorageKey);
                } catch  {
                // ignore
                }
                return null;
            }
            return saved;
        }
        return initialData || null;
    }, [
        mode,
        initialData,
        draftStorageKey
    ]);
    const [draftId, setDraftId] = (0, _react.useState)(initialOrDraft?.id);
    const defaultTierConfig = (0, _packagesService.getPackageTemplateConfig)(initialOrDraft?.presetTier || initialTier);
    // Preset Tier
    const [presetTier, setPresetTier] = (0, _react.useState)(initialOrDraft?.presetTier || initialTier || defaultTierConfig.tier);
    const [templateId, setTemplateId] = (0, _react.useState)(initialOrDraft?.templateId || defaultTierConfig.templateId);
    // Form Fields - Blank by default, never prefilled with dummy text
    const [name, setName] = (0, _react.useState)(initialOrDraft?.name ?? '');
    const [shortDescription, setShortDescription] = (0, _react.useState)(initialOrDraft?.shortDescription ?? '');
    const [whoIsThisFor, setWhoIsThisFor] = (0, _react.useState)(initialOrDraft?.whoIsThisFor ?? '');
    const [price, setPrice] = (0, _react.useState)(initialOrDraft?.price !== undefined ? initialOrDraft.price : '');
    const [currency, setCurrency] = (0, _react.useState)(initialOrDraft?.currency || 'GBP');
    const [duration, setDuration] = (0, _react.useState)(initialOrDraft?.duration || '4 weeks/ 1 month');
    // Coaching & Communication
    const [inquiriesPerWeek, setInquiriesPerWeek] = (0, _react.useState)(initialOrDraft?.coaching?.inquiriesPerWeek ?? 1);
    const [checkInsPerWeek, setCheckInsPerWeek] = (0, _react.useState)(initialOrDraft?.coaching?.checkInsPerWeek ?? 1);
    // Optional Extras
    const [nutritionalPlan, setNutritionalPlan] = (0, _react.useState)(initialOrDraft?.optionalExtras?.nutritionalPlan !== undefined ? Boolean(initialOrDraft.optionalExtras.nutritionalPlan) : false);
    const [nutritionalGuidance, setNutritionalGuidance] = (0, _react.useState)(initialOrDraft?.optionalExtras?.nutritionalGuidance !== undefined ? Boolean(initialOrDraft.optionalExtras.nutritionalGuidance) : false);
    // Delivery & Expectations
    const [initialProgramReadyWithin, setInitialProgramReadyWithin] = (0, _react.useState)(initialOrDraft?.delivery?.initialProgramReadyWithin || '');
    const [nutritionalPlanDelivery, setNutritionalPlanDelivery] = (0, _react.useState)(initialOrDraft?.delivery?.nutritionalPlanDelivery || 'Within 3 days');
    const [isAutoSaving, setIsAutoSaving] = (0, _react.useState)(false);
    const isDirtyRef = (0, _react.useRef)(false);
    const abortControllerRef = (0, _react.useRef)(null);
    const debounceTimerRef = (0, _react.useRef)(null);
    const latestDraftRef = (0, _react.useRef)({});
    const markDirty = ()=>{
        isDirtyRef.current = true;
    };
    // Validation Errors
    const [errors, setErrors] = (0, _react.useState)({});
    // Field-level validation on blur
    const validateField = (fieldName, value)=>{
        const tempPayload = {
            name,
            shortDescription,
            whoIsThisFor,
            price: price === '' ? undefined : Number(price),
            currency,
            duration,
            presetTier,
            optionalExtras: {
                nutritionalPlan,
                nutritionalGuidance
            },
            delivery: {
                initialProgramReadyWithin,
                nutritionalPlanDelivery
            },
            [fieldName]: value
        };
        const { errors: allErrors } = (0, _packagesService.validatePackageClient)(tempPayload);
        setErrors((prev)=>{
            const next = {
                ...prev
            };
            if (allErrors[fieldName]) next[fieldName] = allErrors[fieldName];
            else delete next[fieldName];
            return next;
        });
    };
    // When changing preset tier in header
    const handlePresetChange = (newTier)=>{
        const tier = newTier;
        // Clear any pending debounced autosave from previous tier
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        if (abortControllerRef.current) abortControllerRef.current.abort();
        isDirtyRef.current = false;
        setIsAutoSaving(false);
        // Look for existing package matching this tier in allPackages
        const foundPkg = allPackages.find((p)=>p.presetTier.toLowerCase() === tier.toLowerCase());
        const tierConfig = (0, _packagesService.getPackageTemplateConfig)(tier);
        if (foundPkg) {
            // Package found -> set that package's data
            setDraftId(foundPkg.id);
            setPresetTier(foundPkg.presetTier);
            setTemplateId(foundPkg.templateId || tierConfig.templateId);
            setName(foundPkg.name ?? '');
            setShortDescription(foundPkg.shortDescription ?? '');
            setWhoIsThisFor(foundPkg.whoIsThisFor ?? '');
            setPrice(foundPkg.price !== undefined && foundPkg.price !== 0 ? foundPkg.price : foundPkg.price === 0 ? 0 : '');
            setCurrency(foundPkg.currency || 'GBP');
            setDuration(foundPkg.duration || '4 weeks/ 1 month');
            setInquiriesPerWeek(foundPkg.coaching?.inquiriesPerWeek ?? 1);
            setCheckInsPerWeek(foundPkg.coaching?.checkInsPerWeek ?? 1);
            setNutritionalPlan(Boolean(foundPkg.optionalExtras?.nutritionalPlan));
            setNutritionalGuidance(Boolean(foundPkg.optionalExtras?.nutritionalGuidance));
            setInitialProgramReadyWithin(foundPkg.delivery?.initialProgramReadyWithin || '');
            setNutritionalPlanDelivery(foundPkg.delivery?.nutritionalPlanDelivery || 'Within 3 days');
            setErrors({});
            isDirtyRef.current = false;
            onTierChange?.(tier, foundPkg.id);
        } else {
            // Package not found -> reset form data
            setDraftId(undefined);
            setPresetTier(tier);
            setTemplateId(tierConfig.templateId);
            setName('');
            setShortDescription('');
            setWhoIsThisFor('');
            setPrice('');
            setCurrency('GBP');
            setDuration('4 weeks/ 1 month');
            setInquiriesPerWeek(1);
            setCheckInsPerWeek(1);
            setNutritionalPlan(false);
            setNutritionalGuidance(false);
            setInitialProgramReadyWithin('');
            setNutritionalPlanDelivery('Within 3 days');
            setErrors({});
            isDirtyRef.current = false;
            onTierChange?.(tier, undefined);
        }
    };
    // Re-hydrate when initialData changes
    (0, _react.useEffect)(()=>{
        // If the user has active unsaved edits in progress, NEVER overwrite live inputs!
        if (isDirtyRef.current) {
            if (initialData?.id) setDraftId((prev)=>prev || initialData.id);
            return;
        }
        if (initialData) {
            if (initialData.id) setDraftId(initialData.id);
            const cfg = (0, _packagesService.getPackageTemplateConfig)(initialData.presetTier || initialTier);
            setPresetTier(initialData.presetTier || cfg.tier);
            setTemplateId(initialData.templateId || cfg.templateId);
            setName(initialData.name ?? '');
            setShortDescription(initialData.shortDescription ?? '');
            setWhoIsThisFor(initialData.whoIsThisFor ?? '');
            setPrice(initialData.price !== undefined && initialData.price !== 0 ? initialData.price : initialData.price === 0 ? 0 : '');
            setCurrency(initialData.currency || 'GBP');
            setDuration(initialData.duration || '4 weeks/ 1 month');
            setInquiriesPerWeek(initialData.coaching?.inquiriesPerWeek ?? 1);
            setCheckInsPerWeek(initialData.coaching?.checkInsPerWeek ?? 1);
            setNutritionalPlan(Boolean(initialData.optionalExtras?.nutritionalPlan));
            setNutritionalGuidance(Boolean(initialData.optionalExtras?.nutritionalGuidance));
            setInitialProgramReadyWithin(initialData.delivery?.initialProgramReadyWithin || '');
            setNutritionalPlanDelivery(initialData.delivery?.nutritionalPlanDelivery || 'Within 3 days');
            setErrors({});
        } else {
            const cfg = (0, _packagesService.getPackageTemplateConfig)(initialTier);
            setDraftId(undefined);
            setPresetTier(cfg.tier);
            setTemplateId(cfg.templateId);
            setName('');
            setShortDescription('');
            setWhoIsThisFor('');
            setPrice('');
            setCurrency('GBP');
            setDuration('4 weeks/ 1 month');
            setInquiriesPerWeek(1);
            setCheckInsPerWeek(1);
            setNutritionalPlan(false);
            setNutritionalGuidance(false);
            setInitialProgramReadyWithin('');
            setNutritionalPlanDelivery('Within 3 days');
            setErrors({});
        }
        // RESET dirty flag on load / initialData change - never autosave on mount!
        isDirtyRef.current = false;
        setIsAutoSaving(false);
        if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        if (abortControllerRef.current) abortControllerRef.current.abort();
    }, [
        initialData,
        initialTier
    ]);
    // Dynamic calculated start date note
    const getCalculatedStartDate = ()=>{
        const validation = (0, _packagesService.validateReadyWithinTimeline)(initialProgramReadyWithin);
        const daysToAdd = validation.isValid && validation.days ? validation.days : 3;
        const targetDate = new Date();
        targetDate.setDate(targetDate.getDate() + daysToAdd);
        return targetDate.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };
    // Stepper handlers
    const handleInquiriesChange = (delta)=>{
        markDirty();
        setInquiriesPerWeek((prev)=>Math.max(0, Math.min(10, prev + delta)));
    };
    const handleCheckInsChange = (delta)=>{
        markDirty();
        setCheckInsPerWeek((prev)=>Math.max(0, Math.min(10, prev + delta)));
    };
    // Get current uncommitted draft values (for navigating to document template without losing data)
    const getCurrentDraft = (0, _react.useCallback)((customStatus)=>{
        const effectiveStatus = customStatus || (mode === 'create' ? initialData?.status ?? 'draft' : initialData?.status ?? 'published');
        return {
            ...draftId ? {
                id: draftId
            } : initialData?.id ? {
                id: initialData.id
            } : {},
            templateId,
            name: name.trim(),
            presetTier,
            shortDescription: shortDescription.trim(),
            whoIsThisFor: whoIsThisFor.trim(),
            price: price === '' ? 0 : Number(price),
            currency,
            currencySymbol: (0, _packagesService.CURRENCY_SYMBOLS)[currency] || "\xa3",
            duration,
            coaching: {
                inquiriesPerWeek,
                checkInsPerWeek
            },
            optionalExtras: {
                nutritionalPlan,
                nutritionalGuidance
            },
            delivery: {
                initialProgramReadyWithin: initialProgramReadyWithin.trim() || 'Within 3 days',
                nutritionalPlanDelivery: nutritionalPlan ? nutritionalPlanDelivery : undefined
            },
            terms: {
                coachingPeriod: duration.includes('4 weeks') ? '4-week coaching period' : `${duration} coaching period`,
                renewal: 'No automatic renewal'
            },
            status: effectiveStatus
        };
    }, [
        mode,
        draftId,
        initialData,
        templateId,
        name,
        presetTier,
        shortDescription,
        whoIsThisFor,
        price,
        currency,
        duration,
        inquiriesPerWeek,
        checkInsPerWeek,
        nutritionalPlan,
        nutritionalGuidance,
        initialProgramReadyWithin,
        nutritionalPlanDelivery
    ]);
    // Debounced auto-save (2000ms debounce) for create & edit mode - ONLY triggers when user edits fields
    (0, _react.useEffect)(()=>{
        const currentDraft = getCurrentDraft('draft');
        latestDraftRef.current = currentDraft;
        if (!isDirtyRef.current) return;
        // 1. If a debounce timer is waiting, cancel it immediately
        if (debounceTimerRef.current) {
            clearTimeout(debounceTimerRef.current);
            debounceTimerRef.current = null;
        }
        // 2. If an API request is in-flight, cancel it immediately so stale response cannot overwrite new typing
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
        // 3. Immediately persist full draft to local storage
        try {
            localStorage.setItem(draftStorageKey, JSON.stringify(currentDraft));
        } catch (e) {
            console.error('Failed to auto-save package draft to localStorage', e);
        }
        // 4. Validate client data before sending to backend:
        const draftValidation = (0, _packagesService.validatePackageDraftClient)(currentDraft);
        if (!draftValidation.isValid) {
            setIsAutoSaving(false);
            return;
        }
        setIsAutoSaving(true);
        // 5. 2-second debounce timer
        debounceTimerRef.current = setTimeout(async ()=>{
            if (!onAutoSave) {
                setIsAutoSaving(false);
                return;
            }
            // Create a fresh AbortController for this in-flight network request
            const controller = new AbortController();
            abortControllerRef.current = controller;
            try {
                const draftToSave = latestDraftRef.current || getCurrentDraft('draft');
                const saved = await onAutoSave(draftToSave, controller.signal);
                if (controller.signal.aborted) return;
                if (saved && saved.id) {
                    setDraftId(saved.id);
                    try {
                        localStorage.setItem(draftStorageKey, JSON.stringify({
                            ...draftToSave,
                            id: saved.id
                        }));
                    } catch  {
                    // ignore
                    }
                }
            } catch (apiErr) {
                if (apiErr instanceof Error && (apiErr.name === 'AbortError' || apiErr.message.includes('aborted'))) return;
                console.warn('Direct API auto-save notice:', apiErr);
            } finally{
                if (!controller.signal.aborted) setIsAutoSaving(false);
            }
        }, 2000);
        return ()=>{
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
        };
    }, [
        getCurrentDraft,
        draftStorageKey,
        onAutoSave,
        draftId,
        name,
        presetTier,
        shortDescription,
        whoIsThisFor,
        price,
        currency,
        duration,
        inquiriesPerWeek,
        checkInsPerWeek,
        nutritionalPlan,
        nutritionalGuidance,
        initialProgramReadyWithin,
        nutritionalPlanDelivery
    ]);
    // Cleanup pending timer and in-flight request on unmount
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
            if (abortControllerRef.current) abortControllerRef.current.abort();
        };
    }, []);
    // Form Validation
    const validate = ()=>{
        const payloadForValidation = {
            name,
            shortDescription,
            whoIsThisFor,
            price: price === '' ? undefined : Number(price),
            presetTier,
            currency,
            duration,
            optionalExtras: {
                nutritionalPlan,
                nutritionalGuidance
            },
            delivery: {
                initialProgramReadyWithin,
                nutritionalPlanDelivery
            }
        };
        const result = (0, _packagesService.validatePackageClient)(payloadForValidation);
        setErrors(result.errors);
        return result.isValid;
    };
    // Submit Handler
    const handleSubmit = ()=>{
        if (!validate()) {
            (0, _appAlertDefault.default).error('Please fix the validation errors before publishing.');
            return;
        }
        const payload = {
            ...draftId ? {
                id: draftId
            } : initialData?.id ? {
                id: initialData.id
            } : {},
            templateId,
            name: name.trim(),
            presetTier,
            shortDescription: shortDescription.trim(),
            whoIsThisFor: whoIsThisFor.trim(),
            price: Number(price),
            currency,
            currencySymbol: (0, _packagesService.CURRENCY_SYMBOLS)[currency] || "\xa3",
            duration,
            coaching: {
                inquiriesPerWeek,
                checkInsPerWeek
            },
            optionalExtras: {
                nutritionalPlan,
                nutritionalGuidance
            },
            delivery: {
                initialProgramReadyWithin,
                nutritionalPlanDelivery: nutritionalPlan ? nutritionalPlanDelivery : undefined
            },
            terms: {
                coachingPeriod: duration.includes('4 weeks') ? '4-week coaching period' : `${duration} coaching period`,
                renewal: 'No automatic renewal'
            },
            status: 'published'
        };
        try {
            localStorage.removeItem(draftStorageKey);
        } catch  {
        // ignore
        }
        onSave(payload);
    };
    const handleBack = async ()=>{
        if (isDirtyRef.current) {
            if (debounceTimerRef.current) clearTimeout(debounceTimerRef.current);
            const currentDraft = getCurrentDraft('draft');
            const draftValidation = (0, _packagesService.validatePackageDraftClient)(currentDraft);
            if (draftValidation.isValid && onAutoSave) try {
                await onAutoSave(currentDraft);
            } catch (err) {
                console.warn('Immediate auto-save on back error:', err);
            }
        }
        onBack();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "package-form-page",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "package-form-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        className: "btn-form-back",
                        onClick: handleBack,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2.5",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                    points: "15 18 9 12 15 6"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                className: "form-title",
                                children: mode === 'create' ? 'Create package' : 'Edit package'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "form-subtitle",
                        children: 'Define the coaching and support your clients receive'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "package-form-layout",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-cards-column",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "form-card-header",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "card-heading-left",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "card-icon-pill",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _packageDetailsSvg.ReactComponent), {
                                                            className: "card-header-icon"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                        className: "card-title",
                                                        children: 'Package details'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "preset-selector-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customSelect.CustomSelect), {
                                                    variant: "pill",
                                                    value: presetTier,
                                                    options: PRESET_OPTIONS,
                                                    onChange: handlePresetChange,
                                                    ariaLabel: "Select package preset tier"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "card-instruction",
                                        children: 'Make your offer easy to understand'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "form-fields-stack",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "form-field-group",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        htmlFor: "package-name-input",
                                                        children: 'Package name*'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        id: "package-name-input",
                                                        type: "text",
                                                        className: `text-input ${errors.name ? 'has-error' : ''}`,
                                                        value: name,
                                                        maxLength: 50,
                                                        placeholder: "e.g. 1-on-1 Coaching",
                                                        onChange: (e)=>{
                                                            markDirty();
                                                            setName(e.target.value);
                                                            if (errors.name) setErrors((prev)=>{
                                                                const next = {
                                                                    ...prev
                                                                };
                                                                delete next.name;
                                                                return next;
                                                            });
                                                        },
                                                        onBlur: (e)=>{
                                                            const trimmed = e.target.value.trim();
                                                            setName(trimmed);
                                                            validateField('name', trimmed);
                                                        },
                                                        "aria-describedby": errors.name ? 'package-name-error' : undefined
                                                    }),
                                                    errors.name && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        id: "package-name-error",
                                                        className: "field-error-msg",
                                                        role: "alert",
                                                        children: errors.name
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "form-field-group",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        htmlFor: "package-desc-input",
                                                        children: 'Short description'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        id: "package-desc-input",
                                                        type: "text",
                                                        className: `text-input ${errors.shortDescription ? 'has-error' : ''}`,
                                                        value: shortDescription,
                                                        maxLength: 200,
                                                        placeholder: "Write a short description",
                                                        onChange: (e)=>{
                                                            markDirty();
                                                            setShortDescription(e.target.value);
                                                            if (errors.shortDescription) setErrors((prev)=>{
                                                                const next = {
                                                                    ...prev
                                                                };
                                                                delete next.shortDescription;
                                                                return next;
                                                            });
                                                        },
                                                        onBlur: (e)=>{
                                                            const trimmed = e.target.value.trim();
                                                            setShortDescription(trimmed);
                                                            validateField('shortDescription', trimmed);
                                                        },
                                                        "aria-describedby": errors.shortDescription ? 'package-desc-error' : undefined
                                                    }),
                                                    errors.shortDescription && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        id: "package-desc-error",
                                                        className: "field-error-msg",
                                                        role: "alert",
                                                        children: errors.shortDescription
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "form-field-group",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        htmlFor: "package-who-input",
                                                        children: 'Who is this for?'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        id: "package-who-input",
                                                        type: "text",
                                                        className: `text-input ${errors.whoIsThisFor ? 'has-error' : ''}`,
                                                        value: whoIsThisFor,
                                                        maxLength: 200,
                                                        placeholder: "e.g. Beginners building a consistent routine",
                                                        onChange: (e)=>{
                                                            markDirty();
                                                            setWhoIsThisFor(e.target.value);
                                                            if (errors.whoIsThisFor) setErrors((prev)=>{
                                                                const next = {
                                                                    ...prev
                                                                };
                                                                delete next.whoIsThisFor;
                                                                return next;
                                                            });
                                                        },
                                                        onBlur: (e)=>{
                                                            const trimmed = e.target.value.trim();
                                                            setWhoIsThisFor(trimmed);
                                                            validateField('whoIsThisFor', trimmed);
                                                        },
                                                        "aria-describedby": errors.whoIsThisFor ? 'package-who-error' : undefined
                                                    }),
                                                    errors.whoIsThisFor && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        id: "package-who-error",
                                                        className: "field-error-msg",
                                                        role: "alert",
                                                        children: errors.whoIsThisFor
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "form-row-3col",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "form-field-group price-field",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                                htmlFor: "package-price-input",
                                                                children: 'Price*'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: `price-input-wrapper ${errors.price ? 'has-error' : ''}`,
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "currency-prefix",
                                                                        children: (0, _packagesService.CURRENCY_SYMBOLS)[currency] || "\xa3"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                        id: "package-price-input",
                                                                        type: "text",
                                                                        inputMode: "decimal",
                                                                        className: "price-input",
                                                                        value: price === '' ? '' : price,
                                                                        placeholder: "0",
                                                                        maxLength: 8,
                                                                        onChange: (e)=>{
                                                                            markDirty();
                                                                            const inputVal = e.target.value.replace(/[^0-9.]/g, '');
                                                                            // Disallow multiple dots
                                                                            const parts = inputVal.split('.');
                                                                            if (parts.length > 2) return;
                                                                            const intPart = parts[0];
                                                                            const decPart = parts[1];
                                                                            // Limit integer part to 5 digits (up to 99999)
                                                                            if (intPart.length > 5) return;
                                                                            // Limit decimal part to 2 digits
                                                                            if (decPart !== undefined && decPart.length > 2) return;
                                                                            // Prevent numeric values exceeding 99999
                                                                            if (inputVal !== '' && inputVal !== '.' && Number(inputVal) > 99999) return;
                                                                            setPrice(inputVal);
                                                                            if (errors.price) setErrors((prev)=>{
                                                                                const next = {
                                                                                    ...prev
                                                                                };
                                                                                delete next.price;
                                                                                return next;
                                                                            });
                                                                        },
                                                                        onBlur: ()=>{
                                                                            const str = String(price).trim();
                                                                            if (!str) {
                                                                                setPrice('');
                                                                                validateField('price', undefined);
                                                                                return;
                                                                            }
                                                                            let cleaned = str;
                                                                            if (cleaned.endsWith('.')) cleaned = cleaned.slice(0, -1);
                                                                            if (cleaned === '' || isNaN(Number(cleaned))) {
                                                                                setPrice('');
                                                                                validateField('price', undefined);
                                                                                return;
                                                                            }
                                                                            setPrice(cleaned);
                                                                            validateField('price', Number(cleaned));
                                                                        },
                                                                        "aria-describedby": errors.price ? 'package-price-error' : undefined
                                                                    })
                                                                ]
                                                            }),
                                                            errors.price && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                id: "package-price-error",
                                                                className: "field-error-msg",
                                                                role: "alert",
                                                                children: errors.price
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "form-field-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                                htmlFor: "package-currency-select",
                                                                children: 'Currency'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customSelect.CustomSelect), {
                                                                id: "package-currency-select",
                                                                variant: "input",
                                                                fullWidth: true,
                                                                value: currency,
                                                                options: (0, _packagesService.VALID_CURRENCIES),
                                                                onChange: (val)=>{
                                                                    markDirty();
                                                                    setCurrency(val);
                                                                    validateField('currency', val);
                                                                },
                                                                ariaLabel: "Select currency"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "form-field-group",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                                htmlFor: "package-duration-select",
                                                                children: 'Duration'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customSelect.CustomSelect), {
                                                                id: "package-duration-select",
                                                                variant: "input",
                                                                fullWidth: true,
                                                                value: duration,
                                                                options: (0, _packagesService.VALID_DURATIONS),
                                                                onChange: (val)=>{
                                                                    markDirty();
                                                                    setDuration(val);
                                                                    validateField('duration', val);
                                                                },
                                                                ariaLabel: "Select duration"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "form-card-header",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "card-heading-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "card-icon-pill",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inquiryOrangeSvg.ReactComponent), {
                                                        className: "card-header-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    className: "card-title",
                                                    children: 'Coaching & communication'
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "stepper-rows-stack",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "stepper-control-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "stepper-label-col",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "stepper-title",
                                                                children: 'Inquiries / week*'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "stepper-desc",
                                                                children: 'A written summary of recent workouts and next steps.'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "stepper-widget",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                type: "button",
                                                                className: "btn-stepper-sub",
                                                                onClick: ()=>handleInquiriesChange(-1),
                                                                disabled: inquiriesPerWeek <= 0,
                                                                "aria-label": "Decrease inquiries per week",
                                                                children: "\u2212"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "stepper-value-display",
                                                                children: inquiriesPerWeek
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                type: "button",
                                                                className: "btn-stepper-add",
                                                                onClick: ()=>handleInquiriesChange(1),
                                                                disabled: inquiriesPerWeek >= 10,
                                                                "aria-label": "Increase inquiries per week",
                                                                children: "+"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "stepper-control-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "stepper-label-col",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "stepper-title",
                                                                children: 'Check-ins / week*'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "stepper-desc",
                                                                children: 'Each check-in can take up to 15 min.'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "stepper-widget",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                type: "button",
                                                                className: "btn-stepper-sub",
                                                                onClick: ()=>handleCheckInsChange(-1),
                                                                disabled: checkInsPerWeek <= 0,
                                                                "aria-label": "Decrease check-ins per week",
                                                                children: "\u2212"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "stepper-value-display",
                                                                children: checkInsPerWeek
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                type: "button",
                                                                className: "btn-stepper-add",
                                                                onClick: ()=>handleCheckInsChange(1),
                                                                disabled: checkInsPerWeek >= 10,
                                                                "aria-label": "Increase check-ins per week",
                                                                children: "+"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "form-card-header",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "card-heading-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "card-icon-pill",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _optionalExtrasSvg.ReactComponent), {
                                                        className: "card-header-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    className: "card-title",
                                                    children: 'Optional extras'
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "checkboxes-stack",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                className: "checkbox-item-row",
                                                htmlFor: "nutritional-plan-check",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        id: "nutritional-plan-check",
                                                        type: "checkbox",
                                                        className: "hidden-checkbox",
                                                        checked: nutritionalPlan,
                                                        onChange: (e)=>{
                                                            markDirty();
                                                            setNutritionalPlan(e.target.checked);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: `custom-checkbox-box ${nutritionalPlan ? 'checked' : ''}`,
                                                        children: nutritionalPlan && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            width: "12",
                                                            height: "12",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "#04051B",
                                                            strokeWidth: "3",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                                points: "20 6 9 17 4 12"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "checkbox-label-text",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "checkbox-title",
                                                                children: 'Nutritional plan'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "checkbox-desc",
                                                                children: 'A trainer-prepared plan shared with your client.'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                className: "checkbox-item-row",
                                                htmlFor: "nutritional-guidance-check",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                        id: "nutritional-guidance-check",
                                                        type: "checkbox",
                                                        className: "hidden-checkbox",
                                                        checked: nutritionalGuidance,
                                                        onChange: (e)=>{
                                                            markDirty();
                                                            setNutritionalGuidance(e.target.checked);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: `custom-checkbox-box ${nutritionalGuidance ? 'checked' : ''}`,
                                                        children: nutritionalGuidance && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                            width: "12",
                                                            height: "12",
                                                            viewBox: "0 0 24 24",
                                                            fill: "none",
                                                            stroke: "#04051B",
                                                            strokeWidth: "3",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                                points: "20 6 9 17 4 12"
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "checkbox-label-text",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "checkbox-title",
                                                                children: 'Nutritional guidance'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "checkbox-desc",
                                                                children: 'General food-habit guidance during reviews.'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "form-card-header",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "card-heading-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "card-icon-pill",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _deliveryExpectationsSvg.ReactComponent), {
                                                        className: "card-header-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    className: "card-title",
                                                    children: 'Delivery & expectations'
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "form-fields-stack",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "form-field-group",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        htmlFor: "initial-ready-within-select",
                                                        children: 'Initial program ready within*'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "delivery-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "delivery-select-box",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customSelect.CustomSelect), {
                                                                    id: "initial-ready-within-select",
                                                                    variant: "input",
                                                                    isEditable: true,
                                                                    value: initialProgramReadyWithin,
                                                                    options: READY_WITHIN_OPTIONS,
                                                                    placeholder: "e.g. Within 3 days",
                                                                    hasError: Boolean(errors.initialProgramReadyWithin),
                                                                    onChange: (val)=>{
                                                                        markDirty();
                                                                        // Strip minus signs and illegal symbols to prevent negative numbers & wrong values
                                                                        const sanitized = val.replace(/[-+!@#$%^&*()_=[\]{};':"\\|,.<>/?`~]/g, '');
                                                                        setInitialProgramReadyWithin(sanitized);
                                                                        if (errors.initialProgramReadyWithin) setErrors((prev)=>{
                                                                            const next = {
                                                                                ...prev
                                                                            };
                                                                            delete next.initialProgramReadyWithin;
                                                                            return next;
                                                                        });
                                                                    },
                                                                    onBlur: (val)=>{
                                                                        const trimmed = val.trim();
                                                                        if (!trimmed) {
                                                                            setInitialProgramReadyWithin('');
                                                                            setErrors((prev)=>({
                                                                                    ...prev,
                                                                                    initialProgramReadyWithin: 'Please select or enter when the initial program will be ready.'
                                                                                }));
                                                                            return;
                                                                        }
                                                                        const validation = (0, _packagesService.validateReadyWithinTimeline)(trimmed);
                                                                        if (!validation.isValid && validation.error) {
                                                                            const errorMsg = validation.error;
                                                                            setInitialProgramReadyWithin(trimmed);
                                                                            setErrors((prev)=>({
                                                                                    ...prev,
                                                                                    initialProgramReadyWithin: errorMsg
                                                                                }));
                                                                            return;
                                                                        }
                                                                        // Format valid input nicely
                                                                        const match = trimmed.match(/^(?:within\s+)?(\d+)\s*(days?|hours?|d|h)?$/i);
                                                                        if (match) {
                                                                            const count = parseInt(match[1], 10);
                                                                            const unit = match[2]?.toLowerCase();
                                                                            if (unit && (unit.startsWith('h') || unit === 'hours' || unit === 'hour')) setInitialProgramReadyWithin(`Within ${count} ${count === 1 ? 'hour' : 'hours'}`);
                                                                            else setInitialProgramReadyWithin(`Within ${count} ${count === 1 ? 'day' : 'days'}`);
                                                                        } else setInitialProgramReadyWithin(trimmed);
                                                                        setErrors((prev)=>{
                                                                            const next = {
                                                                                ...prev
                                                                            };
                                                                            delete next.initialProgramReadyWithin;
                                                                            return next;
                                                                        });
                                                                    },
                                                                    ariaLabel: "Initial program ready within",
                                                                    ariaDescribedBy: errors.initialProgramReadyWithin ? 'initial-ready-error' : undefined
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "delivery-date-note",
                                                                children: [
                                                                    getCalculatedStartDate(),
                                                                    ' will be considered the package start date'
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    errors.initialProgramReadyWithin && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        id: "initial-ready-error",
                                                        className: "field-error-msg",
                                                        role: "alert",
                                                        children: errors.initialProgramReadyWithin
                                                    })
                                                ]
                                            }),
                                            nutritionalPlan && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "form-field-group",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                        htmlFor: "nutritional-delivery-select",
                                                        children: 'Nutritional plan delivery'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "nutritional-select-box",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _customSelect.CustomSelect), {
                                                            id: "nutritional-delivery-select",
                                                            variant: "input",
                                                            value: nutritionalPlanDelivery,
                                                            options: NUTRITIONAL_DELIVERY_OPTIONS,
                                                            placeholder: "Set a time",
                                                            hasError: Boolean(errors.nutritionalPlanDelivery),
                                                            onChange: (val)=>{
                                                                markDirty();
                                                                setNutritionalPlanDelivery(val);
                                                                if (errors.nutritionalPlanDelivery) setErrors((prev)=>{
                                                                    const next = {
                                                                        ...prev
                                                                    };
                                                                    delete next.nutritionalPlanDelivery;
                                                                    return next;
                                                                });
                                                            },
                                                            ariaLabel: "Nutritional plan delivery",
                                                            ariaDescribedBy: errors.nutritionalPlanDelivery ? 'nutritional-delivery-error' : undefined
                                                        })
                                                    }),
                                                    errors.nutritionalPlanDelivery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        id: "nutritional-delivery-error",
                                                        className: "field-error-msg",
                                                        role: "alert",
                                                        children: errors.nutritionalPlanDelivery
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "form-card-header",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "card-heading-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "card-icon-pill",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _packageTermsSvg.ReactComponent), {
                                                        className: "card-header-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    className: "card-title",
                                                    children: 'Package terms'
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "card-instruction",
                                        children: 'These terms will be shown to clients before they accept your package.'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "terms-summary-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "term-info-tile",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarPeriodSvg.ReactComponent), {
                                                        className: "term-tile-icon"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "term-tile-label",
                                                        children: duration.includes('4 weeks') ? '4-week coaching period' : `${duration} coaching period`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "term-info-tile",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _noAutomaticRenewalSvg.ReactComponent), {
                                                        className: "term-tile-icon"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "term-tile-label",
                                                        children: 'No automatic renewal'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "terms-documents-list",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "doc-link-item",
                                                onClick: ()=>onOpenTemplate('checkin_policy', getCurrentDraft()),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "doc-link-left",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentPolicySvg.ReactComponent), {
                                                                className: "doc-icon"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "doc-name",
                                                                children: 'Check-in policy'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "doc-arrow",
                                                        children: "\u203A"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "doc-link-item",
                                                onClick: ()=>onOpenTemplate('contractual_terms', getCurrentDraft()),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "doc-link-left",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentPolicySvg.ReactComponent), {
                                                                className: "doc-icon"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "doc-name",
                                                                children: 'Contractual terms'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "doc-arrow",
                                                        children: "\u203A"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "doc-link-item",
                                                onClick: ()=>onOpenTemplate('cancellation_policy', getCurrentDraft()),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "doc-link-left",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _documentPolicySvg.ReactComponent), {
                                                                className: "doc-icon"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "doc-name",
                                                                children: 'Cancellation and unused policy'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "doc-arrow",
                                                        children: "\u203A"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "terms-disclaimer-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                width: "16",
                                                height: "16",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "#8e90a6",
                                                strokeWidth: "2",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                    points: "20 6 9 17 4 12"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Client review full terms before accepting their offer.'
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "preview-action-column",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "client-preview-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "preview-column-label",
                                        children: 'CLIENT PREVIEW'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "preview-pkg-name",
                                        children: name.trim() || 'Package Name'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "preview-pkg-desc",
                                        children: shortDescription.trim() || 'Package description will appear here'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "preview-price-block",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "preview-price-val",
                                                children: [
                                                    (0, _packagesService.CURRENCY_SYMBOLS)[currency] || "\xa3",
                                                    price !== '' && price !== undefined && !isNaN(Number(price)) ? Number(price).toLocaleString('en-GB', {
                                                        minimumFractionDigits: String(price).includes('.') ? String(price).split('.')[1].length : 0,
                                                        maximumFractionDigits: 2
                                                    }) : 0
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "preview-price-period",
                                                children: duration.includes('month') ? ' / month' : ` / ${duration}`
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "preview-renewal-badge",
                                                children: "One-time payment \u2022 No automatic renewal"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "preview-features-stack",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "preview-feature-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "feature-icon-box",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dumbbellProgramSvg.ReactComponent), {
                                                            className: "feature-svg"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "feature-texts",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "feature-title",
                                                                children: 'Personalized training program'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "feature-subtitle",
                                                                children: 'A structured plan tailored to your goals.'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "preview-feature-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "feature-icon-box",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inquiryChatSvg.ReactComponent), {
                                                            className: "feature-svg"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "feature-texts",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "feature-title",
                                                                children: inquiriesPerWeek === 1 ? '1 inquirie / week' : `${inquiriesPerWeek} inquiries / week`
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "feature-subtitle",
                                                                children: 'Detailed feedback on your progress'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "preview-feature-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "feature-icon-box",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoCheckinSvg.ReactComponent), {
                                                            className: "feature-svg"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "feature-texts",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "feature-title",
                                                                children: `${checkInsPerWeek} x 15-min video check-ins`
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "feature-subtitle",
                                                                children: 'Stay on track with regular support.'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            nutritionalPlan && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "preview-feature-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "feature-icon-box",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nutritionalAppleSvg.ReactComponent), {
                                                            className: "feature-svg"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "feature-texts",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "feature-title",
                                                                children: 'Nutritional plan'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: "feature-subtitle",
                                                                children: nutritionalPlanDelivery
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn-request-package-disabled",
                                        disabled: true,
                                        children: 'Request this package'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "preview-security-note",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lockSecuritySvg.ReactComponent), {
                                                className: "lock-icon"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'No payment until your trainer confirms,'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-action-buttons-wrap",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn-publish-orange",
                                        onClick: handleSubmit,
                                        disabled: isSaving,
                                        children: isSaving ? 'Saving...' : mode === 'create' ? 'Publish Package' : 'Publish Changes'
                                    }),
                                    mode === 'edit' && onUnpublishClick && (initialData?.status ?? 'published') === 'published' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn-unpublish-dark",
                                        onClick: onUnpublishClick,
                                        disabled: isSaving,
                                        children: 'Unpublish'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "autosave-indicator",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkGreenSvg.ReactComponent), {
                                                className: "autosave-check-icon"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: isAutoSaving ? 'Saving changes...' : 'All changes are saved automatically'
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/services/packagesService":"8L80X","./CustomSelect":"DX6Ur","src/assets/images/onboarding-trainer/dashboard/profile/packages/packages-list/dumbbell-program.svg":"7JWVP","src/assets/images/onboarding-trainer/dashboard/profile/packages/packages-list/inquiry-chat.svg":"fyjpK","src/assets/images/onboarding-trainer/dashboard/profile/packages/packages-list/video-checkin.svg":"ep1le","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/calendar-period.svg":"fwWHG","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/document-policy.svg":"cl4Fj","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/no-automatic-renewal.svg":"hiJkd","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/nutritional-apple.svg":"k9nhs","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/lock-security.svg":"ipU6d","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/package-details.svg":"7Gm5q","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/inquiry-orange.svg":"2YbSh","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/optional-extras.svg":"a97nA","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/delivery-expectations.svg":"8mHXb","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/package-terms.svg":"fPhsA","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/checkmark-green.svg":"hdQNR","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","src/utils/appAlert":"de4Mq","./PackageForm.scss":"48bg7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"DX6Ur":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CustomSelect", ()=>CustomSelect);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _dropdownChevronSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/dropdown-chevron.svg");
var _customSelectScss = require("./CustomSelect.scss");
const CustomSelect = ({ id, value, options, onChange, onBlur, placeholder = 'Select option', hasError = false, disabled = false, variant = 'input', fullWidth = false, ariaLabel, ariaDescribedBy, className = '', isEditable = false })=>{
    const [isOpen, setIsOpen] = (0, _react.useState)(false);
    const containerRef = (0, _react.useRef)(null);
    const inputRef = (0, _react.useRef)(null);
    // Normalize options
    const normalizedOptions = options.map((opt)=>typeof opt === 'string' ? {
            label: opt,
            value: opt
        } : opt);
    const selectedOption = normalizedOptions.find((opt)=>opt.value === value);
    // Close dropdown on click outside
    (0, _react.useEffect)(()=>{
        const handleOutsideClick = (e)=>{
            if (containerRef.current && !containerRef.current.contains(e.target)) setIsOpen(false);
        };
        if (isOpen) {
            document.addEventListener('mousedown', handleOutsideClick);
            document.addEventListener('touchstart', handleOutsideClick);
        }
        return ()=>{
            document.removeEventListener('mousedown', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        };
    }, [
        isOpen
    ]);
    // Keyboard accessibility
    const handleKeyDown = (e)=>{
        if (disabled) return;
        if (e.key === 'Escape') setIsOpen(false);
        else if (e.key === 'Enter') {
            if (!isEditable) {
                e.preventDefault();
                setIsOpen((prev)=>!prev);
            } else setIsOpen(false);
        } else if (e.key === ' ' && !isEditable) {
            e.preventDefault();
            setIsOpen((prev)=>!prev);
        } else if (e.key === 'ArrowDown') {
            e.preventDefault();
            if (!isOpen) setIsOpen(true);
            else {
                const currentIndex = normalizedOptions.findIndex((opt)=>opt.value === value);
                const nextIndex = (currentIndex + 1) % normalizedOptions.length;
                onChange(normalizedOptions[nextIndex].value);
            }
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            if (!isOpen) setIsOpen(true);
            else {
                const currentIndex = normalizedOptions.findIndex((opt)=>opt.value === value);
                const prevIndex = (currentIndex - 1 + normalizedOptions.length) % normalizedOptions.length;
                onChange(normalizedOptions[prevIndex].value);
            }
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        ref: containerRef,
        className: `custom-select-root variant-${variant} ${fullWidth ? 'full-width' : ''} ${isOpen ? 'is-open' : ''} ${hasError ? 'has-error' : ''} ${disabled ? 'is-disabled' : ''} ${isEditable ? 'is-editable-root' : ''} ${className}`,
        children: [
            isEditable ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `custom-select-trigger is-editable ${!value ? 'is-placeholder' : ''}`,
                onClick: ()=>{
                    if (!disabled) {
                        inputRef.current?.focus();
                        setIsOpen(true);
                    }
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        ref: inputRef,
                        id: id,
                        type: "text",
                        className: "trigger-editable-input",
                        value: value,
                        placeholder: placeholder,
                        disabled: disabled,
                        "aria-label": ariaLabel,
                        "aria-describedby": ariaDescribedBy,
                        "aria-haspopup": "listbox",
                        "aria-expanded": isOpen,
                        onChange: (e)=>{
                            onChange(e.target.value);
                            if (!isOpen) setIsOpen(true);
                        },
                        onFocus: ()=>{
                            if (!disabled) setIsOpen(true);
                        },
                        onBlur: (e)=>{
                            if (onBlur) onBlur(e.target.value);
                        },
                        onKeyDown: handleKeyDown
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "chevron-wrapper",
                        onClick: (e)=>{
                            e.stopPropagation();
                            if (!disabled) setIsOpen((prev)=>!prev);
                        },
                        "aria-label": "Toggle options",
                        tabIndex: -1,
                        disabled: disabled,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownChevronSvg.ReactComponent), {
                            className: `chevron-icon ${isOpen ? 'rotate' : ''}`
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                id: id,
                type: "button",
                className: `custom-select-trigger ${!value ? 'is-placeholder' : ''}`,
                onClick: ()=>!disabled && setIsOpen((prev)=>!prev),
                onKeyDown: handleKeyDown,
                disabled: disabled,
                "aria-haspopup": "listbox",
                "aria-expanded": isOpen,
                "aria-label": ariaLabel,
                "aria-describedby": ariaDescribedBy,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "trigger-label-text",
                        children: selectedOption ? selectedOption.label : placeholder
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "chevron-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownChevronSvg.ReactComponent), {
                            className: `chevron-icon ${isOpen ? 'rotate' : ''}`
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "custom-dropdown-popup",
                role: "listbox",
                "aria-label": ariaLabel,
                children: normalizedOptions.map((opt)=>{
                    const isSelected = opt.value === value;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `custom-dropdown-option ${isSelected ? 'is-selected' : ''}`,
                        role: "option",
                        "aria-selected": isSelected,
                        onMouseDown: (e)=>{
                            e.preventDefault();
                            onChange(opt.value);
                            setIsOpen(false);
                        },
                        onClick: ()=>{
                            onChange(opt.value);
                            setIsOpen(false);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "option-label",
                                children: opt.label
                            }),
                            isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                className: "selected-check-icon",
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "#ffa100",
                                strokeWidth: "2.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                    points: "20 6 9 17 4 12"
                                })
                            })
                        ]
                    }, opt.value);
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/dropdown-chevron.svg":"2TZ6V","./CustomSelect.scss":"eojLZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2TZ6V":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDropdownChevron);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDropdownChevron = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 8,
        fill: "none",
        viewBox: "0 0 14 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m1 1 6 6 6-6"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eojLZ":[function() {},{}],"fwWHG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCalendarPeriod);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCalendarPeriod = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M0 17c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3V9H0zM17 2h-2V1c0-.6-.4-1-1-1s-1 .4-1 1v1H7V1c0-.6-.4-1-1-1S5 .4 5 1v1H3C1.3 2 0 3.3 0 5v2h20V5c0-1.7-1.3-3-3-3"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cl4Fj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDocumentPolicy);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDocumentPolicy = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 20,
        fill: "none",
        viewBox: "0 0 18 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M17.68 5.014a3.85 3.85 0 0 0-.92-1.22l-3-2.72a4.15 4.15 0 0 0-2.39-1.07H5.21A5 5 0 0 0 0 4.864v10.3a5 5 0 0 0 3.31 4.53 4.7 4.7 0 0 0 1.92.3h7.56a5 5 0 0 0 5.21-4.86v-8.57a3.75 3.75 0 0 0-.32-1.55m-13-.4h3.26a1 1 0 0 1 0 2H4.68a1 1 0 0 1 0-2m8.7 10.71h-8.7a1 1 0 0 1 0-2h8.7a1 1 0 0 1 0 1.98zm0-4.35h-8.7a1 1 0 0 1 0-2h8.7a1 1 0 1 1 0 2m-.32-5.57a1.08 1.08 0 0 1-1.09-1.08v-2.65c.66.16 3.23 2.8 3.79 3.24q.25.212.42.49z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hiJkd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNoAutomaticRenewal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNoAutomaticRenewal = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 22,
        height: 22,
        fill: "none",
        viewBox: "0 0 22 22",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m12 15-3 3 3 3m-3-3h5a7 7 0 0 0 3-13.326M5 17.326A7 7 0 0 1 8 4h5m-3 3 3-3-3-3"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k9nhs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNutritionalApple);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNutritionalApple = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 16,
        fill: "none",
        viewBox: "0 0 14 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M10.935 14.952c-.848.822-1.774.692-2.665.303-.944-.398-1.809-.415-2.804 0-1.246.536-1.904.38-2.648-.303C-1.404 10.6-.782 3.972 4.012 3.73c1.169.061 1.982.64 2.665.693 1.022-.208 2-.805 3.09-.727 1.306.104 2.293.623 2.942 1.557-2.7 1.618-2.06 5.175.415 6.17-.493 1.298-1.134 2.587-2.198 3.539zM6.59 3.677C6.461 1.747 8.027.156 9.827 0c.251 2.232-2.025 3.894-3.236 3.677"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ipU6d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLockSecurity);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLockSecurity = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 15,
        fill: "none",
        viewBox: "0 0 14 15",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            fillOpacity: 0.7,
            d: "M6.75 0a4.5 4.5 0 0 1 4.497 4.331l.003.169H12a1.5 1.5 0 0 1 1.496 1.388L13.5 6v7.5a1.5 1.5 0 0 1-1.387 1.496L12 15H1.5a1.5 1.5 0 0 1-1.496-1.387L0 13.5V6a1.5 1.5 0 0 1 1.388-1.496L1.5 4.5h.75A4.5 4.5 0 0 1 6.75 0M12 6H1.5v7.5H12zM6.75 7.5a1.5 1.5 0 0 1 .85 2.735l-.1.064v.951a.75.75 0 0 1-1.495.088L6 11.25v-.951A1.5 1.5 0 0 1 6.75 7.5m0-6a3 3 0 0 0-3 3h6a3 3 0 0 0-3-3"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7Gm5q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPackageDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPackageDetails = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 15,
        fill: "none",
        viewBox: "0 0 15 15",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            fillRule: "evenodd",
            d: "M2.5 0A2.5 2.5 0 0 0 0 2.5v10A2.5 2.5 0 0 0 2.5 15h10a2.5 2.5 0 0 0 2.5-2.5v-10A2.5 2.5 0 0 0 12.5 0zm3.333 4.167a.833.833 0 0 1 .834-.834h5a.833.833 0 0 1 0 1.667h-5a.833.833 0 0 1-.834-.833m0 3.333a.833.833 0 0 1 .834-.833h5a.833.833 0 0 1 0 1.666h-5a.833.833 0 0 1-.834-.833m0 3.333A.833.833 0 0 1 6.667 10h5a.833.833 0 0 1 0 1.667h-5a.833.833 0 0 1-.834-.834m-2.5-7.5a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667M2.5 7.5a.833.833 0 1 1 1.667 0 .833.833 0 0 1-1.667 0m.833 2.5a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2YbSh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgInquiryOrange);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInquiryOrange = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            fillRule: "evenodd",
            d: "M14.333 7.667a6.666 6.666 0 0 1-6.666 6.666H1V7.667a6.667 6.667 0 1 1 13.333 0m-10-2.9h6a.9.9 0 0 1 0 1.8h-6a.9.9 0 0 1 0-1.8m0 2.666h6a.9.9 0 0 1 0 1.8h-6a.9.9 0 0 1 0-1.8m0 2.667h3.334a.9.9 0 0 1 0 1.8H4.333a.9.9 0 0 1 0-1.8",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a97nA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOptionalExtras);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOptionalExtras = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 14,
        fill: "none",
        viewBox: "0 0 15 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M7.134 11.417 3.676 13.5a.76.76 0 0 1-.48.125.8.8 0 0 1-.437-.167 1 1 0 0 1-.292-.364.73.73 0 0 1-.041-.49l.916-3.937L.28 6.02a.8.8 0 0 1-.26-.428.89.89 0 0 1 .28-.843.86.86 0 0 1 .46-.187l4.04-.355L6.364.5a.75.75 0 0 1 .324-.375A.9.9 0 0 1 7.134 0q.228 0 .448.125A.75.75 0 0 1 7.905.5l1.562 3.708 4.042.354q.291.042.458.188a.9.9 0 0 1 .25.375q.084.23.032.47a.8.8 0 0 1-.26.426l-3.063 2.646.916 3.937a.73.73 0 0 1-.041.49 1 1 0 0 1-.292.364.8.8 0 0 1-.437.167.75.75 0 0 1-.48-.125z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8mHXb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDeliveryExpectations);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDeliveryExpectations = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M14.825.062a1.07 1.07 0 0 1 1.364 1.364L11.25 15.535c-.32.915-1.595.966-1.989.08l-2.382-5.36 3.353-3.354a.625.625 0 0 0-.883-.883L5.996 9.37.636 6.99c-.886-.394-.834-1.669.08-1.99z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fPhsA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPackageTerms);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPackageTerms = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 17,
        fill: "none",
        viewBox: "0 0 15 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M14.733 4.179a3.2 3.2 0 0 0-.766-1.017l-2.5-2.267A3.46 3.46 0 0 0 9.475.004H4.342A4.167 4.167 0 0 0 0 4.054v8.583a4.17 4.17 0 0 0 2.758 3.775c.51.194 1.055.28 1.6.25h6.3A4.167 4.167 0 0 0 15 12.612V5.47a3.1 3.1 0 0 0-.267-1.291M3.9 3.845h2.717a.833.833 0 0 1 0 1.667H3.9a.833.833 0 1 1 0-1.667m7.25 8.925H3.9a.833.833 0 1 1 0-1.666h7.25a.834.834 0 0 1 0 1.65zm0-3.625H3.9a.833.833 0 0 1 0-1.666h7.25a.833.833 0 0 1 0 1.666m-.267-4.641a.9.9 0 0 1-.908-.9V1.395c.55.134 2.692 2.334 3.158 2.7q.209.177.35.409z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hdQNR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckmarkGreen);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckmarkGreen = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 13,
        fill: "none",
        viewBox: "0 0 18 13",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#7CC350",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M17 1 6 12 1 7"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"48bg7":[function() {},{}],"1s1dd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnpublishPackageModal", ()=>UnpublishPackageModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _miniPtCareMp4 = require("url:src/assets/videos/mini-pt-care.mp4");
var _miniPtCareMp4Default = parcelHelpers.interopDefault(_miniPtCareMp4);
var _unpublishPackageModalScss = require("./UnpublishPackageModal.scss");
const UnpublishPackageModal = ({ isOpen, onCancel, onConfirm, isPending = false })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        footer: null,
        onCancel: onCancel,
        centered: true,
        width: 460,
        closeIcon: null,
        rootClassName: "unpublish-package-modal",
        className: "unpublish-package-modal",
        styles: {
            mask: {
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(6, 7, 35, 0.8)'
            },
            container: {
                background: 'linear-gradient(180deg, #101438 0%, #070924 100%)',
                backgroundColor: '#0c0f2b',
                border: '1px solid rgba(255, 255, 255, 0.12)',
                borderRadius: '20px',
                boxShadow: '0 24px 48px rgba(0, 0, 0, 0.6)',
                padding: '36px 32px 32px',
                color: '#ffffff',
                overflow: 'hidden'
            },
            body: {
                padding: 0,
                background: 'transparent'
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "unpublish-modal-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "unpublish-icon-wrapper",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                            src: (0, _miniPtCareMp4Default.default),
                            autoPlay: true,
                            loop: true,
                            muted: true,
                            playsInline: true,
                            className: "unpublish-video-orb"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "minipt-inner-text",
                            children: 'miniPT'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "unpublish-modal-title",
                    children: "Are you sure you want to unpublish your package? Clients won\u2019t be able to buy your services anymore."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "unpublish-modal-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            className: "btn-go-back-outline",
                            onClick: onCancel,
                            disabled: isPending,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    className: "arrow-left-icon",
                                    width: "16",
                                    height: "16",
                                    viewBox: "0 0 16 16",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M12.6667 8H3.33334M3.33334 8L8.00001 12.6667M3.33334 8L8.00001 3.33334",
                                        stroke: "currentColor",
                                        strokeWidth: "1.75",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: 'No, Go Back to Edit'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-confirm-unpublish-white",
                            onClick: onConfirm,
                            disabled: isPending,
                            children: isPending ? 'Unpublishing...' : 'Yes, Unpublish'
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"url:src/assets/videos/mini-pt-care.mp4":"5knEg","./UnpublishPackageModal.scss":"k2E0z","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k2E0z":[function() {},{}],"bN8Ok":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DocumentTemplateView", ()=>DocumentTemplateView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetDocumentTemplates = require("src/api/queries/useGetDocumentTemplates");
var _packagesService = require("src/api/services/packagesService");
var _documentTemplateViewScss = require("./DocumentTemplateView.scss");
const DocumentTemplateView = ({ type, onBack })=>{
    const { data: templatesMap, isLoading } = (0, _useGetDocumentTemplates.useGetDocumentTemplates)();
    const config = templatesMap?.[type] || (0, _packagesService.DEFAULT_DOCUMENT_TEMPLATES)[type] || (0, _packagesService.DEFAULT_DOCUMENT_TEMPLATES).contractual_terms;
    (0, _react.useEffect)(()=>{
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'instant'
        });
        const dashboardMain = document.querySelector('.dashboard-main');
        if (dashboardMain) dashboardMain.scrollTop = 0;
        const packagesContainer = document.querySelector('.packages-container');
        if (packagesContainer) packagesContainer.scrollTop = 0;
    }, [
        type
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "document-template-view",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "template-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        className: "btn-template-back",
                        onClick: onBack,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2.5",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                    points: "15 18 9 12 15 6"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                className: "template-main-title",
                                children: config.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "template-subtitle",
                        children: config.subtitle
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "template-content-card",
                children: [
                    isLoading && !templatesMap ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "template-loading-state",
                        style: {
                            padding: '40px',
                            textAlign: 'center',
                            color: '#94a3b8'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: 'Loading terms...'
                        })
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "clauses-list",
                        children: config.clauses.map((clause)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "clause-item",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                        className: "clause-title",
                                        children: [
                                            clause.number,
                                            ". ",
                                            clause.title
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "clause-text",
                                        children: clause.content
                                    })
                                ]
                            }, clause.number))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "template-card-footer",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "footer-meta-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "meta-label",
                                        children: 'Last updated'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "meta-value",
                                        children: config.lastUpdated
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "footer-meta-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "meta-label",
                                        children: 'Version'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "meta-value",
                                        children: config.version
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/queries/useGetDocumentTemplates":"1ualD","src/api/services/packagesService":"8L80X","./DocumentTemplateView.scss":"cpwu4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1ualD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "documentTemplatesQueryKey", ()=>documentTemplatesQueryKey);
parcelHelpers.export(exports, "useGetDocumentTemplates", ()=>useGetDocumentTemplates);
var _reactQuery = require("@tanstack/react-query");
var _packagesService = require("../services/packagesService");
const documentTemplatesQueryKey = [
    'document-templates'
];
function useGetDocumentTemplates() {
    return (0, _reactQuery.useQuery)({
        queryKey: documentTemplatesQueryKey,
        queryFn: async ()=>{
            return (0, _packagesService.packagesService).getDocumentTemplates();
        },
        initialData: (0, _packagesService.DEFAULT_DOCUMENT_TEMPLATES),
        staleTime: 1800000
    });
}

},{"@tanstack/react-query":"lWWNx","../services/packagesService":"8L80X","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cpwu4":[function() {},{}],"camCS":[function() {},{}],"5s4Rm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SETTINGS_OPTIONS", ()=>SETTINGS_OPTIONS);
parcelHelpers.export(exports, "resolveSettingsSectionId", ()=>resolveSettingsSectionId);
parcelHelpers.export(exports, "TrainerSettings", ()=>TrainerSettings);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _scheduleSettings = require("./ScheduleSettings");
var _settingsComingSoon = require("./SettingsComingSoon");
var _trainerSettingsScss = require("./TrainerSettings.scss");
const SETTINGS_OPTIONS = [
    {
        id: 'account-details',
        label: 'Account details',
        description: 'Manage your personal information, profile identification, and contact info.',
        icon: 'user'
    },
    {
        id: 'email',
        label: 'Email',
        description: 'Update your login email address, notification emails, and delivery settings.',
        icon: 'email'
    },
    {
        id: 'password-security',
        label: 'Password & Security',
        description: 'Manage your password, two-factor authentication (2FA), and active logins.',
        icon: 'lock'
    },
    {
        id: 'notifications',
        label: 'Notifications',
        description: 'Configure in-app, email, and push notification preferences for client activities.',
        icon: 'bell'
    },
    {
        id: 'schedule',
        label: 'Schedule',
        description: 'Manage your working hours, blocked dates, and automated AI responses.',
        icon: 'schedule'
    },
    {
        id: 'privacy-data',
        label: 'Privacy & Data',
        description: 'Control your data sharing preferences, analytics consent, and export your data.',
        icon: 'shield'
    },
    {
        id: 'business-payments',
        label: 'Business & Payments',
        description: 'View your Stripe Connect payout account, invoice history, and banking details.',
        icon: 'card'
    },
    {
        id: 'delete-account',
        label: 'Delete Account',
        description: 'Permanently remove your trainer account, client associations, and personal data.',
        icon: 'trash'
    }
];
const resolveSettingsSectionId = (rawQuery)=>{
    if (!rawQuery) return 'schedule';
    const cleaned = rawQuery.trim().toLowerCase().replace(/[\s_]+/g, '-');
    // Exact ID match
    const exact = SETTINGS_OPTIONS.find((opt)=>opt.id === cleaned);
    if (exact) return exact.id;
    // Flexible alias matching
    const aliases = {
        account: 'account-details',
        'account-detail': 'account-details',
        accountdetails: 'account-details',
        'account-details': 'account-details',
        email: 'email',
        password: 'password-security',
        security: 'password-security',
        'password-security': 'password-security',
        passwordsecurity: 'password-security',
        notification: 'notifications',
        notifications: 'notifications',
        schedule: 'schedule',
        schedules: 'schedule',
        privacy: 'privacy-data',
        data: 'privacy-data',
        'privacy-data': 'privacy-data',
        privacydata: 'privacy-data',
        business: 'business-payments',
        payments: 'business-payments',
        payment: 'business-payments',
        'business-payments': 'business-payments',
        businesspayments: 'business-payments',
        delete: 'delete-account',
        'delete-account': 'delete-account',
        deleteaccount: 'delete-account'
    };
    if (aliases[cleaned]) return aliases[cleaned];
    // Label match
    const labelMatch = SETTINGS_OPTIONS.find((opt)=>opt.label.toLowerCase() === rawQuery.trim().toLowerCase());
    if (labelMatch) return labelMatch.id;
    return 'schedule';
};
const TrainerSettings = ()=>{
    const [searchParams, setSearchParams] = (0, _reactRouterDom.useSearchParams)();
    const tabParam = searchParams.get('tab');
    const rawSectionParam = searchParams.get('section') || searchParams.get('subtab') || searchParams.get('subTab') || searchParams.get('setting') || (tabParam !== 'settings' ? tabParam : null);
    const activeSectionId = resolveSettingsSectionId(rawSectionParam);
    // Synchronize URL with canonical query: ?tab=settings&section=<sectionId>
    (0, _react.useEffect)(()=>{
        const currentTab = searchParams.get('tab');
        const currentSection = searchParams.get('section');
        // If on settings tab or arrived via section query, ensure both tab=settings and section are present
        if (currentTab === 'settings' || !currentTab) {
            if (currentSection !== activeSectionId) setSearchParams((prev)=>{
                const next = new URLSearchParams(prev);
                next.set('tab', 'settings');
                next.set('section', activeSectionId);
                next.delete('subtab');
                next.delete('subTab');
                next.delete('setting');
                return next;
            }, {
                replace: true
            });
        }
    }, [
        searchParams,
        setSearchParams,
        activeSectionId
    ]);
    const handleSelectSection = (sectionId)=>{
        setSearchParams((prev)=>{
            const next = new URLSearchParams(prev);
            next.set('tab', 'settings');
            next.set('section', sectionId);
            next.delete('subtab');
            next.delete('subTab');
            next.delete('setting');
            return next;
        });
    };
    const currentOption = SETTINGS_OPTIONS.find((opt)=>opt.id === activeSectionId) || SETTINGS_OPTIONS[4];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "trainer-settings-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "trainer-settings-layout",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("aside", {
                    className: "trainer-settings-sidebar",
                    "aria-label": "Settings navigation",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("nav", {
                        className: "settings-nav-list",
                        children: SETTINGS_OPTIONS.map((option)=>{
                            const isActive = option.id === activeSectionId;
                            const isDelete = option.id === 'delete-account';
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: `settings-nav-item ${isActive ? 'active' : ''} ${isDelete ? 'delete-item' : ''}`,
                                onClick: ()=>handleSelectSection(option.id),
                                "aria-current": isActive ? 'page' : undefined,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "nav-item-label",
                                    children: option.label
                                })
                            }, option.id);
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("main", {
                    className: "trainer-settings-main-content",
                    children: activeSectionId === 'schedule' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _scheduleSettings.ScheduleSettings), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _settingsComingSoon.SettingsComingSoon), {
                        option: currentOption
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./ScheduleSettings":"hiTSk","./SettingsComingSoon":"1G4n0","./TrainerSettings.scss":"27rtW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hiTSk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ScheduleSettings", ()=>ScheduleSettings);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _timezoneUtils = require("src/screens/OnboardingTrainer/screens/Schedule/utils/timezoneUtils");
var _timeSlotPicker = require("src/screens/OnboardingTrainer/screens/Schedule/components/TimeSlotPicker");
var _timezoneSelector = require("src/screens/OnboardingTrainer/screens/Schedule/components/TimezoneSelector");
var _schedule = require("src/screens/OnboardingTrainer/screens/Schedule/Schedule");
var _useGetTrainerSchedule = require("src/api/queries/useGetTrainerSchedule");
var _useUpdateTrainerSchedule = require("src/api/mutations/useUpdateTrainerSchedule");
var _sessionStore = require("src/store/sessionStore");
var _authUtils = require("src/utils/authUtils");
var _appAlert = require("src/utils/appAlert");
var _appAlertDefault = parcelHelpers.interopDefault(_appAlert);
var _connectCalendarModal = require("./ConnectCalendarModal/ConnectCalendarModal");
var _unavailableDatesModal = require("./UnavailableDatesModal/UnavailableDatesModal");
var _scheduleSettingsScss = require("./ScheduleSettings.scss");
const settingsModalStyles = {
    mask: {
        backdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(6, 7, 35, 0.8)'
    },
    container: {
        background: 'linear-gradient(180deg, #101438 0%, #070924 100%)',
        backgroundColor: '#0c0f2b',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        borderRadius: '20px',
        boxShadow: '0 24px 48px rgba(0, 0, 0, 0.6)',
        padding: '32px 28px',
        color: '#ffffff',
        overflow: 'hidden'
    },
    body: {
        padding: 0,
        background: 'transparent'
    }
};
const ScheduleSettings = ()=>{
    const token = (0, _sessionStore.sessionStore)((s)=>s.token);
    const userId = (0, _authUtils.getUserIdFromToken)(token);
    // Timezone and Weekly Schedule state
    const [timezone, setTimezone] = (0, _react.useState)(()=>(0, _timezoneUtils.getBrowserTimezone)() || 'UTC');
    const [schedule, setSchedule] = (0, _react.useState)((0, _timezoneUtils.DEFAULT_WEEKLY_SCHEDULE));
    const [errorMsg, setErrorMsg] = (0, _react.useState)('');
    const [dayErrors, setDayErrors] = (0, _react.useState)({});
    // AI Responses toggle state
    const [aiResponsesEnabled, setAiResponsesEnabled] = (0, _react.useState)(true);
    // Confirmation modal state for turning off an active day
    const [confirmModal, setConfirmModal] = (0, _react.useState)({
        isOpen: false,
        dayKey: null
    });
    // Conflict modal state when updating schedule
    const [conflictModal, setConflictModal] = (0, _react.useState)({
        isOpen: false,
        conflicts: []
    });
    // Calendar connect modal state
    const [calendarModalOpen, setCalendarModalOpen] = (0, _react.useState)(false);
    const [connectedCalendar, setConnectedCalendar] = (0, _react.useState)(null);
    // Unavailable dates modal state
    const [unavailableModalOpen, setUnavailableModalOpen] = (0, _react.useState)(false);
    const [focusedDateForModal, setFocusedDateForModal] = (0, _react.useState)(null);
    const [unavailableDatesList, setUnavailableDatesList] = (0, _react.useState)([]);
    // Queries and mutations
    const { data: existingScheduleData, isLoading: isScheduleLoading } = (0, _useGetTrainerSchedule.useGetTrainerSchedule)(userId || undefined);
    const { mutate: updateSchedule, mutateAsync: updateScheduleAsync, isPending: isUpdatingSchedule } = (0, _useUpdateTrainerSchedule.useUpdateTrainerSchedule)();
    // Hydrate from existing backend data
    (0, _react.useEffect)(()=>{
        if (existingScheduleData?.data) {
            if (existingScheduleData.data.timezone) setTimezone(existingScheduleData.data.timezone);
            if (existingScheduleData.data.weekly_schedule && Object.keys(existingScheduleData.data.weekly_schedule).length > 0) setSchedule({
                ...(0, _timezoneUtils.DEFAULT_WEEKLY_SCHEDULE),
                ...existingScheduleData.data.weekly_schedule
            });
            if (typeof existingScheduleData.data.ai_responses_enabled === 'boolean') setAiResponsesEnabled(existingScheduleData.data.ai_responses_enabled);
            if (Array.isArray(existingScheduleData.data.unavailable_dates)) setUnavailableDatesList(existingScheduleData.data.unavailable_dates);
            if (existingScheduleData.data.connected_calendar) setConnectedCalendar(existingScheduleData.data.connected_calendar);
        }
    }, [
        existingScheduleData
    ]);
    // Handle Day Toggle
    const handleToggleDay = (dayKey)=>{
        setDayErrors((prev)=>{
            const next = {
                ...prev
            };
            delete next[dayKey];
            return next;
        });
        const currentDay = schedule?.[dayKey] || (0, _timezoneUtils.DEFAULT_WEEKLY_SCHEDULE)[dayKey];
        if (currentDay.enabled) {
            if (currentDay.slots && currentDay.slots.length > 0) {
                setConfirmModal({
                    isOpen: true,
                    dayKey
                });
                return;
            }
            setSchedule((prev)=>({
                    ...prev,
                    [dayKey]: {
                        ...prev?.[dayKey] || (0, _timezoneUtils.DEFAULT_WEEKLY_SCHEDULE)[dayKey],
                        enabled: false
                    }
                }));
        } else {
            const defaultSlots = currentDay.slots && currentDay.slots.length > 0 ? currentDay.slots : [
                {
                    id: `slot-${dayKey}-1`,
                    start: '09:00',
                    end: '17:00'
                }
            ];
            setSchedule((prev)=>({
                    ...prev,
                    [dayKey]: {
                        enabled: true,
                        slots: defaultSlots
                    }
                }));
        }
    };
    // Confirm disabling day
    const handleConfirmDisable = ()=>{
        if (confirmModal.dayKey) {
            const dayKey = confirmModal.dayKey;
            setDayErrors((prev)=>{
                const next = {
                    ...prev
                };
                delete next[dayKey];
                return next;
            });
            setSchedule((prev)=>({
                    ...prev,
                    [dayKey]: {
                        enabled: false,
                        slots: []
                    }
                }));
        }
        setConfirmModal({
            isOpen: false,
            dayKey: null
        });
    };
    // Add slot to day
    const handleAddSlot = (dayKey)=>{
        const day = schedule[dayKey];
        if (day.slots.length >= (0, _schedule.MAX_SLOTS_PER_DAY)) {
            setDayErrors((prev)=>({
                    ...prev,
                    [dayKey]: `Maximum ${0, _schedule.MAX_SLOTS_PER_DAY} slots allowed per day.`
                }));
            return;
        }
        const sorted = (0, _timezoneUtils.sortSlots)(day.slots);
        const currentCount = sorted.length;
        const nextCount = currentCount + 1;
        const currentPattern = (0, _schedule.DEFAULT_SLOT_PROGRESSION)[currentCount];
        const nextPattern = (0, _schedule.DEFAULT_SLOT_PROGRESSION)[nextCount];
        const isMatchingDefaultPattern = Boolean(currentPattern && nextPattern) && sorted.every((slot, idx)=>slot.start === currentPattern[idx]?.start && slot.end === currentPattern[idx]?.end);
        let updatedSlots = [];
        if (isMatchingDefaultPattern && nextPattern) updatedSlots = nextPattern.map((slotDef, idx)=>({
                id: sorted[idx]?.id || `slot-${dayKey}-${Date.now()}-${idx + 1}`,
                start: slotDef.start,
                end: slotDef.end
            }));
        else {
            const lastSlot = sorted[sorted.length - 1];
            let newStart = '13:00';
            let newEnd = '17:00';
            if (lastSlot) {
                const lastEndMin = (0, _timezoneUtils.timeToMinutes)(lastSlot.end);
                if (lastEndMin + 60 <= 1440) {
                    newStart = (0, _timezoneUtils.minutesToTime)(lastEndMin);
                    newEnd = (0, _timezoneUtils.minutesToTime)(Math.min(1440, lastEndMin + 240));
                } else {
                    newStart = '08:00';
                    newEnd = '12:00';
                }
            }
            const hasOverlap = sorted.some((s)=>(0, _timezoneUtils.doSlotsOverlap)(s.start, s.end, newStart, newEnd));
            if (hasOverlap) {
                let foundStart = null;
                for(let m = 0; m <= 1380; m += 30){
                    const testStart = (0, _timezoneUtils.minutesToTime)(m);
                    const testEnd = (0, _timezoneUtils.minutesToTime)(m + 60);
                    if (!sorted.some((s)=>(0, _timezoneUtils.doSlotsOverlap)(s.start, s.end, testStart, testEnd))) {
                        foundStart = m;
                        break;
                    }
                }
                if (foundStart !== null) {
                    newStart = (0, _timezoneUtils.minutesToTime)(foundStart);
                    newEnd = (0, _timezoneUtils.minutesToTime)(foundStart + 60);
                } else {
                    setDayErrors((prev)=>({
                            ...prev,
                            [dayKey]: 'No available non-overlapping time slot left on this day.'
                        }));
                    return;
                }
            }
            const newSlot = {
                id: `slot-${dayKey}-${Date.now()}`,
                start: newStart,
                end: newEnd
            };
            updatedSlots = (0, _timezoneUtils.sortSlots)([
                ...day.slots,
                newSlot
            ]);
        }
        const err = (0, _timezoneUtils.validateDaySlots)(updatedSlots);
        setDayErrors((prev)=>{
            const next = {
                ...prev
            };
            if (err) next[dayKey] = err;
            else delete next[dayKey];
            return next;
        });
        setSchedule((prev)=>({
                ...prev,
                [dayKey]: {
                    ...prev[dayKey],
                    slots: updatedSlots
                }
            }));
    };
    // Remove slot from day
    const handleRemoveSlot = (dayKey, slotId)=>{
        const day = schedule[dayKey];
        const updatedSlots = day.slots.filter((s)=>s.id !== slotId);
        const err = (0, _timezoneUtils.validateDaySlots)(updatedSlots);
        setDayErrors((prev)=>{
            const next = {
                ...prev
            };
            if (err) next[dayKey] = err;
            else delete next[dayKey];
            return next;
        });
        setSchedule((prev)=>({
                ...prev,
                [dayKey]: {
                    ...prev[dayKey],
                    slots: updatedSlots
                }
            }));
    };
    // Handle slot time change
    const handleSlotChange = (dayKey, slotId, field, newValue)=>{
        const day = schedule[dayKey];
        const targetSlot = day.slots.find((s)=>s.id === slotId);
        if (!targetSlot) return;
        const updatedStart = field === 'start' ? newValue : targetSlot.start;
        let updatedEnd = field === 'end' ? newValue : targetSlot.end;
        const startMins = (0, _timezoneUtils.timeToMinutes)(updatedStart);
        let endMins = (0, _timezoneUtils.timeToMinutes)(updatedEnd);
        if (field === 'start') {
            if (endMins <= startMins || endMins - startMins < 60) {
                endMins = Math.min(1440, startMins + 60);
                updatedEnd = (0, _timezoneUtils.minutesToTime)(endMins);
            } else if (endMins - startMins > 480) {
                endMins = Math.min(1440, startMins + 480);
                updatedEnd = (0, _timezoneUtils.minutesToTime)(endMins);
            }
        }
        const updatedSlots = day.slots.map((s)=>s.id === slotId ? {
                ...s,
                start: updatedStart,
                end: updatedEnd
            } : s);
        const err = (0, _timezoneUtils.validateDaySlots)(updatedSlots);
        setDayErrors((prev)=>{
            const next = {
                ...prev
            };
            if (err) next[dayKey] = err;
            else delete next[dayKey];
            return next;
        });
        setSchedule((prev)=>({
                ...prev,
                [dayKey]: {
                    ...prev[dayKey],
                    slots: (0, _timezoneUtils.sortSlots)(updatedSlots)
                }
            }));
    };
    // Save Working Hours Schedule
    const executeSaveSchedule = (force = false)=>{
        if (!userId) return;
        updateSchedule({
            uid: userId,
            timezone,
            weekly_schedule: schedule,
            days: (0, _schedule.SCHEDULE_SYNC_DAYS_AHEAD),
            force,
            ai_responses_enabled: aiResponsesEnabled
        }, {
            onSuccess: (res)=>{
                if (res?.hasConflicts && res.conflicts && res.conflicts.length > 0) {
                    setConflictModal({
                        isOpen: true,
                        conflicts: res.conflicts
                    });
                    return;
                }
                (0, _appAlertDefault.default).success('Availability schedule saved successfully.');
            },
            onError: (err)=>{
                (0, _appAlertDefault.default).error(err.message || 'Failed to update schedule');
            }
        });
    };
    const handleSaveWorkingHours = ()=>{
        if (!timezone.trim()) {
            setErrorMsg('Please select a valid timezone to proceed.');
            return;
        }
        const errors = {};
        let hasAnyError = false;
        for (const dayConf of (0, _timezoneUtils.DAYS_CONFIG)){
            const dayData = schedule[dayConf.key];
            if (dayData?.enabled && dayData.slots?.length > 0) {
                const err = (0, _timezoneUtils.validateDaySlots)(dayData.slots);
                if (err) {
                    errors[dayConf.key] = err;
                    hasAnyError = true;
                }
            }
        }
        if (hasAnyError || Object.keys(dayErrors).length > 0) {
            setDayErrors((prev)=>({
                    ...prev,
                    ...errors
                }));
            return;
        }
        setErrorMsg('');
        executeSaveSchedule(false);
    };
    // Save AI Responses Toggle
    const handleSaveAiResponses = ()=>{
        if (!userId) return;
        updateSchedule({
            uid: userId,
            ai_responses_enabled: aiResponsesEnabled,
            ai_responses_only: true
        }, {
            onSuccess: ()=>{
                (0, _appAlertDefault.default).success('AI Responses setting saved successfully.');
            },
            onError: (err)=>{
                (0, _appAlertDefault.default).error(err.message || 'Failed to save AI Responses setting');
            }
        });
    };
    // Open Unavailable Dates Modal (with optional date focus)
    const handleOpenUnavailableModal = (dateStr)=>{
        setFocusedDateForModal(dateStr);
        setUnavailableModalOpen(true);
    };
    // Format unavailable date row for main card list
    const formatUnavailableDateRow = (entry)=>{
        try {
            const [y, m, d] = entry.date.split('-').map(Number);
            const dateObj = new Date(y, m - 1, d);
            const weekday = dateObj.toLocaleDateString('en-GB', {
                weekday: 'long'
            });
            const formattedDate = dateObj.toLocaleDateString('en-GB', {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            });
            const slotsText = entry.allDay ? 'All day' : entry.slots.map((s)=>`${s.start} - ${s.end}`).join('  ');
            return {
                weekday,
                formattedDate,
                slotsText
            };
        } catch  {
            return {
                weekday: '',
                formattedDate: entry.date,
                slotsText: 'Unavailable'
            };
        }
    };
    // Save unavailable dates to backend
    const handleSaveUnavailableDates = async (newDates)=>{
        if (!userId) {
            (0, _appAlertDefault.default).error('User not authenticated');
            return;
        }
        await updateScheduleAsync({
            uid: userId,
            unavailable_dates: newDates,
            unavailable_dates_only: true
        });
        setUnavailableDatesList(newDates);
    };
    // Save calendar connection to backend
    const handleSaveCalendarConnection = async (calendarInfo)=>{
        if (!userId) {
            (0, _appAlertDefault.default).error('User not authenticated');
            return;
        }
        await updateScheduleAsync({
            uid: userId,
            connected_calendar: calendarInfo,
            calendar_connection_only: true
        });
        setConnectedCalendar(calendarInfo);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "schedule-settings-stack",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "settings-card working-hours-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "working-hours-timezone-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "timezone-title-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        className: "globe-icon",
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                cx: "12",
                                                cy: "12",
                                                r: "10"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "2",
                                                y1: "12",
                                                x2: "22",
                                                y2: "12"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "timezone-heading",
                                        children: "TIME ZONE"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "timezone-selector-wrapper",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timezoneSelector.TimezoneSelector), {
                                    value: timezone,
                                    onChange: (newTz)=>{
                                        setTimezone(newTz);
                                        if (errorMsg) setErrorMsg('');
                                    },
                                    error: errorMsg
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "days-schedule-list",
                        children: (0, _timezoneUtils.DAYS_CONFIG).map(({ key, label })=>{
                            const dayData = schedule?.[key] || (0, _timezoneUtils.DEFAULT_WEEKLY_SCHEDULE)[key];
                            const isEnabled = !!dayData?.enabled;
                            const slots = dayData?.slots || [];
                            const canAddSlot = isEnabled && slots.length < (0, _schedule.MAX_SLOTS_PER_DAY);
                            const currentDayError = dayErrors[key];
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "day-item-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: `day-row ${!isEnabled ? 'disabled-day' : ''} ${currentDayError ? 'has-error' : ''}`,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "day-info-col",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "day-name",
                                                        children: label
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        className: `day-toggle-switch ${isEnabled ? 'checked' : ''}`,
                                                        onClick: ()=>handleToggleDay(key),
                                                        role: "switch",
                                                        "aria-checked": isEnabled,
                                                        "aria-label": `Toggle availability for ${label}`,
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "toggle-thumb"
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "day-slots-col",
                                                children: !isEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "unavailable-text",
                                                    children: "Unavailable"
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "slots-wrapper",
                                                            children: slots.map((slot)=>{
                                                                const startMin = (0, _timezoneUtils.timeToMinutes)(slot.start);
                                                                const minEnd = (0, _timezoneUtils.minutesToTime)(Math.min(1440, startMin + 60));
                                                                const maxEnd = (0, _timezoneUtils.minutesToTime)(Math.min(1440, startMin + 480));
                                                                const isSlotInvalid = (0, _timezoneUtils.isSlotConflicting)(slot, slots);
                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: `single-slot-box ${isSlotInvalid ? 'has-error' : ''}`,
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeSlotPicker.TimeSlotPicker), {
                                                                            value: slot.start,
                                                                            type: "start",
                                                                            onChange: (newStart)=>handleSlotChange(key, slot.id, 'start', newStart)
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "slot-separator",
                                                                            children: "\u2014"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeSlotPicker.TimeSlotPicker), {
                                                                            value: slot.end,
                                                                            type: "end",
                                                                            minTime: minEnd,
                                                                            maxTime: maxEnd,
                                                                            onChange: (newEnd)=>handleSlotChange(key, slot.id, 'end', newEnd)
                                                                        }),
                                                                        slots.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                            type: "button",
                                                                            className: "btn-remove-slot",
                                                                            onClick: ()=>handleRemoveSlot(key, slot.id),
                                                                            "aria-label": "Remove slot",
                                                                            title: "Remove slot",
                                                                            children: "\xd7"
                                                                        })
                                                                    ]
                                                                }, slot.id);
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            type: "button",
                                                            className: `btn-add-slot ${!canAddSlot ? 'disabled' : ''}`,
                                                            onClick: ()=>canAddSlot && handleAddSlot(key),
                                                            disabled: !canAddSlot,
                                                            "aria-label": `Add time slot for ${label}`,
                                                            title: slots.length >= (0, _schedule.MAX_SLOTS_PER_DAY) ? `Maximum ${0, _schedule.MAX_SLOTS_PER_DAY} slots per day` : 'Add new slot',
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                width: "14",
                                                                height: "14",
                                                                viewBox: "0 0 24 24",
                                                                fill: "none",
                                                                stroke: "currentColor",
                                                                strokeWidth: "2.5",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                        x1: "12",
                                                                        y1: "5",
                                                                        x2: "12",
                                                                        y2: "19"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                        x1: "5",
                                                                        y1: "12",
                                                                        x2: "19",
                                                                        y2: "12"
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    currentDayError && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "day-inline-error",
                                        role: "alert",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                className: "error-icon",
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "2",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                        cx: "12",
                                                        cy: "12",
                                                        r: "10"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                        x1: "12",
                                                        y1: "8",
                                                        x2: "12",
                                                        y2: "12"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                        x1: "12",
                                                        y1: "16",
                                                        x2: "12.01",
                                                        y2: "16"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: currentDayError
                                            })
                                        ]
                                    })
                                ]
                            }, key);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "card-action-footer",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-save-white",
                            onClick: handleSaveWorkingHours,
                            disabled: isUpdatingSchedule || isScheduleLoading,
                            children: isUpdatingSchedule ? 'Saving...' : 'Save Changes'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "settings-card unavailable-dates-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "unavailable-card-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                className: "unavailable-card-title",
                                children: unavailableDatesList.length > 0 ? 'Unavailable dates' : 'Unavailable dates & times'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "unavailable-card-desc",
                                children: unavailableDatesList.length > 0 ? "Block specific dates when you're not available" : "Add dates you're unavailable, or connect your calendar to automatically block time when you're busy."
                            })
                        ]
                    }),
                    unavailableDatesList.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "unavailable-configured-list",
                        children: unavailableDatesList.map((item)=>{
                            const { weekday, formattedDate, slotsText } = formatUnavailableDateRow(item);
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "configured-date-row",
                                onClick: ()=>handleOpenUnavailableModal(item.date),
                                role: "button",
                                tabIndex: 0,
                                onKeyDown: (e)=>e.key === 'Enter' && handleOpenUnavailableModal(item.date),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "configured-date-info",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "row-weekday",
                                                children: weekday
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "row-pipe-divider",
                                                children: '|'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "row-formatted-date",
                                                children: formattedDate
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "row-pipe-divider",
                                                children: '|'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "row-slots-preview",
                                                children: slotsText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        className: "row-chevron-icon",
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                            points: "9 18 15 12 9 6"
                                        })
                                    })
                                ]
                            }, item.date);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "unavailable-actions-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: `btn-connect-calendar ${connectedCalendar?.connected ? 'is-connected' : ''}`,
                                onClick: ()=>setCalendarModalOpen(true),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        className: "calendar-icon",
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                                                x: "3",
                                                y: "4",
                                                width: "18",
                                                height: "18",
                                                rx: "2",
                                                ry: "2"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "16",
                                                y1: "2",
                                                x2: "16",
                                                y2: "6"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "8",
                                                y1: "2",
                                                x2: "8",
                                                y2: "6"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "3",
                                                y1: "10",
                                                x2: "21",
                                                y2: "10"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: connectedCalendar?.connected ? `${connectedCalendar.provider === 'google' ? 'Google' : 'Apple'} Calendar Connected` : 'Connect your Calendar'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: "btn-add-date-outline",
                                onClick: ()=>handleOpenUnavailableModal(null),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        className: "plus-icon",
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "12",
                                                y1: "5",
                                                x2: "12",
                                                y2: "19"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "5",
                                                y1: "12",
                                                x2: "19",
                                                y2: "12"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Add date"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "settings-card ai-responses-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "ai-responses-content-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "ai-title-toggle-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "ai-responses-title",
                                        children: "AI Responses"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: `day-toggle-switch ${aiResponsesEnabled ? 'checked' : ''}`,
                                        onClick: ()=>setAiResponsesEnabled((prev)=>!prev),
                                        role: "switch",
                                        "aria-checked": aiResponsesEnabled,
                                        "aria-label": "Toggle AI Responses",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "toggle-thumb"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "ai-responses-description-col",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "ai-desc-text",
                                    children: "AI will respond to basic client questions outside your schedule hours to ensure they have 24/7 support. You can choose to turn off this feature at any time."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "card-action-footer",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-save-white",
                            onClick: handleSaveAiResponses,
                            disabled: isUpdatingSchedule,
                            children: isUpdatingSchedule ? 'Saving...' : 'Save Changes'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: confirmModal.isOpen,
                footer: null,
                onCancel: ()=>setConfirmModal({
                        isOpen: false,
                        dayKey: null
                    }),
                centered: true,
                width: 420,
                closeIcon: null,
                rootClassName: "settings-modal",
                className: "settings-modal",
                styles: settingsModalStyles,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "settings-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "modal-icon-badge warning",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "12",
                                        y1: "9",
                                        x2: "12",
                                        y2: "13"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "12",
                                        y1: "17",
                                        x2: "12.01",
                                        y2: "17"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: "modal-title",
                            children: "Disable Day Availability?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "modal-text",
                            children: [
                                "Turning off availability for",
                                ' ',
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                    children: (0, _timezoneUtils.DAYS_CONFIG).find((d)=>d.key === confirmModal.dayKey)?.label || 'this day'
                                }),
                                ' ',
                                "will remove all configured working slots on this day. Are you sure you want to proceed?"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-actions-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "btn-modal-cancel",
                                    onClick: ()=>setConfirmModal({
                                            isOpen: false,
                                            dayKey: null
                                        }),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "btn-modal-confirm",
                                    onClick: handleConfirmDisable,
                                    children: "Yes, Disable"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: conflictModal.isOpen,
                footer: null,
                onCancel: ()=>setConflictModal({
                        isOpen: false,
                        conflicts: []
                    }),
                centered: true,
                width: 500,
                closeIcon: null,
                rootClassName: "settings-modal",
                className: "settings-modal",
                styles: settingsModalStyles,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "settings-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "modal-icon-badge danger",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: "24",
                                height: "24",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: "12",
                                        cy: "12",
                                        r: "10"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "12",
                                        y1: "8",
                                        x2: "12",
                                        y2: "12"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "12",
                                        y1: "16",
                                        x2: "12.01",
                                        y2: "16"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            className: "modal-title",
                            children: "Booking Conflicts Detected"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "modal-text",
                            children: "You have active client bookings during hours that were modified or removed."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "conflicts-scroll-list",
                            children: conflictModal.conflicts.map((c, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "conflict-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "conflict-date",
                                            children: c.date
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "conflict-time",
                                            children: c.time
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "conflict-client",
                                            children: c.clientName || 'Client Check-in'
                                        })
                                    ]
                                }, i))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-actions-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "btn-modal-cancel",
                                    onClick: ()=>setConflictModal({
                                            isOpen: false,
                                            conflicts: []
                                        }),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "btn-modal-confirm danger",
                                    onClick: ()=>{
                                        setConflictModal({
                                            isOpen: false,
                                            conflicts: []
                                        });
                                        executeSaveSchedule(true);
                                    },
                                    children: "Proceed Anyway"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _connectCalendarModal.ConnectCalendarModal), {
                isOpen: calendarModalOpen,
                onClose: ()=>setCalendarModalOpen(false),
                connectedCalendar: connectedCalendar,
                onSaveCalendar: handleSaveCalendarConnection,
                isSaving: isUpdatingSchedule
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unavailableDatesModal.UnavailableDatesModal), {
                isOpen: unavailableModalOpen,
                onClose: ()=>{
                    setUnavailableModalOpen(false);
                    setFocusedDateForModal(null);
                },
                initialDates: unavailableDatesList,
                focusedDate: focusedDateForModal,
                onSave: handleSaveUnavailableDates,
                isSaving: isUpdatingSchedule
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"src/screens/OnboardingTrainer/screens/Schedule/utils/timezoneUtils":"3cRmo","src/screens/OnboardingTrainer/screens/Schedule/components/TimeSlotPicker":"8ZJ4j","src/screens/OnboardingTrainer/screens/Schedule/components/TimezoneSelector":"13NLc","src/screens/OnboardingTrainer/screens/Schedule/Schedule":"itZID","src/api/queries/useGetTrainerSchedule":"2n68F","src/api/mutations/useUpdateTrainerSchedule":"5jf2V","src/store/sessionStore":"kPSO3","src/utils/authUtils":"41GVV","src/utils/appAlert":"de4Mq","./ConnectCalendarModal/ConnectCalendarModal":"gUBYs","./UnavailableDatesModal/UnavailableDatesModal":"fVbrW","./ScheduleSettings.scss":"euJIy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gUBYs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ConnectCalendarModal", ()=>ConnectCalendarModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _googleSvg = require("src/assets/images/onboarding-trainer/google.svg");
var _appleSvg = require("src/assets/images/onboarding-trainer/apple.svg");
var _appAlert = require("src/utils/appAlert");
var _appAlertDefault = parcelHelpers.interopDefault(_appAlert);
var _connectCalendarModalScss = require("./ConnectCalendarModal.scss");
const modalStyles = {
    mask: {
        backdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(4, 5, 27, 0.75)'
    },
    container: {
        background: '#0c0f2b',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        borderRadius: '20px',
        boxShadow: '0 24px 48px rgba(0, 0, 0, 0.6)',
        padding: 0,
        color: '#ffffff',
        overflow: 'hidden'
    },
    body: {
        padding: 0,
        background: 'transparent'
    }
};
const ConnectCalendarModal = ({ isOpen, onClose, connectedCalendar, onSaveCalendar, isSaving = false })=>{
    const [activeProvider, setActiveProvider] = (0, _react.useState)(connectedCalendar?.connected ? connectedCalendar.provider : null);
    const [connecting, setConnecting] = (0, _react.useState)(null);
    const handleSelectProvider = async (provider)=>{
        if (isSaving || connecting) return;
        setConnecting(provider);
        try {
            if (activeProvider === provider) {
                // Disconnect
                await onSaveCalendar({
                    provider: null,
                    connected: false
                });
                setActiveProvider(null);
                (0, _appAlertDefault.default).success(`${provider === 'google' ? 'Google' : 'Apple'} Calendar disconnected successfully.`);
            } else {
                // Connect
                await onSaveCalendar({
                    provider,
                    connected: true,
                    email: provider === 'google' ? 'trainer@gmail.com' : 'trainer@icloud.com'
                });
                setActiveProvider(provider);
                (0, _appAlertDefault.default).success(`${provider === 'google' ? 'Google' : 'Apple'} Calendar connected successfully.`);
                onClose();
            }
        } catch (err) {
            const errorMsg = err instanceof Error ? err.message : 'Failed to update calendar connection';
            (0, _appAlertDefault.default).error(errorMsg);
        } finally{
            setConnecting(null);
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        footer: null,
        onCancel: onClose,
        centered: true,
        width: 480,
        closeIcon: null,
        rootClassName: "connect-calendar-modal-root",
        className: "connect-calendar-modal",
        styles: modalStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "connect-calendar-modal-inner",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-header-row",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "header-titles",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    className: "modal-title",
                                    children: 'Connect your calendar'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "modal-subtitle",
                                    children: 'Choose the account where your calendar is stored.'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "modal-close-btn",
                            onClick: onClose,
                            "aria-label": "Close",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "18",
                                        y1: "6",
                                        x2: "6",
                                        y2: "18"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "6",
                                        y1: "6",
                                        x2: "18",
                                        y2: "18"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "calendar-options-list",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: `calendar-option-card ${activeProvider === 'google' ? 'connected' : ''}`,
                            onClick: ()=>handleSelectProvider('google'),
                            role: "button",
                            tabIndex: 0,
                            onKeyDown: (e)=>e.key === 'Enter' && handleSelectProvider('google'),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "provider-icon-wrapper google",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _googleSvg.ReactComponent), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "provider-info",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "provider-title",
                                            children: 'Google Calendar'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "provider-desc",
                                            children: 'Connect your Google Account'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "provider-action-state",
                                    children: connecting === 'google' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "connecting-spinner",
                                        children: 'Connecting...'
                                    }) : activeProvider === 'google' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "badge-connected",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "3",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                    points: "20 6 9 17 4 12"
                                                })
                                            }),
                                            'Connected'
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        className: "arrow-chevron",
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                            points: "9 18 15 12 9 6"
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: `calendar-option-card ${activeProvider === 'apple' ? 'connected' : ''}`,
                            onClick: ()=>handleSelectProvider('apple'),
                            role: "button",
                            tabIndex: 0,
                            onKeyDown: (e)=>e.key === 'Enter' && handleSelectProvider('apple'),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "provider-icon-wrapper apple",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _appleSvg.ReactComponent), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "provider-info",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "provider-title",
                                            children: 'Apple Calendar (iCloud)'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "provider-desc",
                                            children: 'Connect calendars stored in iCloud'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "provider-action-state",
                                    children: connecting === 'apple' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "connecting-spinner",
                                        children: 'Connecting...'
                                    }) : activeProvider === 'apple' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "badge-connected",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                width: "14",
                                                height: "14",
                                                viewBox: "0 0 24 24",
                                                fill: "none",
                                                stroke: "currentColor",
                                                strokeWidth: "3",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                    points: "20 6 9 17 4 12"
                                                })
                                            }),
                                            'Connected'
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        className: "arrow-chevron",
                                        width: "18",
                                        height: "18",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                            points: "9 18 15 12 9 6"
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"src/assets/images/onboarding-trainer/google.svg":"KnXaD","src/assets/images/onboarding-trainer/apple.svg":"gOuz3","src/utils/appAlert":"de4Mq","./ConnectCalendarModal.scss":"ceSxb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ceSxb":[function() {},{}],"fVbrW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "UnavailableDatesModal", ()=>UnavailableDatesModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _timeSlotPicker = require("src/screens/OnboardingTrainer/screens/Schedule/components/TimeSlotPicker");
var _timezoneUtils = require("src/screens/OnboardingTrainer/screens/Schedule/utils/timezoneUtils");
var _appAlert = require("src/utils/appAlert");
var _appAlertDefault = parcelHelpers.interopDefault(_appAlert);
var _unavailableDatesModalScss = require("./UnavailableDatesModal.scss");
const modalStyles = {
    mask: {
        backdropFilter: 'blur(8px)',
        backgroundColor: 'rgba(4, 5, 27, 0.8)'
    },
    container: {
        background: '#0c0f2b',
        border: '1px solid rgba(255, 255, 255, 0.12)',
        borderRadius: '20px',
        boxShadow: '0 24px 48px rgba(0, 0, 0, 0.6)',
        padding: 0,
        color: '#ffffff',
        overflow: 'hidden'
    },
    body: {
        padding: 0,
        background: 'transparent'
    }
};
const WEEKDAY_NAMES = [
    'Mo',
    'Tu',
    'We',
    'Th',
    'Fr',
    'Sa',
    'Su'
];
const UnavailableDatesModal = ({ isOpen, onClose, initialDates, onSave, isSaving = false, focusedDate })=>{
    // Working copy of unavailable dates
    const [dates, setDates] = (0, _react.useState)([]);
    const [activeDateStr, setActiveDateStr] = (0, _react.useState)(null);
    // Month navigation: year and month (0-indexed)
    const [currentMonth, setCurrentMonth] = (0, _react.useState)(()=>new Date());
    const datesListRef = (0, _react.useRef)(null);
    // Reset or initialize when modal opens
    (0, _react.useEffect)(()=>{
        if (isOpen) {
            const copy = JSON.parse(JSON.stringify(initialDates || []));
            setDates(copy);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            // Determine initial calendar month and active date
            let targetDate = focusedDate;
            if (!targetDate && copy.length > 0) {
                // Pick first non-past date if available
                const upcoming = copy.find((d)=>{
                    const [y, m, day] = d.date.split('-').map(Number);
                    const dt = new Date(y, m - 1, day);
                    dt.setHours(0, 0, 0, 0);
                    return dt.getTime() >= today.getTime();
                });
                targetDate = upcoming?.date;
            }
            if (targetDate) {
                const [y, m, day] = targetDate.split('-').map(Number);
                const dt = new Date(y, m - 1, day);
                dt.setHours(0, 0, 0, 0);
                if (dt.getTime() >= today.getTime()) setActiveDateStr(targetDate);
                else setActiveDateStr(null);
                if (y > today.getFullYear() || y === today.getFullYear() && m - 1 >= today.getMonth()) setCurrentMonth(new Date(y, m - 1, 1));
                else setCurrentMonth(new Date());
            } else {
                setActiveDateStr(null);
                setCurrentMonth(new Date());
            }
        }
    }, [
        isOpen,
        initialDates,
        focusedDate
    ]);
    // Calendar calculations
    const year = currentMonth.getFullYear();
    const month = currentMonth.getMonth(); // 0-indexed
    const monthLabel = currentMonth.toLocaleDateString('en-GB', {
        month: 'short',
        year: 'numeric'
    });
    const isPrevMonthDisabled = (0, _react.useMemo)(()=>{
        const today = new Date();
        const currentYear = today.getFullYear();
        const currentMonthNum = today.getMonth();
        return year < currentYear || year === currentYear && month <= currentMonthNum;
    }, [
        year,
        month
    ]);
    const handlePrevMonth = ()=>{
        if (isPrevMonthDisabled) return;
        setCurrentMonth(new Date(year, month - 1, 1));
    };
    const handleNextMonth = ()=>{
        setCurrentMonth(new Date(year, month + 1, 1));
    };
    // Calendar cells generation (Monday-first)
    const calendarCells = (0, _react.useMemo)(()=>{
        const firstDayOfMonth = new Date(year, month, 1);
        // getDay() gives 0 for Sunday, 1 for Monday... We want Monday = 0, Sunday = 6
        const firstDayIndex = (firstDayOfMonth.getDay() + 6) % 7;
        const daysInCurrentMonth = new Date(year, month + 1, 0).getDate();
        const daysInPrevMonth = new Date(year, month, 0).getDate();
        const cells = [];
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        // Prev month padding
        for(let i = firstDayIndex - 1; i >= 0; i--){
            const dayNum = daysInPrevMonth - i;
            const prevDate = new Date(year, month - 1, dayNum);
            prevDate.setHours(0, 0, 0, 0);
            const dateStr = `${prevDate.getFullYear()}-${String(prevDate.getMonth() + 1).padStart(2, '0')}-${String(dayNum).padStart(2, '0')}`;
            cells.push({
                dateStr,
                dayNumber: dayNum,
                isCurrentMonth: false,
                isPast: prevDate.getTime() < today.getTime(),
                isToday: false,
                hasUnavailableSlots: dates.some((d)=>d.date === dateStr),
                isSelected: activeDateStr === dateStr
            });
        }
        // Current month days
        for(let dayNum = 1; dayNum <= daysInCurrentMonth; dayNum++){
            const thisDate = new Date(year, month, dayNum);
            thisDate.setHours(0, 0, 0, 0);
            const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(dayNum).padStart(2, '0')}`;
            cells.push({
                dateStr,
                dayNumber: dayNum,
                isCurrentMonth: true,
                isPast: thisDate.getTime() < today.getTime(),
                isToday: thisDate.getTime() === today.getTime(),
                hasUnavailableSlots: dates.some((d)=>d.date === dateStr),
                isSelected: activeDateStr === dateStr
            });
        }
        // Next month padding to fill grid to multiple of 7 (at least 35 or 42 cells)
        const remaining = (7 - cells.length % 7) % 7;
        for(let dayNum = 1; dayNum <= remaining; dayNum++){
            const nextDate = new Date(year, month + 1, dayNum);
            nextDate.setHours(0, 0, 0, 0);
            const dateStr = `${nextDate.getFullYear()}-${String(nextDate.getMonth() + 1).padStart(2, '0')}-${String(dayNum).padStart(2, '0')}`;
            cells.push({
                dateStr,
                dayNumber: dayNum,
                isCurrentMonth: false,
                isPast: nextDate.getTime() < today.getTime(),
                isToday: false,
                hasUnavailableSlots: dates.some((d)=>d.date === dateStr),
                isSelected: activeDateStr === dateStr
            });
        }
        return cells;
    }, [
        year,
        month,
        dates,
        activeDateStr
    ]);
    // Click on a calendar day
    const handleSelectDay = (dateStr, isPast)=>{
        if (isPast) return;
        setActiveDateStr(dateStr);
        const existingIdx = dates.findIndex((d)=>d.date === dateStr);
        if (existingIdx === -1) {
            // Add new unavailable date with a default slot
            const newEntry = {
                date: dateStr,
                allDay: false,
                slots: [
                    {
                        id: `slot-${dateStr}-1`,
                        start: '12:00',
                        end: '13:30'
                    }
                ]
            };
            setDates((prev)=>{
                const next = [
                    ...prev,
                    newEntry
                ];
                return next.sort((a, b)=>a.date.localeCompare(b.date));
            });
        }
        // Scroll right list to date
        setTimeout(()=>{
            const el = document.getElementById(`date-entry-${dateStr}`);
            if (el) el.scrollIntoView({
                behavior: 'smooth',
                block: 'nearest'
            });
        }, 100);
    };
    // Remove an entire date
    const handleRemoveDate = (dateStr)=>{
        setDates((prev)=>prev.filter((d)=>d.date !== dateStr));
        if (activeDateStr === dateStr) {
            const remaining = dates.filter((d)=>d.date !== dateStr);
            setActiveDateStr(remaining[0]?.date || null);
        }
    };
    // Toggle all day for a date
    const handleToggleAllDay = (dateStr)=>{
        setDates((prev)=>prev.map((d)=>{
                if (d.date !== dateStr) return d;
                const newAllDay = !d.allDay;
                return {
                    ...d,
                    allDay: newAllDay,
                    slots: newAllDay ? [
                        {
                            id: `slot-${dateStr}-allday`,
                            start: '00:00',
                            end: '24:00'
                        }
                    ] : [
                        {
                            id: `slot-${dateStr}-1`,
                            start: '12:00',
                            end: '13:30'
                        }
                    ]
                };
            }));
    };
    // Change slot time
    const handleSlotTimeChange = (dateStr, slotId, field, val)=>{
        setDates((prev)=>prev.map((d)=>{
                if (d.date !== dateStr) return d;
                return {
                    ...d,
                    slots: d.slots.map((s)=>s.id === slotId ? {
                            ...s,
                            [field]: val
                        } : s)
                };
            }));
    };
    // Add time range to a date
    const handleAddSlot = (dateStr)=>{
        setDates((prev)=>prev.map((d)=>{
                if (d.date !== dateStr) return d;
                if (d.slots.length >= 5) {
                    (0, _appAlertDefault.default).error('Maximum of 5 time ranges per date.');
                    return d;
                }
                // Smart next slot progression based on last slot end time
                const lastSlot = d.slots[d.slots.length - 1];
                let nextStart = '14:00';
                let nextEnd = '17:00';
                if (lastSlot) {
                    const lastEndMins = (0, _timezoneUtils.timeToMinutes)(lastSlot.end);
                    if (lastEndMins + 60 <= 1440) {
                        const startH = Math.floor(lastEndMins / 60);
                        const startM = lastEndMins % 60;
                        nextStart = `${String(startH).padStart(2, '0')}:${String(startM).padStart(2, '0')}`;
                        const endMins = Math.min(lastEndMins + 90, 1440);
                        const endH = Math.floor(endMins / 60);
                        const endM = endMins % 60;
                        nextEnd = `${String(endH).padStart(2, '0')}:${String(endM).padStart(2, '0')}`;
                    }
                }
                const newSlot = {
                    id: `slot-${dateStr}-${Date.now()}`,
                    start: nextStart,
                    end: nextEnd
                };
                return {
                    ...d,
                    slots: [
                        ...d.slots,
                        newSlot
                    ]
                };
            }));
    };
    // Remove slot from a date
    const handleRemoveSlot = (dateStr, slotId)=>{
        setDates((prev)=>prev.map((d)=>{
                if (d.date !== dateStr) return d;
                const updatedSlots = d.slots.filter((s)=>s.id !== slotId);
                // If no slots left, remove date altogether or leave default
                if (updatedSlots.length === 0) return {
                    ...d,
                    allDay: true,
                    slots: [
                        {
                            id: `slot-${dateStr}-allday`,
                            start: '00:00',
                            end: '24:00'
                        }
                    ]
                };
                return {
                    ...d,
                    slots: updatedSlots
                };
            }));
    };
    // Validation per date
    const getDateErrors = (entry)=>{
        if (entry.allDay) return null;
        if (entry.slots.length === 0) return 'At least one time range is required';
        for (const slot of entry.slots){
            const startMins = (0, _timezoneUtils.timeToMinutes)(slot.start);
            const endMins = (0, _timezoneUtils.timeToMinutes)(slot.end);
            if (endMins <= startMins) return 'End time must be after start time';
        }
        // Check overlap
        for(let i = 0; i < entry.slots.length; i++)for(let j = i + 1; j < entry.slots.length; j++){
            if ((0, _timezoneUtils.doSlotsOverlap)(entry.slots[i].start, entry.slots[i].end, entry.slots[j].start, entry.slots[j].end)) return 'Time ranges cannot overlap';
        }
        return null;
    };
    // Global validation check
    const hasAnyErrors = (0, _react.useMemo)(()=>{
        return dates.some((d)=>getDateErrors(d) !== null);
    }, [
        dates
    ]);
    // Save handler
    const handleSave = async ()=>{
        if (hasAnyErrors || isSaving) return;
        try {
            // Sort slots chronologically within each date
            const cleanedDates = dates.map((d)=>({
                    ...d,
                    slots: d.slots.slice().sort((a, b)=>(0, _timezoneUtils.timeToMinutes)(a.start) - (0, _timezoneUtils.timeToMinutes)(b.start))
                }));
            await onSave(cleanedDates);
            (0, _appAlertDefault.default).success('Unavailable dates saved successfully.');
            onClose();
        } catch (err) {
            const msg = err instanceof Error ? err.message : 'Failed to save dates';
            (0, _appAlertDefault.default).error(msg);
        }
    };
    const hasDates = dates.length > 0;
    // Format date helper for side list
    const formatHeading = (dateStr)=>{
        const [y, m, d] = dateStr.split('-').map(Number);
        const dateObj = new Date(y, m - 1, d);
        return dateObj.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        footer: null,
        onCancel: onClose,
        centered: true,
        width: hasDates ? 880 : 520,
        closeIcon: null,
        rootClassName: "unavailable-dates-modal-root",
        className: "unavailable-dates-modal",
        styles: modalStyles,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: `unavailable-modal-inner ${hasDates ? 'has-side-panel' : ''}`,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-header-row",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "header-titles",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    className: "modal-title",
                                    children: 'Select your unavailable dates'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "modal-subtitle",
                                    children: "Times outside your available hours won't affect your schedule."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "modal-close-btn",
                            onClick: onClose,
                            "aria-label": "Close",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                width: "20",
                                height: "20",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "18",
                                        y1: "6",
                                        x2: "6",
                                        y2: "18"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "6",
                                        y1: "6",
                                        x2: "18",
                                        y2: "18"
                                    })
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-body-layout",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "calendar-widget-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "calendar-month-nav",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "month-label",
                                            children: monthLabel
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "nav-arrows",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    className: "nav-arrow-btn",
                                                    onClick: handlePrevMonth,
                                                    disabled: isPrevMonthDisabled,
                                                    "aria-label": "Previous month",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2.5",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                            points: "15 18 9 12 15 6"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    className: "nav-arrow-btn",
                                                    onClick: handleNextMonth,
                                                    "aria-label": "Next month",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2.5",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                            points: "9 18 15 12 9 6"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "calendar-weekdays-row",
                                    children: WEEKDAY_NAMES.map((name)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "weekday-col-header",
                                            children: name
                                        }, name))
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "calendar-days-grid",
                                    children: calendarCells.map((cell)=>{
                                        const cellClasses = [
                                            'calendar-day-cell',
                                            cell.isCurrentMonth ? 'current-month' : 'other-month',
                                            cell.isToday ? 'is-today' : '',
                                            cell.hasUnavailableSlots ? 'has-slots' : '',
                                            cell.isSelected ? 'selected-day' : '',
                                            cell.isPast ? 'is-past' : ''
                                        ].filter(Boolean).join(' ');
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            type: "button",
                                            className: cellClasses,
                                            disabled: cell.isPast,
                                            onClick: ()=>handleSelectDay(cell.dateStr, cell.isPast),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "day-number-text",
                                                    children: cell.dayNumber
                                                }),
                                                cell.hasUnavailableSlots && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "day-slot-dot"
                                                })
                                            ]
                                        }, cell.dateStr);
                                    })
                                })
                            ]
                        }),
                        hasDates && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "dates-side-panel-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "side-panel-header",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "side-panel-title",
                                            children: 'Selected Dates'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "side-panel-count",
                                            children: `${dates.length} date${dates.length > 1 ? 's' : ''}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "side-panel-scroll-list",
                                    ref: datesListRef,
                                    children: dates.map((entry)=>{
                                        const error = getDateErrors(entry);
                                        const isFocused = activeDateStr === entry.date;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            id: `date-entry-${entry.date}`,
                                            className: `date-entry-card ${isFocused ? 'focused' : ''}`,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "entry-card-header",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "date-title-text",
                                                            children: formatHeading(entry.date)
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "entry-header-actions",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    type: "button",
                                                                    className: `btn-toggle-allday ${entry.allDay ? 'active' : ''}`,
                                                                    onClick: ()=>handleToggleAllDay(entry.date),
                                                                    children: entry.allDay ? 'All day' : 'Custom'
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    type: "button",
                                                                    className: "btn-remove-date",
                                                                    onClick: ()=>handleRemoveDate(entry.date),
                                                                    "aria-label": "Remove date",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                        width: "16",
                                                                        height: "16",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "2",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                                x1: "18",
                                                                                y1: "6",
                                                                                x2: "6",
                                                                                y2: "18"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                                x1: "6",
                                                                                y1: "6",
                                                                                x2: "18",
                                                                                y2: "18"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                entry.allDay ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "allday-display-row",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "allday-label",
                                                        children: '00:00 - 24:00 (All day)'
                                                    })
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "slots-list",
                                                    children: [
                                                        entry.slots.map((slot)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "time-slot-row",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeSlotPicker.TimeSlotPicker), {
                                                                        value: slot.start,
                                                                        type: "start",
                                                                        onChange: (val)=>handleSlotTimeChange(entry.date, slot.id, 'start', val)
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "slot-divider",
                                                                        children: '-'
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _timeSlotPicker.TimeSlotPicker), {
                                                                        value: slot.end,
                                                                        type: "end",
                                                                        minTime: slot.start,
                                                                        onChange: (val)=>handleSlotTimeChange(entry.date, slot.id, 'end', val)
                                                                    }),
                                                                    entry.slots.length > 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                        type: "button",
                                                                        className: "btn-remove-slot",
                                                                        onClick: ()=>handleRemoveSlot(entry.date, slot.id),
                                                                        "aria-label": "Remove time range",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                            width: "14",
                                                                            height: "14",
                                                                            viewBox: "0 0 24 24",
                                                                            fill: "none",
                                                                            stroke: "currentColor",
                                                                            strokeWidth: "2",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                                    x1: "18",
                                                                                    y1: "6",
                                                                                    x2: "6",
                                                                                    y2: "18"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                                    x1: "6",
                                                                                    y1: "6",
                                                                                    x2: "18",
                                                                                    y2: "18"
                                                                                })
                                                                            ]
                                                                        })
                                                                    })
                                                                ]
                                                            }, slot.id)),
                                                        entry.slots.length < 5 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                            type: "button",
                                                            className: "btn-add-slot",
                                                            onClick: ()=>handleAddSlot(entry.date),
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                    width: "14",
                                                                    height: "14",
                                                                    viewBox: "0 0 24 24",
                                                                    fill: "none",
                                                                    stroke: "currentColor",
                                                                    strokeWidth: "2.5",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                            x1: "12",
                                                                            y1: "5",
                                                                            x2: "12",
                                                                            y2: "19"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                            x1: "5",
                                                                            y1: "12",
                                                                            x2: "19",
                                                                            y2: "12"
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: 'Add time range'
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                error && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "entry-error-msg",
                                                    children: error
                                                })
                                            ]
                                        }, entry.date);
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-actions-footer",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-footer-cancel",
                            onClick: onClose,
                            disabled: isSaving,
                            children: 'Cancel'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-footer-save",
                            onClick: handleSave,
                            disabled: hasAnyErrors || isSaving,
                            children: isSaving ? 'Saving...' : 'Save Dates'
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"src/screens/OnboardingTrainer/screens/Schedule/components/TimeSlotPicker":"8ZJ4j","src/screens/OnboardingTrainer/screens/Schedule/utils/timezoneUtils":"3cRmo","src/utils/appAlert":"de4Mq","./UnavailableDatesModal.scss":"3PEI0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3PEI0":[function() {},{}],"euJIy":[function() {},{}],"1G4n0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SettingsComingSoon", ()=>SettingsComingSoon);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _settingsComingSoonScss = require("./SettingsComingSoon.scss");
const SettingsComingSoon = ({ option })=>{
    const renderIcon = ()=>{
        switch(option.icon){
            case 'user':
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "12",
                            cy: "7",
                            r: "4"
                        })
                    ]
                });
            case 'email':
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                            points: "22,6 12,13 2,6"
                        })
                    ]
                });
            case 'lock':
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            x: "3",
                            y: "11",
                            width: "18",
                            height: "11",
                            rx: "2",
                            ry: "2"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M7 11V7a5 5 0 0110 0v4"
                        })
                    ]
                });
            case 'bell':
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M18 8A6 6 0 006 8c0 7-3 9-3 9h18s-3-2-3-9"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M13.73 21a2 2 0 01-3.46 0"
                        })
                    ]
                });
            case 'shield':
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"
                    })
                });
            case 'card':
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            x: "1",
                            y: "4",
                            width: "22",
                            height: "16",
                            rx: "2",
                            ry: "2"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                            x1: "1",
                            y1: "10",
                            x2: "23",
                            y2: "10"
                        })
                    ]
                });
            case 'trash':
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                            points: "3 6 5 6 21 6"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"
                        })
                    ]
                });
            default:
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.8",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                            cx: "12",
                            cy: "12",
                            r: "10"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                            x1: "12",
                            y1: "8",
                            x2: "12",
                            y2: "12"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                            x1: "12",
                            y1: "16",
                            x2: "12.01",
                            y2: "16"
                        })
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "settings-coming-soon-card",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "settings-badge-row",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "coming-soon-pill",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "dot"
                        }),
                        'COMING SOON'
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "settings-icon-wrapper",
                children: renderIcon()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "settings-coming-soon-title",
                children: option.label
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "settings-coming-soon-desc",
                children: option.description
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "settings-coming-soon-footer",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "footer-tag",
                    children: 'This feature is currently in active development. Stay tuned!'
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./SettingsComingSoon.scss":"bNt1T","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bNt1T":[function() {},{}],"27rtW":[function() {},{}],"c1CtJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CompleteOnboardingBanner", ()=>CompleteOnboardingBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _sessionStore = require("src/store/sessionStore");
var _authUtils = require("src/utils/authUtils");
var _useGetOnboardingState = require("src/api/mutations/useGetOnboardingState");
var _onboardingUtils = require("src/utils/onboardingUtils");
var _completeOnboardingBannerScss = require("./CompleteOnboardingBanner.scss");
const CompleteOnboardingBanner = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const token = (0, _sessionStore.sessionStore)((s)=>s.token);
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const userId = (0, _authUtils.getUserIdFromToken)(token) || currentUser?.uid;
    const { data: onboardingData, isLoading } = (0, _useGetOnboardingState.useGetOnboardingState)(userId || undefined);
    if (!userId) return null;
    // Prevent flash of banner while fetching state if no cached onboarding state exists yet
    if (isLoading && !onboardingData && !currentUser?.onboarding) return null;
    const onboarding = onboardingData?.onboarding ?? currentUser?.onboarding;
    const progress = (0, _onboardingUtils.computeOnboardingProgress)(onboarding);
    // The banner should only be visible when the trainer has skipped or not finished onboarding
    if (progress.isFullyCompleted) return null;
    const handleResume = ()=>{
        navigate('/onboarding-trainer?resume=true');
    };
    const getStepProgressText = ()=>{
        if (progress.completedStepsCount <= 0) return 'Setup Incomplete (0/4)';
        return `${progress.completedStepsCount}/4 steps completed`;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "complete-onboarding-banner",
        role: "alert",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "banner-left",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "banner-icon-container",
                        "aria-hidden": "true",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                d: "M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "banner-text-content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "banner-title-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        className: "banner-title",
                                        children: "Complete your onboarding"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "banner-step-pill",
                                        children: getStepProgressText()
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "banner-description",
                                children: "Complete your onboarding to set up your experience, coaching specialties, and weekly schedule so clients can find and book sessions with you."
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "banner-right",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                    type: "button",
                    className: "banner-action-btn",
                    onClick: handleResume,
                    "aria-label": "Finish onboarding now",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "Complete Onboarding"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            "aria-hidden": "true",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M5 12h14"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                    d: "M12 5l7 7-7 7"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","src/store/sessionStore":"kPSO3","src/utils/authUtils":"41GVV","src/api/mutations/useGetOnboardingState":"3gbTg","src/utils/onboardingUtils":"gnh1N","./CompleteOnboardingBanner.scss":"90QcY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"90QcY":[function() {},{}],"3rTMt":[function() {},{}],"7qRBh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPencil2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPencil2 = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M2.25 11.456q0 .544.375.844.376.3 1.237.394.3.037.479.271a.77.77 0 0 1 .159.535.78.78 0 0 1-.225.525.58.58 0 0 1-.506.169q-1.52-.188-2.269-.872t-.75-1.866q0-1.218 1.004-1.977 1.002-.76 2.784-.91.73-.057 1.097-.234Q6 8.157 6 7.837q0-.412-.394-.646t-1.293-.366a.67.67 0 0 1-.479-.281.73.73 0 0 1-.14-.544.78.78 0 0 1 .263-.515.65.65 0 0 1 .525-.16q1.556.225 2.287.835.732.61.731 1.678 0 .993-.721 1.556-.722.563-2.129.675-1.2.094-1.8.44-.6.348-.6.947m8.156 2.232-3.093-3.094 6.468-6.469q.375-.375.891-.375t.89.375l1.313 1.313q.375.375.375.89 0 .517-.375.89zM6.731 15a.57.57 0 0 1-.562-.169A.57.57 0 0 1 6 14.27l.581-2.831L9.544 14.4z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3tyy0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgramGeneratorAI", ()=>ProgramGeneratorAI);
var _jsxRuntime = require("react/jsx-runtime");
var _reactQuery = require("@tanstack/react-query");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useStepProgress = require("src/hooks/useStepProgress");
var _useCheckClientFitnessProfile = require("src/hooks/useCheckClientFitnessProfile");
var _programGeneratorProgressStore = require("src/store/programGeneratorProgressStore");
var _useGetPrograms = require("src/api/queries/useGetPrograms");
var _reactRouterDom = require("react-router-dom");
var _miniPtCareMp4 = require("url:../../../../../../assets/videos/mini-pt-care.mp4");
var _miniPtCareMp4Default = parcelHelpers.interopDefault(_miniPtCareMp4);
var _textAnimate = require("src/components/Animation/text-animate");
var _gsapSetup = require("src/utils/gsapSetup");
var _gsapSetupDefault = parcelHelpers.interopDefault(_gsapSetup);
var _antd = require("antd");
var _confirmation = require("./assets/Confirmation");
var _replaceProgramModal = require("src/components/ReplaceProgramModal/ReplaceProgramModal");
var _useGetTrainerProgramPlanList = require("src/api/mutations/useGetTrainerProgramPlanList");
var _useDeleteProgramPlan = require("src/api/mutations/useDeleteProgramPlan");
var _sessionStore = require("src/store/sessionStore");
var _clientSelectionStep = require("./components/ClientSelectionStep");
var _energyLevelStep = require("./components/EnergyLevelStep");
var _fitnessLevelStep = require("./components/FitnessLevelStep");
var _activityLevelStep = require("./components/ActivityLevelStep");
var _movementInsightsStep = require("./components/MovementInsightsStep");
var _onboardNewClientPromptStep = require("./components/OnboardNewClientPromptStep");
var _injuriesLimitationsStep = require("./components/InjuriesLimitationsStep");
var _programDurationStep = require("./components/ProgramDurationStep");
var _howOftenTrainStep = require("./components/HowOftenTrainStep");
var _workoutDurationStep = require("./components/WorkoutDurationStep");
var _trainingGoalStep = require("./components/TrainingGoalStep");
var _increaseStrengthStep1 = require("./components/IncreaseStrengthStep1");
var _increaseStrengthStep2 = require("./components/IncreaseStrengthStep2");
var _increaseStrengthStep3 = require("./components/IncreaseStrengthStep3");
var _enduranceStep1 = require("./components/EnduranceStep1");
var _enduranceStep2 = require("./components/EnduranceStep2");
var _performanceStep1 = require("./components/PerformanceStep1");
var _performanceStep2 = require("./components/PerformanceStep2");
var _performanceStep3 = require("./components/PerformanceStep3");
var _generalFitnessStep1 = require("./components/GeneralFitnessStep1");
var _generalFitnessStep2 = require("./components/GeneralFitnessStep2");
var _injuryPreventionStep1 = require("./components/InjuryPreventionStep1");
var _injuryPreventionStep2 = require("./components/InjuryPreventionStep2");
var _injuryPreventionStep3 = require("./components/InjuryPreventionStep3");
var _rehabilitationStep1 = require("./components/RehabilitationStep1");
var _rehabilitationStep2 = require("./components/RehabilitationStep2");
var _rehabilitationStep3 = require("./components/RehabilitationStep3");
var _mobilityStep1 = require("./components/MobilityStep1");
var _mobilityStep2 = require("./components/MobilityStep2");
var _mobilityStep3 = require("./components/MobilityStep3");
var _buildMuscleStep1 = require("./components/BuildMuscleStep1");
var _buildMuscleStep2 = require("./components/BuildMuscleStep2");
var _buildMuscleStep3 = require("./components/BuildMuscleStep3");
var _weightLossStep1 = require("./components/WeightLossStep1");
var _weightLossStep2 = require("./components/WeightLossStep2");
var _weightLossStep3 = require("./components/WeightLossStep3");
var _weightLossStep4 = require("./components/WeightLossStep4");
var _secondaryTrainingGoalStep = require("./components/SecondaryTrainingGoalStep");
var _intensityVibeStep = require("./components/IntensityVibeStep");
var _selectEquipmentStep = require("./components/SelectEquipmentStep");
var _reviewStep = require("./components/ReviewStep");
var _programNameStep = require("./components/ProgramNameStep");
var _button = require("src/components/Button/Button");
var _constants = require("./constants");
var _types = require("./types");
var _programGeneratorAIScss = require("./ProgramGeneratorAI.scss");
var _backSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/back.svg");
var _nextSvg = require("../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/next.svg");
const ProgramGeneratorAI = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { by } = (0, _reactRouterDom.useParams)();
    const location = (0, _reactRouterDom.useLocation)();
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const stepParam = searchParams.get('step');
    const goalParam = searchParams.get('goal');
    const subStepParam = searchParams.get('subStep');
    const getIndexFromSlug = (0, _react.useCallback)((goal, slug)=>{
        if (!slug) return 1;
        let slugs = [];
        if (stepParam === 'movement-insights') slugs = (0, _constants.MOVEMENT_INSIGHT_SLUGS);
        else if (goal) slugs = (0, _constants.getSubStepSlugs)(goal);
        const idx = slugs.indexOf(slug);
        return idx !== -1 ? idx + 1 : 1;
    }, [
        stepParam
    ]);
    const isCreatingRef = (0, _react.useRef)(false);
    const urlProgramId = searchParams.get('programId');
    const onboardingOnly = searchParams.get('onboardingOnly') === 'true';
    const { data: programDataList, isLoading: isLoadingProgram } = (0, _useGetPrograms.useGetPrograms)({
        program_ids: urlProgramId ? [
            urlProgramId
        ] : []
    }, {
        enabled: !!urlProgramId
    });
    const draftProgram = programDataList?.[0];
    const [hasResumed, setHasResumed] = (0, _react.useState)(false);
    const getNextStepInfo = (0, _react.useCallback)((progress)=>{
        if (!progress['energy_level'] || progress['energy_level'].length === 0) return {
            step: 3,
            subStep: null
        };
        if (!progress['activity_level'] || progress['activity_level'].length === 0) return {
            step: 4,
            subStep: null
        };
        if (!progress['fitness_level'] || progress['fitness_level'].length === 0) return {
            step: 5,
            subStep: null
        };
        const movementProgress = progress['movement_insights'] || [];
        if (movementProgress.length < 5) {
            const currentSubIndex = movementProgress.length + 1;
            const subSlug = (0, _constants.MOVEMENT_INSIGHT_SLUGS)[currentSubIndex - 1] || (0, _constants.MOVEMENT_INSIGHT_SLUGS)[0];
            return {
                step: 6,
                subStep: subSlug
            };
        }
        if (!progress['injuries_parts'] || progress['injuries_parts'].length === 0) return {
            step: 7,
            subStep: null
        };
        if (!progress['program_duration'] || progress['program_duration'].length === 0) return {
            step: 8,
            subStep: null
        };
        if (!progress['how_often_train'] || progress['how_often_train'].length === 0) return {
            step: 10,
            subStep: null
        };
        if (!progress['workout_duration'] || progress['workout_duration'].length === 0) return {
            step: 11,
            subStep: null
        };
        if (!progress['training_goal'] || progress['training_goal'].length === 0) return {
            step: 12,
            subStep: null
        };
        const goal = progress['training_goal']?.[0]?.value || '';
        const subSlugs = (0, _constants.getSubStepSlugs)(goal);
        const goalKeysMap = {
            [(0, _types.TrainingGoalSlug).IncreaseStrength]: [
                'increase_strength_focus',
                'increase_strength_outcome',
                'increase_strength_approach'
            ],
            [(0, _types.TrainingGoalSlug).BuildMuscle]: [
                'build_muscle_primary',
                'build_muscle_secondary',
                'build_muscle_approach'
            ],
            [(0, _types.TrainingGoalSlug).WeightLoss]: [
                'weight_loss_primary',
                'weight_loss_secondary',
                'weight_loss_target',
                'weight_loss_approach'
            ],
            [(0, _types.TrainingGoalSlug).Endurance]: [
                'endurance_type',
                'endurance_approach'
            ],
            [(0, _types.TrainingGoalSlug).Mobility]: [
                'mobility_area',
                'mobility_purpose',
                'mobility_approach'
            ],
            [(0, _types.TrainingGoalSlug).Performance]: [
                'performance_support',
                'performance_focus',
                'performance_approach'
            ],
            [(0, _types.TrainingGoalSlug).GeneralFitness]: [
                'general_fitness_meaning',
                'general_fitness_approach'
            ],
            [(0, _types.TrainingGoalSlug).Rehabilitation]: [
                'rehabilitation_area',
                'rehabilitation_stage',
                'rehabilitation_approach'
            ],
            [(0, _types.TrainingGoalSlug).InjuryPrevention]: [
                'injury_prevention_area',
                'injury_prevention_focus',
                'injury_prevention_approach'
            ]
        };
        const keys = goalKeysMap[goal] || [];
        for(let i = 0; i < keys.length; i++){
            const key = keys[i];
            if (!progress[key] || progress[key].length === 0) {
                const subSlug = subSlugs[i] || subSlugs[0];
                return {
                    step: 13,
                    subStep: subSlug
                };
            }
        }
        if (!progress['secondary_goals'] || progress['secondary_goals'].length === 0) return {
            step: 14,
            subStep: null
        };
        if (!progress['intensity'] || progress['intensity'].length === 0) return {
            step: 15,
            subStep: null
        };
        if (!progress['selected_equipment'] || progress['selected_equipment'].length === 0) return {
            step: 16,
            subStep: null
        };
        return {
            step: 17,
            subStep: null
        };
    }, []);
    const urlClientId = searchParams.get('clientId');
    const urlFrom = searchParams.get('from');
    const { checkProfile, isChecking: isCheckingProfile } = (0, _useCheckClientFitnessProfile.useCheckClientFitnessProfile)();
    const [hasInitializedClient, setHasInitializedClient] = (0, _react.useState)(false);
    const isHydratingProfileRef = (0, _react.useRef)(!!urlClientId && !urlProgramId);
    const currentSlugIndex = (0, _constants.PROGRAM_GENERATOR_SLUGS).indexOf(stepParam || (by === 'manual' ? 'client-selection' : 'intro'));
    const [step, setStep] = (0, _react.useState)(currentSlugIndex !== -1 ? currentSlugIndex + 1 : 1);
    const [currentSubStepIndex, setCurrentSubStepIndex] = (0, _react.useState)(getIndexFromSlug(goalParam, subStepParam));
    const [movementInsightIndex, setMovementInsightIndex] = (0, _react.useState)(stepParam === 'movement-insights' ? getIndexFromSlug(null, subStepParam) : 1);
    const navigateToStep = (0, _react.useCallback)((nextStepIndex)=>{
        setStep(nextStepIndex);
        const slug = (0, _constants.PROGRAM_GENERATOR_SLUGS)[nextStepIndex - 1];
        if (slug) {
            const params = new URLSearchParams(searchParams);
            params.set('step', slug);
            // Clear subStep param if not on a step that supports it
            if (nextStepIndex !== 6 && nextStepIndex !== 13) params.delete('subStep');
            // We do NOT use replace: true so that moving forward creates a new history entry
            navigate(`${location.pathname}?${params.toString()}`);
        }
    }, [
        searchParams,
        navigate,
        location.pathname,
        setStep
    ]);
    (0, _react.useEffect)(()=>{
        if (draftProgram && !hasResumed) {
            const initialize = async ()=>{
                const store = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState();
                store.setProgramId(draftProgram.id);
                store.setClientId(draftProgram.client_id);
                if (draftProgram.progress) store.setProgress(draftProgram.progress);
                // Fetch the fitness profile so the store has BOTH program and fitness data
                if (draftProgram.client_id) await checkProfile(draftProgram.client_id);
                const combinedProgress = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().progress;
                const nextInfo = getNextStepInfo(combinedProgress);
                const nextSlug = (0, _constants.PROGRAM_GENERATOR_SLUGS)[nextInfo.step - 1];
                setHasResumed(true);
                const isEditMode = searchParams.get('editMode') === 'true' || !!searchParams.get('step');
                if (!isEditMode) {
                    const params = new URLSearchParams(searchParams);
                    params.set('step', nextSlug);
                    if (nextInfo.subStep) params.set('subStep', nextInfo.subStep);
                    else params.delete('subStep');
                    if (combinedProgress?.['training_goal']?.[0]?.value) params.set('goal', combinedProgress['training_goal'][0].value);
                    navigate(`${location.pathname}?${params.toString()}`, {
                        replace: true
                    });
                }
            };
            initialize();
        }
    }, [
        draftProgram,
        hasResumed,
        navigate,
        location.pathname,
        searchParams,
        getNextStepInfo,
        checkProfile
    ]);
    (0, _react.useEffect)(()=>{
        if (urlClientId && !urlProgramId && !hasInitializedClient) {
            const isEditMode = searchParams.get('editMode') === 'true' || !!stepParam;
            const isFromClientProfile = urlFrom === 'client-profile';
            const store = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState();
            if (store.clientId !== urlClientId || isFromClientProfile) {
                if (store.clientId !== urlClientId) store.setProgress({});
                store.setClientId(urlClientId);
            }
            setHasInitializedClient(true);
            isHydratingProfileRef.current = true;
            checkProfile(urlClientId).then((_nextStep)=>{
                isHydratingProfileRef.current = false;
                if (!isEditMode && !stepParam) navigateToStep(_nextStep);
            });
        }
    }, [
        urlClientId,
        urlProgramId,
        hasInitializedClient,
        checkProfile,
        searchParams,
        stepParam,
        urlFrom,
        navigateToStep
    ]);
    // Intercept native browser back button (and other route exits)
    const blocker = (0, _reactRouterDom.useBlocker)(({ currentLocation, nextLocation })=>step > 2 && !isCreatingRef.current && (currentLocation.pathname !== nextLocation.pathname || nextLocation.search.includes('action=new_program') && !currentLocation.search.includes('action=new_program')) && !nextLocation.pathname.includes('/completed') && !nextLocation.pathname.includes('/program-generated'));
    const navigateToSubStep = (0, _react.useCallback)((goal, nextIdx)=>{
        if (step === 6) setMovementInsightIndex(nextIdx);
        else setCurrentSubStepIndex(nextIdx);
        const params = new URLSearchParams(searchParams);
        const subSlugs = step === 6 ? (0, _constants.MOVEMENT_INSIGHT_SLUGS) : goal ? (0, _constants.getSubStepSlugs)(goal) : [];
        const subSlug = subSlugs[nextIdx - 1];
        if (subSlug) {
            params.set('subStep', subSlug);
            // We do NOT use replace: true so that moving forward creates a new history entry
            navigate(`${location.pathname}?${params.toString()}`);
        } else navigate(`${location.pathname}?${params.toString()}`);
    }, [
        step,
        searchParams,
        navigate,
        location.pathname,
        setMovementInsightIndex,
        setCurrentSubStepIndex
    ]);
    const [isLoading] = (0, _react.useState)(false);
    const clientId = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore)((state)=>state.clientId);
    const [clientName, setClientName] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).ClientName, 'Client', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || 'Client');
    const [clientBodyProfile, setClientBodyProfile] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).ClientBodyProfile, 'male', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || 'male');
    const [trainingGoal, setTrainingGoal] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).TrainingGoal, goalParam || '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || goalParam || '');
    // Handle 'new_program' action which comes from sidebar 'Create (+)' click
    (0, _react.useEffect)(()=>{
        if (searchParams.get('action') === 'new_program') setTimeout(()=>{
            (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().resetProgress();
            const params = new URLSearchParams(searchParams);
            params.delete('action');
            params.delete('subStep');
            params.delete('goal');
            params.set('step', 'client-selection');
            navigate(`${location.pathname}?${params.toString()}`, {
                replace: true
            });
            setStep(1);
        }, 0);
    }, [
        searchParams,
        location.pathname,
        navigate
    ]);
    // Sync state with URL when user navigates using browser back/forward buttons
    (0, _react.useEffect)(()=>{
        const newSlugIndex = (0, _constants.PROGRAM_GENERATOR_SLUGS).indexOf(stepParam || (by === 'manual' ? 'client-selection' : 'intro'));
        if (newSlugIndex !== -1 && newSlugIndex + 1 !== step) setStep(newSlugIndex + 1);
        if (stepParam === 'movement-insights') {
            const idx = getIndexFromSlug(null, subStepParam);
            if (idx !== movementInsightIndex) setMovementInsightIndex(idx);
        } else {
            const idx = getIndexFromSlug(trainingGoal, subStepParam);
            if (idx !== currentSubStepIndex) setCurrentSubStepIndex(idx);
        }
    }, [
        stepParam,
        subStepParam,
        trainingGoal,
        by,
        movementInsightIndex,
        currentSubStepIndex,
        step,
        getIndexFromSlug
    ]);
    const [increaseStrengthFocus, setIncreaseStrengthFocus] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).IncreaseStrengthFocus, [], (vals)=>vals.map((v)=>({
                slug: v,
                value: v
            })), (items)=>items.map((i)=>i.value) || []);
    const [increaseStrengthOutcome, setIncreaseStrengthOutcome] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).IncreaseStrengthOutcome, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [increaseStrengthApproach, setIncreaseStrengthApproach] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).IncreaseStrengthApproach, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [enduranceType, setEnduranceType] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).EnduranceType, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [enduranceApproach, setEnduranceApproach] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).EnduranceApproach, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [programName, setProgramName] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).ProgramName, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [performanceSupport, setPerformanceSupport] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).PerformanceSupport, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [performanceFocus, setPerformanceFocus] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).PerformanceFocus, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [performanceApproach, setPerformanceApproach] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).PerformanceApproach, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [generalFitnessMeaning, setGeneralFitnessMeaning] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).GeneralFitnessMeaning, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [generalFitnessApproach, setGeneralFitnessApproach] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).GeneralFitnessApproach, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [injuryPreventionArea, setInjuryPreventionArea] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).InjuryPreventionArea, [], (vals)=>vals.map((v)=>({
                slug: v,
                value: v
            })), (items)=>items.map((i)=>i.value) || []);
    const [injuryPreventionFocus, setInjuryPreventionFocus] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).InjuryPreventionFocus, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [injuryPreventionApproach, setInjuryPreventionApproach] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).InjuryPreventionApproach, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [rehabilitationArea, setRehabilitationArea] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).RehabilitationArea, [], (vals)=>vals.map((v)=>({
                slug: v,
                value: v
            })), (items)=>items.map((i)=>i.value) || []);
    const [rehabilitationStage, setRehabilitationStage] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).RehabilitationStage, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [rehabilitationApproach, setRehabilitationApproach] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).RehabilitationApproach, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [mobilityArea, setMobilityArea] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).MobilityArea, [], (vals)=>vals.map((v)=>({
                slug: v,
                value: v
            })), (items)=>items.map((i)=>i.value) || []);
    const [mobilityPurpose, setMobilityPurpose] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).MobilityPurpose, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [mobilityApproach, setMobilityApproach] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).MobilityApproach, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [buildMusclePrimary, setBuildMusclePrimary] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).BuildMusclePrimary, [], (vals)=>vals.map((v)=>({
                slug: v,
                value: v
            })), (items)=>items.map((i)=>i.value) || []);
    const [buildMuscleSecondary, setBuildMuscleSecondary] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).BuildMuscleSecondary, [], (vals)=>vals.map((v)=>({
                slug: v,
                value: v
            })), (items)=>items.map((i)=>i.value) || []);
    const [buildMuscleApproach, setBuildMuscleApproach] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).BuildMuscleApproach, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [weightLossPrimary, setWeightLossPrimary] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).WeightLossPrimary, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [weightLossSecondary, setWeightLossSecondary] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).WeightLossSecondary, [], (vals)=>vals.map((v)=>({
                slug: v,
                value: v
            })), (items)=>items.map((i)=>i.value) || []);
    const [weightLossTarget, setWeightLossTarget] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).WeightLossTarget, {
        target: 45,
        unit: 'Kg'
    }, (val)=>[
            {
                slug: String(val.target),
                value: val.unit
            }
        ], (items)=>items[0] ? {
            target: Number(items[0].slug),
            unit: items[0].value
        } : {
            target: 45,
            unit: 'Kg'
        });
    const [weightLossApproach, setWeightLossApproach] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).WeightLossApproach, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [secondaryGoals, setSecondaryGoals] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).SecondaryGoals, [], (vals)=>vals.map((v)=>({
                slug: v,
                value: v
            })), (items)=>items.map((i)=>i.value) || []);
    const [selectedEquipment, setSelectedEquipment] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).SelectedEquipment, [], (vals)=>vals.map((v)=>({
                slug: v,
                value: v
            })), (items)=>items.map((i)=>i.value) || []);
    const [injuriesParts, setInjuriesParts] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).InjuriesParts, [], (vals)=>vals.map((v)=>({
                slug: v,
                value: v
            })), (items)=>items.map((i)=>i.value) || []);
    const [injuriesNotes, setInjuriesNotes] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).InjuriesNotes, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    // Lifted states
    const [energyLevel, setEnergyLevel] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).EnergyLevel, 'often-low', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || 'often-low');
    const [activityLevel, setActivityLevel] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).ActivityLevel, 10, (val)=>[
            {
                slug: String(val),
                value: String(val)
            }
        ], (items)=>items[0]?.value ? Number(items[0].value) : 10);
    const [fitnessLevel, setFitnessLevel] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).FitnessLevel, 'beginner', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value ? items[0].value : 'beginner');
    const [movementInsights, setMovementInsights] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).MovementInsights, [
        'pain',
        'pain',
        'pain',
        'pain',
        'pain'
    ], (vals)=>vals.map((v, i)=>({
                slug: (0, _constants.MOVEMENT_INSIGHT_SLUGS)[i] || String(i),
                value: v
            })), (items)=>items.length > 0 ? items.map((i)=>i.value) : [
            'pain',
            'pain',
            'pain',
            'pain',
            'pain'
        ]);
    const [programDuration, setProgramDuration] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).ProgramDuration, 1, (val)=>[
            {
                slug: `${val}-week${val > 1 ? 's' : ''}`,
                value: `${val}-week${val > 1 ? 's' : ''}`
            }
        ], (items)=>items[0]?.value ? parseInt(items[0].value, 10) : 1);
    const [howOftenTrain, setHowOftenTrain] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).HowOftenTrain, [], (vals)=>vals.map((v)=>({
                slug: v,
                value: v
            })), (items)=>items.map((i)=>i.value) || []);
    const [howOftenTrainReminder, setHowOftenTrainReminder] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).HowOftenTrainReminder, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [workoutDuration, setWorkoutDuration] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).WorkoutDuration, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [intensity, setIntensity] = (0, _useStepProgress.useStepProgress)((0, _types.ProgramStepId).Intensity, '', (val)=>[
            {
                slug: val,
                value: val
            }
        ], (items)=>items[0]?.value || '');
    const [isEditingFromReview, setIsEditingFromReview] = (0, _react.useState)(false);
    const [showReplaceProgramModal, setShowReplaceProgramModal] = (0, _react.useState)(false);
    const [clientPrograms, setClientPrograms] = (0, _react.useState)([]);
    const [isReplacingProgram, setIsReplacingProgram] = (0, _react.useState)(false);
    const [isCheckingPrograms, setIsCheckingPrograms] = (0, _react.useState)(false);
    const currentUser = (0, _sessionStore.sessionStore)((state)=>state.currentUser);
    const trainerId = currentUser?.uid;
    const { mutateAsync: deleteProgram } = (0, _useDeleteProgramPlan.useDeleteProgramPlan)();
    const videoContainerRef = (0, _react.useRef)(null);
    const videoRef = (0, _react.useRef)(null);
    // Calculate progress percentage assuming 17 steps max for now
    const totalSteps = 17;
    (0, _react.useEffect)(()=>{
        const video = videoRef.current;
        if (video) {
            video.muted = true;
            video.defaultMuted = true;
            const playPromise = video.play();
            if (playPromise !== undefined) playPromise.catch(()=>{});
        }
    }, [
        step
    ]);
    (0, _react.useEffect)(()=>{
        if (videoContainerRef.current) {
            if (step >= 2 && step !== 8) (0, _gsapSetupDefault.default).set(videoContainerRef.current, {
                top: '40px',
                y: 0,
                yPercent: 0,
                scale: 1,
                width: 100,
                height: 100
            });
        }
    }, [
        by,
        step,
        isLoadingProgram,
        hasResumed
    ]);
    (0, _react.useEffect)(()=>{
        if (step === 8 && videoContainerRef.current) {
            (0, _gsapSetupDefault.default).to(videoContainerRef.current, {
                top: 'calc(50% - 80px)',
                y: 0,
                yPercent: -50,
                scale: 1,
                width: 250,
                height: 250,
                duration: 1,
                ease: 'power3.inOut'
            });
            (0, _gsapSetupDefault.default).to('.animation-content-8', {
                opacity: 1,
                duration: 0.5
            });
        }
    }, [
        step
    ]);
    const isEquipmentMandatory = (0, _react.useCallback)(()=>{
        let currentApproach = '';
        switch(trainingGoal){
            case (0, _types.TrainingGoalSlug).IncreaseStrength:
                currentApproach = increaseStrengthApproach;
                break;
            case (0, _types.TrainingGoalSlug).BuildMuscle:
                currentApproach = buildMuscleApproach;
                break;
            case (0, _types.TrainingGoalSlug).WeightLoss:
                currentApproach = weightLossApproach;
                break;
            case (0, _types.TrainingGoalSlug).Endurance:
                currentApproach = enduranceApproach;
                break;
            case (0, _types.TrainingGoalSlug).Mobility:
                currentApproach = mobilityApproach;
                break;
            case (0, _types.TrainingGoalSlug).Performance:
                currentApproach = performanceApproach;
                break;
            case (0, _types.TrainingGoalSlug).GeneralFitness:
                currentApproach = generalFitnessApproach;
                break;
            case (0, _types.TrainingGoalSlug).Rehabilitation:
                currentApproach = rehabilitationApproach;
                break;
            case (0, _types.TrainingGoalSlug).InjuryPrevention:
                currentApproach = injuryPreventionApproach;
                break;
        }
        return (0, _constants.EQUIPMENT_MANDATORY_APPROACHES).includes(currentApproach);
    }, [
        trainingGoal,
        increaseStrengthApproach,
        buildMuscleApproach,
        weightLossApproach,
        enduranceApproach,
        mobilityApproach,
        performanceApproach,
        generalFitnessApproach,
        rehabilitationApproach,
        injuryPreventionApproach
    ]);
    const getEarliestIncompleteStep = (0, _react.useCallback)(()=>{
        const checkPast = (minStep)=>step > minStep || isEditingFromReview;
        const isManual = by === 'manual';
        if (isManual) {
            if (checkPast(2) && !clientId) return {
                stepIndex: 2
            };
            if (checkPast(9) && !programDuration) return {
                stepIndex: 9
            };
            if (checkPast(10) && (howOftenTrain.length === 0 || !howOftenTrainReminder)) return {
                stepIndex: 10
            };
            return null;
        }
        if (checkPast(2) && !clientId && by !== 'manual') return {
            stepIndex: 2
        };
        if (checkPast(3) && !energyLevel) return {
            stepIndex: 3
        };
        if (checkPast(7) && injuriesNotes.trim() !== '' && !/\p{L}/u.test(injuriesNotes)) return {
            stepIndex: 7
        };
        if (checkPast(10) && (howOftenTrain.length === 0 || !howOftenTrainReminder)) return {
            stepIndex: 10
        };
        if (checkPast(11) && !workoutDuration) return {
            stepIndex: 11
        };
        if (checkPast(12) && !trainingGoal) return {
            stepIndex: 12
        };
        if (checkPast(12) || step === 13) {
            const isPast = (idx)=>checkPast(13) || currentSubStepIndex > idx;
            if (trainingGoal === (0, _types.TrainingGoalSlug).IncreaseStrength) {
                if (isPast(1) && increaseStrengthFocus.length === 0) return {
                    stepIndex: 13,
                    subStepIndex: 1
                };
                if (isPast(2) && !increaseStrengthOutcome) return {
                    stepIndex: 13,
                    subStepIndex: 2
                };
                if (isPast(3) && !increaseStrengthApproach) return {
                    stepIndex: 13,
                    subStepIndex: 3
                };
            } else if (trainingGoal === (0, _types.TrainingGoalSlug).BuildMuscle) {
                if (isPast(1) && buildMusclePrimary.length === 0) return {
                    stepIndex: 13,
                    subStepIndex: 1
                };
                if (isPast(2) && buildMuscleSecondary.length === 0) return {
                    stepIndex: 13,
                    subStepIndex: 2
                };
                if (isPast(3) && !buildMuscleApproach) return {
                    stepIndex: 13,
                    subStepIndex: 3
                };
            } else if (trainingGoal === (0, _types.TrainingGoalSlug).WeightLoss) {
                if (isPast(1) && !weightLossPrimary) return {
                    stepIndex: 13,
                    subStepIndex: 1
                };
                if (isPast(2) && weightLossSecondary.length === 0) return {
                    stepIndex: 13,
                    subStepIndex: 2
                };
                if (isPast(3) && !weightLossTarget) return {
                    stepIndex: 13,
                    subStepIndex: 3
                };
                if (isPast(4) && !weightLossApproach) return {
                    stepIndex: 13,
                    subStepIndex: 4
                };
            } else if (trainingGoal === (0, _types.TrainingGoalSlug).Endurance) {
                if (isPast(1) && !enduranceType) return {
                    stepIndex: 13,
                    subStepIndex: 1
                };
                if (isPast(2) && !enduranceApproach) return {
                    stepIndex: 13,
                    subStepIndex: 2
                };
            } else if (trainingGoal === (0, _types.TrainingGoalSlug).Mobility) {
                if (isPast(1) && mobilityArea.length === 0) return {
                    stepIndex: 13,
                    subStepIndex: 1
                };
                if (isPast(2) && !mobilityPurpose) return {
                    stepIndex: 13,
                    subStepIndex: 2
                };
                if (isPast(3) && !mobilityApproach) return {
                    stepIndex: 13,
                    subStepIndex: 3
                };
            } else if (trainingGoal === (0, _types.TrainingGoalSlug).Performance) {
                if (isPast(1) && !performanceSupport) return {
                    stepIndex: 13,
                    subStepIndex: 1
                };
                if (isPast(2) && !performanceFocus) return {
                    stepIndex: 13,
                    subStepIndex: 2
                };
                if (isPast(3) && !performanceApproach) return {
                    stepIndex: 13,
                    subStepIndex: 3
                };
            } else if (trainingGoal === (0, _types.TrainingGoalSlug).GeneralFitness) {
                if (isPast(1) && !generalFitnessMeaning) return {
                    stepIndex: 13,
                    subStepIndex: 1
                };
                if (isPast(2) && !generalFitnessApproach) return {
                    stepIndex: 13,
                    subStepIndex: 2
                };
            } else if (trainingGoal === (0, _types.TrainingGoalSlug).Rehabilitation) {
                if (isPast(1)) {
                    let isRehabAreaValid = true;
                    if (rehabilitationArea.length === 0) isRehabAreaValid = false;
                    else {
                        const otherVal = rehabilitationArea.find((v)=>v.startsWith('other:'));
                        if (otherVal) {
                            const text = otherVal.replace('other:', '').trim();
                            if (text === '' || !/\p{L}/u.test(text)) isRehabAreaValid = false;
                        }
                    }
                    if (!isRehabAreaValid) return {
                        stepIndex: 13,
                        subStepIndex: 1
                    };
                }
                if (isPast(2) && !rehabilitationStage) return {
                    stepIndex: 13,
                    subStepIndex: 2
                };
                if (isPast(3) && !rehabilitationApproach) return {
                    stepIndex: 13,
                    subStepIndex: 3
                };
            } else if (trainingGoal === (0, _types.TrainingGoalSlug).InjuryPrevention) {
                if (isPast(1) && injuryPreventionArea.length === 0) return {
                    stepIndex: 13,
                    subStepIndex: 1
                };
                if (isPast(2) && !injuryPreventionFocus) return {
                    stepIndex: 13,
                    subStepIndex: 2
                };
                if (isPast(3) && !injuryPreventionApproach) return {
                    stepIndex: 13,
                    subStepIndex: 3
                };
            }
        }
        if (checkPast(15) && !intensity) return {
            stepIndex: 15
        };
        if (checkPast(16) && isEquipmentMandatory() && selectedEquipment.length === 0) return {
            stepIndex: 16
        };
        return null;
    }, [
        step,
        currentSubStepIndex,
        clientId,
        programDuration,
        energyLevel,
        injuriesNotes,
        howOftenTrain.length,
        howOftenTrainReminder,
        workoutDuration,
        trainingGoal,
        increaseStrengthFocus,
        increaseStrengthOutcome,
        increaseStrengthApproach,
        buildMusclePrimary.length,
        buildMuscleSecondary.length,
        buildMuscleApproach,
        weightLossPrimary,
        weightLossSecondary.length,
        weightLossTarget,
        weightLossApproach,
        enduranceType,
        enduranceApproach,
        mobilityArea,
        mobilityPurpose,
        mobilityApproach,
        performanceSupport,
        performanceFocus,
        performanceApproach,
        generalFitnessMeaning,
        generalFitnessApproach,
        rehabilitationArea,
        rehabilitationStage,
        rehabilitationApproach,
        injuryPreventionArea,
        injuryPreventionFocus,
        injuryPreventionApproach,
        intensity,
        selectedEquipment.length,
        isEquipmentMandatory,
        isEditingFromReview,
        by
    ]);
    const hasIncompleteStepAhead = (0, _react.useCallback)(()=>{
        const incomplete = getEarliestIncompleteStep();
        if (!incomplete) return false;
        if (incomplete.stepIndex > step) return true;
        if (incomplete.stepIndex === step && incomplete.subStepIndex && incomplete.subStepIndex > currentSubStepIndex) return true;
        return false;
    }, [
        getEarliestIncompleteStep,
        step,
        currentSubStepIndex
    ]);
    // Redirect to earliest incomplete step if user skips ahead via URL
    (0, _react.useEffect)(()=>{
        const isEditMode = searchParams.get('editMode') === 'true' || !!stepParam;
        // Only enforce this if we are not actively loading or editing
        if (isLoading || isEditingFromReview || isCheckingProfile || isHydratingProfileRef.current || isEditMode) return;
        const incomplete = getEarliestIncompleteStep();
        if (incomplete) {
            if (incomplete.stepIndex === 2 && !clientId && by !== 'manual') navigateToStep(1); // Redirect AI flow to Intro instead of client selection
            else if (incomplete.subStepIndex) {
                // Just directly navigate to the missing sub step
                setStep(13);
                setCurrentSubStepIndex(incomplete.subStepIndex);
                const slug = (0, _constants.PROGRAM_GENERATOR_SLUGS)[12];
                const params = new URLSearchParams(searchParams);
                params.set('step', slug);
                const subSlugs = (0, _constants.getSubStepSlugs)(trainingGoal);
                const subSlug = subSlugs[incomplete.subStepIndex - 1];
                if (subSlug) params.set('subStep', subSlug);
                navigate(`${location.pathname}?${params.toString()}`);
            } else navigateToStep(incomplete.stepIndex);
        }
    }, [
        getEarliestIncompleteStep,
        isLoading,
        isCheckingProfile,
        isEditingFromReview,
        by,
        navigate,
        location.pathname,
        searchParams,
        trainingGoal,
        clientId,
        navigateToStep,
        stepParam
    ]);
    const handleAnimationComplete = ()=>{
        setTimeout(()=>{
            // Fade out the step 1 text and orb text
            (0, _gsapSetupDefault.default).to('.animation-content, .mini-pt-text', {
                opacity: 0,
                duration: 0.5
            });
            // Animate the main orb to the top of the screen
            (0, _gsapSetupDefault.default).to(videoContainerRef.current, {
                top: '40px',
                y: 0,
                yPercent: 0,
                scale: 1,
                width: 100,
                height: 100,
                duration: 1,
                ease: 'power3.inOut',
                onComplete: ()=>{
                    navigateToStep(2);
                }
            });
        }, 1500);
    };
    const handleAnimation8Complete = ()=>{
        setTimeout(()=>{
            (0, _gsapSetupDefault.default).to('.animation-content-8', {
                opacity: 0,
                duration: 0.5
            });
            (0, _gsapSetupDefault.default).to(videoContainerRef.current, {
                top: '40px',
                y: 0,
                yPercent: 0,
                scale: 1,
                width: 100,
                height: 100,
                duration: 1,
                ease: 'power3.inOut',
                onComplete: ()=>{
                    navigateToStep(9);
                }
            });
        }, 1500);
    };
    const handleNext = (selectedGoalOrClientId)=>{
        // Disable if already loading
        if (isLoading || isCreatingRef.current || isCheckingProfile || isCheckingPrograms) return;
        // Force save the current state for steps with default values in case the user didn't change them
        if (step === 3) setEnergyLevel((prev)=>prev);
        if (step === 4) setActivityLevel((prev)=>prev);
        if (step === 5) setFitnessLevel((prev)=>prev);
        if (step === 6) setMovementInsights((prev)=>prev);
        if (step === 7) setInjuriesParts((prev)=>prev);
        if (step === 9) setProgramDuration((prev)=>prev);
        if (step === 10) {
            setHowOftenTrain((prev)=>prev);
            setHowOftenTrainReminder((prev)=>prev);
            if (by === 'manual') {
                navigateToStep(18);
                return;
            }
        }
        if (step === 18) {
            setProgramName((prev)=>prev);
            const programId = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().programId;
            setTimeout(()=>{
                navigate(`/onboarding-trainer/dashboard/program-generated/${programId}?isManually=true`);
            }, 300);
            return;
        }
        if (step === 11) setWorkoutDuration((prev)=>prev);
        const currentGoal = typeof selectedGoalOrClientId === 'string' ? selectedGoalOrClientId : trainingGoal;
        if (step === 12) setTrainingGoal(currentGoal);
        if (step === 13) {
            if (currentGoal === (0, _types.TrainingGoalSlug).IncreaseStrength) {
                if (currentSubStepIndex === 1) setIncreaseStrengthFocus((prev)=>prev);
                if (currentSubStepIndex === 2) setIncreaseStrengthOutcome((prev)=>prev);
                if (currentSubStepIndex === 3) setIncreaseStrengthApproach((prev)=>prev);
            } else if (currentGoal === (0, _types.TrainingGoalSlug).BuildMuscle) {
                if (currentSubStepIndex === 1) setBuildMusclePrimary((prev)=>prev);
                if (currentSubStepIndex === 2) setBuildMuscleSecondary((prev)=>prev);
                if (currentSubStepIndex === 3) setBuildMuscleApproach((prev)=>prev);
            } else if (currentGoal === (0, _types.TrainingGoalSlug).WeightLoss) {
                if (currentSubStepIndex === 1) setWeightLossPrimary((prev)=>prev);
                if (currentSubStepIndex === 2) setWeightLossSecondary((prev)=>prev);
                if (currentSubStepIndex === 3) setWeightLossTarget((prev)=>prev);
                if (currentSubStepIndex === 4) setWeightLossApproach((prev)=>prev);
            } else if (currentGoal === (0, _types.TrainingGoalSlug).Endurance) {
                if (currentSubStepIndex === 1) setEnduranceType((prev)=>prev);
                if (currentSubStepIndex === 2) setEnduranceApproach((prev)=>prev);
            } else if (currentGoal === (0, _types.TrainingGoalSlug).Mobility) {
                if (currentSubStepIndex === 1) setMobilityArea((prev)=>prev);
                if (currentSubStepIndex === 2) setMobilityPurpose((prev)=>prev);
                if (currentSubStepIndex === 3) setMobilityApproach((prev)=>prev);
            } else if (currentGoal === (0, _types.TrainingGoalSlug).Performance) {
                if (currentSubStepIndex === 1) setPerformanceSupport((prev)=>prev);
                if (currentSubStepIndex === 2) setPerformanceFocus((prev)=>prev);
                if (currentSubStepIndex === 3) setPerformanceApproach((prev)=>prev);
            } else if (currentGoal === (0, _types.TrainingGoalSlug).GeneralFitness) {
                if (currentSubStepIndex === 1) setGeneralFitnessMeaning((prev)=>prev);
                if (currentSubStepIndex === 2) setGeneralFitnessApproach((prev)=>prev);
            } else if (currentGoal === (0, _types.TrainingGoalSlug).Rehabilitation) {
                if (currentSubStepIndex === 1) setRehabilitationArea((prev)=>prev);
                if (currentSubStepIndex === 2) setRehabilitationStage((prev)=>prev);
                if (currentSubStepIndex === 3) setRehabilitationApproach((prev)=>prev);
            } else if (currentGoal === (0, _types.TrainingGoalSlug).InjuryPrevention) {
                if (currentSubStepIndex === 1) setInjuryPreventionArea((prev)=>prev);
                if (currentSubStepIndex === 2) setInjuryPreventionFocus((prev)=>prev);
                if (currentSubStepIndex === 3) setInjuryPreventionApproach((prev)=>prev);
            }
        }
        if (step === 14) setSecondaryGoals((prev)=>prev);
        if (step === 15) setIntensity((prev)=>prev);
        if (step === 16) setSelectedEquipment((prev)=>prev);
        if (step === 2) {
            const explicitClientId = typeof selectedGoalOrClientId === 'string' ? selectedGoalOrClientId : undefined;
            const targetClientId = explicitClientId || clientId || (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().clientId;
            if (!targetClientId) return;
            const handleProfileCheck = async (cid)=>{
                setIsCheckingPrograms(true);
                try {
                    if (trainerId) {
                        const programs = await (0, _useGetTrainerProgramPlanList.fetchTrainerProgramPlanList)(trainerId, {
                            clientId: cid,
                            isActive: '1'
                        });
                        const activeClientPrograms = (programs || []).filter((p)=>(p.clientId === cid || !p.clientId) && String(p.isActive) === '1');
                        if (activeClientPrograms.length > 0) {
                            setClientPrograms(activeClientPrograms);
                            setShowReplaceProgramModal(true);
                            setIsCheckingPrograms(false);
                            return; // Wait for modal response
                        }
                    }
                    if (by === 'manual') {
                        navigateToStep(9);
                        return;
                    }
                    const nextStep = await checkProfile(cid);
                    navigateToStep(Math.min(nextStep, totalSteps));
                } catch (err) {
                    console.error('Failed to check programs', err);
                    const nextStep = await checkProfile(cid);
                    navigateToStep(Math.min(nextStep, totalSteps));
                } finally{
                    setIsCheckingPrograms(false);
                }
            };
            handleProfileCheck(targetClientId);
            return;
        }
        if (step === 6 && movementInsightIndex < 5) navigateToSubStep(null, movementInsightIndex + 1);
        else if (step === 13) {
            const maxSubSteps = (0, _constants.getSubStepSlugs)(currentGoal).length;
            if (currentSubStepIndex < maxSubSteps) navigateToSubStep(currentGoal, currentSubStepIndex + 1);
            else navigateToStep(Math.min(step + 1, totalSteps));
        } else if (step === 12 && currentGoal !== (0, _types.TrainingGoalSlug).IncreaseStrength && currentGoal !== (0, _types.TrainingGoalSlug).Endurance && currentGoal !== (0, _types.TrainingGoalSlug).Performance && currentGoal !== (0, _types.TrainingGoalSlug).GeneralFitness && currentGoal !== (0, _types.TrainingGoalSlug).InjuryPrevention && currentGoal !== (0, _types.TrainingGoalSlug).Rehabilitation && currentGoal !== (0, _types.TrainingGoalSlug).Mobility && currentGoal !== (0, _types.TrainingGoalSlug).BuildMuscle && currentGoal !== (0, _types.TrainingGoalSlug).WeightLoss) // For now, other goals might not have extra steps, just advance
        navigateToStep(Math.min(step + 1, totalSteps));
        else {
            if (step === 1) handleAnimationComplete();
            else if (urlFrom === 'client-profile' && (step === 6 || step === 7)) {
                const cid = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().clientId || urlClientId;
                queryClient.invalidateQueries({
                    queryKey: [
                        'clientProfileTab'
                    ]
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        'clientOverview'
                    ]
                });
                // Add a slight delay before navigating to ensure backend processing completes
                setTimeout(()=>{
                    if (cid) navigate(`/onboarding-trainer/dashboard/clients/${cid}/client-profile`);
                    else navigate('/onboarding-trainer/dashboard/clients');
                }, 500);
            } else if (step === 7 && onboardingOnly) navigate('/onboarding-trainer/dashboard/clients');
            else navigateToStep(Math.min(step + 1, totalSteps));
        }
    };
    const handleEditStep = (stepIndex)=>{
        navigateToStep(stepIndex);
        setIsEditingFromReview(true);
    };
    const handleSaveEdit = ()=>{
        navigateToStep(17);
        setIsEditingFromReview(false);
    };
    const handleBack = ()=>{
        if (isLoading) return;
        if (step === 9) {
            if (by === 'manual') navigateToStep(2);
            else navigateToStep(7);
        } else if (step === 6 && movementInsightIndex > 1) navigateToSubStep(null, movementInsightIndex - 1);
        else if (step === 13 && currentSubStepIndex > 1) navigateToSubStep(trainingGoal, currentSubStepIndex - 1);
        else if (step === 2 && by === 'manual') navigate(-1);
        else if (step === 18 && by === 'manual') navigateToStep(10);
        else {
            if (step === 7) {
                const maxSubSteps = (0, _constants.MOVEMENT_INSIGHT_SLUGS).length;
                const prevSlug = (0, _constants.PROGRAM_GENERATOR_SLUGS)[5]; // 'movement-insights'
                const newParams = new URLSearchParams(searchParams);
                newParams.set('step', prevSlug);
                newParams.set('subStep', (0, _constants.MOVEMENT_INSIGHT_SLUGS)[maxSubSteps - 1]);
                navigate(`${location.pathname}?${newParams.toString()}`);
                return;
            }
            if (step === 14) {
                const maxSubSteps = (0, _constants.getSubStepSlugs)(trainingGoal).length;
                const prevSlug = (0, _constants.PROGRAM_GENERATOR_SLUGS)[12]; // 'training-goal-details'
                const newParams = new URLSearchParams(searchParams);
                newParams.set('step', prevSlug);
                newParams.set('subStep', (0, _constants.getSubStepSlugs)(trainingGoal)[maxSubSteps - 1]);
                navigate(`${location.pathname}?${newParams.toString()}`);
                return;
            }
            navigateToStep(Math.max(step - 1, 2));
        }
    };
    const handleClientSelect = (0, _react.useCallback)((name, uid, bodyProfile)=>{
        const store = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState();
        if (uid && uid !== store.clientId) {
            store.resetProgress();
            store.setClientId(uid);
        } else if (uid) store.setClientId(uid);
        setClientName(name);
        if (bodyProfile) setClientBodyProfile(bodyProfile);
    }, [
        setClientName,
        setClientBodyProfile
    ]);
    const isNextDisabled = ()=>{
        if (isLoading) return true;
        switch(step){
            case 2:
                return !clientId;
            case 3:
                return !energyLevel;
            case 7:
                return injuriesNotes.trim() !== '' && !/\p{L}/u.test(injuriesNotes);
            case 10:
                return howOftenTrain.length === 0 || !howOftenTrainReminder;
            case 11:
                return !workoutDuration;
            case 12:
                return !trainingGoal;
            case 13:
                if (trainingGoal === (0, _types.TrainingGoalSlug).IncreaseStrength) {
                    if (currentSubStepIndex === 1) return increaseStrengthFocus.length === 0;
                    if (currentSubStepIndex === 2) return !increaseStrengthOutcome;
                    if (currentSubStepIndex === 3) return !increaseStrengthApproach;
                } else if (trainingGoal === (0, _types.TrainingGoalSlug).BuildMuscle) {
                    if (currentSubStepIndex === 1) return buildMusclePrimary.length === 0;
                    if (currentSubStepIndex === 2) return buildMuscleSecondary.length === 0;
                    if (currentSubStepIndex === 3) return !buildMuscleApproach;
                } else if (trainingGoal === (0, _types.TrainingGoalSlug).WeightLoss) {
                    if (currentSubStepIndex === 1) return !weightLossPrimary;
                    if (currentSubStepIndex === 2) return weightLossSecondary.length === 0;
                    if (currentSubStepIndex === 3) return !weightLossTarget;
                    if (currentSubStepIndex === 4) return !weightLossApproach;
                } else if (trainingGoal === (0, _types.TrainingGoalSlug).Endurance) {
                    if (currentSubStepIndex === 1) return !enduranceType;
                    if (currentSubStepIndex === 2) return !enduranceApproach;
                } else if (trainingGoal === (0, _types.TrainingGoalSlug).Mobility) {
                    if (currentSubStepIndex === 1) return mobilityArea.length === 0;
                    if (currentSubStepIndex === 2) return !mobilityPurpose;
                    if (currentSubStepIndex === 3) return !mobilityApproach;
                } else if (trainingGoal === (0, _types.TrainingGoalSlug).Performance) {
                    if (currentSubStepIndex === 1) return !performanceSupport;
                    if (currentSubStepIndex === 2) return !performanceFocus;
                    if (currentSubStepIndex === 3) return !performanceApproach;
                } else if (trainingGoal === (0, _types.TrainingGoalSlug).GeneralFitness) {
                    if (currentSubStepIndex === 1) return !generalFitnessMeaning;
                    if (currentSubStepIndex === 2) return !generalFitnessApproach;
                } else if (trainingGoal === (0, _types.TrainingGoalSlug).Rehabilitation) {
                    if (currentSubStepIndex === 1) {
                        if (rehabilitationArea.length === 0) return true;
                        const otherVal = rehabilitationArea.find((v)=>v.startsWith('other:'));
                        if (otherVal !== undefined) {
                            const text = otherVal.replace('other:', '').trim();
                            if (text === '' || !/\p{L}/u.test(text)) return true;
                        }
                        return false;
                    }
                    if (currentSubStepIndex === 2) return !rehabilitationStage;
                    if (currentSubStepIndex === 3) return !rehabilitationApproach;
                } else if (trainingGoal === (0, _types.TrainingGoalSlug).InjuryPrevention) {
                    if (currentSubStepIndex === 1) return injuryPreventionArea.length === 0;
                    if (currentSubStepIndex === 2) return !injuryPreventionFocus;
                    if (currentSubStepIndex === 3) return !injuryPreventionApproach;
                }
                return false;
            case 15:
                return !intensity;
            case 16:
                if (isEquipmentMandatory()) return selectedEquipment.length === 0;
                return false;
            default:
                return false;
        }
    };
    const isFirstStepOfSection = ()=>{
        if (step === 3) return true; // Client Profile
        if (step === 6 && movementInsightIndex === 1) return true; // Movement Insights
        if (step === 7) return true; // Injuries & Notes
        if (step === 10) return true; // Plan Structure
        if (step === 12) return true; // Program Goals
        if (step === 15) return true; // Intensity & Setup
        return false;
    };
    const isSaveDisabled = ()=>{
        // Check if the entire form is valid to allow returning to the review screen
        if (!clientId && by !== 'manual') return true;
        if (!energyLevel) return true;
        if (injuriesNotes.trim() !== '' && !/\p{L}/u.test(injuriesNotes)) return true;
        if (howOftenTrain.length === 0 || !howOftenTrainReminder) return true;
        if (!workoutDuration) return true;
        if (!trainingGoal) return true;
        if (trainingGoal === (0, _types.TrainingGoalSlug).IncreaseStrength) {
            if (increaseStrengthFocus.length === 0 || !increaseStrengthOutcome || !increaseStrengthApproach) return true;
        } else if (trainingGoal === (0, _types.TrainingGoalSlug).BuildMuscle) {
            if (buildMusclePrimary.length === 0 || buildMuscleSecondary.length === 0 || !buildMuscleApproach) return true;
        } else if (trainingGoal === (0, _types.TrainingGoalSlug).WeightLoss) {
            if (!weightLossPrimary || weightLossSecondary.length === 0 || !weightLossTarget || !weightLossApproach) return true;
        } else if (trainingGoal === (0, _types.TrainingGoalSlug).Endurance) {
            if (!enduranceType || !enduranceApproach) return true;
        } else if (trainingGoal === (0, _types.TrainingGoalSlug).Mobility) {
            if (mobilityArea.length === 0 || !mobilityPurpose || !mobilityApproach) return true;
        } else if (trainingGoal === (0, _types.TrainingGoalSlug).Performance) {
            if (!performanceSupport || !performanceFocus || !performanceApproach) return true;
        } else if (trainingGoal === (0, _types.TrainingGoalSlug).GeneralFitness) {
            if (!generalFitnessMeaning || !generalFitnessApproach) return true;
        } else if (trainingGoal === (0, _types.TrainingGoalSlug).Rehabilitation) {
            let isRehabAreaValid = true;
            if (rehabilitationArea.length === 0) isRehabAreaValid = false;
            else {
                const otherVal = rehabilitationArea.find((v)=>v.startsWith('other:'));
                if (otherVal) {
                    const text = otherVal.replace('other:', '').trim();
                    if (text === '' || !/\p{L}/u.test(text)) isRehabAreaValid = false;
                }
            }
            if (!isRehabAreaValid || !rehabilitationStage || !rehabilitationApproach) return true;
        } else if (trainingGoal === (0, _types.TrainingGoalSlug).InjuryPrevention) {
            if (injuryPreventionArea.length === 0 || !injuryPreventionFocus || !injuryPreventionApproach) return true;
        }
        if (!intensity) return true;
        if (isEquipmentMandatory() && selectedEquipment.length === 0) return true;
        return false;
    };
    const isLastStepOfSection = ()=>{
        if (step === 5) return true; // Client Profile
        if (step === 6 && movementInsightIndex === 5) return true; // Movement Insights
        if (step === 7) return true; // Injuries & Notes
        if (step === 11) return true; // Plan Structure
        if (step === 14) return true; // Program Goals
        if (step === 16) return true; // Intensity & Setup
        return false;
    };
    const getGoalPriority = ()=>{
        switch(trainingGoal){
            case (0, _types.TrainingGoalSlug).IncreaseStrength:
                return increaseStrengthFocus;
            case (0, _types.TrainingGoalSlug).BuildMuscle:
                return buildMusclePrimary;
            case (0, _types.TrainingGoalSlug).WeightLoss:
                return weightLossPrimary ? [
                    weightLossPrimary
                ] : [];
            case (0, _types.TrainingGoalSlug).Endurance:
                return enduranceType ? [
                    enduranceType
                ] : [];
            case (0, _types.TrainingGoalSlug).Mobility:
                return mobilityArea;
            case (0, _types.TrainingGoalSlug).Performance:
                return performanceSupport ? [
                    performanceSupport
                ] : [];
            case (0, _types.TrainingGoalSlug).GeneralFitness:
                return generalFitnessMeaning ? [
                    generalFitnessMeaning
                ] : [];
            case (0, _types.TrainingGoalSlug).Rehabilitation:
                return rehabilitationArea;
            case (0, _types.TrainingGoalSlug).InjuryPrevention:
                return injuryPreventionArea;
            default:
                return [];
        }
    };
    const getGoalSecondary = ()=>{
        switch(trainingGoal){
            case (0, _types.TrainingGoalSlug).IncreaseStrength:
                return increaseStrengthOutcome ? [
                    increaseStrengthOutcome
                ] : [];
            case (0, _types.TrainingGoalSlug).BuildMuscle:
                return buildMuscleSecondary;
            case (0, _types.TrainingGoalSlug).WeightLoss:
                return weightLossSecondary;
            case (0, _types.TrainingGoalSlug).Endurance:
                return enduranceApproach ? [
                    enduranceApproach
                ] : [];
            case (0, _types.TrainingGoalSlug).Mobility:
                return mobilityPurpose ? [
                    mobilityPurpose
                ] : [];
            case (0, _types.TrainingGoalSlug).Performance:
                return performanceFocus ? [
                    performanceFocus
                ] : [];
            case (0, _types.TrainingGoalSlug).GeneralFitness:
                return generalFitnessApproach ? [
                    generalFitnessApproach
                ] : [];
            case (0, _types.TrainingGoalSlug).Rehabilitation:
                return rehabilitationStage ? [
                    rehabilitationStage
                ] : [];
            case (0, _types.TrainingGoalSlug).InjuryPrevention:
                return injuryPreventionFocus ? [
                    injuryPreventionFocus
                ] : [];
            default:
                return [];
        }
    };
    const getGoalApproach = ()=>{
        switch(trainingGoal){
            case (0, _types.TrainingGoalSlug).IncreaseStrength:
                return increaseStrengthApproach;
            case (0, _types.TrainingGoalSlug).BuildMuscle:
                return buildMuscleApproach;
            case (0, _types.TrainingGoalSlug).WeightLoss:
                return weightLossApproach;
            case (0, _types.TrainingGoalSlug).Mobility:
                return mobilityApproach;
            case (0, _types.TrainingGoalSlug).Performance:
                return performanceApproach;
            case (0, _types.TrainingGoalSlug).GeneralFitness:
                return generalFitnessApproach;
            case (0, _types.TrainingGoalSlug).Rehabilitation:
                return rehabilitationApproach;
            case (0, _types.TrainingGoalSlug).InjuryPrevention:
                return injuryPreventionApproach;
            case (0, _types.TrainingGoalSlug).Endurance:
            default:
                return '';
        }
    };
    const isProgressLoading = !!urlProgramId && (isLoadingProgram || !hasResumed);
    if (isProgressLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "dashboard-screen program-generator-ai-screen flex-center-column",
        style: {
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            background: 'transparent'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
            size: "large"
        })
    });
    const getProgressPercentage = ()=>{
        if (by === 'manual') {
            if (step === 2) return 33;
            if (step === 9) return 66;
            if (step === 10) return 100;
            return 0;
        }
        let effectiveStep = step;
        if (step === 6) effectiveStep = step + (movementInsightIndex - 1) / 5;
        else if (step === 13) {
            const maxSubSteps = (0, _constants.getSubStepSlugs)(trainingGoal).length;
            if (maxSubSteps > 0) effectiveStep = step + (currentSubStepIndex - 1) / maxSubSteps;
        }
        if (effectiveStep < 9) return Math.min((effectiveStep - 1) / 7 * 100, 100);
        else return Math.min((effectiveStep - 8) / (totalSteps - 8) * 100, 100);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `dashboard-screen program-generator-ai-screen ${step >= 2 && step !== 8 ? 'step-2-active' : ''}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "hero-glow-video-container flex-center-column",
                ref: videoContainerRef,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                        ref: videoRef,
                        src: (0, _miniPtCareMp4Default.default),
                        autoPlay: true,
                        muted: true,
                        loop: true,
                        playsInline: true,
                        preload: "auto",
                        className: "hero-glow-video",
                        onLoadedData: (e)=>{
                            e.currentTarget.muted = true;
                            e.currentTarget.play().catch(()=>{});
                        }
                    }),
                    (step === 1 || step === 8) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "mini-pt-text",
                        children: "miniPT Core"
                    }),
                    step >= 2 && step !== 8 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "mini-pt-text white-50",
                        children: "miniPT"
                    })
                ]
            }),
            step === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "animation-content max-width-768 animation-text-position",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAnimate.TextAnimate), {
                    animation: "slideUp",
                    by: "word",
                    as: "h2",
                    center: true,
                    className: "page-intro-title mt-0",
                    duration: 1,
                    delay: 0.05,
                    onComplete: handleAnimationComplete,
                    children: `Hi! I'm miniPT Core and I'll\ntake care of building your\nworkout program for you.`
                })
            }),
            step === 8 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "animation-content-8 max-width-768 animation-text-position flex-col-gap-8",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _textAnimate.TextAnimate), {
                    animation: "slideUp",
                    by: "word",
                    as: "h2",
                    center: true,
                    className: "page-intro-title mt-0",
                    duration: 1,
                    delay: 0.05,
                    onComplete: handleAnimation8Complete,
                    children: `Great! Now let's talk about the program`
                })
            }),
            step === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientSelectionStep.ClientSelectionStep), {
                    onClientSelect: handleClientSelect,
                    onNext: handleNext,
                    value: clientId,
                    isLoading: isLoading || isCheckingProfile || isCheckingPrograms
                })
            }),
            step === 2.1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onboardNewClientPromptStep.OnboardNewClientPromptStep), {
                    onNext: ()=>setStep(3),
                    onLater: ()=>{}
                })
            }),
            step === 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _energyLevelStep.EnergyLevelStep), {
                    clientName: clientName.split(' ')[0],
                    value: energyLevel,
                    onChange: (val)=>setEnergyLevel(val),
                    onNext: handleNext
                })
            }),
            step === 4 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _activityLevelStep.ActivityLevelStep), {
                    clientName: clientName.split(' ')[0],
                    value: activityLevel,
                    onChange: (val)=>setActivityLevel(val)
                })
            }),
            step === 5 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fitnessLevelStep.FitnessLevelStep), {
                    clientName: clientName.split(' ')[0],
                    value: fitnessLevel,
                    onChange: (val)=>setFitnessLevel(val)
                })
            }),
            step === 6 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movementInsightsStep.MovementInsightsStep), {
                    insightIndex: movementInsightIndex,
                    values: movementInsights,
                    onChange: (vals)=>setMovementInsights(vals)
                })
            }),
            step === 7 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _injuriesLimitationsStep.InjuriesLimitationsStep), {
                    clientName: clientName.split(' ')[0],
                    bodyProfile: clientBodyProfile,
                    selectedParts: injuriesParts,
                    onChangeParts: setInjuriesParts,
                    notes: injuriesNotes,
                    onChangeNotes: setInjuriesNotes
                })
            }),
            step === 9 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programDurationStep.ProgramDurationStep), {
                    clientName: clientName.split(' ')[0],
                    value: programDuration,
                    onChange: (val)=>setProgramDuration(val)
                })
            }),
            step === 10 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _howOftenTrainStep.HowOftenTrainStep), {
                    clientName: clientName.split(' ')[0],
                    value: howOftenTrain,
                    reminderValue: howOftenTrainReminder,
                    onChange: (days, reminder)=>{
                        setHowOftenTrain(days);
                        setHowOftenTrainReminder(reminder);
                    }
                })
            }),
            step === 11 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _workoutDurationStep.WorkoutDurationStep), {
                    value: workoutDuration,
                    onChange: (val)=>setWorkoutDuration(val),
                    onNext: handleNext
                })
            }),
            step === 12 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trainingGoalStep.TrainingGoalStep), {
                    value: trainingGoal,
                    onNext: (goal)=>{
                        setTrainingGoal(goal);
                        handleNext(goal);
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).IncreaseStrength && currentSubStepIndex === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content increase_strength_strength",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _increaseStrengthStep1.IncreaseStrengthStep1), {
                    clientBodyProfile: clientBodyProfile,
                    value: increaseStrengthFocus,
                    onChange: (val)=>setIncreaseStrengthFocus(val)
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).IncreaseStrength && currentSubStepIndex === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content increase_strength_what_strength",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _increaseStrengthStep2.IncreaseStrengthStep2), {
                    value: increaseStrengthOutcome,
                    onNext: (val)=>{
                        setIncreaseStrengthOutcome(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).IncreaseStrength && currentSubStepIndex === 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content goal_approached",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _increaseStrengthStep3.IncreaseStrengthStep3), {
                    value: increaseStrengthApproach,
                    onNext: (val)=>{
                        setIncreaseStrengthApproach(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).Endurance && currentSubStepIndex === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content endurance_what_strength",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enduranceStep1.EnduranceStep1), {
                    value: enduranceType,
                    onNext: (val)=>{
                        setEnduranceType(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).Endurance && currentSubStepIndex === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content goal_approached",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enduranceStep2.EnduranceStep2), {
                    value: enduranceApproach,
                    onNext: (val)=>{
                        setEnduranceApproach(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).Performance && currentSubStepIndex === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content performance_what_strength",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _performanceStep1.PerformanceStep1), {
                    value: performanceSupport,
                    onNext: (val)=>{
                        setPerformanceSupport(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).Performance && currentSubStepIndex === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content performance_focus",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _performanceStep2.PerformanceStep2), {
                    value: performanceFocus,
                    onNext: (val)=>{
                        setPerformanceFocus(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).Performance && currentSubStepIndex === 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content performance_goal_approached goal_approached",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _performanceStep3.PerformanceStep3), {
                    value: performanceApproach,
                    onNext: (val)=>{
                        setPerformanceApproach(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).GeneralFitness && currentSubStepIndex === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content general_fitness_what_strength",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalFitnessStep1.GeneralFitnessStep1), {
                    value: generalFitnessMeaning,
                    onNext: (val)=>{
                        setGeneralFitnessMeaning(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).GeneralFitness && currentSubStepIndex === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content general_fitness_goal_approached goal_approached",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalFitnessStep2.GeneralFitnessStep2), {
                    value: generalFitnessApproach,
                    onNext: (val)=>{
                        setGeneralFitnessApproach(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).InjuryPrevention && currentSubStepIndex === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content injury_prevention_protect",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _injuryPreventionStep1.InjuryPreventionStep1), {
                    clientBodyProfile: clientBodyProfile,
                    value: injuryPreventionArea,
                    onChange: (val)=>setInjuryPreventionArea(val)
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).InjuryPrevention && currentSubStepIndex === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content injury_prevention_focus",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _injuryPreventionStep2.InjuryPreventionStep2), {
                    value: injuryPreventionFocus,
                    onNext: (val)=>{
                        setInjuryPreventionFocus(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).InjuryPrevention && currentSubStepIndex === 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content injury_prevention_goal_approached goal_approached ",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _injuryPreventionStep3.InjuryPreventionStep3), {
                    value: injuryPreventionApproach,
                    onNext: (val)=>{
                        setInjuryPreventionApproach(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).Rehabilitation && currentSubStepIndex === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content rehabilitation_support",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rehabilitationStep1.RehabilitationStep1), {
                    clientBodyProfile: clientBodyProfile,
                    value: rehabilitationArea,
                    onChange: (val)=>setRehabilitationArea(val)
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).Rehabilitation && currentSubStepIndex === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content rehabilitation_support_stage",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rehabilitationStep2.RehabilitationStep2), {
                    value: rehabilitationStage,
                    onNext: (val)=>{
                        setRehabilitationStage(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).Rehabilitation && currentSubStepIndex === 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content rehabilitation_goal_approached goal_approached",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rehabilitationStep3.RehabilitationStep3), {
                    value: rehabilitationApproach,
                    onNext: (val)=>{
                        setRehabilitationApproach(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).Mobility && currentSubStepIndex === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content mobility_focus",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobilityStep1.MobilityStep1), {
                    value: mobilityArea,
                    clientBodyProfile: clientBodyProfile,
                    onChange: (val)=>setMobilityArea(val)
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).Mobility && currentSubStepIndex === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content mobility_purpose",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobilityStep2.MobilityStep2), {
                    value: mobilityPurpose,
                    onNext: (val)=>{
                        setMobilityPurpose(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).Mobility && currentSubStepIndex === 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content mobility_goal_approached goal_approached",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobilityStep3.MobilityStep3), {
                    value: mobilityApproach,
                    onNext: (val)=>{
                        setMobilityApproach(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).BuildMuscle && currentSubStepIndex === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content main_area",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildMuscleStep1.BuildMuscleStep1), {
                    clientBodyProfile: clientBodyProfile,
                    value: buildMusclePrimary,
                    onChange: (val)=>{
                        setBuildMusclePrimary(val);
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).BuildMuscle && currentSubStepIndex === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content others_area",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildMuscleStep2.BuildMuscleStep2), {
                    clientBodyProfile: clientBodyProfile,
                    value: buildMuscleSecondary,
                    excludedAreas: buildMusclePrimary,
                    onChange: (val)=>setBuildMuscleSecondary(val)
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).BuildMuscle && currentSubStepIndex === 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content build_muscle_goal_approached goal_approached",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildMuscleStep3.BuildMuscleStep3), {
                    value: buildMuscleApproach,
                    onNext: (val)=>{
                        setBuildMuscleApproach(val);
                        handleNext();
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).WeightLoss && currentSubStepIndex === 1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content main_area",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _weightLossStep1.WeightLossStep1), {
                    clientBodyProfile: clientBodyProfile,
                    value: weightLossPrimary,
                    onNext: (val)=>{
                        setWeightLossPrimary(val);
                        handleNext(val);
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).WeightLoss && currentSubStepIndex === 2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content others_area",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _weightLossStep2.WeightLossStep2), {
                    clientBodyProfile: clientBodyProfile,
                    value: weightLossSecondary,
                    excludedArea: weightLossPrimary,
                    onChange: (val)=>{
                        setWeightLossSecondary(val);
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).WeightLoss && currentSubStepIndex === 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _weightLossStep3.WeightLossStep3), {
                    value: weightLossTarget,
                    onChange: (val)=>{
                        setWeightLossTarget(val);
                    }
                })
            }),
            step === 13 && trainingGoal === (0, _types.TrainingGoalSlug).WeightLoss && currentSubStepIndex === 4 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content weight_loss_goal_approached goal_approached",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _weightLossStep4.WeightLossStep4), {
                    value: weightLossApproach,
                    onNext: (val)=>{
                        setWeightLossApproach(val);
                        handleNext();
                    }
                })
            }),
            step === 14 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _secondaryTrainingGoalStep.SecondaryTrainingGoalStep), {
                    value: secondaryGoals,
                    primaryGoal: trainingGoal,
                    onChange: (goals)=>{
                        setSecondaryGoals(goals);
                    }
                })
            }),
            step === 15 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _intensityVibeStep.IntensityVibeStep), {
                    clientName: clientName.split(' ')[0],
                    value: intensity,
                    onChange: (val)=>setIntensity(val),
                    onNext: handleNext
                })
            }),
            step === 16 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectEquipmentStep.SelectEquipmentStep), {
                    value: selectedEquipment,
                    isMandatory: isEquipmentMandatory(),
                    onChange: (equipment)=>{
                        setSelectedEquipment(equipment);
                    }
                })
            }),
            step === 17 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reviewStep.ReviewStep), {
                    onEdit: handleEditStep,
                    onGenerate: (payload)=>{
                        const programId = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().programId || '';
                        navigate(`/onboarding-trainer/dashboard/program-generated/${programId}`, {
                            state: {
                                payload
                            }
                        });
                    },
                    clientName: clientName.split(' ')[0],
                    clientBodyProfile: clientBodyProfile,
                    energyLevel: energyLevel,
                    activityLevel: activityLevel,
                    fitnessLevel: fitnessLevel,
                    movementInsights: movementInsights,
                    injuriesParts: injuriesParts,
                    injuriesNotes: injuriesNotes,
                    programDuration: programDuration,
                    howOftenTrain: howOftenTrain,
                    howOftenTrainReminder: howOftenTrainReminder,
                    workoutDuration: workoutDuration,
                    trainingGoal: trainingGoal,
                    intensity: intensity,
                    selectedEquipment: selectedEquipment,
                    goalPriority: getGoalPriority(),
                    goalSecondary: getGoalSecondary(),
                    goalApproach: getGoalApproach(),
                    secondaryGoals: secondaryGoals
                })
            }),
            step === 18 && by === 'manual' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "step-content flex-center-column",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programNameStep.ProgramNameStep), {
                    value: programName,
                    onChange: (val)=>setProgramName(val),
                    onNext: handleNext
                })
            }),
            step >= 2 && step !== 8 && step !== 17 && step !== 18 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "wizard-footer",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "progress-bar-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "progress-bar",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "progress-fill",
                                style: {
                                    width: `${getProgressPercentage()}%`
                                }
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "actions",
                        children: [
                            step > 2 && (!isEditingFromReview || !isFirstStepOfSection()) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                variant: "outline",
                                className: "back-btn align-items-center m-height-48",
                                onClick: handleBack,
                                svg: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backSvg.ReactComponent), {}),
                                children: 'Back'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                style: {
                                    display: 'flex',
                                    gap: '8px'
                                },
                                children: [
                                    (!isEditingFromReview || !isLastStepOfSection() || hasIncompleteStepAhead()) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        variant: step === 7 && injuriesParts.length === 0 && injuriesNotes.trim() === '' || step === 14 && secondaryGoals.length === 0 || step === 16 && selectedEquipment.length === 0 && !isEquipmentMandatory() ? 'outline' : 'primary',
                                        className: `next-btn right-arrow m-height-48 ${step === 7 && injuriesParts.length === 0 && injuriesNotes.trim() === '' || step === 14 && secondaryGoals.length === 0 || step === 16 && selectedEquipment.length === 0 && !isEquipmentMandatory() ? 'align-items-center' : 'btn-primary-white'}`,
                                        onClick: handleNext,
                                        svg: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nextSvg.ReactComponent), {}),
                                        disabled: isNextDisabled() || isCheckingPrograms || isCheckingProfile,
                                        isLoading: isLoading || isCheckingPrograms || isCheckingProfile,
                                        children: step === 7 && injuriesParts.length === 0 && injuriesNotes.trim() === '' || step === 14 && secondaryGoals.length === 0 || step === 16 && selectedEquipment.length === 0 && !isEquipmentMandatory() ? 'Skip This' : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                color: '#000',
                                                fontWeight: 'bold'
                                            },
                                            children: "Next"
                                        })
                                    }),
                                    isEditingFromReview && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                        variant: "primary",
                                        className: "save-btn align-items-center m-height-48",
                                        onClick: handleSaveEdit,
                                        disabled: isLoading || isSaveDisabled(),
                                        isLoading: isLoading,
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            style: {
                                                color: '#000',
                                                fontWeight: 'bold'
                                            },
                                            children: "Save"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: blocker.state === 'blocked',
                footer: null,
                closable: false,
                centered: true,
                width: 518,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: (0, _confirmation.confirmationSVG)?.draft
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: onboardingOnly ? 'Client fitness profile saved' : 'Your program draft has been saved'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: onboardingOnly ? "The client's fitness profile has been successfully saved." : 'You can continue editing this program from the Programs page.'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "draft-saved-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "btn-back",
                                    onClick: ()=>blocker.state === 'blocked' && blocker.reset(),
                                    children: [
                                        (0, _confirmation.confirmationSVG)?.back,
                                        " Back to The Form"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-proceed",
                                    onClick: ()=>{
                                        if (blocker.state === 'blocked') {
                                            const { location: nextLocation } = blocker;
                                            const currentLocation = window.location;
                                            if (nextLocation.search.includes('action=new_program') && !currentLocation.search.includes('action=new_program')) {
                                                blocker.reset();
                                                navigate('/onboarding-trainer/dashboard/');
                                            } else blocker.proceed();
                                        }
                                    },
                                    children: "Great, Thanks!"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _replaceProgramModal.ReplaceProgramModal), {
                isOpen: showReplaceProgramModal,
                onKeep: ()=>setShowReplaceProgramModal(false),
                isReplacing: isReplacingProgram,
                onReplace: async ()=>{
                    setIsReplacingProgram(true);
                    try {
                        await Promise.all(clientPrograms.map((p)=>deleteProgram({
                                docPath: p.docPath,
                                hideToast: true
                            }).catch(console.error)));
                        setShowReplaceProgramModal(false);
                        const cid = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().clientId;
                        if (by === 'manual') navigateToStep(9);
                        else {
                            const nextStep = await checkProfile(cid);
                            navigateToStep(Math.min(nextStep, totalSteps));
                        }
                    } finally{
                        setIsReplacingProgram(false);
                    }
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","@tanstack/react-query":"97Oud","react":"bmhQu","src/hooks/useStepProgress":"3p9tO","src/hooks/useCheckClientFitnessProfile":"3IwTD","src/store/programGeneratorProgressStore":"2iAYB","src/api/queries/useGetPrograms":"5kEEX","react-router-dom":[["useBlocker","f3cgC"],["useLocation","f3cgC"],["useNavigate","f3cgC"],["useSearchParams","f3cgC"],["useParams","9oT3O"]],"url:../../../../../../assets/videos/mini-pt-care.mp4":"5knEg","src/components/Animation/text-animate":"iQJIi","src/utils/gsapSetup":"8koI4","antd":[["Modal","kY4DD","default"],["Spin","lVvhl","default"]],"./assets/Confirmation":"4Xv03","src/components/ReplaceProgramModal/ReplaceProgramModal":"l3Jvy","src/api/mutations/useGetTrainerProgramPlanList":"eJMbb","src/api/mutations/useDeleteProgramPlan":"gXAUl","src/store/sessionStore":"kPSO3","./components/ClientSelectionStep":"e34Kg","./components/EnergyLevelStep":"ct3mZ","./components/FitnessLevelStep":"5J1ZR","./components/ActivityLevelStep":"kuC7t","./components/MovementInsightsStep":"9OWxb","./components/OnboardNewClientPromptStep":"543Zl","./components/InjuriesLimitationsStep":"5tAFh","./components/ProgramDurationStep":"4BJkD","./components/HowOftenTrainStep":"bolCs","./components/WorkoutDurationStep":"i37lG","./components/TrainingGoalStep":"5mwFM","./components/IncreaseStrengthStep1":"2HUyV","./components/IncreaseStrengthStep2":"u22Am","./components/IncreaseStrengthStep3":"e1vnG","./components/EnduranceStep1":"jkLcG","./components/EnduranceStep2":"gyNnW","./components/PerformanceStep1":"6PNNv","./components/PerformanceStep2":"5oroU","./components/PerformanceStep3":"jEkfG","./components/GeneralFitnessStep1":"ayzoc","./components/GeneralFitnessStep2":"5e1iY","./components/InjuryPreventionStep1":"7TzaN","./components/InjuryPreventionStep2":"4n38l","./components/InjuryPreventionStep3":"cM1aO","./components/RehabilitationStep1":"cGpRm","./components/RehabilitationStep2":"9bf29","./components/RehabilitationStep3":"kuOZW","./components/MobilityStep1":"2Xcmi","./components/MobilityStep2":"eEdn0","./components/MobilityStep3":"dgA7N","./components/BuildMuscleStep1":"gWlvK","./components/BuildMuscleStep2":"fwBa1","./components/BuildMuscleStep3":"62Cqw","./components/WeightLossStep1":"3PwNr","./components/WeightLossStep2":"eFykn","./components/WeightLossStep3":"iDqRm","./components/WeightLossStep4":"9ocBa","./components/SecondaryTrainingGoalStep":"laUOL","./components/IntensityVibeStep":"42ntH","./components/SelectEquipmentStep":"dmLx5","./components/ReviewStep":"fDaDd","./components/ProgramNameStep":"bwANQ","src/components/Button/Button":"g0894","./constants":"2KZSQ","./types":"1DGo2","./ProgramGeneratorAI.scss":"fQUDQ","../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/back.svg":"iFMSq","../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/next.svg":"ixBdp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3p9tO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useStepProgress", ()=>useStepProgress);
var _react = require("react");
var _programGeneratorProgressStore = require("src/store/programGeneratorProgressStore");
var _useSaveProgramProgress = require("src/api/mutations/useSaveProgramProgress");
var _debounce = require("lodash/debounce");
var _debounceDefault = parcelHelpers.interopDefault(_debounce);
function useStepProgress(stepId, initialValue, toStore, fromStore) {
    const store = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore)();
    const { mutate: save } = (0, _useSaveProgramProgress.useSaveProgramProgress)();
    const toStoreRef = (0, _react.useRef)(toStore);
    const fromStoreRef = (0, _react.useRef)(fromStore);
    const initialValueRef = (0, _react.useRef)(initialValue);
    const saveRef = (0, _react.useRef)(save);
    (0, _react.useEffect)(()=>{
        toStoreRef.current = toStore;
        fromStoreRef.current = fromStore;
        initialValueRef.current = initialValue;
        saveRef.current = save;
    }, [
        toStore,
        fromStore,
        initialValue,
        save
    ]);
    const debouncedSaveRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        debouncedSaveRef.current = (0, _debounceDefault.default)((payload)=>{
            saveRef.current(payload);
        }, 1000);
        return ()=>{
            debouncedSaveRef.current?.flush();
        };
    }, []);
    (0, _react.useEffect)(()=>{
        const state = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState();
        if (state.progress[stepId] === undefined) {
            const data = toStoreRef.current(initialValueRef.current);
            state.updateStepProgress(stepId, data);
        // We no longer trigger a save to backend on mount to avoid spamming the backend
        // and creating premature draft programs. Saves will happen via handleNext.
        }
    }, [
        stepId
    ]);
    const storedItems = store.progress[stepId];
    const value = storedItems !== undefined ? fromStore(storedItems) : initialValue;
    const setValue = (0, _react.useCallback)((newVal)=>{
        const state = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState();
        const currentStoredItems = state.progress[stepId];
        const currentValue = currentStoredItems !== undefined ? fromStoreRef.current(currentStoredItems) : initialValueRef.current;
        let finalVal;
        if (typeof newVal === 'function') finalVal = newVal(currentValue);
        else finalVal = newVal;
        const data = toStoreRef.current(finalVal);
        state.updateStepProgress(stepId, data);
        // Save to backend asynchronously with debounce
        if (state.programId || state.clientId) debouncedSaveRef.current?.({
            program_id: state.programId,
            client_id: state.clientId,
            step_id: stepId,
            data
        });
    }, [
        stepId
    ]);
    return [
        value,
        setValue
    ];
}

},{"react":"bmhQu","src/store/programGeneratorProgressStore":"2iAYB","src/api/mutations/useSaveProgramProgress":"gS7Lv","lodash/debounce":"jteyB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gS7Lv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSaveProgramProgress", ()=>useSaveProgramProgress);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _sessionStore = require("src/store/sessionStore");
var _programGeneratorProgressStore = require("src/store/programGeneratorProgressStore");
const saveProgramProgress = async (payload, uid)=>{
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_SAVE_PROGRAM_PROGRESS}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...payload,
            uid
        })
    });
    if (!response.ok) throw new Error('Failed to save program progress');
    return response.json();
};
const useSaveProgramProgress = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: (payload)=>{
            const currentUser = (0, _sessionStore.sessionStore).getState().currentUser;
            const uid = currentUser?.uid;
            if (!uid) throw new Error('User not authenticated');
            return saveProgramProgress(payload, uid);
        },
        onSuccess: (data)=>{
            if (data.program_id) (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().setProgramId(data.program_id);
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-program-plan-list'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientWorkoutsTab'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientProgramTab'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientOverview'
                ]
            });
        }
    });
};

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"src/config/api-config":"9oD3c","src/store/sessionStore":"kPSO3","src/store/programGeneratorProgressStore":"2iAYB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jteyB":[function(require,module,exports,__globalThis) {
var isObject = require("3b174a999d6a40ac"), now = require("575b2317167ce20d"), toNumber = require("a13332670c5c0f63");
/** Error message constants. */ var FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var nativeMax = Math.max, nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError(FUNC_ERROR_TEXT);
    wait = toNumber(wait) || 0;
    if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge(now());
    }
    function debounced() {
        var time = now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
module.exports = debounce;

},{"3b174a999d6a40ac":"b5XR2","575b2317167ce20d":"3KUao","a13332670c5c0f63":"90hUs"}],"3KUao":[function(require,module,exports,__globalThis) {
var root = require("6439589d9d88d885");
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var now = function() {
    return root.Date.now();
};
module.exports = now;

},{"6439589d9d88d885":"63oqc"}],"90hUs":[function(require,module,exports,__globalThis) {
var baseTrim = require("261e89907fb89d78"), isObject = require("faaa289d287a34a5"), isSymbol = require("47b3bd23f771891");
/** Used as references for various `Number` constants. */ var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function toNumber(value) {
    if (typeof value == 'number') return value;
    if (isSymbol(value)) return NAN;
    if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = baseTrim(value);
    var isBinary = reIsBinary.test(value);
    return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}
module.exports = toNumber;

},{"261e89907fb89d78":"dWEaL","faaa289d287a34a5":"b5XR2","47b3bd23f771891":"b0ZB5"}],"dWEaL":[function(require,module,exports,__globalThis) {
var trimmedEndIndex = require("985d3c9be7b51937");
/** Used to match leading whitespace. */ var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}
module.exports = baseTrim;

},{"985d3c9be7b51937":"d0Vs0"}],"d0Vs0":[function(require,module,exports,__globalThis) {
/** Used to match a single whitespace character. */ var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && reWhitespace.test(string.charAt(index)));
    return index;
}
module.exports = trimmedEndIndex;

},{}],"3IwTD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCheckClientFitnessProfile", ()=>useCheckClientFitnessProfile);
var _react = require("react");
var _useGetClientFitnessProfile = require("src/api/queries/useGetClientFitnessProfile");
var _programGeneratorProgressStore = require("src/store/programGeneratorProgressStore");
var _types = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/ProgramGeneratorAI/types");
var _genderUtils = require("src/utils/genderUtils");
const useCheckClientFitnessProfile = ()=>{
    const [isChecking, setIsChecking] = (0, _react.useState)(false);
    const checkProfile = (0, _react.useCallback)(async (clientId)=>{
        setIsChecking(true);
        try {
            const profile = await (0, _useGetClientFitnessProfile.fetchClientFitnessProfile)(clientId);
            let nextStep = 3;
            if (profile) {
                const store = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState();
                store.setClientId(clientId);
                if (profile.body_profile || profile.gender) {
                    const bp = (0, _genderUtils.resolveBodyProfile)(profile);
                    store.updateStepProgress((0, _types.ProgramStepId).ClientBodyProfile, [
                        {
                            slug: bp,
                            value: bp
                        }
                    ]);
                }
                if (profile.name) {
                    const fullName = `${profile.name} ${profile.surname || ''}`.trim();
                    store.updateStepProgress((0, _types.ProgramStepId).ClientName, [
                        {
                            slug: fullName,
                            value: fullName
                        }
                    ]);
                }
                if (profile.energy_level) store.updateStepProgress((0, _types.ProgramStepId).EnergyLevel, profile.energy_level);
                if (profile.activity_level) store.updateStepProgress((0, _types.ProgramStepId).ActivityLevel, profile.activity_level);
                if (profile.fitness_level) store.updateStepProgress((0, _types.ProgramStepId).FitnessLevel, profile.fitness_level);
                if (profile.movement_insights) store.updateStepProgress((0, _types.ProgramStepId).MovementInsights, profile.movement_insights);
                if (profile.injuries_parts) store.updateStepProgress((0, _types.ProgramStepId).InjuriesParts, profile.injuries_parts);
                if (profile.injuries_notes !== undefined) store.updateStepProgress((0, _types.ProgramStepId).InjuriesNotes, profile.injuries_notes);
                let hasMobility = false;
                let hasStability = false;
                let hasBalance = false;
                let hasSymmetry = false;
                let hasQuality = false;
                const movementObj = {};
                if (profile.movement_insights) {
                    if (Array.isArray(profile.movement_insights)) {
                        if (profile.movement_insights.length >= 5 && profile.movement_insights.every((i)=>typeof i === 'string')) {
                            hasMobility = true;
                            hasStability = true;
                            hasBalance = true;
                            hasSymmetry = true;
                            hasQuality = true;
                        } else profile.movement_insights.forEach((item)=>{
                            if (item && typeof item === 'object' && item.slug) movementObj[item.slug] = String(item.value ?? '');
                        });
                    } else if (typeof profile.movement_insights === 'object') Object.keys(profile.movement_insights).forEach((key)=>{
                        movementObj[key] = String(profile.movement_insights[key] ?? '');
                    });
                }
                if (Object.keys(movementObj).length > 0) {
                    hasMobility = !!movementObj['mobility-level'] || !!movementObj['mobility_level'];
                    hasStability = !!movementObj['stability-control'] || !!movementObj['stability_control'];
                    hasBalance = !!movementObj['balance-consistency'] || !!movementObj['balance_consistency'];
                    hasSymmetry = !!movementObj['movement-symmetry'] || !!movementObj['movement_symmetry'];
                    hasQuality = !!movementObj['overall-movement-quality'] || !!movementObj['overall_movement_quality'];
                }
                const isComplete = !!profile.energy_level && profile.activity_level !== undefined && !!profile.fitness_level && hasMobility && hasStability && hasBalance && hasSymmetry && hasQuality && profile.injuries_parts !== undefined;
                if (isComplete) nextStep = 8;
                else if (!profile.energy_level) nextStep = 3;
                else if (!profile.activity_level) nextStep = 4;
                else if (!profile.fitness_level) nextStep = 5;
                else if (!hasMobility || !hasStability || !hasBalance || !hasSymmetry || !hasQuality) nextStep = 6;
                else if (!profile.injuries_parts) nextStep = 7;
            }
            return nextStep;
        } catch (err) {
            console.error('Failed to fetch fitness profile:', err);
            return 3;
        } finally{
            setIsChecking(false);
        }
    }, []);
    return {
        checkProfile,
        isChecking
    };
};

},{"react":"bmhQu","src/api/queries/useGetClientFitnessProfile":"7yyZr","src/store/programGeneratorProgressStore":"2iAYB","src/screens/OnboardingTrainer/screens/Dashboard/screens/ProgramGeneratorAI/types":"1DGo2","src/utils/genderUtils":"aiA54","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7yyZr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchClientFitnessProfile", ()=>fetchClientFitnessProfile);
parcelHelpers.export(exports, "useGetClientFitnessProfile", ()=>useGetClientFitnessProfile);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
const fetchClientFitnessProfile = async (clientId)=>{
    const url = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_CLIENT_FITNESS_PROFILE}?clientId=${clientId}`;
    const res = await fetch(url);
    const data = await res.json();
    if (res.status === 200 && data.status === 'ok') return data.data;
    throw new Error(data.error || 'Failed to fetch client fitness profile');
};
function useGetClientFitnessProfile(clientId, isEnabled = true) {
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'client-fitness-profile',
            clientId
        ],
        queryFn: ()=>fetchClientFitnessProfile(clientId),
        enabled: !!clientId && isEnabled
    });
}

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1DGo2":[function(require,module,exports,__globalThis) {
/**
 * Enum representing the internal state IDs used by the `useStepProgress` hook.
 * These keys map directly to the `id` fields in `program-master-data.json`
 * and are used to store the user's progress across the Program Generator AI flow.
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgramStepId", ()=>ProgramStepId);
parcelHelpers.export(exports, "TrainingGoalSlug", ()=>TrainingGoalSlug);
var ProgramStepId = /*#__PURE__*/ function(ProgramStepId) {
    ProgramStepId["ClientName"] = "client_name";
    ProgramStepId["ClientBodyProfile"] = "client_body_profile";
    ProgramStepId["TrainingGoal"] = "training_goal";
    ProgramStepId["IncreaseStrengthFocus"] = "increase_strength_focus";
    ProgramStepId["IncreaseStrengthOutcome"] = "increase_strength_outcome";
    ProgramStepId["IncreaseStrengthApproach"] = "increase_strength_approach";
    ProgramStepId["EnduranceType"] = "endurance_type";
    ProgramStepId["EnduranceApproach"] = "endurance_approach";
    ProgramStepId["PerformanceSupport"] = "performance_support";
    ProgramStepId["PerformanceFocus"] = "performance_focus";
    ProgramStepId["PerformanceApproach"] = "performance_approach";
    ProgramStepId["GeneralFitnessMeaning"] = "general_fitness_meaning";
    ProgramStepId["GeneralFitnessApproach"] = "general_fitness_approach";
    ProgramStepId["InjuryPreventionArea"] = "injury_prevention_area";
    ProgramStepId["InjuryPreventionFocus"] = "injury_prevention_focus";
    ProgramStepId["InjuryPreventionApproach"] = "injury_prevention_approach";
    ProgramStepId["RehabilitationArea"] = "rehabilitation_area";
    ProgramStepId["RehabilitationStage"] = "rehabilitation_stage";
    ProgramStepId["RehabilitationApproach"] = "rehabilitation_approach";
    ProgramStepId["MobilityArea"] = "mobility_area";
    ProgramStepId["MobilityPurpose"] = "mobility_purpose";
    ProgramStepId["MobilityApproach"] = "mobility_approach";
    ProgramStepId["BuildMusclePrimary"] = "build_muscle_primary";
    ProgramStepId["BuildMuscleSecondary"] = "build_muscle_secondary";
    ProgramStepId["BuildMuscleApproach"] = "build_muscle_approach";
    ProgramStepId["WeightLossPrimary"] = "weight_loss_primary";
    ProgramStepId["WeightLossSecondary"] = "weight_loss_secondary";
    ProgramStepId["WeightLossTarget"] = "weight_loss_target";
    ProgramStepId["WeightLossApproach"] = "weight_loss_approach";
    ProgramStepId["SecondaryGoals"] = "secondary_goals";
    ProgramStepId["SelectedEquipment"] = "selected_equipment";
    ProgramStepId["InjuriesParts"] = "injuries_parts";
    ProgramStepId["InjuriesNotes"] = "injuries_notes";
    ProgramStepId["EnergyLevel"] = "energy_level";
    ProgramStepId["ActivityLevel"] = "activity_level";
    ProgramStepId["FitnessLevel"] = "fitness_level";
    ProgramStepId["MovementInsights"] = "movement_insights";
    ProgramStepId["ProgramDuration"] = "program_duration";
    ProgramStepId["HowOftenTrain"] = "how_often_train";
    ProgramStepId["HowOftenTrainReminder"] = "how_often_train_reminder";
    ProgramStepId["WorkoutDuration"] = "workout_duration";
    ProgramStepId["Intensity"] = "intensity";
    ProgramStepId["ProgramName"] = "program_name";
    return ProgramStepId;
}({});
var TrainingGoalSlug = /*#__PURE__*/ function(TrainingGoalSlug) {
    TrainingGoalSlug["IncreaseStrength"] = "increase-strength";
    TrainingGoalSlug["BuildMuscle"] = "build-muscle";
    TrainingGoalSlug["WeightLoss"] = "weight-loss";
    TrainingGoalSlug["Endurance"] = "endurance";
    TrainingGoalSlug["Mobility"] = "mobility";
    TrainingGoalSlug["Performance"] = "performance";
    TrainingGoalSlug["GeneralFitness"] = "general-fitness";
    TrainingGoalSlug["Rehabilitation"] = "rehabilitation";
    TrainingGoalSlug["InjuryPrevention"] = "injury-prevention";
    return TrainingGoalSlug;
}({});

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5kEEX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGetPrograms", ()=>useGetPrograms);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _sessionStore = require("src/store/sessionStore");
const getPrograms = async (payload, uid)=>{
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_PROGRAMS}`;
    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            ...payload,
            uid
        })
    });
    if (!response.ok) throw new Error('Failed to fetch programs');
    const res = await response.json();
    return res.data;
};
const useGetPrograms = (payload = {}, options)=>{
    const currentUser = (0, _sessionStore.sessionStore)((state)=>state.currentUser);
    const uid = currentUser?.uid;
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'trainer-programs',
            payload
        ],
        queryFn: ()=>{
            if (!uid) throw new Error('User not authenticated');
            return getPrograms(payload, uid);
        },
        enabled: !!uid && options?.enabled !== false
    });
};

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Xv03":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "confirmationSVG", ()=>confirmationSVG);
var _jsxRuntime = require("react/jsx-runtime");
const confirmationSVG = {
    draft: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 64,
        height: 64,
        viewBox: "0 0 64 64",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M32 0.25C49.535 0.25 63.75 14.465 63.75 32C63.75 49.535 49.535 63.75 32 63.75C14.465 63.75 0.25 49.535 0.25 32C0.25 14.465 14.465 0.25 32 0.25Z",
                stroke: "url(#paint0_linear_0_1)",
                strokeWidth: "0.5"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#clip0_0_1)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M26.8269 37.8L43.7769 20.85C44.1769 20.45 44.6436 20.25 45.1769 20.25C45.7103 20.25 46.1769 20.45 46.5769 20.85C46.9769 21.25 47.1769 21.7253 47.1769 22.276C47.1769 22.8267 46.9769 23.3013 46.5769 23.7L28.2269 42.1C27.8269 42.5 27.3603 42.7 26.8269 42.7C26.2936 42.7 25.8269 42.5 25.4269 42.1L16.8269 33.5C16.4269 33.1 16.2349 32.6253 16.2509 32.076C16.2669 31.5267 16.4756 31.0513 16.8769 30.65C17.2783 30.2487 17.7536 30.0487 18.3029 30.05C18.8523 30.0513 19.3269 30.2513 19.7269 30.65L26.8269 37.8Z",
                        fill: "#04051B"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M26.8269 37.8L43.7769 20.85C44.1769 20.45 44.6436 20.25 45.1769 20.25C45.7103 20.25 46.1769 20.45 46.5769 20.85C46.9769 21.25 47.1769 21.7253 47.1769 22.276C47.1769 22.8267 46.9769 23.3013 46.5769 23.7L28.2269 42.1C27.8269 42.5 27.3603 42.7 26.8269 42.7C26.2936 42.7 25.8269 42.5 25.4269 42.1L16.8269 33.5C16.4269 33.1 16.2349 32.6253 16.2509 32.076C16.2669 31.5267 16.4756 31.0513 16.8769 30.65C17.2783 30.2487 17.7536 30.0487 18.3029 30.05C18.8523 30.0513 19.3269 30.2513 19.7269 30.65L26.8269 37.8Z",
                        fill: "url(#paint1_radial_0_1)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "paint0_linear_0_1",
                        x1: 32,
                        y1: 0,
                        x2: 32,
                        y2: 64,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: "0.5"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "paint1_radial_0_1",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(27.8991 -12.6281 2.78295 50.0018 18.0127 38.8915)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFEB14"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFA100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "clip0_0_1",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 31,
                            height: 23,
                            fill: "white",
                            transform: "translate(16.25 20.25)"
                        })
                    })
                ]
            })
        ]
    }),
    back: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 12,
        height: 16,
        viewBox: "0 0 12 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#clip0_13698_4315)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M5.99835 2.19922C6.10371 2.19932 6.20871 2.22022 6.30597 2.26074C6.40317 2.30135 6.49253 2.36075 6.56671 2.43555L6.56769 2.43652C6.64247 2.51081 6.70195 2.59996 6.74249 2.69727C6.78297 2.79461 6.80402 2.89946 6.80402 3.00488C6.80398 3.11035 6.78303 3.21514 6.74249 3.3125C6.70199 3.40967 6.64235 3.49805 6.56769 3.57227L6.56671 3.57324L2.92413 7.20508H10.9984C11.2103 7.20526 11.4139 7.28958 11.5638 7.43945C11.7135 7.58944 11.7982 7.79293 11.7982 8.00488C11.7981 8.21685 11.7136 8.42037 11.5638 8.57031C11.4139 8.72016 11.2103 8.80451 10.9984 8.80469H2.92413L6.56671 12.4365C6.71722 12.5873 6.80206 12.7918 6.80206 13.0049C6.80201 13.2179 6.71727 13.4225 6.56671 13.5732C6.41609 13.7238 6.21133 13.8084 5.99835 13.8086C5.89307 13.8086 5.78804 13.7882 5.69073 13.748C5.59338 13.7077 5.50456 13.6477 5.42999 13.5732L0.432921 8.57617C0.360207 8.50021 0.303026 8.41052 0.264953 8.3125L0.263 8.30859C0.183123 8.11403 0.18321 7.89576 0.263 7.70117L0.264953 7.69727C0.302413 7.60072 0.35888 7.51176 0.429992 7.43652L5.42999 2.43555C5.50431 2.36068 5.59336 2.30131 5.69073 2.26074C5.78808 2.22027 5.89292 2.19922 5.99835 2.19922Z",
                    fill: "white",
                    fillOpacity: "0.7"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "clip0_13698_4315",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 12,
                        height: 16,
                        fill: "white"
                    })
                })
            })
        ]
    })
};

},{"react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l3Jvy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReplaceProgramModal", ()=>ReplaceProgramModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _button = require("src/screens/OnboardingTrainer/components/Button/Button");
var _solarDangerTriangleLinearSvg = require("src/assets/images/onboarding-trainer/solar_danger-triangle-linear.svg");
var _backSvg = require("src/assets/images/onboarding-trainer/dashboard/program-generator-ai/back.svg");
const ReplaceProgramModal = ({ isOpen, onKeep, onReplace, isReplacing })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        onCancel: onKeep,
        footer: null,
        closeIcon: false,
        rootClassName: "logout-modal",
        className: "replace-program-modal",
        centered: true,
        width: 536,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "replace-program-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "icon-container",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _solarDangerTriangleLinearSvg.ReactComponent), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    className: "title",
                    children: "Replace the current program?"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "description",
                    children: "This client already has an active program. Assigning a new one will replace it, and any progress in the current program will be lost."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            variant: "outline",
                            className: "back-btn align-items-center",
                            onClick: onKeep,
                            svg: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _backSvg.ReactComponent), {}),
                            disabled: isReplacing,
                            children: "Keep Current Program"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                            variant: "primary",
                            className: "btn-primary-white replace-btn",
                            onClick: onReplace,
                            isLoading: isReplacing,
                            disabled: isReplacing,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                style: {
                                    color: '#000',
                                    fontWeight: 'bold'
                                },
                                children: "Replace Program"
                            })
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"src/screens/OnboardingTrainer/components/Button/Button":"jLE7r","src/assets/images/onboarding-trainer/solar_danger-triangle-linear.svg":"9eQb4","src/assets/images/onboarding-trainer/dashboard/program-generator-ai/back.svg":"iFMSq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iFMSq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBack);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBack = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "M13.334 8H2.667m4-4-4 4 4 4"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e34Kg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ClientSelectionStep", ()=>ClientSelectionStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _clientSelectionStepScss = require("./ClientSelectionStep.scss");
var _useGetTrainerClients = require("src/api/mutations/useGetTrainerClients");
var _useAddTrainerClient = require("src/api/mutations/useAddTrainerClient");
var _button = require("src/screens/OnboardingTrainer/components/Button/Button");
var _reactInfiniteScrollComponent = require("react-infinite-scroll-component");
var _reactInfiniteScrollComponentDefault = parcelHelpers.interopDefault(_reactInfiniteScrollComponent);
var _radioTick2Svg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/radio-tick-2.svg");
var _nextSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/next.svg");
var _validation = require("src/utils/validation");
var _sessionStore = require("src/store/sessionStore");
const ClientSelectionStep = ({ onNext, onClientSelect, value, isLoading: isNextLoading = false })=>{
    const [tab, setTab] = (0, _react.useState)('list');
    const [userManuallySelectedTab, setUserManuallySelectedTab] = (0, _react.useState)(false);
    const [selectedClient, setSelectedClient] = (0, _react.useState)(value || '');
    const [newName, setNewName] = (0, _react.useState)('');
    const [newSurname, setNewSurname] = (0, _react.useState)('');
    const [newEmail, setNewEmail] = (0, _react.useState)('');
    const [newBodyProfile, setNewBodyProfile] = (0, _react.useState)('');
    const [fieldErrors, setFieldErrors] = (0, _react.useState)({});
    const [touchedFields, setTouchedFields] = (0, _react.useState)({});
    const [serverError, setServerError] = (0, _react.useState)('');
    const [currentPage, setCurrentPage] = (0, _react.useState)(1);
    const { data, isLoading } = (0, _useGetTrainerClients.useGetTrainerClients)('active', '', 'name', currentPage, 50);
    const totalCount = data?.totalCount || 0;
    const [allClients, setAllClients] = (0, _react.useState)([]);
    (0, _react.useEffect)(()=>{
        const fetchedClients = data?.clients;
        if (fetchedClients && fetchedClients.length > 0) {
            if (currentPage === 1) setAllClients(fetchedClients);
            else setAllClients((prev)=>{
                const existingIds = new Set(prev.map((c)=>c.uid));
                const newClients = fetchedClients.filter((c)=>!existingIds.has(c.uid));
                return [
                    ...prev,
                    ...newClients
                ];
            });
        } else if (fetchedClients && fetchedClients.length === 0 && currentPage === 1) setAllClients([]);
    }, [
        data?.clients,
        currentPage
    ]);
    const { mutate: addClient, isPending: isAdding } = (0, _useAddTrainerClient.useAddTrainerClient)();
    const listRef = (0, _react.useRef)(null);
    const [hasScroll, setHasScroll] = (0, _react.useState)(false);
    (0, _react.useEffect)(()=>{
        const checkScroll = ()=>{
            if (listRef.current) setHasScroll(listRef.current.scrollHeight > listRef.current.clientHeight);
        };
        checkScroll();
        // Re-check after a short delay in case of layout shifts
        const timer = setTimeout(checkScroll, 100);
        window.addEventListener('resize', checkScroll);
        return ()=>{
            clearTimeout(timer);
            window.removeEventListener('resize', checkScroll);
        };
    }, [
        allClients,
        tab
    ]);
    // Auto-switch based on data availability (only if user hasn't manually selected)
    (0, _react.useEffect)(()=>{
        if (!isLoading && data && !userManuallySelectedTab) {
            if (data.totalCount === 0) setTab('new');
            else setTab('list');
        }
    }, [
        isLoading,
        data,
        userManuallySelectedTab
    ]);
    // Auto-scroll to selected client when tab is 'list'
    (0, _react.useEffect)(()=>{
        if (tab === 'list' && selectedClient && listRef.current) {
            // Use setTimeout to ensure DOM has updated with the new client before querying
            const timer = setTimeout(()=>{
                const selectedEl = listRef.current?.querySelector('.client-item.selected');
                if (selectedEl) selectedEl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }, 50);
            return ()=>clearTimeout(timer);
        }
    }, [
        tab,
        selectedClient,
        allClients
    ]);
    const getInitials = (name, surname)=>{
        const first = name ? name.charAt(0).toUpperCase() : '';
        const second = surname ? surname.charAt(0).toUpperCase() : '';
        return `${first}${second}`;
    };
    const validateName = (name)=>{
        const trimmed = name.trim();
        if (!trimmed) return 'First Name is required';
        if (name.length > 50) return 'First Name must be 50 characters or less';
        if (!/\p{L}/u.test(trimmed)) return 'First Name must contain at least one valid letter';
        return '';
    };
    const validateSurname = (surname)=>{
        const trimmed = surname.trim();
        if (!trimmed) return 'Surname is required';
        if (surname.length > 50) return 'Surname must be 50 characters or less';
        if (!/\p{L}/u.test(trimmed)) return 'Surname must contain at least one valid letter';
        return '';
    };
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const validateEmail = (email)=>{
        const trimmed = email.trim();
        if (trimmed && trimmed.length > 255) return 'Email must be 255 characters or less';
        if (trimmed && !(0, _validation.isValidEmail)(trimmed)) return 'Please enter a valid email address.';
        if (currentUser?.email && trimmed.toLowerCase() === currentUser.email.trim().toLowerCase()) return 'You cannot add yourself as a client.';
        return '';
    };
    const validateBodyProfile = (profile)=>{
        if (!profile) return 'Please select a body profile.';
        return '';
    };
    const resetForm = ()=>{
        setNewName('');
        setNewSurname('');
        setNewEmail('');
        setNewBodyProfile('');
        setFieldErrors({});
        setTouchedFields({});
        setServerError('');
    };
    const handleAddClient = ()=>{
        const nameErr = validateName(newName);
        const surnameErr = validateSurname(newSurname);
        const emailErr = validateEmail(newEmail);
        const bodyProfileErr = validateBodyProfile(newBodyProfile);
        setTouchedFields({
            name: true,
            surname: true,
            email: true,
            bodyProfile: true
        });
        setFieldErrors({
            name: nameErr,
            surname: surnameErr,
            email: emailErr,
            bodyProfile: bodyProfileErr
        });
        if (nameErr || surnameErr || emailErr || bodyProfileErr) return;
        setServerError('');
        addClient({
            name: newName.trim(),
            surname: newSurname.trim(),
            email: newEmail.trim(),
            bodyProfile: newBodyProfile
        }, {
            onSuccess: (res)=>{
                const newUid = res?.data?.uid || res?.uid;
                const fullName = `${newName.trim()} ${newSurname.trim()}`;
                (0, _reactHotToastDefault.default).success(`${fullName} added successfully`, {
                    id: 'add-client-success'
                });
                // Reset new client form fields
                resetForm();
                if (newUid) {
                    setSelectedClient(newUid);
                    if (onClientSelect) onClientSelect(fullName, newUid, newBodyProfile);
                    if (onNext) onNext(newUid);
                    else {
                        setCurrentPage(1);
                        setTab('list');
                    }
                } else {
                    setCurrentPage(1);
                    setTab('list');
                }
            },
            onError: (err)=>{
                const ERROR_MAPPING = {
                    ERR_CLIENT_EXISTS: 'This client is already in your list.',
                    ERR_CANNOT_INVITE_SELF: 'You cannot add yourself as a client.',
                    ERR_FIRST_NAME_REQUIRED: 'First Name is required',
                    ERR_SURNAME_REQUIRED: 'Surname is required',
                    ERR_FIRST_NAME_TOO_LONG: 'First Name must be 50 characters or less',
                    ERR_SURNAME_TOO_LONG: 'Surname must be 50 characters or less',
                    ERR_EMAIL_TOO_LONG: 'Email must be 255 characters or less',
                    ERR_INVALID_FIRST_NAME: 'First Name must contain at least one valid letter',
                    ERR_INVALID_SURNAME: 'Surname must contain at least one valid letter',
                    ERR_INVALID_EMAIL_FORMAT: 'Please enter a valid email address.',
                    ERR_AUTH_CREATION_FAILED: 'Failed to create user account',
                    ERR_BODY_PROFILE_REQUIRED: 'Please select a body profile.',
                    ERR_INVALID_BODY_PROFILE: 'Please select a valid body profile.'
                };
                const code = err.errorCode || '';
                const msg = ERROR_MAPPING[code] || (err.message === 'CLIENT_EXISTS' || err?.message?.toLowerCase().includes('already exists') ? 'This client is already in your list.' : err.message === 'INVALID_EMAIL' || err?.message?.includes('INVALID_EMAIL') ? 'Please enter a valid email address.' : err.message || 'Failed to add client. Please try again.');
                if (code === 'ERR_FIRST_NAME_REQUIRED' || code === 'ERR_FIRST_NAME_TOO_LONG' || code === 'ERR_INVALID_FIRST_NAME') {
                    setFieldErrors((prev)=>({
                            ...prev,
                            name: msg
                        }));
                    setTouchedFields((prev)=>({
                            ...prev,
                            name: true
                        }));
                } else if (code === 'ERR_SURNAME_REQUIRED' || code === 'ERR_SURNAME_TOO_LONG' || code === 'ERR_INVALID_SURNAME') {
                    setFieldErrors((prev)=>({
                            ...prev,
                            surname: msg
                        }));
                    setTouchedFields((prev)=>({
                            ...prev,
                            surname: true
                        }));
                } else if (code === 'ERR_EMAIL_TOO_LONG' || code === 'ERR_INVALID_EMAIL_FORMAT') {
                    setFieldErrors((prev)=>({
                            ...prev,
                            email: msg
                        }));
                    setTouchedFields((prev)=>({
                            ...prev,
                            email: true
                        }));
                } else if (code === 'ERR_INVALID_BODY_PROFILE' || code === 'ERR_BODY_PROFILE_REQUIRED') {
                    setFieldErrors((prev)=>({
                            ...prev,
                            bodyProfile: msg
                        }));
                    setTouchedFields((prev)=>({
                            ...prev,
                            bodyProfile: true
                        }));
                } else setServerError(msg);
            }
        });
    };
    const isFormInvalid = !newName.trim() || !newSurname.trim() || newName.length > 50 || newSurname.length > 50 || !/\p{L}/u.test(newName.trim()) || !/\p{L}/u.test(newSurname.trim()) || newEmail.trim() !== '' && (newEmail.length > 255 || !(0, _validation.isValidEmail)(newEmail.trim())) || newBodyProfile === '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "client-selection-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: 'Who is this program for?'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: "Let\u2019s select a client from your list."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "tab-toggle",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `tab ${tab === 'list' ? 'active' : ''}`,
                        onClick: ()=>{
                            setTab('list');
                            setUserManuallySelectedTab(true);
                            resetForm();
                        },
                        children: 'Choose from your list'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `tab ${tab === 'new' ? 'active' : ''}`,
                        onClick: ()=>{
                            setTab('new');
                            setUserManuallySelectedTab(true);
                            resetForm();
                        },
                        children: 'Add New'
                    })
                ]
            }),
            tab === 'list' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "client-list-wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `client-list ${hasScroll ? 'has-scroll' : ''}`,
                        ref: listRef,
                        id: "clientSelectionList",
                        children: [
                            isLoading && allClients.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "loading-container",
                                style: {
                                    minHeight: 'auto',
                                    padding: '20px'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'Loading clients...'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        className: "loading-spinner",
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "3",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M21 12a9 9 0 1 1-6.219-8.56"
                                        })
                                    })
                                ]
                            }),
                            !isLoading && allClients.length === 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "empty-message",
                                children: 'No clients found. Add a new one!'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactInfiniteScrollComponentDefault.default), {
                                dataLength: allClients.length,
                                next: ()=>setCurrentPage((prev)=>prev + 1),
                                hasMore: allClients.length < totalCount,
                                loader: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "loading-container",
                                    style: {
                                        padding: '20px 0',
                                        minHeight: 'auto',
                                        flex: 'none'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: 'Loading more clients...'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            className: "loading-spinner",
                                            width: "20",
                                            height: "20",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "3",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                d: "M21 12a9 9 0 1 1-6.219-8.56"
                                            })
                                        })
                                    ]
                                }),
                                scrollableTarget: "clientSelectionList",
                                style: {
                                    overflow: 'hidden'
                                },
                                children: [
                                    ...allClients
                                ].sort((a, b)=>{
                                    const aName = `${a.name} ${a.surname}`.toLowerCase();
                                    const bName = `${b.name} ${b.surname}`.toLowerCase();
                                    return aName.localeCompare(bName);
                                }).map((client)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: `client-item ${selectedClient === client.uid ? 'selected' : ''}`,
                                        onClick: ()=>{
                                            setSelectedClient(client.uid);
                                            if (onClientSelect) onClientSelect(`${client.name} ${client.surname}`, client.uid, client.bodyProfile);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "client-info",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "client-avatar",
                                                        children: client.avatarUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                            src: client.avatarUrl,
                                                            alt: client.name,
                                                            className: "avatar-img"
                                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "avatar-placeholder",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "initials",
                                                                children: getInitials(client.name, client.surname)
                                                            })
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "client-name",
                                                        children: [
                                                            client.name,
                                                            " ",
                                                            client.surname
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "client-radio",
                                                children: selectedClient === client.uid ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioTick2Svg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "radio-circle"
                                                })
                                            })
                                        ]
                                    }, client.uid))
                            })
                        ]
                    }),
                    allClients.length > 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "list-fade-overlay"
                    })
                ]
            }),
            tab === 'new' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "add-new-form",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-group body-profile-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: 'BODY PROFILE'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "gender-selection",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        className: "gender-option",
                                        onClick: ()=>{
                                            setNewBodyProfile('female');
                                            setTouchedFields((prev)=>({
                                                    ...prev,
                                                    bodyProfile: true
                                                }));
                                            setFieldErrors((prev)=>({
                                                    ...prev,
                                                    bodyProfile: ''
                                                }));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: `checkbox-custom ${newBodyProfile === 'female' ? 'checked' : ''}`,
                                                children: newBodyProfile === 'female' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                    width: "12",
                                                    height: "12",
                                                    viewBox: "0 0 12 12",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M10 3L4.5 8.5L2 6",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Female"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                        className: "gender-option",
                                        onClick: ()=>{
                                            setNewBodyProfile('male');
                                            setTouchedFields((prev)=>({
                                                    ...prev,
                                                    bodyProfile: true
                                                }));
                                            setFieldErrors((prev)=>({
                                                    ...prev,
                                                    bodyProfile: ''
                                                }));
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: `checkbox-custom ${newBodyProfile === 'male' ? 'checked' : ''}`,
                                                children: newBodyProfile === 'male' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                    width: "12",
                                                    height: "12",
                                                    viewBox: "0 0 12 12",
                                                    fill: "none",
                                                    xmlns: "http://www.w3.org/2000/svg",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M10 3L4.5 8.5L2 6",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Male"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            touchedFields.bodyProfile && fieldErrors.bodyProfile && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "error-message",
                                children: fieldErrors.bodyProfile
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: 'NAME'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        placeholder: "Name",
                                        maxLength: 50,
                                        value: newName,
                                        onChange: (e)=>{
                                            const val = e.target.value;
                                            setNewName(val);
                                            setServerError('');
                                            if (touchedFields.name) setFieldErrors((prev)=>({
                                                    ...prev,
                                                    name: validateName(val)
                                                }));
                                        },
                                        onBlur: (e)=>{
                                            const val = e.target.value.trim();
                                            setNewName(val);
                                            setTouchedFields((prev)=>({
                                                    ...prev,
                                                    name: true
                                                }));
                                            setFieldErrors((prev)=>({
                                                    ...prev,
                                                    name: validateName(val)
                                                }));
                                        },
                                        className: touchedFields.name && fieldErrors.name ? 'error-border' : ''
                                    }),
                                    touchedFields.name && fieldErrors.name && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "error-message",
                                        children: fieldErrors.name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "form-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: 'SURNAME'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        placeholder: "Surname",
                                        maxLength: 50,
                                        value: newSurname,
                                        onChange: (e)=>{
                                            const val = e.target.value;
                                            setNewSurname(val);
                                            setServerError('');
                                            if (touchedFields.surname) setFieldErrors((prev)=>({
                                                    ...prev,
                                                    surname: validateSurname(val)
                                                }));
                                        },
                                        onBlur: (e)=>{
                                            const val = e.target.value.trim();
                                            setNewSurname(val);
                                            setTouchedFields((prev)=>({
                                                    ...prev,
                                                    surname: true
                                                }));
                                            setFieldErrors((prev)=>({
                                                    ...prev,
                                                    surname: validateSurname(val)
                                                }));
                                        },
                                        className: touchedFields.surname && fieldErrors.surname ? 'error-border' : ''
                                    }),
                                    touchedFields.surname && fieldErrors.surname && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "error-message",
                                        children: fieldErrors.surname
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                children: 'EMAIL(OPTIONAL)'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "email",
                                placeholder: "john.doe@example.com",
                                maxLength: 255,
                                value: newEmail,
                                onChange: (e)=>{
                                    const val = e.target.value;
                                    setNewEmail(val);
                                    setServerError('');
                                    if (touchedFields.email) setFieldErrors((prev)=>({
                                            ...prev,
                                            email: validateEmail(val)
                                        }));
                                },
                                onBlur: (e)=>{
                                    const val = e.target.value.trim();
                                    setNewEmail(val);
                                    setTouchedFields((prev)=>({
                                            ...prev,
                                            email: true
                                        }));
                                    setFieldErrors((prev)=>({
                                            ...prev,
                                            email: validateEmail(val)
                                        }));
                                },
                                className: touchedFields.email && fieldErrors.email ? 'error-border' : ''
                            }),
                            touchedFields.email && fieldErrors.email && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "error-message",
                                children: fieldErrors.email
                            })
                        ]
                    }),
                    serverError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "error-message server-error",
                        children: serverError
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        variant: "primary",
                        className: "next-btn right-arrow m-height-48 btn-primary-white add-client-btn",
                        onClick: handleAddClient,
                        disabled: isAdding || isNextLoading || isFormInvalid,
                        svg: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nextSvg.ReactComponent), {}),
                        isLoading: isAdding || isNextLoading,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "add-client-text",
                            children: 'Add Client'
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-hot-toast":"3T0Wh","./ClientSelectionStep.scss":"gela6","src/api/mutations/useGetTrainerClients":"18nHc","src/api/mutations/useAddTrainerClient":"7Y55Y","src/screens/OnboardingTrainer/components/Button/Button":"jLE7r","react-infinite-scroll-component":"jrRfZ","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/radio-tick-2.svg":"hejBm","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/next.svg":"ixBdp","src/utils/validation":"1NJZx","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gela6":[function() {},{}],"ixBdp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgNext);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgNext = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#04051B",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "M2.667 8h10.666m-4 4 4-4-4-4"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ct3mZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnergyLevelStep", ()=>EnergyLevelStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _energyLevelStepScss = require("./EnergyLevelStep.scss");
var _fluctuatesSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/fluctuates.svg");
var _oftenHighSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/often_high.svg");
var _oftenLowSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/often_low.svg");
const iconMapping = {
    often_low: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _oftenLowSvg.ReactComponent), {}),
    fluctuates: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fluctuatesSvg.ReactComponent), {}),
    often_high: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _oftenHighSvg.ReactComponent), {})
};
const EnergyLevelStep = ({ onNext, clientName, value, onChange })=>{
    const [localLevel, setLocalLevel] = (0, _react.useState)('');
    const selectedLevel = value !== undefined ? value : localLevel;
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const energyLevel = programMasterData?.energyLevel;
    const nameDisplay = clientName ? `${clientName}'s` : 'their';
    const displayTitle = energyLevel?.title.replace('{{clientName}}', nameDisplay);
    // Use the API options and ensure they are sorted by order
    const options = [
        ...energyLevel?.options || []
    ].sort((a, b)=>(a.order || 0) - (b.order || 0));
    const getIcon = (id)=>iconMapping[id] || null;
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "energy-level-step",
        children: 'Loading options...'
    });
    if (isError || !energyLevel) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "energy-level-step",
        children: [
            "E",
            'rror loading options.'
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "energy-level-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: displayTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: energyLevel.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "energy-cards",
                children: options.map((level)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `energy-card ${selectedLevel === level.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            if (onChange) onChange(level.slug);
                            setLocalLevel(level.slug);
                            if (onNext) onNext();
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon-wrapper",
                                children: getIcon(level.id)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "level-label",
                                children: level.title
                            })
                        ]
                    }, level.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./EnergyLevelStep.scss":"e4Lvj","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/fluctuates.svg":"8j8Im","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/often_high.svg":"aSddj","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/often_low.svg":"kRWMR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e4Lvj":[function() {},{}],"8j8Im":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFluctuates);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFluctuates = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M13.064 19.132c.386 0 .723-.25.838-.621l1.395-4.655a1.739 1.739 0 0 1 3.326-.013l3.546 11.8 2.22-4.973a2.6 2.6 0 0 1 2.382-1.538h3.646v-6.945a2.607 2.607 0 0 0-2.604-2.604H12.188a2.607 2.607 0 0 0-2.604 2.604v6.945z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M26.771 20.868c-.346 0-.658.2-.795.508l-2.223 4.975a1.72 1.72 0 0 1-1.583 1.027 1.74 1.74 0 0 1-1.66-1.222l-3.546-11.8-1.401 4.66a2.605 2.605 0 0 1-2.499 1.852h-3.48v6.944a2.607 2.607 0 0 0 2.604 2.604h15.625a2.607 2.607 0 0 0 2.604-2.604v-6.944z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aSddj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOftenHigh);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOftenHigh = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                        id: "b",
                        width: 26,
                        height: 19,
                        x: 9,
                        y: 10,
                        maskUnits: "userSpaceOnUse",
                        style: {
                            maskType: "luminance"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "#fff",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: 2.5,
                                d: "M13.375 27.667a9.355 9.355 0 0 1 0-13.25 9.355 9.355 0 0 1 13.25 0 9.355 9.355 0 0 1 0 13.25"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "#000",
                                d: "M22.201 25.762a5.208 5.208 0 0 1-4.402-9.44c2.607-1.216 16.362-1.884 16.362-1.884s-9.353 10.108-11.96 11.324"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "#fff",
                                d: "M21.32 23.874a3.125 3.125 0 1 1-2.64-5.664c1.563-.73 11.705-2.01 11.705-2.01s-7.5 6.945-9.064 7.674"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        mask: "url(#b)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#E5E5E5",
                            d: "M32.5 7.5h-25v25h25z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M7.5 7.5h25v25h-25z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kRWMR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOftenLow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOftenLow = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                        id: "b",
                        width: 26,
                        height: 19,
                        x: 5,
                        y: 10,
                        maskUnits: "userSpaceOnUse",
                        style: {
                            maskType: "luminance"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "#fff",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: 2.5,
                                d: "M26.625 27.667a9.355 9.355 0 0 0 0-13.25 9.355 9.355 0 0 0-13.25 0 9.355 9.355 0 0 0 0 13.25"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "#000",
                                d: "M17.799 25.762a5.208 5.208 0 0 0 4.402-9.44C19.594 15.105 5.84 14.437 5.84 14.437s9.353 10.108 11.96 11.324"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "#fff",
                                d: "M18.68 23.874a3.125 3.125 0 1 0 2.64-5.664c-1.563-.73-11.705-2.01-11.705-2.01s7.5 6.945 9.064 7.674"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        mask: "url(#b)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#E5E5E5",
                            d: "M7.5 7.5h25v25h-25z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M32.5 7.5h-25v25h25z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5J1ZR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FitnessLevelStep", ()=>FitnessLevelStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _fitnessLevelStepScss = require("./FitnessLevelStep.scss");
var _react1 = require("motion/react");
var _animatedStep = require("src/components/Animation/AnimatedStep");
const fitnessLevelDescriptions = {
    beginner: [
        'Little to no exercise experience',
        'Poor stamina, strength, or mobility',
        'May struggle with basic movements (e.g., squats, push-ups)',
        'Needs focus on form, consistency, and confidence'
    ],
    'early-intermediate': [
        'Some consistency (a few weeks/months of training)',
        'Basic technique understood',
        "Can handle light\u2013moderate intensity",
        'Still improving coordination and endurance'
    ],
    intermediate: [
        'Regular training (6 to 24 months)',
        'Good technique in most exercises',
        'Can follow structured programs',
        "Starting to hit plateaus \u2192 needs progression strategies"
    ],
    advanced: [
        'Years of consistent training',
        'Strong, efficient movement patterns',
        'High work capacity',
        'Needs specific programming (periodization, performance goals)'
    ],
    athlete: [
        'Sport-specific training',
        'Very high performance level',
        'Focus on optimization, recovery, and marginal gains'
    ]
};
const FitnessLevelStep = ({ clientName, value, onChange })=>{
    const [localFitnessLevel, setLocalFitnessLevel] = (0, _react.useState)('beginner');
    const fitnessLevel = value !== undefined ? value : localFitnessLevel;
    (0, _react.useEffect)(()=>{
        if (value === undefined && onChange) onChange('beginner');
    }, [
        value,
        onChange
    ]);
    const nameDisplay = clientName ? `${clientName}'s` : 'their';
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const fitnessLevelData = programMasterData?.fitnessLevel;
    const defaultTitle = `What's ${nameDisplay} fitness level?`;
    const displayTitle = fitnessLevelData?.title ? fitnessLevelData.title.replace('{{clientName}}', nameDisplay) : defaultTitle;
    const displaySubtitle = fitnessLevelData?.subtitle;
    // Use the API options and ensure they are sorted by order
    const options = [
        ...fitnessLevelData?.options || []
    ].sort((a, b)=>(a.order || 0) - (b.order || 0));
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "fitness-level-step",
        children: 'Loading options...'
    });
    if (isError || !fitnessLevelData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "fitness-level-step",
        children: 'Error loading options.'
    });
    const sliderValue = Math.max(1, options.findIndex((opt)=>opt.slug === fitnessLevel) + 1);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "fitness-level-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: displayTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: displaySubtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "fitness-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "slider-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Slider), {
                            min: 1,
                            max: options.length || 5,
                            step: 1,
                            dots: true,
                            value: sliderValue,
                            onChange: (val)=>{
                                const selectedOption = options[val - 1];
                                if (selectedOption) {
                                    if (onChange) onChange(selectedOption.slug);
                                    setLocalFitnessLevel(selectedOption.slug);
                                }
                            },
                            tooltip: {
                                open: false
                            },
                            className: "fitness-slider"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "fitness-labels-desktop",
                        children: options.map((level)=>{
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: `fitness-label-item ${fitnessLevel === level.slug ? 'active' : ''}`,
                                onClick: ()=>{
                                    if (onChange) onChange(level.slug);
                                    setLocalFitnessLevel(level.slug);
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "label-text",
                                    children: level.title
                                })
                            }, level.id);
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "fitness-labels-mobile",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "fitness-label-item active",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "label-text",
                                children: options[sliderValue - 1]?.title
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _animatedStep.AnimatedStep), {
                        isVisible: true,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "gradient-description-container",
                            style: {
                                marginTop: -10
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("ul", {
                                className: "gradient-description-list",
                                children: fitnessLevelDescriptions[fitnessLevel]?.map((description, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react1.motion).li, {
                                        initial: {
                                            opacity: 0,
                                            clipPath: 'inset(0 100% 0 0)'
                                        },
                                        animate: {
                                            opacity: 0.7,
                                            clipPath: 'inset(0 0 0 0)'
                                        },
                                        transition: {
                                            delay: index * 0.1,
                                            duration: 0.8,
                                            ease: 'easeInOut'
                                        },
                                        className: "gradient-description-item text-light slide-up-item",
                                        children: description
                                    }, index))
                            }, fitnessLevel)
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Slider","iCqio","default"]],"src/api/mutations/useGetProgramMasterData":"bOtFg","./FitnessLevelStep.scss":"kbg30","motion/react":"aBn1X","src/components/Animation/AnimatedStep":"duzKS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kbg30":[function() {},{}],"kuC7t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ActivityLevelStep", ()=>ActivityLevelStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _activityLevelStepScss = require("./ActivityLevelStep.scss");
const ActivityLevelStep = ({ clientName, value, onChange })=>{
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const nonGymData = programMasterData?.nonGymActivity;
    // Use dynamic slider boundaries from API, fallback to sensible defaults
    const min = nonGymData?.slider?.min;
    const max = nonGymData?.slider?.max;
    const step = nonGymData?.slider?.step;
    const title = nonGymData?.title?.replace('{{clientName}}', clientName);
    const subtitle = nonGymData?.subtitle || '';
    const [localActivityLike, setLocalActivityLike] = (0, _react.useState)(min ?? 0);
    const activityLike = value !== undefined ? value : localActivityLike;
    (0, _react.useEffect)(()=>{
        if (value === undefined && onChange) onChange(min ?? 0);
    }, [
        value,
        onChange,
        min
    ]);
    const deferredActivityLike = (0, _react.useDeferredValue)(activityLike);
    const options = nonGymData?.options;
    const currentDetails = (0, _react.useMemo)(()=>{
        // Default fallback to first option
        let matchedOption = options?.[0];
        // Find the option where percentage falls between minValue and maxValue
        if (options) for (const option of options){
            const optionMin = option.minValue ?? 0;
            const optionMax = option.maxValue ?? 100;
            if (deferredActivityLike >= optionMin && deferredActivityLike <= optionMax) {
                matchedOption = option;
                break;
            }
        }
        return {
            percent: `${deferredActivityLike}% ACTIVE`,
            title: matchedOption?.title,
            description: matchedOption?.subtitle
        };
    }, [
        deferredActivityLike,
        options
    ]);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "activity-level-step",
        children: 'Loading options...'
    });
    if (isError || !nonGymData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "activity-level-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "activity-level-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "activity-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "slider-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Slider), {
                            min: min,
                            max: max,
                            step: step,
                            defaultValue: min,
                            value: activityLike,
                            onChange: (val)=>{
                                if (onChange) onChange(val);
                                setLocalActivityLike(val);
                            },
                            tooltip: {
                                open: false
                            },
                            className: "activity-slider"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "activity-content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "percent-active",
                                children: currentDetails.percent
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "activity-title",
                                children: currentDetails.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "activity-description",
                                children: currentDetails.description
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Slider","iCqio","default"]],"src/api/mutations/useGetProgramMasterData":"bOtFg","./ActivityLevelStep.scss":"bcC2m","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bcC2m":[function() {},{}],"9OWxb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MovementInsightsStep", ()=>MovementInsightsStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _movementInsightsStepScss = require("./MovementInsightsStep.scss");
const MovementInsightsStep = ({ insightIndex, values: propValues, onChange })=>{
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const movementInsightsData = programMasterData?.movementInsights;
    const items = movementInsightsData?.items;
    // Use the API options and ensure they are sorted by order
    const insights = (0, _react.useMemo)(()=>{
        return [
            ...items || []
        ].sort((a, b)=>(a.order || 0) - (b.order || 0));
    }, [
        items
    ]);
    const commonOptions = movementInsightsData?.commonOptions;
    const options = (0, _react.useMemo)(()=>{
        return [
            ...commonOptions || []
        ].sort((a, b)=>(a.order || 0) - (b.order || 0));
    }, [
        commonOptions
    ]);
    // Store values for all insights independently, defaulting to 1 (Pain)
    // We use a safe length from insights or fallback to 5
    const maxInsights = insights.length > 0 ? insights.length : 5;
    const [localValues, setLocalValues] = (0, _react.useState)(Array(maxInsights).fill('pain'));
    const values = propValues !== undefined ? propValues : localValues;
    (0, _react.useEffect)(()=>{
        if (propValues === undefined && onChange) onChange(Array(maxInsights).fill('pain'));
    }, [
        propValues,
        onChange,
        maxInsights
    ]);
    // Safe fallback if insightIndex goes out of bounds
    const currentInsightIndex = Math.min(Math.max(insightIndex - 1, 0), insights.length - 1);
    const currentInsight = insights[currentInsightIndex];
    const currentValueStr = values[currentInsightIndex] || 'pain';
    const currentValueIndex = Math.max(1, options.findIndex((opt)=>opt.slug === currentValueStr) + 1);
    const handleValueChange = (valIndex)=>{
        const newValues = [
            ...values
        ];
        const option = options[valIndex - 1];
        if (option) {
            newValues[currentInsightIndex] = option.slug;
            if (onChange) onChange(newValues);
            setLocalValues(newValues);
        }
    };
    // If headerTitle is provided, e.g. "Movement Insights 1/5", use it.
    const displayHeader = currentInsight?.headerTitle;
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "movement-insights-step",
        children: 'Loading options...'
    });
    if (isError || !movementInsightsData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "movement-insights-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "movement-insights-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                className: "step-title",
                children: [
                    displayHeader.replace(/\d+\/\d+/, ''),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "step-total",
                        children: `${insightIndex}/${insights.length}`
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "movement-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "movement-card-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "movement-title",
                                children: currentInsight?.title
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "movement-description",
                                children: currentInsight?.subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "slider-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Slider), {
                            min: 1,
                            max: options.length,
                            step: 1,
                            dots: true,
                            value: currentValueIndex,
                            onChange: (val)=>handleValueChange(val),
                            tooltip: {
                                open: false
                            },
                            className: "movement-slider"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "insight-labels",
                        children: options.map((opt, index)=>{
                            const optValue = index + 1;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: `insight-label-item ${currentValueIndex === optValue ? 'active' : ''}`,
                                onClick: ()=>handleValueChange(optValue),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "label-text",
                                    children: opt.title
                                })
                            }, opt.id);
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Slider","iCqio","default"]],"src/api/mutations/useGetProgramMasterData":"bOtFg","./MovementInsightsStep.scss":"1Rgvb","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Rgvb":[function() {},{}],"543Zl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "OnboardNewClientPromptStep", ()=>OnboardNewClientPromptStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _onboardNewClientPromptStepScss = require("./OnboardNewClientPromptStep.scss");
var _button = require("src/screens/OnboardingTrainer/components/Button/Button");
var _nextSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/next.svg");
const OnboardNewClientPromptStep = ({ onNext, onLater })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "onboard-new-client-prompt-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: "Would you like to onboard you new client now?"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: "You'll have to answer some questions about this client."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "prompt-actions",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                        variant: "primary",
                        className: "btn-primary-white m-height-48 right-arrow prompt-btn",
                        onClick: onNext,
                        svg: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nextSvg.ReactComponent), {}),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "btn-text",
                            children: "Onboard Client"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "prompt-btn-later",
                        onClick: onLater,
                        children: "I'll do it later"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./OnboardNewClientPromptStep.scss":"ig4I4","src/screens/OnboardingTrainer/components/Button/Button":"jLE7r","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/next.svg":"ixBdp","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ig4I4":[function() {},{}],"5tAFh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InjuriesLimitationsStep", ()=>InjuriesLimitationsStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _injurieslimitationsMaleNeckWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-neck.webp");
var _injurieslimitationsMaleNeckWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleNeckWebp);
var _injurieslimitationsMaleShouldersWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-shoulders.webp");
var _injurieslimitationsMaleShouldersWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleShouldersWebp);
var _injurieslimitationsMaleChestWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-chest.webp");
var _injurieslimitationsMaleChestWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleChestWebp);
var _injurieslimitationsMaleCoreWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-core.webp");
var _injurieslimitationsMaleCoreWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleCoreWebp);
var _injurieslimitationsMaleBackWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-back.webp");
var _injurieslimitationsMaleBackWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleBackWebp);
var _injurieslimitationsMaleWristsWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-wrists.webp");
var _injurieslimitationsMaleWristsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleWristsWebp);
var _injurieslimitationsMaleElbowWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-elbow.webp");
var _injurieslimitationsMaleElbowWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleElbowWebp);
var _injurieslimitationsMaleArmsWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-arms.webp");
var _injurieslimitationsMaleArmsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleArmsWebp);
var _injurieslimitationsMaleHipsWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-hips.webp");
var _injurieslimitationsMaleHipsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleHipsWebp);
var _injurieslimitationsMaleKneesWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-knees.webp");
var _injurieslimitationsMaleKneesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleKneesWebp);
var _injurieslimitationsMaleAnklesWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-ankles.webp");
var _injurieslimitationsMaleAnklesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleAnklesWebp);
var _injurieslimitationsMaleGlutesWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-glutes.webp");
var _injurieslimitationsMaleGlutesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleGlutesWebp);
var _injurieslimitationsFemaleNeckWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-neck.webp");
var _injurieslimitationsFemaleNeckWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleNeckWebp);
var _injurieslimitationsFemaleShouldersWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-shoulders.webp");
var _injurieslimitationsFemaleShouldersWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleShouldersWebp);
var _injurieslimitationsFemaleChestWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-chest.webp");
var _injurieslimitationsFemaleChestWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleChestWebp);
var _injurieslimitationsFemaleCoreWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-core.webp");
var _injurieslimitationsFemaleCoreWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleCoreWebp);
var _injurieslimitationsFemaleBackWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-back.webp");
var _injurieslimitationsFemaleBackWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleBackWebp);
var _injurieslimitationsFemaleWristsWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-wrists.webp");
var _injurieslimitationsFemaleWristsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleWristsWebp);
var _injurieslimitationsFemaleElbowWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-elbow.webp");
var _injurieslimitationsFemaleElbowWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleElbowWebp);
var _injurieslimitationsFemaleArmsWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-arms.webp");
var _injurieslimitationsFemaleArmsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleArmsWebp);
var _injurieslimitationsFemaleHipsWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-hips.webp");
var _injurieslimitationsFemaleHipsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleHipsWebp);
var _injurieslimitationsFemaleKneesWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-knees.webp");
var _injurieslimitationsFemaleKneesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleKneesWebp);
var _injurieslimitationsFemaleAnklesWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-ankles.webp");
var _injurieslimitationsFemaleAnklesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleAnklesWebp);
var _injurieslimitationsFemaleGlutesWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-glutes.webp");
var _injurieslimitationsFemaleGlutesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleGlutesWebp);
var _injurieslimitationsFemalePregnancyWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-pregnancy.webp");
var _injurieslimitationsFemalePregnancyWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemalePregnancyWebp);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _genderUtils = require("src/utils/genderUtils");
var _injuriesLimitationsStepScss = require("./InjuriesLimitationsStep.scss");
const InjuriesLimitationsStep = ({ bodyProfile = 'male', selectedParts, onChangeParts, notes, onChangeNotes })=>{
    const [localNote, setLocalNote] = (0, _react.useState)(notes || '');
    const [isSaving, setIsSaving] = (0, _react.useState)(false);
    const [isSaved, setIsSaved] = (0, _react.useState)(false);
    const saveTimeoutRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        setLocalNote(notes || '');
    }, [
        notes
    ]);
    (0, _react.useEffect)(()=>{
        return ()=>{
            if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
        };
    }, []);
    const handleNotesChange = (val)=>{
        setIsSaved(false);
        setLocalNote(val);
    };
    const handleAddNote = (e)=>{
        e.preventDefault();
        if (!localNote.trim() || !/\p{L}/u.test(localNote) || isSaving) return;
        setIsSaving(true);
        setIsSaved(false);
        const trimmed = localNote.trim();
        setLocalNote(trimmed);
        onChangeNotes(trimmed);
        if (document.activeElement instanceof HTMLElement) document.activeElement.blur();
        if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
        saveTimeoutRef.current = setTimeout(()=>{
            setIsSaving(false);
            setIsSaved(true);
        }, 500);
    };
    const genderKey = (0, _genderUtils.resolveBodyProfile)(bodyProfile);
    const isFemale = (0, _genderUtils.isFemaleProfile)(bodyProfile);
    const iconMapping = {
        neck: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleNeckWebpDefault.default),
            alt: "InjurieslimitationsFemaleNeckIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleNeckWebpDefault.default),
            alt: "InjurieslimitationsMaleNeckIcon",
            className: "program-svg-icon"
        }),
        shoulders: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleShouldersWebpDefault.default),
            alt: "InjurieslimitationsFemaleShouldersIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleShouldersWebpDefault.default),
            alt: "InjurieslimitationsMaleShouldersIcon",
            className: "program-svg-icon"
        }),
        chest: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleChestWebpDefault.default),
            alt: "InjurieslimitationsFemaleChestIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleChestWebpDefault.default),
            alt: "InjurieslimitationsMaleChestIcon",
            className: "program-svg-icon"
        }),
        core: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleCoreWebpDefault.default),
            alt: "InjurieslimitationsFemaleCoreIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleCoreWebpDefault.default),
            alt: "InjurieslimitationsMaleCoreIcon",
            className: "program-svg-icon"
        }),
        back: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleBackWebpDefault.default),
            alt: "InjurieslimitationsFemaleBackIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleBackWebpDefault.default),
            alt: "InjurieslimitationsMaleBackIcon",
            className: "program-svg-icon"
        }),
        wrists: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleWristsWebpDefault.default),
            alt: "InjurieslimitationsFemaleWristsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleWristsWebpDefault.default),
            alt: "InjurieslimitationsMaleWristsIcon",
            className: "program-svg-icon"
        }),
        elbow: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleElbowWebpDefault.default),
            alt: "InjurieslimitationsFemaleElbowIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleElbowWebpDefault.default),
            alt: "InjurieslimitationsMaleElbowIcon",
            className: "program-svg-icon"
        }),
        arms: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleArmsWebpDefault.default),
            alt: "InjurieslimitationsFemaleArmsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleArmsWebpDefault.default),
            alt: "InjurieslimitationsMaleArmsIcon",
            className: "program-svg-icon"
        }),
        hips: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleHipsWebpDefault.default),
            alt: "InjurieslimitationsFemaleHipsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleHipsWebpDefault.default),
            alt: "InjurieslimitationsMaleHipsIcon",
            className: "program-svg-icon"
        }),
        knees: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleKneesWebpDefault.default),
            alt: "InjurieslimitationsFemaleKneesIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleKneesWebpDefault.default),
            alt: "InjurieslimitationsMaleKneesIcon",
            className: "program-svg-icon"
        }),
        ankles: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleAnklesWebpDefault.default),
            alt: "InjurieslimitationsFemaleAnklesIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleAnklesWebpDefault.default),
            alt: "InjurieslimitationsMaleAnklesIcon",
            className: "program-svg-icon"
        }),
        glutes: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleGlutesWebpDefault.default),
            alt: "InjurieslimitationsFemaleGlutesIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleGlutesWebpDefault.default),
            alt: "InjurieslimitationsMaleGlutesIcon",
            className: "program-svg-icon"
        }),
        pregnancy: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemalePregnancyWebpDefault.default),
            alt: "InjurieslimitationsFemalePregnancyIcon",
            className: "program-svg-icon"
        }) : null
    };
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const injuriesLimitationsData = programMasterData?.injuriesLimitations;
    const togglePart = (id)=>{
        onChangeParts(selectedParts.includes(id) ? selectedParts.filter((p)=>p !== id) : [
            ...selectedParts,
            id
        ]);
    };
    const injuriesOptions = injuriesLimitationsData?.options;
    const options = (0, _react.useMemo)(()=>{
        return [
            ...injuriesOptions || []
        ].filter((opt)=>!opt.targetProfile || opt.targetProfile === genderKey).sort((a, b)=>(a.order || 0) - (b.order || 0));
    }, [
        injuriesOptions,
        genderKey
    ]);
    (0, _react.useEffect)(()=>{
        if (options.length > 0 && selectedParts.length > 0) {
            const allowedSlugs = new Set(options.map((opt)=>opt.slug));
            const filtered = selectedParts.filter((p)=>allowedSlugs.has(p));
            if (filtered.length !== selectedParts.length) onChangeParts(filtered);
        }
    }, [
        options,
        selectedParts,
        onChangeParts
    ]);
    const { title, subtitle, note } = injuriesLimitationsData || {};
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "injuries-limitations-step",
        children: 'Loading options...'
    });
    if (isError || !injuriesLimitationsData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "injuries-limitations-step",
        children: 'Error loading options.'
    });
    const isAddDisabled = !localNote.trim() || !/\p{L}/u.test(localNote) || isSaving;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "injuries-limitations-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "body-parts-grid",
                children: options.map((part)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `body-part-card ${selectedParts.includes(part.slug) ? 'selected' : ''}`,
                        onClick: ()=>togglePart(part.slug),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "part-image",
                                children: iconMapping[part.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "part-label",
                                children: part.title
                            })
                        ]
                    }, part.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "notes-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        className: "notes-label",
                        children: note?.title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                        className: `notes-input ${localNote.trim() !== '' && !/\p{L}/u.test(localNote) ? 'error-border' : ''}`,
                        placeholder: note?.placeholder,
                        value: localNote,
                        maxLength: 1000,
                        onChange: (e)=>handleNotesChange(e.target.value),
                        onBlur: (e)=>handleNotesChange(e.target.value.trim())
                    }),
                    localNote.trim() !== '' && !/\p{L}/u.test(localNote) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "error-message",
                        children: "Notes must contain at least one valid letter."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                        style: {
                            display: 'block',
                            textAlign: 'right',
                            color: '#a0a0ab',
                            fontSize: '12px',
                            marginTop: '4px'
                        },
                        children: [
                            localNote.length,
                            "/1000"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "mobile-add-btn",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: `add-btn ${isSaving ? 'saving' : ''}`,
                                disabled: isAddDisabled,
                                onClick: handleAddNote,
                                children: isSaving ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "btn-spinner"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "Saving..."
                                        })
                                    ]
                                }) : 'Add'
                            }),
                            isSaved && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "note-saved-status",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        width: "16",
                                        height: "16",
                                        viewBox: "0 0 16 16",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                            d: "M13.3334 4L6.00008 11.3333L2.66675 8",
                                            stroke: "#10B981",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Note saved"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","url:src/assets/images/trainer/program-generator/injurieslimitations-male-neck.webp":"bMNGc","url:src/assets/images/trainer/program-generator/injurieslimitations-male-shoulders.webp":"9f150","url:src/assets/images/trainer/program-generator/injurieslimitations-male-chest.webp":"1WA6S","url:src/assets/images/trainer/program-generator/injurieslimitations-male-core.webp":"6ykDS","url:src/assets/images/trainer/program-generator/injurieslimitations-male-back.webp":"552LM","url:src/assets/images/trainer/program-generator/injurieslimitations-male-wrists.webp":"2vVR2","url:src/assets/images/trainer/program-generator/injurieslimitations-male-elbow.webp":"5rwm2","url:src/assets/images/trainer/program-generator/injurieslimitations-male-arms.webp":"gywcQ","url:src/assets/images/trainer/program-generator/injurieslimitations-male-hips.webp":"IL2gD","url:src/assets/images/trainer/program-generator/injurieslimitations-male-knees.webp":"chOpQ","url:src/assets/images/trainer/program-generator/injurieslimitations-male-ankles.webp":"9LTxX","url:src/assets/images/trainer/program-generator/injurieslimitations-male-glutes.webp":"axt4z","url:src/assets/images/trainer/program-generator/injurieslimitations-female-neck.webp":"7ieJ8","url:src/assets/images/trainer/program-generator/injurieslimitations-female-shoulders.webp":"c4vn4","url:src/assets/images/trainer/program-generator/injurieslimitations-female-chest.webp":"18x57","url:src/assets/images/trainer/program-generator/injurieslimitations-female-core.webp":"fAYwU","url:src/assets/images/trainer/program-generator/injurieslimitations-female-back.webp":"b7YNj","url:src/assets/images/trainer/program-generator/injurieslimitations-female-wrists.webp":"jqY0l","url:src/assets/images/trainer/program-generator/injurieslimitations-female-elbow.webp":"cUOkG","url:src/assets/images/trainer/program-generator/injurieslimitations-female-arms.webp":"ejSWy","url:src/assets/images/trainer/program-generator/injurieslimitations-female-hips.webp":"4XVjh","url:src/assets/images/trainer/program-generator/injurieslimitations-female-knees.webp":"bahGv","url:src/assets/images/trainer/program-generator/injurieslimitations-female-ankles.webp":"aEszt","url:src/assets/images/trainer/program-generator/injurieslimitations-female-glutes.webp":"1xfcS","url:src/assets/images/trainer/program-generator/injurieslimitations-female-pregnancy.webp":"zojTP","src/api/mutations/useGetProgramMasterData":"bOtFg","src/utils/genderUtils":"aiA54","./InjuriesLimitationsStep.scss":"6ybvq","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ybvq":[function() {},{}],"4BJkD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgramDurationStep", ()=>ProgramDurationStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _programDurationStepScss = require("./ProgramDurationStep.scss");
const ProgramDurationStep = ({ value, onChange })=>{
    const [localDuration, setLocalDuration] = (0, _react.useState)(1);
    const duration = value !== undefined ? value : localDuration;
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const programDurationData = programMasterData?.programDuration;
    const programDurationOptions = programDurationData?.options;
    const options = (0, _react.useMemo)(()=>{
        return [
            ...programDurationOptions || []
        ].sort((a, b)=>(a.order || 0) - (b.order || 0));
    }, [
        programDurationOptions
    ]);
    const { title, subtitle } = programDurationData || {};
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "program-duration-step",
        children: 'Loading options...'
    });
    if (isError || !programDurationData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "program-duration-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "program-duration-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "duration-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "slider-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Slider), {
                            min: 1,
                            max: options.length > 0 ? options.length : 12,
                            step: 1,
                            dots: true,
                            value: duration,
                            onChange: (val)=>{
                                if (onChange) onChange(val);
                                setLocalDuration(val);
                            },
                            tooltip: {
                                open: false
                            },
                            className: "duration-slider"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "duration-labels",
                        children: options.map((opt, index)=>{
                            const optValue = index + 1;
                            // The design just showed numbers, so we parse out the number or fallback to order
                            const labelNum = opt.title?.match(/\d+/)?.[0] || optValue;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: `duration-label-item ${duration === optValue ? 'active' : ''}`,
                                onClick: ()=>{
                                    if (onChange) onChange(optValue);
                                    setLocalDuration(optValue);
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "label-text",
                                    children: labelNum
                                })
                            }, opt.id);
                        })
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Slider","iCqio","default"]],"src/api/mutations/useGetProgramMasterData":"bOtFg","./ProgramDurationStep.scss":"6pCb2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6pCb2":[function() {},{}],"bolCs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "HowOftenTrainStep", ()=>HowOftenTrainStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _howOftenTrainStepScss = require("./HowOftenTrainStep.scss");
var _morningSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/morning.svg");
var _eveningSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/evening.svg");
var _lunchSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/lunch.svg");
const iconMapping = {
    morning: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _morningSvg.ReactComponent), {}),
    lunch: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lunchSvg.ReactComponent), {}),
    evening: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _eveningSvg.ReactComponent), {})
};
const HowOftenTrainStep = ({ value, reminderValue, onChange })=>{
    const [localDays, setLocalDays] = (0, _react.useState)([]);
    const [localReminder, setLocalReminder] = (0, _react.useState)('');
    const selectedDays = value !== undefined ? value : localDays;
    const selectedReminder = reminderValue !== undefined ? reminderValue : localReminder;
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const trainingSchedule = programMasterData?.trainingSchedule;
    const trainingDaysField = trainingSchedule?.fields?.find((f)=>f.id === 'training_days');
    const preferredTimeField = trainingSchedule?.fields?.find((f)=>f.id === 'preferred_time');
    const trainingDaysOptionsData = trainingDaysField?.options;
    const trainingDaysOptions = (0, _react.useMemo)(()=>{
        return [
            ...trainingDaysOptionsData || []
        ].sort((a, b)=>(a.order || 0) - (b.order || 0));
    }, [
        trainingDaysOptionsData
    ]);
    const preferredTimeOptionsData = preferredTimeField?.options;
    const preferredTimeOptions = (0, _react.useMemo)(()=>{
        return [
            ...preferredTimeOptionsData || []
        ].sort((a, b)=>(a.order || 0) - (b.order || 0));
    }, [
        preferredTimeOptionsData
    ]);
    const handleDaySelect = (id)=>{
        const newDays = selectedDays.includes(id) ? selectedDays.filter((i)=>i !== id) : [
            ...selectedDays,
            id
        ];
        if (onChange) onChange(newDays, selectedReminder);
        setLocalDays(newDays);
    };
    const handleReminderSelect = (reminderId)=>{
        const newReminder = reminderId === selectedReminder ? '' : reminderId;
        if (onChange) onChange(selectedDays, newReminder);
        setLocalReminder(newReminder);
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "how-often-train-step",
        children: 'Loading options...'
    });
    if (isError || !trainingSchedule) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "how-often-train-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "how-often-train-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: trainingSchedule.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: trainingSchedule.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "days-container",
                children: trainingDaysOptions.map((day)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `day-circle ${selectedDays.includes(day.slug) ? 'selected' : ''}`,
                        onClick: ()=>handleDaySelect(day.slug),
                        children: day.shortTitle || day.title?.[0]
                    }, day.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "days-text",
                children: selectedDays.length > 0 ? `${selectedDays.length} DAY${selectedDays.length > 1 ? 'S' : ''} PER WEEK` : '\u00A0'
            }),
            selectedDays.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "reminder-section fadeIn",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "reminder-title",
                        children: preferredTimeField?.title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "reminder-options",
                        children: preferredTimeOptions.map((timeOpt)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                className: `reminder-btn ${selectedReminder === timeOpt.slug ? 'selected' : ''}`,
                                onClick: ()=>handleReminderSelect(timeOpt.slug),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: iconMapping[timeOpt.id] || null
                                    }),
                                    timeOpt.title
                                ]
                            }, timeOpt.id))
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./HowOftenTrainStep.scss":"5zFUE","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/morning.svg":"cTE61","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/evening.svg":"g8LW6","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/lunch.svg":"cDjUk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5zFUE":[function() {},{}],"cTE61":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMorning);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMorning = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M15 22.22a1.03 1.03 0 0 1 1.024.91l.007.121v1.031a1.032 1.032 0 0 1-2.055.121l-.007-.12V23.25A1.03 1.03 0 0 1 15 22.22m6.511-2.156.097.086.722.722a1.031 1.031 0 0 1-1.361 1.544l-.097-.086-.722-.722a1.032 1.032 0 0 1 1.256-1.616zm-11.66.086a1.03 1.03 0 0 1 .085 1.361l-.086.097-.722.722a1.032 1.032 0 0 1-1.544-1.361l.086-.097.722-.722a1.03 1.03 0 0 1 1.458 0m-3.102-6.18a1.031 1.031 0 0 1 .12 2.055l-.12.007h-1.03a1.032 1.032 0 0 1-.12-2.056l.12-.007zm17.533 0a1.03 1.03 0 0 1 .121 2.055l-.12.007H23.25a1.031 1.031 0 0 1-.12-2.056l.12-.007zM9.032 7.584l.096.086.722.722a1.031 1.031 0 0 1-1.36 1.545l-.097-.086-.722-.722a1.031 1.031 0 0 1 1.255-1.616zm13.298.086a1.03 1.03 0 0 1 .086 1.361l-.086.097-.722.722a1.032 1.032 0 0 1-1.544-1.361l.086-.097.722-.722a1.03 1.03 0 0 1 1.458 0M15 4.687a1.03 1.03 0 0 1 1.024.911l.007.12V6.75a1.032 1.032 0 0 1-2.055.12l-.007-.12V5.72A1.03 1.03 0 0 1 15 4.687m0 5.157a5.157 5.157 0 1 1-5.152 5.38l-.005-.223.005-.224A5.156 5.156 0 0 1 15 9.844"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g8LW6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEvening);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEvening = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M17.79 24.375q.82 0 1.64-.164a7.7 7.7 0 0 0 1.57-.492q.258-.117.422-.352a.9.9 0 0 0 .164-.515.88.88 0 0 0-.375-.727 8.74 8.74 0 0 1-2.531-3.164A9.1 9.1 0 0 1 17.79 15q0-2.085.9-3.95a9.1 9.1 0 0 1 2.544-3.175q.165-.14.258-.328a.93.93 0 0 0-.06-.914.95.95 0 0 0-.409-.352 8.4 8.4 0 0 0-3.234-.656 9.1 9.1 0 0 0-3.656.739 9.5 9.5 0 0 0-2.977 2.003 9.5 9.5 0 0 0-2.004 2.977A9.1 9.1 0 0 0 8.414 15a9.15 9.15 0 0 0 .739 3.656 9.5 9.5 0 0 0 2.003 2.977 9.5 9.5 0 0 0 2.977 2.004q1.711.74 3.656.738"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cDjUk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLunch);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLunch = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#E5E5E5",
                    d: "M26.25 18.835a.78.78 0 0 1-.22.543.74.74 0 0 1-.53.224h-21a.74.74 0 0 1-.53-.224.776.776 0 0 1 0-1.085.74.74 0 0 1 .53-.225h3.792a6.98 6.98 0 0 1 1.935-5.648A6.68 6.68 0 0 1 15 10.398c1.79 0 3.507.727 4.773 2.022a6.98 6.98 0 0 1 1.935 5.648H25.5c.199 0 .39.081.53.225s.22.339.22.542m-3.75 3.069h-15c-.199 0-.39.08-.53.224a.776.776 0 0 0 0 1.085c.14.144.331.224.53.224h15c.199 0 .39-.08.53-.224a.776.776 0 0 0 0-1.085.74.74 0 0 0-.53-.224M10.579 9.207a.77.77 0 0 0 .434.385.735.735 0 0 0 .804-.225.77.77 0 0 0 .182-.557.8.8 0 0 0-.078-.29l-.75-1.533a.76.76 0 0 0-.434-.385.74.74 0 0 0-.573.042.76.76 0 0 0-.376.443.78.78 0 0 0 .04.586zm-5.665 4.179 1.5.767a.74.74 0 0 0 .573.041.76.76 0 0 0 .434-.384.78.78 0 0 0 .04-.586.76.76 0 0 0-.375-.443l-1.5-.767a.74.74 0 0 0-1.007.342.78.78 0 0 0 .104.846.8.8 0 0 0 .231.184m18.336.847q.176 0 .335-.08l1.5-.767a.75.75 0 0 0 .376-.444.78.78 0 0 0-.22-.822.75.75 0 0 0-.545-.185.7.7 0 0 0-.283.079l-1.5.767a.76.76 0 0 0-.343.36.78.78 0 0 0 .215.927.74.74 0 0 0 .465.165m-4.836-4.682a.74.74 0 0 0 .828-.107.8.8 0 0 0 .18-.237l.75-1.534a.78.78 0 0 0 .04-.586.76.76 0 0 0-.376-.443.74.74 0 0 0-.573-.042.76.76 0 0 0-.434.385l-.75 1.534a.78.78 0 0 0 .104.846.8.8 0 0 0 .231.184"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i37lG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WorkoutDurationStep", ()=>WorkoutDurationStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _workoutDurationStepScss = require("./WorkoutDurationStep.scss");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
const WorkoutDurationStep = ({ onNext, value, onChange })=>{
    const [localDuration, setLocalDuration] = (0, _react.useState)('');
    const selectedDuration = value !== undefined ? value : localDuration;
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const workoutDuration = programMasterData?.workoutDuration;
    const options = workoutDuration?.options;
    const durationOptions = (0, _react.useMemo)(()=>{
        if (!options) return [];
        return [
            ...options
        ].sort((a, b)=>(a.order || 0) - (b.order || 0));
    }, [
        options
    ]);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "workout-duration-step",
        children: 'Loading options...'
    });
    if (isError || !workoutDuration) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "workout-duration-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "workout-duration-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: workoutDuration.title
            }),
            workoutDuration.subtitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: workoutDuration.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "duration-buttons",
                children: durationOptions.map((duration)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `duration-btn ${selectedDuration === duration.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            if (onChange) onChange(duration.slug);
                            setLocalDuration(duration.slug);
                            if (onNext) onNext();
                        },
                        children: duration.title
                    }, duration.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./WorkoutDurationStep.scss":"gGqm7","src/api/mutations/useGetProgramMasterData":"bOtFg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gGqm7":[function() {},{}],"5mwFM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TrainingGoalStep", ()=>TrainingGoalStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _trainingGoalStepScss = require("./TrainingGoalStep.scss");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/increase_strength.svg");
var _injuryPreventionSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injury_prevention.svg");
var _generalFitnessSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_fitness.svg");
var _rehabilitationSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/rehabilitation.svg");
var _buildMuscleSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/build_muscle.svg");
var _weightLossSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/weight_loss.svg");
var _performanceSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/performance.svg");
var _enduranceSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/endurance.svg");
var _mobilitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility.svg");
const iconMapping = {
    increase_strength: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _increaseStrengthSvg.ReactComponent), {}),
    build_muscle: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildMuscleSvg.ReactComponent), {}),
    weight_loss: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _weightLossSvg.ReactComponent), {}),
    endurance: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enduranceSvg.ReactComponent), {}),
    mobility: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobilitySvg.ReactComponent), {}),
    performance: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _performanceSvg.ReactComponent), {}),
    general_fitness: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalFitnessSvg.ReactComponent), {}),
    rehabilitation: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rehabilitationSvg.ReactComponent), {}),
    injury_prevention: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _injuryPreventionSvg.ReactComponent), {})
};
const TrainingGoalStep = ({ value, onNext })=>{
    const [selectedGoal, setSelectedGoal] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const trainingGoal = programMasterData?.trainingGoal;
    const options = trainingGoal?.options;
    const goalOptions = (0, _react.useMemo)(()=>{
        if (!options) return [];
        return [
            ...options
        ].sort((a, b)=>(a.order || 0) - (b.order || 0));
    }, [
        options
    ]);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "training-goal-step",
        children: 'Loading options...'
    });
    if (isError || !trainingGoal) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "training-goal-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "training-goal-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: trainingGoal.title
            }),
            trainingGoal.subtitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: trainingGoal.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: goalOptions.map((goal)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedGoal === goal.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedGoal(goal.slug);
                            if (onNext) onNext(goal.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMapping[goal.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: goal.title
                            })
                        ]
                    }, goal.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./TrainingGoalStep.scss":"lSKMg","src/api/mutations/useGetProgramMasterData":"bOtFg","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/increase_strength.svg":"c50Bc","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injury_prevention.svg":"i5tXd","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_fitness.svg":"hbh5n","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/rehabilitation.svg":"l4M37","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/build_muscle.svg":"g1Rue","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/weight_loss.svg":"eVRip","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/performance.svg":"3wasH","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/endurance.svg":"2jvJA","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility.svg":"9FD61","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lSKMg":[function() {},{}],"c50Bc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgIncreaseStrength);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgIncreaseStrength = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#E5E5E5",
                    fillRule: "evenodd",
                    d: "M8.73 8.488a2.14 2.14 0 0 1 1.114-.285c.505 0 .874.14 1.114.285.37.22.48.6.486.87.01.538.04 2.313.04 5.642s-.03 5.104-.04 5.642c-.006.27-.117.65-.487.87-.239.144-.608.285-1.113.285-.506 0-.874-.14-1.114-.285-.37-.22-.48-.6-.486-.87-.01-.537-.04-2.312-.04-5.642s.03-5.104.04-5.642c.006-.27.116-.65.486-.87m12.54 0a2.14 2.14 0 0 0-1.114-.285c-.505 0-.874.14-1.113.285-.37.22-.481.6-.487.87-.01.537-.04 2.313-.04 5.642s.03 5.104.04 5.642c.006.27.117.65.486.87.24.144.609.285 1.114.285s.875-.14 1.114-.285c.37-.22.48-.6.486-.87.01-.538.04-2.312.04-5.642s-.03-5.104-.04-5.642c-.006-.27-.117-.65-.486-.87M5.86 10.547c-.31 0-.558.056-.748.13-.476.184-.623.635-.63.937-.01.42-.029 1.499-.029 3.386s.019 2.965.028 3.386c.007.302.155.753.631.937.19.074.438.13.747.13.31 0 .558-.056.748-.13.476-.184.623-.635.63-.937.01-.42.029-1.499.029-3.386s-.02-2.965-.029-3.386c-.007-.302-.154-.753-.63-.937a2.1 2.1 0 0 0-.748-.13m19.028.13a2.1 2.1 0 0 0-.747-.13c-.31 0-.558.056-.748.13-.475.184-.623.635-.63.937-.01.42-.029 1.499-.029 3.386s.02 2.965.028 3.386c.008.302.155.753.631.937.19.074.439.13.748.13s.557-.056.747-.13c.476-.184.623-.635.63-.937.01-.42.029-1.499.029-3.386s-.019-2.965-.028-3.386c-.007-.302-.155-.753-.631-.937m-12.466 5.662v-2.678c0-.445.364-.678.751-.711q.12-.012.359-.025c.319-.018.8-.034 1.468-.034s1.15.017 1.468.034q.24.014.359.025c.387.033.751.266.751.71v2.68c0 .444-.364.677-.751.71q-.12.012-.359.025c-.319.018-.8.034-1.468.034s-1.15-.017-1.468-.034q-.24-.014-.359-.025c-.387-.033-.751-.266-.751-.71",
                    clipRule: "evenodd"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i5tXd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgInjuryPrevention);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInjuryPrevention = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M15.376 6.996q-.297 0-.596.102L9.682 8.926a1.75 1.75 0 0 0-.797.59 1.47 1.47 0 0 0-.308.914v3.839q0 2.843 1.7 5.311t4.568 3.382q.128.041.255.061t.276.02.275-.02.255-.061q2.868-.914 4.569-3.382 1.7-2.468 1.699-5.311v-3.84q0-.508-.309-.913a1.75 1.75 0 0 0-.796-.59l-5.098-1.828a1.8 1.8 0 0 0-.595-.102m-.001 5.18c.328 0 .594.266.594.594v1.655h1.656a.595.595 0 0 1 0 1.19h-1.656v1.655a.594.594 0 0 1-1.187 0v-1.656h-1.656a.595.595 0 0 1 0-1.19h1.656V12.77c0-.328.266-.593.593-.593",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hbh5n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGeneralFitness);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGeneralFitness = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M15.643 9.362c1.706-2.118 4.755-2.245 6.613-.277 1.303 1.38 1.641 3.393 1.016 5.102H19.94l-2.128-4.254-2.438 4.874-1.218-2.436-.909 1.816h-5.77c-.625-1.709-.287-3.722 1.016-5.102 1.858-1.968 4.907-1.84 6.613.277l.268.333zm-7.172 6.45h5.589l1.314 2.63 2.438-4.875 1.123 2.246h3.343l-.022.022-6.878 7.286-.003.004-6.882-7.29z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l4M37":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgRehabilitation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRehabilitation = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M9.674 15.191 8.36 13.764c-1.853-1.861-1.82-4.22-.139-5.918 1.682-1.705 4.057-1.713 5.926.14l1.42 1.314c-.711-.204-1.47-.041-2.261.759l-2.98 2.97c-.79.792-.856 1.453-.652 2.163m6.978 3.934c-.817.816-1.6.84-2.44 0l-2.971-2.979c-.85-.84-.825-1.615-.008-2.432l2.856-2.864c.816-.817 1.591-.833 2.44.016l2.971 2.97c.84.841.816 1.625 0 2.44zm-.743-5.305c.31-.31.31-.791.008-1.093a.76.76 0 0 0-1.094 0 .76.76 0 0 0 .017 1.093.774.774 0 0 0 1.069 0m1.73 1.722a.76.76 0 0 0 0-1.093.76.76 0 0 0-1.093.008.75.75 0 0 0 0 1.069.76.76 0 0 0 1.093.016m-4.53 0a.764.764 0 0 0 1.086-.016.76.76 0 0 0 0-1.069.75.75 0 0 0-1.085-.008.76.76 0 0 0 0 1.093m9.418 6.602c-1.681 1.706-4.072 1.722-5.925-.139l-1.404-1.322c.702.204 1.428.066 2.22-.726l2.979-2.979c.791-.792.865-1.453.661-2.163l1.322 1.412c1.861 1.852 1.828 4.22.147 5.917m-6.61-4.888a.75.75 0 0 0-.008-1.086.75.75 0 0 0-1.07 0c-.31.302-.326.792-.016 1.086a.76.76 0 0 0 1.094 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g1Rue":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBuildMuscle);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBuildMuscle = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M26.133 17.51a.2.2 0 0 1-.032-.063c-.023-.07-2.383-7.063-8.058-9.76a2.8 2.8 0 0 1-1.01-.99c-.016-.032-.266-.47-1.107-.59a4 4 0 0 1 .149.455q.028.097.05.196.031.148.052.3c.01.058.022.116.027.175q.027.24.028.487-.002.692-.204 1.331c.496.065.943.326 1.23.737.596.85.987 2.141 1.163 3.84.001.033.024 1.166.588 2.175.35.378.694.818 1.021 1.348a.244.244 0 1 1-.416.257c-2.17-3.505-5.008-3.18-6.507-2.674a2.38 2.38 0 0 1-1.902-.148c-2.988-1.639-5.645.06-6.397.627 0 0-.035 5.6-.273 9.3l3.389 1.72c.339-.172 1.458-.823 1.855-2.103.092-.294.16-.561.221-.797.164-.633.281-1.09.66-1.276.278-.136.627-.096 1.166.135.15.064.3.127.454.178l.972.322c.192.064.355.108.513.139 2.335.462 4.86.153 6.753-.825 1.778-.915 2.769-1.323 3.287-1.504a4.75 4.75 0 0 0 1.808-1.104c.722-.712.896-1.345.52-1.887m-2.134.178c-.167.766-.774 1.416-1.806 1.932a.243.243 0 0 1-.328-.11.244.244 0 0 1 .11-.327c.89-.446 1.41-.982 1.546-1.595.173-.783-.352-1.455-.357-1.462a.244.244 0 0 1 .381-.306c.027.035.675.853.454 1.868"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M8.26 9.665c.015.025.025.053.04.078.074.129.162.247.25.365.032.043.059.09.092.132.072.088.153.167.23.248.06.061.114.128.177.185.057.053.121.096.182.145.092.075.182.153.28.22.038.025.08.044.12.068.126.079.253.158.388.222l.076.03c.153.069.309.133.47.183.037.011.077.016.115.026.152.042.305.081.463.105a4 4 0 0 0 1.207 0c.158-.024.31-.063.462-.105.038-.01.078-.014.116-.026.163-.05.321-.115.476-.186.023-.01.047-.016.07-.027.14-.067.274-.148.405-.23.034-.022.07-.038.102-.06.105-.07.201-.154.3-.234.053-.044.11-.082.162-.13.069-.062.128-.134.192-.201.072-.077.149-.149.215-.232.037-.046.068-.098.103-.146.083-.114.168-.226.24-.35l.042-.084a3.9 3.9 0 0 0 .484-2.374q-.01-.08-.024-.16a4 4 0 0 0-.046-.263q-.02-.09-.046-.177a4 4 0 0 0-.133-.407 4 4 0 0 0-.104-.241q-.034-.072-.07-.143a4 4 0 0 0-.245-.416l-.077-.103a4 4 0 0 0-.355-.424 4 4 0 0 0-.471-.414q-.105-.08-.212-.151a4 4 0 0 0-.434-.245q-.091-.047-.185-.089a4 4 0 0 0-.418-.15q-.076-.022-.153-.04a4 4 0 0 0-.347-.073q-.075-.014-.152-.024a4 4 0 0 0-.5-.035c-.17 0-.336.015-.5.035q-.077.01-.152.024-.176.029-.348.073-.077.018-.152.04a4 4 0 0 0-.419.15c-.063.027-.124.06-.186.09a4 4 0 0 0-.912.616q-.105.092-.203.193a4 4 0 0 0-.354.422l-.08.106a4.2 4.2 0 0 0-.48.97 4 4 0 0 0-.07.232q-.025.09-.047.182a4 4 0 0 0-.045.26q-.014.08-.025.161a3.9 3.9 0 0 0 .487 2.378m3.052-3.93.044-.008q.187-.038.385-.04.197.002.384.04l.045.009a2.04 2.04 0 0 1 1.608 1.984c0 .843-.514 1.569-1.245 1.88l-.009.004q-.166.068-.347.108-.024.006-.05.01a2 2 0 0 1-.386.04q-.199-.001-.387-.04l-.05-.01a2 2 0 0 1-.347-.108L10.95 9.6a2.05 2.05 0 0 1-1.245-1.88c0-.972.69-1.785 1.608-1.984"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eVRip":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgWeightLoss);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgWeightLoss = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M8.789 20.778a1.625 1.625 0 0 0 1.623 1.535h9.925a1.625 1.625 0 0 0 1.622-1.535l.632-11.375a1.626 1.626 0 0 0-1.622-1.716H9.78a1.625 1.625 0 0 0-1.622 1.716zm2.424-8.305c-.333-.22-.417-.655-.144-.938a5.9 5.9 0 0 1 1.603-1.17 6.2 6.2 0 0 1 2.664-.645 6.2 6.2 0 0 1 2.686.561 5.9 5.9 0 0 1 1.643 1.12c.283.274.215.711-.11.941l-1.752 1.238c-.325.23-.783.155-1.12-.06a2.36 2.36 0 0 0-1.223-.36l-1.379-1.584a.406.406 0 0 0-.613.534l1.07 1.228a2.3 2.3 0 0 0-.413.223c-.33.225-.784.313-1.118.094z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3wasH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPerformance);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPerformance = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    stroke: "#E5E5E5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.875,
                    d: "m23.5 10.938-6.393 6.393c-.322.322-.483.482-.668.543a.8.8 0 0 1-.503 0c-.185-.06-.346-.221-.668-.543l-2.224-2.224c-.322-.322-.482-.483-.668-.543a.8.8 0 0 0-.502 0c-.186.06-.347.221-.668.543L7.25 19.063m16.25-2.438v-5.687h-5.687"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M5.625 5.25h19.5v19.5h-19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2jvJA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEndurance);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEndurance = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M13.75 7.688a.78.78 0 0 1-.578-.234.8.8 0 0 1-.235-.579q0-.345.235-.578a.8.8 0 0 1 .578-.234H17q.345 0 .58.234a.78.78 0 0 1 .233.578q-.001.345-.235.58a.78.78 0 0 1-.578.232zm1.625 8.937q.345 0 .58-.234a.78.78 0 0 0 .232-.578v-3.25a.78.78 0 0 0-.234-.579.8.8 0 0 0-.578-.234.78.78 0 0 0-.578.234.8.8 0 0 0-.235.579v3.25q0 .345.235.579a.78.78 0 0 0 .578.233m0 6.5a7 7 0 0 1-2.834-.578 7.5 7.5 0 0 1-2.325-1.575 7.5 7.5 0 0 1-1.574-2.326 7 7 0 0 1-.58-2.834q0-1.503.58-2.833a7.5 7.5 0 0 1 1.574-2.326 7.5 7.5 0 0 1 2.326-1.574 7 7 0 0 1 2.833-.579q1.26 0 2.417.406t2.174 1.178l.568-.568a.77.77 0 0 1 .57-.224q.345 0 .568.224a.77.77 0 0 1 .223.568.77.77 0 0 1-.223.57l-.569.568a7.9 7.9 0 0 1 1.178 2.173q.407 1.158.407 2.418a7 7 0 0 1-.58 2.833 7.5 7.5 0 0 1-1.574 2.326 7.5 7.5 0 0 1-2.326 1.575 7 7 0 0 1-2.833.578"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9FD61":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMobility);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMobility = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M11.228 13.202c1.139-.83 2.045-1.942 2.552-3.256.583-1.497.765-3.005.822-3.854a.903.903 0 1 1 1.806.068c-.02 3.756-1.775 6.65-1.775 6.65l7.415 10.344a.997.997 0 0 1-1.588 1.207l-4.677-5.804-2.635 2.042-1.021 3.416a1.025 1.025 0 0 1-1.985-.507c.877-4.22 2.693-5.568 2.693-5.568l-1.363-1.546a16 16 0 0 0-.865 4.262.827.827 0 0 1-1.645.046q-.005-.035-.004-.077c-.133-4.943 1.383-6.775 2.27-7.423"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9.202 11.913c-.79-.676-.917-1.824-.284-2.564s1.786-.792 2.576-.117c.79.676.917 1.823.284 2.563s-1.787.793-2.576.117"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2HUyV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IncreaseStrengthStep1", ()=>IncreaseStrengthStep1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _genderUtils = require("src/utils/genderUtils");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
var _buildstrengthMaleFullBodyStrengthWebp = require("url:src/assets/images/trainer/program-generator/buildstrength-male-full-body-strength.webp");
var _buildstrengthMaleFullBodyStrengthWebpDefault = parcelHelpers.interopDefault(_buildstrengthMaleFullBodyStrengthWebp);
var _buildstrengthMaleUpperBodyStrengthWebp = require("url:src/assets/images/trainer/program-generator/buildstrength-male-upper-body-strength.webp");
var _buildstrengthMaleUpperBodyStrengthWebpDefault = parcelHelpers.interopDefault(_buildstrengthMaleUpperBodyStrengthWebp);
var _buildstrengthMaleLowerBodyStrengthWebp = require("url:src/assets/images/trainer/program-generator/buildstrength-male-lower-body-strength.webp");
var _buildstrengthMaleLowerBodyStrengthWebpDefault = parcelHelpers.interopDefault(_buildstrengthMaleLowerBodyStrengthWebp);
var _buildstrengthMaleCoreStrengthWebp = require("url:src/assets/images/trainer/program-generator/buildstrength-male-core-strength.webp");
var _buildstrengthMaleCoreStrengthWebpDefault = parcelHelpers.interopDefault(_buildstrengthMaleCoreStrengthWebp);
var _buildstrengthMaleSpecificLiftMovementWebp = require("url:src/assets/images/trainer/program-generator/buildstrength-male-specific-lift-movement.webp");
var _buildstrengthMaleSpecificLiftMovementWebpDefault = parcelHelpers.interopDefault(_buildstrengthMaleSpecificLiftMovementWebp);
var _buildstrengthFemaleFullBodyStrengthWebp = require("url:src/assets/images/trainer/program-generator/buildstrength-female-full-body-strength.webp");
var _buildstrengthFemaleFullBodyStrengthWebpDefault = parcelHelpers.interopDefault(_buildstrengthFemaleFullBodyStrengthWebp);
var _buildstrengthFemaleUpperBodyStrengthWebp = require("url:src/assets/images/trainer/program-generator/buildstrength-female-upper-body-strength.webp");
var _buildstrengthFemaleUpperBodyStrengthWebpDefault = parcelHelpers.interopDefault(_buildstrengthFemaleUpperBodyStrengthWebp);
var _buildstrengthFemaleLowerBodyStrengthWebp = require("url:src/assets/images/trainer/program-generator/buildstrength-female-lower-body-strength.webp");
var _buildstrengthFemaleLowerBodyStrengthWebpDefault = parcelHelpers.interopDefault(_buildstrengthFemaleLowerBodyStrengthWebp);
var _buildstrengthFemaleCoreStrengthWebp = require("url:src/assets/images/trainer/program-generator/buildstrength-female-core-strength.webp");
var _buildstrengthFemaleCoreStrengthWebpDefault = parcelHelpers.interopDefault(_buildstrengthFemaleCoreStrengthWebp);
var _buildstrengthFemaleSpecificLiftMovementWebp = require("url:src/assets/images/trainer/program-generator/buildstrength-female-specific-lift-movement.webp");
var _buildstrengthFemaleSpecificLiftMovementWebpDefault = parcelHelpers.interopDefault(_buildstrengthFemaleSpecificLiftMovementWebp);
const IncreaseStrengthStep1 = ({ value = [], clientBodyProfile = 'Male', onChange })=>{
    const isFemale = (0, _genderUtils.isFemaleProfile)(clientBodyProfile);
    const iconMap = {
        full_body_strength: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _buildstrengthFemaleFullBodyStrengthWebpDefault.default),
            alt: "BuildstrengthFemaleFullBodyStrengthIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _buildstrengthMaleFullBodyStrengthWebpDefault.default),
            alt: "BuildstrengthMaleFullBodyStrengthIcon",
            className: "program-svg-icon"
        }),
        upper_body_strength: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _buildstrengthFemaleUpperBodyStrengthWebpDefault.default),
            alt: "BuildstrengthFemaleUpperBodyStrengthIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _buildstrengthMaleUpperBodyStrengthWebpDefault.default),
            alt: "BuildstrengthMaleUpperBodyStrengthIcon",
            className: "program-svg-icon"
        }),
        lower_body_strength: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _buildstrengthFemaleLowerBodyStrengthWebpDefault.default),
            alt: "BuildstrengthFemaleLowerBodyStrengthIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _buildstrengthMaleLowerBodyStrengthWebpDefault.default),
            alt: "BuildstrengthMaleLowerBodyStrengthIcon",
            className: "program-svg-icon"
        }),
        core_strength: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _buildstrengthFemaleCoreStrengthWebpDefault.default),
            alt: "BuildstrengthFemaleCoreStrengthIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _buildstrengthMaleCoreStrengthWebpDefault.default),
            alt: "BuildstrengthMaleCoreStrengthIcon",
            className: "program-svg-icon"
        }),
        specific_lift_movement: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _buildstrengthFemaleSpecificLiftMovementWebpDefault.default),
            alt: "BuildstrengthFemaleSpecificLiftMovementIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _buildstrengthMaleSpecificLiftMovementWebpDefault.default),
            alt: "BuildstrengthMaleSpecificLiftMovementIcon",
            className: "program-svg-icon"
        })
    };
    const [selectedGoal, setSelectedGoal] = (0, _react.useState)(value);
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const stepData = programMasterData?.trainingGoalDetails?.groups?.find((item)=>item.goalId === 'increase_strength');
    const title = stepData?.title;
    const options = stepData?.options ? [
        ...stepData.options
    ].sort((a, b)=>(a.order || 0) - (b.order || 0)) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !stepData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-cards-grid",
                children: options.map((option)=>{
                    const icon = iconMap[option.id] || iconMap[option.image] || null;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `goal-card ${selectedGoal.includes(option.slug) ? 'selected' : ''}`,
                        onClick: ()=>{
                            let nextValue = [
                                ...selectedGoal
                            ];
                            if (nextValue.includes(option.slug)) nextValue = nextValue.filter((p)=>p !== option.slug);
                            else nextValue.push(option.slug);
                            setSelectedGoal(nextValue);
                            if (onChange) onChange(nextValue);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-image",
                                children: icon
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: option.title
                            })
                        ]
                    }, option.id);
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","src/utils/genderUtils":"aiA54","./IncreaseStrengthSteps.scss":"lcYno","url:src/assets/images/trainer/program-generator/buildstrength-male-full-body-strength.webp":"cuDJq","url:src/assets/images/trainer/program-generator/buildstrength-male-upper-body-strength.webp":"f1TD0","url:src/assets/images/trainer/program-generator/buildstrength-male-lower-body-strength.webp":"e21Bz","url:src/assets/images/trainer/program-generator/buildstrength-male-core-strength.webp":"fP6hW","url:src/assets/images/trainer/program-generator/buildstrength-male-specific-lift-movement.webp":"hJXby","url:src/assets/images/trainer/program-generator/buildstrength-female-full-body-strength.webp":"8CvDw","url:src/assets/images/trainer/program-generator/buildstrength-female-upper-body-strength.webp":"19WcI","url:src/assets/images/trainer/program-generator/buildstrength-female-lower-body-strength.webp":"hEFj7","url:src/assets/images/trainer/program-generator/buildstrength-female-core-strength.webp":"hRw3t","url:src/assets/images/trainer/program-generator/buildstrength-female-specific-lift-movement.webp":"2uOrX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"cuDJq":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("91CB3");

},{}],"f1TD0":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("Xrpf7");

},{}],"e21Bz":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dAEjr");

},{}],"fP6hW":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2TkH6");

},{}],"hJXby":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("iPdHV");

},{}],"8CvDw":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("k9gFs");

},{}],"19WcI":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4CzKl");

},{}],"hEFj7":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("caoQW");

},{}],"hRw3t":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("hOH6V");

},{}],"2uOrX":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("b5E1b");

},{}],"u22Am":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IncreaseStrengthStep2", ()=>IncreaseStrengthStep2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
var _improveControlAndStabilitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_control_and_stability.svg");
var _buildFunctionalStrengthSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/build_functional_strength.svg");
var _supportSportPerformanceSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/support_sport_performance.svg");
var _improveCompoundLiftsSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_compound_lifts.svg");
var _liftHeavierWeightsSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/lift_heavier_weights.svg");
const iconMap = {
    lift_heavier_weights: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _liftHeavierWeightsSvg.ReactComponent), {}),
    build_functional_strength: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildFunctionalStrengthSvg.ReactComponent), {}),
    improve_compound_lifts: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _improveCompoundLiftsSvg.ReactComponent), {}),
    improve_control_stability: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _improveControlAndStabilitySvg.ReactComponent), {}),
    support_sport_performance: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _supportSportPerformanceSvg.ReactComponent), {})
};
const IncreaseStrengthStep2 = ({ value, onNext })=>{
    const [selectedOutcome, setSelectedOutcome] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const stepData = programMasterData?.trainingGoalPreferences?.groups?.find((item)=>item.goalId === 'increase_strength');
    const title = stepData?.title;
    const options = stepData?.options ? [
        ...stepData.options
    ].sort((a, b)=>(a.order || 0) - (b.order || 0)) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !stepData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: options.map((option)=>{
                    const icon = iconMap[option.id] || iconMap[option.image] || null;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedOutcome === option.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedOutcome(option.slug);
                            if (onNext) onNext(option.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: icon
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: option.title
                            })
                        ]
                    }, option.id);
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_control_and_stability.svg":"5MdhJ","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/build_functional_strength.svg":"ghoso","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/support_sport_performance.svg":"76KCe","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_compound_lifts.svg":"ff1mm","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/lift_heavier_weights.svg":"6nNYk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"5MdhJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgImproveControlAndStability);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgImproveControlAndStability = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M11.228 13.202c1.139-.83 2.045-1.942 2.552-3.256.583-1.497.765-3.005.822-3.854a.903.903 0 1 1 1.806.068c-.02 3.756-1.775 6.65-1.775 6.65l7.415 10.344a.997.997 0 0 1-1.588 1.207l-4.677-5.804-2.635 2.042-1.021 3.416a1.025 1.025 0 0 1-1.985-.507c.877-4.22 2.693-5.568 2.693-5.568l-1.363-1.546a16 16 0 0 0-.865 4.262.827.827 0 0 1-1.645.046q-.005-.035-.004-.077c-.133-4.943 1.383-6.775 2.27-7.423"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9.202 11.913c-.79-.676-.917-1.824-.284-2.564s1.786-.792 2.576-.117c.79.676.917 1.823.284 2.563s-1.787.793-2.576.117"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ghoso":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBuildFunctionalStrength);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBuildFunctionalStrength = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M5.728 17.176a.2.2 0 0 0 .027-.055c.02-.061 2.066-6.122 6.983-8.46a2.4 2.4 0 0 0 .875-.858c.015-.027.231-.407.96-.51a3 3 0 0 0-.129.394q-.023.084-.043.17-.028.127-.046.259c-.007.05-.018.1-.023.152q-.023.209-.024.422 0 .6.177 1.154c-.43.056-.817.282-1.067.639-.516.736-.855 1.855-1.007 3.327 0 .029-.02 1.011-.51 1.885a7.6 7.6 0 0 0-.885 1.168.212.212 0 1 0 .36.223c1.882-3.037 4.341-2.755 5.64-2.317a2.06 2.06 0 0 0 1.649-.128c2.59-1.42 4.892.052 5.544.543 0 0 .03 4.854.236 8.06l-2.937 1.49c-.293-.148-1.264-.712-1.607-1.822a13 13 0 0 1-.192-.69c-.142-.55-.244-.946-.571-1.107-.242-.117-.544-.083-1.012.117q-.193.086-.393.155l-.843.279a4 4 0 0 1-.444.12c-2.023.4-4.212.133-5.853-.714-1.54-.794-2.399-1.147-2.848-1.304a4.1 4.1 0 0 1-1.567-.957c-.626-.616-.777-1.166-.45-1.635m1.849.153c.144.664.67 1.227 1.565 1.674a.212.212 0 1 0 .19-.379c-.772-.385-1.223-.85-1.34-1.381-.151-.68.304-1.261.308-1.267a.212.212 0 0 0-.33-.265c-.024.03-.585.739-.393 1.618"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M21.217 10.376q-.018.033-.034.068-.1.165-.217.316c-.028.037-.05.078-.08.114-.062.077-.132.145-.2.215-.051.053-.098.111-.153.16-.05.046-.105.083-.157.126-.08.065-.158.133-.243.19-.033.023-.07.039-.104.06-.11.068-.22.136-.337.192q-.032.014-.065.026-.199.091-.408.159c-.032.01-.067.014-.1.022q-.195.058-.4.091a3.5 3.5 0 0 1-1.047 0 3 3 0 0 1-.4-.09c-.033-.01-.068-.013-.1-.023a4 4 0 0 1-.413-.16c-.02-.01-.04-.015-.06-.025a4 4 0 0 1-.352-.2c-.029-.018-.06-.032-.088-.05-.091-.062-.175-.134-.26-.204-.046-.038-.096-.071-.14-.112-.06-.054-.111-.117-.167-.175-.062-.066-.129-.129-.186-.2-.033-.04-.059-.086-.09-.128-.072-.098-.145-.196-.207-.303-.014-.023-.024-.05-.037-.073a3.4 3.4 0 0 1-.42-2.058q.01-.069.022-.137.015-.115.04-.229.017-.077.039-.153a4 4 0 0 1 .116-.352q.04-.106.09-.21.028-.063.06-.124.096-.188.213-.36.031-.045.066-.09a4 4 0 0 1 .308-.367q.086-.088.178-.168.111-.1.23-.19.089-.068.184-.132a4 4 0 0 1 .376-.211q.078-.041.16-.078.177-.075.363-.13.065-.019.132-.035.15-.038.301-.063l.132-.02q.213-.029.433-.03.22.002.434.03.066.008.131.02.153.025.301.063.068.016.133.035.186.054.362.13.082.037.161.078a3.4 3.4 0 0 1 .791.534 4 4 0 0 1 .299.302q.096.11.184.23c.023.032.047.06.069.093a3.6 3.6 0 0 1 .416.84q.035.1.06.202.024.078.041.157.023.112.04.226.012.07.021.14.02.186.022.375a3.4 3.4 0 0 1-.443 1.686M18.572 6.97l-.038-.008a2 2 0 0 0-.334-.034q-.17.001-.333.034l-.039.008a1.765 1.765 0 0 0-1.393 1.72c0 .73.445 1.36 1.079 1.629l.008.003q.144.06.3.093l.043.01q.163.033.335.034.173-.001.335-.034l.044-.01q.155-.034.3-.093l.007-.003a1.77 1.77 0 0 0 1.08-1.63c0-.842-.598-1.546-1.394-1.72"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"76KCe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSupportSportPerformance);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSupportSportPerformance = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "#E5E5E5",
                    clipPath: "url(#b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M16.976 14.277 15.788 7.73c-.179-1.37 1.437-1.728 2.157-.921l3.282 3.284a.8.8 0 0 0-.25.18zm-5.758 5.761a.75.75 0 0 1-.517.212H8.456a22.5 22.5 0 0 0 2.68-5.344c.294.299 1.018 1.01 1.319 1.318a.305.305 0 0 0 .431-.431l-1.537-1.534q.292-.928.498-1.884l2.23 2.227a.302.302 0 0 0 .428-.429c-.372-.371-2.182-2.183-2.512-2.515.112-.602.2-1.213.264-1.823a1.265 1.265 0 0 1 2.14-.754l.91.912a.6.6 0 0 0 .304.16c.033.204.78 4.297.842 4.646z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M8.375 20.858h2.328c.354-.001.694-.142.945-.392L17.11 15l4.08-4.084c.205-.221.428-.468.696-.164l.963.963a.78.78 0 0 1 0 1.103l-9.926 9.933a2.1 2.1 0 0 1-1.504.623H8.852a1.26 1.26 0 0 1-1.257-1.258v-.477a.78.78 0 0 1 .78-.781m5.39 1.909h8.93a.303.303 0 0 1 .216.519.3.3 0 0 1-.216.088h-9.558c.138-.104.503-.483.628-.607m8.929-1.303H16.55a.303.303 0 0 1 0-.608h6.144a.304.304 0 0 1 0 .608m-3.818-2.517h3.818a.304.304 0 0 1 0 .608h-3.818a.304.304 0 0 1 0-.608"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M25.125 5.25h-19.5v19.5h19.5z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M24.963 5.25H5.707v19.256h19.256z"
                        })
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ff1mm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgImproveCompoundLifts);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgImproveCompoundLifts = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M8.73 8.488a2.14 2.14 0 0 1 1.114-.285c.505 0 .874.14 1.114.285.37.22.48.6.486.87.01.538.04 2.313.04 5.642s-.03 5.104-.04 5.642c-.006.27-.117.65-.487.87-.239.144-.608.285-1.113.285-.506 0-.874-.14-1.114-.285-.37-.22-.48-.6-.486-.87-.01-.537-.04-2.312-.04-5.642s.03-5.104.04-5.642c.006-.27.116-.65.486-.87m12.54 0a2.14 2.14 0 0 0-1.114-.285c-.505 0-.874.14-1.113.285-.37.22-.481.6-.487.87-.01.537-.04 2.313-.04 5.642s.03 5.104.04 5.642c.006.27.117.65.486.87.24.144.609.285 1.114.285s.875-.14 1.114-.285c.37-.22.48-.6.486-.87.01-.538.04-2.312.04-5.642s-.03-5.104-.04-5.642c-.006-.27-.117-.65-.486-.87M5.86 10.547c-.31 0-.558.056-.748.13-.476.184-.623.635-.63.937-.01.42-.029 1.499-.029 3.386s.019 2.965.028 3.386c.007.302.155.753.631.937.19.074.438.13.747.13.31 0 .558-.056.748-.13.476-.184.623-.635.63-.937.01-.42.029-1.499.029-3.386s-.02-2.965-.029-3.386c-.007-.302-.154-.753-.63-.937a2.1 2.1 0 0 0-.748-.13m19.028.13a2.1 2.1 0 0 0-.747-.13c-.31 0-.558.056-.748.13-.475.184-.623.635-.63.937-.01.42-.029 1.499-.029 3.386s.02 2.965.028 3.386c.008.302.155.753.631.937.19.074.439.13.748.13s.557-.056.747-.13c.476-.184.623-.635.63-.937.01-.42.029-1.499.029-3.386s-.019-2.965-.028-3.386c-.007-.302-.155-.753-.631-.937m-12.466 5.662v-2.678c0-.445.364-.678.751-.711q.12-.012.359-.025c.319-.018.8-.034 1.468-.034s1.15.017 1.468.034q.24.014.359.025c.387.033.751.266.751.71v2.68c0 .444-.364.677-.751.71q-.12.012-.359.025c-.319.018-.8.034-1.468.034s-1.15-.017-1.468-.034q-.24-.014-.359-.025c-.387-.033-.751-.266-.751-.71",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6nNYk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLiftHeavierWeights);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLiftHeavierWeights = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M15 6.563a3.75 3.75 0 0 1 3.75 3.75c0 .684-.178 1.321-.506 1.874h2.381c.89 0 1.64.629 1.828 1.463 1.884 7.51 1.922 7.706 1.922 7.913a1.875 1.875 0 0 1-1.875 1.875h-15a1.875 1.875 0 0 1-1.875-1.875c0-.207.037-.404 1.922-7.913a1.88 1.88 0 0 1 1.828-1.463h2.381a3.66 3.66 0 0 1-.506-1.874A3.75 3.75 0 0 1 15 6.563m0 1.875a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75m-5.625 5.624v7.5h1.875V19.22l.938.937v1.407h1.874v-1.875l-1.874-1.875 1.874-1.875v-1.876h-1.874v1.407l-.938.937v-2.343zm8.438 0a1.87 1.87 0 0 0-1.875 1.876v3.75c0 1.04.834 1.875 1.874 1.875h2.813v-4.688H18.75v2.813h-.937v-3.75h2.812v-1.876z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e1vnG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IncreaseStrengthStep3", ()=>IncreaseStrengthStep3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
var _compoundStrengthTrainingSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/compound_strength_training.svg");
var _strengthMuscleBuildingSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength_muscle_building.svg");
var _powerliftingFocusedSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/powerlifting_focused.svg");
var _functionalStrengthSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/functional_strength.svg");
const iconMap = {
    compound_strength_training: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _compoundStrengthTrainingSvg.ReactComponent), {}),
    powerlifting_focused: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _powerliftingFocusedSvg.ReactComponent), {}),
    functional_strength: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _functionalStrengthSvg.ReactComponent), {}),
    strength_muscle_building: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _strengthMuscleBuildingSvg.ReactComponent), {})
};
const IncreaseStrengthStep3 = ({ value, onNext })=>{
    const [selectedApproach, setSelectedApproach] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const stepData = programMasterData?.trainingGoalApproaches?.groups?.find((item)=>item.goalId === 'increase_strength');
    const title = stepData?.title;
    const subtitle = stepData?.subtitle;
    const options = stepData?.options ? [
        ...stepData.options
    ].sort((a, b)=>(a.order || 0) - (b.order || 0)) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !stepData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: title
            }),
            subtitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: options.map((option)=>{
                    const icon = iconMap[option.id] || iconMap[option.image] || null;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedApproach === option.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedApproach(option.slug);
                            if (onNext) onNext(option.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: icon
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: option.title
                            })
                        ]
                    }, option.id);
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/compound_strength_training.svg":"huXPv","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength_muscle_building.svg":"kK2or","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/powerlifting_focused.svg":"a6g3R","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/functional_strength.svg":"6FY8T","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"huXPv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCompoundStrengthTraining);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCompoundStrengthTraining = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M20.225 9.573c-.2-.12-.507-.237-.928-.237s-.729.117-.928.237c-.308.184-.4.5-.405.725-.01.448-.034 1.927-.034 4.702s.025 4.253.034 4.702c.004.225.097.54.405.725.2.12.507.237.928.237s.728-.117.928-.237c.308-.184.4-.5.405-.725.01-.448.034-1.927.034-4.702s-.025-4.254-.034-4.702a.85.85 0 0 0-.405-.725m-10.45 0c.2-.12.507-.237.928-.237s.729.117.928.237c.308.184.4.5.405.725.01.448.034 1.927.034 4.702s-.025 4.253-.034 4.702a.85.85 0 0 1-.405.725c-.2.12-.507.237-.928.237s-.728-.117-.928-.237a.85.85 0 0 1-.405-.725c-.01-.449-.034-1.927-.034-4.702s.025-4.254.034-4.702a.86.86 0 0 1 .405-.725m12.842 1.716c.258 0 .465.047.623.108.397.154.52.53.525.781.008.35.024 1.25.024 2.822s-.016 2.471-.023 2.822c-.006.251-.13.627-.526.78a1.7 1.7 0 0 1-.623.109c-.258 0-.464-.047-.623-.108-.396-.154-.519-.53-.525-.782A131 131 0 0 1 21.445 15c0-1.573.016-2.471.024-2.822.006-.251.129-.627.525-.78q.302-.113.623-.109m-15.857.108q.302-.111.623-.108c.258 0 .464.047.622.108.397.154.52.53.526.781.008.35.024 1.25.024 2.822s-.016 2.471-.024 2.822c-.006.251-.129.627-.526.78a1.7 1.7 0 0 1-.622.109c-.258 0-.465-.047-.623-.108-.396-.154-.52-.53-.525-.782A131 131 0 0 1 6.21 15c0-1.573.016-2.471.023-2.822.006-.251.13-.627.526-.78m10.388 4.719v-2.232c0-.37-.303-.565-.626-.593a9 9 0 0 0-.299-.02 22 22 0 0 0-1.222-.03c-.557 0-.958.014-1.223.03a9 9 0 0 0-.3.02c-.322.027-.625.222-.625.592v2.232c0 .37.303.565.626.593q.1.01.299.02c.265.015.666.029 1.223.029s.958-.014 1.223-.03q.2-.01.3-.02c.322-.027.625-.222.625-.592",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kK2or":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgStrengthMuscleBuilding);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgStrengthMuscleBuilding = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M5.728 17.176a.2.2 0 0 0 .027-.055c.02-.061 2.066-6.122 6.983-8.46a2.4 2.4 0 0 0 .875-.858c.015-.027.231-.407.96-.51a3 3 0 0 0-.129.394q-.023.084-.043.17-.028.127-.046.259c-.007.05-.018.1-.023.152q-.023.209-.024.422 0 .6.177 1.154c-.43.056-.817.282-1.067.639-.516.736-.855 1.855-1.007 3.327 0 .029-.02 1.011-.51 1.885a7.6 7.6 0 0 0-.885 1.168.212.212 0 1 0 .36.223c1.882-3.037 4.341-2.755 5.64-2.317a2.06 2.06 0 0 0 1.649-.128c2.59-1.42 4.892.052 5.544.543 0 0 .03 4.854.236 8.06l-2.937 1.49c-.293-.148-1.264-.712-1.607-1.822a13 13 0 0 1-.192-.69c-.142-.55-.244-.946-.571-1.107-.242-.117-.544-.083-1.012.117q-.193.086-.393.155l-.843.279a4 4 0 0 1-.444.12c-2.023.4-4.212.133-5.853-.714-1.54-.794-2.399-1.147-2.848-1.304a4.1 4.1 0 0 1-1.567-.957c-.626-.616-.777-1.166-.45-1.635m1.849.153c.144.664.67 1.227 1.565 1.674a.212.212 0 1 0 .19-.379c-.772-.385-1.223-.85-1.34-1.381-.151-.68.304-1.261.308-1.267a.212.212 0 0 0-.33-.265c-.024.03-.585.739-.393 1.618"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M21.217 10.376q-.018.033-.034.068-.1.165-.217.316c-.028.037-.05.078-.08.114-.062.077-.132.145-.2.215-.051.053-.098.111-.153.16-.05.046-.105.083-.157.126-.08.065-.158.133-.243.19-.033.023-.07.039-.104.06-.11.068-.22.136-.337.192q-.032.014-.065.026-.199.091-.408.159c-.032.01-.067.014-.1.022q-.195.058-.4.091a3.5 3.5 0 0 1-1.047 0 3 3 0 0 1-.4-.09c-.033-.01-.068-.013-.1-.023a4 4 0 0 1-.413-.16c-.02-.01-.04-.015-.06-.025a4 4 0 0 1-.352-.2c-.029-.018-.06-.032-.088-.05-.091-.062-.175-.134-.26-.204-.046-.038-.096-.071-.14-.112-.06-.054-.111-.117-.167-.175-.062-.066-.129-.129-.186-.2-.033-.04-.059-.086-.09-.128-.072-.098-.145-.196-.207-.303-.014-.023-.024-.05-.037-.073a3.4 3.4 0 0 1-.42-2.058q.01-.069.022-.137.015-.115.04-.229.017-.077.039-.153a4 4 0 0 1 .116-.352q.04-.106.09-.21.028-.063.06-.124.096-.188.213-.36.031-.045.066-.09a4 4 0 0 1 .308-.367q.086-.088.178-.168.111-.1.23-.19.089-.068.184-.132a4 4 0 0 1 .376-.211q.078-.041.16-.078.177-.075.363-.13.065-.019.132-.035.15-.038.301-.063l.132-.02q.213-.029.433-.03.22.002.434.03.066.008.131.02.153.025.301.063.068.016.133.035.186.054.362.13.082.037.161.078a3.4 3.4 0 0 1 .791.534 4 4 0 0 1 .299.302q.096.11.184.23c.023.032.047.06.069.093a3.6 3.6 0 0 1 .416.84q.035.1.06.202.024.078.041.157.023.112.04.226.012.07.021.14.02.186.022.375a3.4 3.4 0 0 1-.443 1.686M18.572 6.97l-.038-.008a2 2 0 0 0-.334-.034q-.17.001-.333.034l-.039.008a1.765 1.765 0 0 0-1.393 1.72c0 .73.445 1.36 1.079 1.629l.008.003q.144.06.3.093l.043.01q.163.033.335.034.173-.001.335-.034l.044-.01q.155-.034.3-.093l.007-.003a1.77 1.77 0 0 0 1.08-1.63c0-.842-.598-1.546-1.394-1.72"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a6g3R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPowerliftingFocused);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPowerliftingFocused = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M15 6.563a3.75 3.75 0 0 1 3.75 3.75c0 .684-.178 1.321-.506 1.874h2.381c.89 0 1.64.629 1.828 1.463 1.884 7.51 1.922 7.706 1.922 7.913a1.875 1.875 0 0 1-1.875 1.875h-15a1.875 1.875 0 0 1-1.875-1.875c0-.207.037-.404 1.922-7.913a1.88 1.88 0 0 1 1.828-1.463h2.381a3.66 3.66 0 0 1-.506-1.874A3.75 3.75 0 0 1 15 6.563m0 1.875a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75m-5.625 5.624v7.5h1.875V19.22l.938.937v1.407h1.874v-1.875l-1.874-1.875 1.874-1.875v-1.876h-1.874v1.407l-.938.937v-2.343zm8.438 0a1.87 1.87 0 0 0-1.875 1.876v3.75c0 1.04.834 1.875 1.874 1.875h2.813v-4.688H18.75v2.813h-.937v-3.75h2.812v-1.876z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6FY8T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFunctionalStrength);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFunctionalStrength = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M11.228 13.202c1.139-.83 2.045-1.942 2.552-3.256.583-1.497.765-3.005.822-3.854a.903.903 0 1 1 1.806.068c-.02 3.756-1.775 6.65-1.775 6.65l7.415 10.344a.997.997 0 0 1-1.588 1.207l-4.677-5.804-2.635 2.042-1.021 3.416a1.025 1.025 0 0 1-1.985-.507c.877-4.22 2.693-5.568 2.693-5.568l-1.363-1.546a16 16 0 0 0-.865 4.262.827.827 0 0 1-1.645.046q-.005-.035-.004-.077c-.133-4.943 1.383-6.775 2.27-7.423"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9.202 11.913c-.79-.676-.917-1.824-.284-2.564s1.786-.792 2.576-.117c.79.676.917 1.823.284 2.563s-1.787.793-2.576.117"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jkLcG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnduranceStep1", ()=>EnduranceStep1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _generalStaminaSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_stamina.svg");
var _cardiovascularSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cardiovascular.svg");
var _sportSpecificSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/sport_specific.svg");
var _muscularSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/muscular.svg");
var _runningSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/running.svg");
var _cyclingSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cycling.svg");
const iconMap = {
    cardiovascular: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardiovascularSvg.ReactComponent), {}),
    muscular: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _muscularSvg.ReactComponent), {}),
    running: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _runningSvg.ReactComponent), {}),
    cycling: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cyclingSvg.ReactComponent), {}),
    sport_specific: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sportSpecificSvg.ReactComponent), {}),
    general_stamina: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalStaminaSvg.ReactComponent), {})
};
const EnduranceStep1 = ({ value, onNext })=>{
    const [selectedType, setSelectedType] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalDetails?.groups?.find((g)=>g.goalId === 'endurance');
    const types = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: types.map((type)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedType === type.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedType(type.slug);
                            if (onNext) onNext(type.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[type.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: type.title
                            })
                        ]
                    }, type.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_stamina.svg":"gNbzf","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cardiovascular.svg":"aKAoR","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/sport_specific.svg":"g6DJp","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/muscular.svg":"7ZpPL","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/running.svg":"hPuSN","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cycling.svg":"hOaz9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"gNbzf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGeneralStamina);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGeneralStamina = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M20.785 14.323a.68.68 0 0 1-.654-.484l-1.088-3.63a1.356 1.356 0 0 0-2.594-.01l-2.765 9.203-1.733-3.88a2.03 2.03 0 0 0-1.857-1.2H7.25V8.907c0-1.12.911-2.031 2.031-2.031H21.47c1.12 0 2.031.911 2.031 2.031v5.417z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M10.094 15.677c.27 0 .513.156.62.397l1.734 3.88a1.34 1.34 0 0 0 1.234.801c.595 0 1.115-.383 1.296-.953l2.765-9.204 1.093 3.636a2.03 2.03 0 0 0 1.949 1.443H23.5v5.417c0 1.12-.911 2.031-2.031 2.031H9.28a2.034 2.034 0 0 1-2.031-2.031v-5.417z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aKAoR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCardiovascular);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCardiovascular = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M15.643 9.362c1.706-2.118 4.755-2.245 6.613-.277 1.303 1.38 1.641 3.393 1.016 5.102H19.94l-2.128-4.254-2.438 4.874-1.218-2.436-.909 1.816h-5.77c-.625-1.709-.287-3.722 1.016-5.102 1.858-1.968 4.907-1.84 6.613.277l.268.333zm-7.172 6.45h5.589l1.314 2.63 2.438-4.875 1.123 2.246h3.343l-.022.022-6.878 7.286-.003.004-6.882-7.29z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g6DJp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSportSpecific);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSportSpecific = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M9.368 18.046a.39.39 0 0 0-.389-.352H7.144a.387.387 0 0 0-.388.352L6.32 22.2a1.77 1.77 0 0 0 .448 1.35 1.75 1.75 0 0 0 1.294.576 1.74 1.74 0 0 0 1.294-.576 1.76 1.76 0 0 0 .447-1.35zM22.242 22.2l-.435-4.153a.39.39 0 0 0-.389-.352h-1.835a.387.387 0 0 0-.388.352l-.436 4.153a1.77 1.77 0 0 0 .448 1.35 1.75 1.75 0 0 0 1.294.576 1.74 1.74 0 0 0 1.294-.576 1.76 1.76 0 0 0 .447-1.35M17.267 7.213a3.9 3.9 0 0 1 1.784 1.438c.438.649.673 1.415.672 2.2v3.519a.39.39 0 0 1-.388.391.4.4 0 0 0-.304.14.42.42 0 0 0-.077.33l.194.977a.39.39 0 0 0 .381.313h1.866a.39.39 0 0 0 .373-.282c.039-.14.117-.399.28-1.009a.42.42 0 0 0-.078-.328.4.4 0 0 0-.303-.141.387.387 0 0 1-.389-.391v-3.52a5.5 5.5 0 0 0-1.594-3.871 5.43 5.43 0 0 0-5.208-1.432.8.8 0 0 1-.39 0A5.43 5.43 0 0 0 8.878 6.98a5.5 5.5 0 0 0-1.593 3.871v3.52a.39.39 0 0 1-.388.391.4.4 0 0 0-.304.14.42.42 0 0 0-.077.33c.163.61.24.868.28 1.008a.39.39 0 0 0 .373.282h1.866a.39.39 0 0 0 .38-.313l.203-.978a.42.42 0 0 0-.078-.328.41.41 0 0 0-.311-.141.387.387 0 0 1-.389-.391v-3.52c0-.784.234-1.55.672-2.199a3.9 3.9 0 0 1 1.785-1.438.186.186 0 0 1 .225.063.19.19 0 0 1 0 .234 5.5 5.5 0 0 0-1.127 3.34c0 1.037.41 2.032 1.139 2.766a3.88 3.88 0 0 0 2.748 1.145c1.031 0 2.02-.412 2.749-1.145a3.92 3.92 0 0 0 1.138-2.766 5.5 5.5 0 0 0-1.127-3.34.19.19 0 0 1 0-.234.186.186 0 0 1 .226-.063m-2.986 5.984a2.33 2.33 0 0 1-1.649-.688 2.35 2.35 0 0 1-.683-1.659c0-.686.18-1.36.52-1.955a3.9 3.9 0 0 1 1.424-1.432.77.77 0 0 1 .777 0 3.9 3.9 0 0 1 1.423 1.432 3.93 3.93 0 0 1 .52 1.955c0 .623-.245 1.22-.683 1.66-.437.44-1.03.687-1.649.687"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7ZpPL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMuscular);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMuscular = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M26.133 17.51a.2.2 0 0 1-.032-.063c-.023-.07-2.383-7.063-8.058-9.76a2.8 2.8 0 0 1-1.01-.99c-.016-.032-.266-.47-1.107-.59a4 4 0 0 1 .149.455q.028.097.05.196.031.148.052.3c.01.058.022.116.027.175q.027.24.028.487-.002.692-.204 1.331c.496.065.943.326 1.23.737.596.85.987 2.141 1.163 3.84.001.033.024 1.166.588 2.175.35.378.694.818 1.021 1.348a.244.244 0 1 1-.416.257c-2.17-3.505-5.008-3.18-6.507-2.674a2.38 2.38 0 0 1-1.902-.148c-2.988-1.639-5.645.06-6.397.627 0 0-.035 5.6-.273 9.3l3.389 1.72c.339-.172 1.458-.823 1.855-2.103.092-.294.16-.561.221-.797.164-.633.281-1.09.66-1.276.278-.136.627-.096 1.166.135.15.064.3.127.454.178l.972.322c.192.064.355.108.513.139 2.335.462 4.86.153 6.753-.825 1.778-.915 2.769-1.323 3.287-1.504a4.75 4.75 0 0 0 1.808-1.104c.722-.712.896-1.345.52-1.887m-2.134.178c-.167.766-.774 1.416-1.806 1.932a.243.243 0 0 1-.328-.11.244.244 0 0 1 .11-.327c.89-.446 1.41-.982 1.546-1.595.173-.783-.352-1.455-.357-1.462a.244.244 0 0 1 .381-.306c.027.035.675.853.454 1.868"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M8.26 9.665c.015.025.025.053.04.078.074.129.162.247.25.365.032.043.059.09.092.132.072.088.153.167.23.248.06.061.114.128.177.185.057.053.121.096.182.145.092.075.182.153.28.22.038.025.08.044.12.068.126.079.253.158.388.222l.076.03c.153.069.309.133.47.183.037.011.077.016.115.026.152.042.305.081.463.105a4 4 0 0 0 1.207 0c.158-.024.31-.063.462-.105.038-.01.078-.014.116-.026.163-.05.321-.115.476-.186.023-.01.047-.016.07-.027.14-.067.274-.148.405-.23.034-.022.07-.038.102-.06.105-.07.201-.154.3-.234.053-.044.11-.082.162-.13.069-.062.128-.134.192-.201.072-.077.149-.149.215-.232.037-.046.068-.098.103-.146.083-.114.168-.226.24-.35l.042-.084a3.9 3.9 0 0 0 .484-2.374q-.01-.08-.024-.16a4 4 0 0 0-.046-.263q-.02-.09-.046-.177a4 4 0 0 0-.133-.407 4 4 0 0 0-.104-.241q-.034-.072-.07-.143a4 4 0 0 0-.245-.416l-.077-.103a4 4 0 0 0-.355-.424 4 4 0 0 0-.471-.414q-.105-.08-.212-.151a4 4 0 0 0-.434-.245q-.091-.047-.185-.089a4 4 0 0 0-.418-.15q-.076-.022-.153-.04a4 4 0 0 0-.347-.073q-.075-.014-.152-.024a4 4 0 0 0-.5-.035c-.17 0-.336.015-.5.035q-.077.01-.152.024-.176.029-.348.073-.077.018-.152.04a4 4 0 0 0-.419.15c-.063.027-.124.06-.186.09a4 4 0 0 0-.912.616q-.105.092-.203.193a4 4 0 0 0-.354.422l-.08.106a4.2 4.2 0 0 0-.48.97 4 4 0 0 0-.07.232q-.025.09-.047.182a4 4 0 0 0-.045.26q-.014.08-.025.161a3.9 3.9 0 0 0 .487 2.378m3.052-3.93.044-.008q.187-.038.385-.04.197.002.384.04l.045.009a2.04 2.04 0 0 1 1.608 1.984c0 .843-.514 1.569-1.245 1.88l-.009.004q-.166.068-.347.108-.024.006-.05.01a2 2 0 0 1-.386.04q-.199-.001-.387-.04l-.05-.01a2 2 0 0 1-.347-.108L10.95 9.6a2.05 2.05 0 0 1-1.245-1.88c0-.972.69-1.785 1.608-1.984"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hPuSN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgRunning);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRunning = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M10.768 13.517h1.697l1.185-1.185-.002-.005a1.745 1.745 0 1 1 1.703-.653h2.169a.87.87 0 0 1 .615.255l1.72 1.72a.87.87 0 1 1-1.231 1.23l-1.465-1.465h-1.255l1.237 4.807 1.607-.6a.87.87 0 0 1 .608 1.63l-2.523.942a.87.87 0 0 1-1.149-.608l-.373-1.517-3.416 3.416a.87.87 0 0 1-1.23-1.23l4.114-4.114-.466-2.01-.872.872a.87.87 0 0 1-.616.255h-2.057a.87.87 0 1 1 0-1.74M8.87 16.15a.567.567 0 0 1-.802 0 2.43 2.43 0 0 1 0-3.433.567.567 0 0 1 .801.801 1.296 1.296 0 0 0 0 1.831.567.567 0 0 1 0 .802"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M6.693 17.012a3.62 3.62 0 0 1-1.068-2.578c0-.974.379-1.89 1.068-2.578a.567.567 0 0 1 .801.801 2.5 2.5 0 0 0-.736 1.777 2.5 2.5 0 0 0 .736 1.777.567.567 0 1 1-.801.801m14.439-4.295a.567.567 0 0 1 .801 0 2.4 2.4 0 0 1 .712 1.717c0 .648-.253 1.258-.712 1.717a.567.567 0 0 1-.801-.802c.244-.244.379-.57.379-.915s-.135-.671-.38-.916a.567.567 0 0 1 0-.801"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M23.307 11.856a3.62 3.62 0 0 1 1.068 2.578c0 .974-.38 1.89-1.068 2.578a.567.567 0 1 1-.801-.802 2.5 2.5 0 0 0 .735-1.776c0-.671-.26-1.302-.735-1.777a.567.567 0 1 1 .801-.802"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M24.375 5.625H5.625v18.75h18.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hOaz9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCycling);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCycling = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M18.957 14.188h2.105a.813.813 0 0 0 0-1.626h-2.105l-2.437-2.437a1.63 1.63 0 0 0-2.3 0l-2.104 2.104a1.63 1.63 0 0 0 0 2.3l2.437 2.437v2.917a.812.812 0 1 0 1.625 0v-2.917c0-.43-.17-.845-.479-1.145l-1.625-1.625 2.104-2.105 1.625 1.625c.31.309.715.48 1.146.48zm-.333-7.313a1.625 1.625 0 1 0 0 3.25 1.625 1.625 0 0 0 0-3.25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M20.25 15.813a3.25 3.25 0 1 0 0 6.5 3.25 3.25 0 1 0 0-6.5m0 4.874a1.63 1.63 0 0 1-1.625-1.625 1.63 1.63 0 0 1 1.625-1.625 1.63 1.63 0 0 1 1.625 1.625 1.63 1.63 0 0 1-1.625 1.625m-6.5-1.625a3.25 3.25 0 1 0-6.5 0 3.25 3.25 0 1 0 6.5 0m-4.875 0a1.63 1.63 0 0 1 1.625-1.625 1.63 1.63 0 0 1 1.625 1.625 1.63 1.63 0 0 1-1.625 1.625 1.63 1.63 0 0 1-1.625-1.625"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gyNnW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "EnduranceStep2", ()=>EnduranceStep2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _lowImpactConditioningSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_impact_conditioning.svg");
var _cardioStrengthMixSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cardio_strength_mix.svg");
var _steadyStateCardioSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/steady_state_cardio.svg");
var _hiitCircuitsSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/hiit_circuits.svg");
const iconMap = {
    steady_state_cardio: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _steadyStateCardioSvg.ReactComponent), {}),
    hiit_circuits: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiitCircuitsSvg.ReactComponent), {}),
    low_impact_conditioning: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lowImpactConditioningSvg.ReactComponent), {}),
    cardio_strength_mix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardioStrengthMixSvg.ReactComponent), {})
};
const EnduranceStep2 = ({ value, onNext })=>{
    const [selectedApproach, setSelectedApproach] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalApproaches?.groups?.find((g)=>g.goalId === 'endurance');
    const approaches = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: groupData?.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: approaches.map((approach)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedApproach(approach.slug);
                            if (onNext) onNext(approach.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[approach.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: approach.title
                            })
                        ]
                    }, approach.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_impact_conditioning.svg":"4lmGZ","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cardio_strength_mix.svg":"gjsSC","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/steady_state_cardio.svg":"RobAL","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/hiit_circuits.svg":"6u5EV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"4lmGZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLowImpactConditioning);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLowImpactConditioning = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                        id: "b",
                        width: 19,
                        height: 15,
                        x: 4,
                        y: 7,
                        maskUnits: "userSpaceOnUse",
                        style: {
                            maskType: "luminance"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "#fff",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: 1.875,
                                d: "M19.969 20.75a7.016 7.016 0 0 0 0-9.937 7.016 7.016 0 0 0-9.938 0 7.016 7.016 0 0 0 0 9.937"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "#000",
                                d: "M13.348 19.321a3.906 3.906 0 0 0 3.302-7.08c-1.955-.912-12.272-1.413-12.272-1.413s7.015 7.581 8.97 8.493"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "#fff",
                                d: "M14.009 17.905a2.344 2.344 0 0 0 1.98-4.249c-1.172-.547-8.778-1.507-8.778-1.507s5.625 5.209 6.798 5.756"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        mask: "url(#b)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#E5E5E5",
                            d: "M5.625 5.625h18.75v18.75H5.625z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M24.375 5.625H5.625v18.75h18.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gjsSC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCardioStrengthMix);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCardioStrengthMix = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M15.258 9.579c1.641-2.037 4.573-2.16 6.36-.266 1.252 1.326 1.577 3.262.976 4.906H19.39l-2.046-4.09L15 14.814l-1.171-2.343-.874 1.747H7.407c-.601-1.644-.276-3.58.976-4.906 1.788-1.893 4.719-1.77 6.36.266l.258.32zM8.363 15.78h5.373l1.265 2.528 2.343-4.687 1.08 2.16h3.214l-.02.021-6.614 7.006-.003.003-6.618-7.009z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"RobAL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSteadyStateCardio);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSteadyStateCardio = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M15.258 9.579c1.641-2.037 4.573-2.16 6.36-.266 1.252 1.326 1.577 3.262.976 4.906H19.39l-2.046-4.09L15 14.814l-1.171-2.343-.874 1.747H7.407c-.601-1.644-.276-3.58.976-4.906 1.788-1.893 4.719-1.77 6.36.266l.258.32zM8.363 15.78h5.373l1.265 2.528 2.343-4.687 1.08 2.16h3.214l-.02.021-6.614 7.006-.003.003-6.618-7.009z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6u5EV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgHiitCircuits);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgHiitCircuits = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M20.548 6.131a.9.9 0 0 0-.26-.37.58.58 0 0 0-.366-.136h-5.056c-.274 0-.692.178-.804.515L9.437 16.485c-.099.29-.078.628.05.9.126.271.35.43.59.43h3.516v5.623c0 .248.074.487.206.663.132.175.31.274.497.274.218 0 .436-.14.57-.384l5.626-10.307a1.2 1.2 0 0 0 .056-.975.9.9 0 0 0-.257-.377.57.57 0 0 0-.369-.138H17.77l2.722-5.08a1.2 1.2 0 0 0 .056-.975z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6PNNv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PerformanceStep1", ()=>PerformanceStep1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _generalAthleticPerformanceSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_athletic_performance.svg");
var _crossfitStyleTrainingSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/crossfit_style_training.svg");
var _powerLiftingSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/power_lifting.svg");
var _combatSportsSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/combat_sports.svg");
var _footballSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/football.svg");
var _performanceRunningSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/performance-running.svg");
var _tennisSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/tennis.svg");
var _cyclingSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cycling.svg");
const iconMap = {
    running: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _performanceRunningSvg.ReactComponent), {}),
    cycling: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cyclingSvg.ReactComponent), {}),
    swimming: null,
    powerlifting: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _powerLiftingSvg.ReactComponent), {}),
    football: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _footballSvg.ReactComponent), {}),
    tennis: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tennisSvg.ReactComponent), {}),
    combat_sports: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _combatSportsSvg.ReactComponent), {}),
    general_athletic_performance: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalAthleticPerformanceSvg.ReactComponent), {}),
    crossfit_style_training: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _crossfitStyleTrainingSvg.ReactComponent), {})
};
const PerformanceStep1 = ({ value, onNext })=>{
    const [selectedSupport, setSelectedSupport] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalDetails?.groups?.find((g)=>g.goalId === 'performance');
    const supports = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: supports.map((support)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedSupport === support.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedSupport(support.slug);
                            if (onNext) onNext(support.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[support.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: support.title
                            })
                        ]
                    }, support.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_athletic_performance.svg":"1tOSw","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/crossfit_style_training.svg":"8AjiR","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/power_lifting.svg":"eON9Y","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/combat_sports.svg":"b5yek","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/football.svg":"9A6RY","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/performance-running.svg":"fUd2D","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/tennis.svg":"hWfog","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cycling.svg":"hOaz9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"1tOSw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGeneralAthleticPerformance);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGeneralAthleticPerformance = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "#E5E5E5",
                    clipPath: "url(#b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "m16.976 14.275-1.188-6.547c-.179-1.37 1.437-1.728 2.157-.921l3.282 3.284a.8.8 0 0 0-.25.18zm-5.758 5.763a.75.75 0 0 1-.517.212H8.456a22.5 22.5 0 0 0 2.68-5.344c.294.299 1.018 1.01 1.319 1.318a.305.305 0 0 0 .431-.431l-1.537-1.534q.292-.928.498-1.884l2.23 2.227a.302.302 0 0 0 .428-.429c-.372-.371-2.182-2.183-2.512-2.515.112-.602.2-1.213.264-1.823a1.265 1.265 0 0 1 2.14-.754l.91.912a.6.6 0 0 0 .304.16c.033.204.78 4.297.842 4.646z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M8.375 20.857h2.328c.354-.001.694-.142.945-.392L17.11 15l4.08-4.084c.205-.221.428-.468.696-.164l.963.963a.78.78 0 0 1 0 1.103l-9.926 9.933a2.1 2.1 0 0 1-1.504.623H8.852a1.26 1.26 0 0 1-1.257-1.258v-.477a.78.78 0 0 1 .78-.781m5.39 1.908h8.93a.305.305 0 0 1 .216.519.3.3 0 0 1-.216.088h-9.558c.138-.105.503-.483.628-.607m8.929-1.303H16.55a.304.304 0 0 1 0-.608h6.144a.304.304 0 0 1 0 .608m-3.818-2.516h3.818a.304.304 0 0 1 0 .608h-3.818a.304.304 0 0 1 0-.608"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M25.125 5.25h-19.5v19.5h19.5z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M24.963 5.25H5.707v19.256h19.256z"
                        })
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8AjiR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCrossfitStyleTraining);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCrossfitStyleTraining = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "#E5E5E5",
                    clipPath: "url(#b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M15.414 11.63a1.754 1.754 0 1 0 0-3.508 1.754 1.754 0 0 0 0 3.508"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M23.823 5.914a.73.73 0 0 0-.589.313V5.99a.74.74 0 0 0-1.48 0v1.095H9.075V5.99a.74.74 0 0 0-1.481 0v.237a.73.73 0 0 0-.589-.313.74.74 0 0 0-.74.74v1.827c0 .41.332.74.74.74a.73.73 0 0 0 .589-.312v.237a.74.74 0 0 0 1.48 0V8.05h.468c.013.068 1.47 2.942 1.47 2.942a.7.7 0 0 0 .153.203l2.123 1.974v5.225l-1.722 1.653a.87.87 0 0 0-.267.627v2.962a.869.869 0 1 0 1.738 0v-2.591l1.251-1.203h2.25l1.253 1.203v2.591a.869.869 0 1 0 1.737 0v-2.962a.87.87 0 0 0-.267-.627l-1.72-1.652V13.17l2.12-1.974a.7.7 0 0 0 .155-.203s1.456-2.874 1.469-2.942h.467v1.095a.74.74 0 0 0 1.482 0v-.238a.73.73 0 0 0 .588.314.74.74 0 0 0 .74-.74V6.653a.74.74 0 0 0-.74-.74M18.559 10.2l-1.897 1.766h-2.493l-1.9-1.766-1.107-2.15h8.505z"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M5.625 5.25h19.5v19.5h-19.5z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M5.787 5.25h19.256v19.256H5.787z"
                        })
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eON9Y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPowerLifting);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPowerLifting = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M26.133 17.51a.2.2 0 0 1-.032-.063c-.023-.07-2.383-7.063-8.058-9.76a2.8 2.8 0 0 1-1.01-.99c-.016-.032-.266-.47-1.107-.59a4 4 0 0 1 .149.455q.028.097.05.196.031.148.052.3c.01.058.022.116.027.175q.027.24.028.487-.002.692-.204 1.331c.496.065.943.326 1.23.737.596.85.987 2.141 1.163 3.84.001.033.024 1.166.588 2.175.35.378.694.818 1.021 1.348a.244.244 0 1 1-.416.257c-2.17-3.505-5.008-3.18-6.507-2.674a2.38 2.38 0 0 1-1.902-.148c-2.988-1.639-5.645.06-6.397.627 0 0-.035 5.6-.273 9.3l3.389 1.72c.339-.172 1.458-.823 1.855-2.103.092-.294.16-.561.221-.797.164-.633.281-1.09.66-1.276.278-.136.627-.096 1.166.135.15.064.3.127.454.178l.972.322c.192.064.355.108.513.139 2.335.462 4.86.153 6.753-.825 1.778-.915 2.769-1.323 3.287-1.504a4.75 4.75 0 0 0 1.808-1.104c.722-.712.896-1.345.52-1.887m-2.134.178c-.167.766-.774 1.416-1.806 1.932a.243.243 0 0 1-.328-.11.244.244 0 0 1 .11-.327c.89-.446 1.41-.982 1.546-1.595.173-.783-.352-1.455-.357-1.462a.244.244 0 0 1 .381-.306c.027.035.675.853.454 1.868"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M8.26 9.665c.015.025.025.053.04.078.074.129.162.247.25.365.032.043.059.09.092.132.072.088.153.167.23.248.06.061.114.128.177.185.057.053.121.096.182.145.092.075.182.153.28.22.038.025.08.044.12.068.126.079.253.158.388.222l.076.03c.153.069.309.133.47.183.037.011.077.016.115.026.152.042.305.081.463.105a4 4 0 0 0 1.207 0c.158-.024.31-.063.462-.105.038-.01.078-.014.116-.026.163-.05.321-.115.476-.186.023-.01.047-.016.07-.027.14-.067.274-.148.405-.23.034-.022.07-.038.102-.06.105-.07.201-.154.3-.234.053-.044.11-.082.162-.13.069-.062.128-.134.192-.201.072-.077.149-.149.215-.232.037-.046.068-.098.103-.146.083-.114.168-.226.24-.35l.042-.084a3.9 3.9 0 0 0 .484-2.374q-.01-.08-.024-.16a4 4 0 0 0-.046-.263q-.02-.09-.046-.177a4 4 0 0 0-.133-.407 4 4 0 0 0-.104-.241q-.034-.072-.07-.143a4 4 0 0 0-.245-.416l-.077-.103a4 4 0 0 0-.355-.424 4 4 0 0 0-.471-.414q-.105-.08-.212-.151a4 4 0 0 0-.434-.245q-.091-.047-.185-.089a4 4 0 0 0-.418-.15q-.076-.022-.153-.04a4 4 0 0 0-.347-.073q-.075-.014-.152-.024a4 4 0 0 0-.5-.035c-.17 0-.336.015-.5.035q-.077.01-.152.024-.176.029-.348.073-.077.018-.152.04a4 4 0 0 0-.419.15c-.063.027-.124.06-.186.09a4 4 0 0 0-.912.616q-.105.092-.203.193a4 4 0 0 0-.354.422l-.08.106a4.2 4.2 0 0 0-.48.97 4 4 0 0 0-.07.232q-.025.09-.047.182a4 4 0 0 0-.045.26q-.014.08-.025.161a3.9 3.9 0 0 0 .487 2.378m3.052-3.93.044-.008q.187-.038.385-.04.197.002.384.04l.045.009a2.04 2.04 0 0 1 1.608 1.984c0 .843-.514 1.569-1.245 1.88l-.009.004q-.166.068-.347.108-.024.006-.05.01a2 2 0 0 1-.386.04q-.199-.001-.387-.04l-.05-.01a2 2 0 0 1-.347-.108L10.95 9.6a2.05 2.05 0 0 1-1.245-1.88c0-.972.69-1.785 1.608-1.984"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b5yek":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCombatSports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCombatSports = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#E5E5E5",
                    d: "M16.024 13.863q-.92.92-2.116 1.145c-.447.085-.826.431-.848.886-.023.487.368.9.85.828q1.783-.27 3.252-1.64l.569-.57 1.868 1.95-1.188 1.135c-.383.365-.6.871-.6 1.4v3.235a.812.812 0 1 0 1.626 0v-3.413l1.056-.975v1c0 .505.198.99.55 1.352l2.297 2.35a.8.8 0 1 0 1.138-1.123l-2.36-2.36.975-2.844c.163-.487-.081-.894-.488-1.219l-2.68-2.68c-.326-.407-.732-.57-1.138-.57s-.65.082-.894.244zm-10.4.244a.812.812 0 1 0 1.625 0v-1.95l1.463-.57-.732 3.576-.812 4.225-.524 2.564a.842.842 0 0 0 1.647.353l1.314-5.842 1.707 1.625v4.062a.813.813 0 0 0 1.625 0v-4.244c0-.662-.272-1.295-.75-1.752l-.957-.91.488-2.437c.488.487 1.056.975 1.706 1.3a3.4 3.4 0 0 0 2.032-.975c-1.3-.244-2.194-.894-2.763-1.87l-.812-1.3c-.488-.812-1.22-1.055-2.113-.65L5.624 11.1zm10.238-5.282a1.63 1.63 0 0 0-1.625 1.625 1.63 1.63 0 0 0 1.625 1.625 1.63 1.63 0 0 0 1.625-1.625 1.63 1.63 0 0 0-1.625-1.625m-4.144-3.33a1.63 1.63 0 0 0-1.625 1.624 1.63 1.63 0 0 0 1.625 1.625 1.63 1.63 0 0 0 1.625-1.625 1.63 1.63 0 0 0-1.625-1.625"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9A6RY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFootball);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFootball = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M15 5.625A9.375 9.375 0 0 1 24.375 15 9.375 9.375 0 0 1 15 24.375 9.375 9.375 0 0 1 5.625 15 9.375 9.375 0 0 1 15 5.625m1.566 13.125h-3.132l-1.293 1.778.519 1.6A7.5 7.5 0 0 0 15 22.5c.817 0 1.603-.131 2.34-.372l.518-1.6zm-7.853-4.807-1.211.879L7.5 15c0 1.622.515 3.123 1.39 4.35h1.79l1.24-1.706-.963-2.972zm12.574 0-2.244.729-.963 2.972 1.24 1.706h1.79A7.46 7.46 0 0 0 22.5 15l-.003-.18zm-4.14-6.13-1.21.88v2.36l2.526 1.835 2.1-.682.52-1.596a7.5 7.5 0 0 0-3.934-2.798m-4.296 0a7.5 7.5 0 0 0-3.934 2.799l.52 1.595 2.099.682 2.524-1.835v-2.36z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fUd2D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPerformanceRunning);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPerformanceRunning = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9.809 13.181h2.082l1.453-1.454-.002-.006a2.14 2.14 0 1 1 2.089-.8h2.66c.283 0 .555.112.755.312l2.109 2.11a1.067 1.067 0 0 1-1.51 1.509l-1.796-1.797h-1.54l1.517 5.896 1.971-.736a1.067 1.067 0 0 1 .747 2l-3.095 1.156a1.068 1.068 0 0 1-1.41-.745l-.457-1.861-4.19 4.19a1.067 1.067 0 0 1-1.51-1.51L14.73 16.4l-.572-2.466-1.07 1.07c-.2.2-.471.313-.754.313H9.809a1.067 1.067 0 1 1 0-2.135m-2.331 3.23a.695.695 0 0 1-.983 0 2.98 2.98 0 0 1 0-4.212.695.695 0 0 1 .983.983 1.59 1.59 0 0 0 0 2.246.695.695 0 0 1 0 .983"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M4.81 17.469a4.44 4.44 0 0 1-1.31-3.163c0-1.195.464-2.318 1.31-3.163a.695.695 0 1 1 .982.983 3.06 3.06 0 0 0-.902 2.18c0 .823.32 1.597.902 2.18a.695.695 0 1 1-.983.982M22.521 12.2a.695.695 0 0 1 .983 0 2.96 2.96 0 0 1 .873 2.106 2.96 2.96 0 0 1-.872 2.106.695.695 0 0 1-.984-.983c.3-.3.465-.699.465-1.123s-.165-.823-.465-1.123a.695.695 0 0 1 0-.983"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M25.19 11.143a4.44 4.44 0 0 1 1.31 3.163 4.44 4.44 0 0 1-1.31 3.162.695.695 0 1 1-.983-.983 3.06 3.06 0 0 0 .902-2.18c0-.822-.32-1.596-.902-2.179a.695.695 0 0 1 .983-.983"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M26.5 3.5h-23v23h23z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hWfog":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgTennis);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTennis = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M15 5.625a9.3 9.3 0 0 1 6.094 2.25A9.36 9.36 0 0 0 17.812 15c0 2.85 1.275 5.41 3.282 7.125A9.3 9.3 0 0 1 15 24.375a9.3 9.3 0 0 1-6.094-2.25A9.36 9.36 0 0 0 12.187 15c0-2.85-1.274-5.41-3.28-7.125A9.3 9.3 0 0 1 15 5.625M24.375 15a9.3 9.3 0 0 1-1.988 5.766 7.5 7.5 0 0 1-2.7-5.766 7.5 7.5 0 0 1 2.7-5.766A9.32 9.32 0 0 1 24.376 15m-18.75 0a9.3 9.3 0 0 1 1.988-5.766 7.5 7.5 0 0 1 2.7 5.766 7.5 7.5 0 0 1-2.7 5.766A9.32 9.32 0 0 1 5.625 15"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5oroU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PerformanceStep2", ()=>PerformanceStep2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _conditioningSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/conditioning.svg");
var _performanceEnduranceSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/performance-endurance.svg");
var _strengthSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength.svg");
var _agilitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/agility.svg");
var _powerSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/power.svg");
var _speedSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/speed.svg");
const iconMap = {
    strength: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _strengthSvg.ReactComponent), {}),
    power: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _powerSvg.ReactComponent), {}),
    speed: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _speedSvg.ReactComponent), {}),
    agility: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _agilitySvg.ReactComponent), {}),
    conditioning: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditioningSvg.ReactComponent), {}),
    endurance: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _performanceEnduranceSvg.ReactComponent), {})
};
const PerformanceStep2 = ({ value, onNext })=>{
    const [selectedFocus, setSelectedFocus] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalPreferences?.groups?.find((g)=>g.goalId === 'performance');
    const focuses = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: focuses.map((focus)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedFocus === focus.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedFocus(focus.slug);
                            if (onNext) onNext(focus.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[focus.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: focus.title
                            })
                        ]
                    }, focus.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/conditioning.svg":"5m6sK","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/performance-endurance.svg":"9KuZy","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength.svg":"6mltw","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/agility.svg":"f4iJy","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/power.svg":"9ucTG","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/speed.svg":"lqxdW","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"5m6sK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgConditioning);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgConditioning = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M20.785 14.323a.68.68 0 0 1-.654-.484l-1.088-3.63a1.356 1.356 0 0 0-2.594-.01l-2.765 9.203-1.733-3.88a2.03 2.03 0 0 0-1.857-1.2H7.25V8.907c0-1.12.911-2.031 2.031-2.031H21.47c1.12 0 2.031.911 2.031 2.031v5.417z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M10.094 15.677c.27 0 .513.156.62.397l1.734 3.88a1.34 1.34 0 0 0 1.234.801c.595 0 1.115-.383 1.296-.953l2.765-9.204 1.093 3.636a2.03 2.03 0 0 0 1.949 1.443H23.5v5.417c0 1.12-.911 2.031-2.031 2.031H9.28a2.034 2.034 0 0 1-2.031-2.031v-5.417z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9KuZy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPerformanceEndurance);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPerformanceEndurance = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M13.75 7.688a.78.78 0 0 1-.578-.234.8.8 0 0 1-.235-.579q0-.345.235-.578a.8.8 0 0 1 .578-.234H17q.345 0 .58.234a.78.78 0 0 1 .233.578q-.001.345-.235.58a.78.78 0 0 1-.578.232zm1.625 8.937q.345 0 .58-.234a.78.78 0 0 0 .232-.578v-3.25a.78.78 0 0 0-.234-.579.8.8 0 0 0-.578-.234.78.78 0 0 0-.578.234.8.8 0 0 0-.235.579v3.25q0 .345.235.579a.78.78 0 0 0 .578.233m0 6.5a7 7 0 0 1-2.834-.578 7.5 7.5 0 0 1-2.325-1.575 7.5 7.5 0 0 1-1.574-2.326 7 7 0 0 1-.58-2.834q0-1.503.58-2.833a7.5 7.5 0 0 1 1.574-2.326 7.5 7.5 0 0 1 2.326-1.574 7 7 0 0 1 2.833-.579q1.26 0 2.417.406t2.174 1.178l.568-.568a.77.77 0 0 1 .57-.224q.345 0 .568.224a.77.77 0 0 1 .223.568.77.77 0 0 1-.223.57l-.569.568a7.9 7.9 0 0 1 1.178 2.173q.407 1.158.407 2.418a7 7 0 0 1-.58 2.833 7.5 7.5 0 0 1-1.574 2.326 7.5 7.5 0 0 1-2.326 1.575 7 7 0 0 1-2.833.578"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6mltw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgStrength);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgStrength = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M26.133 17.51a.2.2 0 0 1-.032-.063c-.023-.07-2.383-7.063-8.058-9.76a2.8 2.8 0 0 1-1.01-.99c-.016-.032-.266-.47-1.107-.59a4 4 0 0 1 .149.455q.028.097.05.196.031.148.052.3c.01.058.022.116.027.175q.027.24.028.487-.002.692-.204 1.331c.496.065.943.326 1.23.737.596.85.987 2.141 1.163 3.84.001.033.024 1.166.588 2.175.35.378.694.818 1.021 1.348a.244.244 0 1 1-.416.257c-2.17-3.505-5.008-3.18-6.507-2.674a2.38 2.38 0 0 1-1.902-.148c-2.988-1.639-5.645.06-6.397.627 0 0-.035 5.6-.273 9.3l3.389 1.72c.339-.172 1.458-.823 1.855-2.103.092-.294.16-.561.221-.797.164-.633.281-1.09.66-1.276.278-.136.627-.096 1.166.135.15.064.3.127.454.178l.972.322c.192.064.355.108.513.139 2.335.462 4.86.153 6.753-.825 1.778-.915 2.769-1.323 3.287-1.504a4.75 4.75 0 0 0 1.808-1.104c.722-.712.896-1.345.52-1.887m-2.134.178c-.167.766-.774 1.416-1.806 1.932a.243.243 0 0 1-.328-.11.244.244 0 0 1 .11-.327c.89-.446 1.41-.982 1.546-1.595.173-.783-.352-1.455-.357-1.462a.244.244 0 0 1 .381-.306c.027.035.675.853.454 1.868"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M8.26 9.665c.015.025.025.053.04.078.074.129.162.247.25.365.032.043.059.09.092.132.072.088.153.167.23.248.06.061.114.128.177.185.057.053.121.096.182.145.092.075.182.153.28.22.038.025.08.044.12.068.126.079.253.158.388.222l.076.03c.153.069.309.133.47.183.037.011.077.016.115.026.152.042.305.081.463.105a4 4 0 0 0 1.207 0c.158-.024.31-.063.462-.105.038-.01.078-.014.116-.026.163-.05.321-.115.476-.186.023-.01.047-.016.07-.027.14-.067.274-.148.405-.23.034-.022.07-.038.102-.06.105-.07.201-.154.3-.234.053-.044.11-.082.162-.13.069-.062.128-.134.192-.201.072-.077.149-.149.215-.232.037-.046.068-.098.103-.146.083-.114.168-.226.24-.35l.042-.084a3.9 3.9 0 0 0 .484-2.374q-.01-.08-.024-.16a4 4 0 0 0-.046-.263q-.02-.09-.046-.177a4 4 0 0 0-.133-.407 4 4 0 0 0-.104-.241q-.034-.072-.07-.143a4 4 0 0 0-.245-.416l-.077-.103a4 4 0 0 0-.355-.424 4 4 0 0 0-.471-.414q-.105-.08-.212-.151a4 4 0 0 0-.434-.245q-.091-.047-.185-.089a4 4 0 0 0-.418-.15q-.076-.022-.153-.04a4 4 0 0 0-.347-.073q-.075-.014-.152-.024a4 4 0 0 0-.5-.035c-.17 0-.336.015-.5.035q-.077.01-.152.024-.176.029-.348.073-.077.018-.152.04a4 4 0 0 0-.419.15c-.063.027-.124.06-.186.09a4 4 0 0 0-.912.616q-.105.092-.203.193a4 4 0 0 0-.354.422l-.08.106a4.2 4.2 0 0 0-.48.97 4 4 0 0 0-.07.232q-.025.09-.047.182a4 4 0 0 0-.045.26q-.014.08-.025.161a3.9 3.9 0 0 0 .487 2.378m3.052-3.93.044-.008q.187-.038.385-.04.197.002.384.04l.045.009a2.04 2.04 0 0 1 1.608 1.984c0 .843-.514 1.569-1.245 1.88l-.009.004q-.166.068-.347.108-.024.006-.05.01a2 2 0 0 1-.386.04q-.199-.001-.387-.04l-.05-.01a2 2 0 0 1-.347-.108L10.95 9.6a2.05 2.05 0 0 1-1.245-1.88c0-.972.69-1.785 1.608-1.984"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f4iJy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAgility);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAgility = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M9.368 18.046a.39.39 0 0 0-.389-.352H7.144a.387.387 0 0 0-.388.352L6.32 22.2a1.77 1.77 0 0 0 .448 1.35 1.75 1.75 0 0 0 1.294.576 1.74 1.74 0 0 0 1.294-.576 1.76 1.76 0 0 0 .447-1.35zM22.242 22.2l-.435-4.153a.39.39 0 0 0-.389-.352h-1.835a.387.387 0 0 0-.388.352l-.436 4.153a1.77 1.77 0 0 0 .448 1.35 1.75 1.75 0 0 0 1.294.576 1.74 1.74 0 0 0 1.294-.576 1.76 1.76 0 0 0 .447-1.35M17.267 7.213a3.9 3.9 0 0 1 1.784 1.438c.438.649.673 1.415.672 2.2v3.519a.39.39 0 0 1-.388.391.4.4 0 0 0-.304.14.42.42 0 0 0-.077.33l.194.977a.39.39 0 0 0 .381.313h1.866a.39.39 0 0 0 .373-.282c.039-.14.117-.399.28-1.009a.42.42 0 0 0-.078-.328.4.4 0 0 0-.303-.141.387.387 0 0 1-.389-.391v-3.52a5.5 5.5 0 0 0-1.594-3.871 5.43 5.43 0 0 0-5.208-1.432.8.8 0 0 1-.39 0A5.43 5.43 0 0 0 8.878 6.98a5.5 5.5 0 0 0-1.593 3.871v3.52a.39.39 0 0 1-.388.391.4.4 0 0 0-.304.14.42.42 0 0 0-.077.33c.163.61.24.868.28 1.008a.39.39 0 0 0 .373.282h1.866a.39.39 0 0 0 .38-.313l.203-.978a.42.42 0 0 0-.078-.328.41.41 0 0 0-.311-.141.387.387 0 0 1-.389-.391v-3.52c0-.784.234-1.55.672-2.199a3.9 3.9 0 0 1 1.785-1.438.186.186 0 0 1 .225.063.19.19 0 0 1 0 .234 5.5 5.5 0 0 0-1.127 3.34c0 1.037.41 2.032 1.139 2.766a3.88 3.88 0 0 0 2.748 1.145c1.031 0 2.02-.412 2.749-1.145a3.92 3.92 0 0 0 1.138-2.766 5.5 5.5 0 0 0-1.127-3.34.19.19 0 0 1 0-.234.186.186 0 0 1 .226-.063m-2.986 5.984a2.33 2.33 0 0 1-1.649-.688 2.35 2.35 0 0 1-.683-1.659c0-.686.18-1.36.52-1.955a3.9 3.9 0 0 1 1.424-1.432.77.77 0 0 1 .777 0 3.9 3.9 0 0 1 1.423 1.432 3.93 3.93 0 0 1 .52 1.955c0 .623-.245 1.22-.683 1.66-.437.44-1.03.687-1.649.687"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9ucTG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPower);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPower = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M20.548 6.131a.9.9 0 0 0-.26-.37.58.58 0 0 0-.366-.136h-5.056c-.274 0-.692.178-.804.515L9.437 16.485c-.099.29-.078.628.05.9.126.271.35.43.59.43h3.516v5.623c0 .248.074.487.206.663.132.175.31.274.497.274.218 0 .436-.14.57-.384l5.626-10.307a1.2 1.2 0 0 0 .056-.975.9.9 0 0 0-.257-.377.57.57 0 0 0-.369-.138H17.77l2.722-5.08a1.2 1.2 0 0 0 .056-.975z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lqxdW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSpeed);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSpeed = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M10.768 13.518h1.697l1.185-1.185-.002-.005a1.745 1.745 0 1 1 1.703-.653h2.169a.87.87 0 0 1 .615.255l1.72 1.72a.87.87 0 1 1-1.231 1.23l-1.465-1.465h-1.255l1.237 4.807 1.607-.6a.87.87 0 0 1 .608 1.63l-2.523.942a.87.87 0 0 1-1.149-.608l-.373-1.517-3.416 3.416a.87.87 0 1 1-1.23-1.23l4.114-4.114-.466-2.01-.872.872a.87.87 0 0 1-.616.255h-2.057a.87.87 0 1 1 0-1.74M8.87 16.15a.567.567 0 0 1-.802 0 2.43 2.43 0 0 1 0-3.433.567.567 0 0 1 .801.801 1.296 1.296 0 0 0 0 1.831.567.567 0 0 1 0 .802"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M6.693 17.012a3.62 3.62 0 0 1-1.068-2.578c0-.974.379-1.89 1.068-2.578a.567.567 0 0 1 .801.801 2.5 2.5 0 0 0-.736 1.777 2.5 2.5 0 0 0 .736 1.777.567.567 0 1 1-.801.801m14.439-4.295a.567.567 0 0 1 .801 0 2.4 2.4 0 0 1 .712 1.717c0 .648-.253 1.258-.712 1.717a.567.567 0 0 1-.801-.802c.244-.244.379-.57.379-.915s-.135-.671-.38-.916a.567.567 0 0 1 0-.801"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M23.307 11.856a3.62 3.62 0 0 1 1.068 2.578c0 .974-.38 1.89-1.068 2.578a.567.567 0 1 1-.801-.802 2.5 2.5 0 0 0 .735-1.776c0-.671-.26-1.302-.735-1.777a.567.567 0 1 1 .801-.802"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M24.375 5.625H5.625v18.75h18.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jEkfG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PerformanceStep3", ()=>PerformanceStep3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _sportSpecificPerformanceSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/sport_specific_performance.svg");
var _conditioningPerformanceSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/conditioning_performance.svg");
var _strengthPowerSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength_power.svg");
var _speedAgilitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/speed_agility.svg");
const iconMap = {
    sport_specific_performance: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sportSpecificPerformanceSvg.ReactComponent), {}),
    strength_power: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _strengthPowerSvg.ReactComponent), {}),
    speed_agility: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _speedAgilitySvg.ReactComponent), {}),
    conditioning: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _conditioningPerformanceSvg.ReactComponent), {})
};
const PerformanceStep3 = ({ value, onNext })=>{
    const [selectedApproach, setSelectedApproach] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalApproaches?.groups?.find((g)=>g.goalId === 'performance');
    const approaches = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: groupData?.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: approaches.map((approach)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedApproach(approach.slug);
                            if (onNext) onNext(approach.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[approach.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: approach.title
                            })
                        ]
                    }, approach.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/sport_specific_performance.svg":"3a2W5","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/conditioning_performance.svg":"jkG9X","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength_power.svg":"ePjmW","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/speed_agility.svg":"5ew1e","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"3a2W5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSportSpecificPerformance);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSportSpecificPerformance = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.688,
                d: "M17.538 21.99a3.06 3.06 0 0 0-2.165-.896h-.745c-.812 0-1.59.322-2.165.896l-.344.344a.097.097 0 0 0 .069.166h5.625a.1.1 0 0 0 .09-.06.1.1 0 0 0-.021-.106z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.688,
                d: "M15 17.813v3.28"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                fillRule: "evenodd",
                d: "M18.984 7.5v4.323A6.28 6.28 0 0 1 15 17.673a6.28 6.28 0 0 1-3.985-5.849V7.5z",
                clipRule: "evenodd"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M18.984 7.5v-.703a.703.703 0 0 1 .703.703zM15 17.672l.257.654a.7.7 0 0 1-.514 0zM11.015 7.5h-.703a.703.703 0 0 1 .703-.703zm7.266 4.323V7.5h1.407v4.323zm-2.02 4.298a5.58 5.58 0 0 0 2.02-4.297h1.407a6.98 6.98 0 0 1-2.53 5.38zm-1.518.896a5.6 5.6 0 0 0 1.517-.896l.897 1.083a7 7 0 0 1-1.9 1.122zm-1.003-.896c.455.377.967.68 1.517.896l-.514 1.31a7 7 0 0 1-1.9-1.123zm-2.021-4.297a5.58 5.58 0 0 0 2.02 4.297l-.896 1.083a6.98 6.98 0 0 1-2.53-5.38zm0-4.324v4.323h-1.406V7.5zm-.704-.703h7.97v1.406h-7.97z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M18.985 9.375h-.703a.703.703 0 0 1 .703-.703zm-.732 5.39.065.7a.703.703 0 0 1-.686-1.03zm3.573-5.39v-.703a.7.7 0 0 1 .667.481zm-2.138 0v2.448h-1.406V9.375zm0 2.448a7 7 0 0 1-.813 3.271l-1.243-.658c.427-.805.65-1.702.65-2.613zm1.959 1.869a4.9 4.9 0 0 1-3.33 1.773l-.128-1.4a3.5 3.5 0 0 0 2.369-1.264zm.964-4.121a4.8 4.8 0 0 1-.965 4.121l-1.088-.89a3.4 3.4 0 0 0 .683-2.91zm-.118-.418q.069.207.118.418l-1.37.32a3 3 0 0 0-.083-.294zm-3.508-.481h2.84v1.406h-2.84zm-7.97.703h.704a.703.703 0 0 0-.704-.703zm.732 5.39-.065.7a.703.703 0 0 0 .686-1.03zm-3.572-5.39v-.703a.7.7 0 0 0-.668.481zm2.137 0v2.448h1.407V9.375zm0 2.448a7 7 0 0 0 .813 3.271l1.243-.658a5.6 5.6 0 0 1-.65-2.613zm-1.958 1.869a4.9 4.9 0 0 0 3.328 1.773l.129-1.4A3.5 3.5 0 0 1 9.442 12.8zm-.965-4.121a4.8 4.8 0 0 0 .965 4.121l1.088-.89a3.4 3.4 0 0 1-.683-2.91zm.118-.418a5 5 0 0 0-.118.418l1.37.32q.034-.15.083-.294zm3.508-.481h-2.84v1.406h2.84z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jkG9X":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgConditioningPerformance);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgConditioningPerformance = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M15.643 9.362c1.706-2.118 4.755-2.245 6.613-.277 1.303 1.38 1.641 3.393 1.016 5.102H19.94l-2.128-4.254-2.438 4.874-1.218-2.436-.909 1.816h-5.77c-.625-1.709-.287-3.722 1.016-5.102 1.858-1.968 4.907-1.84 6.613.277l.268.333zm-7.172 6.45h5.589l1.314 2.63 2.438-4.875 1.123 2.246h3.343l-.022.022-6.878 7.286-.003.004-6.882-7.29z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ePjmW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgStrengthPower);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgStrengthPower = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M19.624 7.61a.74.74 0 0 0-.217-.31.48.48 0 0 0-.305-.112h-4.214c-.228 0-.576.148-.67.429l-3.854 8.62c-.082.243-.064.524.041.75.106.227.293.36.492.36h2.93v4.685a.93.93 0 0 0 .172.552c.11.146.26.229.415.229.181 0 .363-.118.474-.32l4.689-8.59a1 1 0 0 0 .047-.812.74.74 0 0 0-.215-.314.48.48 0 0 0-.307-.116h-1.793l2.268-4.232a1 1 0 0 0 .047-.812z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5ew1e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSpeedAgility);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSpeedAgility = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M10.768 13.518h1.697l1.185-1.185-.002-.005a1.745 1.745 0 1 1 1.703-.653h2.169a.87.87 0 0 1 .615.255l1.72 1.72a.87.87 0 1 1-1.231 1.23l-1.465-1.465h-1.255l1.237 4.807 1.607-.6a.87.87 0 0 1 .608 1.63l-2.523.942a.87.87 0 0 1-1.149-.608l-.373-1.517-3.416 3.416a.87.87 0 1 1-1.23-1.23l4.114-4.114-.466-2.01-.872.872a.87.87 0 0 1-.616.255h-2.057a.87.87 0 1 1 0-1.74M8.87 16.15a.567.567 0 0 1-.802 0 2.43 2.43 0 0 1 0-3.433.567.567 0 0 1 .801.801 1.296 1.296 0 0 0 0 1.831.567.567 0 0 1 0 .802"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M6.693 17.012a3.62 3.62 0 0 1-1.068-2.578c0-.974.379-1.89 1.068-2.578a.567.567 0 0 1 .801.801 2.5 2.5 0 0 0-.736 1.777 2.5 2.5 0 0 0 .736 1.777.567.567 0 1 1-.801.801m14.439-4.295a.567.567 0 0 1 .801 0 2.4 2.4 0 0 1 .712 1.717c0 .648-.253 1.258-.712 1.717a.567.567 0 0 1-.801-.802c.244-.244.379-.57.379-.915s-.135-.671-.38-.916a.567.567 0 0 1 0-.801"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M23.307 11.856a3.62 3.62 0 0 1 1.068 2.578c0 .974-.38 1.89-1.068 2.578a.567.567 0 1 1-.801-.802 2.5 2.5 0 0 0 .735-1.776c0-.671-.26-1.302-.735-1.777a.567.567 0 1 1 .801-.802"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M24.375 5.625H5.625v18.75h18.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ayzoc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeneralFitnessStep1", ()=>GeneralFitnessStep1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _buildConsistencySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/build_consistency.svg");
var _improveStrengthSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_strength.svg");
var _balancedFitnessSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/balanced_fitness.svg");
var _improveStaminaSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_stamina.svg");
var _feelHealthierSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/feel_healthier.svg");
var _generalFitnessMoveBetterSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_fitness-move_better.svg");
const iconMap = {
    build_consistency: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildConsistencySvg.ReactComponent), {}),
    improve_strength: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _improveStrengthSvg.ReactComponent), {}),
    improve_stamina: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _improveStaminaSvg.ReactComponent), {}),
    move_better: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalFitnessMoveBetterSvg.ReactComponent), {}),
    feel_healthier: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _feelHealthierSvg.ReactComponent), {}),
    balanced_fitness: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _balancedFitnessSvg.ReactComponent), {})
};
const GeneralFitnessStep1 = ({ value, onNext })=>{
    const [selectedFitnessMean, setSelectedFitnessMean] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalDetails?.groups?.find((g)=>g.goalId === 'general_fitness');
    const meanings = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: meanings.map((meaning)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedFitnessMean === meaning.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedFitnessMean(meaning.slug);
                            if (onNext) onNext(meaning.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[meaning.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: meaning.title
                            })
                        ]
                    }, meaning.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/build_consistency.svg":"ezJKZ","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_strength.svg":"fZMz2","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/balanced_fitness.svg":"fPhNa","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_stamina.svg":"9ld2a","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/feel_healthier.svg":"eRjeH","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_fitness-move_better.svg":"4KbDr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"ezJKZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBuildConsistency);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBuildConsistency = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M20.785 14.323a.68.68 0 0 1-.654-.484l-1.088-3.63a1.356 1.356 0 0 0-2.594-.01l-2.765 9.203-1.733-3.88a2.03 2.03 0 0 0-1.857-1.2H7.25V8.907c0-1.12.911-2.031 2.031-2.031H21.47c1.12 0 2.031.911 2.031 2.031v5.417z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M10.094 15.677c.27 0 .513.156.62.397l1.734 3.88a1.34 1.34 0 0 0 1.234.801c.595 0 1.115-.383 1.296-.953l2.765-9.204 1.093 3.636a2.03 2.03 0 0 0 1.949 1.443H23.5v5.417c0 1.12-.911 2.031-2.031 2.031H9.28a2.034 2.034 0 0 1-2.031-2.031v-5.417z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fZMz2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgImproveStrength);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgImproveStrength = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M26.133 17.51a.2.2 0 0 1-.032-.063c-.023-.07-2.383-7.063-8.058-9.76a2.8 2.8 0 0 1-1.01-.99c-.016-.032-.266-.47-1.107-.59a4 4 0 0 1 .149.455q.028.097.05.196.031.148.052.3c.01.058.022.116.027.175q.027.24.028.487-.002.692-.204 1.331c.496.065.943.326 1.23.737.596.85.987 2.141 1.163 3.84.001.033.024 1.166.588 2.175.35.378.694.818 1.021 1.348a.244.244 0 1 1-.416.257c-2.17-3.505-5.008-3.18-6.507-2.674a2.38 2.38 0 0 1-1.902-.148c-2.988-1.639-5.645.06-6.397.627 0 0-.035 5.6-.273 9.3l3.389 1.72c.339-.172 1.458-.823 1.855-2.103.092-.294.16-.561.221-.797.164-.633.281-1.09.66-1.276.278-.136.627-.096 1.166.135.15.064.3.127.454.178l.972.322c.192.064.355.108.513.139 2.335.462 4.86.153 6.753-.825 1.778-.915 2.769-1.323 3.287-1.504a4.75 4.75 0 0 0 1.808-1.104c.722-.712.896-1.345.52-1.887m-2.134.178c-.167.766-.774 1.416-1.806 1.932a.243.243 0 0 1-.328-.11.244.244 0 0 1 .11-.327c.89-.446 1.41-.982 1.546-1.595.173-.783-.352-1.455-.357-1.462a.244.244 0 0 1 .381-.306c.027.035.675.853.454 1.868"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M8.26 9.665c.015.025.025.053.04.078.074.129.162.247.25.365.032.043.059.09.092.132.072.088.153.167.23.248.06.061.114.128.177.185.057.053.121.096.182.145.092.075.182.153.28.22.038.025.08.044.12.068.126.079.253.158.388.222l.076.03c.153.069.309.133.47.183.037.011.077.016.115.026.152.042.305.081.463.105a4 4 0 0 0 1.207 0c.158-.024.31-.063.462-.105.038-.01.078-.014.116-.026.163-.05.321-.115.476-.186.023-.01.047-.016.07-.027.14-.067.274-.148.405-.23.034-.022.07-.038.102-.06.105-.07.201-.154.3-.234.053-.044.11-.082.162-.13.069-.062.128-.134.192-.201.072-.077.149-.149.215-.232.037-.046.068-.098.103-.146.083-.114.168-.226.24-.35l.042-.084a3.9 3.9 0 0 0 .484-2.374q-.01-.08-.024-.16a4 4 0 0 0-.046-.263q-.02-.09-.046-.177a4 4 0 0 0-.133-.407 4 4 0 0 0-.104-.241q-.034-.072-.07-.143a4 4 0 0 0-.245-.416l-.077-.103a4 4 0 0 0-.355-.424 4 4 0 0 0-.471-.414q-.105-.08-.212-.151a4 4 0 0 0-.434-.245q-.091-.047-.185-.089a4 4 0 0 0-.418-.15q-.076-.022-.153-.04a4 4 0 0 0-.347-.073q-.075-.014-.152-.024a4 4 0 0 0-.5-.035c-.17 0-.336.015-.5.035q-.077.01-.152.024-.176.029-.348.073-.077.018-.152.04a4 4 0 0 0-.419.15c-.063.027-.124.06-.186.09a4 4 0 0 0-.912.616q-.105.092-.203.193a4 4 0 0 0-.354.422l-.08.106a4.2 4.2 0 0 0-.48.97 4 4 0 0 0-.07.232q-.025.09-.047.182a4 4 0 0 0-.045.26q-.014.08-.025.161a3.9 3.9 0 0 0 .487 2.378m3.052-3.93.044-.008q.187-.038.385-.04.197.002.384.04l.045.009a2.04 2.04 0 0 1 1.608 1.984c0 .843-.514 1.569-1.245 1.88l-.009.004q-.166.068-.347.108-.024.006-.05.01a2 2 0 0 1-.386.04q-.199-.001-.387-.04l-.05-.01a2 2 0 0 1-.347-.108L10.95 9.6a2.05 2.05 0 0 1-1.245-1.88c0-.972.69-1.785 1.608-1.984"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fPhNa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBalancedFitness);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBalancedFitness = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M20.809 9.356a1.86 1.86 0 0 0-.965-.247c-.438 0-.758.122-.966.247a.89.89 0 0 0-.42.754c-.01.466-.036 2.004-.036 4.89s.026 4.424.035 4.89a.89.89 0 0 0 .421.754c.208.125.528.247.966.247s.757-.122.965-.247a.89.89 0 0 0 .421-.754c.01-.466.036-2.004.036-4.89s-.026-4.424-.036-4.89a.89.89 0 0 0-.421-.754m-10.868 0c.208-.125.527-.247.965-.247s.758.122.965.247a.89.89 0 0 1 .422.754c.01.466.035 2.004.035 4.89s-.026 4.424-.035 4.89a.89.89 0 0 1-.421.754 1.86 1.86 0 0 1-.966.247c-.438 0-.757-.122-.965-.247a.89.89 0 0 1-.421-.754c-.01-.466-.036-2.004-.036-4.89s.026-4.424.036-4.89a.89.89 0 0 1 .421-.754m13.356 1.785c.268 0 .483.048.647.112.413.16.54.551.547.813.008.364.025 1.298.025 2.934s-.017 2.57-.025 2.934c-.006.262-.134.653-.547.813-.164.064-.379.112-.647.112s-.483-.048-.648-.112c-.412-.16-.54-.551-.546-.813A136 136 0 0 1 22.078 15c0-1.636.016-2.57.024-2.934.007-.262.135-.653.547-.813a1.8 1.8 0 0 1 .648-.112m-16.491.112c.207-.077.426-.115.647-.112.268 0 .483.048.648.112.412.16.54.551.546.813.008.364.025 1.298.025 2.934s-.016 2.57-.024 2.934c-.007.262-.135.653-.547.813-.165.064-.38.112-.648.112s-.483-.048-.647-.112c-.413-.16-.54-.551-.547-.813-.008-.364-.025-1.298-.025-2.934s.017-2.57.025-2.934c.006-.262.134-.653.547-.813m10.803 4.908v-2.322c0-.385-.315-.587-.65-.616a9 9 0 0 0-.312-.021c-.276-.015-.693-.03-1.272-.03s-.996.014-1.272.03a9 9 0 0 0-.311.021c-.336.028-.651.231-.651.616v2.322c0 .385.315.587.65.616q.105.01.312.021c.276.016.693.03 1.272.03s.997-.014 1.272-.03q.207-.011.311-.021c.336-.029.651-.231.651-.616",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9ld2a":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgImproveStamina);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgImproveStamina = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M11.228 13.202c1.139-.83 2.045-1.942 2.552-3.256.583-1.497.765-3.005.822-3.854a.903.903 0 1 1 1.806.068c-.02 3.756-1.775 6.65-1.775 6.65l7.415 10.344a.997.997 0 0 1-1.588 1.207l-4.677-5.804-2.635 2.042-1.021 3.416a1.025 1.025 0 0 1-1.985-.507c.877-4.22 2.693-5.568 2.693-5.568l-1.363-1.546a16 16 0 0 0-.865 4.262.827.827 0 0 1-1.645.046q-.005-.035-.004-.077c-.133-4.943 1.383-6.775 2.27-7.423"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9.202 11.913c-.79-.676-.917-1.824-.284-2.564s1.786-.792 2.576-.117c.79.676.917 1.823.284 2.563s-1.787.793-2.576.117"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eRjeH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFeelHealthier);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFeelHealthier = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    stroke: "#E5E5E5",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 1.875,
                    d: "M12.938 12.563h-.009m4.884 0h-.009M7.25 15a8.125 8.125 0 1 0 16.25 0 8.125 8.125 0 0 0-16.25 0m5.281-2.437a.406.406 0 1 0 .813 0 .406.406 0 0 0-.813 0m4.875 0a.406.406 0 1 0 .813 0 .406.406 0 0 0-.813 0m-2.031 6.906c-2.032 0-3.656-1.49-3.656-2.844h7.312c0 1.354-1.624 2.844-3.656 2.844"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4KbDr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGeneralFitnessMoveBetter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGeneralFitnessMoveBetter = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m20.717 24.774-3.423-7.822v-4.553s5.102-3.463.677-8.35a.92.92 0 0 0-1.306-.057c-.008.01-.022.022-.03.031l-.005.004a.92.92 0 0 0-.013 1.284c.896.958 2.127 2.93-.264 5.036-.237.206-.518.36-.826.444l-.127.03a1.7 1.7 0 0 1-.809 0l-.127-.03a2.1 2.1 0 0 1-.827-.444c-2.39-2.1-1.16-4.078-.263-5.036a.92.92 0 0 0-.018-1.284l-.004-.004a.91.91 0 0 0-1.296-.004c-.01.008-.022.022-.031.03-4.426 4.883.676 8.35.676 8.35v4.548L9.279 24.77a1.056 1.056 0 0 0 .54 1.388c.014.005.027.014.04.018a1.054 1.054 0 0 0 1.336-.523L15 17.883l3.801 7.774a1.055 1.055 0 0 0 1.934-.843q-.007-.02-.018-.04"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M14.999 10.043c1.073 0 1.942-.933 1.942-2.083S16.071 5.877 15 5.877s-1.942.933-1.942 2.083.87 2.083 1.942 2.083"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5e1iY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GeneralFitnessStep2", ()=>GeneralFitnessStep2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _beginnerFriendlyFitnessSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/beginner_friendly_fitness.svg");
var _functionalTrainingSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/functional_training.svg");
var _strengthCardioMixSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength_cardio_mix.svg");
var _fullBodyTrainingSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/full_body_training.svg");
const iconMap = {
    full_body_training: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullBodyTrainingSvg.ReactComponent), {}),
    functional_training: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _functionalTrainingSvg.ReactComponent), {}),
    strength_cardio_mix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _strengthCardioMixSvg.ReactComponent), {}),
    beginner_friendly_fitness: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _beginnerFriendlyFitnessSvg.ReactComponent), {})
};
const GeneralFitnessStep2 = ({ value, onNext })=>{
    const [selectedApproach, setSelectedApproach] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalApproaches?.groups?.find((g)=>g.goalId === 'general_fitness');
    const approaches = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: groupData?.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: approaches.map((approach)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedApproach(approach.slug);
                            if (onNext) onNext(approach.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[approach.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: approach.title
                            })
                        ]
                    }, approach.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/beginner_friendly_fitness.svg":"9WwcV","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/functional_training.svg":"1vMjG","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength_cardio_mix.svg":"k3tB9","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/full_body_training.svg":"f1flf","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"9WwcV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBeginnerFriendlyFitness);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBeginnerFriendlyFitness = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                        id: "b",
                        width: 19,
                        height: 15,
                        x: 4,
                        y: 7,
                        maskUnits: "userSpaceOnUse",
                        style: {
                            maskType: "luminance"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "#fff",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: 1.875,
                                d: "M19.969 20.75a7.016 7.016 0 0 0 0-9.937 7.016 7.016 0 0 0-9.938 0 7.016 7.016 0 0 0 0 9.937"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "#000",
                                d: "M13.348 19.322a3.906 3.906 0 0 0 3.302-7.08c-1.955-.912-12.272-1.413-12.272-1.413s7.015 7.581 8.97 8.493"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "#fff",
                                d: "M14.009 17.906a2.344 2.344 0 0 0 1.98-4.249c-1.172-.547-8.778-1.508-8.778-1.508s5.625 5.21 6.798 5.757"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        mask: "url(#b)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#E5E5E5",
                            d: "M5.625 5.625h18.75v18.75H5.625z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M24.375 5.625H5.625v18.75h18.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1vMjG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFunctionalTraining);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFunctionalTraining = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M19.786 12.926c-1.314-.958-2.36-2.241-2.945-3.757-.672-1.727-.883-3.468-.949-4.448a1.042 1.042 0 1 0-2.083.08c.022 4.333 2.048 7.672 2.048 7.672L7.3 24.41a1.15 1.15 0 0 0 1.833 1.393l5.396-6.697 3.04 2.355 1.178 3.942a1.183 1.183 0 0 0 2.29-.584c-1.01-4.87-3.107-6.425-3.107-6.425l1.573-1.784c.717 2.012.936 3.898.998 4.917a.954.954 0 0 0 1.898.053q.006-.041.005-.088c.154-5.704-1.596-7.818-2.62-8.565"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M22.125 11.438c.911-.78 1.058-2.104.327-2.958-.73-.854-2.06-.915-2.972-.135s-1.058 2.103-.327 2.957c.73.854 2.06.915 2.972.136"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k3tB9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgStrengthCardioMix);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgStrengthCardioMix = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M15.643 9.362c1.706-2.118 4.755-2.245 6.613-.277 1.303 1.38 1.641 3.393 1.016 5.102H19.94l-2.128-4.254-2.438 4.874-1.218-2.436-.909 1.816h-5.77c-.625-1.709-.287-3.722 1.016-5.102 1.858-1.968 4.907-1.84 6.613.277l.268.333zm-7.172 6.45h5.589l1.314 2.63 2.438-4.875 1.123 2.246h3.343l-.022.022-6.878 7.286-.003.004-6.882-7.29z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f1flf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFullBodyTraining);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFullBodyTraining = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m10.235 23.145 2.853-6.519v-3.794s-4.251-2.886-.564-6.958a.766.766 0 0 1 1.088-.047l.025.025.004.004a.767.767 0 0 1 .011 1.07c-.747.798-1.772 2.442.22 4.196.198.172.432.3.688.37l.107.025c.223.055.454.055.673 0l.107-.025c.252-.07.49-.194.688-.37 1.992-1.75.967-3.398.22-4.197a.767.767 0 0 1 .014-1.07l.004-.003a.76.76 0 0 1 1.08-.003l.026.025c3.688 4.069-.564 6.958-.564 6.958v3.79l2.853 6.519a.88.88 0 0 1-.45 1.157l-.034.015a.88.88 0 0 1-1.113-.436L15 17.403l-3.168 6.478a.88.88 0 0 1-1.611-.703q.005-.016.014-.033"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M15 10.87c-.893 0-1.618-.777-1.618-1.736 0-.958.725-1.736 1.619-1.736.893 0 1.618.778 1.618 1.736 0 .959-.725 1.736-1.618 1.736"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M24.375 5.625H5.625v18.75h18.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7TzaN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InjuryPreventionStep1", ()=>InjuryPreventionStep1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _genderUtils = require("src/utils/genderUtils");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _rehabilitationMaleAnklesWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-ankles.webp");
var _rehabilitationMaleAnklesWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleAnklesWebp);
var _rehabilitationMaleCoreWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-core.webp");
var _rehabilitationMaleCoreWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleCoreWebp);
var _rehabilitationMaleElbowWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-elbow.webp");
var _rehabilitationMaleElbowWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleElbowWebp);
// import RehabilitationMaleFullBodyIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-full-body.webp';
var _rehabilitationMaleHamstringsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-hamstrings.webp");
var _rehabilitationMaleHamstringsWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleHamstringsWebp);
var _rehabilitationMaleHipsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-hips.webp");
var _rehabilitationMaleHipsWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleHipsWebp);
var _rehabilitationMaleKneesWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-knees.webp");
var _rehabilitationMaleKneesWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleKneesWebp);
var _rehabilitationMaleNeckWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-neck.webp");
var _rehabilitationMaleNeckWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleNeckWebp);
var _rehabilitationMaleShouldersWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-shoulders.webp");
var _rehabilitationMaleShouldersWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleShouldersWebp);
var _rehabilitationMaleSpineBackWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-spine-back.webp");
var _rehabilitationMaleSpineBackWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleSpineBackWebp);
var _rehabilitationMaleWristsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-wrists.webp");
var _rehabilitationMaleWristsWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleWristsWebp);
var _rehabilitationFemaleAnklesWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-ankles.webp");
var _rehabilitationFemaleAnklesWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleAnklesWebp);
var _rehabilitationFemaleCoreWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-core.webp");
var _rehabilitationFemaleCoreWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleCoreWebp);
var _rehabilitationFemaleElbowWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-elbow.webp");
var _rehabilitationFemaleElbowWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleElbowWebp);
// import RehabilitationFemaleFullBodyIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-full-body.webp';
var _rehabilitationFemaleHamstringsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-hamstrings.webp");
var _rehabilitationFemaleHamstringsWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleHamstringsWebp);
var _rehabilitationFemaleHipsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-hips.webp");
var _rehabilitationFemaleHipsWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleHipsWebp);
var _rehabilitationFemaleKneesWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-knees.webp");
var _rehabilitationFemaleKneesWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleKneesWebp);
var _rehabilitationFemaleNeckWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-neck.webp");
var _rehabilitationFemaleNeckWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleNeckWebp);
var _rehabilitationFemaleShouldersWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-shoulders.webp");
var _rehabilitationFemaleShouldersWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleShouldersWebp);
var _rehabilitationFemaleSpineBackWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-spine-back.webp");
var _rehabilitationFemaleSpineBackWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleSpineBackWebp);
var _rehabilitationFemaleWristsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-wrists.webp");
var _rehabilitationFemaleWristsWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleWristsWebp);
const InjuryPreventionStep1 = ({ value = [], clientBodyProfile = 'Male', onChange })=>{
    const isFemale = (0, _genderUtils.isFemaleProfile)(clientBodyProfile);
    const iconMap = {
        shoulders: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleShouldersWebpDefault.default),
            alt: "RehabilitationFemaleShouldersIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleShouldersWebpDefault.default),
            alt: "RehabilitationMaleShouldersIcon",
            className: "program-svg-icon"
        }),
        spine_back: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleSpineBackWebpDefault.default),
            alt: "RehabilitationFemaleSpineBackIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleSpineBackWebpDefault.default),
            alt: "RehabilitationMaleSpineBackIcon",
            className: "program-svg-icon"
        }),
        hips: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleHipsWebpDefault.default),
            alt: "RehabilitationFemaleHipsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleHipsWebpDefault.default),
            alt: "RehabilitationMaleHipsIcon",
            className: "program-svg-icon"
        }),
        knees: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleKneesWebpDefault.default),
            alt: "RehabilitationFemaleKneesIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleKneesWebpDefault.default),
            alt: "RehabilitationMaleKneesIcon",
            className: "program-svg-icon"
        }),
        ankles: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleAnklesWebpDefault.default),
            alt: "RehabilitationFemaleAnklesIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleAnklesWebpDefault.default),
            alt: "RehabilitationMaleAnklesIcon",
            className: "program-svg-icon"
        }),
        wrists: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleWristsWebpDefault.default),
            alt: "RehabilitationFemaleWristsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleWristsWebpDefault.default),
            alt: "RehabilitationMaleWristsIcon",
            className: "program-svg-icon"
        }),
        elbow: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleElbowWebpDefault.default),
            alt: "RehabilitationFemaleElbowIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleElbowWebpDefault.default),
            alt: "RehabilitationMaleElbowIcon",
            className: "program-svg-icon"
        }),
        neck: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleNeckWebpDefault.default),
            alt: "RehabilitationFemaleNeckIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleNeckWebpDefault.default),
            alt: "RehabilitationMaleNeckIcon",
            className: "program-svg-icon"
        }),
        core: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleCoreWebpDefault.default),
            alt: "RehabilitationFemaleCoreIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleCoreWebpDefault.default),
            alt: "RehabilitationMaleCoreIcon",
            className: "program-svg-icon"
        }),
        hamstrings: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleHamstringsWebpDefault.default),
            alt: "RehabilitationFemaleHamstringsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleHamstringsWebpDefault.default),
            alt: "RehabilitationMaleHamstringsIcon",
            className: "program-svg-icon"
        })
    };
    const [selectedArea, setSelectedArea] = (0, _react.useState)(value);
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalDetails?.groups?.find((g)=>g.goalId === 'injury_prevention');
    const areas = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-cards-grid",
                children: areas.map((area)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `goal-card ${selectedArea.includes(area.slug) ? 'selected' : ''}`,
                        onClick: ()=>{
                            let nextValue = [
                                ...selectedArea
                            ];
                            if (nextValue.includes(area.slug)) nextValue = nextValue.filter((p)=>p !== area.slug);
                            else nextValue.push(area.slug);
                            setSelectedArea(nextValue);
                            if (onChange) onChange(nextValue);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-image",
                                children: iconMap[area.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: area.title
                            })
                        ]
                    }, area.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","src/utils/genderUtils":"aiA54","./IncreaseStrengthSteps.scss":"lcYno","url:src/assets/images/trainer/program-generator/rehabilitation-male-ankles.webp":"2TH0O","url:src/assets/images/trainer/program-generator/rehabilitation-male-core.webp":"cUYGf","url:src/assets/images/trainer/program-generator/rehabilitation-male-elbow.webp":"819Df","url:src/assets/images/trainer/program-generator/rehabilitation-male-hamstrings.webp":"hK1AR","url:src/assets/images/trainer/program-generator/rehabilitation-male-hips.webp":"1b122","url:src/assets/images/trainer/program-generator/rehabilitation-male-knees.webp":"8kON7","url:src/assets/images/trainer/program-generator/rehabilitation-male-neck.webp":"29dTk","url:src/assets/images/trainer/program-generator/rehabilitation-male-shoulders.webp":"iiTgT","url:src/assets/images/trainer/program-generator/rehabilitation-male-spine-back.webp":"5vCwk","url:src/assets/images/trainer/program-generator/rehabilitation-male-wrists.webp":"3GfGl","url:src/assets/images/trainer/program-generator/rehabilitation-female-ankles.webp":"u6Vbf","url:src/assets/images/trainer/program-generator/rehabilitation-female-core.webp":"5vaB3","url:src/assets/images/trainer/program-generator/rehabilitation-female-elbow.webp":"fVhZy","url:src/assets/images/trainer/program-generator/rehabilitation-female-hamstrings.webp":"eFiaG","url:src/assets/images/trainer/program-generator/rehabilitation-female-hips.webp":"4azxd","url:src/assets/images/trainer/program-generator/rehabilitation-female-knees.webp":"77UkI","url:src/assets/images/trainer/program-generator/rehabilitation-female-neck.webp":"gClki","url:src/assets/images/trainer/program-generator/rehabilitation-female-shoulders.webp":"egsrs","url:src/assets/images/trainer/program-generator/rehabilitation-female-spine-back.webp":"gcDGe","url:src/assets/images/trainer/program-generator/rehabilitation-female-wrists.webp":"aXYdT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"2TH0O":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("1uv1f");

},{}],"cUYGf":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("du7B9");

},{}],"819Df":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2KEcD");

},{}],"hK1AR":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("80mtv");

},{}],"1b122":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8Uu3M");

},{}],"8kON7":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dAgWx");

},{}],"29dTk":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cgR2Q");

},{}],"iiTgT":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("c60jn");

},{}],"5vCwk":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("l0dg9");

},{}],"3GfGl":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kZcYY");

},{}],"u6Vbf":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("heDRt");

},{}],"5vaB3":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("hJcmo");

},{}],"fVhZy":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gm6hh");

},{}],"eFiaG":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3pJ0w");

},{}],"4azxd":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4bMWD");

},{}],"77UkI":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("gYMqa");

},{}],"gClki":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("eItmh");

},{}],"egsrs":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("41to3");

},{}],"gcDGe":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dJfD2");

},{}],"aXYdT":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("a3EZl");

},{}],"4n38l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InjuryPreventionStep2", ()=>InjuryPreventionStep2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _strengthenWeakAreasSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strengthen_weak_areas.svg");
var _reduceOverloadRiskSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/reduce_overload_risk.svg");
var _improveStabilitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_stability.svg");
var _improveTechniqueSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_technique.svg");
var _improveMobilitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_mobility.svg");
const iconMap = {
    improve_stability: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _improveStabilitySvg.ReactComponent), {}),
    improve_mobility: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _improveMobilitySvg.ReactComponent), {}),
    strengthen_weak_areas: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _strengthenWeakAreasSvg.ReactComponent), {}),
    improve_technique: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _improveTechniqueSvg.ReactComponent), {}),
    reduce_overload_risk: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reduceOverloadRiskSvg.ReactComponent), {})
};
const InjuryPreventionStep2 = ({ value, onNext })=>{
    const [selectedFocus, setSelectedFocus] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalPreferences?.groups?.find((g)=>g.goalId === 'injury_prevention');
    const focuses = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: focuses.map((focus)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedFocus === focus.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedFocus(focus.slug);
                            if (onNext) onNext(focus.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[focus.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: focus.title
                            })
                        ]
                    }, focus.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strengthen_weak_areas.svg":"cR5Bs","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/reduce_overload_risk.svg":"55wq5","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_stability.svg":"hW3Wb","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_technique.svg":"c3h9m","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_mobility.svg":"cvjwn","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"cR5Bs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgStrengthenWeakAreas);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgStrengthenWeakAreas = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.875,
            d: "m23.5 10.938-6.393 6.393c-.322.322-.483.482-.668.543a.8.8 0 0 1-.503 0c-.185-.06-.346-.221-.668-.543l-2.224-2.224c-.322-.322-.482-.483-.668-.543a.8.8 0 0 0-.502 0c-.186.06-.347.221-.668.543L7.25 19.063m16.25-2.438v-5.687h-5.687"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"55wq5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReduceOverloadRisk);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReduceOverloadRisk = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M19.144 15.994v6.637a1.48 1.48 0 0 0 1.481 1.482h1.763a1.48 1.48 0 0 0 1.481-1.482v-6.637a1.49 1.49 0 0 0-1.481-1.49h-1.763a1.49 1.49 0 0 0-1.48 1.49m-6.506-4.303v10.968a1.49 1.49 0 0 0 1.49 1.482h1.754a1.49 1.49 0 0 0 1.49-1.482V11.691a1.49 1.49 0 0 0-1.49-1.491H14.13a1.49 1.49 0 0 0-1.491 1.49M6.132 7.35v15.31a1.49 1.49 0 0 0 1.49 1.48h1.753a1.49 1.49 0 0 0 1.491-1.48V7.35a1.49 1.49 0 0 0-1.49-1.49H7.621a1.49 1.49 0 0 0-1.49 1.49"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hW3Wb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgImproveStability);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgImproveStability = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m10.42 23.47 2.966-6.779v-3.945S8.965 9.744 12.8 5.509a.797.797 0 0 1 1.131-.05l.027.027.003.004c.305.309.309.8.012 1.112-.777.83-1.843 2.54.228 4.365.206.179.45.312.716.385l.11.026c.233.057.473.057.702 0l.11-.026c.263-.073.51-.202.716-.385 2.072-1.82 1.006-3.534.229-4.365a.8.8 0 0 1 .015-1.112l.004-.004a.79.79 0 0 1 1.123-.003l.027.026c3.835 4.232-.587 7.237-.587 7.237v3.941l2.967 6.78a.915.915 0 0 1-.468 1.203c-.012.004-.023.012-.034.015a.913.913 0 0 1-1.158-.453L15.375 17.5l-3.295 6.737a.915.915 0 0 1-1.676-.731q.005-.018.015-.034"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M15.375 10.704c-.93 0-1.683-.808-1.683-1.805s.753-1.805 1.683-1.805 1.684.808 1.684 1.805-.754 1.805-1.684 1.805"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"c3h9m":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgImproveTechnique);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgImproveTechnique = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M15.008 17.485a2.483 2.483 0 0 0 1.753-4.247.706.706 0 0 0-.994 1.003 1.06 1.06 0 0 1 .319.76 1.07 1.07 0 0 1-1.875.758.713.713 0 0 0-1.003 0 .72.72 0 0 0 0 1.004 2.5 2.5 0 0 0 1.8.721"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M5.398 15a9.61 9.61 0 1 0 9.61-9.61.703.703 0 0 0-.703.704v3.562a.71.71 0 0 0 .703.703 4.56 4.56 0 0 1 2.578.778 4.62 4.62 0 0 1 1.978 4.763 4.687 4.687 0 0 1-9.197-.937.695.695 0 0 0-.703-.704H6.102a.703.703 0 0 0-.704.741"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M5.737 9.496a1 1 0 0 0 .215.497l2.035 2.034c.289.291.647.504 1.04.62.23.07.471.105.713.102q.248.023.496 0l1.247-.243 2.138 2.146a.75.75 0 0 0 .497.207.7.7 0 0 0 .497-.207.693.693 0 0 0 0-.993l-2.147-2.157.253-1.237c.075-.399.056-.81-.056-1.2a2.44 2.44 0 0 0-.62-1.04L10.03 6.008a.94.94 0 0 0-.497-.235.84.84 0 0 0-.506.085.94.94 0 0 0-.375.347.94.94 0 0 0-.112.543l.3 2.12-2.11-.292a.88.88 0 0 0-.872.479.94.94 0 0 0-.121.44"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cvjwn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgImproveMobility);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgImproveMobility = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M11.228 13.202c1.139-.83 2.045-1.942 2.552-3.256.583-1.497.765-3.005.822-3.854a.903.903 0 1 1 1.806.068c-.02 3.756-1.775 6.65-1.775 6.65l7.415 10.344a.997.997 0 0 1-1.588 1.207l-4.677-5.804-2.635 2.042-1.021 3.416a1.025 1.025 0 0 1-1.985-.507c.877-4.22 2.693-5.568 2.693-5.568l-1.363-1.546a16 16 0 0 0-.865 4.262.827.827 0 0 1-1.645.046q-.005-.035-.004-.077c-.133-4.943 1.383-6.775 2.27-7.423"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9.202 11.913c-.79-.676-.917-1.824-.284-2.564s1.786-.792 2.576-.117c.79.676.917 1.823.284 2.563s-1.787.793-2.576.117"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cM1aO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InjuryPreventionStep3", ()=>InjuryPreventionStep3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _techniqueFocusedTrainingSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/technique_focused_training.svg");
var _stabilityTrainingSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/stability_training.svg");
var _mobilityControlSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility_control.svg");
var _prehabSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/prehab.svg");
const iconMap = {
    stability_training: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _stabilityTrainingSvg.ReactComponent), {}),
    mobility_control: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobilityControlSvg.ReactComponent), {}),
    prehab: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _prehabSvg.ReactComponent), {}),
    technique_focused_training: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _techniqueFocusedTrainingSvg.ReactComponent), {})
};
const InjuryPreventionStep3 = ({ value, onNext })=>{
    const [selectedApproach, setSelectedApproach] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalApproaches?.groups?.find((g)=>g.goalId === 'injury_prevention');
    const approaches = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: groupData?.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: approaches.map((approach)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedApproach(approach.slug);
                            if (onNext) onNext(approach.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[approach.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: approach.title
                            })
                        ]
                    }, approach.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/technique_focused_training.svg":"95EYs","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/stability_training.svg":"6WRdE","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility_control.svg":"jdiOe","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/prehab.svg":"atsnJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"95EYs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgTechniqueFocusedTraining);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTechniqueFocusedTraining = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M15.382 17.153a2.153 2.153 0 0 0 1.52-3.68.611.611 0 1 0-.862.868.92.92 0 0 1 .276.659.926.926 0 0 1-1.625.658.617.617 0 0 0-.869 0 .626.626 0 0 0 0 .87 2.17 2.17 0 0 0 1.56.625"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M7.053 15a8.328 8.328 0 1 0 8.328-8.328.61.61 0 0 0-.61.61v3.087a.617.617 0 0 0 .61.61 3.95 3.95 0 0 1 2.234.674 4.01 4.01 0 0 1 1.715 4.127 4.063 4.063 0 0 1-7.971-.812.6.6 0 0 0-.61-.61H7.663a.61.61 0 0 0-.61.642"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M7.347 10.231a.86.86 0 0 0 .186.43l1.764 1.764c.25.252.56.436.901.536.2.062.409.092.618.09q.215.018.43 0l1.081-.212L14.18 14.7a.65.65 0 0 0 .43.179.6.6 0 0 0 .431-.179.6.6 0 0 0 0-.861l-1.86-1.869.219-1.072a2.24 2.24 0 0 0-.049-1.04 2.1 2.1 0 0 0-.536-.902l-1.747-1.747a.8.8 0 0 0-.43-.203.73.73 0 0 0-.44.073.8.8 0 0 0-.324.3.8.8 0 0 0-.098.472l.26 1.836-1.828-.252a.76.76 0 0 0-.756.414.8.8 0 0 0-.105.382"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6WRdE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgStabilityTraining);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgStabilityTraining = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M24.9 15.399H4.6a.64.64 0 0 0-.631.65.64.64 0 0 0 .631.648h9.034l-3.216 5.507c-.252.433.052.983.542.983h7.58c.49 0 .795-.549.542-.983l-3.216-5.507H24.9a.64.64 0 0 0 .631-.649.64.64 0 0 0-.631-.649M7.759 14.101c2.093 0 3.79-1.744 3.79-3.894S9.852 6.312 7.76 6.312s-3.79 1.744-3.79 3.895S5.666 14.1 7.759 14.1m13.982.001c2.093 0 3.79-1.744 3.79-3.894s-1.697-3.895-3.79-3.895-3.79 1.744-3.79 3.895 1.697 3.894 3.79 3.894"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jdiOe":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMobilityControl);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMobilityControl = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m10.42 23.47 2.966-6.779v-3.945S8.965 9.744 12.8 5.509a.797.797 0 0 1 1.131-.05l.027.027.003.004c.305.309.309.8.012 1.112-.777.83-1.843 2.54.228 4.365.206.179.45.312.716.385l.11.026c.233.057.473.057.702 0l.11-.026c.263-.073.51-.202.716-.385 2.072-1.82 1.006-3.534.229-4.365a.8.8 0 0 1 .015-1.112l.004-.004a.79.79 0 0 1 1.123-.003l.027.026c3.835 4.232-.587 7.237-.587 7.237v3.941l2.967 6.78a.915.915 0 0 1-.468 1.203c-.012.004-.023.012-.034.015a.913.913 0 0 1-1.158-.453L15.375 17.5l-3.295 6.737a.915.915 0 0 1-1.676-.731q.005-.018.015-.034"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M15.375 10.704c-.93 0-1.683-.808-1.683-1.805s.753-1.805 1.683-1.805 1.684.808 1.684 1.805-.754 1.805-1.684 1.805"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"atsnJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPrehab);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPrehab = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M15.001 7.305q-.286 0-.572.097L9.525 9.16a1.7 1.7 0 0 0-.766.567q-.297.39-.295.878v3.692q0 2.734 1.634 5.107 1.635 2.374 4.392 3.252a1.7 1.7 0 0 0 1.02 0q2.76-.879 4.393-3.253t1.634-5.106v-3.692q0-.488-.296-.878a1.7 1.7 0 0 0-.765-.567l-4.904-1.758a1.8 1.8 0 0 0-.571-.097M15 12.285a.57.57 0 0 1 .571.57v1.592h1.592a.572.572 0 0 1 0 1.144h-1.592v1.593a.571.571 0 0 1-1.141 0V15.59h-1.592a.572.572 0 0 1 0-1.144h1.592v-1.591a.57.57 0 0 1 .57-.57",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cGpRm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RehabilitationStep1", ()=>RehabilitationStep1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _genderUtils = require("src/utils/genderUtils");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
var _rehabilitationMaleAnklesWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-ankles.webp");
var _rehabilitationMaleAnklesWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleAnklesWebp);
var _rehabilitationMaleCoreWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-core.webp");
var _rehabilitationMaleCoreWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleCoreWebp);
var _rehabilitationMaleElbowWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-elbow.webp");
var _rehabilitationMaleElbowWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleElbowWebp);
// import RehabilitationMaleFullBodyIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-full-body.webp';
var _rehabilitationMaleHamstringsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-hamstrings.webp");
var _rehabilitationMaleHamstringsWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleHamstringsWebp);
var _rehabilitationMaleHipsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-hips.webp");
var _rehabilitationMaleHipsWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleHipsWebp);
var _rehabilitationMaleKneesWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-knees.webp");
var _rehabilitationMaleKneesWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleKneesWebp);
var _rehabilitationMaleNeckWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-neck.webp");
var _rehabilitationMaleNeckWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleNeckWebp);
var _rehabilitationMaleShouldersWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-shoulders.webp");
var _rehabilitationMaleShouldersWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleShouldersWebp);
var _rehabilitationMaleSpineBackWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-spine-back.webp");
var _rehabilitationMaleSpineBackWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleSpineBackWebp);
var _rehabilitationMaleWristsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-wrists.webp");
var _rehabilitationMaleWristsWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleWristsWebp);
var _rehabilitationFemaleAnklesWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-ankles.webp");
var _rehabilitationFemaleAnklesWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleAnklesWebp);
var _rehabilitationFemaleCoreWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-core.webp");
var _rehabilitationFemaleCoreWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleCoreWebp);
var _rehabilitationFemaleElbowWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-elbow.webp");
var _rehabilitationFemaleElbowWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleElbowWebp);
// import RehabilitationFemaleFullBodyIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-full-body.webp';
var _rehabilitationFemaleHamstringsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-hamstrings.webp");
var _rehabilitationFemaleHamstringsWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleHamstringsWebp);
var _rehabilitationFemaleHipsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-hips.webp");
var _rehabilitationFemaleHipsWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleHipsWebp);
var _rehabilitationFemaleKneesWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-knees.webp");
var _rehabilitationFemaleKneesWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleKneesWebp);
var _rehabilitationFemaleNeckWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-neck.webp");
var _rehabilitationFemaleNeckWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleNeckWebp);
var _rehabilitationFemaleShouldersWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-shoulders.webp");
var _rehabilitationFemaleShouldersWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleShouldersWebp);
var _rehabilitationFemaleSpineBackWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-spine-back.webp");
var _rehabilitationFemaleSpineBackWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleSpineBackWebp);
var _rehabilitationFemaleWristsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-wrists.webp");
var _rehabilitationFemaleWristsWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleWristsWebp);
const RehabilitationStep1 = ({ value = [], clientBodyProfile = 'Male', onChange })=>{
    const isFemale = (0, _genderUtils.isFemaleProfile)(clientBodyProfile);
    const iconMap = {
        shoulders: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleShouldersWebpDefault.default),
            alt: "RehabilitationFemaleShouldersIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleShouldersWebpDefault.default),
            alt: "RehabilitationMaleShouldersIcon",
            className: "program-svg-icon"
        }),
        spine_back: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleSpineBackWebpDefault.default),
            alt: "RehabilitationFemaleSpineBackIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleSpineBackWebpDefault.default),
            alt: "RehabilitationMaleSpineBackIcon",
            className: "program-svg-icon"
        }),
        hips: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleHipsWebpDefault.default),
            alt: "RehabilitationFemaleHipsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleHipsWebpDefault.default),
            alt: "RehabilitationMaleHipsIcon",
            className: "program-svg-icon"
        }),
        knees: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleKneesWebpDefault.default),
            alt: "RehabilitationFemaleKneesIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleKneesWebpDefault.default),
            alt: "RehabilitationMaleKneesIcon",
            className: "program-svg-icon"
        }),
        ankles: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleAnklesWebpDefault.default),
            alt: "RehabilitationFemaleAnklesIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleAnklesWebpDefault.default),
            alt: "RehabilitationMaleAnklesIcon",
            className: "program-svg-icon"
        }),
        wrists: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleWristsWebpDefault.default),
            alt: "RehabilitationFemaleWristsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleWristsWebpDefault.default),
            alt: "RehabilitationMaleWristsIcon",
            className: "program-svg-icon"
        }),
        elbow: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleElbowWebpDefault.default),
            alt: "RehabilitationFemaleElbowIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleElbowWebpDefault.default),
            alt: "RehabilitationMaleElbowIcon",
            className: "program-svg-icon"
        }),
        neck: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleNeckWebpDefault.default),
            alt: "RehabilitationFemaleNeckIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleNeckWebpDefault.default),
            alt: "RehabilitationMaleNeckIcon",
            className: "program-svg-icon"
        }),
        core: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleCoreWebpDefault.default),
            alt: "RehabilitationFemaleCoreIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleCoreWebpDefault.default),
            alt: "RehabilitationMaleCoreIcon",
            className: "program-svg-icon"
        }),
        hamstrings: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleHamstringsWebpDefault.default),
            alt: "RehabilitationFemaleHamstringsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleHamstringsWebpDefault.default),
            alt: "RehabilitationMaleHamstringsIcon",
            className: "program-svg-icon"
        })
    };
    const [selectedArea, setSelectedArea] = (0, _react.useState)(value);
    const [otherText, setOtherText] = (0, _react.useState)(()=>{
        const otherVal = value.find((v)=>v.startsWith('other:'));
        return otherVal ? otherVal.replace('other:', '') : '';
    });
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalDetails?.groups?.find((g)=>g.goalId === 'rehabilitation');
    const handleSelectArea = (slug)=>{
        let nextValue = [
            ...selectedArea
        ];
        if (slug === 'other') {
            const otherPrefix = 'other:';
            const existingOther = nextValue.find((v)=>v.startsWith(otherPrefix));
            if (existingOther) nextValue = nextValue.filter((v)=>!v.startsWith(otherPrefix));
            else nextValue.push(otherPrefix + otherText);
        } else if (nextValue.includes(slug)) nextValue = nextValue.filter((p)=>p !== slug);
        else nextValue.push(slug);
        setSelectedArea(nextValue);
        if (onChange) onChange(nextValue);
    };
    const areas = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-cards-grid",
                children: areas.map((area)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `goal-card ${selectedArea.includes(area.slug) ? 'selected' : ''}`,
                        onClick: ()=>handleSelectArea(area.slug),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-image",
                                children: iconMap[area.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: area.title
                            })
                        ]
                    }, area.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `goal-buttons ${selectedArea.some((v)=>v.startsWith('other:')) ? `other-selected` : ``}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: `goal-btn ${selectedArea.some((v)=>v.startsWith('other:')) ? 'selected' : ''}`,
                    onClick: ()=>handleSelectArea('other'),
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "goal-label",
                        children: "Other"
                    })
                })
            }),
            selectedArea.some((v)=>v.startsWith('other:')) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "auth-form-common",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "input-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            children: "Please specify what is the rehabilitation focus?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                            className: `notes-input ${otherText.trim() !== '' && !/\p{L}/u.test(otherText) ? 'error-border' : ''}`,
                            placeholder: "Type..",
                            maxLength: 1000,
                            value: otherText,
                            onChange: (e)=>{
                                const text = e.target.value;
                                setOtherText(text);
                                let nextValue = [
                                    ...selectedArea
                                ];
                                const otherPrefix = 'other:';
                                nextValue = nextValue.filter((v)=>!v.startsWith(otherPrefix));
                                if (text || selectedArea.some((v)=>v === 'other:')) nextValue.push(otherPrefix + text);
                                setSelectedArea(nextValue);
                                if (onChange) onChange(nextValue);
                            }
                        }),
                        otherText.trim() !== '' && !/\p{L}/u.test(otherText) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "error-message",
                            children: "Focus must contain at least one valid letter."
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("small", {
                            style: {
                                display: 'block',
                                textAlign: 'right',
                                color: '#a0a0ab',
                                fontSize: '12px',
                                marginTop: '4px'
                            },
                            children: [
                                otherText.length,
                                "/1000"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","src/utils/genderUtils":"aiA54","./IncreaseStrengthSteps.scss":"lcYno","url:src/assets/images/trainer/program-generator/rehabilitation-male-ankles.webp":"2TH0O","url:src/assets/images/trainer/program-generator/rehabilitation-male-core.webp":"cUYGf","url:src/assets/images/trainer/program-generator/rehabilitation-male-elbow.webp":"819Df","url:src/assets/images/trainer/program-generator/rehabilitation-male-hamstrings.webp":"hK1AR","url:src/assets/images/trainer/program-generator/rehabilitation-male-hips.webp":"1b122","url:src/assets/images/trainer/program-generator/rehabilitation-male-knees.webp":"8kON7","url:src/assets/images/trainer/program-generator/rehabilitation-male-neck.webp":"29dTk","url:src/assets/images/trainer/program-generator/rehabilitation-male-shoulders.webp":"iiTgT","url:src/assets/images/trainer/program-generator/rehabilitation-male-spine-back.webp":"5vCwk","url:src/assets/images/trainer/program-generator/rehabilitation-male-wrists.webp":"3GfGl","url:src/assets/images/trainer/program-generator/rehabilitation-female-ankles.webp":"u6Vbf","url:src/assets/images/trainer/program-generator/rehabilitation-female-core.webp":"5vaB3","url:src/assets/images/trainer/program-generator/rehabilitation-female-elbow.webp":"fVhZy","url:src/assets/images/trainer/program-generator/rehabilitation-female-hamstrings.webp":"eFiaG","url:src/assets/images/trainer/program-generator/rehabilitation-female-hips.webp":"4azxd","url:src/assets/images/trainer/program-generator/rehabilitation-female-knees.webp":"77UkI","url:src/assets/images/trainer/program-generator/rehabilitation-female-neck.webp":"gClki","url:src/assets/images/trainer/program-generator/rehabilitation-female-shoulders.webp":"egsrs","url:src/assets/images/trainer/program-generator/rehabilitation-female-spine-back.webp":"gcDGe","url:src/assets/images/trainer/program-generator/rehabilitation-female-wrists.webp":"aXYdT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"9bf29":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RehabilitationStep2", ()=>RehabilitationStep2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
var _lowImpactTrainingOnlySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_impact_training_only.svg");
var _returnToMovementSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_movement.svg");
var _returnToStrengthSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_strength.svg");
var _returnToSportSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_sport.svg");
const iconMap = {
    return_to_movement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _returnToMovementSvg.ReactComponent), {}),
    return_to_strength: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _returnToStrengthSvg.ReactComponent), {}),
    return_to_sport: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _returnToSportSvg.ReactComponent), {}),
    low_impact_training_only: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lowImpactTrainingOnlySvg.ReactComponent), {})
};
const RehabilitationStep2 = ({ value, onNext })=>{
    const [selectedStage, setSelectedStage] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const stageData = programMasterData?.rehabilitationStage;
    const stages = stageData?.options ? [
        ...stageData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !stageData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: stageData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: stages.map((stage)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedStage === stage.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedStage(stage.slug);
                            if (onNext) onNext(stage.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[stage.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: stage.title
                            })
                        ]
                    }, stage.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_impact_training_only.svg":"fIvrV","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_movement.svg":"hzXWp","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_strength.svg":"df7h0","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_sport.svg":"3OyPk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"fIvrV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLowImpactTrainingOnly);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLowImpactTrainingOnly = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M19.144 15.994v6.637a1.48 1.48 0 0 0 1.481 1.482h1.763a1.48 1.48 0 0 0 1.481-1.482v-6.637a1.49 1.49 0 0 0-1.481-1.49h-1.763a1.49 1.49 0 0 0-1.48 1.49m-6.506-4.303v10.968a1.49 1.49 0 0 0 1.49 1.482h1.754a1.49 1.49 0 0 0 1.49-1.482V11.691a1.49 1.49 0 0 0-1.49-1.491H14.13a1.49 1.49 0 0 0-1.491 1.49M6.132 7.35v15.31a1.49 1.49 0 0 0 1.49 1.48h1.753a1.49 1.49 0 0 0 1.491-1.48V7.35a1.49 1.49 0 0 0-1.49-1.49H7.621a1.49 1.49 0 0 0-1.49 1.49"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hzXWp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReturnToMovement);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReturnToMovement = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M11.228 13.202c1.139-.83 2.045-1.942 2.552-3.256.583-1.497.765-3.005.822-3.854a.903.903 0 1 1 1.806.068c-.02 3.756-1.775 6.65-1.775 6.65l7.415 10.344a.997.997 0 0 1-1.588 1.207l-4.677-5.804-2.635 2.042-1.021 3.416a1.025 1.025 0 0 1-1.985-.507c.877-4.22 2.693-5.568 2.693-5.568l-1.363-1.546a16 16 0 0 0-.865 4.262.827.827 0 0 1-1.645.046q-.005-.035-.004-.077c-.133-4.943 1.383-6.775 2.27-7.423"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9.202 11.913c-.79-.676-.917-1.824-.284-2.564s1.786-.792 2.576-.117c.79.676.917 1.823.284 2.563s-1.787.793-2.576.117"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"df7h0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReturnToStrength);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReturnToStrength = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M26.133 17.51a.2.2 0 0 1-.032-.063c-.023-.07-2.383-7.063-8.058-9.76a2.8 2.8 0 0 1-1.01-.99c-.016-.032-.266-.47-1.107-.59a4 4 0 0 1 .149.455q.028.097.05.196.031.148.052.3c.01.058.022.116.027.175q.027.24.028.487-.002.692-.204 1.331c.496.065.943.326 1.23.737.596.85.987 2.141 1.163 3.84.001.033.024 1.166.588 2.175.35.378.694.818 1.021 1.348a.244.244 0 1 1-.416.257c-2.17-3.505-5.008-3.18-6.507-2.674a2.38 2.38 0 0 1-1.902-.148c-2.988-1.639-5.645.06-6.397.627 0 0-.035 5.6-.273 9.3l3.389 1.72c.339-.172 1.458-.823 1.855-2.103.092-.294.16-.561.221-.797.164-.633.281-1.09.66-1.276.278-.136.627-.096 1.166.135.15.064.3.127.454.178l.972.322c.192.064.355.108.513.139 2.335.462 4.86.153 6.753-.825 1.778-.915 2.769-1.323 3.287-1.504a4.75 4.75 0 0 0 1.808-1.104c.722-.712.896-1.345.52-1.887m-2.134.178c-.167.766-.774 1.416-1.806 1.932a.243.243 0 0 1-.328-.11.244.244 0 0 1 .11-.327c.89-.446 1.41-.982 1.546-1.595.173-.783-.352-1.455-.357-1.462a.244.244 0 0 1 .381-.306c.027.035.675.853.454 1.868"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M8.26 9.665c.015.025.025.053.04.078.074.129.162.247.25.365.032.043.059.09.092.132.072.088.153.167.23.248.06.061.114.128.177.185.057.053.121.096.182.145.092.075.182.153.28.22.038.025.08.044.12.068.126.079.253.158.388.222l.076.03c.153.069.309.133.47.183.037.011.077.016.115.026.152.042.305.081.463.105a4 4 0 0 0 1.207 0c.158-.024.31-.063.462-.105.038-.01.078-.014.116-.026.163-.05.321-.115.476-.186.023-.01.047-.016.07-.027.14-.067.274-.148.405-.23.034-.022.07-.038.102-.06.105-.07.201-.154.3-.234.053-.044.11-.082.162-.13.069-.062.128-.134.192-.201.072-.077.149-.149.215-.232.037-.046.068-.098.103-.146.083-.114.168-.226.24-.35l.042-.084a3.9 3.9 0 0 0 .484-2.374q-.01-.08-.024-.16a4 4 0 0 0-.046-.263q-.02-.09-.046-.177a4 4 0 0 0-.133-.407 4 4 0 0 0-.104-.241q-.034-.072-.07-.143a4 4 0 0 0-.245-.416l-.077-.103a4 4 0 0 0-.355-.424 4 4 0 0 0-.471-.414q-.105-.08-.212-.151a4 4 0 0 0-.434-.245q-.091-.047-.185-.089a4 4 0 0 0-.418-.15q-.076-.022-.153-.04a4 4 0 0 0-.347-.073q-.075-.014-.152-.024a4 4 0 0 0-.5-.035c-.17 0-.336.015-.5.035q-.077.01-.152.024-.176.029-.348.073-.077.018-.152.04a4 4 0 0 0-.419.15c-.063.027-.124.06-.186.09a4 4 0 0 0-.912.616q-.105.092-.203.193a4 4 0 0 0-.354.422l-.08.106a4.2 4.2 0 0 0-.48.97 4 4 0 0 0-.07.232q-.025.09-.047.182a4 4 0 0 0-.045.26q-.014.08-.025.161a3.9 3.9 0 0 0 .487 2.378m3.052-3.93.044-.008q.187-.038.385-.04.197.002.384.04l.045.009a2.04 2.04 0 0 1 1.608 1.984c0 .843-.514 1.569-1.245 1.88l-.009.004q-.166.068-.347.108-.024.006-.05.01a2 2 0 0 1-.386.04q-.199-.001-.387-.04l-.05-.01a2 2 0 0 1-.347-.108L10.95 9.6a2.05 2.05 0 0 1-1.245-1.88c0-.972.69-1.785 1.608-1.984"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3OyPk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReturnToSport);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReturnToSport = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "#E5E5E5",
                    clipPath: "url(#b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "m16.976 14.275-1.188-6.547c-.179-1.37 1.437-1.728 2.157-.921l3.282 3.284a.8.8 0 0 0-.25.18zm-5.758 5.763a.75.75 0 0 1-.517.212H8.456a22.5 22.5 0 0 0 2.68-5.344c.294.299 1.018 1.01 1.319 1.318a.305.305 0 0 0 .431-.431l-1.537-1.534q.292-.928.498-1.884l2.23 2.227a.302.302 0 0 0 .428-.429c-.372-.371-2.182-2.183-2.512-2.515.112-.602.2-1.213.264-1.823a1.265 1.265 0 0 1 2.14-.754l.91.912a.6.6 0 0 0 .304.16c.033.204.78 4.297.842 4.646z"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M8.375 20.857h2.328c.354-.001.694-.142.945-.392L17.11 15l4.08-4.084c.205-.221.428-.468.696-.164l.963.963a.78.78 0 0 1 0 1.103l-9.926 9.933a2.1 2.1 0 0 1-1.504.623H8.852a1.26 1.26 0 0 1-1.257-1.258v-.477a.78.78 0 0 1 .78-.781m5.39 1.908h8.93a.305.305 0 0 1 .216.519.3.3 0 0 1-.216.088h-9.558c.138-.105.503-.483.628-.607m8.929-1.303H16.55a.304.304 0 0 1 0-.608h6.144a.304.304 0 0 1 0 .608m-3.818-2.516h3.818a.304.304 0 0 1 0 .608h-3.818a.304.304 0 0 1 0-.608"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M25.125 5.25h-19.5v19.5h19.5z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M24.963 5.25H5.707v19.256h19.256z"
                        })
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kuOZW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RehabilitationStep3", ()=>RehabilitationStep3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
var _lowImpactStrengtheningRehabilitationSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_impact_strengthening_rehabilitation.svg");
var _returnToMovementRehabilitationSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_movement_rehabilitation.svg");
var _returnToStrengthRehabilitationSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_strength_rehabilitation.svg");
var _mobilityStabilityRehabilitationSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility_stability_rehabilitation.svg");
const iconMap = {
    return_to_movement: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _returnToMovementRehabilitationSvg.ReactComponent), {}),
    return_to_strength: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _returnToStrengthRehabilitationSvg.ReactComponent), {}),
    mobility_stability: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobilityStabilityRehabilitationSvg.ReactComponent), {}),
    low_impact_strengthening: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lowImpactStrengtheningRehabilitationSvg.ReactComponent), {})
};
const RehabilitationStep3 = ({ value, onNext })=>{
    const [selectedApproach, setSelectedApproach] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalApproaches?.groups?.find((g)=>g.goalId === 'rehabilitation');
    const approaches = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: groupData?.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: approaches.map((approach)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedApproach(approach.slug);
                            if (onNext) onNext(approach.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[approach.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: approach.title
                            })
                        ]
                    }, approach.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_impact_strengthening_rehabilitation.svg":"h4gOA","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_movement_rehabilitation.svg":"k2qnx","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/return_to_strength_rehabilitation.svg":"jmdOK","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility_stability_rehabilitation.svg":"6bLlY","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"h4gOA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLowImpactStrengtheningRehabilitation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLowImpactStrengtheningRehabilitation = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M18.966 15.861v5.753a1.284 1.284 0 0 0 1.283 1.284h1.528a1.283 1.283 0 0 0 1.284-1.284V15.86a1.29 1.29 0 0 0-1.284-1.292h-1.528a1.29 1.29 0 0 0-1.283 1.292m-5.64-3.73v9.507a1.29 1.29 0 0 0 1.293 1.284h1.519a1.29 1.29 0 0 0 1.292-1.284v-9.506a1.29 1.29 0 0 0-1.292-1.292h-1.52a1.29 1.29 0 0 0-1.291 1.292M7.689 8.37v13.268a1.29 1.29 0 0 0 1.292 1.284h1.52a1.29 1.29 0 0 0 1.291-1.284V8.37A1.29 1.29 0 0 0 10.5 7.078H8.98A1.29 1.29 0 0 0 7.69 8.37"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k2qnx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReturnToMovementRehabilitation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReturnToMovementRehabilitation = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M10.768 13.518h1.697l1.185-1.185-.002-.005a1.745 1.745 0 1 1 1.703-.653h2.169a.87.87 0 0 1 .615.255l1.72 1.72a.87.87 0 1 1-1.231 1.23l-1.465-1.465h-1.255l1.237 4.807 1.607-.6a.87.87 0 0 1 .608 1.63l-2.523.942a.87.87 0 0 1-1.149-.608l-.373-1.517-3.416 3.416a.87.87 0 1 1-1.23-1.23l4.114-4.114-.466-2.01-.872.872a.87.87 0 0 1-.616.255h-2.057a.87.87 0 1 1 0-1.74M8.87 16.15a.567.567 0 0 1-.802 0 2.43 2.43 0 0 1 0-3.433.567.567 0 0 1 .801.801 1.296 1.296 0 0 0 0 1.831.567.567 0 0 1 0 .802"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M6.693 17.012a3.62 3.62 0 0 1-1.068-2.578c0-.974.379-1.89 1.068-2.578a.567.567 0 0 1 .801.801 2.5 2.5 0 0 0-.736 1.777 2.5 2.5 0 0 0 .736 1.777.567.567 0 1 1-.801.801m14.439-4.295a.567.567 0 0 1 .801 0 2.4 2.4 0 0 1 .712 1.717c0 .648-.253 1.258-.712 1.717a.567.567 0 0 1-.801-.802c.244-.244.379-.57.379-.915s-.135-.671-.38-.916a.567.567 0 0 1 0-.801"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M23.307 11.856a3.62 3.62 0 0 1 1.068 2.578c0 .974-.38 1.89-1.068 2.578a.567.567 0 1 1-.801-.802 2.5 2.5 0 0 0 .735-1.776c0-.671-.26-1.302-.735-1.777a.567.567 0 1 1 .801-.802"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M24.375 5.625H5.625v18.75h18.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jmdOK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReturnToStrengthRehabilitation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReturnToStrengthRehabilitation = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M24.9 15.399H4.6a.64.64 0 0 0-.631.65.64.64 0 0 0 .631.648h9.034l-3.216 5.507c-.252.433.052.983.542.983h7.58c.49 0 .795-.549.542-.983l-3.216-5.507H24.9a.64.64 0 0 0 .631-.649.64.64 0 0 0-.631-.649M7.759 14.101c2.093 0 3.79-1.744 3.79-3.894S9.852 6.312 7.76 6.312s-3.79 1.744-3.79 3.895S5.666 14.1 7.759 14.1m13.982.001c2.093 0 3.79-1.744 3.79-3.894s-1.697-3.895-3.79-3.895-3.79 1.744-3.79 3.895 1.697 3.894 3.79 3.894"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6bLlY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMobilityStabilityRehabilitation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMobilityStabilityRehabilitation = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m10.42 23.47 2.966-6.779v-3.945S8.965 9.744 12.8 5.509a.797.797 0 0 1 1.131-.05l.027.027.003.004c.305.309.309.8.012 1.112-.777.83-1.843 2.54.228 4.365.206.179.45.312.716.385l.11.026c.233.057.473.057.702 0l.11-.026c.263-.073.51-.202.716-.385 2.072-1.82 1.006-3.534.229-4.365a.8.8 0 0 1 .015-1.112l.004-.004a.79.79 0 0 1 1.123-.003l.027.026c3.835 4.232-.587 7.237-.587 7.237v3.941l2.967 6.78a.915.915 0 0 1-.468 1.203c-.012.004-.023.012-.034.015a.913.913 0 0 1-1.158-.453L15.375 17.5l-3.295 6.737a.915.915 0 0 1-1.676-.731q.005-.018.015-.034"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M15.375 10.704c-.93 0-1.683-.808-1.683-1.805s.753-1.805 1.683-1.805 1.684.808 1.684 1.805-.754 1.805-1.684 1.805"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Xcmi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobilityStep1", ()=>MobilityStep1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _genderUtils = require("src/utils/genderUtils");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _rehabilitationMaleAnklesWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-ankles.webp");
var _rehabilitationMaleAnklesWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleAnklesWebp);
// import RehabilitationMaleCoreIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-core.webp';
// import RehabilitationMaleElbowIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-male-elbow.webp';
var _rehabilitationMaleFullBodyWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-full-body.webp");
var _rehabilitationMaleFullBodyWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleFullBodyWebp);
var _rehabilitationMaleHamstringsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-hamstrings.webp");
var _rehabilitationMaleHamstringsWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleHamstringsWebp);
var _rehabilitationMaleHipsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-hips.webp");
var _rehabilitationMaleHipsWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleHipsWebp);
var _rehabilitationMaleKneesWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-knees.webp");
var _rehabilitationMaleKneesWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleKneesWebp);
var _rehabilitationMaleNeckWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-neck.webp");
var _rehabilitationMaleNeckWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleNeckWebp);
var _rehabilitationMaleShouldersWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-shoulders.webp");
var _rehabilitationMaleShouldersWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleShouldersWebp);
var _rehabilitationMaleSpineBackWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-spine-back.webp");
var _rehabilitationMaleSpineBackWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleSpineBackWebp);
var _rehabilitationMaleWristsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-male-wrists.webp");
var _rehabilitationMaleWristsWebpDefault = parcelHelpers.interopDefault(_rehabilitationMaleWristsWebp);
var _rehabilitationFemaleAnklesWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-ankles.webp");
var _rehabilitationFemaleAnklesWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleAnklesWebp);
// import RehabilitationFemaleCoreIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-core.webp';
// import RehabilitationFemaleElbowIcon from 'url:src/assets/images/trainer/program-generator/rehabilitation-female-elbow.webp';
var _rehabilitationFemaleFullBodyWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-full-body.webp");
var _rehabilitationFemaleFullBodyWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleFullBodyWebp);
var _rehabilitationFemaleHamstringsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-hamstrings.webp");
var _rehabilitationFemaleHamstringsWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleHamstringsWebp);
var _rehabilitationFemaleHipsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-hips.webp");
var _rehabilitationFemaleHipsWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleHipsWebp);
var _rehabilitationFemaleKneesWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-knees.webp");
var _rehabilitationFemaleKneesWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleKneesWebp);
var _rehabilitationFemaleNeckWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-neck.webp");
var _rehabilitationFemaleNeckWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleNeckWebp);
var _rehabilitationFemaleShouldersWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-shoulders.webp");
var _rehabilitationFemaleShouldersWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleShouldersWebp);
var _rehabilitationFemaleSpineBackWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-spine-back.webp");
var _rehabilitationFemaleSpineBackWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleSpineBackWebp);
var _rehabilitationFemaleWristsWebp = require("url:src/assets/images/trainer/program-generator/rehabilitation-female-wrists.webp");
var _rehabilitationFemaleWristsWebpDefault = parcelHelpers.interopDefault(_rehabilitationFemaleWristsWebp);
const MobilityStep1 = ({ value = [], clientBodyProfile = 'male', onChange })=>{
    // const genderKey = clientBodyProfile.toLowerCase() as 'male' | 'female';
    const [selectedArea, setSelectedArea] = (0, _react.useState)(value);
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const isFemale = (0, _genderUtils.isFemaleProfile)(clientBodyProfile);
    const iconMap = {
        full_body: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleFullBodyWebpDefault.default),
            alt: "RehabilitationFemaleFullBodyIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleFullBodyWebpDefault.default),
            alt: "RehabilitationMaleFullBodyIcon",
            className: "program-svg-icon"
        }),
        shoulders: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleShouldersWebpDefault.default),
            alt: "RehabilitationFemaleShouldersIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleShouldersWebpDefault.default),
            alt: "RehabilitationMaleShouldersIcon",
            className: "program-svg-icon"
        }),
        hips: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleHipsWebpDefault.default),
            alt: "RehabilitationFemaleHipsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleHipsWebpDefault.default),
            alt: "RehabilitationMaleHipsIcon",
            className: "program-svg-icon"
        }),
        knees: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleKneesWebpDefault.default),
            alt: "RehabilitationFemaleKneesIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleKneesWebpDefault.default),
            alt: "RehabilitationMaleKneesIcon",
            className: "program-svg-icon"
        }),
        ankles: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleAnklesWebpDefault.default),
            alt: "RehabilitationFemaleAnklesIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleAnklesWebpDefault.default),
            alt: "RehabilitationMaleAnklesIcon",
            className: "program-svg-icon"
        }),
        spine_back: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleSpineBackWebpDefault.default),
            alt: "RehabilitationFemaleSpineBackIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleSpineBackWebpDefault.default),
            alt: "RehabilitationMaleSpineBackIcon",
            className: "program-svg-icon"
        }),
        hamstrings: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleHamstringsWebpDefault.default),
            alt: "RehabilitationFemaleHamstringsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleHamstringsWebpDefault.default),
            alt: "RehabilitationMaleHamstringsIcon",
            className: "program-svg-icon"
        }),
        wrists: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleWristsWebpDefault.default),
            alt: "RehabilitationFemaleWristsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleWristsWebpDefault.default),
            alt: "RehabilitationMaleWristsIcon",
            className: "program-svg-icon"
        }),
        neck: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationFemaleNeckWebpDefault.default),
            alt: "RehabilitationFemaleNeckIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _rehabilitationMaleNeckWebpDefault.default),
            alt: "RehabilitationMaleNeckIcon",
            className: "program-svg-icon"
        })
    };
    const groupData = programMasterData?.trainingGoalDetails?.groups?.find((g)=>g.goalId === 'mobility');
    const areas = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-cards-grid",
                children: areas.map((area)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `goal-card ${selectedArea.includes(area.slug) ? 'selected' : ''}`,
                        onClick: ()=>{
                            let nextValue = [
                                ...selectedArea
                            ];
                            if (nextValue.includes(area.slug)) nextValue = nextValue.filter((p)=>p !== area.slug);
                            else nextValue.push(area.slug);
                            setSelectedArea(nextValue);
                            if (onChange) onChange(nextValue);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-image",
                                children: iconMap[area.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: area.title
                            })
                        ]
                    }, area.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","src/utils/genderUtils":"aiA54","./IncreaseStrengthSteps.scss":"lcYno","url:src/assets/images/trainer/program-generator/rehabilitation-male-ankles.webp":"2TH0O","url:src/assets/images/trainer/program-generator/rehabilitation-male-full-body.webp":"2kBzM","url:src/assets/images/trainer/program-generator/rehabilitation-male-hamstrings.webp":"hK1AR","url:src/assets/images/trainer/program-generator/rehabilitation-male-hips.webp":"1b122","url:src/assets/images/trainer/program-generator/rehabilitation-male-knees.webp":"8kON7","url:src/assets/images/trainer/program-generator/rehabilitation-male-neck.webp":"29dTk","url:src/assets/images/trainer/program-generator/rehabilitation-male-shoulders.webp":"iiTgT","url:src/assets/images/trainer/program-generator/rehabilitation-male-spine-back.webp":"5vCwk","url:src/assets/images/trainer/program-generator/rehabilitation-male-wrists.webp":"3GfGl","url:src/assets/images/trainer/program-generator/rehabilitation-female-ankles.webp":"u6Vbf","url:src/assets/images/trainer/program-generator/rehabilitation-female-full-body.webp":"izHYn","url:src/assets/images/trainer/program-generator/rehabilitation-female-hamstrings.webp":"eFiaG","url:src/assets/images/trainer/program-generator/rehabilitation-female-hips.webp":"4azxd","url:src/assets/images/trainer/program-generator/rehabilitation-female-knees.webp":"77UkI","url:src/assets/images/trainer/program-generator/rehabilitation-female-neck.webp":"gClki","url:src/assets/images/trainer/program-generator/rehabilitation-female-shoulders.webp":"egsrs","url:src/assets/images/trainer/program-generator/rehabilitation-female-spine-back.webp":"gcDGe","url:src/assets/images/trainer/program-generator/rehabilitation-female-wrists.webp":"aXYdT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"2kBzM":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("i4WPR");

},{}],"izHYn":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kojAS");

},{}],"eEdn0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobilityStep2", ()=>MobilityStep2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _improveLiftingTechniqueSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_lifting_technique.svg");
var _improveRangeOfMotionSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_range_of_motion.svg");
var _reduceStiffnessSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/reduce_stiffness.svg");
var _supportRecoverySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/support_recovery.svg");
var _moveBetterSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/move_better.svg");
const iconMap = {
    move_better: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _moveBetterSvg.ReactComponent), {}),
    improve_lifting_technique: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _improveLiftingTechniqueSvg.ReactComponent), {}),
    reduce_stiffness: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reduceStiffnessSvg.ReactComponent), {}),
    support_recovery: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _supportRecoverySvg.ReactComponent), {}),
    improve_range_of_motion: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _improveRangeOfMotionSvg.ReactComponent), {})
};
const MobilityStep2 = ({ value, onNext })=>{
    const [selectedPurpose, setSelectedPurpose] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalPreferences?.groups?.find((g)=>g.goalId === 'mobility');
    const purposes = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: purposes.map((purpose)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedPurpose === purpose.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedPurpose(purpose.slug);
                            if (onNext) onNext(purpose.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[purpose.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: purpose.title
                            })
                        ]
                    }, purpose.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_lifting_technique.svg":"9fA6s","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/improve_range_of_motion.svg":"3H6Pa","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/reduce_stiffness.svg":"e0kDN","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/support_recovery.svg":"16Rcn","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/move_better.svg":"2eI58","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"9fA6s":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgImproveLiftingTechnique);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgImproveLiftingTechnique = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M26.133 17.51a.2.2 0 0 1-.032-.063c-.023-.07-2.383-7.063-8.058-9.76a2.8 2.8 0 0 1-1.01-.99c-.016-.032-.266-.47-1.107-.59a4 4 0 0 1 .149.455q.028.097.05.196.031.148.052.3c.01.058.022.116.027.175q.027.24.028.487-.002.692-.204 1.331c.496.065.943.326 1.23.737.596.85.987 2.141 1.163 3.84.001.033.024 1.166.588 2.175.35.378.694.818 1.021 1.348a.244.244 0 1 1-.416.257c-2.17-3.505-5.008-3.18-6.507-2.674a2.38 2.38 0 0 1-1.902-.148c-2.988-1.639-5.645.06-6.397.627 0 0-.035 5.6-.273 9.3l3.389 1.72c.339-.172 1.458-.823 1.855-2.103.092-.294.16-.561.221-.797.164-.633.281-1.09.66-1.276.278-.136.627-.096 1.166.135.15.064.3.127.454.178l.972.322c.192.064.355.108.513.139 2.335.462 4.86.153 6.753-.825 1.778-.915 2.769-1.323 3.287-1.504a4.75 4.75 0 0 0 1.808-1.104c.722-.712.896-1.345.52-1.887m-2.134.178c-.167.766-.774 1.416-1.806 1.932a.243.243 0 0 1-.328-.11.244.244 0 0 1 .11-.327c.89-.446 1.41-.982 1.546-1.595.173-.783-.352-1.455-.357-1.462a.244.244 0 0 1 .381-.306c.027.035.675.853.454 1.868"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M8.26 9.665c.015.025.025.053.04.078.074.129.162.247.25.365.032.043.059.09.092.132.072.088.153.167.23.248.06.061.114.128.177.185.057.053.121.096.182.145.092.075.182.153.28.22.038.025.08.044.12.068.126.079.253.158.388.222l.076.03c.153.069.309.133.47.183.037.011.077.016.115.026.152.042.305.081.463.105a4 4 0 0 0 1.207 0c.158-.024.31-.063.462-.105.038-.01.078-.014.116-.026.163-.05.321-.115.476-.186.023-.01.047-.016.07-.027.14-.067.274-.148.405-.23.034-.022.07-.038.102-.06.105-.07.201-.154.3-.234.053-.044.11-.082.162-.13.069-.062.128-.134.192-.201.072-.077.149-.149.215-.232.037-.046.068-.098.103-.146.083-.114.168-.226.24-.35l.042-.084a3.9 3.9 0 0 0 .484-2.374q-.01-.08-.024-.16a4 4 0 0 0-.046-.263q-.02-.09-.046-.177a4 4 0 0 0-.133-.407 4 4 0 0 0-.104-.241q-.034-.072-.07-.143a4 4 0 0 0-.245-.416l-.077-.103a4 4 0 0 0-.355-.424 4 4 0 0 0-.471-.414q-.105-.08-.212-.151a4 4 0 0 0-.434-.245q-.091-.047-.185-.089a4 4 0 0 0-.418-.15q-.076-.022-.153-.04a4 4 0 0 0-.347-.073q-.075-.014-.152-.024a4 4 0 0 0-.5-.035c-.17 0-.336.015-.5.035q-.077.01-.152.024-.176.029-.348.073-.077.018-.152.04a4 4 0 0 0-.419.15c-.063.027-.124.06-.186.09a4 4 0 0 0-.912.616q-.105.092-.203.193a4 4 0 0 0-.354.422l-.08.106a4.2 4.2 0 0 0-.48.97 4 4 0 0 0-.07.232q-.025.09-.047.182a4 4 0 0 0-.045.26q-.014.08-.025.161a3.9 3.9 0 0 0 .487 2.378m3.052-3.93.044-.008q.187-.038.385-.04.197.002.384.04l.045.009a2.04 2.04 0 0 1 1.608 1.984c0 .843-.514 1.569-1.245 1.88l-.009.004q-.166.068-.347.108-.024.006-.05.01a2 2 0 0 1-.386.04q-.199-.001-.387-.04l-.05-.01a2 2 0 0 1-.347-.108L10.95 9.6a2.05 2.05 0 0 1-1.245-1.88c0-.972.69-1.785 1.608-1.984"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3H6Pa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgImproveRangeOfMotion);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgImproveRangeOfMotion = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M11.228 13.202c1.139-.83 2.045-1.942 2.552-3.256.583-1.497.765-3.005.822-3.854a.903.903 0 1 1 1.806.068c-.02 3.756-1.775 6.65-1.775 6.65l7.415 10.344a.997.997 0 0 1-1.588 1.207l-4.677-5.804-2.635 2.042-1.021 3.416a1.025 1.025 0 0 1-1.985-.507c.877-4.22 2.693-5.568 2.693-5.568l-1.363-1.546a16 16 0 0 0-.865 4.262.827.827 0 0 1-1.645.046q-.005-.035-.004-.077c-.133-4.943 1.383-6.775 2.27-7.423"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9.202 11.913c-.79-.676-.917-1.824-.284-2.564s1.786-.792 2.576-.117c.79.676.917 1.823.284 2.563s-1.787.793-2.576.117"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e0kDN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReduceStiffness);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReduceStiffness = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M10.828 7.688c1.011 0 1.774.928 1.574 1.922a2.47 2.47 0 0 1 1.365-1.123l2.17-.724a1.47 1.47 0 0 1 1.716.624l1.227 1.996a.743.743 0 0 1-1.237.823L16.426 9.51l-1.763.647 2.493 2.937c.496.584.768 1.326.768 2.092v5.351c0 .512-.4.946-.913.963a.944.944 0 0 1-.965-.81l-.766-5.361-2.567-2.852a2.47 2.47 0 0 1-.546-2.301 1.605 1.605 0 1 1-1.339-2.488"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m12.487 16.61 1.206-1.725.75.834.235 1.638-.428.575-.577 2.845a.902.902 0 0 1-1.775-.316zm6.903-1.14.376.205.043-.426a.405.405 0 0 1 .595-.316l.911.494a.405.405 0 1 1-.385.711l-.376-.203-.043.425a.405.405 0 0 1-.595.316l-.912-.494a.405.405 0 0 1 .386-.711m-.65-2.643.902-.51a.405.405 0 0 1 .601.306l.05.425.373-.21a.405.405 0 0 1 .398.704l-.903.51a.405.405 0 0 1-.6-.306l-.05-.425-.373.21a.405.405 0 1 1-.398-.704"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M22.281 7.688H8.468V21.5h13.813z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"16Rcn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSupportRecovery);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSupportRecovery = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "m21.076 15.191 1.314-1.427c1.853-1.861 1.82-4.22.139-5.918-1.681-1.705-4.057-1.713-5.925.14L15.184 9.3c.71-.204 1.469-.041 2.26.759l2.98 2.97c.79.792.856 1.453.652 2.163m-6.978 3.934c.817.816 1.6.84 2.44 0l2.971-2.979c.85-.84.825-1.615.008-2.432l-2.856-2.864c-.816-.817-1.591-.833-2.44.016l-2.971 2.97c-.84.841-.816 1.625 0 2.44zm.743-5.305a.766.766 0 0 1-.008-1.093.76.76 0 0 1 1.094 0 .76.76 0 0 1-.017 1.093.774.774 0 0 1-1.069 0m-1.73 1.722a.76.76 0 0 1 0-1.093.76.76 0 0 1 1.093.008.75.75 0 0 1 0 1.069.76.76 0 0 1-1.093.016m4.53 0a.764.764 0 0 1-1.086-.016.76.76 0 0 1 0-1.069.75.75 0 0 1 1.085-.008.76.76 0 0 1 0 1.093m-9.418 6.602c1.681 1.706 4.072 1.722 5.925-.139l1.403-1.322c-.701.204-1.427.066-2.22-.726l-2.978-2.979c-.792-.792-.865-1.453-.66-2.163l-1.323 1.412c-1.861 1.852-1.828 4.22-.147 5.917m6.61-4.888a.75.75 0 0 1 .008-1.086.75.75 0 0 1 1.07 0c.31.302.326.792.016 1.086a.76.76 0 0 1-1.094 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2eI58":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMoveBetter);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMoveBetter = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M11.228 13.202c1.139-.83 2.045-1.942 2.552-3.256.583-1.497.765-3.005.822-3.854a.903.903 0 1 1 1.806.068c-.02 3.756-1.775 6.65-1.775 6.65l7.415 10.344a.997.997 0 0 1-1.588 1.207l-4.677-5.804-2.635 2.042-1.021 3.416a1.025 1.025 0 0 1-1.985-.507c.877-4.22 2.693-5.568 2.693-5.568l-1.363-1.546a16 16 0 0 0-.865 4.262.827.827 0 0 1-1.645.046q-.005-.035-.004-.077c-.133-4.943 1.383-6.775 2.27-7.423"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9.202 11.913c-.79-.676-.917-1.824-.284-2.564s1.786-.792 2.576-.117c.79.676.917 1.823.284 2.563s-1.787.793-2.576.117"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M25.125 5.25h-19.5v19.5h19.5z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dgA7N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MobilityStep3", ()=>MobilityStep3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss"); // Reusing the same SCSS for consistency
var _recoveryFocusedMobilitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/recovery_focused_mobility.svg");
var _areaSpecificMobilitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/area_specific_mobility.svg");
var _fullBodyMobilitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/full_body_mobility.svg");
var _mobilityStabilitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility_stability.svg");
const iconMap = {
    full_body_mobility: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullBodyMobilitySvg.ReactComponent), {}),
    area_specific_mobility: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _areaSpecificMobilitySvg.ReactComponent), {}),
    mobility_stability: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobilityStabilitySvg.ReactComponent), {}),
    recovery_focused_mobility: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recoveryFocusedMobilitySvg.ReactComponent), {})
};
const MobilityStep3 = ({ value, onNext })=>{
    const [selectedApproach, setSelectedApproach] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalApproaches?.groups?.find((g)=>g.goalId === 'mobility');
    const approaches = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: groupData?.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: approaches.map((approach)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedApproach(approach.slug);
                            if (onNext) onNext(approach.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[approach.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: approach.title
                            })
                        ]
                    }, approach.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/recovery_focused_mobility.svg":"jXxO5","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/area_specific_mobility.svg":"88yRb","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/full_body_mobility.svg":"3Im7e","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility_stability.svg":"bXp6E","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"jXxO5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgRecoveryFocusedMobility);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRecoveryFocusedMobility = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M9.674 15.191 8.36 13.764c-1.853-1.861-1.82-4.22-.139-5.918 1.682-1.705 4.057-1.713 5.926.14l1.42 1.314c-.711-.204-1.47-.041-2.261.759l-2.98 2.97c-.79.792-.856 1.453-.652 2.163m6.978 3.934c-.817.816-1.6.84-2.44 0l-2.971-2.979c-.85-.84-.825-1.615-.008-2.432l2.856-2.864c.816-.817 1.591-.833 2.44.016l2.971 2.97c.84.841.816 1.625 0 2.44zm-.743-5.305c.31-.31.31-.791.008-1.093a.76.76 0 0 0-1.094 0 .76.76 0 0 0 .017 1.093.774.774 0 0 0 1.069 0m1.73 1.722a.76.76 0 0 0 0-1.093.76.76 0 0 0-1.093.008.75.75 0 0 0 0 1.069.76.76 0 0 0 1.093.016m-4.53 0a.764.764 0 0 0 1.086-.016.76.76 0 0 0 0-1.069.75.75 0 0 0-1.085-.008.76.76 0 0 0 0 1.093m9.418 6.602c-1.681 1.706-4.072 1.722-5.925-.139l-1.404-1.322c.702.204 1.428.066 2.22-.726l2.979-2.979c.791-.792.865-1.453.661-2.163l1.322 1.412c1.861 1.852 1.828 4.22.147 5.917m-6.61-4.888a.75.75 0 0 0-.008-1.086.75.75 0 0 0-1.07 0c-.31.302-.326.792-.016 1.086a.76.76 0 0 0 1.094 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"88yRb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAreaSpecificMobility);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAreaSpecificMobility = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                d: "M13.688 5.625v5.016l-.643.212c-.534.178-.857.63-.857 1.1 0 .59.53 1.172 1.312 1.172.354 0 .667-.125.897-.318l.603-.506.603.506c.23.193.544.318.897.318.783 0 1.313-.581 1.313-1.172 0-.47-.324-.922-.858-1.1l-.642-.212V5.625h1.875v2.584a7.5 7.5 0 0 1 3.143 10.814 7.5 7.5 0 0 1-3.143 2.768v2.584h-1.875v-5.016l.642-.212c.534-.178.858-.63.858-1.1 0-.59-.53-1.172-1.313-1.172-.354 0-.667.125-.897.318l-.603.506-.603-.506a1.4 1.4 0 0 0-.897-.318c-.783 0-1.312.581-1.312 1.172 0 .47.323.922.857 1.1l.643.212v5.016h-1.876v-2.584A7.5 7.5 0 0 1 8.67 10.977a7.5 7.5 0 0 1 3.143-2.768V5.625z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                fillRule: "evenodd",
                d: "m13.688 10.64-.643.213c-.534.178-.857.63-.857 1.1 0 .59.53 1.172 1.312 1.172.354 0 .667-.125.897-.318l.603-.506.603.506m0 0c.23.193.544.318.897.318.783 0 1.313-.581 1.313-1.172 0-.47-.324-.922-.858-1.1l-.642-.212V5.625h1.875v2.584a7.5 7.5 0 0 1 3.143 10.814 7.5 7.5 0 0 1-3.143 2.768v2.584h-1.875v-5.016l.642-.212c.534-.178.858-.63.858-1.1 0-.59-.53-1.172-1.313-1.172-.354 0-.667.125-.897.318l-.603.506-.603-.506a1.4 1.4 0 0 0-.897-.318c-.783 0-1.312.581-1.312 1.172 0 .47.323.922.857 1.1l.643.212v5.016h-1.876v-2.584A7.5 7.5 0 0 1 8.67 10.977a7.5 7.5 0 0 1 3.143-2.768V5.625h1.876v5.016m6 7.472v-.066c0-1.714-1.46-3.047-3.188-3.047 1.729 0 3.188-1.333 3.188-3.047v-.066A5.6 5.6 0 0 1 20.625 15a5.6 5.6 0 0 1-.937 3.113M15 14.642c.45.23.96.358 1.5.358-.54 0-1.05.128-1.5.358A3.3 3.3 0 0 0 13.503 15 3.3 3.3 0 0 0 15 14.642m-4.687-2.754A5.6 5.6 0 0 0 9.375 15c0 1.15.345 2.22.938 3.113v-.066c0-1.713 1.456-3.046 3.184-3.047-1.728 0-3.184-1.334-3.184-3.047z",
                clipRule: "evenodd"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Im7e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFullBodyMobility);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFullBodyMobility = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M19.786 12.926c-1.314-.958-2.36-2.241-2.945-3.757-.672-1.727-.883-3.468-.949-4.448a1.042 1.042 0 1 0-2.083.08c.022 4.333 2.048 7.672 2.048 7.672L7.3 24.41a1.15 1.15 0 0 0 1.833 1.393l5.396-6.697 3.04 2.355 1.178 3.942a1.183 1.183 0 0 0 2.29-.584c-1.01-4.87-3.107-6.425-3.107-6.425l1.573-1.784c.717 2.012.936 3.898.998 4.917a.954.954 0 0 0 1.898.053q.006-.041.005-.088c.154-5.704-1.596-7.818-2.62-8.565"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M22.125 11.438c.911-.779 1.058-2.103.327-2.957-.73-.854-2.06-.915-2.972-.135s-1.058 2.103-.327 2.957c.73.854 2.06.915 2.972.135"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M3.75 3.75h22.5v22.5H3.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bXp6E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMobilityStability);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMobilityStability = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#E5E5E5",
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m10.235 23.145 2.853-6.519v-3.794s-4.251-2.886-.564-6.958a.766.766 0 0 1 1.088-.047l.025.025.004.004a.767.767 0 0 1 .011 1.07c-.747.798-1.772 2.442.22 4.196.198.172.432.3.688.37l.107.025c.223.055.454.055.673 0l.107-.025c.252-.07.49-.194.688-.37 1.992-1.75.967-3.398.22-4.197a.767.767 0 0 1 .014-1.07l.004-.003a.76.76 0 0 1 1.08-.003l.026.025c3.688 4.069-.564 6.958-.564 6.958v3.79l2.853 6.519a.88.88 0 0 1-.45 1.157l-.034.015a.88.88 0 0 1-1.113-.436L15 17.403l-3.168 6.478a.88.88 0 0 1-1.611-.703q.005-.016.014-.033"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M15 10.87c-.893 0-1.618-.778-1.618-1.737 0-.958.725-1.736 1.619-1.736.893 0 1.618.778 1.618 1.736 0 .959-.725 1.736-1.618 1.736"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M24.375 5.625H5.625v18.75h18.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gWlvK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuildMuscleStep1", ()=>BuildMuscleStep1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("src/components/Button/Button");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _muscleGroupImages = require("../assets/MuscleGroupImages");
var _genderUtils = require("src/utils/genderUtils");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
const BuildMuscleStep1 = ({ value = [], clientBodyProfile = 'Male', onChange })=>{
    const [selectedFocus, setSelectedFocus] = (0, _react.useState)(value);
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const genderKey = (0, _genderUtils.resolveBodyProfile)(clientBodyProfile);
    const images = (0, _muscleGroupImages.MuscleGroupImages)[genderKey] || (0, _muscleGroupImages.MuscleGroupImages).male;
    const iconMap = {
        full_body: images.full_body,
        upper_body: images.upper_body,
        lower_body: images.lower_body,
        core: images.core,
        back: images.back,
        glutes: images.glutes
    };
    const groupData = programMasterData?.trainingGoalDetails?.groups?.find((g)=>g.goalId === 'build_muscle');
    const focusPrograms = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    const toggleFocusProgram = (programSlug)=>{
        let nextValue = [
            ...selectedFocus
        ];
        if (programSlug === 'full-body') nextValue = [
            'full-body'
        ];
        else {
            nextValue = nextValue.filter((p)=>p !== 'full-body');
            if (nextValue.includes(programSlug)) nextValue = nextValue.filter((p)=>p !== programSlug);
            else nextValue.push(programSlug);
        }
        setSelectedFocus(nextValue);
        if (onChange) onChange(nextValue);
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "program-focus-container trainer-program-focus-wrapper max-width-576",
                style: {
                    margin: '0 auto'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "trainer-program-focus-button-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "trainer-program-focus-flex-button",
                            children: focusPrograms.map((program)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    onClick: ()=>toggleFocusProgram(program.slug),
                                    variant: "primary",
                                    className: `${selectedFocus.includes(program.slug) ? 'active' : ''} program-focus-program-button justify-content-center`,
                                    children: program.title
                                }, program.id))
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "trainer-program-focus-image-wrapper",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: images.base,
                                className: "muscle-group",
                                alt: 'muscleGroup'
                            }),
                            focusPrograms.map((program)=>{
                                const imgSrc = iconMap[program.id];
                                if (!imgSrc) return null;
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: imgSrc,
                                    className: `${selectedFocus.includes(program.slug) ? 'active' : ''} muscle-group-item`,
                                    alt: program.id
                                }, program.id);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/components/Button/Button":"g0894","src/api/mutations/useGetProgramMasterData":"bOtFg","../assets/MuscleGroupImages":"9D5GI","src/utils/genderUtils":"aiA54","./IncreaseStrengthSteps.scss":"lcYno","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"fwBa1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuildMuscleStep2", ()=>BuildMuscleStep2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("src/components/Button/Button");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _muscleGroupImages = require("../assets/MuscleGroupImages");
var _genderUtils = require("src/utils/genderUtils");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
const BuildMuscleStep2 = ({ value = [], clientBodyProfile = 'Male', onChange, excludedAreas = [] })=>{
    const [selectedFocus, setSelectedFocus] = (0, _react.useState)(value);
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    (0, _react.useEffect)(()=>{
        if (excludedAreas && excludedAreas.length > 0) {
            const filteredFocus = selectedFocus.filter((focus)=>!excludedAreas.includes(focus));
            if (filteredFocus.length !== selectedFocus.length) {
                setSelectedFocus(filteredFocus);
                if (onChange) onChange(filteredFocus);
            }
        }
    }, [
        excludedAreas,
        selectedFocus,
        onChange
    ]);
    const genderKey = (0, _genderUtils.resolveBodyProfile)(clientBodyProfile);
    const images = (0, _muscleGroupImages.MuscleGroupImages)[genderKey] || (0, _muscleGroupImages.MuscleGroupImages).male;
    const iconMap = {
        full_body: images.full_body,
        upper_body: images.upper_body,
        lower_body: images.lower_body,
        core: images.core,
        back: images.back,
        glutes: images.glutes
    };
    const groupData = programMasterData?.trainingGoalPreferences?.groups?.find((g)=>g.goalId === 'build_muscle');
    const focusPrograms = groupData?.options ? [
        ...groupData.options
    ].filter((opt)=>!excludedAreas.includes(opt.slug)).sort((a, b)=>a.order - b.order) : [];
    const toggleFocusProgram = (programSlug)=>{
        let nextValue = [
            ...selectedFocus
        ];
        if (programSlug === 'full-body') nextValue = [
            'full-body'
        ];
        else {
            nextValue = nextValue.filter((p)=>p !== 'full-body');
            if (nextValue.includes(programSlug)) nextValue = nextValue.filter((p)=>p !== programSlug);
            else nextValue.push(programSlug);
        }
        setSelectedFocus(nextValue);
        if (onChange) onChange(nextValue);
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "program-focus-container trainer-program-focus-wrapper max-width-576",
                style: {
                    margin: '0 auto'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "trainer-program-focus-button-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "trainer-program-focus-flex-button",
                            children: focusPrograms.map((program)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    onClick: ()=>toggleFocusProgram(program.slug),
                                    variant: "primary",
                                    className: `${selectedFocus.includes(program.slug) ? 'active' : ''} program-focus-program-button justify-content-center`,
                                    children: program.title
                                }, program.id))
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "trainer-program-focus-image-wrapper",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: images.base,
                                className: "muscle-group",
                                alt: 'muscleGroup'
                            }),
                            focusPrograms.map((program)=>{
                                const imgSrc = iconMap[program.id];
                                if (!imgSrc) return null;
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: imgSrc,
                                    className: `${selectedFocus.includes(program.slug) ? 'active' : ''} muscle-group-item`,
                                    alt: program.id
                                }, program.id);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/components/Button/Button":"g0894","src/api/mutations/useGetProgramMasterData":"bOtFg","../assets/MuscleGroupImages":"9D5GI","src/utils/genderUtils":"aiA54","./IncreaseStrengthSteps.scss":"lcYno","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"62Cqw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BuildMuscleStep3", ()=>BuildMuscleStep3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
var _fullBodyHypertrophySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/full_body_hypertrophy.svg");
var _upperLowerSplitSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/upper_lower_split.svg");
var _bodyPartSplitSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/body_part_split.svg");
var _pushPullLegsSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/push_pull_legs.svg");
const iconMap = {
    full_body_hypertrophy: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullBodyHypertrophySvg.ReactComponent), {}),
    upper_lower_split: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _upperLowerSplitSvg.ReactComponent), {}),
    push_pull_legs: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pushPullLegsSvg.ReactComponent), {}),
    body_part_split: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bodyPartSplitSvg.ReactComponent), {})
};
const BuildMuscleStep3 = ({ value, onNext })=>{
    const [selectedApproach, setSelectedApproach] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalApproaches?.groups?.find((g)=>g.goalId === 'build_muscle');
    const approaches = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: groupData?.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: approaches.map((approach)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedApproach(approach.slug);
                            if (onNext) onNext(approach.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[approach.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: approach.title
                            })
                        ]
                    }, approach.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/full_body_hypertrophy.svg":"gZTW2","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/upper_lower_split.svg":"kbw4Q","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/body_part_split.svg":"7hNUA","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/push_pull_legs.svg":"exya0","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"gZTW2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFullBodyHypertrophy);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFullBodyHypertrophy = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#E5E5E5",
                    d: "M16.538 8.984a.316.316 0 0 1-.271-.479l1.608-2.68h-2.95l-.546 4.914 1.427-.476a.316.316 0 0 1 .397.406l-.79 2.213 2.73-3.898zm.288 2.981-2.24 3.201a.315.315 0 0 1-.557-.287l1.361-3.811-1.28.427a.316.316 0 0 1-.414-.335l.156-1.393A16.4 16.4 0 0 0 9.75 8.089a1.62 1.62 0 0 0-1.181.147l5.015 4.298-.412.48-5.1-4.37a2 2 0 0 0-.12.159 30.7 30.7 0 0 0 12.99 12.787q.05-.038.095-.078l-4.752-6.337.505-.38 4.339 5.785-.296-.777a18.4 18.4 0 0 0-4.203-6.49l.447-.446a19 19 0 0 1 4.346 6.71l.12.313-.003-.013a16.35 16.35 0 0 0-4.714-7.912m6.631 12.395.56-.56-1.972-2.628a2.3 2.3 0 0 1-1.216 1.216zm-11.051-3.373-.263 3.159h2.377l-.81-2.428a.315.315 0 0 1 .3-.415h.714l-1.345-2.306v1.674a.316.316 0 0 1-.316.316zm-4.66-10.893a16.3 16.3 0 0 0 5.001 8.177v-.443a.316.316 0 0 1 .589-.16l1.125 1.93a16.4 16.4 0 0 0 5.073 2.284q.203.052.412.052c.086 0 .17-.012.253-.025A31.3 31.3 0 0 1 7.697 9.643l-.004.039q0 .209.053.412M7.24 8.799a2.3 2.3 0 0 1 1.216-1.216L5.828 5.61l-.56.56z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M24.375 5.625H5.625v18.75h18.75z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kbw4Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgUpperLowerSplit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUpperLowerSplit = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#E5E5E5",
                    fillRule: "evenodd",
                    d: "M20.245 25.313a.327.327 0 1 0 0-.655h-3.068V5.015a.327.327 0 0 0-.327-.327h-3.7a.327.327 0 0 0-.328.327v19.643H9.755a.327.327 0 1 0 0 .655zm3.828-9.486c.18 0 .327-.146.327-.327V7.687a.327.327 0 0 0-.327-.328h-6.251v8.468zm-2.635-2.564V9.134a.327.327 0 1 0-.655 0v4.128l-.782-.782a.327.327 0 0 0-.463.463l1.341 1.341a.326.326 0 0 0 .463 0l1.342-1.34a.327.327 0 0 0-.463-.464zm-9.26-5.904H5.927a.327.327 0 0 0-.327.328V15.5c0 .18.146.327.327.327h6.25zm-3.29 7.021a.327.327 0 0 0 .328-.327V9.925l.782.782a.326.326 0 0 0 .463 0 .327.327 0 0 0 0-.463l-1.34-1.341a.327.327 0 0 0-.464 0l-1.34 1.34a.327.327 0 1 0 .462.464l.783-.783v4.129c0 .18.146.327.327.327",
                    clipRule: "evenodd"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M4.688 4.688h20.625v20.625H4.688z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7hNUA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBodyPartSplit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBodyPartSplit = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M7.782 12.389a.5.5 0 0 1 .07-.254c.052-.096 1.382-2.331 5.547-2.86a2.2 2.2 0 0 0 1.071-.441c.772-.594 2.3-1.58 3.896-1.437 1.34.111 2.67.518 3.55.843a1.6 1.6 0 0 1 1.05 1.503v6.582h-1.96a2.975 2.975 0 0 1-2.97-2.971.506.506 0 0 0-.508-.508.51.51 0 0 0-.508.508 3.99 3.99 0 0 0 3.986 3.987h1.96v1.711h-2.533a.503.503 0 0 0-.508.508c0 .28.223.508.508.508h2.534v.944c0 .884-.721 1.605-1.605 1.605h-3.174a.51.51 0 0 1-.493-.386c-.157-.63-.548-1.782-.934-2.194-.549-.589-1.503-2.275-1.9-4.164a.6.6 0 0 0-.29-.386.58.58 0 0 0-.492-.026c-1.874.757-4.428 1.54-5.962.97a.51.51 0 0 1-.335-.477z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"exya0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPushPullLegs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPushPullLegs = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                    fill: "#E5E5E5",
                    clipPath: "url(#b)",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M20.705 16.842a2.583 2.583 0 1 0-2.376-4.587 2.583 2.583 0 0 0 2.376 4.587M15.1 9.805c.652 0 1.182.53 1.182 1.182v1.895c.396-.123.724-.359.898-.716.443-.907.22-2.407-1.304-3.323-2.102-1.247-3.54-1.726-6.097-1.967-1.882-.034-2.332 1.165-2.538 2.196-.075.376-.121.679-.073.924q.007.122.035.245l1.161 4.937-.499 6.4a1.435 1.435 0 0 0 2.861.224l.517-6.623q.017-.223-.034-.44l-.845-3.591c1.283.352 2.535.91 3.554 1.353v-1.514c0-.652.53-1.182 1.182-1.182"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M16.018 18.386v-7.398a.918.918 0 0 0-1.836 0v7.398a2.56 2.56 0 0 1 1.836 0m-.918.094a2.313 2.313 0 1 0 0 4.625 2.313 2.313 0 0 0 0-4.625m0 3.4a1.088 1.088 0 1 1 0-2.176 1.088 1.088 0 0 1 0 2.177"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M15.1 21.346a.553.553 0 1 0 0-1.106.553.553 0 0 0 0 1.106"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "a",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M6.5 6.875h16.25v16.25H6.5z"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "b",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#fff",
                            d: "M6.5 6.875h16.25v16.25H6.5z"
                        })
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3PwNr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WeightLossStep1", ()=>WeightLossStep1);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("src/components/Button/Button");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _muscleGroupImages = require("../assets/MuscleGroupImages");
var _genderUtils = require("src/utils/genderUtils");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
const WeightLossStep1 = ({ value, clientBodyProfile = 'Male', onNext })=>{
    const [selectedFocus, setSelectedFocus] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const genderKey = (0, _genderUtils.resolveBodyProfile)(clientBodyProfile);
    const images = (0, _muscleGroupImages.MuscleGroupImages)[genderKey] || (0, _muscleGroupImages.MuscleGroupImages).male;
    const iconMap = {
        full_body: images.full_body,
        upper_body: images.upper_body,
        lower_body: images.lower_body,
        core: images.core,
        back: images.back,
        glutes: images.glutes
    };
    const groupData = programMasterData?.trainingGoalDetails?.groups?.find((g)=>g.goalId === 'weight_loss');
    const focusPrograms = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    const toggleFocusProgram = (programSlug)=>{
        setSelectedFocus(programSlug);
        if (onNext) onNext(programSlug);
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "program-focus-container trainer-program-focus-wrapper max-width-576",
                style: {
                    margin: '0 auto'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "trainer-program-focus-button-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "trainer-program-focus-flex-button",
                            children: focusPrograms.map((program)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    onClick: ()=>toggleFocusProgram(program.slug),
                                    variant: "primary",
                                    className: `${selectedFocus === program.slug ? 'active' : ''} program-focus-program-button justify-content-center`,
                                    children: program.title
                                }, program.id))
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "trainer-program-focus-image-wrapper",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: images.base,
                                className: "muscle-group",
                                alt: 'muscleGroup'
                            }),
                            focusPrograms.map((program)=>{
                                const imgSrc = iconMap[program.id];
                                if (!imgSrc) return null;
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: imgSrc,
                                    className: `${selectedFocus === program.slug ? 'active' : ''} muscle-group-item`,
                                    alt: program.id
                                }, program.id);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/components/Button/Button":"g0894","src/api/mutations/useGetProgramMasterData":"bOtFg","../assets/MuscleGroupImages":"9D5GI","src/utils/genderUtils":"aiA54","./IncreaseStrengthSteps.scss":"lcYno","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"eFykn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WeightLossStep2", ()=>WeightLossStep2);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _button = require("src/components/Button/Button");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _muscleGroupImages = require("../assets/MuscleGroupImages");
var _genderUtils = require("src/utils/genderUtils");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
const WeightLossStep2 = ({ value, clientBodyProfile = 'Male', onChange, excludedArea = '' })=>{
    const [selectedFocuses, setSelectedFocuses] = (0, _react.useState)(value || []);
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const genderKey = (0, _genderUtils.resolveBodyProfile)(clientBodyProfile);
    const images = (0, _muscleGroupImages.MuscleGroupImages)[genderKey] || (0, _muscleGroupImages.MuscleGroupImages).male;
    const iconMap = {
        full_body: images.full_body,
        upper_body: images.upper_body,
        lower_body: images.lower_body,
        core: images.core,
        back: images.back,
        glutes: images.glutes
    };
    const groupData = programMasterData?.trainingGoalPreferences?.groups?.find((g)=>g.goalId === 'weight_loss');
    const focusPrograms = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    const handleToggle = (programSlug)=>{
        let newFocuses = [
            ...selectedFocuses
        ];
        if (programSlug === 'full-body') newFocuses = [
            'full-body'
        ];
        else {
            newFocuses = newFocuses.filter((f)=>f !== 'full-body');
            if (newFocuses.includes(programSlug)) newFocuses = newFocuses.filter((f)=>f !== programSlug);
            else newFocuses.push(programSlug);
        }
        setSelectedFocuses(newFocuses);
        if (onChange) onChange(newFocuses);
    };
    (0, _react.useEffect)(()=>{
    // excludedArea logic removed as requested for weight loss
    }, [
        excludedArea,
        selectedFocuses,
        onChange
    ]);
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "program-focus-container trainer-program-focus-wrapper max-width-576",
                style: {
                    margin: '0 auto'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "trainer-program-focus-button-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "trainer-program-focus-flex-button",
                            children: focusPrograms.map((program)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    onClick: ()=>handleToggle(program.slug),
                                    variant: "primary",
                                    className: `${selectedFocuses.includes(program.slug) ? 'active' : ''} program-focus-program-button justify-content-center`,
                                    children: program.title
                                }, program.id))
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "trainer-program-focus-image-wrapper",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: images.base,
                                className: "muscle-group",
                                alt: 'muscleGroup'
                            }),
                            focusPrograms.map((program)=>{
                                const imgSrc = iconMap[program.id];
                                if (!imgSrc) return null;
                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: imgSrc,
                                    className: `${selectedFocuses.includes(program.slug) ? 'active' : ''} muscle-group-item`,
                                    alt: program.id
                                }, program.id);
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/components/Button/Button":"g0894","src/api/mutations/useGetProgramMasterData":"bOtFg","../assets/MuscleGroupImages":"9D5GI","src/utils/genderUtils":"aiA54","./IncreaseStrengthSteps.scss":"lcYno","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"iDqRm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WeightLossStep3", ()=>WeightLossStep3);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
var _weightLossStep3Scss = require("./WeightLossStep3.scss");
const WeightLossStep3 = ({ value, onChange })=>{
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const targetData = programMasterData?.weightLossTarget;
    const apiMin = targetData?.slider?.min || 40;
    const apiMax = targetData?.slider?.max || 80;
    const [unit, setUnit] = (0, _react.useState)(value?.unit || 'Kg');
    const [weight, setWeight] = (0, _react.useState)(value?.target || (unit === 'Lb' ? Math.round(apiMin * 2.2) : apiMin));
    const [isDragging, setIsDragging] = (0, _react.useState)(false);
    const [startX, setStartX] = (0, _react.useState)(0);
    const [startWeight, setStartWeight] = (0, _react.useState)(0);
    const minWeight = unit === 'Kg' ? apiMin : Math.round(apiMin * 2.2);
    const maxWeight = unit === 'Kg' ? apiMax : Math.round(apiMax * 2.2);
    const handleWeightChange = (delta)=>{
        let newWeight = weight + delta;
        if (newWeight < minWeight) newWeight = minWeight;
        if (newWeight > maxWeight) newWeight = maxWeight;
        if (newWeight !== weight) {
            setWeight(newWeight);
            if (onChange) onChange({
                target: newWeight,
                unit
            });
        }
    };
    const handleUnitChange = (newUnit)=>{
        if (newUnit === unit) return;
        let newWeight = weight;
        if (newUnit === 'Kg') newWeight = Math.round(weight / 2.2);
        else newWeight = Math.round(weight * 2.2);
        const newMin = newUnit === 'Kg' ? apiMin : Math.round(apiMin * 2.2);
        const newMax = newUnit === 'Kg' ? apiMax : Math.round(apiMax * 2.2);
        if (newWeight < newMin) newWeight = newMin;
        if (newWeight > newMax) newWeight = newMax;
        setUnit(newUnit);
        setWeight(newWeight);
        if (onChange) onChange({
            target: newWeight,
            unit: newUnit
        });
    };
    const ticks = [];
    for(let i = minWeight; i <= maxWeight; i++)ticks.push(i);
    const [tickWidth, setTickWidth] = (0, _react.useState)(window.innerWidth <= 768 ? 8 : 10);
    (0, _react.useEffect)(()=>{
        const handleResize = ()=>setTickWidth(window.innerWidth <= 768 ? 8 : 10);
        window.addEventListener('resize', handleResize);
        return ()=>window.removeEventListener('resize', handleResize);
    }, []);
    const shift = (weight - minWeight) * tickWidth;
    const handlePointerDown = (clientX)=>{
        setIsDragging(true);
        setStartX(clientX);
        setStartWeight(weight);
    };
    const handlePointerMove = (clientX)=>{
        if (!isDragging) return;
        const deltaX = clientX - startX;
        const deltaWeight = Math.round(deltaX / tickWidth);
        let newWeight = startWeight - deltaWeight;
        if (newWeight < minWeight) newWeight = minWeight;
        if (newWeight > maxWeight) newWeight = maxWeight;
        if (newWeight !== weight) {
            setWeight(newWeight);
            if (onChange) onChange({
                target: newWeight,
                unit
            });
        }
    };
    const handlePointerUp = ()=>{
        setIsDragging(false);
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !targetData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: targetData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "weight-target-container",
                style: {
                    margin: '40px auto',
                    textAlign: 'center',
                    width: '100%'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "tab-toggle",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: `tab ${unit === 'Kg' ? 'active' : ''}`,
                                onClick: ()=>handleUnitChange('Kg'),
                                children: "Kg"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: `tab ${unit === 'Lb' ? 'active' : ''}`,
                                onClick: ()=>handleUnitChange('Lb'),
                                children: "Lb"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "weight-ruler-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "ruler-nav-btn",
                                onClick: ()=>handleWeightChange(-1),
                                disabled: weight <= minWeight,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    width: 14,
                                    height: 24,
                                    viewBox: "0 0 14 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M10 20.9583L2 12.2917L10 3.625",
                                        stroke: "white",
                                        strokeOpacity: "0.7",
                                        strokeWidth: 2,
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "ruler-viewport",
                                style: {
                                    cursor: isDragging ? 'grabbing' : 'grab'
                                },
                                onMouseDown: (e)=>handlePointerDown(e.clientX),
                                onMouseMove: (e)=>handlePointerMove(e.clientX),
                                onMouseUp: handlePointerUp,
                                onMouseLeave: handlePointerUp,
                                onTouchStart: (e)=>handlePointerDown(e.touches[0].clientX),
                                onTouchMove: (e)=>handlePointerMove(e.touches[0].clientX),
                                onTouchEnd: handlePointerUp,
                                onTouchCancel: handlePointerUp,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "ruler-borders"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "ruler-center-pointer"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "ruler-track",
                                        style: {
                                            transform: `translateX(calc(-${shift}px - ${tickWidth / 2}px))`,
                                            transition: isDragging ? 'none' : 'transform 0.3s ease-out'
                                        },
                                        children: ticks.map((t)=>{
                                            const isMajor = t % 5 === 0;
                                            const isActive = t === weight;
                                            const dist = Math.abs(t - weight);
                                            let distClass = 'dist-far';
                                            if (dist === 0) distClass = 'dist-0';
                                            else if (dist <= 10) distClass = 'dist-10';
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: `ruler-tick ${isMajor ? 'major' : 'minor'} ${isActive ? 'active' : ''} ${distClass}`,
                                                children: [
                                                    isMajor && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "tick-number",
                                                        children: t
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "tick-line"
                                                    })
                                                ]
                                            }, t);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "ruler-nav-btn",
                                onClick: ()=>handleWeightChange(1),
                                disabled: weight >= maxWeight,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                    width: 14,
                                    height: 24,
                                    viewBox: "0 0 14 24",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                        d: "M3.33398 20.9583L11.334 12.2917L3.33398 3.625",
                                        stroke: "white",
                                        strokeOpacity: "0.7",
                                        strokeWidth: 2,
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round"
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "weight-active-display",
                        children: weight
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","./WeightLossStep3.scss":"axSLv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"axSLv":[function() {},{}],"9ocBa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WeightLossStep4", ()=>WeightLossStep4);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthStepsScss = require("./IncreaseStrengthSteps.scss");
var _strengthBasedFatLossSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength_based_fat_loss.svg");
var _lowImpactConditioningSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_impact_conditioning.svg");
var _cardioStrengthMixSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cardio_strength_mix.svg");
var _hiitCircuitsSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/hiit_circuits.svg");
const iconMap = {
    strength_based_fat_loss: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _strengthBasedFatLossSvg.ReactComponent), {}),
    hiit_circuits: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _hiitCircuitsSvg.ReactComponent), {}),
    low_impact_conditioning: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lowImpactConditioningSvg.ReactComponent), {}),
    cardio_strength_mix: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardioStrengthMixSvg.ReactComponent), {})
};
const WeightLossStep4 = ({ value, onNext })=>{
    const [selectedApproach, setSelectedApproach] = (0, _react.useState)(value || '');
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const groupData = programMasterData?.trainingGoalApproaches?.groups?.find((g)=>g.goalId === 'weight_loss');
    const approaches = groupData?.options ? [
        ...groupData.options
    ].sort((a, b)=>a.order - b.order) : [];
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Loading options...'
    });
    if (isError || !groupData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "increase-strength-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "increase-strength-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: groupData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: groupData?.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: approaches.map((approach)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${selectedApproach === approach.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            setSelectedApproach(approach.slug);
                            if (onNext) onNext(approach.slug);
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMap[approach.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: approach.title
                            })
                        ]
                    }, approach.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IncreaseStrengthSteps.scss":"lcYno","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/strength_based_fat_loss.svg":"995Cn","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_impact_conditioning.svg":"4lmGZ","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/cardio_strength_mix.svg":"gjsSC","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/hiit_circuits.svg":"6u5EV","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcYno":[function() {},{}],"995Cn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgStrengthBasedFatLoss);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgStrengthBasedFatLoss = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M8.668 20.556a1.563 1.563 0 0 0 1.56 1.475h9.543a1.56 1.56 0 0 0 1.56-1.476l.608-10.937a1.56 1.56 0 0 0-1.56-1.65H9.62a1.563 1.563 0 0 0-1.56 1.65zm2.33-7.986c-.32-.211-.4-.63-.138-.902.446-.46.967-.84 1.541-1.125a5.96 5.96 0 0 1 2.562-.62c.89-.015 1.772.17 2.582.54.584.266 1.118.63 1.58 1.076.273.264.207.684-.105.906l-1.685 1.19c-.312.22-.753.149-1.077-.057a2.27 2.27 0 0 0-1.176-.346l-1.325-1.524a.391.391 0 0 0-.59.513l1.028 1.181a2.2 2.2 0 0 0-.397.214c-.316.216-.754.301-1.074.09z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"laUOL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SecondaryTrainingGoalStep", ()=>SecondaryTrainingGoalStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _secondaryTrainingGoalStepScss = require("./SecondaryTrainingGoalStep.scss");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _increaseStrengthSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/increase_strength.svg");
var _injuryPreventionSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injury_prevention.svg");
var _generalFitnessSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_fitness.svg");
var _rehabilitationSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/rehabilitation.svg");
var _buildMuscleSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/build_muscle.svg");
var _weightLossSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/weight_loss.svg");
var _performanceSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/performance.svg");
var _enduranceSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/endurance.svg");
var _mobilitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility.svg");
const iconMapping = {
    increase_strength: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _increaseStrengthSvg.ReactComponent), {}),
    build_muscle: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildMuscleSvg.ReactComponent), {}),
    weight_loss: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _weightLossSvg.ReactComponent), {}),
    endurance: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _enduranceSvg.ReactComponent), {}),
    mobility: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mobilitySvg.ReactComponent), {}),
    performance: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _performanceSvg.ReactComponent), {}),
    general_fitness: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generalFitnessSvg.ReactComponent), {}),
    rehabilitation: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rehabilitationSvg.ReactComponent), {}),
    injury_prevention: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _injuryPreventionSvg.ReactComponent), {})
};
const SecondaryTrainingGoalStep = ({ value, primaryGoal, onChange })=>{
    const [selectedGoals, setSelectedGoals] = (0, _react.useState)(()=>{
        const initial = value || [];
        return initial.filter((g)=>g !== primaryGoal);
    });
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const secondaryTrainingGoals = programMasterData?.secondaryTrainingGoals;
    const options = (0, _react.useMemo)(()=>{
        const secOptions = secondaryTrainingGoals?.options || [];
        const primOptions = programMasterData?.trainingGoal?.options || [];
        // Ensure all primary goals are available as secondary goals if not explicitly excluded
        const merged = [
            ...secOptions
        ];
        primOptions.forEach((opt)=>{
            if (!merged.find((o)=>o.slug === opt.slug)) merged.push(opt);
        });
        return merged;
    }, [
        secondaryTrainingGoals?.options,
        programMasterData?.trainingGoal?.options
    ]);
    const maxSelection = secondaryTrainingGoals?.maxSelection || 2;
    (0, _react.useEffect)(()=>{
        if (primaryGoal && selectedGoals.includes(primaryGoal)) {
            const filtered = selectedGoals.filter((id)=>id !== primaryGoal);
            setSelectedGoals(filtered);
            if (onChange) onChange(filtered);
        }
    }, [
        primaryGoal,
        selectedGoals,
        onChange
    ]);
    const goalOptions = (0, _react.useMemo)(()=>{
        if (!options) return [];
        return [
            ...options
        ].filter((opt)=>opt.slug !== primaryGoal).sort((a, b)=>(a.order || 0) - (b.order || 0));
    }, [
        options,
        primaryGoal
    ]);
    const toggleGoal = (goalId)=>{
        let newGoals;
        if (selectedGoals.includes(goalId)) newGoals = selectedGoals.filter((id)=>id !== goalId);
        else if (selectedGoals.length < maxSelection) newGoals = [
            ...selectedGoals,
            goalId
        ];
        else newGoals = selectedGoals;
        setSelectedGoals(newGoals);
        if (onChange) onChange(newGoals);
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "secondary-training-goal-step",
        children: 'Loading options...'
    });
    if (isError || !secondaryTrainingGoals) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "secondary-training-goal-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "secondary-training-goal-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: secondaryTrainingGoals.title
            }),
            secondaryTrainingGoals.subtitle && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: secondaryTrainingGoals.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "goal-buttons",
                children: goalOptions.map((goal)=>{
                    const isSelected = selectedGoals.includes(goal.slug);
                    const isDisabled = !isSelected && selectedGoals.length >= maxSelection;
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `goal-btn ${isSelected ? 'selected' : ''}`,
                        onClick: ()=>{
                            if (!isDisabled || isSelected) toggleGoal(goal.slug);
                        },
                        style: {
                            opacity: isDisabled ? 0.5 : 1,
                            cursor: isDisabled ? 'not-allowed' : 'pointer'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "goal-icon",
                                children: iconMapping[goal.id]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "goal-label",
                                children: goal.title
                            })
                        ]
                    }, goal.id);
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./SecondaryTrainingGoalStep.scss":"6yf4h","src/api/mutations/useGetProgramMasterData":"bOtFg","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/increase_strength.svg":"c50Bc","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injury_prevention.svg":"i5tXd","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/general_fitness.svg":"hbh5n","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/rehabilitation.svg":"l4M37","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/build_muscle.svg":"g1Rue","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/weight_loss.svg":"eVRip","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/performance.svg":"3wasH","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/endurance.svg":"2jvJA","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/mobility.svg":"9FD61","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6yf4h":[function() {},{}],"42ntH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "IntensityVibeStep", ()=>IntensityVibeStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _intensityVibeStepScss = require("./IntensityVibeStep.scss");
var _highIntensitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/high_intensity.svg");
var _lowIntensitySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_intensity.svg");
var _balancedSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/balanced.svg");
const iconMapping = {
    low_intensity: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _lowIntensitySvg.ReactComponent), {}),
    balanced: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _balancedSvg.ReactComponent), {}),
    high_intensity: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _highIntensitySvg.ReactComponent), {})
};
const IntensityVibeStep = ({ onNext, clientName, value, onChange })=>{
    const [localLevel, setLocalLevel] = (0, _react.useState)('');
    const selectedLevel = value !== undefined ? value : localLevel;
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const programIntensity = programMasterData?.programIntensity;
    const nameDisplay = clientName ? `${clientName}'s` : 'their';
    // Use replace similar to EnergyLevel if there's any placeholder, though likely not for this step
    const displayTitle = programIntensity?.title.replace('{{clientName}}', nameDisplay);
    // Use the API options and ensure they are sorted by order
    const options = [
        ...programIntensity?.options || []
    ].sort((a, b)=>(a.order || 0) - (b.order || 0));
    const getIcon = (id)=>iconMapping[id] || null;
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "intensity-vibe-step",
        children: 'Loading options...'
    });
    if (isError || !programIntensity) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "intensity-vibe-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "intensity-vibe-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: displayTitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: programIntensity?.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "intensity-cards",
                children: options.map((level)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: `intensity-card ${selectedLevel === level.slug ? 'selected' : ''}`,
                        onClick: ()=>{
                            if (onChange) onChange(level.slug);
                            setLocalLevel(level.slug);
                            if (onNext) onNext();
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon-wrapper",
                                children: getIcon(level.id)
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "level-label",
                                children: level.title
                            })
                        ]
                    }, level.id))
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./IntensityVibeStep.scss":"3JHTn","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/high_intensity.svg":"fc7Um","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/low_intensity.svg":"6Ygmx","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/balanced.svg":"x8Hbv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3JHTn":[function() {},{}],"fc7Um":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgHighIntensity);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgHighIntensity = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#E5E5E5",
                    d: "M12.4 18.89c.329-.418.729-.779 1.1-1.14.957-.833 2.042-1.43 2.956-2.305 2.129-2.028 2.6-5.376 1.243-7.945 1.357.32 2.542 1.042 3.557 1.833 3.699 2.89 5.156 7.987 3.413 12.362a1.15 1.15 0 0 0-.114.458c0 .306.214.584.5.695.328.139.671.055.943-.167a.8.8 0 0 0 .2-.236c1.614-1.986 1.87-4.834.785-7.111 2.385 1.889 3.685 5.083 3.5 8.097-.086.694-.172 1.389-.415 2.083-.2.834-.585 1.667-1.014 2.403-1.542 2.403-4.213 4.125-7.084 4.473-3.057.375-6.328-.167-8.67-2.223-2.614-2.305-3.528-6-2.185-9.167l.185-.36c.3-.64 1.1-1.75 1.1-1.75m4.513 8.75c.4.333 1.058.694 1.572.833 1.6.555 3.2-.222 4.142-1.14-1.7-.388-2.714-1.61-3.014-2.846-.243-1.111.214-2.028.4-3.098.171-1.027.143-1.902-.243-2.86-.271.527-.557 1.055-.9 1.471-1.1 1.39-2.828 2-3.2 3.89a2 2 0 0 0-.085.597c-.043 1.139.472 2.389 1.328 3.153"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M33.5 7h-26v26h26z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Ygmx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLowIntensity);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLowIntensity = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("mask", {
                        id: "b",
                        width: 26,
                        height: 19,
                        x: 5,
                        y: 10,
                        maskUnits: "userSpaceOnUse",
                        style: {
                            maskType: "luminance"
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                stroke: "#fff",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                strokeWidth: 2.5,
                                d: "M26.625 27.667a9.355 9.355 0 0 0 0-13.25 9.355 9.355 0 0 0-13.25 0 9.355 9.355 0 0 0 0 13.25"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "#000",
                                d: "M17.798 25.762a5.208 5.208 0 0 0 4.402-9.44c-2.607-1.216-16.362-1.884-16.362-1.884s9.353 10.108 11.96 11.324"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                fill: "#fff",
                                d: "M18.677 23.874a3.125 3.125 0 0 0 2.641-5.664c-1.564-.73-11.705-2.01-11.705-2.01s7.5 6.945 9.064 7.674"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                        mask: "url(#b)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            fill: "#E5E5E5",
                            d: "M7.5 7.5h25v25h-25z"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M32.5 7.5h-25v25h25z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"x8Hbv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBalanced);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBalanced = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 40,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M33.533 20.865H6.467a.854.854 0 0 0-.842.866c0 .478.377.865.842.865h12.045l-4.288 7.343c-.337.577.069 1.311.722 1.311h10.108c.652 0 1.06-.733.722-1.31l-4.288-7.344h12.045a.854.854 0 0 0 .842-.865.854.854 0 0 0-.842-.866m-22.854-1.73c2.79 0 5.053-2.325 5.053-5.193S13.47 8.75 10.68 8.75s-5.054 2.325-5.054 5.192 2.263 5.193 5.054 5.193m18.641 0c2.791 0 5.054-2.325 5.054-5.193S32.112 8.75 29.321 8.75c-2.79 0-5.053 2.325-5.053 5.192s2.262 5.193 5.053 5.193"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dmLx5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "equipmentImageMap", ()=>equipmentImageMap);
parcelHelpers.export(exports, "SelectEquipmentStep", ()=>SelectEquipmentStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _selectEquipmentStepScss = require("./SelectEquipmentStep.scss");
var _absCrunchMachineJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/abs_crunch_machine.jpg");
var _absCrunchMachineJpgDefault = parcelHelpers.interopDefault(_absCrunchMachineJpg);
var _barbellJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/barbell.jpg");
var _barbellJpgDefault = parcelHelpers.interopDefault(_barbellJpg);
var _benchJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/bench.jpg");
var _benchJpgDefault = parcelHelpers.interopDefault(_benchJpg);
var _chestPressJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/chest_press.jpg");
var _chestPressJpgDefault = parcelHelpers.interopDefault(_chestPressJpg);
var _crunchBenchJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/crunch_bench.jpg");
var _crunchBenchJpgDefault = parcelHelpers.interopDefault(_crunchBenchJpg);
var _dumbellJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/dumbell.jpg");
var _dumbellJpgDefault = parcelHelpers.interopDefault(_dumbellJpg);
var _fitnessBallJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/fitness_ball.jpg");
var _fitnessBallJpgDefault = parcelHelpers.interopDefault(_fitnessBallJpg);
var _foamRollerJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/foam_roller.jpg");
var _foamRollerJpgDefault = parcelHelpers.interopDefault(_foamRollerJpg);
var _hipAdbuctionJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/hip_adbuction.jpg");
var _hipAdbuctionJpgDefault = parcelHelpers.interopDefault(_hipAdbuctionJpg);
var _hipAdbuction2Jpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/hip_adbuction_2.jpg");
var _hipAdbuction2JpgDefault = parcelHelpers.interopDefault(_hipAdbuction2Jpg);
var _jumpRopeJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/jump_rope.jpg");
var _jumpRopeJpgDefault = parcelHelpers.interopDefault(_jumpRopeJpg);
var _kettlebellJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/kettlebell.jpg");
var _kettlebellJpgDefault = parcelHelpers.interopDefault(_kettlebellJpg);
var _latPullDownJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/lat_pull_down.jpg");
var _latPullDownJpgDefault = parcelHelpers.interopDefault(_latPullDownJpg);
var _legCurlJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/leg_curl.jpg");
var _legCurlJpgDefault = parcelHelpers.interopDefault(_legCurlJpg);
var _legExtensionJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/leg_extension.jpg");
var _legExtensionJpgDefault = parcelHelpers.interopDefault(_legExtensionJpg);
var _legPressJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/leg_press.jpg");
var _legPressJpgDefault = parcelHelpers.interopDefault(_legPressJpg);
var _newCrossoverJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/new_crossover.jpg");
var _newCrossoverJpgDefault = parcelHelpers.interopDefault(_newCrossoverJpg);
var _pulleyMachineJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/pulley_machine.jpg");
var _pulleyMachineJpgDefault = parcelHelpers.interopDefault(_pulleyMachineJpg);
var _seatedRowMachineJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/seated_row_machine.jpg");
var _seatedRowMachineJpgDefault = parcelHelpers.interopDefault(_seatedRowMachineJpg);
var _shoulderPressJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/shoulder_press.jpg");
var _shoulderPressJpgDefault = parcelHelpers.interopDefault(_shoulderPressJpg);
var _tricepsDipMachineJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/triceps_dip_machine.jpg");
var _tricepsDipMachineJpgDefault = parcelHelpers.interopDefault(_tricepsDipMachineJpg);
var _yogaMatJpg = require("url:../../../../../../../assets/images/onboarding-trainer/equipment/yoga_mat.jpg");
var _yogaMatJpgDefault = parcelHelpers.interopDefault(_yogaMatJpg);
var _radioTick2Svg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/radio-tick-2.svg");
const equipmentImageMap = {
    dumbell: (0, _dumbellJpgDefault.default),
    kettlebell: (0, _kettlebellJpgDefault.default),
    barbell: (0, _barbellJpgDefault.default),
    bench: (0, _benchJpgDefault.default),
    crunch_bench: (0, _crunchBenchJpgDefault.default),
    abs_crunch_machine: (0, _absCrunchMachineJpgDefault.default),
    chest_press: (0, _chestPressJpgDefault.default),
    fitness_ball: (0, _fitnessBallJpgDefault.default),
    foam_roller: (0, _foamRollerJpgDefault.default),
    hip_adbuction: (0, _hipAdbuctionJpgDefault.default),
    hip_adbuction_2: (0, _hipAdbuction2JpgDefault.default),
    jump_rope: (0, _jumpRopeJpgDefault.default),
    lat_pull_down: (0, _latPullDownJpgDefault.default),
    leg_curl: (0, _legCurlJpgDefault.default),
    leg_extension: (0, _legExtensionJpgDefault.default),
    leg_press: (0, _legPressJpgDefault.default),
    new_crossover: (0, _newCrossoverJpgDefault.default),
    pulley_machine: (0, _pulleyMachineJpgDefault.default),
    seated_row_machine: (0, _seatedRowMachineJpgDefault.default),
    shoulder_press: (0, _shoulderPressJpgDefault.default),
    triceps_dip_machine: (0, _tricepsDipMachineJpgDefault.default),
    yoga_mat: (0, _yogaMatJpgDefault.default)
};
const SelectEquipmentStep = ({ value, onChange, isMandatory })=>{
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const stepData = programMasterData?.gymEquipments;
    const tabs = (0, _react.useMemo)(()=>stepData?.tabs || [], [
        stepData?.tabs
    ]);
    const equipmentOptions = (0, _react.useMemo)(()=>stepData?.options || [], [
        stepData?.options
    ]);
    const [tab, setTab] = (0, _react.useState)('');
    (0, _react.useEffect)(()=>{
        if (tabs.length > 0 && !tab) setTab(tabs[0].id);
    }, [
        tabs,
        tab
    ]);
    const sortedOptions = [
        ...equipmentOptions
    ].sort((a, b)=>(a.order || 0) - (b.order || 0));
    const filteredEquipment = sortedOptions.filter((item)=>item.tab === tab);
    const toggleEquipment = (id)=>{
        if (value.includes(id)) onChange(value.filter((itemId)=>itemId !== id));
        else onChange([
            ...value,
            id
        ]);
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "select-equipment-step",
        children: 'Loading options...'
    });
    if (isError || !stepData) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "select-equipment-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "select-equipment-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: stepData?.title
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "step-subtitle",
                children: isMandatory ? 'Select at least one item to continue' : stepData?.subtitle
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "tab-toggle",
                children: tabs.map((t)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `tab ${tab === t.id ? 'active' : ''}`,
                        onClick: ()=>setTab(t.id),
                        children: t.title
                    }, t.id))
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "equipment-list-wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `equipment-list ${filteredEquipment.length > 3 ? 'is-scrollable' : ''}`,
                        children: filteredEquipment.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: `equipment-item ${value.includes(item.slug) ? 'selected' : ''}`,
                                onClick: ()=>toggleEquipment(item.slug),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "equipment-info",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "equipment-avatar",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                    src: equipmentImageMap[item.image],
                                                    alt: item.title,
                                                    className: "avatar-img"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "equipment-name",
                                                children: item.title
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "equipment-radio",
                                        children: value.includes(item.slug) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _radioTick2Svg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "radio-circle"
                                        })
                                    })
                                ]
                            }, item.id))
                    }),
                    filteredEquipment.length > 4 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "list-fade-overlay"
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/api/mutations/useGetProgramMasterData":"bOtFg","./SelectEquipmentStep.scss":"bwmTJ","url:../../../../../../../assets/images/onboarding-trainer/equipment/abs_crunch_machine.jpg":"d1m9J","url:../../../../../../../assets/images/onboarding-trainer/equipment/barbell.jpg":"j5bX5","url:../../../../../../../assets/images/onboarding-trainer/equipment/bench.jpg":"8MZpj","url:../../../../../../../assets/images/onboarding-trainer/equipment/chest_press.jpg":"gHnk9","url:../../../../../../../assets/images/onboarding-trainer/equipment/crunch_bench.jpg":"8wFwp","url:../../../../../../../assets/images/onboarding-trainer/equipment/dumbell.jpg":"jU59H","url:../../../../../../../assets/images/onboarding-trainer/equipment/fitness_ball.jpg":"elAWO","url:../../../../../../../assets/images/onboarding-trainer/equipment/foam_roller.jpg":"h1xVP","url:../../../../../../../assets/images/onboarding-trainer/equipment/hip_adbuction.jpg":"hvOys","url:../../../../../../../assets/images/onboarding-trainer/equipment/hip_adbuction_2.jpg":"fRh95","url:../../../../../../../assets/images/onboarding-trainer/equipment/jump_rope.jpg":"5SkxR","url:../../../../../../../assets/images/onboarding-trainer/equipment/kettlebell.jpg":"3zXmT","url:../../../../../../../assets/images/onboarding-trainer/equipment/lat_pull_down.jpg":"3Kcbe","url:../../../../../../../assets/images/onboarding-trainer/equipment/leg_curl.jpg":"fBGLX","url:../../../../../../../assets/images/onboarding-trainer/equipment/leg_extension.jpg":"VhgRs","url:../../../../../../../assets/images/onboarding-trainer/equipment/leg_press.jpg":"9cuNz","url:../../../../../../../assets/images/onboarding-trainer/equipment/new_crossover.jpg":"reW7r","url:../../../../../../../assets/images/onboarding-trainer/equipment/pulley_machine.jpg":"drde4","url:../../../../../../../assets/images/onboarding-trainer/equipment/seated_row_machine.jpg":"bvk4v","url:../../../../../../../assets/images/onboarding-trainer/equipment/shoulder_press.jpg":"3ys4F","url:../../../../../../../assets/images/onboarding-trainer/equipment/triceps_dip_machine.jpg":"6Qj2i","url:../../../../../../../assets/images/onboarding-trainer/equipment/yoga_mat.jpg":"ae1et","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/radio-tick-2.svg":"hejBm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bwmTJ":[function() {},{}],"d1m9J":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("k7AAU");

},{}],"j5bX5":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("uONBT");

},{}],"8MZpj":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7MUca");

},{}],"gHnk9":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6RUDX");

},{}],"8wFwp":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cXQ9g");

},{}],"jU59H":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3Yzvb");

},{}],"elAWO":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2b27S");

},{}],"h1xVP":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("a8OYF");

},{}],"hvOys":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dSVb9");

},{}],"fRh95":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4wlKV");

},{}],"5SkxR":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("8vWfS");

},{}],"3zXmT":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("had2I");

},{}],"3Kcbe":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("beZR3");

},{}],"fBGLX":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3uf0n");

},{}],"VhgRs":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("dlmX9");

},{}],"9cuNz":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fM6Ge");

},{}],"reW7r":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("7PKYy");

},{}],"drde4":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("awgKR");

},{}],"bvk4v":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4ybcF");

},{}],"3ys4F":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("eqQrN");

},{}],"6Qj2i":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4JnYK");

},{}],"ae1et":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4hlXw");

},{}],"fDaDd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReviewStep", ()=>ReviewStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reviewStepScss = require("./ReviewStep.scss");
var _useGetProgramMasterData = require("src/api/mutations/useGetProgramMasterData");
var _programGeneratorProgressStore = require("src/store/programGeneratorProgressStore");
var _useSummarizeInstructionProd = require("src/api/mutations/useSummarizeInstructionProd");
var _buildPayload = require("../utils/buildPayload");
var _injurieslimitationsMaleNeckWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-neck.webp");
var _injurieslimitationsMaleNeckWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleNeckWebp);
var _injurieslimitationsMaleShouldersWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-shoulders.webp");
var _injurieslimitationsMaleShouldersWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleShouldersWebp);
var _injurieslimitationsMaleChestWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-chest.webp");
var _injurieslimitationsMaleChestWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleChestWebp);
var _injurieslimitationsMaleCoreWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-core.webp");
var _injurieslimitationsMaleCoreWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleCoreWebp);
var _injurieslimitationsMaleBackWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-back.webp");
var _injurieslimitationsMaleBackWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleBackWebp);
var _injurieslimitationsMaleWristsWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-wrists.webp");
var _injurieslimitationsMaleWristsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleWristsWebp);
var _injurieslimitationsMaleElbowWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-elbow.webp");
var _injurieslimitationsMaleElbowWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleElbowWebp);
var _injurieslimitationsMaleArmsWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-arms.webp");
var _injurieslimitationsMaleArmsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleArmsWebp);
var _injurieslimitationsMaleHipsWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-hips.webp");
var _injurieslimitationsMaleHipsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleHipsWebp);
var _injurieslimitationsMaleKneesWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-knees.webp");
var _injurieslimitationsMaleKneesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleKneesWebp);
var _injurieslimitationsMaleAnklesWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-ankles.webp");
var _injurieslimitationsMaleAnklesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleAnklesWebp);
var _injurieslimitationsMaleGlutesWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-male-glutes.webp");
var _injurieslimitationsMaleGlutesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsMaleGlutesWebp);
var _injurieslimitationsFemaleNeckWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-neck.webp");
var _injurieslimitationsFemaleNeckWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleNeckWebp);
var _injurieslimitationsFemaleShouldersWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-shoulders.webp");
var _injurieslimitationsFemaleShouldersWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleShouldersWebp);
var _injurieslimitationsFemaleChestWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-chest.webp");
var _injurieslimitationsFemaleChestWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleChestWebp);
var _injurieslimitationsFemaleCoreWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-core.webp");
var _injurieslimitationsFemaleCoreWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleCoreWebp);
var _injurieslimitationsFemaleBackWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-back.webp");
var _injurieslimitationsFemaleBackWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleBackWebp);
var _injurieslimitationsFemaleWristsWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-wrists.webp");
var _injurieslimitationsFemaleWristsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleWristsWebp);
var _injurieslimitationsFemaleElbowWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-elbow.webp");
var _injurieslimitationsFemaleElbowWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleElbowWebp);
var _injurieslimitationsFemaleArmsWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-arms.webp");
var _injurieslimitationsFemaleArmsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleArmsWebp);
var _injurieslimitationsFemaleHipsWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-hips.webp");
var _injurieslimitationsFemaleHipsWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleHipsWebp);
var _injurieslimitationsFemaleKneesWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-knees.webp");
var _injurieslimitationsFemaleKneesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleKneesWebp);
var _injurieslimitationsFemaleAnklesWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-ankles.webp");
var _injurieslimitationsFemaleAnklesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleAnklesWebp);
var _injurieslimitationsFemaleGlutesWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-glutes.webp");
var _injurieslimitationsFemaleGlutesWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemaleGlutesWebp);
var _injurieslimitationsFemalePregnancyWebp = require("url:src/assets/images/trainer/program-generator/injurieslimitations-female-pregnancy.webp");
var _injurieslimitationsFemalePregnancyWebpDefault = parcelHelpers.interopDefault(_injurieslimitationsFemalePregnancyWebp);
var _movementInsightsSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/movement_insights.svg");
var _intensitySetupSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg");
var _programSummarySvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/program_summary.svg");
var _clientProfileSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/client_profile.svg");
var _injuriesNotesSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injuries_notes.svg");
var _planStructureSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/plan_structure.svg");
var _programGoalsSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/program_goals.svg");
var _goalApproachSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/goal_approach.svg");
var _notificationSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/notification.svg");
var _generateSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/generate.svg");
var _monthSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/month.svg");
var _otherSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/other.svg");
var _editSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/edit.svg");
var _equipmentIcons = require("src/utils/equipmentIcons");
var _genderUtils = require("src/utils/genderUtils");
var _intensityCard = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/ProgramTab/IntensityCard");
const mapActivityLevel = (level)=>{
    if (level < 30) return 'Lightly Active';
    if (level < 70) return 'Moderately Active';
    return 'Very Active';
};
const mapEnergyLevel = (level)=>{
    if (level === 'often-low') return 'Often Low';
    if (level === 'often-high') return 'Often High';
    return 'Fluctuates';
};
const mapFitnessLevel = (level)=>{
    switch(level){
        case 'beginner':
            return 'Beginner';
        case 'early-intermediate':
            return 'Early Intermediate';
        case 'intermediate':
            return 'Intermediate';
        case 'advanced':
            return 'Advanced';
        case 'athlete':
            return 'Athlete';
        default:
            return level ? level.charAt(0).toUpperCase() + level.slice(1) : 'Beginner';
    }
};
const mapIntensity = (intensity)=>{
    if (intensity === 'low-intensity') return 'Low';
    if (intensity === 'high-intensity') return 'High';
    return 'Balanced';
};
const mapMovementInsight = (level)=>{
    switch(level){
        case 'pain':
            return 1;
        case 'limited':
            return 2;
        case 'good':
            return 3;
        default:
            return 1;
    }
};
const renderDots = (value, max = 6)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "value-dots",
        children: Array.from({
            length: max
        }).map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `dot ${i < value ? 'purple-100' : 'white-15'}`
            }, i))
    });
};
const customRenderDots = (value, max = 5)=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "value-dots",
        children: Array.from({
            length: max
        }).map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `dot ${i < value ? 'active' : ''}`
            }, i))
    });
};
const renderMarkdownText = (text)=>{
    if (!text) return text;
    const parts = text.split(/(\*\*.*?\*\*)/g);
    return parts.map((part, index)=>{
        if (part.startsWith('**') && part.endsWith('**')) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
            children: part.slice(2, -2)
        }, index);
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
            children: part
        }, index);
    });
};
const ReviewStep = (props)=>{
    const { onEdit, onGenerate, clientName, clientBodyProfile = 'Male', energyLevel, activityLevel, fitnessLevel, movementInsights, injuriesParts, injuriesNotes, programDuration, howOftenTrain, howOftenTrainReminder, workoutDuration, trainingGoal, intensity, selectedEquipment, goalPriority = [], goalApproach, secondaryGoals = [] } = props;
    const { data: programMasterData, isLoading, isError } = (0, _useGetProgramMasterData.useGetProgramMasterData)();
    const { progress, clientId } = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore)();
    const { mutate: summarizeInstruction, data: summaryResponse, isPending: isSummarizing } = (0, _useSummarizeInstructionProd.useSummarizeInstructionProd)();
    const [generatedPayload, setGeneratedPayload] = (0, _react.useState)(null);
    const getDisplayTitle = (slug)=>{
        if (!slug) return slug;
        if (slug.startsWith('other:')) return `Other : ${slug.substring(6)}`;
        if (!programMasterData) return slug;
        let title = null;
        const search = (obj)=>{
            if (title) return;
            if (Array.isArray(obj)) obj.forEach(search);
            else if (obj && typeof obj === 'object') {
                if (obj.slug === slug && obj.title) {
                    title = obj.title;
                    return;
                }
                Object.values(obj).forEach(search);
            }
        };
        search(programMasterData);
        // Fallback if not found, just return original string
        return title || slug;
    };
    (0, _react.useEffect)(()=>{
        const payload = (0, _buildPayload.buildPayloadFromProgress)(progress, clientId);
        if (payload) {
            setGeneratedPayload(payload);
            summarizeInstruction(payload);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const stepData = programMasterData?.gymEquipments;
    const selectedEquipmentOptions = stepData?.options?.filter((item)=>selectedEquipment.includes(item.slug));
    const isFemale = (0, _genderUtils.isFemaleProfile)(clientBodyProfile);
    const injuryIconMapping = {
        neck: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleNeckWebpDefault.default),
            alt: "InjurieslimitationsFemaleNeckIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleNeckWebpDefault.default),
            alt: "InjurieslimitationsMaleNeckIcon",
            className: "program-svg-icon"
        }),
        shoulders: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleShouldersWebpDefault.default),
            alt: "InjurieslimitationsFemaleShouldersIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleShouldersWebpDefault.default),
            alt: "InjurieslimitationsMaleShouldersIcon",
            className: "program-svg-icon"
        }),
        chest: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleChestWebpDefault.default),
            alt: "InjurieslimitationsFemaleChestIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleChestWebpDefault.default),
            alt: "InjurieslimitationsMaleChestIcon",
            className: "program-svg-icon"
        }),
        core: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleCoreWebpDefault.default),
            alt: "InjurieslimitationsFemaleCoreIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleCoreWebpDefault.default),
            alt: "InjurieslimitationsMaleCoreIcon",
            className: "program-svg-icon"
        }),
        back: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleBackWebpDefault.default),
            alt: "InjurieslimitationsFemaleBackIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleBackWebpDefault.default),
            alt: "InjurieslimitationsMaleBackIcon",
            className: "program-svg-icon"
        }),
        wrists: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleWristsWebpDefault.default),
            alt: "InjurieslimitationsFemaleWristsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleWristsWebpDefault.default),
            alt: "InjurieslimitationsMaleWristsIcon",
            className: "program-svg-icon"
        }),
        elbow: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleElbowWebpDefault.default),
            alt: "InjurieslimitationsFemaleElbowIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleElbowWebpDefault.default),
            alt: "InjurieslimitationsMaleElbowIcon",
            className: "program-svg-icon"
        }),
        arms: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleArmsWebpDefault.default),
            alt: "InjurieslimitationsFemaleArmsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleArmsWebpDefault.default),
            alt: "InjurieslimitationsMaleArmsIcon",
            className: "program-svg-icon"
        }),
        hips: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleHipsWebpDefault.default),
            alt: "InjurieslimitationsFemaleHipsIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleHipsWebpDefault.default),
            alt: "InjurieslimitationsMaleHipsIcon",
            className: "program-svg-icon"
        }),
        knees: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleKneesWebpDefault.default),
            alt: "InjurieslimitationsFemaleKneesIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleKneesWebpDefault.default),
            alt: "InjurieslimitationsMaleKneesIcon",
            className: "program-svg-icon"
        }),
        ankles: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleAnklesWebpDefault.default),
            alt: "InjurieslimitationsFemaleAnklesIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleAnklesWebpDefault.default),
            alt: "InjurieslimitationsMaleAnklesIcon",
            className: "program-svg-icon"
        }),
        glutes: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemaleGlutesWebpDefault.default),
            alt: "InjurieslimitationsFemaleGlutesIcon",
            className: "program-svg-icon"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsMaleGlutesWebpDefault.default),
            alt: "InjurieslimitationsMaleGlutesIcon",
            className: "program-svg-icon"
        }),
        pregnancy: isFemale ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
            src: (0, _injurieslimitationsFemalePregnancyWebpDefault.default),
            alt: "InjurieslimitationsFemalePregnancyIcon",
            className: "program-svg-icon"
        }) : null
    };
    const MovementInsights = {
        1: 'Pain',
        2: 'Limited',
        3: 'Good'
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "review-step",
        children: 'Loading options...'
    });
    if (isError) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "review-step",
        children: 'Error loading options.'
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "review-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "step-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        className: "step-title",
                        children: 'Review the program before we create it'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "step-subtitle",
                        children: 'Tap any card to adjust details before generating the program'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "review-grid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "review-card card-summary",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "summary-icon",
                                onClick: ()=>onEdit(12),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programSummarySvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "summary-title",
                                children: `${clientName && clientName.length > 15 ? `${clientName.slice(0, 15)}...` : clientName} \u{2022} Program Summary`
                            }),
                            isSummarizing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "summary-desc",
                                children: "Generating AI summary..."
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "summary-desc",
                                children: summaryResponse?.response ? renderMarkdownText(summaryResponse.response) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        programDuration,
                                        "-week ",
                                        getDisplayTitle(trainingGoal),
                                        " program for an",
                                        ' ',
                                        mapFitnessLevel(fitnessLevel).toLowerCase(),
                                        " client, focused on",
                                        ' ',
                                        goalPriority.length > 0 ? goalPriority.map(getDisplayTitle).join(', ') : 'full body',
                                        ", adapted for",
                                        ' ',
                                        injuriesParts.length > 0 ? injuriesParts.map(getDisplayTitle).join(' and ') : 'no',
                                        ' ',
                                        "limitations."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "summary-badges",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "badge",
                                        children: [
                                            programDuration,
                                            " Weeks"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "badge",
                                        children: [
                                            howOftenTrain.length,
                                            " Days / Week"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "badge",
                                        children: [
                                            workoutDuration.replace('-min', ''),
                                            " Mins"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                className: "generate-btn",
                                disabled: isSummarizing,
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    if (generatedPayload) onGenerate(generatedPayload);
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _generateSvg.ReactComponent), {}),
                                    " ",
                                    'Generate with miniPT AI'
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "review-card client-profile-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clientProfileSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "card-title",
                                        children: 'Client Profile'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        onClick: ()=>onEdit(3),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "card-body",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "info-row client-profile-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "client-profile-details",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value fitness-level-value",
                                                    children: mapFitnessLevel(fitnessLevel)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "inline-info",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "label",
                                                            children: 'Energy:'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: mapEnergyLevel(energyLevel)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "inline-info",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "label",
                                                            children: 'Activity:'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: mapActivityLevel(activityLevel)
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "client-profile-graphs",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "client-profile-chart",
                                                    children: [
                                                        40,
                                                        60,
                                                        30,
                                                        80,
                                                        50,
                                                        70,
                                                        90
                                                    ].map((h, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: `bar bar-h${h}`
                                                        }, i))
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "client-profile-dots",
                                                    children: renderDots(activityLevel != null && !isNaN(Number(activityLevel)) ? Math.min(6, Math.max(1, Math.ceil(Number(activityLevel) / 100 * 6))) : 0, 6)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "review-card movement-insights-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _movementInsightsSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "card-title",
                                        children: 'Movement Insights'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        onClick: ()=>onEdit(6),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body movement-insights",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: 'Mobility:'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: MovementInsights[mapMovementInsight(movementInsights[0]) || 1]
                                            }),
                                            customRenderDots(mapMovementInsight(movementInsights[0]) || 1, 3)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: 'Stability:'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: MovementInsights[mapMovementInsight(movementInsights[1]) || 1]
                                            }),
                                            customRenderDots(mapMovementInsight(movementInsights[1]) || 1, 3)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: 'Balance:'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: MovementInsights[mapMovementInsight(movementInsights[2]) || 1]
                                            }),
                                            customRenderDots(mapMovementInsight(movementInsights[2]) || 1, 3)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: 'Movement Symmetry:'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: MovementInsights[mapMovementInsight(movementInsights[3]) || 1]
                                            }),
                                            customRenderDots(mapMovementInsight(movementInsights[3]) || 1, 3)
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: 'Movement Quality:'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "value",
                                                children: MovementInsights[mapMovementInsight(movementInsights[4]) || 1]
                                            }),
                                            customRenderDots(mapMovementInsight(movementInsights[4]) || 1, 3)
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "review-card program-goals-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _programGoalsSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "card-title",
                                        children: 'Program Goals'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        onClick: ()=>onEdit(12),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body program-goals-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "program-goals",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "info-row primary-goal-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "bullet orange-bullet",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value training-goal-value",
                                                        children: trainingGoal ? getDisplayTitle(trainingGoal) : 'General Fitness'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "info-row priority-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label",
                                                        children: 'Priority:'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "value priority-value",
                                                        children: goalPriority?.length ? goalPriority.map(getDisplayTitle).join(', ') : 'None'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "info-row secondary-header-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "bullet white-bullet",
                                                        children: "\u2022"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label secondary-label",
                                                        children: 'Secondary Support:'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "info-row secondary-value-row",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value secondary-value",
                                                    children: (()=>{
                                                        const validSecondary = secondaryGoals?.filter((g)=>g && g.trim().length > 0 && g.toLowerCase() !== 'none');
                                                        return validSecondary && validSecondary.length > 0 ? validSecondary.map(getDisplayTitle).join(', ') : 'None';
                                                    })()
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "program-goals-graph",
                                        children: (()=>{
                                            const validSecondary = secondaryGoals?.filter((g)=>g && g.trim().length > 0 && g.toLowerCase() !== 'none');
                                            const hasSecondary = validSecondary && validSecondary.length > 0;
                                            const secondaryPct = hasSecondary ? 15 : 0;
                                            const mainPct = 100 - secondaryPct;
                                            const radius = 26;
                                            const strokeWidth = 7.5;
                                            const circumference = 2 * Math.PI * radius;
                                            const secondaryOffset = circumference * (1 - secondaryPct / 100);
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "goal-pie-chart-wrapper",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                    viewBox: "0 0 110 82",
                                                    className: "goal-pie-svg",
                                                    style: {
                                                        width: '100%',
                                                        height: 'auto',
                                                        overflow: 'visible'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                            cx: "34",
                                                            cy: "44",
                                                            r: radius,
                                                            fill: "none",
                                                            stroke: "#ffa100",
                                                            strokeWidth: strokeWidth
                                                        }),
                                                        hasSecondary && /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                            cx: "34",
                                                            cy: "44",
                                                            r: radius,
                                                            fill: "none",
                                                            stroke: "#ffffff",
                                                            strokeWidth: strokeWidth,
                                                            strokeDasharray: circumference,
                                                            strokeDashoffset: secondaryOffset,
                                                            transform: "rotate(-90 34 44)"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                                                            x: "34",
                                                            y: "50",
                                                            textAnchor: "middle",
                                                            fill: "#ffa100",
                                                            fontSize: "15",
                                                            fontWeight: "700",
                                                            fontFamily: "inherit",
                                                            children: [
                                                                mainPct,
                                                                "%"
                                                            ]
                                                        }),
                                                        hasSecondary && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                                                            className: "leader-group",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                    d: "M 48 25 L 62 12 L 88 12",
                                                                    stroke: "#ffffff",
                                                                    strokeWidth: "1.2",
                                                                    fill: "none"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                                                                    x: "76",
                                                                    y: "8",
                                                                    textAnchor: "middle",
                                                                    fill: "#ffffff",
                                                                    fontSize: "11",
                                                                    fontWeight: "600",
                                                                    fontFamily: "inherit",
                                                                    children: [
                                                                        secondaryPct,
                                                                        "%"
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            });
                                        })()
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "review-card goal-approach-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _goalApproachSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "card-title",
                                        children: 'Goal Approach'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        onClick: ()=>onEdit(13),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "card-body",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "info-row client-profile-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "client-profile-details",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "inline-info",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label clamped-value",
                                                        children: goalPriority?.length ? goalPriority.map(getDisplayTitle).join(', ') : 'N/A'
                                                    })
                                                }),
                                                goalApproach && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "inline-info",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "label clamped-value",
                                                        children: getDisplayTitle(goalApproach || '')
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "client-profile-graphs",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "client-profile-chart",
                                                children: [
                                                    40,
                                                    60,
                                                    30,
                                                    80,
                                                    50,
                                                    70,
                                                    90
                                                ].map((h, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: `bar bar-h${h}`
                                                    }, i))
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "review-card plan-structure-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _planStructureSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "card-title",
                                        children: 'Plan Structure'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        onClick: ()=>onEdit(10),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body plan-structure-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "plan-structure",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "inline-info",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "value icon-value-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "icon-emoji",
                                                            children: [
                                                                " ",
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _monthSvg.ReactComponent), {})
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: howOftenTrain.length > 3 ? `${howOftenTrain.length} Days / Week` : [
                                                                ...howOftenTrain
                                                            ].sort((a, b)=>[
                                                                    'monday',
                                                                    'tuesday',
                                                                    'wednesday',
                                                                    'thursday',
                                                                    'friday',
                                                                    'saturday',
                                                                    'sunday'
                                                                ].indexOf(a) - [
                                                                    'monday',
                                                                    'tuesday',
                                                                    'wednesday',
                                                                    'thursday',
                                                                    'friday',
                                                                    'saturday',
                                                                    'sunday'
                                                                ].indexOf(b)).map((d)=>d.charAt(0).toUpperCase() + d.substring(1, 3)).join(' / ')
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "inline-info",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "value icon-value-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "icon-emoji",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _notificationSvg.ReactComponent), {})
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            children: [
                                                                howOftenTrainReminder,
                                                                " reminder"
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "plan-structure-svg",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "calendar-widget",
                                            children: [
                                                'monday',
                                                'tuesday',
                                                'wednesday',
                                                'thursday',
                                                'friday',
                                                'saturday',
                                                'sunday'
                                            ].map((day, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "calendar-day-col",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "day-label",
                                                            children: day.charAt(0).toUpperCase()
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: `dot top-dot ${howOftenTrain.includes(day) ? 'active' : ''}`
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "dot"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "dot"
                                                        })
                                                    ]
                                                }, idx))
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "review-card intensity-setup-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _intensitySetupSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "card-title",
                                        children: 'Intensity & Setup'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        onClick: ()=>onEdit(15),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body intensity-setup-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "label",
                                                children: 'Intensity:'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "value intensity-value",
                                                children: [
                                                    mapIntensity(intensity),
                                                    renderDots((0, _intensityCard.getIntensityActiveDots)(intensity), 6)
                                                ]
                                            })
                                        ]
                                    }),
                                    selectedEquipmentOptions?.slice(0, 2).map((eq, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "info-row",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value",
                                                    children: getDisplayTitle(eq.slug || eq.title || '')
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "avatar-img",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _equipmentIcons.EquipmentIcon), {
                                                        slug: eq.slug || eq.id || eq.title || ''
                                                    })
                                                })
                                            ]
                                        }, i)),
                                    selectedEquipmentOptions && selectedEquipmentOptions.length > 2 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "value",
                                                children: [
                                                    "+",
                                                    selectedEquipmentOptions.length - 2,
                                                    " Other"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "avatar-img",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _otherSvg.ReactComponent), {})
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "review-card injuries-notes-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _injuriesNotesSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "card-title",
                                        children: 'Injuries & Notes'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "edit-btn",
                                        onClick: ()=>onEdit(7),
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _editSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-body injuries-notes-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "injuries-notes",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "inline-info",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value injuries-value",
                                                    children: injuriesParts.length > 0 ? injuriesParts.slice(0, 3).map(getDisplayTitle).join(', ') + (injuriesParts.length > 3 ? '...' : '') : 'None'
                                                })
                                            }),
                                            injuriesNotes ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "inline-info",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value notes-value",
                                                    children: injuriesNotes
                                                })
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "inline-info",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value",
                                                    children: "No special notes"
                                                })
                                            })
                                        ]
                                    }),
                                    injuriesParts.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "injuries-notes-image",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "stacked-images",
                                            children: injuriesParts.slice(0, 3).reverse().map((part, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `stacked-img stack-${injuriesParts.slice(0, 3).length - 1 - i}`,
                                                    children: injuryIconMapping[part]
                                                }, part))
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./ReviewStep.scss":"6GhA7","src/api/mutations/useGetProgramMasterData":"bOtFg","src/store/programGeneratorProgressStore":"2iAYB","src/api/mutations/useSummarizeInstructionProd":"b5oCa","../utils/buildPayload":"43eYD","url:src/assets/images/trainer/program-generator/injurieslimitations-male-neck.webp":"bMNGc","url:src/assets/images/trainer/program-generator/injurieslimitations-male-shoulders.webp":"9f150","url:src/assets/images/trainer/program-generator/injurieslimitations-male-chest.webp":"1WA6S","url:src/assets/images/trainer/program-generator/injurieslimitations-male-core.webp":"6ykDS","url:src/assets/images/trainer/program-generator/injurieslimitations-male-back.webp":"552LM","url:src/assets/images/trainer/program-generator/injurieslimitations-male-wrists.webp":"2vVR2","url:src/assets/images/trainer/program-generator/injurieslimitations-male-elbow.webp":"5rwm2","url:src/assets/images/trainer/program-generator/injurieslimitations-male-arms.webp":"gywcQ","url:src/assets/images/trainer/program-generator/injurieslimitations-male-hips.webp":"IL2gD","url:src/assets/images/trainer/program-generator/injurieslimitations-male-knees.webp":"chOpQ","url:src/assets/images/trainer/program-generator/injurieslimitations-male-ankles.webp":"9LTxX","url:src/assets/images/trainer/program-generator/injurieslimitations-male-glutes.webp":"axt4z","url:src/assets/images/trainer/program-generator/injurieslimitations-female-neck.webp":"7ieJ8","url:src/assets/images/trainer/program-generator/injurieslimitations-female-shoulders.webp":"c4vn4","url:src/assets/images/trainer/program-generator/injurieslimitations-female-chest.webp":"18x57","url:src/assets/images/trainer/program-generator/injurieslimitations-female-core.webp":"fAYwU","url:src/assets/images/trainer/program-generator/injurieslimitations-female-back.webp":"b7YNj","url:src/assets/images/trainer/program-generator/injurieslimitations-female-wrists.webp":"jqY0l","url:src/assets/images/trainer/program-generator/injurieslimitations-female-elbow.webp":"cUOkG","url:src/assets/images/trainer/program-generator/injurieslimitations-female-arms.webp":"ejSWy","url:src/assets/images/trainer/program-generator/injurieslimitations-female-hips.webp":"4XVjh","url:src/assets/images/trainer/program-generator/injurieslimitations-female-knees.webp":"bahGv","url:src/assets/images/trainer/program-generator/injurieslimitations-female-ankles.webp":"aEszt","url:src/assets/images/trainer/program-generator/injurieslimitations-female-glutes.webp":"1xfcS","url:src/assets/images/trainer/program-generator/injurieslimitations-female-pregnancy.webp":"zojTP","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/movement_insights.svg":"9MrjD","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/intensity_setup.svg":"eHDnc","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/program_summary.svg":"2sXTH","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/client_profile.svg":"4wtpD","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/injuries_notes.svg":"tA9Si","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/plan_structure.svg":"fb3Cp","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/program_goals.svg":"3aLZ1","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/goal_approach.svg":"hkeyK","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/notification.svg":"9EZ1c","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/generate.svg":"cSOwL","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/month.svg":"3C1kF","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/other.svg":"3Cuql","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/components/edit.svg":"jR7RI","src/utils/equipmentIcons":"80Hvz","src/utils/genderUtils":"aiA54","src/screens/OnboardingTrainer/screens/Dashboard/screens/ClientOverview/components/ProgramTab/IntensityCard":"kMOpw","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6GhA7":[function() {},{}],"b5oCa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSummarizeInstructionProd", ()=>useSummarizeInstructionProd);
var _reactQuery = require("@tanstack/react-query");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _apiConfigTs = require("src/config/api-config.ts");
var _apiConfigTsDefault = parcelHelpers.interopDefault(_apiConfigTs);
function useSummarizeInstructionProd() {
    return (0, _reactQuery.useMutation)({
        mutationFn: async (params)=>{
            const response = await (0, _axiosDefault.default).post(`${(0, _apiConfigTsDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigTsDefault.default).SUMMARIZE_INSTRUCTION_PROD_API_HOST}`, {
                data: {
                    ...params,
                    clientIds: [
                        params.clientId
                    ],
                    clientId: undefined
                }
            }, {
                headers: {
                    'Content-Type': 'application/json'
                },
                timeout: 600000
            });
            return response.data?.result || response.data?.data || response.data;
        }
    });
}

},{"@tanstack/react-query":"ehKs4","axios":"kL5AO","src/config/api-config.ts":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"43eYD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "buildPayloadFromProgress", ()=>buildPayloadFromProgress);
var _types = require("../types");
const buildPayloadFromProgress = (progress, clientId)=>{
    if (!clientId || !progress) return null;
    const getValues = (stepId)=>(progress[stepId] || []).map((p)=>p.slug);
    const training_goal = getValues((0, _types.ProgramStepId).TrainingGoal);
    const goal = training_goal[0];
    if (!goal) return null; // We need at least the main goal to build a valid payload
    let dynamicParams = {};
    if (goal === (0, _types.TrainingGoalSlug).IncreaseStrength) dynamicParams = {
        training_goal_details: getValues((0, _types.ProgramStepId).IncreaseStrengthFocus),
        training_goal_preferences: getValues((0, _types.ProgramStepId).IncreaseStrengthOutcome),
        training_goal_approaches: getValues((0, _types.ProgramStepId).IncreaseStrengthApproach)
    };
    else if (goal === (0, _types.TrainingGoalSlug).BuildMuscle) dynamicParams = {
        training_goal_details: getValues((0, _types.ProgramStepId).BuildMusclePrimary),
        training_goal_preferences: getValues((0, _types.ProgramStepId).BuildMuscleSecondary),
        training_goal_approaches: getValues((0, _types.ProgramStepId).BuildMuscleApproach)
    };
    else if (goal === (0, _types.TrainingGoalSlug).WeightLoss) dynamicParams = {
        training_goal_details: getValues((0, _types.ProgramStepId).WeightLossPrimary),
        training_goal_preferences: getValues((0, _types.ProgramStepId).WeightLossSecondary),
        training_goal_approaches: getValues((0, _types.ProgramStepId).WeightLossApproach)
    };
    else if (goal === (0, _types.TrainingGoalSlug).Endurance) dynamicParams = {
        training_goal_details: getValues((0, _types.ProgramStepId).EnduranceType),
        training_goal_approaches: getValues((0, _types.ProgramStepId).EnduranceApproach)
    };
    else if (goal === (0, _types.TrainingGoalSlug).Mobility) dynamicParams = {
        training_goal_details: getValues((0, _types.ProgramStepId).MobilityArea),
        training_goal_preferences: getValues((0, _types.ProgramStepId).MobilityPurpose),
        training_goal_approaches: getValues((0, _types.ProgramStepId).MobilityApproach)
    };
    else if (goal === (0, _types.TrainingGoalSlug).Performance) dynamicParams = {
        training_goal_details: getValues((0, _types.ProgramStepId).PerformanceSupport),
        training_goal_preferences: getValues((0, _types.ProgramStepId).PerformanceFocus),
        training_goal_approaches: getValues((0, _types.ProgramStepId).PerformanceApproach)
    };
    else if (goal === (0, _types.TrainingGoalSlug).GeneralFitness) dynamicParams = {
        training_goal_details: getValues((0, _types.ProgramStepId).GeneralFitnessMeaning),
        training_goal_approaches: getValues((0, _types.ProgramStepId).GeneralFitnessApproach)
    };
    else if (goal === (0, _types.TrainingGoalSlug).Rehabilitation) dynamicParams = {
        training_goal_details: getValues((0, _types.ProgramStepId).RehabilitationArea),
        training_goal_preferences: getValues((0, _types.ProgramStepId).RehabilitationStage),
        training_goal_approaches: getValues((0, _types.ProgramStepId).RehabilitationApproach)
    };
    else if (goal === (0, _types.TrainingGoalSlug).InjuryPrevention) dynamicParams = {
        training_goal_details: getValues((0, _types.ProgramStepId).InjuryPreventionArea),
        training_goal_preferences: getValues((0, _types.ProgramStepId).InjuryPreventionFocus),
        training_goal_approaches: getValues((0, _types.ProgramStepId).InjuryPreventionApproach)
    };
    return {
        clientId: clientId,
        parameters: {
            energy_level: getValues((0, _types.ProgramStepId).EnergyLevel),
            non_gym_activity: getValues((0, _types.ProgramStepId).ActivityLevel),
            fitness_level: getValues((0, _types.ProgramStepId).FitnessLevel),
            movement_insights: getValues((0, _types.ProgramStepId).MovementInsights),
            injuries_limitations: getValues((0, _types.ProgramStepId).InjuriesParts).length > 0 ? getValues((0, _types.ProgramStepId).InjuriesParts) : [
                'None'
            ],
            program_duration: getValues((0, _types.ProgramStepId).ProgramDuration),
            training_schedule: getValues((0, _types.ProgramStepId).HowOftenTrain).length > 0 ? [
                getValues((0, _types.ProgramStepId).HowOftenTrain).join(', ')
            ] : getValues((0, _types.ProgramStepId).HowOftenTrain),
            workout_duration: getValues((0, _types.ProgramStepId).WorkoutDuration),
            training_goal: training_goal,
            secondary_training_goals: getValues((0, _types.ProgramStepId).SecondaryGoals).length > 0 ? getValues((0, _types.ProgramStepId).SecondaryGoals) : [
                'None'
            ],
            program_intensity: getValues((0, _types.ProgramStepId).Intensity),
            gym_equipments: getValues((0, _types.ProgramStepId).SelectedEquipment).length > 0 ? getValues((0, _types.ProgramStepId).SelectedEquipment) : [
                'None'
            ],
            weight_loss_target: goal === (0, _types.TrainingGoalSlug).WeightLoss ? getValues((0, _types.ProgramStepId).WeightLossTarget) : undefined,
            rehabilitation_stage: goal === (0, _types.TrainingGoalSlug).Rehabilitation ? getValues((0, _types.ProgramStepId).RehabilitationStage) : undefined,
            ...dynamicParams
        }
    };
};

},{"../types":"1DGo2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cSOwL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGenerate);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGenerate = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#04051B",
            d: "m10.684 8.78-1.433 2.3a.48.48 0 0 1-.508.234q-.325-.05-.409-.383l-.467-1.867-4.55 4.55a.65.65 0 0 1-.458.192.62.62 0 0 1-.475-.192.63.63 0 0 1-.183-.467q0-.283.183-.466l4.55-4.567-1.867-.467q-.333-.082-.383-.408a.48.48 0 0 1 .233-.508l2.3-1.417-.2-2.717a.45.45 0 0 1 .267-.483q.3-.15.55.067l2.083 1.75 2.517-1.017q.317-.133.55.1.234.234.1.55l-1.017 2.517 1.75 2.066a.46.46 0 0 1 .067.55q-.15.3-.483.267zM2.151 4.315a.32.32 0 0 1 0-.467l.866-.866a.32.32 0 0 1 .467 0l.867.866a.32.32 0 0 1 0 .467l-.867.867a.32.32 0 0 1-.467 0zm9.533 9.533-.867-.866a.32.32 0 0 1 0-.467l.867-.867a.32.32 0 0 1 .467 0l.866.867a.32.32 0 0 1 0 .467l-.866.866a.32.32 0 0 1-.467 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bwANQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgramNameStep", ()=>ProgramNameStep);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _button = require("../../../../../../../components/Button/Button");
var _nextSvg = require("../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/next.svg");
var _programNameStepScss = require("./ProgramNameStep.scss");
const ProgramNameStep = ({ value = '', onChange, onNext })=>{
    const [localValue, setLocalValue] = (0, _react.useState)(value);
    const handleBlur = (e)=>{
        const trimmed = e.target.value.trim();
        setLocalValue(trimmed);
        onChange(trimmed);
    };
    const handleChange = (e)=>{
        setLocalValue(e.target.value);
        onChange(e.target.value);
    };
    const isValid = localValue.trim().length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "program-name-step",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                className: "step-title",
                children: "Let's give your workout a name"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "input-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Input), {
                    className: "program-name-input",
                    placeholder: "Enter Workout Name",
                    maxLength: 100,
                    value: localValue,
                    onChange: handleChange,
                    onBlur: handleBlur,
                    onPressEnter: ()=>{
                        if (isValid) onNext();
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "action-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                    variant: "primary",
                    className: "next-btn right-arrow m-height-48 btn-primary-white",
                    onClick: onNext,
                    svg: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _nextSvg.ReactComponent), {}),
                    disabled: !isValid,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        style: {
                            color: '#000',
                            fontWeight: 'bold'
                        },
                        children: "Next"
                    })
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Input","ajgzU","default"]],"../../../../../../../components/Button/Button":"g0894","../../../../../../../assets/images/onboarding-trainer/dashboard/program-generator-ai/next.svg":"ixBdp","./ProgramNameStep.scss":"g2nOx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ajgzU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _group = require("./Group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _otp = require("./OTP");
var _otpDefault = parcelHelpers.interopDefault(_otp);
var _password = require("./Password");
var _passwordDefault = parcelHelpers.interopDefault(_password);
var _search = require("./Search");
var _searchDefault = parcelHelpers.interopDefault(_search);
var _textArea = require("./TextArea");
var _textAreaDefault = parcelHelpers.interopDefault(_textArea);
"use client";
const Input = (0, _inputDefault.default);
Input.Group = (0, _groupDefault.default);
Input.Search = (0, _searchDefault.default);
Input.TextArea = (0, _textAreaDefault.default);
Input.Password = (0, _passwordDefault.default);
Input.OTP = (0, _otpDefault.default);
exports.default = Input;

},{"./Group":"3wVrQ","./Input":"ha6HZ","./OTP":"hRCCB","./Password":"8gqM5","./Search":"lsEWS","./TextArea":"dnpOk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3wVrQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _warning = require("../_util/warning");
var _configProvider = require("../config-provider");
var _context = require("../form/context");
var _space = require("../space");
var _spaceDefault = parcelHelpers.interopDefault(_space);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
/** @deprecated Please use `Space.Compact` */ const Group = (props)=>{
    const { getPrefixCls, direction } = (0, _react.useContext)((0, _configProvider.ConfigContext));
    const { prefixCls: customizePrefixCls, className } = props;
    const prefixCls = getPrefixCls('input-group', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input');
    const [hashId, cssVarCls] = (0, _styleDefault.default)(inputPrefixCls);
    const cls = (0, _clsx.clsx)(prefixCls, cssVarCls, {
        [`${prefixCls}-lg`]: props.size === 'large',
        [`${prefixCls}-sm`]: props.size === 'small',
        [`${prefixCls}-compact`]: props.compact,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, hashId, className);
    const formItemContext = (0, _react.useContext)((0, _context.FormItemInputContext));
    const groupFormItemContext = (0, _react.useMemo)(()=>({
            ...formItemContext,
            isFormItemInput: false
        }), [
        formItemContext
    ]);
    return /*#__PURE__*/ _react.createElement((0, _context.FormItemInputContext).Provider, {
        value: groupFormItemContext
    }, /*#__PURE__*/ _react.createElement((0, _spaceDefault.default).Compact, {
        className: cls,
        style: props.style,
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        onFocus: props.onFocus,
        onBlur: props.onBlur
    }, props.children));
};
exports.default = Group;

},{"react":"bmhQu","clsx":"431Ou","../_util/warning":"95o3w","../config-provider":"dVeAX","../form/context":"krZYn","../space":"j7a5D","./style":"8tbVx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ha6HZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "triggerFocus", ()=>(0, _focus.triggerFocus));
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _input = require("@rc-component/input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _focus = require("@rc-component/util/es/Dom/focus");
var _ref = require("@rc-component/util/es/ref");
var _clsx = require("clsx");
var _contextIsolator = require("../_util/ContextIsolator");
var _contextIsolatorDefault = parcelHelpers.interopDefault(_contextIsolator);
var _getAllowClear = require("../_util/getAllowClear");
var _getAllowClearDefault = parcelHelpers.interopDefault(_getAllowClear);
var _hooks = require("../_util/hooks");
var _statusUtils = require("../_util/statusUtils");
var _warning = require("../_util/warning");
var _context = require("../config-provider/context");
var _disabledContext = require("../config-provider/DisabledContext");
var _disabledContextDefault = parcelHelpers.interopDefault(_disabledContext);
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _useSize = require("../config-provider/hooks/useSize");
var _useSizeDefault = parcelHelpers.interopDefault(_useSize);
var _context1 = require("../form/context");
var _useVariants = require("../form/hooks/useVariants");
var _useVariantsDefault = parcelHelpers.interopDefault(_useVariants);
var _compact = require("../space/Compact");
var _useRemovePasswordTimeout = require("./hooks/useRemovePasswordTimeout");
var _useRemovePasswordTimeoutDefault = parcelHelpers.interopDefault(_useRemovePasswordTimeout);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _utils = require("./utils");
"use client";
const Input = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered = true, status: customStatus, size: customSize, disabled: customDisabled, onBlur, onFocus, suffix, allowClear, addonAfter, addonBefore, className, style, styles, rootClassName, onChange, classNames, variant: customVariant, ...rest } = props;
    var prop, newProp;
    const { getPrefixCls, direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('input');
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    const inputRef = (0, _react.useRef)(null);
    // Style
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _style.useSharedStyle)(prefixCls, rootClassName);
    (0, _styleDefault.default)(prefixCls, rootCls);
    // ===================== Compact Item =====================
    const { compactSize, compactItemClassnames } = (0, _compact.useCompactItemContext)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, _useSizeDefault.default)((ctx)=>customSize ?? compactSize ?? ctx);
    // ===================== Disabled =====================
    const disabled = (0, _reactDefault.default).useContext((0, _disabledContextDefault.default));
    const mergedDisabled = customDisabled ?? disabled;
    // =========== Merged Props for Semantic ==========
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: mergedDisabled
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    // ===================== Status =====================
    const { status: contextStatus, hasFeedback, feedbackIcon } = (0, _react.useContext)((0, _context1.FormItemInputContext));
    const mergedStatus = (0, _statusUtils.getMergedStatus)(contextStatus, customStatus);
    // ===================== Focus warning =====================
    const inputHasPrefixSuffix = (0, _utils.hasPrefixSuffix)(props) || !!hasFeedback;
    const prevHasPrefixSuffix = (0, _react.useRef)(inputHasPrefixSuffix);
    /* eslint-enable */ // ===================== Remove Password value =====================
    const removePasswordTimeout = (0, _useRemovePasswordTimeoutDefault.default)(inputRef, true);
    const handleBlur = (e)=>{
        removePasswordTimeout();
        onBlur?.(e);
    };
    const handleFocus = (e)=>{
        removePasswordTimeout();
        onFocus?.(e);
    };
    const handleChange = (e)=>{
        removePasswordTimeout();
        onChange?.(e);
    };
    const suffixNode = (hasFeedback || suffix) && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, suffix, hasFeedback && feedbackIcon);
    const mergedAllowClear = (0, _getAllowClearDefault.default)(allowClear ?? contextAllowClear);
    const [variant, enableVariantCls] = (0, _useVariantsDefault.default)('input', customVariant, bordered);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _inputDefault.default), {
        ref: (0, _ref.composeRef)(ref, inputRef),
        prefixCls: prefixCls,
        autoComplete: contextAutoComplete,
        ...rest,
        disabled: mergedDisabled,
        onBlur: handleBlur,
        onFocus: handleFocus,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        styles: mergedStyles,
        suffix: suffixNode,
        allowClear: mergedAllowClear,
        className: (0, _clsx.clsx)(className, rootClassName, cssVarCls, rootCls, compactItemClassnames, contextClassName, mergedClassNames.root),
        onChange: handleChange,
        addonBefore: addonBefore && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextIsolatorDefault.default), {
            form: true,
            space: true
        }, addonBefore),
        addonAfter: addonAfter && /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _contextIsolatorDefault.default), {
            form: true,
            space: true
        }, addonAfter),
        classNames: {
            ...mergedClassNames,
            input: (0, _clsx.clsx)({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large',
                [`${prefixCls}-rtl`]: direction === 'rtl'
            }, mergedClassNames.input, hashId),
            variant: (0, _clsx.clsx)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, _statusUtils.getStatusClassNames)(prefixCls, mergedStatus)),
            affixWrapper: (0, _clsx.clsx)({
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl'
            }, hashId),
            wrapper: (0, _clsx.clsx)({
                [`${prefixCls}-group-rtl`]: direction === 'rtl'
            }, hashId),
            groupWrapper: (0, _clsx.clsx)({
                [`${prefixCls}-group-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-group-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-group-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-group-wrapper-${variant}`]: enableVariantCls
            }, (0, _statusUtils.getStatusClassNames)(`${prefixCls}-group-wrapper`, mergedStatus, hasFeedback), hashId)
        }
    });
});
exports.default = Input;

},{"react":"bmhQu","@rc-component/input":"3if1E","@rc-component/util/es/Dom/focus":"3rYvz","@rc-component/util/es/ref":"jmzjd","clsx":"431Ou","../_util/ContextIsolator":"5aVQ9","../_util/getAllowClear":"izZDR","../_util/hooks":"kdnMA","../_util/statusUtils":"gbJk4","../_util/warning":"95o3w","../config-provider/context":"75zwC","../config-provider/DisabledContext":"h4TcW","../config-provider/hooks/useCSSVarCls":"gcu2s","../config-provider/hooks/useSize":"gXe6G","../form/context":"krZYn","../form/hooks/useVariants":"larUs","../space/Compact":"cOSpV","./hooks/useRemovePasswordTimeout":"frSCB","./style":"8tbVx","./utils":"bsT4D","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3if1E":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BaseInput", ()=>(0, _baseInputDefault.default));
var _baseInput = require("./BaseInput");
var _baseInputDefault = parcelHelpers.interopDefault(_baseInput);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
exports.default = (0, _inputDefault.default);

},{"./BaseInput":"hzm83","./Input":"2jFs2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hzm83":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _commonUtils = require("./utils/commonUtils");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BaseInput = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { inputElement: inputEl, children, prefixCls, prefix, suffix, addonBefore, addonAfter, className, style, disabled, readOnly, focused, triggerFocus, allowClear, value, handleReset, hidden, classes, classNames, dataAttrs, styles, components, onClear } = props;
    const inputElement = children ?? inputEl;
    const AffixWrapperComponent = components?.affixWrapper || 'span';
    const GroupWrapperComponent = components?.groupWrapper || 'span';
    const WrapperComponent = components?.wrapper || 'span';
    const GroupAddonComponent = components?.groupAddon || 'span';
    const containerRef = (0, _react.useRef)(null);
    const onInputClick = (e)=>{
        if (containerRef.current?.contains(e.target)) triggerFocus?.();
    };
    const hasAffix = (0, _commonUtils.hasPrefixSuffix)(props);
    let element = /*#__PURE__*/ (0, _react.cloneElement)(inputElement, {
        value,
        className: (0, _clsx.clsx)(inputElement.props?.className, !hasAffix && classNames?.variant) || null
    });
    // ======================== Ref ======================== //
    const groupRef = (0, _react.useRef)(null);
    (0, _reactDefault.default).useImperativeHandle(ref, ()=>({
            nativeElement: groupRef.current || containerRef.current
        }));
    // ================== Prefix & Suffix ================== //
    if (hasAffix) {
        // ================== Clear Icon ================== //
        let clearIcon = null;
        if (allowClear) {
            const needClear = !disabled && !readOnly && value;
            const clearIconCls = `${prefixCls}-clear-icon`;
            const iconNode = typeof allowClear === 'object' && allowClear?.clearIcon ? allowClear.clearIcon : "\u2716";
            clearIcon = /*#__PURE__*/ (0, _reactDefault.default).createElement("button", {
                type: "button",
                tabIndex: -1,
                onClick: (event)=>{
                    handleReset?.(event);
                    onClear?.();
                },
                onMouseDown: (e)=>e.preventDefault(),
                className: (0, _clsx.clsx)(clearIconCls, {
                    [`${clearIconCls}-hidden`]: !needClear,
                    [`${clearIconCls}-has-suffix`]: !!suffix
                })
            }, iconNode);
        }
        const affixWrapperPrefixCls = `${prefixCls}-affix-wrapper`;
        const affixWrapperCls = (0, _clsx.clsx)(affixWrapperPrefixCls, {
            [`${prefixCls}-disabled`]: disabled,
            [`${affixWrapperPrefixCls}-disabled`]: disabled,
            // Not used, but keep it
            [`${affixWrapperPrefixCls}-focused`]: focused,
            // Not used, but keep it
            [`${affixWrapperPrefixCls}-readonly`]: readOnly,
            [`${affixWrapperPrefixCls}-input-with-clear-btn`]: suffix && allowClear && value
        }, classes?.affixWrapper, classNames?.affixWrapper, classNames?.variant);
        const suffixNode = (suffix || allowClear) && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: (0, _clsx.clsx)(`${prefixCls}-suffix`, classNames?.suffix),
            style: styles?.suffix
        }, clearIcon, suffix);
        element = /*#__PURE__*/ (0, _reactDefault.default).createElement(AffixWrapperComponent, _extends({
            className: affixWrapperCls,
            style: styles?.affixWrapper,
            onClick: onInputClick
        }, dataAttrs?.affixWrapper, {
            ref: containerRef
        }), prefix && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: (0, _clsx.clsx)(`${prefixCls}-prefix`, classNames?.prefix),
            style: styles?.prefix
        }, prefix), element, suffixNode);
    }
    // ================== Addon ================== //
    if ((0, _commonUtils.hasAddon)(props)) {
        const wrapperCls = `${prefixCls}-group`;
        const addonCls = `${wrapperCls}-addon`;
        const groupWrapperCls = `${wrapperCls}-wrapper`;
        const mergedWrapperClassName = (0, _clsx.clsx)(`${prefixCls}-wrapper`, wrapperCls, classes?.wrapper, classNames?.wrapper);
        const mergedGroupClassName = (0, _clsx.clsx)(groupWrapperCls, {
            [`${groupWrapperCls}-disabled`]: disabled
        }, classes?.group, classNames?.groupWrapper);
        // Need another wrapper for changing display:table to display:inline-block
        // and put style prop in wrapper
        element = /*#__PURE__*/ (0, _reactDefault.default).createElement(GroupWrapperComponent, {
            className: mergedGroupClassName,
            ref: groupRef
        }, /*#__PURE__*/ (0, _reactDefault.default).createElement(WrapperComponent, {
            className: mergedWrapperClassName
        }, addonBefore && /*#__PURE__*/ (0, _reactDefault.default).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonBefore), element, addonAfter && /*#__PURE__*/ (0, _reactDefault.default).createElement(GroupAddonComponent, {
            className: addonCls
        }, addonAfter)));
    }
    // `className` and `style` are always on the root element
    return /*#__PURE__*/ (0, _reactDefault.default).cloneElement(element, {
        className: (0, _clsx.clsx)(element.props?.className, className) || null,
        style: {
            ...element.props?.style,
            ...style
        },
        hidden
    });
});
exports.default = BaseInput;

},{"clsx":"431Ou","react":"bmhQu","./utils/commonUtils":"lbeHE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lbeHE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasAddon", ()=>hasAddon);
parcelHelpers.export(exports, "hasPrefixSuffix", ()=>hasPrefixSuffix);
parcelHelpers.export(exports, "resolveOnChange", ()=>resolveOnChange);
function hasAddon(props) {
    return !!(props.addonBefore || props.addonAfter);
}
function hasPrefixSuffix(props) {
    return !!(props.prefix || props.suffix || props.allowClear);
}
// TODO: It's better to use `Proxy` replace the `element.value`. But we still need support IE11.
function cloneEvent(event, target, value) {
    // A bug report filed on WebKit's Bugzilla tracker, dating back to 2009, specifically addresses the issue of cloneNode() not copying files of <input type="file"> elements.
    // As of the last update, this bug was still marked as "NEW," indicating that it might not have been resolved yet​​.
    // https://bugs.webkit.org/show_bug.cgi?id=28123
    const currentTarget = target.cloneNode(true);
    // click clear icon
    const newEvent = Object.create(event, {
        target: {
            value: currentTarget
        },
        currentTarget: {
            value: currentTarget
        }
    });
    // Fill data
    currentTarget.value = value;
    // Fill selection. Some type like `email` not support selection
    // https://github.com/ant-design/ant-design/issues/47833
    if (typeof target.selectionStart === 'number' && typeof target.selectionEnd === 'number') {
        currentTarget.selectionStart = target.selectionStart;
        currentTarget.selectionEnd = target.selectionEnd;
    }
    currentTarget.setSelectionRange = (...args)=>{
        target.setSelectionRange(...args);
    };
    return newEvent;
}
function resolveOnChange(target, e, onChange, targetValue) {
    if (!onChange) return;
    let event = e;
    if (e.type === 'click') {
        // Clone a new target for event.
        // Avoid the following usage, the setQuery method gets the original value.
        //
        // const [query, setQuery] = React.useState('');
        // <Input
        //   allowClear
        //   value={query}
        //   onChange={(e)=> {
        //     setQuery((prevStatus) => e.target.value);
        //   }}
        // />
        event = cloneEvent(e, target, '');
        onChange(event);
        return;
    }
    // Trigger by composition event, this means we need force change the input value
    // https://github.com/ant-design/ant-design/issues/45737
    // https://github.com/ant-design/ant-design/issues/46598
    if (target.type !== 'file' && targetValue !== undefined) {
        event = cloneEvent(e, target, targetValue);
        onChange(event);
        return;
    }
    onChange(event);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2jFs2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _clsx = require("clsx");
var _useControlledState = require("@rc-component/util/es/hooks/useControlledState");
var _useControlledStateDefault = parcelHelpers.interopDefault(_useControlledState);
var _omit = require("@rc-component/util/es/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _baseInput = require("./BaseInput");
var _baseInputDefault = parcelHelpers.interopDefault(_baseInput);
var _useCount = require("./hooks/useCount");
var _useCountDefault = parcelHelpers.interopDefault(_useCount);
var _commonUtils = require("./utils/commonUtils");
var _focus = require("@rc-component/util/es/Dom/focus");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Input = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { autoComplete, onChange, onFocus, onBlur, onPressEnter, onKeyDown, onKeyUp, prefixCls = 'rc-input', disabled, htmlSize, className, maxLength, suffix, showCount, count, type = 'text', classes, classNames, styles, onCompositionStart, onCompositionEnd, ...rest } = props;
    const [focused, setFocused] = (0, _react.useState)(false);
    const compositionRef = (0, _react.useRef)(false);
    const keyLockRef = (0, _react.useRef)(false);
    const inputRef = (0, _react.useRef)(null);
    const holderRef = (0, _react.useRef)(null);
    const focus = (option)=>{
        if (inputRef.current) (0, _focus.triggerFocus)(inputRef.current, option);
    };
    // ====================== Value =======================
    const [value, setValue] = (0, _useControlledStateDefault.default)(props.defaultValue, props.value);
    const formatValue = value === undefined || value === null ? '' : String(value);
    // =================== Select Range ===================
    const [selection, setSelection] = (0, _react.useState)(null);
    // ====================== Count =======================
    const countConfig = (0, _useCountDefault.default)(count, showCount);
    const mergedMax = countConfig.max || maxLength;
    const valueLength = countConfig.strategy(formatValue);
    const isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ======================= Ref ========================
    (0, _react.useImperativeHandle)(ref, ()=>({
            focus,
            blur: ()=>{
                inputRef.current?.blur();
            },
            setSelectionRange: (start, end, direction)=>{
                inputRef.current?.setSelectionRange(start, end, direction);
            },
            select: ()=>{
                inputRef.current?.select();
            },
            input: inputRef.current,
            nativeElement: holderRef.current?.nativeElement || inputRef.current
        }));
    (0, _react.useEffect)(()=>{
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused((prev)=>prev && disabled ? false : prev);
    }, [
        disabled
    ]);
    const triggerChange = (e, currentValue, info)=>{
        let cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                inputRef.current?.selectionStart || 0,
                inputRef.current?.selectionEnd || 0
            ]);
        } else if (info.source === 'compositionEnd') // Avoid triggering twice
        // https://github.com/ant-design/ant-design/issues/46587
        return;
        setValue(cutValue);
        if (inputRef.current) (0, _commonUtils.resolveOnChange)(inputRef.current, e, onChange, cutValue);
    };
    (0, _react.useEffect)(()=>{
        if (selection) inputRef.current?.setSelectionRange(...selection);
    }, [
        selection
    ]);
    const onInternalChange = (e)=>{
        triggerChange(e, e.target.value, {
            source: 'change'
        });
    };
    const onInternalCompositionEnd = (e)=>{
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value, {
            source: 'compositionEnd'
        });
        onCompositionEnd?.(e);
    };
    const handleKeyDown = (e)=>{
        if (onPressEnter && e.key === 'Enter' && !keyLockRef.current && !e.nativeEvent.isComposing) {
            keyLockRef.current = true;
            onPressEnter(e);
        }
        onKeyDown?.(e);
    };
    const handleKeyUp = (e)=>{
        if (e.key === 'Enter') keyLockRef.current = false;
        onKeyUp?.(e);
    };
    const handleFocus = (e)=>{
        setFocused(true);
        onFocus?.(e);
    };
    const handleBlur = (e)=>{
        if (keyLockRef.current) keyLockRef.current = false;
        setFocused(false);
        onBlur?.(e);
    };
    const handleReset = (e)=>{
        setValue('');
        focus();
        if (inputRef.current) (0, _commonUtils.resolveOnChange)(inputRef.current, e, onChange);
    };
    // ====================== Input =======================
    const outOfRangeCls = isOutOfRange && `${prefixCls}-out-of-range`;
    const getInputElement = ()=>{
        // Fix https://fb.me/react-unknown-prop
        const otherProps = (0, _omitDefault.default)(props, [
            'prefixCls',
            'onPressEnter',
            'addonBefore',
            'addonAfter',
            'prefix',
            'suffix',
            'allowClear',
            // Input elements must be either controlled or uncontrolled,
            // specify either the value prop, or the defaultValue prop, but not both.
            'defaultValue',
            'showCount',
            'count',
            'classes',
            'htmlSize',
            'styles',
            'classNames',
            'onClear'
        ]);
        return /*#__PURE__*/ (0, _reactDefault.default).createElement("input", _extends({
            autoComplete: autoComplete
        }, otherProps, {
            onChange: onInternalChange,
            onFocus: handleFocus,
            onBlur: handleBlur,
            onKeyDown: handleKeyDown,
            onKeyUp: handleKeyUp,
            className: (0, _clsx.clsx)(prefixCls, {
                [`${prefixCls}-disabled`]: disabled
            }, classNames?.input),
            style: styles?.input,
            ref: inputRef,
            size: htmlSize,
            type: type,
            onCompositionStart: (e)=>{
                compositionRef.current = true;
                onCompositionStart?.(e);
            },
            onCompositionEnd: onInternalCompositionEnd
        }));
    };
    const getSuffix = ()=>{
        // Max length value
        const hasMaxLength = Number(mergedMax) > 0;
        if (suffix || countConfig.show) {
            const dataCount = countConfig.showFormatter ? countConfig.showFormatter({
                value: formatValue,
                count: valueLength,
                maxLength: mergedMax
            }) : `${valueLength}${hasMaxLength ? ` / ${mergedMax}` : ''}`;
            return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, countConfig.show && /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
                className: (0, _clsx.clsx)(`${prefixCls}-show-count-suffix`, {
                    [`${prefixCls}-show-count-has-suffix`]: !!suffix
                }, classNames?.count),
                style: {
                    ...styles?.count
                }
            }, dataCount), suffix);
        }
        return null;
    };
    // ====================== Render ======================
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _baseInputDefault.default), _extends({}, rest, {
        prefixCls: prefixCls,
        className: (0, _clsx.clsx)(className, outOfRangeCls),
        handleReset: handleReset,
        value: formatValue,
        focused: focused,
        triggerFocus: focus,
        suffix: getSuffix(),
        disabled: disabled,
        classes: classes,
        classNames: classNames,
        styles: styles,
        ref: holderRef
    }), getInputElement());
});
exports.default = Input;

},{"clsx":"431Ou","@rc-component/util/es/hooks/useControlledState":"2FQtD","@rc-component/util/es/omit":"1VS01","react":"bmhQu","./BaseInput":"hzm83","./hooks/useCount":"bzoUj","./utils/commonUtils":"lbeHE","@rc-component/util/es/Dom/focus":"3rYvz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bzoUj":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Cut `value` by the `count.max` prop.
 */ parcelHelpers.export(exports, "inCountRange", ()=>inCountRange);
parcelHelpers.export(exports, "default", ()=>useCount);
var _react = require("react");
function inCountRange(value, countConfig) {
    if (!countConfig.max) return true;
    const count = countConfig.strategy(value);
    return count <= countConfig.max;
}
function useCount(count, showCount) {
    return _react.useMemo(()=>{
        let mergedConfig = {};
        if (showCount) mergedConfig.show = typeof showCount === 'object' && showCount.formatter ? showCount.formatter : !!showCount;
        mergedConfig = {
            ...mergedConfig,
            ...count
        };
        const { show, ...rest } = mergedConfig;
        return {
            ...rest,
            show: !!show,
            showFormatter: typeof show === 'function' ? show : undefined,
            strategy: rest.strategy || ((value)=>value.length)
        };
    }, [
        count,
        showCount
    ]);
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"izZDR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _closeCircleFilled = require("@ant-design/icons/es/icons/CloseCircleFilled");
var _closeCircleFilledDefault = parcelHelpers.interopDefault(_closeCircleFilled);
"use client";
const getAllowClear = (allowClear)=>{
    let mergedAllowClear;
    if (typeof allowClear === 'object' && allowClear?.clearIcon) mergedAllowClear = allowClear;
    else if (allowClear) mergedAllowClear = {
        clearIcon: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _closeCircleFilledDefault.default), null)
    };
    return mergedAllowClear;
};
exports.default = getAllowClear;

},{"react":"bmhQu","@ant-design/icons/es/icons/CloseCircleFilled":"d3fPr","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"frSCB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>useRemovePasswordTimeout);
var _react = require("react");
function useRemovePasswordTimeout(inputRef, triggerOnMount) {
    const removePasswordTimeoutRef = (0, _react.useRef)([]);
    const removePasswordTimeout = ()=>{
        removePasswordTimeoutRef.current.push(setTimeout(()=>{
            if (inputRef.current?.input && inputRef.current?.input.getAttribute('type') === 'password' && inputRef.current?.input.hasAttribute('value')) inputRef.current?.input.removeAttribute('value');
        }));
    };
    (0, _react.useEffect)(()=>{
        if (triggerOnMount) removePasswordTimeout();
        return ()=>removePasswordTimeoutRef.current.forEach((timer)=>{
                if (timer) clearTimeout(timer);
            });
    }, []);
    return removePasswordTimeout;
}

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bsT4D":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "hasPrefixSuffix", ()=>hasPrefixSuffix);
function hasPrefixSuffix(props) {
    return !!(props.prefix || props.suffix || props.allowClear || props.showCount);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hRCCB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _toConsumableArray = require("@babel/runtime/helpers/esm/toConsumableArray");
var _toConsumableArrayDefault = parcelHelpers.interopDefault(_toConsumableArray);
var _react = require("react");
var _util = require("@rc-component/util");
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
var _clsx = require("clsx");
var _hooks = require("../../_util/hooks");
var _statusUtils = require("../../_util/statusUtils");
var _warning = require("../../_util/warning");
var _context = require("../../config-provider/context");
var _useSize = require("../../config-provider/hooks/useSize");
var _useSizeDefault = parcelHelpers.interopDefault(_useSize);
var _context1 = require("../../form/context");
var _otp = require("../style/otp");
var _otpDefault = parcelHelpers.interopDefault(_otp);
var _otpinput = require("./OTPInput");
var _otpinputDefault = parcelHelpers.interopDefault(_otpinput);
"use client";
function strToArr(str) {
    return (str || '').split('');
}
const Separator = (props)=>{
    const { index, prefixCls, separator, className: semanticClassName, style: semanticStyle } = props;
    const separatorNode = typeof separator === 'function' ? separator(index) : separator;
    if (!separatorNode) return null;
    return /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(`${prefixCls}-separator`, semanticClassName),
        style: semanticStyle
    }, separatorNode);
};
const OTP = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, length = 6, size: customSize, defaultValue, value, onChange, formatter, separator, variant, disabled, status: customStatus, autoFocus, mask, type, onInput, onFocus, inputMode, classNames, styles, className, style, ...restProps } = props;
    const { classNames: contextClassNames, styles: contextStyles, getPrefixCls, direction, style: contextStyle, className: contextClassName } = (0, _context.useComponentConfig)('otp');
    const prefixCls = getPrefixCls('otp', customizePrefixCls);
    const mergedProps = {
        ...props,
        length
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const domAttrs = (0, _pickAttrsDefault.default)(restProps, {
        aria: true,
        data: true,
        attr: true
    });
    // ========================= Root =========================
    // Style
    const [hashId, cssVarCls] = (0, _otpDefault.default)(prefixCls);
    // ========================= Size =========================
    const mergedSize = (0, _useSizeDefault.default)((ctx)=>customSize ?? ctx);
    // ======================== Status ========================
    const formContext = _react.useContext((0, _context1.FormItemInputContext));
    const mergedStatus = (0, _statusUtils.getMergedStatus)(formContext.status, customStatus);
    const proxyFormContext = _react.useMemo(()=>({
            ...formContext,
            status: mergedStatus,
            hasFeedback: false,
            feedbackIcon: null
        }), [
        formContext,
        mergedStatus
    ]);
    // ========================= Refs =========================
    const containerRef = _react.useRef(null);
    const refs = _react.useRef({});
    _react.useImperativeHandle(ref, ()=>({
            focus: ()=>{
                refs.current[0]?.focus();
            },
            blur: ()=>{
                for(let i = 0; i < length; i += 1)refs.current[i]?.blur();
            },
            nativeElement: containerRef.current
        }));
    // ======================= Formatter ======================
    const internalFormatter = (txt)=>formatter ? formatter(txt) : txt;
    // ======================== Values ========================
    const [valueCells, setValueCells] = _react.useState(()=>strToArr(internalFormatter(defaultValue || '')));
    _react.useEffect(()=>{
        if (value !== undefined) setValueCells(strToArr(value));
    }, [
        value
    ]);
    const triggerValueCellsChange = (0, _util.useEvent)((nextValueCells)=>{
        setValueCells(nextValueCells);
        if (onInput) onInput(nextValueCells);
        // Trigger if all cells are filled
        if (onChange && nextValueCells.length === length && nextValueCells.every((c)=>c) && nextValueCells.some((c, index)=>valueCells[index] !== c)) onChange(nextValueCells.join(''));
    });
    const patchValue = (0, _util.useEvent)((index, txt)=>{
        let nextCells = (0, _toConsumableArrayDefault.default)(valueCells);
        // Fill cells till index
        for(let i = 0; i < index; i += 1)if (!nextCells[i]) nextCells[i] = '';
        if (txt.length <= 1) nextCells[index] = txt;
        else nextCells = nextCells.slice(0, index).concat(strToArr(txt));
        nextCells = nextCells.slice(0, length);
        // Clean the last empty cell
        for(let i = nextCells.length - 1; i >= 0; i -= 1){
            if (nextCells[i]) break;
            nextCells.pop();
        }
        // Format if needed
        const formattedValue = internalFormatter(nextCells.map((c)=>c || ' ').join(''));
        nextCells = strToArr(formattedValue).map((c, i)=>{
            if (c === ' ' && !nextCells[i]) return nextCells[i];
            return c;
        });
        return nextCells;
    });
    // ======================== Change ========================
    const onInputChange = (index, txt)=>{
        const nextCells = patchValue(index, txt);
        const nextIndex = Math.min(index + txt.length, length - 1);
        if (nextIndex !== index && nextCells[index] !== undefined) refs.current[nextIndex]?.focus();
        triggerValueCellsChange(nextCells);
    };
    const onInputActiveChange = (nextIndex)=>{
        refs.current[nextIndex]?.focus();
    };
    // ======================== Focus ========================
    const onInputFocus = (event, index)=>{
        // keep focus on the first empty cell
        for(let i = 0; i < index; i += 1)if (!refs.current[i]?.input?.value) {
            refs.current[i]?.focus();
            break;
        }
        onFocus?.(event);
    };
    // ======================== Render ========================
    const inputSharedProps = {
        variant,
        disabled,
        status: mergedStatus,
        mask,
        type,
        inputMode
    };
    return /*#__PURE__*/ _react.createElement("div", {
        ...domAttrs,
        ref: containerRef,
        className: (0, _clsx.clsx)(className, prefixCls, {
            [`${prefixCls}-sm`]: mergedSize === 'small',
            [`${prefixCls}-lg`]: mergedSize === 'large',
            [`${prefixCls}-rtl`]: direction === 'rtl'
        }, cssVarCls, hashId, contextClassName, mergedClassNames.root),
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        role: "group"
    }, /*#__PURE__*/ _react.createElement((0, _context1.FormItemInputContext).Provider, {
        value: proxyFormContext
    }, Array.from({
        length
    }).map((_, index)=>{
        const key = `otp-${index}`;
        const singleValue = valueCells[index] || '';
        return /*#__PURE__*/ _react.createElement(_react.Fragment, {
            key: key
        }, /*#__PURE__*/ _react.createElement((0, _otpinputDefault.default), {
            ref: (inputEle)=>{
                refs.current[index] = inputEle;
            },
            index: index,
            size: mergedSize,
            htmlSize: 1,
            className: (0, _clsx.clsx)(mergedClassNames.input, `${prefixCls}-input`),
            style: mergedStyles.input,
            onChange: onInputChange,
            value: singleValue,
            onActiveChange: onInputActiveChange,
            autoFocus: index === 0 && autoFocus,
            onFocus: (event)=>onInputFocus(event, index),
            ...inputSharedProps
        }), index < length - 1 && /*#__PURE__*/ _react.createElement(Separator, {
            separator: separator,
            index: index,
            prefixCls: prefixCls,
            className: (0, _clsx.clsx)(mergedClassNames.separator),
            style: mergedStyles.separator
        }));
    })));
});
exports.default = OTP;

},{"@babel/runtime/helpers/esm/toConsumableArray":"inIie","react":"bmhQu","@rc-component/util":"6ZBDN","@rc-component/util/es/pickAttrs":"jGMGD","clsx":"431Ou","../../_util/hooks":"kdnMA","../../_util/statusUtils":"gbJk4","../../_util/warning":"95o3w","../../config-provider/context":"75zwC","../../config-provider/hooks/useSize":"gXe6G","../../form/context":"krZYn","../style/otp":"6ZxDa","./OTPInput":"7JujG","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ZxDa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _internal = require("../../theme/internal");
var _token = require("./token");
// =============================== OTP ================================
const genOTPStyle = (token)=>{
    const { componentCls, paddingXS } = token;
    return {
        [componentCls]: {
            display: 'inline-flex',
            alignItems: 'center',
            flexWrap: 'nowrap',
            columnGap: paddingXS,
            [`${componentCls}-input-wrapper`]: {
                position: 'relative',
                [`${componentCls}-mask-icon`]: {
                    position: 'absolute',
                    zIndex: '1',
                    top: '50%',
                    right: '50%',
                    transform: 'translate(50%, -50%)',
                    pointerEvents: 'none'
                },
                [`${componentCls}-mask-input`]: {
                    color: 'transparent',
                    caretColor: token.colorText
                },
                [`${componentCls}-mask-input[type=number]::-webkit-inner-spin-button`]: {
                    '-webkit-appearance': 'none',
                    margin: 0
                },
                [`${componentCls}-mask-input[type=number]`]: {
                    '-moz-appearance': 'textfield'
                }
            },
            '&-rtl': {
                direction: 'rtl'
            },
            [`${componentCls}-input`]: {
                textAlign: 'center',
                paddingInline: token.paddingXXS
            },
            // ================= Size =================
            [`&${componentCls}-sm ${componentCls}-input`]: {
                paddingInline: token.calc(token.paddingXXS).div(2).equal()
            },
            [`&${componentCls}-lg ${componentCls}-input`]: {
                paddingInline: token.paddingXS
            }
        }
    };
};
// ============================== Export ==============================
exports.default = (0, _internal.genStyleHooks)([
    'Input',
    'OTP'
], (token)=>{
    const inputToken = (0, _internal.mergeToken)(token, (0, _token.initInputToken)(token));
    return genOTPStyle(inputToken);
}, (0, _token.initComponentToken));

},{"../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"./token":"aJMj7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7JujG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _clsx = require("clsx");
var _configProvider = require("../../config-provider");
var _input = require("../Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
"use client";
const OTPInput = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { className, value, onChange, onActiveChange, index, mask, onFocus, ...restProps } = props;
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const prefixCls = getPrefixCls('otp');
    const maskValue = typeof mask === 'string' ? mask : value;
    // ========================== Ref ===========================
    const inputRef = _react.useRef(null);
    _react.useImperativeHandle(ref, ()=>inputRef.current);
    // ========================= Input ==========================
    const onInternalChange = (e)=>{
        onChange(index, e.target.value);
    };
    // ========================= Focus ==========================
    const syncSelection = ()=>{
        (0, _rafDefault.default)(()=>{
            const inputEle = inputRef.current?.input;
            if (document.activeElement === inputEle && inputEle) inputEle.select();
        });
    };
    const onInternalFocus = (e)=>{
        onFocus?.(e);
        syncSelection();
    };
    // ======================== Keyboard ========================
    const onInternalKeyDown = (event)=>{
        const { key, ctrlKey, metaKey } = event;
        if (key === 'ArrowLeft') onActiveChange(index - 1);
        else if (key === 'ArrowRight') onActiveChange(index + 1);
        else if (key === 'z' && (ctrlKey || metaKey)) event.preventDefault();
        else if (key === 'Backspace' && !value) onActiveChange(index - 1);
        syncSelection();
    };
    // ========================= Render =========================
    return /*#__PURE__*/ _react.createElement("span", {
        className: `${prefixCls}-input-wrapper`,
        role: "presentation"
    }, mask && value !== '' && value !== undefined && /*#__PURE__*/ _react.createElement("span", {
        className: `${prefixCls}-mask-icon`,
        "aria-hidden": "true"
    }, maskValue), /*#__PURE__*/ _react.createElement((0, _inputDefault.default), {
        "aria-label": `OTP Input ${index + 1}`,
        type: mask === true ? 'password' : 'text',
        ...restProps,
        ref: inputRef,
        value: value,
        onInput: onInternalChange,
        onFocus: onInternalFocus,
        onKeyDown: onInternalKeyDown,
        onMouseDown: syncSelection,
        onMouseUp: syncSelection,
        className: (0, _clsx.clsx)(className, {
            [`${prefixCls}-mask-input`]: mask
        })
    }));
});
exports.default = OTPInput;

},{"react":"bmhQu","@rc-component/util/es/raf":"ajbAx","clsx":"431Ou","../../config-provider":"dVeAX","../Input":"ha6HZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8gqM5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _eyeInvisibleOutlined = require("@ant-design/icons/es/icons/EyeInvisibleOutlined");
var _eyeInvisibleOutlinedDefault = parcelHelpers.interopDefault(_eyeInvisibleOutlined);
var _eyeOutlined = require("@ant-design/icons/es/icons/EyeOutlined");
var _eyeOutlinedDefault = parcelHelpers.interopDefault(_eyeOutlined);
var _util = require("@rc-component/util");
var _ref = require("@rc-component/util/es/ref");
var _clsx = require("clsx");
var _configProvider = require("../config-provider");
var _disabledContext = require("../config-provider/DisabledContext");
var _disabledContextDefault = parcelHelpers.interopDefault(_disabledContext);
var _useRemovePasswordTimeout = require("./hooks/useRemovePasswordTimeout");
var _useRemovePasswordTimeoutDefault = parcelHelpers.interopDefault(_useRemovePasswordTimeout);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
"use client";
const defaultIconRender = (visible)=>visible ? /*#__PURE__*/ _react.createElement((0, _eyeOutlinedDefault.default), null) : /*#__PURE__*/ _react.createElement((0, _eyeInvisibleOutlinedDefault.default), null);
const actionMap = {
    click: 'onClick',
    hover: 'onMouseOver'
};
const Password = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { disabled: customDisabled, action = 'click', visibilityToggle = true, iconRender = defaultIconRender, suffix } = props;
    // ===================== Disabled =====================
    const disabled = _react.useContext((0, _disabledContextDefault.default));
    const mergedDisabled = customDisabled ?? disabled;
    const visibilityControlled = typeof visibilityToggle === 'object' && visibilityToggle.visible !== undefined;
    const [visible, setVisible] = (0, _react.useState)(()=>visibilityControlled ? visibilityToggle.visible : false);
    const inputRef = (0, _react.useRef)(null);
    _react.useEffect(()=>{
        if (visibilityControlled) setVisible(visibilityToggle.visible);
    }, [
        visibilityControlled,
        visibilityToggle
    ]);
    // Remove Password value
    const removePasswordTimeout = (0, _useRemovePasswordTimeoutDefault.default)(inputRef);
    const onVisibleChange = ()=>{
        if (mergedDisabled) return;
        if (visible) removePasswordTimeout();
        const nextVisible = !visible;
        setVisible(nextVisible);
        if (typeof visibilityToggle === 'object') visibilityToggle.onVisibleChange?.(nextVisible);
    };
    const getIcon = (prefixCls)=>{
        const iconTrigger = actionMap[action] || '';
        const icon = iconRender(visible);
        const iconProps = {
            [iconTrigger]: onVisibleChange,
            className: `${prefixCls}-icon`,
            key: 'passwordIcon',
            onMouseDown: (e)=>{
                // Prevent focused state lost
                // https://github.com/ant-design/ant-design/issues/15173
                e.preventDefault();
            },
            onMouseUp: (e)=>{
                // Prevent caret position change
                // https://github.com/ant-design/ant-design/issues/23524
                e.preventDefault();
            }
        };
        return /*#__PURE__*/ _react.cloneElement(/*#__PURE__*/ _react.isValidElement(icon) ? icon : /*#__PURE__*/ _react.createElement("span", null, icon), iconProps);
    };
    const { className, prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, size, ...restProps } = props;
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const prefixCls = getPrefixCls('input-password', customizePrefixCls);
    const suffixIcon = visibilityToggle && getIcon(prefixCls);
    const inputClassName = (0, _clsx.clsx)(prefixCls, className, {
        [`${prefixCls}-${size}`]: !!size
    });
    const omittedProps = {
        ...(0, _util.omit)(restProps, [
            'suffix',
            'iconRender',
            'visibilityToggle'
        ]),
        type: visible ? 'text' : 'password',
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: /*#__PURE__*/ _react.createElement(_react.Fragment, null, suffixIcon, suffix)
    };
    if (size) omittedProps.size = size;
    return /*#__PURE__*/ _react.createElement((0, _inputDefault.default), {
        ref: (0, _ref.composeRef)(ref, inputRef),
        ...omittedProps
    });
});
exports.default = Password;

},{"react":"bmhQu","@ant-design/icons/es/icons/EyeInvisibleOutlined":"bYrAw","@ant-design/icons/es/icons/EyeOutlined":"eYNz1","@rc-component/util":"6ZBDN","@rc-component/util/es/ref":"jmzjd","clsx":"431Ou","../config-provider":"dVeAX","../config-provider/DisabledContext":"h4TcW","./hooks/useRemovePasswordTimeout":"frSCB","./Input":"ha6HZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bYrAw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _eyeInvisibleOutlined = require("@ant-design/icons-svg/es/asn/EyeInvisibleOutlined");
var _eyeInvisibleOutlinedDefault = parcelHelpers.interopDefault(_eyeInvisibleOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const EyeInvisibleOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _eyeInvisibleOutlinedDefault.default)
    }));
/**![eye-invisible](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yUTg4OS40NyAzNzUuMTEgODE2LjcgMzA1bC01MC44OCA1MC44OEM4MDcuMzEgMzk1LjUzIDg0My40NSA0NDcuNCA4NzQuNyA1MTIgNzkxLjUgNjg0LjIgNjczLjQgNzY2IDUxMiA3NjZxLTcyLjY3IDAtMTMzLjg3LTIyLjM4TDMyMyA3OTguNzVRNDA4IDgzOCA1MTIgODM4cTI4OC4zIDAgNDMwLjItMzAwLjNhNjAuMjkgNjAuMjkgMCAwMDAtNTEuNXptLTYzLjU3LTMyMC42NEw4MzYgMTIyLjg4YTggOCAwIDAwLTExLjMyIDBMNzE1LjMxIDIzMi4yUTYyNC44NiAxODYgNTEyIDE4NnEtMjg4LjMgMC00MzAuMiAzMDAuM2E2MC4zIDYwLjMgMCAwMDAgNTEuNXE1Ni42OSAxMTkuNCAxMzYuNSAxOTEuNDFMMTEyLjQ4IDgzNWE4IDggMCAwMDAgMTEuMzFMMTU1LjE3IDg4OWE4IDggMCAwMDExLjMxIDBsNzEyLjE1LTcxMi4xMmE4IDggMCAwMDAtMTEuMzJ6TTE0OS4zIDUxMkMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGM1NC41NCAwIDEwNC4xMyA5LjM2IDE0OS4xMiAyOC4zOWwtNzAuMyA3MC4zYTE3NiAxNzYgMCAwMC0yMzguMTMgMjM4LjEzbC04My40MiA4My40MkMyMjMuMSA2MzcuNDkgMTgzLjMgNTgyLjI4IDE0OS4zIDUxMnptMjQ2LjcgMGExMTIuMTEgMTEyLjExIDAgMDExNDYuMi0xMDYuNjlMNDAxLjMxIDU0Ni4yQTExMiAxMTIgMCAwMTM5NiA1MTJ6IiAvPjxwYXRoIGQ9Ik01MDggNjI0Yy0zLjQ2IDAtNi44Ny0uMTYtMTAuMjUtLjQ3bC01Mi44MiA1Mi44MmExNzYuMDkgMTc2LjA5IDAgMDAyMjcuNDItMjI3LjQybC01Mi44MiA1Mi44MmMuMzEgMy4zOC40NyA2Ljc5LjQ3IDEwLjI1YTExMS45NCAxMTEuOTQgMCAwMS0xMTIgMTEyeiIgLz48L3N2Zz4=) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(EyeInvisibleOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/EyeInvisibleOutlined":"h14eE","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h14eE":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var EyeInvisibleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 000-51.5zm-63.57-320.64L836 122.88a8 8 0 00-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 000 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 000 11.31L155.17 889a8 8 0 0011.31 0l712.15-712.12a8 8 0 000-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 00-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 01146.2-106.69L401.31 546.2A112 112 0 01396 512z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 00227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 01-112 112z"
                }
            }
        ]
    },
    "name": "eye-invisible",
    "theme": "outlined"
};
exports.default = EyeInvisibleOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eYNz1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _eyeOutlined = require("@ant-design/icons-svg/es/asn/EyeOutlined");
var _eyeOutlinedDefault = parcelHelpers.interopDefault(_eyeOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const EyeOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _eyeOutlinedDefault.default)
    }));
/**![eye](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTk0Mi4yIDQ4Ni4yQzg0Ny40IDI4Ni41IDcwNC4xIDE4NiA1MTIgMTg2Yy0xOTIuMiAwLTMzNS40IDEwMC41LTQzMC4yIDMwMC4zYTYwLjMgNjAuMyAwIDAwMCA1MS41QzE3Ni42IDczNy41IDMxOS45IDgzOCA1MTIgODM4YzE5Mi4yIDAgMzM1LjQtMTAwLjUgNDMwLjItMzAwLjMgNy43LTE2LjIgNy43LTM1IDAtNTEuNXpNNTEyIDc2NmMtMTYxLjMgMC0yNzkuNC04MS44LTM2Mi43LTI1NEMyMzIuNiAzMzkuOCAzNTAuNyAyNTggNTEyIDI1OGMxNjEuMyAwIDI3OS40IDgxLjggMzYyLjcgMjU0Qzc5MS41IDY4NC4yIDY3My40IDc2NiA1MTIgNzY2em0tNC00MzBjLTk3LjIgMC0xNzYgNzguOC0xNzYgMTc2czc4LjggMTc2IDE3NiAxNzYgMTc2LTc4LjggMTc2LTE3Ni03OC44LTE3Ni0xNzYtMTc2em0wIDI4OGMtNjEuOSAwLTExMi01MC4xLTExMi0xMTJzNTAuMS0xMTIgMTEyLTExMiAxMTIgNTAuMSAxMTIgMTEyLTUwLjEgMTEyLTExMiAxMTJ6IiAvPjwvc3ZnPg==) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(EyeOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/EyeOutlined":"djspG","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"djspG":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var EyeOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 000 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z"
                }
            }
        ]
    },
    "name": "eye",
    "theme": "outlined"
};
exports.default = EyeOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lsEWS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _searchOutlined = require("@ant-design/icons/es/icons/SearchOutlined");
var _searchOutlinedDefault = parcelHelpers.interopDefault(_searchOutlined);
var _omit = require("@rc-component/util/es/omit");
var _omitDefault = parcelHelpers.interopDefault(_omit);
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
var _ref = require("@rc-component/util/es/ref");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _reactNode = require("../_util/reactNode");
var _button = require("../button/Button");
var _buttonDefault = parcelHelpers.interopDefault(_button);
var _context = require("../config-provider/context");
var _useSize = require("../config-provider/hooks/useSize");
var _useSizeDefault = parcelHelpers.interopDefault(_useSize);
var _compact = require("../space/Compact");
var _compactDefault = parcelHelpers.interopDefault(_compact);
var _input = require("./Input");
var _inputDefault = parcelHelpers.interopDefault(_input);
var _search = require("./style/search");
var _searchDefault = parcelHelpers.interopDefault(_search);
"use client";
const Search = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, inputPrefixCls: customizeInputPrefixCls, className, size: customizeSize, style, enterButton = false, addonAfter, loading, disabled, onSearch: customOnSearch, onChange: customOnChange, onCompositionStart, onCompositionEnd, variant, onPressEnter: customOnPressEnter, classNames, styles, hidden, ...restProps } = props;
    const { direction, getPrefixCls, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('inputSearch');
    const mergedProps = {
        ...props,
        enterButton
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    }, {
        button: {
            _default: 'root'
        }
    });
    const composedRef = _react.useRef(false);
    const prefixCls = getPrefixCls('input-search', customizePrefixCls);
    const inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
    const [hashId, cssVarCls] = (0, _searchDefault.default)(prefixCls);
    const { compactSize } = (0, _compact.useCompactItemContext)(prefixCls, direction);
    const size = (0, _useSizeDefault.default)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const inputRef = _react.useRef(null);
    const onChange = (e)=>{
        if (e?.target && e.type === 'click' && customOnSearch) customOnSearch(e.target.value, e, {
            source: 'clear'
        });
        customOnChange?.(e);
    };
    const onMouseDown = (e)=>{
        if (document.activeElement === inputRef.current?.input) e.preventDefault();
    };
    const onSearch = (e)=>{
        if (customOnSearch) customOnSearch(inputRef.current?.input?.value, e, {
            source: 'input'
        });
    };
    const onPressEnter = (e)=>{
        if (composedRef.current || loading) return;
        customOnPressEnter?.(e);
        onSearch(e);
    };
    const searchIcon = typeof enterButton === 'boolean' ? /*#__PURE__*/ _react.createElement((0, _searchOutlinedDefault.default), null) : null;
    const btnPrefixCls = `${prefixCls}-btn`;
    const btnClassName = (0, _clsx.clsx)(btnPrefixCls, {
        [`${btnPrefixCls}-${variant}`]: variant
    });
    let button;
    const enterButtonAsElement = enterButton || {};
    const isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
    if (isAntdButton || enterButtonAsElement.type === 'button') button = (0, _reactNode.cloneElement)(enterButtonAsElement, {
        onMouseDown,
        onClick: (e)=>{
            enterButtonAsElement?.props?.onClick?.(e);
            onSearch(e);
        },
        key: 'enterButton',
        ...isAntdButton ? {
            className: btnClassName,
            size
        } : {}
    });
    else button = /*#__PURE__*/ _react.createElement((0, _buttonDefault.default), {
        classNames: mergedClassNames.button,
        styles: mergedStyles.button,
        className: btnClassName,
        color: enterButton ? 'primary' : 'default',
        size: size,
        disabled: disabled,
        key: "enterButton",
        onMouseDown: onMouseDown,
        onClick: onSearch,
        loading: loading,
        icon: searchIcon,
        variant: variant === 'borderless' || variant === 'filled' || variant === 'underlined' ? 'text' : enterButton ? 'solid' : undefined
    }, enterButton);
    if (addonAfter) button = [
        button,
        (0, _reactNode.cloneElement)(addonAfter, {
            key: 'addonAfter'
        })
    ];
    const mergedClassName = (0, _clsx.clsx)(prefixCls, cssVarCls, {
        [`${prefixCls}-rtl`]: direction === 'rtl',
        [`${prefixCls}-${size}`]: !!size,
        [`${prefixCls}-with-button`]: !!enterButton
    }, className, hashId, mergedClassNames.root);
    const handleOnCompositionStart = (e)=>{
        composedRef.current = true;
        onCompositionStart?.(e);
    };
    const handleOnCompositionEnd = (e)=>{
        composedRef.current = false;
        onCompositionEnd?.(e);
    };
    // ========================== Render ==========================
    // >>> Root Props
    const rootProps = (0, _pickAttrsDefault.default)(restProps, {
        data: true
    });
    const inputProps = (0, _omitDefault.default)({
        ...restProps,
        classNames: (0, _omitDefault.default)(mergedClassNames, [
            'button',
            'root'
        ]),
        styles: (0, _omitDefault.default)(mergedStyles, [
            'button',
            'root'
        ]),
        prefixCls: inputPrefixCls,
        type: 'search',
        size,
        variant,
        onPressEnter,
        onCompositionStart: handleOnCompositionStart,
        onCompositionEnd: handleOnCompositionEnd,
        onChange,
        disabled
    }, Object.keys(rootProps));
    return /*#__PURE__*/ _react.createElement((0, _compactDefault.default), {
        className: mergedClassName,
        style: {
            ...style,
            ...mergedStyles.root
        },
        ...rootProps,
        hidden: hidden
    }, /*#__PURE__*/ _react.createElement((0, _inputDefault.default), {
        ref: (0, _ref.composeRef)(inputRef, ref),
        ...inputProps
    }), button);
});
exports.default = Search;

},{"react":"bmhQu","@ant-design/icons/es/icons/SearchOutlined":"iN0sG","@rc-component/util/es/omit":"1VS01","@rc-component/util/es/pickAttrs":"jGMGD","@rc-component/util/es/ref":"jmzjd","clsx":"431Ou","../_util/hooks":"kdnMA","../_util/reactNode":"78pFx","../button/Button":"gfWzz","../config-provider/context":"75zwC","../config-provider/hooks/useSize":"gXe6G","../space/Compact":"cOSpV","./Input":"ha6HZ","./style/search":"cg42H","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cg42H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _internal = require("../../theme/internal");
const genSearchStyle = (token)=>{
    const { componentCls } = token;
    const btnCls = `${componentCls}-btn`;
    return {
        [componentCls]: {
            width: '100%',
            // =========================== Button ===========================
            [btnCls]: {
                '&-filled': {
                    background: token.colorFillTertiary,
                    '&:not(:disabled)': {
                        '&:hover': {
                            background: token.colorFillSecondary
                        },
                        '&:active': {
                            background: token.colorFill
                        }
                    }
                }
            }
        }
    };
};
exports.default = (0, _internal.genStyleHooks)([
    'Input',
    'Search'
], (token)=>{
    return [
        genSearchStyle(token)
    ];
});

},{"../../theme/internal":"eQVSZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dnpOk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _textarea = require("@rc-component/textarea");
var _textareaDefault = parcelHelpers.interopDefault(_textarea);
var _clsx = require("clsx");
var _getAllowClear = require("../_util/getAllowClear");
var _getAllowClearDefault = parcelHelpers.interopDefault(_getAllowClear);
var _hooks = require("../_util/hooks");
var _statusUtils = require("../_util/statusUtils");
var _warning = require("../_util/warning");
var _context = require("../config-provider/context");
var _disabledContext = require("../config-provider/DisabledContext");
var _disabledContextDefault = parcelHelpers.interopDefault(_disabledContext);
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _useSize = require("../config-provider/hooks/useSize");
var _useSizeDefault = parcelHelpers.interopDefault(_useSize);
var _context1 = require("../form/context");
var _useVariants = require("../form/hooks/useVariants");
var _useVariantsDefault = parcelHelpers.interopDefault(_useVariants);
var _compact = require("../space/Compact");
var _input = require("./Input");
var _style = require("./style");
var _textarea1 = require("./style/textarea");
var _textareaDefault1 = parcelHelpers.interopDefault(_textarea1);
"use client";
const TextArea = /*#__PURE__*/ (0, _react.forwardRef)((props, ref)=>{
    const { prefixCls: customizePrefixCls, bordered = true, size: customizeSize, disabled: customDisabled, status: customStatus, allowClear, classNames, rootClassName, className, style, styles, variant: customVariant, showCount, onMouseDown, onResize, ...rest } = props;
    const { getPrefixCls, direction, allowClear: contextAllowClear, autoComplete: contextAutoComplete, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('textArea');
    // =================== Disabled ===================
    const disabled = _react.useContext((0, _disabledContextDefault.default));
    const mergedDisabled = customDisabled ?? disabled;
    // ==================== Status ====================
    const { status: contextStatus, hasFeedback, feedbackIcon } = _react.useContext((0, _context1.FormItemInputContext));
    const mergedStatus = (0, _statusUtils.getMergedStatus)(contextStatus, customStatus);
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props
    });
    // ===================== Ref ======================
    const innerRef = _react.useRef(null);
    _react.useImperativeHandle(ref, ()=>({
            resizableTextArea: innerRef.current?.resizableTextArea,
            focus: (option)=>{
                (0, _input.triggerFocus)(innerRef.current?.resizableTextArea?.textArea, option);
            },
            blur: ()=>innerRef.current?.blur()
        }));
    const prefixCls = getPrefixCls('input', customizePrefixCls);
    // ==================== Style =====================
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _style.useSharedStyle)(prefixCls, rootClassName);
    (0, _textareaDefault1.default)(prefixCls, rootCls);
    // ================= Compact Item =================
    const { compactSize, compactItemClassnames } = (0, _compact.useCompactItemContext)(prefixCls, direction);
    // ===================== Size =====================
    const mergedSize = (0, _useSizeDefault.default)((ctx)=>customizeSize ?? compactSize ?? ctx);
    const [variant, enableVariantCls] = (0, _useVariantsDefault.default)('textArea', customVariant, bordered);
    const mergedAllowClear = (0, _getAllowClearDefault.default)(allowClear ?? contextAllowClear);
    // ==================== Resize ====================
    // https://github.com/ant-design/ant-design/issues/51594
    const [isMouseDown, setIsMouseDown] = _react.useState(false);
    // When has wrapper, resize will make as dirty for `resize: both` style
    const [resizeDirty, setResizeDirty] = _react.useState(false);
    const onInternalMouseDown = (e)=>{
        setIsMouseDown(true);
        onMouseDown?.(e);
        const onMouseUp = ()=>{
            setIsMouseDown(false);
            document.removeEventListener('mouseup', onMouseUp);
        };
        document.addEventListener('mouseup', onMouseUp);
    };
    const onInternalResize = (size)=>{
        onResize?.(size);
        // Change to dirty since this maybe from the `resize: both` style
        if (isMouseDown && typeof getComputedStyle === 'function') {
            const ele = innerRef.current?.nativeElement?.querySelector('textarea');
            if (ele && getComputedStyle(ele).resize === 'both') setResizeDirty(true);
        }
    };
    // ==================== Render ====================
    return /*#__PURE__*/ _react.createElement((0, _textareaDefault.default), {
        autoComplete: contextAutoComplete,
        ...rest,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        styles: mergedStyles,
        disabled: mergedDisabled,
        allowClear: mergedAllowClear,
        className: (0, _clsx.clsx)(cssVarCls, rootCls, className, rootClassName, compactItemClassnames, contextClassName, mergedClassNames.root, // Only for wrapper
        {
            [`${prefixCls}-textarea-affix-wrapper-resize-dirty`]: resizeDirty
        }),
        classNames: {
            ...mergedClassNames,
            textarea: (0, _clsx.clsx)({
                [`${prefixCls}-sm`]: mergedSize === 'small',
                [`${prefixCls}-lg`]: mergedSize === 'large'
            }, hashId, mergedClassNames.textarea, isMouseDown && `${prefixCls}-mouse-active`),
            variant: (0, _clsx.clsx)({
                [`${prefixCls}-${variant}`]: enableVariantCls
            }, (0, _statusUtils.getStatusClassNames)(prefixCls, mergedStatus)),
            affixWrapper: (0, _clsx.clsx)(`${prefixCls}-textarea-affix-wrapper`, {
                [`${prefixCls}-affix-wrapper-rtl`]: direction === 'rtl',
                [`${prefixCls}-affix-wrapper-sm`]: mergedSize === 'small',
                [`${prefixCls}-affix-wrapper-lg`]: mergedSize === 'large',
                [`${prefixCls}-textarea-show-count`]: showCount || props.count?.show
            }, hashId)
        },
        prefixCls: prefixCls,
        suffix: hasFeedback && /*#__PURE__*/ _react.createElement("span", {
            className: `${prefixCls}-textarea-suffix`
        }, feedbackIcon),
        showCount: showCount,
        ref: innerRef,
        onResize: onInternalResize,
        onMouseDown: onInternalMouseDown
    });
});
exports.default = TextArea;

},{"react":"bmhQu","@rc-component/textarea":"8cBem","clsx":"431Ou","../_util/getAllowClear":"izZDR","../_util/hooks":"kdnMA","../_util/statusUtils":"gbJk4","../_util/warning":"95o3w","../config-provider/context":"75zwC","../config-provider/DisabledContext":"h4TcW","../config-provider/hooks/useCSSVarCls":"gcu2s","../config-provider/hooks/useSize":"gXe6G","../form/context":"krZYn","../form/hooks/useVariants":"larUs","../space/Compact":"cOSpV","./Input":"3rYvz","./style":"8tbVx","./style/textarea":"h6E4T","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8cBem":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ResizableTextArea", ()=>(0, _resizableTextAreaDefault.default));
var _textArea = require("./TextArea");
var _textAreaDefault = parcelHelpers.interopDefault(_textArea);
var _resizableTextArea = require("./ResizableTextArea");
var _resizableTextAreaDefault = parcelHelpers.interopDefault(_resizableTextArea);
exports.default = (0, _textAreaDefault.default);

},{"./TextArea":"8150l","./ResizableTextArea":"3DZxI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8150l":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _input = require("@rc-component/input");
var _useCount = require("@rc-component/input/es/hooks/useCount");
var _useCountDefault = parcelHelpers.interopDefault(_useCount);
var _commonUtils = require("@rc-component/input/es/utils/commonUtils");
var _useControlledState = require("@rc-component/util/es/hooks/useControlledState");
var _useControlledStateDefault = parcelHelpers.interopDefault(_useControlledState);
var _clsx = require("clsx");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _resizableTextArea = require("./ResizableTextArea");
var _resizableTextAreaDefault = parcelHelpers.interopDefault(_resizableTextArea);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const TextArea = /*#__PURE__*/ (0, _reactDefault.default).forwardRef(({ defaultValue, value: customValue, onFocus, onBlur, onChange, allowClear, maxLength, onCompositionStart, onCompositionEnd, suffix, prefixCls = 'rc-textarea', showCount, count, className, style, disabled, hidden, classNames, styles, onResize, onClear, onPressEnter, readOnly, autoSize, onKeyDown, ...rest }, ref)=>{
    const [value, setValue] = (0, _useControlledStateDefault.default)(defaultValue, customValue);
    const formatValue = value === undefined || value === null ? '' : String(value);
    const [focused, setFocused] = (0, _reactDefault.default).useState(false);
    const compositionRef = (0, _reactDefault.default).useRef(false);
    const [textareaResized, setTextareaResized] = (0, _reactDefault.default).useState(null);
    // =============================== Ref ================================
    const holderRef = (0, _react.useRef)(null);
    const resizableTextAreaRef = (0, _react.useRef)(null);
    const getTextArea = ()=>resizableTextAreaRef.current?.textArea;
    const focus = ()=>{
        getTextArea().focus();
    };
    (0, _react.useImperativeHandle)(ref, ()=>({
            resizableTextArea: resizableTextAreaRef.current,
            focus,
            blur: ()=>{
                getTextArea().blur();
            },
            nativeElement: holderRef.current?.nativeElement || getTextArea()
        }));
    (0, _react.useEffect)(()=>{
        setFocused((prev)=>!disabled && prev);
    }, [
        disabled
    ]);
    // =========================== Select Range ===========================
    const [selection, setSelection] = (0, _reactDefault.default).useState(null);
    (0, _reactDefault.default).useEffect(()=>{
        if (selection) getTextArea().setSelectionRange(...selection);
    }, [
        selection
    ]);
    // ============================== Count ===============================
    const countConfig = (0, _useCountDefault.default)(count, showCount);
    const mergedMax = countConfig.max ?? maxLength;
    // Max length value
    const hasMaxLength = Number(mergedMax) > 0;
    const valueLength = countConfig.strategy(formatValue);
    const isOutOfRange = !!mergedMax && valueLength > mergedMax;
    // ============================== Change ==============================
    const triggerChange = (e, currentValue)=>{
        let cutValue = currentValue;
        if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
            cutValue = countConfig.exceedFormatter(currentValue, {
                max: countConfig.max
            });
            if (currentValue !== cutValue) setSelection([
                getTextArea().selectionStart || 0,
                getTextArea().selectionEnd || 0
            ]);
        }
        setValue(cutValue);
        (0, _commonUtils.resolveOnChange)(e.currentTarget, e, onChange, cutValue);
    };
    // =========================== Value Update ===========================
    const onInternalCompositionStart = (e)=>{
        compositionRef.current = true;
        onCompositionStart?.(e);
    };
    const onInternalCompositionEnd = (e)=>{
        compositionRef.current = false;
        triggerChange(e, e.currentTarget.value);
        onCompositionEnd?.(e);
    };
    const onInternalChange = (e)=>{
        triggerChange(e, e.target.value);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && onPressEnter && !e.nativeEvent.isComposing) onPressEnter(e);
        onKeyDown?.(e);
    };
    const handleFocus = (e)=>{
        setFocused(true);
        onFocus?.(e);
    };
    const handleBlur = (e)=>{
        setFocused(false);
        onBlur?.(e);
    };
    // ============================== Reset ===============================
    const handleReset = (e)=>{
        setValue('');
        focus();
        (0, _commonUtils.resolveOnChange)(getTextArea(), e, onChange);
    };
    let suffixNode = suffix;
    let dataCount;
    if (countConfig.show) {
        if (countConfig.showFormatter) dataCount = countConfig.showFormatter({
            value: formatValue,
            count: valueLength,
            maxLength: mergedMax
        });
        else dataCount = `${valueLength}${hasMaxLength ? ` / ${mergedMax}` : ''}`;
        suffixNode = /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, suffixNode, /*#__PURE__*/ (0, _reactDefault.default).createElement("span", {
            className: (0, _clsx.clsx)(`${prefixCls}-data-count`, classNames?.count),
            style: styles?.count
        }, dataCount));
    }
    const handleResize = (size)=>{
        onResize?.(size);
        if (getTextArea()?.style.height) setTextareaResized(true);
    };
    const isPureTextArea = !autoSize && !showCount && !allowClear;
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _input.BaseInput), {
        ref: holderRef,
        value: formatValue,
        allowClear: allowClear,
        handleReset: handleReset,
        suffix: suffixNode,
        prefixCls: prefixCls,
        classNames: {
            ...classNames,
            affixWrapper: (0, _clsx.clsx)(classNames?.affixWrapper, {
                [`${prefixCls}-show-count`]: showCount,
                [`${prefixCls}-textarea-allow-clear`]: allowClear
            })
        },
        disabled: disabled,
        focused: focused,
        className: (0, _clsx.clsx)(className, isOutOfRange && `${prefixCls}-out-of-range`),
        style: {
            ...style,
            ...textareaResized && !isPureTextArea ? {
                height: 'auto'
            } : {}
        },
        dataAttrs: {
            affixWrapper: {
                'data-count': typeof dataCount === 'string' ? dataCount : undefined
            }
        },
        hidden: hidden,
        readOnly: readOnly,
        onClear: onClear
    }, /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _resizableTextAreaDefault.default), _extends({}, rest, {
        autoSize: autoSize,
        maxLength: maxLength,
        onKeyDown: handleKeyDown,
        onChange: onInternalChange,
        onFocus: handleFocus,
        onBlur: handleBlur,
        onCompositionStart: onInternalCompositionStart,
        onCompositionEnd: onInternalCompositionEnd,
        className: (0, _clsx.clsx)(classNames?.textarea),
        style: {
            resize: style?.resize,
            ...styles?.textarea
        },
        disabled: disabled,
        prefixCls: prefixCls,
        onResize: handleResize,
        ref: resizableTextAreaRef,
        readOnly: readOnly
    })));
});
exports.default = TextArea;

},{"@rc-component/input":"3if1E","@rc-component/input/es/hooks/useCount":"bzoUj","@rc-component/input/es/utils/commonUtils":"lbeHE","@rc-component/util/es/hooks/useControlledState":"2FQtD","clsx":"431Ou","react":"bmhQu","./ResizableTextArea":"3DZxI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3DZxI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _resizeObserver = require("@rc-component/resize-observer");
var _resizeObserverDefault = parcelHelpers.interopDefault(_resizeObserver);
var _useControlledState = require("@rc-component/util/es/hooks/useControlledState");
var _useControlledStateDefault = parcelHelpers.interopDefault(_useControlledState);
var _useLayoutEffect = require("@rc-component/util/es/hooks/useLayoutEffect");
var _useLayoutEffectDefault = parcelHelpers.interopDefault(_useLayoutEffect);
var _raf = require("@rc-component/util/es/raf");
var _rafDefault = parcelHelpers.interopDefault(_raf);
var _clsx = require("clsx");
var _react = require("react");
var _calculateNodeHeight = require("./calculateNodeHeight");
var _calculateNodeHeightDefault = parcelHelpers.interopDefault(_calculateNodeHeight);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const RESIZE_START = 0;
const RESIZE_MEASURING = 1;
const RESIZE_STABLE = 2;
const ResizableTextArea = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls, defaultValue, value, autoSize, onResize, className, style, disabled, onChange, // Test only
    onInternalAutoSize, ...restProps } = props;
    // =============================== Value ================================
    const [internalValue, setMergedValue] = (0, _useControlledStateDefault.default)(defaultValue, value);
    const mergedValue = internalValue ?? '';
    const onInternalChange = (event)=>{
        setMergedValue(event.target.value);
        onChange?.(event);
    };
    // ================================ Ref =================================
    const textareaRef = _react.useRef();
    _react.useImperativeHandle(ref, ()=>({
            textArea: textareaRef.current
        }));
    // ============================== AutoSize ==============================
    const [minRows, maxRows] = _react.useMemo(()=>{
        if (autoSize && typeof autoSize === 'object') return [
            autoSize.minRows,
            autoSize.maxRows
        ];
        return [];
    }, [
        autoSize
    ]);
    const needAutoSize = !!autoSize;
    // =============================== Resize ===============================
    const [resizeState, setResizeState] = _react.useState(RESIZE_STABLE);
    const [autoSizeStyle, setAutoSizeStyle] = _react.useState();
    const startResize = ()=>{
        setResizeState(RESIZE_START);
    };
    // Change to trigger resize measure
    (0, _useLayoutEffectDefault.default)(()=>{
        if (needAutoSize) startResize();
    }, [
        value,
        minRows,
        maxRows,
        needAutoSize
    ]);
    (0, _useLayoutEffectDefault.default)(()=>{
        if (resizeState === RESIZE_START) setResizeState(RESIZE_MEASURING);
        else if (resizeState === RESIZE_MEASURING) {
            const textareaStyles = (0, _calculateNodeHeightDefault.default)(textareaRef.current, false, minRows, maxRows);
            // Safari has bug that text will keep break line on text cut when it's prev is break line.
            // ZombieJ: This not often happen. So we just skip it.
            // const { selectionStart, selectionEnd, scrollTop } = textareaRef.current;
            // const { value: tmpValue } = textareaRef.current;
            // textareaRef.current.value = '';
            // textareaRef.current.value = tmpValue;
            // if (document.activeElement === textareaRef.current) {
            //   textareaRef.current.scrollTop = scrollTop;
            //   textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
            // }
            setResizeState(RESIZE_STABLE);
            setAutoSizeStyle(textareaStyles);
        }
    }, [
        resizeState
    ]);
    // We lock resize trigger by raf to avoid Safari warning
    const resizeRafRef = _react.useRef();
    const cleanRaf = ()=>{
        (0, _rafDefault.default).cancel(resizeRafRef.current);
    };
    const onInternalResize = (size)=>{
        if (resizeState === RESIZE_STABLE) {
            onResize?.(size);
            if (autoSize) {
                cleanRaf();
                resizeRafRef.current = (0, _rafDefault.default)(()=>{
                    startResize();
                });
            }
        }
    };
    _react.useEffect(()=>cleanRaf, []);
    // =============================== Render ===============================
    const mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
    const mergedStyle = {
        ...style,
        ...mergedAutoSizeStyle
    };
    if (resizeState === RESIZE_START || resizeState === RESIZE_MEASURING) {
        mergedStyle.overflowY = 'hidden';
        mergedStyle.overflowX = 'hidden';
    }
    return /*#__PURE__*/ _react.createElement((0, _resizeObserverDefault.default), {
        onResize: onInternalResize,
        disabled: !(autoSize || onResize)
    }, /*#__PURE__*/ _react.createElement("textarea", _extends({}, restProps, {
        ref: textareaRef,
        style: mergedStyle,
        className: (0, _clsx.clsx)(prefixCls, className, {
            [`${prefixCls}-disabled`]: disabled
        }),
        disabled: disabled,
        value: mergedValue,
        onChange: onInternalChange
    })));
});
exports.default = ResizableTextArea;

},{"@rc-component/resize-observer":"4dgtN","@rc-component/util/es/hooks/useControlledState":"2FQtD","@rc-component/util/es/hooks/useLayoutEffect":"azwns","@rc-component/util/es/raf":"ajbAx","clsx":"431Ou","react":"bmhQu","./calculateNodeHeight":"dgbeT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dgbeT":[function(require,module,exports,__globalThis) {
// Thanks to https://github.com/andreypopp/react-textarea-autosize/
/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateNodeStyling", ()=>calculateNodeStyling);
parcelHelpers.export(exports, "default", ()=>calculateAutoSizeStyle);
const HIDDEN_TEXTAREA_STYLE = `
  min-height:0 !important;
  max-height:none !important;
  height:0 !important;
  visibility:hidden !important;
  overflow:hidden !important;
  position:absolute !important;
  z-index:-1000 !important;
  top:0 !important;
  right:0 !important;
  pointer-events: none !important;
`;
const SIZING_STYLE = [
    'letter-spacing',
    'line-height',
    'padding-top',
    'padding-bottom',
    'font-family',
    'font-weight',
    'font-size',
    'font-variant',
    'text-rendering',
    'text-transform',
    'width',
    'text-indent',
    'padding-left',
    'padding-right',
    'border-width',
    'box-sizing',
    'word-break',
    'white-space'
];
const computedStyleCache = {};
let hiddenTextarea;
function calculateNodeStyling(node, useCache = false) {
    const nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
    if (useCache && computedStyleCache[nodeRef]) return computedStyleCache[nodeRef];
    const style = window.getComputedStyle(node);
    const boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
    const paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
    const borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
    const sizingStyle = SIZING_STYLE.map((name)=>`${name}:${style.getPropertyValue(name)}`).join(';');
    const nodeInfo = {
        sizingStyle,
        paddingSize,
        borderSize,
        boxSizing
    };
    if (useCache && nodeRef) computedStyleCache[nodeRef] = nodeInfo;
    return nodeInfo;
}
function calculateAutoSizeStyle(uiTextNode, useCache = false, minRows = null, maxRows = null) {
    if (!hiddenTextarea) {
        hiddenTextarea = document.createElement('textarea');
        hiddenTextarea.setAttribute('tab-index', '-1');
        hiddenTextarea.setAttribute('aria-hidden', 'true');
        // fix: A form field element should have an id or name attribute
        // A form field element has neither an id nor a name attribute. This might prevent the browser from correctly autofilling the form.
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/textarea
        hiddenTextarea.setAttribute('name', 'hiddenTextarea');
        document.body.appendChild(hiddenTextarea);
    }
    // Fix wrap="off" issue
    // https://github.com/ant-design/ant-design/issues/6577
    if (uiTextNode.getAttribute('wrap')) hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
    else hiddenTextarea.removeAttribute('wrap');
    // Copy all CSS properties that have an impact on the height of the content in
    // the textbox
    const { paddingSize, borderSize, boxSizing, sizingStyle } = calculateNodeStyling(uiTextNode, useCache);
    // Need to have the overflow attribute to hide the scrollbar otherwise
    // text-lines will not calculated properly as the shadow will technically be
    // narrower for content
    hiddenTextarea.setAttribute('style', `${sizingStyle};${HIDDEN_TEXTAREA_STYLE}`);
    hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
    let minHeight = undefined;
    let maxHeight = undefined;
    let overflowY;
    let height = hiddenTextarea.scrollHeight;
    if (boxSizing === 'border-box') // border-box: add border, since height = content + padding + border
    height += borderSize;
    else if (boxSizing === 'content-box') // remove padding, since height = content
    height -= paddingSize;
    if (minRows !== null || maxRows !== null) {
        // measure height of a textarea with a single row
        hiddenTextarea.value = ' ';
        const singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
        if (minRows !== null) {
            minHeight = singleRowHeight * minRows;
            if (boxSizing === 'border-box') minHeight = minHeight + paddingSize + borderSize;
            height = Math.max(minHeight, height);
        }
        if (maxRows !== null) {
            maxHeight = singleRowHeight * maxRows;
            if (boxSizing === 'border-box') maxHeight = maxHeight + paddingSize + borderSize;
            overflowY = height > maxHeight ? '' : 'hidden';
            height = Math.min(maxHeight, height);
        }
    }
    const style = {
        height,
        overflowY,
        resize: 'none'
    };
    if (minHeight) style.minHeight = minHeight;
    if (maxHeight) style.maxHeight = maxHeight;
    return style;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h6E4T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "initComponentToken", ()=>(0, _token.initComponentToken));
parcelHelpers.export(exports, "initInputToken", ()=>(0, _token.initInputToken));
var _internal = require("../../theme/internal");
var _token = require("./token");
const genTextAreaStyle = (token)=>{
    const { componentCls, paddingLG } = token;
    const textareaPrefixCls = `${componentCls}-textarea`;
    return {
        // Raw Textarea
        [`textarea${componentCls}`]: {
            maxWidth: '100%',
            // prevent textarea resize from coming out of its container
            height: 'auto',
            minHeight: token.controlHeight,
            lineHeight: token.lineHeight,
            verticalAlign: 'bottom',
            transition: `all ${token.motionDurationSlow}`,
            resize: 'vertical',
            [`&${componentCls}-mouse-active`]: {
                transition: `all ${token.motionDurationSlow}, height 0s, width 0s`
            }
        },
        // Wrapper for resize
        [`${componentCls}-textarea-affix-wrapper-resize-dirty`]: {
            width: 'auto'
        },
        [textareaPrefixCls]: {
            position: 'relative',
            '&-show-count': {
                [`${componentCls}-data-count`]: {
                    position: 'absolute',
                    bottom: token.calc(token.fontSize).mul(token.lineHeight).mul(-1).equal(),
                    insetInlineEnd: 0,
                    color: token.colorTextDescription,
                    whiteSpace: 'nowrap',
                    pointerEvents: 'none'
                }
            },
            [`
        &-allow-clear > ${componentCls},
        &-affix-wrapper${textareaPrefixCls}-has-feedback ${componentCls}
      `]: {
                paddingInlineEnd: paddingLG
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
                padding: 0,
                [`> textarea${componentCls}`]: {
                    fontSize: 'inherit',
                    border: 'none',
                    outline: 'none',
                    background: 'transparent',
                    minHeight: token.calc(token.controlHeight).sub(token.calc(token.lineWidth).mul(2)).equal(),
                    '&:focus': {
                        boxShadow: 'none !important'
                    }
                },
                [`${componentCls}-suffix`]: {
                    margin: 0,
                    '> *:not(:last-child)': {
                        marginInline: 0
                    },
                    // Clear Icon
                    [`${componentCls}-clear-icon`]: {
                        position: 'absolute',
                        insetInlineEnd: token.paddingInline,
                        insetBlockStart: token.paddingXS
                    },
                    // Feedback Icon
                    [`${textareaPrefixCls}-suffix`]: {
                        position: 'absolute',
                        top: 0,
                        insetInlineEnd: token.paddingInline,
                        bottom: 0,
                        zIndex: 1,
                        display: 'inline-flex',
                        alignItems: 'center',
                        margin: 'auto',
                        pointerEvents: 'none'
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-rtl`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-data-count`]: {
                        direction: 'ltr',
                        insetInlineStart: 0
                    }
                }
            },
            [`&-affix-wrapper${componentCls}-affix-wrapper-sm`]: {
                [`${componentCls}-suffix`]: {
                    [`${componentCls}-clear-icon`]: {
                        insetInlineEnd: token.paddingInlineSM
                    }
                }
            }
        }
    };
};
// ============================== Export ==============================
exports.default = (0, _internal.genStyleHooks)([
    'Input',
    'TextArea'
], (token)=>{
    const inputToken = (0, _internal.mergeToken)(token, (0, _token.initInputToken)(token));
    return genTextAreaStyle(inputToken);
}, (0, _token.initComponentToken), {
    resetFont: false
});

},{"../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"./token":"aJMj7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g2nOx":[function() {},{}],"2KZSQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PROGRAM_GENERATOR_SLUGS", ()=>PROGRAM_GENERATOR_SLUGS);
parcelHelpers.export(exports, "MOVEMENT_INSIGHT_SLUGS", ()=>MOVEMENT_INSIGHT_SLUGS);
parcelHelpers.export(exports, "getSubStepSlugs", ()=>getSubStepSlugs);
parcelHelpers.export(exports, "EQUIPMENT_MANDATORY_APPROACHES", ()=>EQUIPMENT_MANDATORY_APPROACHES);
var _types = require("./types");
const PROGRAM_GENERATOR_SLUGS = [
    'intro',
    'client-selection',
    'energy-level',
    'non-gym-activity',
    'fitness-level',
    'movement-insights',
    'injuries-limitations',
    'intro-minipt',
    'program-duration',
    'training-schedule',
    'workout-duration',
    'training-goal',
    'training-goal-details',
    'secondary-training-goals',
    'program-intensity',
    'equipment',
    'review',
    'manual-program-name'
];
const MOVEMENT_INSIGHT_SLUGS = [
    'mobility-level',
    'stability-control',
    'balance-consistency',
    'movement-symmetry',
    'overall-movement-quality'
];
const getSubStepSlugs = (goal)=>{
    if (goal === (0, _types.TrainingGoalSlug).WeightLoss) return [
        'training-goal-details',
        'training-goal-preferences',
        'weight-loss-target',
        'training-goal-approaches'
    ];
    if (goal === (0, _types.TrainingGoalSlug).Rehabilitation) return [
        'training-goal-details',
        'rehabilitation-stage',
        'training-goal-approaches'
    ];
    if (goal === (0, _types.TrainingGoalSlug).Endurance || goal === (0, _types.TrainingGoalSlug).GeneralFitness) return [
        'training-goal-details',
        'training-goal-approaches'
    ];
    return [
        'training-goal-details',
        'training-goal-preferences',
        'training-goal-approaches'
    ];
};
const EQUIPMENT_MANDATORY_APPROACHES = [
    'compound-strength-training',
    'powerlifting-focused',
    'strength-muscle-building',
    'full-body-hypertrophy',
    'upper-lower-split',
    'push-pull-legs',
    'body-part-split',
    'strength-based-fat-loss',
    'cardio-strength-mix',
    'strength-power',
    'strength-cardio-mix',
    'return-to-strength'
];

},{"./types":"1DGo2","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fQUDQ":[function() {},{}],"kiv6R":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ProgramGenerated", ()=>ProgramGenerated);
var _jsxRuntime = require("react/jsx-runtime");
var _programGeneratedScss = require("./program-generated.scss");
var _dnd = require("@hello-pangea/dnd");
var _antd = require("antd");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("@tanstack/react-query");
var _useMockGenerateWorkoutProgramCoachProd = require("src/api/mutations/useMockGenerateWorkoutProgramCoachProd");
var _useGenerateWorkoutProgramCoachProd = require("src/api/mutations/useGenerateWorkoutProgramCoachProd");
var _useGetTrainerClients = require("src/api/mutations/useGetTrainerClients");
var _useSaveClientProgram = require("src/api/mutations/useSaveClientProgram");
var _useSendProgramPlanToClient = require("src/api/mutations/useSendProgramPlanToClient");
var _useGetAllMovements = require("src/api/queries/useGetAllMovements");
var _useGetTrainerProgramById = require("src/api/queries/useGetTrainerProgramById");
var _durationSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/duration.svg");
var _energyLevelSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/energy-level.svg");
var _focusSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/focus.svg");
var _goalApproachedSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/workouts/goal-approached.svg");
var _dashboardModalDeleteSvg = require("src/assets/images/trainer/clients/dashboard-modal-delete.svg");
var _simpleLineCheckSvg = require("src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/simple-line-check.svg");
var _programGeneratorProgressStore = require("src/store/programGeneratorProgressStore");
var _sessionStore = require("src/store/sessionStore");
var _firebase = require("src/config/firebase");
var _miniPtCareMp4 = require("url:../../../../../../assets/videos/mini-pt-care.mp4");
var _miniPtCareMp4Default = parcelHelpers.interopDefault(_miniPtCareMp4);
var _button = require("../../../../components/Button/Button");
var _confirmation = require("../ProgramGeneratorAI/assets/Confirmation");
var _programGenerator = require("../ProgramGeneratorAI/assets/ProgramGenerator");
var _types = require("../ProgramGeneratorAI/types");
var _buildPayload = require("../ProgramGeneratorAI/utils/buildPayload");
var _shareProgramModal = require("../Programs/components/ShareProgramModal/ShareProgramModal");
var _assignToClientModal = require("./components/AssignToClientModal/AssignToClientModal");
var _exerciseImages = require("./ExerciseImages");
var _genderUtils = require("src/utils/genderUtils");
var _exerciseLibrary = require("./ExerciseLibrary");
var _transformProgramStateToPlan = require("./transformProgramStateToPlan");
var _useProgramDataTransformer = require("./useProgramDataTransformer");
var _useMockProgramDataTransformer = require("./useMockProgramDataTransformer");
const USE_MOCK = false;
const transformApiToProgramData = USE_MOCK ? (0, _useMockProgramDataTransformer.transformApiToProgramData) : (0, _useProgramDataTransformer.transformApiToProgramData);
const transformFinalPlanToProgramData = USE_MOCK ? (0, _useMockProgramDataTransformer.transformFinalPlanToProgramData) : (0, _useProgramDataTransformer.transformFinalPlanToProgramData);
const DEFAULT_OFFSETS_BY_COUNT = {
    1: [
        0
    ],
    2: [
        0,
        3
    ],
    3: [
        0,
        2,
        4
    ],
    4: [
        0,
        2,
        4,
        5
    ],
    5: [
        0,
        1,
        2,
        3,
        4
    ],
    6: [
        0,
        1,
        2,
        3,
        4,
        5
    ],
    7: [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]
};
const DAY_LABELS = {
    monday: {
        full: 'Monday',
        short: 'Mon'
    },
    tuesday: {
        full: 'Tuesday',
        short: 'Tue'
    },
    wednesday: {
        full: 'Wednesday',
        short: 'Wed'
    },
    thursday: {
        full: 'Thursday',
        short: 'Thu'
    },
    friday: {
        full: 'Friday',
        short: 'Fri'
    },
    saturday: {
        full: 'Saturday',
        short: 'Sat'
    },
    sunday: {
        full: 'Sunday',
        short: 'Sun'
    },
    mon: {
        full: 'Monday',
        short: 'Mon'
    },
    tue: {
        full: 'Tuesday',
        short: 'Tue'
    },
    wed: {
        full: 'Wednesday',
        short: 'Wed'
    },
    thu: {
        full: 'Thursday',
        short: 'Thu'
    },
    fri: {
        full: 'Friday',
        short: 'Fri'
    },
    sat: {
        full: 'Saturday',
        short: 'Sat'
    },
    sun: {
        full: 'Sunday',
        short: 'Sun'
    }
};
const ORDERED_DAYS = [
    {
        full: 'Monday',
        short: 'Mon'
    },
    {
        full: 'Tuesday',
        short: 'Tue'
    },
    {
        full: 'Wednesday',
        short: 'Wed'
    },
    {
        full: 'Thursday',
        short: 'Thu'
    },
    {
        full: 'Friday',
        short: 'Fri'
    },
    {
        full: 'Saturday',
        short: 'Sat'
    },
    {
        full: 'Sunday',
        short: 'Sun'
    }
];
const getExerciseDisplayInfo = (ex, gender, allMovements)=>{
    const normalize = (str)=>(str || '').replace(/[^a-zA-Z0-9]/g, '').toLowerCase();
    const masterExercise = allMovements.find((m)=>normalize(m.en_display_name) === normalize(ex.name) || normalize(m.id) === normalize(ex.name));
    const isFemale = (0, _genderUtils.isFemaleProfile)(gender);
    const currentImage = isFemale ? ex.image_female_url || ex.image_male_url : ex.image_male_url || ex.image_female_url;
    const masterImage = isFemale ? masterExercise?.image_female_url || masterExercise?.image_male_url : masterExercise?.image_male_url || masterExercise?.image_female_url;
    const displayName = masterExercise?.en_display_name || ex.name;
    const fallbackImage = (0, _exerciseImages.exerciseImagesMap)[displayName]?.[(0, _genderUtils.resolveBodyProfile)(gender)];
    const displayImage = currentImage || masterImage || fallbackImage;
    return {
        displayName,
        displayImage
    };
};
const WorkoutSection = ({ id, className = '', children })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        id: id,
        className: className,
        children: children
    });
};
const DroppableExercisesList = ({ id, children })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.Droppable), {
        droppableId: id,
        direction: "vertical",
        children: (provided, snapshot)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: provided.innerRef,
                ...provided.droppableProps,
                className: `exercises-list ${snapshot.isDraggingOver ? 'match-over' : ''}`,
                style: {
                    minHeight: '50px'
                },
                children: [
                    children,
                    provided.placeholder
                ]
            })
    });
};
const DroppableSuperset = ({ id, children, style, className = '' })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `superset-content-wrapper ${className}`,
        style: style,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "superset-content-inner",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.Droppable), {
                droppableId: id,
                direction: "vertical",
                children: (provided, snapshot)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        ref: provided.innerRef,
                        ...provided.droppableProps,
                        className: `superset-content ${snapshot.isDraggingOver ? 'match-over' : ''}`,
                        children: [
                            children,
                            provided.placeholder
                        ]
                    })
            })
        })
    });
};
const SortableExerciseCard = ({ ex, index, sectionId, gender, getExerciseMenu, isGenerating, supersetLabel, onDoubleClickMetrics, isEditing, focusField = 'reps', editForm, setEditForm, onEditCancel })=>{
    const { data: movements = [] } = (0, _useGetAllMovements.useGetAllMovements)();
    const { displayName, displayImage } = getExerciseDisplayInfo(ex, gender, movements);
    const setsInputRef = (0, _react.useRef)(null);
    const repsInputRef = (0, _react.useRef)(null);
    const restInputRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (isEditing) {
            const timer = setTimeout(()=>{
                if (focusField === 'sets') {
                    setsInputRef.current?.focus();
                    setsInputRef.current?.select();
                } else if (focusField === 'rest') {
                    restInputRef.current?.focus();
                    restInputRef.current?.select();
                } else {
                    repsInputRef.current?.focus();
                    repsInputRef.current?.select();
                }
            }, 50);
            return ()=>clearTimeout(timer);
        }
    }, [
        isEditing,
        focusField
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.Draggable), {
        draggableId: ex.id,
        index: index,
        children: (provided, snapshot)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: provided.innerRef,
                ...provided.draggableProps,
                style: provided.draggableProps.style,
                className: `exercise-card ${snapshot.isDragging ? 'dragging' : ''}`,
                children: [
                    !supersetLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "drag-handle",
                        ...provided.dragHandleProps,
                        children: (0, _programGenerator.programGeneratorSVG).sidebar.exercisePickerDots
                    }),
                    isGenerating ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "exercise-replacement-state",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "replacement-icon",
                                children: (0, _programGenerator.programGeneratorSVG).header.regenerateWorkout
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "replacement-text",
                                children: "Hang on while I'm generating a replacement..."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            supersetLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: `superset-label ${supersetLabel.startsWith('B') ? 'secondary' : ''}`,
                                children: supersetLabel
                            }),
                            supersetLabel && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "drag-handle",
                                ...provided.dragHandleProps,
                                children: (0, _programGenerator.programGeneratorSVG).sidebar.exercisePickerDots
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "exercise-thumb",
                                children: displayImage ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                    src: displayImage,
                                    alt: displayName
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        width: '100%',
                                        height: '100%',
                                        backgroundColor: '#2a2d3d',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '8px',
                                        color: '#8a8d9d',
                                        fontSize: '12px',
                                        fontWeight: 'bold'
                                    },
                                    children: (displayName || 'U').slice(0, 2).toUpperCase()
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "exercise-details",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                        children: displayName
                                    }),
                                    isEditing ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "pg-inline-edit-overlay",
                                                onClick: onEditCancel
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "exercise-metrics metrics-grid pg-inline-edit-metrics",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "metric-box inline-box",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                            ref: setsInputRef,
                                                            type: "number",
                                                            min: "1",
                                                            value: editForm?.sets || '',
                                                            onChange: (e)=>{
                                                                const val = e.target.value;
                                                                if (val !== '') {
                                                                    const num = parseInt(val, 10);
                                                                    if (isNaN(num) || num <= 0) {
                                                                        (0, _reactHotToastDefault.default).error('Sets must be greater than 0');
                                                                        return;
                                                                    }
                                                                    if (num > 99) {
                                                                        (0, _reactHotToastDefault.default).error('Sets cannot exceed 99');
                                                                        return;
                                                                    }
                                                                    setEditForm?.({
                                                                        ...editForm,
                                                                        sets: num
                                                                    });
                                                                } else setEditForm?.({
                                                                    ...editForm,
                                                                    sets: ''
                                                                });
                                                            },
                                                            onKeyDown: (e)=>{
                                                                if (e.key === 'Enter') {
                                                                    e.preventDefault();
                                                                    e.target.blur();
                                                                    onEditCancel?.();
                                                                }
                                                            },
                                                            className: "pg-inline-input"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "times",
                                                        children: "\xd7"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "metric-box inline-box with-select",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                ref: repsInputRef,
                                                                type: "number",
                                                                min: "1",
                                                                value: editForm?.metricType === 'duration' ? editForm?.duration : editForm?.reps,
                                                                onChange: (e)=>{
                                                                    const val = e.target.value;
                                                                    if (val !== '') {
                                                                        const num = parseInt(val, 10);
                                                                        const isDuration = editForm?.metricType === 'duration';
                                                                        const fieldName = isDuration ? 'Duration' : 'Reps';
                                                                        if (isNaN(num) || num <= 0) {
                                                                            (0, _reactHotToastDefault.default).error(`${fieldName} must be greater than 0`);
                                                                            return;
                                                                        }
                                                                        const maxVal = isDuration ? 3600 : 999;
                                                                        if (num > maxVal) {
                                                                            (0, _reactHotToastDefault.default).error(`${fieldName} cannot exceed ${maxVal}${isDuration ? ' sec' : ''}`);
                                                                            return;
                                                                        }
                                                                        if (isDuration) setEditForm?.({
                                                                            ...editForm,
                                                                            duration: num
                                                                        });
                                                                        else setEditForm?.({
                                                                            ...editForm,
                                                                            reps: num
                                                                        });
                                                                    } else if (editForm?.metricType === 'duration') setEditForm?.({
                                                                        ...editForm,
                                                                        duration: ''
                                                                    });
                                                                    else setEditForm?.({
                                                                        ...editForm,
                                                                        reps: ''
                                                                    });
                                                                },
                                                                onKeyDown: (e)=>{
                                                                    if (e.key === 'Enter') {
                                                                        e.preventDefault();
                                                                        e.target.blur();
                                                                        onEditCancel?.();
                                                                    }
                                                                },
                                                                className: "pg-inline-input"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                                                menu: {
                                                                    items: [
                                                                        {
                                                                            key: 'reps',
                                                                            label: 'reps',
                                                                            onClick: ()=>setEditForm?.({
                                                                                    ...editForm,
                                                                                    metricType: 'reps'
                                                                                }),
                                                                            className: editForm?.metricType === 'reps' ? 'active-week-item' : ''
                                                                        },
                                                                        {
                                                                            key: 'duration',
                                                                            label: 'sec',
                                                                            onClick: ()=>setEditForm?.({
                                                                                    ...editForm,
                                                                                    metricType: 'duration'
                                                                                }),
                                                                            className: editForm?.metricType === 'duration' ? 'active-week-item' : ''
                                                                        }
                                                                    ]
                                                                },
                                                                trigger: [
                                                                    'click'
                                                                ],
                                                                classNames: {
                                                                    root: 'week-dropdown-menu-overlay pg-inline-edit-dropdown-menu-overlay'
                                                                },
                                                                placement: "bottom",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                                    className: "pg-inline-select",
                                                                    style: {
                                                                        display: 'flex',
                                                                        alignItems: 'center',
                                                                        gap: '4px',
                                                                        padding: 0
                                                                    },
                                                                    children: [
                                                                        editForm?.metricType === 'duration' ? 'sec' : 'reps',
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "dropdown-arrow",
                                                                            style: {
                                                                                display: 'flex',
                                                                                transform: 'scale(0.8)'
                                                                            },
                                                                            children: (0, _programGenerator.programGeneratorSVG).weekProgram.weekDropdownArrow
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "metric-box rest inline-box with-text",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                ref: restInputRef,
                                                                type: "text",
                                                                value: (()=>{
                                                                    const m = String(editForm?.restAfterExercise || editForm?.restBetweenSets || '').match(/\d+/);
                                                                    return m && m[0] !== '0' ? m[0] : '';
                                                                })(),
                                                                onChange: (e)=>{
                                                                    const val = e.target.value.trim();
                                                                    if (val !== '') {
                                                                        const num = Number(val);
                                                                        if (isNaN(num) || num <= 0) {
                                                                            (0, _reactHotToastDefault.default).error('Rest duration must be greater than 0');
                                                                            return;
                                                                        }
                                                                        if (num > 3600) {
                                                                            (0, _reactHotToastDefault.default).error('Rest duration cannot exceed 3600 sec');
                                                                            return;
                                                                        }
                                                                    }
                                                                    const formattedRest = val ? `${val}s` : '0s';
                                                                    setEditForm?.({
                                                                        ...editForm,
                                                                        restAfterExercise: formattedRest,
                                                                        restBetweenSets: formattedRest
                                                                    });
                                                                },
                                                                onKeyDown: (e)=>{
                                                                    if (e.key === 'Enter') {
                                                                        e.preventDefault();
                                                                        e.target.blur();
                                                                        onEditCancel?.();
                                                                    }
                                                                },
                                                                className: "pg-inline-input"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: "rest"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "exercise-metrics metrics-grid",
                                        onDoubleClick: ()=>onDoubleClickMetrics?.('reps'),
                                        style: {
                                            cursor: 'pointer'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "metric-box",
                                                onDoubleClick: (e)=>{
                                                    e.stopPropagation();
                                                    onDoubleClickMetrics?.('sets');
                                                },
                                                children: ex.sets || 1
                                            }),
                                            ' ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "times",
                                                children: "\xd7"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "metric-box",
                                                onDoubleClick: (e)=>{
                                                    e.stopPropagation();
                                                    onDoubleClickMetrics?.('reps');
                                                },
                                                children: ex.metricType === 'duration' ? `${ex.duration || 60} sec` : `${ex.reps || 30} reps`
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "metric-box rest",
                                                onDoubleClick: (e)=>{
                                                    e.stopPropagation();
                                                    onDoubleClickMetrics?.('rest');
                                                },
                                                children: (()=>{
                                                    const m = String(ex.restAfterExercise || ex.restBetweenSets || '').match(/\d+/);
                                                    const num = m ? parseInt(m[0], 10) : 0;
                                                    return num > 0 ? `${num}s rest` : 'no rest';
                                                })()
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                menu: {
                                    items: getExerciseMenu(ex, sectionId)
                                },
                                trigger: [
                                    'click'
                                ],
                                placement: "bottomRight",
                                classNames: {
                                    root: 'action-dropdown-menu-overlay'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "icon-btn",
                                    children: (0, _programGenerator.programGeneratorSVG).exerciseAction.menu
                                })
                            })
                        ]
                    })
                ]
            })
    });
};
const SortableRestCard = ({ item, index, sectionId, getExerciseMenu, isEditing, editForm, setEditForm, onEditCancel, onDoubleClickMetrics })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.Draggable), {
        draggableId: item.id,
        index: index,
        children: (provided, snapshot)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: provided.innerRef,
                ...provided.draggableProps,
                style: provided.draggableProps.style,
                className: `exercise-card rest-card ${snapshot.isDragging ? 'dragging' : ''}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "drag-handle",
                        ...provided.dragHandleProps,
                        children: (0, _programGenerator.programGeneratorSVG).sidebar.exercisePickerDots
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "exercise-details",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h5", {
                                children: "Rest"
                            }),
                            isEditing ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "pg-inline-edit-overlay",
                                        onClick: onEditCancel
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "exercise-metrics pg-inline-edit-metrics",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "metric-box inline-box with-text",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "text",
                                                    value: editForm?.restDuration ? editForm.restDuration.replace(' sec', '') : '',
                                                    onChange: (e)=>{
                                                        const val = e.target.value;
                                                        if (val !== '') {
                                                            const num = Number(val);
                                                            if (isNaN(num) || num <= 0) {
                                                                (0, _reactHotToastDefault.default).error('Rest duration must be greater than 0');
                                                                return;
                                                            }
                                                            if (num > 3600) {
                                                                (0, _reactHotToastDefault.default).error('Rest duration cannot exceed 3600 sec');
                                                                return;
                                                            }
                                                        }
                                                        setEditForm?.({
                                                            ...editForm,
                                                            restDuration: val ? `${val} sec` : '0 sec'
                                                        });
                                                    },
                                                    onKeyDown: (e)=>{
                                                        if (e.key === 'Enter') {
                                                            e.preventDefault();
                                                            e.target.blur();
                                                            onEditCancel?.();
                                                        }
                                                    },
                                                    className: "pg-inline-input",
                                                    autoFocus: true
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: "sec"
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "exercise-metrics",
                                onDoubleClick: onDoubleClickMetrics,
                                style: {
                                    cursor: 'pointer'
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "metric-box",
                                    children: item.restDuration || '30 sec'
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                        menu: {
                            items: getExerciseMenu(item, sectionId)
                        },
                        trigger: [
                            'click'
                        ],
                        placement: "bottomRight",
                        classNames: {
                            root: 'action-dropdown-menu-overlay'
                        },
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "icon-btn",
                            children: (0, _programGenerator.programGeneratorSVG).exerciseAction.menu
                        })
                    })
                ]
            })
    });
};
const getSectionDuration = (exercises)=>{
    let totalSeconds = 0;
    exercises.forEach((ex)=>{
        if (ex.isRest) {
            const match = ex.restDuration?.match(/(\d+)/);
            if (match) totalSeconds += parseInt(match[1], 10);
        } else {
            const sets = ex.sets || 1;
            const setDuration = ex.metricType === 'duration' ? ex.duration || 60 : 60;
            let restBetween = 0;
            if (ex.restBetweenSets) {
                const match = ex.restBetweenSets.match(/(\d+)/);
                if (match) restBetween = parseInt(match[1], 10);
            }
            let restAfter = 0;
            if (ex.restAfterExercise) {
                const match = ex.restAfterExercise.match(/(\d+)/);
                if (match) restAfter = parseInt(match[1], 10);
            }
            totalSeconds += sets * setDuration;
            totalSeconds += Math.max(0, sets - 1) * restBetween;
            totalSeconds += restAfter;
        }
    });
    return totalSeconds > 0 ? Math.max(1, Math.round(totalSeconds / 60)) : 0;
};
const ProgramGenerated = ()=>{
    const { data: movementsData = [] } = (0, _useGetAllMovements.useGetAllMovements)();
    const [isRegenerateModalOpen, setIsRegenerateModalOpen] = (0, _react.useState)(false);
    const [isDraftSavedModalOpen, setIsDraftSavedModalOpen] = (0, _react.useState)(false);
    const [isShareModalOpen, setIsShareModalOpen] = (0, _react.useState)(false);
    const [isAssignModalOpen, setIsAssignModalOpen] = (0, _react.useState)(false);
    const [isEditModalOpen, setIsEditModalOpen] = (0, _react.useState)(false);
    const [editingExercise, setEditingExercise] = (0, _react.useState)(null);
    const [exerciseToRemove, setExerciseToRemove] = (0, _react.useState)(null);
    const [sectionToEmpty, setSectionToEmpty] = (0, _react.useState)(null);
    const [collapsedSupersets, setCollapsedSupersets] = (0, _react.useState)({});
    const [editForm, setEditForm] = (0, _react.useState)({
        sets: 1,
        metricType: 'reps',
        reps: 30,
        duration: 60,
        restBetweenSets: '0s',
        restAfterExercise: '0s',
        restDuration: '30 sec'
    });
    (0, _react.useEffect)(()=>{
        if (editingExercise) {
            const initialRest = editingExercise.ex.restAfterExercise || editingExercise.ex.restBetweenSets || '0s';
            setEditForm({
                sets: editingExercise.ex.sets || 1,
                metricType: editingExercise.ex.metricType || 'reps',
                reps: editingExercise.ex.reps || 30,
                duration: editingExercise.ex.duration || 60,
                restBetweenSets: initialRest,
                restAfterExercise: initialRest,
                restDuration: editingExercise.ex.restDuration || '30 sec'
            });
        }
    }, [
        editingExercise
    ]);
    const [isEditSupersetOpen, setIsEditSupersetOpen] = (0, _react.useState)(false);
    const [editingGroupLetter, setEditingGroupLetter] = (0, _react.useState)('A');
    const [currentWeek, setCurrentWeek] = (0, _react.useState)(1); // Default to week 1 as per example
    const [isLibraryOpen, setIsLibraryOpen] = (0, _react.useState)(typeof window !== 'undefined' ? window.innerWidth >= 1024 : true);
    const [editFocusField, setEditFocusField] = (0, _react.useState)('reps');
    const progress = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore)((state)=>state.progress);
    (0, _react.useEffect)(()=>{
        // Hide outer scroll container so react-beautiful-dnd correctly maps pointers
        // without nested scroll collision bugs, while keeping layout intact.
        const dashboardMain = document.querySelector('.dashboard-main');
        if (dashboardMain) {
            const originalOverflow = dashboardMain.style.overflow;
            dashboardMain.style.overflow = 'hidden';
            return ()=>{
                dashboardMain.style.overflow = originalOverflow;
            };
        }
    }, []);
    const { state, search } = (0, _reactRouterDom.useLocation)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const { programId: urlProgramId, workout: urlWorkout } = (0, _reactRouterDom.useParams)();
    const [rawApiResponse, setRawApiResponse] = (0, _react.useState)(null);
    const { data: fetchedProgram, isLoading: isFetchingProgram } = (0, _useGetTrainerProgramById.useGetTrainerProgramById)(urlProgramId, !state?.payload && !rawApiResponse);
    const isManually = new URLSearchParams(search).get('isManually') === 'true' || fetchedProgram?.isManually === true || fetchedProgram?.generatorType === 'manual' || fetchedProgram?.type === 'manual' || state?.isManually === true || state?.generatorType === 'manual';
    const getDraftProgressItems = (0, _react.useCallback)((stepId)=>{
        if (!stepId) return [];
        if (progress[stepId] && progress[stepId].length > 0) return progress[stepId];
        const fetchedProgress = fetchedProgram?.draft;
        if (fetchedProgress?.progress) {
            const camelKey = stepId.replace(/_([a-z])/g, (g)=>g[1].toUpperCase());
            if (fetchedProgress.progress[camelKey] && fetchedProgress.progress[camelKey].length > 0) return fetchedProgress.progress[camelKey];
            if (fetchedProgress.progress[stepId] && fetchedProgress.progress[stepId].length > 0) return fetchedProgress.progress[stepId];
        }
        return [];
    }, [
        progress,
        fetchedProgram
    ]);
    const getDraftProgressSlug = (0, _react.useCallback)((stepId)=>{
        if (!stepId) return '';
        if (progress[stepId]?.[0]?.slug) return progress[stepId][0].slug;
        const fetchedProgress = fetchedProgram?.draft;
        if (fetchedProgress?.progress) {
            const camelKey = stepId.replace(/_([a-z])/g, (g)=>g[1].toUpperCase());
            if (fetchedProgress.progress[camelKey]?.[0]?.slug) return fetchedProgress.progress[camelKey][0].slug;
            if (fetchedProgress.progress[stepId]?.[0]?.slug) return fetchedProgress.progress[stepId][0].slug;
        }
        return '';
    }, [
        progress,
        fetchedProgram
    ]);
    const getDraftProgressValue = (0, _react.useCallback)((stepId)=>{
        if (!stepId) return '';
        if (progress[stepId]?.[0]?.value) return progress[stepId][0].value;
        const fetchedProgress = fetchedProgram?.draft;
        if (fetchedProgress?.progress) {
            const camelKey = stepId.replace(/_([a-z])/g, (g)=>g[1].toUpperCase());
            if (fetchedProgress.progress[camelKey]?.[0]?.value) return fetchedProgress.progress[camelKey][0].value;
            if (fetchedProgress.progress[stepId]?.[0]?.value) return fetchedProgress.progress[stepId][0].value;
        }
        return '';
    }, [
        progress,
        fetchedProgram
    ]);
    const getValue = (stepId)=>progress[stepId]?.[0]?.value || '';
    const getArrayValue = (stepId)=>progress[stepId] || [];
    const clientNameFromProgress = getValue((0, _types.ProgramStepId).ClientName) || '';
    const gender = getValue((0, _types.ProgramStepId).ClientBodyProfile) || 'Male';
    const durationRaw = fetchedProgram?.duration || getDraftProgressValue((0, _types.ProgramStepId).ProgramDuration) || getValue((0, _types.ProgramStepId).ProgramDuration) || '12';
    const duration = parseInt(String(durationRaw).replace(/\D/g, ''), 10) || 12;
    const daysArray = getDraftProgressItems((0, _types.ProgramStepId).HowOftenTrain);
    const existingDaysPerWeek = fetchedProgram?.datetimeList && Array.isArray(fetchedProgram.datetimeList) && duration ? Math.ceil(fetchedProgram.datetimeList.length / duration) : 0;
    const howOftenTrain = daysArray.length > 0 ? daysArray.length : existingDaysPerWeek > 0 ? existingDaysPerWeek : 4;
    const howOftenTrainReminder = getDraftProgressValue((0, _types.ProgramStepId).HowOftenTrainReminder) || getDraftProgressSlug((0, _types.ProgramStepId).HowOftenTrainReminder) || '';
    const mapFitnessLevel = (level)=>{
        switch(level.toLowerCase()){
            case 'beginner':
                return 'Beginner';
            case 'early-intermediate':
                return 'Early Intermediate';
            case 'intermediate':
                return 'Intermediate';
            case 'advanced':
                return 'Advanced';
            case 'athlete':
                return 'Athlete';
            default:
                return level ? level.charAt(0).toUpperCase() + level.slice(1) : 'Beginner';
        }
    };
    const experienceLevelRaw = getDraftProgressValue((0, _types.ProgramStepId).FitnessLevel) || getValue((0, _types.ProgramStepId).FitnessLevel) || 'Intermediate';
    const experienceLevel = mapFitnessLevel(experienceLevelRaw);
    const levels = [
        'Beginner',
        'Early Intermediate',
        'Intermediate',
        'Advanced',
        'Athlete'
    ];
    const levelIndex = levels.findIndex((l)=>l === experienceLevel);
    const dotCount = levelIndex !== -1 ? levelIndex + 1 : 3;
    const programGoal = (getDraftProgressValue((0, _types.ProgramStepId).TrainingGoal) || getValue((0, _types.ProgramStepId).TrainingGoal) || 'Build Muscle').replace(/-/g, ' ');
    const painInjuriesItems = getDraftProgressItems((0, _types.ProgramStepId).InjuriesParts).length > 0 ? getDraftProgressItems((0, _types.ProgramStepId).InjuriesParts) : getArrayValue((0, _types.ProgramStepId).InjuriesParts);
    const painInjuriesRaw = painInjuriesItems.map((i)=>i.value);
    const painInjuries = painInjuriesRaw.length > 0 ? painInjuriesRaw.join(', ') : 'None';
    const getDisplayTitle = (slug)=>{
        return (slug || '').split('-').map((word)=>word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    };
    const mapEnergyLevel = (level)=>{
        const mapping = {
            'i-can-go-all-day': 'High (can go all day)',
            'i-crash-by-mid-afternoon': 'Mid (crash by mid-afternoon)',
            'i-struggle-to-get-out-of-bed': 'Low (struggle to get out of bed)',
            'i-have-steady-energy': 'Steady (have steady energy)'
        };
        return mapping[level] || 'Steady';
    };
    const getInitials = (name)=>{
        const parts = name.split(' ');
        if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
        return name.slice(0, 2).toUpperCase();
    };
    const toTitleCase = (str)=>str.replace(/\w\S*/g, (txt)=>txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
    const handlePrevWeek = ()=>{
        if (currentWeek > 1) setCurrentWeek(currentWeek - 1);
    };
    const handleNextWeek = ()=>{
        if (currentWeek < duration) setCurrentWeek(currentWeek + 1);
    };
    const weekItems = [
        ...Array(duration)
    ].map((_, i)=>{
        const weekNum = i + 1;
        return {
            key: weekNum.toString(),
            label: `Week ${weekNum}`,
            onClick: ()=>setCurrentWeek(weekNum),
            className: currentWeek === weekNum ? 'active-week-item' : ''
        };
    });
    // Drag and Drop State
    const [programData, setProgramData] = (0, _react.useState)({});
    const [currentWorkout, setCurrentWorkout] = (0, _react.useState)(1);
    // Only use wizard progress store name when navigating from the AI wizard (state.payload present)
    const wizardClientName = state?.payload ? clientNameFromProgress : '';
    const { mutateAsync: mockMutateAsync } = (0, _useMockGenerateWorkoutProgramCoachProd.useMockGenerateWorkoutProgramCoachProd)();
    const { mutateAsync: realMutateAsync } = (0, _useGenerateWorkoutProgramCoachProd.useGenerateWorkoutProgramCoachProd)();
    const mutateAsync = USE_MOCK ? mockMutateAsync : realMutateAsync;
    const { mutateAsync: saveProgram, isPending: isSaving } = (0, _useSaveClientProgram.useSaveClientProgram)();
    const { mutate: assignToClient, isPending: isAssigningToClient } = (0, _useSendProgramPlanToClient.useSendProgramPlanToClient)();
    const [hasSentToClient, setHasSentToClient] = (0, _react.useState)(false);
    const [isGeneratingProgram, setIsGeneratingProgram] = (0, _react.useState)(false);
    const isProgramLoaded = Boolean(state?.payload || rawApiResponse || fetchedProgram);
    const showHeaderStats = !isManually && isProgramLoaded && !isFetchingProgram && !isGeneratingProgram;
    const showRegenerateBtn = !isManually && isProgramLoaded && !isFetchingProgram;
    (0, _react.useEffect)(()=>{
        if (fetchedProgram?.isSentToClient) setHasSentToClient(true);
    }, [
        fetchedProgram?.isSentToClient
    ]);
    const [savedProgramId, setSavedProgramId] = (0, _react.useState)(urlProgramId || null);
    const fetchPromise = (0, _react.useRef)(null);
    const trainingGoalSlug = getDraftProgressSlug((0, _types.ProgramStepId).TrainingGoal);
    const getApproachStepId = (slug)=>{
        switch(slug){
            case 'increase-strength':
                return (0, _types.ProgramStepId).IncreaseStrengthApproach;
            case 'build-muscle':
                return (0, _types.ProgramStepId).BuildMuscleApproach;
            case 'weight-loss':
                return (0, _types.ProgramStepId).WeightLossApproach;
            case 'endurance':
                return (0, _types.ProgramStepId).EnduranceApproach;
            case 'mobility':
                return (0, _types.ProgramStepId).MobilityApproach;
            case 'performance':
                return (0, _types.ProgramStepId).PerformanceApproach;
            case 'general-fitness':
                return (0, _types.ProgramStepId).GeneralFitnessApproach;
            case 'rehabilitation':
                return (0, _types.ProgramStepId).RehabilitationApproach;
            case 'injury-prevention':
                return (0, _types.ProgramStepId).InjuryPreventionApproach;
            default:
                return undefined;
        }
    };
    const goalApproach = getDraftProgressValue(getApproachStepId(trainingGoalSlug));
    const trainingGoal = getDraftProgressValue((0, _types.ProgramStepId).TrainingGoal);
    const energyLevel = getDraftProgressValue((0, _types.ProgramStepId).EnergyLevel);
    const workoutDuration = getDraftProgressValue((0, _types.ProgramStepId).WorkoutDuration) || '';
    const pgMainRef = (0, _react.useRef)(null);
    const draftProgramId = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore)((s)=>s.programId);
    const draftClientId = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore)((s)=>s.clientId);
    const isViewingDraft = urlProgramId && draftProgramId && urlProgramId === draftProgramId;
    const activeClientId = state?.payload?.clientId || state?.clientId || (isViewingDraft ? draftClientId : null) || fetchedProgram?.clientId;
    // Fetch the specific client by UID from the program plan's clientId
    const { data: clientData } = (0, _useGetTrainerClients.useGetTrainerClientById)(activeClientId || undefined);
    const fetchedClientName = (()=>{
        const match = clientData?.clients?.[0];
        return match ? `${match.name} ${match.surname}` : '';
    })();
    // Priority: fetched client name (from program plan clientId) → wizard progress name → navigation state clientName → 'Not Assigned'
    const clientName = fetchedClientName || wizardClientName || state?.clientName || 'Not Assigned';
    const getWorkoutDayOfWeek = (0, _react.useCallback)((wNum)=>{
        // 1. Check raw datetimeList from API/fetched program
        const rawDatetimeList = fetchedProgram?.datetimeList || fetchedProgram?.result?.program?.data?.datetimeList || rawApiResponse?.program?.data?.datetimeList || rawApiResponse?.result?.program?.data?.datetimeList || [];
        if (Array.isArray(rawDatetimeList) && rawDatetimeList.length > 0) {
            const sortedDays = [
                ...rawDatetimeList
            ].sort((a, b)=>new Date(a.ymd).getTime() - new Date(b.ymd).getTime());
            const daysPerWeek = Math.ceil(sortedDays.length / duration) || howOftenTrain || 1;
            const targetIndex = (currentWeek - 1) * daysPerWeek + (wNum - 1);
            const dayData = sortedDays[targetIndex];
            if (dayData) {
                if (dayData.weekday) {
                    const key = dayData.weekday.toLowerCase().trim();
                    if (DAY_LABELS[key]) return DAY_LABELS[key];
                }
                if (dayData.ymd) {
                    const parts = dayData.ymd.split('-').map(Number);
                    if (parts.length === 3) {
                        const d = new Date(parts[0], parts[1] - 1, parts[2]);
                        const full = d.toLocaleDateString('en-US', {
                            weekday: 'long'
                        });
                        const short = d.toLocaleDateString('en-US', {
                            weekday: 'short'
                        });
                        if (full && short) return {
                            full,
                            short
                        };
                    }
                }
            }
        }
        // 2. Check daysArray (draft progress) or selectedDays
        const selectedDayItem = daysArray?.[wNum - 1] || fetchedProgram?.selectedDays?.[wNum - 1] || fetchedProgram?.selected_days?.[wNum - 1];
        if (selectedDayItem) {
            const itemObj = selectedDayItem;
            const val = (typeof selectedDayItem === 'string' ? selectedDayItem : itemObj?.slug || itemObj?.value || itemObj?.title || itemObj?.label || '').toLowerCase().trim();
            if (DAY_LABELS[val]) return DAY_LABELS[val];
        }
        // 3. Fallback based on howOftenTrain offset mapping
        const offsets = DEFAULT_OFFSETS_BY_COUNT[howOftenTrain] || DEFAULT_OFFSETS_BY_COUNT[4];
        const offset = offsets?.[wNum - 1] ?? (wNum - 1) % 7;
        return ORDERED_DAYS[offset % 7] || ORDERED_DAYS[0];
    }, [
        fetchedProgram,
        rawApiResponse,
        duration,
        howOftenTrain,
        currentWeek,
        daysArray
    ]);
    const showWorkoutSavedToast = (0, _react.useCallback)(()=>{
        (0, _antd.notification).open({
            title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "custom-toast-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "toast-left",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "toast-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleLineCheckSvg.ReactComponent), {
                                        className: "toast-icon"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "toast-text",
                                        children: "Your workout has been saved"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "toast-progress-track",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "toast-progress-bar"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "toast-right",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "toast-link",
                            onClick: ()=>navigate('/onboarding-trainer/dashboard/programs'),
                            children: [
                                "View in Library ",
                                (0, _programGenerator.programGeneratorSVG).header.viewInLibrary
                            ]
                        })
                    })
                ]
            }),
            placement: 'topRight',
            duration: 5,
            className: 'custom-workout-toast',
            closeIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
        });
    }, [
        navigate
    ]);
    const handleSaveProgram = async ()=>{
        if (!rawApiResponse || !activeClientId) return;
        const finalPlan = (0, _transformProgramStateToPlan.transformProgramStateToPlan)(programData, rawApiResponse, {
            duration,
            daysPerWeek: howOftenTrain,
            selectedDays: daysArray.map((d)=>d.slug || d.value),
            reminderTime: howOftenTrainReminder || getDraftProgressSlug((0, _types.ProgramStepId).HowOftenTrainReminder),
            isManually
        });
        if (!finalPlan) return;
        try {
            const clientId = activeClientId;
            const currentUser = (0, _sessionStore.sessionStore).getState().currentUser;
            const trainerId = currentUser?.uid;
            const payload = {
                clientId,
                trainerId,
                plan: finalPlan
            };
            const targetProgramId = savedProgramId || urlProgramId || draftProgramId;
            if (targetProgramId) payload.programId = targetProgramId;
            const response = await saveProgram(payload);
            const resolvedId = response?.programId || savedProgramId || urlProgramId || draftProgramId;
            if (resolvedId) {
                setSavedProgramId(resolvedId);
                queryClient.setQueryData([
                    'trainer-program-plan',
                    trainerId,
                    resolvedId
                ], {
                    ...finalPlan,
                    id: resolvedId,
                    docPath: `trainer_app_users/${trainerId}/programme_plan/${resolvedId}`
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        'trainer-program-plans'
                    ]
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        'trainer-client-program-tab'
                    ]
                });
            }
            setIsDraftSavedModalOpen(true);
        } catch (error) {
            console.error('Failed to save program', error);
            (0, _reactHotToastDefault.default).error('Failed to save program');
        }
    };
    const handleAutoSave = (0, _react.useCallback)(async (res, newProgramData, clientIdToSave)=>{
        const finalPlan = (0, _transformProgramStateToPlan.transformProgramStateToPlan)(newProgramData, res, {
            duration,
            daysPerWeek: howOftenTrain,
            selectedDays: daysArray.map((d)=>d.slug || d.value),
            reminderTime: howOftenTrainReminder || getDraftProgressSlug((0, _types.ProgramStepId).HowOftenTrainReminder),
            isManually
        });
        if (!finalPlan) return null;
        try {
            const currentUser = (0, _sessionStore.sessionStore).getState().currentUser;
            const trainerId = currentUser?.uid;
            const targetClientId = clientIdToSave || state?.payload?.clientId || state?.clientId || (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().clientId || fetchedProgram?.clientId;
            if (!targetClientId || !trainerId) return null;
            const payload = {
                clientId: targetClientId,
                trainerId,
                plan: finalPlan
            };
            const draftProgramId = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().programId;
            const targetProgramId = urlProgramId || draftProgramId;
            if (targetProgramId) payload.programId = targetProgramId;
            const response = await saveProgram(payload);
            const resolvedId = response?.programId || targetProgramId;
            if (resolvedId) {
                setSavedProgramId(resolvedId);
                queryClient.setQueryData([
                    'trainer-program-plan',
                    trainerId,
                    resolvedId
                ], {
                    ...finalPlan,
                    id: resolvedId,
                    docPath: `trainer_app_users/${trainerId}/programme_plan/${resolvedId}`
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        'trainer-program-plans'
                    ]
                });
                queryClient.invalidateQueries({
                    queryKey: [
                        'trainer-client-program-tab'
                    ]
                });
            }
            return resolvedId;
        } catch (error) {
            console.error('Failed to auto-save program', error);
            return null;
        }
    }, [
        saveProgram,
        state?.payload?.clientId,
        state?.clientId,
        urlProgramId,
        duration,
        howOftenTrain,
        daysArray,
        howOftenTrainReminder,
        getDraftProgressSlug,
        isManually,
        fetchedProgram,
        queryClient
    ]);
    const generateProgram = (isRegenerating = false)=>{
        let payload = state?.payload;
        if (!payload && isRegenerating) {
            const storedProgramId = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().programId;
            if (storedProgramId === urlProgramId) payload = (0, _buildPayload.buildPayloadFromProgress)(progress, clientId);
            else if (fetchedProgram?.draft?.progress) payload = (0, _buildPayload.buildPayloadFromProgress)(fetchedProgram.draft.progress, fetchedProgram.clientId);
        }
        if (!payload) {
            setIsRegenerateModalOpen(false);
            return;
        }
        setIsGeneratingProgram(true);
        // Clear the existing data if we are regenerating
        if (isRegenerating) {
            setProgramData({});
            setSavedProgramId(null);
        }
        fetchPromise.current = mutateAsync(payload);
        fetchPromise.current.then(async (res)=>{
            if (!res) {
                setIsGeneratingProgram(false);
                (0, _reactHotToastDefault.default).error('Program generation failed. Please try again.');
                return;
            }
            setRawApiResponse(res);
            const newProgramData = transformApiToProgramData(res, howOftenTrain);
            setProgramData(newProgramData);
            setIsGeneratingProgram(false);
            const savedId = await handleAutoSave(res, newProgramData);
            if (isRegenerating) setIsRegenerateModalOpen(false);
            const meta = res?.metadata || res?.result?.metadata;
            const generatedId = savedId || meta?.programId || meta?.program_id || res?.program?.id || urlProgramId;
            if (generatedId) {
                setSavedProgramId(generatedId);
                navigate(`/onboarding-trainer/dashboard/program-generated/${generatedId}`, {
                    replace: true,
                    state: {}
                });
            }
        }).catch(()=>{
            setIsGeneratingProgram(false);
            (0, _reactHotToastDefault.default).error('Program generation failed. Please try again.');
        });
    };
    (0, _react.useEffect)(()=>{
        let isMounted = true;
        if (state?.payload) {
            if (!fetchPromise.current) {
                setIsGeneratingProgram(true);
                fetchPromise.current = mutateAsync(state.payload);
            } else // If it's already fetching from a previous mount, just set loading to true
            setIsGeneratingProgram(true);
            fetchPromise.current.then(async (res)=>{
                if (!res) {
                    if (isMounted) {
                        setIsGeneratingProgram(false);
                        (0, _reactHotToastDefault.default).error('Program generation failed. Please try again.');
                    }
                    return;
                }
                if (isMounted) {
                    setRawApiResponse(res);
                    const newProgramData = transformApiToProgramData(res, howOftenTrain);
                    setProgramData(newProgramData);
                    setIsGeneratingProgram(false);
                    const savedId = await handleAutoSave(res, newProgramData);
                    const meta = res?.metadata || res?.result?.metadata;
                    const generatedId = savedId || meta?.programId || meta?.program_id || res?.program?.id || urlProgramId;
                    if (generatedId && isMounted) {
                        setSavedProgramId(generatedId);
                        navigate(`/onboarding-trainer/dashboard/program-generated/${generatedId}`, {
                            replace: true,
                            state: {}
                        });
                    }
                }
            }).catch(()=>{
                if (isMounted) {
                    setIsGeneratingProgram(false);
                    (0, _reactHotToastDefault.default).error('Program generation failed. Please try again.');
                }
            });
        }
        return ()=>{
            isMounted = false;
        };
    }, [
        state?.payload,
        mutateAsync,
        howOftenTrain,
        navigate,
        handleAutoSave,
        urlProgramId
    ]);
    const { clientId } = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore)();
    (0, _react.useEffect)(()=>{
        if (!state?.payload && fetchedProgram && !isGeneratingProgram) {
            // We loaded the program from the API using URL id
            const transformedData = transformFinalPlanToProgramData(fetchedProgram, howOftenTrain);
            const hasWorkouts = Object.keys(transformedData).length > 0;
            if (!hasWorkouts) {
                // The program is empty (draft)
                const storedProgramId = (0, _programGeneratorProgressStore.useProgramGeneratorProgressStore).getState().programId;
                if (storedProgramId === urlProgramId) {
                    // This draft matches the current wizard session! We should auto-generate it!
                    const payload = (0, _buildPayload.buildPayloadFromProgress)(progress, clientId);
                    if (payload) {
                        if (!fetchPromise.current) {
                            setIsGeneratingProgram(true);
                            fetchPromise.current = mutateAsync(payload);
                            fetchPromise.current.then(async (res)=>{
                                if (!res) {
                                    setIsGeneratingProgram(false);
                                    (0, _reactHotToastDefault.default).error('Program generation failed. Please try again.');
                                    return;
                                }
                                setRawApiResponse(res);
                                const newProgramData = transformApiToProgramData(res, howOftenTrain);
                                setProgramData(newProgramData);
                                setIsGeneratingProgram(false);
                                await handleAutoSave(res, newProgramData, clientId || undefined);
                            }).catch(()=>{
                                setIsGeneratingProgram(false);
                                (0, _reactHotToastDefault.default).error('Program generation failed. Please try again.');
                            });
                        }
                        return;
                    }
                }
            }
            setProgramData(transformedData);
            // Reconstruct rawApiResponse partially if needed for save/update logic later
            // The current UI relies on rawApiResponse for the transformer.
            setRawApiResponse({
                result: {
                    program: {
                        data: {
                            ...fetchedProgram,
                            duration: fetchedProgram?.duration || String(duration),
                            isAIGenerate: isManually ? false : fetchedProgram?.isAIGenerate ?? true,
                            isManually,
                            programmeName: fetchedProgram?.programmeName && fetchedProgram?.programmeName !== 'Unnamed' ? fetchedProgram.programmeName : progress?.program_name?.[0]?.value || fetchedProgram?.draft?.progress?.program_name?.[0]?.value || 'Unnamed'
                        }
                    }
                }
            });
        }
    }, [
        fetchedProgram,
        state?.payload,
        howOftenTrain,
        isGeneratingProgram,
        urlProgramId,
        progress,
        clientId,
        mutateAsync,
        handleAutoSave,
        isManually,
        duration,
        navigate
    ]);
    const sections = programData[currentWeek]?.[currentWorkout] || {
        warmup: [],
        main: [],
        cooldown: []
    };
    const updateSection = (sectionId, updater)=>{
        setProgramData((prevData)=>{
            const weekData = prevData[currentWeek] || {};
            const workoutData = weekData[currentWorkout] || {
                warmup: [],
                main: [],
                cooldown: []
            };
            const prevSection = workoutData[sectionId] || [];
            const newSection = updater(prevSection);
            return {
                ...prevData,
                [currentWeek]: {
                    ...weekData,
                    [currentWorkout]: {
                        ...workoutData,
                        [sectionId]: newSection
                    }
                }
            };
        });
    };
    const [copiedContent, setCopiedContent] = (0, _react.useState)(null);
    const [generatingExerciseId] = (0, _react.useState)(null);
    const handleAddExerciseClick = ()=>{
        if (!isLibraryOpen) setIsLibraryOpen(true);
        setTimeout(()=>{
            const exerciseListEl = document.querySelector('.exercise-list');
            if (exerciseListEl) {
                exerciseListEl.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                exerciseListEl.classList.add('highlight-exercise-list');
                setTimeout(()=>{
                    exerciseListEl.classList.remove('highlight-exercise-list');
                }, 7000);
            }
        }, 300);
    };
    const handleSaveExercise = ()=>{
        if (editingExercise) {
            if (!editingExercise.ex.isRest && (editForm.sets < 1 || editForm.metricType === 'reps' && editForm.reps < 1 || editForm.metricType === 'duration' && editForm.duration < 1)) {
                (0, _reactHotToastDefault.default).error('Sets and Reps/Duration must be greater than 0');
                return;
            }
            updateSection(editingExercise.sectionId, (prev)=>prev.map((e)=>e.id === editingExercise.ex.id ? {
                        ...e,
                        ...editForm
                    } : e));
        }
        setIsEditModalOpen(false);
    };
    const getExerciseMenu = (ex, sectionId)=>{
        if (ex.isRest) return [
            {
                key: 'duplicate',
                label: 'Duplicate',
                icon: (0, _programGenerator.programGeneratorSVG).exerciseAction.duplicate,
                onClick: ()=>{
                    updateSection(sectionId, (prev)=>{
                        const index = prev.findIndex((e)=>e.id === ex.id);
                        if (index === -1) return prev;
                        const newEx = {
                            ...ex,
                            id: `rest-${Date.now()}-${Math.random()}`
                        };
                        const newSectionExercises = [
                            ...prev
                        ];
                        newSectionExercises.splice(index + 1, 0, newEx);
                        return newSectionExercises;
                    });
                }
            },
            {
                key: 'remove',
                label: 'Remove',
                icon: (0, _programGenerator.programGeneratorSVG).exerciseAction.remove,
                onClick: ()=>{
                    setExerciseToRemove({
                        sectionId,
                        exId: ex.id
                    });
                }
            }
        ];
        return [
            {
                key: 'duplicate',
                label: 'Duplicate',
                icon: (0, _programGenerator.programGeneratorSVG).exerciseAction.duplicate,
                onClick: ()=>{
                    updateSection(sectionId, (prev)=>{
                        const index = prev.findIndex((e)=>e.id === ex.id);
                        if (index === -1) return prev;
                        const newEx = {
                            ...ex,
                            id: `${ex.name}-${Date.now()}-${Math.random()}`
                        };
                        const newSectionExercises = [
                            ...prev
                        ];
                        newSectionExercises.splice(index + 1, 0, newEx);
                        return newSectionExercises;
                    });
                }
            },
            // {
            //   key: 'replace',
            //   label: 'Replace exercise',
            //   icon: programGeneratorSVG.exerciseAction.replaceExercise,
            //   onClick: () => {
            //     setGeneratingExerciseId(ex.id);
            //     setTimeout(() => {
            //       setGeneratingExerciseId(null);
            //     }, 10000);
            //   },
            // },
            // {
            //   key: 'superset',
            //   label: ex.supersetId ? 'Convert to single exercise' : 'Convert to superset',
            //   icon: programGeneratorSVG.exerciseAction.convertToSuperset,
            //   onClick: () => {
            //     updateSection(sectionId, (prev) => {
            //       const index = prev.findIndex((e) => e.id === ex.id);
            //       if (index === -1) return prev;
            //       const newSectionExercises = [...prev];
            //       if (ex.supersetId) {
            //         newSectionExercises[index] = { ...ex, supersetId: undefined };
            //       } else {
            //         const newSupersetId = `superset-${Date.now()}`;
            //         newSectionExercises[index] = { ...ex, supersetId: newSupersetId };
            //         newSectionExercises.splice(index + 1, 0, {
            //           id: `rest-${Date.now()}`,
            //           name: 'Rest',
            //           tags: [],
            //           isRest: true,
            //           restDuration: '30 sec',
            //           supersetId: newSupersetId,
            //         });
            //       }
            //       return newSectionExercises;
            //     });
            //   },
            // },
            {
                key: 'remove',
                label: 'Remove',
                icon: (0, _programGenerator.programGeneratorSVG).exerciseAction.remove,
                onClick: ()=>{
                    setExerciseToRemove({
                        sectionId,
                        exId: ex.id
                    });
                }
            }
        ];
    };
    const getSectionMenu = (sectionId, exercises)=>{
        const isEmpty = exercises.length === 0;
        const canPaste = copiedContent !== null && copiedContent.length > 0;
        return [
            {
                key: 'copy',
                label: 'Copy content',
                icon: (0, _programGenerator.programGeneratorSVG).exerciseAction.duplicate,
                disabled: isEmpty,
                onClick: ()=>setCopiedContent(exercises)
            },
            {
                key: 'paste',
                label: 'Paste content',
                icon: (0, _programGenerator.programGeneratorSVG).exerciseAction.pasteContent,
                disabled: !canPaste,
                onClick: ()=>{
                    if (copiedContent) updateSection(sectionId, (prev)=>[
                            ...prev,
                            ...copiedContent.map((ex)=>({
                                    ...ex,
                                    id: `${ex.name}-${Date.now()}-${Math.random()}`
                                }))
                        ]);
                }
            },
            // {
            //   key: 'replace',
            //   label: 'Replace exercises',
            //   icon: programGeneratorSVG.exerciseAction.replaceExercise,
            // },
            // {
            //   key: 'superset',
            //   label: 'Convert to superset',
            //   icon: programGeneratorSVG.exerciseAction.convertToSuperset,
            //   disabled: exercises.every((ex) => ex.supersetId),
            //   onClick: () => {
            //     updateSection(sectionId, (prev) => {
            //       const newSupersetId = `superset-${Date.now()}`;
            //       const newExercises = prev.map((ex) =>
            //         ex.supersetId ? ex : { ...ex, supersetId: newSupersetId },
            //       );
            //       // Auto add a rest card at the very end if we converted anything
            //       const hasConverted = prev.some((ex) => !ex.supersetId);
            //       if (hasConverted) {
            //         newExercises.push({
            //           id: `rest-${Date.now()}`,
            //           name: 'Rest',
            //           tags: [],
            //           isRest: true,
            //           restDuration: '30 sec',
            //           supersetId: newSupersetId,
            //         });
            //       }
            //       return newExercises;
            //     });
            //   },
            // },
            {
                key: 'empty',
                label: 'Empty content',
                icon: (0, _programGenerator.programGeneratorSVG).exerciseAction.remove,
                disabled: isEmpty,
                onClick: ()=>{
                    setSectionToEmpty({
                        sectionId
                    });
                }
            }
        ];
    };
    const getFlatIndexForDrop = (arr, sectionId, droppableId, localIndex)=>{
        if (!arr) return -1;
        let count = 0;
        let lastSeenGlobalIndex = -1;
        for(let i = 0; i < arr.length; i++){
            const item = arr[i];
            let itemDroppableId = sectionId;
            if (item.supersetId) itemDroppableId = `superset-drop-${sectionId}-${item.supersetId}`;
            if (itemDroppableId === droppableId) {
                if (count === localIndex) return i;
                count++;
                lastSeenGlobalIndex = i;
            }
        }
        if (count === localIndex) {
            if (lastSeenGlobalIndex !== -1) return lastSeenGlobalIndex + 1;
            else return arr.length;
        }
        return arr.length;
    };
    const handleDragStart = (_start)=>{
    // Keep sidebar layout stable during drag to preserve droppable coordinate precision
    };
    const handleDragEnd = (result)=>{
        console.log('calling DRAG END', result);
        if (!result.destination) return;
        const { source, destination, draggableId } = result;
        if (source.droppableId === destination.droppableId && source.index === destination.index) return;
        const parseDroppableId = (dId)=>{
            if (dId === 'library') return {
                sectionId: 'library',
                supersetId: undefined
            };
            if (dId.startsWith('superset-drop-')) {
                const parts = dId.replace('superset-drop-', '').split('-');
                return {
                    sectionId: parts[0],
                    supersetId: parts.slice(1).join('-')
                };
            }
            return {
                sectionId: dId,
                supersetId: undefined
            };
        };
        const src = parseDroppableId(source.droppableId);
        const dest = parseDroppableId(destination.droppableId);
        // 1. Dropping from Library
        if (src.sectionId === 'library') {
            const moveId = draggableId.replace('lib-', '');
            const isRest = moveId === 'rest-library-item';
            const movement = movementsData.find((m)=>m.id === moveId);
            const exerciseName = isRest ? 'Rest' : movement?.en_display_name || 'Exercise';
            const tags = [];
            if (!isRest && movement) {
                if (movement.move_types) movement.move_types.forEach((t)=>tags.push({
                        label: t,
                        type: 'blue'
                    }));
                if (movement.tags) movement.tags.forEach((t)=>tags.push({
                        label: t,
                        type: 'purple'
                    }));
            } else if (isRest) tags.push({
                label: 'Rest',
                type: 'yellow'
            });
            const tagLabels = tags.map((t)=>t.label.toLowerCase());
            const expectedTag = dest.sectionId === 'cooldown' ? 'cooldown' : dest.sectionId === 'warmup' ? 'warmup' : 'main';
            if (!isRest && !tagLabels.includes(expectedTag)) {
                const typeTags = tags.filter((t)=>t.type !== 'yellow').map((t)=>t.label);
                const sectionDisplay = expectedTag.charAt(0).toUpperCase() + expectedTag.slice(1);
                (0, _reactHotToastDefault.default).error(`${exerciseName} is ideally for ${typeTags.join('/')}, but I've placed it in ${sectionDisplay} for you.`, {
                    style: {
                        marginTop: '10vh'
                    }
                });
            }
            const newExercise = {
                id: `${exerciseName}-${Date.now()}`,
                name: exerciseName,
                tags: tags,
                image_male_url: isRest ? '' : movement?.image_male_url,
                image_female_url: isRest ? '' : movement?.image_female_url,
                isRest: isRest,
                restDuration: isRest ? '30 sec' : undefined,
                supersetId: dest.supersetId
            };
            updateSection(dest.sectionId, (prev)=>{
                const targetGlobalIndex = getFlatIndexForDrop(prev, dest.sectionId, destination.droppableId, destination.index);
                const newArr = [
                    ...prev
                ];
                if (targetGlobalIndex >= 0 && targetGlobalIndex <= newArr.length) newArr.splice(targetGlobalIndex, 0, newExercise);
                else newArr.push(newExercise);
                return newArr;
            });
            if (window.innerWidth < 1024) setIsLibraryOpen(false);
            return;
        }
        // 2. Reordering within same or different section
        if (src.sectionId === dest.sectionId) updateSection(src.sectionId, (prev)=>{
            const sourceGlobalIndex = getFlatIndexForDrop(prev, src.sectionId, source.droppableId, source.index);
            let destGlobalIndex = getFlatIndexForDrop(prev, dest.sectionId, destination.droppableId, destination.index);
            // Safety checks to prevent crashes if indices are invalid
            if (sourceGlobalIndex === -1 || sourceGlobalIndex >= prev.length) return prev;
            if (destGlobalIndex === -1) destGlobalIndex = Math.min(destination.index, prev.length - 1);
            const newArr = [
                ...prev
            ];
            const [movedItem] = newArr.splice(sourceGlobalIndex, 1);
            if (!movedItem) return prev; // Extra safety
            movedItem.supersetId = dest.supersetId;
            // If dragging across different droppables (e.g. from main list into a superset),
            // we must manually subtract 1 from destGlobalIndex if the source item was removed from
            // a preceding global position, because the library's destination.index only accounts
            // for the local shift within the isolated destination droppable.
            if (source.droppableId !== destination.droppableId && sourceGlobalIndex < destGlobalIndex) destGlobalIndex -= 1;
            newArr.splice(destGlobalIndex, 0, movedItem);
            return newArr;
        });
        else {
            // Prevent moving between different sections
            (0, _reactHotToastDefault.default).error('Exercises cannot be moved between Warm Up, Main Movements, and Cool Downs.');
            return;
        }
    };
    const renderSectionExercises = (exercises, sectionId)=>{
        if (exercises.length === 0) return renderEmptyState('Drag exercises here');
        const elements = [];
        let i = 0;
        let supersetCount = 0;
        let droppableIndex = 0;
        while(i < exercises.length){
            const ex = exercises[i];
            if (ex.supersetId) {
                const startIndex = i;
                const group = [];
                const currentSupersetId = ex.supersetId;
                while(i < exercises.length && exercises[i].supersetId === currentSupersetId){
                    group.push(exercises[i]);
                    i++;
                }
                const groupLetter = String.fromCharCode(65 + supersetCount);
                supersetCount++;
                elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "superset-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "superset-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "superset-title",
                                    children: [
                                        "SUPERSET ",
                                        groupLetter,
                                        " \xa0\xa0",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            children: [
                                                "3 rounds \u2022 ",
                                                group.filter((ex)=>!ex.isRest).length,
                                                " exercises \u2022",
                                                ' ',
                                                getSectionDuration(group) * 3,
                                                " min"
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "superset-actions",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: `collapse-icon ${collapsedSupersets[currentSupersetId] ? 'collapsed' : ''}`,
                                            onClick: ()=>setCollapsedSupersets((prev)=>({
                                                        ...prev,
                                                        [currentSupersetId]: !prev[currentSupersetId]
                                                    })),
                                            children: (0, _programGenerator.programGeneratorSVG).weekProgram.weekDropdownArrow
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                            menu: {
                                                items: getSectionMenu(sectionId, group)
                                            },
                                            trigger: [
                                                'click'
                                            ],
                                            placement: "bottomRight",
                                            classNames: {
                                                root: 'action-dropdown-menu-overlay'
                                            },
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "icon-btn",
                                                children: (0, _programGenerator.programGeneratorSVG).exerciseAction.menu
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)(DroppableSuperset, {
                            id: `superset-drop-${sectionId}-${currentSupersetId}`,
                            className: collapsedSupersets[currentSupersetId] ? 'collapsed' : '',
                            children: [
                                (()=>{
                                    let exerciseIndex = 0;
                                    return group.map((gEx, _gIdx)=>{
                                        if (gEx.isRest) return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableRestCard, {
                                            item: gEx,
                                            index: _gIdx,
                                            sectionId: sectionId,
                                            getExerciseMenu: getExerciseMenu,
                                            onDoubleClickMetrics: ()=>{
                                                setEditingExercise({
                                                    ex: gEx,
                                                    sectionId
                                                });
                                                setIsEditModalOpen(true);
                                            },
                                            isEditing: isEditModalOpen && editingExercise?.ex.id === gEx.id && editingExercise?.sectionId === sectionId,
                                            editForm: editForm,
                                            setEditForm: setEditForm,
                                            onEditCancel: ()=>{
                                                handleSaveExercise();
                                                setIsEditModalOpen(false);
                                            }
                                        }, gEx.id);
                                        exerciseIndex++;
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableExerciseCard, {
                                            ex: gEx,
                                            index: _gIdx,
                                            sectionId: sectionId,
                                            gender: gender,
                                            getExerciseMenu: getExerciseMenu,
                                            isGenerating: generatingExerciseId === gEx.id,
                                            supersetLabel: `${groupLetter}${exerciseIndex}`,
                                            onDoubleClickMetrics: ()=>{
                                                setEditingGroupLetter(groupLetter);
                                                setIsEditSupersetOpen(true);
                                            },
                                            isEditing: isEditModalOpen && editingExercise?.ex.id === gEx.id && editingExercise?.sectionId === sectionId,
                                            focusField: editFocusField,
                                            editForm: editForm,
                                            setEditForm: setEditForm,
                                            onEditCancel: ()=>{
                                                handleSaveExercise();
                                                setIsEditModalOpen(false);
                                            }
                                        }, gEx.id);
                                    });
                                })(),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "add-exercise-btn",
                                    onClick: handleAddExerciseClick,
                                    children: "+ Add exercise"
                                })
                            ]
                        })
                    ]
                }, `superset-group-${currentSupersetId}-${startIndex}`));
            } else {
                const cardIndex = droppableIndex++;
                if (ex.isRest) elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableRestCard, {
                    item: ex,
                    index: cardIndex,
                    sectionId: sectionId,
                    getExerciseMenu: getExerciseMenu,
                    onDoubleClickMetrics: ()=>{
                        setEditingExercise({
                            ex,
                            sectionId
                        });
                        setIsEditModalOpen(true);
                    },
                    isEditing: isEditModalOpen && editingExercise?.ex.id === ex.id && editingExercise?.sectionId === sectionId,
                    editForm: editForm,
                    setEditForm: setEditForm,
                    onEditCancel: ()=>{
                        handleSaveExercise();
                        setIsEditModalOpen(false);
                    }
                }, ex.id));
                else elements.push(/*#__PURE__*/ (0, _jsxRuntime.jsx)(SortableExerciseCard, {
                    ex: ex,
                    index: cardIndex,
                    sectionId: sectionId,
                    gender: gender,
                    getExerciseMenu: getExerciseMenu,
                    isGenerating: generatingExerciseId === ex.id,
                    onDoubleClickMetrics: (field = 'reps')=>{
                        setEditFocusField(field);
                        setEditingExercise({
                            ex,
                            sectionId
                        });
                        setIsEditModalOpen(true);
                    },
                    isEditing: isEditModalOpen && editingExercise?.ex.id === ex.id && editingExercise?.sectionId === sectionId,
                    focusField: editFocusField,
                    editForm: editForm,
                    setEditForm: setEditForm,
                    onEditCancel: ()=>{
                        handleSaveExercise();
                        setIsEditModalOpen(false);
                    }
                }, ex.id));
                i++;
            }
        }
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
            children: elements
        });
    };
    const renderEmptyState = (text)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            style: {
                color: '#e5e5e5',
                opacity: 0.4,
                textAlign: 'center',
                padding: '20px 0',
                fontSize: '13px'
            },
            children: text
        });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.DragDropContext), {
                onDragStart: handleDragStart,
                onDragEnd: handleDragEnd,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "pg-layout-container",
                    children: [
                        urlWorkout ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                            className: "workout-view-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "wvh-top",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "wvh-title-row",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "back-btn",
                                                    onClick: ()=>navigate(`/onboarding-trainer/dashboard/program-generated/${urlProgramId}`),
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                                        width: "24",
                                                        height: "24",
                                                        viewBox: "0 0 24 24",
                                                        fill: "none",
                                                        stroke: "currentColor",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                            points: "15 18 9 12 15 6"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                                    children: [
                                                        fetchedProgram?.programmeName && fetchedProgram?.programmeName !== 'Unnamed' ? fetchedProgram.programmeName : progress?.program_name?.[0]?.value || fetchedProgram?.draft?.progress?.program_name?.[0]?.value || '1st program',
                                                        "'s workout",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "dot",
                                                            children: "\u2022"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "date-sub",
                                                            children: "Monday, May 26"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "wvh-actions",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                variant: "light",
                                                className: "btn-save-white",
                                                onClick: handleSaveProgram,
                                                isLoading: isSaving,
                                                disabled: isGeneratingProgram,
                                                children: "Save"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "wvh-badges",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "workout-badge",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _goalApproachedSvg.ReactComponent), {}),
                                                " ",
                                                getDisplayTitle(goalApproach || '')
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "workout-badge",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _energyLevelSvg.ReactComponent), {}),
                                                " ",
                                                mapEnergyLevel(energyLevel)
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "workout-badge",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _durationSvg.ReactComponent), {}),
                                                ' ',
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "badge",
                                                    children: workoutDuration ? `${workoutDuration.replace('-min', '')} Mins` : '45 Mins'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "workout-badge",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _focusSvg.ReactComponent), {}),
                                                ' ',
                                                trainingGoal ? getDisplayTitle(trainingGoal).toUpperCase() : 'GENERAL FITNESS'
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("header", {
                            className: "pg-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "header-client-info",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "client-avatar",
                                            children: clientData?.clients?.[0]?.avatarUrl ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: clientData.clients[0].avatarUrl,
                                                alt: clientName,
                                                style: {
                                                    width: '100%',
                                                    height: '100%',
                                                    borderRadius: '50%',
                                                    objectFit: 'cover'
                                                }
                                            }) : getInitials(clientName)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "client-details",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                    className: "client-name",
                                                    children: clientName
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "client-meta",
                                                    children: [
                                                        duration,
                                                        " weeks \u2022 ",
                                                        howOftenTrain,
                                                        " days"
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                showHeaderStats && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "header-stats",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "stat-block",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "stat-label",
                                                    children: "Experience Level:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    className: "stat-value",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "stat-text",
                                                            children: experienceLevel
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "dots",
                                                            children: [
                                                                ...Array(5)
                                                            ].map((_, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: i < dotCount ? 'active' : ''
                                                                }, i))
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "stat-block",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "stat-label",
                                                    children: "Program Goal:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "stat-value",
                                                    style: {
                                                        textTransform: 'capitalize'
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "stat-text",
                                                        children: toTitleCase(programGoal)
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "stat-block",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "stat-label",
                                                    children: "Pain/Injuries:"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "stat-value",
                                                    style: {
                                                        textTransform: 'capitalize'
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "stat-text",
                                                        children: toTitleCase(painInjuries)
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "header-actions",
                                    children: [
                                        !activeClientId && !isFetchingProgram && !isGeneratingProgram && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            variant: "outline",
                                            className: "btn-assign",
                                            onClick: ()=>setIsAssignModalOpen(true),
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px'
                                                },
                                                children: [
                                                    (0, _programGenerator.programGeneratorSVG).header.assignToClient,
                                                    " Assign to client"
                                                ]
                                            })
                                        }),
                                        showRegenerateBtn && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            variant: "outline",
                                            className: "regenerate-btn",
                                            onClick: ()=>setIsRegenerateModalOpen(true),
                                            disabled: isGeneratingProgram,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                style: {
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    gap: '8px'
                                                },
                                                children: [
                                                    (0, _programGenerator.programGeneratorSVG).header.regenerateWorkout,
                                                    " Regenerate Workout"
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                            variant: "light",
                                            className: "save-btn",
                                            onClick: handleSaveProgram,
                                            isLoading: isSaving,
                                            disabled: isGeneratingProgram,
                                            children: "Save"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: `pg-body ${isLibraryOpen ? 'library-open' : ''}`,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _exerciseLibrary.ExerciseLibrary), {
                                    gender: gender,
                                    isOpen: isLibraryOpen,
                                    onClose: ()=>setIsLibraryOpen(false)
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pg-main",
                                    ref: pgMainRef,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: "lib-trigger-btn",
                                            onClick: ()=>setIsLibraryOpen((prev)=>!prev),
                                            children: (0, _programGenerator.programGeneratorSVG)?.sidebar.toggle
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "main-header",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "main-stat",
                                                    children: [
                                                        (0, _programGenerator.programGeneratorSVG).calender,
                                                        " ",
                                                        duration,
                                                        "-week program"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "main-stat",
                                                    children: [
                                                        howOftenTrain,
                                                        " workouts / week"
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "main-content",
                                            children: isGeneratingProgram || isFetchingProgram ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                style: {
                                                    display: 'flex',
                                                    justifyContent: 'center',
                                                    alignItems: 'center',
                                                    height: '100%',
                                                    minHeight: '400px'
                                                },
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    style: {
                                                        color: '#fff'
                                                    },
                                                    children: isGeneratingProgram ? 'Generating AI Program...' : 'Loading Program...'
                                                })
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "program-view-header",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "week-selector",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                        className: "week-nav-btn",
                                                                        onClick: handlePrevWeek,
                                                                        disabled: currentWeek === 1,
                                                                        children: (0, _programGenerator.programGeneratorSVG).weekProgram.prevWeek
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "week-dropdown-container",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                                                            menu: {
                                                                                items: weekItems
                                                                            },
                                                                            trigger: [
                                                                                'click'
                                                                            ],
                                                                            classNames: {
                                                                                root: 'week-dropdown-menu-overlay'
                                                                            },
                                                                            placement: "bottom",
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                                                className: "week-dropdown-btn",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                                                                                                children: [
                                                                                                    "Week ",
                                                                                                    currentWeek
                                                                                                ]
                                                                                            }),
                                                                                            " of ",
                                                                                            duration
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "dropdown-arrow",
                                                                                        children: (0, _programGenerator.programGeneratorSVG).weekProgram.weekDropdownArrow
                                                                                    })
                                                                                ]
                                                                            })
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                        className: "week-nav-btn",
                                                                        onClick: handleNextWeek,
                                                                        disabled: currentWeek === duration,
                                                                        children: (0, _programGenerator.programGeneratorSVG).weekProgram.nextWeek
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h3", {
                                                                className: "current-workout-title",
                                                                children: [
                                                                    "Week ",
                                                                    currentWeek,
                                                                    " \u2022 Workout ",
                                                                    currentWorkout
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "workout-tabs",
                                                                children: Array.from({
                                                                    length: howOftenTrain
                                                                }).map((_, i)=>{
                                                                    const wNum = i + 1;
                                                                    const dayLabel = getWorkoutDayOfWeek(wNum);
                                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                                        className: `workout-tab ${currentWorkout === wNum ? 'active' : ''}`,
                                                                        onClick: ()=>setCurrentWorkout(wNum),
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("strong", {
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                        className: "desktop-text",
                                                                                        children: [
                                                                                            "Workout ",
                                                                                            wNum
                                                                                        ]
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                        className: "mobile-text",
                                                                                        children: [
                                                                                            "W",
                                                                                            wNum
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                className: "workout-day-text",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "desktop-day",
                                                                                        children: dayLabel.full
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "mobile-day",
                                                                                        children: dayLabel.short
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, wNum);
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "program-view-body",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(WorkoutSection, {
                                                                id: "warmup",
                                                                className: "workout-section",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "section-header",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "header-left",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "section-icon",
                                                                                        children: (0, _programGenerator.programGeneratorSVG).exerciseType.warmup
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                        className: "header-info",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                                                children: "WARM UP"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                                children: [
                                                                                                    sections.warmup.filter((ex)=>!ex.isRest).length,
                                                                                                    " exercises \u2022",
                                                                                                    ' ',
                                                                                                    getSectionDuration(sections.warmup),
                                                                                                    " min"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "header-center desktop-only",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "metrics-grid",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "metrics-grid-info",
                                                                                        children: "Sets \xb7 Repetitions / Time \xb7 Rest"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "header-right",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                                                                    menu: {
                                                                                        items: getSectionMenu('warmup', sections.warmup)
                                                                                    },
                                                                                    trigger: [
                                                                                        'click'
                                                                                    ],
                                                                                    placement: "bottomRight",
                                                                                    classNames: {
                                                                                        root: 'action-dropdown-menu-overlay'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                                        className: "icon-btn",
                                                                                        children: (0, _programGenerator.programGeneratorSVG).exerciseAction.menu
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "section-content",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableExercisesList, {
                                                                                id: "warmup",
                                                                                children: renderSectionExercises(sections.warmup, 'warmup')
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                                className: "add-exercise-btn",
                                                                                onClick: handleAddExerciseClick,
                                                                                children: "+ Add exercise"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(WorkoutSection, {
                                                                id: "main",
                                                                className: "workout-section",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "section-header",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "header-left",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "section-icon",
                                                                                        children: (0, _programGenerator.programGeneratorSVG).exerciseType.main
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                        className: "header-info",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                                                children: "MAIN MOVEMENTS"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                                children: [
                                                                                                    sections.main.filter((ex)=>!ex.isRest).length,
                                                                                                    " exercises \u2022",
                                                                                                    ' ',
                                                                                                    getSectionDuration(sections.main),
                                                                                                    " min"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "header-center desktop-only",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "metrics-grid",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "metrics-grid-info",
                                                                                        children: "Sets \xb7 Repetitions / Time \xb7 Rest"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "header-right",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                                                                    menu: {
                                                                                        items: getSectionMenu('main', sections.main)
                                                                                    },
                                                                                    trigger: [
                                                                                        'click'
                                                                                    ],
                                                                                    placement: "bottomRight",
                                                                                    classNames: {
                                                                                        root: 'action-dropdown-menu-overlay'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                                        className: "icon-btn",
                                                                                        children: (0, _programGenerator.programGeneratorSVG).exerciseAction.menu
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "section-content",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableExercisesList, {
                                                                                id: "main",
                                                                                children: renderSectionExercises(sections.main, 'main')
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                                className: "add-exercise-btn",
                                                                                onClick: handleAddExerciseClick,
                                                                                children: "+ Add exercise"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(WorkoutSection, {
                                                                id: "cooldown",
                                                                className: "workout-section",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "section-header",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "header-left",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "section-icon",
                                                                                        children: (0, _programGenerator.programGeneratorSVG).exerciseType.cooldown
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                        className: "header-info",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                                                children: "COOL DOWNS"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                                children: [
                                                                                                    sections.cooldown.filter((ex)=>!ex.isRest).length,
                                                                                                    " exercises \u2022 ",
                                                                                                    getSectionDuration(sections.cooldown),
                                                                                                    " min"
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "header-center desktop-only",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "metrics-grid",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: "metrics-grid-info",
                                                                                        children: "Sets \xb7 Repetitions / Time \xb7 Rest"
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                className: "header-right",
                                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                                                                    menu: {
                                                                                        items: getSectionMenu('cooldown', sections.cooldown)
                                                                                    },
                                                                                    trigger: [
                                                                                        'click'
                                                                                    ],
                                                                                    placement: "bottomRight",
                                                                                    classNames: {
                                                                                        root: 'action-dropdown-menu-overlay'
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                                        className: "icon-btn",
                                                                                        children: (0, _programGenerator.programGeneratorSVG).exerciseAction.menu
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "section-content",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)(DroppableExercisesList, {
                                                                                id: "cooldown",
                                                                                children: renderSectionExercises(sections.cooldown, 'cooldown')
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                                className: "add-exercise-btn",
                                                                                onClick: handleAddExerciseClick,
                                                                                children: "+ Add exercise"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                            open: !!exerciseToRemove,
                            footer: null,
                            onCancel: ()=>setExerciseToRemove(null),
                            centered: true,
                            width: 518,
                            closeIcon: null,
                            rootClassName: "logout-modal",
                            className: "logout-modal",
                            styles: {
                                mask: {
                                    backdropFilter: 'blur(4px)',
                                    backgroundColor: 'rgba(6, 7, 35, 0.8)'
                                }
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "logout-modal-content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "logout-icon-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardModalDeleteSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        children: "Remove Exercise?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: "Are you sure you want to remove this exercise?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "logout-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "btn-logout",
                                                onClick: ()=>{
                                                    if (exerciseToRemove) {
                                                        updateSection(exerciseToRemove.sectionId, (prev)=>prev.filter((e)=>e.id !== exerciseToRemove.exId));
                                                        setExerciseToRemove(null);
                                                    }
                                                },
                                                children: "Remove"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "btn-cancel",
                                                onClick: ()=>setExerciseToRemove(null),
                                                children: "Cancel"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                            open: !!sectionToEmpty,
                            footer: null,
                            onCancel: ()=>setSectionToEmpty(null),
                            centered: true,
                            width: 518,
                            closeIcon: null,
                            rootClassName: "logout-modal",
                            className: "logout-modal",
                            styles: {
                                mask: {
                                    backdropFilter: 'blur(4px)',
                                    backgroundColor: 'rgba(6, 7, 35, 0.8)'
                                }
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "logout-modal-content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "logout-icon-wrapper",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardModalDeleteSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                        children: "Empty Content?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: "Are you sure you want to empty the content of this section?"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "logout-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "btn-logout",
                                                onClick: ()=>{
                                                    if (sectionToEmpty) {
                                                        updateSection(sectionToEmpty.sectionId, ()=>[]);
                                                        setSectionToEmpty(null);
                                                    }
                                                },
                                                children: "Empty Content"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                className: "btn-cancel",
                                                onClick: ()=>setSectionToEmpty(null),
                                                children: "Cancel"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                            open: isRegenerateModalOpen,
                            footer: null,
                            onCancel: ()=>setIsRegenerateModalOpen(false),
                            centered: true,
                            width: 518,
                            closeIcon: null,
                            rootClassName: "logout-modal regenerate-modal",
                            className: "logout-modal",
                            styles: {
                                mask: {
                                    backdropFilter: 'blur(4px)',
                                    backgroundColor: 'rgba(6, 7, 35, 0.8)'
                                }
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "logout-modal-content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "logout-icon-wrapper",
                                        style: {
                                            width: '80px',
                                            height: '80px',
                                            background: 'transparent',
                                            position: 'relative'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                                                src: (0, _miniPtCareMp4Default.default),
                                                autoPlay: true,
                                                loop: true,
                                                muted: true,
                                                playsInline: true,
                                                style: {
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "minipt-text",
                                                children: "miniPT"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("h2", {
                                        children: [
                                            ' ',
                                            "Are you sure you want to regenerate the program? All manual edits will be lost"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "logout-actions",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                                className: "btn-logout",
                                                onClick: ()=>generateProgram(true),
                                                isLoading: isGeneratingProgram,
                                                disabled: isGeneratingProgram,
                                                children: "Yes, Regenerate"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                className: "btn-cancel",
                                                onClick: ()=>setIsRegenerateModalOpen(false),
                                                children: [
                                                    (0, _programGenerator.programGeneratorSVG).exerciseAction.backToProgram,
                                                    " Back to Program"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                title: `Edit superset ${editingGroupLetter}`,
                open: isEditSupersetOpen,
                onCancel: ()=>setIsEditSupersetOpen(false),
                footer: null,
                centered: true,
                width: 611,
                rootClassName: "pg-edit-modal pg-edit-superset",
                closeIcon: (0, _programGenerator.programGeneratorSVG).EditExercise.close,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "pg-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pg-form-row align-items-center justify-content-between mb-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "superset-field-info",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            children: "Rounds"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: "How many times to repeat the superset"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pg-counter-input",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            children: "\u2212"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "3"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            children: "+"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("hr", {
                            className: "modal-hr"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pg-form-row align-items-center justify-content-between mb-4",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "superset-field-info",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            children: "Rest after pair"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            children: "Recovery time after completing one full round"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "pg-counter-input",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            children: "\u2212"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: "10s"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            children: "+"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "pg-rest-pills mb-4",
                            children: [
                                '0s',
                                '30s',
                                '60s',
                                '90s'
                            ].map((time)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `pg-rest-pill ${time === '30s' ? 'active' : ''}`,
                                    children: time
                                }, time))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pg-modal-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "pg-modal-cancel-btn",
                                    onClick: ()=>setIsEditSupersetOpen(false),
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "pg-modal-save-btn m-0",
                                    onClick: ()=>setIsEditSupersetOpen(false),
                                    children: "Save Changes"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: isDraftSavedModalOpen,
                onCancel: ()=>{
                    setIsDraftSavedModalOpen(false);
                    showWorkoutSavedToast();
                },
                footer: null,
                closable: false,
                centered: true,
                width: 518,
                rootClassName: "logout-modal program-save",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        background: 'rgba(0, 0, 0, 0.40)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: (0, _confirmation.confirmationSVG)?.draft
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Your program has been saved"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "draft-saved-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    className: "btn-back",
                                    onClick: ()=>{
                                        setIsDraftSavedModalOpen(false);
                                        showWorkoutSavedToast();
                                    },
                                    children: [
                                        (0, _confirmation.confirmationSVG)?.back,
                                        " Back to Edit"
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-proceed",
                                    onClick: ()=>{
                                        setIsDraftSavedModalOpen(false);
                                        setIsShareModalOpen(true);
                                        showWorkoutSavedToast();
                                    },
                                    children: "Share With Client"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _assignToClientModal.AssignToClientModal), {
                isOpen: isAssignModalOpen,
                onClose: ()=>setIsAssignModalOpen(false),
                onAssign: (data)=>{
                    return new Promise((resolve, reject)=>{
                        const currentUser = (0, _sessionStore.sessionStore).getState().currentUser;
                        const uid = (0, _firebase.auth).currentUser?.uid || currentUser?.uid;
                        if (!uid || uid.includes('@') || !savedProgramId) {
                            (0, _reactHotToastDefault.default).error('Program ID or Trainer ID is missing');
                            reject(new Error('Program ID or Trainer ID is missing'));
                            return;
                        }
                        assignToClient({
                            docPath: `trainer_app_users/${uid}/programme_plan/${savedProgramId}`,
                            programId: savedProgramId,
                            clientId: data.clientId,
                            startDate: data.startDate,
                            notify: data.notify,
                            message: data.message
                        }, {
                            onSuccess: ()=>{
                                setIsAssignModalOpen(false);
                                (0, _reactHotToastDefault.default).success('Workout assigned successfully');
                                resolve();
                            },
                            onError: (error)=>{
                                reject(error);
                            }
                        });
                    });
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _shareProgramModal.ShareProgramModal), {
                isOpen: isShareModalOpen,
                onClose: ()=>setIsShareModalOpen(false),
                programId: savedProgramId || '',
                programmeName: rawApiResponse?.result?.program?.data?.programmeName || 'Unnamed',
                isSent: hasSentToClient,
                isSending: isAssigningToClient,
                onSendMiniPTApp: ()=>{
                    if (activeClientId) {
                        const currentUser = (0, _sessionStore.sessionStore).getState().currentUser;
                        const uid = (0, _firebase.auth).currentUser?.uid || currentUser?.uid;
                        if (!uid || uid.includes('@') || !savedProgramId) {
                            (0, _reactHotToastDefault.default).error('Please save the program before sending.');
                            return;
                        }
                        // Program is already assigned to a client, directly copy to client
                        assignToClient({
                            docPath: `trainer_app_users/${uid}/programme_plan/${savedProgramId}`,
                            programId: savedProgramId,
                            clientId: activeClientId,
                            startDate: new Date().toISOString().split('T')[0],
                            notify: true,
                            message: ''
                        }, {
                            onSuccess: ()=>{
                                setHasSentToClient(true);
                                setIsShareModalOpen(false);
                                (0, _reactHotToastDefault.default).success('Workout assigned successfully');
                            }
                        });
                    } else {
                        setIsAssignModalOpen(true);
                        setIsShareModalOpen(false);
                    }
                }
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","./program-generated.scss":"63CFA","@hello-pangea/dnd":"djQDB","antd":[["Dropdown","cMU6A","default"],["Modal","kY4DD","default"],["notification","j9bIN","default"]],"react":"bmhQu","react-hot-toast":"3T0Wh","react-router-dom":[["useLocation","f3cgC"],["useNavigate","f3cgC"],["useParams","9oT3O"]],"@tanstack/react-query":"97Oud","src/api/mutations/useMockGenerateWorkoutProgramCoachProd":"8bpTy","src/api/mutations/useGenerateWorkoutProgramCoachProd":"hvohk","src/api/mutations/useGetTrainerClients":"18nHc","src/api/mutations/useSaveClientProgram":"7y4NZ","src/api/mutations/useSendProgramPlanToClient":"4puCf","src/api/queries/useGetAllMovements":"lveJ0","src/api/queries/useGetTrainerProgramById":"cSB8Q","src/assets/images/onboarding-trainer/dashboard/clients/workouts/duration.svg":"5RrLg","src/assets/images/onboarding-trainer/dashboard/clients/workouts/energy-level.svg":"dMi2U","src/assets/images/onboarding-trainer/dashboard/clients/workouts/focus.svg":"eekbv","src/assets/images/onboarding-trainer/dashboard/clients/workouts/goal-approached.svg":"goOdq","src/assets/images/trainer/clients/dashboard-modal-delete.svg":"4NTEi","src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/simple-line-check.svg":"6ZZuW","src/store/programGeneratorProgressStore":"2iAYB","src/store/sessionStore":"kPSO3","src/config/firebase":"cmjIE","url:../../../../../../assets/videos/mini-pt-care.mp4":"5knEg","../../../../components/Button/Button":"jLE7r","../ProgramGeneratorAI/assets/Confirmation":"4Xv03","../ProgramGeneratorAI/assets/ProgramGenerator":"8Npqa","../ProgramGeneratorAI/types":"1DGo2","../ProgramGeneratorAI/utils/buildPayload":"43eYD","../Programs/components/ShareProgramModal/ShareProgramModal":"3Pi50","./components/AssignToClientModal/AssignToClientModal":"erZXW","./ExerciseImages":"7RpZ0","src/utils/genderUtils":"aiA54","./ExerciseLibrary":"6SBz7","./transformProgramStateToPlan":"9pKyq","./useProgramDataTransformer":"P6SxW","./useMockProgramDataTransformer":"fetaT","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"63CFA":[function() {},{}],"djQDB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DragDropContext", ()=>DragDropContext);
parcelHelpers.export(exports, "Draggable", ()=>PublicDraggable);
parcelHelpers.export(exports, "Droppable", ()=>ConnectedDroppable);
parcelHelpers.export(exports, "useKeyboardSensor", ()=>useKeyboardSensor);
parcelHelpers.export(exports, "useMouseSensor", ()=>useMouseSensor);
parcelHelpers.export(exports, "useTouchSensor", ()=>useTouchSensor);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _reactDomDefault = parcelHelpers.interopDefault(_reactDom);
var _redux = require("redux");
var _reactRedux = require("react-redux");
var _cssBoxModel = require("css-box-model");
var _rafSchd = require("raf-schd");
var _rafSchdDefault = parcelHelpers.interopDefault(_rafSchd);
var _extends = require("@babel/runtime/helpers/esm/extends");
var _extendsDefault = parcelHelpers.interopDefault(_extends);
const isProduction$1 = true;
const spacesAndTabs = /[ \t]{2,}/g;
const lineStartWithSpaces = /^[ \t]*/gm;
const clean$2 = (value)=>value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
const getDevMessage = (message)=>clean$2(`
  %c@hello-pangea/dnd

  %c${clean$2(message)}

  %c\u{1F477}\u{200D} This is a development only message. It will be removed in production builds.
`);
const getFormattedMessage = (message)=>[
        getDevMessage(message),
        'color: #00C584; font-size: 1.2em; font-weight: bold;',
        'line-height: 1.5',
        'color: #723874;'
    ];
const isDisabledFlag = '__@hello-pangea/dnd-disable-dev-warnings';
function log(type, message) {
    if (isProduction$1) return;
    if (typeof window !== 'undefined' && window[isDisabledFlag]) return;
    console[type](...getFormattedMessage(message));
}
const warning = log.bind(null, 'warn');
const error = log.bind(null, 'error');
function noop$2() {}
function getOptions(shared, fromBinding) {
    return {
        ...shared,
        ...fromBinding
    };
}
function bindEvents(el, bindings, sharedOptions) {
    const unbindings = bindings.map((binding)=>{
        const options = getOptions(sharedOptions, binding.options);
        el.addEventListener(binding.eventName, binding.fn, options);
        return function unbind() {
            el.removeEventListener(binding.eventName, binding.fn, options);
        };
    });
    return function unbindAll() {
        unbindings.forEach((unbind)=>{
            unbind();
        });
    };
}
const isProduction = true;
const prefix$1 = 'Invariant failed';
class RbdInvariant extends Error {
}
RbdInvariant.prototype.toString = function toString() {
    return this.message;
};
function invariant(condition, message) {
    if (isProduction) throw new RbdInvariant(prefix$1);
    else throw new RbdInvariant(`${prefix$1}: ${message || ''}`);
}
class ErrorBoundary extends (0, _reactDefault.default).Component {
    constructor(...args){
        super(...args);
        this.callbacks = null;
        this.unbind = noop$2;
        this.onWindowError = (event)=>{
            const callbacks = this.getCallbacks();
            if (callbacks.isDragging()) callbacks.tryAbort();
            const err = event.error;
            if (err instanceof RbdInvariant) event.preventDefault();
        };
        this.getCallbacks = ()=>{
            if (!this.callbacks) throw new Error('Unable to find AppCallbacks in <ErrorBoundary/>');
            return this.callbacks;
        };
        this.setCallbacks = (callbacks)=>{
            this.callbacks = callbacks;
        };
    }
    componentDidMount() {
        this.unbind = bindEvents(window, [
            {
                eventName: 'error',
                fn: this.onWindowError
            }
        ]);
    }
    componentDidCatch(err) {
        if (err instanceof RbdInvariant) {
            this.setState({});
            return;
        }
        throw err;
    }
    componentWillUnmount() {
        this.unbind();
    }
    render() {
        return this.props.children(this.setCallbacks);
    }
}
const dragHandleUsageInstructions = `
  Press space bar to start a drag.
  When dragging you can use the arrow keys to move the item around and escape to cancel.
  Some screen readers may require you to be in focus mode or to use your pass through key
`;
const position = (index)=>index + 1;
const onDragStart = (start)=>`
  You have lifted an item in position ${position(start.source.index)}
`;
const withLocation = (source, destination)=>{
    const isInHomeList = source.droppableId === destination.droppableId;
    const startPosition = position(source.index);
    const endPosition = position(destination.index);
    if (isInHomeList) return `
      You have moved the item from position ${startPosition}
      to position ${endPosition}
    `;
    return `
    You have moved the item from position ${startPosition}
    in list ${source.droppableId}
    to list ${destination.droppableId}
    in position ${endPosition}
  `;
};
const withCombine = (id, source, combine)=>{
    const inHomeList = source.droppableId === combine.droppableId;
    if (inHomeList) return `
      The item ${id}
      has been combined with ${combine.draggableId}`;
    return `
      The item ${id}
      in list ${source.droppableId}
      has been combined with ${combine.draggableId}
      in list ${combine.droppableId}
    `;
};
const onDragUpdate = (update)=>{
    const location = update.destination;
    if (location) return withLocation(update.source, location);
    const combine = update.combine;
    if (combine) return withCombine(update.draggableId, update.source, combine);
    return 'You are over an area that cannot be dropped on';
};
const returnedToStart = (source)=>`
  The item has returned to its starting position
  of ${position(source.index)}
`;
const onDragEnd = (result)=>{
    if (result.reason === 'CANCEL') return `
      Movement cancelled.
      ${returnedToStart(result.source)}
    `;
    const location = result.destination;
    const combine = result.combine;
    if (location) return `
      You have dropped the item.
      ${withLocation(result.source, location)}
    `;
    if (combine) return `
      You have dropped the item.
      ${withCombine(result.draggableId, result.source, combine)}
    `;
    return `
    The item has been dropped while not over a drop area.
    ${returnedToStart(result.source)}
  `;
};
const preset = {
    dragHandleUsageInstructions,
    onDragStart,
    onDragUpdate,
    onDragEnd
};
function isEqual$2(first, second) {
    if (first === second) return true;
    if (Number.isNaN(first) && Number.isNaN(second)) return true;
    return false;
}
function areInputsEqual(newInputs, lastInputs) {
    if (newInputs.length !== lastInputs.length) return false;
    for(let i = 0; i < newInputs.length; i++){
        if (!isEqual$2(newInputs[i], lastInputs[i])) return false;
    }
    return true;
}
function useMemo(getResult, inputs) {
    const initial = (0, _react.useState)(()=>({
            inputs,
            result: getResult()
        }))[0];
    const isFirstRun = (0, _react.useRef)(true);
    const committed = (0, _react.useRef)(initial);
    const useCache = isFirstRun.current || Boolean(inputs && committed.current.inputs && areInputsEqual(inputs, committed.current.inputs));
    const cache = useCache ? committed.current : {
        inputs,
        result: getResult()
    };
    (0, _react.useEffect)(()=>{
        isFirstRun.current = false;
        committed.current = cache;
    }, [
        cache
    ]);
    return cache.result;
}
function useCallback(callback, inputs) {
    return useMemo(()=>callback, inputs);
}
const origin = {
    x: 0,
    y: 0
};
const add = (point1, point2)=>({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
const subtract = (point1, point2)=>({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });
const isEqual$1 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
const negate = (point)=>({
        x: point.x !== 0 ? -point.x : 0,
        y: point.y !== 0 ? -point.y : 0
    });
const patch = (line, value, otherValue = 0)=>{
    if (line === 'x') return {
        x: value,
        y: otherValue
    };
    return {
        x: otherValue,
        y: value
    };
};
const distance = (point1, point2)=>Math.sqrt((point2.x - point1.x) ** 2 + (point2.y - point1.y) ** 2);
const closest$1 = (target, points)=>Math.min(...points.map((point)=>distance(target, point)));
const apply = (fn)=>(point)=>({
            x: fn(point.x),
            y: fn(point.y)
        });
var executeClip = (frame, subject)=>{
    const result = (0, _cssBoxModel.getRect)({
        top: Math.max(subject.top, frame.top),
        right: Math.min(subject.right, frame.right),
        bottom: Math.min(subject.bottom, frame.bottom),
        left: Math.max(subject.left, frame.left)
    });
    if (result.width <= 0 || result.height <= 0) return null;
    return result;
};
const offsetByPosition = (spacing, point)=>({
        top: spacing.top + point.y,
        left: spacing.left + point.x,
        bottom: spacing.bottom + point.y,
        right: spacing.right + point.x
    });
const getCorners = (spacing)=>[
        {
            x: spacing.left,
            y: spacing.top
        },
        {
            x: spacing.right,
            y: spacing.top
        },
        {
            x: spacing.left,
            y: spacing.bottom
        },
        {
            x: spacing.right,
            y: spacing.bottom
        }
    ];
const noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
const scroll$1 = (target, frame)=>{
    if (!frame) return target;
    return offsetByPosition(target, frame.scroll.diff.displacement);
};
const increase = (target, axis, withPlaceholder)=>{
    if (withPlaceholder && withPlaceholder.increasedBy) return {
        ...target,
        [axis.end]: target[axis.end] + withPlaceholder.increasedBy[axis.line]
    };
    return target;
};
const clip = (target, frame)=>{
    if (frame && frame.shouldClipSubject) return executeClip(frame.pageMarginBox, target);
    return (0, _cssBoxModel.getRect)(target);
};
var getSubject = ({ page, withPlaceholder, axis, frame })=>{
    const scrolled = scroll$1(page.marginBox, frame);
    const increased = increase(scrolled, axis, withPlaceholder);
    const clipped = clip(increased, frame);
    return {
        page,
        withPlaceholder,
        active: clipped
    };
};
var scrollDroppable = (droppable, newScroll)=>{
    !droppable.frame && invariant();
    const scrollable = droppable.frame;
    const scrollDiff = subtract(newScroll, scrollable.scroll.initial);
    const scrollDisplacement = negate(scrollDiff);
    const frame = {
        ...scrollable,
        scroll: {
            initial: scrollable.scroll.initial,
            current: newScroll,
            diff: {
                value: scrollDiff,
                displacement: scrollDisplacement
            },
            max: scrollable.scroll.max
        }
    };
    const subject = getSubject({
        page: droppable.subject.page,
        withPlaceholder: droppable.subject.withPlaceholder,
        axis: droppable.axis,
        frame
    });
    const result = {
        ...droppable,
        frame,
        subject
    };
    return result;
};
function memoizeOne(resultFn, isEqual = areInputsEqual) {
    let cache = null;
    function memoized(...newArgs) {
        if (cache && cache.lastThis === this && isEqual(newArgs, cache.lastArgs)) return cache.lastResult;
        const lastResult = resultFn.apply(this, newArgs);
        cache = {
            lastResult,
            lastArgs: newArgs,
            lastThis: this
        };
        return lastResult;
    }
    memoized.clear = function clear() {
        cache = null;
    };
    return memoized;
}
const toDroppableMap = memoizeOne((droppables)=>droppables.reduce((previous, current)=>{
        previous[current.descriptor.id] = current;
        return previous;
    }, {}));
const toDraggableMap = memoizeOne((draggables)=>draggables.reduce((previous, current)=>{
        previous[current.descriptor.id] = current;
        return previous;
    }, {}));
const toDroppableList = memoizeOne((droppables)=>Object.values(droppables));
const toDraggableList = memoizeOne((draggables)=>Object.values(draggables));
var getDraggablesInsideDroppable = memoizeOne((droppableId, draggables)=>{
    const result = toDraggableList(draggables).filter((draggable)=>droppableId === draggable.descriptor.droppableId).sort((a, b)=>a.descriptor.index - b.descriptor.index);
    return result;
});
function tryGetDestination(impact) {
    if (impact.at && impact.at.type === 'REORDER') return impact.at.destination;
    return null;
}
function tryGetCombine(impact) {
    if (impact.at && impact.at.type === 'COMBINE') return impact.at.combine;
    return null;
}
var removeDraggableFromList = memoizeOne((remove, list)=>list.filter((item)=>item.descriptor.id !== remove.descriptor.id));
var moveToNextCombine = ({ isMovingForward, draggable, destination, insideDestination, previousImpact })=>{
    if (!destination.isCombineEnabled) return null;
    const location = tryGetDestination(previousImpact);
    if (!location) return null;
    function getImpact(target) {
        const at = {
            type: 'COMBINE',
            combine: {
                draggableId: target,
                droppableId: destination.descriptor.id
            }
        };
        return {
            ...previousImpact,
            at
        };
    }
    const all = previousImpact.displaced.all;
    const closestId = all.length ? all[0] : null;
    if (isMovingForward) return closestId ? getImpact(closestId) : null;
    const withoutDraggable = removeDraggableFromList(draggable, insideDestination);
    if (!closestId) {
        if (!withoutDraggable.length) return null;
        const last = withoutDraggable[withoutDraggable.length - 1];
        return getImpact(last.descriptor.id);
    }
    const indexOfClosest = withoutDraggable.findIndex((d)=>d.descriptor.id === closestId);
    !(indexOfClosest !== -1) && invariant();
    const proposedIndex = indexOfClosest - 1;
    if (proposedIndex < 0) return null;
    const before = withoutDraggable[proposedIndex];
    return getImpact(before.descriptor.id);
};
var isHomeOf = (draggable, destination)=>draggable.descriptor.droppableId === destination.descriptor.id;
const noDisplacedBy = {
    point: origin,
    value: 0
};
const emptyGroups = {
    invisible: {},
    visible: {},
    all: []
};
const noImpact = {
    displaced: emptyGroups,
    displacedBy: noDisplacedBy,
    at: null
};
var isWithin = (lowerBound, upperBound)=>(value)=>lowerBound <= value && value <= upperBound;
var isPartiallyVisibleThroughFrame = (frame)=>{
    const isWithinVertical = isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = isWithin(frame.left, frame.right);
    return (subject)=>{
        const isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        if (isContained) return true;
        const isPartiallyVisibleVertically = isWithinVertical(subject.top) || isWithinVertical(subject.bottom);
        const isPartiallyVisibleHorizontally = isWithinHorizontal(subject.left) || isWithinHorizontal(subject.right);
        const isPartiallyContained = isPartiallyVisibleVertically && isPartiallyVisibleHorizontally;
        if (isPartiallyContained) return true;
        const isBiggerVertically = subject.top < frame.top && subject.bottom > frame.bottom;
        const isBiggerHorizontally = subject.left < frame.left && subject.right > frame.right;
        const isTargetBiggerThanFrame = isBiggerVertically && isBiggerHorizontally;
        if (isTargetBiggerThanFrame) return true;
        const isTargetBiggerOnOneAxis = isBiggerVertically && isPartiallyVisibleHorizontally || isBiggerHorizontally && isPartiallyVisibleVertically;
        return isTargetBiggerOnOneAxis;
    };
};
var isTotallyVisibleThroughFrame = (frame)=>{
    const isWithinVertical = isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = isWithin(frame.left, frame.right);
    return (subject)=>{
        const isContained = isWithinVertical(subject.top) && isWithinVertical(subject.bottom) && isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        return isContained;
    };
};
const vertical = {
    direction: 'vertical',
    line: 'y',
    crossAxisLine: 'x',
    start: 'top',
    end: 'bottom',
    size: 'height',
    crossAxisStart: 'left',
    crossAxisEnd: 'right',
    crossAxisSize: 'width'
};
const horizontal = {
    direction: 'horizontal',
    line: 'x',
    crossAxisLine: 'y',
    start: 'left',
    end: 'right',
    size: 'width',
    crossAxisStart: 'top',
    crossAxisEnd: 'bottom',
    crossAxisSize: 'height'
};
var isTotallyVisibleThroughFrameOnAxis = (axis)=>(frame)=>{
        const isWithinVertical = isWithin(frame.top, frame.bottom);
        const isWithinHorizontal = isWithin(frame.left, frame.right);
        return (subject)=>{
            if (axis === vertical) return isWithinVertical(subject.top) && isWithinVertical(subject.bottom);
            return isWithinHorizontal(subject.left) && isWithinHorizontal(subject.right);
        };
    };
const getDroppableDisplaced = (target, destination)=>{
    const displacement = destination.frame ? destination.frame.scroll.diff.displacement : origin;
    return offsetByPosition(target, displacement);
};
const isVisibleInDroppable = (target, destination, isVisibleThroughFrameFn)=>{
    if (!destination.subject.active) return false;
    return isVisibleThroughFrameFn(destination.subject.active)(target);
};
const isVisibleInViewport = (target, viewport, isVisibleThroughFrameFn)=>isVisibleThroughFrameFn(viewport)(target);
const isVisible$1 = ({ target: toBeDisplaced, destination, viewport, withDroppableDisplacement, isVisibleThroughFrameFn })=>{
    const displacedTarget = withDroppableDisplacement ? getDroppableDisplaced(toBeDisplaced, destination) : toBeDisplaced;
    return isVisibleInDroppable(displacedTarget, destination, isVisibleThroughFrameFn) && isVisibleInViewport(displacedTarget, viewport, isVisibleThroughFrameFn);
};
const isPartiallyVisible = (args)=>isVisible$1({
        ...args,
        isVisibleThroughFrameFn: isPartiallyVisibleThroughFrame
    });
const isTotallyVisible = (args)=>isVisible$1({
        ...args,
        isVisibleThroughFrameFn: isTotallyVisibleThroughFrame
    });
const isTotallyVisibleOnAxis = (args)=>isVisible$1({
        ...args,
        isVisibleThroughFrameFn: isTotallyVisibleThroughFrameOnAxis(args.destination.axis)
    });
const getShouldAnimate = (id, last, forceShouldAnimate)=>{
    if (typeof forceShouldAnimate === 'boolean') return forceShouldAnimate;
    if (!last) return true;
    const { invisible, visible } = last;
    if (invisible[id]) return false;
    const previous = visible[id];
    return previous ? previous.shouldAnimate : true;
};
function getTarget(draggable, displacedBy) {
    const marginBox = draggable.page.marginBox;
    const expandBy = {
        top: displacedBy.point.y,
        right: 0,
        bottom: 0,
        left: displacedBy.point.x
    };
    return (0, _cssBoxModel.getRect)((0, _cssBoxModel.expand)(marginBox, expandBy));
}
function getDisplacementGroups({ afterDragging, destination, displacedBy, viewport, forceShouldAnimate, last }) {
    return afterDragging.reduce(function process(groups, draggable) {
        const target = getTarget(draggable, displacedBy);
        const id = draggable.descriptor.id;
        groups.all.push(id);
        const isVisible = isPartiallyVisible({
            target,
            destination,
            viewport,
            withDroppableDisplacement: true
        });
        if (!isVisible) {
            groups.invisible[draggable.descriptor.id] = true;
            return groups;
        }
        const shouldAnimate = getShouldAnimate(id, last, forceShouldAnimate);
        const displacement = {
            draggableId: id,
            shouldAnimate
        };
        groups.visible[id] = displacement;
        return groups;
    }, {
        all: [],
        visible: {},
        invisible: {}
    });
}
function getIndexOfLastItem(draggables, options) {
    if (!draggables.length) return 0;
    const indexOfLastItem = draggables[draggables.length - 1].descriptor.index;
    return options.inHomeList ? indexOfLastItem : indexOfLastItem + 1;
}
function goAtEnd({ insideDestination, inHomeList, displacedBy, destination }) {
    const newIndex = getIndexOfLastItem(insideDestination, {
        inHomeList
    });
    return {
        displaced: emptyGroups,
        displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index: newIndex
            }
        }
    };
}
function calculateReorderImpact({ draggable, insideDestination, destination, viewport, displacedBy, last, index, forceShouldAnimate }) {
    const inHomeList = isHomeOf(draggable, destination);
    if (index == null) return goAtEnd({
        insideDestination,
        inHomeList,
        displacedBy,
        destination
    });
    const match = insideDestination.find((item)=>item.descriptor.index === index);
    if (!match) return goAtEnd({
        insideDestination,
        inHomeList,
        displacedBy,
        destination
    });
    const withoutDragging = removeDraggableFromList(draggable, insideDestination);
    const sliceFrom = insideDestination.indexOf(match);
    const impacted = withoutDragging.slice(sliceFrom);
    const displaced = getDisplacementGroups({
        afterDragging: impacted,
        destination,
        displacedBy,
        last,
        viewport: viewport.frame,
        forceShouldAnimate
    });
    return {
        displaced,
        displacedBy,
        at: {
            type: 'REORDER',
            destination: {
                droppableId: destination.descriptor.id,
                index
            }
        }
    };
}
function didStartAfterCritical(draggableId, afterCritical) {
    return Boolean(afterCritical.effected[draggableId]);
}
var fromCombine = ({ isMovingForward, destination, draggables, combine, afterCritical })=>{
    if (!destination.isCombineEnabled) return null;
    const combineId = combine.draggableId;
    const combineWith = draggables[combineId];
    const combineWithIndex = combineWith.descriptor.index;
    const didCombineWithStartAfterCritical = didStartAfterCritical(combineId, afterCritical);
    if (didCombineWithStartAfterCritical) {
        if (isMovingForward) return combineWithIndex;
        return combineWithIndex - 1;
    }
    if (isMovingForward) return combineWithIndex + 1;
    return combineWithIndex;
};
var fromReorder = ({ isMovingForward, isInHomeList, insideDestination, location })=>{
    if (!insideDestination.length) return null;
    const currentIndex = location.index;
    const proposedIndex = isMovingForward ? currentIndex + 1 : currentIndex - 1;
    const firstIndex = insideDestination[0].descriptor.index;
    const lastIndex = insideDestination[insideDestination.length - 1].descriptor.index;
    const upperBound = isInHomeList ? lastIndex : lastIndex + 1;
    if (proposedIndex < firstIndex) return null;
    if (proposedIndex > upperBound) return null;
    return proposedIndex;
};
var moveToNextIndex = ({ isMovingForward, isInHomeList, draggable, draggables, destination, insideDestination, previousImpact, viewport, afterCritical })=>{
    const wasAt = previousImpact.at;
    !wasAt && invariant();
    if (wasAt.type === 'REORDER') {
        const newIndex = fromReorder({
            isMovingForward,
            isInHomeList,
            location: wasAt.destination,
            insideDestination
        });
        if (newIndex == null) return null;
        return calculateReorderImpact({
            draggable,
            insideDestination,
            destination,
            viewport,
            last: previousImpact.displaced,
            displacedBy: previousImpact.displacedBy,
            index: newIndex
        });
    }
    const newIndex = fromCombine({
        isMovingForward,
        destination,
        displaced: previousImpact.displaced,
        draggables,
        combine: wasAt.combine,
        afterCritical
    });
    if (newIndex == null) return null;
    return calculateReorderImpact({
        draggable,
        insideDestination,
        destination,
        viewport,
        last: previousImpact.displaced,
        displacedBy: previousImpact.displacedBy,
        index: newIndex
    });
};
var getCombinedItemDisplacement = ({ displaced, afterCritical, combineWith, displacedBy })=>{
    const isDisplaced = Boolean(displaced.visible[combineWith] || displaced.invisible[combineWith]);
    if (didStartAfterCritical(combineWith, afterCritical)) return isDisplaced ? origin : negate(displacedBy.point);
    return isDisplaced ? displacedBy.point : origin;
};
var whenCombining = ({ afterCritical, impact, draggables })=>{
    const combine = tryGetCombine(impact);
    !combine && invariant();
    const combineWith = combine.draggableId;
    const center = draggables[combineWith].page.borderBox.center;
    const displaceBy = getCombinedItemDisplacement({
        displaced: impact.displaced,
        afterCritical,
        combineWith,
        displacedBy: impact.displacedBy
    });
    return add(center, displaceBy);
};
const distanceFromStartToBorderBoxCenter = (axis, box)=>box.margin[axis.start] + box.borderBox[axis.size] / 2;
const distanceFromEndToBorderBoxCenter = (axis, box)=>box.margin[axis.end] + box.borderBox[axis.size] / 2;
const getCrossAxisBorderBoxCenter = (axis, target, isMoving)=>target[axis.crossAxisStart] + isMoving.margin[axis.crossAxisStart] + isMoving.borderBox[axis.crossAxisSize] / 2;
const goAfter = ({ axis, moveRelativeTo, isMoving })=>patch(axis.line, moveRelativeTo.marginBox[axis.end] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
const goBefore = ({ axis, moveRelativeTo, isMoving })=>patch(axis.line, moveRelativeTo.marginBox[axis.start] - distanceFromEndToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveRelativeTo.marginBox, isMoving));
const goIntoStart = ({ axis, moveInto, isMoving })=>patch(axis.line, moveInto.contentBox[axis.start] + distanceFromStartToBorderBoxCenter(axis, isMoving), getCrossAxisBorderBoxCenter(axis, moveInto.contentBox, isMoving));
var whenReordering = ({ impact, draggable, draggables, droppable, afterCritical })=>{
    const insideDestination = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    const draggablePage = draggable.page;
    const axis = droppable.axis;
    if (!insideDestination.length) return goIntoStart({
        axis,
        moveInto: droppable.page,
        isMoving: draggablePage
    });
    const { displaced, displacedBy } = impact;
    const closestAfter = displaced.all[0];
    if (closestAfter) {
        const closest = draggables[closestAfter];
        if (didStartAfterCritical(closestAfter, afterCritical)) return goBefore({
            axis,
            moveRelativeTo: closest.page,
            isMoving: draggablePage
        });
        const withDisplacement = (0, _cssBoxModel.offset)(closest.page, displacedBy.point);
        return goBefore({
            axis,
            moveRelativeTo: withDisplacement,
            isMoving: draggablePage
        });
    }
    const last = insideDestination[insideDestination.length - 1];
    if (last.descriptor.id === draggable.descriptor.id) return draggablePage.borderBox.center;
    if (didStartAfterCritical(last.descriptor.id, afterCritical)) {
        const page = (0, _cssBoxModel.offset)(last.page, negate(afterCritical.displacedBy.point));
        return goAfter({
            axis,
            moveRelativeTo: page,
            isMoving: draggablePage
        });
    }
    return goAfter({
        axis,
        moveRelativeTo: last.page,
        isMoving: draggablePage
    });
};
var withDroppableDisplacement = (droppable, point)=>{
    const frame = droppable.frame;
    if (!frame) return point;
    return add(point, frame.scroll.diff.displacement);
};
const getResultWithoutDroppableDisplacement = ({ impact, draggable, droppable, draggables, afterCritical })=>{
    const original = draggable.page.borderBox.center;
    const at = impact.at;
    if (!droppable) return original;
    if (!at) return original;
    if (at.type === 'REORDER') return whenReordering({
        impact,
        draggable,
        draggables,
        droppable,
        afterCritical
    });
    return whenCombining({
        impact,
        draggables,
        afterCritical
    });
};
var getPageBorderBoxCenterFromImpact = (args)=>{
    const withoutDisplacement = getResultWithoutDroppableDisplacement(args);
    const droppable = args.droppable;
    const withDisplacement = droppable ? withDroppableDisplacement(droppable, withoutDisplacement) : withoutDisplacement;
    return withDisplacement;
};
var scrollViewport = (viewport, newScroll)=>{
    const diff = subtract(newScroll, viewport.scroll.initial);
    const displacement = negate(diff);
    const frame = (0, _cssBoxModel.getRect)({
        top: newScroll.y,
        bottom: newScroll.y + viewport.frame.height,
        left: newScroll.x,
        right: newScroll.x + viewport.frame.width
    });
    const updated = {
        frame,
        scroll: {
            initial: viewport.scroll.initial,
            max: viewport.scroll.max,
            current: newScroll,
            diff: {
                value: diff,
                displacement
            }
        }
    };
    return updated;
};
function getDraggables$1(ids, draggables) {
    return ids.map((id)=>draggables[id]);
}
function tryGetVisible(id, groups) {
    for(let i = 0; i < groups.length; i++){
        const displacement = groups[i].visible[id];
        if (displacement) return displacement;
    }
    return null;
}
var speculativelyIncrease = ({ impact, viewport, destination, draggables, maxScrollChange })=>{
    const scrolledViewport = scrollViewport(viewport, add(viewport.scroll.current, maxScrollChange));
    const scrolledDroppable = destination.frame ? scrollDroppable(destination, add(destination.frame.scroll.current, maxScrollChange)) : destination;
    const last = impact.displaced;
    const withViewportScroll = getDisplacementGroups({
        afterDragging: getDraggables$1(last.all, draggables),
        destination,
        displacedBy: impact.displacedBy,
        viewport: scrolledViewport.frame,
        last,
        forceShouldAnimate: false
    });
    const withDroppableScroll = getDisplacementGroups({
        afterDragging: getDraggables$1(last.all, draggables),
        destination: scrolledDroppable,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        last,
        forceShouldAnimate: false
    });
    const invisible = {};
    const visible = {};
    const groups = [
        last,
        withViewportScroll,
        withDroppableScroll
    ];
    last.all.forEach((id)=>{
        const displacement = tryGetVisible(id, groups);
        if (displacement) {
            visible[id] = displacement;
            return;
        }
        invisible[id] = true;
    });
    const newImpact = {
        ...impact,
        displaced: {
            all: last.all,
            invisible,
            visible
        }
    };
    return newImpact;
};
var withViewportDisplacement = (viewport, point)=>add(viewport.scroll.diff.displacement, point);
var getClientFromPageBorderBoxCenter = ({ pageBorderBoxCenter, draggable, viewport })=>{
    const withoutPageScrollChange = withViewportDisplacement(viewport, pageBorderBoxCenter);
    const offset = subtract(withoutPageScrollChange, draggable.page.borderBox.center);
    return add(draggable.client.borderBox.center, offset);
};
var isTotallyVisibleInNewLocation = ({ draggable, destination, newPageBorderBoxCenter, viewport, withDroppableDisplacement, onlyOnMainAxis = false })=>{
    const changeNeeded = subtract(newPageBorderBoxCenter, draggable.page.borderBox.center);
    const shifted = offsetByPosition(draggable.page.borderBox, changeNeeded);
    const args = {
        target: shifted,
        destination,
        withDroppableDisplacement,
        viewport
    };
    return onlyOnMainAxis ? isTotallyVisibleOnAxis(args) : isTotallyVisible(args);
};
var moveToNextPlace = ({ isMovingForward, draggable, destination, draggables, previousImpact, viewport, previousPageBorderBoxCenter, previousClientSelection, afterCritical })=>{
    if (!destination.isEnabled) return null;
    const insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const isInHomeList = isHomeOf(draggable, destination);
    const impact = moveToNextCombine({
        isMovingForward,
        draggable,
        destination,
        insideDestination,
        previousImpact
    }) || moveToNextIndex({
        isMovingForward,
        isInHomeList,
        draggable,
        draggables,
        destination,
        insideDestination,
        previousImpact,
        viewport,
        afterCritical
    });
    if (!impact) return null;
    const pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
        impact,
        draggable,
        droppable: destination,
        draggables,
        afterCritical
    });
    const isVisibleInNewLocation = isTotallyVisibleInNewLocation({
        draggable,
        destination,
        newPageBorderBoxCenter: pageBorderBoxCenter,
        viewport: viewport.frame,
        withDroppableDisplacement: false,
        onlyOnMainAxis: true
    });
    if (isVisibleInNewLocation) {
        const clientSelection = getClientFromPageBorderBoxCenter({
            pageBorderBoxCenter,
            draggable,
            viewport
        });
        return {
            clientSelection,
            impact,
            scrollJumpRequest: null
        };
    }
    const distance = subtract(pageBorderBoxCenter, previousPageBorderBoxCenter);
    const cautious = speculativelyIncrease({
        impact,
        viewport,
        destination,
        draggables,
        maxScrollChange: distance
    });
    return {
        clientSelection: previousClientSelection,
        impact: cautious,
        scrollJumpRequest: distance
    };
};
const getKnownActive = (droppable)=>{
    const rect = droppable.subject.active;
    !rect && invariant();
    return rect;
};
var getBestCrossAxisDroppable = ({ isMovingForward, pageBorderBoxCenter, source, droppables, viewport })=>{
    const active = source.subject.active;
    if (!active) return null;
    const axis = source.axis;
    const isBetweenSourceClipped = isWithin(active[axis.start], active[axis.end]);
    const candidates = toDroppableList(droppables).filter((droppable)=>droppable !== source).filter((droppable)=>droppable.isEnabled).filter((droppable)=>Boolean(droppable.subject.active)).filter((droppable)=>isPartiallyVisibleThroughFrame(viewport.frame)(getKnownActive(droppable))).filter((droppable)=>{
        const activeOfTarget = getKnownActive(droppable);
        if (isMovingForward) return active[axis.crossAxisEnd] < activeOfTarget[axis.crossAxisEnd];
        return activeOfTarget[axis.crossAxisStart] < active[axis.crossAxisStart];
    }).filter((droppable)=>{
        const activeOfTarget = getKnownActive(droppable);
        const isBetweenDestinationClipped = isWithin(activeOfTarget[axis.start], activeOfTarget[axis.end]);
        return isBetweenSourceClipped(activeOfTarget[axis.start]) || isBetweenSourceClipped(activeOfTarget[axis.end]) || isBetweenDestinationClipped(active[axis.start]) || isBetweenDestinationClipped(active[axis.end]);
    }).sort((a, b)=>{
        const first = getKnownActive(a)[axis.crossAxisStart];
        const second = getKnownActive(b)[axis.crossAxisStart];
        if (isMovingForward) return first - second;
        return second - first;
    }).filter((droppable, index, array)=>getKnownActive(droppable)[axis.crossAxisStart] === getKnownActive(array[0])[axis.crossAxisStart]);
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0];
    const contains = candidates.filter((droppable)=>{
        const isWithinDroppable = isWithin(getKnownActive(droppable)[axis.start], getKnownActive(droppable)[axis.end]);
        return isWithinDroppable(pageBorderBoxCenter[axis.line]);
    });
    if (contains.length === 1) return contains[0];
    if (contains.length > 1) return contains.sort((a, b)=>getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start])[0];
    return candidates.sort((a, b)=>{
        const first = closest$1(pageBorderBoxCenter, getCorners(getKnownActive(a)));
        const second = closest$1(pageBorderBoxCenter, getCorners(getKnownActive(b)));
        if (first !== second) return first - second;
        return getKnownActive(a)[axis.start] - getKnownActive(b)[axis.start];
    })[0];
};
const getCurrentPageBorderBoxCenter = (draggable, afterCritical)=>{
    const original = draggable.page.borderBox.center;
    return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? subtract(original, afterCritical.displacedBy.point) : original;
};
const getCurrentPageBorderBox = (draggable, afterCritical)=>{
    const original = draggable.page.borderBox;
    return didStartAfterCritical(draggable.descriptor.id, afterCritical) ? offsetByPosition(original, negate(afterCritical.displacedBy.point)) : original;
};
var getClosestDraggable = ({ pageBorderBoxCenter, viewport, destination, insideDestination, afterCritical })=>{
    const sorted = insideDestination.filter((draggable)=>isTotallyVisible({
            target: getCurrentPageBorderBox(draggable, afterCritical),
            destination,
            viewport: viewport.frame,
            withDroppableDisplacement: true
        })).sort((a, b)=>{
        const distanceToA = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(a, afterCritical)));
        const distanceToB = distance(pageBorderBoxCenter, withDroppableDisplacement(destination, getCurrentPageBorderBoxCenter(b, afterCritical)));
        if (distanceToA < distanceToB) return -1;
        if (distanceToB < distanceToA) return 1;
        return a.descriptor.index - b.descriptor.index;
    });
    return sorted[0] || null;
};
var getDisplacedBy = memoizeOne(function getDisplacedBy(axis, displaceBy) {
    const displacement = displaceBy[axis.line];
    return {
        value: displacement,
        point: patch(axis.line, displacement)
    };
});
const getRequiredGrowthForPlaceholder = (droppable, placeholderSize, draggables)=>{
    const axis = droppable.axis;
    if (droppable.descriptor.mode === 'virtual') return patch(axis.line, placeholderSize[axis.line]);
    const availableSpace = droppable.subject.page.contentBox[axis.size];
    const insideDroppable = getDraggablesInsideDroppable(droppable.descriptor.id, draggables);
    const spaceUsed = insideDroppable.reduce((sum, dimension)=>sum + dimension.client.marginBox[axis.size], 0);
    const requiredSpace = spaceUsed + placeholderSize[axis.line];
    const needsToGrowBy = requiredSpace - availableSpace;
    if (needsToGrowBy <= 0) return null;
    return patch(axis.line, needsToGrowBy);
};
const withMaxScroll = (frame, max)=>({
        ...frame,
        scroll: {
            ...frame.scroll,
            max
        }
    });
const addPlaceholder = (droppable, draggable, draggables)=>{
    const frame = droppable.frame;
    !!isHomeOf(draggable, droppable) && invariant();
    !!droppable.subject.withPlaceholder && invariant();
    const placeholderSize = getDisplacedBy(droppable.axis, draggable.displaceBy).point;
    const requiredGrowth = getRequiredGrowthForPlaceholder(droppable, placeholderSize, draggables);
    const added = {
        placeholderSize,
        increasedBy: requiredGrowth,
        oldFrameMaxScroll: droppable.frame ? droppable.frame.scroll.max : null
    };
    if (!frame) {
        const subject = getSubject({
            page: droppable.subject.page,
            withPlaceholder: added,
            axis: droppable.axis,
            frame: droppable.frame
        });
        return {
            ...droppable,
            subject
        };
    }
    const maxScroll = requiredGrowth ? add(frame.scroll.max, requiredGrowth) : frame.scroll.max;
    const newFrame = withMaxScroll(frame, maxScroll);
    const subject = getSubject({
        page: droppable.subject.page,
        withPlaceholder: added,
        axis: droppable.axis,
        frame: newFrame
    });
    return {
        ...droppable,
        subject,
        frame: newFrame
    };
};
const removePlaceholder = (droppable)=>{
    const added = droppable.subject.withPlaceholder;
    !added && invariant();
    const frame = droppable.frame;
    if (!frame) {
        const subject = getSubject({
            page: droppable.subject.page,
            axis: droppable.axis,
            frame: null,
            withPlaceholder: null
        });
        return {
            ...droppable,
            subject
        };
    }
    const oldMaxScroll = added.oldFrameMaxScroll;
    !oldMaxScroll && invariant();
    const newFrame = withMaxScroll(frame, oldMaxScroll);
    const subject = getSubject({
        page: droppable.subject.page,
        axis: droppable.axis,
        frame: newFrame,
        withPlaceholder: null
    });
    return {
        ...droppable,
        subject,
        frame: newFrame
    };
};
var moveToNewDroppable = ({ previousPageBorderBoxCenter, moveRelativeTo, insideDestination, draggable, draggables, destination, viewport, afterCritical })=>{
    if (!moveRelativeTo) {
        if (insideDestination.length) return null;
        const proposed = {
            displaced: emptyGroups,
            displacedBy: noDisplacedBy,
            at: {
                type: 'REORDER',
                destination: {
                    droppableId: destination.descriptor.id,
                    index: 0
                }
            }
        };
        const proposedPageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
            impact: proposed,
            draggable,
            droppable: destination,
            draggables,
            afterCritical
        });
        const withPlaceholder = isHomeOf(draggable, destination) ? destination : addPlaceholder(destination, draggable, draggables);
        const isVisibleInNewLocation = isTotallyVisibleInNewLocation({
            draggable,
            destination: withPlaceholder,
            newPageBorderBoxCenter: proposedPageBorderBoxCenter,
            viewport: viewport.frame,
            withDroppableDisplacement: false,
            onlyOnMainAxis: true
        });
        return isVisibleInNewLocation ? proposed : null;
    }
    const isGoingBeforeTarget = Boolean(previousPageBorderBoxCenter[destination.axis.line] <= moveRelativeTo.page.borderBox.center[destination.axis.line]);
    const proposedIndex = (()=>{
        const relativeTo = moveRelativeTo.descriptor.index;
        if (moveRelativeTo.descriptor.id === draggable.descriptor.id) return relativeTo;
        if (isGoingBeforeTarget) return relativeTo;
        return relativeTo + 1;
    })();
    const displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
    return calculateReorderImpact({
        draggable,
        insideDestination,
        destination,
        viewport,
        displacedBy,
        last: emptyGroups,
        index: proposedIndex
    });
};
var moveCrossAxis = ({ isMovingForward, previousPageBorderBoxCenter, draggable, isOver, draggables, droppables, viewport, afterCritical })=>{
    const destination = getBestCrossAxisDroppable({
        isMovingForward,
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        source: isOver,
        droppables,
        viewport
    });
    if (!destination) return null;
    const insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const moveRelativeTo = getClosestDraggable({
        pageBorderBoxCenter: previousPageBorderBoxCenter,
        viewport,
        destination,
        insideDestination,
        afterCritical
    });
    const impact = moveToNewDroppable({
        previousPageBorderBoxCenter,
        destination,
        draggable,
        draggables,
        moveRelativeTo,
        insideDestination,
        viewport,
        afterCritical
    });
    if (!impact) return null;
    const pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
        impact,
        draggable,
        droppable: destination,
        draggables,
        afterCritical
    });
    const clientSelection = getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter,
        draggable,
        viewport
    });
    return {
        clientSelection,
        impact,
        scrollJumpRequest: null
    };
};
var whatIsDraggedOver = (impact)=>{
    const at = impact.at;
    if (!at) return null;
    if (at.type === 'REORDER') return at.destination.droppableId;
    return at.combine.droppableId;
};
const getDroppableOver$1 = (impact, droppables)=>{
    const id = whatIsDraggedOver(impact);
    return id ? droppables[id] : null;
};
var moveInDirection = ({ state, type })=>{
    const isActuallyOver = getDroppableOver$1(state.impact, state.dimensions.droppables);
    const isMainAxisMovementAllowed = Boolean(isActuallyOver);
    const home = state.dimensions.droppables[state.critical.droppable.id];
    const isOver = isActuallyOver || home;
    const direction = isOver.axis.direction;
    const isMovingOnMainAxis = direction === 'vertical' && (type === 'MOVE_UP' || type === 'MOVE_DOWN') || direction === 'horizontal' && (type === 'MOVE_LEFT' || type === 'MOVE_RIGHT');
    if (isMovingOnMainAxis && !isMainAxisMovementAllowed) return null;
    const isMovingForward = type === 'MOVE_DOWN' || type === 'MOVE_RIGHT';
    const draggable = state.dimensions.draggables[state.critical.draggable.id];
    const previousPageBorderBoxCenter = state.current.page.borderBoxCenter;
    const { draggables, droppables } = state.dimensions;
    return isMovingOnMainAxis ? moveToNextPlace({
        isMovingForward,
        previousPageBorderBoxCenter,
        draggable,
        destination: isOver,
        draggables,
        viewport: state.viewport,
        previousClientSelection: state.current.client.selection,
        previousImpact: state.impact,
        afterCritical: state.afterCritical
    }) : moveCrossAxis({
        isMovingForward,
        previousPageBorderBoxCenter,
        draggable,
        isOver,
        draggables,
        droppables,
        viewport: state.viewport,
        afterCritical: state.afterCritical
    });
};
function isMovementAllowed(state) {
    return state.phase === 'DRAGGING' || state.phase === 'COLLECTING';
}
function isPositionInFrame(frame) {
    const isWithinVertical = isWithin(frame.top, frame.bottom);
    const isWithinHorizontal = isWithin(frame.left, frame.right);
    return function run(point) {
        return isWithinVertical(point.y) && isWithinHorizontal(point.x);
    };
}
function getHasOverlap(first, second) {
    return first.left < second.right && first.right > second.left && first.top < second.bottom && first.bottom > second.top;
}
function getFurthestAway({ pageBorderBox, draggable, candidates }) {
    const startCenter = draggable.page.borderBox.center;
    const sorted = candidates.map((candidate)=>{
        const axis = candidate.axis;
        const target = patch(candidate.axis.line, pageBorderBox.center[axis.line], candidate.page.borderBox.center[axis.crossAxisLine]);
        return {
            id: candidate.descriptor.id,
            distance: distance(startCenter, target)
        };
    }).sort((a, b)=>b.distance - a.distance);
    return sorted[0] ? sorted[0].id : null;
}
function getDroppableOver({ pageBorderBox, draggable, droppables }) {
    const candidates = toDroppableList(droppables).filter((item)=>{
        if (!item.isEnabled) return false;
        const active = item.subject.active;
        if (!active) return false;
        if (!getHasOverlap(pageBorderBox, active)) return false;
        if (isPositionInFrame(active)(pageBorderBox.center)) return true;
        const axis = item.axis;
        const childCenter = active.center[axis.crossAxisLine];
        const crossAxisStart = pageBorderBox[axis.crossAxisStart];
        const crossAxisEnd = pageBorderBox[axis.crossAxisEnd];
        const isContained = isWithin(active[axis.crossAxisStart], active[axis.crossAxisEnd]);
        const isStartContained = isContained(crossAxisStart);
        const isEndContained = isContained(crossAxisEnd);
        if (!isStartContained && !isEndContained) return true;
        if (isStartContained) return crossAxisStart < childCenter;
        return crossAxisEnd > childCenter;
    });
    if (!candidates.length) return null;
    if (candidates.length === 1) return candidates[0].descriptor.id;
    return getFurthestAway({
        pageBorderBox,
        draggable,
        candidates
    });
}
const offsetRectByPosition = (rect, point)=>(0, _cssBoxModel.getRect)(offsetByPosition(rect, point));
var withDroppableScroll = (droppable, area)=>{
    const frame = droppable.frame;
    if (!frame) return area;
    return offsetRectByPosition(area, frame.scroll.diff.value);
};
function getIsDisplaced({ displaced, id }) {
    return Boolean(displaced.visible[id] || displaced.invisible[id]);
}
function atIndex({ draggable, closest, inHomeList }) {
    if (!closest) return null;
    if (!inHomeList) return closest.descriptor.index;
    if (closest.descriptor.index > draggable.descriptor.index) return closest.descriptor.index - 1;
    return closest.descriptor.index;
}
var getReorderImpact = ({ pageBorderBoxWithDroppableScroll: targetRect, draggable, destination, insideDestination, last, viewport, afterCritical })=>{
    const axis = destination.axis;
    const displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
    const displacement = displacedBy.value;
    const targetStart = targetRect[axis.start];
    const targetEnd = targetRect[axis.end];
    const withoutDragging = removeDraggableFromList(draggable, insideDestination);
    const closest = withoutDragging.find((child)=>{
        const id = child.descriptor.id;
        const childCenter = child.page.borderBox.center[axis.line];
        const didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
        const isDisplaced = getIsDisplaced({
            displaced: last,
            id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd <= childCenter;
            return targetStart < childCenter - displacement;
        }
        if (isDisplaced) return targetEnd <= childCenter + displacement;
        return targetStart < childCenter;
    }) || null;
    const newIndex = atIndex({
        draggable,
        closest,
        inHomeList: isHomeOf(draggable, destination)
    });
    return calculateReorderImpact({
        draggable,
        insideDestination,
        destination,
        viewport,
        last,
        displacedBy,
        index: newIndex
    });
};
const combineThresholdDivisor = 4;
var getCombineImpact = ({ draggable, pageBorderBoxWithDroppableScroll: targetRect, previousImpact, destination, insideDestination, afterCritical })=>{
    if (!destination.isCombineEnabled) return null;
    const axis = destination.axis;
    const displacedBy = getDisplacedBy(destination.axis, draggable.displaceBy);
    const displacement = displacedBy.value;
    const targetStart = targetRect[axis.start];
    const targetEnd = targetRect[axis.end];
    const withoutDragging = removeDraggableFromList(draggable, insideDestination);
    const combineWith = withoutDragging.find((child)=>{
        const id = child.descriptor.id;
        const childRect = child.page.borderBox;
        const childSize = childRect[axis.size];
        const threshold = childSize / combineThresholdDivisor;
        const didStartAfterCritical$1 = didStartAfterCritical(id, afterCritical);
        const isDisplaced = getIsDisplaced({
            displaced: previousImpact.displaced,
            id
        });
        if (didStartAfterCritical$1) {
            if (isDisplaced) return targetEnd > childRect[axis.start] + threshold && targetEnd < childRect[axis.end] - threshold;
            return targetStart > childRect[axis.start] - displacement + threshold && targetStart < childRect[axis.end] - displacement - threshold;
        }
        if (isDisplaced) return targetEnd > childRect[axis.start] + displacement + threshold && targetEnd < childRect[axis.end] + displacement - threshold;
        return targetStart > childRect[axis.start] + threshold && targetStart < childRect[axis.end] - threshold;
    });
    if (!combineWith) return null;
    const impact = {
        displacedBy,
        displaced: previousImpact.displaced,
        at: {
            type: 'COMBINE',
            combine: {
                draggableId: combineWith.descriptor.id,
                droppableId: destination.descriptor.id
            }
        }
    };
    return impact;
};
var getDragImpact = ({ pageOffset, draggable, draggables, droppables, previousImpact, viewport, afterCritical })=>{
    const pageBorderBox = offsetRectByPosition(draggable.page.borderBox, pageOffset);
    const destinationId = getDroppableOver({
        pageBorderBox,
        draggable,
        droppables
    });
    if (!destinationId) return noImpact;
    const destination = droppables[destinationId];
    const insideDestination = getDraggablesInsideDroppable(destination.descriptor.id, draggables);
    const pageBorderBoxWithDroppableScroll = withDroppableScroll(destination, pageBorderBox);
    return getCombineImpact({
        pageBorderBoxWithDroppableScroll,
        draggable,
        previousImpact,
        destination,
        insideDestination,
        afterCritical
    }) || getReorderImpact({
        pageBorderBoxWithDroppableScroll,
        draggable,
        destination,
        insideDestination,
        last: previousImpact.displaced,
        viewport,
        afterCritical
    });
};
var patchDroppableMap = (droppables, updated)=>({
        ...droppables,
        [updated.descriptor.id]: updated
    });
const clearUnusedPlaceholder = ({ previousImpact, impact, droppables })=>{
    const last = whatIsDraggedOver(previousImpact);
    const now = whatIsDraggedOver(impact);
    if (!last) return droppables;
    if (last === now) return droppables;
    const lastDroppable = droppables[last];
    if (!lastDroppable.subject.withPlaceholder) return droppables;
    const updated = removePlaceholder(lastDroppable);
    return patchDroppableMap(droppables, updated);
};
var recomputePlaceholders = ({ draggable, draggables, droppables, previousImpact, impact })=>{
    const cleaned = clearUnusedPlaceholder({
        previousImpact,
        impact,
        droppables
    });
    const isOver = whatIsDraggedOver(impact);
    if (!isOver) return cleaned;
    const droppable = droppables[isOver];
    if (isHomeOf(draggable, droppable)) return cleaned;
    if (droppable.subject.withPlaceholder) return cleaned;
    const patched = addPlaceholder(droppable, draggable, draggables);
    return patchDroppableMap(cleaned, patched);
};
var update = ({ state, clientSelection: forcedClientSelection, dimensions: forcedDimensions, viewport: forcedViewport, impact: forcedImpact, scrollJumpRequest })=>{
    const viewport = forcedViewport || state.viewport;
    const dimensions = forcedDimensions || state.dimensions;
    const clientSelection = forcedClientSelection || state.current.client.selection;
    const offset = subtract(clientSelection, state.initial.client.selection);
    const client = {
        offset,
        selection: clientSelection,
        borderBoxCenter: add(state.initial.client.borderBoxCenter, offset)
    };
    const page = {
        selection: add(client.selection, viewport.scroll.current),
        borderBoxCenter: add(client.borderBoxCenter, viewport.scroll.current),
        offset: add(client.offset, viewport.scroll.diff.value)
    };
    const current = {
        client,
        page
    };
    if (state.phase === 'COLLECTING') return {
        ...state,
        dimensions,
        viewport,
        current
    };
    const draggable = dimensions.draggables[state.critical.draggable.id];
    const newImpact = forcedImpact || getDragImpact({
        pageOffset: page.offset,
        draggable,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact: state.impact,
        viewport,
        afterCritical: state.afterCritical
    });
    const withUpdatedPlaceholders = recomputePlaceholders({
        draggable,
        impact: newImpact,
        previousImpact: state.impact,
        draggables: dimensions.draggables,
        droppables: dimensions.droppables
    });
    const result = {
        ...state,
        current,
        dimensions: {
            draggables: dimensions.draggables,
            droppables: withUpdatedPlaceholders
        },
        impact: newImpact,
        viewport,
        scrollJumpRequest: scrollJumpRequest || null,
        forceShouldAnimate: scrollJumpRequest ? false : null
    };
    return result;
};
function getDraggables(ids, draggables) {
    return ids.map((id)=>draggables[id]);
}
var recompute = ({ impact, viewport, draggables, destination, forceShouldAnimate })=>{
    const last = impact.displaced;
    const afterDragging = getDraggables(last.all, draggables);
    const displaced = getDisplacementGroups({
        afterDragging,
        destination,
        displacedBy: impact.displacedBy,
        viewport: viewport.frame,
        forceShouldAnimate,
        last
    });
    return {
        ...impact,
        displaced
    };
};
var getClientBorderBoxCenter = ({ impact, draggable, droppable, draggables, viewport, afterCritical })=>{
    const pageBorderBoxCenter = getPageBorderBoxCenterFromImpact({
        impact,
        draggable,
        draggables,
        droppable,
        afterCritical
    });
    return getClientFromPageBorderBoxCenter({
        pageBorderBoxCenter,
        draggable,
        viewport
    });
};
var refreshSnap = ({ state, dimensions: forcedDimensions, viewport: forcedViewport })=>{
    !(state.movementMode === 'SNAP') && invariant();
    const needsVisibilityCheck = state.impact;
    const viewport = forcedViewport || state.viewport;
    const dimensions = forcedDimensions || state.dimensions;
    const { draggables, droppables } = dimensions;
    const draggable = draggables[state.critical.draggable.id];
    const isOver = whatIsDraggedOver(needsVisibilityCheck);
    !isOver && invariant();
    const destination = droppables[isOver];
    const impact = recompute({
        impact: needsVisibilityCheck,
        viewport,
        destination,
        draggables
    });
    const clientSelection = getClientBorderBoxCenter({
        impact,
        draggable,
        droppable: destination,
        draggables,
        viewport,
        afterCritical: state.afterCritical
    });
    return update({
        impact,
        clientSelection,
        state,
        dimensions,
        viewport
    });
};
var getHomeLocation = (descriptor)=>({
        index: descriptor.index,
        droppableId: descriptor.droppableId
    });
var getLiftEffect = ({ draggable, home, draggables, viewport })=>{
    const displacedBy = getDisplacedBy(home.axis, draggable.displaceBy);
    const insideHome = getDraggablesInsideDroppable(home.descriptor.id, draggables);
    const rawIndex = insideHome.indexOf(draggable);
    !(rawIndex !== -1) && invariant();
    const afterDragging = insideHome.slice(rawIndex + 1);
    const effected = afterDragging.reduce((previous, item)=>{
        previous[item.descriptor.id] = true;
        return previous;
    }, {});
    const afterCritical = {
        inVirtualList: home.descriptor.mode === 'virtual',
        displacedBy,
        effected
    };
    const displaced = getDisplacementGroups({
        afterDragging,
        destination: home,
        displacedBy,
        last: null,
        viewport: viewport.frame,
        forceShouldAnimate: false
    });
    const impact = {
        displaced,
        displacedBy,
        at: {
            type: 'REORDER',
            destination: getHomeLocation(draggable.descriptor)
        }
    };
    return {
        impact,
        afterCritical
    };
};
var patchDimensionMap = (dimensions, updated)=>({
        draggables: dimensions.draggables,
        droppables: patchDroppableMap(dimensions.droppables, updated)
    });
const start = (key)=>{};
const finish = (key)=>{};
var offsetDraggable = ({ draggable, offset: offset$1, initialWindowScroll })=>{
    const client = (0, _cssBoxModel.offset)(draggable.client, offset$1);
    const page = (0, _cssBoxModel.withScroll)(client, initialWindowScroll);
    const moved = {
        ...draggable,
        placeholder: {
            ...draggable.placeholder,
            client
        },
        client,
        page
    };
    return moved;
};
var getFrame = (droppable)=>{
    const frame = droppable.frame;
    !frame && invariant();
    return frame;
};
var adjustAdditionsForScrollChanges = ({ additions, updatedDroppables, viewport })=>{
    const windowScrollChange = viewport.scroll.diff.value;
    return additions.map((draggable)=>{
        const droppableId = draggable.descriptor.droppableId;
        const modified = updatedDroppables[droppableId];
        const frame = getFrame(modified);
        const droppableScrollChange = frame.scroll.diff.value;
        const totalChange = add(windowScrollChange, droppableScrollChange);
        const moved = offsetDraggable({
            draggable,
            offset: totalChange,
            initialWindowScroll: viewport.scroll.initial
        });
        return moved;
    });
};
var publishWhileDraggingInVirtual = ({ state, published })=>{
    start();
    const withScrollChange = published.modified.map((update)=>{
        const existing = state.dimensions.droppables[update.droppableId];
        const scrolled = scrollDroppable(existing, update.scroll);
        return scrolled;
    });
    const droppables = {
        ...state.dimensions.droppables,
        ...toDroppableMap(withScrollChange)
    };
    const updatedAdditions = toDraggableMap(adjustAdditionsForScrollChanges({
        additions: published.additions,
        updatedDroppables: droppables,
        viewport: state.viewport
    }));
    const draggables = {
        ...state.dimensions.draggables,
        ...updatedAdditions
    };
    published.removals.forEach((id)=>{
        delete draggables[id];
    });
    const dimensions = {
        droppables,
        draggables
    };
    const wasOverId = whatIsDraggedOver(state.impact);
    const wasOver = wasOverId ? dimensions.droppables[wasOverId] : null;
    const draggable = dimensions.draggables[state.critical.draggable.id];
    const home = dimensions.droppables[state.critical.droppable.id];
    const { impact: onLiftImpact, afterCritical } = getLiftEffect({
        draggable,
        home,
        draggables,
        viewport: state.viewport
    });
    const previousImpact = wasOver && wasOver.isCombineEnabled ? state.impact : onLiftImpact;
    const impact = getDragImpact({
        pageOffset: state.current.page.offset,
        draggable: dimensions.draggables[state.critical.draggable.id],
        draggables: dimensions.draggables,
        droppables: dimensions.droppables,
        previousImpact,
        viewport: state.viewport,
        afterCritical
    });
    finish();
    const draggingState = {
        ...state,
        phase: 'DRAGGING',
        impact,
        onLiftImpact,
        dimensions,
        afterCritical,
        forceShouldAnimate: false
    };
    if (state.phase === 'COLLECTING') return draggingState;
    const dropPending = {
        ...draggingState,
        phase: 'DROP_PENDING',
        reason: state.reason,
        isWaiting: false
    };
    return dropPending;
};
const isSnapping = (state)=>state.movementMode === 'SNAP';
const postDroppableChange = (state, updated, isEnabledChanging)=>{
    const dimensions = patchDimensionMap(state.dimensions, updated);
    if (!isSnapping(state) || isEnabledChanging) return update({
        state,
        dimensions
    });
    return refreshSnap({
        state,
        dimensions
    });
};
function removeScrollJumpRequest(state) {
    if (state.isDragging && state.movementMode === 'SNAP') return {
        ...state,
        scrollJumpRequest: null
    };
    return state;
}
const idle$2 = {
    phase: 'IDLE',
    completed: null,
    shouldFlush: false
};
var reducer = (state = idle$2, action)=>{
    if (action.type === 'FLUSH') return {
        ...idle$2,
        shouldFlush: true
    };
    if (action.type === 'INITIAL_PUBLISH') {
        !(state.phase === 'IDLE') && invariant();
        const { critical, clientSelection, viewport, dimensions, movementMode } = action.payload;
        const draggable = dimensions.draggables[critical.draggable.id];
        const home = dimensions.droppables[critical.droppable.id];
        const client = {
            selection: clientSelection,
            borderBoxCenter: draggable.client.borderBox.center,
            offset: origin
        };
        const initial = {
            client,
            page: {
                selection: add(client.selection, viewport.scroll.initial),
                borderBoxCenter: add(client.selection, viewport.scroll.initial),
                offset: add(client.selection, viewport.scroll.diff.value)
            }
        };
        const isWindowScrollAllowed = toDroppableList(dimensions.droppables).every((item)=>!item.isFixedOnPage);
        const { impact, afterCritical } = getLiftEffect({
            draggable,
            home,
            draggables: dimensions.draggables,
            viewport
        });
        const result = {
            phase: 'DRAGGING',
            isDragging: true,
            critical,
            movementMode,
            dimensions,
            initial,
            current: initial,
            isWindowScrollAllowed,
            impact,
            afterCritical,
            onLiftImpact: impact,
            viewport,
            scrollJumpRequest: null,
            forceShouldAnimate: null
        };
        return result;
    }
    if (action.type === 'COLLECTION_STARTING') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && invariant();
        const result = {
            ...state,
            phase: 'COLLECTING'
        };
        return result;
    }
    if (action.type === 'PUBLISH_WHILE_DRAGGING') {
        !(state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') && invariant();
        return publishWhileDraggingInVirtual({
            state,
            published: action.payload
        });
    }
    if (action.type === 'MOVE') {
        if (state.phase === 'DROP_PENDING') return state;
        !isMovementAllowed(state) && invariant();
        const { client: clientSelection } = action.payload;
        if (isEqual$1(clientSelection, state.current.client.selection)) return state;
        return update({
            state,
            clientSelection,
            impact: isSnapping(state) ? state.impact : null
        });
    }
    if (action.type === 'UPDATE_DROPPABLE_SCROLL') {
        if (state.phase === 'DROP_PENDING') return removeScrollJumpRequest(state);
        if (state.phase === 'COLLECTING') return removeScrollJumpRequest(state);
        !isMovementAllowed(state) && invariant();
        const { id, newScroll } = action.payload;
        const target = state.dimensions.droppables[id];
        if (!target) return state;
        const scrolled = scrollDroppable(target, newScroll);
        return postDroppableChange(state, scrolled, false);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !isMovementAllowed(state) && invariant();
        const { id, isEnabled } = action.payload;
        const target = state.dimensions.droppables[id];
        !target && invariant();
        !(target.isEnabled !== isEnabled) && invariant();
        const updated = {
            ...target,
            isEnabled
        };
        return postDroppableChange(state, updated, true);
    }
    if (action.type === 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED') {
        if (state.phase === 'DROP_PENDING') return state;
        !isMovementAllowed(state) && invariant();
        const { id, isCombineEnabled } = action.payload;
        const target = state.dimensions.droppables[id];
        !target && invariant();
        !(target.isCombineEnabled !== isCombineEnabled) && invariant();
        const updated = {
            ...target,
            isCombineEnabled
        };
        return postDroppableChange(state, updated, true);
    }
    if (action.type === 'MOVE_BY_WINDOW_SCROLL') {
        if (state.phase === 'DROP_PENDING' || state.phase === 'DROP_ANIMATING') return state;
        !isMovementAllowed(state) && invariant();
        !state.isWindowScrollAllowed && invariant();
        const newScroll = action.payload.newScroll;
        if (isEqual$1(state.viewport.scroll.current, newScroll)) return removeScrollJumpRequest(state);
        const viewport = scrollViewport(state.viewport, newScroll);
        if (isSnapping(state)) return refreshSnap({
            state,
            viewport
        });
        return update({
            state,
            viewport
        });
    }
    if (action.type === 'UPDATE_VIEWPORT_MAX_SCROLL') {
        if (!isMovementAllowed(state)) return state;
        const maxScroll = action.payload.maxScroll;
        if (isEqual$1(maxScroll, state.viewport.scroll.max)) return state;
        const withMaxScroll = {
            ...state.viewport,
            scroll: {
                ...state.viewport.scroll,
                max: maxScroll
            }
        };
        return {
            ...state,
            viewport: withMaxScroll
        };
    }
    if (action.type === 'MOVE_UP' || action.type === 'MOVE_DOWN' || action.type === 'MOVE_LEFT' || action.type === 'MOVE_RIGHT') {
        if (state.phase === 'COLLECTING' || state.phase === 'DROP_PENDING') return state;
        !(state.phase === 'DRAGGING') && invariant();
        const result = moveInDirection({
            state,
            type: action.type
        });
        if (!result) return state;
        return update({
            state,
            impact: result.impact,
            clientSelection: result.clientSelection,
            scrollJumpRequest: result.scrollJumpRequest
        });
    }
    if (action.type === 'DROP_PENDING') {
        const reason = action.payload.reason;
        !(state.phase === 'COLLECTING') && invariant();
        const newState = {
            ...state,
            phase: 'DROP_PENDING',
            isWaiting: true,
            reason
        };
        return newState;
    }
    if (action.type === 'DROP_ANIMATE') {
        const { completed, dropDuration, newHomeClientOffset } = action.payload;
        !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && invariant();
        const result = {
            phase: 'DROP_ANIMATING',
            completed,
            dropDuration,
            newHomeClientOffset,
            dimensions: state.dimensions
        };
        return result;
    }
    if (action.type === 'DROP_COMPLETE') {
        const { completed } = action.payload;
        return {
            phase: 'IDLE',
            completed,
            shouldFlush: false
        };
    }
    return state;
};
function guard(action, predicate) {
    return action instanceof Object && 'type' in action && action.type === predicate;
}
const beforeInitialCapture = (args)=>({
        type: 'BEFORE_INITIAL_CAPTURE',
        payload: args
    });
const lift$1 = (args)=>({
        type: 'LIFT',
        payload: args
    });
const initialPublish = (args)=>({
        type: 'INITIAL_PUBLISH',
        payload: args
    });
const publishWhileDragging = (args)=>({
        type: 'PUBLISH_WHILE_DRAGGING',
        payload: args
    });
const collectionStarting = ()=>({
        type: 'COLLECTION_STARTING',
        payload: null
    });
const updateDroppableScroll = (args)=>({
        type: 'UPDATE_DROPPABLE_SCROLL',
        payload: args
    });
const updateDroppableIsEnabled = (args)=>({
        type: 'UPDATE_DROPPABLE_IS_ENABLED',
        payload: args
    });
const updateDroppableIsCombineEnabled = (args)=>({
        type: 'UPDATE_DROPPABLE_IS_COMBINE_ENABLED',
        payload: args
    });
const move = (args)=>({
        type: 'MOVE',
        payload: args
    });
const moveByWindowScroll = (args)=>({
        type: 'MOVE_BY_WINDOW_SCROLL',
        payload: args
    });
const updateViewportMaxScroll = (args)=>({
        type: 'UPDATE_VIEWPORT_MAX_SCROLL',
        payload: args
    });
const moveUp = ()=>({
        type: 'MOVE_UP',
        payload: null
    });
const moveDown = ()=>({
        type: 'MOVE_DOWN',
        payload: null
    });
const moveRight = ()=>({
        type: 'MOVE_RIGHT',
        payload: null
    });
const moveLeft = ()=>({
        type: 'MOVE_LEFT',
        payload: null
    });
const flush = ()=>({
        type: 'FLUSH',
        payload: null
    });
const animateDrop = (args)=>({
        type: 'DROP_ANIMATE',
        payload: args
    });
const completeDrop = (args)=>({
        type: 'DROP_COMPLETE',
        payload: args
    });
const drop = (args)=>({
        type: 'DROP',
        payload: args
    });
const dropPending = (args)=>({
        type: 'DROP_PENDING',
        payload: args
    });
const dropAnimationFinished = ()=>({
        type: 'DROP_ANIMATION_FINISHED',
        payload: null
    });
function checkIndexes(insideDestination) {
    if (insideDestination.length <= 1) return;
    const indexes = insideDestination.map((d)=>d.descriptor.index);
    const errors = {};
    for(let i = 1; i < indexes.length; i++){
        const current = indexes[i];
        const previous = indexes[i - 1];
        if (current !== previous + 1) errors[current] = true;
    }
    if (!Object.keys(errors).length) return;
    const formatted = indexes.map((index)=>{
        const hasError = Boolean(errors[index]);
        return hasError ? `[\u{1F525}${index}]` : `${index}`;
    }).join(', ');
}
function validateDimensions(critical, dimensions) {}
var lift = (marshal)=>({ getState, dispatch })=>(next)=>(action)=>{
                if (!guard(action, 'LIFT')) {
                    next(action);
                    return;
                }
                const { id, clientSelection, movementMode } = action.payload;
                const initial = getState();
                if (initial.phase === 'DROP_ANIMATING') dispatch(completeDrop({
                    completed: initial.completed
                }));
                !(getState().phase === 'IDLE') && invariant();
                dispatch(flush());
                dispatch(beforeInitialCapture({
                    draggableId: id,
                    movementMode
                }));
                const scrollOptions = {
                    shouldPublishImmediately: movementMode === 'SNAP'
                };
                const request = {
                    draggableId: id,
                    scrollOptions
                };
                const { critical, dimensions, viewport } = marshal.startPublishing(request);
                validateDimensions(critical, dimensions);
                dispatch(initialPublish({
                    critical,
                    dimensions,
                    clientSelection,
                    movementMode,
                    viewport
                }));
            };
var style = (marshal)=>()=>(next)=>(action)=>{
                if (guard(action, 'INITIAL_PUBLISH')) marshal.dragging();
                if (guard(action, 'DROP_ANIMATE')) marshal.dropping(action.payload.completed.result.reason);
                if (guard(action, 'FLUSH') || guard(action, 'DROP_COMPLETE')) marshal.resting();
                next(action);
            };
const curves = {
    outOfTheWay: 'cubic-bezier(0.2, 0, 0, 1)',
    drop: 'cubic-bezier(.2,1,.1,1)'
};
const combine = {
    opacity: {
        drop: 0,
        combining: 0.7
    },
    scale: {
        drop: 0.75
    }
};
const timings = {
    outOfTheWay: 0.2,
    minDropTime: 0.33,
    maxDropTime: 0.55
};
const outOfTheWayTiming = `${timings.outOfTheWay}s ${curves.outOfTheWay}`;
const transitions = {
    fluid: `opacity ${outOfTheWayTiming}`,
    snap: `transform ${outOfTheWayTiming}, opacity ${outOfTheWayTiming}`,
    drop: (duration)=>{
        const timing = `${duration}s ${curves.drop}`;
        return `transform ${timing}, opacity ${timing}`;
    },
    outOfTheWay: `transform ${outOfTheWayTiming}`,
    placeholder: `height ${outOfTheWayTiming}, width ${outOfTheWayTiming}, margin ${outOfTheWayTiming}`
};
const moveTo = (offset)=>isEqual$1(offset, origin) ? undefined : `translate(${offset.x}px, ${offset.y}px)`;
const transforms = {
    moveTo,
    drop: (offset, isCombining)=>{
        const translate = moveTo(offset);
        if (!translate) return undefined;
        if (!isCombining) return translate;
        return `${translate} scale(${combine.scale.drop})`;
    }
};
const { minDropTime, maxDropTime } = timings;
const dropTimeRange = maxDropTime - minDropTime;
const maxDropTimeAtDistance = 1500;
const cancelDropModifier = 0.6;
var getDropDuration = ({ current, destination, reason })=>{
    const distance$1 = distance(current, destination);
    if (distance$1 <= 0) return minDropTime;
    if (distance$1 >= maxDropTimeAtDistance) return maxDropTime;
    const percentage = distance$1 / maxDropTimeAtDistance;
    const duration = minDropTime + dropTimeRange * percentage;
    const withDuration = reason === 'CANCEL' ? duration * cancelDropModifier : duration;
    return Number(withDuration.toFixed(2));
};
var getNewHomeClientOffset = ({ impact, draggable, dimensions, viewport, afterCritical })=>{
    const { draggables, droppables } = dimensions;
    const droppableId = whatIsDraggedOver(impact);
    const destination = droppableId ? droppables[droppableId] : null;
    const home = droppables[draggable.descriptor.droppableId];
    const newClientCenter = getClientBorderBoxCenter({
        impact,
        draggable,
        draggables,
        afterCritical,
        droppable: destination || home,
        viewport
    });
    const offset = subtract(newClientCenter, draggable.client.borderBox.center);
    return offset;
};
var getDropImpact = ({ draggables, reason, lastImpact, home, viewport, onLiftImpact })=>{
    if (!lastImpact.at || reason !== 'DROP') {
        const recomputedHomeImpact = recompute({
            draggables,
            impact: onLiftImpact,
            destination: home,
            viewport,
            forceShouldAnimate: true
        });
        return {
            impact: recomputedHomeImpact,
            didDropInsideDroppable: false
        };
    }
    if (lastImpact.at.type === 'REORDER') return {
        impact: lastImpact,
        didDropInsideDroppable: true
    };
    const withoutMovement = {
        ...lastImpact,
        displaced: emptyGroups
    };
    return {
        impact: withoutMovement,
        didDropInsideDroppable: true
    };
};
const dropMiddleware = ({ getState, dispatch })=>(next)=>(action)=>{
            if (!guard(action, 'DROP')) {
                next(action);
                return;
            }
            const state = getState();
            const reason = action.payload.reason;
            if (state.phase === 'COLLECTING') {
                dispatch(dropPending({
                    reason
                }));
                return;
            }
            if (state.phase === 'IDLE') return;
            const isWaitingForDrop = state.phase === 'DROP_PENDING' && state.isWaiting;
            !!isWaitingForDrop && invariant();
            !(state.phase === 'DRAGGING' || state.phase === 'DROP_PENDING') && invariant();
            const critical = state.critical;
            const dimensions = state.dimensions;
            const draggable = dimensions.draggables[state.critical.draggable.id];
            const { impact, didDropInsideDroppable } = getDropImpact({
                reason,
                lastImpact: state.impact,
                afterCritical: state.afterCritical,
                onLiftImpact: state.onLiftImpact,
                home: state.dimensions.droppables[state.critical.droppable.id],
                viewport: state.viewport,
                draggables: state.dimensions.draggables
            });
            const destination = didDropInsideDroppable ? tryGetDestination(impact) : null;
            const combine = didDropInsideDroppable ? tryGetCombine(impact) : null;
            const source = {
                index: critical.draggable.index,
                droppableId: critical.droppable.id
            };
            const result = {
                draggableId: draggable.descriptor.id,
                type: draggable.descriptor.type,
                source,
                reason,
                mode: state.movementMode,
                destination,
                combine
            };
            const newHomeClientOffset = getNewHomeClientOffset({
                impact,
                draggable,
                dimensions,
                viewport: state.viewport,
                afterCritical: state.afterCritical
            });
            const completed = {
                critical: state.critical,
                afterCritical: state.afterCritical,
                result,
                impact
            };
            const isAnimationRequired = !isEqual$1(state.current.client.offset, newHomeClientOffset) || Boolean(result.combine);
            if (!isAnimationRequired) {
                dispatch(completeDrop({
                    completed
                }));
                return;
            }
            const dropDuration = getDropDuration({
                current: state.current.client.offset,
                destination: newHomeClientOffset,
                reason
            });
            const args = {
                newHomeClientOffset,
                dropDuration,
                completed
            };
            dispatch(animateDrop(args));
        };
var getWindowScroll = ()=>({
        x: window.pageXOffset,
        y: window.pageYOffset
    });
function getWindowScrollBinding(update) {
    return {
        eventName: 'scroll',
        options: {
            passive: true,
            capture: false
        },
        fn: (event)=>{
            if (event.target !== window && event.target !== window.document) return;
            update();
        }
    };
}
function getScrollListener({ onWindowScroll }) {
    function updateScroll() {
        onWindowScroll(getWindowScroll());
    }
    const scheduled = (0, _rafSchdDefault.default)(updateScroll);
    const binding = getWindowScrollBinding(scheduled);
    let unbind = noop$2;
    function isActive() {
        return unbind !== noop$2;
    }
    function start() {
        !!isActive() && invariant();
        unbind = bindEvents(window, [
            binding
        ]);
    }
    function stop() {
        !isActive() && invariant();
        scheduled.cancel();
        unbind();
        unbind = noop$2;
    }
    return {
        start,
        stop,
        isActive
    };
}
const shouldStop$1 = (action)=>guard(action, 'DROP_COMPLETE') || guard(action, 'DROP_ANIMATE') || guard(action, 'FLUSH');
const scrollListener = (store)=>{
    const listener = getScrollListener({
        onWindowScroll: (newScroll)=>{
            store.dispatch(moveByWindowScroll({
                newScroll
            }));
        }
    });
    return (next)=>(action)=>{
            if (!listener.isActive() && guard(action, 'INITIAL_PUBLISH')) listener.start();
            if (listener.isActive() && shouldStop$1(action)) listener.stop();
            next(action);
        };
};
var getExpiringAnnounce = (announce)=>{
    let wasCalled = false;
    let isExpired = false;
    const timeoutId = setTimeout(()=>{
        isExpired = true;
    });
    const result = (message)=>{
        if (wasCalled) return;
        if (isExpired) return;
        wasCalled = true;
        announce(message);
        clearTimeout(timeoutId);
    };
    result.wasCalled = ()=>wasCalled;
    return result;
};
var getAsyncMarshal = ()=>{
    const entries = [];
    const execute = (timerId)=>{
        const index = entries.findIndex((item)=>item.timerId === timerId);
        !(index !== -1) && invariant();
        const [entry] = entries.splice(index, 1);
        entry.callback();
    };
    const add = (fn)=>{
        const timerId = setTimeout(()=>execute(timerId));
        const entry = {
            timerId,
            callback: fn
        };
        entries.push(entry);
    };
    const flush = ()=>{
        if (!entries.length) return;
        const shallow = [
            ...entries
        ];
        entries.length = 0;
        shallow.forEach((entry)=>{
            clearTimeout(entry.timerId);
            entry.callback();
        });
    };
    return {
        add,
        flush
    };
};
const areLocationsEqual = (first, second)=>{
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.droppableId === second.droppableId && first.index === second.index;
};
const isCombineEqual = (first, second)=>{
    if (first == null && second == null) return true;
    if (first == null || second == null) return false;
    return first.draggableId === second.draggableId && first.droppableId === second.droppableId;
};
const isCriticalEqual = (first, second)=>{
    if (first === second) return true;
    const isDraggableEqual = first.draggable.id === second.draggable.id && first.draggable.droppableId === second.draggable.droppableId && first.draggable.type === second.draggable.type && first.draggable.index === second.draggable.index;
    const isDroppableEqual = first.droppable.id === second.droppable.id && first.droppable.type === second.droppable.type;
    return isDraggableEqual && isDroppableEqual;
};
const withTimings = (key, fn)=>{
    start();
    fn();
    finish();
};
const getDragStart = (critical, mode)=>({
        draggableId: critical.draggable.id,
        type: critical.droppable.type,
        source: {
            droppableId: critical.droppable.id,
            index: critical.draggable.index
        },
        mode
    });
function execute(responder, data, announce, getDefaultMessage) {
    if (!responder) {
        announce(getDefaultMessage(data));
        return;
    }
    const willExpire = getExpiringAnnounce(announce);
    const provided = {
        announce: willExpire
    };
    responder(data, provided);
    if (!willExpire.wasCalled()) announce(getDefaultMessage(data));
}
var getPublisher = (getResponders, announce)=>{
    const asyncMarshal = getAsyncMarshal();
    let dragging = null;
    const beforeCapture = (draggableId, mode)=>{
        !!dragging && invariant();
        withTimings('onBeforeCapture', ()=>{
            const fn = getResponders().onBeforeCapture;
            if (fn) {
                const before = {
                    draggableId,
                    mode
                };
                fn(before);
            }
        });
    };
    const beforeStart = (critical, mode)=>{
        !!dragging && invariant();
        withTimings('onBeforeDragStart', ()=>{
            const fn = getResponders().onBeforeDragStart;
            if (fn) fn(getDragStart(critical, mode));
        });
    };
    const start = (critical, mode)=>{
        !!dragging && invariant();
        const data = getDragStart(critical, mode);
        dragging = {
            mode,
            lastCritical: critical,
            lastLocation: data.source,
            lastCombine: null
        };
        asyncMarshal.add(()=>{
            withTimings('onDragStart', ()=>execute(getResponders().onDragStart, data, announce, preset.onDragStart));
        });
    };
    const update = (critical, impact)=>{
        const location = tryGetDestination(impact);
        const combine = tryGetCombine(impact);
        !dragging && invariant();
        const hasCriticalChanged = !isCriticalEqual(critical, dragging.lastCritical);
        if (hasCriticalChanged) dragging.lastCritical = critical;
        const hasLocationChanged = !areLocationsEqual(dragging.lastLocation, location);
        if (hasLocationChanged) dragging.lastLocation = location;
        const hasGroupingChanged = !isCombineEqual(dragging.lastCombine, combine);
        if (hasGroupingChanged) dragging.lastCombine = combine;
        if (!hasCriticalChanged && !hasLocationChanged && !hasGroupingChanged) return;
        const data = {
            ...getDragStart(critical, dragging.mode),
            combine,
            destination: location
        };
        asyncMarshal.add(()=>{
            withTimings('onDragUpdate', ()=>execute(getResponders().onDragUpdate, data, announce, preset.onDragUpdate));
        });
    };
    const flush = ()=>{
        !dragging && invariant();
        asyncMarshal.flush();
    };
    const drop = (result)=>{
        !dragging && invariant();
        dragging = null;
        withTimings('onDragEnd', ()=>execute(getResponders().onDragEnd, result, announce, preset.onDragEnd));
    };
    const abort = ()=>{
        if (!dragging) return;
        const result = {
            ...getDragStart(dragging.lastCritical, dragging.mode),
            combine: null,
            destination: null,
            reason: 'CANCEL'
        };
        drop(result);
    };
    return {
        beforeCapture,
        beforeStart,
        start,
        update,
        flush,
        drop,
        abort
    };
};
var responders = (getResponders, announce)=>{
    const publisher = getPublisher(getResponders, announce);
    return (store)=>(next)=>(action)=>{
                if (guard(action, 'BEFORE_INITIAL_CAPTURE')) {
                    publisher.beforeCapture(action.payload.draggableId, action.payload.movementMode);
                    return;
                }
                if (guard(action, 'INITIAL_PUBLISH')) {
                    const critical = action.payload.critical;
                    publisher.beforeStart(critical, action.payload.movementMode);
                    next(action);
                    publisher.start(critical, action.payload.movementMode);
                    return;
                }
                if (guard(action, 'DROP_COMPLETE')) {
                    const result = action.payload.completed.result;
                    publisher.flush();
                    next(action);
                    publisher.drop(result);
                    return;
                }
                next(action);
                if (guard(action, 'FLUSH')) {
                    publisher.abort();
                    return;
                }
                const state = store.getState();
                if (state.phase === 'DRAGGING') publisher.update(state.critical, state.impact);
            };
};
const dropAnimationFinishMiddleware = (store)=>(next)=>(action)=>{
            if (!guard(action, 'DROP_ANIMATION_FINISHED')) {
                next(action);
                return;
            }
            const state = store.getState();
            !(state.phase === 'DROP_ANIMATING') && invariant();
            store.dispatch(completeDrop({
                completed: state.completed
            }));
        };
const dropAnimationFlushOnScrollMiddleware = (store)=>{
    let unbind = null;
    let frameId = null;
    function clear() {
        if (frameId) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (unbind) {
            unbind();
            unbind = null;
        }
    }
    return (next)=>(action)=>{
            if (guard(action, 'FLUSH') || guard(action, 'DROP_COMPLETE') || guard(action, 'DROP_ANIMATION_FINISHED')) clear();
            next(action);
            if (!guard(action, 'DROP_ANIMATE')) return;
            const binding = {
                eventName: 'scroll',
                options: {
                    capture: true,
                    passive: false,
                    once: true
                },
                fn: function flushDropAnimation() {
                    const state = store.getState();
                    if (state.phase === 'DROP_ANIMATING') store.dispatch(dropAnimationFinished());
                }
            };
            frameId = requestAnimationFrame(()=>{
                frameId = null;
                unbind = bindEvents(window, [
                    binding
                ]);
            });
        };
};
var dimensionMarshalStopper = (marshal)=>()=>(next)=>(action)=>{
                if (guard(action, 'DROP_COMPLETE') || guard(action, 'FLUSH') || guard(action, 'DROP_ANIMATE')) marshal.stopPublishing();
                next(action);
            };
var focus = (marshal)=>{
    let isWatching = false;
    return ()=>(next)=>(action)=>{
                if (guard(action, 'INITIAL_PUBLISH')) {
                    isWatching = true;
                    marshal.tryRecordFocus(action.payload.critical.draggable.id);
                    next(action);
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                next(action);
                if (!isWatching) return;
                if (guard(action, 'FLUSH')) {
                    isWatching = false;
                    marshal.tryRestoreFocusRecorded();
                    return;
                }
                if (guard(action, 'DROP_COMPLETE')) {
                    isWatching = false;
                    const result = action.payload.completed.result;
                    if (result.combine) marshal.tryShiftRecord(result.draggableId, result.combine.draggableId);
                    marshal.tryRestoreFocusRecorded();
                }
            };
};
const shouldStop = (action)=>guard(action, 'DROP_COMPLETE') || guard(action, 'DROP_ANIMATE') || guard(action, 'FLUSH');
var autoScroll = (autoScroller)=>(store)=>(next)=>(action)=>{
                if (shouldStop(action)) {
                    autoScroller.stop();
                    next(action);
                    return;
                }
                if (guard(action, 'INITIAL_PUBLISH')) {
                    next(action);
                    const state = store.getState();
                    !(state.phase === 'DRAGGING') && invariant();
                    autoScroller.start(state);
                    return;
                }
                next(action);
                autoScroller.scroll(store.getState());
            };
const pendingDrop = (store)=>(next)=>(action)=>{
            next(action);
            if (!guard(action, 'PUBLISH_WHILE_DRAGGING')) return;
            const postActionState = store.getState();
            if (postActionState.phase !== 'DROP_PENDING') return;
            if (postActionState.isWaiting) return;
            store.dispatch(drop({
                reason: postActionState.reason
            }));
        };
const composeEnhancers = (0, _redux.compose);
var createStore = ({ dimensionMarshal, focusMarshal, styleMarshal, getResponders, announce, autoScroller })=>(0, _redux.createStore)(reducer, composeEnhancers((0, _redux.applyMiddleware)(style(styleMarshal), dimensionMarshalStopper(dimensionMarshal), lift(dimensionMarshal), dropMiddleware, dropAnimationFinishMiddleware, dropAnimationFlushOnScrollMiddleware, pendingDrop, autoScroll(autoScroller), scrollListener, focus(focusMarshal), responders(getResponders, announce))));
const clean$1 = ()=>({
        additions: {},
        removals: {},
        modified: {}
    });
function createPublisher({ registry, callbacks }) {
    let staging = clean$1();
    let frameId = null;
    const collect = ()=>{
        if (frameId) return;
        callbacks.collectionStarting();
        frameId = requestAnimationFrame(()=>{
            frameId = null;
            start();
            const { additions, removals, modified } = staging;
            const added = Object.keys(additions).map((id)=>registry.draggable.getById(id).getDimension(origin)).sort((a, b)=>a.descriptor.index - b.descriptor.index);
            const updated = Object.keys(modified).map((id)=>{
                const entry = registry.droppable.getById(id);
                const scroll = entry.callbacks.getScrollWhileDragging();
                return {
                    droppableId: id,
                    scroll
                };
            });
            const result = {
                additions: added,
                removals: Object.keys(removals),
                modified: updated
            };
            staging = clean$1();
            finish();
            callbacks.publish(result);
        });
    };
    const add = (entry)=>{
        const id = entry.descriptor.id;
        staging.additions[id] = entry;
        staging.modified[entry.descriptor.droppableId] = true;
        if (staging.removals[id]) delete staging.removals[id];
        collect();
    };
    const remove = (entry)=>{
        const descriptor = entry.descriptor;
        staging.removals[descriptor.id] = true;
        staging.modified[descriptor.droppableId] = true;
        if (staging.additions[descriptor.id]) delete staging.additions[descriptor.id];
        collect();
    };
    const stop = ()=>{
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
        staging = clean$1();
    };
    return {
        add,
        remove,
        stop
    };
}
var getMaxScroll = ({ scrollHeight, scrollWidth, height, width })=>{
    const maxScroll = subtract({
        x: scrollWidth,
        y: scrollHeight
    }, {
        x: width,
        y: height
    });
    const adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};
var getDocumentElement = ()=>{
    const doc = document.documentElement;
    !doc && invariant();
    return doc;
};
var getMaxWindowScroll = ()=>{
    const doc = getDocumentElement();
    const maxScroll = getMaxScroll({
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};
var getViewport = ()=>{
    const scroll = getWindowScroll();
    const maxScroll = getMaxWindowScroll();
    const top = scroll.y;
    const left = scroll.x;
    const doc = getDocumentElement();
    const width = doc.clientWidth;
    const height = doc.clientHeight;
    const right = left + width;
    const bottom = top + height;
    const frame = (0, _cssBoxModel.getRect)({
        top,
        left,
        right,
        bottom
    });
    const viewport = {
        frame,
        scroll: {
            initial: scroll,
            current: scroll,
            max: maxScroll,
            diff: {
                value: origin,
                displacement: origin
            }
        }
    };
    return viewport;
};
var getInitialPublish = ({ critical, scrollOptions, registry })=>{
    start();
    const viewport = getViewport();
    const windowScroll = viewport.scroll.current;
    const home = critical.droppable;
    const droppables = registry.droppable.getAllByType(home.type).map((entry)=>entry.callbacks.getDimensionAndWatchScroll(windowScroll, scrollOptions));
    const draggables = registry.draggable.getAllByType(critical.draggable.type).map((entry)=>entry.getDimension(windowScroll));
    const dimensions = {
        draggables: toDraggableMap(draggables),
        droppables: toDroppableMap(droppables)
    };
    finish();
    const result = {
        dimensions,
        critical,
        viewport
    };
    return result;
};
function shouldPublishUpdate(registry, dragging, entry) {
    if (entry.descriptor.id === dragging.id) return false;
    if (entry.descriptor.type !== dragging.type) return false;
    const home = registry.droppable.getById(entry.descriptor.droppableId);
    if (home.descriptor.mode !== 'virtual') return false;
    return true;
}
var createDimensionMarshal = (registry, callbacks)=>{
    let collection = null;
    const publisher = createPublisher({
        callbacks: {
            publish: callbacks.publishWhileDragging,
            collectionStarting: callbacks.collectionStarting
        },
        registry
    });
    const updateDroppableIsEnabled = (id, isEnabled)=>{
        !registry.droppable.exists(id) && invariant();
        if (!collection) return;
        callbacks.updateDroppableIsEnabled({
            id,
            isEnabled
        });
    };
    const updateDroppableIsCombineEnabled = (id, isCombineEnabled)=>{
        if (!collection) return;
        !registry.droppable.exists(id) && invariant();
        callbacks.updateDroppableIsCombineEnabled({
            id,
            isCombineEnabled
        });
    };
    const updateDroppableScroll = (id, newScroll)=>{
        if (!collection) return;
        !registry.droppable.exists(id) && invariant();
        callbacks.updateDroppableScroll({
            id,
            newScroll
        });
    };
    const scrollDroppable = (id, change)=>{
        if (!collection) return;
        registry.droppable.getById(id).callbacks.scroll(change);
    };
    const stopPublishing = ()=>{
        if (!collection) return;
        publisher.stop();
        const home = collection.critical.droppable;
        registry.droppable.getAllByType(home.type).forEach((entry)=>entry.callbacks.dragStopped());
        collection.unsubscribe();
        collection = null;
    };
    const subscriber = (event)=>{
        !collection && invariant();
        const dragging = collection.critical.draggable;
        if (event.type === 'ADDITION') {
            if (shouldPublishUpdate(registry, dragging, event.value)) publisher.add(event.value);
        }
        if (event.type === 'REMOVAL') {
            if (shouldPublishUpdate(registry, dragging, event.value)) publisher.remove(event.value);
        }
    };
    const startPublishing = (request)=>{
        !!collection && invariant();
        const entry = registry.draggable.getById(request.draggableId);
        const home = registry.droppable.getById(entry.descriptor.droppableId);
        const critical = {
            draggable: entry.descriptor,
            droppable: home.descriptor
        };
        const unsubscribe = registry.subscribe(subscriber);
        collection = {
            critical,
            unsubscribe
        };
        return getInitialPublish({
            critical,
            registry,
            scrollOptions: request.scrollOptions
        });
    };
    const marshal = {
        updateDroppableIsEnabled,
        updateDroppableIsCombineEnabled,
        scrollDroppable,
        updateDroppableScroll,
        startPublishing,
        stopPublishing
    };
    return marshal;
};
var canStartDrag = (state, id)=>{
    if (state.phase === 'IDLE') return true;
    if (state.phase !== 'DROP_ANIMATING') return false;
    if (state.completed.result.draggableId === id) return false;
    return state.completed.result.reason === 'DROP';
};
var scrollWindow = (change)=>{
    window.scrollBy(change.x, change.y);
};
const getScrollableDroppables = memoizeOne((droppables)=>toDroppableList(droppables).filter((droppable)=>{
        if (!droppable.isEnabled) return false;
        if (!droppable.frame) return false;
        return true;
    }));
const getScrollableDroppableOver = (target, droppables)=>{
    const maybe = getScrollableDroppables(droppables).find((droppable)=>{
        !droppable.frame && invariant();
        return isPositionInFrame(droppable.frame.pageMarginBox)(target);
    }) || null;
    return maybe;
};
var getBestScrollableDroppable = ({ center, destination, droppables })=>{
    if (destination) {
        const dimension = droppables[destination];
        if (!dimension.frame) return null;
        return dimension;
    }
    const dimension = getScrollableDroppableOver(center, droppables);
    return dimension;
};
const defaultAutoScrollerOptions = {
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    maxPixelScroll: 28,
    ease: (percentage)=>percentage ** 2,
    durationDampening: {
        stopDampeningAt: 1200,
        accelerateAt: 360
    },
    disabled: false
};
var getDistanceThresholds = (container, axis, getAutoScrollerOptions = ()=>defaultAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    const startScrollingFrom = container[axis.size] * autoScrollerOptions.startFromPercentage;
    const maxScrollValueAt = container[axis.size] * autoScrollerOptions.maxScrollAtPercentage;
    const thresholds = {
        startScrollingFrom,
        maxScrollValueAt
    };
    return thresholds;
};
var getPercentage = ({ startOfRange, endOfRange, current })=>{
    const range = endOfRange - startOfRange;
    if (range === 0) return 0;
    const currentInRange = current - startOfRange;
    const percentage = currentInRange / range;
    return percentage;
};
var minScroll = 1;
var getValueFromDistance = (distanceToEdge, thresholds, getAutoScrollerOptions = ()=>defaultAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    if (distanceToEdge <= thresholds.maxScrollValueAt) return autoScrollerOptions.maxPixelScroll;
    if (distanceToEdge === thresholds.startScrollingFrom) return minScroll;
    const percentageFromMaxScrollValueAt = getPercentage({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    const scroll = autoScrollerOptions.maxPixelScroll * autoScrollerOptions.ease(percentageFromStartScrollingFrom);
    return Math.ceil(scroll);
};
var dampenValueByTime = (proposedScroll, dragStartTime, getAutoScrollerOptions)=>{
    const autoScrollerOptions = getAutoScrollerOptions();
    const accelerateAt = autoScrollerOptions.durationDampening.accelerateAt;
    const stopAt = autoScrollerOptions.durationDampening.stopDampeningAt;
    const startOfRange = dragStartTime;
    const endOfRange = stopAt;
    const now = Date.now();
    const runTime = now - startOfRange;
    if (runTime >= stopAt) return proposedScroll;
    if (runTime < accelerateAt) return minScroll;
    const betweenAccelerateAtAndStopAtPercentage = getPercentage({
        startOfRange: accelerateAt,
        endOfRange,
        current: runTime
    });
    const scroll = proposedScroll * autoScrollerOptions.ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};
var getValue = ({ distanceToEdge, thresholds, dragStartTime, shouldUseTimeDampening, getAutoScrollerOptions })=>{
    const scroll = getValueFromDistance(distanceToEdge, thresholds, getAutoScrollerOptions);
    if (scroll === 0) return 0;
    if (!shouldUseTimeDampening) return scroll;
    return Math.max(dampenValueByTime(scroll, dragStartTime, getAutoScrollerOptions), minScroll);
};
var getScrollOnAxis = ({ container, distanceToEdges, dragStartTime, axis, shouldUseTimeDampening, getAutoScrollerOptions })=>{
    const thresholds = getDistanceThresholds(container, axis, getAutoScrollerOptions);
    const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return getValue({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds,
        dragStartTime,
        shouldUseTimeDampening,
        getAutoScrollerOptions
    });
    return -1 * getValue({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds,
        dragStartTime,
        shouldUseTimeDampening,
        getAutoScrollerOptions
    });
};
var adjustForSizeLimits = ({ container, subject, proposedScroll })=>{
    const isTooBigVertically = subject.height > container.height;
    const isTooBigHorizontally = subject.width > container.width;
    if (!isTooBigHorizontally && !isTooBigVertically) return proposedScroll;
    if (isTooBigHorizontally && isTooBigVertically) return null;
    return {
        x: isTooBigHorizontally ? 0 : proposedScroll.x,
        y: isTooBigVertically ? 0 : proposedScroll.y
    };
};
const clean = apply((value)=>value === 0 ? 0 : value);
var getScroll$1 = ({ dragStartTime, container, subject, center, shouldUseTimeDampening, getAutoScrollerOptions })=>{
    const distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    const y = getScrollOnAxis({
        container,
        distanceToEdges,
        dragStartTime,
        axis: vertical,
        shouldUseTimeDampening,
        getAutoScrollerOptions
    });
    const x = getScrollOnAxis({
        container,
        distanceToEdges,
        dragStartTime,
        axis: horizontal,
        shouldUseTimeDampening,
        getAutoScrollerOptions
    });
    const required = clean({
        x,
        y
    });
    if (isEqual$1(required, origin)) return null;
    const limited = adjustForSizeLimits({
        container,
        subject,
        proposedScroll: required
    });
    if (!limited) return null;
    return isEqual$1(limited, origin) ? null : limited;
};
const smallestSigned = apply((value)=>{
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
const getOverlap = (()=>{
    const getRemainder = (target, max)=>{
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return ({ current, max, change })=>{
        const targetScroll = add(current, change);
        const overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if (isEqual$1(overlap, origin)) return null;
        return overlap;
    };
})();
const canPartiallyScroll = ({ max: rawMax, current, change })=>{
    const max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    const smallestChange = smallestSigned(change);
    const overlap = getOverlap({
        max,
        current,
        change: smallestChange
    });
    if (!overlap) return true;
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
const canScrollWindow = (viewport, change)=>canPartiallyScroll({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change
    });
const getWindowOverlap = (viewport, change)=>{
    if (!canScrollWindow(viewport, change)) return null;
    const max = viewport.scroll.max;
    const current = viewport.scroll.current;
    return getOverlap({
        current,
        max,
        change
    });
};
const canScrollDroppable = (droppable, change)=>{
    const frame = droppable.frame;
    if (!frame) return false;
    return canPartiallyScroll({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change
    });
};
const getDroppableOverlap = (droppable, change)=>{
    const frame = droppable.frame;
    if (!frame) return null;
    if (!canScrollDroppable(droppable, change)) return null;
    return getOverlap({
        current: frame.scroll.current,
        max: frame.scroll.max,
        change
    });
};
var getWindowScrollChange = ({ viewport, subject, center, dragStartTime, shouldUseTimeDampening, getAutoScrollerOptions })=>{
    const scroll = getScroll$1({
        dragStartTime,
        container: viewport.frame,
        subject,
        center,
        shouldUseTimeDampening,
        getAutoScrollerOptions
    });
    return scroll && canScrollWindow(viewport, scroll) ? scroll : null;
};
var getDroppableScrollChange = ({ droppable, subject, center, dragStartTime, shouldUseTimeDampening, getAutoScrollerOptions })=>{
    const frame = droppable.frame;
    if (!frame) return null;
    const scroll = getScroll$1({
        dragStartTime,
        container: frame.pageMarginBox,
        subject,
        center,
        shouldUseTimeDampening,
        getAutoScrollerOptions
    });
    return scroll && canScrollDroppable(droppable, scroll) ? scroll : null;
};
var scroll = ({ state, dragStartTime, shouldUseTimeDampening, scrollWindow, scrollDroppable, getAutoScrollerOptions })=>{
    const center = state.current.page.borderBoxCenter;
    const draggable = state.dimensions.draggables[state.critical.draggable.id];
    const subject = draggable.page.marginBox;
    if (state.isWindowScrollAllowed) {
        const viewport = state.viewport;
        const change = getWindowScrollChange({
            dragStartTime,
            viewport,
            subject,
            center,
            shouldUseTimeDampening,
            getAutoScrollerOptions
        });
        if (change) {
            scrollWindow(change);
            return;
        }
    }
    const droppable = getBestScrollableDroppable({
        center,
        destination: whatIsDraggedOver(state.impact),
        droppables: state.dimensions.droppables
    });
    if (!droppable) return;
    const change = getDroppableScrollChange({
        dragStartTime,
        droppable,
        subject,
        center,
        shouldUseTimeDampening,
        getAutoScrollerOptions
    });
    if (change) scrollDroppable(droppable.descriptor.id, change);
};
var createFluidScroller = ({ scrollWindow, scrollDroppable, getAutoScrollerOptions = ()=>defaultAutoScrollerOptions })=>{
    const scheduleWindowScroll = (0, _rafSchdDefault.default)(scrollWindow);
    const scheduleDroppableScroll = (0, _rafSchdDefault.default)(scrollDroppable);
    let dragging = null;
    const tryScroll = (state)=>{
        !dragging && invariant();
        const { shouldUseTimeDampening, dragStartTime } = dragging;
        scroll({
            state,
            scrollWindow: scheduleWindowScroll,
            scrollDroppable: scheduleDroppableScroll,
            dragStartTime,
            shouldUseTimeDampening,
            getAutoScrollerOptions
        });
    };
    const start$1 = (state)=>{
        start();
        !!dragging && invariant();
        const dragStartTime = Date.now();
        let wasScrollNeeded = false;
        const fakeScrollCallback = ()=>{
            wasScrollNeeded = true;
        };
        scroll({
            state,
            dragStartTime: 0,
            shouldUseTimeDampening: false,
            scrollWindow: fakeScrollCallback,
            scrollDroppable: fakeScrollCallback,
            getAutoScrollerOptions
        });
        dragging = {
            dragStartTime,
            shouldUseTimeDampening: wasScrollNeeded
        };
        finish();
        if (wasScrollNeeded) tryScroll(state);
    };
    const stop = ()=>{
        if (!dragging) return;
        scheduleWindowScroll.cancel();
        scheduleDroppableScroll.cancel();
        dragging = null;
    };
    return {
        start: start$1,
        stop,
        scroll: tryScroll
    };
};
var createJumpScroller = ({ move, scrollDroppable, scrollWindow })=>{
    const moveByOffset = (state, offset)=>{
        const client = add(state.current.client.selection, offset);
        move({
            client
        });
    };
    const scrollDroppableAsMuchAsItCan = (droppable, change)=>{
        if (!canScrollDroppable(droppable, change)) return change;
        const overlap = getDroppableOverlap(droppable, change);
        if (!overlap) {
            scrollDroppable(droppable.descriptor.id, change);
            return null;
        }
        const whatTheDroppableCanScroll = subtract(change, overlap);
        scrollDroppable(droppable.descriptor.id, whatTheDroppableCanScroll);
        const remainder = subtract(change, whatTheDroppableCanScroll);
        return remainder;
    };
    const scrollWindowAsMuchAsItCan = (isWindowScrollAllowed, viewport, change)=>{
        if (!isWindowScrollAllowed) return change;
        if (!canScrollWindow(viewport, change)) return change;
        const overlap = getWindowOverlap(viewport, change);
        if (!overlap) {
            scrollWindow(change);
            return null;
        }
        const whatTheWindowCanScroll = subtract(change, overlap);
        scrollWindow(whatTheWindowCanScroll);
        const remainder = subtract(change, whatTheWindowCanScroll);
        return remainder;
    };
    const jumpScroller = (state)=>{
        const request = state.scrollJumpRequest;
        if (!request) return;
        const destination = whatIsDraggedOver(state.impact);
        !destination && invariant();
        const droppableRemainder = scrollDroppableAsMuchAsItCan(state.dimensions.droppables[destination], request);
        if (!droppableRemainder) return;
        const viewport = state.viewport;
        const windowRemainder = scrollWindowAsMuchAsItCan(state.isWindowScrollAllowed, viewport, droppableRemainder);
        if (!windowRemainder) return;
        moveByOffset(state, windowRemainder);
    };
    return jumpScroller;
};
var createAutoScroller = ({ scrollDroppable, scrollWindow, move, getAutoScrollerOptions })=>{
    const fluidScroller = createFluidScroller({
        scrollWindow,
        scrollDroppable,
        getAutoScrollerOptions
    });
    const jumpScroll = createJumpScroller({
        move,
        scrollWindow,
        scrollDroppable
    });
    const scroll = (state)=>{
        const autoScrollerOptions = getAutoScrollerOptions();
        if (autoScrollerOptions.disabled || state.phase !== 'DRAGGING') return;
        if (state.movementMode === 'FLUID') {
            fluidScroller.scroll(state);
            return;
        }
        if (!state.scrollJumpRequest) return;
        jumpScroll(state);
    };
    const scroller = {
        scroll,
        start: fluidScroller.start,
        stop: fluidScroller.stop
    };
    return scroller;
};
const prefix = 'data-rfd';
const dragHandle = (()=>{
    const base = `${prefix}-drag-handle`;
    return {
        base,
        draggableId: `${base}-draggable-id`,
        contextId: `${base}-context-id`
    };
})();
const draggable = (()=>{
    const base = `${prefix}-draggable`;
    return {
        base,
        contextId: `${base}-context-id`,
        id: `${base}-id`
    };
})();
const droppable = (()=>{
    const base = `${prefix}-droppable`;
    return {
        base,
        contextId: `${base}-context-id`,
        id: `${base}-id`
    };
})();
const scrollContainer = {
    contextId: `${prefix}-scroll-container-context-id`
};
const makeGetSelector = (context)=>(attribute)=>`[${attribute}="${context}"]`;
const getStyles = (rules, property)=>rules.map((rule)=>{
        const value = rule.styles[property];
        if (!value) return '';
        return `${rule.selector} { ${value} }`;
    }).join(' ');
const noPointerEvents = 'pointer-events: none;';
var getStyles$1 = (contextId)=>{
    const getSelector = makeGetSelector(contextId);
    const dragHandle$1 = (()=>{
        const grabCursor = `
      cursor: -webkit-grab;
      cursor: grab;
    `;
        return {
            selector: getSelector(dragHandle.contextId),
            styles: {
                always: `
          -webkit-touch-callout: none;
          -webkit-tap-highlight-color: rgba(0,0,0,0);
          touch-action: manipulation;
        `,
                resting: grabCursor,
                dragging: noPointerEvents,
                dropAnimating: grabCursor
            }
        };
    })();
    const draggable$1 = (()=>{
        const transition = `
      transition: ${transitions.outOfTheWay};
    `;
        return {
            selector: getSelector(draggable.contextId),
            styles: {
                dragging: transition,
                dropAnimating: transition,
                userCancel: transition
            }
        };
    })();
    const droppable$1 = {
        selector: getSelector(droppable.contextId),
        styles: {
            always: `overflow-anchor: none;`
        }
    };
    const body = {
        selector: 'body',
        styles: {
            dragging: `
        cursor: grabbing;
        cursor: -webkit-grabbing;
        user-select: none;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        overflow-anchor: none;
      `
        }
    };
    const rules = [
        draggable$1,
        dragHandle$1,
        droppable$1,
        body
    ];
    return {
        always: getStyles(rules, 'always'),
        resting: getStyles(rules, 'resting'),
        dragging: getStyles(rules, 'dragging'),
        dropAnimating: getStyles(rules, 'dropAnimating'),
        userCancel: getStyles(rules, 'userCancel')
    };
};
const useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, _react.useLayoutEffect) : (0, _react.useEffect);
const getHead = ()=>{
    const head = document.querySelector('head');
    !head && invariant();
    return head;
};
const createStyleEl = (nonce)=>{
    const el = document.createElement('style');
    if (nonce) el.setAttribute('nonce', nonce);
    el.type = 'text/css';
    return el;
};
function useStyleMarshal(contextId, nonce) {
    const styles = useMemo(()=>getStyles$1(contextId), [
        contextId
    ]);
    const alwaysRef = (0, _react.useRef)(null);
    const dynamicRef = (0, _react.useRef)(null);
    const setDynamicStyle = useCallback(memoizeOne((proposed)=>{
        const el = dynamicRef.current;
        !el && invariant();
        el.textContent = proposed;
    }), []);
    const setAlwaysStyle = useCallback((proposed)=>{
        const el = alwaysRef.current;
        !el && invariant();
        el.textContent = proposed;
    }, []);
    useIsomorphicLayoutEffect(()=>{
        !(!alwaysRef.current && !dynamicRef.current) && invariant();
        const always = createStyleEl(nonce);
        const dynamic = createStyleEl(nonce);
        alwaysRef.current = always;
        dynamicRef.current = dynamic;
        always.setAttribute(`${prefix}-always`, contextId);
        dynamic.setAttribute(`${prefix}-dynamic`, contextId);
        getHead().appendChild(always);
        getHead().appendChild(dynamic);
        setAlwaysStyle(styles.always);
        setDynamicStyle(styles.resting);
        return ()=>{
            const remove = (ref)=>{
                const current = ref.current;
                !current && invariant();
                getHead().removeChild(current);
                ref.current = null;
            };
            remove(alwaysRef);
            remove(dynamicRef);
        };
    }, [
        nonce,
        setAlwaysStyle,
        setDynamicStyle,
        styles.always,
        styles.resting,
        contextId
    ]);
    const dragging = useCallback(()=>setDynamicStyle(styles.dragging), [
        setDynamicStyle,
        styles.dragging
    ]);
    const dropping = useCallback((reason)=>{
        if (reason === 'DROP') {
            setDynamicStyle(styles.dropAnimating);
            return;
        }
        setDynamicStyle(styles.userCancel);
    }, [
        setDynamicStyle,
        styles.dropAnimating,
        styles.userCancel
    ]);
    const resting = useCallback(()=>{
        if (!dynamicRef.current) return;
        setDynamicStyle(styles.resting);
    }, [
        setDynamicStyle,
        styles.resting
    ]);
    const marshal = useMemo(()=>({
            dragging,
            dropping,
            resting
        }), [
        dragging,
        dropping,
        resting
    ]);
    return marshal;
}
function querySelectorAll(parentNode, selector) {
    return Array.from(parentNode.querySelectorAll(selector));
}
var getWindowFromEl = (el)=>{
    if (el && el.ownerDocument && el.ownerDocument.defaultView) return el.ownerDocument.defaultView;
    return window;
};
function isHtmlElement(el) {
    return el instanceof getWindowFromEl(el).HTMLElement;
}
function findDragHandle(contextId, draggableId) {
    const selector = `[${dragHandle.contextId}="${contextId}"]`;
    const possible = querySelectorAll(document, selector);
    if (!possible.length) return null;
    const handle = possible.find((el)=>{
        return el.getAttribute(dragHandle.draggableId) === draggableId;
    });
    if (!handle) return null;
    if (!isHtmlElement(handle)) return null;
    return handle;
}
function useFocusMarshal(contextId) {
    const entriesRef = (0, _react.useRef)({});
    const recordRef = (0, _react.useRef)(null);
    const restoreFocusFrameRef = (0, _react.useRef)(null);
    const isMountedRef = (0, _react.useRef)(false);
    const register = useCallback(function register(id, focus) {
        const entry = {
            id,
            focus
        };
        entriesRef.current[id] = entry;
        return function unregister() {
            const entries = entriesRef.current;
            const current = entries[id];
            if (current !== entry) delete entries[id];
        };
    }, []);
    const tryGiveFocus = useCallback(function tryGiveFocus(tryGiveFocusTo) {
        const handle = findDragHandle(contextId, tryGiveFocusTo);
        if (handle && handle !== document.activeElement) handle.focus();
    }, [
        contextId
    ]);
    const tryShiftRecord = useCallback(function tryShiftRecord(previous, redirectTo) {
        if (recordRef.current === previous) recordRef.current = redirectTo;
    }, []);
    const tryRestoreFocusRecorded = useCallback(function tryRestoreFocusRecorded() {
        if (restoreFocusFrameRef.current) return;
        if (!isMountedRef.current) return;
        restoreFocusFrameRef.current = requestAnimationFrame(()=>{
            restoreFocusFrameRef.current = null;
            const record = recordRef.current;
            if (record) tryGiveFocus(record);
        });
    }, [
        tryGiveFocus
    ]);
    const tryRecordFocus = useCallback(function tryRecordFocus(id) {
        recordRef.current = null;
        const focused = document.activeElement;
        if (!focused) return;
        if (focused.getAttribute(dragHandle.draggableId) !== id) return;
        recordRef.current = id;
    }, []);
    useIsomorphicLayoutEffect(()=>{
        isMountedRef.current = true;
        return function clearFrameOnUnmount() {
            isMountedRef.current = false;
            const frameId = restoreFocusFrameRef.current;
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, []);
    const marshal = useMemo(()=>({
            register,
            tryRecordFocus,
            tryRestoreFocusRecorded,
            tryShiftRecord
        }), [
        register,
        tryRecordFocus,
        tryRestoreFocusRecorded,
        tryShiftRecord
    ]);
    return marshal;
}
function createRegistry() {
    const entries = {
        draggables: {},
        droppables: {}
    };
    const subscribers = [];
    function subscribe(cb) {
        subscribers.push(cb);
        return function unsubscribe() {
            const index = subscribers.indexOf(cb);
            if (index === -1) return;
            subscribers.splice(index, 1);
        };
    }
    function notify(event) {
        if (subscribers.length) subscribers.forEach((cb)=>cb(event));
    }
    function findDraggableById(id) {
        return entries.draggables[id] || null;
    }
    function getDraggableById(id) {
        const entry = findDraggableById(id);
        !entry && invariant();
        return entry;
    }
    const draggableAPI = {
        register: (entry)=>{
            entries.draggables[entry.descriptor.id] = entry;
            notify({
                type: 'ADDITION',
                value: entry
            });
        },
        update: (entry, last)=>{
            const current = entries.draggables[last.descriptor.id];
            if (!current) return;
            if (current.uniqueId !== entry.uniqueId) return;
            delete entries.draggables[last.descriptor.id];
            entries.draggables[entry.descriptor.id] = entry;
        },
        unregister: (entry)=>{
            const draggableId = entry.descriptor.id;
            const current = findDraggableById(draggableId);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.draggables[draggableId];
            if (entries.droppables[entry.descriptor.droppableId]) notify({
                type: 'REMOVAL',
                value: entry
            });
        },
        getById: getDraggableById,
        findById: findDraggableById,
        exists: (id)=>Boolean(findDraggableById(id)),
        getAllByType: (type)=>Object.values(entries.draggables).filter((entry)=>entry.descriptor.type === type)
    };
    function findDroppableById(id) {
        return entries.droppables[id] || null;
    }
    function getDroppableById(id) {
        const entry = findDroppableById(id);
        !entry && invariant();
        return entry;
    }
    const droppableAPI = {
        register: (entry)=>{
            entries.droppables[entry.descriptor.id] = entry;
        },
        unregister: (entry)=>{
            const current = findDroppableById(entry.descriptor.id);
            if (!current) return;
            if (entry.uniqueId !== current.uniqueId) return;
            delete entries.droppables[entry.descriptor.id];
        },
        getById: getDroppableById,
        findById: findDroppableById,
        exists: (id)=>Boolean(findDroppableById(id)),
        getAllByType: (type)=>Object.values(entries.droppables).filter((entry)=>entry.descriptor.type === type)
    };
    function clean() {
        entries.draggables = {};
        entries.droppables = {};
        subscribers.length = 0;
    }
    return {
        draggable: draggableAPI,
        droppable: droppableAPI,
        subscribe,
        clean
    };
}
function useRegistry() {
    const registry = useMemo(createRegistry, []);
    (0, _react.useEffect)(()=>{
        return function unmount() {
            registry.clean();
        };
    }, [
        registry
    ]);
    return registry;
}
var StoreContext = (0, _reactDefault.default).createContext(null);
var getBodyElement = ()=>{
    const body = document.body;
    !body && invariant();
    return body;
};
const visuallyHidden = {
    position: 'absolute',
    width: '1px',
    height: '1px',
    margin: '-1px',
    border: '0',
    padding: '0',
    overflow: 'hidden',
    clip: 'rect(0 0 0 0)',
    'clip-path': 'inset(100%)'
};
const getId = (contextId)=>`rfd-announcement-${contextId}`;
function useAnnouncer(contextId) {
    const id = useMemo(()=>getId(contextId), [
        contextId
    ]);
    const ref = (0, _react.useRef)(null);
    (0, _react.useEffect)(function setup() {
        const el = document.createElement('div');
        ref.current = el;
        el.id = id;
        el.setAttribute('aria-live', 'assertive');
        el.setAttribute('aria-atomic', 'true');
        (0, _extendsDefault.default)(el.style, visuallyHidden);
        getBodyElement().appendChild(el);
        return function cleanup() {
            setTimeout(function remove() {
                const body = getBodyElement();
                if (body.contains(el)) body.removeChild(el);
                if (el === ref.current) ref.current = null;
            });
        };
    }, [
        id
    ]);
    const announce = useCallback((message)=>{
        const el = ref.current;
        if (el) {
            el.textContent = message;
            return;
        }
    }, []);
    return announce;
}
const defaults = {
    separator: '::'
};
function useUniqueId(prefix, options = defaults) {
    const id = (0, _reactDefault.default).useId();
    return useMemo(()=>`${prefix}${options.separator}${id}`, [
        options.separator,
        prefix,
        id
    ]);
}
function getElementId({ contextId, uniqueId }) {
    return `rfd-hidden-text-${contextId}-${uniqueId}`;
}
function useHiddenTextElement({ contextId, text }) {
    const uniqueId = useUniqueId('hidden-text', {
        separator: '-'
    });
    const id = useMemo(()=>getElementId({
            contextId,
            uniqueId
        }), [
        uniqueId,
        contextId
    ]);
    (0, _react.useEffect)(function mount() {
        const el = document.createElement('div');
        el.id = id;
        el.textContent = text;
        el.style.display = 'none';
        getBodyElement().appendChild(el);
        return function unmount() {
            const body = getBodyElement();
            if (body.contains(el)) body.removeChild(el);
        };
    }, [
        id,
        text
    ]);
    return id;
}
var AppContext = (0, _reactDefault.default).createContext(null);
var peerDependencies = {
    react: "^18.0.0 || ^19.0.0"
};
const semver = /(\d+)\.(\d+)\.(\d+)/;
const getVersion = (value)=>{
    const result = semver.exec(value);
    !(result != null) && invariant();
    const major = Number(result[1]);
    const minor = Number(result[2]);
    const patch = Number(result[3]);
    return {
        major,
        minor,
        patch,
        raw: value
    };
};
const isSatisfied = (expected, actual)=>{
    if (actual.major > expected.major) return true;
    if (actual.major < expected.major) return false;
    if (actual.minor > expected.minor) return true;
    if (actual.minor < expected.minor) return false;
    return actual.patch >= expected.patch;
};
var checkReactVersion = (peerDepValue, actualValue)=>{
    const peerDep = getVersion(peerDepValue);
    const actual = getVersion(actualValue);
    if (isSatisfied(peerDep, actual)) return;
};
const suffix = `
  We expect a html5 doctype: <!doctype html>
  This is to ensure consistent browser layout and measurement

  More information: https://github.com/hello-pangea/dnd/blob/main/docs/guides/doctype.md
`;
var checkDoctype = (doc)=>{
    const doctype = doc.doctype;
    if (!doctype) return;
    doctype.name.toLowerCase();
    doctype.publicId;
};
function useDev(useHook) {}
function useDevSetupWarning(fn, inputs) {
    useDev(()=>{
        (0, _react.useEffect)(()=>{
            try {
                fn();
            } catch (e) {
                error(`
          A setup problem was encountered.

          > ${e.message}
        `);
            }
        }, inputs);
    });
}
function useStartupValidation() {
    useDevSetupWarning(()=>{
        checkReactVersion(peerDependencies.react, (0, _reactDefault.default).version);
        checkDoctype(document);
    }, []);
}
function usePrevious(current) {
    const ref = (0, _react.useRef)(current);
    (0, _react.useEffect)(()=>{
        ref.current = current;
    });
    return ref;
}
function create() {
    let lock = null;
    function isClaimed() {
        return Boolean(lock);
    }
    function isActive(value) {
        return value === lock;
    }
    function claim(abandon) {
        !!lock && invariant();
        const newLock = {
            abandon
        };
        lock = newLock;
        return newLock;
    }
    function release() {
        !lock && invariant();
        lock = null;
    }
    function tryAbandon() {
        if (lock) {
            lock.abandon();
            release();
        }
    }
    return {
        isClaimed,
        isActive,
        claim,
        release,
        tryAbandon
    };
}
function isDragging(state) {
    if (state.phase === 'IDLE' || state.phase === 'DROP_ANIMATING') return false;
    return state.isDragging;
}
const tab = 9;
const enter = 13;
const escape = 27;
const space = 32;
const pageUp = 33;
const pageDown = 34;
const end = 35;
const home = 36;
const arrowLeft = 37;
const arrowUp = 38;
const arrowRight = 39;
const arrowDown = 40;
const preventedKeys = {
    [enter]: true,
    [tab]: true
};
var preventStandardKeyEvents = (event)=>{
    if (preventedKeys[event.keyCode]) event.preventDefault();
};
const supportedEventName = (()=>{
    const base = 'visibilitychange';
    if (typeof document === 'undefined') return base;
    const candidates = [
        base,
        `ms${base}`,
        `webkit${base}`,
        `moz${base}`,
        `o${base}`
    ];
    const supported = candidates.find((eventName)=>`on${eventName}` in document);
    return supported || base;
})();
const primaryButton = 0;
const sloppyClickThreshold = 5;
function isSloppyClickThresholdExceeded(original, current) {
    return Math.abs(current.x - original.x) >= sloppyClickThreshold || Math.abs(current.y - original.y) >= sloppyClickThreshold;
}
const idle$1 = {
    type: 'IDLE'
};
function getCaptureBindings({ cancel, completed, getPhase, setPhase }) {
    return [
        {
            eventName: 'mousemove',
            fn: (event)=>{
                const { button, clientX, clientY } = event;
                if (button !== primaryButton) return;
                const point = {
                    x: clientX,
                    y: clientY
                };
                const phase = getPhase();
                if (phase.type === 'DRAGGING') {
                    event.preventDefault();
                    phase.actions.move(point);
                    return;
                }
                !(phase.type === 'PENDING') && invariant();
                const pending = phase.point;
                if (!isSloppyClickThresholdExceeded(pending, point)) return;
                event.preventDefault();
                const actions = phase.actions.fluidLift(point);
                setPhase({
                    type: 'DRAGGING',
                    actions
                });
            }
        },
        {
            eventName: 'mouseup',
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'mousedown',
            fn: (event)=>{
                if (getPhase().type === 'DRAGGING') event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'keydown',
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type === 'PENDING') {
                    cancel();
                    return;
                }
                if (event.keyCode === escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'scroll',
            options: {
                passive: true,
                capture: false
            },
            fn: ()=>{
                if (getPhase().type === 'PENDING') cancel();
            }
        },
        {
            eventName: 'webkitmouseforcedown',
            fn: (event)=>{
                const phase = getPhase();
                !(phase.type !== 'IDLE') && invariant();
                if (phase.actions.shouldRespectForcePress()) {
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: supportedEventName,
            fn: cancel
        }
    ];
}
function useMouseSensor(api) {
    const phaseRef = (0, _react.useRef)(idle$1);
    const unbindEventsRef = (0, _react.useRef)(noop$2);
    const startCaptureBinding = useMemo(()=>({
            eventName: 'mousedown',
            fn: function onMouseDown(event) {
                if (event.defaultPrevented) return;
                if (event.button !== primaryButton) return;
                if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                event.preventDefault();
                const point = {
                    x: event.clientX,
                    y: event.clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        }), [
        api
    ]);
    const preventForcePressBinding = useMemo(()=>({
            eventName: 'webkitmouseforcewillbegin',
            fn: (event)=>{
                if (event.defaultPrevented) return;
                const id = api.findClosestDraggableId(event);
                if (!id) return;
                const options = api.findOptionsForDraggable(id);
                if (!options) return;
                if (options.shouldRespectForcePress) return;
                if (!api.canGetLock(id)) return;
                event.preventDefault();
            }
        }), [
        api
    ]);
    const listenForCapture = useCallback(function listenForCapture() {
        const options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = bindEvents(window, [
            preventForcePressBinding,
            startCaptureBinding
        ], options);
    }, [
        preventForcePressBinding,
        startCaptureBinding
    ]);
    const stop = useCallback(()=>{
        const current = phaseRef.current;
        if (current.type === 'IDLE') return;
        phaseRef.current = idle$1;
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture
    ]);
    const cancel = useCallback(()=>{
        const phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    const bindCapturingEvents = useCallback(function bindCapturingEvents() {
        const options = {
            capture: true,
            passive: false
        };
        const bindings = getCaptureBindings({
            cancel,
            completed: stop,
            getPhase: ()=>phaseRef.current,
            setPhase: (phase)=>{
                phaseRef.current = phase;
            }
        });
        unbindEventsRef.current = bindEvents(window, bindings, options);
    }, [
        cancel,
        stop
    ]);
    const startPendingDrag = useCallback(function startPendingDrag(actions, point) {
        !(phaseRef.current.type === 'IDLE') && invariant();
        phaseRef.current = {
            type: 'PENDING',
            point,
            actions
        };
        bindCapturingEvents();
    }, [
        bindCapturingEvents
    ]);
    useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
function noop$1() {}
const scrollJumpKeys = {
    [pageDown]: true,
    [pageUp]: true,
    [home]: true,
    [end]: true
};
function getDraggingBindings(actions, stop) {
    function cancel() {
        stop();
        actions.cancel();
    }
    function drop() {
        stop();
        actions.drop();
    }
    return [
        {
            eventName: 'keydown',
            fn: (event)=>{
                if (event.keyCode === escape) {
                    event.preventDefault();
                    cancel();
                    return;
                }
                if (event.keyCode === space) {
                    event.preventDefault();
                    drop();
                    return;
                }
                if (event.keyCode === arrowDown) {
                    event.preventDefault();
                    actions.moveDown();
                    return;
                }
                if (event.keyCode === arrowUp) {
                    event.preventDefault();
                    actions.moveUp();
                    return;
                }
                if (event.keyCode === arrowRight) {
                    event.preventDefault();
                    actions.moveRight();
                    return;
                }
                if (event.keyCode === arrowLeft) {
                    event.preventDefault();
                    actions.moveLeft();
                    return;
                }
                if (scrollJumpKeys[event.keyCode]) {
                    event.preventDefault();
                    return;
                }
                preventStandardKeyEvents(event);
            }
        },
        {
            eventName: 'mousedown',
            fn: cancel
        },
        {
            eventName: 'mouseup',
            fn: cancel
        },
        {
            eventName: 'click',
            fn: cancel
        },
        {
            eventName: 'touchstart',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'wheel',
            fn: cancel,
            options: {
                passive: true
            }
        },
        {
            eventName: supportedEventName,
            fn: cancel
        }
    ];
}
function useKeyboardSensor(api) {
    const unbindEventsRef = (0, _react.useRef)(noop$1);
    const startCaptureBinding = useMemo(()=>({
            eventName: 'keydown',
            fn: function onKeyDown(event) {
                if (event.defaultPrevented) return;
                if (event.keyCode !== space) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const preDrag = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!preDrag) return;
                event.preventDefault();
                let isCapturing = true;
                const actions = preDrag.snapLift();
                unbindEventsRef.current();
                function stop() {
                    !isCapturing && invariant();
                    isCapturing = false;
                    unbindEventsRef.current();
                    listenForCapture();
                }
                unbindEventsRef.current = bindEvents(window, getDraggingBindings(actions, stop), {
                    capture: true,
                    passive: false
                });
            }
        }), [
        api
    ]);
    const listenForCapture = useCallback(function tryStartCapture() {
        const options = {
            passive: false,
            capture: true
        };
        unbindEventsRef.current = bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
        };
    }, [
        listenForCapture
    ]);
}
const idle = {
    type: 'IDLE'
};
const timeForLongPress = 120;
const forcePressThreshold = 0.15;
function getWindowBindings({ cancel, getPhase }) {
    return [
        {
            eventName: 'orientationchange',
            fn: cancel
        },
        {
            eventName: 'resize',
            fn: cancel
        },
        {
            eventName: 'contextmenu',
            fn: (event)=>{
                event.preventDefault();
            }
        },
        {
            eventName: 'keydown',
            fn: (event)=>{
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                if (event.keyCode === escape) event.preventDefault();
                cancel();
            }
        },
        {
            eventName: supportedEventName,
            fn: cancel
        }
    ];
}
function getHandleBindings({ cancel, completed, getPhase }) {
    return [
        {
            eventName: 'touchmove',
            options: {
                capture: false
            },
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                phase.hasMoved = true;
                const { clientX, clientY } = event.touches[0];
                const point = {
                    x: clientX,
                    y: clientY
                };
                event.preventDefault();
                phase.actions.move(point);
            }
        },
        {
            eventName: 'touchend',
            fn: (event)=>{
                const phase = getPhase();
                if (phase.type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                phase.actions.drop({
                    shouldBlockNextClick: true
                });
                completed();
            }
        },
        {
            eventName: 'touchcancel',
            fn: (event)=>{
                if (getPhase().type !== 'DRAGGING') {
                    cancel();
                    return;
                }
                event.preventDefault();
                cancel();
            }
        },
        {
            eventName: 'touchforcechange',
            fn: (event)=>{
                const phase = getPhase();
                !(phase.type !== 'IDLE') && invariant();
                const touch = event.touches[0];
                if (!touch) return;
                const isForcePress = touch.force >= forcePressThreshold;
                if (!isForcePress) return;
                const shouldRespect = phase.actions.shouldRespectForcePress();
                if (phase.type === 'PENDING') {
                    if (shouldRespect) cancel();
                    return;
                }
                if (shouldRespect) {
                    if (phase.hasMoved) {
                        event.preventDefault();
                        return;
                    }
                    cancel();
                    return;
                }
                event.preventDefault();
            }
        },
        {
            eventName: supportedEventName,
            fn: cancel
        }
    ];
}
function useTouchSensor(api) {
    const phaseRef = (0, _react.useRef)(idle);
    const unbindEventsRef = (0, _react.useRef)(noop$2);
    const getPhase = useCallback(function getPhase() {
        return phaseRef.current;
    }, []);
    const setPhase = useCallback(function setPhase(phase) {
        phaseRef.current = phase;
    }, []);
    const startCaptureBinding = useMemo(()=>({
            eventName: 'touchstart',
            fn: function onTouchStart(event) {
                if (event.defaultPrevented) return;
                const draggableId = api.findClosestDraggableId(event);
                if (!draggableId) return;
                const actions = api.tryGetLock(draggableId, stop, {
                    sourceEvent: event
                });
                if (!actions) return;
                const touch = event.touches[0];
                const { clientX, clientY } = touch;
                const point = {
                    x: clientX,
                    y: clientY
                };
                unbindEventsRef.current();
                startPendingDrag(actions, point);
            }
        }), [
        api
    ]);
    const listenForCapture = useCallback(function listenForCapture() {
        const options = {
            capture: true,
            passive: false
        };
        unbindEventsRef.current = bindEvents(window, [
            startCaptureBinding
        ], options);
    }, [
        startCaptureBinding
    ]);
    const stop = useCallback(()=>{
        const current = phaseRef.current;
        if (current.type === 'IDLE') return;
        if (current.type === 'PENDING') clearTimeout(current.longPressTimerId);
        setPhase(idle);
        unbindEventsRef.current();
        listenForCapture();
    }, [
        listenForCapture,
        setPhase
    ]);
    const cancel = useCallback(()=>{
        const phase = phaseRef.current;
        stop();
        if (phase.type === 'DRAGGING') phase.actions.cancel({
            shouldBlockNextClick: true
        });
        if (phase.type === 'PENDING') phase.actions.abort();
    }, [
        stop
    ]);
    const bindCapturingEvents = useCallback(function bindCapturingEvents() {
        const options = {
            capture: true,
            passive: false
        };
        const args = {
            cancel,
            completed: stop,
            getPhase
        };
        const unbindTarget = bindEvents(window, getHandleBindings(args), options);
        const unbindWindow = bindEvents(window, getWindowBindings(args), options);
        unbindEventsRef.current = function unbindAll() {
            unbindTarget();
            unbindWindow();
        };
    }, [
        cancel,
        getPhase,
        stop
    ]);
    const startDragging = useCallback(function startDragging() {
        const phase = getPhase();
        !(phase.type === 'PENDING') && invariant();
        const actions = phase.actions.fluidLift(phase.point);
        setPhase({
            type: 'DRAGGING',
            actions,
            hasMoved: false
        });
    }, [
        getPhase,
        setPhase
    ]);
    const startPendingDrag = useCallback(function startPendingDrag(actions, point) {
        !(getPhase().type === 'IDLE') && invariant();
        const longPressTimerId = setTimeout(startDragging, timeForLongPress);
        setPhase({
            type: 'PENDING',
            point,
            actions,
            longPressTimerId
        });
        bindCapturingEvents();
    }, [
        bindCapturingEvents,
        getPhase,
        setPhase,
        startDragging
    ]);
    useIsomorphicLayoutEffect(function mount() {
        listenForCapture();
        return function unmount() {
            unbindEventsRef.current();
            const phase = getPhase();
            if (phase.type === 'PENDING') {
                clearTimeout(phase.longPressTimerId);
                setPhase(idle);
            }
        };
    }, [
        getPhase,
        listenForCapture,
        setPhase
    ]);
    useIsomorphicLayoutEffect(function webkitHack() {
        const unbind = bindEvents(window, [
            {
                eventName: 'touchmove',
                fn: ()=>{},
                options: {
                    capture: false,
                    passive: false
                }
            }
        ]);
        return unbind;
    }, []);
}
function useValidateSensorHooks(sensorHooks) {
    useDev(()=>{
        const previousRef = usePrevious(sensorHooks);
        useDevSetupWarning(()=>{
            !(previousRef.current.length === sensorHooks.length) && invariant(false);
        });
    });
}
const interactiveTagNames = [
    'input',
    'button',
    'textarea',
    'select',
    'option',
    'optgroup',
    'video',
    'audio'
];
function isAnInteractiveElement(parent, current) {
    if (current == null) return false;
    const hasAnInteractiveTag = interactiveTagNames.includes(current.tagName.toLowerCase());
    if (hasAnInteractiveTag) return true;
    const attribute = current.getAttribute('contenteditable');
    if (attribute === 'true' || attribute === '') return true;
    if (current === parent) return false;
    return isAnInteractiveElement(parent, current.parentElement);
}
function isEventInInteractiveElement(draggable, event) {
    const target = event.target;
    if (!isHtmlElement(target)) return false;
    return isAnInteractiveElement(draggable, target);
}
var getBorderBoxCenterPosition = (el)=>(0, _cssBoxModel.getRect)(el.getBoundingClientRect()).center;
function isElement(el) {
    return el instanceof getWindowFromEl(el).Element;
}
const supportedMatchesName = (()=>{
    const base = 'matches';
    if (typeof document === 'undefined') return base;
    const candidates = [
        base,
        'msMatchesSelector',
        'webkitMatchesSelector'
    ];
    const value = candidates.find((name)=>name in Element.prototype);
    return value || base;
})();
function closestPonyfill(el, selector) {
    if (el == null) return null;
    if (el[supportedMatchesName](selector)) return el;
    return closestPonyfill(el.parentElement, selector);
}
function closest(el, selector) {
    if (el.closest) return el.closest(selector);
    return closestPonyfill(el, selector);
}
function getSelector(contextId) {
    return `[${dragHandle.contextId}="${contextId}"]`;
}
function findClosestDragHandleFromEvent(contextId, event) {
    const target = event.target;
    if (!isElement(target)) return null;
    const selector = getSelector(contextId);
    const handle = closest(target, selector);
    if (!handle) return null;
    if (!isHtmlElement(handle)) return null;
    return handle;
}
function tryGetClosestDraggableIdFromEvent(contextId, event) {
    const handle = findClosestDragHandleFromEvent(contextId, event);
    if (!handle) return null;
    return handle.getAttribute(dragHandle.draggableId);
}
function findDraggable(contextId, draggableId) {
    const selector = `[${draggable.contextId}="${contextId}"]`;
    const possible = querySelectorAll(document, selector);
    const draggable$1 = possible.find((el)=>{
        return el.getAttribute(draggable.id) === draggableId;
    });
    if (!draggable$1) return null;
    if (!isHtmlElement(draggable$1)) return null;
    return draggable$1;
}
function preventDefault(event) {
    event.preventDefault();
}
function isActive({ expected, phase, isLockActive, shouldWarn }) {
    if (!isLockActive()) {
        shouldWarn;
        return false;
    }
    if (expected !== phase) {
        shouldWarn;
        return false;
    }
    return true;
}
function canStart({ lockAPI, store, registry, draggableId }) {
    if (lockAPI.isClaimed()) return false;
    const entry = registry.draggable.findById(draggableId);
    if (!entry) return false;
    if (!entry.options.isEnabled) return false;
    if (!canStartDrag(store.getState(), draggableId)) return false;
    return true;
}
function tryStart({ lockAPI, contextId, store, registry, draggableId, forceSensorStop, sourceEvent }) {
    const shouldStart = canStart({
        lockAPI,
        store,
        registry,
        draggableId
    });
    if (!shouldStart) return null;
    const entry = registry.draggable.getById(draggableId);
    const el = findDraggable(contextId, entry.descriptor.id);
    if (!el) return null;
    if (sourceEvent && !entry.options.canDragInteractiveElements && isEventInInteractiveElement(el, sourceEvent)) return null;
    const lock = lockAPI.claim(forceSensorStop || noop$2);
    let phase = 'PRE_DRAG';
    function getShouldRespectForcePress() {
        return entry.options.shouldRespectForcePress;
    }
    function isLockActive() {
        return lockAPI.isActive(lock);
    }
    function tryDispatch(expected, getAction) {
        if (isActive({
            expected,
            phase,
            isLockActive,
            shouldWarn: true
        })) store.dispatch(getAction());
    }
    const tryDispatchWhenDragging = tryDispatch.bind(null, 'DRAGGING');
    function lift(args) {
        function completed() {
            lockAPI.release();
            phase = 'COMPLETED';
        }
        if (phase !== 'PRE_DRAG') {
            completed();
            invariant();
        }
        store.dispatch(lift$1(args.liftActionArgs));
        phase = 'DRAGGING';
        function finish(reason, options = {
            shouldBlockNextClick: false
        }) {
            args.cleanup();
            if (options.shouldBlockNextClick) {
                const unbind = bindEvents(window, [
                    {
                        eventName: 'click',
                        fn: preventDefault,
                        options: {
                            once: true,
                            passive: false,
                            capture: true
                        }
                    }
                ]);
                setTimeout(unbind);
            }
            completed();
            store.dispatch(drop({
                reason
            }));
        }
        return {
            isActive: ()=>isActive({
                    expected: 'DRAGGING',
                    phase,
                    isLockActive,
                    shouldWarn: false
                }),
            shouldRespectForcePress: getShouldRespectForcePress,
            drop: (options)=>finish('DROP', options),
            cancel: (options)=>finish('CANCEL', options),
            ...args.actions
        };
    }
    function fluidLift(clientSelection) {
        const move$1 = (0, _rafSchdDefault.default)((client)=>{
            tryDispatchWhenDragging(()=>move({
                    client
                }));
        });
        const api = lift({
            liftActionArgs: {
                id: draggableId,
                clientSelection,
                movementMode: 'FLUID'
            },
            cleanup: ()=>move$1.cancel(),
            actions: {
                move: move$1
            }
        });
        return {
            ...api,
            move: move$1
        };
    }
    function snapLift() {
        const actions = {
            moveUp: ()=>tryDispatchWhenDragging(moveUp),
            moveRight: ()=>tryDispatchWhenDragging(moveRight),
            moveDown: ()=>tryDispatchWhenDragging(moveDown),
            moveLeft: ()=>tryDispatchWhenDragging(moveLeft)
        };
        return lift({
            liftActionArgs: {
                id: draggableId,
                clientSelection: getBorderBoxCenterPosition(el),
                movementMode: 'SNAP'
            },
            cleanup: noop$2,
            actions
        });
    }
    function abortPreDrag() {
        const shouldRelease = isActive({
            expected: 'PRE_DRAG',
            phase,
            isLockActive,
            shouldWarn: true
        });
        if (shouldRelease) lockAPI.release();
    }
    const preDrag = {
        isActive: ()=>isActive({
                expected: 'PRE_DRAG',
                phase,
                isLockActive,
                shouldWarn: false
            }),
        shouldRespectForcePress: getShouldRespectForcePress,
        fluidLift,
        snapLift,
        abort: abortPreDrag
    };
    return preDrag;
}
const defaultSensors = [
    useMouseSensor,
    useKeyboardSensor,
    useTouchSensor
];
function useSensorMarshal({ contextId, store, registry, customSensors, enableDefaultSensors }) {
    const useSensors = [
        ...enableDefaultSensors ? defaultSensors : [],
        ...customSensors || []
    ];
    const lockAPI = (0, _react.useState)(()=>create())[0];
    const tryAbandonLock = useCallback(function tryAbandonLock(previous, current) {
        if (isDragging(previous) && !isDragging(current)) lockAPI.tryAbandon();
    }, [
        lockAPI
    ]);
    useIsomorphicLayoutEffect(function listenToStore() {
        let previous = store.getState();
        const unsubscribe = store.subscribe(()=>{
            const current = store.getState();
            tryAbandonLock(previous, current);
            previous = current;
        });
        return unsubscribe;
    }, [
        lockAPI,
        store,
        tryAbandonLock
    ]);
    useIsomorphicLayoutEffect(()=>{
        return lockAPI.tryAbandon;
    }, [
        lockAPI.tryAbandon
    ]);
    const canGetLock = useCallback((draggableId)=>{
        return canStart({
            lockAPI,
            registry,
            store,
            draggableId
        });
    }, [
        lockAPI,
        registry,
        store
    ]);
    const tryGetLock = useCallback((draggableId, forceStop, options)=>tryStart({
            lockAPI,
            registry,
            contextId,
            store,
            draggableId,
            forceSensorStop: forceStop || null,
            sourceEvent: options && options.sourceEvent ? options.sourceEvent : null
        }), [
        contextId,
        lockAPI,
        registry,
        store
    ]);
    const findClosestDraggableId = useCallback((event)=>tryGetClosestDraggableIdFromEvent(contextId, event), [
        contextId
    ]);
    const findOptionsForDraggable = useCallback((id)=>{
        const entry = registry.draggable.findById(id);
        return entry ? entry.options : null;
    }, [
        registry.draggable
    ]);
    const tryReleaseLock = useCallback(function tryReleaseLock() {
        if (!lockAPI.isClaimed()) return;
        lockAPI.tryAbandon();
        if (store.getState().phase !== 'IDLE') store.dispatch(flush());
    }, [
        lockAPI,
        store
    ]);
    const isLockClaimed = useCallback(()=>lockAPI.isClaimed(), [
        lockAPI
    ]);
    const api = useMemo(()=>({
            canGetLock,
            tryGetLock,
            findClosestDraggableId,
            findOptionsForDraggable,
            tryReleaseLock,
            isLockClaimed
        }), [
        canGetLock,
        tryGetLock,
        findClosestDraggableId,
        findOptionsForDraggable,
        tryReleaseLock,
        isLockClaimed
    ]);
    useValidateSensorHooks(useSensors);
    for(let i = 0; i < useSensors.length; i++)useSensors[i](api);
}
const createResponders = (props)=>({
        onBeforeCapture: (t)=>{
            const onBeforeCapureCallback = ()=>{
                if (props.onBeforeCapture) props.onBeforeCapture(t);
            };
            (0, _reactDom.flushSync)(onBeforeCapureCallback);
        },
        onBeforeDragStart: props.onBeforeDragStart,
        onDragStart: props.onDragStart,
        onDragEnd: props.onDragEnd,
        onDragUpdate: props.onDragUpdate
    });
const createAutoScrollerOptions = (props)=>({
        ...defaultAutoScrollerOptions,
        ...props.autoScrollerOptions,
        durationDampening: {
            ...defaultAutoScrollerOptions.durationDampening,
            ...props.autoScrollerOptions
        }
    });
function getStore(lazyRef) {
    !lazyRef.current && invariant();
    return lazyRef.current;
}
function App(props) {
    const { contextId, setCallbacks, sensors, nonce, dragHandleUsageInstructions } = props;
    const lazyStoreRef = (0, _react.useRef)(null);
    useStartupValidation();
    const lastPropsRef = usePrevious(props);
    const getResponders = useCallback(()=>{
        return createResponders(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    const getAutoScrollerOptions = useCallback(()=>{
        return createAutoScrollerOptions(lastPropsRef.current);
    }, [
        lastPropsRef
    ]);
    const announce = useAnnouncer(contextId);
    const dragHandleUsageInstructionsId = useHiddenTextElement({
        contextId,
        text: dragHandleUsageInstructions
    });
    const styleMarshal = useStyleMarshal(contextId, nonce);
    const lazyDispatch = useCallback((action)=>{
        getStore(lazyStoreRef).dispatch(action);
    }, []);
    const marshalCallbacks = useMemo(()=>(0, _redux.bindActionCreators)({
            publishWhileDragging,
            updateDroppableScroll,
            updateDroppableIsEnabled,
            updateDroppableIsCombineEnabled,
            collectionStarting
        }, lazyDispatch), [
        lazyDispatch
    ]);
    const registry = useRegistry();
    const dimensionMarshal = useMemo(()=>{
        return createDimensionMarshal(registry, marshalCallbacks);
    }, [
        registry,
        marshalCallbacks
    ]);
    const autoScroller = useMemo(()=>createAutoScroller({
            scrollWindow,
            scrollDroppable: dimensionMarshal.scrollDroppable,
            getAutoScrollerOptions,
            ...(0, _redux.bindActionCreators)({
                move
            }, lazyDispatch)
        }), [
        dimensionMarshal.scrollDroppable,
        lazyDispatch,
        getAutoScrollerOptions
    ]);
    const focusMarshal = useFocusMarshal(contextId);
    const store = useMemo(()=>createStore({
            announce,
            autoScroller,
            dimensionMarshal,
            focusMarshal,
            getResponders,
            styleMarshal
        }), [
        announce,
        autoScroller,
        dimensionMarshal,
        focusMarshal,
        getResponders,
        styleMarshal
    ]);
    lazyStoreRef.current = store;
    const tryResetStore = useCallback(()=>{
        const current = getStore(lazyStoreRef);
        const state = current.getState();
        if (state.phase !== 'IDLE') current.dispatch(flush());
    }, []);
    const isDragging = useCallback(()=>{
        const state = getStore(lazyStoreRef).getState();
        if (state.phase === 'DROP_ANIMATING') return true;
        if (state.phase === 'IDLE') return false;
        return state.isDragging;
    }, []);
    const appCallbacks = useMemo(()=>({
            isDragging,
            tryAbort: tryResetStore
        }), [
        isDragging,
        tryResetStore
    ]);
    setCallbacks(appCallbacks);
    const getCanLift = useCallback((id)=>canStartDrag(getStore(lazyStoreRef).getState(), id), []);
    const getIsMovementAllowed = useCallback(()=>isMovementAllowed(getStore(lazyStoreRef).getState()), []);
    const appContext = useMemo(()=>({
            marshal: dimensionMarshal,
            focus: focusMarshal,
            contextId,
            canLift: getCanLift,
            isMovementAllowed: getIsMovementAllowed,
            dragHandleUsageInstructionsId,
            registry
        }), [
        contextId,
        dimensionMarshal,
        dragHandleUsageInstructionsId,
        focusMarshal,
        getCanLift,
        getIsMovementAllowed,
        registry
    ]);
    useSensorMarshal({
        contextId,
        store,
        registry,
        customSensors: sensors || null,
        enableDefaultSensors: props.enableDefaultSensors !== false
    });
    (0, _react.useEffect)(()=>{
        return tryResetStore;
    }, [
        tryResetStore
    ]);
    return (0, _reactDefault.default).createElement(AppContext.Provider, {
        value: appContext
    }, (0, _reactDefault.default).createElement((0, _reactRedux.Provider), {
        context: StoreContext,
        store: store
    }, props.children));
}
function useUniqueContextId() {
    return (0, _reactDefault.default).useId();
}
function DragDropContext(props) {
    const contextId = useUniqueContextId();
    const dragHandleUsageInstructions = props.dragHandleUsageInstructions || preset.dragHandleUsageInstructions;
    return (0, _reactDefault.default).createElement(ErrorBoundary, null, (setCallbacks)=>(0, _reactDefault.default).createElement(App, {
            nonce: props.nonce,
            contextId: contextId,
            setCallbacks: setCallbacks,
            dragHandleUsageInstructions: dragHandleUsageInstructions,
            enableDefaultSensors: props.enableDefaultSensors,
            sensors: props.sensors,
            onBeforeCapture: props.onBeforeCapture,
            onBeforeDragStart: props.onBeforeDragStart,
            onDragStart: props.onDragStart,
            onDragUpdate: props.onDragUpdate,
            onDragEnd: props.onDragEnd,
            autoScrollerOptions: props.autoScrollerOptions
        }, props.children));
}
const zIndexOptions = {
    dragging: 5000,
    dropAnimating: 4500
};
const getDraggingTransition = (shouldAnimateDragMovement, dropping)=>{
    if (dropping) return transitions.drop(dropping.duration);
    if (shouldAnimateDragMovement) return transitions.snap;
    return transitions.fluid;
};
const getDraggingOpacity = (isCombining, isDropAnimating)=>{
    if (!isCombining) return undefined;
    return isDropAnimating ? combine.opacity.drop : combine.opacity.combining;
};
const getShouldDraggingAnimate = (dragging)=>{
    if (dragging.forceShouldAnimate != null) return dragging.forceShouldAnimate;
    return dragging.mode === 'SNAP';
};
function getDraggingStyle(dragging) {
    const dimension = dragging.dimension;
    const box = dimension.client;
    const { offset, combineWith, dropping } = dragging;
    const isCombining = Boolean(combineWith);
    const shouldAnimate = getShouldDraggingAnimate(dragging);
    const isDropAnimating = Boolean(dropping);
    const transform = isDropAnimating ? transforms.drop(offset, isCombining) : transforms.moveTo(offset);
    const style = {
        position: 'fixed',
        top: box.marginBox.top,
        left: box.marginBox.left,
        boxSizing: 'border-box',
        width: box.borderBox.width,
        height: box.borderBox.height,
        transition: getDraggingTransition(shouldAnimate, dropping),
        transform,
        opacity: getDraggingOpacity(isCombining, isDropAnimating),
        zIndex: isDropAnimating ? zIndexOptions.dropAnimating : zIndexOptions.dragging,
        pointerEvents: 'none'
    };
    return style;
}
function getSecondaryStyle(secondary) {
    return {
        transform: transforms.moveTo(secondary.offset),
        transition: secondary.shouldAnimateDisplacement ? undefined : 'none'
    };
}
function getStyle$1(mapped) {
    return mapped.type === 'DRAGGING' ? getDraggingStyle(mapped) : getSecondaryStyle(mapped);
}
function getDimension$1(descriptor, el, windowScroll = origin) {
    const computedStyles = window.getComputedStyle(el);
    const borderBox = el.getBoundingClientRect();
    const client = (0, _cssBoxModel.calculateBox)(borderBox, computedStyles);
    const page = (0, _cssBoxModel.withScroll)(client, windowScroll);
    const placeholder = {
        client,
        tagName: el.tagName.toLowerCase(),
        display: computedStyles.display
    };
    const displaceBy = {
        x: client.marginBox.width,
        y: client.marginBox.height
    };
    const dimension = {
        descriptor,
        placeholder,
        displaceBy,
        client,
        page
    };
    return dimension;
}
function useDraggablePublisher(args) {
    const uniqueId = useUniqueId('draggable');
    const { descriptor, registry, getDraggableRef, canDragInteractiveElements, shouldRespectForcePress, isEnabled } = args;
    const options = useMemo(()=>({
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        }), [
        canDragInteractiveElements,
        isEnabled,
        shouldRespectForcePress
    ]);
    const getDimension = useCallback((windowScroll)=>{
        const el = getDraggableRef();
        !el && invariant();
        return getDimension$1(descriptor, el, windowScroll);
    }, [
        descriptor,
        getDraggableRef
    ]);
    const entry = useMemo(()=>({
            uniqueId,
            descriptor,
            options,
            getDimension
        }), [
        descriptor,
        getDimension,
        options,
        uniqueId
    ]);
    const publishedRef = (0, _react.useRef)(entry);
    const isFirstPublishRef = (0, _react.useRef)(true);
    useIsomorphicLayoutEffect(()=>{
        registry.draggable.register(publishedRef.current);
        return ()=>registry.draggable.unregister(publishedRef.current);
    }, [
        registry.draggable
    ]);
    useIsomorphicLayoutEffect(()=>{
        if (isFirstPublishRef.current) {
            isFirstPublishRef.current = false;
            return;
        }
        const last = publishedRef.current;
        publishedRef.current = entry;
        registry.draggable.update(entry, last);
    }, [
        entry,
        registry.draggable
    ]);
}
var DroppableContext = (0, _reactDefault.default).createContext(null);
function checkIsValidInnerRef(el) {
    !(el && isHtmlElement(el)) && invariant();
}
function useValidation$1(props, contextId, getRef) {
    useDevSetupWarning(()=>{
        function prefix(id) {
            return `Draggable[id: ${id}]: `;
        }
        const id = props.draggableId;
        !id && invariant(false);
        !(typeof id === 'string') && invariant(false);
        !Number.isInteger(props.index) && invariant(false);
        if (props.mapped.type === 'DRAGGING') return;
        checkIsValidInnerRef(getRef());
        if (props.isEnabled) !findDragHandle(contextId, id) && invariant(false);
    });
}
function useClonePropValidation(isClone) {
    useDev(()=>{
        const initialRef = (0, _react.useRef)(isClone);
        useDevSetupWarning(()=>{
            !(isClone === initialRef.current) && invariant(false);
        }, [
            isClone
        ]);
    });
}
function useRequiredContext(Context) {
    const result = (0, _react.useContext)(Context);
    !result && invariant();
    return result;
}
function preventHtml5Dnd(event) {
    event.preventDefault();
}
const Draggable = (props)=>{
    const ref = (0, _react.useRef)(null);
    const setRef = useCallback((el = null)=>{
        ref.current = el;
    }, []);
    const getRef = useCallback(()=>ref.current, []);
    const { contextId, dragHandleUsageInstructionsId, registry } = useRequiredContext(AppContext);
    const { type, droppableId } = useRequiredContext(DroppableContext);
    const descriptor = useMemo(()=>({
            id: props.draggableId,
            index: props.index,
            type,
            droppableId
        }), [
        props.draggableId,
        props.index,
        type,
        droppableId
    ]);
    const { children, draggableId, isEnabled, shouldRespectForcePress, canDragInteractiveElements, isClone, mapped, dropAnimationFinished: dropAnimationFinishedAction } = props;
    useValidation$1(props, contextId, getRef);
    useClonePropValidation(isClone);
    if (!isClone) {
        const forPublisher = useMemo(()=>({
                descriptor,
                registry,
                getDraggableRef: getRef,
                canDragInteractiveElements,
                shouldRespectForcePress,
                isEnabled
            }), [
            descriptor,
            registry,
            getRef,
            canDragInteractiveElements,
            shouldRespectForcePress,
            isEnabled
        ]);
        useDraggablePublisher(forPublisher);
    }
    const dragHandleProps = useMemo(()=>isEnabled ? {
            tabIndex: 0,
            role: 'button',
            'aria-describedby': dragHandleUsageInstructionsId,
            'data-rfd-drag-handle-draggable-id': draggableId,
            'data-rfd-drag-handle-context-id': contextId,
            draggable: false,
            onDragStart: preventHtml5Dnd
        } : null, [
        contextId,
        dragHandleUsageInstructionsId,
        draggableId,
        isEnabled
    ]);
    const onMoveEnd = useCallback((event)=>{
        if (mapped.type !== 'DRAGGING') return;
        if (!mapped.dropping) return;
        if (event.propertyName !== 'transform') return;
        (0, _reactDom.flushSync)(dropAnimationFinishedAction);
    }, [
        dropAnimationFinishedAction,
        mapped
    ]);
    const provided = useMemo(()=>{
        const style = getStyle$1(mapped);
        const onTransitionEnd = mapped.type === 'DRAGGING' && mapped.dropping ? onMoveEnd : undefined;
        const result = {
            innerRef: setRef,
            draggableProps: {
                'data-rfd-draggable-context-id': contextId,
                'data-rfd-draggable-id': draggableId,
                style,
                onTransitionEnd
            },
            dragHandleProps
        };
        return result;
    }, [
        contextId,
        dragHandleProps,
        draggableId,
        mapped,
        onMoveEnd,
        setRef
    ]);
    const rubric = useMemo(()=>({
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        }), [
        descriptor.droppableId,
        descriptor.id,
        descriptor.index,
        descriptor.type
    ]);
    return (0, _reactDefault.default).createElement((0, _reactDefault.default).Fragment, null, children(provided, mapped.snapshot, rubric));
};
var isStrictEqual = (a, b)=>a === b;
var whatIsDraggedOverFromResult = (result)=>{
    const { combine, destination } = result;
    if (destination) return destination.droppableId;
    if (combine) return combine.droppableId;
    return null;
};
const getCombineWithFromResult = (result)=>{
    return result.combine ? result.combine.draggableId : null;
};
const getCombineWithFromImpact = (impact)=>{
    return impact.at && impact.at.type === 'COMBINE' ? impact.at.combine.draggableId : null;
};
function getDraggableSelector() {
    const memoizedOffset = memoizeOne((x, y)=>({
            x,
            y
        }));
    const getMemoizedSnapshot = memoizeOne((mode, isClone, draggingOver = null, combineWith = null, dropping = null)=>({
            isDragging: true,
            isClone,
            isDropAnimating: Boolean(dropping),
            dropAnimation: dropping,
            mode,
            draggingOver,
            combineWith,
            combineTargetFor: null
        }));
    const getMemoizedProps = memoizeOne((offset, mode, dimension, isClone, draggingOver = null, combineWith = null, forceShouldAnimate = null)=>({
            mapped: {
                type: 'DRAGGING',
                dropping: null,
                draggingOver,
                combineWith,
                mode,
                offset,
                dimension,
                forceShouldAnimate,
                snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, null)
            }
        }));
    const selector = (state, ownProps)=>{
        if (isDragging(state)) {
            if (state.critical.draggable.id !== ownProps.draggableId) return null;
            const offset = state.current.client.offset;
            const dimension = state.dimensions.draggables[ownProps.draggableId];
            const draggingOver = whatIsDraggedOver(state.impact);
            const combineWith = getCombineWithFromImpact(state.impact);
            const forceShouldAnimate = state.forceShouldAnimate;
            return getMemoizedProps(memoizedOffset(offset.x, offset.y), state.movementMode, dimension, ownProps.isClone, draggingOver, combineWith, forceShouldAnimate);
        }
        if (state.phase === 'DROP_ANIMATING') {
            const completed = state.completed;
            if (completed.result.draggableId !== ownProps.draggableId) return null;
            const isClone = ownProps.isClone;
            const dimension = state.dimensions.draggables[ownProps.draggableId];
            const result = completed.result;
            const mode = result.mode;
            const draggingOver = whatIsDraggedOverFromResult(result);
            const combineWith = getCombineWithFromResult(result);
            const duration = state.dropDuration;
            const dropping = {
                duration,
                curve: curves.drop,
                moveTo: state.newHomeClientOffset,
                opacity: combineWith ? combine.opacity.drop : null,
                scale: combineWith ? combine.scale.drop : null
            };
            return {
                mapped: {
                    type: 'DRAGGING',
                    offset: state.newHomeClientOffset,
                    dimension,
                    dropping,
                    draggingOver,
                    combineWith,
                    mode,
                    forceShouldAnimate: null,
                    snapshot: getMemoizedSnapshot(mode, isClone, draggingOver, combineWith, dropping)
                }
            };
        }
        return null;
    };
    return selector;
}
function getSecondarySnapshot(combineTargetFor = null) {
    return {
        isDragging: false,
        isDropAnimating: false,
        isClone: false,
        dropAnimation: null,
        mode: null,
        draggingOver: null,
        combineTargetFor,
        combineWith: null
    };
}
const atRest = {
    mapped: {
        type: 'SECONDARY',
        offset: origin,
        combineTargetFor: null,
        shouldAnimateDisplacement: true,
        snapshot: getSecondarySnapshot(null)
    }
};
function getSecondarySelector() {
    const memoizedOffset = memoizeOne((x, y)=>({
            x,
            y
        }));
    const getMemoizedSnapshot = memoizeOne(getSecondarySnapshot);
    const getMemoizedProps = memoizeOne((offset, combineTargetFor = null, shouldAnimateDisplacement)=>({
            mapped: {
                type: 'SECONDARY',
                offset,
                combineTargetFor,
                shouldAnimateDisplacement,
                snapshot: getMemoizedSnapshot(combineTargetFor)
            }
        }));
    const getFallback = (combineTargetFor)=>{
        return combineTargetFor ? getMemoizedProps(origin, combineTargetFor, true) : null;
    };
    const getProps = (ownId, draggingId, impact, afterCritical)=>{
        const visualDisplacement = impact.displaced.visible[ownId];
        const isAfterCriticalInVirtualList = Boolean(afterCritical.inVirtualList && afterCritical.effected[ownId]);
        const combine = tryGetCombine(impact);
        const combineTargetFor = combine && combine.draggableId === ownId ? draggingId : null;
        if (!visualDisplacement) {
            if (!isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
            if (impact.displaced.invisible[ownId]) return null;
            const change = negate(afterCritical.displacedBy.point);
            const offset = memoizedOffset(change.x, change.y);
            return getMemoizedProps(offset, combineTargetFor, true);
        }
        if (isAfterCriticalInVirtualList) return getFallback(combineTargetFor);
        const displaceBy = impact.displacedBy.point;
        const offset = memoizedOffset(displaceBy.x, displaceBy.y);
        return getMemoizedProps(offset, combineTargetFor, visualDisplacement.shouldAnimate);
    };
    const selector = (state, ownProps)=>{
        if (isDragging(state)) {
            if (state.critical.draggable.id === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, state.critical.draggable.id, state.impact, state.afterCritical);
        }
        if (state.phase === 'DROP_ANIMATING') {
            const completed = state.completed;
            if (completed.result.draggableId === ownProps.draggableId) return null;
            return getProps(ownProps.draggableId, completed.result.draggableId, completed.impact, completed.afterCritical);
        }
        return null;
    };
    return selector;
}
const makeMapStateToProps$1 = ()=>{
    const draggingSelector = getDraggableSelector();
    const secondarySelector = getSecondarySelector();
    const selector = (state, ownProps)=>draggingSelector(state, ownProps) || secondarySelector(state, ownProps) || atRest;
    return selector;
};
const mapDispatchToProps$1 = {
    dropAnimationFinished: dropAnimationFinished
};
const ConnectedDraggable = (0, _reactRedux.connect)(makeMapStateToProps$1, mapDispatchToProps$1, null, {
    context: StoreContext,
    areStatePropsEqual: isStrictEqual
})(Draggable);
function PrivateDraggable(props) {
    const droppableContext = useRequiredContext(DroppableContext);
    const isUsingCloneFor = droppableContext.isUsingCloneFor;
    if (isUsingCloneFor === props.draggableId && !props.isClone) return null;
    return (0, _reactDefault.default).createElement(ConnectedDraggable, props);
}
function PublicDraggable(props) {
    const isEnabled = typeof props.isDragDisabled === 'boolean' ? !props.isDragDisabled : true;
    const canDragInteractiveElements = Boolean(props.disableInteractiveElementBlocking);
    const shouldRespectForcePress = Boolean(props.shouldRespectForcePress);
    return (0, _reactDefault.default).createElement(PrivateDraggable, (0, _extendsDefault.default)({}, props, {
        isClone: false,
        isEnabled: isEnabled,
        canDragInteractiveElements: canDragInteractiveElements,
        shouldRespectForcePress: shouldRespectForcePress
    }));
}
const isEqual = (base)=>(value)=>base === value;
const isScroll = isEqual('scroll');
const isAuto = isEqual('auto');
const isVisible = isEqual('visible');
const isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const isBoth = (overflow, fn)=>fn(overflow.overflowX) && fn(overflow.overflowY);
const isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return isEither(overflow, isScroll) || isEither(overflow, isAuto);
};
const isBodyScrollable = ()=>{
    return false;
};
const getClosestScrollable = (el)=>{
    if (el == null) return null;
    if (el === document.body) return isBodyScrollable() ? el : null;
    if (el === document.documentElement) return null;
    if (!isElementScrollable(el)) return getClosestScrollable(el.parentElement);
    return el;
};
var checkForNestedScrollContainers = (scrollable)=>{
    if (!scrollable) return;
    const anotherScrollParent = getClosestScrollable(scrollable.parentElement);
    if (!anotherScrollParent) return;
};
var getScroll = (el)=>({
        x: el.scrollLeft,
        y: el.scrollTop
    });
const getIsFixed = (el)=>{
    if (!el) return false;
    const style = window.getComputedStyle(el);
    if (style.position === 'fixed') return true;
    return getIsFixed(el.parentElement);
};
var getEnv = (start)=>{
    const closestScrollable = getClosestScrollable(start);
    const isFixedOnPage = getIsFixed(start);
    return {
        closestScrollable,
        isFixedOnPage
    };
};
var getDroppableDimension = ({ descriptor, isEnabled, isCombineEnabled, isFixedOnPage, direction, client, page, closest })=>{
    const frame = (()=>{
        if (!closest) return null;
        const { scrollSize, client: frameClient } = closest;
        const maxScroll = getMaxScroll({
            scrollHeight: scrollSize.scrollHeight,
            scrollWidth: scrollSize.scrollWidth,
            height: frameClient.paddingBox.height,
            width: frameClient.paddingBox.width
        });
        return {
            pageMarginBox: closest.page.marginBox,
            frameClient,
            scrollSize,
            shouldClipSubject: closest.shouldClipSubject,
            scroll: {
                initial: closest.scroll,
                current: closest.scroll,
                max: maxScroll,
                diff: {
                    value: origin,
                    displacement: origin
                }
            }
        };
    })();
    const axis = direction === 'vertical' ? vertical : horizontal;
    const subject = getSubject({
        page,
        withPlaceholder: null,
        axis,
        frame
    });
    const dimension = {
        descriptor,
        isCombineEnabled,
        isFixedOnPage,
        axis,
        isEnabled,
        client,
        page,
        frame,
        subject
    };
    return dimension;
};
const getClient = (targetRef, closestScrollable)=>{
    const base = (0, _cssBoxModel.getBox)(targetRef);
    if (!closestScrollable) return base;
    if (targetRef !== closestScrollable) return base;
    const top = base.paddingBox.top - closestScrollable.scrollTop;
    const left = base.paddingBox.left - closestScrollable.scrollLeft;
    const bottom = top + closestScrollable.scrollHeight;
    const right = left + closestScrollable.scrollWidth;
    const paddingBox = {
        top,
        right,
        bottom,
        left
    };
    const borderBox = (0, _cssBoxModel.expand)(paddingBox, base.border);
    const client = (0, _cssBoxModel.createBox)({
        borderBox,
        margin: base.margin,
        border: base.border,
        padding: base.padding
    });
    return client;
};
var getDimension = ({ ref, descriptor, env, windowScroll, direction, isDropDisabled, isCombineEnabled, shouldClipSubject })=>{
    const closestScrollable = env.closestScrollable;
    const client = getClient(ref, closestScrollable);
    const page = (0, _cssBoxModel.withScroll)(client, windowScroll);
    const closest = (()=>{
        if (!closestScrollable) return null;
        const frameClient = (0, _cssBoxModel.getBox)(closestScrollable);
        const scrollSize = {
            scrollHeight: closestScrollable.scrollHeight,
            scrollWidth: closestScrollable.scrollWidth
        };
        return {
            client: frameClient,
            page: (0, _cssBoxModel.withScroll)(frameClient, windowScroll),
            scroll: getScroll(closestScrollable),
            scrollSize,
            shouldClipSubject
        };
    })();
    const dimension = getDroppableDimension({
        descriptor,
        isEnabled: !isDropDisabled,
        isCombineEnabled,
        isFixedOnPage: env.isFixedOnPage,
        direction,
        client,
        page,
        closest
    });
    return dimension;
};
const immediate = {
    passive: false
};
const delayed = {
    passive: true
};
var getListenerOptions = (options)=>options.shouldPublishImmediately ? immediate : delayed;
const getClosestScrollableFromDrag = (dragging)=>dragging && dragging.env.closestScrollable || null;
function useDroppablePublisher(args) {
    const whileDraggingRef = (0, _react.useRef)(null);
    const appContext = useRequiredContext(AppContext);
    const uniqueId = useUniqueId('droppable');
    const { registry, marshal } = appContext;
    const previousRef = usePrevious(args);
    const descriptor = useMemo(()=>({
            id: args.droppableId,
            type: args.type,
            mode: args.mode
        }), [
        args.droppableId,
        args.mode,
        args.type
    ]);
    const publishedDescriptorRef = (0, _react.useRef)(descriptor);
    const memoizedUpdateScroll = useMemo(()=>memoizeOne((x, y)=>{
            !whileDraggingRef.current && invariant();
            const scroll = {
                x,
                y
            };
            marshal.updateDroppableScroll(descriptor.id, scroll);
        }), [
        descriptor.id,
        marshal
    ]);
    const getClosestScroll = useCallback(()=>{
        const dragging = whileDraggingRef.current;
        if (!dragging || !dragging.env.closestScrollable) return origin;
        return getScroll(dragging.env.closestScrollable);
    }, []);
    const updateScroll = useCallback(()=>{
        const scroll = getClosestScroll();
        memoizedUpdateScroll(scroll.x, scroll.y);
    }, [
        getClosestScroll,
        memoizedUpdateScroll
    ]);
    const scheduleScrollUpdate = useMemo(()=>(0, _rafSchdDefault.default)(updateScroll), [
        updateScroll
    ]);
    const onClosestScroll = useCallback(()=>{
        const dragging = whileDraggingRef.current;
        const closest = getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && invariant();
        const options = dragging.scrollOptions;
        if (options.shouldPublishImmediately) {
            updateScroll();
            return;
        }
        scheduleScrollUpdate();
    }, [
        scheduleScrollUpdate,
        updateScroll
    ]);
    const getDimensionAndWatchScroll = useCallback((windowScroll, options)=>{
        !!whileDraggingRef.current && invariant();
        const previous = previousRef.current;
        const ref = previous.getDroppableRef();
        !ref && invariant();
        const env = getEnv(ref);
        const dragging = {
            ref,
            descriptor,
            env,
            scrollOptions: options
        };
        whileDraggingRef.current = dragging;
        const dimension = getDimension({
            ref,
            descriptor,
            env,
            windowScroll,
            direction: previous.direction,
            isDropDisabled: previous.isDropDisabled,
            isCombineEnabled: previous.isCombineEnabled,
            shouldClipSubject: !previous.ignoreContainerClipping
        });
        const scrollable = env.closestScrollable;
        if (scrollable) {
            scrollable.setAttribute(scrollContainer.contextId, appContext.contextId);
            scrollable.addEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
        }
        return dimension;
    }, [
        appContext.contextId,
        descriptor,
        onClosestScroll,
        previousRef
    ]);
    const getScrollWhileDragging = useCallback(()=>{
        const dragging = whileDraggingRef.current;
        const closest = getClosestScrollableFromDrag(dragging);
        !(dragging && closest) && invariant();
        return getScroll(closest);
    }, []);
    const dragStopped = useCallback(()=>{
        const dragging = whileDraggingRef.current;
        !dragging && invariant();
        const closest = getClosestScrollableFromDrag(dragging);
        whileDraggingRef.current = null;
        if (!closest) return;
        scheduleScrollUpdate.cancel();
        closest.removeAttribute(scrollContainer.contextId);
        closest.removeEventListener('scroll', onClosestScroll, getListenerOptions(dragging.scrollOptions));
    }, [
        onClosestScroll,
        scheduleScrollUpdate
    ]);
    const scroll = useCallback((change)=>{
        const dragging = whileDraggingRef.current;
        !dragging && invariant();
        const closest = getClosestScrollableFromDrag(dragging);
        !closest && invariant();
        closest.scrollTop += change.y;
        closest.scrollLeft += change.x;
    }, []);
    const callbacks = useMemo(()=>{
        return {
            getDimensionAndWatchScroll,
            getScrollWhileDragging,
            dragStopped,
            scroll
        };
    }, [
        dragStopped,
        getDimensionAndWatchScroll,
        getScrollWhileDragging,
        scroll
    ]);
    const entry = useMemo(()=>({
            uniqueId,
            descriptor,
            callbacks
        }), [
        callbacks,
        descriptor,
        uniqueId
    ]);
    useIsomorphicLayoutEffect(()=>{
        publishedDescriptorRef.current = entry.descriptor;
        registry.droppable.register(entry);
        return ()=>{
            if (whileDraggingRef.current) dragStopped();
            registry.droppable.unregister(entry);
        };
    }, [
        callbacks,
        descriptor,
        dragStopped,
        entry,
        marshal,
        registry.droppable
    ]);
    useIsomorphicLayoutEffect(()=>{
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsEnabled(publishedDescriptorRef.current.id, !args.isDropDisabled);
    }, [
        args.isDropDisabled,
        marshal
    ]);
    useIsomorphicLayoutEffect(()=>{
        if (!whileDraggingRef.current) return;
        marshal.updateDroppableIsCombineEnabled(publishedDescriptorRef.current.id, args.isCombineEnabled);
    }, [
        args.isCombineEnabled,
        marshal
    ]);
}
function noop() {}
const empty = {
    width: 0,
    height: 0,
    margin: noSpacing
};
const getSize = ({ isAnimatingOpenOnMount, placeholder, animate })=>{
    if (isAnimatingOpenOnMount) return empty;
    if (animate === 'close') return empty;
    return {
        height: placeholder.client.borderBox.height,
        width: placeholder.client.borderBox.width,
        margin: placeholder.client.margin
    };
};
const getStyle = ({ isAnimatingOpenOnMount, placeholder, animate })=>{
    const size = getSize({
        isAnimatingOpenOnMount,
        placeholder,
        animate
    });
    return {
        display: placeholder.display,
        boxSizing: 'border-box',
        width: size.width,
        height: size.height,
        marginTop: size.margin.top,
        marginRight: size.margin.right,
        marginBottom: size.margin.bottom,
        marginLeft: size.margin.left,
        flexShrink: '0',
        flexGrow: '0',
        pointerEvents: 'none',
        transition: animate !== 'none' ? transitions.placeholder : null
    };
};
const Placeholder = (props)=>{
    const animateOpenTimerRef = (0, _react.useRef)(null);
    const tryClearAnimateOpenTimer = useCallback(()=>{
        if (!animateOpenTimerRef.current) return;
        clearTimeout(animateOpenTimerRef.current);
        animateOpenTimerRef.current = null;
    }, []);
    const { animate, onTransitionEnd, onClose, contextId } = props;
    const [isAnimatingOpenOnMount, setIsAnimatingOpenOnMount] = (0, _react.useState)(props.animate === 'open');
    (0, _react.useEffect)(()=>{
        if (!isAnimatingOpenOnMount) return noop;
        if (animate !== 'open') {
            tryClearAnimateOpenTimer();
            setIsAnimatingOpenOnMount(false);
            return noop;
        }
        if (animateOpenTimerRef.current) return noop;
        animateOpenTimerRef.current = setTimeout(()=>{
            animateOpenTimerRef.current = null;
            setIsAnimatingOpenOnMount(false);
        });
        return tryClearAnimateOpenTimer;
    }, [
        animate,
        isAnimatingOpenOnMount,
        tryClearAnimateOpenTimer
    ]);
    const onSizeChangeEnd = useCallback((event)=>{
        if (event.propertyName !== 'height') return;
        onTransitionEnd();
        if (animate === 'close') onClose();
    }, [
        animate,
        onClose,
        onTransitionEnd
    ]);
    const style = getStyle({
        isAnimatingOpenOnMount,
        animate: props.animate,
        placeholder: props.placeholder
    });
    return (0, _reactDefault.default).createElement(props.placeholder.tagName, {
        style,
        'data-rfd-placeholder-context-id': contextId,
        onTransitionEnd: onSizeChangeEnd,
        ref: props.innerRef
    });
};
var Placeholder$1 = (0, _reactDefault.default).memo(Placeholder);
function isBoolean(value) {
    return typeof value === 'boolean';
}
function runChecks(args, checks) {
    checks.forEach((check)=>check(args));
}
const shared = [
    function required({ props }) {
        !props.droppableId && invariant();
        !(typeof props.droppableId === 'string') && invariant();
    },
    function boolean({ props }) {
        !isBoolean(props.isDropDisabled) && invariant();
        !isBoolean(props.isCombineEnabled) && invariant();
        !isBoolean(props.ignoreContainerClipping) && invariant();
    },
    function ref({ getDroppableRef }) {
        checkIsValidInnerRef(getDroppableRef());
    }
];
const standard = [
    function placeholder({ props, getPlaceholderRef }) {
        if (!props.placeholder) return;
        const ref = getPlaceholderRef();
        if (ref) return;
    }
];
const virtual = [
    function hasClone({ props }) {
        !props.renderClone && invariant();
    },
    function hasNoPlaceholder({ getPlaceholderRef }) {
        !!getPlaceholderRef() && invariant();
    }
];
function useValidation(args) {
    useDevSetupWarning(()=>{
        runChecks(args, shared);
        if (args.props.mode === 'standard') runChecks(args, standard);
        if (args.props.mode === 'virtual') runChecks(args, virtual);
    });
}
class AnimateInOut extends (0, _reactDefault.default).PureComponent {
    constructor(...args){
        super(...args);
        this.state = {
            isVisible: Boolean(this.props.on),
            data: this.props.on,
            animate: this.props.shouldAnimate && this.props.on ? 'open' : 'none'
        };
        this.onClose = ()=>{
            if (this.state.animate !== 'close') return;
            this.setState({
                isVisible: false
            });
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (!props.shouldAnimate) return {
            isVisible: Boolean(props.on),
            data: props.on,
            animate: 'none'
        };
        if (props.on) return {
            isVisible: true,
            data: props.on,
            animate: 'open'
        };
        if (state.isVisible) return {
            isVisible: true,
            data: state.data,
            animate: 'close'
        };
        return {
            isVisible: false,
            animate: 'close',
            data: null
        };
    }
    render() {
        if (!this.state.isVisible) return null;
        const provided = {
            onClose: this.onClose,
            data: this.state.data,
            animate: this.state.animate
        };
        return this.props.children(provided);
    }
}
const Droppable = (props)=>{
    const appContext = (0, _react.useContext)(AppContext);
    !appContext && invariant();
    const { contextId, isMovementAllowed } = appContext;
    const droppableRef = (0, _react.useRef)(null);
    const placeholderRef = (0, _react.useRef)(null);
    const { children, droppableId, type, mode, direction, ignoreContainerClipping, isDropDisabled, isCombineEnabled, snapshot, useClone, updateViewportMaxScroll, getContainerForClone } = props;
    const getDroppableRef = useCallback(()=>droppableRef.current, []);
    const setDroppableRef = useCallback((value = null)=>{
        droppableRef.current = value;
    }, []);
    const getPlaceholderRef = useCallback(()=>placeholderRef.current, []);
    const setPlaceholderRef = useCallback((value = null)=>{
        placeholderRef.current = value;
    }, []);
    useValidation({
        props,
        getDroppableRef,
        getPlaceholderRef
    });
    const onPlaceholderTransitionEnd = useCallback(()=>{
        if (isMovementAllowed()) updateViewportMaxScroll({
            maxScroll: getMaxWindowScroll()
        });
    }, [
        isMovementAllowed,
        updateViewportMaxScroll
    ]);
    useDroppablePublisher({
        droppableId,
        type,
        mode,
        direction,
        isDropDisabled,
        isCombineEnabled,
        ignoreContainerClipping,
        getDroppableRef
    });
    const placeholder = useMemo(()=>(0, _reactDefault.default).createElement(AnimateInOut, {
            on: props.placeholder,
            shouldAnimate: props.shouldAnimatePlaceholder
        }, ({ onClose, data, animate })=>(0, _reactDefault.default).createElement(Placeholder$1, {
                placeholder: data,
                onClose: onClose,
                innerRef: setPlaceholderRef,
                animate: animate,
                contextId: contextId,
                onTransitionEnd: onPlaceholderTransitionEnd
            })), [
        contextId,
        onPlaceholderTransitionEnd,
        props.placeholder,
        props.shouldAnimatePlaceholder,
        setPlaceholderRef
    ]);
    const provided = useMemo(()=>({
            innerRef: setDroppableRef,
            placeholder,
            droppableProps: {
                'data-rfd-droppable-id': droppableId,
                'data-rfd-droppable-context-id': contextId
            }
        }), [
        contextId,
        droppableId,
        placeholder,
        setDroppableRef
    ]);
    const isUsingCloneFor = useClone ? useClone.dragging.draggableId : null;
    const droppableContext = useMemo(()=>({
            droppableId,
            type,
            isUsingCloneFor
        }), [
        droppableId,
        isUsingCloneFor,
        type
    ]);
    function getClone() {
        if (!useClone) return null;
        const { dragging, render } = useClone;
        const node = (0, _reactDefault.default).createElement(PrivateDraggable, {
            draggableId: dragging.draggableId,
            index: dragging.source.index,
            isClone: true,
            isEnabled: true,
            shouldRespectForcePress: false,
            canDragInteractiveElements: true
        }, (draggableProvided, draggableSnapshot)=>render(draggableProvided, draggableSnapshot, dragging));
        return (0, _reactDomDefault.default).createPortal(node, getContainerForClone());
    }
    return (0, _reactDefault.default).createElement(DroppableContext.Provider, {
        value: droppableContext
    }, children(provided, snapshot), getClone());
};
function getBody() {
    !document.body && invariant();
    return document.body;
}
const defaultProps = {
    mode: 'standard',
    type: 'DEFAULT',
    direction: 'vertical',
    isDropDisabled: false,
    isCombineEnabled: false,
    ignoreContainerClipping: false,
    renderClone: null,
    getContainerForClone: getBody
};
const attachDefaultPropsToOwnProps = (ownProps)=>{
    let mergedProps = {
        ...ownProps
    };
    let defaultPropKey;
    for(defaultPropKey in defaultProps)if (ownProps[defaultPropKey] === undefined) mergedProps = {
        ...mergedProps,
        [defaultPropKey]: defaultProps[defaultPropKey]
    };
    return mergedProps;
};
const isMatchingType = (type, critical)=>type === critical.droppable.type;
const getDraggable = (critical, dimensions)=>dimensions.draggables[critical.draggable.id];
const makeMapStateToProps = ()=>{
    const idleWithAnimation = {
        placeholder: null,
        shouldAnimatePlaceholder: true,
        snapshot: {
            isDraggingOver: false,
            draggingOverWith: null,
            draggingFromThisWith: null,
            isUsingPlaceholder: false
        },
        useClone: null
    };
    const idleWithoutAnimation = {
        ...idleWithAnimation,
        shouldAnimatePlaceholder: false
    };
    const getDraggableRubric = memoizeOne((descriptor)=>({
            draggableId: descriptor.id,
            type: descriptor.type,
            source: {
                index: descriptor.index,
                droppableId: descriptor.droppableId
            }
        }));
    const getMapProps = memoizeOne((id, isEnabled, isDraggingOverForConsumer, isDraggingOverForImpact, dragging, renderClone)=>{
        const draggableId = dragging.descriptor.id;
        const isHome = dragging.descriptor.droppableId === id;
        if (isHome) {
            const useClone = renderClone ? {
                render: renderClone,
                dragging: getDraggableRubric(dragging.descriptor)
            } : null;
            const snapshot = {
                isDraggingOver: isDraggingOverForConsumer,
                draggingOverWith: isDraggingOverForConsumer ? draggableId : null,
                draggingFromThisWith: draggableId,
                isUsingPlaceholder: true
            };
            return {
                placeholder: dragging.placeholder,
                shouldAnimatePlaceholder: false,
                snapshot,
                useClone
            };
        }
        if (!isEnabled) return idleWithoutAnimation;
        if (!isDraggingOverForImpact) return idleWithAnimation;
        const snapshot = {
            isDraggingOver: isDraggingOverForConsumer,
            draggingOverWith: draggableId,
            draggingFromThisWith: null,
            isUsingPlaceholder: true
        };
        return {
            placeholder: dragging.placeholder,
            shouldAnimatePlaceholder: true,
            snapshot,
            useClone: null
        };
    });
    const selector = (state, ownProps)=>{
        const ownPropsWithDefaultProps = attachDefaultPropsToOwnProps(ownProps);
        const id = ownPropsWithDefaultProps.droppableId;
        const type = ownPropsWithDefaultProps.type;
        const isEnabled = !ownPropsWithDefaultProps.isDropDisabled;
        const renderClone = ownPropsWithDefaultProps.renderClone;
        if (isDragging(state)) {
            const critical = state.critical;
            if (!isMatchingType(type, critical)) return idleWithoutAnimation;
            const dragging = getDraggable(critical, state.dimensions);
            const isDraggingOver = whatIsDraggedOver(state.impact) === id;
            return getMapProps(id, isEnabled, isDraggingOver, isDraggingOver, dragging, renderClone);
        }
        if (state.phase === 'DROP_ANIMATING') {
            const completed = state.completed;
            if (!isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            const dragging = getDraggable(completed.critical, state.dimensions);
            return getMapProps(id, isEnabled, whatIsDraggedOverFromResult(completed.result) === id, whatIsDraggedOver(completed.impact) === id, dragging, renderClone);
        }
        if (state.phase === 'IDLE' && state.completed && !state.shouldFlush) {
            const completed = state.completed;
            if (!isMatchingType(type, completed.critical)) return idleWithoutAnimation;
            const wasOver = whatIsDraggedOver(completed.impact) === id;
            const wasCombining = Boolean(completed.impact.at && completed.impact.at.type === 'COMBINE');
            const isHome = completed.critical.droppable.id === id;
            if (wasOver) return wasCombining ? idleWithAnimation : idleWithoutAnimation;
            if (isHome) return idleWithAnimation;
            return idleWithoutAnimation;
        }
        return idleWithoutAnimation;
    };
    return selector;
};
const mapDispatchToProps = {
    updateViewportMaxScroll: updateViewportMaxScroll
};
const ConnectedDroppable = (0, _reactRedux.connect)(makeMapStateToProps, mapDispatchToProps, (stateProps, dispatchProps, ownProps)=>{
    return {
        ...attachDefaultPropsToOwnProps(ownProps),
        ...stateProps,
        ...dispatchProps
    };
}, {
    context: StoreContext,
    areStatePropsEqual: isStrictEqual
})(Droppable);

},{"react":"bmhQu","react-dom":"82aNB","redux":"fptxw","react-redux":"aRDHF","css-box-model":"28IBK","raf-schd":"jBBc2","@babel/runtime/helpers/esm/extends":"85Hd3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"28IBK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "calculateBox", ()=>calculateBox);
parcelHelpers.export(exports, "createBox", ()=>createBox);
parcelHelpers.export(exports, "expand", ()=>expand);
parcelHelpers.export(exports, "getBox", ()=>getBox);
parcelHelpers.export(exports, "getRect", ()=>getRect);
parcelHelpers.export(exports, "offset", ()=>offset);
parcelHelpers.export(exports, "shrink", ()=>shrink);
parcelHelpers.export(exports, "withScroll", ()=>withScroll);
var _tinyInvariant = require("tiny-invariant");
var _tinyInvariantDefault = parcelHelpers.interopDefault(_tinyInvariant);
var getRect = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var expand = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var shrink = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var createBox = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? noSpacing : _ref2$padding;
    var marginBox = getRect(expand(borderBox, margin));
    var paddingBox = getRect(shrink(borderBox, border));
    var contentBox = getRect(shrink(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: getRect(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, _tinyInvariantDefault.default)(false);
    return result;
};
var getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var offset = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = shift(borderBox, change);
    return createBox({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var withScroll = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = getWindowScroll();
    return offset(original, scroll);
};
var calculateBox = function calculateBox(borderBox, styles) {
    var margin = {
        top: parse(styles.marginTop),
        right: parse(styles.marginRight),
        bottom: parse(styles.marginBottom),
        left: parse(styles.marginLeft)
    };
    var padding = {
        top: parse(styles.paddingTop),
        right: parse(styles.paddingRight),
        bottom: parse(styles.paddingBottom),
        left: parse(styles.paddingLeft)
    };
    var border = {
        top: parse(styles.borderTopWidth),
        right: parse(styles.borderRightWidth),
        bottom: parse(styles.borderBottomWidth),
        left: parse(styles.borderLeftWidth)
    };
    return createBox({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var getBox = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return calculateBox(borderBox, styles);
};

},{"tiny-invariant":"7cMkC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7cMkC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>invariant);
var isProduction = true;
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) return;
    if (isProduction) throw new Error(prefix);
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jBBc2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var rafSchd = function rafSchd(fn) {
    var lastArgs = [];
    var frameId = null;
    var wrapperFn = function wrapperFn() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        lastArgs = args;
        if (frameId) return;
        frameId = requestAnimationFrame(function() {
            frameId = null;
            fn.apply(void 0, lastArgs);
        });
    };
    wrapperFn.cancel = function() {
        if (!frameId) return;
        cancelAnimationFrame(frameId);
        frameId = null;
    };
    return wrapperFn;
};
exports.default = rafSchd;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j9bIN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "actWrapper", ()=>actWrapper);
parcelHelpers.export(exports, "actDestroy", ()=>actDestroy);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _render = require("@rc-component/util/es/React/render");
var _context = require("../app/context");
var _configProvider = require("../config-provider");
var _configProviderDefault = parcelHelpers.interopDefault(_configProvider);
var _purePanel = require("./PurePanel");
var _purePanelDefault = parcelHelpers.interopDefault(_purePanel);
var _useNotification = require("./useNotification");
var _useNotificationDefault = parcelHelpers.interopDefault(_useNotification);
"use client";
let notification = null;
let act = (callback)=>callback();
let taskQueue = [];
let defaultGlobalConfig = {};
function getGlobalContext() {
    const { getContainer, rtl, maxCount, top, bottom, showProgress, pauseOnHover } = defaultGlobalConfig;
    const mergedContainer = getContainer?.() || document.body;
    return {
        getContainer: ()=>mergedContainer,
        rtl,
        maxCount,
        top,
        bottom,
        showProgress,
        pauseOnHover
    };
}
const GlobalHolder = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { notificationConfig, sync } = props;
    const { getPrefixCls } = (0, _react.useContext)((0, _configProvider.ConfigContext));
    const prefixCls = defaultGlobalConfig.prefixCls || getPrefixCls('notification');
    const appConfig = (0, _react.useContext)((0, _context.AppConfigContext));
    const [api, holder] = (0, _useNotification.useInternalNotification)({
        ...notificationConfig,
        prefixCls,
        ...appConfig.notification
    });
    (0, _reactDefault.default).useEffect(sync, []);
    (0, _reactDefault.default).useImperativeHandle(ref, ()=>{
        const instance = {
            ...api
        };
        Object.keys(instance).forEach((method)=>{
            instance[method] = (...args)=>{
                sync();
                return api[method].apply(api, args);
            };
        });
        return {
            instance,
            sync
        };
    });
    return holder;
});
const GlobalHolderWrapper = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((_, ref)=>{
    const [notificationConfig, setNotificationConfig] = (0, _reactDefault.default).useState(getGlobalContext);
    const sync = ()=>{
        setNotificationConfig(getGlobalContext);
    };
    (0, _reactDefault.default).useEffect(sync, []);
    const global = (0, _configProvider.globalConfig)();
    const rootPrefixCls = global.getRootPrefixCls();
    const rootIconPrefixCls = global.getIconPrefixCls();
    const theme = global.getTheme();
    const dom = /*#__PURE__*/ (0, _reactDefault.default).createElement(GlobalHolder, {
        ref: ref,
        sync: sync,
        notificationConfig: notificationConfig
    });
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _configProviderDefault.default), {
        prefixCls: rootPrefixCls,
        iconPrefixCls: rootIconPrefixCls,
        theme: theme
    }, global.holderRender ? global.holderRender(dom) : dom);
});
const flushNotificationQueue = ()=>{
    if (!notification) {
        const holderFragment = document.createDocumentFragment();
        const newNotification = {
            fragment: holderFragment
        };
        notification = newNotification;
        // Delay render to avoid sync issue
        act(()=>{
            (0, _render.render)(/*#__PURE__*/ (0, _reactDefault.default).createElement(GlobalHolderWrapper, {
                ref: (node)=>{
                    const { instance, sync } = node || {};
                    Promise.resolve().then(()=>{
                        if (!newNotification.instance && instance) {
                            newNotification.instance = instance;
                            newNotification.sync = sync;
                            flushNotificationQueue();
                        }
                    });
                }
            }), holderFragment);
        });
        return;
    }
    // Notification not ready
    if (!notification.instance) return;
    // >>> Execute task
    taskQueue.forEach((task)=>{
        switch(task.type){
            case 'open':
                act(()=>{
                    notification.instance.open({
                        ...defaultGlobalConfig,
                        ...task.config
                    });
                });
                break;
            case 'destroy':
                act(()=>{
                    notification?.instance?.destroy(task.key);
                });
                break;
        }
    });
    // Clean up
    taskQueue = [];
};
// ==============================================================================
// ==                                  Export                                  ==
// ==============================================================================
function setNotificationGlobalConfig(config) {
    defaultGlobalConfig = {
        ...defaultGlobalConfig,
        ...config
    };
    // Trigger sync for it
    act(()=>{
        notification?.sync?.();
    });
}
function open(config) {
    const global = (0, _configProvider.globalConfig)();
    taskQueue.push({
        type: 'open',
        config
    });
    flushNotificationQueue();
}
const destroy = (key)=>{
    taskQueue.push({
        type: 'destroy',
        key
    });
    flushNotificationQueue();
};
const methods = [
    'success',
    'info',
    'warning',
    'error'
];
const baseStaticMethods = {
    open,
    destroy,
    config: setNotificationGlobalConfig,
    useNotification: (0, _useNotificationDefault.default),
    _InternalPanelDoNotUseOrYouWillBeFired: (0, _purePanelDefault.default)
};
const staticMethods = baseStaticMethods;
methods.forEach((type)=>{
    staticMethods[type] = (config)=>open({
            ...config,
            type
        });
});
// ==============================================================================
// ==                                   Test                                   ==
// ==============================================================================
const noop = ()=>{};
let _actWrapper = noop;
var wrapper;
const actWrapper = _actWrapper;
let _actDestroy = noop;
const actDestroy = _actDestroy;
exports.default = staticMethods;

},{"react":"bmhQu","@rc-component/util/es/React/render":"jackC","../app/context":"jadUJ","../config-provider":"dVeAX","./PurePanel":"i3uQ3","./useNotification":"3HxWI","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i3uQ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TypeIcon", ()=>TypeIcon);
parcelHelpers.export(exports, "getCloseIcon", ()=>getCloseIcon);
parcelHelpers.export(exports, "PureContent", ()=>PureContent);
var _react = require("react");
var _checkCircleFilled = require("@ant-design/icons/es/icons/CheckCircleFilled");
var _checkCircleFilledDefault = parcelHelpers.interopDefault(_checkCircleFilled);
var _closeCircleFilled = require("@ant-design/icons/es/icons/CloseCircleFilled");
var _closeCircleFilledDefault = parcelHelpers.interopDefault(_closeCircleFilled);
var _closeOutlined = require("@ant-design/icons/es/icons/CloseOutlined");
var _closeOutlinedDefault = parcelHelpers.interopDefault(_closeOutlined);
var _exclamationCircleFilled = require("@ant-design/icons/es/icons/ExclamationCircleFilled");
var _exclamationCircleFilledDefault = parcelHelpers.interopDefault(_exclamationCircleFilled);
var _infoCircleFilled = require("@ant-design/icons/es/icons/InfoCircleFilled");
var _infoCircleFilledDefault = parcelHelpers.interopDefault(_infoCircleFilled);
var _loadingOutlined = require("@ant-design/icons/es/icons/LoadingOutlined");
var _loadingOutlinedDefault = parcelHelpers.interopDefault(_loadingOutlined);
var _notification = require("@rc-component/notification");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _warning = require("../_util/warning");
var _configProvider = require("../config-provider");
var _context = require("../config-provider/context");
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _purePanel = require("./style/pure-panel");
var _purePanelDefault = parcelHelpers.interopDefault(_purePanel);
"use client";
const TypeIcon = {
    info: /*#__PURE__*/ _react.createElement((0, _infoCircleFilledDefault.default), null),
    success: /*#__PURE__*/ _react.createElement((0, _checkCircleFilledDefault.default), null),
    error: /*#__PURE__*/ _react.createElement((0, _closeCircleFilledDefault.default), null),
    warning: /*#__PURE__*/ _react.createElement((0, _exclamationCircleFilledDefault.default), null),
    loading: /*#__PURE__*/ _react.createElement((0, _loadingOutlinedDefault.default), null)
};
function getCloseIcon(prefixCls, closeIcon) {
    if (closeIcon === null || closeIcon === false) return null;
    return closeIcon || /*#__PURE__*/ _react.createElement((0, _closeOutlinedDefault.default), {
        className: `${prefixCls}-close-icon`
    });
}
const typeToIcon = {
    success: (0, _checkCircleFilledDefault.default),
    info: (0, _infoCircleFilledDefault.default),
    error: (0, _closeCircleFilledDefault.default),
    warning: (0, _exclamationCircleFilledDefault.default)
};
const PureContent = (props)=>{
    const { prefixCls, icon, type, title, description, actions, role = 'alert', styles, classNames: pureContentCls } = props;
    let iconNode = null;
    if (icon) iconNode = /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(`${prefixCls}-icon`, pureContentCls.icon),
        style: styles.icon
    }, icon);
    else if (type) iconNode = /*#__PURE__*/ _react.createElement(typeToIcon[type] || null, {
        className: (0, _clsx.clsx)(`${prefixCls}-icon`, pureContentCls.icon, `${prefixCls}-icon-${type}`),
        style: styles.icon
    });
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)({
            [`${prefixCls}-with-icon`]: iconNode
        }),
        role: role
    }, iconNode, /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-title`, pureContentCls.title),
        style: styles.title
    }, title), description && /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-description`, pureContentCls.description),
        style: styles.description
    }, description), actions && /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${prefixCls}-actions`, pureContentCls.actions),
        style: styles.actions
    }, actions));
};
/** @private Internal Component. Do not use in your production. */ const PurePanel = (props)=>{
    const { prefixCls: staticPrefixCls, icon, type, message, title, description, btn, actions, closeIcon: _closeIcon, className: notificationClassName, style, styles, classNames: notificationClassNames, closable, ...restProps } = props;
    const { getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('notification');
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        notificationClassNames
    ], [
        contextStyles,
        styles
    ], {
        props
    });
    const { notification: notificationContext } = _react.useContext((0, _configProvider.ConfigContext));
    const mergedActions = actions ?? btn;
    var deprecatedName, newName;
    const mergedTitle = title ?? message;
    const prefixCls = staticPrefixCls || getPrefixCls('notification');
    const noticePrefixCls = `${prefixCls}-notice`;
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
    const [rawClosable, mergedCloseIcon, , ariaProps] = (0, _hooks.useClosable)((0, _hooks.pickClosable)(props), (0, _hooks.pickClosable)(notificationContext), {
        closable: true,
        closeIcon: /*#__PURE__*/ _react.createElement((0, _closeOutlinedDefault.default), {
            className: `${prefixCls}-close-icon`
        }),
        closeIconRender: (icon)=>getCloseIcon(prefixCls, icon)
    });
    const mergedClosable = rawClosable ? {
        onClose: closable && typeof closable === 'object' ? closable?.onClose : undefined,
        closeIcon: mergedCloseIcon,
        ...ariaProps
    } : false;
    return /*#__PURE__*/ _react.createElement("div", {
        className: (0, _clsx.clsx)(`${noticePrefixCls}-pure-panel`, hashId, notificationClassName, cssVarCls, rootCls, mergedClassNames.root),
        style: mergedStyles.root
    }, /*#__PURE__*/ _react.createElement((0, _purePanelDefault.default), {
        prefixCls: prefixCls
    }), /*#__PURE__*/ _react.createElement((0, _notification.Notice), {
        style: {
            ...contextStyle,
            ...style
        },
        ...restProps,
        prefixCls: prefixCls,
        eventKey: "pure",
        duration: null,
        closable: mergedClosable,
        className: (0, _clsx.clsx)(notificationClassName, contextClassName),
        content: /*#__PURE__*/ _react.createElement(PureContent, {
            classNames: mergedClassNames,
            styles: mergedStyles,
            prefixCls: noticePrefixCls,
            icon: icon,
            type: type,
            title: mergedTitle,
            description: description,
            actions: mergedActions
        })
    }));
};
exports.default = PurePanel;

},{"react":"bmhQu","@ant-design/icons/es/icons/CheckCircleFilled":"gk31P","@ant-design/icons/es/icons/CloseCircleFilled":"d3fPr","@ant-design/icons/es/icons/CloseOutlined":"dinn5","@ant-design/icons/es/icons/ExclamationCircleFilled":"24nhX","@ant-design/icons/es/icons/InfoCircleFilled":"aiTER","@ant-design/icons/es/icons/LoadingOutlined":"8Mvdh","@rc-component/notification":"aCyv5","clsx":"431Ou","../_util/hooks":[["pickClosable","cC5so"],["useClosable","cC5so"],["useMergeSemantic","kdnMA"]],"../_util/warning":"95o3w","../config-provider":"dVeAX","../config-provider/context":"75zwC","../config-provider/hooks/useCSSVarCls":"gcu2s","./style":"1I8hr","./style/pure-panel":"fl4Yy","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1I8hr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "genNoticeStyle", ()=>genNoticeStyle);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
parcelHelpers.export(exports, "prepareNotificationToken", ()=>prepareNotificationToken);
var _cssinjs = require("@ant-design/cssinjs");
var _hooks = require("../../_util/hooks");
var _style = require("../../style");
var _internal = require("../../theme/internal");
var _placement = require("./placement");
var _placementDefault = parcelHelpers.interopDefault(_placement);
var _stack = require("./stack");
var _stackDefault = parcelHelpers.interopDefault(_stack);
const genNoticeStyle = (token)=>{
    const { iconCls, componentCls, // .ant-notification
    boxShadow, fontSizeLG, notificationMarginBottom, borderRadiusLG, colorSuccess, colorInfo, colorWarning, colorError, colorTextHeading, notificationBg, notificationPadding, notificationMarginEdge, progressBg, notificationProgressHeight, fontSize, lineHeight, width, notificationIconSize, colorText, colorSuccessBg, colorErrorBg, colorInfoBg, colorWarningBg } = token;
    const noticeCls = `${componentCls}-notice`;
    return {
        position: 'relative',
        marginBottom: notificationMarginBottom,
        marginInlineStart: 'auto',
        background: notificationBg,
        borderRadius: borderRadiusLG,
        boxShadow,
        [noticeCls]: {
            padding: notificationPadding,
            width,
            maxWidth: `calc(100vw - ${(0, _cssinjs.unit)(token.calc(notificationMarginEdge).mul(2).equal())})`,
            lineHeight,
            wordWrap: 'break-word',
            borderRadius: borderRadiusLG,
            overflow: 'hidden',
            // Type-specific background colors
            '&-success': colorSuccessBg ? {
                background: colorSuccessBg
            } : {},
            '&-error': colorErrorBg ? {
                background: colorErrorBg
            } : {},
            '&-info': colorInfoBg ? {
                background: colorInfoBg
            } : {},
            '&-warning': colorWarningBg ? {
                background: colorWarningBg
            } : {}
        },
        [`${noticeCls}-title`]: {
            marginBottom: token.marginXS,
            color: colorTextHeading,
            fontSize: fontSizeLG,
            lineHeight: token.lineHeightLG
        },
        [`${noticeCls}-description`]: {
            fontSize,
            color: colorText,
            marginTop: token.marginXS
        },
        [`${noticeCls}-closable ${noticeCls}-title`]: {
            paddingInlineEnd: token.paddingLG
        },
        [`${noticeCls}-with-icon ${noticeCls}-title`]: {
            marginBottom: token.marginXS,
            marginInlineStart: token.calc(token.marginSM).add(notificationIconSize).equal(),
            fontSize: fontSizeLG
        },
        [`${noticeCls}-with-icon ${noticeCls}-description`]: {
            marginInlineStart: token.calc(token.marginSM).add(notificationIconSize).equal(),
            fontSize
        },
        // Icon & color style in different selector level
        // https://github.com/ant-design/ant-design/issues/16503
        // https://github.com/ant-design/ant-design/issues/15512
        [`${noticeCls}-icon`]: {
            position: 'absolute',
            fontSize: notificationIconSize,
            lineHeight: 1,
            // icon-font
            [`&-success${iconCls}`]: {
                color: colorSuccess
            },
            [`&-info${iconCls}`]: {
                color: colorInfo
            },
            [`&-warning${iconCls}`]: {
                color: colorWarning
            },
            [`&-error${iconCls}`]: {
                color: colorError
            }
        },
        [`${noticeCls}-close`]: {
            position: 'absolute',
            top: token.notificationPaddingVertical,
            insetInlineEnd: token.notificationPaddingHorizontal,
            color: token.colorIcon,
            outline: 'none',
            width: token.notificationCloseButtonSize,
            height: token.notificationCloseButtonSize,
            borderRadius: token.borderRadiusSM,
            transition: `background-color ${token.motionDurationMid}, color ${token.motionDurationMid}`,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'none',
            border: 'none',
            '&:hover': {
                color: token.colorIconHover,
                backgroundColor: token.colorBgTextHover
            },
            '&:active': {
                backgroundColor: token.colorBgTextActive
            },
            ...(0, _style.genFocusStyle)(token)
        },
        [`${noticeCls}-progress`]: {
            position: 'absolute',
            display: 'block',
            appearance: 'none',
            inlineSize: `calc(100% - ${(0, _cssinjs.unit)(borderRadiusLG)} * 2)`,
            left: {
                _skip_check_: true,
                value: borderRadiusLG
            },
            right: {
                _skip_check_: true,
                value: borderRadiusLG
            },
            bottom: 0,
            blockSize: notificationProgressHeight,
            border: 0,
            '&, &::-webkit-progress-bar': {
                borderRadius: borderRadiusLG,
                backgroundColor: `rgba(0, 0, 0, 0.04)`
            },
            '&::-moz-progress-bar': {
                background: progressBg
            },
            '&::-webkit-progress-value': {
                borderRadius: borderRadiusLG,
                background: progressBg
            }
        },
        [`${noticeCls}-actions`]: {
            float: 'right',
            marginTop: token.marginSM
        }
    };
};
const genNotificationStyle = (token)=>{
    const { componentCls, // .ant-notification
    notificationMarginBottom, notificationMarginEdge, motionDurationMid, motionEaseInOut } = token;
    const noticeCls = `${componentCls}-notice`;
    const fadeOut = new (0, _cssinjs.Keyframes)('antNotificationFadeOut', {
        '0%': {
            maxHeight: token.animationMaxHeight,
            marginBottom: notificationMarginBottom
        },
        '100%': {
            maxHeight: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0,
            opacity: 0
        }
    });
    return [
        // ============================ Holder ============================
        {
            [componentCls]: {
                ...(0, _style.resetComponent)(token),
                position: 'fixed',
                zIndex: token.zIndexPopup,
                marginRight: {
                    value: notificationMarginEdge,
                    _skip_check_: true
                },
                [`${componentCls}-hook-holder`]: {
                    position: 'relative'
                },
                //  animation
                [`${componentCls}-fade-appear-prepare`]: {
                    opacity: '0 !important'
                },
                [`${componentCls}-fade-enter, ${componentCls}-fade-appear`]: {
                    animationDuration: token.motionDurationMid,
                    animationTimingFunction: motionEaseInOut,
                    animationFillMode: 'both',
                    opacity: 0,
                    animationPlayState: 'paused'
                },
                [`${componentCls}-fade-leave`]: {
                    animationTimingFunction: motionEaseInOut,
                    animationFillMode: 'both',
                    animationDuration: motionDurationMid,
                    animationPlayState: 'paused'
                },
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationPlayState: 'running'
                },
                [`${componentCls}-fade-leave${componentCls}-fade-leave-active`]: {
                    animationName: fadeOut,
                    animationPlayState: 'running'
                },
                // RTL
                '&-rtl': {
                    direction: 'rtl',
                    [`${noticeCls}-actions`]: {
                        float: 'left'
                    }
                }
            }
        },
        // ============================ Notice ============================
        {
            [componentCls]: {
                [`${noticeCls}-wrapper`]: genNoticeStyle(token)
            }
        }
    ];
};
const prepareComponentToken = (token)=>({
        zIndexPopup: token.zIndexPopupBase + (0, _hooks.CONTAINER_MAX_OFFSET) + 50,
        width: 384,
        progressBg: `linear-gradient(90deg, ${token.colorPrimaryBorderHover}, ${token.colorPrimary})`,
        // Fix notification background color issue
        // https://github.com/ant-design/ant-design/issues/55649
        // https://github.com/ant-design/ant-design/issues/56055
        colorSuccessBg: undefined,
        colorErrorBg: undefined,
        colorInfoBg: undefined,
        colorWarningBg: undefined
    });
const prepareNotificationToken = (token)=>{
    const notificationPaddingVertical = token.paddingMD;
    const notificationPaddingHorizontal = token.paddingLG;
    const notificationToken = (0, _internal.mergeToken)(token, {
        notificationBg: token.colorBgElevated,
        notificationPaddingVertical,
        notificationPaddingHorizontal,
        notificationIconSize: token.calc(token.fontSizeLG).mul(token.lineHeightLG).equal(),
        notificationCloseButtonSize: token.calc(token.controlHeightLG).mul(0.55).equal(),
        notificationMarginBottom: token.margin,
        notificationPadding: `${(0, _cssinjs.unit)(token.paddingMD)} ${(0, _cssinjs.unit)(token.paddingContentHorizontalLG)}`,
        notificationMarginEdge: token.marginLG,
        animationMaxHeight: 150,
        notificationStackLayer: 3,
        notificationProgressHeight: 2
    });
    return notificationToken;
};
exports.default = (0, _internal.genStyleHooks)('Notification', (token)=>{
    const notificationToken = prepareNotificationToken(token);
    return [
        genNotificationStyle(notificationToken),
        (0, _placementDefault.default)(notificationToken),
        (0, _stackDefault.default)(notificationToken)
    ];
}, prepareComponentToken);

},{"@ant-design/cssinjs":"2VNL8","../../_util/hooks":"6noQ6","../../style":"4Ezp0","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"./placement":"60O60","./stack":"5G7jh","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"60O60":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
const genNotificationPlacementStyle = (token)=>{
    const { componentCls, notificationMarginEdge, animationMaxHeight } = token;
    const noticeCls = `${componentCls}-notice`;
    const rightFadeIn = new (0, _cssinjs.Keyframes)('antNotificationFadeIn', {
        '0%': {
            transform: `translate3d(100%, 0, 0)`,
            opacity: 0
        },
        '100%': {
            transform: `translate3d(0, 0, 0)`,
            opacity: 1
        }
    });
    const topFadeIn = new (0, _cssinjs.Keyframes)('antNotificationTopFadeIn', {
        '0%': {
            top: -animationMaxHeight,
            opacity: 0
        },
        '100%': {
            top: 0,
            opacity: 1
        }
    });
    const bottomFadeIn = new (0, _cssinjs.Keyframes)('antNotificationBottomFadeIn', {
        '0%': {
            bottom: token.calc(animationMaxHeight).mul(-1).equal(),
            opacity: 0
        },
        '100%': {
            bottom: 0,
            opacity: 1
        }
    });
    const leftFadeIn = new (0, _cssinjs.Keyframes)('antNotificationLeftFadeIn', {
        '0%': {
            transform: `translate3d(-100%, 0, 0)`,
            opacity: 0
        },
        '100%': {
            transform: `translate3d(0, 0, 0)`,
            opacity: 1
        }
    });
    return {
        [componentCls]: {
            [`&${componentCls}-top, &${componentCls}-bottom`]: {
                marginInline: 0,
                [noticeCls]: {
                    marginInline: 'auto auto'
                }
            },
            [`&${componentCls}-top`]: {
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: topFadeIn
                }
            },
            [`&${componentCls}-bottom`]: {
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: bottomFadeIn
                }
            },
            [`&${componentCls}-topRight, &${componentCls}-bottomRight`]: {
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: rightFadeIn
                }
            },
            [`&${componentCls}-topLeft, &${componentCls}-bottomLeft`]: {
                marginRight: {
                    value: 0,
                    _skip_check_: true
                },
                marginLeft: {
                    value: notificationMarginEdge,
                    _skip_check_: true
                },
                [noticeCls]: {
                    marginInlineEnd: 'auto',
                    marginInlineStart: 0
                },
                [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
                    animationName: leftFadeIn
                }
            }
        }
    };
};
exports.default = genNotificationPlacementStyle;

},{"@ant-design/cssinjs":"2VNL8","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5G7jh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _interface = require("../interface");
const placementAlignProperty = {
    topLeft: 'left',
    topRight: 'right',
    bottomLeft: 'left',
    bottomRight: 'right',
    top: 'left',
    bottom: 'left'
};
const genPlacementStackStyle = (token, placement)=>{
    const { componentCls } = token;
    return {
        [`${componentCls}-${placement}`]: {
            [`&${componentCls}-stack > ${componentCls}-notice-wrapper`]: {
                [placement.startsWith('top') ? 'top' : 'bottom']: 0,
                [placementAlignProperty[placement]]: {
                    value: 0,
                    _skip_check_: true
                }
            }
        }
    };
};
const genStackChildrenStyle = (token)=>{
    const childrenStyle = {};
    for(let i = 1; i < token.notificationStackLayer; i++)childrenStyle[`&:nth-last-child(${i + 1})`] = {
        overflow: 'hidden',
        [`& > ${token.componentCls}-notice`]: {
            opacity: 0,
            transition: `opacity ${token.motionDurationMid}`
        }
    };
    return {
        [`&:not(:nth-last-child(-n+${token.notificationStackLayer}))`]: {
            opacity: 0,
            overflow: 'hidden',
            color: 'transparent',
            pointerEvents: 'none'
        },
        ...childrenStyle
    };
};
const genStackedNoticeStyle = (token)=>{
    const childrenStyle = {};
    for(let i = 1; i < token.notificationStackLayer; i++)childrenStyle[`&:nth-last-child(${i + 1})`] = {
        background: token.colorBgBlur,
        backdropFilter: 'blur(10px)',
        '-webkit-backdrop-filter': 'blur(10px)'
    };
    return {
        ...childrenStyle
    };
};
const genStackStyle = (token)=>{
    const { componentCls } = token;
    return {
        [`${componentCls}-stack`]: {
            [`& > ${componentCls}-notice-wrapper`]: {
                transition: `transform ${token.motionDurationSlow}, backdrop-filter 0s`,
                willChange: 'transform, opacity',
                position: 'absolute',
                ...genStackChildrenStyle(token)
            }
        },
        [`${componentCls}-stack:not(${componentCls}-stack-expanded)`]: {
            [`& > ${componentCls}-notice-wrapper`]: {
                ...genStackedNoticeStyle(token)
            }
        },
        [`${componentCls}-stack${componentCls}-stack-expanded`]: {
            [`& > ${componentCls}-notice-wrapper`]: {
                '&:not(:nth-last-child(-n + 1))': {
                    opacity: 1,
                    overflow: 'unset',
                    color: 'inherit',
                    pointerEvents: 'auto',
                    [`& > ${token.componentCls}-notice`]: {
                        opacity: 1
                    }
                },
                '&:after': {
                    content: '""',
                    position: 'absolute',
                    height: token.margin,
                    width: '100%',
                    insetInline: 0,
                    bottom: token.calc(token.margin).mul(-1).equal(),
                    background: 'transparent',
                    pointerEvents: 'auto'
                }
            }
        },
        ...(0, _interface.NotificationPlacements).map((placement)=>genPlacementStackStyle(token, placement)).reduce((acc, cur)=>({
                ...acc,
                ...cur
            }), {})
    };
};
exports.default = genStackStyle;

},{"../interface":"hICXZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hICXZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotificationPlacements", ()=>NotificationPlacements);
const NotificationPlacements = [
    'top',
    'topLeft',
    'topRight',
    'bottom',
    'bottomLeft',
    'bottomRight'
];

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fl4Yy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _cssinjs = require("@ant-design/cssinjs");
var _ = require(".");
var _internal = require("../../theme/internal");
exports.default = (0, _internal.genSubStyleComponent)([
    'Notification',
    'PurePanel'
], (token)=>{
    const noticeCls = `${token.componentCls}-notice`;
    const notificationToken = (0, _.prepareNotificationToken)(token);
    return {
        [`${noticeCls}-pure-panel`]: {
            ...(0, _.genNoticeStyle)(notificationToken),
            width: notificationToken.width,
            maxWidth: `calc(100vw - ${(0, _cssinjs.unit)(token.calc(notificationToken.notificationMarginEdge).mul(2).equal())})`,
            margin: 0
        }
    };
}, (0, _.prepareComponentToken));

},{"@ant-design/cssinjs":"2VNL8",".":"1I8hr","../../theme/internal":"eQVSZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3HxWI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// ==============================================================================
// ==                                   Hook                                   ==
// ==============================================================================
parcelHelpers.export(exports, "useInternalNotification", ()=>useInternalNotification);
parcelHelpers.export(exports, "default", ()=>useNotification);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _notification = require("@rc-component/notification");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _warning = require("../_util/warning");
var _configProvider = require("../config-provider");
var _context = require("../config-provider/context");
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _internal = require("../theme/internal");
var _purePanel = require("./PurePanel");
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
var _util = require("./util");
"use client";
const DEFAULT_OFFSET = 24;
const DEFAULT_DURATION = 4.5;
const DEFAULT_PLACEMENT = 'topRight';
const Wrapper = ({ children, prefixCls })=>{
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
    return /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _notification.NotificationProvider), {
        classNames: {
            list: (0, _clsx.clsx)(hashId, cssVarCls, rootCls)
        }
    }, children);
};
const renderNotifications = (node, { prefixCls, key })=>/*#__PURE__*/ (0, _reactDefault.default).createElement(Wrapper, {
        prefixCls: prefixCls,
        key: key
    }, node);
const Holder = /*#__PURE__*/ (0, _reactDefault.default).forwardRef((props, ref)=>{
    const { top, bottom, prefixCls: staticPrefixCls, getContainer: staticGetContainer, maxCount, rtl, onAllRemoved, stack, duration = DEFAULT_DURATION, pauseOnHover = true, showProgress } = props;
    const { getPrefixCls, getPopupContainer, direction } = (0, _context.useComponentConfig)('notification');
    const { notification } = (0, _react.useContext)((0, _configProvider.ConfigContext));
    const [, token] = (0, _internal.useToken)();
    const prefixCls = staticPrefixCls || getPrefixCls('notification');
    const mergedDuration = (0, _react.useMemo)(()=>typeof duration === 'number' && duration > 0 ? duration : false, [
        duration
    ]);
    // =============================== Style ===============================
    const getStyle = (placement)=>(0, _util.getPlacementStyle)(placement, top ?? DEFAULT_OFFSET, bottom ?? DEFAULT_OFFSET);
    const getClassName = ()=>(0, _clsx.clsx)({
            [`${prefixCls}-rtl`]: rtl ?? direction === 'rtl'
        });
    // ============================== Motion ===============================
    const getNotificationMotion = ()=>(0, _util.getMotion)(prefixCls);
    // ============================== Origin ===============================
    const [api, holder] = (0, _notification.useNotification)({
        prefixCls,
        style: getStyle,
        className: getClassName,
        motion: getNotificationMotion,
        closable: {
            closeIcon: (0, _purePanel.getCloseIcon)(prefixCls)
        },
        duration: mergedDuration,
        getContainer: ()=>staticGetContainer?.() || getPopupContainer?.() || document.body,
        maxCount,
        pauseOnHover,
        showProgress,
        onAllRemoved,
        renderNotifications,
        stack: stack === false ? false : {
            threshold: typeof stack === 'object' ? stack?.threshold : undefined,
            offset: 8,
            gap: token.margin
        }
    });
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        notification?.classNames,
        props?.classNames
    ], [
        notification?.styles,
        props?.styles
    ], {
        props
    });
    // ================================ Ref ================================
    (0, _reactDefault.default).useImperativeHandle(ref, ()=>({
            ...api,
            prefixCls,
            notification,
            classNames: mergedClassNames,
            styles: mergedStyles
        }));
    return holder;
});
function useInternalNotification(notificationConfig) {
    const holderRef = (0, _reactDefault.default).useRef(null);
    const warning = (0, _warning.devUseWarning)('Notification');
    const { notification: notificationContext } = (0, _reactDefault.default).useContext((0, _configProvider.ConfigContext));
    // ================================ API ================================
    const wrapAPI = (0, _reactDefault.default).useMemo(()=>{
        // Wrap with notification content
        // >>> Open
        const open = (config)=>{
            if (!holderRef.current) return;
            const { open: originOpen, prefixCls, notification, classNames: originClassNames, styles: originStyles } = holderRef.current;
            const contextClassName = notification?.className || {};
            const contextStyle = notification?.style || {};
            const noticePrefixCls = `${prefixCls}-notice`;
            const { title, message, description, icon, type, btn, actions, className, style, role = 'alert', closeIcon, closable, classNames: configClassNames = {}, styles = {}, ...restConfig } = config;
            var deprecatedName, newName;
            const mergedTitle = title ?? message;
            const mergedActions = actions ?? btn;
            const realCloseIcon = (0, _purePanel.getCloseIcon)(noticePrefixCls, (0, _util.getCloseIconConfig)(closeIcon, notificationConfig, notification));
            const [rawClosable, mergedCloseIcon, , ariaProps] = (0, _hooks.computeClosable)((0, _hooks.pickClosable)({
                ...notificationConfig || {},
                ...config
            }), (0, _hooks.pickClosable)(notificationContext), {
                closable: true,
                closeIcon: realCloseIcon
            });
            const mergedClosable = rawClosable ? {
                onClose: closable && typeof closable === 'object' ? closable.onClose : undefined,
                closeIcon: mergedCloseIcon,
                ...ariaProps
            } : false;
            const semanticClassNames = (0, _hooks.resolveStyleOrClass)(configClassNames, {
                props: config
            });
            const semanticStyles = (0, _hooks.resolveStyleOrClass)(styles, {
                props: config
            });
            const mergedClassNames = (0, _hooks.mergeClassNames)(undefined, originClassNames, semanticClassNames);
            const mergedStyles = (0, _hooks.mergeStyles)(originStyles, semanticStyles);
            return originOpen({
                // use placement from props instead of hard-coding "topRight"
                placement: notificationConfig?.placement ?? DEFAULT_PLACEMENT,
                ...restConfig,
                content: /*#__PURE__*/ (0, _reactDefault.default).createElement((0, _purePanel.PureContent), {
                    prefixCls: noticePrefixCls,
                    icon: icon,
                    type: type,
                    title: mergedTitle,
                    description: description,
                    actions: mergedActions,
                    role: role,
                    classNames: mergedClassNames,
                    styles: mergedStyles
                }),
                className: (0, _clsx.clsx)({
                    [`${noticePrefixCls}-${type}`]: type
                }, className, contextClassName, mergedClassNames.root),
                style: {
                    ...contextStyle,
                    ...mergedStyles.root,
                    ...style
                },
                closable: mergedClosable
            });
        };
        // >>> destroy
        const destroy = (key)=>{
            if (key !== undefined) holderRef.current?.close(key);
            else holderRef.current?.destroy();
        };
        const clone = {
            open,
            destroy
        };
        const keys = [
            'success',
            'info',
            'warning',
            'error'
        ];
        keys.forEach((type)=>{
            clone[type] = (config)=>open({
                    ...config,
                    type
                });
        });
        return clone;
    }, [
        notificationConfig,
        notificationContext
    ]);
    // ============================== Return ===============================
    return [
        wrapAPI,
        /*#__PURE__*/ (0, _reactDefault.default).createElement(Holder, {
            key: "notification-holder",
            ...notificationConfig,
            ref: holderRef
        })
    ];
}
function useNotification(notificationConfig) {
    return useInternalNotification(notificationConfig);
}

},{"react":"bmhQu","@rc-component/notification":"aCyv5","clsx":"431Ou","../_util/hooks":[["computeClosable","cC5so"],["pickClosable","cC5so"],["mergeClassNames","kdnMA"],["mergeStyles","kdnMA"],["resolveStyleOrClass","kdnMA"],["useMergeSemantic","kdnMA"]],"../_util/warning":"95o3w","../config-provider":"dVeAX","../config-provider/context":"75zwC","../config-provider/hooks/useCSSVarCls":"gcu2s","../theme/internal":[["useToken","6x222","default"]],"./PurePanel":"i3uQ3","./style":"1I8hr","./util":"ecyZi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ecyZi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "getPlacementStyle", ()=>getPlacementStyle);
parcelHelpers.export(exports, "getMotion", ()=>getMotion);
parcelHelpers.export(exports, "getCloseIconConfig", ()=>getCloseIconConfig);
function getPlacementStyle(placement, top, bottom) {
    let style;
    switch(placement){
        case 'top':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top,
                bottom: 'auto'
            };
            break;
        case 'topLeft':
            style = {
                left: 0,
                top,
                bottom: 'auto'
            };
            break;
        case 'topRight':
            style = {
                right: 0,
                top,
                bottom: 'auto'
            };
            break;
        case 'bottom':
            style = {
                left: '50%',
                transform: 'translateX(-50%)',
                right: 'auto',
                top: 'auto',
                bottom
            };
            break;
        case 'bottomLeft':
            style = {
                left: 0,
                top: 'auto',
                bottom
            };
            break;
        default:
            style = {
                right: 0,
                top: 'auto',
                bottom
            };
            break;
    }
    return style;
}
function getMotion(prefixCls) {
    return {
        motionName: `${prefixCls}-fade`
    };
}
function getCloseIconConfig(closeIcon, notificationConfig, notification) {
    if (typeof closeIcon !== 'undefined') return closeIcon;
    if (typeof notificationConfig?.closeIcon !== 'undefined') return notificationConfig.closeIcon;
    return notification?.closeIcon;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8bpTy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useMockGenerateWorkoutProgramCoachProd", ()=>useMockGenerateWorkoutProgramCoachProd);
var _reactQuery = require("@tanstack/react-query");
var _dayjs = require("dayjs");
var _dayjsDefault = parcelHelpers.interopDefault(_dayjs);
const useMockGenerateWorkoutProgramCoachProd = ()=>{
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            // Simulate network delay
            await new Promise((resolve)=>setTimeout(resolve, 1500));
            const params = payload.parameters;
            // Parse program duration (e.g., '4-weeks' -> 4)
            const durationStr = params.program_duration?.[0] || '4-weeks';
            const weeksMatch = durationStr.match(/\d+/);
            const weeks = weeksMatch ? parseInt(weeksMatch[0], 10) : 4;
            // Parse training schedule
            const schedule = params.training_schedule || [
                'monday',
                'wednesday',
                'friday'
            ];
            const total_workout_days = weeks * schedule.length;
            // Generate chronological dates starting from today
            const workoutDates = [];
            let current = (0, _dayjsDefault.default)();
            while(workoutDates.length < total_workout_days){
                if (schedule.includes(current.format('dddd').toLowerCase())) workoutDates.push(current);
                current = current.add(1, 'day');
            }
            // Exercise pools for randomization
            const warmUpPool = [
                {
                    duration: 60,
                    title: 'Arm circling'
                },
                {
                    duration: 60,
                    title: 'Jumping jacks'
                },
                {
                    duration: 60,
                    title: 'High knees'
                },
                {
                    duration: 60,
                    title: 'Torso twist'
                },
                {
                    duration: 60,
                    title: 'Leg swings'
                }
            ];
            const coolDownPool = [
                {
                    duration: 60,
                    title: 'Bird dog crunch'
                },
                {
                    duration: 60,
                    title: 'Glute bridge'
                },
                {
                    duration: 60,
                    title: 'Standing kick back'
                },
                {
                    duration: 60,
                    title: 'Childs pose'
                },
                {
                    duration: 60,
                    title: 'Cobra stretch'
                }
            ];
            const movesPool = [
                {
                    title: 'PushUp',
                    weight: '0',
                    minReps: 8,
                    maxReps: 15,
                    sets: 3
                },
                {
                    title: 'UpperCut',
                    weight: '0',
                    minReps: 16,
                    maxReps: 24,
                    sets: 2
                },
                {
                    title: 'KettlebellSwing',
                    weight: '8',
                    minReps: 10,
                    maxReps: 15,
                    sets: 3
                },
                {
                    title: 'Burpees',
                    weight: '0',
                    minReps: 6,
                    maxReps: 12,
                    sets: 3
                },
                {
                    title: 'Squats',
                    weight: '0',
                    minReps: 12,
                    maxReps: 20,
                    sets: 4
                },
                {
                    title: 'Dumbbell Row',
                    weight: '10',
                    minReps: 8,
                    maxReps: 12,
                    sets: 3
                }
            ];
            const getRandomItems = (arr, count)=>{
                const shuffled = [
                    ...arr
                ].sort(()=>0.5 - Math.random());
                return shuffled.slice(0, count);
            };
            // Generate the datetimeList array
            const datetimeList = workoutDates.map((date)=>{
                const dailyWarmUp = getRandomItems(warmUpPool, 2);
                const dailyCoolDown = getRandomItems(coolDownPool, 2);
                const dailyMovesDef = getRandomItems(movesPool, 3);
                const dailyMoves = dailyMovesDef.map((moveDef)=>{
                    const actualReps = Math.floor(Math.random() * (moveDef.maxReps - moveDef.minReps + 1)) + moveDef.minReps;
                    return {
                        title: moveDef.title,
                        list: Array.from({
                            length: moveDef.sets
                        }).map(()=>({
                                reps: actualReps.toString(),
                                rest: '60s',
                                weight: moveDef.weight
                            }))
                    };
                });
                return {
                    coolDownMoves: dailyCoolDown,
                    day: date.format('D'),
                    hour: 8,
                    minute: 0,
                    month: parseInt(date.format('M'), 10),
                    moves: dailyMoves,
                    selectTime: '08:00',
                    warmUpMoves: dailyWarmUp,
                    weekday: date.format('dddd'),
                    weekday2: date.format('ddd'),
                    weekdayNum: date.day(),
                    workoutType: (params.training_goal?.[0] || 'increase strength').replace(/-/g, ' '),
                    year: date.year(),
                    ymd: date.format('YYYY-MM-DD')
                };
            });
            // Construct metadata
            const chunks_generated = Math.ceil(weeks / 2); // Sample had 2 chunks for 4 weeks
            const chunk_details = [];
            for(let i = 0; i < chunks_generated; i++)chunk_details.push({
                chunk_number: i + 1,
                days_generated: schedule.length * 2,
                week_range: `${i * 2 + 1}-${(i + 1) * 2}`
            });
            const createTime = (0, _dayjsDefault.default)().toISOString();
            const response = {
                result: {
                    metadata: {
                        chunk_details,
                        chunks_generated,
                        clientId: payload.clientId || '',
                        programId: '',
                        total_workout_days
                    },
                    program: {
                        data: {
                            area: (params.training_goal_details?.[0] || 'upper body strength').replace(/-/g, ' '),
                            createTime,
                            datetimeList,
                            duration: weeks.toString(),
                            isActive: 'true',
                            programmeName: 'Mock Generated Program',
                            updateTime: createTime
                        }
                    }
                }
            };
            return response;
        }
    });
};

},{"@tanstack/react-query":"ehKs4","dayjs":"adpMK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hvohk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useGenerateWorkoutProgramCoachProd", ()=>useGenerateWorkoutProgramCoachProd);
var _reactQuery = require("@tanstack/react-query");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
function mapToPlanData(payload) {
    const isDev = typeof window !== 'undefined' ? window.location.hostname.includes('localhost') || window.location.hostname.includes('127.0.0.1') || window.location.hostname.includes('dev.3rddigital.com') : false;
    const envFlag = isDev ? 'dev' : 'prod';
    if (payload.user_id && payload.selected_days) return {
        ...payload,
        env: payload.env || envFlag
    };
    const params = payload.parameters || {};
    const clientId = payload.clientId || payload.user_id || 'client_001';
    // Duration in weeks
    const durRaw = params.program_duration?.[0] || '4';
    const mWeeks = String(durRaw).match(/\d+/);
    const programLength = mWeeks ? parseInt(mWeeks[0], 10) : 4;
    // Days list
    const scheduleRaw = params.training_schedule || params.how_often_train || [
        'monday',
        'wednesday',
        'friday'
    ];
    const daysList = [];
    if (Array.isArray(scheduleRaw)) scheduleRaw.forEach((s)=>{
        String(s).split(',').forEach((part)=>{
            const trimmed = part.trim();
            if (trimmed && trimmed.toLowerCase() !== 'none') daysList.push(trimmed.charAt(0).toUpperCase() + trimmed.slice(1));
        });
    });
    if (daysList.length === 0) daysList.push('Monday', 'Wednesday', 'Friday');
    const goalRaw = params.training_goal?.[0] || 'increase-strength';
    const formatTitle = (s)=>s.replace(/[-_]/g, ' ').replace(/\b\w/g, (l)=>l.toUpperCase());
    const goalTitle = formatTitle(goalRaw);
    const equipRaw = params.gym_equipments || params.selected_equipment || [
        'dumbell'
    ];
    const equipList = (Array.isArray(equipRaw) ? equipRaw : [
        equipRaw
    ]).filter((e)=>e && String(e).toLowerCase() !== 'none');
    if (equipList.length === 0) equipList.push('dumbell');
    const intensityRaw = params.program_intensity?.[0] || params.intensity?.[0] || 'moderate';
    const intensityTitle = intensityRaw.charAt(0).toUpperCase() + intensityRaw.slice(1).toLowerCase();
    const focusedDetails = params.training_goal_details || [];
    const approaches = params.training_goal_approaches || [];
    const preferences = params.training_goal_preferences || [];
    const focusedArea = focusedDetails.filter((f)=>f && f.toLowerCase() !== 'none').map(formatTitle).join(', ') || goalTitle;
    const muscles = [
        ...focusedDetails.filter((f)=>f && f.toLowerCase() !== 'none').map(formatTitle),
        ...approaches.filter((a)=>a && a.toLowerCase() !== 'none').map(formatTitle)
    ];
    if (muscles.length === 0) muscles.push(goalTitle);
    const todayYmd = new Date().toISOString().split('T')[0];
    return {
        user_id: clientId,
        user_name: payload.userName || `Client ${clientId.slice(0, 6)}`,
        program_name: payload.programName || `${goalTitle} Program`,
        program_type: goalRaw.replace(/-/g, '_'),
        program_length: programLength,
        activation_date: todayYmd,
        equiptments: equipList,
        focused_area: focusedArea,
        muscles: muscles,
        selected_days: daysList,
        workout_intensity: intensityTitle,
        workout_type: goalRaw.replace(/-/g, '_'),
        workout_duration: params.workout_duration?.[0] || '45-min',
        fitness_level: params.fitness_level?.[0] || 'intermediate',
        energy_level: params.energy_level?.[0] || 'moderate',
        goals: [
            goalTitle,
            ...preferences.map(formatTitle)
        ].join('; '),
        preferences: [
            ...preferences.map(formatTitle),
            ...approaches.map(formatTitle)
        ].join('; ') || 'not specified',
        injured_body_parts: (params.injuries_limitations || []).filter((i)=>i && i.toLowerCase() !== 'none').join(', ') || 'none',
        env: envFlag
    };
}
const useGenerateWorkoutProgramCoachProd = ()=>{
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            try {
                const url = (0, _apiConfigDefault.default).GENERATE_WORKOUT_PROGRAM_COACH_PROD_API_HOST.startsWith('http') ? (0, _apiConfigDefault.default).GENERATE_WORKOUT_PROGRAM_COACH_PROD_API_HOST : `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).GENERATE_WORKOUT_PROGRAM_COACH_PROD_API_HOST}`;
                const planData = mapToPlanData(payload);
                const response = await (0, _axiosDefault.default).post(url, planData, {
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    timeout: 600000
                });
                return response.data;
            } catch  {
                // Return null instead of throwing an unhandled exception on 500/network error
                return null;
            }
        }
    });
};

},{"@tanstack/react-query":"ehKs4","axios":"kL5AO","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7y4NZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useSaveClientProgram", ()=>useSaveClientProgram);
var _reactQuery = require("@tanstack/react-query");
var _axios = require("axios");
var _axiosDefault = parcelHelpers.interopDefault(_axios);
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
const useSaveClientProgram = ()=>{
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: async (payload)=>{
            const response = await (0, _axiosDefault.default).post(`${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_SAVE_PROGRAMME_PLAN}`, {
                data: payload
            }, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });
            return response.data;
        },
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-program-plan-list'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientWorkoutsTab'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientProgramTab'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'clientOverview'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'overview'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer_get_client_overview'
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    'clientWorkoutsTab'
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    'clientProgramTab'
                ]
            });
            queryClient.removeQueries({
                queryKey: [
                    'clientOverview'
                ]
            });
        }
    });
};

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQueryClient","97Oud"]],"axios":"kL5AO","src/config/api-config":"9oD3c","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cSB8Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchTrainerProgramPlanById", ()=>fetchTrainerProgramPlanById);
parcelHelpers.export(exports, "useGetTrainerProgramById", ()=>useGetTrainerProgramById);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _deepCamelCaseKeys = require("src/utils/deepCamelCaseKeys");
var _sessionStore = require("src/store/sessionStore");
const fetchTrainerProgramPlanById = async (trainerId, programId)=>{
    if (!trainerId || !programId) throw new Error('Trainer ID or Program ID is missing');
    const queryParams = new URLSearchParams({
        trainerId,
        programId
    });
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_PROGRAM_PLAN_BY_ID}?${queryParams.toString()}`;
    const response = await fetch(apiUrl);
    if (!response.ok) throw new Error(`Failed to fetch trainer program by id: ${response.status}`);
    const res = await response.json();
    const parsedData = (0, _deepCamelCaseKeys.deepCamelCaseKeys)(res.data);
    return parsedData;
};
function useGetTrainerProgramById(programId, isEnabled = true) {
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const trainerId = currentUser?.uid;
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'trainer-program-plan',
            trainerId,
            programId
        ],
        queryFn: ()=>fetchTrainerProgramPlanById(trainerId, programId),
        enabled: !!trainerId && !!programId && isEnabled
    });
}

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","src/utils/deepCamelCaseKeys":"9w8Oj","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5RrLg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDuration);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDuration = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#71BE41",
            d: "M14.444 9.024a.76.76 0 0 1-.777-.762q0-.322.224-.543a.76.76 0 0 1 .553-.219h3.112q.33 0 .554.22t.223.542a.74.74 0 0 1-.224.543.75.75 0 0 1-.553.219zM16 17.404q.33 0 .555-.219a.73.73 0 0 0 .223-.542v-3.048a.73.73 0 0 0-.224-.542.77.77 0 0 0-.554-.22.76.76 0 0 0-.554.22.73.73 0 0 0-.224.542v3.048a.758.758 0 0 0 .778.762m0 6.096q-1.44 0-2.713-.543A7.02 7.02 0 0 1 9.554 19.3 6.5 6.5 0 0 1 9 16.644q0-1.41.555-2.658a7 7 0 0 1 1.506-2.18 7.2 7.2 0 0 1 2.227-1.476A6.8 6.8 0 0 1 16 9.786q1.206 0 2.314.38a7.6 7.6 0 0 1 2.08 1.105l.545-.533a.75.75 0 0 1 .544-.21q.33 0 .545.21.213.21.214.533a.72.72 0 0 1-.214.534l-.545.533a7.4 7.4 0 0 1 1.128 2.038q.39 1.086.389 2.267a6.5 6.5 0 0 1-.555 2.657 7 7 0 0 1-1.506 2.18 7.2 7.2 0 0 1-2.227 1.477A6.8 6.8 0 0 1 16 23.5"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dMi2U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEnergyLevel);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEnergyLevel = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M21.67 15.245c-.23-.284-.51-.53-.77-.775-.67-.567-1.43-.973-2.07-1.568-1.49-1.379-1.82-3.655-.87-5.402-.95.217-1.78.708-2.489 1.247-2.59 1.964-3.61 5.43-2.39 8.406.04.094.08.188.08.311 0 .208-.15.397-.35.472-.23.095-.47.038-.66-.113a.6.6 0 0 1-.14-.16c-1.13-1.351-1.31-3.287-.55-4.836-1.669 1.284-2.579 3.457-2.449 5.506.06.472.12.945.29 1.417.14.567.41 1.133.71 1.634 1.08 1.634 2.95 2.805 4.96 3.04 2.139.256 4.428-.112 6.068-1.51 1.83-1.568 2.47-4.08 1.53-6.234l-.13-.245c-.21-.435-.77-1.19-.77-1.19m-3.16 5.95c-.28.227-.74.472-1.1.567-1.12.377-2.239-.152-2.899-.775 1.19-.264 1.9-1.095 2.11-1.936.17-.756-.15-1.379-.28-2.106-.12-.7-.1-1.294.17-1.946.19.359.39.718.63 1.001.77.945 1.98 1.36 2.24 2.645.04.132.06.264.06.406.03.774-.33 1.624-.93 2.144"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eekbv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFocus);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFocus = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#42CDFF",
            d: "M22.4 12.75v-1.625h-1.6a.796.796 0 0 1-.8-.812q0-.345.23-.579a.77.77 0 0 1 .57-.234h1.6q.66 0 1.13.478.47.477.47 1.147v1.625a.793.793 0 0 1-.8.813.77.77 0 0 1-.57-.235.8.8 0 0 1-.23-.578m-14.4 0v-1.625q0-.671.47-1.147Q8.94 9.5 9.6 9.5h1.6q.34 0 .57.234a.8.8 0 0 1 .23.579q0 .344-.23.579a.76.76 0 0 1-.57.233H9.6v1.625a.793.793 0 0 1-.8.813.77.77 0 0 1-.57-.235.8.8 0 0 1-.23-.578m14.4 9.75h-1.6a.796.796 0 0 1-.8-.812q0-.345.23-.579a.77.77 0 0 1 .57-.234h1.6V19.25a.8.8 0 0 1 .23-.578.77.77 0 0 1 .57-.235q.339 0 .57.235t.23.578v1.625q0 .67-.47 1.148t-1.13.477m-12.8 0q-.66 0-1.13-.477A1.58 1.58 0 0 1 8 20.875V19.25a.8.8 0 0 1 .23-.578.77.77 0 0 1 .57-.235q.339 0 .57.235.232.234.23.578v1.625h1.6q.34 0 .57.234a.8.8 0 0 1 .23.578q0 .345-.23.58a.76.76 0 0 1-.57.233zm1.6-4.875v-3.25q0-.671.47-1.147.47-.477 1.13-.478h6.4q.66 0 1.13.478.47.477.47 1.147v3.25q0 .67-.47 1.148t-1.13.477h-6.4q-.66 0-1.13-.477a1.58 1.58 0 0 1-.47-1.148"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"goOdq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGoalApproached);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGoalApproached = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 32,
        fill: "none",
        viewBox: "0 0 32 32",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#755ADF",
            fillRule: "evenodd",
            d: "M10.65 10.73c.204-.116.519-.23.95-.23s.746.114.95.23c.316.18.41.486.415.704.01.436.035 1.872.035 4.566s-.026 4.13-.035 4.566a.82.82 0 0 1-.415.704c-.204.116-.519.23-.95.23s-.746-.114-.95-.23a.82.82 0 0 1-.415-.704A227 227 0 0 1 10.2 16c0-2.694.026-4.13.035-4.566a.82.82 0 0 1 .415-.704m10.7 0a1.9 1.9 0 0 0-.95-.23c-.431 0-.746.114-.95.23a.82.82 0 0 0-.415.704C19.025 11.87 19 13.306 19 16s.026 4.13.035 4.566a.82.82 0 0 0 .415.704c.204.116.519.23.95.23s.746-.114.95-.23a.82.82 0 0 0 .415-.704c.01-.436.035-1.872.035-4.566s-.026-4.13-.035-4.566a.82.82 0 0 0-.415-.704M8.2 12.397c-.264 0-.476.045-.638.105a.82.82 0 0 0-.538.758C7.016 13.6 7 14.473 7 16s.016 2.4.024 2.74c.006.244.132.61.538.758.162.06.374.105.638.105s.476-.045.638-.105a.82.82 0 0 0 .538-.758c.008-.34.024-1.213.024-2.74s-.016-2.4-.024-2.74a.82.82 0 0 0-.538-.758 1.9 1.9 0 0 0-.638-.105m16.238.105a1.9 1.9 0 0 0-.638-.105c-.264 0-.476.045-.638.105a.82.82 0 0 0-.538.758c-.008.34-.024 1.213-.024 2.74s.016 2.4.024 2.74c.006.244.132.61.538.758.162.06.374.105.638.105s.476-.045.638-.105a.82.82 0 0 0 .538-.758c.008-.34.024-1.213.024-2.74s-.016-2.4-.024-2.74a.82.82 0 0 0-.538-.758M13.8 17.084v-2.168c0-.36.31-.548.641-.575q.102-.01.306-.02c.272-.014.683-.028 1.253-.028s.981.014 1.253.028q.204.01.306.02c.33.026.641.216.641.575v2.168c0 .36-.31.548-.641.575q-.103.01-.306.02c-.272.014-.683.028-1.253.028s-.981-.014-1.253-.028a9 9 0 0 1-.306-.02c-.33-.026-.641-.216-.641-.575",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6ZZuW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSimpleLineCheck);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSimpleLineCheck = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    fill: "#FFA100",
                    d: "M10 0C4.477 0 0 4.477 0 10s4.477 10 10 10 10-4.477 10-10S15.523 0 10 0m0 18.77c-4.825 0-8.75-3.945-8.75-8.77S5.175 1.25 10 1.25s8.75 3.925 8.75 8.75-3.925 8.77-8.75 8.77m3.99-12.43-5.866 5.905-2.642-2.642a.625.625 0 0 0-.885.884l3.094 3.093a.626.626 0 0 0 .958-.09l6.226-6.265a.626.626 0 0 0-.884-.884"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Npqa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "programGeneratorSVG", ()=>programGeneratorSVG);
var _jsxRuntime = require("react/jsx-runtime");
const programGeneratorSVG = {
    header: {
        regenerateWorkout: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            width: 16,
            height: 16,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M6.06945 3.63167C6.46812 2.46501 8.08012 2.42967 8.55278 3.52567L8.59278 3.63234L9.13078 5.20567C9.25408 5.5665 9.45332 5.89668 9.71507 6.17396C9.97682 6.45123 10.295 6.66915 10.6481 6.81301L10.7928 6.86701L12.3661 7.40434C13.5328 7.80301 13.5681 9.41501 12.4728 9.88767L12.3661 9.92768L10.7928 10.4657C10.4318 10.5889 10.1015 10.7881 9.82413 11.0498C9.54673 11.3116 9.32871 11.6298 9.18478 11.983L9.13078 12.127L8.59345 13.701C8.19478 14.8677 6.58278 14.903 6.11078 13.8077L6.06945 13.701L5.53212 12.1277C5.4089 11.7667 5.2097 11.4364 4.94794 11.159C4.68619 10.8816 4.36798 10.6636 4.01478 10.5197L3.87078 10.4657L2.29745 9.92834C1.13012 9.52967 1.09478 7.91767 2.19078 7.44567L2.29745 7.40434L3.87078 6.86701C4.23161 6.74371 4.56179 6.54447 4.83907 6.28272C5.11634 6.02097 5.33426 5.7028 5.47812 5.34967L5.53212 5.20567L6.06945 3.63167ZM12.6648 1.33301C12.7895 1.33301 12.9117 1.36799 13.0176 1.43399C13.1234 1.49998 13.2086 1.59434 13.2635 1.70634L13.2955 1.78434L13.5288 2.46834L14.2135 2.70167C14.3384 2.74414 14.448 2.82275 14.5283 2.92755C14.6085 3.03235 14.6559 3.15862 14.6643 3.29036C14.6727 3.42209 14.6419 3.55336 14.5756 3.66753C14.5093 3.7817 14.4107 3.87363 14.2921 3.93167L14.2135 3.96367L13.5295 4.19701L13.2961 4.88167C13.2536 5.00663 13.1749 5.11614 13.0701 5.19634C12.9652 5.27653 12.8389 5.3238 12.7072 5.33216C12.5755 5.34051 12.4442 5.30957 12.3301 5.24326C12.216 5.17695 12.1241 5.07825 12.0661 4.95967L12.0341 4.88167L11.8008 4.19767L11.1161 3.96434C10.9911 3.92188 10.8816 3.84326 10.8013 3.73846C10.721 3.63366 10.6737 3.5074 10.6653 3.37566C10.6568 3.24393 10.6877 3.11265 10.754 2.99848C10.8202 2.88431 10.9189 2.79238 11.0375 2.73434L11.1161 2.70234L11.8001 2.46901L12.0335 1.78434C12.0784 1.65262 12.1635 1.53828 12.2767 1.45734C12.3899 1.3764 12.5256 1.33292 12.6648 1.33301Z",
                fill: "white",
                fillOpacity: "0.7"
            })
        }),
        assignToClient: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M12 16C10.85 16 9.775 16.175 8.775 16.525C7.775 16.875 6.85 17.3667 6 18V20H18V18C17.15 17.3667 16.225 16.875 15.225 16.525C14.225 16.175 13.15 16 12 16ZM6 22C5.45 22 4.97933 21.8043 4.588 21.413C4.19667 21.0217 4.00067 20.5507 4 20V4C4 3.45 4.196 2.97933 4.588 2.588C4.98 2.19667 5.45067 2.00067 6 2H18C18.55 2 19.021 2.196 19.413 2.588C19.805 2.98 20.0007 3.45067 20 4V20C20 20.55 19.8043 21.021 19.413 21.413C19.0217 21.805 18.5507 22.0007 18 22H6ZM12 14C12.9667 14 13.7917 13.6583 14.475 12.975C15.1583 12.2917 15.5 11.4667 15.5 10.5C15.5 9.53333 15.1583 8.70833 14.475 8.025C13.7917 7.34167 12.9667 7 12 7C11.0333 7 10.2083 7.34167 9.525 8.025C8.84167 8.70833 8.5 9.53333 8.5 10.5C8.5 11.4667 8.84167 12.2917 9.525 12.975C10.2083 13.6583 11.0333 14 12 14Z",
                fill: "white",
                fillOpacity: "0.7"
            })
        }),
        viewInLibrary: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            width: 16,
            height: 16,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M2.67188 8H13.3385M9.33854 4L13.3385 8L9.33854 12",
                stroke: "white",
                strokeWidth: "1.33333",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    },
    sidebar: {
        exerciseLibraryClose: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            width: 32,
            height: 32,
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M11 21L21 11M11 11L21 21",
                stroke: "white",
                strokeWidth: "1.66667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        }),
        exercisePickerDots: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 13,
            height: 24,
            viewBox: "0 0 13 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M5 7C5 7.82843 4.32843 8.5 3.5 8.5C2.67157 8.5 2 7.82843 2 7C2 6.17157 2.67157 5.5 3.5 5.5C4.32843 5.5 5 6.17157 5 7Z",
                    fill: "white",
                    fillOpacity: "0.5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M11 7C11 7.82843 10.3284 8.5 9.5 8.5C8.67157 8.5 8 7.82843 8 7C8 6.17157 8.67157 5.5 9.5 5.5C10.3284 5.5 11 6.17157 11 7Z",
                    fill: "white",
                    fillOpacity: "0.5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M11 12C11 12.8284 10.3284 13.5 9.5 13.5C8.67157 13.5 8 12.8284 8 12C8 11.1716 8.67157 10.5 9.5 10.5C10.3284 10.5 11 11.1716 11 12Z",
                    fill: "white",
                    fillOpacity: "0.5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M5 12C5 12.8284 4.32843 13.5 3.5 13.5C2.67157 13.5 2 12.8284 2 12C2 11.1716 2.67157 10.5 3.5 10.5C4.32843 10.5 5 11.1716 5 12Z",
                    fill: "white",
                    fillOpacity: "0.5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M5 17C5 17.8284 4.32843 18.5 3.5 18.5C2.67157 18.5 2 17.8284 2 17C2 16.1716 2.67157 15.5 3.5 15.5C4.32843 15.5 5 16.1716 5 17Z",
                    fill: "white",
                    fillOpacity: "0.5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M11 17C11 17.8284 10.3284 18.5 9.5 18.5C8.67157 18.5 8 17.8284 8 17C8 16.1716 8.67157 15.5 9.5 15.5C10.3284 15.5 11 16.1716 11 17Z",
                    fill: "white",
                    fillOpacity: "0.5"
                })
            ]
        }),
        toggle: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M7 5.667C7 4.95967 7.28099 4.28131 7.78115 3.78115C8.28131 3.28099 8.95967 3 9.667 3H18.333C18.6832 3 19.03 3.06898 19.3536 3.20301C19.6772 3.33704 19.9712 3.53349 20.2189 3.78115C20.4665 4.0288 20.663 4.32281 20.797 4.64638C20.931 4.96996 21 5.31676 21 5.667V14.333C21 14.6832 20.931 15.03 20.797 15.3536C20.663 15.6772 20.4665 15.9712 20.2189 16.2189C19.9712 16.4665 19.6772 16.663 19.3536 16.797C19.03 16.931 18.6832 17 18.333 17H9.667C8.95967 17 8.28131 16.719 7.78115 16.2189C7.28099 15.7187 7 15.0403 7 14.333V5.667Z",
                    stroke: "#04051B",
                    strokeWidth: 2,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M4.012 7.26C3.705 7.43443 3.44965 7.68702 3.2719 7.99211C3.09415 8.2972 3.00034 8.64391 3 8.997V18.997C3 20.097 3.9 20.997 5 20.997H15C15.75 20.997 16.158 20.612 16.5 19.997M11 7H16M11 10H17M11 13H14",
                    stroke: "#04051B",
                    strokeWidth: 2,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        })
    },
    exerciseType: {
        warmup: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 32,
            height: 32,
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
                    fill: "url(#paint0_linear_12314_32092)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
                    fill: "white",
                    fillOpacity: "0.03"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M16 0.125C24.7675 0.125 31.875 7.23248 31.875 16C31.875 24.7675 24.7675 31.875 16 31.875C7.23248 31.875 0.125 24.7675 0.125 16C0.125 7.23248 7.23248 0.125 16 0.125Z",
                    stroke: "white",
                    strokeOpacity: "0.15",
                    strokeWidth: "0.25"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M21.6699 15.2447C21.44 14.9613 21.16 14.7158 20.9001 14.4702C20.2302 13.9035 19.4703 13.4974 18.8305 12.9024C17.3407 11.5234 17.0108 9.24727 17.9606 7.5C17.0108 7.71723 16.1809 8.20835 15.4711 8.7467C12.8815 10.7112 11.8617 14.1774 13.0815 17.1525C13.1215 17.2469 13.1615 17.3414 13.1615 17.4642C13.1615 17.672 13.0115 17.8609 12.8116 17.9364C12.5816 18.0309 12.3416 17.9742 12.1517 17.8231C12.0949 17.7782 12.0475 17.7237 12.0117 17.6625C10.8819 16.3119 10.7019 14.3758 11.4618 12.8268C9.79211 14.1113 8.88228 16.2836 9.01225 18.3331C9.07224 18.8053 9.13223 19.2776 9.3022 19.7498C9.44218 20.3165 9.71213 20.8832 10.0121 21.3837C11.0919 23.0177 12.9615 24.1888 14.9712 24.4249C17.1108 24.6799 19.4004 24.3116 21.0401 22.9138C22.8697 21.346 23.5096 18.8337 22.5698 16.6803L22.4398 16.4347C22.2298 16.0002 21.6699 15.2447 21.6699 15.2447ZM18.5105 21.1948C18.2306 21.4215 17.7707 21.6671 17.4107 21.7615C16.2909 22.1393 15.1711 21.6104 14.5112 20.9871C15.701 20.7226 16.4109 19.8915 16.6209 19.0509C16.7908 18.2953 16.4709 17.672 16.3409 16.9447C16.2209 16.2458 16.2409 15.6508 16.5109 14.9991C16.7008 15.358 16.9008 15.7169 17.1408 16.0002C17.9106 16.9447 19.1204 17.3603 19.3804 18.6448C19.4203 18.777 19.4403 18.9092 19.4403 19.0509C19.4703 19.8254 19.1104 20.6754 18.5105 21.1948Z",
                    fill: "#E5E5E5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "paint0_linear_12314_32092",
                        x1: "33.45",
                        y1: "32.0083",
                        x2: "8.59413",
                        y2: "-8.20779",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    })
                })
            ]
        }),
        main: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 32,
            height: 32,
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
                    fill: "url(#paint0_linear_12314_32169)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
                    fill: "white",
                    fillOpacity: "0.03"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M16 0.125C24.7675 0.125 31.875 7.23248 31.875 16C31.875 24.7675 24.7675 31.875 16 31.875C7.23248 31.875 0.125 24.7675 0.125 16C0.125 7.23248 7.23248 0.125 16 0.125Z",
                    stroke: "white",
                    strokeOpacity: "0.15",
                    strokeWidth: "0.25"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M22.5069 17.7451C23.8622 17.0587 24.3918 15.4281 23.6897 14.1031C22.9876 12.778 21.3197 12.2603 19.9643 12.9467C18.609 13.6331 18.0794 15.2637 18.7815 16.5888C19.4836 17.9138 21.1515 18.4315 22.5069 17.7451Z",
                    fill: "#E5E5E5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M16.5086 10.3837C17.2063 10.3837 17.7737 10.9386 17.7737 11.6205V13.6022C18.1974 13.4737 18.5481 13.2271 18.7345 12.8538C19.209 11.9045 18.969 10.3351 17.3391 9.37693C15.09 8.0725 13.5501 7.57188 10.8152 7.31911C8.80082 7.28332 8.31958 8.53793 8.09898 9.6171C8.01853 10.0102 7.96952 10.3269 8.02135 10.5831C8.02651 10.6684 8.03756 10.7541 8.0582 10.8401L9.30122 16.0048L8.76704 22.7005C8.70108 23.5269 9.33303 24.2492 10.1785 24.3137C10.2191 24.3168 10.2594 24.3184 10.2994 24.3184C11.0931 24.3184 11.7658 23.7207 11.8285 22.9341L12.3812 16.0054C12.3935 15.851 12.3812 15.6956 12.3451 15.5449L11.441 11.7882C12.8136 12.1566 14.1535 12.7415 15.2435 13.2043V11.6205C15.2435 10.9386 15.811 10.3837 16.5086 10.3837Z",
                    fill: "#E5E5E5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M17.4913 19.3601V11.6205C17.4913 11.09 17.0513 10.6599 16.5086 10.6599C15.966 10.6599 15.526 11.09 15.526 11.6205V19.3601C15.8315 19.2458 16.1625 19.1825 16.5086 19.1825C16.8546 19.1826 17.1858 19.2458 17.4913 19.3601Z",
                    fill: "#E5E5E5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M16.5086 19.4588C15.1418 19.4588 14.0338 20.542 14.0338 21.8783C14.0338 23.2145 15.1418 24.2978 16.5086 24.2978C17.8755 24.2978 18.9835 23.2145 18.9835 21.8783C18.9835 20.542 17.8755 19.4588 16.5086 19.4588ZM16.5086 23.0169C15.8654 23.0169 15.344 22.5071 15.344 21.8783C15.344 21.2494 15.8654 20.7397 16.5086 20.7397C17.1519 20.7397 17.6733 21.2494 17.6733 21.8783C17.6732 22.507 17.1518 23.0169 16.5086 23.0169Z",
                    fill: "#E5E5E5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M16.5086 22.4565C16.8353 22.4565 17.1001 22.1976 17.1001 21.8783C17.1001 21.5589 16.8353 21.3001 16.5086 21.3001C16.182 21.3001 15.9172 21.5589 15.9172 21.8783C15.9172 22.1976 16.182 22.4565 16.5086 22.4565Z",
                    fill: "#E5E5E5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "paint0_linear_12314_32169",
                        x1: "33.45",
                        y1: "32.0083",
                        x2: "8.59413",
                        y2: "-8.20779",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    })
                })
            ]
        }),
        cooldown: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 32,
            height: 32,
            viewBox: "0 0 32 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
                    fill: "url(#paint0_linear_12314_32284)"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
                    fill: "white",
                    fillOpacity: "0.03"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M16 0.125C24.7675 0.125 31.875 7.23248 31.875 16C31.875 24.7675 24.7675 31.875 16 31.875C7.23248 31.875 0.125 24.7675 0.125 16C0.125 7.23248 7.23248 0.125 16 0.125Z",
                    stroke: "white",
                    strokeOpacity: "0.15",
                    strokeWidth: "0.25"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M22.6158 18.9248L21.5169 18.3111C21.7157 18.113 21.9438 17.9445 22.1937 17.8111C22.3571 17.722 22.4774 17.5742 22.5286 17.3997C22.5797 17.2253 22.5575 17.0384 22.4668 16.8797C22.3761 16.721 22.2243 16.6033 22.0443 16.5524C21.8643 16.5014 21.6708 16.5213 21.5059 16.6076C21.0288 16.8629 20.606 17.2033 20.2599 17.6107L17.4122 16.0186L20.2593 14.4292C20.6053 14.8367 21.0281 15.1771 21.5053 15.4323C21.587 15.4769 21.6772 15.5054 21.7704 15.5161C21.8636 15.5268 21.9581 15.5196 22.0485 15.4949C22.1388 15.4701 22.2231 15.4283 22.2967 15.3718C22.3702 15.3154 22.4314 15.2454 22.4768 15.1659C22.5222 15.0865 22.5509 14.9991 22.5612 14.9089C22.5715 14.8187 22.5633 14.7274 22.5369 14.6402C22.5105 14.5531 22.4665 14.4719 22.4075 14.4013C22.3485 14.3307 22.2756 14.2721 22.1931 14.2289C21.9432 14.0953 21.7152 13.9268 21.5163 13.7289L22.6152 13.1151C22.6992 13.0717 22.7734 13.0123 22.8332 12.9406C22.8931 12.8689 22.9374 12.7863 22.9636 12.6976C22.9898 12.609 22.9973 12.5162 22.9856 12.4248C22.974 12.3333 22.9434 12.245 22.8958 12.1652C22.8481 12.0854 22.7844 12.0156 22.7083 11.9601C22.6322 11.9046 22.5454 11.8644 22.4529 11.842C22.3605 11.8196 22.2643 11.8153 22.1701 11.8296C22.076 11.8438 21.9857 11.8762 21.9047 11.9248L20.8058 12.5382C20.7276 12.2726 20.6903 11.9972 20.6953 11.7211C20.6974 11.6306 20.6809 11.5407 20.647 11.4564C20.613 11.3721 20.5622 11.2951 20.4974 11.2298C20.4326 11.1646 20.3551 11.1123 20.2694 11.0761C20.1837 11.0398 20.0914 11.0203 19.9978 11.0186H19.9846C19.7983 11.0185 19.6194 11.0892 19.4864 11.2154C19.3534 11.3415 19.277 11.5131 19.2735 11.6932C19.2635 12.2201 19.3567 12.744 19.5482 13.2373L16.7011 14.8276V11.6492C17.239 11.5632 17.7553 11.3795 18.2224 11.1076C18.384 11.0135 18.5002 10.8612 18.5456 10.6842C18.591 10.5072 18.5619 10.3201 18.4645 10.1639C18.3672 10.0077 18.2097 9.89527 18.0266 9.85138C17.8436 9.80748 17.65 9.83569 17.4884 9.9298C17.2435 10.0721 16.9782 10.1786 16.7011 10.2457V9.20605C16.7011 9.02372 16.6262 8.84885 16.4928 8.71992C16.3595 8.59099 16.1786 8.51855 15.99 8.51855C15.8015 8.51855 15.6206 8.59099 15.4872 8.71992C15.3539 8.84885 15.279 9.02372 15.279 9.20605V10.2457C15.0019 10.1786 14.7365 10.0721 14.4916 9.9298C14.3301 9.83569 14.1365 9.80748 13.9535 9.85138C13.7704 9.89527 13.6129 10.0077 13.5156 10.1639C13.4182 10.3201 13.389 10.5072 13.4344 10.6842C13.4798 10.8612 13.5961 11.0135 13.7576 11.1076C14.2248 11.3795 14.741 11.5632 15.279 11.6492V14.8276L12.4318 13.2373C12.6237 12.7438 12.7171 12.2197 12.7072 11.6926C12.7037 11.5125 12.6273 11.3409 12.4943 11.2147C12.3613 11.0886 12.1825 11.0179 11.9962 11.0179H11.9823C11.8889 11.0196 11.7967 11.039 11.7111 11.0751C11.6255 11.1112 11.5481 11.1633 11.4833 11.2283C11.4185 11.2934 11.3676 11.3701 11.3335 11.4542C11.2994 11.5382 11.2827 11.628 11.2844 11.7182C11.2897 11.9948 11.2525 12.2706 11.1742 12.5367L10.0753 11.9248C9.9944 11.8781 9.90469 11.8475 9.81141 11.8346C9.71813 11.8218 9.62313 11.827 9.53194 11.8499C9.44075 11.8729 9.35519 11.9131 9.28023 11.9683C9.20527 12.0235 9.1424 12.0926 9.09528 12.1715C9.04817 12.2503 9.01774 12.3375 9.00576 12.4279C8.99379 12.5182 9.00051 12.61 9.02554 12.6978C9.05057 12.7857 9.0934 12.8678 9.15155 12.9395C9.2097 13.0112 9.28201 13.071 9.36427 13.1154L10.4632 13.7292C10.2643 13.9272 10.0362 14.0956 9.78638 14.2292C9.70382 14.2724 9.63092 14.331 9.57191 14.4016C9.5129 14.4722 9.46893 14.5534 9.44255 14.6405C9.41616 14.7277 9.40788 14.819 9.41819 14.9092C9.4285 14.9994 9.45718 15.0868 9.50259 15.1663C9.548 15.2457 9.60924 15.3157 9.68276 15.3721C9.75629 15.4286 9.84065 15.4704 9.93098 15.4952C10.0213 15.5199 10.1158 15.5272 10.209 15.5164C10.3023 15.5057 10.3924 15.4772 10.4742 15.4326C10.9513 15.1773 11.374 14.8369 11.7201 14.4295L14.5679 16.0186L11.7208 17.6079C11.3747 17.2005 10.9519 16.8601 10.4748 16.6048C10.393 16.5602 10.3029 16.5317 10.2097 16.521C10.1165 16.5103 10.022 16.5175 9.93162 16.5423C9.8413 16.567 9.75693 16.6088 9.68341 16.6653C9.60988 16.7217 9.54865 16.7917 9.50324 16.8712C9.45783 16.9506 9.42914 17.038 9.41884 17.1282C9.40853 17.2184 9.41681 17.3098 9.44319 17.3969C9.46958 17.484 9.51354 17.5652 9.57256 17.6358C9.63157 17.7064 9.70446 17.765 9.78703 17.8082C10.0369 17.9418 10.2649 18.1103 10.4638 18.3082L9.36427 18.9248C9.28201 18.9692 9.2097 19.029 9.15155 19.1007C9.0934 19.1724 9.05057 19.2546 9.02554 19.3424C9.00051 19.4302 8.99379 19.522 9.00576 19.6124C9.01774 19.7027 9.04817 19.7899 9.09528 19.8688C9.1424 19.9477 9.20527 20.0167 9.28023 20.0719C9.35519 20.1271 9.44075 20.1674 9.53194 20.1903C9.62313 20.2133 9.71813 20.2185 9.81141 20.2056C9.90469 20.1928 9.9944 20.1621 10.0753 20.1154L11.1742 19.502C11.2525 19.7676 11.2898 20.043 11.2848 20.3192C11.2815 20.5013 11.3531 20.6773 11.4839 20.8084C11.6146 20.9395 11.7939 21.0151 11.9823 21.0186H11.9955C12.1818 21.0186 12.3607 20.9479 12.4937 20.8217C12.6266 20.6956 12.7031 20.524 12.7066 20.3439C12.7166 19.817 12.6234 19.2931 12.4318 18.7998L15.279 17.2095V20.3879C14.741 20.4739 14.2248 20.6577 13.7576 20.9295C13.5961 21.0236 13.4798 21.1759 13.4344 21.3529C13.389 21.5299 13.4182 21.7171 13.5156 21.8732C13.6129 22.0294 13.7704 22.1418 13.9535 22.1857C14.1365 22.2296 14.3301 22.2014 14.4916 22.1073C14.7365 21.965 15.0019 21.8586 15.279 21.7914V22.8311C15.279 23.0134 15.3539 23.1883 15.4872 23.3172C15.6206 23.4461 15.8015 23.5186 15.99 23.5186C16.1786 23.5186 16.3595 23.4461 16.4928 23.3172C16.6262 23.1883 16.7011 23.0134 16.7011 22.8311V21.7914C16.9782 21.8586 17.2435 21.965 17.4884 22.1073C17.65 22.2014 17.8436 22.2296 18.0266 22.1857C18.2097 22.1418 18.3672 22.0294 18.4645 21.8732C18.5619 21.7171 18.591 21.5299 18.5456 21.3529C18.5002 21.1759 18.384 21.0236 18.2224 20.9295C17.7553 20.6577 17.239 20.4739 16.7011 20.3879V17.2095L19.5482 18.7998C19.3564 19.2933 19.263 19.8174 19.2729 20.3445C19.2763 20.5246 19.3528 20.6962 19.4858 20.8224C19.6187 20.9485 19.7976 21.0192 19.9839 21.0192H19.9978C20.0912 21.0175 20.1833 20.9981 20.2689 20.962C20.3546 20.9259 20.432 20.8738 20.4968 20.8088C20.5616 20.7438 20.6125 20.667 20.6466 20.583C20.6807 20.4989 20.6974 20.4092 20.6956 20.3189C20.6904 20.0423 20.7275 19.7665 20.8058 19.5004L21.9047 20.1139C21.9857 20.1641 22.0763 20.198 22.1711 20.2134C22.266 20.2288 22.363 20.2254 22.4565 20.2035C22.55 20.1816 22.6378 20.1416 22.7149 20.0859C22.7919 20.0302 22.8564 19.96 22.9045 19.8795C22.9526 19.799 22.9834 19.7099 22.9949 19.6176C23.0064 19.5253 22.9984 19.4317 22.9714 19.3424C22.9444 19.2532 22.899 19.1702 22.8379 19.0984C22.7768 19.0266 22.7012 18.9675 22.6158 18.9248Z",
                    fill: "black"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M22.6158 18.9248L21.5169 18.3111C21.7157 18.113 21.9438 17.9445 22.1937 17.8111C22.3571 17.722 22.4774 17.5742 22.5286 17.3997C22.5797 17.2253 22.5575 17.0384 22.4668 16.8797C22.3761 16.721 22.2243 16.6033 22.0443 16.5524C21.8643 16.5014 21.6708 16.5213 21.5059 16.6076C21.0288 16.8629 20.606 17.2033 20.2599 17.6107L17.4122 16.0186L20.2593 14.4292C20.6053 14.8367 21.0281 15.1771 21.5053 15.4323C21.587 15.4769 21.6772 15.5054 21.7704 15.5161C21.8636 15.5268 21.9581 15.5196 22.0485 15.4949C22.1388 15.4701 22.2231 15.4283 22.2967 15.3718C22.3702 15.3154 22.4314 15.2454 22.4768 15.1659C22.5222 15.0865 22.5509 14.9991 22.5612 14.9089C22.5715 14.8187 22.5633 14.7274 22.5369 14.6402C22.5105 14.5531 22.4665 14.4719 22.4075 14.4013C22.3485 14.3307 22.2756 14.2721 22.1931 14.2289C21.9432 14.0953 21.7152 13.9268 21.5163 13.7289L22.6152 13.1151C22.6992 13.0717 22.7734 13.0123 22.8332 12.9406C22.8931 12.8689 22.9374 12.7863 22.9636 12.6976C22.9898 12.609 22.9973 12.5162 22.9856 12.4248C22.974 12.3333 22.9434 12.245 22.8958 12.1652C22.8481 12.0854 22.7844 12.0156 22.7083 11.9601C22.6322 11.9046 22.5454 11.8644 22.4529 11.842C22.3605 11.8196 22.2643 11.8153 22.1701 11.8296C22.076 11.8438 21.9857 11.8762 21.9047 11.9248L20.8058 12.5382C20.7276 12.2726 20.6903 11.9972 20.6953 11.7211C20.6974 11.6306 20.6809 11.5407 20.647 11.4564C20.613 11.3721 20.5622 11.2951 20.4974 11.2298C20.4326 11.1646 20.3551 11.1123 20.2694 11.0761C20.1837 11.0398 20.0914 11.0203 19.9978 11.0186H19.9846C19.7983 11.0185 19.6194 11.0892 19.4864 11.2154C19.3534 11.3415 19.277 11.5131 19.2735 11.6932C19.2635 12.2201 19.3567 12.744 19.5482 13.2373L16.7011 14.8276V11.6492C17.239 11.5632 17.7553 11.3795 18.2224 11.1076C18.384 11.0135 18.5002 10.8612 18.5456 10.6842C18.591 10.5072 18.5619 10.3201 18.4645 10.1639C18.3672 10.0077 18.2097 9.89527 18.0266 9.85138C17.8436 9.80748 17.65 9.83569 17.4884 9.9298C17.2435 10.0721 16.9782 10.1786 16.7011 10.2457V9.20605C16.7011 9.02372 16.6262 8.84885 16.4928 8.71992C16.3595 8.59099 16.1786 8.51855 15.99 8.51855C15.8015 8.51855 15.6206 8.59099 15.4872 8.71992C15.3539 8.84885 15.279 9.02372 15.279 9.20605V10.2457C15.0019 10.1786 14.7365 10.0721 14.4916 9.9298C14.3301 9.83569 14.1365 9.80748 13.9535 9.85138C13.7704 9.89527 13.6129 10.0077 13.5156 10.1639C13.4182 10.3201 13.389 10.5072 13.4344 10.6842C13.4798 10.8612 13.5961 11.0135 13.7576 11.1076C14.2248 11.3795 14.741 11.5632 15.279 11.6492V14.8276L12.4318 13.2373C12.6237 12.7438 12.7171 12.2197 12.7072 11.6926C12.7037 11.5125 12.6273 11.3409 12.4943 11.2147C12.3613 11.0886 12.1825 11.0179 11.9962 11.0179H11.9823C11.8889 11.0196 11.7967 11.039 11.7111 11.0751C11.6255 11.1112 11.5481 11.1633 11.4833 11.2283C11.4185 11.2934 11.3676 11.3701 11.3335 11.4542C11.2994 11.5382 11.2827 11.628 11.2844 11.7182C11.2897 11.9948 11.2525 12.2706 11.1742 12.5367L10.0753 11.9248C9.9944 11.8781 9.90469 11.8475 9.81141 11.8346C9.71813 11.8218 9.62313 11.827 9.53194 11.8499C9.44075 11.8729 9.35519 11.9131 9.28023 11.9683C9.20527 12.0235 9.1424 12.0926 9.09528 12.1715C9.04817 12.2503 9.01774 12.3375 9.00576 12.4279C8.99379 12.5182 9.00051 12.61 9.02554 12.6978C9.05057 12.7857 9.0934 12.8678 9.15155 12.9395C9.2097 13.0112 9.28201 13.071 9.36427 13.1154L10.4632 13.7292C10.2643 13.9272 10.0362 14.0956 9.78638 14.2292C9.70382 14.2724 9.63092 14.331 9.57191 14.4016C9.5129 14.4722 9.46893 14.5534 9.44255 14.6405C9.41616 14.7277 9.40788 14.819 9.41819 14.9092C9.4285 14.9994 9.45718 15.0868 9.50259 15.1663C9.548 15.2457 9.60924 15.3157 9.68276 15.3721C9.75629 15.4286 9.84065 15.4704 9.93098 15.4952C10.0213 15.5199 10.1158 15.5272 10.209 15.5164C10.3023 15.5057 10.3924 15.4772 10.4742 15.4326C10.9513 15.1773 11.374 14.8369 11.7201 14.4295L14.5679 16.0186L11.7208 17.6079C11.3747 17.2005 10.9519 16.8601 10.4748 16.6048C10.393 16.5602 10.3029 16.5317 10.2097 16.521C10.1165 16.5103 10.022 16.5175 9.93162 16.5423C9.8413 16.567 9.75693 16.6088 9.68341 16.6653C9.60988 16.7217 9.54865 16.7917 9.50324 16.8712C9.45783 16.9506 9.42914 17.038 9.41884 17.1282C9.40853 17.2184 9.41681 17.3098 9.44319 17.3969C9.46958 17.484 9.51354 17.5652 9.57256 17.6358C9.63157 17.7064 9.70446 17.765 9.78703 17.8082C10.0369 17.9418 10.2649 18.1103 10.4638 18.3082L9.36427 18.9248C9.28201 18.9692 9.2097 19.029 9.15155 19.1007C9.0934 19.1724 9.05057 19.2546 9.02554 19.3424C9.00051 19.4302 8.99379 19.522 9.00576 19.6124C9.01774 19.7027 9.04817 19.7899 9.09528 19.8688C9.1424 19.9477 9.20527 20.0167 9.28023 20.0719C9.35519 20.1271 9.44075 20.1674 9.53194 20.1903C9.62313 20.2133 9.71813 20.2185 9.81141 20.2056C9.90469 20.1928 9.9944 20.1621 10.0753 20.1154L11.1742 19.502C11.2525 19.7676 11.2898 20.043 11.2848 20.3192C11.2815 20.5013 11.3531 20.6773 11.4839 20.8084C11.6146 20.9395 11.7939 21.0151 11.9823 21.0186H11.9955C12.1818 21.0186 12.3607 20.9479 12.4937 20.8217C12.6266 20.6956 12.7031 20.524 12.7066 20.3439C12.7166 19.817 12.6234 19.2931 12.4318 18.7998L15.279 17.2095V20.3879C14.741 20.4739 14.2248 20.6577 13.7576 20.9295C13.5961 21.0236 13.4798 21.1759 13.4344 21.3529C13.389 21.5299 13.4182 21.7171 13.5156 21.8732C13.6129 22.0294 13.7704 22.1418 13.9535 22.1857C14.1365 22.2296 14.3301 22.2014 14.4916 22.1073C14.7365 21.965 15.0019 21.8586 15.279 21.7914V22.8311C15.279 23.0134 15.3539 23.1883 15.4872 23.3172C15.6206 23.4461 15.8015 23.5186 15.99 23.5186C16.1786 23.5186 16.3595 23.4461 16.4928 23.3172C16.6262 23.1883 16.7011 23.0134 16.7011 22.8311V21.7914C16.9782 21.8586 17.2435 21.965 17.4884 22.1073C17.65 22.2014 17.8436 22.2296 18.0266 22.1857C18.2097 22.1418 18.3672 22.0294 18.4645 21.8732C18.5619 21.7171 18.591 21.5299 18.5456 21.3529C18.5002 21.1759 18.384 21.0236 18.2224 20.9295C17.7553 20.6577 17.239 20.4739 16.7011 20.3879V17.2095L19.5482 18.7998C19.3564 19.2933 19.263 19.8174 19.2729 20.3445C19.2763 20.5246 19.3528 20.6962 19.4858 20.8224C19.6187 20.9485 19.7976 21.0192 19.9839 21.0192H19.9978C20.0912 21.0175 20.1833 20.9981 20.2689 20.962C20.3546 20.9259 20.432 20.8738 20.4968 20.8088C20.5616 20.7438 20.6125 20.667 20.6466 20.583C20.6807 20.4989 20.6974 20.4092 20.6956 20.3189C20.6904 20.0423 20.7275 19.7665 20.8058 19.5004L21.9047 20.1139C21.9857 20.1641 22.0763 20.198 22.1711 20.2134C22.266 20.2288 22.363 20.2254 22.4565 20.2035C22.55 20.1816 22.6378 20.1416 22.7149 20.0859C22.7919 20.0302 22.8564 19.96 22.9045 19.8795C22.9526 19.799 22.9834 19.7099 22.9949 19.6176C23.0064 19.5253 22.9984 19.4317 22.9714 19.3424C22.9444 19.2532 22.899 19.1702 22.8379 19.0984C22.7768 19.0266 22.7012 18.9675 22.6158 18.9248Z",
                    fill: "#E5E5E5"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "paint0_linear_12314_32284",
                        x1: "33.45",
                        y1: "32.0083",
                        x2: "8.59413",
                        y2: "-8.20779",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    })
                })
            ]
        }),
        fitness: {},
        cardio: {},
        rest: {}
    },
    exerciseAction: {
        menu: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12Z",
                    stroke: "#E5E5E5",
                    strokeWidth: 2,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19Z",
                    stroke: "#E5E5E5",
                    strokeWidth: 2,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M11 5C11 5.55229 11.4477 6 12 6C12.5523 6 13 5.55229 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5Z",
                    stroke: "#E5E5E5",
                    strokeWidth: 2,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
        duplicate: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 16,
            height: 16,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M4 6.0955C4 5.53974 4.22078 5.00674 4.61376 4.61376C5.00674 4.22078 5.53974 4 6.0955 4H12.9045C13.1797 4 13.4522 4.0542 13.7064 4.15951C13.9607 4.26482 14.1917 4.41917 14.3862 4.61376C14.5808 4.80834 14.7352 5.03935 14.8405 5.29359C14.9458 5.54782 15 5.82031 15 6.0955V12.9045C15 13.1797 14.9458 13.4522 14.8405 13.7064C14.7352 13.9607 14.5808 14.1917 14.3862 14.3862C14.1917 14.5808 13.9607 14.7352 13.7064 14.8405C13.4522 14.9458 13.1797 15 12.9045 15H6.0955C5.82031 15 5.54782 14.9458 5.29359 14.8405C5.03935 14.7352 4.80834 14.5808 4.61376 14.3862C4.41917 14.1917 4.26482 13.9607 4.15951 13.7064C4.0542 13.4522 4 13.1797 4 12.9045V6.0955Z",
                    stroke: "#E5E5E5",
                    strokeWidth: "1.6",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M1.74963 11C1.52222 10.873 1.33307 10.6891 1.20141 10.4671C1.06974 10.245 1.00025 9.99257 1 9.73553V2.45592C1 1.65516 1.66667 1 2.48148 1H9.88889C10.4444 1 10.7467 1.28026 11 1.72796",
                    stroke: "#E5E5E5",
                    strokeWidth: "1.6",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
        replaceExercise: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            width: 16,
            height: 16,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M10.6841 8.78076L9.25078 11.0808C9.12856 11.2697 8.95923 11.3474 8.74278 11.3141C8.52634 11.2808 8.39011 11.153 8.33411 10.9308L7.86745 9.0641L3.31745 13.6141C3.19523 13.7363 3.04256 13.8003 2.85945 13.8061C2.67634 13.8119 2.51789 13.7479 2.38411 13.6141C2.26189 13.4919 2.20078 13.3363 2.20078 13.1474C2.20078 12.9585 2.26189 12.803 2.38411 12.6808L6.93411 8.1141L5.06745 7.64743C4.84523 7.59188 4.71745 7.45588 4.68411 7.23943C4.65078 7.02299 4.72856 6.85343 4.91745 6.73076L7.21745 5.3141L7.01745 2.59743C6.99523 2.37521 7.08411 2.2141 7.28411 2.1141C7.48412 2.0141 7.66745 2.03632 7.83411 2.18076L9.91745 3.93076L12.4341 2.9141C12.6452 2.82521 12.8286 2.85854 12.9841 3.0141C13.1397 3.16965 13.173 3.35299 13.0841 3.5641L12.0674 6.08076L13.8174 8.14743C13.9619 8.3141 13.9841 8.49743 13.8841 8.69743C13.7841 8.89743 13.623 8.98632 13.4008 8.9641L10.6841 8.78076ZM2.15078 4.3141C2.08411 4.24743 2.05078 4.16965 2.05078 4.08076C2.05078 3.99188 2.08411 3.9141 2.15078 3.84743L3.01745 2.98076C3.08411 2.9141 3.16189 2.88076 3.25078 2.88076C3.33967 2.88076 3.41745 2.9141 3.48411 2.98076L4.35078 3.84743C4.41745 3.9141 4.45078 3.99188 4.45078 4.08076C4.45078 4.16965 4.41745 4.24743 4.35078 4.3141L3.48411 5.18076C3.41745 5.24743 3.33967 5.28076 3.25078 5.28076C3.16189 5.28076 3.08411 5.24743 3.01745 5.18076L2.15078 4.3141ZM11.6841 13.8474L10.8174 12.9808C10.7508 12.9141 10.7174 12.8363 10.7174 12.7474C10.7174 12.6585 10.7508 12.5808 10.8174 12.5141L11.6841 11.6474C11.7508 11.5808 11.8286 11.5474 11.9174 11.5474C12.0063 11.5474 12.0841 11.5808 12.1508 11.6474L13.0174 12.5141C13.0841 12.5808 13.1174 12.6585 13.1174 12.7474C13.1174 12.8363 13.0841 12.9141 13.0174 12.9808L12.1508 13.8474C12.0841 13.9141 12.0063 13.9474 11.9174 13.9474C11.8286 13.9474 11.7508 13.9141 11.6841 13.8474Z",
                fill: "#E5E5E5"
            })
        }),
        convertToSuperset: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 16,
            height: 16,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    clipPath: "url(#clip0_13518_2699)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M8.66536 10.6663L6.66536 12.6663L8.66536 14.6663M6.66536 12.6663H9.9987C12.576 12.6663 14.6654 10.577 14.6654 7.99967C14.6654 6.13808 13.5753 4.53107 11.9987 3.7821M3.9987 12.2173C2.42207 11.4683 1.33203 9.86127 1.33203 7.99967C1.33203 5.42235 3.42137 3.33301 5.9987 3.33301H9.33203M7.33203 5.33301L9.33203 3.33301L7.33203 1.33301",
                        stroke: "#E5E5E5",
                        strokeWidth: "1.5",
                        strokeLinecap: "round",
                        strokeLinejoin: "round"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "clip0_13518_2699",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 16,
                            height: 16,
                            fill: "white"
                        })
                    })
                })
            ]
        }),
        remove: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            width: 16,
            height: 18,
            viewBox: "0 0 16 18",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M13.75 4.26647L13.0997 14.7895C13.0728 15.2268 12.9035 15.6361 12.6258 15.9349C12.3482 16.2337 11.9829 16.3998 11.6035 16.3998H5.3965C5.0171 16.3998 4.6518 16.2337 4.37416 15.9349C4.09653 15.6361 3.92719 15.2268 3.90025 14.7895L3.25 4.26647M7 7.73314V12.9331M10 7.73314V12.9331M10.75 4.26647V1.66647C10.75 1.43662 10.671 1.21618 10.5303 1.05365C10.3897 0.891114 10.1989 0.799805 10 0.799805H7C6.80109 0.799805 6.61032 0.891114 6.46967 1.05365C6.32902 1.21618 6.25 1.43662 6.25 1.66647V4.26647M2.5 4.26647H14.5",
                stroke: "#E5E5E5",
                strokeWidth: "1.6",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        }),
        pasteContent: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 16,
            height: 16,
            viewBox: "0 0 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M14.3408 4.72852C14.6477 4.72854 14.9422 4.85041 15.1592 5.06738C15.3759 5.28424 15.4979 5.5782 15.498 5.88477V6.41406C15.4979 6.76104 15.2162 7.04199 14.8691 7.04199C14.5222 7.04193 14.2404 6.76101 14.2402 6.41406V6.09668C14.2402 6.03515 14.1904 5.98535 14.1289 5.98535H12.7549C12.4079 5.98523 12.127 5.7035 12.127 5.35645C12.1271 5.00949 12.4079 4.72863 12.7549 4.72852H14.3408Z",
                    fill: "#E5E5E5",
                    stroke: "#E5E5E5",
                    strokeWidth: "0.2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M14.8721 7.90039C15.2191 7.90039 15.5009 8.18129 15.501 8.52832V10.6426C15.501 10.9897 15.2192 11.2715 14.8721 11.2715C14.525 11.2714 14.2441 10.9896 14.2441 10.6426V8.52832C14.2443 8.18136 14.5251 7.90051 14.8721 7.90039Z",
                    fill: "#E5E5E5",
                    stroke: "#E5E5E5",
                    strokeWidth: "0.2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M14.875 12.1289C15.2219 12.1291 15.5028 12.4099 15.5029 12.7568V14.3428C15.5029 14.6496 15.381 14.9442 15.1641 15.1611C14.9471 15.378 14.6525 15.5 14.3457 15.5H13.8174C13.4704 15.4999 13.1895 15.2182 13.1895 14.8711C13.1895 14.5241 13.4704 14.2423 13.8174 14.2422H14.1348C14.1963 14.2422 14.2461 14.1924 14.2461 14.1309V12.7568C14.2462 12.4098 14.5279 12.1289 14.875 12.1289Z",
                    fill: "#E5E5E5",
                    stroke: "#E5E5E5",
                    strokeWidth: "0.2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M10.1152 0.5C10.4221 0.5 10.7166 0.621874 10.9336 0.838867C11.1503 1.05573 11.2723 1.34966 11.2725 1.65625V10.1133C11.2725 10.4202 11.1506 10.7146 10.9336 10.9316C10.7166 11.1486 10.4221 11.2705 10.1152 11.2705H1.6582C1.35161 11.2704 1.05769 11.1484 0.84082 10.9316C0.623827 10.7146 0.501953 10.4202 0.501953 10.1133V1.65625C0.502068 1.34953 0.623929 1.05576 0.84082 0.838867C1.05771 0.621976 1.35148 0.500115 1.6582 0.5H10.1152ZM2.1582 1.75684C1.93763 1.75707 1.75902 1.93568 1.75879 2.15625V9.61328C1.75879 9.83405 1.93749 10.0134 2.1582 10.0137H9.61523C9.83615 10.0137 10.0156 9.83419 10.0156 9.61328V2.15625C10.0154 1.93554 9.836 1.75684 9.61523 1.75684H2.1582Z",
                    fill: "#E5E5E5",
                    stroke: "#E5E5E5",
                    strokeWidth: "0.2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M11.7051 14.2422C12.0521 14.2422 12.3339 14.5231 12.334 14.8701C12.334 15.2172 12.0522 15.499 11.7051 15.499H9.59082C9.24379 15.4989 8.96289 15.2172 8.96289 14.8701C8.96301 14.5232 9.24386 14.2423 9.59082 14.2422H11.7051Z",
                    fill: "#E5E5E5",
                    stroke: "#E5E5E5",
                    strokeWidth: "0.2"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M5.35645 12.1289C5.7035 12.1289 5.98523 12.4098 5.98535 12.7568V13.9199C5.9854 14.098 6.12954 14.242 6.30762 14.2422H7.4707C7.8178 14.2422 8.09955 14.524 8.09961 14.8711C8.09961 15.2182 7.81783 15.5 7.4707 15.5H5.88477C5.5782 15.4999 5.28424 15.3778 5.06738 15.1611C4.85041 14.9442 4.72854 14.6496 4.72852 14.3428V12.7568C4.72863 12.4099 5.00949 12.129 5.35645 12.1289Z",
                    fill: "#E5E5E5",
                    stroke: "#E5E5E5",
                    strokeWidth: "0.2"
                })
            ]
        }),
        backToProgram: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 12,
            height: 16,
            viewBox: "0 0 12 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                    clipPath: "url(#clip0_13651_6617)",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M5.99835 2.19922C6.10371 2.19932 6.20871 2.22022 6.30597 2.26074C6.40317 2.30135 6.49253 2.36075 6.56671 2.43555L6.56769 2.43652C6.64247 2.51081 6.70195 2.59996 6.74249 2.69727C6.78297 2.79461 6.80402 2.89946 6.80402 3.00488C6.80398 3.11035 6.78303 3.21514 6.74249 3.3125C6.70199 3.40967 6.64235 3.49805 6.56769 3.57227L6.56671 3.57324L2.92413 7.20508H10.9984C11.2103 7.20526 11.4139 7.28958 11.5638 7.43945C11.7135 7.58944 11.7982 7.79293 11.7982 8.00488C11.7981 8.21685 11.7136 8.42037 11.5638 8.57031C11.4139 8.72016 11.2103 8.80451 10.9984 8.80469H2.92413L6.56671 12.4365C6.71722 12.5873 6.80206 12.7918 6.80206 13.0049C6.80201 13.2179 6.71727 13.4225 6.56671 13.5732C6.41609 13.7238 6.21133 13.8084 5.99835 13.8086C5.89307 13.8086 5.78804 13.7882 5.69073 13.748C5.59338 13.7077 5.50456 13.6477 5.42999 13.5732L0.432921 8.57617C0.360207 8.50021 0.303026 8.41052 0.264953 8.3125L0.263 8.30859C0.183123 8.11403 0.18321 7.89576 0.263 7.70117L0.264953 7.69727C0.302413 7.60072 0.35888 7.51176 0.429992 7.43652L5.42999 2.43555C5.50431 2.36068 5.59336 2.30131 5.69073 2.26074C5.78808 2.22027 5.89292 2.19922 5.99835 2.19922Z",
                        fill: "white",
                        fillOpacity: "0.7"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                        id: "clip0_13651_6617",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                            width: 12,
                            height: 16,
                            fill: "white"
                        })
                    })
                })
            ]
        })
    },
    calender: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        width: 14,
        height: 14,
        viewBox: "0 0 14 14",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M4.66797 1.16602V3.49935",
                stroke: "white",
                strokeOpacity: "0.6",
                strokeWidth: "1.16667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M9.33203 1.16602V3.49935",
                stroke: "white",
                strokeOpacity: "0.6",
                strokeWidth: "1.16667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M11.0833 2.33398H2.91667C2.27233 2.33398 1.75 2.85632 1.75 3.50065V11.6673C1.75 12.3116 2.27233 12.834 2.91667 12.834H11.0833C11.7277 12.834 12.25 12.3116 12.25 11.6673V3.50065C12.25 2.85632 11.7277 2.33398 11.0833 2.33398Z",
                stroke: "white",
                strokeOpacity: "0.6",
                strokeWidth: "1.16667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M1.75 5.83398H12.25",
                stroke: "white",
                strokeOpacity: "0.6",
                strokeWidth: "1.16667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    }),
    weekProgram: {
        prevWeek: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M18 18L12 12L18 6",
                    stroke: "white",
                    strokeOpacity: "0.7",
                    strokeWidth: 2,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M11 18L5 12L11 6",
                    stroke: "white",
                    strokeOpacity: "0.7",
                    strokeWidth: 2,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
        nextWeek: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M6 18L12 12L6 6",
                    stroke: "white",
                    strokeOpacity: "0.7",
                    strokeWidth: 2,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M13 18L19 12L13 6",
                    stroke: "white",
                    strokeOpacity: "0.7",
                    strokeWidth: 2,
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                })
            ]
        }),
        weekDropdownArrow: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M6 9L12 15L18 9",
                stroke: "white",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    },
    EditExercise: {
        close: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
            width: 24,
            height: 24,
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                d: "M6 18L18 6M6 6L18 18",
                stroke: "#99A1AF",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        })
    }
};

},{"react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Pi50":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ShareProgramModal", ()=>ShareProgramModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _appLinksConfig = require("src/config/app-links.config");
var _closeIconSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/close-icon.svg");
var _copyLinkSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/copy_link.svg");
var _miniptAppSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/minipt-app.svg");
var _messengerSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/messenger.svg");
var _smsSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/sms.svg");
const ShareProgramModal = ({ isOpen, onClose, programId, programmeName, isSent = false, isSending = false, onSendMiniPTApp })=>{
    const appStoreLink = (0, _appLinksConfig.APP_LINKS).ios;
    const shareLink = `${window.location.origin}/program/${programId}`;
    const shareText = `Your PT has sent you \u{201C}${programmeName}\u{201D}. (click on program name to open)
View it in the miniPT app. If you don\u{2019}t have miniPT yet, install the app first, then open this link:
${shareLink}\n\nDownload on the App Store:\n${appStoreLink}`;
    const encodedShareText = encodeURIComponent(shareText);
    const [isCopied, setIsCopied] = (0, _react.useState)(false);
    const handleCopyLink = ()=>{
        navigator.clipboard.writeText(shareText);
        setIsCopied(true);
        setTimeout(()=>{
            setIsCopied(false);
        }, 2000);
    };
    const handleWhatsApp = ()=>{
        window.open(`https://wa.me/?text=${encodedShareText}`, '_blank');
    };
    const handleMessenger = ()=>{
        window.open(`fb-messenger://share/?link=${encodeURIComponent(shareLink)}`, '_blank');
    };
    const handleSMS = ()=>{
        window.open(`sms:?body=${encodedShareText}`, '_self');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        footer: null,
        onCancel: onClose,
        centered: true,
        width: 500,
        closeIcon: null,
        rootClassName: "share-program-modal",
        className: "share-program-modal",
        styles: {
            mask: {
                backdropFilter: 'blur(4px)',
                backgroundColor: 'rgba(6, 7, 35, 0.8)'
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "share-modal-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            children: "Share Program"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: "close-btn",
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeIconSvg.ReactComponent), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "modal-subtitle",
                    children: [
                        'Share "',
                        programmeName,
                        '" with your client'
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "main-options",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: `share-option-btn primary-option ${isCopied ? 'copied-btn' : ''}`,
                            onClick: handleCopyLink,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "icon-box copy-link",
                                    children: isCopied ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        width: "24",
                                        height: "24",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "#ffffff",
                                        strokeWidth: "2.5",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        className: "check-icon",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                            points: "20 6 9 17 4 12"
                                        })
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _copyLinkSvg.ReactComponent), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "option-text",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "option-title",
                                            children: isCopied ? 'Link Copied!' : 'Copy Link'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "option-desc",
                                            children: isCopied ? 'Copied to clipboard!' : 'Copy shareable link to clipboard'
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: "share-option-btn primary-option",
                            onClick: onSendMiniPTApp,
                            disabled: isSending,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "icon-box minipt-app",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _miniptAppSvg.ReactComponent), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "option-text",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "option-title",
                                            children: isSending ? 'Sending...' : isSent ? 'Send Again' : 'Send via miniPT App'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "option-desc",
                                            children: isSent ? "Resend and update programme in client's miniPT app" : "Send directly to client's miniPT app"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "modal-divider",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: "Or share via"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "secondary-options",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: "share-option-btn secondary-option",
                            onClick: handleWhatsApp,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "icon-box social-icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messengerSvg.ReactComponent), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "WhatsApp"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: "share-option-btn secondary-option",
                            onClick: handleMessenger,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "icon-box social-icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messengerSvg.ReactComponent), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Messenger"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: "share-option-btn secondary-option",
                            onClick: handleSMS,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "icon-box social-icon",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _smsSvg.ReactComponent), {})
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "SMS"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"src/config/app-links.config":"lGiup","src/assets/images/onboarding-trainer/dashboard/programs/close-icon.svg":"ifISx","src/assets/images/onboarding-trainer/dashboard/programs/copy_link.svg":"jBuuB","src/assets/images/onboarding-trainer/dashboard/programs/minipt-app.svg":"bUWqY","src/assets/images/onboarding-trainer/dashboard/programs/messenger.svg":"fG1PB","src/assets/images/onboarding-trainer/dashboard/programs/sms.svg":"1OQrU","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7RpZ0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "exerciseImagesMap", ()=>exerciseImagesMap);
var _bicepCurlPng = require("url:../../../../../../assets/images/exercises/bicep-curl.png");
var _bicepCurlPngDefault = parcelHelpers.interopDefault(_bicepCurlPng);
var _burpeesPng = require("url:../../../../../../assets/images/exercises/burpees.png");
var _burpeesPngDefault = parcelHelpers.interopDefault(_burpeesPng);
var _dumbbellLateralRaisePng = require("url:../../../../../../assets/images/exercises/dumbbell-lateral-raise.png");
var _dumbbellLateralRaisePngDefault = parcelHelpers.interopDefault(_dumbbellLateralRaisePng);
var _bicepCurlJpg = require("url:../../../../../../assets/images/exercises/female/bicep-curl.jpg");
var _bicepCurlJpgDefault = parcelHelpers.interopDefault(_bicepCurlJpg);
var _burpeesJpg = require("url:../../../../../../assets/images/exercises/female/burpees.jpg");
var _burpeesJpgDefault = parcelHelpers.interopDefault(_burpeesJpg);
var _dumbbellLateralRaiseJpg = require("url:../../../../../../assets/images/exercises/female/dumbbell-lateral-raise.jpg");
var _dumbbellLateralRaiseJpgDefault = parcelHelpers.interopDefault(_dumbbellLateralRaiseJpg);
var _highKneesJpg = require("url:../../../../../../assets/images/exercises/female/high-knees.jpg");
var _highKneesJpgDefault = parcelHelpers.interopDefault(_highKneesJpg);
var _jabsJpg = require("url:../../../../../../assets/images/exercises/female/jabs.jpg");
var _jabsJpgDefault = parcelHelpers.interopDefault(_jabsJpg);
var _jumpingJacksJpg = require("url:../../../../../../assets/images/exercises/female/jumping-jacks.jpg");
var _jumpingJacksJpgDefault = parcelHelpers.interopDefault(_jumpingJacksJpg);
var _kneeToElbowJpg = require("url:../../../../../../assets/images/exercises/female/knee-to-elbow.jpg");
var _kneeToElbowJpgDefault = parcelHelpers.interopDefault(_kneeToElbowJpg);
var _maleWoodCutterLeftToRightJpg = require("url:../../../../../../assets/images/exercises/female/male-wood-cutter-left-to-right.jpg");
var _maleWoodCutterLeftToRightJpgDefault = parcelHelpers.interopDefault(_maleWoodCutterLeftToRightJpg);
var _maleWoodCutterRightToLeftJpg = require("url:../../../../../../assets/images/exercises/female/male-wood-cutter-right-to-left.jpg");
var _maleWoodCutterRightToLeftJpgDefault = parcelHelpers.interopDefault(_maleWoodCutterRightToLeftJpg);
var _plankJpg = require("url:../../../../../../assets/images/exercises/female/plank.jpg");
var _plankJpgDefault = parcelHelpers.interopDefault(_plankJpg);
var _pressUpJpg = require("url:../../../../../../assets/images/exercises/female/press-up.jpg");
var _pressUpJpgDefault = parcelHelpers.interopDefault(_pressUpJpg);
var _shoulderPressJpg = require("url:../../../../../../assets/images/exercises/female/shoulder-press.jpg");
var _shoulderPressJpgDefault = parcelHelpers.interopDefault(_shoulderPressJpg);
var _sideLungeJpg = require("url:../../../../../../assets/images/exercises/female/side-lunge.jpg");
var _sideLungeJpgDefault = parcelHelpers.interopDefault(_sideLungeJpg);
var _squatJpg = require("url:../../../../../../assets/images/exercises/female/squat.jpg");
var _squatJpgDefault = parcelHelpers.interopDefault(_squatJpg);
var _squatJumpsJpg = require("url:../../../../../../assets/images/exercises/female/squat-jumps.jpg");
var _squatJumpsJpgDefault = parcelHelpers.interopDefault(_squatJumpsJpg);
var _tricepDipsBenchJpg = require("url:../../../../../../assets/images/exercises/female/tricep-dips-bench.jpg");
var _tricepDipsBenchJpgDefault = parcelHelpers.interopDefault(_tricepDipsBenchJpg);
var _upperCutJpg = require("url:../../../../../../assets/images/exercises/female/upper-cut.jpg");
var _upperCutJpgDefault = parcelHelpers.interopDefault(_upperCutJpg);
var _wallSitJpg = require("url:../../../../../../assets/images/exercises/female/wall-sit.jpg");
var _wallSitJpgDefault = parcelHelpers.interopDefault(_wallSitJpg);
var _highKneesPng = require("url:../../../../../../assets/images/exercises/high-knees.png");
var _highKneesPngDefault = parcelHelpers.interopDefault(_highKneesPng);
var _jabsPng = require("url:../../../../../../assets/images/exercises/jabs.png");
var _jabsPngDefault = parcelHelpers.interopDefault(_jabsPng);
var _jumpingJacksPng = require("url:../../../../../../assets/images/exercises/jumping-jacks.png");
var _jumpingJacksPngDefault = parcelHelpers.interopDefault(_jumpingJacksPng);
var _kneeToElbowPng = require("url:../../../../../../assets/images/exercises/knee-to-elbow.png");
var _kneeToElbowPngDefault = parcelHelpers.interopDefault(_kneeToElbowPng);
var _maleWoodCutterLeftToRightPng = require("url:../../../../../../assets/images/exercises/male-wood-cutter-left-to-right.png");
var _maleWoodCutterLeftToRightPngDefault = parcelHelpers.interopDefault(_maleWoodCutterLeftToRightPng);
var _maleWoodCutterRightToLeftPng = require("url:../../../../../../assets/images/exercises/male-wood-cutter-right-to-left.png");
var _maleWoodCutterRightToLeftPngDefault = parcelHelpers.interopDefault(_maleWoodCutterRightToLeftPng);
var _plankPng = require("url:../../../../../../assets/images/exercises/plank.png");
var _plankPngDefault = parcelHelpers.interopDefault(_plankPng);
var _pressUpPng = require("url:../../../../../../assets/images/exercises/press-up.png");
var _pressUpPngDefault = parcelHelpers.interopDefault(_pressUpPng);
var _shoulderPressPng = require("url:../../../../../../assets/images/exercises/shoulder-press.png");
var _shoulderPressPngDefault = parcelHelpers.interopDefault(_shoulderPressPng);
var _sideLungePng = require("url:../../../../../../assets/images/exercises/side-lunge.png");
var _sideLungePngDefault = parcelHelpers.interopDefault(_sideLungePng);
var _squatPng = require("url:../../../../../../assets/images/exercises/squat.png");
var _squatPngDefault = parcelHelpers.interopDefault(_squatPng);
var _squatJumpsPng = require("url:../../../../../../assets/images/exercises/squat-jumps.png");
var _squatJumpsPngDefault = parcelHelpers.interopDefault(_squatJumpsPng);
var _tricepDipsBenchPng = require("url:../../../../../../assets/images/exercises/tricep-dips-bench.png");
var _tricepDipsBenchPngDefault = parcelHelpers.interopDefault(_tricepDipsBenchPng);
var _upperCutPng = require("url:../../../../../../assets/images/exercises/upper-cut.png");
var _upperCutPngDefault = parcelHelpers.interopDefault(_upperCutPng);
var _wallSitPng = require("url:../../../../../../assets/images/exercises/wall-sit.png");
var _wallSitPngDefault = parcelHelpers.interopDefault(_wallSitPng);
const exerciseImagesMap = {
    'Bicep Curl': {
        female: (0, _bicepCurlJpgDefault.default),
        male: (0, _bicepCurlPngDefault.default)
    },
    'Shoulder Press': {
        female: (0, _shoulderPressJpgDefault.default),
        male: (0, _shoulderPressPngDefault.default)
    },
    'Press Up': {
        female: (0, _pressUpJpgDefault.default),
        male: (0, _pressUpPngDefault.default)
    },
    'Side Lunge': {
        female: (0, _sideLungeJpgDefault.default),
        male: (0, _sideLungePngDefault.default)
    },
    'Jumping Jacks': {
        female: (0, _jumpingJacksJpgDefault.default),
        male: (0, _jumpingJacksPngDefault.default)
    },
    Plank: {
        female: (0, _plankJpgDefault.default),
        male: (0, _plankPngDefault.default)
    },
    'Knee To Elbow': {
        female: (0, _kneeToElbowJpgDefault.default),
        male: (0, _kneeToElbowPngDefault.default)
    },
    'High Knees': {
        female: (0, _highKneesJpgDefault.default),
        male: (0, _highKneesPngDefault.default)
    },
    Jabs: {
        female: (0, _jabsJpgDefault.default),
        male: (0, _jabsPngDefault.default)
    },
    'Wood Cutter Left to Right': {
        female: (0, _maleWoodCutterLeftToRightJpgDefault.default),
        male: (0, _maleWoodCutterLeftToRightPngDefault.default)
    },
    'Wood Cutter Right to Left': {
        female: (0, _maleWoodCutterRightToLeftJpgDefault.default),
        male: (0, _maleWoodCutterRightToLeftPngDefault.default)
    },
    'Upper Cut': {
        female: (0, _upperCutJpgDefault.default),
        male: (0, _upperCutPngDefault.default)
    },
    'Dumbbell Lateral Raise': {
        female: (0, _dumbbellLateralRaiseJpgDefault.default),
        male: (0, _dumbbellLateralRaisePngDefault.default)
    },
    'Squat Jumps': {
        female: (0, _squatJumpsJpgDefault.default),
        male: (0, _squatJumpsPngDefault.default)
    },
    'Tricep Dips-Bench': {
        female: (0, _tricepDipsBenchJpgDefault.default),
        male: (0, _tricepDipsBenchPngDefault.default)
    },
    'Wall Sit': {
        female: (0, _wallSitJpgDefault.default),
        male: (0, _wallSitPngDefault.default)
    },
    Burpees: {
        female: (0, _burpeesJpgDefault.default),
        male: (0, _burpeesPngDefault.default)
    },
    Squat: {
        female: (0, _squatJpgDefault.default),
        male: (0, _squatPngDefault.default)
    }
};

},{"url:../../../../../../assets/images/exercises/bicep-curl.png":"7paM0","url:../../../../../../assets/images/exercises/burpees.png":"l5W4L","url:../../../../../../assets/images/exercises/dumbbell-lateral-raise.png":"eGXoX","url:../../../../../../assets/images/exercises/female/bicep-curl.jpg":"h4A2x","url:../../../../../../assets/images/exercises/female/burpees.jpg":"hRsUu","url:../../../../../../assets/images/exercises/female/dumbbell-lateral-raise.jpg":"lovlK","url:../../../../../../assets/images/exercises/female/high-knees.jpg":"c2wfj","url:../../../../../../assets/images/exercises/female/jabs.jpg":"a5PA8","url:../../../../../../assets/images/exercises/female/jumping-jacks.jpg":"jGR2U","url:../../../../../../assets/images/exercises/female/knee-to-elbow.jpg":"l45qt","url:../../../../../../assets/images/exercises/female/male-wood-cutter-left-to-right.jpg":"a2afI","url:../../../../../../assets/images/exercises/female/male-wood-cutter-right-to-left.jpg":"gpapC","url:../../../../../../assets/images/exercises/female/plank.jpg":"fqi0s","url:../../../../../../assets/images/exercises/female/press-up.jpg":"9NrNC","url:../../../../../../assets/images/exercises/female/shoulder-press.jpg":"7aOu6","url:../../../../../../assets/images/exercises/female/side-lunge.jpg":"dAoLc","url:../../../../../../assets/images/exercises/female/squat.jpg":"zz0sz","url:../../../../../../assets/images/exercises/female/squat-jumps.jpg":"hGdmD","url:../../../../../../assets/images/exercises/female/tricep-dips-bench.jpg":"8HPe2","url:../../../../../../assets/images/exercises/female/upper-cut.jpg":"ltK6g","url:../../../../../../assets/images/exercises/female/wall-sit.jpg":"8QKF9","url:../../../../../../assets/images/exercises/high-knees.png":"lirNq","url:../../../../../../assets/images/exercises/jabs.png":"3Gjzc","url:../../../../../../assets/images/exercises/jumping-jacks.png":"e9Z6T","url:../../../../../../assets/images/exercises/knee-to-elbow.png":"2qNjK","url:../../../../../../assets/images/exercises/male-wood-cutter-left-to-right.png":"7BhVA","url:../../../../../../assets/images/exercises/male-wood-cutter-right-to-left.png":"f577B","url:../../../../../../assets/images/exercises/plank.png":"VoEi9","url:../../../../../../assets/images/exercises/press-up.png":"gxe7g","url:../../../../../../assets/images/exercises/shoulder-press.png":"g5CSr","url:../../../../../../assets/images/exercises/side-lunge.png":"qplcG","url:../../../../../../assets/images/exercises/squat.png":"3zOz5","url:../../../../../../assets/images/exercises/squat-jumps.png":"iag5J","url:../../../../../../assets/images/exercises/tricep-dips-bench.png":"jtV4s","url:../../../../../../assets/images/exercises/upper-cut.png":"h9ec0","url:../../../../../../assets/images/exercises/wall-sit.png":"cZXKR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h4A2x":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("kc8oq");

},{}],"hRsUu":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5kAni");

},{}],"lovlK":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5OLgQ");

},{}],"c2wfj":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("4Zren");

},{}],"a5PA8":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("qfz7V");

},{}],"jGR2U":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("3Y3aI");

},{}],"l45qt":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("lMh5U");

},{}],"a2afI":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fmRF5");

},{}],"gpapC":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6GDCP");

},{}],"fqi0s":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("erYVz");

},{}],"9NrNC":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9xWlX");

},{}],"7aOu6":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6ronQ");

},{}],"dAoLc":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("j3d6U");

},{}],"zz0sz":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6hWqi");

},{}],"hGdmD":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("igWTx");

},{}],"8HPe2":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9AvA3");

},{}],"ltK6g":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6zOhF");

},{}],"8QKF9":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("jRVDe");

},{}],"6SBz7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ExerciseLibrary", ()=>ExerciseLibrary);
var _jsxRuntime = require("react/jsx-runtime");
var _dnd = require("@hello-pangea/dnd");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useGetAllMovements = require("src/api/queries/useGetAllMovements");
var _closeSvg = require("src/assets/images/trainer/clients/close.svg");
var _useDebounce = require("src/hooks/useDebounce");
var _genderUtils = require("src/utils/genderUtils");
var _exerciseImages = require("./ExerciseImages");
var _programGenerator = require("../ProgramGeneratorAI/assets/ProgramGenerator");
const DraggableExerciseItem = ({ ex, tags, getImagePath, getFallbackImagePath, index })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.Draggable), {
        draggableId: `lib-${ex.id}`,
        index: index,
        children: (provided, snapshot)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                ref: provided.innerRef,
                ...provided.draggableProps,
                ...provided.dragHandleProps,
                className: `exercise-item ${snapshot.isDragging ? 'is-dragging' : ''}`,
                style: {
                    ...provided.draggableProps.style,
                    opacity: snapshot.isDragging ? 0.8 : 1
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "drag-handle",
                        children: (0, _programGenerator.programGeneratorSVG)?.sidebar?.exercisePickerDots
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "ex-thumb",
                        style: {
                            position: 'relative',
                            width: 48,
                            height: 48,
                            minWidth: 48,
                            borderRadius: 8,
                            overflow: 'hidden',
                            backgroundColor: '#2a2d3d'
                        },
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                style: {
                                    width: '100%',
                                    height: '100%',
                                    backgroundColor: '#2a2d3d',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '8px',
                                    color: '#8a8d9d',
                                    fontSize: '14px',
                                    fontWeight: 'bold'
                                },
                                children: (ex.en_display_name || 'U').slice(0, 2).toUpperCase()
                            }),
                            getImagePath(ex) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: getImagePath(ex),
                                alt: ex.en_display_name,
                                loading: "eager",
                                decoding: "async",
                                style: {
                                    position: 'absolute',
                                    top: 0,
                                    left: 0,
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover'
                                },
                                onError: (e)=>{
                                    const fallback = getFallbackImagePath ? getFallbackImagePath(ex) : null;
                                    const img = e.target;
                                    if (fallback && img.src !== fallback) img.src = fallback;
                                    else img.style.display = 'none';
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "ex-info",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                children: ex.en_display_name
                            }),
                            !ex.isRest && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "ex-tags",
                                children: tags.map((tag, i)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: `tag ${tag.type}`,
                                        children: tag.label
                                    }, i))
                            })
                        ]
                    })
                ]
            })
    });
};
const ExerciseLibrary = ({ gender = 'Male', isOpen, onClose })=>{
    const [activeMuscle, setActiveMuscle] = (0, _react.useState)('All');
    const [activeType, setActiveType] = (0, _react.useState)('All');
    const [search, setSearch] = (0, _react.useState)('');
    const debouncedSearch = (0, _useDebounce.useDebounce)(search, 300);
    const { data: movements = [], isLoading } = (0, _useGetAllMovements.useGetAllMovements)();
    const muscleGroups = [
        'All',
        'Lower Body',
        'Upper Body',
        'Full Body',
        'Core'
    ];
    const exerciseTypes = [
        'All',
        'Warmup',
        'Main',
        'Cooldown',
        'Cardio'
    ];
    const getDummyTags = (ex)=>{
        const tags = [];
        // 1. Muscle group tag (yellow) based on tags
        const tagsLower = (ex.tags || []).map((t)=>t.toLowerCase().trim());
        let muscleGroup = ex.mapped_muscle_group || 'Full Body';
        if (activeMuscle !== 'All') {
            const activeLower = activeMuscle.toLowerCase();
            if (tagsLower.includes(activeLower) || activeLower === 'core' && tagsLower.some((t)=>t.includes('core'))) muscleGroup = activeMuscle;
        } else {
            if (tagsLower.includes('core') || tagsLower.some((t)=>t.includes('core'))) muscleGroup = 'Core';
            else if (tagsLower.includes('upper body')) muscleGroup = 'Upper Body';
            else if (tagsLower.includes('lower body')) muscleGroup = 'Lower Body';
            else if (tagsLower.includes('full body')) muscleGroup = 'Full Body';
        }
        tags.push({
            label: muscleGroup,
            type: 'yellow'
        });
        // 2. All movement types strictly from ex.move_types (green) - e.g. Warmup, Main, Cooldown
        const recognizedMoveTypes = [
            'warmup',
            'main',
            'cooldown',
            'rest'
        ];
        const seen = new Set();
        (ex.move_types || []).forEach((t)=>{
            if (!t) return;
            const lower = t.trim().toLowerCase();
            if (recognizedMoveTypes.includes(lower) && !seen.has(lower)) {
                seen.add(lower);
                tags.push({
                    label: lower.charAt(0).toUpperCase() + lower.slice(1),
                    type: 'green'
                });
            }
        });
        // 3. Cardio tag from ex.tags
        const hasCardio = (ex.tags || []).some((t)=>t.toLowerCase().trim() === 'cardio');
        if (hasCardio) tags.push({
            label: 'Cardio',
            type: 'cardio'
        });
        // If an active type filter is selected (other than 'All'), float it to the front of non-muscle tags
        if (activeType !== 'All') {
            const targetLower = activeType.toLowerCase();
            const muscleTag = tags[0];
            const otherTags = tags.slice(1).sort((a, b)=>{
                if (a.label.toLowerCase() === targetLower) return -1;
                if (b.label.toLowerCase() === targetLower) return 1;
                return 0;
            });
            return [
                muscleTag,
                ...otherTags
            ];
        }
        return tags;
    };
    const getFallbackImagePath = (ex)=>{
        const isFemale = (0, _genderUtils.isFemaleProfile)(gender);
        const genderKey = isFemale ? 'female' : 'male';
        const baseName = (ex.en_display_name || '').split('(')[0].trim();
        return (0, _exerciseImages.exerciseImagesMap)[ex.en_display_name]?.[genderKey] || (0, _exerciseImages.exerciseImagesMap)[baseName]?.[genderKey] || null;
    };
    const getImagePath = (ex)=>{
        const isFemale = (0, _genderUtils.isFemaleProfile)(gender);
        const remoteUrl = isFemale ? ex.image_female_url || ex.image_male_url : ex.image_male_url || ex.image_female_url;
        if (remoteUrl) return remoteUrl;
        return getFallbackImagePath(ex);
    };
    const filteredList = (0, _react.useMemo)(()=>{
        return movements.filter((ex)=>{
            if (ex.is_show_move === false) return false;
            // Search filter
            const name = ex.en_display_name || '';
            if (debouncedSearch && !name.toLowerCase().includes(debouncedSearch.toLowerCase())) return false;
            // Muscle Group filter (strictly based on tags with mapped fallback)
            if (activeMuscle !== 'All') {
                const target = activeMuscle.toLowerCase();
                const tagsLower = (ex.tags || []).map((t)=>t.toLowerCase().trim());
                const hasMuscleTag = tagsLower.includes(target) || target === 'core' && tagsLower.some((t)=>t.includes('core')) || ex.mapped_muscle_group?.toLowerCase() === target;
                if (!hasMuscleTag) return false;
            }
            // Exercise Type filter (based on move_types + cardio from tags)
            if (activeType !== 'All') {
                const targetType = activeType.toLowerCase();
                if (targetType === 'cardio') {
                    const hasCardio = (ex.tags || []).some((t)=>t.toLowerCase().trim() === 'cardio') || (ex.move_types || []).some((t)=>t.toLowerCase().trim() === 'cardio');
                    if (!hasCardio) return false;
                } else {
                    const moveTypes = (ex.move_types || []).map((t)=>t.toLowerCase());
                    if (!moveTypes.includes(targetType)) return false;
                }
            }
            return true;
        }).sort((a, b)=>(a.en_display_name || '').localeCompare(b.en_display_name || ''));
    }, [
        movements,
        debouncedSearch,
        activeMuscle,
        activeType
    ]);
    const grouped = (0, _react.useMemo)(()=>{
        return filteredList.reduce((acc, ex)=>{
            const name = ex.en_display_name || 'U';
            const letter = name.charAt(0).toUpperCase();
            if (!acc[letter]) acc[letter] = [];
            acc[letter].push(ex);
            return acc;
        }, {});
    }, [
        filteredList
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("aside", {
        className: `pg-sidebar ${isOpen ? 'open' : ''}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "sidebar-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Exercise Library"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "sidebar-header-action",
                        onClick: onClose,
                        children: (0, _programGenerator.programGeneratorSVG).sidebar.exerciseLibraryClose
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "sidebar-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "search-bar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                placeholder: "Search movements...",
                                value: search,
                                onChange: (e)=>setSearch(e.target.value)
                            }),
                            search && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "clear-search-btn",
                                onClick: ()=>setSearch(''),
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeSvg.ReactComponent), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "filter",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "filter-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: "Muscle Groups"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "pills",
                                        children: muscleGroups.map((m)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `pill ${activeMuscle === m ? 'active' : ''}`,
                                                onClick: ()=>setActiveMuscle(m),
                                                children: m
                                            }, m))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "filter-group",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                        children: "Exercise Type"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "pills",
                                        children: exerciseTypes.map((t)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `pill ${activeType === t ? 'active' : ''}`,
                                                onClick: ()=>setActiveType(t),
                                                children: t
                                            }, t))
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dnd.Droppable), {
                        droppableId: "library",
                        isDropDisabled: true,
                        children: (provided)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "exercise-list",
                                ref: provided.innerRef,
                                ...provided.droppableProps,
                                children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    style: {
                                        padding: '20px',
                                        textAlign: 'center',
                                        opacity: 0.5
                                    },
                                    children: "Loading exercises..."
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "alpha-group",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableExerciseItem, {
                                                index: 0,
                                                ex: {
                                                    id: 'rest-library-item',
                                                    en_display_name: 'Rest',
                                                    isRest: true,
                                                    image_male_url: '',
                                                    image_female_url: ''
                                                },
                                                tags: [
                                                    {
                                                        label: 'Rest',
                                                        type: 'yellow'
                                                    }
                                                ],
                                                getImagePath: ()=>null
                                            }, "rest-library-item")
                                        }),
                                        (()=>{
                                            let globalIndex = 1;
                                            return Object.keys(grouped).map((letter)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "alpha-group",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "alpha-label",
                                                            children: letter
                                                        }),
                                                        grouped[letter].map((ex)=>{
                                                            const tags = getDummyTags(ex);
                                                            const currIndex = globalIndex++;
                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(DraggableExerciseItem, {
                                                                index: currIndex,
                                                                ex: ex,
                                                                tags: tags,
                                                                getImagePath: getImagePath,
                                                                getFallbackImagePath: getFallbackImagePath
                                                            }, ex.id);
                                                        })
                                                    ]
                                                }, letter));
                                        })(),
                                        provided.placeholder
                                    ]
                                })
                            })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "sidebar-footer",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "footer-text",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "drag",
                            children: " Drag any exercise into a day slot"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            className: "movements",
                            children: [
                                filteredList.length,
                                " movements available"
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","@hello-pangea/dnd":"djQDB","react":"bmhQu","src/api/queries/useGetAllMovements":"lveJ0","src/assets/images/trainer/clients/close.svg":"5zasw","src/hooks/useDebounce":"fxOsA","src/utils/genderUtils":"aiA54","./ExerciseImages":"7RpZ0","../ProgramGeneratorAI/assets/ProgramGenerator":"8Npqa","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9pKyq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformProgramStateToPlan", ()=>transformProgramStateToPlan);
const DAY_CONFIG_MAP = {
    monday: {
        name: 'Monday',
        shortName: 'Mon',
        dayNum: 1,
        offsetFromMonday: 0
    },
    mon: {
        name: 'Monday',
        shortName: 'Mon',
        dayNum: 1,
        offsetFromMonday: 0
    },
    m: {
        name: 'Monday',
        shortName: 'Mon',
        dayNum: 1,
        offsetFromMonday: 0
    },
    tuesday: {
        name: 'Tuesday',
        shortName: 'Tue',
        dayNum: 2,
        offsetFromMonday: 1
    },
    tue: {
        name: 'Tuesday',
        shortName: 'Tue',
        dayNum: 2,
        offsetFromMonday: 1
    },
    t: {
        name: 'Tuesday',
        shortName: 'Tue',
        dayNum: 2,
        offsetFromMonday: 1
    },
    wednesday: {
        name: 'Wednesday',
        shortName: 'Wed',
        dayNum: 3,
        offsetFromMonday: 2
    },
    wed: {
        name: 'Wednesday',
        shortName: 'Wed',
        dayNum: 3,
        offsetFromMonday: 2
    },
    we: {
        name: 'Wednesday',
        shortName: 'Wed',
        dayNum: 3,
        offsetFromMonday: 2
    },
    w: {
        name: 'Wednesday',
        shortName: 'Wed',
        dayNum: 3,
        offsetFromMonday: 2
    },
    thursday: {
        name: 'Thursday',
        shortName: 'Thu',
        dayNum: 4,
        offsetFromMonday: 3
    },
    thu: {
        name: 'Thursday',
        shortName: 'Thu',
        dayNum: 4,
        offsetFromMonday: 3
    },
    th: {
        name: 'Thursday',
        shortName: 'Thu',
        dayNum: 4,
        offsetFromMonday: 3
    },
    friday: {
        name: 'Friday',
        shortName: 'Fri',
        dayNum: 5,
        offsetFromMonday: 4
    },
    fri: {
        name: 'Friday',
        shortName: 'Fri',
        dayNum: 5,
        offsetFromMonday: 4
    },
    f: {
        name: 'Friday',
        shortName: 'Fri',
        dayNum: 5,
        offsetFromMonday: 4
    },
    saturday: {
        name: 'Saturday',
        shortName: 'Sat',
        dayNum: 6,
        offsetFromMonday: 5
    },
    sat: {
        name: 'Saturday',
        shortName: 'Sat',
        dayNum: 6,
        offsetFromMonday: 5
    },
    sa: {
        name: 'Saturday',
        shortName: 'Sat',
        dayNum: 6,
        offsetFromMonday: 5
    },
    s: {
        name: 'Saturday',
        shortName: 'Sat',
        dayNum: 6,
        offsetFromMonday: 5
    },
    sunday: {
        name: 'Sunday',
        shortName: 'Sun',
        dayNum: 7,
        offsetFromMonday: 6
    },
    sun: {
        name: 'Sunday',
        shortName: 'Sun',
        dayNum: 7,
        offsetFromMonday: 6
    },
    su: {
        name: 'Sunday',
        shortName: 'Sun',
        dayNum: 7,
        offsetFromMonday: 6
    }
};
const DEFAULT_CONFIGS = [
    DAY_CONFIG_MAP.monday,
    DAY_CONFIG_MAP.tuesday,
    DAY_CONFIG_MAP.wednesday,
    DAY_CONFIG_MAP.thursday,
    DAY_CONFIG_MAP.friday,
    DAY_CONFIG_MAP.saturday,
    DAY_CONFIG_MAP.sunday
];
const DEFAULT_OFFSETS_BY_DAYS_COUNT = {
    1: [
        0
    ],
    2: [
        0,
        3
    ],
    3: [
        0,
        2,
        4
    ],
    4: [
        0,
        2,
        4,
        5
    ],
    5: [
        0,
        1,
        2,
        3,
        4
    ],
    6: [
        0,
        1,
        2,
        3,
        4,
        5
    ],
    7: [
        0,
        1,
        2,
        3,
        4,
        5,
        6
    ]
};
const getStartMonday = (baseDate)=>{
    const d = new Date(baseDate);
    const day = d.getDay(); // 0 is Sunday, 1 is Monday ... 6 is Saturday
    const diff = d.getDate() - day + (day === 0 ? -6 : 1);
    const monday = new Date(d.getFullYear(), d.getMonth(), diff);
    monday.setHours(0, 0, 0, 0);
    return monday;
};
const transformProgramStateToPlan = (programData, rawApiResponse, options)=>{
    const rawData = rawApiResponse?.program?.data || rawApiResponse?.result?.program?.data || rawApiResponse?.data || rawApiResponse?.result || rawApiResponse || {};
    // 1. Resolve duration in weeks
    const rawDraft = rawData.draft;
    const rawDuration = options?.duration ?? rawData.duration ?? rawDraft?.progress?.program_duration?.[0]?.value ?? rawDraft?.progress?.programDuration?.[0]?.value;
    const totalWeeks = rawDuration ? parseInt(String(rawDuration).replace(/\D/g, ''), 10) || 1 : 1;
    // 2. Existing sorted api days (if AI generated or previously saved)
    const sortedApiDays = [
        ...rawData.datetimeList || []
    ].sort((a, b)=>new Date(a.ymd).getTime() - new Date(b.ymd).getTime());
    // 3. Resolve selected schedule days (e.g. ['monday', 'wednesday', 'friday', 'saturday'])
    const rawSchedule = options?.selectedDays ?? rawData.selectedDays ?? rawData.selected_days ?? (rawDraft?.progress?.how_often_train || []).map((item)=>item.slug || item.value) ?? (rawDraft?.progress?.howOftenTrain || []).map((item)=>item.slug || item.value);
    const normalizedSchedule = [];
    const seenOffsets = new Set();
    if (Array.isArray(rawSchedule)) for (const item of rawSchedule){
        const key = String(item).trim().toLowerCase();
        const config = DAY_CONFIG_MAP[key];
        if (config && !seenOffsets.has(config.offsetFromMonday)) {
            seenOffsets.add(config.offsetFromMonday);
            normalizedSchedule.push(config);
        }
    }
    normalizedSchedule.sort((a, b)=>a.offsetFromMonday - b.offsetFromMonday);
    // 4. Resolve days per week
    const daysPerWeek = options?.daysPerWeek || (normalizedSchedule.length > 0 ? normalizedSchedule.length : 0) || (sortedApiDays.length > 0 ? Math.ceil(sortedApiDays.length / totalWeeks) : 0) || 4;
    // If normalizedSchedule is empty, fill with default days based on daysPerWeek
    if (normalizedSchedule.length === 0) {
        const offsets = DEFAULT_OFFSETS_BY_DAYS_COUNT[daysPerWeek] || DEFAULT_OFFSETS_BY_DAYS_COUNT[4];
        offsets.forEach((off)=>normalizedSchedule.push(DEFAULT_CONFIGS[off]));
    }
    // 5. Resolve reminder time
    const rawReminder = options?.reminderTime ?? rawData.howOftenTrainReminder ?? rawDraft?.progress?.how_often_train_reminder?.[0]?.value ?? rawDraft?.progress?.howOftenTrainReminder?.[0]?.value ?? 'morning';
    const reminderStr = String(rawReminder).toLowerCase();
    let defaultSelectTime = '08:00';
    let defaultHour = 8;
    let defaultMinute = 0;
    if (reminderStr.includes('lunch') || reminderStr.includes('12')) {
        defaultSelectTime = '12:00';
        defaultHour = 12;
        defaultMinute = 0;
    } else if (reminderStr.includes('evening') || reminderStr.includes('18')) {
        defaultSelectTime = '18:00';
        defaultHour = 18;
        defaultMinute = 0;
    }
    // 6. Base date for calculation
    const baseDate = rawData.createTime ? new Date(rawData.createTime) : new Date();
    const startMonday = getStartMonday(baseDate);
    const mapDurationMove = (ex)=>{
        if (ex.isRest) {
            const match = (ex.restDuration || '').match(/(\d+)/);
            const duration = match ? parseInt(match[1], 10) : 30;
            return {
                title: 'Rest',
                duration
            };
        }
        const rawRest = ex.restAfterExercise || ex.restBetweenSets || '0s';
        const match = String(rawRest).match(/\d+/);
        const cleanRest = match ? match[0] : '0';
        return {
            title: ex.name,
            duration: ex.duration || 30,
            ...cleanRest !== '0' ? {
                rest: cleanRest
            } : {}
        };
    };
    const mapWorkoutMove = (ex)=>{
        if (ex.isRest) {
            const match = (ex.restDuration || '').match(/(\d+)/);
            const duration = match ? parseInt(match[1], 10) : 30;
            return {
                title: 'Rest',
                list: [
                    {
                        reps: '0',
                        rest: `${duration}`,
                        weight: '0.0',
                        time: `${duration}`
                    }
                ]
            };
        }
        const rawRest = ex.restAfterExercise || ex.restBetweenSets || '0s';
        const match = String(rawRest).match(/\d+/);
        const cleanRest = match ? match[0] : '0';
        const list = Array.from({
            length: ex.sets || 1
        }).map(()=>{
            const setObj = {
                reps: ex.reps ? ex.reps.toString() : '15',
                rest: cleanRest,
                weight: '0.0'
            };
            if (ex.metricType === 'duration' && ex.duration) setObj.time = ex.duration.toString();
            return setObj;
        });
        return {
            title: ex.name,
            list
        };
    };
    const newDatetimeList = [];
    for(let weekNum = 1; weekNum <= totalWeeks; weekNum++){
        const weekWorkouts = programData[weekNum];
        for(let workoutNum = 1; workoutNum <= daysPerWeek; workoutNum++){
            const dayIndex = (weekNum - 1) * daysPerWeek + (workoutNum - 1);
            const apiDay = sortedApiDays.length > dayIndex ? sortedApiDays[dayIndex] : undefined;
            const dayConfig = normalizedSchedule[(workoutNum - 1) % normalizedSchedule.length];
            const workoutDate = new Date(startMonday);
            workoutDate.setDate(startMonday.getDate() + (weekNum - 1) * 7 + dayConfig.offsetFromMonday);
            const y = workoutDate.getFullYear();
            const m = workoutDate.getMonth() + 1;
            const d = workoutDate.getDate();
            const ymd = `${y}-${String(m).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
            const sectionData = weekWorkouts?.[workoutNum];
            let warmUpMoves = [];
            let moves = [];
            let coolDownMoves = [];
            if (sectionData) {
                warmUpMoves = (sectionData.warmup || []).map(mapDurationMove);
                moves = (sectionData.main || []).map(mapWorkoutMove);
                coolDownMoves = (sectionData.cooldown || []).map(mapDurationMove);
            } else if (apiDay) {
                warmUpMoves = apiDay.warmUpMoves || [];
                moves = apiDay.moves || [];
                coolDownMoves = apiDay.coolDownMoves || [];
            }
            const selectTime = apiDay?.selectTime || defaultSelectTime;
            const hour = apiDay?.hour !== undefined ? apiDay.hour : apiDay?.selectTime ? parseInt(apiDay.selectTime.split(':')[0], 10) : defaultHour;
            const minute = apiDay?.minute !== undefined ? apiDay.minute : apiDay?.selectTime ? parseInt(apiDay.selectTime.split(':')[1], 10) : defaultMinute;
            const newItem = {
                workoutType: apiDay?.workoutType || rawData.workoutType || 'programme',
                ymd: apiDay?.ymd || ymd,
                year: apiDay?.year || y,
                month: apiDay?.month || m,
                day: apiDay?.day || String(d),
                weekday: apiDay?.weekday || dayConfig.name,
                weekday2: apiDay?.weekday2 || dayConfig.shortName,
                weekdayNum: apiDay?.weekdayNum || dayConfig.dayNum,
                selectTime,
                hour,
                minute,
                warmUpMoves,
                moves,
                coolDownMoves
            };
            newDatetimeList.push(newItem);
        }
    }
    const isManually = options?.isManually ?? rawData.isManually ?? false;
    const isAIGenerate = isManually ? false : rawData.isAIGenerate !== undefined ? Boolean(rawData.isAIGenerate) : true;
    return {
        createTime: rawData.createTime || new Date().toISOString(),
        duration: String(totalWeeks),
        focus_area: rawData.area || rawData.focus_area || '',
        isAIGenerate,
        isManually,
        isActive: rawData.isActive !== undefined ? String(rawData.isActive) : '0',
        programmeName: rawData.programmeName || '',
        updateTime: new Date().toISOString(),
        workoutType: rawData.workoutType || 'programme',
        datetimeList: newDatetimeList,
        ...rawDraft ? {
            draft: rawDraft
        } : {}
    };
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"P6SxW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformApiToProgramData", ()=>transformApiToProgramData);
parcelHelpers.export(exports, "transformFinalPlanToProgramData", ()=>transformFinalPlanToProgramData);
const transformApiToProgramData = (apiResponse, scheduleDaysPerWeek)=>{
    const rawData = apiResponse.program?.data || apiResponse.result?.program?.data;
    const apiDays = rawData?.datetimeList || [];
    const programData = {};
    if (apiDays.length === 0) return programData;
    // Extract total program duration in weeks, default to 1 if missing
    const durationStr = rawData?.duration;
    // Sort apiDays chronologically to maintain logical workout order within a week
    const sortedDays = [
        ...apiDays
    ].sort((a, b)=>new Date(a.ymd).getTime() - new Date(b.ymd).getTime());
    if (sortedDays.length > 0) {
        const daysPerWeek = scheduleDaysPerWeek > 0 ? scheduleDaysPerWeek : (parseInt(durationStr || '1', 10) > 0 && sortedDays.length >= parseInt(durationStr || '1', 10) ? Math.ceil(sortedDays.length / parseInt(durationStr || '1', 10)) : sortedDays.length) || 1;
        sortedDays.forEach((apiDay, index)=>{
            const weekNum = Math.floor(index / daysPerWeek) + 1;
            if (!programData[weekNum]) programData[weekNum] = {};
            const currentWorkout = Object.keys(programData[weekNum]).length + 1;
            const rawWarmup = apiDay.warmUpMoves || apiDay.warm_up_moves || apiDay.warmupMoves || apiDay.warmup_moves || [];
            const warmup = rawWarmup.map((m)=>{
                const isRest = m.title?.toLowerCase() === 'rest';
                const restMatch = m.rest ? String(m.rest).match(/\d+/) : m.restAfterExercise ? String(m.restAfterExercise).match(/\d+/) : m.restBetweenSets ? String(m.restBetweenSets).match(/\d+/) : null;
                const restNum = restMatch ? parseInt(restMatch[0], 10) : 0;
                const restStr = restNum > 0 ? `${restNum}s` : '0s';
                return {
                    id: `ex-${Date.now()}-${Math.random()}`,
                    name: m.title,
                    tags: [
                        {
                            label: 'Warmup',
                            type: 'section'
                        }
                    ],
                    sets: 1,
                    metricType: 'duration',
                    duration: m.duration,
                    restBetweenSets: restStr,
                    restAfterExercise: restStr,
                    isRest,
                    restDuration: isRest ? `${m.duration || 30} sec` : undefined
                };
            });
            const rawMain = apiDay.moves || apiDay.main || apiDay.mainMoves || apiDay.main_moves || [];
            const main = rawMain.map((m)=>{
                const isRest = m.title?.toLowerCase() === 'rest';
                const setsCount = m.list?.length || 1;
                const firstSet = m.list?.[0];
                const restMatch = firstSet?.rest ? String(firstSet.rest).match(/\d+/) : null;
                const restNum = restMatch ? parseInt(restMatch[0], 10) : 0;
                const restStr = restNum > 0 ? `${restNum}s` : '0s';
                return {
                    id: `ex-${Date.now()}-${Math.random()}`,
                    name: m.title,
                    tags: [
                        {
                            label: 'Main',
                            type: 'section'
                        }
                    ],
                    sets: setsCount,
                    metricType: firstSet?.time ? 'duration' : 'reps',
                    reps: firstSet?.reps ? parseInt(firstSet.reps, 10) : undefined,
                    duration: firstSet?.time ? parseInt(firstSet.time, 10) : undefined,
                    restBetweenSets: restStr,
                    restAfterExercise: restStr,
                    isRest,
                    restDuration: isRest ? `${firstSet?.time || firstSet?.rest || 30} sec` : undefined
                };
            });
            const rawCooldown = apiDay.coolDownMoves || apiDay.cool_down_moves || apiDay.cooldownMoves || apiDay.cooldown_moves || [];
            const cooldown = rawCooldown.map((m)=>{
                const isRest = m.title?.toLowerCase() === 'rest';
                const restMatch = m.rest ? String(m.rest).match(/\d+/) : m.restAfterExercise ? String(m.restAfterExercise).match(/\d+/) : m.restBetweenSets ? String(m.restBetweenSets).match(/\d+/) : null;
                const restNum = restMatch ? parseInt(restMatch[0], 10) : 0;
                const restStr = restNum > 0 ? `${restNum}s` : '0s';
                return {
                    id: `ex-${Date.now()}-${Math.random()}`,
                    name: m.title,
                    tags: [
                        {
                            label: 'Cooldown',
                            type: 'section'
                        }
                    ],
                    sets: 1,
                    metricType: 'duration',
                    duration: m.duration,
                    restBetweenSets: restStr,
                    restAfterExercise: restStr,
                    isRest,
                    restDuration: isRest ? `${m.duration || 30} sec` : undefined
                };
            });
            programData[weekNum][currentWorkout] = {
                warmup,
                main,
                cooldown
            };
        });
    }
    return programData;
};
const transformFinalPlanToProgramData = (apiResponse, scheduleDaysPerWeek)=>{
    const apiDays = apiResponse?.datetimeList || [];
    const programData = {};
    if (apiDays.length === 0) return programData;
    const durationStr = apiResponse?.duration;
    const sortedDays = [
        ...apiDays
    ].sort((a, b)=>new Date(a.ymd).getTime() - new Date(b.ymd).getTime());
    if (sortedDays.length > 0) {
        const daysPerWeek = scheduleDaysPerWeek > 0 ? scheduleDaysPerWeek : (parseInt(durationStr || '1', 10) > 0 && sortedDays.length >= parseInt(durationStr || '1', 10) ? Math.ceil(sortedDays.length / parseInt(durationStr || '1', 10)) : sortedDays.length) || 1;
        sortedDays.forEach((apiDay, index)=>{
            const weekNum = Math.floor(index / daysPerWeek) + 1;
            if (!programData[weekNum]) programData[weekNum] = {};
            const currentWorkout = Object.keys(programData[weekNum]).length + 1;
            const rawWarmup = apiDay.warmUpMoves || apiDay.warm_up_moves || apiDay.warmupMoves || apiDay.warmup_moves || [];
            const warmup = rawWarmup.map((m)=>{
                const isRest = m.title?.toLowerCase() === 'rest';
                const restMatch = m.rest ? String(m.rest).match(/\d+/) : m.restAfterExercise ? String(m.restAfterExercise).match(/\d+/) : m.restBetweenSets ? String(m.restBetweenSets).match(/\d+/) : null;
                const restNum = restMatch ? parseInt(restMatch[0], 10) : 0;
                const restStr = restNum > 0 ? `${restNum}s` : '0s';
                return {
                    id: `ex-${Date.now()}-${Math.random()}`,
                    name: m.title,
                    tags: [
                        {
                            label: 'Warmup',
                            type: 'section'
                        }
                    ],
                    sets: 1,
                    metricType: 'duration',
                    duration: m.duration,
                    restBetweenSets: restStr,
                    restAfterExercise: restStr,
                    isRest,
                    restDuration: isRest ? `${m.duration || 30} sec` : undefined
                };
            });
            const rawMain = apiDay.moves || apiDay.main || apiDay.mainMoves || apiDay.main_moves || [];
            const main = rawMain.map((m)=>{
                const isRest = m.title?.toLowerCase() === 'rest';
                const setsCount = m.list?.length || 1;
                const firstSet = m.list?.[0];
                const restMatch = firstSet?.rest ? String(firstSet.rest).match(/\d+/) : null;
                const restNum = restMatch ? parseInt(restMatch[0], 10) : 0;
                const restStr = restNum > 0 ? `${restNum}s` : '0s';
                return {
                    id: `ex-${Date.now()}-${Math.random()}`,
                    name: m.title,
                    tags: [
                        {
                            label: 'Main',
                            type: 'section'
                        }
                    ],
                    sets: setsCount,
                    metricType: firstSet?.time ? 'duration' : 'reps',
                    reps: firstSet?.reps ? parseInt(firstSet.reps, 10) : undefined,
                    duration: firstSet?.time ? parseInt(firstSet.time, 10) : undefined,
                    restBetweenSets: restStr,
                    restAfterExercise: restStr,
                    isRest,
                    restDuration: isRest ? `${firstSet?.time || firstSet?.rest || 30} sec` : undefined
                };
            });
            const rawCooldown = apiDay.coolDownMoves || apiDay.cool_down_moves || apiDay.cooldownMoves || apiDay.cooldown_moves || [];
            const cooldown = rawCooldown.map((m)=>{
                const isRest = m.title?.toLowerCase() === 'rest';
                const restMatch = m.rest ? String(m.rest).match(/\d+/) : m.restAfterExercise ? String(m.restAfterExercise).match(/\d+/) : m.restBetweenSets ? String(m.restBetweenSets).match(/\d+/) : null;
                const restNum = restMatch ? parseInt(restMatch[0], 10) : 0;
                const restStr = restNum > 0 ? `${restNum}s` : '0s';
                return {
                    id: `ex-${Date.now()}-${Math.random()}`,
                    name: m.title,
                    tags: [
                        {
                            label: 'Cooldown',
                            type: 'section'
                        }
                    ],
                    sets: 1,
                    metricType: 'duration',
                    duration: m.duration,
                    restBetweenSets: restStr,
                    restAfterExercise: restStr,
                    isRest,
                    restDuration: isRest ? `${m.duration || 30} sec` : undefined
                };
            });
            programData[weekNum][currentWorkout] = {
                warmup,
                main,
                cooldown
            };
        });
    }
    return programData;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fetaT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "transformApiToProgramData", ()=>transformApiToProgramData);
parcelHelpers.export(exports, "transformFinalPlanToProgramData", ()=>transformFinalPlanToProgramData);
const transformApiToProgramData = (apiResponse, scheduleDaysPerWeek)=>{
    const apiDays = apiResponse.result?.program?.data?.datetimeList || [];
    const programData = {};
    if (apiDays.length === 0) return programData;
    // Extract total program duration in weeks, default to 1 if missing
    const durationStr = apiResponse.result?.program?.data?.duration;
    const totalWeeks = durationStr ? parseInt(durationStr, 10) : 1;
    // Sort apiDays chronologically to maintain logical workout order within a week
    const sortedDays = [
        ...apiDays
    ].sort((a, b)=>new Date(a.ymd).getTime() - new Date(b.ymd).getTime());
    // Calculate how many days go into each week based on the total workouts
    const workoutsPerWeek = scheduleDaysPerWeek > 0 ? scheduleDaysPerWeek : (totalWeeks > 0 && sortedDays.length >= totalWeeks ? Math.ceil(sortedDays.length / totalWeeks) : sortedDays.length) || 1;
    let currentWeek = 1;
    let currentWorkout = 1;
    sortedDays.forEach((apiDay)=>{
        if (!programData[currentWeek]) programData[currentWeek] = {};
        const rawWarmup = apiDay.warmUpMoves || apiDay.warm_up_moves || apiDay.warmupMoves || apiDay.warmup_moves || [];
        const warmup = rawWarmup.map((m)=>{
            const isRest = m.title?.toLowerCase() === 'rest';
            const restMatch = m.rest ? String(m.rest).match(/\d+/) : m.restAfterExercise ? String(m.restAfterExercise).match(/\d+/) : m.restBetweenSets ? String(m.restBetweenSets).match(/\d+/) : null;
            const restNum = restMatch ? parseInt(restMatch[0], 10) : 0;
            const restStr = restNum > 0 ? `${restNum}s` : '0s';
            return {
                id: `ex-${Date.now()}-${Math.random()}`,
                name: m.title,
                tags: [
                    {
                        label: 'Warmup',
                        type: 'section'
                    }
                ],
                sets: 1,
                metricType: 'duration',
                duration: m.duration,
                restBetweenSets: restStr,
                restAfterExercise: restStr,
                isRest,
                restDuration: isRest ? `${m.duration || 30} sec` : undefined
            };
        });
        const rawMain = apiDay.moves || apiDay.main || apiDay.mainMoves || apiDay.main_moves || [];
        const main = rawMain.map((m)=>{
            const isRest = m.title?.toLowerCase() === 'rest';
            const setsCount = m.list?.length || 1;
            const firstSet = m.list?.[0];
            const restMatch = firstSet?.rest ? String(firstSet.rest).match(/\d+/) : null;
            const restNum = restMatch ? parseInt(restMatch[0], 10) : 0;
            const restStr = restNum > 0 ? `${restNum}s` : '0s';
            return {
                id: `ex-${Date.now()}-${Math.random()}`,
                name: m.title,
                tags: [
                    {
                        label: 'Main',
                        type: 'section'
                    }
                ],
                sets: setsCount,
                metricType: firstSet?.time ? 'duration' : 'reps',
                reps: firstSet?.reps ? parseInt(firstSet.reps, 10) : undefined,
                duration: firstSet?.time ? parseInt(firstSet.time, 10) : undefined,
                restBetweenSets: restStr,
                restAfterExercise: restStr,
                isRest,
                restDuration: isRest ? `${firstSet?.time || firstSet?.rest || 30} sec` : undefined
            };
        });
        const rawCooldown = apiDay.coolDownMoves || apiDay.cool_down_moves || apiDay.cooldownMoves || apiDay.cooldown_moves || [];
        const cooldown = rawCooldown.map((m)=>{
            const isRest = m.title?.toLowerCase() === 'rest';
            const restMatch = m.rest ? String(m.rest).match(/\d+/) : m.restAfterExercise ? String(m.restAfterExercise).match(/\d+/) : m.restBetweenSets ? String(m.restBetweenSets).match(/\d+/) : null;
            const restNum = restMatch ? parseInt(restMatch[0], 10) : 0;
            const restStr = restNum > 0 ? `${restNum}s` : '0s';
            return {
                id: `ex-${Date.now()}-${Math.random()}`,
                name: m.title,
                tags: [
                    {
                        label: 'Cooldown',
                        type: 'section'
                    }
                ],
                sets: 1,
                metricType: 'duration',
                duration: m.duration,
                restBetweenSets: restStr,
                restAfterExercise: restStr,
                isRest,
                restDuration: isRest ? `${m.duration || 30} sec` : undefined
            };
        });
        programData[currentWeek][currentWorkout] = {
            warmup,
            main,
            cooldown
        };
        currentWorkout++;
        if (currentWorkout > workoutsPerWeek) {
            currentWeek++;
            currentWorkout = 1;
        }
    });
    return programData;
};
const transformFinalPlanToProgramData = (apiResponse, scheduleDaysPerWeek)=>{
    const apiDays = apiResponse?.datetimeList || [];
    const programData = {};
    if (apiDays.length === 0) return programData;
    const durationStr = apiResponse?.duration;
    const totalWeeks = durationStr ? parseInt(durationStr, 10) : 1;
    const sortedDays = [
        ...apiDays
    ].sort((a, b)=>new Date(a.ymd).getTime() - new Date(b.ymd).getTime());
    // Calculate how many days go into each week based on the total workouts
    const workoutsPerWeek = scheduleDaysPerWeek > 0 ? scheduleDaysPerWeek : (totalWeeks > 0 && sortedDays.length >= totalWeeks ? Math.ceil(sortedDays.length / totalWeeks) : sortedDays.length) || 1;
    let currentWeek = 1;
    let currentWorkout = 1;
    sortedDays.forEach((apiDay)=>{
        if (!programData[currentWeek]) programData[currentWeek] = {};
        const rawWarmup = apiDay.warmUpMoves || apiDay.warm_up_moves || apiDay.warmupMoves || apiDay.warmup_moves || [];
        const warmup = rawWarmup.map((m)=>{
            const isRest = m.title?.toLowerCase() === 'rest';
            const restMatch = m.rest ? String(m.rest).match(/\d+/) : m.restAfterExercise ? String(m.restAfterExercise).match(/\d+/) : m.restBetweenSets ? String(m.restBetweenSets).match(/\d+/) : null;
            const restNum = restMatch ? parseInt(restMatch[0], 10) : 0;
            const restStr = restNum > 0 ? `${restNum}s` : '0s';
            return {
                id: `ex-${Date.now()}-${Math.random()}`,
                name: m.title,
                tags: [
                    {
                        label: 'Warmup',
                        type: 'section'
                    }
                ],
                sets: 1,
                metricType: 'duration',
                duration: m.duration,
                restBetweenSets: restStr,
                restAfterExercise: restStr,
                isRest,
                restDuration: isRest ? `${m.duration || 30} sec` : undefined
            };
        });
        const rawMain = apiDay.moves || apiDay.main || apiDay.mainMoves || apiDay.main_moves || [];
        const main = rawMain.map((m)=>{
            const isRest = m.title?.toLowerCase() === 'rest';
            const setsCount = m.list?.length || 1;
            const firstSet = m.list?.[0];
            const restMatch = firstSet?.rest ? String(firstSet.rest).match(/\d+/) : null;
            const restNum = restMatch ? parseInt(restMatch[0], 10) : 0;
            const restStr = restNum > 0 ? `${restNum}s` : '0s';
            return {
                id: `ex-${Date.now()}-${Math.random()}`,
                name: m.title,
                tags: [
                    {
                        label: 'Main',
                        type: 'section'
                    }
                ],
                sets: setsCount,
                metricType: firstSet?.time ? 'duration' : 'reps',
                reps: firstSet?.reps ? parseInt(firstSet.reps, 10) : undefined,
                duration: firstSet?.time ? parseInt(firstSet.time, 10) : undefined,
                restBetweenSets: restStr,
                restAfterExercise: restStr,
                isRest,
                restDuration: isRest ? `${firstSet?.time || firstSet?.rest || 30} sec` : undefined
            };
        });
        const rawCooldown = apiDay.coolDownMoves || apiDay.cool_down_moves || apiDay.cooldownMoves || apiDay.cooldown_moves || [];
        const cooldown = rawCooldown.map((m)=>{
            const isRest = m.title?.toLowerCase() === 'rest';
            const restMatch = m.rest ? String(m.rest).match(/\d+/) : m.restAfterExercise ? String(m.restAfterExercise).match(/\d+/) : m.restBetweenSets ? String(m.restBetweenSets).match(/\d+/) : null;
            const restNum = restMatch ? parseInt(restMatch[0], 10) : 0;
            const restStr = restNum > 0 ? `${restNum}s` : '0s';
            return {
                id: `ex-${Date.now()}-${Math.random()}`,
                name: m.title,
                tags: [
                    {
                        label: 'Cooldown',
                        type: 'section'
                    }
                ],
                sets: 1,
                metricType: 'duration',
                duration: m.duration,
                restBetweenSets: restStr,
                restAfterExercise: restStr,
                isRest,
                restDuration: isRest ? `${m.duration || 30} sec` : undefined
            };
        });
        programData[currentWeek][currentWorkout] = {
            warmup,
            main,
            cooldown
        };
        currentWorkout++;
        if (currentWorkout > workoutsPerWeek) {
            currentWeek++;
            currentWorkout = 1;
        }
    });
    return programData;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fGBV7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DashboardMessagesLayout", ()=>DashboardMessagesLayout);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _messagesSidePanel = require("./components/MessagesSidePanel/MessagesSidePanel");
var _dashboardMessagesLayoutScss = require("./DashboardMessagesLayout.scss");
const DashboardMessagesLayout = ()=>{
    const { chatId, checkinId } = (0, _reactRouterDom.useParams)();
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const inquiryId = searchParams.get('inquiryId') || undefined;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "dashboard-messages-split-layout",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("aside", {
                className: "messages-side-panel-pane",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesSidePanel.MessagesSidePanel), {
                    activeChatId: chatId,
                    activeCheckinId: checkinId,
                    activeInquiryId: inquiryId
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("main", {
                className: "messages-main-pane",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {})
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["Outlet","9oT3O"],["useParams","9oT3O"],["useSearchParams","f3cgC"]],"./components/MessagesSidePanel/MessagesSidePanel":"e0o0T","./DashboardMessagesLayout.scss":"7Cpux","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e0o0T":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MessagesSidePanel", ()=>MessagesSidePanel);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _reactRouterDom = require("react-router-dom");
var _reactInfiniteScrollComponent = require("react-infinite-scroll-component");
var _reactInfiniteScrollComponentDefault = parcelHelpers.interopDefault(_reactInfiniteScrollComponent);
var _useGetTrainerMessages = require("src/api/mutations/useGetTrainerMessages");
var _useGetTrainerClients = require("src/api/mutations/useGetTrainerClients");
var _useChatRealtime = require("src/hooks/useChatRealtime");
var _useInquiriesRealtime = require("src/hooks/useInquiriesRealtime");
var _useCheckinsRealtime = require("src/hooks/useCheckinsRealtime");
var _firebase = require("src/config/firebase");
var _types = require("../../types");
var _inquiriesList = require("../InquiriesList");
var _checkinsList = require("../../../Checkins/CheckinsList");
var _pushDevicesManager = require("src/components/PushDevicesManager/PushDevicesManager");
var _registerPush = require("src/services/push/registerPush");
var _sessionStore = require("src/store/sessionStore");
var _searchSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/search.svg");
var _filterSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/filter.svg");
var _emptyMessagesSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/empty-messages.svg");
var _clearSearchSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/clear-search.svg");
var _chatSupportHeadsetSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-support-headset.svg");
var _bellEnabledSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/notifications/bell-enabled.svg");
var _bellDisabledSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/notifications/bell-disabled.svg");
var _messagesSidePanelScss = require("./MessagesSidePanel.scss");
const SORT_ITEMS = [
    {
        key: 'newest',
        label: 'Date (Newest)'
    },
    {
        key: 'oldest',
        label: 'Date (Oldest)'
    },
    {
        key: 'name_asc',
        label: 'Name (A-Z)'
    }
];
const MessagesSidePanel = ({ activeChatId, activeCheckinId, activeInquiryId, onConversationsLoaded })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const currentUser = (0, _sessionStore.sessionStore)((state)=>state.currentUser);
    const trainerUid = (0, _firebase.auth).currentUser?.uid || currentUser?.uid || '';
    const [pushManagerOpen, setPushManagerOpen] = (0, _react.useState)(false);
    const [isPushEnabled, setIsPushEnabled] = (0, _react.useState)(false);
    const [isPushLoading, setIsPushLoading] = (0, _react.useState)(true);
    const isInitialPushCheckRef = (0, _react.useRef)(true);
    // Check push subscription state
    (0, _react.useEffect)(()=>{
        const unsubscribe = (0, _firebase.auth).onAuthStateChanged(async (user)=>{
            if (!user) {
                setIsPushLoading(false);
                isInitialPushCheckRef.current = false;
                setIsPushEnabled(false);
                return;
            }
            if (isInitialPushCheckRef.current) setIsPushLoading(true);
            try {
                const [subs, token] = await Promise.all([
                    (0, _registerPush.getUserPushSubscriptions)(user.uid, 'trainer'),
                    (0, _registerPush.getCurrentFCMToken)()
                ]);
                const hasPermission = typeof window !== 'undefined' && 'Notification' in window ? Notification.permission === 'granted' : false;
                const storedSubId = typeof window !== 'undefined' ? localStorage.getItem('minipt_current_fcm_sub_id') : null;
                const isThisDeviceRegistered = subs.some((s)=>token && s.fcm_token === token || storedSubId && s.id === storedSubId);
                setIsPushEnabled(isThisDeviceRegistered && hasPermission);
            } catch  {
                setIsPushEnabled(false);
            } finally{
                if (isInitialPushCheckRef.current) {
                    setIsPushLoading(false);
                    isInitialPushCheckRef.current = false;
                }
            }
        });
        return ()=>unsubscribe();
    }, [
        pushManagerOpen
    ]);
    // Tab state: default from query param, or inferred from route context
    const tabFromUrl = searchParams.get('tab');
    const inferredTab = activeCheckinId ? 'checkins' : activeInquiryId || activeChatId?.startsWith('support_') ? 'inquiries' : tabFromUrl || 'messages';
    const [activeTab, setActiveTab] = (0, _react.useState)(inferredTab);
    (0, _react.useEffect)(()=>{
        if (tabFromUrl) setActiveTab(tabFromUrl);
        else if (activeCheckinId) setActiveTab('checkins');
        else if (activeInquiryId || activeChatId?.startsWith('support_')) setActiveTab('inquiries');
    }, [
        tabFromUrl,
        activeCheckinId,
        activeInquiryId,
        activeChatId
    ]);
    const [searchQuery, setSearchQuery] = (0, _react.useState)('');
    const [debouncedSearch, setDebouncedSearch] = (0, _react.useState)('');
    const [clientFilter, setClientFilter] = (0, _react.useState)('all');
    const [sortFilter, setSortFilter] = (0, _react.useState)('newest');
    // Pagination & Data state
    const [cursor, setCursor] = (0, _react.useState)(undefined);
    const [allConversations, setAllConversations] = (0, _react.useState)([]);
    const [hasMore, setHasMore] = (0, _react.useState)(true);
    // Fetch client options for filter
    const { data: clientsData } = (0, _useGetTrainerClients.useGetTrainerClients)('all', '', 'name_asc', 1, 1000);
    const clientOptions = (0, _react.useMemo)(()=>{
        const list = clientsData?.clients || [];
        return [
            {
                key: 'all',
                label: 'All Clients'
            },
            ...list.map((c)=>({
                    key: c.uid,
                    label: `${c.name} ${c.surname}`
                }))
        ];
    }, [
        clientsData
    ]);
    const clientInfoMap = (0, _react.useMemo)(()=>{
        const map = {};
        (clientsData?.clients || []).forEach((c)=>{
            const fullName = `${c.name || ''} ${c.surname || ''}`.trim() || c.email || 'Client';
            map[c.uid] = {
                fullName,
                profilePicture: c.avatarUrl || null
            };
        });
        return map;
    }, [
        clientsData
    ]);
    // Realtime updates
    const { realtimeUpdates } = (0, _useChatRealtime.useChatRealtime)();
    const { inquiries, isLoading: isLoadingInquiries } = (0, _useInquiriesRealtime.useInquiriesRealtime)(trainerUid);
    const { checkins: realtimeCheckins } = (0, _useCheckinsRealtime.useCheckinsRealtime)(trainerUid);
    const prevFiltersRef = (0, _react.useRef)({
        clientFilter,
        sortFilter,
        debouncedSearch
    });
    const [isFetchingPage, setIsFetchingPage] = (0, _react.useState)(false);
    const { data: pageData, isFetching, isLoading: isMessagesLoading } = (0, _useGetTrainerMessages.useGetTrainerMessagesPage)({
        search: debouncedSearch,
        clientId: clientFilter,
        sort: sortFilter,
        limit: 30,
        cursor
    }, !isFetchingPage);
    (0, _react.useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedSearch(searchQuery);
        }, 500);
        return ()=>clearTimeout(handler);
    }, [
        searchQuery
    ]);
    (0, _react.useEffect)(()=>{
        const prev = prevFiltersRef.current;
        if (prev.clientFilter !== clientFilter || prev.sortFilter !== sortFilter || prev.debouncedSearch !== debouncedSearch) {
            prevFiltersRef.current = {
                clientFilter,
                sortFilter,
                debouncedSearch
            };
            setAllConversations([]);
            setCursor(undefined);
            setHasMore(true);
            setIsFetchingPage(false);
        }
    }, [
        clientFilter,
        sortFilter,
        debouncedSearch
    ]);
    (0, _react.useEffect)(()=>{
        if (pageData && !isFetching) {
            setAllConversations((prev)=>{
                const existingIds = new Set(prev.map((c)=>c.chatId));
                const newItems = pageData.items.filter((c)=>!existingIds.has(c.chatId));
                return [
                    ...prev,
                    ...newItems
                ];
            });
            setHasMore(pageData.hasMore);
            setIsFetchingPage(true);
        }
    }, [
        pageData,
        isFetching
    ]);
    const loadNextPage = ()=>{
        if (pageData?.nextCursor && hasMore) {
            setCursor(pageData.nextCursor);
            setIsFetchingPage(false);
        }
    };
    const displayConversations = (0, _react.useMemo)(()=>{
        let merged = [
            ...allConversations
        ];
        Object.values(realtimeUpdates).forEach((updatedChat)=>{
            if (clientFilter !== 'all' && updatedChat.client.uid !== clientFilter) return;
            if (debouncedSearch) {
                const term = debouncedSearch.toLowerCase();
                if (!updatedChat.lastMessage.body.toLowerCase().includes(term)) return;
            }
            const idx = merged.findIndex((c)=>c.chatId === updatedChat.chatId);
            if (idx !== -1) merged[idx] = {
                ...merged[idx],
                ...updatedChat
            };
            else merged.push(updatedChat);
        });
        merged.sort((a, b)=>{
            if (sortFilter === 'newest') return new Date(b.lastMessage.sendTime).getTime() - new Date(a.lastMessage.sendTime).getTime();
            else if (sortFilter === 'oldest') return new Date(a.lastMessage.sendTime).getTime() - new Date(b.lastMessage.sendTime).getTime();
            else if (sortFilter === 'name_asc') return (a.client.fullName || '').localeCompare(b.client.fullName || '');
            return 0;
        });
        const seen = new Set();
        merged = merged.filter((c)=>{
            if (seen.has(c.chatId)) return false;
            seen.add(c.chatId);
            return true;
        });
        if (Object.keys(clientInfoMap).length > 0) merged = merged.filter((c)=>!!clientInfoMap[c.client.uid]);
        merged = merged.map((c)=>{
            const info = clientInfoMap[c.client.uid];
            if (info) return {
                ...c,
                client: {
                    ...c.client,
                    fullName: info.fullName && info.fullName !== 'Client' ? info.fullName : c.client.fullName !== 'Unknown' && c.client.fullName !== 'Client' ? c.client.fullName : info.fullName || 'Client',
                    profilePicture: info.profilePicture || c.client.profilePicture
                }
            };
            return c;
        });
        // Remove support conversations from normal messages tab
        merged = merged.filter((c)=>!c.isSupport && !c.chatId?.startsWith('support_') && c.client?.fullName !== 'miniPT Support');
        return merged;
    }, [
        allConversations,
        realtimeUpdates,
        clientFilter,
        sortFilter,
        debouncedSearch,
        clientInfoMap
    ]);
    (0, _react.useEffect)(()=>{
        if (onConversationsLoaded) onConversationsLoaded(displayConversations);
    }, [
        displayConversations,
        onConversationsLoaded
    ]);
    // Unread badge indicators
    const unreadMessagesCount = (0, _react.useMemo)(()=>{
        return displayConversations.filter((c)=>{
            const isSentByTrainer = c.lastMessage?.senderUid === trainerUid || c.lastMessage?.sender_uid === trainerUid;
            return c.isUnread && !isSentByTrainer;
        }).length;
    }, [
        displayConversations,
        trainerUid
    ]);
    const unreadInquiriesCount = (0, _react.useMemo)(()=>{
        return inquiries.filter((inq)=>{
            const isSentByTrainer = inq.message?.sender_role === 'trainer' || inq.message?.sender_uid === trainerUid || inq.message?.send_uid === trainerUid;
            return !isSentByTrainer && !inq.message.is_read;
        }).length;
    }, [
        inquiries,
        trainerUid
    ]);
    const unreadCheckinsCount = (0, _react.useMemo)(()=>{
        return realtimeCheckins.filter((c)=>!c.is_read && (c.isAppoint || Boolean(c.appointUId))).length;
    }, [
        realtimeCheckins
    ]);
    const formatMessageTime = (isoString)=>{
        if (!isoString) return '';
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return '';
        const now = new Date();
        const isToday = date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);
        const isYesterday = date.getDate() === yesterday.getDate() && date.getMonth() === yesterday.getMonth() && date.getFullYear() === yesterday.getFullYear();
        const timeStr = date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        if (isToday) return timeStr;
        if (isYesterday) return 'Yesterday';
        return date.toLocaleDateString([], {
            month: 'short',
            day: 'numeric',
            year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
        });
    };
    const getInitials = (fullName)=>{
        if (!fullName) return 'U';
        const parts = fullName.trim().split(' ');
        if (parts.length > 1) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        return fullName.substring(0, 2).toUpperCase();
    };
    const handleTabChange = (tab)=>{
        setActiveTab(tab);
        navigate(`/onboarding-trainer/dashboard/messages?tab=${tab}`);
    };
    const getSearchPlaceholder = ()=>{
        if (activeTab === 'inquiries') return 'Search inquiries';
        if (activeTab === 'checkins') return 'Search check-ins';
        return 'Search messages';
    };
    const filteredInquiries = (0, _react.useMemo)(()=>{
        return inquiries.filter((inq)=>{
            const isSupport = Boolean(inq.message.is_support) || inq.chatId.startsWith('support_') || inq.message.sender_name === 'miniPT Support';
            const clientUid = inq.chatId.split('_').find((id)=>id !== currentUser?.uid);
            const clientFromConvo = displayConversations.find((c)=>c.chatId === inq.chatId)?.client;
            const clientFromMap = clientUid ? clientInfoMap[clientUid] : undefined;
            const clientFullName = isSupport ? 'miniPT Support' : clientFromConvo?.fullName || clientFromMap?.fullName || inq.message.sender_name || '';
            if (clientFilter && clientFilter !== 'all') {
                if (isSupport) return false;
                if (clientUid !== clientFilter) return false;
            }
            if (debouncedSearch) {
                const q = debouncedSearch.toLowerCase();
                const nameMatch = clientFullName.toLowerCase().includes(q);
                const bodyMatch = (inq.message.body || '').toLowerCase().includes(q) || (inq.message.inquiry_text || '').toLowerCase().includes(q);
                const subjectMatch = (inq.message.inquirySubject || inq.message.subject || '').toLowerCase().includes(q);
                const detailMatch = (inq.message.inquiryDetail || '').toLowerCase().includes(q);
                const typeMatch = (inq.message.inquiryType || inq.message.topic || inq.message.category || inq.message.inquiry_category || '').toLowerCase().includes(q);
                if (!nameMatch && !bodyMatch && !subjectMatch && !detailMatch && !typeMatch) return false;
            }
            return true;
        });
    }, [
        inquiries,
        displayConversations,
        clientInfoMap,
        clientFilter,
        debouncedSearch,
        currentUser?.uid
    ]);
    // Combined filter menu for the compact filter button
    const filterMenuItems = (0, _react.useMemo)(()=>{
        return [
            {
                key: 'sort-group',
                type: 'group',
                label: 'SORT BY DATE',
                children: SORT_ITEMS.map((item)=>({
                        key: `sort:${item.key}`,
                        label: `${item.label} ${sortFilter === item.key ? "\u2713" : ''}`
                    }))
            },
            {
                type: 'divider'
            },
            {
                key: 'client-group',
                type: 'group',
                label: 'FILTER CLIENT',
                children: clientOptions.slice(0, 15).map((opt)=>({
                        key: `client:${opt.key}`,
                        label: `${opt.label} ${clientFilter === opt.key ? "\u2713" : ''}`
                    }))
            }
        ];
    }, [
        sortFilter,
        clientOptions,
        clientFilter
    ]);
    const handleFilterMenuClick = ({ key })=>{
        if (key.startsWith('sort:')) setSortFilter(key.replace('sort:', ''));
        else if (key.startsWith('client:')) setClientFilter(key.replace('client:', ''));
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "messages-side-panel",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "side-panel-top-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "side-panel-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                className: "side-panel-title",
                                children: "Messages"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>setPushManagerOpen(true),
                                className: `push-settings-btn ${isPushLoading ? 'loading' : isPushEnabled ? 'enabled' : 'disabled'}`,
                                title: isPushLoading ? 'Loading notification settings...' : isPushEnabled ? 'Notification settings: Active' : 'Notification settings: Disabled',
                                "aria-label": "Notification settings",
                                children: isPushLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                    style: {
                                        fontSize: 16,
                                        color: '#FFA100'
                                    },
                                    spin: true
                                }) : isPushEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bellEnabledSvg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bellDisabledSvg.ReactComponent), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "side-panel-search-row",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "search-input-box",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchSvg.ReactComponent), {
                                        className: "search-icon"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "text",
                                        placeholder: getSearchPlaceholder(),
                                        value: searchQuery,
                                        onChange: (e)=>setSearchQuery(e.target.value),
                                        onBlur: (e)=>setSearchQuery(e.target.value.trim())
                                    }),
                                    searchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        onClick: ()=>setSearchQuery(''),
                                        className: "clear-search-btn",
                                        "aria-label": "Clear search",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearSearchSvg.ReactComponent), {})
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                menu: {
                                    items: filterMenuItems,
                                    onClick: handleFilterMenuClick
                                },
                                trigger: [
                                    'click'
                                ],
                                placement: "bottomRight",
                                rootClassName: "dark-theme-dropdown",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: `filter-icon-btn ${clientFilter !== 'all' || sortFilter !== 'newest' ? 'active' : ''}`,
                                    "aria-label": "Filter conversations",
                                    title: "Filter & Sort",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSvg.ReactComponent), {})
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "side-panel-tabs",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `side-tab-pill ${activeTab === 'messages' ? 'active' : ''}`,
                        onClick: ()=>handleTabChange('messages'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "tab-label-wrap",
                            children: [
                                "Messages",
                                unreadMessagesCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "unread-dot"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `side-tab-pill ${activeTab === 'inquiries' ? 'active' : ''}`,
                        onClick: ()=>handleTabChange('inquiries'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "tab-label-wrap",
                            children: [
                                "Inquiries",
                                unreadInquiriesCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "unread-dot"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: `side-tab-pill ${activeTab === 'checkins' ? 'active' : ''}`,
                        onClick: ()=>handleTabChange('checkins'),
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                            className: "tab-label-wrap",
                            children: [
                                "Check-ins",
                                unreadCheckinsCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "unread-dot"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "side-panel-content-area",
                id: "sidePanelScrollable",
                children: [
                    activeTab === 'messages' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                        children: (isFetching || isMessagesLoading || pageData === undefined) && allConversations.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "side-panel-loading",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                    indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                        spin: true,
                                        style: {
                                            color: '#F59E0B'
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Loading conversations..."
                                })
                            ]
                        }) : displayConversations.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "side-panel-list",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactInfiniteScrollComponentDefault.default), {
                                dataLength: displayConversations.length,
                                next: loadNextPage,
                                hasMore: hasMore,
                                scrollableTarget: "sidePanelScrollable",
                                loader: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "side-panel-loader",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                        indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                            spin: true,
                                            style: {
                                                color: '#F59E0B'
                                            }
                                        })
                                    })
                                }),
                                children: displayConversations.map((convo)=>{
                                    const isSelected = convo.chatId === activeChatId;
                                    const isSupportConvo = convo.isSupport === true || convo.lastMessage.messageType === 'support';
                                    const displayName = convo.client.fullName;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: `side-item-card conversation-item ${isSelected ? 'active' : ''}`,
                                        onClick: ()=>navigate(`/onboarding-trainer/dashboard/messages/${convo.chatId}`),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: `item-avatar ${convo.client.profilePicture ? 'has-image' : ''} ${isSupportConvo ? 'is-support-avatar' : ''}`,
                                                style: !isSupportConvo && convo.client.profilePicture ? {
                                                    backgroundImage: `url(${convo.client.profilePicture})`
                                                } : undefined,
                                                children: isSupportConvo ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatSupportHeadsetSvg.ReactComponent), {
                                                    className: "support-headset-icon"
                                                }) : !convo.client.profilePicture && getInitials(displayName)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "item-details",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "item-row-top",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                className: "item-name",
                                                                children: displayName
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "item-time-wrap",
                                                                children: [
                                                                    convo.isUnread && convo.lastMessage?.senderUid !== trainerUid && convo.lastMessage?.sender_uid !== trainerUid && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "unread-dot"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "item-time",
                                                                        children: formatMessageTime(convo.lastMessage.sendTime)
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    (()=>{
                                                        const { specialTag } = (0, _types.getSpecialMessageInfo)(convo.lastMessage);
                                                        if (specialTag) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "item-row-special-tag",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "special-tag-text",
                                                                children: specialTag
                                                            })
                                                        });
                                                        return null;
                                                    })(),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "item-row-preview",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                className: `preview-text ${convo.isUnread && convo.lastMessage?.senderUid !== trainerUid && convo.lastMessage?.sender_uid !== trainerUid ? 'unread' : ''}`,
                                                                children: (0, _types.getSpecialMessageInfo)(convo.lastMessage).previewText
                                                            }),
                                                            convo.isUnread && convo.lastMessage?.senderUid !== trainerUid && convo.lastMessage?.sender_uid !== trainerUid && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                className: "unread-badge",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "status-dot"
                                                                    }),
                                                                    "New"
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, convo.chatId);
                                })
                            })
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "side-panel-empty",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyMessagesSvg.ReactComponent), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: debouncedSearch ? `No conversations for "${debouncedSearch}"` : 'No conversations yet'
                                })
                            ]
                        })
                    }),
                    activeTab === 'inquiries' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "side-panel-inquiries-wrap",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inquiriesList.InquiriesList), {
                            inquiries: filteredInquiries,
                            isLoading: isLoadingInquiries,
                            conversations: displayConversations,
                            activeChatId: activeChatId,
                            activeInquiryId: activeInquiryId
                        })
                    }),
                    activeTab === 'checkins' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "side-panel-checkins-wrap",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkinsList.CheckinsList), {
                            onSelectCheckin: (checkinId)=>navigate(`/onboarding-trainer/dashboard/messages/checkin/${checkinId}`),
                            searchQuery: searchQuery,
                            clientFilter: clientFilter,
                            sortFilter: sortFilter,
                            activeCheckinId: activeCheckinId
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pushDevicesManager.PushDevicesManager), {
                open: pushManagerOpen,
                onClose: ()=>setPushManagerOpen(false)
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Dropdown","cMU6A","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"react-router-dom":"f3cgC","react-infinite-scroll-component":"jrRfZ","src/api/mutations/useGetTrainerMessages":"cLU5d","src/api/mutations/useGetTrainerClients":"18nHc","src/hooks/useChatRealtime":"dvay5","src/hooks/useInquiriesRealtime":"kno3J","src/hooks/useCheckinsRealtime":"dnr1Y","src/config/firebase":"cmjIE","../../types":"61hYx","../InquiriesList":"4hoqW","../../../Checkins/CheckinsList":"86QUQ","src/components/PushDevicesManager/PushDevicesManager":"79wvW","src/services/push/registerPush":"xSUJJ","src/store/sessionStore":"kPSO3","src/assets/images/onboarding-trainer/dashboard/clients/search.svg":"1z49p","src/assets/images/onboarding-trainer/dashboard/clients/filter.svg":"3x6cI","src/assets/images/onboarding-trainer/dashboard/messages/empty-messages.svg":"03Ka2","src/assets/images/onboarding-trainer/dashboard/messages/clear-search.svg":"5DJV6","src/assets/images/onboarding-trainer/dashboard/messages/chat-support-headset.svg":"lkX2A","src/assets/images/onboarding-trainer/dashboard/messages/notifications/bell-enabled.svg":"jPOWW","src/assets/images/onboarding-trainer/dashboard/messages/notifications/bell-disabled.svg":"237Mp","./MessagesSidePanel.scss":"9gl8X","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cLU5d":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchTrainerMessages", ()=>fetchTrainerMessages);
// We don't use useInfiniteQuery here because we want manual control to merge with Firestore realtime updates
parcelHelpers.export(exports, "useGetTrainerMessagesPage", ()=>useGetTrainerMessagesPage);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _deepCamelCaseKeys = require("src/utils/deepCamelCaseKeys");
var _sessionStore = require("src/store/sessionStore");
var _firebase = require("src/config/firebase");
const fetchTrainerMessages = async (params)=>{
    const token = await (0, _firebase.auth).currentUser?.getIdToken();
    if (!token) throw new Error('Not authenticated');
    const queryParams = new URLSearchParams();
    if (params.search) queryParams.append('search', params.search);
    if (params.clientId && params.clientId !== 'all') queryParams.append('clientId', params.clientId);
    if (params.sort) queryParams.append('sort', params.sort);
    if (params.limit !== undefined) queryParams.append('limit', params.limit.toString());
    if (params.cursor) queryParams.append('cursor', params.cursor);
    if (params.paginated !== undefined) queryParams.append('paginated', params.paginated.toString());
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_MESSAGES}?${queryParams.toString()}`;
    const response = await fetch(apiUrl, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    if (!response.ok) {
        const err = await response.json().catch(()=>({}));
        throw new Error(err.error?.message || `Failed to fetch trainer messages: ${response.status}`);
    }
    const res = await response.json();
    const parsedData = (0, _deepCamelCaseKeys.deepCamelCaseKeys)(res);
    return parsedData;
};
function useGetTrainerMessagesPage(params, enabled = true) {
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const trainerId = currentUser?.uid;
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'trainer-messages',
            trainerId,
            params
        ],
        queryFn: ()=>fetchTrainerMessages(params),
        enabled: !!trainerId && enabled,
        staleTime: 0
    });
}

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","src/utils/deepCamelCaseKeys":"9w8Oj","src/store/sessionStore":"kPSO3","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"61hYx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CHECKIN_PROGRESS", ()=>CHECKIN_PROGRESS);
parcelHelpers.export(exports, "parseFirestoreDate", ()=>parseFirestoreDate);
/**
 * Generates a stable private chat document ID by sorting the two UIDs lexicographically.
 */ parcelHelpers.export(exports, "generatePrivateChatId", ()=>generatePrivateChatId);
parcelHelpers.export(exports, "getSpecialMessageInfo", ()=>getSpecialMessageInfo);
const CHECKIN_PROGRESS = {
    PENDING: '1',
    NEW_TIME_PROPOSED: '2',
    CONFIRMED: '3',
    ATTENDED: '4',
    DECLINED: '5',
    CANCELLED: '6'
};
function parseFirestoreDate(val) {
    if (!val) return new Date();
    if (typeof val === 'object' && val !== null && 'toDate' in val && typeof val.toDate === 'function') return val.toDate();
    if (typeof val === 'object' && val !== null) {
        const sec = val.seconds ?? val._seconds;
        if (typeof sec === 'number') {
            const nsec = val.nanoseconds ?? val._nanoseconds ?? 0;
            return new Date(sec * 1000 + Math.floor(nsec / 1000000));
        }
    }
    if (typeof val === 'string' || typeof val === 'number') {
        const d = new Date(val);
        return isNaN(d.getTime()) ? new Date() : d;
    }
    return new Date();
}
function generatePrivateChatId(uid1, uid2) {
    const uids = [
        uid1,
        uid2
    ].sort();
    return `${uids[0]}_${uids[1]}`;
}
function getSpecialMessageInfo(lastMsg) {
    if (!lastMsg) return {
        specialTag: null,
        previewText: 'No messages yet'
    };
    const rawBody = (lastMsg.body || '').trim();
    const rawType = (lastMsg.messageType || '').trim().toLowerCase();
    // Check if body is enclosed in brackets e.g. "[FREE_CALL_INVITATION]"
    let bracketedType = '';
    const bracketMatch = rawBody.match(/^\[([A-Za-z0-9_-]+)\]$/);
    if (bracketMatch) bracketedType = bracketMatch[1].toLowerCase();
    // Determine effective message type
    let effectiveType = rawType;
    if (!effectiveType || effectiveType === 'text') {
        if (bracketedType) effectiveType = bracketedType;
    }
    // Determine special tag
    let specialTag = null;
    if (effectiveType === 'package_request') specialTag = 'Package request';
    else if (effectiveType === 'package_offer') specialTag = 'Package offer';
    else if (effectiveType === 'free_call_invitation' || effectiveType === 'free_call') specialTag = '15-min introductory call';
    else if (effectiveType === 'package_active' || effectiveType === 'package_activated') specialTag = 'Package active';
    // Determine preview text (NEVER contain brackets)
    let previewText = '';
    if (bracketedType) switch(bracketedType){
        case 'free_call_invitation':
        case 'free_call':
            previewText = '15-min introductory call invitation';
            break;
        case 'package_request':
            previewText = 'Package request';
            break;
        case 'package_offer':
            previewText = 'Package offer';
            break;
        case 'package_active':
        case 'package_activated':
            previewText = 'Package active';
            break;
        case 'image':
            previewText = 'Photo';
            break;
        case 'video':
            previewText = 'Video';
            break;
        case 'audio':
        case 'voice':
            previewText = 'Voice message';
            break;
        case 'file':
        case 'pdf':
            previewText = 'Document';
            break;
        default:
            previewText = bracketedType.replace(/_/g, ' ');
            break;
    }
    else if (rawBody && (effectiveType === 'text' || effectiveType === 'support')) previewText = rawBody.replace(/^\[+|\]+$/g, '');
    else switch(effectiveType){
        case 'package_request':
            previewText = rawBody || 'Package request';
            break;
        case 'package_offer':
            previewText = 'Package offer';
            break;
        case 'free_call_invitation':
        case 'free_call':
            previewText = '15-min introductory call invitation';
            break;
        case 'package_active':
        case 'package_activated':
            previewText = rawBody || 'Package active';
            break;
        case 'image':
            previewText = 'Photo';
            break;
        case 'video':
            previewText = 'Video';
            break;
        case 'audio':
        case 'voice':
            previewText = 'Voice message';
            break;
        case 'file':
        case 'pdf':
            previewText = lastMsg.file_name || 'Document';
            break;
        default:
            previewText = rawBody.replace(/^\[+|\]+$/g, '') || 'Message';
            break;
    }
    // Final sanitization: strip any surrounding brackets from preview text
    if (previewText.startsWith('[') && previewText.endsWith(']')) previewText = previewText.slice(1, -1).trim();
    return {
        specialTag,
        previewText
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4hoqW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InquiriesList", ()=>InquiriesList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _types = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/types");
var _emptyInquiriesSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/empty-inquiries.svg");
var _chatSupportHeadsetSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-support-headset.svg");
var _sessionStore = require("src/store/sessionStore");
var _firebase = require("src/config/firebase");
const InquiriesList = ({ inquiries, isLoading, conversations, activeChatId: _activeChatId, activeInquiryId })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const currentUser = (0, _sessionStore.sessionStore)((s)=>s.currentUser);
    const trainerUid = currentUser?.uid || (0, _firebase.auth).currentUser?.uid || '';
    const getClientDetails = (chatId)=>{
        return conversations.find((c)=>c.chatId === chatId)?.client;
    };
    const getInitials = (name)=>{
        if (!name) return '';
        return name.split(' ').map((n)=>n[0]).join('').toUpperCase();
    };
    const formatInquiryTime = (timestamp)=>{
        if (!timestamp) return '';
        const date = (0, _types.parseFirestoreDate)(timestamp);
        if (isNaN(date.getTime())) return '';
        const now = new Date();
        const isToday = date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);
        const isYesterday = date.getDate() === yesterday.getDate() && date.getMonth() === yesterday.getMonth() && date.getFullYear() === yesterday.getFullYear();
        const timeStr = date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        if (isToday) return `Sent at ${timeStr}`;
        if (isYesterday) return 'Yesterday';
        return date.toLocaleDateString([], {
            month: 'short',
            day: 'numeric',
            year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
        });
    };
    const getAttachmentSummary = (message)=>{
        const attachments = message.attachments || [];
        const mediaUrl = message.media_url;
        if (attachments.length === 0 && !mediaUrl) return 'no attachment';
        if (attachments.length > 0) {
            const videoCount = attachments.filter((a)=>a.type === 'video' || a.mime_type?.startsWith('video/') || /\.(mp4|mov|avi|webm|mkv)$/i.test(a.file_name || a.url || '')).length;
            const imageCount = attachments.filter((a)=>a.type === 'image' || a.mime_type?.startsWith('image/') || /\.(jpe?g|png|webp|gif|avif|heic|heif|svg)$/i.test(a.file_name || a.url || '')).length;
            if (videoCount > 0 && imageCount === 0 && videoCount === attachments.length) return `${videoCount} video${videoCount > 1 ? 's' : ''} attached`;
            if (imageCount > 0 && videoCount === 0 && imageCount === attachments.length) return `${imageCount} photo${imageCount > 1 ? 's' : ''} attached`;
            const total = attachments.length;
            return `${total} attachment${total > 1 ? 's' : ''}`;
        }
        if (mediaUrl) {
            const isVideo = message.message_type === 'video' || /\.(mp4|mov|avi|webm|mkv)$/i.test(message.file_name || mediaUrl);
            if (isVideo) return '1 video attached';
            const isImage = message.message_type === 'image' || /\.(jpe?g|png|webp|gif|avif|heic|heif|svg)$/i.test(message.file_name || mediaUrl);
            if (isImage) return '1 photo attached';
            return '1 attachment';
        }
        return 'no attachment';
    };
    const renderStatusBadge = (message, isSupport)=>{
        if (message.isResolve === true || message.status === 'resolved') return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "inquiry-status-pill status-resolved",
            children: "Resolved"
        });
        if (message.status === 'reopened') return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "inquiry-status-pill status-reopened",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "status-dot"
                }),
                "Reopened"
            ]
        });
        if (message.status === 'replied') return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "inquiry-status-pill status-replied",
            children: "Replied"
        });
        const isSentByMe = message.sender_role === 'trainer' || message.sender_uid === trainerUid || message.send_uid === trainerUid;
        if (!isSentByMe && (!message.is_read || message.status === 'new')) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "inquiry-status-pill status-new",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "status-dot"
                }),
                "New"
            ]
        });
        if (isSupport) return null;
        return null;
    };
    if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "loading-container",
        style: {
            padding: '20px 0',
            minHeight: 'auto',
            textAlign: 'center',
            width: '100%',
            color: '#A0A0A0'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                    className: "loading-icon",
                    spin: true,
                    style: {
                        color: '#E1FF00'
                    }
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    marginTop: '8px'
                },
                children: "Loading inquiries..."
            })
        ]
    });
    if (inquiries.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "dashboard-empty-state",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "empty-icon",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyInquiriesSvg.ReactComponent), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "No open inquiries found"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "You have no pending client inquiries at the moment."
            })
        ]
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "messages-list-container",
        id: "scrollableInquiriesList",
        children: inquiries.map((item)=>{
            const client = getClientDetails(item.chatId);
            const isSupport = Boolean(item.message.is_support || item.chatId.startsWith('support_') || item.message.sender_name === 'miniPT Support' || item.message.receive_name === 'miniPT Support');
            const clientName = isSupport ? 'miniPT Support' : client?.fullName || item.message.sender_name || 'Client';
            const clientAvatar = isSupport ? '' : client?.profilePicture || item.message.sender_avatar || '';
            const categoryLabel = item.message.inquiryType || item.message.topic || item.message.category || item.message.inquiry_category || (isSupport ? 'Billing & Subscription' : 'General');
            const attachmentText = getAttachmentSummary(item.message);
            const lastMessage = isSupport ? (item.message.body && item.message.body !== 'Inquiry sent' ? item.message.body : '') || item.message.message || item.message.subject || 'Support inquiry' : item.message.inquirySubject || item.message.subject || item.message.inquiryDetail || item.message.message || (item.message.body && item.message.body !== 'Inquiry sent' ? item.message.body : '') || item.message.inquiry_text || 'Inquiry sent';
            const isSelected = Boolean(activeInquiryId) && item.message.id === activeInquiryId;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `message-item inquiry-item-card ${isSelected ? 'active' : ''}`,
                onClick: ()=>navigate(`/onboarding-trainer/dashboard/messages/${item.chatId}?tab=inquiries&inquiryId=${item.message.id}`),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `message-avatar ${clientAvatar ? 'has-image' : ''} ${isSupport ? 'is-support-avatar' : ''}`,
                        style: {
                            backgroundImage: clientAvatar ? `url(${clientAvatar})` : 'none'
                        },
                        children: isSupport ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatSupportHeadsetSvg.ReactComponent), {
                            className: "support-headset-icon"
                        }) : !clientAvatar && getInitials(clientName)
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "inquiry-item-content",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "inquiry-item-top-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        className: "inquiry-client-name",
                                        children: clientName
                                    }),
                                    renderStatusBadge(item.message, isSupport)
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "inquiry-sent-time",
                                children: formatInquiryTime(item.message.send_time)
                            }),
                            !isSupport && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "inquiry-item-sub-row",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "inquiry-meta-category-attachment",
                                    style: {
                                        textTransform: 'capitalize'
                                    },
                                    children: [
                                        categoryLabel,
                                        " \xb7 ",
                                        attachmentText
                                    ]
                                })
                            }),
                            Boolean(lastMessage?.trim()) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "inquiry-item-last-message",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: !item.message.is_read && item.message.sender_role !== 'trainer' && item.message.sender_uid !== trainerUid && item.message.send_uid !== trainerUid ? 'unread-text' : '',
                                    children: lastMessage.startsWith('[') && lastMessage.endsWith(']') ? lastMessage.slice(1, -1).replace(/_/g, ' ') : lastMessage
                                })
                            })
                        ]
                    })
                ]
            }, item.message.id);
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/types":"61hYx","src/assets/images/onboarding-trainer/dashboard/messages/empty-inquiries.svg":"kJgVQ","src/assets/images/onboarding-trainer/dashboard/messages/chat-support-headset.svg":"lkX2A","src/store/sessionStore":"kPSO3","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kJgVQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEmptyInquiries);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEmptyInquiries = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 80,
        height: 80,
        fill: "none",
        viewBox: "0 0 80 80",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2.5,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M26 31a6 6 0 0 1 6-6h16a6 6 0 0 1 6 6v10a6 6 0 0 1-6 6H38l-6 6v-6h0a6 6 0 0 1-6-6z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M37.5 33.5a2.5 2.5 0 1 1 5 0c0 1.381-2.5 2.3-2.5 3.7"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                        cx: 40,
                        cy: 41.5,
                        r: 0.75,
                        fill: "#FFBA42",
                        stroke: "none"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 83.625,
                        x2: 21.485,
                        y1: 80.021,
                        y2: -20.52,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 40,
                        x2: 40,
                        y1: 0,
                        y2: 80,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lkX2A":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgChatSupportHeadset);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgChatSupportHeadset = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 30 30",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "currentColor",
            d: "M15 0C6.729 0 0 6.729 0 15v6.215C0 22.75 1.346 24 3 24h1.5A1.5 1.5 0 0 0 6 22.5v-7.714a1.5 1.5 0 0 0-1.5-1.5H3.138C3.972 7.48 8.967 3 15 3s11.028 4.48 11.862 10.286H25.5a1.5 1.5 0 0 0-1.5 1.5V24c0 1.654-1.346 3-3 3h-3v-1.5h-6V30h9c3.309 0 6-2.691 6-6 1.654 0 3-1.25 3-2.785V15c0-8.271-6.729-15-15-15"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"86QUQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckinsList", ()=>CheckinsList);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _checkins = require("src/api/checkins");
var _useGetTrainerClients = require("src/api/mutations/useGetTrainerClients");
var _useCheckinsRealtime = require("src/hooks/useCheckinsRealtime");
var _firebase = require("src/config/firebase");
var _searchSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/search.svg");
var _filterSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/filter.svg");
var _emptyCheckinsSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/empty-checkins.svg");
var _rightArrowSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/notifications/right-arrow.svg");
var _checkinDetailsScss = require("./CheckinDetails.scss");
const CheckinsList = ({ onSelectCheckin, searchQuery: externalSearch, clientFilter: externalClient, sortFilter: externalSort, activeCheckinId })=>{
    const isControlled = externalSearch !== undefined;
    // Search and Filter State
    const [internalSearchQuery, setInternalSearchQuery] = (0, _react.useState)('');
    const [internalClientFilter, setInternalClientFilter] = (0, _react.useState)('all');
    const [internalSortFilter, setInternalSortFilter] = (0, _react.useState)('newest'); // 'newest', 'oldest'
    const activeSearch = isControlled ? externalSearch : internalSearchQuery;
    const activeClient = isControlled ? externalClient || 'all' : internalClientFilter;
    const activeSort = isControlled ? externalSort || 'newest' : internalSortFilter;
    const [debouncedSearch, setDebouncedSearch] = (0, _react.useState)(activeSearch);
    const trainerUid = (0, _firebase.auth).currentUser?.uid || '';
    // 1. Fetch server checkins from Cloud Functions backend via React Query
    const { data: serverCheckinsData, isLoading: isServerLoading } = (0, _checkins.useGetTrainerCheckins)({
        search: debouncedSearch || undefined,
        clientId: activeClient !== 'all' && activeClient !== 'All clients' ? activeClient : undefined,
        sort: activeSort
    }, Boolean(trainerUid));
    // 2. Realtime checkins from flutter_chat_messages/{chatId}/checkins
    const { checkins: realtimeCheckins, isLoading: isRealtimeLoading } = (0, _useCheckinsRealtime.useCheckinsRealtime)(trainerUid);
    // Track check-ins marked as read locally for immediate optimistic UI update
    const [readCheckinIds, setReadCheckinIds] = (0, _react.useState)(new Set());
    // Clients Dropdown Options
    const { data: clientsData } = (0, _useGetTrainerClients.useGetTrainerClients)('all', '', 'name_asc', 1, 1000);
    const clientOptions = (0, _react.useMemo)(()=>{
        const list = clientsData?.clients || [];
        return [
            {
                key: 'all',
                label: 'All clients'
            },
            ...list.map((c)=>({
                    key: c.uid,
                    label: `${c.name} ${c.surname}`
                }))
        ];
    }, [
        clientsData
    ]);
    // Debounce search
    (0, _react.useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedSearch(activeSearch);
        }, 400);
        return ()=>clearTimeout(handler);
    }, [
        activeSearch
    ]);
    const getCheckinTimestamp = (item)=>{
        const val = item.status_updated_at || item.updated_at || item.created_at;
        if (!val) {
            const fallback = item.datetime_utc || item.date || '';
            return new Date(fallback).getTime() || 0;
        }
        if (typeof val.toDate === 'function') return val.toDate().getTime();
        if (typeof val === 'number') return val;
        if (typeof val === 'string') {
            const parsed = new Date(val).getTime();
            return isNaN(parsed) ? 0 : parsed;
        }
        if (val.seconds) return val.seconds * 1000;
        return 0;
    };
    // Derived filtered & sorted check-ins combining backend data + realtime updates
    const displayCheckins = (0, _react.useMemo)(()=>{
        const map = new Map();
        // Seed with server data from Cloud Functions backend
        (serverCheckinsData?.items || []).forEach((c)=>{
            const key = c.message_id || c.id;
            map.set(key, c);
        });
        // Merge realtime updates
        realtimeCheckins.forEach((c)=>{
            if (!c.isAppoint && !c.appointUId) return;
            if (activeClient && activeClient !== 'all' && activeClient !== 'All clients') {
                if (c.client_uid !== activeClient) return;
            }
            if (debouncedSearch) {
                const q = debouncedSearch.toLowerCase();
                const matches = (c.client_name || '').toLowerCase().includes(q) || (c.notes || '').toLowerCase().includes(q) || (c.preference || '').toLowerCase().includes(q);
                if (!matches) return;
            }
            const key = c.message_id || c.id;
            const isLocallyRead = readCheckinIds.has(key) || readCheckinIds.has(c.id);
            map.set(key, {
                ...map.get(key),
                ...c,
                id: key,
                message_id: c.message_id || key,
                is_read: isLocallyRead ? true : c.is_read
            });
        });
        const list = Array.from(map.values());
        // Sort by created / updated date
        list.sort((a, b)=>{
            const timeA = getCheckinTimestamp(a);
            const timeB = getCheckinTimestamp(b);
            return activeSort === 'oldest' ? timeA - timeB : timeB - timeA;
        });
        return list;
    }, [
        serverCheckinsData,
        realtimeCheckins,
        activeClient,
        debouncedSearch,
        activeSort,
        readCheckinIds
    ]);
    const isLoading = (isServerLoading || isRealtimeLoading || serverCheckinsData === undefined) && displayCheckins.length === 0;
    const getClientLabel = ()=>{
        if (activeClient === 'all') return 'All clients';
        const found = clientOptions.find((c)=>c.key === activeClient);
        return found ? found.label : 'All clients';
    };
    const sortItems = [
        {
            key: 'newest',
            label: 'Date (Newest)'
        },
        {
            key: 'oldest',
            label: 'Date (Oldest)'
        }
    ];
    const getSortLabel = ()=>{
        const found = sortItems.find((s)=>s.key === activeSort);
        return found ? found.label : 'Date (Newest)';
    };
    const getInitials = (name)=>{
        if (!name || name === 'Client') return 'GU';
        const trimmed = name.trim();
        if (!trimmed) return 'GU';
        const parts = trimmed.split(/\s+/);
        if (parts.length > 1) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        return trimmed.substring(0, 2).toUpperCase();
    };
    const formatCheckinSentTime = (item)=>{
        const timestamp = getCheckinTimestamp(item);
        if (!timestamp) return '';
        const date = new Date(timestamp);
        const now = new Date();
        const isToday = date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
        const yesterday = new Date(now.getTime() - 86400000);
        const isYesterday = date.getDate() === yesterday.getDate() && date.getMonth() === yesterday.getMonth() && date.getFullYear() === yesterday.getFullYear();
        const timeStr = date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        if (isToday) return `Sent at ${timeStr}`;
        if (isYesterday) return 'Yesterday';
        const dateStr = date.toLocaleDateString([], {
            month: 'short',
            day: 'numeric'
        });
        return dateStr;
    };
    const formatSubtitle = (checkin)=>{
        let dateStr = checkin.date || 'Jul 23, 2026';
        let timeStr = checkin.time || '12:00';
        try {
            const utcString = checkin.suggested_datetime_utc || checkin.datetime_utc;
            if (utcString) {
                const d = new Date(utcString);
                dateStr = d.toLocaleDateString('en-US', {
                    month: 'short',
                    day: '2-digit',
                    year: 'numeric'
                });
                timeStr = d.toLocaleTimeString('en-US', {
                    hour: 'numeric',
                    minute: '2-digit',
                    hour12: true
                });
            } else if (checkin.date) {
                const d = new Date(checkin.date);
                dateStr = d.toLocaleDateString('en-US', {
                    month: 'short',
                    day: '2-digit',
                    year: 'numeric'
                });
            }
        } catch  {
        // fallback
        }
        let prefStr = 'Online via Zoom';
        if (checkin.preference === 'in_person') prefStr = 'In-person';
        if (checkin.preference === 'phone') prefStr = 'Phone call';
        return `${dateStr} \xb7 ${timeStr} \xb7 ${prefStr}`;
    };
    const renderBadge = (item)=>{
        const isNewTime = item.status_badge?.label === 'New Time Proposed' || item.status_badge?.label === 'Client Counter-Proposal' || item.status_badge?.className === 'new_time_proposed' || item.checkinProgress === '2';
        if (item.status_badge) {
            const badgeClass = isNewTime ? 'new_time_proposed' : item.status_badge.className;
            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `status-badge ${badgeClass}`,
                children: [
                    item.status_badge.hasDot && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "status-dot"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: item.status_badge.label
                    })
                ]
            });
        }
        const st = isNewTime ? 'new_time_proposed' : item.status || 'pending_confirmation';
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: `status-badge ${st}`,
            children: [
                isNewTime && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "status-dot"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    children: isNewTime ? 'New Time Proposed' : st
                })
            ]
        });
    };
    // When used inside DashboardMessages (isControlled)
    if (isControlled) {
        if (isLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "loading-container",
            style: {
                padding: '40px 0',
                minHeight: 'auto',
                textAlign: 'center',
                width: '100%',
                color: '#A0A0A0'
            },
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                    indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                        style: {
                            fontSize: 28,
                            color: '#F59E0B'
                        },
                        spin: true
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        marginTop: '12px',
                        fontSize: '14px',
                        color: '#8E95A5'
                    },
                    children: "Loading check-ins..."
                })
            ]
        });
        if (displayCheckins.length === 0) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "dashboard-empty-state",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "empty-icon",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyCheckinsSvg.ReactComponent), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: debouncedSearch ? `No check-ins found for "${debouncedSearch}"` : 'No check-ins found'
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: debouncedSearch ? 'Try a different search term or client filter.' : 'You have no check-in requests at the moment.'
                })
            ]
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "checkins-list-container",
            children: displayCheckins.map((item)=>{
                const targetId = item.message_id || item.id;
                const isSelected = Boolean(activeCheckinId) && (targetId === activeCheckinId || item.id === activeCheckinId);
                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: `checkin-card ${isSelected ? 'active' : ''}`,
                    onClick: ()=>{
                        setReadCheckinIds((prev)=>new Set(prev).add(targetId));
                        onSelectCheckin(targetId);
                    },
                    role: "button",
                    tabIndex: 0,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "card-top",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "badge-container",
                                style: {
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px'
                                },
                                children: [
                                    renderBadge(item),
                                    !item.is_read && !readCheckinIds.has(targetId) && !readCheckinIds.has(item.id) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "unread-indicator",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "unread-dot",
                                                style: {
                                                    backgroundColor: '#F59E0B'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                style: {
                                                    color: '#F59E0B'
                                                },
                                                children: "NEW"
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "card-main",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "user-info",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: `avatar ${item.client_avatar ? 'has-image' : ''}`,
                                            style: item.client_avatar ? {
                                                backgroundImage: `url(${item.client_avatar})`
                                            } : undefined,
                                            children: !item.client_avatar && (item.client_initials && item.client_initials !== 'CL' ? item.client_initials : getInitials(item.client_name))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "name-and-time",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                    children: item.client_name && item.client_name !== 'Client' ? item.client_name : 'Guest'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "sent-time",
                                                    children: item.formatted_sent_time || formatCheckinSentTime(item)
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rightArrowSvg.ReactComponent), {
                                    className: "chevron-icon"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "card-divider"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "card-bottom",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "subtitle",
                                children: item.formatted_subtitle || formatSubtitle(item)
                            })
                        })
                    ]
                }, targetId);
            })
        });
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "checkins-list-wrapper",
        style: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            flex: 1
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "dashboard-filter-bar",
                style: {
                    marginTop: '16px'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "filters-left",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "search-input",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchSvg.ReactComponent), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    type: "text",
                                    placeholder: "Search check-ins",
                                    value: internalSearchQuery,
                                    onChange: (e)=>setInternalSearchQuery(e.target.value),
                                    onBlur: (e)=>setInternalSearchQuery(e.target.value.trim())
                                }),
                                internalSearchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    onClick: ()=>setInternalSearchQuery(''),
                                    className: "clear-search-btn",
                                    "aria-label": "Clear search",
                                    style: {
                                        background: 'transparent',
                                        backgroundColor: 'transparent',
                                        backgroundImage: 'none',
                                        border: 'none',
                                        padding: 0,
                                        margin: 0,
                                        outline: 'none',
                                        appearance: 'none',
                                        WebkitAppearance: 'none',
                                        borderRadius: 0,
                                        boxShadow: 'none',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        color: '#838e9e',
                                        width: 20,
                                        height: 20,
                                        minWidth: 'unset',
                                        minHeight: 'unset',
                                        flexShrink: 0
                                    },
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "currentColor",
                                        strokeWidth: "2",
                                        strokeLinecap: "round",
                                        strokeLinejoin: "round",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "18",
                                                y1: "6",
                                                x2: "6",
                                                y2: "18"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                x1: "6",
                                                y1: "6",
                                                x2: "18",
                                                y2: "18"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "filters-right",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "filter-label",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSvg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Filters:"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                menu: {
                                    items: clientOptions,
                                    onClick: (e)=>setInternalClientFilter(e.key)
                                },
                                trigger: [
                                    'click'
                                ],
                                rootClassName: "dark-theme-dropdown",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "filter-item filter-client",
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            children: [
                                                "Client: ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value",
                                                    children: getClientLabel()
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            width: "12",
                                            height: "12",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                points: "6 9 12 15 18 9"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                menu: {
                                    items: sortItems,
                                    onClick: (e)=>setInternalSortFilter(e.key)
                                },
                                trigger: [
                                    'click'
                                ],
                                rootClassName: "dark-theme-dropdown",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "filter-item filter-sort",
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            children: [
                                                "Sort: ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value",
                                                    children: getSortLabel()
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            width: "12",
                                            height: "12",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                points: "6 9 12 15 18 9"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "loading-container",
                style: {
                    padding: '60px 0',
                    textAlign: 'center',
                    width: '100%',
                    color: '#A0A0A0'
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                        indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                            style: {
                                fontSize: 28,
                                color: '#F59E0B'
                            },
                            spin: true
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            marginTop: '12px',
                            fontSize: '14px',
                            color: '#8E95A5'
                        },
                        children: "Loading check-ins..."
                    })
                ]
            }) : displayCheckins.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "checkins-list-container",
                children: displayCheckins.map((item)=>{
                    const targetId = item.message_id || item.id;
                    const isSelected = Boolean(activeCheckinId) && (targetId === activeCheckinId || item.id === activeCheckinId);
                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `checkin-card ${isSelected ? 'active' : ''}`,
                        onClick: ()=>{
                            setReadCheckinIds((prev)=>new Set(prev).add(targetId));
                            onSelectCheckin(targetId);
                        },
                        role: "button",
                        tabIndex: 0,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "card-top",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "badge-container",
                                    style: {
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px'
                                    },
                                    children: [
                                        renderBadge(item),
                                        !item.is_read && !readCheckinIds.has(targetId) && !readCheckinIds.has(item.id) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "unread-indicator",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "unread-dot",
                                                    style: {
                                                        backgroundColor: '#F59E0B'
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    style: {
                                                        color: '#F59E0B'
                                                    },
                                                    children: "NEW"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-main",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "user-info",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: `avatar ${item.client_avatar ? 'has-image' : ''}`,
                                                style: item.client_avatar ? {
                                                    backgroundImage: `url(${item.client_avatar})`
                                                } : undefined,
                                                children: !item.client_avatar && (item.client_initials && item.client_initials !== 'CL' ? item.client_initials : getInitials(item.client_name))
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "name-and-time",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                        children: item.client_name && item.client_name !== 'Client' ? item.client_name : 'Guest'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "sent-time",
                                                        children: item.formatted_sent_time || formatCheckinSentTime(item)
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _rightArrowSvg.ReactComponent), {
                                        className: "chevron-icon"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "card-divider"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "card-bottom",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "subtitle",
                                    children: item.formatted_subtitle || formatSubtitle(item)
                                })
                            })
                        ]
                    }, targetId);
                })
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "dashboard-empty-state",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "empty-icon",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyCheckinsSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: debouncedSearch ? `No check-ins found for "${debouncedSearch}"` : 'No check-ins found'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: debouncedSearch ? 'Try a different search term or client filter.' : 'You have no check-in requests at the moment.'
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Dropdown","cMU6A","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"src/api/checkins":"NC6YO","src/api/mutations/useGetTrainerClients":"18nHc","src/hooks/useCheckinsRealtime":"dnr1Y","src/config/firebase":"cmjIE","src/assets/images/onboarding-trainer/dashboard/clients/search.svg":"1z49p","src/assets/images/onboarding-trainer/dashboard/clients/filter.svg":"3x6cI","src/assets/images/onboarding-trainer/dashboard/messages/empty-checkins.svg":"fRlYS","src/assets/images/onboarding-trainer/dashboard/messages/notifications/right-arrow.svg":"cg3RS","./CheckinDetails.scss":"diakS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fRlYS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEmptyCheckins);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEmptyCheckins = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 80,
        height: 80,
        fill: "none",
        viewBox: "0 0 80 80",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2.5,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M47 26h4a2 2 0 0 1 2 2v23a2 2 0 0 1-2 2H29a2 2 0 0 1-2-2V28a2 2 0 0 1 2-2h4"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 14,
                        height: 6,
                        x: 33,
                        y: 23,
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "m35 39 3.5 3.5 7-7"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 83.625,
                        x2: 21.485,
                        y1: 80.021,
                        y2: -20.52,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 40,
                        x2: 40,
                        y1: 0,
                        y2: 80,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cg3RS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgRightArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRightArrow = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m9 18 6-6-6-6"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"diakS":[function() {},{}],"79wvW":[function(require,module,exports,__globalThis) {
// Push Devices Manager component for managing browser push subscriptions
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PushDevicesManager", ()=>PushDevicesManager);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _registerPush = require("src/services/push/registerPush");
var _sessionStore = require("src/store/sessionStore");
var _firebase = require("src/config/firebase");
var _pushDevicesManagerScss = require("./PushDevicesManager.scss");
const PushDevicesManager = ({ open, onClose })=>{
    const currentUser = (0, _sessionStore.sessionStore)((state)=>state.currentUser);
    const trainerUid = (0, _firebase.auth).currentUser?.uid || currentUser?.uid || '';
    const [enabled, setEnabled] = (0, _react.useState)(false);
    const [loading, setLoading] = (0, _react.useState)(false);
    const [subscriptions, setSubscriptions] = (0, _react.useState)([]);
    const [currentSubId, setCurrentSubId] = (0, _react.useState)(null);
    const [currentFcmToken, setCurrentFcmToken] = (0, _react.useState)(null);
    const [fetching, setFetching] = (0, _react.useState)(true);
    const [isExpanded, setIsExpanded] = (0, _react.useState)(false);
    const permission = typeof window !== 'undefined' && 'Notification' in window ? Notification.permission : 'unsupported';
    const loadSubscriptions = (0, _react.useCallback)(async ()=>{
        if (!trainerUid) return;
        setFetching(true);
        try {
            const [items, token] = await Promise.all([
                (0, _registerPush.getUserPushSubscriptions)(trainerUid, 'trainer'),
                (0, _registerPush.getCurrentFCMToken)()
            ]);
            setSubscriptions(items);
            setCurrentFcmToken(token);
            const activeSubId = token ? (0, _registerPush.getSubscriptionId)(token) : typeof window !== 'undefined' ? localStorage.getItem('minipt_current_fcm_sub_id') : null;
            setCurrentSubId(activeSubId);
            const isCurrentDeviceRegistered = items.some((sub)=>sub.id === activeSubId || token && sub.fcm_token === token);
            setEnabled(isCurrentDeviceRegistered && permission === 'granted');
        } catch (e) {
            console.warn('Failed to load subscriptions:', e);
        } finally{
            setFetching(false);
        }
    }, [
        trainerUid,
        permission
    ]);
    (0, _react.useEffect)(()=>{
        if (open) loadSubscriptions();
    }, [
        open,
        loadSubscriptions
    ]);
    // Sort subscriptions so "This Device" appears at the top if present
    const sortedSubscriptions = (0, _react.useMemo)(()=>{
        return [
            ...subscriptions
        ].sort((a, b)=>{
            const aIsThis = currentSubId && a.id === currentSubId || currentFcmToken && a.fcm_token === currentFcmToken;
            const bIsThis = currentSubId && b.id === currentSubId || currentFcmToken && b.fcm_token === currentFcmToken;
            if (aIsThis && !bIsThis) return -1;
            if (!aIsThis && bIsThis) return 1;
            return 0;
        });
    }, [
        subscriptions,
        currentSubId,
        currentFcmToken
    ]);
    const handleTogglePush = async (checked)=>{
        if (!trainerUid) return;
        setLoading(true);
        if (checked) {
            const result = await (0, _registerPush.registerBrowserPush)(trainerUid, 'trainer');
            if (result.success) {
                (0, _reactHotToastDefault.default).success('Push notifications enabled for this browser!');
                setEnabled(true);
                if (result.token) {
                    setCurrentFcmToken(result.token);
                    setCurrentSubId(result.subId || (0, _registerPush.getSubscriptionId)(result.token));
                }
                await loadSubscriptions();
            } else if (result.status === 'DENIED') {
                (0, _reactHotToastDefault.default).error('Notification permission was blocked in browser settings.');
                setEnabled(false);
            } else {
                (0, _reactHotToastDefault.default).error(result.error || 'Failed to enable notifications.');
                setEnabled(false);
            }
        } else {
            const success = await (0, _registerPush.unsubscribeBrowserPush)(trainerUid, 'trainer');
            if (success) {
                (0, _reactHotToastDefault.default).success('Push notifications disabled for this browser.');
                setEnabled(false);
                setCurrentFcmToken(null);
                setCurrentSubId(null);
                await loadSubscriptions();
            } else (0, _reactHotToastDefault.default).error('Failed to unsubscribe.');
        }
        setLoading(false);
    };
    const handleRemoveDevice = async (sub, isCurrentDevice)=>{
        if (!trainerUid) return;
        const success = await (0, _registerPush.removePushSubscription)(trainerUid, sub.id, sub.fcm_token, 'trainer');
        if (success) {
            (0, _reactHotToastDefault.default).success(isCurrentDevice ? 'Push notifications disabled for this device.' : 'Device subscription removed.');
            if (isCurrentDevice) {
                setEnabled(false);
                setCurrentFcmToken(null);
                setCurrentSubId(null);
            }
            await loadSubscriptions();
        } else (0, _reactHotToastDefault.default).error('Failed to remove device.');
    };
    const parseUserAgent = (ua)=>{
        if (!ua) return 'Web Browser';
        if (/Chrome/.test(ua) && !/Edg/.test(ua)) return 'Google Chrome';
        if (/Safari/.test(ua) && !/Chrome/.test(ua)) return 'Apple Safari';
        if (/Firefox/.test(ua)) return 'Mozilla Firefox';
        if (/Edg/.test(ua)) return 'Microsoft Edge';
        return 'Web Browser';
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: open,
        onCancel: onClose,
        footer: null,
        centered: true,
        rootClassName: "logout-modal push-devices-modal",
        className: "logout-modal push-devices-modal",
        width: 560,
        styles: {
            mask: {
                backdropFilter: 'blur(4px)',
                backgroundColor: 'rgba(6, 7, 35, 0.8)'
            }
        },
        closeIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "modal-close-circle",
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
        }),
        title: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "push-modal-header",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "header-icon-badge",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.BellOutlined), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "header-text",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "modal-title",
                            children: "Notification Settings"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "modal-subtitle",
                            children: "Manage browser push notifications and registered alert devices."
                        })
                    ]
                })
            ]
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "push-manager-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "push-toggle-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "toggle-left",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "toggle-label",
                                    children: "Browser Push Notifications"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "toggle-desc",
                                    children: "Receive instant desktop & mobile alerts for incoming messages, inquiries, and check-in requests."
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "toggle-right",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Switch), {
                                checked: enabled,
                                onChange: handleTogglePush,
                                loading: loading,
                                disabled: loading,
                                className: "custom-push-switch"
                            })
                        })
                    ]
                }),
                permission !== 'granted' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "permission-row",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "permission-label",
                            children: "Browser Permission:"
                        }),
                        permission === 'denied' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "permission-pill denied",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseCircleFilled), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Blocked in Browser"
                                })
                            ]
                        }),
                        permission === 'default' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "permission-pill default",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.ExclamationCircleFilled), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Not Requested Yet"
                                })
                            ]
                        }),
                        permission === 'unsupported' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "permission-pill unsupported",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: "Not Supported by Browser"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "devices-section",
                    children: fetching ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "loading-state",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                size: "small"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: "Checking registered devices..."
                            })
                        ]
                    }) : subscriptions.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "empty-devices-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "empty-icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.BellOutlined), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "empty-title",
                                children: "No Active Devices"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "empty-desc",
                                children: "Toggle browser notifications on above to register this device for instant alerts."
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "devices-container",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "other-devices-accordion",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "accordion-trigger",
                                    onClick: ()=>setIsExpanded((prev)=>!prev),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "accordion-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "section-title",
                                                    children: "ALL REGISTERED DEVICES"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "count-badge",
                                                    children: subscriptions.length
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "accordion-right",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "toggle-text",
                                                    children: isExpanded ? 'Hide' : 'Show'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.DownOutlined), {
                                                    className: `arrow-icon ${isExpanded ? 'expanded' : ''}`
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                isExpanded && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "accordion-content",
                                    children: sortedSubscriptions.map((sub)=>{
                                        const isThisDevice = Boolean(currentSubId && sub.id === currentSubId || currentFcmToken && sub.fcm_token === currentFcmToken);
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: `device-card ${isThisDevice ? 'this-device-card' : ''}`,
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "device-icon-box",
                                                    children: /Mobile|Android|iPhone/.test(sub.ua) ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.MobileOutlined), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.GlobalOutlined), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "device-details",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "device-header",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "device-name",
                                                                    children: parseUserAgent(sub.ua)
                                                                }),
                                                                isThisDevice && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "this-device-badge",
                                                                    children: "This Device"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "active-badge",
                                                                    children: "Active"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "device-time",
                                                            children: [
                                                                "Registered:",
                                                                ' ',
                                                                sub.created_at ? new Date(sub.created_at).toLocaleDateString() : 'Today'
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    className: "delete-device-btn",
                                                    title: isThisDevice ? 'Remove this device' : 'Remove device',
                                                    onClick: ()=>handleRemoveDevice(sub, isThisDevice),
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.DeleteOutlined), {})
                                                })
                                            ]
                                        }, sub.id);
                                    })
                                })
                            ]
                        })
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "modal-footer-row",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        onClick: onClose,
                        className: "done-btn",
                        children: "Done"
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"],["Spin","lVvhl","default"],["Switch","9ecFZ","default"]],"@ant-design/icons":[["BellOutlined","8ojbJ","default"],["CloseCircleFilled","d3fPr","default"],["CloseOutlined","dinn5","default"],["DeleteOutlined","hgODG","default"],["DownOutlined","dGiFt","default"],["ExclamationCircleFilled","24nhX","default"],["GlobalOutlined","4T2MU","default"],["MobileOutlined","2Hl5i","default"]],"react-hot-toast":"3T0Wh","src/services/push/registerPush":"xSUJJ","src/store/sessionStore":"kPSO3","src/config/firebase":"cmjIE","./PushDevicesManager.scss":"dOYC4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9ecFZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _loadingOutlined = require("@ant-design/icons/es/icons/LoadingOutlined");
var _loadingOutlinedDefault = parcelHelpers.interopDefault(_loadingOutlined);
var _switch = require("@rc-component/switch");
var _switchDefault = parcelHelpers.interopDefault(_switch);
var _util = require("@rc-component/util");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _wave = require("../_util/wave");
var _waveDefault = parcelHelpers.interopDefault(_wave);
var _context = require("../config-provider/context");
var _disabledContext = require("../config-provider/DisabledContext");
var _disabledContextDefault = parcelHelpers.interopDefault(_disabledContext);
var _useSize = require("../config-provider/hooks/useSize");
var _useSizeDefault = parcelHelpers.interopDefault(_useSize);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const InternalSwitch = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, size: customizeSize, disabled: customDisabled, loading, className, rootClassName, style, checked: checkedProp, value, defaultChecked: defaultCheckedProp, defaultValue, onChange, styles, classNames, ...restProps } = props;
    const [checked, setChecked] = (0, _util.useControlledState)(defaultCheckedProp ?? defaultValue ?? false, checkedProp ?? value);
    const { getPrefixCls, direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('switch');
    // ===================== Disabled =====================
    const disabled = _react.useContext((0, _disabledContextDefault.default));
    const mergedDisabled = (customDisabled ?? disabled) || loading;
    const prefixCls = getPrefixCls('switch', customizePrefixCls);
    const loadingIcon = /*#__PURE__*/ _react.createElement("div", {
        className: `${prefixCls}-handle`
    }, loading && /*#__PURE__*/ _react.createElement((0, _loadingOutlinedDefault.default), {
        className: `${prefixCls}-loading-icon`
    }));
    // Style
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    const mergedSize = (0, _useSizeDefault.default)(customizeSize);
    const mergedProps = {
        ...props,
        size: mergedSize,
        disabled: mergedDisabled
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const classes = (0, _clsx.clsx)(contextClassName, {
        [`${prefixCls}-small`]: mergedSize === 'small',
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-rtl`]: direction === 'rtl'
    }, className, rootClassName, mergedClassNames.root, hashId, cssVarCls);
    const mergedStyle = {
        ...mergedStyles.root,
        ...contextStyle,
        ...style
    };
    const changeHandler = (...args)=>{
        setChecked(args[0]);
        onChange?.(...args);
    };
    return /*#__PURE__*/ _react.createElement((0, _waveDefault.default), {
        component: "Switch",
        disabled: mergedDisabled
    }, /*#__PURE__*/ _react.createElement((0, _switchDefault.default), {
        ...restProps,
        classNames: mergedClassNames,
        styles: mergedStyles,
        checked: checked,
        onChange: changeHandler,
        prefixCls: prefixCls,
        className: classes,
        style: mergedStyle,
        disabled: mergedDisabled,
        ref: ref,
        loadingIcon: loadingIcon
    }));
});
const Switch = InternalSwitch;
Switch.__ANT_SWITCH = true;
exports.default = Switch;

},{"react":"bmhQu","@ant-design/icons/es/icons/LoadingOutlined":"8Mvdh","@rc-component/switch":"k1Yh2","@rc-component/util":"6ZBDN","clsx":"431Ou","../_util/hooks":"kdnMA","../_util/wave":"dKIm0","../config-provider/context":"75zwC","../config-provider/DisabledContext":"h4TcW","../config-provider/hooks/useSize":"gXe6G","./style":"dbJH9","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k1Yh2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _clsx = require("clsx");
var _useControlledState = require("@rc-component/util/es/hooks/useControlledState");
var _useControlledStateDefault = parcelHelpers.interopDefault(_useControlledState);
var _keyCode = require("@rc-component/util/es/KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const Switch = /*#__PURE__*/ _react.forwardRef(({ prefixCls = 'rc-switch', className, checked, defaultChecked, disabled, loadingIcon, checkedChildren, unCheckedChildren, onClick, onChange, onKeyDown, styles, classNames: switchClassNames, ...restProps }, ref)=>{
    const [innerChecked, setInnerChecked] = (0, _useControlledStateDefault.default)(defaultChecked ?? false, checked);
    function triggerChange(newChecked, event) {
        let mergedChecked = innerChecked;
        if (!disabled) {
            mergedChecked = newChecked;
            setInnerChecked(mergedChecked);
            onChange?.(mergedChecked, event);
        }
        return mergedChecked;
    }
    function onInternalKeyDown(e) {
        if (e.which === (0, _keyCodeDefault.default).LEFT) triggerChange(false, e);
        else if (e.which === (0, _keyCodeDefault.default).RIGHT) triggerChange(true, e);
        onKeyDown?.(e);
    }
    function onInternalClick(e) {
        const ret = triggerChange(!innerChecked, e);
        // [Legacy] trigger onClick with value
        onClick?.(ret, e);
    }
    const switchClassName = (0, _clsx.clsx)(prefixCls, className, {
        [`${prefixCls}-checked`]: innerChecked,
        [`${prefixCls}-disabled`]: disabled
    });
    return /*#__PURE__*/ _react.createElement("button", _extends({}, restProps, {
        type: "button",
        role: "switch",
        "aria-checked": innerChecked,
        disabled: disabled,
        className: switchClassName,
        ref: ref,
        onKeyDown: onInternalKeyDown,
        onClick: onInternalClick
    }), loadingIcon, /*#__PURE__*/ _react.createElement("span", {
        className: `${prefixCls}-inner`
    }, /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(`${prefixCls}-inner-checked`, switchClassNames?.content),
        style: styles?.content
    }, checkedChildren), /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(`${prefixCls}-inner-unchecked`, switchClassNames?.content),
        style: styles?.content
    }, unCheckedChildren)));
});
Switch.displayName = 'Switch';
exports.default = Switch;

},{"react":"bmhQu","clsx":"431Ou","@rc-component/util/es/hooks/useControlledState":"2FQtD","@rc-component/util/es/KeyCode":"6yRlk","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dbJH9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _cssinjs = require("@ant-design/cssinjs");
var _fastColor = require("@ant-design/fast-color");
var _style = require("../../style");
var _internal = require("../../theme/internal");
const genSwitchSmallStyle = (token)=>{
    const { componentCls, trackHeightSM, trackPadding, trackMinWidthSM, innerMinMarginSM, innerMaxMarginSM, handleSizeSM, calc } = token;
    const switchInnerCls = `${componentCls}-inner`;
    const trackPaddingCalc = (0, _cssinjs.unit)(calc(handleSizeSM).add(calc(trackPadding).mul(2)).equal());
    const innerMaxMarginCalc = (0, _cssinjs.unit)(calc(innerMaxMarginSM).mul(2).equal());
    return {
        [componentCls]: {
            [`&${componentCls}-small`]: {
                minWidth: trackMinWidthSM,
                height: trackHeightSM,
                lineHeight: (0, _cssinjs.unit)(trackHeightSM),
                [`${componentCls}-inner`]: {
                    paddingInlineStart: innerMaxMarginSM,
                    paddingInlineEnd: innerMinMarginSM,
                    [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
                        minHeight: trackHeightSM
                    },
                    [`${switchInnerCls}-checked`]: {
                        marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
                        marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
                    },
                    [`${switchInnerCls}-unchecked`]: {
                        marginTop: calc(trackHeightSM).mul(-1).equal(),
                        marginInlineStart: 0,
                        marginInlineEnd: 0
                    }
                },
                [`${componentCls}-handle`]: {
                    width: handleSizeSM,
                    height: handleSizeSM
                },
                [`${componentCls}-loading-icon`]: {
                    top: calc(calc(handleSizeSM).sub(token.switchLoadingIconSize)).div(2).equal(),
                    fontSize: token.switchLoadingIconSize
                },
                [`&${componentCls}-checked`]: {
                    [`${componentCls}-inner`]: {
                        paddingInlineStart: innerMinMarginSM,
                        paddingInlineEnd: innerMaxMarginSM,
                        [`${switchInnerCls}-checked`]: {
                            marginInlineStart: 0,
                            marginInlineEnd: 0
                        },
                        [`${switchInnerCls}-unchecked`]: {
                            marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
                            marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
                        }
                    },
                    [`${componentCls}-handle`]: {
                        insetInlineStart: `calc(100% - ${(0, _cssinjs.unit)(calc(handleSizeSM).add(trackPadding).equal())})`
                    }
                },
                [`&:not(${componentCls}-disabled):active`]: {
                    [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
                        [`${switchInnerCls}-unchecked`]: {
                            marginInlineStart: calc(token.marginXXS).div(2).equal(),
                            marginInlineEnd: calc(token.marginXXS).mul(-1).div(2).equal()
                        }
                    },
                    [`&${componentCls}-checked ${switchInnerCls}`]: {
                        [`${switchInnerCls}-checked`]: {
                            marginInlineStart: calc(token.marginXXS).mul(-1).div(2).equal(),
                            marginInlineEnd: calc(token.marginXXS).div(2).equal()
                        }
                    }
                }
            }
        }
    };
};
const genSwitchLoadingStyle = (token)=>{
    const { componentCls, handleSize, calc } = token;
    return {
        [componentCls]: {
            [`${componentCls}-loading-icon${token.iconCls}`]: {
                position: 'relative',
                top: calc(calc(handleSize).sub(token.fontSize)).div(2).equal(),
                color: token.switchLoadingIconColor,
                verticalAlign: 'top'
            },
            [`&${componentCls}-checked ${componentCls}-loading-icon`]: {
                color: token.switchColor
            }
        }
    };
};
const genSwitchHandleStyle = (token)=>{
    const { componentCls, trackPadding, handleBg, handleShadow, handleSize, calc } = token;
    const switchHandleCls = `${componentCls}-handle`;
    return {
        [componentCls]: {
            [switchHandleCls]: {
                position: 'absolute',
                top: trackPadding,
                insetInlineStart: trackPadding,
                width: handleSize,
                height: handleSize,
                transition: `all ${token.switchDuration} ease-in-out`,
                '&::before': {
                    position: 'absolute',
                    top: 0,
                    insetInlineEnd: 0,
                    bottom: 0,
                    insetInlineStart: 0,
                    backgroundColor: handleBg,
                    borderRadius: calc(handleSize).div(2).equal(),
                    boxShadow: handleShadow,
                    transition: `all ${token.switchDuration} ease-in-out`,
                    content: '""'
                }
            },
            [`&${componentCls}-checked ${switchHandleCls}`]: {
                insetInlineStart: `calc(100% - ${(0, _cssinjs.unit)(calc(handleSize).add(trackPadding).equal())})`
            },
            [`&:not(${componentCls}-disabled):active`]: {
                [`${switchHandleCls}::before`]: {
                    insetInlineEnd: token.switchHandleActiveInset,
                    insetInlineStart: 0
                },
                [`&${componentCls}-checked ${switchHandleCls}::before`]: {
                    insetInlineEnd: 0,
                    insetInlineStart: token.switchHandleActiveInset
                }
            }
        }
    };
};
const genSwitchInnerStyle = (token)=>{
    const { componentCls, trackHeight, trackPadding, innerMinMargin, innerMaxMargin, handleSize, calc } = token;
    const switchInnerCls = `${componentCls}-inner`;
    const trackPaddingCalc = (0, _cssinjs.unit)(calc(handleSize).add(calc(trackPadding).mul(2)).equal());
    const innerMaxMarginCalc = (0, _cssinjs.unit)(calc(innerMaxMargin).mul(2).equal());
    return {
        [componentCls]: {
            [switchInnerCls]: {
                display: 'block',
                overflow: 'hidden',
                borderRadius: 100,
                height: '100%',
                paddingInlineStart: innerMaxMargin,
                paddingInlineEnd: innerMinMargin,
                transition: `padding-inline-start ${token.switchDuration} ease-in-out, padding-inline-end ${token.switchDuration} ease-in-out`,
                [`${switchInnerCls}-checked, ${switchInnerCls}-unchecked`]: {
                    display: 'block',
                    color: token.colorTextLightSolid,
                    fontSize: token.fontSizeSM,
                    transition: `margin-inline-start ${token.switchDuration} ease-in-out, margin-inline-end ${token.switchDuration} ease-in-out`,
                    pointerEvents: 'none',
                    minHeight: trackHeight
                },
                [`${switchInnerCls}-checked`]: {
                    marginInlineStart: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`,
                    marginInlineEnd: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`
                },
                [`${switchInnerCls}-unchecked`]: {
                    marginTop: calc(trackHeight).mul(-1).equal(),
                    marginInlineStart: 0,
                    marginInlineEnd: 0
                }
            },
            [`&${componentCls}-checked ${switchInnerCls}`]: {
                paddingInlineStart: innerMinMargin,
                paddingInlineEnd: innerMaxMargin,
                [`${switchInnerCls}-checked`]: {
                    marginInlineStart: 0,
                    marginInlineEnd: 0
                },
                [`${switchInnerCls}-unchecked`]: {
                    marginInlineStart: `calc(100% - ${trackPaddingCalc} + ${innerMaxMarginCalc})`,
                    marginInlineEnd: `calc(-100% + ${trackPaddingCalc} - ${innerMaxMarginCalc})`
                }
            },
            [`&:not(${componentCls}-disabled):active`]: {
                [`&:not(${componentCls}-checked) ${switchInnerCls}`]: {
                    [`${switchInnerCls}-unchecked`]: {
                        marginInlineStart: calc(trackPadding).mul(2).equal(),
                        marginInlineEnd: calc(trackPadding).mul(-1).mul(2).equal()
                    }
                },
                [`&${componentCls}-checked ${switchInnerCls}`]: {
                    [`${switchInnerCls}-checked`]: {
                        marginInlineStart: calc(trackPadding).mul(-1).mul(2).equal(),
                        marginInlineEnd: calc(trackPadding).mul(2).equal()
                    }
                }
            }
        }
    };
};
const genSwitchStyle = (token)=>{
    const { componentCls, trackHeight, trackMinWidth } = token;
    return {
        [componentCls]: {
            ...(0, _style.resetComponent)(token),
            position: 'relative',
            display: 'inline-block',
            boxSizing: 'border-box',
            minWidth: trackMinWidth,
            height: trackHeight,
            lineHeight: (0, _cssinjs.unit)(trackHeight),
            verticalAlign: 'middle',
            background: token.colorTextQuaternary,
            border: '0',
            borderRadius: 100,
            cursor: 'pointer',
            transition: `all ${token.motionDurationMid}`,
            userSelect: 'none',
            [`&:hover:not(${componentCls}-disabled)`]: {
                background: token.colorTextTertiary
            },
            ...(0, _style.genFocusStyle)(token),
            [`&${componentCls}-checked`]: {
                background: token.switchColor,
                [`&:hover:not(${componentCls}-disabled)`]: {
                    background: token.colorPrimaryHover
                }
            },
            [`&${componentCls}-loading, &${componentCls}-disabled`]: {
                cursor: 'not-allowed',
                opacity: token.switchDisabledOpacity,
                '*': {
                    boxShadow: 'none',
                    cursor: 'not-allowed'
                }
            },
            // rtl style
            [`&${componentCls}-rtl`]: {
                direction: 'rtl'
            }
        }
    };
};
const prepareComponentToken = (token)=>{
    const { fontSize, lineHeight, controlHeight, colorWhite } = token;
    const height = fontSize * lineHeight;
    const heightSM = controlHeight / 2;
    const padding = 2; // Fixed value
    const handleSize = height - padding * 2;
    const handleSizeSM = heightSM - padding * 2;
    return {
        trackHeight: height,
        trackHeightSM: heightSM,
        trackMinWidth: handleSize * 2 + padding * 4,
        trackMinWidthSM: handleSizeSM * 2 + padding * 2,
        trackPadding: padding,
        // Fixed value
        handleBg: colorWhite,
        handleSize,
        handleSizeSM,
        handleShadow: `0 2px 4px 0 ${new (0, _fastColor.FastColor)('#00230b').setA(0.2).toRgbString()}`,
        innerMinMargin: handleSize / 2,
        innerMaxMargin: handleSize + padding + padding * 2,
        innerMinMarginSM: handleSizeSM / 2,
        innerMaxMarginSM: handleSizeSM + padding + padding * 2
    };
};
exports.default = (0, _internal.genStyleHooks)('Switch', (token)=>{
    const switchToken = (0, _internal.mergeToken)(token, {
        switchDuration: token.motionDurationMid,
        switchColor: token.colorPrimary,
        switchDisabledOpacity: token.opacityLoading,
        switchLoadingIconSize: token.calc(token.fontSizeIcon).mul(0.75).equal(),
        switchLoadingIconColor: `rgba(0, 0, 0, ${token.opacityLoading})`,
        switchHandleActiveInset: '-30%'
    });
    return [
        genSwitchStyle(switchToken),
        // inner style
        genSwitchInnerStyle(switchToken),
        // handle style
        genSwitchHandleStyle(switchToken),
        // loading style
        genSwitchLoadingStyle(switchToken),
        // small style
        genSwitchSmallStyle(switchToken)
    ];
}, prepareComponentToken);

},{"@ant-design/cssinjs":"2VNL8","@ant-design/fast-color":"50VUA","../../style":"4Ezp0","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8ojbJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _bellOutlined = require("@ant-design/icons-svg/es/asn/BellOutlined");
var _bellOutlinedDefault = parcelHelpers.interopDefault(_bellOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const BellOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _bellOutlinedDefault.default)
    }));
/**![bell](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgxNiA3NjhoLTI0VjQyOGMwLTE0MS4xLTEwNC4zLTI1Ny43LTI0MC0yNzcuMVYxMTJjMC0yMi4xLTE3LjktNDAtNDAtNDBzLTQwIDE3LjktNDAgNDB2MzguOWMtMTM1LjcgMTkuNC0yNDAgMTM2LTI0MCAyNzcuMXYzNDBoLTI0Yy0xNy43IDAtMzIgMTQuMy0zMiAzMnYzMmMwIDQuNCAzLjYgOCA4IDhoMjE2YzAgNjEuOCA1MC4yIDExMiAxMTIgMTEyczExMi01MC4yIDExMi0xMTJoMjE2YzQuNCAwIDgtMy42IDgtOHYtMzJjMC0xNy43LTE0LjMtMzItMzItMzJ6TTUxMiA4ODhjLTI2LjUgMC00OC0yMS41LTQ4LTQ4aDk2YzAgMjYuNS0yMS41IDQ4LTQ4IDQ4ek0zMDQgNzY4VjQyOGMwLTU1LjYgMjEuNi0xMDcuOCA2MC45LTE0Ny4xUzQ1Ni40IDIyMCA1MTIgMjIwYzU1LjYgMCAxMDcuOCAyMS42IDE0Ny4xIDYwLjlTNzIwIDM3Mi40IDcyMCA0Mjh2MzQwSDMwNHoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(BellOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/BellOutlined":"8I5Ze","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8I5Ze":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var BellOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z"
                }
            }
        ]
    },
    "name": "bell",
    "theme": "outlined"
};
exports.default = BellOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hgODG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _deleteOutlined = require("@ant-design/icons-svg/es/asn/DeleteOutlined");
var _deleteOutlinedDefault = parcelHelpers.interopDefault(_deleteOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const DeleteOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _deleteOutlinedDefault.default)
    }));
/**![delete](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTM2MCAxODRoLThjNC40IDAgOC0zLjYgOC04djhoMzA0di04YzAgNC40IDMuNiA4IDggOGgtOHY3Mmg3MnYtODBjMC0zNS4zLTI4LjctNjQtNjQtNjRIMzUyYy0zNS4zIDAtNjQgMjguNy02NCA2NHY4MGg3MnYtNzJ6bTUwNCA3MkgxNjBjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjMyYzAgNC40IDMuNiA4IDggOGg2MC40bDI0LjcgNTIzYzEuNiAzNC4xIDI5LjggNjEgNjMuOSA2MWg0NTRjMzQuMiAwIDYyLjMtMjYuOCA2My45LTYxbDI0LjctNTIzSDg4OGM0LjQgMCA4LTMuNiA4LTh2LTMyYzAtMTcuNy0xNC4zLTMyLTMyLTMyek03MzEuMyA4NDBIMjkyLjdsLTI0LjItNTEyaDQ4N2wtMjQuMiA1MTJ6IiAvPjwvc3ZnPg==) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(DeleteOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/DeleteOutlined":"4Hoxx","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Hoxx":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var DeleteOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z"
                }
            }
        ]
    },
    "name": "delete",
    "theme": "outlined"
};
exports.default = DeleteOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4T2MU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _globalOutlined = require("@ant-design/icons-svg/es/asn/GlobalOutlined");
var _globalOutlinedDefault = parcelHelpers.interopDefault(_globalOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const GlobalOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _globalOutlinedDefault.default)
    }));
/**![global](data:image/svg+xml;base64,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) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(GlobalOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/GlobalOutlined":"cfi5G","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cfi5G":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var GlobalOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0010-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 003.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 00-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 01887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 01-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 01115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 01540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 00540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 01-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 00-81.5 55.9A373.86 373.86 0 01137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 01-107.6 69.2z"
                }
            }
        ]
    },
    "name": "global",
    "theme": "outlined"
};
exports.default = GlobalOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Hl5i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _mobileOutlined = require("@ant-design/icons-svg/es/asn/MobileOutlined");
var _mobileOutlinedDefault = parcelHelpers.interopDefault(_mobileOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const MobileOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _mobileOutlinedDefault.default)
    }));
/**![mobile](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTc0NCA2MkgyODBjLTM1LjMgMC02NCAyOC43LTY0IDY0djc2OGMwIDM1LjMgMjguNyA2NCA2NCA2NGg0NjRjMzUuMyAwIDY0LTI4LjcgNjQtNjRWMTI2YzAtMzUuMy0yOC43LTY0LTY0LTY0em0tOCA4MjRIMjg4VjEzNGg0NDh2NzUyek00NzIgNzg0YTQwIDQwIDAgMTA4MCAwIDQwIDQwIDAgMTAtODAgMHoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(MobileOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/MobileOutlined":"lyBv2","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lyBv2":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var MobileOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1080 0 40 40 0 10-80 0z"
                }
            }
        ]
    },
    "name": "mobile",
    "theme": "outlined"
};
exports.default = MobileOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dOYC4":[function() {},{}],"03Ka2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEmptyMessages);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEmptyMessages = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 80,
        height: 80,
        fill: "none",
        viewBox: "0 0 80 80",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#a)",
                d: "M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#b)",
                strokeWidth: 0.5,
                d: "M40 .25C61.953.25 79.75 18.047 79.75 40S61.953 79.75 40 79.75.25 61.953.25 40 18.047.25 40 .25Z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                stroke: "#FFBA42",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2.5,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "m47 45.5 4.5 4.5V35a6 6 0 0 0-6-6h-14a6 6 0 0 0-6 6v9a6 6 0 0 0 6 6h11zM32 36h13m-13 6h8"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 83.625,
                        x2: 21.485,
                        y1: 80.021,
                        y2: -20.52,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#13142B"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#050621"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 40,
                        x2: 40,
                        y1: 0,
                        y2: 80,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFA100"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#996100",
                                stopOpacity: 0.5
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5DJV6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgClearSearch);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgClearSearch = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M18 6 6 18M6 6l12 12"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jPOWW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBellEnabled);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBellEnabled = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9M13.73 21a2 2 0 0 1-3.46 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"237Mp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBellDisabled);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBellDisabled = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M8.66 8.66A6 6 0 0 0 6 8c0 7-3 9-3 9h14.5M10.27 3.32A6 6 0 0 1 18 8c0 2.05-.28 3.86-.77 5.42M13.73 21a2 2 0 0 1-3.46 0M2 2l20 20"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9gl8X":[function() {},{}],"7Cpux":[function() {},{}],"6qzcC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DashboardMessagesIndexRoute", ()=>DashboardMessagesIndexRoute);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _useIsDesktop = require("src/hooks/useIsDesktop");
var _dashboardMessages = require("./DashboardMessages");
var _dashboardMessagesPlaceholder = require("./DashboardMessagesPlaceholder");
const DashboardMessagesIndexRoute = ()=>{
    const isDesktop = (0, _useIsDesktop.useIsDesktop)(768);
    if (isDesktop) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardMessagesPlaceholder.DashboardMessagesPlaceholder), {});
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardMessages.DashboardMessages), {});
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/hooks/useIsDesktop":"dYh53","./DashboardMessages":"kkiAL","./DashboardMessagesPlaceholder":"jhLvo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kkiAL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DashboardMessages", ()=>DashboardMessages);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _reactRouterDom = require("react-router-dom");
var _reactInfiniteScrollComponent = require("react-infinite-scroll-component");
var _reactInfiniteScrollComponentDefault = parcelHelpers.interopDefault(_reactInfiniteScrollComponent);
var _useGetTrainerMessages = require("src/api/mutations/useGetTrainerMessages");
var _useGetTrainerClients = require("src/api/mutations/useGetTrainerClients");
var _useChatRealtime = require("src/hooks/useChatRealtime");
var _useInquiriesRealtime = require("src/hooks/useInquiriesRealtime");
var _useCheckinsRealtime = require("src/hooks/useCheckinsRealtime");
var _firebase = require("src/config/firebase");
var _types = require("./types");
var _inquiriesList = require("./components/InquiriesList");
var _checkinsList = require("../Checkins/CheckinsList");
var _checkinDetails = require("../Checkins/CheckinDetails");
var _pushDevicesManager = require("src/components/PushDevicesManager/PushDevicesManager");
var _registerPush = require("src/services/push/registerPush");
var _sessionStore = require("src/store/sessionStore");
var _searchSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/search.svg");
var _filterSvg = require("src/assets/images/onboarding-trainer/dashboard/clients/filter.svg");
var _emptyMessagesSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/empty-messages.svg");
var _clearSearchSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/clear-search.svg");
var _dropdownChevronSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/dropdown-chevron.svg");
var _bellEnabledSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/notifications/bell-enabled.svg");
var _bellDisabledSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/notifications/bell-disabled.svg");
var _dashboardScreensScss = require("../../DashboardScreens.scss");
var _dashboardMessagesScss = require("./DashboardMessages.scss");
const DashboardMessages = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [searchParams, setSearchParams] = (0, _reactRouterDom.useSearchParams)();
    const currentUser = (0, _sessionStore.sessionStore)((state)=>state.currentUser);
    const trainerUid = (0, _firebase.auth).currentUser?.uid || currentUser?.uid || '';
    const [pushManagerOpen, setPushManagerOpen] = (0, _react.useState)(false);
    const [isPushEnabled, setIsPushEnabled] = (0, _react.useState)(false);
    const [isPushLoading, setIsPushLoading] = (0, _react.useState)(true);
    const isInitialPushCheckRef = (0, _react.useRef)(true);
    // Check push subscription state - only show loading indicator initially
    (0, _react.useEffect)(()=>{
        const unsubscribe = (0, _firebase.auth).onAuthStateChanged(async (user)=>{
            if (!user) {
                setIsPushLoading(false);
                isInitialPushCheckRef.current = false;
                setIsPushEnabled(false);
                return;
            }
            if (isInitialPushCheckRef.current) setIsPushLoading(true);
            try {
                const [subs, token] = await Promise.all([
                    (0, _registerPush.getUserPushSubscriptions)(user.uid, 'trainer'),
                    (0, _registerPush.getCurrentFCMToken)()
                ]);
                const hasPermission = typeof window !== 'undefined' && 'Notification' in window ? Notification.permission === 'granted' : false;
                const storedSubId = typeof window !== 'undefined' ? localStorage.getItem('minipt_current_fcm_sub_id') : null;
                const isThisDeviceRegistered = subs.some((s)=>token && s.fcm_token === token || storedSubId && s.id === storedSubId);
                setIsPushEnabled(isThisDeviceRegistered && hasPermission);
            } catch  {
                setIsPushEnabled(false);
            } finally{
                if (isInitialPushCheckRef.current) {
                    setIsPushLoading(false);
                    isInitialPushCheckRef.current = false;
                }
            }
        });
        return ()=>unsubscribe();
    }, [
        pushManagerOpen
    ]);
    // Filters and state
    const tabFromUrl = searchParams.get('tab');
    const [activeTab, setActiveTab] = (0, _react.useState)(tabFromUrl || 'messages');
    (0, _react.useEffect)(()=>{
        if (tabFromUrl && tabFromUrl !== activeTab) setActiveTab(tabFromUrl);
    }, [
        tabFromUrl,
        activeTab
    ]);
    const initialCheckinId = searchParams.get('checkinId') || null;
    const [selectedCheckinId, setSelectedCheckinId] = (0, _react.useState)(initialCheckinId);
    const [sessionReadCheckinIds, setSessionReadCheckinIds] = (0, _react.useState)(()=>new Set(initialCheckinId ? [
            initialCheckinId
        ] : []));
    const [searchQuery, setSearchQuery] = (0, _react.useState)('');
    const [debouncedSearch, setDebouncedSearch] = (0, _react.useState)('');
    const [clientFilter, setClientFilter] = (0, _react.useState)('all'); // 'all' or client uid
    const [sortFilter, setSortFilter] = (0, _react.useState)('newest'); // 'newest', 'oldest', 'name_asc'
    const [isMobileFilterVisible, setIsMobileFilterVisible] = (0, _react.useState)(false);
    // Pagination & Data state
    const [cursor, setCursor] = (0, _react.useState)(undefined);
    const [allConversations, setAllConversations] = (0, _react.useState)([]);
    const [hasMore, setHasMore] = (0, _react.useState)(true);
    // Fetch options for the client dropdown
    const { data: clientsData } = (0, _useGetTrainerClients.useGetTrainerClients)('all', '', 'name_asc', 1, 1000);
    const clientOptions = (0, _react.useMemo)(()=>{
        const list = clientsData?.clients || [];
        return [
            {
                key: 'all',
                label: 'All Clients'
            },
            ...list.map((c)=>({
                    key: c.uid,
                    label: `${c.name} ${c.surname}`
                }))
        ];
    }, [
        clientsData
    ]);
    const clientInfoMap = (0, _react.useMemo)(()=>{
        const map = {};
        (clientsData?.clients || []).forEach((c)=>{
            const fullName = `${c.name || ''} ${c.surname || ''}`.trim() || c.email || 'Client';
            map[c.uid] = {
                fullName,
                profilePicture: c.avatarUrl || null
            };
        });
        return map;
    }, [
        clientsData
    ]);
    // Realtime updates
    const { realtimeUpdates } = (0, _useChatRealtime.useChatRealtime)();
    const { inquiries, isLoading: isLoadingInquiries } = (0, _useInquiriesRealtime.useInquiriesRealtime)(trainerUid);
    const { checkins: realtimeCheckins } = (0, _useCheckinsRealtime.useCheckinsRealtime)(trainerUid);
    // Ref to reset pagination when filters change
    const prevFiltersRef = (0, _react.useRef)({
        clientFilter,
        sortFilter,
        debouncedSearch
    });
    // To avoid querying when we are manually managing state from a new query
    const [isFetchingPage, setIsFetchingPage] = (0, _react.useState)(false);
    // The actual query
    const { data: pageData, isFetching, isLoading: isMessagesLoading } = (0, _useGetTrainerMessages.useGetTrainerMessagesPage)({
        search: debouncedSearch,
        clientId: clientFilter,
        sort: sortFilter,
        limit: 30,
        cursor
    }, !isFetchingPage);
    (0, _react.useEffect)(()=>{
        const handler = setTimeout(()=>{
            setDebouncedSearch(searchQuery);
        }, 500);
        return ()=>clearTimeout(handler);
    }, [
        searchQuery
    ]);
    // Handle filter changes (Reset pagination)
    (0, _react.useEffect)(()=>{
        const prev = prevFiltersRef.current;
        if (prev.clientFilter !== clientFilter || prev.sortFilter !== sortFilter || prev.debouncedSearch !== debouncedSearch) {
            prevFiltersRef.current = {
                clientFilter,
                sortFilter,
                debouncedSearch
            };
            setAllConversations([]);
            setCursor(undefined);
            setHasMore(true);
            setIsFetchingPage(false);
        }
    }, [
        clientFilter,
        sortFilter,
        debouncedSearch
    ]);
    // Merge newly fetched page data
    (0, _react.useEffect)(()=>{
        if (pageData && !isFetching) {
            setAllConversations((prev)=>{
                const existingIds = new Set(prev.map((c)=>c.chatId));
                const newItems = pageData.items.filter((c)=>!existingIds.has(c.chatId));
                return [
                    ...prev,
                    ...newItems
                ];
            });
            setHasMore(pageData.hasMore);
            setIsFetchingPage(true); // pause automatic query re-runs until we explicitly ask for next page
        }
    }, [
        pageData,
        isFetching
    ]);
    const loadNextPage = ()=>{
        if (pageData?.nextCursor && hasMore) {
            setCursor(pageData.nextCursor);
            setIsFetchingPage(false); // trigger next query
        }
    };
    // Merge Realtime Updates
    // When realtimeUpdates changes, we apply it to our loaded conversations
    const displayConversations = (0, _react.useMemo)(()=>{
        let merged = [
            ...allConversations
        ];
        // For every updated chat in the realtime listener
        Object.values(realtimeUpdates).forEach((updatedChat)=>{
            // If we have a client filter active and this chat isn't for that client, skip
            if (clientFilter !== 'all' && updatedChat.client.uid !== clientFilter) return;
            // Basic text search filter for realtime (if applicable)
            if (debouncedSearch) {
                const term = debouncedSearch.toLowerCase();
                if (!updatedChat.lastMessage.body.toLowerCase().includes(term)) return; // Doesn't match current search
            }
            const idx = merged.findIndex((c)=>c.chatId === updatedChat.chatId);
            if (idx !== -1) // Update existing
            merged[idx] = {
                ...merged[idx],
                ...updatedChat
            };
            else // New conversation arrived, insert it (usually at top if newest, but depends on sort)
            merged.push(updatedChat);
        });
        // Re-sort the merged list to ensure realtime updates push things to the top/bottom properly
        merged.sort((a, b)=>{
            if (sortFilter === 'newest') return new Date(b.lastMessage.sendTime).getTime() - new Date(a.lastMessage.sendTime).getTime();
            else if (sortFilter === 'oldest') return new Date(a.lastMessage.sendTime).getTime() - new Date(b.lastMessage.sendTime).getTime();
            else if (sortFilter === 'name_asc') return (a.client.fullName || '').localeCompare(b.client.fullName || '');
            return 0;
        });
        // Remove duplicates that might occur during rapid realtime insertion
        const seen = new Set();
        merged = merged.filter((c)=>{
            if (seen.has(c.chatId)) return false;
            seen.add(c.chatId);
            return true;
        });
        // Filter out chats for deleted clients (not present in clientInfoMap)
        if (Object.keys(clientInfoMap).length > 0) merged = merged.filter((c)=>!!clientInfoMap[c.client.uid]);
        // Enrich client profiles
        merged = merged.map((c)=>{
            const info = clientInfoMap[c.client.uid];
            if (info) return {
                ...c,
                client: {
                    ...c.client,
                    fullName: info.fullName && info.fullName !== 'Client' ? info.fullName : c.client.fullName !== 'Unknown' && c.client.fullName !== 'Client' ? c.client.fullName : info.fullName || 'Client',
                    profilePicture: info.profilePicture || c.client.profilePicture
                }
            };
            return c;
        });
        // Remove support conversations from normal messages tab
        merged = merged.filter((c)=>!c.isSupport && !c.chatId?.startsWith('support_') && c.client?.fullName !== 'miniPT Support');
        return merged;
    }, [
        allConversations,
        realtimeUpdates,
        clientFilter,
        sortFilter,
        debouncedSearch,
        clientInfoMap
    ]);
    // Computed unread / pending counts
    const unreadMessagesCount = (0, _react.useMemo)(()=>{
        return displayConversations.filter((c)=>{
            const isSentByTrainer = c.lastMessage?.senderUid === trainerUid || c.lastMessage?.sender_uid === trainerUid;
            return c.isUnread && !isSentByTrainer;
        }).length;
    }, [
        displayConversations,
        trainerUid
    ]);
    const unreadInquiriesCount = (0, _react.useMemo)(()=>{
        return inquiries.filter((inq)=>{
            const isSentByTrainer = inq.message?.sender_role === 'trainer' || inq.message?.sender_uid === trainerUid || inq.message?.send_uid === trainerUid;
            return !isSentByTrainer && !inq.message.is_read;
        }).length;
    }, [
        inquiries,
        trainerUid
    ]);
    const unreadCheckinsCount = (0, _react.useMemo)(()=>{
        return realtimeCheckins.filter((c)=>!c.is_read && !sessionReadCheckinIds.has(c.id) && (c.isAppoint || Boolean(c.appointUId))).length;
    }, [
        realtimeCheckins,
        sessionReadCheckinIds
    ]);
    const getClientLabel = ()=>clientOptions.find((i)=>i.key === clientFilter)?.label || 'All Clients';
    const sortItems = [
        {
            key: 'newest',
            label: 'Date (Newest)'
        },
        {
            key: 'oldest',
            label: 'Date (Oldest)'
        },
        {
            key: 'name_asc',
            label: 'Name (A-Z)'
        }
    ];
    const getSortLabel = ()=>sortItems.find((i)=>i.key === sortFilter)?.label || 'Date (Newest)';
    const formatMessageTime = (isoString)=>{
        if (!isoString) return '';
        const date = new Date(isoString);
        if (isNaN(date.getTime())) return '';
        const now = new Date();
        const isToday = date.getDate() === now.getDate() && date.getMonth() === now.getMonth() && date.getFullYear() === now.getFullYear();
        const yesterday = new Date(now);
        yesterday.setDate(now.getDate() - 1);
        const isYesterday = date.getDate() === yesterday.getDate() && date.getMonth() === yesterday.getMonth() && date.getFullYear() === yesterday.getFullYear();
        const timeStr = date.toLocaleTimeString([], {
            hour: '2-digit',
            minute: '2-digit',
            hour12: false
        });
        if (isToday) return `Sent at ${timeStr}`;
        if (isYesterday) return 'Yesterday';
        return date.toLocaleDateString([], {
            month: 'short',
            day: 'numeric',
            year: date.getFullYear() !== now.getFullYear() ? 'numeric' : undefined
        });
    };
    const getInitials = (fullName)=>{
        if (!fullName) return 'U';
        const parts = fullName.trim().split(' ');
        if (parts.length > 1) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        return fullName.substring(0, 2).toUpperCase();
    };
    const handleTabChange = (tab)=>{
        setActiveTab(tab);
        setSelectedCheckinId(null);
        setSearchParams({
            tab
        });
    };
    const handleSelectCheckin = (id)=>{
        setSelectedCheckinId(id);
        if (id) {
            setSessionReadCheckinIds((prev)=>new Set(prev).add(id));
            setSearchParams({
                tab: 'checkins',
                checkinId: id
            });
        } else setSearchParams({
            tab: 'checkins'
        });
    };
    const getSearchPlaceholder = ()=>{
        if (activeTab === 'inquiries') return 'Search inquiries';
        if (activeTab === 'checkins') return 'Search check-ins';
        return 'Search messages';
    };
    const filteredInquiries = (0, _react.useMemo)(()=>{
        return inquiries.filter((inq)=>{
            const isSupport = Boolean(inq.message.is_support) || inq.chatId.startsWith('support_') || inq.message.sender_name === 'miniPT Support';
            const clientUid = inq.chatId.split('_').find((id)=>id !== currentUser?.uid);
            const clientFromConvo = displayConversations.find((c)=>c.chatId === inq.chatId)?.client;
            const clientFromMap = clientUid ? clientInfoMap[clientUid] : undefined;
            const clientFullName = isSupport ? 'miniPT Support' : clientFromConvo?.fullName || clientFromMap?.fullName || inq.message.sender_name || '';
            if (clientFilter && clientFilter !== 'all') {
                if (isSupport) return false;
                if (clientUid !== clientFilter) return false;
            }
            if (debouncedSearch) {
                const q = debouncedSearch.toLowerCase();
                const nameMatch = clientFullName.toLowerCase().includes(q);
                const bodyMatch = (inq.message.body || '').toLowerCase().includes(q) || (inq.message.inquiry_text || '').toLowerCase().includes(q);
                const subjectMatch = (inq.message.inquirySubject || inq.message.subject || '').toLowerCase().includes(q);
                const detailMatch = (inq.message.inquiryDetail || '').toLowerCase().includes(q);
                const typeMatch = (inq.message.inquiryType || inq.message.topic || inq.message.category || inq.message.inquiry_category || '').toLowerCase().includes(q);
                if (!nameMatch && !bodyMatch && !subjectMatch && !detailMatch && !typeMatch) return false;
            }
            return true;
        });
    }, [
        inquiries,
        displayConversations,
        clientInfoMap,
        clientFilter,
        debouncedSearch,
        currentUser?.uid
    ]);
    // If a checkin is selected in Check-ins tab, render the full Details view
    if (activeTab === 'checkins' && selectedCheckinId) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "dashboard-screen messages-screen",
        style: {
            padding: 0,
            overflowY: 'hidden',
            height: '100%',
            flex: 1,
            minHeight: 0
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkinDetails.CheckinDetails), {
            checkinId: selectedCheckinId,
            onBack: ()=>handleSelectCheckin(null)
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "dashboard-screen messages-screen",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "dashboard-top-section desktop-only",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "dashboard-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                children: activeTab === 'checkins' ? 'Check-ins' : 'Messages'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                onClick: ()=>setPushManagerOpen(true),
                                className: `push-settings-btn ${isPushLoading ? 'loading' : isPushEnabled ? 'enabled' : 'disabled'}`,
                                title: isPushLoading ? 'Loading notification settings...' : isPushEnabled ? 'Notification settings: Active' : 'Notification settings: Disabled',
                                children: isPushLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                    style: {
                                        fontSize: 16,
                                        color: '#FFA100'
                                    },
                                    spin: true
                                }) : isPushEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bellEnabledSvg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bellDisabledSvg.ReactComponent), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "dashboard-filter-bar",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "filters-left",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "search-input",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchSvg.ReactComponent), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            placeholder: getSearchPlaceholder(),
                                            value: searchQuery,
                                            onChange: (e)=>setSearchQuery(e.target.value),
                                            onBlur: (e)=>setSearchQuery(e.target.value.trim())
                                        }),
                                        searchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            onClick: ()=>setSearchQuery(''),
                                            className: "clear-search-btn",
                                            "aria-label": "Clear search",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearSearchSvg.ReactComponent), {})
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "filters-right",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "filter-label",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Filters:"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                        menu: {
                                            items: clientOptions,
                                            onClick: (e)=>setClientFilter(e.key)
                                        },
                                        trigger: [
                                            'click'
                                        ],
                                        rootClassName: "dark-theme-dropdown",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "filter-item filter-show",
                                            style: {
                                                cursor: 'pointer'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    children: [
                                                        "Client: ",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: getClientLabel()
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownChevronSvg.ReactComponent), {})
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                        menu: {
                                            items: sortItems,
                                            onClick: (e)=>setSortFilter(e.key)
                                        },
                                        trigger: [
                                            'click'
                                        ],
                                        rootClassName: "dark-theme-dropdown",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "filter-item filter-sort",
                                            style: {
                                                cursor: 'pointer'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    children: [
                                                        "Sort: ",
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "value",
                                                            children: getSortLabel()
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownChevronSvg.ReactComponent), {})
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mobile-only",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "dashboard-top-section",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "dashboard-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                    children: activeTab === 'checkins' ? 'Check-ins' : 'Messages'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    onClick: ()=>setPushManagerOpen(true),
                                    className: `push-settings-btn ${isPushLoading ? 'loading' : isPushEnabled ? 'enabled' : 'disabled'}`,
                                    title: isPushLoading ? 'Loading notification settings...' : isPushEnabled ? 'Notification settings: Active' : 'Notification settings: Disabled',
                                    "aria-label": "Notification settings",
                                    children: isPushLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                        style: {
                                            fontSize: 16,
                                            color: '#FFA100'
                                        },
                                        spin: true
                                    }) : isPushEnabled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bellEnabledSvg.ReactComponent), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _bellDisabledSvg.ReactComponent), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "dashboard-filter-bar",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: `search-filter-row ${isMobileFilterVisible ? 'active' : ''}`,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "search-input",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchSvg.ReactComponent), {}),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    type: "text",
                                                    placeholder: getSearchPlaceholder(),
                                                    value: searchQuery,
                                                    onChange: (e)=>setSearchQuery(e.target.value),
                                                    onBlur: (e)=>setSearchQuery(e.target.value.trim())
                                                }),
                                                searchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    onClick: ()=>setSearchQuery(''),
                                                    className: "clear-search-btn",
                                                    "aria-label": "Clear search",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _clearSearchSvg.ReactComponent), {})
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            className: `mobile-filter-btn ${isMobileFilterVisible ? 'active' : ''}`,
                                            onClick: ()=>setIsMobileFilterVisible(!isMobileFilterVisible),
                                            "aria-label": "Toggle filters",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _filterSvg.ReactComponent), {})
                                        })
                                    ]
                                }),
                                isMobileFilterVisible && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "filter-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                            menu: {
                                                items: clientOptions,
                                                onClick: (e)=>setClientFilter(e.key)
                                            },
                                            trigger: [
                                                'click'
                                            ],
                                            rootClassName: "dark-theme-dropdown",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "filter-item filter-show",
                                                style: {
                                                    cursor: 'pointer'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            "Client: ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "value",
                                                                children: getClientLabel()
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownChevronSvg.ReactComponent), {})
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                            menu: {
                                                items: sortItems,
                                                onClick: (e)=>setSortFilter(e.key)
                                            },
                                            trigger: [
                                                'click'
                                            ],
                                            rootClassName: "dark-theme-dropdown",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "filter-item filter-sort",
                                                style: {
                                                    cursor: 'pointer'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            "Sort: ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "value",
                                                                children: getSortLabel()
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownChevronSvg.ReactComponent), {})
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "tabs-navigation-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "tabs-navigation",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: `tab-btn ${activeTab === 'messages' ? 'active' : ''}`,
                            onClick: ()=>handleTabChange('messages'),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Messages"
                                }),
                                unreadMessagesCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "tab-unread-badge",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "tab-unread-dot"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "count",
                                            children: unreadMessagesCount
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: `tab-btn ${activeTab === 'inquiries' ? 'active' : ''}`,
                            onClick: ()=>handleTabChange('inquiries'),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Inquiries"
                                }),
                                unreadInquiriesCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "tab-unread-badge inquiries",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "tab-unread-dot inquiries"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "count",
                                            children: unreadInquiriesCount
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: `tab-btn ${activeTab === 'checkins' ? 'active' : ''}`,
                            onClick: ()=>handleTabChange('checkins'),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Check-ins"
                                }),
                                unreadCheckinsCount > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                    className: "tab-unread-badge checkins",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "tab-unread-dot checkins"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "count",
                                            children: unreadCheckinsCount
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            activeTab === 'messages' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jsxRuntime.Fragment), {
                children: (isFetching || isMessagesLoading || pageData === undefined) && allConversations.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "loading-container",
                    style: {
                        padding: '40px 0',
                        minHeight: 'auto',
                        textAlign: 'center',
                        width: '100%',
                        color: '#A0A0A0'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                            indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                className: "loading-icon",
                                spin: true,
                                style: {
                                    color: '#F59E0B'
                                }
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                marginTop: '8px'
                            },
                            children: "Loading conversations..."
                        })
                    ]
                }) : displayConversations.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "messages-list-container",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactInfiniteScrollComponentDefault.default), {
                        dataLength: displayConversations.length,
                        next: loadNextPage,
                        hasMore: hasMore,
                        scrollableTarget: "scrollableDashboardMain",
                        loader: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "loading-container",
                            style: {
                                padding: '20px 0',
                                minHeight: 'auto',
                                textAlign: 'center',
                                width: '100%',
                                color: '#A0A0A0'
                            },
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                    className: "loading-icon",
                                    spin: true,
                                    style: {
                                        color: '#F59E0B'
                                    }
                                })
                            })
                        }),
                        children: displayConversations.map((convo)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "message-item",
                                onClick: ()=>navigate(`/onboarding-trainer/dashboard/messages/${convo.chatId}`),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: `message-avatar ${convo.client.profilePicture ? 'has-image' : ''}`,
                                        style: convo.client.profilePicture ? {
                                            backgroundImage: `url(${convo.client.profilePicture})`
                                        } : undefined,
                                        children: !convo.client.profilePicture && getInitials(convo.client.fullName)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "message-content",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "message-header",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "name-and-time",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                children: convo.client.fullName
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "message-time",
                                                                children: formatMessageTime(convo.lastMessage.sendTime)
                                                            })
                                                        ]
                                                    }),
                                                    convo.isUnread && convo.lastMessage?.senderUid !== trainerUid && convo.lastMessage?.sender_uid !== trainerUid && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "unread-indicator",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "unread-dot"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: "New"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            (()=>{
                                                const { specialTag } = (0, _types.getSpecialMessageInfo)(convo.lastMessage);
                                                if (specialTag) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "message-special-tag-row",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "special-tag-text",
                                                        children: specialTag
                                                    })
                                                });
                                                return null;
                                            })(),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "message-preview-row",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: convo.isUnread && convo.lastMessage?.senderUid !== trainerUid && convo.lastMessage?.sender_uid !== trainerUid ? 'unread-text' : '',
                                                    children: (0, _types.getSpecialMessageInfo)(convo.lastMessage).previewText
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }, convo.chatId))
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "dashboard-empty-state",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "empty-icon",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyMessagesSvg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: debouncedSearch ? `No conversations found for "${debouncedSearch}"` : 'No conversations found'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: debouncedSearch ? 'Try a different search term or client filter.' : 'You have no conversations yet.'
                        })
                    ]
                })
            }),
            activeTab === 'inquiries' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inquiriesList.InquiriesList), {
                inquiries: filteredInquiries,
                isLoading: isLoadingInquiries,
                conversations: displayConversations
            }),
            activeTab === 'checkins' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkinsList.CheckinsList), {
                onSelectCheckin: handleSelectCheckin,
                searchQuery: searchQuery,
                clientFilter: clientFilter,
                sortFilter: sortFilter,
                activeCheckinId: selectedCheckinId || undefined
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pushDevicesManager.PushDevicesManager), {
                open: pushManagerOpen,
                onClose: ()=>setPushManagerOpen(false)
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Dropdown","cMU6A","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"react-router-dom":"f3cgC","react-infinite-scroll-component":"jrRfZ","src/api/mutations/useGetTrainerMessages":"cLU5d","src/api/mutations/useGetTrainerClients":"18nHc","src/hooks/useChatRealtime":"dvay5","src/hooks/useInquiriesRealtime":"kno3J","src/hooks/useCheckinsRealtime":"dnr1Y","src/config/firebase":"cmjIE","./types":"61hYx","./components/InquiriesList":"4hoqW","../Checkins/CheckinsList":"86QUQ","../Checkins/CheckinDetails":"fpMC3","src/components/PushDevicesManager/PushDevicesManager":"79wvW","src/services/push/registerPush":"xSUJJ","src/store/sessionStore":"kPSO3","src/assets/images/onboarding-trainer/dashboard/clients/search.svg":"1z49p","src/assets/images/onboarding-trainer/dashboard/clients/filter.svg":"3x6cI","src/assets/images/onboarding-trainer/dashboard/messages/empty-messages.svg":"03Ka2","src/assets/images/onboarding-trainer/dashboard/messages/clear-search.svg":"5DJV6","src/assets/images/onboarding-trainer/dashboard/messages/dropdown-chevron.svg":"Wgjdv","src/assets/images/onboarding-trainer/dashboard/messages/notifications/bell-enabled.svg":"jPOWW","src/assets/images/onboarding-trainer/dashboard/messages/notifications/bell-disabled.svg":"237Mp","../../DashboardScreens.scss":"lYzMQ","./DashboardMessages.scss":"fTetm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fpMC3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeTo24HourTime", ()=>normalizeTo24HourTime);
parcelHelpers.export(exports, "CheckinDetails", ()=>CheckinDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _reactQuery = require("@tanstack/react-query");
var _firestore = require("firebase/firestore");
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
var _checkins = require("src/api/checkins");
var _useCheckinRealtime = require("src/hooks/useCheckinRealtime");
var _useCheckinsRealtime = require("src/hooks/useCheckinsRealtime");
var _useGetTrainerClients = require("src/api/mutations/useGetTrainerClients");
var _button = require("src/components/Button/Button");
var _dashboardModalArchiveSvg = require("src/assets/images/trainer/clients/dashboard-modal-archive.svg");
var _dashboardModalDuplicateSvg = require("src/assets/images/trainer/clients/dashboard-modal-duplicate.svg");
var _checinRequestConfirmSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/checin-request-confirm.svg");
var _checinRequestDeclineSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/checin-request-decline.svg");
var _checinRequestSuggestNewTimeSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/checin-request-suggest-new-time.svg");
var _checkinRequestSentSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/checkin-request-sent.svg");
var _checkInConfirmedDetailsSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-details.svg");
var _checkInConfirmedMeetingAccessSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-meeting-access.svg");
var _checkInConfirmedCopyLinkSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-copy-link.svg");
var _checkInConfirmedOpenZoomSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-open-zoom.svg");
var _checkInConfirmedAiProgressSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-ai-progress.svg");
var _checkInConfirmedPerformanceOverviewSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-performance-overview.svg");
var _checkInConfirmedWorkoutCompletedSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-workout-completed.svg");
var _checkInConfirmedLastActivitySvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-last-activity.svg");
var _checkInConfirmedFormConcernSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-form-concern.svg");
var _checkInConfirmedNextActionsSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-next-actions.svg");
var _checkInConfirmedSendReminderSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-send-reminder.svg");
var _checkInConfirmedRescheduleCheckInSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-reschedule-check-in.svg");
var _checkInCompletedTranscriptionSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-completed-transcription.svg");
var _checkInCompletedActionItemsSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-completed-action-items.svg");
var _chatBackArrowSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/notifications/chat-back-arrow.svg");
var _emptyCheckinsSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/empty-checkins.svg");
var _simpleLineCheckSvg = require("src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/simple-line-check.svg");
var _checkinDetailsScss = require("./CheckinDetails.scss");
const formatTimeWithAmPm = (timeStr)=>{
    if (!timeStr) return '4:00 PM';
    const clean = timeStr.trim();
    const ampmMatch = clean.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?$/i);
    if (!ampmMatch) {
        const parts = clean.split(':');
        if (parts.length < 2) return clean;
        let hour = parseInt(parts[0], 10);
        const min = parts[1].replace(/[^\d]/g, '');
        if (isNaN(hour)) return clean;
        const ampm = hour >= 12 ? 'PM' : 'AM';
        hour = hour % 12 || 12;
        return `${hour}:${min.padStart(2, '0')} ${ampm}`;
    }
    let hour = parseInt(ampmMatch[1], 10);
    const min = ampmMatch[2];
    const ampmStr = ampmMatch[3]?.toUpperCase();
    if (ampmStr) return `${hour % 12 || 12}:${min} ${ampmStr}`;
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;
    return `${hour}:${min} ${ampm}`;
};
const normalizeTo24HourTime = (timeStr)=>{
    if (!timeStr) return '';
    const clean = timeStr.trim();
    const ampmMatch = clean.match(/^(\d{1,2}):(\d{2})(?::\d{2})?\s*(AM|PM)?$/i);
    if (!ampmMatch) {
        if (/^\d{1,2}:\d{2}/.test(clean)) {
            const [h, m] = clean.split(':');
            return `${String(parseInt(h, 10)).padStart(2, '0')}:${m.slice(0, 2)}`;
        }
        return clean;
    }
    let hours = parseInt(ampmMatch[1], 10);
    const minutes = ampmMatch[2];
    const ampm = ampmMatch[3]?.toUpperCase();
    if (ampm === 'PM' && hours < 12) hours += 12;
    else if (ampm === 'AM' && hours === 12) hours = 0;
    return `${String(hours).padStart(2, '0')}:${minutes}`;
};
const CheckinDetails = ({ checkinId, onBack })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const currentTrainerUid = (0, _firebase.auth).currentUser?.uid || (0, _sessionStore.sessionStore).getState().currentUser?.uid || '';
    const { checkins: allTrainerCheckins, checkinDaysMap } = (0, _useCheckinsRealtime.useCheckinsRealtime)(currentTrainerUid);
    const matchedFromList = (0, _react.useMemo)(()=>{
        return allTrainerCheckins.find((c)=>c.id === checkinId || c.message_id === checkinId || c.checkin_id === checkinId);
    }, [
        allTrainerCheckins,
        checkinId
    ]);
    const derivedChatId = matchedFromList?.chat_id || (matchedFromList?.client_uid ? `${currentTrainerUid}_${matchedFromList.client_uid}` : undefined);
    const { checkin, loading } = (0, _useCheckinRealtime.useCheckinRealtime)(checkinId, derivedChatId, currentTrainerUid);
    const clientUid = checkin?.client_uid || checkin?.appointUId || '';
    const { data: clientQueryData } = (0, _useGetTrainerClients.useGetTrainerClientById)(clientUid);
    const matchedClient = clientQueryData?.clients?.[0];
    const { data: flutterUserData } = (0, _reactQuery.useQuery)({
        queryKey: [
            'flutter-client-profile',
            clientUid
        ],
        queryFn: async ()=>{
            if (!clientUid) return null;
            try {
                const uSnap = await (0, _firestore.getDoc)((0, _firestore.doc)((0, _firebase.db), 'flutter_user', clientUid));
                if (uSnap.exists()) return uSnap.data();
            } catch (err) {
                console.warn('Failed to fetch flutter_user:', err);
            }
            return null;
        },
        enabled: !!clientUid,
        staleTime: 300000
    });
    const clientName = checkin?.client_name && checkin.client_name !== 'Client' && checkin.client_name !== 'Guest' ? checkin.client_name : matchedClient ? `${matchedClient.name} ${matchedClient.surname}`.trim() : flutterUserData?.name ? `${flutterUserData.name} ${flutterUserData.surname || ''}`.trim() : checkin?.client_name && checkin.client_name !== 'Client' ? checkin.client_name : 'Guest';
    const clientEmail = checkin?.client_email || matchedClient?.email || flutterUserData?.email || '';
    const clientAvatar = checkin?.client_avatar || matchedClient?.avatarUrl || flutterUserData?.avatar_url || flutterUserData?.avatar || flutterUserData?.profile_picture || null;
    const clientInitials = checkin?.client_initials && checkin.client_initials !== 'CL' && checkin.client_initials.length >= 2 ? checkin.client_initials : (()=>{
        const name = clientName && clientName !== 'Client' ? clientName : 'Guest';
        const parts = name.trim().split(/\s+/);
        if (parts.length > 1) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        return name.slice(0, 2).toUpperCase();
    })();
    const handleClientBannerClick = ()=>{
        if (clientUid) navigate(`/onboarding-trainer/dashboard/clients/${clientUid}`);
    };
    // Local date-time bounds (based on user's local timezone)
    const SCHEDULE_DAYS_AHEAD = 60;
    const now = (0, _react.useMemo)(()=>new Date(), []);
    const today = (0, _react.useMemo)(()=>new Date(now.getFullYear(), now.getMonth(), now.getDate()), [
        now
    ]);
    const maxDate = (0, _react.useMemo)(()=>{
        const d = new Date(today);
        d.setDate(d.getDate() + SCHEDULE_DAYS_AHEAD);
        d.setHours(23, 59, 59, 999);
        return d;
    }, [
        today
    ]);
    const minMonthDate = (0, _react.useMemo)(()=>new Date(today.getFullYear(), today.getMonth(), 1), [
        today
    ]);
    const maxMonthDate = (0, _react.useMemo)(()=>new Date(maxDate.getFullYear(), maxDate.getMonth(), 1), [
        maxDate
    ]);
    const markReadMutation = (0, _checkins.useMarkCheckinReadMutation)();
    // Mark checkin as read when opened by trainer via backend API
    (0, _react.useEffect)(()=>{
        if (!checkinId || !checkin || checkin.is_read) return;
        markReadMutation.mutate({
            checkinId,
            targetDate: checkin.date,
            chatId: checkin.chat_id
        });
    }, [
        checkinId,
        checkin,
        markReadMutation
    ]);
    const [view, setView] = (0, _react.useState)('details');
    const [sendZoomLink, setSendZoomLink] = (0, _react.useState)(true);
    // Always reset scroll to top on view or checkin navigation
    (0, _react.useEffect)(()=>{
        const checkinContainer = document.querySelector('.checkin-details-container');
        if (checkinContainer) checkinContainer.scrollTop = 0;
        const dashboardMain = document.getElementById('scrollableDashboardMain');
        if (dashboardMain) dashboardMain.scrollTop = 0;
        window.scrollTo(0, 0);
    }, [
        view,
        checkinId
    ]);
    // Modal states
    const [isFullTranscriptModalOpen, setIsFullTranscriptModalOpen] = (0, _react.useState)(false);
    const [isDeclineModalOpen, setIsDeclineModalOpen] = (0, _react.useState)(false);
    const [declineReason, setDeclineReason] = (0, _react.useState)('');
    const [declineReasonError, setDeclineReasonError] = (0, _react.useState)('');
    const [isConfirmAlreadySentModalOpen, setIsConfirmAlreadySentModalOpen] = (0, _react.useState)(false);
    const [isSuggestAlreadySentModalOpen, setIsSuggestAlreadySentModalOpen] = (0, _react.useState)(false);
    const [isCompleteModalOpen, setIsCompleteModalOpen] = (0, _react.useState)(false);
    // Complete modal form states
    const [completionAttendance, setCompletionAttendance] = (0, _react.useState)('attended');
    const [completionDuration, setCompletionDuration] = (0, _react.useState)(30);
    const [completionNotes, setCompletionNotes] = (0, _react.useState)('');
    const [newActionItemText, setNewActionItemText] = (0, _react.useState)('');
    const [completionActionItems, setCompletionActionItems] = (0, _react.useState)([]);
    const currentActionItems = (0, _react.useMemo)(()=>{
        return checkin?.action_items || [];
    }, [
        checkin?.action_items
    ]);
    // Action items checkbox state
    const [actionItemsChecked, setActionItemsChecked] = (0, _react.useState)({});
    // Sync action items checked state from checkin
    (0, _react.useEffect)(()=>{
        if (currentActionItems && currentActionItems.length > 0) {
            const checkedMap = {};
            currentActionItems.forEach((item)=>{
                checkedMap[item.id] = item.completed;
            });
            setActionItemsChecked(checkedMap);
        }
    }, [
        currentActionItems
    ]);
    // Suggest time calendar state (defaults to current month and day in local timezone)
    const [currentMonthDate, setCurrentMonthDate] = (0, _react.useState)(()=>new Date(now.getFullYear(), now.getMonth(), 1));
    const [selectedDay, setSelectedDay] = (0, _react.useState)(()=>now.getDate());
    const [selectedTimeSlot, setSelectedTimeSlot] = (0, _react.useState)('09:30');
    // Sync calendar selection to current check-in's date and time when opened or navigated to suggest view
    (0, _react.useEffect)(()=>{
        if (checkin?.date) {
            const parts = checkin.date.split('-');
            if (parts.length === 3) {
                const y = parseInt(parts[0], 10);
                const m = parseInt(parts[1], 10) - 1;
                const d = parseInt(parts[2], 10);
                if (!isNaN(y) && !isNaN(m) && !isNaN(d)) {
                    const checkinDate = new Date(y, m, d);
                    if (checkinDate >= today && checkinDate <= maxDate) {
                        setCurrentMonthDate(new Date(y, m, 1));
                        setSelectedDay(d);
                        const targetTime = normalizeTo24HourTime(checkin.time || checkin.checkinTime);
                        if (targetTime) setSelectedTimeSlot(targetTime);
                    }
                }
            }
        }
    }, [
        checkin?.date,
        checkin?.time,
        checkin?.checkinTime,
        today,
        maxDate,
        view
    ]);
    // Mutations
    const confirmMutation = (0, _checkins.useConfirmCheckinMutation)();
    const completeMutation = (0, _checkins.useCompleteCheckinMutation)();
    const suggestMutation = (0, _checkins.useSuggestCheckinMutation)();
    const declineMutation = (0, _checkins.useDeclineCheckinMutation)();
    const sendReminderMutation = (0, _checkins.useSendCheckinReminderMutation)();
    const updateActionItemsMutation = (0, _checkins.useUpdateCheckinActionItemsMutation)();
    const isZoomCheckin = checkin?.preference === 'online_zoom' || !!checkin?.zoom_link || !!checkin?.meeting_id;
    const { data: zoomStatus, isLoading: isZoomStatusLoading } = (0, _checkins.useZoomMeetingStatusQuery)(checkinId, checkin?.chat_id, isCompleteModalOpen && isZoomCheckin);
    (0, _react.useEffect)(()=>{
        if (zoomStatus?.actual_duration_mins && isCompleteModalOpen) setCompletionDuration(zoomStatus.actual_duration_mins);
    }, [
        zoomStatus?.actual_duration_mins,
        isCompleteModalOpen
    ]);
    const durationOptions = (0, _react.useMemo)(()=>{
        const base = [
            15,
            30,
            45,
            60
        ];
        if (zoomStatus?.actual_duration_mins && !base.includes(zoomStatus.actual_duration_mins)) return [
            ...base,
            zoomStatus.actual_duration_mins
        ].sort((a, b)=>a - b);
        return base;
    }, [
        zoomStatus?.actual_duration_mins
    ]);
    const handleOpenCompleteModal = ()=>{
        setCompletionAttendance('attended');
        setCompletionDuration(checkin?.duration_mins || 30);
        setCompletionNotes('');
        setNewActionItemText('');
        setCompletionActionItems([]);
        setIsCompleteModalOpen(true);
    };
    const handleOpenReschedule = ()=>{
        if (checkin?.date) {
            const parts = checkin.date.split('-');
            if (parts.length === 3) {
                const y = parseInt(parts[0], 10);
                const m = parseInt(parts[1], 10) - 1;
                const d = parseInt(parts[2], 10);
                if (!isNaN(y) && !isNaN(m) && !isNaN(d)) {
                    const checkinDate = new Date(y, m, d);
                    if (checkinDate >= today && checkinDate <= maxDate) {
                        setCurrentMonthDate(new Date(y, m, 1));
                        setSelectedDay(d);
                    }
                }
            }
        }
        const targetTime = normalizeTo24HourTime(checkin?.time || checkin?.checkinTime);
        if (targetTime) setSelectedTimeSlot(targetTime);
        setView('suggest');
    };
    const handleAddActionItem = ()=>{
        const trimmed = newActionItemText.trim();
        if (!trimmed) return;
        setCompletionActionItems((prev)=>[
                ...prev,
                {
                    id: String(Date.now()),
                    text: trimmed,
                    completed: false
                }
            ]);
        setNewActionItemText('');
    };
    const handleRemoveActionItem = (id)=>{
        setCompletionActionItems((prev)=>prev.filter((item)=>item.id !== id));
    };
    const handleCompleteSubmit = async ()=>{
        if (!checkinId) return;
        try {
            await completeMutation.mutateAsync({
                checkinId,
                chatId: checkin?.chat_id,
                attendance: completionAttendance,
                durationMins: completionDuration,
                notes: completionNotes.trim(),
                actionItems: completionActionItems
            });
            setIsCompleteModalOpen(false);
            (0, _reactHotToastDefault.default).success('Check-in marked as completed!');
        } catch (err) {
            const msg = err instanceof Error ? err.message : 'Failed to complete check-in';
            (0, _reactHotToastDefault.default).error(msg);
        }
    };
    const showNotificationSentToast = (0, _react.useCallback)(()=>{
        (0, _antd.notification).open({
            title: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "custom-toast-content checkin-notification-toast-content",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "toast-left",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "toast-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _simpleLineCheckSvg.ReactComponent), {
                                    className: "toast-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "toast-text",
                                    children: "Notification Sent"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "toast-progress-track",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "toast-progress-bar"
                            })
                        })
                    ]
                })
            }),
            placement: 'topRight',
            duration: 4,
            className: 'checkin-notification-toast',
            closeIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {})
        });
    }, []);
    const handleSendReminder = async ()=>{
        if (!checkin?.id) return;
        try {
            await sendReminderMutation.mutateAsync({
                checkinId: checkin.id,
                chatId: checkin.chat_id
            });
            showNotificationSentToast();
        } catch (err) {
            const msg = err instanceof Error ? err.message : 'Failed to send reminder.';
            (0, _reactHotToastDefault.default).error(msg);
        }
    };
    const toggleActionItem = async (itemId)=>{
        const newCompleted = !actionItemsChecked[itemId];
        setActionItemsChecked((prev)=>({
                ...prev,
                [itemId]: newCompleted
            }));
        const updatedList = currentActionItems.map((item)=>item.id === itemId ? {
                ...item,
                completed: newCompleted
            } : item);
        if (checkin?.id) try {
            await updateActionItemsMutation.mutateAsync({
                checkinId: checkin.id,
                chatId: checkin.chat_id,
                actionItems: updatedList
            });
        } catch (e) {
            console.error('Error updating action items:', e);
        }
    };
    // Meeting ID and Passcode pre-computed by backend
    const meetingId = checkin?.meeting_id || '';
    const passcode = checkin?.passcode || '';
    const [isCopiedZoomLink, setIsCopiedZoomLink] = (0, _react.useState)(false);
    const handleCopyZoomLink = ()=>{
        const url = checkin?.zoom_link || '';
        if (!url) return;
        navigator.clipboard.writeText(url);
        setIsCopiedZoomLink(true);
        setTimeout(()=>{
            setIsCopiedZoomLink(false);
        }, 2000);
    };
    // Safe dynamic AI progress summary
    const progressSummary = (0, _react.useMemo)(()=>{
        return checkin?.ai_progress_summary || null;
    }, [
        checkin?.ai_progress_summary
    ]);
    // Highlights and summary fallbacks
    const highlights = (0, _react.useMemo)(()=>{
        return checkin?.transcript_highlights || [];
    }, [
        checkin?.transcript_highlights
    ]);
    const aiSummaryParagraphs = (0, _react.useMemo)(()=>{
        return checkin?.ai_summary || [];
    }, [
        checkin?.ai_summary
    ]);
    const fullTranscriptDialogue = (0, _react.useMemo)(()=>{
        return checkin?.full_transcript || [];
    }, [
        checkin?.full_transcript
    ]);
    // Presentation values pre-computed by backend
    const formattedDate = checkin?.formatted_date || (checkin?.date ? new Date(`${checkin.date}T00:00:00`).toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    }) : '');
    const formattedTime = checkin?.formatted_time || (checkin?.time ? (()=>{
        const [hStr, mStr] = checkin.time.split(':');
        const h = parseInt(hStr, 10);
        const m = mStr || '00';
        if (isNaN(h)) return checkin.time;
        const period = h >= 12 ? 'PM' : 'AM';
        const displayH = h % 12 === 0 ? 12 : h % 12;
        return `${displayH}:${m} ${period}`;
    })() : '');
    const preferenceLabel = checkin?.preference_label || (checkin?.preference === 'in_person' ? 'In-person' : 'Online via Zoom');
    const rawStatus = checkin?.status;
    const checkinProgress = checkin?.checkinProgress;
    const status = rawStatus === 'open' || !rawStatus ? 'pending_confirmation' : rawStatus;
    const isNewTimeProposal = checkinProgress === '2' || checkin?.status_badge?.label === 'New Time Proposed' || checkin?.status_badge?.label === 'Client Counter-Proposal' || checkin?.status_badge?.className === 'new_time_proposed';
    const defaultBadgeInfo = isNewTimeProposal ? {
        label: checkin?.checkinNewSuggest ? 'Client Counter-Proposal' : 'New Time Proposed',
        className: 'new_time_proposed',
        hasDot: true
    } : {
        label: 'Pending confirmation',
        className: 'pending_confirmation',
        hasDot: true
    };
    const statusBadgeInfo = checkin?.status_badge ? {
        ...checkin.status_badge,
        className: isNewTimeProposal ? 'new_time_proposed' : checkin.status_badge.className
    } : defaultBadgeInfo;
    // Check if a suggestion was already sent by the trainer
    const hasAlreadySuggested = Boolean(checkinProgress === '2' || checkin?.checkinNewDate || checkin?.suggested_date || checkin?.status_updated_by && checkin.status_updated_by === (0, _firebase.auth).currentUser?.uid);
    // Handle Confirm Click
    const handleConfirmClick = ()=>{
        if (hasAlreadySuggested) setIsConfirmAlreadySentModalOpen(true);
        else executeConfirm();
    };
    const executeConfirm = async ()=>{
        if (!checkinId) return;
        try {
            await confirmMutation.mutateAsync({
                checkinId,
                chatId: checkin?.chat_id,
                sendZoomLinkOnConfirm: sendZoomLink
            });
            setIsConfirmAlreadySentModalOpen(false);
            (0, _reactHotToastDefault.default).success('Check-in confirmed successfully!');
        } catch (err) {
            const errorMsg = err instanceof Error ? err.message : 'Failed to confirm check-in';
            (0, _reactHotToastDefault.default).error(errorMsg);
        }
    };
    // Month navigation bounds
    const canGoPrev = (0, _react.useMemo)(()=>{
        return currentMonthDate.getFullYear() > minMonthDate.getFullYear() || currentMonthDate.getFullYear() === minMonthDate.getFullYear() && currentMonthDate.getMonth() > minMonthDate.getMonth();
    }, [
        currentMonthDate,
        minMonthDate
    ]);
    const canGoNext = (0, _react.useMemo)(()=>{
        return currentMonthDate.getFullYear() < maxMonthDate.getFullYear() || currentMonthDate.getFullYear() === maxMonthDate.getFullYear() && currentMonthDate.getMonth() < maxMonthDate.getMonth();
    }, [
        currentMonthDate,
        maxMonthDate
    ]);
    // Is the currently selected day today in local time
    const isSelectedDateToday = (0, _react.useMemo)(()=>{
        return currentMonthDate.getFullYear() === now.getFullYear() && currentMonthDate.getMonth() === now.getMonth() && selectedDay === now.getDate();
    }, [
        currentMonthDate,
        selectedDay,
        now
    ]);
    // Map of date string "YYYY-MM-DD" -> Set of booked times "HH:MM" for this trainer
    // Map of date string "YYYY-MM-DD" -> Array of booked slot info
    const bookedSlotsDetailsMap = (0, _react.useMemo)(()=>{
        const map = {};
        (allTrainerCheckins || []).forEach((item)=>{
            // Only count active bookings (ignore declined check-ins)
            if (item.status === 'declined') return;
            const itemDate = item.date;
            const itemTime = normalizeTo24HourTime(item.time || item.checkinTime);
            if (itemDate && itemTime && (item.isAppoint || Boolean(item.appointUId))) {
                if (!map[itemDate]) map[itemDate] = [];
                if (!map[itemDate].some((s)=>s.time === itemTime)) {
                    const formatted = formatTimeWithAmPm(itemTime);
                    const currentNormalized = normalizeTo24HourTime(checkin?.time || checkin?.checkinTime);
                    const isCurrent = item.id === checkinId || item.checkin_id === checkinId || item.message_id === checkinId || checkin?.id && (item.id === checkin.id || item.checkin_id === checkin.id) || checkin?.date === itemDate && currentNormalized === itemTime;
                    const rawClient = item.client_name || (isCurrent ? clientName : undefined);
                    const displayClient = isCurrent ? `${rawClient && rawClient !== 'Client' ? rawClient : 'This Booking'} (This Booking)` : rawClient;
                    map[itemDate].push({
                        time: itemTime,
                        formattedTime: formatted,
                        clientName: displayClient,
                        isCurrentCheckin: isCurrent
                    });
                }
            }
        });
        Object.keys(map).forEach((dateKey)=>{
            map[dateKey].sort((a, b)=>a.time.localeCompare(b.time));
        });
        return map;
    }, [
        allTrainerCheckins,
        checkinId,
        checkin?.id,
        checkin?.date,
        checkin?.time,
        checkin?.checkinTime,
        clientName
    ]);
    // Map of date string "YYYY-MM-DD" -> Set of booked times "HH:MM" for fast lookup
    const bookedSlotsMap = (0, _react.useMemo)(()=>{
        const map = {};
        Object.keys(bookedSlotsDetailsMap).forEach((dateKey)=>{
            map[dateKey] = new Set(bookedSlotsDetailsMap[dateKey].map((s)=>s.time));
        });
        return map;
    }, [
        bookedSlotsDetailsMap
    ]);
    // Selected date formatted as "YYYY-MM-DD"
    const selectedDateStr = (0, _react.useMemo)(()=>{
        const year = currentMonthDate.getFullYear();
        const month = String(currentMonthDate.getMonth() + 1).padStart(2, '0');
        const day = String(selectedDay).padStart(2, '0');
        return `${year}-${month}-${day}`;
    }, [
        currentMonthDate,
        selectedDay
    ]);
    const selectedDayDoc = checkinDaysMap[selectedDateStr];
    const morningSlots = (0, _react.useMemo)(()=>{
        return (selectedDayDoc?.morningList || []).map((s)=>({
                ...s,
                display: formatTimeWithAmPm(s.time),
                value: normalizeTo24HourTime(s.time)
            }));
    }, [
        selectedDayDoc
    ]);
    const daytimeSlots = (0, _react.useMemo)(()=>{
        return (selectedDayDoc?.daytimeList || []).map((s)=>({
                ...s,
                display: formatTimeWithAmPm(s.time),
                value: normalizeTo24HourTime(s.time)
            }));
    }, [
        selectedDayDoc
    ]);
    const eveningSlots = (0, _react.useMemo)(()=>{
        return (selectedDayDoc?.eveningList || []).map((s)=>({
                ...s,
                display: formatTimeWithAmPm(s.time),
                value: normalizeTo24HourTime(s.time)
            }));
    }, [
        selectedDayDoc
    ]);
    const allSelectedDateSlots = (0, _react.useMemo)(()=>{
        return [
            ...morningSlots,
            ...daytimeSlots,
            ...eveningSlots
        ];
    }, [
        morningSlots,
        daytimeSlots,
        eveningSlots
    ]);
    // Check if a specific time slot is already booked for this trainer on the selected date
    const isSlotBooked = (0, _react.useCallback)((slotValue, slotObj)=>{
        if (slotObj?.isAppoint || slotObj?.appointUId) return true;
        const normalizedSlot = normalizeTo24HourTime(slotValue);
        return Boolean(bookedSlotsMap[selectedDateStr]?.has(normalizedSlot));
    }, [
        bookedSlotsMap,
        selectedDateStr
    ]);
    // Check if a specific time slot is the current check-in being viewed
    const isCurrentBookingSlot = (0, _react.useCallback)((slotValue)=>{
        if (!checkin?.date) return false;
        const targetTime = normalizeTo24HourTime(checkin.time || checkin.checkinTime);
        const curSlotTime = normalizeTo24HourTime(slotValue);
        return selectedDateStr === checkin.date && Boolean(curSlotTime) && curSlotTime === targetTime;
    }, [
        checkin?.date,
        checkin?.time,
        checkin?.checkinTime,
        selectedDateStr
    ]);
    // Check if a specific time slot is booked by ANOTHER client on the selected date
    const isSlotBookedByOther = (0, _react.useCallback)((slotValue, slotObj)=>{
        if (isCurrentBookingSlot(slotValue)) return false;
        if (slotObj?.isAppoint || slotObj?.appointUId) return true;
        const normalizedSlot = normalizeTo24HourTime(slotValue);
        return Boolean(bookedSlotsMap[selectedDateStr]?.has(normalizedSlot));
    }, [
        bookedSlotsMap,
        selectedDateStr,
        isCurrentBookingSlot
    ]);
    // Check if a specific time slot is disabled (past, closed, or booked by another client)
    const isSlotDisabled = (0, _react.useCallback)((slotValue, slotObj)=>{
        const selectedDate = new Date(currentMonthDate.getFullYear(), currentMonthDate.getMonth(), selectedDay);
        if (selectedDate < today || selectedDate > maxDate) return true;
        if (slotObj?.status === 'close') return true;
        if (isSlotBookedByOther(slotValue, slotObj)) return true;
        if (isSelectedDateToday) {
            const [hStr, mStr] = slotValue.split(':');
            const h = parseInt(hStr, 10);
            const m = parseInt(mStr || '0', 10);
            const currentHours = now.getHours();
            const currentMinutes = now.getMinutes();
            if (h < currentHours || h === currentHours && m <= currentMinutes) return true;
        }
        return false;
    }, [
        currentMonthDate,
        selectedDay,
        today,
        maxDate,
        isSlotBookedByOther,
        isSelectedDateToday,
        now
    ]);
    // Calendar grid calculations
    const calendarDays = (0, _react.useMemo)(()=>{
        const year = currentMonthDate.getFullYear();
        const month = currentMonthDate.getMonth();
        const firstDayIndex = new Date(year, month, 1).getDay(); // 0 = Sun, 1 = Mon ...
        const daysInMonth = new Date(year, month + 1, 0).getDate();
        const daysInPrevMonth = new Date(year, month, 0).getDate();
        // In Europe/UK/spec calendar starts on Monday (Mo, Tu, We, Th, Fr, Sa, Su)
        const startOffset = (firstDayIndex + 6) % 7;
        const days = [];
        // Preceding month padding
        for(let i = startOffset - 1; i >= 0; i--)days.push({
            day: daysInPrevMonth - i,
            isCurrentMonth: false,
            isDisabled: true,
            hasBookings: false,
            isFullyBooked: false,
            bookedSlots: []
        });
        // Current month days with past, 60-day boundary, generated checkinList presence, and booking checks
        for(let i = 1; i <= daysInMonth; i++){
            const cellDate = new Date(year, month, i);
            const isPast = cellDate < today;
            const isBeyondMax = cellDate > maxDate;
            const cellMonthStr = String(month + 1).padStart(2, '0');
            const cellDayStr = String(i).padStart(2, '0');
            const cellDateStr = `${year}-${cellMonthStr}-${cellDayStr}`;
            const dayDoc = checkinDaysMap[cellDateStr];
            const morning = dayDoc?.morningList || [];
            const daytime = dayDoc?.daytimeList || [];
            const evening = dayDoc?.eveningList || [];
            const allDaySlots = [
                ...morning,
                ...daytime,
                ...evening
            ];
            const hasGeneratedSlots = allDaySlots.length > 0;
            const bookedSlotsForDay = bookedSlotsDetailsMap[cellDateStr] || [];
            const bookedCount = bookedSlotsForDay.length;
            const hasBookings = bookedCount > 0;
            // Count open available future slots on this cell
            const isCellToday = cellDate.getFullYear() === now.getFullYear() && cellDate.getMonth() === now.getMonth() && cellDate.getDate() === now.getDate();
            const currentHours = now.getHours();
            const currentMinutes = now.getMinutes();
            let validOpenSlotsCount = 0;
            allDaySlots.forEach((slot)=>{
                const isAppointed = slot.isAppoint || Boolean(slot.appointUId) || bookedSlotsMap[cellDateStr]?.has(slot.time);
                if (isAppointed) return;
                if (slot.status === 'close') return;
                if (isCellToday) {
                    const [hStr, mStr] = slot.time.split(':');
                    const h = parseInt(hStr, 10);
                    const m = parseInt(mStr || '0', 10);
                    if (h < currentHours || h === currentHours && m <= currentMinutes) return;
                }
                validOpenSlotsCount++;
            });
            const isFullyBooked = hasGeneratedSlots && validOpenSlotsCount === 0;
            const isPastDay = isPast && !isCellToday;
            const isDisabled = isBeyondMax || !hasGeneratedSlots && !isCellToday;
            days.push({
                day: i,
                isCurrentMonth: true,
                isDisabled,
                isPast: isPastDay,
                isCellToday,
                hasGeneratedSlots,
                hasBookings,
                isFullyBooked,
                bookedSlots: bookedSlotsForDay
            });
        }
        // Trailing month padding to ensure a fixed 6-row calendar (42 days total)
        const TOTAL_CALENDAR_CELLS = 42;
        let nextMonthDay = 1;
        while(days.length < TOTAL_CALENDAR_CELLS)days.push({
            day: nextMonthDay++,
            isCurrentMonth: false,
            isDisabled: true,
            hasBookings: false,
            isFullyBooked: false,
            bookedSlots: []
        });
        return days;
    }, [
        currentMonthDate,
        today,
        maxDate,
        checkinDaysMap,
        bookedSlotsDetailsMap,
        bookedSlotsMap,
        now
    ]);
    // 1. Auto-adjust selectedDay when navigating months or when availability loads
    (0, _react.useEffect)(()=>{
        const daysInMonth = new Date(currentMonthDate.getFullYear(), currentMonthDate.getMonth() + 1, 0).getDate();
        let validDay = selectedDay;
        if (validDay > daysInMonth) validDay = daysInMonth;
        if (checkin?.date) {
            const parts = checkin.date.split('-');
            if (parts.length === 3) {
                const checkinYear = parseInt(parts[0], 10);
                const checkinMonth = parseInt(parts[1], 10) - 1;
                const checkinDay = parseInt(parts[2], 10);
                if (currentMonthDate.getFullYear() === checkinYear && currentMonthDate.getMonth() === checkinMonth && selectedDay === checkinDay) {
                    const checkinCell = calendarDays.find((d)=>d.isCurrentMonth && d.day === checkinDay && !d.isDisabled);
                    if (checkinCell) return;
                }
            }
        }
        const currentCell = calendarDays.find((d)=>d.isCurrentMonth && d.day === validDay && !d.isDisabled);
        if (!currentCell) {
            // Find the first enabled day in this month
            const firstEnabled = calendarDays.find((d)=>d.isCurrentMonth && !d.isDisabled);
            if (firstEnabled) setSelectedDay(firstEnabled.day);
        } else if (validDay !== selectedDay) setSelectedDay(validDay);
    }, [
        currentMonthDate,
        calendarDays,
        selectedDay,
        checkin?.date
    ]);
    // 2. Auto-adjust selectedTimeSlot if current slot is past, booked, or not in selected date
    (0, _react.useEffect)(()=>{
        if (allSelectedDateSlots.length === 0) return;
        const currentCheckinTime = normalizeTo24HourTime(checkin?.time || checkin?.checkinTime);
        const isCurrentBookingOnThisDate = Boolean(checkin?.date && currentCheckinTime) && selectedDateStr === checkin?.date;
        const isCurrentSlotValid = Boolean(selectedTimeSlot) && allSelectedDateSlots.some((s)=>normalizeTo24HourTime(s.value) === normalizeTo24HourTime(selectedTimeSlot) && !isSlotDisabled(s.value, s));
        if (!isCurrentSlotValid) {
            if (isCurrentBookingOnThisDate && allSelectedDateSlots.some((s)=>normalizeTo24HourTime(s.value) === currentCheckinTime && !isSlotDisabled(s.value, s))) setSelectedTimeSlot(currentCheckinTime);
            else {
                const firstValidSlot = allSelectedDateSlots.find((s)=>!isSlotDisabled(s.value, s));
                if (firstValidSlot) setSelectedTimeSlot(firstValidSlot.value);
                else setSelectedTimeSlot('');
            }
        }
    }, [
        allSelectedDateSlots,
        selectedTimeSlot,
        isSlotDisabled,
        checkin?.date,
        checkin?.time,
        checkin?.checkinTime,
        selectedDateStr
    ]);
    const monthYearLabel = (0, _react.useMemo)(()=>{
        return currentMonthDate.toLocaleDateString('en-US', {
            month: 'short',
            year: 'numeric'
        });
    }, [
        currentMonthDate
    ]);
    // Validate Suggest Inputs
    const validateSuggestInput = ()=>{
        const chosenDate = new Date(currentMonthDate.getFullYear(), currentMonthDate.getMonth(), selectedDay);
        if (chosenDate < today) {
            (0, _reactHotToastDefault.default).error('Cannot select a past date.');
            return false;
        }
        if (chosenDate > maxDate) {
            (0, _reactHotToastDefault.default).error('Cannot select a date more than 60 days in advance.');
            return false;
        }
        const chosenSlot = allSelectedDateSlots.find((s)=>s.value === selectedTimeSlot);
        if (!chosenSlot) {
            (0, _reactHotToastDefault.default).error('Please select an available time slot.');
            return false;
        }
        if (isSlotBooked(chosenSlot.value, chosenSlot)) {
            (0, _reactHotToastDefault.default).error('Selected time slot is already booked with another client. Please choose an open slot.');
            return false;
        }
        if (isSlotDisabled(chosenSlot.value, chosenSlot)) {
            (0, _reactHotToastDefault.default).error('Selected time slot has already passed or is unavailable. Please pick an upcoming time.');
            return false;
        }
        return true;
    };
    // Handle Suggest Submit
    const handleSuggestSubmit = async ()=>{
        if (!checkinId) return;
        if (!validateSuggestInput()) return;
        if (hasAlreadySuggested) setIsSuggestAlreadySentModalOpen(true);
        else executeSuggest();
    };
    const executeSuggest = async ()=>{
        if (!checkinId) return;
        const year = currentMonthDate.getFullYear();
        const month = String(currentMonthDate.getMonth() + 1).padStart(2, '0');
        const day = String(selectedDay).padStart(2, '0');
        const suggestedDateStr = `${year}-${month}-${day}`;
        const hour = parseInt(selectedTimeSlot.split(':')[0], 10);
        const selectTimeType = hour < 12 ? 'morningList' : hour < 17 ? 'daytimeList' : 'eveningList';
        const checkinType = checkin?.checkinType === 'inPerson' || checkin?.preference === 'in_person' ? 'inPerson' : 'online';
        try {
            await suggestMutation.mutateAsync({
                checkinId,
                chatId: checkin?.chat_id,
                suggestedDate: suggestedDateStr,
                suggestedTime: selectedTimeSlot,
                suggestedSelectTimeType: selectTimeType,
                suggestedType: checkinType,
                timezone: checkin?.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC'
            });
            setIsSuggestAlreadySentModalOpen(false);
            setView('success');
        } catch (err) {
            const errorMsg = err instanceof Error ? err.message : 'Failed to suggest new time';
            (0, _reactHotToastDefault.default).error(errorMsg);
        }
    };
    const validateDeclineReason = (val)=>{
        if (val.length > 200) return 'Message must be 200 characters or less';
        return '';
    };
    const handleCloseDeclineModal = ()=>{
        if (declineMutation.isPending) return;
        setIsDeclineModalOpen(false);
        setDeclineReason('');
        setDeclineReasonError('');
    };
    // Handle Decline Submit
    const handleDeclineSubmit = async ()=>{
        if (!checkinId) return;
        const trimmedReason = declineReason.trim();
        const error = validateDeclineReason(trimmedReason);
        if (error) {
            setDeclineReasonError(error);
            return;
        }
        try {
            await declineMutation.mutateAsync({
                checkinId,
                chatId: checkin?.chat_id,
                reason: trimmedReason || undefined
            });
            handleCloseDeclineModal();
            (0, _reactHotToastDefault.default).success('Check-in declined');
        } catch (err) {
            const errorMsg = err instanceof Error ? err.message : 'Failed to decline check-in';
            (0, _reactHotToastDefault.default).error(errorMsg);
        }
    };
    const renderSuggestAlreadySentModal = ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
            open: isSuggestAlreadySentModalOpen,
            footer: null,
            onCancel: ()=>setIsSuggestAlreadySentModalOpen(false),
            centered: true,
            width: 400,
            closeIcon: null,
            rootClassName: "logout-modal",
            className: "logout-modal",
            styles: {
                mask: {
                    backdropFilter: 'blur(4px)',
                    backgroundColor: 'rgba(6, 7, 35, 0.8)'
                }
            },
            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "logout-modal-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "logout-icon-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardModalDuplicateSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "Send New Suggestion?"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            "You have already sent a time proposal to ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: checkin?.client_name || 'the client'
                            }),
                            ". Do you want to replace it and propose this new date and time (",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                children: `${currentMonthDate.toLocaleDateString('en-US', {
                                    month: 'short'
                                })} ${selectedDay}, ${currentMonthDate.getFullYear()} at ${formatTimeWithAmPm(selectedTimeSlot)}`
                            }),
                            ")?"
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "logout-actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                className: "btn-logout",
                                onClick: executeSuggest,
                                disabled: suggestMutation.isPending,
                                isLoading: suggestMutation.isPending,
                                children: "Send New Suggestion"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                className: "btn-cancel",
                                onClick: ()=>setIsSuggestAlreadySentModalOpen(false),
                                disabled: suggestMutation.isPending,
                                children: "Cancel"
                            })
                        ]
                    })
                ]
            })
        });
    // 1. Success Screen View (Request Sent)
    if (view === 'success') return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "checkin-details-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "success-view-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "success-icon-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkinRequestSentSvg.ReactComponent), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: "Request sent!"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Your client will review your request and confirm the check-in. You'll receive a notification once it's approved."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "btn-back-messages",
                    onClick: onBack,
                    children: "Back to Messages"
                })
            ]
        })
    });
    // 2. Suggest New Time Screen View
    if (view === 'suggest') {
        const isSubmitDisabled = suggestMutation.isPending || !selectedTimeSlot || (()=>{
            const chosen = allSelectedDateSlots.find((s)=>s.value === selectedTimeSlot);
            return chosen ? isSlotDisabled(chosen.value, chosen) : true;
        })();
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "checkin-details-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "details-header",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-left",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "back-btn",
                                onClick: ()=>setView('details'),
                                "aria-label": "Go Back",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatBackArrowSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                children: "Suggest New Time"
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "details-body",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "suggest-time-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "calendar-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "calendar-header",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "month-title",
                                                children: monthYearLabel
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "nav-arrows",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        disabled: !canGoPrev,
                                                        onClick: ()=>{
                                                            if (canGoPrev) setCurrentMonthDate(new Date(currentMonthDate.getFullYear(), currentMonthDate.getMonth() - 1, 1));
                                                        },
                                                        "aria-label": "Previous Month",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LeftOutlined), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        disabled: !canGoNext,
                                                        onClick: ()=>{
                                                            if (canGoNext) setCurrentMonthDate(new Date(currentMonthDate.getFullYear(), currentMonthDate.getMonth() + 1, 1));
                                                        },
                                                        "aria-label": "Next Month",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.RightOutlined), {})
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "weekdays-grid",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Mo"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Tu"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "We"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Th"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Fr"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Sa"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: "Su"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "days-grid",
                                        children: calendarDays.map((item, idx)=>{
                                            const isSelected = item.isCurrentMonth && item.day === selectedDay;
                                            const hasBookings = item.hasBookings && item.bookedSlots && item.bookedSlots.length > 0;
                                            const isTopRows = idx < 14;
                                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "day-cell-wrapper",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                        type: "button",
                                                        disabled: item.isDisabled || !item.isCurrentMonth,
                                                        className: `day-cell ${!item.isCurrentMonth ? 'outside-month' : ''} ${item.isPast ? 'past-day' : ''} ${item.hasBookings ? 'has-bookings' : ''} ${item.isFullyBooked ? 'fully-booked' : ''} ${isSelected ? 'selected' : ''}`,
                                                        onClick: ()=>{
                                                            if (item.isCurrentMonth && !item.isDisabled) setSelectedDay(item.day);
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: item.day
                                                            }),
                                                            item.hasBookings && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "calendar-booking-dot"
                                                            })
                                                        ]
                                                    }),
                                                    hasBookings && item.isCurrentMonth && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: `booked-slots-tooltip ${isTopRows ? 'position-bottom' : ''}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "tooltip-header",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                        className: "tooltip-title",
                                                                        children: [
                                                                            "Booked Times (",
                                                                            item.bookedSlots.length,
                                                                            ")"
                                                                        ]
                                                                    }),
                                                                    item.isFullyBooked && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "tooltip-badge",
                                                                        children: "Full"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "tooltip-slots-list",
                                                                children: item.bookedSlots.map((bSlot, sIdx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "tooltip-slot-item",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "slot-dot"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "slot-time",
                                                                                children: bSlot.formattedTime
                                                                            }),
                                                                            bSlot.clientName && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                className: "slot-client",
                                                                                children: [
                                                                                    "\xb7 ",
                                                                                    bSlot.clientName
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }, sIdx))
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, idx);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "time-slots-section",
                                children: allSelectedDateSlots.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "empty-slots-message",
                                    style: {
                                        padding: '20px',
                                        textAlign: 'center',
                                        background: '#111422',
                                        borderRadius: '12px',
                                        border: '1px solid rgba(255, 255, 255, 0.06)',
                                        color: '#8e95a5',
                                        fontSize: '14px'
                                    },
                                    children: "No available time slots configured for this date."
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        morningSlots.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "slot-group",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    children: "Morning"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "chips-grid",
                                                    children: morningSlots.map((slot)=>{
                                                        const isCurrent = isCurrentBookingSlot(slot.value);
                                                        const disabled = isSlotDisabled(slot.value, slot);
                                                        const booked = isSlotBookedByOther(slot.value, slot);
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                            type: "button",
                                                            disabled: disabled,
                                                            className: `time-chip ${disabled ? 'disabled' : ''} ${booked ? 'booked' : ''} ${isCurrent ? 'current-booking' : ''} ${selectedTimeSlot === slot.value && !disabled ? 'selected' : ''}`,
                                                            onClick: ()=>{
                                                                if (!disabled) setSelectedTimeSlot(slot.value);
                                                            },
                                                            title: isCurrent ? 'Current booking time (This Booking)' : booked ? slot.clientName || 'Already booked with another client' : undefined,
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: slot.display
                                                                }),
                                                                isCurrent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "booked-tag current-tag",
                                                                    children: "This Booking"
                                                                }) : booked ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "booked-tag",
                                                                    children: "Booked"
                                                                }) : null
                                                            ]
                                                        }, slot.value);
                                                    })
                                                })
                                            ]
                                        }),
                                        daytimeSlots.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "slot-group",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    children: "Daytime"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "chips-grid",
                                                    children: daytimeSlots.map((slot)=>{
                                                        const isCurrent = isCurrentBookingSlot(slot.value);
                                                        const disabled = isSlotDisabled(slot.value, slot);
                                                        const booked = isSlotBookedByOther(slot.value, slot);
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                            type: "button",
                                                            disabled: disabled,
                                                            className: `time-chip ${disabled ? 'disabled' : ''} ${booked ? 'booked' : ''} ${isCurrent ? 'current-booking' : ''} ${selectedTimeSlot === slot.value && !disabled ? 'selected' : ''}`,
                                                            onClick: ()=>{
                                                                if (!disabled) setSelectedTimeSlot(slot.value);
                                                            },
                                                            title: isCurrent ? 'Current booking time (This Booking)' : booked ? slot.clientName || 'Already booked with another client' : undefined,
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: slot.display
                                                                }),
                                                                isCurrent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "booked-tag current-tag",
                                                                    children: "This Booking"
                                                                }) : booked ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "booked-tag",
                                                                    children: "Booked"
                                                                }) : null
                                                            ]
                                                        }, slot.value);
                                                    })
                                                })
                                            ]
                                        }),
                                        eveningSlots.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "slot-group",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                    children: "Evening"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "chips-grid",
                                                    children: eveningSlots.map((slot)=>{
                                                        const isCurrent = isCurrentBookingSlot(slot.value);
                                                        const disabled = isSlotDisabled(slot.value, slot);
                                                        const booked = isSlotBookedByOther(slot.value, slot);
                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                            type: "button",
                                                            disabled: disabled,
                                                            className: `time-chip ${disabled ? 'disabled' : ''} ${booked ? 'booked' : ''} ${isCurrent ? 'current-booking' : ''} ${selectedTimeSlot === slot.value && !disabled ? 'selected' : ''}`,
                                                            onClick: ()=>{
                                                                if (!disabled) setSelectedTimeSlot(slot.value);
                                                            },
                                                            title: isCurrent ? 'Current booking time (This Booking)' : booked ? slot.clientName || 'Already booked with another client' : undefined,
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: slot.display
                                                                }),
                                                                isCurrent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "booked-tag current-tag",
                                                                    children: "This Booking"
                                                                }) : booked ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "booked-tag",
                                                                    children: "Booked"
                                                                }) : null
                                                            ]
                                                        }, slot.value);
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                className: "btn-submit-suggest",
                                onClick: handleSuggestSubmit,
                                disabled: isSubmitDisabled,
                                isLoading: suggestMutation.isPending,
                                children: "Suggest New Time"
                            })
                        ]
                    })
                }),
                renderSuggestAlreadySentModal()
            ]
        });
    }
    if (loading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "checkin-details-container",
        style: {
            alignItems: 'center',
            justifyContent: 'center'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
            indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                style: {
                    fontSize: 32,
                    color: '#F59E0B'
                },
                spin: true
            })
        })
    });
    const isUnbookedSlot = !checkin || !checkin.isAppoint && !checkin.appointUId && !checkin.client_uid && !checkin.checkinProgress && !checkin.chat_id && !checkin.message_id;
    if (isUnbookedSlot) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "checkin-details-container",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "not-found-view-container",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "not-found-icon-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyCheckinsSvg.ReactComponent), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: !checkin ? 'Check-in Not Found' : 'Unbooked Availability Slot'
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: !checkin ? 'The requested check-in could not be found or may have been removed.' : 'This time slot is open for bookings. No student has reserved this session yet.'
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    className: "btn-back-checkins",
                    onClick: onBack,
                    children: "Back to Check-ins"
                })
            ]
        })
    });
    // 3. Main Check-in View (Confirmed, Completed, or Pending Request)
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "checkin-details-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "details-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-left",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "back-button",
                                onClick: onBack,
                                "aria-label": "Back to Check-ins",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatBackArrowSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: `client-info ${clientUid ? 'clickable' : ''}`,
                                onClick: clientUid ? handleClientBannerClick : undefined,
                                role: clientUid ? 'button' : undefined,
                                tabIndex: clientUid ? 0 : undefined,
                                onKeyDown: (e)=>{
                                    if (clientUid && (e.key === 'Enter' || e.key === ' ')) handleClientBannerClick();
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "client-avatar",
                                        style: {
                                            backgroundImage: clientAvatar ? `url(${clientAvatar})` : 'none'
                                        },
                                        children: !clientAvatar && clientInitials
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "client-name-email",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                children: clientName
                                            }),
                                            clientEmail && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: clientEmail
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `status-badge ${statusBadgeInfo.className}`,
                        children: [
                            statusBadgeInfo.hasDot && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "status-dot"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: statusBadgeInfo.label
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "details-body",
                children: [
                    (status === 'confirmed' || checkinProgress === '3') && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "checkin-dashboard-grid",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "dashboard-column column-left",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "dashboard-card checkin-info-card",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "card-header",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "card-header-icon",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedDetailsSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                        children: "Check-in details"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "details-table",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "table-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "label",
                                                                children: "Date"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "val",
                                                                children: formattedDate || "\u2014"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "table-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "label",
                                                                children: "Time"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "val",
                                                                children: formattedTime || "\u2014"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "table-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "label",
                                                                children: "Meeting"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "val",
                                                                children: preferenceLabel || "\u2014"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "table-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "label",
                                                                children: "Duration"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "val",
                                                                children: checkin?.duration_mins ? `${checkin.duration_mins} min` : '30 min'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "dashboard-card meeting-access-card",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "meeting-access-header",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "title-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "card-header-icon",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedMeetingAccessSvg.ReactComponent), {})
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                children: "Meeting access"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "card-subtitle",
                                                        children: "Join the meeting using the details below"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "meeting-access-inner-box",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "zoom-link-container",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "zoom-link-left",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "link-title",
                                                                        children: "Zoom link (auto-generated)"
                                                                    }),
                                                                    checkin?.zoom_link ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                                        href: checkin.zoom_link,
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        className: "zoom-url-text",
                                                                        children: checkin.zoom_link
                                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "zoom-url-text",
                                                                        style: {
                                                                            color: '#8e95a5'
                                                                        },
                                                                        children: "No Zoom link available"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                                type: "button",
                                                                disabled: !checkin?.zoom_link,
                                                                className: `btn-copy-link ${isCopiedZoomLink ? 'copied-btn' : ''}`,
                                                                onClick: handleCopyZoomLink,
                                                                children: [
                                                                    isCopiedZoomLink ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CheckOutlined), {
                                                                        style: {
                                                                            color: '#22c55e'
                                                                        }
                                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedCopyLinkSvg.ReactComponent), {}),
                                                                    ' ',
                                                                    isCopiedZoomLink ? 'Copied' : 'Copy link'
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "meeting-credentials",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "credential-row",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "label",
                                                                        children: "Meeting ID"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "val",
                                                                        children: meetingId || "\u2014"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "credential-row",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "label",
                                                                        children: "Passcode"
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "val",
                                                                        children: passcode || "\u2014"
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                        type: "button",
                                                        disabled: !checkin?.zoom_link,
                                                        className: "btn-open-zoom",
                                                        onClick: ()=>{
                                                            if (checkin?.zoom_link) window.open(checkin.zoom_link, '_blank');
                                                        },
                                                        children: [
                                                            "Open Zoom ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedOpenZoomSvg.ReactComponent), {})
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "dashboard-column column-right",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "dashboard-card ai-progress-summary-card",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "ai-progress-header",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "title-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "card-header-icon round-sparkle-badge",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedAiProgressSvg.ReactComponent), {})
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                children: "AI progress summary before meeting"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "card-subtitle",
                                                        children: [
                                                            "Here's what ",
                                                            clientName ? clientName.split(' ')[0] : 'the client',
                                                            " has been up to since your last check-in."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "bento-summary-grid",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "bento-cell performance-cell",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "bento-cell-header",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "cell-icon-badge badge-green",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedPerformanceOverviewSvg.ReactComponent), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                        children: "Performance Overview"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "performance-content",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "donut-chart-container",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                                className: "donut-svg",
                                                                                viewBox: "0 0 100 100",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                                        className: "donut-bg",
                                                                                        cx: "50",
                                                                                        cy: "50",
                                                                                        r: "40",
                                                                                        fill: "none",
                                                                                        stroke: "rgba(255,255,255,0.06)",
                                                                                        strokeWidth: "7"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                                        className: "donut-fill",
                                                                                        cx: "50",
                                                                                        cy: "50",
                                                                                        r: "40",
                                                                                        fill: "none",
                                                                                        stroke: "#71BE41",
                                                                                        strokeWidth: "7",
                                                                                        strokeDasharray: "251.33",
                                                                                        strokeDashoffset: progressSummary?.performance_score !== undefined ? 251.33 - 251.33 * progressSummary.performance_score / 100 : 251.33,
                                                                                        strokeLinecap: "round",
                                                                                        transform: "rotate(-90 50 50)"
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "donut-label",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "donut-pct",
                                                                                        children: progressSummary?.performance_score !== undefined ? `${progressSummary.performance_score}%` : "\u2014"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "donut-sub",
                                                                                        children: "Overall Score"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "performance-legend",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "legend-row",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "dot dot-green"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "legend-name",
                                                                                        children: "Great Form"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "legend-num",
                                                                                        children: progressSummary?.great_form_count ?? 0
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "legend-row",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "dot dot-lightgreen"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "legend-name",
                                                                                        children: "Good Form"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "legend-num",
                                                                                        children: progressSummary?.good_form_count ?? 0
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "legend-row",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "dot dot-amber"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "legend-name",
                                                                                        children: "Needs Focus"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "legend-num",
                                                                                        children: progressSummary?.needs_focus_count ?? 0
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "legend-row",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "dot dot-red"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "legend-name",
                                                                                        children: "Skipped"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "legend-num",
                                                                                        children: progressSummary?.skipped_count ?? 0
                                                                                    })
                                                                                ]
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "bento-cell workouts-cell",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "bento-cell-header",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "cell-icon-badge badge-purple",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedWorkoutCompletedSvg.ReactComponent), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                        children: "Workouts completed"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "workouts-content",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "mini-bars-chart",
                                                                        children: [
                                                                            {
                                                                                day: 'M',
                                                                                active: false,
                                                                                height: 12
                                                                            },
                                                                            {
                                                                                day: 'T',
                                                                                active: true,
                                                                                height: 26
                                                                            },
                                                                            {
                                                                                day: 'W',
                                                                                active: false,
                                                                                height: 8
                                                                            },
                                                                            {
                                                                                day: 'T',
                                                                                active: true,
                                                                                height: 26
                                                                            },
                                                                            {
                                                                                day: 'F',
                                                                                active: false,
                                                                                height: 8
                                                                            },
                                                                            {
                                                                                day: 'S',
                                                                                active: false,
                                                                                height: 16
                                                                            },
                                                                            {
                                                                                day: 'S',
                                                                                active: false,
                                                                                height: 10
                                                                            }
                                                                        ].map((bar, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                className: "bar-column",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                        className: `bar-fill ${bar.active ? 'active' : ''}`,
                                                                                        style: {
                                                                                            height: `${bar.height}px`
                                                                                        }
                                                                                    }),
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "bar-day",
                                                                                        children: bar.day
                                                                                    })
                                                                                ]
                                                                            }, idx))
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                        className: "workouts-stat",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                className: "stat-bold",
                                                                                children: [
                                                                                    progressSummary?.workouts_completed ?? 0,
                                                                                    ' ',
                                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                        className: "stat-regular",
                                                                                        children: "of"
                                                                                    }),
                                                                                    ' ',
                                                                                    progressSummary?.workouts_total ?? 0
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                className: "stat-muted",
                                                                                children: "this week"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "bento-cell last-activity-cell",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "bento-cell-header",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "cell-icon-badge badge-cyan",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedLastActivitySvg.ReactComponent), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                        children: "Last activity"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "cell-single-stat",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "stat-highlight",
                                                                    children: [
                                                                        progressSummary?.last_activity_date || 'No recent activity',
                                                                        ' ',
                                                                        progressSummary?.last_activity_relative && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            className: "stat-sub",
                                                                            children: [
                                                                                "(",
                                                                                progressSummary.last_activity_relative,
                                                                                ")"
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "bento-cell form-concern-cell",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "bento-cell-header",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "cell-icon-badge badge-red",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedFormConcernSvg.ReactComponent), {})
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                        children: "Form concern"
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "cell-single-stat",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "stat-highlight",
                                                                    children: progressSummary?.form_concern || 'None reported'
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "dashboard-card next-actions-card",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "section-header-block",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "title-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "card-header-icon",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedNextActionsSvg.ReactComponent), {})
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                children: "Next actions"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                        className: "card-subtitle",
                                                        children: [
                                                            "Prepare for your meeting and keep",
                                                            ' ',
                                                            clientName ? clientName.split(' ')[0] : 'the client',
                                                            " on track."
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "actions-button-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                        type: "button",
                                                        className: "btn-action-complete",
                                                        onClick: handleOpenCompleteModal,
                                                        disabled: completeMutation.isPending,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CheckOutlined), {}),
                                                            " Complete check-in"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                        type: "button",
                                                        className: "btn-action-reminder",
                                                        onClick: handleSendReminder,
                                                        disabled: sendReminderMutation.isPending,
                                                        children: [
                                                            sendReminderMutation.isPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedSendReminderSvg.ReactComponent), {}),
                                                            ' ',
                                                            sendReminderMutation.isPending ? 'Sending...' : 'Send Reminder'
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                        type: "button",
                                                        className: "btn-action-reschedule",
                                                        onClick: handleOpenReschedule,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedRescheduleCheckInSvg.ReactComponent), {}),
                                                            " Reschedule check-in"
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (status === 'completed' || checkinProgress === '4') && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "checkin-dashboard-grid",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "dashboard-column column-left",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "dashboard-card checkin-info-card",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "card-header",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "card-header-icon",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedDetailsSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                        children: "Check-in details"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "details-table",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "table-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "label",
                                                                children: "Date"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "val",
                                                                children: formattedDate
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "table-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "label",
                                                                children: "Time"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "val",
                                                                children: formattedTime
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "table-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "label",
                                                                children: "Meeting"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "val",
                                                                children: preferenceLabel
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "table-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "label",
                                                                children: "Duration"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "val",
                                                                children: checkin?.duration_mins ? `${checkin.duration_mins} min` : '32 min'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "table-row",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "label",
                                                                children: "Attendance"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "val",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "attendance-pill",
                                                                    children: checkin?.attendance === 'missed' ? 'Missed' : 'Attended'
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "dashboard-card transcript-highlights-card",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "card-header-flex",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "card-header-left",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "card-header-icon",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInCompletedTranscriptionSvg.ReactComponent), {})
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                                children: "Transcript highlights"
                                                            })
                                                        ]
                                                    }),
                                                    fullTranscriptDialogue.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                        type: "button",
                                                        className: "btn-view-full-transcript",
                                                        onClick: ()=>setIsFullTranscriptModalOpen(true),
                                                        children: [
                                                            "View full transcript ",
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.RightOutlined), {
                                                                style: {
                                                                    fontSize: 11
                                                                }
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            highlights.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "highlights-list",
                                                children: highlights.map((item, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "highlight-entry",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "timestamp",
                                                                children: item.time
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "entry-text",
                                                                children: item.text
                                                            })
                                                        ]
                                                    }, index))
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "empty-transcript-state",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "card-header-icon empty-icon-wrap",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInCompletedTranscriptionSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "empty-text",
                                                        children: "No Transcript data"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "empty-subtext",
                                                        children: "No transcript recording available for this session."
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "dashboard-column column-right",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "dashboard-card ai-checkin-summary-card",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "card-header",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "card-header-icon round-sparkle-badge",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInConfirmedAiProgressSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                        children: "AI check-in summary"
                                                    })
                                                ]
                                            }),
                                            aiSummaryParagraphs.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "summary-paragraphs",
                                                children: aiSummaryParagraphs.map((para, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        children: para
                                                    }, idx))
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "empty-summary-state",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "empty-subtext",
                                                    children: "No AI summary generated for this check-in."
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "dashboard-card action-items-card",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "card-header",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "card-header-icon",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkInCompletedActionItemsSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                        children: "Action items"
                                                    })
                                                ]
                                            }),
                                            currentActionItems.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "action-items-list",
                                                children: currentActionItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                                        className: "action-checkbox-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                type: "checkbox",
                                                                checked: actionItemsChecked[item.id],
                                                                onChange: ()=>toggleActionItem(item.id)
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "custom-checkbox",
                                                                children: actionItemsChecked[item.id] && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CheckOutlined), {
                                                                    style: {
                                                                        fontSize: 10
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: `item-label ${actionItemsChecked[item.id] ? 'checked' : ''}`,
                                                                children: item.text
                                                            })
                                                        ]
                                                    }, item.id))
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "empty-action-items-state",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "empty-subtext",
                                                    children: "No action items recorded for this check-in."
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    checkinProgress === '2' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "details-center-panel",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: `checkin-proposal-banner ${checkin?.checkinNewSuggest ? 'counter-proposal' : ''}`,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "banner-title",
                                        children: checkin?.checkinNewSuggest ? 'Client Requested Another Time' : 'New Time Proposed'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "banner-desc",
                                        children: checkin?.checkinNewSuggest ? 'The client received your proposed time and requested that you suggest a different date or time.' : 'You have proposed an alternative time for this session. Awaiting confirmation from the client.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "info-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Client"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: clientName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Original Request"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "info-val",
                                                children: [
                                                    formattedDate,
                                                    " at ",
                                                    formattedTime
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Proposed Date"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                style: {
                                                    color: '#F59E0B',
                                                    fontWeight: 600
                                                },
                                                children: checkin?.checkinNewDate || "\u2014"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Proposed Time"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                style: {
                                                    color: '#F59E0B',
                                                    fontWeight: 600
                                                },
                                                children: checkin?.checkinNewTime ? formatTimeWithAmPm(checkin.checkinNewTime) : "\u2014"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Session Type"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: checkin?.checkinNewType === 'inPerson' ? 'In-person' : 'Online via Zoom'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "actions-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        className: "btn-suggest",
                                        onClick: handleOpenReschedule,
                                        disabled: suggestMutation.isPending || declineMutation.isPending,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checinRequestSuggestNewTimeSvg.ReactComponent), {}),
                                            "Suggest Another Time"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        className: "btn-decline",
                                        onClick: ()=>setIsDeclineModalOpen(true),
                                        disabled: suggestMutation.isPending || declineMutation.isPending,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checinRequestDeclineSvg.ReactComponent), {}),
                                            "Decline Request"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (checkinProgress === '5' || status === 'declined' && checkinProgress !== '6') && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "details-center-panel",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "checkin-status-callout declined",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "callout-header",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {
                                                style: {
                                                    color: '#EF4444'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: "Check-in Request Declined"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "callout-desc",
                                        children: "This check-in request was declined and the calendar slot has been freed for new bookings."
                                    }),
                                    (checkin?.checkinDeclinedReason || checkin?.decline_reason) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "callout-reason-box",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "reason-label",
                                                children: "Reason provided:"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "reason-text",
                                                children: [
                                                    "\u201C",
                                                    checkin.checkinDeclinedReason || checkin.decline_reason,
                                                    "\u201D"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "info-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Client"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: clientName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Requested Date"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: formattedDate
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Requested Time"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: formattedTime
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Preference"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: preferenceLabel
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    checkinProgress === '6' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "details-center-panel",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "checkin-status-callout cancelled",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "callout-header",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {
                                                style: {
                                                    color: '#9CA3AF'
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: "Check-in Cancelled"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "callout-desc",
                                        children: "The client cancelled this check-in request. The calendar slot is now open for new bookings."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "info-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Client"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: clientName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Original Date"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: formattedDate
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Original Time"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: formattedTime
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Preference"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: preferenceLabel
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    (checkinProgress === '1' || !checkinProgress) && status === 'pending_confirmation' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "details-center-panel",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "info-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Client"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: clientName
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Date"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: formattedDate
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Time"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: formattedTime
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Preference"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: preferenceLabel
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-label",
                                                children: "Duration"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "info-val",
                                                children: checkin?.duration_mins ? `${checkin.duration_mins} min` : '30 min'
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "toggle-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "toggle-label",
                                        children: [
                                            "Send Zoom link automatically",
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                            "on confirmation"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Switch), {
                                        className: "custom-switch",
                                        checked: sendZoomLink,
                                        onChange: (checked)=>setSendZoomLink(checked),
                                        disabled: confirmMutation.isPending || suggestMutation.isPending || declineMutation.isPending
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "actions-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        className: "btn-confirm",
                                        onClick: handleConfirmClick,
                                        disabled: confirmMutation.isPending || suggestMutation.isPending || declineMutation.isPending,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checinRequestConfirmSvg.ReactComponent), {}),
                                            confirmMutation.isPending ? 'Confirming...' : 'Confirm check-in'
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        className: "btn-suggest",
                                        onClick: handleOpenReschedule,
                                        disabled: confirmMutation.isPending || suggestMutation.isPending || declineMutation.isPending,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checinRequestSuggestNewTimeSvg.ReactComponent), {}),
                                            "Suggest New Time"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        className: "btn-decline",
                                        onClick: ()=>setIsDeclineModalOpen(true),
                                        disabled: confirmMutation.isPending || suggestMutation.isPending || declineMutation.isPending,
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checinRequestDeclineSvg.ReactComponent), {}),
                                            "Decline Request"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: isDeclineModalOpen,
                footer: null,
                onCancel: handleCloseDeclineModal,
                centered: true,
                width: 440,
                closable: false,
                rootClassName: "logout-modal decline-checkin-modal-root",
                className: "logout-modal decline-checkin-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "decline-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "decline-modal-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    className: "modal-title",
                                    children: "Decline Request"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "close-btn",
                                    onClick: handleCloseDeclineModal,
                                    disabled: declineMutation.isPending,
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "decline-modal-body",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    className: "input-label",
                                    htmlFor: "decline-message-input",
                                    children: "Add message (optional)"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: `textarea-container ${declineReasonError ? 'has-error' : ''}`,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                            id: "decline-message-input",
                                            placeholder: "Type here...",
                                            value: declineReason,
                                            maxLength: 200,
                                            rows: 4,
                                            onChange: (e)=>{
                                                const val = e.target.value;
                                                if (val.length <= 200) {
                                                    setDeclineReason(val);
                                                    if (declineReasonError) setDeclineReasonError('');
                                                }
                                            },
                                            onBlur: (e)=>{
                                                const trimmed = e.target.value.trim();
                                                setDeclineReason(trimmed);
                                                const err = validateDeclineReason(trimmed);
                                                setDeclineReasonError(err);
                                            },
                                            disabled: declineMutation.isPending
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "char-counter",
                                            children: [
                                                declineReason.length,
                                                "/200"
                                            ]
                                        })
                                    ]
                                }),
                                declineReasonError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "inline-error-text",
                                    children: declineReasonError
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "decline-modal-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "btn-keep-it",
                                    onClick: handleCloseDeclineModal,
                                    disabled: declineMutation.isPending,
                                    children: "Keep It"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "btn-decline-confirm",
                                    onClick: handleDeclineSubmit,
                                    disabled: declineMutation.isPending || Boolean(declineReasonError),
                                    children: declineMutation.isPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                        indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                            style: {
                                                fontSize: 16,
                                                color: '#FFA100'
                                            },
                                            spin: true
                                        })
                                    }) : 'Decline'
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: isConfirmAlreadySentModalOpen,
                footer: null,
                onCancel: ()=>setIsConfirmAlreadySentModalOpen(false),
                centered: true,
                width: 400,
                closeIcon: null,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "logout-icon-wrapper",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dashboardModalArchiveSvg.ReactComponent), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: "Confirm Check-in?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                            children: [
                                "You have already proposed a new time for this check-in to",
                                ' ',
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                    children: checkin?.client_name || 'the client'
                                }),
                                ". Do you want to proceed and confirm this check-in session for",
                                ' ',
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("b", {
                                    children: [
                                        formattedDate,
                                        " at ",
                                        formattedTime
                                    ]
                                }),
                                "?"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-logout",
                                    onClick: executeConfirm,
                                    disabled: confirmMutation.isPending,
                                    isLoading: confirmMutation.isPending,
                                    children: "Confirm Check-in"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-cancel",
                                    onClick: ()=>setIsConfirmAlreadySentModalOpen(false),
                                    disabled: confirmMutation.isPending,
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }),
            renderSuggestAlreadySentModal(),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: isFullTranscriptModalOpen,
                onCancel: ()=>setIsFullTranscriptModalOpen(false),
                footer: null,
                centered: true,
                width: 680,
                rootClassName: "full-transcript-modal-root",
                wrapClassName: "full-transcript-modal-wrap",
                className: "full-transcript-modal-root",
                styles: {
                    mask: {
                        backdropFilter: 'blur(6px)',
                        backgroundColor: 'rgba(0, 0, 0, 0.75)'
                    }
                },
                modalRender: ()=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "full-transcript-modal-wrapper",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "full-transcript-dialog",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "dialog-header",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "header-text-group",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                    children: "Full Transcript"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "transcript-duration",
                                                    children: "32:45,32"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: "btn-modal-close",
                                            onClick: ()=>setIsFullTranscriptModalOpen(false),
                                            "aria-label": "Close",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "dialog-body custom-dark-scrollbar",
                                    children: fullTranscriptDialogue.length > 0 ? fullTranscriptDialogue.map((paragraph, index)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "transcript-paragraph",
                                            children: paragraph
                                        }, index)) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "empty-transcript-state modal-empty",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FileTextOutlined), {
                                                className: "empty-icon"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "empty-text",
                                                children: "No Transcript data"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "empty-subtext",
                                                children: "No full transcript recording available for this session."
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: isCompleteModalOpen,
                footer: null,
                onCancel: ()=>setIsCompleteModalOpen(false),
                centered: true,
                width: 540,
                closeIcon: null,
                rootClassName: "complete-checkin-modal logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "complete-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "complete-modal-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "header-title-block",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                            className: "modal-title",
                                            children: "Complete Check-in"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                            className: "modal-subtitle",
                                            children: [
                                                "Wrap up your session with ",
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("b", {
                                                    children: clientName
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "close-btn",
                                    onClick: ()=>setIsCompleteModalOpen(false),
                                    "aria-label": "Close",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
                                })
                            ]
                        }),
                        isZoomCheckin && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "zoom-sync-card",
                            children: isZoomStatusLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "zoom-sync-loading",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                        indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                            style: {
                                                fontSize: 16,
                                                color: '#f59e0b'
                                            },
                                            spin: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Connecting to Zoom & checking session details..."
                                    })
                                ]
                            }) : zoomStatus?.has_transcript ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "zoom-sync-status detected",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "status-top",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "pulse-dot green"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "sync-title",
                                                children: "Zoom Session Detected"
                                            }),
                                            zoomStatus.actual_duration_mins && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "duration-tag",
                                                children: [
                                                    zoomStatus.actual_duration_mins,
                                                    " min"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "sync-desc",
                                        children: [
                                            "Cloud transcript and highlights found (",
                                            zoomStatus.transcript_turns_count || 0,
                                            ' ',
                                            "dialogue turns). Actual duration auto-filled below."
                                        ]
                                    }),
                                    zoomStatus.transcript_preview && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "sync-preview",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "preview-label",
                                                children: "Preview:"
                                            }),
                                            ' "',
                                            zoomStatus.transcript_preview,
                                            '"'
                                        ]
                                    })
                                ]
                            }) : zoomStatus?.actual_duration_mins ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "zoom-sync-status duration-only",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "status-top",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "pulse-dot green"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "sync-title",
                                                children: "Zoom Session Recorded"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "duration-tag",
                                                children: [
                                                    zoomStatus.actual_duration_mins,
                                                    " min"
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                        className: "sync-desc",
                                        children: [
                                            "Actual meeting duration detected from Zoom (",
                                            zoomStatus.actual_duration_mins,
                                            ' ',
                                            "mins). No cloud audio transcript found."
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "zoom-sync-status no-recording",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "status-top",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "pulse-dot grey"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "sync-title",
                                                children: "Zoom Session (Scheduled)"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "sync-desc",
                                        children: "No cloud recording found yet. You can confirm attendance, duration, and notes manually below."
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    children: "ATTENDANCE"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "attendance-toggle-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: `pill-btn ${completionAttendance === 'attended' ? 'active' : ''}`,
                                            onClick: ()=>setCompletionAttendance('attended'),
                                            children: "Attended"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: `pill-btn ${completionAttendance === 'missed' ? 'active' : ''}`,
                                            onClick: ()=>setCompletionAttendance('missed'),
                                            children: "Missed"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        "SESSION DURATION",
                                        zoomStatus?.actual_duration_mins ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "optional-tag",
                                            children: "(AUTO-DETECTED FROM ZOOM)"
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "duration-pill-group",
                                    children: durationOptions.map((mins)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            type: "button",
                                            className: `pill-btn ${completionDuration === mins ? 'active' : ''}`,
                                            onClick: ()=>setCompletionDuration(mins),
                                            children: [
                                                mins,
                                                " min"
                                            ]
                                        }, mins))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        "SESSION NOTES / SUMMARY ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "optional-tag",
                                            children: "(OPTIONAL)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                    className: "complete-textarea",
                                    placeholder: "Summarize key points, form feedback, or discussion highlights...",
                                    value: completionNotes,
                                    onChange: (e)=>setCompletionNotes(e.target.value),
                                    onBlur: (e)=>setCompletionNotes(e.target.value.trim()),
                                    rows: 3
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    children: [
                                        "ACTION ITEMS ",
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "optional-tag",
                                            children: "(OPTIONAL)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "action-items-input-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            type: "text",
                                            className: "complete-input",
                                            placeholder: "e.g. Upload squat form video by Friday",
                                            value: newActionItemText,
                                            onChange: (e)=>setNewActionItemText(e.target.value),
                                            onKeyDown: (e)=>{
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    handleAddActionItem();
                                                }
                                            }
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: "btn-add-action-item",
                                            onClick: handleAddActionItem,
                                            disabled: !newActionItemText.trim(),
                                            children: "Add"
                                        })
                                    ]
                                }),
                                completionActionItems.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "action-items-preview-list",
                                    children: completionActionItems.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "action-item-pill",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: item.text
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    className: "btn-remove-item",
                                                    onClick: ()=>handleRemoveActionItem(item.id),
                                                    "aria-label": "Remove item",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
                                                })
                                            ]
                                        }, item.id))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-cancel",
                                    onClick: ()=>setIsCompleteModalOpen(false),
                                    disabled: completeMutation.isPending,
                                    children: "Cancel"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _button.Button), {
                                    className: "btn-complete-submit",
                                    onClick: handleCompleteSubmit,
                                    disabled: completeMutation.isPending,
                                    isLoading: completeMutation.isPending,
                                    children: "Mark as Completed"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","antd":[["Modal","kY4DD","default"],["notification","j9bIN","default"],["Spin","lVvhl","default"],["Switch","9ecFZ","default"]],"@ant-design/icons":[["CheckOutlined","jMPci","default"],["CloseOutlined","dinn5","default"],["FileTextOutlined","ioDdZ","default"],["LeftOutlined","8erTV","default"],["LoadingOutlined","8Mvdh","default"],["RightOutlined","lRGzb","default"]],"react-hot-toast":"3T0Wh","@tanstack/react-query":"lWWNx","firebase/firestore":"5IgBQ","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","src/api/checkins":"NC6YO","src/hooks/useCheckinRealtime":"f3xjQ","src/hooks/useCheckinsRealtime":"dnr1Y","src/api/mutations/useGetTrainerClients":"18nHc","src/components/Button/Button":"g0894","src/assets/images/trainer/clients/dashboard-modal-archive.svg":"iJaEv","src/assets/images/trainer/clients/dashboard-modal-duplicate.svg":"1qXpt","src/assets/images/onboarding-trainer/dashboard/checkins/checin-request-confirm.svg":"7mrkf","src/assets/images/onboarding-trainer/dashboard/checkins/checin-request-decline.svg":"iKQeS","src/assets/images/onboarding-trainer/dashboard/checkins/checin-request-suggest-new-time.svg":"9HMgQ","src/assets/images/onboarding-trainer/dashboard/checkins/checkin-request-sent.svg":"jMwNN","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-details.svg":"8wxQR","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-meeting-access.svg":"1antH","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-copy-link.svg":"1BJdP","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-open-zoom.svg":"kqEdH","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-ai-progress.svg":"iwEMh","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-performance-overview.svg":"3rzrt","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-workout-completed.svg":"d4461","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-last-activity.svg":"etpVO","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-form-concern.svg":"iORmh","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-next-actions.svg":"asqFr","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-send-reminder.svg":"eIQzB","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-confirmed-reschedule-check-in.svg":"gKxmT","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-completed-transcription.svg":"gM0Bd","src/assets/images/onboarding-trainer/dashboard/checkins/confirmed/check-in-completed-action-items.svg":"jDNKV","src/assets/images/onboarding-trainer/dashboard/messages/notifications/chat-back-arrow.svg":"joY4z","src/assets/images/onboarding-trainer/dashboard/messages/empty-checkins.svg":"fRlYS","src/assets/images/onboarding-trainer/dashboard/program-generator-ai/components/simple-line-check.svg":"6ZZuW","./CheckinDetails.scss":"diakS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ioDdZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _fileTextOutlined = require("@ant-design/icons-svg/es/asn/FileTextOutlined");
var _fileTextOutlinedDefault = parcelHelpers.interopDefault(_fileTextOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FileTextOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _fileTextOutlinedDefault.default)
    }));
/**![file-text](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHpNNTA0IDYxOEgzMjBjLTQuNCAwLTggMy42LTggOHY0OGMwIDQuNCAzLjYgOCA4IDhoMTg0YzQuNCAwIDgtMy42IDgtOHYtNDhjMC00LjQtMy42LTgtOC04ek0zMTIgNDkwdjQ4YzAgNC40IDMuNiA4IDggOGgzODRjNC40IDAgOC0zLjYgOC04di00OGMwLTQuNC0zLjYtOC04LThIMzIwYy00LjQgMC04IDMuNi04IDh6IiAvPjwvc3ZnPg==) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(FileTextOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/FileTextOutlined":"3Yk4a","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Yk4a":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var FileTextOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z"
                }
            }
        ]
    },
    "name": "file-text",
    "theme": "outlined"
};
exports.default = FileTextOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f3xjQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useCheckinRealtime", ()=>useCheckinRealtime);
var _react = require("react");
var _firestore = require("firebase/firestore");
var _auth = require("firebase/auth");
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
var _checkins = require("src/api/checkins");
function useCheckinRealtime(checkinId, chatId, trainerUidProp) {
    const [checkin, setCheckin] = (0, _react.useState)(null);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [error, setError] = (0, _react.useState)(null);
    const [activeUid, setActiveUid] = (0, _react.useState)(()=>{
        return trainerUidProp || (0, _firebase.auth).currentUser?.uid || (0, _sessionStore.sessionStore).getState().currentUser?.uid || '';
    });
    (0, _react.useEffect)(()=>{
        const unsubscribeAuth = (0, _auth.onAuthStateChanged)((0, _firebase.auth), (user)=>{
            if (user?.uid) setActiveUid(user.uid);
            else {
                const storedUid = (0, _sessionStore.sessionStore).getState().currentUser?.uid || trainerUidProp || '';
                if (storedUid) setActiveUid(storedUid);
            }
        });
        return ()=>unsubscribeAuth();
    }, [
        trainerUidProp
    ]);
    (0, _react.useEffect)(()=>{
        if (!checkinId) {
            setCheckin(null);
            setLoading(false);
            return;
        }
        const trainerUid = activeUid || (0, _firebase.auth).currentUser?.uid || (0, _sessionStore.sessionStore).getState().currentUser?.uid || trainerUidProp || '';
        if (!trainerUid) {
            setLoading(true);
            return;
        }
        setLoading(true);
        let unsubMsg = null;
        const foundChatId = chatId;
        const attachMsgListener = (effChatId, msgId)=>{
            if (unsubMsg) return;
            try {
                const msgDocRef = (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', effChatId, 'messages', msgId);
                unsubMsg = (0, _firestore.onSnapshot)(msgDocRef, (msgSnap)=>{
                    if (msgSnap.exists()) {
                        const mData = msgSnap.data();
                        mData.id = msgSnap.id;
                        const dateStr = mData.checkinDate || '';
                        const enriched = (0, _checkins.enrichClientCheckin)(mData, dateStr, trainerUid);
                        setCheckin((prev)=>prev ? {
                                ...prev,
                                ...enriched
                            } : enriched);
                        setLoading(false);
                        setError(null);
                    }
                }, (err)=>{
                    console.warn('Realtime message subscription notice:', err);
                });
            } catch (err) {
                console.warn('Error attaching message listener:', err);
            }
        };
        if (foundChatId) attachMsgListener(foundChatId, checkinId);
        const checkinListCol = (0, _firestore.collection)((0, _firebase.db), 'trainer_app_users', trainerUid, 'checkinList');
        const unsubscribeList = (0, _firestore.onSnapshot)(checkinListCol, (snapshot)=>{
            let foundItem = null;
            for (const docSnapshot of snapshot.docs){
                const docData = docSnapshot.data();
                const dateStr = docData.date || docSnapshot.id;
                for (const listKey of [
                    'morningList',
                    'daytimeList',
                    'eveningList'
                ]){
                    const slotList = docData[listKey] || [];
                    for(let idx = 0; idx < slotList.length; idx++){
                        const slot = slotList[idx];
                        const slotId = slot.id || slot.checkin_id || `${dateStr}_${slot.time || '00:00'}_${idx}`;
                        if (slot.message_id === checkinId || slot.id === checkinId || slot.checkin_id === checkinId || slotId === checkinId || `${dateStr}_${slot.time}` === checkinId || `${dateStr}_${slot.time}_${idx}` === checkinId) {
                            foundItem = (0, _checkins.enrichClientCheckin)(slot, dateStr, trainerUid);
                            break;
                        }
                    }
                    if (foundItem) break;
                }
                if (foundItem) break;
            }
            if (foundItem) {
                const clientUid = foundItem.client_uid || foundItem.appointUId;
                const effChatId = foundItem.chat_id || (clientUid ? `${trainerUid}_${clientUid}` : '');
                if (effChatId && !unsubMsg) attachMsgListener(effChatId, foundItem.message_id || checkinId);
                if (clientUid && !foundItem.client_email) (0, _firestore.getDoc)((0, _firestore.doc)((0, _firebase.db), 'flutter_user', clientUid)).then((uSnap)=>{
                    if (uSnap.exists()) {
                        const uData = uSnap.data();
                        setCheckin((prev)=>{
                            if (!prev) return prev;
                            return {
                                ...prev,
                                client_email: uData.email || prev.client_email || '',
                                client_name: prev.client_name === 'Client' || prev.client_name === 'Guest' || !prev.client_name ? uData.name || `${uData.name || ''} ${uData.surname || ''}`.trim() || prev.client_name : prev.client_name,
                                client_avatar: prev.client_avatar || uData.avatar || uData.avatar_url || uData.profile_picture || null
                            };
                        });
                    }
                }).catch((err)=>{
                    console.warn('Could not fetch flutter_user doc in useCheckinRealtime:', err);
                });
                setCheckin((prev)=>{
                    if (!prev) return foundItem;
                    // Merge slot with prev (which might have message updates)
                    return {
                        ...foundItem,
                        ...prev,
                        id: foundItem.id
                    };
                });
                setError(null);
            } else if (!foundChatId && !unsubMsg) setCheckin((prev)=>{
                if (prev) return prev;
                setError('ERR_CHECKIN_NOT_FOUND');
                return null;
            });
            setLoading(false);
        }, (err)=>{
            console.error('Error in checkin realtime checkinList subscription:', err);
            setError(err.message || 'Failed to sync check-in');
            setLoading(false);
        });
        return ()=>{
            unsubscribeList();
            if (unsubMsg) unsubMsg();
        };
    }, [
        checkinId,
        chatId,
        activeUid,
        trainerUidProp
    ]);
    return {
        checkin,
        loading,
        error
    };
}

},{"react":"bmhQu","firebase/firestore":"5IgBQ","firebase/auth":"dZ6yw","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","src/api/checkins":"NC6YO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7mrkf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgChecinRequestConfirm);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgChecinRequestConfirm = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 9,
        fill: "none",
        viewBox: "0 0 12 9",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#04051B",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "M11.333.668 4 8.001.667 4.668"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iKQeS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgChecinRequestDecline);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgChecinRequestDecline = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        fill: "none",
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#ED4040",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "m8.667.668-8 8m0-8 8 8"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9HMgQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgChecinRequestSuggestNewTime);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgChecinRequestSuggestNewTime = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M0 11.333c0 1.134.867 2 2 2h9.333c1.134 0 2-.866 2-2V6H0zm11.333-10H10V.667C10 .267 9.733 0 9.333 0s-.666.267-.666.667v.666h-4V.667C4.667.267 4.4 0 4 0s-.667.267-.667.667v.666H2c-1.133 0-2 .867-2 2v1.334h13.333V3.333c0-1.133-.866-2-2-2"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jMwNN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckinRequestSent);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckinRequestSent = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 58.286,
        height: 58.286,
        viewBox: "187.239 143.765 58.286 58.286",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(27.8991 -12.6281 2.78295 50.0018 61.294 70.391)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#ffeb14"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ffa100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 75,
                        x2: 75,
                        y1: 33,
                        y2: 93,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#ffe111"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#ffa100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "a",
                        width: 150,
                        height: 150,
                        x: 0,
                        y: 0,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                dy: 12
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                stdDeviation: 22.5
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_13686_25566"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_13686_25566",
                                result: "shape"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                filter: "url(#a)",
                transform: "translate(141.382 109.908)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "url(#b)",
                        strokeWidth: 1.714,
                        d: "M75 33.857c16.095 0 29.143 13.048 29.143 29.143S91.095 92.143 75 92.143 45.857 79.095 45.857 63 58.905 33.857 75 33.857Z",
                        shapeRendering: "crispEdges"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#04051b",
                        d: "m70.108 69.3 16.95-16.95q.6-.6 1.4-.6t1.4.6.6 1.426-.6 1.424l-18.35 18.4q-.6.6-1.4.6t-1.4-.6l-8.6-8.6q-.6-.6-.576-1.424.024-.825.626-1.426a1.94 1.94 0 0 1 1.426-.6q.824.001 1.424.6z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "url(#c)",
                        d: "m70.108 69.3 16.95-16.95q.6-.6 1.4-.6t1.4.6.6 1.426-.6 1.424l-18.35 18.4q-.6.6-1.4.6t-1.4-.6l-8.6-8.6q-.6-.6-.576-1.424.024-.825.626-1.426a1.94 1.94 0 0 1 1.426-.6q.824.001 1.424.6z"
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8wxQR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInConfirmedDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInConfirmedDetails = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M0 11.333c0 1.134.867 2 2 2h9.333c1.134 0 2-.866 2-2V6H0zm11.333-10H10V.667C10 .267 9.733 0 9.333 0s-.666.267-.666.667v.666h-4V.667C4.667.267 4.4 0 4 0s-.667.267-.667.667v.666H2c-1.133 0-2 .867-2 2v1.334h13.333V3.333c0-1.133-.866-2-2-2"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1antH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInConfirmedMeetingAccess);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInConfirmedMeetingAccess = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 10,
        fill: "none",
        viewBox: "0 0 14 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M2 0a2 2 0 0 0-2 2v5.333a2 2 0 0 0 2 2h6.667a2 2 0 0 0 2-2V6.276l1.528 1.529a.667.667 0 0 0 1.138-.472V2a.666.666 0 0 0-1.138-.471l-1.528 1.528V2a2 2 0 0 0-2-2z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1BJdP":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInConfirmedCopyLink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInConfirmedCopyLink = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.067,
                d: "M3.2 4.981a1.78 1.78 0 0 1 1.778-1.778h5.777a1.78 1.78 0 0 1 1.778 1.778v5.778a1.777 1.777 0 0 1-1.778 1.777H4.978A1.777 1.777 0 0 1 3.2 10.76z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.067,
                d: "M1.208 9.693a1.33 1.33 0 0 1-.675-1.158V1.868c0-.733.6-1.333 1.334-1.333h6.666c.5 0 .772.257 1 .667"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kqEdH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInConfirmedOpenZoom);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInConfirmedOpenZoom = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 10,
        fill: "none",
        viewBox: "0 0 10 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.7,
            strokeWidth: 1.333,
            d: "m.667 8.668 8-8m0 5.333V.668H3.332"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iwEMh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInConfirmedAiProgress);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInConfirmedAiProgress = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 15,
        fill: "none",
        viewBox: "0 0 14 15",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M4.675 2.299c.399-1.167 2.01-1.202 2.483-.106l.04.106.538 1.574A2.67 2.67 0 0 0 9.254 5.48l.144.054 1.574.537c1.166.399 1.202 2.011.106 2.484l-.106.04-1.574.538A2.67 2.67 0 0 0 7.79 10.65l-.054.144-.537 1.574c-.399 1.167-2.01 1.202-2.483.107l-.041-.107-.537-1.573A2.67 2.67 0 0 0 2.62 9.187l-.144-.054-1.573-.538C-.264 8.197-.3 6.585.796 6.113l.107-.042 1.573-.537a2.67 2.67 0 0 0 1.608-1.517l.054-.144zM11.27 0a.67.67 0 0 1 .599.373l.032.078.233.684.685.234a.666.666 0 0 1 .079 1.23l-.08.032-.683.233-.233.685a.667.667 0 0 1-1.23.078l-.032-.078-.234-.684-.684-.234a.667.667 0 0 1-.08-1.23l.08-.032.684-.233.233-.685A.67.67 0 0 1 11.27 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3rzrt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInConfirmedPerformanceOverview);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInConfirmedPerformanceOverview = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 10,
        fill: "none",
        viewBox: "0 0 17 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#22D543",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m16 1-5.901 5.901c-.297.297-.446.446-.617.502a.75.75 0 0 1-.464 0c-.171-.056-.32-.205-.617-.502L6.35 4.85c-.297-.297-.446-.446-.617-.502a.75.75 0 0 0-.464 0c-.171.056-.32.205-.617.502L1 8.5m15-2.25V1h-5.25"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d4461":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInConfirmedWorkoutCompleted);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInConfirmedWorkoutCompleted = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#8163F3",
            d: "M3.73 7.761v5.083c0 .301-.124.59-.343.802s-.517.332-.827.332H1.17c-.31 0-.608-.12-.828-.332A1.12 1.12 0 0 1 0 12.844V7.761c0-.301.123-.59.342-.805.219-.214.516-.335.827-.337H2.56c.311.002.608.123.827.337.22.214.342.504.342.805m5.135-3.295v8.4c-.002.301-.127.59-.348.802S8 14 7.688 14H6.304c-.31 0-.608-.12-.829-.332a1.13 1.13 0 0 1-.347-.802v-8.4c0-.303.124-.593.345-.808.22-.214.52-.334.831-.334h1.384c.312 0 .611.12.832.334s.345.505.345.808M14 1.142v11.724c-.002.301-.127.59-.347.802s-.519.332-.83.332H11.44c-.311 0-.61-.12-.83-.332a1.13 1.13 0 0 1-.347-.802V1.142c0-.303.124-.594.345-.808S11.128 0 11.44 0h1.383c.313 0 .612.12.832.334.221.214.345.505.345.808"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"etpVO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInConfirmedLastActivity);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInConfirmedLastActivity = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 15,
        fill: "none",
        viewBox: "0 0 16 15",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#42CDFF",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M.75 6s1.504-2.049 2.725-3.271a6.75 6.75 0 1 1-1.712 6.646M5.25 6H.75V1.5"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iORmh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInConfirmedFormConcern);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInConfirmedFormConcern = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 15,
        fill: "none",
        viewBox: "0 0 10 15",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#F16A6A",
                d: "M8.022 6.13a5.6 5.6 0 0 1-1.86-2.501c-.424-1.15-.558-2.309-.6-2.961C5.55.284 5.245-.014 4.88 0c-.364.014-.647.336-.633.72.014 2.885 1.294 5.108 1.294 5.108L.136 13.777a.797.797 0 0 0 .166 1.07c.314.238.75.176.991-.143l3.41-4.459 1.92 1.568.744 2.625a.75.75 0 0 0 .716.562c.414 0 .747-.354.747-.79a1 1 0 0 0-.016-.161C8.175 10.807 6.85 9.771 6.85 9.771l.994-1.188c.452 1.34.591 2.595.63 3.274a.62.62 0 0 0 .53.591c.33.041.63-.207.67-.556q.002-.027.002-.058c.097-3.798-1.008-5.206-1.655-5.703"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#F16A6A",
                d: "M9.5 5.14c.575-.519.668-1.4.206-1.97-.461-.568-1.302-.608-1.877-.09-.576.52-.668 1.401-.207 1.97s1.302.609 1.878.09"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"asqFr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInConfirmedNextActions);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInConfirmedNextActions = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 10,
        fill: "none",
        viewBox: "0 0 14 10",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "M2 0a2 2 0 0 0-2 2v5.333a2 2 0 0 0 2 2h6.667a2 2 0 0 0 2-2V6.276l1.528 1.529a.667.667 0 0 0 1.138-.472V2a.666.666 0 0 0-1.138-.471l-1.528 1.528V2a2 2 0 0 0-2-2z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eIQzB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInConfirmedSendReminder);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInConfirmedSendReminder = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 13,
        height: 13,
        fill: "none",
        viewBox: "0 0 13 13",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M11.86.05a.857.857 0 0 1 1.091 1.09l-3.95 11.288c-.257.732-1.277.773-1.591.064L5.504 8.204l2.682-2.683a.5.5 0 0 0-.706-.707L4.796 7.497.508 5.591C-.2 5.276-.158 4.256.573 4z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gKxmT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInConfirmedRescheduleCheckIn);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInConfirmedRescheduleCheckIn = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M0 11.333c0 1.134.867 2 2 2h9.333c1.134 0 2-.866 2-2V6H0zm11.333-10H10V.667C10 .267 9.733 0 9.333 0s-.666.267-.666.667v.666h-4V.667C4.667.267 4.4 0 4 0s-.667.267-.667.667v.666H2c-1.133 0-2 .867-2 2v1.334h13.333V3.333c0-1.133-.866-2-2-2"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gM0Bd":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInCompletedTranscription);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInCompletedTranscription = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 14,
        fill: "none",
        viewBox: "0 0 12 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M11.787 3.343a2.6 2.6 0 0 0-.614-.813l-2-1.814C8.733.313 8.174.063 7.58.003H3.473A3.333 3.333 0 0 0 0 3.243v6.867a3.33 3.33 0 0 0 2.207 3.02c.408.155.844.223 1.28.2h5.04A3.334 3.334 0 0 0 12 10.09V4.376a2.5 2.5 0 0 0-.213-1.033M3.12 3.076h2.173a.667.667 0 1 1 0 1.334H3.12a.667.667 0 0 1 0-1.334m5.8 7.14h-5.8a.667.667 0 1 1 0-1.333h5.8a.667.667 0 0 1 0 1.32zm0-2.9h-5.8a.667.667 0 1 1 0-1.333h5.8a.667.667 0 1 1 0 1.333m-.213-3.713a.72.72 0 0 1-.727-.72V1.116c.44.107 2.153 1.867 2.527 2.16q.166.141.28.327z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jDNKV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckInCompletedActionItems);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckInCompletedActionItems = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.5,
            d: "M4.667 3.5h7.583M4.667 7h7.583m-7.583 3.5h7.583m-10.5-7h.006M1.75 7h.006m-.006 3.5h.006"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"joY4z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgChatBackArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgChatBackArrow = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.7,
            strokeWidth: 2,
            d: "m15 18-6-6 6-6"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"diakS":[function() {},{}],"Wgjdv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDropdownChevron);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDropdownChevron = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m6 9 6 6 6-6"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lYzMQ":[function() {},{}],"fTetm":[function() {},{}],"jhLvo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DashboardMessagesPlaceholder", ()=>DashboardMessagesPlaceholder);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _emptyMessagesSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/empty-messages.svg");
var _dashboardMessagesPlaceholderScss = require("./DashboardMessagesPlaceholder.scss");
const DashboardMessagesPlaceholder = ()=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "dashboard-messages-placeholder",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "placeholder-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "placeholder-icon-wrap",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emptyMessagesSvg.ReactComponent), {
                        className: "placeholder-icon"
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                    className: "placeholder-title",
                    children: "Select a conversation"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "placeholder-subtitle",
                    children: "Choose a message, inquiry, or check-in from the left panel to view and reply."
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/assets/images/onboarding-trainer/dashboard/messages/empty-messages.svg":"03Ka2","./DashboardMessagesPlaceholder.scss":"2ON31","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2ON31":[function() {},{}],"i7zub":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatTrainerWeeklySchedule", ()=>formatTrainerWeeklySchedule);
parcelHelpers.export(exports, "DashboardChatDetails", ()=>DashboardChatDetails);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _antd = require("antd");
var _emojiPickerReact = require("emoji-picker-react");
var _emojiPickerReactDefault = parcelHelpers.interopDefault(_emojiPickerReact);
var _icons = require("@ant-design/icons");
var _firestore = require("firebase/firestore");
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _reactQuery = require("@tanstack/react-query");
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
var _useGetTrainerClients = require("src/api/mutations/useGetTrainerClients");
var _firebaseStorage = require("src/api/services/firebaseStorage");
var _audioRecorder = require("src/components/AudioRecorder");
var _useDebounce = require("src/hooks/useDebounce");
var _useSearchChatMessages = require("src/api/queries/useSearchChatMessages");
var _reportIssueView = require("./components/ReportIssueModal/ReportIssueView");
var _mediaLinksFilesView = require("./components/MediaLinksFilesView/MediaLinksFilesView");
var _chatLinkCard = require("./components/ChatLinkCard/ChatLinkCard");
var _linkMetadata = require("./utils/linkMetadata");
var _fullScreenImageModal = require("src/components/Modals/FullScreenImageModal/FullScreenImageModal");
var _fullScreenVideoModal = require("src/components/Modals/FullScreenVideoModal/FullScreenVideoModal");
var _messageReadStatus = require("./components/MessageReadStatus");
var _messagesMoreMenuSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-conversion-menu/messages-more-menu.svg");
var _messagesMoreMenuCloseSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-conversion-menu/messages-more-menu-close.svg");
var _messagesViewClientProfileSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-conversion-menu/messages-view-client-profile.svg");
var _messagesSearchInConversationSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-conversion-menu/messages-search-in-conversation.svg");
var _messagesViewMediaLinksFilesSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-conversion-menu/messages-view-media-links-files.svg");
var _messagesReportAnIssueSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-conversion-menu/messages-report-an-issue.svg");
var _messagesInputAttachmentsSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-input/messages-input-attachments.svg");
var _messagesInputEmojiSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-input/messages-input-emoji.svg");
var _messagesInputImagesSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-input/messages-input-images.svg");
var _messagesInputRecordSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-input/messages-input-record.svg");
var _messagesInputSendSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-input/messages-input-send.svg");
var _resolvedCheckboxCheckedSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/resolved-checkbox-checked.svg");
var _resolvedCheckboxUncheckedSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/resolved-checkbox-unchecked.svg");
var _chatBackArrowSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/notifications/chat-back-arrow.svg");
var _chatSupportHeadsetSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/chat-support-headset.svg");
var _types = require("./types");
var _packageRequestBubble = require("./components/PackageRequestBubble/PackageRequestBubble");
var _packageOfferBubble = require("./components/PackageOfferBubble/PackageOfferBubble");
var _packageActiveBanner = require("./components/PackageActiveBanner/PackageActiveBanner");
var _sendFinalOfferModal = require("./components/SendFinalOfferModal/SendFinalOfferModal");
var _inviteFreeCallModal = require("./components/InviteFreeCallModal/InviteFreeCallModal");
var _freeCallInvitationBubble = require("./components/FreeCallInvitationBubble/FreeCallInvitationBubble");
var _useGetTrainerPackages = require("src/api/queries/useGetTrainerPackages");
var _useGetTrainerSchedule = require("src/api/queries/useGetTrainerSchedule");
var _dashboardChatDetailsScss = require("./DashboardChatDetails.scss");
const ALLOWED_IMAGE_TYPES = [
    'image/jpeg',
    'image/png',
    'image/webp',
    'image/gif',
    'image/heic',
    'image/heif',
    'image/avif',
    'image/svg+xml'
];
const MAX_IMAGE_SIZE_BYTES = 3145728; // 3 MB limit
const ALLOWED_VIDEO_TYPES = [
    'video/mp4',
    'video/quicktime',
    'video/webm',
    'video/x-m4v',
    'video/ogg',
    'video/3gpp'
];
const MAX_VIDEO_SIZE_BYTES = 52428800; // 50 MB limit
const MAX_MEDIA_COUNT = 5;
const ALLOWED_DOCUMENT_TYPES = [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'text/plain',
    'text/csv',
    'application/rtf'
];
const MAX_DOC_SIZE_BYTES = 3145728; // 3 MB limit
const MAX_DOCS_COUNT = 5;
function formatDocFileSize(bytes) {
    if (!bytes || bytes <= 0) return '0 B';
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1048576) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / 1048576).toFixed(1)} MB`;
}
const isPureImageExtension = (name, mime)=>{
    if (mime?.startsWith('image/')) return true;
    if (!name) return false;
    return /\.(jpe?g|png|webp|gif|avif|heic|heif|svg)$/i.test(name);
};
const isPureVideoExtension = (name, mime)=>{
    if (mime?.startsWith('video/')) return true;
    if (!name) return false;
    return /\.(mp4|mov|webm|m4v|ogg|ogv|3gp|mkv|avi)$/i.test(name);
};
const getDocTypeMeta = (fileName, mimeType)=>{
    const ext = fileName ? fileName.split('.').pop()?.toLowerCase() : '';
    const mime = mimeType?.toLowerCase() || '';
    if ([
        'mp4',
        'mov',
        'webm',
        'm4v',
        'avi',
        'mkv'
    ].includes(ext || '') || mime.startsWith('video/')) return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.PlayCircleFilled), {
            style: {
                color: '#f59e0b'
            }
        }),
        bg: 'rgba(245, 158, 11, 0.15)',
        color: '#f59e0b',
        label: ext ? ext.toUpperCase() : 'Video'
    };
    if (ext === 'pdf' || mime === 'application/pdf') return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FilePdfOutlined), {
            style: {
                color: '#ef4444'
            }
        }),
        bg: 'rgba(239, 68, 68, 0.15)',
        color: '#ef4444',
        label: 'PDF'
    };
    if ([
        'doc',
        'docx'
    ].includes(ext || '') || mime.includes('word') || mime.includes('officedocument.wordprocessingml')) return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FileWordOutlined), {
            style: {
                color: '#3b82f6'
            }
        }),
        bg: 'rgba(59, 130, 246, 0.15)',
        color: '#3b82f6',
        label: 'Word'
    };
    if ([
        'xls',
        'xlsx',
        'csv'
    ].includes(ext || '') || mime.includes('excel') || mime.includes('spreadsheetml') || mime === 'text/csv') return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FileExcelOutlined), {
            style: {
                color: '#10b981'
            }
        }),
        bg: 'rgba(16, 185, 129, 0.15)',
        color: '#10b981',
        label: ext === 'csv' ? 'CSV' : 'Excel'
    };
    if ([
        'ppt',
        'pptx'
    ].includes(ext || '') || mime.includes('presentation') || mime.includes('powerpoint')) return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FilePptOutlined), {
            style: {
                color: '#f97316'
            }
        }),
        bg: 'rgba(249, 115, 22, 0.15)',
        color: '#f97316',
        label: 'PPT'
    };
    if ([
        'zip',
        'rar',
        '7z',
        'tar',
        'gz'
    ].includes(ext || '') || mime.includes('zip') || mime.includes('compressed')) return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FileZipOutlined), {
            style: {
                color: '#a855f7'
            }
        }),
        bg: 'rgba(168, 85, 247, 0.15)',
        color: '#a855f7',
        label: 'Archive'
    };
    if ([
        'png',
        'jpg',
        'jpeg',
        'webp',
        'gif',
        'svg'
    ].includes(ext || '') || mime.startsWith('image/')) return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FileImageOutlined), {
            style: {
                color: '#06b6d4'
            }
        }),
        bg: 'rgba(6, 182, 212, 0.15)',
        color: '#06b6d4',
        label: ext ? ext.toUpperCase() : 'Image'
    };
    return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FileTextOutlined), {
            style: {
                color: '#60a5fa'
            }
        }),
        bg: 'rgba(96, 165, 250, 0.15)',
        color: '#60a5fa',
        label: ext ? ext.toUpperCase() : 'Document'
    };
};
const formatTimeWithAmPm = (timeStr)=>{
    if (!timeStr) return '';
    if (/AM|PM/i.test(timeStr)) return timeStr;
    const parts = timeStr.split(':');
    if (parts.length < 2) return timeStr;
    let hour = parseInt(parts[0], 10);
    const min = parts[1];
    if (isNaN(hour)) return timeStr;
    const ampm = hour >= 12 ? 'PM' : 'AM';
    hour = hour % 12 || 12;
    return `${hour}:${min} ${ampm}`;
};
function formatTrainerWeeklySchedule(weeklySchedule, timezone = 'Europe/London') {
    const dayConfigs = [
        {
            key: 'monday',
            label: 'Monday'
        },
        {
            key: 'tuesday',
            label: 'Tuesday'
        },
        {
            key: 'wednesday',
            label: 'Wednesday'
        },
        {
            key: 'thursday',
            label: 'Thursday'
        },
        {
            key: 'friday',
            label: 'Friday'
        },
        {
            key: 'saturday',
            label: 'Saturday'
        },
        {
            key: 'sunday',
            label: 'Sunday'
        }
    ];
    if (!weeklySchedule || typeof weeklySchedule !== 'object') return {
        isUniform: true,
        uniformText: "Monday to Friday \u2022 09:00 - 17:00",
        daysList: [
            {
                day: 'Monday',
                time: '09:00 - 17:00'
            },
            {
                day: 'Tuesday',
                time: '09:00 - 17:00'
            },
            {
                day: 'Wednesday',
                time: '09:00 - 17:00'
            },
            {
                day: 'Thursday',
                time: '09:00 - 17:00'
            },
            {
                day: 'Friday',
                time: '09:00 - 17:00'
            }
        ],
        timezone
    };
    const typedSchedule = weeklySchedule;
    const activeDaysWithTimes = [];
    dayConfigs.forEach((dayCfg, index)=>{
        const dayData = typedSchedule[dayCfg.key];
        if (dayData && dayData.enabled && Array.isArray(dayData.slots) && dayData.slots.length > 0) {
            const validSlots = dayData.slots.filter((s)=>typeof s.start === 'string' && typeof s.end === 'string' && Boolean(s.start.trim()) && Boolean(s.end.trim()));
            if (validSlots.length > 0) {
                const sorted = [
                    ...validSlots
                ].sort((a, b)=>(a.start || '').localeCompare(b.start || ''));
                const timeString = sorted.map((s)=>`${s.start} - ${s.end}`).join(', ');
                activeDaysWithTimes.push({
                    key: dayCfg.key,
                    dayIndex: index,
                    label: dayCfg.label,
                    timeString
                });
            }
        }
    });
    if (activeDaysWithTimes.length === 0) return {
        isUniform: true,
        uniformText: "Monday to Friday \u2022 09:00 - 17:00",
        daysList: [],
        timezone
    };
    const firstTimeString = activeDaysWithTimes[0].timeString;
    const isUniform = activeDaysWithTimes.every((d)=>d.timeString === firstTimeString);
    const daysList = activeDaysWithTimes.map((d)=>({
            day: d.label,
            time: d.timeString
        }));
    if (isUniform) {
        const isContiguous = activeDaysWithTimes.length > 1 && activeDaysWithTimes.every((d, i)=>i === 0 || d.dayIndex === activeDaysWithTimes[i - 1].dayIndex + 1);
        let rangeLabel = '';
        if (isContiguous) rangeLabel = `${activeDaysWithTimes[0].label} to ${activeDaysWithTimes[activeDaysWithTimes.length - 1].label}`;
        else if (activeDaysWithTimes.length === 1) rangeLabel = activeDaysWithTimes[0].label;
        else rangeLabel = activeDaysWithTimes.map((d)=>d.label).join(', ');
        return {
            isUniform: true,
            uniformText: `${rangeLabel} \u{2022} ${firstTimeString}`,
            daysList,
            timezone
        };
    }
    return {
        isUniform: false,
        uniformText: undefined,
        daysList,
        timezone
    };
}
const DashboardChatDetails = ()=>{
    const { chatId } = (0, _reactRouterDom.useParams)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const inquiryMessageId = searchParams.get('inquiryId');
    const currentUser = (0, _sessionStore.sessionStore)((state)=>state.currentUser);
    const trainerActualUid = (0, _firebase.auth).currentUser?.uid || currentUser?.uid || '';
    const [clientUid, setClientUid] = (0, _react.useState)('');
    const [messages, setMessages] = (0, _react.useState)([]);
    const [loading, setLoading] = (0, _react.useState)(true);
    const [inputText, setInputText] = (0, _react.useState)('');
    const [sending, setSending] = (0, _react.useState)(false);
    const [dropdownOpen, setDropdownOpen] = (0, _react.useState)(false);
    const [showEmojiPicker, setShowEmojiPicker] = (0, _react.useState)(false);
    const textareaRef = (0, _react.useRef)(null);
    const [expandedMessageIds, setExpandedMessageIds] = (0, _react.useState)({});
    const [isMobile, setIsMobile] = (0, _react.useState)(()=>typeof window !== 'undefined' ? window.innerWidth <= 768 : false);
    const [isSendOfferModalOpen, setIsSendOfferModalOpen] = (0, _react.useState)(false);
    const [isInviteCallModalOpen, setIsInviteCallModalOpen] = (0, _react.useState)(false);
    const [selectedRequestMessage, setSelectedRequestMessage] = (0, _react.useState)(null);
    const [isSendingOffer, setIsSendingOffer] = (0, _react.useState)(false);
    const [isSendingInvitation, setIsSendingInvitation] = (0, _react.useState)(false);
    const { data: trainerPackages = [] } = (0, _useGetTrainerPackages.useGetTrainerPackages)(trainerActualUid);
    const publishedPackages = (0, _react.useMemo)(()=>(trainerPackages || []).filter((p)=>p.status === 'published'), [
        trainerPackages
    ]);
    const { data: scheduleResponse } = (0, _useGetTrainerSchedule.useGetTrainerSchedule)(trainerActualUid);
    const trainerTimezone = scheduleResponse?.data?.timezone || currentUser?.timezone || 'Europe/London';
    const trainerFormattedSchedule = (0, _react.useMemo)(()=>{
        const weeklySchedule = scheduleResponse?.data?.weekly_schedule || currentUser?.weekly_schedule;
        return formatTrainerWeeklySchedule(weeklySchedule, trainerTimezone);
    }, [
        scheduleResponse,
        currentUser,
        trainerTimezone
    ]);
    (0, _react.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        const handleViewportChange = ()=>{
            const mobile = window.innerWidth <= 768;
            setIsMobile(mobile);
            if (mobile) {
                const vv = window.visualViewport;
                const currentHeight = vv ? vv.height : window.innerHeight;
                document.documentElement.style.setProperty('--chat-viewport-height', `${Math.round(currentHeight)}px`);
                // Keep page scroll strictly pinned to top (prevents mobile browser from shifting headers)
                if (window.scrollY !== 0 || window.scrollX !== 0) window.scrollTo(0, 0);
                if (document.body.scrollTop !== 0) document.body.scrollTop = 0;
                if (document.documentElement.scrollTop !== 0) document.documentElement.scrollTop = 0;
                const scrollable = document.getElementById('scrollableDashboardMain');
                if (scrollable && scrollable.scrollTop !== 0) scrollable.scrollTop = 0;
            } else document.documentElement.style.removeProperty('--chat-viewport-height');
        };
        handleViewportChange();
        window.addEventListener('resize', handleViewportChange);
        window.addEventListener('orientationchange', handleViewportChange);
        window.addEventListener('scroll', handleViewportChange, {
            passive: true
        });
        const vv = window.visualViewport;
        if (vv) {
            vv.addEventListener('resize', handleViewportChange);
            vv.addEventListener('scroll', handleViewportChange);
        }
        return ()=>{
            window.removeEventListener('resize', handleViewportChange);
            window.removeEventListener('orientationchange', handleViewportChange);
            window.removeEventListener('scroll', handleViewportChange);
            if (vv) {
                vv.removeEventListener('resize', handleViewportChange);
                vv.removeEventListener('scroll', handleViewportChange);
            }
            document.documentElement.style.removeProperty('--chat-viewport-height');
        };
    }, []);
    // Prevent pull-to-refresh and isolate scrolling strictly to the messages container on mobile
    (0, _react.useEffect)(()=>{
        if (typeof window === 'undefined') return;
        let touchStartY = 0;
        const handleTouchStart = (e)=>{
            touchStartY = e.touches[0].clientY;
            const container = messagesContainerRef.current;
            if (container) {
                // Avoid scroll chaining when starting at extremes
                if (container.scrollTop <= 0) container.scrollTop = 1;
                else if (container.scrollTop + container.clientHeight >= container.scrollHeight) container.scrollTop = container.scrollHeight - container.clientHeight - 1;
            }
        };
        const handleTouchMove = (e)=>{
            const target = e.target;
            if (!target) return;
            const container = messagesContainerRef.current;
            const isInsideMessages = container && (container === target || container.contains(target));
            const isInsideInput = target.closest('textarea, input, [contenteditable="true"]');
            if (!isInsideMessages && !isInsideInput) {
                // Any touch drag outside messages/inputs is cancelled to keep header and main container fixed
                if (e.cancelable) e.preventDefault();
                return;
            }
            if (isInsideMessages && container) {
                const currentY = e.touches[0].clientY;
                const isDraggingDown = currentY > touchStartY;
                // If at the very top and pulling down, prevent browser pull-to-refresh
                if (isDraggingDown && container.scrollTop <= 1 && e.cancelable) e.preventDefault();
            }
        };
        window.addEventListener('touchstart', handleTouchStart, {
            passive: true
        });
        window.addEventListener('touchmove', handleTouchMove, {
            passive: false
        });
        return ()=>{
            window.removeEventListener('touchstart', handleTouchStart);
            window.removeEventListener('touchmove', handleTouchMove);
        };
    }, []);
    const toggleExpandMessage = (msgId)=>{
        setExpandedMessageIds((prev)=>({
                ...prev,
                [msgId]: !prev[msgId]
            }));
    };
    (0, _react.useLayoutEffect)(()=>{
        const textarea = textareaRef.current;
        if (!textarea) return;
        // Reset before measuring so the textarea can shrink when text is removed.
        textarea.style.height = 'auto';
        const maxHeight = 140;
        const nextHeight = Math.max(24, Math.min(textarea.scrollHeight, maxHeight));
        textarea.style.height = `${nextHeight}px`;
        textarea.style.overflowY = textarea.scrollHeight > maxHeight ? 'auto' : 'hidden';
    }, [
        inputText
    ]);
    // Attached media (images & videos) state
    const [attachedMedia, setAttachedMedia] = (0, _react.useState)([]);
    const [mediaLimitWarning, setMediaLimitWarning] = (0, _react.useState)(null);
    const mediaFileInputRef = (0, _react.useRef)(null);
    // Attached documents state
    const [attachedDocs, setAttachedDocs] = (0, _react.useState)([]);
    const [docLimitWarning, setDocLimitWarning] = (0, _react.useState)(null);
    const docFileInputRef = (0, _react.useRef)(null);
    // Audio Recorder Hook (5-min max, 2-sec debounce)
    const audioRecorder = (0, _audioRecorder.useAudioRecorder)({
        maxDurationSeconds: 300,
        minDurationSeconds: 2,
        onMaxDurationReached: ()=>{
            (0, _reactHotToastDefault.default)('Maximum 5-minute recording limit reached.', {
                icon: "\u23F1\uFE0F"
            });
        }
    });
    // Search state
    const [isSearchActive, setIsSearchActive] = (0, _react.useState)(false);
    const [searchQuery, setSearchQuery] = (0, _react.useState)('');
    const debouncedSearchQuery = (0, _useDebounce.useDebounce)(searchQuery, 300);
    const [currentMatchIndex, setCurrentMatchIndex] = (0, _react.useState)(0);
    const [isFetchingContext, setIsFetchingContext] = (0, _react.useState)(false);
    const searchOptions = (0, _react.useMemo)(()=>({
            inquiryId: inquiryMessageId || undefined,
            excludeInquiries: !inquiryMessageId
        }), [
        inquiryMessageId
    ]);
    const { data: searchApiData, isFetching: isSearchingFullHistory } = (0, _useSearchChatMessages.useSearchChatMessages)(chatId || '', debouncedSearchQuery, isSearchActive, searchOptions);
    const isSearchActiveRef = (0, _react.useRef)(isSearchActive);
    const searchInputRef = (0, _react.useRef)(null);
    const attemptedMatchIdsRef = (0, _react.useRef)(new Set());
    const fetchingMatchIdRef = (0, _react.useRef)(null);
    const stableSearchMatchesRef = (0, _react.useRef)([]);
    const prevMatchesKeyRef = (0, _react.useRef)('');
    (0, _react.useEffect)(()=>{
        attemptedMatchIdsRef.current.clear();
        fetchingMatchIdRef.current = null;
        prevMatchesKeyRef.current = '';
        stableSearchMatchesRef.current = [];
    }, [
        debouncedSearchQuery,
        chatId,
        inquiryMessageId
    ]);
    (0, _react.useEffect)(()=>{
        isSearchActiveRef.current = isSearchActive;
        if (isSearchActive) setTimeout(()=>{
            searchInputRef.current?.focus?.({
                preventScroll: true
            });
            if (typeof window !== 'undefined') {
                window.scrollTo(0, 0);
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
                const scrollable = document.getElementById('scrollableDashboardMain');
                if (scrollable) scrollable.scrollTop = 0;
            }
        }, 50);
    }, [
        isSearchActive
    ]);
    const PAGE_SIZE = 10;
    const [messageLimit, setMessageLimit] = (0, _react.useState)(PAGE_SIZE);
    const [hasMore, setHasMore] = (0, _react.useState)(false);
    const [loadingEarlier, setLoadingEarlier] = (0, _react.useState)(false);
    const prevKnownMsgIdsRef = (0, _react.useRef)(new Set());
    const messagesContainerRef = (0, _react.useRef)(null);
    const prevScrollHeightRef = (0, _react.useRef)(0);
    const prevScrollTopRef = (0, _react.useRef)(0);
    const isLoadingEarlierRef = (0, _react.useRef)(false);
    const anchorMsgIdRef = (0, _react.useRef)(null);
    const anchorTopOffsetRef = (0, _react.useRef)(0);
    const anchorOldOffsetTopRef = (0, _react.useRef)(0);
    const isPrependingRef = (0, _react.useRef)(false);
    const loadCooldownRef = (0, _react.useRef)(false);
    const prevFirstMsgIdRef = (0, _react.useRef)(null);
    const [showReportView, setShowReportView] = (0, _react.useState)(false);
    const [activeView, setActiveView] = (0, _react.useState)('chat');
    const [initialMLFTab, setInitialMLFTab] = (0, _react.useState)('media');
    const [previewImageUrl, setPreviewImageUrl] = (0, _react.useState)(null);
    const [previewVideoUrl, setPreviewVideoUrl] = (0, _react.useState)(null);
    const [inquiryDoc, setInquiryDoc] = (0, _react.useState)(null);
    const messagesEndRef = (0, _react.useRef)(null);
    const isInitialLoadRef = (0, _react.useRef)(true);
    const hasUserScrolledRef = (0, _react.useRef)(false);
    (0, _react.useEffect)(()=>{
        setLoading(true);
        setMessages([]);
        setMessageLimit(PAGE_SIZE);
        setHasMore(false);
        setLoadingEarlier(false);
        isLoadingEarlierRef.current = false;
        isPrependingRef.current = false;
        loadCooldownRef.current = false;
        prevKnownMsgIdsRef.current = new Set();
        hasUserScrolledRef.current = false;
        isInitialLoadRef.current = true;
        prevFirstMsgIdRef.current = null;
        anchorMsgIdRef.current = null;
        anchorOldOffsetTopRef.current = 0;
    }, [
        chatId,
        inquiryMessageId
    ]);
    // Dedicated realtime listener for the specific inquiry document when viewing an inquiry
    (0, _react.useEffect)(()=>{
        if (!chatId || !inquiryMessageId) {
            setInquiryDoc(null);
            return;
        }
        const inqRef = (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages', inquiryMessageId);
        const unsubscribe = (0, _firestore.onSnapshot)(inqRef, (snap)=>{
            if (snap.exists()) {
                const data = snap.data();
                setInquiryDoc({
                    id: snap.id,
                    ...data,
                    send_uid: data.send_uid || data.sender_uid || '',
                    sender_uid: data.sender_uid || data.send_uid || ''
                });
            }
        }, (err)=>{
            console.error('Error listening to inquiry document:', err);
        });
        return ()=>unsubscribe();
    }, [
        chatId,
        inquiryMessageId
    ]);
    // Fallback clientUid from inquiry document if not already determined
    (0, _react.useEffect)(()=>{
        const inq = inquiryDoc;
        if (inq && trainerActualUid && !clientUid) {
            const senderUid = inq.sender_uid || inq.send_uid;
            const receiveUid = inq.receive_uid;
            const other = senderUid && senderUid !== trainerActualUid ? senderUid : receiveUid;
            if (other && other !== trainerActualUid) setClientUid(other);
        }
    }, [
        inquiryDoc,
        trainerActualUid,
        clientUid
    ]);
    // Query flutter_user for client profile fallback (especially for inquiries from prospective leads)
    const { data: flutterUserData } = (0, _reactQuery.useQuery)({
        queryKey: [
            'flutter-client-profile',
            clientUid
        ],
        queryFn: async ()=>{
            if (!clientUid) return null;
            try {
                const uSnap = await (0, _firestore.getDoc)((0, _firestore.doc)((0, _firebase.db), 'flutter_user', clientUid));
                if (uSnap.exists()) return uSnap.data();
            } catch (err) {
                console.warn('Failed to fetch flutter_user:', err);
            }
            return null;
        },
        enabled: !!clientUid,
        staleTime: 300000
    });
    // Get client details from existing hook
    const { data: clientsData } = (0, _useGetTrainerClients.useGetTrainerClients)('all', '', 'name_asc', 1, 1000);
    const clientInfo = clientsData?.clients.find((c)=>c.uid === clientUid);
    const [chatParentData, setChatParentData] = (0, _react.useState)(null);
    const isChatReadOnly = (0, _react.useMemo)(()=>{
        if (chatParentData?.is_unbound === true || chatParentData?.isUnbound === true || chatParentData?.is_active === false || chatParentData?.isActive === false) return true;
        if (clientInfo && (clientInfo.isActive === false || clientInfo.is_active === false)) return true;
        return false;
    }, [
        chatParentData,
        clientInfo
    ]);
    (0, _react.useEffect)(()=>{
        if (!chatId || !trainerActualUid) return;
        // Realtime listener on parent chat document to track participants and read-only status (is_unbound / is_active)
        const parentRef = (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId);
        const unsubscribeParent = (0, _firestore.onSnapshot)(parentRef, (parentSnap)=>{
            if (parentSnap.exists()) {
                const pData = parentSnap.data() || {};
                setChatParentData(pData);
                const participants = pData.participants || [];
                const otherUid = participants.find((p)=>p !== trainerActualUid) || participants[0] || trainerActualUid;
                if (otherUid) setClientUid(otherUid);
            } else {
                setChatParentData(null);
                const fallbackUid = chatId.split('_').find((id)=>id !== trainerActualUid) || chatId.split('_')[0] || trainerActualUid;
                setClientUid(fallbackUid);
            }
        }, (err)=>{
            console.error('Error listening to chat parent document:', err);
        });
        // Realtime Listener on messages subcollection (or inquiry_message subcollection if viewing an inquiry)
        const messagesRef = inquiryMessageId ? (0, _firestore.collection)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages', inquiryMessageId, 'inquiry_message') : (0, _firestore.collection)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages');
        const q = inquiryMessageId ? (0, _firestore.query)(messagesRef, (0, _firestore.orderBy)('send_time', 'asc')) : (0, _firestore.query)(messagesRef, (0, _firestore.orderBy)('send_time', 'asc'), (0, _firestore.limitToLast)(messageLimit));
        const unsubscribe = (0, _firestore.onSnapshot)(q, (snapshot)=>{
            const msgs = [];
            snapshot.forEach((d)=>{
                const data = d.data();
                msgs.push({
                    id: d.id,
                    ...data,
                    send_uid: data.send_uid || data.sender_uid || '',
                    sender_uid: data.sender_uid || data.send_uid || ''
                });
            });
            if (inquiryMessageId) msgs.sort((a, b)=>(0, _types.parseFirestoreDate)(a.send_time).getTime() - (0, _types.parseFirestoreDate)(b.send_time).getTime());
            // Capture scroll height and scroll top immediately before rendering prepended messages
            if (messagesContainerRef.current) {
                prevScrollHeightRef.current = messagesContainerRef.current.scrollHeight;
                prevScrollTopRef.current = messagesContainerRef.current.scrollTop;
            }
            setMessages((prev)=>{
                // Keep optimistic messages that haven't been confirmed by the server yet
                const pendingOptimistic = prev.filter((m)=>m.isOptimistic && !msgs.some((sm)=>sm.id === m.id));
                const combined = [
                    ...msgs,
                    ...pendingOptimistic
                ];
                // Re-sort combined array to ensure optimistic messages fall in correct chronological order
                combined.sort((a, b)=>(0, _types.parseFirestoreDate)(a.send_time).getTime() - (0, _types.parseFirestoreDate)(b.send_time).getTime());
                return combined;
            });
            setLoading(false);
            // If returned documents count equals messageLimit, there are more earlier messages
            const hasMoreEarlier = !inquiryMessageId && snapshot.docs.length >= messageLimit;
            setHasMore(hasMoreEarlier);
            // Reset trainer unread count on parent document
            const resetUnread = async ()=>{
                if (snapshot.empty) return;
                try {
                    const parentRef = (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId);
                    const batch = (0, _firestore.writeBatch)((0, _firebase.db));
                    batch.set(parentRef, {
                        [`unread_count_${trainerActualUid}`]: 0
                    }, {
                        merge: true
                    });
                    await batch.commit();
                } catch (error) {
                    console.error('Error resetting unread count:', error);
                }
            };
            resetUnread();
        }, (error)=>{
            console.error('Error listening to messages:', error);
            setLoading(false);
            setLoadingEarlier(false);
            isLoadingEarlierRef.current = false;
            isPrependingRef.current = false;
            loadCooldownRef.current = false;
        });
        return ()=>{
            unsubscribeParent();
            unsubscribe();
        };
    }, [
        chatId,
        trainerActualUid,
        messageLimit,
        inquiryMessageId
    ]);
    // In Direct Chat mode: only direct messages (exclude standalone inquiries and inquiry-linked replies)
    // In Inquiry mode: show ONLY the inquiry card and the replies specifically linked to this inquiry
    const displayMessages = (0, _react.useMemo)(()=>{
        let filtered = [];
        if (!inquiryMessageId) filtered = messages.filter((m)=>m.message_type !== 'inquiry' && !m.inquiry_id);
        else {
            const inqMsg = inquiryDoc;
            const threadReplies = messages.filter((m)=>!inqMsg || m.id !== inqMsg.id);
            filtered = inqMsg ? [
                inqMsg,
                ...threadReplies
            ] : threadReplies;
        }
        return [
            ...filtered
        ].sort((a, b)=>{
            const timeA = (0, _types.parseFirestoreDate)(a.send_time).getTime();
            const timeB = (0, _types.parseFirestoreDate)(b.send_time).getTime();
            return timeA - timeB;
        });
    }, [
        messages,
        inquiryMessageId,
        inquiryDoc
    ]);
    const lastMessageIdRef = (0, _react.useRef)('');
    (0, _react.useLayoutEffect)(()=>{
        if (!messagesContainerRef.current) return;
        const container = messagesContainerRef.current;
        const currentFirstId = displayMessages[0]?.id || null;
        const prevFirstId = prevFirstMsgIdRef.current;
        // Detect if new older messages were prepended to the rendered messages
        const hasPrependedBatch = Boolean(prevFirstId && currentFirstId && prevFirstId !== currentFirstId);
        if (hasPrependedBatch) {
            // Calculate the difference in scroll height before and after the new messages render
            const newScrollHeight = container.scrollHeight;
            const heightDifference = newScrollHeight - prevScrollHeightRef.current;
            // Adjust scrollTop accordingly to keep the scroll position completely stable
            if (heightDifference > 0) {
                const targetScrollTop = container.scrollTop > 0 ? container.scrollTop + heightDifference : prevScrollTopRef.current + heightDifference;
                container.scrollTop = targetScrollTop;
                // Double-check on next frame in case of dynamic reflow
                requestAnimationFrame(()=>{
                    if (container && Math.abs(container.scrollTop - targetScrollTop) > 2) container.scrollTop = targetScrollTop;
                });
            }
            isPrependingRef.current = false;
            isLoadingEarlierRef.current = false;
            anchorMsgIdRef.current = null;
            anchorOldOffsetTopRef.current = 0;
            setTimeout(()=>{
                setLoadingEarlier(false);
            }, 350);
            setTimeout(()=>{
                loadCooldownRef.current = false;
            }, 600);
        } else if (isInitialLoadRef.current && displayMessages.length > 0) {
            // Initial chat load: jump directly to bottom
            container.scrollTop = container.scrollHeight;
            setTimeout(()=>{
                isInitialLoadRef.current = false;
            }, 400);
        } else if (!isSearchActiveRef.current && displayMessages.length > 0) {
            // Check if a new message arrived at the bottom
            const latestMsg = displayMessages[displayMessages.length - 1];
            if (latestMsg && latestMsg.id !== lastMessageIdRef.current) {
                const isSentByTrainer = latestMsg.sender_role === 'trainer' || latestMsg.sender_uid === trainerActualUid || latestMsg.send_uid === trainerActualUid;
                const distanceFromBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
                const wasNearBottom = distanceFromBottom < 200;
                if (wasNearBottom || isSentByTrainer) {
                    if (isSentByTrainer) container.scrollTop = container.scrollHeight;
                    else container.scrollTo({
                        top: container.scrollHeight,
                        behavior: 'smooth'
                    });
                }
            }
        }
        if (displayMessages.length > 0) {
            lastMessageIdRef.current = displayMessages[displayMessages.length - 1].id;
            prevFirstMsgIdRef.current = displayMessages[0].id;
        }
        prevScrollHeightRef.current = container.scrollHeight;
        prevKnownMsgIdsRef.current = new Set(displayMessages.map((m)=>m.id));
    }, [
        displayMessages,
        trainerActualUid
    ]);
    const handleScroll = ()=>{
        if (!messagesContainerRef.current) return;
        const { scrollTop, scrollHeight, clientHeight } = messagesContainerRef.current;
        // Track when user scrolls up from the bottom
        if (scrollHeight - scrollTop - clientHeight > 80) hasUserScrolledRef.current = true;
        const isScrollable = scrollHeight > clientHeight + 40;
        // Automatically load older messages ONLY when:
        // 1. Content overflows (isScrollable)
        // 2. User has actively scrolled up from bottom
        // 3. User is near the top (< 120px)
        // 4. Older messages exist and initial load is settled
        // 5. Cooldown lock is not active
        if (isScrollable && hasUserScrolledRef.current && scrollTop < 120 && hasMore && !loadingEarlier && !isLoadingEarlierRef.current && !loadCooldownRef.current && !isPrependingRef.current && !isInitialLoadRef.current && !loading) {
            const containerRect = messagesContainerRef.current.getBoundingClientRect();
            let anchorId = null;
            let anchorTopOffset = 0;
            // Find the topmost visible message bubble in viewport before prepending
            for(let i = 0; i < displayMessages.length; i++){
                const msgEl = document.getElementById(`msg-${displayMessages[i].id}`);
                if (msgEl) {
                    const elRect = msgEl.getBoundingClientRect();
                    if (elRect.bottom > containerRect.top) {
                        anchorId = displayMessages[i].id;
                        anchorTopOffset = elRect.top - containerRect.top;
                        break;
                    }
                }
            }
            if (!anchorId && displayMessages.length > 0) {
                anchorId = displayMessages[0].id;
                const firstEl = document.getElementById(`msg-${displayMessages[0].id}`);
                if (firstEl) anchorTopOffset = firstEl.getBoundingClientRect().top - containerRect.top;
            }
            anchorMsgIdRef.current = anchorId;
            anchorTopOffsetRef.current = anchorTopOffset;
            isPrependingRef.current = true;
            loadCooldownRef.current = true;
            prevScrollHeightRef.current = scrollHeight;
            prevScrollTopRef.current = scrollTop;
            console.log('[ChatScroll] handleScroll TRIGGERED LOAD MORE:', {
                anchorId,
                anchorTopOffset,
                scrollHeight,
                scrollTop
            });
            isLoadingEarlierRef.current = true;
            setLoadingEarlier(true);
            setMessageLimit((prev)=>prev + PAGE_SIZE);
            // Safety timeout: ensure loading indicator never hangs indefinitely
            setTimeout(()=>{
                setLoadingEarlier(false);
                isLoadingEarlierRef.current = false;
                isPrependingRef.current = false;
            }, 2000);
        }
    };
    // Viewport detection to mark unread incoming messages as read
    const pendingReadIds = (0, _react.useRef)(new Set());
    const markTimeoutRef = (0, _react.useRef)(null);
    const flushMarkAsRead = (0, _react.useCallback)(async ()=>{
        if (pendingReadIds.current.size === 0 || !chatId || !trainerActualUid) return;
        const idsToUpdate = Array.from(pendingReadIds.current);
        pendingReadIds.current.clear();
        try {
            const batch = (0, _firestore.writeBatch)((0, _firebase.db));
            idsToUpdate.forEach((msgId)=>{
                const msgRef = inquiryMessageId ? msgId === inquiryMessageId ? (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages', inquiryMessageId) : (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages', inquiryMessageId, 'inquiry_message', msgId) : (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages', msgId);
                batch.update(msgRef, {
                    is_read: true,
                    read_time: (0, _firestore.serverTimestamp)(),
                    read_by: trainerActualUid
                });
            });
            if (!inquiryMessageId) {
                const parentRef = (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId);
                batch.set(parentRef, {
                    [`unread_count_${trainerActualUid}`]: 0
                }, {
                    merge: true
                });
            }
            await batch.commit();
        } catch (error) {
            console.error('Error marking messages as read:', error);
        }
    }, [
        chatId,
        trainerActualUid,
        inquiryMessageId
    ]);
    (0, _react.useEffect)(()=>{
        if (!chatId || !trainerActualUid || messages.length === 0) return;
        const pendingSet = pendingReadIds.current;
        const observer = new IntersectionObserver((entries)=>{
            if (typeof document !== 'undefined' && document.visibilityState !== 'visible') return;
            let hasNew = false;
            entries.forEach((entry)=>{
                if (entry.isIntersecting) {
                    const msgId = entry.target.getAttribute('data-message-id');
                    if (msgId) {
                        pendingSet.add(msgId);
                        hasNew = true;
                    }
                }
            });
            if (hasNew) {
                if (markTimeoutRef.current) clearTimeout(markTimeoutRef.current);
                markTimeoutRef.current = setTimeout(flushMarkAsRead, 300);
            }
        }, {
            threshold: 0.3
        });
        const unreadNodes = document.querySelectorAll('.message-bubble-wrapper.received[data-unread="true"]');
        unreadNodes.forEach((node)=>observer.observe(node));
        return ()=>{
            observer.disconnect();
            if (markTimeoutRef.current) clearTimeout(markTimeoutRef.current);
            pendingSet.clear();
        };
    }, [
        messages,
        chatId,
        trainerActualUid,
        flushMarkAsRead
    ]);
    // Current inquiry item
    const currentInquiry = (0, _react.useMemo)(()=>{
        if (inquiryMessageId) return inquiryDoc || messages.find((m)=>m.id === inquiryMessageId);
        return undefined;
    }, [
        messages,
        inquiryMessageId,
        inquiryDoc
    ]);
    // Mark inquiry message as read when trainer opens it
    (0, _react.useEffect)(()=>{
        if (inquiryMessageId && currentInquiry && !currentInquiry.is_read && chatId && trainerActualUid) {
            const markInquiryRead = async ()=>{
                try {
                    const inqRef = (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages', inquiryMessageId);
                    await (0, _firestore.updateDoc)(inqRef, {
                        is_read: true,
                        read_time: (0, _firestore.serverTimestamp)(),
                        read_by: trainerActualUid
                    });
                } catch (e) {
                    console.error('Error marking inquiry as read:', e);
                }
            };
            markInquiryRead();
        }
    }, [
        inquiryMessageId,
        currentInquiry,
        chatId,
        trainerActualUid
    ]);
    const isInquiryResolved = currentInquiry?.isResolve === true || currentInquiry?.status === 'resolved';
    const [showResolveConfirmModal, setShowResolveConfirmModal] = (0, _react.useState)(false);
    const [isUpdatingResolveStatus, setIsUpdatingResolveStatus] = (0, _react.useState)(false);
    const handleToggleResolveInquiry = ()=>{
        setShowResolveConfirmModal(true);
    };
    const handleConfirmToggleResolve = async ()=>{
        if (!chatId || !inquiryMessageId) return;
        const hasReplies = displayMessages.some((m)=>m.id !== inquiryMessageId);
        const nextResolved = !isInquiryResolved;
        const nextStatus = nextResolved ? 'resolved' : hasReplies ? 'replied' : 'reopened';
        try {
            setIsUpdatingResolveStatus(true);
            const msgRef = (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages', inquiryMessageId);
            const updatePayload = {
                isResolve: nextResolved,
                resolve_time: (0, _firestore.serverTimestamp)(),
                status: nextStatus,
                status_updated_at: (0, _firestore.serverTimestamp)(),
                status_updated_by: trainerActualUid
            };
            if (nextResolved) {
                updatePayload.resolved_at = (0, _firestore.serverTimestamp)();
                updatePayload.resolved_by = trainerActualUid;
            } else {
                updatePayload.resolved_at = null;
                updatePayload.resolved_by = null;
            }
            await (0, _firestore.updateDoc)(msgRef, updatePayload);
            (0, _reactHotToastDefault.default).success(nextResolved ? 'Inquiry marked as resolved' : 'Inquiry reopened');
            setShowResolveConfirmModal(false);
        } catch (e) {
            console.error('Error updating inquiry status:', e);
            (0, _reactHotToastDefault.default).error('Failed to update inquiry status');
        } finally{
            setIsUpdatingResolveStatus(false);
        }
    };
    // --- Search Logic (Ordered from newest / bottom-most to oldest) ---
    const searchMatches = (0, _react.useMemo)(()=>{
        if (!debouncedSearchQuery.trim()) return [];
        const qStr = debouncedSearchQuery.toLowerCase();
        let ids = [];
        if (searchApiData?.matches) // Backend returned results scoped to this conversation mode
        ids = searchApiData.matches.map((m)=>m.id);
        else // Optimistic in-memory matches from currently visible messages while search API is loading
        ids = [
            ...displayMessages
        ].reverse().filter((msg)=>{
            const bodyText = msg.body || msg.inquiryDetail || msg.inquirySubject || msg.inquiry_text || '';
            if (bodyText.toLowerCase().includes(qStr)) return true;
            if (msg.attachments && Array.isArray(msg.attachments)) return msg.attachments.some((a)=>a.file_name && a.file_name.toLowerCase().includes(qStr));
            return false;
        }).map((msg)=>msg.id);
        const key = ids.join('|');
        if (key === prevMatchesKeyRef.current) return stableSearchMatchesRef.current;
        prevMatchesKeyRef.current = key;
        stableSearchMatchesRef.current = ids;
        return ids;
    }, [
        searchApiData,
        displayMessages,
        debouncedSearchQuery
    ]);
    const jumpToMatch = (0, _react.useCallback)(async (matchId)=>{
        if (!matchId) return;
        const scrollToMatchElement = (target)=>{
            const container = messagesContainerRef.current;
            if (!container || !target) return;
            const containerRect = container.getBoundingClientRect();
            const elRect = target.getBoundingClientRect();
            const relativeTop = elRect.top - containerRect.top;
            const targetScrollTop = container.scrollTop + relativeTop - containerRect.height / 2 + elRect.height / 2;
            container.scrollTo({
                top: targetScrollTop,
                behavior: 'smooth'
            });
        };
        const el = document.getElementById(`msg-${matchId}`);
        if (el) {
            scrollToMatchElement(el);
            return;
        }
        // If already fetching this match or already attempted and not found in DOM, avoid redundant calls
        if (fetchingMatchIdRef.current === matchId || attemptedMatchIdsRef.current.has(matchId)) return;
        try {
            fetchingMatchIdRef.current = matchId;
            setIsFetchingContext(true);
            const res = await (0, _useSearchChatMessages.fetchMessageContextWindow)(chatId || '', matchId, 25);
            if (res.messages && res.messages.length > 0) {
                setMessages((prev)=>{
                    const existingIds = new Set(prev.map((m)=>m.id));
                    const newMsgs = res.messages.filter((m)=>!existingIds.has(m.id));
                    if (newMsgs.length === 0) return prev;
                    const merged = [
                        ...prev,
                        ...newMsgs
                    ];
                    merged.sort((a, b)=>(0, _types.parseFirestoreDate)(a.send_time).getTime() - (0, _types.parseFirestoreDate)(b.send_time).getTime());
                    return merged;
                });
                setTimeout(()=>{
                    const targetEl = document.getElementById(`msg-${matchId}`);
                    if (targetEl) scrollToMatchElement(targetEl);
                    else attemptedMatchIdsRef.current.add(matchId);
                }, 100);
            } else attemptedMatchIdsRef.current.add(matchId);
        } catch (err) {
            console.error('Error fetching context window for search match:', err);
            attemptedMatchIdsRef.current.add(matchId);
        } finally{
            fetchingMatchIdRef.current = null;
            setIsFetchingContext(false);
        }
    }, [
        chatId
    ]);
    (0, _react.useEffect)(()=>{
        if (isSearchActive && searchMatches.length > 0) {
            const matchId = searchMatches[currentMatchIndex];
            if (matchId) jumpToMatch(matchId);
        }
    }, [
        currentMatchIndex,
        searchMatches,
        isSearchActive,
        jumpToMatch
    ]);
    const escapeRegExp = (str)=>str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const renderHighlightedText = (text, highlight, keyPrefix = 'hl')=>{
        if (!text) return null;
        if (!highlight || !highlight.trim()) return text;
        const escaped = escapeRegExp(highlight.trim());
        const regex = new RegExp(`(${escaped})`, 'gi');
        const parts = text.split(regex);
        const cleanHighlight = highlight.trim().toLowerCase();
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
            children: parts.map((part, i)=>part.toLowerCase() === cleanHighlight ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("mark", {
                    className: "search-highlight",
                    children: part
                }, `${keyPrefix}-mark-${i}`) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                    children: part
                }, `${keyPrefix}-text-${i}`))
        }, `hl-frag-${keyPrefix}`);
    };
    // Mobile message length limit before showing Read More
    const MOBILE_MSG_CHAR_LIMIT = 240;
    const extractAllUrls = (text)=>{
        if (!text) return [];
        const matches = text.match(/https?:\/\/[^\s]+[^\s.,;:!?'")]|www\.[^\s]+[^\s.,;:!?'")]/gi);
        if (!matches) return [];
        const unique = [];
        const seen = new Set();
        matches.forEach((m)=>{
            const fullUrl = m.startsWith('http') ? m : `https://${m}`;
            const norm = fullUrl.toLowerCase().replace(/\/+$/, '');
            if (!seen.has(norm)) {
                seen.add(norm);
                unique.push(fullUrl);
            }
        });
        return unique;
    };
    // Clickable link renderer with search highlight and mobile Read More / Read Less support
    const renderMessageTextWithLinksAndHighlight = (text, highlight, msgId)=>{
        if (!text) return null;
        const isExpanded = msgId ? Boolean(expandedMessageIds[msgId]) : false;
        const shouldTruncateOnMobile = isMobile && !highlight && text.length > MOBILE_MSG_CHAR_LIMIT && !isExpanded;
        const displayText = shouldTruncateOnMobile ? `${text.slice(0, MOBILE_MSG_CHAR_LIMIT).trim()}...` : text;
        const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/gi;
        const parts = displayText.split(urlRegex);
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                parts.map((part, i)=>{
                    if (part.match(urlRegex)) {
                        const href = part.startsWith('http') ? part : `https://${part}`;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: href,
                            target: "_blank",
                            rel: "noopener noreferrer",
                            className: "chat-clickable-link",
                            onClick: (e)=>e.stopPropagation(),
                            children: part
                        }, `link-${i}`);
                    }
                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactDefault.default).Fragment, {
                        children: renderHighlightedText(part, highlight, `part-${i}`)
                    }, `part-${i}`);
                }),
                isMobile && !highlight && text.length > MOBILE_MSG_CHAR_LIMIT && msgId && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                    type: "button",
                    className: "chat-read-more-btn",
                    onClick: (e)=>{
                        e.stopPropagation();
                        toggleExpandMessage(msgId);
                    },
                    children: isExpanded ? 'Read less' : 'Read more'
                })
            ]
        });
    };
    const handleSendMessage = async ()=>{
        if (isChatReadOnly) {
            (0, _reactHotToastDefault.default).error('This conversation is read-only.');
            return;
        }
        const hasText = Boolean(inputText.trim());
        const hasAudio = Boolean(audioRecorder.audioBlob);
        const hasMedia = attachedMedia.length > 0;
        const hasDocs = attachedDocs.length > 0;
        if (!hasText && !hasAudio && !hasMedia && !hasDocs || !chatId || !trainerActualUid || !clientUid) return;
        if (hasMedia && attachedMedia.some((m)=>m.isUploading)) {
            (0, _reactHotToastDefault.default)('Please wait for photos/videos to finish uploading.', {
                icon: "\u23F3"
            });
            return;
        }
        if (hasDocs && attachedDocs.some((d)=>d.isUploading)) {
            (0, _reactHotToastDefault.default)('Please wait for files to finish uploading.', {
                icon: "\u23F3"
            });
            return;
        }
        if (inputText.length > 2000) {
            (0, _reactHotToastDefault.default).error('Message is too long. Please reduce the length.');
            return;
        }
        if (isMobile) {
            textareaRef.current?.blur();
            window.scrollTo(0, 0);
            if (document.body) document.body.scrollTop = 0;
            if (document.documentElement) document.documentElement.scrollTop = 0;
            const scrollable = document.getElementById('scrollableDashboardMain');
            if (scrollable) scrollable.scrollTop = 0;
        }
        setSending(true);
        const textToSend = inputText.trim();
        const recordedAudioBlob = audioRecorder.audioBlob;
        const recordedDuration = audioRecorder.duration;
        const currentAttachedMedia = [
            ...attachedMedia
        ];
        const currentAttachedDocs = [
            ...attachedDocs
        ];
        setInputText('');
        audioRecorder.clearAudio();
        setAttachedMedia([]);
        setAttachedDocs([]);
        setMediaLimitWarning(null);
        setDocLimitWarning(null);
        try {
            const mediaAttachments = currentAttachedMedia.filter((m)=>m.storageUrl).map((m)=>({
                    kind: 'media',
                    type: m.mediaType,
                    url: m.storageUrl,
                    storage_path: m.storagePath,
                    file_name: m.file.name,
                    mime_type: m.file.type || (m.mediaType === 'video' ? 'video/mp4' : 'image/jpeg'),
                    size_bytes: m.file.size,
                    size_label: formatDocFileSize(m.file.size)
                }));
            const docAttachments = currentAttachedDocs.filter((d)=>d.storageUrl).map((d)=>({
                    kind: 'file',
                    type: 'document',
                    url: d.storageUrl,
                    storage_path: d.storagePath,
                    file_name: d.file.name,
                    mime_type: d.file.type,
                    size_bytes: d.sizeBytes,
                    size_label: formatDocFileSize(d.sizeBytes)
                }));
            const hasVideos = mediaAttachments.some((m)=>m.type === 'video');
            const hasImages = mediaAttachments.some((m)=>m.type === 'image');
            const isMediaMessage = mediaAttachments.length > 0;
            const isDocMessage = docAttachments.length > 0;
            const isAudioMessage = Boolean(recordedAudioBlob);
            const messageType = isAudioMessage ? 'audio' : hasVideos && !hasImages ? 'video' : hasImages && !hasVideos ? 'image' : isMediaMessage ? 'video' : isDocMessage ? 'file' : 'text';
            const parentRef = (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId);
            const messagesRef = inquiryMessageId ? (0, _firestore.collection)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages', inquiryMessageId, 'inquiry_message') : (0, _firestore.collection)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages');
            const newMsgRef = (0, _firestore.doc)(messagesRef);
            const serverTime = (0, _firestore.serverTimestamp)();
            const unreadField = `unread_count_${clientUid}`;
            const trainerName = currentUser ? `${currentUser.name || currentUser.first_name || ''} ${currentUser.surname || currentUser.last_name || ''}`.trim() || (0, _firebase.auth).currentUser?.displayName || 'Trainer' : (0, _firebase.auth).currentUser?.displayName || 'Trainer';
            const trainerAvatar = currentUser?.avatarUrl || currentUser?.profile_picture_url || currentUser?.profilePicture || (0, _firebase.auth).currentUser?.photoURL || '';
            const clientName = clientInfo ? `${clientInfo.name || ''} ${clientInfo.surname || ''}`.trim() : currentInquiry?.sender_name || 'Client';
            const clientAvatar = clientInfo?.avatarUrl || clientInfo?.profile_picture || currentInquiry?.sender_avatar || '';
            const newMsgData = {
                sender_uid: trainerActualUid,
                receive_uid: clientUid,
                sender_role: 'trainer',
                receive_role: 'client',
                sender_name: trainerName,
                receive_name: clientName,
                sender_avatar: trainerAvatar,
                receive_avatar: clientAvatar,
                sender_gender: '1',
                receive_gender: '1',
                body: textToSend,
                message_type: messageType,
                send_time: serverTime,
                is_read: false,
                read_time: null
            };
            if (isMediaMessage) {
                newMsgData.media_url = mediaAttachments[0].url;
                newMsgData.attachments = mediaAttachments;
                if (hasVideos) {
                    newMsgData.file_name = mediaAttachments[0].file_name;
                    newMsgData.file_size = mediaAttachments[0].size_bytes;
                    newMsgData.size_label = mediaAttachments[0].size_label;
                }
            }
            if (isDocMessage) {
                newMsgData.media_url = docAttachments[0].url;
                newMsgData.file_name = docAttachments[0].file_name;
                newMsgData.file_size = docAttachments[0].size_bytes;
                newMsgData.size_label = docAttachments[0].size_label;
                newMsgData.attachments = docAttachments;
            }
            if (inquiryMessageId) newMsgData.inquiry_id = inquiryMessageId;
            const extractedLinks = extractAllUrls(textToSend);
            if (extractedLinks.length > 0) {
                const previews = extractedLinks.map((url)=>{
                    const linkMeta = (0, _linkMetadata.getInitialLinkMetadata)(url, textToSend);
                    return {
                        url: linkMeta.url,
                        title: linkMeta.title,
                        description: linkMeta.description,
                        domain: linkMeta.domain,
                        display_url: linkMeta.displayUrl,
                        type: linkMeta.type
                    };
                });
                newMsgData.link_previews = previews;
                newMsgData.link_preview = previews[0];
            }
            // 1. Instantly update UI before any network awaits
            const optimisticMsg = {
                id: newMsgRef.id,
                ...newMsgData,
                send_time: new Date().toISOString(),
                send_uid: trainerActualUid,
                isOptimistic: true
            };
            setMessages((prev)=>{
                if (prev.some((m)=>m.id === optimisticMsg.id)) return prev;
                return [
                    ...prev,
                    optimisticMsg
                ];
            });
            // 2. Now perform network operations
            let uploadedAudioUrl = null;
            if (recordedAudioBlob) {
                uploadedAudioUrl = await (0, _firebaseStorage.uploadChatAudio)(recordedAudioBlob, chatId, trainerActualUid);
                newMsgData.audio_url = uploadedAudioUrl;
                newMsgData.audio_duration_seconds = recordedDuration;
            }
            const batch = (0, _firestore.writeBatch)((0, _firebase.db));
            if (inquiryMessageId) {
                // Inquiry reply: write exclusively to inquiry_message subcollection
                batch.set(newMsgRef, newMsgData);
                // Update inquiry document status to 'replied' if not resolved
                const inqRef = (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages', inquiryMessageId);
                if (!isInquiryResolved) batch.update(inqRef, {
                    status: 'replied',
                    status_updated_at: serverTime,
                    status_updated_by: trainerActualUid
                });
            // In accordance with INQUIRY_DATA_FLOW.md, reply writes never touch parent conversation
            } else {
                // Direct conversation message: updates parent conversation metadata
                const parentSnap = await (0, _firestore.getDoc)(parentRef);
                if (!parentSnap.exists()) batch.set(parentRef, {
                    created_time: serverTime,
                    participants: [
                        trainerActualUid,
                        clientUid
                    ],
                    trainer_ids: [
                        trainerActualUid
                    ]
                });
                batch.set(newMsgRef, newMsgData);
                const parentUpdate = {
                    [unreadField]: (parentSnap.data()?.[unreadField] || 0) + 1
                };
                let snippet = textToSend;
                if (isAudioMessage) snippet = `\u{1F3A4} Voice note${textToSend ? ': ' + textToSend : ''}`;
                else if (isMediaMessage) {
                    const videoCount = mediaAttachments.filter((m)=>m.type === 'video').length;
                    const imageCount = mediaAttachments.filter((m)=>m.type === 'image').length;
                    let mediaLabel = 'Photo';
                    if (videoCount > 0 && imageCount === 0) mediaLabel = `\u{1F3A5} Video${videoCount > 1 ? ` (${videoCount})` : ''}`;
                    else if (imageCount > 0 && videoCount === 0) mediaLabel = `\u{1F4F7} Photo${imageCount > 1 ? ` (${imageCount})` : ''}`;
                    else mediaLabel = `\u{1F3AC} Media (${mediaAttachments.length})`;
                    snippet = `${mediaLabel}${textToSend ? ': ' + textToSend : ''}`;
                } else if (isDocMessage) snippet = `\u{1F4C4} ${docAttachments[0].file_name || 'Document'}${docAttachments.length > 1 ? ` (+${docAttachments.length - 1})` : ''}${textToSend ? ': ' + textToSend : ''}`;
                parentUpdate.last_message = {
                    ...newMsgData,
                    body: snippet,
                    send_time: serverTime
                };
                parentUpdate.last_message_time = serverTime;
                batch.set(parentRef, parentUpdate, {
                    merge: true
                });
            }
            await batch.commit();
        } catch (error) {
            console.error('Error sending message:', error);
            (0, _reactHotToastDefault.default).error('Failed to send message');
        } finally{
            setSending(false);
        }
    };
    const handleOpenDocumentTemplate = (docType)=>{
        window.open(`/onboarding-trainer/dashboard/profile?tab=packages&view=template&type=${docType}`, '_blank');
    };
    const handleConfirmSendOffer = async (offerData)=>{
        if (!chatId || !trainerActualUid || !clientUid) return;
        setIsSendingOffer(true);
        try {
            const parentRef = (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId);
            const messagesRef = (0, _firestore.collection)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages');
            const newMsgRef = (0, _firestore.doc)(messagesRef);
            const serverTime = (0, _firestore.serverTimestamp)();
            const unreadField = `unread_count_${clientUid}`;
            const trainerName = currentUser ? `${currentUser.name || currentUser.first_name || ''} ${currentUser.surname || currentUser.last_name || ''}`.trim() || (0, _firebase.auth).currentUser?.displayName || 'Trainer' : (0, _firebase.auth).currentUser?.displayName || 'Trainer';
            const trainerAvatar = currentUser?.avatarUrl || currentUser?.profile_picture_url || currentUser?.profilePicture || (0, _firebase.auth).currentUser?.photoURL || '';
            const clientName = clientInfo ? `${clientInfo.name || ''} ${clientInfo.surname || ''}`.trim() : currentInquiry?.sender_name || 'Client';
            const clientAvatar = clientInfo?.avatarUrl || clientInfo?.profile_picture || currentInquiry?.sender_avatar || '';
            const newMsgData = {
                sender_uid: trainerActualUid,
                receive_uid: clientUid,
                sender_role: 'trainer',
                receive_role: 'client',
                sender_name: trainerName,
                receive_name: clientName,
                sender_avatar: trainerAvatar,
                receive_avatar: clientAvatar,
                body: `Package Offer: ${offerData.pkg.name}`,
                message_type: 'package_offer',
                package_id: offerData.pkg.id,
                package_name: offerData.pkg.name,
                price: offerData.pkg.price,
                currency: offerData.pkg.currency || 'GBP',
                currency_symbol: offerData.pkg.currencySymbol || (offerData.pkg.currency === 'GBP' ? "\xa3" : '$'),
                duration: offerData.pkg.duration || '4 weeks',
                start_date: offerData.startDate,
                offer_status: 'awaiting_response',
                whats_included: offerData.whatsIncluded,
                attached_documents: [
                    {
                        id: 'checkin_policy',
                        title: 'Check-in policy',
                        type: 'checkin_policy'
                    },
                    {
                        id: 'contractual_terms',
                        title: 'Contractual terms',
                        type: 'contractual_terms'
                    },
                    {
                        id: 'cancellation_policy',
                        title: 'Cancellation and unused policy',
                        type: 'cancellation_policy'
                    }
                ],
                send_time: serverTime,
                is_read: false,
                read_time: null
            };
            // Optimistic UI update
            const optimisticMsg = {
                id: newMsgRef.id,
                ...newMsgData,
                send_time: new Date().toISOString(),
                send_uid: trainerActualUid,
                isOptimistic: true
            };
            setMessages((prev)=>{
                if (prev.some((m)=>m.id === optimisticMsg.id)) return prev;
                return [
                    ...prev,
                    optimisticMsg
                ];
            });
            const batch = (0, _firestore.writeBatch)((0, _firebase.db));
            const parentSnap = await (0, _firestore.getDoc)(parentRef);
            if (!parentSnap.exists()) batch.set(parentRef, {
                created_time: serverTime,
                participants: [
                    trainerActualUid,
                    clientUid
                ],
                trainer_ids: [
                    trainerActualUid
                ]
            });
            batch.set(newMsgRef, newMsgData);
            const parentUpdate = {
                [unreadField]: (parentSnap.data()?.[unreadField] || 0) + 1,
                last_message: {
                    ...newMsgData,
                    body: `\u{1F381} Offer sent: ${offerData.pkg.name}`,
                    send_time: serverTime
                },
                last_message_time: serverTime
            };
            batch.set(parentRef, parentUpdate, {
                merge: true
            });
            await batch.commit();
            setIsSendOfferModalOpen(false);
            (0, _reactHotToastDefault.default).success('Offer sent successfully!');
        } catch (err) {
            console.error('Error sending package offer:', err);
            (0, _reactHotToastDefault.default).error('Failed to send offer. Please try again.');
        } finally{
            setIsSendingOffer(false);
        }
    };
    const handleConfirmSendInvitation = async (invitationData)=>{
        if (!chatId || !trainerActualUid || !clientUid) return;
        setIsSendingInvitation(true);
        try {
            const parentRef = (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId);
            const messagesRef = (0, _firestore.collection)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages');
            const newMsgRef = (0, _firestore.doc)(messagesRef);
            const serverTime = (0, _firestore.serverTimestamp)();
            const unreadField = `unread_count_${clientUid}`;
            const trainerRecord = currentUser;
            const clientRecord = clientInfo;
            const trainerName = currentUser ? `${currentUser.name || trainerRecord?.first_name || ''} ${currentUser.surname || trainerRecord?.last_name || ''}`.trim() || (0, _firebase.auth).currentUser?.displayName || 'Trainer' : (0, _firebase.auth).currentUser?.displayName || 'Trainer';
            const trainerAvatar = currentUser?.avatarUrl || trainerRecord?.profile_picture_url || trainerRecord?.profilePicture || (0, _firebase.auth).currentUser?.photoURL || '';
            const clientName = clientInfo ? `${clientInfo.name || ''} ${clientInfo.surname || ''}`.trim() : currentInquiry?.sender_name || 'Client';
            const clientAvatar = clientInfo?.avatarUrl || clientRecord?.profile_picture || currentInquiry?.sender_avatar || '';
            const newMsgData = {
                sender_uid: trainerActualUid,
                receive_uid: clientUid,
                sender_role: 'trainer',
                receive_role: 'client',
                sender_name: trainerName,
                receive_name: clientName,
                sender_avatar: trainerAvatar,
                receive_avatar: clientAvatar,
                body: `Free Call Invitation: ${invitationData.callTitle}`,
                message_type: 'free_call_invitation',
                call_title: invitationData.callTitle,
                call_duration: '15-min',
                call_status: 'awaiting_response',
                trainer_schedule_summary: invitationData.scheduleSummary,
                trainer_timezone: invitationData.timezone,
                ...invitationData.scheduleDays && invitationData.scheduleDays.length > 0 ? {
                    trainer_schedule_days: invitationData.scheduleDays
                } : {},
                send_time: serverTime,
                is_read: false,
                read_time: null
            };
            // Optimistic UI update
            const optimisticMsg = {
                id: newMsgRef.id,
                ...newMsgData,
                send_time: new Date().toISOString(),
                send_uid: trainerActualUid,
                isOptimistic: true
            };
            setMessages((prev)=>{
                if (prev.some((m)=>m.id === optimisticMsg.id)) return prev;
                return [
                    ...prev,
                    optimisticMsg
                ];
            });
            const batch = (0, _firestore.writeBatch)((0, _firebase.db));
            const parentSnap = await (0, _firestore.getDoc)(parentRef);
            if (!parentSnap.exists()) batch.set(parentRef, {
                created_time: serverTime,
                participants: [
                    trainerActualUid,
                    clientUid
                ],
                trainer_ids: [
                    trainerActualUid
                ]
            });
            batch.set(newMsgRef, newMsgData);
            const parentUpdate = {
                [unreadField]: (parentSnap.data()?.[unreadField] || 0) + 1,
                last_message: {
                    ...newMsgData,
                    body: `\u{1F4DE} Free call invitation: ${invitationData.callTitle}`,
                    send_time: serverTime
                },
                last_message_time: serverTime
            };
            batch.set(parentRef, parentUpdate, {
                merge: true
            });
            await batch.commit();
            setIsInviteCallModalOpen(false);
            (0, _reactHotToastDefault.default).success('Invitation sent successfully!');
        } catch (err) {
            console.error('Error sending free call invitation:', err);
            (0, _reactHotToastDefault.default).error('Failed to send invitation. Please try again.');
        } finally{
            setIsSendingInvitation(false);
        }
    };
    const handleMediaFileChange = async (e)=>{
        const files = Array.from(e.target.files || []);
        if (isChatReadOnly || !files.length || !chatId || !trainerActualUid) return;
        if (mediaFileInputRef.current) mediaFileInputRef.current.value = '';
        // Mutual exclusivity: cancel/clear voice note if active
        if (audioRecorder.isRecording || audioRecorder.audioBlob) {
            audioRecorder.cancelRecording();
            audioRecorder.clearAudio();
        }
        const availableSlots = MAX_MEDIA_COUNT - attachedMedia.length;
        if (availableSlots <= 0) {
            setMediaLimitWarning(`Maximum of ${MAX_MEDIA_COUNT} photos/videos allowed per message.`);
            return;
        }
        if (files.length > availableSlots) setMediaLimitWarning(`Limit exceeded: Only ${availableSlots} of ${files.length} selected items were attached (max ${MAX_MEDIA_COUNT}).`);
        else setMediaLimitWarning(null);
        const filesToAdd = files.slice(0, availableSlots);
        const validItems = [];
        for (const file of filesToAdd){
            const isVideo = ALLOWED_VIDEO_TYPES.includes(file.type) || isPureVideoExtension(file.name, file.type);
            const isImage = !isVideo && (ALLOWED_IMAGE_TYPES.includes(file.type) || isPureImageExtension(file.name, file.type));
            if (!isVideo && !isImage) {
                (0, _reactHotToastDefault.default).error(`"${file.name}" is not a supported image or video format.`);
                continue;
            }
            if (isVideo) {
                if (file.size > MAX_VIDEO_SIZE_BYTES) {
                    (0, _reactHotToastDefault.default).error(`"${file.name}" exceeds the 50 MB limit for videos.`);
                    continue;
                }
                validItems.push({
                    id: crypto.randomUUID(),
                    file,
                    mediaType: 'video',
                    previewUrl: URL.createObjectURL(file),
                    isUploading: true
                });
            } else {
                if (file.size > MAX_IMAGE_SIZE_BYTES) {
                    (0, _reactHotToastDefault.default).error(`"${file.name}" exceeds the 3 MB limit for images.`);
                    continue;
                }
                validItems.push({
                    id: crypto.randomUUID(),
                    file,
                    mediaType: 'image',
                    previewUrl: URL.createObjectURL(file),
                    isUploading: true
                });
            }
        }
        if (!validItems.length) return;
        setAttachedMedia((prev)=>[
                ...prev,
                ...validItems
            ]);
        // Instant upload to Firebase Storage
        for (const item of validItems){
            const uploadPromise = item.mediaType === 'video' ? (0, _firebaseStorage.uploadChatVideo)(item.file, chatId, trainerActualUid) : (0, _firebaseStorage.uploadChatImage)(item.file, chatId, trainerActualUid);
            uploadPromise.then((res)=>{
                setAttachedMedia((prev)=>prev.map((m)=>m.id === item.id ? {
                            ...m,
                            storageUrl: res.url,
                            storagePath: res.filePath,
                            isUploading: false
                        } : m));
            }).catch((err)=>{
                console.error(`Error uploading chat ${item.mediaType}:`, err);
                (0, _reactHotToastDefault.default).error(`Failed to upload ${item.file.name}`);
                setAttachedMedia((prev)=>prev.map((m)=>m.id === item.id ? {
                            ...m,
                            isUploading: false,
                            uploadError: true
                        } : m));
            });
        }
    };
    const handleRemoveAttachedMedia = (item)=>{
        const targetPath = item.storagePath || item.storageUrl;
        if (targetPath) (0, _firebaseStorage.deleteChatMedia)(targetPath);
        URL.revokeObjectURL(item.previewUrl);
        setAttachedMedia((prev)=>{
            const remaining = prev.filter((m)=>m.id !== item.id);
            if (remaining.length < MAX_MEDIA_COUNT) setMediaLimitWarning(null);
            return remaining;
        });
    };
    const handleDocFileChange = async (e)=>{
        const files = Array.from(e.target.files || []);
        if (isChatReadOnly || !files.length || !chatId || !trainerActualUid) return;
        if (docFileInputRef.current) docFileInputRef.current.value = '';
        if (audioRecorder.isRecording || audioRecorder.audioBlob) {
            audioRecorder.cancelRecording();
            audioRecorder.clearAudio();
        }
        const availableSlots = MAX_DOCS_COUNT - attachedDocs.length;
        if (availableSlots <= 0) {
            setDocLimitWarning(`Maximum of ${MAX_DOCS_COUNT} files allowed per message.`);
            return;
        }
        if (files.length > availableSlots) setDocLimitWarning(`Limit exceeded: Only ${availableSlots} of ${files.length} selected files were attached (max ${MAX_DOCS_COUNT}).`);
        else setDocLimitWarning(null);
        const filesToAdd = files.slice(0, availableSlots);
        const validItems = [];
        for (const file of filesToAdd){
            const isAllowedDoc = ALLOWED_DOCUMENT_TYPES.includes(file.type) || /\.(pdf|docx?|xlsx?|pptx?|txt|csv|rtf)$/i.test(file.name);
            if (!isAllowedDoc) {
                (0, _reactHotToastDefault.default).error(`"${file.name}" format is not supported.`);
                continue;
            }
            if (file.size > MAX_DOC_SIZE_BYTES) {
                (0, _reactHotToastDefault.default).error(`"${file.name}" exceeds the 3 MB limit.`);
                continue;
            }
            validItems.push({
                id: crypto.randomUUID(),
                file,
                sizeBytes: file.size,
                isUploading: true
            });
        }
        if (!validItems.length) return;
        setAttachedDocs((prev)=>[
                ...prev,
                ...validItems
            ]);
        // Instant upload to Firebase Storage
        for (const item of validItems)(0, _firebaseStorage.uploadChatFile)(item.file, chatId, trainerActualUid).then((res)=>{
            setAttachedDocs((prev)=>prev.map((docItem)=>docItem.id === item.id ? {
                        ...docItem,
                        storageUrl: res.url,
                        storagePath: res.filePath,
                        isUploading: false
                    } : docItem));
        }).catch((err)=>{
            console.error('Error uploading chat doc:', err);
            (0, _reactHotToastDefault.default).error(`Failed to upload ${item.file.name}`);
            setAttachedDocs((prev)=>prev.map((docItem)=>docItem.id === item.id ? {
                        ...docItem,
                        isUploading: false,
                        uploadError: true
                    } : docItem));
        });
    };
    const handleRemoveAttachedDoc = (item)=>{
        const targetPath = item.storagePath || item.storageUrl;
        if (targetPath) (0, _firebaseStorage.deleteChatMedia)(targetPath);
        setAttachedDocs((prev)=>{
            const remaining = prev.filter((d)=>d.id !== item.id);
            if (remaining.length < MAX_DOCS_COUNT) setDocLimitWarning(null);
            return remaining;
        });
    };
    const handleEmojiClick = (emojiData)=>{
        const emoji = emojiData.emoji;
        if (textareaRef.current) {
            const { selectionStart, selectionEnd } = textareaRef.current;
            const text = inputText;
            const newText = text.substring(0, selectionStart) + emoji + text.substring(selectionEnd);
            setInputText(newText);
            setTimeout(()=>{
                if (textareaRef.current) {
                    textareaRef.current.focus();
                    const newPos = selectionStart + emoji.length;
                    textareaRef.current.setSelectionRange(newPos, newPos);
                }
            }, 0);
        } else setInputText((prev)=>prev + emoji);
    };
    const handleKeyDown = (e)=>{
        const isEnter = e.key === 'Enter' || e.code === 'Enter' || e.code === 'NumpadEnter' || e.keyCode === 13 || e.which === 13;
        // Shift + Enter on either main Enter or Keypad Enter -> new line
        if (isEnter && e.shiftKey) {
            e.preventDefault();
            const target = e.currentTarget;
            const start = target.selectionStart;
            const end = target.selectionEnd;
            const currentVal = target.value;
            const nextVal = currentVal.substring(0, start) + '\n' + currentVal.substring(end);
            setInputText(nextVal);
            setTimeout(()=>{
                target.selectionStart = target.selectionEnd = start + 1;
            }, 0);
            return;
        }
        // On mobile devices, Enter creates a new line (send via send button)
        const isMobile = typeof window !== 'undefined' && (window.innerWidth <= 768 || /iphone|ipad|ipod|android/i.test(navigator.userAgent));
        if (isMobile) return;
        // Regular Enter (without Shift/Alt/Ctrl/Cmd) -> Send message
        if (isEnter && !e.shiftKey && !e.altKey && !e.ctrlKey && !e.metaKey) {
            e.preventDefault();
            handleSendMessage();
        }
    };
    const handleMenuClick = (e)=>{
        setDropdownOpen(false);
        if (e.key === 'profile') {
            if (clientUid) navigate(`/onboarding-trainer/dashboard/clients/${clientUid}/client-profile`);
        } else if (e.key === 'search') {
            setIsSearchActive(true);
            setSearchQuery('');
            setCurrentMatchIndex(0);
        } else if (e.key === 'media_files_links') {
            if (chatId) {
                const targetUrl = inquiryMessageId ? `/onboarding-trainer/dashboard/messages/${chatId}/media?inquiryId=${inquiryMessageId}` : `/onboarding-trainer/dashboard/messages/${chatId}/media`;
                navigate(targetUrl);
            } else {
                setActiveView('media_files_links');
                setInitialMLFTab('media');
            }
        } else if (e.key === 'report') setShowReportView(true);
    };
    const moreMenuItems = [
        {
            key: 'profile',
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesViewClientProfileSvg.ReactComponent), {
                className: "dropdown-menu-icon"
            }),
            label: 'View client profile'
        },
        {
            key: 'search',
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesSearchInConversationSvg.ReactComponent), {
                className: "dropdown-menu-icon"
            }),
            label: 'Search in conversation'
        },
        {
            key: 'media_files_links',
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesViewMediaLinksFilesSvg.ReactComponent), {
                className: "dropdown-menu-icon"
            }),
            label: 'View Media, links & files'
        },
        {
            key: 'report',
            icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesReportAnIssueSvg.ReactComponent), {
                className: "dropdown-menu-icon"
            }),
            label: 'Report an issue'
        }
    ];
    const getInitials = (fullName)=>{
        if (!fullName) return 'C';
        const parts = fullName.trim().split(' ');
        if (parts.length > 1) return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
        return fullName.substring(0, 2).toUpperCase();
    };
    const isSupportChat = (0, _react.useMemo)(()=>{
        return Boolean(chatId && chatId.startsWith('support_')) || chatParentData?.is_support === true || chatParentData?.type === 'support' || messages.some((m)=>m.message_type === 'support' || m.is_support);
    }, [
        chatId,
        chatParentData,
        messages
    ]);
    const clientFullName = isSupportChat ? 'miniPT Support' : clientInfo ? `${clientInfo.name} ${clientInfo.surname}`.trim() : flutterUserData?.name ? `${flutterUserData.name} ${flutterUserData.surname || ''}`.trim() : currentInquiry?.sender_name || chatParentData?.client_name || chatParentData?.other_name || 'Client';
    const clientAvatarUrl = isSupportChat ? '' : clientInfo?.avatarUrl || flutterUserData?.avatar_url || flutterUserData?.avatar || flutterUserData?.profile_picture || currentInquiry?.sender_avatar || chatParentData?.client_avatar || '';
    const clientEmailDisplay = isSupportChat ? chatParentData?.support_email || 'support@minipt.co.uk' : clientInfo?.email?.trim() || flutterUserData?.email?.trim() || currentInquiry?.sender_email || currentInquiry?.client_email || chatParentData?.client_email || '';
    const groupMessagesByDate = ()=>{
        const groups = [];
        const today = new Date().toDateString();
        const yesterday = new Date(Date.now() - 86400000).toDateString();
        displayMessages.forEach((msg)=>{
            const msgDate = (0, _types.parseFirestoreDate)(msg.send_time);
            const dateString = msgDate.toDateString();
            let dateLabel = dateString;
            if (dateString === today) dateLabel = 'TODAY';
            else if (dateString === yesterday) dateLabel = 'YESTERDAY';
            else dateLabel = msgDate.toLocaleDateString([], {
                month: 'short',
                day: 'numeric',
                year: msgDate.getFullYear() !== new Date().getFullYear() ? 'numeric' : undefined
            });
            const lastGroup = groups[groups.length - 1];
            if (lastGroup && lastGroup.dateLabel === dateLabel) lastGroup.messages.push(msg);
            else groups.push({
                key: `date_group_${dateString}`,
                dateLabel,
                messages: [
                    msg
                ]
            });
        });
        return groups;
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "dashboard-chat-details",
        children: [
            inquiryMessageId && !isSupportChat ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "chat-header inquiry-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-left",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "back-button",
                                onClick: ()=>{
                                    navigate('/onboarding-trainer/dashboard/messages?tab=inquiries');
                                },
                                "aria-label": "Back to inquiries",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatBackArrowSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "client-info",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "client-avatar",
                                        style: {
                                            backgroundImage: clientAvatarUrl ? `url(${clientAvatarUrl})` : 'none'
                                        },
                                        children: !clientAvatarUrl && getInitials(clientFullName)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "client-name-email",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                children: clientFullName
                                            }),
                                            clientEmailDisplay && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: clientEmailDisplay
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "header-right",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: `mark-resolved-btn ${isInquiryResolved ? 'is-resolved' : ''}`,
                            onClick: handleToggleResolveInquiry,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "Mark as resolved"
                                }),
                                isInquiryResolved ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resolvedCheckboxCheckedSvg.ReactComponent), {
                                    className: "resolved-checkbox-icon"
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _resolvedCheckboxUncheckedSvg.ReactComponent), {
                                    className: "resolved-checkbox-icon"
                                })
                            ]
                        })
                    })
                ]
            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `chat-header ${(!inquiryMessageId || isSupportChat) && isSearchActive ? 'hidden-on-mobile-search' : ''}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-left",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "back-button",
                                onClick: ()=>{
                                    if (isSupportChat || inquiryMessageId || searchParams.get('tab') === 'inquiries') navigate('/onboarding-trainer/dashboard/messages?tab=inquiries');
                                    else navigate('/onboarding-trainer/dashboard/messages');
                                },
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatBackArrowSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "client-info",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: `client-avatar ${isSupportChat ? 'is-support-avatar' : ''}`,
                                        style: {
                                            backgroundImage: clientAvatarUrl ? `url(${clientAvatarUrl})` : 'none'
                                        },
                                        children: isSupportChat ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatSupportHeadsetSvg.ReactComponent), {
                                            className: "support-headset-icon"
                                        }) : !clientAvatarUrl && getInitials(clientFullName)
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "client-name-email",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                children: clientFullName
                                            }),
                                            clientEmailDisplay && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: clientEmailDisplay
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "header-right",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                            menu: {
                                items: moreMenuItems,
                                onClick: handleMenuClick
                            },
                            trigger: [
                                'click'
                            ],
                            placement: "bottomRight",
                            classNames: {
                                root: 'chat-header-dropdown-menu'
                            },
                            open: dropdownOpen,
                            onOpenChange: setDropdownOpen,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: "more-actions-button",
                                "aria-label": "More actions",
                                children: dropdownOpen ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesMoreMenuCloseSvg.ReactComponent), {
                                    className: "more-menu-btn-icon"
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesMoreMenuSvg.ReactComponent), {
                                    className: "more-menu-btn-icon"
                                })
                            })
                        })
                    })
                ]
            }),
            (!inquiryMessageId || isSupportChat) && isSearchActive && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "search-bar-container",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Input), {
                        ref: searchInputRef,
                        prefix: isSearchingFullHistory || isFetchingContext ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                            spin: true,
                            style: {
                                color: '#FFA100',
                                fontSize: 16
                            }
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.SearchOutlined), {}),
                        placeholder: "Search in conversation...",
                        value: searchQuery,
                        onChange: (e)=>{
                            setSearchQuery(e.target.value);
                            setCurrentMatchIndex(0);
                        },
                        onKeyDown: (e)=>{
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                if (searchMatches.length > 0) {
                                    if (e.shiftKey) // Shift+Enter goes to latest match (newer)
                                    setCurrentMatchIndex((prev)=>prev > 0 ? prev - 1 : searchMatches.length - 1);
                                    else // Enter goes to previous match (older)
                                    setCurrentMatchIndex((prev)=>prev < searchMatches.length - 1 ? prev + 1 : 0);
                                }
                            } else if (e.key === 'Escape') {
                                setIsSearchActive(false);
                                setSearchQuery('');
                                setCurrentMatchIndex(0);
                            }
                        },
                        autoFocus: true
                    }),
                    debouncedSearchQuery.trim() && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "search-controls",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "match-count",
                                children: isSearchingFullHistory ? 'Searching...' : isFetchingContext ? 'Loading...' : searchMatches.length > 0 ? `${currentMatchIndex + 1} of ${searchMatches.length}` : '0 matches'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Button), {
                                type: "text",
                                className: "search-nav-btn",
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LeftOutlined), {}),
                                disabled: searchMatches.length === 0 || currentMatchIndex >= searchMatches.length - 1 || isFetchingContext,
                                onClick: ()=>setCurrentMatchIndex((prev)=>Math.min(searchMatches.length - 1, prev + 1)),
                                title: "Previous message (Enter)"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Button), {
                                type: "text",
                                className: "search-nav-btn",
                                icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.RightOutlined), {}),
                                disabled: searchMatches.length === 0 || currentMatchIndex <= 0 || isFetchingContext,
                                onClick: ()=>setCurrentMatchIndex((prev)=>Math.max(0, prev - 1)),
                                title: "Latest message (Shift+Enter)"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Button), {
                        type: "text",
                        className: "search-close-btn",
                        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {}),
                        onClick: ()=>{
                            setIsSearchActive(false);
                            setSearchQuery('');
                            setCurrentMatchIndex(0);
                        },
                        title: "Close search (Esc)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `chat-floating-load-earlier ${loadingEarlier ? 'visible' : ''}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "load-more-loader-pill",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                            spin: true,
                            className: "loader-spin-icon"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "loader-text",
                            children: "Loading older messages..."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "chat-messages-container",
                ref: messagesContainerRef,
                onScroll: handleScroll,
                children: [
                    loading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "chat-loading-skeleton-container",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "skeleton-bubble-row received",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "skeleton-avatar"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "skeleton-bubble-content skeleton-w-55"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "skeleton-bubble-row sent",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "skeleton-bubble-content skeleton-w-40"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "skeleton-bubble-row received",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "skeleton-avatar"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "skeleton-bubble-content skeleton-w-70"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "skeleton-bubble-row sent",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "skeleton-bubble-content skeleton-w-45"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "skeleton-bubble-row received",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "skeleton-avatar"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "skeleton-bubble-content skeleton-w-60"
                                    })
                                ]
                            })
                        ]
                    }) : groupMessagesByDate().map((group)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "date-divider",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: group.dateLabel
                                    })
                                }),
                                group.messages.map((msg)=>{
                                    const isSupportMessage = msg.message_type === 'support' || msg.is_support === true;
                                    const isCheckin = msg.message_type === 'checkin';
                                    const isPackageRequest = msg.message_type === 'package_request';
                                    const isPackageOffer = msg.message_type === 'package_offer';
                                    const isFreeCallInvitation = msg.message_type === 'free_call_invitation';
                                    const isPackageActive = msg.message_type === 'package_active' || msg.message_type === 'package_activated';
                                    const isInquiry = !isSupportMessage && !isCheckin && !isPackageRequest && !isPackageOffer && !isFreeCallInvitation && !isPackageActive && (msg.message_type === 'inquiry' || !isSupportChat && msg.id === inquiryMessageId);
                                    const msgSenderUid = msg.sender_uid || msg.send_uid;
                                    const isSentByTrainer = msg.sender_role === 'trainer' || Boolean(msgSenderUid) && Boolean(trainerActualUid) && msgSenderUid === trainerActualUid || isSupportChat && isSupportMessage;
                                    const timeStr = msg.send_time ? (0, _types.parseFirestoreDate)(msg.send_time).toLocaleTimeString([], {
                                        hour: '2-digit',
                                        minute: '2-digit'
                                    }) : '';
                                    const isCurrentMatch = isSearchActive && searchMatches[currentMatchIndex] === msg.id;
                                    // Render Package Request Bubble (Figma Messages • Individual Messages-2)
                                    if (isPackageRequest) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        id: `msg-${msg.id}`,
                                        "data-message-id": msg.id,
                                        "data-unread": !isSentByTrainer && !msg.is_read,
                                        className: `message-bubble-wrapper ${isSentByTrainer ? 'sent' : 'received'} ${isCurrentMatch ? 'search-match-active' : ''}`,
                                        style: {
                                            maxWidth: '85%'
                                        },
                                        children: [
                                            !isSentByTrainer && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "message-sender-avatar",
                                                style: clientAvatarUrl ? {
                                                    backgroundImage: `url(${clientAvatarUrl})`
                                                } : {},
                                                children: !clientAvatarUrl && getInitials(clientFullName)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "message-content-box",
                                                style: {
                                                    width: '100%'
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _packageRequestBubble.PackageRequestBubble), {
                                                        message: msg,
                                                        onSendOffer: (m)=>{
                                                            setSelectedRequestMessage(m);
                                                            setIsSendOfferModalOpen(true);
                                                        },
                                                        onInviteFreeCall: (m)=>{
                                                            setSelectedRequestMessage(m);
                                                            setIsInviteCallModalOpen(true);
                                                        }
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "message-meta",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageReadStatus.MessageReadStatus), {
                                                                isRead: msg.is_read,
                                                                isSentByTrainer: isSentByTrainer
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: timeStr
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, msg.id);
                                    // Render Package Offer Bubble (Figma Messages • Individual Messages-5 & 6)
                                    if (isPackageOffer) {
                                        const hasSeparateActiveMsg = messages.some((m)=>m.message_type === 'package_active' || m.message_type === 'package_activated');
                                        const isOfferConfirmed = msg.offer_status === 'confirmed' || msg.offer_status === 'accepted' || msg.offer_status === 'active';
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _reactDefault.default).Fragment, {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    id: `msg-${msg.id}`,
                                                    "data-message-id": msg.id,
                                                    "data-unread": !isSentByTrainer && !msg.is_read,
                                                    className: `message-bubble-wrapper ${isSentByTrainer ? 'sent' : 'received'} ${isCurrentMatch ? 'search-match-active' : ''}`,
                                                    style: {
                                                        maxWidth: '85%'
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "message-content-box",
                                                        style: {
                                                            width: '100%'
                                                        },
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _packageOfferBubble.PackageOfferBubble), {
                                                                message: msg,
                                                                onOpenDocument: handleOpenDocumentTemplate
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "message-meta",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageReadStatus.MessageReadStatus), {
                                                                        isRead: msg.is_read,
                                                                        isSentByTrainer: isSentByTrainer
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        children: timeStr
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                }),
                                                isOfferConfirmed && !hasSeparateActiveMsg && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "package-active-message-wrapper",
                                                    style: {
                                                        width: '100%'
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _packageActiveBanner.PackageActiveBanner), {
                                                        message: msg,
                                                        clientName: clientFullName,
                                                        packageName: msg.package_name
                                                    })
                                                }, `active-banner-${msg.id}`)
                                            ]
                                        }, msg.id);
                                    }
                                    // Render Package Active Banner (Figma Messages • Individual Messages-6)
                                    if (isPackageActive) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        id: `msg-${msg.id}`,
                                        "data-message-id": msg.id,
                                        className: `package-active-message-wrapper ${isCurrentMatch ? 'search-match-active' : ''}`,
                                        style: {
                                            width: '100%'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _packageActiveBanner.PackageActiveBanner), {
                                            message: msg,
                                            clientName: clientFullName,
                                            packageName: msg.package_name
                                        })
                                    }, msg.id);
                                    // Render Free Call Invitation Bubble (Figma Messages • Individual Messages-3 & 4)
                                    if (isFreeCallInvitation) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        id: `msg-${msg.id}`,
                                        "data-message-id": msg.id,
                                        "data-unread": !isSentByTrainer && !msg.is_read,
                                        className: `message-bubble-wrapper ${isSentByTrainer ? 'sent' : 'received'} ${isCurrentMatch ? 'search-match-active' : ''}`,
                                        style: {
                                            maxWidth: '85%'
                                        },
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "message-content-box",
                                            style: {
                                                width: '100%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _freeCallInvitationBubble.FreeCallInvitationBubble), {
                                                    message: msg,
                                                    clientName: clientFullName
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "message-meta",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageReadStatus.MessageReadStatus), {
                                                            isRead: msg.is_read,
                                                            isSentByTrainer: isSentByTrainer
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: timeStr
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }, msg.id);
                                    // Render Support Card Bubble (Figma Dashboard-2)
                                    if (isSupportMessage) {
                                        const supportSubject = msg.subject || msg.inquirySubject || 'Support Request';
                                        const supportTopic = msg.topic || msg.inquiryType || msg.category || 'Billing & Subscription';
                                        const supportBody = msg.message || msg.body || msg.inquiryDetail || msg.inquiry_text || '';
                                        const attachmentsList = msg.attachments && msg.attachments.length > 0 ? msg.attachments : msg.media_url ? [
                                            {
                                                url: msg.media_url,
                                                thumbnail: msg.thumbnail,
                                                file_name: msg.file_name || 'attachment',
                                                size_label: msg.size_label || (typeof msg.file_size === 'string' ? msg.file_size : ''),
                                                mime_type: msg.mime_type || '',
                                                kind: 'image',
                                                type: 'image'
                                            }
                                        ] : [];
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            id: `msg-${msg.id}`,
                                            className: `message-bubble-wrapper ${isSentByTrainer ? 'sent' : 'received'} ${isCurrentMatch ? 'search-match-active' : ''}`,
                                            style: {
                                                maxWidth: '85%'
                                            },
                                            children: [
                                                !isSentByTrainer && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "message-sender-avatar is-support-avatar",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatSupportHeadsetSvg.ReactComponent), {
                                                        className: "support-headset-icon"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "message-content-box",
                                                    style: {
                                                        width: '100%'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "support-details-card",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "support-card-row",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "support-card-label",
                                                                            children: "SUBJECT"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "support-card-value font-medium",
                                                                            children: renderMessageTextWithLinksAndHighlight(supportSubject, isSearchActive ? debouncedSearchQuery : '', `${msg.id}_subject`)
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "support-card-divider"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "support-card-row",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "support-card-label",
                                                                            children: "TOPIC"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "support-card-value",
                                                                            children: supportTopic
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "support-card-divider"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "support-card-row",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "support-card-label",
                                                                            children: "MESSAGE"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "support-card-value",
                                                                            children: [
                                                                                renderMessageTextWithLinksAndHighlight(supportBody, isSearchActive ? debouncedSearchQuery : '', `${msg.id}_body`),
                                                                                (()=>{
                                                                                    const linkUrls = extractAllUrls(supportBody);
                                                                                    if (linkUrls.length > 0) {
                                                                                        const previews = msg.link_previews || (msg.link_preview ? [
                                                                                            msg.link_preview
                                                                                        ] : []);
                                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "chat-link-cards-stack",
                                                                                            children: linkUrls.map((linkUrl, idx)=>{
                                                                                                const preview = previews.find((p)=>p.url === linkUrl) || previews[idx];
                                                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatLinkCard.ChatLinkCard), {
                                                                                                    url: linkUrl,
                                                                                                    contextText: supportBody,
                                                                                                    initialTitle: preview?.title,
                                                                                                    initialDescription: preview?.description,
                                                                                                    variant: "message",
                                                                                                    isSentByTrainer: isSentByTrainer
                                                                                                }, `${msg.id}_support_link_${idx}`);
                                                                                            })
                                                                                        });
                                                                                    }
                                                                                    return null;
                                                                                })()
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                attachmentsList.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "support-card-divider"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "support-card-attachments",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "support-card-label",
                                                                                    children: "ATTACHMENTS"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "support-attachments-list",
                                                                                    children: attachmentsList.map((att, attIdx)=>{
                                                                                        const attUrl = att.url;
                                                                                        const attFileName = att.file_name || `attachment_${attIdx + 1}`;
                                                                                        const rawSize = att.size_label || (att.size_bytes ? `${(att.size_bytes / 1048576).toFixed(1)} MB` : typeof att.file_size === 'string' ? att.file_size : '');
                                                                                        const fileExt = attFileName.includes('.') ? attFileName.split('.').pop()?.toUpperCase() : '';
                                                                                        const attSize = rawSize ? fileExt && !rawSize.toUpperCase().includes(fileExt) ? `${rawSize} \xb7 ${fileExt}` : rawSize : fileExt || '';
                                                                                        const attMime = att.mime_type || '';
                                                                                        const isAttImage = att.kind === 'image' || att.type === 'image' || attMime.includes('image') || isPureImageExtension(attFileName, attMime);
                                                                                        const isAttVideo = att.kind === 'video' || att.type === 'video' || attMime.includes('video');
                                                                                        const isAttMedia = isAttImage || isAttVideo;
                                                                                        const meta = getDocTypeMeta(attFileName, attMime);
                                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                            className: "support-attachment-box",
                                                                                            onClick: ()=>{
                                                                                                if (isAttMedia) {
                                                                                                    if (isAttVideo) setPreviewVideoUrl(attUrl);
                                                                                                    else setPreviewImageUrl(attUrl);
                                                                                                } else if (attUrl) window.open(attUrl, '_blank');
                                                                                            },
                                                                                            role: "button",
                                                                                            tabIndex: 0,
                                                                                            children: [
                                                                                                isAttMedia ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                                    className: "support-attachment-thumb",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                            src: att.thumbnail || attUrl,
                                                                                                            alt: attFileName,
                                                                                                            onError: (e)=>{
                                                                                                                e.target.style.display = 'none';
                                                                                                            }
                                                                                                        }),
                                                                                                        isAttVideo && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                            className: "play-icon-overlay",
                                                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.PlayCircleFilled), {})
                                                                                                        })
                                                                                                    ]
                                                                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                    className: "doc-icon-wrapper",
                                                                                                    style: {
                                                                                                        background: meta.bg,
                                                                                                        marginRight: '0px'
                                                                                                    },
                                                                                                    children: meta.icon
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                                    className: "support-attachment-info",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                                            className: "support-attachment-name",
                                                                                                            children: attFileName
                                                                                                        }),
                                                                                                        attSize && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                                            className: "support-attachment-size",
                                                                                                            children: attSize
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }, `${msg.id}_att_${attIdx}`);
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "message-meta",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageReadStatus.MessageReadStatus), {
                                                                    isRead: msg.is_read,
                                                                    isSentByTrainer: isSentByTrainer
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: timeStr
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, msg.id);
                                    }
                                    // Render Check-in Card Bubble
                                    if (isCheckin) {
                                        const progress = msg.checkinProgress || '1';
                                        let statusLabel = 'Pending confirmation';
                                        let statusClass = 'pending';
                                        if (progress === '2') {
                                            statusLabel = msg.checkinNewSuggest ? 'Counter-Proposal' : 'New Time Proposed';
                                            statusClass = 'proposed';
                                        } else if (progress === '3') {
                                            statusLabel = 'Confirmed';
                                            statusClass = 'confirmed';
                                        } else if (progress === '4') {
                                            statusLabel = 'Attended';
                                            statusClass = 'attended';
                                        } else if (progress === '5') {
                                            statusLabel = 'Declined';
                                            statusClass = 'declined';
                                        } else if (progress === '6') {
                                            statusLabel = 'Cancelled';
                                            statusClass = 'cancelled';
                                        }
                                        const isOnline = msg.checkinType !== 'inPerson';
                                        const typeLabel = isOnline ? 'Online via Zoom' : 'In-person';
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            id: `msg-${msg.id}`,
                                            className: `message-bubble-wrapper received ${isCurrentMatch ? 'search-match-active' : ''}`,
                                            style: {
                                                maxWidth: '85%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "message-sender-avatar",
                                                    style: clientAvatarUrl ? {
                                                        backgroundImage: `url(${clientAvatarUrl})`
                                                    } : {},
                                                    children: !clientAvatarUrl && getInitials(clientFullName)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "message-content-box",
                                                    style: {
                                                        width: '100%'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "checkin-details-card",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "checkin-card-header",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "header-title-box",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CalendarOutlined), {
                                                                                    className: "calendar-icon"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "card-title",
                                                                                    children: "Check-in Session"
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: `checkin-status-pill ${statusClass}`,
                                                                            children: statusLabel
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "checkin-card-divider"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "checkin-card-body",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "checkin-card-row",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "checkin-card-label",
                                                                                    children: "Date & Time"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                    className: "checkin-card-value",
                                                                                    children: [
                                                                                        msg.checkinDate || "\u2014",
                                                                                        msg.checkinTime ? ` at ${formatTimeWithAmPm(msg.checkinTime)}` : ''
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "checkin-card-row",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "checkin-card-label",
                                                                                    children: "Meeting Type"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "checkin-card-value",
                                                                                    children: typeLabel
                                                                                })
                                                                            ]
                                                                        }),
                                                                        progress === '2' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "checkin-proposal-box",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "proposal-header",
                                                                                    children: msg.checkinNewSuggest ? 'Client requested another time:' : 'Trainer proposed alternative:'
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    className: "proposal-time",
                                                                                    children: [
                                                                                        msg.checkinNewDate || "\u2014",
                                                                                        msg.checkinNewTime ? ` at ${formatTimeWithAmPm(msg.checkinNewTime)}` : ''
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        progress === '3' && msg.zoomMeetingUrl && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "checkin-zoom-box",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "zoom-label",
                                                                                    children: "Zoom Link:"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                                                                    href: msg.zoomMeetingUrl,
                                                                                    target: "_blank",
                                                                                    rel: "noopener noreferrer",
                                                                                    className: "zoom-url",
                                                                                    children: msg.zoomMeetingUrl
                                                                                })
                                                                            ]
                                                                        }),
                                                                        progress === '5' && msg.checkinDeclinedReason && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "checkin-declined-box",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "decline-label",
                                                                                    children: "Decline Reason:"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                                    className: "decline-text",
                                                                                    children: [
                                                                                        "\u201C",
                                                                                        msg.checkinDeclinedReason,
                                                                                        "\u201D"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "checkin-card-footer",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                        type: "button",
                                                                        className: "btn-view-checkin",
                                                                        onClick: ()=>navigate(`/onboarding-trainer/dashboard/messages/checkin/${msg.id}`),
                                                                        children: "View Check-in Details"
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "message-meta",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageReadStatus.MessageReadStatus), {
                                                                    isRead: msg.is_read,
                                                                    isSentByTrainer: isSentByTrainer
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: timeStr
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, msg.id);
                                    }
                                    // Render Inquiry Card Bubble
                                    if (isInquiry) {
                                        const categoryName = msg.inquiryType || msg.category || msg.inquiry_category || 'General';
                                        const messageBody = msg.inquirySubject ? msg.inquiryDetail ? `${msg.inquirySubject}\n\n${msg.inquiryDetail}` : msg.inquirySubject : msg.inquiryDetail || msg.inquiry_text || (msg.body !== 'Inquiry sent' ? msg.body : '') || 'Inquiry sent';
                                        const inquiryAttachments = msg.attachments && msg.attachments.length > 0 ? msg.attachments : msg.media_url ? [
                                            {
                                                url: msg.media_url,
                                                thumbnail: msg.thumbnail,
                                                file_name: msg.file_name || 'Attachment',
                                                size_label: msg.size_label || (typeof msg.file_size === 'string' ? msg.file_size : ''),
                                                mime_type: msg.mime_type || '',
                                                kind: 'image',
                                                type: msg.message_type || 'image'
                                            }
                                        ] : [];
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            id: `msg-${msg.id}`,
                                            className: `message-bubble-wrapper received ${isCurrentMatch ? 'search-match-active' : ''}`,
                                            style: {
                                                maxWidth: '80%'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "message-sender-avatar",
                                                    style: clientAvatarUrl ? {
                                                        backgroundImage: `url(${clientAvatarUrl})`
                                                    } : {},
                                                    children: !clientAvatarUrl && getInitials(clientFullName)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "message-content-box",
                                                    style: {
                                                        width: '100%'
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "inquiry-details-card",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "inquiry-card-row",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "inquiry-card-label",
                                                                            children: "Category"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "inquiry-card-value",
                                                                            style: {
                                                                                textTransform: 'capitalize'
                                                                            },
                                                                            children: categoryName
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "inquiry-card-divider"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                    className: "inquiry-card-row",
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "inquiry-card-label",
                                                                            children: "Message"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                            className: "inquiry-card-value",
                                                                            children: [
                                                                                renderMessageTextWithLinksAndHighlight(messageBody, isSearchActive ? debouncedSearchQuery : '', msg.id),
                                                                                (()=>{
                                                                                    const linkUrls = extractAllUrls(messageBody);
                                                                                    if (linkUrls.length > 0) {
                                                                                        const previews = msg.link_previews || (msg.link_preview ? [
                                                                                            msg.link_preview
                                                                                        ] : []);
                                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                            className: "chat-link-cards-stack",
                                                                                            children: linkUrls.map((linkUrl, idx)=>{
                                                                                                const preview = previews.find((p)=>p.url === linkUrl) || previews[idx];
                                                                                                return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatLinkCard.ChatLinkCard), {
                                                                                                    url: linkUrl,
                                                                                                    contextText: messageBody,
                                                                                                    initialTitle: preview?.title,
                                                                                                    initialDescription: preview?.description,
                                                                                                    variant: "message",
                                                                                                    isSentByTrainer: false
                                                                                                }, `${msg.id}_inquiry_link_${idx}`);
                                                                                            })
                                                                                        });
                                                                                    }
                                                                                    return null;
                                                                                })()
                                                                            ]
                                                                        })
                                                                    ]
                                                                }),
                                                                inquiryAttachments.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "inquiry-card-divider"
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "inquiry-card-attachments",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "inquiry-card-label",
                                                                                    children: "Attachments"
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "inquiry-attachments-list",
                                                                                    style: {
                                                                                        display: 'flex',
                                                                                        flexDirection: 'column',
                                                                                        gap: '10px'
                                                                                    },
                                                                                    children: inquiryAttachments.map((att, attIdx)=>{
                                                                                        const attUrl = att.url;
                                                                                        const attFileName = att.file_name || `attachment_${attIdx + 1}`;
                                                                                        const attSize = att.size_label || (att.size_bytes ? `${(att.size_bytes / 1048576).toFixed(1)} MB` : typeof att.file_size === 'string' ? att.file_size : '');
                                                                                        const attMime = att.mime_type || '';
                                                                                        const isAttImage = att.kind === 'image' || att.type === 'image' || attMime.includes('image') || isPureImageExtension(attFileName, attMime);
                                                                                        const isAttVideo = att.kind === 'video' || att.type === 'video' || attMime.includes('video');
                                                                                        const isAttMedia = isAttImage || isAttVideo;
                                                                                        const meta = getDocTypeMeta(attFileName, attMime);
                                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                            className: "inquiry-attachment-box",
                                                                                            onClick: ()=>{
                                                                                                if (isAttMedia) {
                                                                                                    if (isAttVideo) setPreviewVideoUrl(attUrl);
                                                                                                    else setPreviewImageUrl(attUrl);
                                                                                                } else if (attUrl) window.open(attUrl, '_blank');
                                                                                            },
                                                                                            role: "button",
                                                                                            tabIndex: 0,
                                                                                            children: [
                                                                                                isAttMedia ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                                    className: "inquiry-attachment-thumb",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                                            src: att.thumbnail || attUrl,
                                                                                                            alt: attFileName,
                                                                                                            onError: (e)=>{
                                                                                                                e.target.style.display = 'none';
                                                                                                            }
                                                                                                        }),
                                                                                                        isAttVideo && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                            className: "play-icon-overlay",
                                                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.PlayCircleFilled), {})
                                                                                                        })
                                                                                                    ]
                                                                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                                    className: "doc-icon-wrapper",
                                                                                                    style: {
                                                                                                        background: meta.bg,
                                                                                                        marginRight: '0px'
                                                                                                    },
                                                                                                    children: meta.icon
                                                                                                }),
                                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                                    className: "inquiry-attachment-info",
                                                                                                    children: [
                                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                                            className: "inquiry-attachment-name",
                                                                                                            children: attFileName
                                                                                                        }),
                                                                                                        attSize && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                                            className: "inquiry-attachment-size",
                                                                                                            children: attSize
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        }, `${msg.id}_inquiry_att_${attIdx}`);
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "message-meta",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageReadStatus.MessageReadStatus), {
                                                                    isRead: msg.is_read,
                                                                    isSentByTrainer: isSentByTrainer
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: timeStr
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, msg.id);
                                    }
                                    // Audio Message Bubble
                                    if (msg.message_type === 'audio' || Boolean(msg.audio_url)) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        id: `msg-${msg.id}`,
                                        "data-message-id": msg.id,
                                        "data-unread": !isSentByTrainer && !msg.is_read,
                                        className: `message-bubble-wrapper ${isSentByTrainer ? 'sent' : 'received'} ${isCurrentMatch ? 'search-match-active' : ''}`,
                                        children: [
                                            !isSentByTrainer && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "message-sender-avatar",
                                                style: clientAvatarUrl ? {
                                                    backgroundImage: `url(${clientAvatarUrl})`
                                                } : {},
                                                children: !clientAvatarUrl && getInitials(clientFullName)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "message-content-box",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _audioRecorder.AudioMessageBubble), {
                                                    message: msg,
                                                    isSentByTrainer: isSentByTrainer,
                                                    timeStr: timeStr,
                                                    renderTextWithLinks: (text)=>renderMessageTextWithLinksAndHighlight(text, isSearchActive ? debouncedSearchQuery : '')
                                                })
                                            })
                                        ]
                                    }, msg.id);
                                    // Determine if it's purely a Media Message (Images / Videos) or Document Message
                                    const hasAttachments = Boolean(msg.attachments && msg.attachments.length > 0);
                                    // Document / File Message Bubble: Any message sent as 'file', 'pdf', or containing document attachments
                                    const hasDocAttachments = msg.message_type === 'file' || msg.message_type === 'pdf' || hasAttachments && msg.attachments.some((a)=>a.kind === 'file' || a.type === 'document' || !isPureImageExtension(a.file_name, a.mime_type) && !isPureVideoExtension(a.file_name, a.mime_type) && a.type !== 'image' && a.type !== 'video') || !hasAttachments && Boolean(msg.media_url) && !msg.audio_url && msg.message_type !== 'inquiry' && msg.message_type !== 'audio' && msg.message_type !== 'image' && msg.message_type !== 'video' && !isPureImageExtension(msg.file_name) && !isPureVideoExtension(msg.file_name);
                                    // Media Gallery: for message_type === 'image' | 'video' (or media attachments) and not a doc message
                                    const isMediaMsg = !hasDocAttachments && (msg.message_type === 'image' || msg.message_type === 'video' || hasAttachments && msg.attachments.every((a)=>a.kind === 'media' || a.type === 'image' || a.type === 'video' || isPureImageExtension(a.file_name, a.mime_type) || isPureVideoExtension(a.file_name, a.mime_type)) || !hasAttachments && Boolean(msg.media_url) && !msg.audio_url && msg.message_type !== 'inquiry' && msg.message_type !== 'audio' && (isPureImageExtension(msg.file_name) || isPureVideoExtension(msg.file_name)));
                                    if (hasDocAttachments) {
                                        const docAttachments = msg.attachments && msg.attachments.length > 0 ? msg.attachments : msg.media_url ? [
                                            {
                                                url: msg.media_url,
                                                kind: 'file',
                                                type: 'document',
                                                file_name: msg.file_name || 'Document',
                                                size_label: msg.size_label || (typeof msg.file_size === 'string' ? msg.file_size : undefined)
                                            }
                                        ] : [];
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            id: `msg-${msg.id}`,
                                            "data-message-id": msg.id,
                                            "data-unread": !isSentByTrainer && !msg.is_read,
                                            className: `message-bubble-wrapper doc-message-bubble-wrapper ${isSentByTrainer ? 'sent' : 'received'} ${isCurrentMatch ? 'search-match-active' : ''}`,
                                            children: [
                                                !isSentByTrainer && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "message-sender-avatar",
                                                    style: clientAvatarUrl ? {
                                                        backgroundImage: `url(${clientAvatarUrl})`
                                                    } : {},
                                                    children: !clientAvatarUrl && getInitials(clientFullName)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "message-content-box",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "doc-bubble-card",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "doc-items-container",
                                                                    children: docAttachments.map((att, idx)=>{
                                                                        const meta = getDocTypeMeta(att.file_name, att.mime_type);
                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                                            href: att.url,
                                                                            target: "_blank",
                                                                            rel: "noopener noreferrer",
                                                                            download: att.file_name || 'document',
                                                                            className: "chat-doc-item",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "doc-icon-wrapper",
                                                                                    style: {
                                                                                        background: meta.bg
                                                                                    },
                                                                                    children: meta.icon
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                                    className: "doc-info-wrapper",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                            className: "doc-name",
                                                                                            title: att.file_name,
                                                                                            children: att.file_name || 'Document'
                                                                                        }),
                                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                            className: "doc-size",
                                                                                            children: att.size_label || (att.size_bytes ? formatDocFileSize(att.size_bytes) : meta.label)
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "doc-download-icon",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.DownloadOutlined), {})
                                                                                })
                                                                            ]
                                                                        }, idx);
                                                                    })
                                                                }),
                                                                Boolean(msg.body && msg.body.trim()) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "doc-caption-text",
                                                                    children: renderMessageTextWithLinksAndHighlight(msg.body, isSearchActive ? debouncedSearchQuery : '', msg.id)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "message-meta",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageReadStatus.MessageReadStatus), {
                                                                    isRead: msg.is_read,
                                                                    isSentByTrainer: isSentByTrainer
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: timeStr
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, msg.id);
                                    }
                                    if (isMediaMsg) {
                                        const mediaAttachments = msg.attachments && msg.attachments.length > 0 ? msg.attachments.filter((a)=>a.kind === 'media' || a.type === 'image' || a.type === 'video' || isPureImageExtension(a.file_name, a.mime_type) || isPureVideoExtension(a.file_name, a.mime_type)) : msg.media_url ? [
                                            {
                                                url: msg.media_url,
                                                kind: 'media',
                                                type: msg.message_type === 'video' || isPureVideoExtension(msg.file_name) ? 'video' : 'image',
                                                file_name: msg.file_name,
                                                size_label: msg.size_label || (typeof msg.file_size === 'string' ? msg.file_size : undefined)
                                            }
                                        ] : [];
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            id: `msg-${msg.id}`,
                                            "data-message-id": msg.id,
                                            "data-unread": !isSentByTrainer && !msg.is_read,
                                            className: `message-bubble-wrapper image-message-bubble-wrapper ${isSentByTrainer ? 'sent' : 'received'} ${isCurrentMatch ? 'search-match-active' : ''}`,
                                            children: [
                                                !isSentByTrainer && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "message-sender-avatar",
                                                    style: clientAvatarUrl ? {
                                                        backgroundImage: `url(${clientAvatarUrl})`
                                                    } : {},
                                                    children: !clientAvatarUrl && getInitials(clientFullName)
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "message-content-box",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "image-bubble-card",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: `chat-images-grid-container count-${Math.min(mediaAttachments.length, 5)}`,
                                                                    children: mediaAttachments.map((att, idx)=>{
                                                                        const isVideoItem = att.type === 'video' || isPureVideoExtension(att.file_name, att.mime_type);
                                                                        if (isVideoItem) return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                            className: "chat-image-item chat-video-item",
                                                                            onClick: ()=>setPreviewVideoUrl(att.url),
                                                                            role: "button",
                                                                            tabIndex: 0,
                                                                            title: "Click to play video",
                                                                            children: [
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                                                                                    src: att.url,
                                                                                    preload: "metadata",
                                                                                    playsInline: true,
                                                                                    muted: true
                                                                                }),
                                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                                    className: "video-play-overlay",
                                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.PlayCircleFilled), {
                                                                                        className: "video-play-icon"
                                                                                    })
                                                                                }),
                                                                                (att.size_label || att.size_bytes) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                                    className: "video-duration-size-badge",
                                                                                    children: att.size_label || formatDocFileSize(att.size_bytes || 0)
                                                                                })
                                                                            ]
                                                                        }, idx);
                                                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                            className: "chat-image-item",
                                                                            onClick: ()=>setPreviewImageUrl(att.url),
                                                                            role: "button",
                                                                            tabIndex: 0,
                                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                                src: att.url,
                                                                                alt: att.file_name || 'attached image',
                                                                                loading: "lazy"
                                                                            })
                                                                        }, idx);
                                                                    })
                                                                }),
                                                                Boolean(msg.body && msg.body.trim()) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                    className: "image-caption-text",
                                                                    children: renderMessageTextWithLinksAndHighlight(msg.body, isSearchActive ? debouncedSearchQuery : '', msg.id)
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "message-meta",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageReadStatus.MessageReadStatus), {
                                                                    isRead: msg.is_read,
                                                                    isSentByTrainer: isSentByTrainer
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: timeStr
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, msg.id);
                                    }
                                    // Normal Chat Bubble
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        id: `msg-${msg.id}`,
                                        "data-message-id": msg.id,
                                        "data-unread": !isSentByTrainer && !msg.is_read,
                                        className: `message-bubble-wrapper ${isSentByTrainer ? 'sent' : 'received'} ${isCurrentMatch ? 'search-match-active' : ''}`,
                                        children: [
                                            !isSentByTrainer && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "message-sender-avatar",
                                                style: clientAvatarUrl ? {
                                                    backgroundImage: `url(${clientAvatarUrl})`
                                                } : {},
                                                children: !clientAvatarUrl && getInitials(clientFullName)
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "message-content-box",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "message-bubble",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "bubble-body",
                                                                children: renderMessageTextWithLinksAndHighlight(msg.body, isSearchActive ? debouncedSearchQuery : '', msg.id)
                                                            }),
                                                            (()=>{
                                                                const linkUrls = extractAllUrls(msg.body);
                                                                if (linkUrls.length > 0) {
                                                                    const previews = msg.link_previews || (msg.link_preview ? [
                                                                        msg.link_preview
                                                                    ] : []);
                                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "chat-link-cards-stack",
                                                                        children: linkUrls.map((linkUrl, idx)=>{
                                                                            const preview = previews.find((p)=>p.url === linkUrl) || previews[idx];
                                                                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatLinkCard.ChatLinkCard), {
                                                                                url: linkUrl,
                                                                                contextText: msg.body,
                                                                                initialTitle: preview?.title,
                                                                                initialDescription: preview?.description,
                                                                                variant: "message",
                                                                                isSentByTrainer: isSentByTrainer
                                                                            }, `${msg.id}_link_${idx}`);
                                                                        })
                                                                    });
                                                                }
                                                                return null;
                                                            })()
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "message-meta",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageReadStatus.MessageReadStatus), {
                                                                isRead: msg.is_read,
                                                                isSentByTrainer: isSentByTrainer
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: timeStr
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }, msg.id);
                                })
                            ]
                        }, group.key)),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        ref: messagesEndRef
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `chat-composer-container ${isChatReadOnly ? 'is-readonly' : ''} ${!inquiryMessageId && isSearchActive ? 'hidden-on-mobile-search' : ''}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        ref: mediaFileInputRef,
                        type: "file",
                        accept: [
                            ...ALLOWED_IMAGE_TYPES,
                            ...ALLOWED_VIDEO_TYPES
                        ].join(','),
                        multiple: true,
                        style: {
                            display: 'none'
                        },
                        onChange: handleMediaFileChange
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        ref: docFileInputRef,
                        type: "file",
                        accept: ALLOWED_DOCUMENT_TYPES.join(','),
                        multiple: true,
                        style: {
                            display: 'none'
                        },
                        onChange: handleDocFileChange
                    }),
                    isChatReadOnly ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "chat-composer-readonly",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LockOutlined), {
                                className: "readonly-icon"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "readonly-text",
                                children: "This conversation is read-only because the client relationship has ended."
                            })
                        ]
                    }) : audioRecorder.isRecording ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _audioRecorder.AudioRecorderInline), {
                        recorder: audioRecorder,
                        maxDurationSeconds: 300
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                        children: [
                            Boolean(audioRecorder.audioUrl) && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "composer-audio-preview-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _audioRecorder.AudioPlayer), {
                                        src: audioRecorder.audioUrl,
                                        durationSeconds: audioRecorder.duration,
                                        theme: "preview"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "delete-preview-btn",
                                        onClick: audioRecorder.clearAudio,
                                        title: "Discard voice note",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.DeleteOutlined), {})
                                    })
                                ]
                            }),
                            attachedMedia.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "composer-image-previews-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "composer-previews-scroll-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "composer-thumbnails-list",
                                                children: attachedMedia.map((m)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "attached-image-thumb-card attached-media-thumb-card",
                                                        onClick: ()=>{
                                                            const targetUrl = m.storageUrl || m.previewUrl;
                                                            if (m.mediaType === 'video') setPreviewVideoUrl(targetUrl);
                                                            else setPreviewImageUrl(targetUrl);
                                                        },
                                                        role: "button",
                                                        tabIndex: 0,
                                                        title: m.mediaType === 'video' ? 'Click to preview video' : 'Click to preview image',
                                                        children: [
                                                            m.mediaType === 'video' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "composer-video-thumb-wrapper",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                                                                        src: m.previewUrl,
                                                                        preload: "metadata",
                                                                        muted: true
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                        className: "composer-video-play-indicator",
                                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.PlayCircleFilled), {})
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: m.previewUrl,
                                                                alt: m.file.name
                                                            }),
                                                            m.isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "upload-overlay",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                                    spin: true
                                                                })
                                                            }),
                                                            m.uploadError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "upload-error-overlay",
                                                                title: "Failed to upload",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.WarningOutlined), {})
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                type: "button",
                                                                className: "remove-image-btn",
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    handleRemoveAttachedMedia(m);
                                                                },
                                                                title: "Remove",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
                                                            })
                                                        ]
                                                    }, m.id))
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: `images-count-pill ${attachedMedia.length >= MAX_MEDIA_COUNT ? 'limit-reached' : ''}`,
                                                children: [
                                                    attachedMedia.length,
                                                    " / ",
                                                    MAX_MEDIA_COUNT
                                                ]
                                            })
                                        ]
                                    }),
                                    mediaLimitWarning && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "composer-limit-warning-banner",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.WarningOutlined), {
                                                className: "warning-icon"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "warning-text",
                                                children: mediaLimitWarning
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "dismiss-warning-btn",
                                                onClick: ()=>setMediaLimitWarning(null),
                                                title: "Dismiss warning",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            attachedDocs.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "composer-doc-previews-container",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "composer-previews-scroll-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "composer-docs-list",
                                                children: attachedDocs.map((docItem)=>{
                                                    const meta = getDocTypeMeta(docItem.file.name, docItem.file.type);
                                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "attached-doc-card",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "doc-card-icon",
                                                                children: meta.icon
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "doc-card-info",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "doc-card-name",
                                                                        title: docItem.file.name,
                                                                        children: docItem.file.name
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "doc-card-size",
                                                                        children: formatDocFileSize(docItem.sizeBytes)
                                                                    })
                                                                ]
                                                            }),
                                                            docItem.isUploading && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "doc-upload-spin",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                                    spin: true
                                                                })
                                                            }),
                                                            docItem.uploadError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "doc-upload-error",
                                                                title: "Failed to upload",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.WarningOutlined), {})
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                type: "button",
                                                                className: "remove-doc-btn",
                                                                onClick: (e)=>{
                                                                    e.stopPropagation();
                                                                    handleRemoveAttachedDoc(docItem);
                                                                },
                                                                title: "Remove file",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
                                                            })
                                                        ]
                                                    }, docItem.id);
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: `docs-count-pill ${attachedDocs.length >= MAX_DOCS_COUNT ? 'limit-reached' : ''}`,
                                                children: [
                                                    attachedDocs.length,
                                                    " / ",
                                                    MAX_DOCS_COUNT
                                                ]
                                            })
                                        ]
                                    }),
                                    docLimitWarning && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "composer-limit-warning-banner",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.WarningOutlined), {
                                                className: "warning-icon"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "warning-text",
                                                children: docLimitWarning
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "dismiss-warning-btn",
                                                onClick: ()=>setDocLimitWarning(null),
                                                title: "Dismiss warning",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
                                            })
                                        ]
                                    })
                                ]
                            }),
                            inquiryMessageId && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "composer-inquiry-title mobile-only",
                                children: "Your response"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "chat-composer-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "chat-composer-input-pill",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                ref: textareaRef,
                                                className: "chat-textarea",
                                                placeholder: audioRecorder.audioBlob ? 'Add optional message with voice note...' : attachedMedia.length > 0 ? 'Add optional message with photos/videos...' : attachedDocs.length > 0 ? 'Add optional message with files...' : inquiryMessageId ? 'Write your response...' : 'Write a message...',
                                                value: inputText,
                                                onChange: (e)=>setInputText(e.target.value),
                                                onKeyDown: handleKeyDown,
                                                onFocus: ()=>{
                                                    if (typeof window !== 'undefined' && window.innerWidth <= 768) setTimeout(()=>{
                                                        window.scrollTo(0, 0);
                                                        if (document.body) document.body.scrollTop = 0;
                                                        if (document.documentElement) document.documentElement.scrollTop = 0;
                                                        const scrollable = document.getElementById('scrollableDashboardMain');
                                                        if (scrollable) scrollable.scrollTop = 0;
                                                        if (messagesContainerRef.current) messagesContainerRef.current.scrollTop = messagesContainerRef.current.scrollHeight;
                                                    }, 100);
                                                },
                                                onBlur: ()=>{
                                                    if (typeof window !== 'undefined' && window.innerWidth <= 768) {
                                                        window.scrollTo(0, 0);
                                                        if (document.body) document.body.scrollTop = 0;
                                                        if (document.documentElement) document.documentElement.scrollTop = 0;
                                                        const scrollable = document.getElementById('scrollableDashboardMain');
                                                        if (scrollable) scrollable.scrollTop = 0;
                                                    }
                                                },
                                                rows: 1
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Popover), {
                                                open: Boolean(audioRecorder.errorMessage),
                                                onOpenChange: (open)=>{
                                                    if (!open) audioRecorder.clearError();
                                                },
                                                placement: "topRight",
                                                trigger: [],
                                                color: "#111422",
                                                rootClassName: "mic-error-popover-overlay",
                                                overlayClassName: "mic-error-popover-overlay",
                                                content: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "mic-error-popover-content",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "mic-error-header",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.WarningOutlined), {
                                                                    className: "mic-error-icon"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "mic-error-title",
                                                                    children: "No microphone detected"
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    type: "button",
                                                                    className: "mic-error-close-btn",
                                                                    onClick: audioRecorder.clearError,
                                                                    title: "Dismiss",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "mic-error-desc",
                                                            children: audioRecorder.errorMessage || 'No microphone was detected on this device. Please connect a microphone and try again.'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "mic-error-actions",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                type: "button",
                                                                className: "mic-error-btn-dismiss",
                                                                onClick: audioRecorder.clearError,
                                                                children: "Got it"
                                                            })
                                                        })
                                                    ]
                                                }),
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Tooltip), {
                                                    title: audioRecorder.errorMessage ? '' : attachedMedia.length > 0 ? 'Remove attached photos/videos to record audio' : attachedDocs.length > 0 ? 'Remove attached files to record audio' : 'Record voice note',
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            className: "mic-icon-btn",
                                                            type: "button",
                                                            disabled: attachedMedia.length > 0 || attachedDocs.length > 0,
                                                            onClick: ()=>{
                                                                if (attachedMedia.length === 0 && attachedDocs.length === 0 && !audioRecorder.isRecording) {
                                                                    audioRecorder.clearError();
                                                                    audioRecorder.startRecording();
                                                                }
                                                            },
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesInputRecordSvg.ReactComponent), {})
                                                        })
                                                    })
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "composer-actions-outside",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Popover), {
                                                content: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "emoji-picker-popover-content",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emojiPickerReactDefault.default), {
                                                        theme: (0, _emojiPickerReact.Theme).DARK,
                                                        onEmojiClick: handleEmojiClick,
                                                        searchPlaceHolder: "Search emoji...",
                                                        width: 340,
                                                        height: 380,
                                                        lazyLoadEmojis: true,
                                                        previewConfig: {
                                                            showPreview: false
                                                        },
                                                        searchDisabled: false,
                                                        autoFocusSearch: false,
                                                        style: {
                                                            border: 'none',
                                                            backgroundColor: '#111422',
                                                            boxShadow: 'none',
                                                            '--epr-bg-color': '#111422',
                                                            '--epr-picker-border-color': 'transparent',
                                                            '--epr-search-input-padding': '0 32px 0 38px',
                                                            '--epr-search-bar-inner-padding': '12px'
                                                        }
                                                    })
                                                }),
                                                trigger: "click",
                                                open: showEmojiPicker,
                                                onOpenChange: setShowEmojiPicker,
                                                placement: "topLeft",
                                                overlayClassName: "chat-emoji-popover-overlay",
                                                arrow: false,
                                                destroyOnHidden: false,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Tooltip), {
                                                    title: "Emoji",
                                                    placement: "top",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: `action-icon-btn ${showEmojiPicker ? 'active' : ''}`,
                                                        type: "button",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesInputEmojiSvg.ReactComponent), {})
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Tooltip), {
                                                title: audioRecorder.isRecording || audioRecorder.audioBlob ? 'Remove voice note to attach photos/videos' : attachedDocs.length > 0 ? 'Remove attached files to attach photos/videos' : 'Attach photos or videos (max 5, photos up to 3MB, videos up to 50MB)',
                                                placement: "top",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: `action-icon-btn ${attachedMedia.length > 0 ? 'active-media' : ''}`,
                                                        type: "button",
                                                        disabled: audioRecorder.isRecording || Boolean(audioRecorder.audioBlob) || attachedDocs.length > 0,
                                                        onClick: ()=>{
                                                            if (!audioRecorder.isRecording && !audioRecorder.audioBlob && attachedDocs.length === 0) {
                                                                if (attachedMedia.length >= MAX_MEDIA_COUNT) {
                                                                    setMediaLimitWarning(`Maximum of ${MAX_MEDIA_COUNT} photos/videos allowed per message.`);
                                                                    return;
                                                                }
                                                                mediaFileInputRef.current?.click();
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesInputImagesSvg.ReactComponent), {})
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Tooltip), {
                                                title: attachedMedia.length > 0 ? 'Remove attached photos/videos to attach files' : audioRecorder.isRecording || audioRecorder.audioBlob ? 'Remove voice note to attach files' : 'Attach files (max 5, up to 3MB each)',
                                                placement: "top",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        className: `action-icon-btn ${attachedDocs.length > 0 ? 'active-media' : ''}`,
                                                        type: "button",
                                                        disabled: attachedMedia.length > 0 || audioRecorder.isRecording || Boolean(audioRecorder.audioBlob),
                                                        onClick: ()=>{
                                                            if (attachedMedia.length === 0 && !audioRecorder.isRecording && !audioRecorder.audioBlob) {
                                                                if (attachedDocs.length >= MAX_DOCS_COUNT) {
                                                                    setDocLimitWarning(`Maximum of ${MAX_DOCS_COUNT} files allowed per message.`);
                                                                    return;
                                                                }
                                                                docFileInputRef.current?.click();
                                                            }
                                                        },
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesInputAttachmentsSvg.ReactComponent), {})
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "composer-hint-mobile",
                                                children: inputText.length > 2000 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    style: {
                                                        color: '#ff4d4f',
                                                        fontWeight: '500'
                                                    },
                                                    children: [
                                                        "Limit exceeded (",
                                                        inputText.length,
                                                        "/2000)"
                                                    ]
                                                }) : 'Press Enter for new line'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        className: "send-button",
                                        onClick: handleSendMessage,
                                        disabled: !inputText.trim() && !audioRecorder.audioBlob && attachedMedia.length === 0 && attachedDocs.length === 0 || inputText.length > 2000 || sending || attachedMedia.some((m)=>m.isUploading) || attachedDocs.some((d)=>d.isUploading),
                                        type: "button",
                                        children: sending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "send-btn-icon-wrap",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messagesInputSendSvg.ReactComponent), {})
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "composer-footer-helper desktop-only",
                                style: {
                                    justifyContent: 'space-between'
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "Press Enter to send \xb7 Shift+Enter for new line"
                                    }),
                                    inputText.length > 2000 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        style: {
                                            color: '#ff4d4f',
                                            fontWeight: '500'
                                        },
                                        children: [
                                            "Character limit exceeded (",
                                            inputText.length,
                                            "/2000)"
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !inquiryMessageId && isSearchActive && debouncedSearchQuery.trim() && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mobile-search-bottom-bar mobile-only",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "search-nav-btn",
                        disabled: searchMatches.length === 0 || currentMatchIndex >= searchMatches.length - 1 || isFetchingContext,
                        onClick: ()=>setCurrentMatchIndex((prev)=>Math.min(searchMatches.length - 1, prev + 1)),
                        "aria-label": "Previous match (older)",
                        title: "Previous message (older)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LeftOutlined), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "search-match-text",
                        children: isSearchingFullHistory ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "Searching all history..."
                        }) : isFetchingContext ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "Loading message context..."
                        }) : searchMatches.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "current-match",
                                    children: currentMatchIndex + 1
                                }),
                                " of",
                                ' ',
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "total-matches",
                                    children: searchMatches.length
                                }),
                                " matches"
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: "0 matches"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "search-nav-btn",
                        disabled: searchMatches.length === 0 || currentMatchIndex <= 0 || isFetchingContext,
                        onClick: ()=>setCurrentMatchIndex((prev)=>Math.max(0, prev - 1)),
                        "aria-label": "Latest match (newer)",
                        title: "Latest message (newer)",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.RightOutlined), {})
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullScreenImageModal.FullScreenImageModal), {
                isOpen: Boolean(previewImageUrl),
                onClose: ()=>setPreviewImageUrl(null),
                imageUrl: previewImageUrl || ''
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullScreenVideoModal.FullScreenVideoModal), {
                isOpen: Boolean(previewVideoUrl),
                onClose: ()=>setPreviewVideoUrl(null),
                videoUrl: previewVideoUrl || ''
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
                open: showResolveConfirmModal,
                onCancel: ()=>!isUpdatingResolveStatus && setShowResolveConfirmModal(false),
                footer: null,
                closable: false,
                centered: true,
                width: 400,
                rootClassName: "logout-modal",
                className: "logout-modal",
                styles: {
                    mask: {
                        backdropFilter: 'blur(4px)',
                        backgroundColor: 'rgba(6, 7, 35, 0.8)'
                    }
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "logout-modal-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: isInquiryResolved ? 'Reopen inquiry?' : 'Mark as resolved?'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: isInquiryResolved ? 'Are you sure you want to unmark this inquiry as resolved and reopen it?' : 'Are you sure you want to mark this inquiry as resolved?'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "logout-actions",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-logout",
                                    onClick: handleConfirmToggleResolve,
                                    disabled: isUpdatingResolveStatus,
                                    style: {
                                        background: isInquiryResolved ? '#ffffff' : '#FFA100',
                                        color: '#04051B'
                                    },
                                    children: isUpdatingResolveStatus ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                        indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                            style: {
                                                fontSize: 16,
                                                color: '#04051B'
                                            },
                                            spin: true
                                        })
                                    }) : isInquiryResolved ? 'Reopen inquiry' : 'Mark as resolved'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    className: "btn-cancel",
                                    onClick: ()=>setShowResolveConfirmModal(false),
                                    disabled: isUpdatingResolveStatus,
                                    children: "Cancel"
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendFinalOfferModal.SendFinalOfferModal), {
                isOpen: isSendOfferModalOpen,
                onClose: ()=>setIsSendOfferModalOpen(false),
                publishedPackages: publishedPackages,
                initialPackageId: selectedRequestMessage?.package_id,
                initialStartDate: selectedRequestMessage?.start_date,
                onConfirmSend: handleConfirmSendOffer,
                onOpenDocument: handleOpenDocumentTemplate,
                isSending: isSendingOffer
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inviteFreeCallModal.InviteFreeCallModal), {
                isOpen: isInviteCallModalOpen,
                onClose: ()=>setIsInviteCallModalOpen(false),
                clientName: clientFullName,
                scheduleData: trainerFormattedSchedule,
                onChangeSchedule: ()=>{
                    setIsInviteCallModalOpen(false);
                    navigate('/onboarding-trainer/dashboard/profile?tab=settings&section=schedule');
                },
                onConfirmSend: handleConfirmSendInvitation,
                isSending: isSendingInvitation
            }),
            showReportView && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportIssueView.ReportIssueView), {
                chatId: chatId || '',
                trainerUid: trainerActualUid,
                clientUid: clientUid,
                onClose: ()=>setShowReportView(false),
                onBlocked: ()=>{
                    setShowReportView(false);
                    navigate('/onboarding-trainer/dashboard/messages', {
                        replace: true
                    });
                }
            }),
            activeView === 'media_files_links' && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mediaLinksFilesView.MediaLinksFilesView), {
                chatId: chatId,
                inquiryId: inquiryMessageId || undefined,
                messages: messages,
                initialTab: initialMLFTab,
                onBack: ()=>setActiveView('chat')
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["useNavigate","f3cgC"],["useSearchParams","f3cgC"],["useParams","9oT3O"]],"antd":[["Button","8HvYt","default"],["Dropdown","cMU6A","default"],["Input","ajgzU","default"],["Modal","kY4DD","default"],["Popover","gV90n","default"],["Spin","lVvhl","default"],["Tooltip","aByoO","default"]],"emoji-picker-react":"eNAcf","@ant-design/icons":[["CalendarOutlined","2q2RO","default"],["CloseOutlined","dinn5","default"],["DeleteOutlined","hgODG","default"],["DownloadOutlined","2dIdb","default"],["FileExcelOutlined","3eyJq","default"],["FileImageOutlined","17Uhv","default"],["FilePdfOutlined","iSC34","default"],["FilePptOutlined","78Duw","default"],["FileTextOutlined","ioDdZ","default"],["FileWordOutlined","9K7Ru","default"],["FileZipOutlined","4k6yg","default"],["LeftOutlined","8erTV","default"],["LoadingOutlined","8Mvdh","default"],["LockOutlined","99y1M","default"],["PlayCircleFilled","eZwrA","default"],["RightOutlined","lRGzb","default"],["SearchOutlined","iN0sG","default"],["WarningOutlined","3SwL4","default"]],"firebase/firestore":"5IgBQ","react-hot-toast":"3T0Wh","@tanstack/react-query":"lWWNx","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","src/api/mutations/useGetTrainerClients":"18nHc","src/api/services/firebaseStorage":"cCllM","src/components/AudioRecorder":"a4h8g","src/hooks/useDebounce":"fxOsA","src/api/queries/useSearchChatMessages":"7jdsU","./components/ReportIssueModal/ReportIssueView":"5s2pW","./components/MediaLinksFilesView/MediaLinksFilesView":"2iBPl","./components/ChatLinkCard/ChatLinkCard":"76qqG","./utils/linkMetadata":"f8rqC","src/components/Modals/FullScreenImageModal/FullScreenImageModal":"7dgg4","src/components/Modals/FullScreenVideoModal/FullScreenVideoModal":"gcrID","./components/MessageReadStatus":"jJM9L","src/assets/images/onboarding-trainer/dashboard/messages/chat-conversion-menu/messages-more-menu.svg":"fJ0Ml","src/assets/images/onboarding-trainer/dashboard/messages/chat-conversion-menu/messages-more-menu-close.svg":"ezAus","src/assets/images/onboarding-trainer/dashboard/messages/chat-conversion-menu/messages-view-client-profile.svg":"1SHjQ","src/assets/images/onboarding-trainer/dashboard/messages/chat-conversion-menu/messages-search-in-conversation.svg":"jvvsg","src/assets/images/onboarding-trainer/dashboard/messages/chat-conversion-menu/messages-view-media-links-files.svg":"igPRg","src/assets/images/onboarding-trainer/dashboard/messages/chat-conversion-menu/messages-report-an-issue.svg":"gaCVc","src/assets/images/onboarding-trainer/dashboard/messages/chat-input/messages-input-attachments.svg":"lsBTX","src/assets/images/onboarding-trainer/dashboard/messages/chat-input/messages-input-emoji.svg":"aFKr4","src/assets/images/onboarding-trainer/dashboard/messages/chat-input/messages-input-images.svg":"1z8Js","src/assets/images/onboarding-trainer/dashboard/messages/chat-input/messages-input-record.svg":"lS0fr","src/assets/images/onboarding-trainer/dashboard/messages/chat-input/messages-input-send.svg":"lwAh0","src/assets/images/onboarding-trainer/dashboard/messages/resolved-checkbox-checked.svg":"j3gen","src/assets/images/onboarding-trainer/dashboard/messages/resolved-checkbox-unchecked.svg":"4nA6G","src/assets/images/onboarding-trainer/dashboard/messages/notifications/chat-back-arrow.svg":"joY4z","src/assets/images/onboarding-trainer/dashboard/messages/chat-support-headset.svg":"lkX2A","./types":"61hYx","./components/PackageRequestBubble/PackageRequestBubble":"h0Vpi","./components/PackageOfferBubble/PackageOfferBubble":"k8mjc","./components/PackageActiveBanner/PackageActiveBanner":"42Yuo","./components/SendFinalOfferModal/SendFinalOfferModal":"5uESC","./components/InviteFreeCallModal/InviteFreeCallModal":"bhbAM","./components/FreeCallInvitationBubble/FreeCallInvitationBubble":"bCp6L","src/api/queries/useGetTrainerPackages":"1t4gF","src/api/queries/useGetTrainerSchedule":"2n68F","./DashboardChatDetails.scss":"blYZQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gV90n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("@rc-component/util");
var _keyCode = require("@rc-component/util/es/KeyCode");
var _keyCodeDefault = parcelHelpers.interopDefault(_keyCode);
var _clsx = require("clsx");
var _getRenderPropValue = require("../_util/getRenderPropValue");
var _hooks = require("../_util/hooks");
var _motion = require("../_util/motion");
var _reactNode = require("../_util/reactNode");
var _context = require("../config-provider/context");
var _tooltip = require("../tooltip");
var _tooltipDefault = parcelHelpers.interopDefault(_tooltip);
var _useMergedArrow = require("../tooltip/hook/useMergedArrow");
var _useMergedArrowDefault = parcelHelpers.interopDefault(_useMergedArrow);
var _purePanel = require("./PurePanel");
var _purePanelDefault = parcelHelpers.interopDefault(_purePanel);
// CSSINJS
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const InternalPopover = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { prefixCls: customizePrefixCls, title, content, overlayClassName, placement = 'top', trigger, children, mouseEnterDelay = 0.1, mouseLeaveDelay = 0.1, onOpenChange, overlayStyle = {}, styles, classNames, motion, arrow: popoverArrow, ...restProps } = props;
    const { getPrefixCls, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles, arrow: contextArrow, trigger: contextTrigger } = (0, _context.useComponentConfig)('popover');
    const prefixCls = getPrefixCls('popover', customizePrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls);
    const rootPrefixCls = getPrefixCls();
    const mergedArrow = (0, _useMergedArrowDefault.default)(popoverArrow, contextArrow);
    const mergedTrigger = trigger || contextTrigger || 'hover';
    // ============================= Styles =============================
    const mergedProps = {
        ...props,
        placement,
        trigger: mergedTrigger,
        mouseEnterDelay,
        mouseLeaveDelay,
        overlayStyle,
        styles,
        classNames
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const rootClassNames = (0, _clsx.clsx)(overlayClassName, hashId, cssVarCls, contextClassName, mergedClassNames.root);
    const [open, setOpen] = (0, _util.useControlledState)(props.defaultOpen ?? false, props.open);
    const settingOpen = (value, e)=>{
        setOpen(value);
        onOpenChange?.(value, e);
    };
    const onKeyDown = (e)=>{
        if (e.keyCode === (0, _keyCodeDefault.default).ESC) settingOpen(false, e);
    };
    const onInternalOpenChange = (value)=>{
        settingOpen(value);
    };
    const titleNode = (0, _getRenderPropValue.getRenderPropValue)(title);
    const contentNode = (0, _getRenderPropValue.getRenderPropValue)(content);
    return /*#__PURE__*/ _react.createElement((0, _tooltipDefault.default), {
        unique: false,
        arrow: mergedArrow,
        placement: placement,
        trigger: mergedTrigger,
        mouseEnterDelay: mouseEnterDelay,
        mouseLeaveDelay: mouseLeaveDelay,
        ...restProps,
        prefixCls: prefixCls,
        classNames: {
            root: rootClassNames,
            container: mergedClassNames.container,
            arrow: mergedClassNames.arrow
        },
        styles: {
            root: {
                ...mergedStyles.root,
                ...contextStyle,
                ...overlayStyle
            },
            container: mergedStyles.container,
            arrow: mergedStyles.arrow
        },
        ref: ref,
        open: open,
        onOpenChange: onInternalOpenChange,
        overlay: titleNode || contentNode ? /*#__PURE__*/ _react.createElement((0, _purePanel.Overlay), {
            prefixCls: prefixCls,
            title: titleNode,
            content: contentNode,
            classNames: mergedClassNames,
            styles: mergedStyles
        }) : null,
        motion: {
            motionName: (0, _motion.getTransitionName)(rootPrefixCls, 'zoom-big', typeof motion?.motionName === 'string' ? motion?.motionName : undefined)
        },
        "data-popover-inject": true
    }, (0, _reactNode.cloneElement)(children, {
        onKeyDown: (e)=>{
            if (/*#__PURE__*/ (0, _react.isValidElement)(children)) children?.props.onKeyDown?.(e);
            onKeyDown(e);
        }
    }));
});
const Popover = InternalPopover;
Popover._InternalPanelDoNotUseOrYouWillBeFired = (0, _purePanelDefault.default);
exports.default = Popover;

},{"react":"bmhQu","@rc-component/util":"6ZBDN","@rc-component/util/es/KeyCode":"6yRlk","clsx":"431Ou","../_util/getRenderPropValue":"bxLP4","../_util/hooks":"kdnMA","../_util/motion":"kUUSo","../_util/reactNode":"78pFx","../config-provider/context":"75zwC","../tooltip":"aByoO","../tooltip/hook/useMergedArrow":"jKxW0","./PurePanel":"cvdfY","./style":"7nbAL","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eNAcf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Categories", ()=>Categories);
parcelHelpers.export(exports, "Emoji", ()=>ExportedEmoji);
parcelHelpers.export(exports, "EmojiStyle", ()=>EmojiStyle);
parcelHelpers.export(exports, "SkinTonePickerLocation", ()=>SkinTonePickerLocation);
parcelHelpers.export(exports, "SkinTones", ()=>SkinTones);
parcelHelpers.export(exports, "SuggestionMode", ()=>SuggestionMode);
parcelHelpers.export(exports, "Theme", ()=>Theme);
parcelHelpers.export(exports, "emojiByUnified", ()=>emojiByUnified);
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _flairup = require("flairup");
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _createForOfIteratorHelperLoose(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (t) return (t = t.call(r)).next.bind(t);
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
        t && (r = t);
        var o = 0;
        return function() {
            return o >= r.length ? {
                done: !0
            } : {
                done: !1,
                value: r[o++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
function _inheritsLoose(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}
function _objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
var ClassNames;
(function(ClassNames) {
    ClassNames["hiddenOnSearch"] = "epr-hidden-on-search";
    ClassNames["searchActive"] = "epr-search-active";
    ClassNames["hidden"] = "epr-hidden";
    ClassNames["visible"] = "epr-visible";
    ClassNames["active"] = "epr-active";
    ClassNames["emoji"] = "epr-emoji";
    ClassNames["category"] = "epr-emoji-category";
    ClassNames["label"] = "epr-emoji-category-label";
    ClassNames["categoryContent"] = "epr-emoji-category-content";
    ClassNames["emojiHasVariations"] = "epr-emoji-has-variations";
    ClassNames["scrollBody"] = "epr-body";
    ClassNames["emojiList"] = "epr-emoji-list";
    ClassNames["external"] = "__EmojiPicker__";
    ClassNames["emojiPicker"] = "EmojiPickerReact";
    ClassNames["open"] = "epr-open";
    ClassNames["vertical"] = "epr-vertical";
    ClassNames["horizontal"] = "epr-horizontal";
    ClassNames["variationPicker"] = "epr-emoji-variation-picker";
    ClassNames["darkTheme"] = "epr-dark-theme";
    ClassNames["autoTheme"] = "epr-auto-theme";
})(ClassNames || (ClassNames = {}));
function asSelectors() {
    for(var _len = arguments.length, classNames = new Array(_len), _key = 0; _key < _len; _key++)classNames[_key] = arguments[_key];
    return classNames.map(function(c) {
        return "." + c;
    }).join('');
}
var stylesheet = /*#__PURE__*/ (0, _flairup.createSheet)('epr', null);
var hidden = {
    display: 'none',
    opacity: '0',
    pointerEvents: 'none',
    visibility: 'hidden',
    overflow: 'hidden'
};
var commonStyles = /*#__PURE__*/ stylesheet.create({
    hidden: /*#__PURE__*/ _extends({
        '.': ClassNames.hidden
    }, hidden)
});
var PickerStyleTag = /*#__PURE__*/ (0, _react.memo)(function PickerStyleTag(_ref) {
    var nonce = _ref.nonce;
    return (0, _react.createElement)("style", {
        nonce: nonce,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: stylesheet.getStyle()
        }
    });
});
var commonInteractionStyles = /*#__PURE__*/ stylesheet.create({
    '.epr-main': {
        ':has(input:not(:placeholder-shown))': {
            categoryBtn: {
                ':hover': {
                    opacity: '1',
                    backgroundPositionY: 'var(--epr-category-navigation-button-size)'
                }
            },
            hiddenOnSearch: /*#__PURE__*/ _extends({
                '.': ClassNames.hiddenOnSearch
            }, hidden)
        },
        ':has(input:placeholder-shown)': {
            visibleOnSearchOnly: hidden
        }
    },
    hiddenOnReactions: {
        transition: 'all 0.5s ease-in-out'
    },
    '.epr-reactions': {
        hiddenOnReactions: {
            height: '0px',
            width: '0px',
            opacity: '0',
            pointerEvents: 'none',
            overflow: 'hidden'
        }
    },
    '.EmojiPickerReact:not(.epr-search-active)': {
        categoryBtn: {
            ':hover': {
                opacity: '1',
                backgroundPositionY: 'var(--epr-category-navigation-button-size)'
            },
            '&.epr-active': {
                opacity: '1',
                backgroundPositionY: 'var(--epr-category-navigation-button-size)'
            }
        },
        visibleOnSearchOnly: /*#__PURE__*/ _extends({
            '.': 'epr-visible-on-search-only'
        }, hidden)
    }
});
function darkMode(key, value) {
    var _eprDarkTheme, _eprAutoTheme;
    return {
        '.epr-dark-theme': (_eprDarkTheme = {}, _eprDarkTheme[key] = value, _eprDarkTheme),
        '.epr-auto-theme': (_eprAutoTheme = {}, _eprAutoTheme[key] = {
            '@media (prefers-color-scheme: dark)': value
        }, _eprAutoTheme)
    };
}
// eslint-disable-next-line complexity
function compareConfig(prev, next) {
    var _prev$customEmojis, _next$customEmojis;
    var prevCustomEmojis = (_prev$customEmojis = prev.customEmojis) != null ? _prev$customEmojis : [];
    var nextCustomEmojis = (_next$customEmojis = next.customEmojis) != null ? _next$customEmojis : [];
    return prev.open === next.open && prev.emojiVersion === next.emojiVersion && prev.reactionsDefaultOpen === next.reactionsDefaultOpen && prev.searchPlaceHolder === next.searchPlaceHolder && prev.searchPlaceholder === next.searchPlaceholder && prev.searchClearButtonLabel === next.searchClearButtonLabel && prev.defaultSkinTone === next.defaultSkinTone && prev.skinTonesDisabled === next.skinTonesDisabled && prev.autoFocusSearch === next.autoFocusSearch && prev.emojiStyle === next.emojiStyle && prev.theme === next.theme && prev.suggestedEmojisMode === next.suggestedEmojisMode && prev.lazyLoadEmojis === next.lazyLoadEmojis && prev.className === next.className && prev.height === next.height && prev.width === next.width && prev.style === next.style && prev.searchDisabled === next.searchDisabled && prev.skinTonePickerLocation === next.skinTonePickerLocation && prevCustomEmojis.length === nextCustomEmojis.length && prev.emojiData === next.emojiData;
}
var DEFAULT_REACTIONS = [
    '1f44d',
    '2764-fe0f',
    '1f603',
    '1f622',
    '1f64f',
    '1f44e',
    '1f621'
];
var SuggestionMode;
(function(SuggestionMode) {
    SuggestionMode["RECENT"] = "recent";
    SuggestionMode["FREQUENT"] = "frequent";
})(SuggestionMode || (SuggestionMode = {}));
var EmojiStyle;
(function(EmojiStyle) {
    EmojiStyle["NATIVE"] = "native";
    EmojiStyle["APPLE"] = "apple";
    EmojiStyle["TWITTER"] = "twitter";
    EmojiStyle["GOOGLE"] = "google";
    EmojiStyle["FACEBOOK"] = "facebook";
})(EmojiStyle || (EmojiStyle = {}));
var Theme;
(function(Theme) {
    Theme["DARK"] = "dark";
    Theme["LIGHT"] = "light";
    Theme["AUTO"] = "auto";
})(Theme || (Theme = {}));
var SkinTones;
(function(SkinTones) {
    SkinTones["NEUTRAL"] = "neutral";
    SkinTones["LIGHT"] = "1f3fb";
    SkinTones["MEDIUM_LIGHT"] = "1f3fc";
    SkinTones["MEDIUM"] = "1f3fd";
    SkinTones["MEDIUM_DARK"] = "1f3fe";
    SkinTones["DARK"] = "1f3ff";
})(SkinTones || (SkinTones = {}));
var Categories;
(function(Categories) {
    Categories["SUGGESTED"] = "suggested";
    Categories["CUSTOM"] = "custom";
    Categories["SMILEYS_PEOPLE"] = "smileys_people";
    Categories["ANIMALS_NATURE"] = "animals_nature";
    Categories["FOOD_DRINK"] = "food_drink";
    Categories["TRAVEL_PLACES"] = "travel_places";
    Categories["ACTIVITIES"] = "activities";
    Categories["OBJECTS"] = "objects";
    Categories["SYMBOLS"] = "symbols";
    Categories["FLAGS"] = "flags";
})(Categories || (Categories = {}));
var SkinTonePickerLocation;
(function(SkinTonePickerLocation) {
    SkinTonePickerLocation["SEARCH"] = "SEARCH";
    SkinTonePickerLocation["PREVIEW"] = "PREVIEW";
})(SkinTonePickerLocation || (SkinTonePickerLocation = {}));
var CDN_URL_APPLE = 'https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/';
var CDN_URL_FACEBOOK = 'https://cdn.jsdelivr.net/npm/emoji-datasource-facebook/img/facebook/64/';
var CDN_URL_TWITTER = 'https://cdn.jsdelivr.net/npm/emoji-datasource-twitter/img/twitter/64/';
var CDN_URL_GOOGLE = 'https://cdn.jsdelivr.net/npm/emoji-datasource-google/img/google/64/';
function cdnUrl(emojiStyle) {
    switch(emojiStyle){
        case EmojiStyle.TWITTER:
            return CDN_URL_TWITTER;
        case EmojiStyle.GOOGLE:
            return CDN_URL_GOOGLE;
        case EmojiStyle.FACEBOOK:
            return CDN_URL_FACEBOOK;
        case EmojiStyle.APPLE:
        default:
            return CDN_URL_APPLE;
    }
}
var skinToneVariations = [
    SkinTones.NEUTRAL,
    SkinTones.LIGHT,
    SkinTones.MEDIUM_LIGHT,
    SkinTones.MEDIUM,
    SkinTones.MEDIUM_DARK,
    SkinTones.DARK
];
var skinTonesNamed = /*#__PURE__*/ Object.entries(SkinTones).reduce(function(acc, _ref) {
    var key = _ref[0], value = _ref[1];
    acc[value] = key;
    return acc;
}, {});
var skinTonesMapped = /*#__PURE__*/ skinToneVariations.reduce(function(mapped, skinTone) {
    var _Object$assign;
    return Object.assign(mapped, (_Object$assign = {}, _Object$assign[skinTone] = skinTone, _Object$assign));
}, {});
var EmojiProperties;
(function(EmojiProperties) {
    EmojiProperties["name"] = "n";
    EmojiProperties["unified"] = "u";
    EmojiProperties["variations"] = "v";
    EmojiProperties["added_in"] = "a";
    EmojiProperties["imgUrl"] = "imgUrl";
})(EmojiProperties || (EmojiProperties = {}));
function emojiNames(emoji) {
    var _emoji$EmojiPropertie;
    return (_emoji$EmojiPropertie = emoji[EmojiProperties.name]) != null ? _emoji$EmojiPropertie : [];
}
function addedIn(emoji) {
    return parseFloat(emoji[EmojiProperties.added_in] || '0');
}
function emojiName(emoji) {
    if (!emoji) return '';
    var names = emojiNames(emoji);
    return names[names.length - 1];
}
function unifiedWithoutSkinTone(unified) {
    var splat = unified.split('-');
    var _splat$splice = splat.splice(1, 1), skinTone = _splat$splice[0];
    if (skinTonesMapped[skinTone]) return splat.join('-');
    return unified;
}
function emojiUnified(emoji, skinTone) {
    var _emojiVariationUnifie;
    var unified = emoji[EmojiProperties.unified];
    if (!skinTone || !emojiHasVariations(emoji)) return unified;
    return (_emojiVariationUnifie = emojiVariationUnified(emoji, skinTone)) != null ? _emojiVariationUnifie : unified;
}
function emojiUrlByUnified(unified, emojiStyle) {
    return "" + cdnUrl(emojiStyle) + unified + ".png";
}
function emojiVariations(emoji) {
    var _emoji$EmojiPropertie2;
    return (_emoji$EmojiPropertie2 = emoji[EmojiProperties.variations]) != null ? _emoji$EmojiPropertie2 : [];
}
function emojiHasVariations(emoji) {
    return emojiVariations(emoji).length > 0;
}
function emojiVariationUnified(emoji, skinTone) {
    return skinTone ? emojiVariations(emoji).find(function(variation) {
        return variation.includes(skinTone);
    }) : emojiUnified(emoji);
}
function activeVariationFromUnified(unified) {
    var _unified$split = unified.split('-'), suspectedSkinTone = _unified$split[1];
    return Object.keys(skinTonesMapped).includes(suspectedSkinTone) ? suspectedSkinTone : null;
}
var _configByCategory;
var categoriesOrdered = [
    Categories.SUGGESTED,
    Categories.CUSTOM,
    Categories.SMILEYS_PEOPLE,
    Categories.ANIMALS_NATURE,
    Categories.FOOD_DRINK,
    Categories.TRAVEL_PLACES,
    Categories.ACTIVITIES,
    Categories.OBJECTS,
    Categories.SYMBOLS,
    Categories.FLAGS
];
var SuggestedRecent = {
    name: 'Recently Used',
    category: Categories.SUGGESTED
};
var configByCategory = (_configByCategory = {}, _configByCategory[Categories.SUGGESTED] = {
    category: Categories.SUGGESTED,
    name: 'Frequently Used'
}, _configByCategory[Categories.CUSTOM] = {
    category: Categories.CUSTOM,
    name: 'Custom Emojis'
}, _configByCategory[Categories.SMILEYS_PEOPLE] = {
    category: Categories.SMILEYS_PEOPLE,
    name: 'Smileys & People'
}, _configByCategory[Categories.ANIMALS_NATURE] = {
    category: Categories.ANIMALS_NATURE,
    name: 'Animals & Nature'
}, _configByCategory[Categories.FOOD_DRINK] = {
    category: Categories.FOOD_DRINK,
    name: 'Food & Drink'
}, _configByCategory[Categories.TRAVEL_PLACES] = {
    category: Categories.TRAVEL_PLACES,
    name: 'Travel & Places'
}, _configByCategory[Categories.ACTIVITIES] = {
    category: Categories.ACTIVITIES,
    name: 'Activities'
}, _configByCategory[Categories.OBJECTS] = {
    category: Categories.OBJECTS,
    name: 'Objects'
}, _configByCategory[Categories.SYMBOLS] = {
    category: Categories.SYMBOLS,
    name: 'Symbols'
}, _configByCategory[Categories.FLAGS] = {
    category: Categories.FLAGS,
    name: 'Flags'
}, _configByCategory);
function baseCategoriesConfig(modifiers) {
    return categoriesOrdered.map(function(category) {
        return _extends({}, configByCategory[category], modifiers && modifiers[category] && modifiers[category]);
    });
}
function categoryFromCategoryConfig(category) {
    return category.category;
}
function categoryNameFromCategoryConfig(category) {
    return category.name;
}
function mergeCategoriesConfig(userCategoriesConfig, modifiers, emojiData) {
    var _userCategoriesConfig;
    if (userCategoriesConfig === void 0) userCategoriesConfig = [];
    if (modifiers === void 0) modifiers = {};
    var extra = function() {
        // 1. Start with localized categories from emojiData
        var fromData = emojiData != null && emojiData.categories ? Object.fromEntries(Object.entries(emojiData.categories).filter(function(_ref) {
            var config = _ref[1];
            return !!config;
        })) : {};
        // 2. Handle "Recently Used" override for explicit 'recent' mode
        if (modifiers.suggestionMode === SuggestionMode.RECENT) {
            var _emojiData$categories;
            var recentConfig = emojiData == null ? void 0 : (_emojiData$categories = emojiData.categories) == null ? void 0 : _emojiData$categories['suggested_recent'];
            fromData[Categories.SUGGESTED] = recentConfig ? {
                category: Categories.SUGGESTED,
                name: recentConfig.name
            } : SuggestedRecent;
        }
        return fromData;
    }();
    var base = baseCategoriesConfig(extra);
    if (!((_userCategoriesConfig = userCategoriesConfig) != null && _userCategoriesConfig.length)) return base;
    return userCategoriesConfig.map(function(category) {
        if (typeof category === 'string') return getBaseConfigByCategory(category, extra[category]);
        return _extends({}, getBaseConfigByCategory(category.category, extra[category.category]), category);
    });
}
function getBaseConfigByCategory(category, modifier) {
    if (modifier === void 0) modifier = {};
    return Object.assign(configByCategory[category], modifier);
}
var KNOWN_FAILING_EMOJIS = [
    '2640-fe0f',
    '2642-fe0f',
    '2695-fe0f'
];
var DEFAULT_SEARCH_PLACEHOLDER = 'Search';
var DEFAULT_SEARCH_CLEAR_BUTTON_LABEL = 'Clear';
var SEARCH_RESULTS_NO_RESULTS_FOUND = 'No results found';
var SEARCH_RESULTS_SUFFIX = ' found. Use up and down arrow keys to navigate.';
var SEARCH_RESULTS_ONE_RESULT_FOUND = '1 result' + SEARCH_RESULTS_SUFFIX;
var SEARCH_RESULTS_MULTIPLE_RESULTS_FOUND = '%n results' + SEARCH_RESULTS_SUFFIX;
function mergeConfig(userConfig) {
    var _userConfig$emojiData, _userConfig$emojiData2, _userConfig$emojiData3, _userConfig$previewCo, _userConfig$previewCo2;
    if (userConfig === void 0) userConfig = {};
    var base = basePickerConfig();
    // Get localized mood from emojiData, fallback to base default
    // Get localized mood from emojiData, fallback to base default
    var localizedMood = (_userConfig$emojiData = userConfig.emojiData) == null ? void 0 : (_userConfig$emojiData2 = _userConfig$emojiData.categories) == null ? void 0 : (_userConfig$emojiData3 = _userConfig$emojiData2.preview_mood) == null ? void 0 : _userConfig$emojiData3.name;
    var previewConfig = _extends({}, base.previewConfig, localizedMood && !((_userConfig$previewCo = userConfig.previewConfig) != null && _userConfig$previewCo.defaultCaption) ? {
        defaultCaption: localizedMood
    } : {}, (_userConfig$previewCo2 = userConfig.previewConfig) != null ? _userConfig$previewCo2 : {});
    var config = Object.assign(base, userConfig);
    var categories = mergeCategoriesConfig(userConfig.categories, {
        suggestionMode: config.suggestedEmojisMode
    }, userConfig.emojiData);
    config.hiddenEmojis.forEach(function(emoji) {
        config.unicodeToHide.add(emoji);
    });
    var skinTonePickerLocation = config.searchDisabled ? SkinTonePickerLocation.PREVIEW : config.skinTonePickerLocation;
    return _extends({}, config, {
        categories: categories,
        previewConfig: previewConfig,
        skinTonePickerLocation: skinTonePickerLocation
    });
}
function basePickerConfig() {
    return {
        autoFocusSearch: true,
        categories: baseCategoriesConfig(),
        className: '',
        customEmojis: [],
        defaultSkinTone: SkinTones.NEUTRAL,
        emojiStyle: EmojiStyle.APPLE,
        emojiVersion: null,
        getEmojiUrl: emojiUrlByUnified,
        height: 450,
        lazyLoadEmojis: false,
        previewConfig: _extends({}, basePreviewConfig),
        searchDisabled: false,
        searchPlaceHolder: DEFAULT_SEARCH_PLACEHOLDER,
        searchPlaceholder: DEFAULT_SEARCH_PLACEHOLDER,
        searchClearButtonLabel: DEFAULT_SEARCH_CLEAR_BUTTON_LABEL,
        skinTonePickerLocation: SkinTonePickerLocation.SEARCH,
        skinTonesDisabled: false,
        style: {},
        suggestedEmojisMode: SuggestionMode.FREQUENT,
        theme: Theme.LIGHT,
        unicodeToHide: new Set(KNOWN_FAILING_EMOJIS),
        width: 350,
        reactionsDefaultOpen: false,
        reactions: DEFAULT_REACTIONS,
        open: true,
        allowExpandReactions: true,
        hiddenEmojis: [],
        emojiData: undefined,
        categoryIcons: {},
        nonce: undefined
    };
}
var basePreviewConfig = {
    defaultEmoji: '1f60a',
    defaultCaption: "What's your mood?",
    showPreview: true
};
var _excluded = [
    "children"
];
var ConfigContext = /*#__PURE__*/ (0, _react.createContext)(/*#__PURE__*/ basePickerConfig());
function PickerConfigProvider(_ref) {
    var children = _ref.children, config = _objectWithoutPropertiesLoose(_ref, _excluded);
    var mergedConfig = useSetConfig(config);
    return (0, _react.createElement)(ConfigContext.Provider, {
        value: mergedConfig
    }, children);
}
function useSetConfig(config) {
    var _config$customEmojis;
    var _React$useState = (0, _react.useState)(function() {
        return mergeConfig(config);
    }), mergedConfig = _React$useState[0], setMergedConfig = _React$useState[1];
    (0, _react.useEffect)(function() {
        if (compareConfig(mergedConfig, config)) return;
        setMergedConfig(mergeConfig(config));
    // not gonna...
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        (_config$customEmojis = config.customEmojis) == null ? void 0 : _config$customEmojis.length,
        config.open,
        config.emojiVersion,
        config.reactionsDefaultOpen,
        config.searchPlaceHolder,
        config.searchPlaceholder,
        config.searchClearButtonLabel,
        config.defaultSkinTone,
        config.skinTonesDisabled,
        config.autoFocusSearch,
        config.emojiStyle,
        config.theme,
        config.suggestedEmojisMode,
        config.lazyLoadEmojis,
        config.className,
        config.height,
        config.width,
        config.searchDisabled,
        config.skinTonePickerLocation,
        config.allowExpandReactions,
        config.emojiData
    ]);
    return mergedConfig;
}
function usePickerConfig() {
    return (0, _react.useContext)(ConfigContext);
}
function useDebouncedState(initialValue, delay) {
    if (delay === void 0) delay = 0;
    var _useState = (0, _react.useState)(initialValue), state = _useState[0], setState = _useState[1];
    var timer = (0, _react.useRef)(null);
    function debouncedSetState(value) {
        return new Promise(function(resolve) {
            var _window;
            if (timer.current) clearTimeout(timer.current);
            timer.current = (_window = window) == null ? void 0 : _window.setTimeout(function() {
                setState(value);
                resolve(value);
            }, delay);
        });
    }
    return [
        state,
        debouncedSetState
    ];
}
var categories = {
    smileys_people: {
        category: "smileys_people",
        name: "people & body"
    },
    animals_nature: {
        category: "animals_nature",
        name: "animals & nature"
    },
    food_drink: {
        category: "food_drink",
        name: "food & drink"
    },
    travel_places: {
        category: "travel_places",
        name: "travel & places"
    },
    activities: {
        category: "activities",
        name: "activities"
    },
    objects: {
        category: "objects",
        name: "objects"
    },
    symbols: {
        category: "symbols",
        name: "symbols"
    },
    flags: {
        category: "flags",
        name: "flags"
    },
    suggested: {
        category: "suggested",
        name: "Frequently Used"
    },
    custom: {
        category: "custom",
        name: "Custom Emojis"
    },
    suggested_recent: {
        category: "suggested",
        name: "Recently Used"
    },
    preview_mood: {
        category: "preview_mood",
        name: "What's your mood?"
    }
};
var emojis = {
    custom: [],
    smileys_people: [
        {
            n: [
                "face",
                "grin",
                "grinning face"
            ],
            u: "1f600",
            a: "1"
        },
        {
            n: [
                "face",
                "open",
                "mouth",
                "smile",
                "grinning face with big eyes"
            ],
            u: "1f603",
            a: "0.6"
        },
        {
            n: [
                "eye",
                "face",
                "open",
                "mouth",
                "smile",
                "grinning face with smiling eyes"
            ],
            u: "1f604",
            a: "0.6"
        },
        {
            n: [
                "eye",
                "face",
                "grin",
                "smile",
                "beaming face with smiling eyes"
            ],
            u: "1f601",
            a: "0.6"
        },
        {
            n: [
                "face",
                "laugh",
                "mouth",
                "smile",
                "satisfied",
                "grinning squinting face"
            ],
            u: "1f606",
            a: "0.6"
        },
        {
            n: [
                "cold",
                "face",
                "open",
                "smile",
                "sweat",
                "grinning face with sweat"
            ],
            u: "1f605",
            a: "0.6"
        },
        {
            n: [
                "face",
                "rofl",
                "floor",
                "laugh",
                "rotfl",
                "rolling",
                "rolling on the floor laughing"
            ],
            u: "1f923",
            a: "3"
        },
        {
            n: [
                "joy",
                "face",
                "tear",
                "laugh",
                "face with tears of joy"
            ],
            u: "1f602",
            a: "0.6"
        },
        {
            n: [
                "face",
                "smile",
                "slightly smiling face"
            ],
            u: "1f642",
            a: "1"
        },
        {
            n: [
                "face",
                "upside down",
                "upside down face"
            ],
            u: "1f643",
            a: "1"
        },
        {
            n: [
                "melt",
                "liquid",
                "dissolve",
                "disappear",
                "melting face"
            ],
            u: "1fae0",
            a: "14"
        },
        {
            n: [
                "face",
                "wink",
                "winking face"
            ],
            u: "1f609",
            a: "0.6"
        },
        {
            n: [
                "eye",
                "face",
                "blush",
                "smile",
                "smiling face with smiling eyes"
            ],
            u: "1f60a",
            a: "0.6"
        },
        {
            n: [
                "face",
                "halo",
                "angel",
                "fantasy",
                "innocent",
                "smiling face with halo"
            ],
            u: "1f607",
            a: "1"
        },
        {
            n: [
                "adore",
                "crush",
                "hearts",
                "in love",
                "smiling face with hearts"
            ],
            u: "1f970",
            a: "11"
        },
        {
            n: [
                "eye",
                "face",
                "love",
                "smile",
                "smiling face with heart eyes"
            ],
            u: "1f60d",
            a: "0.6"
        },
        {
            n: [
                "eyes",
                "face",
                "star",
                "grinning",
                "star struck"
            ],
            u: "1f929",
            a: "5"
        },
        {
            n: [
                "face",
                "kiss",
                "face blowing a kiss"
            ],
            u: "1f618",
            a: "0.6"
        },
        {
            n: [
                "face",
                "kiss",
                "kissing face"
            ],
            u: "1f617",
            a: "1"
        },
        {
            n: [
                "face",
                "smile",
                "relaxed",
                "outlined",
                "smiling face"
            ],
            u: "263a-fe0f",
            a: "0.6"
        },
        {
            n: [
                "eye",
                "face",
                "kiss",
                "closed",
                "kissing face with closed eyes"
            ],
            u: "1f61a",
            a: "0.6"
        },
        {
            n: [
                "eye",
                "face",
                "kiss",
                "smile",
                "kissing face with smiling eyes"
            ],
            u: "1f619",
            a: "1"
        },
        {
            n: [
                "tear",
                "proud",
                "smiling",
                "touched",
                "grateful",
                "relieved",
                "smiling face with tear"
            ],
            u: "1f972",
            a: "13"
        },
        {
            n: [
                "yum",
                "face",
                "smile",
                "delicious",
                "savouring",
                "face savoring food"
            ],
            u: "1f60b",
            a: "0.6"
        },
        {
            n: [
                "face",
                "tongue",
                "face with tongue"
            ],
            u: "1f61b",
            a: "1"
        },
        {
            n: [
                "eye",
                "face",
                "joke",
                "wink",
                "tongue",
                "winking face with tongue"
            ],
            u: "1f61c",
            a: "0.6"
        },
        {
            n: [
                "eye",
                "goofy",
                "large",
                "small",
                "zany face"
            ],
            u: "1f92a",
            a: "5"
        },
        {
            n: [
                "eye",
                "face",
                "taste",
                "tongue",
                "horrible",
                "squinting face with tongue"
            ],
            u: "1f61d",
            a: "0.6"
        },
        {
            n: [
                "face",
                "money",
                "mouth",
                "money mouth face"
            ],
            u: "1f911",
            a: "1"
        },
        {
            n: [
                "hug",
                "face",
                "hugging",
                "open hands",
                "smiling face",
                "smiling face with open hands"
            ],
            u: "1f917",
            a: "1"
        },
        {
            n: [
                "whoops",
                "face with hand over mouth"
            ],
            u: "1f92d",
            a: "5"
        },
        {
            n: [
                "awe",
                "scared",
                "surprise",
                "amazement",
                "disbelief",
                "embarrass",
                "face with open eyes and hand over mouth"
            ],
            u: "1fae2",
            a: "14"
        },
        {
            n: [
                "peep",
                "stare",
                "captivated",
                "face with peeking eye"
            ],
            u: "1fae3",
            a: "14"
        },
        {
            n: [
                "quiet",
                "shush",
                "shushing face"
            ],
            u: "1f92b",
            a: "5"
        },
        {
            n: [
                "face",
                "thinking",
                "thinking face"
            ],
            u: "1f914",
            a: "1"
        },
        {
            n: [
                "ok",
                "yes",
                "sunny",
                "salute",
                "troops",
                "saluting face"
            ],
            u: "1fae1",
            a: "14"
        },
        {
            n: [
                "zip",
                "face",
                "mouth",
                "zipper",
                "zipper mouth face"
            ],
            u: "1f910",
            a: "1"
        },
        {
            n: [
                "skeptic",
                "distrust",
                "face with raised eyebrow"
            ],
            u: "1f928",
            a: "5"
        },
        {
            n: [
                "meh",
                "face",
                "deadpan",
                "neutral",
                "neutral face"
            ],
            u: "1f610",
            a: "0.7"
        },
        {
            n: [
                "meh",
                "face",
                "inexpressive",
                "unexpressive",
                "expressionless",
                "expressionless face"
            ],
            u: "1f611",
            a: "1"
        },
        {
            n: [
                "face",
                "mouth",
                "quiet",
                "silent",
                "face without mouth"
            ],
            u: "1f636",
            a: "1"
        },
        {
            n: [
                "hide",
                "depressed",
                "disappear",
                "introvert",
                "invisible",
                "dotted line face"
            ],
            u: "1fae5",
            a: "14"
        },
        {
            n: [
                "absentminded",
                "face in clouds",
                "head in clouds",
                "face in the fog"
            ],
            u: "1f636-200d-1f32b-fe0f",
            a: "13.1"
        },
        {
            n: [
                "face",
                "smirk",
                "smirking face"
            ],
            u: "1f60f",
            a: "0.6"
        },
        {
            n: [
                "face",
                "unhappy",
                "unamused",
                "unamused face"
            ],
            u: "1f612",
            a: "0.6"
        },
        {
            n: [
                "eyes",
                "face",
                "eyeroll",
                "rolling",
                "face with rolling eyes"
            ],
            u: "1f644",
            a: "1"
        },
        {
            n: [
                "face",
                "grimace",
                "grimacing face"
            ],
            u: "1f62c",
            a: "1"
        },
        {
            n: [
                "gasp",
                "groan",
                "exhale",
                "relief",
                "whisper",
                "whistle",
                "face exhaling"
            ],
            u: "1f62e-200d-1f4a8",
            a: "13.1"
        },
        {
            n: [
                "lie",
                "face",
                "pinocchio",
                "lying face"
            ],
            u: "1f925",
            a: "3"
        },
        {
            n: [
                "face",
                "shock",
                "shaking",
                "vibrate",
                "earthquake",
                "shaking face"
            ],
            u: "1fae8",
            a: "15"
        },
        {
            n: [
                "no",
                "shake",
                "head shaking horizontally"
            ],
            u: "1f642-200d-2194-fe0f",
            a: "15.1"
        },
        {
            n: [
                "nod",
                "yes",
                "head shaking vertically"
            ],
            u: "1f642-200d-2195-fe0f",
            a: "15.1"
        },
        {
            n: [
                "face",
                "relieved",
                "relieved face"
            ],
            u: "1f60c",
            a: "0.6"
        },
        {
            n: [
                "face",
                "pensive",
                "dejected",
                "pensive face"
            ],
            u: "1f614",
            a: "0.6"
        },
        {
            n: [
                "face",
                "sleep",
                "good night",
                "sleepy face"
            ],
            u: "1f62a",
            a: "0.6"
        },
        {
            n: [
                "face",
                "drooling",
                "drooling face"
            ],
            u: "1f924",
            a: "3"
        },
        {
            n: [
                "zzz",
                "face",
                "sleep",
                "good night",
                "sleeping face"
            ],
            u: "1f634",
            a: "1"
        },
        {
            n: [
                "cold",
                "face",
                "mask",
                "sick",
                "doctor",
                "face with medical mask"
            ],
            u: "1f637",
            a: "0.6"
        },
        {
            n: [
                "ill",
                "face",
                "sick",
                "thermometer",
                "face with thermometer"
            ],
            u: "1f912",
            a: "1"
        },
        {
            n: [
                "face",
                "hurt",
                "injury",
                "bandage",
                "face with head bandage"
            ],
            u: "1f915",
            a: "1"
        },
        {
            n: [
                "face",
                "vomit",
                "nauseated",
                "nauseated face"
            ],
            u: "1f922",
            a: "3"
        },
        {
            n: [
                "puke",
                "sick",
                "vomit",
                "face vomiting"
            ],
            u: "1f92e",
            a: "5"
        },
        {
            n: [
                "face",
                "sneeze",
                "gesundheit",
                "sneezing face"
            ],
            u: "1f927",
            a: "3"
        },
        {
            n: [
                "hot",
                "hot face",
                "feverish",
                "sweating",
                "red faced",
                "heat stroke"
            ],
            u: "1f975",
            a: "11"
        },
        {
            n: [
                "cold",
                "icicles",
                "freezing",
                "cold face",
                "frostbite",
                "blue faced"
            ],
            u: "1f976",
            a: "11"
        },
        {
            n: [
                "dizzy",
                "tipsy",
                "woozy face",
                "wavy mouth",
                "intoxicated",
                "uneven eyes"
            ],
            u: "1f974",
            a: "11"
        },
        {
            n: [
                "dead",
                "face",
                "knocked out",
                "crossed out eyes",
                "face with crossed out eyes"
            ],
            u: "1f635",
            a: "0.6"
        },
        {
            n: [
                "whoa",
                "dizzy",
                "spiral",
                "trouble",
                "hypnotized",
                "face with spiral eyes"
            ],
            u: "1f635-200d-1f4ab",
            a: "13.1"
        },
        {
            n: [
                "shocked",
                "mind blown",
                "exploding head"
            ],
            u: "1f92f",
            a: "5"
        },
        {
            n: [
                "hat",
                "face",
                "cowboy",
                "cowgirl",
                "cowboy hat face"
            ],
            u: "1f920",
            a: "3"
        },
        {
            n: [
                "hat",
                "horn",
                "party",
                "celebration",
                "partying face"
            ],
            u: "1f973",
            a: "11"
        },
        {
            n: [
                "face",
                "nose",
                "glasses",
                "disguise",
                "incognito",
                "disguised face"
            ],
            u: "1f978",
            a: "13"
        },
        {
            n: [
                "sun",
                "cool",
                "face",
                "bright",
                "sunglasses",
                "smiling face with sunglasses"
            ],
            u: "1f60e",
            a: "1"
        },
        {
            n: [
                "face",
                "geek",
                "nerd",
                "nerd face"
            ],
            u: "1f913",
            a: "1"
        },
        {
            n: [
                "face",
                "stuffy",
                "monocle",
                "face with monocle"
            ],
            u: "1f9d0",
            a: "5"
        },
        {
            n: [
                "meh",
                "face",
                "confused",
                "confused face"
            ],
            u: "1f615",
            a: "1"
        },
        {
            n: [
                "meh",
                "unsure",
                "skeptical",
                "disappointed",
                "face with diagonal mouth"
            ],
            u: "1fae4",
            a: "14"
        },
        {
            n: [
                "face",
                "worried",
                "worried face"
            ],
            u: "1f61f",
            a: "1"
        },
        {
            n: [
                "face",
                "frown",
                "slightly frowning face"
            ],
            u: "1f641",
            a: "1"
        },
        {
            n: [
                "face",
                "frown",
                "frowning face"
            ],
            u: "2639-fe0f",
            a: "0.7"
        },
        {
            n: [
                "face",
                "open",
                "mouth",
                "sympathy",
                "face with open mouth"
            ],
            u: "1f62e",
            a: "1"
        },
        {
            n: [
                "face",
                "hushed",
                "stunned",
                "surprised",
                "hushed face"
            ],
            u: "1f62f",
            a: "1"
        },
        {
            n: [
                "face",
                "shocked",
                "totally",
                "astonished",
                "astonished face"
            ],
            u: "1f632",
            a: "0.6"
        },
        {
            n: [
                "face",
                "dazed",
                "flushed",
                "flushed face"
            ],
            u: "1f633",
            a: "0.6"
        },
        {
            n: [
                "mercy",
                "begging",
                "puppy eyes",
                "pleading face"
            ],
            u: "1f97a",
            a: "11"
        },
        {
            n: [
                "cry",
                "sad",
                "angry",
                "proud",
                "resist",
                "face holding back tears"
            ],
            u: "1f979",
            a: "14"
        },
        {
            n: [
                "face",
                "open",
                "frown",
                "mouth",
                "frowning face with open mouth"
            ],
            u: "1f626",
            a: "1"
        },
        {
            n: [
                "face",
                "anguished",
                "anguished face"
            ],
            u: "1f627",
            a: "1"
        },
        {
            n: [
                "face",
                "fear",
                "scared",
                "fearful",
                "fearful face"
            ],
            u: "1f628",
            a: "0.6"
        },
        {
            n: [
                "blue",
                "cold",
                "face",
                "sweat",
                "rushed",
                "anxious face with sweat"
            ],
            u: "1f630",
            a: "0.6"
        },
        {
            n: [
                "face",
                "whew",
                "relieved",
                "disappointed",
                "sad but relieved face"
            ],
            u: "1f625",
            a: "0.6"
        },
        {
            n: [
                "cry",
                "sad",
                "face",
                "tear",
                "crying face"
            ],
            u: "1f622",
            a: "0.6"
        },
        {
            n: [
                "cry",
                "sad",
                "sob",
                "face",
                "tear",
                "loudly crying face"
            ],
            u: "1f62d",
            a: "0.6"
        },
        {
            n: [
                "face",
                "fear",
                "munch",
                "scared",
                "scream",
                "face screaming in fear"
            ],
            u: "1f631",
            a: "0.6"
        },
        {
            n: [
                "face",
                "confounded",
                "confounded face"
            ],
            u: "1f616",
            a: "0.6"
        },
        {
            n: [
                "face",
                "persevere",
                "persevering face"
            ],
            u: "1f623",
            a: "0.6"
        },
        {
            n: [
                "face",
                "disappointed",
                "disappointed face"
            ],
            u: "1f61e",
            a: "0.6"
        },
        {
            n: [
                "cold",
                "face",
                "sweat",
                "downcast face with sweat"
            ],
            u: "1f613",
            a: "0.6"
        },
        {
            n: [
                "face",
                "tired",
                "weary",
                "weary face"
            ],
            u: "1f629",
            a: "0.6"
        },
        {
            n: [
                "face",
                "tired",
                "tired face"
            ],
            u: "1f62b",
            a: "0.6"
        },
        {
            n: [
                "yawn",
                "bored",
                "tired",
                "yawning face"
            ],
            u: "1f971",
            a: "12"
        },
        {
            n: [
                "won",
                "face",
                "triumph",
                "face with steam from nose"
            ],
            u: "1f624",
            a: "0.6"
        },
        {
            n: [
                "mad",
                "red",
                "face",
                "rage",
                "angry",
                "enraged",
                "pouting",
                "enraged face"
            ],
            u: "1f621",
            a: "0.6"
        },
        {
            n: [
                "mad",
                "face",
                "anger",
                "angry",
                "angry face"
            ],
            u: "1f620",
            a: "0.6"
        },
        {
            n: [
                "swearing",
                "face with symbols on mouth"
            ],
            u: "1f92c",
            a: "5"
        },
        {
            n: [
                "face",
                "horns",
                "smile",
                "fantasy",
                "fairy tale",
                "smiling face with horns"
            ],
            u: "1f608",
            a: "1"
        },
        {
            n: [
                "imp",
                "face",
                "demon",
                "devil",
                "fantasy",
                "angry face with horns"
            ],
            u: "1f47f",
            a: "0.6"
        },
        {
            n: [
                "face",
                "skull",
                "death",
                "monster",
                "fairy tale"
            ],
            u: "1f480",
            a: "0.6"
        },
        {
            n: [
                "face",
                "death",
                "skull",
                "monster",
                "crossbones",
                "skull and crossbones"
            ],
            u: "2620-fe0f",
            a: "1"
        },
        {
            n: [
                "poo",
                "dung",
                "face",
                "poop",
                "monster",
                "pile of poo"
            ],
            u: "1f4a9",
            a: "0.6"
        },
        {
            n: [
                "face",
                "clown",
                "clown face"
            ],
            u: "1f921",
            a: "3"
        },
        {
            n: [
                "ogre",
                "face",
                "fantasy",
                "monster",
                "creature",
                "fairy tale"
            ],
            u: "1f479",
            a: "0.6"
        },
        {
            n: [
                "face",
                "goblin",
                "fantasy",
                "monster",
                "creature",
                "fairy tale"
            ],
            u: "1f47a",
            a: "0.6"
        },
        {
            n: [
                "face",
                "ghost",
                "fantasy",
                "monster",
                "creature",
                "fairy tale"
            ],
            u: "1f47b",
            a: "0.6"
        },
        {
            n: [
                "ufo",
                "face",
                "alien",
                "fantasy",
                "creature",
                "extraterrestrial"
            ],
            u: "1f47d",
            a: "0.6"
        },
        {
            n: [
                "ufo",
                "face",
                "alien",
                "monster",
                "creature",
                "alien monster",
                "extraterrestrial"
            ],
            u: "1f47e",
            a: "0.6"
        },
        {
            n: [
                "face",
                "robot",
                "monster"
            ],
            u: "1f916",
            a: "1"
        },
        {
            n: [
                "cat",
                "face",
                "open",
                "mouth",
                "smile",
                "grinning",
                "grinning cat"
            ],
            u: "1f63a",
            a: "0.6"
        },
        {
            n: [
                "cat",
                "eye",
                "face",
                "grin",
                "smile",
                "grinning cat with smiling eyes"
            ],
            u: "1f638",
            a: "0.6"
        },
        {
            n: [
                "cat",
                "joy",
                "face",
                "tear",
                "cat with tears of joy"
            ],
            u: "1f639",
            a: "0.6"
        },
        {
            n: [
                "cat",
                "eye",
                "face",
                "love",
                "heart",
                "smile",
                "smiling cat with heart eyes"
            ],
            u: "1f63b",
            a: "0.6"
        },
        {
            n: [
                "cat",
                "wry",
                "face",
                "smile",
                "ironic",
                "cat with wry smile"
            ],
            u: "1f63c",
            a: "0.6"
        },
        {
            n: [
                "cat",
                "eye",
                "face",
                "kiss",
                "kissing cat"
            ],
            u: "1f63d",
            a: "0.6"
        },
        {
            n: [
                "oh",
                "cat",
                "face",
                "weary",
                "weary cat",
                "surprised"
            ],
            u: "1f640",
            a: "0.6"
        },
        {
            n: [
                "cat",
                "cry",
                "sad",
                "face",
                "tear",
                "crying cat"
            ],
            u: "1f63f",
            a: "0.6"
        },
        {
            n: [
                "cat",
                "face",
                "pouting",
                "pouting cat"
            ],
            u: "1f63e",
            a: "0.6"
        },
        {
            n: [
                "see",
                "evil",
                "face",
                "monkey",
                "forbidden",
                "see no evil monkey"
            ],
            u: "1f648",
            a: "0.6"
        },
        {
            n: [
                "evil",
                "face",
                "hear",
                "monkey",
                "forbidden",
                "hear no evil monkey"
            ],
            u: "1f649",
            a: "0.6"
        },
        {
            n: [
                "evil",
                "face",
                "speak",
                "monkey",
                "forbidden",
                "speak no evil monkey"
            ],
            u: "1f64a",
            a: "0.6"
        },
        {
            n: [
                "love",
                "mail",
                "heart",
                "letter",
                "love letter"
            ],
            u: "1f48c",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "cupid",
                "heart with arrow"
            ],
            u: "1f498",
            a: "0.6"
        },
        {
            n: [
                "ribbon",
                "valentine",
                "heart with ribbon"
            ],
            u: "1f49d",
            a: "0.6"
        },
        {
            n: [
                "excited",
                "sparkle",
                "sparkling heart"
            ],
            u: "1f496",
            a: "0.6"
        },
        {
            n: [
                "pulse",
                "excited",
                "growing",
                "nervous",
                "growing heart"
            ],
            u: "1f497",
            a: "0.6"
        },
        {
            n: [
                "beating",
                "heartbeat",
                "pulsating",
                "beating heart"
            ],
            u: "1f493",
            a: "0.6"
        },
        {
            n: [
                "revolving",
                "revolving hearts"
            ],
            u: "1f49e",
            a: "0.6"
        },
        {
            n: [
                "love",
                "two hearts"
            ],
            u: "1f495",
            a: "0.6"
        },
        {
            n: [
                "heart",
                "heart decoration"
            ],
            u: "1f49f",
            a: "0.6"
        },
        {
            n: [
                "mark",
                "exclamation",
                "punctuation",
                "heart exclamation"
            ],
            u: "2763-fe0f",
            a: "1"
        },
        {
            n: [
                "break",
                "broken",
                "broken heart"
            ],
            u: "1f494",
            a: "0.6"
        },
        {
            n: [
                "burn",
                "love",
                "lust",
                "heart",
                "sacred heart",
                "heart on fire"
            ],
            u: "2764-fe0f-200d-1f525",
            a: "13.1"
        },
        {
            n: [
                "well",
                "mending",
                "healthier",
                "improving",
                "recovering",
                "recuperating",
                "mending heart"
            ],
            u: "2764-fe0f-200d-1fa79",
            a: "13.1"
        },
        {
            n: [
                "heart",
                "red heart"
            ],
            u: "2764-fe0f",
            a: "0.6"
        },
        {
            n: [
                "cute",
                "like",
                "love",
                "pink",
                "heart",
                "pink heart"
            ],
            u: "1fa77",
            a: "15"
        },
        {
            n: [
                "orange",
                "orange heart"
            ],
            u: "1f9e1",
            a: "5"
        },
        {
            n: [
                "yellow",
                "yellow heart"
            ],
            u: "1f49b",
            a: "0.6"
        },
        {
            n: [
                "green",
                "green heart"
            ],
            u: "1f49a",
            a: "0.6"
        },
        {
            n: [
                "blue",
                "blue heart"
            ],
            u: "1f499",
            a: "0.6"
        },
        {
            n: [
                "cyan",
                "teal",
                "heart",
                "light blue",
                "light blue heart"
            ],
            u: "1fa75",
            a: "15"
        },
        {
            n: [
                "purple",
                "purple heart"
            ],
            u: "1f49c",
            a: "0.6"
        },
        {
            n: [
                "brown",
                "heart",
                "brown heart"
            ],
            u: "1f90e",
            a: "12"
        },
        {
            n: [
                "evil",
                "black",
                "wicked",
                "black heart"
            ],
            u: "1f5a4",
            a: "3"
        },
        {
            n: [
                "gray",
                "heart",
                "slate",
                "silver",
                "grey heart"
            ],
            u: "1fa76",
            a: "15"
        },
        {
            n: [
                "heart",
                "white",
                "white heart"
            ],
            u: "1f90d",
            a: "12"
        },
        {
            n: [
                "kiss",
                "lips",
                "kiss mark"
            ],
            u: "1f48b",
            a: "0.6"
        },
        {
            n: [
                "100",
                "full",
                "score",
                "hundred",
                "hundred points"
            ],
            u: "1f4af",
            a: "0.6"
        },
        {
            n: [
                "mad",
                "angry",
                "comic",
                "anger symbol"
            ],
            u: "1f4a2",
            a: "0.6"
        },
        {
            n: [
                "boom",
                "comic",
                "collision"
            ],
            u: "1f4a5",
            a: "0.6"
        },
        {
            n: [
                "star",
                "dizzy",
                "comic"
            ],
            u: "1f4ab",
            a: "0.6"
        },
        {
            n: [
                "comic",
                "sweat",
                "splashing",
                "sweat droplets"
            ],
            u: "1f4a6",
            a: "0.6"
        },
        {
            n: [
                "dash",
                "comic",
                "running",
                "dashing away"
            ],
            u: "1f4a8",
            a: "0.6"
        },
        {
            n: [
                "hole"
            ],
            u: "1f573-fe0f",
            a: "0.7"
        },
        {
            n: [
                "comic",
                "bubble",
                "dialog",
                "speech",
                "balloon",
                "speech balloon"
            ],
            u: "1f4ac",
            a: "0.6"
        },
        {
            n: [
                "eye",
                "bubble",
                "speech",
                "balloon",
                "witness",
                "eye in speech bubble"
            ],
            u: "1f441-fe0f-200d-1f5e8-fe0f",
            a: "2"
        },
        {
            n: [
                "bubble",
                "dialog",
                "speech",
                "balloon",
                "left speech bubble"
            ],
            u: "1f5e8-fe0f",
            a: "2"
        },
        {
            n: [
                "mad",
                "angry",
                "bubble",
                "balloon",
                "right anger bubble"
            ],
            u: "1f5ef-fe0f",
            a: "0.7"
        },
        {
            n: [
                "comic",
                "bubble",
                "balloon",
                "thought",
                "thought balloon"
            ],
            u: "1f4ad",
            a: "1"
        },
        {
            n: [
                "ZZZ",
                "zzz",
                "comic",
                "sleep",
                "good night"
            ],
            u: "1f4a4",
            a: "0.6"
        },
        {
            n: [
                "hand",
                "wave",
                "waving",
                "waving hand"
            ],
            u: "1f44b",
            v: [
                "1f44b-1f3fb",
                "1f44b-1f3fc",
                "1f44b-1f3fd",
                "1f44b-1f3fe",
                "1f44b-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "raised",
                "backhand",
                "raised back of hand"
            ],
            u: "1f91a",
            v: [
                "1f91a-1f3fb",
                "1f91a-1f3fc",
                "1f91a-1f3fd",
                "1f91a-1f3fe",
                "1f91a-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "hand",
                "finger",
                "splayed",
                "hand with fingers splayed"
            ],
            u: "1f590-fe0f",
            v: [
                "1f590-1f3fb",
                "1f590-1f3fc",
                "1f590-1f3fd",
                "1f590-1f3fe",
                "1f590-1f3ff"
            ],
            a: "0.7"
        },
        {
            n: [
                "hand",
                "high 5",
                "high five",
                "raised hand"
            ],
            u: "270b",
            v: [
                "270b-1f3fb",
                "270b-1f3fc",
                "270b-1f3fd",
                "270b-1f3fe",
                "270b-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "hand",
                "spock",
                "finger",
                "vulcan",
                "vulcan salute"
            ],
            u: "1f596",
            v: [
                "1f596-1f3fb",
                "1f596-1f3fc",
                "1f596-1f3fd",
                "1f596-1f3fe",
                "1f596-1f3ff"
            ],
            a: "1"
        },
        {
            n: [
                "hand",
                "right",
                "rightward",
                "rightwards hand"
            ],
            u: "1faf1",
            v: [
                "1faf1-1f3fb",
                "1faf1-1f3fc",
                "1faf1-1f3fd",
                "1faf1-1f3fe",
                "1faf1-1f3ff"
            ],
            a: "14"
        },
        {
            n: [
                "hand",
                "left",
                "leftward",
                "leftwards hand"
            ],
            u: "1faf2",
            v: [
                "1faf2-1f3fb",
                "1faf2-1f3fc",
                "1faf2-1f3fd",
                "1faf2-1f3fe",
                "1faf2-1f3ff"
            ],
            a: "14"
        },
        {
            n: [
                "drop",
                "shoo",
                "dismiss",
                "palm down hand"
            ],
            u: "1faf3",
            v: [
                "1faf3-1f3fb",
                "1faf3-1f3fc",
                "1faf3-1f3fd",
                "1faf3-1f3fe",
                "1faf3-1f3ff"
            ],
            a: "14"
        },
        {
            n: [
                "come",
                "catch",
                "offer",
                "beckon",
                "palm up hand"
            ],
            u: "1faf4",
            v: [
                "1faf4-1f3fb",
                "1faf4-1f3fc",
                "1faf4-1f3fd",
                "1faf4-1f3fe",
                "1faf4-1f3ff"
            ],
            a: "14"
        },
        {
            n: [
                "push",
                "stop",
                "wait",
                "refuse",
                "leftward",
                "high five",
                "leftwards pushing hand"
            ],
            u: "1faf7",
            v: [
                "1faf7-1f3fb",
                "1faf7-1f3fc",
                "1faf7-1f3fd",
                "1faf7-1f3fe",
                "1faf7-1f3ff"
            ],
            a: "15"
        },
        {
            n: [
                "push",
                "stop",
                "wait",
                "refuse",
                "high five",
                "rightward",
                "rightwards pushing hand"
            ],
            u: "1faf8",
            v: [
                "1faf8-1f3fb",
                "1faf8-1f3fc",
                "1faf8-1f3fd",
                "1faf8-1f3fe",
                "1faf8-1f3ff"
            ],
            a: "15"
        },
        {
            n: [
                "ok",
                "hand",
                "OK hand"
            ],
            u: "1f44c",
            v: [
                "1f44c-1f3fb",
                "1f44c-1f3fc",
                "1f44c-1f3fd",
                "1f44c-1f3fe",
                "1f44c-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "fingers",
                "pinched",
                "sarcastic",
                "hand gesture",
                "interrogation",
                "pinched fingers"
            ],
            u: "1f90c",
            v: [
                "1f90c-1f3fb",
                "1f90c-1f3fc",
                "1f90c-1f3fd",
                "1f90c-1f3fe",
                "1f90c-1f3ff"
            ],
            a: "13"
        },
        {
            n: [
                "small amount",
                "pinching hand"
            ],
            u: "1f90f",
            v: [
                "1f90f-1f3fb",
                "1f90f-1f3fc",
                "1f90f-1f3fd",
                "1f90f-1f3fe",
                "1f90f-1f3ff"
            ],
            a: "12"
        },
        {
            n: [
                "v",
                "hand",
                "victory",
                "victory hand"
            ],
            u: "270c-fe0f",
            v: [
                "270c-1f3fb",
                "270c-1f3fc",
                "270c-1f3fd",
                "270c-1f3fe",
                "270c-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "hand",
                "luck",
                "cross",
                "finger",
                "crossed fingers"
            ],
            u: "1f91e",
            v: [
                "1f91e-1f3fb",
                "1f91e-1f3fc",
                "1f91e-1f3fd",
                "1f91e-1f3fe",
                "1f91e-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "love",
                "snap",
                "heart",
                "money",
                "expensive",
                "hand with index finger and thumb crossed"
            ],
            u: "1faf0",
            v: [
                "1faf0-1f3fb",
                "1faf0-1f3fc",
                "1faf0-1f3fd",
                "1faf0-1f3fe",
                "1faf0-1f3ff"
            ],
            a: "14"
        },
        {
            n: [
                "ily",
                "hand",
                "love you gesture"
            ],
            u: "1f91f",
            v: [
                "1f91f-1f3fb",
                "1f91f-1f3fc",
                "1f91f-1f3fd",
                "1f91f-1f3fe",
                "1f91f-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "hand",
                "horns",
                "finger",
                "rock on",
                "sign of the horns"
            ],
            u: "1f918",
            v: [
                "1f918-1f3fb",
                "1f918-1f3fc",
                "1f918-1f3fd",
                "1f918-1f3fe",
                "1f918-1f3ff"
            ],
            a: "1"
        },
        {
            n: [
                "call",
                "hand",
                "shaka",
                "hang loose",
                "call me hand"
            ],
            u: "1f919",
            v: [
                "1f919-1f3fb",
                "1f919-1f3fc",
                "1f919-1f3fd",
                "1f919-1f3fe",
                "1f919-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "hand",
                "index",
                "point",
                "finger",
                "backhand",
                "backhand index pointing left"
            ],
            u: "1f448",
            v: [
                "1f448-1f3fb",
                "1f448-1f3fc",
                "1f448-1f3fd",
                "1f448-1f3fe",
                "1f448-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "hand",
                "index",
                "point",
                "finger",
                "backhand",
                "backhand index pointing right"
            ],
            u: "1f449",
            v: [
                "1f449-1f3fb",
                "1f449-1f3fc",
                "1f449-1f3fd",
                "1f449-1f3fe",
                "1f449-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "up",
                "hand",
                "point",
                "finger",
                "backhand",
                "backhand index pointing up"
            ],
            u: "1f446",
            v: [
                "1f446-1f3fb",
                "1f446-1f3fc",
                "1f446-1f3fd",
                "1f446-1f3fe",
                "1f446-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "hand",
                "finger",
                "middle finger"
            ],
            u: "1f595",
            v: [
                "1f595-1f3fb",
                "1f595-1f3fc",
                "1f595-1f3fd",
                "1f595-1f3fe",
                "1f595-1f3ff"
            ],
            a: "1"
        },
        {
            n: [
                "down",
                "hand",
                "point",
                "finger",
                "backhand",
                "backhand index pointing down"
            ],
            u: "1f447",
            v: [
                "1f447-1f3fb",
                "1f447-1f3fc",
                "1f447-1f3fd",
                "1f447-1f3fe",
                "1f447-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "up",
                "hand",
                "index",
                "point",
                "finger",
                "index pointing up"
            ],
            u: "261d-fe0f",
            v: [
                "261d-1f3fb",
                "261d-1f3fc",
                "261d-1f3fd",
                "261d-1f3fe",
                "261d-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "you",
                "point",
                "index pointing at the viewer"
            ],
            u: "1faf5",
            v: [
                "1faf5-1f3fb",
                "1faf5-1f3fc",
                "1faf5-1f3fd",
                "1faf5-1f3fe",
                "1faf5-1f3ff"
            ],
            a: "14"
        },
        {
            n: [
                "+1",
                "up",
                "hand",
                "thumb",
                "thumbs up"
            ],
            u: "1f44d",
            v: [
                "1f44d-1f3fb",
                "1f44d-1f3fc",
                "1f44d-1f3fd",
                "1f44d-1f3fe",
                "1f44d-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                " 1",
                "down",
                "hand",
                "thumb",
                "thumbs down"
            ],
            u: "1f44e",
            v: [
                "1f44e-1f3fb",
                "1f44e-1f3fc",
                "1f44e-1f3fd",
                "1f44e-1f3fe",
                "1f44e-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "fist",
                "hand",
                "punch",
                "clenched",
                "raised fist"
            ],
            u: "270a",
            v: [
                "270a-1f3fb",
                "270a-1f3fc",
                "270a-1f3fd",
                "270a-1f3fe",
                "270a-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "fist",
                "hand",
                "punch",
                "clenched",
                "oncoming fist"
            ],
            u: "1f44a",
            v: [
                "1f44a-1f3fb",
                "1f44a-1f3fc",
                "1f44a-1f3fd",
                "1f44a-1f3fe",
                "1f44a-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "fist",
                "leftwards",
                "left facing fist"
            ],
            u: "1f91b",
            v: [
                "1f91b-1f3fb",
                "1f91b-1f3fc",
                "1f91b-1f3fd",
                "1f91b-1f3fe",
                "1f91b-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "fist",
                "rightwards",
                "right facing fist"
            ],
            u: "1f91c",
            v: [
                "1f91c-1f3fb",
                "1f91c-1f3fc",
                "1f91c-1f3fd",
                "1f91c-1f3fe",
                "1f91c-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "clap",
                "hand",
                "clapping hands"
            ],
            u: "1f44f",
            v: [
                "1f44f-1f3fb",
                "1f44f-1f3fc",
                "1f44f-1f3fd",
                "1f44f-1f3fe",
                "1f44f-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "hand",
                "hooray",
                "raised",
                "gesture",
                "celebration",
                "raising hands"
            ],
            u: "1f64c",
            v: [
                "1f64c-1f3fb",
                "1f64c-1f3fc",
                "1f64c-1f3fd",
                "1f64c-1f3fe",
                "1f64c-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "love",
                "heart hands"
            ],
            u: "1faf6",
            v: [
                "1faf6-1f3fb",
                "1faf6-1f3fc",
                "1faf6-1f3fd",
                "1faf6-1f3fe",
                "1faf6-1f3ff"
            ],
            a: "14"
        },
        {
            n: [
                "hand",
                "open",
                "open hands"
            ],
            u: "1f450",
            v: [
                "1f450-1f3fb",
                "1f450-1f3fc",
                "1f450-1f3fd",
                "1f450-1f3fe",
                "1f450-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "prayer",
                "palms up together"
            ],
            u: "1f932",
            v: [
                "1f932-1f3fb",
                "1f932-1f3fc",
                "1f932-1f3fd",
                "1f932-1f3fe",
                "1f932-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "hand",
                "shake",
                "meeting",
                "handshake",
                "agreement"
            ],
            u: "1f91d",
            v: [
                "1f91d-1f3fb",
                "1f91d-1f3fc",
                "1f91d-1f3fd",
                "1f91d-1f3fe",
                "1f91d-1f3ff",
                "1faf1-1f3fb-200d-1faf2-1f3fc",
                "1faf1-1f3fb-200d-1faf2-1f3fd",
                "1faf1-1f3fb-200d-1faf2-1f3fe",
                "1faf1-1f3fb-200d-1faf2-1f3ff",
                "1faf1-1f3fc-200d-1faf2-1f3fb",
                "1faf1-1f3fc-200d-1faf2-1f3fd",
                "1faf1-1f3fc-200d-1faf2-1f3fe",
                "1faf1-1f3fc-200d-1faf2-1f3ff",
                "1faf1-1f3fd-200d-1faf2-1f3fb",
                "1faf1-1f3fd-200d-1faf2-1f3fc",
                "1faf1-1f3fd-200d-1faf2-1f3fe",
                "1faf1-1f3fd-200d-1faf2-1f3ff",
                "1faf1-1f3fe-200d-1faf2-1f3fb",
                "1faf1-1f3fe-200d-1faf2-1f3fc",
                "1faf1-1f3fe-200d-1faf2-1f3fd",
                "1faf1-1f3fe-200d-1faf2-1f3ff",
                "1faf1-1f3ff-200d-1faf2-1f3fb",
                "1faf1-1f3ff-200d-1faf2-1f3fc",
                "1faf1-1f3ff-200d-1faf2-1f3fd",
                "1faf1-1f3ff-200d-1faf2-1f3fe"
            ],
            a: "3"
        },
        {
            n: [
                "ask",
                "hand",
                "pray",
                "high 5",
                "please",
                "thanks",
                "high five",
                "folded hands"
            ],
            u: "1f64f",
            v: [
                "1f64f-1f3fb",
                "1f64f-1f3fc",
                "1f64f-1f3fd",
                "1f64f-1f3fe",
                "1f64f-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "hand",
                "write",
                "writing hand"
            ],
            u: "270d-fe0f",
            v: [
                "270d-1f3fb",
                "270d-1f3fc",
                "270d-1f3fd",
                "270d-1f3fe",
                "270d-1f3ff"
            ],
            a: "0.7"
        },
        {
            n: [
                "care",
                "nail",
                "polish",
                "manicure",
                "cosmetics",
                "nail polish"
            ],
            u: "1f485",
            v: [
                "1f485-1f3fb",
                "1f485-1f3fc",
                "1f485-1f3fd",
                "1f485-1f3fe",
                "1f485-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "phone",
                "selfie",
                "camera"
            ],
            u: "1f933",
            v: [
                "1f933-1f3fb",
                "1f933-1f3fc",
                "1f933-1f3fd",
                "1f933-1f3fe",
                "1f933-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "flex",
                "comic",
                "biceps",
                "muscle",
                "flexed biceps"
            ],
            u: "1f4aa",
            v: [
                "1f4aa-1f3fb",
                "1f4aa-1f3fc",
                "1f4aa-1f3fd",
                "1f4aa-1f3fe",
                "1f4aa-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "prosthetic",
                "accessibility",
                "mechanical arm"
            ],
            u: "1f9be",
            a: "12"
        },
        {
            n: [
                "prosthetic",
                "accessibility",
                "mechanical leg"
            ],
            u: "1f9bf",
            a: "12"
        },
        {
            n: [
                "leg",
                "kick",
                "limb"
            ],
            u: "1f9b5",
            v: [
                "1f9b5-1f3fb",
                "1f9b5-1f3fc",
                "1f9b5-1f3fd",
                "1f9b5-1f3fe",
                "1f9b5-1f3ff"
            ],
            a: "11"
        },
        {
            n: [
                "foot",
                "kick",
                "stomp"
            ],
            u: "1f9b6",
            v: [
                "1f9b6-1f3fb",
                "1f9b6-1f3fc",
                "1f9b6-1f3fd",
                "1f9b6-1f3fe",
                "1f9b6-1f3ff"
            ],
            a: "11"
        },
        {
            n: [
                "ear",
                "body"
            ],
            u: "1f442",
            v: [
                "1f442-1f3fb",
                "1f442-1f3fc",
                "1f442-1f3fd",
                "1f442-1f3fe",
                "1f442-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "accessibility",
                "hard of hearing",
                "ear with hearing aid"
            ],
            u: "1f9bb",
            v: [
                "1f9bb-1f3fb",
                "1f9bb-1f3fc",
                "1f9bb-1f3fd",
                "1f9bb-1f3fe",
                "1f9bb-1f3ff"
            ],
            a: "12"
        },
        {
            n: [
                "nose",
                "body"
            ],
            u: "1f443",
            v: [
                "1f443-1f3fb",
                "1f443-1f3fc",
                "1f443-1f3fd",
                "1f443-1f3fe",
                "1f443-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "brain",
                "intelligent"
            ],
            u: "1f9e0",
            a: "5"
        },
        {
            n: [
                "heart",
                "organ",
                "pulse",
                "anatomical",
                "cardiology",
                "anatomical heart"
            ],
            u: "1fac0",
            a: "13"
        },
        {
            n: [
                "lungs",
                "organ",
                "breath",
                "exhalation",
                "inhalation",
                "respiration"
            ],
            u: "1fac1",
            a: "13"
        },
        {
            n: [
                "tooth",
                "dentist"
            ],
            u: "1f9b7",
            a: "11"
        },
        {
            n: [
                "bone",
                "skeleton"
            ],
            u: "1f9b4",
            a: "11"
        },
        {
            n: [
                "eye",
                "eyes",
                "face"
            ],
            u: "1f440",
            a: "0.6"
        },
        {
            n: [
                "eye",
                "body"
            ],
            u: "1f441-fe0f",
            a: "0.7"
        },
        {
            n: [
                "body",
                "tongue"
            ],
            u: "1f445",
            a: "0.6"
        },
        {
            n: [
                "lips",
                "mouth"
            ],
            u: "1f444",
            a: "0.6"
        },
        {
            n: [
                "fear",
                "anxious",
                "nervous",
                "worried",
                "flirting",
                "biting lip",
                "uncomfortable"
            ],
            u: "1fae6",
            a: "14"
        },
        {
            n: [
                "baby",
                "young"
            ],
            u: "1f476",
            v: [
                "1f476-1f3fb",
                "1f476-1f3fc",
                "1f476-1f3fd",
                "1f476-1f3fe",
                "1f476-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "child",
                "young",
                "gender neutral",
                "unspecified gender"
            ],
            u: "1f9d2",
            v: [
                "1f9d2-1f3fb",
                "1f9d2-1f3fc",
                "1f9d2-1f3fd",
                "1f9d2-1f3fe",
                "1f9d2-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "boy",
                "young"
            ],
            u: "1f466",
            v: [
                "1f466-1f3fb",
                "1f466-1f3fc",
                "1f466-1f3fd",
                "1f466-1f3fe",
                "1f466-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "girl",
                "virgo",
                "young",
                "zodiac"
            ],
            u: "1f467",
            v: [
                "1f467-1f3fb",
                "1f467-1f3fc",
                "1f467-1f3fd",
                "1f467-1f3fe",
                "1f467-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "adult",
                "person",
                "gender neutral",
                "unspecified gender"
            ],
            u: "1f9d1",
            v: [
                "1f9d1-1f3fb",
                "1f9d1-1f3fc",
                "1f9d1-1f3fd",
                "1f9d1-1f3fe",
                "1f9d1-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "hair",
                "blond",
                "person: blond hair",
                "blond haired person"
            ],
            u: "1f471",
            v: [
                "1f471-1f3fb",
                "1f471-1f3fc",
                "1f471-1f3fd",
                "1f471-1f3fe",
                "1f471-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "adult"
            ],
            u: "1f468",
            v: [
                "1f468-1f3fb",
                "1f468-1f3fc",
                "1f468-1f3fd",
                "1f468-1f3fe",
                "1f468-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "beard",
                "person",
                "person: beard"
            ],
            u: "1f9d4",
            v: [
                "1f9d4-1f3fb",
                "1f9d4-1f3fc",
                "1f9d4-1f3fd",
                "1f9d4-1f3fe",
                "1f9d4-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "man",
                "beard",
                "man: beard"
            ],
            u: "1f9d4-200d-2642-fe0f",
            v: [
                "1f9d4-1f3fb-200d-2642-fe0f",
                "1f9d4-1f3fc-200d-2642-fe0f",
                "1f9d4-1f3fd-200d-2642-fe0f",
                "1f9d4-1f3fe-200d-2642-fe0f",
                "1f9d4-1f3ff-200d-2642-fe0f"
            ],
            a: "13.1"
        },
        {
            n: [
                "beard",
                "woman",
                "woman: beard"
            ],
            u: "1f9d4-200d-2640-fe0f",
            v: [
                "1f9d4-1f3fb-200d-2640-fe0f",
                "1f9d4-1f3fc-200d-2640-fe0f",
                "1f9d4-1f3fd-200d-2640-fe0f",
                "1f9d4-1f3fe-200d-2640-fe0f",
                "1f9d4-1f3ff-200d-2640-fe0f"
            ],
            a: "13.1"
        },
        {
            n: [
                "man",
                "adult",
                "red hair",
                "man: red hair"
            ],
            u: "1f468-200d-1f9b0",
            v: [
                "1f468-1f3fb-200d-1f9b0",
                "1f468-1f3fc-200d-1f9b0",
                "1f468-1f3fd-200d-1f9b0",
                "1f468-1f3fe-200d-1f9b0",
                "1f468-1f3ff-200d-1f9b0"
            ],
            a: "11"
        },
        {
            n: [
                "man",
                "adult",
                "curly hair",
                "man: curly hair"
            ],
            u: "1f468-200d-1f9b1",
            v: [
                "1f468-1f3fb-200d-1f9b1",
                "1f468-1f3fc-200d-1f9b1",
                "1f468-1f3fd-200d-1f9b1",
                "1f468-1f3fe-200d-1f9b1",
                "1f468-1f3ff-200d-1f9b1"
            ],
            a: "11"
        },
        {
            n: [
                "man",
                "adult",
                "white hair",
                "man: white hair"
            ],
            u: "1f468-200d-1f9b3",
            v: [
                "1f468-1f3fb-200d-1f9b3",
                "1f468-1f3fc-200d-1f9b3",
                "1f468-1f3fd-200d-1f9b3",
                "1f468-1f3fe-200d-1f9b3",
                "1f468-1f3ff-200d-1f9b3"
            ],
            a: "11"
        },
        {
            n: [
                "man",
                "bald",
                "adult",
                "man: bald"
            ],
            u: "1f468-200d-1f9b2",
            v: [
                "1f468-1f3fb-200d-1f9b2",
                "1f468-1f3fc-200d-1f9b2",
                "1f468-1f3fd-200d-1f9b2",
                "1f468-1f3fe-200d-1f9b2",
                "1f468-1f3ff-200d-1f9b2"
            ],
            a: "11"
        },
        {
            n: [
                "woman",
                "adult"
            ],
            u: "1f469",
            v: [
                "1f469-1f3fb",
                "1f469-1f3fc",
                "1f469-1f3fd",
                "1f469-1f3fe",
                "1f469-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "adult",
                "woman",
                "red hair",
                "woman: red hair"
            ],
            u: "1f469-200d-1f9b0",
            v: [
                "1f469-1f3fb-200d-1f9b0",
                "1f469-1f3fc-200d-1f9b0",
                "1f469-1f3fd-200d-1f9b0",
                "1f469-1f3fe-200d-1f9b0",
                "1f469-1f3ff-200d-1f9b0"
            ],
            a: "11"
        },
        {
            n: [
                "adult",
                "person",
                "red hair",
                "gender neutral",
                "person: red hair",
                "unspecified gender"
            ],
            u: "1f9d1-200d-1f9b0",
            v: [
                "1f9d1-1f3fb-200d-1f9b0",
                "1f9d1-1f3fc-200d-1f9b0",
                "1f9d1-1f3fd-200d-1f9b0",
                "1f9d1-1f3fe-200d-1f9b0",
                "1f9d1-1f3ff-200d-1f9b0"
            ],
            a: "12.1"
        },
        {
            n: [
                "adult",
                "woman",
                "curly hair",
                "woman: curly hair"
            ],
            u: "1f469-200d-1f9b1",
            v: [
                "1f469-1f3fb-200d-1f9b1",
                "1f469-1f3fc-200d-1f9b1",
                "1f469-1f3fd-200d-1f9b1",
                "1f469-1f3fe-200d-1f9b1",
                "1f469-1f3ff-200d-1f9b1"
            ],
            a: "11"
        },
        {
            n: [
                "adult",
                "person",
                "curly hair",
                "gender neutral",
                "person: curly hair",
                "unspecified gender"
            ],
            u: "1f9d1-200d-1f9b1",
            v: [
                "1f9d1-1f3fb-200d-1f9b1",
                "1f9d1-1f3fc-200d-1f9b1",
                "1f9d1-1f3fd-200d-1f9b1",
                "1f9d1-1f3fe-200d-1f9b1",
                "1f9d1-1f3ff-200d-1f9b1"
            ],
            a: "12.1"
        },
        {
            n: [
                "adult",
                "woman",
                "white hair",
                "woman: white hair"
            ],
            u: "1f469-200d-1f9b3",
            v: [
                "1f469-1f3fb-200d-1f9b3",
                "1f469-1f3fc-200d-1f9b3",
                "1f469-1f3fd-200d-1f9b3",
                "1f469-1f3fe-200d-1f9b3",
                "1f469-1f3ff-200d-1f9b3"
            ],
            a: "11"
        },
        {
            n: [
                "adult",
                "person",
                "white hair",
                "gender neutral",
                "person: white hair",
                "unspecified gender"
            ],
            u: "1f9d1-200d-1f9b3",
            v: [
                "1f9d1-1f3fb-200d-1f9b3",
                "1f9d1-1f3fc-200d-1f9b3",
                "1f9d1-1f3fd-200d-1f9b3",
                "1f9d1-1f3fe-200d-1f9b3",
                "1f9d1-1f3ff-200d-1f9b3"
            ],
            a: "12.1"
        },
        {
            n: [
                "bald",
                "adult",
                "woman",
                "woman: bald"
            ],
            u: "1f469-200d-1f9b2",
            v: [
                "1f469-1f3fb-200d-1f9b2",
                "1f469-1f3fc-200d-1f9b2",
                "1f469-1f3fd-200d-1f9b2",
                "1f469-1f3fe-200d-1f9b2",
                "1f469-1f3ff-200d-1f9b2"
            ],
            a: "11"
        },
        {
            n: [
                "bald",
                "adult",
                "person",
                "person: bald",
                "gender neutral",
                "unspecified gender"
            ],
            u: "1f9d1-200d-1f9b2",
            v: [
                "1f9d1-1f3fb-200d-1f9b2",
                "1f9d1-1f3fc-200d-1f9b2",
                "1f9d1-1f3fd-200d-1f9b2",
                "1f9d1-1f3fe-200d-1f9b2",
                "1f9d1-1f3ff-200d-1f9b2"
            ],
            a: "12.1"
        },
        {
            n: [
                "hair",
                "woman",
                "blonde",
                "woman: blond hair",
                "blond haired woman"
            ],
            u: "1f471-200d-2640-fe0f",
            v: [
                "1f471-1f3fb-200d-2640-fe0f",
                "1f471-1f3fc-200d-2640-fe0f",
                "1f471-1f3fd-200d-2640-fe0f",
                "1f471-1f3fe-200d-2640-fe0f",
                "1f471-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "man",
                "hair",
                "blond",
                "man: blond hair",
                "blond haired man"
            ],
            u: "1f471-200d-2642-fe0f",
            v: [
                "1f471-1f3fb-200d-2642-fe0f",
                "1f471-1f3fc-200d-2642-fe0f",
                "1f471-1f3fd-200d-2642-fe0f",
                "1f471-1f3fe-200d-2642-fe0f",
                "1f471-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "old",
                "adult",
                "older person",
                "gender neutral",
                "unspecified gender"
            ],
            u: "1f9d3",
            v: [
                "1f9d3-1f3fb",
                "1f9d3-1f3fc",
                "1f9d3-1f3fd",
                "1f9d3-1f3fe",
                "1f9d3-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "man",
                "old",
                "adult",
                "old man"
            ],
            u: "1f474",
            v: [
                "1f474-1f3fb",
                "1f474-1f3fc",
                "1f474-1f3fd",
                "1f474-1f3fe",
                "1f474-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "old",
                "adult",
                "woman",
                "old woman"
            ],
            u: "1f475",
            v: [
                "1f475-1f3fb",
                "1f475-1f3fc",
                "1f475-1f3fd",
                "1f475-1f3fe",
                "1f475-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "frown",
                "gesture",
                "person frowning"
            ],
            u: "1f64d",
            v: [
                "1f64d-1f3fb",
                "1f64d-1f3fc",
                "1f64d-1f3fd",
                "1f64d-1f3fe",
                "1f64d-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "gesture",
                "frowning",
                "man frowning"
            ],
            u: "1f64d-200d-2642-fe0f",
            v: [
                "1f64d-1f3fb-200d-2642-fe0f",
                "1f64d-1f3fc-200d-2642-fe0f",
                "1f64d-1f3fd-200d-2642-fe0f",
                "1f64d-1f3fe-200d-2642-fe0f",
                "1f64d-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "gesture",
                "frowning",
                "woman frowning"
            ],
            u: "1f64d-200d-2640-fe0f",
            v: [
                "1f64d-1f3fb-200d-2640-fe0f",
                "1f64d-1f3fc-200d-2640-fe0f",
                "1f64d-1f3fd-200d-2640-fe0f",
                "1f64d-1f3fe-200d-2640-fe0f",
                "1f64d-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "gesture",
                "pouting",
                "person pouting"
            ],
            u: "1f64e",
            v: [
                "1f64e-1f3fb",
                "1f64e-1f3fc",
                "1f64e-1f3fd",
                "1f64e-1f3fe",
                "1f64e-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "gesture",
                "pouting",
                "man pouting"
            ],
            u: "1f64e-200d-2642-fe0f",
            v: [
                "1f64e-1f3fb-200d-2642-fe0f",
                "1f64e-1f3fc-200d-2642-fe0f",
                "1f64e-1f3fd-200d-2642-fe0f",
                "1f64e-1f3fe-200d-2642-fe0f",
                "1f64e-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "gesture",
                "pouting",
                "woman pouting"
            ],
            u: "1f64e-200d-2640-fe0f",
            v: [
                "1f64e-1f3fb-200d-2640-fe0f",
                "1f64e-1f3fc-200d-2640-fe0f",
                "1f64e-1f3fd-200d-2640-fe0f",
                "1f64e-1f3fe-200d-2640-fe0f",
                "1f64e-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "hand",
                "gesture",
                "forbidden",
                "prohibited",
                "person gesturing NO",
                "person gesturing no"
            ],
            u: "1f645",
            v: [
                "1f645-1f3fb",
                "1f645-1f3fc",
                "1f645-1f3fd",
                "1f645-1f3fe",
                "1f645-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "hand",
                "gesture",
                "forbidden",
                "prohibited",
                "man gesturing NO",
                "man gesturing no"
            ],
            u: "1f645-200d-2642-fe0f",
            v: [
                "1f645-1f3fb-200d-2642-fe0f",
                "1f645-1f3fc-200d-2642-fe0f",
                "1f645-1f3fd-200d-2642-fe0f",
                "1f645-1f3fe-200d-2642-fe0f",
                "1f645-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "hand",
                "woman",
                "gesture",
                "forbidden",
                "prohibited",
                "woman gesturing NO",
                "woman gesturing no"
            ],
            u: "1f645-200d-2640-fe0f",
            v: [
                "1f645-1f3fb-200d-2640-fe0f",
                "1f645-1f3fc-200d-2640-fe0f",
                "1f645-1f3fd-200d-2640-fe0f",
                "1f645-1f3fe-200d-2640-fe0f",
                "1f645-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "ok",
                "hand",
                "gesture",
                "person gesturing OK",
                "person gesturing ok"
            ],
            u: "1f646",
            v: [
                "1f646-1f3fb",
                "1f646-1f3fc",
                "1f646-1f3fd",
                "1f646-1f3fe",
                "1f646-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "ok",
                "man",
                "hand",
                "gesture",
                "man gesturing OK",
                "man gesturing ok"
            ],
            u: "1f646-200d-2642-fe0f",
            v: [
                "1f646-1f3fb-200d-2642-fe0f",
                "1f646-1f3fc-200d-2642-fe0f",
                "1f646-1f3fd-200d-2642-fe0f",
                "1f646-1f3fe-200d-2642-fe0f",
                "1f646-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "ok",
                "hand",
                "woman",
                "gesture",
                "woman gesturing OK",
                "woman gesturing ok"
            ],
            u: "1f646-200d-2640-fe0f",
            v: [
                "1f646-1f3fb-200d-2640-fe0f",
                "1f646-1f3fc-200d-2640-fe0f",
                "1f646-1f3fd-200d-2640-fe0f",
                "1f646-1f3fe-200d-2640-fe0f",
                "1f646-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "hand",
                "help",
                "sassy",
                "tipping",
                "information",
                "person tipping hand"
            ],
            u: "1f481",
            v: [
                "1f481-1f3fb",
                "1f481-1f3fc",
                "1f481-1f3fd",
                "1f481-1f3fe",
                "1f481-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "sassy",
                "tipping hand",
                "man tipping hand"
            ],
            u: "1f481-200d-2642-fe0f",
            v: [
                "1f481-1f3fb-200d-2642-fe0f",
                "1f481-1f3fc-200d-2642-fe0f",
                "1f481-1f3fd-200d-2642-fe0f",
                "1f481-1f3fe-200d-2642-fe0f",
                "1f481-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "sassy",
                "woman",
                "tipping hand",
                "woman tipping hand"
            ],
            u: "1f481-200d-2640-fe0f",
            v: [
                "1f481-1f3fb-200d-2640-fe0f",
                "1f481-1f3fc-200d-2640-fe0f",
                "1f481-1f3fd-200d-2640-fe0f",
                "1f481-1f3fe-200d-2640-fe0f",
                "1f481-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "hand",
                "happy",
                "raised",
                "gesture",
                "person raising hand"
            ],
            u: "1f64b",
            v: [
                "1f64b-1f3fb",
                "1f64b-1f3fc",
                "1f64b-1f3fd",
                "1f64b-1f3fe",
                "1f64b-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "gesture",
                "raising hand",
                "man raising hand"
            ],
            u: "1f64b-200d-2642-fe0f",
            v: [
                "1f64b-1f3fb-200d-2642-fe0f",
                "1f64b-1f3fc-200d-2642-fe0f",
                "1f64b-1f3fd-200d-2642-fe0f",
                "1f64b-1f3fe-200d-2642-fe0f",
                "1f64b-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "gesture",
                "raising hand",
                "woman raising hand"
            ],
            u: "1f64b-200d-2640-fe0f",
            v: [
                "1f64b-1f3fb-200d-2640-fe0f",
                "1f64b-1f3fc-200d-2640-fe0f",
                "1f64b-1f3fd-200d-2640-fe0f",
                "1f64b-1f3fe-200d-2640-fe0f",
                "1f64b-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "ear",
                "deaf",
                "hear",
                "deaf person",
                "accessibility"
            ],
            u: "1f9cf",
            v: [
                "1f9cf-1f3fb",
                "1f9cf-1f3fc",
                "1f9cf-1f3fd",
                "1f9cf-1f3fe",
                "1f9cf-1f3ff"
            ],
            a: "12"
        },
        {
            n: [
                "man",
                "deaf",
                "deaf man"
            ],
            u: "1f9cf-200d-2642-fe0f",
            v: [
                "1f9cf-1f3fb-200d-2642-fe0f",
                "1f9cf-1f3fc-200d-2642-fe0f",
                "1f9cf-1f3fd-200d-2642-fe0f",
                "1f9cf-1f3fe-200d-2642-fe0f",
                "1f9cf-1f3ff-200d-2642-fe0f"
            ],
            a: "12"
        },
        {
            n: [
                "deaf",
                "woman",
                "deaf woman"
            ],
            u: "1f9cf-200d-2640-fe0f",
            v: [
                "1f9cf-1f3fb-200d-2640-fe0f",
                "1f9cf-1f3fc-200d-2640-fe0f",
                "1f9cf-1f3fd-200d-2640-fe0f",
                "1f9cf-1f3fe-200d-2640-fe0f",
                "1f9cf-1f3ff-200d-2640-fe0f"
            ],
            a: "12"
        },
        {
            n: [
                "bow",
                "sorry",
                "apology",
                "gesture",
                "person bowing"
            ],
            u: "1f647",
            v: [
                "1f647-1f3fb",
                "1f647-1f3fc",
                "1f647-1f3fd",
                "1f647-1f3fe",
                "1f647-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "favor",
                "sorry",
                "bowing",
                "apology",
                "gesture",
                "man bowing"
            ],
            u: "1f647-200d-2642-fe0f",
            v: [
                "1f647-1f3fb-200d-2642-fe0f",
                "1f647-1f3fc-200d-2642-fe0f",
                "1f647-1f3fd-200d-2642-fe0f",
                "1f647-1f3fe-200d-2642-fe0f",
                "1f647-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "favor",
                "sorry",
                "woman",
                "bowing",
                "apology",
                "gesture",
                "woman bowing"
            ],
            u: "1f647-200d-2640-fe0f",
            v: [
                "1f647-1f3fb-200d-2640-fe0f",
                "1f647-1f3fc-200d-2640-fe0f",
                "1f647-1f3fd-200d-2640-fe0f",
                "1f647-1f3fe-200d-2640-fe0f",
                "1f647-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "face",
                "palm",
                "disbelief",
                "exasperation",
                "person facepalming"
            ],
            u: "1f926",
            v: [
                "1f926-1f3fb",
                "1f926-1f3fc",
                "1f926-1f3fd",
                "1f926-1f3fe",
                "1f926-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "man",
                "facepalm",
                "disbelief",
                "exasperation",
                "man facepalming"
            ],
            u: "1f926-200d-2642-fe0f",
            v: [
                "1f926-1f3fb-200d-2642-fe0f",
                "1f926-1f3fc-200d-2642-fe0f",
                "1f926-1f3fd-200d-2642-fe0f",
                "1f926-1f3fe-200d-2642-fe0f",
                "1f926-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "facepalm",
                "disbelief",
                "exasperation",
                "woman facepalming"
            ],
            u: "1f926-200d-2640-fe0f",
            v: [
                "1f926-1f3fb-200d-2640-fe0f",
                "1f926-1f3fc-200d-2640-fe0f",
                "1f926-1f3fd-200d-2640-fe0f",
                "1f926-1f3fe-200d-2640-fe0f",
                "1f926-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "doubt",
                "shrug",
                "ignorance",
                "indifference",
                "person shrugging"
            ],
            u: "1f937",
            v: [
                "1f937-1f3fb",
                "1f937-1f3fc",
                "1f937-1f3fd",
                "1f937-1f3fe",
                "1f937-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "man",
                "doubt",
                "shrug",
                "ignorance",
                "indifference",
                "man shrugging"
            ],
            u: "1f937-200d-2642-fe0f",
            v: [
                "1f937-1f3fb-200d-2642-fe0f",
                "1f937-1f3fc-200d-2642-fe0f",
                "1f937-1f3fd-200d-2642-fe0f",
                "1f937-1f3fe-200d-2642-fe0f",
                "1f937-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "doubt",
                "shrug",
                "woman",
                "ignorance",
                "indifference",
                "woman shrugging"
            ],
            u: "1f937-200d-2640-fe0f",
            v: [
                "1f937-1f3fb-200d-2640-fe0f",
                "1f937-1f3fc-200d-2640-fe0f",
                "1f937-1f3fd-200d-2640-fe0f",
                "1f937-1f3fe-200d-2640-fe0f",
                "1f937-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "nurse",
                "doctor",
                "therapist",
                "healthcare",
                "health worker"
            ],
            u: "1f9d1-200d-2695-fe0f",
            v: [
                "1f9d1-1f3fb-200d-2695-fe0f",
                "1f9d1-1f3fc-200d-2695-fe0f",
                "1f9d1-1f3fd-200d-2695-fe0f",
                "1f9d1-1f3fe-200d-2695-fe0f",
                "1f9d1-1f3ff-200d-2695-fe0f"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "nurse",
                "doctor",
                "therapist",
                "healthcare",
                "man health worker"
            ],
            u: "1f468-200d-2695-fe0f",
            v: [
                "1f468-1f3fb-200d-2695-fe0f",
                "1f468-1f3fc-200d-2695-fe0f",
                "1f468-1f3fd-200d-2695-fe0f",
                "1f468-1f3fe-200d-2695-fe0f",
                "1f468-1f3ff-200d-2695-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "nurse",
                "woman",
                "doctor",
                "therapist",
                "healthcare",
                "woman health worker"
            ],
            u: "1f469-200d-2695-fe0f",
            v: [
                "1f469-1f3fb-200d-2695-fe0f",
                "1f469-1f3fc-200d-2695-fe0f",
                "1f469-1f3fd-200d-2695-fe0f",
                "1f469-1f3fe-200d-2695-fe0f",
                "1f469-1f3ff-200d-2695-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "student",
                "graduate"
            ],
            u: "1f9d1-200d-1f393",
            v: [
                "1f9d1-1f3fb-200d-1f393",
                "1f9d1-1f3fc-200d-1f393",
                "1f9d1-1f3fd-200d-1f393",
                "1f9d1-1f3fe-200d-1f393",
                "1f9d1-1f3ff-200d-1f393"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "student",
                "graduate",
                "man student"
            ],
            u: "1f468-200d-1f393",
            v: [
                "1f468-1f3fb-200d-1f393",
                "1f468-1f3fc-200d-1f393",
                "1f468-1f3fd-200d-1f393",
                "1f468-1f3fe-200d-1f393",
                "1f468-1f3ff-200d-1f393"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "student",
                "graduate",
                "woman student"
            ],
            u: "1f469-200d-1f393",
            v: [
                "1f469-1f3fb-200d-1f393",
                "1f469-1f3fc-200d-1f393",
                "1f469-1f3fd-200d-1f393",
                "1f469-1f3fe-200d-1f393",
                "1f469-1f3ff-200d-1f393"
            ],
            a: "4"
        },
        {
            n: [
                "teacher",
                "lecturer",
                "professor",
                "instructor"
            ],
            u: "1f9d1-200d-1f3eb",
            v: [
                "1f9d1-1f3fb-200d-1f3eb",
                "1f9d1-1f3fc-200d-1f3eb",
                "1f9d1-1f3fd-200d-1f3eb",
                "1f9d1-1f3fe-200d-1f3eb",
                "1f9d1-1f3ff-200d-1f3eb"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "teacher",
                "lecturer",
                "professor",
                "instructor",
                "man teacher"
            ],
            u: "1f468-200d-1f3eb",
            v: [
                "1f468-1f3fb-200d-1f3eb",
                "1f468-1f3fc-200d-1f3eb",
                "1f468-1f3fd-200d-1f3eb",
                "1f468-1f3fe-200d-1f3eb",
                "1f468-1f3ff-200d-1f3eb"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "teacher",
                "lecturer",
                "professor",
                "instructor",
                "woman teacher"
            ],
            u: "1f469-200d-1f3eb",
            v: [
                "1f469-1f3fb-200d-1f3eb",
                "1f469-1f3fc-200d-1f3eb",
                "1f469-1f3fd-200d-1f3eb",
                "1f469-1f3fe-200d-1f3eb",
                "1f469-1f3ff-200d-1f3eb"
            ],
            a: "4"
        },
        {
            n: [
                "law",
                "judge",
                "scales",
                "justice"
            ],
            u: "1f9d1-200d-2696-fe0f",
            v: [
                "1f9d1-1f3fb-200d-2696-fe0f",
                "1f9d1-1f3fc-200d-2696-fe0f",
                "1f9d1-1f3fd-200d-2696-fe0f",
                "1f9d1-1f3fe-200d-2696-fe0f",
                "1f9d1-1f3ff-200d-2696-fe0f"
            ],
            a: "12.1"
        },
        {
            n: [
                "law",
                "man",
                "judge",
                "scales",
                "justice",
                "man judge"
            ],
            u: "1f468-200d-2696-fe0f",
            v: [
                "1f468-1f3fb-200d-2696-fe0f",
                "1f468-1f3fc-200d-2696-fe0f",
                "1f468-1f3fd-200d-2696-fe0f",
                "1f468-1f3fe-200d-2696-fe0f",
                "1f468-1f3ff-200d-2696-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "law",
                "judge",
                "woman",
                "scales",
                "justice",
                "woman judge"
            ],
            u: "1f469-200d-2696-fe0f",
            v: [
                "1f469-1f3fb-200d-2696-fe0f",
                "1f469-1f3fc-200d-2696-fe0f",
                "1f469-1f3fd-200d-2696-fe0f",
                "1f469-1f3fe-200d-2696-fe0f",
                "1f469-1f3ff-200d-2696-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "farmer",
                "rancher",
                "gardener"
            ],
            u: "1f9d1-200d-1f33e",
            v: [
                "1f9d1-1f3fb-200d-1f33e",
                "1f9d1-1f3fc-200d-1f33e",
                "1f9d1-1f3fd-200d-1f33e",
                "1f9d1-1f3fe-200d-1f33e",
                "1f9d1-1f3ff-200d-1f33e"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "farmer",
                "rancher",
                "gardener",
                "man farmer"
            ],
            u: "1f468-200d-1f33e",
            v: [
                "1f468-1f3fb-200d-1f33e",
                "1f468-1f3fc-200d-1f33e",
                "1f468-1f3fd-200d-1f33e",
                "1f468-1f3fe-200d-1f33e",
                "1f468-1f3ff-200d-1f33e"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "farmer",
                "rancher",
                "gardener",
                "woman farmer"
            ],
            u: "1f469-200d-1f33e",
            v: [
                "1f469-1f3fb-200d-1f33e",
                "1f469-1f3fc-200d-1f33e",
                "1f469-1f3fd-200d-1f33e",
                "1f469-1f3fe-200d-1f33e",
                "1f469-1f3ff-200d-1f33e"
            ],
            a: "4"
        },
        {
            n: [
                "cook",
                "chef"
            ],
            u: "1f9d1-200d-1f373",
            v: [
                "1f9d1-1f3fb-200d-1f373",
                "1f9d1-1f3fc-200d-1f373",
                "1f9d1-1f3fd-200d-1f373",
                "1f9d1-1f3fe-200d-1f373",
                "1f9d1-1f3ff-200d-1f373"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "chef",
                "cook",
                "man cook"
            ],
            u: "1f468-200d-1f373",
            v: [
                "1f468-1f3fb-200d-1f373",
                "1f468-1f3fc-200d-1f373",
                "1f468-1f3fd-200d-1f373",
                "1f468-1f3fe-200d-1f373",
                "1f468-1f3ff-200d-1f373"
            ],
            a: "4"
        },
        {
            n: [
                "chef",
                "cook",
                "woman",
                "woman cook"
            ],
            u: "1f469-200d-1f373",
            v: [
                "1f469-1f3fb-200d-1f373",
                "1f469-1f3fc-200d-1f373",
                "1f469-1f3fd-200d-1f373",
                "1f469-1f3fe-200d-1f373",
                "1f469-1f3ff-200d-1f373"
            ],
            a: "4"
        },
        {
            n: [
                "plumber",
                "mechanic",
                "electrician",
                "tradesperson"
            ],
            u: "1f9d1-200d-1f527",
            v: [
                "1f9d1-1f3fb-200d-1f527",
                "1f9d1-1f3fc-200d-1f527",
                "1f9d1-1f3fd-200d-1f527",
                "1f9d1-1f3fe-200d-1f527",
                "1f9d1-1f3ff-200d-1f527"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "plumber",
                "mechanic",
                "electrician",
                "man mechanic",
                "tradesperson"
            ],
            u: "1f468-200d-1f527",
            v: [
                "1f468-1f3fb-200d-1f527",
                "1f468-1f3fc-200d-1f527",
                "1f468-1f3fd-200d-1f527",
                "1f468-1f3fe-200d-1f527",
                "1f468-1f3ff-200d-1f527"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "plumber",
                "mechanic",
                "electrician",
                "tradesperson",
                "woman mechanic"
            ],
            u: "1f469-200d-1f527",
            v: [
                "1f469-1f3fb-200d-1f527",
                "1f469-1f3fc-200d-1f527",
                "1f469-1f3fd-200d-1f527",
                "1f469-1f3fe-200d-1f527",
                "1f469-1f3ff-200d-1f527"
            ],
            a: "4"
        },
        {
            n: [
                "worker",
                "factory",
                "assembly",
                "industrial",
                "factory worker"
            ],
            u: "1f9d1-200d-1f3ed",
            v: [
                "1f9d1-1f3fb-200d-1f3ed",
                "1f9d1-1f3fc-200d-1f3ed",
                "1f9d1-1f3fd-200d-1f3ed",
                "1f9d1-1f3fe-200d-1f3ed",
                "1f9d1-1f3ff-200d-1f3ed"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "worker",
                "factory",
                "assembly",
                "industrial",
                "man factory worker"
            ],
            u: "1f468-200d-1f3ed",
            v: [
                "1f468-1f3fb-200d-1f3ed",
                "1f468-1f3fc-200d-1f3ed",
                "1f468-1f3fd-200d-1f3ed",
                "1f468-1f3fe-200d-1f3ed",
                "1f468-1f3ff-200d-1f3ed"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "worker",
                "factory",
                "assembly",
                "industrial",
                "woman factory worker"
            ],
            u: "1f469-200d-1f3ed",
            v: [
                "1f469-1f3fb-200d-1f3ed",
                "1f469-1f3fc-200d-1f3ed",
                "1f469-1f3fd-200d-1f3ed",
                "1f469-1f3fe-200d-1f3ed",
                "1f469-1f3ff-200d-1f3ed"
            ],
            a: "4"
        },
        {
            n: [
                "manager",
                "business",
                "architect",
                "white collar",
                "office worker"
            ],
            u: "1f9d1-200d-1f4bc",
            v: [
                "1f9d1-1f3fb-200d-1f4bc",
                "1f9d1-1f3fc-200d-1f4bc",
                "1f9d1-1f3fd-200d-1f4bc",
                "1f9d1-1f3fe-200d-1f4bc",
                "1f9d1-1f3ff-200d-1f4bc"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "manager",
                "business",
                "architect",
                "white collar",
                "man office worker"
            ],
            u: "1f468-200d-1f4bc",
            v: [
                "1f468-1f3fb-200d-1f4bc",
                "1f468-1f3fc-200d-1f4bc",
                "1f468-1f3fd-200d-1f4bc",
                "1f468-1f3fe-200d-1f4bc",
                "1f468-1f3ff-200d-1f4bc"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "manager",
                "business",
                "architect",
                "white collar",
                "woman office worker"
            ],
            u: "1f469-200d-1f4bc",
            v: [
                "1f469-1f3fb-200d-1f4bc",
                "1f469-1f3fc-200d-1f4bc",
                "1f469-1f3fd-200d-1f4bc",
                "1f469-1f3fe-200d-1f4bc",
                "1f469-1f3ff-200d-1f4bc"
            ],
            a: "4"
        },
        {
            n: [
                "chemist",
                "engineer",
                "scientist",
                "biologist",
                "physicist"
            ],
            u: "1f9d1-200d-1f52c",
            v: [
                "1f9d1-1f3fb-200d-1f52c",
                "1f9d1-1f3fc-200d-1f52c",
                "1f9d1-1f3fd-200d-1f52c",
                "1f9d1-1f3fe-200d-1f52c",
                "1f9d1-1f3ff-200d-1f52c"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "chemist",
                "engineer",
                "biologist",
                "physicist",
                "scientist",
                "man scientist"
            ],
            u: "1f468-200d-1f52c",
            v: [
                "1f468-1f3fb-200d-1f52c",
                "1f468-1f3fc-200d-1f52c",
                "1f468-1f3fd-200d-1f52c",
                "1f468-1f3fe-200d-1f52c",
                "1f468-1f3ff-200d-1f52c"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "chemist",
                "engineer",
                "biologist",
                "physicist",
                "scientist",
                "woman scientist"
            ],
            u: "1f469-200d-1f52c",
            v: [
                "1f469-1f3fb-200d-1f52c",
                "1f469-1f3fc-200d-1f52c",
                "1f469-1f3fd-200d-1f52c",
                "1f469-1f3fe-200d-1f52c",
                "1f469-1f3ff-200d-1f52c"
            ],
            a: "4"
        },
        {
            n: [
                "coder",
                "inventor",
                "software",
                "developer",
                "technologist"
            ],
            u: "1f9d1-200d-1f4bb",
            v: [
                "1f9d1-1f3fb-200d-1f4bb",
                "1f9d1-1f3fc-200d-1f4bb",
                "1f9d1-1f3fd-200d-1f4bb",
                "1f9d1-1f3fe-200d-1f4bb",
                "1f9d1-1f3ff-200d-1f4bb"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "coder",
                "inventor",
                "software",
                "developer",
                "technologist",
                "man technologist"
            ],
            u: "1f468-200d-1f4bb",
            v: [
                "1f468-1f3fb-200d-1f4bb",
                "1f468-1f3fc-200d-1f4bb",
                "1f468-1f3fd-200d-1f4bb",
                "1f468-1f3fe-200d-1f4bb",
                "1f468-1f3ff-200d-1f4bb"
            ],
            a: "4"
        },
        {
            n: [
                "coder",
                "woman",
                "inventor",
                "software",
                "developer",
                "technologist",
                "woman technologist"
            ],
            u: "1f469-200d-1f4bb",
            v: [
                "1f469-1f3fb-200d-1f4bb",
                "1f469-1f3fc-200d-1f4bb",
                "1f469-1f3fd-200d-1f4bb",
                "1f469-1f3fe-200d-1f4bb",
                "1f469-1f3ff-200d-1f4bb"
            ],
            a: "4"
        },
        {
            n: [
                "rock",
                "star",
                "actor",
                "singer",
                "entertainer"
            ],
            u: "1f9d1-200d-1f3a4",
            v: [
                "1f9d1-1f3fb-200d-1f3a4",
                "1f9d1-1f3fc-200d-1f3a4",
                "1f9d1-1f3fd-200d-1f3a4",
                "1f9d1-1f3fe-200d-1f3a4",
                "1f9d1-1f3ff-200d-1f3a4"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "rock",
                "star",
                "actor",
                "singer",
                "man singer",
                "entertainer"
            ],
            u: "1f468-200d-1f3a4",
            v: [
                "1f468-1f3fb-200d-1f3a4",
                "1f468-1f3fc-200d-1f3a4",
                "1f468-1f3fd-200d-1f3a4",
                "1f468-1f3fe-200d-1f3a4",
                "1f468-1f3ff-200d-1f3a4"
            ],
            a: "4"
        },
        {
            n: [
                "rock",
                "star",
                "actor",
                "woman",
                "singer",
                "entertainer",
                "woman singer"
            ],
            u: "1f469-200d-1f3a4",
            v: [
                "1f469-1f3fb-200d-1f3a4",
                "1f469-1f3fc-200d-1f3a4",
                "1f469-1f3fd-200d-1f3a4",
                "1f469-1f3fe-200d-1f3a4",
                "1f469-1f3ff-200d-1f3a4"
            ],
            a: "4"
        },
        {
            n: [
                "artist",
                "palette"
            ],
            u: "1f9d1-200d-1f3a8",
            v: [
                "1f9d1-1f3fb-200d-1f3a8",
                "1f9d1-1f3fc-200d-1f3a8",
                "1f9d1-1f3fd-200d-1f3a8",
                "1f9d1-1f3fe-200d-1f3a8",
                "1f9d1-1f3ff-200d-1f3a8"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "artist",
                "palette",
                "man artist"
            ],
            u: "1f468-200d-1f3a8",
            v: [
                "1f468-1f3fb-200d-1f3a8",
                "1f468-1f3fc-200d-1f3a8",
                "1f468-1f3fd-200d-1f3a8",
                "1f468-1f3fe-200d-1f3a8",
                "1f468-1f3ff-200d-1f3a8"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "artist",
                "palette",
                "woman artist"
            ],
            u: "1f469-200d-1f3a8",
            v: [
                "1f469-1f3fb-200d-1f3a8",
                "1f469-1f3fc-200d-1f3a8",
                "1f469-1f3fd-200d-1f3a8",
                "1f469-1f3fe-200d-1f3a8",
                "1f469-1f3ff-200d-1f3a8"
            ],
            a: "4"
        },
        {
            n: [
                "pilot",
                "plane"
            ],
            u: "1f9d1-200d-2708-fe0f",
            v: [
                "1f9d1-1f3fb-200d-2708-fe0f",
                "1f9d1-1f3fc-200d-2708-fe0f",
                "1f9d1-1f3fd-200d-2708-fe0f",
                "1f9d1-1f3fe-200d-2708-fe0f",
                "1f9d1-1f3ff-200d-2708-fe0f"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "pilot",
                "plane",
                "man pilot"
            ],
            u: "1f468-200d-2708-fe0f",
            v: [
                "1f468-1f3fb-200d-2708-fe0f",
                "1f468-1f3fc-200d-2708-fe0f",
                "1f468-1f3fd-200d-2708-fe0f",
                "1f468-1f3fe-200d-2708-fe0f",
                "1f468-1f3ff-200d-2708-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "pilot",
                "plane",
                "woman",
                "woman pilot"
            ],
            u: "1f469-200d-2708-fe0f",
            v: [
                "1f469-1f3fb-200d-2708-fe0f",
                "1f469-1f3fc-200d-2708-fe0f",
                "1f469-1f3fd-200d-2708-fe0f",
                "1f469-1f3fe-200d-2708-fe0f",
                "1f469-1f3ff-200d-2708-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "rocket",
                "astronaut"
            ],
            u: "1f9d1-200d-1f680",
            v: [
                "1f9d1-1f3fb-200d-1f680",
                "1f9d1-1f3fc-200d-1f680",
                "1f9d1-1f3fd-200d-1f680",
                "1f9d1-1f3fe-200d-1f680",
                "1f9d1-1f3ff-200d-1f680"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "rocket",
                "astronaut",
                "man astronaut"
            ],
            u: "1f468-200d-1f680",
            v: [
                "1f468-1f3fb-200d-1f680",
                "1f468-1f3fc-200d-1f680",
                "1f468-1f3fd-200d-1f680",
                "1f468-1f3fe-200d-1f680",
                "1f468-1f3ff-200d-1f680"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "rocket",
                "astronaut",
                "woman astronaut"
            ],
            u: "1f469-200d-1f680",
            v: [
                "1f469-1f3fb-200d-1f680",
                "1f469-1f3fc-200d-1f680",
                "1f469-1f3fd-200d-1f680",
                "1f469-1f3fe-200d-1f680",
                "1f469-1f3ff-200d-1f680"
            ],
            a: "4"
        },
        {
            n: [
                "fire",
                "firetruck",
                "firefighter"
            ],
            u: "1f9d1-200d-1f692",
            v: [
                "1f9d1-1f3fb-200d-1f692",
                "1f9d1-1f3fc-200d-1f692",
                "1f9d1-1f3fd-200d-1f692",
                "1f9d1-1f3fe-200d-1f692",
                "1f9d1-1f3ff-200d-1f692"
            ],
            a: "12.1"
        },
        {
            n: [
                "man",
                "firetruck",
                "firefighter",
                "man firefighter"
            ],
            u: "1f468-200d-1f692",
            v: [
                "1f468-1f3fb-200d-1f692",
                "1f468-1f3fc-200d-1f692",
                "1f468-1f3fd-200d-1f692",
                "1f468-1f3fe-200d-1f692",
                "1f468-1f3ff-200d-1f692"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "firetruck",
                "firefighter",
                "woman firefighter"
            ],
            u: "1f469-200d-1f692",
            v: [
                "1f469-1f3fb-200d-1f692",
                "1f469-1f3fc-200d-1f692",
                "1f469-1f3fd-200d-1f692",
                "1f469-1f3fe-200d-1f692",
                "1f469-1f3ff-200d-1f692"
            ],
            a: "4"
        },
        {
            n: [
                "cop",
                "police",
                "officer",
                "police officer"
            ],
            u: "1f46e",
            v: [
                "1f46e-1f3fb",
                "1f46e-1f3fc",
                "1f46e-1f3fd",
                "1f46e-1f3fe",
                "1f46e-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "cop",
                "man",
                "police",
                "officer",
                "man police officer"
            ],
            u: "1f46e-200d-2642-fe0f",
            v: [
                "1f46e-1f3fb-200d-2642-fe0f",
                "1f46e-1f3fc-200d-2642-fe0f",
                "1f46e-1f3fd-200d-2642-fe0f",
                "1f46e-1f3fe-200d-2642-fe0f",
                "1f46e-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "cop",
                "woman",
                "police",
                "officer",
                "woman police officer"
            ],
            u: "1f46e-200d-2640-fe0f",
            v: [
                "1f46e-1f3fb-200d-2640-fe0f",
                "1f46e-1f3fc-200d-2640-fe0f",
                "1f46e-1f3fd-200d-2640-fe0f",
                "1f46e-1f3fe-200d-2640-fe0f",
                "1f46e-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "spy",
                "sleuth",
                "detective"
            ],
            u: "1f575-fe0f",
            v: [
                "1f575-1f3fb",
                "1f575-1f3fc",
                "1f575-1f3fd",
                "1f575-1f3fe",
                "1f575-1f3ff"
            ],
            a: "0.7"
        },
        {
            n: [
                "man",
                "spy",
                "sleuth",
                "detective",
                "man detective"
            ],
            u: "1f575-fe0f-200d-2642-fe0f",
            v: [
                "1f575-1f3fb-200d-2642-fe0f",
                "1f575-1f3fc-200d-2642-fe0f",
                "1f575-1f3fd-200d-2642-fe0f",
                "1f575-1f3fe-200d-2642-fe0f",
                "1f575-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "spy",
                "woman",
                "sleuth",
                "detective",
                "woman detective"
            ],
            u: "1f575-fe0f-200d-2640-fe0f",
            v: [
                "1f575-1f3fb-200d-2640-fe0f",
                "1f575-1f3fc-200d-2640-fe0f",
                "1f575-1f3fd-200d-2640-fe0f",
                "1f575-1f3fe-200d-2640-fe0f",
                "1f575-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "guard"
            ],
            u: "1f482",
            v: [
                "1f482-1f3fb",
                "1f482-1f3fc",
                "1f482-1f3fd",
                "1f482-1f3fe",
                "1f482-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "guard",
                "man guard"
            ],
            u: "1f482-200d-2642-fe0f",
            v: [
                "1f482-1f3fb-200d-2642-fe0f",
                "1f482-1f3fc-200d-2642-fe0f",
                "1f482-1f3fd-200d-2642-fe0f",
                "1f482-1f3fe-200d-2642-fe0f",
                "1f482-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "guard",
                "woman",
                "woman guard"
            ],
            u: "1f482-200d-2640-fe0f",
            v: [
                "1f482-1f3fb-200d-2640-fe0f",
                "1f482-1f3fc-200d-2640-fe0f",
                "1f482-1f3fd-200d-2640-fe0f",
                "1f482-1f3fe-200d-2640-fe0f",
                "1f482-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "ninja",
                "hidden",
                "fighter",
                "stealth"
            ],
            u: "1f977",
            v: [
                "1f977-1f3fb",
                "1f977-1f3fc",
                "1f977-1f3fd",
                "1f977-1f3fe",
                "1f977-1f3ff"
            ],
            a: "13"
        },
        {
            n: [
                "hat",
                "worker",
                "construction",
                "construction worker"
            ],
            u: "1f477",
            v: [
                "1f477-1f3fb",
                "1f477-1f3fc",
                "1f477-1f3fd",
                "1f477-1f3fe",
                "1f477-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "worker",
                "construction",
                "man construction worker"
            ],
            u: "1f477-200d-2642-fe0f",
            v: [
                "1f477-1f3fb-200d-2642-fe0f",
                "1f477-1f3fc-200d-2642-fe0f",
                "1f477-1f3fd-200d-2642-fe0f",
                "1f477-1f3fe-200d-2642-fe0f",
                "1f477-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "worker",
                "construction",
                "woman construction worker"
            ],
            u: "1f477-200d-2640-fe0f",
            v: [
                "1f477-1f3fb-200d-2640-fe0f",
                "1f477-1f3fc-200d-2640-fe0f",
                "1f477-1f3fd-200d-2640-fe0f",
                "1f477-1f3fe-200d-2640-fe0f",
                "1f477-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "noble",
                "regal",
                "monarch",
                "royalty",
                "person with crown"
            ],
            u: "1fac5",
            v: [
                "1fac5-1f3fb",
                "1fac5-1f3fc",
                "1fac5-1f3fd",
                "1fac5-1f3fe",
                "1fac5-1f3ff"
            ],
            a: "14"
        },
        {
            n: [
                "prince"
            ],
            u: "1f934",
            v: [
                "1f934-1f3fb",
                "1f934-1f3fc",
                "1f934-1f3fd",
                "1f934-1f3fe",
                "1f934-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "fantasy",
                "princess",
                "fairy tale"
            ],
            u: "1f478",
            v: [
                "1f478-1f3fb",
                "1f478-1f3fc",
                "1f478-1f3fd",
                "1f478-1f3fe",
                "1f478-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "turban",
                "person wearing turban"
            ],
            u: "1f473",
            v: [
                "1f473-1f3fb",
                "1f473-1f3fc",
                "1f473-1f3fd",
                "1f473-1f3fe",
                "1f473-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "turban",
                "man wearing turban"
            ],
            u: "1f473-200d-2642-fe0f",
            v: [
                "1f473-1f3fb-200d-2642-fe0f",
                "1f473-1f3fc-200d-2642-fe0f",
                "1f473-1f3fd-200d-2642-fe0f",
                "1f473-1f3fe-200d-2642-fe0f",
                "1f473-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "turban",
                "woman wearing turban"
            ],
            u: "1f473-200d-2640-fe0f",
            v: [
                "1f473-1f3fb-200d-2640-fe0f",
                "1f473-1f3fc-200d-2640-fe0f",
                "1f473-1f3fd-200d-2640-fe0f",
                "1f473-1f3fe-200d-2640-fe0f",
                "1f473-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "cap",
                "hat",
                "person",
                "skullcap",
                "gua pi mao",
                "person with skullcap"
            ],
            u: "1f472",
            v: [
                "1f472-1f3fb",
                "1f472-1f3fc",
                "1f472-1f3fd",
                "1f472-1f3fe",
                "1f472-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "hijab",
                "tichel",
                "mantilla",
                "headscarf",
                "woman with headscarf"
            ],
            u: "1f9d5",
            v: [
                "1f9d5-1f3fb",
                "1f9d5-1f3fc",
                "1f9d5-1f3fd",
                "1f9d5-1f3fe",
                "1f9d5-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "groom",
                "person",
                "tuxedo",
                "person in tuxedo"
            ],
            u: "1f935",
            v: [
                "1f935-1f3fb",
                "1f935-1f3fc",
                "1f935-1f3fd",
                "1f935-1f3fe",
                "1f935-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "man",
                "tuxedo",
                "man in tuxedo"
            ],
            u: "1f935-200d-2642-fe0f",
            v: [
                "1f935-1f3fb-200d-2642-fe0f",
                "1f935-1f3fc-200d-2642-fe0f",
                "1f935-1f3fd-200d-2642-fe0f",
                "1f935-1f3fe-200d-2642-fe0f",
                "1f935-1f3ff-200d-2642-fe0f"
            ],
            a: "13"
        },
        {
            n: [
                "woman",
                "tuxedo",
                "woman in tuxedo"
            ],
            u: "1f935-200d-2640-fe0f",
            v: [
                "1f935-1f3fb-200d-2640-fe0f",
                "1f935-1f3fc-200d-2640-fe0f",
                "1f935-1f3fd-200d-2640-fe0f",
                "1f935-1f3fe-200d-2640-fe0f",
                "1f935-1f3ff-200d-2640-fe0f"
            ],
            a: "13"
        },
        {
            n: [
                "veil",
                "bride",
                "person",
                "wedding",
                "person with veil"
            ],
            u: "1f470",
            v: [
                "1f470-1f3fb",
                "1f470-1f3fc",
                "1f470-1f3fd",
                "1f470-1f3fe",
                "1f470-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "veil",
                "man with veil"
            ],
            u: "1f470-200d-2642-fe0f",
            v: [
                "1f470-1f3fb-200d-2642-fe0f",
                "1f470-1f3fc-200d-2642-fe0f",
                "1f470-1f3fd-200d-2642-fe0f",
                "1f470-1f3fe-200d-2642-fe0f",
                "1f470-1f3ff-200d-2642-fe0f"
            ],
            a: "13"
        },
        {
            n: [
                "veil",
                "woman",
                "woman with veil"
            ],
            u: "1f470-200d-2640-fe0f",
            v: [
                "1f470-1f3fb-200d-2640-fe0f",
                "1f470-1f3fc-200d-2640-fe0f",
                "1f470-1f3fd-200d-2640-fe0f",
                "1f470-1f3fe-200d-2640-fe0f",
                "1f470-1f3ff-200d-2640-fe0f"
            ],
            a: "13"
        },
        {
            n: [
                "woman",
                "pregnant",
                "pregnant woman"
            ],
            u: "1f930",
            v: [
                "1f930-1f3fb",
                "1f930-1f3fc",
                "1f930-1f3fd",
                "1f930-1f3fe",
                "1f930-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "full",
                "belly",
                "bloated",
                "pregnant",
                "pregnant man"
            ],
            u: "1fac3",
            v: [
                "1fac3-1f3fb",
                "1fac3-1f3fc",
                "1fac3-1f3fd",
                "1fac3-1f3fe",
                "1fac3-1f3ff"
            ],
            a: "14"
        },
        {
            n: [
                "full",
                "belly",
                "bloated",
                "pregnant",
                "pregnant person"
            ],
            u: "1fac4",
            v: [
                "1fac4-1f3fb",
                "1fac4-1f3fc",
                "1fac4-1f3fd",
                "1fac4-1f3fe",
                "1fac4-1f3ff"
            ],
            a: "14"
        },
        {
            n: [
                "baby",
                "breast",
                "nursing",
                "breast feeding"
            ],
            u: "1f931",
            v: [
                "1f931-1f3fb",
                "1f931-1f3fc",
                "1f931-1f3fd",
                "1f931-1f3fe",
                "1f931-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "baby",
                "woman",
                "feeding",
                "nursing",
                "woman feeding baby"
            ],
            u: "1f469-200d-1f37c",
            v: [
                "1f469-1f3fb-200d-1f37c",
                "1f469-1f3fc-200d-1f37c",
                "1f469-1f3fd-200d-1f37c",
                "1f469-1f3fe-200d-1f37c",
                "1f469-1f3ff-200d-1f37c"
            ],
            a: "13"
        },
        {
            n: [
                "man",
                "baby",
                "feeding",
                "nursing",
                "man feeding baby"
            ],
            u: "1f468-200d-1f37c",
            v: [
                "1f468-1f3fb-200d-1f37c",
                "1f468-1f3fc-200d-1f37c",
                "1f468-1f3fd-200d-1f37c",
                "1f468-1f3fe-200d-1f37c",
                "1f468-1f3ff-200d-1f37c"
            ],
            a: "13"
        },
        {
            n: [
                "baby",
                "person",
                "feeding",
                "nursing",
                "person feeding baby"
            ],
            u: "1f9d1-200d-1f37c",
            v: [
                "1f9d1-1f3fb-200d-1f37c",
                "1f9d1-1f3fc-200d-1f37c",
                "1f9d1-1f3fd-200d-1f37c",
                "1f9d1-1f3fe-200d-1f37c",
                "1f9d1-1f3ff-200d-1f37c"
            ],
            a: "13"
        },
        {
            n: [
                "baby",
                "face",
                "angel",
                "fantasy",
                "baby angel",
                "fairy tale"
            ],
            u: "1f47c",
            v: [
                "1f47c-1f3fb",
                "1f47c-1f3fc",
                "1f47c-1f3fd",
                "1f47c-1f3fe",
                "1f47c-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "claus",
                "santa",
                "father",
                "christmas",
                "Santa Claus",
                "celebration"
            ],
            u: "1f385",
            v: [
                "1f385-1f3fb",
                "1f385-1f3fc",
                "1f385-1f3fd",
                "1f385-1f3fe",
                "1f385-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "mrs.",
                "claus",
                "mother",
                "christmas",
                "Mrs. Claus",
                "celebration"
            ],
            u: "1f936",
            v: [
                "1f936-1f3fb",
                "1f936-1f3fc",
                "1f936-1f3fd",
                "1f936-1f3fe",
                "1f936-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "claus",
                "mx claus",
                "christmas"
            ],
            u: "1f9d1-200d-1f384",
            v: [
                "1f9d1-1f3fb-200d-1f384",
                "1f9d1-1f3fc-200d-1f384",
                "1f9d1-1f3fd-200d-1f384",
                "1f9d1-1f3fe-200d-1f384",
                "1f9d1-1f3ff-200d-1f384"
            ],
            a: "13"
        },
        {
            n: [
                "good",
                "hero",
                "heroine",
                "superhero",
                "superpower"
            ],
            u: "1f9b8",
            v: [
                "1f9b8-1f3fb",
                "1f9b8-1f3fc",
                "1f9b8-1f3fd",
                "1f9b8-1f3fe",
                "1f9b8-1f3ff"
            ],
            a: "11"
        },
        {
            n: [
                "man",
                "good",
                "hero",
                "superpower",
                "man superhero"
            ],
            u: "1f9b8-200d-2642-fe0f",
            v: [
                "1f9b8-1f3fb-200d-2642-fe0f",
                "1f9b8-1f3fc-200d-2642-fe0f",
                "1f9b8-1f3fd-200d-2642-fe0f",
                "1f9b8-1f3fe-200d-2642-fe0f",
                "1f9b8-1f3ff-200d-2642-fe0f"
            ],
            a: "11"
        },
        {
            n: [
                "good",
                "hero",
                "woman",
                "heroine",
                "superpower",
                "woman superhero"
            ],
            u: "1f9b8-200d-2640-fe0f",
            v: [
                "1f9b8-1f3fb-200d-2640-fe0f",
                "1f9b8-1f3fc-200d-2640-fe0f",
                "1f9b8-1f3fd-200d-2640-fe0f",
                "1f9b8-1f3fe-200d-2640-fe0f",
                "1f9b8-1f3ff-200d-2640-fe0f"
            ],
            a: "11"
        },
        {
            n: [
                "evil",
                "villain",
                "criminal",
                "superpower",
                "supervillain"
            ],
            u: "1f9b9",
            v: [
                "1f9b9-1f3fb",
                "1f9b9-1f3fc",
                "1f9b9-1f3fd",
                "1f9b9-1f3fe",
                "1f9b9-1f3ff"
            ],
            a: "11"
        },
        {
            n: [
                "man",
                "evil",
                "villain",
                "criminal",
                "superpower",
                "man supervillain"
            ],
            u: "1f9b9-200d-2642-fe0f",
            v: [
                "1f9b9-1f3fb-200d-2642-fe0f",
                "1f9b9-1f3fc-200d-2642-fe0f",
                "1f9b9-1f3fd-200d-2642-fe0f",
                "1f9b9-1f3fe-200d-2642-fe0f",
                "1f9b9-1f3ff-200d-2642-fe0f"
            ],
            a: "11"
        },
        {
            n: [
                "evil",
                "woman",
                "villain",
                "criminal",
                "superpower",
                "woman supervillain"
            ],
            u: "1f9b9-200d-2640-fe0f",
            v: [
                "1f9b9-1f3fb-200d-2640-fe0f",
                "1f9b9-1f3fc-200d-2640-fe0f",
                "1f9b9-1f3fd-200d-2640-fe0f",
                "1f9b9-1f3fe-200d-2640-fe0f",
                "1f9b9-1f3ff-200d-2640-fe0f"
            ],
            a: "11"
        },
        {
            n: [
                "mage",
                "witch",
                "wizard",
                "sorcerer",
                "sorceress"
            ],
            u: "1f9d9",
            v: [
                "1f9d9-1f3fb",
                "1f9d9-1f3fc",
                "1f9d9-1f3fd",
                "1f9d9-1f3fe",
                "1f9d9-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "wizard",
                "man mage",
                "sorcerer"
            ],
            u: "1f9d9-200d-2642-fe0f",
            v: [
                "1f9d9-1f3fb-200d-2642-fe0f",
                "1f9d9-1f3fc-200d-2642-fe0f",
                "1f9d9-1f3fd-200d-2642-fe0f",
                "1f9d9-1f3fe-200d-2642-fe0f",
                "1f9d9-1f3ff-200d-2642-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "witch",
                "sorceress",
                "woman mage"
            ],
            u: "1f9d9-200d-2640-fe0f",
            v: [
                "1f9d9-1f3fb-200d-2640-fe0f",
                "1f9d9-1f3fc-200d-2640-fe0f",
                "1f9d9-1f3fd-200d-2640-fe0f",
                "1f9d9-1f3fe-200d-2640-fe0f",
                "1f9d9-1f3ff-200d-2640-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "puck",
                "fairy",
                "oberon",
                "titania"
            ],
            u: "1f9da",
            v: [
                "1f9da-1f3fb",
                "1f9da-1f3fc",
                "1f9da-1f3fd",
                "1f9da-1f3fe",
                "1f9da-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "puck",
                "oberon",
                "man fairy"
            ],
            u: "1f9da-200d-2642-fe0f",
            v: [
                "1f9da-1f3fb-200d-2642-fe0f",
                "1f9da-1f3fc-200d-2642-fe0f",
                "1f9da-1f3fd-200d-2642-fe0f",
                "1f9da-1f3fe-200d-2642-fe0f",
                "1f9da-1f3ff-200d-2642-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "titania",
                "woman fairy"
            ],
            u: "1f9da-200d-2640-fe0f",
            v: [
                "1f9da-1f3fb-200d-2640-fe0f",
                "1f9da-1f3fc-200d-2640-fe0f",
                "1f9da-1f3fd-200d-2640-fe0f",
                "1f9da-1f3fe-200d-2640-fe0f",
                "1f9da-1f3ff-200d-2640-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "undead",
                "vampire",
                "dracula"
            ],
            u: "1f9db",
            v: [
                "1f9db-1f3fb",
                "1f9db-1f3fc",
                "1f9db-1f3fd",
                "1f9db-1f3fe",
                "1f9db-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "undead",
                "dracula",
                "man vampire"
            ],
            u: "1f9db-200d-2642-fe0f",
            v: [
                "1f9db-1f3fb-200d-2642-fe0f",
                "1f9db-1f3fc-200d-2642-fe0f",
                "1f9db-1f3fd-200d-2642-fe0f",
                "1f9db-1f3fe-200d-2642-fe0f",
                "1f9db-1f3ff-200d-2642-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "undead",
                "woman vampire"
            ],
            u: "1f9db-200d-2640-fe0f",
            v: [
                "1f9db-1f3fb-200d-2640-fe0f",
                "1f9db-1f3fc-200d-2640-fe0f",
                "1f9db-1f3fd-200d-2640-fe0f",
                "1f9db-1f3fe-200d-2640-fe0f",
                "1f9db-1f3ff-200d-2640-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "merman",
                "mermaid",
                "merwoman",
                "merperson"
            ],
            u: "1f9dc",
            v: [
                "1f9dc-1f3fb",
                "1f9dc-1f3fc",
                "1f9dc-1f3fd",
                "1f9dc-1f3fe",
                "1f9dc-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "merman",
                "triton"
            ],
            u: "1f9dc-200d-2642-fe0f",
            v: [
                "1f9dc-1f3fb-200d-2642-fe0f",
                "1f9dc-1f3fc-200d-2642-fe0f",
                "1f9dc-1f3fd-200d-2642-fe0f",
                "1f9dc-1f3fe-200d-2642-fe0f",
                "1f9dc-1f3ff-200d-2642-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "mermaid",
                "merwoman"
            ],
            u: "1f9dc-200d-2640-fe0f",
            v: [
                "1f9dc-1f3fb-200d-2640-fe0f",
                "1f9dc-1f3fc-200d-2640-fe0f",
                "1f9dc-1f3fd-200d-2640-fe0f",
                "1f9dc-1f3fe-200d-2640-fe0f",
                "1f9dc-1f3ff-200d-2640-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "elf",
                "magical"
            ],
            u: "1f9dd",
            v: [
                "1f9dd-1f3fb",
                "1f9dd-1f3fc",
                "1f9dd-1f3fd",
                "1f9dd-1f3fe",
                "1f9dd-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "man elf",
                "magical"
            ],
            u: "1f9dd-200d-2642-fe0f",
            v: [
                "1f9dd-1f3fb-200d-2642-fe0f",
                "1f9dd-1f3fc-200d-2642-fe0f",
                "1f9dd-1f3fd-200d-2642-fe0f",
                "1f9dd-1f3fe-200d-2642-fe0f",
                "1f9dd-1f3ff-200d-2642-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "magical",
                "woman elf"
            ],
            u: "1f9dd-200d-2640-fe0f",
            v: [
                "1f9dd-1f3fb-200d-2640-fe0f",
                "1f9dd-1f3fc-200d-2640-fe0f",
                "1f9dd-1f3fd-200d-2640-fe0f",
                "1f9dd-1f3fe-200d-2640-fe0f",
                "1f9dd-1f3ff-200d-2640-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "genie",
                "djinn"
            ],
            u: "1f9de",
            a: "5"
        },
        {
            n: [
                "djinn",
                "man genie"
            ],
            u: "1f9de-200d-2642-fe0f",
            a: "5"
        },
        {
            n: [
                "djinn",
                "woman genie"
            ],
            u: "1f9de-200d-2640-fe0f",
            a: "5"
        },
        {
            n: [
                "zombie",
                "undead",
                "walking dead"
            ],
            u: "1f9df",
            a: "5"
        },
        {
            n: [
                "undead",
                "man zombie",
                "walking dead"
            ],
            u: "1f9df-200d-2642-fe0f",
            a: "5"
        },
        {
            n: [
                "undead",
                "woman zombie",
                "walking dead"
            ],
            u: "1f9df-200d-2640-fe0f",
            a: "5"
        },
        {
            n: [
                "troll",
                "fantasy",
                "monster",
                "fairy tale"
            ],
            u: "1f9cc",
            a: "14"
        },
        {
            n: [
                "face",
                "salon",
                "massage",
                "person getting massage"
            ],
            u: "1f486",
            v: [
                "1f486-1f3fb",
                "1f486-1f3fc",
                "1f486-1f3fd",
                "1f486-1f3fe",
                "1f486-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "face",
                "massage",
                "man getting massage"
            ],
            u: "1f486-200d-2642-fe0f",
            v: [
                "1f486-1f3fb-200d-2642-fe0f",
                "1f486-1f3fc-200d-2642-fe0f",
                "1f486-1f3fd-200d-2642-fe0f",
                "1f486-1f3fe-200d-2642-fe0f",
                "1f486-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "face",
                "woman",
                "massage",
                "woman getting massage"
            ],
            u: "1f486-200d-2640-fe0f",
            v: [
                "1f486-1f3fb-200d-2640-fe0f",
                "1f486-1f3fc-200d-2640-fe0f",
                "1f486-1f3fd-200d-2640-fe0f",
                "1f486-1f3fe-200d-2640-fe0f",
                "1f486-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "barber",
                "beauty",
                "parlor",
                "haircut",
                "person getting haircut"
            ],
            u: "1f487",
            v: [
                "1f487-1f3fb",
                "1f487-1f3fc",
                "1f487-1f3fd",
                "1f487-1f3fe",
                "1f487-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "haircut",
                "man getting haircut"
            ],
            u: "1f487-200d-2642-fe0f",
            v: [
                "1f487-1f3fb-200d-2642-fe0f",
                "1f487-1f3fc-200d-2642-fe0f",
                "1f487-1f3fd-200d-2642-fe0f",
                "1f487-1f3fe-200d-2642-fe0f",
                "1f487-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "haircut",
                "woman getting haircut"
            ],
            u: "1f487-200d-2640-fe0f",
            v: [
                "1f487-1f3fb-200d-2640-fe0f",
                "1f487-1f3fc-200d-2640-fe0f",
                "1f487-1f3fd-200d-2640-fe0f",
                "1f487-1f3fe-200d-2640-fe0f",
                "1f487-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "hike",
                "walk",
                "walking",
                "person walking"
            ],
            u: "1f6b6",
            v: [
                "1f6b6-1f3fb",
                "1f6b6-1f3fc",
                "1f6b6-1f3fd",
                "1f6b6-1f3fe",
                "1f6b6-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "hike",
                "walk",
                "man walking"
            ],
            u: "1f6b6-200d-2642-fe0f",
            v: [
                "1f6b6-1f3fb-200d-2642-fe0f",
                "1f6b6-1f3fc-200d-2642-fe0f",
                "1f6b6-1f3fd-200d-2642-fe0f",
                "1f6b6-1f3fe-200d-2642-fe0f",
                "1f6b6-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "hike",
                "walk",
                "woman",
                "woman walking"
            ],
            u: "1f6b6-200d-2640-fe0f",
            v: [
                "1f6b6-1f3fb-200d-2640-fe0f",
                "1f6b6-1f3fc-200d-2640-fe0f",
                "1f6b6-1f3fd-200d-2640-fe0f",
                "1f6b6-1f3fe-200d-2640-fe0f",
                "1f6b6-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "hike",
                "walk",
                "walking",
                "person walking",
                "person walking facing right"
            ],
            u: "1f6b6-200d-27a1-fe0f",
            v: [
                "1f6b6-1f3fb-200d-27a1-fe0f",
                "1f6b6-1f3fc-200d-27a1-fe0f",
                "1f6b6-1f3fd-200d-27a1-fe0f",
                "1f6b6-1f3fe-200d-27a1-fe0f",
                "1f6b6-1f3ff-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "hike",
                "walk",
                "woman",
                "woman walking",
                "woman walking facing right"
            ],
            u: "1f6b6-200d-2640-fe0f-200d-27a1-fe0f",
            v: [
                "1f6b6-1f3fb-200d-2640-fe0f-200d-27a1-fe0f",
                "1f6b6-1f3fc-200d-2640-fe0f-200d-27a1-fe0f",
                "1f6b6-1f3fd-200d-2640-fe0f-200d-27a1-fe0f",
                "1f6b6-1f3fe-200d-2640-fe0f-200d-27a1-fe0f",
                "1f6b6-1f3ff-200d-2640-fe0f-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "man",
                "hike",
                "walk",
                "man walking",
                "man walking facing right"
            ],
            u: "1f6b6-200d-2642-fe0f-200d-27a1-fe0f",
            v: [
                "1f6b6-1f3fb-200d-2642-fe0f-200d-27a1-fe0f",
                "1f6b6-1f3fc-200d-2642-fe0f-200d-27a1-fe0f",
                "1f6b6-1f3fd-200d-2642-fe0f-200d-27a1-fe0f",
                "1f6b6-1f3fe-200d-2642-fe0f-200d-27a1-fe0f",
                "1f6b6-1f3ff-200d-2642-fe0f-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "stand",
                "standing",
                "person standing"
            ],
            u: "1f9cd",
            v: [
                "1f9cd-1f3fb",
                "1f9cd-1f3fc",
                "1f9cd-1f3fd",
                "1f9cd-1f3fe",
                "1f9cd-1f3ff"
            ],
            a: "12"
        },
        {
            n: [
                "man",
                "standing",
                "man standing"
            ],
            u: "1f9cd-200d-2642-fe0f",
            v: [
                "1f9cd-1f3fb-200d-2642-fe0f",
                "1f9cd-1f3fc-200d-2642-fe0f",
                "1f9cd-1f3fd-200d-2642-fe0f",
                "1f9cd-1f3fe-200d-2642-fe0f",
                "1f9cd-1f3ff-200d-2642-fe0f"
            ],
            a: "12"
        },
        {
            n: [
                "woman",
                "standing",
                "woman standing"
            ],
            u: "1f9cd-200d-2640-fe0f",
            v: [
                "1f9cd-1f3fb-200d-2640-fe0f",
                "1f9cd-1f3fc-200d-2640-fe0f",
                "1f9cd-1f3fd-200d-2640-fe0f",
                "1f9cd-1f3fe-200d-2640-fe0f",
                "1f9cd-1f3ff-200d-2640-fe0f"
            ],
            a: "12"
        },
        {
            n: [
                "kneel",
                "kneeling",
                "person kneeling"
            ],
            u: "1f9ce",
            v: [
                "1f9ce-1f3fb",
                "1f9ce-1f3fc",
                "1f9ce-1f3fd",
                "1f9ce-1f3fe",
                "1f9ce-1f3ff"
            ],
            a: "12"
        },
        {
            n: [
                "man",
                "kneeling",
                "man kneeling"
            ],
            u: "1f9ce-200d-2642-fe0f",
            v: [
                "1f9ce-1f3fb-200d-2642-fe0f",
                "1f9ce-1f3fc-200d-2642-fe0f",
                "1f9ce-1f3fd-200d-2642-fe0f",
                "1f9ce-1f3fe-200d-2642-fe0f",
                "1f9ce-1f3ff-200d-2642-fe0f"
            ],
            a: "12"
        },
        {
            n: [
                "woman",
                "kneeling",
                "woman kneeling"
            ],
            u: "1f9ce-200d-2640-fe0f",
            v: [
                "1f9ce-1f3fb-200d-2640-fe0f",
                "1f9ce-1f3fc-200d-2640-fe0f",
                "1f9ce-1f3fd-200d-2640-fe0f",
                "1f9ce-1f3fe-200d-2640-fe0f",
                "1f9ce-1f3ff-200d-2640-fe0f"
            ],
            a: "12"
        },
        {
            n: [
                "kneel",
                "kneeling",
                "person kneeling",
                "person kneeling facing right"
            ],
            u: "1f9ce-200d-27a1-fe0f",
            v: [
                "1f9ce-1f3fb-200d-27a1-fe0f",
                "1f9ce-1f3fc-200d-27a1-fe0f",
                "1f9ce-1f3fd-200d-27a1-fe0f",
                "1f9ce-1f3fe-200d-27a1-fe0f",
                "1f9ce-1f3ff-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "woman",
                "kneeling",
                "woman kneeling facing right"
            ],
            u: "1f9ce-200d-2640-fe0f-200d-27a1-fe0f",
            v: [
                "1f9ce-1f3fb-200d-2640-fe0f-200d-27a1-fe0f",
                "1f9ce-1f3fc-200d-2640-fe0f-200d-27a1-fe0f",
                "1f9ce-1f3fd-200d-2640-fe0f-200d-27a1-fe0f",
                "1f9ce-1f3fe-200d-2640-fe0f-200d-27a1-fe0f",
                "1f9ce-1f3ff-200d-2640-fe0f-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "man",
                "kneeling",
                "man kneeling facing right"
            ],
            u: "1f9ce-200d-2642-fe0f-200d-27a1-fe0f",
            v: [
                "1f9ce-1f3fb-200d-2642-fe0f-200d-27a1-fe0f",
                "1f9ce-1f3fc-200d-2642-fe0f-200d-27a1-fe0f",
                "1f9ce-1f3fd-200d-2642-fe0f-200d-27a1-fe0f",
                "1f9ce-1f3fe-200d-2642-fe0f-200d-27a1-fe0f",
                "1f9ce-1f3ff-200d-2642-fe0f-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "blind",
                "accessibility",
                "person with white cane"
            ],
            u: "1f9d1-200d-1f9af",
            v: [
                "1f9d1-1f3fb-200d-1f9af",
                "1f9d1-1f3fc-200d-1f9af",
                "1f9d1-1f3fd-200d-1f9af",
                "1f9d1-1f3fe-200d-1f9af",
                "1f9d1-1f3ff-200d-1f9af"
            ],
            a: "12.1"
        },
        {
            n: [
                "blind",
                "accessibility",
                "person with white cane",
                "person with white cane facing right"
            ],
            u: "1f9d1-200d-1f9af-200d-27a1-fe0f",
            v: [
                "1f9d1-1f3fb-200d-1f9af-200d-27a1-fe0f",
                "1f9d1-1f3fc-200d-1f9af-200d-27a1-fe0f",
                "1f9d1-1f3fd-200d-1f9af-200d-27a1-fe0f",
                "1f9d1-1f3fe-200d-1f9af-200d-27a1-fe0f",
                "1f9d1-1f3ff-200d-1f9af-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "man",
                "blind",
                "accessibility",
                "man with white cane"
            ],
            u: "1f468-200d-1f9af",
            v: [
                "1f468-1f3fb-200d-1f9af",
                "1f468-1f3fc-200d-1f9af",
                "1f468-1f3fd-200d-1f9af",
                "1f468-1f3fe-200d-1f9af",
                "1f468-1f3ff-200d-1f9af"
            ],
            a: "12"
        },
        {
            n: [
                "man",
                "blind",
                "accessibility",
                "man with white cane",
                "man with white cane facing right"
            ],
            u: "1f468-200d-1f9af-200d-27a1-fe0f",
            v: [
                "1f468-1f3fb-200d-1f9af-200d-27a1-fe0f",
                "1f468-1f3fc-200d-1f9af-200d-27a1-fe0f",
                "1f468-1f3fd-200d-1f9af-200d-27a1-fe0f",
                "1f468-1f3fe-200d-1f9af-200d-27a1-fe0f",
                "1f468-1f3ff-200d-1f9af-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "blind",
                "woman",
                "accessibility",
                "woman with white cane"
            ],
            u: "1f469-200d-1f9af",
            v: [
                "1f469-1f3fb-200d-1f9af",
                "1f469-1f3fc-200d-1f9af",
                "1f469-1f3fd-200d-1f9af",
                "1f469-1f3fe-200d-1f9af",
                "1f469-1f3ff-200d-1f9af"
            ],
            a: "12"
        },
        {
            n: [
                "blind",
                "woman",
                "accessibility",
                "woman with white cane",
                "woman with white cane facing right"
            ],
            u: "1f469-200d-1f9af-200d-27a1-fe0f",
            v: [
                "1f469-1f3fb-200d-1f9af-200d-27a1-fe0f",
                "1f469-1f3fc-200d-1f9af-200d-27a1-fe0f",
                "1f469-1f3fd-200d-1f9af-200d-27a1-fe0f",
                "1f469-1f3fe-200d-1f9af-200d-27a1-fe0f",
                "1f469-1f3ff-200d-1f9af-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "wheelchair",
                "accessibility",
                "person in motorized wheelchair"
            ],
            u: "1f9d1-200d-1f9bc",
            v: [
                "1f9d1-1f3fb-200d-1f9bc",
                "1f9d1-1f3fc-200d-1f9bc",
                "1f9d1-1f3fd-200d-1f9bc",
                "1f9d1-1f3fe-200d-1f9bc",
                "1f9d1-1f3ff-200d-1f9bc"
            ],
            a: "12.1"
        },
        {
            n: [
                "wheelchair",
                "accessibility",
                "person in motorized wheelchair",
                "person in motorized wheelchair facing right"
            ],
            u: "1f9d1-200d-1f9bc-200d-27a1-fe0f",
            v: [
                "1f9d1-1f3fb-200d-1f9bc-200d-27a1-fe0f",
                "1f9d1-1f3fc-200d-1f9bc-200d-27a1-fe0f",
                "1f9d1-1f3fd-200d-1f9bc-200d-27a1-fe0f",
                "1f9d1-1f3fe-200d-1f9bc-200d-27a1-fe0f",
                "1f9d1-1f3ff-200d-1f9bc-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "man",
                "wheelchair",
                "accessibility",
                "man in motorized wheelchair"
            ],
            u: "1f468-200d-1f9bc",
            v: [
                "1f468-1f3fb-200d-1f9bc",
                "1f468-1f3fc-200d-1f9bc",
                "1f468-1f3fd-200d-1f9bc",
                "1f468-1f3fe-200d-1f9bc",
                "1f468-1f3ff-200d-1f9bc"
            ],
            a: "12"
        },
        {
            n: [
                "man",
                "wheelchair",
                "accessibility",
                "man in motorized wheelchair",
                "man in motorized wheelchair facing right"
            ],
            u: "1f468-200d-1f9bc-200d-27a1-fe0f",
            v: [
                "1f468-1f3fb-200d-1f9bc-200d-27a1-fe0f",
                "1f468-1f3fc-200d-1f9bc-200d-27a1-fe0f",
                "1f468-1f3fd-200d-1f9bc-200d-27a1-fe0f",
                "1f468-1f3fe-200d-1f9bc-200d-27a1-fe0f",
                "1f468-1f3ff-200d-1f9bc-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "woman",
                "wheelchair",
                "accessibility",
                "woman in motorized wheelchair"
            ],
            u: "1f469-200d-1f9bc",
            v: [
                "1f469-1f3fb-200d-1f9bc",
                "1f469-1f3fc-200d-1f9bc",
                "1f469-1f3fd-200d-1f9bc",
                "1f469-1f3fe-200d-1f9bc",
                "1f469-1f3ff-200d-1f9bc"
            ],
            a: "12"
        },
        {
            n: [
                "woman",
                "wheelchair",
                "accessibility",
                "woman in motorized wheelchair",
                "woman in motorized wheelchair facing right"
            ],
            u: "1f469-200d-1f9bc-200d-27a1-fe0f",
            v: [
                "1f469-1f3fb-200d-1f9bc-200d-27a1-fe0f",
                "1f469-1f3fc-200d-1f9bc-200d-27a1-fe0f",
                "1f469-1f3fd-200d-1f9bc-200d-27a1-fe0f",
                "1f469-1f3fe-200d-1f9bc-200d-27a1-fe0f",
                "1f469-1f3ff-200d-1f9bc-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "wheelchair",
                "accessibility",
                "person in manual wheelchair"
            ],
            u: "1f9d1-200d-1f9bd",
            v: [
                "1f9d1-1f3fb-200d-1f9bd",
                "1f9d1-1f3fc-200d-1f9bd",
                "1f9d1-1f3fd-200d-1f9bd",
                "1f9d1-1f3fe-200d-1f9bd",
                "1f9d1-1f3ff-200d-1f9bd"
            ],
            a: "12.1"
        },
        {
            n: [
                "wheelchair",
                "accessibility",
                "person in manual wheelchair",
                "person in manual wheelchair facing right"
            ],
            u: "1f9d1-200d-1f9bd-200d-27a1-fe0f",
            v: [
                "1f9d1-1f3fb-200d-1f9bd-200d-27a1-fe0f",
                "1f9d1-1f3fc-200d-1f9bd-200d-27a1-fe0f",
                "1f9d1-1f3fd-200d-1f9bd-200d-27a1-fe0f",
                "1f9d1-1f3fe-200d-1f9bd-200d-27a1-fe0f",
                "1f9d1-1f3ff-200d-1f9bd-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "man",
                "wheelchair",
                "accessibility",
                "man in manual wheelchair"
            ],
            u: "1f468-200d-1f9bd",
            v: [
                "1f468-1f3fb-200d-1f9bd",
                "1f468-1f3fc-200d-1f9bd",
                "1f468-1f3fd-200d-1f9bd",
                "1f468-1f3fe-200d-1f9bd",
                "1f468-1f3ff-200d-1f9bd"
            ],
            a: "12"
        },
        {
            n: [
                "man",
                "wheelchair",
                "accessibility",
                "man in manual wheelchair",
                "man in manual wheelchair facing right"
            ],
            u: "1f468-200d-1f9bd-200d-27a1-fe0f",
            v: [
                "1f468-1f3fb-200d-1f9bd-200d-27a1-fe0f",
                "1f468-1f3fc-200d-1f9bd-200d-27a1-fe0f",
                "1f468-1f3fd-200d-1f9bd-200d-27a1-fe0f",
                "1f468-1f3fe-200d-1f9bd-200d-27a1-fe0f",
                "1f468-1f3ff-200d-1f9bd-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "woman",
                "wheelchair",
                "accessibility",
                "woman in manual wheelchair"
            ],
            u: "1f469-200d-1f9bd",
            v: [
                "1f469-1f3fb-200d-1f9bd",
                "1f469-1f3fc-200d-1f9bd",
                "1f469-1f3fd-200d-1f9bd",
                "1f469-1f3fe-200d-1f9bd",
                "1f469-1f3ff-200d-1f9bd"
            ],
            a: "12"
        },
        {
            n: [
                "woman",
                "wheelchair",
                "accessibility",
                "woman in manual wheelchair",
                "woman in manual wheelchair facing right"
            ],
            u: "1f469-200d-1f9bd-200d-27a1-fe0f",
            v: [
                "1f469-1f3fb-200d-1f9bd-200d-27a1-fe0f",
                "1f469-1f3fc-200d-1f9bd-200d-27a1-fe0f",
                "1f469-1f3fd-200d-1f9bd-200d-27a1-fe0f",
                "1f469-1f3fe-200d-1f9bd-200d-27a1-fe0f",
                "1f469-1f3ff-200d-1f9bd-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "running",
                "marathon",
                "person running"
            ],
            u: "1f3c3",
            v: [
                "1f3c3-1f3fb",
                "1f3c3-1f3fc",
                "1f3c3-1f3fd",
                "1f3c3-1f3fe",
                "1f3c3-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "racing",
                "running",
                "marathon",
                "man running"
            ],
            u: "1f3c3-200d-2642-fe0f",
            v: [
                "1f3c3-1f3fb-200d-2642-fe0f",
                "1f3c3-1f3fc-200d-2642-fe0f",
                "1f3c3-1f3fd-200d-2642-fe0f",
                "1f3c3-1f3fe-200d-2642-fe0f",
                "1f3c3-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "racing",
                "running",
                "marathon",
                "woman running"
            ],
            u: "1f3c3-200d-2640-fe0f",
            v: [
                "1f3c3-1f3fb-200d-2640-fe0f",
                "1f3c3-1f3fc-200d-2640-fe0f",
                "1f3c3-1f3fd-200d-2640-fe0f",
                "1f3c3-1f3fe-200d-2640-fe0f",
                "1f3c3-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "running",
                "marathon",
                "person running",
                "person running facing right"
            ],
            u: "1f3c3-200d-27a1-fe0f",
            v: [
                "1f3c3-1f3fb-200d-27a1-fe0f",
                "1f3c3-1f3fc-200d-27a1-fe0f",
                "1f3c3-1f3fd-200d-27a1-fe0f",
                "1f3c3-1f3fe-200d-27a1-fe0f",
                "1f3c3-1f3ff-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "woman",
                "racing",
                "running",
                "marathon",
                "woman running facing right"
            ],
            u: "1f3c3-200d-2640-fe0f-200d-27a1-fe0f",
            v: [
                "1f3c3-1f3fb-200d-2640-fe0f-200d-27a1-fe0f",
                "1f3c3-1f3fc-200d-2640-fe0f-200d-27a1-fe0f",
                "1f3c3-1f3fd-200d-2640-fe0f-200d-27a1-fe0f",
                "1f3c3-1f3fe-200d-2640-fe0f-200d-27a1-fe0f",
                "1f3c3-1f3ff-200d-2640-fe0f-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "man",
                "racing",
                "running",
                "marathon",
                "man running facing right"
            ],
            u: "1f3c3-200d-2642-fe0f-200d-27a1-fe0f",
            v: [
                "1f3c3-1f3fb-200d-2642-fe0f-200d-27a1-fe0f",
                "1f3c3-1f3fc-200d-2642-fe0f-200d-27a1-fe0f",
                "1f3c3-1f3fd-200d-2642-fe0f-200d-27a1-fe0f",
                "1f3c3-1f3fe-200d-2642-fe0f-200d-27a1-fe0f",
                "1f3c3-1f3ff-200d-2642-fe0f-200d-27a1-fe0f"
            ],
            a: "15.1"
        },
        {
            n: [
                "dance",
                "woman",
                "dancing",
                "woman dancing"
            ],
            u: "1f483",
            v: [
                "1f483-1f3fb",
                "1f483-1f3fc",
                "1f483-1f3fd",
                "1f483-1f3fe",
                "1f483-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "dance",
                "dancing",
                "man dancing"
            ],
            u: "1f57a",
            v: [
                "1f57a-1f3fb",
                "1f57a-1f3fc",
                "1f57a-1f3fd",
                "1f57a-1f3fe",
                "1f57a-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "suit",
                "person",
                "business",
                "person in suit levitating"
            ],
            u: "1f574-fe0f",
            v: [
                "1f574-1f3fb",
                "1f574-1f3fc",
                "1f574-1f3fd",
                "1f574-1f3fe",
                "1f574-1f3ff"
            ],
            a: "0.7"
        },
        {
            n: [
                "dancer",
                "partying",
                "bunny ear",
                "people with bunny ears"
            ],
            u: "1f46f",
            a: "0.6"
        },
        {
            n: [
                "men",
                "dancer",
                "partying",
                "bunny ear",
                "men with bunny ears"
            ],
            u: "1f46f-200d-2642-fe0f",
            a: "4"
        },
        {
            n: [
                "women",
                "dancer",
                "partying",
                "bunny ear",
                "women with bunny ears"
            ],
            u: "1f46f-200d-2640-fe0f",
            a: "4"
        },
        {
            n: [
                "sauna",
                "steam room",
                "person in steamy room"
            ],
            u: "1f9d6",
            v: [
                "1f9d6-1f3fb",
                "1f9d6-1f3fc",
                "1f9d6-1f3fd",
                "1f9d6-1f3fe",
                "1f9d6-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "sauna",
                "steam room",
                "man in steamy room"
            ],
            u: "1f9d6-200d-2642-fe0f",
            v: [
                "1f9d6-1f3fb-200d-2642-fe0f",
                "1f9d6-1f3fc-200d-2642-fe0f",
                "1f9d6-1f3fd-200d-2642-fe0f",
                "1f9d6-1f3fe-200d-2642-fe0f",
                "1f9d6-1f3ff-200d-2642-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "sauna",
                "steam room",
                "woman in steamy room"
            ],
            u: "1f9d6-200d-2640-fe0f",
            v: [
                "1f9d6-1f3fb-200d-2640-fe0f",
                "1f9d6-1f3fc-200d-2640-fe0f",
                "1f9d6-1f3fd-200d-2640-fe0f",
                "1f9d6-1f3fe-200d-2640-fe0f",
                "1f9d6-1f3ff-200d-2640-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "climber",
                "person climbing"
            ],
            u: "1f9d7",
            v: [
                "1f9d7-1f3fb",
                "1f9d7-1f3fc",
                "1f9d7-1f3fd",
                "1f9d7-1f3fe",
                "1f9d7-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "climber",
                "man climbing"
            ],
            u: "1f9d7-200d-2642-fe0f",
            v: [
                "1f9d7-1f3fb-200d-2642-fe0f",
                "1f9d7-1f3fc-200d-2642-fe0f",
                "1f9d7-1f3fd-200d-2642-fe0f",
                "1f9d7-1f3fe-200d-2642-fe0f",
                "1f9d7-1f3ff-200d-2642-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "climber",
                "woman climbing"
            ],
            u: "1f9d7-200d-2640-fe0f",
            v: [
                "1f9d7-1f3fb-200d-2640-fe0f",
                "1f9d7-1f3fc-200d-2640-fe0f",
                "1f9d7-1f3fd-200d-2640-fe0f",
                "1f9d7-1f3fe-200d-2640-fe0f",
                "1f9d7-1f3ff-200d-2640-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "sword",
                "fencer",
                "fencing",
                "person fencing"
            ],
            u: "1f93a",
            a: "3"
        },
        {
            n: [
                "horse",
                "jockey",
                "racing",
                "racehorse",
                "horse racing"
            ],
            u: "1f3c7",
            v: [
                "1f3c7-1f3fb",
                "1f3c7-1f3fc",
                "1f3c7-1f3fd",
                "1f3c7-1f3fe",
                "1f3c7-1f3ff"
            ],
            a: "1"
        },
        {
            n: [
                "ski",
                "snow",
                "skier"
            ],
            u: "26f7-fe0f",
            a: "0.7"
        },
        {
            n: [
                "ski",
                "snow",
                "snowboard",
                "snowboarder"
            ],
            u: "1f3c2",
            v: [
                "1f3c2-1f3fb",
                "1f3c2-1f3fc",
                "1f3c2-1f3fd",
                "1f3c2-1f3fe",
                "1f3c2-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "ball",
                "golf",
                "person golfing"
            ],
            u: "1f3cc-fe0f",
            v: [
                "1f3cc-1f3fb",
                "1f3cc-1f3fc",
                "1f3cc-1f3fd",
                "1f3cc-1f3fe",
                "1f3cc-1f3ff"
            ],
            a: "0.7"
        },
        {
            n: [
                "man",
                "golf",
                "man golfing"
            ],
            u: "1f3cc-fe0f-200d-2642-fe0f",
            v: [
                "1f3cc-1f3fb-200d-2642-fe0f",
                "1f3cc-1f3fc-200d-2642-fe0f",
                "1f3cc-1f3fd-200d-2642-fe0f",
                "1f3cc-1f3fe-200d-2642-fe0f",
                "1f3cc-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "golf",
                "woman",
                "woman golfing"
            ],
            u: "1f3cc-fe0f-200d-2640-fe0f",
            v: [
                "1f3cc-1f3fb-200d-2640-fe0f",
                "1f3cc-1f3fc-200d-2640-fe0f",
                "1f3cc-1f3fd-200d-2640-fe0f",
                "1f3cc-1f3fe-200d-2640-fe0f",
                "1f3cc-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "surfing",
                "person surfing"
            ],
            u: "1f3c4",
            v: [
                "1f3c4-1f3fb",
                "1f3c4-1f3fc",
                "1f3c4-1f3fd",
                "1f3c4-1f3fe",
                "1f3c4-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "surfing",
                "man surfing"
            ],
            u: "1f3c4-200d-2642-fe0f",
            v: [
                "1f3c4-1f3fb-200d-2642-fe0f",
                "1f3c4-1f3fc-200d-2642-fe0f",
                "1f3c4-1f3fd-200d-2642-fe0f",
                "1f3c4-1f3fe-200d-2642-fe0f",
                "1f3c4-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "surfing",
                "woman surfing"
            ],
            u: "1f3c4-200d-2640-fe0f",
            v: [
                "1f3c4-1f3fb-200d-2640-fe0f",
                "1f3c4-1f3fc-200d-2640-fe0f",
                "1f3c4-1f3fd-200d-2640-fe0f",
                "1f3c4-1f3fe-200d-2640-fe0f",
                "1f3c4-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "boat",
                "rowboat",
                "person rowing boat"
            ],
            u: "1f6a3",
            v: [
                "1f6a3-1f3fb",
                "1f6a3-1f3fc",
                "1f6a3-1f3fd",
                "1f6a3-1f3fe",
                "1f6a3-1f3ff"
            ],
            a: "1"
        },
        {
            n: [
                "man",
                "boat",
                "rowboat",
                "man rowing boat"
            ],
            u: "1f6a3-200d-2642-fe0f",
            v: [
                "1f6a3-1f3fb-200d-2642-fe0f",
                "1f6a3-1f3fc-200d-2642-fe0f",
                "1f6a3-1f3fd-200d-2642-fe0f",
                "1f6a3-1f3fe-200d-2642-fe0f",
                "1f6a3-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "boat",
                "woman",
                "rowboat",
                "woman rowing boat"
            ],
            u: "1f6a3-200d-2640-fe0f",
            v: [
                "1f6a3-1f3fb-200d-2640-fe0f",
                "1f6a3-1f3fc-200d-2640-fe0f",
                "1f6a3-1f3fd-200d-2640-fe0f",
                "1f6a3-1f3fe-200d-2640-fe0f",
                "1f6a3-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "swim",
                "person swimming"
            ],
            u: "1f3ca",
            v: [
                "1f3ca-1f3fb",
                "1f3ca-1f3fc",
                "1f3ca-1f3fd",
                "1f3ca-1f3fe",
                "1f3ca-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "swim",
                "man swimming"
            ],
            u: "1f3ca-200d-2642-fe0f",
            v: [
                "1f3ca-1f3fb-200d-2642-fe0f",
                "1f3ca-1f3fc-200d-2642-fe0f",
                "1f3ca-1f3fd-200d-2642-fe0f",
                "1f3ca-1f3fe-200d-2642-fe0f",
                "1f3ca-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "swim",
                "woman",
                "woman swimming"
            ],
            u: "1f3ca-200d-2640-fe0f",
            v: [
                "1f3ca-1f3fb-200d-2640-fe0f",
                "1f3ca-1f3fc-200d-2640-fe0f",
                "1f3ca-1f3fd-200d-2640-fe0f",
                "1f3ca-1f3fe-200d-2640-fe0f",
                "1f3ca-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "ball",
                "person bouncing ball"
            ],
            u: "26f9-fe0f",
            v: [
                "26f9-1f3fb",
                "26f9-1f3fc",
                "26f9-1f3fd",
                "26f9-1f3fe",
                "26f9-1f3ff"
            ],
            a: "0.7"
        },
        {
            n: [
                "man",
                "ball",
                "man bouncing ball"
            ],
            u: "26f9-fe0f-200d-2642-fe0f",
            v: [
                "26f9-1f3fb-200d-2642-fe0f",
                "26f9-1f3fc-200d-2642-fe0f",
                "26f9-1f3fd-200d-2642-fe0f",
                "26f9-1f3fe-200d-2642-fe0f",
                "26f9-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "ball",
                "woman",
                "woman bouncing ball"
            ],
            u: "26f9-fe0f-200d-2640-fe0f",
            v: [
                "26f9-1f3fb-200d-2640-fe0f",
                "26f9-1f3fc-200d-2640-fe0f",
                "26f9-1f3fd-200d-2640-fe0f",
                "26f9-1f3fe-200d-2640-fe0f",
                "26f9-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "lifter",
                "weight",
                "person lifting weights"
            ],
            u: "1f3cb-fe0f",
            v: [
                "1f3cb-1f3fb",
                "1f3cb-1f3fc",
                "1f3cb-1f3fd",
                "1f3cb-1f3fe",
                "1f3cb-1f3ff"
            ],
            a: "0.7"
        },
        {
            n: [
                "man",
                "weight lifter",
                "man lifting weights"
            ],
            u: "1f3cb-fe0f-200d-2642-fe0f",
            v: [
                "1f3cb-1f3fb-200d-2642-fe0f",
                "1f3cb-1f3fc-200d-2642-fe0f",
                "1f3cb-1f3fd-200d-2642-fe0f",
                "1f3cb-1f3fe-200d-2642-fe0f",
                "1f3cb-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "weight lifter",
                "woman lifting weights"
            ],
            u: "1f3cb-fe0f-200d-2640-fe0f",
            v: [
                "1f3cb-1f3fb-200d-2640-fe0f",
                "1f3cb-1f3fc-200d-2640-fe0f",
                "1f3cb-1f3fd-200d-2640-fe0f",
                "1f3cb-1f3fe-200d-2640-fe0f",
                "1f3cb-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "biking",
                "bicycle",
                "cyclist",
                "person biking"
            ],
            u: "1f6b4",
            v: [
                "1f6b4-1f3fb",
                "1f6b4-1f3fc",
                "1f6b4-1f3fd",
                "1f6b4-1f3fe",
                "1f6b4-1f3ff"
            ],
            a: "1"
        },
        {
            n: [
                "man",
                "biking",
                "bicycle",
                "cyclist",
                "man biking"
            ],
            u: "1f6b4-200d-2642-fe0f",
            v: [
                "1f6b4-1f3fb-200d-2642-fe0f",
                "1f6b4-1f3fc-200d-2642-fe0f",
                "1f6b4-1f3fd-200d-2642-fe0f",
                "1f6b4-1f3fe-200d-2642-fe0f",
                "1f6b4-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "biking",
                "bicycle",
                "cyclist",
                "woman biking"
            ],
            u: "1f6b4-200d-2640-fe0f",
            v: [
                "1f6b4-1f3fb-200d-2640-fe0f",
                "1f6b4-1f3fc-200d-2640-fe0f",
                "1f6b4-1f3fd-200d-2640-fe0f",
                "1f6b4-1f3fe-200d-2640-fe0f",
                "1f6b4-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "bike",
                "bicycle",
                "cyclist",
                "mountain",
                "bicyclist",
                "person mountain biking"
            ],
            u: "1f6b5",
            v: [
                "1f6b5-1f3fb",
                "1f6b5-1f3fc",
                "1f6b5-1f3fd",
                "1f6b5-1f3fe",
                "1f6b5-1f3ff"
            ],
            a: "1"
        },
        {
            n: [
                "man",
                "bike",
                "bicycle",
                "cyclist",
                "mountain",
                "man mountain biking"
            ],
            u: "1f6b5-200d-2642-fe0f",
            v: [
                "1f6b5-1f3fb-200d-2642-fe0f",
                "1f6b5-1f3fc-200d-2642-fe0f",
                "1f6b5-1f3fd-200d-2642-fe0f",
                "1f6b5-1f3fe-200d-2642-fe0f",
                "1f6b5-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "bike",
                "woman",
                "biking",
                "bicycle",
                "cyclist",
                "mountain",
                "woman mountain biking"
            ],
            u: "1f6b5-200d-2640-fe0f",
            v: [
                "1f6b5-1f3fb-200d-2640-fe0f",
                "1f6b5-1f3fc-200d-2640-fe0f",
                "1f6b5-1f3fd-200d-2640-fe0f",
                "1f6b5-1f3fe-200d-2640-fe0f",
                "1f6b5-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "cartwheel",
                "gymnastics",
                "person cartwheeling"
            ],
            u: "1f938",
            v: [
                "1f938-1f3fb",
                "1f938-1f3fc",
                "1f938-1f3fd",
                "1f938-1f3fe",
                "1f938-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "man",
                "cartwheel",
                "gymnastics",
                "man cartwheeling"
            ],
            u: "1f938-200d-2642-fe0f",
            v: [
                "1f938-1f3fb-200d-2642-fe0f",
                "1f938-1f3fc-200d-2642-fe0f",
                "1f938-1f3fd-200d-2642-fe0f",
                "1f938-1f3fe-200d-2642-fe0f",
                "1f938-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "cartwheel",
                "gymnastics",
                "woman cartwheeling"
            ],
            u: "1f938-200d-2640-fe0f",
            v: [
                "1f938-1f3fb-200d-2640-fe0f",
                "1f938-1f3fc-200d-2640-fe0f",
                "1f938-1f3fd-200d-2640-fe0f",
                "1f938-1f3fe-200d-2640-fe0f",
                "1f938-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "wrestle",
                "wrestler",
                "people wrestling"
            ],
            u: "1f93c",
            a: "3"
        },
        {
            n: [
                "men",
                "wrestle",
                "men wrestling"
            ],
            u: "1f93c-200d-2642-fe0f",
            a: "4"
        },
        {
            n: [
                "women",
                "wrestle",
                "women wrestling"
            ],
            u: "1f93c-200d-2640-fe0f",
            a: "4"
        },
        {
            n: [
                "polo",
                "water",
                "person playing water polo"
            ],
            u: "1f93d",
            v: [
                "1f93d-1f3fb",
                "1f93d-1f3fc",
                "1f93d-1f3fd",
                "1f93d-1f3fe",
                "1f93d-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "man",
                "water polo",
                "man playing water polo"
            ],
            u: "1f93d-200d-2642-fe0f",
            v: [
                "1f93d-1f3fb-200d-2642-fe0f",
                "1f93d-1f3fc-200d-2642-fe0f",
                "1f93d-1f3fd-200d-2642-fe0f",
                "1f93d-1f3fe-200d-2642-fe0f",
                "1f93d-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "water polo",
                "woman playing water polo"
            ],
            u: "1f93d-200d-2640-fe0f",
            v: [
                "1f93d-1f3fb-200d-2640-fe0f",
                "1f93d-1f3fc-200d-2640-fe0f",
                "1f93d-1f3fd-200d-2640-fe0f",
                "1f93d-1f3fe-200d-2640-fe0f",
                "1f93d-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "ball",
                "handball",
                "person playing handball"
            ],
            u: "1f93e",
            v: [
                "1f93e-1f3fb",
                "1f93e-1f3fc",
                "1f93e-1f3fd",
                "1f93e-1f3fe",
                "1f93e-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "man",
                "handball",
                "man playing handball"
            ],
            u: "1f93e-200d-2642-fe0f",
            v: [
                "1f93e-1f3fb-200d-2642-fe0f",
                "1f93e-1f3fc-200d-2642-fe0f",
                "1f93e-1f3fd-200d-2642-fe0f",
                "1f93e-1f3fe-200d-2642-fe0f",
                "1f93e-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "handball",
                "woman playing handball"
            ],
            u: "1f93e-200d-2640-fe0f",
            v: [
                "1f93e-1f3fb-200d-2640-fe0f",
                "1f93e-1f3fc-200d-2640-fe0f",
                "1f93e-1f3fd-200d-2640-fe0f",
                "1f93e-1f3fe-200d-2640-fe0f",
                "1f93e-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "skill",
                "juggle",
                "balance",
                "multitask",
                "person juggling"
            ],
            u: "1f939",
            v: [
                "1f939-1f3fb",
                "1f939-1f3fc",
                "1f939-1f3fd",
                "1f939-1f3fe",
                "1f939-1f3ff"
            ],
            a: "3"
        },
        {
            n: [
                "man",
                "juggling",
                "multitask",
                "man juggling"
            ],
            u: "1f939-200d-2642-fe0f",
            v: [
                "1f939-1f3fb-200d-2642-fe0f",
                "1f939-1f3fc-200d-2642-fe0f",
                "1f939-1f3fd-200d-2642-fe0f",
                "1f939-1f3fe-200d-2642-fe0f",
                "1f939-1f3ff-200d-2642-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "woman",
                "juggling",
                "multitask",
                "woman juggling"
            ],
            u: "1f939-200d-2640-fe0f",
            v: [
                "1f939-1f3fb-200d-2640-fe0f",
                "1f939-1f3fc-200d-2640-fe0f",
                "1f939-1f3fd-200d-2640-fe0f",
                "1f939-1f3fe-200d-2640-fe0f",
                "1f939-1f3ff-200d-2640-fe0f"
            ],
            a: "4"
        },
        {
            n: [
                "yoga",
                "meditation",
                "person in lotus position"
            ],
            u: "1f9d8",
            v: [
                "1f9d8-1f3fb",
                "1f9d8-1f3fc",
                "1f9d8-1f3fd",
                "1f9d8-1f3fe",
                "1f9d8-1f3ff"
            ],
            a: "5"
        },
        {
            n: [
                "yoga",
                "meditation",
                "man in lotus position"
            ],
            u: "1f9d8-200d-2642-fe0f",
            v: [
                "1f9d8-1f3fb-200d-2642-fe0f",
                "1f9d8-1f3fc-200d-2642-fe0f",
                "1f9d8-1f3fd-200d-2642-fe0f",
                "1f9d8-1f3fe-200d-2642-fe0f",
                "1f9d8-1f3ff-200d-2642-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "yoga",
                "meditation",
                "woman in lotus position"
            ],
            u: "1f9d8-200d-2640-fe0f",
            v: [
                "1f9d8-1f3fb-200d-2640-fe0f",
                "1f9d8-1f3fc-200d-2640-fe0f",
                "1f9d8-1f3fd-200d-2640-fe0f",
                "1f9d8-1f3fe-200d-2640-fe0f",
                "1f9d8-1f3ff-200d-2640-fe0f"
            ],
            a: "5"
        },
        {
            n: [
                "bath",
                "bathtub",
                "person taking bath"
            ],
            u: "1f6c0",
            v: [
                "1f6c0-1f3fb",
                "1f6c0-1f3fc",
                "1f6c0-1f3fd",
                "1f6c0-1f3fe",
                "1f6c0-1f3ff"
            ],
            a: "0.6"
        },
        {
            n: [
                "hotel",
                "sleep",
                "good night",
                "person in bed"
            ],
            u: "1f6cc",
            v: [
                "1f6cc-1f3fb",
                "1f6cc-1f3fc",
                "1f6cc-1f3fd",
                "1f6cc-1f3fe",
                "1f6cc-1f3ff"
            ],
            a: "1"
        },
        {
            n: [
                "hand",
                "hold",
                "couple",
                "person",
                "holding hands",
                "people holding hands"
            ],
            u: "1f9d1-200d-1f91d-200d-1f9d1",
            v: [
                "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb",
                "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fc",
                "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fd",
                "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fe",
                "1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3ff",
                "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fb",
                "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc",
                "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fd",
                "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fe",
                "1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3ff",
                "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fb",
                "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fc",
                "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd",
                "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fe",
                "1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3ff",
                "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fb",
                "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fc",
                "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fd",
                "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe",
                "1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3ff",
                "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fb",
                "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fc",
                "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fd",
                "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3fe",
                "1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff"
            ],
            a: "12"
        },
        {
            n: [
                "hand",
                "women",
                "couple",
                "holding hands",
                "women holding hands"
            ],
            u: "1f46d",
            v: [
                "1f46d-1f3fb",
                "1f46d-1f3fc",
                "1f46d-1f3fd",
                "1f46d-1f3fe",
                "1f46d-1f3ff",
                "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fc",
                "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fd",
                "1f469-1f3fb-200d-1f91d-200d-1f469-1f3fe",
                "1f469-1f3fb-200d-1f91d-200d-1f469-1f3ff",
                "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fb",
                "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fd",
                "1f469-1f3fc-200d-1f91d-200d-1f469-1f3fe",
                "1f469-1f3fc-200d-1f91d-200d-1f469-1f3ff",
                "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fb",
                "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fc",
                "1f469-1f3fd-200d-1f91d-200d-1f469-1f3fe",
                "1f469-1f3fd-200d-1f91d-200d-1f469-1f3ff",
                "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fb",
                "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fc",
                "1f469-1f3fe-200d-1f91d-200d-1f469-1f3fd",
                "1f469-1f3fe-200d-1f91d-200d-1f469-1f3ff",
                "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fb",
                "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fc",
                "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fd",
                "1f469-1f3ff-200d-1f91d-200d-1f469-1f3fe"
            ],
            a: "1"
        },
        {
            n: [
                "man",
                "hand",
                "hold",
                "woman",
                "couple",
                "holding hands",
                "woman and man holding hands"
            ],
            u: "1f46b",
            v: [
                "1f46b-1f3fb",
                "1f46b-1f3fc",
                "1f46b-1f3fd",
                "1f46b-1f3fe",
                "1f46b-1f3ff",
                "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fc",
                "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fd",
                "1f469-1f3fb-200d-1f91d-200d-1f468-1f3fe",
                "1f469-1f3fb-200d-1f91d-200d-1f468-1f3ff",
                "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fb",
                "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fd",
                "1f469-1f3fc-200d-1f91d-200d-1f468-1f3fe",
                "1f469-1f3fc-200d-1f91d-200d-1f468-1f3ff",
                "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fb",
                "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fc",
                "1f469-1f3fd-200d-1f91d-200d-1f468-1f3fe",
                "1f469-1f3fd-200d-1f91d-200d-1f468-1f3ff",
                "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fb",
                "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fc",
                "1f469-1f3fe-200d-1f91d-200d-1f468-1f3fd",
                "1f469-1f3fe-200d-1f91d-200d-1f468-1f3ff",
                "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fb",
                "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fc",
                "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fd",
                "1f469-1f3ff-200d-1f91d-200d-1f468-1f3fe"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "men",
                "twins",
                "couple",
                "gemini",
                "zodiac",
                "holding hands",
                "men holding hands"
            ],
            u: "1f46c",
            v: [
                "1f46c-1f3fb",
                "1f46c-1f3fc",
                "1f46c-1f3fd",
                "1f46c-1f3fe",
                "1f46c-1f3ff",
                "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fc",
                "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fd",
                "1f468-1f3fb-200d-1f91d-200d-1f468-1f3fe",
                "1f468-1f3fb-200d-1f91d-200d-1f468-1f3ff",
                "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fb",
                "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fd",
                "1f468-1f3fc-200d-1f91d-200d-1f468-1f3fe",
                "1f468-1f3fc-200d-1f91d-200d-1f468-1f3ff",
                "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fb",
                "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fc",
                "1f468-1f3fd-200d-1f91d-200d-1f468-1f3fe",
                "1f468-1f3fd-200d-1f91d-200d-1f468-1f3ff",
                "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fb",
                "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fc",
                "1f468-1f3fe-200d-1f91d-200d-1f468-1f3fd",
                "1f468-1f3fe-200d-1f91d-200d-1f468-1f3ff",
                "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fb",
                "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fc",
                "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fd",
                "1f468-1f3ff-200d-1f91d-200d-1f468-1f3fe"
            ],
            a: "1"
        },
        {
            n: [
                "kiss",
                "couple"
            ],
            u: "1f48f",
            v: [
                "1f48f-1f3fb",
                "1f48f-1f3fc",
                "1f48f-1f3fd",
                "1f48f-1f3fe",
                "1f48f-1f3ff",
                "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
                "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
                "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
                "1f9d1-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
                "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
                "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
                "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
                "1f9d1-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
                "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
                "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
                "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe",
                "1f9d1-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
                "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
                "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
                "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
                "1f9d1-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3ff",
                "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fb",
                "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fc",
                "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fd",
                "1f9d1-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f9d1-1f3fe"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "kiss",
                "woman",
                "couple",
                "kiss: woman, man"
            ],
            u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f468",
            v: [
                "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
            ],
            a: "2"
        },
        {
            n: [
                "man",
                "kiss",
                "couple",
                "kiss: man, man"
            ],
            u: "1f468-200d-2764-fe0f-200d-1f48b-200d-1f468",
            v: [
                "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                "1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                "1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                "1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                "1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff",
                "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb",
                "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc",
                "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd",
                "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe",
                "1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff"
            ],
            a: "2"
        },
        {
            n: [
                "kiss",
                "woman",
                "couple",
                "kiss: woman, woman"
            ],
            u: "1f469-200d-2764-fe0f-200d-1f48b-200d-1f469",
            v: [
                "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff"
            ],
            a: "2"
        },
        {
            n: [
                "love",
                "couple",
                "couple with heart"
            ],
            u: "1f491",
            v: [
                "1f491-1f3fb",
                "1f491-1f3fc",
                "1f491-1f3fd",
                "1f491-1f3fe",
                "1f491-1f3ff",
                "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fc",
                "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fd",
                "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3fe",
                "1f9d1-1f3fb-200d-2764-fe0f-200d-1f9d1-1f3ff",
                "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fb",
                "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fd",
                "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3fe",
                "1f9d1-1f3fc-200d-2764-fe0f-200d-1f9d1-1f3ff",
                "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fb",
                "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fc",
                "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3fe",
                "1f9d1-1f3fd-200d-2764-fe0f-200d-1f9d1-1f3ff",
                "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fb",
                "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fc",
                "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3fd",
                "1f9d1-1f3fe-200d-2764-fe0f-200d-1f9d1-1f3ff",
                "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fb",
                "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fc",
                "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fd",
                "1f9d1-1f3ff-200d-2764-fe0f-200d-1f9d1-1f3fe"
            ],
            a: "0.6"
        },
        {
            n: [
                "man",
                "love",
                "woman",
                "couple",
                "couple with heart",
                "couple with heart: woman, man"
            ],
            u: "1f469-200d-2764-fe0f-200d-1f468",
            v: [
                "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
            ],
            a: "2"
        },
        {
            n: [
                "man",
                "love",
                "couple",
                "couple with heart",
                "couple with heart: man, man"
            ],
            u: "1f468-200d-2764-fe0f-200d-1f468",
            v: [
                "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb",
                "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fc",
                "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fd",
                "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fe",
                "1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3ff",
                "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fb",
                "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc",
                "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fd",
                "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fe",
                "1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3ff",
                "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fb",
                "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fc",
                "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd",
                "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fe",
                "1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3ff",
                "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fb",
                "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fc",
                "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fd",
                "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe",
                "1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3ff",
                "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fb",
                "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fc",
                "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fd",
                "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3fe",
                "1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff"
            ],
            a: "2"
        },
        {
            n: [
                "love",
                "woman",
                "couple",
                "couple with heart",
                "couple with heart: woman, woman"
            ],
            u: "1f469-200d-2764-fe0f-200d-1f469",
            v: [
                "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fc",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fd",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fe",
                "1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3ff",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fb",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fd",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fe",
                "1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3ff",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fb",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fc",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fe",
                "1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3ff",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fb",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fc",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fd",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe",
                "1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3ff",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fb",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fc",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fd",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3fe",
                "1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff"
            ],
            a: "2"
        },
        {
            n: [
                "boy",
                "man",
                "woman",
                "family",
                "family: man, woman, boy"
            ],
            u: "1f468-200d-1f469-200d-1f466",
            a: "2"
        },
        {
            n: [
                "man",
                "girl",
                "woman",
                "family",
                "family: man, woman, girl"
            ],
            u: "1f468-200d-1f469-200d-1f467",
            a: "2"
        },
        {
            n: [
                "boy",
                "man",
                "girl",
                "woman",
                "family",
                "family: man, woman, girl, boy"
            ],
            u: "1f468-200d-1f469-200d-1f467-200d-1f466",
            a: "2"
        },
        {
            n: [
                "boy",
                "man",
                "woman",
                "family",
                "family: man, woman, boy, boy"
            ],
            u: "1f468-200d-1f469-200d-1f466-200d-1f466",
            a: "2"
        },
        {
            n: [
                "man",
                "girl",
                "woman",
                "family",
                "family: man, woman, girl, girl"
            ],
            u: "1f468-200d-1f469-200d-1f467-200d-1f467",
            a: "2"
        },
        {
            n: [
                "boy",
                "man",
                "family",
                "family: man, man, boy"
            ],
            u: "1f468-200d-1f468-200d-1f466",
            a: "2"
        },
        {
            n: [
                "man",
                "girl",
                "family",
                "family: man, man, girl"
            ],
            u: "1f468-200d-1f468-200d-1f467",
            a: "2"
        },
        {
            n: [
                "boy",
                "man",
                "girl",
                "family",
                "family: man, man, girl, boy"
            ],
            u: "1f468-200d-1f468-200d-1f467-200d-1f466",
            a: "2"
        },
        {
            n: [
                "boy",
                "man",
                "family",
                "family: man, man, boy, boy"
            ],
            u: "1f468-200d-1f468-200d-1f466-200d-1f466",
            a: "2"
        },
        {
            n: [
                "man",
                "girl",
                "family",
                "family: man, man, girl, girl"
            ],
            u: "1f468-200d-1f468-200d-1f467-200d-1f467",
            a: "2"
        },
        {
            n: [
                "boy",
                "woman",
                "family",
                "family: woman, woman, boy"
            ],
            u: "1f469-200d-1f469-200d-1f466",
            a: "2"
        },
        {
            n: [
                "girl",
                "woman",
                "family",
                "family: woman, woman, girl"
            ],
            u: "1f469-200d-1f469-200d-1f467",
            a: "2"
        },
        {
            n: [
                "boy",
                "girl",
                "woman",
                "family",
                "family: woman, woman, girl, boy"
            ],
            u: "1f469-200d-1f469-200d-1f467-200d-1f466",
            a: "2"
        },
        {
            n: [
                "boy",
                "woman",
                "family",
                "family: woman, woman, boy, boy"
            ],
            u: "1f469-200d-1f469-200d-1f466-200d-1f466",
            a: "2"
        },
        {
            n: [
                "girl",
                "woman",
                "family",
                "family: woman, woman, girl, girl"
            ],
            u: "1f469-200d-1f469-200d-1f467-200d-1f467",
            a: "2"
        },
        {
            n: [
                "boy",
                "man",
                "family",
                "family: man, boy"
            ],
            u: "1f468-200d-1f466",
            a: "4"
        },
        {
            n: [
                "boy",
                "man",
                "family",
                "family: man, boy, boy"
            ],
            u: "1f468-200d-1f466-200d-1f466",
            a: "4"
        },
        {
            n: [
                "man",
                "girl",
                "family",
                "family: man, girl"
            ],
            u: "1f468-200d-1f467",
            a: "4"
        },
        {
            n: [
                "boy",
                "man",
                "girl",
                "family",
                "family: man, girl, boy"
            ],
            u: "1f468-200d-1f467-200d-1f466",
            a: "4"
        },
        {
            n: [
                "man",
                "girl",
                "family",
                "family: man, girl, girl"
            ],
            u: "1f468-200d-1f467-200d-1f467",
            a: "4"
        },
        {
            n: [
                "boy",
                "woman",
                "family",
                "family: woman, boy"
            ],
            u: "1f469-200d-1f466",
            a: "4"
        },
        {
            n: [
                "boy",
                "woman",
                "family",
                "family: woman, boy, boy"
            ],
            u: "1f469-200d-1f466-200d-1f466",
            a: "4"
        },
        {
            n: [
                "girl",
                "woman",
                "family",
                "family: woman, girl"
            ],
            u: "1f469-200d-1f467",
            a: "4"
        },
        {
            n: [
                "boy",
                "girl",
                "woman",
                "family",
                "family: woman, girl, boy"
            ],
            u: "1f469-200d-1f467-200d-1f466",
            a: "4"
        },
        {
            n: [
                "girl",
                "woman",
                "family",
                "family: woman, girl, girl"
            ],
            u: "1f469-200d-1f467-200d-1f467",
            a: "4"
        },
        {
            n: [
                "face",
                "head",
                "speak",
                "speaking",
                "silhouette",
                "speaking head"
            ],
            u: "1f5e3-fe0f",
            a: "0.7"
        },
        {
            n: [
                "bust",
                "silhouette",
                "bust in silhouette"
            ],
            u: "1f464",
            a: "0.6"
        },
        {
            n: [
                "bust",
                "silhouette",
                "busts in silhouette"
            ],
            u: "1f465",
            a: "1"
        },
        {
            n: [
                "hug",
                "hello",
                "thanks",
                "goodbye",
                "people hugging"
            ],
            u: "1fac2",
            a: "13"
        },
        {
            n: [
                "family"
            ],
            u: "1f46a",
            a: "0.6"
        },
        {
            n: [
                "family: adult, adult, child"
            ],
            u: "1f9d1-200d-1f9d1-200d-1f9d2",
            a: "15.1"
        },
        {
            n: [
                "family: adult, adult, child, child"
            ],
            u: "1f9d1-200d-1f9d1-200d-1f9d2-200d-1f9d2",
            a: "15.1"
        },
        {
            n: [
                "family: adult, child"
            ],
            u: "1f9d1-200d-1f9d2",
            a: "15.1"
        },
        {
            n: [
                "family: adult, child, child"
            ],
            u: "1f9d1-200d-1f9d2-200d-1f9d2",
            a: "15.1"
        },
        {
            n: [
                "print",
                "clothing",
                "footprint",
                "footprints"
            ],
            u: "1f463",
            a: "0.6"
        }
    ],
    animals_nature: [
        {
            n: [
                "face",
                "monkey",
                "monkey face"
            ],
            u: "1f435",
            a: "0.6"
        },
        {
            n: [
                "monkey"
            ],
            u: "1f412",
            a: "0.6"
        },
        {
            n: [
                "gorilla"
            ],
            u: "1f98d",
            a: "3"
        },
        {
            n: [
                "ape",
                "orangutan"
            ],
            u: "1f9a7",
            a: "12"
        },
        {
            n: [
                "dog",
                "pet",
                "face",
                "dog face"
            ],
            u: "1f436",
            a: "0.6"
        },
        {
            n: [
                "dog",
                "pet"
            ],
            u: "1f415",
            a: "0.7"
        },
        {
            n: [
                "blind",
                "guide",
                "guide dog",
                "accessibility"
            ],
            u: "1f9ae",
            a: "12"
        },
        {
            n: [
                "dog",
                "service",
                "assistance",
                "service dog",
                "accessibility"
            ],
            u: "1f415-200d-1f9ba",
            a: "12"
        },
        {
            n: [
                "dog",
                "poodle"
            ],
            u: "1f429",
            a: "0.6"
        },
        {
            n: [
                "wolf",
                "face"
            ],
            u: "1f43a",
            a: "0.6"
        },
        {
            n: [
                "fox",
                "face"
            ],
            u: "1f98a",
            a: "3"
        },
        {
            n: [
                "sly",
                "raccoon",
                "curious"
            ],
            u: "1f99d",
            a: "11"
        },
        {
            n: [
                "cat",
                "pet",
                "face",
                "cat face"
            ],
            u: "1f431",
            a: "0.6"
        },
        {
            n: [
                "cat",
                "pet"
            ],
            u: "1f408",
            a: "0.7"
        },
        {
            n: [
                "cat",
                "black",
                "unlucky",
                "black cat"
            ],
            u: "1f408-200d-2b1b",
            a: "13"
        },
        {
            n: [
                "leo",
                "lion",
                "face",
                "zodiac"
            ],
            u: "1f981",
            a: "1"
        },
        {
            n: [
                "face",
                "tiger",
                "tiger face"
            ],
            u: "1f42f",
            a: "0.6"
        },
        {
            n: [
                "tiger"
            ],
            u: "1f405",
            a: "1"
        },
        {
            n: [
                "leopard"
            ],
            u: "1f406",
            a: "1"
        },
        {
            n: [
                "face",
                "horse",
                "horse face"
            ],
            u: "1f434",
            a: "0.6"
        },
        {
            n: [
                "elk",
                "moose",
                "animal",
                "mammal",
                "antlers"
            ],
            u: "1face",
            a: "15"
        },
        {
            n: [
                "ass",
                "mule",
                "burro",
                "donkey",
                "animal",
                "mammal",
                "stubborn"
            ],
            u: "1facf",
            a: "15"
        },
        {
            n: [
                "horse",
                "racing",
                "racehorse",
                "equestrian"
            ],
            u: "1f40e",
            a: "0.6"
        },
        {
            n: [
                "face",
                "unicorn"
            ],
            u: "1f984",
            a: "1"
        },
        {
            n: [
                "zebra",
                "stripe"
            ],
            u: "1f993",
            a: "5"
        },
        {
            n: [
                "deer"
            ],
            u: "1f98c",
            a: "3"
        },
        {
            n: [
                "herd",
                "bison",
                "wisent",
                "buffalo"
            ],
            u: "1f9ac",
            a: "13"
        },
        {
            n: [
                "cow",
                "face",
                "cow face"
            ],
            u: "1f42e",
            a: "0.6"
        },
        {
            n: [
                "ox",
                "bull",
                "taurus",
                "zodiac"
            ],
            u: "1f402",
            a: "1"
        },
        {
            n: [
                "water",
                "buffalo",
                "water buffalo"
            ],
            u: "1f403",
            a: "1"
        },
        {
            n: [
                "cow"
            ],
            u: "1f404",
            a: "1"
        },
        {
            n: [
                "pig",
                "face",
                "pig face"
            ],
            u: "1f437",
            a: "0.6"
        },
        {
            n: [
                "pig",
                "sow"
            ],
            u: "1f416",
            a: "1"
        },
        {
            n: [
                "pig",
                "boar"
            ],
            u: "1f417",
            a: "0.6"
        },
        {
            n: [
                "pig",
                "face",
                "nose",
                "pig nose"
            ],
            u: "1f43d",
            a: "0.6"
        },
        {
            n: [
                "ram",
                "male",
                "aries",
                "sheep",
                "zodiac"
            ],
            u: "1f40f",
            a: "1"
        },
        {
            n: [
                "ewe",
                "sheep",
                "female"
            ],
            u: "1f411",
            a: "0.6"
        },
        {
            n: [
                "goat",
                "zodiac",
                "capricorn"
            ],
            u: "1f410",
            a: "1"
        },
        {
            n: [
                "hump",
                "camel",
                "dromedary"
            ],
            u: "1f42a",
            a: "1"
        },
        {
            n: [
                "hump",
                "camel",
                "bactrian",
                "two hump camel"
            ],
            u: "1f42b",
            a: "0.6"
        },
        {
            n: [
                "wool",
                "llama",
                "alpaca",
                "vicu\xf1a",
                "guanaco"
            ],
            u: "1f999",
            a: "11"
        },
        {
            n: [
                "spots",
                "giraffe"
            ],
            u: "1f992",
            a: "5"
        },
        {
            n: [
                "elephant"
            ],
            u: "1f418",
            a: "0.6"
        },
        {
            n: [
                "tusk",
                "large",
                "woolly",
                "mammoth",
                "extinction"
            ],
            u: "1f9a3",
            a: "13"
        },
        {
            n: [
                "rhinoceros"
            ],
            u: "1f98f",
            a: "3"
        },
        {
            n: [
                "hippo",
                "hippopotamus"
            ],
            u: "1f99b",
            a: "11"
        },
        {
            n: [
                "face",
                "mouse",
                "mouse face"
            ],
            u: "1f42d",
            a: "0.6"
        },
        {
            n: [
                "mouse"
            ],
            u: "1f401",
            a: "1"
        },
        {
            n: [
                "rat"
            ],
            u: "1f400",
            a: "1"
        },
        {
            n: [
                "pet",
                "face",
                "hamster"
            ],
            u: "1f439",
            a: "0.6"
        },
        {
            n: [
                "pet",
                "face",
                "bunny",
                "rabbit",
                "rabbit face"
            ],
            u: "1f430",
            a: "0.6"
        },
        {
            n: [
                "pet",
                "bunny",
                "rabbit"
            ],
            u: "1f407",
            a: "1"
        },
        {
            n: [
                "chipmunk",
                "squirrel"
            ],
            u: "1f43f-fe0f",
            a: "0.7"
        },
        {
            n: [
                "dam",
                "beaver"
            ],
            u: "1f9ab",
            a: "13"
        },
        {
            n: [
                "spiny",
                "hedgehog"
            ],
            u: "1f994",
            a: "5"
        },
        {
            n: [
                "bat",
                "vampire"
            ],
            u: "1f987",
            a: "3"
        },
        {
            n: [
                "bear",
                "face"
            ],
            u: "1f43b",
            a: "0.6"
        },
        {
            n: [
                "bear",
                "white",
                "arctic",
                "polar bear"
            ],
            u: "1f43b-200d-2744-fe0f",
            a: "13"
        },
        {
            n: [
                "face",
                "koala",
                "marsupial"
            ],
            u: "1f428",
            a: "0.6"
        },
        {
            n: [
                "face",
                "panda"
            ],
            u: "1f43c",
            a: "0.6"
        },
        {
            n: [
                "lazy",
                "slow",
                "sloth"
            ],
            u: "1f9a5",
            a: "12"
        },
        {
            n: [
                "otter",
                "fishing",
                "playful"
            ],
            u: "1f9a6",
            a: "12"
        },
        {
            n: [
                "skunk",
                "stink"
            ],
            u: "1f9a8",
            a: "12"
        },
        {
            n: [
                "joey",
                "jump",
                "kangaroo",
                "marsupial"
            ],
            u: "1f998",
            a: "11"
        },
        {
            n: [
                "badger",
                "pester",
                "honey badger"
            ],
            u: "1f9a1",
            a: "11"
        },
        {
            n: [
                "paw",
                "feet",
                "print",
                "paw prints"
            ],
            u: "1f43e",
            a: "0.6"
        },
        {
            n: [
                "bird",
                "turkey"
            ],
            u: "1f983",
            a: "1"
        },
        {
            n: [
                "bird",
                "chicken"
            ],
            u: "1f414",
            a: "0.6"
        },
        {
            n: [
                "bird",
                "rooster"
            ],
            u: "1f413",
            a: "1"
        },
        {
            n: [
                "baby",
                "bird",
                "chick",
                "hatching",
                "hatching chick"
            ],
            u: "1f423",
            a: "0.6"
        },
        {
            n: [
                "baby",
                "bird",
                "chick",
                "baby chick"
            ],
            u: "1f424",
            a: "0.6"
        },
        {
            n: [
                "baby",
                "bird",
                "chick",
                "front facing baby chick"
            ],
            u: "1f425",
            a: "0.6"
        },
        {
            n: [
                "bird"
            ],
            u: "1f426",
            a: "0.6"
        },
        {
            n: [
                "bird",
                "penguin"
            ],
            u: "1f427",
            a: "0.6"
        },
        {
            n: [
                "fly",
                "dove",
                "bird",
                "peace"
            ],
            u: "1f54a-fe0f",
            a: "0.7"
        },
        {
            n: [
                "bird",
                "eagle"
            ],
            u: "1f985",
            a: "3"
        },
        {
            n: [
                "duck",
                "bird"
            ],
            u: "1f986",
            a: "3"
        },
        {
            n: [
                "swan",
                "bird",
                "cygnet",
                "ugly duckling"
            ],
            u: "1f9a2",
            a: "11"
        },
        {
            n: [
                "owl",
                "bird",
                "wise"
            ],
            u: "1f989",
            a: "3"
        },
        {
            n: [
                "dodo",
                "large",
                "mauritius",
                "extinction"
            ],
            u: "1f9a4",
            a: "13"
        },
        {
            n: [
                "bird",
                "light",
                "flight",
                "feather",
                "plumage"
            ],
            u: "1fab6",
            a: "13"
        },
        {
            n: [
                "flamingo",
                "tropical",
                "flamboyant"
            ],
            u: "1f9a9",
            a: "12"
        },
        {
            n: [
                "bird",
                "proud",
                "peahen",
                "peacock",
                "ostentatious"
            ],
            u: "1f99a",
            a: "11"
        },
        {
            n: [
                "bird",
                "talk",
                "parrot",
                "pirate"
            ],
            u: "1f99c",
            a: "11"
        },
        {
            n: [
                "wing",
                "bird",
                "flying",
                "angelic",
                "aviation",
                "mythology"
            ],
            u: "1fabd",
            a: "15"
        },
        {
            n: [
                "bird",
                "crow",
                "rook",
                "black",
                "raven",
                "black bird"
            ],
            u: "1f426-200d-2b1b",
            a: "15"
        },
        {
            n: [
                "bird",
                "fowl",
                "honk",
                "goose",
                "silly"
            ],
            u: "1fabf",
            a: "15"
        },
        {
            n: [
                "phoenix",
                "fantasy",
                "rebirth",
                "firebird",
                "reincarnation"
            ],
            u: "1f426-200d-1f525",
            a: "15.1"
        },
        {
            n: [
                "frog",
                "face"
            ],
            u: "1f438",
            a: "0.6"
        },
        {
            n: [
                "crocodile"
            ],
            u: "1f40a",
            a: "1"
        },
        {
            n: [
                "turtle",
                "terrapin",
                "tortoise"
            ],
            u: "1f422",
            a: "0.6"
        },
        {
            n: [
                "lizard",
                "reptile"
            ],
            u: "1f98e",
            a: "3"
        },
        {
            n: [
                "snake",
                "bearer",
                "zodiac",
                "serpent",
                "ophiuchus"
            ],
            u: "1f40d",
            a: "0.6"
        },
        {
            n: [
                "face",
                "dragon",
                "fairy tale",
                "dragon face"
            ],
            u: "1f432",
            a: "0.6"
        },
        {
            n: [
                "dragon",
                "fairy tale"
            ],
            u: "1f409",
            a: "1"
        },
        {
            n: [
                "sauropod",
                "diplodocus",
                "brontosaurus",
                "brachiosaurus"
            ],
            u: "1f995",
            a: "5"
        },
        {
            n: [
                "T Rex",
                "t rex",
                "tyrannosaurus rex"
            ],
            u: "1f996",
            a: "5"
        },
        {
            n: [
                "face",
                "whale",
                "spouting",
                "spouting whale"
            ],
            u: "1f433",
            a: "0.6"
        },
        {
            n: [
                "whale"
            ],
            u: "1f40b",
            a: "1"
        },
        {
            n: [
                "dolphin",
                "flipper"
            ],
            u: "1f42c",
            a: "0.6"
        },
        {
            n: [
                "seal",
                "sea lion"
            ],
            u: "1f9ad",
            a: "13"
        },
        {
            n: [
                "fish",
                "pisces",
                "zodiac"
            ],
            u: "1f41f",
            a: "0.6"
        },
        {
            n: [
                "fish",
                "tropical",
                "tropical fish"
            ],
            u: "1f420",
            a: "0.6"
        },
        {
            n: [
                "fish",
                "blowfish"
            ],
            u: "1f421",
            a: "0.6"
        },
        {
            n: [
                "fish",
                "shark"
            ],
            u: "1f988",
            a: "3"
        },
        {
            n: [
                "octopus"
            ],
            u: "1f419",
            a: "0.6"
        },
        {
            n: [
                "shell",
                "spiral",
                "spiral shell"
            ],
            u: "1f41a",
            a: "0.6"
        },
        {
            n: [
                "reef",
                "coral",
                "ocean"
            ],
            u: "1fab8",
            a: "14"
        },
        {
            n: [
                "burn",
                "ouch",
                "jelly",
                "marine",
                "stinger",
                "jellyfish",
                "invertebrate"
            ],
            u: "1fabc",
            a: "15"
        },
        {
            n: [
                "snail"
            ],
            u: "1f40c",
            a: "0.6"
        },
        {
            n: [
                "insect",
                "pretty",
                "butterfly"
            ],
            u: "1f98b",
            a: "3"
        },
        {
            n: [
                "bug",
                "insect"
            ],
            u: "1f41b",
            a: "0.6"
        },
        {
            n: [
                "ant",
                "insect"
            ],
            u: "1f41c",
            a: "0.6"
        },
        {
            n: [
                "bee",
                "insect",
                "honeybee"
            ],
            u: "1f41d",
            a: "0.6"
        },
        {
            n: [
                "bug",
                "beetle",
                "insect"
            ],
            u: "1fab2",
            a: "13"
        },
        {
            n: [
                "beetle",
                "insect",
                "ladybug",
                "ladybird",
                "lady beetle"
            ],
            u: "1f41e",
            a: "0.6"
        },
        {
            n: [
                "cricket",
                "grasshopper"
            ],
            u: "1f997",
            a: "5"
        },
        {
            n: [
                "pest",
                "roach",
                "insect",
                "cockroach"
            ],
            u: "1fab3",
            a: "13"
        },
        {
            n: [
                "spider",
                "insect"
            ],
            u: "1f577-fe0f",
            a: "0.7"
        },
        {
            n: [
                "web",
                "spider",
                "spider web"
            ],
            u: "1f578-fe0f",
            a: "0.7"
        },
        {
            n: [
                "zodiac",
                "scorpio",
                "scorpion"
            ],
            u: "1f982",
            a: "1"
        },
        {
            n: [
                "pest",
                "fever",
                "virus",
                "disease",
                "malaria",
                "mosquito"
            ],
            u: "1f99f",
            a: "11"
        },
        {
            n: [
                "fly",
                "pest",
                "maggot",
                "disease",
                "rotting"
            ],
            u: "1fab0",
            a: "13"
        },
        {
            n: [
                "worm",
                "annelid",
                "parasite",
                "earthworm"
            ],
            u: "1fab1",
            a: "13"
        },
        {
            n: [
                "virus",
                "amoeba",
                "microbe",
                "bacteria"
            ],
            u: "1f9a0",
            a: "11"
        },
        {
            n: [
                "flower",
                "bouquet"
            ],
            u: "1f490",
            a: "0.6"
        },
        {
            n: [
                "cherry",
                "flower",
                "blossom",
                "cherry blossom"
            ],
            u: "1f338",
            a: "0.6"
        },
        {
            n: [
                "flower",
                "white flower"
            ],
            u: "1f4ae",
            a: "0.6"
        },
        {
            n: [
                "lotus",
                "flower",
                "purity",
                "buddhism",
                "hinduism"
            ],
            u: "1fab7",
            a: "14"
        },
        {
            n: [
                "plant",
                "rosette"
            ],
            u: "1f3f5-fe0f",
            a: "0.7"
        },
        {
            n: [
                "rose",
                "flower"
            ],
            u: "1f339",
            a: "0.6"
        },
        {
            n: [
                "flower",
                "wilted",
                "wilted flower"
            ],
            u: "1f940",
            a: "3"
        },
        {
            n: [
                "flower",
                "hibiscus"
            ],
            u: "1f33a",
            a: "0.6"
        },
        {
            n: [
                "sun",
                "flower",
                "sunflower"
            ],
            u: "1f33b",
            a: "0.6"
        },
        {
            n: [
                "flower",
                "blossom"
            ],
            u: "1f33c",
            a: "0.6"
        },
        {
            n: [
                "tulip",
                "flower"
            ],
            u: "1f337",
            a: "0.6"
        },
        {
            n: [
                "flower",
                "lupine",
                "hyacinth",
                "lavender",
                "bluebonnet",
                "snapdragon"
            ],
            u: "1fabb",
            a: "15"
        },
        {
            n: [
                "young",
                "seedling"
            ],
            u: "1f331",
            a: "0.6"
        },
        {
            n: [
                "grow",
                "house",
                "plant",
                "boring",
                "useless",
                "nurturing",
                "potted plant"
            ],
            u: "1fab4",
            a: "13"
        },
        {
            n: [
                "tree",
                "evergreen tree"
            ],
            u: "1f332",
            a: "1"
        },
        {
            n: [
                "tree",
                "shedding",
                "deciduous",
                "deciduous tree"
            ],
            u: "1f333",
            a: "1"
        },
        {
            n: [
                "palm",
                "tree",
                "palm tree"
            ],
            u: "1f334",
            a: "0.6"
        },
        {
            n: [
                "plant",
                "cactus"
            ],
            u: "1f335",
            a: "0.6"
        },
        {
            n: [
                "ear",
                "rice",
                "grain",
                "sheaf of rice"
            ],
            u: "1f33e",
            a: "0.6"
        },
        {
            n: [
                "herb",
                "leaf"
            ],
            u: "1f33f",
            a: "0.6"
        },
        {
            n: [
                "plant",
                "shamrock"
            ],
            u: "2618-fe0f",
            a: "1"
        },
        {
            n: [
                "4",
                "four",
                "leaf",
                "clover",
                "four leaf clover"
            ],
            u: "1f340",
            a: "0.6"
        },
        {
            n: [
                "leaf",
                "maple",
                "falling",
                "maple leaf"
            ],
            u: "1f341",
            a: "0.6"
        },
        {
            n: [
                "leaf",
                "falling",
                "fallen leaf"
            ],
            u: "1f342",
            a: "0.6"
        },
        {
            n: [
                "blow",
                "leaf",
                "wind",
                "flutter",
                "leaf fluttering in wind"
            ],
            u: "1f343",
            a: "0.6"
        },
        {
            n: [
                "nesting",
                "empty nest"
            ],
            u: "1fab9",
            a: "14"
        },
        {
            n: [
                "nesting",
                "nest with eggs"
            ],
            u: "1faba",
            a: "14"
        },
        {
            n: [
                "mushroom",
                "toadstool"
            ],
            u: "1f344",
            a: "0.6"
        }
    ],
    food_drink: [
        {
            n: [
                "fruit",
                "grape",
                "grapes"
            ],
            u: "1f347",
            a: "0.6"
        },
        {
            n: [
                "melon",
                "fruit"
            ],
            u: "1f348",
            a: "0.6"
        },
        {
            n: [
                "fruit",
                "watermelon"
            ],
            u: "1f349",
            a: "0.6"
        },
        {
            n: [
                "fruit",
                "orange",
                "tangerine"
            ],
            u: "1f34a",
            a: "0.6"
        },
        {
            n: [
                "lemon",
                "fruit",
                "citrus"
            ],
            u: "1f34b",
            a: "1"
        },
        {
            n: [
                "lime",
                "fruit",
                "citrus",
                "tropical"
            ],
            u: "1f34b-200d-1f7e9",
            a: "15.1"
        },
        {
            n: [
                "fruit",
                "banana"
            ],
            u: "1f34c",
            a: "0.6"
        },
        {
            n: [
                "fruit",
                "pineapple"
            ],
            u: "1f34d",
            a: "0.6"
        },
        {
            n: [
                "mango",
                "fruit",
                "tropical"
            ],
            u: "1f96d",
            a: "11"
        },
        {
            n: [
                "red",
                "apple",
                "fruit",
                "red apple"
            ],
            u: "1f34e",
            a: "0.6"
        },
        {
            n: [
                "apple",
                "fruit",
                "green",
                "green apple"
            ],
            u: "1f34f",
            a: "0.6"
        },
        {
            n: [
                "pear",
                "fruit"
            ],
            u: "1f350",
            a: "1"
        },
        {
            n: [
                "peach",
                "fruit"
            ],
            u: "1f351",
            a: "0.6"
        },
        {
            n: [
                "red",
                "fruit",
                "cherry",
                "berries",
                "cherries"
            ],
            u: "1f352",
            a: "0.6"
        },
        {
            n: [
                "berry",
                "fruit",
                "strawberry"
            ],
            u: "1f353",
            a: "0.6"
        },
        {
            n: [
                "blue",
                "berry",
                "bilberry",
                "blueberry",
                "blueberries"
            ],
            u: "1fad0",
            a: "13"
        },
        {
            n: [
                "food",
                "kiwi",
                "fruit",
                "kiwi fruit"
            ],
            u: "1f95d",
            a: "3"
        },
        {
            n: [
                "fruit",
                "tomato",
                "vegetable"
            ],
            u: "1f345",
            a: "0.6"
        },
        {
            n: [
                "food",
                "olive"
            ],
            u: "1fad2",
            a: "13"
        },
        {
            n: [
                "palm",
                "coconut",
                "pi\xf1a colada"
            ],
            u: "1f965",
            a: "5"
        },
        {
            n: [
                "food",
                "fruit",
                "avocado"
            ],
            u: "1f951",
            a: "3"
        },
        {
            n: [
                "eggplant",
                "aubergine",
                "vegetable"
            ],
            u: "1f346",
            a: "0.6"
        },
        {
            n: [
                "food",
                "potato",
                "vegetable"
            ],
            u: "1f954",
            a: "3"
        },
        {
            n: [
                "food",
                "carrot",
                "vegetable"
            ],
            u: "1f955",
            a: "3"
        },
        {
            n: [
                "ear",
                "corn",
                "maze",
                "maize",
                "ear of corn"
            ],
            u: "1f33d",
            a: "0.6"
        },
        {
            n: [
                "hot",
                "pepper",
                "hot pepper"
            ],
            u: "1f336-fe0f",
            a: "0.7"
        },
        {
            n: [
                "pepper",
                "capsicum",
                "vegetable",
                "bell pepper"
            ],
            u: "1fad1",
            a: "13"
        },
        {
            n: [
                "food",
                "pickle",
                "cucumber",
                "vegetable"
            ],
            u: "1f952",
            a: "3"
        },
        {
            n: [
                "kale",
                "cabbage",
                "lettuce",
                "bok choy",
                "leafy green"
            ],
            u: "1f96c",
            a: "11"
        },
        {
            n: [
                "broccoli",
                "wild cabbage"
            ],
            u: "1f966",
            a: "5"
        },
        {
            n: [
                "garlic",
                "flavoring"
            ],
            u: "1f9c4",
            a: "12"
        },
        {
            n: [
                "onion",
                "flavoring"
            ],
            u: "1f9c5",
            a: "12"
        },
        {
            n: [
                "nut",
                "food",
                "peanut",
                "peanuts",
                "vegetable"
            ],
            u: "1f95c",
            a: "3"
        },
        {
            n: [
                "food",
                "beans",
                "kidney",
                "legume"
            ],
            u: "1fad8",
            a: "14"
        },
        {
            n: [
                "plant",
                "chestnut"
            ],
            u: "1f330",
            a: "0.6"
        },
        {
            n: [
                "beer",
                "root",
                "spice",
                "ginger root"
            ],
            u: "1fada",
            a: "15"
        },
        {
            n: [
                "pea",
                "pod",
                "beans",
                "legume",
                "pea pod",
                "edamame",
                "vegetable"
            ],
            u: "1fadb",
            a: "15"
        },
        {
            n: [
                "food",
                "fungus",
                "nature",
                "vegetable",
                "brown mushroom"
            ],
            u: "1f344-200d-1f7eb",
            a: "15.1"
        },
        {
            n: [
                "loaf",
                "bread"
            ],
            u: "1f35e",
            a: "0.6"
        },
        {
            n: [
                "food",
                "roll",
                "bread",
                "french",
                "croissant",
                "breakfast"
            ],
            u: "1f950",
            a: "3"
        },
        {
            n: [
                "food",
                "bread",
                "french",
                "baguette",
                "baguette bread"
            ],
            u: "1f956",
            a: "3"
        },
        {
            n: [
                "naan",
                "pita",
                "arepa",
                "lavash",
                "flatbread"
            ],
            u: "1fad3",
            a: "13"
        },
        {
            n: [
                "pretzel",
                "twisted"
            ],
            u: "1f968",
            a: "5"
        },
        {
            n: [
                "bagel",
                "bakery",
                "schmear",
                "breakfast"
            ],
            u: "1f96f",
            a: "11"
        },
        {
            n: [
                "food",
                "cr\xeape",
                "hotcake",
                "pancake",
                "pancakes",
                "breakfast"
            ],
            u: "1f95e",
            a: "3"
        },
        {
            n: [
                "iron",
                "waffle",
                "breakfast",
                "indecisive"
            ],
            u: "1f9c7",
            a: "12"
        },
        {
            n: [
                "cheese",
                "cheese wedge"
            ],
            u: "1f9c0",
            a: "1"
        },
        {
            n: [
                "bone",
                "meat",
                "meat on bone"
            ],
            u: "1f356",
            a: "0.6"
        },
        {
            n: [
                "leg",
                "bone",
                "chicken",
                "poultry",
                "drumstick",
                "poultry leg"
            ],
            u: "1f357",
            a: "0.6"
        },
        {
            n: [
                "chop",
                "steak",
                "lambchop",
                "porkchop",
                "cut of meat"
            ],
            u: "1f969",
            a: "5"
        },
        {
            n: [
                "food",
                "meat",
                "bacon",
                "breakfast"
            ],
            u: "1f953",
            a: "3"
        },
        {
            n: [
                "burger",
                "hamburger"
            ],
            u: "1f354",
            a: "0.6"
        },
        {
            n: [
                "fries",
                "french",
                "french fries"
            ],
            u: "1f35f",
            a: "0.6"
        },
        {
            n: [
                "pizza",
                "slice",
                "cheese"
            ],
            u: "1f355",
            a: "0.6"
        },
        {
            n: [
                "hotdog",
                "hot dog",
                "sausage",
                "frankfurter"
            ],
            u: "1f32d",
            a: "1"
        },
        {
            n: [
                "bread",
                "sandwich"
            ],
            u: "1f96a",
            a: "5"
        },
        {
            n: [
                "taco",
                "mexican"
            ],
            u: "1f32e",
            a: "1"
        },
        {
            n: [
                "wrap",
                "burrito",
                "mexican"
            ],
            u: "1f32f",
            a: "1"
        },
        {
            n: [
                "tamale",
                "mexican",
                "wrapped"
            ],
            u: "1fad4",
            a: "13"
        },
        {
            n: [
                "food",
                "gyro",
                "kebab",
                "falafel",
                "stuffed",
                "flatbread",
                "stuffed flatbread"
            ],
            u: "1f959",
            a: "3"
        },
        {
            n: [
                "falafel",
                "chickpea",
                "meatball"
            ],
            u: "1f9c6",
            a: "12"
        },
        {
            n: [
                "egg",
                "food",
                "breakfast"
            ],
            u: "1f95a",
            a: "3"
        },
        {
            n: [
                "egg",
                "pan",
                "frying",
                "cooking",
                "breakfast"
            ],
            u: "1f373",
            a: "0.6"
        },
        {
            n: [
                "pan",
                "food",
                "paella",
                "shallow",
                "casserole",
                "shallow pan of food"
            ],
            u: "1f958",
            a: "3"
        },
        {
            n: [
                "pot",
                "stew",
                "pot of food"
            ],
            u: "1f372",
            a: "0.6"
        },
        {
            n: [
                "pot",
                "swiss",
                "fondue",
                "cheese",
                "melted",
                "chocolate"
            ],
            u: "1fad5",
            a: "13"
        },
        {
            n: [
                "cereal",
                "congee",
                "breakfast",
                "bowl with spoon"
            ],
            u: "1f963",
            a: "5"
        },
        {
            n: [
                "food",
                "green",
                "salad",
                "green salad"
            ],
            u: "1f957",
            a: "3"
        },
        {
            n: [
                "popcorn"
            ],
            u: "1f37f",
            a: "1"
        },
        {
            n: [
                "dairy",
                "butter"
            ],
            u: "1f9c8",
            a: "12"
        },
        {
            n: [
                "salt",
                "shaker",
                "condiment"
            ],
            u: "1f9c2",
            a: "11"
        },
        {
            n: [
                "can",
                "canned food"
            ],
            u: "1f96b",
            a: "5"
        },
        {
            n: [
                "box",
                "bento",
                "bento box"
            ],
            u: "1f371",
            a: "0.6"
        },
        {
            n: [
                "rice",
                "cracker",
                "rice cracker"
            ],
            u: "1f358",
            a: "0.6"
        },
        {
            n: [
                "ball",
                "rice",
                "japanese",
                "rice ball"
            ],
            u: "1f359",
            a: "0.6"
        },
        {
            n: [
                "rice",
                "cooked",
                "cooked rice"
            ],
            u: "1f35a",
            a: "0.6"
        },
        {
            n: [
                "rice",
                "curry",
                "curry rice"
            ],
            u: "1f35b",
            a: "0.6"
        },
        {
            n: [
                "bowl",
                "ramen",
                "noodle",
                "steaming",
                "steaming bowl"
            ],
            u: "1f35c",
            a: "0.6"
        },
        {
            n: [
                "pasta",
                "spaghetti"
            ],
            u: "1f35d",
            a: "0.6"
        },
        {
            n: [
                "sweet",
                "potato",
                "roasted",
                "roasted sweet potato"
            ],
            u: "1f360",
            a: "0.6"
        },
        {
            n: [
                "oden",
                "kebab",
                "stick",
                "skewer",
                "seafood"
            ],
            u: "1f362",
            a: "0.6"
        },
        {
            n: [
                "sushi"
            ],
            u: "1f363",
            a: "0.6"
        },
        {
            n: [
                "fried",
                "prawn",
                "shrimp",
                "tempura",
                "fried shrimp"
            ],
            u: "1f364",
            a: "0.6"
        },
        {
            n: [
                "cake",
                "fish",
                "swirl",
                "pastry",
                "fish cake with swirl"
            ],
            u: "1f365",
            a: "0.6"
        },
        {
            n: [
                "autumn",
                "yu\xe8b\u01D0ng",
                "festival",
                "moon cake"
            ],
            u: "1f96e",
            a: "11"
        },
        {
            n: [
                "dango",
                "stick",
                "sweet",
                "skewer",
                "dessert",
                "japanese"
            ],
            u: "1f361",
            a: "0.6"
        },
        {
            n: [
                "gy\u014Dza",
                "jiaozi",
                "pierogi",
                "dumpling",
                "empanada",
                "potsticker"
            ],
            u: "1f95f",
            a: "5"
        },
        {
            n: [
                "prophecy",
                "fortune cookie"
            ],
            u: "1f960",
            a: "5"
        },
        {
            n: [
                "takeout box",
                "oyster pail"
            ],
            u: "1f961",
            a: "5"
        },
        {
            n: [
                "crab",
                "cancer",
                "zodiac"
            ],
            u: "1f980",
            a: "1"
        },
        {
            n: [
                "claws",
                "bisque",
                "lobster",
                "seafood"
            ],
            u: "1f99e",
            a: "11"
        },
        {
            n: [
                "food",
                "small",
                "shrimp",
                "shellfish"
            ],
            u: "1f990",
            a: "3"
        },
        {
            n: [
                "food",
                "squid",
                "molusc"
            ],
            u: "1f991",
            a: "3"
        },
        {
            n: [
                "pearl",
                "oyster",
                "diving"
            ],
            u: "1f9aa",
            a: "12"
        },
        {
            n: [
                "ice",
                "soft",
                "cream",
                "sweet",
                "dessert",
                "icecream",
                "soft ice cream"
            ],
            u: "1f366",
            a: "0.6"
        },
        {
            n: [
                "ice",
                "sweet",
                "shaved",
                "dessert",
                "shaved ice"
            ],
            u: "1f367",
            a: "0.6"
        },
        {
            n: [
                "ice",
                "cream",
                "sweet",
                "dessert",
                "ice cream"
            ],
            u: "1f368",
            a: "0.6"
        },
        {
            n: [
                "donut",
                "sweet",
                "dessert",
                "doughnut",
                "breakfast"
            ],
            u: "1f369",
            a: "0.6"
        },
        {
            n: [
                "sweet",
                "cookie",
                "dessert"
            ],
            u: "1f36a",
            a: "0.6"
        },
        {
            n: [
                "cake",
                "sweet",
                "pastry",
                "dessert",
                "birthday",
                "celebration",
                "birthday cake"
            ],
            u: "1f382",
            a: "0.6"
        },
        {
            n: [
                "cake",
                "slice",
                "sweet",
                "pastry",
                "dessert",
                "shortcake"
            ],
            u: "1f370",
            a: "0.6"
        },
        {
            n: [
                "sweet",
                "bakery",
                "cupcake"
            ],
            u: "1f9c1",
            a: "11"
        },
        {
            n: [
                "pie",
                "pastry",
                "filling"
            ],
            u: "1f967",
            a: "5"
        },
        {
            n: [
                "bar",
                "sweet",
                "dessert",
                "chocolate",
                "chocolate bar"
            ],
            u: "1f36b",
            a: "0.6"
        },
        {
            n: [
                "candy",
                "sweet",
                "dessert"
            ],
            u: "1f36c",
            a: "0.6"
        },
        {
            n: [
                "candy",
                "sweet",
                "dessert",
                "lollipop"
            ],
            u: "1f36d",
            a: "0.6"
        },
        {
            n: [
                "sweet",
                "custard",
                "dessert",
                "pudding"
            ],
            u: "1f36e",
            a: "0.6"
        },
        {
            n: [
                "pot",
                "honey",
                "sweet",
                "honeypot",
                "honey pot"
            ],
            u: "1f36f",
            a: "0.6"
        },
        {
            n: [
                "baby",
                "milk",
                "drink",
                "bottle",
                "baby bottle"
            ],
            u: "1f37c",
            a: "1"
        },
        {
            n: [
                "milk",
                "drink",
                "glass",
                "glass of milk"
            ],
            u: "1f95b",
            a: "3"
        },
        {
            n: [
                "hot",
                "tea",
                "drink",
                "coffee",
                "beverage",
                "steaming",
                "hot beverage"
            ],
            u: "2615",
            a: "0.6"
        },
        {
            n: [
                "pot",
                "tea",
                "drink",
                "teapot"
            ],
            u: "1fad6",
            a: "13"
        },
        {
            n: [
                "cup",
                "tea",
                "drink",
                "teacup",
                "beverage",
                "teacup without handle"
            ],
            u: "1f375",
            a: "0.6"
        },
        {
            n: [
                "bar",
                "cup",
                "sake",
                "drink",
                "bottle",
                "beverage"
            ],
            u: "1f376",
            a: "0.6"
        },
        {
            n: [
                "bar",
                "cork",
                "drink",
                "bottle",
                "popping",
                "bottle with popping cork"
            ],
            u: "1f37e",
            a: "1"
        },
        {
            n: [
                "bar",
                "wine",
                "drink",
                "glass",
                "beverage",
                "wine glass"
            ],
            u: "1f377",
            a: "0.6"
        },
        {
            n: [
                "bar",
                "drink",
                "glass",
                "cocktail",
                "cocktail glass"
            ],
            u: "1f378",
            a: "0.6"
        },
        {
            n: [
                "bar",
                "drink",
                "tropical",
                "tropical drink"
            ],
            u: "1f379",
            a: "0.6"
        },
        {
            n: [
                "bar",
                "mug",
                "beer",
                "drink",
                "beer mug"
            ],
            u: "1f37a",
            a: "0.6"
        },
        {
            n: [
                "bar",
                "mug",
                "beer",
                "clink",
                "drink",
                "clinking beer mugs"
            ],
            u: "1f37b",
            a: "0.6"
        },
        {
            n: [
                "clink",
                "drink",
                "glass",
                "celebrate",
                "clinking glasses"
            ],
            u: "1f942",
            a: "3"
        },
        {
            n: [
                "shot",
                "glass",
                "liquor",
                "whisky",
                "tumbler",
                "tumbler glass"
            ],
            u: "1f943",
            a: "3"
        },
        {
            n: [
                "drink",
                "empty",
                "glass",
                "spill",
                "pouring liquid"
            ],
            u: "1fad7",
            a: "14"
        },
        {
            n: [
                "soda",
                "juice",
                "cup with straw"
            ],
            u: "1f964",
            a: "5"
        },
        {
            n: [
                "tea",
                "milk",
                "pearl",
                "bubble",
                "bubble tea"
            ],
            u: "1f9cb",
            a: "13"
        },
        {
            n: [
                "box",
                "juice",
                "straw",
                "sweet",
                "beverage",
                "beverage box"
            ],
            u: "1f9c3",
            a: "12"
        },
        {
            n: [
                "mate",
                "drink"
            ],
            u: "1f9c9",
            a: "12"
        },
        {
            n: [
                "ice",
                "cold",
                "iceberg",
                "ice cube"
            ],
            u: "1f9ca",
            a: "12"
        },
        {
            n: [
                "hashi",
                "chopsticks"
            ],
            u: "1f962",
            a: "5"
        },
        {
            n: [
                "fork",
                "knife",
                "plate",
                "cooking",
                "fork and knife with plate"
            ],
            u: "1f37d-fe0f",
            a: "0.7"
        },
        {
            n: [
                "fork",
                "knife",
                "cooking",
                "cutlery",
                "fork and knife"
            ],
            u: "1f374",
            a: "0.6"
        },
        {
            n: [
                "spoon",
                "tableware"
            ],
            u: "1f944",
            a: "3"
        },
        {
            n: [
                "tool",
                "hocho",
                "knife",
                "weapon",
                "cooking",
                "kitchen knife"
            ],
            u: "1f52a",
            a: "0.6"
        },
        {
            n: [
                "jar",
                "empty",
                "sauce",
                "store",
                "condiment",
                "container"
            ],
            u: "1fad9",
            a: "14"
        },
        {
            n: [
                "jug",
                "drink",
                "zodiac",
                "amphora",
                "cooking",
                "aquarius"
            ],
            u: "1f3fa",
            a: "1"
        }
    ],
    travel_places: [
        {
            n: [
                "earth",
                "globe",
                "world",
                "africa",
                "europe",
                "globe showing Europe Africa",
                "globe showing europe africa"
            ],
            u: "1f30d",
            a: "0.7"
        },
        {
            n: [
                "earth",
                "globe",
                "world",
                "americas",
                "globe showing Americas",
                "globe showing americas"
            ],
            u: "1f30e",
            a: "0.7"
        },
        {
            n: [
                "asia",
                "earth",
                "globe",
                "world",
                "australia",
                "globe showing Asia Australia",
                "globe showing asia australia"
            ],
            u: "1f30f",
            a: "0.6"
        },
        {
            n: [
                "earth",
                "globe",
                "world",
                "meridians",
                "globe with meridians"
            ],
            u: "1f310",
            a: "1"
        },
        {
            n: [
                "map",
                "world",
                "world map"
            ],
            u: "1f5fa-fe0f",
            a: "0.7"
        },
        {
            n: [
                "map",
                "japan",
                "map of Japan",
                "map of japan"
            ],
            u: "1f5fe",
            a: "0.6"
        },
        {
            n: [
                "compass",
                "magnetic",
                "navigation",
                "orienteering"
            ],
            u: "1f9ed",
            a: "11"
        },
        {
            n: [
                "cold",
                "snow",
                "mountain",
                "snow capped mountain"
            ],
            u: "1f3d4-fe0f",
            a: "0.7"
        },
        {
            n: [
                "mountain"
            ],
            u: "26f0-fe0f",
            a: "0.7"
        },
        {
            n: [
                "volcano",
                "eruption",
                "mountain"
            ],
            u: "1f30b",
            a: "0.6"
        },
        {
            n: [
                "fuji",
                "mountain",
                "mount fuji"
            ],
            u: "1f5fb",
            a: "0.6"
        },
        {
            n: [
                "camping"
            ],
            u: "1f3d5-fe0f",
            a: "0.7"
        },
        {
            n: [
                "beach",
                "umbrella",
                "beach with umbrella"
            ],
            u: "1f3d6-fe0f",
            a: "0.7"
        },
        {
            n: [
                "desert"
            ],
            u: "1f3dc-fe0f",
            a: "0.7"
        },
        {
            n: [
                "desert",
                "island",
                "desert island"
            ],
            u: "1f3dd-fe0f",
            a: "0.7"
        },
        {
            n: [
                "park",
                "national park"
            ],
            u: "1f3de-fe0f",
            a: "0.7"
        },
        {
            n: [
                "stadium"
            ],
            u: "1f3df-fe0f",
            a: "0.7"
        },
        {
            n: [
                "classical",
                "classical building"
            ],
            u: "1f3db-fe0f",
            a: "0.7"
        },
        {
            n: [
                "construction",
                "building construction"
            ],
            u: "1f3d7-fe0f",
            a: "0.7"
        },
        {
            n: [
                "clay",
                "wall",
                "brick",
                "bricks",
                "mortar"
            ],
            u: "1f9f1",
            a: "11"
        },
        {
            n: [
                "rock",
                "heavy",
                "solid",
                "stone",
                "boulder"
            ],
            u: "1faa8",
            a: "13"
        },
        {
            n: [
                "log",
                "wood",
                "lumber",
                "timber"
            ],
            u: "1fab5",
            a: "13"
        },
        {
            n: [
                "hut",
                "yurt",
                "house",
                "roundhouse"
            ],
            u: "1f6d6",
            a: "13"
        },
        {
            n: [
                "houses"
            ],
            u: "1f3d8-fe0f",
            a: "0.7"
        },
        {
            n: [
                "house",
                "derelict",
                "derelict house"
            ],
            u: "1f3da-fe0f",
            a: "0.7"
        },
        {
            n: [
                "home",
                "house"
            ],
            u: "1f3e0",
            a: "0.6"
        },
        {
            n: [
                "home",
                "house",
                "garden",
                "house with garden"
            ],
            u: "1f3e1",
            a: "0.6"
        },
        {
            n: [
                "building",
                "office building"
            ],
            u: "1f3e2",
            a: "0.6"
        },
        {
            n: [
                "post",
                "japanese",
                "Japanese post office",
                "japanese post office"
            ],
            u: "1f3e3",
            a: "0.6"
        },
        {
            n: [
                "post",
                "european",
                "post office"
            ],
            u: "1f3e4",
            a: "1"
        },
        {
            n: [
                "doctor",
                "hospital",
                "medicine"
            ],
            u: "1f3e5",
            a: "0.6"
        },
        {
            n: [
                "bank",
                "building"
            ],
            u: "1f3e6",
            a: "0.6"
        },
        {
            n: [
                "hotel",
                "building"
            ],
            u: "1f3e8",
            a: "0.6"
        },
        {
            n: [
                "love",
                "hotel",
                "love hotel"
            ],
            u: "1f3e9",
            a: "0.6"
        },
        {
            n: [
                "store",
                "convenience",
                "convenience store"
            ],
            u: "1f3ea",
            a: "0.6"
        },
        {
            n: [
                "school",
                "building"
            ],
            u: "1f3eb",
            a: "0.6"
        },
        {
            n: [
                "store",
                "department",
                "department store"
            ],
            u: "1f3ec",
            a: "0.6"
        },
        {
            n: [
                "factory",
                "building"
            ],
            u: "1f3ed",
            a: "0.6"
        },
        {
            n: [
                "castle",
                "japanese",
                "Japanese castle"
            ],
            u: "1f3ef",
            a: "0.6"
        },
        {
            n: [
                "castle",
                "european"
            ],
            u: "1f3f0",
            a: "0.6"
        },
        {
            n: [
                "chapel",
                "wedding",
                "romance"
            ],
            u: "1f492",
            a: "0.6"
        },
        {
            n: [
                "tokyo",
                "tower",
                "Tokyo tower"
            ],
            u: "1f5fc",
            a: "0.6"
        },
        {
            n: [
                "statue",
                "liberty",
                "Statue of Liberty",
                "statue of liberty"
            ],
            u: "1f5fd",
            a: "0.6"
        },
        {
            n: [
                "cross",
                "church",
                "religion",
                "christian"
            ],
            u: "26ea",
            a: "0.6"
        },
        {
            n: [
                "islam",
                "mosque",
                "muslim",
                "religion"
            ],
            u: "1f54c",
            a: "1"
        },
        {
            n: [
                "hindu",
                "temple",
                "hindu temple"
            ],
            u: "1f6d5",
            a: "12"
        },
        {
            n: [
                "jew",
                "jewish",
                "temple",
                "religion",
                "synagogue"
            ],
            u: "1f54d",
            a: "1"
        },
        {
            n: [
                "shinto",
                "shrine",
                "religion",
                "shinto shrine"
            ],
            u: "26e9-fe0f",
            a: "0.7"
        },
        {
            n: [
                "kaaba",
                "islam",
                "muslim",
                "religion"
            ],
            u: "1f54b",
            a: "1"
        },
        {
            n: [
                "fountain"
            ],
            u: "26f2",
            a: "0.6"
        },
        {
            n: [
                "tent",
                "camping"
            ],
            u: "26fa",
            a: "0.6"
        },
        {
            n: [
                "fog",
                "foggy"
            ],
            u: "1f301",
            a: "0.6"
        },
        {
            n: [
                "star",
                "night",
                "night with stars"
            ],
            u: "1f303",
            a: "0.6"
        },
        {
            n: [
                "city",
                "cityscape"
            ],
            u: "1f3d9-fe0f",
            a: "0.7"
        },
        {
            n: [
                "sun",
                "morning",
                "sunrise",
                "mountain",
                "sunrise over mountains"
            ],
            u: "1f304",
            a: "0.6"
        },
        {
            n: [
                "sun",
                "sunrise",
                "morning"
            ],
            u: "1f305",
            a: "0.6"
        },
        {
            n: [
                "city",
                "dusk",
                "sunset",
                "evening",
                "landscape",
                "cityscape at dusk"
            ],
            u: "1f306",
            a: "0.6"
        },
        {
            n: [
                "sun",
                "dusk",
                "sunset"
            ],
            u: "1f307",
            a: "0.6"
        },
        {
            n: [
                "night",
                "bridge",
                "bridge at night"
            ],
            u: "1f309",
            a: "0.6"
        },
        {
            n: [
                "hot",
                "springs",
                "steaming",
                "hotsprings",
                "hot springs"
            ],
            u: "2668-fe0f",
            a: "0.6"
        },
        {
            n: [
                "horse",
                "carousel",
                "carousel horse"
            ],
            u: "1f3a0",
            a: "0.6"
        },
        {
            n: [
                "play",
                "theme park",
                "amusement park",
                "playground slide"
            ],
            u: "1f6dd",
            a: "14"
        },
        {
            n: [
                "wheel",
                "ferris",
                "theme park",
                "ferris wheel",
                "amusement park"
            ],
            u: "1f3a1",
            a: "0.6"
        },
        {
            n: [
                "roller",
                "coaster",
                "theme park",
                "roller coaster",
                "amusement park"
            ],
            u: "1f3a2",
            a: "0.6"
        },
        {
            n: [
                "pole",
                "barber",
                "haircut",
                "barber pole"
            ],
            u: "1f488",
            a: "0.6"
        },
        {
            n: [
                "tent",
                "circus",
                "circus tent"
            ],
            u: "1f3aa",
            a: "0.6"
        },
        {
            n: [
                "steam",
                "train",
                "engine",
                "railway",
                "locomotive"
            ],
            u: "1f682",
            a: "1"
        },
        {
            n: [
                "car",
                "tram",
                "train",
                "railway",
                "electric",
                "trolleybus",
                "railway car"
            ],
            u: "1f683",
            a: "0.6"
        },
        {
            n: [
                "speed",
                "train",
                "railway",
                "shinkansen",
                "high speed train"
            ],
            u: "1f684",
            a: "0.6"
        },
        {
            n: [
                "speed",
                "train",
                "bullet",
                "railway",
                "shinkansen",
                "bullet train"
            ],
            u: "1f685",
            a: "0.6"
        },
        {
            n: [
                "train",
                "railway"
            ],
            u: "1f686",
            a: "1"
        },
        {
            n: [
                "metro",
                "subway"
            ],
            u: "1f687",
            a: "0.6"
        },
        {
            n: [
                "railway",
                "light rail"
            ],
            u: "1f688",
            a: "1"
        },
        {
            n: [
                "train",
                "station",
                "railway"
            ],
            u: "1f689",
            a: "0.6"
        },
        {
            n: [
                "tram",
                "trolleybus"
            ],
            u: "1f68a",
            a: "1"
        },
        {
            n: [
                "vehicle",
                "monorail"
            ],
            u: "1f69d",
            a: "1"
        },
        {
            n: [
                "car",
                "railway",
                "mountain",
                "mountain railway"
            ],
            u: "1f69e",
            a: "1"
        },
        {
            n: [
                "car",
                "tram",
                "tram car",
                "trolleybus"
            ],
            u: "1f68b",
            a: "1"
        },
        {
            n: [
                "bus",
                "vehicle"
            ],
            u: "1f68c",
            a: "0.6"
        },
        {
            n: [
                "bus",
                "oncoming",
                "oncoming bus"
            ],
            u: "1f68d",
            a: "0.7"
        },
        {
            n: [
                "bus",
                "tram",
                "trolley",
                "trolleybus"
            ],
            u: "1f68e",
            a: "1"
        },
        {
            n: [
                "bus",
                "minibus"
            ],
            u: "1f690",
            a: "1"
        },
        {
            n: [
                "vehicle",
                "ambulance"
            ],
            u: "1f691",
            a: "0.6"
        },
        {
            n: [
                "fire",
                "truck",
                "engine",
                "fire engine"
            ],
            u: "1f692",
            a: "0.6"
        },
        {
            n: [
                "car",
                "patrol",
                "police",
                "police car"
            ],
            u: "1f693",
            a: "0.6"
        },
        {
            n: [
                "car",
                "police",
                "oncoming",
                "oncoming police car"
            ],
            u: "1f694",
            a: "0.7"
        },
        {
            n: [
                "taxi",
                "vehicle"
            ],
            u: "1f695",
            a: "0.6"
        },
        {
            n: [
                "taxi",
                "oncoming",
                "oncoming taxi"
            ],
            u: "1f696",
            a: "1"
        },
        {
            n: [
                "car",
                "automobile"
            ],
            u: "1f697",
            a: "0.6"
        },
        {
            n: [
                "car",
                "oncoming",
                "automobile",
                "oncoming automobile"
            ],
            u: "1f698",
            a: "0.7"
        },
        {
            n: [
                "recreational",
                "sport utility",
                "sport utility vehicle"
            ],
            u: "1f699",
            a: "0.6"
        },
        {
            n: [
                "truck",
                "pickup",
                "pick up",
                "pickup truck"
            ],
            u: "1f6fb",
            a: "13"
        },
        {
            n: [
                "truck",
                "delivery",
                "delivery truck"
            ],
            u: "1f69a",
            a: "0.6"
        },
        {
            n: [
                "semi",
                "lorry",
                "truck",
                "articulated lorry"
            ],
            u: "1f69b",
            a: "1"
        },
        {
            n: [
                "tractor",
                "vehicle"
            ],
            u: "1f69c",
            a: "1"
        },
        {
            n: [
                "car",
                "racing",
                "racing car"
            ],
            u: "1f3ce-fe0f",
            a: "0.7"
        },
        {
            n: [
                "racing",
                "motorcycle"
            ],
            u: "1f3cd-fe0f",
            a: "0.7"
        },
        {
            n: [
                "motor",
                "scooter",
                "motor scooter"
            ],
            u: "1f6f5",
            a: "3"
        },
        {
            n: [
                "accessibility",
                "manual wheelchair"
            ],
            u: "1f9bd",
            a: "12"
        },
        {
            n: [
                "accessibility",
                "motorized wheelchair"
            ],
            u: "1f9bc",
            a: "12"
        },
        {
            n: [
                "tuk tuk",
                "auto rickshaw"
            ],
            u: "1f6fa",
            a: "12"
        },
        {
            n: [
                "bike",
                "bicycle"
            ],
            u: "1f6b2",
            a: "0.6"
        },
        {
            n: [
                "kick",
                "scooter",
                "kick scooter"
            ],
            u: "1f6f4",
            a: "3"
        },
        {
            n: [
                "board",
                "skateboard"
            ],
            u: "1f6f9",
            a: "11"
        },
        {
            n: [
                "skate",
                "roller",
                "roller skate"
            ],
            u: "1f6fc",
            a: "13"
        },
        {
            n: [
                "bus",
                "stop",
                "bus stop"
            ],
            u: "1f68f",
            a: "0.6"
        },
        {
            n: [
                "road",
                "highway",
                "motorway"
            ],
            u: "1f6e3-fe0f",
            a: "0.7"
        },
        {
            n: [
                "train",
                "railway",
                "railway track"
            ],
            u: "1f6e4-fe0f",
            a: "0.7"
        },
        {
            n: [
                "oil",
                "drum",
                "oil drum"
            ],
            u: "1f6e2-fe0f",
            a: "0.7"
        },
        {
            n: [
                "gas",
                "fuel",
                "pump",
                "diesel",
                "station",
                "fuelpump",
                "fuel pump"
            ],
            u: "26fd",
            a: "0.6"
        },
        {
            n: [
                "tire",
                "turn",
                "wheel",
                "circle"
            ],
            u: "1f6de",
            a: "14"
        },
        {
            n: [
                "car",
                "light",
                "beacon",
                "police",
                "revolving",
                "police car light"
            ],
            u: "1f6a8",
            a: "0.6"
        },
        {
            n: [
                "light",
                "signal",
                "traffic",
                "horizontal traffic light"
            ],
            u: "1f6a5",
            a: "0.6"
        },
        {
            n: [
                "light",
                "signal",
                "traffic",
                "vertical traffic light"
            ],
            u: "1f6a6",
            a: "1"
        },
        {
            n: [
                "sign",
                "stop",
                "stop sign",
                "octagonal"
            ],
            u: "1f6d1",
            a: "3"
        },
        {
            n: [
                "barrier",
                "construction"
            ],
            u: "1f6a7",
            a: "0.6"
        },
        {
            n: [
                "ship",
                "tool",
                "anchor"
            ],
            u: "2693",
            a: "0.6"
        },
        {
            n: [
                "float",
                "rescue",
                "safety",
                "ring buoy",
                "life saver",
                "life preserver"
            ],
            u: "1f6df",
            a: "14"
        },
        {
            n: [
                "sea",
                "boat",
                "yacht",
                "resort",
                "sailboat"
            ],
            u: "26f5",
            a: "0.6"
        },
        {
            n: [
                "boat",
                "canoe"
            ],
            u: "1f6f6",
            a: "3"
        },
        {
            n: [
                "boat",
                "speedboat"
            ],
            u: "1f6a4",
            a: "0.6"
        },
        {
            n: [
                "ship",
                "passenger",
                "passenger ship"
            ],
            u: "1f6f3-fe0f",
            a: "0.7"
        },
        {
            n: [
                "boat",
                "ferry",
                "passenger"
            ],
            u: "26f4-fe0f",
            a: "0.7"
        },
        {
            n: [
                "boat",
                "motorboat",
                "motor boat"
            ],
            u: "1f6e5-fe0f",
            a: "0.7"
        },
        {
            n: [
                "ship",
                "boat",
                "passenger"
            ],
            u: "1f6a2",
            a: "0.6"
        },
        {
            n: [
                "airplane",
                "aeroplane"
            ],
            u: "2708-fe0f",
            a: "0.6"
        },
        {
            n: [
                "airplane",
                "aeroplane",
                "small airplane"
            ],
            u: "1f6e9-fe0f",
            a: "0.7"
        },
        {
            n: [
                "airplane",
                "check in",
                "aeroplane",
                "departure",
                "departures",
                "airplane departure"
            ],
            u: "1f6eb",
            a: "1"
        },
        {
            n: [
                "landing",
                "airplane",
                "arrivals",
                "arriving",
                "aeroplane",
                "airplane arrival"
            ],
            u: "1f6ec",
            a: "1"
        },
        {
            n: [
                "skydive",
                "parasail",
                "parachute",
                "hang glide"
            ],
            u: "1fa82",
            a: "12"
        },
        {
            n: [
                "seat",
                "chair"
            ],
            u: "1f4ba",
            a: "0.6"
        },
        {
            n: [
                "vehicle",
                "helicopter"
            ],
            u: "1f681",
            a: "1"
        },
        {
            n: [
                "railway",
                "suspension",
                "suspension railway"
            ],
            u: "1f69f",
            a: "1"
        },
        {
            n: [
                "cable",
                "gondola",
                "mountain",
                "mountain cableway"
            ],
            u: "1f6a0",
            a: "1"
        },
        {
            n: [
                "car",
                "cable",
                "aerial",
                "gondola",
                "tramway",
                "aerial tramway"
            ],
            u: "1f6a1",
            a: "1"
        },
        {
            n: [
                "space",
                "satellite"
            ],
            u: "1f6f0-fe0f",
            a: "0.7"
        },
        {
            n: [
                "space",
                "rocket"
            ],
            u: "1f680",
            a: "0.6"
        },
        {
            n: [
                "ufo",
                "flying saucer"
            ],
            u: "1f6f8",
            a: "5"
        },
        {
            n: [
                "bell",
                "hotel",
                "bellhop",
                "bellhop bell"
            ],
            u: "1f6ce-fe0f",
            a: "0.7"
        },
        {
            n: [
                "travel",
                "luggage",
                "packing"
            ],
            u: "1f9f3",
            a: "11"
        },
        {
            n: [
                "sand",
                "timer",
                "hourglass done"
            ],
            u: "231b",
            a: "0.6"
        },
        {
            n: [
                "sand",
                "timer",
                "hourglass",
                "hourglass not done"
            ],
            u: "23f3",
            a: "0.6"
        },
        {
            n: [
                "watch",
                "clock"
            ],
            u: "231a",
            a: "0.6"
        },
        {
            n: [
                "alarm",
                "clock",
                "alarm clock"
            ],
            u: "23f0",
            a: "0.6"
        },
        {
            n: [
                "clock",
                "stopwatch"
            ],
            u: "23f1-fe0f",
            a: "1"
        },
        {
            n: [
                "clock",
                "timer",
                "timer clock"
            ],
            u: "23f2-fe0f",
            a: "1"
        },
        {
            n: [
                "clock",
                "mantelpiece clock"
            ],
            u: "1f570-fe0f",
            a: "0.7"
        },
        {
            n: [
                "00",
                "12",
                "12:00",
                "clock",
                "twelve",
                "o\u2019clock",
                "twelve o\u2019clock"
            ],
            u: "1f55b",
            a: "0.6"
        },
        {
            n: [
                "12",
                "12:30",
                "clock",
                "thirty",
                "twelve",
                "twelve thirty"
            ],
            u: "1f567",
            a: "0.7"
        },
        {
            n: [
                "1",
                "00",
                "one",
                "1:00",
                "clock",
                "o\u2019clock",
                "one o\u2019clock"
            ],
            u: "1f550",
            a: "0.6"
        },
        {
            n: [
                "1",
                "one",
                "1:30",
                "clock",
                "thirty",
                "one thirty"
            ],
            u: "1f55c",
            a: "0.7"
        },
        {
            n: [
                "2",
                "00",
                "two",
                "2:00",
                "clock",
                "o\u2019clock",
                "two o\u2019clock"
            ],
            u: "1f551",
            a: "0.6"
        },
        {
            n: [
                "2",
                "two",
                "2:30",
                "clock",
                "thirty",
                "two thirty"
            ],
            u: "1f55d",
            a: "0.7"
        },
        {
            n: [
                "3",
                "00",
                "3:00",
                "clock",
                "three",
                "o\u2019clock",
                "three o\u2019clock"
            ],
            u: "1f552",
            a: "0.6"
        },
        {
            n: [
                "3",
                "3:30",
                "clock",
                "three",
                "thirty",
                "three thirty"
            ],
            u: "1f55e",
            a: "0.7"
        },
        {
            n: [
                "4",
                "00",
                "4:00",
                "four",
                "clock",
                "o\u2019clock",
                "four o\u2019clock"
            ],
            u: "1f553",
            a: "0.6"
        },
        {
            n: [
                "4",
                "4:30",
                "four",
                "clock",
                "thirty",
                "four thirty"
            ],
            u: "1f55f",
            a: "0.7"
        },
        {
            n: [
                "5",
                "00",
                "5:00",
                "five",
                "clock",
                "o\u2019clock",
                "five o\u2019clock"
            ],
            u: "1f554",
            a: "0.6"
        },
        {
            n: [
                "5",
                "5:30",
                "five",
                "clock",
                "thirty",
                "five thirty"
            ],
            u: "1f560",
            a: "0.7"
        },
        {
            n: [
                "6",
                "00",
                "six",
                "6:00",
                "clock",
                "o\u2019clock",
                "six o\u2019clock"
            ],
            u: "1f555",
            a: "0.6"
        },
        {
            n: [
                "6",
                "six",
                "6:30",
                "clock",
                "thirty",
                "six thirty"
            ],
            u: "1f561",
            a: "0.7"
        },
        {
            n: [
                "7",
                "00",
                "7:00",
                "clock",
                "seven",
                "o\u2019clock",
                "seven o\u2019clock"
            ],
            u: "1f556",
            a: "0.6"
        },
        {
            n: [
                "7",
                "7:30",
                "clock",
                "seven",
                "thirty",
                "seven thirty"
            ],
            u: "1f562",
            a: "0.7"
        },
        {
            n: [
                "8",
                "00",
                "8:00",
                "clock",
                "eight",
                "o\u2019clock",
                "eight o\u2019clock"
            ],
            u: "1f557",
            a: "0.6"
        },
        {
            n: [
                "8",
                "8:30",
                "clock",
                "eight",
                "thirty",
                "eight thirty"
            ],
            u: "1f563",
            a: "0.7"
        },
        {
            n: [
                "9",
                "00",
                "9:00",
                "nine",
                "clock",
                "o\u2019clock",
                "nine o\u2019clock"
            ],
            u: "1f558",
            a: "0.6"
        },
        {
            n: [
                "9",
                "9:30",
                "nine",
                "clock",
                "thirty",
                "nine thirty"
            ],
            u: "1f564",
            a: "0.7"
        },
        {
            n: [
                "00",
                "10",
                "ten",
                "10:00",
                "clock",
                "o\u2019clock",
                "ten o\u2019clock"
            ],
            u: "1f559",
            a: "0.6"
        },
        {
            n: [
                "10",
                "ten",
                "10:30",
                "clock",
                "thirty",
                "ten thirty"
            ],
            u: "1f565",
            a: "0.7"
        },
        {
            n: [
                "00",
                "11",
                "11:00",
                "clock",
                "eleven",
                "o\u2019clock",
                "eleven o\u2019clock"
            ],
            u: "1f55a",
            a: "0.6"
        },
        {
            n: [
                "11",
                "11:30",
                "clock",
                "eleven",
                "thirty",
                "eleven thirty"
            ],
            u: "1f566",
            a: "0.7"
        },
        {
            n: [
                "dark",
                "moon",
                "new moon"
            ],
            u: "1f311",
            a: "0.6"
        },
        {
            n: [
                "moon",
                "waxing",
                "crescent",
                "waxing crescent moon"
            ],
            u: "1f312",
            a: "1"
        },
        {
            n: [
                "moon",
                "quarter",
                "first quarter moon"
            ],
            u: "1f313",
            a: "0.6"
        },
        {
            n: [
                "moon",
                "waxing",
                "gibbous",
                "waxing gibbous moon"
            ],
            u: "1f314",
            a: "0.6"
        },
        {
            n: [
                "full",
                "moon",
                "full moon"
            ],
            u: "1f315",
            a: "0.6"
        },
        {
            n: [
                "moon",
                "waning",
                "gibbous",
                "waning gibbous moon"
            ],
            u: "1f316",
            a: "1"
        },
        {
            n: [
                "moon",
                "quarter",
                "last quarter moon"
            ],
            u: "1f317",
            a: "1"
        },
        {
            n: [
                "moon",
                "waning",
                "crescent",
                "waning crescent moon"
            ],
            u: "1f318",
            a: "1"
        },
        {
            n: [
                "moon",
                "crescent",
                "crescent moon"
            ],
            u: "1f319",
            a: "0.6"
        },
        {
            n: [
                "face",
                "moon",
                "new moon face"
            ],
            u: "1f31a",
            a: "1"
        },
        {
            n: [
                "face",
                "moon",
                "quarter",
                "first quarter moon face"
            ],
            u: "1f31b",
            a: "0.6"
        },
        {
            n: [
                "face",
                "moon",
                "quarter",
                "last quarter moon face"
            ],
            u: "1f31c",
            a: "0.7"
        },
        {
            n: [
                "weather",
                "thermometer"
            ],
            u: "1f321-fe0f",
            a: "0.7"
        },
        {
            n: [
                "sun",
                "rays",
                "sunny",
                "bright"
            ],
            u: "2600-fe0f",
            a: "0.6"
        },
        {
            n: [
                "face",
                "full",
                "moon",
                "bright",
                "full moon face"
            ],
            u: "1f31d",
            a: "1"
        },
        {
            n: [
                "sun",
                "face",
                "bright",
                "sun with face"
            ],
            u: "1f31e",
            a: "1"
        },
        {
            n: [
                "saturn",
                "saturnine",
                "ringed planet"
            ],
            u: "1fa90",
            a: "12"
        },
        {
            n: [
                "star"
            ],
            u: "2b50",
            a: "0.6"
        },
        {
            n: [
                "glow",
                "star",
                "shining",
                "sparkle",
                "glittery",
                "glowing star"
            ],
            u: "1f31f",
            a: "0.6"
        },
        {
            n: [
                "star",
                "falling",
                "shooting",
                "shooting star"
            ],
            u: "1f320",
            a: "0.6"
        },
        {
            n: [
                "space",
                "milky way"
            ],
            u: "1f30c",
            a: "0.6"
        },
        {
            n: [
                "cloud",
                "weather"
            ],
            u: "2601-fe0f",
            a: "0.6"
        },
        {
            n: [
                "sun",
                "cloud",
                "sun behind cloud"
            ],
            u: "26c5",
            a: "0.6"
        },
        {
            n: [
                "rain",
                "cloud",
                "thunder",
                "cloud with lightning and rain"
            ],
            u: "26c8-fe0f",
            a: "0.7"
        },
        {
            n: [
                "sun",
                "cloud",
                "sun behind small cloud"
            ],
            u: "1f324-fe0f",
            a: "0.7"
        },
        {
            n: [
                "sun",
                "cloud",
                "sun behind large cloud"
            ],
            u: "1f325-fe0f",
            a: "0.7"
        },
        {
            n: [
                "sun",
                "rain",
                "cloud",
                "sun behind rain cloud"
            ],
            u: "1f326-fe0f",
            a: "0.7"
        },
        {
            n: [
                "rain",
                "cloud",
                "cloud with rain"
            ],
            u: "1f327-fe0f",
            a: "0.7"
        },
        {
            n: [
                "cold",
                "snow",
                "cloud",
                "cloud with snow"
            ],
            u: "1f328-fe0f",
            a: "0.7"
        },
        {
            n: [
                "cloud",
                "lightning",
                "cloud with lightning"
            ],
            u: "1f329-fe0f",
            a: "0.7"
        },
        {
            n: [
                "cloud",
                "tornado",
                "whirlwind"
            ],
            u: "1f32a-fe0f",
            a: "0.7"
        },
        {
            n: [
                "fog",
                "cloud"
            ],
            u: "1f32b-fe0f",
            a: "0.7"
        },
        {
            n: [
                "blow",
                "face",
                "wind",
                "cloud",
                "wind face"
            ],
            u: "1f32c-fe0f",
            a: "0.7"
        },
        {
            n: [
                "dizzy",
                "cyclone",
                "twister",
                "typhoon",
                "hurricane"
            ],
            u: "1f300",
            a: "0.6"
        },
        {
            n: [
                "rain",
                "rainbow"
            ],
            u: "1f308",
            a: "0.6"
        },
        {
            n: [
                "rain",
                "clothing",
                "umbrella",
                "closed umbrella"
            ],
            u: "1f302",
            a: "0.6"
        },
        {
            n: [
                "rain",
                "umbrella",
                "clothing"
            ],
            u: "2602-fe0f",
            a: "0.7"
        },
        {
            n: [
                "drop",
                "rain",
                "clothing",
                "umbrella",
                "umbrella with rain drops"
            ],
            u: "2614",
            a: "0.6"
        },
        {
            n: [
                "sun",
                "rain",
                "umbrella",
                "umbrella on ground"
            ],
            u: "26f1-fe0f",
            a: "0.7"
        },
        {
            n: [
                "zap",
                "danger",
                "voltage",
                "electric",
                "lightning",
                "high voltage"
            ],
            u: "26a1",
            a: "0.6"
        },
        {
            n: [
                "cold",
                "snow",
                "snowflake"
            ],
            u: "2744-fe0f",
            a: "0.6"
        },
        {
            n: [
                "cold",
                "snow",
                "snowman"
            ],
            u: "2603-fe0f",
            a: "0.7"
        },
        {
            n: [
                "cold",
                "snow",
                "snowman",
                "snowman without snow"
            ],
            u: "26c4",
            a: "0.6"
        },
        {
            n: [
                "comet",
                "space"
            ],
            u: "2604-fe0f",
            a: "1"
        },
        {
            n: [
                "fire",
                "tool",
                "flame"
            ],
            u: "1f525",
            a: "0.6"
        },
        {
            n: [
                "cold",
                "drop",
                "comic",
                "sweat",
                "droplet"
            ],
            u: "1f4a7",
            a: "0.6"
        },
        {
            n: [
                "wave",
                "ocean",
                "water",
                "water wave"
            ],
            u: "1f30a",
            a: "0.6"
        }
    ],
    activities: [
        {
            n: [
                "jack",
                "lantern",
                "halloween",
                "celebration",
                "jack o lantern"
            ],
            u: "1f383",
            a: "0.6"
        },
        {
            n: [
                "tree",
                "christmas",
                "celebration",
                "Christmas tree"
            ],
            u: "1f384",
            a: "0.6"
        },
        {
            n: [
                "fireworks",
                "celebration"
            ],
            u: "1f386",
            a: "0.6"
        },
        {
            n: [
                "sparkle",
                "sparkler",
                "fireworks",
                "celebration"
            ],
            u: "1f387",
            a: "0.6"
        },
        {
            n: [
                "dynamite",
                "explosive",
                "fireworks",
                "firecracker"
            ],
            u: "1f9e8",
            a: "11"
        },
        {
            n: [
                "*",
                "star",
                "sparkle",
                "sparkles"
            ],
            u: "2728",
            a: "0.6"
        },
        {
            n: [
                "balloon",
                "celebration"
            ],
            u: "1f388",
            a: "0.6"
        },
        {
            n: [
                "tada",
                "party",
                "popper",
                "celebration",
                "party popper"
            ],
            u: "1f389",
            a: "0.6"
        },
        {
            n: [
                "ball",
                "confetti",
                "celebration",
                "confetti ball"
            ],
            u: "1f38a",
            a: "0.6"
        },
        {
            n: [
                "tree",
                "banner",
                "japanese",
                "celebration",
                "tanabata tree"
            ],
            u: "1f38b",
            a: "0.6"
        },
        {
            n: [
                "pine",
                "bamboo",
                "japanese",
                "celebration",
                "pine decoration"
            ],
            u: "1f38d",
            a: "0.6"
        },
        {
            n: [
                "doll",
                "festival",
                "japanese",
                "celebration",
                "Japanese dolls",
                "japanese dolls"
            ],
            u: "1f38e",
            a: "0.6"
        },
        {
            n: [
                "carp",
                "streamer",
                "celebration",
                "carp streamer"
            ],
            u: "1f38f",
            a: "0.6"
        },
        {
            n: [
                "bell",
                "wind",
                "chime",
                "wind chime",
                "celebration"
            ],
            u: "1f390",
            a: "0.6"
        },
        {
            n: [
                "moon",
                "ceremony",
                "celebration",
                "moon viewing ceremony"
            ],
            u: "1f391",
            a: "0.6"
        },
        {
            n: [
                "gift",
                "money",
                "h\xf3ngb\u0101o",
                "lai see",
                "good luck",
                "red envelope"
            ],
            u: "1f9e7",
            a: "11"
        },
        {
            n: [
                "ribbon",
                "celebration"
            ],
            u: "1f380",
            a: "0.6"
        },
        {
            n: [
                "box",
                "gift",
                "present",
                "wrapped",
                "celebration",
                "wrapped gift"
            ],
            u: "1f381",
            a: "0.6"
        },
        {
            n: [
                "ribbon",
                "reminder",
                "celebration",
                "reminder ribbon"
            ],
            u: "1f397-fe0f",
            a: "0.7"
        },
        {
            n: [
                "ticket",
                "admission",
                "admission tickets"
            ],
            u: "1f39f-fe0f",
            a: "0.7"
        },
        {
            n: [
                "ticket",
                "admission"
            ],
            u: "1f3ab",
            a: "0.6"
        },
        {
            n: [
                "medal",
                "military",
                "celebration",
                "military medal"
            ],
            u: "1f396-fe0f",
            a: "0.7"
        },
        {
            n: [
                "prize",
                "trophy"
            ],
            u: "1f3c6",
            a: "0.6"
        },
        {
            n: [
                "medal",
                "sports medal"
            ],
            u: "1f3c5",
            a: "1"
        },
        {
            n: [
                "gold",
                "first",
                "medal",
                "1st place medal"
            ],
            u: "1f947",
            a: "3"
        },
        {
            n: [
                "medal",
                "second",
                "silver",
                "2nd place medal"
            ],
            u: "1f948",
            a: "3"
        },
        {
            n: [
                "medal",
                "third",
                "bronze",
                "3rd place medal"
            ],
            u: "1f949",
            a: "3"
        },
        {
            n: [
                "ball",
                "soccer",
                "football",
                "soccer ball"
            ],
            u: "26bd",
            a: "0.6"
        },
        {
            n: [
                "ball",
                "baseball"
            ],
            u: "26be",
            a: "0.6"
        },
        {
            n: [
                "ball",
                "glove",
                "softball",
                "underarm"
            ],
            u: "1f94e",
            a: "11"
        },
        {
            n: [
                "ball",
                "hoop",
                "basketball"
            ],
            u: "1f3c0",
            a: "0.6"
        },
        {
            n: [
                "ball",
                "game",
                "volleyball"
            ],
            u: "1f3d0",
            a: "1"
        },
        {
            n: [
                "ball",
                "american",
                "football",
                "american football"
            ],
            u: "1f3c8",
            a: "0.6"
        },
        {
            n: [
                "ball",
                "rugby",
                "football",
                "rugby football"
            ],
            u: "1f3c9",
            a: "1"
        },
        {
            n: [
                "ball",
                "tennis",
                "racquet"
            ],
            u: "1f3be",
            a: "0.6"
        },
        {
            n: [
                "ultimate",
                "flying disc"
            ],
            u: "1f94f",
            a: "11"
        },
        {
            n: [
                "ball",
                "game",
                "bowling"
            ],
            u: "1f3b3",
            a: "0.6"
        },
        {
            n: [
                "bat",
                "ball",
                "game",
                "cricket game"
            ],
            u: "1f3cf",
            a: "1"
        },
        {
            n: [
                "ball",
                "game",
                "field",
                "stick",
                "hockey",
                "field hockey"
            ],
            u: "1f3d1",
            a: "1"
        },
        {
            n: [
                "ice",
                "game",
                "puck",
                "stick",
                "hockey",
                "ice hockey"
            ],
            u: "1f3d2",
            a: "1"
        },
        {
            n: [
                "ball",
                "goal",
                "stick",
                "lacrosse"
            ],
            u: "1f94d",
            a: "11"
        },
        {
            n: [
                "bat",
                "ball",
                "game",
                "paddle",
                "ping pong",
                "table tennis"
            ],
            u: "1f3d3",
            a: "1"
        },
        {
            n: [
                "game",
                "birdie",
                "racquet",
                "badminton",
                "shuttlecock"
            ],
            u: "1f3f8",
            a: "1"
        },
        {
            n: [
                "glove",
                "boxing",
                "boxing glove"
            ],
            u: "1f94a",
            a: "3"
        },
        {
            n: [
                "judo",
                "karate",
                "uniform",
                "taekwondo",
                "martial arts",
                "martial arts uniform"
            ],
            u: "1f94b",
            a: "3"
        },
        {
            n: [
                "net",
                "goal",
                "goal net"
            ],
            u: "1f945",
            a: "3"
        },
        {
            n: [
                "golf",
                "hole",
                "flag in hole"
            ],
            u: "26f3",
            a: "0.6"
        },
        {
            n: [
                "ice",
                "skate",
                "ice skate"
            ],
            u: "26f8-fe0f",
            a: "0.7"
        },
        {
            n: [
                "fish",
                "pole",
                "fishing pole"
            ],
            u: "1f3a3",
            a: "0.6"
        },
        {
            n: [
                "scuba",
                "diving",
                "snorkeling",
                "diving mask"
            ],
            u: "1f93f",
            a: "12"
        },
        {
            n: [
                "sash",
                "shirt",
                "running",
                "athletics",
                "running shirt"
            ],
            u: "1f3bd",
            a: "0.6"
        },
        {
            n: [
                "ski",
                "skis",
                "snow"
            ],
            u: "1f3bf",
            a: "0.6"
        },
        {
            n: [
                "sled",
                "sledge",
                "sleigh"
            ],
            u: "1f6f7",
            a: "5"
        },
        {
            n: [
                "game",
                "rock",
                "curling stone"
            ],
            u: "1f94c",
            a: "5"
        },
        {
            n: [
                "hit",
                "dart",
                "game",
                "target",
                "bullseye",
                "direct hit"
            ],
            u: "1f3af",
            a: "0.6"
        },
        {
            n: [
                "toy",
                "yo yo",
                "fluctuate"
            ],
            u: "1fa80",
            a: "12"
        },
        {
            n: [
                "fly",
                "kite",
                "soar"
            ],
            u: "1fa81",
            a: "12"
        },
        {
            n: [
                "gun",
                "tool",
                "water",
                "pistol",
                "weapon",
                "handgun",
                "revolver",
                "water pistol"
            ],
            u: "1f52b",
            a: "0.6"
        },
        {
            n: [
                "8",
                "ball",
                "game",
                "eight",
                "billiard",
                "pool 8 ball"
            ],
            u: "1f3b1",
            a: "0.6"
        },
        {
            n: [
                "ball",
                "tool",
                "crystal",
                "fantasy",
                "fortune",
                "fairy tale",
                "crystal ball"
            ],
            u: "1f52e",
            a: "0.6"
        },
        {
            n: [
                "magic",
                "witch",
                "wizard",
                "magic wand"
            ],
            u: "1fa84",
            a: "13"
        },
        {
            n: [
                "game",
                "video game",
                "controller"
            ],
            u: "1f3ae",
            a: "0.6"
        },
        {
            n: [
                "game",
                "joystick",
                "video game"
            ],
            u: "1f579-fe0f",
            a: "0.7"
        },
        {
            n: [
                "game",
                "slot",
                "slot machine"
            ],
            u: "1f3b0",
            a: "0.6"
        },
        {
            n: [
                "die",
                "dice",
                "game",
                "game die"
            ],
            u: "1f3b2",
            a: "0.6"
        },
        {
            n: [
                "clue",
                "piece",
                "jigsaw",
                "puzzle",
                "puzzle piece",
                "interlocking"
            ],
            u: "1f9e9",
            a: "11"
        },
        {
            n: [
                "toy",
                "plush",
                "stuffed",
                "plaything",
                "teddy bear"
            ],
            u: "1f9f8",
            a: "11"
        },
        {
            n: [
                "party",
                "pi\xf1ata",
                "celebration"
            ],
            u: "1fa85",
            a: "13"
        },
        {
            n: [
                "dance",
                "disco",
                "party",
                "glitter",
                "mirror ball"
            ],
            u: "1faa9",
            a: "14"
        },
        {
            n: [
                "doll",
                "russia",
                "nesting",
                "nesting dolls"
            ],
            u: "1fa86",
            a: "13"
        },
        {
            n: [
                "card",
                "game",
                "spade suit"
            ],
            u: "2660-fe0f",
            a: "0.6"
        },
        {
            n: [
                "card",
                "game",
                "heart suit"
            ],
            u: "2665-fe0f",
            a: "0.6"
        },
        {
            n: [
                "card",
                "game",
                "diamond suit"
            ],
            u: "2666-fe0f",
            a: "0.6"
        },
        {
            n: [
                "card",
                "game",
                "club suit"
            ],
            u: "2663-fe0f",
            a: "0.6"
        },
        {
            n: [
                "dupe",
                "chess",
                "chess pawn",
                "expendable"
            ],
            u: "265f-fe0f",
            a: "11"
        },
        {
            n: [
                "card",
                "game",
                "joker",
                "wildcard"
            ],
            u: "1f0cf",
            a: "0.6"
        },
        {
            n: [
                "red",
                "game",
                "mahjong",
                "mahjong red dragon"
            ],
            u: "1f004",
            a: "0.6"
        },
        {
            n: [
                "card",
                "game",
                "flower",
                "playing",
                "japanese",
                "flower playing cards"
            ],
            u: "1f3b4",
            a: "0.6"
        },
        {
            n: [
                "art",
                "mask",
                "theater",
                "theatre",
                "performing",
                "performing arts"
            ],
            u: "1f3ad",
            a: "0.6"
        },
        {
            n: [
                "art",
                "frame",
                "museum",
                "picture",
                "painting",
                "framed picture"
            ],
            u: "1f5bc-fe0f",
            a: "0.7"
        },
        {
            n: [
                "art",
                "museum",
                "palette",
                "painting",
                "artist palette"
            ],
            u: "1f3a8",
            a: "0.6"
        },
        {
            n: [
                "spool",
                "thread",
                "needle",
                "sewing",
                "string"
            ],
            u: "1f9f5",
            a: "11"
        },
        {
            n: [
                "needle",
                "sewing",
                "sutures",
                "stitches",
                "tailoring",
                "embroidery",
                "sewing needle"
            ],
            u: "1faa1",
            a: "13"
        },
        {
            n: [
                "yarn",
                "ball",
                "knit",
                "crochet"
            ],
            u: "1f9f6",
            a: "11"
        },
        {
            n: [
                "tie",
                "knot",
                "rope",
                "twine",
                "twist",
                "tangled"
            ],
            u: "1faa2",
            a: "13"
        }
    ],
    objects: [
        {
            n: [
                "eye",
                "glasses",
                "eyewear",
                "clothing",
                "eyeglasses"
            ],
            u: "1f453",
            a: "0.6"
        },
        {
            n: [
                "eye",
                "dark",
                "eyewear",
                "glasses",
                "sunglasses"
            ],
            u: "1f576-fe0f",
            a: "0.7"
        },
        {
            n: [
                "goggles",
                "welding",
                "swimming",
                "eye protection"
            ],
            u: "1f97d",
            a: "11"
        },
        {
            n: [
                "doctor",
                "lab coat",
                "scientist",
                "experiment"
            ],
            u: "1f97c",
            a: "11"
        },
        {
            n: [
                "vest",
                "safety",
                "emergency",
                "safety vest"
            ],
            u: "1f9ba",
            a: "12"
        },
        {
            n: [
                "tie",
                "necktie",
                "clothing"
            ],
            u: "1f454",
            a: "0.6"
        },
        {
            n: [
                "shirt",
                "tshirt",
                "t shirt",
                "clothing"
            ],
            u: "1f455",
            a: "0.6"
        },
        {
            n: [
                "jeans",
                "pants",
                "clothing",
                "trousers"
            ],
            u: "1f456",
            a: "0.6"
        },
        {
            n: [
                "neck",
                "scarf"
            ],
            u: "1f9e3",
            a: "5"
        },
        {
            n: [
                "hand",
                "gloves"
            ],
            u: "1f9e4",
            a: "5"
        },
        {
            n: [
                "coat",
                "jacket"
            ],
            u: "1f9e5",
            a: "5"
        },
        {
            n: [
                "socks",
                "stocking"
            ],
            u: "1f9e6",
            a: "5"
        },
        {
            n: [
                "dress",
                "clothing"
            ],
            u: "1f457",
            a: "0.6"
        },
        {
            n: [
                "kimono",
                "clothing"
            ],
            u: "1f458",
            a: "0.6"
        },
        {
            n: [
                "sari",
                "dress",
                "clothing"
            ],
            u: "1f97b",
            a: "12"
        },
        {
            n: [
                "bathing suit",
                "one piece swimsuit"
            ],
            u: "1fa71",
            a: "12"
        },
        {
            n: [
                "briefs",
                "swimsuit",
                "one piece",
                "underwear",
                "bathing suit"
            ],
            u: "1fa72",
            a: "12"
        },
        {
            n: [
                "pants",
                "shorts",
                "underwear",
                "bathing suit"
            ],
            u: "1fa73",
            a: "12"
        },
        {
            n: [
                "swim",
                "bikini",
                "clothing"
            ],
            u: "1f459",
            a: "0.6"
        },
        {
            n: [
                "woman",
                "clothing",
                "woman\u2019s clothes"
            ],
            u: "1f45a",
            a: "0.6"
        },
        {
            n: [
                "fan",
                "hot",
                "shy",
                "dance",
                "cooling",
                "flutter",
                "folding hand fan"
            ],
            u: "1faad",
            a: "15"
        },
        {
            n: [
                "coin",
                "purse",
                "clothing"
            ],
            u: "1f45b",
            a: "0.6"
        },
        {
            n: [
                "bag",
                "purse",
                "handbag",
                "clothing"
            ],
            u: "1f45c",
            a: "0.6"
        },
        {
            n: [
                "bag",
                "pouch",
                "clothing",
                "clutch bag"
            ],
            u: "1f45d",
            a: "0.6"
        },
        {
            n: [
                "bag",
                "hotel",
                "shopping",
                "shopping bags"
            ],
            u: "1f6cd-fe0f",
            a: "0.7"
        },
        {
            n: [
                "bag",
                "school",
                "satchel",
                "backpack",
                "rucksack"
            ],
            u: "1f392",
            a: "0.6"
        },
        {
            n: [
                "z\u014Dri",
                "thongs",
                "sandals",
                "thong sandal",
                "beach sandals",
                "thong sandals"
            ],
            u: "1fa74",
            a: "13"
        },
        {
            n: [
                "man",
                "shoe",
                "clothing",
                "man\u2019s shoe"
            ],
            u: "1f45e",
            a: "0.6"
        },
        {
            n: [
                "shoe",
                "sneaker",
                "athletic",
                "clothing",
                "running shoe"
            ],
            u: "1f45f",
            a: "0.6"
        },
        {
            n: [
                "boot",
                "hiking",
                "camping",
                "hiking boot",
                "backpacking"
            ],
            u: "1f97e",
            a: "11"
        },
        {
            n: [
                "slip on",
                "slipper",
                "flat shoe",
                "ballet flat"
            ],
            u: "1f97f",
            a: "11"
        },
        {
            n: [
                "heel",
                "shoe",
                "woman",
                "clothing",
                "high heeled shoe"
            ],
            u: "1f460",
            a: "0.6"
        },
        {
            n: [
                "shoe",
                "woman",
                "sandal",
                "clothing",
                "woman\u2019s sandal"
            ],
            u: "1f461",
            a: "0.6"
        },
        {
            n: [
                "dance",
                "ballet",
                "ballet shoes"
            ],
            u: "1fa70",
            a: "12"
        },
        {
            n: [
                "boot",
                "shoe",
                "woman",
                "clothing",
                "woman\u2019s boot"
            ],
            u: "1f462",
            a: "0.6"
        },
        {
            n: [
                "afro",
                "comb",
                "hair",
                "pick",
                "hair pick"
            ],
            u: "1faae",
            a: "15"
        },
        {
            n: [
                "king",
                "crown",
                "queen",
                "clothing"
            ],
            u: "1f451",
            a: "0.6"
        },
        {
            n: [
                "hat",
                "woman",
                "clothing",
                "woman\u2019s hat"
            ],
            u: "1f452",
            a: "0.6"
        },
        {
            n: [
                "hat",
                "top",
                "tophat",
                "top hat",
                "clothing"
            ],
            u: "1f3a9",
            a: "0.6"
        },
        {
            n: [
                "cap",
                "hat",
                "clothing",
                "graduation",
                "celebration",
                "graduation cap"
            ],
            u: "1f393",
            a: "0.6"
        },
        {
            n: [
                "billed cap",
                "baseball cap"
            ],
            u: "1f9e2",
            a: "5"
        },
        {
            n: [
                "army",
                "helmet",
                "soldier",
                "warrior",
                "military",
                "military helmet"
            ],
            u: "1fa96",
            a: "13"
        },
        {
            n: [
                "aid",
                "hat",
                "face",
                "cross",
                "helmet",
                "rescue worker\u2019s helmet"
            ],
            u: "26d1-fe0f",
            a: "0.7"
        },
        {
            n: [
                "beads",
                "prayer",
                "clothing",
                "necklace",
                "religion",
                "prayer beads"
            ],
            u: "1f4ff",
            a: "1"
        },
        {
            n: [
                "makeup",
                "lipstick",
                "cosmetics"
            ],
            u: "1f484",
            a: "0.6"
        },
        {
            n: [
                "ring",
                "diamond"
            ],
            u: "1f48d",
            a: "0.6"
        },
        {
            n: [
                "gem",
                "jewel",
                "diamond",
                "gem stone"
            ],
            u: "1f48e",
            a: "0.6"
        },
        {
            n: [
                "mute",
                "quiet",
                "silent",
                "speaker",
                "muted speaker"
            ],
            u: "1f507",
            a: "1"
        },
        {
            n: [
                "soft",
                "speaker low volume"
            ],
            u: "1f508",
            a: "0.7"
        },
        {
            n: [
                "medium",
                "speaker medium volume"
            ],
            u: "1f509",
            a: "1"
        },
        {
            n: [
                "loud",
                "speaker high volume"
            ],
            u: "1f50a",
            a: "0.6"
        },
        {
            n: [
                "loud",
                "loudspeaker",
                "public address"
            ],
            u: "1f4e2",
            a: "0.6"
        },
        {
            n: [
                "cheering",
                "megaphone"
            ],
            u: "1f4e3",
            a: "0.6"
        },
        {
            n: [
                "horn",
                "post",
                "postal",
                "postal horn"
            ],
            u: "1f4ef",
            a: "1"
        },
        {
            n: [
                "bell"
            ],
            u: "1f514",
            a: "0.6"
        },
        {
            n: [
                "bell",
                "mute",
                "quiet",
                "silent",
                "forbidden",
                "bell with slash"
            ],
            u: "1f515",
            a: "1"
        },
        {
            n: [
                "music",
                "score",
                "musical score"
            ],
            u: "1f3bc",
            a: "0.6"
        },
        {
            n: [
                "note",
                "music",
                "musical note"
            ],
            u: "1f3b5",
            a: "0.6"
        },
        {
            n: [
                "note",
                "music",
                "notes",
                "musical notes"
            ],
            u: "1f3b6",
            a: "0.6"
        },
        {
            n: [
                "mic",
                "music",
                "studio",
                "microphone",
                "studio microphone"
            ],
            u: "1f399-fe0f",
            a: "0.7"
        },
        {
            n: [
                "level",
                "music",
                "slider",
                "level slider"
            ],
            u: "1f39a-fe0f",
            a: "0.7"
        },
        {
            n: [
                "knobs",
                "music",
                "control",
                "control knobs"
            ],
            u: "1f39b-fe0f",
            a: "0.7"
        },
        {
            n: [
                "mic",
                "karaoke",
                "microphone"
            ],
            u: "1f3a4",
            a: "0.6"
        },
        {
            n: [
                "earbud",
                "headphone"
            ],
            u: "1f3a7",
            a: "0.6"
        },
        {
            n: [
                "radio",
                "video"
            ],
            u: "1f4fb",
            a: "0.6"
        },
        {
            n: [
                "sax",
                "music",
                "saxophone",
                "instrument"
            ],
            u: "1f3b7",
            a: "0.6"
        },
        {
            n: [
                "accordion",
                "concertina",
                "squeeze box"
            ],
            u: "1fa97",
            a: "13"
        },
        {
            n: [
                "music",
                "guitar",
                "instrument"
            ],
            u: "1f3b8",
            a: "0.6"
        },
        {
            n: [
                "music",
                "piano",
                "keyboard",
                "instrument",
                "musical keyboard"
            ],
            u: "1f3b9",
            a: "0.6"
        },
        {
            n: [
                "music",
                "trumpet",
                "instrument"
            ],
            u: "1f3ba",
            a: "0.6"
        },
        {
            n: [
                "music",
                "violin",
                "instrument"
            ],
            u: "1f3bb",
            a: "0.6"
        },
        {
            n: [
                "banjo",
                "music",
                "stringed"
            ],
            u: "1fa95",
            a: "12"
        },
        {
            n: [
                "drum",
                "music",
                "drumsticks"
            ],
            u: "1f941",
            a: "3"
        },
        {
            n: [
                "beat",
                "drum",
                "conga",
                "rhythm",
                "long drum"
            ],
            u: "1fa98",
            a: "13"
        },
        {
            n: [
                "music",
                "shake",
                "rattle",
                "maracas",
                "instrument",
                "percussion"
            ],
            u: "1fa87",
            a: "15"
        },
        {
            n: [
                "fife",
                "pipe",
                "flute",
                "music",
                "recorder",
                "woodwind"
            ],
            u: "1fa88",
            a: "15"
        },
        {
            n: [
                "cell",
                "phone",
                "mobile",
                "telephone",
                "mobile phone"
            ],
            u: "1f4f1",
            a: "0.6"
        },
        {
            n: [
                "cell",
                "arrow",
                "phone",
                "mobile",
                "receive",
                "mobile phone with arrow"
            ],
            u: "1f4f2",
            a: "0.6"
        },
        {
            n: [
                "phone",
                "telephone"
            ],
            u: "260e-fe0f",
            a: "0.6"
        },
        {
            n: [
                "phone",
                "receiver",
                "telephone",
                "telephone receiver"
            ],
            u: "1f4de",
            a: "0.6"
        },
        {
            n: [
                "pager"
            ],
            u: "1f4df",
            a: "0.6"
        },
        {
            n: [
                "fax",
                "fax machine"
            ],
            u: "1f4e0",
            a: "0.6"
        },
        {
            n: [
                "battery"
            ],
            u: "1f50b",
            a: "0.6"
        },
        {
            n: [
                "electronic",
                "low energy",
                "low battery"
            ],
            u: "1faab",
            a: "14"
        },
        {
            n: [
                "plug",
                "electric",
                "electricity",
                "electric plug"
            ],
            u: "1f50c",
            a: "0.6"
        },
        {
            n: [
                "pc",
                "laptop",
                "computer",
                "personal"
            ],
            u: "1f4bb",
            a: "0.6"
        },
        {
            n: [
                "desktop",
                "computer",
                "desktop computer"
            ],
            u: "1f5a5-fe0f",
            a: "0.7"
        },
        {
            n: [
                "printer",
                "computer"
            ],
            u: "1f5a8-fe0f",
            a: "0.7"
        },
        {
            n: [
                "keyboard",
                "computer"
            ],
            u: "2328-fe0f",
            a: "1"
        },
        {
            n: [
                "computer",
                "computer mouse"
            ],
            u: "1f5b1-fe0f",
            a: "0.7"
        },
        {
            n: [
                "computer",
                "trackball"
            ],
            u: "1f5b2-fe0f",
            a: "0.7"
        },
        {
            n: [
                "disk",
                "optical",
                "computer",
                "minidisk",
                "computer disk"
            ],
            u: "1f4bd",
            a: "0.6"
        },
        {
            n: [
                "disk",
                "floppy",
                "computer",
                "floppy disk"
            ],
            u: "1f4be",
            a: "0.6"
        },
        {
            n: [
                "cd",
                "disk",
                "optical",
                "computer",
                "optical disk"
            ],
            u: "1f4bf",
            a: "0.6"
        },
        {
            n: [
                "dvd",
                "disk",
                "blu ray",
                "optical",
                "computer"
            ],
            u: "1f4c0",
            a: "0.6"
        },
        {
            n: [
                "abacus",
                "calculation"
            ],
            u: "1f9ee",
            a: "11"
        },
        {
            n: [
                "movie",
                "camera",
                "cinema",
                "movie camera"
            ],
            u: "1f3a5",
            a: "0.6"
        },
        {
            n: [
                "film",
                "movie",
                "cinema",
                "frames",
                "film frames"
            ],
            u: "1f39e-fe0f",
            a: "0.7"
        },
        {
            n: [
                "film",
                "movie",
                "video",
                "cinema",
                "projector",
                "film projector"
            ],
            u: "1f4fd-fe0f",
            a: "0.7"
        },
        {
            n: [
                "movie",
                "clapper",
                "clapper board"
            ],
            u: "1f3ac",
            a: "0.6"
        },
        {
            n: [
                "tv",
                "video",
                "television"
            ],
            u: "1f4fa",
            a: "0.6"
        },
        {
            n: [
                "video",
                "camera"
            ],
            u: "1f4f7",
            a: "0.6"
        },
        {
            n: [
                "flash",
                "video",
                "camera",
                "camera with flash"
            ],
            u: "1f4f8",
            a: "1"
        },
        {
            n: [
                "video",
                "camera",
                "video camera"
            ],
            u: "1f4f9",
            a: "0.6"
        },
        {
            n: [
                "vhs",
                "tape",
                "video",
                "videocassette"
            ],
            u: "1f4fc",
            a: "0.6"
        },
        {
            n: [
                "tool",
                "glass",
                "search",
                "magnifying",
                "magnifying glass tilted left"
            ],
            u: "1f50d",
            a: "0.6"
        },
        {
            n: [
                "tool",
                "glass",
                "search",
                "magnifying",
                "magnifying glass tilted right"
            ],
            u: "1f50e",
            a: "0.6"
        },
        {
            n: [
                "light",
                "candle"
            ],
            u: "1f56f-fe0f",
            a: "0.7"
        },
        {
            n: [
                "bulb",
                "idea",
                "comic",
                "light",
                "electric",
                "light bulb"
            ],
            u: "1f4a1",
            a: "0.6"
        },
        {
            n: [
                "tool",
                "light",
                "torch",
                "electric",
                "flashlight"
            ],
            u: "1f526",
            a: "0.6"
        },
        {
            n: [
                "bar",
                "red",
                "light",
                "lantern",
                "red paper lantern"
            ],
            u: "1f3ee",
            a: "0.6"
        },
        {
            n: [
                "oil",
                "diya",
                "lamp",
                "diya lamp"
            ],
            u: "1fa94",
            a: "12"
        },
        {
            n: [
                "book",
                "cover",
                "notebook",
                "decorated",
                "notebook with decorative cover"
            ],
            u: "1f4d4",
            a: "0.6"
        },
        {
            n: [
                "book",
                "closed",
                "closed book"
            ],
            u: "1f4d5",
            a: "0.6"
        },
        {
            n: [
                "book",
                "open",
                "open book"
            ],
            u: "1f4d6",
            a: "0.6"
        },
        {
            n: [
                "book",
                "green",
                "green book"
            ],
            u: "1f4d7",
            a: "0.6"
        },
        {
            n: [
                "blue",
                "book",
                "blue book"
            ],
            u: "1f4d8",
            a: "0.6"
        },
        {
            n: [
                "book",
                "orange",
                "orange book"
            ],
            u: "1f4d9",
            a: "0.6"
        },
        {
            n: [
                "book",
                "books"
            ],
            u: "1f4da",
            a: "0.6"
        },
        {
            n: [
                "notebook"
            ],
            u: "1f4d3",
            a: "0.6"
        },
        {
            n: [
                "ledger",
                "notebook"
            ],
            u: "1f4d2",
            a: "0.6"
        },
        {
            n: [
                "curl",
                "page",
                "document",
                "page with curl"
            ],
            u: "1f4c3",
            a: "0.6"
        },
        {
            n: [
                "paper",
                "scroll"
            ],
            u: "1f4dc",
            a: "0.6"
        },
        {
            n: [
                "page",
                "document",
                "page facing up"
            ],
            u: "1f4c4",
            a: "0.6"
        },
        {
            n: [
                "news",
                "paper",
                "newspaper"
            ],
            u: "1f4f0",
            a: "0.6"
        },
        {
            n: [
                "news",
                "paper",
                "rolled",
                "newspaper",
                "rolled up newspaper"
            ],
            u: "1f5de-fe0f",
            a: "0.7"
        },
        {
            n: [
                "mark",
                "tabs",
                "marker",
                "bookmark",
                "bookmark tabs"
            ],
            u: "1f4d1",
            a: "0.6"
        },
        {
            n: [
                "mark",
                "bookmark"
            ],
            u: "1f516",
            a: "0.6"
        },
        {
            n: [
                "label"
            ],
            u: "1f3f7-fe0f",
            a: "0.7"
        },
        {
            n: [
                "bag",
                "money",
                "dollar",
                "moneybag",
                "money bag"
            ],
            u: "1f4b0",
            a: "0.6"
        },
        {
            n: [
                "coin",
                "gold",
                "metal",
                "money",
                "silver",
                "treasure"
            ],
            u: "1fa99",
            a: "13"
        },
        {
            n: [
                "yen",
                "bill",
                "note",
                "money",
                "banknote",
                "currency",
                "yen banknote"
            ],
            u: "1f4b4",
            a: "0.6"
        },
        {
            n: [
                "bill",
                "note",
                "money",
                "dollar",
                "banknote",
                "currency",
                "dollar banknote"
            ],
            u: "1f4b5",
            a: "0.6"
        },
        {
            n: [
                "bill",
                "euro",
                "note",
                "money",
                "banknote",
                "currency",
                "euro banknote"
            ],
            u: "1f4b6",
            a: "1"
        },
        {
            n: [
                "bill",
                "note",
                "money",
                "pound",
                "banknote",
                "currency",
                "pound banknote"
            ],
            u: "1f4b7",
            a: "1"
        },
        {
            n: [
                "fly",
                "bill",
                "money",
                "wings",
                "banknote",
                "money with wings"
            ],
            u: "1f4b8",
            a: "0.6"
        },
        {
            n: [
                "card",
                "money",
                "credit",
                "credit card"
            ],
            u: "1f4b3",
            a: "0.6"
        },
        {
            n: [
                "proof",
                "receipt",
                "evidence",
                "accounting",
                "bookkeeping"
            ],
            u: "1f9fe",
            a: "11"
        },
        {
            n: [
                "yen",
                "chart",
                "graph",
                "money",
                "growth",
                "chart increasing with yen"
            ],
            u: "1f4b9",
            a: "0.6"
        },
        {
            n: [
                "email",
                "letter",
                "envelope"
            ],
            u: "2709-fe0f",
            a: "0.6"
        },
        {
            n: [
                "mail",
                "email",
                "e mail",
                "letter"
            ],
            u: "1f4e7",
            a: "0.6"
        },
        {
            n: [
                "email",
                "e mail",
                "letter",
                "receive",
                "envelope",
                "incoming",
                "incoming envelope"
            ],
            u: "1f4e8",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "email",
                "e mail",
                "envelope",
                "outgoing",
                "envelope with arrow"
            ],
            u: "1f4e9",
            a: "0.6"
        },
        {
            n: [
                "box",
                "mail",
                "sent",
                "tray",
                "letter",
                "outbox",
                "outbox tray"
            ],
            u: "1f4e4",
            a: "0.6"
        },
        {
            n: [
                "box",
                "mail",
                "tray",
                "inbox",
                "letter",
                "receive",
                "inbox tray"
            ],
            u: "1f4e5",
            a: "0.6"
        },
        {
            n: [
                "box",
                "parcel",
                "package"
            ],
            u: "1f4e6",
            a: "0.6"
        },
        {
            n: [
                "mail",
                "closed",
                "mailbox",
                "postbox",
                "closed mailbox with raised flag"
            ],
            u: "1f4eb",
            a: "0.6"
        },
        {
            n: [
                "mail",
                "closed",
                "lowered",
                "mailbox",
                "postbox",
                "closed mailbox with lowered flag"
            ],
            u: "1f4ea",
            a: "0.6"
        },
        {
            n: [
                "mail",
                "open",
                "mailbox",
                "postbox",
                "open mailbox with raised flag"
            ],
            u: "1f4ec",
            a: "0.7"
        },
        {
            n: [
                "mail",
                "open",
                "lowered",
                "mailbox",
                "postbox",
                "open mailbox with lowered flag"
            ],
            u: "1f4ed",
            a: "0.7"
        },
        {
            n: [
                "mail",
                "postbox",
                "mailbox"
            ],
            u: "1f4ee",
            a: "0.6"
        },
        {
            n: [
                "box",
                "ballot",
                "ballot box with ballot"
            ],
            u: "1f5f3-fe0f",
            a: "0.7"
        },
        {
            n: [
                "pencil"
            ],
            u: "270f-fe0f",
            a: "0.6"
        },
        {
            n: [
                "nib",
                "pen",
                "black nib"
            ],
            u: "2712-fe0f",
            a: "0.6"
        },
        {
            n: [
                "pen",
                "fountain",
                "fountain pen"
            ],
            u: "1f58b-fe0f",
            a: "0.7"
        },
        {
            n: [
                "pen",
                "ballpoint"
            ],
            u: "1f58a-fe0f",
            a: "0.7"
        },
        {
            n: [
                "painting",
                "paintbrush"
            ],
            u: "1f58c-fe0f",
            a: "0.7"
        },
        {
            n: [
                "crayon"
            ],
            u: "1f58d-fe0f",
            a: "0.7"
        },
        {
            n: [
                "memo",
                "pencil"
            ],
            u: "1f4dd",
            a: "0.6"
        },
        {
            n: [
                "briefcase"
            ],
            u: "1f4bc",
            a: "0.6"
        },
        {
            n: [
                "file",
                "folder",
                "file folder"
            ],
            u: "1f4c1",
            a: "0.6"
        },
        {
            n: [
                "file",
                "open",
                "folder",
                "open file folder"
            ],
            u: "1f4c2",
            a: "0.6"
        },
        {
            n: [
                "card",
                "index",
                "dividers",
                "card index dividers"
            ],
            u: "1f5c2-fe0f",
            a: "0.7"
        },
        {
            n: [
                "date",
                "calendar"
            ],
            u: "1f4c5",
            a: "0.6"
        },
        {
            n: [
                "calendar",
                "tear off calendar"
            ],
            u: "1f4c6",
            a: "0.6"
        },
        {
            n: [
                "pad",
                "note",
                "spiral",
                "spiral notepad"
            ],
            u: "1f5d2-fe0f",
            a: "0.7"
        },
        {
            n: [
                "pad",
                "spiral",
                "calendar",
                "spiral calendar"
            ],
            u: "1f5d3-fe0f",
            a: "0.7"
        },
        {
            n: [
                "card",
                "index",
                "rolodex",
                "card index"
            ],
            u: "1f4c7",
            a: "0.6"
        },
        {
            n: [
                "chart",
                "graph",
                "trend",
                "growth",
                "upward",
                "chart increasing"
            ],
            u: "1f4c8",
            a: "0.6"
        },
        {
            n: [
                "down",
                "chart",
                "graph",
                "trend",
                "chart decreasing"
            ],
            u: "1f4c9",
            a: "0.6"
        },
        {
            n: [
                "bar",
                "chart",
                "graph",
                "bar chart"
            ],
            u: "1f4ca",
            a: "0.6"
        },
        {
            n: [
                "clipboard"
            ],
            u: "1f4cb",
            a: "0.6"
        },
        {
            n: [
                "pin",
                "pushpin"
            ],
            u: "1f4cc",
            a: "0.6"
        },
        {
            n: [
                "pin",
                "pushpin",
                "round pushpin"
            ],
            u: "1f4cd",
            a: "0.6"
        },
        {
            n: [
                "paperclip"
            ],
            u: "1f4ce",
            a: "0.6"
        },
        {
            n: [
                "link",
                "paperclip",
                "linked paperclips"
            ],
            u: "1f587-fe0f",
            a: "0.7"
        },
        {
            n: [
                "ruler",
                "straight edge",
                "straight ruler"
            ],
            u: "1f4cf",
            a: "0.6"
        },
        {
            n: [
                "set",
                "ruler",
                "triangle",
                "triangular ruler"
            ],
            u: "1f4d0",
            a: "0.6"
        },
        {
            n: [
                "tool",
                "cutting",
                "scissors"
            ],
            u: "2702-fe0f",
            a: "0.6"
        },
        {
            n: [
                "box",
                "card",
                "file",
                "card file box"
            ],
            u: "1f5c3-fe0f",
            a: "0.7"
        },
        {
            n: [
                "file",
                "filing",
                "cabinet",
                "file cabinet"
            ],
            u: "1f5c4-fe0f",
            a: "0.7"
        },
        {
            n: [
                "wastebasket"
            ],
            u: "1f5d1-fe0f",
            a: "0.7"
        },
        {
            n: [
                "locked",
                "closed"
            ],
            u: "1f512",
            a: "0.6"
        },
        {
            n: [
                "lock",
                "open",
                "unlock",
                "unlocked"
            ],
            u: "1f513",
            a: "0.6"
        },
        {
            n: [
                "ink",
                "nib",
                "pen",
                "lock",
                "privacy",
                "locked with pen"
            ],
            u: "1f50f",
            a: "0.6"
        },
        {
            n: [
                "key",
                "lock",
                "closed",
                "secure",
                "locked with key"
            ],
            u: "1f510",
            a: "0.6"
        },
        {
            n: [
                "key",
                "lock",
                "password"
            ],
            u: "1f511",
            a: "0.6"
        },
        {
            n: [
                "key",
                "old",
                "clue",
                "lock",
                "old key"
            ],
            u: "1f5dd-fe0f",
            a: "0.7"
        },
        {
            n: [
                "tool",
                "hammer"
            ],
            u: "1f528",
            a: "0.6"
        },
        {
            n: [
                "axe",
                "chop",
                "wood",
                "split",
                "hatchet"
            ],
            u: "1fa93",
            a: "12"
        },
        {
            n: [
                "pick",
                "tool",
                "mining"
            ],
            u: "26cf-fe0f",
            a: "0.7"
        },
        {
            n: [
                "pick",
                "tool",
                "hammer",
                "hammer and pick"
            ],
            u: "2692-fe0f",
            a: "1"
        },
        {
            n: [
                "tool",
                "hammer",
                "wrench",
                "spanner",
                "hammer and wrench"
            ],
            u: "1f6e0-fe0f",
            a: "0.7"
        },
        {
            n: [
                "knife",
                "dagger",
                "weapon"
            ],
            u: "1f5e1-fe0f",
            a: "0.7"
        },
        {
            n: [
                "swords",
                "weapon",
                "crossed",
                "crossed swords"
            ],
            u: "2694-fe0f",
            a: "1"
        },
        {
            n: [
                "bomb",
                "comic"
            ],
            u: "1f4a3",
            a: "0.6"
        },
        {
            n: [
                "rebound",
                "boomerang",
                "repercussion"
            ],
            u: "1fa83",
            a: "13"
        },
        {
            n: [
                "bow",
                "arrow",
                "archer",
                "zodiac",
                "sagittarius",
                "bow and arrow"
            ],
            u: "1f3f9",
            a: "1"
        },
        {
            n: [
                "shield",
                "weapon"
            ],
            u: "1f6e1-fe0f",
            a: "0.7"
        },
        {
            n: [
                "saw",
                "tool",
                "lumber",
                "carpenter",
                "carpentry saw"
            ],
            u: "1fa9a",
            a: "13"
        },
        {
            n: [
                "tool",
                "wrench",
                "spanner"
            ],
            u: "1f527",
            a: "0.6"
        },
        {
            n: [
                "tool",
                "screw",
                "screwdriver"
            ],
            u: "1fa9b",
            a: "13"
        },
        {
            n: [
                "nut",
                "bolt",
                "tool",
                "nut and bolt"
            ],
            u: "1f529",
            a: "0.6"
        },
        {
            n: [
                "cog",
                "gear",
                "tool",
                "cogwheel"
            ],
            u: "2699-fe0f",
            a: "1"
        },
        {
            n: [
                "tool",
                "vice",
                "clamp",
                "compress"
            ],
            u: "1f5dc-fe0f",
            a: "0.7"
        },
        {
            n: [
                "libra",
                "scale",
                "zodiac",
                "balance",
                "justice",
                "balance scale"
            ],
            u: "2696-fe0f",
            a: "1"
        },
        {
            n: [
                "blind",
                "white cane",
                "accessibility"
            ],
            u: "1f9af",
            a: "12"
        },
        {
            n: [
                "link"
            ],
            u: "1f517",
            a: "0.6"
        },
        {
            n: [
                "break",
                "chain",
                "cuffs",
                "freedom",
                "breaking",
                "broken chain"
            ],
            u: "26d3-fe0f-200d-1f4a5",
            a: "15.1"
        },
        {
            n: [
                "chain",
                "chains"
            ],
            u: "26d3-fe0f",
            a: "0.7"
        },
        {
            n: [
                "hook",
                "catch",
                "crook",
                "curve",
                "ensnare",
                "selling point"
            ],
            u: "1fa9d",
            a: "13"
        },
        {
            n: [
                "tool",
                "chest",
                "toolbox",
                "mechanic"
            ],
            u: "1f9f0",
            a: "11"
        },
        {
            n: [
                "magnet",
                "magnetic",
                "horseshoe",
                "attraction"
            ],
            u: "1f9f2",
            a: "11"
        },
        {
            n: [
                "rung",
                "step",
                "climb",
                "ladder"
            ],
            u: "1fa9c",
            a: "13"
        },
        {
            n: [
                "tool",
                "alembic",
                "chemistry"
            ],
            u: "2697-fe0f",
            a: "1"
        },
        {
            n: [
                "lab",
                "chemist",
                "science",
                "test tube",
                "chemistry",
                "experiment"
            ],
            u: "1f9ea",
            a: "11"
        },
        {
            n: [
                "lab",
                "biology",
                "culture",
                "bacteria",
                "biologist",
                "petri dish"
            ],
            u: "1f9eb",
            a: "11"
        },
        {
            n: [
                "dna",
                "gene",
                "life",
                "genetics",
                "biologist",
                "evolution"
            ],
            u: "1f9ec",
            a: "11"
        },
        {
            n: [
                "tool",
                "science",
                "microscope"
            ],
            u: "1f52c",
            a: "1"
        },
        {
            n: [
                "tool",
                "science",
                "telescope"
            ],
            u: "1f52d",
            a: "1"
        },
        {
            n: [
                "dish",
                "antenna",
                "satellite",
                "satellite antenna"
            ],
            u: "1f4e1",
            a: "0.6"
        },
        {
            n: [
                "shot",
                "sick",
                "needle",
                "syringe",
                "medicine"
            ],
            u: "1f489",
            a: "0.6"
        },
        {
            n: [
                "bleed",
                "injury",
                "medicine",
                "menstruation",
                "drop of blood",
                "blood donation"
            ],
            u: "1fa78",
            a: "12"
        },
        {
            n: [
                "pill",
                "sick",
                "doctor",
                "medicine"
            ],
            u: "1f48a",
            a: "0.6"
        },
        {
            n: [
                "bandage",
                "adhesive bandage"
            ],
            u: "1fa79",
            a: "12"
        },
        {
            n: [
                "cane",
                "hurt",
                "stick",
                "crutch",
                "disability",
                "mobility aid"
            ],
            u: "1fa7c",
            a: "14"
        },
        {
            n: [
                "heart",
                "doctor",
                "medicine",
                "stethoscope"
            ],
            u: "1fa7a",
            a: "12"
        },
        {
            n: [
                "x ray",
                "bones",
                "doctor",
                "medical",
                "skeleton"
            ],
            u: "1fa7b",
            a: "14"
        },
        {
            n: [
                "door"
            ],
            u: "1f6aa",
            a: "0.6"
        },
        {
            n: [
                "lift",
                "hoist",
                "elevator",
                "accessibility"
            ],
            u: "1f6d7",
            a: "13"
        },
        {
            n: [
                "mirror",
                "speculum",
                "reflector",
                "reflection"
            ],
            u: "1fa9e",
            a: "13"
        },
        {
            n: [
                "view",
                "frame",
                "window",
                "opening",
                "fresh air",
                "transparent"
            ],
            u: "1fa9f",
            a: "13"
        },
        {
            n: [
                "bed",
                "hotel",
                "sleep"
            ],
            u: "1f6cf-fe0f",
            a: "0.7"
        },
        {
            n: [
                "lamp",
                "couch",
                "hotel",
                "couch and lamp"
            ],
            u: "1f6cb-fe0f",
            a: "0.7"
        },
        {
            n: [
                "sit",
                "seat",
                "chair"
            ],
            u: "1fa91",
            a: "12"
        },
        {
            n: [
                "toilet"
            ],
            u: "1f6bd",
            a: "0.6"
        },
        {
            n: [
                "toilet",
                "plunger",
                "plumber",
                "suction",
                "force cup"
            ],
            u: "1faa0",
            a: "13"
        },
        {
            n: [
                "water",
                "shower"
            ],
            u: "1f6bf",
            a: "1"
        },
        {
            n: [
                "bath",
                "bathtub"
            ],
            u: "1f6c1",
            a: "1"
        },
        {
            n: [
                "bait",
                "trap",
                "snare",
                "mousetrap",
                "mouse trap"
            ],
            u: "1faa4",
            a: "13"
        },
        {
            n: [
                "razor",
                "sharp",
                "shave"
            ],
            u: "1fa92",
            a: "12"
        },
        {
            n: [
                "lotion",
                "shampoo",
                "sunscreen",
                "moisturizer",
                "lotion bottle"
            ],
            u: "1f9f4",
            a: "11"
        },
        {
            n: [
                "diaper",
                "punk rock",
                "safety pin"
            ],
            u: "1f9f7",
            a: "11"
        },
        {
            n: [
                "broom",
                "witch",
                "cleaning",
                "sweeping"
            ],
            u: "1f9f9",
            a: "11"
        },
        {
            n: [
                "basket",
                "picnic",
                "farming",
                "laundry"
            ],
            u: "1f9fa",
            a: "11"
        },
        {
            n: [
                "paper towels",
                "toilet paper",
                "roll of paper"
            ],
            u: "1f9fb",
            a: "11"
        },
        {
            n: [
                "vat",
                "cask",
                "pail",
                "bucket"
            ],
            u: "1faa3",
            a: "13"
        },
        {
            n: [
                "bar",
                "soap",
                "lather",
                "bathing",
                "cleaning",
                "soapdish"
            ],
            u: "1f9fc",
            a: "11"
        },
        {
            n: [
                "burp",
                "soap",
                "clean",
                "bubbles",
                "underwater"
            ],
            u: "1fae7",
            a: "14"
        },
        {
            n: [
                "brush",
                "clean",
                "teeth",
                "dental",
                "hygiene",
                "bathroom",
                "toothbrush"
            ],
            u: "1faa5",
            a: "13"
        },
        {
            n: [
                "sponge",
                "porous",
                "cleaning",
                "absorbing"
            ],
            u: "1f9fd",
            a: "11"
        },
        {
            n: [
                "fire",
                "quench",
                "extinguish",
                "fire extinguisher"
            ],
            u: "1f9ef",
            a: "11"
        },
        {
            n: [
                "cart",
                "trolley",
                "shopping",
                "shopping cart"
            ],
            u: "1f6d2",
            a: "3"
        },
        {
            n: [
                "smoking",
                "cigarette"
            ],
            u: "1f6ac",
            a: "0.6"
        },
        {
            n: [
                "death",
                "coffin"
            ],
            u: "26b0-fe0f",
            a: "1"
        },
        {
            n: [
                "grave",
                "cemetery",
                "headstone",
                "graveyard",
                "tombstone"
            ],
            u: "1faa6",
            a: "13"
        },
        {
            n: [
                "urn",
                "ashes",
                "death",
                "funeral",
                "funeral urn"
            ],
            u: "26b1-fe0f",
            a: "1"
        },
        {
            n: [
                "bead",
                "charm",
                "nazar",
                "evil eye",
                "talisman",
                "nazar amulet"
            ],
            u: "1f9ff",
            a: "11"
        },
        {
            n: [
                "hand",
                "mary",
                "hamsa",
                "amulet",
                "fatima",
                "miriam",
                "protection"
            ],
            u: "1faac",
            a: "14"
        },
        {
            n: [
                "moai",
                "face",
                "moyai",
                "statue"
            ],
            u: "1f5ff",
            a: "0.6"
        },
        {
            n: [
                "sign",
                "picket",
                "placard",
                "protest",
                "demonstration"
            ],
            u: "1faa7",
            a: "13"
        },
        {
            n: [
                "id",
                "license",
                "security",
                "credentials",
                "identification card"
            ],
            u: "1faaa",
            a: "14"
        }
    ],
    symbols: [
        {
            n: [
                "atm",
                "bank",
                "teller",
                "ATM sign",
                "atm sign",
                "automated"
            ],
            u: "1f3e7",
            a: "0.6"
        },
        {
            n: [
                "litter",
                "litter bin",
                "litter in bin sign"
            ],
            u: "1f6ae",
            a: "1"
        },
        {
            n: [
                "water",
                "potable",
                "drinking",
                "potable water"
            ],
            u: "1f6b0",
            a: "1"
        },
        {
            n: [
                "access",
                "wheelchair symbol"
            ],
            u: "267f",
            a: "0.6"
        },
        {
            n: [
                "wc",
                "man",
                "toilet",
                "bathroom",
                "lavatory",
                "restroom",
                "men\u2019s room"
            ],
            u: "1f6b9",
            a: "0.6"
        },
        {
            n: [
                "wc",
                "woman",
                "toilet",
                "bathroom",
                "lavatory",
                "restroom",
                "women\u2019s room"
            ],
            u: "1f6ba",
            a: "0.6"
        },
        {
            n: [
                "wc",
                "toilet",
                "restroom",
                "bathroom",
                "lavatory"
            ],
            u: "1f6bb",
            a: "0.6"
        },
        {
            n: [
                "baby",
                "changing",
                "baby symbol"
            ],
            u: "1f6bc",
            a: "0.6"
        },
        {
            n: [
                "wc",
                "water",
                "closet",
                "toilet",
                "bathroom",
                "lavatory",
                "restroom",
                "water closet"
            ],
            u: "1f6be",
            a: "0.6"
        },
        {
            n: [
                "control",
                "passport",
                "passport control"
            ],
            u: "1f6c2",
            a: "1"
        },
        {
            n: [
                "customs"
            ],
            u: "1f6c3",
            a: "1"
        },
        {
            n: [
                "claim",
                "baggage",
                "baggage claim"
            ],
            u: "1f6c4",
            a: "1"
        },
        {
            n: [
                "locker",
                "baggage",
                "luggage",
                "left luggage"
            ],
            u: "1f6c5",
            a: "1"
        },
        {
            n: [
                "warning"
            ],
            u: "26a0-fe0f",
            a: "0.6"
        },
        {
            n: [
                "child",
                "traffic",
                "crossing",
                "pedestrian",
                "children crossing"
            ],
            u: "1f6b8",
            a: "1"
        },
        {
            n: [
                "no",
                "not",
                "entry",
                "traffic",
                "no entry",
                "forbidden",
                "prohibited"
            ],
            u: "26d4",
            a: "0.6"
        },
        {
            n: [
                "no",
                "not",
                "entry",
                "forbidden",
                "prohibited"
            ],
            u: "1f6ab",
            a: "0.6"
        },
        {
            n: [
                "no",
                "bike",
                "bicycle",
                "forbidden",
                "prohibited",
                "no bicycles"
            ],
            u: "1f6b3",
            a: "1"
        },
        {
            n: [
                "no",
                "not",
                "smoking",
                "forbidden",
                "no smoking",
                "prohibited"
            ],
            u: "1f6ad",
            a: "0.6"
        },
        {
            n: [
                "no",
                "not",
                "litter",
                "forbidden",
                "prohibited",
                "no littering"
            ],
            u: "1f6af",
            a: "1"
        },
        {
            n: [
                "water",
                "non potable",
                "non drinking",
                "non potable water"
            ],
            u: "1f6b1",
            a: "1"
        },
        {
            n: [
                "no",
                "not",
                "forbidden",
                "pedestrian",
                "prohibited",
                "no pedestrians"
            ],
            u: "1f6b7",
            a: "1"
        },
        {
            n: [
                "no",
                "cell",
                "phone",
                "mobile",
                "forbidden",
                "no mobile phones"
            ],
            u: "1f4f5",
            a: "1"
        },
        {
            n: [
                "18",
                "eighteen",
                "underage",
                "prohibited",
                "age restriction",
                "no one under eighteen"
            ],
            u: "1f51e",
            a: "0.6"
        },
        {
            n: [
                "sign",
                "radioactive"
            ],
            u: "2622-fe0f",
            a: "1"
        },
        {
            n: [
                "sign",
                "biohazard"
            ],
            u: "2623-fe0f",
            a: "1"
        },
        {
            n: [
                "arrow",
                "north",
                "up arrow",
                "cardinal",
                "direction"
            ],
            u: "2b06-fe0f",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "direction",
                "northeast",
                "intercardinal",
                "up right arrow"
            ],
            u: "2197-fe0f",
            a: "0.6"
        },
        {
            n: [
                "east",
                "arrow",
                "cardinal",
                "direction",
                "right arrow"
            ],
            u: "27a1-fe0f",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "direction",
                "southeast",
                "intercardinal",
                "down right arrow"
            ],
            u: "2198-fe0f",
            a: "0.6"
        },
        {
            n: [
                "down",
                "arrow",
                "south",
                "cardinal",
                "direction",
                "down arrow"
            ],
            u: "2b07-fe0f",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "direction",
                "southwest",
                "intercardinal",
                "down left arrow"
            ],
            u: "2199-fe0f",
            a: "0.6"
        },
        {
            n: [
                "west",
                "arrow",
                "cardinal",
                "direction",
                "left arrow"
            ],
            u: "2b05-fe0f",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "direction",
                "northwest",
                "up left arrow",
                "intercardinal"
            ],
            u: "2196-fe0f",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "up down arrow"
            ],
            u: "2195-fe0f",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "left right arrow"
            ],
            u: "2194-fe0f",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "right arrow curving left"
            ],
            u: "21a9-fe0f",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "left arrow curving right"
            ],
            u: "21aa-fe0f",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "right arrow curving up"
            ],
            u: "2934-fe0f",
            a: "0.6"
        },
        {
            n: [
                "down",
                "arrow",
                "right arrow curving down"
            ],
            u: "2935-fe0f",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "reload",
                "clockwise",
                "clockwise vertical arrows"
            ],
            u: "1f503",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "withershins",
                "anticlockwise",
                "counterclockwise",
                "counterclockwise arrows button"
            ],
            u: "1f504",
            a: "1"
        },
        {
            n: [
                "back",
                "arrow",
                "BACK arrow"
            ],
            u: "1f519",
            a: "0.6"
        },
        {
            n: [
                "end",
                "arrow",
                "END arrow"
            ],
            u: "1f51a",
            a: "0.6"
        },
        {
            n: [
                "on",
                "on!",
                "mark",
                "arrow",
                "ON! arrow"
            ],
            u: "1f51b",
            a: "0.6"
        },
        {
            n: [
                "soon",
                "arrow",
                "SOON arrow"
            ],
            u: "1f51c",
            a: "0.6"
        },
        {
            n: [
                "up",
                "top",
                "arrow",
                "TOP arrow"
            ],
            u: "1f51d",
            a: "0.6"
        },
        {
            n: [
                "worship",
                "religion",
                "place of worship"
            ],
            u: "1f6d0",
            a: "1"
        },
        {
            n: [
                "atom",
                "atheist",
                "atom symbol"
            ],
            u: "269b-fe0f",
            a: "1"
        },
        {
            n: [
                "om",
                "hindu",
                "religion"
            ],
            u: "1f549-fe0f",
            a: "0.7"
        },
        {
            n: [
                "jew",
                "star",
                "david",
                "jewish",
                "religion",
                "star of David",
                "star of david"
            ],
            u: "2721-fe0f",
            a: "0.7"
        },
        {
            n: [
                "wheel",
                "dharma",
                "buddhist",
                "religion",
                "wheel of dharma"
            ],
            u: "2638-fe0f",
            a: "0.7"
        },
        {
            n: [
                "tao",
                "yin",
                "yang",
                "taoist",
                "yin yang",
                "religion"
            ],
            u: "262f-fe0f",
            a: "0.7"
        },
        {
            n: [
                "cross",
                "religion",
                "christian",
                "latin cross"
            ],
            u: "271d-fe0f",
            a: "0.7"
        },
        {
            n: [
                "cross",
                "religion",
                "christian",
                "orthodox cross"
            ],
            u: "2626-fe0f",
            a: "1"
        },
        {
            n: [
                "islam",
                "muslim",
                "religion",
                "star and crescent"
            ],
            u: "262a-fe0f",
            a: "0.7"
        },
        {
            n: [
                "peace",
                "peace symbol"
            ],
            u: "262e-fe0f",
            a: "1"
        },
        {
            n: [
                "menorah",
                "religion",
                "candelabrum",
                "candlestick"
            ],
            u: "1f54e",
            a: "1"
        },
        {
            n: [
                "star",
                "fortune",
                "dotted six pointed star"
            ],
            u: "1f52f",
            a: "0.6"
        },
        {
            n: [
                "sikh",
                "khanda",
                "religion"
            ],
            u: "1faaf",
            a: "15"
        },
        {
            n: [
                "ram",
                "Aries",
                "aries",
                "zodiac"
            ],
            u: "2648",
            a: "0.6"
        },
        {
            n: [
                "ox",
                "bull",
                "Taurus",
                "taurus",
                "zodiac"
            ],
            u: "2649",
            a: "0.6"
        },
        {
            n: [
                "twins",
                "Gemini",
                "gemini",
                "zodiac"
            ],
            u: "264a",
            a: "0.6"
        },
        {
            n: [
                "crab",
                "Cancer",
                "cancer",
                "zodiac"
            ],
            u: "264b",
            a: "0.6"
        },
        {
            n: [
                "Leo",
                "leo",
                "lion",
                "zodiac"
            ],
            u: "264c",
            a: "0.6"
        },
        {
            n: [
                "Virgo",
                "virgo",
                "zodiac"
            ],
            u: "264d",
            a: "0.6"
        },
        {
            n: [
                "Libra",
                "libra",
                "scales",
                "zodiac",
                "balance",
                "justice"
            ],
            u: "264e",
            a: "0.6"
        },
        {
            n: [
                "zodiac",
                "Scorpio",
                "scorpio",
                "scorpion",
                "scorpius"
            ],
            u: "264f",
            a: "0.6"
        },
        {
            n: [
                "archer",
                "zodiac",
                "Sagittarius",
                "sagittarius"
            ],
            u: "2650",
            a: "0.6"
        },
        {
            n: [
                "goat",
                "zodiac",
                "Capricorn",
                "capricorn"
            ],
            u: "2651",
            a: "0.6"
        },
        {
            n: [
                "water",
                "bearer",
                "zodiac",
                "Aquarius",
                "aquarius"
            ],
            u: "2652",
            a: "0.6"
        },
        {
            n: [
                "fish",
                "Pisces",
                "pisces",
                "zodiac"
            ],
            u: "2653",
            a: "0.6"
        },
        {
            n: [
                "snake",
                "bearer",
                "zodiac",
                "serpent",
                "Ophiuchus",
                "ophiuchus"
            ],
            u: "26ce",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "crossed",
                "shuffle tracks button"
            ],
            u: "1f500",
            a: "1"
        },
        {
            n: [
                "arrow",
                "repeat",
                "clockwise",
                "repeat button"
            ],
            u: "1f501",
            a: "1"
        },
        {
            n: [
                "once",
                "arrow",
                "clockwise",
                "repeat single button"
            ],
            u: "1f502",
            a: "1"
        },
        {
            n: [
                "play",
                "arrow",
                "right",
                "triangle",
                "play button"
            ],
            u: "25b6-fe0f",
            a: "0.6"
        },
        {
            n: [
                "fast",
                "arrow",
                "double",
                "forward",
                "fast forward button"
            ],
            u: "23e9",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "triangle",
                "next scene",
                "next track",
                "next track button"
            ],
            u: "23ed-fe0f",
            a: "0.7"
        },
        {
            n: [
                "play",
                "arrow",
                "pause",
                "right",
                "triangle",
                "play or pause button"
            ],
            u: "23ef-fe0f",
            a: "1"
        },
        {
            n: [
                "left",
                "arrow",
                "reverse",
                "triangle",
                "reverse button"
            ],
            u: "25c0-fe0f",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "double",
                "rewind",
                "fast reverse button"
            ],
            u: "23ea",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "triangle",
                "previous scene",
                "previous track",
                "last track button"
            ],
            u: "23ee-fe0f",
            a: "0.7"
        },
        {
            n: [
                "arrow",
                "button",
                "upwards button"
            ],
            u: "1f53c",
            a: "0.6"
        },
        {
            n: [
                "arrow",
                "double",
                "fast up button"
            ],
            u: "23eb",
            a: "0.6"
        },
        {
            n: [
                "down",
                "arrow",
                "button",
                "downwards button"
            ],
            u: "1f53d",
            a: "0.6"
        },
        {
            n: [
                "down",
                "arrow",
                "double",
                "fast down button"
            ],
            u: "23ec",
            a: "0.6"
        },
        {
            n: [
                "bar",
                "pause",
                "double",
                "vertical",
                "pause button"
            ],
            u: "23f8-fe0f",
            a: "0.7"
        },
        {
            n: [
                "stop",
                "square",
                "stop button"
            ],
            u: "23f9-fe0f",
            a: "0.7"
        },
        {
            n: [
                "circle",
                "record",
                "record button"
            ],
            u: "23fa-fe0f",
            a: "0.7"
        },
        {
            n: [
                "eject",
                "eject button"
            ],
            u: "23cf-fe0f",
            a: "1"
        },
        {
            n: [
                "film",
                "movie",
                "cinema",
                "camera"
            ],
            u: "1f3a6",
            a: "0.6"
        },
        {
            n: [
                "dim",
                "low",
                "dim button",
                "brightness"
            ],
            u: "1f505",
            a: "1"
        },
        {
            n: [
                "bright",
                "brightness",
                "bright button"
            ],
            u: "1f506",
            a: "1"
        },
        {
            n: [
                "bar",
                "cell",
                "phone",
                "mobile",
                "antenna",
                "antenna bars"
            ],
            u: "1f4f6",
            a: "0.6"
        },
        {
            n: [
                "wifi",
                "wi fi",
                "network",
                "wireless",
                "computer",
                "internet"
            ],
            u: "1f6dc",
            a: "15"
        },
        {
            n: [
                "cell",
                "mode",
                "phone",
                "mobile",
                "telephone",
                "vibration",
                "vibration mode"
            ],
            u: "1f4f3",
            a: "0.6"
        },
        {
            n: [
                "off",
                "cell",
                "phone",
                "mobile",
                "telephone",
                "mobile phone off"
            ],
            u: "1f4f4",
            a: "0.6"
        },
        {
            n: [
                "woman",
                "female sign"
            ],
            u: "2640-fe0f",
            a: "4"
        },
        {
            n: [
                "man",
                "male sign"
            ],
            u: "2642-fe0f",
            a: "4"
        },
        {
            n: [
                "transgender",
                "transgender symbol"
            ],
            u: "26a7-fe0f",
            a: "13"
        },
        {
            n: [
                "x",
                "\xd7",
                "sign",
                "cancel",
                "multiply",
                "multiplication"
            ],
            u: "2716-fe0f",
            a: "0.6"
        },
        {
            n: [
                "+",
                "plus",
                "math",
                "sign"
            ],
            u: "2795",
            a: "0.6"
        },
        {
            n: [
                " ",
                "\u2212",
                "math",
                "sign",
                "minus"
            ],
            u: "2796",
            a: "0.6"
        },
        {
            n: [
                "\xf7",
                "math",
                "sign",
                "divide",
                "division"
            ],
            u: "2797",
            a: "0.6"
        },
        {
            n: [
                "math",
                "equality",
                "heavy equals sign"
            ],
            u: "1f7f0",
            a: "14"
        },
        {
            n: [
                "forever",
                "infinity",
                "unbounded",
                "universal"
            ],
            u: "267e-fe0f",
            a: "11"
        },
        {
            n: [
                "!",
                "!!",
                "mark",
                "bangbang",
                "exclamation",
                "double exclamation mark"
            ],
            u: "203c-fe0f",
            a: "0.6"
        },
        {
            n: [
                "!",
                "?",
                "!?",
                "mark",
                "question",
                "exclamation",
                "interrobang",
                "punctuation",
                "exclamation question mark"
            ],
            u: "2049-fe0f",
            a: "0.6"
        },
        {
            n: [
                "?",
                "mark",
                "question",
                "punctuation",
                "red question mark"
            ],
            u: "2753",
            a: "0.6"
        },
        {
            n: [
                "?",
                "mark",
                "outlined",
                "question",
                "punctuation",
                "white question mark"
            ],
            u: "2754",
            a: "0.6"
        },
        {
            n: [
                "!",
                "mark",
                "outlined",
                "exclamation",
                "punctuation",
                "white exclamation mark"
            ],
            u: "2755",
            a: "0.6"
        },
        {
            n: [
                "!",
                "mark",
                "exclamation",
                "punctuation",
                "red exclamation mark"
            ],
            u: "2757",
            a: "0.6"
        },
        {
            n: [
                "dash",
                "wavy",
                "wavy dash",
                "punctuation"
            ],
            u: "3030-fe0f",
            a: "0.6"
        },
        {
            n: [
                "bank",
                "money",
                "currency",
                "exchange",
                "currency exchange"
            ],
            u: "1f4b1",
            a: "0.6"
        },
        {
            n: [
                "money",
                "dollar",
                "currency",
                "heavy dollar sign"
            ],
            u: "1f4b2",
            a: "0.6"
        },
        {
            n: [
                "staff",
                "medicine",
                "aesculapius",
                "medical symbol"
            ],
            u: "2695-fe0f",
            a: "4"
        },
        {
            n: [
                "recycle",
                "recycling symbol"
            ],
            u: "267b-fe0f",
            a: "0.6"
        },
        {
            n: [
                "fleur de lis"
            ],
            u: "269c-fe0f",
            a: "1"
        },
        {
            n: [
                "ship",
                "tool",
                "anchor",
                "emblem",
                "trident",
                "trident emblem"
            ],
            u: "1f531",
            a: "0.6"
        },
        {
            n: [
                "name",
                "badge",
                "name badge"
            ],
            u: "1f4db",
            a: "0.6"
        },
        {
            n: [
                "leaf",
                "chevron",
                "beginner",
                "japanese",
                "Japanese symbol for beginner",
                "japanese symbol for beginner"
            ],
            u: "1f530",
            a: "0.6"
        },
        {
            n: [
                "o",
                "red",
                "large",
                "circle",
                "hollow red circle"
            ],
            u: "2b55",
            a: "0.6"
        },
        {
            n: [
                "\u2713",
                "mark",
                "check",
                "button",
                "check mark button"
            ],
            u: "2705",
            a: "0.6"
        },
        {
            n: [
                "\u2713",
                "box",
                "check",
                "check box with check"
            ],
            u: "2611-fe0f",
            a: "0.6"
        },
        {
            n: [
                "\u2713",
                "mark",
                "check",
                "check mark"
            ],
            u: "2714-fe0f",
            a: "0.6"
        },
        {
            n: [
                "x",
                "\xd7",
                "mark",
                "cross",
                "cancel",
                "multiply",
                "cross mark",
                "multiplication"
            ],
            u: "274c",
            a: "0.6"
        },
        {
            n: [
                "x",
                "\xd7",
                "mark",
                "square",
                "cross mark button"
            ],
            u: "274e",
            a: "0.6"
        },
        {
            n: [
                "curl",
                "loop",
                "curly loop"
            ],
            u: "27b0",
            a: "0.6"
        },
        {
            n: [
                "curl",
                "loop",
                "double",
                "double curly loop"
            ],
            u: "27bf",
            a: "1"
        },
        {
            n: [
                "mark",
                "part",
                "part alternation mark"
            ],
            u: "303d-fe0f",
            a: "0.6"
        },
        {
            n: [
                "*",
                "asterisk",
                "eight spoked asterisk"
            ],
            u: "2733-fe0f",
            a: "0.6"
        },
        {
            n: [
                "*",
                "star",
                "eight pointed star"
            ],
            u: "2734-fe0f",
            a: "0.6"
        },
        {
            n: [
                "*",
                "sparkle"
            ],
            u: "2747-fe0f",
            a: "0.6"
        },
        {
            n: [
                "c",
                "copyright"
            ],
            u: "00a9-fe0f",
            a: "0.6"
        },
        {
            n: [
                "r",
                "registered"
            ],
            u: "00ae-fe0f",
            a: "0.6"
        },
        {
            n: [
                "tm",
                "mark",
                "trademark",
                "trade mark"
            ],
            u: "2122-fe0f",
            a: "0.6"
        },
        {
            n: [
                "keycap",
                "keycap: #"
            ],
            u: "0023-fe0f-20e3",
            a: "0.6"
        },
        {
            n: [
                "keycap",
                "keycap: *"
            ],
            u: "002a-fe0f-20e3",
            a: "2"
        },
        {
            n: [
                "keycap",
                "keycap: 0"
            ],
            u: "0030-fe0f-20e3",
            a: "0.6"
        },
        {
            n: [
                "keycap",
                "keycap: 1"
            ],
            u: "0031-fe0f-20e3",
            a: "0.6"
        },
        {
            n: [
                "keycap",
                "keycap: 2"
            ],
            u: "0032-fe0f-20e3",
            a: "0.6"
        },
        {
            n: [
                "keycap",
                "keycap: 3"
            ],
            u: "0033-fe0f-20e3",
            a: "0.6"
        },
        {
            n: [
                "keycap",
                "keycap: 4"
            ],
            u: "0034-fe0f-20e3",
            a: "0.6"
        },
        {
            n: [
                "keycap",
                "keycap: 5"
            ],
            u: "0035-fe0f-20e3",
            a: "0.6"
        },
        {
            n: [
                "keycap",
                "keycap: 6"
            ],
            u: "0036-fe0f-20e3",
            a: "0.6"
        },
        {
            n: [
                "keycap",
                "keycap: 7"
            ],
            u: "0037-fe0f-20e3",
            a: "0.6"
        },
        {
            n: [
                "keycap",
                "keycap: 8"
            ],
            u: "0038-fe0f-20e3",
            a: "0.6"
        },
        {
            n: [
                "keycap",
                "keycap: 9"
            ],
            u: "0039-fe0f-20e3",
            a: "0.6"
        },
        {
            n: [
                "keycap",
                "keycap: 10"
            ],
            u: "1f51f",
            a: "0.6"
        },
        {
            n: [
                "abcd",
                "input",
                "latin",
                "letters",
                "uppercase",
                "input latin uppercase"
            ],
            u: "1f520",
            a: "0.6"
        },
        {
            n: [
                "abcd",
                "input",
                "latin",
                "letters",
                "lowercase",
                "input latin lowercase"
            ],
            u: "1f521",
            a: "0.6"
        },
        {
            n: [
                "1234",
                "input",
                "numbers",
                "input numbers"
            ],
            u: "1f522",
            a: "0.6"
        },
        {
            n: [
                "\u3012\u266A&%",
                "input",
                "input symbols"
            ],
            u: "1f523",
            a: "0.6"
        },
        {
            n: [
                "abc",
                "input",
                "latin",
                "letters",
                "alphabet",
                "input latin letters"
            ],
            u: "1f524",
            a: "0.6"
        },
        {
            n: [
                "a",
                "blood type",
                "A button (blood type)",
                "a button (blood type)"
            ],
            u: "1f170-fe0f",
            a: "0.6"
        },
        {
            n: [
                "ab",
                "blood type",
                "AB button (blood type)",
                "ab button (blood type)"
            ],
            u: "1f18e",
            a: "0.6"
        },
        {
            n: [
                "b",
                "blood type",
                "B button (blood type)",
                "b button (blood type)"
            ],
            u: "1f171-fe0f",
            a: "0.6"
        },
        {
            n: [
                "cl",
                "CL button",
                "cl button"
            ],
            u: "1f191",
            a: "0.6"
        },
        {
            n: [
                "cool",
                "COOL button",
                "cool button"
            ],
            u: "1f192",
            a: "0.6"
        },
        {
            n: [
                "free",
                "FREE button",
                "free button"
            ],
            u: "1f193",
            a: "0.6"
        },
        {
            n: [
                "i",
                "information"
            ],
            u: "2139-fe0f",
            a: "0.6"
        },
        {
            n: [
                "id",
                "identity",
                "ID button",
                "id button"
            ],
            u: "1f194",
            a: "0.6"
        },
        {
            n: [
                "m",
                "circle",
                "circled M",
                "circled m"
            ],
            u: "24c2-fe0f",
            a: "0.6"
        },
        {
            n: [
                "new",
                "NEW button",
                "new button"
            ],
            u: "1f195",
            a: "0.6"
        },
        {
            n: [
                "ng",
                "NG button",
                "ng button"
            ],
            u: "1f196",
            a: "0.6"
        },
        {
            n: [
                "o",
                "blood type",
                "O button (blood type)",
                "o button (blood type)"
            ],
            u: "1f17e-fe0f",
            a: "0.6"
        },
        {
            n: [
                "ok",
                "OK button",
                "ok button"
            ],
            u: "1f197",
            a: "0.6"
        },
        {
            n: [
                "p",
                "parking",
                "P button",
                "p button"
            ],
            u: "1f17f-fe0f",
            a: "0.6"
        },
        {
            n: [
                "sos",
                "help",
                "SOS button",
                "sos button"
            ],
            u: "1f198",
            a: "0.6"
        },
        {
            n: [
                "up",
                "up!",
                "mark",
                "UP! button",
                "up! button"
            ],
            u: "1f199",
            a: "0.6"
        },
        {
            n: [
                "vs",
                "versus",
                "VS button",
                "vs button"
            ],
            u: "1f19a",
            a: "0.6"
        },
        {
            n: [
                "\u30B3\u30B3",
                "\u201Chere\u201D",
                "japanese",
                "katakana",
                "Japanese \u201Chere\u201D button",
                "japanese \u201Chere\u201D button"
            ],
            u: "1f201",
            a: "0.6"
        },
        {
            n: [
                "\u30B5",
                "japanese",
                "katakana",
                "\u201Cservice charge\u201D",
                "Japanese \u201Cservice charge\u201D button",
                "japanese \u201Cservice charge\u201D button"
            ],
            u: "1f202-fe0f",
            a: "0.6"
        },
        {
            n: [
                "\u6708",
                "japanese",
                "ideograph",
                "\u201Cmonthly amount\u201D",
                "Japanese \u201Cmonthly amount\u201D button",
                "japanese \u201Cmonthly amount\u201D button"
            ],
            u: "1f237-fe0f",
            a: "0.6"
        },
        {
            n: [
                "\u6709",
                "japanese",
                "ideograph",
                "\u201Cnot free of charge\u201D",
                "Japanese \u201Cnot free of charge\u201D button",
                "japanese \u201Cnot free of charge\u201D button"
            ],
            u: "1f236",
            a: "0.6"
        },
        {
            n: [
                "\u6307",
                "japanese",
                "ideograph",
                "\u201Creserved\u201D",
                "Japanese \u201Creserved\u201D button",
                "japanese \u201Creserved\u201D button"
            ],
            u: "1f22f",
            a: "0.6"
        },
        {
            n: [
                "\u5F97",
                "japanese",
                "ideograph",
                "\u201Cbargain\u201D",
                "Japanese \u201Cbargain\u201D button",
                "japanese \u201Cbargain\u201D button"
            ],
            u: "1f250",
            a: "0.6"
        },
        {
            n: [
                "\u5272",
                "japanese",
                "ideograph",
                "\u201Cdiscount\u201D",
                "Japanese \u201Cdiscount\u201D button",
                "japanese \u201Cdiscount\u201D button"
            ],
            u: "1f239",
            a: "0.6"
        },
        {
            n: [
                "\u7121",
                "japanese",
                "ideograph",
                "\u201Cfree of charge\u201D",
                "Japanese \u201Cfree of charge\u201D button",
                "japanese \u201Cfree of charge\u201D button"
            ],
            u: "1f21a",
            a: "0.6"
        },
        {
            n: [
                "\u7981",
                "japanese",
                "ideograph",
                "\u201Cprohibited\u201D",
                "Japanese \u201Cprohibited\u201D button",
                "japanese \u201Cprohibited\u201D button"
            ],
            u: "1f232",
            a: "0.6"
        },
        {
            n: [
                "\u53EF",
                "japanese",
                "ideograph",
                "\u201Cacceptable\u201D",
                "Japanese \u201Cacceptable\u201D button",
                "japanese \u201Cacceptable\u201D button"
            ],
            u: "1f251",
            a: "0.6"
        },
        {
            n: [
                "\u7533",
                "japanese",
                "ideograph",
                "\u201Capplication\u201D",
                "Japanese \u201Capplication\u201D button",
                "japanese \u201Capplication\u201D button"
            ],
            u: "1f238",
            a: "0.6"
        },
        {
            n: [
                "\u5408",
                "japanese",
                "ideograph",
                "\u201Cpassing grade\u201D",
                "Japanese \u201Cpassing grade\u201D button",
                "japanese \u201Cpassing grade\u201D button"
            ],
            u: "1f234",
            a: "0.6"
        },
        {
            n: [
                "\u7A7A",
                "japanese",
                "ideograph",
                "\u201Cvacancy\u201D",
                "Japanese \u201Cvacancy\u201D button",
                "japanese \u201Cvacancy\u201D button"
            ],
            u: "1f233",
            a: "0.6"
        },
        {
            n: [
                "\u795D",
                "japanese",
                "ideograph",
                "\u201Ccongratulations\u201D",
                "Japanese \u201Ccongratulations\u201D button",
                "japanese \u201Ccongratulations\u201D button"
            ],
            u: "3297-fe0f",
            a: "0.6"
        },
        {
            n: [
                "\u79D8",
                "japanese",
                "\u201Csecret\u201D",
                "ideograph",
                "Japanese \u201Csecret\u201D button",
                "japanese \u201Csecret\u201D button"
            ],
            u: "3299-fe0f",
            a: "0.6"
        },
        {
            n: [
                "\u55B6",
                "japanese",
                "ideograph",
                "\u201Copen for business\u201D",
                "Japanese \u201Copen for business\u201D button",
                "japanese \u201Copen for business\u201D button"
            ],
            u: "1f23a",
            a: "0.6"
        },
        {
            n: [
                "\u6E80",
                "japanese",
                "ideograph",
                "\u201Cno vacancy\u201D",
                "Japanese \u201Cno vacancy\u201D button",
                "japanese \u201Cno vacancy\u201D button"
            ],
            u: "1f235",
            a: "0.6"
        },
        {
            n: [
                "red",
                "circle",
                "geometric",
                "red circle"
            ],
            u: "1f534",
            a: "0.6"
        },
        {
            n: [
                "circle",
                "orange",
                "orange circle"
            ],
            u: "1f7e0",
            a: "12"
        },
        {
            n: [
                "circle",
                "yellow",
                "yellow circle"
            ],
            u: "1f7e1",
            a: "12"
        },
        {
            n: [
                "green",
                "circle",
                "green circle"
            ],
            u: "1f7e2",
            a: "12"
        },
        {
            n: [
                "blue",
                "circle",
                "geometric",
                "blue circle"
            ],
            u: "1f535",
            a: "0.6"
        },
        {
            n: [
                "circle",
                "purple",
                "purple circle"
            ],
            u: "1f7e3",
            a: "12"
        },
        {
            n: [
                "brown",
                "circle",
                "brown circle"
            ],
            u: "1f7e4",
            a: "12"
        },
        {
            n: [
                "circle",
                "geometric",
                "black circle"
            ],
            u: "26ab",
            a: "0.6"
        },
        {
            n: [
                "circle",
                "geometric",
                "white circle"
            ],
            u: "26aa",
            a: "0.6"
        },
        {
            n: [
                "red",
                "square",
                "red square"
            ],
            u: "1f7e5",
            a: "12"
        },
        {
            n: [
                "orange",
                "square",
                "orange square"
            ],
            u: "1f7e7",
            a: "12"
        },
        {
            n: [
                "square",
                "yellow",
                "yellow square"
            ],
            u: "1f7e8",
            a: "12"
        },
        {
            n: [
                "green",
                "square",
                "green square"
            ],
            u: "1f7e9",
            a: "12"
        },
        {
            n: [
                "blue",
                "square",
                "blue square"
            ],
            u: "1f7e6",
            a: "12"
        },
        {
            n: [
                "purple",
                "square",
                "purple square"
            ],
            u: "1f7ea",
            a: "12"
        },
        {
            n: [
                "brown",
                "square",
                "brown square"
            ],
            u: "1f7eb",
            a: "12"
        },
        {
            n: [
                "square",
                "geometric",
                "black large square"
            ],
            u: "2b1b",
            a: "0.6"
        },
        {
            n: [
                "square",
                "geometric",
                "white large square"
            ],
            u: "2b1c",
            a: "0.6"
        },
        {
            n: [
                "square",
                "geometric",
                "black medium square"
            ],
            u: "25fc-fe0f",
            a: "0.6"
        },
        {
            n: [
                "square",
                "geometric",
                "white medium square"
            ],
            u: "25fb-fe0f",
            a: "0.6"
        },
        {
            n: [
                "square",
                "geometric",
                "black medium small square"
            ],
            u: "25fe",
            a: "0.6"
        },
        {
            n: [
                "square",
                "geometric",
                "white medium small square"
            ],
            u: "25fd",
            a: "0.6"
        },
        {
            n: [
                "square",
                "geometric",
                "black small square"
            ],
            u: "25aa-fe0f",
            a: "0.6"
        },
        {
            n: [
                "square",
                "geometric",
                "white small square"
            ],
            u: "25ab-fe0f",
            a: "0.6"
        },
        {
            n: [
                "orange",
                "diamond",
                "geometric",
                "large orange diamond"
            ],
            u: "1f536",
            a: "0.6"
        },
        {
            n: [
                "blue",
                "diamond",
                "geometric",
                "large blue diamond"
            ],
            u: "1f537",
            a: "0.6"
        },
        {
            n: [
                "orange",
                "diamond",
                "geometric",
                "small orange diamond"
            ],
            u: "1f538",
            a: "0.6"
        },
        {
            n: [
                "blue",
                "diamond",
                "geometric",
                "small blue diamond"
            ],
            u: "1f539",
            a: "0.6"
        },
        {
            n: [
                "red",
                "geometric",
                "red triangle pointed up"
            ],
            u: "1f53a",
            a: "0.6"
        },
        {
            n: [
                "red",
                "down",
                "geometric",
                "red triangle pointed down"
            ],
            u: "1f53b",
            a: "0.6"
        },
        {
            n: [
                "comic",
                "inside",
                "diamond",
                "geometric",
                "diamond with a dot"
            ],
            u: "1f4a0",
            a: "0.6"
        },
        {
            n: [
                "radio",
                "button",
                "geometric",
                "radio button"
            ],
            u: "1f518",
            a: "0.6"
        },
        {
            n: [
                "button",
                "square",
                "outlined",
                "geometric",
                "white square button"
            ],
            u: "1f533",
            a: "0.6"
        },
        {
            n: [
                "button",
                "square",
                "geometric",
                "black square button"
            ],
            u: "1f532",
            a: "0.6"
        }
    ],
    flags: [
        {
            n: [
                "racing",
                "checkered",
                "chequered",
                "chequered flag"
            ],
            u: "1f3c1",
            a: "0.6"
        },
        {
            n: [
                "post",
                "triangular flag"
            ],
            u: "1f6a9",
            a: "0.6"
        },
        {
            n: [
                "cross",
                "crossed",
                "japanese",
                "celebration",
                "crossed flags"
            ],
            u: "1f38c",
            a: "0.6"
        },
        {
            n: [
                "waving",
                "black flag"
            ],
            u: "1f3f4",
            a: "1"
        },
        {
            n: [
                "waving",
                "white flag"
            ],
            u: "1f3f3-fe0f",
            a: "0.7"
        },
        {
            n: [
                "pride",
                "rainbow",
                "rainbow flag"
            ],
            u: "1f3f3-fe0f-200d-1f308",
            a: "4"
        },
        {
            n: [
                "flag",
                "pink",
                "white",
                "light blue",
                "transgender",
                "transgender flag"
            ],
            u: "1f3f3-fe0f-200d-26a7-fe0f",
            a: "13"
        },
        {
            n: [
                "pirate",
                "plunder",
                "treasure",
                "pirate flag",
                "jolly roger"
            ],
            u: "1f3f4-200d-2620-fe0f",
            a: "11"
        },
        {
            n: [
                "AC",
                "flag",
                "flag: Ascension Island",
                "flag: ascension island"
            ],
            u: "1f1e6-1f1e8",
            a: "2"
        },
        {
            n: [
                "AD",
                "flag",
                "flag: Andorra",
                "flag: andorra"
            ],
            u: "1f1e6-1f1e9",
            a: "2"
        },
        {
            n: [
                "AE",
                "flag",
                "flag: United Arab Emirates",
                "flag: united arab emirates"
            ],
            u: "1f1e6-1f1ea",
            a: "2"
        },
        {
            n: [
                "AF",
                "flag",
                "flag: Afghanistan",
                "flag: afghanistan"
            ],
            u: "1f1e6-1f1eb",
            a: "2"
        },
        {
            n: [
                "AG",
                "flag",
                "flag: Antigua & Barbuda",
                "flag: antigua & barbuda"
            ],
            u: "1f1e6-1f1ec",
            a: "2"
        },
        {
            n: [
                "AI",
                "flag",
                "flag: Anguilla",
                "flag: anguilla"
            ],
            u: "1f1e6-1f1ee",
            a: "2"
        },
        {
            n: [
                "AL",
                "flag",
                "flag: Albania",
                "flag: albania"
            ],
            u: "1f1e6-1f1f1",
            a: "2"
        },
        {
            n: [
                "AM",
                "flag",
                "flag: Armenia",
                "flag: armenia"
            ],
            u: "1f1e6-1f1f2",
            a: "2"
        },
        {
            n: [
                "AO",
                "flag",
                "flag: Angola",
                "flag: angola"
            ],
            u: "1f1e6-1f1f4",
            a: "2"
        },
        {
            n: [
                "AQ",
                "flag",
                "flag: Antarctica",
                "flag: antarctica"
            ],
            u: "1f1e6-1f1f6",
            a: "2"
        },
        {
            n: [
                "AR",
                "flag",
                "flag: Argentina",
                "flag: argentina"
            ],
            u: "1f1e6-1f1f7",
            a: "2"
        },
        {
            n: [
                "AS",
                "flag",
                "flag: American Samoa",
                "flag: american samoa"
            ],
            u: "1f1e6-1f1f8",
            a: "2"
        },
        {
            n: [
                "AT",
                "flag",
                "flag: Austria",
                "flag: austria"
            ],
            u: "1f1e6-1f1f9",
            a: "2"
        },
        {
            n: [
                "AU",
                "flag",
                "flag: Australia",
                "flag: australia"
            ],
            u: "1f1e6-1f1fa",
            a: "2"
        },
        {
            n: [
                "AW",
                "flag",
                "flag: Aruba",
                "flag: aruba"
            ],
            u: "1f1e6-1f1fc",
            a: "2"
        },
        {
            n: [
                "AX",
                "flag",
                "flag: \xc5land Islands",
                "flag: \xe5land islands"
            ],
            u: "1f1e6-1f1fd",
            a: "2"
        },
        {
            n: [
                "AZ",
                "flag",
                "flag: Azerbaijan",
                "flag: azerbaijan"
            ],
            u: "1f1e6-1f1ff",
            a: "2"
        },
        {
            n: [
                "BA",
                "flag",
                "flag: Bosnia & Herzegovina",
                "flag: bosnia & herzegovina"
            ],
            u: "1f1e7-1f1e6",
            a: "2"
        },
        {
            n: [
                "BB",
                "flag",
                "flag: Barbados",
                "flag: barbados"
            ],
            u: "1f1e7-1f1e7",
            a: "2"
        },
        {
            n: [
                "BD",
                "flag",
                "flag: Bangladesh",
                "flag: bangladesh"
            ],
            u: "1f1e7-1f1e9",
            a: "2"
        },
        {
            n: [
                "BE",
                "flag",
                "flag: Belgium",
                "flag: belgium"
            ],
            u: "1f1e7-1f1ea",
            a: "2"
        },
        {
            n: [
                "BF",
                "flag",
                "flag: Burkina Faso",
                "flag: burkina faso"
            ],
            u: "1f1e7-1f1eb",
            a: "2"
        },
        {
            n: [
                "BG",
                "flag",
                "flag: Bulgaria",
                "flag: bulgaria"
            ],
            u: "1f1e7-1f1ec",
            a: "2"
        },
        {
            n: [
                "BH",
                "flag",
                "flag: Bahrain",
                "flag: bahrain"
            ],
            u: "1f1e7-1f1ed",
            a: "2"
        },
        {
            n: [
                "BI",
                "flag",
                "flag: Burundi",
                "flag: burundi"
            ],
            u: "1f1e7-1f1ee",
            a: "2"
        },
        {
            n: [
                "BJ",
                "flag",
                "flag: Benin",
                "flag: benin"
            ],
            u: "1f1e7-1f1ef",
            a: "2"
        },
        {
            n: [
                "BL",
                "flag",
                "flag: St. Barth\xe9lemy",
                "flag: st. barth\xe9lemy"
            ],
            u: "1f1e7-1f1f1",
            a: "2"
        },
        {
            n: [
                "BM",
                "flag",
                "flag: Bermuda",
                "flag: bermuda"
            ],
            u: "1f1e7-1f1f2",
            a: "2"
        },
        {
            n: [
                "BN",
                "flag",
                "flag: Brunei",
                "flag: brunei"
            ],
            u: "1f1e7-1f1f3",
            a: "2"
        },
        {
            n: [
                "BO",
                "flag",
                "flag: Bolivia",
                "flag: bolivia"
            ],
            u: "1f1e7-1f1f4",
            a: "2"
        },
        {
            n: [
                "BQ",
                "flag",
                "flag: Caribbean Netherlands",
                "flag: caribbean netherlands"
            ],
            u: "1f1e7-1f1f6",
            a: "2"
        },
        {
            n: [
                "BR",
                "flag",
                "flag: Brazil",
                "flag: brazil"
            ],
            u: "1f1e7-1f1f7",
            a: "2"
        },
        {
            n: [
                "BS",
                "flag",
                "flag: Bahamas",
                "flag: bahamas"
            ],
            u: "1f1e7-1f1f8",
            a: "2"
        },
        {
            n: [
                "BT",
                "flag",
                "flag: Bhutan",
                "flag: bhutan"
            ],
            u: "1f1e7-1f1f9",
            a: "2"
        },
        {
            n: [
                "BV",
                "flag",
                "flag: Bouvet Island",
                "flag: bouvet island"
            ],
            u: "1f1e7-1f1fb",
            a: "2"
        },
        {
            n: [
                "BW",
                "flag",
                "flag: Botswana",
                "flag: botswana"
            ],
            u: "1f1e7-1f1fc",
            a: "2"
        },
        {
            n: [
                "BY",
                "flag",
                "flag: Belarus",
                "flag: belarus"
            ],
            u: "1f1e7-1f1fe",
            a: "2"
        },
        {
            n: [
                "BZ",
                "flag",
                "flag: Belize",
                "flag: belize"
            ],
            u: "1f1e7-1f1ff",
            a: "2"
        },
        {
            n: [
                "CA",
                "flag",
                "flag: Canada",
                "flag: canada"
            ],
            u: "1f1e8-1f1e6",
            a: "2"
        },
        {
            n: [
                "CC",
                "flag",
                "flag: Cocos (Keeling) Islands",
                "flag: cocos (keeling) islands"
            ],
            u: "1f1e8-1f1e8",
            a: "2"
        },
        {
            n: [
                "CD",
                "flag",
                "flag: Congo   Kinshasa",
                "flag: congo   kinshasa"
            ],
            u: "1f1e8-1f1e9",
            a: "2"
        },
        {
            n: [
                "CF",
                "flag",
                "flag: Central African Republic",
                "flag: central african republic"
            ],
            u: "1f1e8-1f1eb",
            a: "2"
        },
        {
            n: [
                "CG",
                "flag",
                "flag: Congo   Brazzaville",
                "flag: congo   brazzaville"
            ],
            u: "1f1e8-1f1ec",
            a: "2"
        },
        {
            n: [
                "CH",
                "flag",
                "flag: Switzerland",
                "flag: switzerland"
            ],
            u: "1f1e8-1f1ed",
            a: "2"
        },
        {
            n: [
                "CI",
                "flag",
                "flag: C\xf4te d\u2019Ivoire",
                "flag: c\xf4te d\u2019ivoire"
            ],
            u: "1f1e8-1f1ee",
            a: "2"
        },
        {
            n: [
                "CK",
                "flag",
                "flag: Cook Islands",
                "flag: cook islands"
            ],
            u: "1f1e8-1f1f0",
            a: "2"
        },
        {
            n: [
                "CL",
                "flag",
                "flag: Chile",
                "flag: chile"
            ],
            u: "1f1e8-1f1f1",
            a: "2"
        },
        {
            n: [
                "CM",
                "flag",
                "flag: Cameroon",
                "flag: cameroon"
            ],
            u: "1f1e8-1f1f2",
            a: "2"
        },
        {
            n: [
                "CN",
                "flag",
                "flag: China",
                "flag: china"
            ],
            u: "1f1e8-1f1f3",
            a: "0.6"
        },
        {
            n: [
                "CO",
                "flag",
                "flag: Colombia",
                "flag: colombia"
            ],
            u: "1f1e8-1f1f4",
            a: "2"
        },
        {
            n: [
                "CP",
                "flag",
                "flag: Clipperton Island",
                "flag: clipperton island"
            ],
            u: "1f1e8-1f1f5",
            a: "2"
        },
        {
            n: [
                "CR",
                "flag",
                "flag: Costa Rica",
                "flag: costa rica"
            ],
            u: "1f1e8-1f1f7",
            a: "2"
        },
        {
            n: [
                "CU",
                "flag",
                "flag: Cuba",
                "flag: cuba"
            ],
            u: "1f1e8-1f1fa",
            a: "2"
        },
        {
            n: [
                "CV",
                "flag",
                "flag: Cape Verde",
                "flag: cape verde"
            ],
            u: "1f1e8-1f1fb",
            a: "2"
        },
        {
            n: [
                "CW",
                "flag",
                "flag: Cura\xe7ao",
                "flag: cura\xe7ao"
            ],
            u: "1f1e8-1f1fc",
            a: "2"
        },
        {
            n: [
                "CX",
                "flag",
                "flag: Christmas Island",
                "flag: christmas island"
            ],
            u: "1f1e8-1f1fd",
            a: "2"
        },
        {
            n: [
                "CY",
                "flag",
                "flag: Cyprus",
                "flag: cyprus"
            ],
            u: "1f1e8-1f1fe",
            a: "2"
        },
        {
            n: [
                "CZ",
                "flag",
                "flag: Czechia",
                "flag: czechia"
            ],
            u: "1f1e8-1f1ff",
            a: "2"
        },
        {
            n: [
                "DE",
                "flag",
                "flag: Germany",
                "flag: germany"
            ],
            u: "1f1e9-1f1ea",
            a: "0.6"
        },
        {
            n: [
                "DG",
                "flag",
                "flag: Diego Garcia",
                "flag: diego garcia"
            ],
            u: "1f1e9-1f1ec",
            a: "2"
        },
        {
            n: [
                "DJ",
                "flag",
                "flag: Djibouti",
                "flag: djibouti"
            ],
            u: "1f1e9-1f1ef",
            a: "2"
        },
        {
            n: [
                "DK",
                "flag",
                "flag: Denmark",
                "flag: denmark"
            ],
            u: "1f1e9-1f1f0",
            a: "2"
        },
        {
            n: [
                "DM",
                "flag",
                "flag: Dominica",
                "flag: dominica"
            ],
            u: "1f1e9-1f1f2",
            a: "2"
        },
        {
            n: [
                "DO",
                "flag",
                "flag: Dominican Republic",
                "flag: dominican republic"
            ],
            u: "1f1e9-1f1f4",
            a: "2"
        },
        {
            n: [
                "DZ",
                "flag",
                "flag: Algeria",
                "flag: algeria"
            ],
            u: "1f1e9-1f1ff",
            a: "2"
        },
        {
            n: [
                "EA",
                "flag",
                "flag: Ceuta & Melilla",
                "flag: ceuta & melilla"
            ],
            u: "1f1ea-1f1e6",
            a: "2"
        },
        {
            n: [
                "EC",
                "flag",
                "flag: Ecuador",
                "flag: ecuador"
            ],
            u: "1f1ea-1f1e8",
            a: "2"
        },
        {
            n: [
                "EE",
                "flag",
                "flag: Estonia",
                "flag: estonia"
            ],
            u: "1f1ea-1f1ea",
            a: "2"
        },
        {
            n: [
                "EG",
                "flag",
                "flag: Egypt",
                "flag: egypt"
            ],
            u: "1f1ea-1f1ec",
            a: "2"
        },
        {
            n: [
                "EH",
                "flag",
                "flag: Western Sahara",
                "flag: western sahara"
            ],
            u: "1f1ea-1f1ed",
            a: "2"
        },
        {
            n: [
                "ER",
                "flag",
                "flag: Eritrea",
                "flag: eritrea"
            ],
            u: "1f1ea-1f1f7",
            a: "2"
        },
        {
            n: [
                "ES",
                "flag",
                "flag: Spain",
                "flag: spain"
            ],
            u: "1f1ea-1f1f8",
            a: "0.6"
        },
        {
            n: [
                "ET",
                "flag",
                "flag: Ethiopia",
                "flag: ethiopia"
            ],
            u: "1f1ea-1f1f9",
            a: "2"
        },
        {
            n: [
                "EU",
                "flag",
                "flag: European Union",
                "flag: european union"
            ],
            u: "1f1ea-1f1fa",
            a: "2"
        },
        {
            n: [
                "FI",
                "flag",
                "flag: Finland",
                "flag: finland"
            ],
            u: "1f1eb-1f1ee",
            a: "2"
        },
        {
            n: [
                "FJ",
                "flag",
                "flag: Fiji",
                "flag: fiji"
            ],
            u: "1f1eb-1f1ef",
            a: "2"
        },
        {
            n: [
                "FK",
                "flag",
                "flag: Falkland Islands",
                "flag: falkland islands"
            ],
            u: "1f1eb-1f1f0",
            a: "2"
        },
        {
            n: [
                "FM",
                "flag",
                "flag: Micronesia",
                "flag: micronesia"
            ],
            u: "1f1eb-1f1f2",
            a: "2"
        },
        {
            n: [
                "FO",
                "flag",
                "flag: Faroe Islands",
                "flag: faroe islands"
            ],
            u: "1f1eb-1f1f4",
            a: "2"
        },
        {
            n: [
                "FR",
                "flag",
                "flag: France",
                "flag: france"
            ],
            u: "1f1eb-1f1f7",
            a: "0.6"
        },
        {
            n: [
                "GA",
                "flag",
                "flag: Gabon",
                "flag: gabon"
            ],
            u: "1f1ec-1f1e6",
            a: "2"
        },
        {
            n: [
                "GB",
                "flag",
                "flag: United Kingdom",
                "flag: united kingdom"
            ],
            u: "1f1ec-1f1e7",
            a: "0.6"
        },
        {
            n: [
                "GD",
                "flag",
                "flag: Grenada",
                "flag: grenada"
            ],
            u: "1f1ec-1f1e9",
            a: "2"
        },
        {
            n: [
                "GE",
                "flag",
                "flag: Georgia",
                "flag: georgia"
            ],
            u: "1f1ec-1f1ea",
            a: "2"
        },
        {
            n: [
                "GF",
                "flag",
                "flag: French Guiana",
                "flag: french guiana"
            ],
            u: "1f1ec-1f1eb",
            a: "2"
        },
        {
            n: [
                "GG",
                "flag",
                "flag: Guernsey",
                "flag: guernsey"
            ],
            u: "1f1ec-1f1ec",
            a: "2"
        },
        {
            n: [
                "GH",
                "flag",
                "flag: Ghana",
                "flag: ghana"
            ],
            u: "1f1ec-1f1ed",
            a: "2"
        },
        {
            n: [
                "GI",
                "flag",
                "flag: Gibraltar",
                "flag: gibraltar"
            ],
            u: "1f1ec-1f1ee",
            a: "2"
        },
        {
            n: [
                "GL",
                "flag",
                "flag: Greenland",
                "flag: greenland"
            ],
            u: "1f1ec-1f1f1",
            a: "2"
        },
        {
            n: [
                "GM",
                "flag",
                "flag: Gambia",
                "flag: gambia"
            ],
            u: "1f1ec-1f1f2",
            a: "2"
        },
        {
            n: [
                "GN",
                "flag",
                "flag: Guinea",
                "flag: guinea"
            ],
            u: "1f1ec-1f1f3",
            a: "2"
        },
        {
            n: [
                "GP",
                "flag",
                "flag: Guadeloupe",
                "flag: guadeloupe"
            ],
            u: "1f1ec-1f1f5",
            a: "2"
        },
        {
            n: [
                "GQ",
                "flag",
                "flag: Equatorial Guinea",
                "flag: equatorial guinea"
            ],
            u: "1f1ec-1f1f6",
            a: "2"
        },
        {
            n: [
                "GR",
                "flag",
                "flag: Greece",
                "flag: greece"
            ],
            u: "1f1ec-1f1f7",
            a: "2"
        },
        {
            n: [
                "GS",
                "flag",
                "flag: South Georgia & South Sandwich Islands",
                "flag: south georgia & south sandwich islands"
            ],
            u: "1f1ec-1f1f8",
            a: "2"
        },
        {
            n: [
                "GT",
                "flag",
                "flag: Guatemala",
                "flag: guatemala"
            ],
            u: "1f1ec-1f1f9",
            a: "2"
        },
        {
            n: [
                "GU",
                "flag",
                "flag: Guam",
                "flag: guam"
            ],
            u: "1f1ec-1f1fa",
            a: "2"
        },
        {
            n: [
                "GW",
                "flag",
                "flag: Guinea Bissau",
                "flag: guinea bissau"
            ],
            u: "1f1ec-1f1fc",
            a: "2"
        },
        {
            n: [
                "GY",
                "flag",
                "flag: Guyana",
                "flag: guyana"
            ],
            u: "1f1ec-1f1fe",
            a: "2"
        },
        {
            n: [
                "HK",
                "flag",
                "flag: Hong Kong SAR China",
                "flag: hong kong sar china"
            ],
            u: "1f1ed-1f1f0",
            a: "2"
        },
        {
            n: [
                "HM",
                "flag",
                "flag: Heard & McDonald Islands",
                "flag: heard & mcdonald islands"
            ],
            u: "1f1ed-1f1f2",
            a: "2"
        },
        {
            n: [
                "HN",
                "flag",
                "flag: Honduras",
                "flag: honduras"
            ],
            u: "1f1ed-1f1f3",
            a: "2"
        },
        {
            n: [
                "HR",
                "flag",
                "flag: Croatia",
                "flag: croatia"
            ],
            u: "1f1ed-1f1f7",
            a: "2"
        },
        {
            n: [
                "HT",
                "flag",
                "flag: Haiti",
                "flag: haiti"
            ],
            u: "1f1ed-1f1f9",
            a: "2"
        },
        {
            n: [
                "HU",
                "flag",
                "flag: Hungary",
                "flag: hungary"
            ],
            u: "1f1ed-1f1fa",
            a: "2"
        },
        {
            n: [
                "IC",
                "flag",
                "flag: Canary Islands",
                "flag: canary islands"
            ],
            u: "1f1ee-1f1e8",
            a: "2"
        },
        {
            n: [
                "ID",
                "flag",
                "flag: Indonesia",
                "flag: indonesia"
            ],
            u: "1f1ee-1f1e9",
            a: "2"
        },
        {
            n: [
                "IE",
                "flag",
                "flag: Ireland",
                "flag: ireland"
            ],
            u: "1f1ee-1f1ea",
            a: "2"
        },
        {
            n: [
                "IL",
                "flag",
                "flag: Israel",
                "flag: israel"
            ],
            u: "1f1ee-1f1f1",
            a: "2"
        },
        {
            n: [
                "IM",
                "flag",
                "flag: Isle of Man",
                "flag: isle of man"
            ],
            u: "1f1ee-1f1f2",
            a: "2"
        },
        {
            n: [
                "IN",
                "flag",
                "flag: India",
                "flag: india"
            ],
            u: "1f1ee-1f1f3",
            a: "2"
        },
        {
            n: [
                "IO",
                "flag",
                "flag: British Indian Ocean Territory",
                "flag: british indian ocean territory"
            ],
            u: "1f1ee-1f1f4",
            a: "2"
        },
        {
            n: [
                "IQ",
                "flag",
                "flag: Iraq",
                "flag: iraq"
            ],
            u: "1f1ee-1f1f6",
            a: "2"
        },
        {
            n: [
                "IR",
                "flag",
                "flag: Iran",
                "flag: iran"
            ],
            u: "1f1ee-1f1f7",
            a: "2"
        },
        {
            n: [
                "IS",
                "flag",
                "flag: Iceland",
                "flag: iceland"
            ],
            u: "1f1ee-1f1f8",
            a: "2"
        },
        {
            n: [
                "IT",
                "flag",
                "flag: Italy",
                "flag: italy"
            ],
            u: "1f1ee-1f1f9",
            a: "0.6"
        },
        {
            n: [
                "JE",
                "flag",
                "flag: Jersey",
                "flag: jersey"
            ],
            u: "1f1ef-1f1ea",
            a: "2"
        },
        {
            n: [
                "JM",
                "flag",
                "flag: Jamaica",
                "flag: jamaica"
            ],
            u: "1f1ef-1f1f2",
            a: "2"
        },
        {
            n: [
                "JO",
                "flag",
                "flag: Jordan",
                "flag: jordan"
            ],
            u: "1f1ef-1f1f4",
            a: "2"
        },
        {
            n: [
                "JP",
                "flag",
                "flag: Japan",
                "flag: japan"
            ],
            u: "1f1ef-1f1f5",
            a: "0.6"
        },
        {
            n: [
                "KE",
                "flag",
                "flag: Kenya",
                "flag: kenya"
            ],
            u: "1f1f0-1f1ea",
            a: "2"
        },
        {
            n: [
                "KG",
                "flag",
                "flag: Kyrgyzstan",
                "flag: kyrgyzstan"
            ],
            u: "1f1f0-1f1ec",
            a: "2"
        },
        {
            n: [
                "KH",
                "flag",
                "flag: Cambodia",
                "flag: cambodia"
            ],
            u: "1f1f0-1f1ed",
            a: "2"
        },
        {
            n: [
                "KI",
                "flag",
                "flag: Kiribati",
                "flag: kiribati"
            ],
            u: "1f1f0-1f1ee",
            a: "2"
        },
        {
            n: [
                "KM",
                "flag",
                "flag: Comoros",
                "flag: comoros"
            ],
            u: "1f1f0-1f1f2",
            a: "2"
        },
        {
            n: [
                "KN",
                "flag",
                "flag: St. Kitts & Nevis",
                "flag: st. kitts & nevis"
            ],
            u: "1f1f0-1f1f3",
            a: "2"
        },
        {
            n: [
                "KP",
                "flag",
                "flag: North Korea",
                "flag: north korea"
            ],
            u: "1f1f0-1f1f5",
            a: "2"
        },
        {
            n: [
                "KR",
                "flag",
                "flag: South Korea",
                "flag: south korea"
            ],
            u: "1f1f0-1f1f7",
            a: "0.6"
        },
        {
            n: [
                "KW",
                "flag",
                "flag: Kuwait",
                "flag: kuwait"
            ],
            u: "1f1f0-1f1fc",
            a: "2"
        },
        {
            n: [
                "KY",
                "flag",
                "flag: Cayman Islands",
                "flag: cayman islands"
            ],
            u: "1f1f0-1f1fe",
            a: "2"
        },
        {
            n: [
                "KZ",
                "flag",
                "flag: Kazakhstan",
                "flag: kazakhstan"
            ],
            u: "1f1f0-1f1ff",
            a: "2"
        },
        {
            n: [
                "LA",
                "flag",
                "flag: Laos",
                "flag: laos"
            ],
            u: "1f1f1-1f1e6",
            a: "2"
        },
        {
            n: [
                "LB",
                "flag",
                "flag: Lebanon",
                "flag: lebanon"
            ],
            u: "1f1f1-1f1e7",
            a: "2"
        },
        {
            n: [
                "LC",
                "flag",
                "flag: St. Lucia",
                "flag: st. lucia"
            ],
            u: "1f1f1-1f1e8",
            a: "2"
        },
        {
            n: [
                "LI",
                "flag",
                "flag: Liechtenstein",
                "flag: liechtenstein"
            ],
            u: "1f1f1-1f1ee",
            a: "2"
        },
        {
            n: [
                "LK",
                "flag",
                "flag: Sri Lanka",
                "flag: sri lanka"
            ],
            u: "1f1f1-1f1f0",
            a: "2"
        },
        {
            n: [
                "LR",
                "flag",
                "flag: Liberia",
                "flag: liberia"
            ],
            u: "1f1f1-1f1f7",
            a: "2"
        },
        {
            n: [
                "LS",
                "flag",
                "flag: Lesotho",
                "flag: lesotho"
            ],
            u: "1f1f1-1f1f8",
            a: "2"
        },
        {
            n: [
                "LT",
                "flag",
                "flag: Lithuania",
                "flag: lithuania"
            ],
            u: "1f1f1-1f1f9",
            a: "2"
        },
        {
            n: [
                "LU",
                "flag",
                "flag: Luxembourg",
                "flag: luxembourg"
            ],
            u: "1f1f1-1f1fa",
            a: "2"
        },
        {
            n: [
                "LV",
                "flag",
                "flag: Latvia",
                "flag: latvia"
            ],
            u: "1f1f1-1f1fb",
            a: "2"
        },
        {
            n: [
                "LY",
                "flag",
                "flag: Libya",
                "flag: libya"
            ],
            u: "1f1f1-1f1fe",
            a: "2"
        },
        {
            n: [
                "MA",
                "flag",
                "flag: Morocco",
                "flag: morocco"
            ],
            u: "1f1f2-1f1e6",
            a: "2"
        },
        {
            n: [
                "MC",
                "flag",
                "flag: Monaco",
                "flag: monaco"
            ],
            u: "1f1f2-1f1e8",
            a: "2"
        },
        {
            n: [
                "MD",
                "flag",
                "flag: Moldova",
                "flag: moldova"
            ],
            u: "1f1f2-1f1e9",
            a: "2"
        },
        {
            n: [
                "ME",
                "flag",
                "flag: Montenegro",
                "flag: montenegro"
            ],
            u: "1f1f2-1f1ea",
            a: "2"
        },
        {
            n: [
                "MF",
                "flag",
                "flag: St. Martin",
                "flag: st. martin"
            ],
            u: "1f1f2-1f1eb",
            a: "2"
        },
        {
            n: [
                "MG",
                "flag",
                "flag: Madagascar",
                "flag: madagascar"
            ],
            u: "1f1f2-1f1ec",
            a: "2"
        },
        {
            n: [
                "MH",
                "flag",
                "flag: Marshall Islands",
                "flag: marshall islands"
            ],
            u: "1f1f2-1f1ed",
            a: "2"
        },
        {
            n: [
                "MK",
                "flag",
                "flag: North Macedonia",
                "flag: north macedonia"
            ],
            u: "1f1f2-1f1f0",
            a: "2"
        },
        {
            n: [
                "ML",
                "flag",
                "flag: Mali",
                "flag: mali"
            ],
            u: "1f1f2-1f1f1",
            a: "2"
        },
        {
            n: [
                "MM",
                "flag",
                "flag: Myanmar (Burma)",
                "flag: myanmar (burma)"
            ],
            u: "1f1f2-1f1f2",
            a: "2"
        },
        {
            n: [
                "MN",
                "flag",
                "flag: Mongolia",
                "flag: mongolia"
            ],
            u: "1f1f2-1f1f3",
            a: "2"
        },
        {
            n: [
                "MO",
                "flag",
                "flag: Macao SAR China",
                "flag: macao sar china"
            ],
            u: "1f1f2-1f1f4",
            a: "2"
        },
        {
            n: [
                "MP",
                "flag",
                "flag: Northern Mariana Islands",
                "flag: northern mariana islands"
            ],
            u: "1f1f2-1f1f5",
            a: "2"
        },
        {
            n: [
                "MQ",
                "flag",
                "flag: Martinique",
                "flag: martinique"
            ],
            u: "1f1f2-1f1f6",
            a: "2"
        },
        {
            n: [
                "MR",
                "flag",
                "flag: Mauritania",
                "flag: mauritania"
            ],
            u: "1f1f2-1f1f7",
            a: "2"
        },
        {
            n: [
                "MS",
                "flag",
                "flag: Montserrat",
                "flag: montserrat"
            ],
            u: "1f1f2-1f1f8",
            a: "2"
        },
        {
            n: [
                "MT",
                "flag",
                "flag: Malta",
                "flag: malta"
            ],
            u: "1f1f2-1f1f9",
            a: "2"
        },
        {
            n: [
                "MU",
                "flag",
                "flag: Mauritius",
                "flag: mauritius"
            ],
            u: "1f1f2-1f1fa",
            a: "2"
        },
        {
            n: [
                "MV",
                "flag",
                "flag: Maldives",
                "flag: maldives"
            ],
            u: "1f1f2-1f1fb",
            a: "2"
        },
        {
            n: [
                "MW",
                "flag",
                "flag: Malawi",
                "flag: malawi"
            ],
            u: "1f1f2-1f1fc",
            a: "2"
        },
        {
            n: [
                "MX",
                "flag",
                "flag: Mexico",
                "flag: mexico"
            ],
            u: "1f1f2-1f1fd",
            a: "2"
        },
        {
            n: [
                "MY",
                "flag",
                "flag: Malaysia",
                "flag: malaysia"
            ],
            u: "1f1f2-1f1fe",
            a: "2"
        },
        {
            n: [
                "MZ",
                "flag",
                "flag: Mozambique",
                "flag: mozambique"
            ],
            u: "1f1f2-1f1ff",
            a: "2"
        },
        {
            n: [
                "NA",
                "flag",
                "flag: Namibia",
                "flag: namibia"
            ],
            u: "1f1f3-1f1e6",
            a: "2"
        },
        {
            n: [
                "NC",
                "flag",
                "flag: New Caledonia",
                "flag: new caledonia"
            ],
            u: "1f1f3-1f1e8",
            a: "2"
        },
        {
            n: [
                "NE",
                "flag",
                "flag: Niger",
                "flag: niger"
            ],
            u: "1f1f3-1f1ea",
            a: "2"
        },
        {
            n: [
                "NF",
                "flag",
                "flag: Norfolk Island",
                "flag: norfolk island"
            ],
            u: "1f1f3-1f1eb",
            a: "2"
        },
        {
            n: [
                "NG",
                "flag",
                "flag: Nigeria",
                "flag: nigeria"
            ],
            u: "1f1f3-1f1ec",
            a: "2"
        },
        {
            n: [
                "NI",
                "flag",
                "flag: Nicaragua",
                "flag: nicaragua"
            ],
            u: "1f1f3-1f1ee",
            a: "2"
        },
        {
            n: [
                "NL",
                "flag",
                "flag: Netherlands",
                "flag: netherlands"
            ],
            u: "1f1f3-1f1f1",
            a: "2"
        },
        {
            n: [
                "NO",
                "flag",
                "flag: Norway",
                "flag: norway"
            ],
            u: "1f1f3-1f1f4",
            a: "2"
        },
        {
            n: [
                "NP",
                "flag",
                "flag: Nepal",
                "flag: nepal"
            ],
            u: "1f1f3-1f1f5",
            a: "2"
        },
        {
            n: [
                "NR",
                "flag",
                "flag: Nauru",
                "flag: nauru"
            ],
            u: "1f1f3-1f1f7",
            a: "2"
        },
        {
            n: [
                "NU",
                "flag",
                "flag: Niue",
                "flag: niue"
            ],
            u: "1f1f3-1f1fa",
            a: "2"
        },
        {
            n: [
                "NZ",
                "flag",
                "flag: New Zealand",
                "flag: new zealand"
            ],
            u: "1f1f3-1f1ff",
            a: "2"
        },
        {
            n: [
                "OM",
                "flag",
                "flag: Oman",
                "flag: oman"
            ],
            u: "1f1f4-1f1f2",
            a: "2"
        },
        {
            n: [
                "PA",
                "flag",
                "flag: Panama",
                "flag: panama"
            ],
            u: "1f1f5-1f1e6",
            a: "2"
        },
        {
            n: [
                "PE",
                "flag",
                "flag: Peru",
                "flag: peru"
            ],
            u: "1f1f5-1f1ea",
            a: "2"
        },
        {
            n: [
                "PF",
                "flag",
                "flag: French Polynesia",
                "flag: french polynesia"
            ],
            u: "1f1f5-1f1eb",
            a: "2"
        },
        {
            n: [
                "PG",
                "flag",
                "flag: Papua New Guinea",
                "flag: papua new guinea"
            ],
            u: "1f1f5-1f1ec",
            a: "2"
        },
        {
            n: [
                "PH",
                "flag",
                "flag: Philippines",
                "flag: philippines"
            ],
            u: "1f1f5-1f1ed",
            a: "2"
        },
        {
            n: [
                "PK",
                "flag",
                "flag: Pakistan",
                "flag: pakistan"
            ],
            u: "1f1f5-1f1f0",
            a: "2"
        },
        {
            n: [
                "PL",
                "flag",
                "flag: Poland",
                "flag: poland"
            ],
            u: "1f1f5-1f1f1",
            a: "2"
        },
        {
            n: [
                "PM",
                "flag",
                "flag: St. Pierre & Miquelon",
                "flag: st. pierre & miquelon"
            ],
            u: "1f1f5-1f1f2",
            a: "2"
        },
        {
            n: [
                "PN",
                "flag",
                "flag: Pitcairn Islands",
                "flag: pitcairn islands"
            ],
            u: "1f1f5-1f1f3",
            a: "2"
        },
        {
            n: [
                "PR",
                "flag",
                "flag: Puerto Rico",
                "flag: puerto rico"
            ],
            u: "1f1f5-1f1f7",
            a: "2"
        },
        {
            n: [
                "PS",
                "flag",
                "flag: Palestinian Territories",
                "flag: palestinian territories"
            ],
            u: "1f1f5-1f1f8",
            a: "2"
        },
        {
            n: [
                "PT",
                "flag",
                "flag: Portugal",
                "flag: portugal"
            ],
            u: "1f1f5-1f1f9",
            a: "2"
        },
        {
            n: [
                "PW",
                "flag",
                "flag: Palau",
                "flag: palau"
            ],
            u: "1f1f5-1f1fc",
            a: "2"
        },
        {
            n: [
                "PY",
                "flag",
                "flag: Paraguay",
                "flag: paraguay"
            ],
            u: "1f1f5-1f1fe",
            a: "2"
        },
        {
            n: [
                "QA",
                "flag",
                "flag: Qatar",
                "flag: qatar"
            ],
            u: "1f1f6-1f1e6",
            a: "2"
        },
        {
            n: [
                "RE",
                "flag",
                "flag: R\xe9union",
                "flag: r\xe9union"
            ],
            u: "1f1f7-1f1ea",
            a: "2"
        },
        {
            n: [
                "RO",
                "flag",
                "flag: Romania",
                "flag: romania"
            ],
            u: "1f1f7-1f1f4",
            a: "2"
        },
        {
            n: [
                "RS",
                "flag",
                "flag: Serbia",
                "flag: serbia"
            ],
            u: "1f1f7-1f1f8",
            a: "2"
        },
        {
            n: [
                "RU",
                "flag",
                "flag: Russia",
                "flag: russia"
            ],
            u: "1f1f7-1f1fa",
            a: "0.6"
        },
        {
            n: [
                "RW",
                "flag",
                "flag: Rwanda",
                "flag: rwanda"
            ],
            u: "1f1f7-1f1fc",
            a: "2"
        },
        {
            n: [
                "SA",
                "flag",
                "flag: Saudi Arabia",
                "flag: saudi arabia"
            ],
            u: "1f1f8-1f1e6",
            a: "2"
        },
        {
            n: [
                "SB",
                "flag",
                "flag: Solomon Islands",
                "flag: solomon islands"
            ],
            u: "1f1f8-1f1e7",
            a: "2"
        },
        {
            n: [
                "SC",
                "flag",
                "flag: Seychelles",
                "flag: seychelles"
            ],
            u: "1f1f8-1f1e8",
            a: "2"
        },
        {
            n: [
                "SD",
                "flag",
                "flag: Sudan",
                "flag: sudan"
            ],
            u: "1f1f8-1f1e9",
            a: "2"
        },
        {
            n: [
                "SE",
                "flag",
                "flag: Sweden",
                "flag: sweden"
            ],
            u: "1f1f8-1f1ea",
            a: "2"
        },
        {
            n: [
                "SG",
                "flag",
                "flag: Singapore",
                "flag: singapore"
            ],
            u: "1f1f8-1f1ec",
            a: "2"
        },
        {
            n: [
                "SH",
                "flag",
                "flag: St. Helena",
                "flag: st. helena"
            ],
            u: "1f1f8-1f1ed",
            a: "2"
        },
        {
            n: [
                "SI",
                "flag",
                "flag: Slovenia",
                "flag: slovenia"
            ],
            u: "1f1f8-1f1ee",
            a: "2"
        },
        {
            n: [
                "SJ",
                "flag",
                "flag: Svalbard & Jan Mayen",
                "flag: svalbard & jan mayen"
            ],
            u: "1f1f8-1f1ef",
            a: "2"
        },
        {
            n: [
                "SK",
                "flag",
                "flag: Slovakia",
                "flag: slovakia"
            ],
            u: "1f1f8-1f1f0",
            a: "2"
        },
        {
            n: [
                "SL",
                "flag",
                "flag: Sierra Leone",
                "flag: sierra leone"
            ],
            u: "1f1f8-1f1f1",
            a: "2"
        },
        {
            n: [
                "SM",
                "flag",
                "flag: San Marino",
                "flag: san marino"
            ],
            u: "1f1f8-1f1f2",
            a: "2"
        },
        {
            n: [
                "SN",
                "flag",
                "flag: Senegal",
                "flag: senegal"
            ],
            u: "1f1f8-1f1f3",
            a: "2"
        },
        {
            n: [
                "SO",
                "flag",
                "flag: Somalia",
                "flag: somalia"
            ],
            u: "1f1f8-1f1f4",
            a: "2"
        },
        {
            n: [
                "SR",
                "flag",
                "flag: Suriname",
                "flag: suriname"
            ],
            u: "1f1f8-1f1f7",
            a: "2"
        },
        {
            n: [
                "SS",
                "flag",
                "flag: South Sudan",
                "flag: south sudan"
            ],
            u: "1f1f8-1f1f8",
            a: "2"
        },
        {
            n: [
                "ST",
                "flag",
                "flag: S\xe3o Tom\xe9 & Pr\xedncipe",
                "flag: s\xe3o tom\xe9 & pr\xedncipe"
            ],
            u: "1f1f8-1f1f9",
            a: "2"
        },
        {
            n: [
                "SV",
                "flag",
                "flag: El Salvador",
                "flag: el salvador"
            ],
            u: "1f1f8-1f1fb",
            a: "2"
        },
        {
            n: [
                "SX",
                "flag",
                "flag: Sint Maarten",
                "flag: sint maarten"
            ],
            u: "1f1f8-1f1fd",
            a: "2"
        },
        {
            n: [
                "SY",
                "flag",
                "flag: Syria",
                "flag: syria"
            ],
            u: "1f1f8-1f1fe",
            a: "2"
        },
        {
            n: [
                "SZ",
                "flag",
                "flag: Eswatini",
                "flag: eswatini"
            ],
            u: "1f1f8-1f1ff",
            a: "2"
        },
        {
            n: [
                "TA",
                "flag",
                "flag: Tristan da Cunha",
                "flag: tristan da cunha"
            ],
            u: "1f1f9-1f1e6",
            a: "2"
        },
        {
            n: [
                "TC",
                "flag",
                "flag: Turks & Caicos Islands",
                "flag: turks & caicos islands"
            ],
            u: "1f1f9-1f1e8",
            a: "2"
        },
        {
            n: [
                "TD",
                "flag",
                "flag: Chad",
                "flag: chad"
            ],
            u: "1f1f9-1f1e9",
            a: "2"
        },
        {
            n: [
                "TF",
                "flag",
                "flag: French Southern Territories",
                "flag: french southern territories"
            ],
            u: "1f1f9-1f1eb",
            a: "2"
        },
        {
            n: [
                "TG",
                "flag",
                "flag: Togo",
                "flag: togo"
            ],
            u: "1f1f9-1f1ec",
            a: "2"
        },
        {
            n: [
                "TH",
                "flag",
                "flag: Thailand",
                "flag: thailand"
            ],
            u: "1f1f9-1f1ed",
            a: "2"
        },
        {
            n: [
                "TJ",
                "flag",
                "flag: Tajikistan",
                "flag: tajikistan"
            ],
            u: "1f1f9-1f1ef",
            a: "2"
        },
        {
            n: [
                "TK",
                "flag",
                "flag: Tokelau",
                "flag: tokelau"
            ],
            u: "1f1f9-1f1f0",
            a: "2"
        },
        {
            n: [
                "TL",
                "flag",
                "flag: Timor Leste",
                "flag: timor leste"
            ],
            u: "1f1f9-1f1f1",
            a: "2"
        },
        {
            n: [
                "TM",
                "flag",
                "flag: Turkmenistan",
                "flag: turkmenistan"
            ],
            u: "1f1f9-1f1f2",
            a: "2"
        },
        {
            n: [
                "TN",
                "flag",
                "flag: Tunisia",
                "flag: tunisia"
            ],
            u: "1f1f9-1f1f3",
            a: "2"
        },
        {
            n: [
                "TO",
                "flag",
                "flag: Tonga",
                "flag: tonga"
            ],
            u: "1f1f9-1f1f4",
            a: "2"
        },
        {
            n: [
                "TR",
                "flag",
                "flag: T\xfcrkiye",
                "flag: t\xfcrkiye"
            ],
            u: "1f1f9-1f1f7",
            a: "2"
        },
        {
            n: [
                "TT",
                "flag",
                "flag: Trinidad & Tobago",
                "flag: trinidad & tobago"
            ],
            u: "1f1f9-1f1f9",
            a: "2"
        },
        {
            n: [
                "TV",
                "flag",
                "flag: Tuvalu",
                "flag: tuvalu"
            ],
            u: "1f1f9-1f1fb",
            a: "2"
        },
        {
            n: [
                "TW",
                "flag",
                "flag: Taiwan",
                "flag: taiwan"
            ],
            u: "1f1f9-1f1fc",
            a: "2"
        },
        {
            n: [
                "TZ",
                "flag",
                "flag: Tanzania",
                "flag: tanzania"
            ],
            u: "1f1f9-1f1ff",
            a: "2"
        },
        {
            n: [
                "UA",
                "flag",
                "flag: Ukraine",
                "flag: ukraine"
            ],
            u: "1f1fa-1f1e6",
            a: "2"
        },
        {
            n: [
                "UG",
                "flag",
                "flag: Uganda",
                "flag: uganda"
            ],
            u: "1f1fa-1f1ec",
            a: "2"
        },
        {
            n: [
                "UM",
                "flag",
                "flag: U.S. Outlying Islands",
                "flag: u.s. outlying islands"
            ],
            u: "1f1fa-1f1f2",
            a: "2"
        },
        {
            n: [
                "UN",
                "flag",
                "flag: United Nations",
                "flag: united nations"
            ],
            u: "1f1fa-1f1f3",
            a: "4"
        },
        {
            n: [
                "US",
                "flag",
                "flag: United States",
                "flag: united states"
            ],
            u: "1f1fa-1f1f8",
            a: "0.6"
        },
        {
            n: [
                "UY",
                "flag",
                "flag: Uruguay",
                "flag: uruguay"
            ],
            u: "1f1fa-1f1fe",
            a: "2"
        },
        {
            n: [
                "UZ",
                "flag",
                "flag: Uzbekistan",
                "flag: uzbekistan"
            ],
            u: "1f1fa-1f1ff",
            a: "2"
        },
        {
            n: [
                "VA",
                "flag",
                "flag: Vatican City",
                "flag: vatican city"
            ],
            u: "1f1fb-1f1e6",
            a: "2"
        },
        {
            n: [
                "VC",
                "flag",
                "flag: St. Vincent & Grenadines",
                "flag: st. vincent & grenadines"
            ],
            u: "1f1fb-1f1e8",
            a: "2"
        },
        {
            n: [
                "VE",
                "flag",
                "flag: Venezuela",
                "flag: venezuela"
            ],
            u: "1f1fb-1f1ea",
            a: "2"
        },
        {
            n: [
                "VG",
                "flag",
                "flag: British Virgin Islands",
                "flag: british virgin islands"
            ],
            u: "1f1fb-1f1ec",
            a: "2"
        },
        {
            n: [
                "VI",
                "flag",
                "flag: U.S. Virgin Islands",
                "flag: u.s. virgin islands"
            ],
            u: "1f1fb-1f1ee",
            a: "2"
        },
        {
            n: [
                "VN",
                "flag",
                "flag: Vietnam",
                "flag: vietnam"
            ],
            u: "1f1fb-1f1f3",
            a: "2"
        },
        {
            n: [
                "VU",
                "flag",
                "flag: Vanuatu",
                "flag: vanuatu"
            ],
            u: "1f1fb-1f1fa",
            a: "2"
        },
        {
            n: [
                "WF",
                "flag",
                "flag: Wallis & Futuna",
                "flag: wallis & futuna"
            ],
            u: "1f1fc-1f1eb",
            a: "2"
        },
        {
            n: [
                "WS",
                "flag",
                "flag: Samoa",
                "flag: samoa"
            ],
            u: "1f1fc-1f1f8",
            a: "2"
        },
        {
            n: [
                "XK",
                "flag",
                "flag: Kosovo",
                "flag: kosovo"
            ],
            u: "1f1fd-1f1f0",
            a: "2"
        },
        {
            n: [
                "YE",
                "flag",
                "flag: Yemen",
                "flag: yemen"
            ],
            u: "1f1fe-1f1ea",
            a: "2"
        },
        {
            n: [
                "YT",
                "flag",
                "flag: Mayotte",
                "flag: mayotte"
            ],
            u: "1f1fe-1f1f9",
            a: "2"
        },
        {
            n: [
                "ZA",
                "flag",
                "flag: South Africa",
                "flag: south africa"
            ],
            u: "1f1ff-1f1e6",
            a: "2"
        },
        {
            n: [
                "ZM",
                "flag",
                "flag: Zambia",
                "flag: zambia"
            ],
            u: "1f1ff-1f1f2",
            a: "2"
        },
        {
            n: [
                "ZW",
                "flag",
                "flag: Zimbabwe",
                "flag: zimbabwe"
            ],
            u: "1f1ff-1f1fc",
            a: "2"
        },
        {
            n: [
                "flag",
                "gbeng",
                "flag: England",
                "flag: england"
            ],
            u: "1f3f4-e0067-e0062-e0065-e006e-e0067-e007f",
            a: "5"
        },
        {
            n: [
                "flag",
                "gbsct",
                "flag: Scotland",
                "flag: scotland"
            ],
            u: "1f3f4-e0067-e0062-e0073-e0063-e0074-e007f",
            a: "5"
        },
        {
            n: [
                "flag",
                "gbwls",
                "flag: Wales",
                "flag: wales"
            ],
            u: "1f3f4-e0067-e0062-e0077-e006c-e0073-e007f",
            a: "5"
        }
    ]
};
var defaultEmojiData = {
    categories: categories,
    emojis: emojis
};
var SUGGESTED_LS_KEY = 'epr_suggested';
function getSuggested(mode) {
    try {
        var _window, _window$localStorage$, _window2;
        if (!((_window = window) != null && _window.localStorage)) return [];
        var recent = JSON.parse((_window$localStorage$ = (_window2 = window) == null ? void 0 : _window2.localStorage.getItem(SUGGESTED_LS_KEY)) != null ? _window$localStorage$ : '[]');
        if (mode === SuggestionMode.FREQUENT) return recent.sort(function(a, b) {
            return b.count - a.count;
        });
        return recent;
    } catch (_unused) {
        return [];
    }
}
function setSuggested(emoji, skinTone) {
    var recent = getSuggested();
    var unified = emojiUnified$1(emoji, skinTone);
    var originalUnified = emojiUnified$1(emoji);
    var existing = recent.find(function(_ref) {
        var u = _ref.unified;
        return u === unified;
    });
    var nextList;
    if (existing) nextList = [
        existing
    ].concat(recent.filter(function(i) {
        return i !== existing;
    }));
    else {
        existing = {
            unified: unified,
            original: originalUnified,
            count: 0
        };
        nextList = [
            existing
        ].concat(recent);
    }
    existing.count++;
    nextList.length = Math.min(nextList.length, 14);
    try {
        var _window3;
        (_window3 = window) == null || _window3.localStorage.setItem(SUGGESTED_LS_KEY, JSON.stringify(nextList));
    // Prevents the change from being seen immediately.
    } catch (_unused2) {
    // ignore
    }
}
function emojiNames$1(emoji) {
    var _emoji$EmojiPropertie;
    return (_emoji$EmojiPropertie = emoji[EmojiProperties.name]) != null ? _emoji$EmojiPropertie : [];
}
function emojiName$1(emoji) {
    if (!emoji) return '';
    var names = emojiNames$1(emoji);
    return names[names.length - 1];
}
function unifiedWithoutSkinTone$1(unified) {
    var splat = unified.split('-');
    var _splat$splice = splat.splice(1, 1), skinTone = _splat$splice[0];
    if (skinTonesMapped[skinTone]) return splat.join('-');
    return unified;
}
function emojiUnified$1(emoji, skinTone) {
    var _emojiVariationUnifie;
    var unified = emoji[EmojiProperties.unified];
    if (!skinTone || !emojiHasVariations$1(emoji)) return unified;
    return (_emojiVariationUnifie = emojiVariationUnified$1(emoji, skinTone)) != null ? _emojiVariationUnifie : unified;
}
function useGetEmojisByCategory() {
    var suggestedEmojisModeConfig = useSuggestedEmojisModeConfig();
    var _useUpdateSuggested = useUpdateSuggested(), suggestedUpdated = _useUpdateSuggested[0];
    var suggested = (0, _reactDefault.default).useMemo(function() {
        var _getSuggested;
        var suggested = (_getSuggested = getSuggested(suggestedEmojisModeConfig)) != null ? _getSuggested : [];
        return suggested.map(function(s) {
            return emojiByUnified(s.unified);
        }).filter(Boolean);
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        suggestedUpdated,
        suggestedEmojisModeConfig
    ]);
    return function getEmojisByCategory(category) {
        var _emojis$emojis$catego;
        if (category === Categories.SUGGESTED) return suggested;
        // @ts-ignore
        return (_emojis$emojis$catego = defaultEmojiData.emojis[category]) != null ? _emojis$emojis$catego : [];
    };
}
function emojiVariations$1(emoji) {
    var _emoji$EmojiPropertie2;
    return (_emoji$EmojiPropertie2 = emoji[EmojiProperties.variations]) != null ? _emoji$EmojiPropertie2 : [];
}
function emojiHasVariations$1(emoji) {
    return emojiVariations$1(emoji).length > 0;
}
function emojiVariationUnified$1(emoji, skinTone) {
    return skinTone ? emojiVariations$1(emoji).find(function(variation) {
        return variation.includes(skinTone);
    }) : emojiUnified$1(emoji);
}
function emojiByUnified(unified) {
    if (!unified) return;
    if (allEmojisByUnified[unified]) return allEmojisByUnified[unified];
    var withoutSkinTone = unifiedWithoutSkinTone$1(unified);
    return allEmojisByUnified[withoutSkinTone];
}
var allEmojis = /*#__PURE__*/ Object.values(defaultEmojiData.emojis).flat();
var allEmojisByUnified = {};
allEmojis.reduce(function(allEmojis, Emoji) {
    allEmojis[emojiUnified$1(Emoji)] = Emoji;
    if (emojiHasVariations$1(Emoji)) emojiVariations$1(Emoji).forEach(function(variation) {
        allEmojis[variation] = Emoji;
    });
    return allEmojis;
}, allEmojisByUnified);
function activeVariationFromUnified$1(unified) {
    var _unified$split = unified.split('-'), suspectedSkinTone = _unified$split[1];
    return skinToneVariations.includes(suspectedSkinTone) ? suspectedSkinTone : null;
}
var PickerDataContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({
    emojiData: {},
    allEmojis: [],
    allEmojisByUnified: {},
    searchIndex: {},
    emojiByUnified: emojiByUnified,
    activeVariationFromUnified: function activeVariationFromUnified() {
        return null;
    }
});
function PickerDataProvider(_ref) {
    var children = _ref.children;
    var _usePickerConfig = usePickerConfig(), customEmojis = _usePickerConfig.customEmojis, genericEmojiData = _usePickerConfig.emojiData;
    var data = (0, _reactDefault.default).useMemo(function() {
        var emojiData = genericEmojiData || defaultEmojiData;
        // Clone to avoid mutation of shared source
        var newData = JSON.parse(JSON.stringify(emojiData));
        if (customEmojis && customEmojis.length > 0) newData.emojis[Categories.CUSTOM] = customEmojis.map(customToRegularEmoji);
        var emojis = newData.emojis || {};
        var allEmojis = Object.values(emojis).flat();
        var allEmojisByUnified = {};
        var searchIndex = {};
        allEmojis.forEach(function(emoji) {
            var unified = emoji[EmojiProperties.unified];
            allEmojisByUnified[unified] = emoji;
            if (emoji[EmojiProperties.variations]) {
                var _emoji$Keys$variation;
                (_emoji$Keys$variation = emoji[EmojiProperties.variations]) == null || _emoji$Keys$variation.forEach(function(variation) {
                    allEmojisByUnified[variation] = emoji;
                });
            }
            // Index for search
            // Re-implement indexEmoji logic here to be local
            var joinedNameString = (emoji[EmojiProperties.name] || []).join('').toLowerCase().split('');
            joinedNameString.forEach(function(_char) {
                var _searchIndex$_char;
                searchIndex[_char] = (_searchIndex$_char = searchIndex[_char]) != null ? _searchIndex$_char : {};
                searchIndex[_char][unified] = emoji;
            });
        });
        return {
            emojiData: newData,
            allEmojis: allEmojis,
            allEmojisByUnified: allEmojisByUnified,
            searchIndex: searchIndex
        };
    }, [
        genericEmojiData,
        customEmojis
    ]);
    var emojiByUnified = (0, _reactDefault.default).useCallback(function(unified) {
        var _data$allEmojisByUnif;
        if (!unified) return undefined;
        var result = (_data$allEmojisByUnif = data.allEmojisByUnified[unified]) != null ? _data$allEmojisByUnif : data.allEmojisByUnified[unifiedWithoutSkinTone(unified)];
        return result;
    }, [
        data.allEmojisByUnified
    ]);
    return (0, _reactDefault.default).createElement(PickerDataContext.Provider, {
        value: _extends({}, data, {
            emojiByUnified: emojiByUnified,
            activeVariationFromUnified: activeVariationFromUnified
        })
    }, children);
}
function usePickerDataContext() {
    return (0, _reactDefault.default).useContext(PickerDataContext);
}
function useGetEmojisByCategory$1() {
    var _usePickerDataContext = usePickerDataContext(), emojiData = _usePickerDataContext.emojiData, emojiByUnified = _usePickerDataContext.emojiByUnified;
    var suggestedEmojisModeConfig = useSuggestedEmojisModeConfig();
    var _useUpdateSuggested = useUpdateSuggested(), suggestedUpdated = _useUpdateSuggested[0];
    var suggested = (0, _reactDefault.default).useMemo(function() {
        var _getSuggested;
        var suggested = (_getSuggested = getSuggested(suggestedEmojisModeConfig)) != null ? _getSuggested : [];
        return suggested.map(function(s) {
            var _extends2;
            var emoji = emojiByUnified(s.unified);
            if (!emoji) return undefined;
            return _extends({}, emoji, (_extends2 = {}, _extends2[EmojiProperties.unified] = s.unified, _extends2));
        }).filter(Boolean);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        suggestedUpdated,
        suggestedEmojisModeConfig,
        emojiByUnified
    ]);
    return function getEmojisByCategory(category) {
        var _emojiData$emojis$cat, _emojiData$emojis;
        if (category === Categories.SUGGESTED) return suggested;
        return (_emojiData$emojis$cat = (_emojiData$emojis = emojiData.emojis) == null ? void 0 : _emojiData$emojis[category]) != null ? _emojiData$emojis$cat : [];
    };
}
function customToRegularEmoji(emoji) {
    var _ref2;
    return _ref2 = {}, _ref2[EmojiProperties.name] = emoji.names.map(function(name) {
        return name.toLowerCase();
    }), _ref2[EmojiProperties.unified] = emoji.id.toLowerCase(), _ref2[EmojiProperties.added_in] = '0', _ref2[EmojiProperties.imgUrl] = emoji.imgUrl, _ref2;
}
function useIsUnicodeHidden() {
    var unicodeToHide = useUnicodeToHide();
    return function(emojiUnified) {
        return unicodeToHide.has(emojiUnified);
    };
}
function useDisallowedEmojis() {
    var DisallowedEmojisRef = (0, _react.useRef)({});
    var emojiVersionConfig = useEmojiVersionConfig();
    var _usePickerDataContext = usePickerDataContext(), allEmojis = _usePickerDataContext.allEmojis;
    return (0, _react.useMemo)(function() {
        var emojiVersion = parseFloat("" + emojiVersionConfig);
        if (!emojiVersionConfig || Number.isNaN(emojiVersion)) return DisallowedEmojisRef.current;
        return allEmojis.reduce(function(disallowedEmojis, emoji) {
            if (addedInNewerVersion(emoji, emojiVersion)) disallowedEmojis[emojiUnified(emoji)] = true;
            return disallowedEmojis;
        }, DisallowedEmojisRef.current);
    }, [
        emojiVersionConfig,
        allEmojis
    ]);
}
function useIsEmojiDisallowed() {
    var disallowedEmojis = useDisallowedEmojis();
    var isUnicodeHidden = useIsUnicodeHidden();
    return function isEmojiDisallowed(emoji) {
        var unified = unifiedWithoutSkinTone(emojiUnified(emoji));
        return Boolean(disallowedEmojis[unified] || isUnicodeHidden(unified));
    };
}
function addedInNewerVersion(emoji, supportedLevel) {
    return addedIn(emoji) > supportedLevel;
}
function useMarkInitialLoad(dispatch) {
    (0, _react.useEffect)(function() {
        dispatch(true);
    }, [
        dispatch
    ]);
}
function PickerContextProvider(_ref) {
    var children = _ref.children;
    var disallowedEmojis = useDisallowedEmojis();
    var defaultSkinTone = useDefaultSkinToneConfig();
    var reactionsDefaultOpen = useReactionsOpenConfig();
    var _usePickerDataContext = usePickerDataContext(), searchIndex = _usePickerDataContext.searchIndex;
    // Initialize the filter with the inititial dictionary
    var filterRef = (0, _react.useRef)(searchIndex);
    (0, _react.useEffect)(function() {
        filterRef.current = searchIndex;
    }, [
        searchIndex
    ]);
    var disallowClickRef = (0, _react.useRef)(false);
    var disallowMouseRef = (0, _react.useRef)(false);
    var disallowedEmojisRef = (0, _react.useRef)(disallowedEmojis);
    var suggestedUpdateState = useDebouncedState(Date.now(), 200);
    var searchTerm = useDebouncedState('', 100);
    var skinToneFanOpenState = (0, _react.useState)(false);
    var activeSkinTone = (0, _react.useState)(defaultSkinTone);
    var activeCategoryState = (0, _react.useState)(null);
    var emojisThatFailedToLoadState = (0, _react.useState)(new Set());
    var emojiVariationPickerState = (0, _react.useState)(null);
    var reactionsModeState = (0, _react.useState)(reactionsDefaultOpen);
    var _useState = (0, _react.useState)(false), isPastInitialLoad = _useState[0], setIsPastInitialLoad = _useState[1];
    var visibleCategoriesState = (0, _react.useState)([]);
    var emojiSizeState = (0, _react.useState)(null);
    useMarkInitialLoad(setIsPastInitialLoad);
    return (0, _react.createElement)(PickerContext.Provider, {
        value: {
            activeCategoryState: activeCategoryState,
            activeSkinTone: activeSkinTone,
            disallowClickRef: disallowClickRef,
            disallowMouseRef: disallowMouseRef,
            disallowedEmojisRef: disallowedEmojisRef,
            emojiVariationPickerState: emojiVariationPickerState,
            emojisThatFailedToLoadState: emojisThatFailedToLoadState,
            filterRef: filterRef,
            isPastInitialLoad: isPastInitialLoad,
            searchTerm: searchTerm,
            skinToneFanOpenState: skinToneFanOpenState,
            suggestedUpdateState: suggestedUpdateState,
            reactionsModeState: reactionsModeState,
            visibleCategoriesState: visibleCategoriesState,
            emojiSizeState: emojiSizeState
        }
    }, children);
}
var PickerContext = /*#__PURE__*/ (0, _react.createContext)({
    activeCategoryState: [
        null,
        function() {}
    ],
    activeSkinTone: [
        SkinTones.NEUTRAL,
        function() {}
    ],
    disallowClickRef: {
        current: false
    },
    disallowMouseRef: {
        current: false
    },
    disallowedEmojisRef: {
        current: {}
    },
    emojiVariationPickerState: [
        null,
        function() {}
    ],
    emojisThatFailedToLoadState: [
        /*#__PURE__*/ new Set(),
        function() {}
    ],
    filterRef: {
        current: {}
    },
    isPastInitialLoad: true,
    searchTerm: [
        '',
        function() {
            return new Promise(function() {
                return undefined;
            });
        }
    ],
    skinToneFanOpenState: [
        false,
        function() {}
    ],
    suggestedUpdateState: [
        /*#__PURE__*/ Date.now(),
        function() {}
    ],
    reactionsModeState: [
        false,
        function() {}
    ],
    visibleCategoriesState: [
        [],
        function() {
            return [];
        }
    ],
    emojiSizeState: [
        null,
        function() {}
    ]
});
function useFilterRef() {
    var _React$useContext = (0, _react.useContext)(PickerContext), filterRef = _React$useContext.filterRef;
    return filterRef;
}
function useDisallowClickRef() {
    var _React$useContext2 = (0, _react.useContext)(PickerContext), disallowClickRef = _React$useContext2.disallowClickRef;
    return disallowClickRef;
}
function useDisallowMouseRef() {
    var _React$useContext3 = (0, _react.useContext)(PickerContext), disallowMouseRef = _React$useContext3.disallowMouseRef;
    return disallowMouseRef;
}
function useReactionsModeState() {
    var _React$useContext4 = (0, _react.useContext)(PickerContext), reactionsModeState = _React$useContext4.reactionsModeState;
    return reactionsModeState;
}
function useSearchTermState() {
    var _React$useContext5 = (0, _react.useContext)(PickerContext), searchTerm = _React$useContext5.searchTerm;
    return searchTerm;
}
function useActiveSkinToneState() {
    var _React$useContext6 = (0, _react.useContext)(PickerContext), activeSkinTone = _React$useContext6.activeSkinTone;
    return activeSkinTone;
}
function useEmojisThatFailedToLoadState() {
    var _React$useContext7 = (0, _react.useContext)(PickerContext), emojisThatFailedToLoadState = _React$useContext7.emojisThatFailedToLoadState;
    return emojisThatFailedToLoadState;
}
function useEmojiVariationPickerState() {
    var _React$useContext9 = (0, _react.useContext)(PickerContext), emojiVariationPickerState = _React$useContext9.emojiVariationPickerState;
    return emojiVariationPickerState;
}
function useSkinToneFanOpenState() {
    var _React$useContext0 = (0, _react.useContext)(PickerContext), skinToneFanOpenState = _React$useContext0.skinToneFanOpenState;
    return skinToneFanOpenState;
}
function useVisibleCategoriesState() {
    var _React$useContext10 = (0, _react.useContext)(PickerContext), visibleCategoriesState = _React$useContext10.visibleCategoriesState;
    return visibleCategoriesState;
}
function useEmojiSizeState() {
    var _React$useContext11 = (0, _react.useContext)(PickerContext), emojiSizeState = _React$useContext11.emojiSizeState;
    return emojiSizeState;
}
function useUpdateSuggested() {
    var _React$useContext12 = (0, _react.useContext)(PickerContext), suggestedUpdateState = _React$useContext12.suggestedUpdateState;
    var suggestedUpdated = suggestedUpdateState[0], setsuggestedUpdate = suggestedUpdateState[1];
    return [
        suggestedUpdated,
        function updateSuggested() {
            setsuggestedUpdate(Date.now());
        }
    ];
}
var MutableConfigContext = /*#__PURE__*/ (0, _reactDefault.default).createContext({});
function useMutableConfig() {
    var mutableConfig = (0, _reactDefault.default).useContext(MutableConfigContext);
    return mutableConfig;
}
function useDefineMutableConfig(config) {
    var MutableConfigRef = (0, _reactDefault.default).useRef({
        onEmojiClick: config.onEmojiClick || emptyFunc,
        onReactionClick: config.onReactionClick || config.onEmojiClick,
        onSkinToneChange: config.onSkinToneChange || emptyFunc
    });
    (0, _reactDefault.default).useEffect(function() {
        MutableConfigRef.current.onEmojiClick = config.onEmojiClick || emptyFunc;
        MutableConfigRef.current.onReactionClick = config.onReactionClick || config.onEmojiClick;
    }, [
        config.onEmojiClick,
        config.onReactionClick
    ]);
    (0, _reactDefault.default).useEffect(function() {
        MutableConfigRef.current.onSkinToneChange = config.onSkinToneChange || emptyFunc;
    }, [
        config.onSkinToneChange
    ]);
    return MutableConfigRef;
}
function emptyFunc() {}
var MOUSE_EVENT_SOURCE;
(function(MOUSE_EVENT_SOURCE) {
    MOUSE_EVENT_SOURCE["REACTIONS"] = "reactions";
    MOUSE_EVENT_SOURCE["PICKER"] = "picker";
})(MOUSE_EVENT_SOURCE || (MOUSE_EVENT_SOURCE = {}));
function useSearchPlaceHolderConfig() {
    var _find;
    var _usePickerConfig = usePickerConfig(), searchPlaceHolder = _usePickerConfig.searchPlaceHolder, searchPlaceholder = _usePickerConfig.searchPlaceholder;
    return (_find = [
        searchPlaceHolder,
        searchPlaceholder
    ].find(function(p) {
        return p !== DEFAULT_SEARCH_PLACEHOLDER;
    })) != null ? _find : DEFAULT_SEARCH_PLACEHOLDER;
}
function useSearchClearButtonLabelConfig() {
    var _usePickerConfig2 = usePickerConfig(), searchClearButtonLabel = _usePickerConfig2.searchClearButtonLabel;
    return searchClearButtonLabel != null ? searchClearButtonLabel : DEFAULT_SEARCH_CLEAR_BUTTON_LABEL;
}
function useDefaultSkinToneConfig() {
    var _usePickerConfig3 = usePickerConfig(), defaultSkinTone = _usePickerConfig3.defaultSkinTone;
    return defaultSkinTone;
}
function useAllowExpandReactions() {
    var _usePickerConfig4 = usePickerConfig(), allowExpandReactions = _usePickerConfig4.allowExpandReactions;
    return allowExpandReactions;
}
function useSkinTonesDisabledConfig() {
    var _usePickerConfig5 = usePickerConfig(), skinTonesDisabled = _usePickerConfig5.skinTonesDisabled;
    return skinTonesDisabled;
}
function useEmojiStyleConfig() {
    var _usePickerConfig6 = usePickerConfig(), emojiStyle = _usePickerConfig6.emojiStyle;
    return emojiStyle;
}
function useAutoFocusSearchConfig() {
    var _usePickerConfig7 = usePickerConfig(), autoFocusSearch = _usePickerConfig7.autoFocusSearch;
    return autoFocusSearch;
}
function useCategoriesConfig() {
    var _usePickerConfig8 = usePickerConfig(), categories = _usePickerConfig8.categories;
    return categories;
}
function useCategoryIconsConfig() {
    var _usePickerConfig9 = usePickerConfig(), categoryIcons = _usePickerConfig9.categoryIcons;
    return categoryIcons;
}
function useCustomEmojisConfig() {
    var _usePickerConfig0 = usePickerConfig(), customEmojis = _usePickerConfig0.customEmojis;
    return customEmojis;
}
function useOpenConfig() {
    var _usePickerConfig1 = usePickerConfig(), open = _usePickerConfig1.open;
    return open;
}
function useOnEmojiClickConfig(mouseEventSource) {
    var _useMutableConfig = useMutableConfig(), current = _useMutableConfig.current;
    var _useReactionsModeStat = useReactionsModeState(), setReactionsOpen = _useReactionsModeStat[1];
    var handler = current.onEmojiClick || function() {};
    var onReactionClick = current.onReactionClick;
    if (mouseEventSource === MOUSE_EVENT_SOURCE.REACTIONS && onReactionClick) return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return onReactionClick.apply(void 0, args.concat([
            {
                collapseToReactions: function collapseToReactions() {
                    setReactionsOpen(function(o) {
                        return o;
                    });
                }
            }
        ]));
    };
    return function() {
        for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
        handler.apply(void 0, args.concat([
            {
                collapseToReactions: function collapseToReactions() {
                    setReactionsOpen(true);
                }
            }
        ]));
    };
}
function useOnSkinToneChangeConfig() {
    var _useMutableConfig2 = useMutableConfig(), current = _useMutableConfig2.current;
    return current.onSkinToneChange || function() {};
}
function usePreviewConfig() {
    var _usePickerConfig10 = usePickerConfig(), previewConfig = _usePickerConfig10.previewConfig;
    return previewConfig;
}
function useThemeConfig() {
    var _usePickerConfig11 = usePickerConfig(), theme = _usePickerConfig11.theme;
    return theme;
}
function useSuggestedEmojisModeConfig() {
    var _usePickerConfig12 = usePickerConfig(), suggestedEmojisMode = _usePickerConfig12.suggestedEmojisMode;
    return suggestedEmojisMode;
}
function useLazyLoadEmojisConfig() {
    var _usePickerConfig13 = usePickerConfig(), lazyLoadEmojis = _usePickerConfig13.lazyLoadEmojis;
    return lazyLoadEmojis;
}
function useClassNameConfig() {
    var _usePickerConfig14 = usePickerConfig(), className = _usePickerConfig14.className;
    return className;
}
function useStyleConfig() {
    var _usePickerConfig15 = usePickerConfig(), height = _usePickerConfig15.height, width = _usePickerConfig15.width, style = _usePickerConfig15.style;
    return _extends({
        height: getDimension(height),
        width: getDimension(width)
    }, style);
}
function useReactionsOpenConfig() {
    var _usePickerConfig16 = usePickerConfig(), reactionsDefaultOpen = _usePickerConfig16.reactionsDefaultOpen;
    return reactionsDefaultOpen;
}
function useEmojiVersionConfig() {
    var _usePickerConfig17 = usePickerConfig(), emojiVersion = _usePickerConfig17.emojiVersion;
    return emojiVersion;
}
function useSearchDisabledConfig() {
    var _usePickerConfig18 = usePickerConfig(), searchDisabled = _usePickerConfig18.searchDisabled;
    return searchDisabled;
}
function useSkinTonePickerLocationConfig() {
    var _usePickerConfig19 = usePickerConfig(), skinTonePickerLocation = _usePickerConfig19.skinTonePickerLocation;
    return skinTonePickerLocation;
}
function useUnicodeToHide() {
    var _usePickerConfig20 = usePickerConfig(), unicodeToHide = _usePickerConfig20.unicodeToHide;
    return unicodeToHide;
}
function useReactionsConfig() {
    var _usePickerConfig21 = usePickerConfig(), reactions = _usePickerConfig21.reactions;
    return reactions;
}
function useGetEmojiUrlConfig() {
    var _usePickerConfig22 = usePickerConfig(), getEmojiUrl = _usePickerConfig22.getEmojiUrl;
    return getEmojiUrl;
}
function getDimension(dimensionConfig) {
    return typeof dimensionConfig === 'number' ? dimensionConfig + "px" : dimensionConfig;
}
function useSearchResultsConfig(searchResultsCount) {
    var hasResults = searchResultsCount > 0;
    var isPlural = searchResultsCount > 1;
    if (hasResults) return isPlural ? SEARCH_RESULTS_MULTIPLE_RESULTS_FOUND.replace('%n', searchResultsCount.toString()) : SEARCH_RESULTS_ONE_RESULT_FOUND;
    return SEARCH_RESULTS_NO_RESULTS_FOUND;
}
function useIsSearchMode() {
    var _useSearchTermState = useSearchTermState(), searchTerm = _useSearchTermState[0];
    return !!searchTerm;
}
function focusElement(element) {
    if (!element) return;
    requestAnimationFrame(function() {
        element.focus();
    });
}
function focusPrevElementSibling(element) {
    if (!element) return;
    var prev = element.previousElementSibling;
    focusElement(prev);
}
function focusNextElementSibling(element) {
    if (!element) return;
    var next = element.nextElementSibling;
    focusElement(next);
}
function focusFirstElementChild(element) {
    if (!element) return;
    var first = element.firstElementChild;
    focusElement(first);
}
function getActiveElement() {
    return document.activeElement;
}
function ElementRefContextProvider(_ref) {
    var children = _ref.children;
    var PickerMainRef = (0, _react.useRef)(null);
    var AnchoredEmojiRef = (0, _react.useRef)(null);
    var BodyRef = (0, _react.useRef)(null);
    var EmojiListRef = (0, _react.useRef)(null);
    var SearchInputRef = (0, _react.useRef)(null);
    var SkinTonePickerRef = (0, _react.useRef)(null);
    var CategoryNavigationRef = (0, _react.useRef)(null);
    var VariationPickerRef = (0, _react.useRef)(null);
    var ReactionsRef = (0, _react.useRef)(null);
    return (0, _react.createElement)(ElementRefContext.Provider, {
        value: {
            AnchoredEmojiRef: AnchoredEmojiRef,
            BodyRef: BodyRef,
            EmojiListRef: EmojiListRef,
            CategoryNavigationRef: CategoryNavigationRef,
            PickerMainRef: PickerMainRef,
            SearchInputRef: SearchInputRef,
            SkinTonePickerRef: SkinTonePickerRef,
            VariationPickerRef: VariationPickerRef,
            ReactionsRef: ReactionsRef
        }
    }, children);
}
var ElementRefContext = /*#__PURE__*/ (0, _react.createContext)({
    AnchoredEmojiRef: /*#__PURE__*/ (0, _react.createRef)(),
    BodyRef: /*#__PURE__*/ (0, _react.createRef)(),
    CategoryNavigationRef: /*#__PURE__*/ (0, _react.createRef)(),
    EmojiListRef: /*#__PURE__*/ (0, _react.createRef)(),
    PickerMainRef: /*#__PURE__*/ (0, _react.createRef)(),
    SearchInputRef: /*#__PURE__*/ (0, _react.createRef)(),
    SkinTonePickerRef: /*#__PURE__*/ (0, _react.createRef)(),
    VariationPickerRef: /*#__PURE__*/ (0, _react.createRef)(),
    ReactionsRef: /*#__PURE__*/ (0, _react.createRef)()
});
function useElementRef() {
    return (0, _react.useContext)(ElementRefContext);
}
function useEmojiListRef() {
    return useElementRef()['EmojiListRef'];
}
function usePickerMainRef() {
    return useElementRef()['PickerMainRef'];
}
function useAnchoredEmojiRef() {
    return useElementRef()['AnchoredEmojiRef'];
}
function useSetAnchoredEmojiRef() {
    var AnchoredEmojiRef = useAnchoredEmojiRef();
    return function(target) {
        if (target === null && AnchoredEmojiRef.current !== null) focusElement(AnchoredEmojiRef.current);
        AnchoredEmojiRef.current = target;
    };
}
function useBodyRef() {
    return useElementRef()['BodyRef'];
}
function useReactionsRef() {
    return useElementRef()['ReactionsRef'];
}
function useSearchInputRef() {
    return useElementRef()['SearchInputRef'];
}
function useSkinTonePickerRef() {
    return useElementRef()['SkinTonePickerRef'];
}
function useCategoryNavigationRef() {
    return useElementRef()['CategoryNavigationRef'];
}
function useVariationPickerRef() {
    return useElementRef()['VariationPickerRef'];
}
function scrollTo(root, top) {
    if (top === void 0) top = 0;
    var $eprBody = queryScrollBody(root);
    if (!$eprBody) return;
    requestAnimationFrame(function() {
        $eprBody.scrollTop = top;
    });
}
function scrollBy(root, by) {
    var $eprBody = queryScrollBody(root);
    if (!$eprBody) return;
    requestAnimationFrame(function() {
        $eprBody.scrollTop = $eprBody.scrollTop + by;
    });
}
function useScrollTo() {
    var BodyRef = useBodyRef();
    return (0, _react.useCallback)(function(top) {
        requestAnimationFrame(function() {
            if (BodyRef.current) BodyRef.current.scrollTop = top;
        });
    }, [
        BodyRef
    ]);
}
function scrollEmojiAboveLabel(emoji) {
    if (!emoji || !isEmojiBehindLabel(emoji)) return;
    if (emoji.closest(asSelectors(ClassNames.variationPicker))) return;
    var scrollBody = closestScrollBody(emoji);
    var by = emojiDistanceFromScrollTop(emoji);
    scrollBy(scrollBody, -(categoryLabelHeight(closestCategory(emoji)) - by));
}
function focusFirstVisibleEmoji(parent) {
    var emoji = firstVisibleEmoji(parent);
    focusElement(emoji);
    scrollEmojiAboveLabel(emoji);
}
function focusAndClickFirstVisibleEmoji(parent) {
    var firstEmoji = firstVisibleEmoji(parent);
    focusElement(firstEmoji);
    firstEmoji == null || firstEmoji.click();
}
function focusLastVisibleEmoji(parent) {
    focusElement(lastVisibleEmoji(parent));
}
function focusNextVisibleEmoji(element) {
    if (!element) return;
    var next = nextVisibleEmoji(element);
    if (!next) return focusFirstVisibleEmoji(nextCategory(element));
    focusElement(next);
    scrollEmojiAboveLabel(next);
}
function focusPrevVisibleEmoji(element) {
    if (!element) return;
    var prev = prevVisibleEmoji(element);
    if (!prev) return focusLastVisibleEmoji(prevCategory(element));
    focusElement(prev);
    scrollEmojiAboveLabel(prev);
}
function focusVisibleEmojiOneRowUp(element, exitUp) {
    if (!element) return;
    var prev = visibleEmojiOneRowUp(element);
    if (!prev) return exitUp();
    focusElement(prev);
    scrollEmojiAboveLabel(prev);
}
function focusVisibleEmojiOneRowDown(element) {
    if (!element) return;
    var next = visibleEmojiOneRowDown(element);
    return focusElement(next);
}
function visibleEmojiOneRowUp(element) {
    if (!element) return null;
    var categoryContent = closestCategoryContent(element);
    var category = closestCategory(categoryContent);
    var countInRow = elementCountInRow(categoryContent, element);
    var emojisInCurrentCategory = allVisibleEmojis(category);
    var currentEmojiIndex = emojisInCurrentCategory.indexOf(element);
    var indexInRow = currentEmojiIndex % countInRow;
    if (currentEmojiIndex === -1) return null;
    if (emojisInCurrentCategory[currentEmojiIndex - countInRow]) return emojisInCurrentCategory[currentEmojiIndex - countInRow];
    var prevVisibleCategory = prevCategory(category);
    if (!prevVisibleCategory) return null;
    var allPrevEmojis = allVisibleEmojis(prevVisibleCategory);
    // if there is an emoji in the same index of `indexInRow` in the previous category, return it
    // for this we need to find the last emoji in the previous category that shares the same indexInRow
    // this is by using the % operator to find the last emoji that matches
    var lastIndexInRow = allPrevEmojis.length % countInRow - 1;
    if (indexInRow > lastIndexInRow) return allPrevEmojis.at(-1);
    // otherwise, return the last emoji that shares the same indexInRow
    for(var i = allPrevEmojis.length - 1; i >= 0; i--){
        if (i % countInRow === indexInRow) return allPrevEmojis[i];
    }
    return allPrevEmojis.at(-1);
}
function visibleEmojiOneRowDown(element) {
    var _emojisInNextCategory;
    if (!element) return null;
    var categoryContent = closestCategoryContent(element);
    var category = closestCategory(categoryContent);
    var countInRow = elementCountInRow(categoryContent, element);
    var emojisInCurrentCategory = allVisibleEmojis(category);
    var currentEmojiIndex = emojisInCurrentCategory.indexOf(element);
    if (currentEmojiIndex === -1) return null;
    // the remainder until the end of the row
    var remainder = countInRow - currentEmojiIndex % countInRow - 1;
    var firstInNextRow = currentEmojiIndex + remainder + 1;
    if (emojisInCurrentCategory[firstInNextRow]) // if we have a next row, search in the next row for the last available emoji
    for(var p = currentEmojiIndex + countInRow; p % countInRow >= 0; p--){
        if (emojisInCurrentCategory[p]) return emojisInCurrentCategory[p];
    }
    var indexInRow = currentEmojiIndex % countInRow;
    var nextVisibleCategory = nextCategory(category);
    var emojisInNextCategory = allVisibleEmojis(nextVisibleCategory);
    if (emojisInNextCategory[indexInRow]) return emojisInNextCategory[indexInRow];
    return (_emojisInNextCategory = emojisInNextCategory.at(0)) != null ? _emojisInNextCategory : null;
}
function useCloseAllOpenToggles() {
    var _useEmojiVariationPic = useEmojiVariationPickerState(), variationPicker = _useEmojiVariationPic[0], setVariationPicker = _useEmojiVariationPic[1];
    var _useSkinToneFanOpenSt = useSkinToneFanOpenState(), skinToneFanOpen = _useSkinToneFanOpenSt[0], setSkinToneFanOpen = _useSkinToneFanOpenSt[1];
    var closeAllOpenToggles = (0, _react.useCallback)(function() {
        if (variationPicker) setVariationPicker(null);
        if (skinToneFanOpen) setSkinToneFanOpen(false);
    }, [
        variationPicker,
        skinToneFanOpen,
        setVariationPicker,
        setSkinToneFanOpen
    ]);
    return closeAllOpenToggles;
}
function useHasOpenToggles() {
    var _useEmojiVariationPic2 = useEmojiVariationPickerState(), variationPicker = _useEmojiVariationPic2[0];
    var _useSkinToneFanOpenSt2 = useSkinToneFanOpenState(), skinToneFanOpen = _useSkinToneFanOpenSt2[0];
    return function hasOpenToggles() {
        return !!variationPicker || skinToneFanOpen;
    };
}
function useDisallowMouseMove() {
    var DisallowMouseRef = useDisallowMouseRef();
    return function disallowMouseMove() {
        DisallowMouseRef.current = true;
    };
}
function useAllowMouseMove() {
    var DisallowMouseRef = useDisallowMouseRef();
    return function allowMouseMove() {
        DisallowMouseRef.current = false;
    };
}
function useIsMouseDisallowed() {
    var DisallowMouseRef = useDisallowMouseRef();
    return function isMouseDisallowed() {
        return DisallowMouseRef.current;
    };
}
function useOnMouseMove() {
    var BodyRef = useBodyRef();
    var allowMouseMove = useAllowMouseMove();
    var isMouseDisallowed = useIsMouseDisallowed();
    (0, _react.useEffect)(function() {
        var bodyRef = BodyRef.current;
        bodyRef == null || bodyRef.addEventListener('mousemove', onMouseMove, {
            passive: true
        });
        function onMouseMove() {
            if (isMouseDisallowed()) allowMouseMove();
        }
        return function() {
            bodyRef == null || bodyRef.removeEventListener('mousemove', onMouseMove);
        };
    }, [
        BodyRef,
        allowMouseMove,
        isMouseDisallowed
    ]);
}
function useFocusSearchInput() {
    var SearchInputRef = useSearchInputRef();
    return (0, _react.useCallback)(function() {
        focusElement(SearchInputRef.current);
    }, [
        SearchInputRef
    ]);
}
function useFocusSkinTonePicker() {
    var SkinTonePickerRef = useSkinTonePickerRef();
    return (0, _react.useCallback)(function() {
        if (!SkinTonePickerRef.current) return;
        focusFirstElementChild(SkinTonePickerRef.current);
    }, [
        SkinTonePickerRef
    ]);
}
function useFocusCategoryNavigation() {
    var CategoryNavigationRef = useCategoryNavigationRef();
    return (0, _react.useCallback)(function() {
        if (!CategoryNavigationRef.current) return;
        focusFirstElementChild(CategoryNavigationRef.current);
    }, [
        CategoryNavigationRef
    ]);
}
function useSetFilterRef() {
    var filterRef = useFilterRef();
    return function setFilter(setter) {
        if (typeof setter === 'function') return setFilter(setter(filterRef.current));
        filterRef.current = setter;
    };
}
function useClearSearch() {
    var applySearch = useApplySearch();
    var SearchInputRef = useSearchInputRef();
    var focusSearchInput = useFocusSearchInput();
    return function clearSearch() {
        if (SearchInputRef.current) SearchInputRef.current.value = '';
        applySearch('');
        focusSearchInput();
    };
}
function useAppendSearch() {
    var SearchInputRef = useSearchInputRef();
    var applySearch = useApplySearch();
    return function appendSearch(str) {
        if (SearchInputRef.current) {
            SearchInputRef.current.value = "" + SearchInputRef.current.value + str;
            applySearch(getNormalizedSearchTerm(SearchInputRef.current.value));
        } else applySearch(getNormalizedSearchTerm(str));
    };
}
function useFilter() {
    var SearchInputRef = useSearchInputRef();
    var filterRef = useFilterRef();
    var setFilterRef = useSetFilterRef();
    var applySearch = useApplySearch();
    var _useSearchTermState = useSearchTermState(), searchTerm = _useSearchTermState[0];
    var statusSearchResults = getStatusSearchResults(filterRef.current, searchTerm);
    return {
        onChange: onChange,
        searchTerm: searchTerm,
        SearchInputRef: SearchInputRef,
        statusSearchResults: statusSearchResults
    };
    function onChange(inputValue) {
        var filter = filterRef.current;
        var nextValue = inputValue.toLowerCase();
        if (filter != null && filter[nextValue] || nextValue.length <= 1) return applySearch(nextValue);
        var longestMatch = findLongestMatch(nextValue, filter);
        if (!longestMatch) // Can we even get here?
        // If so, we need to search among all emojis
        return applySearch(nextValue);
        setFilterRef(function(current) {
            var _Object$assign;
            return Object.assign(current, (_Object$assign = {}, _Object$assign[nextValue] = filterEmojiObjectByKeyword(longestMatch, nextValue), _Object$assign));
        });
        applySearch(nextValue);
    }
}
function useApplySearch() {
    var _useSearchTermState2 = useSearchTermState(), setSearchTerm = _useSearchTermState2[1];
    var PickerMainRef = usePickerMainRef();
    return function applySearch(searchTerm) {
        requestAnimationFrame(function() {
            setSearchTerm(searchTerm ? searchTerm == null ? void 0 : searchTerm.toLowerCase() : searchTerm).then(function() {
                scrollTo(PickerMainRef.current, 0);
            });
        });
    };
}
function filterEmojiObjectByKeyword(emojis, keyword) {
    var filtered = {};
    for(var unified in emojis){
        var emoji = emojis[unified];
        if (hasMatch(emoji, keyword)) filtered[unified] = emoji;
    }
    return filtered;
}
function hasMatch(emoji, keyword) {
    return emojiNames(emoji).some(function(name) {
        return name.includes(keyword);
    });
}
function useIsEmojiFiltered() {
    var _useFilterRef = useFilterRef(), filter = _useFilterRef.current;
    var _useSearchTermState3 = useSearchTermState(), searchTerm = _useSearchTermState3[0];
    return function(unified) {
        return isEmojiFilteredBySearchTerm(unified, filter, searchTerm);
    };
}
function isEmojiFilteredBySearchTerm(unified, filter, searchTerm) {
    var _filter$searchTerm;
    if (!filter || !searchTerm) return false;
    return !((_filter$searchTerm = filter[searchTerm]) != null && _filter$searchTerm[unified]);
}
function findLongestMatch(keyword, dict) {
    if (!dict) return null;
    if (dict[keyword]) return dict[keyword];
    var longestMatchingKey = Object.keys(dict).sort(function(a, b) {
        return b.length - a.length;
    }).find(function(key) {
        return keyword.includes(key);
    });
    if (longestMatchingKey) return dict[longestMatchingKey];
    return null;
}
function getNormalizedSearchTerm(str) {
    if (!str || typeof str !== 'string') return '';
    return str.trim().toLowerCase();
}
function getStatusSearchResults(filterState, searchTerm) {
    var _Object$entries;
    if (!(filterState != null && filterState[searchTerm])) return '';
    var searchResultsCount = ((_Object$entries = Object.entries(filterState == null ? void 0 : filterState[searchTerm])) == null ? void 0 : _Object$entries.length) || 0;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useSearchResultsConfig(searchResultsCount);
}
function useSetVariationPicker() {
    var setAnchoredEmojiRef = useSetAnchoredEmojiRef();
    var _useEmojiVariationPic = useEmojiVariationPickerState(), setEmojiVariationPicker = _useEmojiVariationPic[1];
    return function setVariationPicker(element) {
        var _emojiFromElement = emojiFromElement(element), emoji = _emojiFromElement[0];
        if (emoji) {
            setAnchoredEmojiRef(element);
            setEmojiVariationPicker(emoji);
        }
    };
}
function useIsSkinToneInSearch() {
    var skinTonePickerLocationConfig = useSkinTonePickerLocationConfig();
    return skinTonePickerLocationConfig === SkinTonePickerLocation.SEARCH;
}
function useIsSkinToneInPreview() {
    var skinTonePickerLocationConfig = useSkinTonePickerLocationConfig();
    return skinTonePickerLocationConfig === SkinTonePickerLocation.PREVIEW;
}
var KeyboardEvents;
(function(KeyboardEvents) {
    KeyboardEvents["ArrowDown"] = "ArrowDown";
    KeyboardEvents["ArrowUp"] = "ArrowUp";
    KeyboardEvents["ArrowLeft"] = "ArrowLeft";
    KeyboardEvents["ArrowRight"] = "ArrowRight";
    KeyboardEvents["Escape"] = "Escape";
    KeyboardEvents["Enter"] = "Enter";
    KeyboardEvents["Space"] = " ";
})(KeyboardEvents || (KeyboardEvents = {}));
function useKeyboardNavigation() {
    usePickerMainKeyboardEvents();
    useSearchInputKeyboardEvents();
    useSkinTonePickerKeyboardEvents();
    useCategoryNavigationKeyboardEvents();
    useBodyKeyboardEvents();
}
function usePickerMainKeyboardEvents() {
    var PickerMainRef = usePickerMainRef();
    var clearSearch = useClearSearch();
    var scrollTo = useScrollTo();
    var SearchInputRef = useSearchInputRef();
    var focusSearchInput = useFocusSearchInput();
    var hasOpenToggles = useHasOpenToggles();
    var disallowMouseMove = useDisallowMouseMove();
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var onKeyDown = (0, _react.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            disallowMouseMove();
            switch(key){
                // eslint-disable-next-line no-fallthrough
                case KeyboardEvents.Escape:
                    event.preventDefault();
                    if (hasOpenToggles()) {
                        closeAllOpenToggles();
                        return;
                    }
                    clearSearch();
                    scrollTo(0);
                    focusSearchInput();
                    break;
            }
        };
    }, [
        scrollTo,
        clearSearch,
        closeAllOpenToggles,
        focusSearchInput,
        hasOpenToggles,
        disallowMouseMove
    ]);
    (0, _react.useEffect)(function() {
        var current = PickerMainRef.current;
        if (!current) return;
        current.addEventListener('keydown', onKeyDown);
        return function() {
            current.removeEventListener('keydown', onKeyDown);
        };
    }, [
        PickerMainRef,
        SearchInputRef,
        scrollTo,
        onKeyDown
    ]);
}
function useSearchInputKeyboardEvents() {
    var focusSkinTonePicker = useFocusSkinTonePicker();
    var PickerMainRef = usePickerMainRef();
    var BodyRef = useBodyRef();
    var SearchInputRef = useSearchInputRef();
    var _useSkinToneFanOpenSt = useSkinToneFanOpenState(), setSkinToneFanOpenState = _useSkinToneFanOpenSt[1];
    var goDownFromSearchInput = useGoDownFromSearchInput();
    var isSkinToneInSearch = useIsSkinToneInSearch();
    var onKeyDown = (0, _react.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            switch(key){
                case KeyboardEvents.ArrowRight:
                    if (!isSkinToneInSearch) return;
                    event.preventDefault();
                    setSkinToneFanOpenState(true);
                    focusSkinTonePicker();
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    goDownFromSearchInput();
                    break;
                case KeyboardEvents.Enter:
                    event.preventDefault();
                    focusAndClickFirstVisibleEmoji(BodyRef.current);
                    break;
            }
        };
    }, [
        focusSkinTonePicker,
        goDownFromSearchInput,
        setSkinToneFanOpenState,
        BodyRef,
        isSkinToneInSearch
    ]);
    (0, _react.useEffect)(function() {
        var current = SearchInputRef.current;
        if (!current) return;
        current.addEventListener('keydown', onKeyDown);
        return function() {
            current.removeEventListener('keydown', onKeyDown);
        };
    }, [
        PickerMainRef,
        SearchInputRef,
        onKeyDown
    ]);
}
function useSkinTonePickerKeyboardEvents() {
    var SkinTonePickerRef = useSkinTonePickerRef();
    var focusSearchInput = useFocusSearchInput();
    var SearchInputRef = useSearchInputRef();
    var goDownFromSearchInput = useGoDownFromSearchInput();
    var _useSkinToneFanOpenSt2 = useSkinToneFanOpenState(), isOpen = _useSkinToneFanOpenSt2[0], setIsOpen = _useSkinToneFanOpenSt2[1];
    var isSkinToneInPreview = useIsSkinToneInPreview();
    var isSkinToneInSearch = useIsSkinToneInSearch();
    var onType = useOnType();
    var onKeyDown = (0, _react.useMemo)(function() {
        return(// eslint-disable-next-line complexity
        function onKeyDown(event) {
            var key = event.key;
            if (isSkinToneInSearch) switch(key){
                case KeyboardEvents.ArrowLeft:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    focusNextSkinTone(focusSearchInput);
                    break;
                case KeyboardEvents.ArrowRight:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    focusPrevSkinTone();
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    if (isOpen) setIsOpen(false);
                    goDownFromSearchInput();
                    break;
                default:
                    onType(event);
                    break;
            }
            if (isSkinToneInPreview) switch(key){
                case KeyboardEvents.ArrowUp:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    focusNextSkinTone(focusSearchInput);
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    if (!isOpen) return focusSearchInput();
                    focusPrevSkinTone();
                    break;
                default:
                    onType(event);
                    break;
            }
        });
    }, [
        isOpen,
        focusSearchInput,
        setIsOpen,
        goDownFromSearchInput,
        onType,
        isSkinToneInPreview,
        isSkinToneInSearch
    ]);
    (0, _react.useEffect)(function() {
        var current = SkinTonePickerRef.current;
        if (!current) return;
        current.addEventListener('keydown', onKeyDown);
        return function() {
            current.removeEventListener('keydown', onKeyDown);
        };
    }, [
        SkinTonePickerRef,
        SearchInputRef,
        isOpen,
        onKeyDown
    ]);
}
function useCategoryNavigationKeyboardEvents() {
    var focusSearchInput = useFocusSearchInput();
    var CategoryNavigationRef = useCategoryNavigationRef();
    var BodyRef = useBodyRef();
    var onType = useOnType();
    var onKeyDown = (0, _react.useMemo)(function() {
        return function onKeyDown(event) {
            var key = event.key;
            switch(key){
                case KeyboardEvents.ArrowUp:
                    event.preventDefault();
                    focusSearchInput();
                    break;
                case KeyboardEvents.ArrowRight:
                    event.preventDefault();
                    focusNextElementSibling(getActiveElement());
                    break;
                case KeyboardEvents.ArrowLeft:
                    event.preventDefault();
                    focusPrevElementSibling(getActiveElement());
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    focusFirstVisibleEmoji(BodyRef.current);
                    break;
                default:
                    onType(event);
                    break;
            }
        };
    }, [
        BodyRef,
        focusSearchInput,
        onType
    ]);
    (0, _react.useEffect)(function() {
        var current = CategoryNavigationRef.current;
        if (!current) return;
        current.addEventListener('keydown', onKeyDown);
        return function() {
            current.removeEventListener('keydown', onKeyDown);
        };
    }, [
        CategoryNavigationRef,
        BodyRef,
        onKeyDown
    ]);
}
function useBodyKeyboardEvents() {
    var BodyRef = useBodyRef();
    var goUpFromBody = useGoUpFromBody();
    var setVariationPicker = useSetVariationPicker();
    var hasOpenToggles = useHasOpenToggles();
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var onType = useOnType();
    var onKeyDown = (0, _react.useMemo)(function() {
        return(// eslint-disable-next-line complexity
        function onKeyDown(event) {
            var key = event.key;
            var activeElement = buttonFromTarget(getActiveElement());
            switch(key){
                case KeyboardEvents.ArrowRight:
                    event.preventDefault();
                    focusNextVisibleEmoji(activeElement);
                    break;
                case KeyboardEvents.ArrowLeft:
                    event.preventDefault();
                    focusPrevVisibleEmoji(activeElement);
                    break;
                case KeyboardEvents.ArrowDown:
                    event.preventDefault();
                    if (hasOpenToggles()) {
                        closeAllOpenToggles();
                        break;
                    }
                    focusVisibleEmojiOneRowDown(activeElement);
                    break;
                case KeyboardEvents.ArrowUp:
                    event.preventDefault();
                    if (hasOpenToggles()) {
                        closeAllOpenToggles();
                        break;
                    }
                    focusVisibleEmojiOneRowUp(activeElement, goUpFromBody);
                    break;
                case KeyboardEvents.Space:
                    event.preventDefault();
                    setVariationPicker(event.target);
                    break;
                default:
                    onType(event);
                    break;
            }
        });
    }, [
        goUpFromBody,
        onType,
        setVariationPicker,
        hasOpenToggles,
        closeAllOpenToggles
    ]);
    (0, _react.useEffect)(function() {
        var current = BodyRef.current;
        if (!current) return;
        current.addEventListener('keydown', onKeyDown);
        return function() {
            current.removeEventListener('keydown', onKeyDown);
        };
    }, [
        BodyRef,
        onKeyDown
    ]);
}
function useGoDownFromSearchInput() {
    var focusCategoryNavigation = useFocusCategoryNavigation();
    var isSearchMode = useIsSearchMode();
    var BodyRef = useBodyRef();
    return (0, _react.useCallback)(function goDownFromSearchInput() {
        if (isSearchMode) return focusFirstVisibleEmoji(BodyRef.current);
        return focusCategoryNavigation();
    }, [
        BodyRef,
        focusCategoryNavigation,
        isSearchMode
    ]);
}
function useGoUpFromBody() {
    var focusSearchInput = useFocusSearchInput();
    var focusCategoryNavigation = useFocusCategoryNavigation();
    var isSearchMode = useIsSearchMode();
    return (0, _react.useCallback)(function goUpFromEmoji() {
        if (isSearchMode) return focusSearchInput();
        return focusCategoryNavigation();
    }, [
        focusSearchInput,
        isSearchMode,
        focusCategoryNavigation
    ]);
}
function focusNextSkinTone(exitLeft) {
    var currentSkinTone = getActiveElement();
    if (!currentSkinTone) return;
    if (!hasNextElementSibling(currentSkinTone)) exitLeft();
    focusNextElementSibling(currentSkinTone);
}
function focusPrevSkinTone() {
    var currentSkinTone = getActiveElement();
    if (!currentSkinTone) return;
    focusPrevElementSibling(currentSkinTone);
}
function useOnType() {
    var appendSearch = useAppendSearch();
    var focusSearchInput = useFocusSearchInput();
    var searchDisabled = useSearchDisabledConfig();
    var closeAllOpenToggles = useCloseAllOpenToggles();
    return function onType(event) {
        var key = event.key;
        if (hasModifier(event) || searchDisabled) return;
        if (key.match(/(^[a-zA-Z0-9]$){1}/)) {
            event.preventDefault();
            closeAllOpenToggles();
            focusSearchInput();
            appendSearch(key);
        }
    };
}
function hasModifier(event) {
    var metaKey = event.metaKey, ctrlKey = event.ctrlKey, altKey = event.altKey;
    return metaKey || ctrlKey || altKey;
}
// eslint-disable-next-line max-params
function preloadEmojiIfNeeded(emoji, emojiStyles, scrollTop, clientHeight, topOffset, style, dimensions, getEmojiUrl) {
    if (!emoji) return;
    if (emojiStyles === EmojiStyle.NATIVE) return;
    var unified = emojiUnified(emoji);
    if (preloadedEmojs.has(unified)) return;
    // preload only if the emoji is a few rows below the viewport
    if (!style || !dimensions) return;
    setTimeout(function() {
        var emojiTop = topOffset + style.top;
        var viewportBottom = scrollTop + clientHeight;
        var isJustBelowViewport = emojiTop >= viewportBottom && emojiTop < viewportBottom + dimensions.emojiSize * 2;
        if (isJustBelowViewport) preloadEmoji(getEmojiUrl, emoji, emojiStyles);
    });
}
function preloadEmoji(getEmojiUrl, emoji, emojiStyle) {
    if (!emoji) return;
    var unified = emojiUnified(emoji);
    if (preloadedEmojs.has(unified)) return;
    preloadedEmojs.add(unified);
    emojiVariations(emoji).concat(unified).forEach(function(variation) {
        var emojiUrl = getEmojiUrl(variation, emojiStyle);
        preloadImage(emojiUrl);
    });
}
var preloadedEmojs = /*#__PURE__*/ new Set();
function preloadImage(url) {
    var image = new Image();
    image.src = url;
}
function useOnFocus() {
    var BodyRef = useBodyRef();
    var emojiStyle = useEmojiStyleConfig();
    var getEmojiUrl = useGetEmojiUrlConfig();
    (0, _react.useEffect)(function() {
        if (emojiStyle === EmojiStyle.NATIVE) return;
        var bodyRef = BodyRef.current;
        bodyRef == null || bodyRef.addEventListener('focusin', onFocus);
        return function() {
            bodyRef == null || bodyRef.removeEventListener('focusin', onFocus);
        };
        function onFocus(event) {
            var button = buttonFromTarget(event.target);
            if (!button) return;
            var _emojiFromElement = emojiFromElement(button), emoji = _emojiFromElement[0];
            if (!emoji) return;
            if (emojiHasVariations$1(emoji)) preloadEmoji(getEmojiUrl, emoji, emojiStyle);
        }
    }, [
        BodyRef,
        emojiStyle,
        getEmojiUrl
    ]);
}
var _excluded$1 = [
    "width",
    "height"
];
var DEFAULT_LABEL_HEIGHT = 40;
function PickerMain(_ref) {
    var children = _ref.children;
    return (0, _react.createElement)(PickerContextProvider, null, (0, _react.createElement)(PickerRootElement, null, children));
}
function PickerRootElement(_ref2) {
    var _cx;
    var children = _ref2.children;
    var _useReactionsModeStat = useReactionsModeState(), reactionsMode = _useReactionsModeStat[0];
    var theme = useThemeConfig();
    var searchModeActive = useIsSearchMode();
    var PickerMainRef = usePickerMainRef();
    var className = useClassNameConfig();
    var style = useStyleConfig();
    useKeyboardNavigation();
    useOnFocus();
    var _ref3 = style || {}, width = _ref3.width, height = _ref3.height, styleProps = _objectWithoutPropertiesLoose(_ref3, _excluded$1);
    return (0, _react.createElement)("aside", {
        className: (0, _flairup.cx)(styles.main, styles.baseVariables, theme === Theme.DARK && styles.darkTheme, theme === Theme.AUTO && styles.autoThemeDark, (_cx = {}, _cx[ClassNames.searchActive] = searchModeActive, _cx), reactionsMode && styles.reactionsMenu, className),
        ref: PickerMainRef,
        style: _extends({}, styleProps, !reactionsMode && {
            height: height,
            width: width
        })
    }, children);
}
var DarkTheme = {
    '--epr-emoji-variation-picker-bg-color': 'var(--epr-dark-emoji-variation-picker-bg-color)',
    '--epr-hover-bg-color-reduced-opacity': 'var(--epr-dark-hover-bg-color-reduced-opacity)',
    '--epr-highlight-color': 'var(--epr-dark-highlight-color)',
    '--epr-text-color': 'var(--epr-dark-text-color)',
    '--epr-hover-bg-color': 'var(--epr-dark-hover-bg-color)',
    '--epr-focus-bg-color': 'var(--epr-dark-focus-bg-color)',
    '--epr-search-input-bg-color': 'var(--epr-dark-search-input-bg-color)',
    '--epr-category-label-bg-color': 'var(--epr-dark-category-label-bg-color)',
    '--epr-picker-border-color': 'var(--epr-dark-picker-border-color)',
    '--epr-bg-color': 'var(--epr-dark-bg-color)',
    '--epr-reactions-bg-color': 'var(--epr-dark-reactions-bg-color)',
    '--epr-search-input-bg-color-active': 'var(--epr-dark-search-input-bg-color-active)',
    '--epr-emoji-variation-indicator-color': 'var(--epr-dark-emoji-variation-indicator-color)',
    '--epr-category-icon-active-color': 'var(--epr-dark-category-icon-active-color)',
    '--epr-skin-tone-picker-menu-color': 'var(--epr-dark-skin-tone-picker-menu-color)',
    '--epr-skin-tone-outer-border-color': 'var(--epr-dark-skin-tone-outer-border-color)',
    '--epr-skin-tone-inner-border-color': 'var(--epr-dark-skin-tone-inner-border-color)'
};
var styles = /*#__PURE__*/ stylesheet.create({
    main: {
        '.': [
            'epr-main',
            ClassNames.emojiPicker
        ],
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderRadius: 'var(--epr-picker-border-radius)',
        borderColor: 'var(--epr-picker-border-color)',
        backgroundColor: 'var(--epr-bg-color)',
        overflow: 'hidden',
        transition: 'height 0.3s ease-in-out, background-color 0.1s ease-in-out',
        '*': {
            boxSizing: 'border-box',
            fontFamily: 'sans-serif'
        }
    },
    baseVariables: {
        '--': {
            '--epr-highlight-color': '#007aeb',
            '--epr-hover-bg-color': '#e5f0fa',
            '--epr-hover-bg-color-reduced-opacity': '#e5f0fa80',
            '--epr-focus-bg-color': '#e0f0ff',
            '--epr-text-color': '#858585',
            '--epr-search-input-bg-color': '#f6f6f6',
            '--epr-picker-border-color': '#e7e7e7',
            '--epr-bg-color': '#fff',
            '--epr-reactions-bg-color': '#ffffff90',
            '--epr-category-icon-active-color': '#6aa8de',
            '--epr-skin-tone-picker-menu-color': '#ffffff95',
            '--epr-skin-tone-outer-border-color': '#555555',
            '--epr-skin-tone-inner-border-color': 'var(--epr-bg-color)',
            '--epr-horizontal-padding': '10px',
            '--epr-picker-border-radius': '8px',
            /* Header */ '--epr-header-padding': '15px var(--epr-horizontal-padding)',
            /* Skin Tone Picker */ '--epr-active-skin-tone-indicator-border-color': 'var(--epr-highlight-color)',
            '--epr-active-skin-hover-color': 'var(--epr-hover-bg-color)',
            /* Search */ '--epr-search-input-bg-color-active': 'var(--epr-search-input-bg-color)',
            '--epr-search-input-padding': '0 30px',
            '--epr-search-input-border-radius': '8px',
            '--epr-search-input-height': '40px',
            '--epr-search-input-text-color': 'var(--epr-text-color)',
            '--epr-search-input-placeholder-color': 'var(--epr-text-color)',
            '--epr-search-bar-inner-padding': 'var(--epr-horizontal-padding)',
            '--epr-search-border-color': 'var(--epr-search-input-bg-color)',
            '--epr-search-border-color-active': 'var(--epr-highlight-color)',
            /*  Category Navigation */ '--epr-category-navigation-button-size': '30px',
            /* Variation Picker */ '--epr-emoji-variation-picker-height': '45px',
            '--epr-emoji-variation-picker-bg-color': 'var(--epr-bg-color)',
            /*  Preview */ '--epr-preview-height': '70px',
            '--epr-preview-text-size': '14px',
            '--epr-preview-text-padding': '0 var(--epr-horizontal-padding)',
            '--epr-preview-border-color': 'var(--epr-picker-border-color)',
            '--epr-preview-text-color': 'var(--epr-text-color)',
            /* Category */ '--epr-category-padding': '0 var(--epr-horizontal-padding)',
            /*  Category Label */ '--epr-category-label-bg-color': '#ffffffe6',
            '--epr-category-label-text-color': 'var(--epr-text-color)',
            '--epr-category-label-padding': '0 var(--epr-horizontal-padding)',
            '--epr-category-label-height': DEFAULT_LABEL_HEIGHT + "px",
            /*  Emoji */ '--epr-emoji-size': '30px',
            '--epr-emoji-padding': '5px',
            '--epr-emoji-fullsize': 'calc(var(--epr-emoji-size) + var(--epr-emoji-padding) * 2)',
            '--epr-emoji-hover-color': 'var(--epr-hover-bg-color)',
            '--epr-emoji-variation-indicator-color': 'var(--epr-picker-border-color)',
            '--epr-emoji-variation-indicator-color-hover': 'var(--epr-text-color)',
            /* Z-Index */ '--epr-header-overlay-z-index': '3',
            '--epr-emoji-variations-indictator-z-index': '1',
            '--epr-category-label-z-index': '2',
            '--epr-skin-variation-picker-z-index': '5',
            '--epr-preview-z-index': '6',
            /* Dark Theme Variables */ '--epr-dark': '#000',
            '--epr-dark-emoji-variation-picker-bg-color': 'var(--epr-dark)',
            '--epr-dark-highlight-color': '#c0c0c0',
            '--epr-dark-text-color': 'var(--epr-highlight-color)',
            '--epr-dark-hover-bg-color': '#363636f6',
            '--epr-dark-hover-bg-color-reduced-opacity': '#36363680',
            '--epr-dark-focus-bg-color': '#474747',
            '--epr-dark-search-input-bg-color': '#333333',
            '--epr-dark-category-label-bg-color': '#222222e6',
            '--epr-dark-picker-border-color': '#151617',
            '--epr-dark-bg-color': '#222222',
            '--epr-dark-reactions-bg-color': '#22222290',
            '--epr-dark-search-input-bg-color-active': 'var(--epr-dark)',
            '--epr-dark-emoji-variation-indicator-color': '#444',
            '--epr-dark-category-icon-active-color': '#3271b7',
            '--epr-dark-skin-tone-picker-menu-color': '#22222295',
            '--epr-dark-skin-tone-outer-border-color': 'var(--epr-dark-picker-border-color)',
            '--epr-dark-skin-tone-inner-border-color': '#00000000'
        }
    },
    autoThemeDark: {
        '.': ClassNames.autoTheme,
        '@media (prefers-color-scheme: dark)': {
            '--': DarkTheme
        }
    },
    darkTheme: {
        '.': ClassNames.darkTheme,
        '--': DarkTheme
    },
    reactionsMenu: {
        '.': 'epr-reactions',
        height: '50px',
        display: 'inline-flex',
        backgroundColor: 'var(--epr-reactions-bg-color)',
        // @ts-ignore - backdropFilter is not recognized.
        backdropFilter: 'blur(8px)',
        '--': {
            '--epr-picker-border-radius': '50px'
        }
    }
});
function elementCountInRow(parent, element) {
    if (!parent || !element) return 0;
    var parentWidth = parent.getBoundingClientRect().width;
    var elementWidth = element.getBoundingClientRect().width;
    return Math.floor(parentWidth / elementWidth);
}
function firstVisibleElementInContainer(parent, elements, maxVisibilityDiffThreshold) {
    if (maxVisibilityDiffThreshold === void 0) maxVisibilityDiffThreshold = 0;
    if (!parent || !elements.length) return null;
    var parentTop = parent.getBoundingClientRect().top;
    var parentBottom = parent.getBoundingClientRect().bottom;
    var parentTopWithLabel = parentTop + getLabelHeight(parent);
    var visibleElements = elements.find(function(element) {
        var elementTop = element.getBoundingClientRect().top;
        var elementBottom = element.getBoundingClientRect().bottom;
        var maxVisibilityDiffPixels = element.clientHeight * maxVisibilityDiffThreshold;
        var elementTopWithAllowedDiff = elementTop + maxVisibilityDiffPixels;
        var elementBottomWithAllowedDiff = elementBottom - maxVisibilityDiffPixels;
        if (elementTopWithAllowedDiff < parentTopWithLabel) return false;
        return elementTopWithAllowedDiff >= parentTop && elementTopWithAllowedDiff <= parentBottom || elementBottomWithAllowedDiff >= parentTop && elementBottomWithAllowedDiff <= parentBottom;
    });
    return visibleElements || null;
}
function hasNextElementSibling(element) {
    return !!element.nextElementSibling;
}
function getLabelHeight(parentNode) {
    if (!parentNode) return DEFAULT_LABEL_HEIGHT;
    var label = parentNode.querySelector(asSelectors(ClassNames.label));
    if (label) {
        var height = label.getBoundingClientRect().height;
        if (height > 0) return height;
    }
    // fallback to default
    return DEFAULT_LABEL_HEIGHT;
}
var EmojiButtonSelector = "button" + /*#__PURE__*/ asSelectors(ClassNames.emoji);
var VisibleEmojiSelector = /*#__PURE__*/ [
    EmojiButtonSelector,
    asSelectors(ClassNames.visible),
    ":not(" + asSelectors(ClassNames.hidden) + ")"
].join('');
function buttonFromTarget(emojiElement) {
    var _emojiElement$closest;
    return (_emojiElement$closest = emojiElement == null ? void 0 : emojiElement.closest(EmojiButtonSelector)) != null ? _emojiElement$closest : null;
}
function emojiFromElement(element) {
    var originalUnified = originalUnifiedFromEmojiElement(element);
    var unified = unifiedFromEmojiElement(element);
    if (!originalUnified) return [];
    var emoji = emojiByUnified(unified != null ? unified : originalUnified);
    if (!emoji) return [];
    return [
        emoji,
        unified
    ];
}
function isEmojiElement(element) {
    var _element$parentElemen;
    return Boolean((element == null ? void 0 : element.matches(EmojiButtonSelector)) || (element == null ? void 0 : (_element$parentElemen = element.parentElement) == null ? void 0 : _element$parentElemen.matches(EmojiButtonSelector)));
}
function elementHeight(element) {
    var _element$clientHeight;
    return (_element$clientHeight = element == null ? void 0 : element.clientHeight) != null ? _element$clientHeight : 0;
}
function emojiTrueOffsetTop(element) {
    if (!element) return 0;
    var button = buttonFromTarget(element);
    var category = closestCategory(button);
    // compensate for the label height
    var labelHeight = categoryLabelHeight(category);
    return elementOffsetTop(button) + elementOffsetTop(category) + labelHeight;
}
function categoryLabelHeight(category) {
    var _category$clientHeigh, _categoryWithoutLabel;
    if (!category) return 0;
    var categoryWithoutLabel = category.querySelector(asSelectors(ClassNames.categoryContent));
    return ((_category$clientHeigh = category == null ? void 0 : category.clientHeight) != null ? _category$clientHeigh : 0) - ((_categoryWithoutLabel = categoryWithoutLabel == null ? void 0 : categoryWithoutLabel.clientHeight) != null ? _categoryWithoutLabel : 0);
}
function isEmojiBehindLabel(emoji) {
    if (!emoji) return false;
    return emojiDistanceFromScrollTop(emoji) < categoryLabelHeight(closestCategory(emoji));
}
function queryScrollBody(root) {
    if (!root) return null;
    return root.matches(asSelectors(ClassNames.scrollBody)) ? root : root.querySelector(asSelectors(ClassNames.scrollBody));
}
function emojiDistanceFromScrollTop(emoji) {
    var _closestScrollBody$sc, _closestScrollBody;
    if (!emoji) return 0;
    return emojiTrueOffsetTop(emoji) - ((_closestScrollBody$sc = (_closestScrollBody = closestScrollBody(emoji)) == null ? void 0 : _closestScrollBody.scrollTop) != null ? _closestScrollBody$sc : 0);
}
function closestScrollBody(element) {
    var _element$closest;
    if (!element) return null;
    return (_element$closest = element.closest(asSelectors(ClassNames.scrollBody))) != null ? _element$closest : null;
}
function emojiTruOffsetLeft(element) {
    var button = buttonFromTarget(element);
    var category = closestCategory(button);
    return elementOffsetLeft(button) + elementOffsetLeft(category);
}
function elementOffsetTop(element) {
    var _element$offsetTop;
    return (_element$offsetTop = element == null ? void 0 : element.offsetTop) != null ? _element$offsetTop : 0;
}
function elementOffsetLeft(element) {
    var _element$offsetLeft;
    return (_element$offsetLeft = element == null ? void 0 : element.offsetLeft) != null ? _element$offsetLeft : 0;
}
function unifiedFromEmojiElement(emoji) {
    var _elementDataSetKey;
    return (_elementDataSetKey = elementDataSetKey(buttonFromTarget(emoji), 'unified')) != null ? _elementDataSetKey : null;
}
function originalUnifiedFromEmojiElement(emoji) {
    var unified = unifiedFromEmojiElement(emoji);
    if (unified) return unifiedWithoutSkinTone$1(unified);
    return null;
}
function allUnifiedFromEmojiElement(emoji) {
    if (!emoji) return {
        unified: null,
        originalUnified: null
    };
    return {
        unified: unifiedFromEmojiElement(emoji),
        originalUnified: originalUnifiedFromEmojiElement(emoji)
    };
}
function elementDataSetKey(element, key) {
    var _elementDataSet$key;
    return (_elementDataSet$key = elementDataSet(element)[key]) != null ? _elementDataSet$key : null;
}
function elementDataSet(element) {
    var _element$dataset;
    return (_element$dataset = element == null ? void 0 : element.dataset) != null ? _element$dataset : {};
}
function isVisibleEmoji(element) {
    return element.classList.contains(ClassNames.visible);
}
function isHidden(element) {
    if (!element) return true;
    return element.classList.contains(ClassNames.hidden);
}
function allVisibleEmojis(parent) {
    if (!parent) return [];
    return Array.from(parent.querySelectorAll(VisibleEmojiSelector));
}
function lastVisibleEmoji(element) {
    if (!element) return null;
    var allEmojis = allVisibleEmojis(element);
    var _allEmojis$slice = allEmojis.slice(-1), last = _allEmojis$slice[0];
    if (!last) return null;
    if (!isVisibleEmoji(last)) return prevVisibleEmoji(last);
    return last;
}
function nextVisibleEmoji(element) {
    var next = element.nextElementSibling;
    if (!next) return firstVisibleEmoji(nextCategory(element));
    if (!isVisibleEmoji(next)) return nextVisibleEmoji(next);
    return next;
}
function prevVisibleEmoji(element) {
    var prev = element.previousElementSibling;
    if (!prev) return lastVisibleEmoji(prevCategory(element));
    if (!isVisibleEmoji(prev)) return prevVisibleEmoji(prev);
    return prev;
}
function firstVisibleEmoji(parent) {
    if (!parent) return null;
    var allEmojis = allVisibleEmojis(parent);
    return firstVisibleElementInContainer(parent, allEmojis, 0.1);
}
function prevCategory(element) {
    var category = closestCategory(element);
    if (!category) return null;
    var prev = category.previousElementSibling;
    if (!prev) return null;
    if (isHidden(prev)) return prevCategory(prev);
    return prev;
}
function nextCategory(element) {
    var category = closestCategory(element);
    if (!category) return null;
    var next = category.nextElementSibling;
    if (!next) return null;
    if (isHidden(next)) return nextCategory(next);
    return next;
}
function closestCategory(element) {
    if (!element) return null;
    return element.closest(asSelectors(ClassNames.category));
}
function closestCategoryContent(element) {
    if (!element) return null;
    return element.closest(asSelectors(ClassNames.categoryContent));
}
function parseNativeEmoji(unified) {
    return unified.split('-').map(function(hex) {
        return String.fromCodePoint(parseInt(hex, 16));
    }).join('');
}
function isCustomCategory(category) {
    return category.category === Categories.CUSTOM;
}
function isCustomEmoji(emoji) {
    return emoji.imgUrl !== undefined;
}
function useMouseDownHandlers(ContainerRef, mouseEventSource) {
    var mouseDownTimerRef = (0, _react.useRef)();
    var setVariationPicker = useSetVariationPicker();
    var disallowClickRef = useDisallowClickRef();
    var _useEmojiVariationPic = useEmojiVariationPickerState(), setEmojiVariationPicker = _useEmojiVariationPic[1];
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var _useActiveSkinToneSta = useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0];
    var onEmojiClick = useOnEmojiClickConfig(mouseEventSource);
    var _useUpdateSuggested = useUpdateSuggested(), updateSuggested = _useUpdateSuggested[1];
    var getEmojiUrl = useGetEmojiUrlConfig();
    var activeEmojiStyle = useEmojiStyleConfig();
    var _usePickerDataContext = usePickerDataContext(), emojiByUnified = _usePickerDataContext.emojiByUnified;
    var onClick = (0, _react.useCallback)(function onClick(event) {
        if (disallowClickRef.current) return;
        closeAllOpenToggles();
        var _emojiFromEvent = emojiFromEvent(event, emojiByUnified), emoji = _emojiFromEvent[0], unified = _emojiFromEvent[1];
        if (!emoji || !unified) return;
        var skinToneToUse = activeVariationFromUnified$1(unified) || activeSkinTone;
        updateSuggested();
        setSuggested(emoji, skinToneToUse);
        onEmojiClick(emojiClickOutput(emoji, skinToneToUse, activeEmojiStyle, getEmojiUrl), event);
    }, [
        activeSkinTone,
        closeAllOpenToggles,
        disallowClickRef,
        emojiByUnified,
        onEmojiClick,
        updateSuggested,
        getEmojiUrl,
        activeEmojiStyle
    ]);
    var onMouseDown = (0, _react.useCallback)(function onMouseDown(event) {
        var _window;
        if (mouseDownTimerRef.current) clearTimeout(mouseDownTimerRef.current);
        var _emojiFromEvent2 = emojiFromEvent(event, emojiByUnified), emoji = _emojiFromEvent2[0];
        if (!emoji || !emojiHasVariations$1(emoji)) return;
        mouseDownTimerRef.current = (_window = window) == null ? void 0 : _window.setTimeout(function() {
            disallowClickRef.current = true;
            mouseDownTimerRef.current = undefined;
            closeAllOpenToggles();
            setVariationPicker(event.target);
            setEmojiVariationPicker(emoji);
        }, 500);
    }, [
        disallowClickRef,
        emojiByUnified,
        closeAllOpenToggles,
        setVariationPicker,
        setEmojiVariationPicker
    ]);
    var onMouseUp = (0, _react.useCallback)(function onMouseUp() {
        if (mouseDownTimerRef.current) {
            clearTimeout(mouseDownTimerRef.current);
            mouseDownTimerRef.current = undefined;
        } else if (disallowClickRef.current) // The problem we're trying to overcome here
        // is that the emoji has both mouseup and click events
        // and when releasing a mouseup event
        // the click gets triggered too
        // So we're disallowing the click event for a short time
        requestAnimationFrame(function() {
            disallowClickRef.current = false;
        });
    }, [
        disallowClickRef
    ]);
    (0, _react.useEffect)(function() {
        if (!ContainerRef.current) return;
        var confainerRef = ContainerRef.current;
        confainerRef.addEventListener('click', onClick, {
            passive: true
        });
        confainerRef.addEventListener('mousedown', onMouseDown, {
            passive: true
        });
        confainerRef.addEventListener('mouseup', onMouseUp, {
            passive: true
        });
        return function() {
            confainerRef == null || confainerRef.removeEventListener('click', onClick);
            confainerRef == null || confainerRef.removeEventListener('mousedown', onMouseDown);
            confainerRef == null || confainerRef.removeEventListener('mouseup', onMouseUp);
        };
    }, [
        ContainerRef,
        onClick,
        onMouseDown,
        onMouseUp
    ]);
}
function emojiFromEvent(event, lookupEmojiByUnified) {
    var target = event == null ? void 0 : event.target;
    if (!isEmojiElement(target)) return [];
    var _allUnifiedFromEmojiE = allUnifiedFromEmojiElement(target), unified = _allUnifiedFromEmojiE.unified, originalUnified = _allUnifiedFromEmojiE.originalUnified;
    var resolvedUnified = unified != null ? unified : originalUnified;
    if (!resolvedUnified) return [];
    var emoji = lookupEmojiByUnified(resolvedUnified);
    if (!emoji) return [];
    return [
        emoji,
        unified != null ? unified : resolvedUnified
    ];
}
function emojiClickOutput(emoji, activeSkinTone, activeEmojiStyle, getEmojiUrl) {
    var names = emojiNames$1(emoji);
    if (isCustomEmoji(emoji)) {
        var _unified = emojiUnified$1(emoji);
        return {
            activeSkinTone: activeSkinTone,
            emoji: _unified,
            getImageUrl: function getImageUrl() {
                return emoji.imgUrl;
            },
            imageUrl: emoji.imgUrl,
            isCustom: true,
            names: names,
            unified: _unified,
            unifiedWithoutSkinTone: _unified
        };
    }
    var unified = emojiUnified$1(emoji, activeSkinTone);
    return {
        activeSkinTone: activeSkinTone,
        emoji: parseNativeEmoji(unified),
        getImageUrl: function getImageUrl(emojiStyle) {
            if (emojiStyle === void 0) emojiStyle = activeEmojiStyle != null ? activeEmojiStyle : EmojiStyle.APPLE;
            return getEmojiUrl(unified, emojiStyle);
        },
        imageUrl: getEmojiUrl(unified, activeEmojiStyle != null ? activeEmojiStyle : EmojiStyle.APPLE),
        isCustom: false,
        names: names,
        unified: unified,
        unifiedWithoutSkinTone: emojiUnified$1(emoji)
    };
}
function Button(props) {
    return (0, _react.createElement)("button", Object.assign({
        type: "button"
    }, props, {
        className: (0, _flairup.cx)(styles$1.button, props.className)
    }), props.children);
}
var styles$1 = /*#__PURE__*/ stylesheet.create({
    button: {
        '.': 'epr-btn',
        cursor: 'pointer',
        border: '0',
        background: 'none',
        outline: 'none'
    }
});
function ClickableEmojiButton(_ref) {
    var _cx;
    var emojiNames = _ref.emojiNames, unified = _ref.unified, hidden = _ref.hidden, hiddenOnSearch = _ref.hiddenOnSearch, _ref$showVariations = _ref.showVariations, showVariations = _ref$showVariations === void 0 ? true : _ref$showVariations, hasVariations = _ref.hasVariations, children = _ref.children, className = _ref.className, _ref$noBackground = _ref.noBackground, noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground, style = _ref.style;
    return (0, _react.createElement)(Button, {
        className: (0, _flairup.cx)(styles$2.emoji, hidden && commonStyles.hidden, hiddenOnSearch && commonInteractionStyles.hiddenOnSearch, (_cx = {}, _cx[ClassNames.visible] = !hidden && !hiddenOnSearch, _cx), !!(hasVariations && showVariations) && styles$2.hasVariations, noBackground && styles$2.noBackground, className),
        "data-unified": unified,
        "aria-label": getAriaLabel(emojiNames),
        "data-full-name": emojiNames,
        style: style
    }, children);
}
function getAriaLabel(emojiNames) {
    return emojiNames[emojiNames.length - 1];
}
var styles$2 = /*#__PURE__*/ stylesheet.create({
    emoji: {
        '.': ClassNames.emoji,
        position: 'relative',
        width: 'var(--epr-emoji-fullsize)',
        height: 'var(--epr-emoji-fullsize)',
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        maxWidth: 'var(--epr-emoji-fullsize)',
        maxHeight: 'var(--epr-emoji-fullsize)',
        borderRadius: '8px',
        overflow: 'hidden',
        transition: 'background-color 0.2s',
        ':hover': {
            backgroundColor: 'var(--epr-emoji-hover-color)'
        },
        ':focus': {
            backgroundColor: 'var(--epr-focus-bg-color)'
        }
    },
    noBackground: {
        background: 'none',
        ':hover': {
            backgroundColor: 'transparent',
            background: 'none'
        },
        ':focus': {
            backgroundColor: 'transparent',
            background: 'none'
        }
    },
    hasVariations: {
        '.': ClassNames.emojiHasVariations,
        ':after': {
            content: '',
            display: 'block',
            width: '0',
            height: '0',
            right: '0px',
            bottom: '1px',
            position: 'absolute',
            borderLeft: '4px solid transparent',
            borderRight: '4px solid transparent',
            transform: 'rotate(135deg)',
            borderBottom: '4px solid var(--epr-emoji-variation-indicator-color)',
            zIndex: 'var(--epr-emoji-variations-indictator-z-index)'
        },
        ':hover:after': {
            borderBottom: '4px solid var(--epr-emoji-variation-indicator-color-hover)'
        }
    }
});
var emojiStyles = /*#__PURE__*/ stylesheet.create({
    external: {
        '.': ClassNames.external,
        fontSize: '0'
    },
    common: {
        alignSelf: 'center',
        justifySelf: 'center',
        display: 'block'
    }
});
function EmojiImg(_ref) {
    var emojiName = _ref.emojiName, style = _ref.style, _ref$lazyLoad = _ref.lazyLoad, lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad, imgUrl = _ref.imgUrl, onError = _ref.onError, className = _ref.className;
    return (0, _react.createElement)("img", {
        src: imgUrl,
        alt: emojiName,
        className: (0, _flairup.cx)(styles$3.emojiImag, emojiStyles.external, emojiStyles.common, className),
        loading: lazyLoad ? 'lazy' : 'eager',
        onError: onError,
        style: style
    });
}
var styles$3 = /*#__PURE__*/ stylesheet.create({
    emojiImag: {
        '.': 'epr-emoji-img',
        maxWidth: 'var(--epr-emoji-fullsize)',
        maxHeight: 'var(--epr-emoji-fullsize)',
        minWidth: 'var(--epr-emoji-fullsize)',
        minHeight: 'var(--epr-emoji-fullsize)',
        padding: 'var(--epr-emoji-padding)'
    }
});
function NativeEmoji(_ref) {
    var unified = _ref.unified, style = _ref.style, className = _ref.className;
    return (0, _react.createElement)("span", {
        className: (0, _flairup.cx)(styles$4.nativeEmoji, emojiStyles.common, emojiStyles.external, className),
        "data-unified": unified,
        style: style
    }, parseNativeEmoji(unified));
}
var styles$4 = /*#__PURE__*/ stylesheet.create({
    nativeEmoji: {
        '.': 'epr-emoji-native',
        fontFamily: '"Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "EmojiOne Color", "Android Emoji"!important',
        position: 'relative',
        lineHeight: '100%',
        fontSize: 'var(--epr-emoji-size)',
        textAlign: 'center',
        alignSelf: 'center',
        justifySelf: 'center',
        letterSpacing: '0',
        padding: 'var(--epr-emoji-padding)'
    }
});
function ViewOnlyEmoji(_ref) {
    var emoji = _ref.emoji, unified = _ref.unified, emojiStyle = _ref.emojiStyle, size = _ref.size, lazyLoad = _ref.lazyLoad, _ref$getEmojiUrl = _ref.getEmojiUrl, getEmojiUrl = _ref$getEmojiUrl === void 0 ? emojiUrlByUnified : _ref$getEmojiUrl, className = _ref.className;
    var _useEmojisThatFailedT = useEmojisThatFailedToLoadState(), setEmojisThatFailedToLoad = _useEmojisThatFailedT[1];
    var _usePickerDataContext = usePickerDataContext(), emojiByUnified = _usePickerDataContext.emojiByUnified;
    var style = {};
    if (size) style.width = style.height = style.fontSize = size + "px";
    var emojiToRender = emoji ? emoji : emojiByUnified(unified);
    if (!emojiToRender) return null;
    if (isCustomEmoji(emojiToRender)) return (0, _react.createElement)(EmojiImg, {
        style: style,
        emojiName: unified,
        emojiStyle: EmojiStyle.NATIVE,
        lazyLoad: lazyLoad,
        imgUrl: emojiToRender.imgUrl,
        onError: onError,
        className: className
    });
    return (0, _react.createElement)((0, _react.Fragment), null, emojiStyle === EmojiStyle.NATIVE ? (0, _react.createElement)(NativeEmoji, {
        unified: unified,
        style: style,
        className: className
    }) : (0, _react.createElement)(EmojiImg, {
        style: style,
        emojiName: emojiName(emojiToRender),
        emojiStyle: emojiStyle,
        lazyLoad: lazyLoad,
        imgUrl: getEmojiUrl(unified, emojiStyle),
        onError: onError,
        className: className
    }));
    function onError() {
        setEmojisThatFailedToLoad(function(prev) {
            return new Set(prev).add(unified);
        });
    }
}
function ClickableEmoji(_ref) {
    var emoji = _ref.emoji, unified = _ref.unified, hidden = _ref.hidden, hiddenOnSearch = _ref.hiddenOnSearch, emojiStyle = _ref.emojiStyle, _ref$showVariations = _ref.showVariations, showVariations = _ref$showVariations === void 0 ? true : _ref$showVariations, size = _ref.size, lazyLoad = _ref.lazyLoad, getEmojiUrl = _ref.getEmojiUrl, className = _ref.className, _ref$noBackground = _ref.noBackground, noBackground = _ref$noBackground === void 0 ? false : _ref$noBackground, style = _ref.style;
    var hasVariations = emojiHasVariations$1(emoji);
    return (0, _react.createElement)(ClickableEmojiButton, {
        hasVariations: hasVariations,
        showVariations: showVariations,
        hidden: hidden,
        hiddenOnSearch: hiddenOnSearch,
        emojiNames: emojiNames$1(emoji),
        unified: unified,
        noBackground: noBackground,
        style: style
    }, (0, _react.createElement)(ViewOnlyEmoji, {
        unified: unified,
        emoji: emoji,
        size: size,
        emojiStyle: emojiStyle,
        lazyLoad: lazyLoad,
        getEmojiUrl: getEmojiUrl,
        className: className
    }));
}
var Plus = 'data:image/svg+xml;base64,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';
function BtnPlus() {
    var _useReactionsModeStat = useReactionsModeState(), setReactionsMode = _useReactionsModeStat[1];
    return (0, _react.createElement)(Button, {
        "aria-label": "Show all Emojis",
        title: "Show all Emojis",
        tabIndex: 0,
        className: (0, _flairup.cx)(styles$5.plusSign),
        onClick: function onClick() {
            return setReactionsMode(false);
        }
    });
}
var styles$5 = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    plusSign: {
        fontSize: '20px',
        padding: '17px',
        color: 'var(--epr-text-color)',
        borderRadius: '50%',
        textAlign: 'center',
        lineHeight: '100%',
        width: '20px',
        height: '20px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'background-color 0.2s ease-in-out',
        ':after': {
            content: '',
            minWidth: '20px',
            minHeight: '20px',
            backgroundImage: "url(" + Plus + ")",
            backgroundColor: 'transparent',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '20px',
            backgroundPositionY: '0'
        },
        ':hover': {
            color: 'var(--epr-highlight-color)',
            backgroundColor: 'var(--epr-hover-bg-color-reduced-opacity)',
            ':after': {
                backgroundPositionY: '-20px'
            }
        },
        ':focus': {
            color: 'var(--epr-highlight-color)',
            backgroundColor: 'var(--epr-hover-bg-color-reduced-opacity)',
            ':after': {
                backgroundPositionY: '-40px'
            }
        }
    }
}, /*#__PURE__*/ darkMode('plusSign', {
    ':after': {
        backgroundPositionY: '-40px'
    },
    ':hover:after': {
        backgroundPositionY: '-60px'
    }
})));
function Reactions() {
    var _useReactionsModeStat = useReactionsModeState(), reactionsOpen = _useReactionsModeStat[0];
    var ReactionsRef = useReactionsRef();
    var reactions = useReactionsConfig();
    useMouseDownHandlers(ReactionsRef, MOUSE_EVENT_SOURCE.REACTIONS);
    var emojiStyle = useEmojiStyleConfig();
    var allowExpandReactions = useAllowExpandReactions();
    var getEmojiUrl = useGetEmojiUrlConfig();
    if (!reactionsOpen) return null;
    return (0, _react.createElement)("ul", {
        className: (0, _flairup.cx)(styles$6.list, !reactionsOpen && commonStyles.hidden),
        ref: ReactionsRef,
        "aria-label": "Reactions"
    }, reactions.map(function(reaction) {
        var emoji = emojiByUnified(reaction);
        if (!emoji) return null;
        return (0, _react.createElement)("li", {
            key: reaction
        }, (0, _react.createElement)(ClickableEmoji, {
            emoji: emoji,
            emojiStyle: emojiStyle,
            unified: reaction,
            showVariations: false,
            className: (0, _flairup.cx)(styles$6.emojiButton),
            noBackground: true,
            getEmojiUrl: getEmojiUrl
        }));
    }), allowExpandReactions ? (0, _react.createElement)("li", null, (0, _react.createElement)(BtnPlus, null)) : null);
}
var styles$6 = /*#__PURE__*/ stylesheet.create({
    list: {
        listStyle: 'none',
        margin: '0',
        padding: '0 5px',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        height: '100%'
    },
    emojiButton: {
        ':hover': {
            transform: 'scale(1.2)'
        },
        ':focus': {
            transform: 'scale(1.2)'
        },
        ':active': {
            transform: 'scale(1.1)'
        },
        transition: 'transform 0.2s cubic-bezier(0.175, 0.885, 0.32, 1.5)'
    }
});
function useOnScroll(BodyRef) {
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var _useState = (0, _react.useState)(0), scrollTop = _useState[0], setScrollTop = _useState[1];
    (0, _react.useEffect)(function() {
        var bodyRef = BodyRef.current;
        if (!bodyRef) return;
        bodyRef.addEventListener('scroll', onScroll, {
            passive: true
        });
        function onScroll() {
            var _bodyRef$scrollTop;
            setScrollTop((_bodyRef$scrollTop = bodyRef == null ? void 0 : bodyRef.scrollTop) != null ? _bodyRef$scrollTop : 0);
            closeAllOpenToggles();
        }
        return function() {
            bodyRef == null || bodyRef.removeEventListener('scroll', onScroll);
        };
    }, [
        BodyRef,
        closeAllOpenToggles
    ]);
    return scrollTop;
}
function shouldVirtualize(_ref) {
    var scrollTop = _ref.scrollTop, clientHeight = _ref.clientHeight, topOffset = _ref.topOffset, style = _ref.style, dimensions = _ref.dimensions;
    if (!style || !dimensions) return false;
    var emojiTop = topOffset + style.top;
    var emojiBottom = emojiTop + dimensions.emojiSize;
    var isVisible = emojiBottom + dimensions.emojiSize * 2 >= scrollTop && emojiTop <= scrollTop + clientHeight + dimensions.emojiSize;
    return !isVisible;
}
function getEmojiPositionStyle(dimensions, index) {
    return dimensions ? {
        top: Math.floor(index / dimensions.emojisPerRow) * dimensions.emojiSize,
        left: index % dimensions.emojisPerRow * dimensions.emojiSize
    } : undefined;
}
var EMOJI_SIZE_DEFAULT = 40;
function useCategoryHeight(emojiCount) {
    var EmojiListRef = useEmojiListRef();
    var _useReactionsModeStat = useReactionsModeState(), isReactionsMode = _useReactionsModeStat[0];
    var PickerMainRef = usePickerMainRef();
    var emojiSizeRef = (0, _react.useRef)();
    var _useVisibleCategories = useVisibleCategoriesState(), visibleCategories = _useVisibleCategories[0];
    var _useEmojiSizeState = useEmojiSizeState(), emojiSizeFromContext = _useEmojiSizeState[0];
    var _React$useState = (0, _react.useState)(), dimensions = _React$useState[0], setDimensions = _React$useState[1];
    // Helper to compute and store dimensions based on current DOM
    var computeAndSetDimensions = (0, _react.useCallback)(function() {
        var listEl = EmojiListRef.current;
        if (!listEl) return;
        var emojiElement = listEl.querySelector(EmojiButtonSelector);
        var measured = emojiElement == null ? void 0 : emojiElement.clientHeight;
        if (measured) emojiSizeRef.current = measured;
        var emojiSize = emojiSizeFromContext || measured || emojiSizeRef.current || EMOJI_SIZE_DEFAULT;
        var pickerWidth = listEl.clientWidth;
        if (pickerWidth === 0 || emojiSize === 0) return;
        var emojisPerRow = Math.max(1, Math.floor(pickerWidth / emojiSize));
        var rowCount = Math.ceil(emojiCount / emojisPerRow);
        var categoryHeight = rowCount * emojiSize;
        setDimensions({
            categoryHeight: categoryHeight,
            emojisPerRow: emojisPerRow,
            emojiSize: emojiSize
        });
    }, [
        EmojiListRef,
        emojiCount,
        emojiSizeFromContext
    ]);
    // Recompute on data-count changes and when reactions mode toggles
    (0, _react.useEffect)(function() {
        computeAndSetDimensions();
    }, [
        emojiCount,
        isReactionsMode,
        computeAndSetDimensions,
        visibleCategories.length
    ]);
    // Listen to transitionend on the picker root (where height transition occurs)
    (0, _react.useEffect)(function() {
        var rootEl = PickerMainRef.current;
        if (!rootEl) return;
        var handler = function handler(e) {
            var te = e;
            var prop = te.propertyName;
            if (prop === 'width' || prop === 'max-width' || prop === 'min-width' || prop === 'height' || prop === 'max-height' || prop === 'min-height') {
                if (typeof queueMicrotask === 'function') queueMicrotask(function() {
                    return computeAndSetDimensions();
                });
                else requestAnimationFrame(function() {
                    return computeAndSetDimensions();
                });
            }
        };
        rootEl.addEventListener('transitionend', handler, {
            passive: true
        });
        return function() {
            rootEl.removeEventListener('transitionend', handler);
        };
    }, [
        PickerMainRef,
        computeAndSetDimensions
    ]);
    return dimensions;
}
function useIsEmojiHidden() {
    var _useEmojisThatFailedT = useEmojisThatFailedToLoadState(), emojisThatFailedToLoad = _useEmojisThatFailedT[0];
    var isEmojiFiltered = useIsEmojiFiltered();
    return function(emoji) {
        var unified = emojiUnified(emoji);
        var failedToLoad = emojisThatFailedToLoad.has(unified);
        var filteredOut = isEmojiFiltered(unified);
        return {
            failedToLoad: failedToLoad,
            filteredOut: filteredOut,
            hidden: failedToLoad || filteredOut
        };
    };
}
function useEmojiVirtualization(_ref) {
    var categoryEmojis = _ref.categoryEmojis, topOffset = _ref.topOffset, onHeightReady = _ref.onHeightReady, scrollTop = _ref.scrollTop, isCategoryVisible = _ref.isCategoryVisible;
    var isEmojiHidden = useIsEmojiHidden();
    var lazyLoadEmojis = useLazyLoadEmojisConfig();
    var emojiStyle = useEmojiStyleConfig();
    var _useActiveSkinToneSta = useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0];
    var isEmojiDisallowed = useIsEmojiDisallowed();
    var getEmojiUrl = useGetEmojiUrlConfig();
    var showVariations = !useSkinTonesDisabledConfig();
    var BodyRef = useBodyRef();
    var virtualizedCounter = 0;
    var emojisToPush = categoryEmojis.filter(function(emoji) {
        var isDisallowed = isEmojiDisallowed(emoji);
        var _isEmojiHidden = isEmojiHidden(emoji), failedToLoad = _isEmojiHidden.failedToLoad, filteredOut = _isEmojiHidden.filteredOut, hidden = _isEmojiHidden.hidden;
        return !failedToLoad && !filteredOut && !hidden && !isDisallowed;
    });
    var dimensions = useCategoryHeight(emojisToPush.length);
    (0, _react.useEffect)(function() {
        if (dimensions) onHeightReady(dimensions.categoryHeight);
    }, [
        dimensions,
        onHeightReady,
        emojisToPush.length
    ]);
    var isVirtualized = function isVirtualized(style) {
        var _BodyRef$current$clie, _BodyRef$current;
        return dimensions && BodyRef.current && shouldVirtualize({
            scrollTop: scrollTop,
            clientHeight: (_BodyRef$current$clie = (_BodyRef$current = BodyRef.current) == null ? void 0 : _BodyRef$current.clientHeight) != null ? _BodyRef$current$clie : 0,
            topOffset: topOffset,
            style: style,
            dimensions: dimensions
        });
    };
    var emojis = emojisToPush.reduce(function(accumulator, emoji, index) {
        var unified = emojiUnified(emoji, activeSkinTone);
        var style = getEmojiPositionStyle(dimensions, index);
        if (isVirtualized(style)) {
            var _BodyRef$current$clie2, _BodyRef$current2;
            virtualizedCounter++;
            preloadEmojiIfNeeded(emoji, emojiStyle, scrollTop, (_BodyRef$current$clie2 = (_BodyRef$current2 = BodyRef.current) == null ? void 0 : _BodyRef$current2.clientHeight) != null ? _BodyRef$current$clie2 : 0, topOffset, style, dimensions, getEmojiUrl);
            return accumulator;
        }
        if (!isCategoryVisible) {
            virtualizedCounter++;
            return accumulator;
        }
        accumulator.push((0, _react.createElement)(ClickableEmoji, {
            showVariations: showVariations,
            key: unified,
            emoji: emoji,
            unified: unified,
            emojiStyle: emojiStyle,
            lazyLoad: lazyLoadEmojis,
            getEmojiUrl: getEmojiUrl,
            style: _extends({}, style, {
                position: 'absolute'
            })
        }));
        return accumulator;
    }, []);
    return {
        virtualizedCounter: virtualizedCounter,
        emojis: emojis,
        dimensions: dimensions
    };
}
function EmojiCategory(_ref) {
    var categoryConfig = _ref.categoryConfig, children = _ref.children, hidden = _ref.hidden, hiddenOnSearch = _ref.hiddenOnSearch, height = _ref.height;
    var category = categoryFromCategoryConfig(categoryConfig);
    var categoryName = categoryNameFromCategoryConfig(categoryConfig);
    return (0, _react.createElement)("li", {
        className: (0, _flairup.cx)(styles$7.category, hidden && commonStyles.hidden, hiddenOnSearch && commonInteractionStyles.hiddenOnSearch),
        "data-name": category,
        "aria-label": categoryName
    }, (0, _react.createElement)("h2", {
        className: (0, _flairup.cx)(styles$7.label)
    }, categoryName), (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$7.categoryContent),
        style: {
            height: height
        }
    }, children));
}
var styles$7 = /*#__PURE__*/ stylesheet.create({
    category: {
        '.': ClassNames.category,
        minHeight: 'calc(var(--epr-emoji-fullsize) + var(--epr-category-label-height))',
        position: 'relative'
    },
    categoryContent: {
        '.': ClassNames.categoryContent,
        display: 'grid',
        gridGap: '0',
        gridTemplateColumns: 'repeat(auto-fill, var(--epr-emoji-fullsize))',
        justifyContent: 'space-between',
        margin: 'var(--epr-category-padding)',
        position: 'relative'
    },
    label: {
        '.': ClassNames.label,
        alignItems: 'center',
        // @ts-ignore - backdropFilter is not recognized.
        backdropFilter: 'blur(3px)',
        backgroundColor: 'var(--epr-category-label-bg-color)',
        color: 'var(--epr-category-label-text-color)',
        display: 'flex',
        fontSize: '16px',
        fontWeight: 'bold',
        height: 'var(--epr-category-label-height)',
        margin: '0',
        padding: 'var(--epr-category-label-padding)',
        position: 'sticky',
        textTransform: 'capitalize',
        top: '0',
        width: '100%',
        zIndex: 'var(--epr-category-label-z-index)'
    }
});
function MeasureEmoji() {
    var categories = useCategoriesConfig();
    var getEmojisByCategory = useGetEmojisByCategory();
    var emojiStyle = useEmojiStyleConfig();
    var getEmojiUrl = useGetEmojiUrlConfig();
    var lazyLoadEmojis = useLazyLoadEmojisConfig();
    var _useActiveSkinToneSta = useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0];
    var _useEmojiSizeState = useEmojiSizeState(), emojiSize = _useEmojiSizeState[0], setEmojiSize = _useEmojiSizeState[1];
    var ref = (0, _react.useRef)(null);
    (0, _react.useLayoutEffect)(function() {
        if (ref.current) setEmojiSize(ref.current.clientHeight);
    });
    if (emojiSize) return null;
    var firstCategory = categories[0];
    var dummyEmoji = getEmojisByCategory(categoryFromCategoryConfig(firstCategory))[0];
    var unified = dummyEmoji ? emojiUnified$1(dummyEmoji, activeSkinTone) : '';
    if (!dummyEmoji) return null;
    return (0, _react.createElement)("div", {
        ref: ref
    }, (0, _react.createElement)(ClickableEmoji, {
        emoji: dummyEmoji,
        unified: unified,
        emojiStyle: emojiStyle,
        getEmojiUrl: getEmojiUrl,
        lazyLoad: lazyLoadEmojis,
        showVariations: false,
        hidden: false,
        style: {
            opacity: 0,
            pointerEvents: 'none',
            position: 'absolute',
            top: 0,
            left: 0,
            zIndex: -1,
            height: 'var(--epr-emoji-fullsize)',
            width: 'var(--epr-emoji-fullsize)'
        }
    }));
}
function EmojiList(_ref) {
    var scrollTop = _ref.scrollTop;
    var categories = useCategoriesConfig();
    var _React$useState = (0, _react.useState)({}), categoryHeights = _React$useState[0], setCategoryHeights = _React$useState[1];
    var EmojiListRef = useEmojiListRef();
    var getEmojisByCategory = useGetEmojisByCategory$1();
    var labelHeight = getLabelHeight(EmojiListRef.current);
    var topOffset = 0;
    return (0, _react.createElement)("ul", {
        className: (0, _flairup.cx)(styles$8.emojiList),
        ref: EmojiListRef
    }, (0, _react.createElement)(MeasureEmoji, null), categories.map(function(categoryConfig) {
        var category = categoryFromCategoryConfig(categoryConfig);
        var currentOffset = topOffset;
        var categoryHeight = categoryHeights[category];
        if (categoryHeight) topOffset += categoryHeight + labelHeight;
        return (0, _react.createElement)((0, _react.Suspense), {
            key: category
        }, (0, _react.createElement)(RenderCategory, {
            categoryEmojis: getEmojisByCategory(category),
            categoryConfig: categoryConfig,
            topOffset: currentOffset,
            onHeightReady: function onHeightReady(height) {
                if (categoryHeights[category] !== height) setCategoryHeights(function(prev) {
                    var _extends2;
                    return _extends({}, prev, (_extends2 = {}, _extends2[category] = height, _extends2));
                });
            },
            scrollTop: scrollTop
        }));
    }));
}
function RenderCategory(_ref2) {
    var categoryEmojis = _ref2.categoryEmojis, categoryConfig = _ref2.categoryConfig, topOffset = _ref2.topOffset, onHeightReady = _ref2.onHeightReady, scrollTop = _ref2.scrollTop;
    var _useVisibleCategories = useVisibleCategoriesState(), visibleCategories = _useVisibleCategories[0];
    var _useEmojiVirtualizati = useEmojiVirtualization({
        categoryEmojis: categoryEmojis,
        topOffset: topOffset,
        onHeightReady: onHeightReady,
        scrollTop: scrollTop,
        isCategoryVisible: visibleCategories.includes(categoryConfig.category)
    }), virtualizedCounter = _useEmojiVirtualizati.virtualizedCounter, emojis = _useEmojiVirtualizati.emojis, dimensions = _useEmojiVirtualizati.dimensions;
    return (0, _react.createElement)(EmojiCategory, {
        categoryConfig: categoryConfig,
        height: dimensions == null ? void 0 : dimensions.categoryHeight,
        // Indicates that there are no visible emojis
        // Hence, the category should be hidden
        hidden: !emojis.length && virtualizedCounter === 0
    }, emojis);
}
var styles$8 = /*#__PURE__*/ stylesheet.create({
    emojiList: {
        '.': ClassNames.emojiList,
        listStyle: 'none',
        margin: '0',
        padding: '0'
    }
});
var SVGTriangle = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSI1MHB4IgoJIGhlaWdodD0iMTVweCIgdmlld0JveD0iMCAwIDUwIDE1IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1MCAxNSIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxnIGlkPSJMYXllcl8xIj4KPC9nPgo8ZyBpZD0iTGF5ZXJfMiI+Cgk8cGF0aCBmaWxsPSIjRkZGRkZGIiBzdHJva2U9IiNFOEU3RTciIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIgZD0iTTEuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KCTxwYXRoIGZpbGw9IiMwMTAyMDIiIHN0cm9rZT0iIzE1MTYxNyIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBkPSJNMjYuODYtMC40M2w5LjgzLDExLjUzYzAuNTksMC42OSwxLjU2LDAuNjksMi4xNCwwbDkuODMtMTEuNTMiLz4KPC9nPgo8L3N2Zz4=';
var Direction;
(function(Direction) {
    Direction[Direction["Up"] = 0] = "Up";
    Direction[Direction["Down"] = 1] = "Down";
})(Direction || (Direction = {}));
// eslint-disable-next-line complexity
function EmojiVariationPicker() {
    var AnchoredEmojiRef = useAnchoredEmojiRef();
    var VariationPickerRef = useVariationPickerRef();
    var _useEmojiVariationPic = useEmojiVariationPickerState(), emoji = _useEmojiVariationPic[0];
    var emojiStyle = useEmojiStyleConfig();
    var _useVariationPickerTo = useVariationPickerTop(VariationPickerRef), getTop = _useVariationPickerTo.getTop, getMenuDirection = _useVariationPickerTo.getMenuDirection;
    var setAnchoredEmojiRef = useSetAnchoredEmojiRef();
    var getPointerStyle = usePointerStyle(VariationPickerRef);
    var getEmojiUrl = useGetEmojiUrlConfig();
    var button = buttonFromTarget(AnchoredEmojiRef.current);
    var visible = Boolean(emoji && button && emojiHasVariations$1(emoji) && button.classList.contains(ClassNames.emojiHasVariations));
    (0, _react.useEffect)(function() {
        if (!visible) return;
        focusFirstVisibleEmoji(VariationPickerRef.current);
    }, [
        VariationPickerRef,
        visible,
        AnchoredEmojiRef
    ]);
    var top, pointerStyle;
    if (!visible && AnchoredEmojiRef.current) setAnchoredEmojiRef(null);
    else {
        top = getTop();
        pointerStyle = getPointerStyle();
    }
    return (0, _react.createElement)("div", {
        ref: VariationPickerRef,
        className: (0, _flairup.cx)(styles$9.variationPicker, getMenuDirection() === Direction.Down && styles$9.pointingUp, visible && styles$9.visible),
        style: {
            top: top
        }
    }, visible && emoji ? [
        emojiUnified$1(emoji)
    ].concat(emojiVariations$1(emoji)).slice(0, 6).map(function(unified) {
        return (0, _react.createElement)(ClickableEmoji, {
            key: unified,
            emoji: emoji,
            unified: unified,
            emojiStyle: emojiStyle,
            showVariations: false,
            getEmojiUrl: getEmojiUrl
        });
    }) : null, (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$9.pointer),
        style: pointerStyle
    }));
}
function usePointerStyle(VariationPickerRef) {
    var AnchoredEmojiRef = useAnchoredEmojiRef();
    return function getPointerStyle() {
        var style = {};
        if (!VariationPickerRef.current) return style;
        if (AnchoredEmojiRef.current) {
            var button = buttonFromTarget(AnchoredEmojiRef.current);
            var offsetLeft = emojiTruOffsetLeft(button);
            if (!button) return style;
            // half of the button
            style.left = offsetLeft + (button == null ? void 0 : button.clientWidth) / 2;
        }
        return style;
    };
}
function useVariationPickerTop(VariationPickerRef) {
    var AnchoredEmojiRef = useAnchoredEmojiRef();
    var BodyRef = useBodyRef();
    var direction = Direction.Up;
    return {
        getMenuDirection: getMenuDirection,
        getTop: getTop
    };
    function getMenuDirection() {
        return direction;
    }
    function getTop() {
        direction = Direction.Up;
        var emojiOffsetTop = 0;
        if (!VariationPickerRef.current) return 0;
        var height = elementHeight(VariationPickerRef.current);
        if (AnchoredEmojiRef.current) {
            var _bodyRef$scrollTop;
            var bodyRef = BodyRef.current;
            var button = buttonFromTarget(AnchoredEmojiRef.current);
            var buttonHeight = elementHeight(button);
            emojiOffsetTop = emojiTrueOffsetTop(button);
            var scrollTop = (_bodyRef$scrollTop = bodyRef == null ? void 0 : bodyRef.scrollTop) != null ? _bodyRef$scrollTop : 0;
            if (scrollTop > emojiOffsetTop - height) {
                direction = Direction.Down;
                emojiOffsetTop += buttonHeight + height;
            }
        }
        return emojiOffsetTop - height;
    }
}
var styles$9 = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    variationPicker: {
        '.': ClassNames.variationPicker,
        position: 'absolute',
        right: '15px',
        left: '15px',
        padding: '5px',
        boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.2)',
        borderRadius: '3px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        opacity: '0',
        visibility: 'hidden',
        pointerEvents: 'none',
        top: '-100%',
        border: '1px solid var(--epr-picker-border-color)',
        height: 'var(--epr-emoji-variation-picker-height)',
        zIndex: 'var(--epr-skin-variation-picker-z-index)',
        background: 'var(--epr-emoji-variation-picker-bg-color)',
        transform: 'scale(0.9)',
        transition: 'transform 0.1s ease-out, opacity 0.2s ease-out'
    },
    visible: {
        opacity: '1',
        visibility: 'visible',
        pointerEvents: 'all',
        transform: 'scale(1)'
    },
    pointingUp: {
        '.': 'pointing-up',
        transformOrigin: 'center 0%',
        transform: 'scale(0.9)'
    },
    '.pointing-up': {
        pointer: {
            top: '0',
            transform: 'rotate(180deg) translateY(100%) translateX(18px)'
        }
    },
    pointer: {
        '.': 'epr-emoji-pointer',
        content: '',
        position: 'absolute',
        width: '25px',
        height: '15px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0 0',
        backgroundSize: '50px 15px',
        top: '100%',
        transform: 'translateX(-18px)',
        backgroundImage: "url(" + SVGTriangle + ")"
    }
}, /*#__PURE__*/ darkMode('pointer', {
    backgroundPosition: '-25px 0'
})));
function Body() {
    var BodyRef = useBodyRef();
    var scrollTop = useOnScroll(BodyRef);
    useMouseDownHandlers(BodyRef, MOUSE_EVENT_SOURCE.PICKER);
    useOnMouseMove();
    return (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$a.body, commonInteractionStyles.hiddenOnReactions),
        ref: BodyRef
    }, (0, _react.createElement)(EmojiVariationPicker, null), (0, _react.createElement)(EmojiList, {
        scrollTop: scrollTop
    }));
}
var styles$a = /*#__PURE__*/ stylesheet.create({
    body: {
        '.': ClassNames.scrollBody,
        flex: '1',
        overflowY: 'scroll',
        overflowX: 'hidden',
        position: 'relative'
    }
});
function detectEmojyPartiallyBelowFold(button, bodyRef) {
    if (!button || !bodyRef) return 0;
    var buttonRect = button.getBoundingClientRect();
    var bodyRect = bodyRef.getBoundingClientRect();
    // If the element is obscured by at least half of its size
    return bodyRect.height - (buttonRect.y - bodyRect.y);
}
function useEmojiPreviewEvents(allow, setPreviewEmoji) {
    var BodyRef = useBodyRef();
    var isMouseDisallowed = useIsMouseDisallowed();
    var allowMouseMove = useAllowMouseMove();
    (0, _react.useEffect)(function() {
        if (!allow) return;
        var bodyRef = BodyRef.current;
        bodyRef == null || bodyRef.addEventListener('keydown', onEscape, {
            passive: true
        });
        bodyRef == null || bodyRef.addEventListener('mouseover', onMouseOver, true);
        bodyRef == null || bodyRef.addEventListener('focus', onEnter, true);
        bodyRef == null || bodyRef.addEventListener('mouseout', onLeave, {
            passive: true
        });
        bodyRef == null || bodyRef.addEventListener('blur', onLeave, true);
        function onEnter(e) {
            var button = buttonFromTarget(e.target);
            if (!button) return onLeave();
            var _allUnifiedFromEmojiE = allUnifiedFromEmojiElement(button), unified = _allUnifiedFromEmojiE.unified, originalUnified = _allUnifiedFromEmojiE.originalUnified;
            if (!unified || !originalUnified) return onLeave();
            setPreviewEmoji({
                unified: unified,
                originalUnified: originalUnified
            });
        }
        function onLeave(e) {
            if (e) {
                var relatedTarget = e.relatedTarget;
                if (!buttonFromTarget(relatedTarget)) return setPreviewEmoji(null);
            }
            setPreviewEmoji(null);
        }
        function onEscape(e) {
            if (e.key === 'Escape') setPreviewEmoji(null);
        }
        function onMouseOver(e) {
            if (isMouseDisallowed()) return;
            var button = buttonFromTarget(e.target);
            if (button) {
                var belowFoldByPx = detectEmojyPartiallyBelowFold(button, bodyRef);
                var buttonHeight = button.getBoundingClientRect().height;
                if (belowFoldByPx < buttonHeight) return handlePartiallyVisibleElementFocus(button, setPreviewEmoji);
                focusElement(button);
            }
        }
        return function() {
            bodyRef == null || bodyRef.removeEventListener('mouseover', onMouseOver);
            bodyRef == null || bodyRef.removeEventListener('mouseout', onLeave);
            bodyRef == null || bodyRef.removeEventListener('focus', onEnter, true);
            bodyRef == null || bodyRef.removeEventListener('blur', onLeave, true);
            bodyRef == null || bodyRef.removeEventListener('keydown', onEscape);
        };
    }, [
        BodyRef,
        allow,
        setPreviewEmoji,
        isMouseDisallowed,
        allowMouseMove
    ]);
}
function handlePartiallyVisibleElementFocus(button, setPreviewEmoji) {
    var _document$activeEleme;
    var _allUnifiedFromEmojiE2 = allUnifiedFromEmojiElement(button), unified = _allUnifiedFromEmojiE2.unified, originalUnified = _allUnifiedFromEmojiE2.originalUnified;
    if (!unified || !originalUnified) return;
    (_document$activeEleme = document.activeElement) == null || _document$activeEleme.blur == null || _document$activeEleme.blur();
    setPreviewEmoji({
        unified: unified,
        originalUnified: originalUnified
    });
}
var _stylesheet$create;
var FlexDirection;
(function(FlexDirection) {
    FlexDirection["ROW"] = "FlexRow";
    FlexDirection["COLUMN"] = "FlexColumn";
})(FlexDirection || (FlexDirection = {}));
function Flex(_ref) {
    var children = _ref.children, className = _ref.className, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style, _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? FlexDirection.ROW : _ref$direction;
    return (0, _react.createElement)("div", {
        style: _extends({}, style),
        className: (0, _flairup.cx)(styles$b.flex, className, styles$b[direction])
    }, children);
}
var styles$b = /*#__PURE__*/ stylesheet.create((_stylesheet$create = {
    flex: {
        display: 'flex'
    }
}, _stylesheet$create[FlexDirection.ROW] = {
    flexDirection: 'row'
}, _stylesheet$create[FlexDirection.COLUMN] = {
    flexDirection: 'column'
}, _stylesheet$create));
function Space(_ref) {
    var className = _ref.className, _ref$style = _ref.style, style = _ref$style === void 0 ? {} : _ref$style;
    return (0, _react.createElement)("div", {
        style: _extends({
            flex: 1
        }, style),
        className: (0, _flairup.cx)(className)
    });
}
function Absolute(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style;
    return (0, _react.createElement)("div", {
        style: _extends({}, style, {
            position: 'absolute'
        }),
        className: className
    }, children);
}
function Relative(_ref) {
    var children = _ref.children, className = _ref.className, style = _ref.style;
    return (0, _react.createElement)("div", {
        style: _extends({}, style, {
            position: 'relative'
        }),
        className: className
    }, children);
}
// eslint-disable-next-line complexity
function BtnSkinToneVariation(_ref) {
    var isOpen = _ref.isOpen, onClick = _ref.onClick, isActive = _ref.isActive, skinToneVariation = _ref.skinToneVariation, style = _ref.style;
    return (0, _react.createElement)(Button, {
        style: style,
        onClick: onClick,
        className: (0, _flairup.cx)("epr-tone-" + skinToneVariation, styles$c.tone, !isOpen && styles$c.closedTone, isActive && styles$c.active),
        "aria-pressed": isActive,
        "aria-label": "Skin tone " + skinTonesNamed[skinToneVariation]
    });
}
var styles$c = /*#__PURE__*/ stylesheet.create({
    closedTone: {
        opacity: '0',
        zIndex: '0'
    },
    active: {
        '.': 'epr-active',
        zIndex: '1',
        opacity: '1'
    },
    tone: {
        '.': 'epr-tone',
        width: 'var(--epr-skin-tone-size)',
        display: 'block',
        cursor: 'pointer',
        borderRadius: '4px',
        height: 'var(--epr-skin-tone-size)',
        position: 'absolute',
        right: '0',
        transition: 'transform 0.3s ease-in-out, opacity 0.35s ease-in-out',
        zIndex: '0',
        border: '1px solid var(--epr-skin-tone-outer-border-color)',
        boxShadow: 'inset 0px 0px 0 1px var(--epr-skin-tone-inner-border-color)',
        ':hover': {
            boxShadow: '0 0 0 3px var(--epr-active-skin-hover-color), inset 0px 0px 0 1px var(--epr-skin-tone-inner-border-color)'
        },
        ':focus': {
            boxShadow: '0 0 0 3px var(--epr-focus-bg-color)'
        },
        '&.epr-tone-neutral': {
            backgroundColor: '#ffd225'
        },
        '&.epr-tone-1f3fb': {
            backgroundColor: '#ffdfbd'
        },
        '&.epr-tone-1f3fc': {
            backgroundColor: '#e9c197'
        },
        '&.epr-tone-1f3fd': {
            backgroundColor: '#c88e62'
        },
        '&.epr-tone-1f3fe': {
            backgroundColor: '#a86637'
        },
        '&.epr-tone-1f3ff': {
            backgroundColor: '#60463a'
        }
    }
});
/* eslint-disable complexity */ var ITEM_SIZE = 28;
function SkinTonePickerMenu() {
    return (0, _react.createElement)(Relative, {
        style: {
            height: ITEM_SIZE
        }
    }, (0, _react.createElement)(Absolute, {
        style: {
            bottom: 0,
            right: 0
        }
    }, (0, _react.createElement)(SkinTonePicker, {
        direction: SkinTonePickerDirection.VERTICAL
    })));
}
function SkinTonePicker(_ref) {
    var _ref$direction = _ref.direction, direction = _ref$direction === void 0 ? SkinTonePickerDirection.HORIZONTAL : _ref$direction;
    var SkinTonePickerRef = useSkinTonePickerRef();
    var isDisabled = useSkinTonesDisabledConfig();
    var _useSkinToneFanOpenSt = useSkinToneFanOpenState(), isOpen = _useSkinToneFanOpenSt[0], setIsOpen = _useSkinToneFanOpenSt[1];
    var _useActiveSkinToneSta = useActiveSkinToneState(), activeSkinTone = _useActiveSkinToneSta[0], setActiveSkinTone = _useActiveSkinToneSta[1];
    var onSkinToneChange = useOnSkinToneChangeConfig();
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var focusSearchInput = useFocusSearchInput();
    if (isDisabled) return null;
    var fullWidth = ITEM_SIZE * skinToneVariations.length + "px";
    var expandedSize = isOpen ? fullWidth : ITEM_SIZE + 'px';
    var vertical = direction === SkinTonePickerDirection.VERTICAL;
    return (0, _react.createElement)(Relative, {
        className: (0, _flairup.cx)(styles$d.skinTones, vertical && styles$d.vertical, isOpen && styles$d.open, vertical && isOpen && styles$d.verticalShadow),
        style: vertical ? {
            flexBasis: expandedSize,
            height: expandedSize
        } : {
            flexBasis: expandedSize
        }
    }, (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$d.select),
        ref: SkinTonePickerRef
    }, skinToneVariations.map(function(skinToneVariation, i) {
        var active = skinToneVariation === activeSkinTone;
        return (0, _react.createElement)(BtnSkinToneVariation, {
            key: skinToneVariation,
            skinToneVariation: skinToneVariation,
            isOpen: isOpen,
            style: {
                transform: (0, _flairup.cx)(vertical ? "translateY(-" + i * (isOpen ? ITEM_SIZE : 0) + "px)" : "translateX(-" + i * (isOpen ? ITEM_SIZE : 0) + "px)", isOpen && active && 'scale(1.3)')
            },
            isActive: active,
            onClick: function onClick() {
                if (isOpen) {
                    setActiveSkinTone(skinToneVariation);
                    onSkinToneChange(skinToneVariation);
                    focusSearchInput();
                } else setIsOpen(true);
                closeAllOpenToggles();
            }
        });
    })));
}
var SkinTonePickerDirection;
(function(SkinTonePickerDirection) {
    SkinTonePickerDirection["VERTICAL"] = "epr-vertical";
    SkinTonePickerDirection["HORIZONTAL"] = "epr-horizontal";
})(SkinTonePickerDirection || (SkinTonePickerDirection = {}));
var styles$d = /*#__PURE__*/ stylesheet.create({
    skinTones: {
        '.': 'epr-skin-tones',
        '--': {
            '--epr-skin-tone-size': '15px'
        },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        transition: 'all 0.3s ease-in-out',
        padding: '10px 0'
    },
    vertical: {
        padding: '9px',
        alignItems: 'flex-end',
        flexDirection: 'column',
        borderRadius: '6px',
        border: '1px solid var(--epr-bg-color)'
    },
    verticalShadow: {
        boxShadow: '0px 0 7px var(--epr-picker-border-color)'
    },
    open: {
        // @ts-ignore - backdropFilter is not recognized.
        backdropFilter: 'blur(5px)',
        background: 'var(--epr-skin-tone-picker-menu-color)',
        '.epr-active': {
            border: '1px solid var(--epr-active-skin-tone-indicator-border-color)'
        }
    },
    select: {
        '.': 'epr-skin-tone-select',
        position: 'relative',
        width: 'var(--epr-skin-tone-size)',
        height: 'var(--epr-skin-tone-size)'
    }
});
function Preview() {
    var previewConfig = usePreviewConfig();
    var isSkinToneInPreview = useIsSkinToneInPreview();
    var _useReactionsModeStat = useReactionsModeState(), reactionsOpen = _useReactionsModeStat[0];
    if (!previewConfig.showPreview) return null;
    return (0, _react.createElement)(Flex, {
        className: (0, _flairup.cx)(styles$e.preview, commonInteractionStyles.hiddenOnReactions, reactionsOpen && styles$e.hideOnReactions)
    }, (0, _react.createElement)(PreviewBody, null), (0, _react.createElement)(Space, null), isSkinToneInPreview ? (0, _react.createElement)(SkinTonePickerMenu, null) : null);
}
function PreviewBody() {
    var _previewEmoji$unified;
    var previewConfig = usePreviewConfig();
    var _useState = (0, _react.useState)(null), previewEmoji = _useState[0], setPreviewEmoji = _useState[1];
    var emojiStyle = useEmojiStyleConfig();
    var _useEmojiVariationPic = useEmojiVariationPickerState(), variationPickerEmoji = _useEmojiVariationPic[0];
    var getEmojiUrl = useGetEmojiUrlConfig();
    var _usePickerDataContext = usePickerDataContext(), emojiByUnified = _usePickerDataContext.emojiByUnified;
    useEmojiPreviewEvents(previewConfig.showPreview, setPreviewEmoji);
    var emoji = emojiByUnified((_previewEmoji$unified = previewEmoji == null ? void 0 : previewEmoji.unified) != null ? _previewEmoji$unified : previewEmoji == null ? void 0 : previewEmoji.originalUnified);
    var show = emoji != null && previewEmoji != null;
    return (0, _react.createElement)(PreviewContent, null);
    function PreviewContent() {
        var defaultEmoji = variationPickerEmoji != null ? variationPickerEmoji : emojiByUnified(previewConfig.defaultEmoji);
        if (!defaultEmoji) return null;
        var defaultText = variationPickerEmoji ? emojiName$1(variationPickerEmoji) : previewConfig.defaultCaption;
        return (0, _react.createElement)((0, _react.Fragment), null, (0, _react.createElement)("div", null, show ? (0, _react.createElement)(ViewOnlyEmoji, {
            unified: previewEmoji == null ? void 0 : previewEmoji.unified,
            emoji: emoji,
            emojiStyle: emojiStyle,
            size: 45,
            getEmojiUrl: getEmojiUrl,
            className: (0, _flairup.cx)(styles$e.emoji)
        }) : defaultEmoji ? (0, _react.createElement)(ViewOnlyEmoji, {
            unified: emojiUnified$1(defaultEmoji),
            emoji: defaultEmoji,
            emojiStyle: emojiStyle,
            size: 45,
            getEmojiUrl: getEmojiUrl,
            className: (0, _flairup.cx)(styles$e.emoji)
        }) : null), (0, _react.createElement)("div", {
            className: (0, _flairup.cx)(styles$e.label)
        }, show ? emojiName$1(emoji) : defaultText));
    }
}
var styles$e = /*#__PURE__*/ stylesheet.create({
    preview: {
        alignItems: 'center',
        borderTop: '1px solid var(--epr-preview-border-color)',
        height: 'var(--epr-preview-height)',
        padding: '0 var(--epr-horizontal-padding)',
        position: 'relative',
        zIndex: 'var(--epr-preview-z-index)'
    },
    label: {
        color: 'var(--epr-preview-text-color)',
        fontSize: 'var(--epr-preview-text-size)',
        padding: 'var(--epr-preview-text-padding)',
        textTransform: 'capitalize'
    },
    emoji: {
        padding: '0'
    },
    hideOnReactions: {
        opacity: '0',
        transition: 'opacity 0.5s ease-in-out'
    }
});
function categoryNameFromDom($category) {
    var _$category$getAttribu;
    return (_$category$getAttribu = $category == null ? void 0 : $category.getAttribute('data-name')) != null ? _$category$getAttribu : null;
}
function useActiveCategoryScrollDetection(_ref) {
    var setActiveCategory = _ref.setActiveCategory, setVisibleCategories = _ref.setVisibleCategories;
    var BodyRef = useBodyRef();
    (0, _react.useEffect)(function() {
        var visibleCategories = new Map();
        var intersectingCategories = new Map();
        var bodyRef = BodyRef.current;
        var observer = new IntersectionObserver(function(entries) {
            if (!bodyRef) return;
            for(var _iterator = _createForOfIteratorHelperLoose(entries), _step; !(_step = _iterator()).done;){
                var entry = _step.value;
                var _id = categoryNameFromDom(entry.target);
                if (!_id) continue;
                visibleCategories.set(_id, entry.intersectionRatio);
                intersectingCategories.set(_id, entry.isIntersecting);
            }
            var ratios = Array.from(visibleCategories);
            var visibleCats = ratios.filter(function(_ref2) {
                var id = _ref2[0], ratio = _ref2[1];
                return ratio > 0 || intersectingCategories.get(id);
            }).map(function(_ref3) {
                var id = _ref3[0];
                return id;
            });
            setVisibleCategories(visibleCats);
            var lastCategory = ratios[ratios.length - 1];
            if ((lastCategory == null ? void 0 : lastCategory[1]) == 1) return setActiveCategory(lastCategory[0]);
            for(var _i = 0, _ratios = ratios; _i < _ratios.length; _i++){
                var _ratios$_i = _ratios[_i], id = _ratios$_i[0], ratio = _ratios$_i[1];
                if (ratio) {
                    setActiveCategory(id);
                    break;
                }
            }
        }, {
            root: bodyRef,
            threshold: [
                0,
                1
            ]
        });
        bodyRef == null || bodyRef.querySelectorAll(asSelectors(ClassNames.category)).forEach(function(el) {
            observer.observe(el);
        });
        return function() {
            observer.disconnect();
        };
    }, [
        BodyRef,
        setActiveCategory,
        setVisibleCategories
    ]);
}
function useScrollCategoryIntoView() {
    var BodyRef = useBodyRef();
    var PickerMainRef = usePickerMainRef();
    return function scrollCategoryIntoView(category) {
        var _BodyRef$current;
        if (!BodyRef.current) return;
        var $category = (_BodyRef$current = BodyRef.current) == null ? void 0 : _BodyRef$current.querySelector("[data-name=\"" + category + "\"]");
        if (!$category) return;
        var offsetTop = $category.offsetTop || 0;
        scrollTo(PickerMainRef.current, offsetTop);
    };
}
function useShouldHideCustomEmojis() {
    var customCategoryConfig = useCustomEmojisConfig();
    if (!customCategoryConfig) return false;
    return customCategoryConfig.length === 0;
}
var SVGNavigation = 'data:image/svg+xml;base64,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';
function CategoryButton(_ref) {
    var _categoryConfig$icon, _cx;
    var isActiveCategory = _ref.isActiveCategory, category = _ref.category, allowNavigation = _ref.allowNavigation, categoryConfig = _ref.categoryConfig, onClick = _ref.onClick, customIcon = _ref.customIcon;
    // Priority: categoryConfig.icon > customIcon prop (from categoryIcons)
    var icon = (_categoryConfig$icon = categoryConfig.icon) != null ? _categoryConfig$icon : customIcon;
    var hasCustomIcon = icon != null;
    return (0, _react.createElement)(Button, {
        tabIndex: allowNavigation ? 0 : -1,
        className: (0, _flairup.cx)(styles$f.catBtn, commonInteractionStyles.categoryBtn, hasCustomIcon ? styles$f.customIcon : "epr-icn-" + category, (_cx = {}, _cx[ClassNames.active] = isActiveCategory, _cx)),
        onClick: onClick,
        "aria-label": categoryNameFromCategoryConfig(categoryConfig),
        "aria-selected": isActiveCategory,
        role: "tab",
        "aria-controls": "epr-category-nav-id"
    }, hasCustomIcon ? icon : null);
}
var DarkActivePositionY = {
    backgroundPositionY: 'calc(var(--epr-category-navigation-button-size) * 3)'
};
var DarkPositionY = {
    backgroundPositionY: 'calc(var(--epr-category-navigation-button-size) * 2)'
};
var DarkInactivePosition = {
    ':not(.epr-search-active)': {
        catBtn: {
            ':hover': DarkActivePositionY,
            '&.epr-active': DarkActivePositionY
        }
    }
};
var styles$f = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    catBtn: {
        '.': 'epr-cat-btn',
        display: 'inline-block',
        transition: 'opacity 0.2s ease-in-out',
        position: 'relative',
        height: 'var(--epr-category-navigation-button-size)',
        width: 'var(--epr-category-navigation-button-size)',
        backgroundSize: 'calc(var(--epr-category-navigation-button-size) * 10)',
        outline: 'none',
        backgroundPosition: '0 0',
        backgroundImage: "url(" + SVGNavigation + ")",
        ':focus:before': {
            content: '',
            position: 'absolute',
            top: '-2px',
            left: '-2px',
            right: '-2px',
            bottom: '-2px',
            border: '2px solid var(--epr-category-icon-active-color)',
            borderRadius: '50%'
        },
        '&.epr-icn-suggested': {
            backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -8)'
        },
        '&.epr-icn-custom': {
            backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -9)'
        },
        '&.epr-icn-activities': {
            backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -4)'
        },
        '&.epr-icn-animals_nature': {
            backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -1)'
        },
        '&.epr-icn-flags': {
            backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -7)'
        },
        '&.epr-icn-food_drink': {
            backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -2)'
        },
        '&.epr-icn-objects': {
            backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -5)'
        },
        '&.epr-icn-smileys_people': {
            backgroundPositionX: '0px'
        },
        '&.epr-icn-symbols': {
            backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -6)'
        },
        '&.epr-icn-travel_places': {
            backgroundPositionX: 'calc(var(--epr-category-navigation-button-size) * -3)'
        }
    },
    customIcon: {
        '.': 'epr-cat-btn-custom-icon',
        backgroundImage: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    }
}, /*#__PURE__*/ darkMode('catBtn', DarkPositionY), {
    '.epr-dark-theme': /*#__PURE__*/ _extends({}, DarkInactivePosition),
    '.epr-auto-theme': /*#__PURE__*/ _extends({}, DarkInactivePosition)
}));
function CategoryNavigation() {
    var _useState = (0, _react.useState)(null), activeCategory = _useState[0], setActiveCategory = _useState[1];
    var _useVisibleCategories = useVisibleCategoriesState(), setVisibleCategories = _useVisibleCategories[1];
    var scrollCategoryIntoView = useScrollCategoryIntoView();
    useActiveCategoryScrollDetection({
        setActiveCategory: setActiveCategory,
        setVisibleCategories: setVisibleCategories
    });
    var isSearchMode = useIsSearchMode();
    var categoriesConfig = useCategoriesConfig();
    var categoryIcons = useCategoryIconsConfig();
    var CategoryNavigationRef = useCategoryNavigationRef();
    var hideCustomCategory = useShouldHideCustomEmojis();
    return (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$g.nav),
        role: "tablist",
        "aria-label": "Category navigation",
        id: "epr-category-nav-id",
        ref: CategoryNavigationRef
    }, categoriesConfig.map(function(categoryConfig) {
        var category = categoryFromCategoryConfig(categoryConfig);
        var isActiveCategory = category === activeCategory;
        if (isCustomCategory(categoryConfig) && hideCustomCategory) return null;
        var allowNavigation = !isSearchMode && !isActiveCategory;
        return (0, _react.createElement)(CategoryButton, {
            key: category,
            category: category,
            isActiveCategory: isActiveCategory,
            allowNavigation: allowNavigation,
            categoryConfig: categoryConfig,
            customIcon: categoryIcons[category],
            onClick: function onClick() {
                scrollCategoryIntoView(category);
                setTimeout(function() {
                    setActiveCategory(category);
                }, 10);
            }
        });
    }));
}
var styles$g = /*#__PURE__*/ stylesheet.create({
    nav: {
        '.': 'epr-category-nav',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-around',
        padding: 'var(--epr-header-padding)'
    },
    '.epr-search-active': {
        nav: {
            opacity: '0.3',
            cursor: 'default',
            pointerEvents: 'none'
        }
    },
    '.epr-main:has(input:not(:placeholder-shown))': {
        nav: {
            opacity: '0.3',
            cursor: 'default',
            pointerEvents: 'none'
        }
    }
});
var SVGTimes = 'data:image/svg+xml;base64,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';
function BtnClearSearch() {
    var clearSearch = useClearSearch();
    var searchClearButtonLabel = useSearchClearButtonLabelConfig();
    return (0, _react.createElement)(Button, {
        className: (0, _flairup.cx)(styles$h.btnClearSearch, commonInteractionStyles.visibleOnSearchOnly),
        onClick: clearSearch,
        "aria-label": searchClearButtonLabel,
        title: searchClearButtonLabel
    }, (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$h.icnClearnSearch)
    }));
}
var HoverDark = {
    ':hover': {
        '> .epr-icn-clear-search': {
            backgroundPositionY: '-60px'
        }
    }
};
var styles$h = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    btnClearSearch: {
        '.': 'epr-btn-clear-search',
        position: 'absolute',
        right: 'var(--epr-search-bar-inner-padding)',
        height: '30px',
        width: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        top: '50%',
        transform: 'translateY(-50%)',
        padding: '0',
        borderRadius: '50%',
        ':hover': {
            background: 'var(--epr-hover-bg-color)'
        },
        ':focus': {
            background: 'var(--epr-hover-bg-color)'
        }
    },
    icnClearnSearch: {
        '.': 'epr-icn-clear-search',
        backgroundColor: 'transparent',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '20px',
        height: '20px',
        width: '20px',
        backgroundImage: "url(" + SVGTimes + ")",
        ':hover': {
            backgroundPositionY: '-20px'
        },
        ':focus': {
            backgroundPositionY: '-20px'
        }
    }
}, /*#__PURE__*/ darkMode('icnClearnSearch', {
    backgroundPositionY: '-40px'
}), /*#__PURE__*/ darkMode('btnClearSearch', HoverDark)));
var SVGMagnifier = 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI2LjMuMSwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSIyMHB4IiBoZWlnaHQ9IjQwcHgiIHZpZXdCb3g9IjAgMCAyMCA0MCIgZW5hYmxlLWJhY2tncm91bmQ9Im5ldyAwIDAgMjAgNDAiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iIzg2ODY4NiIgZD0iTTEyLDguODFjMCwyLjA4LTEuNjgsMy43Ni0zLjc2LDMuNzZjLTIuMDgsMC0zLjc2LTEuNjgtMy43Ni0zLjc2CgljMC0yLjA4LDEuNjgtMy43NiwzLjc2LTMuNzZDMTAuMzIsNS4wNSwxMiw2LjczLDEyLDguODF6IE0xMS4yMywxMi43MmMtMC44MywwLjY0LTEuODcsMS4wMS0yLjk5LDEuMDFjLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTIKCWMwLTIuNzIsMi4yLTQuOTIsNC45Mi00LjkyYzIuNzIsMCw0LjkyLDIuMiw0LjkyLDQuOTJjMCwxLjEzLTAuMzgsMi4xNi0xLjAxLDIuOTlsMy45NCwzLjkzYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyCgljLTAuMjUsMC4yNS0wLjY2LDAuMjUtMC45MiwwTDExLjIzLDEyLjcyeiIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0MwQzBCRiIgZD0iTTEyLDI4LjgxYzAsMi4wOC0xLjY4LDMuNzYtMy43NiwzLjc2Yy0yLjA4LDAtMy43Ni0xLjY4LTMuNzYtMy43NgoJYzAtMi4wOCwxLjY4LTMuNzYsMy43Ni0zLjc2QzEwLjMyLDI1LjA1LDEyLDI2LjczLDEyLDI4LjgxeiBNMTEuMjMsMzIuNzJjLTAuODMsMC42NC0xLjg3LDEuMDEtMi45OSwxLjAxCgljLTIuNzIsMC00LjkyLTIuMi00LjkyLTQuOTJjMC0yLjcyLDIuMi00LjkyLDQuOTItNC45MmMyLjcyLDAsNC45MiwyLjIsNC45Miw0LjkyYzAsMS4xMy0wLjM4LDIuMTYtMS4wMSwyLjk5bDMuOTQsMy45MwoJYzAuMjUsMC4yNSwwLjI1LDAuNjYsMCwwLjkyYy0wLjI1LDAuMjUtMC42NiwwLjI1LTAuOTIsMEwxMS4yMywzMi43MnoiLz4KPC9zdmc+';
function IcnSearch() {
    return (0, _react.createElement)("div", {
        className: (0, _flairup.cx)(styles$i.icnSearch)
    });
}
var styles$i = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    icnSearch: {
        '.': 'epr-icn-search',
        content: '',
        position: 'absolute',
        top: '50%',
        left: 'var(--epr-search-bar-inner-padding)',
        transform: 'translateY(-50%)',
        width: '20px',
        height: '20px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '0 0',
        backgroundSize: '20px',
        backgroundImage: "url(" + SVGMagnifier + ")"
    }
}, /*#__PURE__*/ darkMode('icnSearch', {
    backgroundPositionY: '-20px'
})));
function SearchContainer() {
    var searchDisabled = useSearchDisabledConfig();
    var isSkinToneInSearch = useIsSkinToneInSearch();
    if (searchDisabled) return null;
    return (0, _react.createElement)(Flex, {
        className: (0, _flairup.cx)(styles$j.overlay)
    }, (0, _react.createElement)(Search, null), isSkinToneInSearch ? (0, _react.createElement)(SkinTonePicker, null) : null);
}
function Search() {
    var closeAllOpenToggles = useCloseAllOpenToggles();
    var SearchInputRef = useSearchInputRef();
    var placeholder = useSearchPlaceHolderConfig();
    var autoFocus = useAutoFocusSearchConfig();
    var _useFilter = useFilter(), statusSearchResults = _useFilter.statusSearchResults, searchTerm = _useFilter.searchTerm, _onChange = _useFilter.onChange;
    var input = SearchInputRef == null ? void 0 : SearchInputRef.current;
    var value = input == null ? void 0 : input.value;
    return (0, _react.createElement)(Relative, {
        className: (0, _flairup.cx)(styles$j.searchContainer)
    }, (0, _react.createElement)("input", {
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus: autoFocus,
        "aria-label": 'Type to search for an emoji',
        onFocus: closeAllOpenToggles,
        className: (0, _flairup.cx)(styles$j.search),
        type: "text",
        "aria-controls": "epr-search-id",
        placeholder: placeholder,
        onChange: function onChange(event) {
            var _event$target$value, _event$target;
            _onChange((_event$target$value = event == null ? void 0 : (_event$target = event.target) == null ? void 0 : _event$target.value) != null ? _event$target$value : value);
        },
        ref: SearchInputRef
    }), searchTerm ? (0, _react.createElement)("div", {
        role: "status",
        className: (0, _flairup.cx)('epr-status-search-results', styles$j.visuallyHidden),
        "aria-live": "polite",
        id: "epr-search-id",
        "aria-atomic": "true"
    }, statusSearchResults) : null, (0, _react.createElement)(IcnSearch, null), (0, _react.createElement)(BtnClearSearch, null));
}
var styles$j = /*#__PURE__*/ stylesheet.create(/*#__PURE__*/ _extends({
    overlay: {
        padding: 'var(--epr-header-padding)',
        zIndex: 'var(--epr-header-overlay-z-index)'
    },
    searchContainer: {
        '.': 'epr-search-container',
        flex: '1',
        display: 'block',
        minWidth: '0'
    },
    visuallyHidden: {
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: '1px',
        overflow: 'hidden',
        position: 'absolute',
        whiteSpace: 'nowrap',
        width: '1px'
    },
    search: {
        outline: 'none',
        transition: 'all 0.2s ease-in-out',
        color: 'var(--epr-search-input-text-color)',
        borderRadius: 'var(--epr-search-input-border-radius)',
        padding: 'var(--epr-search-input-padding)',
        height: 'var(--epr-search-input-height)',
        backgroundColor: 'var(--epr-search-input-bg-color)',
        border: '1px solid var(--epr-search-border-color)',
        width: '100%',
        ':focus': {
            backgroundColor: 'var(--epr-search-input-bg-color-active)',
            border: '1px solid var(--epr-search-border-color-active)'
        },
        '::placeholder': {
            color: 'var(--epr-search-input-placeholder-color)'
        }
    },
    btnClearSearch: {
        '.': 'epr-btn-clear-search',
        position: 'absolute',
        right: 'var(--epr-search-bar-inner-padding)',
        height: '30px',
        width: '30px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        top: '50%',
        transform: 'translateY(-50%)',
        padding: '0',
        borderRadius: '50%',
        ':hover': {
            background: 'var(--epr-hover-bg-color)'
        },
        ':focus': {
            background: 'var(--epr-hover-bg-color)'
        }
    },
    icnClearnSearch: {
        '.': 'epr-icn-clear-search',
        backgroundColor: 'transparent',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '20px',
        height: '20px',
        width: '20px',
        backgroundImage: "url(" + SVGTimes + ")",
        ':hover': {
            backgroundPositionY: '-20px'
        },
        ':focus': {
            backgroundPositionY: '-20px'
        }
    }
}, /*#__PURE__*/ darkMode('icnClearnSearch', {
    backgroundPositionY: '-40px'
}), /*#__PURE__*/ darkMode('btnClearSearch', {
    ':hover > .epr-icn-clear-search': {
        backgroundPositionY: '-60px'
    }
})));
function Header() {
    return (0, _react.createElement)(Relative, {
        className: (0, _flairup.cx)('epr-header', commonInteractionStyles.hiddenOnReactions)
    }, (0, _react.createElement)(SearchContainer, null), (0, _react.createElement)(CategoryNavigation, null));
}
function EmojiPicker(props) {
    return (0, _react.createElement)(ElementRefContextProvider, null, (0, _react.createElement)(PickerStyleTag, {
        nonce: props.nonce
    }), (0, _react.createElement)(PickerConfigProvider, Object.assign({}, props), (0, _react.createElement)(PickerDataProvider, null, (0, _react.createElement)(ContentControl, null))));
}
function ContentControl() {
    var _useReactionsModeStat = useReactionsModeState(), reactionsDefaultOpen = _useReactionsModeStat[0];
    var allowExpandReactions = useAllowExpandReactions();
    var _React$useState = (0, _react.useState)(!reactionsDefaultOpen), renderAll = _React$useState[0], setRenderAll = _React$useState[1];
    var isOpen = useOpenConfig();
    (0, _react.useEffect)(function() {
        if (reactionsDefaultOpen && !allowExpandReactions) return;
        if (!renderAll) setRenderAll(true);
    }, [
        renderAll,
        allowExpandReactions,
        reactionsDefaultOpen
    ]);
    if (!isOpen) return null;
    return (0, _react.createElement)(PickerMain, null, (0, _react.createElement)(Reactions, null), (0, _react.createElement)(ExpandedPickerContent, {
        renderAll: renderAll
    }));
}
function ExpandedPickerContent(_ref) {
    var renderAll = _ref.renderAll;
    if (!renderAll) return null;
    return (0, _react.createElement)((0, _react.Fragment), null, (0, _react.createElement)(Header, null), (0, _react.createElement)(Body, null), (0, _react.createElement)(Preview, null));
}
// eslint-disable-next-line complexity
var EmojiPickerReact = /*#__PURE__*/ (0, _react.memo)(EmojiPicker, compareConfig);
var ErrorBoundary = /*#__PURE__*/ function(_React$Component) {
    _inheritsLoose(ErrorBoundary, _React$Component);
    function ErrorBoundary(props) {
        var _this;
        _this = _React$Component.call(this, props) || this;
        _this.state = {
            hasError: false
        };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        return {
            hasError: true
        };
    };
    var _proto = ErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        // eslint-disable-next-line no-console
        console.error('Emoji Picker React failed to render:', error, errorInfo);
    };
    _proto.render = function render() {
        if (this.state.hasError) return null;
        return this.props.children;
    };
    return ErrorBoundary;
}((0, _react.Component));
function ExportedEmoji(_ref) {
    var unified = _ref.unified, _ref$size = _ref.size, size = _ref$size === void 0 ? 32 : _ref$size, _ref$emojiStyle = _ref.emojiStyle, emojiStyle = _ref$emojiStyle === void 0 ? EmojiStyle.APPLE : _ref$emojiStyle, _ref$lazyLoad = _ref.lazyLoad, lazyLoad = _ref$lazyLoad === void 0 ? false : _ref$lazyLoad, getEmojiUrl = _ref.getEmojiUrl, emojiUrl = _ref.emojiUrl;
    if (!unified && !emojiUrl && !getEmojiUrl) return null;
    return (0, _react.createElement)(ViewOnlyEmoji, {
        unified: unified,
        size: size,
        emojiStyle: emojiStyle,
        lazyLoad: lazyLoad,
        getEmojiUrl: emojiUrl ? function() {
            return emojiUrl;
        } : getEmojiUrl
    });
}
function EmojiPicker$1(props) {
    var MutableConfigRef = useDefineMutableConfig({
        onEmojiClick: props.onEmojiClick,
        onReactionClick: props.onReactionClick,
        onSkinToneChange: props.onSkinToneChange
    });
    return (0, _react.createElement)(ErrorBoundary, null, (0, _react.createElement)(MutableConfigContext.Provider, {
        value: MutableConfigRef
    }, (0, _react.createElement)(EmojiPickerReact, Object.assign({}, props))));
}
exports.default = EmojiPicker$1;

},{"react":"bmhQu","flairup":"7uLXQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7uLXQ":[function(require,module,exports,__globalThis) {
"use strict";
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) return !!right[Symbol.hasInstance](left);
    else return left instanceof right;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = function(target, all) {
    for(var name in all)__defProp(target, name, {
        get: all[name],
        enumerable: true
    });
};
var __copyProps = function(to, from, except, desc) {
    if (from && typeof from === "object" || typeof from === "function") {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
                    get: function() {
                        return from[key];
                    },
                    enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
                });
            };
            for(var _iterator = __getOwnPropNames(from)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
    }
    return to;
};
var __toCommonJS = function(mod) {
    return __copyProps(__defProp({}, "__esModule", {
        value: true
    }), mod);
};
// src/index.ts
var src_exports = {};
__export(src_exports, {
    createSheet: function() {
        return createSheet;
    },
    cx: function() {
        return cx;
    }
});
module.exports = __toCommonJS(src_exports);
// src/utils/asArray.ts
function asArray(v) {
    return [].concat(v);
}
// src/utils/is.ts
function isPsuedoSelector(selector) {
    return selector.startsWith(":");
}
function isStyleCondition(selector) {
    return isString(selector) && (selector === "*" || selector.length > 1 && ":>~.+*".includes(selector.slice(0, 1)) || isImmediatePostcondition(selector));
}
function isValidProperty(property, value) {
    return (isString(value) || typeof value === "number") && !isCssVariables(property) && !isPsuedoSelector(property) && !isMediaQuery(property);
}
function isMediaQuery(selector) {
    return selector.startsWith("@media");
}
function isDirectClass(selector) {
    return selector === ".";
}
function isCssVariables(selector) {
    return selector === "--";
}
function isString(value) {
    return value + "" === value;
}
function isImmediatePostcondition(value) {
    return isString(value) && (value.startsWith("&") || isPsuedoSelector(value));
}
// src/utils/joinTruthy.ts
function joinTruthy(arr) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return arr.filter(Boolean).join(delimiter);
}
// src/utils/stableHash.ts
function stableHash(prefix, seed) {
    var hash = 0;
    if (seed.length === 0) return hash.toString();
    for(var i = 0; i < seed.length; i++){
        var char = seed.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash;
    }
    return "".concat(prefix !== null && prefix !== void 0 ? prefix : "cl", "_").concat(hash.toString(36));
}
// src/utils/stringManipulators.ts
function handlePropertyValue(property, value) {
    if (property === "content") return '"'.concat(value, '"');
    return value;
}
function camelCaseToDash(str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
function joinedProperty(property, value) {
    return "".concat(property, ":").concat(value);
}
function toClass(str) {
    return str ? ".".concat(str) : "";
}
function appendString(base, line) {
    return base ? "".concat(base, "\n").concat(line) : line;
}
// src/Rule.ts
var Rule = /*#__PURE__*/ function() {
    function _Rule(sheet, property, value, selector) {
        _class_call_check(this, _Rule);
        this.sheet = sheet;
        this.property = property;
        this.value = value;
        this.selector = selector;
        this.property = property;
        this.value = value;
        this.joined = joinedProperty(property, value);
        var joinedConditions = this.selector.preconditions.concat(this.selector.postconditions);
        this.hash = this.selector.hasConditions ? this.selector.scopeClassName : stableHash(this.sheet.name, this.joined);
        this.key = joinTruthy([
            this.joined,
            joinedConditions,
            this.hash
        ]);
    }
    _create_class(_Rule, [
        {
            key: "toString",
            value: function toString() {
                var selectors = mergeSelectors(this.selector.preconditions, {
                    right: this.hash
                });
                selectors = mergeSelectors(this.selector.postconditions, {
                    left: selectors
                });
                return "".concat(selectors, " {").concat(_Rule.genRule(this.property, this.value), "}");
            }
        }
    ], [
        {
            key: "genRule",
            value: function genRule(property, value) {
                var transformedProperty = camelCaseToDash(property);
                return joinedProperty(transformedProperty, handlePropertyValue(property, value)) + ";";
            }
        }
    ]);
    return _Rule;
}();
function mergeSelectors(selectors) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_left = _ref.left, left = _ref_left === void 0 ? "" : _ref_left, _ref_right = _ref.right, right = _ref_right === void 0 ? "" : _ref_right;
    var output = selectors.reduce(function(selectors2, current) {
        if (isPsuedoSelector(current)) return selectors2 + current;
        if (isImmediatePostcondition(current)) return selectors2 + current.slice(1);
        return joinTruthy([
            selectors2,
            current
        ], " ");
    }, left);
    return joinTruthy([
        output,
        toClass(right)
    ], " ");
}
var Selector = /*#__PURE__*/ function() {
    function _Selector(sheet) {
        var scopeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, preconditions = _ref.preconditions, postconditions = _ref.postconditions;
        _class_call_check(this, _Selector);
        this.sheet = sheet;
        this.preconditions = [];
        this.scopeClassName = null;
        this.scopeName = null;
        this.postconditions = [];
        this.preconditions = preconditions ? asArray(preconditions) : [];
        this.postconditions = postconditions ? asArray(postconditions) : [];
        this.setScope(scopeName);
    }
    _create_class(_Selector, [
        {
            key: "setScope",
            value: function setScope(scopeName) {
                if (!scopeName) return this;
                if (!this.scopeClassName) {
                    this.scopeName = scopeName;
                    this.scopeClassName = stableHash(this.sheet.name, scopeName + this.sheet.count);
                }
                return this;
            }
        },
        {
            key: "hasConditions",
            get: function get() {
                return this.preconditions.length > 0 || this.postconditions.length > 0;
            }
        },
        {
            key: "addScope",
            value: function addScope(scopeName) {
                return new _Selector(this.sheet, scopeName, {
                    preconditions: this.preconditions,
                    postconditions: this.postconditions
                });
            }
        },
        {
            key: "addPrecondition",
            value: function addPrecondition(precondition) {
                return new _Selector(this.sheet, this.scopeClassName, {
                    postconditions: this.postconditions,
                    preconditions: this.preconditions.concat(precondition)
                });
            }
        },
        {
            key: "addPostcondition",
            value: function addPostcondition(postcondition) {
                return new _Selector(this.sheet, this.scopeClassName, {
                    preconditions: this.preconditions,
                    postconditions: this.postconditions.concat(postcondition)
                });
            }
        },
        {
            key: "createRule",
            value: function createRule(property, value) {
                return new Rule(this.sheet, property, value, this);
            }
        }
    ]);
    return _Selector;
}();
// src/Sheet.ts
var Sheet = /*#__PURE__*/ function() {
    function Sheet(name, rootNode) {
        _class_call_check(this, Sheet);
        this.name = name;
        this.rootNode = rootNode;
        // Hash->css
        this.storedStyles = {};
        // styles->hash
        this.storedClasses = {};
        this.style = "";
        this.count = 0;
        this.id = "flairup-".concat(name);
        this.styleTag = this.createStyleTag();
    }
    _create_class(Sheet, [
        {
            key: "getStyle",
            value: function getStyle() {
                return this.style;
            }
        },
        {
            key: "append",
            value: function append(css) {
                this.style = appendString(this.style, css);
            }
        },
        {
            key: "apply",
            value: function apply() {
                this.count++;
                if (!this.styleTag) return;
                this.styleTag.innerHTML = this.style;
            }
        },
        {
            key: "isApplied",
            value: function isApplied() {
                return !!this.styleTag;
            }
        },
        {
            key: "createStyleTag",
            value: function createStyleTag() {
                if (typeof document === "undefined" || this.isApplied() || // Explicitly disallow mounting to the DOM
                this.rootNode === null) return this.styleTag;
                var styleTag = document.createElement("style");
                styleTag.type = "text/css";
                styleTag.id = this.id;
                var _this_rootNode;
                ((_this_rootNode = this.rootNode) !== null && _this_rootNode !== void 0 ? _this_rootNode : document.head).appendChild(styleTag);
                return styleTag;
            }
        },
        {
            key: "addRule",
            value: function addRule(rule) {
                var storedClass = this.storedClasses[rule.key];
                if (isString(storedClass)) return storedClass;
                this.storedClasses[rule.key] = rule.hash;
                this.storedStyles[rule.hash] = [
                    rule.property,
                    rule.value
                ];
                this.append(rule.toString());
                return rule.hash;
            }
        }
    ]);
    return Sheet;
}();
// src/utils/forIn.ts
function forIn(obj, fn) {
    for(var key in obj)fn(key.trim(), obj[key]);
}
// src/cx.ts
function cx() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    var classes = args.reduce(function(classes2, arg) {
        if (_instanceof(arg, Set)) {
            var _classes2;
            (_classes2 = classes2).push.apply(_classes2, _to_consumable_array(arg));
        } else if (typeof arg === "string") classes2.push(arg);
        else if (Array.isArray(arg)) classes2.push(cx.apply(void 0, _to_consumable_array(arg)));
        else if (typeof arg === "object") Object.entries(arg).forEach(function(param) {
            var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
            if (value) classes2.push(key);
        });
        return classes2;
    }, []);
    return joinTruthy(classes, " ").trim();
}
// src/index.ts
function createSheet(name, rootNode) {
    var sheet = new Sheet(name, rootNode);
    return {
        create: create,
        getStyle: sheet.getStyle.bind(sheet),
        isApplied: sheet.isApplied.bind(sheet)
    };
    function create(styles) {
        var scopedStyles = {};
        iteratePreconditions(sheet, styles, new Selector(sheet)).forEach(function(param) {
            var _param = _sliced_to_array(param, 3), scopeName = _param[0], styles2 = _param[1], selector = _param[2];
            iterateStyles(sheet, styles2, selector).forEach(function(className) {
                addScopedStyle(scopeName, className);
            });
        });
        sheet.apply();
        return scopedStyles;
        function addScopedStyle(name2, className) {
            var _scopedStyles_name2;
            scopedStyles[name2] = (_scopedStyles_name2 = scopedStyles[name2]) !== null && _scopedStyles_name2 !== void 0 ? _scopedStyles_name2 : /* @__PURE__ */ new Set();
            scopedStyles[name2].add(className);
        }
    }
}
function iteratePreconditions(sheet, styles, selector) {
    var output = [];
    forIn(styles, function(key, value) {
        if (isStyleCondition(key)) return iteratePreconditions(sheet, value, selector.addPrecondition(key)).forEach(function(item) {
            return output.push(item);
        });
        output.push([
            key,
            styles[key],
            selector.addScope(key)
        ]);
    });
    return output;
}
function iterateStyles(sheet, styles, selector) {
    var output = /* @__PURE__ */ new Set();
    forIn(styles, function(property, value) {
        var res = [];
        if (isStyleCondition(property)) res = iterateStyles(sheet, value, selector.addPostcondition(property));
        else if (isDirectClass(property)) res = asArray(value);
        else if (isMediaQuery(property)) res = handleMediaQuery(sheet, value, property, selector);
        else if (isCssVariables(property)) res = cssVariablesBlock(sheet, value, selector);
        else if (isValidProperty(property, value)) {
            var rule = selector.createRule(property, value);
            sheet.addRule(rule);
            output.add(rule.hash);
        }
        return addEachClass(res, output);
    });
    return output;
}
function addEachClass(list, to) {
    list.forEach(function(className) {
        return to.add(className);
    });
    return to;
}
function cssVariablesBlock(sheet, styles, selector) {
    var classes = /* @__PURE__ */ new Set();
    var chunkRows = [];
    forIn(styles, function(property, value) {
        if (isValidProperty(property, value)) {
            chunkRows.push(Rule.genRule(property, value));
            return;
        }
        var res = iterateStyles(sheet, value !== null && value !== void 0 ? value : {}, selector);
        addEachClass(res, classes);
    });
    if (!selector.scopeClassName) return classes;
    if (chunkRows.length) {
        var output = chunkRows.join(" ");
        sheet.append("".concat(mergeSelectors(selector.preconditions, {
            right: selector.scopeClassName
        }), " {").concat(output, "}"));
    }
    classes.add(selector.scopeClassName);
    return classes;
}
function handleMediaQuery(sheet, styles, mediaQuery, selector) {
    sheet.append(mediaQuery + " {");
    var output = iterateStyles(sheet, styles, selector);
    sheet.append("}");
    return output;
}

},{}],"2dIdb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _downloadOutlined = require("@ant-design/icons-svg/es/asn/DownloadOutlined");
var _downloadOutlinedDefault = parcelHelpers.interopDefault(_downloadOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const DownloadOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _downloadOutlinedDefault.default)
    }));
/**![download](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUwNS43IDY2MWE4IDggMCAwMDEyLjYgMGwxMTItMTQxLjdjNC4xLTUuMi40LTEyLjktNi4zLTEyLjloLTc0LjFWMTY4YzAtNC40LTMuNi04LTgtOGgtNjBjLTQuNCAwLTggMy42LTggOHYzMzguM0g0MDBjLTYuNyAwLTEwLjQgNy43LTYuMyAxMi45bDExMiAxNDEuOHpNODc4IDYyNmgtNjBjLTQuNCAwLTggMy42LTggOHYxNTRIMjE0VjYzNGMwLTQuNC0zLjYtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDh2MTk4YzAgMTcuNyAxNC4zIDMyIDMyIDMyaDY4NGMxNy43IDAgMzItMTQuMyAzMi0zMlY2MzRjMC00LjQtMy42LTgtOC04eiIgLz48L3N2Zz4=) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(DownloadOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/DownloadOutlined":"5aif1","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5aif1":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var DownloadOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M505.7 661a8 8 0 0012.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "download",
    "theme": "outlined"
};
exports.default = DownloadOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3eyJq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _fileExcelOutlined = require("@ant-design/icons-svg/es/asn/FileExcelOutlined");
var _fileExcelOutlinedDefault = parcelHelpers.interopDefault(_fileExcelOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FileExcelOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _fileExcelOutlinedDefault.default)
    }));
/**![file-excel](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHpNNTE0LjEgNTgwLjFsLTYxLjgtMTAyLjRjLTIuMi0zLjYtNi4xLTUuOC0xMC4zLTUuOGgtMzguNGMtMi4zIDAtNC41LjYtNi40IDEuOS01LjYgMy41LTcuMyAxMC45LTMuNyAxNi42bDgyLjMgMTMwLjQtODMuNCAxMzIuOGExMi4wNCAxMi4wNCAwIDAwMTAuMiAxOC40aDM0LjVjNC4yIDAgOC0yLjIgMTAuMi01LjdMNTEwIDY2NC44bDYyLjMgMTAxLjRjMi4yIDMuNiA2LjEgNS43IDEwLjIgNS43SDYyMGMyLjMgMCA0LjUtLjcgNi41LTEuOSA1LjYtMy42IDcuMi0xMSAzLjYtMTYuNmwtODQtMTMwLjQgODUuMy0xMzIuNWExMi4wNCAxMi4wNCAwIDAwLTEwLjEtMTguNWgtMzUuN2MtNC4yIDAtOC4xIDIuMi0xMC4zIDUuOGwtNjEuMiAxMDIuM3oiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(FileExcelOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/FileExcelOutlined":"jdeKA","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jdeKA":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var FileExcelOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0010.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 00-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z"
                }
            }
        ]
    },
    "name": "file-excel",
    "theme": "outlined"
};
exports.default = FileExcelOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"17Uhv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _fileImageOutlined = require("@ant-design/icons-svg/es/asn/FileImageOutlined");
var _fileImageOutlinedDefault = parcelHelpers.interopDefault(_fileImageOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FileImageOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _fileImageOutlinedDefault.default)
    }));
/**![file-image](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTU1My4xIDUwOS4xbC03Ny44IDk5LjItNDEuMS01Mi40YTggOCAwIDAwLTEyLjYgMGwtOTkuOCAxMjcuMmE3Ljk4IDcuOTggMCAwMDYuMyAxMi45SDY5NmM2LjcgMCAxMC40LTcuNyA2LjMtMTIuOWwtMTM2LjUtMTc0YTguMSA4LjEgMCAwMC0xMi43IDB6TTM2MCA0NDJhNDAgNDAgMCAxMDgwIDAgNDAgNDAgMCAxMC04MCAwem00OTQuNi0xNTMuNEw2MzkuNCA3My40Yy02LTYtMTQuMS05LjQtMjIuNi05LjRIMTkyYy0xNy43IDAtMzIgMTQuMy0zMiAzMnY4MzJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjQwYzE3LjcgMCAzMi0xNC4zIDMyLTMyVjMxMS4zYzAtOC41LTMuNC0xNi43LTkuNC0yMi43ek03OTAuMiAzMjZINjAyVjEzNy44TDc5MC4yIDMyNnptMS44IDU2MkgyMzJWMTM2aDMwMnYyMTZhNDIgNDIgMCAwMDQyIDQyaDIxNnY0OTR6IiAvPjwvc3ZnPg==) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(FileImageOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/FileImageOutlined":"8Wp3J","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8Wp3J":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var FileImageOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 00-12.6 0l-99.8 127.2a7.98 7.98 0 006.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 00-12.7 0zM360 442a40 40 0 1080 0 40 40 0 10-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file-image",
    "theme": "outlined"
};
exports.default = FileImageOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iSC34":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _filePdfOutlined = require("@ant-design/icons-svg/es/asn/FilePdfOutlined");
var _filePdfOutlinedDefault = parcelHelpers.interopDefault(_filePdfOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FilePdfOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _filePdfOutlinedDefault.default)
    }));
/**![file-pdf](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUzMS4zIDU3NC40bC4zLTEuNGM1LjgtMjMuOSAxMy4xLTUzLjcgNy40LTgwLjctMy44LTIxLjMtMTkuNS0yOS42LTMyLjktMzAuMi0xNS44LS43LTI5LjkgOC4zLTMzLjQgMjEuNC02LjYgMjQtLjcgNTYuOCAxMC4xIDk4LjYtMTMuNiAzMi40LTM1LjMgNzkuNS01MS4yIDEwNy41LTI5LjYgMTUuMy02OS4zIDM4LjktNzUuMiA2OC43LTEuMiA1LjUuMiAxMi41IDMuNSAxOC44IDMuNyA3IDkuNiAxMi40IDE2LjUgMTUgMyAxLjEgNi42IDIgMTAuOCAyIDE3LjYgMCA0Ni4xLTE0LjIgODQuMS03OS40IDUuOC0xLjkgMTEuOC0zLjkgMTcuNi01LjkgMjcuMi05LjIgNTUuNC0xOC44IDgwLjktMjMuMSAyOC4yIDE1LjEgNjAuMyAyNC44IDgyLjEgMjQuOCAyMS42IDAgMzAuMS0xMi44IDMzLjMtMjAuNSA1LjYtMTMuNSAyLjktMzAuNS02LjItMzkuNi0xMy4yLTEzLTQ1LjMtMTYuNC05NS4zLTEwLjItMjQuNi0xNS00MC43LTM1LjQtNTIuNC02NS44ek00MjEuNiA3MjYuM2MtMTMuOSAyMC4yLTI0LjQgMzAuMy0zMC4xIDM0LjcgNi43LTEyLjMgMTkuOC0yNS4zIDMwLjEtMzQuN3ptODcuNi0yMzUuNWM1LjIgOC45IDQuNSAzNS44LjUgNDkuNC00LjktMTkuOS01LjYtNDguMS0yLjctNTEuNC44LjEgMS41LjcgMi4yIDJ6bS0xLjYgMTIwLjVjMTAuNyAxOC41IDI0LjIgMzQuNCAzOS4xIDQ2LjItMjEuNiA0LjktNDEuMyAxMy01OC45IDIwLjItNC4yIDEuNy04LjMgMy40LTEyLjMgNSAxMy4zLTI0LjEgMjQuNC01MS40IDMyLjEtNzEuNHptMTU1LjYgNjUuNWMuMS4yLjIuNS0uNC45aC0uMmwtLjIuM2MtLjguNS05IDUuMy00NC4zLTguNiA0MC42LTEuOSA0NSA3LjMgNDUuMSA3LjR6bTE5MS40LTM4OC4yTDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(FilePdfOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/FilePdfOutlined":"6qTh7","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6qTh7":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var FilePdfOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file-pdf",
    "theme": "outlined"
};
exports.default = FilePdfOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"78Duw":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _filePptOutlined = require("@ant-design/icons-svg/es/asn/FilePptOutlined");
var _filePptOutlinedDefault = parcelHelpers.interopDefault(_filePptOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FilePptOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _filePptOutlinedDefault.default)
    }));
/**![file-ppt](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQyNCA0NzZjLTQuNCAwLTggMy42LTggOHYyNzZjMCA0LjQgMy42IDggOCA4aDMyLjVjNC40IDAgOC0zLjYgOC04di05NS41aDYzLjNjNTkuNCAwIDk2LjItMzguOSA5Ni4yLTk0LjEgMC01NC41LTM2LjMtOTQuMy05Ni05NC4zSDQyNHptMTUwLjYgOTQuM2MwIDQzLjQtMjYuNSA1NC4zLTcxLjIgNTQuM2gtMzguOVY1MTYuMmg1Ni4yYzMzLjggMCA1My45IDE5LjcgNTMuOSA1NC4xem0yODAtMjgxLjdMNjM5LjQgNzMuNGMtNi02LTE0LjEtOS40LTIyLjYtOS40SDE5MmMtMTcuNyAwLTMyIDE0LjMtMzIgMzJ2ODMyYzAgMTcuNyAxNC4zIDMyIDMyIDMyaDY0MGMxNy43IDAgMzItMTQuMyAzMi0zMlYzMTEuM2MwLTguNS0zLjQtMTYuNy05LjQtMjIuN3pNNzkwLjIgMzI2SDYwMlYxMzcuOEw3OTAuMiAzMjZ6bTEuOCA1NjJIMjMyVjEzNmgzMDJ2MjE2YTQyIDQyIDAgMDA0MiA0MmgyMTZ2NDk0eiIgLz48L3N2Zz4=) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(FilePptOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/FilePptOutlined":"aqOfz","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aqOfz":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var FilePptOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file-ppt",
    "theme": "outlined"
};
exports.default = FilePptOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9K7Ru":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _fileWordOutlined = require("@ant-design/icons-svg/es/asn/FileWordOutlined");
var _fileWordOutlinedDefault = parcelHelpers.interopDefault(_fileWordOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FileWordOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _fileWordOutlinedDefault.default)
    }));
/**![file-word](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg1NC42IDI4OC42TDYzOS40IDczLjRjLTYtNi0xNC4xLTkuNC0yMi42LTkuNEgxOTJjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjgzMmMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWMzExLjNjMC04LjUtMy40LTE2LjctOS40LTIyLjd6TTc5MC4yIDMyNkg2MDJWMTM3LjhMNzkwLjIgMzI2em0xLjggNTYySDIzMlYxMzZoMzAydjIxNmE0MiA0MiAwIDAwNDIgNDJoMjE2djQ5NHpNNTI4LjEgNDcyaC0zMi4yYy01LjUgMC0xMC4zIDMuNy0xMS42IDkuMUw0MzQuNiA2ODBsLTQ2LjEtMTk4LjdjLTEuMy01LjQtNi4xLTkuMy0xMS43LTkuM2gtMzUuNGExMi4wMiAxMi4wMiAwIDAwLTExLjYgMTUuMWw3NC4yIDI3NmMxLjQgNS4yIDYuMiA4LjkgMTEuNiA4LjloMzJjNS40IDAgMTAuMi0zLjYgMTEuNi04LjlsNTIuOC0xOTcgNTIuOCAxOTdjMS40IDUuMiA2LjIgOC45IDExLjYgOC45aDMxLjhjNS40IDAgMTAuMi0zLjYgMTEuNi04LjlsNzQuNC0yNzZhMTIuMDQgMTIuMDQgMCAwMC0xMS42LTE1LjFINjQ3Yy01LjYgMC0xMC40IDMuOS0xMS43IDkuM2wtNDUuOCAxOTkuMS00OS44LTE5OS4zYy0xLjMtNS40LTYuMS05LjEtMTEuNi05LjF6IiAvPjwvc3ZnPg==) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(FileWordOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/FileWordOutlined":"5U9Rg","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5U9Rg":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var FileWordOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0042 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 00-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 00-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z"
                }
            }
        ]
    },
    "name": "file-word",
    "theme": "outlined"
};
exports.default = FileWordOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4k6yg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _fileZipOutlined = require("@ant-design/icons-svg/es/asn/FileZipOutlined");
var _fileZipOutlinedDefault = parcelHelpers.interopDefault(_fileZipOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const FileZipOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _fileZipOutlinedDefault.default)
    }));
/**![file-zip](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTI5NiAzOTJoNjR2NjRoLTY0em0wIDE5MHYxNjBoMTI4VjU4MmgtNjR2LTYyaC02NHY2MnptODAgNDh2NjRoLTMydi02NGgzMnptLTE2LTMwMmg2NHY2NGgtNjR6bS02NC02NGg2NHY2NGgtNjR6bTY0IDE5Mmg2NHY2NGgtNjR6bTAtMjU2aDY0djY0aC02NHptNDk0LjYgODguNkw2MzkuNCA3My40Yy02LTYtMTQuMS05LjQtMjIuNi05LjRIMTkyYy0xNy43IDAtMzIgMTQuMy0zMiAzMnY4MzJjMCAxNy43IDE0LjMgMzIgMzIgMzJoNjQwYzE3LjcgMCAzMi0xNC4zIDMyLTMyVjMxMS4zYzAtOC41LTMuNC0xNi43LTkuNC0yMi43ek03OTAuMiAzMjZINjAyVjEzNy44TDc5MC4yIDMyNnptMS44IDU2MkgyMzJWMTM2aDY0djY0aDY0di02NGgxNzR2MjE2YTQyIDQyIDAgMDA0MiA0MmgyMTZ2NDk0eiIgLz48L3N2Zz4=) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(FileZipOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/FileZipOutlined":"3IRzy","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3IRzy":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var FileZipOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0042 42h216v494z"
                }
            }
        ]
    },
    "name": "file-zip",
    "theme": "outlined"
};
exports.default = FileZipOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"99y1M":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _lockOutlined = require("@ant-design/icons-svg/es/asn/LockOutlined");
var _lockOutlinedDefault = parcelHelpers.interopDefault(_lockOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const LockOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _lockOutlinedDefault.default)
    }));
/**![lock](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTgzMiA0NjRoLTY4VjI0MGMwLTcwLjctNTcuMy0xMjgtMTI4LTEyOEgzODhjLTcwLjcgMC0xMjggNTcuMy0xMjggMTI4djIyNGgtNjhjLTE3LjcgMC0zMiAxNC4zLTMyIDMydjM4NGMwIDE3LjcgMTQuMyAzMiAzMiAzMmg2NDBjMTcuNyAwIDMyLTE0LjMgMzItMzJWNDk2YzAtMTcuNy0xNC4zLTMyLTMyLTMyek0zMzIgMjQwYzAtMzAuOSAyNS4xLTU2IDU2LTU2aDI0OGMzMC45IDAgNTYgMjUuMSA1NiA1NnYyMjRIMzMyVjI0MHptNDYwIDYwMEgyMzJWNTM2aDU2MHYzMDR6TTQ4NCA3MDF2NTNjMCA0LjQgMy42IDggOCA4aDQwYzQuNCAwIDgtMy42IDgtOHYtNTNhNDguMDEgNDguMDEgMCAxMC01NiAweiIgLz48L3N2Zz4=) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(LockOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/LockOutlined":"8s9AR","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8s9AR":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var LockOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 10-56 0z"
                }
            }
        ]
    },
    "name": "lock",
    "theme": "outlined"
};
exports.default = LockOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eZwrA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _playCircleFilled = require("@ant-design/icons-svg/es/asn/PlayCircleFilled");
var _playCircleFilledDefault = parcelHelpers.interopDefault(_playCircleFilled);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const PlayCircleFilled = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _playCircleFilledDefault.default)
    }));
/**![play-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0xNDQuMSA0NTQuOUw0MzcuNyA2NzcuOGE4LjAyIDguMDIgMCAwMS0xMi43LTYuNVYzNTMuN2E4IDggMCAwMTEyLjctNi41TDY1Ni4xIDUwNmE3LjkgNy45IDAgMDEwIDEyLjl6IiAvPjwvc3ZnPg==) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(PlayCircleFilled);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/PlayCircleFilled":"k6yIq","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k6yIq":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var PlayCircleFilled = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 01-12.7-6.5V353.7a8 8 0 0112.7-6.5L656.1 506a7.9 7.9 0 010 12.9z"
                }
            }
        ]
    },
    "name": "play-circle",
    "theme": "filled"
};
exports.default = PlayCircleFilled;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3SwL4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _warningOutlined = require("@ant-design/icons-svg/es/asn/WarningOutlined");
var _warningOutlinedDefault = parcelHelpers.interopDefault(_warningOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const WarningOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _warningOutlinedDefault.default)
    }));
/**![warning](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ2NCA3MjBhNDggNDggMCAxMDk2IDAgNDggNDggMCAxMC05NiAwem0xNi0zMDR2MTg0YzAgNC40IDMuNiA4IDggOGg0OGM0LjQgMCA4LTMuNiA4LThWNDE2YzAtNC40LTMuNi04LTgtOGgtNDhjLTQuNCAwLTggMy42LTggOHptNDc1LjcgNDQwbC00MTYtNzIwYy02LjItMTAuNy0xNi45LTE2LTI3LjctMTZzLTIxLjYgNS4zLTI3LjcgMTZsLTQxNiA3MjBDNTYgODc3LjQgNzEuNCA5MDQgOTYgOTA0aDgzMmMyNC42IDAgNDAtMjYuNiAyNy43LTQ4em0tNzgzLjUtMjcuOUw1MTIgMjM5LjlsMzM5LjggNTg4LjJIMTcyLjJ6IiAvPjwvc3ZnPg==) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(WarningOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/WarningOutlined":"bDTTw","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bDTTw":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var WarningOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 720a48 48 0 1096 0 48 48 0 10-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z"
                }
            }
        ]
    },
    "name": "warning",
    "theme": "outlined"
};
exports.default = WarningOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a4h8g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _useAudioRecorder = require("./useAudioRecorder");
parcelHelpers.exportAll(_useAudioRecorder, exports);
var _audioPlayer = require("./AudioPlayer");
parcelHelpers.exportAll(_audioPlayer, exports);
var _audioRecorderInline = require("./AudioRecorderInline");
parcelHelpers.exportAll(_audioRecorderInline, exports);
var _audioMessageBubble = require("./AudioMessageBubble");
parcelHelpers.exportAll(_audioMessageBubble, exports);
var _audioRecorderScss = require("./AudioRecorder.scss");

},{"./useAudioRecorder":"6Gsrv","./AudioPlayer":"jKOtr","./AudioRecorderInline":"4t7mY","./AudioMessageBubble":"7Rhmk","./AudioRecorder.scss":"1eYUx","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6Gsrv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "formatAudioDuration", ()=>formatAudioDuration);
parcelHelpers.export(exports, "useAudioRecorder", ()=>useAudioRecorder);
var _react = require("react");
var _lamejs = require("@breezystack/lamejs");
function formatAudioDuration(seconds) {
    if (typeof seconds !== 'number' || isNaN(seconds) || !isFinite(seconds) || seconds <= 0) return '00:00';
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
}
/**
 * Encodes an array of Float32Array PCM chunks into an MP3 Blob using lamejs.
 */ function encodePCMToMp3(chunks, sampleRate) {
    let totalLength = 0;
    for(let i = 0; i < chunks.length; i++)totalLength += chunks[i].length;
    const fullPcm = new Float32Array(totalLength);
    let offset = 0;
    for(let i = 0; i < chunks.length; i++){
        fullPcm.set(chunks[i], offset);
        offset += chunks[i].length;
    }
    // Convert Float32Array (-1.0 to 1.0) to Int16Array (-32768 to 32767)
    const int16Samples = new Int16Array(fullPcm.length);
    for(let i = 0; i < fullPcm.length; i++){
        const s = Math.max(-1, Math.min(1, fullPcm[i]));
        int16Samples[i] = s < 0 ? s * 0x8000 : s * 0x7fff;
    }
    // 1 channel (mono), 128 kbps
    const encoder = new (0, _lamejs.Mp3Encoder)(1, sampleRate, 128);
    const mp3Data = [];
    const blockSize = 1152;
    for(let i = 0; i < int16Samples.length; i += blockSize){
        const chunk = int16Samples.subarray(i, i + blockSize);
        const mp3buf = encoder.encodeBuffer(chunk);
        if (mp3buf.length > 0) mp3Data.push(mp3buf);
    }
    const endBuf = encoder.flush();
    if (endBuf.length > 0) mp3Data.push(endBuf);
    return new Blob(mp3Data, {
        type: 'audio/mp3'
    });
}
const useAudioRecorder = (options = {})=>{
    const { maxDurationSeconds = 300, minDurationSeconds = 2, onMaxDurationReached } = options;
    const [isRecording, setIsRecording] = (0, _react.useState)(false);
    const [isPaused, setIsPaused] = (0, _react.useState)(false);
    const [duration, setDuration] = (0, _react.useState)(0);
    const [audioBlob, setAudioBlob] = (0, _react.useState)(null);
    const [audioUrl, setAudioUrl] = (0, _react.useState)(null);
    const [volumeLevel, setVolumeLevel] = (0, _react.useState)(0);
    const [permissionStatus, setPermissionStatus] = (0, _react.useState)('prompt');
    const [errorMessage, setErrorMessage] = (0, _react.useState)(null);
    const maxDurationSecondsRef = (0, _react.useRef)(maxDurationSeconds);
    const minDurationSecondsRef = (0, _react.useRef)(minDurationSeconds);
    const onMaxDurationReachedRef = (0, _react.useRef)(onMaxDurationReached);
    (0, _react.useEffect)(()=>{
        maxDurationSecondsRef.current = maxDurationSeconds;
    }, [
        maxDurationSeconds
    ]);
    (0, _react.useEffect)(()=>{
        minDurationSecondsRef.current = minDurationSeconds;
    }, [
        minDurationSeconds
    ]);
    (0, _react.useEffect)(()=>{
        onMaxDurationReachedRef.current = onMaxDurationReached;
    }, [
        onMaxDurationReached
    ]);
    const mediaStreamRef = (0, _react.useRef)(null);
    const audioContextRef = (0, _react.useRef)(null);
    const sourceNodeRef = (0, _react.useRef)(null);
    const processorNodeRef = (0, _react.useRef)(null);
    const analyserRef = (0, _react.useRef)(null);
    const animFrameRef = (0, _react.useRef)(null);
    const timerIntervalRef = (0, _react.useRef)(null);
    const durationRef = (0, _react.useRef)(0);
    const pcmChunksRef = (0, _react.useRef)([]);
    const totalSamplesRef = (0, _react.useRef)(0);
    const isRecordingRef = (0, _react.useRef)(false);
    const isPausedRef = (0, _react.useRef)(false);
    const errorTimerRef = (0, _react.useRef)(null);
    const clearError = (0, _react.useCallback)(()=>{
        if (errorTimerRef.current) {
            clearTimeout(errorTimerRef.current);
            errorTimerRef.current = null;
        }
        setErrorMessage(null);
    }, []);
    // Keep duration ref in sync for interval check
    (0, _react.useEffect)(()=>{
        durationRef.current = duration;
    }, [
        duration
    ]);
    // Keep paused ref in sync
    (0, _react.useEffect)(()=>{
        isPausedRef.current = isPaused;
    }, [
        isPaused
    ]);
    // Keep recording ref in sync
    (0, _react.useEffect)(()=>{
        isRecordingRef.current = isRecording;
    }, [
        isRecording
    ]);
    // Cleanup helper
    const cleanupStreamAndAudioContext = (0, _react.useCallback)(()=>{
        if (animFrameRef.current) {
            cancelAnimationFrame(animFrameRef.current);
            animFrameRef.current = null;
        }
        if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current);
            timerIntervalRef.current = null;
        }
        if (processorNodeRef.current) {
            processorNodeRef.current.disconnect();
            processorNodeRef.current = null;
        }
        if (sourceNodeRef.current) {
            sourceNodeRef.current.disconnect();
            sourceNodeRef.current = null;
        }
        if (analyserRef.current) {
            analyserRef.current.disconnect();
            analyserRef.current = null;
        }
        if (mediaStreamRef.current) {
            mediaStreamRef.current.getTracks().forEach((track)=>track.stop());
            mediaStreamRef.current = null;
        }
        if (audioContextRef.current && audioContextRef.current.state !== 'closed') {
            audioContextRef.current.close().catch(()=>null);
            audioContextRef.current = null;
        }
        setVolumeLevel(0);
    }, []);
    // Stop recording internal and encode to MP3
    const stopRecordingInternal = (0, _react.useCallback)(()=>{
        if (!isRecordingRef.current) return;
        isRecordingRef.current = false;
        const currentSampleRate = audioContextRef.current?.sampleRate || 44100;
        const collectedChunks = [
            ...pcmChunksRef.current
        ];
        cleanupStreamAndAudioContext();
        setIsRecording(false);
        setIsPaused(false);
        isPausedRef.current = false;
        if (collectedChunks.length > 0) try {
            const mp3Blob = encodePCMToMp3(collectedChunks, currentSampleRate);
            setAudioBlob(mp3Blob);
            const url = URL.createObjectURL(mp3Blob);
            setAudioUrl(url);
        } catch (err) {
            console.error('Error encoding MP3 audio:', err);
        }
    }, [
        cleanupStreamAndAudioContext
    ]);
    // Trigger limit reached auto-stop
    const handleReachMaxLimit = (0, _react.useCallback)(()=>{
        if (!isRecordingRef.current) return;
        if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current);
            timerIntervalRef.current = null;
        }
        setDuration(maxDurationSecondsRef.current);
        stopRecordingInternal();
        onMaxDurationReachedRef.current?.();
    }, [
        stopRecordingInternal
    ]);
    // Start audio level visualizer loop
    const startVolumeAnalyser = (0, _react.useCallback)((analyser)=>{
        const dataArray = new Uint8Array(analyser.frequencyBinCount);
        const updateVolume = ()=>{
            if (!analyserRef.current) return;
            analyserRef.current.getByteFrequencyData(dataArray);
            let sum = 0;
            for(let i = 0; i < dataArray.length; i++)sum += dataArray[i];
            const avg = sum / dataArray.length;
            const normalized = Math.min(100, Math.round(avg / 128 * 100));
            setVolumeLevel(normalized);
            animFrameRef.current = requestAnimationFrame(updateVolume);
        };
        updateVolume();
    }, []);
    // Start recording
    const startRecording = (0, _react.useCallback)(async ()=>{
        clearError();
        if (typeof navigator === 'undefined' || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
            setPermissionStatus('unsupported');
            setErrorMessage('Audio recording is not supported in this browser. Please try Chrome, Firefox, or Safari.');
            return false;
        }
        try {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    echoCancellation: true,
                    noiseSuppression: true,
                    autoGainControl: true
                }
            });
            mediaStreamRef.current = stream;
            setPermissionStatus('granted');
            // Initialize AudioContext
            const AudioCtx = window.AudioContext || window.webkitAudioContext;
            const audioCtx = new AudioCtx();
            audioContextRef.current = audioCtx;
            const sourceNode = audioCtx.createMediaStreamSource(stream);
            sourceNodeRef.current = sourceNode;
            // Analyser for waveform / volume level
            const analyser = audioCtx.createAnalyser();
            analyser.fftSize = 64;
            analyser.smoothingTimeConstant = 0.8;
            sourceNode.connect(analyser);
            analyserRef.current = analyser;
            // ScriptProcessor to capture raw PCM chunks
            const bufferSize = 4096;
            const processor = audioCtx.createScriptProcessor(bufferSize, 1, 1);
            processorNodeRef.current = processor;
            pcmChunksRef.current = [];
            totalSamplesRef.current = 0;
            processor.onaudioprocess = (e)=>{
                if (isPausedRef.current || !isRecordingRef.current) return;
                const channelData = e.inputBuffer.getChannelData(0);
                const sampleRate = audioContextRef.current?.sampleRate || 44100;
                const maxSamples = sampleRate * maxDurationSecondsRef.current;
                if (totalSamplesRef.current + channelData.length >= maxSamples) {
                    const remaining = Math.max(0, maxSamples - totalSamplesRef.current);
                    if (remaining > 0) {
                        pcmChunksRef.current.push(new Float32Array(channelData.subarray(0, remaining)));
                        totalSamplesRef.current += remaining;
                    }
                    handleReachMaxLimit();
                    return;
                }
                pcmChunksRef.current.push(new Float32Array(channelData));
                totalSamplesRef.current += channelData.length;
            };
            sourceNode.connect(processor);
            // Connect to a silent/zero gain node or destination to keep processor active in all browsers
            const silentGain = audioCtx.createGain();
            silentGain.gain.value = 0;
            processor.connect(silentGain);
            silentGain.connect(audioCtx.destination);
            isRecordingRef.current = true;
            setIsRecording(true);
            setIsPaused(false);
            isPausedRef.current = false;
            setDuration(0);
            // Start volume analyser
            startVolumeAnalyser(analyser);
            // Start duration timer
            if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
            timerIntervalRef.current = setInterval(()=>{
                setDuration((prev)=>{
                    const next = prev + 1;
                    if (next >= maxDurationSecondsRef.current) {
                        handleReachMaxLimit();
                        return maxDurationSecondsRef.current;
                    }
                    return next;
                });
            }, 1000);
            return true;
        } catch (err) {
            const error = err;
            let friendlyMsg = 'Failed to start recording. Please check microphone permissions.';
            if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError' || error.message && error.message.toLowerCase().includes('permission')) {
                setPermissionStatus('denied');
                friendlyMsg = 'Microphone access is blocked in your browser settings. Please allow microphone access to record voice notes.';
            } else if (error.name === 'NotFoundError' || error.name === 'DevicesNotFoundError' || error.message && error.message.toLowerCase().includes('not found')) {
                setPermissionStatus('not_found');
                friendlyMsg = 'No microphone was detected on this device. Please connect a microphone and try again.';
            } else if (error.name === 'NotReadableError') {
                setPermissionStatus('denied');
                friendlyMsg = 'Your microphone is currently in use by another application.';
            } else {
                setPermissionStatus('denied');
                friendlyMsg = error.message || friendlyMsg;
            }
            setErrorMessage(friendlyMsg);
            if (errorTimerRef.current) clearTimeout(errorTimerRef.current);
            errorTimerRef.current = setTimeout(()=>{
                setErrorMessage(null);
            }, 6000);
            return false;
        }
    }, [
        clearError,
        handleReachMaxLimit,
        startVolumeAnalyser
    ]);
    // Pause recording
    const pauseRecording = (0, _react.useCallback)(()=>{
        if (!isRecordingRef.current || isPausedRef.current) return;
        setIsPaused(true);
        isPausedRef.current = true;
        if (timerIntervalRef.current) {
            clearInterval(timerIntervalRef.current);
            timerIntervalRef.current = null;
        }
    }, []);
    // Resume recording
    const resumeRecording = (0, _react.useCallback)(()=>{
        if (!isRecordingRef.current || !isPausedRef.current) return;
        setIsPaused(false);
        isPausedRef.current = false;
        if (timerIntervalRef.current) clearInterval(timerIntervalRef.current);
        timerIntervalRef.current = setInterval(()=>{
            setDuration((prev)=>{
                const next = prev + 1;
                if (next >= maxDurationSecondsRef.current) {
                    handleReachMaxLimit();
                    return maxDurationSecondsRef.current;
                }
                return next;
            });
        }, 1000);
    }, [
        handleReachMaxLimit
    ]);
    // Stop recording
    const stopRecording = (0, _react.useCallback)(()=>{
        if (!isRecordingRef.current) return;
        if (durationRef.current < minDurationSecondsRef.current) return; // Debounce guard: cannot stop before minimum duration
        stopRecordingInternal();
    }, [
        stopRecordingInternal
    ]);
    // Cancel / discard recording
    const cancelRecording = (0, _react.useCallback)(()=>{
        isRecordingRef.current = false;
        cleanupStreamAndAudioContext();
        pcmChunksRef.current = [];
        totalSamplesRef.current = 0;
        setIsRecording(false);
        setIsPaused(false);
        isPausedRef.current = false;
        setDuration(0);
        if (audioUrl) URL.revokeObjectURL(audioUrl);
        setAudioBlob(null);
        setAudioUrl(null);
    }, [
        cleanupStreamAndAudioContext,
        audioUrl
    ]);
    // Clear recorded audio
    const clearAudio = (0, _react.useCallback)(()=>{
        if (audioUrl) URL.revokeObjectURL(audioUrl);
        setAudioBlob(null);
        setAudioUrl(null);
        setDuration(0);
        pcmChunksRef.current = [];
        totalSamplesRef.current = 0;
    }, [
        audioUrl
    ]);
    // Cleanup on unmount
    (0, _react.useEffect)(()=>{
        return ()=>{
            cleanupStreamAndAudioContext();
            if (audioUrl) URL.revokeObjectURL(audioUrl);
        };
    }, [
        cleanupStreamAndAudioContext,
        audioUrl
    ]);
    return {
        isRecording,
        isPaused,
        duration,
        formattedDuration: formatAudioDuration(Math.min(duration, maxDurationSeconds)),
        audioBlob,
        audioUrl,
        volumeLevel,
        canStop: duration >= minDurationSeconds,
        permissionStatus,
        errorMessage,
        startRecording,
        pauseRecording,
        resumeRecording,
        stopRecording,
        cancelRecording,
        clearAudio,
        clearError
    };
};

},{"react":"bmhQu","@breezystack/lamejs":"dFibA","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dFibA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Mp3Encoder", ()=>Sr);
parcelHelpers.export(exports, "WavHeader", ()=>dr);
parcelHelpers.export(exports, "default", ()=>fa);
var fa = {};
function Xa(w) {
    return new Int8Array(w);
}
function ma(w) {
    return new Int16Array(w);
}
function ba(w) {
    return new Int32Array(w);
}
function ca(w) {
    return new Float32Array(w);
}
function Ya(w) {
    return new Float64Array(w);
}
function Sa(w) {
    if (w.length == 1) return ca(w[0]);
    var Z = w[0];
    w = w.slice(1);
    for(var X = [], z = 0; z < Z; z++)X.push(Sa(w));
    return X;
}
function da(w) {
    if (w.length == 1) return ba(w[0]);
    var Z = w[0];
    w = w.slice(1);
    for(var X = [], z = 0; z < Z; z++)X.push(da(w));
    return X;
}
function Aa(w) {
    if (w.length == 1) return ma(w[0]);
    var Z = w[0];
    w = w.slice(1);
    for(var X = [], z = 0; z < Z; z++)X.push(Aa(w));
    return X;
}
function Ra(w) {
    if (w.length == 1) return new Array(w[0]);
    var Z = w[0];
    w = w.slice(1);
    for(var X = [], z = 0; z < Z; z++)X.push(Ra(w));
    return X;
}
var xa = {};
xa.fill = function(w, Z, X, z) {
    if (arguments.length == 2) for(var u0 = 0; u0 < w.length; u0++)w[u0] = arguments[1];
    else for(var u0 = Z; u0 < X; u0++)w[u0] = z;
};
var W1 = {};
W1.arraycopy = function(w, Z, X, z, u0) {
    for(var W = Z + u0; Z < W;)X[z++] = w[Z++];
};
W1.out = {};
W1.out.println = function(w) {
    console.log(w);
};
W1.out.printf = function() {
    console.log.apply(console, arguments);
};
var se = {};
se.SQRT2 = 1.4142135623730951;
se.FAST_LOG10 = function(w) {
    return Math.log10(w);
};
se.FAST_LOG10_X = function(w, Z) {
    return Math.log10(w) * Z;
};
function B1(w) {
    this.ordinal = w;
}
B1.short_block_allowed = new B1(0);
B1.short_block_coupled = new B1(1);
B1.short_block_dispensed = new B1(2);
B1.short_block_forced = new B1(3);
var Ma = {};
Ma.MAX_VALUE = 34028235e31;
function u1(w) {
    this.ordinal = w;
}
u1.vbr_off = new u1(0);
u1.vbr_mt = new u1(1);
u1.vbr_rh = new u1(2);
u1.vbr_abr = new u1(3);
u1.vbr_mtrh = new u1(4);
u1.vbr_default = u1.vbr_mtrh;
var qa = function(w) {}, Q0 = {
    System: W1,
    VbrMode: u1,
    Float: Ma,
    ShortBlock: B1,
    Util: se,
    Arrays: xa,
    new_array_n: Ra,
    new_byte: Xa,
    new_double: Ya,
    new_float: ca,
    new_float_n: Sa,
    new_int: ba,
    new_int_n: da,
    new_short: ma,
    new_short_n: Aa,
    assert: qa
}, ce, De;
function Da() {
    if (De) return ce;
    De = 1;
    var w = Q0, Z = w.System, X = w.Util, z = w.Arrays, u0 = w.new_float, W = t1();
    function Q() {
        var D = [
            -0.1482523854003001,
            32.308141959636465,
            296.40344946382766,
            883.1344870032432,
            11113.947376231741,
            1057.2713659324597,
            305.7402417275812,
            30.825928907280012,
            /* 15 */ 3.8533188138216365,
            59.42900443849514,
            709.5899960123345,
            5281.91112291017,
            -5829.66483675846,
            -817.6293103748613,
            -76.91656988279972,
            -4.594269939176596,
            0.9063471690191471,
            0.1960342806591213,
            -0.15466694054279598,
            34.324387823855965,
            301.8067566458425,
            817.599602898885,
            11573.795901679885,
            1181.2520595540152,
            321.59731579894424,
            31.232021761053772,
            /* 14 */ 3.7107095756221318,
            53.650946155329365,
            684.167428119626,
            5224.56624370173,
            -6366.391851890084,
            -908.9766368219582,
            -89.83068876699639,
            -5.411397422890401,
            0.8206787908286602,
            0.3901806440322567,
            -0.16070888947830023,
            36.147034243915876,
            304.11815768187864,
            732.7429163887613,
            11989.60988270091,
            1300.012278487897,
            335.28490093152146,
            31.48816102859945,
            /* 13 */ 3.373875931311736,
            47.232241542899175,
            652.7371796173471,
            5132.414255594984,
            -6909.087078780055,
            -1001.9990371107289,
            -103.62185754286375,
            -6.104916304710272,
            0.7416505462720353,
            0.5805693545089249,
            -0.16636367662261495,
            37.751650073343995,
            303.01103387567713,
            627.9747488785183,
            12358.763425278165,
            1412.2779918482834,
            346.7496836825721,
            31.598286663170416,
            /* 12 */ 3.1598635433980946,
            40.57878626349686,
            616.1671130880391,
            5007.833007176154,
            -7454.040671756168,
            -1095.7960341867115,
            -118.24411666465777,
            -6.818469345853504,
            0.6681786379192989,
            0.7653668647301797,
            -0.1716176790982088,
            39.11551877123304,
            298.3413246578966,
            503.5259106886539,
            12679.589408408976,
            1516.5821921214542,
            355.9850766329023,
            31.395241710249053,
            /* 11 */ 2.9164211881972335,
            33.79716964664243,
            574.8943997801362,
            4853.234992253242,
            -7997.57021486075,
            -1189.7624067269965,
            -133.6444792601766,
            -7.7202770609839915,
            0.5993769336819237,
            0.9427934736519954,
            -0.17645823955292173,
            40.21879108166477,
            289.9982036694474,
            359.3226160751053,
            12950.259102786438,
            1612.1013903507662,
            362.85067106591504,
            31.045922092242872,
            /* 10 */ 2.822222032597987,
            26.988862316190684,
            529.8996541764288,
            4671.371946949588,
            -8535.899136645805,
            -1282.5898586244496,
            -149.58553632943463,
            -8.643494270763135,
            0.5345111359507916,
            1.111140466039205,
            -0.36174739330527045,
            41.04429910497807,
            277.5463268268618,
            195.6386023135583,
            13169.43812144731,
            1697.6433561479398,
            367.40983966190305,
            30.557037410382826,
            /* 9 */ 2.531473372857427,
            20.070154905927314,
            481.50208566532336,
            4464.970341588308,
            -9065.36882077239,
            -1373.62841526722,
            -166.1660487028118,
            -9.58289321133207,
            0.4729647758913199,
            1.268786568327291,
            -0.36970682634889585,
            41.393213350082036,
            261.2935935556502,
            12.935476055240873,
            13336.131683328815,
            1772.508612059496,
            369.76534388639965,
            29.751323653701338,
            2.4023193045459172,
            13.304795348228817,
            430.5615775526625,
            4237.0568611071185,
            -9581.931701634761,
            -1461.6913552409758,
            -183.12733958476446,
            -10.718010163869403,
            0.41421356237309503,
            /* tan(PI/8) */ 1.414213562373095,
            -0.37677560326535325,
            41.619486213528496,
            241.05423794991074,
            -187.94665032361226,
            13450.063605744153,
            1836.153896465782,
            369.4908799925761,
            29.001847876923147,
            /* 7 */ 2.0714759319987186,
            6.779591200894186,
            377.7767837205709,
            3990.386575512536,
            -10081.709459700915,
            -1545.947424837898,
            -200.3762958015653,
            -11.864482073055006,
            0.3578057213145241,
            1.546020906725474,
            -0.3829366947518991,
            41.1516456456653,
            216.47684307105183,
            -406.1569483347166,
            13511.136535077321,
            1887.8076599260432,
            367.3025214564151,
            28.136213436723654,
            /* 6 */ 1.913880671464418,
            0.3829366947518991,
            323.85365704338597,
            3728.1472257487526,
            -10561.233882199509,
            -1625.2025997821418,
            -217.62525175416,
            -13.015432208941645,
            0.3033466836073424,
            1.66293922460509,
            -0.5822628872992417,
            40.35639251440489,
            188.20071124269245,
            -640.2706748618148,
            13519.21490106562,
            1927.6022433578062,
            362.8197642637487,
            26.968821921868447,
            /* 5 */ 1.7463817695935329,
            -5.62650678237171,
            269.3016715297017,
            3453.386536448852,
            -11016.145278780888,
            -1698.6569643425091,
            -234.7658734267683,
            -14.16351421663124,
            0.2504869601913055,
            1.76384252869671,
            -0.5887180101749253,
            39.23429103868072,
            155.76096234403798,
            -889.2492977967378,
            13475.470561874661,
            1955.0535223723712,
            356.4450994756727,
            25.894952980042156,
            /* 4 */ 1.5695032905781554,
            -11.181939564328772,
            214.80884394039484,
            3169.1640829158237,
            -11443.321309975563,
            -1765.1588461316153,
            -251.68908574481912,
            -15.49755935939164,
            0.198912367379658,
            1.847759065022573,
            -0.7912582233652842,
            37.39369355329111,
            119.699486012458,
            -1151.0956593239027,
            13380.446257078214,
            1970.3952110853447,
            348.01959814116185,
            24.731487364283044,
            /* 3 */ 1.3850130831637748,
            -16.421408865300393,
            161.05030052864092,
            2878.3322807850063,
            -11838.991423510031,
            -1823.985884688674,
            -268.2854986386903,
            -16.81724543849939,
            0.1483359875383474,
            1.913880671464418,
            -0.7960642926861912,
            35.2322109610459,
            80.01928065061526,
            -1424.0212633405113,
            13235.794061869668,
            1973.804052543835,
            337.9908651258184,
            23.289159354463873,
            1.3934255946442087,
            -21.099669467133474,
            108.48348407242611,
            2583.700758091299,
            -12199.726194855148,
            -1874.2780658979746,
            -284.2467154529415,
            -18.11369784385905,
            0.09849140335716425,
            1.961570560806461,
            -0.998795456205172,
            32.56307803611191,
            36.958364584370486,
            -1706.075448829146,
            13043.287458812016,
            1965.3831106103316,
            326.43182772364605,
            22.175018750622293,
            1.198638339011324,
            -25.371248002043963,
            57.53505923036915,
            2288.41886619975,
            -12522.674544337233,
            -1914.8400385312243,
            -299.26241273417224,
            -19.37805630698734,
            0.04912684976946725,
            1.990369453344394,
            0.035780907 * X.SQRT2 * 0.5 / 2384e-9,
            0.017876148 * X.SQRT2 * 0.5 / 2384e-9,
            3134727e-9 * X.SQRT2 * 0.5 / 2384e-9,
            2457142e-9 * X.SQRT2 * 0.5 / 2384e-9,
            971317e-9 * X.SQRT2 * 0.5 / 2384e-9,
            218868e-9 * X.SQRT2 * 0.5 / 2384e-9,
            101566e-9 * X.SQRT2 * 0.5 / 2384e-9,
            13828e-9 * X.SQRT2 * 0.5 / 2384e-9,
            12804.797818791945,
            1945.5515939597317,
            313.4244966442953,
            20.801593959731544,
            1995.1556208053692,
            9.000838926174497,
            -29.20218120805369
        ], g = 12, f0 = 36, A = [
            [
                2382191739347913e-28,
                6423305872147834e-28,
                9400849094049688e-28,
                1122435026096556e-27,
                1183840321267481e-27,
                1122435026096556e-27,
                940084909404969e-27,
                6423305872147839e-28,
                2382191739347918e-28,
                5456116108943412e-27,
                4878985199565852e-27,
                4240448995017367e-27,
                3559909094758252e-27,
                2858043359288075e-27,
                2156177623817898e-27,
                1475637723558783e-27,
                8371015190102974e-28,
                2599706096327376e-28,
                -0.000000000005456116108943412,
                -0.000000000004878985199565852,
                -0.000000000004240448995017367,
                -0.000000000003559909094758252,
                -0.000000000002858043359288076,
                -0.000000000002156177623817898,
                -0.000000000001475637723558783,
                -0.0000000000008371015190102975,
                -0.0000000000002599706096327376,
                -0.0000000000002382191739347923,
                -0.0000000000006423305872147843,
                -0.0000000000009400849094049696,
                -0.000000000001122435026096556,
                -0.000000000001183840321267481,
                -0.000000000001122435026096556,
                -0.0000000000009400849094049694,
                -0.000000000000642330587214784,
                -0.0000000000002382191739347918
            ],
            [
                2382191739347913e-28,
                6423305872147834e-28,
                9400849094049688e-28,
                1122435026096556e-27,
                1183840321267481e-27,
                1122435026096556e-27,
                9400849094049688e-28,
                6423305872147841e-28,
                2382191739347918e-28,
                5456116108943413e-27,
                4878985199565852e-27,
                4240448995017367e-27,
                3559909094758253e-27,
                2858043359288075e-27,
                2156177623817898e-27,
                1475637723558782e-27,
                8371015190102975e-28,
                2599706096327376e-28,
                -0.000000000005461314069809755,
                -0.000000000004921085770524055,
                -0.000000000004343405037091838,
                -0.000000000003732668368707687,
                -0.000000000003093523840190885,
                -0.000000000002430835727329465,
                -0.000000000001734679010007751,
                -0.000000000000974825365660928,
                -0.0000000000002797435120168326,
                0,
                0,
                0,
                0,
                0,
                0,
                -0.0000000000002283748241799531,
                -0.0000000000004037858874020686,
                -0.0000000000002146547464825323
            ],
            [
                0.1316524975873958,
                /* win[SHORT_TYPE] */ 0.414213562373095,
                0.7673269879789602,
                1.091308501069271,
                /* tantab_l */ 1.303225372841206,
                1.56968557711749,
                1.920982126971166,
                2.414213562373094,
                3.171594802363212,
                4.510708503662055,
                7.595754112725146,
                22.90376554843115,
                0.984807753012208,
                /* cx */ 0.6427876096865394,
                0.3420201433256688,
                0.9396926207859084,
                -0.1736481776669303,
                -0.7660444431189779,
                0.8660254037844387,
                0.5,
                -0.5144957554275265,
                /* ca */ -0.4717319685649723,
                -0.3133774542039019,
                -0.1819131996109812,
                -0.09457419252642064,
                -0.04096558288530405,
                -0.01419856857247115,
                -0.003699974673760037,
                0.8574929257125442,
                /* cs */ 0.8817419973177052,
                0.9496286491027329,
                0.9833145924917901,
                0.9955178160675857,
                0.9991605581781475,
                0.999899195244447,
                0.9999931550702802
            ],
            [
                0,
                0,
                0,
                0,
                0,
                0,
                2283748241799531e-28,
                4037858874020686e-28,
                2146547464825323e-28,
                5461314069809755e-27,
                4921085770524055e-27,
                4343405037091838e-27,
                3732668368707687e-27,
                3093523840190885e-27,
                2430835727329466e-27,
                1734679010007751e-27,
                974825365660928e-27,
                2797435120168326e-28,
                -0.000000000005456116108943413,
                -0.000000000004878985199565852,
                -0.000000000004240448995017367,
                -0.000000000003559909094758253,
                -0.000000000002858043359288075,
                -0.000000000002156177623817898,
                -0.000000000001475637723558782,
                -0.0000000000008371015190102975,
                -0.0000000000002599706096327376,
                -0.0000000000002382191739347913,
                -0.0000000000006423305872147834,
                -0.0000000000009400849094049688,
                -0.000000000001122435026096556,
                -0.000000000001183840321267481,
                -0.000000000001122435026096556,
                -0.0000000000009400849094049688,
                -0.0000000000006423305872147841,
                -0.0000000000002382191739347918
            ]
        ], m = A[W.SHORT_TYPE], O = A[W.SHORT_TYPE], s0 = A[W.SHORT_TYPE], K = A[W.SHORT_TYPE], t0 = [
            0,
            1,
            16,
            17,
            8,
            9,
            24,
            25,
            4,
            5,
            20,
            21,
            12,
            13,
            28,
            29,
            2,
            3,
            18,
            19,
            10,
            11,
            26,
            27,
            6,
            7,
            22,
            23,
            14,
            15,
            30,
            31
        ];
        function U(u, d, e) {
            for(var l = 10, M = d + 238 - 14 - 286, p = -15; p < 0; p++){
                var H, B, I;
                H = D[l + -10], B = u[M + -224] * H, I = u[d + 224] * H, H = D[l + -9], B += u[M + -160] * H, I += u[d + 160] * H, H = D[l + -8], B += u[M + -96] * H, I += u[d + 96] * H, H = D[l + -7], B += u[M + -32] * H, I += u[d + 32] * H, H = D[l + -6], B += u[M + 32] * H, I += u[d + -32] * H, H = D[l + -5], B += u[M + 96] * H, I += u[d + -96] * H, H = D[l + -4], B += u[M + 160] * H, I += u[d + -160] * H, H = D[l + -3], B += u[M + 224] * H, I += u[d + -224] * H, H = D[l + -2], B += u[d + -256] * H, I -= u[M + 256] * H, H = D[l + -1], B += u[d + -192] * H, I -= u[M + 192] * H, H = D[l + 0], B += u[d + -128] * H, I -= u[M + 128] * H, H = D[l + 1], B += u[d + -64] * H, I -= u[M + 64] * H, H = D[l + 2], B += u[d + 0] * H, I -= u[M + 0] * H, H = D[l + 3], B += u[d + 64] * H, I -= u[M + -64] * H, H = D[l + 4], B += u[d + 128] * H, I -= u[M + -128] * H, H = D[l + 5], B += u[d + 192] * H, I -= u[M + -192] * H, B *= D[l + 6], H = I - B, e[30 + p * 2] = I + B, e[31 + p * 2] = D[l + 7] * H, l += 18, d--, M++;
            }
            var B, I, v0, b;
            I = u[d + -16] * D[l + -10], B = u[d + -32] * D[l + -2], I += (u[d + -48] - u[d + 16]) * D[l + -9], B += u[d + -96] * D[l + -1], I += (u[d + -80] + u[d + 48]) * D[l + -8], B += u[d + -160] * D[l + 0], I += (u[d + -112] - u[d + 80]) * D[l + -7], B += u[d + -224] * D[l + 1], I += (u[d + -144] + u[d + 112]) * D[l + -6], B -= u[d + 32] * D[l + 2], I += (u[d + -176] - u[d + 144]) * D[l + -5], B -= u[d + 96] * D[l + 3], I += (u[d + -208] + u[d + 176]) * D[l + -4], B -= u[d + 160] * D[l + 4], I += (u[d + -240] - u[d + 208]) * D[l + -3], B -= u[d + 224], v0 = B - I, b = B + I, I = e[14], B = e[15] - I, e[31] = b + I, e[30] = v0 + B, e[15] = v0 - B, e[14] = b - I;
            var a;
            a = e[28] - e[0], e[0] += e[28], e[28] = a * D[l + -36 + 7], a = e[29] - e[1], e[1] += e[29], e[29] = a * D[l + -36 + 7], a = e[26] - e[2], e[2] += e[26], e[26] = a * D[l + -72 + 7], a = e[27] - e[3], e[3] += e[27], e[27] = a * D[l + -72 + 7], a = e[24] - e[4], e[4] += e[24], e[24] = a * D[l + -108 + 7], a = e[25] - e[5], e[5] += e[25], e[25] = a * D[l + -108 + 7], a = e[22] - e[6], e[6] += e[22], e[22] = a * X.SQRT2, a = e[23] - e[7], e[7] += e[23], e[23] = a * X.SQRT2 - e[7], e[7] -= e[6], e[22] -= e[7], e[23] -= e[22], a = e[6], e[6] = e[31] - a, e[31] = e[31] + a, a = e[7], e[7] = e[30] - a, e[30] = e[30] + a, a = e[22], e[22] = e[15] - a, e[15] = e[15] + a, a = e[23], e[23] = e[14] - a, e[14] = e[14] + a, a = e[20] - e[8], e[8] += e[20], e[20] = a * D[l + -180 + 7], a = e[21] - e[9], e[9] += e[21], e[21] = a * D[l + -180 + 7], a = e[18] - e[10], e[10] += e[18], e[18] = a * D[l + -216 + 7], a = e[19] - e[11], e[11] += e[19], e[19] = a * D[l + -216 + 7], a = e[16] - e[12], e[12] += e[16], e[16] = a * D[l + -252 + 7], a = e[17] - e[13], e[13] += e[17], e[17] = a * D[l + -252 + 7], a = -e[20] + e[24], e[20] += e[24], e[24] = a * D[l + -216 + 7], a = -e[21] + e[25], e[21] += e[25], e[25] = a * D[l + -216 + 7], a = e[4] - e[8], e[4] += e[8], e[8] = a * D[l + -216 + 7], a = e[5] - e[9], e[5] += e[9], e[9] = a * D[l + -216 + 7], a = e[0] - e[12], e[0] += e[12], e[12] = a * D[l + -72 + 7], a = e[1] - e[13], e[1] += e[13], e[13] = a * D[l + -72 + 7], a = e[16] - e[28], e[16] += e[28], e[28] = a * D[l + -72 + 7], a = -e[17] + e[29], e[17] += e[29], e[29] = a * D[l + -72 + 7], a = X.SQRT2 * (e[2] - e[10]), e[2] += e[10], e[10] = a, a = X.SQRT2 * (e[3] - e[11]), e[3] += e[11], e[11] = a, a = X.SQRT2 * (-e[18] + e[26]), e[18] += e[26], e[26] = a - e[18], a = X.SQRT2 * (-e[19] + e[27]), e[19] += e[27], e[27] = a - e[19], a = e[2], e[19] -= e[3], e[3] -= a, e[2] = e[31] - a, e[31] += a, a = e[3], e[11] -= e[19], e[18] -= a, e[3] = e[30] - a, e[30] += a, a = e[18], e[27] -= e[11], e[19] -= a, e[18] = e[15] - a, e[15] += a, a = e[19], e[10] -= a, e[19] = e[14] - a, e[14] += a, a = e[10], e[11] -= a, e[10] = e[23] - a, e[23] += a, a = e[11], e[26] -= a, e[11] = e[22] - a, e[22] += a, a = e[26], e[27] -= a, e[26] = e[7] - a, e[7] += a, a = e[27], e[27] = e[6] - a, e[6] += a, a = X.SQRT2 * (e[0] - e[4]), e[0] += e[4], e[4] = a, a = X.SQRT2 * (e[1] - e[5]), e[1] += e[5], e[5] = a, a = X.SQRT2 * (e[16] - e[20]), e[16] += e[20], e[20] = a, a = X.SQRT2 * (e[17] - e[21]), e[17] += e[21], e[21] = a, a = -X.SQRT2 * (e[8] - e[12]), e[8] += e[12], e[12] = a - e[8], a = -X.SQRT2 * (e[9] - e[13]), e[9] += e[13], e[13] = a - e[9], a = -X.SQRT2 * (e[25] - e[29]), e[25] += e[29], e[29] = a - e[25], a = -X.SQRT2 * (e[24] + e[28]), e[24] -= e[28], e[28] = a - e[24], a = e[24] - e[16], e[24] = a, a = e[20] - a, e[20] = a, a = e[28] - a, e[28] = a, a = e[25] - e[17], e[25] = a, a = e[21] - a, e[21] = a, a = e[29] - a, e[29] = a, a = e[17] - e[1], e[17] = a, a = e[9] - a, e[9] = a, a = e[25] - a, e[25] = a, a = e[5] - a, e[5] = a, a = e[21] - a, e[21] = a, a = e[13] - a, e[13] = a, a = e[29] - a, e[29] = a, a = e[1] - e[0], e[1] = a, a = e[16] - a, e[16] = a, a = e[17] - a, e[17] = a, a = e[8] - a, e[8] = a, a = e[9] - a, e[9] = a, a = e[24] - a, e[24] = a, a = e[25] - a, e[25] = a, a = e[4] - a, e[4] = a, a = e[5] - a, e[5] = a, a = e[20] - a, e[20] = a, a = e[21] - a, e[21] = a, a = e[12] - a, e[12] = a, a = e[13] - a, e[13] = a, a = e[28] - a, e[28] = a, a = e[29] - a, e[29] = a, a = e[0], e[0] += e[31], e[31] -= a, a = e[1], e[1] += e[30], e[30] -= a, a = e[16], e[16] += e[15], e[15] -= a, a = e[17], e[17] += e[14], e[14] -= a, a = e[8], e[8] += e[23], e[23] -= a, a = e[9], e[9] += e[22], e[22] -= a, a = e[24], e[24] += e[7], e[7] -= a, a = e[25], e[25] += e[6], e[6] -= a, a = e[4], e[4] += e[27], e[27] -= a, a = e[5], e[5] += e[26], e[26] -= a, a = e[20], e[20] += e[11], e[11] -= a, a = e[21], e[21] += e[10], e[10] -= a, a = e[12], e[12] += e[19], e[19] -= a, a = e[13], e[13] += e[18], e[18] -= a, a = e[28], e[28] += e[3], e[3] -= a, a = e[29], e[29] += e[2], e[2] -= a;
        }
        function R(u, d) {
            for(var e = 0; e < 3; e++){
                var l, M, p, H, B, I;
                H = u[d + 6] * A[W.SHORT_TYPE][0] - u[d + 15], l = u[d + 0] * A[W.SHORT_TYPE][2] - u[d + 9], M = H + l, p = H - l, H = u[d + 15] * A[W.SHORT_TYPE][0] + u[d + 6], l = u[d + 9] * A[W.SHORT_TYPE][2] + u[d + 0], B = H + l, I = -H + l, l = (u[d + 3] * A[W.SHORT_TYPE][1] - u[d + 12]) * 2069978111953089e-26, H = (u[d + 12] * A[W.SHORT_TYPE][1] + u[d + 3]) * 2069978111953089e-26, u[d + 0] = M * 190752519173728e-25 + l, u[d + 15] = -B * 190752519173728e-25 + H, p = p * 0.000000000016519652744032674, B = B * 0.5 * 1907525191737281e-26 + H, u[d + 3] = p - B, u[d + 6] = p + B, M = M * 0.5 * 1907525191737281e-26 - l, I = I * 0.000000000016519652744032674, u[d + 9] = M + I, u[d + 12] = M - I, d++;
            }
        }
        function o(u, d, e) {
            var l, M;
            var p, H, B, I, v0, b, a, S;
            p = e[17] - e[9], B = e[15] - e[11], I = e[14] - e[12], v0 = e[0] + e[8], b = e[1] + e[7], a = e[2] + e[6], S = e[3] + e[5], u[d + 17] = v0 + a - S - (b - e[4]), M = (v0 + a - S) * O[19] + (b - e[4]), l = (p - B - I) * O[18], u[d + 5] = l + M, u[d + 6] = l - M, H = (e[16] - e[10]) * O[18], b = b * O[19] + e[4], l = p * O[12] + H + B * O[13] + I * O[14], M = -v0 * O[16] + b - a * O[17] + S * O[15], u[d + 1] = l + M, u[d + 2] = l - M, l = p * O[13] - H - B * O[14] + I * O[12], M = -v0 * O[17] + b - a * O[15] + S * O[16], u[d + 9] = l + M, u[d + 10] = l - M, l = p * O[14] - H + B * O[12] - I * O[13], M = v0 * O[15] - b + a * O[16] - S * O[17], u[d + 13] = l + M, u[d + 14] = l - M;
            var L, V, N, P, E, i, s, r;
            L = e[8] - e[0], N = e[6] - e[2], P = e[5] - e[3], E = e[17] + e[9], i = e[16] + e[10], s = e[15] + e[11], r = e[14] + e[12], u[d + 0] = E + s + r + (i + e[13]), l = (E + s + r) * O[19] - (i + e[13]), M = (L - N + P) * O[18], u[d + 11] = l + M, u[d + 12] = l - M, V = (e[7] - e[1]) * O[18], i = e[13] - i * O[19], l = E * O[15] - i + s * O[16] + r * O[17], M = L * O[14] + V + N * O[12] + P * O[13], u[d + 3] = l + M, u[d + 4] = l - M, l = -E * O[17] + i - s * O[15] - r * O[16], M = L * O[13] + V - N * O[14] - P * O[12], u[d + 7] = l + M, u[d + 8] = l - M, l = -E * O[16] + i - s * O[17] - r * O[15], M = L * O[12] - V + N * O[13] - P * O[14], u[d + 15] = l + M, u[d + 16] = l - M;
        }
        this.mdct_sub48 = function(u, d, e) {
            for(var l = d, M = 286, p = 0; p < u.channels_out; p++){
                for(var H = 0; H < u.mode_gr; H++){
                    for(var B, I = u.l3_side.tt[H][p], v0 = I.xr, b = 0, a = u.sb_sample[p][1 - H], S = 0, L = 0; L < 9; L++)for(U(l, M, a[S]), U(l, M + 32, a[S + 1]), S += 2, M += 64, B = 1; B < 32; B += 2)a[S - 1][B] *= -1;
                    for(B = 0; B < 32; B++, b += 18){
                        var V = I.block_type, N = u.sb_sample[p][H], P = u.sb_sample[p][1 - H];
                        if (I.mixed_block_flag != 0 && B < 2 && (V = 0), u.amp_filter[B] < 1e-12) z.fill(v0, b + 0, b + 18, 0);
                        else {
                            if (u.amp_filter[B] < 1) for(var L = 0; L < 18; L++)P[L][t0[B]] *= u.amp_filter[B];
                            if (V == W.SHORT_TYPE) {
                                for(var L = -g / 4; L < 0; L++){
                                    var E = A[W.SHORT_TYPE][L + 3];
                                    v0[b + L * 3 + 9] = N[9 + L][t0[B]] * E - N[8 - L][t0[B]], v0[b + L * 3 + 18] = N[14 - L][t0[B]] * E + N[15 + L][t0[B]], v0[b + L * 3 + 10] = N[15 + L][t0[B]] * E - N[14 - L][t0[B]], v0[b + L * 3 + 19] = P[2 - L][t0[B]] * E + P[3 + L][t0[B]], v0[b + L * 3 + 11] = P[3 + L][t0[B]] * E - P[2 - L][t0[B]], v0[b + L * 3 + 20] = P[8 - L][t0[B]] * E + P[9 + L][t0[B]];
                                }
                                R(v0, b);
                            } else {
                                for(var i = u0(18), L = -f0 / 4; L < 0; L++){
                                    var s, r;
                                    s = A[V][L + 27] * P[L + 9][t0[B]] + A[V][L + 36] * P[8 - L][t0[B]], r = A[V][L + 9] * N[L + 9][t0[B]] - A[V][L + 18] * N[8 - L][t0[B]], i[L + 9] = s - r * m[3 + L + 9], i[L + 18] = s * m[3 + L + 9] + r;
                                }
                                o(v0, b, i);
                            }
                        }
                        if (V != W.SHORT_TYPE && B != 0) for(var L = 7; L >= 0; --L){
                            var n, f;
                            n = v0[b + L] * s0[20 + L] + v0[b + -1 - L] * K[28 + L], f = v0[b + L] * K[28 + L] - v0[b + -1 - L] * s0[20 + L], v0[b + -1 - L] = n, v0[b + L] = f;
                        }
                    }
                }
                if (l = e, M = 286, u.mode_gr == 1) for(var Y = 0; Y < 18; Y++)Z.arraycopy(u.sb_sample[p][1][Y], 0, u.sb_sample[p][0][Y], 0, 32);
            }
        };
    }
    return ce = Q, ce;
}
var Se, Ge;
function Ea() {
    if (Ge) return Se;
    Ge = 1;
    var w = t1(), Z = Q0, X = Z.System, z = Z.new_float, u0 = Z.new_float_n;
    function W() {
        this.l = z(w.SBMAX_l), this.s = u0([
            w.SBMAX_s,
            3
        ]);
        var Q = this;
        this.assign = function(D) {
            X.arraycopy(D.l, 0, Q.l, 0, w.SBMAX_l);
            for(var g = 0; g < w.SBMAX_s; g++)for(var f0 = 0; f0 < 3; f0++)Q.s[g][f0] = D.s[g][f0];
        };
    }
    return Se = W, Se;
}
var de, $e;
function Ga() {
    if ($e) return de;
    $e = 1;
    var w = Ea();
    function Z() {
        this.thm = new w(), this.en = new w();
    }
    return de = Z, de;
}
function R1(w) {
    var Z = w;
    this.ordinal = function() {
        return Z;
    };
}
R1.STEREO = new R1(0);
R1.JOINT_STEREO = new R1(1);
R1.DUAL_CHANNEL = new R1(2);
R1.MONO = new R1(3);
R1.NOT_SET = new R1(4);
var j1 = R1, Ae, Pe;
function t1() {
    if (Pe) return Ae;
    Pe = 1;
    var w = Q0, Z = w.System, X = w.VbrMode, z = w.new_array_n, u0 = w.new_float, W = w.new_float_n, Q = w.new_int, D = w.assert;
    g.ENCDELAY = 576, g.POSTDELAY = 1152, g.MDCTDELAY = 48, g.FFTOFFSET = 224 + g.MDCTDELAY, g.DECDELAY = 528, g.SBLIMIT = 32, g.CBANDS = 64, g.SBPSY_l = 21, g.SBPSY_s = 12, g.SBMAX_l = 22, g.SBMAX_s = 13, g.PSFB21 = 6, g.PSFB12 = 6, g.BLKSIZE = 1024, g.HBLKSIZE = g.BLKSIZE / 2 + 1, g.BLKSIZE_s = 256, g.HBLKSIZE_s = g.BLKSIZE_s / 2 + 1, g.NORM_TYPE = 0, g.START_TYPE = 1, g.SHORT_TYPE = 2, g.STOP_TYPE = 3, g.MPG_MD_LR_LR = 0, g.MPG_MD_LR_I = 1, g.MPG_MD_MS_LR = 2, g.MPG_MD_MS_I = 3, g.fircoef = [
        -0.1039435,
        -0.1892065,
        -0.0432472 * 5,
        -0.155915,
        779609e-23 * 5,
        0.0467745 * 5,
        0.50455,
        0.756825,
        0.187098 * 5
    ];
    function g() {
        var f0 = Da(), A = Ga(), m = j1, O = g.FFTOFFSET, s0 = g.MPG_MD_MS_LR, K = null;
        this.psy = null;
        var t0 = null, U = null, R = null;
        this.setModules = function(l, M, p, H) {
            K = l, this.psy = M, t0 = M, U = H, R = p;
        };
        var o = new f0();
        function u(l) {
            var M, p;
            if (l.ATH.useAdjust == 0) {
                l.ATH.adjust = 1;
                return;
            }
            if (p = l.loudness_sq[0][0], M = l.loudness_sq[1][0], l.channels_out == 2 ? (p += l.loudness_sq[0][1], M += l.loudness_sq[1][1]) : (p += p, M += M), l.mode_gr == 2 && (p = Math.max(p, M)), p *= 0.5, p *= l.ATH.aaSensitivityP, p > 0.03125) l.ATH.adjust >= 1 ? l.ATH.adjust = 1 : l.ATH.adjust < l.ATH.adjustLimit && (l.ATH.adjust = l.ATH.adjustLimit), l.ATH.adjustLimit = 1;
            else {
                var H = 31.98 * p + 625e-6;
                l.ATH.adjust >= H ? (l.ATH.adjust *= H * 0.075 + 0.925, l.ATH.adjust < H && (l.ATH.adjust = H)) : l.ATH.adjustLimit >= H ? l.ATH.adjust = H : l.ATH.adjust < l.ATH.adjustLimit && (l.ATH.adjust = l.ATH.adjustLimit), l.ATH.adjustLimit = H;
            }
        }
        function d(l) {
            var M, p;
            for(D(0 <= l.bitrate_index && l.bitrate_index < 16), D(0 <= l.mode_ext && l.mode_ext < 4), l.bitrate_stereoMode_Hist[l.bitrate_index][4]++, l.bitrate_stereoMode_Hist[15][4]++, l.channels_out == 2 && (l.bitrate_stereoMode_Hist[l.bitrate_index][l.mode_ext]++, l.bitrate_stereoMode_Hist[15][l.mode_ext]++), M = 0; M < l.mode_gr; ++M)for(p = 0; p < l.channels_out; ++p){
                var H = l.l3_side.tt[M][p].block_type | 0;
                l.l3_side.tt[M][p].mixed_block_flag != 0 && (H = 4), l.bitrate_blockType_Hist[l.bitrate_index][H]++, l.bitrate_blockType_Hist[l.bitrate_index][5]++, l.bitrate_blockType_Hist[15][H]++, l.bitrate_blockType_Hist[15][5]++;
            }
        }
        function e(l, M) {
            var p = l.internal_flags, H, B;
            if (p.lame_encode_frame_init == 0) {
                var I, v0, b = u0(2014), a = u0(2014);
                for(p.lame_encode_frame_init = 1, I = 0, v0 = 0; I < 286 + 576 * (1 + p.mode_gr); ++I)I < 576 * p.mode_gr ? (b[I] = 0, p.channels_out == 2 && (a[I] = 0)) : (b[I] = M[0][v0], p.channels_out == 2 && (a[I] = M[1][v0]), ++v0);
                for(B = 0; B < p.mode_gr; B++)for(H = 0; H < p.channels_out; H++)p.l3_side.tt[B][H].block_type = g.SHORT_TYPE;
                o.mdct_sub48(p, b, a), D(576 >= g.FFTOFFSET), D(p.mf_size >= g.BLKSIZE + l.framesize - g.FFTOFFSET), D(p.mf_size >= 512 + l.framesize - 32);
            }
        }
        this.lame_encode_mp3_frame = function(l, M, p, H, B, I) {
            var v0, b = z([
                2,
                2
            ]);
            b[0][0] = new A(), b[0][1] = new A(), b[1][0] = new A(), b[1][1] = new A();
            var a = z([
                2,
                2
            ]);
            a[0][0] = new A(), a[0][1] = new A(), a[1][0] = new A(), a[1][1] = new A();
            var S, L = [
                null,
                null
            ], V = l.internal_flags, N = W([
                2,
                4
            ]), P = [
                0.5,
                0.5
            ], E = [
                [
                    0,
                    0
                ],
                [
                    0,
                    0
                ]
            ], i = [
                [
                    0,
                    0
                ],
                [
                    0,
                    0
                ]
            ], s, r, n;
            if (L[0] = M, L[1] = p, V.lame_encode_frame_init == 0 && e(l, L), V.padding = 0, (V.slot_lag -= V.frac_SpF) < 0 && (V.slot_lag += l.out_samplerate, V.padding = 1), V.psymodel != 0) {
                var f, Y = [
                    null,
                    null
                ], J = 0, T = Q(2);
                for(n = 0; n < V.mode_gr; n++){
                    for(r = 0; r < V.channels_out; r++)Y[r] = L[r], J = 576 + n * 576 - g.FFTOFFSET;
                    if (l.VBR == X.vbr_mtrh || l.VBR == X.vbr_mt ? f = t0.L3psycho_anal_vbr(l, Y, J, n, b, a, E[n], i[n], N[n], T) : f = t0.L3psycho_anal_ns(l, Y, J, n, b, a, E[n], i[n], N[n], T), f != 0) return -4;
                    for(l.mode == m.JOINT_STEREO && (P[n] = N[n][2] + N[n][3], P[n] > 0 && (P[n] = N[n][3] / P[n])), r = 0; r < V.channels_out; r++){
                        var q = V.l3_side.tt[n][r];
                        q.block_type = T[r], q.mixed_block_flag = 0;
                    }
                }
            } else for(n = 0; n < V.mode_gr; n++)for(r = 0; r < V.channels_out; r++)V.l3_side.tt[n][r].block_type = g.NORM_TYPE, V.l3_side.tt[n][r].mixed_block_flag = 0, i[n][r] = E[n][r] = 700;
            if (u(V), o.mdct_sub48(V, L[0], L[1]), V.mode_ext = g.MPG_MD_LR_LR, l.force_ms) V.mode_ext = g.MPG_MD_MS_LR;
            else if (l.mode == m.JOINT_STEREO) {
                var i0 = 0, h0 = 0;
                for(n = 0; n < V.mode_gr; n++)for(r = 0; r < V.channels_out; r++)i0 += i[n][r], h0 += E[n][r];
                if (i0 <= 1 * h0) {
                    var d0 = V.l3_side.tt[0], M0 = V.l3_side.tt[V.mode_gr - 1];
                    d0[0].block_type == d0[1].block_type && M0[0].block_type == M0[1].block_type && (V.mode_ext = g.MPG_MD_MS_LR);
                }
            }
            if (V.mode_ext == s0 ? (S = a, s = i) : (S = b, s = E), l.analysis && V.pinfo != null) for(n = 0; n < V.mode_gr; n++)for(r = 0; r < V.channels_out; r++)V.pinfo.ms_ratio[n] = V.ms_ratio[n], V.pinfo.ms_ener_ratio[n] = P[n], V.pinfo.blocktype[n][r] = V.l3_side.tt[n][r].block_type, V.pinfo.pe[n][r] = s[n][r], Z.arraycopy(V.l3_side.tt[n][r].xr, 0, V.pinfo.xr[n][r], 0, 576), V.mode_ext == s0 && (V.pinfo.ers[n][r] = V.pinfo.ers[n][r + 2], Z.arraycopy(V.pinfo.energy[n][r + 2], 0, V.pinfo.energy[n][r], 0, V.pinfo.energy[n][r].length));
            if (l.VBR == X.vbr_off || l.VBR == X.vbr_abr) {
                var R0, A0;
                for(R0 = 0; R0 < 18; R0++)V.nsPsy.pefirbuf[R0] = V.nsPsy.pefirbuf[R0 + 1];
                for(A0 = 0, n = 0; n < V.mode_gr; n++)for(r = 0; r < V.channels_out; r++)A0 += s[n][r];
                for(V.nsPsy.pefirbuf[18] = A0, A0 = V.nsPsy.pefirbuf[9], R0 = 0; R0 < 9; R0++)A0 += (V.nsPsy.pefirbuf[R0] + V.nsPsy.pefirbuf[18 - R0]) * g.fircoef[R0];
                for(A0 = 3350 * V.mode_gr * V.channels_out / A0, n = 0; n < V.mode_gr; n++)for(r = 0; r < V.channels_out; r++)s[n][r] *= A0;
            }
            if (V.iteration_loop.iteration_loop(l, s, P, S), K.format_bitstream(l), v0 = K.copy_buffer(V, H, B, I, 1), l.bWriteVbrTag && U.addVbrFrame(l), l.analysis && V.pinfo != null) {
                for(r = 0; r < V.channels_out; r++){
                    var w0;
                    for(w0 = 0; w0 < O; w0++)V.pinfo.pcmdata[r][w0] = V.pinfo.pcmdata[r][w0 + l.framesize];
                    for(w0 = O; w0 < 1600; w0++)V.pinfo.pcmdata[r][w0] = L[r][w0 - O];
                }
                R.set_frame_pinfo(l, S);
            }
            return d(V), v0;
        };
    }
    return Ae = g, Ae;
}
var Ba = Q0, Ze = Ba.Util, Ke = Ba.new_float, J0 = t1();
function $a() {
    var w = Ke(J0.BLKSIZE), Z = Ke(J0.BLKSIZE_s / 2), X = [
        0.9238795325112867,
        0.3826834323650898,
        0.9951847266721969,
        0.0980171403295606,
        0.9996988186962042,
        0.02454122852291229,
        0.9999811752826011,
        0.006135884649154475
    ];
    function z(W, Q, D) {
        var g = 0, f0, A, m;
        D <<= 1;
        var O = Q + D;
        f0 = 4;
        do {
            var s0, K, t0, U, R, o, u;
            u = f0 >> 1, U = f0, R = f0 << 1, o = R + U, f0 = R << 1, A = Q, m = A + u;
            do {
                var d, e, l, M;
                e = W[A + 0] - W[A + U], d = W[A + 0] + W[A + U], M = W[A + R] - W[A + o], l = W[A + R] + W[A + o], W[A + R] = d - l, W[A + 0] = d + l, W[A + o] = e - M, W[A + U] = e + M, e = W[m + 0] - W[m + U], d = W[m + 0] + W[m + U], M = Ze.SQRT2 * W[m + o], l = Ze.SQRT2 * W[m + R], W[m + R] = d - l, W[m + 0] = d + l, W[m + o] = e - M, W[m + U] = e + M, m += f0, A += f0;
            }while (A < O);
            for(K = X[g + 0], s0 = X[g + 1], t0 = 1; t0 < u; t0++){
                var p, H;
                p = 1 - 2 * s0 * s0, H = 2 * s0 * K, A = Q + t0, m = Q + U - t0;
                do {
                    var B, I, v0, d, e, b, l, a, M, S;
                    I = H * W[A + U] - p * W[m + U], B = p * W[A + U] + H * W[m + U], e = W[A + 0] - B, d = W[A + 0] + B, b = W[m + 0] - I, v0 = W[m + 0] + I, I = H * W[A + o] - p * W[m + o], B = p * W[A + o] + H * W[m + o], M = W[A + R] - B, l = W[A + R] + B, S = W[m + R] - I, a = W[m + R] + I, I = s0 * l - K * S, B = K * l + s0 * S, W[A + R] = d - B, W[A + 0] = d + B, W[m + o] = b - I, W[m + U] = b + I, I = K * a - s0 * M, B = s0 * a + K * M, W[m + R] = v0 - B, W[m + 0] = v0 + B, W[A + o] = e - I, W[A + U] = e + I, m += f0, A += f0;
                }while (A < O);
                p = K, K = p * X[g + 0] - s0 * X[g + 1], s0 = p * X[g + 1] + s0 * X[g + 0];
            }
            g += 2;
        }while (f0 < D);
    }
    var u0 = [
        0,
        128,
        64,
        192,
        32,
        160,
        96,
        224,
        16,
        144,
        80,
        208,
        48,
        176,
        112,
        240,
        8,
        136,
        72,
        200,
        40,
        168,
        104,
        232,
        24,
        152,
        88,
        216,
        56,
        184,
        120,
        248,
        4,
        132,
        68,
        196,
        36,
        164,
        100,
        228,
        20,
        148,
        84,
        212,
        52,
        180,
        116,
        244,
        12,
        140,
        76,
        204,
        44,
        172,
        108,
        236,
        28,
        156,
        92,
        220,
        60,
        188,
        124,
        252,
        2,
        130,
        66,
        194,
        34,
        162,
        98,
        226,
        18,
        146,
        82,
        210,
        50,
        178,
        114,
        242,
        10,
        138,
        74,
        202,
        42,
        170,
        106,
        234,
        26,
        154,
        90,
        218,
        58,
        186,
        122,
        250,
        6,
        134,
        70,
        198,
        38,
        166,
        102,
        230,
        22,
        150,
        86,
        214,
        54,
        182,
        118,
        246,
        14,
        142,
        78,
        206,
        46,
        174,
        110,
        238,
        30,
        158,
        94,
        222,
        62,
        190,
        126,
        254
    ];
    this.fft_short = function(W, Q, D, g, f0) {
        for(var A = 0; A < 3; A++){
            var m = J0.BLKSIZE_s / 2, O = 65535 & 192 * (A + 1), s0 = J0.BLKSIZE_s / 8 - 1;
            do {
                var K, t0, U, R, o, u = u0[s0 << 2] & 255;
                K = Z[u] * g[D][f0 + u + O], o = Z[127 - u] * g[D][f0 + u + O + 128], t0 = K - o, K = K + o, U = Z[u + 64] * g[D][f0 + u + O + 64], o = Z[63 - u] * g[D][f0 + u + O + 192], R = U - o, U = U + o, m -= 4, Q[A][m + 0] = K + U, Q[A][m + 2] = K - U, Q[A][m + 1] = t0 + R, Q[A][m + 3] = t0 - R, K = Z[u + 1] * g[D][f0 + u + O + 1], o = Z[126 - u] * g[D][f0 + u + O + 129], t0 = K - o, K = K + o, U = Z[u + 65] * g[D][f0 + u + O + 65], o = Z[62 - u] * g[D][f0 + u + O + 193], R = U - o, U = U + o, Q[A][m + J0.BLKSIZE_s / 2 + 0] = K + U, Q[A][m + J0.BLKSIZE_s / 2 + 2] = K - U, Q[A][m + J0.BLKSIZE_s / 2 + 1] = t0 + R, Q[A][m + J0.BLKSIZE_s / 2 + 3] = t0 - R;
            }while (--s0 >= 0);
            z(Q[A], m, J0.BLKSIZE_s / 2);
        }
    }, this.fft_long = function(W, Q, D, g, f0) {
        var A = J0.BLKSIZE / 8 - 1, m = J0.BLKSIZE / 2;
        do {
            var O, s0, K, t0, U, R = u0[A] & 255;
            O = w[R] * g[D][f0 + R], U = w[R + 512] * g[D][f0 + R + 512], s0 = O - U, O = O + U, K = w[R + 256] * g[D][f0 + R + 256], U = w[R + 768] * g[D][f0 + R + 768], t0 = K - U, K = K + U, m -= 4, Q[m + 0] = O + K, Q[m + 2] = O - K, Q[m + 1] = s0 + t0, Q[m + 3] = s0 - t0, O = w[R + 1] * g[D][f0 + R + 1], U = w[R + 513] * g[D][f0 + R + 513], s0 = O - U, O = O + U, K = w[R + 257] * g[D][f0 + R + 257], U = w[R + 769] * g[D][f0 + R + 769], t0 = K - U, K = K + U, Q[m + J0.BLKSIZE / 2 + 0] = O + K, Q[m + J0.BLKSIZE / 2 + 2] = O - K, Q[m + J0.BLKSIZE / 2 + 1] = s0 + t0, Q[m + J0.BLKSIZE / 2 + 3] = s0 - t0;
        }while (--A >= 0);
        z(Q, m, J0.BLKSIZE / 2);
    }, this.init_fft = function(W) {
        for(var Q = 0; Q < J0.BLKSIZE; Q++)w[Q] = 0.42 - 0.5 * Math.cos(2 * Math.PI * (Q + 0.5) / J0.BLKSIZE) + 0.08 * Math.cos(4 * Math.PI * (Q + 0.5) / J0.BLKSIZE);
        for(var Q = 0; Q < J0.BLKSIZE_s / 2; Q++)Z[Q] = 0.5 * (1 - Math.cos(2 * Math.PI * (Q + 0.5) / J0.BLKSIZE_s));
    };
}
var Pa = $a, T1 = Q0, C1 = T1.VbrMode, Ue = T1.Float, F1 = T1.ShortBlock, n1 = T1.Util, Za = T1.Arrays, g0 = T1.new_float, m1 = T1.new_float_n, L1 = T1.new_int, C0 = T1.assert, Ka = Pa, r0 = t1();
function Ua() {
    var w = j1, Z = new Ka(), X = 2.302585092994046, z = 2, u0 = 16, W = 2, Q = 16, D = 0.34, g = 1 / 217621504 / (r0.BLKSIZE / 2), f0 = 0.01, A = 0.8, m = 0.6, O = 0.3, s0 = 3.5, K = 21, t0 = 0.2302585093;
    function U(v) {
        return v;
    }
    function R(v, h) {
        for(var x = 0, y = 0; y < r0.BLKSIZE / 2; ++y)x += v[y] * h.ATH.eql_w[y];
        return x *= g, x;
    }
    function o(v, h, x, y, k, c, C, G, F, e0, $) {
        var a0 = v.internal_flags;
        if (F < 2) Z.fft_long(a0, y[k], F, e0, $), Z.fft_short(a0, c[C], F, e0, $);
        else if (F == 2) {
            for(var m0 = r0.BLKSIZE - 1; m0 >= 0; --m0){
                var N0 = y[k + 0][m0], n0 = y[k + 1][m0];
                y[k + 0][m0] = (N0 + n0) * n1.SQRT2 * 0.5, y[k + 1][m0] = (N0 - n0) * n1.SQRT2 * 0.5;
            }
            for(var L0 = 2; L0 >= 0; --L0)for(var m0 = r0.BLKSIZE_s - 1; m0 >= 0; --m0){
                var N0 = c[C + 0][L0][m0], n0 = c[C + 1][L0][m0];
                c[C + 0][L0][m0] = (N0 + n0) * n1.SQRT2 * 0.5, c[C + 1][L0][m0] = (N0 - n0) * n1.SQRT2 * 0.5;
            }
        }
        h[0] = y[k + 0][0], h[0] *= h[0];
        for(var m0 = r0.BLKSIZE / 2 - 1; m0 >= 0; --m0){
            var j = y[k + 0][r0.BLKSIZE / 2 - m0], x0 = y[k + 0][r0.BLKSIZE / 2 + m0];
            h[r0.BLKSIZE / 2 - m0] = (j * j + x0 * x0) * 0.5;
        }
        for(var L0 = 2; L0 >= 0; --L0){
            x[L0][0] = c[C + 0][L0][0], x[L0][0] *= x[L0][0];
            for(var m0 = r0.BLKSIZE_s / 2 - 1; m0 >= 0; --m0){
                var j = c[C + 0][L0][r0.BLKSIZE_s / 2 - m0], x0 = c[C + 0][L0][r0.BLKSIZE_s / 2 + m0];
                x[L0][r0.BLKSIZE_s / 2 - m0] = (j * j + x0 * x0) * 0.5;
            }
        }
        for(var k0 = 0, m0 = 11; m0 < r0.HBLKSIZE; m0++)k0 += h[m0];
        a0.tot_ener[F] = k0;
        if (v.analysis) {
            for(var m0 = 0; m0 < r0.HBLKSIZE; m0++)a0.pinfo.energy[G][F][m0] = a0.pinfo.energy_save[F][m0], a0.pinfo.energy_save[F][m0] = h[m0];
            a0.pinfo.pe[G][F] = a0.pe[F];
        }
        v.athaa_loudapprox == 2 && F < 2 && (a0.loudness_sq[G][F] = a0.loudness_sq_save[F], a0.loudness_sq_save[F] = R(h, a0));
    }
    var u = 8, d = 23, e = 15, l, M, p, H = [
        1,
        0.79433,
        0.63096,
        0.63096,
        0.63096,
        0.63096,
        0.63096,
        0.25119,
        0.11749
    ];
    function B() {
        l = Math.pow(10, (u + 1) / 16), M = Math.pow(10, (d + 1) / 16), p = Math.pow(10, e / 10);
    }
    var I = [
        3.3246 * 3.3246,
        3.23837 * 3.23837,
        9.9500500969,
        9.0247369744,
        8.1854926609,
        7.0440875649,
        2.46209 * 2.46209,
        2.284 * 2.284,
        4.4892710641,
        1.96552 * 1.96552,
        1.82335 * 1.82335,
        1.69146 * 1.69146,
        2.4621061921,
        2.1508568964,
        1.37074 * 1.37074,
        1.31036 * 1.31036,
        1.5691069696,
        1.4555939904,
        1.16203 * 1.16203,
        1.2715945225,
        1.09428 * 1.09428,
        1.0659 * 1.0659,
        1.0779838276,
        1.0382591025,
        1
    ], v0 = [
        1.7782755904,
        1.35879 * 1.35879,
        1.38454 * 1.38454,
        1.39497 * 1.39497,
        1.40548 * 1.40548,
        1.3537 * 1.3537,
        1.6999465924,
        1.22321 * 1.22321,
        1.3169398564,
        1
    ], b = [
        5.5396212496,
        2.29259 * 2.29259,
        4.9868695969,
        2.12675 * 2.12675,
        2.02545 * 2.02545,
        1.87894 * 1.87894,
        1.74303 * 1.74303,
        1.61695 * 1.61695,
        2.2499700001,
        1.39148 * 1.39148,
        1.29083 * 1.29083,
        1.19746 * 1.19746,
        1.2339655056,
        1.0779838276
    ];
    function a(v, h, x, y, k, c) {
        var C;
        if (h > v) {
            if (h < v * M) C = h / v;
            else return v + h;
        } else {
            if (v >= h * M) return v + h;
            C = v / h;
        }
        if (v += h, y + 3 <= 6) {
            if (C >= l) return v;
            var G = 0 | n1.FAST_LOG10_X(C, 16);
            return v * v0[G];
        }
        var G = 0 | n1.FAST_LOG10_X(C, 16);
        if (c != 0 ? h = k.ATH.cb_s[x] * k.ATH.adjust : h = k.ATH.cb_l[x] * k.ATH.adjust, v < p * h) {
            if (v > h) {
                var F, e0;
                return F = 1, G <= 13 && (F = b[G]), e0 = n1.FAST_LOG10_X(v / h, 10 / 15), v * ((I[G] - F) * e0 + F);
            }
            return G > 13 ? v : v * b[G];
        }
        return v * I[G];
    }
    var S = [
        1.7782755904,
        1.35879 * 1.35879,
        1.38454 * 1.38454,
        1.39497 * 1.39497,
        1.40548 * 1.40548,
        1.3537 * 1.3537,
        1.6999465924,
        1.22321 * 1.22321,
        1.3169398564,
        1
    ];
    function L(v, h, x) {
        var y;
        if (v < 0 && (v = 0), h < 0 && (h = 0), v <= 0) return h;
        if (h <= 0) return v;
        if (h > v ? y = h / v : y = v / h, -2 <= x && x <= 2) {
            if (y >= l) return v + h;
            var k = 0 | n1.FAST_LOG10_X(y, 16);
            return (v + h) * S[k];
        }
        return y < M ? v + h : (v < h && (v = h), v);
    }
    function V(v, h) {
        var x = v.internal_flags;
        if (x.channels_out > 1) {
            for(var y = 0; y < r0.SBMAX_l; y++){
                var k = x.thm[0].l[y], c = x.thm[1].l[y];
                x.thm[0].l[y] += c * h, x.thm[1].l[y] += k * h;
            }
            for(var y = 0; y < r0.SBMAX_s; y++)for(var C = 0; C < 3; C++){
                var k = x.thm[0].s[y][C], c = x.thm[1].s[y][C];
                x.thm[0].s[y][C] += c * h, x.thm[1].s[y][C] += k * h;
            }
        }
    }
    function N(v) {
        for(var h = 0; h < r0.SBMAX_l; h++)if (!(v.thm[0].l[h] > 1.58 * v.thm[1].l[h] || v.thm[1].l[h] > 1.58 * v.thm[0].l[h])) {
            var x = v.mld_l[h] * v.en[3].l[h], y = Math.max(v.thm[2].l[h], Math.min(v.thm[3].l[h], x));
            x = v.mld_l[h] * v.en[2].l[h];
            var k = Math.max(v.thm[3].l[h], Math.min(v.thm[2].l[h], x));
            v.thm[2].l[h] = y, v.thm[3].l[h] = k;
        }
        for(var h = 0; h < r0.SBMAX_s; h++)for(var c = 0; c < 3; c++)if (!(v.thm[0].s[h][c] > 1.58 * v.thm[1].s[h][c] || v.thm[1].s[h][c] > 1.58 * v.thm[0].s[h][c])) {
            var x = v.mld_s[h] * v.en[3].s[h][c], y = Math.max(v.thm[2].s[h][c], Math.min(v.thm[3].s[h][c], x));
            x = v.mld_s[h] * v.en[2].s[h][c];
            var k = Math.max(v.thm[3].s[h][c], Math.min(v.thm[2].s[h][c], x));
            v.thm[2].s[h][c] = y, v.thm[3].s[h][c] = k;
        }
    }
    function P(v, h, x) {
        var y = h, k = Math.pow(10, x);
        h *= 2, y *= 2;
        for(var c = 0; c < r0.SBMAX_l; c++){
            var C, G, F, e0;
            if (e0 = v.ATH.cb_l[v.bm_l[c]] * k, C = Math.min(Math.max(v.thm[0].l[c], e0), Math.max(v.thm[1].l[c], e0)), G = Math.max(v.thm[2].l[c], e0), F = Math.max(v.thm[3].l[c], e0), C * h < G + F) {
                var $ = C * y / (G + F);
                G *= $, F *= $;
            }
            v.thm[2].l[c] = Math.min(G, v.thm[2].l[c]), v.thm[3].l[c] = Math.min(F, v.thm[3].l[c]);
        }
        k *= r0.BLKSIZE_s / r0.BLKSIZE;
        for(var c = 0; c < r0.SBMAX_s; c++)for(var a0 = 0; a0 < 3; a0++){
            var C, G, F, e0;
            if (e0 = v.ATH.cb_s[v.bm_s[c]] * k, C = Math.min(Math.max(v.thm[0].s[c][a0], e0), Math.max(v.thm[1].s[c][a0], e0)), G = Math.max(v.thm[2].s[c][a0], e0), F = Math.max(v.thm[3].s[c][a0], e0), C * h < G + F) {
                var $ = C * h / (G + F);
                G *= $, F *= $;
            }
            v.thm[2].s[c][a0] = Math.min(v.thm[2].s[c][a0], G), v.thm[3].s[c][a0] = Math.min(v.thm[3].s[c][a0], F);
        }
    }
    function E(v, h, x, y, k) {
        var c, C, G = 0, F = 0;
        for(c = C = 0; c < r0.SBMAX_s; ++C, ++c){
            for(var e0 = v.bo_s[c], $ = v.npart_s, a0 = e0 < $ ? e0 : $; C < a0;)C0(h[C] >= 0), C0(x[C] >= 0), G += h[C], F += x[C], C++;
            if (v.en[y].s[c][k] = G, v.thm[y].s[c][k] = F, C >= $) {
                ++c;
                break;
            }
            C0(h[C] >= 0), C0(x[C] >= 0);
            var m0 = v.PSY.bo_s_weight[c], N0 = 1 - m0;
            G = m0 * h[C], F = m0 * x[C], v.en[y].s[c][k] += G, v.thm[y].s[c][k] += F, G = N0 * h[C], F = N0 * x[C];
        }
        for(; c < r0.SBMAX_s; ++c)v.en[y].s[c][k] = 0, v.thm[y].s[c][k] = 0;
    }
    function i(v, h, x, y) {
        var k, c, C = 0, G = 0;
        for(k = c = 0; k < r0.SBMAX_l; ++c, ++k){
            for(var F = v.bo_l[k], e0 = v.npart_l, $ = F < e0 ? F : e0; c < $;)C0(h[c] >= 0), C0(x[c] >= 0), C += h[c], G += x[c], c++;
            if (v.en[y].l[k] = C, v.thm[y].l[k] = G, c >= e0) {
                ++k;
                break;
            }
            C0(h[c] >= 0), C0(x[c] >= 0);
            var a0 = v.PSY.bo_l_weight[k], m0 = 1 - a0;
            C = a0 * h[c], G = a0 * x[c], v.en[y].l[k] += C, v.thm[y].l[k] += G, C = m0 * h[c], G = m0 * x[c];
        }
        for(; k < r0.SBMAX_l; ++k)v.en[y].l[k] = 0, v.thm[y].l[k] = 0;
    }
    function s(v, h, x, y, k, c) {
        var C = v.internal_flags, G, F;
        for(F = G = 0; F < C.npart_s; ++F){
            for(var e0 = 0, $ = C.numlines_s[F], a0 = 0; a0 < $; ++a0, ++G){
                var m0 = h[c][G];
                e0 += m0;
            }
            x[F] = e0;
        }
        for(C0(F == C.npart_s), G = F = 0; F < C.npart_s; F++){
            var N0 = C.s3ind_s[F][0], n0 = C.s3_ss[G++] * x[N0];
            for(++N0; N0 <= C.s3ind_s[F][1];)n0 += C.s3_ss[G] * x[N0], ++G, ++N0;
            var L0 = W * C.nb_s1[k][F];
            y[F] = Math.min(n0, L0);
            if (C.blocktype_old[k & 1] == r0.SHORT_TYPE) {
                var L0 = Q * C.nb_s2[k][F], j = y[F];
                y[F] = Math.min(L0, j);
            }
            C.nb_s2[k][F] = C.nb_s1[k][F], C.nb_s1[k][F] = n0, C0(y[F] >= 0);
        }
        for(; F <= r0.CBANDS; ++F)x[F] = 0, y[F] = 0;
    }
    function r(v, h, x, y) {
        var k = v.internal_flags;
        v.short_blocks == F1.short_block_coupled && !(h[0] != 0 && h[1] != 0) && (h[0] = h[1] = 0);
        for(var c = 0; c < k.channels_out; c++)y[c] = r0.NORM_TYPE, v.short_blocks == F1.short_block_dispensed && (h[c] = 1), v.short_blocks == F1.short_block_forced && (h[c] = 0), h[c] != 0 ? (C0(k.blocktype_old[c] != r0.START_TYPE), k.blocktype_old[c] == r0.SHORT_TYPE && (y[c] = r0.STOP_TYPE)) : (y[c] = r0.SHORT_TYPE, k.blocktype_old[c] == r0.NORM_TYPE && (k.blocktype_old[c] = r0.START_TYPE), k.blocktype_old[c] == r0.STOP_TYPE && (k.blocktype_old[c] = r0.SHORT_TYPE)), x[c] = k.blocktype_old[c], k.blocktype_old[c] = y[c];
    }
    function n(v, h, x) {
        return x >= 1 ? v : x <= 0 ? h : h > 0 ? Math.pow(v / h, x) * h : 0;
    }
    var f = [
        11.8,
        13.6,
        17.2,
        32,
        46.5,
        51.3,
        57.5,
        67.1,
        71.5,
        84.6,
        97.6,
        130
    ];
    function Y(v, h) {
        for(var x = 309.07, y = 0; y < r0.SBMAX_s - 1; y++)for(var k = 0; k < 3; k++){
            var c = v.thm.s[y][k];
            if (c > 0) {
                var C = c * h, G = v.en.s[y][k];
                G > C && (G > C * 1e10 ? x += f[y] * (10 * X) : x += f[y] * n1.FAST_LOG10(G / C));
            }
        }
        return x;
    }
    var J = [
        6.8,
        5.8,
        5.8,
        6.4,
        6.5,
        9.9,
        12.1,
        14.4,
        15,
        18.9,
        21.6,
        26.9,
        34.2,
        40.2,
        46.8,
        56.5,
        60.7,
        73.9,
        85.7,
        93.4,
        126.1
    ];
    function T(v, h) {
        for(var x = 281.0575, y = 0; y < r0.SBMAX_l - 1; y++){
            var k = v.thm.l[y];
            if (k > 0) {
                var c = k * h, C = v.en.l[y];
                C > c && (C > c * 1e10 ? x += J[y] * (10 * X) : x += J[y] * n1.FAST_LOG10(C / c));
            }
        }
        return x;
    }
    function q(v, h, x, y, k) {
        var c, C;
        for(c = C = 0; c < v.npart_l; ++c){
            var G = 0, F = 0, e0;
            for(e0 = 0; e0 < v.numlines_l[c]; ++e0, ++C){
                var $ = h[C];
                G += $, F < $ && (F = $);
            }
            x[c] = G, y[c] = F, k[c] = G * v.rnumlines_l[c], C0(v.rnumlines_l[c] >= 0), C0(x[c] >= 0), C0(y[c] >= 0), C0(k[c] >= 0);
        }
    }
    function i0(v, h, x, y) {
        var k = H.length - 1, c = 0, C = x[c] + x[c + 1];
        if (C > 0) {
            var G = h[c];
            G < h[c + 1] && (G = h[c + 1]), C0(v.numlines_l[c] + v.numlines_l[c + 1] - 1 > 0), C = 20 * (G * 2 - C) / (C * (v.numlines_l[c] + v.numlines_l[c + 1] - 1));
            var F = 0 | C;
            F > k && (F = k), y[c] = F;
        } else y[c] = 0;
        for(c = 1; c < v.npart_l - 1; c++)if (C = x[c - 1] + x[c] + x[c + 1], C > 0) {
            var G = h[c - 1];
            G < h[c] && (G = h[c]), G < h[c + 1] && (G = h[c + 1]), C0(v.numlines_l[c - 1] + v.numlines_l[c] + v.numlines_l[c + 1] - 1 > 0), C = 20 * (G * 3 - C) / (C * (v.numlines_l[c - 1] + v.numlines_l[c] + v.numlines_l[c + 1] - 1));
            var F = 0 | C;
            F > k && (F = k), y[c] = F;
        } else y[c] = 0;
        if (C0(c == v.npart_l - 1), C = x[c - 1] + x[c], C > 0) {
            var G = h[c - 1];
            G < h[c] && (G = h[c]), C0(v.numlines_l[c - 1] + v.numlines_l[c] - 1 > 0), C = 20 * (G * 2 - C) / (C * (v.numlines_l[c - 1] + v.numlines_l[c] - 1));
            var F = 0 | C;
            F > k && (F = k), y[c] = F;
        } else y[c] = 0;
        C0(c == v.npart_l - 1);
    }
    var h0 = [
        -0.00000000000000000865163 * 2,
        -0.01703172,
        -0.00000000000000000674764 * 2,
        0.0418072,
        -0.0000000000000000336639 * 2,
        -0.0876324,
        -0.0000000000000000154175 * 2,
        0.1863476,
        -0.0000000000000000552212 * 2,
        -0.627638
    ];
    this.L3psycho_anal_ns = function(v, h, x, y, k, c, C, G, F, e0) {
        var $ = v.internal_flags, a0 = m1([
            2,
            r0.BLKSIZE
        ]), m0 = m1([
            2,
            3,
            r0.BLKSIZE_s
        ]), N0 = g0(r0.CBANDS + 1), n0 = g0(r0.CBANDS + 1), L0 = g0(r0.CBANDS + 2), j = L1(2), x0 = L1(2), k0, _0, B0, l0, p0, P0, c0, O0, X0 = m1([
            2,
            576
        ]), Z0, v1 = L1(r0.CBANDS + 2), z0 = L1(r0.CBANDS + 2);
        for(Za.fill(z0, 0), k0 = $.channels_out, v.mode == w.JOINT_STEREO && (k0 = 4), v.VBR == C1.vbr_off ? Z0 = $.ResvMax == 0 ? 0 : $.ResvSize / $.ResvMax * 0.5 : v.VBR == C1.vbr_rh || v.VBR == C1.vbr_mtrh || v.VBR == C1.vbr_mt ? Z0 = 0.6 : Z0 = 1, _0 = 0; _0 < $.channels_out; _0++){
            var K0 = h[_0], s1 = x + 576 - 350 - K + 192;
            for(l0 = 0; l0 < 576; l0++){
                var o1, h1;
                for(o1 = K0[s1 + l0 + 10], h1 = 0, p0 = 0; p0 < (K - 1) / 2 - 1; p0 += 2)o1 += h0[p0] * (K0[s1 + l0 + p0] + K0[s1 + l0 + K - p0]), h1 += h0[p0 + 1] * (K0[s1 + l0 + p0 + 1] + K0[s1 + l0 + K - p0 - 1]);
                X0[_0][l0] = o1 + h1;
            }
            k[y][_0].en.assign($.en[_0]), k[y][_0].thm.assign($.thm[_0]), k0 > 2 && (c[y][_0].en.assign($.en[_0 + 2]), c[y][_0].thm.assign($.thm[_0 + 2]));
        }
        for(_0 = 0; _0 < k0; _0++){
            var c1, S1, r1 = g0(12), x1 = [
                0,
                0,
                0,
                0
            ], O1 = g0(12), le = 1, Ce, Fe = g0(r0.CBANDS), ke = g0(r0.CBANDS), U0 = [
                0,
                0,
                0,
                0
            ], Xe = g0(r0.HBLKSIZE), Ye = m1([
                3,
                r0.HBLKSIZE_s
            ]);
            for(C0($.npart_s <= r0.CBANDS), C0($.npart_l <= r0.CBANDS), l0 = 0; l0 < 3; l0++)r1[l0] = $.nsPsy.last_en_subshort[_0][l0 + 6], C0($.nsPsy.last_en_subshort[_0][l0 + 4] > 0), O1[l0] = r1[l0] / $.nsPsy.last_en_subshort[_0][l0 + 4], x1[0] += r1[l0];
            if (_0 == 2) for(l0 = 0; l0 < 576; l0++){
                var ve, oe;
                ve = X0[0][l0], oe = X0[1][l0], X0[0][l0] = ve + oe, X0[1][l0] = ve - oe;
            }
            var qe = X0[_0 & 1], G1 = 0;
            for(l0 = 0; l0 < 9; l0++){
                for(var ka = G1 + 64, a1 = 1; G1 < ka; G1++)a1 < Math.abs(qe[G1]) && (a1 = Math.abs(qe[G1]));
                $.nsPsy.last_en_subshort[_0][l0] = r1[l0 + 3] = a1, x1[1 + l0 / 3] += a1, a1 > r1[l0 + 3 - 2] ? (C0(r1[l0 + 3 - 2] > 0), a1 = a1 / r1[l0 + 3 - 2]) : r1[l0 + 3 - 2] > a1 * 10 ? a1 = r1[l0 + 3 - 2] / (a1 * 10) : a1 = 0, O1[l0 + 3] = a1;
            }
            if (v.analysis) {
                var he = O1[0];
                for(l0 = 1; l0 < 12; l0++)he < O1[l0] && (he = O1[l0]);
                $.pinfo.ers[y][_0] = $.pinfo.ers_save[_0], $.pinfo.ers_save[_0] = he;
            }
            for(Ce = _0 == 3 ? $.nsPsy.attackthre_s : $.nsPsy.attackthre, l0 = 0; l0 < 12; l0++)U0[l0 / 3] == 0 && O1[l0] > Ce && (U0[l0 / 3] = l0 % 3 + 1);
            for(l0 = 1; l0 < 4; l0++){
                var ue;
                x1[l0 - 1] > x1[l0] ? (C0(x1[l0] > 0), ue = x1[l0 - 1] / x1[l0]) : (C0(x1[l0 - 1] > 0), ue = x1[l0] / x1[l0 - 1]), ue < 1.7 && (U0[l0] = 0, l0 == 1 && (U0[0] = 0));
            }
            for(U0[0] != 0 && $.nsPsy.lastAttacks[_0] != 0 && (U0[0] = 0), ($.nsPsy.lastAttacks[_0] == 3 || U0[0] + U0[1] + U0[2] + U0[3] != 0) && (le = 0, U0[1] != 0 && U0[0] != 0 && (U0[1] = 0), U0[2] != 0 && U0[1] != 0 && (U0[2] = 0), U0[3] != 0 && U0[2] != 0 && (U0[3] = 0)), _0 < 2 ? x0[_0] = le : le == 0 && (x0[0] = x0[1] = 0), F[_0] = $.tot_ener[_0], S1 = m0, c1 = a0, o(v, Xe, Ye, c1, _0 & 1, S1, _0 & 1, y, _0, h, x), q($, Xe, N0, Fe, ke), i0($, Fe, ke, v1), O0 = 0; O0 < 3; O0++){
                var fe, i1;
                for(s(v, Ye, n0, L0, _0, O0), E($, n0, L0, _0, O0), c0 = 0; c0 < r0.SBMAX_s; c0++){
                    if (i1 = $.thm[_0].s[c0][O0], i1 *= A, U0[O0] >= 2 || U0[O0 + 1] == 1) {
                        var $1 = O0 != 0 ? O0 - 1 : 2, a1 = n($.thm[_0].s[c0][$1], i1, m * Z0);
                        i1 = Math.min(i1, a1);
                    }
                    if (U0[O0] == 1) {
                        var $1 = O0 != 0 ? O0 - 1 : 2, a1 = n($.thm[_0].s[c0][$1], i1, O * Z0);
                        i1 = Math.min(i1, a1);
                    } else if (O0 != 0 && U0[O0 - 1] == 3 || O0 == 0 && $.nsPsy.lastAttacks[_0] == 3) {
                        var $1 = O0 != 2 ? O0 + 1 : 0, a1 = n($.thm[_0].s[c0][$1], i1, O * Z0);
                        i1 = Math.min(i1, a1);
                    }
                    fe = r1[O0 * 3 + 3] + r1[O0 * 3 + 4] + r1[O0 * 3 + 5], r1[O0 * 3 + 5] * 6 < fe && (i1 *= 0.5, r1[O0 * 3 + 4] * 6 < fe && (i1 *= 0.5)), $.thm[_0].s[c0][O0] = i1;
                }
            }
            for($.nsPsy.lastAttacks[_0] = U0[2], P0 = 0, B0 = 0; B0 < $.npart_l; B0++){
                for(var w1 = $.s3ind[B0][0], me = N0[w1] * H[v1[w1]], I1 = $.s3_ll[P0++] * me; ++w1 <= $.s3ind[B0][1];)me = N0[w1] * H[v1[w1]], I1 = a(I1, $.s3_ll[P0++] * me, w1, w1 - B0, $, 0);
                I1 *= 0.158489319246111, $.blocktype_old[_0 & 1] == r0.SHORT_TYPE ? L0[B0] = I1 : L0[B0] = n(Math.min(I1, Math.min(z * $.nb_1[_0][B0], u0 * $.nb_2[_0][B0])), I1, Z0), $.nb_2[_0][B0] = $.nb_1[_0][B0], $.nb_1[_0][B0] = I1;
            }
            for(; B0 <= r0.CBANDS; ++B0)N0[B0] = 0, L0[B0] = 0;
            i($, N0, L0, _0);
        }
        if ((v.mode == w.STEREO || v.mode == w.JOINT_STEREO) && v.interChRatio > 0 && V(v, v.interChRatio), v.mode == w.JOINT_STEREO) {
            var be;
            N($), be = v.msfix, Math.abs(be) > 0 && P($, be, v.ATHlower * $.ATH.adjust);
        }
        for(r(v, x0, e0, j), _0 = 0; _0 < k0; _0++){
            var P1, Z1 = 0, z1, J1;
            _0 > 1 ? (P1 = G, Z1 = -2, z1 = r0.NORM_TYPE, (e0[0] == r0.SHORT_TYPE || e0[1] == r0.SHORT_TYPE) && (z1 = r0.SHORT_TYPE), J1 = c[y][_0 - 2]) : (P1 = C, Z1 = 0, z1 = e0[_0], J1 = k[y][_0]), z1 == r0.SHORT_TYPE ? P1[Z1 + _0] = Y(J1, $.masking_lower) : P1[Z1 + _0] = T(J1, $.masking_lower), v.analysis && ($.pinfo.pe[y][_0] = P1[Z1 + _0]);
        }
        return 0;
    };
    function d0(v, h, x, y, k, c, C, G) {
        var F = v.internal_flags;
        if (y < 2) Z.fft_long(F, C[G], y, h, x);
        else if (y == 2) for(var e0 = r0.BLKSIZE - 1; e0 >= 0; --e0){
            var $ = C[G + 0][e0], a0 = C[G + 1][e0];
            C[G + 0][e0] = ($ + a0) * n1.SQRT2 * 0.5, C[G + 1][e0] = ($ - a0) * n1.SQRT2 * 0.5;
        }
        c[0] = C[G + 0][0], c[0] *= c[0];
        for(var e0 = r0.BLKSIZE / 2 - 1; e0 >= 0; --e0){
            var m0 = C[G + 0][r0.BLKSIZE / 2 - e0], N0 = C[G + 0][r0.BLKSIZE / 2 + e0];
            c[r0.BLKSIZE / 2 - e0] = (m0 * m0 + N0 * N0) * 0.5;
        }
        for(var n0 = 0, e0 = 11; e0 < r0.HBLKSIZE; e0++)n0 += c[e0];
        F.tot_ener[y] = n0;
        if (v.analysis) {
            for(var e0 = 0; e0 < r0.HBLKSIZE; e0++)F.pinfo.energy[k][y][e0] = F.pinfo.energy_save[y][e0], F.pinfo.energy_save[y][e0] = c[e0];
            F.pinfo.pe[k][y] = F.pe[y];
        }
    }
    function M0(v, h, x, y, k, c, C, G) {
        var F = v.internal_flags;
        if (k == 0 && y < 2 && Z.fft_short(F, C[G], y, h, x), y == 2) for(var e0 = r0.BLKSIZE_s - 1; e0 >= 0; --e0){
            var $ = C[G + 0][k][e0], a0 = C[G + 1][k][e0];
            C[G + 0][k][e0] = ($ + a0) * n1.SQRT2 * 0.5, C[G + 1][k][e0] = ($ - a0) * n1.SQRT2 * 0.5;
        }
        c[k][0] = C[G + 0][k][0], c[k][0] *= c[k][0];
        for(var e0 = r0.BLKSIZE_s / 2 - 1; e0 >= 0; --e0){
            var m0 = C[G + 0][k][r0.BLKSIZE_s / 2 - e0], N0 = C[G + 0][k][r0.BLKSIZE_s / 2 + e0];
            c[k][r0.BLKSIZE_s / 2 - e0] = (m0 * m0 + N0 * N0) * 0.5;
        }
    }
    function R0(v, h, x, y) {
        var k = v.internal_flags;
        v.athaa_loudapprox == 2 && x < 2 && (k.loudness_sq[h][x] = k.loudness_sq_save[x], k.loudness_sq_save[x] = R(y, k));
    }
    var A0 = [
        -0.00000000000000000865163 * 2,
        -0.01703172,
        -0.00000000000000000674764 * 2,
        0.0418072,
        -0.0000000000000000336639 * 2,
        -0.0876324,
        -0.0000000000000000154175 * 2,
        0.1863476,
        -0.0000000000000000552212 * 2,
        -0.627638
    ];
    function w0(v, h, x, y, k, c, C, G, F, e0) {
        for(var $ = m1([
            2,
            576
        ]), a0 = v.internal_flags, m0 = a0.channels_out, N0 = v.mode == w.JOINT_STEREO ? 4 : m0, n0 = 0; n0 < m0; n0++){
            firbuf = h[n0];
            for(var L0 = x + 576 - 350 - K + 192, j = 0; j < 576; j++){
                var x0, k0;
                x0 = firbuf[L0 + j + 10], k0 = 0;
                for(var _0 = 0; _0 < (K - 1) / 2 - 1; _0 += 2)x0 += A0[_0] * (firbuf[L0 + j + _0] + firbuf[L0 + j + K - _0]), k0 += A0[_0 + 1] * (firbuf[L0 + j + _0 + 1] + firbuf[L0 + j + K - _0 - 1]);
                $[n0][j] = x0 + k0;
            }
            k[y][n0].en.assign(a0.en[n0]), k[y][n0].thm.assign(a0.thm[n0]), N0 > 2 && (c[y][n0].en.assign(a0.en[n0 + 2]), c[y][n0].thm.assign(a0.thm[n0 + 2]));
        }
        for(var n0 = 0; n0 < N0; n0++){
            var B0 = g0(12), l0 = g0(12), p0 = [
                0,
                0,
                0,
                0
            ], P0 = $[n0 & 1], c0 = 0, O0 = n0 == 3 ? a0.nsPsy.attackthre_s : a0.nsPsy.attackthre, X0 = 1;
            if (n0 == 2) for(var j = 0, _0 = 576; _0 > 0; ++j, --_0){
                var Z0 = $[0][j], v1 = $[1][j];
                $[0][j] = Z0 + v1, $[1][j] = Z0 - v1;
            }
            for(var j = 0; j < 3; j++)l0[j] = a0.nsPsy.last_en_subshort[n0][j + 6], C0(a0.nsPsy.last_en_subshort[n0][j + 4] > 0), B0[j] = l0[j] / a0.nsPsy.last_en_subshort[n0][j + 4], p0[0] += l0[j];
            for(var j = 0; j < 9; j++){
                for(var z0 = c0 + 64, K0 = 1; c0 < z0; c0++)K0 < Math.abs(P0[c0]) && (K0 = Math.abs(P0[c0]));
                a0.nsPsy.last_en_subshort[n0][j] = l0[j + 3] = K0, p0[1 + j / 3] += K0, K0 > l0[j + 3 - 2] ? (C0(l0[j + 3 - 2] > 0), K0 = K0 / l0[j + 3 - 2]) : l0[j + 3 - 2] > K0 * 10 ? K0 = l0[j + 3 - 2] / (K0 * 10) : K0 = 0, B0[j + 3] = K0;
            }
            for(var j = 0; j < 3; ++j){
                var s1 = l0[j * 3 + 3] + l0[j * 3 + 4] + l0[j * 3 + 5], o1 = 1;
                l0[j * 3 + 5] * 6 < s1 && (o1 *= 0.5, l0[j * 3 + 4] * 6 < s1 && (o1 *= 0.5)), G[n0][j] = o1;
            }
            if (v.analysis) {
                for(var h1 = B0[0], j = 1; j < 12; j++)h1 < B0[j] && (h1 = B0[j]);
                a0.pinfo.ers[y][n0] = a0.pinfo.ers_save[n0], a0.pinfo.ers_save[n0] = h1;
            }
            for(var j = 0; j < 12; j++)F[n0][j / 3] == 0 && B0[j] > O0 && (F[n0][j / 3] = j % 3 + 1);
            for(var j = 1; j < 4; j++){
                var c1 = p0[j - 1], S1 = p0[j], r1 = Math.max(c1, S1);
                r1 < 4e4 && c1 < 1.7 * S1 && S1 < 1.7 * c1 && (j == 1 && F[n0][0] <= F[n0][j] && (F[n0][0] = 0), F[n0][j] = 0);
            }
            F[n0][0] <= a0.nsPsy.lastAttacks[n0] && (F[n0][0] = 0), (a0.nsPsy.lastAttacks[n0] == 3 || F[n0][0] + F[n0][1] + F[n0][2] + F[n0][3] != 0) && (X0 = 0, F[n0][1] != 0 && F[n0][0] != 0 && (F[n0][1] = 0), F[n0][2] != 0 && F[n0][1] != 0 && (F[n0][2] = 0), F[n0][3] != 0 && F[n0][2] != 0 && (F[n0][3] = 0)), n0 < 2 ? e0[n0] = X0 : X0 == 0 && (e0[0] = e0[1] = 0), C[n0] = a0.tot_ener[n0];
        }
    }
    function $0(v, h, x) {
        if (x == 0) for(var y = 0; y < v.npart_s; y++)v.nb_s2[h][y] = v.nb_s1[h][y], v.nb_s1[h][y] = 0;
    }
    function f1(v, h) {
        for(var x = 0; x < v.npart_l; x++)v.nb_2[h][x] = v.nb_1[h][x], v.nb_1[h][x] = 0;
    }
    function t(v, h, x, y) {
        var k = H.length - 1, c = 0, C = x[c] + x[c + 1];
        if (C > 0) {
            var G = h[c];
            G < h[c + 1] && (G = h[c + 1]), C0(v.numlines_s[c] + v.numlines_s[c + 1] - 1 > 0), C = 20 * (G * 2 - C) / (C * (v.numlines_s[c] + v.numlines_s[c + 1] - 1));
            var F = 0 | C;
            F > k && (F = k), y[c] = F;
        } else y[c] = 0;
        for(c = 1; c < v.npart_s - 1; c++)if (C = x[c - 1] + x[c] + x[c + 1], C0(c + 1 < v.npart_s), C > 0) {
            var G = h[c - 1];
            G < h[c] && (G = h[c]), G < h[c + 1] && (G = h[c + 1]), C0(v.numlines_s[c - 1] + v.numlines_s[c] + v.numlines_s[c + 1] - 1 > 0), C = 20 * (G * 3 - C) / (C * (v.numlines_s[c - 1] + v.numlines_s[c] + v.numlines_s[c + 1] - 1));
            var F = 0 | C;
            F > k && (F = k), y[c] = F;
        } else y[c] = 0;
        if (C0(c == v.npart_s - 1), C = x[c - 1] + x[c], C > 0) {
            var G = h[c - 1];
            G < h[c] && (G = h[c]), C0(v.numlines_s[c - 1] + v.numlines_s[c] - 1 > 0), C = 20 * (G * 2 - C) / (C * (v.numlines_s[c - 1] + v.numlines_s[c] - 1));
            var F = 0 | C;
            F > k && (F = k), y[c] = F;
        } else y[c] = 0;
        C0(c == v.npart_s - 1);
    }
    function _(v, h, x, y, k, c) {
        var C = v.internal_flags, G = new float[r0.CBANDS](), F = g0(r0.CBANDS), e0, $, a0, m0 = new int[r0.CBANDS]();
        for(a0 = $ = 0; a0 < C.npart_s; ++a0){
            var N0 = 0, n0 = 0, L0 = C.numlines_s[a0];
            for(e0 = 0; e0 < L0; ++e0, ++$){
                var j = h[c][$];
                N0 += j, n0 < j && (n0 = j);
            }
            x[a0] = N0, G[a0] = n0, F[a0] = N0 / L0, C0(F[a0] >= 0);
        }
        for(C0(a0 == C.npart_s); a0 < r0.CBANDS; ++a0)G[a0] = 0, F[a0] = 0;
        for(t(C, G, F, m0), $ = a0 = 0; a0 < C.npart_s; a0++){
            var x0 = C.s3ind_s[a0][0], k0 = C.s3ind_s[a0][1], _0, B0, l0, p0, P0;
            for(_0 = m0[x0], B0 = 1, p0 = C.s3_ss[$] * x[x0] * H[m0[x0]], ++$, ++x0; x0 <= k0;)_0 += m0[x0], B0 += 1, l0 = C.s3_ss[$] * x[x0] * H[m0[x0]], p0 = L(p0, l0, x0 - a0), ++$, ++x0;
            _0 = (1 + 2 * _0) / (2 * B0), P0 = H[_0] * 0.5, p0 *= P0, y[a0] = p0, C.nb_s2[k][a0] = C.nb_s1[k][a0], C.nb_s1[k][a0] = p0, l0 = G[a0], l0 *= C.minval_s[a0], l0 *= P0, y[a0] > l0 && (y[a0] = l0), C.masking_lower > 1 && (y[a0] *= C.masking_lower), y[a0] > x[a0] && (y[a0] = x[a0]), C.masking_lower < 1 && (y[a0] *= C.masking_lower), C0(y[a0] >= 0);
        }
        for(; a0 < r0.CBANDS; ++a0)x[a0] = 0, y[a0] = 0;
    }
    function S0(v, h, x, y, k) {
        var c = g0(r0.CBANDS), C = g0(r0.CBANDS), G = L1(r0.CBANDS + 2), F;
        q(v, h, x, c, C), i0(v, c, C, G);
        var e0 = 0;
        for(F = 0; F < v.npart_l; F++){
            var $, a0, m0, N0, n0 = v.s3ind[F][0], L0 = v.s3ind[F][1], j = 0, x0 = 0;
            for(j = G[n0], x0 += 1, a0 = v.s3_ll[e0] * x[n0] * H[G[n0]], ++e0, ++n0; n0 <= L0;)j += G[n0], x0 += 1, $ = v.s3_ll[e0] * x[n0] * H[G[n0]], N0 = L(a0, $, n0 - F), a0 = N0, ++e0, ++n0;
            if (j = (1 + 2 * j) / (2 * x0), m0 = H[j] * 0.5, a0 *= m0, v.blocktype_old[k & 1] == r0.SHORT_TYPE) {
                var k0 = z * v.nb_1[k][F];
                k0 > 0 ? y[F] = Math.min(a0, k0) : y[F] = Math.min(a0, x[F] * O);
            } else {
                var _0 = u0 * v.nb_2[k][F], B0 = z * v.nb_1[k][F], k0;
                _0 <= 0 && (_0 = a0), B0 <= 0 && (B0 = a0), v.blocktype_old[k & 1] == r0.NORM_TYPE ? k0 = Math.min(B0, _0) : k0 = B0, y[F] = Math.min(a0, k0);
            }
            v.nb_2[k][F] = v.nb_1[k][F], v.nb_1[k][F] = a0, $ = c[F], $ *= v.minval_l[F], $ *= m0, y[F] > $ && (y[F] = $), v.masking_lower > 1 && (y[F] *= v.masking_lower), y[F] > x[F] && (y[F] = x[F]), v.masking_lower < 1 && (y[F] *= v.masking_lower), C0(y[F] >= 0);
        }
        for(; F < r0.CBANDS; ++F)x[F] = 0, y[F] = 0;
    }
    function E0(v, h) {
        var x = v.internal_flags;
        v.short_blocks == F1.short_block_coupled && !(h[0] != 0 && h[1] != 0) && (h[0] = h[1] = 0);
        for(var y = 0; y < x.channels_out; y++)v.short_blocks == F1.short_block_dispensed && (h[y] = 1), v.short_blocks == F1.short_block_forced && (h[y] = 0);
    }
    function V0(v, h, x) {
        for(var y = v.internal_flags, k = 0; k < y.channels_out; k++){
            var c = r0.NORM_TYPE;
            h[k] != 0 ? (C0(y.blocktype_old[k] != r0.START_TYPE), y.blocktype_old[k] == r0.SHORT_TYPE && (c = r0.STOP_TYPE)) : (c = r0.SHORT_TYPE, y.blocktype_old[k] == r0.NORM_TYPE && (y.blocktype_old[k] = r0.START_TYPE), y.blocktype_old[k] == r0.STOP_TYPE && (y.blocktype_old[k] = r0.SHORT_TYPE)), x[k] = y.blocktype_old[k], y.blocktype_old[k] = c;
        }
    }
    function H0(v, h, x, y, k, c, C) {
        for(var G = c * 2, F = c > 0 ? Math.pow(10, k) : 1, e0, $, a0 = 0; a0 < C; ++a0){
            var m0 = v[2][a0], N0 = v[3][a0], n0 = h[0][a0], L0 = h[1][a0], j = h[2][a0], x0 = h[3][a0];
            if (n0 <= 1.58 * L0 && L0 <= 1.58 * n0) {
                var k0 = x[a0] * N0, _0 = x[a0] * m0;
                $ = Math.max(j, Math.min(x0, k0)), e0 = Math.max(x0, Math.min(j, _0));
            } else $ = j, e0 = x0;
            if (c > 0) {
                var B0, l0, p0 = y[a0] * F;
                if (B0 = Math.min(Math.max(n0, p0), Math.max(L0, p0)), j = Math.max($, p0), x0 = Math.max(e0, p0), l0 = j + x0, l0 > 0 && B0 * G < l0) {
                    var P0 = B0 * G / l0;
                    j *= P0, x0 *= P0;
                }
                $ = Math.min(j, $), e0 = Math.min(x0, e0);
            }
            $ > m0 && ($ = m0), e0 > N0 && (e0 = N0), h[2][a0] = $, h[3][a0] = e0;
        }
    }
    this.L3psycho_anal_vbr = function(v, h, x, y, k, c, C, G, F, e0) {
        var $ = v.internal_flags, a0, m0, N0 = g0(r0.HBLKSIZE), n0 = m1([
            3,
            r0.HBLKSIZE_s
        ]), L0 = m1([
            2,
            r0.BLKSIZE
        ]), j = m1([
            2,
            3,
            r0.BLKSIZE_s
        ]), x0 = m1([
            4,
            r0.CBANDS
        ]), k0 = m1([
            4,
            r0.CBANDS
        ]), _0 = m1([
            4,
            3
        ]), B0 = 0.6, l0 = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ], p0 = L1(2), P0 = v.mode == w.JOINT_STEREO ? 4 : $.channels_out;
        w0(v, h, x, y, k, c, F, _0, l0, p0), E0(v, p0);
        for(var c0 = 0; c0 < P0; c0++){
            var O0 = c0 & 1;
            a0 = L0, d0(v, h, x, c0, y, N0, a0, O0), R0(v, y, c0, N0), p0[O0] != 0 ? S0($, N0, x0[c0], k0[c0], c0) : f1($, c0);
        }
        p0[0] + p0[1] == 2 && v.mode == w.JOINT_STEREO && H0(x0, k0, $.mld_cb_l, $.ATH.cb_l, v.ATHlower * $.ATH.adjust, v.msfix, $.npart_l);
        for(var c0 = 0; c0 < P0; c0++){
            var O0 = c0 & 1;
            p0[O0] != 0 && i($, x0[c0], k0[c0], c0);
        }
        for(var X0 = 0; X0 < 3; X0++){
            for(var c0 = 0; c0 < P0; ++c0){
                var O0 = c0 & 1;
                p0[O0] != 0 ? $0($, c0, X0) : (m0 = j, M0(v, h, x, c0, X0, n0, m0, O0), _(v, n0, x0[c0], k0[c0], c0, X0));
            }
            p0[0] + p0[1] == 0 && v.mode == w.JOINT_STEREO && H0(x0, k0, $.mld_cb_s, $.ATH.cb_s, v.ATHlower * $.ATH.adjust, v.msfix, $.npart_s);
            for(var c0 = 0; c0 < P0; ++c0){
                var O0 = c0 & 1;
                p0[O0] == 0 && E($, x0[c0], k0[c0], c0, X0);
            }
        }
        for(var c0 = 0; c0 < P0; c0++){
            var O0 = c0 & 1;
            if (p0[O0] == 0) for(var Z0 = 0; Z0 < r0.SBMAX_s; Z0++){
                for(var v1 = g0(3), X0 = 0; X0 < 3; X0++){
                    var z0 = $.thm[c0].s[Z0][X0];
                    if (z0 *= A, l0[c0][X0] >= 2 || l0[c0][X0 + 1] == 1) {
                        var K0 = X0 != 0 ? X0 - 1 : 2, s1 = n($.thm[c0].s[Z0][K0], z0, m * B0);
                        z0 = Math.min(z0, s1);
                    } else if (l0[c0][X0] == 1) {
                        var K0 = X0 != 0 ? X0 - 1 : 2, s1 = n($.thm[c0].s[Z0][K0], z0, O * B0);
                        z0 = Math.min(z0, s1);
                    } else if (X0 != 0 && l0[c0][X0 - 1] == 3 || X0 == 0 && $.nsPsy.lastAttacks[c0] == 3) {
                        var K0 = X0 != 2 ? X0 + 1 : 0, s1 = n($.thm[c0].s[Z0][K0], z0, O * B0);
                        z0 = Math.min(z0, s1);
                    }
                    z0 *= _0[c0][X0], v1[X0] = z0;
                }
                for(var X0 = 0; X0 < 3; X0++)$.thm[c0].s[Z0][X0] = v1[X0];
            }
        }
        for(var c0 = 0; c0 < P0; c0++)$.nsPsy.lastAttacks[c0] = l0[c0][2];
        V0(v, p0, e0);
        for(var c0 = 0; c0 < P0; c0++){
            var o1, h1, c1, S1;
            c0 > 1 ? (o1 = G, h1 = -2, c1 = r0.NORM_TYPE, (e0[0] == r0.SHORT_TYPE || e0[1] == r0.SHORT_TYPE) && (c1 = r0.SHORT_TYPE), S1 = c[y][c0 - 2]) : (o1 = C, h1 = 0, c1 = e0[c0], S1 = k[y][c0]), c1 == r0.SHORT_TYPE ? o1[h1 + c0] = Y(S1, $.masking_lower) : o1[h1 + c0] = T(S1, $.masking_lower), v.analysis && ($.pinfo.pe[y][c0] = o1[h1 + c0]);
        }
        return 0;
    };
    function y0(v, h) {
        var x = v, y;
        return x >= 0 ? y = -x * 27 : y = x * h, y <= -72 ? 0 : Math.exp(y * t0);
    }
    function T0(v) {
        var h = 0, x = 0;
        var y = 0, k, c;
        for(y = 0; y0(y, v) > 1e-20; y -= 1);
        for(k = y, c = 0; Math.abs(c - k) > 1e-12;)y = (c + k) / 2, y0(y, v) > 0 ? c = y : k = y;
        h = k;
        var y = 0, k, c;
        for(y = 0; y0(y, v) > 1e-20; y += 1);
        for(k = 0, c = y; Math.abs(c - k) > 1e-12;)y = (c + k) / 2, y0(y, v) > 0 ? k = y : c = y;
        x = c;
        var C = 0, G = 1e3, F;
        for(F = 0; F <= G; ++F){
            var y = h + F * (x - h) / G, e0 = y0(y, v);
            C += e0;
        }
        var $ = (G + 1) / (C * (x - h));
        return $;
    }
    function F0(v) {
        var h, x, y, k;
        return h = v, h >= 0 ? h *= 3 : h *= 1.5, h >= 0.5 && h <= 2.5 ? (k = h - 0.5, x = 8 * (k * k - 2 * k)) : x = 0, h += 0.474, y = 15.811389 + 7.5 * h - 17.5 * Math.sqrt(1 + h * h), y <= -60 ? 0 : (h = Math.exp((x + y) * t0), h /= 0.6609193, h);
    }
    function I0(v) {
        return v < 0 && (v = 0), v = v * 1e-3, 13 * Math.atan(0.76 * v) + 3.5 * Math.atan(v * v / 56.25);
    }
    function b0(v, h, x, y, k, c, C, G, F, e0, $, a0) {
        var m0 = g0(r0.CBANDS + 1), N0 = G / (a0 > 15 ? 1152 : 384), n0 = L1(r0.HBLKSIZE), L0;
        G /= F;
        var j = 0, x0 = 0;
        for(L0 = 0; L0 < r0.CBANDS; L0++){
            var k0, _0;
            for(k0 = I0(G * j), m0[L0] = G * j, _0 = j; I0(G * _0) - k0 < D && _0 <= F / 2; _0++);
            for(v[L0] = _0 - j, x0 = L0 + 1; j < _0;)C0(j < r0.HBLKSIZE), n0[j++] = L0;
            if (j > F / 2) {
                j = F / 2, ++L0;
                break;
            }
        }
        C0(L0 < r0.CBANDS), m0[L0] = G * j;
        for(var B0 = 0; B0 < a0; B0++){
            var l0, p0, P0, c0, O0;
            P0 = e0[B0], c0 = e0[B0 + 1], l0 = 0 | Math.floor(0.5 + $ * (P0 - 0.5)), l0 < 0 && (l0 = 0), p0 = 0 | Math.floor(0.5 + $ * (c0 - 0.5)), p0 > F / 2 && (p0 = F / 2), x[B0] = (n0[l0] + n0[p0]) / 2, h[B0] = n0[p0];
            var X0 = N0 * c0;
            C[B0] = (X0 - m0[h[B0]]) / (m0[h[B0] + 1] - m0[h[B0]]), C[B0] < 0 ? C[B0] = 0 : C[B0] > 1 && (C[B0] = 1), O0 = I0(G * e0[B0] * $), O0 = Math.min(O0, 15.5) / 15.5, c[B0] = Math.pow(10, 1.25 * (1 - Math.cos(Math.PI * O0)) - 2.5);
        }
        j = 0;
        for(var Z0 = 0; Z0 < x0; Z0++){
            var v1 = v[Z0], k0, z0;
            k0 = I0(G * j), z0 = I0(G * (j + v1 - 1)), y[Z0] = 0.5 * (k0 + z0), k0 = I0(G * (j - 0.5)), z0 = I0(G * (j + v1 - 0.5)), k[Z0] = z0 - k0, j += v1;
        }
        return x0;
    }
    function G0(v, h, x, y, k, c) {
        var C = m1([
            r0.CBANDS,
            r0.CBANDS
        ]), G, F = 0;
        if (c) for(var e0 = 0; e0 < h; e0++)for(G = 0; G < h; G++){
            var $ = F0(x[e0] - x[G]) * y[G];
            C[e0][G] = $ * k[e0];
        }
        else for(G = 0; G < h; G++)for(var a0 = 15 + Math.min(21 / x[G], 12), m0 = T0(a0), e0 = 0; e0 < h; e0++){
            var $ = m0 * y0(x[e0] - x[G], a0) * y[G];
            C[e0][G] = $ * k[e0];
        }
        for(var e0 = 0; e0 < h; e0++){
            for(G = 0; G < h && !(C[e0][G] > 0); G++);
            for(v[e0][0] = G, G = h - 1; G > 0 && !(C[e0][G] > 0); G--);
            v[e0][1] = G, F += v[e0][1] - v[e0][0] + 1;
        }
        for(var N0 = g0(F), n0 = 0, e0 = 0; e0 < h; e0++)for(G = v[e0][0]; G <= v[e0][1]; G++)N0[n0++] = C[e0][G];
        return N0;
    }
    function e1(v) {
        var h = I0(v);
        return h = Math.min(h, 15.5) / 15.5, Math.pow(10, 1.25 * (1 - Math.cos(Math.PI * h)) - 2.5);
    }
    this.psymodel_init = function(v) {
        var h = v.internal_flags, x, y = !0, k = 13, c = 24, C = 0, G = 0, F = -8.25, e0 = -4.5, $ = g0(r0.CBANDS), a0 = g0(r0.CBANDS), m0 = g0(r0.CBANDS), N0 = v.out_samplerate;
        switch(v.experimentalZ){
            default:
            case 0:
                y = !0;
                break;
            case 1:
                y = !(v.VBR == C1.vbr_mtrh || v.VBR == C1.vbr_mt);
                break;
            case 2:
                y = !1;
                break;
            case 3:
                k = 8, C = -1.75, G = -0.0125, F = -8.25, e0 = -2.25;
                break;
        }
        for(h.ms_ener_ratio_old = 0.25, h.blocktype_old[0] = h.blocktype_old[1] = r0.NORM_TYPE, x = 0; x < 4; ++x){
            for(var j = 0; j < r0.CBANDS; ++j)h.nb_1[x][j] = 1e20, h.nb_2[x][j] = 1e20, h.nb_s1[x][j] = h.nb_s2[x][j] = 1;
            for(var n0 = 0; n0 < r0.SBMAX_l; n0++)h.en[x].l[n0] = 1e20, h.thm[x].l[n0] = 1e20;
            for(var j = 0; j < 3; ++j){
                for(var n0 = 0; n0 < r0.SBMAX_s; n0++)h.en[x].s[n0][j] = 1e20, h.thm[x].s[n0][j] = 1e20;
                h.nsPsy.lastAttacks[x] = 0;
            }
            for(var j = 0; j < 9; j++)h.nsPsy.last_en_subshort[x][j] = 10;
        }
        for(h.loudness_sq_save[0] = h.loudness_sq_save[1] = 0, h.npart_l = b0(h.numlines_l, h.bo_l, h.bm_l, $, a0, h.mld_l, h.PSY.bo_l_weight, N0, r0.BLKSIZE, h.scalefac_band.l, r0.BLKSIZE / 1152, r0.SBMAX_l), C0(h.npart_l < r0.CBANDS), x = 0; x < h.npart_l; x++){
            var L0 = C;
            $[x] >= k && (L0 = G * ($[x] - k) / (c - k) + C * (c - $[x]) / (c - k)), m0[x] = Math.pow(10, L0 / 10), h.numlines_l[x] > 0 ? h.rnumlines_l[x] = 1 / h.numlines_l[x] : h.rnumlines_l[x] = 0;
        }
        h.s3_ll = G0(h.s3ind, h.npart_l, $, a0, m0, y);
        var j = 0;
        for(x = 0; x < h.npart_l; x++){
            var x0;
            x0 = Ue.MAX_VALUE;
            for(var k0 = 0; k0 < h.numlines_l[x]; k0++, j++){
                var _0 = N0 * j / (1e3 * r0.BLKSIZE), B0;
                B0 = this.ATHformula(_0 * 1e3, v) - 20, B0 = Math.pow(10, 0.1 * B0), B0 *= h.numlines_l[x], x0 > B0 && (x0 = B0);
            }
            h.ATH.cb_l[x] = x0, x0 = -20 + $[x] * 20 / 10, x0 > 6 && (x0 = 100), x0 < -15 && (x0 = -15), x0 -= 8, h.minval_l[x] = Math.pow(10, x0 / 10) * h.numlines_l[x];
        }
        for(h.npart_s = b0(h.numlines_s, h.bo_s, h.bm_s, $, a0, h.mld_s, h.PSY.bo_s_weight, N0, r0.BLKSIZE_s, h.scalefac_band.s, r0.BLKSIZE_s / 384, r0.SBMAX_s), C0(h.npart_s < r0.CBANDS), j = 0, x = 0; x < h.npart_s; x++){
            var x0, L0 = F;
            $[x] >= k && (L0 = e0 * ($[x] - k) / (c - k) + F * (c - $[x]) / (c - k)), m0[x] = Math.pow(10, L0 / 10), x0 = Ue.MAX_VALUE;
            for(var k0 = 0; k0 < h.numlines_s[x]; k0++, j++){
                var _0 = N0 * j / (1e3 * r0.BLKSIZE_s), B0;
                B0 = this.ATHformula(_0 * 1e3, v) - 20, B0 = Math.pow(10, 0.1 * B0), B0 *= h.numlines_s[x], x0 > B0 && (x0 = B0);
            }
            h.ATH.cb_s[x] = x0, x0 = -7 + $[x] * 7 / 12, $[x] > 12 && (x0 *= 1 + Math.log(1 + x0) * 3.1), $[x] < 12 && (x0 *= 1 + Math.log(1 - x0) * 2.3), x0 < -15 && (x0 = -15), x0 -= 8, h.minval_s[x] = Math.pow(10, x0 / 10) * h.numlines_s[x];
        }
        h.s3_ss = G0(h.s3ind_s, h.npart_s, $, a0, m0, y), B(), Z.init_fft(h), h.decay = Math.exp(-1 * X / (f0 * N0 / 192));
        var l0;
        l0 = s0, v.exp_nspsytune & 2 && (l0 = 1), Math.abs(v.msfix) > 0 && (l0 = v.msfix), v.msfix = l0;
        for(var p0 = 0; p0 < h.npart_l; p0++)h.s3ind[p0][1] > h.npart_l - 1 && (h.s3ind[p0][1] = h.npart_l - 1);
        var P0 = 576 * h.mode_gr / N0;
        if (h.ATH.decay = Math.pow(10, -1.2 * P0), h.ATH.adjust = 0.01, h.ATH.adjustLimit = 1, C0(h.bo_l[r0.SBMAX_l - 1] <= h.npart_l), C0(h.bo_s[r0.SBMAX_s - 1] <= h.npart_s), v.ATHtype != -1) {
            var _0, c0 = v.out_samplerate / r0.BLKSIZE, O0 = 0;
            for(_0 = 0, x = 0; x < r0.BLKSIZE / 2; ++x)_0 += c0, h.ATH.eql_w[x] = 1 / Math.pow(10, this.ATHformula(_0, v) / 10), O0 += h.ATH.eql_w[x];
            for(O0 = 1 / O0, x = r0.BLKSIZE / 2; --x >= 0;)h.ATH.eql_w[x] *= O0;
        }
        for(var p0 = j = 0; p0 < h.npart_s; ++p0)for(x = 0; x < h.numlines_s[p0]; ++x)++j;
        for(var p0 = j = 0; p0 < h.npart_l; ++p0)for(x = 0; x < h.numlines_l[p0]; ++x)++j;
        for(j = 0, x = 0; x < h.npart_l; x++){
            var _0 = N0 * (j + h.numlines_l[x] / 2) / (1 * r0.BLKSIZE);
            h.mld_cb_l[x] = e1(_0), j += h.numlines_l[x];
        }
        for(; x < r0.CBANDS; ++x)h.mld_cb_l[x] = 1;
        for(j = 0, x = 0; x < h.npart_s; x++){
            var _0 = N0 * (j + h.numlines_s[x] / 2) / (1 * r0.BLKSIZE_s);
            h.mld_cb_s[x] = e1(_0), j += h.numlines_s[x];
        }
        for(; x < r0.CBANDS; ++x)h.mld_cb_s[x] = 1;
        return 0;
    };
    function Y0(v, h) {
        v < -0.3 && (v = 3410), v /= 1e3, v = Math.max(0.1, v);
        var x = 3.64 * Math.pow(v, -0.8) - 6.8 * Math.exp(-0.6 * Math.pow(v - 3.4, 2)) + 6 * Math.exp(-0.15 * Math.pow(v - 8.7, 2)) + (0.6 + 0.04 * h) * 1e-3 * Math.pow(v, 4);
        return x;
    }
    this.ATHformula = function(v, h) {
        var x;
        switch(h.ATHtype){
            case 0:
                x = Y0(v, 9);
                break;
            case 1:
                x = Y0(v, -1);
                break;
            case 2:
                x = Y0(v, 0);
                break;
            case 3:
                x = Y0(v, 1) + 6;
                break;
            case 4:
                x = Y0(v, h.ATHcurve);
                break;
            default:
                x = Y0(v, 0);
                break;
        }
        return x;
    };
}
var Qa = Ua, Wa = j1;
function ja() {
    this.class_id = 0, this.num_samples = 0, this.num_channels = 0, this.in_samplerate = 0, this.out_samplerate = 0, this.scale = 0, this.scale_left = 0, this.scale_right = 0, this.analysis = !1, this.bWriteVbrTag = !1, this.decode_only = !1, this.quality = 0, this.mode = Wa.STEREO, this.force_ms = !1, this.free_format = !1, this.findReplayGain = !1, this.decode_on_the_fly = !1, this.write_id3tag_automatic = !1, this.brate = 0, this.compression_ratio = 0, this.copyright = 0, this.original = 0, this.extension = 0, this.emphasis = 0, this.error_protection = 0, this.strict_ISO = !1, this.disable_reservoir = !1, this.quant_comp = 0, this.quant_comp_short = 0, this.experimentalY = !1, this.experimentalZ = 0, this.exp_nspsytune = 0, this.preset = 0, this.VBR = null, this.VBR_q_frac = 0, this.VBR_q = 0, this.VBR_mean_bitrate_kbps = 0, this.VBR_min_bitrate_kbps = 0, this.VBR_max_bitrate_kbps = 0, this.VBR_hard_min = 0, this.lowpassfreq = 0, this.highpassfreq = 0, this.lowpasswidth = 0, this.highpasswidth = 0, this.maskingadjust = 0, this.maskingadjust_short = 0, this.ATHonly = !1, this.ATHshort = !1, this.noATH = !1, this.ATHtype = 0, this.ATHcurve = 0, this.ATHlower = 0, this.athaa_type = 0, this.athaa_loudapprox = 0, this.athaa_sensitivity = 0, this.short_blocks = null, this.useTemporal = !1, this.interChRatio = 0, this.msfix = 0, this.tune = !1, this.tune_value_a = 0, this.version = 0, this.encoder_delay = 0, this.encoder_padding = 0, this.framesize = 0, this.frameNum = 0, this.lame_allocated_gfp = 0, this.internal_flags = null;
}
var za = ja, Ja = t1(), Ta = {};
Ta.SFBMAX = Ja.SBMAX_s * 3;
var ie = Ta, ya = Q0, ga = ya.new_float, N1 = ya.new_int, Re = ie;
function e2() {
    this.xr = ga(576), this.l3_enc = N1(576), this.scalefac = N1(Re.SFBMAX), this.xrpow_max = 0, this.part2_3_length = 0, this.big_values = 0, this.count1 = 0, this.global_gain = 0, this.scalefac_compress = 0, this.block_type = 0, this.mixed_block_flag = 0, this.table_select = N1(3), this.subblock_gain = N1(4), this.region0_count = 0, this.region1_count = 0, this.preflag = 0, this.scalefac_scale = 0, this.count1table_select = 0, this.part2_length = 0, this.sfb_lmax = 0, this.sfb_smin = 0, this.psy_lmax = 0, this.sfbmax = 0, this.psymax = 0, this.sfbdivide = 0, this.width = N1(Re.SFBMAX), this.window = N1(Re.SFBMAX), this.count1bits = 0, this.sfb_partition_table = null, this.slen = N1(4), this.max_nonzero_coeff = 0;
    var w = this;
    function Z(z) {
        return new Int32Array(z);
    }
    function X(z) {
        return new Float32Array(z);
    }
    this.assign = function(z) {
        w.xr = X(z.xr), w.l3_enc = Z(z.l3_enc), w.scalefac = Z(z.scalefac), w.xrpow_max = z.xrpow_max, w.part2_3_length = z.part2_3_length, w.big_values = z.big_values, w.count1 = z.count1, w.global_gain = z.global_gain, w.scalefac_compress = z.scalefac_compress, w.block_type = z.block_type, w.mixed_block_flag = z.mixed_block_flag, w.table_select = Z(z.table_select), w.subblock_gain = Z(z.subblock_gain), w.region0_count = z.region0_count, w.region1_count = z.region1_count, w.preflag = z.preflag, w.scalefac_scale = z.scalefac_scale, w.count1table_select = z.count1table_select, w.part2_length = z.part2_length, w.sfb_lmax = z.sfb_lmax, w.sfb_smin = z.sfb_smin, w.psy_lmax = z.psy_lmax, w.sfbmax = z.sfbmax, w.psymax = z.psymax, w.sfbdivide = z.sfbdivide, w.width = Z(z.width), w.window = Z(z.window), w.count1bits = z.count1bits, w.sfb_partition_table = z.sfb_partition_table.slice(0), w.slen = Z(z.slen), w.max_nonzero_coeff = z.max_nonzero_coeff;
    };
}
var Le = e2, a2 = Q0, Qe = a2.new_int, r2 = Le;
function t2() {
    this.tt = [
        [
            null,
            null
        ],
        [
            null,
            null
        ]
    ], this.main_data_begin = 0, this.private_bits = 0, this.resvDrain_pre = 0, this.resvDrain_post = 0, this.scfsi = [
        Qe(4),
        Qe(4)
    ];
    for(var w = 0; w < 2; w++)for(var Z = 0; Z < 2; Z++)this.tt[w][Z] = new r2();
}
var s2 = t2, wa = Q0, g1 = wa.System, ee = wa.new_int, ae = t1();
function i2(w, Z, X, z) {
    this.l = ee(1 + ae.SBMAX_l), this.s = ee(1 + ae.SBMAX_s), this.psfb21 = ee(1 + ae.PSFB21), this.psfb12 = ee(1 + ae.PSFB12);
    var u0 = this.l, W = this.s;
    arguments.length == 4 && (this.arrL = arguments[0], this.arrS = arguments[1], this.arr21 = arguments[2], this.arr12 = arguments[3], g1.arraycopy(this.arrL, 0, u0, 0, Math.min(this.arrL.length, this.l.length)), g1.arraycopy(this.arrS, 0, W, 0, Math.min(this.arrS.length, this.s.length)), g1.arraycopy(this.arr21, 0, this.psfb21, 0, Math.min(this.arr21.length, this.psfb21.length)), g1.arraycopy(this.arr12, 0, this.psfb12, 0, Math.min(this.arr12.length, this.psfb12.length)));
}
var Ia = i2, Ne = Q0, xe = Ne.new_float, n2 = Ne.new_float_n, _2 = Ne.new_int, We = t1();
function l2() {
    this.last_en_subshort = n2([
        4,
        9
    ]), this.lastAttacks = _2(4), this.pefirbuf = xe(19), this.longfact = xe(We.SBMAX_l), this.shortfact = xe(We.SBMAX_s), this.attackthre = 0, this.attackthre_s = 0;
}
var v2 = l2;
function o2() {
    this.sum = 0, this.seen = 0, this.want = 0, this.pos = 0, this.size = 0, this.bag = null, this.nVbrNumFrames = 0, this.nBytesWritten = 0, this.TotalFrameSize = 0;
}
var h2 = o2, Y1 = Q0, u2 = Y1.new_byte, f2 = Y1.new_double, b1 = Y1.new_float, p1 = Y1.new_float_n, d1 = Y1.new_int, re = Y1.new_int_n, m2 = s2, b2 = Ia, c2 = v2, S2 = h2, je = Ea(), W0 = t1(), d2 = ie;
E1.MFSIZE = 3456 + W0.ENCDELAY - W0.MDCTDELAY;
E1.MAX_HEADER_BUF = 256;
E1.MAX_BITS_PER_CHANNEL = 4095;
E1.MAX_BITS_PER_GRANULE = 7680;
E1.BPC = 320;
function E1() {
    var w = 40;
    this.Class_ID = 0, this.lame_encode_frame_init = 0, this.iteration_init_init = 0, this.fill_buffer_resample_init = 0, this.mfbuf = p1([
        2,
        E1.MFSIZE
    ]), this.mode_gr = 0, this.channels_in = 0, this.channels_out = 0, this.resample_ratio = 0, this.mf_samples_to_encode = 0, this.mf_size = 0, this.VBR_min_bitrate = 0, this.VBR_max_bitrate = 0, this.bitrate_index = 0, this.samplerate_index = 0, this.mode_ext = 0, this.lowpass1 = 0, this.lowpass2 = 0, this.highpass1 = 0, this.highpass2 = 0, this.noise_shaping = 0, this.noise_shaping_amp = 0, this.substep_shaping = 0, this.psymodel = 0, this.noise_shaping_stop = 0, this.subblock_gain = 0, this.use_best_huffman = 0, this.full_outer_loop = 0, this.l3_side = new m2(), this.ms_ratio = b1(2), this.padding = 0, this.frac_SpF = 0, this.slot_lag = 0, this.tag_spec = null, this.nMusicCRC = 0, this.OldValue = d1(2), this.CurrentStep = d1(2), this.masking_lower = 0, this.bv_scf = d1(576), this.pseudohalf = d1(d2.SFBMAX), this.sfb21_extra = !1, this.inbuf_old = new Array(2), this.blackfilt = new Array(2 * E1.BPC + 1), this.itime = f2(2), this.sideinfo_len = 0, this.sb_sample = p1([
        2,
        2,
        18,
        W0.SBLIMIT
    ]), this.amp_filter = b1(32);
    function Z() {
        this.write_timing = 0, this.ptr = 0, this.buf = u2(w);
    }
    this.header = new Array(E1.MAX_HEADER_BUF), this.h_ptr = 0, this.w_ptr = 0, this.ancillary_flag = 0, this.ResvSize = 0, this.ResvMax = 0, this.scalefac_band = new b2(), this.minval_l = b1(W0.CBANDS), this.minval_s = b1(W0.CBANDS), this.nb_1 = p1([
        4,
        W0.CBANDS
    ]), this.nb_2 = p1([
        4,
        W0.CBANDS
    ]), this.nb_s1 = p1([
        4,
        W0.CBANDS
    ]), this.nb_s2 = p1([
        4,
        W0.CBANDS
    ]), this.s3_ss = null, this.s3_ll = null, this.decay = 0, this.thm = new Array(4), this.en = new Array(4), this.tot_ener = b1(4), this.loudness_sq = p1([
        2,
        2
    ]), this.loudness_sq_save = b1(2), this.mld_l = b1(W0.SBMAX_l), this.mld_s = b1(W0.SBMAX_s), this.bm_l = d1(W0.SBMAX_l), this.bo_l = d1(W0.SBMAX_l), this.bm_s = d1(W0.SBMAX_s), this.bo_s = d1(W0.SBMAX_s), this.npart_l = 0, this.npart_s = 0, this.s3ind = re([
        W0.CBANDS,
        2
    ]), this.s3ind_s = re([
        W0.CBANDS,
        2
    ]), this.numlines_s = d1(W0.CBANDS), this.numlines_l = d1(W0.CBANDS), this.rnumlines_l = b1(W0.CBANDS), this.mld_cb_l = b1(W0.CBANDS), this.mld_cb_s = b1(W0.CBANDS), this.numlines_s_num1 = 0, this.numlines_l_num1 = 0, this.pe = b1(4), this.ms_ratio_s_old = 0, this.ms_ratio_l_old = 0, this.ms_ener_ratio_old = 0, this.blocktype_old = d1(2), this.nsPsy = new c2(), this.VBR_seek_table = new S2(), this.ATH = null, this.PSY = null, this.nogap_total = 0, this.nogap_current = 0, this.decode_on_the_fly = !0, this.findReplayGain = !0, this.findPeakSample = !0, this.PeakSample = 0, this.RadioGain = 0, this.AudiophileGain = 0, this.rgdata = null, this.noclipGainChange = 0, this.noclipScale = 0, this.bitrate_stereoMode_Hist = re([
        16,
        5
    ]), this.bitrate_blockType_Hist = re([
        16,
        6
    ]), this.pinfo = null, this.hip = null, this.in_buffer_nsamples = 0, this.in_buffer_0 = null, this.in_buffer_1 = null, this.iteration_loop = null;
    for(var X = 0; X < this.en.length; X++)this.en[X] = new je();
    for(var X = 0; X < this.thm.length; X++)this.thm[X] = new je();
    for(var X = 0; X < this.header.length; X++)this.header[X] = new Z();
}
var ne = E1, A2 = Q0, H1 = A2.new_float, V1 = t1();
function R2() {
    this.useAdjust = 0, this.aaSensitivityP = 0, this.adjust = 0, this.adjustLimit = 0, this.decay = 0, this.floor = 0, this.l = H1(V1.SBMAX_l), this.s = H1(V1.SBMAX_s), this.psfb21 = H1(V1.PSFB21), this.psfb12 = H1(V1.PSFB12), this.cb_l = H1(V1.CBANDS), this.cb_s = H1(V1.CBANDS), this.eql_w = H1(V1.BLKSIZE / 2);
}
var x2 = R2, La = Q0, _1 = La.System, ze = La.Arrays;
j0.STEPS_per_dB = 100;
j0.MAX_dB = 120;
j0.GAIN_NOT_ENOUGH_SAMPLES = -24601;
j0.GAIN_ANALYSIS_ERROR = 0;
j0.GAIN_ANALYSIS_OK = 1;
j0.INIT_GAIN_ANALYSIS_ERROR = 0;
j0.INIT_GAIN_ANALYSIS_OK = 1;
j0.YULE_ORDER = 10;
j0.MAX_ORDER = j0.YULE_ORDER;
j0.MAX_SAMP_FREQ = 48e3;
j0.RMS_WINDOW_TIME_NUMERATOR = 1;
j0.RMS_WINDOW_TIME_DENOMINATOR = 20;
j0.MAX_SAMPLES_PER_WINDOW = j0.MAX_SAMP_FREQ * j0.RMS_WINDOW_TIME_NUMERATOR / j0.RMS_WINDOW_TIME_DENOMINATOR + 1;
function j0() {
    var w = 64.82, Z = 0.95, X = j0.RMS_WINDOW_TIME_NUMERATOR, z = j0.RMS_WINDOW_TIME_DENOMINATOR, u0 = [
        [
            0.038575994352,
            -3.84664617118067,
            -0.02160367184185,
            7.81501653005538,
            -0.00123395316851,
            -11.34170355132042,
            -0.00009291677959,
            13.05504219327545,
            -0.01655260341619,
            -12.28759895145294,
            0.02161526843274,
            9.4829380631979,
            -0.02074045215285,
            -5.87257861775999,
            0.00594298065125,
            2.75465861874613,
            0.00306428023191,
            -0.86984376593551,
            12025322027e-14,
            0.13919314567432,
            0.00288463683916
        ],
        [
            0.0541865640643,
            -3.47845948550071,
            -0.02911007808948,
            6.36317777566148,
            -0.00848709379851,
            -8.54751527471874,
            -0.00851165645469,
            9.4769360780128,
            -0.00834990904936,
            -8.81498681370155,
            0.02245293253339,
            6.85401540936998,
            -0.02596338512915,
            -4.39470996079559,
            0.01624864962975,
            2.19611684890774,
            -0.00240879051584,
            -0.75104302451432,
            0.00674613682247,
            0.13149317958808,
            -0.00187763777362
        ],
        [
            0.15457299681924,
            -2.37898834973084,
            -0.09331049056315,
            2.84868151156327,
            -0.06247880153653,
            -2.64577170229825,
            0.02163541888798,
            2.23697657451713,
            -0.05588393329856,
            -1.67148153367602,
            0.04781476674921,
            1.00595954808547,
            0.00222312597743,
            -0.45953458054983,
            0.03174092540049,
            0.16378164858596,
            -0.01390589421898,
            -0.05032077717131,
            0.00651420667831,
            0.0234789740702,
            -0.00881362733839
        ],
        [
            0.30296907319327,
            -1.61273165137247,
            -0.22613988682123,
            1.0797749225997,
            -0.08587323730772,
            -0.2565625775407,
            0.03282930172664,
            -0.1627671912044,
            -0.00915702933434,
            -0.22638893773906,
            -0.02364141202522,
            0.39120800788284,
            -0.00584456039913,
            -0.22138138954925,
            0.06276101321749,
            0.04500235387352,
            -0.00000828086748,
            0.02005851806501,
            0.00205861885564,
            0.00302439095741,
            -0.02950134983287
        ],
        [
            0.33642304856132,
            -1.49858979367799,
            -0.2557224142557,
            0.87350271418188,
            -0.11828570177555,
            0.12205022308084,
            0.11921148675203,
            -0.80774944671438,
            -0.07834489609479,
            0.47854794562326,
            -0.0046997791438,
            -0.12453458140019,
            -0.0058950022444,
            -0.04067510197014,
            0.05724228140351,
            0.08333755284107,
            0.00832043980773,
            -0.04237348025746,
            -0.0163538138454,
            0.02977207319925,
            -0.0176017656815
        ],
        [
            0.4491525660845,
            -0.62820619233671,
            -0.14351757464547,
            0.29661783706366,
            -0.22784394429749,
            -0.372563729424,
            -0.01419140100551,
            0.00213767857124,
            0.04078262797139,
            -0.42029820170918,
            -0.12398163381748,
            0.22199650564824,
            0.04097565135648,
            0.00613424350682,
            0.10478503600251,
            0.06747620744683,
            -0.01863887810927,
            0.05784820375801,
            -0.03193428438915,
            0.03222754072173,
            0.00541907748707
        ],
        [
            0.56619470757641,
            -1.04800335126349,
            -0.75464456939302,
            0.29156311971249,
            0.1624213774223,
            -0.26806001042947,
            0.16744243493672,
            0.00819999645858,
            -0.18901604199609,
            0.45054734505008,
            0.3093178284183,
            -0.33032403314006,
            -0.27562961986224,
            0.0673936833311,
            0.00647310677246,
            -0.04784254229033,
            0.08647503780351,
            0.01639907836189,
            -0.0378898455484,
            0.01807364323573,
            -0.00588215443421
        ],
        [
            0.58100494960553,
            -0.51035327095184,
            -0.53174909058578,
            -0.31863563325245,
            -0.14289799034253,
            -0.20256413484477,
            0.17520704835522,
            0.1472815413433,
            0.02377945217615,
            0.38952639978999,
            0.15558449135573,
            -0.23313271880868,
            -0.25344790059353,
            -0.05246019024463,
            0.01628462406333,
            -0.02505961724053,
            0.06920467763959,
            0.02442357316099,
            -0.03721611395801,
            0.01818801111503,
            -0.00749618797172
        ],
        [
            0.53648789255105,
            -0.2504987195602,
            -0.42163034350696,
            -0.43193942311114,
            -0.00275953611929,
            -0.03424681017675,
            0.04267842219415,
            -0.04678328784242,
            -0.10214864179676,
            0.26408300200955,
            0.14590772289388,
            0.15113130533216,
            -0.02459864859345,
            -0.17556493366449,
            -0.11202315195388,
            -0.18823009262115,
            -0.04060034127,
            0.05477720428674,
            0.0478866554818,
            0.0470440968812,
            -0.02217936801134
        ]
    ], W = [
        [
            0.98621192462708,
            -1.97223372919527,
            -1.97242384925416,
            0.97261396931306,
            0.98621192462708
        ],
        [
            0.98500175787242,
            -1.96977855582618,
            -1.97000351574484,
            0.9702284756635,
            0.98500175787242
        ],
        [
            0.97938932735214,
            -1.95835380975398,
            -1.95877865470428,
            0.95920349965459,
            0.97938932735214
        ],
        [
            0.97531843204928,
            -1.95002759149878,
            -1.95063686409857,
            0.95124613669835,
            0.97531843204928
        ],
        [
            0.97316523498161,
            -1.94561023566527,
            -1.94633046996323,
            0.94705070426118,
            0.97316523498161
        ],
        [
            0.96454515552826,
            -1.92783286977036,
            -1.92909031105652,
            0.93034775234268,
            0.96454515552826
        ],
        [
            0.96009142950541,
            -1.91858953033784,
            -1.92018285901082,
            0.92177618768381,
            0.96009142950541
        ],
        [
            0.95856916599601,
            -1.9154210807478,
            -1.91713833199203,
            0.91885558323625,
            0.95856916599601
        ],
        [
            0.94597685600279,
            -1.88903307939452,
            -1.89195371200558,
            0.89487434461664,
            0.94597685600279
        ]
    ];
    function Q(m, O, s0, K, t0, U) {
        for(; t0-- != 0;)s0[K] = 1e-10 + m[O + 0] * U[0] - s0[K - 1] * U[1] + m[O - 1] * U[2] - s0[K - 2] * U[3] + m[O - 2] * U[4] - s0[K - 3] * U[5] + m[O - 3] * U[6] - s0[K - 4] * U[7] + m[O - 4] * U[8] - s0[K - 5] * U[9] + m[O - 5] * U[10] - s0[K - 6] * U[11] + m[O - 6] * U[12] - s0[K - 7] * U[13] + m[O - 7] * U[14] - s0[K - 8] * U[15] + m[O - 8] * U[16] - s0[K - 9] * U[17] + m[O - 9] * U[18] - s0[K - 10] * U[19] + m[O - 10] * U[20], ++K, ++O;
    }
    function D(m, O, s0, K, t0, U) {
        for(; t0-- != 0;)s0[K] = m[O + 0] * U[0] - s0[K - 1] * U[1] + m[O - 1] * U[2] - s0[K - 2] * U[3] + m[O - 2] * U[4], ++K, ++O;
    }
    function g(m, O) {
        for(var s0 = 0; s0 < MAX_ORDER; s0++)m.linprebuf[s0] = m.lstepbuf[s0] = m.loutbuf[s0] = m.rinprebuf[s0] = m.rstepbuf[s0] = m.routbuf[s0] = 0;
        switch(0 | O){
            case 48e3:
                m.reqindex = 0;
                break;
            case 44100:
                m.reqindex = 1;
                break;
            case 32e3:
                m.reqindex = 2;
                break;
            case 24e3:
                m.reqindex = 3;
                break;
            case 22050:
                m.reqindex = 4;
                break;
            case 16e3:
                m.reqindex = 5;
                break;
            case 12e3:
                m.reqindex = 6;
                break;
            case 11025:
                m.reqindex = 7;
                break;
            case 8e3:
                m.reqindex = 8;
                break;
            default:
                return INIT_GAIN_ANALYSIS_ERROR;
        }
        return m.sampleWindow = 0 | (O * X + z - 1) / z, m.lsum = 0, m.rsum = 0, m.totsamp = 0, ze.ill(m.A, 0), INIT_GAIN_ANALYSIS_OK;
    }
    this.InitGainAnalysis = function(m, O) {
        return g(m, O) != INIT_GAIN_ANALYSIS_OK ? INIT_GAIN_ANALYSIS_ERROR : (m.linpre = MAX_ORDER, m.rinpre = MAX_ORDER, m.lstep = MAX_ORDER, m.rstep = MAX_ORDER, m.lout = MAX_ORDER, m.rout = MAX_ORDER, ze.fill(m.B, 0), INIT_GAIN_ANALYSIS_OK);
    };
    function f0(m) {
        return m * m;
    }
    this.AnalyzeSamples = function(m, O, s0, K, t0, U, R) {
        var o, u, d, e, l, M, p;
        if (U == 0) return GAIN_ANALYSIS_OK;
        switch(p = 0, l = U, R){
            case 1:
                K = O, t0 = s0;
                break;
            case 2:
                break;
            default:
                return GAIN_ANALYSIS_ERROR;
        }
        for(U < MAX_ORDER ? (_1.arraycopy(O, s0, m.linprebuf, MAX_ORDER, U), _1.arraycopy(K, t0, m.rinprebuf, MAX_ORDER, U)) : (_1.arraycopy(O, s0, m.linprebuf, MAX_ORDER, MAX_ORDER), _1.arraycopy(K, t0, m.rinprebuf, MAX_ORDER, MAX_ORDER)); l > 0;){
            M = l > m.sampleWindow - m.totsamp ? m.sampleWindow - m.totsamp : l, p < MAX_ORDER ? (o = m.linpre + p, u = m.linprebuf, d = m.rinpre + p, e = m.rinprebuf, M > MAX_ORDER - p && (M = MAX_ORDER - p)) : (o = s0 + p, u = O, d = t0 + p, e = K), Q(u, o, m.lstepbuf, m.lstep + m.totsamp, M, u0[m.reqindex]), Q(e, d, m.rstepbuf, m.rstep + m.totsamp, M, u0[m.reqindex]), D(m.lstepbuf, m.lstep + m.totsamp, m.loutbuf, m.lout + m.totsamp, M, W[m.reqindex]), D(m.rstepbuf, m.rstep + m.totsamp, m.routbuf, m.rout + m.totsamp, M, W[m.reqindex]), o = m.lout + m.totsamp, u = m.loutbuf, d = m.rout + m.totsamp, e = m.routbuf;
            for(var H = M % 8; H-- != 0;)m.lsum += f0(u[o++]), m.rsum += f0(e[d++]);
            for(H = M / 8; H-- != 0;)m.lsum += f0(u[o + 0]) + f0(u[o + 1]) + f0(u[o + 2]) + f0(u[o + 3]) + f0(u[o + 4]) + f0(u[o + 5]) + f0(u[o + 6]) + f0(u[o + 7]), o += 8, m.rsum += f0(e[d + 0]) + f0(e[d + 1]) + f0(e[d + 2]) + f0(e[d + 3]) + f0(e[d + 4]) + f0(e[d + 5]) + f0(e[d + 6]) + f0(e[d + 7]), d += 8;
            if (l -= M, p += M, m.totsamp += M, m.totsamp == m.sampleWindow) {
                var B = j0.STEPS_per_dB * 10 * Math.log10((m.lsum + m.rsum) / m.totsamp * 0.5 + 1e-37), I = B <= 0 ? 0 : 0 | B;
                I >= m.A.length && (I = m.A.length - 1), m.A[I]++, m.lsum = m.rsum = 0, _1.arraycopy(m.loutbuf, m.totsamp, m.loutbuf, 0, MAX_ORDER), _1.arraycopy(m.routbuf, m.totsamp, m.routbuf, 0, MAX_ORDER), _1.arraycopy(m.lstepbuf, m.totsamp, m.lstepbuf, 0, MAX_ORDER), _1.arraycopy(m.rstepbuf, m.totsamp, m.rstepbuf, 0, MAX_ORDER), m.totsamp = 0;
            }
            if (m.totsamp > m.sampleWindow) return GAIN_ANALYSIS_ERROR;
        }
        return U < MAX_ORDER ? (_1.arraycopy(m.linprebuf, U, m.linprebuf, 0, MAX_ORDER - U), _1.arraycopy(m.rinprebuf, U, m.rinprebuf, 0, MAX_ORDER - U), _1.arraycopy(O, s0, m.linprebuf, MAX_ORDER - U, U), _1.arraycopy(K, t0, m.rinprebuf, MAX_ORDER - U, U)) : (_1.arraycopy(O, s0 + U - MAX_ORDER, m.linprebuf, 0, MAX_ORDER), _1.arraycopy(K, t0 + U - MAX_ORDER, m.rinprebuf, 0, MAX_ORDER)), GAIN_ANALYSIS_OK;
    };
    function A(m, O) {
        var s0, K = 0;
        for(s0 = 0; s0 < O; s0++)K += m[s0];
        if (K == 0) return GAIN_NOT_ENOUGH_SAMPLES;
        var t0 = 0 | Math.ceil(K * (1 - Z));
        for(s0 = O; s0-- > 0 && !((t0 -= m[s0]) <= 0););
        return w - s0 / j0.STEPS_per_dB;
    }
    this.GetTitleGain = function(m) {
        for(var O = A(m.A, m.A.length), s0 = 0; s0 < m.A.length; s0++)m.B[s0] += m.A[s0], m.A[s0] = 0;
        for(var s0 = 0; s0 < MAX_ORDER; s0++)m.linprebuf[s0] = m.lstepbuf[s0] = m.loutbuf[s0] = m.rinprebuf[s0] = m.rstepbuf[s0] = m.routbuf[s0] = 0;
        return m.totsamp = 0, m.lsum = m.rsum = 0, O;
    };
}
var Na = j0, pa = Q0, k1 = pa.new_float, Je = pa.new_int, l1 = Na;
function M2() {
    this.linprebuf = k1(l1.MAX_ORDER * 2), this.linpre = 0, this.lstepbuf = k1(l1.MAX_SAMPLES_PER_WINDOW + l1.MAX_ORDER), this.lstep = 0, this.loutbuf = k1(l1.MAX_SAMPLES_PER_WINDOW + l1.MAX_ORDER), this.lout = 0, this.rinprebuf = k1(l1.MAX_ORDER * 2), this.rinpre = 0, this.rstepbuf = k1(l1.MAX_SAMPLES_PER_WINDOW + l1.MAX_ORDER), this.rstep = 0, this.routbuf = k1(l1.MAX_SAMPLES_PER_WINDOW + l1.MAX_ORDER), this.rout = 0, this.sampleWindow = 0, this.totsamp = 0, this.lsum = 0, this.rsum = 0, this.freqindex = 0, this.first = 0, this.A = Je(0 | l1.STEPS_per_dB * l1.MAX_dB), this.B = Je(0 | l1.STEPS_per_dB * l1.MAX_dB);
}
var E2 = M2;
function B2(w) {
    this.bits = w;
}
var Ha = B2, pe = Q0, ge = pe.new_float, T2 = pe.new_int, ea = pe.assert, y2 = Ha, aa = t1(), w2 = ie, I2 = ne;
function L2(w) {
    var Z = w;
    this.quantize = Z, this.iteration_loop = function(X, z, u0, W) {
        var Q = X.internal_flags, D = ge(w2.SFBMAX), g = ge(576), f0 = T2(2), A = 0, m, O = Q.l3_side, s0 = new y2(A);
        this.quantize.rv.ResvFrameBegin(X, s0), A = s0.bits;
        for(var K = 0; K < Q.mode_gr; K++){
            m = this.quantize.qupvt.on_pe(X, z, f0, A, K, K), Q.mode_ext == aa.MPG_MD_MS_LR && (this.quantize.ms_convert(Q.l3_side, K), this.quantize.qupvt.reduce_side(f0, u0[K], A, m));
            for(var t0 = 0; t0 < Q.channels_out; t0++){
                var U, R, o = O.tt[K][t0];
                o.block_type != aa.SHORT_TYPE ? (U = 0, R = Q.PSY.mask_adjust - U) : (U = 0, R = Q.PSY.mask_adjust_short - U), Q.masking_lower = Math.pow(10, R * 0.1), this.quantize.init_outer_loop(Q, o), this.quantize.init_xrpow(Q, o, g) && (this.quantize.qupvt.calc_xmin(X, W[K][t0], o, D), this.quantize.outer_loop(X, o, D, g, t0, f0[t0])), this.quantize.iteration_finish_one(Q, K, t0), ea(o.part2_3_length <= I2.MAX_BITS_PER_CHANNEL), ea(o.part2_3_length <= f0[t0]);
            }
        }
        this.quantize.rv.ResvFrameEnd(Q, A);
    };
}
var N2 = L2;
function q0(w, Z, X, z) {
    this.xlen = w, this.linmax = Z, this.table = X, this.hlen = z;
}
var o0 = {};
o0.t1HB = [
    1,
    1,
    1,
    0
];
o0.t2HB = [
    1,
    2,
    1,
    3,
    1,
    1,
    3,
    2,
    0
];
o0.t3HB = [
    3,
    2,
    1,
    1,
    1,
    1,
    3,
    2,
    0
];
o0.t5HB = [
    1,
    2,
    6,
    5,
    3,
    1,
    4,
    4,
    7,
    5,
    7,
    1,
    6,
    1,
    1,
    0
];
o0.t6HB = [
    7,
    3,
    5,
    1,
    6,
    2,
    3,
    2,
    5,
    4,
    4,
    1,
    3,
    3,
    2,
    0
];
o0.t7HB = [
    1,
    2,
    10,
    19,
    16,
    10,
    3,
    3,
    7,
    10,
    5,
    3,
    11,
    4,
    13,
    17,
    8,
    4,
    12,
    11,
    18,
    15,
    11,
    2,
    7,
    6,
    9,
    14,
    3,
    1,
    6,
    4,
    5,
    3,
    2,
    0
];
o0.t8HB = [
    3,
    4,
    6,
    18,
    12,
    5,
    5,
    1,
    2,
    16,
    9,
    3,
    7,
    3,
    5,
    14,
    7,
    3,
    19,
    17,
    15,
    13,
    10,
    4,
    13,
    5,
    8,
    11,
    5,
    1,
    12,
    4,
    4,
    1,
    1,
    0
];
o0.t9HB = [
    7,
    5,
    9,
    14,
    15,
    7,
    6,
    4,
    5,
    5,
    6,
    7,
    7,
    6,
    8,
    8,
    8,
    5,
    15,
    6,
    9,
    10,
    5,
    1,
    11,
    7,
    9,
    6,
    4,
    1,
    14,
    4,
    6,
    2,
    6,
    0
];
o0.t10HB = [
    1,
    2,
    10,
    23,
    35,
    30,
    12,
    17,
    3,
    3,
    8,
    12,
    18,
    21,
    12,
    7,
    11,
    9,
    15,
    21,
    32,
    40,
    19,
    6,
    14,
    13,
    22,
    34,
    46,
    23,
    18,
    7,
    20,
    19,
    33,
    47,
    27,
    22,
    9,
    3,
    31,
    22,
    41,
    26,
    21,
    20,
    5,
    3,
    14,
    13,
    10,
    11,
    16,
    6,
    5,
    1,
    9,
    8,
    7,
    8,
    4,
    4,
    2,
    0
];
o0.t11HB = [
    3,
    4,
    10,
    24,
    34,
    33,
    21,
    15,
    5,
    3,
    4,
    10,
    32,
    17,
    11,
    10,
    11,
    7,
    13,
    18,
    30,
    31,
    20,
    5,
    25,
    11,
    19,
    59,
    27,
    18,
    12,
    5,
    35,
    33,
    31,
    58,
    30,
    16,
    7,
    5,
    28,
    26,
    32,
    19,
    17,
    15,
    8,
    14,
    14,
    12,
    9,
    13,
    14,
    9,
    4,
    1,
    11,
    4,
    6,
    6,
    6,
    3,
    2,
    0
];
o0.t12HB = [
    9,
    6,
    16,
    33,
    41,
    39,
    38,
    26,
    7,
    5,
    6,
    9,
    23,
    16,
    26,
    11,
    17,
    7,
    11,
    14,
    21,
    30,
    10,
    7,
    17,
    10,
    15,
    12,
    18,
    28,
    14,
    5,
    32,
    13,
    22,
    19,
    18,
    16,
    9,
    5,
    40,
    17,
    31,
    29,
    17,
    13,
    4,
    2,
    27,
    12,
    11,
    15,
    10,
    7,
    4,
    1,
    27,
    12,
    8,
    12,
    6,
    3,
    1,
    0
];
o0.t13HB = [
    1,
    5,
    14,
    21,
    34,
    51,
    46,
    71,
    42,
    52,
    68,
    52,
    67,
    44,
    43,
    19,
    3,
    4,
    12,
    19,
    31,
    26,
    44,
    33,
    31,
    24,
    32,
    24,
    31,
    35,
    22,
    14,
    15,
    13,
    23,
    36,
    59,
    49,
    77,
    65,
    29,
    40,
    30,
    40,
    27,
    33,
    42,
    16,
    22,
    20,
    37,
    61,
    56,
    79,
    73,
    64,
    43,
    76,
    56,
    37,
    26,
    31,
    25,
    14,
    35,
    16,
    60,
    57,
    97,
    75,
    114,
    91,
    54,
    73,
    55,
    41,
    48,
    53,
    23,
    24,
    58,
    27,
    50,
    96,
    76,
    70,
    93,
    84,
    77,
    58,
    79,
    29,
    74,
    49,
    41,
    17,
    47,
    45,
    78,
    74,
    115,
    94,
    90,
    79,
    69,
    83,
    71,
    50,
    59,
    38,
    36,
    15,
    72,
    34,
    56,
    95,
    92,
    85,
    91,
    90,
    86,
    73,
    77,
    65,
    51,
    44,
    43,
    42,
    43,
    20,
    30,
    44,
    55,
    78,
    72,
    87,
    78,
    61,
    46,
    54,
    37,
    30,
    20,
    16,
    53,
    25,
    41,
    37,
    44,
    59,
    54,
    81,
    66,
    76,
    57,
    54,
    37,
    18,
    39,
    11,
    35,
    33,
    31,
    57,
    42,
    82,
    72,
    80,
    47,
    58,
    55,
    21,
    22,
    26,
    38,
    22,
    53,
    25,
    23,
    38,
    70,
    60,
    51,
    36,
    55,
    26,
    34,
    23,
    27,
    14,
    9,
    7,
    34,
    32,
    28,
    39,
    49,
    75,
    30,
    52,
    48,
    40,
    52,
    28,
    18,
    17,
    9,
    5,
    45,
    21,
    34,
    64,
    56,
    50,
    49,
    45,
    31,
    19,
    12,
    15,
    10,
    7,
    6,
    3,
    48,
    23,
    20,
    39,
    36,
    35,
    53,
    21,
    16,
    23,
    13,
    10,
    6,
    1,
    4,
    2,
    16,
    15,
    17,
    27,
    25,
    20,
    29,
    11,
    17,
    12,
    16,
    8,
    1,
    1,
    0,
    1
];
o0.t15HB = [
    7,
    12,
    18,
    53,
    47,
    76,
    124,
    108,
    89,
    123,
    108,
    119,
    107,
    81,
    122,
    63,
    13,
    5,
    16,
    27,
    46,
    36,
    61,
    51,
    42,
    70,
    52,
    83,
    65,
    41,
    59,
    36,
    19,
    17,
    15,
    24,
    41,
    34,
    59,
    48,
    40,
    64,
    50,
    78,
    62,
    80,
    56,
    33,
    29,
    28,
    25,
    43,
    39,
    63,
    55,
    93,
    76,
    59,
    93,
    72,
    54,
    75,
    50,
    29,
    52,
    22,
    42,
    40,
    67,
    57,
    95,
    79,
    72,
    57,
    89,
    69,
    49,
    66,
    46,
    27,
    77,
    37,
    35,
    66,
    58,
    52,
    91,
    74,
    62,
    48,
    79,
    63,
    90,
    62,
    40,
    38,
    125,
    32,
    60,
    56,
    50,
    92,
    78,
    65,
    55,
    87,
    71,
    51,
    73,
    51,
    70,
    30,
    109,
    53,
    49,
    94,
    88,
    75,
    66,
    122,
    91,
    73,
    56,
    42,
    64,
    44,
    21,
    25,
    90,
    43,
    41,
    77,
    73,
    63,
    56,
    92,
    77,
    66,
    47,
    67,
    48,
    53,
    36,
    20,
    71,
    34,
    67,
    60,
    58,
    49,
    88,
    76,
    67,
    106,
    71,
    54,
    38,
    39,
    23,
    15,
    109,
    53,
    51,
    47,
    90,
    82,
    58,
    57,
    48,
    72,
    57,
    41,
    23,
    27,
    62,
    9,
    86,
    42,
    40,
    37,
    70,
    64,
    52,
    43,
    70,
    55,
    42,
    25,
    29,
    18,
    11,
    11,
    118,
    68,
    30,
    55,
    50,
    46,
    74,
    65,
    49,
    39,
    24,
    16,
    22,
    13,
    14,
    7,
    91,
    44,
    39,
    38,
    34,
    63,
    52,
    45,
    31,
    52,
    28,
    19,
    14,
    8,
    9,
    3,
    123,
    60,
    58,
    53,
    47,
    43,
    32,
    22,
    37,
    24,
    17,
    12,
    15,
    10,
    2,
    1,
    71,
    37,
    34,
    30,
    28,
    20,
    17,
    26,
    21,
    16,
    10,
    6,
    8,
    6,
    2,
    0
];
o0.t16HB = [
    1,
    5,
    14,
    44,
    74,
    63,
    110,
    93,
    172,
    149,
    138,
    242,
    225,
    195,
    376,
    17,
    3,
    4,
    12,
    20,
    35,
    62,
    53,
    47,
    83,
    75,
    68,
    119,
    201,
    107,
    207,
    9,
    15,
    13,
    23,
    38,
    67,
    58,
    103,
    90,
    161,
    72,
    127,
    117,
    110,
    209,
    206,
    16,
    45,
    21,
    39,
    69,
    64,
    114,
    99,
    87,
    158,
    140,
    252,
    212,
    199,
    387,
    365,
    26,
    75,
    36,
    68,
    65,
    115,
    101,
    179,
    164,
    155,
    264,
    246,
    226,
    395,
    382,
    362,
    9,
    66,
    30,
    59,
    56,
    102,
    185,
    173,
    265,
    142,
    253,
    232,
    400,
    388,
    378,
    445,
    16,
    111,
    54,
    52,
    100,
    184,
    178,
    160,
    133,
    257,
    244,
    228,
    217,
    385,
    366,
    715,
    10,
    98,
    48,
    91,
    88,
    165,
    157,
    148,
    261,
    248,
    407,
    397,
    372,
    380,
    889,
    884,
    8,
    85,
    84,
    81,
    159,
    156,
    143,
    260,
    249,
    427,
    401,
    392,
    383,
    727,
    713,
    708,
    7,
    154,
    76,
    73,
    141,
    131,
    256,
    245,
    426,
    406,
    394,
    384,
    735,
    359,
    710,
    352,
    11,
    139,
    129,
    67,
    125,
    247,
    233,
    229,
    219,
    393,
    743,
    737,
    720,
    885,
    882,
    439,
    4,
    243,
    120,
    118,
    115,
    227,
    223,
    396,
    746,
    742,
    736,
    721,
    712,
    706,
    223,
    436,
    6,
    202,
    224,
    222,
    218,
    216,
    389,
    386,
    381,
    364,
    888,
    443,
    707,
    440,
    437,
    1728,
    4,
    747,
    211,
    210,
    208,
    370,
    379,
    734,
    723,
    714,
    1735,
    883,
    877,
    876,
    3459,
    865,
    2,
    377,
    369,
    102,
    187,
    726,
    722,
    358,
    711,
    709,
    866,
    1734,
    871,
    3458,
    870,
    434,
    0,
    12,
    10,
    7,
    11,
    10,
    17,
    11,
    9,
    13,
    12,
    10,
    7,
    5,
    3,
    1,
    3
];
o0.t24HB = [
    15,
    13,
    46,
    80,
    146,
    262,
    248,
    434,
    426,
    669,
    653,
    649,
    621,
    517,
    1032,
    88,
    14,
    12,
    21,
    38,
    71,
    130,
    122,
    216,
    209,
    198,
    327,
    345,
    319,
    297,
    279,
    42,
    47,
    22,
    41,
    74,
    68,
    128,
    120,
    221,
    207,
    194,
    182,
    340,
    315,
    295,
    541,
    18,
    81,
    39,
    75,
    70,
    134,
    125,
    116,
    220,
    204,
    190,
    178,
    325,
    311,
    293,
    271,
    16,
    147,
    72,
    69,
    135,
    127,
    118,
    112,
    210,
    200,
    188,
    352,
    323,
    306,
    285,
    540,
    14,
    263,
    66,
    129,
    126,
    119,
    114,
    214,
    202,
    192,
    180,
    341,
    317,
    301,
    281,
    262,
    12,
    249,
    123,
    121,
    117,
    113,
    215,
    206,
    195,
    185,
    347,
    330,
    308,
    291,
    272,
    520,
    10,
    435,
    115,
    111,
    109,
    211,
    203,
    196,
    187,
    353,
    332,
    313,
    298,
    283,
    531,
    381,
    17,
    427,
    212,
    208,
    205,
    201,
    193,
    186,
    177,
    169,
    320,
    303,
    286,
    268,
    514,
    377,
    16,
    335,
    199,
    197,
    191,
    189,
    181,
    174,
    333,
    321,
    305,
    289,
    275,
    521,
    379,
    371,
    11,
    668,
    184,
    183,
    179,
    175,
    344,
    331,
    314,
    304,
    290,
    277,
    530,
    383,
    373,
    366,
    10,
    652,
    346,
    171,
    168,
    164,
    318,
    309,
    299,
    287,
    276,
    263,
    513,
    375,
    368,
    362,
    6,
    648,
    322,
    316,
    312,
    307,
    302,
    292,
    284,
    269,
    261,
    512,
    376,
    370,
    364,
    359,
    4,
    620,
    300,
    296,
    294,
    288,
    282,
    273,
    266,
    515,
    380,
    374,
    369,
    365,
    361,
    357,
    2,
    1033,
    280,
    278,
    274,
    267,
    264,
    259,
    382,
    378,
    372,
    367,
    363,
    360,
    358,
    356,
    0,
    43,
    20,
    19,
    17,
    15,
    13,
    11,
    9,
    7,
    6,
    4,
    7,
    5,
    3,
    1,
    3
];
o0.t32HB = [
    1,
    10,
    8,
    20,
    12,
    20,
    16,
    32,
    14,
    12,
    24,
    0,
    28,
    16,
    24,
    16
];
o0.t33HB = [
    15,
    28,
    26,
    48,
    22,
    40,
    36,
    64,
    14,
    24,
    20,
    32,
    12,
    16,
    8,
    0
];
o0.t1l = [
    1,
    4,
    3,
    5
];
o0.t2l = [
    1,
    4,
    7,
    4,
    5,
    7,
    6,
    7,
    8
];
o0.t3l = [
    2,
    3,
    7,
    4,
    4,
    7,
    6,
    7,
    8
];
o0.t5l = [
    1,
    4,
    7,
    8,
    4,
    5,
    8,
    9,
    7,
    8,
    9,
    10,
    8,
    8,
    9,
    10
];
o0.t6l = [
    3,
    4,
    6,
    8,
    4,
    4,
    6,
    7,
    5,
    6,
    7,
    8,
    7,
    7,
    8,
    9
];
o0.t7l = [
    1,
    4,
    7,
    9,
    9,
    10,
    4,
    6,
    8,
    9,
    9,
    10,
    7,
    7,
    9,
    10,
    10,
    11,
    8,
    9,
    10,
    11,
    11,
    11,
    8,
    9,
    10,
    11,
    11,
    12,
    9,
    10,
    11,
    12,
    12,
    12
];
o0.t8l = [
    2,
    4,
    7,
    9,
    9,
    10,
    4,
    4,
    6,
    10,
    10,
    10,
    7,
    6,
    8,
    10,
    10,
    11,
    9,
    10,
    10,
    11,
    11,
    12,
    9,
    9,
    10,
    11,
    12,
    12,
    10,
    10,
    11,
    11,
    13,
    13
];
o0.t9l = [
    3,
    4,
    6,
    7,
    9,
    10,
    4,
    5,
    6,
    7,
    8,
    10,
    5,
    6,
    7,
    8,
    9,
    10,
    7,
    7,
    8,
    9,
    9,
    10,
    8,
    8,
    9,
    9,
    10,
    11,
    9,
    9,
    10,
    10,
    11,
    11
];
o0.t10l = [
    1,
    4,
    7,
    9,
    10,
    10,
    10,
    11,
    4,
    6,
    8,
    9,
    10,
    11,
    10,
    10,
    7,
    8,
    9,
    10,
    11,
    12,
    11,
    11,
    8,
    9,
    10,
    11,
    12,
    12,
    11,
    12,
    9,
    10,
    11,
    12,
    12,
    12,
    12,
    12,
    10,
    11,
    12,
    12,
    13,
    13,
    12,
    13,
    9,
    10,
    11,
    12,
    12,
    12,
    13,
    13,
    10,
    10,
    11,
    12,
    12,
    13,
    13,
    13
];
o0.t11l = [
    2,
    4,
    6,
    8,
    9,
    10,
    9,
    10,
    4,
    5,
    6,
    8,
    10,
    10,
    9,
    10,
    6,
    7,
    8,
    9,
    10,
    11,
    10,
    10,
    8,
    8,
    9,
    11,
    10,
    12,
    10,
    11,
    9,
    10,
    10,
    11,
    11,
    12,
    11,
    12,
    9,
    10,
    11,
    12,
    12,
    13,
    12,
    13,
    9,
    9,
    9,
    10,
    11,
    12,
    12,
    12,
    9,
    9,
    10,
    11,
    12,
    12,
    12,
    12
];
o0.t12l = [
    4,
    4,
    6,
    8,
    9,
    10,
    10,
    10,
    4,
    5,
    6,
    7,
    9,
    9,
    10,
    10,
    6,
    6,
    7,
    8,
    9,
    10,
    9,
    10,
    7,
    7,
    8,
    8,
    9,
    10,
    10,
    10,
    8,
    8,
    9,
    9,
    10,
    10,
    10,
    11,
    9,
    9,
    10,
    10,
    10,
    11,
    10,
    11,
    9,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12
];
o0.t13l = [
    1,
    5,
    7,
    8,
    9,
    10,
    10,
    11,
    10,
    11,
    12,
    12,
    13,
    13,
    14,
    14,
    4,
    6,
    8,
    9,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    13,
    14,
    14,
    14,
    7,
    8,
    9,
    10,
    11,
    11,
    12,
    12,
    11,
    12,
    12,
    13,
    13,
    14,
    15,
    15,
    8,
    9,
    10,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    15,
    15,
    9,
    9,
    11,
    11,
    12,
    12,
    13,
    13,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    16,
    10,
    10,
    11,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    13,
    15,
    15,
    16,
    16,
    10,
    11,
    12,
    12,
    13,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    15,
    15,
    16,
    16,
    11,
    11,
    12,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    16,
    18,
    18,
    10,
    10,
    11,
    12,
    12,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    16,
    17,
    17,
    11,
    11,
    12,
    12,
    13,
    13,
    13,
    15,
    14,
    15,
    15,
    16,
    16,
    16,
    18,
    17,
    11,
    12,
    12,
    13,
    13,
    14,
    14,
    15,
    14,
    15,
    16,
    15,
    16,
    17,
    18,
    19,
    12,
    12,
    12,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    16,
    17,
    17,
    17,
    18,
    12,
    13,
    13,
    14,
    14,
    15,
    14,
    15,
    16,
    16,
    17,
    17,
    17,
    18,
    18,
    18,
    13,
    13,
    14,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    16,
    17,
    18,
    17,
    18,
    18,
    14,
    14,
    14,
    15,
    15,
    15,
    17,
    16,
    16,
    19,
    17,
    17,
    17,
    19,
    18,
    18,
    13,
    14,
    15,
    16,
    16,
    16,
    17,
    16,
    17,
    17,
    18,
    18,
    21,
    20,
    21,
    18
];
o0.t15l = [
    3,
    5,
    6,
    8,
    8,
    9,
    10,
    10,
    10,
    11,
    11,
    12,
    12,
    12,
    13,
    14,
    5,
    5,
    7,
    8,
    9,
    9,
    10,
    10,
    10,
    11,
    11,
    12,
    12,
    12,
    13,
    13,
    6,
    7,
    7,
    8,
    9,
    9,
    10,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    13,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    11,
    12,
    12,
    12,
    13,
    13,
    13,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    13,
    13,
    13,
    9,
    9,
    9,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    13,
    13,
    13,
    14,
    10,
    9,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    13,
    13,
    14,
    14,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    14,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    14,
    14,
    14,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    15,
    14,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    15,
    12,
    12,
    11,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    13,
    13,
    14,
    14,
    15,
    15,
    12,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    14,
    15,
    15,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    14,
    15,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15
];
o0.t16_5l = [
    1,
    5,
    7,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    12,
    13,
    13,
    13,
    14,
    11,
    4,
    6,
    8,
    9,
    10,
    11,
    11,
    11,
    12,
    12,
    12,
    13,
    14,
    13,
    14,
    11,
    7,
    8,
    9,
    10,
    11,
    11,
    12,
    12,
    13,
    12,
    13,
    13,
    13,
    14,
    14,
    12,
    9,
    9,
    10,
    11,
    11,
    12,
    12,
    12,
    13,
    13,
    14,
    14,
    14,
    15,
    15,
    13,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    13,
    14,
    14,
    14,
    15,
    15,
    15,
    12,
    10,
    10,
    11,
    11,
    12,
    13,
    13,
    14,
    13,
    14,
    14,
    15,
    15,
    15,
    16,
    13,
    11,
    11,
    11,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    16,
    13,
    11,
    11,
    12,
    12,
    13,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    17,
    17,
    13,
    11,
    12,
    12,
    13,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    13,
    12,
    12,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    15,
    16,
    15,
    14,
    12,
    13,
    12,
    13,
    14,
    14,
    14,
    14,
    15,
    16,
    16,
    16,
    17,
    17,
    16,
    13,
    13,
    13,
    13,
    13,
    14,
    14,
    15,
    16,
    16,
    16,
    16,
    16,
    16,
    15,
    16,
    14,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15,
    17,
    16,
    16,
    16,
    16,
    18,
    14,
    15,
    14,
    14,
    14,
    15,
    15,
    16,
    16,
    16,
    18,
    17,
    17,
    17,
    19,
    17,
    14,
    14,
    15,
    13,
    14,
    16,
    16,
    15,
    16,
    16,
    17,
    18,
    17,
    19,
    17,
    16,
    14,
    11,
    11,
    11,
    12,
    12,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    14,
    14,
    14,
    12
];
o0.t16l = [
    1,
    5,
    7,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    12,
    13,
    13,
    13,
    14,
    10,
    4,
    6,
    8,
    9,
    10,
    11,
    11,
    11,
    12,
    12,
    12,
    13,
    14,
    13,
    14,
    10,
    7,
    8,
    9,
    10,
    11,
    11,
    12,
    12,
    13,
    12,
    13,
    13,
    13,
    14,
    14,
    11,
    9,
    9,
    10,
    11,
    11,
    12,
    12,
    12,
    13,
    13,
    14,
    14,
    14,
    15,
    15,
    12,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13,
    13,
    14,
    14,
    14,
    15,
    15,
    15,
    11,
    10,
    10,
    11,
    11,
    12,
    13,
    13,
    14,
    13,
    14,
    14,
    15,
    15,
    15,
    16,
    12,
    11,
    11,
    11,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    16,
    12,
    11,
    11,
    12,
    12,
    13,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    17,
    17,
    12,
    11,
    12,
    12,
    13,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    12,
    12,
    12,
    12,
    13,
    13,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    15,
    16,
    15,
    13,
    12,
    13,
    12,
    13,
    14,
    14,
    14,
    14,
    15,
    16,
    16,
    16,
    17,
    17,
    16,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    15,
    16,
    16,
    16,
    16,
    16,
    16,
    15,
    16,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15,
    17,
    16,
    16,
    16,
    16,
    18,
    13,
    15,
    14,
    14,
    14,
    15,
    15,
    16,
    16,
    16,
    18,
    17,
    17,
    17,
    19,
    17,
    13,
    14,
    15,
    13,
    14,
    16,
    16,
    15,
    16,
    16,
    17,
    18,
    17,
    19,
    17,
    16,
    13,
    10,
    10,
    10,
    11,
    11,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    10
];
o0.t24l = [
    4,
    5,
    7,
    8,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    12,
    12,
    12,
    13,
    10,
    5,
    6,
    7,
    8,
    9,
    10,
    10,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    12,
    10,
    7,
    7,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    13,
    9,
    8,
    8,
    9,
    9,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    9,
    9,
    9,
    9,
    10,
    10,
    10,
    10,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    9,
    10,
    9,
    10,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    12,
    9,
    10,
    10,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    12,
    13,
    9,
    11,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    12,
    13,
    13,
    10,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    10,
    11,
    11,
    11,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    10,
    12,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    10,
    12,
    12,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    10,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    13,
    10,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    10,
    13,
    12,
    12,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    13,
    10,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    9,
    10,
    10,
    10,
    10,
    6
];
o0.t32l = [
    1,
    5,
    5,
    7,
    5,
    8,
    7,
    9,
    5,
    7,
    7,
    9,
    7,
    9,
    9,
    10
];
o0.t33l = [
    4,
    5,
    5,
    6,
    5,
    6,
    6,
    7,
    5,
    6,
    6,
    7,
    6,
    7,
    7,
    8
];
o0.ht = [
    /* xlen, linmax, table, hlen */ new q0(0, 0, null, null),
    new q0(2, 0, o0.t1HB, o0.t1l),
    new q0(3, 0, o0.t2HB, o0.t2l),
    new q0(3, 0, o0.t3HB, o0.t3l),
    new q0(0, 0, null, null),
    /* Apparently not used */ new q0(4, 0, o0.t5HB, o0.t5l),
    new q0(4, 0, o0.t6HB, o0.t6l),
    new q0(6, 0, o0.t7HB, o0.t7l),
    new q0(6, 0, o0.t8HB, o0.t8l),
    new q0(6, 0, o0.t9HB, o0.t9l),
    new q0(8, 0, o0.t10HB, o0.t10l),
    new q0(8, 0, o0.t11HB, o0.t11l),
    new q0(8, 0, o0.t12HB, o0.t12l),
    new q0(16, 0, o0.t13HB, o0.t13l),
    new q0(0, 0, null, o0.t16_5l),
    /* Apparently not used */ new q0(16, 0, o0.t15HB, o0.t15l),
    new q0(1, 1, o0.t16HB, o0.t16l),
    new q0(2, 3, o0.t16HB, o0.t16l),
    new q0(3, 7, o0.t16HB, o0.t16l),
    new q0(4, 15, o0.t16HB, o0.t16l),
    new q0(6, 63, o0.t16HB, o0.t16l),
    new q0(8, 255, o0.t16HB, o0.t16l),
    new q0(10, 1023, o0.t16HB, o0.t16l),
    new q0(13, 8191, o0.t16HB, o0.t16l),
    new q0(4, 15, o0.t24HB, o0.t24l),
    new q0(5, 31, o0.t24HB, o0.t24l),
    new q0(6, 63, o0.t24HB, o0.t24l),
    new q0(7, 127, o0.t24HB, o0.t24l),
    new q0(8, 255, o0.t24HB, o0.t24l),
    new q0(9, 511, o0.t24HB, o0.t24l),
    new q0(11, 2047, o0.t24HB, o0.t24l),
    new q0(13, 8191, o0.t24HB, o0.t24l),
    new q0(0, 0, o0.t32HB, o0.t32l),
    new q0(0, 0, o0.t33HB, o0.t33l)
];
o0.largetbl = [
    65540,
    327685,
    458759,
    589832,
    655369,
    655370,
    720906,
    720907,
    786443,
    786444,
    786444,
    851980,
    851980,
    851980,
    917517,
    655370,
    262149,
    393222,
    524295,
    589832,
    655369,
    720906,
    720906,
    720907,
    786443,
    786443,
    786444,
    851980,
    917516,
    851980,
    917516,
    655370,
    458759,
    524295,
    589832,
    655369,
    720905,
    720906,
    786442,
    786443,
    851979,
    786443,
    851979,
    851980,
    851980,
    917516,
    917517,
    720905,
    589832,
    589832,
    655369,
    720905,
    720906,
    786442,
    786442,
    786443,
    851979,
    851979,
    917515,
    917516,
    917516,
    983052,
    983052,
    786441,
    655369,
    655369,
    720905,
    720906,
    786442,
    786442,
    851978,
    851979,
    851979,
    917515,
    917516,
    917516,
    983052,
    983052,
    983053,
    720905,
    655370,
    655369,
    720906,
    720906,
    786442,
    851978,
    851979,
    917515,
    851979,
    917515,
    917516,
    983052,
    983052,
    983052,
    1048588,
    786441,
    720906,
    720906,
    720906,
    786442,
    851978,
    851979,
    851979,
    851979,
    917515,
    917516,
    917516,
    917516,
    983052,
    983052,
    1048589,
    786441,
    720907,
    720906,
    786442,
    786442,
    851979,
    851979,
    851979,
    917515,
    917516,
    983052,
    983052,
    983052,
    983052,
    1114125,
    1114125,
    786442,
    720907,
    786443,
    786443,
    851979,
    851979,
    851979,
    917515,
    917515,
    983051,
    983052,
    983052,
    983052,
    1048588,
    1048589,
    1048589,
    786442,
    786443,
    786443,
    786443,
    851979,
    851979,
    917515,
    917515,
    983052,
    983052,
    983052,
    983052,
    1048588,
    983053,
    1048589,
    983053,
    851978,
    786444,
    851979,
    786443,
    851979,
    917515,
    917516,
    917516,
    917516,
    983052,
    1048588,
    1048588,
    1048589,
    1114125,
    1114125,
    1048589,
    786442,
    851980,
    851980,
    851979,
    851979,
    917515,
    917516,
    983052,
    1048588,
    1048588,
    1048588,
    1048588,
    1048589,
    1048589,
    983053,
    1048589,
    851978,
    851980,
    917516,
    917516,
    917516,
    917516,
    983052,
    983052,
    983052,
    983052,
    1114124,
    1048589,
    1048589,
    1048589,
    1048589,
    1179661,
    851978,
    983052,
    917516,
    917516,
    917516,
    983052,
    983052,
    1048588,
    1048588,
    1048589,
    1179661,
    1114125,
    1114125,
    1114125,
    1245197,
    1114125,
    851978,
    917517,
    983052,
    851980,
    917516,
    1048588,
    1048588,
    983052,
    1048589,
    1048589,
    1114125,
    1179661,
    1114125,
    1245197,
    1114125,
    1048589,
    851978,
    655369,
    655369,
    655369,
    720905,
    720905,
    786441,
    786441,
    786441,
    851977,
    851977,
    851977,
    851978,
    851978,
    851978,
    851978,
    655366
];
o0.table23 = [
    65538,
    262147,
    458759,
    262148,
    327684,
    458759,
    393222,
    458759,
    524296
];
o0.table56 = [
    65539,
    262148,
    458758,
    524296,
    262148,
    327684,
    524294,
    589831,
    458757,
    524294,
    589831,
    655368,
    524295,
    524295,
    589832,
    655369
];
o0.bitrate_table = [
    [
        0,
        8,
        16,
        24,
        32,
        40,
        48,
        56,
        64,
        80,
        96,
        112,
        128,
        144,
        160,
        -1
    ],
    /* MPEG 2 */ [
        0,
        32,
        40,
        48,
        56,
        64,
        80,
        96,
        112,
        128,
        160,
        192,
        224,
        256,
        320,
        -1
    ],
    /* MPEG 1 */ [
        0,
        8,
        16,
        24,
        32,
        40,
        48,
        56,
        64,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1,
        -1
    ]
];
o0.samplerate_table = [
    [
        22050,
        24e3,
        16e3,
        -1
    ],
    [
        44100,
        48e3,
        32e3,
        -1
    ],
    [
        11025,
        12e3,
        8e3,
        -1
    ]
];
o0.scfsi_band = [
    0,
    6,
    11,
    16,
    21
];
var He = o0, Me, ra;
function Va() {
    if (ra) return Me;
    ra = 1;
    var w = Ia, Z = Q0, X = Z.VbrMode, z = Z.Float, u0 = Z.Util, W = Z.new_float, Q = Z.new_int, D = Z.assert, g = t1(), f0 = Ha, A = ne;
    m.Q_MAX = 257, m.Q_MAX2 = 116, m.LARGE_BITS = 1e5, m.IXMAX_VAL = 8206;
    function m() {
        var O = Ve(), s0 = null, K = null, t0 = null;
        this.setModules = function(S, L, V) {
            s0 = S, K = L, t0 = V;
        };
        function U(S) {
            return D(0 <= S + m.Q_MAX2 && S < m.Q_MAX), p[S + m.Q_MAX2];
        }
        this.IPOW20 = function(S) {
            return D(0 <= S && S < m.Q_MAX), H[S];
        };
        var R = 2220446049250313e-31, o = m.IXMAX_VAL, u = o + 2, d = m.Q_MAX, e = m.Q_MAX2;
        m.LARGE_BITS;
        var l = 100;
        this.nr_of_sfb_block = [
            [
                [
                    6,
                    5,
                    5,
                    5
                ],
                [
                    9,
                    9,
                    9,
                    9
                ],
                [
                    6,
                    9,
                    9,
                    9
                ]
            ],
            [
                [
                    6,
                    5,
                    7,
                    3
                ],
                [
                    9,
                    9,
                    12,
                    6
                ],
                [
                    6,
                    9,
                    12,
                    6
                ]
            ],
            [
                [
                    11,
                    10,
                    0,
                    0
                ],
                [
                    18,
                    18,
                    0,
                    0
                ],
                [
                    15,
                    18,
                    0,
                    0
                ]
            ],
            [
                [
                    7,
                    7,
                    7,
                    0
                ],
                [
                    12,
                    12,
                    12,
                    0
                ],
                [
                    6,
                    15,
                    12,
                    0
                ]
            ],
            [
                [
                    6,
                    6,
                    6,
                    3
                ],
                [
                    12,
                    9,
                    9,
                    6
                ],
                [
                    6,
                    12,
                    9,
                    6
                ]
            ],
            [
                [
                    8,
                    8,
                    5,
                    0
                ],
                [
                    15,
                    12,
                    9,
                    0
                ],
                [
                    6,
                    18,
                    9,
                    0
                ]
            ]
        ];
        var M = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            3,
            3,
            3,
            2,
            0
        ];
        this.pretab = M, this.sfBandIndex = [
            // Table B.2.b: 22.05 kHz
            new w([
                0,
                6,
                12,
                18,
                24,
                30,
                36,
                44,
                54,
                66,
                80,
                96,
                116,
                140,
                168,
                200,
                238,
                284,
                336,
                396,
                464,
                522,
                576
            ], [
                0,
                4,
                8,
                12,
                18,
                24,
                32,
                42,
                56,
                74,
                100,
                132,
                174,
                192
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]),
            /* Table B.2.c: 24 kHz */ /* docs: 332. mpg123(broken): 330 */ new w([
                0,
                6,
                12,
                18,
                24,
                30,
                36,
                44,
                54,
                66,
                80,
                96,
                114,
                136,
                162,
                194,
                232,
                278,
                332,
                394,
                464,
                540,
                576
            ], [
                0,
                4,
                8,
                12,
                18,
                26,
                36,
                48,
                62,
                80,
                104,
                136,
                180,
                192
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]),
            /* Table B.2.a: 16 kHz */ new w([
                0,
                6,
                12,
                18,
                24,
                30,
                36,
                44,
                54,
                66,
                80,
                96,
                116,
                140,
                168,
                200,
                238,
                284,
                336,
                396,
                464,
                522,
                576
            ], [
                0,
                4,
                8,
                12,
                18,
                26,
                36,
                48,
                62,
                80,
                104,
                134,
                174,
                192
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]),
            /* Table B.8.b: 44.1 kHz */ new w([
                0,
                4,
                8,
                12,
                16,
                20,
                24,
                30,
                36,
                44,
                52,
                62,
                74,
                90,
                110,
                134,
                162,
                196,
                238,
                288,
                342,
                418,
                576
            ], [
                0,
                4,
                8,
                12,
                16,
                22,
                30,
                40,
                52,
                66,
                84,
                106,
                136,
                192
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]),
            /* Table B.8.c: 48 kHz */ new w([
                0,
                4,
                8,
                12,
                16,
                20,
                24,
                30,
                36,
                42,
                50,
                60,
                72,
                88,
                106,
                128,
                156,
                190,
                230,
                276,
                330,
                384,
                576
            ], [
                0,
                4,
                8,
                12,
                16,
                22,
                28,
                38,
                50,
                64,
                80,
                100,
                126,
                192
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]),
            /* Table B.8.a: 32 kHz */ new w([
                0,
                4,
                8,
                12,
                16,
                20,
                24,
                30,
                36,
                44,
                54,
                66,
                82,
                102,
                126,
                156,
                194,
                240,
                296,
                364,
                448,
                550,
                576
            ], [
                0,
                4,
                8,
                12,
                16,
                22,
                30,
                42,
                58,
                78,
                104,
                138,
                180,
                192
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]),
            /* MPEG-2.5 11.025 kHz */ new w([
                0,
                6,
                12,
                18,
                24,
                30,
                36,
                44,
                54,
                66,
                80,
                96,
                116,
                140,
                168,
                200,
                238,
                284,
                336,
                396,
                464,
                522,
                576
            ], [
                0,
                4,
                8,
                12,
                18,
                26,
                36,
                48,
                62,
                80,
                104,
                134,
                174,
                192
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]),
            /* MPEG-2.5 12 kHz */ new w([
                0,
                6,
                12,
                18,
                24,
                30,
                36,
                44,
                54,
                66,
                80,
                96,
                116,
                140,
                168,
                200,
                238,
                284,
                336,
                396,
                464,
                522,
                576
            ], [
                0,
                4,
                8,
                12,
                18,
                26,
                36,
                48,
                62,
                80,
                104,
                134,
                174,
                192
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ]),
            /* MPEG-2.5 8 kHz */ new w([
                0,
                12,
                24,
                36,
                48,
                60,
                72,
                88,
                108,
                132,
                160,
                192,
                232,
                280,
                336,
                400,
                476,
                566,
                568,
                570,
                572,
                574,
                576
            ], [
                0,
                8,
                16,
                24,
                36,
                52,
                72,
                96,
                124,
                160,
                162,
                164,
                166,
                192
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ], [
                0,
                0,
                0,
                0,
                0,
                0,
                0
            ])
        ];
        var p = W(d + e + 1), H = W(d), B = W(u), I = W(u);
        this.adj43 = I;
        function v0(S, L) {
            var V = t0.ATHformula(L, S);
            return V -= l, V = Math.pow(10, V / 10 + S.ATHlower), V;
        }
        function b(S) {
            for(var L = S.internal_flags.ATH.l, V = S.internal_flags.ATH.psfb21, N = S.internal_flags.ATH.s, P = S.internal_flags.ATH.psfb12, E = S.internal_flags, i = S.out_samplerate, s = 0; s < g.SBMAX_l; s++){
                var r = E.scalefac_band.l[s], n = E.scalefac_band.l[s + 1];
                L[s] = z.MAX_VALUE;
                for(var f = r; f < n; f++){
                    var Y = f * i / 1152, J = v0(S, Y);
                    L[s] = Math.min(L[s], J);
                }
            }
            for(var s = 0; s < g.PSFB21; s++){
                var r = E.scalefac_band.psfb21[s], n = E.scalefac_band.psfb21[s + 1];
                V[s] = z.MAX_VALUE;
                for(var f = r; f < n; f++){
                    var Y = f * i / 1152, J = v0(S, Y);
                    V[s] = Math.min(V[s], J);
                }
            }
            for(var s = 0; s < g.SBMAX_s; s++){
                var r = E.scalefac_band.s[s], n = E.scalefac_band.s[s + 1];
                N[s] = z.MAX_VALUE;
                for(var f = r; f < n; f++){
                    var Y = f * i / 384, J = v0(S, Y);
                    N[s] = Math.min(N[s], J);
                }
                N[s] *= E.scalefac_band.s[s + 1] - E.scalefac_band.s[s];
            }
            for(var s = 0; s < g.PSFB12; s++){
                var r = E.scalefac_band.psfb12[s], n = E.scalefac_band.psfb12[s + 1];
                P[s] = z.MAX_VALUE;
                for(var f = r; f < n; f++){
                    var Y = f * i / 384, J = v0(S, Y);
                    P[s] = Math.min(P[s], J);
                }
                P[s] *= E.scalefac_band.s[13] - E.scalefac_band.s[12];
            }
            if (S.noATH) {
                for(var s = 0; s < g.SBMAX_l; s++)L[s] = 1e-20;
                for(var s = 0; s < g.PSFB21; s++)V[s] = 1e-20;
                for(var s = 0; s < g.SBMAX_s; s++)N[s] = 1e-20;
                for(var s = 0; s < g.PSFB12; s++)P[s] = 1e-20;
            }
            E.ATH.floor = 10 * Math.log10(v0(S, -1));
        }
        this.iteration_init = function(S) {
            var L = S.internal_flags, V = L.l3_side, N;
            if (L.iteration_init_init == 0) {
                for(L.iteration_init_init = 1, V.main_data_begin = 0, b(S), B[0] = 0, N = 1; N < u; N++)B[N] = Math.pow(N, 4 / 3);
                for(N = 0; N < u - 1; N++)I[N] = N + 1 - Math.pow(0.5 * (B[N] + B[N + 1]), 0.75);
                for(I[N] = 0.5, N = 0; N < d; N++)H[N] = Math.pow(2, (N - 210) * -0.1875);
                for(N = 0; N <= d + e; N++)p[N] = Math.pow(2, (N - 210 - e) * 0.25);
                s0.huffman_init(L);
                var P, E, i, s;
                for(N = S.exp_nspsytune >> 2 & 63, N >= 32 && (N -= 64), P = Math.pow(10, N / 4 / 10), N = S.exp_nspsytune >> 8 & 63, N >= 32 && (N -= 64), E = Math.pow(10, N / 4 / 10), N = S.exp_nspsytune >> 14 & 63, N >= 32 && (N -= 64), i = Math.pow(10, N / 4 / 10), N = S.exp_nspsytune >> 20 & 63, N >= 32 && (N -= 64), s = i * Math.pow(10, N / 4 / 10), N = 0; N < g.SBMAX_l; N++){
                    var r;
                    N <= 6 ? r = P : N <= 13 ? r = E : N <= 20 ? r = i : r = s, L.nsPsy.longfact[N] = r;
                }
                for(N = 0; N < g.SBMAX_s; N++){
                    var r;
                    N <= 5 ? r = P : N <= 10 ? r = E : N <= 11 ? r = i : r = s, L.nsPsy.shortfact[N] = r;
                }
            }
        }, this.on_pe = function(S, L, V, N, P, E) {
            var i = S.internal_flags, s = 0, r, n = Q(2), f, Y = new f0(s), J = K.ResvMaxBits(S, N, Y, E);
            s = Y.bits;
            var T = s + J;
            for(T > A.MAX_BITS_PER_GRANULE && (T = A.MAX_BITS_PER_GRANULE), r = 0, f = 0; f < i.channels_out; ++f)V[f] = Math.min(A.MAX_BITS_PER_CHANNEL, s / i.channels_out), n[f] = 0 | V[f] * L[P][f] / 700 - V[f], n[f] > N * 3 / 4 && (n[f] = N * 3 / 4), n[f] < 0 && (n[f] = 0), n[f] + V[f] > A.MAX_BITS_PER_CHANNEL && (n[f] = Math.max(0, A.MAX_BITS_PER_CHANNEL - V[f])), r += n[f];
            if (r > J) for(f = 0; f < i.channels_out; ++f)n[f] = J * n[f] / r;
            for(f = 0; f < i.channels_out; ++f)V[f] += n[f], J -= n[f];
            for(r = 0, f = 0; f < i.channels_out; ++f)r += V[f];
            if (r > A.MAX_BITS_PER_GRANULE) {
                var q = 0;
                for(f = 0; f < i.channels_out; ++f)V[f] *= A.MAX_BITS_PER_GRANULE, V[f] /= r, q += V[f];
            }
            return T;
        }, this.reduce_side = function(S, L, V, N) {
            D(S[0] + S[1] <= A.MAX_BITS_PER_GRANULE);
            var P = 0.33 * (0.5 - L) / 0.5;
            P < 0 && (P = 0), P > 0.5 && (P = 0.5);
            var E = 0 | P * 0.5 * (S[0] + S[1]);
            E > A.MAX_BITS_PER_CHANNEL - S[0] && (E = A.MAX_BITS_PER_CHANNEL - S[0]), E < 0 && (E = 0), S[1] >= 125 && (S[1] - E > 125 ? (S[0] < V && (S[0] += E), S[1] -= E) : (S[0] += S[1] - 125, S[1] = 125)), E = S[0] + S[1], E > N && (S[0] = N * S[0] / E, S[1] = N * S[1] / E), D(S[0] <= A.MAX_BITS_PER_CHANNEL), D(S[1] <= A.MAX_BITS_PER_CHANNEL), D(S[0] + S[1] <= A.MAX_BITS_PER_GRANULE);
        }, this.athAdjust = function(S, L, V) {
            var N = 90.30873362, P = 94.82444863, E = u0.FAST_LOG10_X(L, 10), i = S * S, s = 0;
            return E -= V, i > 1e-20 && (s = 1 + u0.FAST_LOG10_X(i, 10 / N)), s < 0 && (s = 0), E *= s, E += V + N - P, Math.pow(10, 0.1 * E);
        }, this.calc_xmin = function(S, L, V, N) {
            var P = 0, E = S.internal_flags, i, s = 0, r = 0, n = E.ATH, f = V.xr, Y = S.VBR == X.vbr_mtrh ? 1 : 0, J = E.masking_lower;
            for((S.VBR == X.vbr_mtrh || S.VBR == X.vbr_mt) && (J = 1), i = 0; i < V.psy_lmax; i++){
                var T, q, i0, h0, d0, M0;
                S.VBR == X.vbr_rh || S.VBR == X.vbr_mtrh ? q = athAdjust(n.adjust, n.l[i], n.floor) : q = n.adjust * n.l[i], d0 = V.width[i], i0 = q / d0, h0 = R, M0 = d0 >> 1, T = 0;
                do {
                    var R0, A0;
                    R0 = f[s] * f[s], T += R0, h0 += R0 < i0 ? R0 : i0, s++, A0 = f[s] * f[s], T += A0, h0 += A0 < i0 ? A0 : i0, s++;
                }while (--M0 > 0);
                if (T > q && r++, i == g.SBPSY_l) {
                    var w0 = q * E.nsPsy.longfact[i];
                    h0 < w0 && (h0 = w0);
                }
                if (Y != 0 && (q = h0), !S.ATHonly) {
                    var $0 = L.en.l[i];
                    if ($0 > 0) {
                        var w0;
                        w0 = T * L.thm.l[i] * J / $0, Y != 0 && (w0 *= E.nsPsy.longfact[i]), q < w0 && (q = w0);
                    }
                }
                Y != 0 ? N[P++] = q : N[P++] = q * E.nsPsy.longfact[i];
            }
            var f1 = 575;
            if (V.block_type != g.SHORT_TYPE) for(var t = 576; t-- != 0 && O.EQ(f[t], 0);)f1 = t;
            V.max_nonzero_coeff = f1;
            for(var _ = V.sfb_smin; i < V.psymax; _++, i += 3){
                var d0, S0, E0;
                for(S.VBR == X.vbr_rh || S.VBR == X.vbr_mtrh ? E0 = athAdjust(n.adjust, n.s[_], n.floor) : E0 = n.adjust * n.s[_], d0 = V.width[i], S0 = 0; S0 < 3; S0++){
                    var T = 0, q, i0, h0, M0 = d0 >> 1;
                    i0 = E0 / d0, h0 = R;
                    do {
                        var R0, A0;
                        R0 = f[s] * f[s], T += R0, h0 += R0 < i0 ? R0 : i0, s++, A0 = f[s] * f[s], T += A0, h0 += A0 < i0 ? A0 : i0, s++;
                    }while (--M0 > 0);
                    if (T > E0 && r++, _ == g.SBPSY_s) {
                        var w0 = E0 * E.nsPsy.shortfact[_];
                        h0 < w0 && (h0 = w0);
                    }
                    if (Y != 0 ? q = h0 : q = E0, !S.ATHonly && !S.ATHshort) {
                        var $0 = L.en.s[_][S0];
                        if ($0 > 0) {
                            var w0;
                            w0 = T * L.thm.s[_][S0] * J / $0, Y != 0 && (w0 *= E.nsPsy.shortfact[_]), q < w0 && (q = w0);
                        }
                    }
                    Y != 0 ? N[P++] = q : N[P++] = q * E.nsPsy.shortfact[_];
                }
                S.useTemporal && (N[P - 3] > N[P - 3 + 1] && (N[P - 3 + 1] += (N[P - 3] - N[P - 3 + 1]) * E.decay), N[P - 3 + 1] > N[P - 3 + 2] && (N[P - 3 + 2] += (N[P - 3 + 1] - N[P - 3 + 2]) * E.decay));
            }
            return r;
        };
        function a(S) {
            this.s = S;
        }
        this.calc_noise_core = function(S, L, V, N) {
            var P = 0, E = L.s, i = S.l3_enc;
            if (E > S.count1) for(; V-- != 0;){
                var s;
                s = S.xr[E], E++, P += s * s, s = S.xr[E], E++, P += s * s;
            }
            else if (E > S.big_values) {
                var r = W(2);
                for(r[0] = 0, r[1] = N; V-- != 0;){
                    var s;
                    s = Math.abs(S.xr[E]) - r[i[E]], E++, P += s * s, s = Math.abs(S.xr[E]) - r[i[E]], E++, P += s * s;
                }
            } else for(; V-- != 0;){
                var s;
                s = Math.abs(S.xr[E]) - B[i[E]] * N, E++, P += s * s, s = Math.abs(S.xr[E]) - B[i[E]] * N, E++, P += s * s;
            }
            return L.s = E, P;
        }, this.calc_noise = function(S, L, V, N, P) {
            var E = 0, i = 0, s, r, n = 0, f = 0, Y = 0, J = -20, T = 0, q = S.scalefac, i0 = 0;
            for(N.over_SSD = 0, s = 0; s < S.psymax; s++){
                var h0 = S.global_gain - (q[i0++] + (S.preflag != 0 ? M[s] : 0) << S.scalefac_scale + 1) - S.subblock_gain[S.window[s]] * 8, d0 = 0;
                if (P != null && P.step[s] == h0) d0 = P.noise[s], T += S.width[s], V[E++] = d0 / L[i++], d0 = P.noise_log[s];
                else {
                    var M0 = U(h0);
                    if (r = S.width[s] >> 1, T + S.width[s] > S.max_nonzero_coeff) {
                        var R0;
                        R0 = S.max_nonzero_coeff - T + 1, R0 > 0 ? r = R0 >> 1 : r = 0;
                    }
                    var A0 = new a(T);
                    d0 = this.calc_noise_core(S, A0, r, M0), T = A0.s, P != null && (P.step[s] = h0, P.noise[s] = d0), d0 = V[E++] = d0 / L[i++], d0 = u0.FAST_LOG10(Math.max(d0, 1e-20)), P != null && (P.noise_log[s] = d0);
                }
                if (P != null && (P.global_gain = S.global_gain), Y += d0, d0 > 0) {
                    var w0;
                    w0 = Math.max(0 | d0 * 10 + 0.5, 1), N.over_SSD += w0 * w0, n++, f += d0;
                }
                J = Math.max(J, d0);
            }
            return N.over_count = n, N.tot_noise = Y, N.over_noise = f, N.max_noise = J, n;
        }, this.set_pinfo = function(S, L, V, N, P) {
            var E = S.internal_flags, i, s, r, n, f, Y = L.scalefac_scale == 0 ? 0.5 : 1, J = L.scalefac, T = W(L3Side.SFBMAX), q = W(L3Side.SFBMAX), i0 = new CalcNoiseResult();
            calc_xmin(S, V, L, T), calc_noise(L, T, q, i0, null);
            var h0 = 0;
            for(s = L.sfb_lmax, L.block_type != g.SHORT_TYPE && L.mixed_block_flag == 0 && (s = 22), i = 0; i < s; i++){
                var d0 = E.scalefac_band.l[i], M0 = E.scalefac_band.l[i + 1], R0 = M0 - d0;
                for(n = 0; h0 < M0; h0++)n += L.xr[h0] * L.xr[h0];
                n /= R0, f = 1e15, E.pinfo.en[N][P][i] = f * n, E.pinfo.xfsf[N][P][i] = f * T[i] * q[i] / R0, V.en.l[i] > 0 && !S.ATHonly ? n = n / V.en.l[i] : n = 0, E.pinfo.thr[N][P][i] = f * Math.max(n * V.thm.l[i], E.ATH.l[i]), E.pinfo.LAMEsfb[N][P][i] = 0, L.preflag != 0 && i >= 11 && (E.pinfo.LAMEsfb[N][P][i] = -Y * M[i]), i < g.SBPSY_l && (D(J[i] >= 0), E.pinfo.LAMEsfb[N][P][i] -= Y * J[i]);
            }
            if (L.block_type == g.SHORT_TYPE) for(s = i, i = L.sfb_smin; i < g.SBMAX_s; i++)for(var d0 = E.scalefac_band.s[i], M0 = E.scalefac_band.s[i + 1], R0 = M0 - d0, A0 = 0; A0 < 3; A0++){
                for(n = 0, r = d0; r < M0; r++)n += L.xr[h0] * L.xr[h0], h0++;
                n = Math.max(n / R0, 1e-20), f = 1e15, E.pinfo.en_s[N][P][3 * i + A0] = f * n, E.pinfo.xfsf_s[N][P][3 * i + A0] = f * T[s] * q[s] / R0, V.en.s[i][A0] > 0 ? n = n / V.en.s[i][A0] : n = 0, (S.ATHonly || S.ATHshort) && (n = 0), E.pinfo.thr_s[N][P][3 * i + A0] = f * Math.max(n * V.thm.s[i][A0], E.ATH.s[i]), E.pinfo.LAMEsfb_s[N][P][3 * i + A0] = -2 * L.subblock_gain[A0], i < g.SBPSY_s && (E.pinfo.LAMEsfb_s[N][P][3 * i + A0] -= Y * J[s]), s++;
            }
            E.pinfo.LAMEqss[N][P] = L.global_gain, E.pinfo.LAMEmainbits[N][P] = L.part2_3_length + L.part2_length, E.pinfo.LAMEsfbits[N][P] = L.part2_length, E.pinfo.over[N][P] = i0.over_count, E.pinfo.max_noise[N][P] = i0.max_noise * 10, E.pinfo.over_noise[N][P] = i0.over_noise * 10, E.pinfo.tot_noise[N][P] = i0.tot_noise * 10, E.pinfo.over_SSD[N][P] = i0.over_SSD;
        };
    }
    return Me = m, Me;
}
var Ee, ta;
function Oa() {
    if (ta) return Ee;
    ta = 1;
    var w = Q0, Z = w.System, X = w.Arrays, z = w.new_int, u0 = w.assert, W = t1(), Q = He, D = Le, g = Va();
    function f0() {
        var A = null;
        this.qupvt = null, this.setModules = function(E) {
            this.qupvt = E, A = E;
        };
        function m(E) {
            this.bits = 0 | E;
        }
        var O = [
            [
                0,
                0
            ],
            /* 0 bands */ [
                0,
                0
            ],
            /* 1 bands */ [
                0,
                0
            ],
            /* 2 bands */ [
                0,
                0
            ],
            /* 3 bands */ [
                0,
                0
            ],
            /* 4 bands */ [
                0,
                1
            ],
            /* 5 bands */ [
                1,
                1
            ],
            /* 6 bands */ [
                1,
                1
            ],
            /* 7 bands */ [
                1,
                2
            ],
            /* 8 bands */ [
                2,
                2
            ],
            /* 9 bands */ [
                2,
                3
            ],
            /* 10 bands */ [
                2,
                3
            ],
            /* 11 bands */ [
                3,
                4
            ],
            /* 12 bands */ [
                3,
                4
            ],
            /* 13 bands */ [
                3,
                4
            ],
            /* 14 bands */ [
                4,
                5
            ],
            /* 15 bands */ [
                4,
                5
            ],
            /* 16 bands */ [
                4,
                6
            ],
            /* 17 bands */ [
                5,
                6
            ],
            /* 18 bands */ [
                5,
                6
            ],
            /* 19 bands */ [
                5,
                7
            ],
            /* 20 bands */ [
                6,
                7
            ],
            /* 21 bands */ [
                6,
                7
            ]
        ];
        function s0(E, i, s, r, n, f) {
            var Y = 0.5946 / i;
            for(E = E >> 1; E-- != 0;)n[f++] = Y > s[r++] ? 0 : 1, n[f++] = Y > s[r++] ? 0 : 1;
        }
        function K(E, i, s, r, n, f) {
            E = E >> 1;
            var Y = E % 2;
            for(E = E >> 1; E-- != 0;){
                var J, T, q, i0, h0, d0, M0, R0;
                J = s[r++] * i, T = s[r++] * i, h0 = 0 | J, q = s[r++] * i, d0 = 0 | T, i0 = s[r++] * i, M0 = 0 | q, J += A.adj43[h0], R0 = 0 | i0, T += A.adj43[d0], n[f++] = 0 | J, q += A.adj43[M0], n[f++] = 0 | T, i0 += A.adj43[R0], n[f++] = 0 | q, n[f++] = 0 | i0;
            }
            if (Y != 0) {
                var J, T, h0, d0;
                J = s[r++] * i, T = s[r++] * i, h0 = 0 | J, d0 = 0 | T, J += A.adj43[h0], T += A.adj43[d0], n[f++] = 0 | J, n[f++] = 0 | T;
            }
        }
        function t0(E, i, s, r, n) {
            var f, Y, J = 0, T, q = 0, i0 = 0, h0 = 0, d0 = i, M0 = 0, R0 = d0, A0 = 0, w0 = E, $0 = 0;
            for(T = n != null && r.global_gain == n.global_gain, r.block_type == W.SHORT_TYPE ? Y = 38 : Y = 21, f = 0; f <= Y; f++){
                var f1 = -1;
                if ((T || r.block_type == W.NORM_TYPE) && (f1 = r.global_gain - (r.scalefac[f] + (r.preflag != 0 ? A.pretab[f] : 0) << r.scalefac_scale + 1) - r.subblock_gain[r.window[f]] * 8), u0(r.width[f] >= 0), T && n.step[f] == f1) q != 0 && (K(q, s, w0, $0, R0, A0), q = 0), i0 != 0 && (s0(i0, s, w0, $0, R0, A0), i0 = 0);
                else {
                    var t = r.width[f];
                    if (J + r.width[f] > r.max_nonzero_coeff) {
                        var _;
                        _ = r.max_nonzero_coeff - J + 1, X.fill(i, r.max_nonzero_coeff, 576, 0), t = _, t < 0 && (t = 0), f = Y + 1;
                    }
                    if (q == 0 && i0 == 0 && (R0 = d0, A0 = M0, w0 = E, $0 = h0), n != null && n.sfb_count1 > 0 && f >= n.sfb_count1 && n.step[f] > 0 && f1 >= n.step[f] ? (q != 0 && (K(q, s, w0, $0, R0, A0), q = 0, R0 = d0, A0 = M0, w0 = E, $0 = h0), i0 += t) : (i0 != 0 && (s0(i0, s, w0, $0, R0, A0), i0 = 0, R0 = d0, A0 = M0, w0 = E, $0 = h0), q += t), t <= 0) {
                        i0 != 0 && (s0(i0, s, w0, $0, R0, A0), i0 = 0), q != 0 && (K(q, s, w0, $0, R0, A0), q = 0);
                        break;
                    }
                }
                f <= Y && (M0 += r.width[f], h0 += r.width[f], J += r.width[f]);
            }
            q != 0 && (K(q, s, w0, $0, R0, A0), q = 0), i0 != 0 && (s0(i0, s, w0, $0, R0, A0), i0 = 0);
        }
        function U(E, i, s) {
            var r = 0, n = 0;
            do {
                var f = E[i++], Y = E[i++];
                r < f && (r = f), n < Y && (n = Y);
            }while (i < s);
            return r < n && (r = n), r;
        }
        function R(E, i, s, r, n, f) {
            var Y = Q.ht[r].xlen * 65536 + Q.ht[n].xlen, J = 0, T;
            do {
                var q = E[i++], i0 = E[i++];
                q != 0 && (q > 14 && (q = 15, J += Y), q *= 16), i0 != 0 && (i0 > 14 && (i0 = 15, J += Y), q += i0), J += Q.largetbl[q];
            }while (i < s);
            return T = J & 65535, J >>= 16, J > T && (J = T, r = n), f.bits += J, r;
        }
        function o(E, i, s, r) {
            var n = 0, f = Q.ht[1].hlen;
            do {
                var Y = E[i + 0] * 2 + E[i + 1];
                i += 2, n += f[Y];
            }while (i < s);
            return r.bits += n, 1;
        }
        function u(E, i, s, r, n) {
            var f = 0, Y, J = Q.ht[r].xlen, T;
            r == 2 ? T = Q.table23 : T = Q.table56;
            do {
                var q = E[i + 0] * J + E[i + 1];
                i += 2, f += T[q];
            }while (i < s);
            return Y = f & 65535, f >>= 16, f > Y && (f = Y, r++), n.bits += f, r;
        }
        function d(E, i, s, r, n) {
            var f = 0, Y = 0, J = 0, T = Q.ht[r].xlen, q = Q.ht[r].hlen, i0 = Q.ht[r + 1].hlen, h0 = Q.ht[r + 2].hlen;
            do {
                var d0 = E[i + 0] * T + E[i + 1];
                i += 2, f += q[d0], Y += i0[d0], J += h0[d0];
            }while (i < s);
            var M0 = r;
            return f > Y && (f = Y, M0++), f > J && (f = J, M0 = r + 2), n.bits += f, M0;
        }
        var e = [
            1,
            2,
            5,
            7,
            7,
            10,
            10,
            13,
            13,
            13,
            13,
            13,
            13,
            13,
            13
        ];
        function l(E, i, s, r) {
            var n = U(E, i, s);
            switch(n){
                case 0:
                    return n;
                case 1:
                    return o(E, i, s, r);
                case 2:
                case 3:
                    return u(E, i, s, e[n - 1], r);
                case 4:
                case 5:
                case 6:
                case 7:
                case 8:
                case 9:
                case 10:
                case 11:
                case 12:
                case 13:
                case 14:
                case 15:
                    return d(E, i, s, e[n - 1], r);
                default:
                    if (n > g.IXMAX_VAL) return r.bits = g.LARGE_BITS, -1;
                    n -= 15;
                    var f;
                    for(f = 24; f < 32 && !(Q.ht[f].linmax >= n); f++);
                    var Y;
                    for(Y = f - 8; Y < 24 && !(Q.ht[Y].linmax >= n); Y++);
                    return R(E, i, s, Y, f, r);
            }
        }
        this.noquant_count_bits = function(E, i, s) {
            var r = i.l3_enc, n = Math.min(576, i.max_nonzero_coeff + 2 >> 1 << 1);
            for(s != null && (s.sfb_count1 = 0); n > 1 && !(r[n - 1] | r[n - 2]); n -= 2);
            i.count1 = n;
            for(var f = 0, Y = 0; n > 3; n -= 4){
                var J;
                if (((r[n - 1] | r[n - 2] | r[n - 3] | r[n - 4]) & 2147483647) > 1) break;
                J = ((r[n - 4] * 2 + r[n - 3]) * 2 + r[n - 2]) * 2 + r[n - 1], f += Q.t32l[J], Y += Q.t33l[J];
            }
            var T = f;
            if (i.count1table_select = 0, f > Y && (T = Y, i.count1table_select = 1), i.count1bits = T, i.big_values = n, n == 0) return T;
            if (i.block_type == W.SHORT_TYPE) f = 3 * E.scalefac_band.s[3], f > i.big_values && (f = i.big_values), Y = i.big_values;
            else if (i.block_type == W.NORM_TYPE) {
                if (f = i.region0_count = E.bv_scf[n - 2], Y = i.region1_count = E.bv_scf[n - 1], u0(f + Y + 2 < W.SBPSY_l), Y = E.scalefac_band.l[f + Y + 2], f = E.scalefac_band.l[f + 1], Y < n) {
                    var q = new m(T);
                    i.table_select[2] = l(r, Y, n, q), T = q.bits;
                }
            } else i.region0_count = 7, i.region1_count = W.SBMAX_l - 1 - 7 - 1, f = E.scalefac_band.l[8], Y = n, f > Y && (f = Y);
            if (f = Math.min(f, n), Y = Math.min(Y, n), 0 < f) {
                var q = new m(T);
                i.table_select[0] = l(r, 0, f, q), T = q.bits;
            }
            if (f < Y) {
                var q = new m(T);
                i.table_select[1] = l(r, f, Y, q), T = q.bits;
            }
            if (E.use_best_huffman == 2 && (i.part2_3_length = T, best_huffman_divide(E, i), T = i.part2_3_length), s != null && i.block_type == W.NORM_TYPE) {
                for(var i0 = 0; E.scalefac_band.l[i0] < i.big_values;)i0++;
                s.sfb_count1 = i0;
            }
            return T;
        }, this.count_bits = function(E, i, s, r) {
            var n = s.l3_enc, f = g.IXMAX_VAL / A.IPOW20(s.global_gain);
            if (s.xrpow_max > f) return g.LARGE_BITS;
            if (t0(i, n, A.IPOW20(s.global_gain), s, r), E.substep_shaping & 2) for(var Y = 0, J = s.global_gain + s.scalefac_scale, T = 0.634521682242439 / A.IPOW20(J), q = 0; q < s.sfbmax; q++){
                var i0 = s.width[q];
                if (E.pseudohalf[q] == 0) Y += i0;
                else {
                    var h0;
                    for(h0 = Y, Y += i0; h0 < Y; ++h0)n[h0] = i[h0] >= T ? n[h0] : 0;
                }
            }
            return this.noquant_count_bits(E, s, r);
        };
        function M(E, i, s, r, n, f, Y) {
            for(var J = i.big_values, T = 0; T <= 22; T++)r[T] = g.LARGE_BITS;
            for(var T = 0; T < 16; T++){
                var q = E.scalefac_band.l[T + 1];
                if (q >= J) break;
                var i0 = 0, h0 = new m(i0), d0 = l(s, 0, q, h0);
                i0 = h0.bits;
                for(var M0 = 0; M0 < 8; M0++){
                    var R0 = E.scalefac_band.l[T + M0 + 2];
                    if (R0 >= J) break;
                    var A0 = i0;
                    h0 = new m(A0);
                    var w0 = l(s, q, R0, h0);
                    A0 = h0.bits, r[T + M0] > A0 && (r[T + M0] = A0, n[T + M0] = T, f[T + M0] = d0, Y[T + M0] = w0);
                }
            }
        }
        function p(E, i, s, r, n, f, Y, J) {
            for(var T = i.big_values, q = 2; q < W.SBMAX_l + 1; q++){
                var i0 = E.scalefac_band.l[q];
                if (i0 >= T) break;
                var h0 = n[q - 2] + i.count1bits;
                if (s.part2_3_length <= h0) break;
                var d0 = new m(h0), M0 = l(r, i0, T, d0);
                h0 = d0.bits, !(s.part2_3_length <= h0) && (s.assign(i), s.part2_3_length = h0, s.region0_count = f[q - 2], s.region1_count = q - 2 - f[q - 2], s.table_select[0] = Y[q - 2], s.table_select[1] = J[q - 2], s.table_select[2] = M0);
            }
        }
        this.best_huffman_divide = function(E, i) {
            var s = new D(), r = i.l3_enc, n = z(23), f = z(23), Y = z(23), J = z(23);
            if (!(i.block_type == W.SHORT_TYPE && E.mode_gr == 1)) {
                s.assign(i), i.block_type == W.NORM_TYPE && (M(E, i, r, n, f, Y, J), p(E, s, i, r, n, f, Y, J));
                var T = s.big_values;
                if (!(T == 0 || (r[T - 2] | r[T - 1]) > 1) && (T = i.count1 + 2, !(T > 576))) {
                    s.assign(i), s.count1 = T;
                    for(var q = 0, i0 = 0; T > s.big_values; T -= 4){
                        var h0 = ((r[T - 4] * 2 + r[T - 3]) * 2 + r[T - 2]) * 2 + r[T - 1];
                        q += Q.t32l[h0], i0 += Q.t33l[h0];
                    }
                    if (s.big_values = T, s.count1table_select = 0, q > i0 && (q = i0, s.count1table_select = 1), s.count1bits = q, s.block_type == W.NORM_TYPE) p(E, s, i, r, n, f, Y, J);
                    else {
                        if (s.part2_3_length = q, q = E.scalefac_band.l[8], q > T && (q = T), q > 0) {
                            var d0 = new m(s.part2_3_length);
                            s.table_select[0] = l(r, 0, q, d0), s.part2_3_length = d0.bits;
                        }
                        if (T > q) {
                            var d0 = new m(s.part2_3_length);
                            s.table_select[1] = l(r, q, T, d0), s.part2_3_length = d0.bits;
                        }
                        i.part2_3_length > s.part2_3_length && i.assign(s);
                    }
                }
            }
        };
        var H = [
            1,
            1,
            1,
            1,
            8,
            2,
            2,
            2,
            4,
            4,
            4,
            8,
            8,
            8,
            16,
            16
        ], B = [
            1,
            2,
            4,
            8,
            1,
            2,
            4,
            8,
            2,
            4,
            8,
            2,
            4,
            8,
            4,
            8
        ], I = [
            0,
            0,
            0,
            0,
            3,
            1,
            1,
            1,
            2,
            2,
            2,
            3,
            3,
            3,
            4,
            4
        ], v0 = [
            0,
            1,
            2,
            3,
            0,
            1,
            2,
            3,
            1,
            2,
            3,
            1,
            2,
            3,
            2,
            3
        ];
        f0.slen1_tab = I, f0.slen2_tab = v0;
        function b(E, i) {
            for(var s, r = i.tt[1][E], n = i.tt[0][E], f = 0; f < Q.scfsi_band.length - 1; f++){
                for(s = Q.scfsi_band[f]; s < Q.scfsi_band[f + 1] && !(n.scalefac[s] != r.scalefac[s] && r.scalefac[s] >= 0); s++);
                if (s == Q.scfsi_band[f + 1]) {
                    for(s = Q.scfsi_band[f]; s < Q.scfsi_band[f + 1]; s++)r.scalefac[s] = -1;
                    i.scfsi[E][f] = 1;
                }
            }
            var Y = 0, J = 0;
            for(s = 0; s < 11; s++)r.scalefac[s] != -1 && (J++, Y < r.scalefac[s] && (Y = r.scalefac[s]));
            for(var T = 0, q = 0; s < W.SBPSY_l; s++)r.scalefac[s] != -1 && (q++, T < r.scalefac[s] && (T = r.scalefac[s]));
            for(var f = 0; f < 16; f++)if (Y < H[f] && T < B[f]) {
                var i0 = I[f] * J + v0[f] * q;
                r.part2_length > i0 && (r.part2_length = i0, r.scalefac_compress = f);
            }
        }
        this.best_scalefac_store = function(E, i, s, r) {
            var n = r.tt[i][s], f, Y, J, T, q = 0;
            for(J = 0, f = 0; f < n.sfbmax; f++){
                var i0 = n.width[f];
                for(J += i0, T = -i0; T < 0 && n.l3_enc[T + J] == 0; T++);
                T == 0 && (n.scalefac[f] = q = -2);
            }
            if (n.scalefac_scale == 0 && n.preflag == 0) {
                var h0 = 0;
                for(f = 0; f < n.sfbmax; f++)n.scalefac[f] > 0 && (h0 |= n.scalefac[f]);
                if (!(h0 & 1) && h0 != 0) {
                    for(f = 0; f < n.sfbmax; f++)n.scalefac[f] > 0 && (n.scalefac[f] >>= 1);
                    n.scalefac_scale = q = 1;
                }
            }
            if (n.preflag == 0 && n.block_type != W.SHORT_TYPE && E.mode_gr == 2) {
                for(f = 11; f < W.SBPSY_l && !(n.scalefac[f] < A.pretab[f] && n.scalefac[f] != -2); f++);
                if (f == W.SBPSY_l) {
                    for(f = 11; f < W.SBPSY_l; f++)n.scalefac[f] > 0 && (n.scalefac[f] -= A.pretab[f]);
                    n.preflag = q = 1;
                }
            }
            for(Y = 0; Y < 4; Y++)r.scfsi[s][Y] = 0;
            for(E.mode_gr == 2 && i == 1 && r.tt[0][s].block_type != W.SHORT_TYPE && r.tt[1][s].block_type != W.SHORT_TYPE && (b(s, r), q = 0), f = 0; f < n.sfbmax; f++)n.scalefac[f] == -2 && (n.scalefac[f] = 0);
            q != 0 && (E.mode_gr == 2 ? this.scale_bitcount(n) : this.scale_bitcount_lsf(E, n));
        };
        function a(E, i) {
            for(var s = 0; s < i; ++s)if (E[s] < 0) return !1;
            return !0;
        }
        var S = [
            0,
            18,
            36,
            54,
            54,
            36,
            54,
            72,
            54,
            72,
            90,
            72,
            90,
            108,
            108,
            126
        ], L = [
            0,
            18,
            36,
            54,
            51,
            35,
            53,
            71,
            52,
            70,
            88,
            69,
            87,
            105,
            104,
            122
        ], V = [
            0,
            10,
            20,
            30,
            33,
            21,
            31,
            41,
            32,
            42,
            52,
            43,
            53,
            63,
            64,
            74
        ];
        this.scale_bitcount = function(E) {
            var i, s, r = 0, n = 0, f, Y = E.scalefac;
            if (u0(a(Y, E.sfbmax)), E.block_type == W.SHORT_TYPE) f = S, E.mixed_block_flag != 0 && (f = L);
            else if (f = V, E.preflag == 0) {
                for(s = 11; s < W.SBPSY_l && !(Y[s] < A.pretab[s]); s++);
                if (s == W.SBPSY_l) for(E.preflag = 1, s = 11; s < W.SBPSY_l; s++)Y[s] -= A.pretab[s];
            }
            for(s = 0; s < E.sfbdivide; s++)r < Y[s] && (r = Y[s]);
            for(; s < E.sfbmax; s++)n < Y[s] && (n = Y[s]);
            for(E.part2_length = g.LARGE_BITS, i = 0; i < 16; i++)r < H[i] && n < B[i] && E.part2_length > f[i] && (E.part2_length = f[i], E.scalefac_compress = i);
            return E.part2_length == g.LARGE_BITS;
        };
        var N = [
            [
                15,
                15,
                7,
                7
            ],
            [
                15,
                15,
                7,
                0
            ],
            [
                7,
                3,
                0,
                0
            ],
            [
                15,
                31,
                31,
                0
            ],
            [
                7,
                7,
                7,
                0
            ],
            [
                3,
                3,
                0,
                0
            ]
        ];
        this.scale_bitcount_lsf = function(E, i) {
            var s, r, n, f, Y, J, T, q, i0 = z(4), h0 = i.scalefac;
            for(i.preflag != 0 ? s = 2 : s = 0, T = 0; T < 4; T++)i0[T] = 0;
            if (i.block_type == W.SHORT_TYPE) {
                r = 1;
                var d0 = A.nr_of_sfb_block[s][r];
                for(q = 0, n = 0; n < 4; n++)for(f = d0[n] / 3, T = 0; T < f; T++, q++)for(Y = 0; Y < 3; Y++)h0[q * 3 + Y] > i0[n] && (i0[n] = h0[q * 3 + Y]);
            } else {
                r = 0;
                var d0 = A.nr_of_sfb_block[s][r];
                for(q = 0, n = 0; n < 4; n++)for(f = d0[n], T = 0; T < f; T++, q++)h0[q] > i0[n] && (i0[n] = h0[q]);
            }
            for(J = !1, n = 0; n < 4; n++)i0[n] > N[s][n] && (J = !0);
            if (!J) {
                var M0, R0, A0, w0;
                for(i.sfb_partition_table = A.nr_of_sfb_block[s][r], n = 0; n < 4; n++)i.slen[n] = P[i0[n]];
                switch(M0 = i.slen[0], R0 = i.slen[1], A0 = i.slen[2], w0 = i.slen[3], s){
                    case 0:
                        i.scalefac_compress = (M0 * 5 + R0 << 4) + (A0 << 2) + w0;
                        break;
                    case 1:
                        i.scalefac_compress = 400 + (M0 * 5 + R0 << 2) + A0;
                        break;
                    case 2:
                        i.scalefac_compress = 500 + M0 * 3 + R0;
                        break;
                    default:
                        Z.err.printf(`intensity stereo not implemented yet
`);
                        break;
                }
            }
            if (!J) for(u0(i.sfb_partition_table != null), i.part2_length = 0, n = 0; n < 4; n++)i.part2_length += i.slen[n] * i.sfb_partition_table[n];
            return J;
        };
        var P = [
            0,
            1,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            4,
            4,
            4,
            4
        ];
        this.huffman_init = function(E) {
            for(var i = 2; i <= 576; i += 2){
                for(var s = 0, r; E.scalefac_band.l[++s] < i;);
                for(r = O[s][0]; E.scalefac_band.l[r + 1] > i;)r--;
                for(r < 0 && (r = O[s][0]), E.bv_scf[i - 2] = r, r = O[s][1]; E.scalefac_band.l[r + E.bv_scf[i - 2] + 2] > i;)r--;
                r < 0 && (r = O[s][1]), E.bv_scf[i - 1] = r;
            }
        };
    }
    return Ee = f0, Ee;
}
var Be, sa;
function Ve() {
    if (sa) return Be;
    sa = 1;
    var w = Q0, Z = w.System, X = w.Arrays, z = w.new_byte, u0 = w.new_float_n, W = w.new_int, Q = w.assert, D = Oa(), g = He, f0 = t1(), A = ne;
    m.EQ = function(O, s0) {
        return Math.abs(O) > Math.abs(s0) ? Math.abs(O - s0) <= Math.abs(O) * 1e-6 : Math.abs(O - s0) <= Math.abs(s0) * 1e-6;
    }, m.NEQ = function(O, s0) {
        return !m.EQ(O, s0);
    };
    function m() {
        var O = Oe(), s0 = this, K = 32773, t0 = null, U = null, R = null, o = null;
        this.setModules = function(i, s, r, n) {
            t0 = i, U = s, R = r, o = n;
        };
        var u = null, d = 0, e = 0, l = 0;
        this.getframebits = function(i) {
            var s = i.internal_flags, r;
            s.bitrate_index != 0 ? r = g.bitrate_table[i.version][s.bitrate_index] : r = i.brate;
            var n = 0 | (i.version + 1) * 72e3 * r / i.out_samplerate + s.padding;
            return 8 * n;
        };
        function M(i) {
            Z.arraycopy(i.header[i.w_ptr].buf, 0, u, e, i.sideinfo_len), e += i.sideinfo_len, d += i.sideinfo_len * 8, i.w_ptr = i.w_ptr + 1 & A.MAX_HEADER_BUF - 1;
        }
        function p(i, s, r) {
            for(; r > 0;){
                var n;
                l == 0 && (l = 8, e++, Q(e < O.LAME_MAXMP3BUFFER), Q(i.header[i.w_ptr].write_timing >= d), i.header[i.w_ptr].write_timing == d && M(i), u[e] = 0), n = Math.min(r, l), r -= n, l -= n, u[e] |= s >> r << l, d += n;
            }
        }
        function H(i, s, r) {
            for(; r > 0;){
                var n;
                l == 0 && (l = 8, e++, Q(e < O.LAME_MAXMP3BUFFER), u[e] = 0), n = Math.min(r, l), r -= n, l -= n, u[e] |= s >> r << l, d += n;
            }
        }
        function B(i, s) {
            var r = i.internal_flags, n;
            if (s >= 8 && (p(r, 76, 8), s -= 8), s >= 8 && (p(r, 65, 8), s -= 8), s >= 8 && (p(r, 77, 8), s -= 8), s >= 8 && (p(r, 69, 8), s -= 8), s >= 32) {
                var f = R.getLameShortVersion();
                if (s >= 32) for(n = 0; n < f.length && s >= 8; ++n)s -= 8, p(r, f.charAt(n), 8);
            }
            for(; s >= 1; s -= 1)p(r, r.ancillary_flag, 1), r.ancillary_flag ^= i.disable_reservoir ? 0 : 1;
        }
        function I(i, s, r) {
            for(var n = i.header[i.h_ptr].ptr; r > 0;){
                var f = Math.min(r, 8 - (n & 7));
                r -= f, i.header[i.h_ptr].buf[n >> 3] |= s >> r << 8 - (n & 7) - f, n += f;
            }
            i.header[i.h_ptr].ptr = n;
        }
        function v0(i, s) {
            i <<= 8;
            for(var r = 0; r < 8; r++)i <<= 1, s <<= 1, (s ^ i) & 65536 && (s ^= K);
            return s;
        }
        this.CRC_writeheader = function(i, s) {
            var r = 65535;
            r = v0(s[2] & 255, r), r = v0(s[3] & 255, r);
            for(var n = 6; n < i.sideinfo_len; n++)r = v0(s[n] & 255, r);
            s[4] = byte(r >> 8), s[5] = byte(r & 255);
        };
        function b(i, s) {
            var r = i.internal_flags, n, f, Y;
            if (n = r.l3_side, r.header[r.h_ptr].ptr = 0, X.fill(r.header[r.h_ptr].buf, 0, r.sideinfo_len, 0), i.out_samplerate < 16e3 ? I(r, 4094, 12) : I(r, 4095, 12), I(r, i.version, 1), I(r, 1, 2), I(r, i.error_protection ? 0 : 1, 1), I(r, r.bitrate_index, 4), I(r, r.samplerate_index, 2), I(r, r.padding, 1), I(r, i.extension, 1), I(r, i.mode.ordinal(), 2), I(r, r.mode_ext, 2), I(r, i.copyright, 1), I(r, i.original, 1), I(r, i.emphasis, 2), i.error_protection && I(r, 0, 16), i.version == 1) {
                for(Q(n.main_data_begin >= 0), I(r, n.main_data_begin, 9), r.channels_out == 2 ? I(r, n.private_bits, 3) : I(r, n.private_bits, 5), Y = 0; Y < r.channels_out; Y++){
                    var J;
                    for(J = 0; J < 4; J++)I(r, n.scfsi[Y][J], 1);
                }
                for(f = 0; f < 2; f++)for(Y = 0; Y < r.channels_out; Y++){
                    var T = n.tt[f][Y];
                    I(r, T.part2_3_length + T.part2_length, 12), I(r, T.big_values / 2, 9), I(r, T.global_gain, 8), I(r, T.scalefac_compress, 4), T.block_type != f0.NORM_TYPE ? (I(r, 1, 1), I(r, T.block_type, 2), I(r, T.mixed_block_flag, 1), T.table_select[0] == 14 && (T.table_select[0] = 16), I(r, T.table_select[0], 5), T.table_select[1] == 14 && (T.table_select[1] = 16), I(r, T.table_select[1], 5), I(r, T.subblock_gain[0], 3), I(r, T.subblock_gain[1], 3), I(r, T.subblock_gain[2], 3)) : (I(r, 0, 1), T.table_select[0] == 14 && (T.table_select[0] = 16), I(r, T.table_select[0], 5), T.table_select[1] == 14 && (T.table_select[1] = 16), I(r, T.table_select[1], 5), T.table_select[2] == 14 && (T.table_select[2] = 16), I(r, T.table_select[2], 5), Q(0 <= T.region0_count && T.region0_count < 16), Q(0 <= T.region1_count && T.region1_count < 8), I(r, T.region0_count, 4), I(r, T.region1_count, 3)), I(r, T.preflag, 1), I(r, T.scalefac_scale, 1), I(r, T.count1table_select, 1);
                }
            } else for(Q(n.main_data_begin >= 0), I(r, n.main_data_begin, 8), I(r, n.private_bits, r.channels_out), f = 0, Y = 0; Y < r.channels_out; Y++){
                var T = n.tt[f][Y];
                I(r, T.part2_3_length + T.part2_length, 12), I(r, T.big_values / 2, 9), I(r, T.global_gain, 8), I(r, T.scalefac_compress, 9), T.block_type != f0.NORM_TYPE ? (I(r, 1, 1), I(r, T.block_type, 2), I(r, T.mixed_block_flag, 1), T.table_select[0] == 14 && (T.table_select[0] = 16), I(r, T.table_select[0], 5), T.table_select[1] == 14 && (T.table_select[1] = 16), I(r, T.table_select[1], 5), I(r, T.subblock_gain[0], 3), I(r, T.subblock_gain[1], 3), I(r, T.subblock_gain[2], 3)) : (I(r, 0, 1), T.table_select[0] == 14 && (T.table_select[0] = 16), I(r, T.table_select[0], 5), T.table_select[1] == 14 && (T.table_select[1] = 16), I(r, T.table_select[1], 5), T.table_select[2] == 14 && (T.table_select[2] = 16), I(r, T.table_select[2], 5), Q(0 <= T.region0_count && T.region0_count < 16), Q(0 <= T.region1_count && T.region1_count < 8), I(r, T.region0_count, 4), I(r, T.region1_count, 3)), I(r, T.scalefac_scale, 1), I(r, T.count1table_select, 1);
            }
            i.error_protection && CRC_writeheader(r, r.header[r.h_ptr].buf);
            var q = r.h_ptr;
            Q(r.header[q].ptr == r.sideinfo_len * 8), r.h_ptr = q + 1 & A.MAX_HEADER_BUF - 1, r.header[r.h_ptr].write_timing = r.header[q].write_timing + s, r.h_ptr == r.w_ptr && Z.err.println(`Error: MAX_HEADER_BUF too small in bitstream.c 
`);
        }
        function a(i, s) {
            var r = g.ht[s.count1table_select + 32], n, f = 0, Y = s.big_values, J = s.big_values;
            for(Q(s.count1table_select < 2), n = (s.count1 - s.big_values) / 4; n > 0; --n){
                var T = 0, q = 0, i0;
                i0 = s.l3_enc[Y + 0], i0 != 0 && (q += 8, s.xr[J + 0] < 0 && T++), i0 = s.l3_enc[Y + 1], i0 != 0 && (q += 4, T *= 2, s.xr[J + 1] < 0 && T++), i0 = s.l3_enc[Y + 2], i0 != 0 && (q += 2, T *= 2, s.xr[J + 2] < 0 && T++), i0 = s.l3_enc[Y + 3], i0 != 0 && (q++, T *= 2, s.xr[J + 3] < 0 && T++), Y += 4, J += 4, p(i, T + r.table[q], r.hlen[q]), f += r.hlen[q];
            }
            return f;
        }
        function S(i, s, r, n, f) {
            var Y = g.ht[s], J = 0;
            if (s == 0) return J;
            for(var T = r; T < n; T += 2){
                var q = 0, i0 = 0, h0 = Y.xlen, d0 = Y.xlen, M0 = 0, R0 = f.l3_enc[T], A0 = f.l3_enc[T + 1];
                if (R0 != 0 && (f.xr[T] < 0 && M0++, q--), s > 15) {
                    if (R0 > 14) {
                        var w0 = R0 - 15;
                        Q(w0 <= Y.linmax), M0 |= w0 << 1, i0 = h0, R0 = 15;
                    }
                    if (A0 > 14) {
                        var $0 = A0 - 15;
                        Q($0 <= Y.linmax), M0 <<= h0, M0 |= $0, i0 += h0, A0 = 15;
                    }
                    d0 = 16;
                }
                A0 != 0 && (M0 <<= 1, f.xr[T + 1] < 0 && M0++, q--), R0 = R0 * d0 + A0, i0 -= q, q += Y.hlen[R0], p(i, Y.table[R0], q), p(i, M0, i0), J += q + i0;
            }
            return J;
        }
        function L(i, s) {
            var r = 3 * i.scalefac_band.s[3];
            r > s.big_values && (r = s.big_values);
            var n = S(i, s.table_select[0], 0, r, s);
            return n += S(i, s.table_select[1], r, s.big_values, s), n;
        }
        function V(i, s) {
            var r, n, f, Y;
            r = s.big_values;
            var J = s.region0_count + 1;
            return Q(J < i.scalefac_band.l.length), f = i.scalefac_band.l[J], J += s.region1_count + 1, Q(J < i.scalefac_band.l.length), Y = i.scalefac_band.l[J], f > r && (f = r), Y > r && (Y = r), n = S(i, s.table_select[0], 0, f, s), n += S(i, s.table_select[1], f, Y, s), n += S(i, s.table_select[2], Y, r, s), n;
        }
        function N(i) {
            var s, r, n, f, Y = 0, J = i.internal_flags, T = J.l3_side;
            if (i.version == 1) for(s = 0; s < 2; s++)for(r = 0; r < J.channels_out; r++){
                var q = T.tt[s][r], i0 = D.slen1_tab[q.scalefac_compress], h0 = D.slen2_tab[q.scalefac_compress];
                for(f = 0, n = 0; n < q.sfbdivide; n++)q.scalefac[n] != -1 && (p(J, q.scalefac[n], i0), f += i0);
                for(; n < q.sfbmax; n++)q.scalefac[n] != -1 && (p(J, q.scalefac[n], h0), f += h0);
                Q(f == q.part2_length), q.block_type == f0.SHORT_TYPE ? f += L(J, q) : f += V(J, q), f += a(J, q), Q(f == q.part2_3_length + q.part2_length), Y += f;
            }
            else for(s = 0, r = 0; r < J.channels_out; r++){
                var q = T.tt[s][r], d0, M0, R0 = 0;
                if (Q(q.sfb_partition_table != null), f = 0, n = 0, M0 = 0, q.block_type == f0.SHORT_TYPE) {
                    for(; M0 < 4; M0++){
                        var A0 = q.sfb_partition_table[M0] / 3, w0 = q.slen[M0];
                        for(d0 = 0; d0 < A0; d0++, n++)p(J, Math.max(q.scalefac[n * 3 + 0], 0), w0), p(J, Math.max(q.scalefac[n * 3 + 1], 0), w0), p(J, Math.max(q.scalefac[n * 3 + 2], 0), w0), R0 += 3 * w0;
                    }
                    f += L(J, q);
                } else {
                    for(; M0 < 4; M0++){
                        var A0 = q.sfb_partition_table[M0], w0 = q.slen[M0];
                        for(d0 = 0; d0 < A0; d0++, n++)p(J, Math.max(q.scalefac[n], 0), w0), R0 += w0;
                    }
                    f += V(J, q);
                }
                f += a(J, q), Q(f == q.part2_3_length), Q(R0 == q.part2_length), Y += R0 + f;
            }
            return Y;
        }
        function P() {
            this.total = 0;
        }
        function E(i, s) {
            var r = i.internal_flags, n, f, Y, J, T;
            return T = r.w_ptr, J = r.h_ptr - 1, J == -1 && (J = A.MAX_HEADER_BUF - 1), n = r.header[J].write_timing - d, s.total = n, n >= 0 && (f = 1 + J - T, J < T && (f = 1 + J - T + A.MAX_HEADER_BUF), n -= f * 8 * r.sideinfo_len), Y = s0.getframebits(i), n += Y, s.total += Y, s.total % 8 != 0 ? s.total = 1 + s.total / 8 : s.total = s.total / 8, s.total += e + 1, n < 0 && Z.err.println(`strange error flushing buffer ... 
`), n;
        }
        this.flush_bitstream = function(i) {
            var s = i.internal_flags, r, n, f = s.h_ptr - 1;
            if (f == -1 && (f = A.MAX_HEADER_BUF - 1), r = s.l3_side, !((n = E(i, new P())) < 0)) {
                if (B(i, n), Q(s.header[f].write_timing + this.getframebits(i) == d), s.ResvSize = 0, r.main_data_begin = 0, s.findReplayGain) {
                    var Y = t0.GetTitleGain(s.rgdata);
                    Q(NEQ(Y, GainAnalysis.GAIN_NOT_ENOUGH_SAMPLES)), s.RadioGain = Math.floor(Y * 10 + 0.5) | 0;
                }
                s.findPeakSample && (s.noclipGainChange = Math.ceil(Math.log10(s.PeakSample / 32767) * 200) | 0, s.noclipGainChange > 0 && (EQ(i.scale, 1) || EQ(i.scale, 0)) ? s.noclipScale = Math.floor(32767 / s.PeakSample * 100) / 100 : s.noclipScale = -1);
            }
        }, this.add_dummy_byte = function(i, s, r) {
            for(var n = i.internal_flags, f; r-- > 0;)for(H(n, s, 8), f = 0; f < A.MAX_HEADER_BUF; ++f)n.header[f].write_timing += 8;
        }, this.format_bitstream = function(i) {
            var s = i.internal_flags, r;
            r = s.l3_side;
            var n = this.getframebits(i);
            B(i, r.resvDrain_pre), b(i, n);
            var f = 8 * s.sideinfo_len;
            if (f += N(i), B(i, r.resvDrain_post), f += r.resvDrain_post, r.main_data_begin += (n - f) / 8, E(i, new P()) != s.ResvSize && Z.err.println("Internal buffer inconsistency. flushbits <> ResvSize"), r.main_data_begin * 8 != s.ResvSize && (Z.err.printf(`bit reservoir error: 
l3_side.main_data_begin: %d 
Resvoir size:             %d 
resv drain (post)         %d 
resv drain (pre)          %d 
header and sideinfo:      %d 
data bits:                %d 
total bits:               %d (remainder: %d) 
bitsperframe:             %d 
`, 8 * r.main_data_begin, s.ResvSize, r.resvDrain_post, r.resvDrain_pre, 8 * s.sideinfo_len, f - r.resvDrain_post - 8 * s.sideinfo_len, f, f % 8, n), Z.err.println("This is a fatal error.  It has several possible causes:"), Z.err.println("90%%  LAME compiled with buggy version of gcc using advanced optimizations"), Z.err.println(" 9%%  Your system is overclocked"), Z.err.println(" 1%%  bug in LAME encoding library"), s.ResvSize = r.main_data_begin * 8), d > 1e9) {
                var Y;
                for(Y = 0; Y < A.MAX_HEADER_BUF; ++Y)s.header[Y].write_timing -= d;
                d = 0;
            }
            return 0;
        }, this.copy_buffer = function(i, s, r, n, f) {
            var Y = e + 1;
            if (Y <= 0) return 0;
            if (n != 0 && Y > n) return -1;
            if (Z.arraycopy(u, 0, s, r, Y), e = -1, l = 0, f != 0) {
                var J = W(1);
                if (J[0] = i.nMusicCRC, o.updateMusicCRC(J, s, r, Y), i.nMusicCRC = J[0], Y > 0 && (i.VBR_seek_table.nBytesWritten += Y), i.decode_on_the_fly) {
                    for(var T = u0([
                        2,
                        1152
                    ]), q = Y, i0 = -1, h0; i0 != 0;)if (i0 = U.hip_decode1_unclipped(i.hip, s, r, q, T[0], T[1]), q = 0, i0 == -1 && (i0 = 0), i0 > 0) {
                        if (i.findPeakSample) {
                            for(h0 = 0; h0 < i0; h0++)T[0][h0] > i.PeakSample ? i.PeakSample = T[0][h0] : -T[0][h0] > i.PeakSample && (i.PeakSample = -T[0][h0]);
                            if (i.channels_out > 1) for(h0 = 0; h0 < i0; h0++)T[1][h0] > i.PeakSample ? i.PeakSample = T[1][h0] : -T[1][h0] > i.PeakSample && (i.PeakSample = -T[1][h0]);
                        }
                        if (i.findReplayGain && t0.AnalyzeSamples(i.rgdata, T[0], 0, T[1], 0, i0, i.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR) return -6;
                    }
                }
            }
            return Y;
        }, this.init_bit_stream_w = function(i) {
            u = z(O.LAME_MAXMP3BUFFER), i.h_ptr = i.w_ptr = 0, i.header[i.h_ptr].write_timing = 0, e = -1, l = 0, d = 0;
        };
    }
    return Be = m, Be;
}
var Te, ia;
function Oe() {
    if (ia) return Te;
    ia = 1;
    var w = Q0, Z = w.System, X = w.VbrMode, z = w.ShortBlock, u0 = w.new_float, W = w.new_int_n, Q = w.new_short_n, D = w.assert, g = Qa, f0 = za, A = ne, m = x2, O = E2, s0 = N2, K = Ve(), t0 = He, U = t1();
    function R() {
        var o = j1, u = this, d = 131072;
        R.V9 = 410, R.V8 = 420, R.V7 = 430, R.V6 = 440, R.V5 = 450, R.V4 = 460, R.V3 = 470, R.V2 = 480, R.V1 = 490, R.V0 = 500, R.R3MIX = 1e3, R.STANDARD = 1001, R.EXTREME = 1002, R.INSANE = 1003, R.STANDARD_FAST = 1004, R.EXTREME_FAST = 1005, R.MEDIUM = 1006, R.MEDIUM_FAST = 1007;
        var e = 16384 + d;
        R.LAME_MAXMP3BUFFER = e;
        var l, M, p, H, B, I = new g(), v0, b, a;
        this.enc = new U(), this.setModules = function(t, _, S0, E0, V0, H0, y0, T0, F0) {
            l = t, M = _, p = S0, H = E0, B = V0, v0 = H0, b = T0, a = F0, this.enc.setModules(M, I, H, v0);
        };
        function S() {
            this.mask_adjust = 0, this.mask_adjust_short = 0, this.bo_l_weight = u0(U.SBMAX_l), this.bo_s_weight = u0(U.SBMAX_s);
        }
        function L() {
            this.lowerlimit = 0;
        }
        function V(t, _) {
            this.lowpass = _;
        }
        var N = 4294479419;
        function P(t) {
            var _;
            return t.class_id = N, _ = t.internal_flags = new A(), t.mode = o.NOT_SET, t.original = 1, t.in_samplerate = 44100, t.num_channels = 2, t.num_samples = -1, t.bWriteVbrTag = !0, t.quality = -1, t.short_blocks = null, _.subblock_gain = -1, t.lowpassfreq = 0, t.highpassfreq = 0, t.lowpasswidth = -1, t.highpasswidth = -1, t.VBR = X.vbr_off, t.VBR_q = 4, t.ATHcurve = -1, t.VBR_mean_bitrate_kbps = 128, t.VBR_min_bitrate_kbps = 0, t.VBR_max_bitrate_kbps = 0, t.VBR_hard_min = 0, _.VBR_min_bitrate = 1, _.VBR_max_bitrate = 13, t.quant_comp = -1, t.quant_comp_short = -1, t.msfix = -1, _.resample_ratio = 1, _.OldValue[0] = 180, _.OldValue[1] = 180, _.CurrentStep[0] = 4, _.CurrentStep[1] = 4, _.masking_lower = 1, _.nsPsy.attackthre = -1, _.nsPsy.attackthre_s = -1, t.scale = -1, t.athaa_type = -1, t.ATHtype = -1, t.athaa_loudapprox = -1, t.athaa_sensitivity = 0, t.useTemporal = null, t.interChRatio = -1, _.mf_samples_to_encode = U.ENCDELAY + U.POSTDELAY, t.encoder_padding = 0, _.mf_size = U.ENCDELAY - U.MDCTDELAY, t.findReplayGain = !1, t.decode_on_the_fly = !1, _.decode_on_the_fly = !1, _.findReplayGain = !1, _.findPeakSample = !1, _.RadioGain = 0, _.AudiophileGain = 0, _.noclipGainChange = 0, _.noclipScale = -1, t.preset = 0, t.write_id3tag_automatic = !0, 0;
        }
        this.lame_init = function() {
            var t = new f0();
            return P(t), t.lame_allocated_gfp = 1, t;
        };
        function E(t) {
            return t > 1 ? 0 : t <= 0 ? 1 : Math.cos(Math.PI / 2 * t);
        }
        this.nearestBitrateFullIndex = function(t) {
            var _ = [
                8,
                16,
                24,
                32,
                40,
                48,
                56,
                64,
                80,
                96,
                112,
                128,
                160,
                192,
                224,
                256,
                320
            ], S0 = 0, E0 = 0, V0 = 0, H0 = 0;
            H0 = _[16], V0 = 16, E0 = _[16], S0 = 16;
            for(var y0 = 0; y0 < 16; y0++)if (Math.max(t, _[y0 + 1]) != t) {
                H0 = _[y0 + 1], V0 = y0 + 1, E0 = _[y0], S0 = y0;
                break;
            }
            return H0 - t > t - E0 ? S0 : V0;
        };
        function i(t, _) {
            var S0 = 44100;
            return _ >= 48e3 ? S0 = 48e3 : _ >= 44100 ? S0 = 44100 : _ >= 32e3 ? S0 = 32e3 : _ >= 24e3 ? S0 = 24e3 : _ >= 22050 ? S0 = 22050 : _ >= 16e3 ? S0 = 16e3 : _ >= 12e3 ? S0 = 12e3 : _ >= 11025 ? S0 = 11025 : _ >= 8e3 && (S0 = 8e3), t == -1 ? S0 : (t <= 15960 && (S0 = 44100), t <= 15250 && (S0 = 32e3), t <= 11220 && (S0 = 24e3), t <= 9970 && (S0 = 22050), t <= 7230 && (S0 = 16e3), t <= 5420 && (S0 = 12e3), t <= 4510 && (S0 = 11025), t <= 3970 && (S0 = 8e3), _ < S0 ? _ > 44100 ? 48e3 : _ > 32e3 ? 44100 : _ > 24e3 ? 32e3 : _ > 22050 ? 24e3 : _ > 16e3 ? 22050 : _ > 12e3 ? 16e3 : _ > 11025 ? 12e3 : _ > 8e3 ? 11025 : 8e3 : S0);
        }
        function s(t, _) {
            switch(t){
                case 44100:
                    return _.version = 1, 0;
                case 48e3:
                    return _.version = 1, 1;
                case 32e3:
                    return _.version = 1, 2;
                case 22050:
                    return _.version = 0, 0;
                case 24e3:
                    return _.version = 0, 1;
                case 16e3:
                    return _.version = 0, 2;
                case 11025:
                    return _.version = 0, 0;
                case 12e3:
                    return _.version = 0, 1;
                case 8e3:
                    return _.version = 0, 2;
                default:
                    return _.version = 0, -1;
            }
        }
        function r(t, _, S0) {
            S0 < 16e3 && (_ = 2);
            for(var E0 = t0.bitrate_table[_][1], V0 = 2; V0 <= 14; V0++)t0.bitrate_table[_][V0] > 0 && Math.abs(t0.bitrate_table[_][V0] - t) < Math.abs(E0 - t) && (E0 = t0.bitrate_table[_][V0]);
            return E0;
        }
        function n(t, _, S0) {
            S0 < 16e3 && (_ = 2);
            for(var E0 = 0; E0 <= 14; E0++)if (t0.bitrate_table[_][E0] > 0 && t0.bitrate_table[_][E0] == t) return E0;
            return -1;
        }
        function f(t, _) {
            var S0 = [
                new V(8, 2e3),
                new V(16, 3700),
                new V(24, 3900),
                new V(32, 5500),
                new V(40, 7e3),
                new V(48, 7500),
                new V(56, 1e4),
                new V(64, 11e3),
                new V(80, 13500),
                new V(96, 15100),
                new V(112, 15600),
                new V(128, 17e3),
                new V(160, 17500),
                new V(192, 18600),
                new V(224, 19400),
                new V(256, 19700),
                new V(320, 20500)
            ], E0 = u.nearestBitrateFullIndex(_);
            t.lowerlimit = S0[E0].lowpass;
        }
        function Y(t) {
            var _ = t.internal_flags, S0 = 32, E0 = -1;
            if (_.lowpass1 > 0) {
                for(var V0 = 999, H0 = 0; H0 <= 31; H0++){
                    var y0 = H0 / 31;
                    y0 >= _.lowpass2 && (S0 = Math.min(S0, H0)), _.lowpass1 < y0 && y0 < _.lowpass2 && (V0 = Math.min(V0, H0));
                }
                V0 == 999 ? _.lowpass1 = (S0 - 0.75) / 31 : _.lowpass1 = (V0 - 0.75) / 31, _.lowpass2 = S0 / 31;
            }
            if (_.highpass2 > 0 && _.highpass2 < 0.9 * (0.75 / 31) && (_.highpass1 = 0, _.highpass2 = 0, Z.err.println(`Warning: highpass filter disabled.  highpass frequency too small
`)), _.highpass2 > 0) {
                for(var T0 = -1, H0 = 0; H0 <= 31; H0++){
                    var y0 = H0 / 31;
                    y0 <= _.highpass1 && (E0 = Math.max(E0, H0)), _.highpass1 < y0 && y0 < _.highpass2 && (T0 = Math.max(T0, H0));
                }
                _.highpass1 = E0 / 31, T0 == -1 ? _.highpass2 = (E0 + 0.75) / 31 : _.highpass2 = (T0 + 0.75) / 31;
            }
            for(var H0 = 0; H0 < 32; H0++){
                var F0, I0, y0 = H0 / 31;
                _.highpass2 > _.highpass1 ? F0 = E((_.highpass2 - y0) / (_.highpass2 - _.highpass1 + 1e-20)) : F0 = 1, _.lowpass2 > _.lowpass1 ? I0 = E((y0 - _.lowpass1) / (_.lowpass2 - _.lowpass1 + 1e-20)) : I0 = 1, _.amp_filter[H0] = F0 * I0;
            }
        }
        function J(t) {
            var _ = t.internal_flags;
            switch(t.quality){
                default:
                case 9:
                    _.psymodel = 0, _.noise_shaping = 0, _.noise_shaping_amp = 0, _.noise_shaping_stop = 0, _.use_best_huffman = 0, _.full_outer_loop = 0;
                    break;
                case 8:
                    t.quality = 7;
                case 7:
                    _.psymodel = 1, _.noise_shaping = 0, _.noise_shaping_amp = 0, _.noise_shaping_stop = 0, _.use_best_huffman = 0, _.full_outer_loop = 0;
                    break;
                case 6:
                    _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.noise_shaping_amp = 0, _.noise_shaping_stop = 0, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 0, _.full_outer_loop = 0;
                    break;
                case 5:
                    _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.noise_shaping_amp = 0, _.noise_shaping_stop = 0, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 0, _.full_outer_loop = 0;
                    break;
                case 4:
                    _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.noise_shaping_amp = 0, _.noise_shaping_stop = 0, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 1, _.full_outer_loop = 0;
                    break;
                case 3:
                    _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.noise_shaping_amp = 1, _.noise_shaping_stop = 1, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 1, _.full_outer_loop = 0;
                    break;
                case 2:
                    _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.substep_shaping == 0 && (_.substep_shaping = 2), _.noise_shaping_amp = 1, _.noise_shaping_stop = 1, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 1, _.full_outer_loop = 0;
                    break;
                case 1:
                    _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.substep_shaping == 0 && (_.substep_shaping = 2), _.noise_shaping_amp = 2, _.noise_shaping_stop = 1, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 1, _.full_outer_loop = 0;
                    break;
                case 0:
                    _.psymodel = 1, _.noise_shaping == 0 && (_.noise_shaping = 1), _.substep_shaping == 0 && (_.substep_shaping = 2), _.noise_shaping_amp = 2, _.noise_shaping_stop = 1, _.subblock_gain == -1 && (_.subblock_gain = 1), _.use_best_huffman = 1, _.full_outer_loop = 0;
                    break;
            }
        }
        function T(t) {
            var _ = t.internal_flags;
            t.frameNum = 0, t.write_id3tag_automatic && b.id3tag_write_v2(t), _.bitrate_stereoMode_Hist = W([
                16,
                5
            ]), _.bitrate_blockType_Hist = W([
                16,
                6
            ]), _.PeakSample = 0, t.bWriteVbrTag && v0.InitVbrTag(t);
        }
        this.lame_init_params = function(t) {
            var _ = t.internal_flags;
            if (_.Class_ID = 0, _.ATH == null && (_.ATH = new m()), _.PSY == null && (_.PSY = new S()), _.rgdata == null && (_.rgdata = new O()), _.channels_in = t.num_channels, _.channels_in == 1 && (t.mode = o.MONO), _.channels_out = t.mode == o.MONO ? 1 : 2, _.mode_ext = U.MPG_MD_MS_LR, t.mode == o.MONO && (t.force_ms = !1), t.VBR == X.vbr_off && t.VBR_mean_bitrate_kbps != 128 && t.brate == 0 && (t.brate = t.VBR_mean_bitrate_kbps), t.VBR == X.vbr_off || t.VBR == X.vbr_mtrh || t.VBR == X.vbr_mt || (t.free_format = !1), t.VBR == X.vbr_off && t.brate == 0 && K.EQ(t.compression_ratio, 0) && (t.compression_ratio = 11.025), t.VBR == X.vbr_off && t.compression_ratio > 0 && (t.out_samplerate == 0 && (t.out_samplerate = map2MP3Frequency(int(0.97 * t.in_samplerate))), t.brate = 0 | t.out_samplerate * 16 * _.channels_out / (1e3 * t.compression_ratio), _.samplerate_index = s(t.out_samplerate, t), t.free_format || (t.brate = r(t.brate, t.version, t.out_samplerate))), t.out_samplerate != 0 && (t.out_samplerate < 16e3 ? (t.VBR_mean_bitrate_kbps = Math.max(t.VBR_mean_bitrate_kbps, 8), t.VBR_mean_bitrate_kbps = Math.min(t.VBR_mean_bitrate_kbps, 64)) : t.out_samplerate < 32e3 ? (t.VBR_mean_bitrate_kbps = Math.max(t.VBR_mean_bitrate_kbps, 8), t.VBR_mean_bitrate_kbps = Math.min(t.VBR_mean_bitrate_kbps, 160)) : (t.VBR_mean_bitrate_kbps = Math.max(t.VBR_mean_bitrate_kbps, 32), t.VBR_mean_bitrate_kbps = Math.min(t.VBR_mean_bitrate_kbps, 320))), t.lowpassfreq == 0) {
                var S0 = 16e3;
                switch(t.VBR){
                    case X.vbr_off:
                        var E0 = new L();
                        f(E0, t.brate), S0 = E0.lowerlimit;
                        break;
                    case X.vbr_abr:
                        var E0 = new L();
                        f(E0, t.VBR_mean_bitrate_kbps), S0 = E0.lowerlimit;
                        break;
                    case X.vbr_rh:
                        var V0 = [
                            19500,
                            19e3,
                            18600,
                            18e3,
                            17500,
                            16e3,
                            15600,
                            14900,
                            12500,
                            1e4,
                            3950
                        ];
                        if (0 <= t.VBR_q && t.VBR_q <= 9) {
                            var H0 = V0[t.VBR_q], y0 = V0[t.VBR_q + 1], T0 = t.VBR_q_frac;
                            S0 = linear_int(H0, y0, T0);
                        } else S0 = 19500;
                        break;
                    default:
                        var V0 = [
                            19500,
                            19e3,
                            18500,
                            18e3,
                            17500,
                            16500,
                            15500,
                            14500,
                            12500,
                            9500,
                            3950
                        ];
                        if (0 <= t.VBR_q && t.VBR_q <= 9) {
                            var H0 = V0[t.VBR_q], y0 = V0[t.VBR_q + 1], T0 = t.VBR_q_frac;
                            S0 = linear_int(H0, y0, T0);
                        } else S0 = 19500;
                }
                t.mode == o.MONO && (t.VBR == X.vbr_off || t.VBR == X.vbr_abr) && (S0 *= 1.5), t.lowpassfreq = S0 | 0;
            }
            if (t.out_samplerate == 0 && (2 * t.lowpassfreq > t.in_samplerate && (t.lowpassfreq = t.in_samplerate / 2), t.out_samplerate = i(t.lowpassfreq | 0, t.in_samplerate)), t.lowpassfreq = Math.min(20500, t.lowpassfreq), t.lowpassfreq = Math.min(t.out_samplerate / 2, t.lowpassfreq), t.VBR == X.vbr_off && (t.compression_ratio = t.out_samplerate * 16 * _.channels_out / (1e3 * t.brate)), t.VBR == X.vbr_abr && (t.compression_ratio = t.out_samplerate * 16 * _.channels_out / (1e3 * t.VBR_mean_bitrate_kbps)), t.bWriteVbrTag || (t.findReplayGain = !1, t.decode_on_the_fly = !1, _.findPeakSample = !1), _.findReplayGain = t.findReplayGain, _.decode_on_the_fly = t.decode_on_the_fly, _.decode_on_the_fly && (_.findPeakSample = !0), _.findReplayGain && l.InitGainAnalysis(_.rgdata, t.out_samplerate) == GainAnalysis.INIT_GAIN_ANALYSIS_ERROR) return t.internal_flags = null, -6;
            switch(_.decode_on_the_fly && !t.decode_only && (_.hip != null && a.hip_decode_exit(_.hip), _.hip = a.hip_decode_init()), _.mode_gr = t.out_samplerate <= 24e3 ? 1 : 2, t.framesize = 576 * _.mode_gr, t.encoder_delay = U.ENCDELAY, _.resample_ratio = t.in_samplerate / t.out_samplerate, t.VBR){
                case X.vbr_mt:
                case X.vbr_rh:
                case X.vbr_mtrh:
                    var F0 = [
                        5.7,
                        6.5,
                        7.3,
                        8.2,
                        10,
                        11.9,
                        13,
                        14,
                        15,
                        16.5
                    ];
                    t.compression_ratio = F0[t.VBR_q];
                    break;
                case X.vbr_abr:
                    t.compression_ratio = t.out_samplerate * 16 * _.channels_out / (1e3 * t.VBR_mean_bitrate_kbps);
                    break;
                default:
                    t.compression_ratio = t.out_samplerate * 16 * _.channels_out / (1e3 * t.brate);
                    break;
            }
            if (t.mode == o.NOT_SET && (t.mode = o.JOINT_STEREO), t.highpassfreq > 0 ? (_.highpass1 = 2 * t.highpassfreq, t.highpasswidth >= 0 ? _.highpass2 = 2 * (t.highpassfreq + t.highpasswidth) : _.highpass2 = 2 * t.highpassfreq, _.highpass1 /= t.out_samplerate, _.highpass2 /= t.out_samplerate) : (_.highpass1 = 0, _.highpass2 = 0), t.lowpassfreq > 0 ? (_.lowpass2 = 2 * t.lowpassfreq, t.lowpasswidth >= 0 ? (_.lowpass1 = 2 * (t.lowpassfreq - t.lowpasswidth), _.lowpass1 < 0 && (_.lowpass1 = 0)) : _.lowpass1 = 2 * t.lowpassfreq, _.lowpass1 /= t.out_samplerate, _.lowpass2 /= t.out_samplerate) : (_.lowpass1 = 0, _.lowpass2 = 0), Y(t), _.samplerate_index = s(t.out_samplerate, t), _.samplerate_index < 0) return t.internal_flags = null, -1;
            if (t.VBR == X.vbr_off) {
                if (t.free_format) _.bitrate_index = 0;
                else if (t.brate = r(t.brate, t.version, t.out_samplerate), _.bitrate_index = n(t.brate, t.version, t.out_samplerate), _.bitrate_index <= 0) return t.internal_flags = null, -1;
            } else _.bitrate_index = 1;
            t.analysis && (t.bWriteVbrTag = !1), _.pinfo != null && (t.bWriteVbrTag = !1), M.init_bit_stream_w(_);
            for(var I0 = _.samplerate_index + 3 * t.version + 6 * (t.out_samplerate < 16e3 ? 1 : 0), b0 = 0; b0 < U.SBMAX_l + 1; b0++)_.scalefac_band.l[b0] = H.sfBandIndex[I0].l[b0];
            for(var b0 = 0; b0 < U.PSFB21 + 1; b0++){
                var G0 = (_.scalefac_band.l[22] - _.scalefac_band.l[21]) / U.PSFB21, e1 = _.scalefac_band.l[21] + b0 * G0;
                _.scalefac_band.psfb21[b0] = e1;
            }
            _.scalefac_band.psfb21[U.PSFB21] = 576;
            for(var b0 = 0; b0 < U.SBMAX_s + 1; b0++)_.scalefac_band.s[b0] = H.sfBandIndex[I0].s[b0];
            for(var b0 = 0; b0 < U.PSFB12 + 1; b0++){
                var G0 = (_.scalefac_band.s[13] - _.scalefac_band.s[12]) / U.PSFB12, e1 = _.scalefac_band.s[12] + b0 * G0;
                _.scalefac_band.psfb12[b0] = e1;
            }
            _.scalefac_band.psfb12[U.PSFB12] = 192, t.version == 1 ? _.sideinfo_len = _.channels_out == 1 ? 21 : 36 : _.sideinfo_len = _.channels_out == 1 ? 13 : 21, t.error_protection && (_.sideinfo_len += 2), T(t), _.Class_ID = N;
            var Y0;
            for(Y0 = 0; Y0 < 19; Y0++)_.nsPsy.pefirbuf[Y0] = 700 * _.mode_gr * _.channels_out;
            t.ATHtype == -1 && (t.ATHtype = 4);
            switch(D(t.VBR_q <= 9), D(t.VBR_q >= 0), t.VBR){
                case X.vbr_mt:
                    t.VBR = X.vbr_mtrh;
                case X.vbr_mtrh:
                    t.useTemporal == null && (t.useTemporal = !1), p.apply_preset(t, 500 - t.VBR_q * 10, 0), t.quality < 0 && (t.quality = LAME_DEFAULT_QUALITY), t.quality < 5 && (t.quality = 0), t.quality > 5 && (t.quality = 5), _.PSY.mask_adjust = t.maskingadjust, _.PSY.mask_adjust_short = t.maskingadjust_short, t.experimentalY ? _.sfb21_extra = !1 : _.sfb21_extra = t.out_samplerate > 44e3, _.iteration_loop = new VBRNewIterationLoop(B);
                    break;
                case X.vbr_rh:
                    p.apply_preset(t, 500 - t.VBR_q * 10, 0), _.PSY.mask_adjust = t.maskingadjust, _.PSY.mask_adjust_short = t.maskingadjust_short, t.experimentalY ? _.sfb21_extra = !1 : _.sfb21_extra = t.out_samplerate > 44e3, t.quality > 6 && (t.quality = 6), t.quality < 0 && (t.quality = LAME_DEFAULT_QUALITY), _.iteration_loop = new VBROldIterationLoop(B);
                    break;
                default:
                    var v;
                    _.sfb21_extra = !1, t.quality < 0 && (t.quality = LAME_DEFAULT_QUALITY), v = t.VBR, v == X.vbr_off && (t.VBR_mean_bitrate_kbps = t.brate), p.apply_preset(t, t.VBR_mean_bitrate_kbps, 0), t.VBR = v, _.PSY.mask_adjust = t.maskingadjust, _.PSY.mask_adjust_short = t.maskingadjust_short, v == X.vbr_off ? _.iteration_loop = new s0(B) : _.iteration_loop = new ABRIterationLoop(B);
                    break;
            }
            if (D(t.scale >= 0), t.VBR != X.vbr_off) {
                if (_.VBR_min_bitrate = 1, _.VBR_max_bitrate = 14, t.out_samplerate < 16e3 && (_.VBR_max_bitrate = 8), t.VBR_min_bitrate_kbps != 0 && (t.VBR_min_bitrate_kbps = r(t.VBR_min_bitrate_kbps, t.version, t.out_samplerate), _.VBR_min_bitrate = n(t.VBR_min_bitrate_kbps, t.version, t.out_samplerate), _.VBR_min_bitrate < 0) || t.VBR_max_bitrate_kbps != 0 && (t.VBR_max_bitrate_kbps = r(t.VBR_max_bitrate_kbps, t.version, t.out_samplerate), _.VBR_max_bitrate = n(t.VBR_max_bitrate_kbps, t.version, t.out_samplerate), _.VBR_max_bitrate < 0)) return -1;
                t.VBR_min_bitrate_kbps = t0.bitrate_table[t.version][_.VBR_min_bitrate], t.VBR_max_bitrate_kbps = t0.bitrate_table[t.version][_.VBR_max_bitrate], t.VBR_mean_bitrate_kbps = Math.min(t0.bitrate_table[t.version][_.VBR_max_bitrate], t.VBR_mean_bitrate_kbps), t.VBR_mean_bitrate_kbps = Math.max(t0.bitrate_table[t.version][_.VBR_min_bitrate], t.VBR_mean_bitrate_kbps);
            }
            return t.tune && (_.PSY.mask_adjust += t.tune_value_a, _.PSY.mask_adjust_short += t.tune_value_a), J(t), D(t.scale >= 0), t.athaa_type < 0 ? _.ATH.useAdjust = 3 : _.ATH.useAdjust = t.athaa_type, _.ATH.aaSensitivityP = Math.pow(10, t.athaa_sensitivity / -10), t.short_blocks == null && (t.short_blocks = z.short_block_allowed), t.short_blocks == z.short_block_allowed && (t.mode == o.JOINT_STEREO || t.mode == o.STEREO) && (t.short_blocks = z.short_block_coupled), t.quant_comp < 0 && (t.quant_comp = 1), t.quant_comp_short < 0 && (t.quant_comp_short = 0), t.msfix < 0 && (t.msfix = 0), t.exp_nspsytune = t.exp_nspsytune | 1, t.internal_flags.nsPsy.attackthre < 0 && (t.internal_flags.nsPsy.attackthre = g.NSATTACKTHRE), t.internal_flags.nsPsy.attackthre_s < 0 && (t.internal_flags.nsPsy.attackthre_s = g.NSATTACKTHRE_S), D(t.scale >= 0), t.scale < 0 && (t.scale = 1), t.ATHtype < 0 && (t.ATHtype = 4), t.ATHcurve < 0 && (t.ATHcurve = 4), t.athaa_loudapprox < 0 && (t.athaa_loudapprox = 2), t.interChRatio < 0 && (t.interChRatio = 0), t.useTemporal == null && (t.useTemporal = !0), _.slot_lag = _.frac_SpF = 0, t.VBR == X.vbr_off && (_.slot_lag = _.frac_SpF = (t.version + 1) * 72e3 * t.brate % t.out_samplerate | 0), H.iteration_init(t), I.psymodel_init(t), D(t.scale >= 0), 0;
        };
        function q(t, _) {
            (t.in_buffer_0 == null || t.in_buffer_nsamples < _) && (t.in_buffer_0 = u0(_), t.in_buffer_1 = u0(_), t.in_buffer_nsamples = _);
        }
        this.lame_encode_flush = function(t, _, S0, E0) {
            var V0 = t.internal_flags, H0 = Q([
                2,
                1152
            ]), y0 = 0, T0, F0, I0, b0, G0 = V0.mf_samples_to_encode - U.POSTDELAY, e1 = i0(t);
            if (V0.mf_samples_to_encode < 1) return 0;
            for(T0 = 0, t.in_samplerate != t.out_samplerate && (G0 += 16 * t.out_samplerate / t.in_samplerate), I0 = t.framesize - G0 % t.framesize, I0 < 576 && (I0 += t.framesize), t.encoder_padding = I0, b0 = (G0 + I0) / t.framesize; b0 > 0 && y0 >= 0;){
                var Y0 = e1 - V0.mf_size, v = t.frameNum;
                Y0 *= t.in_samplerate, Y0 /= t.out_samplerate, Y0 > 1152 && (Y0 = 1152), Y0 < 1 && (Y0 = 1), F0 = E0 - T0, E0 == 0 && (F0 = 0), y0 = this.lame_encode_buffer(t, H0[0], H0[1], Y0, _, S0, F0), S0 += y0, T0 += y0, b0 -= v != t.frameNum ? 1 : 0;
            }
            if (V0.mf_samples_to_encode = 0, y0 < 0 || (F0 = E0 - T0, E0 == 0 && (F0 = 0), M.flush_bitstream(t), y0 = M.copy_buffer(V0, _, S0, F0, 1), y0 < 0)) return y0;
            if (S0 += y0, T0 += y0, F0 = E0 - T0, E0 == 0 && (F0 = 0), t.write_id3tag_automatic) {
                if (b.id3tag_write_v1(t), y0 = M.copy_buffer(V0, _, S0, F0, 0), y0 < 0) return y0;
                T0 += y0;
            }
            return T0;
        }, this.lame_encode_buffer = function(t, _, S0, E0, V0, H0, y0) {
            var T0 = t.internal_flags, F0 = [
                null,
                null
            ];
            if (T0.Class_ID != N) return -3;
            if (E0 == 0) return 0;
            q(T0, E0), F0[0] = T0.in_buffer_0, F0[1] = T0.in_buffer_1;
            for(var I0 = 0; I0 < E0; I0++)F0[0][I0] = _[I0], T0.channels_in > 1 && (F0[1][I0] = S0[I0]);
            return h0(t, F0[0], F0[1], E0, V0, H0, y0);
        };
        function i0(t) {
            var _ = U.BLKSIZE + t.framesize - U.FFTOFFSET;
            return _ = Math.max(_, 512 + t.framesize - 32), _;
        }
        function h0(t, _, S0, E0, V0, H0, y0) {
            var T0 = t.internal_flags, F0 = 0, I0, b0, G0, e1, Y0, v = [
                null,
                null
            ], h = [
                null,
                null
            ];
            if (T0.Class_ID != N) return -3;
            if (E0 == 0) return 0;
            if (Y0 = M.copy_buffer(T0, V0, H0, y0, 0), Y0 < 0) return Y0;
            if (H0 += Y0, F0 += Y0, h[0] = _, h[1] = S0, K.NEQ(t.scale, 0) && K.NEQ(t.scale, 1)) for(b0 = 0; b0 < E0; ++b0)h[0][b0] *= t.scale, T0.channels_out == 2 && (h[1][b0] *= t.scale);
            if (K.NEQ(t.scale_left, 0) && K.NEQ(t.scale_left, 1)) for(b0 = 0; b0 < E0; ++b0)h[0][b0] *= t.scale_left;
            if (K.NEQ(t.scale_right, 0) && K.NEQ(t.scale_right, 1)) for(b0 = 0; b0 < E0; ++b0)h[1][b0] *= t.scale_right;
            if (t.num_channels == 2 && T0.channels_out == 1) for(b0 = 0; b0 < E0; ++b0)h[0][b0] = 0.5 * (h[0][b0] + h[1][b0]), h[1][b0] = 0;
            e1 = i0(t), v[0] = T0.mfbuf[0], v[1] = T0.mfbuf[1];
            for(var x = 0; E0 > 0;){
                var y = [
                    null,
                    null
                ], k = 0, c = 0;
                y[0] = h[0], y[1] = h[1];
                var C = new M0();
                if (f1(t, v, y, x, E0, C), k = C.n_in, c = C.n_out, T0.findReplayGain && !T0.decode_on_the_fly && l.AnalyzeSamples(T0.rgdata, v[0], T0.mf_size, v[1], T0.mf_size, c, T0.channels_out) == GainAnalysis.GAIN_ANALYSIS_ERROR) return -6;
                if (E0 -= k, x += k, T0.channels_out, T0.mf_size += c, D(T0.mf_size <= A.MFSIZE), T0.mf_samples_to_encode < 1 && (T0.mf_samples_to_encode = U.ENCDELAY + U.POSTDELAY), T0.mf_samples_to_encode += c, T0.mf_size >= e1) {
                    var G = y0 - F0;
                    if (y0 == 0 && (G = 0), I0 = d0(t, v[0], v[1], V0, H0, G), I0 < 0) return I0;
                    for(H0 += I0, F0 += I0, T0.mf_size -= t.framesize, T0.mf_samples_to_encode -= t.framesize, G0 = 0; G0 < T0.channels_out; G0++)for(b0 = 0; b0 < T0.mf_size; b0++)v[G0][b0] = v[G0][b0 + t.framesize];
                }
            }
            return F0;
        }
        function d0(t, _, S0, E0, V0, H0) {
            var y0 = u.enc.lame_encode_mp3_frame(t, _, S0, E0, V0, H0);
            return t.frameNum++, y0;
        }
        function M0() {
            this.n_in = 0, this.n_out = 0;
        }
        function R0() {
            this.num_used = 0;
        }
        function A0(t, _) {
            return _ != 0 ? A0(_, t % _) : t;
        }
        function w0(t, _, S0) {
            var E0 = Math.PI * _;
            t /= S0, t < 0 && (t = 0), t > 1 && (t = 1);
            var V0 = t - 0.5, H0 = 0.42 - 0.5 * Math.cos(2 * t * Math.PI) + 0.08 * Math.cos(4 * t * Math.PI);
            return Math.abs(V0) < 1e-9 ? E0 / Math.PI : H0 * Math.sin(S0 * E0 * V0) / (Math.PI * S0 * V0);
        }
        function $0(t, _, S0, E0, V0, H0, y0, T0, F0) {
            var I0 = t.internal_flags, b0, G0 = 0, e1, Y0 = t.out_samplerate / A0(t.out_samplerate, t.in_samplerate);
            Y0 > A.BPC && (Y0 = A.BPC);
            var v = Math.abs(I0.resample_ratio - Math.floor(0.5 + I0.resample_ratio)) < 1e-4 ? 1 : 0, h = 1 / I0.resample_ratio;
            h > 1 && (h = 1);
            var x = 31;
            x % 2 == 0 && --x, x += v;
            var y = x + 1;
            if (I0.fill_buffer_resample_init == 0) {
                for(I0.inbuf_old[0] = u0(y), I0.inbuf_old[1] = u0(y), b0 = 0; b0 <= 2 * Y0; ++b0)I0.blackfilt[b0] = u0(y);
                for(I0.itime[0] = 0, I0.itime[1] = 0, G0 = 0; G0 <= 2 * Y0; G0++){
                    var k = 0, c = (G0 - Y0) / (2 * Y0);
                    for(b0 = 0; b0 <= x; b0++)k += I0.blackfilt[G0][b0] = w0(b0 - c, h, x);
                    for(b0 = 0; b0 <= x; b0++)I0.blackfilt[G0][b0] /= k;
                }
                I0.fill_buffer_resample_init = 1;
            }
            var C = I0.inbuf_old[F0];
            for(e1 = 0; e1 < E0; e1++){
                var G, F;
                if (G = e1 * I0.resample_ratio, G0 = 0 | Math.floor(G - I0.itime[F0]), x + G0 - x / 2 >= y0) break;
                var c = G - I0.itime[F0] - (G0 + 0.5 * (x % 2));
                F = 0 | Math.floor(c * 2 * Y0 + Y0 + 0.5);
                var e0 = 0;
                for(b0 = 0; b0 <= x; ++b0){
                    var $ = 0 | b0 + G0 - x / 2, a0;
                    a0 = $ < 0 ? C[y + $] : V0[H0 + $], e0 += a0 * I0.blackfilt[F][b0];
                }
                _[S0 + e1] = e0;
            }
            if (T0.num_used = Math.min(y0, x + G0 - x / 2), I0.itime[F0] += T0.num_used - e1 * I0.resample_ratio, T0.num_used >= y) for(b0 = 0; b0 < y; b0++)C[b0] = V0[H0 + T0.num_used + b0 - y];
            else {
                var m0 = y - T0.num_used;
                for(b0 = 0; b0 < m0; ++b0)C[b0] = C[b0 + T0.num_used];
                for(G0 = 0; b0 < y; ++b0, ++G0)C[b0] = V0[H0 + G0];
                D(G0 == T0.num_used);
            }
            return e1;
        }
        function f1(t, _, S0, E0, V0, H0) {
            var y0 = t.internal_flags;
            if (y0.resample_ratio < 0.9999 || y0.resample_ratio > 1.0001) for(var T0 = 0; T0 < y0.channels_out; T0++){
                var F0 = new R0();
                H0.n_out = $0(t, _[T0], y0.mf_size, t.framesize, S0[T0], E0, V0, F0, T0), H0.n_in = F0.num_used;
            }
            else {
                H0.n_out = Math.min(t.framesize, V0), H0.n_in = H0.n_out;
                for(var I0 = 0; I0 < H0.n_out; ++I0)_[0][y0.mf_size + I0] = S0[0][E0 + I0], y0.channels_out == 2 && (_[1][y0.mf_size + I0] = S0[1][E0 + I0]);
            }
        }
    }
    return Te = R, Te;
}
var p2 = Q0, M1 = p2.VbrMode;
function H2() {
    var w = Oe();
    function Z(A, m, O, s0, K, t0, U, R, o, u, d, e, l, M, p) {
        this.vbr_q = A, this.quant_comp = m, this.quant_comp_s = O, this.expY = s0, this.st_lrm = K, this.st_s = t0, this.masking_adj = U, this.masking_adj_short = R, this.ath_lower = o, this.ath_curve = u, this.ath_sensitivity = d, this.interch = e, this.safejoint = l, this.sfb21mod = M, this.msfix = p;
    }
    function X(A, m, O, s0, K, t0, U, R, o, u, d, e, l, M) {
        this.quant_comp = m, this.quant_comp_s = O, this.safejoint = s0, this.nsmsfix = K, this.st_lrm = t0, this.st_s = U, this.nsbass = R, this.scale = o, this.masking_adj = u, this.ath_lower = d, this.ath_curve = e, this.interch = l, this.sfscale = M;
    }
    var z;
    this.setModules = function(A) {
        z = A;
    };
    var u0 = [
        new Z(0, 9, 9, 0, 5.2, 125, -4.2, -6.3, 4.8, 1, 0, 0, 2, 21, 0.97),
        new Z(1, 9, 9, 0, 5.3, 125, -3.6, -5.6, 4.5, 1.5, 0, 0, 2, 21, 1.35),
        new Z(2, 9, 9, 0, 5.6, 125, -2.2, -3.5, 2.8, 2, 0, 0, 2, 21, 1.49),
        new Z(3, 9, 9, 1, 5.8, 130, -1.8, -2.8, 2.6, 3, -4, 0, 2, 20, 1.64),
        new Z(4, 9, 9, 1, 6, 135, -0.7, -1.1, 1.1, 3.5, -8, 0, 2, 0, 1.79),
        new Z(5, 9, 9, 1, 6.4, 140, 0.5, 0.4, -7.5, 4, -12, 2e-4, 0, 0, 1.95),
        new Z(6, 9, 9, 1, 6.6, 145, 0.67, 0.65, -14.7, 6.5, -19, 4e-4, 0, 0, 2.3),
        new Z(7, 9, 9, 1, 6.6, 145, 0.8, 0.75, -19.7, 8, -22, 6e-4, 0, 0, 2.7),
        new Z(8, 9, 9, 1, 6.6, 145, 1.2, 1.15, -27.5, 10, -23, 7e-4, 0, 0, 0),
        new Z(9, 9, 9, 1, 6.6, 145, 1.6, 1.6, -36, 11, -25, 8e-4, 0, 0, 0),
        new Z(10, 9, 9, 1, 6.6, 145, 2, 2, -36, 12, -25, 8e-4, 0, 0, 0)
    ], W = [
        new Z(0, 9, 9, 0, 4.2, 25, -7, -4, 7.5, 1, 0, 0, 2, 26, 0.97),
        new Z(1, 9, 9, 0, 4.2, 25, -5.6, -3.6, 4.5, 1.5, 0, 0, 2, 21, 1.35),
        new Z(2, 9, 9, 0, 4.2, 25, -4.4, -1.8, 2, 2, 0, 0, 2, 18, 1.49),
        new Z(3, 9, 9, 1, 4.2, 25, -3.4, -1.25, 1.1, 3, -4, 0, 2, 15, 1.64),
        new Z(4, 9, 9, 1, 4.2, 25, -2.2, 0.1, 0, 3.5, -8, 0, 2, 0, 1.79),
        new Z(5, 9, 9, 1, 4.2, 25, -1, 1.65, -7.7, 4, -12, 2e-4, 0, 0, 1.95),
        new Z(6, 9, 9, 1, 4.2, 25, -0, 2.47, -7.7, 6.5, -19, 4e-4, 0, 0, 2),
        new Z(7, 9, 9, 1, 4.2, 25, 0.5, 2, -14.5, 8, -22, 6e-4, 0, 0, 2),
        new Z(8, 9, 9, 1, 4.2, 25, 1, 2.4, -22, 10, -23, 7e-4, 0, 0, 2),
        new Z(9, 9, 9, 1, 4.2, 25, 1.5, 2.95, -30, 11, -25, 8e-4, 0, 0, 2),
        new Z(10, 9, 9, 1, 4.2, 25, 2, 2.95, -36, 12, -30, 8e-4, 0, 0, 2)
    ];
    function Q(A, m, O) {
        var s0 = A.VBR == M1.vbr_rh ? u0 : W, K = A.VBR_q_frac, t0 = s0[m], U = s0[m + 1], R = t0;
        t0.st_lrm = t0.st_lrm + K * (U.st_lrm - t0.st_lrm), t0.st_s = t0.st_s + K * (U.st_s - t0.st_s), t0.masking_adj = t0.masking_adj + K * (U.masking_adj - t0.masking_adj), t0.masking_adj_short = t0.masking_adj_short + K * (U.masking_adj_short - t0.masking_adj_short), t0.ath_lower = t0.ath_lower + K * (U.ath_lower - t0.ath_lower), t0.ath_curve = t0.ath_curve + K * (U.ath_curve - t0.ath_curve), t0.ath_sensitivity = t0.ath_sensitivity + K * (U.ath_sensitivity - t0.ath_sensitivity), t0.interch = t0.interch + K * (U.interch - t0.interch), t0.msfix = t0.msfix + K * (U.msfix - t0.msfix), f0(A, R.vbr_q), O != 0 ? A.quant_comp = R.quant_comp : Math.abs(A.quant_comp - -1) > 0 || (A.quant_comp = R.quant_comp), O != 0 ? A.quant_comp_short = R.quant_comp_s : Math.abs(A.quant_comp_short - -1) > 0 || (A.quant_comp_short = R.quant_comp_s), R.expY != 0 && (A.experimentalY = R.expY != 0), O != 0 ? A.internal_flags.nsPsy.attackthre = R.st_lrm : Math.abs(A.internal_flags.nsPsy.attackthre - -1) > 0 || (A.internal_flags.nsPsy.attackthre = R.st_lrm), O != 0 ? A.internal_flags.nsPsy.attackthre_s = R.st_s : Math.abs(A.internal_flags.nsPsy.attackthre_s - -1) > 0 || (A.internal_flags.nsPsy.attackthre_s = R.st_s), O != 0 ? A.maskingadjust = R.masking_adj : Math.abs(A.maskingadjust - 0) > 0 || (A.maskingadjust = R.masking_adj), O != 0 ? A.maskingadjust_short = R.masking_adj_short : Math.abs(A.maskingadjust_short - 0) > 0 || (A.maskingadjust_short = R.masking_adj_short), O != 0 ? A.ATHlower = -R.ath_lower / 10 : Math.abs(-A.ATHlower * 10 - 0) > 0 || (A.ATHlower = -R.ath_lower / 10), O != 0 ? A.ATHcurve = R.ath_curve : Math.abs(A.ATHcurve - -1) > 0 || (A.ATHcurve = R.ath_curve), O != 0 ? A.athaa_sensitivity = R.ath_sensitivity : Math.abs(A.athaa_sensitivity - -1) > 0 || (A.athaa_sensitivity = R.ath_sensitivity), R.interch > 0 && (O != 0 ? A.interChRatio = R.interch : Math.abs(A.interChRatio - -1) > 0 || (A.interChRatio = R.interch)), R.safejoint > 0 && (A.exp_nspsytune = A.exp_nspsytune | R.safejoint), R.sfb21mod > 0 && (A.exp_nspsytune = A.exp_nspsytune | R.sfb21mod << 20), O != 0 ? A.msfix = R.msfix : Math.abs(A.msfix - -1) > 0 || (A.msfix = R.msfix), O == 0 && (A.VBR_q = m, A.VBR_q_frac = K);
    }
    var D = [
        new X(8, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -30, 11, 12e-4, 1),
        /*   8, impossible to use in stereo */ new X(16, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -25, 11, 1e-3, 1),
        /*  16 */ new X(24, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -20, 11, 1e-3, 1),
        /*  24 */ new X(32, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -15, 11, 1e-3, 1),
        /*  32 */ new X(40, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -10, 11, 9e-4, 1),
        /*  40 */ new X(48, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -10, 11, 9e-4, 1),
        /*  48 */ new X(56, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -6, 11, 8e-4, 1),
        /*  56 */ new X(64, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, -2, 11, 8e-4, 1),
        /*  64 */ new X(80, 9, 9, 0, 0, 6.6, 145, 0, 0.95, 0, 0, 8, 7e-4, 1),
        /*  80 */ new X(96, 9, 9, 0, 2.5, 6.6, 145, 0, 0.95, 0, 1, 5.5, 6e-4, 1),
        /*  96 */ new X(112, 9, 9, 0, 2.25, 6.6, 145, 0, 0.95, 0, 2, 4.5, 5e-4, 1),
        /* 112 */ new X(128, 9, 9, 0, 1.95, 6.4, 140, 0, 0.95, 0, 3, 4, 2e-4, 1),
        /* 128 */ new X(160, 9, 9, 1, 1.79, 6, 135, 0, 0.95, -2, 5, 3.5, 0, 1),
        /* 160 */ new X(192, 9, 9, 1, 1.49, 5.6, 125, 0, 0.97, -4, 7, 3, 0, 0),
        /* 192 */ new X(224, 9, 9, 1, 1.25, 5.2, 125, 0, 0.98, -6, 9, 2, 0, 0),
        /* 224 */ new X(256, 9, 9, 1, 0.97, 5.2, 125, 0, 1, -8, 10, 1, 0, 0),
        /* 256 */ new X(320, 9, 9, 1, 0.9, 5.2, 125, 0, 1, -10, 12, 0, 0, 0)
    ];
    function g(A, m, O) {
        var s0 = m, K = z.nearestBitrateFullIndex(m);
        if (A.VBR = M1.vbr_abr, A.VBR_mean_bitrate_kbps = s0, A.VBR_mean_bitrate_kbps = Math.min(A.VBR_mean_bitrate_kbps, 320), A.VBR_mean_bitrate_kbps = Math.max(A.VBR_mean_bitrate_kbps, 8), A.brate = A.VBR_mean_bitrate_kbps, A.VBR_mean_bitrate_kbps > 320 && (A.disable_reservoir = !0), D[K].safejoint > 0 && (A.exp_nspsytune = A.exp_nspsytune | 2), D[K].sfscale > 0 && (A.internal_flags.noise_shaping = 2), Math.abs(D[K].nsbass) > 0) {
            var t0 = int(D[K].nsbass * 4);
            t0 < 0 && (t0 += 64), A.exp_nspsytune = A.exp_nspsytune | t0 << 2;
        }
        return O != 0 ? A.quant_comp = D[K].quant_comp : Math.abs(A.quant_comp - -1) > 0 || (A.quant_comp = D[K].quant_comp), O != 0 ? A.quant_comp_short = D[K].quant_comp_s : Math.abs(A.quant_comp_short - -1) > 0 || (A.quant_comp_short = D[K].quant_comp_s), O != 0 ? A.msfix = D[K].nsmsfix : Math.abs(A.msfix - -1) > 0 || (A.msfix = D[K].nsmsfix), O != 0 ? A.internal_flags.nsPsy.attackthre = D[K].st_lrm : Math.abs(A.internal_flags.nsPsy.attackthre - -1) > 0 || (A.internal_flags.nsPsy.attackthre = D[K].st_lrm), O != 0 ? A.internal_flags.nsPsy.attackthre_s = D[K].st_s : Math.abs(A.internal_flags.nsPsy.attackthre_s - -1) > 0 || (A.internal_flags.nsPsy.attackthre_s = D[K].st_s), O != 0 ? A.scale = D[K].scale : Math.abs(A.scale - -1) > 0 || (A.scale = D[K].scale), O != 0 ? A.maskingadjust = D[K].masking_adj : Math.abs(A.maskingadjust - 0) > 0 || (A.maskingadjust = D[K].masking_adj), D[K].masking_adj > 0 ? O != 0 ? A.maskingadjust_short = D[K].masking_adj * 0.9 : Math.abs(A.maskingadjust_short - 0) > 0 || (A.maskingadjust_short = D[K].masking_adj * 0.9) : O != 0 ? A.maskingadjust_short = D[K].masking_adj * 1.1 : Math.abs(A.maskingadjust_short - 0) > 0 || (A.maskingadjust_short = D[K].masking_adj * 1.1), O != 0 ? A.ATHlower = -D[K].ath_lower / 10 : Math.abs(-A.ATHlower * 10 - 0) > 0 || (A.ATHlower = -D[K].ath_lower / 10), O != 0 ? A.ATHcurve = D[K].ath_curve : Math.abs(A.ATHcurve - -1) > 0 || (A.ATHcurve = D[K].ath_curve), O != 0 ? A.interChRatio = D[K].interch : Math.abs(A.interChRatio - -1) > 0 || (A.interChRatio = D[K].interch), m;
    }
    this.apply_preset = function(A, m, O) {
        switch(m){
            case w.R3MIX:
                m = w.V3, A.VBR = M1.vbr_mtrh;
                break;
            case w.MEDIUM:
                m = w.V4, A.VBR = M1.vbr_rh;
                break;
            case w.MEDIUM_FAST:
                m = w.V4, A.VBR = M1.vbr_mtrh;
                break;
            case w.STANDARD:
                m = w.V2, A.VBR = M1.vbr_rh;
                break;
            case w.STANDARD_FAST:
                m = w.V2, A.VBR = M1.vbr_mtrh;
                break;
            case w.EXTREME:
                m = w.V0, A.VBR = M1.vbr_rh;
                break;
            case w.EXTREME_FAST:
                m = w.V0, A.VBR = M1.vbr_mtrh;
                break;
            case w.INSANE:
                return m = 320, A.preset = m, g(A, m, O), A.VBR = M1.vbr_off, m;
        }
        switch(A.preset = m, m){
            case w.V9:
                return Q(A, 9, O), m;
            case w.V8:
                return Q(A, 8, O), m;
            case w.V7:
                return Q(A, 7, O), m;
            case w.V6:
                return Q(A, 6, O), m;
            case w.V5:
                return Q(A, 5, O), m;
            case w.V4:
                return Q(A, 4, O), m;
            case w.V3:
                return Q(A, 3, O), m;
            case w.V2:
                return Q(A, 2, O), m;
            case w.V1:
                return Q(A, 1, O), m;
            case w.V0:
                return Q(A, 0, O), m;
        }
        return 8 <= m && m <= 320 ? g(A, m, O) : (A.preset = 0, m);
    };
    function f0(A, m) {
        var O = 0;
        return 0 > m && (O = -1, m = 0), 9 < m && (O = -1, m = 9), A.VBR_q = m, A.VBR_q_frac = 0, O;
    }
}
var V2 = H2;
function O2() {
    this.setModules = function(w, Z) {};
}
var C2 = O2;
function F2() {
    this.over_noise = 0, this.tot_noise = 0, this.max_noise = 0, this.over_count = 0, this.over_SSD = 0, this.bits = 0;
}
var k2 = F2, Ca = Q0, na = Ca.new_float, X2 = Ca.new_int;
function Y2() {
    this.global_gain = 0, this.sfb_count1 = 0, this.step = X2(39), this.noise = na(39), this.noise_log = na(39);
}
var q2 = Y2, q1 = Q0, y1 = q1.System, _a = q1.VbrMode, ye = q1.Util, X1 = q1.Arrays, K1 = q1.new_float, U1 = q1.assert, D2 = C2, we = k2, G2 = q2, D0 = t1(), la = Le, va = ie;
function $2() {
    var w;
    this.rv = null;
    var Z;
    this.qupvt = null;
    var X, z = new D2(), u0;
    this.setModules = function(R, o, u, d) {
        w = R, Z = o, this.rv = o, X = u, this.qupvt = u, u0 = d, z.setModules(X, u0);
    }, this.ms_convert = function(R, o) {
        for(var u = 0; u < 576; ++u){
            var d = R.tt[o][0].xr[u], e = R.tt[o][1].xr[u];
            R.tt[o][0].xr[u] = (d + e) * (ye.SQRT2 * 0.5), R.tt[o][1].xr[u] = (d - e) * (ye.SQRT2 * 0.5);
        }
    };
    function W(R, o, u, d) {
        d = 0;
        for(var e = 0; e <= u; ++e){
            var l = Math.abs(R.xr[e]);
            d += l, o[e] = Math.sqrt(l * Math.sqrt(l)), o[e] > R.xrpow_max && (R.xrpow_max = o[e]);
        }
        return d;
    }
    this.init_xrpow = function(R, o, u) {
        var d = 0, e = 0 | o.max_nonzero_coeff;
        if (o.xrpow_max = 0, X1.fill(u, e, 576, 0), d = W(o, u, e, d), d > 1e-20) {
            var l = 0;
            R.substep_shaping & 2 && (l = 1);
            for(var M = 0; M < o.psymax; M++)R.pseudohalf[M] = l;
            return !0;
        }
        return X1.fill(o.l3_enc, 0, 576, 0), !1;
    };
    function Q(R, o) {
        var u = R.ATH, d = o.xr;
        if (o.block_type != D0.SHORT_TYPE) for(var e = !1, l = D0.PSFB21 - 1; l >= 0 && !e; l--){
            var M = R.scalefac_band.psfb21[l], p = R.scalefac_band.psfb21[l + 1], H = X.athAdjust(u.adjust, u.psfb21[l], u.floor);
            R.nsPsy.longfact[21] > 1e-12 && (H *= R.nsPsy.longfact[21]);
            for(var B = p - 1; B >= M; B--)if (Math.abs(d[B]) < H) d[B] = 0;
            else {
                e = !0;
                break;
            }
        }
        else for(var I = 0; I < 3; I++)for(var e = !1, l = D0.PSFB12 - 1; l >= 0 && !e; l--){
            var M = R.scalefac_band.s[12] * 3 + (R.scalefac_band.s[13] - R.scalefac_band.s[12]) * I + (R.scalefac_band.psfb12[l] - R.scalefac_band.psfb12[0]), p = M + (R.scalefac_band.psfb12[l + 1] - R.scalefac_band.psfb12[l]), v0 = X.athAdjust(u.adjust, u.psfb12[l], u.floor);
            R.nsPsy.shortfact[12] > 1e-12 && (v0 *= R.nsPsy.shortfact[12]);
            for(var B = p - 1; B >= M; B--)if (Math.abs(d[B]) < v0) d[B] = 0;
            else {
                e = !0;
                break;
            }
        }
    }
    this.init_outer_loop = function(R, o) {
        o.part2_3_length = 0, o.big_values = 0, o.count1 = 0, o.global_gain = 210, o.scalefac_compress = 0, o.table_select[0] = 0, o.table_select[1] = 0, o.table_select[2] = 0, o.subblock_gain[0] = 0, o.subblock_gain[1] = 0, o.subblock_gain[2] = 0, o.subblock_gain[3] = 0, o.region0_count = 0, o.region1_count = 0, o.preflag = 0, o.scalefac_scale = 0, o.count1table_select = 0, o.part2_length = 0, o.sfb_lmax = D0.SBPSY_l, o.sfb_smin = D0.SBPSY_s, o.psy_lmax = R.sfb21_extra ? D0.SBMAX_l : D0.SBPSY_l, o.psymax = o.psy_lmax, o.sfbmax = o.sfb_lmax, o.sfbdivide = 11;
        for(var u = 0; u < D0.SBMAX_l; u++)o.width[u] = R.scalefac_band.l[u + 1] - R.scalefac_band.l[u], o.window[u] = 3;
        if (o.block_type == D0.SHORT_TYPE) {
            var d = K1(576);
            o.sfb_smin = 0, o.sfb_lmax = 0, o.mixed_block_flag != 0 && (o.sfb_smin = 3, o.sfb_lmax = R.mode_gr * 2 + 4), o.psymax = o.sfb_lmax + 3 * ((R.sfb21_extra ? D0.SBMAX_s : D0.SBPSY_s) - o.sfb_smin), o.sfbmax = o.sfb_lmax + 3 * (D0.SBPSY_s - o.sfb_smin), o.sfbdivide = o.sfbmax - 18, o.psy_lmax = o.sfb_lmax;
            var e = R.scalefac_band.l[o.sfb_lmax];
            y1.arraycopy(o.xr, 0, d, 0, 576);
            for(var u = o.sfb_smin; u < D0.SBMAX_s; u++)for(var l = R.scalefac_band.s[u], M = R.scalefac_band.s[u + 1], p = 0; p < 3; p++)for(var H = l; H < M; H++)o.xr[e++] = d[3 * H + p];
            for(var B = o.sfb_lmax, u = o.sfb_smin; u < D0.SBMAX_s; u++)o.width[B] = o.width[B + 1] = o.width[B + 2] = R.scalefac_band.s[u + 1] - R.scalefac_band.s[u], o.window[B] = 0, o.window[B + 1] = 1, o.window[B + 2] = 2, B += 3;
        }
        o.count1bits = 0, o.sfb_partition_table = X.nr_of_sfb_block[0][0], o.slen[0] = 0, o.slen[1] = 0, o.slen[2] = 0, o.slen[3] = 0, o.max_nonzero_coeff = 575, X1.fill(o.scalefac, 0), Q(R, o);
    };
    function D(R) {
        this.ordinal = R;
    }
    D.BINSEARCH_NONE = new D(0), D.BINSEARCH_UP = new D(1), D.BINSEARCH_DOWN = new D(2);
    function g(R, o, u, d, e) {
        var l, M = R.CurrentStep[d], p = !1, H = R.OldValue[d], B = D.BINSEARCH_NONE;
        for(o.global_gain = H, u -= o.part2_length;;){
            var I;
            if (l = u0.count_bits(R, e, o, null), M == 1 || l == u) break;
            l > u ? (B == D.BINSEARCH_DOWN && (p = !0), p && (M /= 2), B = D.BINSEARCH_UP, I = M) : (B == D.BINSEARCH_UP && (p = !0), p && (M /= 2), B = D.BINSEARCH_DOWN, I = -M), o.global_gain += I, o.global_gain < 0 && (o.global_gain = 0, p = !0), o.global_gain > 255 && (o.global_gain = 255, p = !0);
        }
        for(U1(o.global_gain >= 0), U1(o.global_gain < 256); l > u && o.global_gain < 255;)o.global_gain++, l = u0.count_bits(R, e, o, null);
        return R.CurrentStep[d] = H - o.global_gain >= 4 ? 4 : 2, R.OldValue[d] = o.global_gain, o.part2_3_length = l, l;
    }
    this.trancate_smallspectrums = function(R, o, u, d) {
        var e = K1(va.SFBMAX);
        if (!(!(R.substep_shaping & 4) && o.block_type == D0.SHORT_TYPE || R.substep_shaping & 128)) {
            X.calc_noise(o, u, e, new we(), null);
            for(var M = 0; M < 576; M++){
                var l = 0;
                o.l3_enc[M] != 0 && (l = Math.abs(o.xr[M])), d[M] = l;
            }
            var M = 0, p = 8;
            o.block_type == D0.SHORT_TYPE && (p = 6);
            do {
                var H, B, I, v0, b = o.width[p];
                if (M += b, !(e[p] >= 1) && (X1.sort(d, M - b, b), !BitStream.EQ(d[M - 1], 0))) {
                    H = (1 - e[p]) * u[p], B = 0, v0 = 0;
                    do {
                        var a;
                        for(I = 1; v0 + I < b && !BitStream.NEQ(d[v0 + M - b], d[v0 + M + I - b]); I++);
                        if (a = d[v0 + M - b] * d[v0 + M - b] * I, H < a) {
                            v0 != 0 && (B = d[v0 + M - b - 1]);
                            break;
                        }
                        H -= a, v0 += I;
                    }while (v0 < b);
                    if (!BitStream.EQ(B, 0)) do Math.abs(o.xr[M - b]) <= B && (o.l3_enc[M - b] = 0);
                    while (--b > 0);
                }
            }while (++p < o.psymax);
            o.part2_3_length = u0.noquant_count_bits(R, o, null);
        }
    };
    function f0(R) {
        for(var o = 0; o < R.sfbmax; o++)if (R.scalefac[o] + R.subblock_gain[R.window[o]] == 0) return !1;
        return !0;
    }
    function A(R) {
        return ye.FAST_LOG10(0.368 + 0.632 * R * R * R);
    }
    function m(R, o) {
        for(var u = 1e-37, d = 0; d < o.psymax; d++)u += A(R[d]);
        return Math.max(1e-20, u);
    }
    function O(R, o, u, d, e) {
        var l;
        switch(R){
            default:
            case 9:
                o.over_count > 0 ? (l = u.over_SSD <= o.over_SSD, u.over_SSD == o.over_SSD && (l = u.bits < o.bits)) : l = u.max_noise < 0 && u.max_noise * 10 + u.bits <= o.max_noise * 10 + o.bits;
                break;
            case 0:
                l = u.over_count < o.over_count || u.over_count == o.over_count && u.over_noise < o.over_noise || u.over_count == o.over_count && BitStream.EQ(u.over_noise, o.over_noise) && u.tot_noise < o.tot_noise;
                break;
            case 8:
                u.max_noise = m(e, d);
            case 1:
                l = u.max_noise < o.max_noise;
                break;
            case 2:
                l = u.tot_noise < o.tot_noise;
                break;
            case 3:
                l = u.tot_noise < o.tot_noise && u.max_noise < o.max_noise;
                break;
            case 4:
                l = u.max_noise <= 0 && o.max_noise > 0.2 || u.max_noise <= 0 && o.max_noise < 0 && o.max_noise > u.max_noise - 0.2 && u.tot_noise < o.tot_noise || u.max_noise <= 0 && o.max_noise > 0 && o.max_noise > u.max_noise - 0.2 && u.tot_noise < o.tot_noise + o.over_noise || u.max_noise > 0 && o.max_noise > -0.05 && o.max_noise > u.max_noise - 0.1 && u.tot_noise + u.over_noise < o.tot_noise + o.over_noise || u.max_noise > 0 && o.max_noise > -0.1 && o.max_noise > u.max_noise - 0.15 && u.tot_noise + u.over_noise + u.over_noise < o.tot_noise + o.over_noise + o.over_noise;
                break;
            case 5:
                l = u.over_noise < o.over_noise || BitStream.EQ(u.over_noise, o.over_noise) && u.tot_noise < o.tot_noise;
                break;
            case 6:
                l = u.over_noise < o.over_noise || BitStream.EQ(u.over_noise, o.over_noise) && (u.max_noise < o.max_noise || BitStream.EQ(u.max_noise, o.max_noise) && u.tot_noise <= o.tot_noise);
                break;
            case 7:
                l = u.over_count < o.over_count || u.over_noise < o.over_noise;
                break;
        }
        return o.over_count == 0 && (l = l && u.bits < o.bits), l;
    }
    function s0(R, o, u, d, e) {
        var l = R.internal_flags, M;
        o.scalefac_scale == 0 ? M = 1.2968395546510096 : M = 1.6817928305074292;
        for(var p = 0, H = 0; H < o.sfbmax; H++)p < u[H] && (p = u[H]);
        var B = l.noise_shaping_amp;
        switch(B == 3 && (e ? B = 2 : B = 1), B){
            case 2:
                break;
            case 1:
                p > 1 ? p = Math.pow(p, 0.5) : p *= 0.95;
                break;
            case 0:
            default:
                p > 1 ? p = 1 : p *= 0.95;
                break;
        }
        for(var I = 0, H = 0; H < o.sfbmax; H++){
            var v0 = o.width[H], b;
            if (I += v0, !(u[H] < p)) {
                if (l.substep_shaping & 2 && (l.pseudohalf[H] = l.pseudohalf[H] == 0 ? 1 : 0, l.pseudohalf[H] == 0 && l.noise_shaping_amp == 2)) return;
                for(o.scalefac[H]++, b = -v0; b < 0; b++)d[I + b] *= M, d[I + b] > o.xrpow_max && (o.xrpow_max = d[I + b]);
                if (l.noise_shaping_amp == 2) return;
            }
        }
    }
    function K(R, o) {
        for(var u = 1.2968395546510096, d = 0, e = 0; e < R.sfbmax; e++){
            var l = R.width[e], M = R.scalefac[e];
            if (R.preflag != 0 && (M += X.pretab[e]), d += l, M & 1) {
                M++;
                for(var p = -l; p < 0; p++)o[d + p] *= u, o[d + p] > R.xrpow_max && (R.xrpow_max = o[d + p]);
            }
            R.scalefac[e] = M >> 1;
        }
        R.preflag = 0, R.scalefac_scale = 1;
    }
    function t0(R, o, u) {
        var d, e = o.scalefac;
        for(d = 0; d < o.sfb_lmax; d++)if (e[d] >= 16) return !0;
        for(var l = 0; l < 3; l++){
            var M = 0, p = 0;
            for(d = o.sfb_lmax + l; d < o.sfbdivide; d += 3)M < e[d] && (M = e[d]);
            for(; d < o.sfbmax; d += 3)p < e[d] && (p = e[d]);
            if (!(M < 16 && p < 8)) {
                if (o.subblock_gain[l] >= 7) return !0;
                o.subblock_gain[l]++;
                var H = R.scalefac_band.l[o.sfb_lmax];
                for(d = o.sfb_lmax + l; d < o.sfbmax; d += 3){
                    var B, I = o.width[d], v0 = e[d];
                    if (v0 = v0 - (4 >> o.scalefac_scale), v0 >= 0) {
                        e[d] = v0, H += I * 3;
                        continue;
                    }
                    e[d] = 0;
                    var b = 210 + (v0 << o.scalefac_scale + 1);
                    B = X.IPOW20(b);
                    H += I * (l + 1);
                    for(var a = -I; a < 0; a++)u[H + a] *= B, u[H + a] > o.xrpow_max && (o.xrpow_max = u[H + a]);
                    H += I * (3 - l - 1);
                }
                var B = X.IPOW20(202);
                H += o.width[d] * (l + 1);
                for(var a = -o.width[d]; a < 0; a++)u[H + a] *= B, u[H + a] > o.xrpow_max && (o.xrpow_max = u[H + a]);
            }
        }
        return !1;
    }
    function U(R, o, u, d, e) {
        var l = R.internal_flags;
        s0(R, o, u, d, e);
        var M = f0(o);
        return M ? !1 : (l.mode_gr == 2 ? M = u0.scale_bitcount(o) : M = u0.scale_bitcount_lsf(l, o), M ? (l.noise_shaping > 1 && (X1.fill(l.pseudohalf, 0), o.scalefac_scale == 0 ? (K(o, d), M = !1) : o.block_type == D0.SHORT_TYPE && l.subblock_gain > 0 && (M = t0(l, o, d) || f0(o))), M || (l.mode_gr == 2 ? M = u0.scale_bitcount(o) : M = u0.scale_bitcount_lsf(l, o)), !M) : !0);
    }
    this.outer_loop = function(R, o, u, d, e, l) {
        var M = R.internal_flags, p = new la(), H = K1(576), B = K1(va.SFBMAX), I = new we(), v0, b = new G2(), a = 9999999, S = !1, L = !1, V = 0;
        if (g(M, o, l, e, d), M.noise_shaping == 0) return 100;
        X.calc_noise(o, u, B, I, b), I.bits = o.part2_3_length, p.assign(o);
        var N = 0;
        for(y1.arraycopy(d, 0, H, 0, 576); !S;){
            do {
                var P = new we(), E, i = 255;
                if (M.substep_shaping & 2 ? E = 20 : E = 3, M.sfb21_extra && (B[p.sfbmax] > 1 || p.block_type == D0.SHORT_TYPE && (B[p.sfbmax + 1] > 1 || B[p.sfbmax + 2] > 1)) || !U(R, p, B, d, L)) break;
                p.scalefac_scale != 0 && (i = 254);
                var s = l - p.part2_length;
                if (s <= 0) break;
                for(; (p.part2_3_length = u0.count_bits(M, d, p, b)) > s && p.global_gain <= i;)p.global_gain++;
                if (p.global_gain > i) break;
                if (I.over_count == 0) {
                    for(; (p.part2_3_length = u0.count_bits(M, d, p, b)) > a && p.global_gain <= i;)p.global_gain++;
                    if (p.global_gain > i) break;
                }
                if (X.calc_noise(p, u, B, P, b), P.bits = p.part2_3_length, o.block_type != D0.SHORT_TYPE ? v0 = R.quant_comp : v0 = R.quant_comp_short, v0 = O(v0, I, P, p, B) ? 1 : 0, v0 != 0) a = o.part2_3_length, I = P, o.assign(p), N = 0, y1.arraycopy(d, 0, H, 0, 576);
                else if (M.full_outer_loop == 0 && (++N > E && I.over_count == 0 || M.noise_shaping_amp == 3 && L && N > 30 || M.noise_shaping_amp == 3 && L && p.global_gain - V > 15)) break;
            }while (p.global_gain + p.scalefac_scale < 255);
            M.noise_shaping_amp == 3 ? L ? S = !0 : (p.assign(o), y1.arraycopy(H, 0, d, 0, 576), N = 0, V = p.global_gain, L = !0) : S = !0;
        }
        return U1(o.global_gain + o.scalefac_scale <= 255), R.VBR == _a.vbr_rh || R.VBR == _a.vbr_mtrh ? y1.arraycopy(H, 0, d, 0, 576) : M.substep_shaping & 1 && trancate_smallspectrums(M, o, u, d), I.over_count;
    }, this.iteration_finish_one = function(R, o, u) {
        var d = R.l3_side, e = d.tt[o][u];
        u0.best_scalefac_store(R, o, u, d), R.use_best_huffman == 1 && u0.best_huffman_divide(R, e), Z.ResvAdjust(R, e);
    }, this.VBR_encode_granule = function(R, o, u, d, e, l, M) {
        var p = R.internal_flags, H = new la(), B = K1(576), I = M, v0 = M + 1, b = (M + l) / 2, a, S, L = 0, V = p.sfb21_extra;
        U1(I <= LameInternalFlags.MAX_BITS_PER_CHANNEL), X1.fill(H.l3_enc, 0);
        do b > I - 42 ? p.sfb21_extra = !1 : p.sfb21_extra = V, S = outer_loop(R, o, u, d, e, b), S <= 0 ? (L = 1, v0 = o.part2_3_length, H.assign(o), y1.arraycopy(d, 0, B, 0, 576), M = v0 - 32, a = M - l, b = (M + l) / 2) : (l = b + 32, a = M - l, b = (M + l) / 2, L != 0 && (L = 2, o.assign(H), y1.arraycopy(B, 0, d, 0, 576)));
        while (a > 12);
        p.sfb21_extra = V, L == 2 && y1.arraycopy(H.l3_enc, 0, o.l3_enc, 0, 576), U1(o.part2_3_length <= I);
    }, this.get_framebits = function(R, o) {
        var u = R.internal_flags;
        u.bitrate_index = u.VBR_min_bitrate;
        var d = w.getframebits(R);
        u.bitrate_index = 1, d = w.getframebits(R);
        for(var e = 1; e <= u.VBR_max_bitrate; e++){
            u.bitrate_index = e;
            var l = new MeanBits(d);
            o[e] = Z.ResvFrameBegin(R, l), d = l.bits;
        }
    }, this.VBR_old_prepare = function(R, o, u, d, e, l, M, p, H) {
        var B = R.internal_flags, I, v0 = 0, b = 1, a = 0;
        B.bitrate_index = B.VBR_max_bitrate;
        var S = Z.ResvFrameBegin(R, new MeanBits(0)) / B.mode_gr;
        get_framebits(R, l);
        for(var L = 0; L < B.mode_gr; L++){
            var V = X.on_pe(R, o, p[L], S, L, 0);
            B.mode_ext == D0.MPG_MD_MS_LR && (ms_convert(B.l3_side, L), X.reduce_side(p[L], u[L], S, V));
            for(var N = 0; N < B.channels_out; ++N){
                var P = B.l3_side.tt[L][N];
                P.block_type != D0.SHORT_TYPE ? (v0 = 1.28 / (1 + Math.exp(3.5 - o[L][N] / 300)) - 0.05, I = B.PSY.mask_adjust - v0) : (v0 = 2.56 / (1 + Math.exp(3.5 - o[L][N] / 300)) - 0.14, I = B.PSY.mask_adjust_short - v0), B.masking_lower = Math.pow(10, I * 0.1), init_outer_loop(B, P), H[L][N] = X.calc_xmin(R, d[L][N], P, e[L][N]), H[L][N] != 0 && (b = 0), M[L][N] = 126, a += p[L][N];
            }
        }
        for(var L = 0; L < B.mode_gr; L++)for(var N = 0; N < B.channels_out; N++)a > l[B.VBR_max_bitrate] && (p[L][N] *= l[B.VBR_max_bitrate], p[L][N] /= a), M[L][N] > p[L][N] && (M[L][N] = p[L][N]);
        return b;
    }, this.bitpressure_strategy = function(R, o, u, d) {
        for(var e = 0; e < R.mode_gr; e++)for(var l = 0; l < R.channels_out; l++){
            for(var M = R.l3_side.tt[e][l], p = o[e][l], H = 0, B = 0; B < M.psy_lmax; B++)p[H++] *= 1 + 0.029 * B * B / D0.SBMAX_l / D0.SBMAX_l;
            if (M.block_type == D0.SHORT_TYPE) for(var B = M.sfb_smin; B < D0.SBMAX_s; B++)p[H++] *= 1 + 0.029 * B * B / D0.SBMAX_s / D0.SBMAX_s, p[H++] *= 1 + 0.029 * B * B / D0.SBMAX_s / D0.SBMAX_s, p[H++] *= 1 + 0.029 * B * B / D0.SBMAX_s / D0.SBMAX_s;
            d[e][l] = 0 | Math.max(u[e][l], 0.9 * d[e][l]);
        }
    }, this.VBR_new_prepare = function(R, o, u, d, e, l) {
        var M = R.internal_flags, p = 1, H = 0, B = 0, I;
        if (R.free_format) {
            M.bitrate_index = 0;
            var v0 = new MeanBits(H);
            I = Z.ResvFrameBegin(R, v0), H = v0.bits, e[0] = I;
        } else {
            M.bitrate_index = M.VBR_max_bitrate;
            var v0 = new MeanBits(H);
            Z.ResvFrameBegin(R, v0), H = v0.bits, get_framebits(R, e), I = e[M.VBR_max_bitrate];
        }
        for(var b = 0; b < M.mode_gr; b++){
            X.on_pe(R, o, l[b], H, b, 0), M.mode_ext == D0.MPG_MD_MS_LR && ms_convert(M.l3_side, b);
            for(var a = 0; a < M.channels_out; ++a){
                var S = M.l3_side.tt[b][a];
                M.masking_lower = Math.pow(10, M.PSY.mask_adjust * 0.1), init_outer_loop(M, S), X.calc_xmin(R, u[b][a], S, d[b][a]) != 0 && (p = 0), B += l[b][a];
            }
        }
        for(var b = 0; b < M.mode_gr; b++)for(var a = 0; a < M.channels_out; a++)B > I && (l[b][a] *= I, l[b][a] /= B);
        return p;
    }, this.calc_target_bits = function(R, o, u, d, e, l) {
        var M = R.internal_flags, p = M.l3_side, H, B, I, v0, b = 0;
        M.bitrate_index = M.VBR_max_bitrate;
        var a = new MeanBits(b);
        for(l[0] = Z.ResvFrameBegin(R, a), b = a.bits, M.bitrate_index = 1, b = w.getframebits(R) - M.sideinfo_len * 8, e[0] = b / (M.mode_gr * M.channels_out), b = R.VBR_mean_bitrate_kbps * R.framesize * 1e3, M.substep_shaping & 1 && (b *= 1.09), b /= R.out_samplerate, b -= M.sideinfo_len * 8, b /= M.mode_gr * M.channels_out, H = 0.93 + 0.07 * (11 - R.compression_ratio) / 5.5, H < 0.9 && (H = 0.9), H > 1 && (H = 1), B = 0; B < M.mode_gr; B++){
            var S = 0;
            for(I = 0; I < M.channels_out; I++){
                if (d[B][I] = int(H * b), o[B][I] > 700) {
                    var L = int((o[B][I] - 700) / 1.4), V = p.tt[B][I];
                    d[B][I] = int(H * b), V.block_type == D0.SHORT_TYPE && L < b / 2 && (L = b / 2), L > b * 3 / 2 ? L = b * 3 / 2 : L < 0 && (L = 0), d[B][I] += L;
                }
                d[B][I] > LameInternalFlags.MAX_BITS_PER_CHANNEL && (d[B][I] = LameInternalFlags.MAX_BITS_PER_CHANNEL), S += d[B][I];
            }
            if (S > LameInternalFlags.MAX_BITS_PER_GRANULE) for(I = 0; I < M.channels_out; ++I)d[B][I] *= LameInternalFlags.MAX_BITS_PER_GRANULE, d[B][I] /= S;
        }
        if (M.mode_ext == D0.MPG_MD_MS_LR) for(B = 0; B < M.mode_gr; B++)X.reduce_side(d[B], u[B], b * M.channels_out, LameInternalFlags.MAX_BITS_PER_GRANULE);
        for(v0 = 0, B = 0; B < M.mode_gr; B++)for(I = 0; I < M.channels_out; I++)d[B][I] > LameInternalFlags.MAX_BITS_PER_CHANNEL && (d[B][I] = LameInternalFlags.MAX_BITS_PER_CHANNEL), v0 += d[B][I];
        if (v0 > l[0]) for(B = 0; B < M.mode_gr; B++)for(I = 0; I < M.channels_out; I++)d[B][I] *= l[0], d[B][I] /= v0;
    };
}
var P2 = $2, Z2 = Q0, oa = Z2.assert;
function K2() {
    var w;
    this.setModules = function(Z) {
        w = Z;
    }, this.ResvFrameBegin = function(Z, X) {
        var z = Z.internal_flags, u0, W = z.l3_side, Q = w.getframebits(Z);
        X.bits = (Q - z.sideinfo_len * 8) / z.mode_gr;
        var D = 2048 * z.mode_gr - 8;
        Z.brate > 320 ? u0 = 8 * int(Z.brate * 1e3 / (Z.out_samplerate / 1152) / 8 + 0.5) : (u0 = 11520, Z.strict_ISO && (u0 = 8 * int(32e4 / (Z.out_samplerate / 1152) / 8 + 0.5))), z.ResvMax = u0 - Q, z.ResvMax > D && (z.ResvMax = D), (z.ResvMax < 0 || Z.disable_reservoir) && (z.ResvMax = 0);
        var g = X.bits * z.mode_gr + Math.min(z.ResvSize, z.ResvMax);
        return g > u0 && (g = u0), oa(z.ResvMax % 8 == 0), oa(z.ResvMax >= 0), W.resvDrain_pre = 0, z.pinfo != null && (z.pinfo.mean_bits = X.bits / 2, z.pinfo.resvsize = z.ResvSize), g;
    }, this.ResvMaxBits = function(Z, X, z, u0) {
        var W = Z.internal_flags, Q, D = W.ResvSize, g = W.ResvMax;
        u0 != 0 && (D += X), W.substep_shaping & 1 && (g *= 0.9), z.bits = X, D * 10 > g * 9 ? (Q = D - g * 9 / 10, z.bits += Q, W.substep_shaping |= 128) : (Q = 0, W.substep_shaping &= 127, !Z.disable_reservoir && !(W.substep_shaping & 1) && (z.bits -= 0.1 * X));
        var f0 = D < W.ResvMax * 6 / 10 ? D : W.ResvMax * 6 / 10;
        return f0 -= Q, f0 < 0 && (f0 = 0), f0;
    }, this.ResvAdjust = function(Z, X) {
        Z.ResvSize -= X.part2_3_length + X.part2_length;
    }, this.ResvFrameEnd = function(Z, X) {
        var z, u0 = Z.l3_side;
        Z.ResvSize += X * Z.mode_gr;
        var W = 0;
        u0.resvDrain_post = 0, u0.resvDrain_pre = 0, (z = Z.ResvSize % 8) != 0 && (W += z), z = Z.ResvSize - W - Z.ResvMax, z > 0 && (W += z);
        var Q = Math.min(u0.main_data_begin * 8, W) / 8;
        u0.resvDrain_pre += 8 * Q, W -= 8 * Q, Z.ResvSize -= 8 * Q, u0.main_data_begin -= Q;
        u0.resvDrain_post += W, Z.ResvSize -= W;
    };
}
var U2 = K2;
function Q2() {
    var w = "http://www.mp3dev.org/", Z = 3, X = 98, z = 4, u0 = 0, W = 93;
    this.getLameVersion = function() {
        return Z + "." + X + "." + z;
    }, this.getLameShortVersion = function() {
        return Z + "." + X + "." + z;
    }, this.getLameVeryShortVersion = function() {
        return "LAME" + Z + "." + X + "r";
    }, this.getPsyVersion = function() {
        return u0 + "." + W;
    }, this.getLameUrl = function() {
        return w;
    }, this.getLameOsBitness = function() {
        return "32bits";
    };
}
var W2 = Q2, D1 = Q0, j2 = D1.System, Ie = D1.VbrMode, ha = D1.ShortBlock, z2 = D1.Arrays, te = D1.new_byte, J2 = D1.assert;
Q1.NUMTOCENTRIES = 100;
Q1.MAXFRAMESIZE = 2880;
function Q1() {
    var w, Z, X;
    this.setModules = function(b, a, S) {
        w = b, Z = a, X = S;
    };
    var z = 1, u0 = 2, W = 4, Q = 8, D = Q1.NUMTOCENTRIES, g = Q1.MAXFRAMESIZE, f0 = D + 4 + 4 + 4 + 4 + 4, A = f0 + 9 + 1 + 1 + 8 + 1 + 1 + 3 + 1 + 1 + 2 + 4 + 2 + 2, m = 128, O = 64, s0 = 32, K = null, t0 = "Xing", U = "Info", R = [
        0,
        49345,
        49537,
        320,
        49921,
        960,
        640,
        49729,
        50689,
        1728,
        1920,
        51009,
        1280,
        50625,
        50305,
        1088,
        52225,
        3264,
        3456,
        52545,
        3840,
        53185,
        52865,
        3648,
        2560,
        51905,
        52097,
        2880,
        51457,
        2496,
        2176,
        51265,
        55297,
        6336,
        6528,
        55617,
        6912,
        56257,
        55937,
        6720,
        7680,
        57025,
        57217,
        8e3,
        56577,
        7616,
        7296,
        56385,
        5120,
        54465,
        54657,
        5440,
        55041,
        6080,
        5760,
        54849,
        53761,
        4800,
        4992,
        54081,
        4352,
        53697,
        53377,
        4160,
        61441,
        12480,
        12672,
        61761,
        13056,
        62401,
        62081,
        12864,
        13824,
        63169,
        63361,
        14144,
        62721,
        13760,
        13440,
        62529,
        15360,
        64705,
        64897,
        15680,
        65281,
        16320,
        16e3,
        65089,
        64001,
        15040,
        15232,
        64321,
        14592,
        63937,
        63617,
        14400,
        10240,
        59585,
        59777,
        10560,
        60161,
        11200,
        10880,
        59969,
        60929,
        11968,
        12160,
        61249,
        11520,
        60865,
        60545,
        11328,
        58369,
        9408,
        9600,
        58689,
        9984,
        59329,
        59009,
        9792,
        8704,
        58049,
        58241,
        9024,
        57601,
        8640,
        8320,
        57409,
        40961,
        24768,
        24960,
        41281,
        25344,
        41921,
        41601,
        25152,
        26112,
        42689,
        42881,
        26432,
        42241,
        26048,
        25728,
        42049,
        27648,
        44225,
        44417,
        27968,
        44801,
        28608,
        28288,
        44609,
        43521,
        27328,
        27520,
        43841,
        26880,
        43457,
        43137,
        26688,
        30720,
        47297,
        47489,
        31040,
        47873,
        31680,
        31360,
        47681,
        48641,
        32448,
        32640,
        48961,
        32e3,
        48577,
        48257,
        31808,
        46081,
        29888,
        30080,
        46401,
        30464,
        47041,
        46721,
        30272,
        29184,
        45761,
        45953,
        29504,
        45313,
        29120,
        28800,
        45121,
        20480,
        37057,
        37249,
        20800,
        37633,
        21440,
        21120,
        37441,
        38401,
        22208,
        22400,
        38721,
        21760,
        38337,
        38017,
        21568,
        39937,
        23744,
        23936,
        40257,
        24320,
        40897,
        40577,
        24128,
        23040,
        39617,
        39809,
        23360,
        39169,
        22976,
        22656,
        38977,
        34817,
        18624,
        18816,
        35137,
        19200,
        35777,
        35457,
        19008,
        19968,
        36545,
        36737,
        20288,
        36097,
        19904,
        19584,
        35905,
        17408,
        33985,
        34177,
        17728,
        34561,
        18368,
        18048,
        34369,
        33281,
        17088,
        17280,
        33601,
        16640,
        33217,
        32897,
        16448
    ];
    function o(b, a) {
        if (b.nVbrNumFrames++, b.sum += a, b.seen++, !(b.seen < b.want) && (b.pos < b.size && (b.bag[b.pos] = b.sum, b.pos++, b.seen = 0), b.pos == b.size)) {
            for(var S = 1; S < b.size; S += 2)b.bag[S / 2] = b.bag[S];
            b.want *= 2, b.pos /= 2;
        }
    }
    function u(b, a) {
        if (!(b.pos <= 0)) for(var S = 1; S < D; ++S){
            var L = S / D, V, N, P = 0 | Math.floor(L * b.pos);
            P > b.pos - 1 && (P = b.pos - 1), V = b.bag[P], N = b.sum;
            var E = 0 | 256 * V / N;
            E > 255 && (E = 255), a[S] = 255 & E;
        }
    }
    this.addVbrFrame = function(b) {
        var a = b.internal_flags, S = Tables.bitrate_table[b.version][a.bitrate_index];
        J2(a.VBR_seek_table.bag != null), o(a.VBR_seek_table, S);
    };
    function d(b, a) {
        var S = b[a + 0] & 255;
        return S <<= 8, S |= b[a + 1] & 255, S <<= 8, S |= b[a + 2] & 255, S <<= 8, S |= b[a + 3] & 255, S;
    }
    function e(b, a, S) {
        b[a + 0] = 255 & (S >> 24 & 255), b[a + 1] = 255 & (S >> 16 & 255), b[a + 2] = 255 & (S >> 8 & 255), b[a + 3] = 255 & (S & 255);
    }
    function l(b, a, S) {
        b[a + 0] = 255 & (S >> 8 & 255), b[a + 1] = 255 & (S & 255);
    }
    function M(b, a) {
        return new String(b, a, t0.length(), K).equals(t0) || new String(b, a, U.length(), K).equals(U);
    }
    function p(b, a, S) {
        return 255 & (b << a | S & ~(-1 << a));
    }
    function H(b, a) {
        var S = b.internal_flags;
        a[0] = p(a[0], 8, 255), a[1] = p(a[1], 3, 7), a[1] = p(a[1], 1, b.out_samplerate < 16e3 ? 0 : 1), a[1] = p(a[1], 1, b.version), a[1] = p(a[1], 2, 1), a[1] = p(a[1], 1, b.error_protection ? 0 : 1), a[2] = p(a[2], 4, S.bitrate_index), a[2] = p(a[2], 2, S.samplerate_index), a[2] = p(a[2], 1, 0), a[2] = p(a[2], 1, b.extension), a[3] = p(a[3], 2, b.mode.ordinal()), a[3] = p(a[3], 2, S.mode_ext), a[3] = p(a[3], 1, b.copyright), a[3] = p(a[3], 1, b.original), a[3] = p(a[3], 2, b.emphasis), a[0] = 255;
        var L = 255 & (a[1] & 241), V;
        b.version == 1 ? V = m : b.out_samplerate < 16e3 ? V = s0 : V = O, b.VBR == Ie.vbr_off && (V = b.brate);
        var N;
        b.free_format ? N = 0 : N = 255 & 16 * w.BitrateIndex(V, b.version, b.out_samplerate), b.version == 1 ? (a[1] = 255 & (L | 10), L = 255 & (a[2] & 13), a[2] = 255 & (N | L)) : (a[1] = 255 & (L | 2), L = 255 & (a[2] & 13), a[2] = 255 & (N | L));
    }
    this.getVbrTag = function(b) {
        var a = new VBRTagData(), S = 0;
        a.flags = 0;
        var L = b[S + 1] >> 3 & 1, V = b[S + 2] >> 2 & 3, N = b[S + 3] >> 6 & 3, P = b[S + 2] >> 4 & 15;
        if (P = Tables.bitrate_table[L][P], b[S + 1] >> 4 == 14 ? a.samprate = Tables.samplerate_table[2][V] : a.samprate = Tables.samplerate_table[L][V], L != 0 ? N != 3 ? S += 36 : S += 21 : N != 3 ? S += 21 : S += 13, !M(b, S)) return null;
        S += 4, a.hId = L;
        var E = a.flags = d(b, S);
        if (S += 4, E & z && (a.frames = d(b, S), S += 4), E & u0 && (a.bytes = d(b, S), S += 4), E & W) {
            if (a.toc != null) for(var i = 0; i < D; i++)a.toc[i] = b[S + i];
            S += D;
        }
        a.vbrScale = -1, E & Q && (a.vbrScale = d(b, S), S += 4), a.headersize = (L + 1) * 72e3 * P / a.samprate, S += 21;
        var s = b[S + 0] << 4;
        s += b[S + 1] >> 4;
        var r = (b[S + 1] & 15) << 8;
        return r += b[S + 2] & 255, (s < 0 || s > 3e3) && (s = -1), (r < 0 || r > 3e3) && (r = -1), a.encDelay = s, a.encPadding = r, a;
    }, this.InitVbrTag = function(b) {
        var a = b.internal_flags, S;
        b.version == 1 ? S = m : b.out_samplerate < 16e3 ? S = s0 : S = O, b.VBR == Ie.vbr_off && (S = b.brate);
        var L = (b.version + 1) * 72e3 * S / b.out_samplerate, V = a.sideinfo_len + A;
        if (a.VBR_seek_table.TotalFrameSize = L, L < V || L > g) {
            b.bWriteVbrTag = !1;
            return;
        }
        a.VBR_seek_table.nVbrNumFrames = 0, a.VBR_seek_table.nBytesWritten = 0, a.VBR_seek_table.sum = 0, a.VBR_seek_table.seen = 0, a.VBR_seek_table.want = 1, a.VBR_seek_table.pos = 0, a.VBR_seek_table.bag == null && (a.VBR_seek_table.bag = new int[400](), a.VBR_seek_table.size = 400);
        var N = te(g);
        H(b, N);
        for(var P = a.VBR_seek_table.TotalFrameSize, E = 0; E < P; ++E)Z.add_dummy_byte(b, N[E] & 255, 1);
    };
    function B(b, a) {
        var S = a ^ b;
        return a = a >> 8 ^ R[S & 255], a;
    }
    this.updateMusicCRC = function(b, a, S, L) {
        for(var V = 0; V < L; ++V)b[0] = B(a[S + V], b[0]);
    };
    function I(b, a, S, L, V) {
        var N = b.internal_flags, P = 0, E = b.encoder_delay, i = b.encoder_padding, s = 100 - 10 * b.VBR_q - b.quality, r = X.getLameVeryShortVersion(), n, f = 0, Y, J = [
            1,
            5,
            3,
            2,
            4,
            0,
            3
        ], T = 0 | (b.lowpassfreq / 100 + 0.5 > 255 ? 255 : b.lowpassfreq / 100 + 0.5), q = 0, i0 = 0, h0 = 0, d0 = b.internal_flags.noise_shaping, M0 = 0, R0 = 0, A0 = 0, w0 = 0, $0 = 0, f1 = (b.exp_nspsytune & 1) != 0, t = (b.exp_nspsytune & 2) != 0, _ = !1, S0 = !1, E0 = b.internal_flags.nogap_total, V0 = b.internal_flags.nogap_current, H0 = b.ATHtype, y0 = 0, T0;
        switch(b.VBR){
            case vbr_abr:
                T0 = b.VBR_mean_bitrate_kbps;
                break;
            case vbr_off:
                T0 = b.brate;
                break;
            default:
                T0 = b.VBR_min_bitrate_kbps;
        }
        switch(b.VBR.ordinal() < J.length ? n = J[b.VBR.ordinal()] : n = 0, Y = 16 * f + n, N.findReplayGain && (N.RadioGain > 510 && (N.RadioGain = 510), N.RadioGain < -510 && (N.RadioGain = -510), i0 = 8192, i0 |= 3072, N.RadioGain >= 0 ? i0 |= N.RadioGain : (i0 |= 512, i0 |= -N.RadioGain)), N.findPeakSample && (q = Math.abs(0 | N.PeakSample / 32767 * Math.pow(2, 23) + 0.5)), E0 != -1 && (V0 > 0 && (S0 = !0), V0 < E0 - 1 && (_ = !0)), y0 = H0 + ((f1 ? 1 : 0) << 4) + ((t ? 1 : 0) << 5) + ((_ ? 1 : 0) << 6) + ((S0 ? 1 : 0) << 7), s < 0 && (s = 0), b.mode){
            case MONO:
                M0 = 0;
                break;
            case STEREO:
                M0 = 1;
                break;
            case DUAL_CHANNEL:
                M0 = 2;
                break;
            case JOINT_STEREO:
                b.force_ms ? M0 = 4 : M0 = 3;
                break;
            case NOT_SET:
            default:
                M0 = 7;
                break;
        }
        b.in_samplerate <= 32e3 ? A0 = 0 : b.in_samplerate == 48e3 ? A0 = 2 : b.in_samplerate > 48e3 ? A0 = 3 : A0 = 1, (b.short_blocks == ha.short_block_forced || b.short_blocks == ha.short_block_dispensed || b.lowpassfreq == -1 && b.highpassfreq == -1 || /* "-k" */ b.scale_left < b.scale_right || b.scale_left > b.scale_right || b.disable_reservoir && b.brate < 320 || b.noATH || b.ATHonly || H0 == 0 || b.in_samplerate <= 32e3) && (R0 = 1), w0 = d0 + (M0 << 2) + (R0 << 5) + (A0 << 6), $0 = N.nMusicCRC, e(S, L + P, s), P += 4;
        for(var F0 = 0; F0 < 9; F0++)S[L + P + F0] = 255 & r.charAt(F0);
        P += 9, S[L + P] = 255 & Y, P++, S[L + P] = 255 & T, P++, e(S, L + P, q), P += 4, l(S, L + P, i0), P += 2, l(S, L + P, h0), P += 2, S[L + P] = 255 & y0, P++, T0 >= 255 ? S[L + P] = 255 : S[L + P] = 255 & T0, P++, S[L + P] = 255 & E >> 4, S[L + P + 1] = 255 & (E << 4) + (i >> 8), S[L + P + 2] = 255 & i, P += 3, S[L + P] = 255 & w0, P++, S[L + P++] = 0, l(S, L + P, b.preset), P += 2, e(S, L + P, a), P += 4, l(S, L + P, $0), P += 2;
        for(var I0 = 0; I0 < P; I0++)V = B(S[L + I0], V);
        return l(S, L + P, V), P += 2, P;
    }
    function v0(b) {
        b.seek(0);
        var a = te(10);
        b.readFully(a);
        var S;
        return new String(a, "ISO-8859-1").startsWith("ID3") ? S = 0 : S = ((a[6] & 127) << 21 | (a[7] & 127) << 14 | (a[8] & 127) << 7 | a[9] & 127) + a.length, S;
    }
    this.getLameTagFrame = function(b, a) {
        var S = b.internal_flags;
        if (!b.bWriteVbrTag || S.Class_ID != Lame.LAME_ID || S.VBR_seek_table.pos <= 0) return 0;
        if (a.length < S.VBR_seek_table.TotalFrameSize) return S.VBR_seek_table.TotalFrameSize;
        z2.fill(a, 0, S.VBR_seek_table.TotalFrameSize, 0), H(b, a);
        var L = te(D);
        if (b.free_format) for(var V = 1; V < D; ++V)L[V] = 255 & 255 * V / 100;
        else u(S.VBR_seek_table, L);
        var N = S.sideinfo_len;
        b.error_protection && (N -= 2), b.VBR == Ie.vbr_off ? (a[N++] = 255 & U.charAt(0), a[N++] = 255 & U.charAt(1), a[N++] = 255 & U.charAt(2), a[N++] = 255 & U.charAt(3)) : (a[N++] = 255 & t0.charAt(0), a[N++] = 255 & t0.charAt(1), a[N++] = 255 & t0.charAt(2), a[N++] = 255 & t0.charAt(3)), e(a, N, z + u0 + W + Q), N += 4, e(a, N, S.VBR_seek_table.nVbrNumFrames), N += 4;
        var P = S.VBR_seek_table.nBytesWritten + S.VBR_seek_table.TotalFrameSize;
        e(a, N, 0 | P), N += 4, j2.arraycopy(L, 0, a, N, L.length), N += L.length, b.error_protection && Z.CRC_writeheader(S, a);
        for(var E = 0, V = 0; V < N; V++)E = B(a[V], E);
        return N += I(b, P, a, N, E), S.VBR_seek_table.TotalFrameSize;
    }, this.putVbrTag = function(b, a) {
        var S = b.internal_flags;
        if (S.VBR_seek_table.pos <= 0 || (a.seek(a.length()), a.length() == 0)) return -1;
        var L = v0(a);
        a.seek(L);
        var V = te(g), N = getLameTagFrame(b, V);
        return N > V.length ? -1 : (N < 1 || a.write(V, 0, N), 0);
    };
}
var g2 = Q1, Fa = Q0, ua = Fa.new_byte, er = Fa.assert, ar = Oe(), rr = V2, tr = Na, sr = Va(), ir = P2, nr = Oa(), _r = U2, lr = j1, vr = Ve();
t1();
var or = W2, hr = g2;
function ur() {
    this.setModules = function(w, Z) {};
}
function fr() {
    this.setModules = function(w, Z, X) {};
}
function mr() {}
function br() {
    this.setModules = function(w, Z) {};
}
function cr(w, Z, X) {
    arguments.length != 3 && (console.error("WARN: Mp3Encoder(channels, samplerate, kbps) not specified"), w = 1, Z = 44100, X = 128);
    var z = new ar(), u0 = new ur(), W = new tr(), Q = new vr(), D = new rr(), g = new sr(), f0 = new ir(), A = new hr(), m = new or(), O = new br(), s0 = new _r(), K = new nr(), t0 = new fr(), U = new mr();
    z.setModules(W, Q, D, g, f0, A, m, O, U), Q.setModules(W, U, m, A), O.setModules(Q, m), D.setModules(z), f0.setModules(Q, s0, g, K), g.setModules(K, s0, z.enc.psy), s0.setModules(Q), K.setModules(g), A.setModules(z, Q, m), u0.setModules(t0, U), t0.setModules(m, O, D);
    var R = z.lame_init();
    R.num_channels = w, R.in_samplerate = Z, R.brate = X, R.mode = lr.STEREO, R.quality = 3, R.bWriteVbrTag = !1, R.disable_reservoir = !0, R.write_id3tag_automatic = !1, z.lame_init_params(R);
    var o = 1152, u = 0 | 1.25 * o + 7200, d = ua(u);
    this.encodeBuffer = function(e, l) {
        w == 1 && (l = e), er(e.length == l.length), e.length > o && (o = e.length, u = 0 | 1.25 * o + 7200, d = ua(u));
        var M = z.lame_encode_buffer(R, e, l, e.length, d, 0, u);
        return new Int8Array(d.subarray(0, M));
    }, this.flush = function() {
        var e = z.lame_encode_flush(R, d, 0, u);
        return new Int8Array(d.subarray(0, e));
    };
}
function A1() {
    this.dataOffset = 0, this.dataLen = 0, this.channels = 0, this.sampleRate = 0;
}
function _e(w) {
    return w.charCodeAt(0) << 24 | w.charCodeAt(1) << 16 | w.charCodeAt(2) << 8 | w.charCodeAt(3);
}
A1.RIFF = _e("RIFF");
A1.WAVE = _e("WAVE");
A1.fmt_ = _e("fmt ");
A1.data = _e("data");
A1.readHeader = function(w) {
    var Z = new A1(), X = w.getUint32(0, !1);
    if (A1.RIFF == X && (w.getUint32(4, !0), A1.WAVE == w.getUint32(8, !1) && A1.fmt_ == w.getUint32(12, !1))) {
        var z = w.getUint32(16, !0), u0 = 20;
        switch(z){
            case 16:
            case 18:
                Z.channels = w.getUint16(u0 + 2, !0), Z.sampleRate = w.getUint32(u0 + 4, !0);
                break;
            default:
                throw "extended fmt chunk not implemented";
        }
        u0 += z;
        for(var W = A1.data, Q = 0; W != X && (X = w.getUint32(u0, !1), Q = w.getUint32(u0 + 4, !0), W != X);)u0 += Q + 8;
        return Z.dataLen = Q, Z.dataOffset = u0 + 8, Z;
    }
};
var Sr = fa.Mp3Encoder = cr, dr = fa.WavHeader = A1;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jKOtr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AudioPlayer", ()=>AudioPlayer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _icons = require("@ant-design/icons");
var _useAudioRecorder = require("./useAudioRecorder");
const SPEED_OPTIONS = [
    1.0,
    1.5,
    2.0
];
// Generates stable pseudo-waveform heights based on a seed or index
const WAVEFORM_BAR_COUNT = 28;
function generateWaveformBars(barCount, seed) {
    const bars = [];
    let num = 42;
    if (seed) for(let i = 0; i < seed.length; i++)num = (num * 31 + seed.charCodeAt(i)) % 1000;
    for(let i = 0; i < barCount; i++){
        // Generate height between 20% and 95%
        const pseudo = (Math.sin(i * 0.7 + num) + 1) / 2 * 60 + 20;
        bars.push(Math.round(pseudo));
    }
    return bars;
}
const AudioPlayer = ({ src, durationSeconds, compact = false, className = '', theme = 'preview' })=>{
    const audioRef = (0, _react.useRef)(null);
    const [isPlaying, setIsPlaying] = (0, _react.useState)(false);
    const [currentTime, setCurrentTime] = (0, _react.useState)(0);
    const [totalDuration, setTotalDuration] = (0, _react.useState)(durationSeconds || 0);
    const [playbackRateIndex, setPlaybackRateIndex] = (0, _react.useState)(0);
    const [isUnavailable, setIsUnavailable] = (0, _react.useState)(!src || !src.trim());
    const waveformBars = (0, _react.useMemo)(()=>generateWaveformBars(WAVEFORM_BAR_COUNT, src), [
        src
    ]);
    // Sync initial duration & src
    (0, _react.useEffect)(()=>{
        if (durationSeconds && durationSeconds > 0) setTotalDuration(durationSeconds);
        if (!src || !src.trim()) setIsUnavailable(true);
        else setIsUnavailable(false);
    }, [
        durationSeconds,
        src
    ]);
    // Handle Play/Pause gracefully
    const togglePlayPause = (0, _react.useCallback)(()=>{
        if (!audioRef.current || isUnavailable) return;
        if (isPlaying) audioRef.current.pause();
        else audioRef.current.play().then(()=>setIsPlaying(true)).catch(()=>{
            // Gracefully mark unavailable without throwing or polluting console
            setIsUnavailable(true);
            setIsPlaying(false);
        });
    }, [
        isPlaying,
        isUnavailable
    ]);
    // Handle Speed Change
    const cyclePlaybackRate = (0, _react.useCallback)(()=>{
        const nextIndex = (playbackRateIndex + 1) % SPEED_OPTIONS.length;
        setPlaybackRateIndex(nextIndex);
        if (audioRef.current) audioRef.current.playbackRate = SPEED_OPTIONS[nextIndex];
    }, [
        playbackRateIndex
    ]);
    // Handle Seek
    const safeDuration = totalDuration && isFinite(totalDuration) && totalDuration > 0 ? totalDuration : durationSeconds && isFinite(durationSeconds) && durationSeconds > 0 ? durationSeconds : 0;
    const handleScrubberClick = (e)=>{
        if (!audioRef.current || !safeDuration || isUnavailable) return;
        const rect = e.currentTarget.getBoundingClientRect();
        const clickX = e.clientX - rect.left;
        const percentage = Math.max(0, Math.min(1, clickX / rect.width));
        const newTime = percentage * safeDuration;
        audioRef.current.currentTime = newTime;
        setCurrentTime(newTime);
    };
    const progressPercentage = safeDuration > 0 ? currentTime / safeDuration * 100 : 0;
    if (isUnavailable) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `audio-player-component audio-unavailable theme-${theme} ${compact ? 'compact' : ''} ${className}`,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "audio-unavailable-badge",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.AudioMutedOutlined), {
                    className: "unavailable-icon"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    className: "unavailable-text",
                    children: "Voice note unavailable"
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `audio-player-component theme-${theme} ${compact ? 'compact' : ''} ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("audio", {
                ref: audioRef,
                src: src,
                preload: "metadata",
                onError: ()=>{
                    // Media deleted or source unsupported
                    setIsUnavailable(true);
                    setIsPlaying(false);
                },
                onLoadedMetadata: ()=>{
                    const d = audioRef.current?.duration;
                    if (d && !isNaN(d) && isFinite(d) && d > 0) setTotalDuration(d);
                    else if (durationSeconds && isFinite(durationSeconds) && durationSeconds > 0) setTotalDuration(durationSeconds);
                },
                onTimeUpdate: ()=>{
                    if (audioRef.current) setCurrentTime(audioRef.current.currentTime);
                },
                onPlay: ()=>setIsPlaying(true),
                onPause: ()=>setIsPlaying(false),
                onEnded: ()=>{
                    setIsPlaying(false);
                    setCurrentTime(0);
                    if (audioRef.current) audioRef.current.currentTime = 0;
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: `audio-play-btn ${isPlaying ? 'playing' : ''}`,
                onClick: togglePlayPause,
                "aria-label": isPlaying ? 'Pause voice note' : 'Play voice note',
                children: isPlaying ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.PauseOutlined), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CaretRightOutlined), {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "audio-waveform-container",
                onClick: handleScrubberClick,
                role: "slider",
                "aria-valuemin": 0,
                "aria-valuemax": safeDuration,
                "aria-valuenow": currentTime,
                tabIndex: 0,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "waveform-bars",
                    children: waveformBars.map((heightPercent, idx)=>{
                        const barProgress = idx / WAVEFORM_BAR_COUNT * 100;
                        const isPlayed = barProgress <= progressPercentage;
                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: `waveform-bar ${isPlayed ? 'played' : ''}`,
                            style: {
                                height: `${heightPercent}%`
                            }
                        }, idx);
                    })
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "audio-time-label",
                children: isPlaying || currentTime > 0 ? (0, _useAudioRecorder.formatAudioDuration)(currentTime) : (0, _useAudioRecorder.formatAudioDuration)(safeDuration)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                className: "audio-speed-btn",
                onClick: cyclePlaybackRate,
                title: "Change playback speed",
                children: [
                    SPEED_OPTIONS[playbackRateIndex],
                    "x"
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@ant-design/icons":[["AudioMutedOutlined","esXVS","default"],["CaretRightOutlined","lViGK","default"],["PauseOutlined","jyzqu","default"]],"./useAudioRecorder":"6Gsrv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"esXVS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _audioMutedOutlined = require("@ant-design/icons-svg/es/asn/AudioMutedOutlined");
var _audioMutedOutlinedDefault = parcelHelpers.interopDefault(_audioMutedOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const AudioMutedOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _audioMutedOutlinedDefault.default)
    }));
/**![audio-muted](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnM+PHN0eWxlIC8+PC9kZWZzPjxwYXRoIGQ9Ik02ODIgNDU1VjMxMWwtNzYgNzZ2NjhjLS4xIDUwLjctNDIgOTIuMS05NCA5MmE5NS44IDk1LjggMCAwMS01Mi0xNWwtNTQgNTVjMjkuMSAyMi40IDY1LjkgMzYgMTA2IDM2IDkzLjggMCAxNzAtNzUuMSAxNzAtMTY4eiIgLz48cGF0aCBkPSJNODMzIDQ0NmgtNjBjLTQuNCAwLTggMy42LTggOCAwIDE0MC4zLTExMy43IDI1NC0yNTQgMjU0LTYzIDAtMTIwLjctMjMtMTY1LTYxbC01NCA1NGEzMzQuMDEgMzM0LjAxIDAgMDAxNzkgODF2MTAySDMyNmMtMTMuOSAwLTI0LjkgMTQuMy0yNSAzMnYzNmMuMSA0LjQgMi45IDggNiA4aDQwOGMzLjIgMCA2LTMuNiA2LTh2LTM2YzAtMTcuNy0xMS0zMi0yNS0zMkg1NDdWNzgyYzE2NS4zLTE3LjkgMjk0LTE1Ny45IDI5NC0zMjggMC00LjQtMy42LTgtOC04em0xMy4xLTM3Ny43bC00My41LTQxLjlhOCA4IDAgMDAtMTEuMi4xbC0xMjkgMTI5QzYzNC4zIDEwMS4yIDU3NyA2NCA1MTEgNjRjLTkzLjkgMC0xNzAgNzUuMy0xNzAgMTY4djIyNGMwIDYuNy40IDEzLjMgMS4yIDE5LjhsLTY4IDY4QTI1Mi4zMyAyNTIuMzMgMCAwMTI1OCA0NTRjLS4yLTQuNC0zLjgtOC04LThoLTYwYy00LjQgMC04IDMuNi04IDggMCA1MyAxMi41IDEwMyAzNC42IDE0Ny40bC0xMzcgMTM3YTguMDMgOC4wMyAwIDAwMCAxMS4zbDQyLjcgNDIuN2MzLjEgMy4xIDguMiAzLjEgMTEuMyAwTDg0Ni4yIDc5LjhsLjEtLjFjMy4xLTMuMiAzLTguMy0uMi0xMS40ek00MTcgNDAxVjIzMmMwLTUwLjYgNDEuOS05MiA5NC05MiA0NiAwIDg0LjEgMzIuMyA5Mi4zIDc0LjdMNDE3IDQwMXoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(AudioMutedOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/AudioMutedOutlined":"iwXGY","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iwXGY":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var AudioMutedOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "defs",
                "attrs": {},
                "children": [
                    {
                        "tag": "style",
                        "attrs": {}
                    }
                ]
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M682 455V311l-76 76v68c-.1 50.7-42 92.1-94 92a95.8 95.8 0 01-52-15l-54 55c29.1 22.4 65.9 36 106 36 93.8 0 170-75.1 170-168z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M833 446h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254-63 0-120.7-23-165-61l-54 54a334.01 334.01 0 00179 81v102H326c-13.9 0-24.9 14.3-25 32v36c.1 4.4 2.9 8 6 8h408c3.2 0 6-3.6 6-8v-36c0-17.7-11-32-25-32H547V782c165.3-17.9 294-157.9 294-328 0-4.4-3.6-8-8-8zm13.1-377.7l-43.5-41.9a8 8 0 00-11.2.1l-129 129C634.3 101.2 577 64 511 64c-93.9 0-170 75.3-170 168v224c0 6.7.4 13.3 1.2 19.8l-68 68A252.33 252.33 0 01258 454c-.2-4.4-3.8-8-8-8h-60c-4.4 0-8 3.6-8 8 0 53 12.5 103 34.6 147.4l-137 137a8.03 8.03 0 000 11.3l42.7 42.7c3.1 3.1 8.2 3.1 11.3 0L846.2 79.8l.1-.1c3.1-3.2 3-8.3-.2-11.4zM417 401V232c0-50.6 41.9-92 94-92 46 0 84.1 32.3 92.3 74.7L417 401z"
                }
            }
        ]
    },
    "name": "audio-muted",
    "theme": "outlined"
};
exports.default = AudioMutedOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lViGK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _caretRightOutlined = require("@ant-design/icons-svg/es/asn/CaretRightOutlined");
var _caretRightOutlinedDefault = parcelHelpers.interopDefault(_caretRightOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const CaretRightOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _caretRightOutlinedDefault.default)
    }));
/**![caret-right](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTcxNS44IDQ5My41TDMzNSAxNjUuMWMtMTQuMi0xMi4yLTM1LTEuMi0zNSAxOC41djY1Ni44YzAgMTkuNyAyMC44IDMwLjcgMzUgMTguNWwzODAuOC0zMjguNGMxMC45LTkuNCAxMC45LTI3LjYgMC0zN3oiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(CaretRightOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/CaretRightOutlined":"5XMpg","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5XMpg":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var CaretRightOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "0 0 1024 1024",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z"
                }
            }
        ]
    },
    "name": "caret-right",
    "theme": "outlined"
};
exports.default = CaretRightOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jyzqu":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _pauseOutlined = require("@ant-design/icons-svg/es/asn/PauseOutlined");
var _pauseOutlinedDefault = parcelHelpers.interopDefault(_pauseOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const PauseOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _pauseOutlinedDefault.default)
    }));
/**![pause](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTMwNCAxNzZoODB2NjcyaC04MHptNDA4IDBoLTY0Yy00LjQgMC04IDMuNi04IDh2NjU2YzAgNC40IDMuNiA4IDggOGg2NGM0LjQgMCA4LTMuNiA4LThWMTg0YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(PauseOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/PauseOutlined":"2XgLE","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2XgLE":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var PauseOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "pause",
    "theme": "outlined"
};
exports.default = PauseOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4t7mY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AudioRecorderInline", ()=>AudioRecorderInline);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _icons = require("@ant-design/icons");
var _useAudioRecorder = require("./useAudioRecorder");
const AudioRecorderInline = ({ recorder, maxDurationSeconds = 300, onFinish, onCancel, className = '' })=>{
    const { isPaused, duration, volumeLevel, canStop, permissionStatus, errorMessage, pauseRecording, resumeRecording, stopRecording, cancelRecording } = recorder;
    const handleCancel = ()=>{
        cancelRecording();
        onCancel?.();
    };
    const handleStop = ()=>{
        if (!canStop) return;
        stopRecording();
        onFinish?.();
    };
    // If permission is blocked or device not found
    if (permissionStatus === 'denied' || permissionStatus === 'not_found' || permissionStatus === 'unsupported') return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `audio-recorder-inline error-state ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "error-message-box",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.WarningOutlined), {
                        className: "error-icon"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "error-text",
                        children: errorMessage || 'Microphone access is blocked. Please allow permissions in browser settings.'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                type: "button",
                className: "recorder-cancel-btn",
                onClick: handleCancel,
                title: "Dismiss",
                children: "Dismiss"
            })
        ]
    });
    // Equalizer visualizer bars (12 bars scaled by volume level)
    const equalizerBars = Array.from({
        length: 14
    }).map((_, index)=>{
        // Generate organic wave based on volume and index
        const baseHeight = 15;
        const waveFactor = Math.sin(index / 14 * Math.PI);
        const dynamicHeight = Math.max(baseHeight, Math.min(100, volumeLevel * waveFactor * 1.4 + (isPaused ? 0 : 10)));
        return isPaused ? baseHeight : dynamicHeight;
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `audio-recorder-inline ${className}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "recording-status-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `recording-dot ${isPaused ? 'paused' : 'live'}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "recording-text",
                        children: isPaused ? 'Paused' : 'Recording'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                        className: "recording-timer",
                        children: [
                            (0, _useAudioRecorder.formatAudioDuration)(Math.min(duration, maxDurationSeconds)),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "max-timer",
                                children: [
                                    " / ",
                                    (0, _useAudioRecorder.formatAudioDuration)(maxDurationSeconds)
                                ]
                            })
                        ]
                    })
                ]
            }),
            !isPaused && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "recording-equalizer-container",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "equalizer-bars",
                    children: equalizerBars.map((heightPercent, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            className: "equalizer-bar",
                            style: {
                                height: `${heightPercent}%`
                            }
                        }, idx))
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "recording-actions-section",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "action-btn discard-btn",
                        onClick: handleCancel,
                        title: "Discard voice note",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.DeleteOutlined), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "action-btn pause-resume-btn",
                        onClick: isPaused ? resumeRecording : pauseRecording,
                        title: isPaused ? 'Resume recording' : 'Pause recording',
                        children: isPaused ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CaretRightOutlined), {}) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.PauseOutlined), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: `action-btn finish-btn ${!canStop ? 'disabled-debouncing' : ''}`,
                        onClick: handleStop,
                        disabled: !canStop,
                        title: !canStop ? 'Recording (minimum 2s)...' : 'Finish recording',
                        children: !canStop ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                            className: "debounce-spin"
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CheckOutlined), {})
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@ant-design/icons":[["CaretRightOutlined","lViGK","default"],["CheckOutlined","jMPci","default"],["DeleteOutlined","hgODG","default"],["LoadingOutlined","8Mvdh","default"],["PauseOutlined","jyzqu","default"],["WarningOutlined","3SwL4","default"]],"./useAudioRecorder":"6Gsrv","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7Rhmk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AudioMessageBubble", ()=>AudioMessageBubble);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _audioPlayer = require("./AudioPlayer");
var _messageReadStatus = require("src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/components/MessageReadStatus");
const AudioMessageBubble = ({ message, isSentByTrainer, timeStr, renderTextWithLinks })=>{
    const audioSrc = message.audio_url || message.media_url || '';
    const duration = message.audio_duration_seconds;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `audio-message-bubble-box ${isSentByTrainer ? 'sent' : 'received'}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "audio-bubble-card",
                children: [
                    audioSrc && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _audioPlayer.AudioPlayer), {
                        src: audioSrc,
                        durationSeconds: duration,
                        theme: isSentByTrainer ? 'sent' : 'received'
                    }),
                    Boolean(message.body && message.body.trim()) && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "audio-caption-text",
                        children: renderTextWithLinks ? renderTextWithLinks(message.body) : message.body
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "message-meta",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageReadStatus.MessageReadStatus), {
                        isRead: !!message.is_read,
                        isSentByTrainer: isSentByTrainer
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: timeStr
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","./AudioPlayer":"jKOtr","src/screens/OnboardingTrainer/screens/Dashboard/screens/Messages/components/MessageReadStatus":"jJM9L","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jJM9L":[function(require,module,exports,__globalThis) {
// MessageReadStatus component for single (sent) and double (read) checkmark indicators
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MessageReadStatus", ()=>MessageReadStatus);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _messageReadSingleCheckSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/read-status/message-read-single-check.svg");
var _messageReadDoubleCheckSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/read-status/message-read-double-check.svg");
const MessageReadStatus = (props)=>{
    const { isRead, isSentByTrainer } = props;
    if (!isSentByTrainer) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
        className: `message-read-status ${isRead ? 'read' : 'sent'}`,
        "aria-label": isRead ? 'Message read by recipient' : 'Message sent',
        title: isRead ? 'Read' : 'Delivered',
        children: isRead ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageReadDoubleCheckSvg.ReactComponent), {
            className: "checkmark-svg double-check"
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageReadSingleCheckSvg.ReactComponent), {
            className: "checkmark-svg single-check"
        })
    });
};
MessageReadStatus.displayName = 'MessageReadStatus';

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/assets/images/onboarding-trainer/dashboard/messages/read-status/message-read-single-check.svg":"jD18w","src/assets/images/onboarding-trainer/dashboard/messages/read-status/message-read-double-check.svg":"3Bf5e","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jD18w":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessageReadSingleCheck);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessageReadSingleCheck = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        fill: "none",
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.6,
            d: "m1.5 6.5 3 3 6-7"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Bf5e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessageReadDoubleCheck);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessageReadDoubleCheck = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 12,
        fill: "none",
        viewBox: "0 0 16 12",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.6,
                d: "M1 6.5 4.5 10l7-8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.6,
                d: "M5.5 6.5 9 10l6.5-8"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1eYUx":[function() {},{}],"7jdsU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "searchConversationMessages", ()=>searchConversationMessages);
parcelHelpers.export(exports, "useSearchChatMessages", ()=>useSearchChatMessages);
parcelHelpers.export(exports, "fetchMessageContextWindow", ()=>fetchMessageContextWindow);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
const searchConversationMessages = async (chatId, query, options)=>{
    if (!chatId || !query.trim()) return {
        chatId,
        query,
        totalMatches: 0,
        matches: []
    };
    const token = await (0, _firebase.auth).currentUser?.getIdToken() || (0, _sessionStore.sessionStore).getState().token;
    if (!token) throw new Error('Authentication required.');
    const queryParams = new URLSearchParams({
        chatId,
        query: query.trim(),
        limit: String(options?.limit ?? 100)
    });
    if (options?.inquiryId) queryParams.set('inquiryId', options.inquiryId);
    if (options?.excludeInquiries) queryParams.set('excludeInquiries', 'true');
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_SEARCH_CONVERSATION_MESSAGES}?${queryParams.toString()}`;
    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    });
    if (!response.ok) {
        const errorData = await response.json().catch(()=>({}));
        throw new Error(errorData?.error?.message || 'Failed to search messages.');
    }
    return response.json();
};
const useSearchChatMessages = (chatId, query, enabled = true, options)=>{
    const trimmed = query.trim();
    const inquiryId = options?.inquiryId || '';
    const excludeInquiries = Boolean(options?.excludeInquiries);
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'search-chat-messages',
            chatId,
            trimmed,
            inquiryId,
            excludeInquiries
        ],
        queryFn: ()=>searchConversationMessages(chatId, trimmed, options),
        enabled: Boolean(chatId) && trimmed.length > 0 && enabled,
        staleTime: 10000
    });
};
const fetchMessageContextWindow = async (chatId, targetMessageId, surroundingLimit = 25)=>{
    if (!chatId || !targetMessageId) throw new Error('chatId and targetMessageId are required.');
    const token = await (0, _firebase.auth).currentUser?.getIdToken() || (0, _sessionStore.sessionStore).getState().token;
    if (!token) throw new Error('Authentication required.');
    const queryParams = new URLSearchParams({
        chatId,
        targetMessageId,
        surroundingLimit: String(surroundingLimit)
    });
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_MESSAGE_CONTEXT_WINDOW}?${queryParams.toString()}`;
    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    });
    if (!response.ok) {
        const errorData = await response.json().catch(()=>({}));
        throw new Error(errorData?.error?.message || 'Failed to load message context.');
    }
    return response.json();
};

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5s2pW":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReportIssueView", ()=>ReportIssueView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _firebaseStorage = require("src/api/services/firebaseStorage");
var _supportReports = require("src/api/supportReports");
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _reportIssueInappropriateBehaviourSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-inappropriate-behaviour.svg");
var _reportIssueHarassmentOrAbuseSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-harassment-or-abuse.svg");
var _reportIssueSpamOrUnwantedMessagesSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-spam-or-unwanted-messages.svg");
var _reportIssuePaymentOrBillingSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-payment-or-billing.svg");
var _reportIssueTechnicalIssueSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-technical-issue.svg");
var _reportIssueOtherSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-other.svg");
var _reportIssueCheckmarkSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-checkmark.svg");
var _checkinRequestSentSvg = require("src/assets/images/onboarding-trainer/dashboard/checkins/checkin-request-sent.svg");
var _reactRouterDom = require("react-router-dom");
var _reactQuery = require("@tanstack/react-query");
var _reportBackArrowSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-back-arrow.svg");
var _reportIssueViewScss = require("./ReportIssueView.scss");
const CATEGORIES = [
    {
        name: 'Inappropriate behaviour',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportIssueInappropriateBehaviourSvg.ReactComponent), {})
    },
    {
        name: 'Harassment or abuse',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportIssueHarassmentOrAbuseSvg.ReactComponent), {})
    },
    {
        name: 'Spam or unwanted messages',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportIssueSpamOrUnwantedMessagesSvg.ReactComponent), {})
    },
    {
        name: 'Payment or billing',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportIssuePaymentOrBillingSvg.ReactComponent), {})
    },
    {
        name: 'Technical issue',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportIssueTechnicalIssueSvg.ReactComponent), {})
    },
    {
        name: 'Other',
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportIssueOtherSvg.ReactComponent), {})
    }
];
const ALLOWED_TYPES = [
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/gif',
    'image/webp'
];
const MAX_SIZE_MB = 5;
const ReportIssueView = ({ chatId, trainerUid, clientUid, onClose, onBlocked })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const queryClient = (0, _reactQuery.useQueryClient)();
    const [selectedCategory, setSelectedCategory] = (0, _react.useState)('');
    const [details, setDetails] = (0, _react.useState)('');
    const [screenshots, setScreenshots] = (0, _react.useState)([]);
    const [isSubmitting, setIsSubmitting] = (0, _react.useState)(false);
    const [isSubmitted, setIsSubmitted] = (0, _react.useState)(false);
    const submitReportMutation = (0, _supportReports.useSubmitSupportReportMutation)();
    const blockClientMutation = (0, _supportReports.useBlockClientMutation)();
    const fileInputRef = (0, _react.useRef)(null);
    const handleFileChange = (e)=>{
        if (!e.target.files?.length) return;
        const newFiles = Array.from(e.target.files);
        const validFiles = [];
        newFiles.forEach((file)=>{
            if (!ALLOWED_TYPES.includes(file.type)) {
                (0, _reactHotToastDefault.default).error(`${file.name} is not a supported image format.`);
                return;
            }
            if (file.size > MAX_SIZE_MB * 1048576) {
                (0, _reactHotToastDefault.default).error(`${file.name} exceeds the 5MB size limit.`);
                return;
            }
            validFiles.push(file);
        });
        if (screenshots.length + validFiles.length > 5) {
            (0, _reactHotToastDefault.default).error('You can only attach up to 5 screenshots.');
            validFiles.splice(5 - screenshots.length);
        }
        setScreenshots((prev)=>[
                ...prev,
                ...validFiles
            ]);
        if (fileInputRef.current) fileInputRef.current.value = '';
    };
    const removeScreenshot = (index)=>{
        setScreenshots((prev)=>prev.filter((_, i)=>i !== index));
    };
    const handleSubmit = async ()=>{
        if (!selectedCategory) {
            (0, _reactHotToastDefault.default).error('Please select an issue category.');
            return;
        }
        setIsSubmitting(true);
        try {
            // Parallel upload of screenshots
            const uploadPromises = screenshots.map((file)=>(0, _firebaseStorage.uploadSupportScreenshot)(file, trainerUid).catch((e)=>{
                    console.error('Screenshot upload failed', e);
                    throw new Error(`Failed to upload ${file.name}`);
                }));
            const uploadedUrls = await Promise.all(uploadPromises);
            // Submit report via backend Cloud Function API
            await submitReportMutation.mutateAsync({
                chatId,
                reportedUid: clientUid,
                category: selectedCategory,
                details: details.trim(),
                screenshots: uploadedUrls
            });
            setIsSubmitted(true);
        } catch (error) {
            (0, _reactHotToastDefault.default).error(error.message || 'Failed to submit report. Please try again.');
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleBlockClient = async ()=>{
        try {
            await blockClientMutation.mutateAsync({
                clientUid,
                chatId,
                reason: selectedCategory || 'Reported issue block'
            });
            (0, _reactHotToastDefault.default).success('Client blocked successfully', {
                id: 'block-client-success'
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-clients'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'inquiries'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'chats'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'checkins'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-messages-page'
                ]
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'trainer-program-plan-list'
                ]
            });
            onBlocked?.();
            onClose();
            navigate('/onboarding-trainer/dashboard/messages', {
                replace: true
            });
        } catch (error) {
            (0, _reactHotToastDefault.default).error(error.message || 'Failed to block client. Please try again.');
        }
    };
    if (isSubmitted) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "report-issue-view submitted",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "success-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "success-icon-badge",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkinRequestSentSvg.ReactComponent), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: "Report submitted!"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    children: "Thanks for reporting this issue. Our support team will review the details and any screenshots you attached."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "success-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: `block-button ${blockClientMutation.isPending ? 'submitting' : ''}`,
                            onClick: handleBlockClient,
                            disabled: blockClientMutation.isPending,
                            children: blockClientMutation.isPending ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                    style: {
                                        color: '#04051b',
                                        fontSize: 20
                                    },
                                    spin: true
                                })
                            }) : 'Block client'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            className: "back-button",
                            onClick: onClose,
                            disabled: blockClientMutation.isPending,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportBackArrowSvg.ReactComponent), {
                                    className: "back-arrow-icon"
                                }),
                                " Back to chat"
                            ]
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "report-issue-view",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "report-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "back-nav",
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LeftOutlined), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "Report an issue"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "report-content-scroll",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "report-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "section-title",
                            children: "What's the issue about?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "category-list",
                            children: CATEGORIES.map((category)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    type: "button",
                                    className: `category-item ${selectedCategory === category.name ? 'selected' : ''}`,
                                    onClick: ()=>setSelectedCategory(category.name),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "category-content",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "category-icon",
                                                    children: category.icon
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "category-text",
                                                    children: category.name
                                                })
                                            ]
                                        }),
                                        selectedCategory === category.name && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "selected-check-badge",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reportIssueCheckmarkSvg.ReactComponent), {})
                                        })
                                    ]
                                }, category.name))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "section-title",
                            children: "Please provide more details"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "details-container",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                    placeholder: "Please describe the issue...",
                                    value: details,
                                    onChange: (e)=>setDetails(e.target.value.substring(0, 500)),
                                    maxLength: 500,
                                    rows: 5
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "char-count",
                                    children: [
                                        details.length,
                                        "/500"
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "section-title",
                            children: [
                                "Add screenshots ",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: "(optional)"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "screenshots-subtitle",
                            children: "You can add up to 5 screenshots"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "screenshots-container",
                            children: [
                                screenshots.length < 5 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "upload-box",
                                    onClick: ()=>fileInputRef.current?.click(),
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.PlusOutlined), {})
                                }),
                                screenshots.map((file, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "screenshot-preview",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: URL.createObjectURL(file),
                                                alt: `Screenshot ${idx + 1}`
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "remove-btn",
                                                onClick: ()=>removeScreenshot(idx),
                                                "aria-label": "Remove screenshot",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {})
                                            })
                                        ]
                                    }, idx))
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "file",
                            ref: fileInputRef,
                            style: {
                                display: 'none'
                            },
                            accept: "image/png, image/jpeg, image/jpg, image/gif, image/webp",
                            multiple: true,
                            onChange: handleFileChange
                        }),
                        (()=>{
                            const isSubmittingReport = isSubmitting || submitReportMutation.isPending;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                className: `submit-report-btn ${isSubmittingReport ? 'submitting' : ''}`,
                                onClick: handleSubmit,
                                disabled: !selectedCategory || isSubmittingReport,
                                children: isSubmittingReport ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                    indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                        style: {
                                            color: '#04051b',
                                            fontSize: 22
                                        },
                                        spin: true
                                    })
                                }) : 'Submit Report'
                            });
                        })()
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["CloseOutlined","dinn5","default"],["LeftOutlined","8erTV","default"],["LoadingOutlined","8Mvdh","default"],["PlusOutlined","hcqGE","default"]],"src/api/services/firebaseStorage":"cCllM","src/api/supportReports":"3GxXz","react-hot-toast":"3T0Wh","src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-inappropriate-behaviour.svg":"fWEVO","src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-harassment-or-abuse.svg":"bCOEO","src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-spam-or-unwanted-messages.svg":"3XV8S","src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-payment-or-billing.svg":"k9w5j","src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-technical-issue.svg":"kcHYk","src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-other.svg":"654w7","src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-issue-checkmark.svg":"MoMRy","src/assets/images/onboarding-trainer/dashboard/checkins/checkin-request-sent.svg":"jMwNN","react-router-dom":"f3cgC","@tanstack/react-query":"97Oud","src/assets/images/onboarding-trainer/dashboard/messages/report-issue/report-back-arrow.svg":"03eqR","./ReportIssueView.scss":"8QD3m","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hcqGE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _plusOutlined = require("@ant-design/icons-svg/es/asn/PlusOutlined");
var _plusOutlinedDefault = parcelHelpers.interopDefault(_plusOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const PlusOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _plusOutlinedDefault.default)
    }));
/**![plus](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTQ4MiAxNTJoNjBxOCAwIDggOHY3MDRxMCA4LTggOGgtNjBxLTggMC04LThWMTYwcTAtOCA4LTh6IiAvPjxwYXRoIGQ9Ik0xOTIgNDc0aDY3MnE4IDAgOCA4djYwcTAgOC04IDhIMTYwcS04IDAtOC04di02MHEwLTggOC04eiIgLz48L3N2Zz4=) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(PlusOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/PlusOutlined":"kNWPr","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kNWPr":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var PlusOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8z"
                }
            }
        ]
    },
    "name": "plus",
    "theme": "outlined"
};
exports.default = PlusOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fWEVO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReportIssueInappropriateBehaviour);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReportIssueInappropriateBehaviour = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 18,
        fill: "none",
        viewBox: "0 0 15 18",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M7.5 8.75A4.375 4.375 0 1 0 7.5 0a4.375 4.375 0 0 0 0 8.75M2.188 10A2.19 2.19 0 0 0 0 12.188v.312c0 1.496.952 2.76 2.303 3.62 1.359.866 3.198 1.38 5.197 1.38s3.838-.514 5.197-1.38C14.048 15.26 15 13.997 15 12.5v-.312A2.19 2.19 0 0 0 12.813 10z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bCOEO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReportIssueHarassmentOrAbuse);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReportIssueHarassmentOrAbuse = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 15,
        fill: "none",
        viewBox: "0 0 17 15",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "m9.527.625 7.196 12.462a1.25 1.25 0 0 1-1.083 1.875H1.25a1.25 1.25 0 0 1-1.083-1.875L7.362.625a1.25 1.25 0 0 1 2.165 0m-1.082 9.877a.834.834 0 1 0 0 1.667.834.834 0 0 0 0-1.667m0-5.834a.833.833 0 0 0-.828.736l-.005.098v3.333a.833.833 0 0 0 1.66.097l.006-.097V5.502a.833.833 0 0 0-.833-.834"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3XV8S":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReportIssueSpamOrUnwantedMessages);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReportIssueSpamOrUnwantedMessages = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 14,
        fill: "none",
        viewBox: "0 0 17 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M1.667 13.333q-.688 0-1.177-.489A1.6 1.6 0 0 1 0 11.667v-10Q0 .98.49.49T1.667 0H15q.687 0 1.177.49t.49 1.177v10q0 .687-.49 1.177a1.6 1.6 0 0 1-1.177.49zm6.666-5.979q.105 0 .22-.032a1 1 0 0 0 .218-.093l5.896-3.687A.69.69 0 0 0 15 2.938a.68.68 0 0 0-.354-.626q-.354-.207-.73.021l-5.583 3.5-5.583-3.5q-.375-.229-.73-.01-.353.219-.353.615 0 .207.083.365a.55.55 0 0 0 .25.239l5.896 3.687a.9.9 0 0 0 .437.125"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k9w5j":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReportIssuePaymentOrBilling);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReportIssuePaymentOrBilling = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 14,
        fill: "none",
        viewBox: "0 0 18 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M0 11.563a2.187 2.187 0 0 0 2.188 2.187h13.125a2.19 2.19 0 0 0 2.187-2.187V5.547H0zm2.578-2.97A1.17 1.17 0 0 1 3.75 7.423h1.875a1.17 1.17 0 0 1 1.172 1.172v.781a1.17 1.17 0 0 1-1.172 1.172H3.75a1.17 1.17 0 0 1-1.172-1.172zM15.313 0H2.188A2.19 2.19 0 0 0 0 2.188v1.015h17.5V2.188A2.19 2.19 0 0 0 15.313 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kcHYk":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReportIssueTechnicalIssue);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReportIssueTechnicalIssue = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            fillRule: "evenodd",
            d: "m5.054 4.948.782-2.342L3.467.239C3.951.085 4.467 0 5.002 0a5 5 0 0 1 4.786 6.453l5.214 5.214A2.357 2.357 0 1 1 11.67 15L6.455 9.786A5 5 0 0 1 .24 3.473l2.366 2.36 2.344-.78z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"654w7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReportIssueOther);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReportIssueOther = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 4,
        fill: "none",
        viewBox: "0 0 16 4",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M7.667 2.667a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667M13.5 2.667A.833.833 0 1 0 13.5 1a.833.833 0 0 0 0 1.667M1.833 2.667a.833.833 0 1 0 0-1.667.833.833 0 0 0 0 1.667"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"MoMRy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReportIssueCheckmark);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReportIssueCheckmark = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#04051B",
            d: "m5.37 10.1 5.65-5.65a.64.64 0 0 1 .466-.2.64.64 0 0 1 .467.2q.2.2.2.475a.65.65 0 0 1-.2.475l-6.117 6.133a.64.64 0 0 1-.467.2.64.64 0 0 1-.466-.2L2.036 8.667a.62.62 0 0 1-.192-.475.68.68 0 0 1 .209-.475.65.65 0 0 1 .475-.2q.274 0 .475.2z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"03eqR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgReportBackArrow);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgReportBackArrow = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M20 12H4m6-6-6 6 6 6"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8QD3m":[function() {},{}],"2iBPl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MediaLinksFilesView", ()=>MediaLinksFilesView);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _icons = require("@ant-design/icons");
var _antd = require("antd");
var _types = require("../../types");
var _useGetChatMedia = require("src/api/mutations/useGetChatMedia");
var _fullScreenImageModal = require("src/components/Modals/FullScreenImageModal/FullScreenImageModal");
var _fullScreenVideoModal = require("src/components/Modals/FullScreenVideoModal/FullScreenVideoModal");
var _mediaLinksFilesDownloadSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/media-links/media-links-files-download.svg");
var _chatLinkCard = require("../ChatLinkCard/ChatLinkCard");
var _linkMetadata = require("../../utils/linkMetadata");
var _mediaLinksFilesViewScss = require("./MediaLinksFilesView.scss");
const formatBytes = (bytes)=>{
    if (!bytes || bytes === 0) return '0 B';
    const k = 1024;
    const sizes = [
        'B',
        'KB',
        'MB',
        'GB',
        'TB'
    ];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(1)) + ' ' + sizes[i];
};
const getFileMeta = (mimeType, fileName)=>{
    const ext = fileName ? fileName.split('.').pop()?.toLowerCase() : '';
    const mime = mimeType?.toLowerCase() || '';
    if (ext === 'pdf' || mime === 'application/pdf') return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FilePdfOutlined), {
            style: {
                color: '#ef4444'
            }
        }),
        bg: 'rgba(239, 68, 68, 0.15)',
        color: '#ef4444',
        label: 'PDF'
    };
    if ([
        'doc',
        'docx'
    ].includes(ext || '') || mime.includes('word') || mime.includes('officedocument.wordprocessingml')) return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FileWordOutlined), {
            style: {
                color: '#3b82f6'
            }
        }),
        bg: 'rgba(59, 130, 246, 0.15)',
        color: '#3b82f6',
        label: 'Word'
    };
    if ([
        'xls',
        'xlsx',
        'csv'
    ].includes(ext || '') || mime.includes('excel') || mime.includes('spreadsheetml') || mime === 'text/csv') return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FileExcelOutlined), {
            style: {
                color: '#10b981'
            }
        }),
        bg: 'rgba(16, 185, 129, 0.15)',
        color: '#10b981',
        label: ext === 'csv' ? 'CSV' : 'Excel'
    };
    if ([
        'ppt',
        'pptx'
    ].includes(ext || '') || mime.includes('presentation') || mime.includes('powerpoint')) return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FilePptOutlined), {
            style: {
                color: '#f97316'
            }
        }),
        bg: 'rgba(249, 115, 22, 0.15)',
        color: '#f97316',
        label: 'PPT'
    };
    if ([
        'zip',
        'rar',
        '7z',
        'tar',
        'gz'
    ].includes(ext || '') || mime.includes('zip') || mime.includes('compressed')) return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FileZipOutlined), {
            style: {
                color: '#a855f7'
            }
        }),
        bg: 'rgba(168, 85, 247, 0.15)',
        color: '#a855f7',
        label: 'Archive'
    };
    if ([
        'png',
        'jpg',
        'jpeg',
        'webp',
        'gif',
        'svg'
    ].includes(ext || '') || mime.startsWith('image/')) return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FileImageOutlined), {
            style: {
                color: '#06b6d4'
            }
        }),
        bg: 'rgba(6, 182, 212, 0.15)',
        color: '#06b6d4',
        label: ext ? ext.toUpperCase() : 'Image'
    };
    return {
        icon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.FileTextOutlined), {
            style: {
                color: '#60a5fa'
            }
        }),
        bg: 'rgba(96, 165, 250, 0.15)',
        color: '#60a5fa',
        label: ext ? ext.toUpperCase() : 'Document'
    };
};
const MediaLinksFilesView = ({ chatId, inquiryId, messages = [], onBack, initialTab = 'media' })=>{
    const [activeTab, setActiveTab] = (0, _react.useState)(initialTab);
    // Preview modals
    const [previewOpen, setPreviewOpen] = (0, _react.useState)(false);
    const [previewUrl, setPreviewUrl] = (0, _react.useState)('');
    const [previewVideoUrl, setPreviewVideoUrl] = (0, _react.useState)(null);
    // Fetch all chat media without pagination from Cloud Function backend
    const { data: serverMediaData, isLoading: isServerLoading } = (0, _useGetChatMedia.useGetChatMedia)(chatId || '', inquiryId, Boolean(chatId));
    // Normalize and merge media items (server + realtime messages)
    const mediaItems = (0, _react.useMemo)(()=>{
        const map = new Map();
        // 1. Seed from backend API
        if (serverMediaData?.media) serverMediaData.media.forEach((item)=>{
            map.set(item.id, {
                id: item.id,
                url: item.url,
                type: item.type,
                fileName: item.file_name,
                date: new Date(item.date)
            });
        });
        // 2. Overlay from realtime messages
        messages.forEach((msg)=>{
            if (msg.attachments && msg.attachments.length > 0) msg.attachments.forEach((att, idx)=>{
                if (att.kind === 'media' || att.type === 'image' || att.type === 'video') {
                    const id = `${msg.id}_${idx}`;
                    map.set(id, {
                        id,
                        url: att.url,
                        type: att.type === 'video' ? 'video' : 'image',
                        fileName: att.file_name,
                        date: (0, _types.parseFirestoreDate)(msg.send_time)
                    });
                }
            });
            else if (msg.message_type === 'image' || msg.message_type === 'video') {
                if (msg.media_url) map.set(msg.id, {
                    id: msg.id,
                    url: msg.media_url,
                    type: msg.message_type,
                    fileName: msg.file_name,
                    date: (0, _types.parseFirestoreDate)(msg.send_time)
                });
            }
        });
        const list = Array.from(map.values());
        return list.sort((a, b)=>b.date.getTime() - a.date.getTime());
    }, [
        serverMediaData,
        messages
    ]);
    // Normalize and merge file items (server + realtime messages)
    const fileItems = (0, _react.useMemo)(()=>{
        const map = new Map();
        // 1. Seed from backend API
        if (serverMediaData?.files) serverMediaData.files.forEach((item)=>{
            map.set(item.id, {
                id: item.id,
                url: item.url,
                fileName: item.file_name || 'Unknown File',
                mimeType: item.mime_type || '',
                sizeBytes: item.size_bytes || 0,
                sizeLabel: item.size_label,
                date: new Date(item.date)
            });
        });
        // 2. Overlay from realtime messages
        messages.forEach((msg)=>{
            if (msg.attachments && msg.attachments.length > 0) msg.attachments.forEach((att, idx)=>{
                if (att.kind === 'file') {
                    const id = `${msg.id}_${idx}`;
                    map.set(id, {
                        id,
                        url: att.url,
                        fileName: att.file_name || 'Unknown File',
                        mimeType: att.mime_type || '',
                        sizeBytes: att.size_bytes || 0,
                        sizeLabel: att.size_label,
                        date: (0, _types.parseFirestoreDate)(msg.send_time)
                    });
                }
            });
            else if (msg.message_type === 'pdf') {
                const legacyUrl = msg.file_url || msg.media_url;
                if (legacyUrl) map.set(msg.id, {
                    id: msg.id,
                    url: legacyUrl,
                    fileName: msg.file_name || 'Document.pdf',
                    mimeType: 'application/pdf',
                    sizeBytes: typeof msg.file_size === 'number' ? msg.file_size : 0,
                    date: (0, _types.parseFirestoreDate)(msg.send_time)
                });
            }
        });
        const list = Array.from(map.values());
        return list.sort((a, b)=>b.date.getTime() - a.date.getTime());
    }, [
        serverMediaData,
        messages
    ]);
    // Normalize and merge link items (server + realtime messages)
    const linkItems = (0, _react.useMemo)(()=>{
        const map = new Map();
        const URL_REGEX = /https?:\/\/[^\s]+[^\s.,;:!?'")]/g;
        // 1. Seed from backend API
        if (serverMediaData?.links) serverMediaData.links.forEach((item)=>{
            const initMeta = (0, _linkMetadata.getInitialLinkMetadata)(item.url);
            map.set(item.id, {
                id: item.id,
                url: item.url,
                domain: item.domain || initMeta.domain,
                title: item.title || initMeta.title,
                description: item.description || initMeta.description,
                date: new Date(item.date)
            });
        });
        // 2. Overlay from realtime messages
        messages.forEach((msg)=>{
            const bodyText = msg.body || msg.inquiryDetail || msg.inquirySubject || msg.inquiry_text;
            if (bodyText && bodyText.trim().length > 0) {
                const matches = bodyText.match(URL_REGEX);
                if (matches) {
                    const seenUrls = new Set();
                    matches.forEach((url)=>{
                        const normalizedUrl = url.endsWith('/') ? url.slice(0, -1) : url;
                        if (!seenUrls.has(normalizedUrl)) {
                            seenUrls.add(normalizedUrl);
                            const preview = msg.link_preview;
                            const initMeta = (0, _linkMetadata.getInitialLinkMetadata)(url, bodyText);
                            const id = `${msg.id}_${normalizedUrl}`;
                            map.set(id, {
                                id,
                                url,
                                domain: preview?.domain || initMeta.domain,
                                title: preview?.title || initMeta.title,
                                description: preview?.description || initMeta.description,
                                contextText: bodyText,
                                date: (0, _types.parseFirestoreDate)(msg.send_time)
                            });
                        }
                    });
                }
            }
        });
        const list = Array.from(map.values());
        return list.sort((a, b)=>b.date.getTime() - a.date.getTime());
    }, [
        serverMediaData,
        messages
    ]);
    // Group by Date for Media
    const groupedMedia = (0, _react.useMemo)(()=>{
        const groups = [];
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        mediaItems.forEach((item)=>{
            const itemDate = new Date(item.date.getFullYear(), item.date.getMonth(), item.date.getDate());
            let label = '';
            if (itemDate.getTime() === today.getTime()) label = 'Today';
            else if (itemDate.getTime() === yesterday.getTime()) label = 'Yesterday';
            else label = item.date.toLocaleDateString('en-GB', {
                month: 'short'
            });
            const lastGroup = groups[groups.length - 1];
            if (lastGroup && lastGroup.label === label) lastGroup.items.push(item);
            else groups.push({
                label,
                items: [
                    item
                ]
            });
        });
        return groups;
    }, [
        mediaItems
    ]);
    // Group by Date for Files
    const groupedFiles = (0, _react.useMemo)(()=>{
        const groups = [];
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        fileItems.forEach((item)=>{
            const itemDate = new Date(item.date.getFullYear(), item.date.getMonth(), item.date.getDate());
            let label = '';
            if (itemDate.getTime() === today.getTime()) label = 'Today';
            else if (itemDate.getTime() === yesterday.getTime()) label = 'Yesterday';
            else label = item.date.toLocaleDateString('en-GB', {
                month: 'short'
            });
            const lastGroup = groups[groups.length - 1];
            if (lastGroup && lastGroup.label === label) lastGroup.items.push(item);
            else groups.push({
                label,
                items: [
                    item
                ]
            });
        });
        return groups;
    }, [
        fileItems
    ]);
    // Group by Date for Links
    const groupedLinks = (0, _react.useMemo)(()=>{
        const groups = [];
        const now = new Date();
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const yesterday = new Date(today);
        yesterday.setDate(yesterday.getDate() - 1);
        linkItems.forEach((item)=>{
            const itemDate = new Date(item.date.getFullYear(), item.date.getMonth(), item.date.getDate());
            let label = '';
            if (itemDate.getTime() === today.getTime()) label = 'Today';
            else if (itemDate.getTime() === yesterday.getTime()) label = 'Yesterday';
            else label = item.date.toLocaleDateString('en-GB', {
                month: 'short'
            });
            const lastGroup = groups[groups.length - 1];
            if (lastGroup && lastGroup.label === label) lastGroup.items.push(item);
            else groups.push({
                label,
                items: [
                    item
                ]
            });
        });
        return groups;
    }, [
        linkItems
    ]);
    const openPreview = (item)=>{
        if (item.type === 'video') {
            setPreviewVideoUrl(item.url);
            return;
        }
        setPreviewUrl(item.url);
        setPreviewOpen(true);
    };
    const downloadFile = (url)=>{
        window.open(url, '_blank');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "media-links-files-view",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mlf-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: "back-nav",
                        onClick: onBack,
                        "aria-label": "Back",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LeftOutlined), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: "Media, links & files"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "mlf-segmented-control",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: activeTab === 'media' ? 'active' : '',
                        onClick: ()=>setActiveTab('media'),
                        children: "Media"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: activeTab === 'files' ? 'active' : '',
                        onClick: ()=>setActiveTab('files'),
                        children: "Files"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        className: activeTab === 'links' ? 'active' : '',
                        onClick: ()=>setActiveTab('links'),
                        children: "Links"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mlf-content",
                children: isServerLoading && mediaItems.length === 0 && fileItems.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        textAlign: 'center',
                        padding: '60px 0'
                    },
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                        indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                            style: {
                                fontSize: 28,
                                color: '#F59E0B'
                            },
                            spin: true
                        })
                    })
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        activeTab === 'media' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "media-tab",
                            children: groupedMedia.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "empty-state",
                                children: "No media in this conversation"
                            }) : groupedMedia.map((group)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "media-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-label",
                                            children: group.label
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "media-grid",
                                            children: group.items.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `media-item ${item.type}`,
                                                    onClick: ()=>openPreview(item),
                                                    children: item.type === 'video' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "video-thumbnail",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                                                                src: item.url,
                                                                preload: "metadata"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                                className: "play-icon-overlay",
                                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.PlayCircleFilled), {})
                                                            })
                                                        ]
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                        src: item.url,
                                                        alt: "Media attachment",
                                                        loading: "lazy"
                                                    })
                                                }, item.id))
                                        })
                                    ]
                                }, group.label))
                        }),
                        activeTab === 'files' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "files-tab",
                            children: groupedFiles.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "empty-state",
                                children: "No files in this conversation"
                            }) : groupedFiles.map((group)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "file-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-label",
                                            children: group.label
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "file-list",
                                            children: group.items.map((item)=>{
                                                const meta = getFileMeta(item.mimeType, item.fileName);
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "file-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "file-icon-container",
                                                            style: {
                                                                background: meta.bg
                                                            },
                                                            children: meta.icon
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "file-details",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "file-name",
                                                                    children: item.fileName
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "file-meta",
                                                                    children: [
                                                                        meta.label,
                                                                        " \u2022 ",
                                                                        item.sizeLabel || formatBytes(item.sizeBytes)
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            className: "download-btn",
                                                            onClick: ()=>downloadFile(item.url),
                                                            title: `Download ${item.fileName}`,
                                                            "aria-label": `Download ${item.fileName}`,
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mediaLinksFilesDownloadSvg.ReactComponent), {})
                                                        })
                                                    ]
                                                }, item.id);
                                            })
                                        })
                                    ]
                                }, group.label))
                        }),
                        activeTab === 'links' && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "links-tab",
                            children: groupedLinks.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "empty-state",
                                children: "No links in this conversation"
                            }) : groupedLinks.map((group)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "link-group",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "group-label",
                                            children: group.label
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "link-list",
                                            children: group.items.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chatLinkCard.ChatLinkCard), {
                                                    url: item.url,
                                                    contextText: item.contextText,
                                                    initialTitle: item.title,
                                                    initialDescription: item.description,
                                                    variant: "list"
                                                }, item.id))
                                        })
                                    ]
                                }, group.label))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullScreenImageModal.FullScreenImageModal), {
                isOpen: previewOpen,
                onClose: ()=>setPreviewOpen(false),
                imageUrl: previewUrl
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fullScreenVideoModal.FullScreenVideoModal), {
                isOpen: Boolean(previewVideoUrl),
                onClose: ()=>setPreviewVideoUrl(null),
                videoUrl: previewVideoUrl || ''
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@ant-design/icons":[["FileExcelOutlined","3eyJq","default"],["FileImageOutlined","17Uhv","default"],["FilePdfOutlined","iSC34","default"],["FilePptOutlined","78Duw","default"],["FileTextOutlined","ioDdZ","default"],["FileWordOutlined","9K7Ru","default"],["FileZipOutlined","4k6yg","default"],["LeftOutlined","8erTV","default"],["LoadingOutlined","8Mvdh","default"],["PlayCircleFilled","eZwrA","default"]],"antd":[["Spin","lVvhl","default"]],"../../types":"61hYx","src/api/mutations/useGetChatMedia":"gcLFF","src/components/Modals/FullScreenImageModal/FullScreenImageModal":"7dgg4","src/components/Modals/FullScreenVideoModal/FullScreenVideoModal":"gcrID","src/assets/images/onboarding-trainer/dashboard/messages/media-links/media-links-files-download.svg":"fm9MX","../ChatLinkCard/ChatLinkCard":"76qqG","../../utils/linkMetadata":"f8rqC","./MediaLinksFilesView.scss":"gptPe","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gcLFF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "fetchChatMedia", ()=>fetchChatMedia);
parcelHelpers.export(exports, "useGetChatMedia", ()=>useGetChatMedia);
var _reactQuery = require("@tanstack/react-query");
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
const fetchChatMedia = async (chatId, inquiryId)=>{
    const token = await (0, _firebase.auth).currentUser?.getIdToken() || (0, _sessionStore.sessionStore).getState().token;
    if (!token) throw new Error('Authentication required.');
    const queryParams = new URLSearchParams({
        chatId
    });
    if (inquiryId) queryParams.append('inquiryId', inquiryId);
    const apiUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${(0, _apiConfigDefault.default).TRAINER_GET_CHAT_MEDIA}?${queryParams.toString()}`;
    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
        }
    });
    if (!response.ok) {
        const errorData = await response.json().catch(()=>({}));
        throw new Error(errorData?.error?.message || 'Failed to fetch chat media.');
    }
    return response.json();
};
const useGetChatMedia = (chatId, inquiryId, enabled = true)=>{
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'chat-media',
            chatId,
            inquiryId
        ],
        queryFn: ()=>fetchChatMedia(chatId, inquiryId),
        enabled: Boolean(chatId) && enabled,
        staleTime: 30000
    });
};

},{"@tanstack/react-query":"lWWNx","src/config/api-config":"9oD3c","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fm9MX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMediaLinksFilesDownload);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMediaLinksFilesDownload = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            stroke: "#12132B",
            strokeWidth: 0.2,
            d: "M18.455 13.11q.481 0 .806.325t.324.805v2.461q0 .974-.693 1.668a2.26 2.26 0 0 1-1.667.694H2.46a2.27 2.27 0 0 1-1.667-.694A2.28 2.28 0 0 1 .1 16.701v-2.46q0-.483.325-.806.323-.323.805-.325.483 0 .807.325.326.325.323.805v2.562h14.964v-2.56c0-.324.109-.59.325-.807q.323-.323.806-.325ZM9.842.1q.482.001.806.325.325.322.325.805v9.039L13.45 7.79q.34-.34.803-.325.464.013.806.351v.001a1.2 1.2 0 0 1 .328.797q.017.447-.325.787l-4.43 4.43a1 1 0 0 1-.361.237 1.3 1.3 0 0 1-.43.072q-.228 0-.426-.072a1 1 0 0 1-.364-.238L4.623 9.402a1.03 1.03 0 0 1-.325-.787q.013-.453.325-.794.342-.341.809-.355.462-.016.802.325l2.478 2.478V1.23q0-.483.325-.806.324-.325.805-.324Z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"76qqG":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ChatLinkCard", ()=>ChatLinkCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _linkMetadata = require("../../utils/linkMetadata");
var _mediaLinksVideoYoutubeLinkSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/media-links/media-links-video-youtube-link.svg");
var _mediaLinksZoomLinkSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/media-links/media-links-zoom-link.svg");
var _mediaLinksGeneralLinkSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/media-links/media-links-general-link.svg");
var _chatLinkCardScss = require("./ChatLinkCard.scss");
const ChatLinkCard = ({ url, contextText, initialTitle, initialDescription, className = '', variant = 'message', isSentByTrainer = false })=>{
    const [meta, setMeta] = (0, _react.useState)(()=>{
        const init = (0, _linkMetadata.getInitialLinkMetadata)(url, contextText);
        if (initialTitle) init.title = initialTitle;
        if (initialDescription) init.description = initialDescription;
        return init;
    });
    (0, _react.useEffect)(()=>{
        // Zoom links always use the Figma copy directly
        if (meta.type === 'zoom') return;
        // Subscribe to dynamic client-side metadata updates
        const unsubscribe = (0, _linkMetadata.subscribeLinkMetadata)(url, (dynamicMeta)=>{
            setMeta((prev)=>({
                    ...prev,
                    title: dynamicMeta.title || prev.title,
                    description: dynamicMeta.description || prev.description,
                    image: dynamicMeta.image || prev.image,
                    type: dynamicMeta.type || prev.type
                }));
        });
        return ()=>unsubscribe();
    }, [
        url,
        meta.type
    ]);
    const getLinkIcon = ()=>{
        if (meta.type === 'zoom') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mediaLinksZoomLinkSvg.ReactComponent), {
            className: "link-type-svg"
        });
        if (meta.type === 'youtube') return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mediaLinksVideoYoutubeLinkSvg.ReactComponent), {
            className: "link-type-svg"
        });
        return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mediaLinksGeneralLinkSvg.ReactComponent), {
            className: "link-type-svg"
        });
    };
    const handleOpenLink = (e)=>{
        e.stopPropagation();
        const href = url.startsWith('http') ? url : `https://${url}`;
        window.open(href, '_blank', 'noopener,noreferrer');
    };
    const themeClass = isSentByTrainer && variant === 'message' ? 'theme-sent' : 'theme-dark';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `chat-link-card-container ${variant === 'list' ? 'variant-list' : 'variant-message'} ${themeClass} ${className}`,
        onClick: handleOpenLink,
        role: "button",
        tabIndex: 0,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `link-card-icon-box icon-${meta.type}`,
                children: getLinkIcon()
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "link-card-content",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        className: "link-card-title",
                        title: meta.title,
                        children: meta.title
                    }),
                    meta.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "link-card-description",
                        title: meta.description,
                        children: meta.description
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "link-card-domain",
                        title: meta.url,
                        children: meta.displayUrl
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                className: "link-card-action-btn",
                onClick: handleOpenLink,
                title: `Open ${meta.displayUrl}`,
                "aria-label": `Open ${meta.displayUrl}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                    width: "20",
                    height: "20",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "2",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    className: "link-card-open-svg",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                            points: "15 3 21 3 21 9"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                            x1: "10",
                            y1: "14",
                            x2: "21",
                            y2: "3"
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../utils/linkMetadata":"f8rqC","src/assets/images/onboarding-trainer/dashboard/messages/media-links/media-links-video-youtube-link.svg":"7MMcA","src/assets/images/onboarding-trainer/dashboard/messages/media-links/media-links-zoom-link.svg":"feK51","src/assets/images/onboarding-trainer/dashboard/messages/media-links/media-links-general-link.svg":"ekEP2","./ChatLinkCard.scss":"hNYWM","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f8rqC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
/**
 * Format domain into readable site name
 */ parcelHelpers.export(exports, "formatDomainToTitle", ()=>formatDomainToTitle);
/**
 * Format domain and path into clean display URL
 */ parcelHelpers.export(exports, "formatDisplayUrl", ()=>formatDisplayUrl);
/**
 * Synchronous initial metadata resolver
 */ parcelHelpers.export(exports, "getInitialLinkMetadata", ()=>getInitialLinkMetadata);
/**
 * Client-side dynamic metadata fetcher using multi-tiered public OpenGraph / oEmbed engines
 */ parcelHelpers.export(exports, "fetchClientLinkMetadata", ()=>fetchClientLinkMetadata);
parcelHelpers.export(exports, "subscribeLinkMetadata", ()=>subscribeLinkMetadata);
const STORAGE_CACHE_KEY = 'minipt_link_meta_cache';
// In-memory cache for dynamic client-side fetched metadata
const metadataCache = new Map();
const metadataListeners = new Map();
// Initialize cache from localStorage
if (typeof window !== 'undefined' && window.localStorage) try {
    const saved = localStorage.getItem(STORAGE_CACHE_KEY);
    if (saved) {
        const parsed = JSON.parse(saved);
        if (typeof parsed === 'object' && parsed !== null) Object.entries(parsed).forEach(([k, v])=>{
            if (v && typeof v === 'object') metadataCache.set(k, v);
        });
    }
} catch  {
// Ignore storage parse errors
}
function persistCacheToStorage() {
    if (typeof window === 'undefined' || !window.localStorage) return;
    try {
        const obj = {};
        metadataCache.forEach((v, k)=>{
            obj[k] = v;
        });
        localStorage.setItem(STORAGE_CACHE_KEY, JSON.stringify(obj));
    } catch  {
    // Ignore storage write errors
    }
}
const IGNORED_SLUGS = new Set([
    'in',
    'us',
    'uk',
    'ca',
    'au',
    'de',
    'fr',
    'es',
    'it',
    'nl',
    'se',
    'no',
    'dk',
    'fi',
    'pt',
    'pl',
    'ru',
    'cn',
    'jp',
    'kr',
    'br',
    'mx',
    'ar',
    'za',
    'sg',
    'nz',
    'ie',
    'ae',
    'sa',
    'index',
    'home',
    'app',
    'login',
    'signup',
    'default',
    'en',
    'en-us',
    'en-gb',
    'en-in',
    'p',
    'd',
    'v',
    'watch',
    'item',
    'page',
    'post'
]);
const KNOWN_DOMAINS = {
    'store.google.com': 'Google Store',
    'google.com': 'Google',
    'mail.google.com': 'Google Mail',
    'docs.google.com': 'Google Docs',
    'drive.google.com': 'Google Drive',
    'youtube.com': 'YouTube',
    'youtu.be': 'YouTube',
    'github.com': 'GitHub',
    'zoom.us': 'Zoom',
    'healthline.com': 'Healthline',
    'webmd.com': 'WebMD',
    'myfitnesspal.com': 'MyFitnessPal',
    'wikipedia.org': 'Wikipedia',
    'en.wikipedia.org': 'Wikipedia',
    'apple.com': 'Apple',
    'amazon.com': 'Amazon',
    'medium.com': 'Medium',
    'instagram.com': 'Instagram',
    'facebook.com': 'Facebook',
    'linkedin.com': 'LinkedIn',
    'twitter.com': 'Twitter / X',
    'x.com': 'X',
    'bbc.com': 'BBC',
    'nytimes.com': 'The New York Times',
    'spotify.com': 'Spotify'
};
function formatDomainToTitle(domain) {
    const cleanDomain = domain.toLowerCase().replace(/^www\./, '');
    if (KNOWN_DOMAINS[cleanDomain]) return KNOWN_DOMAINS[cleanDomain];
    // Handle subdomain e.g. store.something.com
    const parts = cleanDomain.split('.');
    if (parts.length >= 3 && parts[parts.length - 2].length > 2) {
        const sub = parts[0];
        const main = parts[1];
        return `${main.charAt(0).toUpperCase() + main.slice(1)} ${sub.charAt(0).toUpperCase() + sub.slice(1)}`;
    }
    if (parts.length >= 2) {
        const main = parts[0];
        return main.charAt(0).toUpperCase() + main.slice(1);
    }
    return cleanDomain.charAt(0).toUpperCase() + cleanDomain.slice(1);
}
/**
 * Format a slug into capitalized readable words
 * e.g. "post-workout-recovery-tips" -> "Post-workout recovery tips"
 */ function formatSlugToTitle(slug) {
    if (!slug) return '';
    const clean = slug.replace(/\.[a-zA-Z0-9]+$/, '').replace(/[-_]+/g, ' ').trim();
    if (!clean) return '';
    return clean.charAt(0).toUpperCase() + clean.slice(1);
}
function formatDisplayUrl(urlStr, maxLen = 45) {
    try {
        const parsed = new URL(urlStr.startsWith('http') ? urlStr : `https://${urlStr}`);
        const cleanHost = parsed.hostname.replace(/^www\./, '');
        const cleanPath = parsed.pathname;
        if (cleanPath === '/' || cleanPath === '') return cleanHost;
        const full = `${cleanHost}${cleanPath}`;
        if (full.length > maxLen) return full.slice(0, maxLen - 3) + '...';
        return full;
    } catch  {
        const raw = urlStr.replace(/^https?:\/\//i, '').replace(/^www\./i, '');
        if (raw.length > maxLen) return raw.slice(0, maxLen - 3) + '...';
        return raw;
    }
}
function getInitialLinkMetadata(rawUrl, contextText) {
    const url = rawUrl.trim();
    let domain = url;
    let pathname = '';
    try {
        const parsed = new URL(url.startsWith('http') ? url : `https://${url}`);
        domain = parsed.hostname.replace(/^www\./, '');
        pathname = parsed.pathname;
    } catch  {
        domain = url.split('/')[0].replace(/^www\./, '');
    }
    const lowerUrl = url.toLowerCase();
    const lowerDomain = domain.toLowerCase();
    // 1. ZOOM LINK (Exact Figma copy: "Check-in call (Zoom)" / "Join our check-in to review your progress and the next steps")
    if (lowerUrl.includes('zoom.us') || lowerDomain.includes('zoom.us') || lowerDomain.includes('zoom')) return {
        url,
        domain,
        displayUrl: formatDisplayUrl(url),
        title: 'Check-in call (Zoom)',
        description: 'Join our check-in to review your progress and the next steps',
        type: 'zoom'
    };
    // Check cache for already fetched metadata
    const cached = metadataCache.get(url);
    if (cached && cached.title) return {
        url,
        domain,
        displayUrl: formatDisplayUrl(url),
        title: cached.title,
        description: cached.description || '',
        type: cached.type || (lowerUrl.includes('youtube') ? 'youtube' : 'general'),
        image: cached.image,
        isLoading: false
    };
    // 2. YOUTUBE LINK
    const isYoutube = lowerUrl.includes('youtube.com') || lowerUrl.includes('youtu.be') || lowerDomain.includes('youtube') || lowerDomain.includes('youtu.be');
    if (isYoutube) return {
        url,
        domain,
        displayUrl: formatDisplayUrl(url),
        title: 'Squat form tutorial',
        description: 'Join our check-in to review your progress and the next steps',
        type: 'youtube',
        isLoading: true
    };
    // 3. GENERAL / HEALTH / FITNESS / ARTICLE LINKS
    const pathSegments = pathname.split('/').filter(Boolean);
    const lastSegment = pathSegments[pathSegments.length - 1] || '';
    const isIgnoredSlug = !lastSegment || lastSegment.length <= 2 || IGNORED_SLUGS.has(lastSegment.toLowerCase());
    let fallbackTitle = '';
    if (!isIgnoredSlug) fallbackTitle = formatSlugToTitle(lastSegment);
    if (!fallbackTitle) fallbackTitle = formatDomainToTitle(domain);
    // Initial description from context or clean domain note
    let fallbackDesc = '';
    if (contextText && contextText.trim()) {
        const cleanContext = contextText.replace(url, '').replace(/https?:\/\/[^\s]+/g, '').trim();
        if (cleanContext.length > 5) fallbackDesc = cleanContext.length > 90 ? cleanContext.slice(0, 87) + '...' : cleanContext;
    }
    return {
        url,
        domain,
        displayUrl: formatDisplayUrl(url),
        title: fallbackTitle,
        description: fallbackDesc,
        type: 'general',
        isLoading: true
    };
}
async function fetchClientLinkMetadata(url) {
    const lowerUrl = url.toLowerCase();
    // Zoom is static per requirements
    if (lowerUrl.includes('zoom.us') || lowerUrl.includes('zoom')) return null;
    // Check cache first
    if (metadataCache.has(url) && metadataCache.get(url)?.title) return metadataCache.get(url) || null;
    // 1. YouTube oEmbed
    if (lowerUrl.includes('youtube.com') || lowerUrl.includes('youtu.be')) try {
        const oembedUrl = `https://www.youtube.com/oembed?url=${encodeURIComponent(url)}&format=json`;
        const res = await fetch(oembedUrl);
        if (res.ok) {
            const data = await res.json();
            const result = {
                title: data.title || 'Squat form tutorial',
                description: data.author_name ? `Video by ${data.author_name} on YouTube` : 'Watch the video guide and technique breakdown on YouTube',
                image: data.thumbnail_url,
                type: 'youtube'
            };
            metadataCache.set(url, result);
            persistCacheToStorage();
            notifyListeners(url, result);
            return result;
        }
    } catch  {
    // Fall through to other providers
    }
    // 2. Microlink OpenGraph API (Industry standard for web link metadata)
    try {
        const microlinkUrl = `https://api.microlink.io?url=${encodeURIComponent(url)}`;
        const mlRes = await fetch(microlinkUrl, {
            signal: AbortSignal.timeout(5000)
        });
        if (mlRes.ok) {
            const mlData = await mlRes.json();
            if (mlData.status === 'success' && mlData.data) {
                const d = mlData.data;
                const result = {
                    title: d.title || undefined,
                    description: d.description || undefined,
                    image: d.image?.url || undefined
                };
                if (result.title) {
                    metadataCache.set(url, result);
                    persistCacheToStorage();
                    notifyListeners(url, result);
                    return result;
                }
            }
        }
    } catch  {
    // Fall through
    }
    // 3. NoEmbed Provider
    try {
        const noembedUrl = `https://noembed.com/embed?url=${encodeURIComponent(url)}`;
        const noembedRes = await fetch(noembedUrl, {
            signal: AbortSignal.timeout(4000)
        });
        if (noembedRes.ok) {
            const data = await noembedRes.json();
            if (data.title && !data.error) {
                const result = {
                    title: data.title,
                    description: data.description || (data.author_name ? `By ${data.author_name} on ${data.provider_name || 'web'}` : undefined),
                    image: data.thumbnail_url
                };
                metadataCache.set(url, result);
                persistCacheToStorage();
                notifyListeners(url, result);
                return result;
            }
        }
    } catch  {
    // Fall through
    }
    // 4. AllOrigins Proxy with in-browser DOMParser
    try {
        const allOriginsUrl = `https://api.allorigins.win/get?url=${encodeURIComponent(url)}`;
        const aoRes = await fetch(allOriginsUrl, {
            signal: AbortSignal.timeout(5000)
        });
        if (aoRes.ok) {
            const aoData = await aoRes.json();
            if (aoData.contents && typeof aoData.contents === 'string') {
                const parser = new DOMParser();
                const doc = parser.parseFromString(aoData.contents, 'text/html');
                const ogTitle = doc.querySelector('meta[property="og:title"]')?.getAttribute('content') || doc.querySelector('meta[name="twitter:title"]')?.getAttribute('content') || doc.querySelector('title')?.textContent?.trim();
                const ogDesc = doc.querySelector('meta[property="og:description"]')?.getAttribute('content') || doc.querySelector('meta[name="twitter:description"]')?.getAttribute('content') || doc.querySelector('meta[name="description"]')?.getAttribute('content');
                const ogImage = doc.querySelector('meta[property="og:image"]')?.getAttribute('content') || doc.querySelector('meta[name="twitter:image"]')?.getAttribute('content');
                if (ogTitle) {
                    const result = {
                        title: ogTitle,
                        description: ogDesc || undefined,
                        image: ogImage || undefined
                    };
                    metadataCache.set(url, result);
                    persistCacheToStorage();
                    notifyListeners(url, result);
                    return result;
                }
            }
        }
    } catch  {
    // Fallback
    }
    return null;
}
function notifyListeners(url, meta) {
    const listeners = metadataListeners.get(url);
    if (listeners) listeners.forEach((fn)=>fn(meta));
}
function subscribeLinkMetadata(url, callback) {
    if (!metadataListeners.has(url)) metadataListeners.set(url, new Set());
    metadataListeners.get(url).add(callback);
    // If already cached, call immediately
    if (metadataCache.has(url)) callback(metadataCache.get(url));
    else // Trigger background client-side fetch
    fetchClientLinkMetadata(url);
    return ()=>{
        metadataListeners.get(url)?.delete(callback);
        if (metadataListeners.get(url)?.size === 0) metadataListeners.delete(url);
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7MMcA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMediaLinksVideoYoutubeLink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMediaLinksVideoYoutubeLink = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "currentColor",
            d: "m10 15 5.19-3L10 9zm11.56-7.83c.13.47.22 1.1.28 1.9.07.8.1 1.49.1 2.09L22 12c0 2.19-.16 3.8-.44 4.83-.25.9-.83 1.48-1.73 1.73-.47.13-1.33.22-2.65.28-1.3.07-2.49.1-3.59.1L12 19c-4.19 0-6.8-.16-7.83-.44-.9-.25-1.48-.83-1.73-1.73-.13-.47-.22-1.1-.28-1.9-.07-.8-.1-1.49-.1-2.09L2 12c0-2.19.16-3.8.44-4.83.25-.9.83-1.48 1.73-1.73.47-.13 1.33-.22 2.65-.28 1.3-.07 2.49-.1 3.59-.1L12 5c4.19 0 6.8.16 7.83.44.9.25 1.48.83 1.73 1.73"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"feK51":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMediaLinksZoomLink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMediaLinksZoomLink = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M5 5a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3v-1.586l2.293 2.293A1 1 0 0 0 22 16V8a1 1 0 0 0-1.707-.707L18 9.586V8a3 3 0 0 0-3-3z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ekEP2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMediaLinksGeneralLink);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMediaLinksGeneralLink = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "currentColor",
            d: "M15.319 12.844H8.607c.102 2.267.605 4.356 1.319 5.885.4.861.833 1.47 1.234 1.842.394.37.664.429.805.429.14 0 .411-.06.805-.429.4-.373.833-.984 1.234-1.842.714-1.53 1.216-3.618 1.318-5.885zm-6.715-1.688h6.711C15.217 8.89 14.715 6.8 14 5.271c-.4-.858-.833-1.47-1.234-1.842-.393-.37-.664-.429-.805-.429-.14 0-.411.06-.805.429-.4.373-.833.984-1.234 1.842-.713 1.53-1.216 3.618-1.318 5.885m-1.688 0c.123-3.01.9-5.804 2.036-7.64A9 9 0 0 0 3 11.157zM3 12.844a9 9 0 0 0 5.952 7.64c-1.136-1.836-1.913-4.63-2.036-7.64zm14.006 0c-.123 3.01-.9 5.804-2.035 7.64a9.01 9.01 0 0 0 5.952-7.64zm3.917-1.688a9 9 0 0 0-5.952-7.64c1.135 1.836 1.912 4.63 2.035 7.64z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hNYWM":[function() {},{}],"gptPe":[function() {},{}],"fJ0Ml":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessagesMoreMenu);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessagesMoreMenu = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 4,
        fill: "none",
        viewBox: "0 0 18 4",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#D6D6D6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M16 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2M2 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ezAus":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessagesMoreMenuClose);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessagesMoreMenuClose = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#D6D6D6",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M13 1 1 13M1 1l12 12"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1SHjQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessagesViewClientProfile);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessagesViewClientProfile = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M10 10a4.375 4.375 0 1 0 0-8.75A4.375 4.375 0 0 0 10 10m-5.312 1.25A2.19 2.19 0 0 0 2.5 13.438v.312c0 1.496.952 2.76 2.303 3.62 1.359.866 3.198 1.38 5.197 1.38s3.838-.514 5.197-1.38c1.351-.86 2.303-2.124 2.303-3.62v-.312a2.19 2.19 0 0 0-2.187-2.188z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jvvsg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessagesSearchInConversation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessagesSearchInConversation = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m17.5 17.5-5-5m1.667-4.167a5.833 5.833 0 1 1-11.667 0 5.833 5.833 0 0 1 11.667 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"igPRg":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessagesViewMediaLinksFiles);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessagesViewMediaLinksFiles = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M17.233 5.847a3.2 3.2 0 0 0-.766-1.017l-2.5-2.267a3.46 3.46 0 0 0-1.992-.891H6.842A4.167 4.167 0 0 0 2.5 5.722v8.583a4.17 4.17 0 0 0 2.758 3.775c.51.194 1.055.28 1.6.25h6.3a4.165 4.165 0 0 0 4.342-4.05V7.138a3.1 3.1 0 0 0-.267-1.291M6.4 5.513h2.717a.833.833 0 1 1 0 1.667H6.4a.833.833 0 1 1 0-1.667m7.25 8.925H6.4a.833.833 0 1 1 0-1.666h7.25a.833.833 0 0 1 0 1.65zm0-3.625H6.4a.833.833 0 1 1 0-1.666h7.25a.833.833 0 0 1 0 1.666m-.267-4.641a.9.9 0 0 1-.908-.9V3.063c.55.134 2.692 2.334 3.158 2.7q.209.177.35.409z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gaCVc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessagesReportAnIssue);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessagesReportAnIssue = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "m11.083 2.625 7.195 12.462a1.249 1.249 0 0 1-1.083 1.875H2.805a1.25 1.25 0 0 1-1.082-1.875L8.918 2.625a1.25 1.25 0 0 1 2.165 0M10 12.502a.834.834 0 1 0 0 1.667.834.834 0 0 0 0-1.667m0-5.834a.833.833 0 0 0-.827.736l-.006.098v3.333a.833.833 0 0 0 1.66.097l.007-.097V7.502A.833.833 0 0 0 10 6.668"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lsBTX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessagesInputAttachments);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessagesInputAttachments = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.4,
            strokeWidth: 1.667,
            d: "M11.03 16.877 17.5 10.25M13.334 5l-7.012 7.156a1.667 1.667 0 0 0 2.357 2.356l7.011-7.155a3.333 3.333 0 0 0-4.713-4.713L3.965 9.798a5 5 0 0 0 7.071 7.072"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aFKr4":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessagesInputEmoji);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessagesInputEmoji = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeOpacity: 0.4,
                strokeWidth: 1.667,
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M10 18.33a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.667"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M6.666 11.664s1.25 1.667 3.333 1.667 3.334-1.667 3.334-1.667M7.5 7.5h.008M12.5 7.5h.008"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1z8Js":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessagesInputImages);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessagesInputImages = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeOpacity: 0.4,
                strokeWidth: 1.667,
                d: "M15.833 2.5H4.167c-.92 0-1.667.746-1.667 1.667v11.666c0 .92.746 1.667 1.667 1.667h11.666c.92 0 1.667-.746 1.667-1.667V4.167c0-.92-.746-1.667-1.667-1.667"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeOpacity: 0.4,
                strokeWidth: 1.667,
                d: "M7.5 9.17a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.333M17.5 12.497l-2.572-2.572a1.667 1.667 0 0 0-2.356 0L5 17.497"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lS0fr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessagesInputRecord);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessagesInputRecord = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#E5E5E5",
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M7.5 5a2.5 2.5 0 1 1 5 0v4.167a2.5 2.5 0 1 1-5 0z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M10 14.999a5.834 5.834 0 0 1-5.833-5.834v-.833M10 14.999a5.833 5.833 0 0 0 5.833-5.834v-.833M10 14.999v2.5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lwAh0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessagesInputSend);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessagesInputSend = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        style: {
            overflow: "visible"
        },
        viewBox: "-1 -1 19 19",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#04051B",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.417,
            d: "M10.296 15.36a.355.355 0 0 0 .663-.017l4.604-13.458a.351.351 0 0 0-.45-.45L1.656 6.039a.354.354 0 0 0-.017.664l5.617 2.252a1.42 1.42 0 0 1 .788.787zM15.48 1.523 7.73 9.272"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"j3gen":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgResolvedCheckboxChecked);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgResolvedCheckboxChecked = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 20,
                height: 20,
                fill: "#FFA100",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#04051B",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2.2,
                d: "m5.5 10.5 3 3 6-7"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4nA6G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgResolvedCheckboxUnchecked);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgResolvedCheckboxUnchecked = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
            width: 18,
            height: 18,
            x: 1,
            y: 1,
            stroke: "currentColor",
            strokeWidth: 1.8,
            rx: 4
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"h0Vpi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PackageRequestBubble", ()=>PackageRequestBubble);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _types = require("../../types");
var _packageRequestBubbleScss = require("./PackageRequestBubble.scss");
// SVG Icons imported from package-request
var _genderSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-request/gender.svg");
var _fitnessGoalSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-request/fitness-goal.svg");
var _fitnessLevelSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-request/fitness-level.svg");
var _injuriesSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-request/injuries.svg");
var _focusAreaSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-request/focus-area.svg");
var _trainingScheduleSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-request/training-schedule.svg");
var _workoutDurationSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-request/workout-duration.svg");
var _workoutLoadLevelSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-request/workout-load-level.svg");
var _trainingLocationSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-request/training-location.svg");
var _sendOfferSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-request/send-offer.svg");
var _inviteToFreeCallSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-request/invite-to-free-call.svg");
const PackageRequestBubble = ({ message, onSendOffer, onInviteFreeCall })=>{
    const [isExpanded, setIsExpanded] = (0, _react.useState)(true);
    const packageName = message.package_name || 'Basic';
    const currencySymbol = message.currency_symbol || (message.currency === 'GBP' ? "\xa3" : '$');
    const price = message.price !== undefined ? message.price : 95;
    const duration = message.duration || '4 weeks';
    const sendDate = (0, _types.parseFirestoreDate)(message.send_time);
    const formattedDate = sendDate.toLocaleDateString('en-US', {
        month: 'short',
        day: 'numeric',
        year: 'numeric'
    });
    const intake = message.intake_data || {};
    const gender = intake.gender || 'Female';
    const fitnessGoal = intake.fitness_goal || 'Build muscle';
    const fitnessLevel = intake.fitness_level || 'Beginner';
    const injuries = intake.injuries || 'Back, Knees';
    const focusAreas = intake.focus_areas || 'Full body';
    const trainingSchedule = intake.training_schedule || '3 per week';
    const workoutDuration = intake.workout_duration || '30 minutes';
    const workoutLoadLevel = intake.workout_load_level || 'Medium';
    const trainingLocation = intake.training_location || 'Gym';
    const startDate = message.start_date || '12.09.2026';
    const userMessage = message.body || message.message || 'I want to build a consistent routine. Will you be able to help me?';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `package-request-card ${isExpanded ? 'expanded' : 'collapsed'}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "pkg-request-header",
                onClick: ()=>setIsExpanded(!isExpanded),
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "pkg-header-info",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                className: "pkg-title",
                                children: `Request ${packageName} Package`
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "pkg-pricing-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "pkg-price",
                                        children: `${currencySymbol}${price}`
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "pkg-duration",
                                        children: ` / ${duration}`
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "pkg-meta-dates",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: `Requested ${formattedDate}`
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "pkg-toggle-btn",
                        "aria-label": isExpanded ? 'Collapse' : 'Expand',
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                            className: `chevron-icon ${isExpanded ? 'open' : ''}`,
                            width: "20",
                            height: "20",
                            viewBox: "0 0 24 24",
                            fill: "none",
                            stroke: "currentColor",
                            strokeWidth: "2.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                points: "18 15 12 9 6 15"
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: `pkg-request-body-wrapper ${isExpanded ? 'expanded' : 'collapsed'}`,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "pkg-request-body",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pkg-questionnaire-list",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "questionnaire-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "icon-wrap",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genderSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "field-label",
                                                    children: 'Gender'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "field-value",
                                            children: gender
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "questionnaire-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "icon-wrap",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fitnessGoalSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "field-label",
                                                    children: 'Fitness goal'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "field-value",
                                            children: fitnessGoal
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "questionnaire-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "icon-wrap",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _fitnessLevelSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "field-label",
                                                    children: 'Fitness level'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "field-value",
                                            children: fitnessLevel
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "questionnaire-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "icon-wrap",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _injuriesSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "field-label",
                                                    children: 'Injuries'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "field-value",
                                            children: injuries
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "questionnaire-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "icon-wrap",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _focusAreaSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "field-label",
                                                    children: 'Focus areas'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "field-value",
                                            children: focusAreas
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "questionnaire-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "icon-wrap",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trainingScheduleSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "field-label",
                                                    children: 'Training schedule'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "field-value",
                                            children: trainingSchedule
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "questionnaire-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "icon-wrap",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _workoutDurationSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "field-label",
                                                    children: 'Workout duration'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "field-value",
                                            children: workoutDuration
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "questionnaire-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "icon-wrap",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _workoutLoadLevelSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "field-label",
                                                    children: 'Workout load level'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "field-value",
                                            children: workoutLoadLevel
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "questionnaire-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "row-left",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "icon-wrap",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trainingLocationSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "field-label",
                                                    children: 'Training location'
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "field-value",
                                            children: trainingLocation
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "pkg-additional-details",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "detail-line",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "detail-label",
                                            children: 'Start Date'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "detail-val",
                                            children: startDate
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "detail-line",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "detail-label",
                                            children: 'Message'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "detail-msg",
                                            children: userMessage
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "pkg-request-actions",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        className: "btn-send-offer",
                        onClick: ()=>onSendOffer?.(message),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendOfferSvg.ReactComponent), {
                                className: "btn-icon"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: 'Send Offer'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        className: "btn-invite-free-call",
                        onClick: ()=>onInviteFreeCall?.(message),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _inviteToFreeCallSvg.ReactComponent), {
                                className: "btn-icon"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: 'Invite to Free Call'
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","../../types":"61hYx","./PackageRequestBubble.scss":"1MxGz","src/assets/images/onboarding-trainer/dashboard/messages/package-request/gender.svg":"eIBR6","src/assets/images/onboarding-trainer/dashboard/messages/package-request/fitness-goal.svg":"4Cc1z","src/assets/images/onboarding-trainer/dashboard/messages/package-request/fitness-level.svg":"8IsZi","src/assets/images/onboarding-trainer/dashboard/messages/package-request/injuries.svg":"3xPis","src/assets/images/onboarding-trainer/dashboard/messages/package-request/focus-area.svg":"fR3L0","src/assets/images/onboarding-trainer/dashboard/messages/package-request/training-schedule.svg":"1Rv1Q","src/assets/images/onboarding-trainer/dashboard/messages/package-request/workout-duration.svg":"7vFLN","src/assets/images/onboarding-trainer/dashboard/messages/package-request/workout-load-level.svg":"b5OBi","src/assets/images/onboarding-trainer/dashboard/messages/package-request/training-location.svg":"icQlI","src/assets/images/onboarding-trainer/dashboard/messages/package-request/send-offer.svg":"gBFc2","src/assets/images/onboarding-trainer/dashboard/messages/package-request/invite-to-free-call.svg":"eyasz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1MxGz":[function() {},{}],"eIBR6":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGender);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGender = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M8.333 0a8.334 8.334 0 1 0 0 16.667A8.334 8.334 0 0 0 8.334 0m-1.69 10.455c0 .025 0 .05.002.088l.05-.044c.152-.151.301-.308.46-.453a.434.434 0 0 1 .618.021.443.443 0 0 1 0 .621q-.28.285-.564.566l-.66.66c-.226.225-.483.225-.709 0q-.6-.6-1.199-1.2c-.203-.202-.202-.48 0-.67.154-.147.423-.157.578-.012.161.15.314.309.47.463l.053.046c.002-.022.004-.035.004-.048v-1.64c0-.058-.018-.078-.073-.092a2.04 2.04 0 0 1-1.337-1.037 2.05 2.05 0 0 1-.065-1.898c.26-.573.701-.958 1.302-1.14a2.05 2.05 0 0 1 1.753.238c.456.28.784.728.913 1.247.16.606.065 1.18-.275 1.702a2.04 2.04 0 0 1-1.235.884c-.07.017-.089.044-.088.115q.003.791.002 1.583m5.745.345c-.27.593-.726.99-1.346 1.18a2.11 2.11 0 0 1-1.813-.247 2.12 2.12 0 0 1-.944-1.289 2.12 2.12 0 0 1 .284-1.76c.292-.46.75-.787 1.278-.915.072-.019.092-.046.091-.12l-.002-.89h-.679a.488.488 0 1 1 0-.976h.679v-.734a.464.464 0 0 1 .928 0v.734h.681a.488.488 0 0 1 0 .976h-.681v.912c0 .06.018.08.075.095.614.159 1.084.516 1.384 1.072.342.637.366 1.3.065 1.962"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4Cc1z":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFitnessGoal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFitnessGoal = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                d: "M9.993 12.208a2.208 2.208 0 0 1-1.558-3.775.628.628 0 0 1 .883.892.94.94 0 0 0-.283.675.95.95 0 0 0 1.667.675.633.633 0 0 1 .891 0 .64.64 0 0 1 0 .891 2.23 2.23 0 0 1-1.6.642"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                d: "M18.535 10A8.541 8.541 0 1 1 9.993 1.46a.625.625 0 0 1 .625.624V5.25a.633.633 0 0 1-.625.625 4.05 4.05 0 0 0-2.291.692A4.11 4.11 0 0 0 5.943 10.8a4.167 4.167 0 0 0 8.175-.833.617.617 0 0 1 .625-.625h3.167a.625.625 0 0 1 .625.658"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                d: "M18.235 5.109a.9.9 0 0 1-.192.441L16.235 7.36a2.17 2.17 0 0 1-.925.55 2.1 2.1 0 0 1-.633.091 2.5 2.5 0 0 1-.442 0l-1.108-.216-1.9 1.908a.67.67 0 0 1-.442.183.63.63 0 0 1-.442-.183.616.616 0 0 1 0-.883l1.909-1.917-.225-1.1a2.3 2.3 0 0 1 .05-1.067c.102-.35.291-.668.55-.925l1.791-1.791a.83.83 0 0 1 .442-.209.75.75 0 0 1 .45.075c.137.07.253.177.333.309a.83.83 0 0 1 .1.483l-.266 1.883 1.875-.258a.78.78 0 0 1 .775.425c.068.12.105.254.108.392"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8IsZi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFitnessLevel);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFitnessLevel = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 17,
        fill: "none",
        viewBox: "0 0 16 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M4.2 9.008v5.9a1.317 1.317 0 0 1-1.317 1.317H1.317A1.317 1.317 0 0 1 0 14.908v-5.9a1.325 1.325 0 0 1 1.317-1.325h1.566A1.325 1.325 0 0 1 4.2 9.008m5.783-3.825v9.75a1.325 1.325 0 0 1-1.325 1.317H7.1a1.325 1.325 0 0 1-1.325-1.317v-9.75A1.325 1.325 0 0 1 7.1 3.858h1.558a1.325 1.325 0 0 1 1.325 1.325m5.784-3.858v13.608a1.325 1.325 0 0 1-1.325 1.317h-1.559a1.325 1.325 0 0 1-1.325-1.317V1.325A1.325 1.325 0 0 1 12.883 0h1.559a1.325 1.325 0 0 1 1.325 1.325"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3xPis":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgInjuries);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInjuries = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 16,
        fill: "none",
        viewBox: "0 0 17 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M8.137 1.717C6.387-.455 3.26-.585 1.354 1.434.018 2.849-.33 4.914.312 6.667h3.417l2.183-4.364 2.5 5 1.25-2.5.932 1.864h5.918c.641-1.753.294-3.818-1.042-5.233-1.906-2.02-5.033-1.889-6.783.283l-.275.342zm7.355 6.616H9.76L8.412 11.03l-2.5-5L4.76 8.333H1.332l.022.024 7.054 7.473.004.003 7.058-7.476z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fR3L0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFocusArea);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFocusArea = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("g", {
                fill: "#fff",
                clipPath: "url(#a)",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                    d: "M10 4.375A2.188 2.188 0 1 0 10 0a2.188 2.188 0 0 0 0 4.375M17.07 5H2.93a1.055 1.055 0 1 0 0 2.11h3.98c.27 0 .585.12.764.586.21.54.107 1.583-.022 2.391l-.169.955a.02.02 0 0 1-.004.014l-1.352 7.688a1.07 1.07 0 0 0 .865 1.24 1.056 1.056 0 0 0 1.228-.87l.934-5.345s.3-1.269.846-1.269c.556 0 .85 1.27.85 1.27l.933 5.348a1.064 1.064 0 1 0 2.095-.375l-1.352-7.688a.02.02 0 0 0-.005-.014l-.169-.955c-.129-.808-.23-1.851-.022-2.392.178-.464.504-.586.753-.586h3.987a1.055 1.055 0 0 0 0-2.109z"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h20v20H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Rv1Q":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgTrainingSchedule);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTrainingSchedule = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                d: "M2.785 7.639a.7.7 0 0 0 .67-.497L4.57 3.42a1.39 1.39 0 0 1 2.66-.01l2.837 9.44 1.777-3.98a2.08 2.08 0 0 1 1.905-1.23h2.917V2.083A2.086 2.086 0 0 0 14.583 0h-12.5A2.086 2.086 0 0 0 0 2.083V7.64z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#fff",
                d: "M13.75 9.028a.69.69 0 0 0-.636.407l-1.779 3.98a1.39 1.39 0 0 1-2.594-.156l-2.837-9.44-1.12 3.729a2.08 2.08 0 0 1-2 1.48H0v5.556c0 1.148.935 2.083 2.083 2.083h12.5a2.086 2.086 0 0 0 2.084-2.083V9.028z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7vFLN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgWorkoutDuration);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgWorkoutDuration = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 18,
        fill: "none",
        viewBox: "0 0 15 18",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M5.833 1.667a.8.8 0 0 1-.593-.24A.8.8 0 0 1 5 .833Q5 .48 5.24.24T5.833 0h3.334q.354 0 .594.24T10 .833t-.24.595a.8.8 0 0 1-.593.239zM7.5 10.833q.354 0 .594-.24t.24-.593V6.667a.8.8 0 0 0-.24-.594.8.8 0 0 0-.594-.24.8.8 0 0 0-.593.24.8.8 0 0 0-.24.594V10q0 .354.24.594t.593.24m0 6.667a7.2 7.2 0 0 1-2.907-.593 7.6 7.6 0 0 1-2.385-1.615 7.7 7.7 0 0 1-1.614-2.386A7.2 7.2 0 0 1 0 10q0-1.542.594-2.907a7.7 7.7 0 0 1 1.614-2.385 7.7 7.7 0 0 1 2.386-1.614A7.2 7.2 0 0 1 7.5 2.5q1.292 0 2.48.417 1.186.416 2.228 1.208l.584-.583a.8.8 0 0 1 .583-.23.8.8 0 0 1 .583.23.8.8 0 0 1 .23.583.8.8 0 0 1-.23.583l-.583.584a8.1 8.1 0 0 1 1.208 2.229Q15 8.709 15 10a7.2 7.2 0 0 1-.594 2.907 7.7 7.7 0 0 1-1.614 2.385 7.7 7.7 0 0 1-2.386 1.615Q9.04 17.5 7.5 17.5"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"b5OBi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgWorkoutLoadLevel);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgWorkoutLoadLevel = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 16,
        fill: "none",
        viewBox: "0 0 17 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M8.333 0 5.95 8.9a2.52 2.52 0 0 0 .6 2.55 2.508 2.508 0 0 0 4.192-2.425M10.5 1.642l.517 1.941A6.66 6.66 0 0 1 15 9.683a6.6 6.6 0 0 1-1.95 4.709h-.008a.83.83 0 0 0 0 1.175.85.85 0 0 0 1.183.008 8.3 8.3 0 0 0 2.442-5.892c0-3.85-2.617-7.083-6.167-8.041m-4.333.008C2.625 2.6 0 5.85 0 9.683c0 2.3.933 4.384 2.442 5.892a.838.838 0 0 0 1.418-.596.83.83 0 0 0-.243-.587 6.63 6.63 0 0 1-1.95-4.709c0-2.791 1.616-5.116 3.991-6.125"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"icQlI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgTrainingLocation);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTrainingLocation = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 17,
        fill: "none",
        viewBox: "0 0 14 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M6.667 16.104q-.293 0-.584-.104a1.5 1.5 0 0 1-.52-.312 33 33 0 0 1-2.396-2.438 18 18 0 0 1-1.74-2.302A11 11 0 0 1 .365 8.803Q0 7.77 0 6.833q0-3.125 2.01-4.979Q4.022 0 6.668 0q2.644 0 4.656 1.854t2.01 4.98q0 .936-.364 1.969a11 11 0 0 1-1.062 2.145 18 18 0 0 1-1.74 2.302 33 33 0 0 1-2.396 2.438A1.5 1.5 0 0 1 7.25 16q-.292.105-.583.104m0-7.77q.687 0 1.177-.49a1.6 1.6 0 0 0 .49-1.177q-.001-.689-.49-1.177A1.6 1.6 0 0 0 6.667 5a1.6 1.6 0 0 0-1.177.49q-.487.492-.49 1.177-.002.685.49 1.177t1.177.49"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"gBFc2":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSendOffer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSendOffer = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 20,
        fill: "none",
        viewBox: "0 0 18 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#07092C",
            d: "M17.68 5.014a3.85 3.85 0 0 0-.92-1.22l-3-2.72a4.15 4.15 0 0 0-2.39-1.07H5.21A5 5 0 0 0 0 4.864v10.3a5 5 0 0 0 3.31 4.53 4.7 4.7 0 0 0 1.92.3h7.56a5 5 0 0 0 5.21-4.86v-8.57a3.75 3.75 0 0 0-.32-1.55m-13-.4h3.26a1 1 0 0 1 0 2H4.68a1 1 0 0 1 0-2m8.7 10.71h-8.7a1 1 0 0 1 0-2h8.7a1 1 0 0 1 0 1.98zm0-4.35h-8.7a1 1 0 0 1 0-2h8.7a1 1 0 1 1 0 2m-.32-5.57a1.08 1.08 0 0 1-1.09-1.08v-2.65c.66.16 3.23 2.8 3.79 3.24q.25.212.42.49z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eyasz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgInviteToFreeCall);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgInviteToFreeCall = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 14,
        fill: "none",
        viewBox: "0 0 20 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#07092C",
            fillRule: "evenodd",
            d: "M3 0a3 3 0 0 0-3 3v8a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V9.414l2.293 2.293A1 1 0 0 0 20 11V3a1 1 0 0 0-1.707-.707L16 4.586V3a3 3 0 0 0-3-3z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k8mjc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PackageOfferBubble", ()=>PackageOfferBubble);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _calendarPeriodSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/calendar-period.svg");
var _attachedDocsSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/attached-docs.svg");
var _whatsIncludedSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/whats-included.svg");
var _chevronRightSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/chevron-right.svg");
var _packageOfferBubbleScss = require("./PackageOfferBubble.scss");
const DEFAULT_INCLUDED_ITEMS = [
    'Pre-session questionnaire to understand your goals, fitness level, and schedule',
    'Session programme tailored to you, integrating AI-based form tracking & MPT Score',
    'Real-time feedback from a certified PT',
    'Session-specific MPT Score (accuracy, goal-based calorie burn, reps completed)',
    'Access to personal trainer notes & AI session history',
    'Chat/message support in the app for quick form checks or questions (during package period)'
];
const PackageOfferBubble = ({ message, onOpenDocument })=>{
    const [isIncludedOpen, setIsIncludedOpen] = (0, _react.useState)(true);
    const packageName = message.package_name || 'Basic Package';
    const price = message.price !== undefined ? message.price : 95;
    const currencySymbol = message.currency_symbol || (message.currency === 'GBP' ? "\xa3" : '$');
    const duration = message.duration || '4 weeks';
    const startDate = message.start_date || '28 Sep 2026';
    const isConfirmed = message.offer_status === 'confirmed' || message.offer_status === 'accepted' || message.offer_status === 'active';
    const statusLabel = isConfirmed ? 'Confirmed' : message.offer_status === 'declined' ? 'Declined' : 'Awaiting response';
    const items = message.whats_included && message.whats_included.length > 0 ? message.whats_included : DEFAULT_INCLUDED_ITEMS;
    const handleDocClick = (docType)=>{
        if (onOpenDocument) onOpenDocument(docType);
        else window.open(`/onboarding-trainer/dashboard/profile?tab=packages&view=template&type=${docType}`, '_blank');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "package-offer-bubble-card",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `offer-status-badge ${isConfirmed ? 'confirmed' : ''}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "status-dot"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "status-text",
                        children: statusLabel
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "offer-pkg-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "offer-pkg-title",
                        children: packageName
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "offer-price-val",
                        children: `${currencySymbol}${price}`
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "offer-duration-meta",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: `${duration} \u{2022} 28 Sep - 25 Sep 2026`
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "offer-start-date-box",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "start-date-left",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "cal-icon-wrap",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarPeriodSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "date-text-col",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "date-label",
                                        children: 'Program Start Date'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "date-sub",
                                        children: 'Training program will be ready on this date'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "start-date-display",
                        children: startDate
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "offer-included-box",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "included-header",
                        onClick: ()=>setIsIncludedOpen(!isIncludedOpen),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "included-title-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "fire-icon-wrap",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _whatsIncludedSvg.ReactComponent), {
                                            className: "fire-icon"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "included-title",
                                        children: "What's included"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                className: `chevron-icon ${isIncludedOpen ? 'open' : ''}`,
                                width: "20",
                                height: "20",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "currentColor",
                                strokeWidth: "2.5",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                    points: "18 15 12 9 6 15"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `included-checklist-wrapper ${isIncludedOpen ? 'expanded' : 'collapsed'}`,
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "included-checklist",
                            children: items.map((text, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "included-check-item",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "check-icon-circle",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                width: "18",
                                                height: "18",
                                                viewBox: "0 0 18 18",
                                                fill: "none",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                        cx: "9",
                                                        cy: "9",
                                                        r: "9",
                                                        fill: "#FFA100"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                        d: "M5.5 9.2L7.8 11.5L12.5 6.5",
                                                        stroke: "#FFFFFF",
                                                        strokeWidth: "2",
                                                        strokeLinecap: "round",
                                                        strokeLinejoin: "round"
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "check-desc",
                                            children: text
                                        })
                                    ]
                                }, idx))
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "offer-attached-docs",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "docs-label",
                        children: 'Attached documents'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "docs-card-list",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "doc-card-row",
                                onClick: ()=>handleDocClick('checkin_policy'),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "doc-left",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachedDocsSvg.ReactComponent), {
                                                className: "doc-icon"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Check-in policy'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronRightSvg.ReactComponent), {
                                        className: "doc-chevron"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "doc-card-row",
                                onClick: ()=>handleDocClick('contractual_terms'),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "doc-left",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachedDocsSvg.ReactComponent), {
                                                className: "doc-icon"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Contractual terms'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronRightSvg.ReactComponent), {
                                        className: "doc-chevron"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "doc-card-row",
                                onClick: ()=>handleDocClick('cancellation_policy'),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "doc-left",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachedDocsSvg.ReactComponent), {
                                                className: "doc-icon"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Cancellation and unused policy'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronRightSvg.ReactComponent), {
                                        className: "doc-chevron"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/calendar-period.svg":"fwWHG","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/attached-docs.svg":"kogNT","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/whats-included.svg":"839e8","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/chevron-right.svg":"d3v0H","./PackageOfferBubble.scss":"fdsEH","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kogNT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAttachedDocs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAttachedDocs = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 20,
        fill: "none",
        viewBox: "0 0 18 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M17.68 5.014a3.85 3.85 0 0 0-.92-1.22l-3-2.72a4.15 4.15 0 0 0-2.39-1.07H5.21A5 5 0 0 0 0 4.864v10.3a5 5 0 0 0 3.31 4.53 4.7 4.7 0 0 0 1.92.3h7.56a5 5 0 0 0 5.21-4.86v-8.57a3.75 3.75 0 0 0-.32-1.55m-13-.4h3.26a1 1 0 0 1 0 2H4.68a1 1 0 0 1 0-2m8.7 10.71h-8.7a1 1 0 0 1 0-2h8.7a1 1 0 0 1 0 1.98zm0-4.35h-8.7a1 1 0 0 1 0-2h8.7a1 1 0 1 1 0 2m-.32-5.57a1.08 1.08 0 0 1-1.09-1.08v-2.65c.66.16 3.23 2.8 3.79 3.24q.25.212.42.49z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"839e8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgWhatsIncluded);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgWhatsIncluded = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 20,
        fill: "none",
        viewBox: "0 0 16 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M14.48 9.111c-.263-.333-.583-.622-.88-.91-.765-.667-1.634-1.145-2.365-1.845-1.703-1.623-2.08-4.3-.994-6.356-1.086.256-2.034.833-2.845 1.467-2.96 2.31-4.125 6.389-2.731 9.889a.9.9 0 0 1 .091.367.62.62 0 0 1-.4.555c-.263.111-.537.045-.754-.133a.7.7 0 0 1-.16-.19c-1.291-1.588-1.497-3.866-.629-5.688C.905 7.778-.135 10.334.014 12.745c.069.555.137 1.111.331 1.667.16.666.469 1.333.812 1.922 1.234 1.922 3.37 3.3 5.667 3.578 2.445.3 5.062-.134 6.936-1.778 2.091-1.845 2.822-4.8 1.748-7.334l-.148-.289c-.24-.51-.88-1.4-.88-1.4m-3.61 7c-.32.267-.846.556-1.258.667-1.28.445-2.56-.177-3.313-.91 1.36-.312 2.17-1.29 2.41-2.279.195-.889-.17-1.622-.32-2.478-.136-.822-.114-1.522.195-2.289.217.423.446.845.72 1.178.88 1.111 2.262 1.6 2.56 3.112.045.155.068.31.068.477.034.911-.377 1.911-1.063 2.523"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d3v0H":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgChevronRight);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgChevronRight = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 8,
        height: 14,
        fill: "none",
        viewBox: "0 0 8 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m1 13 6-6-6-6"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fdsEH":[function() {},{}],"42Yuo":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PackageActiveBanner", ()=>PackageActiveBanner);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _onlyLogoSvg = require("src/assets/images/onboarding-trainer/components/sidebar/only-logo.svg");
var _packageActiveBannerScss = require("./PackageActiveBanner.scss");
const PackageActiveBanner = ({ message, clientName, packageName })=>{
    // Determine client's display first name
    const rawClientName = message?.client_name || clientName || 'Client';
    const firstName = rawClientName.trim().split(/\s+/)[0] || 'Client';
    // Determine package name and strip redundant "Package" word if present
    const rawPkgName = message?.package_name || packageName || 'Basic';
    const cleanPkgName = rawPkgName.replace(/\s*package\s*/i, '').trim() || 'Basic';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "package-active-banner-row",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "package-active-pill",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onlyLogoSvg.ReactComponent), {
                    className: "package-active-logo"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                    className: "package-active-text",
                    children: [
                        `${firstName}\u{2019}s ${cleanPkgName} package is now `,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                            children: "active"
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/assets/images/onboarding-trainer/components/sidebar/only-logo.svg":"5717Y","./PackageActiveBanner.scss":"2uql6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2uql6":[function() {},{}],"5uESC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DEFAULT_WHATS_INCLUDED", ()=>DEFAULT_WHATS_INCLUDED);
parcelHelpers.export(exports, "SendFinalOfferModal", ()=>SendFinalOfferModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _calendarPeriodSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/calendar-period.svg");
var _attachedDocsSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/attached-docs.svg");
var _sendOfferSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/send-offer.svg");
var _whatsIncludedSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/whats-included.svg");
var _dropdownSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/dropdown.svg");
var _closeSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/close.svg");
var _chevronRightSvg = require("src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/chevron-right.svg");
var _sendFinalOfferModalScss = require("./SendFinalOfferModal.scss");
const DEFAULT_WHATS_INCLUDED = [
    'Pre-session questionnaire to understand your goals, fitness level, and schedule',
    'Session programme tailored to you, integrating AI-based form tracking & MPT Score',
    'Real-time feedback from a certified PT',
    'Session-specific MPT Score (accuracy, goal-based calorie burn, reps completed)',
    'Access to personal trainer notes & AI session history',
    'Chat/message support in the app for quick form checks or questions (during package period)'
];
const SendFinalOfferModal = ({ isOpen, onClose, publishedPackages, initialPackageId, initialStartDate, onConfirmSend, isSending = false, onOpenDocument })=>{
    const [selectedPackage, setSelectedPackage] = (0, _react.useState)(null);
    const [isDropdownOpen, setIsDropdownOpen] = (0, _react.useState)(false);
    const [startDate, setStartDate] = (0, _react.useState)(initialStartDate || '28 Sep 2026');
    const dropdownRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        if (initialStartDate) setStartDate(initialStartDate);
    }, [
        initialStartDate
    ]);
    // Sync selected package from published list
    (0, _react.useEffect)(()=>{
        if (publishedPackages.length > 0) {
            const matched = publishedPackages.find((p)=>p.id === initialPackageId);
            setSelectedPackage(matched || publishedPackages[0]);
        } else setSelectedPackage(null);
    }, [
        publishedPackages,
        initialPackageId
    ]);
    // Click outside to close dropdown
    (0, _react.useEffect)(()=>{
        const handleClickOutside = (e)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) setIsDropdownOpen(false);
        };
        if (isDropdownOpen) document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        isDropdownOpen
    ]);
    if (!isOpen) return null;
    const pkgName = selectedPackage?.name || 'Basic Package';
    const price = selectedPackage?.price !== undefined ? selectedPackage.price : 95;
    const currencySymbol = selectedPackage?.currencySymbol || (selectedPackage?.currency === 'GBP' ? "\xa3" : '$');
    const duration = selectedPackage?.duration || '4 weeks';
    const handleSend = ()=>{
        if (!selectedPackage) return;
        onConfirmSend({
            pkg: selectedPackage,
            startDate,
            whatsIncluded: DEFAULT_WHATS_INCLUDED
        });
    };
    const handleDocClick = (docType)=>{
        if (onOpenDocument) onOpenDocument(docType);
        else window.open(`/onboarding-trainer/dashboard/profile?tab=packages&view=template&type=${docType}`, '_blank');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        footer: null,
        onCancel: onClose,
        centered: true,
        width: 560,
        closeIcon: null,
        rootClassName: "send-final-offer-modal",
        className: "send-final-offer-modal",
        styles: {
            mask: {
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(4, 5, 27, 0.75)'
            },
            container: {
                background: '#060821',
                backgroundColor: '#060821',
                border: '1px solid #1b1c2f',
                borderRadius: '20px',
                boxShadow: '0 24px 60px rgba(0, 0, 0, 0.75)',
                padding: '24px',
                color: '#ffffff',
                overflow: 'visible'
            },
            body: {
                padding: 0,
                background: 'transparent'
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "send-final-offer-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-top-bar",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "modal-heading",
                            children: 'Send final offer'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "close-btn",
                            onClick: onClose,
                            "aria-label": "Close modal",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeSvg.ReactComponent), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "offer-summary-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "card-header-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "dropdown-container",
                                    ref: dropdownRef,
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "selected-package-trigger",
                                            onClick: ()=>setIsDropdownOpen(!isDropdownOpen),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "selected-pkg-name",
                                                    children: pkgName
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownSvg.ReactComponent), {
                                                    className: `chevron-svg ${isDropdownOpen ? 'open' : ''}`
                                                })
                                            ]
                                        }),
                                        isDropdownOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "packages-select-menu",
                                            children: publishedPackages.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "empty-pkg-opt",
                                                children: 'No published packages'
                                            }) : publishedPackages.map((pkg)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `pkg-select-option ${selectedPackage?.id === pkg.id ? 'active' : ''}`,
                                                    onClick: ()=>{
                                                        setSelectedPackage(pkg);
                                                        setIsDropdownOpen(false);
                                                    },
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: pkg.name
                                                    })
                                                }, pkg.id))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "pkg-duration-subtitle",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: `${duration} \u{2022} 28 Sep - 25 Oct`
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "header-price-col",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "price-tag",
                                        children: `${currencySymbol}${price}`
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "program-start-date-box",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "start-date-left",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "cal-icon-wrap",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _calendarPeriodSvg.ReactComponent), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "date-text-col",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "date-title",
                                                    children: 'Program Start Date'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "date-desc",
                                                    children: 'Training program will be ready on this date'
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "start-date-val",
                                    children: startDate
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "whats-included-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "section-title-row",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "title-icon-wrap",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _whatsIncludedSvg.ReactComponent), {})
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "section-label",
                                            children: "What's included"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "checklist-items",
                                    children: DEFAULT_WHATS_INCLUDED.map((item, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "checklist-row",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "orange-check-icon",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                        width: "18",
                                                        height: "18",
                                                        viewBox: "0 0 18 18",
                                                        fill: "none",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                                                cx: "9",
                                                                cy: "9",
                                                                r: "9",
                                                                fill: "#261e24"
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                                                                d: "M5.5 9.2L7.8 11.5L12.5 6.5",
                                                                stroke: "#FFA101",
                                                                strokeWidth: "2",
                                                                strokeLinecap: "round",
                                                                strokeLinejoin: "round"
                                                            })
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "check-text",
                                                    children: item
                                                })
                                            ]
                                        }, idx))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "attached-docs-section",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "docs-section-label",
                                    children: 'Attached documents'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "docs-list",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "doc-item-row",
                                            onClick: ()=>handleDocClick('checkin_policy'),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "doc-item-left",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachedDocsSvg.ReactComponent), {
                                                            className: "doc-svg-icon"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: 'Check-in policy'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronRightSvg.ReactComponent), {
                                                    className: "doc-chevron"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "doc-item-row",
                                            onClick: ()=>handleDocClick('contractual_terms'),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "doc-item-left",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachedDocsSvg.ReactComponent), {
                                                            className: "doc-svg-icon"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: 'Contractual terms'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronRightSvg.ReactComponent), {
                                                    className: "doc-chevron"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "doc-item-row",
                                            onClick: ()=>handleDocClick('cancellation_policy'),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "doc-item-left",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _attachedDocsSvg.ReactComponent), {
                                                            className: "doc-svg-icon"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: 'Cancellation and unused policy'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _chevronRightSvg.ReactComponent), {
                                                    className: "doc-chevron"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            className: "btn-confirm-send-offer",
                            onClick: handleSend,
                            disabled: !selectedPackage || isSending,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendOfferSvg.ReactComponent), {
                                    className: "send-svg-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: isSending ? 'Sending Offer...' : 'Send Offer'
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/calendar-period.svg":"fwWHG","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/attached-docs.svg":"kogNT","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/send-offer.svg":"hfnCA","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/whats-included.svg":"839e8","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/dropdown.svg":"2pGmQ","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/close.svg":"k0CgM","src/assets/images/onboarding-trainer/dashboard/profile/packages/create-edit-package/chevron-right.svg":"d3v0H","./SendFinalOfferModal.scss":"7vr6a","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hfnCA":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSendOffer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSendOffer = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#07092C",
            d: "M17.79.074c1.016-.355 1.992.621 1.637 1.637l-5.925 16.93c-.385 1.098-1.915 1.16-2.387.097l-2.86-6.432 4.025-4.025a.75.75 0 0 0-1.06-1.06l-4.025 4.024L.763 8.386C-.3 7.913-.237 6.384.86 6z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2pGmQ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDropdown = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 8,
        fill: "none",
        viewBox: "0 0 14 8",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M13 1 7 7 1 1"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k0CgM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgClose);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgClose = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#99A1AF",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "M1 13 13 1M1 1l12 12"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7vr6a":[function() {},{}],"bhbAM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "InviteFreeCallModal", ()=>InviteFreeCallModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _closeSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/close.svg");
var _freeSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/free.svg");
var _onlineViaZoomSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/online-via-zoom.svg");
var _letChooseTimeSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/let-choose-time.svg");
var _sendOfferSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/send-offer.svg");
var _inviteFreeCallModalScss = require("./InviteFreeCallModal.scss");
const InviteFreeCallModal = ({ isOpen, onClose, clientName = 'Client', scheduleData, onChangeSchedule, onConfirmSend, isSending = false })=>{
    if (!isOpen) return null;
    const clientFirstName = clientName.split(' ')[0] || 'Client';
    const handleSend = ()=>{
        const summary = scheduleData.isUniform ? scheduleData.uniformText || "Monday to Friday \u2022 09:00 - 17:00" : scheduleData.daysList.map((d)=>`${d.day}: ${d.time}`).join(' | ');
        onConfirmSend({
            callTitle: '15-min introductory call',
            scheduleSummary: summary,
            scheduleDays: !scheduleData.isUniform ? scheduleData.daysList : undefined,
            timezone: scheduleData.timezone
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        footer: null,
        onCancel: onClose,
        centered: true,
        width: 540,
        closeIcon: null,
        rootClassName: "invite-free-call-modal",
        className: "invite-free-call-modal",
        styles: {
            mask: {
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(6, 7, 35, 0.8)'
            },
            container: {
                background: '#060821',
                backgroundColor: '#060821',
                border: '1px solid #1b1c2f',
                borderRadius: '20px',
                boxShadow: '0 24px 60px rgba(0, 0, 0, 0.75)',
                padding: '24px',
                color: '#ffffff',
                overflow: 'visible'
            },
            body: {
                padding: 0,
                background: 'transparent'
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "invite-call-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-top-bar",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            className: "modal-heading",
                            children: 'Invite to a free call'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "close-btn",
                            onClick: onClose,
                            "aria-label": "Close modal",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeSvg.ReactComponent), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "call-details-card",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "card-header-info",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    className: "call-title",
                                    children: '15-min introductory call'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "call-subtitle",
                                    children: "A chance to discuss your goals and see if we're a good fit"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "card-divider"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "badges-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "call-pill-badge",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _freeSvg.ReactComponent), {
                                            className: "badge-svg"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: 'Free'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "call-pill-badge",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onlineViaZoomSvg.ReactComponent), {
                                            className: "badge-svg"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: 'Online via Zoom'
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "card-divider"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "availability-intro-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _letChooseTimeSvg.ReactComponent), {
                                    className: "cal-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: `Let ${clientFirstName} choose a time from your availability.`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "schedule-info-box",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "schedule-left-col",
                                    children: [
                                        scheduleData.isUniform ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "schedule-hours",
                                            children: scheduleData.uniformText
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "schedule-days-list",
                                            children: scheduleData.daysList.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "schedule-day-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "day-name",
                                                            children: [
                                                                item.day,
                                                                ":"
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "day-time",
                                                            children: item.time
                                                        })
                                                    ]
                                                }, item.day))
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "schedule-tz",
                                            children: scheduleData.timezone
                                        })
                                    ]
                                }),
                                onChangeSchedule && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "btn-change-schedule",
                                    onClick: onChangeSchedule,
                                    children: 'Change'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            className: "btn-send-invitation",
                            onClick: handleSend,
                            disabled: isSending,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendOfferSvg.ReactComponent), {
                                    className: "send-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: isSending ? 'Sending Invitation...' : 'Send Invitation'
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"src/assets/images/onboarding-trainer/dashboard/messages/package-offer/close.svg":"k0CgM","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/free.svg":"4w33e","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/online-via-zoom.svg":"fuxSa","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/let-choose-time.svg":"cnOW5","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/send-offer.svg":"hfnCA","./InviteFreeCallModal.scss":"2HEWQ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4w33e":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFree);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFree = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 14,
        fill: "none",
        viewBox: "0 0 15 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M7.134 11.417 3.676 13.5a.76.76 0 0 1-.48.125.8.8 0 0 1-.437-.167 1 1 0 0 1-.292-.364.73.73 0 0 1-.041-.49l.916-3.937L.28 6.02a.8.8 0 0 1-.26-.428.89.89 0 0 1 .28-.843.86.86 0 0 1 .46-.187l4.04-.355L6.364.5a.75.75 0 0 1 .324-.375A.9.9 0 0 1 7.134 0q.228 0 .448.125A.75.75 0 0 1 7.905.5l1.562 3.708 4.042.354q.291.042.458.188a.9.9 0 0 1 .25.375q.084.23.032.47a.8.8 0 0 1-.26.426l-3.063 2.646.916 3.937a.73.73 0 0 1-.041.49 1 1 0 0 1-.292.364.8.8 0 0 1-.437.167.75.75 0 0 1-.48-.125z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fuxSa":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOnlineViaZoom);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOnlineViaZoom = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 12,
        fill: "none",
        viewBox: "0 0 17 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            fillRule: "evenodd",
            d: "M2.5 0A2.5 2.5 0 0 0 0 2.5v6.667a2.5 2.5 0 0 0 2.5 2.5h8.333a2.5 2.5 0 0 0 2.5-2.5V7.845l1.911 1.91a.833.833 0 0 0 1.423-.588V2.5a.834.834 0 0 0-1.423-.59l-1.91 1.912V2.5a2.5 2.5 0 0 0-2.5-2.5z",
            clipRule: "evenodd"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cnOW5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgLetChooseTime);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgLetChooseTime = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 17,
        height: 17,
        fill: "none",
        viewBox: "0 0 17 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            d: "M0 14.167c0 1.416 1.083 2.5 2.5 2.5h11.667c1.416 0 2.5-1.084 2.5-2.5V7.5H0zm14.167-12.5H12.5V.833c0-.5-.333-.833-.833-.833s-.834.333-.834.833v.834h-5V.833C5.833.333 5.5 0 5 0s-.833.333-.833.833v.834H2.5c-1.417 0-2.5 1.083-2.5 2.5v1.666h16.667V4.167c0-1.417-1.084-2.5-2.5-2.5"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2HEWQ":[function() {},{}],"bCp6L":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "FreeCallInvitationBubble", ()=>FreeCallInvitationBubble);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _letChooseTimeSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/let-choose-time.svg");
var _onlineViaZoomSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/online-via-zoom.svg");
var _freeSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/free.svg");
var _callTimingClockSvg = require("src/assets/images/onboarding-trainer/dashboard/messages/package-offer/call-timing-clock.svg");
var _freeCallInvitationBubbleScss = require("./FreeCallInvitationBubble.scss");
const FreeCallInvitationBubble = ({ message, clientName = 'Client' })=>{
    const isConfirmed = message.call_status === 'confirmed';
    const clientFirstName = (clientName || message.receive_name || 'Client').split(' ')[0];
    const scheduleSummary = message.trainer_schedule_summary || "Monday to Friday \u2022 09:00 - 17:00";
    const timezone = message.trainer_timezone || 'Europe/London';
    const scheduleLine = `${scheduleSummary} (${timezone})`;
    const confirmedDate = message.call_date || '14 May 2026';
    const confirmedTime = message.call_time || '09:00 - 09:15';
    const hasDaysList = Array.isArray(message.trainer_schedule_days) && message.trainer_schedule_days.length > 0;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "free-call-invitation-bubble-card",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `call-status-badge ${isConfirmed ? 'confirmed' : 'awaiting'}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "status-dot"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "status-text",
                        children: isConfirmed ? 'Confirmed' : 'Awaiting response'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "call-info-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        className: "call-title",
                        children: '15-min introductory call'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "call-subtitle",
                        children: "A chance to discuss your goals and see if we're a good fit"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "call-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "call-badges-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "bubble-badge-pill",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _freeSvg.ReactComponent), {
                                className: "badge-svg star-icon"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: 'Free'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "bubble-badge-pill",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _onlineViaZoomSvg.ReactComponent), {
                                className: "badge-svg zoom-icon"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: 'Online via Zoom'
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "call-divider"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "call-details-lines",
                children: isConfirmed ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "detail-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _letChooseTimeSvg.ReactComponent), {
                                    className: "detail-svg-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-text bold",
                                    children: confirmedDate
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "detail-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _callTimingClockSvg.ReactComponent), {
                                    className: "detail-svg-icon clock-solid"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-text bold",
                                    children: confirmedTime
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "detail-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _letChooseTimeSvg.ReactComponent), {
                                    className: "detail-svg-icon"
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-text bold",
                                    children: `${clientFirstName} will choose a time from your availability`
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: `detail-row ${hasDaysList ? 'multi-line' : ''}`,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _callTimingClockSvg.ReactComponent), {
                                    className: "detail-svg-icon clock-solid"
                                }),
                                hasDaysList ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "bubble-schedule-days",
                                    children: [
                                        message.trainer_schedule_days?.map((item)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "bubble-day-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "day-name",
                                                        children: [
                                                            item.day,
                                                            ":"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "day-time",
                                                        children: item.time
                                                    })
                                                ]
                                            }, item.day)),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "bubble-tz",
                                            children: `(${timezone})`
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-text bold",
                                    children: scheduleLine
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/let-choose-time.svg":"cnOW5","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/online-via-zoom.svg":"fuxSa","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/free.svg":"4w33e","src/assets/images/onboarding-trainer/dashboard/messages/package-offer/call-timing-clock.svg":"2Z7xJ","./FreeCallInvitationBubble.scss":"4AHwo","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Z7xJ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCallTimingClock);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCallTimingClock = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 8,
                cy: 8,
                r: 8,
                fill: "#080A24"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#fff",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M8 4.2V8l2.5 2.5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4AHwo":[function() {},{}],"blYZQ":[function() {},{}],"enFFI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "DashboardMediaLinksFilesScreen", ()=>DashboardMediaLinksFilesScreen);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _firestore = require("firebase/firestore");
var _firebase = require("src/config/firebase");
var _mediaLinksFilesView = require("./components/MediaLinksFilesView/MediaLinksFilesView");
const DashboardMediaLinksFilesScreen = ()=>{
    const { chatId } = (0, _reactRouterDom.useParams)();
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    const inquiryId = searchParams.get('inquiryId') || undefined;
    const tabParam = searchParams.get('tab');
    const initialTab = tabParam === 'files' || tabParam === 'links' ? tabParam : 'media';
    const [realtimeMessages, setRealtimeMessages] = (0, _react.useState)([]);
    // Listen to realtime messages for newly incoming attachments
    (0, _react.useEffect)(()=>{
        if (!chatId) return;
        const msgsRef = (0, _firestore.collection)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages');
        const q = (0, _firestore.query)(msgsRef, (0, _firestore.orderBy)('send_time', 'desc'), (0, _firestore.limit)(50));
        const unsubscribe = (0, _firestore.onSnapshot)(q, (snapshot)=>{
            const msgs = [];
            snapshot.forEach((doc)=>{
                msgs.push({
                    id: doc.id,
                    ...doc.data()
                });
            });
            setRealtimeMessages(msgs);
        }, (error)=>{
            console.error('Error listening to chat messages:', error);
        });
        return ()=>unsubscribe();
    }, [
        chatId
    ]);
    const handleBack = ()=>{
        if (chatId) {
            const returnUrl = inquiryId ? `/onboarding-trainer/dashboard/messages/${chatId}?inquiryId=${inquiryId}` : `/onboarding-trainer/dashboard/messages/${chatId}`;
            navigate(returnUrl);
        } else navigate('/onboarding-trainer/dashboard/messages');
    };
    if (!chatId) return null;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            position: 'relative',
            width: '100%',
            height: '100%',
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden',
            background: '#060723'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mediaLinksFilesView.MediaLinksFilesView), {
            chatId: chatId,
            inquiryId: inquiryId,
            messages: realtimeMessages,
            initialTab: initialTab,
            onBack: handleBack
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["useNavigate","f3cgC"],["useSearchParams","f3cgC"],["useParams","9oT3O"]],"firebase/firestore":"5IgBQ","src/config/firebase":"cmjIE","./components/MediaLinksFilesView/MediaLinksFilesView":"2iBPl","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fjpjR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CheckinDetailsRoute", ()=>CheckinDetailsRoute);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _checkinDetails = require("./CheckinDetails");
const CheckinDetailsRoute = ()=>{
    const { checkinId } = (0, _reactRouterDom.useParams)();
    const navigate = (0, _reactRouterDom.useNavigate)();
    if (!checkinId) {
        navigate('/onboarding-trainer/dashboard/messages?tab=checkins');
        return null;
    }
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "dashboard-screen messages-screen",
        style: {
            padding: 0,
            overflowY: 'hidden',
            height: '100%'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkinDetails.CheckinDetails), {
            checkinId: checkinId,
            onBack: ()=>{
                if (window.history.length > 1) navigate(-1);
                else navigate('/onboarding-trainer/dashboard/messages?tab=checkins');
            }
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":[["useNavigate","f3cgC"],["useParams","9oT3O"]],"./CheckinDetails":"fpMC3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jbt5N":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Welcome", ()=>(0, _welcome.Welcome));
parcelHelpers.export(exports, "SubscriptionPlans", ()=>(0, _subscriptionPlans.SubscriptionPlans));
parcelHelpers.export(exports, "Checkout", ()=>(0, _checkout.Checkout));
parcelHelpers.export(exports, "PrivacyPolicyScreen", ()=>(0, _privacyPolicyScreen.PrivacyPolicyScreen));
parcelHelpers.export(exports, "TermsOfServiceScreen", ()=>(0, _termsOfServiceScreen.TermsOfServiceScreen));
parcelHelpers.export(exports, "MySubscription", ()=>(0, _mySubscription.MySubscription));
parcelHelpers.export(exports, "ManagePaymentMethod", ()=>(0, _managePaymentMethod.ManagePaymentMethod));
parcelHelpers.export(exports, "BillingHistory", ()=>(0, _billingHistory.BillingHistory));
parcelHelpers.export(exports, "CancelSubscription", ()=>(0, _cancelSubscription.CancelSubscription));
parcelHelpers.export(exports, "ReactivatePro", ()=>(0, _reactivatePro.ReactivatePro));
parcelHelpers.export(exports, "ContactSupport", ()=>(0, _contactSupport.ContactSupport));
var _welcome = require("./Welcome/Welcome");
var _subscriptionPlans = require("./Plans/SubscriptionPlans");
var _checkout = require("./Checkout/Checkout");
var _privacyPolicyScreen = require("./Legal/PrivacyPolicyScreen");
var _termsOfServiceScreen = require("./Legal/TermsOfServiceScreen");
var _mySubscription = require("./MySubscription/MySubscription");
var _managePaymentMethod = require("./ManagePaymentMethod/ManagePaymentMethod");
var _billingHistory = require("./BillingHistory/BillingHistory");
var _cancelSubscription = require("./Cancellation/CancelSubscription");
var _reactivatePro = require("./Reactivation/ReactivatePro");
var _contactSupport = require("./ContactSupport/ContactSupport");

},{"./Welcome/Welcome":"1vIg1","./Plans/SubscriptionPlans":"3T8bD","./Checkout/Checkout":"hKBKI","./Legal/PrivacyPolicyScreen":"9loYM","./Legal/TermsOfServiceScreen":"cfbmz","./MySubscription/MySubscription":"ANxhc","./ManagePaymentMethod/ManagePaymentMethod":"4P7Pp","./BillingHistory/BillingHistory":"dASiK","./Cancellation/CancelSubscription":"f1Phb","./Reactivation/ReactivatePro":"3ko3J","./ContactSupport/ContactSupport":"gks7i","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1vIg1":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Welcome", ()=>Welcome);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _subscriptionService = require("src/services/subscriptionService");
var _createWithManualSvg = require("src/assets/images/onboarding-trainer/dashboard/overview/create-with-manual.svg");
var _createWithAiSvg = require("src/assets/images/onboarding-trainer/dashboard/overview/create-with-ai.svg");
var _createArrowSvg = require("src/assets/images/onboarding-trainer/dashboard/overview/create-arrow.svg");
var _logoSvg = require("src/assets/images/onboarding-trainer/logo.svg");
var _welcomeScss = require("./Welcome.scss");
const Welcome = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleCreateWithAi = async ()=>{
        try {
            const res = await (0, _subscriptionService.subscriptionService).checkFeatureAccess('ai_program_generator', 'welcome_screen');
            if (res.allowed) navigate('/onboarding-trainer/dashboard/programs');
            else navigate('/onboarding-trainer/dashboard/subscription');
        } catch  {
            navigate('/onboarding-trainer/dashboard/subscription');
        }
    };
    const handleCreateManually = ()=>{
        navigate('/onboarding-trainer/dashboard/programs');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "welcome-screen-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "welcome-header-center",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "welcome-logo-center",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _logoSvg.ReactComponent), {})
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                        children: 'Create personalized workout programs for your clients'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "welcome-action-cards",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        className: "welcome-action-card ai-card",
                        onClick: handleCreateWithAi,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon-circle",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createWithAiSvg.ReactComponent), {
                                    viewBox: "0 0 64 64"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-title gold-title",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: 'Create with Ai'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createArrowSvg.ReactComponent), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "card-description",
                                children: 'Let AI generate a customized workout program'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        className: "welcome-action-card manual-card",
                        onClick: handleCreateManually,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "icon-circle",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createWithManualSvg.ReactComponent), {
                                    viewBox: "0 0 64 64"
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "card-title white-title",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: 'Create Manually'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createArrowSvg.ReactComponent), {})
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "card-description",
                                children: 'Build your workout program from scratch'
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","src/services/subscriptionService":"7NbXi","src/assets/images/onboarding-trainer/dashboard/overview/create-with-manual.svg":"iUQ2I","src/assets/images/onboarding-trainer/dashboard/overview/create-with-ai.svg":"gzhlc","src/assets/images/onboarding-trainer/dashboard/overview/create-arrow.svg":"6TMMd","src/assets/images/onboarding-trainer/logo.svg":"iy8G7","./Welcome.scss":"5BCKs","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7NbXi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscriptionApiError", ()=>SubscriptionApiError);
parcelHelpers.export(exports, "subscriptionService", ()=>subscriptionService);
var _apiConfig = require("src/config/api-config");
var _apiConfigDefault = parcelHelpers.interopDefault(_apiConfig);
var _firebase = require("src/config/firebase");
class SubscriptionApiError extends Error {
    code;
    subCode;
    errorTitle;
    userMessage;
    fieldErrors;
    retryable;
    nextAction;
    status;
    constructor(status, err){
        super(err.message || 'Subscription API error');
        this.name = 'SubscriptionApiError';
        this.code = err.code || 'ERR_INTERNAL';
        this.subCode = err.sub_code;
        this.errorTitle = err.error_title;
        this.userMessage = err.user_message || err.message || 'An unexpected error occurred.';
        this.fieldErrors = err.field_errors;
        this.retryable = err.retryable ?? false;
        this.nextAction = err.next_action;
        this.status = status;
    }
}
// Helper to get token
const getAuthToken = async ()=>{
    const user = (0, _firebase.auth).currentUser;
    if (!user) throw new SubscriptionApiError(401, {
        code: 'ERR_UNAUTHENTICATED',
        message: 'User is not logged in',
        user_message: 'Please log in to continue.'
    });
    return await user.getIdToken();
};
// Generic request wrapper
async function requestApi(endpoint, options = {}) {
    const token = await getAuthToken();
    const method = options.method || 'GET';
    // Target unified subscription_api dispatcher with direct endpoint fallback
    let url = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}subscription_api/${endpoint}`;
    if (options.params) {
        const searchParams = new URLSearchParams();
        Object.entries(options.params).forEach(([k, v])=>{
            if (v !== undefined && v !== null) searchParams.append(k, String(v));
        });
        const qs = searchParams.toString();
        if (qs) url += (url.includes('?') ? '&' : '?') + qs;
    }
    const headers = {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
        'X-Client-Version': '1.0.0'
    };
    if ([
        'POST',
        'PUT',
        'DELETE'
    ].includes(method)) headers['Idempotency-Key'] = options.idempotencyKey || `req_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
    const fetchOptions = {
        method,
        headers
    };
    if (options.body && [
        'POST',
        'PUT',
        'DELETE'
    ].includes(method)) fetchOptions.body = JSON.stringify(options.body);
    let response;
    try {
        response = await fetch(url, fetchOptions);
        if (response.status === 404) {
            const directUrl = `${(0, _apiConfigDefault.default).CLOUD_FUNCTIONS_BASE_URL}${endpoint}` + (url.includes('?') ? `?${url.split('?')[1]}` : '');
            const directResp = await fetch(directUrl, fetchOptions);
            if (directResp.status !== 404) response = directResp;
        }
    } catch (netErr) {
        throw new SubscriptionApiError(503, {
            code: 'ERR_NETWORK',
            message: netErr?.message || 'Network request failed',
            user_message: 'Unable to connect to server. Please check your internet connection.',
            retryable: true
        });
    }
    let jsonResult;
    try {
        jsonResult = await response.json();
    } catch  {
        jsonResult = null;
    }
    if (!response.ok || jsonResult && jsonResult.ok === false) {
        const errDetail = jsonResult?.error || {
            code: response.status === 401 ? 'ERR_UNAUTHENTICATED' : 'ERR_INTERNAL',
            message: response.statusText || 'Request failed',
            user_message: 'An error occurred while communicating with the billing service.',
            retryable: response.status >= 500
        };
        throw new SubscriptionApiError(response.status, errDetail);
    }
    if (jsonResult && jsonResult.ok === true && jsonResult.data !== undefined) return jsonResult.data;
    return jsonResult?.data ?? jsonResult;
}
const subscriptionService = {
    // 1. Entitlements
    getEntitlements: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_ENTITLEMENTS),
    checkFeatureAccess: (feature, source)=>requestApi((0, _apiConfigDefault.default).TRAINER_CHECK_FEATURE_ACCESS, {
            method: 'POST',
            body: {
                feature,
                source
            }
        }),
    // 2. Plans & Eligibility
    getSubscriptionPlans: (country)=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_SUBSCRIPTION_PLANS, {
            params: country ? {
                country
            } : undefined
        }),
    getTrialEligibility: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_TRIAL_ELIGIBILITY),
    previewCheckout: (payload)=>requestApi((0, _apiConfigDefault.default).TRAINER_PREVIEW_CHECKOUT, {
            method: 'POST',
            body: payload
        }),
    validatePromoCode: (payload)=>requestApi((0, _apiConfigDefault.default).TRAINER_VALIDATE_PROMO_CODE, {
            method: 'POST',
            body: payload
        }),
    // 3. Checkout & SCA
    checkoutSubscription: (payload)=>requestApi((0, _apiConfigDefault.default).TRAINER_CHECKOUT_SUBSCRIPTION, {
            method: 'POST',
            body: payload
        }),
    syncSubscription: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_SYNC_SUBSCRIPTION, {
            method: 'POST'
        }),
    getPaymentOperationStatus: (operationId)=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_PAYMENT_OPERATION_STATUS, {
            params: {
                operation_id: operationId
            }
        }),
    // 4. Legal
    getTermsOfService: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_TERMS_OF_SERVICE),
    getPrivacyPolicy: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_PRIVACY_POLICY),
    recordLegalAcknowledgement: (termsVersion, privacyVersion)=>requestApi((0, _apiConfigDefault.default).TRAINER_RECORD_LEGAL_ACKNOWLEDGEMENT, {
            method: 'POST',
            body: {
                ...termsVersion ? {
                    terms_version: termsVersion
                } : {},
                ...privacyVersion ? {
                    privacy_version: privacyVersion
                } : {},
                accepted: true
            }
        }),
    // 5. Billing Profile
    getBillingProfile: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_BILLING_PROFILE),
    saveBillingProfile: (profile)=>requestApi((0, _apiConfigDefault.default).TRAINER_SAVE_BILLING_PROFILE, {
            method: 'PUT',
            body: profile
        }),
    validateBillingProfile: (profile)=>requestApi((0, _apiConfigDefault.default).TRAINER_VALIDATE_BILLING_PROFILE, {
            method: 'POST',
            body: profile
        }),
    // 6. Payment Methods
    createSetupIntent: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_CREATE_SETUP_INTENT, {
            method: 'POST'
        }),
    getStripeConfig: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_STRIPE_CONFIG),
    getPaymentMethods: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_PAYMENT_METHODS),
    savePaymentMethod: (payload)=>requestApi((0, _apiConfigDefault.default).TRAINER_SAVE_PAYMENT_METHOD, {
            method: 'POST',
            body: payload
        }),
    setDefaultPaymentMethod: (pmId)=>requestApi((0, _apiConfigDefault.default).TRAINER_SET_DEFAULT_PAYMENT_METHOD, {
            method: 'POST',
            body: {
                payment_method_id: pmId
            }
        }),
    replacePaymentMethod: (payload)=>requestApi((0, _apiConfigDefault.default).TRAINER_REPLACE_PAYMENT_METHOD, {
            method: 'POST',
            body: payload
        }),
    deletePaymentMethod: (pmId)=>requestApi((0, _apiConfigDefault.default).TRAINER_DELETE_PAYMENT_METHOD, {
            method: 'DELETE',
            body: {
                payment_method_id: pmId
            }
        }),
    // 7. My Subscription
    getSubscriptionState: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_SUBSCRIPTION_STATE),
    cancelSubscription: (reason, feedback)=>requestApi((0, _apiConfigDefault.default).TRAINER_CANCEL_SUBSCRIPTION, {
            method: 'POST',
            body: {
                reason,
                feedback
            }
        }),
    reactivateSubscription: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_REACTIVATE_SUBSCRIPTION, {
            method: 'POST'
        }),
    previewIntervalSwitch: (targetInterval)=>requestApi((0, _apiConfigDefault.default).TRAINER_SWITCH_BILLING_INTERVAL_PREVIEW, {
            method: 'POST',
            body: {
                target_interval: targetInterval
            }
        }),
    switchInterval: (targetInterval)=>requestApi((0, _apiConfigDefault.default).TRAINER_SWITCH_BILLING_INTERVAL, {
            method: 'POST',
            body: {
                target_interval: targetInterval
            }
        }),
    cancelScheduledIntervalSwitch: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_CANCEL_SCHEDULED_INTERVAL_SWITCH, {
            method: 'POST'
        }),
    retryPastDuePayment: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_RETRY_INVOICE_PAYMENT, {
            method: 'POST'
        }),
    // 8. Billing History & Invoices
    getBillingHistory: (params = {})=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_BILLING_HISTORY, {
            params
        }),
    getInvoiceDownloadUrl: (invoiceId)=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_INVOICE_DOWNLOAD_URL, {
            params: {
                invoice_id: invoiceId
            }
        }),
    downloadAllInvoices: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_DOWNLOAD_ALL_INVOICES, {
            method: 'POST'
        }),
    getExportStatus: (exportId)=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_EXPORT_STATUS, {
            params: {
                export_id: exportId
            }
        }),
    // 9. Contact Support
    getSupportConfig: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_SUPPORT_CONFIG),
    contactSupport: (payload)=>requestApi((0, _apiConfigDefault.default).TRAINER_CONTACT_SUPPORT, {
            method: 'POST',
            body: payload
        }),
    deleteSupportAttachment: (storagePath)=>requestApi((0, _apiConfigDefault.default).TRAINER_DELETE_SUPPORT_ATTACHMENT, {
            method: 'POST',
            body: {
                storage_path: storagePath
            }
        }),
    // 10. Account Deletion
    previewAccountDeletion: ()=>requestApi((0, _apiConfigDefault.default).TRAINER_PREVIEW_ACCOUNT_DELETION, {
            method: 'POST'
        }),
    requestAccountDeletion: (confirmation)=>requestApi((0, _apiConfigDefault.default).TRAINER_REQUEST_ACCOUNT_DELETION, {
            method: 'POST',
            body: {
                confirmation
            }
        }),
    getAccountDeletionStatus: (jobId)=>requestApi((0, _apiConfigDefault.default).TRAINER_GET_ACCOUNT_DELETION_STATUS, {
            params: {
                job_id: jobId
            }
        })
};

},{"src/config/api-config":"9oD3c","src/config/firebase":"cmjIE","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5BCKs":[function() {},{}],"3T8bD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SubscriptionPlans", ()=>SubscriptionPlans);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _subscriptionStore = require("src/store/subscriptionStore");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _cancelAnytimeSvg = require("src/assets/images/onboarding-trainer/subscription-icons/trial/cancel-anytime.svg");
var _contactSupportSvg = require("src/assets/images/onboarding-trainer/subscription-icons/trial/contact-support.svg");
var _paymentsSecureSvg = require("src/assets/images/onboarding-trainer/subscription-icons/trial/payments-secure.svg");
var _recommendedSvg = require("src/assets/images/onboarding-trainer/subscription-icons/trial/recommended.svg");
var _checkmarkSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/checkmark.svg");
var _managePaymentMethodNextSvg = require("src/assets/images/onboarding-trainer/subscription-icons/billing-history/manage-payment-method-next.svg");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _subscriptionPlansScss = require("./SubscriptionPlans.scss");
const SubscriptionPlans = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { billingCycle, setBillingCycle, billingInfo } = (0, _subscriptionStore.useSubscriptionStore)();
    const [activeCycle, setActiveCycle] = (0, _react.useState)(billingCycle);
    // Authoritative billing country
    const { data: serverBillingProfile } = (0, _useSubscriptionApi.useBillingProfileQuery)();
    const currentCountry = serverBillingProfile?.country || billingInfo.country;
    const { data: subscriptionState } = (0, _useSubscriptionApi.useSubscriptionStateQuery)();
    // Load plans & trial eligibility from server API with country context
    const { data: plansData, isLoading: isPlansLoading, isError: isPlansError, error: plansErrorObj, refetch: refetchPlans } = (0, _useSubscriptionApi.useSubscriptionPlansQuery)(currentCountry || undefined);
    const { data: eligibilityData } = (0, _useSubscriptionApi.useTrialEligibilityQuery)();
    const basicPlan = plansData?.plans?.find((p)=>p.tier_slug === 'basic' && p.interval === (activeCycle === 'yearly' ? 'year' : 'month')) || plansData?.plans?.find((p)=>p.tier_slug === 'basic');
    const proPlan = plansData?.plans?.find((p)=>p.tier_slug === 'pro' && p.interval === (activeCycle === 'yearly' ? 'year' : 'month'));
    const proMonthPlan = plansData?.plans?.find((p)=>p.tier_slug === 'pro' && p.interval === 'month');
    const proYearPlan = plansData?.plans?.find((p)=>p.tier_slug === 'pro' && p.interval === 'year');
    const formatSubDate = (isoString)=>{
        if (!isoString) return null;
        try {
            const d = new Date(isoString);
            return !isNaN(d.getTime()) ? d.toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            }) : null;
        } catch  {
            return null;
        }
    };
    const isCancelled = subscriptionState?.status === 'cancelled' || Boolean(subscriptionState?.cancel_at_period_end);
    const isActivePro = subscriptionState?.tier_slug === 'pro' && (subscriptionState?.status === 'active' || subscriptionState?.status === 'trialing') && !isCancelled;
    const isPastDue = subscriptionState?.tier_slug === 'pro' && subscriptionState?.status === 'past_due';
    const isProCurrent = subscriptionState?.tier_slug === 'pro' && [
        'active',
        'trialing',
        'cancelled',
        'past_due'
    ].includes(subscriptionState.status) || Boolean(plansData?.plans?.some((plan)=>plan.tier_slug === 'pro' && plan.is_current));
    const accessUntilFormatted = formatSubDate(subscriptionState?.access_until || subscriptionState?.current_period_end);
    const basicFeatures = basicPlan?.features ?? [];
    const proFeatures = proPlan?.features ?? [];
    // Server-verified trial eligibility (Backend is authoritative)
    const serverTrialEligible = eligibilityData?.trial_eligible ?? plansData?.trial_eligible ?? false;
    const canStartTrial = serverTrialEligible && !isProCurrent && !isCancelled;
    const handleCycleChange = (cycle)=>{
        setActiveCycle(cycle);
        setBillingCycle(cycle);
    };
    const handleSelectPro = ()=>{
        setBillingCycle(activeCycle);
        navigate(`/onboarding-trainer/dashboard/subscription/checkout?cycle=${activeCycle}`);
    };
    const handleGoToMySubscription = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/my-subscription');
    };
    const handleGoToReactivate = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/reactivate');
    };
    const handleGoToCancel = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/cancel');
    };
    const handleGoToSupport = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/contact-support');
    };
    if (isPlansLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "subscription-plans-page",
        style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '60vh'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
            indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                style: {
                    fontSize: 32,
                    color: '#E2F163'
                },
                spin: true
            })
        })
    });
    if (isPlansError) {
        const errorDetails = plansErrorObj;
        const userMessage = errorDetails?.user_message || errorDetails?.message || 'Unable to load subscription plans. Subscriptions may not be supported in your country yet.';
        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "subscription-plans-page",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "plans-page-header",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-titles",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                children: 'Subscription Plans'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: 'Choose the plan that fits how you coach and build programs.'
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        margin: '40px auto',
                        maxWidth: 600,
                        padding: 32,
                        background: 'rgba(255, 255, 255, 0.04)',
                        borderRadius: 16,
                        textAlign: 'center',
                        border: '1px solid rgba(255, 255, 255, 0.1)'
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                            style: {
                                color: '#FF7D7D',
                                marginBottom: 12
                            },
                            children: 'Unable to Load Plans'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            style: {
                                color: 'rgba(255, 255, 255, 0.7)',
                                marginBottom: 24
                            },
                            children: userMessage
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            style: {
                                display: 'flex',
                                gap: 12,
                                justifyContent: 'center'
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "btn-upgrade-pro",
                                    style: {
                                        width: 'auto',
                                        padding: '10px 24px'
                                    },
                                    onClick: ()=>refetchPlans(),
                                    children: 'Retry'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "btn-current-plan",
                                    style: {
                                        width: 'auto',
                                        padding: '10px 24px',
                                        cursor: 'pointer'
                                    },
                                    onClick: handleGoToSupport,
                                    children: 'Contact Support'
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    }
    // Only display "My Subscription Plan" if the user has or ever had a subscription
    const hasHadSubscription = Boolean(subscriptionState?.has_had_subscription) || subscriptionState?.status && subscriptionState.status !== 'inactive' || Boolean(subscriptionState?.has_used_trial) || Boolean(subscriptionState?.current_period_start) || isProCurrent;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "subscription-plans-page",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "plans-page-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-titles",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                                children: 'Subscription Plans'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                children: 'Choose the plan that fits how you coach and build programs.'
                            })
                        ]
                    }),
                    hasHadSubscription && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        className: "my-plan-nav-btn",
                        onClick: handleGoToMySubscription,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: 'My Subscription Plan'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _managePaymentMethodNextSvg.ReactComponent), {})
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "billing-cycle-toggle-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "billing-cycle-toggle",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: `cycle-btn ${activeCycle === 'monthly' ? 'active' : ''}`,
                            onClick: ()=>handleCycleChange('monthly'),
                            children: 'Monthly'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            className: `cycle-btn ${activeCycle === 'yearly' ? 'active' : ''}`,
                            onClick: ()=>handleCycleChange('yearly'),
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: 'Yearly'
                                }),
                                proYearPlan?.savings_percent ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "save-badge",
                                    children: `SAVE ${proYearPlan.savings_percent}%`
                                }) : null
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "plans-grid",
                children: [
                    basicPlan && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "plan-card basic-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "plan-card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "plan-title-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: basicPlan.name
                                            }),
                                            !isProCurrent && !isCancelled && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "current-plan-badge",
                                                children: 'Current plan'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "plan-price-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "price-amount",
                                                children: basicPlan.formatted_amount
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "price-period",
                                                children: basicPlan.billing_period
                                            })
                                        ]
                                    }),
                                    basicPlan.description && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "plan-subtitle",
                                        children: basicPlan.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "plan-features-list",
                                children: basicFeatures.map((feat)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "feature-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkSvg.ReactComponent), {
                                                className: "feature-check white-check"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: feat
                                            })
                                        ]
                                    }, feat))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "plan-card-footer",
                                children: [
                                    isCancelled ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "btn-current-plan",
                                                disabled: true,
                                                children: 'Downgrade Scheduled'
                                            }),
                                            accessUntilFormatted && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "plan-status-subtext",
                                                children: `Active from ${accessUntilFormatted}`
                                            })
                                        ]
                                    }) : isActivePro ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn-downgrade-to-basic",
                                        onClick: handleGoToCancel,
                                        children: 'Downgrade to Basic'
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn-current-plan",
                                        disabled: true,
                                        children: 'Current Plan'
                                    }),
                                    canStartTrial && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "trial-disclaimer-spacer"
                                    })
                                ]
                            })
                        ]
                    }),
                    proPlan && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "plan-card pro-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "plan-card-header",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "plan-title-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: proPlan.name
                                            }),
                                            isCancelled ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "cancelled-plan-badge",
                                                children: 'Cancelled'
                                            }) : proPlan.recommended || proPlan.tier_slug === 'pro' ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                className: "recommended-badge",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recommendedSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: 'Recommended'
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "plan-price-row",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "price-amount",
                                                children: proPlan.formatted_amount
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "price-period",
                                                children: proPlan.billing_period
                                            })
                                        ]
                                    }),
                                    activeCycle === 'monthly' && (canStartTrial ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "plan-subtitle",
                                        children: `${plansData?.currency_symbol || "\xa3"}0 for the first two weeks. ${proMonthPlan?.formatted_amount || proPlan.formatted_amount}/month after trial`
                                    }) : proPlan.description ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "plan-subtitle",
                                        children: proPlan.description
                                    }) : null),
                                    proPlan.tagline && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "plan-tagline",
                                        children: proPlan.tagline
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "plan-features-list",
                                children: proFeatures.map((feat)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "feature-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkSvg.ReactComponent), {
                                                className: "feature-check gold-check"
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: feat
                                            })
                                        ]
                                    }, feat))
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "plan-card-footer",
                                children: isCancelled ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: "btn-upgrade-pro btn-reactivate-plans-cta",
                                            onClick: handleGoToReactivate,
                                            children: 'Reactivate Pro'
                                        }),
                                        accessUntilFormatted && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "trial-disclaimer",
                                            children: `Pro access active until ${accessUntilFormatted}`
                                        })
                                    ]
                                }) : isPastDue ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: "btn-upgrade-pro",
                                            onClick: handleGoToMySubscription,
                                            children: 'Resolve Payment'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "trial-disclaimer error-text",
                                            children: 'Payment is past due. Please update payment method.'
                                        })
                                    ]
                                }) : isActivePro ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "button",
                                    className: "btn-current-plan",
                                    disabled: true,
                                    children: 'Current Plan'
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: "btn-upgrade-pro",
                                            onClick: handleSelectPro,
                                            children: canStartTrial && plansData?.trial_days ? `Start ${plansData.trial_days}-day free trial` : 'Upgrade to Pro'
                                        }),
                                        canStartTrial && proPlan && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "trial-disclaimer",
                                            children: `No charge today. ${proPlan.formatted_amount}${proPlan.billing_period} after trial. Cancel anytime before your first payment.`
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "trust-cards-grid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "trust-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "trust-icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancelAnytimeSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "trust-text",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                        children: 'Cancel anytime'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'No lock-in contracts. Cancel or change plans at any time.'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "trust-card clickable",
                        onClick: handleGoToSupport,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "trust-icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _contactSupportSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "trust-text",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                        children: 'Questions? Contact support'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: "We're here to help you."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "trust-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "trust-icon",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentsSecureSvg.ReactComponent), {})
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "trust-text",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                        children: 'Payments secure and encrypted'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'All plans include secure data'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","src/store/subscriptionStore":"rMPpj","src/api/subscription/useSubscriptionApi":"5YJAT","src/assets/images/onboarding-trainer/subscription-icons/trial/cancel-anytime.svg":"e2qOX","src/assets/images/onboarding-trainer/subscription-icons/trial/contact-support.svg":"4g5Ff","src/assets/images/onboarding-trainer/subscription-icons/trial/payments-secure.svg":"6cZRV","src/assets/images/onboarding-trainer/subscription-icons/trial/recommended.svg":"2dXTZ","src/assets/images/onboarding-trainer/subscription-icons/checkout/checkmark.svg":"9ELfB","src/assets/images/onboarding-trainer/subscription-icons/billing-history/manage-payment-method-next.svg":"kgObN","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"./SubscriptionPlans.scss":"fY4oB","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5YJAT":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "subscriptionKeys", ()=>subscriptionKeys);
// ==========================================
// QUERIES
// ==========================================
parcelHelpers.export(exports, "useEntitlementsQuery", ()=>useEntitlementsQuery);
parcelHelpers.export(exports, "useSubscriptionPlansQuery", ()=>useSubscriptionPlansQuery);
parcelHelpers.export(exports, "useTrialEligibilityQuery", ()=>useTrialEligibilityQuery);
parcelHelpers.export(exports, "useSubscriptionStateQuery", ()=>useSubscriptionStateQuery);
parcelHelpers.export(exports, "useBillingProfileQuery", ()=>useBillingProfileQuery);
parcelHelpers.export(exports, "usePaymentMethodsQuery", ()=>usePaymentMethodsQuery);
parcelHelpers.export(exports, "useBillingHistoryQuery", ()=>useBillingHistoryQuery);
parcelHelpers.export(exports, "useSupportConfigQuery", ()=>useSupportConfigQuery);
parcelHelpers.export(exports, "useStripeConfigQuery", ()=>useStripeConfigQuery);
parcelHelpers.export(exports, "useTermsOfServiceQuery", ()=>useTermsOfServiceQuery);
parcelHelpers.export(exports, "usePrivacyPolicyQuery", ()=>usePrivacyPolicyQuery);
// ==========================================
// MUTATIONS
// ==========================================
parcelHelpers.export(exports, "useCheckoutPreviewQuery", ()=>useCheckoutPreviewQuery);
parcelHelpers.export(exports, "usePreviewCheckoutMutation", ()=>usePreviewCheckoutMutation);
parcelHelpers.export(exports, "useValidatePromoCodeMutation", ()=>useValidatePromoCodeMutation);
parcelHelpers.export(exports, "useCheckoutSubscriptionMutation", ()=>useCheckoutSubscriptionMutation);
parcelHelpers.export(exports, "useSyncSubscriptionMutation", ()=>useSyncSubscriptionMutation);
parcelHelpers.export(exports, "useSaveBillingProfileMutation", ()=>useSaveBillingProfileMutation);
parcelHelpers.export(exports, "useValidateBillingProfileMutation", ()=>useValidateBillingProfileMutation);
parcelHelpers.export(exports, "useCreateSetupIntentMutation", ()=>useCreateSetupIntentMutation);
parcelHelpers.export(exports, "useSavePaymentMethodMutation", ()=>useSavePaymentMethodMutation);
parcelHelpers.export(exports, "useSetDefaultPaymentMethodMutation", ()=>useSetDefaultPaymentMethodMutation);
parcelHelpers.export(exports, "useReplacePaymentMethodMutation", ()=>useReplacePaymentMethodMutation);
parcelHelpers.export(exports, "useDeletePaymentMethodMutation", ()=>useDeletePaymentMethodMutation);
parcelHelpers.export(exports, "useCancelSubscriptionMutation", ()=>useCancelSubscriptionMutation);
parcelHelpers.export(exports, "useReactivateSubscriptionMutation", ()=>useReactivateSubscriptionMutation);
parcelHelpers.export(exports, "useIntervalSwitchMutation", ()=>useIntervalSwitchMutation);
parcelHelpers.export(exports, "useCancelScheduledIntervalSwitchMutation", ()=>useCancelScheduledIntervalSwitchMutation);
parcelHelpers.export(exports, "useRetryPastDuePaymentMutation", ()=>useRetryPastDuePaymentMutation);
parcelHelpers.export(exports, "useContactSupportMutation", ()=>useContactSupportMutation);
parcelHelpers.export(exports, "useDeleteSupportAttachmentMutation", ()=>useDeleteSupportAttachmentMutation);
parcelHelpers.export(exports, "useRecordLegalAcknowledgementMutation", ()=>useRecordLegalAcknowledgementMutation);
var _reactQuery = require("@tanstack/react-query");
var _subscriptionService = require("src/services/subscriptionService");
const subscriptionKeys = {
    all: [
        'subscription'
    ],
    entitlements: ()=>[
            ...subscriptionKeys.all,
            'entitlements'
        ],
    plans: (country)=>[
            ...subscriptionKeys.all,
            'plans',
            country
        ],
    eligibility: ()=>[
            ...subscriptionKeys.all,
            'eligibility'
        ],
    state: ()=>[
            ...subscriptionKeys.all,
            'state'
        ],
    billingProfile: ()=>[
            ...subscriptionKeys.all,
            'billing-profile'
        ],
    paymentMethods: ()=>[
            ...subscriptionKeys.all,
            'payment-methods'
        ],
    billingHistory: (params)=>params !== undefined ? [
            ...subscriptionKeys.all,
            'billing-history',
            params
        ] : [
            ...subscriptionKeys.all,
            'billing-history'
        ],
    supportConfig: ()=>[
            ...subscriptionKeys.all,
            'support-config'
        ],
    stripeConfig: ()=>[
            ...subscriptionKeys.all,
            'stripe-config'
        ]
};
function useEntitlementsQuery(enabled = true) {
    return (0, _reactQuery.useQuery)({
        queryKey: subscriptionKeys.entitlements(),
        queryFn: ()=>(0, _subscriptionService.subscriptionService).getEntitlements(),
        staleTime: 120000,
        enabled
    });
}
function useSubscriptionPlansQuery(country, enabled = true) {
    return (0, _reactQuery.useQuery)({
        queryKey: subscriptionKeys.plans(country),
        queryFn: ()=>(0, _subscriptionService.subscriptionService).getSubscriptionPlans(country),
        staleTime: 300000,
        // Plan buttons depend on the current subscription, which can change in
        // another screen or browser tab. Always refresh when this screen mounts.
        refetchOnMount: 'always',
        enabled
    });
}
function useTrialEligibilityQuery(enabled = true) {
    return (0, _reactQuery.useQuery)({
        queryKey: subscriptionKeys.eligibility(),
        queryFn: ()=>(0, _subscriptionService.subscriptionService).getTrialEligibility(),
        staleTime: 300000,
        enabled
    });
}
function useSubscriptionStateQuery(enabled = true) {
    return (0, _reactQuery.useQuery)({
        queryKey: subscriptionKeys.state(),
        queryFn: ()=>(0, _subscriptionService.subscriptionService).getSubscriptionState(),
        staleTime: 30000,
        enabled
    });
}
function useBillingProfileQuery(enabled = true) {
    return (0, _reactQuery.useQuery)({
        queryKey: subscriptionKeys.billingProfile(),
        queryFn: ()=>(0, _subscriptionService.subscriptionService).getBillingProfile(),
        staleTime: 300000,
        enabled
    });
}
function usePaymentMethodsQuery(enabled = true) {
    return (0, _reactQuery.useQuery)({
        queryKey: subscriptionKeys.paymentMethods(),
        queryFn: ()=>(0, _subscriptionService.subscriptionService).getPaymentMethods(),
        staleTime: 120000,
        enabled
    });
}
function useBillingHistoryQuery(params = {}, enabled = true) {
    return (0, _reactQuery.useQuery)({
        queryKey: subscriptionKeys.billingHistory(params),
        queryFn: ()=>(0, _subscriptionService.subscriptionService).getBillingHistory(params),
        staleTime: 60000,
        enabled
    });
}
function useSupportConfigQuery(enabled = true) {
    return (0, _reactQuery.useQuery)({
        queryKey: subscriptionKeys.supportConfig(),
        queryFn: ()=>(0, _subscriptionService.subscriptionService).getSupportConfig(),
        staleTime: 600000,
        enabled
    });
}
function useStripeConfigQuery(enabled = true) {
    return (0, _reactQuery.useQuery)({
        queryKey: subscriptionKeys.stripeConfig(),
        queryFn: ()=>(0, _subscriptionService.subscriptionService).getStripeConfig(),
        staleTime: 3600000,
        enabled
    });
}
function useTermsOfServiceQuery(enabled = true) {
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'subscription',
            'legal',
            'terms-of-service'
        ],
        queryFn: ()=>(0, _subscriptionService.subscriptionService).getTermsOfService(),
        staleTime: 3600000,
        enabled
    });
}
function usePrivacyPolicyQuery(enabled = true) {
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'subscription',
            'legal',
            'privacy-policy'
        ],
        queryFn: ()=>(0, _subscriptionService.subscriptionService).getPrivacyPolicy(),
        staleTime: 3600000,
        enabled
    });
}
function useCheckoutPreviewQuery(params) {
    return (0, _reactQuery.useQuery)({
        queryKey: [
            'subscription',
            'checkout',
            'preview',
            params.tier_slug,
            params.interval,
            params.price_id,
            params.promo_code,
            params.country,
            params.billing_profile_version,
            params.trial_selection
        ],
        queryFn: ()=>(0, _subscriptionService.subscriptionService).previewCheckout({
                tier_slug: params.tier_slug,
                interval: params.interval,
                price_id: params.price_id,
                promo_code: params.promo_code,
                country: params.country,
                trial_selection: params.trial_selection
            }),
        enabled: params.enabled ?? true,
        staleTime: 120000
    });
}
function usePreviewCheckoutMutation() {
    return (0, _reactQuery.useMutation)({
        mutationFn: (payload)=>(0, _subscriptionService.subscriptionService).previewCheckout(payload)
    });
}
function useValidatePromoCodeMutation() {
    return (0, _reactQuery.useMutation)({
        mutationFn: (payload)=>(0, _subscriptionService.subscriptionService).validatePromoCode(payload)
    });
}
function useCheckoutSubscriptionMutation() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: (payload)=>(0, _subscriptionService.subscriptionService).checkoutSubscription(payload),
        onSuccess: (_data)=>{
            // Invalidate subscription queries
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.state()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.entitlements()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.plans()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.billingHistory()
            });
        }
    });
}
function useSyncSubscriptionMutation() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: ()=>(0, _subscriptionService.subscriptionService).syncSubscription(),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.state()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.entitlements()
            });
        }
    });
}
function useSaveBillingProfileMutation() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: (profile)=>(0, _subscriptionService.subscriptionService).saveBillingProfile(profile),
        onSuccess: (savedData)=>{
            // Synchronously hydrate query data to prevent stale race condition
            queryClient.setQueryData(subscriptionKeys.billingProfile(), savedData);
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.plans()
            });
            queryClient.invalidateQueries({
                queryKey: [
                    'subscription',
                    'checkout',
                    'preview'
                ]
            });
        }
    });
}
function useValidateBillingProfileMutation() {
    return (0, _reactQuery.useMutation)({
        mutationFn: (profile)=>(0, _subscriptionService.subscriptionService).validateBillingProfile(profile)
    });
}
function useCreateSetupIntentMutation() {
    return (0, _reactQuery.useMutation)({
        mutationFn: ()=>(0, _subscriptionService.subscriptionService).createSetupIntent()
    });
}
function useSavePaymentMethodMutation() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: (payload)=>(0, _subscriptionService.subscriptionService).savePaymentMethod(payload),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.paymentMethods()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.state()
            });
        }
    });
}
function useSetDefaultPaymentMethodMutation() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: (pmId)=>(0, _subscriptionService.subscriptionService).setDefaultPaymentMethod(pmId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.paymentMethods()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.state()
            });
        }
    });
}
function useReplacePaymentMethodMutation() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: (payload)=>(0, _subscriptionService.subscriptionService).replacePaymentMethod(payload),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.paymentMethods()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.state()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.billingHistory()
            });
        }
    });
}
function useDeletePaymentMethodMutation() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: (pmId)=>(0, _subscriptionService.subscriptionService).deletePaymentMethod(pmId),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.paymentMethods()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.state()
            });
        }
    });
}
function useCancelSubscriptionMutation() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: ({ reason, feedback })=>(0, _subscriptionService.subscriptionService).cancelSubscription(reason, feedback),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.state()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.entitlements()
            });
        }
    });
}
function useReactivateSubscriptionMutation() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: ()=>(0, _subscriptionService.subscriptionService).reactivateSubscription(),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.state()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.entitlements()
            });
        }
    });
}
function useIntervalSwitchMutation() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: (targetInterval)=>(0, _subscriptionService.subscriptionService).switchInterval(targetInterval),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.state()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.plans()
            });
        }
    });
}
function useCancelScheduledIntervalSwitchMutation() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: ()=>(0, _subscriptionService.subscriptionService).cancelScheduledIntervalSwitch(),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.state()
            });
        }
    });
}
function useRetryPastDuePaymentMutation() {
    const queryClient = (0, _reactQuery.useQueryClient)();
    return (0, _reactQuery.useMutation)({
        mutationFn: ()=>(0, _subscriptionService.subscriptionService).retryPastDuePayment(),
        onSuccess: ()=>{
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.state()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.entitlements()
            });
            queryClient.invalidateQueries({
                queryKey: subscriptionKeys.billingHistory()
            });
        }
    });
}
function useContactSupportMutation() {
    return (0, _reactQuery.useMutation)({
        mutationFn: (payload)=>(0, _subscriptionService.subscriptionService).contactSupport(payload)
    });
}
function useDeleteSupportAttachmentMutation() {
    return (0, _reactQuery.useMutation)({
        mutationFn: (storagePath)=>(0, _subscriptionService.subscriptionService).deleteSupportAttachment(storagePath)
    });
}
function useRecordLegalAcknowledgementMutation() {
    return (0, _reactQuery.useMutation)({
        mutationFn: (payload)=>(0, _subscriptionService.subscriptionService).recordLegalAcknowledgement(payload?.termsVersion, payload?.privacyVersion)
    });
}

},{"@tanstack/react-query":[["useMutation","ehKs4"],["useQuery","lWWNx"],["useQueryClient","97Oud"]],"src/services/subscriptionService":"7NbXi","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"e2qOX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCancelAnytime);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCancelAnytime = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 35,
        fill: "none",
        viewBox: "0 0 30 35",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "square",
                strokeWidth: 3,
                d: "M1.5 6.314V17.34C1.5 28.364 15 33.09 15 33.09s13.5-4.725 13.5-15.75V6.314L15 1.59z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#E5E5E5",
                strokeLinecap: "square",
                strokeWidth: 3,
                d: "m9.26 16.099 4.24 4.241 8.486-8.485"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4g5Ff":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgContactSupport);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgContactSupport = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        viewBox: "0 0 30 30",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M15 0C6.729 0 0 6.729 0 15v6.215C0 22.75 1.346 24 3 24h1.5A1.5 1.5 0 0 0 6 22.5v-7.714a1.5 1.5 0 0 0-1.5-1.5H3.138C3.972 7.48 8.967 3 15 3s11.028 4.48 11.862 10.286H25.5a1.5 1.5 0 0 0-1.5 1.5V24c0 1.654-1.346 3-3 3h-3v-1.5h-6V30h9c3.309 0 6-2.691 6-6 1.654 0 3-1.25 3-2.785V15c0-8.271-6.729-15-15-15"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6cZRV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPaymentsSecure);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPaymentsSecure = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 27,
        height: 33,
        fill: "none",
        viewBox: "0 0 27 33",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M13.5 0a9 9 0 0 1 8.994 8.663L22.5 9H24a3 3 0 0 1 2.992 2.775L27 12v15a3 3 0 0 1-2.775 2.992L24 30H3a3 3 0 0 1-2.992-2.775L0 27V12a3 3 0 0 1 2.775-2.992L3 9h1.5a9 9 0 0 1 9-9M24 12H3v15h21zm-10.5 3a3 3 0 0 1 1.701 5.47l-.201.128V22.5a1.5 1.5 0 0 1-2.99.175L12 22.5v-1.902A3 3 0 0 1 13.5 15m0-12a6 6 0 0 0-6 6h12a6 6 0 0 0-6-6"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2dXTZ":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgRecommended);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRecommended = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 13,
        height: 13,
        fill: "none",
        viewBox: "0 0 13 13",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FFA100",
            d: "M6.42 10.275 3.309 12.15a.68.68 0 0 1-.431.112.73.73 0 0 1-.394-.15.9.9 0 0 1-.262-.327.66.66 0 0 1-.038-.441L3.008 7.8.252 5.419a.7.7 0 0 1-.234-.385.8.8 0 0 1 .253-.759.78.78 0 0 1 .412-.169l3.638-.318L5.727.45a.67.67 0 0 1 .29-.337A.8.8 0 0 1 6.422 0q.205 0 .402.113a.67.67 0 0 1 .291.337l1.407 3.338 3.637.318a.8.8 0 0 1 .413.169.8.8 0 0 1 .253.76.7.7 0 0 1-.235.384L9.833 7.8l.825 3.544a.66.66 0 0 1-.037.44.9.9 0 0 1-.263.329.73.73 0 0 1-.394.15.68.68 0 0 1-.43-.113z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9ELfB":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCheckmark);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCheckmark = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 9,
        fill: "none",
        viewBox: "0 0 12 9",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#FFA100",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "M11.333.667 4 8 .667 4.667"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fY4oB":[function() {},{}],"hKBKI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Checkout", ()=>Checkout);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _stripeJs = require("@stripe/stripe-js");
var _subscriptionStore = require("src/store/subscriptionStore");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _userChevronLeftSvg = require("src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg");
var _recommendedSvg = require("src/assets/images/onboarding-trainer/subscription-icons/trial/recommended.svg");
var _checkmarkSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/checkmark.svg");
var _securePaymentLockSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/secure-payment-lock.svg");
var _14DayFreeTrialSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/14-day-free-trial.svg");
var _billingInfoEditSvg = require("src/assets/images/onboarding-trainer/subscription-icons/reactivate-pro/billing-info-edit.svg");
var _addButtonSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/add-button.svg");
var _cardBrandLogo = require("../components/CardBrandLogo");
var _cardUtils = require("src/utils/cardUtils");
var _billingInfoModal = require("../modals/BillingInfoModal");
var _paymentMethodModal = require("../modals/PaymentMethodModal");
var _selectPaymentMethodModal = require("../modals/SelectPaymentMethodModal");
var _paymentConfirmedModal = require("../modals/PaymentConfirmedModal");
var _paymentFailedModal = require("../modals/PaymentFailedModal");
var _appAlert = require("src/utils/appAlert");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _checkoutScss = require("./Checkout.scss");
const Checkout = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const queryFail = searchParams.get('fail');
    const { billingCycle, setStatus, billingInfo, paymentMethods, appliedPromo, applyPromoCode, removePromoCode } = (0, _subscriptionStore.useSubscriptionStore)();
    // API Queries & Mutations
    const { data: serverBillingProfile, refetch: refetchBillingProfile } = (0, _useSubscriptionApi.useBillingProfileQuery)();
    const { data: serverPaymentMethods, refetch: refetchPaymentMethods } = (0, _useSubscriptionApi.usePaymentMethodsQuery)();
    const { data: serverEligibility } = (0, _useSubscriptionApi.useTrialEligibilityQuery)();
    const setDefaultPaymentMutation = (0, _useSubscriptionApi.useSetDefaultPaymentMethodMutation)();
    const profileBillingCountry = serverBillingProfile?.country || billingInfo?.country;
    const { data: plansData, isLoading: isPlansLoading, isFetching: isPlansFetching, isError: isPlansError } = (0, _useSubscriptionApi.useSubscriptionPlansQuery)(profileBillingCountry);
    const billingCountry = profileBillingCountry || plansData?.country;
    const validatePromoMutation = (0, _useSubscriptionApi.useValidatePromoCodeMutation)();
    const checkoutMutation = (0, _useSubscriptionApi.useCheckoutSubscriptionMutation)();
    const syncSubscriptionMutation = (0, _useSubscriptionApi.useSyncSubscriptionMutation)();
    const recordLegalAck = (0, _useSubscriptionApi.useRecordLegalAcknowledgementMutation)();
    const { data: stripeConfig } = (0, _useSubscriptionApi.useStripeConfigQuery)(true);
    const stripePromise = (0, _react.useMemo)(()=>stripeConfig?.publishable_key ? (0, _stripeJs.loadStripe)(stripeConfig.publishable_key) : null, [
        stripeConfig?.publishable_key
    ]);
    const targetInterval = billingCycle === 'yearly' ? 'year' : 'month';
    const proPlan = plansData?.plans?.find((p)=>p.tier_slug === 'pro' && p.interval === targetInterval) || plansData?.plans?.find((p)=>p.tier_slug === 'pro') || plansData?.plans?.[0];
    const featuresList = proPlan?.features?.length ? proPlan.features : [];
    // Server-authoritative trial state
    const isTrial = serverEligibility?.trial_eligible ?? false;
    const { data: previewData, isLoading: isPreviewLoading, isFetching: isPreviewFetching, isError: isPreviewError, error: previewError, refetch: refetchPreview } = (0, _useSubscriptionApi.useCheckoutPreviewQuery)({
        tier_slug: 'pro',
        interval: targetInterval,
        price_id: proPlan?.price_id,
        promo_code: appliedPromo?.code,
        country: billingCountry,
        trial_selection: isTrial,
        // Do not send an incomplete preview request. The plans response resolves the
        // backend-selected country when no billing profile exists yet.
        enabled: Boolean(proPlan?.price_id && billingCountry)
    });
    const isSummaryLoading = isPlansLoading || isPlansFetching || isPreviewLoading || isPreviewFetching || !isPlansError && (!proPlan?.price_id || !billingCountry);
    const effectiveTrial = previewData?.is_trial ?? isTrial;
    const trialDays = previewData?.trial_days ?? serverEligibility?.trial_days ?? 0;
    const trialEndsDateFormatted = previewData?.formatted_trial_ends_at;
    // Modals
    const [isBillingModalOpen, setIsBillingModalOpen] = (0, _react.useState)(false);
    const [isPaymentModalOpen, setIsPaymentModalOpen] = (0, _react.useState)(false);
    const [isSelectCardModalOpen, setIsSelectCardModalOpen] = (0, _react.useState)(false);
    const [isConfirmedModalOpen, setIsConfirmedModalOpen] = (0, _react.useState)(false);
    const [isFailedModalOpen, setIsFailedModalOpen] = (0, _react.useState)(false);
    const [failedError, setFailedError] = (0, _react.useState)({});
    // Form states
    const [promoInput, setPromoInput] = (0, _react.useState)('');
    const [promoError, setPromoError] = (0, _react.useState)('');
    const [isApplyingPromo, setIsApplyingPromo] = (0, _react.useState)(false);
    const [isAgreed, setIsAgreed] = (0, _react.useState)(false);
    const [agreedError, setAgreedError] = (0, _react.useState)(false);
    const handleApplyPromo = ()=>{
        const trimmed = promoInput.trim();
        if (!trimmed || isApplyingPromo) {
            if (!trimmed) setPromoError('Please enter a promo code');
            return;
        }
        if (trimmed.length < 3) {
            setPromoError('Promo code must be at least 3 characters');
            return;
        }
        if (trimmed.length > 30) {
            setPromoError('Promo code cannot exceed 30 characters');
            return;
        }
        setPromoError('');
        setIsApplyingPromo(true);
        validatePromoMutation.mutate({
            code: trimmed,
            tier_slug: 'pro',
            interval: targetInterval,
            price_id: proPlan?.price_id,
            country: billingCountry
        }, {
            onSuccess: (data)=>{
                setIsApplyingPromo(false);
                const promoCode = data.applied_promo?.code || data.code || trimmed;
                const promoDiscount = data.applied_promo?.discount_percent ?? data.discount_percent ?? 0;
                applyPromoCode(promoCode, promoDiscount);
                (0, _appAlert.toast).success(data.message || `Promo code ${promoCode} applied!`);
                setPromoInput('');
                setPromoError('');
            },
            onError: (err)=>{
                setIsApplyingPromo(false);
                setPromoError(err.userMessage || 'Invalid promo code');
            }
        });
    };
    const [isConfirmingPayment, setIsConfirmingPayment] = (0, _react.useState)(false);
    const isSubmitting = checkoutMutation.isPending || isConfirmingPayment;
    const showPaymentFailure = (error)=>{
        const message = error?.userMessage || error?.message || 'Payment could not be completed.';
        setFailedError({
            code: error?.code || 'ERR_PAYMENT_FAILED',
            subCode: error?.subCode || error?.sub_code,
            title: error?.errorTitle || error?.error_title,
            message
        });
        (0, _appAlert.toast).error(message);
        setIsFailedModalOpen(true);
    };
    const completeScaChallenge = async (clientSecret)=>{
        setIsConfirmingPayment(true);
        try {
            const stripe = await stripePromise;
            if (!stripe) throw new Error('Secure payment confirmation is unavailable. Please try again.');
            const confirmation = await stripe.confirmCardPayment(clientSecret);
            if (confirmation.error) throw confirmation.error;
            const paymentIntentStatus = confirmation.paymentIntent?.status;
            if (!confirmation.paymentIntent || !paymentIntentStatus || ![
                'succeeded',
                'processing'
            ].includes(paymentIntentStatus)) throw new Error('Payment authentication was not completed. Please try again.');
            let synced = await syncSubscriptionMutation.mutateAsync();
            if (![
                'active',
                'trialing',
                'processing'
            ].includes(synced.status)) {
                // Stripe may update the subscription a moment after the PaymentIntent.
                await new Promise((resolve)=>window.setTimeout(resolve, 300));
                synced = await syncSubscriptionMutation.mutateAsync();
            }
            if (synced.status === 'active' || synced.status === 'trialing') {
                recordLegalAck.mutate();
                removePromoCode();
                setStatus('active');
                setIsConfirmedModalOpen(true);
            } else if (synced.status === 'processing' || paymentIntentStatus === 'processing') {
                removePromoCode();
                (0, _appAlert.toast).success('Your payment is processing.');
            } else throw new Error('Payment was authenticated, but the subscription is not active yet.');
        } catch (error) {
            showPaymentFailure(error);
        } finally{
            setIsConfirmingPayment(false);
        }
    };
    const handleConfirmCheckout = async ()=>{
        if (isSubmitting) return;
        const activeBilling = activeBillingInfo || serverBillingProfile || billingInfo;
        if (!activeBilling?.fullName && !activeBilling?.companyName) {
            (0, _appAlert.toast).error('Please add your billing information before continuing.');
            setIsBillingModalOpen(true);
            return;
        }
        const cards = activeCards.length > 0 ? activeCards : serverPaymentMethods?.payment_methods || paymentMethods;
        if (cards.length === 0) {
            (0, _appAlert.toast).error('Please add a payment method before continuing.');
            setIsPaymentModalOpen(true);
            return;
        }
        if (!isAgreed) {
            setAgreedError(true);
            (0, _appAlert.toast).error('Please agree to the Terms of Service and Privacy Policy.');
            return;
        }
        setAgreedError(false);
        const shouldFail = queryFail === 'true' || searchParams.get('failed') === 'true' || searchParams.get('payment') === 'failed';
        if (shouldFail) {
            setFailedError({
                code: 'ERR_PAYMENT_FAILED',
                message: 'Payment simulation failed. Please try another card.'
            });
            setIsFailedModalOpen(true);
            return;
        }
        const defaultCard = cards.find((c)=>c.isDefault || c.is_default) || cards[0];
        checkoutMutation.mutate({
            tier_slug: 'pro',
            interval: targetInterval,
            price_id: previewData?.price_id || proPlan?.price_id,
            payment_method_id: defaultCard?.id,
            promo_code: appliedPromo?.code,
            trial_choice: isTrial,
            trial_selection: isTrial,
            quote_id: previewData?.quote_id,
            country: billingCountry
        }, {
            onSuccess: (data)=>{
                setIsFailedModalOpen(false);
                recordLegalAck.mutate();
                if (data.status === 'trialing' || data.status === 'active') {
                    removePromoCode();
                    setStatus('active');
                    setIsConfirmedModalOpen(true);
                } else if (data.status === 'processing') {
                    removePromoCode();
                    (0, _appAlert.toast).success('Your payment is processing.');
                    setIsConfirmedModalOpen(true);
                } else {
                    setFailedError({
                        code: 'ERR_PAYMENT_FAILED',
                        message: 'Payment could not be completed.'
                    });
                    setIsFailedModalOpen(true);
                }
            },
            onError: (err)=>{
                const clientSecret = err?.fieldErrors?.payment_intent_client_secret;
                if (err?.code === 'ERR_PAYMENT_REQUIRES_ACTION' && clientSecret) {
                    setIsFailedModalOpen(false);
                    completeScaChallenge(clientSecret);
                    return;
                }
                showPaymentFailure(err);
            }
        });
    };
    const handleBack = ()=>{
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/onboarding-trainer/dashboard/subscription/plans');
    };
    const handleNavigateLegal = (path)=>{
        navigate(`/onboarding-trainer/dashboard/subscription/${path}`);
    };
    const activeBillingInfo = (0, _react.useMemo)(()=>{
        if (serverBillingProfile && (serverBillingProfile.fullName || serverBillingProfile.companyName || serverBillingProfile.addressLine1)) return {
            billingType: serverBillingProfile.billingType || billingInfo?.billingType || 'individual',
            fullName: serverBillingProfile.fullName || '',
            companyName: serverBillingProfile.companyName || '',
            billingEmail: serverBillingProfile.billingEmail || '',
            country: serverBillingProfile.country || billingInfo?.country || '',
            stateRegion: serverBillingProfile.stateRegion || '',
            addressLine1: serverBillingProfile.addressLine1 || '',
            addressLine2: serverBillingProfile.addressLine2 || '',
            city: serverBillingProfile.city || '',
            postcode: serverBillingProfile.postcode || '',
            companyRegistrationNumber: serverBillingProfile.companyRegistrationNumber || '',
            taxVatNumber: serverBillingProfile.taxVatNumber || ''
        };
        if (billingInfo?.fullName || billingInfo?.companyName || billingInfo?.addressLine1) return billingInfo;
        return null;
    }, [
        serverBillingProfile,
        billingInfo
    ]);
    const hasBillingInfo = Boolean(activeBillingInfo?.fullName || activeBillingInfo?.companyName || activeBillingInfo?.addressLine1);
    const activeCards = (0, _react.useMemo)(()=>{
        const serverCards = serverPaymentMethods?.payment_methods;
        const rawCards = serverCards && serverCards.length > 0 ? serverCards : paymentMethods;
        if (!rawCards || rawCards.length === 0) return [];
        const defaultId = serverPaymentMethods?.default_payment_method_id;
        // Determine the single authoritative default card id:
        // 1. Explicit default_payment_method_id from server
        // 2. Or the first card that has is_default / isDefault set
        // 3. Or fallback to the first card in the list
        let singleDefaultId = defaultId;
        if (!singleDefaultId) {
            const foundDefault = rawCards.find((c)=>c.is_default || c.isDefault);
            singleDefaultId = foundDefault ? foundDefault.id : rawCards[0]?.id;
        }
        const mapped = rawCards.map((c)=>{
            const isDefault = Boolean(singleDefaultId && c.id === singleDefaultId);
            const expiry = c.expiry || (c.exp_month && c.exp_year ? `${String(c.exp_month).padStart(2, '0')} / ${String(c.exp_year).slice(-2)}` : '');
            return {
                id: c.id,
                brand: c.brand?.toLowerCase() || 'visa',
                last4: c.last4,
                expiry,
                cardholderName: c.cardholder_name || c.cardholderName || '',
                isDefault
            };
        });
        return mapped.sort((a, b)=>(b.isDefault ? 1 : 0) - (a.isDefault ? 1 : 0));
    }, [
        serverPaymentMethods,
        paymentMethods
    ]);
    const [settingDefaultCardId, setSettingDefaultCardId] = (0, _react.useState)(null);
    const handleSelectCard = (cardId)=>{
        if (settingDefaultCardId) return;
        if (serverPaymentMethods?.payment_methods?.some((c)=>c.id === cardId)) {
            setSettingDefaultCardId(cardId);
            setDefaultPaymentMutation.mutate(cardId, {
                onSuccess: ()=>{
                    (0, _subscriptionStore.useSubscriptionStore).getState().setDefaultPaymentMethod(cardId);
                    (0, _appAlert.toast).success('Default payment method updated.');
                    refetchPaymentMethods();
                },
                onError: ()=>{
                    (0, _appAlert.toast).error('Failed to update default card. Please try again.');
                },
                onSettled: ()=>{
                    setSettingDefaultCardId(null);
                }
            });
        } else (0, _subscriptionStore.useSubscriptionStore).getState().setDefaultPaymentMethod(cardId);
    };
    if (isSummaryLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "checkout-page-container",
        style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '60vh'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
            indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                style: {
                    fontSize: 32,
                    color: '#E2F163'
                },
                spin: true
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "checkout-page-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "checkout-page-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        className: "checkout-back-btn",
                        onClick: handleBack,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userChevronLeftSvg.ReactComponent), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: 'Checkout'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "checkout-header-subtitle",
                        children: "You're one step away from unlocking Pro."
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "checkout-content-grid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "checkout-left-col",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "checkout-card billing-summary-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: 'Billing Summary'
                                    }),
                                    isPreviewError || !previewData ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "summary-error-state",
                                        style: {
                                            padding: '24px 0',
                                            textAlign: 'center'
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                style: {
                                                    color: '#ff6b6b',
                                                    fontSize: 13,
                                                    marginBottom: 12
                                                },
                                                children: previewError?.userMessage || 'Unable to calculate checkout summary.'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "btn-retry-preview",
                                                onClick: ()=>refetchPreview(),
                                                style: {
                                                    background: 'transparent',
                                                    border: '1px solid #e2f163',
                                                    color: '#e2f163',
                                                    borderRadius: 4,
                                                    padding: '6px 16px',
                                                    fontSize: 12,
                                                    cursor: 'pointer'
                                                },
                                                children: 'Retry'
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "summary-rows",
                                        children: effectiveTrial ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row due-today-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: 'Due today'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value bold-val",
                                                            children: previewData.formatted_due_today
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: 'Billing Cycle'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value capitalize",
                                                            children: billingCycle
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: 'Trial ends'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value",
                                                            children: trialEndsDateFormatted
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "summary-divider"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: proPlan?.name || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value",
                                                            children: previewData.formatted_discount ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "strikethrough",
                                                                        children: previewData.formatted_subtotal
                                                                    }),
                                                                    ' ',
                                                                    previewData.formatted_discounted_subtotal
                                                                ]
                                                            }) : previewData.formatted_subtotal
                                                        })
                                                    ]
                                                }),
                                                previewData.formatted_discount && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row discount-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: previewData.promotion_percentage ? `Discount (${previewData.promotion_percentage}% off)` : 'Discount'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "row-value discount-val",
                                                            children: [
                                                                "-",
                                                                previewData.formatted_discount
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: `${previewData.tax_display_name || 'Tax'} (${previewData.tax_rate_percent}%)`
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value",
                                                            children: previewData.formatted_tax
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row total-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: 'First payment after trial'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value highlight-val",
                                                            children: previewData.formatted_first_payment_after_trial || previewData.formatted_total
                                                        })
                                                    ]
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: proPlan?.name || "\u2014"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value",
                                                            children: previewData.formatted_discount ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "strikethrough",
                                                                        children: previewData.formatted_subtotal
                                                                    }),
                                                                    ' ',
                                                                    previewData.formatted_discounted_subtotal
                                                                ]
                                                            }) : previewData.formatted_subtotal
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: 'Billing Cycle'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value capitalize",
                                                            children: billingCycle
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "summary-divider"
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: 'Subtotal'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value",
                                                            children: previewData.formatted_subtotal
                                                        })
                                                    ]
                                                }),
                                                previewData.formatted_discount && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row discount-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: previewData.promotion_percentage ? `Discount (${previewData.promotion_percentage}% off)` : 'Discount'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "row-value discount-val",
                                                            children: [
                                                                "-",
                                                                previewData.formatted_discount
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: previewData.is_tax_inclusive ? `${previewData.tax_display_name || 'Tax'} (${previewData.tax_rate_percent}%)` : `${previewData.tax_display_name || 'Tax'} (${previewData.tax_rate_percent}%)`
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value",
                                                            children: previewData.formatted_tax
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row total-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: 'Total'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value highlight-val",
                                                            children: previewData.formatted_total
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "promo-code-section",
                                        children: appliedPromo && previewData?.applied_promotion_code ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "applied-promo-badge",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: previewData.promotion_percentage ? `Promo applied: ${previewData.applied_promotion_code} (-${previewData.promotion_percentage}%)` : `Promo applied: ${previewData.applied_promotion_code} (-${previewData.formatted_promotion_discount_amount || previewData.formatted_discount || ''})`
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    onClick: removePromoCode,
                                                    "aria-label": "Remove promo code",
                                                    children: "\u2715"
                                                })
                                            ]
                                        }) : appliedPromo ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "applied-promo-badge",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: `Promo applied: ${appliedPromo.code}`
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    onClick: removePromoCode,
                                                    "aria-label": "Remove promo code",
                                                    children: "\u2715"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    htmlFor: "promo-input",
                                                    children: 'Add promo code'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                                    className: "promo-input-row",
                                                    onSubmit: (e)=>{
                                                        e.preventDefault();
                                                        handleApplyPromo();
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "promo-input-field-wrap",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                    id: "promo-input",
                                                                    type: "text",
                                                                    placeholder: "Code",
                                                                    maxLength: 30,
                                                                    className: promoError ? 'has-error' : '',
                                                                    value: promoInput,
                                                                    onChange: (e)=>{
                                                                        setPromoInput(e.target.value.toUpperCase());
                                                                        if (promoError) setPromoError('');
                                                                    },
                                                                    onBlur: (e)=>setPromoInput(e.target.value.trim()),
                                                                    autoComplete: "off"
                                                                }),
                                                                promoInput.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    type: "button",
                                                                    className: "clear-promo-btn",
                                                                    onClick: ()=>{
                                                                        setPromoInput('');
                                                                        if (promoError) setPromoError('');
                                                                    },
                                                                    "aria-label": "Clear promo code",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                        width: "14",
                                                                        height: "14",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "2",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                                x1: "18",
                                                                                y1: "6",
                                                                                x2: "6",
                                                                                y2: "18"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                                x1: "6",
                                                                                y1: "6",
                                                                                x2: "18",
                                                                                y2: "18"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            type: "submit",
                                                            className: "btn-add-promo",
                                                            disabled: isApplyingPromo,
                                                            children: isApplyingPromo ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                                    style: {
                                                                        fontSize: 13,
                                                                        color: '#060723'
                                                                    },
                                                                    spin: true
                                                                })
                                                            }) : 'Add'
                                                        })
                                                    ]
                                                }),
                                                promoError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "promo-error-text",
                                                    children: promoError
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "checkout-card billing-info-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "card-header-with-action",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: 'Billing Information'
                                            }),
                                            hasBillingInfo ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "icon-action-btn",
                                                onClick: ()=>setIsBillingModalOpen(true),
                                                title: "Edit billing info",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _billingInfoEditSvg.ReactComponent), {})
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "btn-add-mini desktop-only-add",
                                                onClick: ()=>setIsBillingModalOpen(true),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: 'Add'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    hasBillingInfo && activeBillingInfo ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-key-value-list",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "kv-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "kv-key",
                                                        children: activeBillingInfo.billingType === 'business' ? 'Company Name' : 'Full Name'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "kv-val",
                                                        children: activeBillingInfo.fullName || activeBillingInfo.companyName
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "kv-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "kv-key",
                                                        children: 'Billing Email'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "kv-val",
                                                        children: activeBillingInfo.billingEmail
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "kv-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "kv-key",
                                                        children: 'Address'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "kv-val",
                                                        children: [
                                                            activeBillingInfo.addressLine1,
                                                            activeBillingInfo.city ? `, ${activeBillingInfo.city}` : '',
                                                            activeBillingInfo.postcode ? ` ${activeBillingInfo.postcode}` : ''
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "card-empty-description",
                                                children: 'These details will appear on your invoices.'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "btn-add-full mobile-only-add",
                                                onClick: ()=>setIsBillingModalOpen(true),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: 'Add'
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "checkout-card payment-method-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "card-header-with-action",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: 'Payment Method'
                                            }),
                                            activeCards.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "btn-add-mini",
                                                onClick: ()=>setIsPaymentModalOpen(true),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: 'Add'
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "btn-add-mini desktop-only-add",
                                                onClick: ()=>setIsPaymentModalOpen(true),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: 'Add'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    activeCards.length > 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "saved-cards-list",
                                        children: [
                                            activeCards.slice(0, 3).map((card)=>{
                                                const isSettingThisCard = settingDefaultCardId === card.id;
                                                const isBusy = Boolean(settingDefaultCardId);
                                                return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: `payment-card-row ${card.isDefault ? 'selected-card' : ''} ${isSettingThisCard ? 'is-loading' : ''} ${isBusy ? 'disabled' : ''}`,
                                                    onClick: ()=>{
                                                        if (isBusy) return;
                                                        handleSelectCard(card.id);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                            className: "card-brand-wrap",
                                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                                                brand: card.brand
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "card-info-text",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "card-title-text",
                                                                    children: (0, _cardUtils.getCardBrandDisplayName)(card.brand)
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "card-mask",
                                                                    children: (0, _cardUtils.formatMaskedCardNumber)(card.brand, card.last4)
                                                                })
                                                            ]
                                                        }),
                                                        isSettingThisCard ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: "setting-default-indicator",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                                    indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                                        style: {
                                                                            fontSize: 13,
                                                                            color: '#ffa100'
                                                                        },
                                                                        spin: true
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: 'Updating...'
                                                                })
                                                            ]
                                                        }) : card.isDefault ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "default-pill",
                                                            children: 'Default'
                                                        }) : null
                                                    ]
                                                }, card.id);
                                            }),
                                            activeCards.length > 3 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "btn-view-more-cards",
                                                onClick: ()=>setIsSelectCardModalOpen(true),
                                                children: `+${activeCards.length - 3} more cards`
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "card-empty-description",
                                                children: "A payment method is required to start the trial. You won\u2019t be charged today."
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "btn-add-full mobile-only-add",
                                                onClick: ()=>setIsPaymentModalOpen(true),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: 'Add'
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "checkout-right-col",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "pro-plan-review-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "pro-card-header",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "title-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                        children: proPlan?.name
                                                    }),
                                                    (proPlan?.recommended || proPlan?.tier_slug === 'pro') && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "recommended-badge",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _recommendedSvg.ReactComponent), {}),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: 'Recommended'
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "price-row",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "price-amount",
                                                        children: proPlan?.formatted_amount
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "price-period",
                                                        children: proPlan?.billing_period
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "price-subtext",
                                                children: effectiveTrial && proPlan?.trial_information?.text ? proPlan.trial_information.text : proPlan?.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "features-list",
                                        children: featuresList.map((feat)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "feature-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkSvg.ReactComponent), {
                                                        className: "gold-check"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: feat
                                                    })
                                                ]
                                            }, feat))
                                    }),
                                    effectiveTrial && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "trial-callout-box",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "callout-icon",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _14DayFreeTrialSvg.ReactComponent), {})
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "callout-text",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                        children: `${trialDays}-day free trial included`
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        children: `No charge today. After the trial, you\u{2019}ll be charged ${previewData?.formatted_first_payment_after_trial || "\u2014"} unless you cancel before the trial ends.`
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "security-notice",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "security-icon-wrap",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _securePaymentLockSvg.ReactComponent), {})
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: 'Your payment information is secure and encrypted.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                className: `terms-agreement-checkbox ${agreedError ? 'has-error' : ''}`,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "checkbox",
                                        checked: isAgreed,
                                        onChange: (e)=>{
                                            setIsAgreed(e.target.checked);
                                            if (e.target.checked) setAgreedError(false);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            'I agree to the ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "legal-inline-link",
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    handleNavigateLegal('terms-of-service');
                                                },
                                                children: 'Terms of Service'
                                            }),
                                            ' and ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "legal-inline-link",
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    handleNavigateLegal('privacy-policy');
                                                },
                                                children: 'Privacy Policy'
                                            }),
                                            '.'
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn-confirm-checkout",
                                onClick: handleConfirmCheckout,
                                disabled: isSubmitting || isSummaryLoading || Boolean(isPreviewError) || !previewData,
                                children: isSubmitting ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                            indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                style: {
                                                    fontSize: 18,
                                                    color: '#060723'
                                                },
                                                spin: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: 'Processing...'
                                        })
                                    ]
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: effectiveTrial ? `Start ${trialDays}-day free trial` : 'Confirm Upgrade to Pro'
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _billingInfoModal.BillingInfoModal), {
                isOpen: isBillingModalOpen,
                onClose: ()=>setIsBillingModalOpen(false),
                onSuccess: ()=>{
                    refetchBillingProfile();
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentMethodModal.PaymentMethodModal), {
                isOpen: isPaymentModalOpen,
                onClose: ()=>setIsPaymentModalOpen(false),
                onSuccess: ()=>{
                    refetchPaymentMethods();
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _selectPaymentMethodModal.SelectPaymentMethodModal), {
                isOpen: isSelectCardModalOpen,
                onClose: ()=>setIsSelectCardModalOpen(false),
                cards: activeCards,
                isUpdatingCardId: settingDefaultCardId,
                onSelectCard: handleSelectCard,
                onAddNewCard: ()=>setIsPaymentModalOpen(true)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentConfirmedModal.PaymentConfirmedModal), {
                isOpen: isConfirmedModalOpen,
                onClose: ()=>setIsConfirmedModalOpen(false),
                isTrialMode: effectiveTrial,
                amountFormatted: previewData?.formatted_total,
                dueTodayFormatted: previewData?.formatted_due_today,
                firstPaymentFormatted: previewData?.formatted_first_payment_after_trial || previewData?.formatted_total,
                trialEndsDateFormatted: trialEndsDateFormatted
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentFailedModal.PaymentFailedModal), {
                isOpen: isFailedModalOpen,
                onClose: ()=>setIsFailedModalOpen(false),
                onTryAgain: handleConfirmCheckout,
                onChangePaymentMethod: ()=>{
                    setIsFailedModalOpen(false);
                    setIsPaymentModalOpen(true);
                },
                errorCode: failedError.code,
                subCode: failedError.subCode,
                errorTitle: failedError.title,
                errorMessage: failedError.message,
                isLoading: isSubmitting
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","@stripe/stripe-js":"23Dax","src/store/subscriptionStore":"rMPpj","src/api/subscription/useSubscriptionApi":"5YJAT","src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg":"bF2mm","src/assets/images/onboarding-trainer/subscription-icons/trial/recommended.svg":"2dXTZ","src/assets/images/onboarding-trainer/subscription-icons/checkout/checkmark.svg":"9ELfB","src/assets/images/onboarding-trainer/subscription-icons/checkout/secure-payment-lock.svg":"2POVx","src/assets/images/onboarding-trainer/subscription-icons/checkout/14-day-free-trial.svg":"cCQnz","src/assets/images/onboarding-trainer/subscription-icons/reactivate-pro/billing-info-edit.svg":"d1EPl","src/assets/images/onboarding-trainer/subscription-icons/checkout/add-button.svg":"6V9WO","../components/CardBrandLogo":"g5uLF","src/utils/cardUtils":"2ly56","../modals/BillingInfoModal":"5jyNn","../modals/PaymentMethodModal":"9Ak0b","../modals/SelectPaymentMethodModal":"lciKE","../modals/PaymentConfirmedModal":"6SHFU","../modals/PaymentFailedModal":"fsM9g","src/utils/appAlert":"de4Mq","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"./Checkout.scss":"4MSMz","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"23Dax":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _indexMjs = require("../dist/index.mjs");
parcelHelpers.exportAll(_indexMjs, exports);

},{"../dist/index.mjs":"7b73G","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7b73G":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "loadStripe", ()=>loadStripe);
function _typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") _typeof = function(obj) {
        return typeof obj;
    };
    else _typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return _typeof(obj);
}
var RELEASE_TRAIN = 'dahlia';
var runtimeVersionToUrlVersion = function runtimeVersionToUrlVersion(version) {
    return version === 3 ? 'v3' : version;
};
var ORIGIN = 'https://js.stripe.com';
var STRIPE_JS_URL = "".concat(ORIGIN, "/").concat(RELEASE_TRAIN, "/stripe.js");
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var STRIPE_JS_URL_REGEX = /^https:\/\/js\.stripe\.com\/(v3|[a-z]+)\/stripe\.js(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var isStripeJSURL = function isStripeJSURL(url) {
    return V3_URL_REGEX.test(url) || STRIPE_JS_URL_REGEX.test(url);
};
var findScript = function findScript() {
    var scripts = document.querySelectorAll("script[src^=\"".concat(ORIGIN, "\"]"));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!isStripeJSURL(script.src)) continue;
        return script;
    }
    return null;
};
var injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
    var script = document.createElement('script');
    script.src = "".concat(STRIPE_JS_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
    headOrBody.appendChild(script);
    return script;
};
var registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: 'stripe-js',
        version: "9.17.0",
        startTime: startTime
    });
};
var stripePromise$1 = null;
var onErrorListener = null;
var onLoadListener = null;
var onError = function onError(reject) {
    return function(cause) {
        reject(new Error('Failed to load Stripe.js', {
            cause: cause
        }));
    };
};
var onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error('Stripe.js not available'));
    };
};
var loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if (stripePromise$1 !== null) return stripePromise$1;
    stripePromise$1 = new Promise(function(resolve, reject) {
        if (typeof window === 'undefined' || typeof document === 'undefined') {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn(EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = findScript();
            if (script && params) console.warn(EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = injectScript(params);
            else if (script && onLoadListener !== null && onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener('load', onLoadListener);
                script.removeEventListener('error', onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = injectScript(params);
            }
            onLoadListener = onLoad(resolve, reject);
            onErrorListener = onError(reject);
            script.addEventListener('load', onLoadListener);
            script.addEventListener('error', onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return stripePromise$1["catch"](function(error) {
        stripePromise$1 = null;
        return Promise.reject(error);
    });
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var pk = args[0];
    if (typeof pk !== 'string') throw new Error("Expected publishable key to be of type string, got type ".concat(_typeof(pk), " instead."));
    var isTestKey = pk.match(/^pk_test/); // @ts-expect-error this is not publicly typed
    var version = runtimeVersionToUrlVersion(maybeStripe.version);
    var expectedVersion = RELEASE_TRAIN;
    if (isTestKey && version !== expectedVersion) console.warn("Stripe.js@".concat(version, " was loaded on the page, but @stripe/stripe-js@").concat("9.17.0", " expected Stripe.js@").concat(expectedVersion, ". This may result in unexpected behavior. For more information, see https://docs.stripe.com/sdks/stripejs-versioning"));
    var stripe = maybeStripe.apply(undefined, args);
    registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var stripePromise;
var loadCalled = false;
var getStripePromise = function getStripePromise() {
    if (stripePromise) return stripePromise;
    stripePromise = loadScript(null)["catch"](function(error) {
        // clear cache on error
        stripePromise = null;
        return Promise.reject(error);
    });
    return stripePromise;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return getStripePromise();
})["catch"](function(error) {
    if (!loadCalled) console.warn(error);
});
var loadStripe = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return getStripePromise().then(function(maybeStripe) {
        return initStripe(maybeStripe, args, startTime);
    });
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2POVx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSecurePaymentLock);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSecurePaymentLock = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 15,
        fill: "none",
        viewBox: "0 0 14 15",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            fillOpacity: 0.7,
            d: "M6.75 0a4.5 4.5 0 0 1 4.497 4.331l.003.169H12a1.5 1.5 0 0 1 1.496 1.388L13.5 6v7.5a1.5 1.5 0 0 1-1.387 1.496L12 15H1.5a1.5 1.5 0 0 1-1.496-1.387L0 13.5V6a1.5 1.5 0 0 1 1.388-1.496L1.5 4.5h.75A4.5 4.5 0 0 1 6.75 0M12 6H1.5v7.5H12zM6.75 7.5a1.5 1.5 0 0 1 .85 2.735l-.1.064v.951a.75.75 0 0 1-1.495.088L6 11.25v-.951A1.5 1.5 0 0 1 6.75 7.5m0-6a3 3 0 0 0-3 3h6a3 3 0 0 0-3-3"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cCQnz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>Svg14DayFreeTrial);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const Svg14DayFreeTrial = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#D6D6D6",
            d: "M0 17c0 1.7 1.3 3 3 3h14c1.7 0 3-1.3 3-3V9H0zM17 2h-2V1c0-.6-.4-1-1-1s-1 .4-1 1v1H7V1c0-.6-.4-1-1-1S5 .4 5 1v1H3C1.3 2 0 3.3 0 5v2h20V5c0-1.7-1.3-3-3-3"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"d1EPl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBillingInfoEdit);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBillingInfoEdit = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 26,
        height: 26,
        fill: "none",
        viewBox: "0 0 26 26",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#D6D6D6",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.333,
                d: "m15.157 8.488 2.357 2.358m-1.357-3.358a1.667 1.667 0 0 1 2.357 2.358l-9.179 9.178H7.002v-2.381z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#D6D6D6",
                strokeLinecap: "round",
                strokeWidth: 1.2,
                d: "M6.6 22.4h12.8"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6V9WO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAddButton);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAddButton = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 11,
        height: 11,
        fill: "none",
        viewBox: "0 0 11 11",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.333,
            d: "M5.333.667V10M.667 5.333H10"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g5uLF":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CardBrandLogo", ()=>CardBrandLogo);
parcelHelpers.export(exports, "getCardBrandDisplayName", ()=>(0, _cardUtils.getCardBrandDisplayName));
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _visaLogoSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/visa-logo.svg");
var _mastercardLogoSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/mastercard-logo.svg");
var _amexLogoSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/amex-logo.svg");
var _discoverLogoSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/discover-logo.svg");
var _jcbLogoSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/jcb-logo.svg");
var _dinersClubLogoSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/diners-club-logo.svg");
var _unionpayLogoSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/unionpay-logo.svg");
var _maestroLogoSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/maestro-logo.svg");
var _genericCardLogoSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/generic-card-logo.svg");
var _cardUtils = require("src/utils/cardUtils");
const CardBrandLogo = ({ brand, ...props })=>{
    const norm = (0, _cardUtils.normalizeCardBrand)(brand);
    switch(norm){
        case 'visa':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _visaLogoSvg.ReactComponent), {
                ...props
            });
        case 'mastercard':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _mastercardLogoSvg.ReactComponent), {
                ...props
            });
        case 'amex':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _amexLogoSvg.ReactComponent), {
                ...props
            });
        case 'discover':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _discoverLogoSvg.ReactComponent), {
                ...props
            });
        case 'jcb':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _jcbLogoSvg.ReactComponent), {
                ...props
            });
        case 'diners':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dinersClubLogoSvg.ReactComponent), {
                ...props
            });
        case 'unionpay':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _unionpayLogoSvg.ReactComponent), {
                ...props
            });
        case 'maestro':
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _maestroLogoSvg.ReactComponent), {
                ...props
            });
        default:
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _genericCardLogoSvg.ReactComponent), {
                ...props
            });
    }
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","src/assets/images/onboarding-trainer/subscription-icons/common/visa-logo.svg":"eoleH","src/assets/images/onboarding-trainer/subscription-icons/common/mastercard-logo.svg":"k5UwS","src/assets/images/onboarding-trainer/subscription-icons/common/amex-logo.svg":"9U9Jl","src/assets/images/onboarding-trainer/subscription-icons/common/discover-logo.svg":"k4cpl","src/assets/images/onboarding-trainer/subscription-icons/common/jcb-logo.svg":"3nxYs","src/assets/images/onboarding-trainer/subscription-icons/common/diners-club-logo.svg":"i3nKK","src/assets/images/onboarding-trainer/subscription-icons/common/unionpay-logo.svg":"65i6c","src/assets/images/onboarding-trainer/subscription-icons/common/maestro-logo.svg":"kZ0kf","src/assets/images/onboarding-trainer/subscription-icons/common/generic-card-logo.svg":"dDFWN","src/utils/cardUtils":"2ly56","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eoleH":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgVisaLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgVisaLogo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 28,
        fill: "none",
        viewBox: "0 0 48 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 48,
                height: 28,
                fill: "#fff",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#1A1F71",
                d: "M18.8 19h-2.6l1.6-9.5h2.6zm9.7-9.3c-.5-.2-1.3-.4-2.3-.4-2.6 0-4.4 1.4-4.4 3.3 0 1.4 1.3 2.2 2.3 2.7s1.3.8 1.3 1.3c0 .7-.8 1-1.6 1-1 0-1.6-.2-2.3-.5l-.4-.2-.4 2.4c.7.3 1.8.6 2.9.6 2.8 0 4.6-1.4 4.6-3.5 0-1.7-1.1-2.5-2.4-3.1-.9-.5-1.4-.8-1.4-1.3s.6-.9 1.6-.9c.8 0 1.4.2 1.9.4l.3.1zm6.9-.2h-2c-.7 0-1.2.2-1.5.9L27.2 19h2.7l.6-1.6h3.3l.3 1.6h2.4l-2.1-9.5zm-4.2 5.8 1.4-3.7.8 3.7zM14.9 9.5 12.4 16l-.3-1.4c-.5-1.6-1.9-3.4-3.6-4.3l2.3 8.7h2.7l4-9.5z"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k5UwS":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMastercardLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMastercardLogo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 28,
        fill: "none",
        viewBox: "0 0 48 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 48,
                height: 28,
                fill: "#fff",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 19,
                cy: 14,
                r: 7,
                fill: "#EB001B"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 29,
                cy: 14,
                r: 7,
                fill: "#F79E1B",
                fillOpacity: 0.85
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9U9Jl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgAmexLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgAmexLogo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 28,
        fill: "none",
        viewBox: "0 0 48 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 48,
                height: 28,
                fill: "#006FCF",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                x: 24,
                y: 18,
                fill: "#FFF",
                fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                fontSize: 9.5,
                fontWeight: 900,
                letterSpacing: 0.8,
                textAnchor: "middle",
                children: "\n    AMEX\n  "
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k4cpl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDiscoverLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDiscoverLogo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 28,
        fill: "none",
        viewBox: "0 0 48 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 48,
                height: 28,
                fill: "#FFF",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 24,
                cy: 14,
                r: 5,
                fill: "#FF6000"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("text", {
                x: 24,
                y: 17.5,
                fill: "#13294B",
                fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
                fontSize: 6.8,
                fontWeight: 900,
                letterSpacing: 0.4,
                textAnchor: "middle",
                children: [
                    "\n    DISC",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("tspan", {
                        fill: "#FF6000",
                        children: "O"
                    }),
                    "VER\n  "
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3nxYs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgJcbLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgJcbLogo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 28,
        fill: "none",
        viewBox: "0 0 48 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 48,
                height: 28,
                fill: "#FFF",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                transform: "translate(10 6)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 8.5,
                        height: 16,
                        fill: "#003B82",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 8.5,
                        height: 16,
                        x: 9.5,
                        fill: "#CE1126",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                        width: 8.5,
                        height: 16,
                        x: 19,
                        fill: "#008238",
                        rx: 2
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        x: 4.25,
                        y: 11,
                        fill: "#FFF",
                        fontFamily: "sans-serif",
                        fontSize: 6.5,
                        fontWeight: 900,
                        textAnchor: "middle",
                        children: "J"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        x: 13.75,
                        y: 11,
                        fill: "#FFF",
                        fontFamily: "sans-serif",
                        fontSize: 6.5,
                        fontWeight: 900,
                        textAnchor: "middle",
                        children: "C"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                        x: 23.25,
                        y: 11,
                        fill: "#FFF",
                        fontFamily: "sans-serif",
                        fontSize: 6.5,
                        fontWeight: 900,
                        textAnchor: "middle",
                        children: "B"
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"i3nKK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDinersClubLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDinersClubLogo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 28,
        fill: "none",
        viewBox: "0 0 48 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 48,
                height: 28,
                fill: "#004A97",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 21,
                cy: 14,
                r: 5.5,
                stroke: "#FFF",
                strokeWidth: 1.6
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 27,
                cy: 14,
                r: 5.5,
                stroke: "#FFF",
                strokeWidth: 1.6
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "#FFF",
                d: "M21 9.5v9m6-9v9"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"65i6c":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgUnionpayLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgUnionpayLogo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 28,
        fill: "none",
        viewBox: "0 0 48 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 48,
                height: 28,
                fill: "#FFF",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#D81E06",
                d: "M11 7h8.5L17 21h-6z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#004A97",
                d: "M18 7h8.5L24 21h-6z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#008238",
                d: "M25 7h8.5L31 21h-8.5z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("text", {
                x: 13,
                y: 10,
                fill: "#FFF",
                fontFamily: "sans-serif",
                fontSize: 5.5,
                fontWeight: "bold",
                textAnchor: "middle",
                transform: "translate(11 7)",
                children: "\u94F6\u8054"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kZ0kf":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMaestroLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMaestroLogo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 28,
        fill: "none",
        viewBox: "0 0 48 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 48,
                height: 28,
                fill: "#FFF",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 19,
                cy: 14,
                r: 7,
                fill: "#0061A8"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 29,
                cy: 14,
                r: 7,
                fill: "#EB001B"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "#7B2C82",
                d: "M24 8.8a7 7 0 0 1 0 10.4 7 7 0 0 1 0-10.4"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dDFWN":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgGenericCardLogo);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgGenericCardLogo = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 48,
        height: 28,
        fill: "none",
        viewBox: "0 0 48 28",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 48,
                height: 28,
                fill: "#1C2147",
                stroke: "rgba(255, 255, 255, 0.15)",
                rx: 4
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("rect", {
                width: 7,
                height: 5,
                x: 5,
                y: 6,
                fill: "#FFA100",
                rx: 1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "rgba(255, 255, 255, 0.5)",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "M5 18h17"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "rgba(255, 255, 255, 0.3)",
                strokeLinecap: "round",
                strokeWidth: 1.5,
                d: "M26 18h9"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2ly56":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "normalizeCardBrand", ()=>normalizeCardBrand);
parcelHelpers.export(exports, "getCardBrandDisplayName", ()=>getCardBrandDisplayName);
parcelHelpers.export(exports, "formatCardNumberWithGaps", ()=>formatCardNumberWithGaps);
parcelHelpers.export(exports, "formatExpiry", ()=>formatExpiry);
parcelHelpers.export(exports, "formatMaskedCardNumber", ()=>formatMaskedCardNumber);
parcelHelpers.export(exports, "getCardInfo", ()=>getCardInfo);
parcelHelpers.export(exports, "validateCardNumber", ()=>validateCardNumber);
parcelHelpers.export(exports, "validateExpiry", ()=>validateExpiry);
parcelHelpers.export(exports, "validateCvc", ()=>validateCvc);
parcelHelpers.export(exports, "validateCardholderName", ()=>validateCardholderName);
var _cardValidator = require("card-validator");
var _cardValidatorDefault = parcelHelpers.interopDefault(_cardValidator);
const normalizeCardBrand = (type)=>{
    if (!type) return 'generic';
    const norm = type.toLowerCase().replace(/[\s-_]/g, '');
    if (norm.includes('visa')) return 'visa';
    if (norm.includes('master')) return 'mastercard';
    if (norm.includes('americanexpress') || norm.includes('amex')) return 'amex';
    if (norm.includes('discover')) return 'discover';
    if (norm.includes('jcb')) return 'jcb';
    if (norm.includes('diner')) return 'diners';
    if (norm.includes('union')) return 'unionpay';
    if (norm.includes('maestro')) return 'maestro';
    return 'generic';
};
const getCardBrandDisplayName = (brand)=>{
    const norm = (brand || '').toLowerCase().replace(/[\s-_]/g, '');
    if (norm.includes('visa')) return 'Visa';
    if (norm.includes('master')) return 'Mastercard';
    if (norm.includes('amex') || norm.includes('americanexpress')) return 'American Express';
    if (norm.includes('discover')) return 'Discover';
    if (norm.includes('jcb')) return 'JCB';
    if (norm.includes('diner')) return 'Diners Club';
    if (norm.includes('union')) return 'UnionPay';
    if (norm.includes('maestro')) return 'Maestro';
    return 'Card';
};
const formatCardNumberWithGaps = (digits, gaps = [
    4,
    8,
    12
], maxLength = 19)=>{
    const capped = digits.substring(0, maxLength);
    const parts = [];
    let prev = 0;
    for (const gap of gaps){
        if (capped.length > gap) {
            parts.push(capped.substring(prev, gap));
            prev = gap;
        } else break;
    }
    parts.push(capped.substring(prev));
    return parts.filter(Boolean).join(' ');
};
const formatExpiry = (value)=>{
    const digits = value.replace(/\D/g, '').substring(0, 4);
    if (digits.length >= 3) return `${digits.substring(0, 2)} / ${digits.substring(2)}`;
    return digits;
};
const formatMaskedCardNumber = (brand, last4)=>{
    const norm = (brand || '').toLowerCase().replace(/[\s-_]/g, '');
    const isAmex = norm.includes('amex') || norm.includes('americanexpress');
    return `${isAmex ? "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022\u2022\u2022 \u2022" : "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 "}${last4}`;
};
const getCardInfo = (rawNumber, cardToEdit)=>{
    const cleanNumber = rawNumber.replace(/\D/g, '');
    if (cardToEdit && !cleanNumber) {
        const isAmex = cardToEdit.brand === 'amex';
        return {
            brand: cardToEdit.brand,
            niceType: getCardBrandDisplayName(cardToEdit.brand),
            isAmex,
            gaps: isAmex ? [
                4,
                10
            ] : [
                4,
                8,
                12
            ],
            maxLength: isAmex ? 15 : 16,
            codeName: isAmex ? 'CID' : 'CVC',
            codeSize: isAmex ? 4 : 3,
            isValid: true,
            isPotentiallyValid: true,
            card: null
        };
    }
    const validation = (0, _cardValidatorDefault.default).number(cleanNumber);
    let card = validation.card;
    // Single-digit and early 2-digit high-confidence heuristics before card-validator's full match
    if (!card && cleanNumber.length > 0) {
        if (cleanNumber.startsWith('4')) card = {
            type: 'visa',
            niceType: 'Visa',
            patterns: [
                4
            ],
            gaps: [
                4,
                8,
                12
            ],
            lengths: [
                16,
                18,
                19
            ],
            code: {
                name: 'CVV',
                size: 3
            }
        };
    }
    const detectedBrand = card ? normalizeCardBrand(card.type) : 'generic';
    const isAmex = detectedBrand === 'amex' || cleanNumber.startsWith('34') || cleanNumber.startsWith('37');
    const gaps = card?.gaps || (isAmex ? [
        4,
        10
    ] : [
        4,
        8,
        12
    ]);
    const maxLength = card?.lengths ? Math.max(...card.lengths) : isAmex ? 15 : 19;
    const codeName = isAmex ? 'CID' : card?.code?.name === 'CID' ? 'CID' : 'CVC';
    const codeSize = isAmex ? 4 : 3;
    return {
        card,
        brand: detectedBrand,
        niceType: card?.niceType || (isAmex ? 'American Express' : 'Card'),
        isAmex,
        gaps,
        maxLength,
        codeName,
        codeSize,
        isValid: validation.isValid,
        isPotentiallyValid: validation.isPotentiallyValid
    };
};
const validateCardNumber = (rawNumber, isAmex, isEdit = false)=>{
    const clean = rawNumber.replace(/\D/g, '');
    if (!clean && !isEdit) return 'Card number is required';
    if (!isEdit && clean) {
        const v = (0, _cardValidatorDefault.default).number(clean);
        if (clean.length < 13 || !v.isValid && !v.isPotentiallyValid) return 'Please enter a valid card number';
        if (isAmex && clean.length !== 15) return 'American Express card number must be 15 digits';
        if (!v.isValid && clean.length >= 15) return isAmex ? 'Enter a valid 15-digit American Express card number' : 'Please enter a valid card number';
    }
    return '';
};
const validateExpiry = (expiry)=>{
    const trimmed = expiry.trim();
    if (!trimmed) return 'Expiry date is required';
    const expVal = (0, _cardValidatorDefault.default).expirationDate(trimmed);
    if (!expVal.isValid) return 'Enter a valid expiration date (MM / YY)';
    return '';
};
const validateCvc = (rawCvc, codeSize, codeName = 'CVC', isEdit = false)=>{
    const clean = rawCvc.replace(/\D/g, '');
    if (!clean && !isEdit) return `${codeName} is required`;
    if (!isEdit && clean) {
        if (clean.length !== codeSize) return `${codeName} must be ${codeSize} digits`;
        const cvvVal = (0, _cardValidatorDefault.default).cvv(clean, codeSize);
        if (!cvvVal.isValid) return `Invalid ${codeName}`;
    }
    return '';
};
const validateCardholderName = (name)=>{
    const trimmed = name.trim();
    if (!trimmed) return 'Cardholder name is required';
    if (!/\p{L}/u.test(trimmed)) return 'Name must contain letters';
    return '';
};

},{"card-validator":"3Rnpg","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3Rnpg":[function(require,module,exports,__globalThis) {
"use strict";
var __createBinding = this && this.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var __importStar = this && this.__importStar || function() {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function(o) {
            var ar = [];
            for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) {
            for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
        }
        __setModuleDefault(result, mod);
        return result;
    };
}();
var creditCardType = __importStar(require("1d3e08c74e8c57b6"));
var cardholder_name_1 = require("6d5d9c2b8eef212");
var card_number_1 = require("12de689611a5b354");
var expiration_date_1 = require("53dbbc0eeef46d42");
var expiration_month_1 = require("3558029ddb7d8ac0");
var expiration_year_1 = require("900cc6d26d05f76f");
var cvv_1 = require("aea98623c473d5cc");
var postal_code_1 = require("db1a29fa06887272");
var cardValidator = {
    creditCardType: creditCardType,
    cardholderName: cardholder_name_1.cardholderName,
    number: card_number_1.cardNumber,
    expirationDate: expiration_date_1.expirationDate,
    expirationMonth: expiration_month_1.expirationMonth,
    expirationYear: expiration_year_1.expirationYear,
    cvv: cvv_1.cvv,
    postalCode: postal_code_1.postalCode
};
module.exports = cardValidator;

},{"1d3e08c74e8c57b6":"g7CJg","6d5d9c2b8eef212":"7kpbZ","12de689611a5b354":"jKGcx","53dbbc0eeef46d42":"2lyVA","3558029ddb7d8ac0":"hXU2L","900cc6d26d05f76f":"bzK5P","aea98623c473d5cc":"56kMe","db1a29fa06887272":"dEG6u"}],"g7CJg":[function(require,module,exports,__globalThis) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var cardTypes = require("85712e0c1cba7199");
var add_matching_cards_to_results_1 = require("938b984176c9165c");
var is_valid_input_type_1 = require("47c8180a2047ef8e");
var find_best_match_1 = require("f8d0f39fb43c912b");
var clone_1 = require("cae954e0d0b5a14c");
var customCards = {};
var cardNames = {
    VISA: "visa",
    MASTERCARD: "mastercard",
    AMERICAN_EXPRESS: "american-express",
    DINERS_CLUB: "diners-club",
    DISCOVER: "discover",
    TROY: "troy",
    JCB: "jcb",
    UNIONPAY: "unionpay",
    NARANJA: "naranja",
    VERVE: "verve",
    MAESTRO: "maestro",
    ELO: "elo",
    MIR: "mir",
    HIPER: "hiper",
    HIPERCARD: "hipercard"
};
var ORIGINAL_TEST_ORDER = [
    cardNames.VISA,
    cardNames.MASTERCARD,
    cardNames.AMERICAN_EXPRESS,
    cardNames.DINERS_CLUB,
    cardNames.DISCOVER,
    cardNames.TROY,
    cardNames.JCB,
    cardNames.UNIONPAY,
    cardNames.NARANJA,
    cardNames.VERVE,
    cardNames.MAESTRO,
    cardNames.ELO,
    cardNames.MIR,
    cardNames.HIPER,
    cardNames.HIPERCARD
];
var testOrder = (0, clone_1.clone)(ORIGINAL_TEST_ORDER);
function findType(cardType) {
    return customCards[cardType] || cardTypes[cardType];
}
function getAllCardTypes() {
    return testOrder.map(function(cardType) {
        return (0, clone_1.clone)(findType(cardType));
    });
}
function getCardPosition(name, ignoreErrorForNotExisting) {
    if (ignoreErrorForNotExisting === void 0) ignoreErrorForNotExisting = false;
    var position = testOrder.indexOf(name);
    if (!ignoreErrorForNotExisting && position === -1) throw new Error('"' + name + '" is not a supported card type.');
    return position;
}
function creditCardType(cardNumber) {
    var results = [];
    if (!(0, is_valid_input_type_1.isValidInputType)(cardNumber)) return results;
    if (cardNumber.length === 0) return getAllCardTypes();
    testOrder.forEach(function(cardType) {
        var cardConfiguration = findType(cardType);
        (0, add_matching_cards_to_results_1.addMatchingCardsToResults)(cardNumber, cardConfiguration, results);
    });
    var bestMatch = (0, find_best_match_1.findBestMatch)(results);
    if (bestMatch) return [
        bestMatch
    ];
    return results;
}
creditCardType.getTypeInfo = function(cardType) {
    return (0, clone_1.clone)(findType(cardType));
};
creditCardType.removeCard = function(name) {
    var position = getCardPosition(name);
    testOrder.splice(position, 1);
};
creditCardType.addCard = function(config) {
    var existingCardPosition = getCardPosition(config.type, true);
    customCards[config.type] = config;
    if (existingCardPosition === -1) testOrder.push(config.type);
};
creditCardType.updateCard = function(cardType, updates) {
    var originalObject = customCards[cardType] || cardTypes[cardType];
    if (!originalObject) throw new Error("\"".concat(cardType, "\" is not a recognized type. Use `addCard` instead.'"));
    if (updates.type && originalObject.type !== updates.type) throw new Error("Cannot overwrite type parameter.");
    var clonedCard = (0, clone_1.clone)(originalObject);
    clonedCard = __assign(__assign({}, clonedCard), updates);
    customCards[clonedCard.type] = clonedCard;
};
creditCardType.changeOrder = function(name, position) {
    var currentPosition = getCardPosition(name);
    testOrder.splice(currentPosition, 1);
    testOrder.splice(position, 0, name);
};
creditCardType.resetModifications = function() {
    testOrder = (0, clone_1.clone)(ORIGINAL_TEST_ORDER);
    customCards = {};
};
creditCardType.types = cardNames;
module.exports = creditCardType;

},{"85712e0c1cba7199":"6zvxb","938b984176c9165c":"8nvPa","47c8180a2047ef8e":"aazvf","f8d0f39fb43c912b":"9kr54","cae954e0d0b5a14c":"3rIbN"}],"6zvxb":[function(require,module,exports,__globalThis) {
"use strict";
var cardTypes = {
    visa: {
        niceType: "Visa",
        type: "visa",
        patterns: [
            4
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            18,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    mastercard: {
        niceType: "Mastercard",
        type: "mastercard",
        patterns: [
            [
                51,
                55
            ],
            [
                2221,
                2229
            ],
            [
                223,
                229
            ],
            [
                23,
                26
            ],
            [
                270,
                271
            ],
            2720
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    "american-express": {
        niceType: "American Express",
        type: "american-express",
        patterns: [
            34,
            37
        ],
        gaps: [
            4,
            10
        ],
        lengths: [
            15
        ],
        code: {
            name: "CID",
            size: 4
        }
    },
    "diners-club": {
        niceType: "Diners Club",
        type: "diners-club",
        patterns: [
            [
                300,
                305
            ],
            36,
            38,
            39
        ],
        gaps: [
            4,
            10
        ],
        lengths: [
            14,
            16,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    troy: {
        niceType: "Troy",
        type: "troy",
        patterns: [
            9792,
            650052,
            [
                650082,
                650083
            ],
            650092,
            650161,
            650170,
            650173,
            650175,
            650268,
            650271,
            [
                650273,
                650274
            ],
            [
                650456,
                650457
            ],
            650836,
            [
                650846,
                650850
            ],
            650923,
            650987,
            650990,
            654997,
            657366,
            657998,
            658758,
            [
                658767,
                658768
            ],
            [
                65083700,
                65083704
            ],
            [
                65085800,
                65085804
            ],
            [
                65085900,
                65085901
            ],
            65086000,
            [
                65086100,
                65086105
            ],
            [
                65086200,
                65086203
            ],
            [
                65875000,
                65875003
            ],
            65875009,
            [
                65875101,
                65875104
            ],
            65875200,
            65875501,
            65875601,
            65875900,
            [
                65876000,
                65876002
            ],
            [
                65876100,
                65876103
            ],
            65876110,
            [
                65876115,
                65876116
            ],
            [
                65876200,
                65876201
            ],
            65876500,
            [
                65876504,
                65876505
            ],
            [
                65876600,
                65876602
            ],
            [
                65877100,
                65877101
            ],
            [
                65877600,
                65877602
            ],
            65877700,
            [
                65877801,
                65877802
            ],
            [
                65878200,
                65878202
            ],
            [
                65878300,
                65878311
            ],
            [
                65878400,
                65878405
            ],
            [
                65878500,
                65878505
            ],
            [
                65878600,
                65878601
            ],
            65879800,
            65880800,
            65880900
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    discover: {
        niceType: "Discover",
        type: "discover",
        patterns: [
            6011,
            [
                644,
                649
            ],
            65
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            19
        ],
        code: {
            name: "CID",
            size: 3
        }
    },
    jcb: {
        niceType: "JCB",
        type: "jcb",
        patterns: [
            2131,
            1800,
            [
                3528,
                3589
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    unionpay: {
        niceType: "UnionPay",
        type: "unionpay",
        patterns: [
            620,
            [
                62100,
                62182
            ],
            [
                62184,
                62187
            ],
            [
                62185,
                62197
            ],
            [
                62200,
                62205
            ],
            [
                622010,
                622999
            ],
            622018,
            [
                62207,
                62209
            ],
            [
                623,
                626
            ],
            6270,
            6272,
            6276,
            [
                627700,
                627779
            ],
            [
                627781,
                627799
            ],
            [
                6282,
                6289
            ],
            6291,
            6292,
            810,
            [
                8110,
                8131
            ],
            [
                8132,
                8151
            ],
            [
                8152,
                8163
            ],
            [
                8164,
                8171
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            14,
            15,
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVN",
            size: 3
        }
    },
    maestro: {
        niceType: "Maestro",
        type: "maestro",
        patterns: [
            493698,
            [
                500000,
                504174
            ],
            [
                504176,
                506698
            ],
            [
                506779,
                508999
            ],
            [
                56,
                59
            ],
            63,
            67,
            6
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            12,
            13,
            14,
            15,
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    elo: {
        niceType: "Elo",
        type: "elo",
        patterns: [
            401178,
            401179,
            438935,
            457631,
            457632,
            431274,
            451416,
            457393,
            504175,
            [
                506699,
                506778
            ],
            [
                509000,
                509999
            ],
            627780,
            636297,
            636368,
            [
                650031,
                650033
            ],
            [
                650035,
                650051
            ],
            [
                650405,
                650439
            ],
            [
                650485,
                650538
            ],
            [
                650541,
                650598
            ],
            [
                650700,
                650718
            ],
            [
                650720,
                650727
            ],
            [
                650901,
                650978
            ],
            [
                651652,
                651679
            ],
            [
                655000,
                655019
            ],
            [
                655021,
                655058
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVE",
            size: 3
        }
    },
    mir: {
        niceType: "Mir",
        type: "mir",
        patterns: [
            [
                2200,
                2204
            ]
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            17,
            18,
            19
        ],
        code: {
            name: "CVP2",
            size: 3
        }
    },
    hiper: {
        niceType: "Hiper",
        type: "hiper",
        patterns: [
            637095,
            63737423,
            63743358,
            637568,
            637599,
            637609,
            637612
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    hipercard: {
        niceType: "Hipercard",
        type: "hipercard",
        patterns: [
            606282
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVC",
            size: 3
        }
    },
    naranja: {
        niceType: "Naranja",
        type: "naranja",
        patterns: [
            589562,
            402918,
            527572
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16
        ],
        code: {
            name: "CVV",
            size: 3
        }
    },
    verve: {
        niceType: "Verve",
        type: "verve",
        patterns: [
            [
                506099,
                506127
            ],
            506129,
            [
                506133,
                506150
            ],
            [
                506158,
                506163
            ],
            506166,
            506168,
            506170,
            506173,
            [
                506176,
                506180
            ],
            506184,
            [
                506187,
                506188
            ],
            506191,
            506195,
            506197,
            507865,
            507866,
            [
                507868,
                507877
            ],
            [
                507880,
                507888
            ],
            507900,
            507941
        ],
        gaps: [
            4,
            8,
            12
        ],
        lengths: [
            16,
            18,
            19
        ],
        code: {
            name: "CVV",
            size: 3
        }
    }
};
module.exports = cardTypes;

},{}],"8nvPa":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.addMatchingCardsToResults = addMatchingCardsToResults;
var clone_1 = require("4ba80497c6ccd5d4");
var matches_1 = require("f863fee5bdc6faeb");
function addMatchingCardsToResults(cardNumber, cardConfiguration, results) {
    var i, patternLength;
    for(i = 0; i < cardConfiguration.patterns.length; i++){
        var pattern = cardConfiguration.patterns[i];
        if (!(0, matches_1.matches)(cardNumber, pattern)) continue;
        var clonedCardConfiguration = (0, clone_1.clone)(cardConfiguration);
        if (Array.isArray(pattern)) patternLength = String(pattern[0]).length;
        else patternLength = String(pattern).length;
        if (cardNumber.length >= patternLength) clonedCardConfiguration.matchStrength = patternLength;
        results.push(clonedCardConfiguration);
        break;
    }
}

},{"4ba80497c6ccd5d4":"3rIbN","f863fee5bdc6faeb":"1Vzsp"}],"3rIbN":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.clone = clone;
function clone(originalObject) {
    if (!originalObject) return null;
    return JSON.parse(JSON.stringify(originalObject));
}

},{}],"1Vzsp":[function(require,module,exports,__globalThis) {
"use strict";
/*
 * Adapted from https://github.com/polvo-labs/card-type/blob/aaab11f80fa1939bccc8f24905a06ae3cd864356/src/cardType.js#L37-L42
 * */ Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.matches = matches;
function matchesRange(cardNumber, min, max) {
    var maxLengthToCheck = String(min).length;
    var substr = cardNumber.substr(0, maxLengthToCheck);
    var integerRepresentationOfCardNumber = parseInt(substr, 10);
    min = parseInt(String(min).substr(0, substr.length), 10);
    max = parseInt(String(max).substr(0, substr.length), 10);
    return integerRepresentationOfCardNumber >= min && integerRepresentationOfCardNumber <= max;
}
function matchesPattern(cardNumber, pattern) {
    pattern = String(pattern);
    return pattern.substring(0, cardNumber.length) === cardNumber.substring(0, pattern.length);
}
function matches(cardNumber, pattern) {
    if (Array.isArray(pattern)) return matchesRange(cardNumber, pattern[0], pattern[1]);
    return matchesPattern(cardNumber, pattern);
}

},{}],"aazvf":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isValidInputType = isValidInputType;
function isValidInputType(cardNumber) {
    return typeof cardNumber === "string" || cardNumber instanceof String;
}

},{}],"9kr54":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.findBestMatch = findBestMatch;
function hasEnoughResultsToDetermineBestMatch(results) {
    var numberOfResultsWithMaxStrengthProperty = results.filter(function(result) {
        return result.matchStrength;
    }).length;
    /*
     * if all possible results have a maxStrength property that means the card
     * number is sufficiently long enough to determine conclusively what the card
     * type is
     * */ return numberOfResultsWithMaxStrengthProperty > 0 && numberOfResultsWithMaxStrengthProperty === results.length;
}
function findBestMatch(results) {
    if (!hasEnoughResultsToDetermineBestMatch(results)) return null;
    return results.reduce(function(bestMatch, result) {
        if (!bestMatch) return result;
        /*
         * If the current best match pattern is less specific than this result, set
         * the result as the new best match
         * */ if (Number(bestMatch.matchStrength) < Number(result.matchStrength)) return result;
        return bestMatch;
    });
}

},{}],"7kpbZ":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cardholderName = cardholderName;
var CARD_NUMBER_REGEX = /^[\d\s-]*$/;
var MAX_LENGTH = 255;
function verification(isValid, isPotentiallyValid) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid
    };
}
function cardholderName(value) {
    if (typeof value !== "string") return verification(false, false);
    if (value.length === 0) return verification(false, true);
    if (value.length > MAX_LENGTH) return verification(false, false);
    if (CARD_NUMBER_REGEX.test(value)) return verification(false, true);
    return verification(true, true);
}

},{}],"jKGcx":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cardNumber = cardNumber;
var luhn10 = require("b76f36fc6ea6b135");
var getCardTypes = require("57979caee5e93b86");
function verification(card, isPotentiallyValid, isValid) {
    return {
        card: card,
        isPotentiallyValid: isPotentiallyValid,
        isValid: isValid
    };
}
function cardNumber(value, options) {
    if (options === void 0) options = {};
    var isPotentiallyValid, isValid, maxLength;
    if (typeof value !== "string" && typeof value !== "number") return verification(null, false, false);
    var testCardValue = String(value).replace(/-|\s/g, "");
    if (!/^\d*$/.test(testCardValue)) return verification(null, false, false);
    var potentialTypes = getCardTypes(testCardValue);
    if (potentialTypes.length === 0) return verification(null, false, false);
    else if (potentialTypes.length !== 1) return verification(null, true, false);
    var cardType = potentialTypes[0];
    if (options.maxLength && testCardValue.length > options.maxLength) return verification(cardType, false, false);
    if (options.skipLuhnValidation === true || cardType.type === getCardTypes.types.UNIONPAY && options.luhnValidateUnionPay !== true) isValid = true;
    else isValid = luhn10(testCardValue);
    maxLength = Math.max.apply(null, cardType.lengths);
    if (options.maxLength) maxLength = Math.min(options.maxLength, maxLength);
    for(var i = 0; i < cardType.lengths.length; i++)if (cardType.lengths[i] === testCardValue.length) {
        isPotentiallyValid = testCardValue.length < maxLength || isValid;
        return verification(cardType, isPotentiallyValid, isValid);
    }
    return verification(cardType, testCardValue.length < maxLength, false);
}

},{"b76f36fc6ea6b135":"b19Nx","57979caee5e93b86":"g7CJg"}],"b19Nx":[function(require,module,exports,__globalThis) {
/* eslint-disable */ /*
 * Luhn algorithm implementation in JavaScript
 * Copyright (c) 2009 Nicholas C. Zakas
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ "use strict";
function luhn10(identifier) {
    var sum = 0;
    var alt = false;
    var i = identifier.length - 1;
    var num;
    while(i >= 0){
        num = parseInt(identifier.charAt(i), 10);
        if (alt) {
            num *= 2;
            if (num > 9) num = num % 10 + 1; // eslint-disable-line no-extra-parens
        }
        alt = !alt;
        sum += num;
        i--;
    }
    return sum % 10 === 0;
}
module.exports = luhn10;

},{}],"2lyVA":[function(require,module,exports,__globalThis) {
"use strict";
var __assign = this && this.__assign || function() {
    __assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.expirationDate = expirationDate;
var parse_date_1 = require("5c5d87ca73cc3887");
var expiration_month_1 = require("42c778c88cc7c395");
var expiration_year_1 = require("d3b08b7a0eece1a6");
function verification(isValid, isPotentiallyValid, month, year) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid,
        month: month,
        year: year
    };
}
function expirationDate(value, maxElapsedYear) {
    var date;
    if (typeof value === "string") {
        value = value.replace(/^(\d\d) (\d\d(\d\d)?)$/, "$1/$2");
        date = (0, parse_date_1.parseDate)(String(value));
    } else if (value !== null && typeof value === "object") {
        var fullDate = __assign({}, value);
        date = {
            month: String(fullDate.month),
            year: String(fullDate.year)
        };
    } else return verification(false, false, null, null);
    var monthValid = (0, expiration_month_1.expirationMonth)(date.month);
    var yearValid = (0, expiration_year_1.expirationYear)(date.year, maxElapsedYear);
    if (monthValid.isValid) {
        if (yearValid.isCurrentYear) {
            var isValidForThisYear = monthValid.isValidForThisYear;
            return verification(isValidForThisYear, isValidForThisYear, date.month, date.year);
        }
        if (yearValid.isValid) return verification(true, true, date.month, date.year);
    }
    if (monthValid.isPotentiallyValid && yearValid.isPotentiallyValid) return verification(false, true, null, null);
    return verification(false, false, null, null);
}

},{"5c5d87ca73cc3887":"7wrz6","42c778c88cc7c395":"hXU2L","d3b08b7a0eece1a6":"bzK5P"}],"7wrz6":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.parseDate = parseDate;
var expiration_year_1 = require("c88724e2b0e48bb");
var is_array_1 = require("6021106b5fe9a350");
function getNumberOfMonthDigitsInDateString(dateString) {
    var firstCharacter = Number(dateString[0]);
    var assumedYear;
    /*
      if the first character in the string starts with `0`,
      we know that the month will be 2 digits.
  
      '0122' => {month: '01', year: '22'}
    */ if (firstCharacter === 0) return 2;
    /*
      if the first character in the string starts with
      number greater than 1, it must be a 1 digit month
  
      '322' => {month: '3', year: '22'}
    */ if (firstCharacter > 1) return 1;
    /*
      if the first 2 characters make up a number between
      13-19, we know that the month portion must be 1
  
      '139' => {month: '1', year: '39'}
    */ if (firstCharacter === 1 && Number(dateString[1]) > 2) return 1;
    /*
      if the first 2 characters make up a number between
      10-12, we check if the year portion would be considered
      valid if we assumed that the month was 1. If it is
      not potentially valid, we assume the month must have
      2 digits.
  
      '109' => {month: '10', year: '9'}
      '120' => {month: '1', year: '20'} // when checked in the year 2019
      '120' => {month: '12', year: '0'} // when checked in the year 2021
    */ if (firstCharacter === 1) {
        assumedYear = dateString.substr(1);
        return (0, expiration_year_1.expirationYear)(assumedYear).isPotentiallyValid ? 1 : 2;
    }
    /*
      If the length of the value is exactly 5 characters,
      we assume a full year was passed in, meaning the remaining
      single leading digit must be the month value.
  
      '12202' => {month: '1', year: '2202'}
    */ if (dateString.length === 5) return 1;
    /*
      If the length of the value is more than five characters,
      we assume a full year was passed in addition to the month
      and therefore the month portion must be 2 digits.
  
      '112020' => {month: '11', year: '2020'}
    */ if (dateString.length > 5) return 2;
    /*
      By default, the month value is the first value
    */ return 1;
}
function parseDate(datestring) {
    var date;
    if (/^\d{4}-\d{1,2}$/.test(datestring)) date = datestring.split("-").reverse();
    else if (/\//.test(datestring)) date = datestring.split(/\s*\/\s*/g);
    else if (/\s/.test(datestring)) date = datestring.split(/ +/g);
    if ((0, is_array_1.isArray)(date)) return {
        month: date[0] || "",
        year: date.slice(1).join()
    };
    var numberOfDigitsInMonth = getNumberOfMonthDigitsInDateString(datestring);
    var month = datestring.substr(0, numberOfDigitsInMonth);
    return {
        month: month,
        year: datestring.substr(month.length)
    };
}

},{"c88724e2b0e48bb":"bzK5P","6021106b5fe9a350":"fG0lt"}],"bzK5P":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.expirationYear = expirationYear;
var DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE = 19;
function verification(isValid, isPotentiallyValid, isCurrentYear) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid,
        isCurrentYear: isCurrentYear || false
    };
}
function expirationYear(value, maxElapsedYear) {
    if (maxElapsedYear === void 0) maxElapsedYear = DEFAULT_VALID_NUMBER_OF_YEARS_IN_THE_FUTURE;
    var isCurrentYear;
    if (typeof value !== "string") return verification(false, false);
    if (value.replace(/\s/g, "") === "") return verification(false, true);
    if (!/^\d*$/.test(value)) return verification(false, false);
    var len = value.length;
    if (len < 2) return verification(false, true);
    var currentYear = new Date().getFullYear();
    if (len === 3) {
        // 20x === 20x
        var firstTwo = value.slice(0, 2);
        var currentFirstTwo = String(currentYear).slice(0, 2);
        return verification(false, firstTwo === currentFirstTwo);
    }
    if (len > 4) return verification(false, false);
    var numericValue = parseInt(value, 10);
    var twoDigitYear = Number(String(currentYear).substr(2, 2));
    var valid = false;
    if (len === 2) {
        if (String(currentYear).substr(0, 2) === value) return verification(false, true);
        isCurrentYear = twoDigitYear === numericValue;
        valid = numericValue >= twoDigitYear && numericValue <= twoDigitYear + maxElapsedYear;
    } else if (len === 4) {
        isCurrentYear = currentYear === numericValue;
        valid = numericValue >= currentYear && numericValue <= currentYear + maxElapsedYear;
    }
    return verification(valid, valid, isCurrentYear);
}

},{}],"fG0lt":[function(require,module,exports,__globalThis) {
"use strict";
// Polyfill taken from <https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray#Polyfill>.
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isArray = void 0;
exports.isArray = Array.isArray || function(arg) {
    return Object.prototype.toString.call(arg) === "[object Array]";
};

},{}],"hXU2L":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.expirationMonth = expirationMonth;
function verification(isValid, isPotentiallyValid, isValidForThisYear) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid,
        isValidForThisYear: isValidForThisYear || false
    };
}
function expirationMonth(value) {
    var currentMonth = new Date().getMonth() + 1;
    if (typeof value !== "string") return verification(false, false);
    if (value.replace(/\s/g, "") === "" || value === "0") return verification(false, true);
    if (!/^\d*$/.test(value)) return verification(false, false);
    var month = parseInt(value, 10);
    if (isNaN(Number(value))) return verification(false, false);
    var result = month > 0 && month < 13;
    return verification(result, result, result && month >= currentMonth);
}

},{}],"56kMe":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cvv = cvv;
var DEFAULT_LENGTH = 3;
function includes(array, thing) {
    for(var i = 0; i < array.length; i++){
        if (thing === array[i]) return true;
    }
    return false;
}
function max(array) {
    var maximum = DEFAULT_LENGTH;
    var i = 0;
    for(; i < array.length; i++)maximum = array[i] > maximum ? array[i] : maximum;
    return maximum;
}
function verification(isValid, isPotentiallyValid) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid
    };
}
function cvv(value, maxLength) {
    if (maxLength === void 0) maxLength = DEFAULT_LENGTH;
    maxLength = maxLength instanceof Array ? maxLength : [
        maxLength
    ];
    if (typeof value !== "string") return verification(false, false);
    if (!/^\d*$/.test(value)) return verification(false, false);
    if (includes(maxLength, value.length)) return verification(true, true);
    if (value.length < Math.min.apply(null, maxLength)) return verification(false, true);
    if (value.length > max(maxLength)) return verification(false, false);
    return verification(true, true);
}

},{}],"dEG6u":[function(require,module,exports,__globalThis) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.postalCode = postalCode;
var DEFAULT_MIN_POSTAL_CODE_LENGTH = 2;
var ALPHANUM = new RegExp(/^[a-z0-9]+$/i);
function verification(isValid, isPotentiallyValid) {
    return {
        isValid: isValid,
        isPotentiallyValid: isPotentiallyValid
    };
}
function postalCode(value, options) {
    if (options === void 0) options = {};
    var minLength = options.minLength || DEFAULT_MIN_POSTAL_CODE_LENGTH;
    if (typeof value !== "string") return verification(false, false);
    else if (value.length < minLength) return verification(false, true);
    else if (!ALPHANUM.test(value.trim().slice(0, minLength))) return verification(false, true);
    return verification(true, true);
}

},{}],"5jyNn":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "WORLD_COUNTRIES", ()=>WORLD_COUNTRIES);
parcelHelpers.export(exports, "detectBrowserCountry", ()=>detectBrowserCountry);
parcelHelpers.export(exports, "BillingInfoModal", ()=>BillingInfoModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _subscriptionStore = require("src/store/subscriptionStore");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _appAlert = require("src/utils/appAlert");
var _individualSvg = require("src/assets/images/onboarding-trainer/subscription-icons/billing-information/individual.svg");
var _buildingSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/building.svg");
var _subscriptionModalsScss = require("./SubscriptionModals.scss");
const WORLD_COUNTRIES = [
    'Afghanistan',
    'Albania',
    'Algeria',
    'Andorra',
    'Angola',
    'Antigua and Barbuda',
    'Argentina',
    'Armenia',
    'Australia',
    'Austria',
    'Azerbaijan',
    'Bahamas',
    'Bahrain',
    'Bangladesh',
    'Barbados',
    'Belarus',
    'Belgium',
    'Belize',
    'Benin',
    'Bhutan',
    'Bolivia',
    'Bosnia and Herzegovina',
    'Botswana',
    'Brazil',
    'Brunei',
    'Bulgaria',
    'Burkina Faso',
    'Burundi',
    'Cabo Verde',
    'Cambodia',
    'Cameroon',
    'Canada',
    'Central African Republic',
    'Chad',
    'Chile',
    'China',
    'Colombia',
    'Comoros',
    'Congo (Congo-Brazzaville)',
    'Costa Rica',
    'Croatia',
    'Cuba',
    'Cyprus',
    'Czechia (Czech Republic)',
    'Democratic Republic of the Congo',
    'Denmark',
    'Djibouti',
    'Dominica',
    'Dominican Republic',
    'Ecuador',
    'Egypt',
    'El Salvador',
    'Equatorial Guinea',
    'Eritrea',
    'Estonia',
    'Eswatini',
    'Ethiopia',
    'Fiji',
    'Finland',
    'France',
    'Gabon',
    'Gambia',
    'Georgia',
    'Germany',
    'Ghana',
    'Greece',
    'Grenada',
    'Guatemala',
    'Guinea',
    'Guinea-Bissau',
    'Guyana',
    'Haiti',
    'Holy See',
    'Honduras',
    'Hungary',
    'Iceland',
    'India',
    'Indonesia',
    'Iran',
    'Iraq',
    'Ireland',
    'Israel',
    'Italy',
    'Jamaica',
    'Japan',
    'Jordan',
    'Kazakhstan',
    'Kenya',
    'Kiribati',
    'Kuwait',
    'Kyrgyzstan',
    'Laos',
    'Latvia',
    'Lebanon',
    'Lesotho',
    'Liberia',
    'Libya',
    'Liechtenstein',
    'Lithuania',
    'Luxembourg',
    'Madagascar',
    'Malawi',
    'Malaysia',
    'Maldives',
    'Mali',
    'Malta',
    'Marshall Islands',
    'Mauritania',
    'Mauritius',
    'Mexico',
    'Micronesia',
    'Moldova',
    'Monaco',
    'Mongolia',
    'Montenegro',
    'Morocco',
    'Mozambique',
    'Myanmar (Burma)',
    'Namibia',
    'Nauru',
    'Nepal',
    'Netherlands',
    'New Zealand',
    'Nicaragua',
    'Niger',
    'Nigeria',
    'North Korea',
    'North Macedonia',
    'Norway',
    'Oman',
    'Pakistan',
    'Palau',
    'Palestine State',
    'Panama',
    'Papua New Guinea',
    'Paraguay',
    'Peru',
    'Philippines',
    'Poland',
    'Portugal',
    'Qatar',
    'Romania',
    'Russia',
    'Rwanda',
    'Saint Kitts and Nevis',
    'Saint Lucia',
    'Saint Vincent and the Grenadines',
    'Samoa',
    'San Marino',
    'Sao Tome and Principe',
    'Saudi Arabia',
    'Senegal',
    'Serbia',
    'Seychelles',
    'Sierra Leone',
    'Singapore',
    'Slovakia',
    'Slovenia',
    'Solomon Islands',
    'Somalia',
    'South Africa',
    'South Korea',
    'South Sudan',
    'Spain',
    'Sri Lanka',
    'Sudan',
    'Suriname',
    'Sweden',
    'Switzerland',
    'Syria',
    'Taiwan',
    'Tajikistan',
    'Tanzania',
    'Thailand',
    'Timor-Leste',
    'Togo',
    'Tonga',
    'Trinidad and Tobago',
    'Tunisia',
    'Turkey',
    'Turkmenistan',
    'Tuvalu',
    'Uganda',
    'Ukraine',
    'United Arab Emirates',
    'United Kingdom',
    'United States',
    'Uruguay',
    'Uzbekistan',
    'Vanuatu',
    'Venezuela',
    'Vietnam',
    'Yemen',
    'Zambia',
    'Zimbabwe'
];
const findMatchingCountry = (countryName)=>{
    if (!countryName) return undefined;
    const normalized = countryName.trim().toLowerCase();
    // Exact match
    const exact = WORLD_COUNTRIES.find((c)=>c.toLowerCase() === normalized);
    if (exact) return exact;
    // Partial / alias match
    return WORLD_COUNTRIES.find((c)=>c.toLowerCase().includes(normalized) || normalized.includes(c.toLowerCase()));
};
const detectBrowserCountry = ()=>{
    try {
        // 1. Gather all potential locale strings from the browser
        const candidateLocales = [];
        // From resolved Intl options
        const resolvedLocale = Intl.DateTimeFormat().resolvedOptions().locale;
        if (resolvedLocale) candidateLocales.push(resolvedLocale);
        // From navigator.languages / navigator.language
        if (typeof navigator !== 'undefined') {
            if (Array.isArray(navigator.languages)) candidateLocales.push(...navigator.languages);
            if (navigator.language) candidateLocales.push(navigator.language);
        }
        // 2. Iterate through candidate locales to extract standard ISO region code
        for (const localeStr of candidateLocales){
            if (!localeStr) continue;
            let regionCode;
            // Use Intl.Locale if available
            if (typeof Intl.Locale === 'function') try {
                const localeObj = new Intl.Locale(localeStr);
                regionCode = localeObj.region;
                if (!regionCode && typeof localeObj.maximize === 'function') regionCode = localeObj.maximize().region;
            } catch  {
            // Ignore invalid locale string parse errors
            }
            // Regex fallback if Intl.Locale did not yield region
            if (!regionCode) {
                const match = localeStr.match(/[-_]([A-Za-z]{2})\b/);
                if (match) regionCode = match[1].toUpperCase();
            }
            if (regionCode && regionCode.length === 2) {
                if (typeof Intl.DisplayNames === 'function') {
                    const regionNames = new Intl.DisplayNames([
                        'en'
                    ], {
                        type: 'region'
                    });
                    const englishName = regionNames.of(regionCode);
                    if (englishName) {
                        const matched = findMatchingCountry(englishName);
                        if (matched) return matched;
                    }
                }
            }
        }
        // 3. TimeZone-based dynamic resolution
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (timeZone) for (const c of WORLD_COUNTRIES){
            const cleanCountry = c.toLowerCase().replace(/[^a-z]/g, '');
            const cleanTz = timeZone.toLowerCase().replace(/[^a-z]/g, '');
            if (cleanCountry.length > 3 && cleanTz.includes(cleanCountry)) return c;
        }
    } catch  {
    // Fallback safely
    }
    return 'India';
};
const SearchableCountrySelect = ({ value, onChange, onBlur, hasError })=>{
    const [isOpen, setIsOpen] = (0, _react.useState)(false);
    const [searchQuery, setSearchQuery] = (0, _react.useState)('');
    const dropdownRef = (0, _react.useRef)(null);
    const searchInputRef = (0, _react.useRef)(null);
    (0, _react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) setIsOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    (0, _react.useEffect)(()=>{
        if (isOpen) setTimeout(()=>{
            searchInputRef.current?.focus();
        }, 50);
        else setSearchQuery('');
    }, [
        isOpen
    ]);
    const filteredCountries = WORLD_COUNTRIES.filter((c)=>c.toLowerCase().includes(searchQuery.toLowerCase().trim()));
    const handleSelect = (c)=>{
        onChange(c);
        setIsOpen(false);
        onBlur();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `custom-country-select-wrapper ${isOpen ? 'is-open' : ''}`,
        ref: dropdownRef,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                type: "button",
                id: "billing-country-trigger",
                className: `custom-country-trigger ${hasError ? 'has-error' : ''} ${!value ? 'is-placeholder' : ''}`,
                onClick: ()=>setIsOpen((prev)=>!prev),
                "aria-haspopup": "listbox",
                "aria-expanded": isOpen,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "selected-country-label",
                        children: value || 'Choose from list'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                        className: `dropdown-chevron ${isOpen ? 'open' : ''}`,
                        width: "16",
                        height: "16",
                        viewBox: "0 0 24 24",
                        fill: "none",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                            d: "M6 9L12 15L18 9",
                            stroke: "rgba(255,255,255,0.4)",
                            strokeWidth: "2",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        })
                    })
                ]
            }),
            isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "custom-country-dropdown-menu",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "search-input-box",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                className: "search-icon",
                                width: "14",
                                height: "14",
                                viewBox: "0 0 24 24",
                                fill: "none",
                                stroke: "rgba(255,255,255,0.4)",
                                strokeWidth: "2",
                                strokeLinecap: "round",
                                strokeLinejoin: "round",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                                        cx: "11",
                                        cy: "11",
                                        r: "8"
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                        x1: "21",
                                        y1: "21",
                                        x2: "16.65",
                                        y2: "16.65"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                ref: searchInputRef,
                                type: "text",
                                placeholder: "Search country...",
                                value: searchQuery,
                                onChange: (e)=>setSearchQuery(e.target.value),
                                onClick: (e)=>e.stopPropagation()
                            }),
                            searchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "clear-search-btn",
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    setSearchQuery('');
                                    searchInputRef.current?.focus();
                                },
                                children: "\xd7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "country-list-scroll",
                        children: filteredCountries.length > 0 ? filteredCountries.map((c)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: `country-item ${c === value ? 'selected' : ''}`,
                                onClick: ()=>handleSelect(c),
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: c
                                    }),
                                    c === value && /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                        width: "14",
                                        height: "14",
                                        viewBox: "0 0 24 24",
                                        fill: "none",
                                        stroke: "#ffa100",
                                        strokeWidth: "2.5",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                            points: "20 6 9 17 4 12"
                                        })
                                    })
                                ]
                            }, c)) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "no-countries-found",
                            children: 'No country found'
                        })
                    })
                ]
            })
        ]
    });
};
const BillingInfoModal = ({ isOpen, onClose, onSuccess })=>{
    const { billingInfo, updateBillingInfo } = (0, _subscriptionStore.useSubscriptionStore)();
    const saveProfileMutation = (0, _useSubscriptionApi.useSaveBillingProfileMutation)();
    const { data: serverProfile } = (0, _useSubscriptionApi.useBillingProfileQuery)(isOpen);
    const [billingType, setBillingType] = (0, _react.useState)(serverProfile?.billingType || billingInfo.billingType || 'individual');
    const [individualData, setIndividualData] = (0, _react.useState)({
        fullName: '',
        billingEmail: '',
        country: detectBrowserCountry(),
        stateRegion: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        postcode: '',
        taxVatNumber: ''
    });
    const [businessData, setBusinessData] = (0, _react.useState)({
        companyName: '',
        billingEmail: '',
        country: detectBrowserCountry(),
        stateRegion: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        postcode: '',
        companyRegistrationNumber: '',
        taxVatNumber: ''
    });
    const [isDefault, setIsDefault] = (0, _react.useState)(billingInfo.isDefault ?? true);
    const [errors, setErrors] = (0, _react.useState)({});
    const [touched, setTouched] = (0, _react.useState)({});
    (0, _react.useEffect)(()=>{
        if (isOpen) {
            const source = serverProfile && (serverProfile.fullName || serverProfile.companyName || serverProfile.addressLine1) ? {
                billingType: serverProfile.billingType || billingInfo.billingType,
                fullName: serverProfile.fullName || billingInfo.fullName,
                companyName: serverProfile.companyName || billingInfo.companyName,
                billingEmail: serverProfile.billingEmail || billingInfo.billingEmail,
                country: serverProfile.country || billingInfo.country,
                stateRegion: serverProfile.stateRegion || billingInfo.stateRegion,
                addressLine1: serverProfile.addressLine1 || billingInfo.addressLine1,
                addressLine2: serverProfile.addressLine2 || billingInfo.addressLine2,
                city: serverProfile.city || billingInfo.city,
                postcode: serverProfile.postcode || billingInfo.postcode,
                companyRegistrationNumber: serverProfile.companyRegistrationNumber || billingInfo.companyRegistrationNumber,
                taxVatNumber: serverProfile.taxVatNumber || billingInfo.taxVatNumber,
                isDefault: serverProfile.isDefault ?? billingInfo.isDefault
            } : billingInfo;
            const activeType = source.billingType || 'individual';
            const isSaved = Boolean(source.fullName || source.companyName || source.addressLine1);
            const chosenCountry = isSaved && source.country ? source.country : detectBrowserCountry();
            setBillingType(activeType);
            if (activeType === 'individual') {
                setIndividualData({
                    fullName: source.fullName || '',
                    billingEmail: source.billingEmail || '',
                    country: chosenCountry,
                    stateRegion: source.stateRegion || '',
                    addressLine1: source.addressLine1 || '',
                    addressLine2: source.addressLine2 || '',
                    city: source.city || '',
                    postcode: source.postcode || '',
                    taxVatNumber: source.taxVatNumber || ''
                });
                setBusinessData({
                    companyName: '',
                    billingEmail: '',
                    country: detectBrowserCountry(),
                    stateRegion: '',
                    addressLine1: '',
                    addressLine2: '',
                    city: '',
                    postcode: '',
                    companyRegistrationNumber: '',
                    taxVatNumber: ''
                });
            } else {
                setBusinessData({
                    companyName: source.companyName || '',
                    billingEmail: source.billingEmail || '',
                    country: chosenCountry,
                    stateRegion: source.stateRegion || '',
                    addressLine1: source.addressLine1 || '',
                    addressLine2: source.addressLine2 || '',
                    city: source.city || '',
                    postcode: source.postcode || '',
                    companyRegistrationNumber: source.companyRegistrationNumber || '',
                    taxVatNumber: source.taxVatNumber || ''
                });
                setIndividualData({
                    fullName: '',
                    billingEmail: '',
                    country: detectBrowserCountry(),
                    stateRegion: '',
                    addressLine1: '',
                    addressLine2: '',
                    city: '',
                    postcode: '',
                    taxVatNumber: ''
                });
            }
            setIsDefault(source.isDefault ?? true);
            setErrors({});
            setTouched({});
        }
    }, [
        isOpen,
        billingInfo,
        serverProfile
    ]);
    const handleSwitchBillingType = (type)=>{
        if (type === billingType) return;
        setBillingType(type);
        setErrors({});
        setTouched({});
    };
    const handleBlur = (field, value)=>{
        setTouched((prev)=>({
                ...prev,
                [field]: true
            }));
        validateField(field, value.trim());
    };
    const validateField = (field, value)=>{
        let error = '';
        const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (field === 'fullName' && billingType === 'individual') {
            if (!value.trim()) error = 'Full Name is required';
            else if (!/\p{L}/u.test(value)) error = 'Full Name must contain letters';
        } else if (field === 'companyName' && billingType === 'business') {
            if (!value.trim()) error = 'Company Name is required';
            else if (!/\p{L}/u.test(value)) error = 'Company Name must contain letters';
        } else if (field === 'billingEmail') {
            if (!value.trim()) error = 'Billing Email is required';
            else if (!emailRegex.test(value.trim())) error = 'Please enter a valid email address';
        } else if (field === 'country') {
            if (!value.trim()) error = 'Country is required';
            else if (!WORLD_COUNTRIES.includes(value.trim())) error = 'Please select a valid country';
        } else if (field === 'addressLine1') {
            if (!value.trim()) error = 'Address Line 1 is required';
        } else if (field === 'city') {
            if (!value.trim()) error = 'City is required';
            else if (!/\p{L}/u.test(value)) error = 'City must contain letters';
        } else if (field === 'postcode') {
            if (!value.trim()) error = 'Postcode is required';
        }
        setErrors((prev)=>({
                ...prev,
                [field]: error
            }));
        return !error;
    };
    const handleSave = ()=>{
        const isInd = billingType === 'individual';
        const newErrors = {};
        const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
        if (isInd) {
            if (!individualData.fullName.trim()) newErrors.fullName = 'Full Name is required';
            else if (!/\p{L}/u.test(individualData.fullName)) newErrors.fullName = 'Full Name must contain letters';
            if (!individualData.billingEmail.trim()) newErrors.billingEmail = 'Billing Email is required';
            else if (!emailRegex.test(individualData.billingEmail.trim())) newErrors.billingEmail = 'Please enter a valid email address';
            if (!individualData.country.trim()) newErrors.country = 'Country is required';
            else if (!WORLD_COUNTRIES.includes(individualData.country.trim())) newErrors.country = 'Please select a valid country';
            if (!individualData.addressLine1.trim()) newErrors.addressLine1 = 'Address Line 1 is required';
            if (!individualData.city.trim()) newErrors.city = 'City is required';
            else if (!/\p{L}/u.test(individualData.city)) newErrors.city = 'City must contain letters';
            if (!individualData.postcode.trim()) newErrors.postcode = 'Postcode is required';
            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                setTouched({
                    fullName: true,
                    billingEmail: true,
                    country: true,
                    addressLine1: true,
                    city: true,
                    postcode: true
                });
                return;
            }
            const updated = {
                billingType: 'individual',
                fullName: individualData.fullName.trim(),
                companyName: '',
                billingEmail: individualData.billingEmail.trim(),
                country: individualData.country.trim(),
                stateRegion: individualData.stateRegion.trim(),
                addressLine1: individualData.addressLine1.trim(),
                addressLine2: individualData.addressLine2.trim(),
                city: individualData.city.trim(),
                postcode: individualData.postcode.trim(),
                companyRegistrationNumber: '',
                taxVatNumber: individualData.taxVatNumber.trim(),
                isDefault
            };
            saveProfileMutation.mutate(updated, {
                onSuccess: ()=>{
                    updateBillingInfo(updated);
                    (0, _appAlert.toast).success('Billing information saved.');
                    if (onSuccess) onSuccess();
                    onClose();
                },
                onError: (err)=>{
                    if (err.fieldErrors) setErrors(err.fieldErrors);
                    (0, _appAlert.toast).error(err.userMessage || 'Failed to save billing information.');
                }
            });
        } else {
            if (!businessData.companyName.trim()) newErrors.companyName = 'Company Name is required';
            else if (!/\p{L}/u.test(businessData.companyName)) newErrors.companyName = 'Company Name must contain letters';
            if (!businessData.billingEmail.trim()) newErrors.billingEmail = 'Billing Email is required';
            else if (!emailRegex.test(businessData.billingEmail.trim())) newErrors.billingEmail = 'Please enter a valid email address';
            if (!businessData.country.trim()) newErrors.country = 'Country is required';
            else if (!WORLD_COUNTRIES.includes(businessData.country.trim())) newErrors.country = 'Please select a valid country';
            if (!businessData.addressLine1.trim()) newErrors.addressLine1 = 'Address Line 1 is required';
            if (!businessData.city.trim()) newErrors.city = 'City is required';
            else if (!/\p{L}/u.test(businessData.city)) newErrors.city = 'City must contain letters';
            if (!businessData.postcode.trim()) newErrors.postcode = 'Postcode is required';
            if (Object.keys(newErrors).length > 0) {
                setErrors(newErrors);
                setTouched({
                    companyName: true,
                    billingEmail: true,
                    country: true,
                    addressLine1: true,
                    city: true,
                    postcode: true
                });
                return;
            }
            const updated = {
                billingType: 'business',
                fullName: '',
                companyName: businessData.companyName.trim(),
                billingEmail: businessData.billingEmail.trim(),
                country: businessData.country.trim(),
                stateRegion: businessData.stateRegion.trim(),
                addressLine1: businessData.addressLine1.trim(),
                addressLine2: businessData.addressLine2.trim(),
                city: businessData.city.trim(),
                postcode: businessData.postcode.trim(),
                companyRegistrationNumber: businessData.companyRegistrationNumber.trim(),
                taxVatNumber: businessData.taxVatNumber.trim(),
                isDefault
            };
            saveProfileMutation.mutate(updated, {
                onSuccess: ()=>{
                    updateBillingInfo(updated);
                    (0, _appAlert.toast).success('Billing information saved.');
                    if (onSuccess) onSuccess();
                    onClose();
                },
                onError: (err)=>{
                    if (err.fieldErrors) setErrors(err.fieldErrors);
                    (0, _appAlert.toast).error(err.userMessage || 'Failed to save billing information.');
                }
            });
        }
    };
    const isIndividual = billingType === 'individual';
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        onCancel: onClose,
        footer: null,
        centered: true,
        width: 640,
        closeIcon: null,
        rootClassName: "subscription-modal-wrapper",
        styles: {
            mask: {
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(6, 7, 35, 0.75)'
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
            onSubmit: (e)=>{
                e.preventDefault();
                handleSave();
            },
            noValidate: true,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                            children: 'Billing Information'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: 'These information will be used for invoices and receipts'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-group",
                    style: {
                        marginBottom: 16
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            children: 'Billing type'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "billing-type-tabs",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    type: "button",
                                    className: `type-tab-btn ${isIndividual ? 'active' : ''}`,
                                    onClick: ()=>handleSwitchBillingType('individual'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _individualSvg.ReactComponent), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: 'Individual'
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    type: "button",
                                    className: `type-tab-btn ${!isIndividual ? 'active' : ''}`,
                                    onClick: ()=>handleSwitchBillingType('business'),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buildingSvg.ReactComponent), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: 'Business'
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-row stack-on-mobile",
                    children: [
                        isIndividual ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "billing-full-name",
                                    children: 'FULL NAME*'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "billing-full-name",
                                    type: "text",
                                    value: individualData.fullName,
                                    maxLength: 70,
                                    className: touched.fullName && errors.fullName ? 'has-error' : '',
                                    onChange: (e)=>setIndividualData((prev)=>({
                                                ...prev,
                                                fullName: e.target.value
                                            })),
                                    onBlur: (e)=>{
                                        setIndividualData((prev)=>({
                                                ...prev,
                                                fullName: e.target.value.trim()
                                            }));
                                        handleBlur('fullName', e.target.value);
                                    }
                                }),
                                touched.fullName && errors.fullName && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "error-text",
                                    children: errors.fullName
                                })
                            ]
                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "billing-company-name",
                                    children: 'COMPANY NAME*'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "billing-company-name",
                                    type: "text",
                                    value: businessData.companyName,
                                    maxLength: 100,
                                    className: touched.companyName && errors.companyName ? 'has-error' : '',
                                    onChange: (e)=>setBusinessData((prev)=>({
                                                ...prev,
                                                companyName: e.target.value
                                            })),
                                    onBlur: (e)=>{
                                        setBusinessData((prev)=>({
                                                ...prev,
                                                companyName: e.target.value.trim()
                                            }));
                                        handleBlur('companyName', e.target.value);
                                    }
                                }),
                                touched.companyName && errors.companyName && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "error-text",
                                    children: errors.companyName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "billing-email",
                                    children: 'BILLING EMAIL*'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "billing-email",
                                    type: "email",
                                    value: isIndividual ? individualData.billingEmail : businessData.billingEmail,
                                    maxLength: 255,
                                    className: touched.billingEmail && errors.billingEmail ? 'has-error' : '',
                                    onChange: (e)=>{
                                        const val = e.target.value;
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                billingEmail: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                billingEmail: val
                                            }));
                                    },
                                    onBlur: (e)=>{
                                        const val = e.target.value.trim();
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                billingEmail: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                billingEmail: val
                                            }));
                                        handleBlur('billingEmail', e.target.value);
                                    }
                                }),
                                touched.billingEmail && errors.billingEmail && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "error-text",
                                    children: errors.billingEmail
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-row stack-on-mobile",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "billing-country-trigger",
                                    children: 'COUNTRY*'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(SearchableCountrySelect, {
                                    value: isIndividual ? individualData.country : businessData.country,
                                    onChange: (val)=>{
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                country: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                country: val
                                            }));
                                        validateField('country', val);
                                    },
                                    onBlur: ()=>handleBlur('country', isIndividual ? individualData.country : businessData.country),
                                    hasError: touched.country && !!errors.country
                                }),
                                touched.country && errors.country && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "error-text",
                                    children: errors.country
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "billing-state",
                                    children: 'STATE/REGION (OPTIONAL)'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "billing-state",
                                    type: "text",
                                    value: isIndividual ? individualData.stateRegion : businessData.stateRegion,
                                    maxLength: 60,
                                    onChange: (e)=>{
                                        const val = e.target.value;
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                stateRegion: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                stateRegion: val
                                            }));
                                    },
                                    onBlur: (e)=>{
                                        const val = e.target.value.trim();
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                stateRegion: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                stateRegion: val
                                            }));
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-row stack-on-mobile",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "billing-address-1",
                                    children: 'ADDRESS LINE 1*'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "billing-address-1",
                                    type: "text",
                                    value: isIndividual ? individualData.addressLine1 : businessData.addressLine1,
                                    maxLength: 120,
                                    className: touched.addressLine1 && errors.addressLine1 ? 'has-error' : '',
                                    onChange: (e)=>{
                                        const val = e.target.value;
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                addressLine1: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                addressLine1: val
                                            }));
                                    },
                                    onBlur: (e)=>{
                                        const val = e.target.value.trim();
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                addressLine1: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                addressLine1: val
                                            }));
                                        handleBlur('addressLine1', e.target.value);
                                    }
                                }),
                                touched.addressLine1 && errors.addressLine1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "error-text",
                                    children: errors.addressLine1
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "billing-address-2",
                                    children: 'ADDRESS LINE 2 (OPTIONAL)'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "billing-address-2",
                                    type: "text",
                                    value: isIndividual ? individualData.addressLine2 : businessData.addressLine2,
                                    maxLength: 120,
                                    onChange: (e)=>{
                                        const val = e.target.value;
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                addressLine2: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                addressLine2: val
                                            }));
                                    },
                                    onBlur: (e)=>{
                                        const val = e.target.value.trim();
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                addressLine2: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                addressLine2: val
                                            }));
                                    }
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-row",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "billing-city",
                                    children: 'CITY*'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "billing-city",
                                    type: "text",
                                    value: isIndividual ? individualData.city : businessData.city,
                                    maxLength: 60,
                                    className: touched.city && errors.city ? 'has-error' : '',
                                    onChange: (e)=>{
                                        const val = e.target.value;
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                city: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                city: val
                                            }));
                                    },
                                    onBlur: (e)=>{
                                        const val = e.target.value.trim();
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                city: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                city: val
                                            }));
                                        handleBlur('city', e.target.value);
                                    }
                                }),
                                touched.city && errors.city && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "error-text",
                                    children: errors.city
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "billing-postcode",
                                    children: 'POSTCODE*'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "billing-postcode",
                                    type: "text",
                                    value: isIndividual ? individualData.postcode : businessData.postcode,
                                    maxLength: 20,
                                    className: touched.postcode && errors.postcode ? 'has-error' : '',
                                    onChange: (e)=>{
                                        const val = e.target.value;
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                postcode: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                postcode: val
                                            }));
                                    },
                                    onBlur: (e)=>{
                                        const val = e.target.value.trim();
                                        if (isIndividual) setIndividualData((prev)=>({
                                                ...prev,
                                                postcode: val
                                            }));
                                        else setBusinessData((prev)=>({
                                                ...prev,
                                                postcode: val
                                            }));
                                        handleBlur('postcode', e.target.value);
                                    }
                                }),
                                touched.postcode && errors.postcode && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "error-text",
                                    children: errors.postcode
                                })
                            ]
                        })
                    ]
                }),
                !isIndividual ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "form-row stack-on-mobile",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "billing-company-reg",
                                    children: 'COMPANY REGISTRATION NUMBER (OPTIONAL)'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "billing-company-reg",
                                    type: "text",
                                    value: businessData.companyRegistrationNumber,
                                    maxLength: 30,
                                    onChange: (e)=>setBusinessData((prev)=>({
                                                ...prev,
                                                companyRegistrationNumber: e.target.value
                                            })),
                                    onBlur: (e)=>setBusinessData((prev)=>({
                                                ...prev,
                                                companyRegistrationNumber: e.target.value.trim()
                                            }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "form-group",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                    htmlFor: "billing-tax-vat",
                                    children: 'TAX / VAT NUMBER (OPTIONAL)'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                    id: "billing-tax-vat",
                                    type: "text",
                                    value: businessData.taxVatNumber,
                                    maxLength: 30,
                                    onChange: (e)=>setBusinessData((prev)=>({
                                                ...prev,
                                                taxVatNumber: e.target.value
                                            })),
                                    onBlur: (e)=>setBusinessData((prev)=>({
                                                ...prev,
                                                taxVatNumber: e.target.value.trim()
                                            }))
                                })
                            ]
                        })
                    ]
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "form-row single",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "billing-tax-vat",
                                children: 'TAX / VAT NUMBER (OPTIONAL)'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                id: "billing-tax-vat",
                                type: "text",
                                value: individualData.taxVatNumber,
                                maxLength: 30,
                                onChange: (e)=>setIndividualData((prev)=>({
                                            ...prev,
                                            taxVatNumber: e.target.value
                                        })),
                                onBlur: (e)=>setIndividualData((prev)=>({
                                            ...prev,
                                            taxVatNumber: e.target.value.trim()
                                        }))
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                    className: "checkbox-group",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                            type: "checkbox",
                            checked: isDefault,
                            onChange: (e)=>setIsDefault(e.target.checked)
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            children: 'Set as default billing information'
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-cancel",
                            onClick: onClose,
                            children: 'Cancel'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "submit",
                            className: "btn-save",
                            disabled: saveProfileMutation.isPending,
                            children: saveProfileMutation.isPending ? 'Saving...' : 'Save'
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"src/store/subscriptionStore":"rMPpj","src/api/subscription/useSubscriptionApi":"5YJAT","src/utils/appAlert":"de4Mq","src/assets/images/onboarding-trainer/subscription-icons/billing-information/individual.svg":"1Uzg0","src/assets/images/onboarding-trainer/subscription-icons/common/building.svg":"6pE4f","./SubscriptionModals.scss":"lcfUX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Uzg0":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgIndividual);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgIndividual = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 18,
        fill: "none",
        viewBox: "0 0 15 18",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M7.5 8.75A4.375 4.375 0 1 0 7.5 0a4.375 4.375 0 0 0 0 8.75M2.188 10A2.19 2.19 0 0 0 0 12.188v.312c0 1.496.952 2.76 2.303 3.62 1.359.866 3.198 1.38 5.197 1.38s3.838-.514 5.197-1.38C14.048 15.26 15 13.997 15 12.5v-.312A2.19 2.19 0 0 0 12.813 10z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6pE4f":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBuilding);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBuilding = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeWidth: 2,
                d: "M3 21h18"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M5 21V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeWidth: 2,
                d: "M9 7h2M13 7h2M9 11h2M13 11h2M9 15h2M13 15h2"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcfUX":[function() {},{}],"9Ak0b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaymentMethodModal", ()=>PaymentMethodModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _stripeJs = require("@stripe/stripe-js");
var _reactStripeJs = require("@stripe/react-stripe-js");
var _antd = require("antd");
var _subscriptionStore = require("src/store/subscriptionStore");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _appAlert = require("src/utils/appAlert");
var _cardSvg = require("src/assets/images/onboarding-trainer/subscription-icons/add-payment-method/card.svg");
var _cvvHintSvg = require("src/assets/images/onboarding-trainer/subscription-icons/add-payment-method/cvv-hint.svg");
var _cardBrandLogo = require("../components/CardBrandLogo");
var _cardUtils = require("src/utils/cardUtils");
var _subscriptionModalsScss = require("./SubscriptionModals.scss");
const stripeElementOptions = {
    style: {
        base: {
            color: '#ffffff',
            fontFamily: 'Poppins, sans-serif',
            fontSize: '13px',
            fontSmoothing: 'antialiased',
            '::placeholder': {
                color: 'rgba(255, 255, 255, 0.3)'
            }
        },
        invalid: {
            color: '#ff8a8a'
        }
    }
};
const getCardBrand = (brand)=>{
    const supportedBrands = [
        'visa',
        'mastercard',
        'amex',
        'discover',
        'jcb',
        'diners',
        'unionpay',
        'maestro'
    ];
    return supportedBrands.includes(brand) ? brand : 'generic';
};
const PaymentMethodForm = ({ isOpen, onClose, cardToEdit, onSuccess })=>{
    const stripe = (0, _reactStripeJs.useStripe)();
    const elements = (0, _reactStripeJs.useElements)();
    const { addPaymentMethod, updatePaymentMethod, paymentMethods: storePaymentMethods } = (0, _subscriptionStore.useSubscriptionStore)();
    const { data: serverPaymentMethods } = (0, _useSubscriptionApi.usePaymentMethodsQuery)(isOpen);
    const createSetupIntentMutation = (0, _useSubscriptionApi.useCreateSetupIntentMutation)();
    const savePaymentMutation = (0, _useSubscriptionApi.useSavePaymentMethodMutation)();
    const existingCards = serverPaymentMethods?.payment_methods ?? storePaymentMethods ?? [];
    const existingCardsCount = existingCards.length;
    // If user has 0 cards or is editing their only card (<= 1 card), it must be default and cannot be changed
    const isDefaultForced = existingCardsCount === 0 || Boolean(cardToEdit) && existingCardsCount <= 1;
    const [cardholderName, setCardholderName] = (0, _react.useState)('');
    const [isDefault, setIsDefault] = (0, _react.useState)(true);
    const [cardBrand, setCardBrand] = (0, _react.useState)('generic');
    const [errors, setErrors] = (0, _react.useState)({});
    const [touched, setTouched] = (0, _react.useState)({});
    const [stripeFields, setStripeFields] = (0, _react.useState)({
        cardNumber: {
            complete: false,
            error: ''
        },
        expiry: {
            complete: false,
            error: ''
        },
        cvc: {
            complete: false,
            error: ''
        }
    });
    const resetForm = (0, _react.useCallback)(()=>{
        setCardholderName('');
        setIsDefault(true);
        setCardBrand('generic');
        setErrors({});
        setTouched({});
        setStripeFields({
            cardNumber: {
                complete: false,
                error: ''
            },
            expiry: {
                complete: false,
                error: ''
            },
            cvc: {
                complete: false,
                error: ''
            }
        });
        if (elements) {
            elements.getElement((0, _reactStripeJs.CardNumberElement))?.clear();
            elements.getElement((0, _reactStripeJs.CardExpiryElement))?.clear();
            elements.getElement((0, _reactStripeJs.CardCvcElement))?.clear();
        }
    }, [
        elements
    ]);
    (0, _react.useEffect)(()=>{
        if (isOpen) {
            setCardholderName(cardToEdit?.cardholderName || '');
            setIsDefault(isDefaultForced ? true : cardToEdit?.isDefault ?? false);
            setCardBrand(cardToEdit?.brand || 'generic');
            setErrors({});
            setTouched({});
            setStripeFields({
                cardNumber: {
                    complete: Boolean(cardToEdit),
                    error: ''
                },
                expiry: {
                    complete: Boolean(cardToEdit),
                    error: ''
                },
                cvc: {
                    complete: Boolean(cardToEdit),
                    error: ''
                }
            });
            if (!cardToEdit && elements) {
                elements.getElement((0, _reactStripeJs.CardNumberElement))?.clear();
                elements.getElement((0, _reactStripeJs.CardExpiryElement))?.clear();
                elements.getElement((0, _reactStripeJs.CardCvcElement))?.clear();
            }
        } else resetForm();
    }, [
        isOpen,
        cardToEdit,
        resetForm,
        isDefaultForced,
        elements
    ]);
    const handleStripeChange = (field, event)=>{
        const errorMessage = event.error?.message || '';
        setStripeFields((previous)=>({
                ...previous,
                [field]: {
                    complete: event.complete,
                    error: errorMessage
                }
            }));
        setErrors((previous)=>({
                ...previous,
                [field]: errorMessage
            }));
        if (field === 'cardNumber' && event.brand) setCardBrand(getCardBrand(event.brand));
    };
    const handleStripeBlur = (field)=>{
        setTouched((previous)=>({
                ...previous,
                [field]: true
            }));
    };
    const validateName = ()=>{
        const error = (0, _cardUtils.validateCardholderName)(cardholderName.trim());
        setErrors((previous)=>({
                ...previous,
                cardholderName: error
            }));
        setTouched((previous)=>({
                ...previous,
                cardholderName: true
            }));
        return !error;
    };
    const handleSave = async ()=>{
        const nextErrors = {};
        if (!cardToEdit) [
            'cardNumber',
            'expiry',
            'cvc'
        ].forEach((field)=>{
            if (!stripeFields[field].complete) nextErrors[field] = stripeFields[field].error || 'Please complete this field.';
        });
        const nameError = (0, _cardUtils.validateCardholderName)(cardholderName.trim());
        if (nameError) nextErrors.cardholderName = nameError;
        if (Object.keys(nextErrors).length > 0) {
            setErrors(nextErrors);
            setTouched({
                cardNumber: true,
                expiry: true,
                cvc: true,
                cardholderName: true
            });
            return;
        }
        try {
            let paymentMethodId = cardToEdit?.id;
            if (!cardToEdit) {
                if (!stripe || !elements) {
                    (0, _appAlert.toast).error('Secure card fields are still loading. Please try again.');
                    return;
                }
                const cardNumberElement = elements.getElement((0, _reactStripeJs.CardNumberElement));
                if (!cardNumberElement) {
                    (0, _appAlert.toast).error('Secure card fields are unavailable. Please reopen the form.');
                    return;
                }
                const setupIntent = await createSetupIntentMutation.mutateAsync();
                const confirmation = await stripe.confirmCardSetup(setupIntent.client_secret, {
                    payment_method: {
                        card: cardNumberElement,
                        billing_details: {
                            name: cardholderName.trim()
                        }
                    }
                });
                if (confirmation.error) {
                    const message = confirmation.error.message || 'Could not validate your card.';
                    setErrors((previous)=>({
                            ...previous,
                            cardNumber: message
                        }));
                    setTouched((previous)=>({
                            ...previous,
                            cardNumber: true
                        }));
                    (0, _appAlert.toast).error(message);
                    return;
                }
                const confirmedPaymentMethod = confirmation.setupIntent?.payment_method;
                paymentMethodId = typeof confirmedPaymentMethod === 'string' ? confirmedPaymentMethod : confirmedPaymentMethod?.id;
                if (confirmation.setupIntent?.status !== 'succeeded' || !paymentMethodId) {
                    (0, _appAlert.toast).error('The card could not be verified. Please try another card.');
                    return;
                }
            }
            if (!paymentMethodId) {
                (0, _appAlert.toast).error('A payment method is required.');
                return;
            }
            const savedCard = await savePaymentMutation.mutateAsync({
                payment_method_id: paymentMethodId,
                cardholder_name: cardholderName.trim(),
                is_default: isDefaultForced ? true : isDefault
            });
            if (cardToEdit) updatePaymentMethod(cardToEdit.id, {
                expiry: savedCard?.expiry || cardToEdit.expiry,
                cardholderName: cardholderName.trim(),
                isDefault: isDefaultForced ? true : isDefault
            });
            else addPaymentMethod({
                brand: getCardBrand(savedCard?.brand) || cardBrand,
                last4: savedCard?.last4 || '',
                expiry: savedCard?.expiry || '',
                cardholderName: cardholderName.trim(),
                isDefault: isDefaultForced ? true : isDefault
            });
            (0, _appAlert.toast).success('Payment method saved successfully.');
            onSuccess?.();
            onClose();
        } catch (error) {
            if (error?.fieldErrors) setErrors(error.fieldErrors);
            (0, _appAlert.toast).error(error?.userMessage || 'Failed to save card. Please try again.');
        }
    };
    const handleModalClose = ()=>{
        resetForm();
        onClose();
    };
    const isSaving = createSetupIntentMutation.isPending || savePaymentMutation.isPending;
    const cardNumberError = touched.cardNumber ? errors.cardNumber : '';
    const expiryError = touched.expiry ? errors.expiry : '';
    const cvcError = touched.cvc ? errors.cvc : '';
    const nameError = touched.cardholderName ? errors.cardholderName : '';
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
        onSubmit: (event)=>{
            event.preventDefault();
            handleSave();
        },
        noValidate: true,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "modal-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                        children: cardToEdit ? 'Edit Payment Method' : 'Add Payment Method'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: 'Add a card to start your Pro subscription'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    marginBottom: 16
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                    style: {
                        fontSize: 13,
                        fontWeight: 600,
                        color: '#ffffff'
                    },
                    children: 'Card Details'
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group",
                style: {
                    marginBottom: 16
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "modal-card-number",
                        children: 'CARD NUMBER'
                    }),
                    cardToEdit ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "input-wrapper",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                id: "modal-card-number",
                                type: "text",
                                value: `\u{2022}\u{2022}\u{2022}\u{2022} \u{2022}\u{2022}\u{2022}\u{2022} \u{2022}\u{2022}\u{2022}\u{2022} ${cardToEdit.last4}`,
                                readOnly: true,
                                "aria-label": "Saved card number"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "input-icon-right",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                    brand: cardToEdit.brand,
                                    className: "card-brand-preview",
                                    "aria-label": `${cardToEdit.brand} card logo`
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: `stripe-element-wrapper ${cardNumberError ? 'has-error' : ''}`,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactStripeJs.CardNumberElement), {
                                id: "modal-card-number",
                                options: {
                                    ...stripeElementOptions,
                                    placeholder: '1234 1234 1234 1234'
                                },
                                onChange: (event)=>handleStripeChange('cardNumber', event),
                                onBlur: ()=>handleStripeBlur('cardNumber')
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "input-icon-right",
                                children: cardBrand !== 'generic' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                    brand: cardBrand,
                                    className: "card-brand-preview",
                                    "aria-label": `${cardBrand} card logo`
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardSvg.ReactComponent), {
                                    className: "card-generic-icon"
                                })
                            })
                        ]
                    }),
                    cardNumberError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "error-text",
                        children: cardNumberError
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "modal-card-expiry",
                                children: 'EXPIRY DATE'
                            }),
                            cardToEdit ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                id: "modal-card-expiry",
                                type: "text",
                                value: cardToEdit.expiry,
                                readOnly: true
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: `stripe-element-wrapper ${expiryError ? 'has-error' : ''}`,
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactStripeJs.CardExpiryElement), {
                                    id: "modal-card-expiry",
                                    options: {
                                        ...stripeElementOptions,
                                        placeholder: 'MM / YY'
                                    },
                                    onChange: (event)=>handleStripeChange('expiry', event),
                                    onBlur: ()=>handleStripeBlur('expiry')
                                })
                            }),
                            expiryError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "error-text",
                                children: expiryError
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "form-group",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                htmlFor: "modal-card-cvc",
                                children: cardBrand === 'amex' ? 'CID' : 'CVC'
                            }),
                            cardToEdit ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                id: "modal-card-cvc",
                                type: "text",
                                value: "\u2022\u2022\u2022",
                                readOnly: true
                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: `stripe-element-wrapper with-icon-right ${cvcError ? 'has-error' : ''}`,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactStripeJs.CardCvcElement), {
                                        id: "modal-card-cvc",
                                        options: {
                                            ...stripeElementOptions,
                                            placeholder: cardBrand === 'amex' ? '1234' : 'CVC'
                                        },
                                        onChange: (event)=>handleStripeChange('cvc', event),
                                        onBlur: ()=>handleStripeBlur('cvc')
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "input-icon-right",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Tooltip), {
                                            title: cardBrand === 'amex' ? '4-digit CID security code on the front of your card' : '3-digit security code on the back of your card',
                                            placement: "topRight",
                                            rootClassName: "cvv-tooltip-overlay",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "cvv-hint-btn",
                                                "aria-label": `${cardBrand === 'amex' ? 'CID' : 'CVC'} security code hint`,
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cvvHintSvg.ReactComponent), {})
                                            })
                                        })
                                    })
                                ]
                            }),
                            cvcError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "error-text",
                                children: cvcError
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "form-group",
                style: {
                    marginBottom: 16
                },
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                        htmlFor: "modal-cardholder-name",
                        children: 'CARDHOLDER NAME'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        id: "modal-cardholder-name",
                        type: "text",
                        autoComplete: "cc-name",
                        value: cardholderName,
                        maxLength: 50,
                        placeholder: "Name on card",
                        className: nameError ? 'has-error' : '',
                        "aria-required": "true",
                        "aria-invalid": !!nameError,
                        onChange: (event)=>setCardholderName(event.target.value),
                        onBlur: ()=>validateName()
                    }),
                    nameError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        className: "error-text",
                        children: nameError
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                className: `checkbox-group ${isDefaultForced ? 'disabled' : ''}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                        type: "checkbox",
                        checked: isDefaultForced ? true : isDefault,
                        disabled: isDefaultForced,
                        onChange: (event)=>{
                            if (!isDefaultForced) setIsDefault(event.target.checked);
                        }
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                        children: 'Set as default payment method'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "modal-actions",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "btn-cancel",
                        onClick: handleModalClose,
                        children: 'Cancel'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "submit",
                        className: "btn-save",
                        disabled: isSaving,
                        children: isSaving ? 'Saving...' : 'Save'
                    })
                ]
            })
        ]
    });
};
const PaymentMethodModal = (props)=>{
    const { isOpen, cardToEdit } = props;
    const { data: stripeConfig, isLoading, isError } = (0, _useSubscriptionApi.useStripeConfigQuery)(isOpen);
    const stripePromise = (0, _react.useMemo)(()=>stripeConfig?.publishable_key ? (0, _stripeJs.loadStripe)(stripeConfig.publishable_key) : null, [
        stripeConfig
    ]);
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        onCancel: props.onClose,
        footer: null,
        centered: true,
        width: 560,
        closeIcon: null,
        destroyOnHidden: true,
        rootClassName: "subscription-modal-wrapper",
        styles: {
            mask: {
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(6, 7, 35, 0.75)'
            }
        },
        children: isOpen && isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "stripe-loading-message",
            children: 'Loading secure card fields...'
        }) : isOpen && isError && !cardToEdit ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: "stripe-loading-message stripe-error-message",
            children: 'Unable to load secure card fields. Please close and try again.'
        }) : isOpen && stripePromise ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactStripeJs.Elements), {
            stripe: stripePromise,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(PaymentMethodForm, {
                ...props
            })
        }, isOpen ? 'open' : 'closed') : null
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@stripe/stripe-js":"23Dax","@stripe/react-stripe-js":"bBl9I","antd":[["Modal","kY4DD","default"],["Tooltip","aByoO","default"]],"src/store/subscriptionStore":"rMPpj","src/api/subscription/useSubscriptionApi":"5YJAT","src/utils/appAlert":"de4Mq","src/assets/images/onboarding-trainer/subscription-icons/add-payment-method/card.svg":"ijZ2b","src/assets/images/onboarding-trainer/subscription-icons/add-payment-method/cvv-hint.svg":"koZdE","../components/CardBrandLogo":"g5uLF","src/utils/cardUtils":"2ly56","./SubscriptionModals.scss":"lcfUX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bBl9I":[function(require,module,exports,__globalThis) {
(function(global, factory) {
    factory(exports, require("d99b0077bf8bdf43"));
})(this, function(exports1, React) {
    'use strict';
    function _arrayLikeToArray(r, a) {
        (null == a || a > r.length) && (a = r.length);
        for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
        return n;
    }
    function _arrayWithHoles(r) {
        if (Array.isArray(r)) return r;
    }
    function asyncGeneratorStep(n, t, e, r, o, a, c) {
        try {
            var i = n[a](c), u = i.value;
        } catch (n) {
            return void e(n);
        }
        i.done ? t(u) : Promise.resolve(u).then(r, o);
    }
    function _asyncToGenerator(n) {
        return function() {
            var t = this, e = arguments;
            return new Promise(function(r, o) {
                var a = n.apply(t, e);
                function _next(n) {
                    asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
                }
                function _throw(n) {
                    asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
                }
                _next(void 0);
            });
        };
    }
    function _defineProperty(e, r, t) {
        return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
            value: t,
            enumerable: true,
            configurable: true,
            writable: true
        }) : e[r] = t, e;
    }
    function _iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = true, o = false;
            try {
                if (i = (t = t.call(r)).next, 0 === l) ;
                else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = true, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function _nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function _objectSpread2(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? ownKeys(Object(t), true).forEach(function(r) {
                _defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function _objectWithoutProperties(e, t) {
        if (null == e) return {};
        var o, r, i = _objectWithoutPropertiesLoose(e, t);
        if (Object.getOwnPropertySymbols) {
            var n = Object.getOwnPropertySymbols(e);
            for(r = 0; r < n.length; r++)o = n[r], -1 === t.indexOf(o) && ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
        }
        return i;
    }
    function _objectWithoutPropertiesLoose(r, e) {
        if (null == r) return {};
        var t = {};
        for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
            if (-1 !== e.indexOf(n)) continue;
            t[n] = r[n];
        }
        return t;
    }
    function _slicedToArray(r, e) {
        return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
    }
    function _toPrimitive(t, r) {
        if ("object" != typeof t || !t) return t;
        var e = t[Symbol.toPrimitive];
        if (void 0 !== e) {
            var i = e.call(t, r);
            if ("object" != typeof i) return i;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return ("string" === r ? String : Number)(t);
    }
    function _toPropertyKey(t) {
        var i = _toPrimitive(t, "string");
        return "symbol" == typeof i ? i : i + "";
    }
    function _typeof(o) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, _typeof(o);
    }
    function _unsupportedIterableToArray(r, a) {
        if (r) {
            if ("string" == typeof r) return _arrayLikeToArray(r, a);
            var t = ({}).toString.call(r).slice(8, -1);
            return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
        }
    }
    function getDefaultExportFromCjs(x) {
        return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
    }
    var propTypes = {
        exports: {}
    };
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var ReactPropTypesSecret_1;
    var hasRequiredReactPropTypesSecret;
    function requireReactPropTypesSecret() {
        if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
        hasRequiredReactPropTypesSecret = 1;
        var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
        ReactPropTypesSecret_1 = ReactPropTypesSecret;
        return ReactPropTypesSecret_1;
    }
    /**
   * Copyright (c) 2013-present, Facebook, Inc.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */ var factoryWithThrowingShims;
    var hasRequiredFactoryWithThrowingShims;
    function requireFactoryWithThrowingShims() {
        if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
        hasRequiredFactoryWithThrowingShims = 1;
        var ReactPropTypesSecret = requireReactPropTypesSecret();
        function emptyFunction() {}
        function emptyFunctionWithReset() {}
        emptyFunctionWithReset.resetWarningCache = emptyFunction;
        factoryWithThrowingShims = function() {
            function shim(props, propName, componentName, location, propFullName, secret) {
                if (secret === ReactPropTypesSecret) // It is still safe when called from React.
                return;
                var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                err.name = 'Invariant Violation';
                throw err;
            }
            shim.isRequired = shim;
            function getShim() {
                return shim;
            }
            // Important!
            // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
            var ReactPropTypes = {
                array: shim,
                bool: shim,
                func: shim,
                number: shim,
                object: shim,
                string: shim,
                symbol: shim,
                any: shim,
                arrayOf: getShim,
                element: shim,
                elementType: shim,
                instanceOf: getShim,
                node: shim,
                objectOf: getShim,
                oneOf: getShim,
                oneOfType: getShim,
                shape: getShim,
                exact: getShim,
                checkPropTypes: emptyFunctionWithReset,
                resetWarningCache: emptyFunction
            };
            ReactPropTypes.PropTypes = ReactPropTypes;
            return ReactPropTypes;
        };
        return factoryWithThrowingShims;
    }
    // By explicitly using `prop-types` you are opting into new production behavior.
    // http://fb.me/prop-types-in-prod
    propTypes.exports = requireFactoryWithThrowingShims()();
    var propTypesExports = propTypes.exports;
    var PropTypes = /*@__PURE__*/ getDefaultExportFromCjs(propTypesExports);
    var useAttachEvent = function useAttachEvent(element, event, cb) {
        var cbDefined = !!cb;
        var cbRef = React.useRef(cb);
        // In many integrations the callback prop changes on each render.
        // Using a ref saves us from calling element.on/.off every render.
        React.useEffect(function() {
            cbRef.current = cb;
        }, [
            cb
        ]);
        React.useEffect(function() {
            if (!cbDefined || !element) return function() {};
            var decoratedCb = function decoratedCb() {
                if (cbRef.current) return cbRef.current.apply(cbRef, arguments);
                return undefined;
            };
            element.on(event, decoratedCb);
            return function() {
                element.off(event, decoratedCb);
            };
        }, [
            cbDefined,
            event,
            element,
            cbRef
        ]);
    };
    var usePrevious = function usePrevious(value) {
        var ref = React.useRef(value);
        React.useEffect(function() {
            ref.current = value;
        }, [
            value
        ]);
        return ref.current;
    };
    var isUnknownObject = function isUnknownObject(raw) {
        return raw !== null && _typeof(raw) === 'object';
    };
    var isPromise = function isPromise(raw) {
        return isUnknownObject(raw) && typeof raw.then === 'function';
    };
    // We are using types to enforce the `stripe` prop in this lib,
    // but in an untyped integration `stripe` could be anything, so we need
    // to do some sanity validation to prevent type errors.
    var isStripe = function isStripe(raw) {
        return isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
    };
    var PLAIN_OBJECT_STR = '[object Object]';
    var isEqual = function isEqual(left, right) {
        if (left === right) return true;
        if (!isUnknownObject(left) || !isUnknownObject(right)) return left === right;
        var leftArray = Array.isArray(left);
        var rightArray = Array.isArray(right);
        if (leftArray !== rightArray) return false;
        var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
        var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
        if (leftPlainObject !== rightPlainObject) return false;
        // not sure what sort of special object this is (regexp is one option), so
        // fallback to reference check.
        if (!leftPlainObject && !leftArray) return left === right;
        var leftKeys = Object.keys(left);
        var rightKeys = Object.keys(right);
        if (leftKeys.length !== rightKeys.length) return false;
        var keySet = {};
        for(var i = 0; i < leftKeys.length; i += 1)keySet[leftKeys[i]] = true;
        for(var _i = 0; _i < rightKeys.length; _i += 1)keySet[rightKeys[_i]] = true;
        var allKeys = Object.keys(keySet);
        if (allKeys.length !== leftKeys.length) return false;
        var l = left;
        var r = right;
        var pred = function pred(key) {
            return isEqual(l[key], r[key]);
        };
        return allKeys.every(pred);
    };
    var extractAllowedOptionsUpdates = function extractAllowedOptionsUpdates(options, prevOptions, immutableKeys) {
        if (!isUnknownObject(options)) return null;
        return Object.keys(options).reduce(function(newOptions, key) {
            var isUpdated = !isUnknownObject(prevOptions) || !isEqual(options[key], prevOptions[key]);
            if (immutableKeys.includes(key)) {
                if (isUpdated) console.warn("Unsupported prop change: options.".concat(key, " is not a mutable property."));
                return newOptions;
            }
            if (!isUpdated) return newOptions;
            return _objectSpread2(_objectSpread2({}, newOptions || {}), {}, _defineProperty({}, key, options[key]));
        }, null);
    };
    var INVALID_STRIPE_ERROR$1 = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    // We are using types to enforce the `stripe` prop in this lib, but in a real
    // integration `stripe` could be anything, so we need to do some sanity
    // validation to prevent type errors.
    var validateStripe = function validateStripe(maybeStripe) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$1;
        if (maybeStripe === null || isStripe(maybeStripe)) return maybeStripe;
        throw new Error(errorMsg);
    };
    var parseStripeProp = function parseStripeProp(raw) {
        var errorMsg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : INVALID_STRIPE_ERROR$1;
        if (isPromise(raw)) return {
            tag: 'async',
            stripePromise: Promise.resolve(raw).then(function(result) {
                return validateStripe(result, errorMsg);
            })
        };
        var stripe = validateStripe(raw, errorMsg);
        if (stripe === null) return {
            tag: 'empty'
        };
        return {
            tag: 'sync',
            stripe: stripe
        };
    };
    var registerWithStripeJs = function registerWithStripeJs(stripe) {
        if (!stripe || !stripe._registerWrapper || !stripe.registerAppInfo) return;
        stripe._registerWrapper({
            name: 'react-stripe-js',
            version: "6.12.0"
        });
        stripe.registerAppInfo({
            name: 'react-stripe-js',
            version: "6.12.0",
            url: 'https://stripe.com/docs/stripe-js/react'
        });
    };
    var ElementsContext = /*#__PURE__*/ React.createContext(null);
    ElementsContext.displayName = 'ElementsContext';
    var parseElementsContext = function parseElementsContext(ctx, useCase) {
        if (!ctx) throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
        return ctx;
    };
    /**
   * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
   * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
   *
   * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
   * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
   * Pass the returned `Promise` to `Elements`.
   *
   * @docs https://docs.stripe.com/sdks/stripejs-react?ui=elements#elements-provider
   */ var Elements = function Elements(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        // For a sync stripe instance, initialize into context
        var _React$useState = React.useState(function() {
            return {
                stripe: parsed.tag === 'sync' ? parsed.stripe : null,
                elements: parsed.tag === 'sync' ? parsed.stripe.elements(options) : null
            };
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            var safeSetContext = function safeSetContext(stripe) {
                setContext(function(ctx) {
                    // no-op if we already have a stripe instance (https://github.com/stripe/react-stripe-js/issues/296)
                    if (ctx.stripe) return ctx;
                    return {
                        stripe: stripe,
                        elements: stripe.elements(options)
                    };
                });
            };
            // For an async stripePromise, store it in context once resolved
            if (parsed.tag === 'async' && !ctx.stripe) parsed.stripePromise.then(function(stripe) {
                if (stripe && isMounted) // Only update Elements context if the component is still mounted
                // and stripe is not null. We allow stripe to be null to make
                // handling SSR easier.
                safeSetContext(stripe);
            });
            else if (parsed.tag === 'sync' && !ctx.stripe) // Or, handle a sync stripe instance going from null -> populated
            safeSetContext(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed,
            ctx,
            options
        ]);
        // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]);
        // Apply updates to elements when options prop has relevant changes
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (!ctx.elements) return;
            var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                'clientSecret',
                'fonts'
            ]);
            if (updates) ctx.elements.update(updates);
        }, [
            options,
            prevOptions,
            ctx.elements
        ]);
        // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(ctx.stripe);
        }, [
            ctx.stripe
        ]);
        return /*#__PURE__*/ React.createElement(ElementsContext.Provider, {
            value: ctx
        }, children);
    };
    Elements.propTypes = {
        stripe: PropTypes.any,
        options: PropTypes.object
    };
    var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
        var ctx = React.useContext(ElementsContext);
        return parseElementsContext(ctx, useCaseMessage);
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
   */ var useElements = function useElements() {
        var _useElementsContextWi = useElementsContextWithUseCase('calls useElements()'), elements = _useElementsContextWi.elements;
        return elements;
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
   */ var ElementsConsumer = function ElementsConsumer(_ref2) {
        var children = _ref2.children;
        var ctx = useElementsContextWithUseCase('mounts <ElementsConsumer>');
        // Assert to satisfy the busted React.FC return type (it should be ReactNode)
        return children(ctx);
    };
    ElementsConsumer.propTypes = {
        children: PropTypes.func.isRequired
    };
    var CheckoutContext = /*#__PURE__*/ React.createContext(null);
    CheckoutContext.displayName = 'CheckoutContext';
    // Element wrappers and useStripe need SDK references, not session updates.
    // A non-null value also identifies a checkout provider before initialization.
    var CheckoutSdkContext = /*#__PURE__*/ React.createContext(null);
    CheckoutSdkContext.displayName = 'CheckoutSdkContext';
    var useElementsOrCheckoutContextWithUseCase = function useElementsOrCheckoutContextWithUseCase(useCaseString) {
        var checkout = React.useContext(CheckoutSdkContext);
        var elements = React.useContext(ElementsContext);
        if (checkout) {
            if (elements) throw new Error("You cannot wrap the part of your app that ".concat(useCaseString, " in both a checkout provider and <Elements> provider."));
            else return checkout;
        } else return parseElementsContext(elements, useCaseString);
    };
    var _excluded = [
        "mode"
    ];
    var capitalized = function capitalized(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var createElementComponent = function createElementComponent(type, isServer, customDisplayName) {
        var displayName = "".concat(capitalized(type), "Element");
        var ClientElement = function ClientElement(_ref) {
            var id = _ref.id, className = _ref.className, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, onBlur = _ref.onBlur, onFocus = _ref.onFocus, onReady = _ref.onReady, onChange = _ref.onChange, onEscape = _ref.onEscape, onClick = _ref.onClick, onLoadError = _ref.onLoadError, onLoaderStart = _ref.onLoaderStart, onNetworksChange = _ref.onNetworksChange, onConfirm = _ref.onConfirm, onCancel = _ref.onCancel, onShippingAddressChange = _ref.onShippingAddressChange, onShippingRateChange = _ref.onShippingRateChange, onSavedPaymentMethodRemove = _ref.onSavedPaymentMethodRemove, onSavedPaymentMethodUpdate = _ref.onSavedPaymentMethodUpdate, onAvailablePaymentMethodsChange = _ref.onAvailablePaymentMethodsChange;
            var ctx = useElementsOrCheckoutContextWithUseCase("mounts <".concat(displayName, ">"));
            var elements = 'elements' in ctx ? ctx.elements : null;
            var checkoutSdk = 'checkoutSdk' in ctx ? ctx.checkoutSdk : null;
            var _React$useState = React.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), element = _React$useState2[0], setElement = _React$useState2[1];
            var elementRef = React.useRef(null);
            var domNode = React.useRef(null);
            // For every event where the merchant provides a callback, call element.on
            // with that callback. If the merchant ever changes the callback, removes
            // the old callback with element.off and then call element.on with the new one.
            useAttachEvent(element, 'blur', onBlur);
            useAttachEvent(element, 'focus', onFocus);
            useAttachEvent(element, 'escape', onEscape);
            useAttachEvent(element, 'click', onClick);
            useAttachEvent(element, 'loaderror', onLoadError);
            useAttachEvent(element, 'loaderstart', onLoaderStart);
            useAttachEvent(element, 'networkschange', onNetworksChange);
            useAttachEvent(element, 'confirm', onConfirm);
            useAttachEvent(element, 'cancel', onCancel);
            useAttachEvent(element, 'shippingaddresschange', onShippingAddressChange);
            useAttachEvent(element, 'shippingratechange', onShippingRateChange);
            useAttachEvent(element, 'savedpaymentmethodremove', onSavedPaymentMethodRemove);
            useAttachEvent(element, 'savedpaymentmethodupdate', onSavedPaymentMethodUpdate);
            useAttachEvent(element, 'availablepaymentmethodschange', onAvailablePaymentMethodsChange);
            useAttachEvent(element, 'change', onChange);
            var readyCallback;
            if (onReady) {
                if (type === 'expressCheckout') // Passes through the event, which includes visible PM types
                readyCallback = onReady;
                else // For other Elements, pass through the Element itself.
                readyCallback = function readyCallback() {
                    onReady(element);
                };
            }
            useAttachEvent(element, 'ready', readyCallback);
            React.useLayoutEffect(function() {
                if (elementRef.current === null && domNode.current !== null && (elements || checkoutSdk)) {
                    var newElement = null;
                    if (checkoutSdk) {
                        var elementsSdk = checkoutSdk;
                        var formSdk = checkoutSdk;
                        switch(type){
                            case 'paymentForm':
                                newElement = formSdk.createForm(options);
                                break;
                            case 'payment':
                                newElement = elementsSdk.createPaymentElement(options);
                                break;
                            case 'address':
                                if ('mode' in options) {
                                    var mode = options.mode, restOptions = _objectWithoutProperties(options, _excluded);
                                    if (mode === 'shipping') newElement = elementsSdk.createShippingAddressElement(restOptions);
                                    else if (mode === 'billing') newElement = elementsSdk.createBillingAddressElement(restOptions);
                                    else throw new Error("Invalid options.mode. mode must be 'billing' or 'shipping'.");
                                } else throw new Error("You must supply options.mode. mode must be 'billing' or 'shipping'.");
                                break;
                            case 'expressCheckout':
                                newElement = elementsSdk.createExpressCheckoutElement(options);
                                break;
                            case 'currencySelector':
                                newElement = checkoutSdk.createCurrencySelectorElement();
                                break;
                            case 'taxId':
                                newElement = elementsSdk.createTaxIdElement(options);
                                break;
                            case 'contactDetails':
                                newElement = elementsSdk.createContactDetailsElement();
                                break;
                            case 'linkSignup':
                                if ('createLinkSignupElement' in checkoutSdk) newElement = checkoutSdk.createLinkSignupElement(options);
                                else throw new Error('<LinkSignupElement> requires <CheckoutElementsProvider> and is not supported inside <CheckoutFormProvider>.');
                                break;
                            case 'terms':
                                newElement = elementsSdk.createTermsElement(options);
                                break;
                            default:
                                throw new Error("<".concat(displayName, "> is not supported inside a checkout provider. Use an <Elements> provider instead."));
                        }
                    } else if (elements) newElement = elements.create(type, options);
                    // Store element in a ref to ensure it's _immediately_ available in cleanup hooks in StrictMode
                    elementRef.current = newElement;
                    // Store element in state to facilitate event listener attachment
                    setElement(newElement);
                    if (newElement) newElement.mount(domNode.current);
                }
            }, [
                elements,
                checkoutSdk,
                options
            ]);
            var prevOptions = usePrevious(options);
            React.useEffect(function() {
                if (!elementRef.current) return;
                var updates = extractAllowedOptionsUpdates(options, prevOptions, [
                    'paymentRequest'
                ]);
                if (updates && 'update' in elementRef.current) elementRef.current.update(updates);
            }, [
                options,
                prevOptions
            ]);
            React.useLayoutEffect(function() {
                return function() {
                    if (elementRef.current && typeof elementRef.current.destroy === 'function') try {
                        elementRef.current.destroy();
                        elementRef.current = null;
                    } catch (error) {
                    // Do nothing
                    }
                };
            }, []);
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className,
                ref: domNode
            });
        };
        // Only render the Element wrapper in a server environment.
        var ServerElement = function ServerElement(props) {
            useElementsOrCheckoutContextWithUseCase("mounts <".concat(displayName, ">"));
            var id = props.id, className = props.className;
            return /*#__PURE__*/ React.createElement("div", {
                id: id,
                className: className
            });
        };
        var Element = isServer ? ServerElement : ClientElement;
        Element.propTypes = {
            id: PropTypes.string,
            className: PropTypes.string,
            onChange: PropTypes.func,
            onBlur: PropTypes.func,
            onFocus: PropTypes.func,
            onReady: PropTypes.func,
            onEscape: PropTypes.func,
            onClick: PropTypes.func,
            onLoadError: PropTypes.func,
            onLoaderStart: PropTypes.func,
            onNetworksChange: PropTypes.func,
            onConfirm: PropTypes.func,
            onCancel: PropTypes.func,
            onShippingAddressChange: PropTypes.func,
            onShippingRateChange: PropTypes.func,
            onSavedPaymentMethodRemove: PropTypes.func,
            onSavedPaymentMethodUpdate: PropTypes.func,
            onAvailablePaymentMethodsChange: PropTypes.func,
            options: PropTypes.object
        };
        Element.displayName = displayName;
        Element.__elementType = type;
        return Element;
    };
    var isServer = typeof window === 'undefined';
    var EmbeddedCheckoutContext = /*#__PURE__*/ React.createContext(null);
    EmbeddedCheckoutContext.displayName = 'EmbeddedCheckoutProviderContext';
    var useEmbeddedCheckoutContext = function useEmbeddedCheckoutContext() {
        var ctx = React.useContext(EmbeddedCheckoutContext);
        if (!ctx) throw new Error('<EmbeddedCheckout> must be used within <EmbeddedCheckoutProvider>');
        return ctx;
    };
    var INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `EmbeddedCheckoutProvider`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.';
    var EmbeddedCheckoutProvider = function EmbeddedCheckoutProvider(_ref) {
        var rawStripeProp = _ref.stripe, options = _ref.options, children = _ref.children;
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp, INVALID_STRIPE_ERROR);
        }, [
            rawStripeProp
        ]);
        var embeddedCheckoutPromise = React.useRef(null);
        var loadedStripe = React.useRef(null);
        var _React$useState = React.useState({
            embeddedCheckout: null
        }), _React$useState2 = _slicedToArray(_React$useState, 2), ctx = _React$useState2[0], setContext = _React$useState2[1];
        React.useEffect(function() {
            // Don't support any ctx updates once embeddedCheckout or stripe is set.
            if (loadedStripe.current || embeddedCheckoutPromise.current) return;
            var setStripeAndInitEmbeddedCheckout = function setStripeAndInitEmbeddedCheckout(stripe) {
                if (loadedStripe.current || embeddedCheckoutPromise.current) return;
                loadedStripe.current = stripe;
                embeddedCheckoutPromise.current = loadedStripe.current.createEmbeddedCheckoutPage(options).then(function(embeddedCheckout) {
                    setContext({
                        embeddedCheckout: embeddedCheckout
                    });
                });
            };
            // For an async stripePromise, store it once resolved
            if (parsed.tag === 'async' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) parsed.stripePromise.then(function(stripe) {
                if (stripe) setStripeAndInitEmbeddedCheckout(stripe);
            });
            else if (parsed.tag === 'sync' && !loadedStripe.current && (options.clientSecret || options.fetchClientSecret)) // Or, handle a sync stripe instance going from null -> populated
            setStripeAndInitEmbeddedCheckout(parsed.stripe);
        }, [
            parsed,
            options,
            ctx,
            loadedStripe
        ]);
        React.useEffect(function() {
            // cleanup on unmount
            return function() {
                // If embedded checkout is fully initialized, destroy it.
                if (ctx.embeddedCheckout) {
                    embeddedCheckoutPromise.current = null;
                    ctx.embeddedCheckout.destroy();
                } else if (embeddedCheckoutPromise.current) // If embedded checkout is still initializing, destroy it once
                // it's done. This could be caused by unmounting very quickly
                // after mounting.
                embeddedCheckoutPromise.current.then(function() {
                    embeddedCheckoutPromise.current = null;
                    if (ctx.embeddedCheckout) ctx.embeddedCheckout.destroy();
                });
            };
        }, [
            ctx.embeddedCheckout
        ]);
        // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(loadedStripe);
        }, [
            loadedStripe
        ]);
        // Warn on changes to stripe prop.
        // The stripe prop value can only go from null to non-null once and
        // can't be changed after that.
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]);
        // Warn on changes to options.
        var prevOptions = usePrevious(options);
        React.useEffect(function() {
            if (prevOptions == null) return;
            if (options == null) {
                console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot unset options after setting them.');
                return;
            }
            if (options.clientSecret === undefined && options.fetchClientSecret === undefined) console.warn('Invalid props passed to EmbeddedCheckoutProvider: You must provide one of either `options.fetchClientSecret` or `options.clientSecret`.');
            if (prevOptions.clientSecret != null && options.clientSecret !== prevOptions.clientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the client secret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.fetchClientSecret != null && options.fetchClientSecret !== prevOptions.fetchClientSecret) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change fetchClientSecret after setting it. Unmount and create a new instance of EmbeddedCheckoutProvider instead.');
            if (prevOptions.onComplete != null && options.onComplete !== prevOptions.onComplete) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onComplete option after setting it.');
            if (prevOptions.onShippingDetailsChange != null && options.onShippingDetailsChange !== prevOptions.onShippingDetailsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onShippingDetailsChange option after setting it.');
            if (prevOptions.onLineItemsChange != null && options.onLineItemsChange !== prevOptions.onLineItemsChange) console.warn('Unsupported prop change on EmbeddedCheckoutProvider: You cannot change the onLineItemsChange option after setting it.');
        }, [
            prevOptions,
            options
        ]);
        return /*#__PURE__*/ React.createElement(EmbeddedCheckoutContext.Provider, {
            value: ctx
        }, children);
    };
    var EmbeddedCheckoutClientElement = function EmbeddedCheckoutClientElement(_ref) {
        var id = _ref.id, className = _ref.className;
        var _useEmbeddedCheckoutC = useEmbeddedCheckoutContext(), embeddedCheckout = _useEmbeddedCheckoutC.embeddedCheckout;
        var isMounted = React.useRef(false);
        var domNode = React.useRef(null);
        React.useLayoutEffect(function() {
            if (!isMounted.current && embeddedCheckout && domNode.current !== null) {
                embeddedCheckout.mount(domNode.current);
                isMounted.current = true;
            }
            // Clean up on unmount
            return function() {
                if (isMounted.current && embeddedCheckout) try {
                    embeddedCheckout.unmount();
                    isMounted.current = false;
                } catch (e) {
                // Do nothing.
                // Parent effects are destroyed before child effects, so
                // in cases where both the EmbeddedCheckoutProvider and
                // the EmbeddedCheckout component are removed at the same
                // time, the embeddedCheckout instance will be destroyed,
                // which causes an error when calling unmount.
                }
            };
        }, [
            embeddedCheckout
        ]);
        return /*#__PURE__*/ React.createElement("div", {
            ref: domNode,
            id: id,
            className: className
        });
    };
    // Only render the wrapper in a server environment.
    var EmbeddedCheckoutServerElement = function EmbeddedCheckoutServerElement(_ref2) {
        var id = _ref2.id, className = _ref2.className;
        // Validate that we are in the right context by calling useEmbeddedCheckoutContext.
        useEmbeddedCheckoutContext();
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            className: className
        });
    };
    var EmbeddedCheckout = isServer ? EmbeddedCheckoutServerElement : EmbeddedCheckoutClientElement;
    var FinancialAccountDisclosure = function FinancialAccountDisclosure(_ref) {
        var rawStripeProp = _ref.stripe, onLoad = _ref.onLoad, onError = _ref.onError, options = _ref.options;
        var businessName = options === null || options === void 0 ? void 0 : options.businessName;
        var learnMoreLink = options === null || options === void 0 ? void 0 : options.learnMoreLink;
        var containerRef = React.useRef(null);
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        var _React$useState = React.useState(parsed.tag === 'sync' ? parsed.stripe : null), _React$useState2 = _slicedToArray(_React$useState, 2), stripeState = _React$useState2[0], setStripeState = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async') parsed.stripePromise.then(function(stripePromise) {
                if (stripePromise && isMounted) setStripeState(stripePromise);
            });
            else if (parsed.tag === 'sync') setStripeState(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed
        ]);
        // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on FinancialAccountDisclosure: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]);
        // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(stripeState);
        }, [
            stripeState
        ]);
        React.useEffect(function() {
            var createDisclosure = /*#__PURE__*/ function() {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
                    var _yield$stripeState$cr, disclosureContent, error, container;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!stripeState || !containerRef.current)) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 2:
                                _context.next = 4;
                                return stripeState.createFinancialAccountDisclosure({
                                    businessName: businessName,
                                    learnMoreLink: learnMoreLink
                                });
                            case 4:
                                _yield$stripeState$cr = _context.sent;
                                disclosureContent = _yield$stripeState$cr.htmlElement;
                                error = _yield$stripeState$cr.error;
                                if (error && onError) onError(error);
                                else if (disclosureContent) {
                                    container = containerRef.current;
                                    container.innerHTML = '';
                                    container.appendChild(disclosureContent);
                                    if (onLoad) onLoad();
                                }
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function createDisclosure() {
                    return _ref2.apply(this, arguments);
                };
            }();
            createDisclosure();
        }, [
            stripeState,
            businessName,
            learnMoreLink,
            onLoad,
            onError
        ]);
        return /*#__PURE__*/ React.createElement('div', {
            ref: containerRef
        });
    };
    var IssuingDisclosure = function IssuingDisclosure(_ref) {
        var rawStripeProp = _ref.stripe, onLoad = _ref.onLoad, onError = _ref.onError, options = _ref.options;
        var issuingProgramID = options === null || options === void 0 ? void 0 : options.issuingProgramID;
        var publicCardProgramName = options === null || options === void 0 ? void 0 : options.publicCardProgramName;
        var learnMoreLink = options === null || options === void 0 ? void 0 : options.learnMoreLink;
        var containerRef = React.useRef(null);
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        var _React$useState = React.useState(parsed.tag === 'sync' ? parsed.stripe : null), _React$useState2 = _slicedToArray(_React$useState, 2), stripeState = _React$useState2[0], setStripeState = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async') parsed.stripePromise.then(function(stripePromise) {
                if (stripePromise && isMounted) setStripeState(stripePromise);
            });
            else if (parsed.tag === 'sync') setStripeState(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed
        ]);
        // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on IssuingDisclosure: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]);
        // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(stripeState);
        }, [
            stripeState
        ]);
        React.useEffect(function() {
            var createDisclosure = /*#__PURE__*/ function() {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
                    var _yield$stripeState$cr, disclosureContent, error, container;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!stripeState || !containerRef.current)) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 2:
                                _context.next = 4;
                                return stripeState.createIssuingDisclosure({
                                    issuingProgramID: issuingProgramID,
                                    publicCardProgramName: publicCardProgramName,
                                    learnMoreLink: learnMoreLink
                                });
                            case 4:
                                _yield$stripeState$cr = _context.sent;
                                disclosureContent = _yield$stripeState$cr.htmlElement;
                                error = _yield$stripeState$cr.error;
                                if (error && onError) onError(error);
                                else if (disclosureContent) {
                                    container = containerRef.current;
                                    container.innerHTML = '';
                                    container.appendChild(disclosureContent);
                                    if (onLoad) onLoad();
                                }
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function createDisclosure() {
                    return _ref2.apply(this, arguments);
                };
            }();
            createDisclosure();
        }, [
            stripeState,
            issuingProgramID,
            publicCardProgramName,
            learnMoreLink,
            onLoad,
            onError
        ]);
        return /*#__PURE__*/ React.createElement('div', {
            ref: containerRef
        });
    };
    var TreasuryDisclosure = function TreasuryDisclosure(_ref) {
        var rawStripeProp = _ref.stripe, onLoad = _ref.onLoad, onError = _ref.onError, options = _ref.options;
        var businessName = options === null || options === void 0 ? void 0 : options.businessName;
        var learnMoreLink = options === null || options === void 0 ? void 0 : options.learnMoreLink;
        var containerRef = React.useRef(null);
        var parsed = React.useMemo(function() {
            return parseStripeProp(rawStripeProp);
        }, [
            rawStripeProp
        ]);
        var _React$useState = React.useState(parsed.tag === 'sync' ? parsed.stripe : null), _React$useState2 = _slicedToArray(_React$useState, 2), stripeState = _React$useState2[0], setStripeState = _React$useState2[1];
        React.useEffect(function() {
            var isMounted = true;
            if (parsed.tag === 'async') parsed.stripePromise.then(function(stripePromise) {
                if (stripePromise && isMounted) setStripeState(stripePromise);
            });
            else if (parsed.tag === 'sync') setStripeState(parsed.stripe);
            return function() {
                isMounted = false;
            };
        }, [
            parsed
        ]);
        // Warn on changes to stripe prop
        var prevStripe = usePrevious(rawStripeProp);
        React.useEffect(function() {
            if (prevStripe !== null && prevStripe !== rawStripeProp) console.warn('Unsupported prop change on TreasuryDisclosure: You cannot change the `stripe` prop after setting it.');
        }, [
            prevStripe,
            rawStripeProp
        ]);
        // Attach react-stripe-js version to stripe.js instance
        React.useEffect(function() {
            registerWithStripeJs(stripeState);
        }, [
            stripeState
        ]);
        React.useEffect(function() {
            var createDisclosure = /*#__PURE__*/ function() {
                var _ref2 = _asyncToGenerator(/*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
                    var _yield$stripeState$cr, disclosureContent, error, container;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while(true)switch(_context.prev = _context.next){
                            case 0:
                                if (!(!stripeState || !containerRef.current)) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt("return");
                            case 2:
                                _context.next = 4;
                                return stripeState.createTreasuryDisclosure({
                                    businessName: businessName,
                                    learnMoreLink: learnMoreLink
                                });
                            case 4:
                                _yield$stripeState$cr = _context.sent;
                                disclosureContent = _yield$stripeState$cr.htmlElement;
                                error = _yield$stripeState$cr.error;
                                if (error && onError) onError(error);
                                else if (disclosureContent) {
                                    container = containerRef.current;
                                    container.innerHTML = '';
                                    container.appendChild(disclosureContent);
                                    if (onLoad) onLoad();
                                }
                            case 8:
                            case "end":
                                return _context.stop();
                        }
                    }, _callee);
                }));
                return function createDisclosure() {
                    return _ref2.apply(this, arguments);
                };
            }();
            createDisclosure();
        }, [
            stripeState,
            businessName,
            learnMoreLink,
            onLoad,
            onError
        ]);
        return /*#__PURE__*/ React.createElement('div', {
            ref: containerRef
        });
    };
    /**
   * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
   */ var useStripe = function useStripe() {
        var _useElementsOrCheckou = useElementsOrCheckoutContextWithUseCase('calls useStripe()'), stripe = _useElementsOrCheckou.stripe;
        return stripe;
    };
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AuBankAccountElement = createElementComponent('auBankAccount', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardElement = createElementComponent('card', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardNumberElement = createElementComponent('cardNumber', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardExpiryElement = createElementComponent('cardExpiry', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var CardCvcElement = createElementComponent('cardCvc', isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var CurrencySelectorElement = createElementComponent('currencySelector', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var IbanElement = createElementComponent('iban', isServer);
    var PaymentElement = createElementComponent('payment', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ExpressCheckoutElement = createElementComponent('expressCheckout', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentRequestButtonElement = createElementComponent('paymentRequestButton', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var LinkAuthenticationElement = createElementComponent('linkAuthentication', isServer);
    /**
   * Requires beta access.
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var LinkSignupElement = createElementComponent('linkSignup', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ContactDetailsElement = createElementComponent('contactDetails', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var AddressElement = createElementComponent('address', isServer);
    /**
   * @deprecated
   * Use `AddressElement` instead.
   *
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var ShippingAddressElement = createElementComponent('shippingAddress', isServer);
    /**
   * @docs https://stripe.com/docs/stripe-js/react#element-components
   */ var PaymentMethodMessagingElement = createElementComponent('paymentMethodMessaging', isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var TaxIdElement = createElementComponent('taxId', isServer);
    /**
   * @docs https://stripe.com/docs/issuing/elements
   */ var IssuingCardNumberDisplayElement = createElementComponent('issuingCardNumberDisplay', isServer);
    /**
   * @docs https://stripe.com/docs/issuing/elements
   */ var IssuingCardCvcDisplayElement = createElementComponent('issuingCardCvcDisplay', isServer);
    /**
   * @docs https://stripe.com/docs/issuing/elements
   */ var IssuingCardExpiryDisplayElement = createElementComponent('issuingCardExpiryDisplay', isServer);
    /**
   * @docs https://stripe.com/docs/issuing/elements
   */ var IssuingCardPinDisplayElement = createElementComponent('issuingCardPinDisplay', isServer);
    /**
   * @docs https://stripe.com/docs/issuing/elements
   */ var IssuingCardCopyButtonElement = createElementComponent('issuingCardCopyButton', isServer);
    /**
   * Requires beta access:
   * Contact [Stripe support](https://support.stripe.com/) for more information.
   */ var TermsElement = createElementComponent('terms', isServer);
    exports1.AddressElement = AddressElement;
    exports1.AuBankAccountElement = AuBankAccountElement;
    exports1.CardCvcElement = CardCvcElement;
    exports1.CardElement = CardElement;
    exports1.CardExpiryElement = CardExpiryElement;
    exports1.CardNumberElement = CardNumberElement;
    exports1.ContactDetailsElement = ContactDetailsElement;
    exports1.CurrencySelectorElement = CurrencySelectorElement;
    exports1.Elements = Elements;
    exports1.ElementsConsumer = ElementsConsumer;
    exports1.EmbeddedCheckout = EmbeddedCheckout;
    exports1.EmbeddedCheckoutProvider = EmbeddedCheckoutProvider;
    exports1.ExpressCheckoutElement = ExpressCheckoutElement;
    exports1.FinancialAccountDisclosure = FinancialAccountDisclosure;
    exports1.IbanElement = IbanElement;
    exports1.IssuingCardCopyButtonElement = IssuingCardCopyButtonElement;
    exports1.IssuingCardCvcDisplayElement = IssuingCardCvcDisplayElement;
    exports1.IssuingCardExpiryDisplayElement = IssuingCardExpiryDisplayElement;
    exports1.IssuingCardNumberDisplayElement = IssuingCardNumberDisplayElement;
    exports1.IssuingCardPinDisplayElement = IssuingCardPinDisplayElement;
    exports1.IssuingDisclosure = IssuingDisclosure;
    exports1.LinkAuthenticationElement = LinkAuthenticationElement;
    exports1.LinkSignupElement = LinkSignupElement;
    exports1.PaymentElement = PaymentElement;
    exports1.PaymentMethodMessagingElement = PaymentMethodMessagingElement;
    exports1.PaymentRequestButtonElement = PaymentRequestButtonElement;
    exports1.ShippingAddressElement = ShippingAddressElement;
    exports1.TaxIdElement = TaxIdElement;
    exports1.TermsElement = TermsElement;
    exports1.TreasuryDisclosure = TreasuryDisclosure;
    exports1.useElements = useElements;
    exports1.useStripe = useStripe;
});

},{"d99b0077bf8bdf43":"bmhQu"}],"ijZ2b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCard = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 17,
        fill: "none",
        viewBox: "0 0 21 17",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M0 13.875A2.625 2.625 0 0 0 2.625 16.5h15.75A2.625 2.625 0 0 0 21 13.875V6.656H0zm3.094-3.562A1.406 1.406 0 0 1 4.5 8.906h2.25a1.406 1.406 0 0 1 1.406 1.406v.938a1.406 1.406 0 0 1-1.406 1.406H4.5a1.406 1.406 0 0 1-1.406-1.406zM18.375 0H2.625A2.625 2.625 0 0 0 0 2.625v1.219h21V2.625A2.625 2.625 0 0 0 18.375 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"koZdE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCvvHint);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCvvHint = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 15,
        fill: "none",
        viewBox: "0 0 15 15",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.5,
            strokeWidth: 1.5,
            d: "M7.417 14.083a6.667 6.667 0 1 0 0-13.333 6.667 6.667 0 0 0 0 13.333M7.417 10.083V7.417m0-2.667h.006"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcfUX":[function() {},{}],"lciKE":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "SelectPaymentMethodModal", ()=>SelectPaymentMethodModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _cardBrandLogo = require("../components/CardBrandLogo");
var _cardUtils = require("src/utils/cardUtils");
var _closeIconSvg = require("src/assets/images/onboarding-trainer/dashboard/programs/close-icon.svg");
var _subscriptionModalsScss = require("./SubscriptionModals.scss");
const SelectPaymentMethodModal = ({ isOpen, onClose, cards, isUpdatingCardId, onSelectCard, onAddNewCard })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        onCancel: onClose,
        footer: null,
        centered: true,
        width: 480,
        closeIcon: null,
        rootClassName: "subscription-modal-wrapper",
        styles: {
            mask: {
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(6, 7, 35, 0.75)'
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "select-payment-method-modal-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "modal-header-with-close",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "modal-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                    children: 'Payment Methods'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    children: 'Select a payment method to set it as default for your subscription.'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "modal-close-btn",
                            onClick: onClose,
                            "aria-label": "Close modal",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _closeIconSvg.ReactComponent), {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "modal-cards-list",
                    children: cards.map((card)=>{
                        const isThisUpdating = isUpdatingCardId === card.id;
                        const isBusy = Boolean(isUpdatingCardId);
                        return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: `modal-card-item ${card.isDefault ? 'selected' : ''} ${isThisUpdating ? 'is-loading' : ''} ${isBusy ? 'disabled' : ''}`,
                            onClick: ()=>{
                                if (isBusy) return;
                                onSelectCard(card.id);
                                onClose();
                            },
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "card-brand-wrap",
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                        brand: card.brand
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "card-info-text",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "card-title-text",
                                            children: (0, _cardUtils.getCardBrandDisplayName)(card.brand)
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "card-mask",
                                            children: (0, _cardUtils.formatMaskedCardNumber)(card.brand, card.last4)
                                        }),
                                        card.expiry && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "card-exp",
                                            children: `Expires ${card.expiry}`
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                    className: "card-status-wrap",
                                    children: isThisUpdating ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        className: "setting-default-indicator",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                    style: {
                                                        fontSize: 13,
                                                        color: '#ffa100'
                                                    },
                                                    spin: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Updating...'
                                            })
                                        ]
                                    }) : card.isDefault ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "default-pill",
                                        children: 'Default'
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "set-default-action",
                                        children: 'Set as default'
                                    })
                                })
                            ]
                        }, card.id);
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "modal-bottom-actions",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                        type: "button",
                        className: "btn-add-new-card",
                        onClick: ()=>{
                            onClose();
                            onAddNewCard();
                        },
                        children: '+ Add new payment method'
                    })
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"../components/CardBrandLogo":"g5uLF","src/utils/cardUtils":"2ly56","src/assets/images/onboarding-trainer/dashboard/programs/close-icon.svg":"ifISx","./SubscriptionModals.scss":"lcfUX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcfUX":[function() {},{}],"6SHFU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaymentConfirmedModal", ()=>PaymentConfirmedModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _reactRouterDom = require("react-router-dom");
var _subscriptionStore = require("src/store/subscriptionStore");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _freeTrialUnlockedSvg = require("src/assets/images/onboarding-trainer/subscription-icons/free-trial-unlocked/free-trial-unlocked.svg");
var _cardBrandLogo = require("../components/CardBrandLogo");
var _subscriptionModalsScss = require("./SubscriptionModals.scss");
const PaymentConfirmedModal = ({ isOpen, onClose, isTrialMode = true, amountFormatted, dueTodayFormatted, firstPaymentFormatted, trialEndsDateFormatted, nextBillingDateFormatted })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { billingCycle, paymentMethods, billingInfo, removePromoCode } = (0, _subscriptionStore.useSubscriptionStore)();
    const { data: serverState } = (0, _useSubscriptionApi.useSubscriptionStateQuery)(isOpen);
    const { data: serverBillingProfile } = (0, _useSubscriptionApi.useBillingProfileQuery)(isOpen);
    const { data: serverPaymentMethods } = (0, _useSubscriptionApi.usePaymentMethodsQuery)(isOpen);
    (0, _react.useEffect)(()=>{
        if (isOpen) removePromoCode();
    }, [
        isOpen,
        removePromoCode
    ]);
    const serverCards = serverPaymentMethods?.payment_methods || [];
    const defaultMethodCard = serverCards.find((c)=>c.id === serverPaymentMethods?.default_payment_method_id) || serverCards.find((c)=>c.is_default || c.isDefault) || serverCards[0];
    const defaultCard = (serverState?.default_payment_method ? {
        brand: serverState.default_payment_method.brand.toLowerCase(),
        last4: serverState.default_payment_method.last4
    } : null) || (defaultMethodCard ? {
        brand: defaultMethodCard.brand?.toLowerCase() || 'visa',
        last4: defaultMethodCard.last4
    } : null) || paymentMethods.find((c)=>c.isDefault) || paymentMethods[0];
    const receiptEmail = serverBillingProfile?.billingEmail || billingInfo.billingEmail || 'your email';
    const handleStartPro = ()=>{
        removePromoCode();
        onClose();
        navigate('/onboarding-trainer/dashboard/program-generator/ai');
    };
    const handleViewSubscription = ()=>{
        removePromoCode();
        onClose();
        navigate('/onboarding-trainer/dashboard/subscription/my-subscription', {
            replace: true
        });
    };
    const nextBillingDate = (0, _react.useMemo)(()=>{
        if (nextBillingDateFormatted && nextBillingDateFormatted !== "\u2014") return nextBillingDateFormatted;
        if (serverState?.current_period_end) try {
            const d = new Date(serverState.current_period_end);
            if (!isNaN(d.getTime())) return d.toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });
        } catch  {
        // Fallback
        }
        const cycle = serverState?.billing_interval === 'year' || billingCycle === 'yearly' ? 'year' : 'month';
        const d = new Date();
        if (cycle === 'year') d.setFullYear(d.getFullYear() + 1);
        else d.setMonth(d.getMonth() + 1);
        return d.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    }, [
        nextBillingDateFormatted,
        serverState,
        billingCycle
    ]);
    const resolvedDate = isTrialMode ? trialEndsDateFormatted && trialEndsDateFormatted !== "\u2014" ? trialEndsDateFormatted : nextBillingDate : nextBillingDate;
    const amountDisplay = amountFormatted || serverState?.amount?.formatted || "\u2014";
    const dueTodayDisplay = dueTodayFormatted || (isTrialMode ? 'Free' : amountDisplay);
    const firstPaymentDisplay = firstPaymentFormatted || amountDisplay;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        onCancel: onClose,
        footer: null,
        centered: true,
        width: 480,
        closeIcon: null,
        rootClassName: "subscription-modal-wrapper",
        styles: {
            mask: {
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(6, 7, 35, 0.75)'
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "result-modal-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "result-icon-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _freeTrialUnlockedSvg.ReactComponent), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: isTrialMode ? 'Free Trial Unlocked!' : "You're now on Pro!"
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "result-subtitle-1",
                    children: isTrialMode ? 'Your 14-day Pro trial is now active.' : 'Thank you! Your payment was successful.'
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "result-subtitle-2",
                    children: 'You now have access to all Pro features.'
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "result-details-box",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "detail-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-label",
                                    children: 'Plan'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-value",
                                    children: 'Pro Plan'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "detail-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-label",
                                    children: 'Billing Cycle'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-value",
                                    style: {
                                        textTransform: 'capitalize'
                                    },
                                    children: billingCycle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "detail-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-label",
                                    children: isTrialMode ? 'Due Today' : 'Amount'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-value",
                                    children: isTrialMode ? dueTodayDisplay : amountDisplay
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "detail-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-label",
                                    children: isTrialMode ? 'First Payment' : 'Next Billing Date'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-value",
                                    children: isTrialMode ? `${firstPaymentDisplay} on ${resolvedDate}` : resolvedDate
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "detail-row",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-label",
                                    children: 'Payment Method'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    className: "detail-value",
                                    children: defaultCard ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                                brand: defaultCard.brand,
                                                style: {
                                                    width: 34,
                                                    height: 20
                                                }
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: `\u{2022}\u{2022}\u{2022}\u{2022} ${defaultCard.last4}`
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: "\u2014"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "result-receipt-note",
                    children: isTrialMode ? 'Your first payment will be collected after the trial ends unless you cancel before then.' : `A receipt has been sent to ${receiptEmail}`
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "result-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-primary-action",
                            onClick: handleStartPro,
                            children: 'Start Using Pro Features'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-secondary-action",
                            onClick: handleViewSubscription,
                            children: 'View Subscription'
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"react-router-dom":"f3cgC","src/store/subscriptionStore":"rMPpj","src/api/subscription/useSubscriptionApi":"5YJAT","src/assets/images/onboarding-trainer/subscription-icons/free-trial-unlocked/free-trial-unlocked.svg":"bjwAb","../components/CardBrandLogo":"g5uLF","./SubscriptionModals.scss":"lcfUX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bjwAb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgFreeTrialUnlocked);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgFreeTrialUnlocked = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 150,
        height: 150,
        fill: "none",
        viewBox: "0 0 150 150",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                filter: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "url(#b)",
                        strokeWidth: 1.714,
                        d: "M75 33.857c16.095 0 29.143 13.048 29.143 29.143S91.095 92.143 75 92.143 45.857 79.095 45.857 63 58.905 33.857 75 33.857Z",
                        shapeRendering: "crispEdges"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#04051B",
                        d: "m70.108 69.3 16.95-16.95q.6-.6 1.4-.6t1.4.6.6 1.426-.6 1.424l-18.35 18.4q-.6.6-1.4.6t-1.4-.6l-8.6-8.6q-.6-.6-.576-1.424.024-.825.626-1.426a1.94 1.94 0 0 1 1.426-.6q.824.001 1.424.6z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "url(#c)",
                        d: "m70.108 69.3 16.95-16.95q.6-.6 1.4-.6t1.4.6.6 1.426-.6 1.424l-18.35 18.4q-.6.6-1.4.6t-1.4-.6l-8.6-8.6q-.6-.6-.576-1.424.024-.825.626-1.426a1.94 1.94 0 0 1 1.426-.6q.824.001 1.424.6z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "c",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(27.8991 -12.6281 2.78295 50.0018 61.294 70.391)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFEB14"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFA100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 75,
                        x2: 75,
                        y1: 33,
                        y2: 93,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFE111"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFA100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "a",
                        width: 150,
                        height: 150,
                        x: 0,
                        y: 0,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                dy: 12
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                stdDeviation: 22.5
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_17008_33039"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_17008_33039",
                                result: "shape"
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcfUX":[function() {},{}],"fsM9g":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PaymentFailedModal", ()=>PaymentFailedModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _reactRouterDom = require("react-router-dom");
var _containerSvg = require("src/assets/images/onboarding-trainer/subscription-icons/payment-failed/container.svg");
var _vectorSvg = require("src/assets/images/onboarding-trainer/subscription-icons/payment-failed/vector.svg");
var _subscriptionModalsScss = require("./SubscriptionModals.scss");
const PaymentFailedModal = ({ isOpen, onClose, onTryAgain, onChangePaymentMethod, errorCode, subCode, errorTitle, errorMessage, isLoading = false })=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const handleBackToPlans = ()=>{
        onClose();
        navigate('/onboarding-trainer/dashboard/subscription/plans');
    };
    // Prioritize backend-provided errorTitle and human-friendly user message,
    // with fallback logic if not provided by backend.
    const getFailureDetails = ()=>{
        const rawMsg = errorMessage || '';
        const code = (errorCode || '').toUpperCase();
        const sub = (subCode || '').toUpperCase();
        if (errorTitle) return {
            title: errorTitle,
            description: rawMsg || 'We were unable to complete this transaction. Please try again or use another payment method.'
        };
        if (code === 'ERR_INSUFFICIENT_FUNDS' || sub === 'PMT-001' || rawMsg.toLowerCase().includes('insufficient funds')) return {
            title: 'Insufficient Funds',
            description: rawMsg || 'Your account has insufficient funds to complete this transaction. Please add funds to your account or try another payment card.'
        };
        if (code === 'ERR_INVALID_CARD_DETAILS' || sub === 'PMT-002' || rawMsg.toLowerCase().includes('cvc') || rawMsg.toLowerCase().includes('security code') || rawMsg.toLowerCase().includes('expired')) return {
            title: 'Card Details Error',
            description: rawMsg || 'The expiration date, security code (CVC), or card number is invalid. Please double-check your card details.'
        };
        if (code === 'ERR_3DS_AUTHENTICATION_FAILED' || sub === 'PMT-004' || rawMsg.toLowerCase().includes('authentication')) return {
            title: 'Authentication Incomplete',
            description: rawMsg || 'Your bank could not verify the payment authentication. Please ensure you approve the confirmation request in your banking app.'
        };
        if (code === 'ERR_CARD_DECLINED' || sub === 'PMT-003' || rawMsg.toLowerCase().includes('declined')) return {
            title: 'Card Declined by Bank',
            description: rawMsg || 'Your bank declined this transaction. Please authorize online payments with your card issuer or try a different card.'
        };
        return {
            title: 'Payment Could Not Be Completed',
            description: rawMsg || 'We were unable to complete this transaction. Please try again or use another payment method.'
        };
    };
    const { title: displayTitle, description: displayDescription } = getFailureDetails();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        onCancel: ()=>{
            if (!isLoading) onClose();
        },
        footer: null,
        centered: true,
        width: 480,
        closeIcon: null,
        maskClosable: !isLoading,
        keyboard: !isLoading,
        rootClassName: "subscription-modal-wrapper",
        styles: {
            mask: {
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(6, 7, 35, 0.75)'
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "result-modal-content payment-failed-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "result-icon-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _containerSvg.ReactComponent), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: 'Payment Failed'
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "result-subtitle",
                    children: "We couldn't process your payment. Please check your payment method or try again."
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "error-code-box",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "error-header",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _vectorSvg.ReactComponent), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: displayTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "error-msg",
                            children: displayDescription
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "result-actions column-layout",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-primary-action",
                            disabled: isLoading,
                            onClick: ()=>{
                                if (onTryAgain) onTryAgain();
                                else onClose();
                            },
                            children: isLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                className: "btn-loading-content",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                        indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                            style: {
                                                fontSize: 16,
                                                color: '#060723'
                                            },
                                            spin: true
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: 'Retrying Payment...'
                                    })
                                ]
                            }) : 'Try Again'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-secondary-action",
                            disabled: isLoading,
                            onClick: ()=>{
                                onClose();
                                if (onChangePaymentMethod) onChangePaymentMethod();
                            },
                            children: 'Change Payment Method'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-ghost-action",
                            disabled: isLoading,
                            onClick: handleBackToPlans,
                            children: 'Back to Plans'
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"react-router-dom":"f3cgC","src/assets/images/onboarding-trainer/subscription-icons/payment-failed/container.svg":"cY1hR","src/assets/images/onboarding-trainer/subscription-icons/payment-failed/vector.svg":"1APZ7","./SubscriptionModals.scss":"lcfUX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cY1hR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgContainer);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgContainer = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 150,
        height: 150,
        fill: "none",
        viewBox: "0 0 150 150",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                filter: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "#E91616",
                        strokeWidth: 1.714,
                        d: "M75 33.857c16.095 0 29.143 13.048 29.143 29.143S91.095 92.143 75 92.143 45.857 79.095 45.857 63 58.905 33.857 75 33.857Z",
                        shapeRendering: "crispEdges"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#000",
                        d: "M64.989 50.488a1.737 1.737 0 0 0-2.457 2.457l10.034 10.034L62.53 73.013a1.737 1.737 0 1 0 2.457 2.457l10.035-10.034L85.056 75.47a1.737 1.737 0 0 0 2.456-2.457L77.48 62.979l10.033-10.034a1.737 1.737 0 0 0-2.456-2.457L75.022 60.522z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#E91616",
                        d: "M64.989 50.488a1.737 1.737 0 0 0-2.457 2.457l10.034 10.034L62.53 73.013a1.737 1.737 0 1 0 2.457 2.457l10.035-10.034L85.056 75.47a1.737 1.737 0 0 0 2.456-2.457L77.48 62.979l10.033-10.034a1.737 1.737 0 0 0-2.456-2.457L75.022 60.522z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                    id: "a",
                    width: 150,
                    height: 150,
                    x: 0,
                    y: 0,
                    colorInterpolationFilters: "sRGB",
                    filterUnits: "userSpaceOnUse",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                            floodOpacity: 0,
                            result: "BackgroundImageFix"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                            in: "SourceAlpha",
                            result: "hardAlpha",
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                            dy: 12
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                            stdDeviation: 22.5
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                            in2: "hardAlpha",
                            operator: "out"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                            values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                            in2: "BackgroundImageFix",
                            result: "effect1_dropShadow_17024_16926"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                            in: "SourceGraphic",
                            in2: "effect1_dropShadow_17024_16926",
                            result: "shape"
                        })
                    ]
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1APZ7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgVector);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgVector = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 19,
        fill: "none",
        viewBox: "0 0 20 19",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#FF6803",
            d: "M10.884.49c-.346-.653-1.422-.653-1.768 0l-9 17A1 1 0 0 0 1 18.96h18a.997.997 0 0 0 .883-1.468zM11 15.96H9v-2h2zm-2-4v-5h2l.001 5z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcfUX":[function() {},{}],"4MSMz":[function() {},{}],"9loYM":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PrivacyPolicyScreen", ()=>PrivacyPolicyScreen);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _userChevronLeftSvg = require("src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg");
var _securePaymentLockSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/secure-payment-lock.svg");
var _legalScreenScss = require("./LegalScreen.scss");
const PrivacyPolicyScreen = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { data: privacyData } = (0, _useSubscriptionApi.usePrivacyPolicyQuery)();
    const { mutate: recordAck } = (0, _useSubscriptionApi.useRecordLegalAcknowledgementMutation)();
    const handleBack = ()=>{
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/onboarding-trainer/dashboard/subscription');
    };
    const handleContinue = ()=>{
        recordAck(privacyData?.version ? {
            privacyVersion: privacyData.version
        } : undefined);
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/onboarding-trainer/dashboard/subscription/checkout');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "legal-page-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "legal-page-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        className: "legal-back-btn",
                        onClick: handleBack,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userChevronLeftSvg.ReactComponent), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: 'Privacy Policy'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "legal-header-subtitle",
                        children: 'Learn how miniPT collects, uses, stores, and protects your data.'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "legal-body-wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "legal-content-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '1. Information We Collect'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'We collect information you provide directly, such as your name, email address, business details, and payment information when you create an account, manage your subscription, or communicate with us. We also collect automatically certain technical information when you use miniPT, including device, browser, and usage data.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '2. How We Use Your Data'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'We use your data to provide, maintain, and improve the miniPT platform, process payments, communicate important updates, deliver customer support, and develop new features. We may also use aggregated and anonymised data for analytics and product improvement.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '3. Billing & Payment Data'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'Payment details are processed securely by our trusted payment provider (Stripe). We do not store full card details on our servers. We collect billing information such as name, billing email, address, VAT number, and transaction history to manage your subscription and comply with legal obligations.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '4. Client and Trainer Data'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'You may store client information, programs, progress, messages, and notes within miniPT. You are responsible for ensuring you have the appropriate consent from clients to store their data and for keeping that information accurate and up to date.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '5. AI & Uploaded Content'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'miniPT includes AI features that may process the information you provide (e.g. program details, notes, messages) to generate suggestions and insights. You remain the owner of your content. Do not upload sensitive personal data you do not wish to be processed.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '6. Data Sharing'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'We do not sell your data. We share information only with trusted service providers who help us operate miniPT (e.g. hosting, analytics, email, payments) under strict confidentiality agreements. We may disclose data when required by law or to protect our rights and users.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '7. Data Retention'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'We retain your data for as long as your account is active or as needed to provide our services and comply with legal obligations. If you delete your account, we will delete or anonymise your data within 30 days, except where we are required to retain it for legal or accounting reasons.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '8. Security Measures'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'We implement industry-standard technical and organisational measures to protect your data, including encryption in transit and at rest, access controls, regular security reviews, and monitoring.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '9. Your Rights'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'You have the right to access, update, or delete your personal data, object to or restrict certain processing, and data portability. You can manage your data in-app or contact us to exercise these rights.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '10. Contact / Support'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'If you have any questions about this Privacy Policy or how we handle your data, please contact us.'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "legal-meta-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "meta-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "meta-label",
                                        children: 'Last updated'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "meta-value",
                                        children: privacyData?.effective_date || "\u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "meta-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "meta-label",
                                        children: 'Version'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "meta-value",
                                        children: privacyData?.version || "\u2014"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "legal-actions-footer",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn-read-continue",
                                onClick: handleContinue,
                                children: 'Read & Continue'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-bottom-disclaimer",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _securePaymentLockSvg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: 'miniPT is compliant with GDPR. Your data is hosted securely in the EU.'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","src/api/subscription/useSubscriptionApi":"5YJAT","src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg":"bF2mm","src/assets/images/onboarding-trainer/subscription-icons/checkout/secure-payment-lock.svg":"2POVx","./LegalScreen.scss":"hqTao","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hqTao":[function() {},{}],"cfbmz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TermsOfServiceScreen", ()=>TermsOfServiceScreen);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _userChevronLeftSvg = require("src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg");
var _securePaymentLockSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/secure-payment-lock.svg");
var _legalScreenScss = require("./LegalScreen.scss");
const TermsOfServiceScreen = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { data: termsData } = (0, _useSubscriptionApi.useTermsOfServiceQuery)();
    const { mutate: recordAck } = (0, _useSubscriptionApi.useRecordLegalAcknowledgementMutation)();
    const handleBack = ()=>{
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/onboarding-trainer/dashboard/subscription');
    };
    const handleContinue = ()=>{
        recordAck(termsData?.version ? {
            termsVersion: termsData.version
        } : undefined);
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/onboarding-trainer/dashboard/subscription/checkout');
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "legal-page-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "legal-page-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        className: "legal-back-btn",
                        onClick: handleBack,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userChevronLeftSvg.ReactComponent), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: 'Terms of Service'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "legal-header-subtitle",
                        children: 'Please review the terms that apply to your use of the platform and paid subscription'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "legal-body-wrapper",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "legal-content-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '1. Acceptance of Terms'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: "By accessing or using miniPT (\u201Cthe Platform\u201D), you agree to be bound by these Terms of Service and all applicable laws and regulations. If you do not agree, you may not use the Platform."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '2. Account Eligibility'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'You must be at least 18 years old and capable of forming a binding contract to create an account on miniPT. You agree to provide accurate and complete information during registration.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '3. Subscription & Billing'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'miniPT offers recurring subscription plans billed in advance. By subscribing, you authorise us to charge your selected payment method on a recurring basis until cancelled.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '4. Free Trial Terms'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'New eligible users may receive a 14-day free trial. At the end of the trial, your subscription will automatically begin and your payment method will be charged unless you cancel before the trial ends. One free trial per user.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '5. Cancellations & Refunds'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'You can cancel your subscription at any time from your account settings. Cancellations take effect at the end of the current billing period. We do not offer refunds for partial billing periods or unused subscription time, except as required by law.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '6. Trainer Responsibilities'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'You agree to use the Platform only for lawful purposes and in a professional manner. You are responsible for the accuracy of the information you provide and for obtaining any necessary consents from your clients.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '7. Content & Intellectual Property'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'All content, features, and materials on miniPT are owned by miniPT or its licensors and are protected by copyright, trademark, and other intellectual property laws. You retain ownership of the content you create, while granting miniPT a limited license to host and display it as needed to provide the service.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '8. Limitation of Liability'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: "miniPT is provided \u201Cas is\u201D and \u201Cas available.\u201D To the fullest extent permitted by law, miniPT shall not be liable for any indirect, incidental, or consequential damages arising out of your use of the Platform."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-section",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: '9. Contact Information'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        children: 'If you have any questions about these Terms, please contact us at legal@minipt.com or 12 Fitness Street, London, SW1A 1AA, United Kingdom.'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "legal-meta-card",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "meta-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "meta-label",
                                        children: 'Last updated'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "meta-value",
                                        children: termsData?.effective_date || "\u2014"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "meta-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "meta-label",
                                        children: 'Version'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        className: "meta-value",
                                        children: termsData?.version || "\u2014"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "legal-actions-footer",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn-read-continue",
                                onClick: handleContinue,
                                children: 'Read & Continue'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "legal-bottom-disclaimer",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _securePaymentLockSvg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: 'By continuing, you agree to be bound by these terms.'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","src/api/subscription/useSubscriptionApi":"5YJAT","src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg":"bF2mm","src/assets/images/onboarding-trainer/subscription-icons/checkout/secure-payment-lock.svg":"2POVx","./LegalScreen.scss":"hqTao","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hqTao":[function() {},{}],"ANxhc":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "MySubscription", ()=>MySubscription);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _subscriptionStore = require("src/store/subscriptionStore");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _userChevronLeftSvg = require("src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg");
var _managePaymentMethodNextSvg = require("src/assets/images/onboarding-trainer/subscription-icons/billing-history/manage-payment-method-next.svg");
var _billingHistoryDocSvg = require("src/assets/images/onboarding-trainer/subscription-icons/my-subscription/billing-history-doc.svg");
var _questionsContactSupportSvg = require("src/assets/images/onboarding-trainer/subscription-icons/my-subscription/questions-contact-support.svg");
var _trendDownSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/trend-down.svg");
var _createWithAiSvg = require("src/assets/images/onboarding-trainer/subscription-icons/my-subscription/create-with-ai.svg");
var _paymentMethodSvg = require("src/assets/images/onboarding-trainer/subscription-icons/my-subscription/payment-method.svg");
var _cardNotChargedShieldSvg = require("src/assets/images/onboarding-trainer/subscription-icons/my-subscription/card-not-charged-shield.svg");
var _vectorSvg = require("src/assets/images/onboarding-trainer/subscription-icons/payment-failed/vector.svg");
var _cvvHintSvg = require("src/assets/images/onboarding-trainer/subscription-icons/add-payment-method/cvv-hint.svg");
var _cardBrandLogo = require("../components/CardBrandLogo");
var _billingInfoModal = require("../modals/BillingInfoModal");
var _paymentMethodModal = require("../modals/PaymentMethodModal");
var _removePaymentMethodModal = require("../modals/RemovePaymentMethodModal");
var _appAlert = require("src/utils/appAlert");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _mySubscriptionScss = require("./MySubscription.scss");
const MySubscription = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [searchParams] = (0, _reactRouterDom.useSearchParams)();
    const queryStatus = searchParams.get('status');
    const { billingCycle, billingInfo, paymentMethods, removePaymentMethod } = (0, _subscriptionStore.useSubscriptionStore)();
    const { data: serverState, isLoading: isStateLoading, refetch: refetchState } = (0, _useSubscriptionApi.useSubscriptionStateQuery)();
    const { data: serverBillingProfile, refetch: refetchBillingProfile } = (0, _useSubscriptionApi.useBillingProfileQuery)();
    const { data: serverPaymentMethods, refetch: refetchPaymentMethods } = (0, _useSubscriptionApi.usePaymentMethodsQuery)();
    const retryMutation = (0, _useSubscriptionApi.useRetryPastDuePaymentMutation)();
    const cancelScheduleMutation = (0, _useSubscriptionApi.useCancelScheduledIntervalSwitchMutation)();
    const currentStatus = queryStatus || serverState?.status || 'inactive';
    const formatSubDate = (isoString, fallback = "\u2014")=>{
        if (!isoString) return fallback;
        try {
            const d = new Date(isoString);
            return d.toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });
        } catch  {
            return fallback;
        }
    };
    const dynamicNextBillingDate = formatSubDate(serverState?.current_period_end);
    const dynamicAccessEndsDate = formatSubDate(serverState?.access_until || serverState?.current_period_end);
    const dynamicGracePeriodDate = formatSubDate(serverState?.past_due?.grace_period_ends_at || serverState?.current_period_end);
    const dynamicExpiredDate = formatSubDate(serverState?.access_until || serverState?.current_period_end, "\u2014");
    const displayAmount = serverState?.amount?.formatted || "\u2014";
    // Trial duration calculation
    const [currentTimestamp] = (0, _react.useState)(()=>Date.now());
    const trialDaysRemaining = (0, _react.useMemo)(()=>{
        const trialEndIso = serverState?.trial?.ends_at;
        if (!trialEndIso) return null;
        const ends = new Date(trialEndIso).getTime();
        const diffDays = Math.ceil((ends - currentTimestamp) / 86400000);
        return Math.max(0, diffDays);
    }, [
        serverState?.trial?.ends_at,
        currentTimestamp
    ]);
    // Modals
    const [isBillingModalOpen, setIsBillingModalOpen] = (0, _react.useState)(false);
    const [isPaymentModalOpen, setIsPaymentModalOpen] = (0, _react.useState)(false);
    const [isRemoveModalOpen, setIsRemoveModalOpen] = (0, _react.useState)(false);
    const serverCards = serverPaymentMethods?.payment_methods || [];
    const defaultMethodCard = serverCards.find((c)=>c.id === serverPaymentMethods?.default_payment_method_id) || serverCards.find((c)=>c.is_default || c.isDefault) || serverCards[0];
    const defaultCard = (serverState?.default_payment_method ? {
        id: serverState.default_payment_method.id,
        brand: serverState.default_payment_method.brand.toLowerCase(),
        last4: serverState.default_payment_method.last4,
        expiry: `${serverState.default_payment_method.exp_month} / ${serverState.default_payment_method.exp_year}`,
        cardholderName: serverState.default_payment_method.cardholder_name,
        isDefault: true
    } : null) || (defaultMethodCard ? {
        id: defaultMethodCard.id,
        brand: defaultMethodCard.brand?.toLowerCase() || 'visa',
        last4: defaultMethodCard.last4,
        expiry: defaultMethodCard.expiry || (defaultMethodCard.exp_month && defaultMethodCard.exp_year ? `${defaultMethodCard.exp_month} / ${defaultMethodCard.exp_year}` : "\u2014"),
        cardholderName: defaultMethodCard.cardholder_name || '',
        isDefault: true
    } : null) || paymentMethods.find((c)=>c.isDefault) || paymentMethods[0];
    const isBusinessBilling = serverBillingProfile?.billingType === 'business' || billingInfo.billingType === 'business';
    const handleBack = ()=>{
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/onboarding-trainer/dashboard');
    };
    const handleGoToBillingHistory = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/billing-history');
    };
    const handleGoToManagePayment = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/manage-payment-method');
    };
    const handleGoToSupport = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/contact-support');
    };
    const handleCreateWithAi = ()=>{
        navigate('/onboarding-trainer/dashboard/program-generator/ai');
    };
    const handleCancelSubscription = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/cancel');
    };
    const handleReactivate = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/reactivate');
    };
    const handleUpgradeToPro = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription');
    };
    const handleRetryPayment = ()=>{
        retryMutation.mutate(undefined, {
            onSuccess: ()=>{
                (0, _appAlert.toast).success('Payment processed successfully!');
                refetchState();
            },
            onError: (err)=>{
                (0, _appAlert.toast).error(err.userMessage || 'Payment retry failed. Please update your card.');
            }
        });
    };
    const handleCancelScheduledSwitch = ()=>{
        cancelScheduleMutation.mutate(undefined, {
            onSuccess: ()=>{
                (0, _appAlert.toast).success('Scheduled interval switch cancelled.');
            },
            onError: (err)=>{
                (0, _appAlert.toast).error(err.userMessage || 'Failed to cancel scheduled switch.');
            }
        });
    };
    const handleConfirmRemoveCard = ()=>{
        if (defaultCard) {
            removePaymentMethod(defaultCard.id);
            (0, _appAlert.toast).success('Payment method removed.');
        }
    };
    if (isStateLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "my-subscription-page-container",
        style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '60vh'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
            indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                style: {
                    fontSize: 32,
                    color: '#E2F163'
                },
                spin: true
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "my-subscription-page-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "subscription-header-row",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-left",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: "sub-back-title-btn",
                                onClick: handleBack,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userChevronLeftSvg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: 'My Subscription'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "sub-header-subtitle",
                                children: 'Manage your plan, billing details, and payment method.'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "header-right-actions",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            className: "btn-billing-history",
                            onClick: handleGoToBillingHistory,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _billingHistoryDocSvg.ReactComponent), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: 'Billing History'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _managePaymentMethodNextSvg.ReactComponent), {})
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "my-sub-grid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "my-sub-left-col",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "sub-main-card",
                                children: [
                                    serverState?.pending_update && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "sub-pending-switch-banner",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "pending-text",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: 'Scheduled Switch: '
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: serverState.pending_update.message || `Your subscription is scheduled to switch to ${serverState.pending_update.pending_interval === 'month' ? 'Monthly' : 'Yearly'} billing on ${formatSubDate(serverState.pending_update.pending_change_at)}.`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "btn-cancel-switch",
                                                onClick: handleCancelScheduledSwitch,
                                                disabled: cancelScheduleMutation.isPending,
                                                children: cancelScheduleMutation.isPending ? 'Cancelling...' : 'Cancel Switch'
                                            })
                                        ]
                                    }),
                                    (currentStatus === 'active' || currentStatus === 'trialing') && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "card-top-row",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "title-with-badge",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                            children: 'Pro Plan'
                                                        }),
                                                        currentStatus === 'trialing' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "status-pill trial-pill",
                                                            children: '14-Day Free Trial'
                                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "status-pill active-pill",
                                                            children: 'Active'
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "status-card-description",
                                                children: 'Ai and motion tracking are unlocked for your account.'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "sub-details-list",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Billing Cycle'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value capitalize",
                                                                children: serverState?.billing_interval || billingCycle
                                                            })
                                                        ]
                                                    }),
                                                    currentStatus === 'trialing' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "sub-detail-item",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "detail-name",
                                                                        children: 'Trial Period Ends'
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "detail-value",
                                                                        children: formatSubDate(serverState?.trial?.ends_at)
                                                                    })
                                                                ]
                                                            }),
                                                            trialDaysRemaining !== null && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "sub-detail-item",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "detail-name",
                                                                        children: 'Days Remaining'
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "detail-value",
                                                                        children: `${trialDaysRemaining} day${trialDaysRemaining === 1 ? '' : 's'}`
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Next Billing Date'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value",
                                                                children: dynamicNextBillingDate
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Amount'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value",
                                                                children: displayAmount
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Payment Method'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value card-val",
                                                                children: defaultCard ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                                                            brand: defaultCard.brand,
                                                                            style: {
                                                                                width: 32,
                                                                                height: 18
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            children: `${(0, _cardBrandLogo.getCardBrandDisplayName)(defaultCard.brand)} \u{2022}\u{2022}\u{2022}\u{2022} ${defaultCard.last4}`
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: 'No payment method'
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            currentStatus === 'trialing' && trialDaysRemaining !== null && trialDaysRemaining <= 3 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "sub-warning-banner past-due-warning",
                                                style: {
                                                    marginTop: 18,
                                                    marginBottom: 18
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNotChargedShieldSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: `Your free trial will conclude in ${trialDaysRemaining} day${trialDaysRemaining === 1 ? '' : 's'}. Your default card will be charged on ${formatSubDate(serverState?.trial?.ends_at)}.`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "btn-create-ai-white",
                                                onClick: handleCreateWithAi,
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createWithAiSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: 'Create with AI'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    currentStatus === 'cancelled' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "card-top-row",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "title-with-badge",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                            children: 'Pro Plan'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "status-pill cancelled-pill",
                                                            children: 'Cancelled'
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                className: "status-card-description",
                                                children: `Your Pro subscription has been cancelled. You'll keep access to Ai and motion tracking until ${dynamicAccessEndsDate}.`
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "sub-details-list",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Access ends'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value",
                                                                children: dynamicAccessEndsDate
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'After that'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value",
                                                                children: 'Basic Plan'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Future charges'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value",
                                                                children: 'None'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Payment Method'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value card-val",
                                                                children: defaultCard ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                                                            brand: defaultCard.brand,
                                                                            style: {
                                                                                width: 32,
                                                                                height: 18
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            children: `${(0, _cardBrandLogo.getCardBrandDisplayName)(defaultCard.brand)} \u{2022}\u{2022}\u{2022}\u{2022} ${defaultCard.last4}`
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: 'No payment method'
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "btn-keep-pro-gold",
                                                onClick: handleReactivate,
                                                children: 'Keep My Pro Plan'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "sub-info-note",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cvvHintSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: `Reactivate before ${dynamicAccessEndsDate} to keep your Pro access without interruption.`
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    currentStatus === 'inactive' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "card-top-row",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "title-with-badge",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                            children: 'Pro Plan'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "status-pill inactive-pill",
                                                            children: 'Inactive'
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "sub-warning-banner",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNotChargedShieldSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: "Your Pro Plan has expired. You're now on the free Basic Plan."
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "sub-details-list",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Status'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value",
                                                                children: 'Expired'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Expired on'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value",
                                                                children: dynamicExpiredDate
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Current Plan'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value",
                                                                children: 'Basic Plan (Free)'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Payment Method'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value card-val",
                                                                children: defaultCard ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                                                            brand: defaultCard.brand,
                                                                            style: {
                                                                                width: 32,
                                                                                height: 18
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            children: `${(0, _cardBrandLogo.getCardBrandDisplayName)(defaultCard.brand)} \u{2022}\u{2022}\u{2022}\u{2022} ${defaultCard.last4}`
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: 'No payment method'
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "upgrade-callout-banner",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "callout-icon-left",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _createWithAiSvg.ReactComponent), {})
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "callout-texts",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                                                children: 'Upgrade to Pro to unlock all features'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                                children: 'Get AI program generation, motion tracking, advanced analytics and more'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        className: "btn-upgrade-banner",
                                                        onClick: handleUpgradeToPro,
                                                        children: 'Upgrade to Pro'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    currentStatus === 'past_due' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "card-top-row",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "title-with-badge",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                                                            children: 'Pro Plan'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "status-pill past-due-pill",
                                                            children: 'Past Due'
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "sub-past-due-note",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNotChargedShieldSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        children: [
                                                            `We couldn\u{2019}t process your last payment. Your Pro access is still active until `,
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                                children: dynamicGracePeriodDate
                                                            }),
                                                            ` while we retry your renewal.`
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "sub-details-list",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Billing cycle'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value capitalize",
                                                                children: serverState?.billing_interval || billingCycle
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Last payment attempt'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value",
                                                                children: dynamicNextBillingDate
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Amount due'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value",
                                                                children: serverState?.past_due?.amount_due || serverState?.amount?.formatted || "\u2014"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Grace period ends'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value highlight-orange",
                                                                children: dynamicGracePeriodDate
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Payment Method'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value card-val",
                                                                children: defaultCard ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                    children: [
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                                                            brand: defaultCard.brand,
                                                                            style: {
                                                                                width: 32,
                                                                                height: 18
                                                                            }
                                                                        }),
                                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            children: `${(0, _cardBrandLogo.getCardBrandDisplayName)(defaultCard.brand)} \u{2022}\u{2022}\u{2022}\u{2022} ${defaultCard.last4}`
                                                                        })
                                                                    ]
                                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    children: 'No payment method'
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "past-due-action-buttons",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        className: "btn-update-method-white",
                                                        onClick: ()=>setIsPaymentModalOpen(true),
                                                        children: 'Update Payment Method'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                        type: "button",
                                                        className: "btn-retry-dark",
                                                        onClick: handleRetryPayment,
                                                        children: 'Retry Payment'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "sub-info-note",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNotChargedShieldSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: `If payment isn\u{2019}t completed by ${dynamicGracePeriodDate}, your account will move to the Basic Plan.`
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "sub-card billing-info-sub-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: 'Billing Information'
                                    }),
                                    currentStatus === 'inactive' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "card-muted-text",
                                        children: 'Your current Plan is Free.'
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "sub-details-list",
                                                style: {
                                                    marginBottom: 18
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: isBusinessBilling ? 'Company Name' : 'Full Name'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value",
                                                                children: serverBillingProfile?.fullName || serverBillingProfile?.companyName || billingInfo.fullName || billingInfo.companyName || "\u2014"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "sub-detail-item",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-name",
                                                                children: 'Billing Email'
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "detail-value",
                                                                children: serverBillingProfile?.billingEmail || billingInfo.billingEmail || "\u2014"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "btn-card-action",
                                                onClick: ()=>setIsBillingModalOpen(true),
                                                children: 'Change Billing Information'
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "my-sub-right-col",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "sub-card payment-method-sub-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "sub-card-header-icon",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentMethodSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: 'Payment Method'
                                            })
                                        ]
                                    }),
                                    defaultCard ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "current-card-item",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "card-brand-wrap",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                                    brand: defaultCard.brand
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "card-details",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "card-type",
                                                        children: (0, _cardBrandLogo.getCardBrandDisplayName)(defaultCard.brand)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                        className: "card-number",
                                                        children: [
                                                            "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ",
                                                            defaultCard.last4
                                                        ]
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "default-pill",
                                                children: 'Default'
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "card-muted-text",
                                        children: 'No payment method on file.'
                                    }),
                                    currentStatus === 'cancelled' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "card-status-note",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNotChargedShieldSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'This card will not be charged again unless you reactivate your subscription'
                                            })
                                        ]
                                    }),
                                    currentStatus === 'inactive' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "card-status-note",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardNotChargedShieldSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'This card is not being charged.'
                                            })
                                        ]
                                    }),
                                    currentStatus === 'past_due' && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "card-status-note warning-note",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _vectorSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'This card was declined for the latest renewal.'
                                            })
                                        ]
                                    }),
                                    currentStatus === 'inactive' ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn-card-action",
                                        onClick: ()=>setIsRemoveModalOpen(true),
                                        children: 'Remove Card'
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn-card-action",
                                        onClick: handleGoToManagePayment,
                                        children: currentStatus === 'active' ? 'Change Default' : 'Manage Payment Method'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "sub-card support-sub-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "sub-card-header-icon",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _questionsContactSupportSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "sub-card-header-text",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                        children: 'Questions? Contact support'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                        className: "card-muted-text",
                                                        children: "We're here to help you."
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn-card-action",
                                        onClick: handleGoToSupport,
                                        children: 'Contact Support'
                                    })
                                ]
                            }),
                            (currentStatus === 'active' || currentStatus === 'trialing') && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "sub-card downgrade-sub-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "sub-card-header-icon",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _trendDownSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: 'Downgrade to Basic'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "card-muted-text",
                                        children: "You'll lose your Pro subscription, including AI and motion-tracking features."
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn-card-action btn-danger-action",
                                        onClick: handleCancelSubscription,
                                        children: 'Give up Pro features'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _billingInfoModal.BillingInfoModal), {
                isOpen: isBillingModalOpen,
                onClose: ()=>setIsBillingModalOpen(false),
                onSuccess: ()=>{
                    refetchBillingProfile();
                    refetchState();
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentMethodModal.PaymentMethodModal), {
                isOpen: isPaymentModalOpen,
                onClose: ()=>setIsPaymentModalOpen(false),
                onSuccess: ()=>{
                    refetchPaymentMethods();
                    refetchState();
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removePaymentMethodModal.RemovePaymentMethodModal), {
                isOpen: isRemoveModalOpen,
                onClose: ()=>setIsRemoveModalOpen(false),
                onConfirmRemove: handleConfirmRemoveCard
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","src/store/subscriptionStore":"rMPpj","src/api/subscription/useSubscriptionApi":"5YJAT","src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg":"bF2mm","src/assets/images/onboarding-trainer/subscription-icons/billing-history/manage-payment-method-next.svg":"kgObN","src/assets/images/onboarding-trainer/subscription-icons/my-subscription/billing-history-doc.svg":"fG9qh","src/assets/images/onboarding-trainer/subscription-icons/my-subscription/questions-contact-support.svg":"5Yx7O","src/assets/images/onboarding-trainer/subscription-icons/common/trend-down.svg":"5ln9t","src/assets/images/onboarding-trainer/subscription-icons/my-subscription/create-with-ai.svg":"jD0Z9","src/assets/images/onboarding-trainer/subscription-icons/my-subscription/payment-method.svg":"FW22b","src/assets/images/onboarding-trainer/subscription-icons/my-subscription/card-not-charged-shield.svg":"8cl6y","src/assets/images/onboarding-trainer/subscription-icons/payment-failed/vector.svg":"1APZ7","src/assets/images/onboarding-trainer/subscription-icons/add-payment-method/cvv-hint.svg":"koZdE","../components/CardBrandLogo":"g5uLF","../modals/BillingInfoModal":"5jyNn","../modals/PaymentMethodModal":"9Ak0b","../modals/RemovePaymentMethodModal":"5L4Y7","src/utils/appAlert":"de4Mq","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"./MySubscription.scss":"3QQYm","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fG9qh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgBillingHistoryDoc);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgBillingHistoryDoc = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M9.333 1.333H3.667a1 1 0 0 0-1 1v11.334a1 1 0 0 0 1 1h8.666a1 1 0 0 0 1-1V5.333z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 1.5,
                d: "M9.333 1.333v4h4M5.5 7.5h3M5.5 10h5M5.5 12.5h5"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5Yx7O":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgQuestionsContactSupport);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgQuestionsContactSupport = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        viewBox: "0 0 30 30",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M15 0C6.729 0 0 6.729 0 15v6.215C0 22.75 1.346 24 3 24h1.5A1.5 1.5 0 0 0 6 22.5v-7.714a1.5 1.5 0 0 0-1.5-1.5H3.138C3.972 7.48 8.967 3 15 3s11.028 4.48 11.862 10.286H25.5a1.5 1.5 0 0 0-1.5 1.5V24c0 1.654-1.346 3-3 3h-3v-1.5h-6V30h9c3.309 0 6-2.691 6-6 1.654 0 3-1.25 3-2.785V15c0-8.271-6.729-15-15-15"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5ln9t":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgTrendDown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTrendDown = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "m23 18-9.5-9.5-5 5L1 6"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeWidth: 2,
                d: "M17 18h6v-6"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jD0Z9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCreateWithAi);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCreateWithAi = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "none",
        viewBox: "0 0 20 20",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "currentColor",
            d: "M7.012 3.448c.598-1.75 3.016-1.803 3.725-.159l.06.16.807 2.36A4 4 0 0 0 13.88 8.22l.217.081 2.36.806c1.75.598 1.803 3.016.16 3.725l-.16.06-2.36.807a4 4 0 0 0-2.412 2.276l-.08.216-.807 2.361c-.598 1.75-3.016 1.803-3.724.16l-.062-.16-.806-2.36A4 4 0 0 0 3.93 13.78l-.216-.081-2.36-.806c-1.75-.598-1.804-3.016-.16-3.724l.16-.062 2.36-.806a4 4 0 0 0 2.411-2.276l.081-.216zM16.905 0a1 1 0 0 1 .898.56l.048.117.35 1.026 1.027.35a1 1 0 0 1 .118 1.845l-.118.048-1.026.35-.35 1.027a1 1 0 0 1-1.845.117l-.048-.117-.35-1.026-1.027-.35a1 1 0 0 1-.118-1.845l.118-.048 1.026-.35.35-1.027A1 1 0 0 1 16.905 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"FW22b":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPaymentMethod);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPaymentMethod = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 32,
        height: 25,
        fill: "none",
        viewBox: "0 0 32 25",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M0 20.813a3.937 3.937 0 0 0 3.938 3.937h23.625a3.937 3.937 0 0 0 3.937-3.937V9.984H0zm4.64-5.344a2.11 2.11 0 0 1 2.11-2.11h3.375a2.11 2.11 0 0 1 2.11 2.11v1.406a2.11 2.11 0 0 1-2.11 2.11H6.75a2.11 2.11 0 0 1-2.11-2.11zM27.564 0H3.938A3.937 3.937 0 0 0 0 3.938v1.828h31.5V3.938A3.937 3.937 0 0 0 27.563 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"8cl6y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCardNotChargedShield);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCardNotChargedShield = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "none",
        viewBox: "0 0 18 18",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                fill: "#fff",
                fillOpacity: 0.7,
                clipPath: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M9.75 11.625a.75.75 0 1 1-1.5 0 .75.75 0 0 1 1.5 0m-.187-6.187a.563.563 0 1 0-1.126 0v3.375a.563.563 0 1 0 1.126 0z"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        d: "M8.595.478c.263-.085.547-.085.81 0l6.188 2.006a1.31 1.31 0 0 1 .907 1.248V7.5c0 4.643-2.828 8.03-7.05 9.623-.29.109-.61.109-.9 0C4.329 15.528 1.5 12.143 1.5 7.5V3.732c0-.57.367-1.072.908-1.248zm.463 1.07a.2.2 0 0 0-.116 0L2.755 3.555a.19.19 0 0 0-.13.178V7.5c0 4.096 2.46 7.113 6.323 8.57a.15.15 0 0 0 .104 0c3.863-1.457 6.323-4.475 6.323-8.57V3.732a.19.19 0 0 0-.13-.177z"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("defs", {
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("clipPath", {
                    id: "a",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0h18v18H0z"
                    })
                })
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5L4Y7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RemovePaymentMethodModal", ()=>RemovePaymentMethodModal);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _removeAlertSvg = require("src/assets/images/onboarding-trainer/subscription-icons/remove-payment-method/remove-alert.svg");
var _userChevronLeftSvg = require("src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg");
var _subscriptionModalsScss = require("./SubscriptionModals.scss");
const RemovePaymentMethodModal = ({ isOpen, onClose, onConfirmRemove })=>{
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: isOpen,
        onCancel: onClose,
        footer: null,
        centered: true,
        width: 420,
        closeIcon: null,
        rootClassName: "subscription-modal-wrapper",
        styles: {
            mask: {
                backdropFilter: 'blur(8px)',
                backgroundColor: 'rgba(6, 7, 35, 0.75)'
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "remove-card-modal-content",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "trash-icon-wrap",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeAlertSvg.ReactComponent), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: 'Are you sure you want to remove the card?'
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "remove-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-confirm-remove",
                            onClick: ()=>{
                                onConfirmRemove();
                                onClose();
                            },
                            children: 'Yes, remove card'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            className: "btn-back-manage",
                            onClick: onClose,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userChevronLeftSvg.ReactComponent), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: 'Back to Manage Payments'
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"src/assets/images/onboarding-trainer/subscription-icons/remove-payment-method/remove-alert.svg":"4LyK7","src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg":"bF2mm","./SubscriptionModals.scss":"lcfUX","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4LyK7":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgRemoveAlert);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRemoveAlert = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 40,
        height: 46,
        fill: "none",
        viewBox: "0 0 40 46",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 3.733,
            d: "M35.408 11.22 33.47 39.613a4.76 4.76 0 0 1-1.413 3.09 4.37 4.37 0 0 1-3.048 1.255H10.503a4.37 4.37 0 0 1-3.049-1.254 4.76 4.76 0 0 1-1.412-3.09L4.102 11.22m11.181 9.354v14.03m8.945-14.03v14.03m2.236-23.384V4.205c0-.62-.236-1.215-.655-1.653a2.19 2.19 0 0 0-1.581-.685h-8.945c-.593 0-1.161.246-1.58.685a2.4 2.4 0 0 0-.656 1.653v7.015m-11.18 0h35.777"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lcfUX":[function() {},{}],"3QQYm":[function() {},{}],"4P7Pp":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ManagePaymentMethod", ()=>ManagePaymentMethod);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _subscriptionStore = require("src/store/subscriptionStore");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _userChevronLeftSvg = require("src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg");
var _addButtonSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/add-button.svg");
var _removeCardSvg = require("src/assets/images/onboarding-trainer/subscription-icons/manage-payment-method/remove-card.svg");
var _expiresSvg = require("src/assets/images/onboarding-trainer/subscription-icons/manage-payment-method/expires.svg");
var _cardholderNameSvg = require("src/assets/images/onboarding-trainer/subscription-icons/manage-payment-method/cardholder-name.svg");
var _cardBrandLogo = require("../components/CardBrandLogo");
var _cardUtils = require("src/utils/cardUtils");
var _paymentMethodModal = require("../modals/PaymentMethodModal");
var _removePaymentMethodModal = require("../modals/RemovePaymentMethodModal");
var _appAlert = require("src/utils/appAlert");
var _managePaymentMethodScss = require("./ManagePaymentMethod.scss");
const ManagePaymentMethod = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { paymentMethods, removePaymentMethod } = (0, _subscriptionStore.useSubscriptionStore)();
    const { data: serverMethods, refetch: refetchMethods } = (0, _useSubscriptionApi.usePaymentMethodsQuery)();
    const deleteCardMutation = (0, _useSubscriptionApi.useDeletePaymentMethodMutation)();
    const [isAddModalOpen, setIsAddModalOpen] = (0, _react.useState)(false);
    const [editingCard, setEditingCard] = (0, _react.useState)(null);
    const [cardToRemove, setCardToRemove] = (0, _react.useState)(null);
    const defaultId = serverMethods?.default_payment_method_id;
    const rawCards = serverMethods?.payment_methods || paymentMethods;
    let singleDefaultId = defaultId;
    if (!singleDefaultId) {
        const foundDefault = rawCards.find((c)=>c.is_default || c.isDefault);
        singleDefaultId = foundDefault ? foundDefault.id : rawCards[0]?.id;
    }
    const cards = rawCards.map((c)=>({
            id: c.id,
            brand: c.brand?.toLowerCase() || 'visa',
            last4: c.last4,
            expiry: c.expiry || (c.exp_month && c.exp_year ? `${String(c.exp_month).padStart(2, '0')}/${String(c.exp_year).slice(-2)}` : "\u2014"),
            cardholderName: c.cardholder_name || c.cardholderName || "\u2014",
            isDefault: Boolean(singleDefaultId && c.id === singleDefaultId)
        }));
    const handleBack = ()=>{
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/onboarding-trainer/dashboard/subscription/my-subscription');
    };
    const handleEditCard = (card)=>{
        setEditingCard(card);
        setIsAddModalOpen(true);
    };
    const handleOpenRemoveDialog = (card)=>{
        setCardToRemove(card);
    };
    const handleConfirmRemove = ()=>{
        if (cardToRemove) deleteCardMutation.mutate(cardToRemove.id, {
            onSuccess: ()=>{
                removePaymentMethod(cardToRemove.id);
                (0, _appAlert.toast).success('Card removed successfully.');
                setCardToRemove(null);
            },
            onError: (err)=>{
                (0, _appAlert.toast).error(err.userMessage || 'Failed to remove card.');
                setCardToRemove(null);
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "manage-payment-page-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "manage-payment-header",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "header-titles",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            className: "manage-back-btn",
                            onClick: handleBack,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userChevronLeftSvg.ReactComponent), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: 'Manage Payment Method'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "manage-subtitle",
                            children: 'Update or add a payment method for your subscription.'
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: `payment-methods-box ${cards.length <= 1 ? 'single-box' : 'multi-box'}`,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "payment-box-header",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: 'Current Payment Method'
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: "btn-add-card-white",
                                onClick: ()=>{
                                    setEditingCard(null);
                                    setIsAddModalOpen(true);
                                },
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonSvg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: 'Add'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: `cards-grid ${cards.length > 1 ? 'multi-cards' : 'single-card'}`,
                        children: cards.map((card)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "payment-card-box",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "card-top-header",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "brand-and-mask",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "brand-icon",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                                            brand: card.brand
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "title-and-mask",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "card-brand-name",
                                                                children: (0, _cardUtils.getCardBrandDisplayName)(card.brand)
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "card-full-mask",
                                                                children: (0, _cardUtils.formatMaskedCardNumber)(card.brand, card.last4)
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            card.isDefault && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "card-default-pill",
                                                children: 'Default'
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "card-meta-details",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "meta-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "meta-icon-label",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _expiresSvg.ReactComponent), {}),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: 'Expires'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "meta-val",
                                                        children: card.expiry || "\u2014"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "meta-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "meta-icon-label",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardholderNameSvg.ReactComponent), {}),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                children: 'Cardholder Name'
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "meta-val",
                                                        title: card.cardholderName || '',
                                                        children: card.cardholderName || "\u2014"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    cards.length === 1 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "card-action-single",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: "btn-edit-card",
                                            onClick: ()=>handleEditCard(card),
                                            children: 'Edit Card'
                                        })
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "card-action-split",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "btn-update-card",
                                                onClick: ()=>handleEditCard(card),
                                                children: 'Update'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "btn-remove-card",
                                                onClick: ()=>handleOpenRemoveDialog(card),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removeCardSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: 'Remove'
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, card.id))
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "encryption-footer-note",
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            children: 'Your payment information is secure and encrypted.'
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentMethodModal.PaymentMethodModal), {
                isOpen: isAddModalOpen,
                onClose: ()=>{
                    setIsAddModalOpen(false);
                    setEditingCard(null);
                },
                cardToEdit: editingCard,
                onSuccess: ()=>{
                    refetchMethods();
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _removePaymentMethodModal.RemovePaymentMethodModal), {
                isOpen: Boolean(cardToRemove),
                onClose: ()=>setCardToRemove(null),
                onConfirmRemove: handleConfirmRemove
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","src/store/subscriptionStore":"rMPpj","src/api/subscription/useSubscriptionApi":"5YJAT","src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg":"bF2mm","src/assets/images/onboarding-trainer/subscription-icons/checkout/add-button.svg":"6V9WO","src/assets/images/onboarding-trainer/subscription-icons/manage-payment-method/remove-card.svg":"2EW1J","src/assets/images/onboarding-trainer/subscription-icons/manage-payment-method/expires.svg":"lMKCy","src/assets/images/onboarding-trainer/subscription-icons/manage-payment-method/cardholder-name.svg":"15218","../components/CardBrandLogo":"g5uLF","src/utils/cardUtils":"2ly56","../modals/PaymentMethodModal":"9Ak0b","../modals/RemovePaymentMethodModal":"5L4Y7","src/utils/appAlert":"de4Mq","./ManagePaymentMethod.scss":"btQMc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2EW1J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgRemoveCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgRemoveCard = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 14,
        fill: "none",
        viewBox: "0 0 12 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 1.067,
            d: "m10.117 3.206-.554 8.112a1.36 1.36 0 0 1-.404.883c-.237.23-.548.358-.871.358H3.001c-.324 0-.635-.128-.871-.358a1.36 1.36 0 0 1-.404-.883l-.554-8.112m3.195 2.672v4.009m2.555-4.009v4.009m.639-6.681V1.2A.68.68 0 0 0 7.374.73a.63.63 0 0 0-.452-.196H4.367c-.17 0-.332.07-.452.196a.68.68 0 0 0-.187.472v2.005m-3.195 0h10.222"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lMKCy":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgExpires);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgExpires = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 15,
        height: 15,
        fill: "none",
        viewBox: "0 0 15 15",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M0 12.75C0 14.025.975 15 2.25 15h10.5c1.275 0 2.25-.975 2.25-2.25v-6H0zM12.75 1.5h-1.5V.75c0-.45-.3-.75-.75-.75s-.75.3-.75.75v.75h-4.5V.75C5.25.3 4.95 0 4.5 0s-.75.3-.75.75v.75h-1.5C.975 1.5 0 2.475 0 3.75v1.5h15v-1.5c0-1.275-.975-2.25-2.25-2.25"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"15218":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCardholderName);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCardholderName = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 16,
        fill: "none",
        viewBox: "0 0 14 16",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M6.75 7.875A3.937 3.937 0 1 0 6.75 0a3.937 3.937 0 0 0 0 7.875M1.969 9A1.97 1.97 0 0 0 0 10.969v.281c0 1.346.857 2.485 2.073 3.259 1.223.778 2.878 1.241 4.677 1.241s3.454-.463 4.677-1.241c1.216-.774 2.073-1.913 2.073-3.259v-.281A1.97 1.97 0 0 0 11.531 9z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"btQMc":[function() {},{}],"dASiK":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "BillingHistory", ()=>BillingHistory);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _subscriptionService = require("src/services/subscriptionService");
var _userChevronLeftSvg = require("src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg");
var _managePaymentMethodCardSvg = require("src/assets/images/onboarding-trainer/subscription-icons/billing-history/manage-payment-method-card.svg");
var _managePaymentMethodNextSvg = require("src/assets/images/onboarding-trainer/subscription-icons/billing-history/manage-payment-method-next.svg");
var _downloadAllInvoicesSvg = require("src/assets/images/onboarding-trainer/subscription-icons/billing-history/download-all-invoices.svg");
var _searchSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/search.svg");
var _pageArrowPreviousSvg = require("src/assets/images/onboarding-trainer/subscription-icons/billing-history/page-arrow-previous.svg");
var _pageArrowNextSvg = require("src/assets/images/onboarding-trainer/subscription-icons/billing-history/page-arrow-next.svg");
var _appAlert = require("src/utils/appAlert");
var _billingHistoryScss = require("./BillingHistory.scss");
const BillingHistory = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const [filterStatus, setFilterStatus] = (0, _react.useState)('ALL');
    const [sortBy, setSortBy] = (0, _react.useState)('NEWEST');
    const [searchQuery, setSearchQuery] = (0, _react.useState)('');
    const [debouncedSearch, setDebouncedSearch] = (0, _react.useState)('');
    const [currentPage, setCurrentPage] = (0, _react.useState)(1);
    const [downloadingId, setDownloadingId] = (0, _react.useState)(null);
    const [isDownloadingAll, setIsDownloadingAll] = (0, _react.useState)(false);
    const pageSize = 7;
    (0, _react.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebouncedSearch(searchQuery.trim());
        }, 400);
        return ()=>clearTimeout(timer);
    }, [
        searchQuery
    ]);
    const { data: historyData, isLoading, isFetching } = (0, _useSubscriptionApi.useBillingHistoryQuery)({
        page: currentPage,
        limit: pageSize,
        status: filterStatus === 'ALL' ? undefined : filterStatus.toLowerCase(),
        search: debouncedSearch || undefined,
        sort: sortBy.toLowerCase()
    });
    const showItems = [
        {
            key: 'ALL',
            label: 'All Transactions'
        },
        {
            key: 'PAID',
            label: 'Paid'
        },
        {
            key: 'TRIAL',
            label: 'Free Trial'
        },
        {
            key: 'PENDING',
            label: 'Pending'
        },
        {
            key: 'PROCESSING',
            label: 'Processing'
        },
        {
            key: 'FAILED',
            label: 'Failed'
        },
        {
            key: 'REFUNDED',
            label: 'Refunded'
        },
        {
            key: 'CANCELLED',
            label: 'Cancelled'
        }
    ];
    const sortItems = [
        {
            key: 'NEWEST',
            label: 'Date (Newest)'
        },
        {
            key: 'OLDEST',
            label: 'Date (Oldest)'
        }
    ];
    const getShowLabel = ()=>showItems.find((i)=>i.key === filterStatus)?.label || 'All Transactions';
    const getSortLabel = ()=>sortItems.find((i)=>i.key === sortBy)?.label || 'Date (Newest)';
    const handleBack = ()=>{
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/onboarding-trainer/dashboard/subscription/my-subscription');
    };
    const handleGoToManagePayment = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/manage-payment-method');
    };
    const triggerCrossPlatformDownload = (url, filename)=>{
        if (!url) return;
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        link.target = '_blank';
        link.rel = 'noopener noreferrer';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        window.setTimeout(()=>{
            if (document.body.contains(link)) document.body.removeChild(link);
        }, 200);
    };
    const handleDownloadInvoice = async (invoiceId, invNum)=>{
        try {
            setDownloadingId(invoiceId);
            (0, _appAlert.toast).success(`Preparing invoice ${invNum}...`);
            const res = await (0, _subscriptionService.subscriptionService).getInvoiceDownloadUrl(invoiceId);
            const url = res.download_url || res.invoice_pdf || res.hosted_invoice_url;
            if (url) triggerCrossPlatformDownload(url, `${invNum || 'invoice'}.pdf`);
            else (0, _appAlert.toast).error('Download URL is not available for this invoice.');
        } catch (err) {
            (0, _appAlert.toast).error(err.message || `Failed to download invoice ${invNum}`);
        } finally{
            setDownloadingId(null);
        }
    };
    const handleDownloadAll = async ()=>{
        if (isDownloadingAll) return;
        try {
            setIsDownloadingAll(true);
            const res = await (0, _subscriptionService.subscriptionService).downloadAllInvoices();
            if (res.download_url) triggerCrossPlatformDownload(res.download_url, 'all_invoices.zip');
            else (0, _appAlert.toast).error('Download link is not available.');
        } catch (err) {
            (0, _appAlert.toast).error(err.message || 'Failed to download all invoices.');
        } finally{
            setIsDownloadingAll(false);
        }
    };
    const paginatedInvoices = historyData?.invoices || historyData?.items || [];
    const totalResults = historyData?.total_count ?? historyData?.pagination?.total_items ?? paginatedInvoices.length;
    const totalPages = historyData?.total_pages ?? historyData?.pagination?.total_pages ?? Math.max(1, Math.ceil(totalResults / pageSize));
    const startIndex = (currentPage - 1) * pageSize;
    const isTableLoading = isLoading || isFetching;
    const getPaginationItems = (current, total)=>{
        if (total <= 7) return Array.from({
            length: total
        }, (_, i)=>i + 1);
        if (current <= 4) return [
            1,
            2,
            3,
            4,
            5,
            '...',
            total
        ];
        if (current >= total - 3) return [
            1,
            '...',
            total - 4,
            total - 3,
            total - 2,
            total - 1,
            total
        ];
        return [
            1,
            '...',
            current - 1,
            current,
            current + 1,
            '...',
            total
        ];
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "billing-history-page-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "billing-history-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-titles",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: "history-back-btn",
                                onClick: handleBack,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userChevronLeftSvg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: 'Billing History'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                className: "history-subtitle",
                                children: 'View your past payments, invoices, and receipts.'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "header-actions",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                type: "button",
                                className: "btn-manage-pay-header",
                                onClick: handleGoToManagePayment,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _managePaymentMethodCardSvg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: 'Manage Payment Method'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _managePaymentMethodNextSvg.ReactComponent), {})
                                ]
                            }),
                            totalResults > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "download-all-container",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                    type: "button",
                                    className: "btn-download-all-header",
                                    onClick: handleDownloadAll,
                                    disabled: isDownloadingAll,
                                    children: [
                                        isDownloadingAll ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                            indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                style: {
                                                    fontSize: 16,
                                                    color: '#060723'
                                                },
                                                spin: true
                                            })
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downloadAllInvoicesSvg.ReactComponent), {}),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: isDownloadingAll ? 'Preparing all invoices archive...' : 'Download All Invoices'
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "filters-search-bar",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "filter-dropdowns",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                menu: {
                                    items: showItems,
                                    onClick: (e)=>{
                                        setFilterStatus(e.key);
                                        setCurrentPage(1);
                                    }
                                },
                                trigger: [
                                    'click'
                                ],
                                rootClassName: "dark-theme-dropdown",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "filter-item filter-show",
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "desktop-prefix",
                                                    children: 'Show: '
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value",
                                                    children: getShowLabel()
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            width: "12",
                                            height: "12",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                points: "6 9 12 15 18 9"
                                            })
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Dropdown), {
                                menu: {
                                    items: sortItems,
                                    onClick: (e)=>{
                                        setSortBy(e.key);
                                        setCurrentPage(1);
                                    }
                                },
                                trigger: [
                                    'click'
                                ],
                                rootClassName: "dark-theme-dropdown",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "filter-item filter-sort",
                                    style: {
                                        cursor: 'pointer'
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "desktop-prefix",
                                                    children: 'Sort: '
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "value",
                                                    children: getSortLabel()
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
                                            width: "12",
                                            height: "12",
                                            viewBox: "0 0 24 24",
                                            fill: "none",
                                            stroke: "currentColor",
                                            strokeWidth: "2",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round",
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("polyline", {
                                                points: "6 9 12 15 18 9"
                                            })
                                        })
                                    ]
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "divider"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "search-input",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _searchSvg.ReactComponent), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                type: "text",
                                placeholder: "Search invoices...",
                                maxLength: 100,
                                "aria-label": "Search invoices",
                                value: searchQuery,
                                onChange: (e)=>{
                                    setSearchQuery(e.target.value);
                                    setCurrentPage(1);
                                },
                                onBlur: (e)=>setSearchQuery(e.target.value.trim())
                            }),
                            searchQuery && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                onClick: ()=>{
                                    setSearchQuery('');
                                    setCurrentPage(1);
                                },
                                className: "clear-search-btn",
                                "aria-label": "Clear search",
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                    width: "14",
                                    height: "14",
                                    viewBox: "0 0 24 24",
                                    fill: "none",
                                    stroke: "currentColor",
                                    strokeWidth: "2",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                            x1: "18",
                                            y1: "6",
                                            x2: "6",
                                            y2: "18"
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                            x1: "6",
                                            y1: "6",
                                            x2: "18",
                                            y2: "18"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "invoices-table-card",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("table", {
                        className: "invoices-table",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("thead", {
                                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: 'Date'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: 'Description'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: 'Plan'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: 'Amount'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: 'Status'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            children: 'Invoice'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("th", {
                                            className: "th-action"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("tbody", {
                                children: isTableLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        colSpan: 7,
                                        className: "td-loading",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "table-loading-container",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                    indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                        style: {
                                                            fontSize: 28,
                                                            color: '#E2F163'
                                                        },
                                                        spin: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "table-loading-text",
                                                    children: 'Loading invoices...'
                                                })
                                            ]
                                        })
                                    })
                                }) : paginatedInvoices.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("tr", {
                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                        colSpan: 7,
                                        className: "td-empty",
                                        children: 'No billing transactions found.'
                                    })
                                }) : paginatedInvoices.map((inv)=>{
                                    const invId = inv.id;
                                    const invNum = inv.invoice_number || inv.invoiceNumber || inv.id;
                                    const invDate = inv.formatted_date || inv.date;
                                    const invDesc = inv.description;
                                    const invPeriod = inv.period;
                                    const invPlan = inv.plan_name || inv.plan || 'Pro Plan';
                                    const invAmount = inv.formatted_amount || inv.amount;
                                    const invStatus = inv.status;
                                    const statusText = inv.status_label || (invStatus === 'TRIAL' ? 'Free Trial' : invStatus);
                                    const isDownloadDisabled = (inv.is_trial || invStatus === 'TRIAL') && !inv.invoice_pdf && !inv.pdf_available;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                className: "td-date",
                                                children: invDate
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("td", {
                                                className: "td-description",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "desc-title",
                                                        children: invDesc
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "desc-sub",
                                                        children: invPeriod
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                className: "td-plan",
                                                children: invPlan
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                className: "td-amount",
                                                children: invAmount
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                className: "td-status",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: `status-badge ${String(invStatus).toLowerCase()}`,
                                                    children: statusText
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                className: "td-invoice-num",
                                                children: invNum
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("td", {
                                                className: "td-download",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    className: "btn-download-row",
                                                    onClick: ()=>handleDownloadInvoice(invId, invNum),
                                                    disabled: downloadingId === invId || isDownloadingAll || isDownloadDisabled,
                                                    title: isDownloadDisabled ? 'Free trial activation (No charge)' : 'Download invoice',
                                                    "aria-label": `Download invoice ${invNum}`,
                                                    children: downloadingId === invId ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                        indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                            style: {
                                                                fontSize: 15,
                                                                color: '#E2F163'
                                                            },
                                                            spin: true
                                                        })
                                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downloadAllInvoicesSvg.ReactComponent), {})
                                                })
                                            })
                                        ]
                                    }, invId);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: "mobile-invoices-cards",
                        children: isTableLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "mobile-loading-state",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                    indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                        style: {
                                            fontSize: 26,
                                            color: '#E2F163'
                                        },
                                        spin: true
                                    })
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: 'Loading invoices...'
                                })
                            ]
                        }) : paginatedInvoices.length === 0 ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: "mobile-empty-state",
                            children: 'No billing transactions found.'
                        }) : paginatedInvoices.map((inv)=>{
                            const invId = inv.id;
                            const invNum = inv.invoice_number || inv.invoiceNumber || inv.id;
                            const invDate = inv.formatted_date || inv.date;
                            const invDesc = inv.description;
                            const invPeriod = inv.period;
                            const invAmount = inv.formatted_amount || inv.amount;
                            const invStatus = inv.status;
                            const statusText = inv.status_label || (invStatus === 'TRIAL' ? 'Free Trial' : invStatus);
                            const isDownloadDisabled = (inv.is_trial || invStatus === 'TRIAL') && !inv.invoice_pdf && !inv.pdf_available;
                            return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "mobile-invoice-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "card-date-label",
                                        children: invDate
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "card-row-main",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "card-desc-title",
                                                children: invDesc
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "card-amount",
                                                children: invAmount
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "card-row-sub",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "card-period",
                                                children: invPeriod
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: `status-badge ${String(invStatus).toLowerCase()}`,
                                                children: statusText
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                        type: "button",
                                        className: "btn-mobile-download-invoice",
                                        onClick: ()=>handleDownloadInvoice(invId, invNum),
                                        disabled: downloadingId === invId || isDownloadingAll || isDownloadDisabled,
                                        title: isDownloadDisabled ? 'Free trial activation (No charge)' : 'Download invoice',
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: invNum
                                            }),
                                            downloadingId === invId ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                    style: {
                                                        fontSize: 15,
                                                        color: '#E2F163'
                                                    },
                                                    spin: true
                                                })
                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _downloadAllInvoicesSvg.ReactComponent), {})
                                        ]
                                    })
                                ]
                            }, invId);
                        })
                    }),
                    totalResults > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "table-pagination-footer",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                className: "results-counter",
                                children: `Showing ${Math.min(startIndex + 1, totalResults)} to ${Math.min(startIndex + pageSize, totalResults)} \u{2022} ${totalResults} results`
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "pagination-controls",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "page-nav-btn",
                                        disabled: currentPage <= 1 || isFetching,
                                        onClick: ()=>setCurrentPage((p)=>Math.max(1, p - 1)),
                                        "aria-label": "Previous Page",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageArrowPreviousSvg.ReactComponent), {})
                                    }),
                                    getPaginationItems(currentPage, totalPages).map((item, index)=>{
                                        if (typeof item === 'string') return /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "page-ellipsis",
                                            children: item
                                        }, `ellipsis-${index}`);
                                        return /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                            type: "button",
                                            className: `page-num-btn ${currentPage === item ? 'active' : ''}`,
                                            onClick: ()=>setCurrentPage(item),
                                            disabled: isFetching,
                                            children: item
                                        }, item);
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "page-nav-btn",
                                        disabled: currentPage >= totalPages || isFetching,
                                        onClick: ()=>setCurrentPage((p)=>Math.min(totalPages, p + 1)),
                                        "aria-label": "Next Page",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _pageArrowNextSvg.ReactComponent), {})
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","antd":[["Dropdown","cMU6A","default"],["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"src/api/subscription/useSubscriptionApi":"5YJAT","src/services/subscriptionService":"7NbXi","src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg":"bF2mm","src/assets/images/onboarding-trainer/subscription-icons/billing-history/manage-payment-method-card.svg":"hGAwv","src/assets/images/onboarding-trainer/subscription-icons/billing-history/manage-payment-method-next.svg":"kgObN","src/assets/images/onboarding-trainer/subscription-icons/billing-history/download-all-invoices.svg":"a5rz9","src/assets/images/onboarding-trainer/subscription-icons/common/search.svg":"kpWW5","src/assets/images/onboarding-trainer/subscription-icons/billing-history/page-arrow-previous.svg":"dkp7U","src/assets/images/onboarding-trainer/subscription-icons/billing-history/page-arrow-next.svg":"a92SY","src/utils/appAlert":"de4Mq","./BillingHistory.scss":"53n6j","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"hGAwv":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgManagePaymentMethodCard);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgManagePaymentMethodCard = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 11,
        fill: "none",
        viewBox: "0 0 14 11",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M0 9.25A1.75 1.75 0 0 0 1.75 11h10.5A1.75 1.75 0 0 0 14 9.25V4.438H0zm2.063-2.375A.937.937 0 0 1 3 5.938h1.5a.937.937 0 0 1 .938.937V7.5a.937.937 0 0 1-.938.938H3a.937.937 0 0 1-.937-.938zM12.25 0H1.75A1.75 1.75 0 0 0 0 1.75v.813h14V1.75A1.75 1.75 0 0 0 12.25 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a5rz9":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDownloadAllInvoices);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDownloadAllInvoices = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 13,
        fill: "none",
        viewBox: "0 0 14 13",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M1.64 12.775q-.676 0-1.158-.482A1.58 1.58 0 0 1 0 11.134v-1.64q0-.348.236-.584a.8.8 0 0 1 .584-.236q.348 0 .585.236a.79.79 0 0 1 .235.584v1.64h9.843v-1.64q0-.348.236-.584a.8.8 0 0 1 .584-.236q.348 0 .585.236a.79.79 0 0 1 .235.584v1.64q0 .677-.481 1.16a1.58 1.58 0 0 1-1.16.48zm5.742-6.09L8.92 5.147a.76.76 0 0 1 .584-.236q.338.01.585.256.225.247.236.574a.75.75 0 0 1-.236.575L7.136 9.268a.7.7 0 0 1-.267.174.93.93 0 0 1-.615 0 .74.74 0 0 1-.267-.174L3.035 6.316a.75.75 0 0 1-.237-.575.837.837 0 0 1 .82-.83.76.76 0 0 1 .585.236l1.538 1.538V.82q0-.348.237-.585A.8.8 0 0 1 6.562 0q.347.001.584.236a.8.8 0 0 1 .236.584z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kpWW5":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSearch);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSearch = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 24 24",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 11,
                cy: 11,
                r: 8,
                stroke: "currentColor",
                strokeWidth: 2
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeWidth: 2,
                d: "m21 21-4.35-4.35"
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dkp7U":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPageArrowPrevious);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPageArrowPrevious = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        fill: "none",
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            fillOpacity: 0.7,
            d: "M5.795 0a.8.8 0 0 1 .569.236v.001a.804.804 0 0 1 0 1.136v.001L2.72 5.006h8.074a.801.801 0 0 1 .566 1.365.8.8 0 0 1-.566.234H2.721l3.643 3.632a.805.805 0 0 1-.876 1.312.8.8 0 0 1-.261-.175L.23 6.377a.8.8 0 0 1-.168-.264L.06 6.11a.8.8 0 0 1 0-.607l.002-.004a.8.8 0 0 1 .165-.26l5-5.002A.8.8 0 0 1 5.795 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"a92SY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgPageArrowNext);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgPageArrowNext = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 12,
        height: 12,
        fill: "none",
        viewBox: "0 0 12 12",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#fff",
            fillOpacity: 0.7,
            d: "M5.8 0a.8.8 0 0 0-.568.236L5.23.237a.804.804 0 0 0 0 1.136v.001l3.643 3.632H.8a.801.801 0 0 0 0 1.6h8.074l-3.642 3.631a.805.805 0 0 0 1.136 1.137l4.997-4.997a.8.8 0 0 0 .168-.264l.002-.004a.8.8 0 0 0 0-.607l-.002-.004a.8.8 0 0 0-.165-.26l-5-5.002A.8.8 0 0 0 5.8 0"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"53n6j":[function() {},{}],"f1Phb":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "CancelSubscription", ()=>CancelSubscription);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _subscriptionStore = require("src/store/subscriptionStore");
var _userChevronLeftSvg = require("src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg");
var _checkmarkSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/checkmark.svg");
var _cancellationConfirmedSvg = require("src/assets/images/onboarding-trainer/subscription-icons/cancellation/cancellation-confirmed.svg");
var _appAlert = require("src/utils/appAlert");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _cancellationScss = require("./Cancellation.scss");
const CANCEL_REASONS = [
    'Too expensive',
    'Not using enough',
    'Missing features I need',
    'Switching to another tool',
    'Other'
];
const formatDate = (isoString)=>{
    if (!isoString) return null;
    try {
        const d = new Date(isoString);
        return d.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric'
        });
    } catch  {
        return null;
    }
};
const CancelSubscription = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { data: subState } = (0, _useSubscriptionApi.useSubscriptionStateQuery)();
    const { mutate: cancelSub, isPending } = (0, _useSubscriptionApi.useCancelSubscriptionMutation)();
    const { cancelSubscription: storeCancel, accessEndsDate: storeAccessEndsDate } = (0, _subscriptionStore.useSubscriptionStore)();
    const [selectedReason, setSelectedReason] = (0, _react.useState)('');
    const [isConfirmed, setIsConfirmed] = (0, _react.useState)(false);
    const [dynamicAccessDate, setDynamicAccessDate] = (0, _react.useState)(null);
    const displayAccessDate = dynamicAccessDate || formatDate(subState?.access_until || subState?.current_period_end) || storeAccessEndsDate || 'the end of your billing cycle';
    const handleBack = ()=>{
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/onboarding-trainer/dashboard/subscription/my-subscription');
    };
    const handleKeepPro = ()=>{
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/onboarding-trainer/dashboard/subscription/my-subscription');
    };
    const handleBackToSub = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/my-subscription', {
            replace: true
        });
    };
    const handleReactivate = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/reactivate', {
            replace: true
        });
    };
    const handleConfirmCancellation = ()=>{
        if (!selectedReason || isPending) {
            if (!selectedReason) (0, _appAlert.toast).error('Please select a reason for cancelling.');
            return;
        }
        cancelSub({
            reason: selectedReason
        }, {
            onSuccess: (res)=>{
                const formattedAccess = res.access_until ? formatDate(res.access_until) : undefined;
                storeCancel(selectedReason, formattedAccess || undefined);
                if (res.access_until) setDynamicAccessDate(formatDate(res.access_until));
                (0, _appAlert.toast).success(res.message || 'Your subscription has been cancelled.');
                setIsConfirmed(true);
            },
            onError: (err)=>{
                (0, _appAlert.toast).error(err.message || 'Failed to cancel subscription.');
            }
        });
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "cancellation-page-container",
        children: !isConfirmed ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "cancellation-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            className: "cancel-back-btn",
                            onClick: handleBack,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userChevronLeftSvg.ReactComponent), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: 'Cancel Subscription'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "cancel-subtitle",
                            children: "We're sorry to see you go. Please let us know why you're cancelling."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "cancellation-card-wrapper",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "reasons-form-box",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                children: "What's the reason for cancelling?"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: "reasons-list",
                                children: CANCEL_REASONS.map((reason)=>{
                                    const isSelected = selectedReason === reason;
                                    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: `reason-option-item ${isSelected ? 'selected' : ''}`,
                                        onClick: ()=>setSelectedReason(reason),
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "reason-text",
                                                children: reason
                                            }),
                                            isSelected && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "reason-check-wrap",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkSvg.ReactComponent), {
                                                    className: "gold-check"
                                                })
                                            })
                                        ]
                                    }, reason);
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "before-you-go-box",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                                        children: 'Before you go...'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "benefits-checklist",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "benefit-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkSvg.ReactComponent), {
                                                        className: "orange-check"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: `Your Pro access will continue until ${displayAccessDate}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "benefit-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkSvg.ReactComponent), {
                                                        className: "orange-check"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: 'You can reactivate anytime.'
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "benefit-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkSvg.ReactComponent), {
                                                        className: "orange-check"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: 'All your data and programs will be saved'
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "cancellation-actions-row",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn-keep-pro",
                                        onClick: handleKeepPro,
                                        disabled: isPending,
                                        children: 'Keep Pro Access'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "btn-confirm-cancel",
                                        onClick: handleConfirmCancellation,
                                        disabled: !selectedReason || isPending,
                                        children: isPending ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                    indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                        style: {
                                                            fontSize: 14,
                                                            color: '#fff',
                                                            marginRight: 8
                                                        },
                                                        spin: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    children: 'Cancelling...'
                                                })
                                            ]
                                        }) : 'Confirm Cancellation'
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        }) : /* State 2: Cancellation Confirmed */ /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "cancellation-confirmed-view",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "confirmed-icon-wrap",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cancellationConfirmedSvg.ReactComponent), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: 'Cancellation confirmed'
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                    className: "confirmed-subtext",
                    children: `Your subscription has been cancelled. You will continue to have Pro access until ${displayAccessDate}`
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "confirmed-actions",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            className: "btn-back-to-sub",
                            onClick: handleBackToSub,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userChevronLeftSvg.ReactComponent), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: 'Back to subscription'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-reactivate-dark",
                            onClick: handleReactivate,
                            children: 'Reactivate Pro'
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","src/api/subscription/useSubscriptionApi":"5YJAT","src/store/subscriptionStore":"rMPpj","src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg":"bF2mm","src/assets/images/onboarding-trainer/subscription-icons/checkout/checkmark.svg":"9ELfB","src/assets/images/onboarding-trainer/subscription-icons/cancellation/cancellation-confirmed.svg":"kaxBV","src/utils/appAlert":"de4Mq","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"./Cancellation.scss":"id9FJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kaxBV":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgCancellationConfirmed);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgCancellationConfirmed = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 64,
        height: 64,
        fill: "none",
        viewBox: "43 31 64 64",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("circle", {
                cx: 75,
                cy: 63,
                r: 29,
                fill: "rgba(255, 225, 17, 0.06)"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                stroke: "url(#a)",
                strokeWidth: 2,
                d: "M75 33.857c16.095 0 29.143 13.048 29.143 29.143S91.095 92.143 75 92.143 45.857 79.095 45.857 63 58.905 33.857 75 33.857Z",
                shapeRendering: "crispEdges"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                fill: "url(#b)",
                d: "m70.108 69.3 16.95-16.95q.6-.6 1.4-.6t1.4.6.6 1.426-.6 1.424l-18.35 18.4q-.6.6-1.4.6t-1.4-.6l-8.6-8.6q-.6-.6-.576-1.424.024-.825.626-1.426a1.94 1.94 0 0 1 1.426-.6q.824.001 1.424.6z"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "b",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(27.8991 -12.6281 2.78295 50.0018 61.294 70.391)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFEB14"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFA100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "a",
                        x1: 75,
                        x2: 75,
                        y1: 33,
                        y2: 93,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFE111"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFA100"
                            })
                        ]
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"id9FJ":[function() {},{}],"3ko3J":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactivatePro", ()=>ReactivatePro);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _subscriptionStore = require("src/store/subscriptionStore");
var _userChevronLeftSvg = require("src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg");
var _checkmarkSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/checkmark.svg");
var _securePaymentLockSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/secure-payment-lock.svg");
var _billingInfoEditSvg = require("src/assets/images/onboarding-trainer/subscription-icons/reactivate-pro/billing-info-edit.svg");
var _addButtonSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/add-button.svg");
var _cardBrandLogo = require("../components/CardBrandLogo");
var _cardUtils = require("src/utils/cardUtils");
var _billingInfoModal = require("../modals/BillingInfoModal");
var _paymentMethodModal = require("../modals/PaymentMethodModal");
var _paymentConfirmedModal = require("../modals/PaymentConfirmedModal");
var _appAlert = require("src/utils/appAlert");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _reactivateProScss = require("./ReactivatePro.scss");
const ReactivatePro = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { data: subState } = (0, _useSubscriptionApi.useSubscriptionStateQuery)();
    const { data: billingProfile, refetch: refetchBillingProfile } = (0, _useSubscriptionApi.useBillingProfileQuery)();
    const { data: paymentMethodsData, refetch: refetchPaymentMethods } = (0, _useSubscriptionApi.usePaymentMethodsQuery)();
    const { billingCycle: storeBillingCycle, billingInfo: storeBillingInfo, paymentMethods: storePaymentMethods, reactivateSubscription: storeReactivate, appliedPromo: storeAppliedPromo, removePromoCode: storeRemovePromo } = (0, _subscriptionStore.useSubscriptionStore)();
    const profileBillingCountry = billingProfile?.country || storeBillingInfo.country;
    const { data: plansData, isLoading: isPlansLoading } = (0, _useSubscriptionApi.useSubscriptionPlansQuery)(profileBillingCountry);
    const billingCountry = profileBillingCountry || plansData?.country;
    const { mutate: validatePromo, isPending: isValidatingPromo } = (0, _useSubscriptionApi.useValidatePromoCodeMutation)();
    const { mutate: reactivateSub, isPending: isSubmitting } = (0, _useSubscriptionApi.useReactivateSubscriptionMutation)();
    const recordLegalAck = (0, _useSubscriptionApi.useRecordLegalAcknowledgementMutation)();
    const [isBillingModalOpen, setIsBillingModalOpen] = (0, _react.useState)(false);
    const [isPaymentModalOpen, setIsPaymentModalOpen] = (0, _react.useState)(false);
    const [isConfirmedModalOpen, setIsConfirmedModalOpen] = (0, _react.useState)(false);
    const [promoInput, setPromoInput] = (0, _react.useState)('');
    const [promoError, setPromoError] = (0, _react.useState)('');
    const [appliedPromoState, setAppliedPromoState] = (0, _react.useState)(null);
    const [isAgreed, setIsAgreed] = (0, _react.useState)(false);
    const [agreedError, setAgreedError] = (0, _react.useState)(false);
    const billingCycle = subState?.billing_interval === 'year' ? 'yearly' : storeBillingCycle || 'monthly';
    const targetInterval = billingCycle === 'yearly' ? 'year' : 'month';
    const proPlan = plansData?.plans?.find((p)=>p.tier_slug === 'pro' && p.interval === targetInterval) || plansData?.plans?.find((p)=>p.tier_slug === 'pro') || plansData?.plans?.[0];
    const featuresList = proPlan?.features?.length ? proPlan.features : [];
    const activePromo = appliedPromoState || storeAppliedPromo;
    const { data: previewData, isLoading: isPreviewLoading, isError: isPreviewError, error: previewError, refetch: refetchPreview } = (0, _useSubscriptionApi.useCheckoutPreviewQuery)({
        tier_slug: 'pro',
        interval: targetInterval,
        price_id: proPlan?.price_id,
        promo_code: activePromo?.code,
        country: billingCountry,
        trial_selection: false,
        enabled: Boolean(proPlan?.price_id)
    });
    const backendPromoLabel = previewData?.promotion_percentage ? ` (-${previewData.promotion_percentage}%)` : previewData?.formatted_promotion_discount_amount || previewData?.formatted_discount ? ` (-${previewData.formatted_promotion_discount_amount || previewData.formatted_discount})` : '';
    const [currentTimestamp] = (0, _react.useState)(()=>Date.now());
    const rawAccessUntil = subState?.access_until || subState?.current_period_end;
    const isPlanNotExpired = (0, _react.useMemo)(()=>{
        const isCancelledOrPending = subState?.status === 'cancelled' || subState?.cancel_at_period_end === true;
        if (!isCancelledOrPending || !rawAccessUntil) return false;
        const accessTime = new Date(rawAccessUntil).getTime();
        return !isNaN(accessTime) && accessTime > currentTimestamp;
    }, [
        subState?.status,
        subState?.cancel_at_period_end,
        rawAccessUntil,
        currentTimestamp
    ]);
    const accessUntilFormatted = (0, _react.useMemo)(()=>{
        if (!rawAccessUntil) return '';
        try {
            const d = new Date(rawAccessUntil);
            if (isNaN(d.getTime())) return '';
            return d.toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'short',
                year: 'numeric'
            });
        } catch  {
            return '';
        }
    }, [
        rawAccessUntil
    ]);
    const currencySymbol = previewData?.currency_symbol || plansData?.currency_symbol || previewData?.formatted_total?.match(/^[^\d\s]+/)?.[0] || "\u20B9";
    const handleBack = ()=>{
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/onboarding-trainer/dashboard/subscription/my-subscription');
    };
    const handleApplyPromo = ()=>{
        const trimmed = promoInput.trim().toUpperCase();
        if (!trimmed || isValidatingPromo) {
            if (!trimmed) setPromoError('Please enter a promo code');
            return;
        }
        if (trimmed.length < 3) {
            setPromoError('Promo code must be at least 3 characters');
            return;
        }
        if (trimmed.length > 30) {
            setPromoError('Promo code cannot exceed 30 characters');
            return;
        }
        setPromoError('');
        validatePromo({
            code: trimmed,
            tier_slug: 'pro',
            interval: targetInterval,
            price_id: proPlan?.price_id,
            country: billingCountry
        }, {
            onSuccess: (res)=>{
                const promoCode = res.applied_promo?.code || res.code || trimmed;
                const promoDiscount = res.applied_promo?.discount_percent ?? res.discount_percent ?? res.percent_off ?? 0;
                setAppliedPromoState({
                    code: promoCode,
                    discountPercent: promoDiscount
                });
                (0, _appAlert.toast).success(res.message || `Promo code ${promoCode} applied!`);
                setPromoInput('');
                setPromoError('');
            },
            onError: (err)=>{
                setPromoError(err.userMessage || err.message || 'Invalid promo code');
            }
        });
    };
    const handleRemovePromo = ()=>{
        setAppliedPromoState(null);
        storeRemovePromo();
    };
    const handleReactivate = ()=>{
        if (!isAgreed) {
            setAgreedError(true);
            (0, _appAlert.toast).error('Please agree to the Terms of Service and Privacy Policy.');
            return;
        }
        setAgreedError(false);
        reactivateSub(undefined, {
            onSuccess: (res)=>{
                recordLegalAck.mutate();
                storeReactivate();
                setIsConfirmedModalOpen(true);
                (0, _appAlert.toast).success(res.message || 'Welcome back! Your Pro subscription has been reactivated.');
            },
            onError: (err)=>{
                if (err.code === 'ERR_SUBSCRIPTION_ALREADY_EXPIRED') {
                    (0, _appAlert.toast).error('Your subscription has expired. Please select a plan to renew Pro.');
                    navigate('/onboarding-trainer/dashboard/subscription/plans');
                } else (0, _appAlert.toast).error(err.message || 'Failed to reactivate subscription.');
            }
        });
    };
    const handleGoToSupport = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/contact-support');
    };
    const handleNavigateLegal = (path)=>{
        navigate(`/onboarding-trainer/dashboard/subscription/${path}`);
    };
    const paymentCards = paymentMethodsData?.payment_methods || [];
    const defaultCard = paymentCards.find((c)=>c.id === paymentMethodsData?.default_payment_method_id) || paymentCards.find((c)=>c.is_default || c.isDefault) || paymentCards[0] || storePaymentMethods.find((c)=>c.isDefault) || storePaymentMethods[0];
    const fullNameDisplay = billingProfile?.fullName || billingProfile?.companyName || storeBillingInfo.fullName || storeBillingInfo.companyName || 'Personal Trainer';
    const emailDisplay = billingProfile?.billingEmail || storeBillingInfo.billingEmail || '';
    const addressDisplay = billingProfile?.addressLine1 ? `${billingProfile.addressLine1}${billingProfile.city ? `, ${billingProfile.city}` : ''}` : storeBillingInfo.addressLine1;
    if (isPlansLoading || isPreviewLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "reactivate-page-container",
        style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '60vh'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
            indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                style: {
                    fontSize: 32,
                    color: '#E2F163'
                },
                spin: true
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "reactivate-page-container",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "reactivate-page-header",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        type: "button",
                        className: "reactivate-back-btn",
                        onClick: handleBack,
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userChevronLeftSvg.ReactComponent), {}),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                children: 'Reactivate Pro'
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "reactivate-subtitle",
                        children: 'Welcome back! Reactivate your Pro plan to regain access to all features'
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "reactivate-grid",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "reactivate-left-col",
                        children: [
                            isPlanNotExpired && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "reactivate-unexpired-banner",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "banner-icon-wrap",
                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.InfoCircleOutlined), {
                                            className: "banner-icon"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "banner-content",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "banner-header",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "banner-title",
                                                        children: 'No charge today'
                                                    }),
                                                    accessUntilFormatted && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "banner-pill",
                                                        children: `Active until ${accessUntilFormatted}`
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                                                className: "banner-desc",
                                                children: [
                                                    'You already have active Pro access until ',
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: accessUntilFormatted || 'the end of your billing cycle'
                                                    }),
                                                    '. Reactivating keeps all your Pro features active without interruption, and your automatic renewal will resume on ',
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                                        children: accessUntilFormatted || 'your next billing date'
                                                    }),
                                                    '.'
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "reactivate-card summary-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: 'Billing Summary'
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "summary-rows",
                                        children: isPreviewError ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            style: {
                                                padding: '12px',
                                                borderRadius: '8px',
                                                backgroundColor: 'rgba(239, 68, 68, 0.1)',
                                                border: '1px solid rgba(239, 68, 68, 0.3)',
                                                color: '#ef4444',
                                                fontSize: '13px',
                                                marginBottom: '12px'
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    style: {
                                                        margin: '0 0 6px 0'
                                                    },
                                                    children: previewError?.userMessage || previewError?.message || 'Failed to load pricing preview.'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>refetchPreview(),
                                                    style: {
                                                        background: 'none',
                                                        border: 'none',
                                                        color: '#ef4444',
                                                        textDecoration: 'underline',
                                                        cursor: 'pointer',
                                                        padding: 0,
                                                        fontWeight: 600
                                                    },
                                                    children: 'Retry'
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: proPlan?.name || 'Pro Plan'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value",
                                                            children: previewData?.formatted_subtotal || "\u2014"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row cycle-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: 'Billing Cycle'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value capitalize",
                                                            children: billingCycle
                                                        })
                                                    ]
                                                }),
                                                activePromo && previewData?.formatted_discount && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row discount-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: `Promo Discount (${activePromo.code})`
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value",
                                                            style: {
                                                                color: '#10b981'
                                                            },
                                                            children: `-${previewData.formatted_discount}`
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: 'Subtotal'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value",
                                                            children: activePromo && previewData?.formatted_discount ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "strikethrough",
                                                                        children: previewData.formatted_subtotal
                                                                    }),
                                                                    ' ',
                                                                    previewData.formatted_discounted_subtotal || previewData.formatted_total
                                                                ]
                                                            }) : previewData?.formatted_subtotal || "\u2014"
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: `Tax (${previewData?.tax_rate_percent ?? 0}%)`
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value",
                                                            children: previewData?.formatted_tax || "\u2014"
                                                        })
                                                    ]
                                                }),
                                                isPlanNotExpired ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "summary-row next-charge-row",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "row-label",
                                                                    children: accessUntilFormatted ? `Renewal Total (on ${accessUntilFormatted})` : 'Renewal Total'
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "row-value",
                                                                    children: previewData?.formatted_total || "\u2014"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "summary-row total-row due-today-row",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                                    className: "row-label",
                                                                    children: [
                                                                        'Due Today',
                                                                        accessUntilFormatted && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                            className: "already-paid-tag",
                                                                            children: `Paid until ${accessUntilFormatted}`
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "row-value highlight-val zero-cost",
                                                                    children: `${currencySymbol}0.00`
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "summary-row total-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-label",
                                                            children: 'Total'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "row-value highlight-val",
                                                            children: previewData?.formatted_total || "\u2014"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    }),
                                    isPlanNotExpired && defaultCard && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "reactivate-renewal-card-section",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "renewal-section-label",
                                                children: accessUntilFormatted ? `Upcoming renewal on ${accessUntilFormatted} will be billed to:` : 'Upcoming renewal will be billed to:'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "payment-card-row selected-card",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                        className: "card-brand-wrap",
                                                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                                            brand: defaultCard.brand
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: "card-info-text",
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "card-title-text",
                                                                children: (0, _cardUtils.getCardBrandDisplayName)(defaultCard.brand)
                                                            }),
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                className: "card-mask",
                                                                children: (0, _cardUtils.formatMaskedCardNumber)(defaultCard.brand, defaultCard.last4)
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "default-pill",
                                                        children: 'Default'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    !isPlanNotExpired && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "promo-section",
                                        children: activePromo ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "applied-promo-badge",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                    children: [
                                                        `Promo applied: ${activePromo.code}`,
                                                        backendPromoLabel
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                    type: "button",
                                                    onClick: handleRemovePromo,
                                                    "aria-label": "Remove promo code",
                                                    children: "\u2715"
                                                })
                                            ]
                                        }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                                    htmlFor: "reactivate-promo-input",
                                                    children: 'Add promo code'
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                                                    className: "promo-input-row",
                                                    onSubmit: (e)=>{
                                                        e.preventDefault();
                                                        handleApplyPromo();
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                            className: "promo-input-field-wrap",
                                                            children: [
                                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                                    id: "reactivate-promo-input",
                                                                    type: "text",
                                                                    placeholder: "Code",
                                                                    maxLength: 30,
                                                                    className: promoError ? 'has-error' : '',
                                                                    value: promoInput,
                                                                    onChange: (e)=>{
                                                                        setPromoInput(e.target.value.toUpperCase());
                                                                        if (promoError) setPromoError('');
                                                                    },
                                                                    onBlur: (e)=>setPromoInput(e.target.value.trim()),
                                                                    autoComplete: "off"
                                                                }),
                                                                promoInput.length > 0 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                    type: "button",
                                                                    className: "clear-promo-btn",
                                                                    onClick: ()=>{
                                                                        setPromoInput('');
                                                                        if (promoError) setPromoError('');
                                                                    },
                                                                    "aria-label": "Clear promo code",
                                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
                                                                        width: "14",
                                                                        height: "14",
                                                                        viewBox: "0 0 24 24",
                                                                        fill: "none",
                                                                        stroke: "currentColor",
                                                                        strokeWidth: "2",
                                                                        strokeLinecap: "round",
                                                                        strokeLinejoin: "round",
                                                                        children: [
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                                x1: "18",
                                                                                y1: "6",
                                                                                x2: "6",
                                                                                y2: "18"
                                                                            }),
                                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("line", {
                                                                                x1: "6",
                                                                                y1: "6",
                                                                                x2: "18",
                                                                                y2: "18"
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                            type: "submit",
                                                            className: "btn-add-promo",
                                                            disabled: isValidatingPromo,
                                                            children: isValidatingPromo ? /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                                    style: {
                                                                        fontSize: 13,
                                                                        color: '#060723'
                                                                    },
                                                                    spin: true
                                                                })
                                                            }) : 'Add'
                                                        })
                                                    ]
                                                }),
                                                promoError && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                    className: "promo-error-text",
                                                    children: promoError
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }),
                            !isPlanNotExpired && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "reactivate-card billing-info-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "card-header-with-action",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: 'Billing Information'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "icon-action-btn",
                                                onClick: ()=>setIsBillingModalOpen(true),
                                                title: "Edit billing info",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _billingInfoEditSvg.ReactComponent), {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "info-key-value-list",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "kv-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "kv-key",
                                                        children: 'Full Name'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "kv-val",
                                                        children: fullNameDisplay
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "kv-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "kv-key",
                                                        children: 'Billing Email'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "kv-val",
                                                        children: emailDisplay
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "kv-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "kv-key",
                                                        children: 'Address'
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "kv-val",
                                                        children: addressDisplay
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !isPlanNotExpired && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "reactivate-card payment-method-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "card-header-with-action",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                children: 'Payment Method'
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                                type: "button",
                                                className: "btn-add-mini",
                                                onClick: ()=>setIsPaymentModalOpen(true),
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonSvg.ReactComponent), {}),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: 'Add'
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    defaultCard ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                        className: "payment-card-row selected-card",
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                className: "card-brand-wrap",
                                                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _cardBrandLogo.CardBrandLogo), {
                                                    brand: defaultCard.brand
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "card-info-text",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "card-title-text",
                                                        children: (0, _cardUtils.getCardBrandDisplayName)(defaultCard.brand)
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        className: "card-mask",
                                                        children: (0, _cardUtils.formatMaskedCardNumber)(defaultCard.brand, defaultCard.last4)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                className: "default-pill",
                                                children: 'Default'
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                        className: "card-empty-description",
                                        children: 'A payment method is required to reactivate Pro.'
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                        className: "reactivate-right-col",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "with-pro-card",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                        children: `With ${proPlan?.name ?? 'Pro'} you get`
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                        className: "features-list",
                                        children: featuresList.map((feat)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                className: "feature-item",
                                                children: [
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkSvg.ReactComponent), {
                                                        className: "gold-check"
                                                    }),
                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                        children: feat
                                                    })
                                                ]
                                            }, feat))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "security-notice",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _securePaymentLockSvg.ReactComponent), {}),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: 'Your payment information is secure and encrypted.'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                className: `terms-agreement-checkbox ${agreedError ? 'has-error' : ''}`,
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                        type: "checkbox",
                                        checked: isAgreed,
                                        onChange: (e)=>{
                                            setIsAgreed(e.target.checked);
                                            if (e.target.checked) setAgreedError(false);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                        children: [
                                            'I agree to the ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "legal-inline-link",
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    handleNavigateLegal('terms-of-service');
                                                },
                                                children: 'Terms of Service'
                                            }),
                                            ' and ',
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                type: "button",
                                                className: "legal-inline-link",
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    handleNavigateLegal('privacy-policy');
                                                },
                                                children: 'Privacy Policy'
                                            }),
                                            '.'
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                type: "button",
                                className: "btn-reactivate-cta",
                                onClick: handleReactivate,
                                disabled: isSubmitting || isPreviewLoading || isPreviewError || !previewData,
                                children: isSubmitting ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                            indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                style: {
                                                    fontSize: 18,
                                                    color: '#060723'
                                                },
                                                spin: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            children: 'Reactivating...'
                                        })
                                    ]
                                }) : isPreviewLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: 'Loading pricing...'
                                }) : isPlanNotExpired ? /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: `Reactivate Pro \u{2014} ${currencySymbol}0.00 Due Today`
                                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: 'Reactivate Pro'
                                })
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                className: "need-help-link-wrap",
                                children: [
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                        children: 'Need help? '
                                    }),
                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                        type: "button",
                                        className: "help-link",
                                        onClick: handleGoToSupport,
                                        children: 'Contact Support'
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _billingInfoModal.BillingInfoModal), {
                isOpen: isBillingModalOpen,
                onClose: ()=>setIsBillingModalOpen(false),
                onSuccess: ()=>{
                    refetchBillingProfile();
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentMethodModal.PaymentMethodModal), {
                isOpen: isPaymentModalOpen,
                onClose: ()=>setIsPaymentModalOpen(false),
                onSuccess: ()=>{
                    refetchPaymentMethods();
                }
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _paymentConfirmedModal.PaymentConfirmedModal), {
                isOpen: isConfirmedModalOpen,
                onClose: ()=>setIsConfirmedModalOpen(false),
                isTrialMode: false,
                amountFormatted: previewData?.formatted_total,
                dueTodayFormatted: isPlanNotExpired ? `${currencySymbol}0.00` : previewData?.formatted_due_today || previewData?.formatted_total,
                firstPaymentFormatted: previewData?.formatted_total,
                nextBillingDateFormatted: isPlanNotExpired ? accessUntilFormatted : undefined
            })
        ]
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","src/api/subscription/useSubscriptionApi":"5YJAT","src/store/subscriptionStore":"rMPpj","src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg":"bF2mm","src/assets/images/onboarding-trainer/subscription-icons/checkout/checkmark.svg":"9ELfB","src/assets/images/onboarding-trainer/subscription-icons/checkout/secure-payment-lock.svg":"2POVx","src/assets/images/onboarding-trainer/subscription-icons/reactivate-pro/billing-info-edit.svg":"d1EPl","src/assets/images/onboarding-trainer/subscription-icons/checkout/add-button.svg":"6V9WO","../components/CardBrandLogo":"g5uLF","src/utils/cardUtils":"2ly56","../modals/BillingInfoModal":"5jyNn","../modals/PaymentMethodModal":"9Ak0b","../modals/PaymentConfirmedModal":"6SHFU","src/utils/appAlert":"de4Mq","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["InfoCircleOutlined","1jBmx","default"],["LoadingOutlined","8Mvdh","default"]],"./ReactivatePro.scss":"alkeZ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1jBmx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
var _react = require("react");
var _infoCircleOutlined = require("@ant-design/icons-svg/es/asn/InfoCircleOutlined");
var _infoCircleOutlinedDefault = parcelHelpers.interopDefault(_infoCircleOutlined);
var _antdIcon = require("../components/AntdIcon");
var _antdIconDefault = parcelHelpers.interopDefault(_antdIcon);
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const InfoCircleOutlined = (props, ref)=>/*#__PURE__*/ _react.createElement((0, _antdIconDefault.default), _extends({}, props, {
        ref: ref,
        icon: (0, _infoCircleOutlinedDefault.default)
    }));
/**![info-circle](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTUxMiA2NEMyNjQuNiA2NCA2NCAyNjQuNiA2NCA1MTJzMjAwLjYgNDQ4IDQ0OCA0NDggNDQ4LTIwMC42IDQ0OC00NDhTNzU5LjQgNjQgNTEyIDY0em0wIDgyMGMtMjA1LjQgMC0zNzItMTY2LjYtMzcyLTM3MnMxNjYuNi0zNzIgMzcyLTM3MiAzNzIgMTY2LjYgMzcyIDM3Mi0xNjYuNiAzNzItMzcyIDM3MnoiIC8+PHBhdGggZD0iTTQ2NCAzMzZhNDggNDggMCAxMDk2IDAgNDggNDggMCAxMC05NiAwem03MiAxMTJoLTQ4Yy00LjQgMC04IDMuNi04IDh2MjcyYzAgNC40IDMuNiA4IDggOGg0OGM0LjQgMCA4LTMuNiA4LThWNDU2YzAtNC40LTMuNi04LTgtOHoiIC8+PC9zdmc+) */ const RefIcon = /*#__PURE__*/ _react.forwardRef(InfoCircleOutlined);
exports.default = RefIcon;

},{"react":"bmhQu","@ant-design/icons-svg/es/asn/InfoCircleOutlined":"jSMQ0","../components/AntdIcon":"hjeUJ","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jSMQ0":[function(require,module,exports,__globalThis) {
// This icon file is generated automatically.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var InfoCircleOutlined = {
    "icon": {
        "tag": "svg",
        "attrs": {
            "viewBox": "64 64 896 896",
            "focusable": "false"
        },
        "children": [
            {
                "tag": "path",
                "attrs": {
                    "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"
                }
            },
            {
                "tag": "path",
                "attrs": {
                    "d": "M464 336a48 48 0 1096 0 48 48 0 10-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z"
                }
            }
        ]
    },
    "name": "info-circle",
    "theme": "outlined"
};
exports.default = InfoCircleOutlined;

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"alkeZ":[function() {},{}],"gks7i":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ContactSupport", ()=>ContactSupport);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _useSubscriptionApi = require("src/api/subscription/useSubscriptionApi");
var _subscriptionStore = require("src/store/subscriptionStore");
var _sessionStore = require("src/store/sessionStore");
var _firebase = require("src/config/firebase");
var _storage = require("firebase/storage");
var _firebaseStorage = require("src/api/services/firebaseStorage");
var _firestore = require("firebase/firestore");
var _userChevronLeftSvg = require("src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg");
var _supportAvailabilitySvg = require("src/assets/images/onboarding-trainer/subscription-icons/contact-support/support-availability.svg");
var _tipsSupportSvg = require("src/assets/images/onboarding-trainer/subscription-icons/contact-support/tips-support.svg");
var _otherWaysSvg = require("src/assets/images/onboarding-trainer/subscription-icons/contact-support/other-ways.svg");
var _emailUsSvg = require("src/assets/images/onboarding-trainer/subscription-icons/contact-support/email-us.svg");
var _sendPlaneSvg = require("src/assets/images/onboarding-trainer/subscription-icons/common/send-plane.svg");
var _addButtonSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/add-button.svg");
var _checkmarkSvg = require("src/assets/images/onboarding-trainer/subscription-icons/checkout/checkmark.svg");
var _dropdownSvg = require("src/assets/images/onboarding-trainer/subscription-icons/billing-information/dropdown.svg");
var _messageSentCheckSvg = require("src/assets/images/onboarding-trainer/subscription-icons/contact-support/message-sent-check.svg");
var _appAlert = require("src/utils/appAlert");
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _contactSupportScss = require("./ContactSupport.scss");
const DEFAULT_TOPICS = [
    {
        code: 'billing_subscription',
        label: 'Billing & Subscription'
    },
    {
        code: 'payment_issue',
        label: 'Payment Issue'
    },
    {
        code: 'technical_problem',
        label: 'Technical Problem'
    },
    {
        code: 'account_settings',
        label: 'Account Settings'
    },
    {
        code: 'feature_request',
        label: 'Feature Request'
    },
    {
        code: 'other',
        label: 'Other'
    }
];
const ContactSupport = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    const { addSupportTicket, billingInfo } = (0, _subscriptionStore.useSubscriptionStore)();
    const currentUser = (0, _sessionStore.sessionStore)((state)=>state.currentUser);
    const { data: supportConfig, isLoading: isSupportConfigLoading } = (0, _useSubscriptionApi.useSupportConfigQuery)();
    const { data: serverProfile } = (0, _useSubscriptionApi.useBillingProfileQuery)();
    const { mutateAsync: submitTicketAsync, isPending: isSubmittingTicket } = (0, _useSubscriptionApi.useContactSupportMutation)();
    const { mutate: deleteServerAttachment } = (0, _useSubscriptionApi.useDeleteSupportAttachmentMutation)();
    const [isSubmitting, setIsSubmitting] = (0, _react.useState)(false);
    const [topicCode, setTopicCode] = (0, _react.useState)('');
    const [isTopicDropdownOpen, setIsTopicDropdownOpen] = (0, _react.useState)(false);
    const [subject, setSubject] = (0, _react.useState)('');
    const [message, setMessage] = (0, _react.useState)('');
    const [screenshots, setScreenshots] = (0, _react.useState)([]);
    const [isUploadingFile, setIsUploadingFile] = (0, _react.useState)(false);
    const [isSent, setIsSent] = (0, _react.useState)(false);
    const [sentReplyEmail, setSentReplyEmail] = (0, _react.useState)(null);
    const [createdChatId, setCreatedChatId] = (0, _react.useState)('');
    const [errors, setErrors] = (0, _react.useState)({});
    const [touched, setTouched] = (0, _react.useState)({});
    const fileInputRef = (0, _react.useRef)(null);
    const topicDropdownRef = (0, _react.useRef)(null);
    const availableTopics = supportConfig?.topics?.length ? supportConfig.topics : DEFAULT_TOPICS;
    const supportEmail = supportConfig?.support_email || 'support@minipt.co.uk';
    // Close dropdown on click outside
    (0, _react.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (topicDropdownRef.current && !topicDropdownRef.current.contains(event.target)) setIsTopicDropdownOpen(false);
        };
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    const handleBack = ()=>{
        if (window.history.state && window.history.state.idx > 0) navigate(-1);
        else navigate('/onboarding-trainer/dashboard/subscription/my-subscription');
    };
    const handleBlur = (field, val)=>{
        setTouched((prev)=>({
                ...prev,
                [field]: true
            }));
        validateField(field, val.trim());
    };
    const validateField = (field, val)=>{
        let error = '';
        if (field === 'topic') {
            if (!val) error = 'Please select a topic';
        } else if (field === 'subject') {
            if (!val) error = 'Subject is required';
            else if (!/\p{L}/u.test(val)) error = 'Subject must contain letters';
        } else if (field === 'message') {
            if (!val) error = 'Message is required';
            else if (val.length < 10) error = 'Please provide more details (at least 10 characters)';
        }
        setErrors((prev)=>({
                ...prev,
                [field]: error
            }));
        return !error;
    };
    const handleFileChange = async (e)=>{
        const files = e.target.files;
        if (!files || files.length === 0) return;
        if (screenshots.length + files.length > 5) {
            (0, _appAlert.toast).error('You can add up to 5 screenshots.');
            if (fileInputRef.current) fileInputRef.current.value = '';
            return;
        }
        const allowedTypes = supportConfig?.allowed_mime_types || [
            'image/png',
            'image/jpeg',
            'image/jpg',
            'image/webp'
        ];
        const uid = currentUser?.uid || (0, _firebase.auth).currentUser?.uid || 'temp_trainer';
        const validFiles = [];
        for (const file of Array.from(files)){
            if (!allowedTypes.includes(file.type)) {
                (0, _appAlert.toast).error(`Invalid file format for ${file.name}. Only PNG, JPG, and WebP are allowed.`);
                continue;
            }
            if (file.size > 5242880) {
                (0, _appAlert.toast).error(`File ${file.name} is too large. Max 5MB.`);
                continue;
            }
            validFiles.push(file);
        }
        if (validFiles.length === 0) {
            if (fileInputRef.current) fileInputRef.current.value = '';
            return;
        }
        // Immediately attach images with uploading indicator overlay
        const newItems = validFiles.map((file)=>({
                id: `img_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`,
                fileName: file.name,
                storagePath: '',
                previewUrl: URL.createObjectURL(file),
                fileSizeBytes: file.size,
                contentType: file.type,
                isUploading: true
            }));
        setScreenshots((prev)=>[
                ...prev,
                ...newItems
            ]);
        setIsUploadingFile(true);
        try {
            for(let i = 0; i < validFiles.length; i++){
                const file = validFiles[i];
                const item = newItems[i];
                const safeFileName = file.name.replace(/[^a-zA-Z0-9._-]/g, '_');
                const storagePath = `support_tickets/${uid}/${Date.now()}_${safeFileName}`;
                const storageRef = (0, _storage.ref)((0, _firebase.storage), storagePath);
                try {
                    await (0, _storage.uploadBytes)(storageRef, file, {
                        contentType: file.type
                    });
                    // Mark uploaded
                    setScreenshots((prev)=>prev.map((s)=>s.id === item.id ? {
                                ...s,
                                storagePath,
                                isUploading: false
                            } : s));
                } catch  {
                    // Remove failed screenshot
                    setScreenshots((prev)=>prev.filter((s)=>s.id !== item.id));
                    (0, _appAlert.toast).error(`Failed to upload ${file.name}. Please try again.`);
                }
            }
        } catch  {
            (0, _appAlert.toast).error('Failed to upload screenshot. Please try again.');
        } finally{
            setIsUploadingFile(false);
            if (fileInputRef.current) fileInputRef.current.value = '';
        }
    };
    const handleRemoveScreenshot = (idToRemove)=>{
        const target = screenshots.find((s)=>s.id === idToRemove);
        if (!target) return;
        // Remove from UI state immediately
        setScreenshots((prev)=>prev.filter((s)=>s.id !== idToRemove));
        // Revoke local object URL if it was a blob
        if (target.previewUrl && target.previewUrl.startsWith('blob:')) URL.revokeObjectURL(target.previewUrl);
        // Delete from Firebase Storage server and backend API
        if (target.storagePath) {
            (0, _firebaseStorage.deleteSupportScreenshot)(target.storagePath);
            deleteServerAttachment(target.storagePath, {
                onError: (err)=>{
                    console.warn('Backend server attachment deletion notice:', err);
                }
            });
        }
    };
    const handleSendMessage = async ()=>{
        const newErrors = {};
        if (!topicCode) newErrors.topic = 'Please select a topic';
        if (!subject.trim()) newErrors.subject = 'Subject is required';
        else if (!/\p{L}/u.test(subject)) newErrors.subject = 'Subject must contain letters';
        if (!message.trim()) newErrors.message = 'Message is required';
        else if (message.trim().length < 10) newErrors.message = 'Please provide more details (at least 10 characters)';
        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setTouched({
                topic: true,
                subject: true,
                message: true
            });
            return;
        }
        if (isUploadingFile || screenshots.some((s)=>s.isUploading)) {
            (0, _appAlert.toast).error('Please wait for screenshots to finish uploading.');
            return;
        }
        const trainerUid = currentUser?.uid || (0, _firebase.auth).currentUser?.uid;
        if (!trainerUid) {
            (0, _appAlert.toast).error('You must be signed in to submit a support message.');
            return;
        }
        const payloadAttachments = screenshots.filter((s)=>!s.isUploading && s.storagePath).map((s)=>({
                file_name: s.fileName,
                storage_path: s.storagePath,
                file_size_bytes: s.fileSizeBytes,
                content_type: s.contentType
            }));
        setIsSubmitting(true);
        try {
            const res = await submitTicketAsync({
                topic: topicCode,
                subject: subject.trim(),
                message: message.trim(),
                attachments: payloadAttachments
            });
            const matchedTopic = availableTopics.find((t)=>t.code === topicCode)?.label || topicCode;
            addSupportTicket({
                topic: matchedTopic,
                subject: subject.trim(),
                message: message.trim(),
                screenshots: screenshots.map((s)=>s.previewUrl)
            });
            if (res.reply_email) setSentReplyEmail(res.reply_email);
            // Write message to flutter_chat_messages
            try {
                const supportUid = res.support_uid || supportConfig?.support_uid || 'support';
                const currentTrainerUid = currentUser?.uid || (0, _firebase.auth).currentUser?.uid;
                if (!currentTrainerUid) throw new Error('Trainer is not authenticated. Cannot create support chat conversation.');
                const trainerName = `${currentUser?.name || ''} ${currentUser?.surname || ''}`.trim() || (0, _firebase.auth).currentUser?.displayName || 'Trainer';
                const trainerAvatar = currentUser?.avatarUrl || currentUser?.profile_picture_url || (0, _firebase.auth).currentUser?.photoURL || '';
                const chatId = res.chat_id || `support_${currentTrainerUid}`;
                setCreatedChatId(chatId);
                const parentChatRef = (0, _firestore.doc)((0, _firebase.db), 'flutter_chat_messages', chatId);
                const messageRef = (0, _firestore.doc)((0, _firestore.collection)((0, _firebase.db), 'flutter_chat_messages', chatId, 'messages'));
                // Resolve download URLs for attachments if available
                const chatAttachments = await Promise.all(screenshots.filter((s)=>!s.isUploading && s.storagePath).map(async (s)=>{
                    let downloadUrl = s.previewUrl;
                    try {
                        downloadUrl = await (0, _storage.getDownloadURL)((0, _storage.ref)((0, _firebase.storage), s.storagePath));
                    } catch  {
                    // Fallback to previewUrl if download URL resolution fails
                    }
                    return {
                        file_name: s.fileName,
                        url: downloadUrl,
                        storage_path: s.storagePath,
                        mime_type: s.contentType,
                        size_bytes: s.fileSizeBytes,
                        size_label: `${(s.fileSizeBytes / 1048576).toFixed(1)} MB`,
                        type: s.contentType.startsWith('image/') ? 'image' : 'file'
                    };
                }));
                const newMsgData = {
                    id: messageRef.id,
                    message_type: 'support',
                    send_uid: currentTrainerUid,
                    sender_uid: currentTrainerUid,
                    sender_name: trainerName,
                    sender_avatar: trainerAvatar,
                    sender_role: 'trainer',
                    receive_uid: supportUid,
                    receive_name: 'miniPT Support',
                    receive_avatar: '',
                    receive_role: 'support',
                    subject: subject.trim(),
                    topic: matchedTopic,
                    topic_code: topicCode,
                    message: message.trim(),
                    body: message.trim(),
                    attachments: chatAttachments,
                    send_time: (0, _firestore.serverTimestamp)(),
                    is_read: true,
                    read_time: null,
                    ticket_id: res.ticket_id || '',
                    is_support: true
                };
                await (0, _firestore.setDoc)(messageRef, newMsgData);
                await (0, _firestore.setDoc)(parentChatRef, {
                    id: chatId,
                    created_time: (0, _firestore.serverTimestamp)(),
                    participants: [
                        currentTrainerUid,
                        supportUid
                    ],
                    trainer_ids: [
                        currentTrainerUid
                    ],
                    client_id: supportUid,
                    client_name: 'miniPT Support',
                    is_support: true,
                    type: 'support',
                    is_active: true,
                    last_message: {
                        body: message.trim(),
                        message_type: 'support',
                        send_time: (0, _firestore.serverTimestamp)(),
                        sender_uid: currentTrainerUid,
                        sender_name: trainerName,
                        receive_uid: supportUid,
                        receive_name: 'miniPT Support',
                        subject: subject.trim(),
                        topic: matchedTopic
                    },
                    last_message_time: (0, _firestore.serverTimestamp)(),
                    [`unread_count_${supportUid}`]: (0, _firestore.increment)(1),
                    [`unread_count_${currentTrainerUid}`]: 0
                }, {
                    merge: true
                });
            } catch (chatErr) {
                console.error('Failed to create support chat message:', chatErr);
            }
            setIsSent(true);
        } catch (err) {
            (0, _appAlert.toast).error(err?.message || 'Failed to submit support ticket.');
        } finally{
            setIsSubmitting(false);
        }
    };
    const handleDone = ()=>{
        navigate('/onboarding-trainer/dashboard/subscription/my-subscription');
    };
    const replyEmail = sentReplyEmail || serverProfile?.billingEmail || billingInfo.billingEmail || currentUser?.email || (0, _firebase.auth).currentUser?.email || 'trainer@example.com';
    const selectedTopicLabel = availableTopics.find((t)=>t.code === topicCode)?.label || 'Select a topic';
    const formatSupportHours = (dayObj)=>{
        if (!dayObj || !dayObj.enabled || !dayObj.opens_at || !dayObj.closes_at) return {
            text: 'Closed',
            isClosed: true
        };
        const to12h = (time)=>{
            const [h, m] = time.split(':').map(Number);
            const p = h >= 12 ? 'PM' : 'AM';
            const hr = h % 12 === 0 ? 12 : h % 12;
            return `${hr}:${m < 10 ? '0' : ''}${m} ${p}`;
        };
        return {
            text: `${to12h(dayObj.opens_at)} \u{2013} ${to12h(dayObj.closes_at)}`,
            isClosed: false
        };
    };
    const weekdays = supportConfig?.availability?.weekdays;
    const timezone = supportConfig?.availability?.timezone || 'UTC';
    const availabilityDescription = supportConfig?.availability?.description || 'Our team is available to help you during these hours.';
    const availabilitySchedule = supportConfig?.availability?.schedule;
    const monFriHours = formatSupportHours(weekdays?.monday);
    const satHours = formatSupportHours(weekdays?.saturday);
    const sunHours = formatSupportHours(weekdays?.sunday);
    const fallbackSchedule = [
        {
            days: 'Monday - Friday',
            hours: monFriHours.text,
            is_closed: monFriHours.isClosed
        },
        {
            days: 'Saturday',
            hours: satHours.text,
            is_closed: satHours.isClosed
        },
        {
            days: 'Sunday',
            hours: sunHours.text,
            is_closed: sunHours.isClosed
        }
    ];
    const displayedSchedule = availabilitySchedule && availabilitySchedule.length > 0 ? availabilitySchedule : fallbackSchedule;
    const tipsSubtitle = supportConfig?.tips?.subtitle || 'Include as much detail as possible, such as:';
    const tipsItems = supportConfig?.tips?.items && supportConfig.tips.items.length > 0 ? supportConfig.tips.items : [
        'What you were trying to do',
        'What happened',
        'Any error messages',
        'Steps to reproduce the issue'
    ];
    const emailSubtitle = supportConfig?.contact_methods?.email?.subtitle || 'Prefer email? Reach us directly.';
    const emailReplyNote = supportConfig?.contact_methods?.email?.reply_time_note || 'We typically reply within a few hours.';
    const activeSupportEmail = supportConfig?.contact_methods?.email?.email_address || supportEmail;
    if (isSupportConfigLoading) return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "contact-support-page-container",
        style: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight: '60vh'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
            indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                style: {
                    fontSize: 32,
                    color: '#E2F163'
                },
                spin: true
            })
        })
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: `contact-support-page-container ${isSent ? 'is-sent-mode' : ''}`,
        children: !isSent ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "contact-support-header",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                            type: "button",
                            className: "support-back-btn",
                            onClick: handleBack,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _userChevronLeftSvg.ReactComponent), {}),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                    children: 'Contact Support'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: "support-subtitle",
                            children: "We're here to help. Send us a message and our team will get back to you."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "support-content-grid",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("form", {
                            className: "support-form-card",
                            onSubmit: (e)=>{
                                e.preventDefault();
                                handleSendMessage();
                            },
                            noValidate: true,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                    children: 'Send us a message'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                    className: "form-sub-hint",
                                    children: 'Please provide as much detail as possible so we can help you faster.'
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group topic-select-group",
                                    ref: topicDropdownRef,
                                    style: {
                                        marginBottom: 18
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "support-topic-trigger",
                                            children: 'What can we help you with?'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                                            id: "support-topic-trigger",
                                            type: "button",
                                            className: `custom-select-trigger ${touched.topic && errors.topic ? 'has-error' : ''} ${isTopicDropdownOpen ? 'is-open' : ''} ${topicCode ? 'has-value' : ''}`,
                                            onClick: ()=>setIsTopicDropdownOpen((prev)=>!prev),
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "trigger-text",
                                                    children: selectedTopicLabel
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _dropdownSvg.ReactComponent), {
                                                    className: `dropdown-chevron ${isTopicDropdownOpen ? 'rotate' : ''}`
                                                })
                                            ]
                                        }),
                                        isTopicDropdownOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "custom-dropdown-menu",
                                            children: availableTopics.map((t)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: `custom-dropdown-item ${topicCode === t.code ? 'selected' : ''}`,
                                                    onClick: ()=>{
                                                        setTopicCode(t.code);
                                                        setIsTopicDropdownOpen(false);
                                                        validateField('topic', t.code);
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: t.label
                                                        }),
                                                        topicCode === t.code && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkSvg.ReactComponent), {
                                                            className: "topic-check-icon"
                                                        })
                                                    ]
                                                }, t.code))
                                        }),
                                        touched.topic && errors.topic && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            className: "error-text",
                                            children: errors.topic
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    style: {
                                        marginBottom: 18
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "support-subject",
                                            children: 'Subject*'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                            id: "support-subject",
                                            type: "text",
                                            maxLength: 100,
                                            placeholder: "Briefly describe your issue",
                                            value: subject,
                                            className: touched.subject && errors.subject ? 'has-error' : '',
                                            "aria-required": "true",
                                            "aria-invalid": touched.subject && !!errors.subject,
                                            "aria-describedby": touched.subject && errors.subject ? 'support-subject-error' : undefined,
                                            onChange: (e)=>setSubject(e.target.value),
                                            onBlur: (e)=>{
                                                setSubject(e.target.value.trim());
                                                handleBlur('subject', e.target.value);
                                            }
                                        }),
                                        touched.subject && errors.subject && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            id: "support-subject-error",
                                            className: "error-text",
                                            children: errors.subject
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "form-group",
                                    style: {
                                        marginBottom: 18
                                    },
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            htmlFor: "support-message",
                                            children: 'Message*'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "textarea-container",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("textarea", {
                                                    id: "support-message",
                                                    rows: 6,
                                                    maxLength: 500,
                                                    placeholder: "Please describe the issue...",
                                                    value: message,
                                                    className: touched.message && errors.message ? 'has-error' : '',
                                                    "aria-required": "true",
                                                    "aria-invalid": touched.message && !!errors.message,
                                                    "aria-describedby": touched.message && errors.message ? 'support-message-error' : undefined,
                                                    onChange: (e)=>setMessage(e.target.value),
                                                    onBlur: (e)=>{
                                                        setMessage(e.target.value.trim());
                                                        handleBlur('message', e.target.value);
                                                    }
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                    className: "char-count",
                                                    children: `${message.length}/500`
                                                })
                                            ]
                                        }),
                                        touched.message && errors.message && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                            id: "support-message-error",
                                            className: "error-text",
                                            children: errors.message
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "screenshots-section",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                                            children: 'Add screenshots (optional)'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                            className: "screenshots-hint",
                                            children: 'You can add up to 5 screenshots'
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "screenshots-gallery",
                                            children: [
                                                screenshots.length < 5 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: `upload-drop-tile ${isUploadingFile ? 'disabled' : ''}`,
                                                    onClick: ()=>{
                                                        if (!isUploadingFile) fileInputRef.current?.click();
                                                    },
                                                    role: "button",
                                                    tabIndex: 0,
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _addButtonSvg.ReactComponent), {
                                                        className: "plus-icon-svg"
                                                    })
                                                }),
                                                screenshots.map((s)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                        className: `screenshot-preview-tile ${s.isUploading ? 'is-uploading' : ''}`,
                                                        children: [
                                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                                src: s.previewUrl,
                                                                alt: s.fileName || 'Screenshot'
                                                            }),
                                                            s.isUploading ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                                className: "uploading-overlay",
                                                                children: [
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                                        indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                                            className: "uploading-spinner",
                                                                            spin: true
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                        className: "uploading-text",
                                                                        children: 'Uploading...'
                                                                    })
                                                                ]
                                                            }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                                                type: "button",
                                                                className: "btn-remove-thumb",
                                                                onClick: ()=>handleRemoveScreenshot(s.id),
                                                                title: "Remove screenshot",
                                                                children: "\u2715"
                                                            })
                                                        ]
                                                    }, s.id)),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("input", {
                                                    ref: fileInputRef,
                                                    type: "file",
                                                    accept: "image/png, image/jpeg, image/jpg, image/webp",
                                                    multiple: true,
                                                    disabled: isUploadingFile,
                                                    style: {
                                                        display: 'none'
                                                    },
                                                    onChange: handleFileChange
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                                    type: "submit",
                                    className: "btn-send-message",
                                    disabled: isSubmitting || isSubmittingTicket || isUploadingFile || screenshots.some((s)=>s.isUploading),
                                    children: isSubmitting || isSubmittingTicket ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                    style: {
                                                        fontSize: 16,
                                                        color: '#060723'
                                                    },
                                                    spin: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Sending...'
                                            })
                                        ]
                                    }) : isUploadingFile || screenshots.some((s)=>s.isUploading) ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Spin), {
                                                indicator: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LoadingOutlined), {
                                                    style: {
                                                        fontSize: 16,
                                                        color: '#060723'
                                                    },
                                                    spin: true
                                                })
                                            }),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Uploading...'
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _sendPlaneSvg.ReactComponent), {}),
                                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                children: 'Send Message'
                                            })
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: "support-info-col",
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "info-card availability-card",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "card-header-with-icon",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "card-main-icon",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _supportAvailabilitySvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "card-titles-col",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                            children: 'Support Availability'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "card-sub-hint",
                                                            children: availabilityDescription
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "hours-list",
                                            children: displayedSchedule.map((item, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "hours-row",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "days-label",
                                                            children: item.days
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
                                                            className: `time-val ${item.is_closed ? 'closed' : ''}`,
                                                            children: [
                                                                item.hours,
                                                                ' ',
                                                                !item.is_closed && /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                                    className: "timezone-tag",
                                                                    children: timezone
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }, item.days || idx))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "info-card tips-card",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "card-header-with-icon",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "card-main-icon",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _tipsSupportSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "card-titles-col",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                            children: 'Tips for faster support'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "card-sub-hint",
                                                            children: tipsSubtitle
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: "tips-list",
                                            children: tipsItems.map((tip, idx)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "tip-item",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _checkmarkSvg.ReactComponent), {
                                                            className: "orange-check"
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: tip
                                                        })
                                                    ]
                                                }, idx))
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                    className: "info-card email-card",
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "card-header-with-icon",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                                    className: "card-main-icon",
                                                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _otherWaysSvg.ReactComponent), {})
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "card-titles-col",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                                                            children: 'Other ways to reach us'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                                                            className: "card-sub-hint",
                                                            children: emailSubtitle
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                            className: "email-action-box",
                                            children: [
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                                                    className: "email-meta",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "email-address",
                                                            children: activeSupportEmail
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            className: "reply-time-note",
                                                            children: emailReplyNote
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("a", {
                                                    href: `mailto:${activeSupportEmail}`,
                                                    className: "btn-email-us",
                                                    target: "_blank",
                                                    rel: "noreferrer",
                                                    children: [
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                                                            children: 'Email Us'
                                                        }),
                                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _emailUsSvg.ReactComponent), {})
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            ]
        }) : /* State 2: Message Sent Confirmation */ /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: "support-message-sent-view",
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "sent-icon-wrap",
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _messageSentCheckSvg.ReactComponent), {})
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                    children: 'Message sent!'
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                    className: "sent-subtitle",
                    children: [
                        `Thanks for contacting us about your subscription. Our support team will review your message and reply to `,
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                            children: replyEmail
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "sent-buttons-row",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-view-messages",
                            onClick: ()=>{
                                const trainerUid = currentUser?.uid || (0, _firebase.auth).currentUser?.uid;
                                if (!createdChatId && !trainerUid) {
                                    (0, _appAlert.toast).error('Unable to locate support conversation.');
                                    return;
                                }
                                const chatId = createdChatId || `support_${trainerUid}`;
                                navigate(`/onboarding-trainer/dashboard/messages/${chatId}?tab=inquiries`);
                            },
                            children: 'View in Messages'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            type: "button",
                            className: "btn-done-white",
                            onClick: handleDone,
                            children: 'Done'
                        })
                    ]
                })
            ]
        })
    });
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","src/api/subscription/useSubscriptionApi":"5YJAT","src/store/subscriptionStore":"rMPpj","src/store/sessionStore":"kPSO3","src/config/firebase":"cmjIE","firebase/storage":"9JHfQ","src/api/services/firebaseStorage":"cCllM","firebase/firestore":"5IgBQ","src/assets/images/onboarding-trainer/components/sidebar/user-chevron-left.svg":"bF2mm","src/assets/images/onboarding-trainer/subscription-icons/contact-support/support-availability.svg":"Z6ETs","src/assets/images/onboarding-trainer/subscription-icons/contact-support/tips-support.svg":"7XoJY","src/assets/images/onboarding-trainer/subscription-icons/contact-support/other-ways.svg":"1Fldh","src/assets/images/onboarding-trainer/subscription-icons/contact-support/email-us.svg":"cALvi","src/assets/images/onboarding-trainer/subscription-icons/common/send-plane.svg":"lBpfI","src/assets/images/onboarding-trainer/subscription-icons/checkout/add-button.svg":"6V9WO","src/assets/images/onboarding-trainer/subscription-icons/checkout/checkmark.svg":"9ELfB","src/assets/images/onboarding-trainer/subscription-icons/billing-information/dropdown.svg":"5coyC","src/assets/images/onboarding-trainer/subscription-icons/contact-support/message-sent-check.svg":"4EtxL","src/utils/appAlert":"de4Mq","antd":[["Spin","lVvhl","default"]],"@ant-design/icons":[["LoadingOutlined","8Mvdh","default"]],"./ContactSupport.scss":"ctWA3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"Z6ETs":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSupportAvailability);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSupportAvailability = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 30,
        fill: "none",
        viewBox: "0 0 30 30",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M15 0C6.729 0 0 6.729 0 15v6.215C0 22.75 1.346 24 3 24h1.5A1.5 1.5 0 0 0 6 22.5v-7.714a1.5 1.5 0 0 0-1.5-1.5H3.138C3.972 7.48 8.967 3 15 3s11.028 4.48 11.862 10.286H25.5a1.5 1.5 0 0 0-1.5 1.5V24c0 1.654-1.346 3-3 3h-3v-1.5h-6V30h9c3.309 0 6-2.691 6-6 1.654 0 3-1.25 3-2.785V15c0-8.271-6.729-15-15-15"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7XoJY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgTipsSupport);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgTipsSupport = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 21,
        height: 30,
        fill: "none",
        viewBox: "0 0 21 30",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#E5E5E5",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 3,
            d: "M6.002 28.5h9m-4.5-27a9 9 0 0 0-7.528 13.935c1.43 2.178 2.145 3.267 2.24 3.429.824 1.447.673.938.776 2.601.012.186.012.47.012 1.035a1.5 1.5 0 0 0 1.5 1.5h6a1.5 1.5 0 0 0 1.5-1.5c0-.566 0-.849.012-1.035.105-1.665-.05-1.154.777-2.601.093-.162.81-1.251 2.24-3.43A9 9 0 0 0 10.502 1.5"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"1Fldh":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgOtherWays);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgOtherWays = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 30,
        height: 24,
        fill: "none",
        viewBox: "0 0 30 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            fill: "#E5E5E5",
            d: "M3 24a2.89 2.89 0 0 1-2.118-.88A2.9 2.9 0 0 1 0 21V3Q0 1.762.882.882A2.9 2.9 0 0 1 3 0h24a2.9 2.9 0 0 1 2.12.882Q30 1.764 30 3v18q0 1.238-.88 2.12A2.88 2.88 0 0 1 27 24zM27 6l-11.212 7.012a1.6 1.6 0 0 1-.788.226 1.6 1.6 0 0 1-.787-.226L3 6v15h24zm-12 4.5L27 3H3zM3 6.375V4.162 4.2v-.018z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cALvi":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgEmailUs);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgEmailUs = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 14,
        height: 14,
        fill: "none",
        viewBox: "0 0 14 14",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "#fff",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeOpacity: 0.7,
            strokeWidth: 2,
            d: "M1 13 13 1m0 8V1H5"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lBpfI":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgSendPlane);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgSendPlane = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "currentColor",
        viewBox: "0 0 24 24",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M21.707 2.293a1 1 0 0 0-1.069-.225l-18 7a1 1 0 0 0-.145 1.787l6.638 3.32 3.32 6.638a1 1 0 0 0 1.787-.145l7-18a1 1 0 0 0-.231-1.075z"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5coyC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgDropdown);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgDropdown = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: 10,
        height: 6,
        fill: "none",
        viewBox: "0 0 10 6",
        ...props,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            stroke: "currentColor",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: 2,
            d: "m1 1 4 4 4-4"
        })
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"4EtxL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ReactComponent", ()=>SvgMessageSentCheck);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
const SvgMessageSentCheck = (props)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        width: 64,
        height: 64,
        fill: "none",
        viewBox: "43 31 64 64",
        ...props,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("g", {
                filter: "url(#a)",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        stroke: "url(#b)",
                        strokeWidth: 1.714,
                        d: "M75 33.857c16.095 0 29.143 13.048 29.143 29.143S91.095 92.143 75 92.143 45.857 79.095 45.857 63 58.905 33.857 75 33.857Z",
                        shapeRendering: "crispEdges"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("use", {
                        xlinkHref: "#c",
                        fill: "#04051B",
                        href: "#c"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("use", {
                        xlinkHref: "#c",
                        fill: "url(#d)",
                        href: "#c"
                    })
                ]
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("defs", {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("radialGradient", {
                        id: "d",
                        cx: 0,
                        cy: 0,
                        r: 1,
                        gradientTransform: "matrix(27.8991 -12.6281 2.78295 50.0018 61.294 70.391)",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFEB14"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFA100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("linearGradient", {
                        id: "b",
                        x1: 75,
                        x2: 75,
                        y1: 33,
                        y2: 93,
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                stopColor: "#FFE111"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("stop", {
                                offset: 1,
                                stopColor: "#FFA100"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("filter", {
                        id: "a",
                        width: 150,
                        height: 150,
                        x: 0,
                        y: 0,
                        colorInterpolationFilters: "sRGB",
                        filterUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feFlood", {
                                floodOpacity: 0,
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                in: "SourceAlpha",
                                result: "hardAlpha",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feOffset", {
                                dy: 12
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feGaussianBlur", {
                                stdDeviation: 22.5
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feComposite", {
                                in2: "hardAlpha",
                                operator: "out"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feColorMatrix", {
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in2: "BackgroundImageFix",
                                result: "effect1_dropShadow_17024_14640"
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("feBlend", {
                                in: "SourceGraphic",
                                in2: "effect1_dropShadow_17024_14640",
                                result: "shape"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
                        id: "c",
                        d: "m70.108 69.3 16.95-16.95q.6-.6 1.4-.6t1.4.6.6 1.426-.6 1.424l-18.35 18.4q-.6.6-1.4.6t-1.4-.6l-8.6-8.6q-.6-.6-.576-1.424.024-.825.626-1.426a1.94 1.94 0 0 1 1.426-.6q.824.001 1.424.6z"
                    })
                ]
            })
        ]
    });

},{"react/jsx-runtime":"gonF6","react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"ctWA3":[function() {},{}],"784WL":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "About", ()=>About);
var _jsxRuntime = require("react/jsx-runtime");
var _aboutModuleCss = require("./About.module.css");
var _seo = require("src/components/SEO");
var _seoDefault = parcelHelpers.interopDefault(_seo);
function About() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seoDefault.default), {
                title: "About miniPT",
                description: "Learn more about miniPT's mission to revolutionize personal training and fitness.",
                canonicalUrl: "/about"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: _aboutModuleCss.container,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                    children: "About"
                })
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","./About.module.css":"40in6","src/components/SEO":"9lYJS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"40in6":[function(require,module,exports,__globalThis) {
var _indexCss = require("../../index.css");
module.exports["container"] = `Cnmrjq_container`;
module.exports["deaths"] = `Cnmrjq_deaths`;
module.exports["infected"] = `Cnmrjq_infected`;
module.exports["recovered"] = `Cnmrjq_recovered`;
for(let key in _indexCss)if (key in module.exports) module.exports[key] += ' ' + _indexCss[key];
else module.exports[key] = _indexCss[key];

},{"../../index.css":"fW8RG"}],"fW8RG":[function() {},{}],"5lRtz":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "NotFound", ()=>NotFound);
var _jsxRuntime = require("react/jsx-runtime");
var _notFoundModuleCss = require("./NotFound.module.css");
var _buttonTsx = require("src/components/Button/Button.tsx");
var _backArrowBlackWebp = require("url:../../assets/images/back-arrow-black.webp");
var _backArrowBlackWebpDefault = parcelHelpers.interopDefault(_backArrowBlackWebp);
var _searchIconWebp = require("url:../../assets/images/search-icon.webp");
var _searchIconWebpDefault = parcelHelpers.interopDefault(_searchIconWebp);
var _reactRouterDom = require("react-router-dom");
function NotFound() {
    const navigate = (0, _reactRouterDom.useNavigate)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: _notFoundModuleCss.container,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: _notFoundModuleCss.searchContainer,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                    src: (0, _searchIconWebpDefault.default),
                    className: _notFoundModuleCss.menuLogo,
                    alt: ""
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: _notFoundModuleCss.title,
                children: 'Page not found'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: _notFoundModuleCss.message,
                children: "The page you are looking for doesn't exist.\nHere are some helpful links:"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: _notFoundModuleCss.buttonContainer,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                        iconWidth: 16,
                        className: _notFoundModuleCss.buttonWrapperBack,
                        icon: (0, _backArrowBlackWebpDefault.default),
                        variant: 'light',
                        onClick: ()=>navigate('/'),
                        children: 'Go back'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                        className: _notFoundModuleCss.buttonWrapperHome,
                        variant: 'primary',
                        onClick: ()=>navigate('/'),
                        children: 'Take me home'
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","./NotFound.module.css":"aRyib","src/components/Button/Button.tsx":"g0894","url:../../assets/images/back-arrow-black.webp":"dNiPO","url:../../assets/images/search-icon.webp":"foBqE","react-router-dom":"f3cgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"aRyib":[function(require,module,exports,__globalThis) {
module.exports["buttonContainer"] = `rpphrW_buttonContainer`;
module.exports["buttonWrapperBack"] = `rpphrW_buttonWrapperBack`;
module.exports["buttonWrapperHome"] = `rpphrW_buttonWrapperHome`;
module.exports["container"] = `rpphrW_container`;
module.exports["menuLogo"] = `rpphrW_menuLogo`;
module.exports["message"] = `rpphrW_message`;
module.exports["searchContainer"] = `rpphrW_searchContainer`;
module.exports["title"] = `rpphrW_title`;

},{}],"dNiPO":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("fYmpe");

},{}],"foBqE":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("cJZo8");

},{}],"71pYm":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ServerError", ()=>ServerError);
var _jsxRuntime = require("react/jsx-runtime");
function ServerError() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            padding: 40,
            textAlign: 'center'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "500"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Something went wrong."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Please try again later."
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2BMbt":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Unauthorized", ()=>Unauthorized);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
function Unauthorized() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            padding: 40,
            textAlign: 'center'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h1", {
                children: "401"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "You are not authorized to view this page."
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Link), {
                to: "/login",
                children: "Login"
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","react-router-dom":"f3cgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"eZRIx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Loading", ()=>Loading);
var _jsxRuntime = require("react/jsx-runtime");
function Loading() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        style: {
            padding: 40,
            textAlign: 'center'
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
            children: "Loading..."
        })
    });
}

},{"react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"bvYRr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Maintenance", ()=>Maintenance);
var _jsxRuntime = require("react/jsx-runtime");
function Maintenance() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            padding: 40,
            textAlign: 'center'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "We\u2019re updating the system\u2026"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "Service will resume shortly."
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"lhYyx":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "ComingSoon", ()=>ComingSoon);
var _jsxRuntime = require("react/jsx-runtime");
function ComingSoon() {
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            padding: 40,
            textAlign: 'center'
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: "Coming Soon"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: "This page is under development."
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6wOPq":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AccountStatus", ()=>AccountStatus);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
function AccountStatus() {
    const location = (0, _reactRouterDom.useLocation)();
    const { title, message, email } = location.state || {};
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            padding: 20
        },
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("h2", {
                children: title || 'Account'
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                children: message || 'No message available.'
            }),
            email && /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                children: [
                    "Support Email: ",
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                        children: email
                    })
                ]
            })
        ]
    });
}

},{"react/jsx-runtime":"gonF6","react-router-dom":"f3cgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"GoYTU":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "PrivacyPolicy", ()=>PrivacyPolicy);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _privacyPolicyModuleCss = require("./PrivacyPolicy.module.css");
var _backIconBlackWebp = require("url:../../assets/images/back-icon-black.webp");
var _backIconBlackWebpDefault = parcelHelpers.interopDefault(_backIconBlackWebp);
var _seo = require("src/components/SEO");
var _seoDefault = parcelHelpers.interopDefault(_seo);
const PrivacyPolicy = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    (0, _react.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seoDefault.default), {
                title: "Privacy Policy - miniPT",
                description: "Read the miniPT privacy policy to understand how we protect and manage your data.",
                canonicalUrl: "/privacy-policy"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: _privacyPolicyModuleCss.page,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: _privacyPolicyModuleCss.backButton,
                        onClick: ()=>navigate(-1),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _backIconBlackWebpDefault.default),
                                alt: "Back",
                                className: _privacyPolicyModuleCss.backIcon
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: _privacyPolicyModuleCss.backButtonText,
                                children: "Back"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: _privacyPolicyModuleCss.title,
                        children: "MiniPT Privacy Policy"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: _privacyPolicyModuleCss.date,
                        children: "Effective Date: January 16, 2026"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: 'At MiniPT, we are committed to protecting your privacy and providing a safe and secure experience for all our users. This Privacy Policy sets out how we collect, use, and share your personal data when you use our mobile application (the "App") and any other related services provided by MiniPT. This Privacy Policy applies to all users of the App.'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Data Controller"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "MiniPT is the data controller of your personal data under applicable data protection laws, including the General Data Protection Regulation (GDPR) and the Data Protection Act 2018."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "What Information We Collect"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "2.1 We may collect personal data, such as your name, email address, location data, fitness and health-related information, and other information provided by you through text fields, your interaction with the MiniPT chatbot (MPTChat) messaging system, and other data, to provide our services and improve the App's functionality."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "2.2 We may also collect non-personal data, such as your IP address, browser type, and device information, to analyze App usage and improve our services."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "How We Use Your Information"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "3.1 We use your personal data to provide our services, including to:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Facilitate communication between you and our team."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Customize and personalize your experience with our App."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Monitor the use of the App to improve and develop our services."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "3.2 We use your non-personal data to:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Improve the performance and functionality of the App."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Analyze usage patterns and trends to improve our services."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Legal Basis for Processing Your Data"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "4.1 We process your personal data based on one or more of the following legal bases:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Performance of a contract: We need to process your personal data to fulfill our contractual obligations to you."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Consent: We may process your personal data with your consent."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Legitimate interests: We may process your personal data for our legitimate interests in improving our services and enhancing your user experience."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Who We Share Your Information With"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "5.1 We may share your personal data with:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Our affiliates, partners, or service providers who help us to provide and improve our services."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "Law enforcement agencies, regulatory authorities, or other authorized third parties in response to a subpoena, court order, or other legal process."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Data Security and Retention"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "6.1 We take appropriate technical and organizational measures to protect your personal data against unauthorized or unlawful processing and against accidental loss, destruction, or damage."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "6.2 We retain your personal data for as long as necessary to fulfill the purposes for which it was collected, including for the purposes of satisfying any legal, accounting, or reporting requirements."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Your Rights"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "7.1 You have the following rights with respect to your personal data:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "The right to access your personal data and to receive a copy of your personal data."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "The right to rectify any inaccurate or incomplete personal data."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "The right to erase your personal data, subject to certain limitations."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "The right to restrict the processing of your personal data."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "The right to data portability, which allows you to receive your personal data in a structured, commonly used, and machine-readable format and to transmit it to another controller."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "The right to object to the processing of your personal data."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            "7.2 You can exercise your rights by contacting us at",
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "mailto:Samuel@minipt.co.uk",
                                children: "Samuel@minipt.co.uk"
                            }),
                            ". We will respond to your request as soon as possible and in any event within one month of receiving your request."
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "Changes to This Policy"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "8.1 We may update this Privacy Policy from time to time. If we make material changes to this Privacy Policy, we will notify you by email or by posting a notice on the App. Your continued use of the App after the effective date of any changes to this Privacy Policy constitutes your acceptance of the revised Privacy Policy."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "9. Contact Us"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            "9.1 If you have any questions or concerns about this Privacy Policy or the App, please get in touch with MiniPT at ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "mailto:samuel@minipt.co.uk",
                                children: "samuel@minipt.co.uk"
                            }),
                            "."
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "10. Supervisory Authority"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "10.1 You have the right to lodge a complaint with a supervisory authority, such as the Information Commissioner's Office (ICO) in the UK or your local data protection authority in the EU."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "11. GDPR Data Protection Officer (DPO)"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "11.1 We have appointed a Data Protection Officer (DPO) to oversee our data protection practices. You can contact our DPO at samuel@minipt.co.uk."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "By using the MiniPT App and related services, you consent to our collection and use of your personal data in accordance with this Privacy Policy. You must not use the MiniPT App and related services if you do not agree to this Privacy Policy."
                    })
                ]
            })
        ]
    });
};
exports.default = PrivacyPolicy;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./PrivacyPolicy.module.css":"5nl5g","url:../../assets/images/back-icon-black.webp":"lo3NX","src/components/SEO":"9lYJS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"5nl5g":[function(require,module,exports,__globalThis) {
module.exports["backButton"] = `mONMnq_backButton`;
module.exports["backButtonText"] = `mONMnq_backButtonText`;
module.exports["backIcon"] = `mONMnq_backIcon`;
module.exports["date"] = `mONMnq_date`;
module.exports["page"] = `mONMnq_page`;
module.exports["subtitle"] = `mONMnq_subtitle`;
module.exports["title"] = `mONMnq_title`;
module.exports["wrapper"] = `mONMnq_wrapper`;

},{}],"lo3NX":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("5siFF");

},{}],"kQN6n":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "TermsOfService", ()=>TermsOfService);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _termsOfServiceModuleCss = require("./TermsOfService.module.css");
var _backIconBlackWebp = require("url:../../assets/images/back-icon-black.webp");
var _backIconBlackWebpDefault = parcelHelpers.interopDefault(_backIconBlackWebp);
var _seo = require("src/components/SEO");
var _seoDefault = parcelHelpers.interopDefault(_seo);
const TermsOfService = ()=>{
    const navigate = (0, _reactRouterDom.useNavigate)();
    (0, _react.useEffect)(()=>{
        window.scrollTo(0, 0);
    }, []);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _seoDefault.default), {
                title: "Terms of Service - miniPT",
                description: "miniPT terms of service and usage conditions.",
                canonicalUrl: "/terms-of-service"
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: _termsOfServiceModuleCss.page,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("button", {
                        className: _termsOfServiceModuleCss.backButton,
                        onClick: ()=>navigate(-1),
                        children: [
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                src: (0, _backIconBlackWebpDefault.default),
                                alt: "Back",
                                className: _termsOfServiceModuleCss.backIcon
                            }),
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                className: _termsOfServiceModuleCss.backButtonText,
                                children: "Back"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        className: _termsOfServiceModuleCss.title,
                        children: "MiniPT Terms of Service"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: _termsOfServiceModuleCss.date,
                        children: "Effective Date: January 16, 2026"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "1. Introduction"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: '1.1 MiniPT is a fitness company that provides a mobile application (the "App") to allowing them to access a range of fitness and health-related services.'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: '1.2 These terms and conditions (the "Terms") govern your use of the App and any related services provided by MiniPT. By accessing or using the App, you agree to be bound by these Terms. If you do not agree with these Terms, you must not use the App.'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "2. Data Collection"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "2.1 MiniPT may collect and use your personal data, which is defined as any information that can be used to identify you as an individual. This includes, but is not limited to:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            "- Your name, age, gender, and contact details (e.g. email address, phone number)",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            "- Your fitness and health-related data, such as your weight, height, body mass index (BMI), exercise routines, and nutrition plans",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            "- Your location data, if you choose to enable location services on the App",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                            "- Information provided by you through text fields, your interaction with the MiniPT chatbot (MPTChat) messaging system, and other data."
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "3. Data Collection"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "3.1 MiniPT may collect and use your personal data, such as information provided by you through text fields, your interaction with the MiniPT chatbot (MPTChat) messaging system, your location data and other data, in accordance with MiniPT's Privacy Policy, which is available on the App and on the MiniPT website."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "3.2 You agree to provide MiniPT with accurate, complete and up-to-date information and to keep such information updated."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "4. Intellectual Property"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "4.1 All intellectual property rights in the App and related services, including but not limited to copyrights, trademarks, patents and trade secrets, are owned by MiniPT or its licensors. You may not use any MiniPT content for commercial purposes or for any other unauthorized purpose."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "5. Disclaimer of Warranties"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: '5.1 MiniPT provides the App and related services on an "as is" and "as available" basis and makes no representations or warranties of any kind, express or implied, as to the operation of the App or the information, content, materials, or products included on the App.'
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "5.2 MiniPT does not warrant that the App will be uninterrupted or error-free, and MiniPT will not be liable for any interruptions or errors."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "6. Limitation of Liability"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "6.1 In no event will MiniPT be liable for any damages, including but not limited to indirect, incidental, special, punitive or consequential damages, arising out of the use of or inability to use the App or any information, content, materials, products or services available through the App, even if MiniPT has been advised of the possibility of such damages."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "7. Indemnification"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "7.1 You agree to indemnify and hold MiniPT, its affiliates, officers, agents, and employees harmless from any claim or demand, including reasonable attorney's fees, made by any party due to or arising out of your use of the App or violation of these Terms."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "8. Termination"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "8.1 MiniPT may, in its sole discretion, at any time terminate or suspend all or a portion of the App or your use of all or a portion of the App, with or without notice and with or without cause."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "9. Governing Law"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "9.1 These Terms shall be governed by and construed in accordance with the laws of England and Wales, without giving effect to any principles of conflicts of law."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "10. General"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "10.1 These Terms constitute the entire agreement between you and MiniPT with respect to the use of the App and supersede all prior agreements and understandings between you and MiniPT, whether written or oral, relating to the use of the App."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "10.2 If any provision of these Terms is found to be invalid or unenforceable, such provision shall be severed from these Terms, and the remaining provisions shall remain in full force and effect."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "11. Contact"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)("p", {
                        children: [
                            "11.1 If you have any questions or concerns about these Terms or the App, please contact MiniPT at ",
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                                href: "mailto:Samuel@minipt.co.uk",
                                children: "Samuel@minipt.co.uk"
                            }),
                            ",",
                            ' ',
                            /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                                children: "Onega House, 112 Main Road, Sidcup, Kent, DA14 6NE, UK, 07393207131."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "12. Changes to Terms"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "12.1 MiniPT may make changes to these Terms from time to time. The updated version of these Terms will be posted on the App and/or the MiniPT website. Your continued use of the App after such changes constitutes your acceptance of the new Terms."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "13. Assignment"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "13.1 You may not assign these Terms or transfer any rights to use the App without the prior written consent of MiniPT. MiniPT may assign these Terms or transfer any rights to use the App without your prior written consent."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "14. Third-Party Services"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "14.1 The App may contain links to third-party websites or services that are not owned or controlled by MiniPT. MiniPT has no control over and assumes no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You acknowledge and agree that MiniPT shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such websites or services."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "15. User Conduct"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "15.1 You agree to use the App in accordance with all applicable laws and regulations and in a manner that does not violate the rights of MiniPT or any third party. You may not use the App to engage in any illegal or unauthorized activity, including but not limited to:"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "a. uploading, posting, or transmitting any content that is illegal, obscene, defamatory, threatening, harassing, hateful, or offensive;"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "b. impersonating any person or entity or falsely stating or otherwise misrepresenting your affiliation with a person or entity;"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "c. accessing or attempting to access the App by any means other than through the interface provided by MiniPT;"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "d. attempting to interfere with, compromise the system integrity or security, or decipher any transmissions to or from the servers running the App;"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "e. taking any action that imposes, or may impose, at MiniPT's sole discretion, an unreasonable or disproportionately large load on MiniPT's infrastructure;"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "f. uploading invalid data, viruses, worms, or other software agents through the App;"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "g. collecting or harvesting any personally identifiable information, including account names, from the App;"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "h. using the App for any commercial solicitation purposes."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "16. Dispute Resolution"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "16.1 If a dispute arises between you and MiniPT, you agree first to contact MiniPT and attempt to resolve the dispute informally. If the dispute cannot be resolved informally, the parties agree to resolve the dispute through binding arbitration in accordance with the rules of the American Arbitration Association."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "17. Agreement to Electronic Communication"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "17.1 By using the App, you consent to receive electronic communications from MiniPT. These communications may include notices about your account and information and updates concerning the App and related services."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h3", {
                        children: "18. No Waiver"
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "18.1 MiniPT's failure to enforce any right or provision in these Terms shall not constitute a waiver of such right or provision unless acknowledged and agreed to by MiniPT in writing."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "These Terms and Conditions of Use represent the entire understanding between you and MiniPT regarding the use of the MiniPT App and related services and supersedes all prior agreements and understandings, whether written or oral, relating to the use of the MiniPT App and related services."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: "By using the MiniPT App and related services, you agree to be bound by these Terms and Conditions. If you do not agree to these Terms and Conditions, you must not use the MiniPT App and related services."
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "https://www.notion.so/Whoop-1e773cfa3b044ef6ab88f4b006ba1697?pvs=21",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Whoop"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("a", {
                            href: "https://www.notion.so/Pelaton-dddda32025e341b889d8d2e6201b4b18?pvs=21",
                            target: "_blank",
                            rel: "noopener noreferrer",
                            children: "Pelaton"
                        })
                    })
                ]
            })
        ]
    });
};
exports.default = TermsOfService;

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"f3cgC","./TermsOfService.module.css":"71MBs","url:../../assets/images/back-icon-black.webp":"lo3NX","src/components/SEO":"9lYJS","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"71MBs":[function(require,module,exports,__globalThis) {
module.exports["backButton"] = `T2OvPW_backButton`;
module.exports["backButtonText"] = `T2OvPW_backButtonText`;
module.exports["backIcon"] = `T2OvPW_backIcon`;
module.exports["date"] = `T2OvPW_date`;
module.exports["page"] = `T2OvPW_page`;
module.exports["subtitle"] = `T2OvPW_subtitle`;
module.exports["title"] = `T2OvPW_title`;
module.exports["wrapper"] = `T2OvPW_wrapper`;

},{}],"5Jgx8":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _reactRouterDom = require("react-router-dom");
var _react = require("react");
var _utilityLayoutModuleCss = require("./UtilityLayout.module.css");
var _uiStoreTs = require("src/store/uiStore.ts");
var _useScrollSmoother = require("src/hooks/useScrollSmoother");
// Hook
var _useRouteClass = require("src/hooks/useRouteClass");
var _useRouteClassDefault = parcelHelpers.interopDefault(_useRouteClass);
var _constantsTs = require("src/config/constants.ts");
const FloatingHeader = /*#__PURE__*/ (0, _react.lazy)(()=>require("bb5f888ef478937"));
const MainFooter = /*#__PURE__*/ (0, _react.lazy)(()=>require("4408fa348b2a1bec"));
const CallToActionBanner = /*#__PURE__*/ (0, _react.lazy)(()=>require("4636a85f9c59f3ae"));
const MiniPTFooterPromo = /*#__PURE__*/ (0, _react.lazy)(()=>require("accb680ca640403"));
const ConsentBanner = /*#__PURE__*/ (0, _react.lazy)(()=>require("d4778c74762f2442"));
const UtilityLayout = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    // Disable smooth scrolling only on the /trainer route
    // but keep it enabled for /onboarding-trainer
    const isTrainerRoute = location.pathname === '/trainer' || location.pathname.startsWith('/trainer/') || location.pathname === '/onboarding-trainer' || location.pathname.startsWith('/onboarding-trainer/');
    (0, _useScrollSmoother.useScrollSmoother)({
        contentClass: 'smootherContent',
        enabled: !isTrainerRoute
    });
    const setWaitlistModalVisible = (0, _uiStoreTs.uiStore)((s)=>s.setWaitlistModalVisible);
    const setQuizModalVisible = (0, _uiStoreTs.uiStore)((s)=>s.setQuizModalVisible);
    const setWaitlistEmail = (0, _uiStoreTs.uiStore)((s)=>s.setWaitlistEmail);
    (0, _useRouteClassDefault.default)();
    // Hide header and footers on specific standalone pages
    const isAuthPage = location.pathname.includes('/login') || location.pathname.includes('/signup') || location.pathname.includes('/dashboard') || location.pathname.includes('/forgot-password') || location.pathname.includes('/reset-password');
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            !isAuthPage && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(FloatingHeader, {})
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: "smooth-wrapper",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: "smootherContent",
                    id: "smooth-content",
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {}),
                        !isAuthPage && /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _react.Suspense), {
                            fallback: null,
                            children: [
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(CallToActionBanner, {
                                    className: _utilityLayoutModuleCss.callToAction,
                                    onPressJoinTheWaitlist: (email)=>{
                                        setWaitlistEmail(email || null);
                                        setWaitlistModalVisible(true);
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(MiniPTFooterPromo, {
                                    className: _utilityLayoutModuleCss.promotionCard,
                                    onPressTakeFreeQuiz: ()=>{
                                        setQuizModalVisible(true);
                                    }
                                }),
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)(MainFooter, {
                                    onPressTakeFreeQuiz: ()=>{
                                        setQuizModalVisible(true);
                                    }
                                })
                            ]
                        })
                    ]
                })
            }),
            (0, _constantsTs.REQUIRE_ANALYTICS_CONSENT) && /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _react.Suspense), {
                fallback: null,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(ConsentBanner, {})
            })
        ]
    });
};
exports.default = UtilityLayout;

},{"react/jsx-runtime":"gonF6","react-router-dom":[["Outlet","9oT3O"],["useLocation","f3cgC"]],"react":"bmhQu","bb5f888ef478937":"l3JtD","4408fa348b2a1bec":"jHE3o","4636a85f9c59f3ae":"6uK6h","accb680ca640403":"6wgH0","d4778c74762f2442":"foAvd","./UtilityLayout.module.css":"iZ4R7","src/store/uiStore.ts":"hxErL","src/hooks/useScrollSmoother":"86R0y","src/hooks/useRouteClass":"2Y6Px","src/config/constants.ts":"uHGJK","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"l3JtD":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("426ae215de6e1b75")(import.meta.resolve("iwago")),
    import("gsR9B")
]).then(()=>module.bundle.root('bzENz'));

},{"426ae215de6e1b75":"deFMk"}],"jHE3o":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("5a7152e79c1fb7bd")(import.meta.resolve("jsCgV")),
    import("e308a")
]).then(()=>module.bundle.root('jhNzv'));

},{"5a7152e79c1fb7bd":"deFMk"}],"6uK6h":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("475686b4e84027cf")(import.meta.resolve("3BnpR")),
    import("2K3Wl")
]).then(()=>module.bundle.root('ktHZ3'));

},{"475686b4e84027cf":"deFMk"}],"6wgH0":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("969a2cff9fb353d8")(import.meta.resolve("f1AF3")),
    import("jEiBi")
]).then(()=>module.bundle.root('aP0H6'));

},{"969a2cff9fb353d8":"deFMk"}],"foAvd":[function(require,module,exports,__globalThis) {
module.exports = Promise.all([
    require("5d8c63f3f33c4319")(import.meta.resolve("h3ii2")),
    import("9FFWE")
]).then(()=>module.bundle.root('4Rs01'));

},{"5d8c63f3f33c4319":"deFMk"}],"iZ4R7":[function(require,module,exports,__globalThis) {
module.exports["callToAction"] = `Khrawa_callToAction`;
module.exports["promotionCard"] = `Khrawa_promotionCard`;

},{}],"86R0y":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScrollSmoother", ()=>useScrollSmoother);
var _react = require("react");
var _gsapSetup = require("src/utils/gsapSetup");
var _gsapSetupDefault = parcelHelpers.interopDefault(_gsapSetup);
var _scrollSmoother = require("gsap/ScrollSmoother");
function useScrollSmoother({ contentClass, smooth = 4, smoothTouch = 0.5, normalizeScroll = true, ignoreMobileResize = true, effects = true, enabled = true }) {
    (0, _react.useEffect)(()=>{
        const smoother = (0, _scrollSmoother.ScrollSmoother).get();
        // ❌ DISABLED CASE → kill existing smoother
        if (!enabled) {
            if (smoother) smoother.kill();
            return;
        }
        if (!smoother) {
            const ctx = (0, _gsapSetupDefault.default).context(()=>{
                (0, _scrollSmoother.ScrollSmoother).create({
                    wrapper: '#smooth-wrapper',
                    content: `.${contentClass}`,
                    smooth,
                    smoothTouch,
                    normalizeScroll,
                    ignoreMobileResize,
                    effects
                });
            });
            return ()=>{
                ctx.revert();
            };
        }
    }, [
        contentClass,
        smooth,
        smoothTouch,
        normalizeScroll,
        ignoreMobileResize,
        effects,
        enabled
    ]);
}

},{"react":"bmhQu","src/utils/gsapSetup":"8koI4","gsap/ScrollSmoother":"4XNUc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"2Y6Px":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
const useRouteClass = ()=>{
    const location = (0, _reactRouterDom.useLocation)();
    (0, _react.useEffect)(()=>{
        const html = document.documentElement; // <html> element
        // Convert path to class-friendly string
        const path = location.pathname.replace(/^\//, '') // remove leading slash
        .replace(/\//g, '-') || // replace nested routes with dash
        'home';
        const className = `page-${path}`;
        // Remove old route classes
        html.classList.forEach((cls)=>{
            if (cls.startsWith('page-')) html.classList.remove(cls);
        });
        // Add new class
        html.classList.add(className);
        // Cleanup
        return ()=>{
            html.classList.remove(className);
        };
    }, [
        location.pathname
    ]);
};
exports.default = useRouteClass;

},{"react":"bmhQu","react-router-dom":"f3cgC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"f08Ie":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>ScrollToTop);
var _react = require("react");
var _reactRouterDom = require("react-router-dom");
var _gsapSetupTs = require("src/utils/gsapSetup.ts");
var _gsapSetupTsDefault = parcelHelpers.interopDefault(_gsapSetupTs);
function ScrollToTop() {
    const { pathname } = (0, _reactRouterDom.useLocation)();
    (0, _react.useEffect)(()=>{
        (0, _gsapSetupTsDefault.default).to(window, {
            scrollTo: {
                y: 0,
                autoKill: true
            },
            duration: 0.1,
            ease: 'power2.out'
        });
    }, [
        pathname
    ]);
    return null;
}

},{"react":"bmhQu","react-router-dom":"f3cgC","src/utils/gsapSetup.ts":"8koI4","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"6jk7r":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _auth = require("firebase/auth");
var _firebase = require("src/config/firebase");
var _sessionStore = require("src/store/sessionStore");
var _trainerPresence = require("src/services/presence/trainerPresence");
var _waitlistModalTsx = require("src/components/Modals/WaitlistModal/WaitlistModal.tsx");
var _waitlistModalTsxDefault = parcelHelpers.interopDefault(_waitlistModalTsx);
var _quizModalTsx = require("src/components/Modals/QuizModal/QuizModal.tsx");
var _quizModalTsxDefault = parcelHelpers.interopDefault(_quizModalTsx);
var _videoOverlayTsx = require("src/components/VideoOverlay/VideoOverlay.tsx");
var _videoOverlayTsxDefault = parcelHelpers.interopDefault(_videoOverlayTsx);
var _reactHotToast = require("react-hot-toast");
var _reactHotToastDefault = parcelHelpers.interopDefault(_reactHotToast);
var _registerPush = require("src/services/push/registerPush");
var _uiStoreTs = require("src/store/uiStore.ts");
var _useBodyScrollLockTs = require("src/hooks/useBodyScrollLock.ts");
const AppManager = ({ children })=>{
    (0, _react.useEffect)(()=>{
        return (0, _auth.onIdTokenChanged)((0, _firebase.auth), async (user)=>{
            if (!user) // Firebase says user is logged out
            (0, _sessionStore.sessionStore).getState().logout();
            else try {
                // Keep the ID token fresh in Zustand store even when reopening the browser next day
                const freshToken = await user.getIdToken();
                const currentStore = (0, _sessionStore.sessionStore).getState();
                if (currentStore.token !== freshToken || !currentStore.isLoggedIn) currentStore.setToken(freshToken, currentStore.currentUser || undefined);
                (0, _registerPush.printCurrentFCMToken)();
            } catch (err) {
                console.warn('Failed to refresh Firebase token:', err);
            }
        });
    }, []);
    // Automatic presence tracking for trainer (is_online, last_seen)
    (0, _react.useEffect)(()=>{
        let presenceCleanup = null;
        const unsubscribe = (0, _auth.onIdTokenChanged)((0, _firebase.auth), (user)=>{
            if (presenceCleanup) {
                presenceCleanup();
                presenceCleanup = null;
            }
            if (user && user.uid) presenceCleanup = (0, _trainerPresence.initializeTrainerPresence)(user.uid);
        });
        return ()=>{
            if (presenceCleanup) presenceCleanup();
            unsubscribe();
        };
    }, []);
    // Foreground FCM Push Notification listener
    (0, _react.useEffect)(()=>{
        return (0, _registerPush.onForegroundFCMMessage)((payload)=>{
            const title = payload.notification?.title || payload.data?.title || 'miniPT';
            let body = payload.notification?.body || payload.data?.body || 'You received a new message.';
            let clickUrl = '/onboarding-trainer/dashboard/messages';
            if (payload.data?.content) try {
                const content = typeof payload.data.content === 'string' ? JSON.parse(payload.data.content) : payload.data.content;
                if (content.body) body = content.body;
                if (content.chat_id) {
                    clickUrl = `/onboarding-trainer/dashboard/messages/${content.chat_id}`;
                    if (content.message_type === 'inquiry' && content.message_id) clickUrl += `?inquiryId=${content.message_id}`;
                }
                if (content.message_type === 'checkin' && content.checkin_id) clickUrl = `/onboarding-trainer/dashboard/messages/checkin/${content.checkin_id}`;
                if (content.click_url) clickUrl = content.click_url;
            } catch  {
            // Ignored
            }
            else if (payload.data?.click_url) clickUrl = payload.data.click_url;
            (0, _reactHotToastDefault.default)((t)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    style: {
                        cursor: 'pointer',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '2px'
                    },
                    onClick: ()=>{
                        (0, _reactHotToastDefault.default).dismiss(t.id);
                        if (typeof window !== 'undefined') window.dispatchEvent(new CustomEvent('app:navigate', {
                            detail: clickUrl
                        }));
                    },
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                            style: {
                                color: '#fff',
                                fontSize: '13px'
                            },
                            children: title
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("span", {
                            style: {
                                color: '#F59E0B',
                                fontSize: '12px'
                            },
                            children: body
                        })
                    ]
                }), {
                icon: "\uD83D\uDCAC",
                duration: 6000,
                style: {
                    background: '#1A1A1A',
                    border: '1px solid #333333',
                    color: '#FFFFFF',
                    borderRadius: '8px'
                }
            });
        });
    }, []);
    //Waitlist model
    const waitlistModalVisible = (0, _uiStoreTs.uiStore)((s)=>s.waitlistModalVisible);
    const setWaitlistModalVisible = (0, _uiStoreTs.uiStore)((s)=>s.setWaitlistModalVisible);
    const waitlistEmail = (0, _uiStoreTs.uiStore)((s)=>s.waitlistEmail);
    const quizModalVisible = (0, _uiStoreTs.uiStore)((s)=>s.quizModalVisible);
    const setQuizModalVisible = (0, _uiStoreTs.uiStore)((s)=>s.setQuizModalVisible);
    //Video player link
    const hideVideoPlayerVisible = (0, _uiStoreTs.uiStore)((s)=>s.hideVideoPlayerVisible);
    const videoPlayerLink = (0, _uiStoreTs.uiStore)((s)=>s.videoPlayerLink);
    const videoPlayerVisible = (0, _uiStoreTs.uiStore)((s)=>s.videoPlayerVisible);
    (0, _useBodyScrollLockTs.useScrollSmootherLock)(waitlistModalVisible);
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)((0, _jsxRuntime.Fragment), {
        children: [
            children,
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _waitlistModalTsxDefault.default), {
                visible: waitlistModalVisible,
                onClose: ()=>setWaitlistModalVisible(false),
                initialEmail: waitlistEmail
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _quizModalTsxDefault.default), {
                visible: quizModalVisible,
                onClose: ()=>setQuizModalVisible(false)
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _videoOverlayTsxDefault.default), {
                video: videoPlayerLink,
                open: videoPlayerVisible,
                onClose: ()=>hideVideoPlayerVisible()
            })
        ]
    });
};
exports.default = /*#__PURE__*/ (0, _react.memo)(AppManager);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","firebase/auth":"dZ6yw","src/config/firebase":"cmjIE","src/store/sessionStore":"kPSO3","src/services/presence/trainerPresence":"8wUar","src/components/Modals/WaitlistModal/WaitlistModal.tsx":"cb8ib","src/components/Modals/QuizModal/QuizModal.tsx":"1FtrY","src/components/VideoOverlay/VideoOverlay.tsx":"bgg1I","react-hot-toast":"3T0Wh","src/services/push/registerPush":"xSUJJ","src/store/uiStore.ts":"hxErL","src/hooks/useBodyScrollLock.ts":"1yO46","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"cb8ib":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _waitlistModalModuleCss = require("./WaitlistModal.module.css");
var _commandDialog = require("../CommandDialog/CommandDialog");
var _commandDialogDefault = parcelHelpers.interopDefault(_commandDialog);
var _useJoinWaitlistTs = require("src/api/mutations/useJoinWaitlist.ts");
const WaitlistModal = ({ visible, onClose, initialEmail })=>{
    const [email, setEmail] = (0, _react.useState)('');
    const [userType, setUserType] = (0, _react.useState)(undefined);
    const [success, setSuccess] = (0, _react.useState)(false);
    const [fieldErrors, setFieldErrors] = (0, _react.useState)({});
    const { mutate: joinWaitlist, isPending } = (0, _useJoinWaitlistTs.useJoinWaitlist)();
    (0, _react.useEffect)(()=>{
        if (visible) {
            setEmail(initialEmail || '');
            setUserType(undefined);
            setSuccess(false);
            setFieldErrors({});
        }
    }, [
        visible,
        initialEmail
    ]);
    const handleSubmit = ()=>{
        if (!email || !userType) return;
        setFieldErrors({});
        joinWaitlist({
            email,
            type: userType
        }, {
            onSuccess: ()=>{
                setSuccess(true);
            },
            onError: (err)=>{
                const axiosErr = err;
                const apiError = axiosErr.response?.data?.error;
                if (!apiError) {
                    setFieldErrors({
                        general: 'Something went wrong. Please try again.'
                    });
                    return;
                }
                if (apiError.field === 'email') setFieldErrors({
                    email: apiError.message
                });
                else if (apiError.field === 'type') setFieldErrors({
                    type: apiError.message
                });
                else setFieldErrors({
                    general: apiError.message
                });
            }
        });
    };
    const radioOptions = [
        {
            value: 'mover',
            label: "I'm a mover",
            description: 'I want to train with miniPT'
        },
        {
            value: 'trainer',
            label: "I'm a trainer",
            description: 'I want to coach with miniPT'
        }
    ];
    const RadioCard = ({ value, label, description })=>/*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
            className: `${_waitlistModalModuleCss.radioCard} ${userType === value ? _waitlistModalModuleCss.selected : ''}`,
            onClick: ()=>setUserType(value),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Radio), {
                className: _waitlistModalModuleCss.radioCustom,
                checked: userType === value,
                value: value,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: _waitlistModalModuleCss.radioContent,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: _waitlistModalModuleCss.radioLabel,
                            children: label
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: _waitlistModalModuleCss.radioDescription,
                            children: description
                        })
                    ]
                })
            })
        });
    if (success) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _commandDialogDefault.default), {
        visible: visible,
        onClose: onClose,
        type: "success",
        title: "You're on the list!",
        description: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("span", {
            children: [
                "We've added ",
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("strong", {
                    children: email
                }),
                " to our waitlist."
            ]
        }),
        confirmText: "Done"
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: visible,
        onCancel: onClose,
        footer: null,
        closeIcon: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CloseOutlined), {
            style: {
                fontSize: '20px'
            }
        }),
        className: _waitlistModalModuleCss.waitlistModalContainer,
        styles: {
            body: {
                padding: '0px',
                boxShadow: 'none'
            }
        },
        width: '26.563rem',
        centered: true,
        rootClassName: "edit-waitlist",
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            className: _waitlistModalModuleCss.waitlistModalContent,
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: _waitlistModalModuleCss.modalTitle,
                            children: 'Join the waitlist'
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                            className: _waitlistModalModuleCss.modalSubtitle,
                            children: "Be the first to know when miniPT is ready for you."
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("label", {
                            className: _waitlistModalModuleCss.inputLabel,
                            htmlFor: "email-input",
                            children: "Email"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Input), {
                            id: "email-input",
                            placeholder: "Enter your email",
                            value: email,
                            onChange: (e)=>setEmail(e.target.value),
                            status: fieldErrors.email ? 'error' : undefined
                        }),
                        fieldErrors.email && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            style: {
                                color: 'red',
                                marginTop: 4
                            },
                            children: fieldErrors.email
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Space), {
                    orientation: "horizontal",
                    size: 16,
                    className: _waitlistModalModuleCss.radioOptionsSpace,
                    children: radioOptions.map((option)=>/*#__PURE__*/ (0, _jsxRuntime.jsx)(RadioCard, {
                            ...option
                        }, option.value))
                }),
                fieldErrors.type && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        color: 'red',
                        textAlign: 'center'
                    },
                    children: fieldErrors.type
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Button), {
                    type: "primary",
                    onClick: handleSubmit,
                    disabled: !email || !userType || isPending,
                    loading: isPending,
                    className: _waitlistModalModuleCss.joinButtonCustom,
                    children: 'Join the waitlist'
                }),
                fieldErrors.general && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    style: {
                        color: 'red',
                        marginTop: 10,
                        textAlign: 'center'
                    },
                    children: fieldErrors.general
                })
            ]
        })
    });
};
WaitlistModal.displayName = 'WaitlistModal';
exports.default = /*#__PURE__*/ (0, _react.memo)(WaitlistModal);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Button","8HvYt","default"],["Input","ajgzU","default"],["Modal","kY4DD","default"],["Radio","40JQ3","default"],["Space","j7a5D","default"]],"@ant-design/icons":[["CloseOutlined","dinn5","default"]],"./WaitlistModal.module.css":"iXp4y","../CommandDialog/CommandDialog":"1t08c","src/api/mutations/useJoinWaitlist.ts":"4RZ0a","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"40JQ3":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "Button", ()=>(0, _radioButtonDefault.default));
parcelHelpers.export(exports, "Group", ()=>(0, _groupDefault.default));
var _group = require("./group");
var _groupDefault = parcelHelpers.interopDefault(_group);
var _radio = require("./radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _radioButton = require("./radioButton");
var _radioButtonDefault = parcelHelpers.interopDefault(_radioButton);
"use client";
const Radio = (0, _radioDefault.default);
Radio.Button = (0, _radioButtonDefault.default);
Radio.Group = (0, _groupDefault.default);
Radio.__ANT_RADIO = true;
exports.default = Radio;

},{"./group":"82AXl","./radio":"k3PMD","./radioButton":"dyHtO","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"82AXl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _util = require("@rc-component/util");
var _useId = require("@rc-component/util/es/hooks/useId");
var _useIdDefault = parcelHelpers.interopDefault(_useId);
var _pickAttrs = require("@rc-component/util/es/pickAttrs");
var _pickAttrsDefault = parcelHelpers.interopDefault(_pickAttrs);
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _configProvider = require("../config-provider");
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _useSize = require("../config-provider/hooks/useSize");
var _useSizeDefault = parcelHelpers.interopDefault(_useSize);
var _context = require("../form/context");
var _useForm = require("../form/hooks/useForm");
var _context1 = require("./context");
var _radio = require("./radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const RadioGroup = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const { getPrefixCls, direction } = _react.useContext((0, _configProvider.ConfigContext));
    const { name: formItemName } = _react.useContext((0, _context.FormItemInputContext));
    const defaultName = (0, _useIdDefault.default)((0, _useForm.toNamePathStr)(formItemName));
    const { prefixCls: customizePrefixCls, className, rootClassName, options, buttonStyle = 'outline', disabled, children, size: customizeSize, style, id, optionType, name = defaultName, defaultValue, value: customizedValue, block = false, onChange, onMouseEnter, onMouseLeave, onFocus, onBlur, orientation, vertical } = props;
    const [value, setValue] = (0, _util.useControlledState)(defaultValue, customizedValue);
    const onRadioChange = _react.useCallback((event)=>{
        const lastValue = value;
        const val = event.target.value;
        if (!('value' in props)) setValue(val);
        if (val !== lastValue) onChange?.(event);
    }, [
        value,
        setValue,
        onChange
    ]);
    const prefixCls = getPrefixCls('radio', customizePrefixCls);
    const groupPrefixCls = `${prefixCls}-group`;
    // Style
    const rootCls = (0, _useCSSVarClsDefault.default)(prefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(prefixCls, rootCls);
    let childrenToRender = children;
    // 如果存在 options, 优先使用
    if (options && options.length > 0) childrenToRender = options.map((option)=>{
        if (typeof option === 'string' || typeof option === 'number') // 此处类型自动推导为 string
        return /*#__PURE__*/ _react.createElement((0, _radioDefault.default), {
            key: option.toString(),
            prefixCls: prefixCls,
            disabled: disabled,
            value: option,
            checked: value === option
        }, option);
        // 此处类型自动推导为 { label: string value: string }
        return /*#__PURE__*/ _react.createElement((0, _radioDefault.default), {
            key: `radio-group-value-options-${option.value}`,
            prefixCls: prefixCls,
            disabled: option.disabled || disabled,
            value: option.value,
            checked: value === option.value,
            title: option.title,
            style: option.style,
            className: option.className,
            id: option.id,
            required: option.required
        }, option.label);
    });
    const mergedSize = (0, _useSizeDefault.default)(customizeSize);
    const [, mergedVertical] = (0, _hooks.useOrientation)(orientation, vertical);
    const classString = (0, _clsx.clsx)(groupPrefixCls, `${groupPrefixCls}-${buttonStyle}`, {
        [`${groupPrefixCls}-${mergedSize}`]: mergedSize,
        [`${groupPrefixCls}-rtl`]: direction === 'rtl',
        [`${groupPrefixCls}-block`]: block
    }, className, rootClassName, hashId, cssVarCls, rootCls);
    const memoizedValue = _react.useMemo(()=>({
            onChange: onRadioChange,
            value,
            disabled,
            name,
            optionType,
            block
        }), [
        onRadioChange,
        value,
        disabled,
        name,
        optionType,
        block
    ]);
    return /*#__PURE__*/ _react.createElement("div", {
        ...(0, _pickAttrsDefault.default)(props, {
            aria: true,
            data: true
        }),
        className: (0, _clsx.clsx)(classString, {
            [`${prefixCls}-group-vertical`]: mergedVertical
        }),
        style: style,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        id: id,
        ref: ref
    }, /*#__PURE__*/ _react.createElement((0, _context1.RadioGroupContextProvider), {
        value: memoizedValue
    }, childrenToRender));
});
exports.default = /*#__PURE__*/ _react.memo(RadioGroup);

},{"react":"bmhQu","@rc-component/util":"6ZBDN","@rc-component/util/es/hooks/useId":"910ko","@rc-component/util/es/pickAttrs":"jGMGD","clsx":"431Ou","../_util/hooks":"k313C","../config-provider":"dVeAX","../config-provider/hooks/useCSSVarCls":"gcu2s","../config-provider/hooks/useSize":"gXe6G","../form/context":"krZYn","../form/hooks/useForm":"dLMIr","./context":"jMYyl","./radio":"k3PMD","./style":"3EAuR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dLMIr":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toNamePathStr", ()=>toNamePathStr);
parcelHelpers.export(exports, "default", ()=>useForm);
var _react = require("react");
var _form = require("@rc-component/form");
var _findDOMNode = require("@rc-component/util/es/Dom/findDOMNode");
var _scrollIntoViewIfNeeded = require("scroll-into-view-if-needed");
var _scrollIntoViewIfNeededDefault = parcelHelpers.interopDefault(_scrollIntoViewIfNeeded);
var _util = require("../util");
function toNamePathStr(name) {
    const namePath = (0, _util.toArray)(name);
    return namePath.join('_');
}
function getFieldDOMNode(name, wrapForm) {
    const field = wrapForm.getFieldInstance(name);
    const fieldDom = (0, _findDOMNode.getDOM)(field);
    if (fieldDom) return fieldDom;
    const fieldId = (0, _util.getFieldId)((0, _util.toArray)(name), wrapForm.__INTERNAL__.name);
    if (fieldId) return document.getElementById(fieldId);
}
function useForm(form) {
    const [rcForm] = (0, _form.useForm)();
    const itemsRef = _react.useRef({});
    const wrapForm = _react.useMemo(()=>form ?? {
            ...rcForm,
            __INTERNAL__: {
                itemRef: (name)=>(node)=>{
                        const namePathStr = toNamePathStr(name);
                        if (node) itemsRef.current[namePathStr] = node;
                        else delete itemsRef.current[namePathStr];
                    }
            },
            scrollToField: (name, options = {})=>{
                const { focus, ...restOpt } = options;
                const node = getFieldDOMNode(name, wrapForm);
                if (node) {
                    (0, _scrollIntoViewIfNeededDefault.default)(node, {
                        scrollMode: 'if-needed',
                        block: 'nearest',
                        ...restOpt
                    });
                    // Focus if scroll success
                    if (focus) wrapForm.focusField(name);
                }
            },
            focusField: (name)=>{
                const itemRef = wrapForm.getFieldInstance(name);
                if (typeof itemRef?.focus === 'function') itemRef.focus();
                else getFieldDOMNode(name, wrapForm)?.focus?.();
            },
            getFieldInstance: (name)=>{
                const namePathStr = toNamePathStr(name);
                return itemsRef.current[namePathStr];
            }
        }, [
        form,
        rcForm
    ]);
    return [
        wrapForm
    ];
}

},{"react":"bmhQu","@rc-component/form":"jnip8","@rc-component/util/es/Dom/findDOMNode":"5IZto","scroll-into-view-if-needed":"7mNOX","../util":"esYKD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"7mNOX":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "default", ()=>e);
var _computeScrollIntoView = require("compute-scroll-into-view");
const o = (t)=>!1 === t ? {
        block: "end",
        inline: "nearest"
    } : ((t)=>t === Object(t) && 0 !== Object.keys(t).length)(t) ? t : {
        block: "start",
        inline: "nearest"
    };
function e(e, r) {
    if (!e.isConnected || !((t)=>{
        let o = t;
        for(; o && o.parentNode;){
            if (o.parentNode === document) return !0;
            o = o.parentNode instanceof ShadowRoot ? o.parentNode.host : o.parentNode;
        }
        return !1;
    })(e)) return;
    const n = ((t)=>{
        const o = window.getComputedStyle(t);
        return {
            top: parseFloat(o.scrollMarginTop) || 0,
            right: parseFloat(o.scrollMarginRight) || 0,
            bottom: parseFloat(o.scrollMarginBottom) || 0,
            left: parseFloat(o.scrollMarginLeft) || 0
        };
    })(e);
    if (((t)=>"object" == typeof t && "function" == typeof t.behavior)(r)) return r.behavior((0, _computeScrollIntoView.compute)(e, r));
    const l = "boolean" == typeof r || null == r ? void 0 : r.behavior;
    for (const { el: a, top: i, left: s } of (0, _computeScrollIntoView.compute)(e, o(r))){
        const t = i - n.top + n.bottom, o = s - n.left + n.right;
        a.scroll({
            top: t,
            left: o,
            behavior: l
        });
    }
}

},{"compute-scroll-into-view":"fk1yC","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"fk1yC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "compute", ()=>r);
const t = (t)=>"object" == typeof t && null != t && 1 === t.nodeType, e = (t, e)=>(!e || "hidden" !== t) && "visible" !== t && "clip" !== t, n = (t, n)=>{
    if (t.clientHeight < t.scrollHeight || t.clientWidth < t.scrollWidth) {
        const o = getComputedStyle(t, null);
        return e(o.overflowY, n) || e(o.overflowX, n) || ((t)=>{
            const e = ((t)=>{
                if (!t.ownerDocument || !t.ownerDocument.defaultView) return null;
                try {
                    return t.ownerDocument.defaultView.frameElement;
                } catch (t) {
                    return null;
                }
            })(t);
            return !!e && (e.clientHeight < t.scrollHeight || e.clientWidth < t.scrollWidth);
        })(t);
    }
    return !1;
}, o = (t, e, n, o, l, r, i, s)=>r < t && i > e || r > t && i < e ? 0 : r <= t && s <= n || i >= e && s >= n ? r - t - o : i > e && s < n || r < t && s > n ? i - e + l : 0, l = (t)=>{
    const e = t.parentElement;
    return null == e ? t.getRootNode().host || null : e;
}, r = (e, r)=>{
    var i, s, d, h;
    if ("undefined" == typeof document) return [];
    const { scrollMode: c, block: f, inline: u, boundary: a, skipOverflowHiddenElements: g } = r, p = "function" == typeof a ? a : (t)=>t !== a;
    if (!t(e)) throw new TypeError("Invalid target");
    const m = document.scrollingElement || document.documentElement, w = [];
    let W = e;
    for(; t(W) && p(W);){
        if (W = l(W), W === m) {
            w.push(W);
            break;
        }
        null != W && W === document.body && n(W) && !n(document.documentElement) || null != W && n(W, g) && w.push(W);
    }
    const b = null != (s = null == (i = window.visualViewport) ? void 0 : i.width) ? s : innerWidth, H = null != (h = null == (d = window.visualViewport) ? void 0 : d.height) ? h : innerHeight, { scrollX: y, scrollY: M } = window, { height: v, width: E, top: x, right: C, bottom: I, left: R } = e.getBoundingClientRect(), { top: T, right: B, bottom: F, left: V } = ((t)=>{
        const e = window.getComputedStyle(t);
        return {
            top: parseFloat(e.scrollMarginTop) || 0,
            right: parseFloat(e.scrollMarginRight) || 0,
            bottom: parseFloat(e.scrollMarginBottom) || 0,
            left: parseFloat(e.scrollMarginLeft) || 0
        };
    })(e);
    let k = "start" === f || "nearest" === f ? x - T : "end" === f ? I + F : x + v / 2 - T + F, D = "center" === u ? R + E / 2 - V + B : "end" === u ? C + B : R - V;
    const L = [];
    for(let t = 0; t < w.length; t++){
        const e = w[t], { height: l, width: r, top: i, right: s, bottom: d, left: h } = e.getBoundingClientRect();
        if ("if-needed" === c && x >= 0 && R >= 0 && I <= H && C <= b && (e === m && !n(e) || x >= i && I <= d && R >= h && C <= s)) return L;
        const a = getComputedStyle(e), g = parseInt(a.borderLeftWidth, 10), p = parseInt(a.borderTopWidth, 10), W = parseInt(a.borderRightWidth, 10), T = parseInt(a.borderBottomWidth, 10);
        let B = 0, F = 0;
        const V = "offsetWidth" in e ? e.offsetWidth - e.clientWidth - g - W : 0, S = "offsetHeight" in e ? e.offsetHeight - e.clientHeight - p - T : 0, X = "offsetWidth" in e ? 0 === e.offsetWidth ? 0 : r / e.offsetWidth : 0, Y = "offsetHeight" in e ? 0 === e.offsetHeight ? 0 : l / e.offsetHeight : 0;
        if (m === e) B = "start" === f ? k : "end" === f ? k - H : "nearest" === f ? o(M, M + H, H, p, T, M + k, M + k + v, v) : k - H / 2, F = "start" === u ? D : "center" === u ? D - b / 2 : "end" === u ? D - b : o(y, y + b, b, g, W, y + D, y + D + E, E), B = Math.max(0, B + M), F = Math.max(0, F + y);
        else {
            B = "start" === f ? k - i - p : "end" === f ? k - d + T + S : "nearest" === f ? o(i, d, l, p, T + S, k, k + v, v) : k - (i + l / 2) + S / 2, F = "start" === u ? D - h - g : "center" === u ? D - (h + r / 2) + V / 2 : "end" === u ? D - s + W + V : o(h, s, r, g, W + V, D, D + E, E);
            const { scrollLeft: t, scrollTop: n } = e;
            B = 0 === Y ? 0 : Math.max(0, Math.min(n + B / Y, e.scrollHeight - l / Y + S)), F = 0 === X ? 0 : Math.max(0, Math.min(t + F / X, e.scrollWidth - r / X + V)), k += n - B, D += t - F;
        }
        L.push({
            el: e,
            top: B,
            left: F
        });
    }
    return L;
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"esYKD":[function(require,module,exports,__globalThis) {
// form item name black list.  in form ,you can use form.id get the form item element.
// use object hasOwnProperty will get better performance if black list is longer.
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "toArray", ()=>toArray);
parcelHelpers.export(exports, "getFieldId", ()=>getFieldId);
/**
 * Get merged status by meta or passed `validateStatus`.
 */ parcelHelpers.export(exports, "getStatus", ()=>getStatus);
const formItemNameBlackList = [
    'parentNode'
];
// default form item id prefix.
const defaultItemNamePrefixCls = 'form_item';
function toArray(candidate) {
    if (candidate === undefined || candidate === false) return [];
    return Array.isArray(candidate) ? candidate : [
        candidate
    ];
}
function getFieldId(namePath, formName) {
    if (!namePath.length) return undefined;
    const mergedId = namePath.join('_');
    if (formName) return `${formName}_${mergedId}`;
    const isIllegalName = formItemNameBlackList.includes(mergedId);
    return isIllegalName ? `${defaultItemNamePrefixCls}_${mergedId}` : mergedId;
}
function getStatus(errors, warnings, meta, defaultValidateStatus, hasFeedback, validateStatus) {
    let status = defaultValidateStatus;
    if (validateStatus !== undefined) status = validateStatus;
    else if (meta.validating) status = 'validating';
    else if (errors.length) status = 'error';
    else if (warnings.length) status = 'warning';
    else if (meta.touched || hasFeedback && meta.validated) // success feedback should display when pass hasFeedback prop and current value is valid value
    status = 'success';
    return status;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"jMYyl":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "RadioGroupContextProvider", ()=>RadioGroupContextProvider);
parcelHelpers.export(exports, "RadioOptionTypeContext", ()=>RadioOptionTypeContext);
parcelHelpers.export(exports, "RadioOptionTypeContextProvider", ()=>RadioOptionTypeContextProvider);
var _react = require("react");
const RadioGroupContext = /*#__PURE__*/ _react.createContext(null);
const RadioGroupContextProvider = RadioGroupContext.Provider;
exports.default = RadioGroupContext;
const RadioOptionTypeContext = /*#__PURE__*/ _react.createContext(null);
const RadioOptionTypeContextProvider = RadioOptionTypeContext.Provider;

},{"react":"bmhQu","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"k3PMD":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _checkbox = require("@rc-component/checkbox");
var _checkboxDefault = parcelHelpers.interopDefault(_checkbox);
var _ref = require("@rc-component/util/es/ref");
var _clsx = require("clsx");
var _hooks = require("../_util/hooks");
var _warning = require("../_util/warning");
var _wave = require("../_util/wave");
var _waveDefault = parcelHelpers.interopDefault(_wave);
var _interface = require("../_util/wave/interface");
var _useBubbleLock = require("../checkbox/useBubbleLock");
var _useBubbleLockDefault = parcelHelpers.interopDefault(_useBubbleLock);
var _context = require("../config-provider/context");
var _disabledContext = require("../config-provider/DisabledContext");
var _disabledContextDefault = parcelHelpers.interopDefault(_disabledContext);
var _useCSSVarCls = require("../config-provider/hooks/useCSSVarCls");
var _useCSSVarClsDefault = parcelHelpers.interopDefault(_useCSSVarCls);
var _context1 = require("../form/context");
var _context2 = require("./context");
var _contextDefault = parcelHelpers.interopDefault(_context2);
var _style = require("./style");
var _styleDefault = parcelHelpers.interopDefault(_style);
"use client";
const InternalRadio = (props, ref)=>{
    const groupContext = _react.useContext((0, _contextDefault.default));
    const radioOptionTypeContext = _react.useContext((0, _context2.RadioOptionTypeContext));
    const { getPrefixCls, direction, className: contextClassName, style: contextStyle, classNames: contextClassNames, styles: contextStyles } = (0, _context.useComponentConfig)('radio');
    const innerRef = _react.useRef(null);
    const mergedRef = (0, _ref.composeRef)(ref, innerRef);
    const { isFormItemInput } = _react.useContext((0, _context1.FormItemInputContext));
    const onChange = (e)=>{
        props.onChange?.(e);
        groupContext?.onChange?.(e);
    };
    const { prefixCls: customizePrefixCls, className, rootClassName, children, style, title, classNames, styles, ...restProps } = props;
    const radioPrefixCls = getPrefixCls('radio', customizePrefixCls);
    const isButtonType = (groupContext?.optionType || radioOptionTypeContext) === 'button';
    const prefixCls = isButtonType ? `${radioPrefixCls}-button` : radioPrefixCls;
    // Style
    const rootCls = (0, _useCSSVarClsDefault.default)(radioPrefixCls);
    const [hashId, cssVarCls] = (0, _styleDefault.default)(radioPrefixCls, rootCls);
    const radioProps = {
        ...restProps
    };
    // ===================== Disabled =====================
    const disabled = _react.useContext((0, _disabledContextDefault.default));
    if (groupContext) {
        radioProps.name = groupContext.name;
        radioProps.onChange = onChange;
        radioProps.checked = props.value === groupContext.value;
        radioProps.disabled = radioProps.disabled ?? groupContext.disabled;
    }
    radioProps.disabled = radioProps.disabled ?? disabled;
    // =========== Merged Props for Semantic ===========
    const mergedProps = {
        ...props,
        ...radioProps
    };
    const [mergedClassNames, mergedStyles] = (0, _hooks.useMergeSemantic)([
        contextClassNames,
        classNames
    ], [
        contextStyles,
        styles
    ], {
        props: mergedProps
    });
    const wrapperClassString = (0, _clsx.clsx)(`${prefixCls}-wrapper`, {
        [`${prefixCls}-wrapper-checked`]: radioProps.checked,
        [`${prefixCls}-wrapper-disabled`]: radioProps.disabled,
        [`${prefixCls}-wrapper-rtl`]: direction === 'rtl',
        [`${prefixCls}-wrapper-in-form-item`]: isFormItemInput,
        [`${prefixCls}-wrapper-block`]: !!groupContext?.block
    }, contextClassName, className, rootClassName, mergedClassNames.root, hashId, cssVarCls, rootCls);
    // ============================ Event Lock ============================
    const [onLabelClick, onInputClick] = (0, _useBubbleLockDefault.default)(radioProps.onClick);
    // ============================== Render ==============================
    return /*#__PURE__*/ _react.createElement((0, _waveDefault.default), {
        component: "Radio",
        disabled: radioProps.disabled
    }, /*#__PURE__*/ _react.createElement("label", {
        className: wrapperClassString,
        style: {
            ...mergedStyles.root,
            ...contextStyle,
            ...style
        },
        onMouseEnter: props.onMouseEnter,
        onMouseLeave: props.onMouseLeave,
        title: title,
        onClick: onLabelClick
    }, /*#__PURE__*/ _react.createElement((0, _checkboxDefault.default), {
        ...radioProps,
        className: (0, _clsx.clsx)(mergedClassNames.icon, {
            [(0, _interface.TARGET_CLS)]: !isButtonType
        }),
        style: mergedStyles.icon,
        type: "radio",
        prefixCls: prefixCls,
        ref: mergedRef,
        onClick: onInputClick
    }), children !== undefined ? /*#__PURE__*/ _react.createElement("span", {
        className: (0, _clsx.clsx)(`${prefixCls}-label`, mergedClassNames.label),
        style: mergedStyles.label
    }, children) : null));
};
const Radio = /*#__PURE__*/ _react.forwardRef(InternalRadio);
exports.default = Radio;

},{"react":"bmhQu","@rc-component/checkbox":"3GY1u","@rc-component/util/es/ref":"jmzjd","clsx":"431Ou","../_util/hooks":"kdnMA","../_util/warning":"95o3w","../_util/wave":"dKIm0","../_util/wave/interface":"jOEZ1","../checkbox/useBubbleLock":"69M93","../config-provider/context":"75zwC","../config-provider/DisabledContext":"h4TcW","../config-provider/hooks/useCSSVarCls":"gcu2s","../form/context":"krZYn","./context":"jMYyl","./style":"3EAuR","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3EAuR":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "prepareComponentToken", ()=>prepareComponentToken);
var _cssinjs = require("@ant-design/cssinjs");
var _style = require("../../style");
var _internal = require("../../theme/internal");
// ============================== Styles ==============================
// styles from RadioGroup only
const getGroupRadioStyle = (token)=>{
    const { componentCls, antCls } = token;
    const groupPrefixCls = `${componentCls}-group`;
    return {
        [groupPrefixCls]: {
            ...(0, _style.resetComponent)(token),
            display: 'inline-block',
            fontSize: 0,
            // RTL
            [`&${groupPrefixCls}-rtl`]: {
                direction: 'rtl'
            },
            [`&${groupPrefixCls}-block`]: {
                display: 'flex'
            },
            [`${antCls}-badge ${antCls}-badge-count`]: {
                zIndex: 1
            },
            [`> ${antCls}-badge:not(:first-child) > ${antCls}-button-wrapper`]: {
                borderInlineStart: 'none'
            },
            '&-vertical': {
                display: 'flex',
                flexDirection: 'column',
                rowGap: token.marginXS
            }
        }
    };
};
// Styles from radio-wrapper
const getRadioBasicStyle = (token)=>{
    const { componentCls, wrapperMarginInlineEnd, colorPrimary, radioSize, motionDurationSlow, motionDurationMid, motionEaseInOutCirc, colorBgContainer, colorBorder, lineWidth, colorBgContainerDisabled, colorTextDisabled, paddingXS, dotColorDisabled, lineType, radioColor, radioBgColor, calc } = token;
    const radioInnerPrefixCls = `${componentCls}-inner`;
    const dotPadding = 4;
    const radioDotDisabledSize = calc(radioSize).sub(calc(dotPadding).mul(2));
    const radioSizeCalc = calc(1).mul(radioSize).equal({
        unit: true
    });
    return {
        [`${componentCls}-wrapper`]: {
            ...(0, _style.resetComponent)(token),
            display: 'inline-flex',
            alignItems: 'baseline',
            marginInlineStart: 0,
            marginInlineEnd: wrapperMarginInlineEnd,
            cursor: 'pointer',
            '&:last-child': {
                marginInlineEnd: 0
            },
            // RTL
            [`&${componentCls}-wrapper-rtl`]: {
                direction: 'rtl'
            },
            '&-disabled': {
                cursor: 'not-allowed',
                color: token.colorTextDisabled
            },
            '&::after': {
                display: 'inline-block',
                width: 0,
                overflow: 'hidden',
                content: '"\\a0"'
            },
            '&-block': {
                flex: 1,
                justifyContent: 'center'
            },
            // hashId 在 wrapper 上，只能铺平
            [`${componentCls}-checked::after`]: {
                position: 'absolute',
                insetBlockStart: 0,
                insetInlineStart: 0,
                width: '100%',
                height: '100%',
                border: `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorPrimary}`,
                borderRadius: '50%',
                visibility: 'hidden',
                opacity: 0,
                content: '""'
            },
            [componentCls]: {
                ...(0, _style.resetComponent)(token),
                position: 'relative',
                display: 'inline-block',
                outline: 'none',
                cursor: 'pointer',
                alignSelf: 'center',
                borderRadius: '50%'
            },
            [`${componentCls}-wrapper:hover &,
        &:hover ${radioInnerPrefixCls}`]: {
                borderColor: colorPrimary
            },
            [`${componentCls}-input:focus-visible + ${radioInnerPrefixCls}`]: (0, _style.genFocusOutline)(token),
            [`${componentCls}:hover::after, ${componentCls}-wrapper:hover &::after`]: {
                visibility: 'visible'
            },
            [`${componentCls}-inner`]: {
                '&::after': {
                    boxSizing: 'border-box',
                    position: 'absolute',
                    insetBlockStart: '50%',
                    insetInlineStart: '50%',
                    display: 'block',
                    width: radioSizeCalc,
                    height: radioSizeCalc,
                    marginBlockStart: calc(1).mul(radioSize).div(-2).equal({
                        unit: true
                    }),
                    marginInlineStart: calc(1).mul(radioSize).div(-2).equal({
                        unit: true
                    }),
                    backgroundColor: radioColor,
                    borderBlockStart: 0,
                    borderInlineStart: 0,
                    borderRadius: radioSizeCalc,
                    transform: 'scale(0)',
                    opacity: 0,
                    transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`,
                    content: '""'
                },
                boxSizing: 'border-box',
                position: 'relative',
                insetBlockStart: 0,
                insetInlineStart: 0,
                display: 'block',
                width: radioSizeCalc,
                height: radioSizeCalc,
                backgroundColor: colorBgContainer,
                borderColor: colorBorder,
                borderStyle: 'solid',
                borderWidth: lineWidth,
                borderRadius: '50%',
                transition: `all ${motionDurationMid}`
            },
            [`${componentCls}-input`]: {
                position: 'absolute',
                inset: 0,
                zIndex: 1,
                cursor: 'pointer',
                opacity: 0
            },
            // 选中状态
            [`${componentCls}-checked`]: {
                [radioInnerPrefixCls]: {
                    borderColor: colorPrimary,
                    backgroundColor: radioBgColor,
                    '&::after': {
                        transform: `scale(${token.calc(token.dotSize).div(radioSize).equal()})`,
                        opacity: 1,
                        transition: `all ${motionDurationSlow} ${motionEaseInOutCirc}`
                    }
                }
            },
            [`${componentCls}-disabled`]: {
                cursor: 'not-allowed',
                [radioInnerPrefixCls]: {
                    backgroundColor: colorBgContainerDisabled,
                    borderColor: colorBorder,
                    cursor: 'not-allowed',
                    '&::after': {
                        backgroundColor: dotColorDisabled
                    }
                },
                [`${componentCls}-input`]: {
                    cursor: 'not-allowed'
                },
                [`${componentCls}-disabled + span`]: {
                    color: colorTextDisabled,
                    cursor: 'not-allowed'
                },
                [`&${componentCls}-checked`]: {
                    [radioInnerPrefixCls]: {
                        '&::after': {
                            transform: `scale(${calc(radioDotDisabledSize).div(radioSize).equal()})`
                        }
                    }
                }
            },
            [`span${componentCls} + *`]: {
                paddingInlineStart: paddingXS,
                paddingInlineEnd: paddingXS
            }
        }
    };
};
// Styles from radio-button
const getRadioButtonStyle = (token)=>{
    const { buttonColor, controlHeight, componentCls, lineWidth, lineType, colorBorder, motionDurationMid, buttonPaddingInline, fontSize, buttonBg, fontSizeLG, controlHeightLG, controlHeightSM, paddingXS, borderRadius, borderRadiusSM, borderRadiusLG, buttonCheckedBg, buttonSolidCheckedColor, colorTextDisabled, colorBgContainerDisabled, buttonCheckedBgDisabled, buttonCheckedColorDisabled, colorPrimary, colorPrimaryHover, colorPrimaryActive, buttonSolidCheckedBg, buttonSolidCheckedHoverBg, buttonSolidCheckedActiveBg, calc } = token;
    return {
        [`${componentCls}-button-wrapper`]: {
            position: 'relative',
            display: 'inline-block',
            height: controlHeight,
            margin: 0,
            paddingInline: buttonPaddingInline,
            paddingBlock: 0,
            color: buttonColor,
            fontSize,
            lineHeight: (0, _cssinjs.unit)(calc(controlHeight).sub(calc(lineWidth).mul(2)).equal()),
            background: buttonBg,
            border: `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorBorder}`,
            // strange align fix for chrome but works
            // https://gw.alipayobjects.com/zos/rmsportal/VFTfKXJuogBAXcvfAUWJ.gif
            borderBlockStartWidth: calc(lineWidth).add(0.02).equal(),
            borderInlineEndWidth: lineWidth,
            cursor: 'pointer',
            transition: [
                `color ${motionDurationMid}`,
                `background ${motionDurationMid}`,
                `box-shadow ${motionDurationMid}`
            ].join(','),
            a: {
                color: buttonColor
            },
            [`> ${componentCls}-button`]: {
                position: 'absolute',
                insetBlockStart: 0,
                insetInlineStart: 0,
                zIndex: -1,
                width: '100%',
                height: '100%'
            },
            '&:not(:last-child)': {
                marginInlineEnd: calc(lineWidth).mul(-1).equal()
            },
            '&:first-child': {
                borderInlineStart: `${(0, _cssinjs.unit)(lineWidth)} ${lineType} ${colorBorder}`,
                borderStartStartRadius: borderRadius,
                borderEndStartRadius: borderRadius
            },
            '&:last-child': {
                borderStartEndRadius: borderRadius,
                borderEndEndRadius: borderRadius
            },
            '&:first-child:last-child': {
                borderRadius
            },
            [`${componentCls}-group-large &`]: {
                height: controlHeightLG,
                fontSize: fontSizeLG,
                lineHeight: (0, _cssinjs.unit)(calc(controlHeightLG).sub(calc(lineWidth).mul(2)).equal()),
                '&:first-child': {
                    borderStartStartRadius: borderRadiusLG,
                    borderEndStartRadius: borderRadiusLG
                },
                '&:last-child': {
                    borderStartEndRadius: borderRadiusLG,
                    borderEndEndRadius: borderRadiusLG
                }
            },
            [`${componentCls}-group-small &`]: {
                height: controlHeightSM,
                paddingInline: calc(paddingXS).sub(lineWidth).equal(),
                paddingBlock: 0,
                lineHeight: (0, _cssinjs.unit)(calc(controlHeightSM).sub(calc(lineWidth).mul(2)).equal()),
                '&:first-child': {
                    borderStartStartRadius: borderRadiusSM,
                    borderEndStartRadius: borderRadiusSM
                },
                '&:last-child': {
                    borderStartEndRadius: borderRadiusSM,
                    borderEndEndRadius: borderRadiusSM
                }
            },
            '&:hover': {
                position: 'relative',
                color: colorPrimary
            },
            '&:has(:focus-visible)': (0, _style.genFocusOutline)(token),
            [`${componentCls}-inner, input[type='checkbox'], input[type='radio']`]: {
                width: 0,
                height: 0,
                opacity: 0,
                pointerEvents: 'none'
            },
            [`&-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                zIndex: 1,
                color: colorPrimary,
                background: buttonCheckedBg,
                borderColor: colorPrimary,
                '&::before': {
                    backgroundColor: colorPrimary
                },
                '&:first-child': {
                    borderColor: colorPrimary
                },
                '&:hover': {
                    color: colorPrimaryHover,
                    borderColor: colorPrimaryHover,
                    '&::before': {
                        backgroundColor: colorPrimaryHover
                    }
                },
                '&:active': {
                    color: colorPrimaryActive,
                    borderColor: colorPrimaryActive,
                    '&::before': {
                        backgroundColor: colorPrimaryActive
                    }
                }
            },
            [`${componentCls}-group-solid &-checked:not(${componentCls}-button-wrapper-disabled)`]: {
                color: buttonSolidCheckedColor,
                background: buttonSolidCheckedBg,
                borderColor: buttonSolidCheckedBg,
                '&:hover': {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedHoverBg,
                    borderColor: buttonSolidCheckedHoverBg
                },
                '&:active': {
                    color: buttonSolidCheckedColor,
                    background: buttonSolidCheckedActiveBg,
                    borderColor: buttonSolidCheckedActiveBg
                }
            },
            '&-disabled': {
                color: colorTextDisabled,
                backgroundColor: colorBgContainerDisabled,
                borderColor: colorBorder,
                cursor: 'not-allowed',
                '&:first-child, &:hover': {
                    color: colorTextDisabled,
                    backgroundColor: colorBgContainerDisabled,
                    borderColor: colorBorder
                }
            },
            [`&-disabled${componentCls}-button-wrapper-checked`]: {
                color: buttonCheckedColorDisabled,
                backgroundColor: buttonCheckedBgDisabled,
                borderColor: colorBorder,
                boxShadow: 'none'
            },
            '&-block': {
                flex: 1,
                textAlign: 'center'
            }
        }
    };
};
const prepareComponentToken = (token)=>{
    const { wireframe, padding, marginXS, lineWidth, fontSizeLG, colorText, colorBgContainer, colorTextDisabled, controlItemBgActiveDisabled, colorTextLightSolid, colorPrimary, colorPrimaryHover, colorPrimaryActive, colorWhite } = token;
    const dotPadding = 4; // Fixed value
    const radioSize = fontSizeLG;
    const radioDotSize = wireframe ? radioSize - dotPadding * 2 : radioSize - (dotPadding + lineWidth) * 2;
    return {
        // Radio
        radioSize,
        dotSize: radioDotSize,
        dotColorDisabled: colorTextDisabled,
        // Radio buttons
        buttonSolidCheckedColor: colorTextLightSolid,
        buttonSolidCheckedBg: colorPrimary,
        buttonSolidCheckedHoverBg: colorPrimaryHover,
        buttonSolidCheckedActiveBg: colorPrimaryActive,
        buttonBg: colorBgContainer,
        buttonCheckedBg: colorBgContainer,
        buttonColor: colorText,
        buttonCheckedBgDisabled: controlItemBgActiveDisabled,
        buttonCheckedColorDisabled: colorTextDisabled,
        buttonPaddingInline: padding - lineWidth,
        wrapperMarginInlineEnd: marginXS,
        // internal
        radioColor: wireframe ? colorPrimary : colorWhite,
        radioBgColor: wireframe ? colorBgContainer : colorPrimary
    };
};
exports.default = (0, _internal.genStyleHooks)('Radio', (token)=>{
    const { controlOutline, controlOutlineWidth } = token;
    const radioFocusShadow = `0 0 0 ${(0, _cssinjs.unit)(controlOutlineWidth)} ${controlOutline}`;
    const radioButtonFocusShadow = radioFocusShadow;
    const radioToken = (0, _internal.mergeToken)(token, {
        radioFocusShadow,
        radioButtonFocusShadow
    });
    return [
        getGroupRadioStyle(radioToken),
        getRadioBasicStyle(radioToken),
        getRadioButtonStyle(radioToken)
    ];
}, prepareComponentToken, {
    unitless: {
        radioSize: true,
        dotSize: true
    }
});

},{"@ant-design/cssinjs":"2VNL8","../../style":"4Ezp0","../../theme/internal":[["genStyleHooks","eQVSZ"],["mergeToken","g8twD"]],"@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"dyHtO":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _react = require("react");
var _configProvider = require("../config-provider");
var _context = require("./context");
var _radio = require("./radio");
var _radioDefault = parcelHelpers.interopDefault(_radio);
"use client";
const RadioButton = (props, ref)=>{
    const { getPrefixCls } = _react.useContext((0, _configProvider.ConfigContext));
    const { prefixCls: customizePrefixCls, ...radioProps } = props;
    const prefixCls = getPrefixCls('radio', customizePrefixCls);
    return /*#__PURE__*/ _react.createElement((0, _context.RadioOptionTypeContextProvider), {
        value: "button"
    }, /*#__PURE__*/ _react.createElement((0, _radioDefault.default), {
        prefixCls: prefixCls,
        ...radioProps,
        type: "radio",
        ref: ref
    }));
};
exports.default = /*#__PURE__*/ _react.forwardRef(RadioButton);

},{"react":"bmhQu","../config-provider":"dVeAX","./context":"jMYyl","./radio":"k3PMD","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"iXp4y":[function(require,module,exports,__globalThis) {
module.exports["ant-modal-close"] = `TEkJ6W_ant-modal-close`;
module.exports["ant-modal-content"] = `TEkJ6W_ant-modal-content`;
module.exports["emailInputCustom"] = `TEkJ6W_emailInputCustom`;
module.exports["inputLabel"] = `TEkJ6W_inputLabel`;
module.exports["joinButtonCustom"] = `TEkJ6W_joinButtonCustom`;
module.exports["modalSubtitle"] = `TEkJ6W_modalSubtitle`;
module.exports["modalTitle"] = `TEkJ6W_modalTitle`;
module.exports["radioCard"] = `TEkJ6W_radioCard`;
module.exports["radioContent"] = `TEkJ6W_radioContent`;
module.exports["radioCustom"] = `TEkJ6W_radioCustom`;
module.exports["radioDescription"] = `TEkJ6W_radioDescription`;
module.exports["radioLabel"] = `TEkJ6W_radioLabel`;
module.exports["radioOptionsSpace"] = `TEkJ6W_radioOptionsSpace`;
module.exports["selected"] = `TEkJ6W_selected`;
module.exports["waitlistModalContainer"] = `TEkJ6W_waitlistModalContainer`;
module.exports["waitlistModalContent"] = `TEkJ6W_waitlistModalContent`;

},{}],"1FtrY":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _antd = require("antd");
var _icons = require("@ant-design/icons");
var _quizModalModuleCss = require("./QuizModal.module.css");
var _buttonTsx = require("src/components/Button/Button.tsx");
var _genderMaleWebp = require("url:../../../assets/images/gender-male.webp");
var _genderMaleWebpDefault = parcelHelpers.interopDefault(_genderMaleWebp);
var _genderFemaleWebp = require("url:../../../assets/images/gender-female.webp");
var _genderFemaleWebpDefault = parcelHelpers.interopDefault(_genderFemaleWebp);
var _genderOtherWebp = require("url:../../../assets/images/gender-other.webp");
var _genderOtherWebpDefault = parcelHelpers.interopDefault(_genderOtherWebp);
var _bannerBgMobileMainWebp = require("url:../../../assets/images/banner-bg-mobile-main.webp");
var _bannerBgMobileMainWebpDefault = parcelHelpers.interopDefault(_bannerBgMobileMainWebp);
const iconMap = {
    male: (0, _genderMaleWebpDefault.default),
    female: (0, _genderFemaleWebpDefault.default),
    other: (0, _genderOtherWebpDefault.default)
};
const QuizModal = ({ visible, onClose })=>{
    const [selection, setSelection] = (0, _react.useState)(undefined);
    const handleNext = ()=>{
        console.log('Gender selected:', selection);
        onClose();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _antd.Modal), {
        open: visible,
        onCancel: onClose,
        footer: null,
        closeIcon: null,
        className: _quizModalModuleCss.quizModalContainer,
        width: 600,
        centered: true,
        maskClosable: false,
        styles: {
            wrapper: {
                backgroundColor: '#fef5e7',
                backgroundImage: `url(${(0, _bannerBgMobileMainWebpDefault.default)})`,
                backgroundRepeat: `no-repeat`,
                backgroundPosition: `top left`,
                backgroundSize: `100% auto`
            }
        },
        children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: _quizModalModuleCss.headerLayer,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("button", {
                            className: _quizModalModuleCss.backButton,
                            onClick: onClose,
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.LeftOutlined), {})
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: _quizModalModuleCss.progressCounter,
                            children: "1/12"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: _quizModalModuleCss.headerProgress,
                    children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                        style: {
                            width: '8%'
                        },
                        className: _quizModalModuleCss.progressBar
                    })
                }),
                /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: _quizModalModuleCss.quizModalContent,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                            className: _quizModalModuleCss.title,
                            children: [
                                "First things first:",
                                /*#__PURE__*/ (0, _jsxRuntime.jsx)("br", {}),
                                "Let\u2019s get to know you!"
                            ]
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: _quizModalModuleCss.question,
                            children: "What is your gender?"
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: _quizModalModuleCss.optionsColumn,
                            children: [
                                'female',
                                'male',
                                'other'
                            ].map((key)=>/*#__PURE__*/ (0, _jsxRuntime.jsxs)("label", {
                                    className: `${_quizModalModuleCss.optionRow} ${selection === key ? _quizModalModuleCss.selected : ''}`,
                                    onClick: ()=>setSelection(key),
                                    children: [
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: _quizModalModuleCss.optionIcon,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                                src: iconMap[key],
                                                alt: key,
                                                className: _quizModalModuleCss.optionIconImage
                                            })
                                        }),
                                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: _quizModalModuleCss.optionText,
                                            children: key.charAt(0).toUpperCase() + key.slice(1)
                                        }),
                                        selection === key && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                                            className: _quizModalModuleCss.checkMark,
                                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _icons.CheckOutlined), {})
                                        })
                                    ]
                                }, key))
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _buttonTsx.Button), {
                            disabled: !selection,
                            onClick: handleNext,
                            className: _quizModalModuleCss.nextButton,
                            children: "Next"
                        })
                    ]
                })
            ]
        })
    });
};
exports.default = /*#__PURE__*/ (0, _react.memo)(QuizModal);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","antd":[["Modal","kY4DD","default"]],"@ant-design/icons":[["CheckOutlined","jMPci","default"],["LeftOutlined","8erTV","default"]],"./QuizModal.module.css":"g7qQp","src/components/Button/Button.tsx":"g0894","url:../../../assets/images/gender-male.webp":"gssc7","url:../../../assets/images/gender-female.webp":"dBrhH","url:../../../assets/images/gender-other.webp":"6QcnD","url:../../../assets/images/banner-bg-mobile-main.webp":"dt3D7","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"g7qQp":[function(require,module,exports,__globalThis) {
module.exports["backButton"] = `ZNlTZq_backButton`;
module.exports["checkMark"] = `ZNlTZq_checkMark`;
module.exports["headerLayer"] = `ZNlTZq_headerLayer`;
module.exports["headerProgress"] = `ZNlTZq_headerProgress`;
module.exports["myClassname"] = `ZNlTZq_myClassname`;
module.exports["nextButton"] = `ZNlTZq_nextButton`;
module.exports["optionIcon"] = `ZNlTZq_optionIcon`;
module.exports["optionIconImage"] = `ZNlTZq_optionIconImage`;
module.exports["optionRow"] = `ZNlTZq_optionRow`;
module.exports["optionText"] = `ZNlTZq_optionText`;
module.exports["optionsColumn"] = `ZNlTZq_optionsColumn`;
module.exports["progressBar"] = `ZNlTZq_progressBar`;
module.exports["progressCounter"] = `ZNlTZq_progressCounter`;
module.exports["question"] = `ZNlTZq_question`;
module.exports["quizModalContainer"] = `ZNlTZq_quizModalContainer`;
module.exports["quizModalContent"] = `ZNlTZq_quizModalContent`;
module.exports["selected"] = `ZNlTZq_selected`;
module.exports["title"] = `ZNlTZq_title`;

},{}],"gssc7":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("eCXtr");

},{}],"dBrhH":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2lQrl");

},{}],"6QcnD":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("9W7vo");

},{}],"dt3D7":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("2qlLv");

},{}],"bgg1I":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactDom = require("react-dom");
var _videoOverlayModuleCss = require("./VideoOverlay.module.css");
var _crossBlackIconWebp = require("url:../../assets/images/cross-black-icon.webp");
var _crossBlackIconWebpDefault = parcelHelpers.interopDefault(_crossBlackIconWebp);
const VideoOverlay = ({ open, onClose, video })=>{
    const videoRef = (0, _react.useRef)(null);
    const [mounted, setMounted] = (0, _react.useState)(false);
    const [phase, setPhase] = (0, _react.useState)('closed');
    /* ---------- OPEN (ESLint-safe) ---------- */ (0, _react.useLayoutEffect)(()=>{
        if (!open) return;
        let raf2;
        const raf1 = requestAnimationFrame(()=>{
            setMounted(true);
            setPhase('closed');
            raf2 = requestAnimationFrame(()=>{
                setPhase('open');
            });
        });
        return ()=>{
            cancelAnimationFrame(raf1);
            cancelAnimationFrame(raf2);
        };
    }, [
        open
    ]);
    /* ---------- CLOSE ---------- */ const handleClose = ()=>{
        setPhase('closing');
        setTimeout(()=>{
            setMounted(false);
            setPhase('closed');
            onClose();
        }, 280); // must match CSS transition
    };
    /* ---------- VIDEO + SCROLL LOCK ---------- */ (0, _react.useLayoutEffect)(()=>{
        if (!mounted || phase !== 'open') return;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        const v = videoRef.current;
        if (v) requestAnimationFrame(()=>{
            v.currentTime = 0;
            v.play().catch(()=>{});
        });
        return ()=>{
            document.documentElement.style.overflow = '';
            document.body.style.overflow = '';
        };
    }, [
        mounted,
        phase
    ]);
    if (!mounted) return null;
    return /*#__PURE__*/ (0, _reactDom.createPortal)(/*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: `${_videoOverlayModuleCss.overlay} ${phase === 'open' ? _videoOverlayModuleCss.open : phase === 'closing' ? _videoOverlayModuleCss.closing : ''}`,
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: _videoOverlayModuleCss.backdrop,
                onClick: handleClose
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: _videoOverlayModuleCss.container,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                    className: _videoOverlayModuleCss.videoContainer,
                    children: [
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                            className: _videoOverlayModuleCss.closeButton,
                            onClick: handleClose,
                            role: "button",
                            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("img", {
                                className: _videoOverlayModuleCss.closeIcon,
                                src: (0, _crossBlackIconWebpDefault.default),
                                alt: "Close"
                            })
                        }),
                        /*#__PURE__*/ (0, _jsxRuntime.jsx)("video", {
                            ref: videoRef,
                            src: video,
                            controls: true,
                            playsInline: true
                        })
                    ]
                })
            })
        ]
    }), document.body);
};
exports.default = /*#__PURE__*/ (0, _react.memo)(VideoOverlay);

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-dom":"82aNB","./VideoOverlay.module.css":"kHnlk","url:../../assets/images/cross-black-icon.webp":"j51Kj","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"kHnlk":[function(require,module,exports,__globalThis) {
module.exports["backdrop"] = `zYIQMq_backdrop`;
module.exports["closeButton"] = `zYIQMq_closeButton`;
module.exports["closeIcon"] = `zYIQMq_closeIcon`;
module.exports["closing"] = `zYIQMq_closing`;
module.exports["container"] = `zYIQMq_container`;
module.exports["open"] = `zYIQMq_open`;
module.exports["overlay"] = `zYIQMq_overlay`;
module.exports["videoContainer"] = `zYIQMq_videoContainer`;

},{}],"j51Kj":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("eSbp4");

},{}],"1yO46":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "useScrollSmootherLock", ()=>useScrollSmootherLock);
var _react = require("react");
var _scrollSmoother = require("gsap/ScrollSmoother");
function useScrollSmootherLock(locked) {
    const scrollYRef = (0, _react.useRef)(0);
    (0, _react.useEffect)(()=>{
        const smoother = (0, _scrollSmoother.ScrollSmoother).get();
        if (!smoother) return;
        const prevent = (e)=>e.preventDefault();
        if (locked) {
            scrollYRef.current = smoother.scrollTop();
            smoother.paused(true);
            window.addEventListener('wheel', prevent, {
                passive: false
            });
            window.addEventListener('touchmove', prevent, {
                passive: false
            });
            window.addEventListener('keydown', preventKeys, {
                passive: false
            });
            return ()=>{
                smoother.scrollTop(scrollYRef.current);
                smoother.paused(false);
                window.removeEventListener('wheel', prevent);
                window.removeEventListener('touchmove', prevent);
                window.removeEventListener('keydown', preventKeys);
            };
        }
    }, [
        locked
    ]);
}
function preventKeys(e) {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp' || e.key === 'PageDown' || e.key === 'PageUp' || e.key === 'Home' || e.key === 'End' || e.key === ' ') e.preventDefault();
}

},{"react":"bmhQu","gsap/ScrollSmoother":"4XNUc","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"9gfHC":[function(require,module,exports,__globalThis) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "GuestRoute", ()=>GuestRoute);
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _reactDefault = parcelHelpers.interopDefault(_react);
var _reactRouterDom = require("react-router-dom");
var _sessionStore = require("src/store/sessionStore");
const GuestRoute = ()=>{
    const { currentUser } = (0, _sessionStore.sessionStore)();
    if (currentUser) return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Navigate), {
        to: "/onboarding-trainer",
        replace: true
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)((0, _reactRouterDom.Outlet), {});
};

},{"react/jsx-runtime":"gonF6","react":"bmhQu","react-router-dom":"9oT3O","src/store/sessionStore":"kPSO3","@parcel/transformer-js/src/esmodule-helpers.js":"91HVb"}],"3DBKq":[function(require,module,exports,__globalThis) {
module.exports = import.meta.resolve("6Z43t");

},{}]},["5DEId"], "5DEId", "parcelRequirefb80", {})

//# sourceMappingURL=mini-pt-frontend.26493c7d.js.map
